(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateNotificationSubscriptionP = exports.removeCustomFormatP = exports.createCustomFormatP = exports.updateBrandColorP = exports.submitReview = exports.sendTypitoInvitation = exports.removeFontP = exports.uploadFontToGcloudP = exports.uploadFontP = exports.restartSubscriptionWithTokenP = exports.cancelUserSubscriptionP = exports.cancelDeleteAccountRequest = exports.deleteAccount = exports.checkIfCanDeleteAccount = exports.updatePassword = exports.renameWorkspaceP = exports.updateWorkspaceDetails = exports.updateUserDetails = exports.saveNewUserCardP = exports.updateEmailP = undefined;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _UploadApi = require('../edit/api/UploadApi');

var _constants = require('../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var updateEmailP = exports.updateEmailP = function updateEmailP(newEmail) {
    return _bluebird2.default.resolve($.ajax('/api/user/updateEmail', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ newEmail: newEmail })
    })).then(function (response) {
        return response;
    }).catch(function (err) {
        console.error('Error while updating email', err);
        return {
            success: false,
            result: 'api_call_failed',
            errorMessage: "Couldn't update your email. Please check your internet connection and try again"
        };
    });
};

var saveNewUserCardP = exports.saveNewUserCardP = function saveNewUserCardP(stripeToken, cardLast4, cardBrand) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/payment/saveNewUserCard').send({
            stripeToken: stripeToken,
            cardLast4: cardLast4,
            cardBrand: cardBrand
        }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var updateUserDetails = exports.updateUserDetails = function updateUserDetails(name, value) {
    return _bluebird2.default.resolve($.ajax('/api/user/updateField', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ name: name, value: value })
    })).then(function (response) {
        return response;
    }).catch(function (err) {
        console.error('Error while updating ' + name, err);
        var tmpName = name == 'name' ? 'Name' : '';
        return {
            success: false,
            result: 'api_call_failed',
            errorMessage: 'Couldn\'t update your ' + tmpName + '. Please check your internet connection and try again'
        };
    });
};

var updateWorkspaceDetails = exports.updateWorkspaceDetails = function updateWorkspaceDetails(workspaceId, name, value) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/updateField', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ workspaceId: workspaceId, name: name, value: value })
    })).then(function (response) {
        return response;
    }).catch(function (err) {
        var tmp = name;
        switch (name) {
            case 'billingAddress':
                tmp = 'billing address';
                break;
            case 'billingEmail':
                tmp = 'billing email';
                break;
            case 'taxID':
                tmp = 'tax id';
                break;
            case 'companyName':
                tmp = 'company name';
                break;
        }
        console.error('Error while updating ' + tmp, err);
        return {
            success: false,
            result: 'api_call_failed',
            errorMessage: 'Couldn\'t update your ' + tmp + '. Please check your internet connection and try again'
        };
    });
};

var renameWorkspaceP = exports.renameWorkspaceP = function renameWorkspaceP(workspaceId, workspaceName) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/renameWorkspace', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ workspaceId: workspaceId, workspaceName: workspaceName })
    })).catch(function (err) {
        console.error('Error while renaming team', err);
        return {
            success: false,
            errorCode: 'api_call_failed',
            errorMessage: "Couldn't rename team. Please check your internet connection and try again"
        };
    });
};

var updatePassword = exports.updatePassword = function updatePassword(newPassword, confirmPassword, password) {
    return _bluebird2.default.resolve($.ajax('/api/user/changePassword', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ newPassword: newPassword, confirmPassword: confirmPassword, password: password })
    })).then(function (response) {
        return response;
    }).catch(function (err) {
        console.error('Error while updating password', err);
        return {
            success: false,
            result: 'api_call_failed',
            errorMessage: "Couldn't update your password. Please check your internet connection and try again"
        };
    });
};

var checkIfCanDeleteAccount = exports.checkIfCanDeleteAccount = function checkIfCanDeleteAccount() {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/user/canDeleteAccount').end(function (err, res) {
            if (err) {
                reject(err);
            } else {
                resolve(res.body);
            }
        });
    });
};

var deleteAccount = exports.deleteAccount = function deleteAccount(password, isLoginViaSocial) {
    return _bluebird2.default.resolve($.ajax('/api/user/deleteAccount', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ password: password, isLoginViaSocial: isLoginViaSocial })
    })).then(function (response) {
        return response;
    }).catch(function (err) {
        console.error('Error while deleting account', err);
        return {
            success: false,
            result: 'api_call_failed',
            errorMessage: "Couldn't delete your account. Please check your internet connection and try again"
        };
    });
};

var cancelDeleteAccountRequest = exports.cancelDeleteAccountRequest = function cancelDeleteAccountRequest() {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/user/cancelAccountDeleteRequest').end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (!res.body.success) {
                return reject(res.body.errorMessage);
            }
            return resolve(res.body);
        });
    });
};

var cancelUserSubscriptionP = exports.cancelUserSubscriptionP = function cancelUserSubscriptionP() {
    return _bluebird2.default.resolve($.ajax('/api/payment/switchToFreePlan', {
        method: 'POST',
        contentType: 'application/json',
        data: ''
    })).then(function (response) {
        return response;
    }).catch(function (err) {
        console.error('Error while subscription cancelation', err);
        return {
            success: false,
            result: 'api_call_failed',
            errorMessage: "Couldn't cancel subscription. Please check your internet connection and try again"
        };
    });
};

var restartSubscriptionWithTokenP = exports.restartSubscriptionWithTokenP = function restartSubscriptionWithTokenP(activeWorkspaceId, stripeToken, subscriptionPlanId, cardLast4, cardBrand) {
    return _superagent2.default.post('/api/payment/newSubscription').send({
        activeWorkspaceId: activeWorkspaceId,
        subscriptionPlanId: subscriptionPlanId,
        stripeToken: stripeToken,
        cardLast4: cardLast4,
        cardBrand: cardBrand,
        useSavedCard: false,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (response) {
        var stripe = Stripe(window.stripePublishableKey);
        return stripe.confirmCardPayment(response.body.clientSecret, {
            setup_future_usage: 'off_session'
        }).then(function (result) {
            if (!!window.checkPaymentStatus) {
                window.checkPaymentStatus();
            } else {
                console.error('Failed to check payment status');
            }
            if (!!result.error) {
                return {
                    success: true,
                    status: 'payment_error',
                    errorType: result.error.type,
                    errorMessage: result.error.message
                };
            }
            return response.body;
        });
    }).catch(function (err) {
        throw err;
    });
};

var uploadFontP = exports.uploadFontP = function uploadFontP(fontObj) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/uploadFont').field('fontName', fontObj.fontName).field('fontLanguage', fontObj.fontLanguage).field('fontScript', fontObj.fontScript).field('fontClassification', fontObj.fontClassification).field('sourceView', (0, _constants.getSourceView)()).attach('file', fontObj.fontFile).then(function (response) {
            resolve(response.body);
        }).catch(function (err) {
            console.error('Error while uploading font', err);
            return {
                success: false
            };
        });
    });
};

var uploadFontToGcloudP = exports.uploadFontToGcloudP = function uploadFontToGcloudP(fontObj) {
    return new _bluebird2.default(function (resolve, reject) {
        var params = {
            itemType: 'FONT',
            fontName: fontObj.fontName,
            fontLanguage: fontObj.fontLanguage,
            fontScript: fontObj.fontScript,
            fontClassification: fontObj.fontClassification,
            originalFileName: fontObj.fontFile.name
        };

        (0, _UploadApi.uploadFileToGCloudP)(fontObj.fontFile, params, function () {}).then(function (response) {
            return resolve({
                success: true,
                font: response.data
            });
        }).catch(function (err) {
            console.error('Error while uploading font', err);
            err.errorCode = err.errorCode || 'unknown';
            return reject(err);
        });
    });
};

var removeFontP = exports.removeFontP = function removeFontP(fontKey) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/removeFont').send({
            fontKey: fontKey,
            sourceView: (0, _constants.getSourceView)()
        }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var sendTypitoInvitation = exports.sendTypitoInvitation = function sendTypitoInvitation(emails) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/user/inviteUser').send({ emails: emails }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var submitReview = exports.submitReview = function submitReview(reviewLink, reviewImage) {
    return new _bluebird2.default(function (resolve, reject) {
        return _superagent2.default.post('/api/submitReview').field('reviewLink', reviewLink).attach('file', reviewImage).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var updateBrandColorP = exports.updateBrandColorP = function updateBrandColorP(colorIndex, newColor) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/workspace/updateBrandColor').send({ colorIndex: colorIndex, newColor: newColor }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var createCustomFormatP = exports.createCustomFormatP = function createCustomFormatP(formatObj) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/createFormat').send({
            formatObj: formatObj,
            sourceView: (0, _constants.getSourceView)()
        }).then(function (response) {
            resolve(response.body);
        }).catch(function (err) {
            console.error('Error while creating format', err);
            return {
                success: false
            };
        });
    });
};

var removeCustomFormatP = exports.removeCustomFormatP = function removeCustomFormatP(formatKey) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/removeFormat').send({
            formatKey: formatKey,
            sourceView: (0, _constants.getSourceView)()
        }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var updateNotificationSubscriptionP = exports.updateNotificationSubscriptionP = function updateNotificationSubscriptionP(notificationType, value) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/user/updateNotificationSubscriptions').send({
            notificationType: notificationType,
            value: value
        }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (!res.body.success) {
                return reject(res.body.message || 'Error updating notification subscriptions');
            }
            return resolve(res.body);
        });
    });
};

},{"../common/constants":61,"../edit/api/UploadApi":178,"bluebird":389,"superagent":1193}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReviewStatus = exports.IntegrationService = exports.BillingUpdateUIState = exports.AddMemberModalUIState = exports.TaxIDStatus = exports.CollaboratorRole = exports.ChangePlanModalUIState = exports.SubscriptionModalUIState = exports.DeleteAccountUIState = exports.ConfirmPasswordUIState = exports.ProfileUpdateUIState = exports.CustomFormatUIState = exports.FontUploadUIState = exports.EmailUpdateUIState = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var EmailUpdateUIState = exports.EmailUpdateUIState = (0, _keymirror2.default)({
    OPEN: null,
    MAIL_SENT: null,
    MAIL_SEND_ERROR: null,
    CLOSED: null,
    ERROR: null,
    SENDING_MAIL: null
});

var FontUploadUIState = exports.FontUploadUIState = (0, _keymirror2.default)({
    OPEN: null,
    UPLOADING: null,
    UPLOAD_SUCCESS: null,
    UPLOAD_FAILED: null,
    CLOSED: null
});

var CustomFormatUIState = exports.CustomFormatUIState = (0, _keymirror2.default)({
    OPEN: null,
    CREATING: null,
    CREATION_SUCCESS: null,
    CREATION_FAILED: null,
    CLOSED: null,
    CF_LIMIT_REACHED: null
});

var ProfileUpdateUIState = exports.ProfileUpdateUIState = (0, _keymirror2.default)({
    INITIAL: null,
    NAME_UPDATE_SUCCESS: null,
    NAME_UPDATE_ERROR: null,
    LASTNAME_UPDATE_SUCCESS: null,
    LASTNAME_UPDATE_ERROR: null,
    EMAIL_UPDATE_SUCCESS: null,
    EMAIL_UPDATE_ERROR: null,
    PASSWORD_UPDATE_SUCCESS: null,
    PASSWORD_UPDATE_ERROR: null
});

var ConfirmPasswordUIState = exports.ConfirmPasswordUIState = (0, _keymirror2.default)({
    OPEN: null,
    SENT: null,
    SEND_ERROR: null,
    CLOSED: null,
    ERROR: null,
    SENDING: null
});

var DeleteAccountUIState = exports.DeleteAccountUIState = (0, _keymirror2.default)({
    OPEN: null,
    SUCCESS: null,
    CLOSED: null,
    ERROR: null,
    PROGRESS: null,
    CANCEL_CONFIRM: null,
    CANCEL_SUCCESS: null,
    CANCEL_ERROR: null
});

var SubscriptionModalUIState = exports.SubscriptionModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    CHECKING: null,
    WAITING_TOKEN: null,
    PROCESSING_TOKEN: null,
    PAYMENT_SUCCESS: null,
    PAYMENT_ERROR: null,
    SUBSCRIPTION_SUCCESS: null
});

var ChangePlanModalUIState = exports.ChangePlanModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    PROCESSING: null,
    COMPLETE: null,
    FAILED: null
});

var CollaboratorRole = exports.CollaboratorRole = (0, _keymirror2.default)({
    ADMIN: null,
    PRODUCER: null,
    EDITOR: null
});

var TaxIDStatus = exports.TaxIDStatus = (0, _keymirror2.default)({
    UNVERIFIED: null,
    VERIFIED: null,
    FAILED: null
});

var AddMemberModalUIState = exports.AddMemberModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    INVITE_SUCCESS: null,
    INVITE_ERROR: null
});

var BillingUpdateUIState = exports.BillingUpdateUIState = (0, _keymirror2.default)({
    INITIAL: null,
    NAME_UPDATE_SUCCESS: null,
    NAME_UPDATE_ERROR: null,
    EMAIL_UPDATE_SUCCESS: null,
    EMAIL_UPDATE_ERROR: null,
    ADDRESS_UPDATE_SUCCESS: null,
    ADDRESS_UPDATE_ERROR: null,
    TAX_ID_UPDATE_PROCESSING: null,
    TAX_ID_UPDATE_SUCCESS: null,
    TAX_ID_UPDATE_ERROR: null
});

var IntegrationService = exports.IntegrationService = (0, _keymirror2.default)({
    CHANGE_INTEGRATION_STATUS_CONNECT: null,
    CHANGE_INTEGRATION_STATUS_DISCONNECT: null
});

var ReviewStatus = exports.ReviewStatus = (0, _keymirror2.default)({
    NOT_SUBMITTED: null,
    SUBMITTING: null,
    SUBMITTED: null,
    SUBMIT_ERROR: null,
    APPROVED: null
});

},{"keymirror":677}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconScoutApi = exports.IconScoutCategories = exports.PluginControlApi = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _PluginService = require('../constants/PluginService');

var _errorReporting = require('../utils/errorReporting');

var _GeneralUtils = require('../utils/GeneralUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var dlog = (0, _GeneralUtils.createDlog)(true);

var PluginControlApi = exports.PluginControlApi = function () {
    function PluginControlApi() {
        var _this = this;

        _classCallCheck(this, PluginControlApi);

        this.baseUrl = '/plugins';

        this.registerIconScoutAsset = async function (userId, projectId, workspaceId, iconscoutAssetId) {
            try {
                if (!userId || !projectId || !workspaceId || !iconscoutAssetId) throw new Error('Argument not provided properly');
                var response = await _axios2.default.post(_this.baseUrl + '/' + _PluginService.SupportedPlugins.iconscout + '/register/pluginasset', {
                    pluginAssetId: iconscoutAssetId,
                    projectId: projectId,
                    workspaceId: workspaceId,
                    userId: userId,
                    fillSvgString: true
                });
                if (response.status === 500) throw new Error('Internal PluginService error');
                var assetData = response.data.asset;
                return assetData;
            } catch (err) {
                // dlog(`Request failed to register asset for IconScout`);
                (0, _errorReporting.reportError)(new _errorReporting.PluginApiError('Registering Iconscout Asset Id ' + assetId + ' failed'));
                throw err;
            }
        };

        this.registerInternalAsset = async function (plugin, assetId, userId, projectId, workspaceId) {
            try {
                if (!userId || !projectId || !workspaceId || !assetId) throw new Error('Argument not provided properly');
                var response = await _axios2.default.post(_this.baseUrl + '/' + plugin + '/register/asset/' + assetId, {
                    assetId: assetId,
                    projectId: projectId,
                    workspaceId: workspaceId,
                    userId: userId
                });
                if (response.status === 500) throw new Error('Internal PluginService error');
                var assetData = response.data.asset;
                return assetData;
            } catch (err) {
                (0, _errorReporting.reportError)(new _errorReporting.PluginApiError('Registering Internal Plugin Asset faild : plugin :' + plugin + ' : assetId:' + assetId));
                throw err;
            }
        };
    }

    _createClass(PluginControlApi, [{
        key: 'initialize',
        value: function initialize(_ref) {
            var _ref$baseUrl = _ref.baseUrl,
                baseUrl = _ref$baseUrl === undefined ? '/plugins' : _ref$baseUrl;

            this.baseUrl = baseUrl;
        }
    }, {
        key: 'togglePlugin',
        value: async function togglePlugin(userId, pluginName) {
            try {
                var response = await _axios2.default.post(this.baseUrl + '/toggle/user/' + userId, {
                    plugin: pluginName,
                    userId: userId // for authentication
                });
                var _response$data = response.data,
                    enabled = _response$data.enabled,
                    plugin = _response$data.plugin;

                return enabled;
            } catch (err) {
                // dlog(`Request failed to toggle user : `, err);
                return {
                    plugin: pluginName,
                    enabled: false
                };
            }
        }
    }]);

    return PluginControlApi;
}();

var IconScoutCategories = exports.IconScoutCategories = ['flat', 'line', 'sticker', 'colored-outline', 'glyph', 'isometric', 'doodle', 'gradient', 'dualtone', 'rounded'];

var IconScoutApi = exports.IconScoutApi = function () {
    function IconScoutApi(_ref2) {
        var _ref2$requestUrl = _ref2.requestUrl,
            requestUrl = _ref2$requestUrl === undefined ? null : _ref2$requestUrl,
            _ref2$clientId = _ref2.clientId,
            clientId = _ref2$clientId === undefined ? '' : _ref2$clientId,
            _ref2$priceSegment = _ref2.priceSegment,
            priceSegment = _ref2$priceSegment === undefined ? 'free' : _ref2$priceSegment;

        _classCallCheck(this, IconScoutApi);

        this.clientId = clientId;
        this.requestUrl = requestUrl;
        this.priceSegment = priceSegment;
        this.formats = ['svg'];
        this.productType = 'item';
        this.assetType = 'icon';
        this.filters = {
            sort: ['relevant', 'popular', 'latest', 'color'],
            styles: IconScoutCategories
        };

        // this.cancelTokens = this.filters.styles.reduce((acc, v) => {
        //     acc[v] = null;
        //     return acc;
        // }, {});

        this.__searchIconsV3 = (0, _GeneralUtils.memoizeAsync)(this.__searchIconsV3.bind(this));
    }

    /**
     *
     *
     * @param {{
     *  query : string ,
     * perPage : number ,
     * page : number ,
     * sort :'relevant'| 'popular'|'latest'|'color' ,
     * styles : ('flat' | 'line'|'sticker' | 'colored-outline'|'glyph'|'isometric'|'doodle'|'gradient'|'dualtone'|'rounded')[]
     * }} { query = '', perPage = 30, page = 1, sort = '', styles = [] }
     * @return {{
     *  id : number ,
     *  uuid : string,
     *  asset : string ,
     *  name : string ,
     *  score : number,
     *  urls : {
     *   low : string ,
     *   high : string ,
     *   medium : string
     *  },
     * style : string ,
     * svgUrl : string | undefined,
     * type : 'svg'
     * }}
     * @memberof IconScoutApi
     */

    _createClass(IconScoutApi, [{
        key: 'searchIconsV3',
        value: async function searchIconsV3(_ref3) {
            var _this2 = this;

            var _ref3$query = _ref3.query,
                query = _ref3$query === undefined ? '' : _ref3$query,
                _ref3$perPage = _ref3.perPage,
                perPage = _ref3$perPage === undefined ? 30 : _ref3$perPage,
                _ref3$page = _ref3.page,
                page = _ref3$page === undefined ? 1 : _ref3$page,
                _ref3$sort = _ref3.sort,
                sort = _ref3$sort === undefined ? 'relevant' : _ref3$sort,
                _ref3$styles = _ref3.styles,
                styles = _ref3$styles === undefined ? [] : _ref3$styles;

            var allResults = await Promise.all(styles.map(function (style) {
                return _this2.__searchIconsV3({
                    query: query,
                    perPage: perPage,
                    page: page,
                    sort: sort,
                    style: style
                });
            }));
            allResults = allResults.flat();
            // dlog(`All results :`, {
            //     allResults,
            //     cancelToken: this.cancelTokens,
            // });
            return allResults;
        }
    }, {
        key: 'searchIconsV3MultiQuery',
        value: async function searchIconsV3MultiQuery(_ref4) {
            var _ref4$queryList = _ref4.queryList,
                queryList = _ref4$queryList === undefined ? [''] : _ref4$queryList,
                _ref4$perPage = _ref4.perPage,
                perPage = _ref4$perPage === undefined ? 30 : _ref4$perPage,
                _ref4$page = _ref4.page,
                page = _ref4$page === undefined ? 1 : _ref4$page,
                _ref4$sort = _ref4.sort,
                sort = _ref4$sort === undefined ? 'relevant' : _ref4$sort,
                _ref4$styles = _ref4.styles,
                styles = _ref4$styles === undefined ? [] : _ref4$styles;

            var searchP = [];
            for (var i = 0; i < queryList.length; i++) {
                var query = queryList[i];

                searchP.push(this.__searchIconsV3({
                    query: query,
                    perPage: perPage,
                    page: page,
                    sort: sort,
                    style: styles[i]
                }));
            }
            var allResults = await Promise.all(searchP);
            allResults = allResults.flat();
            // dlog(`All results :`, {
            //     allResults,
            //     cancelToken: this.cancelTokens,
            // });
            return allResults;
        }
    }, {
        key: '__searchIconsV3',
        value: async function __searchIconsV3(_ref5) {
            var _ref5$query = _ref5.query,
                query = _ref5$query === undefined ? '' : _ref5$query,
                _ref5$perPage = _ref5.perPage,
                perPage = _ref5$perPage === undefined ? 30 : _ref5$perPage,
                _ref5$page = _ref5.page,
                page = _ref5$page === undefined ? 1 : _ref5$page,
                _ref5$sort = _ref5.sort,
                sort = _ref5$sort === undefined ? 'relevant' : _ref5$sort,
                _ref5$style = _ref5.style,
                style = _ref5$style === undefined ? '' : _ref5$style;

            try {
                // dlog(`Query : ${query} , other args`, { sort, style, perPage, page }, ` for IconScout Singl Request`);

                //This will cancel existing request that was fired off
                // if (this.cancelTokens[style]) {
                //     this.cancelTokens[style]('stale-request');
                // }

                // const cancelTokenSource = Axios.CancelToken.source();

                // const cancelRequest = (msg) => cancelTokenSource.cancel(msg);

                // this.cancelTokens[style] = cancelRequest;

                var response = await _axios2.default.get(this.requestUrl + '/search', {
                    headers: {
                        'Client-ID': this.clientId
                    },
                    params: {
                        query: query,
                        product_type: this.productType,
                        asset: this.assetType,
                        price: this.priceSegment,
                        per_page: perPage,
                        page: page,
                        format: this.formats,
                        sort: sort,
                        styles: [style]
                        // cancelToken: cancelTokenSource.token
                    } });
                if (response.data.status === 'success') {
                    var _response$data$respon = response.data.response.items,
                        data = _response$data$respon.data,
                        currentPage = _response$data$respon.current_page,
                        _perPage = _response$data$respon.per_page;

                    var newData = data.map(function (d) {
                        return {
                            id: d.id,
                            uuid: d.uuid,
                            asset: d.asset,
                            name: d.name,
                            score: d._score,
                            style: style,
                            type: 'svg',
                            urls: {
                                low: d.urls.png_64,
                                medium: d.urls.png_128,
                                high: d.urls.png_256
                            },
                            svgUrl: d.urls.original
                        };
                    });
                    return newData;
                } else if (response.data.status === 'error') {
                    var message = response.data.message;
                    // log important

                    console.log('[Plugin Api] Failed to grab data from IconScout', message);
                    (0, _errorReporting.reportError)(new _errorReporting.PluginApiError('Failed to grab IconScout Data message :' + message));
                } else {
                    return [];
                }
            } catch (err) {
                console.error(err);
                return [];
            }
        }
    }]);

    return IconScoutApi;
}();

},{"../constants/PluginService":65,"../utils/GeneralUtils":77,"../utils/errorReporting":101,"axios":335}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setProjectReady = exports.createNewProject = exports.syncEditData = exports.saveUpdatedScriptInTypito = exports.generateAiProjectFromScript = exports.createAiProjectRenderEdit = exports.createProjectRenderEdit = undefined;
exports.renameProjectP = renameProjectP;
exports.getCaptionLimitStatus = getCaptionLimitStatus;
exports.getProjectTakeoneDataP = getProjectTakeoneDataP;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function renameProjectP(project_id, name) {
    return _axios2.default.post('/api/project/update', {
        id: project_id,
        name: name
    }).then(function (res) {
        if (res.data.success) {
            return true;
        }
        throw new Error('Creation unsuccessful');
    });
}

var createProjectRenderEdit = exports.createProjectRenderEdit = function createProjectRenderEdit(formatId) {
    var serverRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var useUploadPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var workflow = arguments[3];

    return _axios2.default.post('/api/project/create', {
        formatId: formatId,
        redirectToEditor: serverRedirect,
        useUploadPage: useUploadPage,
        createDefaultClip: false,
        workflow: workflow
    }).then(function (response) {
        var data = response.data;
        var projectId = data.projectId;

        window.open('/edit/' + projectId, '_blank');
        return response.data;
    });
};

var createAiProjectRenderEdit = exports.createAiProjectRenderEdit = async function createAiProjectRenderEdit(formatId, prompt) {
    var response = await _axios2.default.post('/api/project/createWithTakeone', {
        formatId: formatId,
        prompt: prompt
    });
    return response.data;
};

var generateAiProjectFromScript = exports.generateAiProjectFromScript = async function generateAiProjectFromScript(projectId, sentences) {
    var response = await _axios2.default.post('/api/project/generateProjectFromScriptTakeone', {
        projectId: projectId,
        sentences: sentences
    });
    return response.data;
};

var saveUpdatedScriptInTypito = exports.saveUpdatedScriptInTypito = async function saveUpdatedScriptInTypito(projectId, sentences) {
    var response = await _axios2.default.post('/api/project/saveUpdatedScriptInTypito', {
        projectId: projectId,
        sentences: sentences
    });
    return response.data;
};

var syncEditData = exports.syncEditData = function syncEditData(projectId, editData, syncCounter) {
    return _axios2.default.post('/api/project/update', {
        id: projectId,
        editData: editData,
        editDataSyncCounter: syncCounter
    }).then(function (responseData) {
        if (responseData.data.success) {
            return true;
        }
        throw new Error('Failed to update edit data');
    });
};
/**
 * Older API used for upload page based direction
 * @param {*} formatId
 * @returns
 */
var createNewProject = exports.createNewProject = function createNewProject(formatId) {
    return _axios2.default.post('/api/project/create', {
        formatId: formatId,
        useUploadPage: true
    }).then(function (responseData) {
        if (responseData.data.success) {
            return responseData;
        }
        throw new Error('Failed to update edit data');
    });
};

var setProjectReady = exports.setProjectReady = function setProjectReady(projectId, editData) {
    return _axios2.default.post('/api/project/setReady', {
        id: projectId,
        editData: editData
    }).then(function (responseData) {
        if (responseData.data.success) {
            return responseData;
        }
        throw new Error('Failed to Set project ready');
    });
};

function getCaptionLimitStatus(projectId) {
    return _axios2.default.get('/api/project/getCaptionLimitStatus', {
        params: {
            projectId: projectId
        }
    }).then(function (_ref) {
        var data = _ref.data;

        if (data.success) {
            return data.captionDurationLeftInMin;
        } else {
            throw new Error("couldn't fetch caption limit info.");
        }
    });
}

async function getProjectTakeoneDataP(projectId) {
    var _ref2 = await _axios2.default.get('/api/project/' + projectId + '/getProjectTakeoneData'),
        data = _ref2.data;

    if (data.success) {
        return {
            takeoneProjectId: data.takeoneProjectId,
            takeoneProjectStatus: data.takeoneProjectStatus
        };
    }

    throw new Error('Failed to fetch takeone data');
}

},{"axios":335}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.saveUserWorkflow = exports.saveWorkflowBannerShown = exports.saveDndIntroShown = exports.saveOnboardingData = undefined;
exports.logoutUserP = logoutUserP;
exports.getAccountDetailsP = getAccountDetailsP;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _GeneralUtils = require('../utils/GeneralUtils');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function logoutUserP() {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/user/logoutuser').end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                if (analytics) {
                    analytics.reset();
                }
                return resolve();
            }
            return reject(new Error('facebook upload failed'));
        });
    });
}

function getAccountDetailsP() {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/user/accountdetails').end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (!res.body.success) {
                return reject(new Error('Failed to get account details'));
            }
            try {
                return resolve(JSON.parse(res.body.accountData));
            } catch (err) {
                return reject(err);
            }
        });
    });
}

var saveOnboardingData = exports.saveOnboardingData = function () {
    var request = _bluebird2.default.resolve();
    return (0, _GeneralUtils.debounce)(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        request = request.then(function () {
            return _axios2.default.post('/api/user/updateOnboardingData', data);
        });
        return request;
    }, 100);
}();

var saveDndIntroShown = exports.saveDndIntroShown = function saveDndIntroShown() {
    return _bluebird2.default.resolve().then(function () {
        return _axios2.default.post('/api/user/updateDragDropIntroShown');
    });
};

var saveWorkflowBannerShown = exports.saveWorkflowBannerShown = function saveWorkflowBannerShown(_ref) {
    var workflow = _ref.workflow;
    return _bluebird2.default.resolve().then(function () {
        return _axios2.default.post('/api/user/updateWorkflowBannerShown', {
            workflow: workflow,
            sourceView: (0, _constants.getSourceView)()
        });
    });
};

var saveUserWorkflow = exports.saveUserWorkflow = function saveUserWorkflow() {
    var newWorkflows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return _axios2.default.post('/api/user/updateUserWorkflows', { newWorkflows: newWorkflows }).then(function (res) {
        if (res.data.success) {
            return res.data.userWorkflows;
        }
        if (res.data.needLogin) {
            window.location.href = res.data.loginUrl;
        } else {
            throw new Error('Error updating user media');
        }
    });
};

},{"../constants":61,"../utils/GeneralUtils":77,"axios":335,"bluebird":389,"superagent":1193}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeUserFromWorkspaceP = exports.removeCustomFormatP = exports.createCustomFormatP = exports.getWorkspaceDataP = exports.addUserToWorkspaceP = exports.addBrandColorP = undefined;
exports.switchWorkspaceP = switchWorkspaceP;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function switchWorkspaceP(workspaceId) {
    return _axios2.default.post('/api/workspace/switchWorkspace', {
        switchToWorkspaceId: workspaceId
    }).then(function (res) {
        if (res.data.success) {
            return res.data;
        }
        throw new Error('Failed to switch team');
    }).catch(function (err) {
        return err;
    });
}

var addBrandColorP = exports.addBrandColorP = function addBrandColorP(color) {
    return _axios2.default.post('/api/workspace/addBrandColor', { color: color }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        return console.error('Error adding color to brandkit', err);
    });
};

var addUserToWorkspaceP = exports.addUserToWorkspaceP = function addUserToWorkspaceP(workspaceId, inviteeData) {
    return _axios2.default.post('/api/workspace/addMember', {
        workspaceId: workspaceId,
        inviteeData: inviteeData
    }).then(function (res) {
        if (res.data.success) {
            return res.data;
        }
        throw new Error('Failed to invite user to workspace');
    }).catch(function (err) {
        throw new Error('Failed to invite user to workspace');
    });
};

var getWorkspaceDataP = exports.getWorkspaceDataP = function getWorkspaceDataP() {
    return _axios2.default.get('/api/workspace/getWorkspaceData').then(function (res) {
        if (res.data.success) {
            return JSON.parse(res.data.workspaces);
        }
        throw new Error('Failed to get workspace details');
    }).catch(function (err) {
        throw new Error('Failed to get workspace details');
    });
};

var createCustomFormatP = exports.createCustomFormatP = function createCustomFormatP(formatObj) {
    return _axios2.default.post('/api/createFormat', {
        formatObj: formatObj,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        console.error('Error while creating format', err);
        return {
            success: false
        };
    });
};

var removeCustomFormatP = exports.removeCustomFormatP = function removeCustomFormatP(formatKey) {
    return _axios2.default.post('/api/removeFormat', {
        formatKey: formatKey,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        console.error(err);
    });
};

var removeUserFromWorkspaceP = exports.removeUserFromWorkspaceP = function removeUserFromWorkspaceP(email, workspaceId) {
    return _axios2.default.post('/api/workspace/removeMember', {
        memberEmail: email,
        workspaceId: workspaceId
    }).then(function (res) {
        if (res.data.success) {
            return res.data;
        }
        throw new Error('Failed to remove user from workspace');
    }).catch(function (err) {
        throw new Error('Failed to remove user from workspace');
    });
};

},{"../constants":61,"axios":335}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var AudioRegistry = function () {
    function AudioRegistry() {
        _classCallCheck(this, AudioRegistry);

        this.audioRegistry = [];
    }

    _createClass(AudioRegistry, [{
        key: "registerAudios",
        value: function registerAudios() {
            var audios = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            this.audioRegistry = audios;
        }
    }, {
        key: "getOverlayAudios",
        value: function getOverlayAudios() {
            return this.audioRegistry.overlay;
        }
    }, {
        key: "getOverlayAudioById",
        value: function getOverlayAudioById(id) {
            return this.audioRegistry.overlay.find(function (a) {
                return a.id == id;
            });
        }
    }, {
        key: "getReelAudios",
        value: function getReelAudios() {
            return this.audioRegistry.reel;
        }
    }, {
        key: "getReelAudioById",
        value: function getReelAudioById(id) {
            return this.audioRegistry.reel.find(function (a) {
                return a.id == id;
            });
        }
    }]);

    return AudioRegistry;
}();

exports.default = new AudioRegistry();

},{}],8:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _DisplayGridHelpers = require('../utils/DisplayGridHelpers');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var getCssProps = function getCssProps(_ref) {
    var left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height;
    return { left: left, top: top, width: width, height: height };
};

var ClipBoxCover = function (_PureComponent) {
    _inherits(ClipBoxCover, _PureComponent);

    function ClipBoxCover() {
        _classCallCheck(this, ClipBoxCover);

        return _possibleConstructorReturn(this, (ClipBoxCover.__proto__ || Object.getPrototypeOf(ClipBoxCover)).apply(this, arguments));
    }

    _createClass(ClipBoxCover, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isCropping = _props.isCropping,
                clipBox = _props.clipBox,
                canvas = _props.canvas;

            if (!isCropping) {
                return null;
            }

            var rootStyle = _extends({
                opacity: isCropping ? 1 : 0
            }, this.props.style || {});

            var boxes = (0, _DisplayGridHelpers.analyzeBoxIntersection)(clipBox, _extends({}, canvas, { x: 0, y: 0 }), function (v) {
                return v + '%';
            }).filter(function (v) {
                return !v.inTarget && v.inSource;
            });

            return _react2.default.createElement('div', { className: 'clipbox-cover', style: rootStyle }, boxes.map(function (b) {

                var css = getCssProps(b);
                if (!!_this2.props.style && !!_this2.props.style.zIndex) {
                    css.zIndex = _this2.props.style.zIndex;
                }
                return _react2.default.createElement('div', { key: b.type, className: 'clipbox-cover-part ' + b.type,
                    style: css
                });
            }), this.props.children);
        }
    }]);

    return ClipBoxCover;
}(_react.PureComponent);

ClipBoxCover.propTypes = {
    isCropping: _propTypes2.default.bool.isRequired,
    clipBox: _propTypes2.default.object,
    canvas: _propTypes2.default.object.isRequired,
    style: _propTypes2.default.object
};
exports.default = ClipBoxCover;

},{"../utils/DisplayGridHelpers":74,"color":418,"prop-types":896,"react":1107}],9:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomFormat = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactSwitch = require('react-switch');

var _reactSwitch2 = _interopRequireDefault(_reactSwitch);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _constants = require('../constants');

var _SVGIcon = require('./SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// TODO move away from inline styling.

var paddingTooltip = _react2.default.createElement(_reactTooltip2.default, {
    className: 'padding-tooltip',
    id: 'padding-control-tooltip',
    place: 'right',
    globalEventOff: 'click',
    effect: 'solid'
}, 'Add borders at the top and bottom of the video. You can use this space to add text, shapes, or subtitles');

var CustomFormat = exports.CustomFormat = function (_PureComponent) {
    _inherits(CustomFormat, _PureComponent);

    function CustomFormat(props) {
        _classCallCheck(this, CustomFormat);

        var _this = _possibleConstructorReturn(this, (CustomFormat.__proto__ || Object.getPrototypeOf(CustomFormat)).call(this, props));

        _this.componentDidMount = function () {
            _this.updateFormatView();
        };

        _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevState.formatWidth !== _this.state.formatWidth || prevState.formatHeight !== _this.state.formatHeight) {
                _this.updateFormatView();
            }
            if (prevState.formatWidth !== _this.state.formatWidth || prevState.formatHeight !== _this.state.formatHeight || prevState.formatName !== _this.state.formatName || prevState.topPadding !== _this.state.topPadding || prevState.bottomPadding !== _this.state.bottomPadding) {
                _this.enableCreateButton();
            }
        };

        _this.enableCreateButton = function () {
            if (_this.state.formatWidth >= 300 && _this.state.formatHeight >= 300 && _this.state.formatWidth <= 1920 && _this.state.formatHeight <= 1920 && _this.state.formatName.trim().length && _this.state.formatName.length <= 40 && (_this.state.showPaddingControls ? _this.state.topPadding <= 50 && _this.state.bottomPadding <= 50 : true)) {
                _this.setState({
                    createButtonDisabled: false
                });
            } else {
                _this.setState({
                    createButtonDisabled: true
                });
            }
        };

        _this.onCreateNewProject = function (e) {
            var _this$props = _this.props,
                onCloseCustomFormatModal = _this$props.onCloseCustomFormatModal,
                _this$props$onStartPr = _this$props.onStartProject,
                onStartProject = _this$props$onStartPr === undefined ? null : _this$props$onStartPr,
                customFormats = _this$props.customFormats,
                _this$props$onResetPa = _this$props.onResetParentModal,
                onResetParentModal = _this$props$onResetPa === undefined ? function () {} : _this$props$onResetPa;

            if (!onStartProject) {
                _this.onClickCancel();
                return;
            }
            _this.setState(_this.initialState);
            _this.updateFormatView();
            onResetParentModal();
            onStartProject(customFormats[customFormats.length - 1].formatKey);
            setTimeout(function () {
                return onCloseCustomFormatModal();
            }, 1000);
        };

        _this.onClickCancel = function (e) {
            var onCloseCustomFormatModal = _this.props.onCloseCustomFormatModal;

            _this.setState(_this.initialState);
            _this.updateFormatView();
            onCloseCustomFormatModal();
        };

        _this.onClickSave = function () {
            if (!_this.checkFormValidation()) {
                var x = 0;
                var topPadding = Math.floor(_this.state.topPadding * _this.state.formatHeight / 100);
                var contentHeight = _this.state.formatHeight - topPadding - Math.floor(_this.state.bottomPadding * _this.state.formatHeight / 100);
                var customFormatObj = {
                    name: _this.state.formatName,
                    x: x,
                    y: topPadding,
                    width: _this.state.formatWidth,
                    height: _this.state.formatHeight,
                    contentWidth: _this.state.formatWidth,
                    contentHeight: contentHeight,
                    useCase: _this.state.useCase
                };
                _this.props.saveCustomFormat(customFormatObj);
                // this.onClickCancel()
            }
        };

        _this.onClickUpgrade = function () {
            _this.onClickCancel();
            window.open('/pricing', '_blank');
        };

        _this.checkFormValidation = function () {
            var errCount = 0;
            Object.keys(_this.state).map(function (key) {
                var elemVal = _this.state[key];
                var elem = document.getElementById(key);

                switch (key) {
                    case 'formatName':
                        if (elemVal === '') {
                            _this.addError(elem, 'Required to help you refer this format');
                            errCount++;
                        } else if (elemVal.length > 40) {
                            _this.addError(elem, 'Shorter is sweeter!');
                            errCount++;
                        }
                        break;
                    case 'formatHeight':
                    case 'formatWidth':
                        elemVal = parseInt(elemVal, 10);
                        if (isNaN(elemVal)) {
                            _this.addError(elem, 'This field is required!');
                            errCount++;
                        } else if (elemVal > 1920 || elemVal < 300) {
                            _this.addError(elem, 'Supports 300px to 1920px');
                            errCount++;
                        }
                        break;
                    case 'topPadding':
                    case 'bottomPadding':
                        if (elemVal) {
                            if (elemVal > 50 || elemVal < 0) {
                                _this.addError(elem, 'Supports max 50%');
                                errCount++;
                            }
                        }
                        break;
                    case 'useCase':
                        if (elemVal.length > 100) {
                            _this.addError(elem, 'Shorter is sweeter!');
                        }
                        break;
                    default:
                        break;
                }

                return elemVal;
            });
            return errCount;
        };

        _this.updateState = function (e) {
            var elem = e.target;
            var elemVal = elem.value;
            $(elem).parent().removeClass('has-error');
            $(elem).parents('div.row.double, div.editable-input').find('span').addClass('hide');
            switch (elem.name) {
                case 'formatName':
                    {
                        if (elemVal === '') {
                            _this.addError(elem, 'Required to help you refer this format');
                        } else if (elemVal.length > 40) {
                            _this.addError(elem, 'Shorter is sweeter!');
                        }
                    }
                    break;
                case 'useCase':
                    {
                        if (elemVal.length > 100) {
                            _this.addError(elem, 'Shorter is sweeter!');
                        }
                    }
                    break;

                case 'formatHeight':
                case 'formatWidth':
                    {
                        elemVal = parseInt(elemVal, 10) || '';
                        if (elemVal === '') {
                            _this.addError(elem, 'This field is required');
                        } else if (elemVal > 1920 || elemVal < 300) {
                            _this.addError(elem, 'Supports 300px to 1920px');
                        }
                    }
                    break;

                case 'topPadding':
                case 'bottomPadding':
                    {
                        elemVal = parseInt(elemVal.trim(), 10) || 0;
                        if (elemVal > 50 || elemVal < 0) {
                            _this.addError(elem, 'Supports max 50%');
                        }
                    }
                    break;
                default:
                    return;
            }
            var upObj = {};
            upObj[elem.name] = elemVal;
            _this.setState(upObj);
        };

        _this.updateFormatView = function () {
            var width = parseInt(_this.state.formatWidth, 10) || 1920;
            var height = parseInt(_this.state.formatHeight, 10) || 1080;
            // If height and width of the format is within the limit, show format view else not
            if (width >= 300 && height >= 300 && width <= 1920 && height <= 1920) {
                var ar = width / height;
                if (width >= height) {
                    _this.setState({
                        formatViewWidth: width,
                        formatViewHeight: 320 / ar,
                        showFormat: true
                    });
                } else {
                    _this.setState({
                        formatViewWidth: ar * 320,
                        formatViewHeight: height,
                        showFormat: true
                    });
                }
            } else {
                _this.setState({
                    formatViewWidth: 0,
                    formatViewHeight: 0,
                    showFormat: false
                });
            }
        };

        _this.onSwitchPaddingControls = function (togglePaddingControl) {
            _this.setState({
                showPaddingControls: togglePaddingControl
            });
        };

        _this.initialState = {
            showFormatCreator: false,
            selectedFormat: null,
            formatName: '',
            formatWidth: '',
            formatHeight: '',
            formatViewWidth: '',
            formatViewHeight: '',
            topPadding: 0,
            bottomPadding: 0,
            ar: '',
            showFormat: false,
            showAdvancedOptions: false,
            createButtonDisabled: true,
            showUpgradeModal: false,
            showPaddingControls: false
        };
        _this.state = _this.initialState;
        _this.updateState = _this.updateState.bind(_this);
        return _this;
    }

    _createClass(CustomFormat, [{
        key: 'openCustomFormatHelp',
        value: function openCustomFormatHelp() {
            window.open('https://help.typito.com/video-editing-on-typito/creating-videos-with-custom-formats-in-typito', '_blank');
        }
    }, {
        key: 'addError',
        value: function addError(elem, message) {
            $(elem).parent().addClass('has-error');
            $(elem).parents('div.row.double, div.editable-input').find('span').text(message).removeClass('hide');
        }
    }, {
        key: 'isNumber',
        value: function isNumber(n) {
            return Number.isInteger(parseFloat(n));
        }
    }, {
        key: 'disableSubmit',
        value: function disableSubmit(e) {
            e.preventDefault();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                customFormatUIState = _props.customFormatUIState,
                isPaidWorkspace = _props.isPaidWorkspace;

            var show = customFormatUIState !== _constants.CustomFormatUIState.CLOSED;

            var _props2 = this.props,
                _props2$createButtonT = _props2.createButtonText,
                createButtonText = _props2$createButtonT === undefined ? 'Create custom format' : _props2$createButtonT,
                _props2$createSuccess = _props2.createSuccessText,
                createSuccessText = _props2$createSuccess === undefined ? 'OKAY' : _props2$createSuccess;

            var modalContentNode = null;
            var creationStatusNode = null;

            var _state = this.state,
                formatViewHeight = _state.formatViewHeight,
                formatViewWidth = _state.formatViewWidth,
                topPadding = _state.topPadding,
                bottomPadding = _state.bottomPadding,
                formatHeight = _state.formatHeight,
                formatWidth = _state.formatWidth;

            var showTopPadding = topPadding >= 0 && topPadding <= 50 && this.isNumber(topPadding);
            var showBottomPadding = bottomPadding >= 0 && bottomPadding <= 50 && this.isNumber(bottomPadding);

            var frameStyle = {
                height: formatViewHeight + 'px',
                width: formatViewWidth + 'px'
            };

            // const labelStyle = {
            //     top: `${(formatViewHeight > 360 ? 360: formatViewHeight)/7.2}%`,
            // }

            var paddingTopFill = {
                position: 'relative',
                height: topPadding + '%',
                background: '#000'
            };

            var paddingBottomFill = {
                position: 'relative',
                top: 100 - bottomPadding - (showTopPadding ? topPadding : 0) + '%',
                height: bottomPadding + '%',
                background: '#000'
            };

            if (customFormatUIState == _constants.CustomFormatUIState.CREATING) {
                creationStatusNode = _react2.default.createElement('div', { className: 'fu-content', style: { padding: '5px', marginRight: '100px', marginTop: '30px' } }, _react2.default.createElement('div', { className: 'uploading-font' }, 'Creating format...'));
            } else if (customFormatUIState == _constants.CustomFormatUIState.CREATION_SUCCESS) {
                creationStatusNode = _react2.default.createElement('div', { className: 'fu-content', style: { padding: '5px' } }, _react2.default.createElement('div', { className: 'uploading-success' }, 'New Custom Format ', _react2.default.createElement('strong', null, this.state.formatName), ' created successfully!'), _react2.default.createElement('button', { className: 'btn btn-typito-primary btn-lg', onClick: this.onCreateNewProject }, createSuccessText));
            } else if (customFormatUIState == _constants.CustomFormatUIState.CREATION_FAILED) {
                creationStatusNode = _react2.default.createElement('div', { className: 'fu-content', style: { padding: '5px' } }, _react2.default.createElement('div', { className: 'uploading-failed' }, 'New Custom Format creation failed!', _react2.default.createElement('br', null), 'Please try again.'), _react2.default.createElement('button', { className: 'btn btn-typito-primary btn-lg', onClick: this.onClickCancel }, 'OKAY'));
            } else if (customFormatUIState == _constants.CustomFormatUIState.CF_LIMIT_REACHED) {
                creationStatusNode = _react2.default.createElement('div', { className: 'fu-content', style: { padding: '5px' } }, _react2.default.createElement('div', { className: 'uploading-failed' }, 'New Custom Format creation failed!', _react2.default.createElement('br', null), 'Please upgrade your account to create more Formats.'), _react2.default.createElement('button', { className: 'btn btn-typito-primary btn-lg', onClick: this.onClickUpgrade }, 'UPGRADE'));
            }

            if (customFormatUIState == _constants.CustomFormatUIState.OPEN) {
                modalContentNode = _react2.default.createElement('div', { className: 'cf-dialog' }, _react2.default.createElement('div', { className: 'fill-parent cf-root' }, _react2.default.createElement('div', { className: 'cf-title' }, 'Create custom format', _react2.default.createElement('div', { className: 'cf-close', onClick: this.onClickCancel }, _react2.default.createElement('svg', { width: '16px', height: '16px', viewBox: '0 0 100 100' }, _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '2', x2: '98', y2: '98' }), _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '98', x2: '98', y2: '2' })))), _react2.default.createElement('div', { className: 'cf-desc custom' }, _react2.default.createElement('div', { className: 'row no-margin' }, _react2.default.createElement('div', { className: 'my-md-5 my-sm-5' }, isPaidWorkspace ? null : _react2.default.createElement('div', { className: 'cf-upgrade-label' }, _react2.default.createElement('span', { className: 'crown-icon' }, _react2.default.createElement(_SVGIcon2.default, { iconId: 'crown-circle', height: '32', width: '32' })), _react2.default.createElement('p', { style: { textAlign: 'left' } }, 'Custom Formats is a Premium feature. Upgrade to a subscription plan to export your video with a custom format.')), _react2.default.createElement('div', { className: 'label-wrapper' }, _react2.default.createElement('div', { className: 'label' }, 'Format name')), _react2.default.createElement('div', { className: 'control-group form-group' }, _react2.default.createElement('div', { className: 'editable-input', style: { position: 'relative' } }, _react2.default.createElement('input', {
                    type: 'text',
                    className: 'form-control custom-input',
                    name: 'formatName',
                    id: 'formatName',
                    maxLength: '40',
                    placeholder: 'My New Format',
                    onChange: this.updateState,
                    value: this.state.formatName
                }), _react2.default.createElement('span', { className: 'text-danger hide error-block' }, 'Error Message'))), _react2.default.createElement('div', { className: 'label-wrapper' }, _react2.default.createElement('div', { className: 'label' }, 'Description')), _react2.default.createElement('div', { className: 'control-group form-group' }, _react2.default.createElement('div', { className: 'editable-input' }, _react2.default.createElement('textarea', {
                    cols: 5,
                    type: 'text-area',
                    className: 'form-control custom-input',
                    name: 'useCase',
                    id: 'useCase',
                    maxLength: '100',
                    placeholder: 'This format is used for...',
                    onChange: this.updateState,
                    value: this.state.useCase
                }), _react2.default.createElement('span', { className: 'text-danger hide error-block' }, 'Error Message'))), _react2.default.createElement('div', { className: 'row double' }, _react2.default.createElement('div', { className: 'my-md-6' }, _react2.default.createElement('div', { className: 'label-wrapper' }, _react2.default.createElement('div', { className: 'label' }, 'Width (px)')), _react2.default.createElement('div', { className: 'control-group form-group' }, _react2.default.createElement('div', {
                    className: 'editable-input numbers',
                    style: { position: 'relative' }
                }, _react2.default.createElement('input', {
                    type: 'number',
                    className: 'form-control custom-input',
                    name: 'formatWidth',
                    id: 'formatWidth',
                    min: '300',
                    max: '1920',
                    placeholder: '1920',
                    onChange: this.updateState,
                    value: '' + formatWidth
                })))), _react2.default.createElement('div', { className: 'my-md-6' }, _react2.default.createElement('div', { className: 'label-wrapper' }, _react2.default.createElement('div', { className: 'label' }, 'Height (px)')), _react2.default.createElement('div', { className: 'control-group form-group' }, _react2.default.createElement('div', {
                    className: 'editable-input numbers',
                    style: { position: 'relative' }
                }, _react2.default.createElement('input', {
                    type: 'number',
                    className: 'form-control custom-input',
                    name: 'formatHeight',
                    id: 'formatHeight',
                    min: '300',
                    max: '1920',
                    placeholder: '1080',
                    onChange: this.updateState,
                    value: '' + formatHeight
                })))), _react2.default.createElement('div', { className: 'my-md-12' }, _react2.default.createElement('span', { className: 'text-danger hide error-block' }, 'Error Message'))), _react2.default.createElement('div', { className: 'padding-toggle-control' }, _react2.default.createElement(_reactSwitch2.default, {
                    className: (0, _classnames2.default)('typito-switch', {
                        'typito-switch-on': this.state.showPaddingControls
                    }),
                    height: 18,
                    width: 32,
                    uncheckedIcon: false,
                    checkedIcon: false,
                    onColor: '#F2C94C',
                    offColor: '#424242',
                    onHandleColor: '#424242',
                    offHandleColor: '#bbb',
                    handleDiameter: 10,
                    onChange: function onChange(checked) {
                        return _this2.onSwitchPaddingControls(checked);
                    },
                    checked: this.state.showPaddingControls
                }), _react2.default.createElement('div', { className: 'padding-control-label' }, 'Add Padding', _react2.default.createElement('div', {
                    'data-for': 'padding-control-tooltip',
                    'data-tip': true,
                    className: 'padding-control-tooltip'
                }, _react2.default.createElement(_SVGIcon2.default, { iconId: 'help-icon', height: '18', width: '18' })), paddingTooltip)), this.state.showPaddingControls && _react2.default.createElement('div', { className: 'row double' }, _react2.default.createElement('div', { className: 'my-md-6' }, _react2.default.createElement('div', { className: 'control-group form-group' }, _react2.default.createElement('div', {
                    className: 'editable-input numbers',
                    style: { position: 'relative' }
                }, _react2.default.createElement('input', {
                    type: 'number',
                    min: '0',
                    max: '50',
                    className: 'form-control custom-input',
                    name: 'topPadding',
                    id: 'topPadding',
                    placeholder: 'Top padding (%)',
                    onChange: this.updateState,
                    value: '' + topPadding
                }), _react2.default.createElement('div', { className: 'padding-percent-label' }, '%')))), _react2.default.createElement('div', { className: 'my-md-6' }, _react2.default.createElement('div', { className: 'control-group form-group' }, _react2.default.createElement('div', {
                    className: 'editable-input numbers',
                    style: { position: 'relative' }
                }, _react2.default.createElement('input', {
                    type: 'number',
                    min: '0',
                    max: '50',
                    className: 'form-control custom-input',
                    name: 'bottomPadding',
                    id: 'bottomPadding',
                    placeholder: 'Bottom padding (%)',
                    onChange: this.updateState,
                    value: '' + bottomPadding
                }), _react2.default.createElement('div', { className: 'padding-percent-label' }, '%')))), _react2.default.createElement('div', { className: 'my-md-12' }, _react2.default.createElement('span', { className: 'text-danger hide error-block' }, 'Error Message'))), _react2.default.createElement('div', { className: 'row no-margin my-md-12 text-center' }, _react2.default.createElement('button', {
                    className: 'btn btn-update',
                    type: 'button',
                    disabled: this.state.createButtonDisabled,
                    onClick: this.onClickSave
                }, createButtonText))), _react2.default.createElement('div', { className: 'my-md-6 my-sm-6' }, _react2.default.createElement('div', { className: 'frame-wrapper' }, _react2.default.createElement('span', { className: 'preview-label' }, 'PREVIEW', _react2.default.createElement('br', null), '(Scaled by 50%)'), this.state.showFormat && _react2.default.createElement('div', { style: frameStyle, className: 'frame-block' }, showTopPadding && _react2.default.createElement('div', { style: paddingTopFill, id: 'marginTopFill' }), showBottomPadding && _react2.default.createElement('div', { style: paddingBottomFill, id: 'marginBottomFill' }))))))));
            } else if (customFormatUIState == _constants.CustomFormatUIState.CREATING || customFormatUIState == _constants.CustomFormatUIState.CREATION_SUCCESS || customFormatUIState == _constants.CustomFormatUIState.CREATION_FAILED || customFormatUIState == _constants.CustomFormatUIState.CF_LIMIT_REACHED) {
                modalContentNode = _react2.default.createElement('div', { className: 'fu-dialog custom-format', id: 'fu-dialog' }, _react2.default.createElement('div', { className: 'fu-title' }, _react2.default.createElement('div', { className: 'fu-close', onClick: this.onClickCancel }, _react2.default.createElement('svg', { width: '16px', height: '16px', viewBox: '0 0 100 100' }, _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '2', x2: '98', y2: '98' }), _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '98', x2: '98', y2: '2' })))), creationStatusNode);
            }

            return modalContentNode;
        }
    }]);

    return CustomFormat;
}(_react.PureComponent);

CustomFormat.propTypes = {
    customFormats: _propTypes2.default.array,
    // onRemoveFormat: PropTypes.func.isRequired,
    saveCustomFormat: _propTypes2.default.func.isRequired,
    isPaidWorkspace: _propTypes2.default.bool.isRequired,
    selectedWorkspace: _propTypes2.default.object.isRequired,
    customFormatUIState: _propTypes2.default.string.isRequired,
    createButtonText: _propTypes2.default.string,
    onCloseCustomFormatModal: _propTypes2.default.func.isRequired,
    onStartProject: _propTypes2.default.func
};
CustomFormat.defaultProps = {
    customFormats: [],
    isPaidWorkspace: false,
    selectedWorkspace: { customFormatLimit: 5 },
    onStartProject: null
};

exports.default = function (_ref) {
    var customFormatUIState = _ref.customFormatUIState,
        props = _objectWithoutProperties(_ref, ['customFormatUIState']);

    var show = customFormatUIState !== _constants.CustomFormatUIState.CLOSED;

    var onClickCancel = function onClickCancel() {
        var onCloseCustomFormatModal = props.onCloseCustomFormatModal;

        onCloseCustomFormatModal();
    };

    var modalClassname = (0, _classnames2.default)({
        'modal-cf': customFormatUIState == _constants.CustomFormatUIState.OPEN,
        'modal-fu': !(customFormatUIState == _constants.CustomFormatUIState.OPEN)
    });

    return _react2.default.createElement(_reactModal2.default, {
        className: modalClassname,
        isOpen: show,
        onRequestClose: onClickCancel,
        overlayClassName: 'ReactModal__Overlay',
        closeTimeoutMS: 300
    }, _react2.default.createElement(CustomFormat, _extends({}, props, { customFormatUIState: customFormatUIState })));
};

},{"../constants":61,"./SVGIcon.react":13,"classnames":410,"color":418,"prop-types":896,"react":1107,"react-modal":1041,"react-switch":1091,"react-tooltip":1092}],10:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateErrorGuard = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _errorReporting = require('../utils/errorReporting');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEBUG = true && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var CreateErrorGuard = function CreateErrorGuard(ComposedComponent, _ref) {
    var _class, _temp;

    var _ref$defaultFallbackC = _ref.defaultFallbackComponent,
        defaultFallbackComponent = _ref$defaultFallbackC === undefined ? null : _ref$defaultFallbackC,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? 'generic-error-guarded-component' : _ref$id,
        _ref$onError = _ref.onError,
        onError = _ref$onError === undefined ? function (error, errorInfo, id, message) {
        (0, _errorReporting.reportError)(new _errorReporting.ReactRenderError('[Component Failed][Name:' + id + '][error-info: ' + JSON.stringify(errorInfo) + '][message-' + message + ']', error));
    } : _ref$onError;
    return _temp = _class = function (_PureComponent) {
        _inherits(_class, _PureComponent);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.state = {
                hasError: false,
                attemptedRecoveryTime: 0
            };
            return _this;
        }

        _createClass(_class, [{
            key: 'componentDidCatch',
            value: function componentDidCatch(error, errorInfo) {
                this.props.onErrorCatch(error, errorInfo, id, this.props.customMessage);
                onError(error, errorInfo, id, this.props.customMessage, { props: this.props, state: this.state });
                dlog('Error caught :', error, errorInfo);
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props,
                    onErrorCatch = _props.onErrorCatch,
                    fallbackComponent = _props.fallbackComponent,
                    customMessage = _props.customMessage,
                    otherProps = _objectWithoutProperties(_props, ['onErrorCatch', 'fallbackComponent', 'customMessage']);

                if (this.state.hasError) return fallbackComponent || defaultFallbackComponent;
                return _react2.default.createElement(ComposedComponent, otherProps);
            }
        }], [{
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(props, state) {
                if (state.hasError && props.attemptRecoveryCount > state.attemptedRecoveryTime) {
                    return {
                        hasError: false,
                        attemptedRecoveryTime: attemptRecoveryCount
                    };
                }

                return state;
            }
        }, {
            key: 'getDerivedStateFromError',
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true
                };
            }
        }]);

        return _class;
    }(_react.PureComponent), _class.defaultProps = {
        onErrorCatch: function onErrorCatch() {},
        fallbackComponent: null,
        customMessage: '',
        attemptRecoveryCount: 0
    }, _temp;
};
exports.CreateErrorGuard = CreateErrorGuard;

},{"../utils/errorReporting":101,"react":1107}],11:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _DisplayGridHelpers = require('../utils/DisplayGridHelpers');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var getCssProps = function getCssProps(_ref) {
    var left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height;
    return { left: left, top: top, width: width, height: height };
};

var FramePaddingBox = function (_Component) {
    _inherits(FramePaddingBox, _Component);

    function FramePaddingBox() {
        _classCallCheck(this, FramePaddingBox);

        return _possibleConstructorReturn(this, (FramePaddingBox.__proto__ || Object.getPrototypeOf(FramePaddingBox)).apply(this, arguments));
    }

    _createClass(FramePaddingBox, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isCropping = _props.isCropping,
                contentBox = _props.contentBox,
                canvas = _props.canvas,
                frameColor = _props.frameColor;

            var boxes = (0, _DisplayGridHelpers.analyzeBoxIntersection)(contentBox, _extends({}, canvas, { x: 0, y: 0 }), function (v) {
                return v + '%';
            }).filter(function (v) {
                return v.inTarget && !v.inSource;
            });

            return _react2.default.createElement('div', { className: 'framepadding-box' }, boxes.map(function (b) {
                return _react2.default.createElement('div', {
                    key: b.type,
                    className: 'framepadding-box-part ' + b.type,
                    style: _extends({}, getCssProps(b), {
                        opacity: isCropping ? 0.5 : 1,
                        backgroundColor: (0, _color2.default)(frameColor).rgb().string()
                    })
                });
            }));
        }
    }]);

    return FramePaddingBox;
}(_react.Component);

FramePaddingBox.propTypes = {
    isCropping: _propTypes2.default.bool.isRequired,
    contentBox: _propTypes2.default.object.isRequired,
    canvas: _propTypes2.default.object.isRequired,
    frameColor: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.object.isRequired]).isRequired
};
exports.default = FramePaddingBox;

},{"../utils/DisplayGridHelpers":74,"color":418,"prop-types":896,"react":1107}],12:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _svg4everybody = require('svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _polyfill = require('../utils/scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SVGFontLabel = function (_Component) {
    _inherits(SVGFontLabel, _Component);

    function SVGFontLabel() {
        _classCallCheck(this, SVGFontLabel);

        return _possibleConstructorReturn(this, (SVGFontLabel.__proto__ || Object.getPrototypeOf(SVGFontLabel)).apply(this, arguments));
    }

    _createClass(SVGFontLabel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return this.props.fontKey !== nextProps.fontKey;
        }
    }, {
        key: 'createMarkup',
        value: function createMarkup(fontKey) {
            var _this2 = this;

            var url = '';

            if (_FontManager2.default.isCustomFont(fontKey)) {
                url = window.getCustomFontSpriteBundlePath() + '#' + fontKey;
            } else if (_FontManager2.default.isUploadedFont(fontKey)) {
                url = _FontManager2.default.uploadedFontSprite + '#' + fontKey;
            } else {
                var version = window.getFontSpriteBundleVersion();
                var staticBaseUrl = window.getStaticBaseUrl();

                if (!!this.props.isDemoLabel) {
                    var bundlePath = window.getDemoFontSpriteBundlePath();
                    url = staticBaseUrl + '/' + bundlePath + '?v=' + version + '#' + fontKey;
                } else {
                    var _bundlePath = window.getFontSpriteBundlePath();
                    url = staticBaseUrl + '/' + _bundlePath + '?v=' + version + '#' + fontKey;
                }
            }

            (0, _polyfill.localMicrotask)(function () {
                (0, _svg4everybody2.default)(url, function (target) {
                    if (!target || !_this2.root) {
                        // if target or root either is null , we get ignore request
                        return;
                    }
                    // create a document fragment to hold the contents of the target
                    var fragment = document.createDocumentFragment();

                    var targetViewBox = target.getAttribute('viewBox');

                    // conditionally set the viewBox on the svg if this is different from the cached one
                    if (targetViewBox !== _this2.root.getAttribute("viewBox")) {
                        _this2.root.setAttribute('viewBox', targetViewBox);
                    }

                    // clone the target
                    var clone = target.cloneNode(true);

                    // copy the contents of the clone into the fragment
                    while (clone.childNodes.length) {
                        fragment.appendChild(clone.firstChild);
                    }

                    while (_this2.root.childNodes.length) {
                        _this2.root.removeChild(_this2.root.firstChild);
                    }

                    // append the fragment into the svg
                    _this2.root.appendChild(fragment);
                });
            });

            return '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                fontKey = _props.fontKey,
                otherProps = _objectWithoutProperties(_props, ['fontKey']);

            return _react2.default.createElement('svg', _extends({}, otherProps, {
                ref: function ref(c) {
                    _this3.root = c;
                },
                preserveAspectRatio: 'xMinYMin slice',
                width: '100%',
                height: '100%',
                style: { pointerEvents: "none" },
                dangerouslySetInnerHTML: { __html: this.createMarkup(fontKey) } }));
        }
    }]);

    return SVGFontLabel;
}(_react.Component);

SVGFontLabel.propTypes = {
    fontKey: _propTypes2.default.string.isRequired,
    isDemoLabel: _propTypes2.default.bool
};
exports.default = SVGFontLabel;

},{"../../common/utils/FontManager":76,"../utils/scheduler/polyfill":126,"prop-types":896,"react":1107,"svg4everybody":1197}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg4everybody = require('svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

var _polyfill = require('../utils/scheduler/polyfill');

var _usePropRefReact = require('../utils/hooks/usePropRef.react.js');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var loadDataIntoSVG = function loadDataIntoSVG(rootRef, target) {
    if (!rootRef.current || !target) {
        return;
    }

    // create a document fragment to hold the contents of the target
    var fragment = document.createDocumentFragment();

    // cache the closest matching viewBox
    var viewBox = !!rootRef.current && target.getAttribute('viewBox');

    // conditionally set the viewBox on the svg
    if (viewBox) {
        rootRef.current.setAttribute('viewBox', viewBox);
    }

    // clone the target
    var clone = target.cloneNode(true);

    // copy the contents of the clone into the fragment
    while (clone.childNodes.length) {
        fragment.appendChild(clone.firstChild);
    }

    // append the fragment into the svg
    if (!!rootRef.current && !!rootRef.current.replaceChildren) {
        rootRef.current.replaceChildren(fragment);
    }
};

var SVGIcon = _react2.default.memo(_react2.default.forwardRef(function (props, ref) {
    var iconId = props.iconId,
        iconsBundleVersion = props.iconsBundleVersion,
        bundlePath = props.bundlePath,
        _props$fill = props.fill,
        fill = _props$fill === undefined ? '#000' : _props$fill,
        _props$fillOpacity = props.fillOpacity,
        fillOpacity = _props$fillOpacity === undefined ? '1' : _props$fillOpacity,
        innerRef = props.innerRef,
        otherProps = _objectWithoutProperties(props, ['iconId', 'iconsBundleVersion', 'bundlePath', 'fill', 'fillOpacity', 'innerRef']);

    var rootRef = (0, _react.useRef)();

    var _usePrevPropRef = (0, _usePropRefReact.usePrevPropRef)(iconId),
        _usePrevPropRef2 = _slicedToArray(_usePrevPropRef, 2),
        previousIconId = _usePrevPropRef2[0],
        newIconId = _usePrevPropRef2[1];

    var grabSvgElement = (0, _react.useCallback)(function (c) {
        rootRef.current = c;
        !!innerRef && (innerRef.current = c);

        if (previousIconId != newIconId) {
            createMarkup(iconId);
        }
    }, [iconId]);

    var createMarkup = (0, _react.useCallback)(function (iconId) {
        var version = !!iconsBundleVersion ? iconsBundleVersion : window.getIconsBundleVersion();
        var staticBaseUrl = window.getStaticBaseUrl();
        var bundlePath = !!bundlePath ? bundlePath : window.getIconsBundlePath();

        var url = staticBaseUrl + '/' + bundlePath + '?v=' + version + '#' + iconId;

        (0, _svg4everybody2.default)(url, function (target) {
            (0, _polyfill.qeueBatchedOperation)(function () {
                return loadDataIntoSVG(rootRef, target);
            }, 'raf');
        });
    }, []);

    return _react2.default.createElement('svg', _extends({}, otherProps, {
        iconid: iconId,
        fill: fill,
        fillOpacity: fillOpacity,
        ref: grabSvgElement,
        key: iconId
    }));
}));

exports.default = SVGIcon;

},{"../utils/hooks/usePropRef.react.js":107,"../utils/scheduler/polyfill":126,"react":1107,"svg4everybody":1197}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fa = require('react-icons/fa');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _WorkspaceUpgradeModal = require('./WorkspaceUpgradeModal.react');

var _WorkspaceUpgradeModal2 = _interopRequireDefault(_WorkspaceUpgradeModal);

var _CustomFormatModal = require('./CustomFormatModal.react');

var _SVGIcon = require('./SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _constants = require('../constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var modalBackgroundStyle = {
    overlay: {
        zIndex: 99999
    }
};

var standardFormats = [{
    label: 'Widescreen',
    AR_label: '16:9',
    dimensions: '1920 x 1080',
    aspectRatio: 16 / 9,
    usedFor: 'YouTube, Facebook, and Twitter feed',
    socialIcons: [_fa.FaYoutube, _fa.FaFacebook, _fa.FaTwitter],
    formatId: 'youtube_widescreen_16x9'
}, {
    label: 'Square',
    AR_label: '1:1',
    dimensions: '1080 x 1080',
    aspectRatio: 1,
    usedFor: 'Instagram, Facebook, and Pinterest feed',
    socialIcons: [_fa.FaInstagram, _fa.FaFacebook, _fa.FaPinterest],
    formatId: 'insta_square_1x1'
}, {
    label: 'Story',
    AR_label: '9:16',
    dimensions: '1080 x 1920',
    aspectRatio: 9 / 16,
    usedFor: 'Stories, Instagram Reels, Tiktok and Snapchat',
    socialIcons: [_fa.FaInstagram, _fa.FaTiktok, _fa.FaSnapchat],
    formatId: 'insta_vertical_9x16'
}, {
    label: 'Vertical',
    AR_label: '4:5',
    dimensions: '1080 x 1350',
    aspectRatio: 4 / 5,
    usedFor: 'Facebook, Instagram, and LinkedIn feed',
    socialIcons: [_fa.FaFacebook, _fa.FaInstagram, _fa.FaLinkedin],
    formatId: 'fb_vertical_4x5'
}];

// openCreateCustomFormat = (activeCustomFormats) => {
//     const {
//         selectedWorkspace: { planConfig = {} },
//     } = this.props;

//     if (
//         planConfig.hasOwnProperty('customFormatLimit') &&
//         activeCustomFormats.length >= planConfig.customFormatLimit
//     ) {
//         this.setState({ showUpgradeModal: true, upgradeType: 'Custom format' });
//     } else {
//         // window.open("/account#brandkit", '_blank');
//         this.props.openCustomFormatModal();
//     }
// };

var getPreviewDimensions = function getPreviewDimensions(aspectRatio) {
    var minSide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var width = minSide;
    var height = minSide;

    if (aspectRatio < 1) {
        // Height is greater
        height = Math.floor(width / aspectRatio);
    } else {
        // Width is greater or equal
        width = Math.floor(height * aspectRatio);
    }

    return { width: width, height: height };
};

var FormatPreview = function FormatPreview(_ref) {
    var _ref$format = _ref.format,
        formatId = _ref$format.formatId,
        label = _ref$format.label,
        AR_label = _ref$format.AR_label,
        dimensions = _ref$format.dimensions,
        aspectRatio = _ref$format.aspectRatio,
        usedFor = _ref$format.usedFor,
        socialIcons = _ref$format.socialIcons,
        onChooseFormat = _ref.onChooseFormat;

    var _getPreviewDimensions = getPreviewDimensions(aspectRatio, 180),
        width = _getPreviewDimensions.width,
        height = _getPreviewDimensions.height;

    return _react2.default.createElement('div', {
        className: 'simple-format-container',
        style: {
            width: width + 40 + 'px',
            minWidth: width + 40 + 'px'
        }
    }, _react2.default.createElement('div', {
        className: 'format-preview',
        style: {
            height: height + 'px'
        }
    }, _react2.default.createElement('div', { className: 'ar-label' }, AR_label), _react2.default.createElement('div', { className: 'dimensions-label' }, dimensions), socialIcons && _react2.default.createElement('div', { className: 'social-icons-wrapper' }, socialIcons.map(function (si, index) {
        var Icon = si;
        return _react2.default.createElement(Icon, { key: 'social-icon-' + index, className: 'social-icon' });
    }))), _react2.default.createElement('div', { className: 'format-description-wrapper' }, _react2.default.createElement('div', { className: 'format-label' }, label), _react2.default.createElement('div', { className: 'used-for' }, usedFor)), _react2.default.createElement('button', { type: 'button', className: 'choose-cta', onClick: function onClick() {
            return onChooseFormat(formatId);
        } }, 'Choose'));
};

var FormatSelectorView = function FormatSelectorView(_ref2) {
    var _ref2$formats = _ref2.formats,
        formats = _ref2$formats === undefined ? [] : _ref2$formats,
        openCustomFormatModal = _ref2.openCustomFormatModal,
        onClickCreate = _ref2.onClickCreate;

    var scrollRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(0),
        _useState2 = _slicedToArray(_useState, 2),
        scrollX = _useState2[0],
        setscrollX = _useState2[1];

    var _useState3 = (0, _react.useState)(true),
        _useState4 = _slicedToArray(_useState3, 2),
        scrolEnd = _useState4[0],
        setscrolEnd = _useState4[1];

    var slide = function slide(shift) {
        scrollRef.current.scroll({
            left: scrollRef.current.scrollLeft + shift,
            behavior: 'smooth'
        });

        setscrollX(scrollX + shift);

        if (Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <= scrollRef.current.offsetWidth) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    var scrollCheck = function scrollCheck() {
        setscrollX(scrollRef.current.scrollLeft);
        if (Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <= scrollRef.current.offsetWidth) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    (0, _react.useEffect)(function () {
        // To check if the scroll buttons should show up after initial render
        scrollCheck();
    }, []);

    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', { className: 'header' }, _react2.default.createElement('div', { className: 'header-label' }, 'Pick a format'), _react2.default.createElement('div', { className: 'custom-format-cta', onClick: openCustomFormatModal }, _react2.default.createElement('span', { className: 'cta-icon' }), _react2.default.createElement('span', { className: 'cta-label' }, 'Custom format'))), _react2.default.createElement('hr', null), _react2.default.createElement('div', { className: 'select-format-label' }, 'Start your project by selecting the right aspect ratio for the video'), _react2.default.createElement('button', {
        type: 'button',
        className: (0, _classnames2.default)('slide-left-button', { hide: scrollX <= 0 }),
        onClick: function onClick() {
            return slide(-250);
        }
    }, _react2.default.createElement(_SVGIcon2.default, { height: '20', width: '20', iconId: 'arrow-left', fill: 'white' })), _react2.default.createElement('div', { className: 'formats-container', ref: scrollRef, onScroll: scrollCheck }, _react2.default.createElement('div', { className: 'formats-wrapper' }, formats.map(function (format) {
        return _react2.default.createElement(FormatPreview, {
            key: format.label,
            format: format,
            onChooseFormat: onClickCreate
        });
    }))), _react2.default.createElement('button', {
        type: 'button',
        className: (0, _classnames2.default)('slide-right-button', { hide: scrolEnd }),
        onClick: function onClick() {
            return slide(+250);
        }
    }, _react2.default.createElement(_SVGIcon2.default, { height: '20', width: '20', iconId: 'arrow-left', fill: 'white' })));
};

var parseCustomFormats = function parseCustomFormats() {
    var customFormats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return customFormats.map(function (_ref3) {
        var label = _ref3.label,
            size = _ref3.size,
            width = _ref3.width,
            height = _ref3.height,
            useCase = _ref3.useCase,
            formatKey = _ref3.formatKey;
        return {
            label: label,
            AR_label: size,
            dimensions: width + ' x ' + height,
            aspectRatio: width / height,
            usedFor: useCase,
            formatId: formatKey
        };
    });
};

var SimpleFormatSelectModal = function SimpleFormatSelectModal(props) {
    var show = props.show,
        _props$customFormats = props.customFormats,
        customFormats = _props$customFormats === undefined ? [] : _props$customFormats,
        selectedWorkspace = props.selectedWorkspace,
        createButtonText = props.createButtonText,
        customFormatUIState = props.customFormatUIState,
        _saveCustomFormat = props.saveCustomFormat,
        onClose = props.onClose,
        onClickCreate = props.onClickCreate,
        onCloseCustomFormatModal = props.onCloseCustomFormatModal,
        openCustomFormatModal = props.openCustomFormatModal,
        openFitnessEditor = props.openFitnessEditor,
        useAICreator = props.useAICreator;

    var customFormatPreviewData = parseCustomFormats(customFormats);

    var closeFormatModal = function closeFormatModal() {
        setTimeout(function () {
            onCloseCustomFormatModal();
        }, 300);
        onClose();
    };

    var onCreate = function onCreate(formatId) {
        onClickCreate(formatId, openFitnessEditor, useAICreator);
    };

    var formatSelectorView = _react2.default.createElement(FormatSelectorView, {
        formats: [].concat(_toConsumableArray(customFormatPreviewData), standardFormats),
        openCustomFormatModal: openCustomFormatModal,
        onClickCreate: onCreate
    });

    var customFormatCreateView = _react2.default.createElement('div', { className: 'custom-format-wrapper' }, _react2.default.createElement(_CustomFormatModal.CustomFormat, {
        customFormats: customFormats,
        selectedWorkspace: selectedWorkspace,
        customFormatUIState: customFormatUIState,
        isPaidWorkspace: selectedWorkspace.isPaidWorkspace,
        createButtonText: createButtonText,
        onCloseCustomFormatModal: onCloseCustomFormatModal,
        saveCustomFormat: function saveCustomFormat(customFormat) {
            return _saveCustomFormat(customFormat);
        },
        createSuccessText: 'Start Project',
        onStartProject: onCreate
    }));

    var isCreatingCustomFormat = customFormatUIState !== _constants.CustomFormatUIState.CLOSED;

    var modalClassnames = (0, _classnames2.default)('simple-format-container-root', {
        'custom-format-modal': isCreatingCustomFormat
    });

    return _react2.default.createElement(_reactModal2.default, {
        isOpen: show,
        onRequestClose: closeFormatModal,
        closeTimeoutMS: 300,
        overlayClassName: 'ReactModal__Overlay',
        className: modalClassnames,
        ariaHideApp: false,
        style: modalBackgroundStyle
    }, isCreatingCustomFormat ? customFormatCreateView : formatSelectorView);
};

exports.default = SimpleFormatSelectModal;

},{"../constants":61,"./CustomFormatModal.react":9,"./SVGIcon.react":13,"./WorkspaceUpgradeModal.react":16,"classnames":410,"react":1107,"react-icons/fa":1021,"react-modal":1041}],15:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('../../account/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import SVGIcon from './components/SVGIcon.react'


var WorkspaceSelectModal = function (_Component) {
    _inherits(WorkspaceSelectModal, _Component);

    function WorkspaceSelectModal(props) {
        _classCallCheck(this, WorkspaceSelectModal);

        var _this = _possibleConstructorReturn(this, (WorkspaceSelectModal.__proto__ || Object.getPrototypeOf(WorkspaceSelectModal)).call(this, props));

        _this.state = {
            showWorkspaceList: false,
            selectedWorkspace: props.selectedWorkspace
        };
        return _this;
    }

    _createClass(WorkspaceSelectModal, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.selectedWorkspace !== prevProps.selectedWorkspace) {
                this.setState({ selectedWorkspace: this.props.selectedWorkspace });
            }
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.setState({ showWorkspaceList: false });
            this.props.onClose();
        }
    }, {
        key: 'onSelectWorkspace',
        value: function onSelectWorkspace(e, workspace) {
            e.stopPropagation();
            this.setState({ selectedWorkspace: workspace, showWorkspaceList: false });
        }
    }, {
        key: 'toggleWorkspaceList',
        value: function toggleWorkspaceList() {
            this.setState({ showWorkspaceList: !this.state.showWorkspaceList });
        }
    }, {
        key: 'onClickAction',
        value: function onClickAction() {
            this.onClose();
            this.props.onConfirm(this.state.selectedWorkspace.workspaceId);
        }
    }, {
        key: 'switchWorkspace',
        value: function switchWorkspace(workspaceId) {
            this.onClose();
            this.props.onConfirm(workspaceId);
        }
    }, {
        key: 'getRoleLabel',
        value: function getRoleLabel(role) {
            switch (role) {
                case _constants.CollaboratorRole.ADMIN:
                    return 'Owner';
                case _constants.CollaboratorRole.EDITOR:
                    return 'Editor';
                case _constants.CollaboratorRole.PRODUCER:
                    return 'Producer';
                default:
                    return '';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                confirmButtonLabel = _props.confirmButtonLabel,
                show = _props.show,
                allWorkspaces = _props.allWorkspaces,
                activeWorkspace = _props.selectedWorkspace,
                _props$currentLabel = _props.currentLabel,
                currentLabel = _props$currentLabel === undefined ? 'Current' : _props$currentLabel,
                _props$activeButtonCl = _props.activeButtonClass,
                activeButtonClass = _props$activeButtonCl === undefined ? 'btn-disabled' : _props$activeButtonCl,
                _props$switchButtonCl = _props.switchButtonClass,
                switchButtonClass = _props$switchButtonCl === undefined ? "btn-typito-primary btn-team-switch" : _props$switchButtonCl;
            var _state = this.state,
                selectedWorkspace = _state.selectedWorkspace,
                showWorkspaceList = _state.showWorkspaceList;

            if (!activeWorkspace || !selectedWorkspace) {
                return null;
            }

            // const hasWorkspaceChanged = selectedWorkspace.workspaceId !== activeWorkspace.workspaceId

            // let confirmLabel = confirmButtonLabel
            // if(!confirmLabel) {
            //     confirmLabel = hasWorkspaceChanged ? 'Switch' : 'Continue'
            // }
            //
            // let workspaceListNode = null
            // if(showWorkspaceList){
            //     workspaceListNode = (
            //         <div className="workspace-list">
            //             {allWorkspaces.map((w,i) => {
            //
            //                 return (
            //                     <div key={`workspace_${i}`} className="workspace-list-item"
            //                     onClick={(e) => this.onSelectWorkspace(e, w)}>
            //                     {w.workspaceName}
            //                     </div>
            //                 )
            //             })
            //             }
            //         </div>
            //     )
            // }

            allWorkspaces.unshift(allWorkspaces.splice(allWorkspaces.findIndex(function (elt) {
                return elt.workspaceId === activeWorkspace.workspaceId;
            }), 1)[0]);

            return _react2.default.createElement(_reactModal2.default, { className: 'modal-wsm', isOpen: show, onRequestClose: function onRequestClose(e) {
                    return _this2.onClose();
                },
                overlayClassName: 'ReactModal__Overlay', closeTimeoutMS: 300 }, _react2.default.createElement('div', { className: 'wsm-dialog' }, _react2.default.createElement('div', { className: 'wsm-close', onClick: function onClick(e) {
                    return _this2.onClose();
                } }, _react2.default.createElement('svg', { width: '16px', height: '16px', viewBox: '0 0 100 100' }, _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '2', x2: '98', y2: '98' }), _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '98', x2: '98', y2: '2' }))), _react2.default.createElement('div', { className: 'wsm-container' }, _react2.default.createElement('div', { className: 'wsm-title' }, this.props.heading || 'Switch to another Team'), _react2.default.createElement('div', { className: 'table' }, _react2.default.createElement('table', { className: 'table workspace-table' }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', { className: 'heading w-45' }, 'Team'), _react2.default.createElement('th', { className: 'heading w-35' }, 'Your Role'), _react2.default.createElement('th', null))), _react2.default.createElement('tbody', null, allWorkspaces.map(function (w, i) {
                var isActive = activeWorkspace.workspaceId === w.workspaceId;
                return _react2.default.createElement('tr', { key: i }, _react2.default.createElement('td', { className: 'ws-name' }, w.workspaceName), _react2.default.createElement('td', { className: 'ws-role' }, _this2.getRoleLabel(w.role)), _react2.default.createElement('td', null, _react2.default.createElement('button', { onClick: function onClick() {
                        return _this2.switchWorkspace(w.workspaceId);
                    },
                    disabled: isActive && activeButtonClass.indexOf("btn-disabled") !== -1,
                    className: 'btn btn-md ' + (isActive ? activeButtonClass : switchButtonClass) }, isActive ? currentLabel : 'Switch')));
            })))))));
        }
    }]);

    return WorkspaceSelectModal;
}(_react.Component);

WorkspaceSelectModal.propTypes = {
    confirmButtonLabel: _propTypes2.default.string,
    onClose: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.bool.isRequired,
    selectedWorkspace: _propTypes2.default.object.isRequired,
    allWorkspaces: _propTypes2.default.array.isRequired,
    onConfirm: _propTypes2.default.func.isRequired
};
WorkspaceSelectModal.defaultProps = {
    confirmButtonLabel: ''
};
exports.default = WorkspaceSelectModal;

},{"../../account/constants":2,"classnames":410,"prop-types":896,"react":1107,"react-modal":1041}],16:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var WorkspaceUpgradeModal = function (_Component) {
    _inherits(WorkspaceUpgradeModal, _Component);

    function WorkspaceUpgradeModal() {
        _classCallCheck(this, WorkspaceUpgradeModal);

        return _possibleConstructorReturn(this, (WorkspaceUpgradeModal.__proto__ || Object.getPrototypeOf(WorkspaceUpgradeModal)).apply(this, arguments));
    }

    _createClass(WorkspaceUpgradeModal, [{
        key: 'onClickUpgrade',
        value: function onClickUpgrade() {
            this.props.onHide();
            if (!!this.props.onClickUpgrade) {
                this.props.onClickUpgrade();
            } else {
                // added since in-place sub modal is not added on upload, lang-demo and templates page.
                window.open('/pricing', '_blank');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                show = _props.show,
                onHide = _props.onHide,
                title = _props.title,
                reason = _props.reason,
                extraInfo = _props.extraInfo,
                _props$showStandardMe = _props.showStandardMessage,
                showStandardMessage = _props$showStandardMe === undefined ? true : _props$showStandardMe,
                _props$showLearnMoreL = _props.showLearnMoreLink,
                showLearnMoreLink = _props$showLearnMoreL === undefined ? false : _props$showLearnMoreL;

            return _react2.default.createElement(_reactModal2.default, { className: 'modal-wu', isOpen: show, onRequestClose: onHide,
                overlayClassName: 'ReactModal__Overlay', closeTimeoutMS: 300 }, _react2.default.createElement('div', { className: 'wu-dialog' }, !!title && _react2.default.createElement('div', { className: 'wu-header' }, _react2.default.createElement('div', { className: 'wu-label' }, title), _react2.default.createElement('div', { className: 'wu-close', onClick: onHide }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 100 100' }, _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '2', x2: '98', y2: '98' }), _react2.default.createElement('line', { className: 'close-path', x1: '2', y1: '98', x2: '98', y2: '2' })))), _react2.default.createElement('div', { className: 'wu-root' }, _react2.default.createElement('div', { className: 'wu-message' }, showStandardMessage ? _react2.default.createElement('div', null, _react2.default.createElement('p', null, 'Upgrade your plan'), !!reason && _react2.default.createElement('p', null, reason)) : _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: reason } })), _react2.default.createElement('div', { className: 'wu-content' }, _react2.default.createElement('div', { className: 'wu-action-buttons' }, _react2.default.createElement('button', { className: 'btn btn-typito-primary btn-md',
                onClick: function onClick() {
                    return _this2.onClickUpgrade();
                }
            }, 'Upgrade'), showLearnMoreLink && _react2.default.createElement('a', { className: 'learn-more-link', target: '_blank',
                href: 'https://help.typito.com/en/articles/3220734-video-restrictions-on-free-plan' }, 'Learn More')), !!extraInfo && _react2.default.createElement('p', { className: 'wu-extra-info' }, extraInfo)))));
        }
    }]);

    return WorkspaceUpgradeModal;
}(_react.Component);

WorkspaceUpgradeModal.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    onHide: _propTypes2.default.func.isRequired,
    onClickUpgrade: _propTypes2.default.func,
    title: _propTypes2.default.string,
    reason: _propTypes2.default.string,
    extraInfo: _propTypes2.default.string,
    showStandardMessage: _propTypes2.default.bool,
    showLearnMoreLink: _propTypes2.default.bool
};
exports.default = WorkspaceUpgradeModal;

},{"prop-types":896,"react":1107,"react-modal":1041}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorSwatch = require('./ColorSwatch.react');

var _ColorSwatch2 = _interopRequireDefault(_ColorSwatch);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function ColorButton(props) {
    var colorHex = props.colorHex,
        isCurrentTextSelected = props.isCurrentTextSelected,
        colorRange = props.colorRange,
        currentFocus = props.currentFocus,
        otherProps = _objectWithoutProperties(props, ['colorHex', 'isCurrentTextSelected', 'colorRange', 'currentFocus']);

    var colors = [];

    if (!!colorRange && !!colorRange.getSelectionColors) {
        colors = colorRange.getSelectionColors(isCurrentTextSelected ? currentFocus : null);
    } else if (!!colorRange && Array.isArray(colorRange)) {
        colors = colorRange;
    } else {
        colors = [colorHex];
    }

    return _react2.default.createElement(_ColorSwatch2.default, _extends({
        colors: colors
    }, otherProps));
}

ColorButton.propTypes = {
    colorHex: _propTypes2.default.string.isRequired,
    isCurrentTextSelected: _propTypes2.default.bool,
    colorRange: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    currentFocus: _propTypes2.default.object
};

exports.default = ColorButton;

},{"./ColorSwatch.react":20,"prop-types":896,"react":1107}],18:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CustomColorPicker = require('./CustomColorPicker.react');

var _CustomColorPicker2 = _interopRequireDefault(_CustomColorPicker);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _SVGIcon = require('../SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ColorPickerButton = function (_Component) {
    _inherits(ColorPickerButton, _Component);

    function ColorPickerButton(props) {
        _classCallCheck(this, ColorPickerButton);

        var _this = _possibleConstructorReturn(this, (ColorPickerButton.__proto__ || Object.getPrototypeOf(ColorPickerButton)).call(this, props));

        var updatingColorHex = !!props.selectedColor ? (0, _color2.default)(props.selectedColor).hex() : '';
        _this.state = {
            open: false,
            editingHexCode: null,
            updatingColorHex: updatingColorHex,
            showColorEyeDropper: true
        };
        _this.initializeColorPicker = _this.initializeColorPicker.bind(_this);
        return _this;
    }

    _createClass(ColorPickerButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // this.addToProjectColors()
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);
            var actionButton = null;
            if (this.actionButton) {
                actionButton = $(this.actionButton);
            }

            var clickedOnActionButton = !!actionButton && $(e.target).closest(actionButton).length;

            if (clickedOnActionButton) {
                var _props = this.props,
                    isUpdatingColor = _props.isUpdatingColor,
                    selectedColor = _props.selectedColor,
                    onClickActionButton = _props.onClickActionButton;

                if (isUpdatingColor) {
                    var updatingColorHex = !!selectedColor ? (0, _color2.default)(selectedColor).hex() : '';
                    this.setState({ open: false, updatingColorHex: updatingColorHex });
                } else {
                    this.setState({ open: false });
                }

                onClickActionButton();
            } else if ($(e.target).closest(selectorRoot).length) {
                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                // this.addToProjectColors()
                this.setState({ open: false });
            }
        }
        // addToProjectColors(){
        //     const { selectedColor, onSelectColor} = this.props
        //     onSelectColor(selectedColor)
        // }

    }, {
        key: 'tryChangeColorFromEditor',
        value: function tryChangeColorFromEditor(editingHexCode) {
            try {
                var selectedColor = this.props.selectedColor;

                var alpha = !!selectedColor ? (0, _color2.default)(selectedColor).valpha : 1;

                var newColorHex = (0, _color2.default)('#' + editingHexCode).alpha(alpha).rgb().string();

                // Parsed successfully, send it
                this.props.onColorChangeFinish(newColorHex, this.props.selectedColor);

                this.setState({ editingHexCode: null });
            } catch (e) {
                // error parsing the color, let not clear the hex code in state
            }
        }
    }, {
        key: 'onHexCodeKeyDown',
        value: function onHexCodeKeyDown(e) {
            if (e.key == 'Enter') {
                this.tryChangeColorFromEditor(this.state.editingHexCode);
            }
        }
    }, {
        key: 'onHexCodeInputChange',
        value: function onHexCodeInputChange(e) {
            var newHexCode = e.target.value.slice(1);

            var hexLetters = /^[a-fA-F0-9]*$/;

            if (newHexCode.length <= 6 && newHexCode.match(hexLetters)) {
                this.setState({ editingHexCode: newHexCode });
            }

            if (newHexCode.length == 6) {
                this.tryChangeColorFromEditor(newHexCode);
            }
        }
    }, {
        key: 'handleHexCodeEditorBlur',
        value: function handleHexCodeEditorBlur() {
            this.setState({ editingHexCode: null });
        }
    }, {
        key: 'initializeColorPicker',
        value: function initializeColorPicker() {
            if (window.EyeDropper === undefined) {
                this.setState({ showColorEyeDropper: false });
                return;
            }
        }
    }, {
        key: 'pickColor',
        value: async function pickColor(event) {
            var eyeDropper = new EyeDropper();
            try {
                var pickedColor = await eyeDropper.open();
                this.tryChangeColorFromEditor((0, _color2.default)(pickedColor.sRGBHex).hex().slice(1));
                this.props.onColorChangeIncremental((0, _color2.default)(pickedColor.sRGBHex).hex());
                this.props.onColorChangeFinish((0, _color2.default)(pickedColor.sRGBHex).hex());
            } catch (error) {
                console.log(error);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                showActionButton = _props2.showActionButton,
                actionButtonLabel = _props2.actionButtonLabel,
                isUpdatingColor = _props2.isUpdatingColor,
                selectedColor = _props2.selectedColor,
                onColorChangeIncremental = _props2.onColorChangeIncremental,
                onColorChangeFinish = _props2.onColorChangeFinish;
            var _state = this.state,
                open = _state.open,
                editingHexCode = _state.editingHexCode,
                updatingColorHex = _state.updatingColorHex;

            var colorPickerNode = null;

            var colorHex = !!selectedColor ? (0, _color2.default)(selectedColor).hex() : '';

            var colorHexCode = editingHexCode != null ? editingHexCode : colorHex.substring(1);

            var selectedColorPreviewCls = {
                backgroundColor: '#' + colorHexCode,
                borderRadius: '3px'
            };

            if (open) {
                colorPickerNode = _react2.default.createElement('div', { className: 'color-picker' }, _react2.default.createElement(_CustomColorPicker2.default, {
                    color: '#' + colorHexCode,
                    onChange: function onChange(e) {
                        return onColorChangeIncremental(e.hex);
                    },
                    onChangeComplete: function onChangeComplete(e) {
                        return onColorChangeFinish(e.hex, selectedColor);
                    }
                }), _react2.default.createElement('div', { className: 'color-picker-hex-editor-container clearfix' }, showActionButton && _react2.default.createElement('div', {
                    className: 'selected-color-preview',
                    style: selectedColorPreviewCls
                }), _react2.default.createElement('input', {
                    className: 'color-picker-hex-editor-input',
                    type: 'text',
                    value: '#' + colorHexCode,
                    onKeyDown: function onKeyDown(e) {
                        return _this3.onHexCodeKeyDown(e);
                    },
                    onChange: function onChange(e) {
                        return _this3.onHexCodeInputChange(e);
                    },
                    onBlur: function onBlur(e) {
                        return _this3.handleHexCodeEditorBlur(e);
                    }
                }), this.state.showColorEyeDropper && _react2.default.createElement('div', {
                    id: 'eyedropperButton',
                    className: 'color-picker-dropper-button',
                    onClick: function onClick(e) {
                        return _this3.pickColor(e);
                    }
                }, _react2.default.createElement(_SVGIcon2.default, { width: 20, height: 20, iconId: 'color-picker-dropper' }))), showActionButton && _react2.default.createElement('div', { className: 'add-button-container' }, _react2.default.createElement('div', {
                    className: 'btn btn-md btn-typito-primary',
                    ref: function ref(c) {
                        _this3.actionButton = c;
                    }
                }, actionButtonLabel)));
            }
            var iconNode = null;
            if (isUpdatingColor) {
                var updateIconCls = {
                    backgroundColor: '' + updatingColorHex
                };
                iconNode = _react2.default.createElement('div', { className: 'update-color-icon', style: updateIconCls });
            } else {
                iconNode = _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'color-pick' });
            }

            return _react2.default.createElement('div', {
                className: 'color-picker-button-root',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement('div', {
                ref: function ref(c) {
                    _this3.selectorButton = c;
                },
                className: 'color-picker-trigger-button',
                onClick: this.initializeColorPicker
            }, iconNode), colorPickerNode);
        }
    }]);

    return ColorPickerButton;
}(_react.Component);

ColorPickerButton.propTypes = {
    selectedColor: _propTypes2.default.string.isRequired,
    onSelectColor: _propTypes2.default.func,
    onColorChangeIncremental: _propTypes2.default.func.isRequired,
    onColorChangeFinish: _propTypes2.default.func.isRequired,
    showActionButton: _propTypes2.default.bool,
    isUpdatingColor: _propTypes2.default.bool,
    onClickActionButton: _propTypes2.default.func,
    actionButtonLabel: _propTypes2.default.string
};
ColorPickerButton.defaultProps = {
    onSelectColor: function onSelectColor() {},
    onClickActionButton: function onClickActionButton() {},
    actionButtonLabel: 'Add',
    showActionButton: false,
    isUpdatingColor: false
};
exports.default = ColorPickerButton;

},{"../SVGIcon.react":13,"./CustomColorPicker.react":21,"color":418,"prop-types":896,"react":1107}],19:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorSwatch = require('./ColorSwatch.react');

var _ColorSwatch2 = _interopRequireDefault(_ColorSwatch);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypeToLabel = function propTypeToLabel(type) {
    if (type === 'textColor') {
        return 'Text Color';
    } else if (type === 'highlightColor') {
        return 'Highlight Color';
    } else if (type === 'highlightTextColor') {
        return 'Highlight Text Color';
    }
};

var isHighlightable = function isHighlightable(types) {
    return types.filter(function (t) {
        return t === 'highlightColor' || t === 'highlightTextColor';
    }).length > 0;
};

var ColorSelectGroup = function (_Component) {
    _inherits(ColorSelectGroup, _Component);

    function ColorSelectGroup() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ColorSelectGroup);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorSelectGroup.__proto__ || Object.getPrototypeOf(ColorSelectGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: false }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ColorSelectGroup, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                colors = _props.colors,
                isCurrentTextSelected = _props.isCurrentTextSelected,
                layerProps = _props.layerProps,
                renderLayerProp = _props.renderLayerProp,
                onClearHighlights = _props.onClearHighlights;

            return _react2.default.createElement('div', { className: 'color-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement(_ColorSwatch2.default, { colors: colors, isTextColor: true,
                dashedBorder: isCurrentTextSelected,
                cbRef: function cbRef(c) {
                    _this3.selectorButton = c;
                }
            }), this.state.open ? _react2.default.createElement('div', { className: 'color-options-container'
            }, layerProps.map(function (layerProp) {
                return _react2.default.createElement('div', { key: layerProp.prop, className: 'color-prop-wrapper' }, _react2.default.createElement('div', { className: 'color-prop-label' }, propTypeToLabel(layerProp.type)), _react2.default.createElement('div', { className: 'color-prop-select' }, renderLayerProp(layerProp)));
            }), isHighlightable(layerProps.map(function (lp) {
                return lp.type;
            })) ? _react2.default.createElement('button', { className: 'clear-highlights-button', onClick: function onClick() {
                    return onClearHighlights();
                } }, 'Clear All Highlights') : null) : null);
        }
    }]);

    return ColorSelectGroup;
}(_react.Component);

ColorSelectGroup.propTypes = {
    colors: _propTypes2.default.array.isRequired,
    renderLayerProp: _propTypes2.default.func.isRequired,
    onClearHighlights: _propTypes2.default.func.isRequired
};
exports.default = ColorSelectGroup;

},{"./ColorSwatch.react":20,"prop-types":896,"react":1107}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function ColorSwatch(props) {
    var _props$colors = props.colors,
        colors = _props$colors === undefined ? [] : _props$colors,
        _props$noColor = props.noColor,
        noColor = _props$noColor === undefined ? false : _props$noColor,
        _props$showBorder = props.showBorder,
        showBorder = _props$showBorder === undefined ? false : _props$showBorder,
        _props$showDisabledHi = props.showDisabledHighlight,
        showDisabledHighlight = _props$showDisabledHi === undefined ? false : _props$showDisabledHi,
        _props$isHighlightCol = props.isHighlightColor,
        isHighlightColor = _props$isHighlightCol === undefined ? false : _props$isHighlightCol,
        _props$cbRef = props.cbRef,
        cbRef = _props$cbRef === undefined ? function () {} : _props$cbRef,
        _props$selectorType = props.selectorType,
        selectorType = _props$selectorType === undefined ? '' : _props$selectorType,
        _props$isTextColor = props.isTextColor,
        isTextColor = _props$isTextColor === undefined ? false : _props$isTextColor,
        otherProps = _objectWithoutProperties(props, ['colors', 'noColor', 'showBorder', 'showDisabledHighlight', 'isHighlightColor', 'cbRef', 'selectorType', 'isTextColor']);

    var noColorMode = noColor || colors.length === 0;

    var background = null;

    if (!noColorMode) {
        if (colors.length === 1 || isHighlightColor) {
            var _colors = _slicedToArray(colors, 1),
                c = _colors[0];

            var color = (0, _color2.default)(c);

            if (color.valpha < 1 && !isHighlightColor && !selectorType) {
                var colorRgba = color.rgb().string();
                var colorRgbSansAlpha = color.alpha(1).rgb().string();

                background = 'linear-gradient(to right, ' + colorRgbSansAlpha + ' 0%, ' + colorRgbSansAlpha + ' 50%, ' + colorRgba + ' 50%)';
            } else {
                background = color.rgb().string();
            }
        } else {
            var uniqueColors = getUniqueColors();
            var gradientColors = uniqueColors.map(function (c, i) {
                return c + ' ' + i / uniqueColors.length * 100 + '%, ' + c + ' ' + (i + 1) / uniqueColors.length * 100 + '%';
            }).join(',');

            background = 'linear-gradient(to right ,' + gradientColors + ')';
        }
    }

    function getUniqueColors() {
        var colorRange = colors.map(function (c) {
            return (0, _color2.default)(c).alpha(1).rgb().string();
        });
        return [].concat(_toConsumableArray(new Set(colorRange)));
    }

    function getIcon() {

        if (isHighlightColor) {
            var iconId = 'highlighter' + (showDisabledHighlight ? '-disabled' : '');
            return _react2.default.createElement(_SVGIcon2.default, { iconId: iconId, className: (0, _classnames2.default)('highlight-selector', { disabled: showDisabledHighlight }), width: '100%', height: '100%', fill: background });
        } else if (!!selectorType) {
            switch (selectorType) {
                case 'color':
                    {
                        return _react2.default.createElement(_SVGIcon2.default, { iconId: 'color-drop', width: '28px', height: '28px', fill: background });
                    }
                case 'textColor':
                case 'highlightTextColor':
                    {
                        return _react2.default.createElement(_SVGIcon2.default, { iconId: 'color-text', width: '28px', height: '28px', fill: background });
                    }
            }
        } else {
            return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', { className: (0, _classnames2.default)('no-color', { hide: !noColorMode }) }, _react2.default.createElement('svg', { viewBox: '0 0 100 100' }, _react2.default.createElement('line', { className: 'line', x1: '98', y1: '2', x2: '2', y2: '98' }))), _react2.default.createElement('div', { className: (0, _classnames2.default)('alpha-bg', { hide: noColorMode }) }), _react2.default.createElement('div', { className: (0, _classnames2.default)('color-button-shape prevent-clip-select-close', {
                    'hide': noColorMode,
                    'selected': showBorder,
                    'square': isTextColor
                }), style: { background: background }
            }));
        }
    }

    return _react2.default.createElement('div', _extends({ className: 'color-button', ref: cbRef }, otherProps), getIcon());
}

ColorSwatch.propTypes = {
    colors: _propTypes2.default.array,
    noColor: _propTypes2.default.bool,
    cbRef: _propTypes2.default.func
};

exports.default = ColorSwatch;

},{"../SVGIcon.react":13,"classnames":410,"color":418,"prop-types":896,"react":1107}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactColor = require('react-color');

var _common = require('react-color/lib/components/common');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var MyPicker = function MyPicker(_ref) {
    var hex = _ref.hex,
        hsl = _ref.hsl,
        hsv = _ref.hsv,
        onChange = _ref.onChange,
        onChangeComplete = _ref.onChangeComplete;

    var styles = {
        hue: {
            height: '10px',
            position: 'relative',
            margin: '10px'
        },
        saturation: {
            height: '170px',
            position: 'relative',
            marginBottom: '20px'
        },
        saturationPointer: {
            border: '4px solid white',
            transform: 'translate(-9px, -1px)',
            height: '18px',
            borderRadius: '50%',
            width: '18px'
        },
        huePointer: {
            border: '4px solid white',
            transform: 'translate(-7px, -2px)',
            height: '15px',
            borderRadius: '50%',
            width: '15px'
        }
    };

    var SaturationPointer = function SaturationPointer() {
        return _react2.default.createElement('div', { style: styles.saturationPointer });
    };
    var HuePointer = function HuePointer() {
        return _react2.default.createElement('div', { style: styles.huePointer });
    };
    return _react2.default.createElement('div', { className: 'customColorPicker' }, _react2.default.createElement('div', { style: styles.saturation }, _react2.default.createElement(_common.Saturation, {
        hsl: hsl,
        hsv: hsv,
        pointer: SaturationPointer,
        onChange: onChange,
        onChangeComplete: onChangeComplete
    })), _react2.default.createElement('div', { className: 'hue', style: styles.hue }, _react2.default.createElement(_common.Hue, {
        hsl: hsl,
        pointer: HuePointer,
        onChange: onChange,
        onChangeComplete: onChangeComplete
    })));
};

exports.default = (0, _reactColor.CustomPicker)(MyPicker);

},{"react":1107,"react-color":955,"react-color/lib/components/common":919}],22:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Loaders = require('./Loaders.react');

var _Loaders2 = _interopRequireDefault(_Loaders);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 *
 *
 * @param {{
 *  className : string,
 *  type : "li"|"div"|"span",
 *  style : Object,
 *  height : number ,
 *  width : number ,
 *  className : string ,
 * }} props
 * @return {React.ReactElement}
 */
function LazyRectPlaceholder(props) {
    var insideElem = _react2.default.createElement('div', { className: 'rect' });

    var className = (0, _classnames2.default)('loaders', props.className);

    var element = _react2.default.createElement(_Loaders2.default, _extends({}, props, { className: className }), insideElem);

    return _react2.default.createElement(_react.Fragment, null, element);
}

exports.default = _react2.default.memo(LazyRectPlaceholder);

},{"./Loaders.react":23,"classnames":410,"react":1107}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.default = LoaderPlaceholder;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * 
 *
 * @export
 * @param {{
 *  type : "li"|"div"|"span",
 *  style : Object,
 *  height : number , 
 *  width : number , 
 *  className : string ,
 * }} props
 * @return {React.ReactElement} 
 */
function LoaderPlaceholder(props) {
    var _props$type = props.type,
        type = _props$type === undefined ? 'li' : _props$type,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        _props$height = props.height,
        height = _props$height === undefined ? "85px" : _props$height,
        _props$width = props.width,
        width = _props$width === undefined ? "85px" : _props$width,
        _props$className = props.className,
        className = _props$className === undefined ? "" : _props$className,
        _props$children = props.children,
        children = _props$children === undefined ? null : _props$children;

    style = _extends({
        height: height,
        width: width
    }, style);

    var element = _react2.default.createElement(type, {
        className: className,
        style: style,
        children: children
    });

    return _react2.default.createElement(_react.Fragment, null, element);
}

},{"react":1107}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconNotificationBadgeCounter = exports.getBadgeContentStore = exports.decreaseNotificationBadgeCounter = exports.increaseNotificationBadgeCounter = exports.clearNotificationBadgeCounterAll = exports.clearNotificationBadgeCounter = exports.badgeCounterAction = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _GeneralUtils = require('../../utils/GeneralUtils');

var _useEvent = require('../../utils/hooks/useEvent.react');

var _useEvent2 = _interopRequireDefault(_useEvent);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var dlog = (0, _GeneralUtils.createDlog)(true);

var badgeCounterAction = exports.badgeCounterAction = (0, _keymirror2.default)({
    INCREMENT_COUNTER: null,
    DECREMENT_COUNTER: null,
    CLEAR_COUNTER: null,
    CLEAR_ALL_COUNTER: null
});

var observer = (0, _useEvent.getUseEventObserver)();

var clearNotificationBadgeCounter = exports.clearNotificationBadgeCounter = function clearNotificationBadgeCounter(id) {
    observer.emit('notification-counter-badge', {
        type: badgeCounterAction.CLEAR_COUNTER,
        id: id
    });
};

var clearNotificationBadgeCounterAll = exports.clearNotificationBadgeCounterAll = function clearNotificationBadgeCounterAll() {
    observer.emit('notification-counter-badge', {
        type: badgeCounterAction.CLEAR_ALL_COUNTER
    });
};

var increaseNotificationBadgeCounter = exports.increaseNotificationBadgeCounter = function increaseNotificationBadgeCounter(id, contentId) {
    observer.emit('notification-counter-badge', {
        type: badgeCounterAction.INCREMENT_COUNTER,
        id: id,
        contentId: contentId
    });
};

var decreaseNotificationBadgeCounter = exports.decreaseNotificationBadgeCounter = function decreaseNotificationBadgeCounter(id, contentId) {
    observer.emit('notification-counter-badge', {
        type: badgeCounterAction.DECREMENT_COUNTER,
        id: id,
        contentId: contentId
    });
};

var badgeContentStore = function () {
    var store = {};
    return function (fn) {
        if (fn) store = fn(store);
        return store;
    };
}();

var getBadgeContentStore = exports.getBadgeContentStore = function getBadgeContentStore() {
    return badgeContentStore;
};

function _IconNotificationBadgeCounter(_ref) {
    var id = _ref.id,
        _ref$allowNegative = _ref.allowNegative,
        allowNegative = _ref$allowNegative === undefined ? false : _ref$allowNegative,
        otherProps = _objectWithoutProperties(_ref, ['id', 'allowNegative']);

    var _useState = (0, _react.useState)(0),
        _useState2 = _slicedToArray(_useState, 2),
        count = _useState2[0],
        setCount = _useState2[1];

    if (!id) id = (0, _react.useRef)((0, _shortid2.default)()).current;
    // initial state register in the store
    (0, _react.useEffect)(function () {
        var store = badgeContentStore(function (store) {
            return _extends({}, store, _defineProperty({}, id, {
                type: 'counter',
                count: count,
                content: {}
            }));
        });
        // dlog(store)
    }, []);

    (0, _useEvent2.default)({
        topic: 'notification-counter-badge',
        callback: function callback(_ref2) {
            var type = _ref2.type,
                requestedId = _ref2.id,
                contentId = _ref2.contentId;

            if (id !== requestedId && type !== badgeCounterAction.CLEAR_ALL_COUNTER) return;

            badgeContentStore(function (store) {
                switch (type) {
                    case badgeCounterAction.INCREMENT_COUNTER:
                        {
                            var _store$id = store[id],
                                _type = _store$id.type,
                                _count = _store$id.count,
                                content = _store$id.content;

                            if (content[contentId]) return store;

                            setCount(function (c) {
                                return ++c;
                            });
                            return _extends({}, store, _defineProperty({}, id, _extends({}, store[id], {
                                count: _count + 1,
                                content: _extends({}, content, _defineProperty({}, contentId, true))
                            })));
                        }
                    case badgeCounterAction.DECREMENT_COUNTER:
                        {
                            var _store$id2 = store[id],
                                _type2 = _store$id2.type,
                                _count2 = _store$id2.count,
                                _content = _store$id2.content;

                            if (!allowNegative && _count2 === 0) return store;
                            if (!_content[contentId]) return store;

                            setCount(function (c) {
                                return --c;
                            });
                            delete _content[contentId];
                            return _extends({}, store, _defineProperty({}, id, _extends({}, store[id], {
                                count: _count2 - 1,
                                content: _content
                            })));
                        }

                    case badgeCounterAction.CLEAR_ALL_COUNTER:
                    case badgeCounterAction.CLEAR_COUNTER:
                        {
                            var _store$id3 = store[id],
                                _type3 = _store$id3.type,
                                _count3 = _store$id3.count;

                            if (_count3 === 0) return store;
                            setCount(0);
                            return _extends({}, store, _defineProperty({}, id, _extends({}, store[id], {
                                count: 0,
                                content: {}
                            })));
                        }

                    default:
                        {
                            return store;
                        }
                }
            });
        }
    });

    var showContent = count !== 0;

    return _react2.default.createElement(IconNotificationBadgeMemo, _extends({ content: '' + count, showContent: showContent }, otherProps));
}

var IconNotificationBadgeCounter = exports.IconNotificationBadgeCounter = _react2.default.memo(_IconNotificationBadgeCounter);

function IconNotificationBadge(_ref3) {
    var _ref3$counterStyle = _ref3.counterStyle,
        counterStyle = _ref3$counterStyle === undefined ? null : _ref3$counterStyle,
        _ref3$rootContainerCl = _ref3.rootContainerClass,
        rootContainerClass = _ref3$rootContainerCl === undefined ? '' : _ref3$rootContainerCl,
        _ref3$rootContainerSt = _ref3.rootContainerStyle,
        rootContainerStyle = _ref3$rootContainerSt === undefined ? null : _ref3$rootContainerSt,
        _ref3$iconContainerCl = _ref3.iconContainerClass,
        iconContainerClass = _ref3$iconContainerCl === undefined ? '' : _ref3$iconContainerCl,
        _ref3$iconContainerSt = _ref3.iconContainerStyle,
        iconContainerStyle = _ref3$iconContainerSt === undefined ? null : _ref3$iconContainerSt,
        _ref3$content = _ref3.content,
        content = _ref3$content === undefined ? '0' : _ref3$content,
        _ref3$showContent = _ref3.showContent,
        showContent = _ref3$showContent === undefined ? false : _ref3$showContent,
        children = _ref3.children,
        otherProps = _objectWithoutProperties(_ref3, ['counterStyle', 'rootContainerClass', 'rootContainerStyle', 'iconContainerClass', 'iconContainerStyle', 'content', 'showContent', 'children']);

    var referenceId = (0, _react.useRef)((0, _shortid2.default)());

    var identityClassName = 'icon-counter-' + referenceId.current;
    var identityChildClassName = 'icon-conter-child-' + referenceId.current;

    children = _react2.default.Children.toArray(children);

    var child = children[0];

    var clone = _react2.default.cloneElement(child);
    var providClassName = clone.props.className;

    var viewElement = _react2.default.cloneElement(child, {
        className: providClassName + ' ' + identityChildClassName
    });

    var containerClass = (0, _classnames2.default)('icon-notification-badge', identityClassName, rootContainerClass);

    // useResizeDetector(({element}) => {
    //     fastdom.measure(() => {
    //         const availableDim =  {width :  element.clientWidth  , height : element.clientHeight } // border excluded
    //         console.log({
    //             availableDim , identityChildClassName
    //         })
    //     })

    // } ,[] , {
    //     fireOnLoad:true,
    //     targetContainer:`.${identityClassName}`
    // })

    iconContainerClass = (0, _classnames2.default)('counter-icon-container', iconContainerClass, {
        'hide-counter': !showContent
    });

    return _react2.default.createElement('div', _extends({ className: containerClass, style: rootContainerStyle }, otherProps), viewElement, _react2.default.createElement('div', { className: iconContainerClass, style: iconContainerStyle }, _react2.default.createElement('div', { className: 'counter-text', style: counterStyle }, content)));
}

var IconNotificationBadgeMemo = _react2.default.memo(IconNotificationBadge, function (prevProps, nextProps) {
    return prevProps.content === nextProps.content && prevProps.showContent === nextProps.showContent && prevProps.children === nextProps.children;
});

},{"../../utils/GeneralUtils":77,"../../utils/hooks/useEvent.react":105,"classnames":410,"keymirror":677,"react":1107,"shortid":1163}],25:[function(require,module,exports){
'use strict';

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHotToast = require('react-hot-toast');

var _SVGIcon = require('../SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var defaultContainerStyle = {
    height: '60px',
    width: '320px',
    padding: '0px',
    background: '#333333',
    border: '1px solid #4F4F4F',
    boxSizing: 'border-box',
    borderRadius: '4px'
};

var contextSplit = '$$-$$';

function createNotificationContext(contextId) {
    function CustomNotificationWrapper(_ref) {
        var children = _ref.children,
            _ref$closeNotificatio = _ref.closeNotification,
            closeNotification = _ref$closeNotificatio === undefined ? function () {} : _ref$closeNotificatio,
            _ref$innerRef = _ref.innerRef,
            innerRef = _ref$innerRef === undefined ? null : _ref$innerRef,
            style = _ref.style,
            _ref$className = _ref.className,
            className = _ref$className === undefined ? '' : _ref$className,
            _ref$notificationClos = _ref.notificationCloseIconId,
            notificationCloseIconId = _ref$notificationClos === undefined ? 'notification-close' : _ref$notificationClos,
            id = _ref.id;

        var customClass = (0, _classnames2.default)('notification-card', className);

        return _react2.default.createElement('div', { ref: innerRef, style: style, className: customClass, id: id }, _react2.default.createElement('div', { className: 'notification-container' }, children, _react2.default.createElement('div', { className: 'cross-button', onClick: closeNotification }, _react2.default.createElement(_SVGIcon2.default, { iconId: notificationCloseIconId, height: '100%', width: '100%' }))));
    }

    function dismissToast(id) {
        var tContext = id.split(contextSplit)[0];
        if (tContext == contextId) _reactHotToast.toast.dismiss(id);
    }

    function isToastVisible(t) {
        var tContext = t.id.split(contextSplit)[0];
        return t.visible && tContext == contextId;
    }

    /**
     *
     *
     * How to use ?
     * - use the notify , function to pop up a notification using default settings
     * - But ideally use the custom notifyWithComponent , or notifyWithText
     * - notifyWithComponent takes parameter and close event function
     *
     * maxToast : limits number of toast can come up at once
     *
     *
     *
     *
     * @export
     * @param {{
     *  defaultPosition : "bottom-center" | "bottom-left" | "bottom-right" | "top-center" | "top-right" | "top-left",
     *  defaultDuration : number ,
     *  className : string,
     *  maxToast : number ,
     *  children
     * }}
     * @return {*}
     */
    function NotificationCard(props) {
        var _props$defaultPositio = props.defaultPosition,
            defaultPosition = _props$defaultPositio === undefined ? 'bottom-left' : _props$defaultPositio,
            _props$defaultDuratio = props.defaultDuration,
            defaultDuration = _props$defaultDuratio === undefined ? 100000 : _props$defaultDuratio,
            className = props.className,
            _props$maxToast = props.maxToast,
            maxToast = _props$maxToast === undefined ? 3 : _props$maxToast;

        var containerClass = (0, _classnames2.default)('notification-card-cover', className);

        var _useToasterStore = (0, _reactHotToast.useToasterStore)(),
            toasts = _useToasterStore.toasts;

        var notificationRootRef = (0, _react.useRef)(null);

        var _useState = (0, _react.useState)(0),
            _useState2 = _slicedToArray(_useState, 2),
            _ = _useState2[0],
            setState = _useState2[1];

        var forceRender = function forceRender() {
            return setState(function (v) {
                return ++v;
            });
        };

        (0, _react.useEffect)(function () {
            var filteredToasts = toasts;

            // DISMISS NOTIFICATION BASED ON MAX NOTIFICATION ALLOWED
            var persisToast = filteredToasts.filter(function (t) {
                return isToastVisible(t) && !!t.persist;
            });
            var normalToast = filteredToasts.filter(function (t) {
                return isToastVisible(t) && !t.persist;
            });
            var combined = [].concat(_toConsumableArray(persisToast), _toConsumableArray(normalToast));
            combined.slice(maxToast, combined.length).forEach(function (v) {
                return dismissToast(v.id);
            });
        }, [toasts]);

        (0, _react.useEffect)(function () {
            var body = document.querySelector('body');
            var element = document.createElement('div');
            element.id = 'notification-global-portal-container';
            body.appendChild(element);
            notificationRootRef.current = element;
            forceRender();
        }, []);

        if (notificationRootRef.current == null) return null;

        return _reactDom2.default.createPortal(_react2.default.createElement(_reactHotToast.Toaster, {
            position: defaultPosition,
            containerClassName: containerClass,
            toastOptions: {
                duration: defaultDuration
            }
        }, function (t) {
            if (isToastVisible(t)) {
                return _react2.default.createElement(_reactHotToast.ToastBar, { toast: t, style: defaultContainerStyle }, function (_ref2) {
                    var message = _ref2.message;
                    return _react2.default.createElement(CustomNotificationWrapper, { closeNotification: function closeNotification() {
                            return dismissToast(t.id);
                        }, id: t.id }, message);
                });
            }
            return null;
        }), notificationRootRef.current);
    }

    /**
     *
     * Send a Message as a Toast , useful for Basic text most of the time
     * Style component will control the style container
     * can send an extra icon as well
     *
     *
     * @param {*} message
     * @param {*} [{ id, duration = 4000, position, style = null, persist = false, x = null, y = null, icon = '❎' }={}]
     * @return {*}
     */
    var notifyWithText = function notifyWithText(message) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            id = _ref3.id,
            _ref3$duration = _ref3.duration,
            duration = _ref3$duration === undefined ? 4000 : _ref3$duration,
            position = _ref3.position,
            _ref3$textContainerSt = _ref3.textContainerStyle,
            textContainerStyle = _ref3$textContainerSt === undefined ? null : _ref3$textContainerSt,
            _ref3$componentStyle = _ref3.componentStyle,
            componentStyle = _ref3$componentStyle === undefined ? {} : _ref3$componentStyle,
            _ref3$customClass = _ref3.customClass,
            customClass = _ref3$customClass === undefined ? null : _ref3$customClass,
            _ref3$persist = _ref3.persist,
            persist = _ref3$persist === undefined ? false : _ref3$persist,
            _ref3$x = _ref3.x,
            x = _ref3$x === undefined ? null : _ref3$x,
            _ref3$y = _ref3.y,
            y = _ref3$y === undefined ? null : _ref3$y,
            _ref3$icon = _ref3.icon,
            icon = _ref3$icon === undefined ? '' : _ref3$icon,
            notificationCloseIconId = _ref3.notificationCloseIconId,
            _ref3$onClose = _ref3.onClose,
            onClose = _ref3$onClose === undefined ? null : _ref3$onClose;

        return notifyWithComponent(_react2.default.createElement('div', { className: 'text-container', style: textContainerStyle }, icon, ' ', message), {
            id: id,
            duration: duration,
            position: position,
            persist: persist,
            x: x,
            y: y,
            notificationCloseIconId: notificationCloseIconId,
            onClose: onClose,
            customClass: customClass,
            style: componentStyle
        });
    };

    /**
     * Send an entire component for notification
     *
     * style will applied to container any other style can comr from the custom component being sent
     * persist - if u want the notification to persist even if there are multiple notfication more than maxout
     *
     *
     */
    var notifyWithComponent = function notifyWithComponent() {
        var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            id = _ref4.id,
            _ref4$duration = _ref4.duration,
            duration = _ref4$duration === undefined ? 4000 : _ref4$duration,
            position = _ref4.position,
            _ref4$style = _ref4.style,
            style = _ref4$style === undefined ? {} : _ref4$style,
            _ref4$persist = _ref4.persist,
            persist = _ref4$persist === undefined ? false : _ref4$persist,
            _ref4$x = _ref4.x,
            x = _ref4$x === undefined ? null : _ref4$x,
            _ref4$y = _ref4.y,
            y = _ref4$y === undefined ? null : _ref4$y,
            _ref4$onClose = _ref4.onClose,
            onClose = _ref4$onClose === undefined ? null : _ref4$onClose,
            customClass = _ref4.customClass,
            notificationCloseIconId = _ref4.notificationCloseIconId;

        if (!component) return;
        // const containerStyle = {};

        // if (!!x && !!y) {
        //     position = 'bottom-left';
        //     containerStyle.left = x;
        //     containerStyle.top = y;
        // }

        var idWithContext = '' + contextId + contextSplit + id;

        var toastId = _reactHotToast.toast.custom(function (t) {
            return _react2.default.createElement(_reactHotToast.ToastBar, { toast: t }, function (_ref5) {
                var message = _ref5.message;
                return _react2.default.createElement(CustomNotificationWrapper, {
                    className: customClass,
                    closeNotification: function closeNotification() {
                        if (!!onClose) onClose();
                        dismissToast(t.id);
                    },
                    notificationCloseIconId: notificationCloseIconId,
                    id: idWithContext
                }, component);
            });
        }, {
            id: idWithContext,
            duration: duration,
            position: position,
            persist: persist,
            style: _extends({}, defaultContainerStyle, style),
            x: x,
            y: y
        });

        return toastId;
    };

    // export const notifyWithCustomComponent = (
    //     component,
    //     { id, duration = 4000, position, style = {}, persist = false } = {}
    // ) => {
    //     return toast.custom(component, {
    //         id,
    //         duration: duration,
    //         position,
    //         style: {
    //             ...defaultContainerStyle,
    //             style,
    //         },
    //         persist,
    //     });
    // };

    var notify = _reactHotToast.toast;
    return {
        notify: notify,
        notifyWithComponent: notifyWithComponent,
        notifyWithText: notifyWithText,
        NotificationCard: NotificationCard,
        dismissToast: dismissToast,
        isToastVisible: isToastVisible,
        CustomNotificationWrapper: CustomNotificationWrapper
    };
}

var defaults = createNotificationContext('default');

module.exports = _extends({}, defaults, { createNotificationContext: createNotificationContext });

},{"../SVGIcon.react":13,"classnames":410,"react":1107,"react-dom":1016,"react-hot-toast":1018}],26:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannerDiv = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.showNudgeBanner = showNudgeBanner;
exports.dismissNudgeBanner = dismissNudgeBanner;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _constants = require('./constants');

var _NotificationCard = require('./NotificationCard.react');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var initialState = {
    items: []
};

var reducer = function reducer(state, action) {
    switch (action.type) {
        case _constants.BannerActions.SHOW_BANNER:
            {
                var data = action.data;

                return _extends({}, state, {
                    items: [data].concat(_toConsumableArray(state.items)) // front of the list
                });
            }

        case _constants.BannerActions.UPDATE_BANNER:
            {
                var _data = action.data;

                var index = state.items.findIndex(function (v) {
                    return v.id === _data.id;
                });
                if (index < 0) return state;

                state.items[index] = _extends({}, state.items[index], _data);

                return _extends({}, state, {
                    items: [].concat(_toConsumableArray(state.items)) // front of the list
                });
            }

        case _constants.BannerActions.HIDE_BANNER:
            {
                var id = action.id;

                var _index = state.items.findIndex(function (v) {
                    return v.id === id;
                });
                if (_index < 0) return state;

                if (state.items[_index] && !state.items[_index].visible && !state.items[_index].persist) {
                    return state;
                }

                var newItems = [].concat(_toConsumableArray(state.items));
                newItems[_index] = _extends({}, newItems[_index], {
                    visible: false,
                    persist: false
                });
                return _extends({}, state, {
                    items: newItems
                });
            }
        case _constants.BannerActions.REMOVE_BANNER:
            {
                var _id = action.id;

                var _newItems = state.items.filter(function (v) {
                    return v.id !== _id;
                });

                return _extends({}, state, {
                    items: _newItems
                });
            }

        default:
            {
                return state;
            }
    }
};

var doBannerDipatch = function doBannerDipatch() {
    throw new Error('BannerCard not instantiated yet');
};

var shouldShowBanner = function shouldShowBanner(item) {
    return item.visible && item.component;
};

var globalDispatch = function globalDispatch() {
    throw new Error('Banner card no instantiated yet');
};

exports.default = _react2.default.memo(function (_ref) {
    _objectDestructuringEmpty(_ref);

    var _useReducer = (0, _react.useReducer)(reducer, initialState),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        state = _useReducer2[0],
        dispatch = _useReducer2[1];

    globalDispatch = dispatch;

    doBannerDipatch = function doBannerDipatch(_ref2) {
        var _ref2$id = _ref2.id,
            id = _ref2$id === undefined ? (0, _shortid2.default)() : _ref2$id,
            _ref2$createdTime = _ref2.createdTime,
            createdTime = _ref2$createdTime === undefined ? -1 : _ref2$createdTime,
            _ref2$persist = _ref2.persist,
            persist = _ref2$persist === undefined ? true : _ref2$persist,
            _ref2$duration = _ref2.duration,
            duration = _ref2$duration === undefined ? Infinity : _ref2$duration,
            _ref2$visible = _ref2.visible,
            visible = _ref2$visible === undefined ? false : _ref2$visible,
            _ref2$direction = _ref2.direction,
            direction = _ref2$direction === undefined ? 'vertical' : _ref2$direction,
            otherData = _objectWithoutProperties(_ref2, ['id', 'createdTime', 'persist', 'duration', 'visible', 'direction']);

        var items = state.items;

        var index = items.findIndex(function (v) {
            return v.id === id;
        });
        var data = void 0;

        if (index >= 0) {
            var item = items[index];
            data = _extends({}, item, {
                persist: persist,
                duration: duration,
                visible: visible
            }, otherData);
            clearTimeout(data.hideTimeout);
            dispatch({ type: _constants.BannerActions.UPDATE_BANNER, data: data });
        } else {
            data = _extends({
                id: id,
                createdTime: createdTime,
                persist: persist,
                duration: duration,
                direction: direction,
                visible: visible,
                hideTimeout: null,
                removeTimeout: null
            }, otherData);

            dispatch({ type: _constants.BannerActions.SHOW_BANNER, data: data });
            dlog('created nudge for display ', data);
        }

        if (!persist) {
            clearTimeout(data.hideTimeout);
            data.hideTimeout = setTimeout(function () {
                dispatch({ type: _constants.BannerActions.HIDE_BANNER, id: id });
            }, duration);
            // data.removeTimeout = setTimeout(() => {
            //     globalDispatch({ type: NudgeActions.REMOVE_NUDGE, id: id });
            // }, MAX_LIFETIME_NUDGE + duration);
        }
        return id;
    };

    var items = state.items;

    dlog('banner state : ', state);

    (0, _react.useEffect)(function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (shouldShowBanner(item)) {
                    var setComponentState = item.setComponentState;

                    setComponentState({
                        component: item.component,
                        onClose: item.onClose,
                        visible: item.visible,
                        direction: item.direction
                    });
                } else {
                    if (item.component) {
                        var _setComponentState = item.setComponentState;

                        _setComponentState({
                            component: item.component,
                            onClose: item.onClose,
                            visible: item.visible,
                            direction: item.direction
                        });
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [state.items]);

    return null;
}, function () {
    return true;
});

/**
 * Use component to establish and create a Banner
 * Which can then show content based on `showNudgeBanner`
 *
 *
 * @export
 * @param {string} { bannerId }
 * @return {*}
 */

var BannerDiv = exports.BannerDiv = _react2.default.memo(function (_ref3) {
    var bannerId = _ref3.bannerId,
        _ref3$visible = _ref3.visible,
        visible = _ref3$visible === undefined ? false : _ref3$visible;

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        componentState = _useState2[0],
        setComponentState = _useState2[1];

    (0, _react.useEffect)(function () {
        doBannerDipatch({
            id: bannerId,
            setComponentState: setComponentState,
            visible: visible
        });
    }, []);

    var containerRef = (0, _react.useRef)(null);
    var nonZeroHeight = (0, _react.useRef)(0);
    var nonZeroWidth = (0, _react.useRef)(0);

    (0, _react.useEffect)(function () {
        var containerElement = containerRef.current;
        if (containerElement && componentState) {
            _fastdom2.default.measure(function () {
                var box = containerElement.getBoundingClientRect();
                var height = box.height,
                    width = box.width;

                if (height !== 0) nonZeroHeight.current = height;
                if (width !== 0) nonZeroWidth.current = width;

                var visible = componentState.visible,
                    direction = componentState.direction;

                var prop = direction === 'vertical' ? 'height' : 'width';
                var maxValue = direction === 'vertical' ? nonZeroHeight.current : nonZeroWidth.current;
                var currentMaxValue = direction === 'vertical' ? height : width;

                if (maxValue == 0) return;

                if (visible && currentMaxValue === 0) {
                    TweenMax.fromTo(containerElement, 0.1, _defineProperty({}, prop, 0), _defineProperty({}, prop, maxValue));
                    return;
                }

                // Intent of hiding and at max height
                if (!visible && currentMaxValue === maxValue) {
                    TweenMax.fromTo(containerElement, 0.1, _defineProperty({}, prop, maxValue), _defineProperty({}, prop, 0));
                    return;
                }
            });
        }
    }, [containerRef, componentState]);

    if (!componentState) return _react2.default.createElement('div', { ref: containerRef, className: 'notification-card-cover banner' });

    var onClose = componentState.onClose,
        component = componentState.component,
        direction = componentState.direction;

    dlog('Banner : ' + bannerId + ' :', componentState);

    var containerClasses = void 0;

    if (direction === 'vertical') containerClasses = (0, _classnames2.default)('notification-card-cover', 'banner', 'growy-animation');else containerClasses = (0, _classnames2.default)('notification-card-cover', 'banner');

    var closeClick = function closeClick() {
        if (onClose) onClose();
        dismissNudgeBanner(bannerId);
    };

    return _react2.default.createElement('div', { ref: containerRef, className: containerClasses }, _react2.default.createElement(_NotificationCard.CustomNotificationWrapper, { closeNotification: closeClick }, component));
}, function () {
    return true;
});

/**
 *
 *
 * @export
 * @param {React.Component | React.FunctionComponent} component
 * @param {{
 *  onClose : Function  ,
 *  id : string ,
 *  duration : number ,
 *  persist : boolean  ,
 *  direction : "vertical" | "horizontal"
 * }}
 * @return {string}
 */
function showNudgeBanner(component) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$onClose = _ref4.onClose,
        onClose = _ref4$onClose === undefined ? function () {} : _ref4$onClose,
        id = _ref4.id,
        _ref4$duration = _ref4.duration,
        duration = _ref4$duration === undefined ? Infinity : _ref4$duration,
        _ref4$persist = _ref4.persist,
        persist = _ref4$persist === undefined ? false : _ref4$persist,
        _ref4$direction = _ref4.direction,
        direction = _ref4$direction === undefined ? 'vertical' : _ref4$direction;

    return doBannerDipatch({
        id: id,
        createdTime: Date.now(),
        persist: persist,
        duration: duration,
        visible: true,
        direction: 'vertical',
        component: component
    });
}

function dismissNudgeBanner(id) {
    globalDispatch({ type: _constants.BannerActions.HIDE_BANNER, id: id });
}

},{"./NotificationCard.react":25,"./constants":28,"classnames":410,"fastdom":634,"react":1107,"shortid":1163}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NudgeDiv = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.showNudgeTooltip = showNudgeTooltip;
exports.dismissNudge = dismissNudge;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _constants = require('./constants');

var _NotificationCard = require('./NotificationCard.react');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var MAX_LIFETIME_NUDGE = 30000;

var initialState = {
    items: []
};

var reducer = function reducer(state, action) {
    switch (action.type) {
        case _constants.NudgeActions.SHOW_NUDGE:
            {
                var data = action.data;

                return _extends({}, state, {
                    items: [data].concat(_toConsumableArray(state.items)) // front of the list
                });
            }

        case _constants.NudgeActions.UPDATE_NUDGE:
            {
                var _data = action.data;

                var index = state.items.findIndex(function (v) {
                    return v.id === _data.id;
                });
                if (index < 0) return state;

                state.items[index] = _extends({}, state.items[index], _data);

                return _extends({}, state, {
                    items: [].concat(_toConsumableArray(state.items)) // front of the list
                });
            }

        case _constants.NudgeActions.HIDE_NUDGE:
            {
                var id = action.id;

                var _index = state.items.findIndex(function (v) {
                    return v.id === id;
                });
                if (_index < 0) return state;

                var newItems = [].concat(_toConsumableArray(state.items));
                newItems[_index] = _extends({}, newItems[_index], {
                    visible: false,
                    persist: false
                });
                return _extends({}, state, {
                    items: newItems
                });
            }
        case _constants.NudgeActions.REMOVE_NUDGE:
            {
                var _id = action.id;

                var _newItems = state.items.filter(function (v) {
                    return v.id !== _id;
                });

                return _extends({}, state, {
                    items: _newItems
                });
            }

        default:
            {
                return state;
            }
    }
};

var globalState = void 0;

var globalDispatch = void 0;

var THEME = {
    blue: {
        borderColor: '#2F80ED',
        arrowColor: '#2F80ED',
        backgroundColor: '#2F80ED'
    }
};

var globalUseReducer = function globalUseReducer(reducer, initialState) {
    var _useReducer = (0, _react.useReducer)(reducer, initialState),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        state = _useReducer2[0],
        dispatch = _useReducer2[1];

    globalState = state;
    globalDispatch = dispatch;

    return [state, dispatch];
};

var doNudgeDispatch = function doNudgeDispatch() {
    throw new Error('NudgeCard not initialised yet');
};

function _nudgeDiv(_ref) {
    var tooltipId = _ref.tooltipId,
        _ref$debug = _ref.debug,
        debug = _ref$debug === undefined ? true : _ref$debug,
        innerRef = _ref.innerRef,
        otherData = _objectWithoutProperties(_ref, ['tooltipId', 'debug', 'innerRef']);

    var divRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function () {
        if (divRef.current) {
            if (innerRef) {
                innerRef.current = divRef.current;
            }

            if (tooltipId) {
                doNudgeDispatch({
                    id: tooltipId,
                    element: divRef.current
                });
                dlog('updated nudge element for - ' + tooltipId + ' with :', divRef.current);
            }
        }
    }, []);

    return _react2.default.createElement('div', _extends({ ref: divRef, 'data-for': tooltipId, 'data-tip': 'tip - ' + tooltipId }, otherData));
}

var NudgeDiv = exports.NudgeDiv = _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(_nudgeDiv, _extends({}, props, { innerRef: ref }));
});

var shouldShowToolTip = function shouldShowToolTip(item) {
    return item.visible && item.element;
};
var defaultCustomPosition = function defaultCustomPosition(_ref2, currentEvent, currentTarget, node, place, desiredPlace, effect, offset) {
    var left = _ref2.left,
        top = _ref2.top;

    // TODO -- enforce positioning , by having arrows on side

    // console.log({
    //     left , top , currentEvent , currentTarget , node , place , desiredPlace , effect , offset
    // })

    // if(currentTarget){
    //     const boudingBox = currentTarget.getBoundingClientRect()

    // }

    return {
        left: left,
        top: top
    };
};

exports.default = _react2.default.memo(function (_ref3) {
    var _ref3$theme = _ref3.theme,
        theme = _ref3$theme === undefined ? 'blue' : _ref3$theme;

    var _globalUseReducer = globalUseReducer(reducer, initialState),
        _globalUseReducer2 = _slicedToArray(_globalUseReducer, 2),
        state = _globalUseReducer2[0],
        dispatch = _globalUseReducer2[1];

    var items = state.items;

    doNudgeDispatch = function doNudgeDispatch() {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _ref4$id = _ref4.id,
            id = _ref4$id === undefined ? (0, _shortid2.default)() : _ref4$id,
            _ref4$createdTime = _ref4.createdTime,
            createdTime = _ref4$createdTime === undefined ? -1 : _ref4$createdTime,
            _ref4$persist = _ref4.persist,
            persist = _ref4$persist === undefined ? true : _ref4$persist,
            _ref4$duration = _ref4.duration,
            duration = _ref4$duration === undefined ? Infinity : _ref4$duration,
            _ref4$visible = _ref4.visible,
            visible = _ref4$visible === undefined ? false : _ref4$visible,
            _ref4$place = _ref4.place,
            place = _ref4$place === undefined ? 'right' : _ref4$place,
            otherData = _objectWithoutProperties(_ref4, ['id', 'createdTime', 'persist', 'duration', 'visible', 'place']);

        var items = globalState.items;

        var index = items.findIndex(function (v) {
            return v.id === id;
        });
        var data = void 0;

        if (index >= 0) {
            var item = items[index];
            data = _extends({}, item, {
                persist: persist,
                duration: duration,
                visible: visible,
                place: place
            }, otherData);

            clearTimeout(data.hideTimeout);
            clearTimeout(data.removeTimeout);

            dispatch({ type: _constants.NudgeActions.UPDATE_NUDGE, data: data });
        } else {
            data = _extends({
                id: id,
                createdTime: createdTime,
                persist: persist,
                duration: duration,
                place: place,
                visible: visible,
                hideTimeout: null,
                removeTimeout: null
            }, otherData);

            dispatch({ type: _constants.NudgeActions.SHOW_NUDGE, data: data });
            dlog('created nudge for display ', data);
        }

        if (!persist) {
            data.hideTimeout = setTimeout(function () {
                dispatch({ type: _constants.NudgeActions.HIDE_NUDGE, id: id });
            }, duration);

            // data.removeTimeout = setTimeout(() => {
            //     globalDispatch({ type: NudgeActions.REMOVE_NUDGE, id: id });
            // }, MAX_LIFETIME_NUDGE + duration);
        }

        return id;
    };

    (0, _react.useEffect)(function () {
        dlog(state);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (shouldShowToolTip(item)) {
                    _reactTooltip2.default.show(item.element);
                } else {
                    _reactTooltip2.default.hide(item.element);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [items]);

    return _react2.default.createElement(_react.Fragment, null, items.map(function (item) {
        var onClose = item.onClose,
            _item$component = item.component,
            component = _item$component === undefined ? null : _item$component,
            visible = item.visible,
            customPosition = item.customPosition;

        if (!item.element || !component || !visible) return null;

        var onCloseNudge = function onCloseNudge() {
            dismissNudge(item.id);
            if (onClose) {
                onClose(item.id);
            }
        };
        var overridePositon = defaultCustomPosition;
        if (!!customPosition) {
            overridePositon = customPosition;
        }

        return _react2.default.createElement(_reactTooltip2.default, _extends({
            key: item.id,
            event: 'no-event'
        }, THEME[theme], {
            className: 'nudge-container',
            effect: 'solid',
            overridePosition: overridePositon,
            place: item.place,
            disable: !item.visible,
            clickable: item.visible,
            resizeHide: false,
            scrollHide: false,
            isCapture: true,
            id: item.id
        }), _react2.default.createElement(_NotificationCard.CustomNotificationWrapper, { closeNotification: onCloseNudge }, component));
    }));
}, function () {
    return true;
});

/**
 *
 *
 * @export
 * @param {React.Component | React.FunctionComponent} component
 * @param {{
 *  onClose : Function  ,
 *  id : string ,
 *  duration : number ,
 *  persist : boolean  ,
 *  place : "right" | "left" | "top" | "bottom",
 *  customPosition : Function,
 * }}
 * @return {string}
 */

function showNudgeTooltip(component) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref5$onClose = _ref5.onClose,
        onClose = _ref5$onClose === undefined ? function () {} : _ref5$onClose,
        id = _ref5.id,
        _ref5$duration = _ref5.duration,
        duration = _ref5$duration === undefined ? Infinity : _ref5$duration,
        _ref5$persist = _ref5.persist,
        persist = _ref5$persist === undefined ? false : _ref5$persist,
        _ref5$place = _ref5.place,
        place = _ref5$place === undefined ? 'left' : _ref5$place,
        _ref5$customPosition = _ref5.customPosition,
        customPosition = _ref5$customPosition === undefined ? null : _ref5$customPosition;

    return doNudgeDispatch({
        id: id,
        createdTime: Date.now(),
        duration: duration,
        persist: duration === Infinity || persist,
        place: place,
        visible: true,
        onClose: onClose,
        component: component,
        customPosition: customPosition
    });
}

function dismissNudge(id) {
    globalDispatch({ type: _constants.NudgeActions.HIDE_NUDGE, id: id });
}

if (DEBUG) {
    window.rct = _reactTooltip2.default;
    window.dismissNudge = dismissNudge;
}

},{"./NotificationCard.react":25,"./constants":28,"react":1107,"react-tooltip":1092,"shortid":1163}],28:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannerActions = exports.NudgeActions = exports.Category = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Category = exports.Category = (0, _keymirror2.default)({
    CARD: null,
    NUDGE: null
});

var NudgeActions = exports.NudgeActions = (0, _keymirror2.default)({
    SHOW_NUDGE: null,
    HIDE_NUDGE: null,
    REMOVE_NUDGE: null,
    UPDATE_NUDGE: null
});

var BannerActions = exports.BannerActions = (0, _keymirror2.default)({
    SHOW_BANNER: null,
    HIDE_BANNER: null,
    REMOVE_BANNER: null,
    UPDATE_BANNER: null
});

},{"keymirror":677}],29:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSVGTemplateDefFromWorkspaceSVG = exports.createBitmapTemplateDefFromWorkspaceImage = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _TemplateTypes = require('../constants/TemplateTypes');

var _TemplateTypes2 = _interopRequireDefault(_TemplateTypes);

var _GeneralUtils = require('../utils/GeneralUtils');

var _AllTemplateDefs = require('./AllTemplateDefs1');

var _AllTemplateDefs2 = _interopRequireDefault(_AllTemplateDefs);

var _AllTemplateDefs3 = require('./AllTemplateDefs2');

var _AllTemplateDefs4 = _interopRequireDefault(_AllTemplateDefs3);

var _AllTemplateDefs5 = require('./AllTemplateDefs3');

var _AllTemplateDefs6 = _interopRequireDefault(_AllTemplateDefs5);

var _AllTemplateDefs7 = require('./AllTemplateDefs4');

var _AllTemplateDefs8 = _interopRequireDefault(_AllTemplateDefs7);

var _AllTemplateDefs9 = require('./AllTemplateDefs5');

var _AllTemplateDefs10 = _interopRequireDefault(_AllTemplateDefs9);

var _AllTemplateDefs11 = require('./AllTemplateDefs6');

var _AllTemplateDefs12 = _interopRequireDefault(_AllTemplateDefs11);

var _AllTemplateDefs13 = require('./AllTemplateDefs7');

var _AllTemplateDefs14 = _interopRequireDefault(_AllTemplateDefs13);

var _AllTemplateDefs15 = require('./AllTemplateDefs8');

var _AllTemplateDefs16 = _interopRequireDefault(_AllTemplateDefs15);

var _AllTemplateDefs17 = require('./AllTemplateDefs9');

var _AllTemplateDefs18 = _interopRequireDefault(_AllTemplateDefs17);

var _AllTemplateDefs19 = require('./AllTemplateDefs10');

var _AllTemplateDefs20 = _interopRequireDefault(_AllTemplateDefs19);

var _dataSvgs = require('./data-svgs');

var _dataSvgs2 = _interopRequireDefault(_dataSvgs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var defs = [];

var createSVGTemplateDefFromWorkspaceSVG = function createSVGTemplateDefFromWorkspaceSVG(svgData) {
    var _attrs;

    var namingFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_ref) {
        var id = _ref.id;

        return 'defId-userSVGTemplate-' + id;
    };
    var createUniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_ref2) {
        var id = _ref2.id;
        return '' + id;
    };
    var _svgData$svgString = svgData.svgString,
        svgString = _svgData$svgString === undefined ? undefined : _svgData$svgString,
        assetSource = svgData.assetSource,
        _svgData$generatedMet = svgData.generatedMetaData,
        generatedMetaData = _svgData$generatedMet === undefined ? {} : _svgData$generatedMet;

    var lazyLoadedSvg = !svgString;
    if (lazyLoadedSvg) svgString = _dataSvgs2.default['loading_placeholder'];

    var _generatedMetaData$he = generatedMetaData.height,
        height = _generatedMetaData$he === undefined ? 200 : _generatedMetaData$he,
        _generatedMetaData$wi = generatedMetaData.width,
        width = _generatedMetaData$wi === undefined ? 200 : _generatedMetaData$wi,
        _generatedMetaData$as = generatedMetaData.aspectRatio,
        aspectRatio = _generatedMetaData$as === undefined ? 1 : _generatedMetaData$as,
        _generatedMetaData$la = generatedMetaData.layerPropertyHash,
        layerPropertyHash = _generatedMetaData$la === undefined ? '' : _generatedMetaData$la,
        _generatedMetaData$la2 = generatedMetaData.layerProps,
        layerProps = _generatedMetaData$la2 === undefined ? {} : _generatedMetaData$la2,
        _generatedMetaData$te = generatedMetaData.templateProps,
        templateProps = _generatedMetaData$te === undefined ? {} : _generatedMetaData$te,
        _generatedMetaData$de = generatedMetaData.defaultTemplateProps,
        defaultTemplateProps = _generatedMetaData$de === undefined ? {} : _generatedMetaData$de,
        _generatedMetaData$pr = generatedMetaData.previewUrl,
        previewUrl = _generatedMetaData$pr === undefined ? '' : _generatedMetaData$pr;

    var viewBox = [0, 0, width, height].join(' ');

    return {
        id: namingFunc(svgData),
        desc: 'SVG Template from ' + assetSource,
        type: _TemplateTypes2.default.ICONS,
        meta: {
            nativeAspectRatio: aspectRatio,
            canOverrideAnimation: true,
            source: assetSource,
            dynamicSvg: lazyLoadedSvg,
            dynamicSvgLayerId: ['s1'],
            viewBox: viewBox,
            previewUrl: previewUrl
        },
        props: _extends({
            alpha: 'alpha',
            shadow: 'shadow'
        }, templateProps),
        defaults: _extends({
            alpha: 1,
            shadow: false
        }, defaultTemplateProps),
        layers: [{
            id: 's1',
            desc: 'static svg layer',
            type: 'svg',
            meta: {
                svgData: svgString, // not changing
                layerProps: layerProps
            },
            attrs: (_attrs = {
                x: 0,
                y: 0,
                alpha: '${alpha}',
                width: '${ow}',
                height: '${oh}'
            }, _defineProperty(_attrs, 'alpha', '${alpha}'), _defineProperty(_attrs, 'shadowEnabled', '${shadow}'), _defineProperty(_attrs, 'svgId', createUniqueId(svgData)), _defineProperty(_attrs, 'layerPropertyHash', layerPropertyHash), _attrs),
            animation: {
                enterkeyframes: {},
                exitkeyframes: {}
            }
        }]
    };
};

var createBitmapTemplateDefFromWorkspaceImage = function createBitmapTemplateDefFromWorkspaceImage(wImage) {
    var id = wImage.id,
        width = wImage.width,
        height = wImage.height;

    return {
        id: 'defId-userBitmap-' + id,
        desc: 'User bitmap',
        meta: {
            canOverrideAnimation: true,
            // scaleOnly : true, // Image Overlays will support scaling in all direction
            nativeAspectRatio: width / height,
            imageId: id,
            mappings: {}
        },
        props: {
            alpha: 'alpha',
            shadow: 'shadow',
            crop: 'crop',
            imageId: 'imageId'
        },
        defaults: {
            alpha: 1,
            shadow: false,
            crop: 'none',
            imageId: id
        },
        layers: [{
            id: 'b1',
            desc: 'Only bitmap',
            type: 'bitmap',
            attrs: {
                imageId: '${imageId}',
                alpha: '${alpha}',
                width: '${ow}',
                height: '${oh}',
                crop: '${crop}',
                shadowEnabled: '${shadow}'
            },
            animation: {
                enterkeyframes: {},
                exitkeyframes: {}
            }
        }]
    };
};

// Basic text - legacy
defs.push({
    id: 'defId-legacyText',
    desc: 'Plain multiline text',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        textColor1: '#FFFFFF',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// SVG badge-1
defs.push({
    id: 'defId-Sk_viB25',
    desc: 'Badge 1',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (476.2/560)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M238.8,63.1c-0.2,0-0.7-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0C142.7,63,66,139.7,66,234.3c0,94.6,76.7,171.3,171.3,171.3\n            \t\t      c0.2,0,0.4,0,0.7,0c0,0,0.5,0.1,0.8,0.1c94.6,0,171.3-76.7,171.3-171.3C410.1,139.8,333.4,63.1,238.8,63.1z\n                          M405.8,371.2c2.3-0.6,5-0.8,7.9-0.4c12.7,1.9,18.3-5.8,12.5-17.2c-5.7-11.4,0-21.4,12.8-22.1c12.8-0.7,16.7-9.5,8.7-19.5\n                            c-8-10-4.5-20.9,7.8-24.3c12.4-3.3,14.4-12.8,4.4-20.9c-9.9-8.1-8.7-19.5,2.7-25.4c11.4-5.9,11.4-15.4,0-21.3\n                            c-11.4-5.9-12.6-17.3-2.7-25.4c9.9-8.1,7.9-17.5-4.4-20.8c-12.3-3.4-15.9-14.3-7.8-24.3c8-10,4.1-18.7-8.7-19.5\n                      \t\tc-12.8-0.7-18.5-10.7-12.8-22.1c5.8-11.4,0.1-19.2-12.5-17.3c-12.6,1.9-20.3-6.6-17.1-19c3.3-12.4-3.9-18.8-15.8-14.3\n                      \t\tc-12,4.5-21.2-2.2-20.6-15c0.6-12.8-7.7-17.6-18.4-10.6c-10.8,6.9-21.2,2.2-23.3-10.4c-2.1-12.7-11.2-15.6-20.3-6.6\n                      \t\tc-9.1,9-20.3,6.6-25-5.3c-4.6-11.9-14.2-12.9-21.2-2.2c-3.8,5.8-8.9,8.1-13.9,7.7l0,0c-5.1,0.5-10.2-1.8-14-7.7\n                      \t\tc-7-10.7-16.5-9.7-21.2,2.2s-15.9,14.3-25,5.3c-9.1-9-18.2-6.1-20.3,6.6c-2.1,12.6-12.6,17.3-23.3,10.4\n                      \t\tc-10.8-6.9-19.1-2.1-18.5,10.7c0.6,12.7-8.7,19.5-20.6,15c-12-4.5-19.1,1.9-15.8,14.3c3.3,12.4-4.4,20.9-17.1,19\n                      \t\tc-12.7-2-18.3,5.8-12.5,17.3c5.7,11.4,0,21.3-12.8,22.1c-12.8,0.7-16.7,9.5-8.7,19.4c8,10,4.5,20.9-7.8,24.3\n                      \t\tc-12.4,3.4-14.3,12.7-4.4,20.8c9.9,8.1,8.7,19.5-2.7,25.4c-11.4,5.9-11.4,15.4,0,21.3c11.4,5.9,12.6,17.3,2.7,25.4\n                      \t\tc-9.9,8.1-7.9,17.5,4.4,20.9c12.3,3.4,15.9,14.3,7.9,24.3c-8,10-4.1,18.8,8.7,19.5c12.8,0.7,18.5,10.7,12.8,22.1\n                      \t\tc-5.8,11.4-0.1,19.1,12.5,17.2c3-0.5,5.6-0.3,7.9,0.4L0,502.7h74.2l37.7,57.2l71-117c7.9-4.1,16.1-0.8,19.9,8.9\n                      \t\tc4.6,11.9,14.2,12.9,21.2,2.2c3.8-5.8,8.9-8.1,13.9-7.6v0.1c5.1-0.5,10.2,1.8,14,7.6c7,10.7,16.5,9.7,21.2-2.2\n                      \t\tc3.8-9.8,12.1-13,19.9-8.9l71,117l37.7-57.2h74.3L405.8,371.2z M329.2,397.6l-2.7,1.5c-26.3,13.9-56.2,21.9-88,21.9\n                      \t\tc-0.1,0-0.4-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0c-31.8,0-61.7-8-88-21.9l-2.7-1.5c-57.6-31.8-96.7-92.9-96.7-162.9\n                      \t\tc0-102.7,84.1-186.2,187.4-186.2c0.1,0,0.4,0.1,0.4,0.1c0.2,0,0.3,0,0.5,0c103.3,0,187.4,83.6,187.4,186.2\n                      \t\tC425.9,304.7,386.8,365.8,329.2,397.6z',
            viewBox: '0 0 476.2 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Badge-2
defs.push({
    id: 'defId-HyPgfp5j',
    desc: 'Badge 2',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M533.4,224.9c-25.9-20.5-39-52.3-35.3-85.1c2.5-21.5-4.9-42.5-20.1-57.8c-15.3-15.3-36.3-22.6-57.8-20.1\n            \t\tc-32.8,3.8-64.6-9.4-85.1-35.3C321.7,9.7,301.6,0,280,0c-21.6,0-41.7,9.7-55.1,26.6c-20.5,25.9-52.3,39-85.1,35.3\n            \t\tC118.3,59.4,97.3,66.7,82,82c-15.3,15.3-22.6,36.3-20.1,57.8c3.8,32.8-9.4,64.6-35.3,85.1C9.7,238.3,0,258.4,0,280\n            \t\ts9.7,41.7,26.6,55.1c25.9,20.5,39,52.3,35.3,85.1c-2.5,21.5,4.9,42.5,20.1,57.8c15.3,15.3,36.3,22.6,57.8,20.1\n            \t\tc32.8-3.8,64.6,9.4,85.1,35.3c13.4,16.9,33.5,26.6,55.1,26.6c21.6,0,41.7-9.7,55.1-26.6c20.5-25.9,52.3-39,85.1-35.3\n            \t\tc21.5,2.5,42.5-4.9,57.8-20.1c15.3-15.3,22.6-36.3,20.1-57.8c-3.8-32.8,9.4-64.6,35.3-85.1c16.9-13.4,26.6-33.5,26.6-55.1\n            \t\tS550.3,238.3,533.4,224.9z',
            viewBox: '0 0 560 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Badge-3
defs.push({
    id: 'defId-ryEQM6qi',
    desc: 'Badge 3',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (560 / 462.6)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M84,310.6L84 345.7 136 377.6 165.6 432 226.9 432 280 462.6 333.1 432 394.4 432 424 377.6 476 345.7 476 310.6 438.7 310.6 438.7 325.3 397.1 350.7 374 394.6 323.6\n                    394.6 280 419.8 236.4 394.6 186 394.6 162.9 350.7 121.3 325.3 121.3 310.6z\n                    M476,161.3L476 117 424 85 394.4 30.6 333.1 30.6 280 0 226.9 30.6 165.6 30.6 136 85 84 117 84\n                        161.3 121.3 161.3 121.3 137.4 162.9 111.9 186 68 236.4 68 280 42.8 323.6 68 374 68 397.1 111.9 438.7 137.4 438.7 161.3z\n                    M363.2,86.6L318.6 86.6 280 64.4 241.4 86.6 196.8 86.6 176.6 125.5 140 148.1 140 161.3 420 161.3 420 148.1 383.4 125.5z\n                    M196.8,376L241.4 376 280 398.3 318.6 376 363.2 376 383.4 337.1 420 314.5 420 310.6 140 310.6 140 314.5 176.6 337.1z\n                    M84,301.3L121.3 301.3 130.7 301.3 140 301.3 420 301.3 429.3 301.3 438.7 301.3 476 301.3 560 301.3 530.5 232.3 560 170.6 476 170.6 438.7 170.6 429.3 170.6 420 170.6 140 170.6 130.7 170.6 121.3 170.6 84 170.6 0 170.6 29.5 237.2 0 301.3z',
            viewBox: '0 0 560 462.6',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Cloud
defs.push({
    id: 'defId-Sy6qM6co',
    desc: 'Cloud',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (560 / 362.2)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M479.1,168.9c0.9-4.9,1.4-9.9,1.4-15c0-47.8-38.7-86.5-86.5-86.5c-10.4,0-20.4,1.9-29.7,5.3C336.1,29,287.1,0,231.3,0\n            \t\tC143.9,0,73,70.9,73,158.3c0,4.1,0.3,8.1,0.6,12.2C31.4,181,0,219.2,0,264.8c0,53.8,43.6,97.4,97.4,97.4h365.2\n            \t\tc53.8,0,97.4-43.6,97.4-97.4C560,216.6,525,176.7,479.1,168.9z',
            viewBox: '0 0 560 362.2',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Ellipse
defs.push({
    id: 'defId-rJoHrT9o',
    desc: 'Ellipse',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 560 / 473.1,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'ellipse',
        attrs: {
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Geometric 1
defs.push({
    id: 'defId-By9sUT9o',
    desc: 'Geometric 1',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M396.7,77.9L357.8 77.9 280 0 202.1 77.9 163.3 77.9 110.2 169.8 0 280 110.2 390.2 163.3 482.1 202.1 482.1 280 560 357.8 482.1 396.7 482.1 449.8 390.2 560 280 449.8 169.8z',
            viewBox: '0 0 560 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Heart
defs.push({
    id: 'defId-SkehLpci',
    desc: 'Heart',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (560 / 532.3)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M403.5,0c-53.1,0-101,27.8-123.3,71.1C257.9,27.8,209.3,0,156.2,0C73.3,0-37.9,66.9,12.7,249.3\n            \t\tc57.9,178.2,267.4,283.1,267.4,283.1c0,0,209.3-104.8,267.1-283.1C597.9,66.9,486.4,0,403.5,0z',
            viewBox: '0 0 560 532.3',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Hexagon
defs.push({
    id: 'defId-HJvnLpqj',
    desc: 'Hexagon',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (560 / 485)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M0,242.5L140,0h280l140,242.5L420,485H140L0,242.5z',
            viewBox: '0 0 560 485',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Hexagonal Shield
defs.push({
    id: 'defId-rknn8T5o',
    desc: 'Hexagonal Shield',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (421.5 / 560)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M421.5,69.8v421.5h-7.8C270,512.8,210.8,560,210.8,560c-60.4-44.8-170.4-63.9-202-68.6H0V69.8c0,0,139.7-17.2,210.8-69.8\n            \t\tC210.8,0,269.6,55.1,421.5,69.8z',
            viewBox: '0 0 421.5 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Pentagon
defs.push({
    id: 'defId-BkEpL65s',
    desc: 'Pentagon',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (558.8 / 560)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M279.2,0L0 211.5 139.9 560 418.3 560 558.8 211.5z',
            viewBox: '0 0 558.8 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Rectangle
defs.push({
    id: 'defId-HJ5p8T9s',
    desc: 'Rectangle',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 960 / 560,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'rect',
        attrs: {
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Rounded Rectangle
defs.push({
    id: 'defId-HJfRI65j',
    desc: 'Rounded Rectangle',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 960 / 560,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M780,0H180C80.6,0,0,55.5,0,124.1v311.8C0,504.5,80.6,560,180,560h600c99.4,0,180-55.5,180-124.1V124.1\n            \t\tC960,55.5,879.4,0,780,0z',
            viewBox: '0 0 960 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Ribbon 1
defs.push({
    id: 'defId-S1u08Tqs',
    desc: 'Ribbon 1',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 960 / 557.4,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M48.4,0C48.4,0,0,15.1,0,91.3c0,76.2,0,466.1,0,466.1s5.4-93.9,48.4-93.9H960l-93-240L960,0L48.4,0L48.4,0z',
            viewBox: '0 0 960 557.4',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Ribbon 2
defs.push({
    id: 'defId-S1CA8p9s',
    desc: 'Ribbon 2',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 960 / 556.9,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M883.8,126.4L883.8 430.5 960 430.5 927.9 269.9 960 126.4z\n                    M794.6,477.1L867.7 477.1 867.7 430.5 867.7 126.4 867.7 79.8 794.6 79.8z\n                    M76.2,430.5L76.2 126.4 0 126.4 32.1 274.4 0 430.5z\n                    M92.3,430.5L92.3 477.1 165.4 477.1 165.4 79.8 92.3 79.8 92.3 126.4z\n                    M181.4,44L181.4 61.9 181.4 79.8 181.4 477.1 181.4 495 181.4 512.9 181.4 556.9 778.6 556.9 778.6 512.9 778.6 495 778.6 477.1 778.6 79.8 778.6 61.9 778.6 44 778.6 0 181.4 0z',
            viewBox: '0 0 960 556.9',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Ribbon Square
defs.push({
    id: 'defId-r1vkwa9s',
    desc: 'Ribbon Square',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 960 / 559.1,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M928.6,0H31.4C14.1,0,0,9,0,20.1v368c0,11.1,14.1,20.1,31.4,20.1h480.5v130.7c0,8.1,7.7,15.5,19.4,18.6c3.9,1,8,1.5,12,1.5\n            \t\tc8.2,0,16.2-2,22.2-5.9l228-144.9h135.1c17.4,0,31.4-9,31.4-20.1v-368C960,9,945.9,0,928.6,0L928.6,0z',
            viewBox: '0 0 960 559.1',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Shield
defs.push({
    id: 'defId-H161Dp5s',
    desc: 'Shield',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (463.4 / 560)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M231.7,558.4c0,0.6,0,1.1,0,1.6h0.1c0.8-112.1,119.4-202.8,230-202.8c0.6,0,1.1,0,1.6,0L395.9,0H67.6L0,357.4\n            \t\tC112.2,358.6,231.7,448.1,231.7,558.4z',
            viewBox: '0 0 463.4 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Speech bubble
defs.push({
    id: 'defId-SJBlwp5i',
    desc: 'Speech bubble',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (560 / 485.2)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M280,0C125.4,0,0,98.5,0,220c0,57.5,28.1,110,74.2,149.2c-1.8,38.2-9.7,89.6-37.7,116c53.5,0,108.2-35.2,140.7-60.6\n            \t\tC209,434.6,243.7,440,280,440c154.6,0,280-98.5,280-220S434.6,0,280,0z',
            viewBox: '0 0 560 485.2',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Square
defs.push({
    id: 'defId-HyTgPpci',
    desc: 'Square',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'rect',
        attrs: {
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Star
defs.push({
    id: 'defId-SJQ-Daco',
    desc: 'Star',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (560 / 535.5)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M550.9,233.2L437.3,344l26.8,156.4c1.9,11.3-2.7,22.7-12,29.4c-5.2,3.8-11.4,5.7-17.7,5.7c-4.8,0-9.6-1.1-14-3.5L280,458.2\n            \t\tl-140.5,73.9c-10.1,5.3-22.4,4.4-31.6-2.3c-9.2-6.7-13.9-18.1-11.9-29.4L122.8,344L9.1,233.2c-8.2-8-11.1-19.9-7.6-30.8\n            \t\tC5,191.5,14.4,183.6,25.7,182l157.1-22.8l70.3-142.3C258.1,6.5,268.6,0,280,0c11.5,0,21.9,6.5,26.9,16.7l70.3,142.3l157.1,22.8\n            \t\tc11.3,1.6,20.7,9.6,24.2,20.4C562.1,213.2,559.1,225.2,550.9,233.2z',
            viewBox: '0 0 560 535.5',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Thought bubble
defs.push({
    id: 'defId-S1o-v69i',
    desc: 'Thought bubble',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (751.9 / 524.3)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M71.5,189.2a340.2,189.2 0 1,0 680.4,0a340.2,189.2 0 1,0 -680.4,0z\n                    M94,431.6a113.4,63.1 0 1,0 226.8,0a113.4,63.1 0 1,0 -226.8,0z\n                    M0,494.7a53.4,29.7 0 1,0 106.8,0a53.4,29.7 0 1,0 -106.8,0z',
            viewBox: '0 0 751.9 524.3',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Triangle
defs.push({
    id: 'defId-HyVGvpqs',
    desc: 'Triangle',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 560 / 483.4,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M280,0L0,483.4h560L280,0L280,0z',
            viewBox: '0 0 560 483.4',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Wedge
defs.push({
    id: 'defId-B15Mwp9j',
    desc: 'Wedge',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (286 / 559.9)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M256.3,0H29.7C13.3,0,0,16.9,0,37.8v484.3c0,15.1,7,28.7,17.9,34.7s23.5,3.2,32.1-7.1l93-111l93,111\n            \t\tc5.6,6.7,12.9,10.2,20.3,10.2c4,0,8-1,11.8-3.1c10.9-6,17.9-19.6,17.9-34.7V37.8C286,16.9,272.7,0,256.3,0z',
            viewBox: '0 0 286 559.9',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Wedge 1
defs.push({
    id: 'defId-BkQl1lXQl',
    desc: 'Wedge 1',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 411 / 112,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M0.69140625,0.01171875L0.38671875 107.785156 410.976562 111.152344 334.523438 1.58203125z',
            viewBox: '0 0 411 112',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Wedge 2
defs.push({
    id: 'defId-By6Q1eQ7e',
    desc: 'Wedge 2',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 406 / 119,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M0.08203125,0.515625L8.8203125 117.597656 375.492188 118.984375 405.894531 89.2773437 398.316406 0.515625z',
            viewBox: '0 0 406 119',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Wedge 3
defs.push({
    id: 'defId-Syr4yxXQx',
    desc: 'Wedge 3',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 490 / 84,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M44.6211665,0.442578872L0.38671875 83.5859375 437.284278 83.5859375 490 0z',
            viewBox: '0 0 490 84',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// ICONS

//twitch tv
defs.push({
    id: 'defId-ByKAagpIW',
    desc: 'Twitch tv',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M497.231,0h-448c-3.5,0-6.74,1.856-8.505,4.885L6.264,63.962c-0.88,1.51-1.341,3.221-1.341,4.961  v364.308c0,5.442,4.409,9.846,9.846,9.846h108.308v59.077c0,5.442,4.409,9.846,9.846,9.846h68.923c2.433,0,4.779-0.904,6.587-2.529  l73.774-66.394h91.947c2.471,0,4.851-0.933,6.668-2.596L503.899,327.25c2.024-1.865,3.178-4.5,3.178-7.25V9.846  C507.077,4.404,502.668,0,497.231,0z M428.308,286.385l-58.231,58.231H260.923c-2.61,0-5.115,1.039-6.961,2.885l-42.269,42.269  v-35.308c0-5.442-4.409-9.846-9.846-9.846h-98.462V68.923h324.923V286.385z',
            viewBox: '0 0 512 512',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's2',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M54.885,19.692L24.615,71.586v351.798h108.308c5.438,0,9.846,4.404,9.846,9.846v59.077h55.298  l73.774-66.394c1.808-1.625,4.154-2.529,6.587-2.529h91.885l117.072-107.702V19.692H54.885z M428.308,286.385l-58.231,58.231  H260.923c-2.61,0-5.115,1.039-6.961,2.885l-42.269,42.269v-35.308c0-5.442-4.409-9.846-9.846-9.846h-98.462V68.923h324.923V286.385z  ',
            viewBox: '0 0 512 512',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's3',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M438.154,49.231H93.538c-5.438,0-9.846,4.404-9.846,9.846v295.385c0,5.442,4.409,9.846,9.846,9.846   H192v49.231c0,3.981,2.399,7.577,6.077,9.096c1.221,0.51,2.5,0.75,3.769,0.75c2.562,0,5.077-1,6.961-2.885L265,364.308h109.154   c2.61,0,5.115-1.039,6.961-2.885l64-64c1.846-1.846,2.885-4.346,2.885-6.961V59.077C448,53.635,443.591,49.231,438.154,49.231z    M428.308,286.385l-58.231,58.231H260.923c-2.61,0-5.115,1.039-6.961,2.885l-42.269,42.269v-35.308   c0-5.442-4.409-9.846-9.846-9.846h-98.462V68.923h324.923V286.385z',
            viewBox: '0 0 512 512',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's4',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M211.692,275.692h39.385c5.438,0,9.846-4.404,9.846-9.846v-128c0-5.442-4.409-9.846-9.846-9.846   h-39.385c-5.438,0-9.846,4.404-9.846,9.846v128C201.846,271.288,206.255,275.692,211.692,275.692z',
            viewBox: '0 0 512 512',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's5',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M310.154,275.692h39.385c5.438,0,9.846-4.404,9.846-9.846v-128c0-5.442-4.409-9.846-9.846-9.846  h-39.385c-5.438,0-9.846,4.404-9.846,9.846v128C300.308,271.288,304.716,275.692,310.154,275.692z',
            viewBox: '0 0 512 512',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's6',
        desc: '',
        type: 'rect',
        attrs: {
            x: 221.538,
            y: 147.692,
            width: 19.692,
            height: 108.308,
            fill: '${color2}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's7',
        desc: '',
        type: 'rect',
        attrs: {
            x: 320,
            y: 147.692,
            width: 19.692,
            height: 108.308,
            fill: '${color2}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Cook 1
defs.push({
    id: 'defId-rykmPT5o',
    desc: 'Cook 1',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (416.2 / 560)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M416.2,484.3v-454c0-16.6-13.6-30.3-30.3-30.3H30.3C13.6,0,0,13.6,0,30.3v30.3v423.8v45.4C0,546.4,13.6,560,30.3,560h355.7\n            \t\tc11.1,0,20.8-6.1,26-15.1H60.5c-16.6,0-30.3-13.6-30.3-30.3h355.7C402.6,514.6,416.2,501,416.2,484.3z M103.4,405\n            \t\tc-5.4,5.4-14.2,5.4-19.6,0c-5.4-5.4-5.4-14.2,0-19.6l86.3-86.3l19.6,19.6L103.4,405z M313.5,406.2c-5.4,5.4-14.2,5.4-19.6,0\n            \t\tL147.1,259.5c-0.6-0.6-1-1.4-1.5-2.2c-21.2,10.1-51.7,2.8-74.3-19.8c-27-27-32.5-65.4-12.2-85.6c20.2-20.2,58.6-14.8,85.6,12.2\n            \t\tc22.7,22.7,29.9,53.1,19.8,74.4c0.7,0.5,1.5,0.8,2.2,1.5l146.8,146.7C318.8,392.1,318.9,400.8,313.5,406.2z M367.2,195l-62.9,62.9\n            \t\tc-0.5,0.5-1.1,0.8-1.6,1.1c-21.5,19.1-43.5,19.2-61.4,7.7c-0.4,0.4-0.5,1-0.9,1.4l-14.4,14.4l-19.6-19.6l14.5-14.5\n            \t\tc0.4-0.4,0.9-0.5,1.4-0.9c-11.6-18-11.4-40,7.7-61.4c0.3-0.5,0.6-1.2,1.1-1.6l62.9-62.9c2.9-2.9,7.6-2.9,10.5,0\n            \t\tc2.9,2.9,2.9,7.6,0,10.5l-60.8,60.8l10.5,10.5l60.8-60.8c2.9-2.9,7.6-2.9,10.5,0c2.9,2.9,2.9,7.6,0,10.5l-60.8,60.8l10.5,10.5\n            \t\tl60.8-60.8c2.9-2.9,7.6-2.9,10.5,0c2.9,2.9,2.9,7.6,0,10.5l-60.8,60.8l10.5,10.5l60.8-60.8c2.9-2.9,7.6-2.9,10.5,0\n            \t\tC370.1,187.4,370.1,192.1,367.2,195z',
            viewBox: '0 0 416.2 560',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-SkmNgSsrb',
    desc: 'Flame',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow * 611 / 390}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'm104.02,612.195c5.978,3.178 12.284,-3.704 8.624,-9.4c-19.866,-30.919 -38.678,-82.947 -8.706,-149.952c49.982,-111.737 80.396,-169.609 80.396,-169.609s16.177,67.536 60.029,127.585c42.205,57.793 65.306,130.478 28.064,191.029c-3.495,5.683 2.668,12.388 8.607,9.349c46.1,-23.582 97.806,-70.885 103.64,-165.017c2.151,-28.764 -1.075,-69.034 -17.206,-119.851c-20.741,-64.406 -46.239,-94.459 -60.992,-107.365c-4.413,-3.861 -11.276,-0.439 -10.914,5.413c4.299,69.494 -21.845,87.129 -36.726,47.386c-5.943,-15.874 -9.409,-43.33 -9.409,-76.766c0,-55.665 -16.15,-112.967 -51.755,-159.531c-9.259,-12.109 -20.093,-23.424 -32.523,-33.073c-4.5,-3.494 -11.023,0.018 -10.611,5.7c2.734,37.736 0.257,145.885 -94.624,275.089c-86.029,119.851 -52.693,211.896 -40.864,236.826c22.616,47.759 54.162,75.806 84.97,92.187z',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-HJMUhl0rZ',
    desc: 'Inked circle',
    meta: {
        canOverrideAnimation: true,
        nativeAspectRatio: 1,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'm202.53378,30.65644c0.63709,0 5.73378,2.45781 8.60066,3.37949c-0.95563,0.30723 -3.18543,-0.61445 -5.73378,-1.53613c0.63709,0 1.91126,0.30723 3.18543,0.92168c-0.63709,-0.61445 -5.41523,-2.15058 -6.05232,-2.76504m-47.46292,-9.52402c0.95563,-0.30723 12.10464,1.22891 17.20133,1.53613c0.31854,-0.30723 -0.63709,-0.30723 -1.91126,-0.61445c1.59272,-0.30723 4.77815,0.61445 7.00795,0.92168c-6.6894,0.30723 -14.0159,-1.53613 -20.38676,-0.92168c-2.2298,0 -0.63709,-0.61445 -1.91126,-0.92168m-9.23775,0c5.73378,0 10.19338,0 1.91126,0.61445c-0.95563,-0.30723 -2.2298,-0.30723 -1.91126,-0.61445m90.14769,25.49979c0.63709,0 3.18543,2.76504 4.4596,3.68672c-0.31854,0.30723 -2.86689,-2.15058 -4.14106,-3.07226c0.31854,0.30723 0,0 -0.31854,-0.61445m-6.37086,-3.99394c-2.54834,-2.15058 -3.50397,-2.15058 -3.82252,-3.37949c2.2298,1.22891 3.82252,2.45781 3.82252,3.37949m-41.09206,-19.35526c0.31854,-0.30723 0.95563,0.30723 2.54834,0.61445c-1.91126,-0.30723 -1.59272,0 -0.95563,0.61445c-2.2298,-0.30723 -2.86689,-0.61445 -2.2298,-1.22891c1.27417,0.61445 1.59272,0.30723 0.63709,0m-90.46623,3.68672c0,-0.30723 1.27417,-0.92168 2.2298,-1.22891c-0.95563,0.61445 -0.63709,0.92168 0.95563,0.30723c0,0.30723 -1.91126,0.92168 -3.18543,1.53613c0.63709,-0.30723 1.27417,-1.22891 0,-0.61445m96.83709,-6.75898c-0.95563,0.30723 -4.4596,-1.53613 -7.96358,-2.15058c-1.91126,-0.61445 7.64503,1.53613 7.96358,2.15058m-187.94041,151.76981c1.91126,7.68066 0.63709,7.37343 0,0m0.31854,-46.08395c0.31854,-1.22891 0.63709,-4.6084 0.95563,-4.30117c-0.95563,7.37343 -2.54834,10.75292 -2.86689,16.283c0.95563,-4.91562 -0.31854,2.76504 -0.63709,4.6084c0.31854,2.45781 0.31854,-1.53613 0.95563,-0.92168c0.63709,0.92168 -1.27417,13.82519 -0.63709,6.75898c-0.63709,6.45175 0,13.51796 1.27417,15.36132c-1.59272,9.83124 6.37086,31.95154 7.96358,36.55994c0.31854,0.30723 0,-1.53613 0.63709,-0.30723c0.63709,3.99394 3.50397,6.75898 4.4596,11.06015c0.95563,1.22891 4.77815,7.98788 5.41523,9.52402c1.27417,2.45781 1.91126,2.15058 3.18543,4.6084c3.82252,7.06621 9.87484,13.82519 15.60861,20.27694c18.4755,20.89139 46.82583,38.09607 78.3616,44.24059c31.53576,6.45175 64.66424,1.84336 90.46623,-10.13847c1.59272,-0.92168 1.27417,-1.22891 3.18543,-1.84336c8.91921,-2.76504 19.74967,-11.6746 25.80199,-15.05409c2.86689,-3.07226 10.51192,-8.29511 11.46755,-11.36737c5.41523,-4.30117 10.83046,-11.36737 13.69735,-15.97577c1.59272,-2.45781 2.86689,-2.45781 3.50397,-3.99394c-0.31854,0 5.09669,-6.45175 6.6894,-10.13847c-0.63709,0 -1.59272,1.84336 -1.59272,0c11.46755,-21.19862 17.83841,-49.77067 14.33444,-69.43315c0.63709,24.27088 -5.73378,51.3068 -17.83841,68.51148c-5.41523,11.06015 -16.56424,23.04198 -26.75762,31.64431c-1.59272,1.53613 -3.18543,3.37949 -5.09669,4.6084c-6.05232,4.91562 -12.74172,8.90956 -19.74967,12.59628c-16.56424,8.90956 -35.03974,16.59022 -56.70067,16.89745c37.26954,-3.07226 70.71656,-21.19862 89.19206,-43.31891c-14.0159,13.21073 -20.06821,18.43358 -35.67682,26.11424c-1.27417,2.15058 -11.78609,6.45175 -18.79404,8.29511c4.14106,-1.84336 12.74172,-4.91562 15.60861,-7.37343c-23.25364,10.75292 -49.05563,16.89745 -73.26491,13.51796c9.23775,0 22.29802,0.30723 34.7212,-1.84336c1.91126,-0.61445 2.86689,-1.22891 5.09669,-1.53613c24.20927,-5.22285 47.46292,-16.59022 64.02716,-32.56599c-9.55629,8.29511 -23.89073,18.12635 -33.12848,21.19862c8.60066,-4.6084 24.20927,-13.51796 29.30596,-20.27694c-10.19338,9.83124 -29.30596,19.66249 -41.4106,23.96365c-1.91126,0.30723 1.27417,-1.22891 -1.91126,0c-3.82252,0.92168 -2.2298,0.92168 -3.18543,1.53613c-14.65298,3.99394 -31.53576,7.37343 -45.55166,6.14453c-2.54834,-0.30723 -3.50397,-0.92168 -5.73378,-0.92168c-2.54834,-0.30723 -4.77815,-0.30723 -7.64503,-0.30723c-11.14901,-1.22891 -23.25364,-5.53007 -32.17285,-9.21679c-4.77815,-2.15058 -9.55629,-3.68672 -14.33444,-6.45175c-3.82252,-2.15058 -7.00795,-4.6084 -10.19338,-7.06621c-12.10464,-8.60234 -22.29802,-17.20468 -31.85431,-29.49373c-17.20133,-23.04198 -26.12053,-51.92125 -24.84636,-80.4933c1.27417,-28.57205 13.06027,-56.52965 31.85431,-77.11381c-0.95563,0.92168 1.27417,-2.15058 3.18543,-3.99394c0,0.61445 -0.31854,1.53613 1.91126,-0.61445c1.91126,-2.15058 -0.63709,-0.61445 0.31854,-1.84336c19.74967,-20.89139 54.15232,-37.78884 89.5106,-38.40329c1.27417,-0.92168 3.50397,-2.15058 6.05232,-1.53613c0,0.30723 -1.59272,0.30723 -1.59272,0.30723c3.50397,-0.30723 6.6894,-0.30723 8.28212,0.30723c0.31854,-0.30723 -1.27417,-0.61445 0,-0.61445c2.2298,0.61445 2.86689,0 4.14106,0.61445c-0.95563,0 -1.91126,0 -2.54834,0.30723c7.96358,0 13.06027,1.84336 21.02384,2.45781c-4.14106,-0.92168 -5.09669,-0.92168 -8.28212,-1.84336c3.50397,0.61445 5.09669,1.22891 6.6894,0.92168c-0.63709,0 -0.31854,-0.92168 0.31854,-0.61445c6.37086,1.53613 7.00795,2.15058 13.69735,4.30117c0.63709,-0.61445 -2.86689,-0.92168 -3.82252,-1.84336c6.37086,2.15058 12.10464,3.68672 15.92715,6.14453c-1.27417,-0.92168 -5.09669,-2.15058 -7.96358,-3.37949c-0.31854,0.30723 0.95563,0.61445 1.27417,1.22891c-3.18543,-1.53613 -7.64503,-3.07226 -12.10464,-3.68672c3.82252,0.92168 6.37086,2.15058 7.96358,2.76504c-3.50397,-0.61445 -7.96358,-2.76504 -13.06027,-3.68672c8.28212,2.45781 23.89073,7.98788 33.44702,12.90351c-3.50397,-2.15058 -7.64503,-3.68672 -9.87484,-4.91562c1.91126,0.30723 4.14106,1.53613 4.14106,0.92168c2.2298,0.92168 5.09669,3.07226 6.6894,3.37949c-2.86689,-1.84336 -8.60066,-4.6084 -10.51192,-5.53007c23.89073,10.4457 45.23312,27.9576 58.93047,50.38512c1.27417,2.15058 3.18543,7.06621 4.77815,7.68066c-0.31854,-1.53613 -1.59272,-2.45781 -2.86689,-4.91562c0.63709,0 0.63709,-0.92168 0,-1.84336c-1.27417,-1.53613 0,1.22891 -1.27417,-0.30723c-5.73378,-10.13847 -12.74172,-19.04803 -23.57219,-28.87928c6.05232,5.53007 1.59272,1.53613 0.31854,-0.30723c8.28212,7.06621 17.83841,19.04803 21.97947,25.19256c-0.63709,-0.92168 -0.95563,-1.53613 -0.63709,-1.53613c7.64503,12.59628 12.42318,23.96365 17.20133,40.24665c0.31854,0.30723 0,-1.22891 0.63709,-0.30723c3.18543,12.90351 4.14106,23.65643 3.82252,33.48767c2.54834,-16.59022 -3.18543,-42.39724 -13.37881,-62.67417c-1.27417,-2.45781 -1.27417,-0.61445 -2.54834,-3.37949c0,-0.92168 -0.95563,-2.76504 -1.59272,-3.99394c-12.74172,-20.27694 -28.35033,-34.71658 -46.82583,-46.08395c1.27417,0.61445 3.82252,2.45781 3.82252,2.15058c-34.40265,-21.81307 -74.22054,-24.88533 -107.03047,-18.12635c-2.2298,0.92168 -3.18543,1.84336 -5.73378,3.07226c4.77815,-1.53613 7.64503,-1.84336 12.10464,-2.76504c0.95563,-0.92168 -4.14106,0.30723 -1.91126,-0.61445c0.31854,0.30723 4.4596,-0.61445 5.41523,-0.30723c0,0.30723 -1.27417,0.61445 -1.59272,0.92168c10.51192,-2.15058 21.34239,-2.45781 30.58014,-1.84336c-5.41523,0.30723 -15.29007,-0.61445 -18.4755,0.92168c3.18543,-0.30723 7.64503,-0.61445 10.51192,-0.30723c-3.82252,0 -10.83046,0.30723 -14.0159,0.61445c-0.31854,-0.30723 5.09669,-0.92168 1.59272,-0.92168c-1.59272,0.30723 -4.14106,0.30723 -5.09669,1.22891c-27.3947,2.45781 -54.15232,16.283 -72.94636,32.56599c-3.82252,3.07226 -8.28212,6.45175 -11.14901,9.83124c-7.00795,7.68066 -11.46755,15.36132 -16.56424,22.1203c3.18543,-6.45175 10.19338,-16.283 18.4755,-24.57811c8.28212,-8.29511 17.20133,-15.36132 21.97947,-19.04803c0,1.22891 7.64503,-4.6084 10.51192,-6.45175c-1.91126,1.53613 1.27417,-0.61445 1.91126,-0.30723c10.19338,-5.8373 18.4755,-7.98788 27.71325,-11.36737c-2.2298,0.61445 -4.14106,1.22891 -4.4596,0.92168c2.2298,-0.61445 3.50397,-1.22891 3.18543,-1.53613c-8.91921,2.45781 -22.9351,8.29511 -34.08411,14.74686c20.06821,-13.21073 45.55166,-21.19862 70.71656,-21.50584c25.1649,-0.61445 49.69272,5.53007 69.12385,15.36132c13.06027,5.53007 25.48345,15.66854 35.35828,25.49979c2.86689,2.45781 0.63709,-0.61445 4.77815,3.68672c-1.27417,-0.61445 -2.2298,-1.22891 -0.63709,0.61445c2.54834,2.76504 -0.63709,-2.15058 3.50397,2.76504c-0.31854,0 -1.59272,-1.53613 -1.59272,-0.92168c11.14901,9.52402 19.74967,26.72869 24.84636,38.09607c-1.27417,-4.6084 -4.4596,-11.06015 -7.00795,-15.66854c7.64503,13.51796 10.19338,21.50584 13.37881,33.48767c1.27417,0.92168 -0.63709,-4.30117 0.63709,-1.84336c0.31854,1.84336 0.63709,7.68066 1.91126,8.60234c-0.95563,-5.8373 -2.54834,-12.90351 -3.82252,-14.13241c0.95563,0.61445 -1.59272,-7.06621 -3.18543,-8.90956c-0.63709,-4.91562 -5.09669,-13.51796 -8.91921,-19.96971c-13.69735,-25.80701 -38.22517,-47.00563 -65.61987,-58.68023c0,-0.61445 -1.59272,-1.22891 -2.2298,-1.84336c-27.07616,-11.06015 -59.56756,-14.13241 -90.78478,-7.06621c-31.53576,7.37343 -61.16027,24.88533 -82.18411,50.07789c0.95563,-3.07226 8.91921,-8.90956 9.23775,-11.36737c-9.23775,9.52402 -19.11258,22.1203 -25.80199,35.63826c-7.00795,13.51796 -10.83046,27.34314 -12.42318,37.48161',
            viewBox: '0 0 300 300',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-B1smihOrW',
    desc: 'Angle 1',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow * 420 / 580}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'm260.73877,413.14588l-252.95192,0l55.55346,-166.5l253.56544,0l80.82199,-240.14423l176.79949,0l-82.20944,240.14423l-56.86067,166.5l-174.71835,0z',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-By_HrTOHb',
    desc: 'Angle 2',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow * 420 / 580}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'm182.05514,415.225l-175.41204,0l80.04807,-240.14421l56.16698,-166.5l175.41204,0l255.11329,0l-57.6346,166.5l-254.33936,0l-79.35438,240.14421z',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Cook 4
defs.push({
    id: 'defId-ryUQPpqo',
    desc: 'Cook 4',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (35.2 / 35.2)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M26.8,12.7h-7.5c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2h-3.1c-0.7,0-1.2,0.5-1.2,1.2s0.6,1.2,1.2,1.2H8.6\n        \t\t\tc-2.1,0-3.8,1.9-4.2,3.9h26.5C30.6,14.6,28.9,12.7,26.8,12.7z\n                    M31,18.7v-0.4H4.5H4.4H0v1.8h4.4V31c0,2.3,1.9,4.2,4.2,4.2h18.1c2.3,0,4.2-1.9,4.2-4.2V20.4h4.2v-1.8H31z\n                    M11.2,4.2c0.1,0.2,0.3,0.3,0.4,0.5L12,5c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2\n            \t\t\tc0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.5,0.3-0.8\n            \t\t\tc0-0.3,0-0.5-0.1-0.7c-0.1-0.4-0.3-0.8-0.5-1.1c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.5-0.6-0.9-0.6-1.4\n            \t\t\tc-0.1-0.5,0-1.1,0.3-1.8c-0.8,0.2-1.5,0.8-1.7,1.7c-0.1,0.4-0.1,0.9,0,1.4C10.8,3.5,11,3.9,11.2,4.2z\n                    M15.8,4.2c0.1,0.2,0.3,0.3,0.4,0.5L16.5,5c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2\n            \t\t\tc0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.5,0.3-0.8\n            \t\t\tc0-0.3,0-0.5-0.1-0.7c-0.1-0.4-0.3-0.8-0.5-1.1c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.5-0.6-0.9-0.6-1.4\n            \t\t\tc-0.1-0.5,0-1.1,0.3-1.8c-0.8,0.2-1.5,0.8-1.7,1.7c-0.1,0.4-0.1,0.9,0,1.4C15.4,3.5,15.6,3.9,15.8,4.2z\n                    M20,4.2c0.1,0.2,0.3,0.3,0.4,0.5L20.7,5c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2\n            \t\t\tc0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.5,0.3-0.8\n            \t\t\tc0-0.3,0-0.5-0.1-0.7C22.4,4.7,22.2,4.3,22,4c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.5-0.6-0.9-0.6-1.4\n            \t\t\tc-0.1-0.5,0-1.1,0.3-1.8c-0.8,0.2-1.5,0.8-1.7,1.7c-0.1,0.4-0.1,0.9,0,1.4C19.5,3.5,19.7,3.9,20,4.2z',
            viewBox: '0 0 35.2 35.2',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Email 5
defs.push({
    id: 'defId-B1T7wT9i',
    desc: 'Email 5',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (14 / 10)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M7,7L5.3,5.5l-5,4.2C0.5,9.9,0.7,10,1,10h12c0.3,0,0.5-0.1,0.7-0.3L8.7,5.5L7,7z\n                    M13.7,0.3C13.5,0.1,13.3,0,13,0H1C0.7,0,0.5,0.1,0.3,0.3L7,6L13.7,0.3z\n                    M0,0.9L0 9.2 4.8 5.1z\n                    M9.2,5.1L14 9.2 14 0.9z',
            viewBox: '0 0 14 10',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Facebook 29
defs.push({
    id: 'defId-SkmEDp5j',
    desc: 'Facebook 29',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (90 / 90)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M90,15c0-7.9-7.1-15-15-15H15C7.1,0,0,7.1,0,15v60c0,7.9,7.1,15,15,15h30V56H34V41h11v-5.8\n            \t\tC45,25.1,52.6,16,61.9,16H74v15H61.9c-1.3,0-2.9,1.6-2.9,4v6h15v15H59v34h16c7.9,0,15-7.1,15-15V15z',
            viewBox: '0 0 90 90',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Instagram
defs.push({
    id: 'defId-HJFEP6co',
    desc: 'Instagram',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M24.8,29.8c2.7,0,5-2.2,5-5c0-1.1-0.4-2.1-0.9-2.9c-0.9-1.3-2.4-2.1-4-2.1c-1.7,0-3.1,0.8-4,2.1\n    \t\t\t\tc-0.6,0.8-0.9,1.8-0.9,2.9C19.9,27.6,22.1,29.8,24.8,29.8z\n                    M35.7,18.7L35.7 14.6 35.7 14 35.1 14 30.9 14 30.9 18.8 z\n                    M24.8,0C11.1,0,0,11.1,0,24.8c0,13.7,11.1,24.8,24.8,24.8c13.7,0,24.8-11.1,24.8-24.8C49.7,11.1,38.5,0,24.8,0z\n    \t\t\t\tM38.9,21.9v11.6c0,3-2.4,5.5-5.5,5.5H16.2c-3,0-5.5-2.4-5.5-5.5V21.9v-5.8c0-3,2.4-5.5,5.5-5.5h17.3c3,0,5.5,2.4,5.5,5.5V21.9z\n                    M32.5,24.8c0,4.3-3.5,7.7-7.7,7.7s-7.7-3.5-7.7-7.7c0-1,0.2-2,0.6-2.9h-4.2v11.6c0,1.5,1.2,2.7,2.7,2.7h17.3\n        \t\t\t\tc1.5,0,2.7-1.2,2.7-2.7V21.9H32C32.3,22.8,32.5,23.8,32.5,24.8z',
            viewBox: '0 0 49.7 49.7',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// logotype46
defs.push({
    id: 'defId-SJ4rv6ci',
    desc: 'logotype46',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (18.1 / 18.1)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M16.3,0H1.9C0.8,0,0,0.8,0,1.9v14.4c0,1,0.8,1.9,1.9,1.9h14.4c1,0,1.9-0.8,1.9-1.9V1.9C18.1,0.8,17.3,0,16.3,0z M10.4,3.1\n            \t\th0.9v2.8c0,0.5,0,0.5,0,0.6c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.2,0.3-0.3c0-0.1,0-0.1,0-0.6V3.1h0.9v4.2H12L12,7l-0.3-0.1\n            \t\tc-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3\n            \t\tc0-0.1,0-0.4,0-0.8V3.1L10.4,3.1z M7.4,4.8c0-0.4,0-0.8,0.1-1c0.1-0.2,0.2-0.4,0.4-0.5C8,3.1,8.3,3.1,8.5,3.1c0.2,0,0.5,0,0.6,0.1\n            \t\tc0.2,0.1,0.3,0.2,0.4,0.3C9.6,3.7,9.7,3.8,9.7,4c0,0.2,0.1,0.4,0.1,0.7v0.7c0,0.4,0,0.7,0,0.9c0,0.2-0.1,0.3-0.2,0.5\n            \t\tC9.4,7,9.3,7.1,9.2,7.2C9,7.3,8.8,7.3,8.6,7.3c-0.2,0-0.5,0-0.6-0.1C7.8,7.2,7.7,7.1,7.6,7C7.5,6.8,7.5,6.7,7.4,6.5\n            \t\tc0-0.2-0.1-0.5-0.1-0.9L7.4,4.8z M5.3,1.6L6,3.9c0.1-0.6,0.4-1.4,0.6-2.3h0.7L6.4,4.9l0,0v2.3H5.6V4.9l0,0l-1-3.3H5.3z M15.7,14.5\n            \t\tc-0.1,1-1,1.9-2.1,2c-3,0.1-6.1,0.1-9.1,0c-1-0.1-2-0.9-2.1-2c-0.1-1.6-0.1-3.3,0-4.9c0.1-1,1-1.9,2.1-2c3-0.1,6.1-0.1,9.1,0\n            \t\tc1,0.1,2,0.9,2.1,2C15.8,11.2,15.8,12.9,15.7,14.5z M8.6,6.8c0.1,0,0.2-0.1,0.3-0.2c0-0.1,0-0.2,0-0.5V4.3c0-0.4,0-0.5,0-0.6\n            \t\tc0-0.1-0.1-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.6v1.8c0,0.3,0,0.5,0,0.5C8.4,6.7,8.5,6.8,8.6,6.8z M3.6,9.9h0.7\n            \t\th0.1v0.1v4.7h0.9v-4.7V9.9h0.1h0.7V9H3.6V9.9z M7.9,13.1c0,0.5,0,0.6,0,0.7c0,0.1-0.1,0.2-0.3,0.2c-0.1,0-0.2-0.1-0.3-0.2\n            \t\tc0-0.1,0-0.2,0-0.7v-2.8H6.4v3c0,0.4,0,0.7,0,0.8c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1\n            \t\tc0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3l0.3,0.1l0,0.2h0.9v-4.4H7.9L7.9,13.1z M11.7,10.6c0-0.1-0.1-0.2-0.2-0.2\n            \t\tc-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3,0.4v-0.5V9H9.4v5.8h0.8l0.1-0.3l0.1-0.4l0.2,0.3\n            \t\tc0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2,0.1-0.4,0.1-0.4v-2.3\n            \t\tc0,0,0-0.2,0-0.7C11.8,10.8,11.7,10.7,11.7,10.6z M10.9,13.1c0,0.4,0,0.5,0,0.6c0,0.1-0.1,0.2-0.3,0.2c-0.1,0-0.2-0.1-0.3-0.2\n            \t\tc0-0.1,0-0.2,0-0.6V12c0-0.4,0-0.5,0-0.6c0-0.1,0.1-0.2,0.3-0.2c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0,0.2,0,0.6L10.9,13.1L10.9,13.1\n            \t\tL10.9,13.1z M13.3,12.7h0.1h1.3v-0.5c0-0.4,0-0.9-0.1-1.2c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.7-0.2\n            \t\tc-0.2,0-0.4,0.1-0.6,0.2s-0.3,0.3-0.4,0.5c-0.1,0.2-0.1,0.5-0.1,1.1v1.3c0,0.2,0,0.4,0.1,0.6c0,0.2,0.1,0.3,0.2,0.4\n            \t\tc0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.2,0.2-0.3,0.2-0.4\n            \t\tc0-0.1,0-0.4,0-0.6v-0.2H14v0.5c0,0.2,0,0.4-0.1,0.5c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.1-0.3-0.2c0-0.1,0-0.2,0-0.5v-0.8\n            \t\tL13.3,12.7L13.3,12.7L13.3,12.7z M13.3,12.1v-0.5c0-0.4,0-0.3,0-0.4c0-0.1,0.1-0.2,0.3-0.2c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0,0,0,0.3\n            \t\tv0.5v0.1h-0.1h-0.3h-0.1C13.3,12.2,13.3,12.1,13.3,12.1z',
            viewBox: '0 0 18.1 18.1',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Play Button
defs.push({
    id: 'defId-Hk9BP65o',
    desc: 'Play Button',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (350 / 350)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M175,0C78.3,0,0,78.3,0,175c0,96.7,78.3,175,175,175c96.7,0,175-78.3,175-175C350,78.3,271.7,0,175,0z M258.7,189.1\n                \tl-104.4,71.8c-2.9,2-6.3,3-9.7,3c-2.7,0-5.4-0.6-7.9-2c-5.6-3-9.1-8.8-9.1-15.1V103.2c0-6.3,3.5-12.1,9.1-15.1\n                \tc5.6-2.9,12.4-2.5,17.6,1.1l104.4,71.8c4.6,3.2,7.4,8.4,7.4,14.1C266.1,180.6,263.4,185.9,258.7,189.1z',
            viewBox: '0 0 350 350',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Thumb
defs.push({
    id: 'defId-Syk8PT9j',
    desc: 'Thumb',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (949.3 / 927.7)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M899.3,327.3L544,326.9c0,0,20.6-84.3,24.3-123.8c2.5-27,3.1-53.9-3.1-80.5c-9.2-40-19.5-65-35.9-96\n            \t\tC520.5,10.2,503.5,0,485,0h-68.8c-27.7,0-50.1,22.5-50,50.2c0.2,46.3,0.2,108.1-0.8,110.2c-27,56.8-58.3,111.3-93.6,163.3\n            \t\tc-16.1,23.8-33,46.9-52.6,68c-8.6,9.2-13.3,21.4-13.3,33.9v437.2c0,12.9,5,25.4,14,34.7c13.4,13.8,37.4,30.2,76.8,30.2\n            \t\tc124.3-0.5,325.7-1.6,468.9-0.6c17.9,0.1,34.5-9.3,43.5-24.8l126.3-216.2c8.6-15,13.1-32,13.2-49.3l0.7-259.3\n            \t\tC949.3,349.8,926.9,327.4,899.3,327.3z\n                    M94.8,398.7H50c-27.6,0-50,22.4-50,50v429c0,27.6,22.4,50,50,50h44.7c27.6,0,50-22.4,50-50v-429\n                \t\tC144.8,421.1,122.4,398.7,94.8,398.7z',
            viewBox: '0 0 949.3 927.7',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Twitter
defs.push({
    id: 'defId-HkU8wa9o',
    desc: 'Twitter',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (486.4 / 486.4)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M395.2,0h-304C40.8,0,0,40.8,0,91.2v304c0,50.4,40.8,91.2,91.2,91.2h304c50.4,0,91.2-40.8,91.2-91.2v-304\n    \t\t\t\tC486.4,40.8,445.6,0,395.2,0z M364.2,188.6l0.2,7.8c0,79.2-60.2,170.4-170.4,170.4c-33.8,0-65.3-9.9-91.8-26.9\n    \t\t\t\tc4.7,0.5,9.5,0.9,14.3,0.9c28.1,0,53.9-9.6,74.4-25.6c-26.2-0.5-48.3-17.8-55.9-41.6c3.7,0.7,7.4,1,11.3,1\n    \t\t\t\tc5.5,0,10.8-0.7,15.8-2.1c-27.4-5.5-48-29.7-48-58.7v-0.8c8.1,4.5,17.3,7.2,27.1,7.5c-16.1-10.7-26.6-29.1-26.6-49.8\n    \t\t\t\tc0-11,2.9-21.2,8.1-30.1c29.5,36.2,73.7,60.1,123.4,62.6c-1-4.4-1.6-9-1.6-13.6c0-33,26.8-59.9,59.9-59.9\n    \t\t\t\tc17.2,0,32.8,7.3,43.7,18.9c13.6-2.7,26.4-7.7,38-14.5c-4.5,14-14,25.7-26.3,33.1c12.1-1.4,23.7-4.7,34.4-9.4\n    \t\t\t\tC386.1,169.7,375.9,180.2,364.2,188.6z',
            viewBox: '0 0 486.4 486.4',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// Youtube
defs.push({
    id: 'defId-H1hUw65i',
    desc: 'Youtube',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        scaleOnly: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        alpha: 1,
        shadow: false
    },
    precalc: {
        oh: '${ow / (90 / 63)}'
    },
    layers: [{
        id: 's1',
        desc: '',
        type: 'path',
        attrs: {
            d: 'M90,13.5C90,6,84,0,76.6,0H13.5C6,0,0,6,0,13.5v36.1C0,57,6,63,13.4,63h63.1\n            \t\tC84,63,90,57,90,49.5V13.5z M36,46.7V12.8l25.7,16.9L36,46.7z',
            viewBox: '0 0 90 63',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: '${shadow ? calcSelfShadowColor() : "#fff"}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

// legacy template - border lines
defs.push({
    id: 'defId-SyBZK1sj-legacy',
    desc: 'lines border',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        color1: '#fff',
        textColor1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            // lineHeightFactor : 1.42,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 0,
            y: 0,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__height}' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__t1__height}' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Line Borders',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M${-oh/2 - 50},${oh/2}L${ow/2},${-ow/2 - 50}L${ow+oh/2 + 50},${oh/2}L${ow/2},${oh+ow/2 + 50}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: '${l__t1__shadowOffsetX}',
            shadowOffsetY: '${l__t1__shadowOffsetY}',
            shadowBlur: '${l__t1__shadowBlur}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': {
                        v: 'M${-oh/2},${oh/2}L${-oh/2},${oh/2}L${ow/2},${oh+ow/2}L${ow/2},${oh+ow/2}z'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                clipPath: {
                    '100%': {
                        v: 'M${-oh/2},${oh/2}L${-oh/2},${oh/2}L${ow/2},${oh+ow/2}L${ow/2},${oh+ow/2}z'
                    }
                }
            }
        }
    }]
});

// LEGACY template - ribbon strips
defs.push({
    id: 'defId-Hk2MND86',
    desc: 'Ribbon strips',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        color1: '#b32c39',
        textColor1: '#004e7f',
        alpha: 1,
        text1: 'SIMPLE RULES',
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        shadow: true,
        lineHeight: 1.65,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height * (60/41.5)}'
    },
    layers: [{
        id: 'l1p',
        desc: 'First strip phantom',
        type: 'path',
        attrs: {
            d: 'M172.99,124.68L450.77,168.27L172.99,168.27z',
            viewBox: '129 109 372 60',
            fill: '#444',
            fillAlpha: 0.5,
            alpha: '${0.5*alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M450.77,168.27L450.77,168.27L450.77,168.27Z' },
                    '21%': {},
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'First strip',
        type: 'path',
        attrs: {
            d: 'M172.99,124.68L450.77,168.27L172.99,168.27z',
            viewBox: '129 109 372 60',
            fill: '#edede5',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: '#000',
            shadowAlpha: 0.6,
            shadowOffsetX: 0,
            shadowOffsetY: 4,
            shadowBlur: 12,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M450.77,168.27L450.77,168.27L450.77,168.27Z' },
                    '24%': {},
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l2p',
        desc: 'Second strip phantom',
        type: 'path',
        attrs: {
            d: 'M172.99,124.68L172.99,169.13L500.34,151.2L500.34,109.32z',
            viewBox: '129 109 372 60',
            fill: '#444',
            fillAlpha: 0.5,
            alpha: '${0.5*alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M172.99,124.68L172.99,169.13L172.99,169.13L172.99,124.68z' },
                    '24%': { v: 'M172.99,124.68L172.99,169.13L172.99,169.13L172.99,124.68z' },
                    '56%': {},
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'Second strip',
        type: 'path',
        attrs: {
            d: 'M172.99,124.68L172.99,169.13L500.34,151.2L500.34,109.32z',
            viewBox: '129 109 372 60',
            fill: '${color1}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: '#000',
            shadowAlpha: 0.6,
            shadowOffsetX: 0,
            shadowOffsetY: 4,
            shadowBlur: 12,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M172.99,124.68L172.99,169.13L172.99,169.13L172.99,124.68z' },
                    '27%': { v: 'M172.99,124.68L172.99,169.13L172.99,169.13L172.99,124.68z' },
                    '59%': {},
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l3p',
        desc: 'Third strip phantom',
        type: 'path',
        attrs: {
            d: 'M130.08,109.38L500.08,109.38L500.08,150.88L130.08,150.88z',
            viewBox: '129 109 372 60',
            fill: '#444',
            fillAlpha: 0.5,
            alpha: '${0.5*alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M500.08,109.38L500.08,109.38L500.08,150.88L500.08,150.88z' },
                    '59%': { v: 'M500.08,109.38L500.08,109.38L500.08,150.88L500.08,150.88z' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l3',
        desc: 'Third strip',
        type: 'path',
        attrs: {
            d: 'M130.08,109.38L500.08,109.38L500.08,150.88L130.08,150.88z',
            viewBox: '129 109 372 60',
            fill: '#edede5',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: '#000',
            shadowAlpha: 0.6,
            shadowOffsetX: 0,
            shadowOffsetY: 4,
            shadowBlur: 12,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M500.08,109.38L500.08,109.38L500.08,150.88L500.08,150.88z' },
                    '62%': { v: 'M500.08,109.38L500.08,109.38L500.08,150.88L500.08,150.88z' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            // lineHeightFactor : 1.65,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxLines: 1,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            clipPath: 'M0,0h${ow}v${l__self__height}h${-ow}z',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${l__t1__height}h0z' },
                    '62%': { v: 'M${ow},0h0v${l__t1__height}h0z' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0 }
                }
            }
        }
    }]
});

// Old penguin slide
defs.push({
    id: 'defId-BJlN7AjBe',
    desc: 'Two text + wedgy background + side borders',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color2'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#F1626E',
        color2: '#000000',
        textColor1: '#FFFFFF',
        textColor2: '#F1626E',
        alpha: 0.8,
        lineHeight1: 1,
        letterSpacing1: 0,
        lineHeight2: 1,
        letterSpacing2: 0,
        text1: 'PENGUIN SLIDE',
        text2: 'Next show after the Lion Dance',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL'
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 40}'
    },
    layers: [{
        id: 's2',
        desc: 'Background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}L${ow - 95},${oh}H0z',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${-ow}, 0)' },
                    '20%': { v: 'translate(${-ow}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '80%': { v: 'translate(${-ow}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${-ow}, 0)' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Straight border line',
        type: 'rect',
        attrs: {
            width: 13,
            height: '${oh}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Slant border line',
        type: 'path',
        attrs: {
            d: 'M${ow},0h-10l-95,${oh}h10z',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0h-140l-95,${oh}h140z' },
                    '36%': { v: 'M0,0h-140l-95,${oh}h140z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                d: {
                    '10%': {},
                    '64%': { v: 'M0,0h-140l-95,${oh}h140z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0h-140l-95,${oh}h140z' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 1,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 60,
            y: 50,
            maxWidth: '${ow - 60 - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M20,30h${l__self__maxWidth}v${l__self__height + 30}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,30h0v${l__t1__height + 30}h0z' },
                    '36%': { v: 'M0,30h0v${l__t1__height + 30}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 15}' },
                    '50%': { v: '${l__t1__y + l__t1__height + 15}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': {
                        v: 'M0,30h0v${l__t1__height + 30}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,30h0v${l__t1__height + 30}h0z' }
                },
                y: {
                    '50%': {
                        v: '${l__t1__y + l__t1__height + 15}',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: '${l__t1__y + l__t1__height + 15}' }
                }
            }
        }
    }, {
        id: 't2',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            // lineHeightFactor : 1,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 60,
            y: '${l__t1__y + l__t1__height + 30}',
            maxWidth: '${ow - 60 - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M60,${l__self__y - 15}h${l__self__maxWidth}v${l__self__height + 15}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z' },
                    '36%': { v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${-l__t2__height - 15}' },
                    '50%': { v: '${-l__t2__height - 15}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': {
                        v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z' }
                },
                y: {
                    '20%': {},
                    '50%': { v: '${-l__t2__height - 15}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height - 15}' }
                }
            }
        }
    }]
});

//New penguin slide
defs.push({
    id: 'defId-SJMNwOZ0G',
    desc: 'Two text + wedgy background + side borders',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color2'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#F1626E',
        color2: '#000000',
        textColor1: '#FFFFFF',
        textColor2: '#F1626E',
        alpha: 0.8,
        lineHeight1: 1,
        letterSpacing1: 0,
        lineHeight2: 1,
        letterSpacing2: 0,
        text1: 'PENGUIN SLIDE',
        text2: 'Next show after the Lion Dance',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL'
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 40}'
    },
    layers: [{
        id: 's2',
        desc: 'Background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}L${ow - 95},${oh}H0z',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${-ow}, 0)' },
                    '20%': { v: 'translate(${-ow}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '80%': { v: 'translate(${-ow}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${-ow}, 0)' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Straight border line',
        type: 'rect',
        attrs: {
            width: 13,
            height: '${oh}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Slant border line',
        type: 'path',
        attrs: {
            d: 'M${ow},0h-10l-95,${oh}h10z',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0h-140l-95,${oh}h140z' },
                    '36%': { v: 'M0,0h-140l-95,${oh}h140z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                d: {
                    '10%': {},
                    '64%': { v: 'M0,0h-140l-95,${oh}h140z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0h-140l-95,${oh}h140z' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 1,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 60,
            y: 50,
            maxWidth: '${ow - 60 - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M20,30h${l__self__maxWidth}v${l__self__height + 30}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,30h0v${l__t1__height + 30}h0z' },
                    '36%': { v: 'M0,30h0v${l__t1__height + 30}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 15}' },
                    '50%': { v: '${l__t1__y + l__t1__height + 15}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': {
                        v: 'M0,30h0v${l__t1__height + 30}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,30h0v${l__t1__height + 30}h0z' }
                },
                y: {
                    '50%': {
                        v: '${l__t1__y + l__t1__height + 15}',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: '${l__t1__y + l__t1__height + 15}' }
                }
            }
        }
    }, {
        id: 't2',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 70,
            lineSpacing: 10,
            // lineHeightFactor : 1,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 60,
            y: '${l__t1__y + l__t1__height + 30}',
            maxWidth: '${ow - 60 - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M60,${l__self__y - 15}h${l__self__maxWidth}v${l__self__height + 15}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z' },
                    '36%': { v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${-l__t2__height - 15}' },
                    '50%': { v: '${-l__t2__height - 15}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': {
                        v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t2__y - 15}h0v${l__t2__height + 15}h0z' }
                },
                y: {
                    '20%': {},
                    '50%': { v: '${-l__t2__height - 15}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height - 15}' }
                }
            }
        }
    }]
});

// // Bubbles template
// defs.push({
//     id : 'defId-rkqyw4ute',
//     meta : {
//         autoHeight : true,
//         textEditors : {
//             'text1' : 't1'
//         },
//         mappings : {
//             primaryColor : 'color2'
//         }
//     },
//     props : {
//         color1 : 'color',
//         color2 : 'color',
//         color3 : 'color',
//         alpha : 'alpha',
//         text1 : 'text',
//         fontFamily1 : 'fontfamily',
//         shadow : 'shadow'
//     },
//     defaults : {
//         color1 : '#FFFFFF',
//         color2 : '#1edd82',
//         color3 : '#FFFFFF',
//         alpha : 1,
//         text1 : '',
//         fontFamily1 : 'ROBOTO',
//         shadow : true
//     },
//     precalc : {
//         'oh' : '${l__t1__height}'
//     },
//     layers : [
//         {
//             id : 't1'
//         }
//     ]
// })

// defs.push({
//     id : 'defId-SyBZK1sj',
//     meta : {
//         autoHeight : true,
//         textEditors : {
//             'text1' : 't1'
//         },
//         mappings : {
//             primaryColor : 'color1'
//         }
//     },
//     props : {
//         color1 : 'color',
//         alpha : 'alpha',
//         text1 : 'text',
//         fontFamily1 : 'fontfamily',
//         shadow : 'shadow'
//     },
//     precalc : {
//         'oh' : '${10 + l__t1__height + 10}'
//     },
//     layers : [
//         {
//             id : 't1',
//             desc : 'Only text',
//             type : 'text',
//             attrs : {
//                 fontFamily : '${fontFamily1}',
//                 fontWeight : 'NORMAL',
//                 fontStyle : 'NORMAL',
//                 fontSize : 75,
//                 maxLines : 100,
//                 lineSpacing : 10,
//                 x : 10,
//                 y : 10,
//                 maxWidth : '${ow - 10 - 10}',
//                 height : '${calcSelfHeight()}',
//                 align : 'center',
//                 text : '${text1}',
//                 fill : '${color1}',
//                 alpha : '${alpha}',
//                 shadowEnabled : '${shadow}',
//                 shadowColor : "${shadow ? calcSelfShadowColor() : '#fff'}",
//                 shadowAlpha : '${l__self__alpha}'
//             },
//             vars : {
//                 condeven : {
//                     expr : '${i%2 == 0}', type : 'bool'
//                 },
//                 condodd : {
//                     expr : '${i%2 != 0}', type : 'bool'
//                 }
//             },
//             animation : {
//                 enterkeyframes : {
//                     '${map(filter(lines, condeven), getter("transform"))}' : {
//                         '0%' : { v : 'translate(0, ${get(get(lines, i), "lineHeight")})' },
//                         '100%' : {}
//                     },
//                     '${map(filter(lines, condodd), "transform")}' : {
//                         '0%' : { v : 'scale(1, 0)' },
//                         '100%' : {}
//                     }
//                 },
//                 exitkeyframes : {
//                     alpha : {
//                         '100%' : { v : 0 }
//                     }
//                 }
//             }
//         },
//         {
//             id : 'b1',
//             desc : 'Line Border Top and left',
//             type : 'path',
//             attrs : {
//                 d : 'M0,${oh}L0,0L${ow},0L${ow - 10},10L10,10L10,${oh - 10}z',
//                 fill : '${color1}',
//                 alpha : '${alpha}',
//                 transform : ''//,
//                 // shadowEnabled : '${shadow}',
//                 // shadowColor : "${shadow ? calcSelfShadowColor() : '#fff'}",
//                 // shadowAlpha : '${l__self__alpha}'
//             },
//             animation : {
//                 enterkeyframes : {
//                     d : {
//                         '0%' : { v : 'M0,${oh}L0,${oh}L${ow},0L${ow - 10},10L10,10L10,${oh - 10}z' },
//                         '100%' : {}
//                     }
//                 },
//                 exitkeyframes : {
//                     d : {
//                         '100%' : { v : 'M0,${oh}L10,${oh - 10}z' }
//                     }
//                 }
//             }
//         },
//         {
//             id : 'b2',
//             desc : 'Line Border Right and bottom',
//             type : 'path',
//             attrs : {
//                 d : 'M0,${oh}L0,0L${ow},0L${ow - 10},10L10,10L10,${oh - 10}z',
//                 fill : '${color1}',
//                 alpha : '${alpha}',
//                 transform : 'scale(-1, -1) translate(${-ow}, ${-oh})'//,
//                 // shadowEnabled : '${shadow}',
//                 // shadowColor : "${shadow ? calcSelfShadowColor() : '#fff'}",
//                 // shadowAlpha : '${l__self__alpha}'
//             },
//             animation : {
//                 enterkeyframes : {
//                     'd' : {
//                         '0%' : { v : 'M0,${oh}L10,${oh - 10}z' }
//                     }
//                 },
//                 exitkeyframes : {
//                     'd' : {
//                         '100%' : { v : 'M0,${oh}L10,${oh - 10}z' }
//                     }
//                 }
//             }
//         }
//     ]
// })

defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs2.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs4.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs6.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs8.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs10.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs12.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs14.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs16.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs18.default));
defs.push.apply(defs, _toConsumableArray(_AllTemplateDefs20.default));

exports.default = (0, _GeneralUtils.deepFreeze)(defs);
exports.createBitmapTemplateDefFromWorkspaceImage = createBitmapTemplateDefFromWorkspaceImage;
exports.createSVGTemplateDefFromWorkspaceSVG = createSVGTemplateDefFromWorkspaceSVG;

},{"../constants/TemplateTypes":67,"../utils/GeneralUtils":77,"./AllTemplateDefs1":30,"./AllTemplateDefs10":31,"./AllTemplateDefs2":32,"./AllTemplateDefs3":33,"./AllTemplateDefs4":34,"./AllTemplateDefs5":35,"./AllTemplateDefs6":36,"./AllTemplateDefs7":37,"./AllTemplateDefs8":38,"./AllTemplateDefs9":39,"./data-svgs":59}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var defs = [];

// box stencil
defs.push({
    id: 'defId-SJkMxSuKl',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text2': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFFFFF',
        color2: '#5C875E',
        textColor1: '#FFFFFF',
        text1: '',
        text2: 'THANK YOU',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        lineHeight1: 1.5,
        lineHeight2: 1.5,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${20 + l__r1__height + 10 + l__t2__height + 20}'
    },
    layers: [{
        id: 'r1',
        desc: 'Text background box 1',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 't1',
                mAlphaInv: true
            }]
        },
        attrs: {
            x: 20,
            y: 20,
            width: '${ow - 40}',
            height: '${l__t1__height}',
            fill: '${color2}'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '88%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                height: {
                    '0%': {},
                    '12%': {},
                    '50%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'r2',
        desc: 'Text background box 2',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 't1',
                mAlphaInv: true
            }]
        },
        attrs: {
            x: '${l__r1__x}',
            y: '${l__r1__y}',
            width: '${l__r1__width}',
            height: '${l__r1__height}',
            fill: '${calcInterColor(color1, color2, 0.32, 0.68)}'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '0%': { v: 0 },
                    '55%': { v: 0 },
                    '93%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                height: {
                    '0%': {},
                    '7%': {},
                    '45%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'r3',
        desc: 'Text background box 3',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 't1',
                mAlphaInv: true
            }]
        },
        attrs: {
            x: '${l__r1__x}',
            y: '${l__r1__y}',
            width: '${l__r1__width}',
            height: '${l__r1__height}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '0%': { v: 0 },
                    '58%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                height: {
                    '42%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'lol',
        desc: 'Outer outline left',
        type: 'path',
        attrs: {
            d: 'M${ow/2},${oh + 20}h${-ow/2 - 20}v${-oh - 40}h${ow/2 + 20}',
            stroke: '${color1}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '17%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '28%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '78%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '72%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '83%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lor',
        desc: 'Outer outline right',
        type: 'path',
        attrs: {
            d: 'M${ow/2},${oh + 20}h${ow/2 + 20}v${-oh - 40}h${-ow/2 - 20}',
            stroke: '${color1}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '17%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '28%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '78%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '72%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '83%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'li1l',
        desc: 'Inner outline 1 left',
        type: 'path',
        attrs: {
            d: 'M${ow/2},${oh}h${-ow/2}v${-oh}h${ow/2}',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '28%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'li1r',
        desc: 'Inner outline 1 right',
        type: 'path',
        attrs: {
            d: 'M${ow/2},${oh}h${ow/2}v${-oh}h${-ow/2}',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '28%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'li2l',
        desc: 'Inner outline 2 left',
        type: 'path',
        attrs: {
            d: '${l__li1l__d}',
            stroke: '${calcInterColor(color1, color2, 0.32, 0.68)}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '3%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '75%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '25%': {},
                    '97%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'li2r',
        desc: 'Inner outline 2 right',
        type: 'path',
        attrs: {
            d: '${l__li1r__d}',
            stroke: '${calcInterColor(color1, color2, 0.32, 0.68)}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '3%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '75%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '25%': {},
                    '97%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'li3l',
        desc: 'Inner outline 3 left',
        type: 'path',
        attrs: {
            d: '${l__li1l__d}',
            stroke: '${color2}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '7%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '78%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '22%': {},
                    '93%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'li3r',
        desc: 'Inner outline 3 right',
        type: 'path',
        attrs: {
            d: '${l__li1r__d}',
            stroke: '${color2}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '7%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '78%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '22%': {},
                    '93%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        meta: {
            shy: true
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 140,
            // lineHeightFactor : 1.5,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${l__r1__x}',
            y: '${l__r1__y}',
            maxWidth: '${l__r1__width}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Sub text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            // lineHeightFactor : 1.5,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__r1__x}',
            y: '${l__r1__y + l__r1__height + 10}',
            maxWidth: '${l__r1__width}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__self__y - 10}h${l__self__maxWidth}V${oh}h${-l__self__maxWidth}z',
            align: 'center',
            text: '${text2}',
            fill: '${textColor1}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(0, -${l__t2__height + 10})' },
                    '75%': { v: 'translate(0, -${l__t2__height + 10})' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '25%': {
                        v: 'translate(0, -${l__t2__height + 10})',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: 'translate(0, -${l__t2__height + 10})',
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

// Top and bottom line title + subtitle
defs.push({
    id: 'defId-S1OoyT3Fg',
    desc: 'Top and bottom line title + subtitle',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        shadow: 'shadow',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#50ffd1',
        textColor1: '#FFF',
        textColor2: '#50ffd1',
        alpha: 1,
        shadow: false,
        text1: 'SIMPLE TITLES',
        text2: 'ANIMATION',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        lineHeight1: 1.2,
        lineHeight2: 1.5,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 'l1',
        desc: 'Top line',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            fillAlpha: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                transform: {
                    '0%': { v: 'translate(0, ${l__t1__height/2})' },
                    '40%': { v: 'translate(0, ${l__t1__height/2})' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '0%': {},
                    '50%': { v: 'translate(0, ${l__t1__height/2})', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(0, ${oh})', ease: 'easyEaseInOutReverse' }
                },
                alpha: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'Bottom line',
        type: 'path',
        attrs: {
            d: 'M0,${l__t1__height}h${ow}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            fillAlpha: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                transform: {
                    '0%': { v: 'translate(0, ${-l__t1__height/2})' },
                    '40%': { v: 'translate(0, ${-l__t1__height/2})' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '0%': {},
                    '50%': { v: 'translate(0, ${-l__t1__height/2})', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(0, ${oh - l__t1__height})', ease: 'easyEaseInOutReverse' }
                },
                alpha: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 140,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            align: 'center',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__height/2}h${l__t1__maxWidth}v0h${-l__t1__maxWidth}z' },
                    '40%': { v: 'M0,${l__t1__height/2}h${l__t1__maxWidth}v0h${-l__t1__maxWidth}z' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                transform: {
                    '0%': { v: 'translate(${l__t1__maxWidth/2}, ${l__t1__height/2}) scale(0.95, 0.95) translate(${-l__t1__maxWidth/2}, ${-l__t1__height/2})' },
                    '40%': { v: 'translate(${l__t1__maxWidth/2}, ${l__t1__height/2}) scale(0.95, 0.95) translate(${-l__t1__maxWidth/2}, ${-l__t1__height/2})' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '50%': { v: 'M0,${l__t1__height/2}h${l__t1__maxWidth}v0h${-l__t1__maxWidth}z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t1__height/2}h${l__t1__maxWidth}v0h${-l__t1__maxWidth}z' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            // lineHeightFactor : 1.5,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            align: 'center',
            y: '${l__t1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__self__y}h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '70%': { v: 'scale(1, 0)' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__height/2}h${l__t2__maxWidth}v${oh - l__t1__height/2}h${-l__t1__maxWidth}z' },
                    '50%': { v: 'M0,${l__t1__height/2}h${l__t2__maxWidth}v${oh - l__t1__height/2}h${-l__t1__maxWidth}z' },
                    '100%': { v: 'M0,${oh}h${l__t1__maxWidth}v0h${-l__t1__maxWidth}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

// Circle with text
defs.push({
    id: 'defId-HyFe_MV5e',
    desc: 'Circle + text',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFFFFF',
        textColor1: '#C4005B',
        textColor2: '#000000',
        alpha: 1,
        text1: 'CUSTOM',
        text2: 'TEXT',
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight1: 1.1,
        lineHeight2: 1.1,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${ow}'
    },
    layers: [{
        id: 'cb1',
        desc: 'circle back',
        type: 'ellipse',
        attrs: {
            cx: '${ow/2}',
            cy: '${oh/2}',
            rx: '${ow/2 - 5}',
            ry: '${oh/2 - 5}',
            fill: '${color1}',
            alpha: '${alpha * 0.77}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '48%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '52%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' }
                }
            }
        }
    }, {
        id: 'cb2',
        desc: 'circle back 2',
        type: 'ellipse',
        attrs: {
            cx: '${ow/2}',
            cy: '${oh/2}',
            rx: '${ow/2 - 40}',
            ry: '${oh/2 - 40}',
            fill: '${color1}',
            alpha: '${alpha * 0.63}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '52%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '94%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '6%': {},
                    '48%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' }
                }
            }
        }
    }, {
        id: 'co1',
        desc: 'circle outward 1',
        type: 'ellipse',
        attrs: {
            cx: '${ow/2}',
            cy: '${oh/2}',
            rx: '${ow/2 - 40}',
            ry: '${oh/2 - 40}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 0,
            strokeAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '76%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeWidth: {
                    '0%': { v: 133 },
                    '76%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '24%': {},
                    '100%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})', ease: 'easyEaseInOutReverse' }
                },
                strokeWidth: {
                    '24%': {},
                    '100%': { v: 133, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'co2',
        desc: 'circle outward 2',
        type: 'ellipse',
        attrs: {
            cx: '${ow/2}',
            cy: '${oh/2}',
            rx: '${ow/2 - 40}',
            ry: '${oh/2 - 40}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 0,
            strokeAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '26%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                strokeWidth: {
                    '0%': { v: 133 },
                    '26%': { v: 133 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '74%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${ow/2}, ${oh/2}) scale(0, 0) translate(${-ow/2}, ${-oh/2})' }
                },
                strokeWidth: {
                    '74%': { v: 133, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 133 }
                }
            }
        }
    }, {
        id: 'cl1',
        desc: 'circle line 1',
        type: 'path',
        attrs: {
            d: 'M${ow/2},-40A ${ow/2 - 20} ${oh/2 - 20} 0 0 1 ${ow/2},${oh + 40}A ${ow/2 - 20} ${oh/2 - 20} 0 0 1 ${ow/2},-40',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 ${PI * (ow + 80)}'
            },
            strokeWidth: 50,
            strokeAlpha: '${alpha * 0.77}'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '6%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '22%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '23%'
                        },
                        ease: 'easeinout'
                    },
                    '70%': {
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '30%': {},
                    '78%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '23%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '94%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        },
                        ease: 'easeinout'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    }
                }
            }
        }
    }, {
        id: 'cl2',
        desc: 'circle line 2',
        type: 'path',
        attrs: {
            d: 'M${ow/2},-74A ${ow/2 - 37} ${oh/2 - 37} 0 0 1 ${ow/2},${oh + 74}A ${ow/2 - 37} ${oh/2 - 37} 0 0 1 ${ow/2},-74',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 ${PI * (ow + 148) * 1}'
            },
            strokeWidth: 10,
            strokeAlpha: '${alpha * 0.77}'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '16%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '23%'
                        },
                        ease: 'easeinout'
                    },
                    '64%': {
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '36%': {},
                    '84%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '23%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        },
                        ease: 'easeinout'
                    }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Top text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.1,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            align: 'center',
            x: '${ow * 0.1 + 37}',
            y: '${oh/2 - l__self__height}',
            maxWidth: '${ow * 0.8 - 75}',
            maxHeight: '${oh * 0.35 - 37}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh/2}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh/2 + 5}' },
                    '66%': { v: '${oh/2 + 5}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '34%': { v: '${oh/2 + 5}', ease: 'easeInOutReverse' },
                    '100%': { v: '${oh/2 + 5}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.1,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            align: 'center',
            x: '${ow * 0.1 + 37}',
            y: '${oh/2}',
            maxWidth: '${ow * 0.8 - 75}',
            maxHeight: '${oh * 0.35 - 37}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${oh}h${ow}v${-oh/2}h${-ow}z',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh/2 - l__t2__height - 5}' },
                    '66%': { v: '${oh/2 - l__t2__height - 5}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '34%': { v: '${oh/2 - l__t2__height - 5}', ease: 'easeInOutReverse' },
                    '100%': { v: '${oh/2 - l__t2__height - 5}' }
                }
            }
        }
    }]
});
exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77}],31:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var defs = [];

defs.push({
    id: 'defId-a3m5eMKuu',
    desc: 'Fitness timer template 1',
    meta: {
        autoHeight: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        textEditors: {
            text1: 't2'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        },
        minWidth: 350
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        color1: 'color',
        color2: 'color',
        color3: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        text1: 'Jumping Jacks',
        textColor1: '#f00',
        color1: '#fff',
        color2: '#f00',
        color3: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        shadow: false,
        timeFormat: 'SECS',
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: '${l__t2__height * 3}'
    },
    layers: [{
        id: 'b1',
        desc: 'Label background',
        type: 'path',
        attrs: {
            d: 'M0,${oh/4}h${ow-oh- 40}v${oh/2}h${-ow}z',
            fillAlpha: 1,
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Label text',
        type: 'text',
        attrs: {
            x: 20,
            y: '${(oh - l__t2__height)/2}',
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            layoutAlgo: 'fixed',
            maxWidth: '${ow - 300}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            maxLines: 1,
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'b3',
        desc: 'Counter background',
        type: 'ellipse',
        attrs: {
            cx: '${ow - oh/2}',
            // cx : '${oh/2}',
            cy: '${oh/2}',
            rx: '${oh/2-39}',
            ry: '${oh/2-39}',
            fill: '${color2}',
            shadowEnabled: false,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'Counter timer circle fill',
        type: 'path',
        attrs: {
            d: 'M${(oh-40)/2},0A${(oh-40)/2},${(oh-40)/2} 0 1,1 ${(oh-40)/2-1},0z',
            height: '${oh}',
            y: 20,
            x: '${ow - oh + 20}',
            fillAlpha: 0,
            strokeWidth: 40,
            stroke: '${color3}',
            strokeAlpha: '1',
            strokeCap: 'butt',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Counter text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${ow - oh + 45}',
            y: '${(oh - calcSelfHeight())/2}',
            width: '${oh - 90}',
            maxWidth: '${oh - 90}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-Yl0eKjoPE',
    desc: 'Fitness timer template 3',
    meta: {
        autoHeight: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        mappings: {
            primaryColor: 'color1'
        },
        textEditors: {
            text1: 't2'
        },
        textColors: {
            text1: 'textColor1'
        },
        minWidth: 350
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        text1: 'Jumping Jacks',
        textColor1: '#f00',
        color1: '#fff',
        color2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        shadow: false,
        timeFormat: 'SECS',
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 10}',
        clockHeight: '${l__t1__height}'
    },
    layers: [{
        id: 't2',
        desc: 'Label',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            y: '${l__t1__height + 10}',
            width: '${oh}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'Timer border',
        type: 'path',
        attrs: {
            d: 'M${ow-10},0H10a10,10 0 0 0 -10,10V${clockHeight-10}a10,10 0 0 0 10,10H${ow-10}a10,10 0 0 0 10,-10V10a10,10 0 0 0 -10,-10z',
            height: '${oh}',
            y: 0,
            x: 0,
            fillAlpha: 0,
            strokeWidth: 20,
            stroke: '${color2}',
            strokeAlpha: '1',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '100%': {
                        ease: 'linear',
                        v: {
                            strokeRangeEnd: '0'
                        }
                    }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            width: '${oh}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-u2ytfIbGg',
    desc: 'Fitness timer template 4',
    meta: {
        autoHeight: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        mappings: {
            primaryColor: 'color1'
        },
        textEditors: {
            text1: 't2'
        },
        textColors: {
            text1: 'textColor1'
        },
        minWidth: 350
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        text1: 'Jumping Jacks',
        textColor1: '#f00',
        color1: '#fff',
        color2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        shadow: false,
        timeFormat: 'MINS',
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 10}',
        clockHeight: '${l__t1__height}'
    },
    layers: [{
        id: 't2',
        desc: 'Label',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            y: '${l__t1__height + 10}',
            width: '${oh}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'Timer border',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            height: '${l__t1__height}',
            clipPath: 'M20,0H${ow-20}a20,20 0 0 1 20,20V${clockHeight-20}a20,20 0 0 1 -20,20H20a20,20 0 0 1 -20,-20V20a20,20 0 0 1 20,-20z',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: '${l__t1__shadowOffsetX}',
            shadowOffsetY: '${l__t1__shadowOffsetY}',
            shadowBlur: '${l__t1__shadowBlur}'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: '${ow}' },
                    '100%': { v: 0, ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            width: '${oh}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-IzYujIxyL',
    desc: 'Horizontal progress bar',
    meta: {
        scaleAndHeight: true,
        templateType: 'progress-bar',
        containsCounter: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        isAscendingTimer: 'isAscendingTimer',
        roundEdges: 'roundEdges',
        startFraction: 'startFraction',
        endFraction: 'endFraction',
        timeFormat: 'timeFormat'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        isAscendingTimer: false,
        roundEdges: true,
        startFraction: 0,
        endFraction: 1,
        timeFormat: 'SECS'
    },
    precalc: {
        // oh: 50,
        curvePath: 'M25,0H${ow-25}a25,25 0 0 1 25,25V${oh-25}a25,25 0 0 1 -25,25H25a25,25 0 0 1 -25,-25V25a25,25 0 0 1 25,-25z'
    },
    layers: [{
        id: 's1',
        desc: 'Timer progress bar',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 0,
            height: '${oh}',
            clipPath: '${roundEdges ? curvePath : ""}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: '${isAscendingTimer ? ow * startFraction : ow * endFraction}' },
                    '100%': {
                        v: '${isAscendingTimer ? ow * endFraction : ow * startFraction}',
                        ease: 'linear'
                    }
                }
            },
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-ZnlFA1XfB',
    desc: 'Vertical progress bar',
    meta: {
        scaleAndHeight: true,
        templateType: 'progress-bar',
        containsCounter: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        isAscendingTimer: 'isAscendingTimer',
        roundEdges: 'roundEdges',
        startFraction: 'startFraction',
        endFraction: 'endFraction',
        timeFormat: 'timeFormat'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        isAscendingTimer: false,
        roundEdges: true,
        startFraction: 0,
        endFraction: 1,
        timeFormat: 'SECS'
    },
    precalc: {
        // ow: 50,
        curvePath: 'M25,0H${ow-25}a25,25 0 0 1 25,25V${oh-25}a25,25 0 0 1 -25,25H25a25,25 0 0 1 -25,-25V25a25,25 0 0 1 25,-25z'
    },
    layers: [{
        id: 's1',
        desc: 'Timer progress bar',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 0,
            y: 0,
            width: '${ow}',
            height: '${oh}',
            clipPath: '${roundEdges ? curvePath : ""}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                height: {
                    '0%': { v: '${isAscendingTimer ? oh * startFraction : oh * endFraction}' },
                    '100%': {
                        v: '${isAscendingTimer ? oh * endFraction : oh * startFraction}',
                        ease: 'linear'
                    }
                }
            },
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-g8m5vHKwu',
    desc: 'Calorie Meter template 1',
    meta: {
        autoHeight: true,
        containsCounter: true,
        templateType: 'calorie-meter',
        textEditors: {
            text1: 't2'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        },
        minWidth: 150
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        color1: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        lowerCalorieLimit: 'calorieCount',
        higherCalorieLimit: 'calorieCount',
        lowerCalorieOffset: 'calorieCount',
        higherCalorieOffset: 'calorieCount'
    },
    defaults: {
        alpha: 0.8,
        text1: 'KCAL',
        textColor1: '#fff',
        color1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: true,
        shadow: false,
        timeFormat: 'SECS',
        lowerCalorieLimit: 10,
        higherCalorieLimit: 20,
        lowerCalorieOffset: 0,
        higherCalorieOffset: 0
    },
    precalc: {
        oh: '${l__t2__height}'
    },
    layers: [{
        id: 't2',
        desc: 'Label text',
        type: 'text',
        attrs: {
            x: 0,
            y: 0,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            layoutAlgo: 'fixed',
            width: '${calcSelfWidth()}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            maxLines: 1,
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Counter text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${l__t2__x + l__t2__width + 50}',
            y: 0,
            width: '${calcSelfWidth()}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '010 - 020',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: true,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            lowerCalorieLimit: '${lowerCalorieLimit}',
            higherCalorieLimit: '${higherCalorieLimit}',
            lowerCalorieOffset: '${lowerCalorieOffset}',
            higherCalorieOffset: '${higherCalorieOffset}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-a8m98xKZp',
    desc: 'Calorie Meter template 2',
    meta: {
        autoHeight: true,
        containsCounter: true,
        templateType: 'calorie-meter',
        textEditors: {
            text1: 't2'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        },
        minWidth: 150
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        lowerCalorieLimit: 'calorieCount',
        higherCalorieLimit: 'calorieCount',
        lowerCalorieOffset: 'calorieCount',
        higherCalorieOffset: 'calorieCount'
    },
    defaults: {
        alpha: 0.8,
        text1: 'CALORIES',
        textColor1: '#fff',
        color1: '#fff',
        color2: '#2f80ed',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: true,
        shadow: false,
        timeFormat: 'SECS',
        lowerCalorieLimit: 10,
        higherCalorieLimit: 20,
        lowerCalorieOffset: 0,
        higherCalorieOffset: 0
    },
    precalc: {
        oh: '${l__t2__height + 40}'
    },
    layers: [{
        id: 'b1',
        desc: 'Solid background',
        type: 'path',
        attrs: {
            d: 'M${ow-20},0H20a20,20 0 0 0 -20,20V${oh-20}a20,20 0 0 0 20,20H${ow-20}a20,20 0 0 0 20,-20V20a20,20 0 0 0 -20,-20z',
            fillAlpha: 1,
            fill: '${color2}',
            alpha: '${alpha}',
            clipPath: 'M${ow-20},0H20a20,20 0 0 0 -20,20V${oh-20}a20,20 0 0 0 20,20H${ow-20}a20,20 0 0 0 20,-20V20a20,20 0 0 0 -20,-20z',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Label text',
        type: 'text',
        attrs: {
            x: 20,
            y: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            layoutAlgo: 'fixed',
            width: '${calcSelfWidth()-20}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            maxLines: 1,
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Counter text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${l__t2__x + l__t2__width + 50}',
            y: 20,
            width: '${calcSelfWidth()}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '010 - 020',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: true,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            lowerCalorieLimit: '${lowerCalorieLimit}',
            higherCalorieLimit: '${higherCalorieLimit}',
            lowerCalorieOffset: '${lowerCalorieOffset}',
            higherCalorieOffset: '${higherCalorieOffset}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-u71HCQSlW',
    desc: 'Header with line items',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        textColor2: 'textColor',
        color1: 'color',
        color2: 'color',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        enterTextAnimType: 'enterTextAnimType',
        exitTextAnimType: 'exitTextAnimType'
    },
    defaults: {
        textColor1: '#f00',
        textColor2: '#000',
        color1: '#fff',
        color2: '#fff',
        alpha: 1,
        text1: 'Title',
        text2: 'List item 1\nList item 2\nList item 3',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'center',
        shadow: false,
        lineHeight1: 1.42,
        letterSpacing1: 0,
        lineHeight2: 1.42,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't2',
        desc: 'Only text',
        type: 'text',
        attrs: {
            y: '${l__t1__height}',
            fontFamily: '${fontFamily2}',
            fontSize: 75,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '1',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 6,
            bgFill: '${color2}',
            bgAlpha: '${alpha}',
            enterTextAnim: 'line',
            exitTextAnim: 'line',
            visibleLineFactor: 1,
            enterTextAnimType: '${align == "center" ? "fromBottom" : align == "left"? "fromLeft" : "fromRight"}',
            exitTextAnimType: '${align == "center" ? "toBottom" : align == "left"? "toLeft" : "toRight"}'
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                visibleLineFactor: {
                    '0%': {},
                    '80%': { v: 0, ease: 'linear' },
                    '100%': { v: 0, ease: 'linear' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Header background',
        type: 'rect',
        attrs: {
            height: '${l__t1__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '20%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '80%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Header text',
        type: 'text',
        attrs: {
            x: 0,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '1',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '20%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '80%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-887f4IrXH',
    desc: '2 text lower third items',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        textColor2: 'textColor',
        color1: 'color',
        color2: 'color',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        textColor1: '#f00',
        textColor2: '#0f0',
        color1: '#fff',
        color2: '#f00',
        alpha: 1,
        text1: 'Workout Circuit',
        text2: '3 rounds 30 seconds\n45 seconds rest',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'right',
        shadow: false,
        lineHeight1: 1.42,
        letterSpacing1: 0,
        lineHeight2: 1.42,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 40}',
        lowerTextWidth: '${ow * 0.95}'
    },
    layers: [{
        id: 'b1',
        desc: 'Header background',
        type: 'rect',
        attrs: {
            height: '${l__t1__height}',
            clipPath: 'M0,0H${ow}V${l__t1__height}H0z',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'Top background bar',
        type: 'rect',
        attrs: {
            x: '${ow - 20}',
            height: '${l__t1__height}',
            width: 30,
            clipPath: 'M0,0H${ow+20}V${l__t1__height}H0z',
            fill: '${color2}',
            alpha: '1',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${l__b2__width}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${l__b2__width}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Top text',
        type: 'text',
        attrs: {
            x: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            maxWidth: '${ow - 60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '1',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'b3',
        desc: 'Bottom text background',
        type: 'rect',
        attrs: {
            y: '${l__t2__y}',
            width: '${lowerTextWidth}',
            height: '${l__t2__height}',
            clipPath: 'M0,${l__t2__y}H${ow}V${oh}H0z',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${l__b3__width}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${l__b3__width}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'b4',
        desc: 'Bottom Background bar',
        type: 'rect',
        attrs: {
            x: '${lowerTextWidth - 20}',
            y: '${l__t2__y}',
            height: '${l__t2__height}',
            width: 30,
            clipPath: 'M0,${l__t2__y}H${ow}V${oh}H0z',
            fill: '${color2}',
            alpha: 1,
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${l__b4__width}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${l__b4__width}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        attrs: {
            x: 20,
            y: '${l__t1__height + 40}',
            fontFamily: '${fontFamily2}',
            fontSize: 70,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            maxWidth: '${lowerTextWidth - 60}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '1',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${lowerTextWidth}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${lowerTextWidth}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Eb65en7aN',
    desc: 'Fitness timer template 5',
    meta: {
        autoHeight: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        textEditors: {
            text1: 't2'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        },
        minWidth: 350
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        color1: 'color',
        color2: 'color',
        color3: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        text1: 'Jumping Jacks',
        textColor1: '#f00',
        color1: '#fff',
        color2: '#f00',
        color3: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        shadow: false,
        timeFormat: 'SECS',
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: '${l__t2__height * 3}'
    },
    layers: [{
        id: 'b1',
        desc: 'Label background',
        type: 'path',
        attrs: {
            d: 'M0,${oh/3}h${ow-oh- 40}v${oh/2}h${-ow}z',
            fillAlpha: 1,
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Label text',
        type: 'text',
        attrs: {
            x: 20,
            y: '${(oh/4 + l__t2__height/2)}',
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            layoutAlgo: 'fixed',
            maxWidth: '${ow - 300}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            maxLines: 1,
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'b4',
        desc: 'Label background',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            height: '${l__t3__height + 10}',
            width: '${l__t3__width + 40}',
            fillAlpha: 1,
            fill: '${color3}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't3',
        desc: 'Label text',
        type: 'text',
        attrs: {
            x: 20,
            y: 0,
            fontFamily: '${fontFamily1}',
            fontSize: 50,
            layoutAlgo: 'fixed',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: 'NOW:',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            maxLines: 1,
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            width: '${calcSelfWidth()}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'b3',
        desc: 'Counter background',
        type: 'ellipse',
        attrs: {
            cx: '${ow - oh/2}',
            cy: '${oh/2}',
            rx: '${oh/2-39}',
            ry: '${oh/2-39}',
            fill: '${color2}',
            shadowEnabled: false,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'Counter timer circle fill',
        type: 'path',
        attrs: {
            d: 'M${(oh-40)/2},0A${(oh-40)/2},${(oh-40)/2} 0 1,1 ${(oh-40)/2-1},0z',
            height: '${oh}',
            y: 20,
            x: '${ow - oh + 20}',
            fillAlpha: 0,
            strokeWidth: 40,
            stroke: '${color3}',
            strokeAlpha: '1',
            strokeCap: 'butt',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Counter text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${ow - oh + 45}',
            y: '${(oh - calcSelfHeight())/2}',
            width: '${oh - 90}',
            maxWidth: '${oh - 90}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-VrlJPlhax',
    desc: 'Multi-text lower third',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        color1: '#f00',
        text1: 'Heading',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'Subtext',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: true
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 25}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            maxWidth: '${ow-20}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${l__t1__height }h${-ow}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ l__t1__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding lower line',
        type: 'path',
        attrs: {
            d: 'M20,${l__t1__height+l__t1__y + 11}H${ow}',
            stroke: '#fff',
            strokeWidth: 18,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Bottom line',
        type: 'path',
        attrs: {
            d: 'M10,${l__t1__height+l__t1__y + 11}H${ow}',
            strokeWidth: 18,
            strokeAlpha: 1,
            width: 150,
            stroke: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Secondary Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 10,
            y: '${l__t1__height + 20}',
            maxWidth: '${ow-20}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}V${oh}h${-ow}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '90%': { v: '${ -ow }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77}],32:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _GeneralUtils = require('../utils/GeneralUtils');

var _dataSvgs = require('./data-svgs');

var _dataSvgs2 = _interopRequireDefault(_dataSvgs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var defs = [];

// hexagonal lines + text
defs.push({
    id: 'defId-SJhabeq5e',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        shadow: 'shadow',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        textColor1: '#FFFFFF',
        textColor2: '#50ffd1',
        color1: '#50ffd1',
        text1: 'SPACE-DOG',
        text2: 'PRODUCTION',
        alpha: 1,
        shadow: true,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${2*ow/pow(3, 0.5)}'
    },
    layers: [{
        id: 'lxi',
        desc: 'Inner hexagonal line',
        type: 'path',
        attrs: {
            d: 'M${ow/2},0L${ow},${oh/4}v${oh/2}L${ow/2},${oh}L0,${oh*0.75}v${-oh/2}L${ow/2},0l${0.1 * (ow/2)},${0.1 * (oh/4)}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeWidth: 7,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            transform: 'translate(${ow/2}, ${oh/2}) scale(0.95, 0.95) translate(${-ow/2}, ${-oh/2})'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '12%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '100%': {
                        ease: 'easyEaseInOut'
                    }
                }
            },
            exitkeyframes: {
                shadowAlpha: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeAlpha: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'lxo',
        desc: 'Outer hexagonal line',
        type: 'path',
        attrs: {
            d: 'M${ow/2},0L${ow},${oh/4}v${oh/2}L${ow/2},${oh}L0,${oh*0.75}v${-oh/2}L${ow/2},0l${0.1 * (ow/2)},${0.1 * (oh/4)}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeWidth: 15,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '100%': {
                        ease: 'easyEaseInOut'
                    }
                }
            },
            exitkeyframes: {
                shadowAlpha: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeAlpha: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text top',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${oh/2 - l__self__height}',
            maxWidth: '${ow - 80}',
            maxHeight: '${oh/4}',
            height: '${calcSelfHeight()}',
            clipPath: 'M20,0h${ow - 40}v${oh/2}h${-ow + 40}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '50%': { v: '${-ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '70%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Text bottom',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${oh/2}',
            maxWidth: '${ow - 80}',
            maxHeight: '${oh/4}',
            height: '${calcSelfHeight()}',
            clipPath: 'M20,${oh}h${ow - 40}v${-oh/2}h${-ow + 40}z',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '60%': { v: '${-ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '60%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}' }
                }
            }
        }
    }]
});

//Snapchat social media 1
var smp_1_snapchat = {
    id: 'defId-SyBZK1sk-sc',
    desc: 'snapchat',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        color1: '#fffc00',
        color2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 0.8,
        lineHeight2: 0.8,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's4',
        desc: 'T1 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-95,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: 0,
            width: '${ow - l__self__x}',
            height: '${oh*0.67 -10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 't2 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-45,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: '${l__s4__y + l__s4__height + 10}',
            width: '${l__s4__width * 0.67}',
            height: '${oh*0.33}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo background',
        type: 'path',
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#fffc00',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 's2',
        type: 'path',
        attrs: {
            d: 'M407.001 473.488c-1.068 0-2.087-.039-2.862-.076-.615.053-1.25.076-1.886.076-22.437 0-37.439-10.607-50.678-19.973-9.489-6.703-18.438-13.031-28.922-14.775-5.149-.854-10.271-1.287-15.22-1.287-8.917 0-15.964 1.383-21.109 2.389-3.166.617-5.896 1.148-8.006 1.148-2.21 0-4.895-.49-6.014-4.311-.887-3.014-1.523-5.934-2.137-8.746-1.536-7.027-2.65-11.316-5.281-11.723-28.141-4.342-44.768-10.738-48.08-18.484a7.187 7.187 0 0 1-.584-2.443 4.518 4.518 0 0 1 3.777-4.711c22.348-3.68 42.219-15.492 59.064-35.119 13.049-15.195 19.457-29.713 20.145-31.316a2.85 2.85 0 0 1 .101-.217c3.247-6.588 3.893-12.281 1.926-16.916-3.626-8.551-15.635-12.361-23.58-14.882-1.976-.625-3.845-1.217-5.334-1.808-7.043-2.782-18.626-8.66-17.083-16.773 1.124-5.916 8.949-10.036 15.273-10.036 1.756 0 3.312.308 4.622.923 7.146 3.348 13.575 5.045 19.104 5.045 6.876 0 10.197-2.618 11-3.362a1170.709 1170.709 0 0 0-.679-11.262c-1.614-25.675-3.627-57.627 4.546-75.95 24.462-54.847 76.339-59.112 91.651-59.112a3909.561 3909.561 0 0 0 7.582-.071c15.354 0 67.339 4.27 91.816 59.15 8.173 18.335 6.158 50.314 4.539 76.016l-.076 1.23c-.222 3.49-.427 6.793-.6 9.995.756.696 3.795 3.096 9.978 3.339 5.271-.202 11.328-1.891 17.998-5.014 2.062-.968 4.345-1.169 5.895-1.169 2.343 0 4.727.456 6.714 1.285l.106.041c5.66 2.009 9.367 6.024 9.447 10.242.071 3.932-2.851 9.809-17.223 15.485-1.472.583-3.35 1.179-5.334 1.808-7.952 2.524-19.951 6.332-23.577 14.878-1.97 4.635-1.322 10.326 1.926 16.912.036.072.067.145.102.221 1 2.344 25.205 57.535 79.209 66.432a4.523 4.523 0 0 1 3.778 4.711 7.252 7.252 0 0 1-.598 2.465c-3.289 7.703-19.915 14.09-48.064 18.438-2.642.408-3.755 4.678-5.277 11.668-.63 2.887-1.271 5.717-2.146 8.691-.819 2.797-2.641 4.164-5.567 4.164h-.441c-1.905 0-4.604-.346-8.008-1.012-5.95-1.158-12.623-2.236-21.109-2.236-4.948 0-10.069.434-15.224 1.287-10.473 1.744-19.421 8.062-28.893 14.758-13.265 9.379-28.272 19.987-50.707 19.987',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#fff',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s2__height/2} ${l__s2__height/2}' },
                    '100%': { v: '1 1 ${l__s2__width/2} ${l__s2__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s2__width/2} ${l__s2__height/2}' },
                    '100%': { v: '-0.01 ${l__s2__width/2} ${l__s2__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s2__width/2} ${l__s2__height/2}' },
                    '50%': { v: '1 1 ${l__s2__width/2} ${l__s2__height/2}' },
                    '100%': { v: '0 0 ${l__s2__width/2} ${l__s2__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s2__width/2} ${l__s2__height/2}' }
                }
            }
        }
    }, {
        id: 's3',
        type: 'path',
        attrs: {
            d: 'M408.336 124.235c14.455 0 64.231 3.883 87.688 56.472 7.724 17.317 5.744 48.686 4.156 73.885-.248 3.999-.494 7.875-.694 11.576l-.084 1.591 1.062 1.185c.429.476 4.444 4.672 13.374 5.017l.144.008.15-.003c5.904-.225 12.554-2.059 19.776-5.442 1.064-.498 2.48-.741 3.978-.741 1.707 0 3.521.321 5.017.951l.226.09c3.787 1.327 6.464 3.829 6.505 6.093.022 1.28-.935 5.891-14.359 11.194-1.312.518-3.039 1.069-5.041 1.7-8.736 2.774-21.934 6.96-26.376 17.427-2.501 5.896-1.816 12.854 2.034 20.678 1.584 3.697 26.52 59.865 82.631 69.111a2.487 2.487 0 0 1-.229.9c-.951 2.24-6.996 9.979-44.612 15.783-5.886.902-7.328 7.5-9 15.17-.604 2.746-1.218 5.518-2.062 8.381-.258.865-.306.914-1.233.914h-.442c-1.668 0-4.2-.346-7.135-.922-5.345-1.041-12.647-2.318-21.982-2.318-5.21 0-10.577.453-15.962 1.352-11.511 1.914-20.872 8.535-30.786 15.543-13.314 9.408-27.075 19.143-48.071 19.143-.917 0-1.812-.031-2.709-.076l-.236-.01-.237.018c-.515.045-1.034.068-1.564.068-20.993 0-34.76-9.732-48.068-19.143-9.916-7.008-19.282-13.629-30.791-15.543-5.38-.896-10.752-1.352-15.959-1.352-9.333 0-16.644 1.428-21.978 2.471-2.935.574-5.476 1.066-7.139 1.066-1.362 0-1.388-.08-1.676-1.064-.844-2.865-1.461-5.703-2.062-8.445-1.676-7.678-3.119-14.312-9.002-15.215-37.613-5.809-43.659-13.561-44.613-15.795a2.739 2.739 0 0 1-.231-.918c56.11-9.238 81.041-65.408 82.63-69.119 3.857-7.818 4.541-14.775 2.032-20.678-4.442-10.461-17.638-14.653-26.368-17.422-2.007-.635-3.735-1.187-5.048-1.705-11.336-4.479-14.823-8.991-14.305-11.725.601-3.153 6.067-6.359 10.837-6.359 1.072 0 2.012.173 2.707.498 7.747 3.631 14.819 5.472 21.022 5.472 9.751 0 14.091-4.537 14.557-5.055l1.057-1.182-.085-1.583c-.197-3.699-.44-7.574-.696-11.565-1.583-25.205-3.563-56.553 4.158-73.871 23.37-52.396 72.903-56.435 87.525-56.435.36 0 6.717-.065 6.717-.065.26-.002.549-.006.852-.006m0-9.038h-.017c-.333 0-.646 0-.944.004l-6.633.066c-8.566 0-25.705 1.21-44.115 9.336-10.526 4.643-19.994 10.921-28.14 18.66-9.712 9.221-17.624 20.59-23.512 33.796-8.623 19.336-6.576 51.905-4.932 78.078l.006.041c.176 2.803.361 5.73.53 8.582-1.265.581-3.316 1.194-6.339 1.194-4.864 0-10.648-1.555-17.187-4.619-1.924-.896-4.12-1.349-6.543-1.349-3.893 0-7.997 1.146-11.557 3.239-4.479 2.63-7.373 6.347-8.159 10.468-.518 2.726-.493 8.114 5.492 13.578 3.292 3.008 8.128 5.782 14.37 8.249 1.638.645 3.582 1.261 5.641 1.914 7.145 2.271 17.959 5.702 20.779 12.339 1.429 3.365.814 7.793-1.823 13.145-.069.146-.138.289-.201.439-.659 1.539-6.807 15.465-19.418 30.152-7.166 8.352-15.059 15.332-23.447 20.752-10.238 6.617-21.316 10.943-32.923 12.855a9.038 9.038 0 0 0-7.559 9.424c.078 1.33.39 2.656.931 3.939l.013.023c1.843 4.311 6.116 7.973 13.063 11.203 8.489 3.943 21.185 7.26 37.732 9.855.836 1.59 1.704 5.586 2.305 8.322.629 2.908 1.285 5.898 2.22 9.074 1.009 3.441 3.626 7.553 10.349 7.553 2.548 0 5.478-.574 8.871-1.232 4.969-.975 11.764-2.305 20.245-2.305 4.702 0 9.575.414 14.48 1.229 9.455 1.574 17.606 7.332 27.037 14 13.804 9.758 29.429 20.803 53.302 20.803.651 0 1.304-.021 1.949-.066.789.037 1.767.066 2.799.066 23.88 0 39.501-11.049 53.29-20.799l.022-.02c9.433-6.66 17.575-12.41 27.027-13.984 4.903-.814 9.775-1.229 14.479-1.229 8.102 0 14.517 1.033 20.245 2.15 3.738.736 6.643 1.09 8.872 1.09l.218.004h.226c4.917 0 8.53-2.699 9.909-7.422.916-3.109 1.57-6.029 2.215-8.986.562-2.564 1.46-6.674 2.296-8.281 16.558-2.6 29.249-5.91 37.739-9.852 6.931-3.215 11.199-6.873 13.053-11.166.556-1.287.881-2.621.954-3.979a9.036 9.036 0 0 0-7.56-9.424c-51.585-8.502-74.824-61.506-75.785-63.758a6.454 6.454 0 0 0-.205-.438c-2.637-5.354-3.246-9.777-1.816-13.148 2.814-6.631 13.621-10.062 20.771-12.332 2.07-.652 4.021-1.272 5.646-1.914 7.039-2.78 12.07-5.796 15.389-9.221 3.964-4.083 4.736-7.995 4.688-10.555-.121-6.194-4.856-11.698-12.388-14.393-2.544-1.052-5.445-1.607-8.399-1.607-2.011 0-4.989.276-7.808 1.592-6.035 2.824-11.441 4.368-16.082 4.588-2.468-.125-4.199-.66-5.32-1.171.141-2.416.297-4.898.458-7.486l.067-1.108c1.653-26.19 3.707-58.784-4.92-78.134-5.913-13.253-13.853-24.651-23.604-33.892-8.178-7.744-17.678-14.021-28.242-18.661-18.384-8.066-35.522-9.271-44.1-9.271',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#020202',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '-0.01 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s2__width/2} ${l__s2__height/2}' },
                    '50%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            }
        }
    }, {
        id: 's6',
        desc: 'logo-mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#000',
            alpha: 1,
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            scale: '1.08 1.08 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Handle',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ l__s4__x + 60}',
            y: '${ l__s4__y + 50}',
            maxLines: 1,
            maxWidth: '${l__s4__width-95-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__s4__y+20}h${l__self__maxWidth}v${l__s4__height - l__s4__y - 40}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${color2}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '60%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {
                        v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' }
                },
                y: {
                    '0%': {},
                    '40%': { v: '${oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${oh}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Follow message',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${ l__s5__x + 60}',
            y: '${l__s5__y + 25}',
            maxLines: 1,
            maxWidth: '${l__s5__width-45-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__self__y}h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${color1}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '60%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${- l__t2__height}' },
                    '60%': { v: '${- l__t2__height}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: '${-l__t2__height}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height}' }
                }
            }
        }
    }, {
        id: 'uo',
        desc: 'Upper outer-line',
        type: 'path',
        attrs: {
            d: 'M${l__s4__x},-20h${l__s4__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '98%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lo',
        desc: 'lower outline',
        type: 'path',
        attrs: {
            d: 'M${l__s5__x},${oh + 20}h${l__s5__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
};

defs.push(smp_1_snapchat);
defs.push((0, _deepmerge2.default)(smp_1_snapchat, { id: 'defId-SyBZK1sk' }));

defs.push({
    id: 'defId-SyBZK1sk-fb',
    desc: 'facebook',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        color1: '#3a5998',
        color2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 0.8,
        lineHeight2: 0.8,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's4',
        desc: 'T1 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-95,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: 0,
            width: '${ow - l__self__x}',
            height: '${oh*0.67 -10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 't2 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-45,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: '${l__s4__y + l__s4__height + 10}',
            width: '${l__s4__width * 0.67}',
            height: '${oh*0.33}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo background',
        type: 'path',
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#3b5998',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Facebook icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Facebook_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: '${l__s1__width}',
            height: '${l__s1__height}',
            alpha: '${alpha}',
            scale: '1 1 ${l__self__width/2} ${l__self__height/2}',
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '-0.01 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '50%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            }
        }
    }, {
        id: 's6',
        desc: 'logo-mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#000',
            alpha: 1,
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            scale: '1.08 1.08 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Handle',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ l__s4__x + 60}',
            y: '${ l__s4__y + 50}',
            maxLines: 1,
            maxWidth: '${l__s4__width-95-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__s4__y+20}h${l__self__maxWidth}v${l__s4__height - l__s4__y - 40}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '60%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {
                        v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' }
                },
                y: {
                    '0%': {},
                    '40%': { v: '${oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${oh}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Follow message',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${ l__s5__x + 60}',
            y: '${l__s5__y + 25}',
            maxLines: 1,
            maxWidth: '${l__s5__width-45-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__self__y}h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '60%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${- l__t2__height}' },
                    '60%': { v: '${- l__t2__height}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: '${-l__t2__height}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height}' }
                }
            }
        }
    }, {
        id: 'uo',
        desc: 'Upper outer-line',
        type: 'path',
        attrs: {
            d: 'M${l__s4__x},-20h${l__s4__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '98%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lo',
        desc: 'lower outline',
        type: 'path',
        attrs: {
            d: 'M${l__s5__x},${oh + 20}h${l__s5__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

var smp_1_instagram = {
    id: 'defId-SyBZK1sk-ig',
    desc: 'instagram',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        color1: '#9E45EC',
        color2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 0.8,
        lineHeight2: 0.8,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's4',
        desc: 'T1 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-95,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: 0,
            width: '${ow - l__self__x}',
            height: '${oh*0.67 -10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 't2 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-45,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: '${l__s4__y + l__s4__height + 10}',
            width: '${l__s4__width * 0.67}',
            height: '${oh*0.33}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo background',
        type: 'path',
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '145 39.286 516 514.631',
            fill: '#9E45EC',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Instagram icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Instagram_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: '${l__s1__width}',
            height: '${l__s1__height}',
            alpha: '${alpha}',
            scale: '1 1 ${l__self__width/2} ${l__self__height/2}',
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '-0.01 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '50%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            }
        }
    }, {
        id: 's6',
        desc: 'logo-mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#000',
            alpha: 1,
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            scale: '1.08 1.08 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Handle',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ l__s4__x + 60}',
            y: '${ l__s4__y + 50}',
            maxLines: 1,
            maxWidth: '${l__s4__width-95-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__s4__y+20}h${l__self__maxWidth}v${l__s4__height - l__s4__y - 40}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '60%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {
                        v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' }
                },
                y: {
                    '0%': {},
                    '40%': { v: '${oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${oh}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Follow message',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${ l__s5__x + 60}',
            y: '${l__s5__y + 25}',
            maxLines: 1,
            maxWidth: '${l__s5__width-45-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__self__y}h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '60%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${- l__t2__height}' },
                    '60%': { v: '${- l__t2__height}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: '${-l__t2__height}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height}' }
                }
            }
        }
    }, {
        id: 'uo',
        desc: 'Upper outer-line',
        type: 'path',
        attrs: {
            d: 'M${l__s4__x},-20h${l__s4__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '98%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lo',
        desc: 'lower outline',
        type: 'path',
        attrs: {
            d: 'M${l__s5__x},${oh + 20}h${l__s5__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
};

defs.push(smp_1_instagram);
defs.push((0, _deepmerge2.default)(smp_1_instagram, { id: 'defId-SyBZK1sk-insta' }));

var smp_1_twitter = {
    id: 'defId-SyBZK1sk-tw',
    desc: 'twitter',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        color1: '#00abf1',
        color2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 0.8,
        lineHeight2: 0.8,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's4',
        desc: 'T1 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-95,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: 0,
            width: '${ow - l__self__x}',
            height: '${oh*0.67 -10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 't2 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-45,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: '${l__s4__y + l__s4__height + 10}',
            width: '${l__s4__width * 0.67}',
            height: '${oh*0.33}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo background',
        type: 'path',
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#00abf1',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Twitter icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Twitter_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: '${l__s1__width}',
            height: '${l__s1__height}',
            alpha: '${alpha}',
            scale: '1 1 ${l__self__width/2} ${l__self__height/2}',
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '-0.01 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '50%': { v: '1 1 ${l__s3__width/2} ${l__s3__height/2}' },
                    '100%': { v: '0 0 ${l__s3__width/2} ${l__s3__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s3__width/2} ${l__s3__height/2}' }
                }
            }
        }
    }, {
        id: 's6',
        desc: 'logo-mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#000',
            alpha: 1,
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            scale: '1.08 1.08 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Handle',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ l__s4__x + 60}',
            y: '${ l__s4__y + 50}',
            maxLines: 1,
            maxWidth: '${l__s4__width-95-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__s4__y+20}h${l__self__maxWidth}v${l__s4__height - l__s4__y - 40}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '60%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {
                        v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' }
                },
                y: {
                    '0%': {},
                    '40%': { v: '${oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${oh}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Follow message',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${ l__s5__x + 60}',
            y: '${l__s5__y + 25}',
            maxLines: 1,
            maxWidth: '${l__s5__width-45-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__self__y}h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '60%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${- l__t2__height}' },
                    '60%': { v: '${- l__t2__height}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: '${-l__t2__height}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height}' }
                }
            }
        }
    }, {
        id: 'uo',
        desc: 'Upper outer-line',
        type: 'path',
        attrs: {
            d: 'M${l__s4__x},-20h${l__s4__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '98%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lo',
        desc: 'lower outline',
        type: 'path',
        attrs: {
            d: 'M${l__s5__x},${oh + 20}h${l__s5__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
};

defs.push(smp_1_twitter);
defs.push((0, _deepmerge2.default)(smp_1_twitter, { id: 'defId-SyBZK1sk-twitter' }));

var smp_1_youtube = {
    id: 'defId-SyBZK1sk-yt',
    desc: 'youtube',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        color1: '#bb0000',
        color2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 0.8,
        lineHeight2: 0.8,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's4',
        desc: 'T1 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-95,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: 0,
            width: '${ow - l__self__x}',
            height: '${oh*0.67 -10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s4__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s4__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 't2 background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's6',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M0,0h${l__self__width}l-45,${l__self__height}H0z',
            viewBox: '0 0 ${l__self__width} ${l__self__height}',
            x: '${l__s1__x + l__s1__width - 30}',
            y: '${l__s4__y + l__s4__height + 10}',
            width: '${l__s4__width * 0.67}',
            height: '${oh*0.33}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${l__self__x} 0'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '50%': { v: 'scale(0, 1, ${l__s5__x}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '60%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'scale(0, 1, ${l__s5__x}, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo background',
        type: 'path',
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#bb0000',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 's2',
        type: 'path',
        attrs: {
            d: 'M3110 2497l-933 504 0 -776 0 -236 421 229 512 279zm1116 -684c0,0 -33,-248 -137,-357 -131,-144 -278,-145 -346,-153 -483,-36 -1208,-36 -1208,-36l-2 0c0,0 -725,0 -1209,36 -67,8 -214,9 -346,153 -103,109 -137,357 -137,357 0,0 -35,292 -35,583l0 36 0 238c0,291 35,583 35,583 0,0 34,248 137,357 132,144 304,139 381,154 277,28 1175,36 1175,36 0,0 726,-1 1209,-37 68,-9 215,-9 346,-153 104,-109 137,-357 137,-357 0,0 35,-292 35,-583l0 -223 0 -51c0,-291 -35,-583 -35,-583z',
            viewBox: '0 0 5067 5067',
            fill: '#fff',
            alpha: '${alpha}',
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1 1 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 's6',
        desc: 'logo-mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-255.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008',
            viewBox: '147.553 39.286 514.231 514.631',
            fill: '#000',
            alpha: 1,
            width: 257,
            height: 257,
            rotate: '-0.01 ${l__self__width/2} ${l__self__height/2}',
            scale: '1.08 1.08 ${l__self__width/2} ${l__self__height/2}'
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '-0.01 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '50%': { v: '1.08 1.08 ${l__s1__width/2} ${l__s1__height/2}' },
                    '100%': { v: '0 0 ${l__s1__width/2} ${l__s1__height/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '50%': {},
                    '100%': { v: '-90 ${l__s1__width/2} ${l__s1__height/2}' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Handle',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ l__s4__x + 60}',
            y: '${ l__s4__y + 50}',
            maxLines: 1,
            maxWidth: '${l__s4__width-95-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__s4__y+20}h${l__self__maxWidth}v${l__s4__height - l__s4__y - 40}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '60%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {
                        v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z',
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': { v: 'M0,${l__t1__y}h0v${l__s4__height - l__s4__y - 40}h0z' }
                },
                y: {
                    '0%': {},
                    '40%': { v: '${oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${oh}' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Follow message',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            // lineHeightFactor : 0.8,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${ l__s5__x + 60}',
            y: '${l__s5__y + 25}',
            maxLines: 1,
            maxWidth: '${l__s5__width-45-60}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${l__self__x},${l__self__y}h${l__self__maxWidth}v${l__self__height}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '60%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${- l__t2__height}' },
                    '60%': { v: '${- l__t2__height}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y}h0v${l__t2__height}h0z' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: '${-l__t2__height}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height}' }
                }
            }
        }
    }, {
        id: 'uo',
        desc: 'Upper outer-line',
        type: 'path',
        attrs: {
            d: 'M${l__s4__x},-20h${l__s4__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '98%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lo',
        desc: 'lower outline',
        type: 'path',
        attrs: {
            d: 'M${l__s5__x},${oh + 20}h${l__s5__width}',
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            },
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '47%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '58%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '63%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '22%': {},
                    '52%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '43%'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '63%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
};

defs.push(smp_1_youtube);
defs.push((0, _deepmerge2.default)(smp_1_youtube, { id: 'defId-SyBZK1sk-youtube' }));

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77,"./data-svgs":59,"deepmerge":549}],33:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var _dataBodymovinJsons = require('./data-bodymovin-jsons');

var _dataBodymovinJsons2 = _interopRequireDefault(_dataBodymovinJsons);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var defs = [];

// Social media pack 1 - Instagram
defs.push({
    id: 'defId-r1ikFdy1b',
    desc: 'SMP 1 - Instagram icon',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        textColor1: '#50ffd1',
        text1: '@HELLO',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__i1__height + l__t1__height}'
    },
    layers: [{
        id: 'i1',
        desc: 'Instagram Icon + anim',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['SMP_1_Instagram'],
            viewBox: '884 426 150 150' // 884,426 1034,576
        },
        attrs: {
            width: 400,
            height: 400,
            x: '${ow/2 - 200}',
            y: 0,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text below',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__i1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 100}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': {
                        v: '${l__t1__y + l__t1__height + 100}',
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

// Social media pack 1 - Twitter
defs.push({
    id: 'defId-Hk9HfRvkZ',
    desc: 'SMP 1 - Twitter icon',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        textColor1: '#50ffd1',
        text1: '@HELLO',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__i1__height + l__t1__height}'
    },
    layers: [{
        id: 'i1',
        desc: 'Twitter Icon + anim',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['SMP_1_Twitter'],
            viewBox: '860 400 200 200' // 860,420 1060,580
        },
        attrs: {
            width: 400,
            height: 400,
            x: '${ow/2 - 200}',
            y: 0,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text below',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__i1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 100}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': {
                        v: '${l__t1__y + l__t1__height + 100}',
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

// Social media pack 1 - Snapchat
defs.push({
    id: 'defId-HkSjE0wyW',
    desc: 'SMP 1 - Snapchat icon',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        textColor1: '#50ffd1',
        text1: '@HELLO',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__i1__height + l__t1__height}'
    },
    layers: [{
        id: 'i1',
        desc: 'Snapchat Icon + anim',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['SMP_1_Snapchat'],
            viewBox: '880 420 160 160' // 880,420 1040,580
        },
        attrs: {
            width: 400,
            height: 400,
            x: '${ow/2 - 200}',
            y: 0,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text below',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__i1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 100}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': {
                        v: '${l__t1__y + l__t1__height + 100}',
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

// Social media pack 1 - Facebook
defs.push({
    id: 'defId-Sy1P8AvJW',
    desc: 'SMP 1 - Facebook icon',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        textColor1: '#50ffd1',
        text1: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__i1__height + l__t1__height}'
    },
    layers: [{
        id: 'i1',
        desc: 'Facebook Icon + anim',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['SMP_1_Facebook'],
            viewBox: '880 420 160 160' // 880,420 1040,580
        },
        attrs: {
            width: 400,
            height: 400,
            x: '${ow/2 - 200}',
            y: 0,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text below',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__i1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 100}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': {
                        v: '${l__t1__y + l__t1__height + 100}',
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

// Social media pack 1 - Youtube
defs.push({
    id: 'defId-HJss3Aw1W',
    desc: 'SMP 1 - Youtube icon',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        textColor1: '#E62D27',
        text1: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__i1__height + l__t1__height}'
    },
    layers: [{
        id: 'i1',
        desc: 'Youtube Icon + anim',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['SMP_1_Youtube'],
            viewBox: '850 420 220 160' // 850,420 1070,580
        },
        attrs: {
            width: 400 * (220 / 160),
            height: 400,
            x: '${ow/2 - l__self__width/2}',
            y: 0,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text below',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__i1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 100}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': {
                        v: '${l__t1__y + l__t1__height + 100}',
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

// Modern Openers - Lower Third 1 - (Deprectaed impl - kept for reference)
// defs.push({
//     id : 'defId-B1yUXWYJZ',
//     desc : 'Modern Openers - Lower Third 1',
//     meta : {
//         autoHeight : true,
//         textEditors : {
//             'text1' : 't1'
//         },
//         mappings : {
//             primaryColor : 'color1'
//         }
//     },
//     props : {
//         color1 : 'color',
//         color2 : 'color',
//         text1 : 'text',
//         alpha : 'alpha',
//         fontFamily1 : 'fontfamily'
//     },
//     defaults : {
//         color1 : '#000',
//         color2 : '#fff',
//         text1 : '',
//         alpha : 1,
//         fontFamily1 : 'RALEWAY:NORMAL:NORMAL'
//     },
//     precalc : {
//         'oh' : '${l__bg1__height}'
//     },
//     layers : [
//         {
//             id : 'bg1',
//             desc : 'Background',
//             type : 'bmae',
//             meta : {
//                 animationData : dataBodymovinJsons['Modern_Openers_Lt1'],
//                 viewBox : "250 870 860 100", // 250,870	1110,970
//                 timeSlice : "0 1000",
//                 outTimeSlice : "4000 5000",
//                 mappings : {
//                     colorLine : { exp : [ 'layers', 0, 'ef', 1, 'ef', 0, 'v', 'k', 0, 's' ], type : 'color' },
//                     colorBg : { exp : [ 'layers', 0, 'ef', 0, 'ef', 0, 'v', 'k', 0, 's' ], type : 'color' },
//                 },
//                 reverseMappings : {
//                     textX1 : {
//                         exp : [ 'elements', 4, 'dynamicProperties', 1, 'position', 0 ],
//                         type : 'distance_x',
//                         offset : 250
//                     },
//                     textY1 : {
//                         exp : [ 'elements', 1, 'dynamicProperties', 0, 'position', 1 ],
//                         type : 'distance_y',
//                         offset : 885
//                     }
//                 }
//             },
//             attrs : {
//                 colorLine : '${color1}',
//                 colorBg : '${color2}',
//                 height : '${l__t1__height}',
//                 alpha : '${alpha}'
//             },
//             animation : {
//                 enterkeyframes : {
//                 },
//                 exitkeyframes : {
//                 }
//             }
//         },
//         {
//             id : 't1',
//             desc : 'Only Text',
//             type : 'text',
//             meta : {
//                 masks : [
//                     { mLayerId : 'mt1' }
//                 ]
//             },
//             attrs : {
//                 fontFamily : '${fontFamily1}',
//                 fontSize : 100,
//                 lineHeightFactor : 1.2,
//                 layoutAlgo : 'fixed',
//                 x : 20,
//                 y : '${l__bg1__textY1}',
//                 maxWidth : '${ow - 20}',
//                 height : '${calcSelfHeight()}',
//                 align : 'left',
//                 text : '${text1}',
//                 fill : '${color1}',
//                 alpha : '${alpha}'
//             },
//             animation : {
//                 enterkeyframes : {
//                 },
//                 exitkeyframes : {
//                 }
//             }
//         },
//         {
//             id : 'mt1',
//             type : 'rect',
//             meta : { shy : true },
//             attrs : {
//                 x : '${l__bg1__textX1}',
//                 y : '${l__bg1__textY1}',
//                 width : '${ow}',
//                 height : '${oh}',
//                 fill : '#00f'
//             }
//         }
//     ]
// })

// Modern Openers - Lower Third 1
defs.push({
    id: 'defId-B1yUXWYJZ',
    desc: 'Modern Openers - Lower Third 1',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        color1: '#f0f',
        color2: '#fff',
        textColor1: '#f0f',
        text1: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        'oh': '${l__t1__height + 20}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Background',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            width: '${ow}',
            height: '${l__t1__height}',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '0%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Only Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 0,
            maxWidth: '${ow - 20}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg1__height}' },
                    '50%': { v: '${l__bg1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${oh}h0z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '100%': { v: 'M0,0h0v${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'r1',
        desc: 'Bottom bar',
        type: 'path',
        attrs: {
            d: 'M0,0h100v100h-100z',
            viewBox: '0 0 100 100',
            x: 0,
            y: '${l__t1__height}',
            width: '${0.25*ow}',
            height: 20,
            strokeWidth: 0.1,
            strokeAlpha: 0.01,
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: 1920 },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 10000 },
                    '30%': { v: 10000 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: 1920, ease: 'easyEaseInOutReverse' }
                },
                width: {
                    '0%': {},
                    '70%': { v: 10000, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 10000 }
                }
            }
        }
    }]
});

// Modern Openers - Lower Third 4
defs.push({
    id: 'defId-ryhIdDc1W',
    desc: 'Modern Openers - Lower Third 4',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color2'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#000',
        color2: '#fff',
        textColor1: '#fff',
        textColor2: '#fff',
        text1: '',
        text2: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0,
        shadow: 'false'
    },
    precalc: {
        'oh': '${l__t2__y + l__t2__height + 30}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Background',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            width: '40',
            height: '${oh}',
            fill: '${color1}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '50%': { v: '${ow}', ease: 'easyEaseInOut' },
                    '90%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '70%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                },
                x: {
                    '20%': {},
                    '100%': { v: '${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'bg2',
        desc: 'Background 2',
        type: 'rect',
        attrs: {
            x: 40,
            y: 0,
            width: '${ow - 40}',
            height: '${oh}',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '90%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow}' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '20%': {},
                    '90%': { v: 0, ease: 'easyEaseInOut' }
                },
                x: {
                    '20%': {},
                    '90%': { v: '${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 60,
            y: 30,
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#424242'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 20}' },
                    '90%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${oh}h0z' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '20%': {},
                    '30%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__x}',
            y: '${l__t1__y + l__t1__height + 20}',
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#424242'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t2__y + l__t2__height + 20}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${oh-8}h0z' },
                    '80%': { v: 'M0,0h${ow}v${oh-8}h${-ow}z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '20%': {},
                    '30%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

// Modern Openers - Lower Third 10
defs.push({
    id: 'defId-S16ZUu5Jb',
    desc: 'Modern Openers - Lower Third 10',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor2'
        }
    },
    props: {
        textColor1: 'textColor',
        textColor2: 'textColor',
        color1: 'color',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        textColor1: '#000',
        textColor2: '#000',
        color1: '#000',
        text1: '',
        text2: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t2__y + l__t2__height + 30}'
    },
    layers: [{
        id: 'l1',
        desc: 'Top line',
        type: 'rect',
        attrs: {
            width: 150,
            height: 20,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            y: '${l__t1__y + l__t1__height + 5}',
            width: 300,
            height: 10,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 25,
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height}h${ow}v${oh - l__l1__height}h${-ow}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t1__height }' },
                    '50%': { v: '${ - l__t1__height }' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,${l__l1__height}h${ow}v${l__t1__y + l__t1__height - l__l1__height}h${-ow}z' },
                    '100%': { v: 'M0,${l__l1__height}h${ow}v0h${-ow}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 120,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__x}',
            y: '${l__l2__y + l__l2__height + 10}',
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l2__y + l__l2__height}h${ow}V${oh}h${-ow}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__l2__y - l__t2__height}' },
                    '50%': { v: '${l__l2__y - l__t2__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '100%': { v: 'M0,${l__l2__y + l__l2__height}h${ow}v0h${-ow}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

// Modern Openers - Lower Third 21
defs.push({
    id: 'defId-S1LmnmTyW',
    desc: 'Modern Openers - Lower Third 21',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        color1: '#000',
        textColor1: '#000',
        text1: '',
        alpha: 1,
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        'oh': '${30 + l__t1__height + 30}'
    },
    layers: [{
        id: 'lt',
        desc: 'Box Top line',
        type: 'path',
        attrs: {
            d: 'M${ow},${oh/2}v${-oh/2}H${0.25*ow}v25',
            stroke: '${color1}',
            fillAlpha: 0,
            strokeWidth: 15,
            strokeAlpha: '${alpha}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: 100 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'lb',
        desc: 'Box Bottom line',
        type: 'path',
        attrs: {
            d: 'M${ow},${oh/2}v${oh/2}H${0.25*ow}v-25',
            stroke: '${color1}',
            fillAlpha: 0,
            strokeWidth: 15,
            strokeAlpha: '${alpha}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: 100 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 30,
            y: 25,
            maxWidth: '${ow - 30}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${oh}h0z' },
                    '99.9%': { v: 'M0,0h${ow}v${oh}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': {}
                },
                x: {
                    '0%': { v: -100 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,0h${ow}v${oh}h${-ow}z' },
                    '100%': { v: 'M0,0h0v${oh}h0z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

// Modern Openers - Lower Third 31
defs.push({
    id: 'defId-Hy671s1lW',
    desc: 'Modern Openers - Lower Third 31',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#000',
        textColor1: '#000',
        textColor2: '#000',
        text1: '',
        text2: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        shadow: false,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t2__y + l__t2__height + 30}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 150,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 0,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: 100 },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M0,${oh}h${ow}v0h${-ow}z' },
                    '100%': { v: 'M0,${oh}h${ow}v${-oh}h${-ow}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,0h${ow}v${oh}h${-ow}z' },
                    '100%': { v: 'M0,0h${ow}v0h${-ow}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            x: '${0.2*ow}',
            y: '${l__t1__y + l__t1__height}',
            width: '${0.6*ow}',
            height: 15,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${0.5*ow}' },
                    '40%': { v: '${0.5*ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '40%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,0h${ow}v${oh}h${-ow}z' },
                    '100%': { v: 'M0,0h${ow}v0h${-ow}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__l1__y + l__l1__height + 10}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__l1__y + l__l1__height + 10 + l__t2__height + 20}' },
                    '20%': { v: '${l__l1__y + l__l1__height + 10 + l__t2__height + 20}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M0,${oh}h${ow}v0h${-ow}z' },
                    '100%': { v: 'M0,${oh}h${ow}v${-oh}h${-ow}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,0h${ow}v${oh}h${-ow}z' },
                    '100%': { v: 'M0,0h${ow}v0h${-ow}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

// Clean Lower Thirds - Lower Third 1
defs.push({
    id: 'defId-ByT6rpkxZ',
    desc: 'Clean Lower Thirds - Lower Third 1',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        color3: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#545454',
        color2: '#f0f',
        color3: '#000',
        textColor1: '#f0f',
        textColor2: '#0ff',
        text1: 'ALAN RICKMAN',
        text2: 'Professor Snape',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        lineHeight1: 1.4,
        lineHeight2: 1.4,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__bg1__height + l__bg2__height}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Main text Background',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['Clean_Lower_Thirds_Lt1'],
            viewBox: "380 1358 2000 323", // 380,1358 2380,1720 380 1358 2000 362
            timeSlice: "0 1283",
            mappings: {
                colorBg: { exp: ['layers', 0, 'ef', 0, 'ef', 0, 'v', 'k', 0, 's'], type: 'color' },
                colorLine: { exp: ['layers', 0, 'ef', 1, 'ef', 0, 'v', 'k', 0, 's'], type: 'color' }
            }
        },
        attrs: {
            colorBg: '${color1}',
            colorLine: '${color2}',
            height: '${l__t1__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'bg2',
        desc: 'Lower text background',
        type: 'rect',
        attrs: {
            fill: '${color3}',
            x: '${ow - l__self__width}',
            y: '${l__bg1__y + l__bg1__height}',
            width: '${l__t2__width + 70}',
            height: '${l__t2__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '18.9%': { v: '${ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '18.9%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '81.1%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}' }
                },
                width: {
                    '81.1%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 5,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'right',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '2%': { v: 'M${ow},0h0v${l__t1__height}h0z' },
                    '96%': { v: 'M${ow},0h${-ow}v${l__t1__height}h${ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow},0h${-ow}v${l__t1__height}h${ow}z' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '4%': { v: 'M${ow},0h${-ow}v${l__t1__height}h${ow}z' },
                    '98%': { v: 'M${ow},0h0v${l__t1__height}h0z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__bg2__y}',
            maxWidth: '${ow - 20 - 20}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'right',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},${l__t2__y}h0v${l__t2__height}h0z' },
                    '18.9%': { v: 'M${ow},${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { v: 'M${ow},${l__t2__y}h${-l__bg2__width}v${l__t2__height}h${l__bg2__width}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},${l__t2__y}h${-l__bg2__width}v${l__t2__height}h${l__bg2__width}z' },
                    '81.1%': { v: 'M${ow},${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${ow},${l__t2__y}h0v${l__t2__height}h0z' }
                }
            }
        }
    }, {
        id: 'box1',
        desc: 'Box before sub text',
        type: 'rect',
        attrs: {
            fill: '${color2}',
            x: '${l__bg2__x}',
            y: '${l__bg2__y}',
            width: 0,
            height: '${l__bg2__height}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '18.9%': { v: '${ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '18.9%': { v: 40 },
                    '45%': { v: 60 },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '81.1%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}' }
                },
                width: {
                    '55%': { v: 60, ease: 'easeinout' },
                    '81.1%': { v: 40 },
                    '100%': { v: 0 }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-SyBboyFxb',
    desc: 'Christine bradley',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'MAKE THE WORLD',
        text2: 'A BETTER PLACE',
        color1: '#F1626E',
        textColor1: '#FFF',
        textColor2: '#FFF',
        fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
        fontFamily2: 'GLACIAL_INDIFFERENCE:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.4,
        lineHeight2: 1.4,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t2__y + l__t2__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 10,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            clipPath: 'M0,0h${ow}v${l__l1__y}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: -30 },
                    '40%': { v: -30 },
                    '70%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M0,0h${ow}v0h${-ow}z' },
                    '70%': { v: 'M0,0h${ow}v0h${-ow}z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '40%': { v: 'M0,0h${ow}v0h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M0,${oh}h${ow}v0h${-ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1d',
        desc: 'Main Text Duplicate',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 10,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${color1}',
            clipPath: 'M0,${l__l1__y}h${ow}v${oh - l__l1__y}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: -30 },
                    '40%': { v: -30 },
                    '70%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '70%': { v: 'M0,0h${ow}v${oh}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '40%': { v: 'M0,${l__l1__y}h${ow}v${oh - l__l1__y}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M0,${oh}h${ow}v0h${-ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            x: 0,
            y: '${l__t2__y + 10}',
            clipPath: 'M0,0h${ow}v${l__t2__y}h${-ow}z',
            width: '${ow}',
            height: 8,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2}' },
                    '20%': { v: '${ow/2}' },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t2__y - 25}' },
                    '40%': { v: '${l__t2__y - 25}' },
                    '70%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '40%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: '${oh}', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'bg2',
        desc: 'background bottom text',
        type: 'rect',
        attrs: {
            x: 0,
            y: '${l__t2__y}',
            width: '${ow}',
            height: '${l__t2__height}',
            cornerRadius: 40,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2}' },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '40%': {
                        v: 'M0,0h${ow}v${oh}h${-ow}z'
                    },
                    '100%': {
                        v: 'M0,${oh}h${ow}v0h${-ow}z', ease: 'easyEaseInOut'
                    }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 70,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__t1__y + l__t1__height}',
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            clipPath: 'M${ow-40},${l__t2__y}A40,40 0 0,1 ${ow},${l__t2__y + 40}' + 'V${l__t2__y + l__t2__height - 40}' + 'A40,40 0 0,1 ${ow-40},${l__t2__y + l__t2__height}' + 'H40A40,40 0 0,1 0,${l__t2__y + l__t2__height - 40}' + 'V${l__t2__y + 40}' + 'A40,40 0 0,1 40,${l__t2__y}z',
            transform: 'translate(${ow/2}, ${l__t2__height/2}) scale(1, 1) translate(${-ow/2}, ${- l__t2__height/2})'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': {
                        v: 'translate(${ow/2}, ${l__t2__height/2}) scale(6, 6) translate(${-ow/2}, ${- l__t2__height/2})'
                    },
                    '30%': { ease: 'easeinout' }
                },
                clipPath: {
                    '0%': {
                        v: 'M${ow/2-40},${l__t2__y}A40,40 0 0,1 ${ow/2},${l__t2__y + 40}' + 'V${l__t2__y + l__t2__height - 40}' + 'A40,40 0 0,1 ${ow/2-40},${l__t2__y + l__t2__height}' + 'H${ow/2+40}A40,40 0 0,1 ${ow/2},${l__t2__y + l__t2__height - 40}' + 'V${l__t2__y + 40}' + 'A40,40 0 0,1 ${ow/2},${l__t2__y}z'
                    },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {
                        v: 'M0,0h${ow}v${oh}h${-ow}z'
                    },
                    '40%': {
                        v: 'M0,0h${ow}v${oh}h${-ow}z'
                    },
                    '100%': {
                        v: 'M0,${oh}h${ow}v0h${-ow}z',
                        ease: 'easyEaseInOut'
                    }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HyflD1ixW',
    desc: '4 lines + 2 text',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'HOOLI',
        text2: 'BETTER PLACE',
        color1: '#f00',
        color2: '#0f0',
        textColor1: '#ff0',
        textColor2: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t2__y + l__t2__height + 10}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Main text background',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            width: '${ow}',
            height: '${l__t1__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                height: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__bg1__height}', ease: 'easyEaseInOutReverse' }
                },
                height: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 0,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'right',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            clipPath: 'M0,0h${ow}v${l__t1__height}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__t1__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'bg2',
        desc: 'Bottom text background',
        type: 'rect',
        attrs: {
            x: '${ow - l__t2__width -30 - 30}',
            y: '${l__t2__y - 10}',
            width: '${ow - l__self__x}',
            height: '${l__t2__height + 20}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                height: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                },
                height: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 30,
            y: '${l__t1__y + l__t1__height + 30}',
            maxWidth: '${ow - l__self__x - 30}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'right',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1,
            clipPath: 'M${l__bg2__x},${l__bg2__y}h${l__bg2__width}v${l__bg2__height}h${-l__bg2__width}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg2__y + l__bg2__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__bg2__y + l__bg2__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'ltb',
        desc: 'Line along left side going from top to bottom',
        type: 'path',
        attrs: {
            d: 'M-20,-300V${oh + 300}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'llr',
        desc: 'Line along top side going from left to right',
        type: 'path',
        attrs: {
            d: 'M-300,-20H${ow + 300}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'lbt',
        desc: 'Line along right side going from bottom to top',
        type: 'path',
        attrs: {
            d: 'M${ow+20},${oh + 300}V-300',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'lrl',
        desc: 'Line along bottom of main text going from right to left',
        type: 'path',
        attrs: {
            d: 'M${ow + 300},${l__bg1__y + l__bg1__height + 20}H-300',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByjSOsWxZ',
    desc: 'Layered Hexagon Title',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        text2: '',
        color1: '#fff',
        textColor1: '#fff',
        textColor2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'HOMENAJE:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${7/8*ow}'
    },
    layers: [{
        id: 'ofl',
        desc: 'Outer flash line',
        type: 'path',
        attrs: {
            d: 'M${ow/4},0H${ow*0.75}L${ow},${oh/2}L${ow*0.75},${oh}H${ow/4}L0,${oh/2}L${ow/4},0',
            fillAlpha: 0,
            x: -50,
            y: -50,
            width: '${ow + 100}',
            height: '${oh + 100}',
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeWidth: 10,
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 999999'
            }
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '40%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    }, '42%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '10%'
                        }
                    },
                    '90%': {
                        v: {
                            strokeRangeStart: '100%',
                            strokeRangeEnd: '99%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '100%': {
                        ease: 'easyEaseInOut'
                    }
                }
            }
        }
    }, {

        id: 'ohl',
        desc: 'outer hex line',
        type: 'path',
        attrs: {
            d: 'M${ow/4},0H${ow*0.75}L${ow},${oh/2}L${ow*0.75},${oh}H${ow/4}L0,${oh/2}L${ow/4},0h5',
            x: -30,
            y: -30,
            width: '${ow + 60}',
            height: '${oh + 60}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeWidth: 12,
            scale: '1 1 ${ow/2} ${oh/2})',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${(ow)/2} ${(oh)/2}' },
                    '50%': { v: '1 1 ${ow/2} ${oh/2}', ease: 'easeinout' }
                },
                strokeWidth: {
                    '40%': { v: '30' },
                    '50%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M-50,-50h${ow+100}v${oh+100}h${-ow-100}z' },
                    '100%': { v: 'M-50,${oh+50}h${ow+100}v0h${-ow-100}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'ihl',
        desc: 'Inner hex line',
        type: 'path',
        attrs: {
            d: 'M${ow/4},0H${ow*0.75}L${ow},${oh/2}L${ow*0.75},${oh}H${ow/4}L0,${oh/2}L${ow/4},0h5',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeWidth: 12,
            scale: '1 1 ${ow/2} ${oh/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },

        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${ow/2} ${oh/2}' },
                    '10%': { v: '0 0 ${ow/2} ${oh/2}' },
                    '60%': { v: '1 1 ${ow/2} ${oh/2}', ease: 'easeinout' }
                },
                strokeWidth: {
                    '0%': { v: '30' },
                    '50%': { v: '30' },
                    '60%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M-50,-50h${ow+100}v${oh+100}h${-ow-100}z' },
                    '100%': { v: 'M-50,${oh+50}h${ow+100}v0h${-ow-100}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'uhl',
        desc: 'upper horizontal line',
        type: 'rect',
        attrs: {
            x: '${ow * 0.25}',
            width: '${ow * 0.50}',
            height: 0,
            y: '${oh/4}',
            clipPath: '${l__ihl__d}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeWidth: 7,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            transform: 'scale(1.2, 1.2, ${ow/2}, ${oh/2})'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { v: '${oh/4}', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M-50,-50h${ow+100}v${oh+100}h${-ow-100}z' },
                    '100%': { v: 'M-50,${oh+50}h${ow+100}v0h${-ow-100}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'lhl',
        desc: 'lower horizontal line',
        type: 'rect',
        attrs: {
            x: '${ow * 0.25}',
            width: '${ow * 0.5}',
            height: 0,
            y: '${oh * 0.75}',
            clipPath: '${l__ihl__d}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeWidth: 7,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            transform: 'scale(1.2, 1.2, ${ow/2}, ${oh/2})'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { v: '${oh * 0.75}', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M-50,-50h${ow+100}v${oh+100}h${-ow-100}z' },
                    '100%': { v: 'M-50,${oh+50}h${ow+100}v0h${-ow-100}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text top',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1s',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ow/4 - 40}',
            y: '${oh/2 - l__self__height}',
            maxWidth: '${ow/2+80}',
            maxHeight: '${oh/4}',
            height: '${calcSelfHeight()}',
            clipPath: '${l__ihl__d}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh+ l__t1__height}' },
                    '50%': { v: '${oh+ l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            }, exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M-50,-50h${ow+100}v${oh+100}h${-ow-100}z' },
                    '100%': { v: 'M-50,${oh+50}h${ow+100}v0h${-ow-100}z', ease: 'easyEaseInOutReverse' }
                }
            }

        }
    }, {
        id: 'mt1',
        desc: 'Mask t1',
        type: 'text',
        meta: {
            shy: true
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${ow/4 - 40}',
            y: '${oh/2 - l__self__height}',
            maxWidth: '${ow/2+80}',
            maxHeight: '${oh/4}',
            height: '${calcSelfHeight()}',
            clipPath: '${l__ihl__d}',
            align: 'center',
            text: '${text1}',
            fill: '#000',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh+ l__mt1__height}' },
                    '50%': { v: '${oh+ l__mt1__height}' },
                    '95%': { ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Text lower',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1s',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${oh/2}',
            maxWidth: '${ow - 80}',
            maxHeight: '${oh/4}',
            height: '${calcSelfHeight()}',
            clipPath: '${l__ihl__d}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M-50,-50h${ow+100}v${oh+100}h${-ow-100}z' },
                    '100%': { v: 'M-50,${oh+50}h${ow+100}v0h${-ow-100}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'mt2',
        desc: 'Text lower',
        type: 'text',
        meta: {
            shy: true
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${oh/2}',
            maxWidth: '${ow - 80}',
            maxHeight: '${oh/4}',
            height: '${calcSelfHeight()}',
            clipPath: '${l__ihl__d}',
            align: 'center',
            text: '${text2}',
            fill: '#000',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '60%': { v: '${oh}' },
                    '95%': { ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'solid polygon fil',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 'mt1',
                mAlphaInv: true
            }, { mLayerId: 'mt2',
                mAlphaInv: true
            }, { mLayerId: 'ihl',
                mAlphaInv: true
            }]
        },
        attrs: {
            clipPath: '${l__ihl__d}',
            fillAlpha: 1,
            fill: '${color1}',
            height: '${oh/4}',
            y: '${-l__s1__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '55%': {},
                    '100%': { v: '${oh/2}', ease: 'easeinout' }

                },
                y: {
                    '50%': { v: '${-l__s1__height}' },
                    '100%': { v: '${oh}', ease: 'easeinout' }
                }

            }
        }
    }, {
        id: 's1s',
        desc: 'solid polygon fil - shy',
        type: 'rect',
        meta: {
            shy: true
        },
        attrs: {
            clipPath: '${l__ihl__d}',
            fillAlpha: 1,
            height: '${oh/4}',
            y: '${-l__s1__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '55%': {},
                    '100%': { v: '${oh/2}', ease: 'easeinout' }

                },
                y: {
                    '50%': { v: '${-l__s1__height}' },
                    '100%': { v: '${oh}', ease: 'easeinout' }
                }

            }
        }
    }]
});

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77,"./data-bodymovin-jsons":51}],34:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var _dataBodymovinJsons = require('./data-bodymovin-jsons');

var _dataBodymovinJsons2 = _interopRequireDefault(_dataBodymovinJsons);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var defs = [];

defs.push({
    id: 'defId-rJIN9b7xZ',
    desc: 'Wedges inside Box Intro Title',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        text2: '',
        color1: '#fff',
        color2: '#fff',
        textColor1: '#58D3E1',
        textColor2: '#fff',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'HOMENAJE:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height + 40}'
    },
    layers: [{
        id: 'tm',
        desc: 'text mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M0,0l150,${oh+100}l${ow},${oh}V0z',
            x: -160,
            fill: '#f0f'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow+20}' },
                    '50%': { v: '${ow+20}' },
                    '91%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow+20}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'bg',
        desc: 'background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M0,0l150,${oh+100}l${ow},${oh}V0z',
            x: -150,
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '50%': { v: '${ow+20}' },
                    '91%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow+20}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text top',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '40',
            y: '${oh/2 - l__self__height}',
            maxWidth: '${ow-80}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-l__t1__maxWidth}' },
                    '25%': { v: '${-l__t1__maxWidth}' },
                    '95%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '55%': { v: '${-l__t1__maxWidth}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Text lower',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '40',
            y: '${oh/2}',
            maxWidth: '${ow-80}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-l__t2__maxWidth}' },
                    '30%': { v: '${-l__t2__maxWidth}' },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '80%': { v: '${-l__t1__maxWidth}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'sl1',
        desc: 'slant line 1',
        type: 'path',
        attrs: {
            d: 'M0,-50l150,${oh+100}',
            x: -160,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            fillAlpha: 0,
            clipPath: 'M0,0H${ow}V${oh}H0z',
            shadowEnabled: false,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow+20}' },
                    '40%': { v: '${ow+20}' },
                    '90%': { ease: 'easeinout' }
                },
                strokeWidth: {
                    '40%': {},
                    '60%': { v: '50', ease: 'easeinout' },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': { v: '${ow+20}', ease: 'easeinout' }
                },
                strokeWidth: {
                    '0%': {},
                    '20%': { v: '50', ease: 'easeinout' },
                    '50%': { ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'sl2',
        desc: 'slant line 2',
        type: 'path',
        attrs: {
            d: 'M0,-50l150,${oh+100}',
            x: -160,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            fillAlpha: 0,
            clipPath: 'M0,0H${ow}V${oh}H0z',
            shadowEnabled: false,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow+20}' },
                    '50%': { v: '${ow+20}' },
                    '90%': { ease: 'easeinout' }
                },
                strokeWidth: {
                    '50%': {},
                    '60%': { v: '50', ease: 'easeinout' },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow+20}', ease: 'easeinout' }
                },
                strokeWidth: {
                    '0%': {},
                    '20%': { v: '50', ease: 'easeinout' },
                    '50%': { ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'ob',
        desc: 'Outer box',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}v${oh}h${-ow}v${-oh}h${ow}v1',
            x: -20,
            y: -20,
            width: '${ow + 40}',
            height: '${oh + 40}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: 1,
            strokeRangeProps: {
                strokeRangeStart: '${(100*ow+1)/(3*ow+2*oh)}%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            fillAlpha: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '10%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '38%': {
                        v: {
                            strokeRangeStart: '26%',
                            strokeRangeEnd: '73%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '64%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '25%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }, ease: 'easyEaseInOut' }
                }
            }

        }
    }, {
        id: 'ib',
        desc: 'inner box',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}v${oh}h${-ow}v${-oh}h${ow}v1',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0,
            strokeRangeProps: {
                strokeRangeStart: '${(100*ow+1)/(3*ow+2*oh)}%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {

                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '7%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '31%': {
                        v: {
                            strokeRangeEnd: '73%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '64%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            }, exitkeyframes: {
                strokeRangeProps: {
                    '30%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }, ease: 'easyEaseInOut' }
                }
            }

        }
    }]
});

defs.push({
    id: 'defId-HkIRUSqWX',
    desc: 'Wedges inside Box Intro Title - single text',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        color1: '#fff',
        color2: '#fff',
        textColor1: '#58D3E1',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.2,
        letterSpacing1: 0
    },
    precalc: {
        'oh': '${l__t1__height + 40}'
    },
    layers: [{
        id: 'tm',
        desc: 'text mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M0,0l150,${oh+100}l${ow},${oh}V0z',
            x: -160,
            fill: '#f0f'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow+20}' },
                    '50%': { v: '${ow+20}' },
                    '91%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow+20}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'bg',
        desc: 'background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M0,0l150,${oh+100}l${ow},${oh}V0z',
            x: -150,
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '50%': { v: '${ow+20}' },
                    '91%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow+20}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text top',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '40',
            y: '20',
            maxWidth: '${ow-80}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-l__t1__maxWidth}' },
                    '25%': { v: '${-l__t1__maxWidth}' },
                    '95%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '55%': { v: '${-l__t1__maxWidth}', ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'sl1',
        desc: 'slant line 1',
        type: 'path',
        attrs: {
            d: 'M0,-50l150,${oh+100}',
            x: -160,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            fillAlpha: 0,
            clipPath: 'M0,0H${ow}V${oh}H0z',
            shadowEnabled: false,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow+20}' },
                    '40%': { v: '${ow+20}' },
                    '90%': { ease: 'easeinout' }
                },
                strokeWidth: {
                    '40%': {},
                    '60%': { v: '50', ease: 'easeinout' },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': { v: '${ow+20}', ease: 'easeinout' }
                },
                strokeWidth: {
                    '0%': {},
                    '20%': { v: '50', ease: 'easeinout' },
                    '50%': { ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'sl2',
        desc: 'slant line 2',
        type: 'path',
        attrs: {
            d: 'M0,-50l150,${oh+100}',
            x: -160,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            fillAlpha: 0,
            clipPath: 'M0,0H${ow}V${oh}H0z',
            shadowEnabled: false,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow+20}' },
                    '50%': { v: '${ow+20}' },
                    '90%': { ease: 'easeinout' }
                },
                strokeWidth: {
                    '50%': {},
                    '60%': { v: '50', ease: 'easeinout' },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow+20}', ease: 'easeinout' }
                },
                strokeWidth: {
                    '0%': {},
                    '20%': { v: '50', ease: 'easeinout' },
                    '50%': { ease: 'easeinout' }
                }
            }
        }
    }, {
        id: 'ob',
        desc: 'Outer box',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}v${oh}h${-ow}v${-oh}h${ow}v1',
            x: -20,
            y: -20,
            width: '${ow + 40}',
            height: '${oh + 40}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: 1,
            strokeRangeProps: {
                strokeRangeStart: '${(100*ow+1)/(3*ow+2*oh)}%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            fillAlpha: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '10%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '38%': {
                        v: {
                            strokeRangeStart: '26%',
                            strokeRangeEnd: '73%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '64%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '25%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }, ease: 'easyEaseInOut' }
                }
            }

        }
    }, {
        id: 'ib',
        desc: 'inner box',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}v${oh}h${-ow}v${-oh}h${ow}v1',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0,
            strokeRangeProps: {
                strokeRangeStart: '${(100*ow+1)/(3*ow+2*oh)}%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {

                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '7%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '31%': {
                        v: {
                            strokeRangeEnd: '73%'
                        },
                        ease: 'easyEaseInOut'
                    },
                    '64%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            }, exitkeyframes: {
                strokeRangeProps: {
                    '30%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }, ease: 'easyEaseInOut' }
                }
            }

        }
    }]
});

defs.push({
    id: 'defId-ByjurzPxW',
    desc: 'Line to Slant Lower Third',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'DURATION CONTROL',
        color1: '#ff0',
        textColor1: '#000',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        'oh': '${l__t1__height + 40}'
    },
    layers: [{
        id: 's2',
        desc: 'sliding bg 2',
        clipPath: 'M-20,0H${ow}l-20,${oh}h${-ow}z',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}l-20,${oh}h${-ow}z',
            fill: '${color1}',
            alpha: '${alpha}',
            stroke: '${color1}',
            fillAlpha: 1,
            strokeWidth: 1,
            strokeAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0h1' },
                    '67%': { v: 'M0,0h1' },
                    '68%': { v: 'M0,0h20l0,${oh}h-20z' },
                    '99%': { v: 'M0,0h${ow}l-20,${oh}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M0,0h${ow}l-20,${oh}h${-ow}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': { v: 'M0,0h${ow}l-20,${oh}h${-ow}z' },
                    '40%': { v: 'M0,0h20l0,${oh}h-20z', ease: 'easyEaseInOutReverse' },
                    '45%': { v: 'M0,0h1', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0h1', ease: 'easyEaseInOutReverse'
                        //'100%' :{v:'M0,0h${ow}l-20,${oh}h${-ow}z', ease:'easyEaseInOut'},
                    } }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg 1',
        type: 'path',
        attrs: {
            d: 'M${ow/2},0h20l20,${oh}h-20z',
            clipPath: 'M-20,-${oh/2}H${ow}l-20,${oh*2}h${-ow}z',
            stroke: '${color1}',
            strokeWidth: 1,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1,
            scale: '1 0 ${ow/2} ${oh/2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 'M-20,0H${ow}l-20,${oh}h${-ow}z' }
                },
                scale: {
                    '0%': { v: '0 0 ${ow/2} ${oh/2}' },
                    '25%': { v: '1 2 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' },
                    '40%': { v: '1 1 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '1 1 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' }
                },
                d: {
                    '0%': { v: 'M${ow/2},0h20l20,${oh}h-20z' },
                    '25%': { v: 'M${ow/2},0h20l20,${oh}h-20z' },
                    '65%': { v: 'M-20,0h20l20,${oh}h-20z', ease: 'easyEaseInOut' }, //move to left
                    '100%': { v: 'M${ow+20},0h${ow}l-20,${oh}h${-ow}z', ease: 'easyEaseInOut' //move to right
                    } },
                rotate: {
                    '0%': { v: '-180 ${ow/2} ${oh/2}' },
                    //'30%' : {v:'-180 ${ow/2} ${oh/2}'},
                    '35%': { v: '0 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '0 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': { v: '1 1 ${ow/2} ${oh/2}' },
                    '65%': { v: '1 1 ${ow/2} ${oh/2}' },
                    '80%': { v: '1 2 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '0 0 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' }
                },
                d: {
                    '0%': { v: 'M${ow+20},0h${ow}l-20,${oh}h${-ow}z' },
                    '45%': { v: 'M-20,0h20l20,${oh}h-20z', ease: 'easyEaseInOutReverse' },
                    '70%': { v: 'M${ow/2},0h20l20,${oh}h-20z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${ow/2},0h20l20,${oh}h-20z', ease: 'easyEaseInOutReverse' }
                },
                rotate: {
                    '0%': { v: '0 ${ow/2} ${oh/2}' },
                    '65%': { v: '0 ${ow/2} ${oh/2}' },
                    '100%': { v: '-180 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text',
        type: 'text',
        // meta:{
        // 	masks : [
        // 		 {
        //             mLayerId : 's2',
        //         	mAlphaInv : false
        // 		 }
        // 	]
        // },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '20',
            y: '20',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: false,
            alpha: 1,
            transform: 'skew(-10,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '65%': { v: '${ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByJPiQOxW',
    desc: 'Square to Lower Third',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: '',
        text2: 'EASY CONTROL',
        color1: '#f00',
        color2: '#fff',
        textColor1: '#f00',
        textColor2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height + 40 + 10}'
    },
    layers: [{
        id: 's2m',
        desc: 'sliding bg 2 mask',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            clipPath: 'M0,-20h${ow+50}V${oh+50}h${-ow-50}z',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: '#000',
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z' },
                    '36%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z' },
                    '65%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '70%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's2',
        desc: 'sliding bg 2',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            clipPath: 'M0,-20h${ow+50}V${oh+50}h${-ow-50}z',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: '#000',
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z' },
                    '36%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z' },
                    '65%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '70%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow/2-oh/2},0h0V${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's2m',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 50 + 40,
            y: 20,
            maxWidth: '${ow - 50 - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            // alpha : '${alpha}',
            transform: 'skew(-5,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '37%': { v: '${-ow}' },
                    '78%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '77%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Lower text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's2m',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 50 + 40,
            y: '${l__t1__y + l__t1__height + 10}',
            maxWidth: '${ow - 50 - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            // alpha : '${alpha}',
            transform: 'skew(-5,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '40%': { v: '${-ow}' },
                    '78%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '70%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg 1',
        type: 'path',
        attrs: {
            d: 'M0,0h50V${oh}h-50z',
            fill: '${color1}',
            fillAlpha: 1,
            rotate: '0 ${ow/2} ${oh/2}',
            scale: '1 1 ${ow/2} ${oh/2}'
            // alpha : '${alpha}',
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${ow/2} ${oh/2}' },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                d: {
                    '0%': { v: 'M${ow/2-oh/2},0h${oh}v${oh}h${-oh}z' },
                    '35%': { v: 'M${ow/2-oh/2},0h${oh}v${oh}h${-oh}z' },
                    '65%': { ease: 'easyEaseInOut' }, //move to left
                    '100%': { ease: 'easyEaseInOut' //move to left
                    } },
                rotate: {
                    '0%': { v: '-180 ${ow/2} ${oh/2}' },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '70%': {},
                    '100%': { v: '0 0 ${ow/2} ${oh/2}', ease: 'easyEaseInOutReverse' }
                },
                d: {
                    '0%': {},
                    '20%': {},
                    '70%': { v: 'M${ow/2-oh/2},0h${oh}v${oh}h${-oh}z', ease: 'easyEaseInOut' }, //move to left
                    '100%': { v: 'M${ow/2-oh/2},0h${oh}v${oh}h${-oh}z', ease: 'easyEaseInOut' //move to left
                    } },
                rotate: {
                    '0%': {},
                    '70%': {},
                    '100%': { v: '-180 ${ow/2} ${oh/2}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByxOg5ueb-tw',
    desc: 'Social Media pack 5 - twitter',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 0.2,
        text1: '/casey',
        color1: '#fff',
        color2: '#000',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        'oh': '${l__s1__height}'
    },
    layers: [{
        id: 's2',
        desc: 'handle container',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'ms1',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M${oh/2},${oh*0.16}H${ow - oh*0.33}a${oh/4},${oh/4},0,0,1,0,${oh * 0.66}H${oh/2}',
            fillAlpha: '${alpha}',
            fill: '${color2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '30%': {},
                    '50%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'ms1',
        desc: 'logo circle mask',
        type: 'path',
        meta: {
            shy: true },
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            strokeWidth: 20,
            strokeAlpha: 1
        }
    }, {
        id: 't1',
        desc: 'text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M${oh},${oh/4}H${ow}V${oh*0.75}H${oh}z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh+30}',
            y: '${oh/4}',
            maxWidth: '${ow - oh - 60}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '40%': { v: '${-ow}' },
                    '68%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '15%': {},
                    '50%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo circle',
        type: 'path',
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            fill: '${color2}',
            fillAlpha: '${alpha}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '40%': {},
                    '60%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        attrs: {
            d: 'M612,116.258c-22.525,9.981-46.694,16.75-72.088,19.772c25.929-15.527,45.777-40.155,55.184-69.411    c-24.322,14.379-51.169,24.82-79.775,30.48c-22.907-24.437-55.49-39.658-91.63-39.658c-69.334,0-125.551,56.217-125.551,125.513    c0,9.828,1.109,19.427,3.251,28.606C197.065,206.32,104.556,156.337,42.641,80.386c-10.823,18.51-16.98,40.078-16.98,63.101    c0,43.559,22.181,81.993,55.835,104.479c-20.575-0.688-39.926-6.348-56.867-15.756v1.568c0,60.806,43.291,111.554,100.693,123.104    c-10.517,2.83-21.607,4.398-33.08,4.398c-8.107,0-15.947-0.803-23.634-2.333c15.985,49.907,62.336,86.199,117.253,87.194    c-42.947,33.654-97.099,53.655-155.916,53.655c-10.134,0-20.116-0.612-29.944-1.721c55.567,35.681,121.536,56.485,192.438,56.485    c230.948,0,357.188-191.291,357.188-357.188l-0.421-16.253C573.872,163.526,595.211,141.422,612,116.258z',
            viewBox: "0 0 612 612",
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            scale: '1 1 ${oh*0.3} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            }, exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByxOg5ueb-sc',
    desc: 'Social Media pack 5 - snapchat',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 0.2,
        text1: '/casey',
        color1: '#fff',
        color2: '#000',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's2',
        desc: 'handle container',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'ms1',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M${oh/2},${oh*0.16}H${ow - oh*0.33}a${oh/4},${oh/4},0,0,1,0,${oh * 0.66}H${oh/2}',
            fillAlpha: '${alpha}',
            fill: '${color2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '30%': {},
                    '50%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'ms1',
        desc: 'logo circle mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            strokeWidth: 20,
            strokeAlpha: 1
        }
    }, {
        id: 't1',
        desc: 'text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M${oh},${oh/4}H${ow}V${oh*0.75}H${oh}z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh+30}',
            y: '${oh/4}',
            maxWidth: '${ow - oh - 60}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '40%': { v: '${-ow}' },
                    '68%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '15%': {},
                    '50%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo circle',
        type: 'path',
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            fill: '${color2}',
            fillAlpha: '${alpha}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '40%': {},
                    '60%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'snapchat logo',
        type: 'path',
        attrs: {
            d: 'M407.001 473.488c-1.068 0-2.087-.039-2.862-.076-.615.053-1.25.076-1.886.076-22.437 0-37.439-10.607-50.678-19.973-9.489-6.703-18.438-13.031-28.922-14.775-5.149-.854-10.271-1.287-15.22-1.287-8.917 0-15.964 1.383-21.109 2.389-3.166.617-5.896 1.148-8.006 1.148-2.21 0-4.895-.49-6.014-4.311-.887-3.014-1.523-5.934-2.137-8.746-1.536-7.027-2.65-11.316-5.281-11.723-28.141-4.342-44.768-10.738-48.08-18.484a7.187 7.187 0 0 1-.584-2.443 4.518 4.518 0 0 1 3.777-4.711c22.348-3.68 42.219-15.492 59.064-35.119 13.049-15.195 19.457-29.713 20.145-31.316a2.85 2.85 0 0 1 .101-.217c3.247-6.588 3.893-12.281 1.926-16.916-3.626-8.551-15.635-12.361-23.58-14.882-1.976-.625-3.845-1.217-5.334-1.808-7.043-2.782-18.626-8.66-17.083-16.773 1.124-5.916 8.949-10.036 15.273-10.036 1.756 0 3.312.308 4.622.923 7.146 3.348 13.575 5.045 19.104 5.045 6.876 0 10.197-2.618 11-3.362a1170.709 1170.709 0 0 0-.679-11.262c-1.614-25.675-3.627-57.627 4.546-75.95 24.462-54.847 76.339-59.112 91.651-59.112a3909.561 3909.561 0 0 0 7.582-.071c15.354 0 67.339 4.27 91.816 59.15 8.173 18.335 6.158 50.314 4.539 76.016l-.076 1.23c-.222 3.49-.427 6.793-.6 9.995.756.696 3.795 3.096 9.978 3.339 5.271-.202 11.328-1.891 17.998-5.014 2.062-.968 4.345-1.169 5.895-1.169 2.343 0 4.727.456 6.714 1.285l.106.041c5.66 2.009 9.367 6.024 9.447 10.242.071 3.932-2.851 9.809-17.223 15.485-1.472.583-3.35 1.179-5.334 1.808-7.952 2.524-19.951 6.332-23.577 14.878-1.97 4.635-1.322 10.326 1.926 16.912.036.072.067.145.102.221 1 2.344 25.205 57.535 79.209 66.432a4.523 4.523 0 0 1 3.778 4.711 7.252 7.252 0 0 1-.598 2.465c-3.289 7.703-19.915 14.09-48.064 18.438-2.642.408-3.755 4.678-5.277 11.668-.63 2.887-1.271 5.717-2.146 8.691-.819 2.797-2.641 4.164-5.567 4.164h-.441c-1.905 0-4.604-.346-8.008-1.012-5.95-1.158-12.623-2.236-21.109-2.236-4.948 0-10.069.434-15.224 1.287-10.473 1.744-19.421 8.062-28.893 14.758-13.265 9.379-28.272 19.987-50.707 19.987',
            viewBox: '215 107.286 380 380',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            scale: '1 1 ${oh*0.3} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByxOg5ueb-fb',
    desc: 'Social Media pack 5 - facebook',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 0.2,
        text1: '/casey',
        color1: '#fff',
        color2: '#000',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's2',
        desc: 'handle container',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'ms1',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M${oh/2},${oh*0.16}H${ow - oh*0.33}a${oh/4},${oh/4},0,0,1,0,${oh * 0.66}H${oh/2}',
            fillAlpha: '${alpha}',
            fill: '${color2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '30%': {},
                    '50%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'ms1',
        desc: 'logo circle mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            strokeWidth: 20,
            strokeAlpha: 1
        }
    }, {
        id: 't1',
        desc: 'text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M${oh},${oh/4}H${ow}V${oh*0.75}H${oh}z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh+30}',
            y: '${oh/4}',
            maxWidth: '${ow - oh - 60}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '40%': { v: '${-ow}' },
                    '68%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '15%': {},
                    '50%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo circle',
        type: 'path',
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            fill: '${color2}',
            fillAlpha: '${alpha}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '40%': {},
                    '60%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        attrs: {
            d: 'M158.232 219.912v-94.461h31.707l4.747-36.813h-36.454V65.134c0-10.658 2.96-17.922 18.245-17.922l19.494-.009V14.278c-3.373-.447-14.944-1.449-28.406-1.449-28.106 0-47.348 17.155-47.348 48.661v27.149H88.428v36.813h31.788v94.461l38.016-.001z',
            viewBox: '88.428 12.828 107.543 207.085',
            height: '${oh* 0.6}',
            width: '${l__self__height / 1.92}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh * 0.34} ${oh/5}',
            scale: '1 1 ${oh*0.16} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.16} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.16} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.16} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.16} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.16} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.16} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.16} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByxOg5ueb-ig',
    desc: 'Social Media pack 5 - instagram',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 0.2,
        text1: '/casey',
        color1: '#fff',
        color2: '#000',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's2',
        desc: 'handle container',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'ms1',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M${oh/2},${oh*0.16}H${ow - oh*0.33}a${oh/4},${oh/4},0,0,1,0,${oh * 0.66}H${oh/2}',
            fillAlpha: '${alpha}',
            fill: '${color2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '30%': {},
                    '50%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'ms1',
        desc: 'logo circle mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            strokeWidth: 20,
            strokeAlpha: 1
        }
    }, {
        id: 't1',
        desc: 'text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M${oh},${oh/4}H${ow}V${oh*0.75}H${oh}z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh+30}',
            y: '${oh/4}',
            maxWidth: '${ow - oh - 60}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '40%': { v: '${-ow}' },
                    '68%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '15%': {},
                    '50%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo circle',
        type: 'path',
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            fill: '${color2}',
            fillAlpha: '${alpha}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '40%': {},
                    '60%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo p1',
        type: 'path',
        attrs: {
            d: 'M400.003,72.068c106.804,0,119.451,0.408,161.633,2.332   c38.997,1.781,60.178,8.298,74.274,13.774c18.673,7.257,31.996,15.926,45.993,29.923c13.999,13.997,22.669,27.317,29.923,45.99   c5.477,14.097,11.993,35.277,13.771,74.275c1.924,42.181,2.332,54.829,2.332,161.636s-0.408,119.457-2.332,161.636   c-1.778,39-8.295,60.181-13.771,74.274c-7.254,18.669-15.924,31.993-29.923,45.993c-13.997,13.996-27.32,22.666-45.993,29.923   c-14.097,5.476-35.277,11.993-74.274,13.771c-42.175,1.927-54.82,2.331-161.633,2.331c-106.815,0-119.46-0.404-161.636-2.331   c-38.997-1.778-60.178-8.296-74.275-13.771c-18.669-7.257-31.996-15.927-45.993-29.923c-13.996-14-22.663-27.324-29.92-45.993   c-5.476-14.094-11.996-35.274-13.774-74.274c-1.924-42.179-2.332-54.829-2.332-161.636s0.408-119.455,2.332-161.636   c1.778-38.998,8.298-60.178,13.774-74.275c7.257-18.672,15.924-31.993,29.92-45.99c13.997-13.997,27.324-22.666,45.993-29.923   c14.097-5.476,35.278-11.994,74.275-13.774C280.549,72.476,293.196,72.068,400.003,72.068 M400.003-0.003   c-108.636,0-122.258,0.459-164.92,2.408c-42.577,1.942-71.654,8.706-97.096,18.593C111.683,31.22,89.376,44.896,67.14,67.133   C44.903,89.37,31.223,111.68,21.004,137.98C11.111,163.429,4.35,192.502,2.408,235.08c-1.948,42.666-2.405,56.285-2.405,164.917   c0,108.636,0.457,122.255,2.405,164.917c1.942,42.58,8.703,71.654,18.596,97.1c10.219,26.303,23.899,48.61,46.136,70.85   c22.236,22.237,44.543,35.914,70.847,46.136c25.442,9.887,54.519,16.647,97.096,18.593c42.663,1.945,56.285,2.408,164.92,2.408   c108.633,0,122.255-0.463,164.917-2.408c42.578-1.945,71.654-8.706,97.097-18.593c26.304-10.222,48.61-23.898,70.851-46.136   c22.236-22.239,35.913-44.547,46.135-70.85c9.891-25.445,16.651-54.52,18.594-97.1c1.947-42.662,2.404-56.281,2.404-164.917   c0-108.633-0.457-122.252-2.404-164.917c-1.942-42.577-8.703-71.651-18.594-97.099c-10.222-26.3-23.898-48.61-46.135-70.847   c-22.24-22.237-44.547-35.914-70.851-46.135c-25.442-9.887-54.519-16.651-97.097-18.593C522.258,0.457,508.636-0.003,400.003-0.003',
            viewBox: '0 0 800 800',
            height: '${oh* 0.6}',
            width: '${oh* 0.6}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            scale: '1 1 ${oh*0.3} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's4',
        desc: 'logo p2',
        type: 'path',
        attrs: {
            d: 'M400.003,194.594c-113.442,0-205.406,91.961-205.406,205.403S286.561,605.4,400.003,605.4   c113.439,0,205.403-91.961,205.403-205.403S513.442,194.594,400.003,194.594 M400.003,533.329   c-73.639,0-133.335-59.693-133.335-133.332s59.696-133.333,133.335-133.333s133.332,59.694,133.332,133.333   S473.642,533.329,400.003,533.329',
            viewBox: '0 0 800 800',
            height: '${oh* 0.6}',
            width: '${oh* 0.6}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            scale: '1 1 ${oh*0.3} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 'logo p3',
        type: 'path',
        attrs: {
            d: 'M661.523,186.479c0,26.507-21.488,47.998-48.002,47.998c-26.508,0-47.998-21.491-47.998-47.998   c0-26.514,21.49-48.002,47.998-48.002C640.035,138.477,661.523,159.965,661.523,186.479',
            viewBox: '0 0 800 800',
            height: '${oh* 0.6}',
            width: '${oh* 0.6}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            scale: '1 1 ${oh*0.3} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByxOg5ueb-yt',
    desc: 'Social Media pack 5 - youtube',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 0.2,
        text1: '/casey',
        color1: '#fff',
        color2: '#000',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '${l__s1__height}'
    },
    layers: [{
        id: 's2',
        desc: 'handle container',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 'ms1',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M${oh/2},${oh*0.16}H${ow - oh*0.33}a${oh/4},${oh/4},0,0,1,0,${oh * 0.66}H${oh/2}',
            fillAlpha: '${alpha}',
            fill: '${color2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '30%': {},
                    '50%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'ms1',
        desc: 'logo circle mask',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            strokeWidth: 20,
            strokeAlpha: 1
        }
    }, {
        id: 't1',
        desc: 'text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M${oh},${oh/4}H${ow}V${oh*0.75}H${oh}z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh+30}',
            y: '${oh/4}',
            maxWidth: '${ow - oh - 60}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '40%': { v: '${-ow}' },
                    '68%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '15%': {},
                    '50%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'logo circle',
        type: 'path',
        attrs: {
            d: 'M${oh/2},0A${oh/2},${oh/2} 0 1,1 ${oh/2-1},0z',
            height: 250,
            fill: '${color2}',
            fillAlpha: '${alpha}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: 1,
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                fillAlpha: {
                    '0%': { v: '0' },
                    '60%': { v: '0' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '40%': {},
                    '60%': { v: { strokeRangeEnd: '0' }, ease: 'reverseEasyEaseInOut' }
                },
                fillAlpha: {
                    '0%': {},
                    '30%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        attrs: {
            d: 'M68.2,936.1c0-45.3,0-839.6,0-870.8c0-40.5,41.9-70.6,83.3-46.9c33.2,19,696.1,401.8,752.7,434.5c37.2,21.5,36.5,72.8,0,94.3C863.4,571.3,198,956,149.8,982.8C114.5,1002.3,68.2,980.7,68.2,936.1z',
            viewBox: '-80 0 1000 1000',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color1}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            scale: '1 1 ${oh*0.3} ${oh*0.3}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: 1,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                scale: {
                    '0%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '28%': { v: '0 0 ${oh*0.3} ${oh*0.3}' },
                    '40%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}' },
                    '45%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                scale: {
                    '0%': {},
                    '20%': {},
                    '30%': { v: '0.95 0.95 ${oh*0.3} ${oh*0.3}' },
                    '35%': { v: '1.05 1.05 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' },
                    '50%': { v: '0 0 ${oh*0.3} ${oh*0.3}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});
exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77,"./data-bodymovin-jsons":51}],35:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var _dataBodymovinJsons = require('./data-bodymovin-jsons');

var _dataBodymovinJsons2 = _interopRequireDefault(_dataBodymovinJsons);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var defs = [];

defs.push({
    id: 'defId-ryyMxR5eW',
    desc: 'Square to Lower Third Title',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor2'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'mission',
        text2: 'impossible',
        color1: '#fff',
        textColor1: '#fff',
        textColor2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 50}'
    },
    layers: [{
        id: 't1',
        desc: 'Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 50 + 40,
            y: 20,
            maxWidth: '${ow - 50 - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            transform: 'skew(-10,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '45%': { v: '${-ow}' },
                    '85%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '37%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Lower text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 50 + 30,
            y: '${l__t1__y + l__t1__height + 10}',
            maxWidth: '${ow - 50 - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            transform: 'skew(-10,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '53%': { v: '${-ow}' },
                    '85%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '30%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'tm',
        desc: 'text mask',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M0,0h${ow}V${oh}h${-ow}z',
            x: '40',
            fillAlpha: 1,
            scale: '1 1 ${ow/2} ${oh/2}',
            rotate: '0 ${ow/2} ${oh/2}',
            transform: 'skew(-10,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2}' },
                    '30%': { v: '${ow/2}' },
                    '55%': { v: '${ow-oh/4}', ease: 'easyEaseInOut' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '10%': {},
                    '55%': { v: '${ow-oh/4}', ease: 'easyEaseInOut' },
                    '80%': { v: '${ow/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '${ow/2}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0V${oh}z',
            x: '40',
            stroke: '${color1}',
            strokeWidth: '40',
            strokeAlpha: 1,
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            scale: '1 1 ${ow/2} ${oh/2}',
            rotate: '0.01 ${ow/2} ${oh/2}',
            transform: 'skew(-10,0)'
        },
        animation: {
            enterkeyframes: {
                strokeWidth: {
                    '0%': { v: '${oh/2}' },
                    '55%': { v: '${oh/2}' },
                    '60%': { v: '${oh * 0.66}', ease: 'easyEaseInOut' },
                    '90%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow/2}' },
                    '30%': { v: '${ow/2}' },
                    '55%': { v: '${ow-oh/4}', ease: 'easyEaseInOut' },
                    '90%': { ease: 'easyEaseInOut' }
                },
                scale: {
                    '0%': { v: '1 0 ${ow/2} ${oh/2}' },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                rotate: {
                    '0%': { v: '-180 ${ow/2} ${oh/2}' },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                transform: {
                    '0%': { v: 'skew(0,0)' },
                    '55%': { v: 'skew(0,0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeWidth: {
                    '0%': {},
                    '10%': {},
                    '25%': { v: '${oh * 0.66}', ease: 'easyEaseInOut' },
                    '50%': { v: '${oh/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '${oh/2}', ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': {},
                    '10%': {},
                    '55%': { v: '${ow-oh/4}', ease: 'easyEaseInOut' },
                    '80%': { v: '${ow/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '${ow/2}', ease: 'easyEaseInOut' }
                },
                scale: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '1 0 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' }
                },
                rotate: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '-180 ${ow/2} ${oh/2}', ease: 'easyEaseInOut' }
                },
                transform: {
                    '0%': {},
                    '10%': {},
                    '55%': { v: 'skew(0,0)', ease: 'easyEaseInOut' },
                    '100%': { v: 'skew(0,0)', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJSyaloxZ-fb',
    desc: 'Social Media Pack - facebook',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        color1: '#3b5998',
        color2: '#fff',
        textColor1: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '150'
    },
    layers: [{
        id: 's2',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                fillAlpha: {
                    '0%': { v: '0' },
                    '10%': { v: '0' },
                    '11%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                fillAlpha: {
                    '0%': {},
                    '79%': {},
                    '80%': { v: '0' },
                    '100%': { v: '0', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'handle',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 10,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0H${oh}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '20%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M158.232 219.912v-94.461h31.707l4.747-36.813h-36.454V65.134c0-10.658 2.96-17.922 18.245-17.922l19.494-.009V14.278c-3.373-.447-14.944-1.449-28.406-1.449-28.106 0-47.348 17.155-47.348 48.661v27.149H88.428v36.813h31.788v94.461l38.016-.001z',
            viewBox: '88.428 12.828 107.543 207.085',
            height: '${oh * 0.6}',
            width: '${l__self__height / 1.92}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh * 0.34} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJSyaloxZ-tw',
    desc: 'Social Media Pack - twitter',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        color1: '#3b5998',
        color2: '#fff',
        textColor1: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '150'
    },
    layers: [{
        id: 's2',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                fillAlpha: {
                    '0%': { v: '0' },
                    '10%': { v: '0' },
                    '11%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                fillAlpha: {
                    '0%': {},
                    '79%': {},
                    '80%': { v: '0' },
                    '100%': { v: '0', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'handle',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 10,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0H${oh}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '20%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M612,116.258c-22.525,9.981-46.694,16.75-72.088,19.772c25.929-15.527,45.777-40.155,55.184-69.411    c-24.322,14.379-51.169,24.82-79.775,30.48c-22.907-24.437-55.49-39.658-91.63-39.658c-69.334,0-125.551,56.217-125.551,125.513    c0,9.828,1.109,19.427,3.251,28.606C197.065,206.32,104.556,156.337,42.641,80.386c-10.823,18.51-16.98,40.078-16.98,63.101    c0,43.559,22.181,81.993,55.835,104.479c-20.575-0.688-39.926-6.348-56.867-15.756v1.568c0,60.806,43.291,111.554,100.693,123.104    c-10.517,2.83-21.607,4.398-33.08,4.398c-8.107,0-15.947-0.803-23.634-2.333c15.985,49.907,62.336,86.199,117.253,87.194    c-42.947,33.654-97.099,53.655-155.916,53.655c-10.134,0-20.116-0.612-29.944-1.721c55.567,35.681,121.536,56.485,192.438,56.485    c230.948,0,357.188-191.291,357.188-357.188l-0.421-16.253C573.872,163.526,595.211,141.422,612,116.258z',
            viewBox: '0 0 612 612',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJSyaloxZ-sc',
    desc: 'Social Media Pack - snapchat',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        color1: '#3b5998',
        color2: '#fff',
        textColor1: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '150'
    },
    layers: [{
        id: 's2',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                fillAlpha: {
                    '0%': { v: '0' },
                    '10%': { v: '0' },
                    '11%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                fillAlpha: {
                    '0%': {},
                    '79%': {},
                    '80%': { v: '0' },
                    '100%': { v: '0', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'handle',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 10,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0H${oh}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '20%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M407.001 473.488c-1.068 0-2.087-.039-2.862-.076-.615.053-1.25.076-1.886.076-22.437 0-37.439-10.607-50.678-19.973-9.489-6.703-18.438-13.031-28.922-14.775-5.149-.854-10.271-1.287-15.22-1.287-8.917 0-15.964 1.383-21.109 2.389-3.166.617-5.896 1.148-8.006 1.148-2.21 0-4.895-.49-6.014-4.311-.887-3.014-1.523-5.934-2.137-8.746-1.536-7.027-2.65-11.316-5.281-11.723-28.141-4.342-44.768-10.738-48.08-18.484a7.187 7.187 0 0 1-.584-2.443 4.518 4.518 0 0 1 3.777-4.711c22.348-3.68 42.219-15.492 59.064-35.119 13.049-15.195 19.457-29.713 20.145-31.316a2.85 2.85 0 0 1 .101-.217c3.247-6.588 3.893-12.281 1.926-16.916-3.626-8.551-15.635-12.361-23.58-14.882-1.976-.625-3.845-1.217-5.334-1.808-7.043-2.782-18.626-8.66-17.083-16.773 1.124-5.916 8.949-10.036 15.273-10.036 1.756 0 3.312.308 4.622.923 7.146 3.348 13.575 5.045 19.104 5.045 6.876 0 10.197-2.618 11-3.362a1170.709 1170.709 0 0 0-.679-11.262c-1.614-25.675-3.627-57.627 4.546-75.95 24.462-54.847 76.339-59.112 91.651-59.112a3909.561 3909.561 0 0 0 7.582-.071c15.354 0 67.339 4.27 91.816 59.15 8.173 18.335 6.158 50.314 4.539 76.016l-.076 1.23c-.222 3.49-.427 6.793-.6 9.995.756.696 3.795 3.096 9.978 3.339 5.271-.202 11.328-1.891 17.998-5.014 2.062-.968 4.345-1.169 5.895-1.169 2.343 0 4.727.456 6.714 1.285l.106.041c5.66 2.009 9.367 6.024 9.447 10.242.071 3.932-2.851 9.809-17.223 15.485-1.472.583-3.35 1.179-5.334 1.808-7.952 2.524-19.951 6.332-23.577 14.878-1.97 4.635-1.322 10.326 1.926 16.912.036.072.067.145.102.221 1 2.344 25.205 57.535 79.209 66.432a4.523 4.523 0 0 1 3.778 4.711 7.252 7.252 0 0 1-.598 2.465c-3.289 7.703-19.915 14.09-48.064 18.438-2.642.408-3.755 4.678-5.277 11.668-.63 2.887-1.271 5.717-2.146 8.691-.819 2.797-2.641 4.164-5.567 4.164h-.441c-1.905 0-4.604-.346-8.008-1.012-5.95-1.158-12.623-2.236-21.109-2.236-4.948 0-10.069.434-15.224 1.287-10.473 1.744-19.421 8.062-28.893 14.758-13.265 9.379-28.272 19.987-50.707 19.987',
            viewBox: '215 107.286 380 380',
            width: '${oh * 0.6}',
            height: '${oh * 0.6}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJSyaloxZ-yt',
    desc: 'Social Media Pack - youtube',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        color1: '#3b5998',
        color2: '#fff',
        textColor1: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '150'
    },
    layers: [{
        id: 's2',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                fillAlpha: {
                    '0%': { v: '0' },
                    '10%': { v: '0' },
                    '11%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                fillAlpha: {
                    '0%': {},
                    '79%': {},
                    '80%': { v: '0' },
                    '100%': { v: '0', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'handle',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 10,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0H${oh}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '20%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M68.2,936.1c0-45.3,0-839.6,0-870.8c0-40.5,41.9-70.6,83.3-46.9c33.2,19,696.1,401.8,752.7,434.5c37.2,21.5,36.5,72.8,0,94.3C863.4,571.3,198,956,149.8,982.8C114.5,1002.3,68.2,980.7,68.2,936.1z',
            viewBox: '-80 0 1000 1000',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJSyaloxZ-ig',
    desc: 'Social Media Pack - instagram',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        color1: '#3b5998',
        color2: '#fff',
        textColor1: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0
    },
    precalc: {
        oh: '150'
    },
    layers: [{
        id: 's2',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color2}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                fillAlpha: {
                    '0%': { v: '0' },
                    '10%': { v: '0' },
                    '11%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                fillAlpha: {
                    '0%': {},
                    '79%': {},
                    '80%': { v: '0' },
                    '100%': { v: '0', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'handle',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 10,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0H${oh}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '20%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0H${ow}V${oh}H0z', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'logo',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M400.003,72.068c106.804,0,119.451,0.408,161.633,2.332   c38.997,1.781,60.178,8.298,74.274,13.774c18.673,7.257,31.996,15.926,45.993,29.923c13.999,13.997,22.669,27.317,29.923,45.99   c5.477,14.097,11.993,35.277,13.771,74.275c1.924,42.181,2.332,54.829,2.332,161.636s-0.408,119.457-2.332,161.636   c-1.778,39-8.295,60.181-13.771,74.274c-7.254,18.669-15.924,31.993-29.923,45.993c-13.997,13.996-27.32,22.666-45.993,29.923   c-14.097,5.476-35.277,11.993-74.274,13.771c-42.175,1.927-54.82,2.331-161.633,2.331c-106.815,0-119.46-0.404-161.636-2.331   c-38.997-1.778-60.178-8.296-74.275-13.771c-18.669-7.257-31.996-15.927-45.993-29.923c-13.996-14-22.663-27.324-29.92-45.993   c-5.476-14.094-11.996-35.274-13.774-74.274c-1.924-42.179-2.332-54.829-2.332-161.636s0.408-119.455,2.332-161.636   c1.778-38.998,8.298-60.178,13.774-74.275c7.257-18.672,15.924-31.993,29.92-45.99c13.997-13.997,27.324-22.666,45.993-29.923   c14.097-5.476,35.278-11.994,74.275-13.774C280.549,72.476,293.196,72.068,400.003,72.068 M400.003-0.003   c-108.636,0-122.258,0.459-164.92,2.408c-42.577,1.942-71.654,8.706-97.096,18.593C111.683,31.22,89.376,44.896,67.14,67.133   C44.903,89.37,31.223,111.68,21.004,137.98C11.111,163.429,4.35,192.502,2.408,235.08c-1.948,42.666-2.405,56.285-2.405,164.917   c0,108.636,0.457,122.255,2.405,164.917c1.942,42.58,8.703,71.654,18.596,97.1c10.219,26.303,23.899,48.61,46.136,70.85   c22.236,22.237,44.543,35.914,70.847,46.136c25.442,9.887,54.519,16.647,97.096,18.593c42.663,1.945,56.285,2.408,164.92,2.408   c108.633,0,122.255-0.463,164.917-2.408c42.578-1.945,71.654-8.706,97.097-18.593c26.304-10.222,48.61-23.898,70.851-46.136   c22.236-22.239,35.913-44.547,46.135-70.85c9.891-25.445,16.651-54.52,18.594-97.1c1.947-42.662,2.404-56.281,2.404-164.917   c0-108.633-0.457-122.252-2.404-164.917c-1.942-42.577-8.703-71.651-18.594-97.099c-10.222-26.3-23.898-48.61-46.135-70.847   c-22.24-22.237-44.547-35.914-70.851-46.135c-25.442-9.887-54.519-16.651-97.097-18.593C522.258,0.457,508.636-0.003,400.003-0.003',
            viewBox: '0 0 800 800',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's4',
        desc: 'logo p2',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M400.003,194.594c-113.442,0-205.406,91.961-205.406,205.403S286.561,605.4,400.003,605.4   c113.439,0,205.403-91.961,205.403-205.403S513.442,194.594,400.003,194.594 M400.003,533.329   c-73.639,0-133.335-59.693-133.335-133.332s59.696-133.333,133.335-133.333s133.332,59.694,133.332,133.333   S473.642,533.329,400.003,533.329',
            viewBox: '0 0 800 800',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's5',
        desc: 'logo p3',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1',
                mAlphaInv: false
            }]
        },
        attrs: {
            d: 'M661.523,186.479c0,26.507-21.488,47.998-48.002,47.998c-26.508,0-47.998-21.491-47.998-47.998   c0-26.514,21.49-48.002,47.998-48.002C640.035,138.477,661.523,159.965,661.523,186.479',
            viewBox: '0 0 800 800',
            width: '${oh * 0.6}',
            height: '${oh* 0.6}',
            fill: '${color2}',
            fillAlpha: 1,
            translate: '${oh/5} ${oh/5}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2 - oh/2}' },
                    '20%': { v: '${ow/2 - oh/2}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow/2 - oh/2}', ease: 'easyEaseInOutReverse' }
                },
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-H1uuZVngW',
    desc: 'Overlap Animation Title',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        text2: 'FULL DEVELOP',
        color1: '#fff',
        textColor1: '#fff',
        textColor2: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t1__height + 2 * l__t2__height + 20}'
    },
    layers: [{
        id: 'bgm',
        desc: 'background mask',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M0,${l__t1__y}H${ow}v${l__t1__height}H0z',
            fill: '#f00',
            alpha: '${alpha}'
        }
    }, {
        id: 't1m',
        desc: 'text 1 mask',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M0,${l__t1__y}h${ow}v${l__t1__height}h${-ow}z',
            fill: '#0f0',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,${l__t1__y}h0v${l__t1__height}h0z' },
                    '5%': { v: 'M0,${l__t1__y}h0v${l__t1__height}h0z' },
                    '55%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 'M0,${l__t1__y}h0v${l__t1__height}h0z', ease: 'easyEaseInOut' //move to right
                    } }
            }
        }
    }, {
        id: 't1',
        desc: 'primary text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 't1m',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 5,
            y: '${l__t2__height + l__t2__y}',
            maxWidth: '${ow - 10}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '5%': { v: '${ow}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: '${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Secondary text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'bgm',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 5,
            y: 10,
            maxWidth: '${ow - 10}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            transform: 'rotate(0)'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y}' },
                    '10%': { v: '${l__t1__y}' },
                    '60%': { v: '${l__t1__y + l__t1__height}', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                transform: {
                    '0%': { v: 'rotate(-9)' },
                    '10%': { v: 'rotate(-9)' },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y+20}H${ow}V${oh}H0z' },
                    '60%': { v: 'M0,${l__t1__y+20}H${ow}V${oh}H0z' },
                    '61%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '40%': { v: '${l__t1__y + l__t1__height}', ease: 'easyEaseInOut' },
                    '100%': { v: '${l__t1__y}', ease: 'easyEaseInOut' }
                },
                transform: {
                    '0%': {},
                    '40%': {},
                    '95%': { v: 'rotate(-9)', ease: 'easyEaseInOut' },
                    '100%': { v: 'rotate(-9)', ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '41%': { v: 'M0,${l__t1__y+20}H${ow}V${oh}H0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's2',
        desc: 'sliding bg 2',
        type: 'path',
        attrs: {
            d: 'M0,${l__t1__y}h0v${l__t1__height}h0z',
            clipPath: 'M0,0h${ow}V${oh}H0z',
            fill: '${color1}',
            alpha: '${alpha}',
            fillAlpha: 1
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': {},
                    '5%': {},
                    '55%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z' },
                    '50%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z' },
                    '100%': { ease: 'easyEaseInOut' //move to right
                    } }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg 1',
        type: 'path',
        attrs: {
            d: 'M0,${l__t1__y}h0v${l__t1__height}h0z',
            clipPath: 'M0,0h${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1,
            scale: '1 1 ${ow/2} ${oh/2}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': {},
                    '55%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z', ease: 'easyEaseInOut' }, //move to right
                    '100%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z', ease: 'easyEaseInOut' //move to right
                    } }
            },
            exitkeyframes: {
                d: {
                    '0%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z' },
                    '55%': { v: 'M${ow},${l__t1__y}h${ow/2}v${l__t1__height}h${-ow/2}z' },
                    '100%': { ease: 'easyEaseInOut' //move to right
                    } }
            }
        }
    }, {
        id: 's3',
        desc: 'sliding upper line',
        type: 'path',
        attrs: {
            d: 'M20,${l__t2__y+5}H${ow-20}',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '16.4%': { v: 0 },
                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '22.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '38.18%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: 0 }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '42.72%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 's4',
        desc: 'sliding lower line',
        type: 'path',
        attrs: {
            d: 'M20,${l__t2__y+l__t2__height-5}H${ow-20}',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimStart: {
                    '0%': { v: 100 },
                    '49%': { v: 100 },
                    '89.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimEnd: {
                    '0%': { v: 100 },
                    '53.63%': { v: 100 },
                    '93.63%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '0%': {},
                    '29%': {},
                    '79.18%': { v: 100, ease: 'easyEaseInOut' },
                    '100%': { v: 100 }
                },
                strokeTrimStart: {
                    '0%': {},
                    '33.63%': {},
                    '83.63%': { v: 100, ease: 'easyEaseInOut' },
                    '100%': { v: 100 }
                }
            }
        }
    }]
});

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77,"./data-bodymovin-jsons":51}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var defs = [];

// 2 text + racing lines
defs.push({
	id: 'defId-Hk3GZNoxZ',
	desc: '2 text + racing lines',
	meta: {
		autoHeight: true,
		textEditors: {
			'text1': 't1',
			'text2': 't2'
		},
		textColors: {
			'text1': 'textColor1',
			'text2': 'textColor2'
		},
		mappings: {
			primaryColor: 'textColor1'
		}
	},
	props: {
		text1: 'text',
		text2: 'text',
		color1: 'color',
		textColor1: 'textColor',
		textColor2: 'textColor',
		alpha: 'alpha',
		fontFamily1: 'fontfamily',
		fontFamily2: 'fontfamily',
		shadow: 'shadow',
		lineHeight1: 'lineHeight',
		lineHeight2: 'lineHeight',
		letterSpacing1: 'letterSpacing',
		letterSpacing2: 'letterSpacing'
	},
	defaults: {
		alpha: 1,
		text1: 'JONATHAN CLEMENT',
		text2: 'ANIMATION ARTIST',
		color1: '#f00',
		textColor1: '#f00',
		textColor2: '#0f0',
		fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
		fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
		shadow: true,
		lineHeight1: 1.4,
		lineHeight2: 1.2,
		letterSpacing1: 0,
		letterSpacing2: 0
	},
	precalc: {
		'oh': '${l__t2__y + l__t2__height + 20}',
		'TILT': '${tan(PI*(15/90))}'
	},
	layers: [{
		id: 't1single',
		desc: 'Main Text visible',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 100,
			// lineHeightFactor : 1.4,
			lineHeightFactor: '${lineHeight1}',
			letterSpacingFactor: '${letterSpacing1}',
			layoutAlgo: 'fixed',
			x: 20,
			y: 0,
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			align: 'center',
			text: '${text1}',
			fill: '${textColor1}',
			fillAlpha: '${alpha}',
			transform: 'skew(-15,0)',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			alpha: 1
		},
		animation: {
			enterkeyframes: {
				alpha: {
					'0%': { v: 0 },
					'99.99%': { v: 0 },
					'100%': {}
				}
			},
			exitkeyframes: {
				alpha: {
					'0.01%': { v: 0 },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: 't1',
		desc: 'Main Text Left part',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 100,
			// lineHeightFactor : 1.4,
			lineHeightFactor: '${lineHeight1}',
			letterSpacingFactor: '${letterSpacing1}',
			layoutAlgo: 'fixed',
			x: 20,
			y: 0,
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'center',
			text: '${text1}',
			fill: '${textColor1}',
			fillAlpha: '${alpha}',
			transform: 'skew(-15,0)',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			alpha: 0,
			clipPath: 'M${ow/2},${l__t1__height/2}' + 'l${l__t1__height * TILT},${-l__t1__height}' + 'h${-ow}h${-2*l__t1__height * TILT}' + 'v${2*l__t1__height}h${ow}z'
		},
		animation: {
			enterkeyframes: {
				x: {
					'0%': { v: '${l__t1__width/2 + 50}' },
					'100%': { ease: 'easyEaseInOut' }
				},
				alpha: {
					'0%': { v: 1 },
					'99.99%': { v: 1 },
					'100%': {}
				}
			},
			exitkeyframes: {
				x: {
					'100%': { v: '${l__t1__width/2 + 50}', ease: 'easyEaseInOutReverse' }
				},
				alpha: {
					'0.01%': { v: 1 },
					'100%': { v: 1 }
				}
			}
		}
	}, {
		id: 't1right',
		desc: 'Main Text Right part',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 100,
			// lineHeightFactor : 1.4,
			lineHeightFactor: '${lineHeight1}',
			letterSpacingFactor: '${letterSpacing1}',
			layoutAlgo: 'fixed',
			x: 20,
			y: 0,
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			align: 'center',
			text: '${text1}',
			fill: '${textColor1}',
			fillAlpha: '${alpha}',
			transform: 'skew(-15,0)',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			alpha: 0,
			clipPath: 'M${ow/2},${l__t1__height/2}' + 'l${l__t1__height * TILT},${-l__t1__height}' + 'h${ow}v${2*l__t1__height}h${-ow}' + 'h${-2*l__t1__height * TILT}z'
		},
		animation: {
			enterkeyframes: {
				x: {
					'0%': { v: '${-l__t1__width/2 - 50}' },
					'100%': { ease: 'easyEaseInOut' }
				},
				alpha: {
					'0%': { v: 1 },
					'99.99%': { v: 1 },
					'100%': {}
				}
			},
			exitkeyframes: {
				x: {
					'100%': { v: '${-l__t1__width/2 - 50}', ease: 'easyEaseInOutReverse' }
				},
				alpha: {
					'0.01%': { v: 1 },
					'100%': { v: 1 }
				}
			}
		}
	}, {
		id: 't2single',
		desc: 'Bottom Text',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily2}',
			fontSize: 80,
			// lineHeightFactor : 1.2,
			lineHeightFactor: '${lineHeight2}',
			letterSpacingFactor: '${letterSpacing2}',
			layoutAlgo: 'fixed',
			x: 20,
			y: '${l__t1__y + l__t1__height + 10}',
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'center',
			text: '${text2}',
			fill: '${textColor2}',
			fillAlpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			alpha: 1,
			transform: 'skew(-15,0)'
		},
		animation: {
			enterkeyframes: {
				alpha: {
					'0%': { v: 0 },
					'99.99%': { v: 0 },
					'100%': {}
				}
			},
			exitkeyframes: {
				alpha: {
					'0.01%': { v: 0 },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: 't2',
		desc: 'Bottom Text',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily2}',
			fontSize: 80,
			// lineHeightFactor : 1.2,
			lineHeightFactor: '${lineHeight2}',
			letterSpacingFactor: '${letterSpacing2}',
			layoutAlgo: 'fixed',
			x: 20,
			y: '${l__t1__y + l__t1__height + 10}',
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'center',
			text: '${text2}',
			fill: '${textColor2}',
			fillAlpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			alpha: 0,
			transform: 'skew(-15,0)',
			clipPath: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${l__t2__height * TILT},${-l__t2__height}' + 'h${-ow}h${-2*l__t2__height * TILT}' + 'v${2*l__t2__height}h${ow}z'
		},
		animation: {
			enterkeyframes: {
				x: {
					'0%': { v: '${l__t2__width/2 + 50}' },
					'100%': { ease: 'easyEaseInOut' }
				},
				alpha: {
					'0%': { v: 1 },
					'99.99%': { v: 1 },
					'100%': {}
				}
			},
			exitkeyframes: {
				x: {
					'100%': { v: '${l__t2__width/2 + 50}', ease: 'easyEaseInOutReverse' }
				},
				alpha: {
					'0.01%': { v: 1 },
					'100%': { v: 1 }
				}
			}
		}
	}, {
		id: 't2right',
		desc: 'Bottom Text',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily2}',
			fontSize: 80,
			// lineHeightFactor : 1.2,
			lineHeightFactor: '${lineHeight2}',
			letterSpacingFactor: '${letterSpacing2}',
			layoutAlgo: 'fixed',
			x: 20,
			y: '${l__t1__y + l__t1__height + 10}',
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'center',
			text: '${text2}',
			fill: '${textColor2}',
			fillAlpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			alpha: 0,
			transform: 'skew(-15,0)',
			clipPath: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${l__t2__height * TILT},${-l__t2__height}' + 'h${ow}v${2*l__t2__height}h${-ow}' + 'h${-2*l__t2__height * TILT}z'
		},
		animation: {
			enterkeyframes: {
				x: {
					'0%': { v: '${-l__t2__width/2 - 50}' },
					'100%': { ease: 'easyEaseInOut' }
				},
				alpha: {
					'0%': { v: 1 },
					'99.99%': { v: 1 },
					'100%': {}
				}
			},
			exitkeyframes: {
				x: {
					'100%': { v: '${-l__t2__width/2 - 50}', ease: 'easyEaseInOutReverse' }
				},
				alpha: {
					'0.01%': { v: 1 },
					'100%': { v: 1 }
				}
			}
		}
	}, {
		id: '1tf1',
		desc: 'First Line for top text racing up',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t1__y + l__t1__height/2}' + 'l${3*l__t1__height * TILT},${-3*l__t1__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'31.3%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'16.4%': { v: 0 },
					'47.78%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'68.7%': {},
					'100%': { v: 0, ease: 'easyEaseInOutReverse' }
				},
				strokeTrimStart: {
					'52.22%': {},
					'83.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1tf2',
		desc: 'Second Line for top text racing down',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t1__y + l__t1__height/2}' + 'l${-3.5*l__t1__height * TILT},${3.5*l__t1__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'31.3%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'16.4%': { v: 0 },
					'47.78%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'68.7%': {},
					'100%': { v: 0, ease: 'easyEaseInOutReverse' }
				},
				strokeTrimStart: {
					'52.22%': {},
					'83.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1ts1',
		desc: 'Third Line for top text racing up',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t1__y + l__t1__height/2}' + 'l${3*l__t1__height * TILT},${-3*l__t1__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'24.4%': { v: 0 },
					'56.7%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'41.8%': { v: 0 },
					'73.1%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'43.3%': {},
					'75.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'26.9%': {},
					'58.2%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1ts2',
		desc: 'Second Line for top text racing down',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t1__y + l__t1__height/2}' + 'l${-3.5*l__t1__height * TILT},${3.5*l__t1__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'24.4%': { v: 0 },
					'56.7%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'41.8%': { v: 0 },
					'73.1%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'43.3%': {},
					'75.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'26.9%': {},
					'58.2%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1tt1',
		desc: 'Third Line for top text racing up',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t1__y + l__t1__height/2}' + 'l${3*l__t1__height * TILT},${-3*l__t1__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'52.2%': { v: 0 },
					'83.6%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'68.6%': { v: 0 },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'16.4%': {},
					'47.8%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'31.4%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1tt2',
		desc: 'Second Line for top text racing down',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t1__y + l__t1__height/2}' + 'l${-3.5*l__t1__height * TILT},${3.5*l__t1__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'52.2%': { v: 0 },
					'83.6%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'68.6%': { v: 0 },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'16.4%': {},
					'47.8%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'31.4%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1bf1',
		desc: 'First Line for top text racing up',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${3*l__t2__height * TILT},${-3*l__t2__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'31.3%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'16.4%': { v: 0 },
					'47.78%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'68.7%': {},
					'100%': { v: 0, ease: 'easyEaseInOutReverse' }
				},
				strokeTrimStart: {
					'52.22%': {},
					'83.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1bf2',
		desc: 'Second Line for top text racing down',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${-3.5*l__t2__height * TILT},${3.5*l__t2__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'31.3%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'16.4%': { v: 0 },
					'47.78%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'68.7%': {},
					'100%': { v: 0, ease: 'easyEaseInOutReverse' }
				},
				strokeTrimStart: {
					'52.22%': {},
					'83.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1bs1',
		desc: 'Third Line for top text racing up',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${3*l__t2__height * TILT},${-3*l__t2__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'24.4%': { v: 0 },
					'56.7%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'41.8%': { v: 0 },
					'73.1%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'43.3%': {},
					'75.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'26.9%': {},
					'58.2%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1bs2',
		desc: 'Second Line for top text racing down',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${-3.5*l__t2__height * TILT},${3.5*l__t2__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'24.4%': { v: 0 },
					'56.7%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'41.8%': { v: 0 },
					'73.1%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'43.3%': {},
					'75.6%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'26.9%': {},
					'58.2%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1bt1',
		desc: 'Third Line for top text racing up',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${3*l__t2__height * TILT},${-3*l__t2__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'52.2%': { v: 0 },
					'83.6%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'68.6%': { v: 0 },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'16.4%': {},
					'47.8%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'31.4%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: '1bt2',
		desc: 'Second Line for top text racing down',
		type: 'path',
		attrs: {
			d: 'M${ow/2},${l__t2__y + l__t2__height/2}' + 'l${-3.5*l__t2__height * TILT},${3.5*l__t2__height}',
			strokeWidth: 8,
			strokeAlpha: 1,
			alpha: '${alpha}',
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100,
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'52.2%': { v: 0 },
					'83.6%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'68.6%': { v: 0 },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'16.4%': {},
					'47.8%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'31.4%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}]
});

defs.push({
	id: 'defId-B1kkKcjxW',
	desc: 'Rotating block around text',
	meta: {
		autoHeight: true,
		textEditors: {
			'text1': 't1',
			'text2': 't2'
		},
		textColors: {
			'text1': 'textColor1',
			'text2': 'textColor2'
		},
		mappings: {
			primaryColor: 'textColor1'
		}
	},
	props: {
		text1: 'text',
		text2: 'text',
		color1: 'color',
		textColor1: 'textColor',
		textColor2: 'textColor',
		alpha: 'alpha',
		fontFamily1: 'fontfamily',
		fontFamily2: 'fontfamily',
		shadow: 'shadow',
		lineHeight1: 'lineHeight',
		lineHeight2: 'lineHeight',
		letterSpacing1: 'letterSpacing',
		letterSpacing2: 'letterSpacing'
	},
	defaults: {
		alpha: 1,
		text1: 'JENNIFER MATTHEW',
		text2: 'EXECUTIVE DIRECTOR',
		color1: '#00f',
		textColor1: '#f00',
		textColor2: '#f00',
		fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
		fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
		shadow: true,
		lineHeight1: 1.4,
		lineHeight2: 1.4,
		letterSpacing1: 0,
		letterSpacing2: 0
	},
	precalc: {
		'oh': '${l__t2__y + l__t2__height}'
	},
	layers: [{
		id: 't1',
		desc: 'Main Text Left part',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 100,
			// lineHeightFactor : 1.4,
			lineHeightFactor: '${lineHeight1}',
			letterSpacingFactor: '${letterSpacing1}',
			layoutAlgo: 'fixed',
			x: 20,
			y: 0,
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'center',
			text: '${text1}',
			fill: '${textColor1}',
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			clipPath: 'M0,0h${ow}v${l__t1__height + 10}h${-ow}z',
			scale: '1 1 ${ow/2} ${l__t1__height/2}',
			rotate: '0 ${ow/2} ${l__t1__height/2}',
			clipPathRotate: '0 ${ow/2} ${l__t1__height/2}'
		},
		animation: {
			enterkeyframes: {
				scale: {
					'0%': { v: '1.66 1.66 ${ow/2} ${l__t1__height/2}' },
					'12%': { v: '1.66 1.66 ${ow/2} ${l__t1__height/2}' },
					'65.5%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				rotate: {
					'0%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
					'12%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
					'65.5%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				clipPathRotate: {
					'0%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
					'12%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
					'65.5%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				clipPath: {
					'0%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0z' },
					'12%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0z' },
					'65.5%': { v: 'M0,0h${ow}v${l__t1__height + 10}h${-ow}z', ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				scale: {
					'34.5%': {},
					'88%': { v: '1.66 1.66 ${ow/2} ${l__t1__height/2}' },
					'100%': { v: '1.66 1.66 ${ow/2} ${l__t1__height/2}', ease: 'easyEaseInOutReverse' }
				},
				rotate: {
					'34.5%': {},
					'88%': { v: '-180 ${ow/2} ${l__t1__height/2}', ease: 'easyEaseInOutReverse' },
					'100%': { v: '-180 ${ow/2} ${l__t1__height/2}' }
				},
				clipPathRotate: {
					'34.5%': {},
					'88%': { v: '-180 ${ow/2} ${l__t1__height/2}', ease: 'easyEaseInOutReverse' },
					'100%': { v: '-180 ${ow/2} ${l__t1__height/2}' }
				},
				clipPath: {
					'34.5%': { v: 'M0,0h${ow}v${l__t1__height + 10}h${-ow}z', ease: 'easyEaseInOutReverse' },
					'88%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0z', ease: 'easyEaseInOutReverse' },
					'100%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0z' }
				}
			}
		}
	}, {
		id: 't2',
		desc: 'Bottom Text',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily2}',
			fontSize: 60,
			// lineHeightFactor : 1.4,
			lineHeightFactor: '${lineHeight2}',
			letterSpacingFactor: '${letterSpacing2}',
			layoutAlgo: 'fixed',
			x: 20,
			y: '${l__t1__y + l__t1__height + 5}',
			maxWidth: '${ow - l__self__x - 20}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'center',
			text: '${text2}',
			fill: '${textColor2}',
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
		},
		animation: {
			enterkeyframes: {
				y: {
					'0%': { v: '${1.5*oh}' },
					'65.5%': { v: '${1.5*oh}' },
					'100%': { ease: 'easyEaseInOut' }
				},
				clipPath: {
					'0%': { v: 'M0,0h${ow}v${l__t1__height}h${-ow}z' },
					'65.5%': { v: 'M0,0h${ow}v${l__t1__height}h${-ow}z' },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				y: {
					'34.5%': { v: '${1.5*oh}', ease: 'easyEaseInOutReverse' },
					'100%': { v: '${1.5*oh}' }
				},
				clipPath: {
					'34.5%': { v: 'M0,0h${ow}v${l__t1__height}h${-ow}z', ease: 'easyEaseInOutReverse' },
					'100%': { v: 'M0,0h${ow}v${l__t1__height}h${-ow}z' }
				}
			}
		}
	}, {
		id: 'b1',
		desc: 'Box around top text',
		type: 'path',
		attrs: {
			d: 'M0,0h${ow}v${l__t2__height + 10}h${-ow}v${-l__t2__height - 10}h1',
			y: '${l__t1__height}',
			stroke: '${color1}',
			strokeAlpha: 1,
			strokeWidth: 10,
			fillAlpha: 0,
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			scale: '1 1 ${ow/2} ${l__t1__height/2}',
			rotate: '0 ${ow/2} ${l__t1__height/2}'
		},
		animation: {
			enterkeyframes: {
				scale: {
					'0%': { v: '1 0 ${ow/2} ${l__t1__height/2}' },
					'12%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				rotate: {
					'0%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
					'12%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
					'65.5%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				d: {
					'0%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0v${-l__t1__height - 10}h0' },
					'12%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0v${-l__t1__height - 10}h0' },
					'65.5%': { v: 'M0,0h${ow}v${l__t1__height + 10}h${-ow}v${-l__t1__height - 10}h1', ease: 'easyEaseInOut' },
					'100%': {}
				},
				y: {
					'0%': { v: 0 },
					'12%': { v: 0 },
					'65.5%': { v: 0, ease: 'easyEaseInOut' },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				scale: {
					'88%': {},
					'100%': { v: '1 0 ${ow/2} ${l__t1__height/2}', ease: 'easyEaseInOutReverse' }
				},
				rotate: {
					'34.5%': {},
					'88%': { v: '-180 ${ow/2} ${l__t1__height/2}', ease: 'easyEaseInOutReverse' },
					'100%': { v: '-180 ${ow/2} ${l__t1__height/2}' }
				},
				d: {
					'34.5%': { v: 'M0,0h${ow}v${l__t1__height + 10}h${-ow}z', ease: 'easyEaseInOutReverse' },
					'88%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0z', ease: 'easyEaseInOutReverse' },
					'100%': { v: 'M${ow/2},0h0v${l__t1__height + 10}h0z' }
				},
				y: {
					'34.5%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}]
});

defs.push({
	id: 'defId-BycZy8nxW',
	desc: 'sliding reveal text + lines',
	meta: {
		autoHeight: true,
		textEditors: {
			'text1': 't1',
			'text2': 't2'
		},
		textColors: {
			'text1': 'textColor1',
			'text2': 'textColor2'
		},
		mappings: {
			primaryColor: 'textColor1'
		}
	},
	props: {
		text1: 'text',
		text2: 'text',
		color1: 'color',
		textColor1: 'textColor',
		textColor2: 'textColor',
		alpha: 'alpha',
		fontFamily1: 'fontfamily',
		fontFamily2: 'fontfamily',
		shadow: 'shadow',
		lineHeight1: 'lineHeight',
		letterSpacing1: 'letterSpacing',
		lineHeight2: 'lineHeight',
		letterSpacing2: 'letterSpacing'
	},
	defaults: {
		alpha: 1,
		text1: 'JENNIFER MATTHEW',
		text2: 'EXECUTIVE DIRECTOR',
		color1: '#f00',
		textColor1: '#f00',
		textColor2: '#f00',
		fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
		fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
		shadow: true,
		lineHeight1: 1.6,
		letterSpacing1: 0,
		lineHeight2: 1.4,
		letterSpacing2: 0
	},
	precalc: {
		'oh': '${l__t2__y + l__t2__height + 20}'
	},
	layers: [{
		id: 't1',
		desc: 'Main Text',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 100,
			// lineHeightFactor : 1.6,
			lineHeightFactor: '${lineHeight1}',
			letterSpacingFactor: '${letterSpacing1}',
			layoutAlgo: 'fixed',
			x: 40,
			y: 0,
			maxWidth: '${ow - 2 * l__self__x}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'left',
			text: '${text1}',
			fill: '${textColor1}',
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
		},
		animation: {
			enterkeyframes: {
				clipPath: {
					'0%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z' },
					'26.9%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z' },
					'90.8%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z', ease: 'easyEaseInOut' },
					'99.99%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z' },
					'100%': {}
				},
				x: {
					'0%': { v: 240 },
					'16.2%': { v: 240 },
					'100%': { ease: 'easyEaseInOut' }
				}
			},
			exitkeyframes: {
				clipPath: {
					'0.01%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z' },
					'9.2%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z' },
					'73.1%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z', ease: 'easyEaseInOutReverse' },
					'100%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z' }
				},
				x: {
					'83.8%': { v: 240, ease: 'easyEaseInOutReverse' },
					'100%': { v: 240 }
				}
			}
		}
	}, {
		id: 's1',
		desc: 'sliding box for main text',
		type: 'rect',
		attrs: {
			x: 0,
			y: 0,
			width: 0,
			height: '${l__t1__height}',
			fill: '${color1}',
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			clipPath: '${l__l1__d}'
		},
		animation: {
			enterkeyframes: {
				x: {
					'0%': { v: '${l__t1__width + 80}' },
					'26.1%': { v: '${l__t1__width + 80}' },
					'90%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				width: {
					'0%': { v: 100 },
					'26.9%': { v: 100 },
					'90.8%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				x: {
					'10%': {},
					'73.9%': { v: '${l__t1__width + 80}', ease: 'easyEaseInOutReverse' },
					'100%': { v: '${l__t1__width + 80}' }
				},
				width: {
					'9.2%': {},
					'73.1%': { v: 100, ease: 'easyEaseInOutReverse' },
					'100%': { v: 100 }
				}
			}
		}
	}, {
		id: 'l1',
		desc: 'Thicker box',
		type: 'path',
		attrs: {
			d: 'M0,0v${l__t1__height}h${2 * l__t1__x + l__t1__width}v${-l__t1__height}h${-2 * l__t1__x - l__t1__width}v1',
			fillAlpha: 0,
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			strokeWidth: 14,
			strokeAlpha: 1,
			stroke: '${color1}',
			strokeTrimStart: 0,
			strokeTrimEnd: 100
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'16.9%': { v: 48.9, ease: 'easyEaseInOut' },
					'54.6%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'45.4%': {},
					'83.1%': { v: 48.9, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0, ease: 'easyEaseInOutReverse' }
				}
			}
		}
	}, {
		id: 'l2',
		desc: 'Thinner box',
		type: 'path',
		attrs: {
			d: 'M-25,-25v${l__t1__height + 50}h${2 * l__t1__x + l__t1__width + 50}v${-l__t1__height - l__t1__y/2 - 50}z',
			fillAlpha: 0,
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			strokeWidth: 8,
			strokeAlpha: 1,
			stroke: '${color1}',
			strokeTrimStart: 100,
			strokeTrimEnd: 100
		},
		animation: {
			enterkeyframes: {
				strokeTrimEnd: {
					'0%': { v: 0 },
					'4.6%': { v: 0 },
					'57.7%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				strokeTrimStart: {
					'0%': { v: 0 },
					'10%': { v: 0 },
					'70.8%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				strokeTrimEnd: {
					'42.3%': {},
					'95.4%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				},
				strokeTrimStart: {
					'29.2%': {},
					'90%': { v: 0, ease: 'easyEaseInOutReverse' },
					'100%': { v: 0 }
				}
			}
		}
	}, {
		id: 't2',
		desc: 'Bottom Text',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily2}',
			fontSize: 60,
			// lineHeightFactor : 1.4,
			lineHeightFactor: '${lineHeight2}',
			letterSpacingFactor: '${letterSpacing2}',
			layoutAlgo: 'fixed',
			x: 40,
			y: '${l__t1__y + l__t1__height + 30}',
			maxWidth: '${ow - 2*l__self__x}',
			height: '${calcSelfHeight()}',
			width: '${calcSelfWidth()}',
			align: 'left',
			text: '${text2}',
			fill: '${textColor2}',
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
		},
		animation: {
			enterkeyframes: {
				clipPath: {
					'0%': { v: 'M-150,0h0v${oh}h0z' },
					'33%': { v: 'M-150,0h0v${oh}h0z' },
					'92.3%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z', ease: 'easyEaseInOut' },
					'99.99%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z' },
					'100%': {}
				},
				x: {
					'0%': { v: 240 },
					'26.2%': { v: 240 },
					'93.1%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				clipPath: {
					'0.01%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z' },
					'7.7%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z' },
					'67%': { v: 'M-150,0h0v${oh}h0z', ease: 'easyEaseInOutReverse' },
					'100%': { v: 'M-150,0h0v${oh}h0z' }
				},
				x: {
					'6.9%': {},
					'73.8%': { v: 240, ease: 'easyEaseInOutReverse' },
					'100%': { v: 240 }
				}
			}
		}
	}, {
		id: 's2',
		desc: 'sliding box for bottom text',
		type: 'rect',
		attrs: {
			x: '${2*l__t2__x + l__t2__width}',
			y: '${l__t2__y}',
			width: 0,
			height: '${l__t2__height}',
			fill: '${color1}',
			alpha: '${alpha}',
			shadowEnabled: '${shadow}',
			shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
			shadowAlpha: '${alpha}',
			shadowOffsetX: 2,
			shadowOffsetY: 2,
			shadowBlur: 6,
			clipPath: 'M10,0h${ow}v${oh}h${-ow}z'
		},
		animation: {
			enterkeyframes: {
				x: {
					'0%': { v: -150 },
					'33%': { v: -150 },
					'92.3%': { ease: 'easyEaseInOut' },
					'100%': {}
				},
				width: {
					'0%': { v: 150 },
					'30%': { v: 150 },
					'89.2%': { ease: 'easyEaseInOut' },
					'100%': {}
				}
			},
			exitkeyframes: {
				x: {
					'7.7%': {},
					'67%': { v: -150, ease: 'easyEaseInOutReverse' },
					'100%': { v: -150 }
				},
				width: {
					'10.8%': {},
					'70%': { v: 150, ease: 'easyEaseInOutReverse' },
					'100%': { v: 150 }
				}
			}
		}
	}]
});

defs.push({
	id: 'defId-HkosyyrBZ',
	desc: 'simple multi-color template',
	meta: {
		autoHeight: true,
		canOverrideAnimation: true,
		textEditors: {
			'text1': 't1'
		},
		textColors: {
			'text1': 'textColor1'
		},
		mappings: {
			primaryColor: 'textColor1'
		}
	},
	props: {
		color1: 'color',
		textColor1: 'textColor',
		alpha: 'alpha',
		align: 'align',
		text1: 'text',
		fontFamily1: 'fontfamily',
		lineHeight: 'lineHeight',
		letterSpacing: 'letterSpacing'
	},
	defaults: {
		color1: '#fff',
		textColor1: '#fff',
		alpha: 1,
		align: 'center',
		text1: '',
		fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
		lineHeight: 1.42,
		letterSpacing: 0
	},
	precalc: {
		'oh': '${l__t1__height}'
	},
	layers: [{
		id: 'b1',
		desc: 'Solid background',
		type: 'path',
		attrs: {
			d: 'M0,0h${ow}v${oh}h${-ow}z',
			fillAlpha: 1,
			fill: '${color1}',
			alpha: '${alpha}',
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
			shadowEnabled: false
		},
		animation: {
			enterkeyframes: {},
			exitkeyframes: {}
		}
	}, {
		id: 't1',
		desc: 'Text Only',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 75,
			lineSpacing: 0,
			layoutAlgo: 'fixed',
			lineHeightFactor: '${lineHeight}',
			letterSpacingFactor: '${letterSpacing}',
			x: 20,
			y: 0,
			maxWidth: '${ow-40}',
			height: '${calcSelfHeight()}',
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
			text: '${text1}',
			fill: '${textColor1}',
			align: '${align}',
			shadowEnabled: false
		},
		animation: {
			enterkeyframes: {},
			exitkeyframes: {}
		}
	}]
});

defs.push({
	id: 'defId-SkArkqfFG',
	desc: 'simple multi-color template with variable line spacing',
	meta: {
		autoHeight: true,
		variableLineSpacing: true,
		canOverrideAnimation: true,
		textEditors: {
			'text1': 't1'
		},
		textColors: {
			'text1': 'textColor1'
		},
		mappings: {
			primaryColor: 'textColor1'
		}
	},
	props: {
		color1: 'color',
		textColor1: 'textColor',
		alpha: 'alpha',
		align: 'align',
		text1: 'text',
		fontFamily1: 'fontfamily',
		lineHeight: 'lineHeight',
		letterSpacing: 'letterSpacing',
		lineSpacing: 'lineSpacing'
	},
	defaults: {
		color1: '#fff',
		textColor1: '#fff',
		alpha: 1,
		align: 'center',
		text1: '',
		fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
		lineHeight: 1.42,
		letterSpacing: 0,
		lineSpacing: 0
	},
	precalc: {
		'oh': '${l__t1__height}'
	},
	layers: [{
		id: 'b1',
		desc: 'Solid background',
		type: 'path',
		attrs: {
			d: 'M0,0h${ow}v${oh}h${-ow}z',
			fillAlpha: 1,
			fill: '${color1}',
			alpha: '${alpha}',
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
			shadowEnabled: false
		},
		animation: {
			enterkeyframes: {},
			exitkeyframes: {}
		}
	}, {
		id: 't1',
		desc: 'Text Only',
		type: 'text',
		attrs: {
			fontFamily: '${fontFamily1}',
			fontSize: 75,
			lineSpacing: '${lineSpacing}',
			layoutAlgo: 'fixed',
			lineHeightFactor: '${lineHeight}',
			letterSpacingFactor: '${letterSpacing}',
			x: 20,
			y: 0,
			maxWidth: '${ow-40}',
			height: '${calcSelfHeight()}',
			clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
			text: '${text1}',
			fill: '${textColor1}',
			align: '${align}',
			shadowEnabled: false
		},
		animation: {
			enterkeyframes: {},
			exitkeyframes: {}
		}
	}]
});

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77}],37:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _attrs, _attrs2, _attrs3;

var _GeneralUtils = require('../utils/GeneralUtils');

var _dataBodymovinJsons = require('./data-bodymovin-jsons');

var _dataBodymovinJsons2 = _interopRequireDefault(_dataBodymovinJsons);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var defs = [];

defs.push({
    id: 'defId-r1B8k5GYz',
    desc: 'simple background text template',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing'
    },
    defaults: {
        color1: '#fff',
        textColor1: '#fff',
        alpha: 0.8,
        align: 'center',
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: '${align}',
            bgAlpha: '${alpha}',
            bgFill: '${color1}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-ryIPP7WKG',
    desc: 'simple background text template',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        canOverrideAnimation: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        color1: '#fff',
        textColor1: '#fff',
        alpha: 0.8,
        align: 'center',
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 30
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: '${align}',
            bgAlpha: '${alpha}',
            bgFill: '${color1}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-rJOy89MtM',
    desc: 'simple background text template',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        canOverrideAnimation: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        color1: '#fff',
        textColor1: '#fff',
        alpha: 0.8,
        align: 'center',
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: '${align}',
            bgAlpha: '${alpha}',
            bgFill: '${color1}',
            fadeBackground: true,
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-rkZ3Og5UM',
    desc: 'placeholder template 1',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        color1: '#fff',
        color2: '#f00',
        textColor1: '#000',
        textColor2: '#000',
        alpha: 1,
        text1: '',
        text2: 'ROSANE',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight1: 1.42,
        letterSpacing1: 0,
        lineHeight2: 1.42,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        'oh': '${l__i1__height + 12}'
    },
    layers: [{
        id: 'b1',
        desc: 'upper background',
        type: 'path',
        attrs: {
            d: 'M${l__i1__height/2},20H${ow}l-40,${l__t1__height}H${l__i1__height/2}z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,20H${ow}v${l__t1__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},20H${ow}v${l__t1__height}H${ow}z' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '30%': {},
                    '100%': { v: 'M${ow},20H${ow}v${l__t1__height}H${ow}z', ease: 'easeInOutReverse' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'lower background',
        type: 'path',
        attrs: {
            d: 'M${l__i1__height/2},${l__t1__height+20}H${ow-40}l40,${l__t2__height}H${l__i1__height/2}z',
            fillAlpha: 1,
            fill: '${color2}',
            alpha: '${alpha}',
            clipPath: 'M0,${l__t1__height+20}H${ow}v${l__t2__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__height+20}H0v${l__t2__height}H0z' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '30%': {},
                    '100%': { v: 'M0,${l__t1__height+20}H0v${l__t2__height}H0z', ease: 'easeInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        meta: {
            masks: [{ mLayerId: 'b1' }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            x: '${l__i1__x + l__i1__width + 30}',
            y: 10,
            maxWidth: '${ow - l__i1__width - 50}',
            height: '${oh/2 - 20}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: 'left',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        meta: {
            masks: [{ mLayerId: 'b2' }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            x: '${l__i1__x + l__i1__width + 30}',
            y: '${l__t1__height + 10}',
            maxWidth: '${ow - l__i1__width - 50}',
            height: '${oh/2 -20}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text2}',
            fill: '${textColor2}',
            align: 'left',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'b3',
        desc: 'Image background',
        type: 'ellipse',
        attrs: {
            cx: '${oh/2}',
            cy: '${oh/2}',
            rx: '${oh/2}',
            ry: '${oh/2}',
            fill: '${color2}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                rx: {
                    '0%': { v: '0' },
                    '20%': { v: '0' },
                    '50%': { v: '${oh/2 * 1.1}', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                ry: {
                    '0%': { v: '0' },
                    '20%': { v: '0' },
                    '50%': { v: '${oh/2 * 1.1}', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                rx: {
                    '30%': {},
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                },
                ry: {
                    '30%': {},
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: 6,
            y: 6,
            width: '200',
            height: '200',
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            transform: 'scale(1, 1, ${l__i1__width/2}, ${l__i1__height/2})',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${l__i1__width/2}, ${l__i1__height/2})' },
                    '20%': { v: 'scale(0, 0, ${l__i1__width/2}, ${l__i1__height/2})', ease: 'easeInOut' },
                    '50%': { v: 'scale(1.1, 1.1, ${l__i1__width/2}, ${l__i1__height/2})', ease: 'easeInOut' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '30%': {},
                    '100%': { v: 'scale(0, 0, ${l__i1__width/2}, ${l__i1__height/2})', ease: 'easeInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJc0zNgDf',
    desc: 'placeholder template 2',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        color2: '#f00',
        textColor1: '#000',
        textColor2: '#000',
        alpha: 1,
        text1: '',
        text2: 'ROSANE',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight1: 1.42,
        letterSpacing1: 0,
        lineHeight2: 1.42,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        'oh': '${l__i1__height + 20}'
    },
    layers: [{
        id: 'b1',
        desc: 'upper background',
        type: 'path',
        attrs: {
            d: 'M0,40H${ow}v${l__t1__height + 10}H0z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,40H${ow}v${l__t1__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},40H${ow}v${l__t1__height + 10 }H${ow}z' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '30%': {},
                    '100%': { v: 'M${ow},40H${ow}v${l__t1__height + 10}H${ow}z', ease: 'easeInOutReverse' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'lower background',
        type: 'path',
        attrs: {
            d: 'M0,${l__t1__y + l__t1__height + 10 }H${ow}v${l__t2__height }H0z',
            fillAlpha: 1,
            fill: '${color2}',
            alpha: '${alpha}',
            clipPath: 'M0,${l__t1__y + l__t1__height + 10}H${ow}v${l__t2__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t1__y + l__t1__height + 10 }H0v${l__t2__height }H0z' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '30%': {},
                    '100%': { v: 'M0,${l__t1__y + l__t1__height + 10}H0v${l__t2__height}H0z', ease: 'easeInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        meta: {
            masks: [{ mLayerId: 'b1' }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            x: '${l__i1__x + l__i1__width + 30}',
            y: 30,
            maxWidth: '${ow - l__i1__width - 50}',
            height: '${(oh - 40 - 10)/2}',
            clipPath: 'M0,50h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: 'left',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        meta: {
            masks: [{ mLayerId: 'b2' }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 55,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            x: '${l__i1__x + l__i1__width + 30 }',
            y: '${l__t1__y + l__t1__height + 10}',
            maxWidth: '${ow - l__i1__width - 50}',
            height: '${(oh - 40 - 10 - 20)/2}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text2}',
            fill: '${textColor2}',
            align: 'left',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'b3',
        desc: 'Image background',
        type: 'ellipse',
        attrs: {
            cx: '${oh/2 + 20}',
            cy: '${oh/2}',
            rx: '${oh/2}',
            ry: '${oh/2}',
            fill: '${color2}',
            shadowEnabled: false,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                rx: {
                    '0%': { v: '0' },
                    '20%': { v: '0' },
                    '50%': { v: '${oh/2 * 1.1}', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                ry: {
                    '0%': { v: '0' },
                    '20%': { v: '0' },
                    '50%': { v: '${oh/2 * 1.1}', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                rx: {
                    '30%': {},
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                },
                ry: {
                    '30%': {},
                    '100%': { v: '0', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            alpha: '${alpha}',
            x: 30,
            y: 10,
            width: '200',
            height: '200',
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            transform: 'scale(1, 1, ${l__i1__width/2}, ${l__i1__height/2})',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${l__i1__width/2}, ${l__i1__height/2})' },
                    '20%': { v: 'scale(0, 0, ${l__i1__width/2}, ${l__i1__height/2})', ease: 'easeInOut' },
                    '50%': { v: 'scale(1.1, 1.1, ${l__i1__width/2}, ${l__i1__height/2})', ease: 'easeInOut' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '30%': {},
                    '100%': { v: 'scale(0, 0, ${l__i1__width/2}, ${l__i1__height/2})', ease: 'easeInOutReverse' }
                }
            }
        }
    }]
});

// Modern Openers - Lower Third 4 with placeholder
defs.push({
    id: 'defId-ryI5sWewM',
    desc: 'Modern Openers - Lower Third 4 with placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color2'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#000',
        color2: '#fff',
        textColor1: '#fff',
        textColor2: '#fff',
        text1: '',
        text2: '',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        'oh': '${l__i1__height}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Background',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            width: '${oh + 40}',
            height: '${oh}',
            fill: '${color1}',
            alpha: 1,
            clipPath: 'M0,0H${ow - 10}V${oh}H0',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '60%': { v: '${ow}', ease: 'easyEaseInOut' },
                    '90%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow}' },
                    '20%': { v: '${ow}' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '0%': {},
                    '70%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': {},
                    '20%': {},
                    '100%': { v: '${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'bg2',
        desc: 'Background 2',
        type: 'rect',
        attrs: {
            x: '${oh + 40}',
            y: 0,
            width: '${ow - oh - 40}',
            height: '${oh}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '90%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow}' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '20%': {},
                    '90%': { v: 0, ease: 'easyEaseInOut' }
                },
                x: {
                    '20%': {},
                    '90%': { v: '${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40 + 20}',
            y: 20,
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 20}' },
                    '90%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${oh}h0z' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '20%': {},
                    '30%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__x}',
            y: '${l__t1__y + l__t1__height + 10}',
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t2__y + l__t2__height + 20}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow},0h0v${oh-8}h0z' },
                    '80%': { v: 'M0,0h${ow}v${oh-8}h${-ow}z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '20%': {},
                    '30%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow},0h0v${oh}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        meta: {
            masks: [{ mLayerId: 'bg1' }]
        },
        attrs: {
            imageId: '${imageId}',
            x: 20,
            y: 0,
            width: 250,
            height: 250,
            crop: 'square',
            cropEnabled: true,
            cropX: '${cropX}',
            cropY: '${cropY}',
            alpha: 1,
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '89%': {},
                    '90%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HybO9fewz',
    desc: 'Two text + wedgy background + side borders + placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color2'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#F1626E',
        color2: '#000000',
        textColor1: '#FFFFFF',
        textColor2: '#F1626E',
        alpha: 0.8,
        lineHeight1: 1,
        letterSpacing1: 0,
        lineHeight2: 1,
        letterSpacing2: 0,
        text1: 'PENGUIN SLIDE',
        text2: 'Next show after the Lion Dance',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        'oh': '${l__i1__height + 26}'
    },
    layers: [{
        id: 's2',
        desc: 'Background',
        type: 'path',
        attrs: {
            d: 'M${oh+10},0H${ow}L${ow - 95},${oh}H${oh+10}z',
            clipPath: 'M${oh+10},0H${ow}L${ow - 95},${oh}H${oh+10}z',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${-ow}, 0)' },
                    '20%': { v: 'translate(${-ow}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '80%': { v: 'translate(${-ow}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${-ow}, 0)' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Straight border line',
        type: 'rect',
        attrs: {
            x: '${oh + 10}',
            width: 13,
            height: '${oh}',
            fill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Slant border line',
        type: 'path',
        attrs: {
            d: 'M${ow},0h-10l-95,${oh}h10z',
            clipPath: 'M${l__s1__x+l__s1__width},0H${ow}l-95,${oh}H${l__s1__x+l__s1__width}z',
            fill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M${oh + 20},0h-140l-95,${oh}h140z' },
                    '36%': { v: 'M${oh + 20},0h-140l-95,${oh}h140z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                d: {
                    '10%': {},
                    '64%': { v: 'M${oh + 20},0h-140l-95,${oh}h140z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${oh + 20},0h-140l-95,${oh}h140z' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 20,
            maxWidth: '${ow - l__self__x - 95 }',
            height: '${calcSelfHeight()}',
            clipPath: 'M${oh + 40},20h${l__self__maxWidth}v${l__self__height + 20}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,20h0v${l__t1__height + 20}h0z' },
                    '36%': { v: 'M0,20h0v${l__t1__height + 20}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 10}' },
                    '50%': { v: '${l__t1__y + l__t1__height + 10}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': { v: 'M0,20h0v${l__t1__height + 20}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,20h0v${l__t1__height + 20}h0z' }
                },
                y: {
                    '50%': { v: '${l__t1__y + l__t1__height + 10}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${l__t1__y + l__t1__height + 10}' }
                }
            }
        }
    }, {
        id: 't2',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: '${l__t1__y + l__t1__height + 20}',
            maxWidth: '${ow - l__self__x - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${oh + 40},${l__self__y - 10}h${l__self__maxWidth}v${l__self__height + 10}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z' },
                    '36%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${-l__t2__height - 10}' },
                    '50%': { v: '${-l__t2__height - 10}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z' }
                },
                y: {
                    '20%': {},
                    '50%': { v: '${-l__t2__height - 10}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height - 10}' }
                }
            }
        }
    }, {
        id: 's4',
        desc: 'Placeholder Background',
        type: 'rect',
        attrs: {
            width: '${oh}',
            height: '${oh}',
            fill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        meta: {
            masks: [{
                mLayerId: 's4'
            }]
        },
        attrs: {
            imageId: '${imageId}',
            x: 13,
            y: 13,
            width: '200',
            height: '200',
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-HylJjbCZDM',
    desc: 'Flat placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        alpha: 1,
        text1: 'Casey Neistat',
        color1: '#3b5998',
        textColor1: '#3b5998',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: true,
        lineHeight: 1.2,
        letterSpacing: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        'oh': '150'
    },
    layers: [{
        id: 's1',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0H${ow}V${oh}H${ow}z' },
                    '30%': { ease: 'easyeaseinout' },
                    '100%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 'M${ow},0H${ow}V${oh}H${ow}z', ease: 'easyEaseInOutReverse' }
                }
            } }
    }, {
        id: 't1',
        desc: 'handle',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's1'
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            fontSize: 100,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 10,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            width: '${oh}',
            height: '${oh}',
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: false,
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${- ow - l__i1__width}' },
                    '10%': { v: '${- ow - l__i1__width}' },
                    '40%': { ease: 'easyEaseInOutReverse' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${- ow - l__i1__width}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${- ow - l__i1__width}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-r1TfRRbvf',
    desc: 'Clean Lower Thirds with placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        color3: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        color1: '#545454',
        color2: '#f0f',
        color3: '#000',
        textColor1: '#f0f',
        textColor2: '#0ff',
        text1: 'ALAN RICKMAN',
        text2: 'Professor Snape',
        alpha: 1,
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        fontFamily2: 'RALEWAY:NORMAL:NORMAL',
        lineHeight1: 1.4,
        lineHeight2: 1.4,
        letterSpacing1: 0,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        'oh': '${l__i1__height}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Main text Background',
        type: 'bmae',
        meta: {
            animationData: _dataBodymovinJsons2.default['Clean_Lower_Thirds_Lt1'],
            viewBox: "380 1358 2000 323", // 380,1358 2380,1720 380 1358 2000 362
            timeSlice: "0 1283",
            mappings: {
                colorBg: { exp: ['layers', 0, 'ef', 0, 'ef', 0, 'v', 'k', 0, 's'], type: 'color' },
                colorLine: { exp: ['layers', 0, 'ef', 1, 'ef', 0, 'v', 'k', 0, 's'], type: 'color' }
            }
        },
        attrs: {
            colorBg: '${color1}',
            colorLine: '${color2}',
            height: '${l__t1__height}',
            x: '${ow - oh - l__self__width}',
            y: 0,
            width: '${ow - oh}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'bg2',
        desc: 'Lower text background',
        type: 'rect',
        attrs: {
            fill: '${color3}',
            x: '${ow - oh - l__self__width}',
            y: '${l__bg1__y + l__bg1__height}',
            width: '${l__t2__width + 70}',
            height: '${l__t2__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow - oh}' },
                    '18.9%': { v: '${ow - oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '18.9%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '81.1%': { v: '${ow - oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow - oh}' }
                },
                width: {
                    '81.1%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 5,
            maxWidth: '${ow - l__self__x - 20 - oh}',
            height: '${calcSelfHeight()}',
            align: 'right',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '2%': { v: 'M${ow - oh},0h0v${l__t1__height}h0z' },
                    '96%': { v: 'M${ow - oh},0h${-ow + oh}v${l__t1__height}h${ow - oh}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M${ow - oh},0h${-ow + oh}v${l__t1__height}h${ow -oh}z' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '4%': { v: 'M${ow - oh},0h${-ow + oh}v${l__t1__height}h${ow - oh}z' },
                    '98%': { v: 'M${ow - oh},0h0v${l__t1__height}h0z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__bg2__y}',
            maxWidth: '${ow - 20 - 20 - oh}',
            height: '${oh - l__t1__height}',
            width: '${calcSelfWidth()}',
            align: 'right',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow - oh},${l__t2__y}h0v${l__t2__height}h0z' },
                    '18.9%': { v: 'M${ow - oh},${l__t2__y}h0v${l__t2__height}h0z' },
                    '100%': { v: 'M${ow - oh},${l__t2__y}h${-l__bg2__width}v${l__t2__height}h${l__bg2__width}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow - oh},${l__t2__y}h${-l__bg2__width}v${l__t2__height}h${l__bg2__width}z' },
                    '81.1%': { v: 'M${ow - oh},${l__t2__y}h0v${l__t2__height}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${ow - oh},${l__t2__y}h0v${l__t2__height}h0z' }
                }
            }
        }
    }, {
        id: 'box1',
        desc: 'Box before sub text',
        type: 'rect',
        attrs: {
            fill: '${color2}',
            x: '${l__bg2__x}',
            y: '${l__bg2__y}',
            width: 0,
            height: '${l__bg2__height}',
            alpha: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow - oh}' },
                    '18.9%': { v: '${ow - oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '18.9%': { v: 40 },
                    '45%': { v: 60 },
                    '100%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '81.1%': { v: '${ow - oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow - oh}' }
                },
                width: {
                    '55%': { v: 60, ease: 'easeinout' },
                    '81.1%': { v: 40 },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: '${l__bg1__x + l__bg1__width}',
            width: 250,
            height: 250,
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '30%': { v: '${oh}' },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '50%': {},
                    '80%': { v: '${oh}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJ0PRafPf',
    desc: '4 lines + 2 text + placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        alpha: 1,
        text1: 'HOOLI',
        text2: 'BETTER PLACE',
        color1: '#f00',
        color2: '#0f0',
        textColor1: '#ff0',
        textColor2: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: true,
        lineHeight1: 1.4,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        'oh': '${l__bgi1__height}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Main text background',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            width: '${ow - oh - 20}',
            height: '${l__t1__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                height: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__bg1__height}', ease: 'easyEaseInOutReverse' }
                },
                height: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 0,
            maxWidth: '${ow - l__self__x - 20 - oh - 20}',
            height: '${calcSelfHeight()}',
            align: 'right',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            clipPath: 'M0,0h${ow}v${l__t1__height}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__t1__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'bg2',
        desc: 'Bottom text background',
        type: 'rect',
        attrs: {
            x: '${ow - oh - 20 - l__t2__width - 50 }',
            y: '${l__t2__y - 10}',
            width: '${l__t2__width + 50}',
            height: '${l__t2__height + 20}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                height: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                },
                height: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 30,
            y: '${l__t1__y + l__t1__height + 30}',
            maxWidth: '${ow - l__self__x - 30 - oh - 20}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'right',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1,
            clipPath: 'M${l__bg2__x},${l__bg2__y}h${l__bg2__width}v${l__bg2__height}h${-l__bg2__width}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg2__y + l__bg2__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__bg2__y + l__bg2__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'ltb',
        desc: 'Line along left side going from top to bottom',
        type: 'path',
        attrs: {
            d: 'M-20,-300V${oh + 300}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'llr',
        desc: 'Line along top side going from left to right',
        type: 'path',
        attrs: {
            d: 'M-300,-20H${ow + 300}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'lbt',
        desc: 'Line along right side going from bottom to top',
        type: 'path',
        attrs: {
            d: 'M${ow+20},${oh + 300}V-300',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'lrl',
        desc: 'Line along bottom of main text going from right to left',
        type: 'path',
        attrs: {
            d: 'M${ow + 300},${l__bg1__y + l__bg1__height + 20}H-300',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'bgi1',
        desc: 'Placeholder Background',
        type: 'rect',
        attrs: {
            x: '${l__bg1__x + l__bg1__width + 20}',
            width: 250,
            height: 250,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: '${l__bg1__x + l__bg1__width + 20 + 10}',
            y: 10,
            width: '${oh-20}',
            height: '${oh-20}',
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { v: '${oh}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJvsIJXDG',
    desc: 'title with central placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        text2: 'MCI',
        color1: '#f00',
        textColor1: '#ff0',
        textColor2: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        'oh': '${l__bgi1__rx * 2}'
    },
    layers: [{
        id: 'lul',
        desc: 'left upper line',
        type: 'path',
        attrs: {
            d: 'M0,${oh/4}H${(ow - oh)/2 - 10}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            fillAlpha: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimStart: {
                    '0%': { v: 100 },
                    '30%': { v: 100 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '50%': { v: 100, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 100, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'lll',
        desc: 'Left lower line',
        type: 'path',
        attrs: {
            d: 'M0,${oh*3/4}H${(ow - oh)/2 - 10}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeTrimStart: {
                    '0%': { v: 100 },
                    '30%': { v: 100 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '50%': { v: 100, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 100, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'rul',
        desc: 'right upper line',
        type: 'path',
        attrs: {
            d: 'M${(ow+oh)/2 + 10},${oh/4}H${ow}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '50%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'rll',
        desc: 'right lower line',
        type: 'path',
        attrs: {
            d: 'M${(ow+oh)/2 + 10},${oh*3/4}H${ow}',
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '30%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '50%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Left Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            y: '${oh / 4}',
            width: '${calcSelfWidth()}',
            maxWidth: '${(ow - oh)/2 - l__self__x - 20 }',
            height: '${oh/2}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1,
            clipPath: 'M10,${oh / 4}H${(ow-oh)/2 - 10}v${l__t1__height}H10z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${(ow-oh)/2 - 10},${oh / 4}H${(ow-oh)/2 - 10}v${l__t1__height}H${(ow-oh)/2 - 10}z' },
                    '30%': { v: 'M${(ow-oh)/2 - 10},${oh / 4}H${(ow-oh)/2 - 10}v${l__t1__height}H${(ow-oh)/2 - 10}z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': { ease: 'easyEaseInOut' },
                    '50%': { v: 'M${(ow-oh)/2 - 10},${oh / 4}H${(ow-oh)/2 - 10}v${l__t1__height}H${(ow-oh)/2 - 10}z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${(ow-oh)/2 - 10},${oh / 4}H${(ow-oh)/2 - 10}v${l__t1__height}H${(ow-oh)/2 - 10}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Right Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${(ow + oh)/2 + 20}',
            y: '${oh / 4}',
            maxWidth: '${(ow - oh)/2 - 20 }',
            height: '${oh/2}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1,
            maxLines: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            clipPath: 'M${(ow + oh)/2 + 20},${oh / 4}H${ow - 10}v${l__t2__height}H${(ow + oh)/2 + 20}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${(ow+oh)/2 + 20},${oh / 4}H${(ow+oh)/2 + 20}v${l__t2__height}H${(ow+oh)/2 + 20}z' },
                    '30%': { v: 'M${(ow+oh)/2 + 20},${oh / 4}H${(ow+oh)/2 + 20}v${l__t2__height}H${(ow+oh)/2 + 20}z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': { ease: 'easyEaseInOut' },
                    '50%': { v: 'M${(ow+oh)/2 + 20},${oh / 4}H${(ow+oh)/2 + 20}v${l__t2__height}H${(ow+oh)/2 + 20}z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${(ow+oh)/2 + 20},${oh / 4}H${(ow+oh)/2 + 20}v${l__t2__height}H${(ow+oh)/2 + 20}z', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'bgi1',
        desc: 'Placeholder Background',
        type: 'ellipse',
        attrs: {
            cx: '${ow/2}',
            cy: '${oh/2}',
            rx: 125,
            ry: 125,
            fill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${l__bgi1__cx}, ${l__bgi1__cy})' },
                    '32%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '50%': {},
                    '100%': { v: 'scale(0, 0, ${l__bgi1__cx}, ${l__bgi1__cy})', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: '${ (ow - l__self__width)/2}',
            y: 10,
            width: '${oh-20}',
            height: '${oh-20}',
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${l__i1__x + l__i1__width/2}, ${l__i1__y + l__i1__height/2})' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '40%': {},
                    '100%': { v: 'scale(0, 0, ${l__i1__x + l__i1__width/2}, ${l__i1__y + l__i1__height/2})', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-H1rMwZ7wG',
    desc: 'trapezium border with placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        },
        placeholders: {
            'imageId': 'i1'
        }
    },
    props: {
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        'oh': 150
    },
    layers: [{
        id: 'b1',
        desc: 'left box',
        type: 'path',
        attrs: {
            d: 'M20,0H${oh + 20}l-20,${oh}H0z',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${ow}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '-${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '-${ow}', ease: 'easyEaseInOutReverse' }
                },
                alpha: {
                    '0%': {},
                    '20%': {},
                    '70%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'b1s',
        desc: 'left box',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M20,0H${oh + 20}l-20,${oh}H0z',
            fillAlpha: 1,
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${ow}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '-${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '-${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'right box',
        type: 'path',
        attrs: {
            d: 'M${oh + 20 + 10},0H${ow}l-20,${oh}H${oh + 10}z',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 6,
            strokeAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}', ease: 'easyEaseInOutReverse' }
                },
                alpha: {
                    '0%': {},
                    '10%': {},
                    '70%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'b2s',
        desc: 'right box shy',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M${oh + 20 + 10},0H${ow}l-20,${oh}H${oh + 10}z',
            fillAlpha: 1,
            fill: '${color1}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        meta: {
            masks: [{ mLayerId: 'b2s' }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 20 + 20}',
            y: '${(oh - calcSelfHeight())/2}',
            width: '${calcSelfWidth()}',
            maxWidth: '${ow - l__self__x }',
            height: '${oh}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            maxLines: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            clipPath: 'M${oh + 20 + 20},${(oh - calcSelfHeight())/2}H${ow}V${oh}H${oh + 20 + 20}z'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '-${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '-${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        meta: {
            masks: [{ mLayerId: 'b1s' }]
        },
        attrs: {
            imageId: '${imageId}',
            x: 20,
            y: 10,
            width: '${oh-20}',
            height: '${oh-20}',
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: false,
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByTiDzPTf',
    desc: 'CNN-1',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: true
    },
    precalc: {
        'oh': '${l__t1__height+20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 20,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height}h${ow}v${oh - l__l1__height}h${-ow}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t1__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ - l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding upper line',
        type: 'path',
        attrs: {
            d: 'M0,10H${ow}',
            stroke: '#fff',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }

            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Top line',
        type: 'rect',
        attrs: {
            width: 150,
            height: 20,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-S1L4fmPpz',
    desc: 'CNN-2',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        text2: 'text',
        textColor2: 'textColor',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow',
        fontSize1: 'fontSize',
        fontSize2: 'fontSize'

    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'City',
        textColor2: '#fff',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.2,
        letterSpacing2: 0,
        shadow: true,
        fontSize1: 100,
        fontSize2: 60
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height +20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: '${fontSize1}',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 20,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height}h${ow}v${l__self__height}H0z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t1__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ - l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: '${fontSize2}',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__t1__y + l__t1__height }',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height}h${ow}V${oh}h${-ow}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t2__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ - l__t2__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding upper line',
        type: 'path',
        attrs: {
            d: 'M0,10H${ow}',
            stroke: '#fff',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }

            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Top line',
        type: 'rect',
        attrs: {
            width: 150,
            height: 20,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJZNLQwpz',
    desc: 'CNN-3',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        text2: 'text',
        textColor2: 'textColor',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'City',
        textColor2: '#fff',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.2,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height +20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 20,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height}h${ow}v${l__self__height}H0z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t1__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ - l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__t1__y + l__t1__height }',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height + l__t1__height}h${ow}V${oh}h${-ow}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t2__height }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '80%': { v: '${ - l__t2__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding upper line',
        type: 'path',
        attrs: {
            d: 'M0,10H${ow}',
            stroke: '#fff',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }

            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Top line',
        type: 'rect',
        attrs: {
            width: 150,
            height: 20,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Sk6ex4wTG',
    desc: 'Travel-ixigo',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        text2: 'text',
        textColor2: 'textColor',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        align: 'left',
        text1: 'Manchester',
        color1: '#f00',
        color2: '#f00',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'City',
        textColor2: '#fff',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.2,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Top Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            x: 20,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0H${ow}v${l__self__height}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            bgAlpha: '${alpha}',
            bgFill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ ow }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '85%': { v: '${ - l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: (_attrs = {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__t1__height +10}',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__t1__height + 10}H${ow}V${oh}H0z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            bgAlpha: '${alpha}',
            bgFill: '${color2}',
            alpha: '${alpha}'
        }, _defineProperty(_attrs, 'align', '${align}'), _defineProperty(_attrs, 'shadowEnabled', '${shadow}'), _defineProperty(_attrs, 'shadowColor', "${shadow ? calcSelfShadowColor() : '#fff'}"), _defineProperty(_attrs, 'shadowAlpha', '${l__self__alpha}'), _attrs),
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ ow }' },
                    '55%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ - l__t2__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-H1ZX7XOTM',
    desc: 'Ingredients-Tasty',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        text2: 'text',
        textColor2: 'textColor',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        align: 'left',
        text1: 'Manchester',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'City',
        textColor2: '#fff',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.2,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Top Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            x: 0,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: (_attrs2 = {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__t1__height}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}'
        }, _defineProperty(_attrs2, 'align', '${align}'), _defineProperty(_attrs2, 'shadowEnabled', '${shadow}'), _defineProperty(_attrs2, 'shadowColor', "${shadow ? calcSelfShadowColor() : '#fff'}"), _defineProperty(_attrs2, 'shadowAlpha', '${l__self__alpha}'), _attrs2),
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-BkjjFQdpG',
    desc: 'BuzzFeed - Caption',
    meta: {
        canOverrideAnimation: true,
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        color2: 'color',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color1: '#FFF',
        color2: '#FF0000',
        text1: 'Manchester',
        textColor1: '#F00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: false
    },
    precalc: {
        'oh': '${l__t1__height + 40}'
    },
    layers: [{
        id: 'b1',
        desc: 'Solid background',
        type: 'path',
        attrs: (_attrs3 = {
            d: 'M0,0h${ow}v${oh}h${-ow}z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            shadowEnabled: false,
            strokeWidth: 20,
            strokeAlpha: 1
        }, _defineProperty(_attrs3, 'alpha', '${alpha}'), _defineProperty(_attrs3, 'stroke', '${color2}'), _attrs3),
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            x: 30,
            y: 20,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-S1dSCmuTM',
    desc: 'Music - Intro',
    meta: {
        canOverrideAnimation: true,
        variableLineHeight: true,
        variableLineHeightProp: 'lineHeight1',
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color1: '#FFF',
        text1: 'Manchester',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 'b1',
        desc: 'Solid background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 't1',
                mAlphaInv: true
            }]
        },
        attrs: _defineProperty({
            d: 'M0,0h${ow}v${oh}h${-ow}z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            shadowEnabled: false
        }, 'alpha', '${alpha}'),
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text',
        type: 'text',
        meta: {
            shy: true
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            //fill : '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-SJlAzSOTM',
    desc: 'simple multi-color template with variable line height',
    meta: {
        autoHeight: true,
        variableLineHeight: true,
        variableLineHeightProp: 'lineHeight',
        canOverrideAnimation: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        color1: '#fff',
        textColor1: '#fff',
        alpha: 1,
        align: 'center',
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 'b1',
        desc: 'Solid background',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}v${oh}h${-ow}z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: '${align}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-SJaMb8dTM',
    desc: 'Tasty - outro',
    meta: {
        variableLineSpacing: true,
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        alpha: 1,
        align: 'left',
        color1: '#FFF',
        color2: '#FF0',
        textColor1: '#000',
        text1: 'Finally,\nYour own tasty kitchen',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        lineSpacing: 50
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 'b1',
        desc: 'Solid background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 't1m2',
                mAlphaInv: false
            }]
        },
        attrs: _defineProperty({
            d: 'M0,0h${ow}v${oh}h${-ow}z',
            fillAlpha: 1,
            fill: '${color2}',
            alpha: '${alpha}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            shadowEnabled: false
        }, 'alpha', '${alpha}'),
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'b2',
        desc: 'Solid background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 't1m1',
                mAlphaInv: false
            }]
        },
        attrs: _defineProperty({
            d: 'M0,0h${ow}v${oh}h${-ow}z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            shadowEnabled: false
        }, 'alpha', '${alpha}'),
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1m1',
        desc: 'Text',
        type: 'text',
        meta: {
            shy: true
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            bgFill: '${color1}',
            bgAlpha: '${alpha}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t1__height }' },
                    '44%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '85%': { v: '${ - l__t1__height }' }
                }
            }
        }
    }, {
        id: 't1m2',
        desc: 'Text',
        type: 'text',
        meta: {
            shy: true
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineSpacing: '${lineSpacing}',
            x: 20,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            bgFill: '${color1}',
            bgAlpha: '${alpha}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t1__height }' },
                    '30%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': { v: '${ - l__t1__height }' },
                    '100%': { v: '${ - l__t1__height }' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'b2',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '5%': { v: '${ - l__t1__height }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '75%': { v: '${ - l__t1__height }' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HkCKkduaG',
    desc: 'Creative design',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color1: '#FFF',
        textColor1: '#FFF',
        text1: 'Creative\nDesign',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0
    },
    precalc: {
        'oh': '${l__t1__height+40}'
    },
    layers: [{
        id: 't1',
        desc: 'Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 40,
            y: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-80}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '5%': { v: '${ oh }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '60%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Line Borders',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 15,
            strokeAlpha: '${alpha}',
            clipPath: 'M-30,${oh-60}H60V${oh+30}H-30V${oh-60}M${ow+30},-30V60H${ow-60}V-30z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${oh}H0V${oh}H0V${oh}M${ow},0V0H${ow}V0z' },
                    '20%': { v: 'M0,${oh}H0V${oh}H0V${oh}M${ow},0V0H${ow}V0z' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: 'M0,${oh}H0V${oh}H0V${oh}M${ow},0V0H${ow}V0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Skez5udaz',
    desc: 'BBC - Title',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color1: '#FFF',
        textColor1: '#FFF',
        textColor2: '#FFF',
        text1: 'Macron Vs. Merkel',
        text2: 'Different dynamics with Tru',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 30,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M30,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '5%': { v: '${ l__t1__height }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '60%': { v: '${ l__t1__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 30,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '10%': { v: '${ l__t1__height + l__t1__y + l__t2__height }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '70%': { v: '${ l__t1__height + l__t1__y + l__t2__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Left Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M0,0H10V${oh}H0z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh-20}' },
                    '20%': { v: '${-oh-20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${oh+20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'Right Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M${ow-10},0H${ow}V${oh}H${ow-10}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh+20}' },
                    '20%': { v: '${oh+20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${-oh-20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-S1kIZYdTM',
    desc: 'BBC - Title',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color1: '#FFF',
        textColor1: '#FFF',
        textColor2: '#FFF',
        text1: 'Macron Vs. Merkel',
        text2: 'Different dynamics with Tru',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 60,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M30,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60-20}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '5%': { v: '${ l__t1__height }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '60%': { v: '${ -l__t1__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 60,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60-20}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '10%': { v: '${ l__t1__height + l__t1__y + l__t2__height }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '70%': { v: '${ - l__t2__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Left Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M0,0H10V${oh}H0z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh-20}' },
                    '20%': { v: '${-oh-20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${oh+20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-H1e1GtOaf',
    desc: 'BBC - Title',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1'
        },
        textColors: {
            'text1': 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color1: '#FFF',
        textColor1: '#FFF',
        text1: 'Macron Vs. Merkel',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        shadow: false
    },
    precalc: {
        'oh': '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 60,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M30,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-120}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ l__t1__height }' },
                    '5%': { v: '${ l__t1__height }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '60%': { v: '${ l__t1__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Left Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M0,0H10V${oh}H0z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh-20}' },
                    '20%': { v: '${-oh-20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${oh+20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'Right Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M${ow-10},0H${ow}V${oh}H${ow-10}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh+20}' },
                    '20%': { v: '${oh+20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${-oh-20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJyH4cdTG',
    desc: 'AJ+ credits',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        color2: '#FFF',
        color3: '#FF0',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 60,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            bgFill: '${color1}',
            bgAlpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ oh }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '70%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Moving fade',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 't1',
                mAlphaInv: false
            }]
        },
        attrs: {
            fillAlpha: 1,
            x: '${ow}',
            width: '${l__t1__height}',
            height: '${l__t1__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0H${l__t1__width}V${l__t1__height}H0z'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ -l__t1__height }' },
                    '30%': { v: '${ -l__t1__height }' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 40,
            y: '${l__t1__height + l__t1__y + 20}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ oh }' },
                    '20%': { v: '${ oh }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '60%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HJkwwcuTM',
    desc: 'AJ+ - News 2',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        color2: '#FFF',
        color3: '#FF0',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 'b1',
        desc: 'Moving fade',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 0,
            y: '${l__t1__height}',
            width: '${ow}',
            height: '10',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '0%': {},
                    '60%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0H${ow}V${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ oh }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': {},
                    '70%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 20,
            y: '${l__t1__height + l__t1__y + 10}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t2__height }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': {},
                    '60%': { v: '${ -l__t2__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJYdu5OpM',
    desc: 'AJ+ - News 3',
    meta: {
        autoHeight: true,
        textEditors: {
            'text1': 't1',
            'text2': 't2'
        },
        textColors: {
            'text1': 'textColor1',
            'text2': 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        align: 'align'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        color2: '#FFF',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        align: 'left'
    },
    precalc: {
        'oh': '${l__t1__height + l__t2__height }'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0H${ow}V${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false',
            bgFill: '${color1}',
            bgAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ oh }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': {},
                    '70%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 20,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: '${align}',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false',
            bgFill: '${color2}',
            bgAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ - l__t2__height }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': {},
                    '60%': { v: '${ -l__t2__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});
exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77,"./data-bodymovin-jsons":51}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _attrs, _alpha, _alpha2, _alpha3, _alpha4, _attrs2;

var _GeneralUtils = require('../utils/GeneralUtils');

var _dataSvgs = require('./data-svgs');

var _dataSvgs2 = _interopRequireDefault(_dataSvgs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var defs = [];

defs.push({
    id: 'defId-HyzdqtOaM',
    desc: 'NowThis - News',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        color3: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        color2: '#FFF',
        color3: '#FF0',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Macron',
        text2: 'Different dynamics',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 55}'
    },
    layers: [{
        id: 'b1',
        desc: 'Top text Backgroudn',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 5,
            y: 5,
            width: '${l__t1__width + 60}',
            height: '${l__t1__height + 10}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            stroke: '${color3}',
            fill: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ -ow }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '90%': { v: '${ -ow }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 30,
            y: 5,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ -ow }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '90%': { v: '${ -ow }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'Bottom text Border',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 5,
            y: '${l__t2__y - 5}',
            width: '${l__t2__width + 60}',
            height: '${l__t2__height + 10}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            stroke: '${color3}',
            fill: '${color2}',
            strokeWidth: 10,
            strokeAlpha: 1,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ -ow }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '${ -ow }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 30,
            y: '${l__t1__height + l__t1__y + 20 + 20}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ -ow }' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%%': { v: '${ -ow }', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJeZQSc3z',
    desc: 'Line by line animation with fade in/out',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        enterTextAnimType: 'enterTextAnimType',
        exitTextAnimType: 'exitTextAnimType'
    },
    defaults: {
        textColor1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        enterTextAnimType: 'none',
        exitTextAnimType: 'none'
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            enterTextAnim: 'line',
            exitTextAnim: 'line',
            visibleLineFactor: 1,
            enterTextAnimType: '${enterTextAnimType}',
            exitTextAnimType: '${exitTextAnimType}'
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                visibleLineFactor: {
                    '0%': {},
                    '100%': { v: 0, ease: 'linear' }
                }
            }
        }
    }]
});

// Type writer effect
defs.push({
    id: 'defId-B16boBqnz',
    desc: 'Character by character animation like a typewriter',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        enterTextAnimType: 'enterTextAnimType',
        exitTextAnimType: 'exitTextAnimType'
    },
    defaults: {
        textColor1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        enterTextAnimType: 'none',
        exitTextAnimType: 'none'
    },
    precalc: {
        oh: '${l__t1__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 10,
            y: 10,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 20}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            enterTextAnim: 'char',
            exitTextAnim: 'char',
            visibleLineFactor: 1,
            enterTextAnimType: '${enterTextAnimType}',
            exitTextAnimType: '${exitTextAnimType}'
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                visibleLineFactor: {
                    '0%': {},
                    '100%': { v: 0, ease: 'linear' }
                }
            }
        }
    }]
});

// Character by character animation with border
defs.push({
    id: 'defId-B1a8SpFnz',
    desc: 'Character by character animation with border',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        enterTextAnimType: 'enterTextAnimType',
        exitTextAnimType: 'exitTextAnimType'
    },
    defaults: {
        textColor1: '#fff',
        color1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        enterTextAnimType: 'none',
        exitTextAnimType: 'none'
    },
    precalc: {
        oh: '${l__t1__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 10,
            y: 10,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: 0,
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 20}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            enterTextAnim: 'char',
            exitTextAnim: 'char',
            visibleLineFactor: 1,
            enterTextAnimType: '${enterTextAnimType}',
            exitTextAnimType: '${exitTextAnimType}'
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                visibleLineFactor: {
                    '0%': {},
                    '100%': { v: 0, ease: 'linear' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'border',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H0z',
            stroke: '${color1}',
            strokeCap: 'round',
            strokeWidth: 10,
            strokeAlpha: '${alpha}',
            fillAlpha: 0,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '10%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '22%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-SJ8DyFtTG',
    desc: 'Wedding title',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: 'false'
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 20 }'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            y: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,${l__self__y}H${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': {},
                    '100%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'io',
        desc: 'Inner outline',
        type: 'path',
        attrs: {
            d: 'M${ow/2 + l__t2__width/2+20},${l__t2__y+l__t2__height/2 - 5}H${ow-10}V10H12V${l__t2__y+l__t2__height/2 - 5}H${ow/2 - l__t2__width/2 - 20}',
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: '${alpha}',
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '28%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 'oo',
        desc: 'Outer outline',
        type: 'path',
        attrs: {
            d: 'M${ow/2 + l__t2__width/2+20},${l__t2__y+l__t2__height/2 + 5}H${ow}V0H0V${l__t2__y+l__t2__height/2 + 5}H${ow/2 - l__t2__width/2 - 20}',
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: '${alpha}',
            fillAlpha: 0
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '64%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '28%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 20,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '20%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '10%': {},
                    '100%': { v: '${ -l__t2__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rymfKKY6f',
    desc: 'Wedding outrow',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height }'
    },
    layers: [{
        id: 't1',
        desc: 'Top Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 60,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,${l__self__y}H${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: (_attrs = {
            fontFamily: '${fontFamily2}',
            x: 20,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false',
            alpha: '${alpha}'
        }, _defineProperty(_attrs, 'shadowEnabled', '${shadow}'), _defineProperty(_attrs, 'shadowColor', "${shadow ? calcSelfShadowColor() : '#fff'}"), _defineProperty(_attrs, 'shadowAlpha', '${alpha}'), _defineProperty(_attrs, 'shadowOffsetX', 2), _defineProperty(_attrs, 'shadowOffsetY', 2), _defineProperty(_attrs, 'shadowBlur', 6), _attrs),
        animation: {
            enterkeyframes: {
                alpha: {
                    '40%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Sk8i6tKaf',
    desc: 'CNN-4',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: true
    },
    precalc: {
        oh: '${l__t1__height+25}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            maxWidth: '${ow-20}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh - 21}h${-ow}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ l__t1__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding lower line',
        type: 'path',
        attrs: {
            d: 'M20,${l__t1__height+l__t1__y + 11}H${ow}',
            stroke: '#fff',
            strokeWidth: 18,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Bottom line',
        type: 'path',
        attrs: {
            d: 'M10,${l__t1__height+l__t1__y + 11}H${ow}',
            strokeWidth: 18,
            strokeAlpha: 1,
            width: 150,
            stroke: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                width: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByH2G9Faf',
    desc: 'CNN-5',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: true
    },
    precalc: {
        oh: '${l__t1__height+20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            y: 20,
            maxWidth: '${ow-20}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__l1__height}h${ow}v${oh - l__l1__height}h${-ow}z',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ -l__t1__height }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ -l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding right line',
        type: 'path',
        attrs: {
            d: 'M${ow/2},10H${ow}',
            stroke: '#fff',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l3',
        desc: 'sliding left line',
        type: 'path',
        attrs: {
            d: 'M${ow/2},10H0',
            stroke: '#fff',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '58.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '62.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '78.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '84.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Bottom line',
        type: 'rect',
        attrs: {
            width: 150,
            height: 20,
            x: '${ow/2 - 75}',
            clipPath: 'M${ow/2},0h75v20h-150V0z',
            y: 0,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2},0h0v20h0V0z' },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '70%': {},
                    '100%': { v: 'M${ow/2},0h0v20h0V0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rk0585FTG',
    desc: 'CNN Branded',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        text1: 'text',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        alpha: 1,
        text1: 'HOOLI',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        letterSpacing1: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        oh: '${l__t1__height + l__i1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__i1__height}',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            clipPath: 'M0,200H${ow}v${l__t1__height}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${-l__t1__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1m',
        desc: 'placeholder layer mask',
        type: 'rect',
        meta: {
            shy: true
        },
        attrs: {
            x: '${ow/2 - l__self__width/2}',
            y: 0,
            width: 200,
            height: 200,
            fill: '#F00',
            shadowEnabled: 'false',
            clipPath: 'M0,0H${ow}v200H0z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        meta: {
            masks: [{
                mLayerId: 'i1m',
                mAlphaInv: false
            }]
        },
        attrs: {
            imageId: '${imageId}',
            x: '${ow/2 - l__self__width/2}',
            y: 0,
            width: 200,
            height: 200,
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJ6qlstTz',
    desc: 'Interview - 1',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        text2: 'text',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'HOOLI',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        text2: 'HOOLI',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        letterSpacing1: 0,
        lineHeight2: 1.4,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        oh: '${l__i1__height + 40}'
    },
    layers: [{
        id: 'io3',
        desc: 'Inner outline',
        type: 'path',
        attrs: {
            d: 'M20,${oh}H${oh+10}V0',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0,
            strokeTrimStart: 50,
            strokeTrimEnd: 100
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                },
                strokeTrimStart: {
                    '0%': {},
                    '60%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 30}',
            y: 0,
            maxWidth: '${ow - oh - 50}',
            height: '${oh*5/8}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh + 30},0H${ow}v${l__t1__height}H${oh + 30}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-l__t1__width}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '70%': { v: '${-l__t1__width}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 30}',
            y: '${l__t1__height}',
            maxWidth: '${ow - oh - 50}',
            height: '${oh*3/8}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh + 30},${l__self__y}H${ow}V${oh}H${oh + 30}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-l__t2__width}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '70%': { v: '${-l__t2__width}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1m',
        desc: 'placeholder layer mask',
        type: 'rect',
        meta: { shy: true },
        attrs: {
            x: '${l__i1__x}',
            y: '${l__i1__y}',
            width: '${l__i1__width}',
            height: '${l__i1__height}',
            fill: '#F00',
            shadowEnabled: 'false',
            clipPath: 'M0,0H${oh}v${oh}H0z'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${oh + 10}' },
                    '10%': { v: '${oh + 10}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '70%': { v: '${oh+20}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        meta: {
            masks: [{
                mLayerId: 'i1m',
                mAlphaInv: false
            }]
        },
        attrs: {
            imageId: '${imageId}',
            x: 20,
            y: 20,
            width: 210,
            height: 210,
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${oh}' },
                    '10%': { v: '${oh}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '70%': { v: '${oh+20}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-S1ahpaYaf',
    desc: 'NowThis-Credits',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        text2: 'text',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'HOO\nLI',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        text2: 'HOOLI',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        letterSpacing1: 0,
        lineHeight2: 1.4,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        oh: '${l__i1__height + max(l__t1__height, l__t2__height) +  20}'
    },
    layers: [{
        id: 'l1',
        desc: 'divider line',
        type: 'path',
        attrs: {
            d: 'M0,${l__i1__height + 10}H${ow}',
            stroke: '${color1}',
            strokeWidth: 10,
            strokeAlpha: 1,
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                },
                strokeTrimStart: {
                    '0%': {},
                    '60%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            y: '${l__i1__height + 20}',
            maxWidth: '${ow/2 - 20}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            enterTextAnim: 'line',
            visibleLineFactor: 1
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '10%': { v: 0 },
                    '60%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '70%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${ow/2 + 10}',
            y: '${l__i1__height + 20}',
            maxWidth: '${ow/2 - 20}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'right',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            enterTextAnim: 'line',
            visibleLineFactor: 1
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '10%': { v: 0 },
                    '60%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '70%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: 20,
            y: 0,
            width: 100,
            height: 100,
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '10%': { v: 0 },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '70%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJaRpRt6M',
    desc: 'NowThis-LowerThird',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'HOOasdsadasdsadfasdfsadfsadf\nLI',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        letterSpacing1: 0
    },
    precalc: {
        oh: '${l__l1__height + l__t1__height  + 40}'
    },
    layers: [{
        id: 'l1',
        desc: 'Top box',
        type: 'rect',
        attrs: {
            width: 80,
            height: 80,
            x: 0,
            y: 0,
            fill: '${color1}',
            alpha: '${alpha}',
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeWidth: 10,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '0%': { v: 0 },
                    '15%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                height: {
                    '85%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'Text box',
        type: 'rect',
        attrs: {
            width: '${l__t1__width + 60 }',
            height: '${l__t1__height + 40 }',
            x: 0,
            y: '${l__l1__height}',
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            fillAlpha: 0,
            strokeWidth: 10,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                height: {
                    '0%': { v: 0 },
                    '15%': { v: 0 },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '15%': { v: 0 },
                    '16%': { v: '${l__l1__width }' },
                    '50%': { v: '${l__l1__width }' },
                    '70%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                height: {
                    '0%': {},
                    '65%': {},
                    '85%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                width: {
                    '0%': {},
                    '30%': {},
                    '65%': { v: '${l__l1__width}', ease: 'easyEaseInOutReverse' },
                    '85%': { v: '${l__l1__width}', ease: 'easyEaseInOutReverse' },
                    '86%': { v: 0 },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 30,
            y: '${l__l1__height + 20}',
            maxWidth: '${ow - 60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            enterTextAnim: 'line',
            visibleLineFactor: 1,
            enterTextAnimType: 'fade'
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '60%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '50%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-S19Sibj6f',
    desc: 'NowThis-Quotes',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: '-Hooli',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height  + 70}'
    },
    layers: [{
        id: 'l1',
        desc: 'border',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}V${oh}H100l-50,40V${oh}H0z',
            stroke: '${color1}',
            strokeCap: 'round',
            strokeWidth: 10,
            strokeAlpha: '${alpha}',
            fillAlpha: 0,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeRangeProps: {
                    '0%': {},
                    '12%': {},
                    '100%': {
                        v: {
                            strokeRangeStart: '0',
                            strokeRangeEnd: '0'
                        },
                        ease: 'easyEaseInOutReverse'
                    }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 40,
            y: 10,
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            enterTextAnim: 'char',
            visibleLineFactor: 1,
            enterTextAnimType: 'fade',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '10%': { v: 0 },
                    '85%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${l__t1__y + l__t1__height + 20}',
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            enterTextAnim: 'char',
            visibleLineFactor: 1,
            enterTextAnimType: 'fade',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '90%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJmIeXoTM-ig',
    desc: 'Social Media - instagram',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__s1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 0,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},0H${ow}V${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: '${oh - l__self__height-20}',
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},${l__self__y}H${ow}v${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                },
                alpha: (_alpha = {
                    '0%': {},
                    '72%': {},
                    '74%': { v: 0, ease: 'linear' },
                    '76%': { ease: 'linear' },
                    '78%': { v: 0, ease: 'linear' },
                    '80%': { ease: 'linear' }
                }, _defineProperty(_alpha, '78%', { v: 0, ease: 'linear' }), _defineProperty(_alpha, '80%', { ease: 'linear' }), _defineProperty(_alpha, '82%', { v: 0, ease: 'linear' }), _defineProperty(_alpha, '84%', { ease: 'linear' }), _defineProperty(_alpha, '86%', { v: 0, ease: 'linear' }), _defineProperty(_alpha, '88%', { ease: 'linear' }), _defineProperty(_alpha, '90%', { v: 0, ease: 'linear' }), _defineProperty(_alpha, '92%', { ease: 'linear' }), _defineProperty(_alpha, '94%', { v: 0, ease: 'linear' }), _defineProperty(_alpha, '96%', { ease: 'linear' }), _alpha)
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Instagram icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Instagram_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: 200,
            height: 200,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '80%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M${oh+10},0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': { ease: 'easyEaseInOut' },
                    '80%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${-oh}', ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow-20},0h10V${oh}h-10' },
                    '40%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJmIeXoTM-fb',
    desc: 'Social Media - facebook',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__s1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 0,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},0H${ow}V${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: '${oh - l__self__height-20}',
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},${l__self__y}H${ow}v${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                },
                alpha: (_alpha2 = {
                    '0%': {},
                    '72%': {},
                    '74%': { v: 0, ease: 'linear' },
                    '76%': { ease: 'linear' },
                    '78%': { v: 0, ease: 'linear' },
                    '80%': { ease: 'linear' }
                }, _defineProperty(_alpha2, '78%', { v: 0, ease: 'linear' }), _defineProperty(_alpha2, '80%', { ease: 'linear' }), _defineProperty(_alpha2, '82%', { v: 0, ease: 'linear' }), _defineProperty(_alpha2, '84%', { ease: 'linear' }), _defineProperty(_alpha2, '86%', { v: 0, ease: 'linear' }), _defineProperty(_alpha2, '88%', { ease: 'linear' }), _defineProperty(_alpha2, '90%', { v: 0, ease: 'linear' }), _defineProperty(_alpha2, '92%', { ease: 'linear' }), _defineProperty(_alpha2, '94%', { v: 0, ease: 'linear' }), _defineProperty(_alpha2, '96%', { ease: 'linear' }), _alpha2)
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Facebook icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_3_Facebook_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: 200,
            height: 200,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '80%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M${oh+10},0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': { ease: 'easyEaseInOut' },
                    '80%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${-oh}', ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow-20},0h10V${oh}h-10' },
                    '40%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJmIeXoTM-tw',
    desc: 'Social Media',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__s1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 0,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},0H${ow}V${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: '${oh - l__self__height-20}',
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},${l__self__y}H${ow}v${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                },
                alpha: (_alpha3 = {
                    '0%': {},
                    '72%': {},
                    '74%': { v: 0, ease: 'linear' },
                    '76%': { ease: 'linear' },
                    '78%': { v: 0, ease: 'linear' },
                    '80%': { ease: 'linear' }
                }, _defineProperty(_alpha3, '78%', { v: 0, ease: 'linear' }), _defineProperty(_alpha3, '80%', { ease: 'linear' }), _defineProperty(_alpha3, '82%', { v: 0, ease: 'linear' }), _defineProperty(_alpha3, '84%', { ease: 'linear' }), _defineProperty(_alpha3, '86%', { v: 0, ease: 'linear' }), _defineProperty(_alpha3, '88%', { ease: 'linear' }), _defineProperty(_alpha3, '90%', { v: 0, ease: 'linear' }), _defineProperty(_alpha3, '92%', { ease: 'linear' }), _defineProperty(_alpha3, '94%', { v: 0, ease: 'linear' }), _defineProperty(_alpha3, '96%', { ease: 'linear' }), _alpha3)
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Twitter icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_3_Twitter_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: 200,
            height: 200,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '80%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M${oh+10},0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': { ease: 'easyEaseInOut' },
                    '80%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${-oh}', ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow-20},0h10V${oh}h-10' },
                    '40%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJmIeXoTM-yt',
    desc: 'Social Media - instagram',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__s1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 0,
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},0H${ow}V${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},0H0V${l__t1__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 40,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: '${oh - l__self__height-20}',
            maxWidth: '${ow - oh - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M${oh+40},${l__self__y}H${ow}v${l__self__height}H${oh+40}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '40%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z' },
                    '80%': { ease: 'easyEaseInOut' }
                },
                alpha: (_alpha4 = {
                    '0%': {},
                    '72%': {},
                    '74%': { v: 0, ease: 'linear' },
                    '76%': { ease: 'linear' },
                    '78%': { v: 0, ease: 'linear' },
                    '80%': { ease: 'linear' }
                }, _defineProperty(_alpha4, '78%', { v: 0, ease: 'linear' }), _defineProperty(_alpha4, '80%', { ease: 'linear' }), _defineProperty(_alpha4, '82%', { v: 0, ease: 'linear' }), _defineProperty(_alpha4, '84%', { ease: 'linear' }), _defineProperty(_alpha4, '86%', { v: 0, ease: 'linear' }), _defineProperty(_alpha4, '88%', { ease: 'linear' }), _defineProperty(_alpha4, '90%', { v: 0, ease: 'linear' }), _defineProperty(_alpha4, '92%', { ease: 'linear' }), _defineProperty(_alpha4, '94%', { v: 0, ease: 'linear' }), _defineProperty(_alpha4, '96%', { ease: 'linear' }), _alpha4)
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '80%': { v: 'M${oh+40},${l__t2__y}H0v${l__t2__height}H${oh+40}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Youtube icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Youtube_Icon']
        },
        attrs: {
            x: 0,
            y: 0,
            width: 200,
            height: 200,
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '80%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M${oh+10},0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh}' },
                    '40%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': { ease: 'easyEaseInOut' },
                    '80%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '80%': {},
                    '100%': { v: '${-oh}', ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M${ow-20},0h10V${oh}h-10' },
                    '40%': { v: 'M${ow-20},0h10V${oh}h-10', ease: 'easyEaseInOut' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-r1RIWA2Tf',
    desc: 'Fashion Steps',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: '1. Cleanse\n2. Tone\n3. Moisturize',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Title Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 0,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { v: 1, ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__t1__height}',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            enterTextAnim: 'line',
            visibleLineFactor: 1,
            enterTextAnimType: 'fromRight',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-SyzmWyT6G',
    desc: 'Highlight text',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: '#FEED',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Title Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 0,
            y: 0,
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            enterTextAnim: 'line',
            visibleLineFactor: 1,
            enterTextAnimType: 'fade',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '50%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Top box',
        type: 'rect',
        attrs: {
            width: '${l__t2__width + 40}',
            height: '${l__t2__height}',
            x: '${ow/2 - l__t2__width/2 - 20}',
            y: '${l__t1__height + 10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: 0 },
                    '70%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'l1'
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__t1__height + 10}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '70%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2m',
        desc: 'Sub Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'l1',
                mAlphaInv: true
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 0,
            y: '${l__t1__height + 10}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '50%': { v: 0 },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-r1c6Bk6pf',
    desc: 'Highlight text',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: '#FEED',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Title Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            enterTextAnim: 'char',
            visibleLineFactor: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '50%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Top box',
        type: 'rect',
        attrs: {
            width: '${l__t2__width + 40}',
            height: '${l__t2__height}',
            x: 20,
            y: '${l__t1__y + l__t1__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '70%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${l__t1__height}',
            maxWidth: '${ow-40-20}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            enterTextAnim: 'char',
            visibleLineFactor: 1,
            maxLines: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '70%': { ease: 'linear' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ByILf5TTz',
    desc: 'Dont Quit Template',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: "DON'T",
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'QUIT',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 40,
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'right',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            strokeWidth: 0.1,
            strokeAlpha: 0.01
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: -1920 },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '20%': {},
                    '100%': { v: -1920, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${l__t1__y + l__t1__height}',
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: 1920 },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '20%': {},
                    '100%': { v: 1920, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rknCBip6f',
    desc: 'Software stablization Template',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: "DON'T",
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'QUIT',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 120,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            strokeWidth: 0.1,
            strokeAlpha: 0.01
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${l__t1__width/2 + 10},${l__t1__height/2})' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '50%': {},
                    '100%': { v: 'scale(0, 0, ${l__t1__width/2},${l__t1__height/2})', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${l__t1__y + l__t1__height}',
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-B1tU6ip6M',
    desc: 'AJ+ template',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        color1: '#000',
        color2: '#F00',
        textColor1: '#fff',
        alpha: 1,
        align: 'center',
        text1: 'HEewrwerwerwerewrwerwerwerL\nwerwerwerwerwerLO',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 'b1',
        desc: 'Solid background',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}v${oh}h${-ow}z',
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2},${oh/2}h0v0h0z' },
                    '40%': { v: 'M${ow/2},${oh/2}h0v0h0z' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '60%': { v: 'M${ow/2},${oh/2}h0v0h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'b1'
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text1}',
            fill: '${textColor1}',
            align: '${align}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'l1',
        desc: 'upper angle',
        type: 'path',
        attrs: {
            d: 'M-20,-30 h80 l-15,30 h-50 l-20,40 h-30 L-20,-30',
            stroke: '${color2}',
            fill: '${color2}',
            strokeWidth: 20,
            strokeAlpha: 0,
            fillAlpha: 1,
            rotate: '1'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${ow/2}, ${oh/2})' },
                    '30%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${ow/2 + 10}' },
                    '40%': { v: '${ow/2 + 10}' },
                    '70%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${oh/2 + 10}' },
                    '40%': { v: '${oh/2 + 10}' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '70%': {},
                    '100%': { v: 'scale(0, 0, ${ow/2}, ${oh/2})', ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': {},
                    '20%': {},
                    '60%': { v: '${ow/2+ 10}', ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '60%': { v: '${oh/2 +10}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'lower angle',
        type: 'path',
        attrs: (_attrs2 = {
            d: 'M${ow+20},${oh+10} h-80 l15,-30 h50 l 20,-40 h 30 L ${ow+20},${oh+10}',
            fill: '${color2}',
            strokeWidth: 20,
            strokeAlpha: 0,
            fillAlpha: 1
        }, _defineProperty(_attrs2, 'fill', '${color2}'), _defineProperty(_attrs2, 'rotate', '1'), _attrs2),
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${ow/2}, ${oh/2})' },
                    '30%': { ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': { v: '${-ow/2 - 10}' },
                    '40%': { v: '${-ow/2-10}' },
                    '70%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${-oh/2 - 10}' },
                    '40%': { v: '${-oh/2 - 10}' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '70%': {},
                    '100%': { v: 'scale(0, 0, ${ow/2}, ${oh/2})', ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': {},
                    '20%': {},
                    '60%': { v: '${-ow/2-10}', ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': {},
                    '20%': {},
                    '60%': { v: '${-oh/2-10}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Hy1sgAaaM',
    desc: 'Influencer title',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Welcome to the',
        text2: 'Different dynamics',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: 'false'
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 40}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 70,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            x: 30,
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: '0' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '90%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Bottom line',
        type: 'rect',
        attrs: {
            width: '${ow/4}',
            height: 10,
            x: '${(ow - l__self__width)/2}',
            y: '${l__t1__height + l__t1__y + 10}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false',
            clipPath: 'M${l__self__x},${l__self__y}h${ow/4}v${l__self__height}h${-ow/4}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2},0h0V${oh}h0z' },
                    '70%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '90%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 30,
            y: '${l__t1__height + l__t1__y + 40}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1,
            enterTextAnim: 'char',
            visibleLineFactor: 1
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '30%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '100%%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Sk29fATaz',
    desc: 'Lifestyle title',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        textColor1: '#F00',
        text1: 'Welcome to the',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: 'false'
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 'l1',
        desc: 'Text bg',
        type: 'rect',
        attrs: {
            width: '${ow}',
            height: '${oh}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false',
            clipPath: 'M0,0H${ow}V${oh}H0z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2},0H${ow/2}V${oh}H${ow/2}z' },
                    '100%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 70,
            x: 30,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            clipPath: 'M0,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            maxLines: 1,
            enterTextAnim: 'char',
            enterTextAnimType: 'fade',
            visibleLineFactor: 1
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '90%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJjQuCT6G',
    desc: 'TechRadar LowerThird',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        color2: '#FFF',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height }'
    },
    layers: [{
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 20,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            //clipPath : 'M0,${l__t1__height + l__t1__y}H${ow}V${oh}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false',
            bgFill: '${color2}',
            bgAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ - ow }' },
                    '30%': { v: '${ - ow }' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '20%': {},
                    '60%': { v: '${ -ow }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            //clipPath :'M0,0H${ow}V${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false',
            bgFill: '${color1}',
            bgAlpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ oh }' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '20%': {},
                    '60%': { v: '${ oh }', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJ20mJR6M',
    desc: 'Tech Title',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text2: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        textColor1: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 20 }'
    },
    layers: [{
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            x: 20,
            y: '${l__t1__height + l__t1__y}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            clipPath: 'M0,${l__t1__height + l__t1__y}H${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor1}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '80%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M0,${l__t1__height + l__t1__y}H${ow}v0H0z' },
                    '30%': { v: 'M0,${l__t1__height + l__t1__y}H${ow}v0H0z' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '50%': { v: 'M0,${l__t1__height + l__t1__y}H${ow}v0H0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        meta: { shy: true },
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 20,
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '#FFF',
            shadowEnabled: 'false',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'bgt1',
        desc: 'background',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 't1',
                mAlphaInv: true
            }]
        },
        attrs: {
            d: 'M${ow/2- l__t1__width/2 - 20},${l__t1__y}h${l__t1__width + 40}v${l__t1__height}h${-l__t1__width-40}z',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M${ow/2},${l__t1__y}h0v${l__t1__height}h0z' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '40%': {},
                    '100%': { v: 'M${ow/2},${l__t1__y}h0v${l__t1__height}h0z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Bottom line',
        type: 'rect',
        attrs: {
            width: '${ow}',
            height: 10,
            y: '${l__t2__height + l__t2__y }',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow/2},0h0V${oh}h0z' },
                    '30%': { ease: 'easeInOut' }
                },
                y: {
                    '0%': { v: '${l__t1__height + l__t1__y + 10}' },
                    '30%': { v: '${l__t1__height + l__t1__y + 10}' },
                    '80%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '40%': {},
                    '100%': { v: 'M${ow/2},0h0V${oh}h0z', ease: 'easeInOut' }
                },
                y: {
                    '0%': {},
                    '50%': { v: '${l__t1__height + l__t1__y + 10}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-r1FTllCTG',
    desc: 'Top 10s',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        color1: '#FFF',
        color2: '#FFF',
        textColor1: '#F00',
        textColor2: '#F00',
        text1: 'Producer',
        text2: 'Sarah Al-Ansari',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: 200
    },
    layers: [{
        id: 'bgt2',
        desc: 'background',
        type: 'rect',
        attrs: {
            x: '${oh/2}',
            width: '${l__t2__width + l__t2__x}',
            y: '${l__t2__y - 10}',
            height: '${l__t2__height + 20}',
            cornerRadius: 54,
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                width: {
                    '0%': { v: '0' },
                    '40%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': {}
                },
                height: {
                    '0%': { v: '0' },
                    '40%': { v: '0' },
                    '41%': {},
                    '100%': {}
                }
            },
            exitkeyframes: {
                width: {
                    '0%': {},
                    '40%': { v: '0', ease: 'easyEaseInOut' },
                    '100%': { v: '0' }
                },
                height: {
                    '0%': {},
                    '40%': {},
                    '41%': { v: '0' },
                    '100%': { v: '0' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Main Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'bgt2'
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            x: '${oh + 20}',
            y: '${(oh - l__self__height)/2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-oh-40}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: 'false',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '40%': {},
                    '100%': { v: '${-ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'cb1',
        desc: 'circle back',
        type: 'ellipse',
        attrs: {
            cx: '${oh/2}',
            cy: '${oh/2}',
            rx: '${oh/2}',
            ry: '${oh/2}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${oh/2}, ${oh/2})' },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 'scale(0, 0, ${oh/2}, ${oh/2})', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Left Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'cb1'
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            x: 10,
            y: '${(oh - l__self__height)/2}',
            fontSize: 110,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${oh-20}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${oh/2}, ${oh/2})' },
                    '10%': { v: 'scale(0, 0, ${oh/2}, ${oh/2})' },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 'scale(0, 0, ${oh/2}, ${oh/2})', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Byvrv3Rpf-ig',
    desc: 'Social Media - instagram',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 30,
            y: 0,
            maxWidth: '${ow - 60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,0H${ow}V${l__self__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__height + 50}',
            y: '${l__t1__height}',
            maxWidth: '${ow- l__t1__height  - 70 }',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,${l__t1__height}H${ow}V${oh}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Instagram icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Instagram_Icon']
        },
        attrs: {
            x: 30,
            y: '${l__t2__y}',
            width: '${l__t2__height}',
            height: '${l__t2__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow-10},0h10V${oh}h-10' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow-10},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Byvrv3Rpf-fb',
    desc: 'Social Media - facebook',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 30,
            y: 0,
            maxWidth: '${ow - 60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,0H${ow}V${l__self__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__height + 50}',
            y: '${l__t1__height}',
            maxWidth: '${ow- l__t1__height  - 70 }',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,${l__t1__height}H${ow}V${oh}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Facebook icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_3_Facebook_Icon']
        },
        attrs: {
            x: 30,
            y: '${l__t2__y}',
            width: '${l__t2__height}',
            height: '${l__t2__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow-10},0h10V${oh}h-10' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow-10},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Byvrv3Rpf-tw',
    desc: 'Social Media - twitter',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 30,
            y: 0,
            maxWidth: '${ow - 60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,0H${ow}V${l__self__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__height + 50}',
            y: '${l__t1__height}',
            maxWidth: '${ow- l__t1__height  - 70 }',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,${l__t1__height}H${ow}V${oh}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Twitter icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_3_Twitter_Icon']
        },
        attrs: {
            x: 30,
            y: '${l__t2__y}',
            width: '${l__t2__height}',
            height: '${l__t2__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow-10},0h10V${oh}h-10' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow-10},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Byvrv3Rpf-yt',
    desc: 'Social Media - youtube',
    meta: {
        autoHeight: true,
        templateType: 'social-media',
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        color1: '#FFF',
        alpha: 1,
        text1: 'Test Text\nline 2',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'FOLLOW ME',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 30,
            y: 0,
            maxWidth: '${ow - 60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,0H${ow}V${l__self__height}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},0H${ow}V${l__t1__height}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__height + 50}',
            y: '${l__t1__height}',
            maxWidth: '${ow- l__t1__height  - 70 }',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            maxLines: 1,
            clipPath: 'M0,${l__t1__height}H${ow}V${oh}H0z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow},${l__t1__height}H${ow}V${oh}H${ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Youtube icon',
        type: 'svg',
        meta: {
            svgData: _dataSvgs2.default['SMP_2_Youtube_Icon']
        },
        attrs: {
            x: 30,
            y: '${l__t2__y}',
            width: '${l__t2__height}',
            height: '${l__t2__height}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { v: 0 },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '0%': {},
                    '20%': {},
                    '40%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Divider',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            fill: '${color1}',
            alpha: '${alpha}',
            clipPath: 'M0,0h10V${oh}h-10'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${ow-10},0h10V${oh}h-10' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {},
                    '20%': {},
                    '80%': { v: 'M${ow-10},0h10V${oh}h-10', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HyTv10TJ7',
    desc: 'Emoji template',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        mappings: {}
    },
    props: {
        alpha: 'alpha',
        emojiId: 'emojiId'
    },
    defaults: {
        alpha: 1,
        shadow: false,
        emojiId: 'emoji_1f600'
    },
    precalc: {
        oh: '${l__i1__height}'
    },
    layers: [{
        id: 'i1',
        desc: 'emoji layer',
        type: 'bitmap',
        attrs: {
            imageId: '${emojiId}',
            x: 0,
            y: 0,
            width: 150,
            height: 150,
            shadowEnabled: 'false',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-SkbUfhC1Q',
    desc: 'Emoji template 2',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        emojiId1: 'emojiId',
        emojiId2: 'emojiId',
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        shadow: false,
        emojiId1: 'emoji_1f600',
        emojiId2: 'emoji_1f600',
        color1: '#FFF',
        textColor1: '#F00',
        text1: 'LEGO MAN ICE CUBES',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0
    },
    precalc: {
        oh: 200
    },
    layers: [{
        id: 'b1',
        desc: 'Top text Backgroudn',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 0,
            y: 0,
            width: '${ow}',
            height: '${oh}',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'i1',
        desc: 'emoji layer2',
        type: 'bitmap',
        attrs: {
            imageId: '${emojiId1}',
            x: 20,
            y: 20,
            width: '${oh-40}',
            height: '${oh-40}',
            shadowEnabled: 'false',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'i2',
        desc: 'emoji layer2',
        type: 'bitmap',
        attrs: {
            imageId: '${emojiId2}',
            x: '${ow - l__self__width - 20}',
            y: 20,
            width: '${oh-40}',
            height: '${oh-40}',
            shadowEnabled: 'false',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: '${l__i1__x + l__i1__width + 20}',
            y: '${oh/2 - l__self__height/2}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow - l__i1__width - l__i2__width - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false',
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-r15LonRJ7',
    desc: 'Multi line with emoji on sides',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        alpha: 'alpha',
        emojiId1: 'emojiId',
        emojiId2: 'emojiId',
        color1: 'color',
        textColor1: 'textColor',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        shadow: false,
        emojiId1: 'emoji_1f600',
        emojiId2: 'emoji_1f600',
        color1: '#FFF',
        textColor1: '#F00',
        text1: 'LEGO MAN ICE CUBES',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0
    },
    precalc: {
        oh: '${l__t1__height + 40}'
    },
    layers: [{
        id: 'b1',
        desc: 'Top text Backgroudn',
        type: 'rect',
        attrs: {
            fillAlpha: 1,
            x: 0,
            y: 0,
            width: '${ow}',
            height: '${oh}',
            fill: '${color1}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'i1',
        desc: 'emoji layer2',
        type: 'bitmap',
        attrs: {
            imageId: '${emojiId1}',
            x: 40,
            y: '${oh/2 - l__self__height/2}',
            width: '${ow * .1}',
            height: '${ow * .1}',
            shadowEnabled: 'false',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'i2',
        desc: 'emoji layer2',
        type: 'bitmap',
        attrs: {
            imageId: '${emojiId2}',
            x: '${ow - l__self__width - 40}',
            y: '${oh/2 - l__self__height/2}',
            width: '${ow * .1}',
            height: '${ow * .1}',
            shadowEnabled: 'false',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            x: '${l__i1__x + l__i1__width + 30}',
            y: 20,
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${0.8 * ow - 80 - 60}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-rkkbkstl7',
    desc: 'slide in text + bottom bar',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow',
        align: 'align'
    },
    defaults: {
        alpha: 1,
        align: 'right',
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: true
    },
    precalc: {
        oh: '${l__t1__height+25}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            maxWidth: '${ow-20}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh - 28}h${-ow}z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ l__t1__height }' },
                    '30%': { v: '${ l__t1__height }' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '50%': { v: '${ l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding lower line',
        type: 'path',
        attrs: {
            d: 'M10,${l__t1__height+l__t1__y + 11}H${ow}',
            stroke: '${color1}',
            strokeWidth: 14,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '48.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '52.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '68.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '74.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l4',
        desc: 'sliding top line from left',
        type: 'path',
        attrs: {
            d: 'M10,${oh - 10}H${ow}',
            stroke: '${color1}',
            strokeWidth: 14,
            strokeAlpha: '${align == "left" ? 1 : 0}',
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '38.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '52.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '30%': {},
                    '68.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: _defineProperty({
                    '0%': {},
                    '40.72%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }, '100%', { v: 0 })
            }
        }
    }, {
        id: 'l3',
        desc: 'sliding top line from left',
        type: 'path',
        attrs: {
            d: 'M${ow - 10},${oh-10}H0',
            stroke: '${color1}',
            strokeWidth: 14,
            strokeAlpha: '${align == "right" ? 1 : 0}',
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '38.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '52.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '68.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '74.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            width: '${ow}',
            y: '${oh-16}',
            height: 14,
            fill: '${color1}',
            alpha: '${align == "center" ? 1 : 0}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${0.5*ow}' },
                    '48%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '48%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '58%': {},
                    '100%': { v: '${0.5*ow}', ease: 'easyEaseInOut' }
                },
                width: {
                    '58%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJo3ejKxQ',
    desc: 'slide in text + top bar',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        shadow: 'shadow',
        align: 'align'
    },
    defaults: {
        alpha: 1,
        align: 'left',
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        shadow: true
    },
    precalc: {
        oh: '${l__t1__height+25}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 10,
            y: 20,
            maxWidth: '${ow-20}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,20h${ow}V${oh}h${-ow}z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ -l__t1__height }' },
                    '30%': { v: '${ -l__t1__height }' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '50%': { v: '${ -l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding top line from left',
        type: 'path',
        attrs: {
            d: 'M10,10H${ow}',
            stroke: '${color1}',
            strokeWidth: 14,
            strokeAlpha: '${align == "left" ? 1 : 0}',
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '38.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '52.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '30%': {},
                    '68.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: _defineProperty({
                    '0%': {},
                    '40.72%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }, '100%', { v: 0 })
            }
        }
    }, {
        id: 'l3',
        desc: 'sliding top line from left',
        type: 'path',
        attrs: {
            d: 'M${ow - 10},10H0',
            stroke: '${color1}',
            strokeWidth: 14,
            strokeAlpha: '${align == "right" ? 1 : 0}',
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '38.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '52.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '68.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '6.72%': {},
                    '74.72%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            width: '${ow}',
            y: 2,
            height: 14,
            fill: '${color1}',
            alpha: '${align == "center" ? 1 : 0}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${0.5*ow}' },
                    '48%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '48%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '40%': {},
                    '100%': { v: '${0.5*ow}', ease: 'easyEaseInOut' }
                },
                width: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-S1ZJMOce7',
    desc: 'Line by line animation with fade in/out',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing',
        enterTextAnimType: 'enterTextAnimType',
        exitTextAnimType: 'exitTextAnimType'
    },
    defaults: {
        textColor1: '#fff',
        color1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            bgFill: '${color1}',
            bgAlpha: '${alpha}',
            enterTextAnim: 'line',
            exitTextAnim: 'line',
            visibleLineFactor: 1,
            enterTextAnimType: '${align == "center" ? "fromBottom" : align == "left"? "fromLeft" : "fromRight"}',
            exitTextAnimType: '${align == "center" ? "toBottom" : align == "left"? "toLeft" : "toRight"}'
        },
        animation: {
            enterkeyframes: {
                visibleLineFactor: {
                    '0%': { v: 0 },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                visibleLineFactor: {
                    '0%': {},
                    '100%': { v: 0, ease: 'linear' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-rJ3az0kb7',
    desc: 'Highlightable template stencil',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        highlightColors: {
            text1: {
                highlight: 'highlightColor1'
            }
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        highlightColor1: 'highlightColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        textColor1: '#fff',
        highlightColor1: '',
        color1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            highlightEnabled: true,
            highlightColor: '${highlightColor1}',
            highlightTextColor: 'rgba(0,0,0,0)'
        },
        animation: {
            highlights: {
                enter: {
                    type: 'right_to_left',
                    t_start: 0,
                    t_end: 100,
                    ease: 'easyEaseInOut'
                }
            },
            enterkeyframes: {
                x: {
                    '0%': { v: '${-oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                alpha: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '100%': { v: '${-oh}', ease: 'easyEaseInOutReverse' }
                },
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-HkKnZ3HbQ',
    desc: 'Highlightable template generic',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        highlightColors: {
            text1: {
                highlight: 'highlightColor1',
                highlightText: 'highlightTextColor1'
            }
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        highlightColor1: 'highlightColor',
        highlightTextColor1: 'highlightTextColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        textColor1: '#fff',
        highlightColor1: '',
        highlightTextColor1: '',
        color1: '#fff',
        alpha: 1,
        text1: '',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            highlightEnabled: true,
            highlightColor: '${highlightColor1}',
            highlightTextColor: '${highlightTextColor1}'
        },
        animation: {
            highlights: {
                enter: {
                    type: 'left_to_right',
                    t_start: 50,
                    t_end: 100,
                    ease: 'easyEaseInOut'
                }
            },
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '50%': { v: 0.001, ease: 'linear' },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-SyQWMQiZX',
    desc: 'Highlightable template from top',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        highlightColors: {
            text1: {
                highlight: 'highlightColor1',
                highlightText: 'highlightTextColor1'
            }
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        highlightColor1: 'highlightColor',
        highlightTextColor1: 'highlightTextColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        textColor1: '#fff',
        highlightColor1: '[11,{"color":"yellow","start":6,"end":10}]',
        highlightTextColor1: '',
        color1: '#fff',
        alpha: 1,
        text1: 'HELLO WORLD',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            highlightEnabled: true,
            highlightColor: '${highlightColor1}',
            highlightTextColor: '${highlightTextColor1}'
        },
        animation: {
            highlights: {
                enter: {
                    type: 'left_to_right',
                    t_start: 50,
                    t_end: 100,
                    ease: 'easyEaseInOut'
                    // exit : {
                    // 	type : 'right_to_left',
                    // 	t_start : 0,
                    // 	t_end : 100,
                    // 	ease : 'easyEaseInOutReverse'
                    // },
                } },
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh}' },
                    '50%': { v: 0.001, ease: 'linear' },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${-oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BJ8aNQjZX',
    desc: 'Highlightable template from bottom',
    meta: {
        autoHeight: true,
        variableLineSpacing: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        highlightColors: {
            text1: {
                highlight: 'highlightColor1',
                highlightText: 'highlightTextColor1'
            }
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        highlightColor1: 'highlightColor',
        highlightTextColor1: 'highlightTextColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        textColor1: '#fff',
        highlightColor1: '[11,{"color":"yellow","start":6,"end":10}]',
        highlightTextColor1: '',
        color1: '#fff',
        alpha: 1,
        text1: 'HELLO WORLD',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            lineSpacing: '${lineSpacing}',
            lineEntry: 1,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            highlightEnabled: true,
            highlightColor: '${highlightColor1}',
            highlightTextColor: '${highlightTextColor1}'
        },
        animation: {
            highlights: {
                enter: {
                    type: 'left_to_right',
                    t_start: 50,
                    t_end: 100,
                    ease: 'easyEaseInOut'
                },
                exit: {
                    type: 'right_to_left',
                    t_start: 0,
                    t_end: 100,
                    ease: 'easyEaseInOutReverse'
                }
            },
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '50%': { v: 0.001, ease: 'linear' },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77,"./data-svgs":59}],39:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _attrs;

var _GeneralUtils = require('../utils/GeneralUtils');

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var defs = [];

defs.push({
    id: 'defId-H1nZqYuWQ',
    desc: 'Box with text from screen bottom',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        textColor2: 'textColor',
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        textColor1: '#fff',
        textColor2: '#ccc',
        color1: '#f00',
        alpha: 1,
        text1: 'Privewoning :',
        text2: 'geen verplichting',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.4,
        letterSpacing: 0,
        lineSpacing: 0,
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 40}'
    },
    layers: [{
        id: 'bg',
        desc: 'background',
        type: 'rect',
        attrs: {
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ch - oy}' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 40,
            y: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 90,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': {
                        v: '${-l__t1__height}'
                    },
                    '60%': {
                        v: '${-l__t1__height}'
                    },
                    '80%': {
                        v: '${l__t1__y}'
                    },
                    '100%': {
                        ease: 'easyEaseInOut'
                    }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        attrs: {
            x: '${l__t1__x}',
            y: '${l__t1__y + l__t1__height}',
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': {
                        v: '${oh}'
                    },
                    '80%': {
                        v: '${oh}'
                    },
                    '100%': {
                        ease: 'easyEaseInOut'
                    }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-B1xqQOtZQ',
    desc: 'rotating then zoom out box',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        textColor2: 'textColor',
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        textColor1: '#f00',
        textColor2: '#fff',
        color1: '#ccc',
        alpha: 1,
        text1: 'Privewoning :',
        text2: 'geen verplichting',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight: 1.4,
        letterSpacing: 0,
        lineSpacing: 0,
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 80}'
    },
    layers: [{
        id: 'bg',
        desc: 'background',
        type: 'path',
        attrs: {
            d: 'M40,0H${ow}V${oh-40}H40z',
            y: 0,
            height: '${oh}',
            rotate: '0 ${ow/2} ${l__t1__height/2}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh/2-10}' },
                    '30%': { v: '${oh/2-10}' },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                height: {
                    '0%': { v: 20 },
                    '30%': { v: 20 },
                    '60%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                rotate: {
                    '0%': { v: '-180 ${ow/2} ${l__t1__height/2}' },
                    '30%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                d: {
                    '0%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '60%': { v: 'M0,0H${ow}V${oh}H0z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 80,
            y: 20,
            fontFamily: '${fontFamily1}',
            fontSize: 90,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': {
                        v: 0
                    },
                    '60%': { v: 0 },
                    '60.01%': {},
                    '100%': {}
                },
                x: {
                    '0%': { v: 40 },
                    '60%': { v: 40 },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: 60 },
                    '60%': { v: 60 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        attrs: {
            x: '${l__t1__x}',
            y: '${l__t1__y + l__t1__height}',
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: '${lineSpacing}',
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': {
                        v: 0
                    },
                    '60%': { v: 0 },
                    '60.01%': {},
                    '100%': {}
                },
                x: {
                    '0%': { v: 40 },
                    '60%': { v: 40 },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t2__y + 40}' },
                    '60%': { v: '${l__t2__y + 40}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-r1NhZFtZQ',
    desc: 'bullet line by line from screen bottom',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        textColor1: '#f00',
        color1: '#ccc',
        alpha: 1,
        text1: 'Dat brandblussers in prive-woningen\nneit verplicht, maar wel aangeraden zijn',
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        shadow: false,
        lineHeight: 1.4,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 's1',
        desc: 'bullet',
        type: 'ellipse',
        attrs: {
            cx: 44,
            cy: '${44 * lineHeight - l__self__ry}',
            rx: 10,
            ry: 10,
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                alpha: {
                    '0%': { v: 0 },
                    '50%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 2 * 44,
            y: 0,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow - l__self__x}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            rotate: '0.01 0 0',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            lines: {
                enter: {
                    type: 'slide_from_bottom',
                    t_start: 20,
                    t_end: 100,
                    staggerFactor: 0.75,
                    ease: 'easeOut'
                }
            },
            enterkeyframes: {
                y: {
                    '0%': { v: '${ch - oy}' },
                    '20%': { v: '${ch - oy}' },
                    '50%': { ease: 'easeOut' },
                    '100%': { ease: 'easeOut' }
                },
                alpha: {
                    '0%': { v: '${0*l__t1__alpha}' },
                    '20%': { v: '${0.01*l__t1__alpha}' },
                    '60%': { v: '${0.99*l__t1__alpha}', ease: 'easeOut' },
                    '100%': { ease: 'easeOut' }
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-BkoWnqKZX',
    desc: 'char by char',
    meta: {
        autoHeight: true,
        canOverrideAnimationSpeed: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        textColor1: 'textColor',
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        align: 'align',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        lineSpacing: 'lineSpacing'
    },
    defaults: {
        textColor1: '#f00',
        color1: '#ccc',
        alpha: 1,
        text1: 'Dat brandblussers\nin prive-woningen neit verplicht',
        fontFamily1: 'RALEWAY:NORMAL:NORMAL',
        shadow: false,
        align: 'center',
        lineHeight: 1.4,
        letterSpacing: 0,
        lineSpacing: 0
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            x: 0,
            y: 0,
            fontFamily: '${fontFamily1}',
            fontSize: 75,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            characters: {
                enter: {
                    type: 'slide_from_top_left',
                    t_start: 0,
                    t_end: 100,
                    staggerFactor: 0.05,
                    ease: 'linear'
                }
            },
            enterkeyframes: {
                alpha: {
                    '0%': { v: '${0.99*l__t1__alpha}' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                alpha: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-tEbcxD7OZ',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        align: 'align',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: "DON'T",
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'QUIT',
        textColor2: '#ff0',
        align: 'center',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.4,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 40,
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6,
            strokeWidth: 0.1,
            strokeAlpha: 0.01
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: -1920 },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '20%': {},
                    '100%': { v: -1920, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${l__t1__y + l__t1__height}',
            maxWidth: '${ow - 80}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: '${align}',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: 1920 },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '20%': {},
                    '100%': { v: 1920, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-05eocRwNw',
    desc: 'Two text + wedgy background + side borders + placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color2'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#F1626E',
        color2: '#000000',
        textColor1: '#FFFFFF',
        textColor2: '#F1626E',
        alpha: 0.8,
        lineHeight1: 1,
        letterSpacing1: 0,
        lineHeight2: 1,
        letterSpacing2: 0,
        text1: 'PENGUIN',
        text2: 'Next show after the Lion Dance',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        fontFamily2: 'ROBOTO_CONDENSED:NORMAL:NORMAL',
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        oh: '${l__i1__height + 26}'
    },
    layers: [{
        id: 's2',
        desc: 'Background',
        type: 'path',
        attrs: {
            d: 'M${oh+10},0H${ow}L${ow},${oh}H${oh+10}z',
            clipPath: 'M${oh+10},0H${ow}L${ow},${oh}H${oh+10}z',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${-ow}, 0)' },
                    '20%': { v: 'translate(${-ow}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '80%': { v: 'translate(${-ow}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${-ow}, 0)' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Straight border line',
        type: 'rect',
        attrs: {
            x: '${oh + 10}',
            width: 13,
            height: '${oh}',
            fill: '${color1}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Slant border line',
        type: 'path',
        attrs: {
            d: 'M${ow},0h-10l0,${oh}h10z',
            clipPath: 'M${l__s1__x+l__s1__width},0H${ow}l0,${oh}H${l__s1__x+l__s1__width}z',
            fill: '${color1}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M${oh + 20},0h-140l0,${oh}h140z' },
                    '36%': { v: 'M${oh + 20},0h-140l0,${oh}h140z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                d: {
                    '10%': {},
                    '64%': { v: 'M${oh + 20},0h-140l0,${oh}h140z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${oh + 20},0h-140l0,${oh}h140z' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: 20,
            maxWidth: '${ow - l__self__x - 95 }',
            height: '${calcSelfHeight()}',
            clipPath: 'M${oh + 40},20h${l__self__maxWidth}v${l__self__height + 20}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,20h0v${l__t1__height + 20}h0z' },
                    '36%': { v: 'M0,20h0v${l__t1__height + 20}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 10}' },
                    '50%': { v: '${l__t1__y + l__t1__height + 10}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': { v: 'M0,20h0v${l__t1__height + 20}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,20h0v${l__t1__height + 20}h0z' }
                },
                y: {
                    '50%': { v: '${l__t1__y + l__t1__height + 10}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${l__t1__y + l__t1__height + 10}' }
                }
            }
        }
    }, {
        id: 't2',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 50,
            lineSpacing: 10,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 40}',
            y: '${l__t1__y + l__t1__height + 20}',
            maxWidth: '${ow - l__self__x - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M${oh + 40},${l__self__y - 10}h${l__self__maxWidth}v${l__self__height + 10}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z' },
                    '36%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${-l__t2__height - 10}' },
                    '50%': { v: '${-l__t2__height - 10}' },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,${l__t2__y - 10}h0v${l__t2__height + 10}h0z' }
                },
                y: {
                    '20%': {},
                    '50%': { v: '${-l__t2__height - 10}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-l__t2__height - 10}' }
                }
            }
        }
    }, {
        id: 's4',
        desc: 'Placeholder Background',
        type: 'rect',
        attrs: {
            width: '${oh}',
            height: '${oh}',
            fill: '${color1}',
            shadowEnabled: false
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        meta: {
            masks: [{
                mLayerId: 's4'
            }]
        },
        attrs: {
            imageId: '${imageId}',
            x: 13,
            y: 13,
            width: '200',
            height: '200',
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-BA7BJfqkr',
    desc: 'Square to Lower Third Title',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor2'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'mission',
        text2: 'impossible',
        color1: '#fff',
        textColor1: '#fff',
        textColor2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.2,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${ l__t1__height + l__t2__height + 50}'
    },
    layers: [{
        id: 't1',
        desc: 'Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 50,
            y: 20,
            maxWidth: '${ow - 50 - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '5%': { v: '${-ow}' },
                    '45%': { ease: 'easyeaseinout' },
                    '85%': { ease: 'easyeaseinout' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '37%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Lower text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 'tm',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 50,
            y: '${l__t1__y + l__t1__height + 10}',
            maxWidth: '${ow - 50 - 80}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${-ow}' },
                    '10%': { v: '${-ow}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '85%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '30%': { v: '${-ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${-ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'tm',
        desc: 'text mask',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M0,0h${ow}V${oh}h${-ow}z',
            x: '20',
            fillAlpha: 1,
            scale: '1 1 ${ow/2} ${oh/2}',
            rotate: '0 ${ow/2} ${oh/2}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow-oh/4}', ease: 'easyEaseInOut' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '10%': {},
                    '55%': { v: '${ow-oh/4}', ease: 'easyEaseInOut' },
                    '80%': { v: '${ow/2}', ease: 'easyEaseInOut' },
                    '100%': { v: '${ow/2}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg',
        type: 'path',
        attrs: {
            d: 'M0,0V${oh}z',
            x: '10',
            stroke: '${color1}',
            strokeWidth: '20',
            strokeAlpha: 1,
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeWidth: _defineProperty({
                    '0%': { v: '${oh/2}' },
                    '50%': { v: '${oh * 0.66}', ease: 'easyEaseInOut' }
                }, '50%', { ease: 'easyEaseInOut' }),
                x: {
                    '0%': { v: '${ow-oh/4}' },
                    '50%': { ease: 'easyEaseInOut' },
                    '90%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                strokeWidth: {
                    '0%': {},
                    '10%': {},
                    '25%': { v: '${oh * 0.66}', ease: 'easyEaseInOut' },
                    '60%': { v: '0', ease: 'easyEaseInOut' }
                },
                x: {
                    '0%': {},
                    '10%': {},
                    '55%': { v: '${ow}', ease: 'easyEaseInOut' },
                    '100%': { v: '${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-EGdMkJc9Y',
    desc: 'one text + wedgy background + side borders',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color2'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing'
    },
    defaults: {
        color1: '#F1626E',
        color2: '#000000',
        textColor1: '#FFFFFF',
        alpha: 0.8,
        lineHeight1: 1,
        letterSpacing1: 0,
        text1: 'PENGUIN SLIDE',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL'
    },
    precalc: {
        oh: '${l__t1__height + 40}'
    },
    layers: [{
        id: 's2',
        desc: 'Background',
        type: 'path',
        attrs: {
            d: 'M0,0H${ow}L${ow - 95},${oh}H0z',
            fill: '${color2}',
            alpha: '${alpha}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'translate(${-ow}, 0)' },
                    '20%': { v: 'translate(${-ow}, 0)' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '10%': {},
                    '80%': { v: 'translate(${-ow}, 0)', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'translate(${-ow}, 0)' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'Straight border line',
        type: 'rect',
        attrs: {
            width: 13,
            height: '${oh}',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's3',
        desc: 'Slant border line',
        type: 'path',
        attrs: {
            d: 'M${ow},0h-10l-95,${oh}h10z',
            fill: '${color1}'
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0h-140l-95,${oh}h140z' },
                    '36%': { v: 'M0,0h-140l-95,${oh}h140z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                d: {
                    '10%': {},
                    '64%': { v: 'M0,0h-140l-95,${oh}h140z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0h-140l-95,${oh}h140z' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 98,
            lineSpacing: 0,
            // lineHeightFactor : 1,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 60,
            y: 20,
            maxWidth: '${ow - 60 - 95 - 10 - 10}',
            height: '${calcSelfHeight()}',
            clipPath: 'M20,30h${l__self__maxWidth}v${l__self__height + 30}h${-l__self__maxWidth}z',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M0,30h0v${l__t1__height + 30}h0z' },
                    '36%': { v: 'M0,30h0v${l__t1__height + 30}h0z' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t1__y + l__t1__height + 15}' },
                    '50%': { v: '${l__t1__y + l__t1__height + 15}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '10%': {},
                    '64%': { v: 'M0,30h0v${l__t1__height + 30}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,30h0v${l__t1__height + 30}h0z' }
                },
                y: {
                    '50%': { v: '${l__t1__y + l__t1__height + 15}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${l__t1__y + l__t1__height + 15}' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-LcGRv4HFu',
    desc: '4 lines + 2 text + placeholder',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        alpha: 1,
        text1: 'HOOLI',
        text2: 'BETTER PLACE',
        color1: '#f00',
        color2: '#0f0',
        textColor1: '#ff0',
        textColor2: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: true,
        lineHeight1: 1.4,
        lineHeight2: 1.2,
        letterSpacing1: 0,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        oh: '${l__bgi1__height}'
    },
    layers: [{
        id: 'bg1',
        desc: 'Main text background',
        type: 'rect',
        attrs: {
            x: '${oh + 20}',
            y: 0,
            width: '${ow - oh - 20}',
            height: '${l__t1__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                height: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__bg1__height}', ease: 'easyEaseInOutReverse' }
                },
                height: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: '${oh + 20 + 20}',
            y: 0,
            maxWidth: '${ow - l__self__x - 20 - oh - 20}',
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: 1,
            clipPath: 'M0,0h${ow}v${l__t1__height}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__t1__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'bg2',
        desc: 'Bottom text background',
        type: 'rect',
        attrs: {
            x: '${oh + 20}',
            y: '${l__t2__y - 10}',
            width: '${l__t2__width + 50}',
            height: '${l__t2__height + 20}',
            fill: '${color2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                height: {
                    '0%': { v: 0 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                },
                height: {
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${oh + 20 + 20}',
            y: '${l__t1__y + l__t1__height + 30}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: 1,
            clipPath: 'M${l__bg2__x},${l__bg2__y}h${l__bg2__width}v${l__bg2__height}h${-l__bg2__width}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${l__bg2__y + l__bg2__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${l__bg2__y + l__bg2__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'ltb',
        desc: 'Line along left side going from top to bottom',
        type: 'path',
        attrs: {
            d: 'M-20,-300V${oh + 300}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'llr',
        desc: 'Line along top side going from left to right',
        type: 'path',
        attrs: {
            d: 'M-300,-20H${ow + 300}',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'lbt',
        desc: 'Line along right side going from bottom to top',
        type: 'path',
        attrs: {
            d: 'M${ow+20},${oh + 300}V-300',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'lrl',
        desc: 'Line along bottom of main text going from right to left',
        type: 'path',
        attrs: {
            d: 'M${ow + 300},${l__bg1__y + l__bg1__height + 20}H-300',
            fillAlpha: 0,
            stroke: '${color1}',
            strokeWidth: 5,
            strokeAlpha: 1,
            strokeTrimStart: 100,
            strokeTrimEnd: 100,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '80%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '20%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimStart: {
                    '20%': {},
                    '80%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 'bgi1',
        desc: 'Placeholder Background',
        type: 'rect',
        attrs: {
            x: 0,
            width: 250,
            height: 250,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(1, 0)' },
                    '42%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                transform: {
                    '58%': {},
                    '100%': { v: 'scale(1, 0)', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: 10,
            y: 10,
            width: '${oh-20}',
            height: '${oh-20}',
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '10%': { v: '${oh}' },
                    '52%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '50%': {},
                    '100%': { v: '${oh}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-ZSpLlREoy',
    desc: 'Line to Slant Lower Third',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        text1: 'text',
        color1: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        align: 'align'
    },
    defaults: {
        alpha: 1,
        text1: 'DURATION CONTROL',
        color1: '#ff0',
        textColor1: '#000',
        fontFamily1: 'HOMENAJE:NORMAL:NORMAL',
        shadow: false,
        lineHeight: 1.2,
        letterSpacing: 0,
        align: 'left'
    },
    precalc: {
        oh: '${l__t1__height + 40}'
    },
    layers: [{
        id: 's2',
        desc: 'sliding bg 2',
        clipPath: 'M-20,0H${ow}l-20,${oh}h${-ow}z',
        type: 'path',
        attrs: {
            d: 'M0,0h${ow}l-20,${oh}h${-ow}z',
            fill: '${color1}',
            alpha: '${alpha}',
            stroke: '${color1}',
            fillAlpha: 1,
            strokeWidth: 1,
            strokeAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                d: {
                    '0%': { v: 'M0,0h1' },
                    '7%': { v: 'M0,0h1' },
                    '8%': { v: 'M0,0h20l0,${oh}h-20z' },
                    '68%': { v: 'M0,0h${ow}l-20,${oh}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M0,0h${ow}l-20,${oh}h${-ow}z', ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                d: {
                    '0%': { v: 'M0,0h${ow}l-20,${oh}h${-ow}z' },
                    '40%': { v: 'M0,0h20l0,${oh}h-20z', ease: 'easyEaseInOutReverse' },
                    '45%': { v: 'M0,0h1', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M0,0h1', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding bg 1',
        type: 'path',
        attrs: {
            d: 'M${ow/2},0h20l20,${oh}h-20z',
            clipPath: 'M-20,-${oh/2}H${ow}l-20,${oh*2}h${-ow}z',
            stroke: '${color1}',
            strokeWidth: 1,
            strokeAlpha: 1,
            alpha: '${alpha}',
            fill: '${color1}',
            fillAlpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '100%': { v: 'M-20,0H${ow}l-20,${oh}h${-ow}z' }
                },
                d: {
                    '0%': { v: 'M-20,0h20l20,${oh}h-20z', ease: 'easyEaseInOut' }, //move to left
                    '70%': { v: 'M${ow+20},0h${ow}l-20,${oh}h${-ow}z', ease: 'easyEaseInOut' //move to right
                    } }
            },
            exitkeyframes: {
                d: {
                    '0%': { v: 'M${ow+20},0h${ow}l-20,${oh}h${-ow}z' },
                    '45%': { v: 'M-20,0h20l20,${oh}h-20z', ease: 'easyEaseInOutReverse' },
                    '70%': { v: 'M-20,0h20l20,${oh}h-20z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M-20,0h20l20,${oh}h-20z', ease: 'easyEaseInOutReverse' }
                },
                alpha: {
                    '0%': {},
                    '55%': { v: '0', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Text',
        type: 'text',
        meta: {
            masks: [{
                mLayerId: 's2',
                mAlphaInv: false
            }]
        },
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.2,
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: '20',
            y: '20',
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: false,
            alpha: 1,
            transform: 'skew(-10,0)'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow}' },
                    '10%': { v: '${ow}' },
                    '55%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '40%': { v: '${ow}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${ow}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-LP9auH2fi',
    desc: 'CNN Branded',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1'
        },
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        text1: 'text',
        textColor1: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        alpha: 1,
        text1: 'HOOLI',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        letterSpacing1: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        oh: '${l__t1__height + l__i1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__i1__height}',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            clipPath: 'M0,200H${ow}v${l__t1__height}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '100%': { v: '${-l__t1__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: '${ow/2 - l__self__width/2}',
            y: 0,
            width: 200,
            height: 200,
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            cropEnabled: true,
            transform: 'scale(1, 1, ${ow/2}, ${l__i1__height/2})',
            shadowEnabled: '${shadow}',
            shadowColor: '#424242',
            alpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${ow/2}, ${l__i1__height/2})' },
                    '10%': { v: 'scale(0, 0, ${ow/2}, ${l__i1__height/2})', ease: 'easeInOut' },
                    '30%': { v: 'scale(1.1, 1.1, ${ow/2}, ${l__i1__height/2})', ease: 'easeInOut' },
                    '50%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '30%': {},
                    '100%': { v: 'scale(0, 0, ${ow/2}, ${l__i1__height/2})', ease: 'easeInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Zh66ITasF',
    desc: 'non-profit-2',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        alpha: 'alpha',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        text2: 'text',
        textColor2: 'textColor',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow',
        fontSize1: 'fontSize'
    },
    defaults: {
        alpha: 1,
        text1: 'MUN',
        color1: '#f00',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.2,
        letterSpacing1: 0,
        text2: 'City',
        textColor2: '#fff',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.2,
        letterSpacing2: 0,
        shadow: true,
        fontSize1: 100
    },
    precalc: {
        oh: '${max(l__t1__height, l__t2__height) + 20}'
    },
    layers: [{
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: '${fontSize1}',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: '${l__t1__x + l__t1__width + 40}',
            y: 0,
            height: '${calcSelfHeight()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            width: '${0.4*ow}',
            maxWidth: '${0.4*ow}',
            // clipPath: 'M0,0H${ow}V${oh}H0',
            clipPath: 'M${0.6*ow - 10},0H${ow}V${oh}H${0.6*ow  - 10}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            alpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${0.4*ow}' },
                    '10%': { v: '-${0.4*ow}' },
                    '70%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '60%': { v: '-${0.4*ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'left box',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            height: '${oh}',
            width: '${l__t1__width + 40}',
            alpha: '${alpha}',
            fillAlpha: 1,
            fill: '${color1}',
            shadowEnabled: 'false',
            clipPath: 'M0,0H${ow}V${oh}H0'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${ow}' },
                    '30%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'bottom line',
        type: 'rect',
        attrs: {
            width: '${ l__t2__width + 40 }',
            x: '${l__t1__width + 40}',
            y: '${oh - 20}',
            height: 20,
            fill: '${color1}',
            alpha: '${alpha}',
            // clipPath: 'M${ow/2 - 10},0H${ow}V${oh}H${ow/2  - 10}',
            clipPath: 'M${0.6*ow - 10},0H${ow}V${oh}H${0.6*ow  - 10}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${l__l1__x}' },
                    '10%': { v: '-${l__l1__x}' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '70%': { v: '-${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: '${fontSize1}',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 0,
            width: '${ow*0.6 - 40}',
            maxWidth: '${ow*.6 - 40}',
            height: '${calcSelfHeight()}',
            align: 'right',
            text: '${text1}',
            fill: '${textColor1}',
            clipPath: 'M0,0H${ow}V${oh}H0',
            // clipPath: 'M${ow/2 - 10},0H${ow}V${oh}H${ow/2  - 10}',
            bgFill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            alpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '-${ow}' },
                    '30%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '0%': {},
                    '100%': { v: '-${ow}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-q1VsYkigl',
    desc: 'Non-profit-3',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        color1: 'color',
        color2: 'color',
        alpha: 'alpha',
        align: 'align',
        text1: 'text',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        text2: 'text',
        textColor2: 'textColor',
        fontFamily2: 'fontfamily',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        shadow: 'shadow'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        text1: 'Manchester',
        color1: '#f00',
        color2: '#f00',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight1: 1.4,
        letterSpacing1: 0,
        text2: 'City',
        textColor2: '#fff',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight2: 1.2,
        letterSpacing2: 0,
        shadow: false
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + 10}'
    },
    layers: [{
        id: 't1',
        desc: 'Top Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 80,
            x: 20,
            y: 0,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0H${ow}v${l__self__height}H0z',
            align: '${align}',
            text: '${text1}',
            fill: '${textColor1}',
            bgAlpha: '${alpha}',
            bgFill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            alpha: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ (align == "right" ? ow : ( align == "left" ? -ow : 20 )) }' },
                    '50%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${ (align == "center" ? l__t1__height + 20 : 0 ) }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '85%': { v: '${ - l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: (_attrs = {
            fontFamily: '${fontFamily2}',
            fontSize: 65,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__t1__height +10}',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,${l__t1__height + 10}H${ow}V${oh}H0z',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            bgAlpha: '${alpha}',
            bgFill: '${color2}'
        }, _defineProperty(_attrs, 'align', '${align}'), _defineProperty(_attrs, 'shadowEnabled', '${shadow}'), _defineProperty(_attrs, 'shadowColor', "${shadow ? calcSelfShadowColor() : '#fff'}"), _defineProperty(_attrs, 'alpha', 1), _defineProperty(_attrs, 'shadowOffsetX', 1), _defineProperty(_attrs, 'shadowOffsetY', 1), _defineProperty(_attrs, 'shadowBlur', 4), _attrs),
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ (align == "right" ? ow : ( align == "left" ? -ow : 20 )) }' },
                    '55%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${ (align == "center" ? -l__t2__height : l__t1__height + 10 ) }' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '90%': { v: '${ - l__t2__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-XIaAPix7n',
    desc: 'sliding reveal text + lines',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'JENNIFER MATTHEW',
        text2: 'EXECUTIVE DIRECTOR',
        color1: '#f00',
        textColor1: '#f00',
        textColor2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: true,
        lineHeight1: 1.6,
        letterSpacing1: 0,
        lineHeight2: 1.4,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.6,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 40,
            y: 10,
            maxWidth: '${ow - 2 * l__self__x}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z' },
                    '26.9%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z' },
                    '90.8%': {
                        v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z',
                        ease: 'easyEaseInOut'
                    },
                    '99.99%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z' },
                    '100%': {}
                },
                x: {
                    '0%': { v: 240 },
                    '16.2%': { v: 240 },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z' },
                    '9.2%': { v: 'M0,0h${2*l__t1__x + l__t1__width}v${oh}h${-2*l__t1__x - l__t1__width}z' },
                    '73.1%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M${l__t1__width + 80},0h0v${oh}h0z' }
                },
                x: {
                    '83.8%': { v: 240, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 240 }
                }
            }
        }
    }, {
        id: 's1',
        desc: 'sliding box for main text',
        type: 'rect',
        attrs: {
            x: 0,
            y: 0,
            width: 0,
            height: '${l__t1__height }',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            clipPath: '${l__l1__d}'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${l__t1__width + 80}' },
                    '26.1%': { v: '${l__t1__width + 80}' },
                    '90%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                width: {
                    '0%': { v: 100 },
                    '26.9%': { v: 100 },
                    '90.8%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '10%': {},
                    '73.9%': { v: '${l__t1__width + 80}', ease: 'easyEaseInOutReverse' },
                    '100%': { v: '${l__t1__width + 80}' }
                },
                width: {
                    '9.2%': {},
                    '73.1%': { v: 100, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 100 }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Thicker box',
        type: 'path',
        attrs: {
            d: 'M0,0v${l__t1__height + 10}h${2 * l__t1__x + l__t1__width}v${-l__t1__height - 10}h${-2 * l__t1__x - l__t1__width}v1',
            fillAlpha: 0,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            strokeWidth: 14,
            strokeAlpha: 1,
            stroke: '${color1}',
            strokeTrimStart: 0,
            strokeTrimEnd: 100
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '16.9%': { v: 48.9, ease: 'easyEaseInOut' },
                    '54.6%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '45.4%': {},
                    '83.1%': { v: 48.9, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'Thinner box',
        type: 'path',
        attrs: {
            d: 'M-25,-25v${l__t1__height + 50}h${2 * l__t1__x + l__t1__width + 50}v${-l__t1__height - l__t1__y/2 - 50}z',
            fillAlpha: 0,
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            strokeWidth: 8,
            strokeAlpha: 1,
            stroke: '${color1}',
            strokeTrimStart: 100,
            strokeTrimEnd: 100
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },
                    '4.6%': { v: 0 },
                    '57.7%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10%': { v: 0 },
                    '70.8%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimEnd: {
                    '42.3%': {},
                    '95.4%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                },
                strokeTrimStart: {
                    '29.2%': {},
                    '90%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0 }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 60,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 40,
            y: '${l__t1__y + l__t1__height + 20}',
            maxWidth: '${ow - 2*l__self__x}',
            height: '${calcSelfHeight()}',
            width: '${calcSelfWidth()}',
            align: 'left',
            text: '${text2}',
            fill: '${textColor2}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                clipPath: {
                    '0%': { v: 'M-150,0h0v${oh}h0z' },
                    '33%': { v: 'M-150,0h0v${oh}h0z' },
                    '92.3%': {
                        v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z',
                        ease: 'easyEaseInOut'
                    },
                    '99.99%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z' },
                    '100%': {}
                },
                x: {
                    '0%': { v: 240 },
                    '26.2%': { v: 240 },
                    '93.1%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0.01%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z' },
                    '7.7%': { v: 'M0,0h${2*l__t2__x + l__t2__width}v${oh}h${-2*l__t2__x - l__t2__width}z' },
                    '67%': { v: 'M-150,0h0v${oh}h0z', ease: 'easyEaseInOutReverse' },
                    '100%': { v: 'M-150,0h0v${oh}h0z' }
                },
                x: {
                    '6.9%': {},
                    '73.8%': { v: 240, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 240 }
                }
            }
        }
    }, {
        id: 's2',
        desc: 'sliding box for bottom text',
        type: 'rect',
        attrs: {
            x: '${2*l__t2__x + l__t2__width}',
            y: '${l__t2__y}',
            width: 0,
            height: '${l__t2__height}',
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            clipPath: 'M10,0h${ow}v${oh}h${-ow}z'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: -150 },
                    '33%': { v: -150 },
                    '92.3%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                width: {
                    '0%': { v: 150 },
                    '30%': { v: 150 },
                    '89.2%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                x: {
                    '7.7%': {},
                    '67%': { v: -150, ease: 'easyEaseInOutReverse' },
                    '100%': { v: -150 }
                },
                width: {
                    '10.8%': {},
                    '70%': { v: 150, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 150 }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-aVjMauUgu',
    desc: 'CNN Branded',
    meta: {
        canOverrideAnimationSpeed: true,
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        text1: 'text',
        textColor1: 'textColor',
        text2: 'text',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight'
    },
    defaults: {
        alpha: 1,
        text1: 'HOOLI',
        textColor1: '#ff0',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        text2: 'HOOLI',
        textColor2: '#ff0',
        fontFamily2: 'MONTSERRAT:MEDIUM:NORMAL',
        shadow: false,
        lineHeight1: 1.4,
        letterSpacing1: 0,
        lineHeight2: 1.4,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder'
    },
    precalc: {
        oh: '${l__t1__height + l__t2__height + l__i1__height + 30}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 0,
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            alpha: '${alpha}',
            //	clipPath : 'M0,200H${ow}v${l__t1__height}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-l__t1__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '30%': {},
                    '90%': { v: '${-l__t1__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Sub Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 65,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            // y : '${l__t1__height + 20}',
            y: '${l__t1__y + l__t1__height }',
            maxWidth: '${ow - 40}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            //				clipPath : 'M0,200H${ow}v${l__t2__height}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-l__t2__height}' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '20%': {},
                    '90%': { v: '${-l__t2__height}', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            x: '${ow/2 - l__self__width/2}',
            y: '${l__t1__height + l__t2__height + 30}',
            width: 200,
            height: 200,
            crop: 'square',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            cropEnabled: true,
            transform: 'scale(1, 1, ${ow/2}, ${l__t1__height + l__t2__height + l__i1__height/2})',
            shadowEnabled: '${shadow}',
            shadowColor: '#424242',
            alpha: '${alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': { v: 'scale(0, 0, ${ow/2}, ${l__t1__height + l__t2__height + l__i1__height/2})' },
                    '10%': {
                        v: 'scale(0, 0, ${ow/2}, ${l__t1__height + l__t2__height + l__i1__height/2})',
                        ease: 'easeInOut'
                    },
                    '30%': {
                        v: 'scale(1.1, 1.1, ${ow/2}, ${l__t1__height + l__t2__height + l__i1__height/2})',
                        ease: 'easeInOut'
                    },
                    '50%': { ease: 'easeInOut' }
                }
            },
            exitkeyframes: {
                transform: {
                    '30%': {},
                    '100%': {
                        v: 'scale(0, 0, ${ow/2}, ${l__t1__height + l__t2__height + l__i1__height/2})',
                        ease: 'easeInOutReverse'
                    }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-Z4B2xcjuG',
    desc: 'Christine bradley',
    meta: {
        autoHeight: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'MAKE THE WORLD',
        text2: 'A BETTER PLACE',
        color1: '#F1626E',
        textColor1: '#FFF',
        textColor2: '#FFF',
        fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
        fontFamily2: 'GLACIAL_INDIFFERENCE:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.4,
        lineHeight2: 1.4,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 10,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            clipPath: 'M0,0h${ow}v${l__l1__y}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: -30 },
                    '40%': { v: -30 },
                    '70%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': { v: 'M0,0h${ow}v0h${-ow}z' },
                    '70%': { v: 'M0,0h${ow}v0h${-ow}z' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '40%': { v: 'M0,0h${ow}v0h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M0,${oh}h${ow}v0h${-ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't1d',
        desc: 'Main Text Duplicate',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 10,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${color1}',
            clipPath: 'M0,${l__l1__y}h${ow}v${oh - l__l1__y}h${-ow}z',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: -30 },
                    '40%': { v: -30 },
                    '70%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                clipPath: {
                    '0%': {},
                    '40%': {},
                    '70%': { v: 'M0,0h${ow}v${oh}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '40%': { v: 'M0,${l__l1__y}h${ow}v${oh - l__l1__y}h${-ow}z', ease: 'easyEaseInOut' },
                    '100%': { v: 'M0,${oh}h${ow}v0h${-ow}z', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            x: 0,
            y: '${l__t2__y}',
            //	clipPath : 'M0,0h${ow}v${l__t2__y}h${-ow}z',
            width: '${ow}',
            height: 8,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${ow/2}' },
                    '20%': { v: '${ow/2}' },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '20%': { v: 0 },
                    '40%': { ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                },
                y: {
                    '0%': { v: '${l__t2__y - 25}' },
                    '40%': { v: '${l__t2__y - 25}' },
                    '70%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '40%': { v: 0, ease: 'easyEaseInOut' },
                    '100%': { v: '${oh}', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 70,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__t1__y + l__t1__height}',
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            transform: 'translate(${ow/2}, ${l__t2__height/2}) scale(1, 1) translate(${-ow/2}, ${- l__t2__height/2})'
        },
        animation: {
            enterkeyframes: {
                transform: {
                    '0%': {
                        v: 'translate(${ow/2}, ${l__t2__height/2}) scale(6, 6) translate(${-ow/2}, ${- l__t2__height/2})'
                    },
                    '30%': { ease: 'easeinout' }
                }
            },
            exitkeyframes: {
                clipPath: {
                    '0%': {
                        v: 'M0,0h${ow}v${oh}h${-ow}z'
                    },
                    '40%': {
                        v: 'M0,0h${ow}v${oh}h${-ow}z'
                    },
                    '100%': {
                        v: 'M0,${oh}h${ow}v0h${-ow}z',
                        ease: 'easyEaseInOut'
                    }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-lDRwTAotw',
    desc: 'Nonprofit interview',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        text1: 'text',
        text2: 'text',
        color1: 'color',
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        shadow: 'shadow',
        lineHeight1: 'lineHeight',
        lineHeight2: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        letterSpacing2: 'letterSpacing'
    },
    defaults: {
        alpha: 1,
        text1: 'MAKE THE WORLD',
        text2: 'A BETTER PLACE',
        color1: '#F1626E',
        textColor1: '#FFF',
        textColor2: '#FFF',
        fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
        fontFamily2: 'GLACIAL_INDIFFERENCE:NORMAL:NORMAL',
        shadow: true,
        lineHeight1: 1.4,
        lineHeight2: 1.4,
        letterSpacing1: 0,
        letterSpacing2: 0
    },
    precalc: {
        oh: '${l__t2__y + l__t2__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 100,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            layoutAlgo: 'fixed',
            x: 20,
            y: 10,
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text1}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            x: 0,
            y: '${l__t2__y}',
            width: '${ow}',
            height: 8,
            fill: '${color1}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Bottom Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 70,
            // lineHeightFactor : 1.4,
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            layoutAlgo: 'fixed',
            x: 20,
            y: '${l__t1__y + l__t1__height}',
            maxWidth: '${ow - l__self__x - 20}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${text2}',
            fill: '${textColor2}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-XrQ6PNFV3',
    desc: 'Non-profit-logo',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            text1: 't1',
            text2: 't2'
        },
        textColors: {
            text1: 'textColor1',
            text2: 'textColor2'
        },
        mappings: {
            primaryColor: 'textColor1'
        },
        placeholders: {
            imageId: 'i1'
        }
    },
    props: {
        textColor1: 'textColor',
        textColor2: 'textColor',
        alpha: 'alpha',
        text1: 'text',
        text2: 'text',
        fontFamily1: 'fontfamily',
        fontFamily2: 'fontfamily',
        lineHeight1: 'lineHeight',
        letterSpacing1: 'letterSpacing',
        lineHeight2: 'lineHeight',
        letterSpacing2: 'letterSpacing',
        imageId: 'imageId',
        cropX: 'cropX',
        cropY: 'cropY',
        cropWidth: 'cropWidth',
        cropHeight: 'cropHeight',
        shadow: 'shadow'
    },
    defaults: {
        color1: '#fff',
        color2: '#f00',
        textColor1: '#fff',
        textColor2: '#fff',
        alpha: 1,
        text1: '',
        text2: 'ROSANE',
        fontFamily1: 'ROBOTO:ULTRA_BOLD:NORMAL',
        fontFamily2: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight1: 1.42,
        letterSpacing1: 0,
        lineHeight2: 1.42,
        letterSpacing2: 0,
        cropX: 28,
        cropY: 0,
        cropWidth: 38,
        cropHeight: 100,
        imageId: 'placeholder',
        shadow: true
    },
    precalc: {
        oh: '${l__i1__height + 20}'
    },
    layers: [{
        id: 't1',
        desc: 'Main text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 140,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight1}',
            letterSpacingFactor: '${letterSpacing1}',
            x: '${l__i1__x + l__i1__width + 30}',
            y: 10,
            maxWidth: '${ow - l__i1__width - 50}',
            height: '${(oh - 40 - 10)/2}',
            text: '${text1}',
            fill: '${textColor1}',
            align: 'left',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'Bottom text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily2}',
            fontSize: 40,
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight2}',
            letterSpacingFactor: '${letterSpacing2}',
            x: '${l__i1__x + l__i1__width + 30 }',
            y: '${l__t1__y + l__t1__height + 40}',
            maxWidth: '${ow - l__i1__width - 50}',
            height: '${(oh - 40 - 10 - 20)/2}',
            text: '${text2}',
            fill: '${textColor2}',
            align: 'left',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${0.8 * alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4,
            maxLines: 1
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'i1',
        desc: 'placeholder layer',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            alpha: '${alpha}',
            x: 20,
            y: 10,
            width: '200',
            height: '200',
            crop: 'circle',
            cropX: '${cropX}',
            cropY: '${cropY}',
            cropWidth: '${cropWidth}',
            cropHeight: '${cropHeight}',
            shadowEnabled: 'false',
            transform: 'scale(1, 1, ${l__i1__width/2}, ${l__i1__height/2})',
            cropEnabled: true
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-gDhmAAst5',
    desc: 'Subtitle-1',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            text: 't1'
        },
        textColors: {
            text: 'textColor'
        },
        mappings: {
            primaryColor: 'textColor'
        }
    },
    props: {
        textColor: 'textColor',
        alpha: 'alpha',
        text: 'text',
        fontFamily: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        fontSize: 'fontSize'
    },
    defaults: {
        textColor: '#fff',
        alpha: 1,
        text: '',
        fontFamily: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        fontSize: 75
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily}',
            fontSize: '${fontSize}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text}',
            fill: '${textColor}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-xpLe5lkXl',
    desc: 'Subtitle 2',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            text: 't1'
        },
        textColors: {
            text: 'textColor'
        },
        mappings: {
            primaryColor: 'textColor'
        }
    },
    props: {
        color: 'color',
        textColor: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text: 'text',
        fontFamily: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        fontSize: 'fontSize',
        shadow: 'shadow'
    },
    defaults: {
        color: '#fff',
        textColor: '#fff',
        alpha: 0.8,
        align: 'center',
        text: '',
        fontFamily: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0,
        fontSize: 80,
        shadow: true
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily}',
            fontSize: '${fontSize}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text}',
            fill: '${textColor}',
            align: '${align}',
            bgAlpha: '${alpha}',
            bgFill: '${color}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 4
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-RowkFqM4M',
    desc: 'Subtitle 3',
    meta: {
        autoHeight: true,
        textEditors: {
            text: 't1'
        },
        textColors: {
            text: 'textColor'
        },
        mappings: {
            primaryColor: 'textColor'
        }
    },
    props: {
        text: 'text',
        color: 'color',
        textColor: 'textColor',
        alpha: 'alpha',
        fontFamily: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        shadow: 'shadow',
        align: 'align',
        fontSize: 'fontSize'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        text: 'MUN',
        color: '#f00',
        textColor: '#ff0',
        fontFamily: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight: 1.4,
        letterSpacing: 0,
        shadow: true,
        fontSize: 80
    },
    precalc: {
        oh: '${l__t1__height+25}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily}',
            fontSize: '${fontSize}',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            layoutAlgo: 'fixed',
            x: 10,
            y: 20,
            maxWidth: '${ow}',
            width: '${calcSelfWidth()}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,20h${ow}V${oh}h${-ow}z',
            align: '${align}',
            text: '${text}',
            fill: '${textColor}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ -l__t1__height }' },
                    // '30%' : { v : '${ -l__t1__height }' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '100%': { v: '${ -l__t1__height }', ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l2',
        desc: 'sliding top line from left',
        type: 'path',
        attrs: {
            d: 'M${l__t1__x},10H${l__t1__width}',
            stroke: '${color}',
            strokeWidth: 14,
            strokeAlpha: '${align == "left" ? 1 : 0}',
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '88.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '92.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '30%': {},
                    '88.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '40.72%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l3',
        desc: 'sliding top line from left',
        type: 'path',
        attrs: {
            d: 'M${ow - 10},10h${-l__t1__width}',
            stroke: '${color}',
            strokeWidth: 14,
            strokeAlpha: '${align == "right" ? 1 : 0}',
            alpha: '${alpha}',
            fillAlpha: 0,
            strokeTrimStart: 0,
            strokeTrimEnd: 100,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeTrimEnd: {
                    '0%': { v: 0 },

                    '88.18%': { ease: 'easyEaseInOut' },
                    '100%': {}
                },
                strokeTrimStart: {
                    '0%': { v: 0 },
                    '10.72%': { v: 0 },
                    '92.72%': { ease: 'easyEaseInOut' },
                    '100%': {}
                }
            },
            exitkeyframes: {
                strokeTrimStart: {
                    '0%': {},
                    '88.18%': { v: 0, ease: 'easyEaseInOutReverse' },
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                },
                strokeTrimEnd: {
                    '0%': {},
                    '40.72%': {},
                    '100%': { v: 0, ease: 'easyEaseInOutReverse' }
                }
            }
        }
    }, {
        id: 'l1',
        desc: 'Middle line',
        type: 'rect',
        attrs: {
            x: '${ow/2 - l__self__width/2}',
            width: '${l__t1__width}',
            y: 2,
            height: 14,
            fill: '${color}',
            alpha: '${align == "center" ? 1 : 0}',
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                x: {
                    '0%': { v: '${0.5*ow}' },
                    '88%': { ease: 'easyEaseInOut' }
                },
                width: {
                    '0%': { v: 0 },
                    '88%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                x: {
                    '40%': {},
                    '100%': { v: '${0.5*ow}', ease: 'easyEaseInOut' }
                },
                width: {
                    '40%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-fxkzh3ilU',
    desc: 'Subtitle 4',
    meta: {
        autoHeight: true,
        textEditors: {
            text: 't1'
        },
        textColors: {
            text: 'textColor'
        },
        mappings: {
            primaryColor: 'textColor'
        }
    },
    props: {
        alpha: 'alpha',
        align: 'align',
        color: 'color',
        textColor: 'textColor',
        text: 'text',
        fontFamily: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        shadow: 'shadow',
        fontSize: 'fontSize'
    },
    defaults: {
        alpha: 1,
        align: 'center',
        color: '#FFF',
        textColor: '#FFF',
        text: 'Macron Vs. Merkel',
        fontFamily: 'MONTSERRAT:MEDIUM:NORMAL',
        lineHeight: 1.4,
        shadow: false,
        fontSize: 80
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Main Text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily}',
            x: 60,
            fontSize: '${fontSize}',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            clipPath: 'M30,0h${ow}v${l__self__height}H0z',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            maxWidth: '${ow-120}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text}',
            fill: '${textColor}',
            alpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowBlur: 6
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ l__t1__height }' },
                    '5%': { v: '${ l__t1__height }' },
                    '60%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '60%': { v: '${ l__t1__height }', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b1',
        desc: 'Left Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M0,0H10V${oh}H0z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${-oh-20}' },
                    '20%': { v: '${-oh-20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${oh+20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }, {
        id: 'b2',
        desc: 'Right Border',
        type: 'rect',
        attrs: {
            fillAlpha: 0,
            stroke: '${color}',
            strokeWidth: 20,
            strokeAlpha: 1,
            alpha: '${alpha}',
            clipPath: 'M${ow-10},0H${ow}V${oh}H${ow-10}z'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh+20}' },
                    '20%': { v: '${oh+20}' },
                    '50%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '10%': {},
                    '50%': { v: '${-oh-20}', ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-5PRXPOBd1',
    desc: 'Subtitle-5',
    meta: {
        autoHeight: true,
        textEditors: {
            text: 't1'
        },
        textColors: {
            text: 'textColor'
        },
        mappings: {
            primaryColor: 'textColor'
        }
    },
    props: {
        textColor: 'textColor',
        alpha: 'alpha',
        text: 'text',
        fontFamily: 'fontfamily',
        align: 'align',
        shadow: 'shadow',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        fontSize: 'fontSize',
        color: 'color'
    },
    defaults: {
        textColor: '#fff',
        alpha: 1,
        text: '',
        fontFamily: 'ROBOTO:ULTRA_BOLD:NORMAL',
        align: 'left',
        shadow: false,
        lineHeight: 1.42,
        letterSpacing: 0,
        fontSize: 75,
        color: '#000'
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Only text',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily}',
            fontSize: '${fontSize}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            maxWidth: '${ow}',
            height: '${calcSelfHeight()}',
            align: '${align}',
            text: '${text}',
            fill: '${textColor}',
            alpha: 1,
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            clipPath: 'M0,0H${ow}V${oh}H0z',
            bgAlpha: '${alpha}',
            bgFill: '${color}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${ l__t1__height }' },
                    '100%': { ease: 'easyEaseInOut' }
                }
            },
            exitkeyframes: {
                y: {
                    '0%': {},
                    '100%': { v: '${ -l__t1__height }', ease: 'easyEaseInOut' }
                },
                alpha: {
                    '0%': {},
                    '100%': { v: 0, ease: 'easyEaseInOut' }
                }
            }
        }
    }]
});

defs.push({
    id: 'defId-XnF23RgVH',
    desc: 'Subtitle 6',
    meta: {
        autoHeight: true,
        canOverrideAnimation: true,
        textEditors: {
            text: 't1'
        },
        textColors: {
            text: 'textColor'
        },
        mappings: {
            primaryColor: 'textColor'
        }
    },
    props: {
        color: 'color',
        textColor: 'textColor',
        alpha: 'alpha',
        align: 'align',
        text: 'text',
        fontFamily: 'fontfamily',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        shadow: 'shadow',
        fontSize: 'fontSize'
    },
    defaults: {
        color: '#fff',
        textColor: '#fff',
        alpha: 0.8,
        align: 'center',
        text: '',
        fontFamily: 'ROBOTO:ULTRA_BOLD:NORMAL',
        lineHeight: 1.42,
        letterSpacing: 0,
        shadow: false,
        fontSize: 75
    },
    precalc: {
        oh: '${l__t1__height}'
    },
    layers: [{
        id: 't1',
        desc: 'Text Only',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily}',
            fontSize: '${fontSize}',
            lineSpacing: 0,
            layoutAlgo: 'fixed',
            lineHeightFactor: '${lineHeight}',
            letterSpacingFactor: '${letterSpacing}',
            x: 20,
            y: 0,
            maxWidth: '${ow-40}',
            height: '${calcSelfHeight()}',
            clipPath: 'M0,0h${ow}v${oh}h${-ow}z',
            text: '${text}',
            fill: '${textColor}',
            align: '${align}',
            bgAlpha: '${alpha}',
            bgFill: '${color}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-0G2V5Ey0N',
    desc: 'Countdown Template 1',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        timeFormat: 'timeFormat',
        shadow: 'shadow',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        color2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        timeFormat: 'SECS',
        shadow: false,
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: 300,
        ow: 275
    },
    layers: [{
        id: 's2',
        desc: 'timer circle',
        type: 'path',
        attrs: {
            d: 'M${(oh-100)/2},0A${(oh-100)/2},${(oh-100)/2} 0 1,1 ${(oh-100)/2-1},0z',
            height: '${oh}',
            y: 90,
            x: 40,
            fillAlpha: 0,
            strokeAlpha: '${alpha/2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'timer circle fill',
        type: 'path',
        attrs: {
            d: 'M${(oh-100)/2},0A${(oh-100)/2},${(oh-100)/2} 0 1,1 ${(oh-100)/2-1},0z',
            height: '${oh}',
            y: 90,
            x: 40,
            fillAlpha: 0,
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 120,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: 50,
            y: '${(oh - calcSelfHeight())/2 + 40}',
            width: '${ow-100}',
            maxWidth: '${ow-100}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            timeFormat: '${timeFormat}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'text layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 40,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: 25,
            y: 0,
            width: '${ow - 10}',
            maxWidth: '${ow - 50}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "MINUTES": "SECONDS"}',
            fill: '${color1}',
            bgFill: '${color2}',
            bgAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-oWm7tEZbb',
    desc: 'Countdown Template 2',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        timeFormat: 'timeFormat',
        shadow: 'shadow',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        color2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        timeFormat: 'SECS',
        shadow: false,
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: 300,
        ow: 275
    },
    layers: [{
        id: 's3',
        desc: 'background',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 's4m'
            }]
        },
        attrs: {
            y: 90,
            x: 45,
            width: 190,
            height: 200,
            fill: '${color2}',
            fillAlpha: '${alpha/1.5}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 's4m',
        desc: 'timer circle',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M 5, 100a 95,95 0 1,1 190,0a 95,95 0 1,1 -190,0',
            height: '${oh}',
            y: 90,
            x: 40,
            fillAlpha: 1,
            strokeAlpha: 0,
            strokeWidth: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's2',
        desc: 'timer circle',
        type: 'path',
        attrs: {
            d: 'M${(oh-100)/2},0A${(oh-100)/2},${(oh-100)/2} 0 1,1 ${(oh-100)/2-1},0z',
            //d:'M 10, 100a 90,90 0 1,1 180,0a 90,90 0 1,1 -180,0',
            height: '${oh}',
            y: 90,
            x: 40,
            fillAlpha: 0,
            fill: 'red',
            strokeAlpha: '${alpha}',
            strokeWidth: 10,
            stroke: '${color2}',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 120,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: 50,
            y: '${(oh - calcSelfHeight())/2 + 40}',
            width: '${ow - 100}',
            maxWidth: '${ow - 100}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'text layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 40,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: 25,
            y: 0,
            width: '${ow - 10}',
            maxWidth: '${ow - 50}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "MINUTES": "SECONDS"}',
            fill: '${color1}',
            bgFill: '${color2}',
            bgAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-d3qv8ja2b',
    desc: 'Countdown Template 3',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        timeFormat: 'timeFormat',
        shadow: 'shadow',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        color2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        timeFormat: 'SECS',
        shadow: false,
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: 300,
        ow: 275
    },
    layers: [{
        id: 'cl1',
        desc: 'circle line 1',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1m'
            }]
        },
        attrs: {
            d: 'M${(oh-100)/2},0A${(oh-100)/2},${(oh-100)/2} 0 1,1 ${(oh-100)/2-1},0z',
            y: 90,
            x: 40,
            fillAlpha: 0,
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 ${PI * (ow + 80)}'
            },
            strokeWidth: 200,
            strokeAlpha: '${alpha * 0.77}'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '100%'
                        },
                        ease: 'linear'
                    }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 's1m',
        desc: 'timer circle fill',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M${(oh-100)/2},0A${(oh-100)/2},${(oh-100)/2} 0 1,1 ${(oh-100)/2-1},0z',
            height: '${oh}',
            y: 90,
            x: 40,
            fillAlpha: 1,
            strokeWidth: 0,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'timer circle',
        type: 'path',
        attrs: {
            d: 'M${(oh-100)/2},0A${(oh-100)/2},${(oh-100)/2} 0 1,1 ${(oh-100)/2-1},0z',
            height: '${oh}',
            y: 90,
            x: 40,
            fillAlpha: 0,
            strokeWidth: 10,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeCap: 'round',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 120,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: 50,
            y: '${(oh - calcSelfHeight())/2 + 40}',
            width: '${ow-100}',
            maxWidth: '${ow-100}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${color1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't2',
        desc: 'text layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 40,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: 25,
            y: 0,
            width: '${ow - 10}',
            maxWidth: '${ow - 50}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "MINUTES": "SECONDS"}',
            fill: '${color1}',
            bgFill: '${color2}',
            bgAlpha: '${alpha}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-ZRaU2irIU',
    desc: 'Countdown Template 4',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        timeFormat: 'timeFormat',
        shadow: 'shadow',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        timeFormat: 'SECS',
        shadow: false,
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: 300,
        ow: 300
    },
    layers: [{
        id: 's2',
        desc: 'timer circle',
        type: 'path',
        attrs: {
            d: 'M${(oh)/2},0A${(oh-20)/2},${(oh-20)/2} 0 1,1 ${(oh-20)/2-1},0z',
            height: '${oh}',
            y: 10,
            x: 10,
            fillAlpha: 0,
            strokeAlpha: '${alpha/2}',
            strokeWidth: 20,
            stroke: '${color1}',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'timer circle fill',
        type: 'path',
        attrs: {
            d: 'M${(oh)/2},0A${(oh-20)/2},${(oh-20)/2} 0 1,1 ${(oh-20)/2-1},0z',
            height: '${oh}',
            y: 10,
            x: 10,
            fillAlpha: 0,
            strokeWidth: 20,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeEnd: '0'
                        }
                    },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 150,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${ow/12}',
            y: '${(oh - calcSelfHeight())/2}',
            width: '${5*ow/6}',
            maxWidth: '${5*ow/6}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${textColor1}',
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            timeFormat: '${timeFormat}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-6EglX08N_',
    desc: 'Countdown Template 5',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        color1: 'color',
        color2: 'color',
        textColor1: 'textColor',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        timeFormat: 'timeFormat',
        shadow: 'shadow',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        color2: '#f00',
        textColor1: '#fff',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        timeFormat: 'SECS',
        shadow: false,
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: 300,
        ow: 300
    },
    layers: [{
        id: 's3',
        desc: 'background',
        type: 'rect',
        meta: {
            masks: [{
                mLayerId: 's4m'
            }]
        },
        attrs: {
            y: 0,
            x: 0,
            width: 390,
            height: 400,
            fill: '${color2}',
            fillAlpha: '${alpha/1.5}'
        },
        animation: {
            enterkeyframes: {
                y: {
                    '0%': { v: '${oh}' },
                    '100%': { ease: 'linear' }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 's4m',
        desc: 'timer circle',
        type: 'path',
        meta: {
            shy: true
        },
        attrs: {
            d: 'M 3, 148a 145,145 0 1,1 290,0a 145,145 0 1,1 -290,0',
            height: '${oh}',
            y: 5,
            x: 5,
            fillAlpha: 1,
            strokeAlpha: 0,
            strokeWidth: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's2',
        desc: 'timer circle',
        type: 'path',
        attrs: {
            d: 'M${(oh)/2},0A${(oh-10)/2},${(oh-10)/2} 0 1,1 ${(oh-10)/2-1},0z',
            height: '${oh}',
            y: 5,
            x: 5,
            fillAlpha: 0,
            fill: 'red',
            strokeAlpha: '${alpha}',
            strokeWidth: 10,
            stroke: '${color2}',
            strokeCap: 'round',
            strokeRangeProps: {
                strokeRangeStart: '0%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '999999 0'
            },
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 150,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${ow/12}',
            y: '${(oh - calcSelfHeight())/2}',
            width: '${5*ow/6}',
            maxWidth: '${5*ow/6}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

defs.push({
    id: 'defId-5tgtQy3zF',
    desc: 'Countdown Template 6',
    meta: {
        autoHeight: true,
        scaleOnly: true,
        templateType: 'timer',
        containsCounter: true,
        containsAudio: true,
        textColors: {
            text1: 'textColor1'
        },
        mappings: {
            primaryColor: 'color1'
        }
    },
    props: {
        alpha: 'alpha',
        textColor1: 'textColor',
        color1: 'color',
        color2: 'color',
        fontFamily1: 'fontfamily',
        isAscendingTimer: 'isAscendingTimer',
        shadow: 'shadow',
        timeFormat: 'timeFormat',
        audioId1: 'audioId',
        volume1: 'volume',
        audioId2: 'audioId',
        volume2: 'volume',
        audioDuration1: 'audioDuration'
    },
    defaults: {
        alpha: 0.8,
        color1: '#fff',
        textColor1: '#fff',
        color2: '#f00',
        fontFamily1: 'MONTSERRAT:MEDIUM:NORMAL',
        isAscendingTimer: false,
        shadow: false,
        timeFormat: 'SECS',
        audioId1: 'COUNTDOWN_BEEP_1',
        volume1: 100,
        audioDuration1: 3000,
        audioId2: 'COUNTDOWN_BEEP_END_1',
        volume2: 100
    },
    precalc: {
        oh: 300,
        ow: 300
    },
    layers: [{
        id: 'cl1',
        desc: 'circle line 1',
        type: 'path',
        meta: {
            masks: [{
                mLayerId: 's1m'
            }]
        },
        attrs: {
            d: 'M${(oh)/2},0A${(oh-20)/2},${(oh-20)/2} 0 1,1 ${(oh-20)/2-1},0z',
            y: 10,
            x: 10,
            fillAlpha: 0,
            stroke: '${color2}',
            strokeRangeProps: {
                strokeRangeStart: '100%',
                strokeRangeEnd: '100%',
                strokeDashoffset: '0',
                strokeDasharray: '0 ${PI * (ow + 80)}'
            },
            strokeWidth: 280,
            strokeAlpha: '${alpha * 0.77}'
        },
        animation: {
            enterkeyframes: {
                strokeRangeProps: {
                    '0%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '0%'
                        }
                    },
                    '100%': {
                        v: {
                            strokeRangeStart: '0%',
                            strokeRangeEnd: '100%'
                        },
                        ease: 'linear'
                    }
                }
            },
            exitkeyframes: {}
        }
    }, {
        id: 's1m',
        desc: 'timer circle fill',
        type: 'path',
        meta: { shy: true },
        attrs: {
            d: 'M${(oh)/2},0A${(oh-20)/2},${(oh-20)/2} 0 1,1 ${(oh-20)/2-1},0z',
            height: '${oh}',
            y: 10,
            x: 10,
            fillAlpha: 1,
            strokeWidth: 0,
            shadowEnabled: 'false'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 's1',
        desc: 'timer circle',
        type: 'path',
        attrs: {
            d: 'M${(oh)/2},0A${(oh-20)/2},${(oh-20)/2} 0 1,1 ${(oh-20)/2-1},0z',
            height: '${oh}',
            y: 10,
            x: 10,
            fillAlpha: 0,
            strokeWidth: 10,
            stroke: '${color1}',
            strokeAlpha: '${alpha}',
            strokeCap: 'round',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 't1',
        desc: 'countdown layer',
        type: 'text',
        attrs: {
            fontFamily: '${fontFamily1}',
            fontSize: 150,
            lineHeightFactor: 1.2,
            letterSpacingFactor: 0,
            layoutAlgo: 'fixed',
            x: '${ow/12}',
            y: '${(oh - calcSelfHeight())/2 }',
            width: '${5*ow/6}',
            maxWidth: '${5*ow/6}',
            height: '${calcSelfHeight()}',
            align: 'center',
            text: '${timeFormat == "MINS"? "10:00": "10"}',
            fill: '${textColor1}',
            shadowEnabled: '${shadow}',
            shadowColor: "${shadow ? calcSelfShadowColor() : '#fff'}",
            shadowAlpha: '${l__self__alpha}',
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 3,
            isCounterLayer: true,
            isAscendingTimer: '${isAscendingTimer}',
            timeFormat: '${timeFormat}'
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a1',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId1}',
            volume: '${volume1}',
            audioDuration: '${audioDuration1}',
            exitOffset: 1000
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }, {
        id: 'a2',
        desc: 'audio layer',
        type: 'audio',
        attrs: {
            audioId: '${audioId2}',
            volume: '${volume2}',
            audioDuration: '${audioDuration1 > 0? 1000: 0}',
            exitOffset: 0
        },
        animation: {
            enterkeyframes: {},
            exitkeyframes: {}
        }
    }]
});

exports.default = (0, _GeneralUtils.deepFreeze)(defs);

},{"../utils/GeneralUtils":77}],40:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../utils/GeneralUtils');

var animDefList = [];

function addAnimationDef(_ref) {
    var id = _ref.id,
        type = _ref.type,
        displayName = _ref.displayName,
        desc = _ref.desc,
        keyframes = _ref.keyframes,
        _ref$flag = _ref.flag,
        flag = _ref$flag === undefined ? null : _ref$flag;

    animDefList.push({
        id: id,
        type: type,
        displayName: displayName,
        desc: desc,
        keyframes: keyframes,
        flag: flag
    });
}

// FADE_IN
addAnimationDef({
    id: 'animDefId-FADE-IN',
    type: 'enter',
    displayName: 'Fade In',
    desc: '',
    keyframes: {
        gl_alpha: {
            '0%': { v: 0 },
            '100%': {}
        }
    }
});

// FADE_OUT
addAnimationDef({
    id: 'animDefId-FADE-OUT',
    type: 'exit',
    displayName: 'Fade Out',
    desc: '',
    keyframes: {
        gl_alpha: {
            '100%': { v: 0 }
        }
    }
});

// FROM_LEFT
addAnimationDef({
    id: 'animDefId-FROM-LEFT',
    type: 'enter',
    displayName: 'From Left',
    desc: '',
    keyframes: {
        gl_x: {
            '0%': { v: '${-(gw + gx)}' },
            '100%': {}
        }
    }
});

// FROM_LEFT_LINEAR
addAnimationDef({
    id: 'animDefId-FROM-LEFT-LINEAR',
    type: 'enter',
    displayName: 'From Left Linear',
    desc: '',
    keyframes: {
        gl_x: {
            '0%': { v: '${-(gw + gx)}' },
            '100%': { ease: 'linear' }
        }
    },
    flag: 'feature_flag_linear_anim'
});

// TO_LEFT
addAnimationDef({
    id: 'animDefId-TO-LEFT',
    type: 'exit',
    displayName: 'To Left',
    desc: '',
    keyframes: {
        gl_x: {
            '100%': { v: '${-(gw + gx)}' }
        }
    }
});

// TO_LEFT_LINEAR
addAnimationDef({
    id: 'animDefId-TO-LEFT-LINEAR',
    type: 'exit',
    displayName: 'To Left Linear',
    desc: '',
    keyframes: {
        gl_x: {
            '100%': { v: '${-(gw + gx)}', ease: 'linear' }
        }
    },
    flag: 'feature_flag_linear_anim'
});

// FROM_TOP
addAnimationDef({
    id: 'animDefId-FROM-TOP',
    type: 'enter',
    displayName: 'From Top',
    desc: '',
    keyframes: {
        gl_y: {
            '0%': { v: '${-(gh + gy)}' },
            '100%': {}
        }
    }
});

// TO_TOP
addAnimationDef({
    id: 'animDefId-TO-TOP',
    type: 'exit',
    displayName: 'To Top',
    desc: '',
    keyframes: {
        gl_y: {
            '100%': { v: '${-(gh + gy)}' }
        }
    }
});

// FROM_RIGHT
addAnimationDef({
    id: 'animDefId-FROM-RIGHT',
    type: 'enter',
    displayName: 'From Right',
    desc: '',
    keyframes: {
        gl_x: {
            '0%': { v: '${cw - gx}' },
            '100%': {}
        }
    }
});

// FROM_RIGHT_LINEAR
addAnimationDef({
    id: 'animDefId-FROM-RIGHT-LINEAR',
    type: 'enter',
    displayName: 'From Right Linear',
    desc: '',
    keyframes: {
        gl_x: {
            '0%': { v: '${cw - gx}' },
            '100%': { ease: 'linear' }
        }
    },
    flag: 'feature_flag_linear_anim'
});

// TO_RIGHT
addAnimationDef({
    id: 'animDefId-TO-RIGHT',
    type: 'exit',
    displayName: 'To Right',
    desc: '',
    keyframes: {
        gl_x: {
            '100%': { v: '${cw - gx}' }
        }
    }
});

// TO_RIGHT_LINEAR
addAnimationDef({
    id: 'animDefId-TO-RIGHT-LINEAR',
    type: 'exit',
    displayName: 'To Right Linear',
    desc: '',
    keyframes: {
        gl_x: {
            '100%': { v: '${cw - gx}', ease: 'linear' }
        }
    },
    flag: 'feature_flag_linear_anim'
});

// FROM_BOTTOM
addAnimationDef({
    id: 'animDefId-FROM-BOTTOM',
    type: 'enter',
    displayName: 'From Bottom',
    desc: '',
    keyframes: {
        gl_y: {
            '0%': { v: '${ch - gy}' },
            '100%': {}
        }
    }
});

// TO_BOTTOM
addAnimationDef({
    id: 'animDefId-TO-BOTTOM',
    type: 'exit',
    displayName: 'To Bottom',
    desc: '',
    keyframes: {
        gl_y: {
            '100%': { v: '${ch - gy}' }
        }
    }
});

// POP_IN
addAnimationDef({
    id: 'animDefId-POP-IN',
    type: 'enter',
    displayName: 'Pop In',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '0%': { v: 'matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1)' },
            '100%': { ease: 'elasticEaseOut' }
        }
    }
});

// POP_OUT
addAnimationDef({
    id: 'animDefId-POP-OUT',
    type: 'exit',
    displayName: 'Pop Out',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '100%': { v: 'matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1)', ease: 'elasticEaseIn' }
        }
    }
});

// REVEAL_IN_LEFT
addAnimationDef({
    id: 'animDefId-REVEAL-IN-LEFT',
    type: 'enter',
    displayName: 'Reveal In Left',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${gx-ox},${gy-oy}L${gx-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_OUT_LEFT
addAnimationDef({
    id: 'animDefId-REVEAL-OUT-LEFT',
    type: 'exit',
    displayName: 'Reveal Out Left',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${gx-ox},${gy-oy}L${gx-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_IN_TOP
addAnimationDef({
    id: 'animDefId-REVEAL-IN-TOP',
    type: 'enter',
    displayName: 'Reveal In Top',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${gx-ox},${gy-oy}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_OUT_TOP
addAnimationDef({
    id: 'animDefId-REVEAL-OUT-TOP',
    type: 'exit',
    displayName: 'Reveal Out Top',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${gx-ox},${gy-oy}Z' }
        }
    }
});

// REVEAL_IN_RIGHT
addAnimationDef({
    id: 'animDefId-REVEAL-IN-RIGHT',
    type: 'enter',
    displayName: 'Reveal In Right',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${(gx+gw)-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_OUT_RIGHT
addAnimationDef({
    id: 'animDefId-REVEAL-OUT-RIGHT',
    type: 'exit',
    displayName: 'Reveal Out Right',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${(gx+gw)-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_IN_BOTTOM
addAnimationDef({
    id: 'animDefId-REVEAL-IN-BOTTOM',
    type: 'enter',
    displayName: 'Reveal In Bottom',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${(gy+gh)-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_OUT_BOTTOM
addAnimationDef({
    id: 'animDefId-REVEAL-OUT-BOTTOM',
    type: 'exit',
    displayName: 'Reveal Out Bottom',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${gx-ox},${(gy+gh)-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_IN_CENTER
addAnimationDef({
    id: 'animDefId-REVEAL-IN-CENTER',
    type: 'enter',
    displayName: 'Reveal In Center',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}L${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}L${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}L${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}Z' },
            '100%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' }
        }
    }
});

// REVEAL_OUT_CENTER
addAnimationDef({
    id: 'animDefId-REVEAL-OUT-CENTER',
    type: 'exit',
    displayName: 'Reveal Out Center',
    desc: '',
    keyframes: {
        gl_clipPath: {
            '0%': { v: 'M${gx-ox},${gy-oy}L${(gx+gw)-ox},${gy-oy}L${(gx+gw)-ox},${(gy+gh)-oy}L${gx-ox},${(gy+gh)-oy}Z' },
            '100%': { v: 'M${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}L${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}L${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}L${((gx+gw)-ox)/2},${((gy+gh)-oy)/2}Z' }
        }
    }
});

// ZOOM_IN
addAnimationDef({
    id: 'animDefId-ZOOM-IN',
    type: 'enter',
    displayName: 'Zoom In',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '0%': { v: 'matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1)' },
            '100%': {}
        }
    }
});

// ZOOM_OUT
addAnimationDef({
    id: 'animDefId-ZOOM-OUT',
    type: 'exit',
    displayName: 'Zoom Out',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '100%': { v: 'matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1)' }
        }
    }
});

// SWIVEL_IN_HORZ
addAnimationDef({
    id: 'animDefId-SWIVEL-IN-HORZ',
    type: 'enter',
    displayName: 'Swivel in horizontal',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '0%': { v: 'matrix3d(0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 1)' },
            '100%': {}
        }
    }
});

// SWIVEL_OUT_HORZ
addAnimationDef({
    id: 'animDefId-SWIVEL-OUT-HORZ',
    type: 'exit',
    displayName: 'Swivel out horizontal',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '100%': { v: 'matrix3d(0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 1)'
            }
        }
    }
});

// SWIVEL_IN_VERT
addAnimationDef({
    id: 'animDefId-SWIVEL-IN-VERT',
    type: 'enter',
    displayName: 'Swivel in vertical',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '0%': { v: 'matrix3d(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1)' },
            '100%': {}
        }
    }
});

// SWIVEL_OUT_VERT
addAnimationDef({
    id: 'animDefId-SWIVEL-OUT-VERT',
    type: 'exit',
    displayName: 'Swivel out vertical',
    desc: '',
    keyframes: {
        gl_transformOrigin: {
            'pre': { v: '${gw/2 + gx - ox} ${gh/2 + gy - oy}' }
        },
        gl_transform: {
            '100%': { v: 'matrix3d(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1)'
            }
        }
    }
});

// NONE
addAnimationDef({
    id: 'animDefId-IN-NONE',
    type: 'enter',
    displayName: 'None',
    desc: '',
    keyframes: {
        gl_alpha: {
            '0%': { v: 1 }
        }
    }
});

// NONE
addAnimationDef({
    id: 'animDefId-OUT-NONE',
    type: 'exit',
    displayName: 'None',
    desc: '',
    keyframes: {
        gl_alpha: {
            '0%': { v: 0 }
        }
    }
});

exports.default = (0, _GeneralUtils.deepFreeze)(animDefList);

},{"../utils/GeneralUtils":77}],41:[function(require,module,exports){
module.exports=[
    {
        "startTime": 0,
        "endTime": 7263,
        "text": "Why LinkedIn is the place to be right now.\nLinkedIn is poppin."
    },
    {
        "startTime": 7600,
        "endTime": 11299,
        "text": "Seriously people, we are in the \nprime time of this platform."
    },
    {
        "startTime": 11300,
        "endTime": 15605,
        "text": "What is prime time? It's easy to grow.\nIt's easy to get reach on your content. "
    },
    {
        "startTime": 15648,
        "endTime": 19521,
        "text": "The platform is generous right now, \nand it won't be forever!"
    },
    {
        "startTime": 25518,
        "endTime": 28854,
        "text": " Pretty much anyone who made a Facebook page in 2013, and bang their"
    },
    {
        "startTime": 28900,
        "endTime": 32547,
        "text": " head against the keyboard every day,\ngrew a following and made money off of it "
    },
    {
        "startTime": 41776,
        "endTime": 44600,
        "text": " You better pay up! \nZucks needs that money."
    },
    {
        "startTime": 44700,
        "endTime": 49999,
        "text": "All right. I'm not trying to scare you. \nBut the point is, this won't last forever."
    },
    {
        "startTime": 50000,
        "endTime": 52816,
        "text": "The reason being is that the \nmore people that come to the platform,"
    },
    {
        "startTime": 54733,
        "endTime": 59898,
        "text": "Right now, there's not enough LinkedIn influencers. Take advantage of it now!"
    },
    {
        "startTime": 59900,
        "endTime": 63349,
        "text": "And when you feel like you're making enough content, make 10 times more."
    },
    {
        "startTime": 65053,
        "endTime": 68577,
        "text": "PS: Grant Cardone should also be playing in the background of your office all day."
    },
    {
        "startTime": 68580,
        "endTime": 71996,
        "text": "Again, I'm not trying to scare you. \nI'm trying to motivate you."
    },
    {
        "startTime": 75138,
        "endTime": 76499,
        "text": "Get after it."
    },
    {
        "startTime": 76500,
        "endTime": 79323,
        "text": "I think LinkedIn is going to \npass up Facebook. Seriously."
    },
    {
        "startTime": 79415,
        "endTime": 82992,
        "text": "Eventually, of course. What other social media platform has this many"
    },
    {
        "startTime": 85236,
        "endTime": 89299,
        "text": "Yeah, you might be able to market your pizza print pajamas better on a platform"
    },
    {
        "startTime": 89300,
        "endTime": 94706,
        "text": "like Facebook, but B2B? B2B? \nB2B be on LinkedIn yo!"
    },
    {
        "startTime": 94775,
        "endTime": 96699,
        "text": "Get after it. \nGet creative."
    },
    {
        "startTime": 96700,
        "endTime": 99499,
        "text": "I got some more tips and surprises coming out for all of you soon."
    },
    {
        "startTime": 99500,
        "endTime": 104021,
        "text": "But in the meantime, the bottom line is,\nor should I say the Rowbottom line is,"
    },
    {
        "startTime": 104121,
        "endTime": 108999,
        "text": "For now, just start. Done is better than perfect and you can do it."
    },
    {
        "startTime": 109000,
        "endTime": 111499,
        "text": "Have you achieved success in leads through Linkedin?"
    },
    {
        "startTime": 111500,
        "endTime": 115899,
        "text": "If so, how? Share your story below \nand if not, that's totally fine."
    },
    {
        "startTime": 115900,
        "endTime": 118985,
        "text": "But tell me, what's the number one biggest reason that's preventing"
    },
    {
        "startTime": 119115,
        "endTime": 121999,
        "text": "you from making video content \non LinkedIn, today!"
    },
    {
        "startTime": 19522,
        "endTime": 22077,
        "text": "Let me tell you about my experience working on Facebook"
    },
    {
        "startTime": 22078,
        "endTime": 25518,
        "text": "the past couple of years. Facebook \nwent through the same thing."
    },
    {
        "startTime": 32548,
        "endTime": 35024,
        "text": "And I mean serious money!"
    },
    {
        "startTime": 38307,
        "endTime": 41125,
        "text": "Just like that! Try growing a following\non Facebook today,"
    },
    {
        "startTime": 52817,
        "endTime": 54733,
        "text": "the more saturated it gets."
    },
    {
        "startTime": 63350,
        "endTime": 64999,
        "text": "10X that issue baby!"
    },
    {
        "startTime": 72021,
        "endTime": 75137,
        "text": " Wake up people, this platform \nis incredble!"
    },
    {
        "startTime": 82993,
        "endTime": 85213,
        "text": "educated people on it with money? "
    },
    {
        "startTime": 122000,
        "endTime": 124041,
        "text": "Share in the comments below, \nand remember,"
    },
    {
        "startTime": 124062,
        "endTime": 127940,
        "text": "you have a window of opportunity. \nTake advantage of it, right now!"
    }
]

},{}],42:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadTemplates = exports.createTemplateFromDef = exports.REFERENCE_CANVAS = undefined;

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _cloneextend = require('cloneextend');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _TemplateTypes = require('../constants/TemplateTypes');

var _TemplateTypes2 = _interopRequireDefault(_TemplateTypes);

var _general = require('../../edit/components/utility/pluginUtils/general');

var _PluginService = require('../constants/PluginService');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var REFERENCE_CANVAS = exports.REFERENCE_CANVAS = { width: 1920, height: 1080 };

var TemplateConfig = {
    text: [{
        id: 'basic',
        title: 'BASIC',
        items: []
    }, {
        id: 'presets',
        title: 'STYLISED',
        items: []
    }, {
        id: 'subtitles',
        title: 'SUBTITLES',
        items: []
    }],
    images: [
    // {
    //     id: 'shapes',
    //     title: 'SHAPES',
    //     items: [],
    // },
    // {
    //     id: 'icons',
    //     title: 'ICONS',
    //     items: [],
    // },
    {
        id: 'workspaceImages',
        title: 'YOUR IMAGES',
        items: []
    },
    // new type of templates , pure SVG layers
    // with time the layers will be more customizable
    // primarily used for svg assets
    {
        id: 'svg-assets',
        title: 'SVG-ASSETS',
        items: []
    }],
    workspaceTemplates: [{
        id: 'saved',
        title: 'SAVED',
        items: []
    }]
};

var staticBaseUrl = window.getStaticBaseUrl();

var createTemplateFromDef = function createTemplateFromDef(defId) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'noname';
    var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var previewOverrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var displayPrefs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var ready = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var _overrides$space = overrides.space,
        space = _overrides$space === undefined ? {} : _overrides$space,
        _overrides$time = overrides.time,
        time = _overrides$time === undefined ? {} : _overrides$time,
        _overrides$values = overrides.values,
        values = _overrides$values === undefined ? {} : _overrides$values;

    var def = null;
    if (defId.constructor === Object) {
        def = (0, _cloneextend.clone)(defId);
        defId = def.id;
    } else {
        def = getTemplateDefForId(defId);
    }

    var o = (0, _deepmerge2.default)({
        id: _shortid2.default.generate(),
        name: name,
        defId: defId,
        space: {
            width: 300,
            height: 200,
            transform: ''
        },
        time: {
            enterstart: 0,
            enterdone: 200,
            exitstart: 3800,
            exitdone: 4000
        }
    }, overrides);

    o = (0, _deepmerge2.default)(o, { ready: ready });

    if ('nativeAspectRatio' in def.meta) {
        o = (0, _deepmerge2.default)(o, {
            space: {
                height: o.space.width / def.meta.nativeAspectRatio
            }
        });
        if (!!previewOverrides && !!previewOverrides.space && !!previewOverrides.space.width) {
            previewOverrides = (0, _deepmerge2.default)(previewOverrides, {
                space: {
                    height: previewOverrides.space.width / def.meta.nativeAspectRatio
                }
            });
        }
    }

    o = (0, _deepmerge2.default)(o, { previewOverrides: previewOverrides, displayPrefs: displayPrefs });

    return o;
};

function loadTemplates() {
    var addedTemplates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var ShapeIconNameMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var textBasic = TemplateConfig.text.find(function (grp) {
        return grp.id === 'basic';
    });
    var textPresets = TemplateConfig.text.find(function (grp) {
        return grp.id === 'presets';
    });
    var textSubtitles = TemplateConfig.text.find(function (grp) {
        return grp.id === 'subtitles';
    });

    var fitnessSpecificTextBasic = [createTemplateFromDef('defId-rJYdu5OpM', 'virtual-fitness-class', {
        space: {
            width: 549.899774674389,
            height: 207.38563692798476,
            transform: 'matrix(1.2344383150475284, 0, 0, 1.2344383150475284, 0, 0)',
            x: 685.0501126628055,
            y: 436.30718153600765,
            referenceCanvas: {
                width: 1920,
                height: 1080
            },
            zIndex: 8
        },
        time: {
            enterstart: 200,
            enterdone: 2200,
            exitstart: 4000,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            color1: '#F30000',
            color2: '#F30000',
            textColor1: 'rgb(255, 255, 255)',
            textColor2: 'rgb(255, 255, 255)',
            text1: '30 MIN',
            text2: 'HIIT WORKOUT',
            fontFamily1: 'ARCHIVO_NARROW:BOLD:NORMAL',
            lineHeight1: 1.2,
            letterSpacing1: 0,
            fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            lineHeight2: 1.2,
            letterSpacing2: 0,
            align: 'center',
            lineSpacing1: 0,
            lineSpacing2: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-H1uuZVngW', 'travel-royale', {
        space: {
            width: 1108.7539536613162,
            height: 541.8660170167261,
            transform: 'matrix(1.425963202675595, 0, 0, 1.425963202675595, 0, 0)',
            x: 405.6230231693419,
            y: 351.6777311931724,
            zIndex: 3
        },
        time: {
            enterstart: 9329,
            enterdone: 12329,
            exitstart: 14810,
            exitdone: 16810
        },
        values: {
            alpha: 1,
            text1: 'with Amanda',
            text2: 'MORNING YOGA FLOW',
            color1: '#FFC941',
            textColor1: '#FFC941',
            textColor2: '#FFF',
            fontFamily1: 'OREGANO:NORMAL:NORMAL',
            fontFamily2: 'CABIN:MEDIUM:NORMAL',
            shadow: true,
            lineHeight1: 0.8066666666666668,
            lineHeight2: 1.2,
            letterSpacing1: 0,
            letterSpacing2: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-LP9auH2fi', 'nonprofit-branded-outro', {
        space: {
            width: 1239.2659120717005,
            height: 481.5433258335751,
            transform: 'matrix(1.416303899510515, 0, 0, 1.416303899510515, 0, 0)',
            x: 340.36704396414973,
            y: 299.2283370832124,
            referenceCanvas: {
                width: 1920,
                height: 1080
            },
            zIndex: 5
        },
        time: {
            enterstart: 1096,
            enterdone: 2096,
            exitstart: 6017,
            exitdone: 6517
        },
        values: {
            alpha: 1,
            text1: 'PHOENIX YOGA STUDIO',
            textColor1: '#FFFFFF',
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            shadow: true,
            lineHeight1: 1.4,
            letterSpacing1: 0,
            cropX: 0,
            cropY: 0,
            cropWidth: 100,
            cropHeight: 100,
            imageId: 'placeholder'
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-rJIN9b7xZ', 'fashionistas-dream', {
        space: {
            width: 979.2155905676269,
            height: 358.4737306223864,
            transform: 'matrix(1.28026332365138, 0, 0, 1.28026332365138, 0, 0)',
            x: 470.39220471618654,
            y: 360.76313468880676,
            zIndex: 5
        },
        time: {
            enterstart: 23473,
            enterdone: 26473,
            exitstart: 28304,
            exitdone: 30304
        },
        values: {
            alpha: 0.70234375,
            text1: 'BEGINNER',
            text2: 'Cardio Workout',
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#ED474D',
            textColor2: '#FFF',
            fontFamily1: 'POPPINS:MEDIUM:NORMAL',
            fontFamily2: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
            shadow: true,
            lineHeight1: 1.2,
            lineHeight2: 1.2,
            letterSpacing1: 0,
            letterSpacing2: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-legacyText', 'vintage-wedding', {
        space: {
            width: 1161.4652588717527,
            height: 278.2967763184419,
            transform: 'matrix(2.613115270595699, 0, 0, 2.613115270595699, 0, 0)',
            x: 325.15949756399255,
            y: 381.54179128391365,
            zIndex: 11
        },
        time: {
            enterstart: 40059,
            enterdone: 42059,
            exitstart: 45487,
            exitdone: 47487,
            enterAnimDefId: 'animDefId-FADE-IN',
            exitAnimDefId: 'animDefId-FADE-OUT'
        },
        values: {
            textColor1: '#FFADE3',
            alpha: 1,
            text1: 'Dancing Heart Studio',
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            align: 'center',
            shadow: true,
            lineHeight: 1.42,
            letterSpacing: 33.333333333333314
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-S1OoyT3Fg', 'fitness-linear', {
        space: {
            width: 1069.490511024822,
            height: 502.14184963359406,
            transform: 'matrix(1.1011882667403379, 0, 0, 1.1011882667403379, 0, 0)',
            x: 317.75474448758905,
            y: 228.42907518320297,
            zIndex: 20
        },
        time: {
            enterstart: 125656,
            enterdone: 127156,
            exitstart: 129156,
            exitdone: 130656
        },
        values: {
            color1: '#FF5C5C',
            textColor1: '#FFFFFF',
            textColor2: '#FFFFFF',
            alpha: 1,
            shadow: true,
            text1: 'CARDIO DANCE\nCELEBS LOVE',
            text2: 'POPSUGAR FITNESS',
            fontFamily1: 'EDO:NORMAL:NORMAL',
            fontFamily2: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
            lineHeight1: 1.2,
            lineHeight2: 1.5,
            letterSpacing1: 0,
            letterSpacing2: 0
        },
        canvas: {
            width: 1705,
            height: 959,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-HJyH4cdTG', 'work-out-challenge', {
        space: {
            width: 766.8910879924214,
            height: 191.60601573857693,
            transform: 'matrix(1.0191809347796645, 0, 0, 1.0191809347796645, 0, 0)',
            x: 72.03422665173787,
            y: 732.5121352371211,
            referenceCanvas: {
                width: 1920,
                height: 1080
            },
            zIndex: 3
        },
        time: {
            enterstart: 4141,
            enterdone: 6141,
            exitstart: 7941,
            exitdone: 7941
        },
        values: {
            alpha: 1,
            color1: '#4DAA18',
            color2: '#FFF',
            color3: '#FF0',
            textColor1: '#000',
            textColor2: '#FFFFFF',
            text1: 'UP NEXT',
            text2: 'STEP IN & OUT',
            fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
            lineHeight1: 1.2,
            letterSpacing1: 0,
            fontFamily2: 'POPPINS:EXTRA_BOLD:NORMAL',
            lineHeight2: 1.2,
            letterSpacing2: 0,
            lineSpacing1: 0,
            lineSpacing2: 0,
            align: 'left'
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-BJ6qlstTz', 'logo-lower-third', {
        space: {
            height: 223.08005948449883,
            transform: 'matrix(0.8923202379379953, 0, 0, 0.8923202379379953, 0, 0)',
            width: 1527.797955673269,
            x: 63.1531899016031,
            y: 793.0061242058774,
            zIndex: 35
        },
        time: {
            enterstart: 246093,
            enterdone: 248093,
            exitstart: 251747,
            exitdone: 253247
        },
        values: {
            color1: '#f2d147',
            alpha: 1,
            text1: 'WARRIOR STRETCH',
            textColor1: '#FFF',
            fontFamily1: 'POPPINS:MEDIUM:NORMAL',
            text2: 'ADVANCED: Hold for 45 secs ',
            textColor2: '#FFF',
            fontFamily2: 'WELLFLEET:NORMAL:NORMAL',
            shadow: false,
            lineHeight1: 1.5,
            letterSpacing1: 0,
            lineHeight2: 1,
            letterSpacing2: 0,
            cropX: 0,
            cropY: 0,
            cropWidth: 100,
            cropHeight: 100,
            imageId: 'placeholder'
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-VrlJPlhax', 'yoga-challenge', {
        space: {
            width: 782.4205546944999,
            height: 299.45804544868395,
            transform: 'matrix(0.9407059019330385, 0, 0, 0.9407059019330385, 0, 0)',
            x: 75.54021191397227,
            y: 699.0792530325624,
            referenceCanvas: {
                width: 1920,
                height: 1080
            },
            zIndex: 19
        },
        time: {
            enterstart: 27051,
            enterdone: 29051,
            exitstart: 31218,
            exitdone: 31218
        },
        values: {
            alpha: 1,
            color1: '#FFFFFF',
            text1: 'Full Body Stretch',
            textColor1: 'rgb(255, 255, 255)',
            fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
            lineHeight1: 1.2,
            letterSpacing1: 0,
            text2: '20 min | Yoga for \nstress & anxiety relief',
            textColor2: 'rgb(255, 144, 174)',
            fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
            lineHeight2: 1.2333333333333334,
            letterSpacing2: 0,
            shadow: true,
            lineSpacing1: 0,
            lineSpacing2: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-HyflD1ixW', 'fitness-challenge', {
        space: {
            width: 815.9738546754663,
            height: 156.43015760392814,
            transform: 'matrix(0.6609724969180062, 0, 0, 0.6609724969180062, 0, 0)',
            x: 1104.0261453245337,
            y: 732.5121352371211,
            referenceCanvas: {
                width: 1920,
                height: 1080
            },
            zIndex: 7
        },
        time: {
            enterstart: 200,
            enterdone: 2200,
            exitstart: 4000,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: 'MOUNTAIN CLIMBERS',
            text2: '45 SECS EXERCISE | 15 SECS REST',
            color1: '#C8EAF4',
            color2: '#004E7F',
            textColor1: '#004E7F',
            textColor2: '#FFFFFF',
            fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
            fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            shadow: true,
            lineHeight1: 1.2466666666666666,
            lineHeight2: 1.2,
            letterSpacing1: 0,
            letterSpacing2: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-S1LmnmTyW', 'fitness-rep', {
        space: {
            color1: '#C8FF09',
            textColor1: '#FFFFFF$$$[38,{"color":"hsl(73.39999999999998, 100%, 51.7%)","start":26,"end":37}]',
            text1: 'SIDE CRUNCH\nW/ LEG RAISE\n(45 SECONDS)',
            alpha: 1,
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            shadow: true,
            lineHeight: 1.2,
            letterSpacing: 0
        },
        time: {
            enterstart: 102992,
            enterdone: 103992,
            exitstart: 107430,
            exitdone: 108430
        },
        values: {
            color1: '#96F2FF',
            textColor1: '#FFFFFF$$$[37,{"color":"#96F2FF","start":25,"end":36}]',
            text1: 'SIDE CRUNCH\nW/ LEG RAISE\n(45 SECONDS)',
            alpha: 1,
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            shadow: true,
            lineHeight: 1.2,
            letterSpacing: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-u71HCQSlW', 'workout-preview-list', {
        space: {
            width: 583.665671993174,
            height: 253.0522894067336,
            transform: 'matrix(0.6358097723787276, 0, 0, 0.6358097723787276, 0, 0)',
            x: 148.33348096035957,
            y: 718.9477105932664,
            zIndex: 13
        },
        time: {
            enterstart: 14444,
            enterdone: 17444,
            exitstart: 24013.428571428572,
            exitdone: 24732
        },
        values: {
            textColor1: 'rgb(255, 255, 255)',
            textColor2: '#0c0c0c',
            color1: '#FA8334',
            color2: '#ffffff',
            alpha: 0.6999999999999998,
            text1: 'NEXT REP GOAL',
            text2: '           LEVEL 1: 10 REPS           \n           LEVEL 2: 50 REPS           \n           LEVEL 3: 20 REPS           ',
            fontFamily1: 'ALFA_SLAB_ONE:NORMAL:NORMAL',
            fontFamily2: 'ARCHIVO_NARROW:BOLD:NORMAL',
            align: 'center',
            shadow: false,
            lineHeight1: 1.4066666666666667,
            letterSpacing1: 46.666666666666686,
            lineHeight2: 1.3,
            letterSpacing2: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-legacyText', 'travel-insider-subtitle', {
        space: {
            width: 1584.9603094873469,
            height: 214.00967786628578,
            transform: 'matrix(1.236435963298785, 0, 0, 1.236435963298785, 0, 0)',
            x: 167.51984525632656,
            y: 840.3119158878503,
            zIndex: 2
        },
        time: {
            enterstart: 7815,
            enterdone: 7815,
            exitstart: 11815,
            exitdone: 11815,
            enterAnimDefId: 'animDefId-IN-NONE',
            exitAnimDefId: 'animDefId-OUT-NONE'
        },
        values: {
            textColor1: '#fff',
            alpha: 1,
            text1: "This is episode 4 of the Get Toned Challenge! It's a 30 minute full body workout, and you can do this with or without equipment!",
            fontFamily1: 'OPEN_SANS:SEMI_BOLD:NORMAL',
            align: 'center',
            shadow: true,
            lineHeight: 1.15390625,
            letterSpacing: -30.20833333333337
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-SkArkqfFG', 'event-experience-subtitle', {
        space: {
            height: 206.72110553381344,
            referenceCanvas: { width: 1920, height: 1080 },
            transform: 'matrix(1.1397933021033007, 0, 0, 1.1397933021033007, 0, 0)',
            width: 1919.470998813517,
            x: 0.2645005932414506,
            y: 0,
            zIndex: 22
        },
        time: {
            enterstart: 0,
            enterdone: 500,
            exitstart: 5322,
            exitdone: 5322,
            enterAnimDefId: 'animDefId-POP-IN',
            exitAnimDefId: 'animDefId-OUT-NONE'
        },
        values: {
            color1: 'rgb(255, 249, 82)',
            textColor1: '#000000$$$[122,{"color":"rgb(0, 0, 0)","start":33,"end":35}]',
            alpha: 0.9005208333333333,
            align: 'center',
            text1: 'Please consult a health professional before starting any workout. Especially if you have any underlying health conditions.',
            fontFamily1: 'PORT_LLIGAT_SLAB:NORMAL:NORMAL',
            lineHeight: 1.2091145833333332,
            letterSpacing: 0,
            lineSpacing: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-ByTiDzPTf', 'cnn-subtitle', {
        space: {
            width: 1119.32250896596,
            height: 287.6251866662695,
            transform: 'matrix(0.9486318821446883, 0, 0, 0.9486318821446883, 0, 0)',
            x: 161.83486238532112,
            y: 633.394495412844,
            zIndex: 37
        },
        time: {
            enterstart: 255710,
            enterdone: 257710,
            exitstart: 259224,
            exitdone: 260724
        },
        values: {
            alpha: 1,
            text1: 'Warm Up & Cool down\n\n- Shortened but built in. \n- Add extra time for both as needed.',
            color1: '#CB0714',
            textColor1: '#FFF',
            fontFamily1: 'CHIVO:NORMAL:NORMAL',
            lineHeight1: 1.18,
            letterSpacing1: 0,
            shadow: true,
            align: 'right',
            lineSpacing1: 0
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-H1e1GtOaf', 'bbc-social', {
        space: {
            width: 1369.0814207577403,
            height: 363.1581943836565,
            transform: 'matrix(1.2609659527210295, 0, 0, 1.2609659527210295, 0, 0)',
            x: 125.3260099938108,
            y: 635.9152151149683,
            zIndex: 29
        },
        time: {
            enterstart: 190434,
            enterdone: 192434,
            exitstart: 194746,
            exitdone: 196246
        },
        values: {
            alpha: 1,
            align: 'center',
            color1: '#CF0914',
            textColor1: '#FFF',
            text1: 'Swap stretching for a dynamic warmup. \nIt’s a good idea to move through about five to ten minutes.\n ',
            fontFamily1: 'ANONYMOUS_PRO:NORMAL:NORMAL',
            lineHeight1: 1.2
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-S1ZJMOce7', 'line-by-line-one', {
        space: {
            width: 1268.4362662168676,
            height: 406.8604643433436,
            transform: 'matrix(1.028923754440866, 0, 0, 1.028923754440866, 0, 0)',
            x: 338.29021072285934,
            y: 591.4318743203045,
            referenceCanvas: {
                width: 1472,
                height: 1080
            },
            zIndex: 9
        },
        time: {
            enterstart: 43933,
            enterdone: 44833,
            exitstart: 47525,
            exitdone: 48425,
            enterAnimTimeManual: true,
            exitAnimTimeManual: true
        },
        values: {
            text1: 'This episode is sponsored by FitnessShark.\nUse code FIT50 to shop now and \nreceive 50% at checkout.',
            alpha: 1,
            color1: '#F3BC28',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            letterSpacing: 0,
            lineHeight: 1.5513020833333335,
            lineSpacing: 23.190184049079754,
            shadow: false,
            textColor1: '#000000'
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {}), createTemplateFromDef('defId-r1B8k5GYz', 'insider-social-media', {
        space: {
            width: 1486.0077817338058,
            height: 234.3,
            transform: 'matrix(1.1, 0, 0, 1.1, 0, 0)',
            x: 236.93219578885834,
            y: 783.2488902042024,
            zIndex: 20
        },
        time: {
            enterstart: 120504,
            enterdone: 120504,
            exitstart: 124504,
            exitdone: 124504,
            enterAnimDefId: 'animDefId-IN-NONE',
            exitAnimDefId: 'animDefId-OUT-NONE'
        },
        values: {
            align: 'center',
            alpha: 0.8,
            color1: '#00ABF1',
            fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
            letterSpacing: 0,
            lineHeight: 1.42,
            text1: 'Take a 30 second break\nHit PAUSE to take a longer break',
            textColor1: '#FFFFFF'
        },
        canvas: {
            width: 1920,
            height: 1080,
            color: '#000000'
        }
    }, {})];

    textBasic.items.push.apply(textBasic.items, [createTemplateFromDef('defId-legacyText', 'simple-text-title', {
        space: {
            width: 900,
            transform: 'scale(1.5, 1.5)'
        },
        time: {
            enterAnimDefId: 'animDefId-FADE-IN',
            exitAnimDefId: 'animDefId-FADE-OUT',
            enterstart: 0,
            enterdone: 200,
            exitstart: 3800,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            textColor1: '#FFFFFF',
            text1: 'ADD A TITLE',
            align: 'center',
            alpha: 1,
            shadow: true
        }
    }, {
        space: {
            width: 750
        },
        values: {
            textColor1: '#4fc7ff',
            shadow: false
        }
    }), createTemplateFromDef('defId-legacyText', 'simple-text-subtitle', {
        space: {
            width: 800
        },
        time: {
            enterAnimDefId: 'animDefId-FADE-IN',
            exitAnimDefId: 'animDefId-FADE-OUT',
            enterstart: 0,
            enterdone: 200,
            exitstart: 3800,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'RALEWAY:NORMAL:NORMAL',
            textColor1: '#FFFFFF',
            text1: 'Add a subtitle',
            align: 'center',
            shadow: true,
            alpha: 1
        }
    }, {
        space: {
            width: 1000
        },
        values: {
            textColor1: '#9ce3ff',
            shadow: false
        }
    })].concat(_toConsumableArray(window.editorWorkflow === _constants.SupportedEditorWorkflows.fitness ? fitnessSpecificTextBasic : [])));

    textSubtitles.items.push.apply(textSubtitles.items, [createTemplateFromDef('defId-gDhmAAst5', 'Good Ol’ Block Style', {
        space: {
            width: 1920,
            x: 0,
            y: 820
            // transform : 'scale(1.5, 1.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 0,
            exitstart: 4000,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-IN-NONE',
            exitAnimDefId: 'animDefId-OUT-NONE'
        },
        values: {
            fontFamily: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            textColor: '#fff',
            text: 'The most expensive pizza in the world costs $12,000 and takes 72 hours to make.',
            align: 'center',
            alpha: 1,
            shadow: true,
            lineHeight: 1.18,
            letterSpacing: 0,
            fontSize: 80
        },
        canOverrideAnimation: true
    }, {
        space: {
            // width : 750
            width: 900,
            transform: 'scale(0.7, 0.7)'
        },
        values: {
            textColor: '#fff',
            shadow: false
        }
    }), createTemplateFromDef('defId-XnF23RgVH', 'Subtitle with a background Style', {
        space: {
            width: 1920,
            x: 0,
            y: 820
        },
        time: {
            enterstart: 0,
            enterdone: 0,
            exitstart: 4000,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-IN-NONE',
            exitAnimDefId: 'animDefId-OUT-NONE'
        },
        values: {
            alpha: 0.8,
            text: 'An adult panda can eat up to 40 kilos of bamboo per day.',
            color: '#ffffff',
            align: 'center',
            shadow: false,
            fontSize: 80,
            textColor: '#000',
            fontFamily: 'LATO:ULTRA_BOLD:NORMAL'
        },
        canOverrideAnimation: true
    }, {
        space: {
            width: 900,
            transform: 'scale(0.7, 0.7)'
        }
    }), createTemplateFromDef('defId-RowkFqM4M', 'CNN News Style', {
        space: {
            width: 1920,
            x: 0,
            y: 820
            // transform : 'scale(1.5, 1.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 4000,
            exitdone: 4000
        },
        values: {
            fontFamily: 'LATO:ULTRA_BOLD:NORMAL',
            textColor: '#fff',
            text: 'All human eyes are brown\neven if they appear to be blue.',
            align: 'center',
            alpha: 1,
            shadow: true,
            lineHeight: 1.18,
            letterSpacing: 0,
            fontSize: 80
        }
    }, {
        space: {
            width: 900,
            transform: 'scale(0.7, 0.7)'
        },
        values: {
            textColor: '#fff',
            shadow: false
        }
    }), createTemplateFromDef('defId-5PRXPOBd1', 'Ardent Highlight Subtitle', {
        space: {
            width: 1920,
            x: 0,
            y: 820
            // transform : 'scale(1.5, 1.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 400,
            exitstart: 3700,
            exitdone: 4000
        },
        values: {
            color: '#5271FF',
            textColor: '#FFFFFF',
            alpha: 0.9,
            align: 'center',
            text: 'Every child is born with the power\nto create and learn.',
            fontFamily: 'LATO:ULTRA_BOLD:NORMAL',
            lineHeight: 1.18,
            letterSpacing: 0,
            lineSpacing: 0,
            shadow: false
        }
    }, {
        space: {
            width: 880,
            transform: 'scale(0.7, 0.7)'
        },
        values: {
            shadow: false
        }
    }), createTemplateFromDef('defId-fxkzh3ilU', 'BBC Social Subtitles', {
        space: {
            width: 1920,
            x: 0,
            y: 820
            // transform : 'scale(1.5, 1.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 4000,
            exitdone: 4000
        },
        values: {
            color: '#A3B8D1',
            textColor: '#FFFFFF',
            alpha: 1,
            align: 'center',
            text: 'China has built the World’s\nbiggest floating solar farm',
            fontFamily: 'FIRA_SANS:MEDIUM:NORMAL',
            lineHeight: 1.18,
            letterSpacing: 0,
            lineSpacing: 0,
            shadow: true
        }
    }, {
        space: {
            width: 775,
            transform: 'scale(0.7, 0.7)'
        },
        values: {
            shadow: false
        }
    })]);

    var portedTemplates = addedTemplates.map(function (item) {
        return createTemplateFromDef(item.defId, item.name, {
            id: item.id,
            space: item.config.space,
            time: item.config.time,
            values: item.config.values,
            tags: item.tags,
            enterAnimationOnly: item.config.enterAnimationOnly
        }, {
            // No preview overides needed
        }, {
            previewImage: item.thumbnail_image_url
        });
    });

    textPresets.items.push.apply(textPresets.items, [].concat(_toConsumableArray(portedTemplates), [createTemplateFromDef('defId-SkArkqfFG', 'exq-spaced-handful-olives', {
        space: {
            x: 800,
            y: 740,
            width: 1100,
            transform: 'scale(1.2, 1.2)'
        },
        time: {
            enterstart: 0,
            enterdone: 500,
            exitstart: 3500,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-REVEAL-IN-RIGHT',
            exitAnimDefId: 'animDefId-REVEAL-OUT-RIGHT'
        },
        values: {
            alpha: 0.9,
            text1: '1 HANDFUL OF OLIVES\n2 TSP RED CHILI FLAKES',
            color1: '#FFFFFF',
            align: 'right',
            textColor1: '#B32C39$$$[42,{"color":"#000000","start":0,"end":11},{"color":"rgb(113, 159, 51)","start":13,"end":18},{"color":"#000000","start":20,"end":24},{"color":"#ED1C24","start":26,"end":41}]',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            lineSpacing: 0,
            lineHeight: 1.18
        },
        tags: ['lowerThirds', 'popular']
    }, {
        space: {
            width: 820,
            transform: 'scale(0.9, 0.9)'
        },
        values: {
            color1: '#FFFFFF',
            textColor1: '#B32C39$$$[42,{"color":"#000000","start":0,"end":11},{"color":"#4B6922","start":13,"end":18},{"color":"#000000","start":20,"end":24},{"color":"#A11319","start":26,"end":41}]'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/exq-spaced-handful-olives.png?v=2'
    }), createTemplateFromDef('defId-r1B8k5GYz', 'exq-online-marketers', {
        space: {
            x: 20,
            y: 730,
            width: 1140,
            transform: 'scale(1.1, 1.1)'
        },
        time: {
            enterstart: 0,
            enterdone: 500,
            exitstart: 3500,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-REVEAL-IN-LEFT',
            exitAnimDefId: 'animDefId-REVEAL-OUT-LEFT'
        },
        values: {
            alpha: 0.8,
            text1: '87% OF ONLINE MARKETERS\nUSE VIDEO CONTENT',
            color1: '#000000',
            align: 'left',
            textColor1: '#FFFFFF$$$[41,{"color":"#168EEA","start":14,"end":22},{"color":"#168EEA","start":27,"end":32},{"color":"#6b8e23","start":45,"end":45}]',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL'
        },
        tags: ['lowerThirds', 'popular']
    }, {
        space: {
            width: 940,
            transform: 'scale(0.9, 0.9)'
        },
        values: {
            color1: '#000000',
            textColor1: '#FFFFFF$$$[41,{"color":"#168EEA","start":14,"end":22},{"color":"#168EEA","start":27,"end":32},{"color":"#6b8e23","start":45,"end":45}]'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/exq-online-marketers.png?v=2'
    }), createTemplateFromDef('defId-r15LonRJ7', 'exq-emoji-template-multiline', {
        space: {
            width: 1920,
            height: 325.81572960813565,
            transform: 'matrix(1.4571772672900547, 0, 0, 1.4571772672900547, 0, 0)',
            x: 0,
            y: 0
        },
        time: {
            enterstart: 0,
            enterdone: 500,
            exitstart: 3500,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            shadow: false,
            emojiId1: 'emoji_1f63b',
            emojiId2: 'emoji_1f63b',
            color1: '#604EFF',
            textColor1: '#FFFFFF',
            text1: 'I MUST HAVE THESE\nCAT BUTT COSTERS!',
            fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
            lineHeight1: 0.91796875,
            letterSpacing1: 0
        },
        tags: ['lowerThirds', 'popular']
    }, {}, {}), createTemplateFromDef('defId-rJOy89MtM', 'exq-three-shades', {
        space: {
            x: 0,
            y: 270,
            width: 800,
            transform: 'scale(1.3, 1.3)'
        },
        time: {
            enterstart: 0,
            enterdone: 500,
            exitstart: 3500,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-REVEAL-IN-LEFT',
            exitAnimDefId: 'animDefId-REVEAL-OUT-LEFT'
        },
        values: {
            alpha: 1,
            text1: 'PRESENTING TO YOU\nTHREE SHADES\nOF BLISS',
            color1: '#E9C730',
            align: 'left',
            textColor1: '#000000',
            fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
            lineSpacing: 0
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 800,
            transform: 'scale(1.2, 1.2)'
        },
        values: {
            color1: '#E9C730',
            textColor1: '#000000'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/exq-three-shades.png?v=2'
    }), createTemplateFromDef('defId-ryIPP7WKG', 'exq-far-apart', {
        space: {
            x: 70,
            y: 500,
            width: 1100,
            transform: 'scale(1.1, 1.1)'
        },
        time: {
            enterstart: 0,
            enterdone: 500,
            exitstart: 3500,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-REVEAL-IN-RIGHT',
            exitAnimDefId: 'animDefId-REVEAL-OUT-RIGHT'
        },
        values: {
            alpha: 0.9,
            text1: 'USE THE BOTTOM KNOB\nTO BRING THE LINES CLOSER\nOR FAR APART',
            color1: '#F02B2B',
            align: 'left',
            textColor1: '#FFFFFF$$$[58,{"color":"#FFEA03","start":8,"end":19},{"color":"#FFEA03","start":39,"end":45},{"color":"#FFEA03","start":49,"end":51},{"color":"#FFEA03","start":53,"end":57}]',
            fontFamily1: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
            lineSpacing: 20
        },
        tags: ['lowerThirds', 'popular']
    }, {
        space: {
            width: 750,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#F02B2B',
            textColor1: '#FFFFFF$$$[58,{"color":"#FFEA03","start":8,"end":19},{"color":"#FFEA03","start":39,"end":45},{"color":"#FFEA03","start":49,"end":51},{"color":"#FFEA03","start":53,"end":57}]'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/exq-far-apart.png?v=2'
    }), createTemplateFromDef('defId-HJ0PRafPf', 'ph-tasty', {
        space: {
            x: 600,
            y: 735,
            width: 1220,
            transform: 'scale(0.86, 0.86)'
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 3000,
            exitdone: 5000
        },
        values: {
            alpha: 1,
            text1: 'BAKE THE CAKE FOR 2 MINS',
            text2: 'COOKING TIPS',
            color1: '#931E61',
            color2: '#FFF',
            textColor1: '#FFF',
            textColor2: '#931E61',
            fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
            fontFamily2: 'BOOGALOO:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['lowerThirds', 'branded']
    }, {
        space: {
            width: 1220,
            transform: 'scale(0.86, 0.86)'
        },
        values: {
            color1: '#931E61',
            color2: '#FFF',
            textColor1: '#FFF',
            textColor2: '#931E61'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-tasty.png?v=2'
    }), createTemplateFromDef('defId-BycZy8nxW', 'exq-christiano-ronaldo', {
        space: {
            x: 40,
            y: 735,
            width: 900,
            transform: 'scale(0.75, 0.75)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 4500,
            exitdone: 5500
        },
        values: {
            alpha: 1,
            text1: 'CRISTIANO RONALDO',
            text2: 'REAL MADRID',
            color1: '#004E7F',
            textColor1: '#FFE974',
            textColor2: '#FFE974',
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            fontFamily2: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            shadow: true
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 720,
            transform: 'scale(0.6, 0.6)'
        },
        values: {
            color1: '#004E7F',
            textColor1: '#FFE974',
            textColor2: '#FFE974',
            shadow: true
        }
    }, {
        backgroundColor: '#9A6B76',
        previewImage: staticBaseUrl + '/images/template-previews/exq-christiano-ronaldo.png?v=2'
    }), createTemplateFromDef('defId-H1uuZVngW', 'exq-constantinople', {
        space: {
            width: 900,
            transform: 'scale(0.75, 0.75)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'CORMORANT:MEDIUM:NORMAL',
            fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
            color1: '#FFC941',
            textColor1: '#FFC941',
            textColor2: '#FFF',
            text1: 'CONSTANTINOPLE',
            text2: 'THE RISE OF',
            alpha: 1,
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 900,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#FFC941',
            textColor1: '#FFC941',
            textColor2: '#FFF',
            shadow: true
        }
    }, {
        backgroundColor: '#9A5E89',
        previewImage: staticBaseUrl + '/images/template-previews/exq-constantinople.png?v=2'
    }), createTemplateFromDef('defId-BJc0zNgDf', 'ph-rosanes-kitchen', {
        space: {
            x: 0,
            y: 760,
            transform: 'scale(1.44, 1.44)',
            width: 1920
        },
        time: {
            enterstart: 0,
            enterdone: 600,
            exitstart: 3400,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: 'BACON CHEESE FRITTATA',
            text2: "ROSANE'S KITCHEN",
            color1: '#2B5F59',
            color2: '#67C676',
            textColor1: '#FFFFFF',
            textColor2: '#2B5F59',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            fontFamily2: 'BOOGALOO:NORMAL:NORMAL',
            shadow: false
        },
        tags: ['branded', 'lowerThirds']
    }, {
        space: {
            transform: 'scale(1.44, 1.44)',
            width: 1920
        },
        values: {
            color1: '#2B5F59',
            color2: '#67C676',
            textColor1: '#FFFFFF',
            textColor2: '#2B5F59',
            shadow: false
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-rosanes-kitchen.png?v=2'
    }), createTemplateFromDef('defId-ryyMxR5eW', 'exq-valar-morghulis', {
        space: {
            x: 40,
            y: 715,
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            fontFamily2: 'WATERLILY:NORMAL:NORMAL',
            color1: '#FF4F55',
            textColor1: '#FFF',
            textColor2: '#FF4F55',
            text1: 'VALAR MORGHULIS',
            text2: 'GAME OF THRONES',
            alpha: 1,
            shadow: true
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#FF4F55',
            textColor1: '#FFF',
            textColor2: '#FF4F55',
            shadow: true
        }
    }, {
        backgroundColor: '#345E7F',
        previewImage: staticBaseUrl + '/images/template-previews/exq-valar-morghulis.png?v=2'
    }),
    // TODO - Overrides the Template Config data -- need to make this consistent across the board
    createTemplateFromDef('defId-ByjurzPxW', 'exq-fast-and-furious', {
        space: {
            x: 40,
            y: 715,
            width: 650,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            alpha: 1,
            fontFamily1: 'CHEWY:NORMAL:NORMAL',
            text1: 'FAST AND FURIOUS',
            color1: '#FF0',
            textColor1: '#000',
            shadow: false
        },
        tags: ['lowerThirds', 'titles']
    }, {
        space: {
            width: 650,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#FF0',
            textColor1: '#000',
            shadow: false
        }
    }, {
        backgroundColor: '#6570DA',
        previewImage: staticBaseUrl + '/images/template-previews/exq-fast-and-furious.png?v=2'
    }), createTemplateFromDef('defId-rJIN9b7xZ', 'exq-christian-louboutin', {
        space: {
            width: 800
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'CORMORANT:MEDIUM:NORMAL',
            fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#ED474D',
            textColor2: '#FFF',
            text1: 'CHRISTIAN',
            text2: 'LOUBOUTIN',
            alpha: 0.2,
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#ED474D',
            textColor2: '#FFF',
            alpha: 0.2
        }
    }, {
        backgroundColor: '#C0CAEF',
        previewImage: staticBaseUrl + '/images/template-previews/exq-christian-louboutin.png?v=2'
    }), createTemplateFromDef('defId-HybO9fewz', 'ph-kevin-nolan', {
        space: {
            x: 40,
            y: 785,
            width: 1000,
            transform: 'scale(0.7, 0.7)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 3000,
            exitdone: 4500
        },
        values: {
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            fontFamily2: 'LATO:ULTRA_BOLD:NORMAL',
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#fff',
            textColor2: '#F9E47D',
            text1: 'KEVIN NOLAN',
            text2: 'VP - GROWTH, TYPITO INC',
            alpha: 0.8
        },
        tags: ['branded', 'lowerThirds']
    }, {
        space: {
            width: 1000,
            transform: 'scale(0.7, 0.7)'
        },
        values: {
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#fff',
            textColor2: '#F9E47D'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-kevin-nolan.png?v=2'
    }), createTemplateFromDef('defId-ryhIdDc1W', 'exq-blue-lagoon', {
        space: {
            x: 40,
            y: 785,
            width: 800,
            transform: 'scale(0.5, 0.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            fontFamily2: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#fff',
            textColor2: '#fff',
            text1: 'BLUE LAGOON',
            text2: 'MOUNTAINS REFLECT ON THE LAGOON',
            alpha: 1
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.5, 0.5)'
        },
        values: {
            color1: '#fff',
            color2: '#004E7F',
            textColor1: '#fff',
            textColor2: '#fff'
        }
    }, {
        backgroundColor: '#DD9BCA',
        previewImage: staticBaseUrl + '/images/template-previews/exq-blue-lagoon.png?v=2'
    }), createTemplateFromDef('defId-S16ZUu5Jb', 'exq-shrewsbury', {
        space: {
            x: 40,
            y: 730,
            width: 1100,
            transform: 'scale(0.65, 0.65)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'OREGANO:NORMAL:NORMAL',
            fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
            color1: '#FFDF78',
            textColor1: '#FFDF78',
            textColor2: '#FFDF78',
            text1: 'SHREWSBURY',
            text2: 'FERNS AND PETALS',
            alpha: 1,
            shadow: true
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.5, 0.5)'
        },
        values: {
            color1: '#FFDF78',
            textColor1: '#FFDF78',
            textColor2: '#FFDF78'
        }
    }, {
        backgroundColor: '#F1626E',
        previewImage: staticBaseUrl + '/images/template-previews/exq-shrewsbury.png?v=2'
    }), createTemplateFromDef('defId-B1yUXWYJZ', 'exq-shape-of-you', {
        space: {
            x: 65,
            y: 780,
            width: 800
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            color1: '#ED1C24',
            color2: '#fff',
            textColor1: '#ED1C24',
            text1: 'SHAPE OF YOU',
            alpha: 1
        },
        tags: ['lowerThirds']
    }, {
        values: {
            color1: '#ED1C24',
            color2: '#fff',
            textColor1: '#ED1C24'
        }
    }, {
        backgroundColor: '#FFE372',
        previewImage: staticBaseUrl + '/images/template-previews/exq-shape-of-you.png?v=2'
    }), createTemplateFromDef('defId-HJvsIJXDG', 'ph-chelsea-arsenal', {
        space: {
            x: 460,
            y: 460,
            width: 1000,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 2500,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: 'CHELSEA',
            text2: 'ARSENAL',
            color1: '#FFF',
            textColor1: '#034693',
            textColor2: '#dd402c',
            fontFamily1: 'BUNGEE_INLINE:NORMAL:NORMAL'
        },
        tags: ['titles', 'branded']
    }, {
        space: {
            width: 1000,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#FFF',
            textColor1: '#009FFF',
            textColor2: '#ED1C24'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-chelsea-arsenal.png?v=2'
    }), createTemplateFromDef('defId-ByJPiQOxW', 'exq-jackscrew-quillbachs', {
        space: {
            x: 40,
            y: 715,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'MERRIWEATHER:NORMAL:NORMAL',
            fontFamily2: 'RALEWAY:NORMAL:NORMAL',
            color1: '#B3091E',
            color2: '#FFF',
            textColor1: '#B3091E',
            textColor2: '#B3091E',
            text1: 'JACKSCREW',
            text2: 'QUILLBACHS',
            alpha: 1
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#B3091E',
            color2: '#FFF',
            textColor1: '#B3091E',
            textColor2: '#B3091E'
        }
    }, {
        backgroundColor: '#E7E568',
        previewImage: staticBaseUrl + '/images/template-previews/exq-jackscrew-quillbachs.png?v=2'
    }), createTemplateFromDef('defId-S1LmnmTyW', 'exq-grand-hotel', {
        space: {
            x: 850,
            y: 780,
            width: 950,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            color1: '#ED1C24',
            textColor1: '#ED1C24',
            text1: 'THE GRAND HOTEL',
            alpha: 1,
            shadow: true
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#ED1C24',
            textColor1: '#ED1C24',
            shadow: false
        }
    }, {
        backgroundColor: '#FFE372',
        previewImage: staticBaseUrl + '/images/template-previews/exq-grand-hotel.png?v=2'
    }), createTemplateFromDef('defId-Hy671s1lW', 'exq-machu-picchu', {
        space: {
            width: 1300
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'IM_FELL_DW_PICA:NORMAL:NORMAL',
            fontFamily2: 'OREGANO:NORMAL:NORMAL',
            color1: '#fff',
            textColor1: '#fff',
            textColor2: '#fff',
            text1: 'MACHU PICCHU',
            text2: 'FOLLOW THE INCA TRAIL',
            alpha: 1,
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 925,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#fff',
            textColor1: '#fff',
            textColor2: '#fff',
            shadow: false
        }
    }, {
        backgroundColor: '#8c4171',
        previewImage: staticBaseUrl + '/images/template-previews/exq-machu-picchu.png?v=2'
    }), createTemplateFromDef('defId-H1rMwZ7wG', 'ph-satoshi', {
        space: {
            x: 100,
            y: 860,
            width: 840,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 2500,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: 'SATOSHI NAKAMOTO',
            color1: '#FFF',
            textColor1: '#04A9F4',
            fontFamily1: 'KAUSHAN_SCRIPT:NORMAL:NORMAL'
        },
        tags: ['lowerThirds', 'branded']
    }, {
        space: {
            width: 840,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#FFF',
            textColor1: '#04A9F4'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-satoshi.png?v=2'
    }), createTemplateFromDef('defId-ByT6rpkxZ', 'exq-alan-rickman', {
        space: {
            x: 890,
            y: 750,
            width: 960,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            fontFamily1: 'ELECTROLIZE:NORMAL:NORMAL',
            fontFamily2: 'OPEN_SANS:SEMI_BOLD:NORMAL',
            color1: '#004E7F',
            color2: '#fee35f',
            color3: '#000',
            textColor1: '#fee35f',
            textColor2: '#fff',
            text1: 'ALAN RICKMAN',
            text2: 'AS PROFESSOR SNAPE',
            alpha: 1,
            shadow: false
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#FFA6E1',
            color2: '#FFFFFF',
            color3: '#000',
            textColor1: '#2E4461',
            textColor2: '#fff'
        }
    }, {
        backgroundColor: '#d9ebfe',
        previewImage: staticBaseUrl + '/images/template-previews/exq-alan-rickman.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-SyBboyFxb', 'exq-better-place', {
        space: {
            width: 1000
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            alpha: 1,
            text1: 'MAKE THE WORLD',
            text2: 'A BETTER PLACE',
            color1: '#F1626E',
            textColor1: '#FFF',
            textColor2: '#FFF',
            fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
            fontFamily2: 'POPPINS:MEDIUM:NORMAL',
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 750,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#F1626E',
            textColor1: '#FFF',
            textColor2: '#FFF',
            shadow: false
        }
    }, {
        backgroundColor: '#275c77',
        previewImage: staticBaseUrl + '/images/template-previews/exq-better-place.png?v=2'
    }), createTemplateFromDef('defId-ryI5sWewM', 'ph-elon-musk', {
        space: {
            x: 40,
            y: 785,
            width: 1000,
            transform: 'scale(0.7, 0.7)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 3000,
            exitdone: 4500
        },
        values: {
            fontFamily1: 'MULI:BOLD:ITALIC',
            fontFamily2: 'LATO:ULTRA_BOLD:NORMAL',
            color1: '#fff',
            color2: '#CD0001',
            textColor1: '#fff',
            textColor2: '#fff',
            text1: 'BREAKING NEWS',
            text2: 'ELON MUSK FIRES HIS CAR TO SPACE',
            alpha: 0.8
        },
        tags: ['branded', 'lowerThirds']
    }, {
        space: {
            width: 1000,
            transform: 'scale(0.7, 0.7)'
        },
        values: {
            color1: '#fff',
            color2: '#CD0001',
            textColor1: '#fff',
            textColor2: '#fff'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-elon-musk.png?v=2'
    }), createTemplateFromDef('defId-B1tU6ip6M', 'rk8ukSURz-aj-presents', {
        space: {
            width: 1419.8121505732538,
            height: 311.6353572973991,
            transform: 'matrix(1.4630767948234698, 0, 0, 1.4630767948234698, 0, 0)',
            x: 128.29350649350653,
            y: 652.5155149889557
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            color1: '#000',
            color2: '#FFBD4A',
            textColor1: '#FFF',
            alpha: 1,
            align: 'center',
            text1: 'NASA LAUNCHES INSIGHT SPACECRAFT TO MARS ',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            lineHeight: 1.42,
            letterSpacing: 0,
            lineSpacing: 0,
            lineHeight1: 1.2
        },
        tags: ['aj+', 'news', 'caption']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-tEbcxD7OZ', 'event-one-liner', {
        space: {
            width: 1581.7432097504593,
            height: 494.54581264404186,
            transform: 'matrix(1.9350478098156925, 0, 0, 1.9350478098156925, 0, 0)',
            x: 169.12839512477035,
            y: 292.72709367797904
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 3500,
            exitdone: 4500
        },
        values: {
            alpha: 1,
            text1: 'FORBES 100',
            textColor1: 'rgb(255, 255, 255)',
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            lineHeight1: 1.3361979166666669,
            letterSpacing1: 0,
            text2: 'IN ONE ROOM',
            textColor2: 'rgb(255, 255, 255)',
            align: 'center',
            fontFamily2: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            lineHeight2: 1.21953125,
            letterSpacing2: 0,
            shadow: true
        },
        tags: ['event']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-rJOy89MtM', 'fitness-guideline', {
        space: {
            width: 637.5364298588983,
            height: 359.747091254223,
            transform: 'matrix(1.125968986711183, 0, 0, 1.125968986711183, 0, 0)',
            x: 37.14195547767394,
            y: 487.7157320872275
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3500,
            exitdone: 4000,
            enterAnimDefId: 'animDefId-REVEAL-IN-LEFT',
            exitAnimDefId: 'animDefId-REVEAL-OUT-LEFT'
        },
        values: {
            color1: '#56C59E',
            textColor1: '#000000$$$[42,{"color":"#034693","start":10,"end":14},{"color":"#034693","start":25,"end":29},{"color":"#034693","start":37,"end":41}]',
            alpha: 1,
            align: 'left',
            text1: 'PROTEIN - 30 GM \nCARBS - 70 GM\nFAT - 20 GM',
            fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
            lineHeight: 1.42,
            letterSpacing: 0,
            lineSpacing: 0
        },
        tags: ['wellness', 'fitness', 'lower-third', 'food']
    }, {
        space: {
            width: 500,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-rkZ3Og5UM', 'ph-nike-runner', {
        space: {
            x: 0,
            y: 830,
            width: 945,
            transform: 'scale(0.9, 0.9)'
        },
        time: {
            enterstart: 0,
            enterdone: 600,
            exitstart: 3400,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: 'NIKE RUNNER PRO',
            text2: 'IN YOUR NEAREST STORE',
            color1: '#FFFFFF',
            color2: '#B32C39',
            textColor1: '#000000',
            textColor2: '#FFFFFF',
            fontFamily1: 'BOOGALOO:NORMAL:NORMAL',
            fontFamily2: 'SPECTRAL:SEMI_BOLD:NORMAL'
        },
        tags: ['lowerThirds', 'branded']
    }, {
        space: {
            width: 945,
            transform: 'scale(0.9, 0.9)'
        },
        values: {
            color1: '#FFFFFF',
            color2: '#B32C39',
            textColor1: '#000000',
            textColor2: '#FFFFFF'
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-nike-runner.png?v=2'
    }), createTemplateFromDef('defId-HyflD1ixW', 'exq-technical-glitch', {
        space: {
            x: 950,
            y: 735,
            width: 900,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            alpha: 1,
            text1: 'TECHNICAL GLITCH',
            text2: 'PLEASE REFRESH',
            color1: '#FFC40C',
            color2: '#FFF',
            textColor1: '#004E7F',
            textColor2: '#004E7F',
            fontFamily1: 'FREDOKA_ONE:NORMAL:NORMAL',
            fontFamily2: 'ELECTROLIZE:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.75, 0.75)'
        },
        values: {
            color1: '#FFC40C',
            color2: '#FFF',
            textColor1: '#004E7F',
            textColor2: '#004E7F',
            shadow: true
        }
    }, {
        backgroundColor: '#FA979D',
        previewImage: staticBaseUrl + '/images/template-previews/exq-technical-glitch.png?v=2'
    }), createTemplateFromDef('defId-Hk3GZNoxZ', 'exq-rogue-nation', {
        space: {
            width: 1000,
            transform: 'scale(0.75, 0.75)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 4500,
            exitdone: 6000
        },
        values: {
            alpha: 1,
            text1: 'MISSION IMPOSSIBLE',
            text2: 'ROGUE NATION',
            color1: '#FFF',
            textColor1: '#FFF',
            textColor2: '#ED4352',
            fontFamily1: 'FREDOKA_ONE:NORMAL:NORMAL',
            fontFamily2: 'BUNGEE_INLINE:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 750,
            transform: 'scale(0.5, 0.5)'
        },
        values: {
            color1: '#FFF',
            textColor1: '#FFF',
            textColor2: '#ED4352',
            shadow: true
        }
    }, {
        backgroundColor: '#FFD969',
        previewImage: staticBaseUrl + '/images/template-previews/exq-rogue-nation.png?v=2'
    }), createTemplateFromDef('defId-B1kkKcjxW', 'exq-moulin-rouge', {
        space: {
            width: 1200,
            transform: 'scale(1, 1)'
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 4500,
            exitdone: 6000
        },
        values: {
            alpha: 1,
            text1: 'MOULIN ROUGE',
            text2: 'THE RED MILL',
            color1: '#FFF',
            textColor1: '#ED4352',
            textColor2: '#ED4352',
            fontFamily1: 'MONOTON:NORMAL:NORMAL',
            fontFamily2: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 660,
            transform: 'scale(0.6, 0.6)'
        },
        values: {
            color1: '#FFF',
            textColor1: '#ED4352',
            textColor2: '#ED4352',
            shadow: false
        }
    }, {
        backgroundColor: '#96B3A0',
        previewImage: staticBaseUrl + '/images/template-previews/exq-moulin-rouge.png?v=2'
    }), createTemplateFromDef('defId-HylJjbCZDM', 'ph-muhammad-ali', {
        space: {
            x: 60,
            y: 840,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 3000,
            exitdone: 5000
        },
        values: {
            fontFamily1: 'CHEWY:NORMAL:NORMAL',
            color1: '#FFFFFF',
            textColor1: '#000000',
            text1: 'Muhammad Ali',
            alpha: 1,
            shadow: false
        },
        tags: ['branded']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#FFFFFF',
            textColor1: '#000000',
            shadow: false
        }
    }, {
        previewImage: staticBaseUrl + '/images/template-previews/ph-muhammad-ali.png?v=2'
    }), createTemplateFromDef('defId-ByjSOsWxZ', 'exq-seafarers-expedition', {
        space: {
            width: 700
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 5000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            fontFamily2: 'PT_SERIF:NORMAL:NORMAL',
            color1: '#fff',
            textColor1: '#fff',
            textColor2: '#fff',
            text1: 'SEAFARERS',
            text2: 'EXPEDITION',
            alpha: 1
        },
        tags: ['titles']
    }, {
        space: {
            width: 500,
            transform: 'scale(0.5, 0.5)'
        },
        values: {
            color1: '#fff',
            textColor1: '#fff',
            textColor2: '#fff'
        }
    }, {
        backgroundColor: '#F15F60',
        previewImage: staticBaseUrl + '/images/template-previews/exq-seafarers-expedition.png?v=2'
    }), createTemplateFromDef('defId-SyBZK1sj-legacy', 'exq-keep-calm', {
        space: {
            width: 600
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 1500,
            exitdone: 2000
        },
        values: {
            fontFamily1: 'BUNGEE_INLINE:NORMAL:NORMAL',
            color1: '#fff',
            textColor1: '#fff',
            text1: 'KEEP CALM\nTAKE AIM!',
            alpha: 1,
            shadow: true
        },
        tags: ['titles']
    }, {}, {
        backgroundColor: '#fee4c4',
        previewImage: staticBaseUrl + '/images/template-previews/exq-keep-calm.png?v=2'
    }), createTemplateFromDef('defId-SJMNwOZ0G', 'exq-penguin-slide', {
        space: {
            x: 40,
            y: 715,
            width: 950,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1660,
            exitstart: 5000,
            exitdone: 6660
        },
        values: {
            color1: '#F1626E',
            color2: '#000000',
            textColor1: '#FFFFFF',
            textColor2: '#F1626E',
            alpha: 0.8,
            text1: 'PENGUIN SLIDE',
            text2: 'Next show after the Lion Dance',
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            fontFamily2: 'FIRA_SANS:MEDIUM:NORMAL'
        },
        tags: ['lowerThirds']
    }, {
        space: {
            width: 950
        },
        values: {
            color1: '#F1626E',
            color2: '#000000',
            textColor1: '#FFFFFF',
            textColor2: '#F1626E',
            alpha: 0.8,
            text1: 'PENGUIN SLIDE',
            text2: 'Next show after the Lion Dance',
            fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
            fontFamily2: 'FIRA_SANS:MEDIUM:NORMAL'
        }
    }, {
        backgroundColor: '#87e0d0',
        previewImage: staticBaseUrl + '/images/template-previews/exq-penguin-slide.png?v=2'
    }), createTemplateFromDef('defId-Hk2MND86', 'exq-simple-rules', {
        space: {
            width: 800
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 4000,
            exitdone: 4500
        },
        values: {
            textColor1: '#004e7f',
            color1: '#b32c39',
            alpha: 1,
            text1: 'SIMPLE RULES',
            fontFamily1: 'CORMORANT:MEDIUM:NORMAL',
            shadow: true
        },
        tags: ['titles']
    }, {
        space: {
            width: 600
        },
        values: {
            textColor1: '#004e7f',
            color1: '#b32c39',
            alpha: 1,
            text1: 'SIMPLE RULES',
            fontFamily1: 'CORMORANT:MEDIUM:NORMAL',
            shadow: true
        }
    }, {
        backgroundColor: '#7ffed4',
        previewImage: staticBaseUrl + '/images/template-previews/exq-simple-rules.png?v=2'
    }), createTemplateFromDef('defId-SJkMxSuKl', 'exq-rules-creativity', {
        space: {
            width: 1170,
            transform: 'matrix(0.6381136415204, 0, 0, 0.6381136415204, 0, 0)'
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 5000,
            exitdone: 6500
        },
        values: {
            color1: '#FFFFFF',
            color2: '#5C875E',
            textColor1: '#FFFFFF',
            text1: 'RULES OF CREATIVITY',
            text2: "WAIT. THEY DON'T EXIST",
            fontFamily1: 'PERMANENT_MARKER:NORMAL:NORMAL',
            fontFamily2: 'MULI:BOLD:ITALIC'
        },
        tags: ['titles']
    }, {
        space: {
            width: 800,
            transform: 'matrix(0.6381136415204, 0, 0, 0.6381136415204, 0, 0)'
        },
        values: {
            color1: '#FFFFFF',
            color2: '#5C875E',
            textColor1: '#FFFFFF',
            text1: 'CREATIVITY',
            text2: 'GOT NO RULES',
            fontFamily1: 'PERMANENT_MARKER:NORMAL:NORMAL',
            fontFamily2: 'MULI:BOLD:ITALIC'
        }
    }, {
        backgroundColor: '#fd7f4f',
        previewImage: staticBaseUrl + '/images/template-previews/exq-rules-creativity.png?v=2'
    }), createTemplateFromDef('defId-S1OoyT3Fg', 'exq-mic-drop', {
        space: {
            width: 1200
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 3500,
            exitdone: 5000
        },
        values: {
            color1: '#50ffd1',
            textColor1: '#FFFFFF',
            textColor2: '#50ffd1',
            alpha: 1,
            shadow: true,
            text1: 'MIC DROP',
            text2: 'YOUR ONE-LINER HERE',
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            fontFamily2: 'BOOGALOO:NORMAL:NORMAL'
        },
        tags: ['titles']
    }, {
        space: {
            width: 1200
        },
        values: {
            color1: '#50ffd1',
            textColor1: '#FFFFFF',
            textColor2: '#50ffd1',
            alpha: 1,
            shadow: true,
            text1: 'MIC DROP',
            text2: 'YOUR ONE-LINER HERE',
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            fontFamily2: 'BOOGALOO:NORMAL:NORMAL'
        }
    }, {
        backgroundColor: '#cd5c5c',
        previewImage: staticBaseUrl + '/images/template-previews/exq-mic-drop.png?v=2'
    }), createTemplateFromDef('defId-HyFe_MV5e', 'exq-licious-circle', {
        space: {
            width: 650
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 3500,
            exitdone: 5000
        },
        values: {
            color1: '#FFFFFF',
            textColor1: '#C4005B',
            textColor2: '#000000',
            alpha: 1,
            text1: 'LICIOUS',
            text2: 'CIRCLE',
            fontFamily1: 'PLAYFAIR_DISPLAY:SEMI_BOLD:NORMAL',
            fontFamily2: 'RIGHTEOUS:NORMAL:NORMAL'
        },
        tags: ['titles']
    }, {
        space: {
            width: 650
        },
        values: {
            color1: '#FFFFFF',
            textColor1: '#C4005B',
            textColor2: '#000000',
            alpha: 1,
            text1: 'LICIOUS',
            text2: 'CIRCLE',
            fontFamily1: 'PLAYFAIR_DISPLAY:SEMI_BOLD:NORMAL',
            fontFamily2: 'RIGHTEOUS:NORMAL:NORMAL'
        }
    }, {
        backgroundColor: '#bdb76b',
        previewImage: staticBaseUrl + '/images/template-previews/exq-licious-circle.png?v=2'
    }), createTemplateFromDef('defId-SJhabeq5e', 'exq-space-bug', {
        space: {
            width: 700
        },
        time: {
            enterstart: 0,
            enterdone: 1500,
            exitstart: 3500,
            exitdone: 5000
        },
        values: {
            textColor1: '#FFFFFF',
            textColor2: '#FFBB65',
            color1: '#FFBB65',
            alpha: 1,
            shadow: true,
            text1: 'SPACE BUG',
            text2: 'PRODUCTION',
            fontFamily1: 'BUNGEE_SHADE:NORMAL:NORMAL',
            fontFamily2: 'POPPINS:MEDIUM:NORMAL'
        },
        tags: ['titles']
    }, {
        space: {
            width: 700
        },
        values: {
            textColor1: '#FFFFFF',
            textColor2: '#FFBB65',
            color1: '#FFBB65',
            alpha: 1,
            shadow: true,
            text1: 'SPACE BUG',
            text2: 'PRODUCTION',
            fontFamily1: 'BUNGEE_SHADE:NORMAL:NORMAL',
            fontFamily2: 'POPPINS:MEDIUM:NORMAL'
        }
    }, {
        backgroundColor: '#9370db',
        previewImage: staticBaseUrl + '/images/template-previews/exq-space-bug.png?v=2'
    }), createTemplateFromDef('defId-rknCBip6f', 'tech-top-10', {
        space: {
            width: 768.8808268853261,
            height: 394.6921578011341,
            transform: 'matrix(1.495046052277023, 0, 0, 1.495046052277023, 0, 0)',
            x: 236.954128440367,
            y: 133.04587155963299
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: '#1',
            textColor1: '#FFF61A',
            fontFamily1: 'SPECTRAL:SEMI_BOLD:NORMAL',
            lineHeight1: 1.2,
            letterSpacing1: 0,
            text2: 'SOFTWARE\nSTABILIZATION',
            textColor2: '#FFF',
            fontFamily2: 'ALEGREYA:BOLD:NORMAL',
            lineHeight2: 1.2,
            letterSpacing2: 0,
            shadow: true
        },
        tags: ['technology', 'top-10', 'lower-third']
    }, {
        space: {
            width: 400,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-S1L4fmPpz', 'event-quote-bold', {
        space: {
            width: 1558.152873266382,
            height: 484.22629188873174,
            transform: 'matrix(1.0643067065347493, 0, 0, 1.0643067065347493, 0, 0)',
            x: 51.33158771408203,
            y: 500.52328499205856
        },
        time: {
            enterstart: 0,
            enterdone: 2000,
            exitstart: 3000,
            exitdone: 4500
        },
        values: {
            alpha: 1,
            text1: 'CODE PROVIDES A PLATFORM TO DISCUSS TECHNOLOGY ANDITS OVERLAP WITH POLITICS',
            color1: 'rgb(155, 192, 255)',
            textColor1: 'rgb(255, 255, 255)$$$[75,{"color":"rgb(155, 192, 255)","start":36,"end":45},{"color":"rgb(155, 192, 255)","start":67,"end":74}]',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            lineHeight1: 1.2,
            letterSpacing1: 0,
            text2: 'SHERYL SANDBERG, COO - FACEBOOK',
            textColor2: 'rgb(255, 255, 255)',
            fontFamily2: 'OPEN_SANS:SEMI_BOLD:NORMAL',
            lineHeight2: 1.2494791666666667,
            letterSpacing2: 0,
            shadow: true,
            fontSize1: 100,
            fontSize2: 60,
            lineSpacing1: 0,
            lineSpacing2: 0
        },
        tags: ['event']
    }, {
        space: {
            width: 1000,
            transform: 'scale(0.6, 0.6)'
        }
    }, {}), createTemplateFromDef('defId-BJeZQSc3z', 'buzzfeed-special', {
        space: {
            width: 1137.0184945058406,
            height: 1080,
            transform: 'matrix(2.440677966101695, 0, 0, 2.440677966101695, 0, 0)',
            x: 375.1271944331938,
            y: 0
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3500,
            exitdone: 4500
        },
        values: {
            textColor1: '#FFF61A',
            alpha: 1,
            text1: '\nALL\nTHE\nTIME\n ',
            fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
            align: 'center',
            shadow: true,
            lineHeight: 1.18,
            letterSpacing: 0,
            enterTextAnimType: 'none',
            exitTextAnimType: 'none',
            lineSpacing: 0
        },
        tags: ['buzzfeed', 'title', 'intro']
    }, {
        space: {
            width: 400,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-ByT6rpkxZ', 'count-down-listicle', {
        space: {
            width: 891.4679254839575,
            height: 293.41781618915314,
            transform: 'matrix(1.3099009651301479, 0, 0, 1.3099009651301479, 0, 0)',
            x: 813.5320745160425,
            y: 609.2645164803719
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4500
        },
        values: {
            color1: '#CB0714',
            color2: '#CB0714',
            color3: '#000',
            textColor1: '#FFFFFF',
            textColor2: '#FFFFFF',
            text1: '5. Taylor Swift ',
            text2: '#TOP10STARS',
            alpha: 1,
            fontFamily1: 'LOBSTER_TWO:NORMAL:ITALIC',
            fontFamily2: 'OPEN_SANS:SEMI_BOLD:NORMAL',
            lineHeight1: 1.4,
            lineHeight2: 1.4,
            letterSpacing1: 0,
            letterSpacing2: 0,
            shadow: false
        },
        tags: ['music', 'top-10', 'lower-third']
    }, {
        space: {
            width: 500,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-ByILf5TTz', 'champions-title', {
        space: {
            width: 1282.832705246264,
            height: 557.5755019592867,
            transform: 'matrix(2.6837427018346216, 0, 0, 2.6837427018346216, 0, 0)',
            x: 318.58364737686804,
            y: 261.21224902035664
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 4000
        },
        values: {
            alpha: 1,
            text1: "DON'T",
            textColor1: '#FFF$$$[5,{"color":"#B30004","start":0,"end":1}]',
            fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
            lineHeight1: 1.0304687499999998,
            letterSpacing1: 0,
            text2: 'QUIT',
            textColor2: '#000$$$[4,{"color":"#B30004","start":2,"end":3},{"color":"#FFFFFF","start":0,"end":1}]',
            fontFamily2: 'LATO:ULTRA_BOLD:NORMAL',
            lineHeight2: 1.0471354166666667,
            letterSpacing2: 0,
            shadow: false
        },
        tags: ['music', 'top-10', 'lower-third']
    }, {
        space: {
            width: 350,
            transform: 'scale(0.7, 0.7)'
        }
    }, {}), createTemplateFromDef('defId-ByxOg5ueb-tw', 'exq-smp-pipes-twitter', {
        space: {
            x: 40,
            y: 815,
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            text1: '/caseyneistat',
            alpha: 0.3,
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            alpha: 0.2,
            shadow: false
        }
    }, {
        backgroundColor: '#0084b4',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-pipes-twitter.png?v=2'
    }), createTemplateFromDef('defId-ByxOg5ueb-sc', 'exq-smp-pipes-snapchat', {
        space: {
            x: 40,
            y: 815,
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            text1: '/caseyneistat',
            alpha: 0.3,
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            alpha: 0.2,
            shadow: false
        }
    }, {
        backgroundColor: '#faff00',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-pipes-snapchat.png?v=3'
    }), createTemplateFromDef('defId-ByxOg5ueb-ig', 'exq-smp-pipes-instagram', {
        space: {
            x: 40,
            y: 815,
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            text1: '/caseyneistat',
            alpha: 0.3,
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            alpha: 0.2,
            shadow: false
        }
    }, {
        backgroundColor: '#b93894',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-pipes-instagram.png?v=2'
    }), createTemplateFromDef('defId-ByxOg5ueb-fb', 'exq-smp-pipes-facebook', {
        space: {
            x: 40,
            y: 815,
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            text1: 'Casey Neistat',
            alpha: 0.3,
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            alpha: 0.2,
            shadow: false
        }
    }, {
        backgroundColor: '#3c5a9a',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-pipes-facebook.png?v=2'
    }), createTemplateFromDef('defId-ByxOg5ueb-yt', 'exq-smp-pipes-youtube', {
        space: {
            x: 40,
            y: 815,
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'ALADIN:NORMAL:NORMAL',
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            text1: 'Casey Neistat',
            alpha: 0.3,
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 800,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#fff',
            color2: '#000',
            textColor1: '#fff',
            alpha: 0.2,
            shadow: false
        }
    }, {
        backgroundColor: '#bb0000',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-pipes-youtube.png?v=2'
    }), createTemplateFromDef('defId-SyBZK1sk-sc', 'exq-smp-wedgy-snapchat', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1660,
            exitstart: 5000,
            exitdone: 6660
        },
        values: {
            alpha: 1,
            color1: '#fffc00',
            color2: '#000',
            text1: '@caseyneistat',
            text2: 'FOLLOW ME ON',
            fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            fontFamily2: 'PT_SANS:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        values: {
            color1: '#fffc00',
            color2: '#000'
        }
    }, {
        backgroundColor: '#F1626E',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-wedgy-snapchat.png?v=2'
    }), createTemplateFromDef('defId-SyBZK1sk-fb', 'exq-smp-wedgy-facebook', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1660,
            exitstart: 5000,
            exitdone: 6660
        },
        values: {
            alpha: 1,
            color1: '#3b5998',
            color2: '#fff',
            text1: 'Casey Neistat',
            text2: 'LIKE ME ON',
            fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            fontFamily2: 'PT_SANS:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700
        },
        values: {
            color1: '#3b5998',
            color2: '#fff',
            text1: 'Casey Neistat',
            shadow: false
        }
    }, {
        backgroundColor: '#FFEA67',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-wedgy-facebook.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-SyBZK1sk-ig', 'exq-smp-wedgy-instagram', {
        tabs: {
            all: true,
            social: true
        },
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1660,
            exitstart: 5000,
            exitdone: 6660
        },
        values: {
            alpha: 1,
            color1: '#b93894',
            color2: '#fff',
            text1: '@caseyneistat',
            text2: 'FOLLOW ME ON',
            fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            fontFamily2: 'PT_SANS:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        values: {
            color1: '#b93894',
            color2: '#fff',
            shadow: true
        }
    }, {
        backgroundColor: '#FFF',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-wedgy-instagram.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-SyBZK1sk-tw', 'exq-smp-wedgy-twitter', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1660,
            exitstart: 5000,
            exitdone: 6660
        },
        values: {
            alpha: 1,
            color1: '#00abf1',
            color2: '#fff',
            text1: '@caseyneistat',
            text2: 'FOLLOW ME ON',
            fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            fontFamily2: 'PT_SANS:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        values: {
            color1: '#00abf1',
            color2: '#fff',
            shadow: false
        }
    }, {
        backgroundColor: '#e8dbff',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-wedgy-twitter.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-SyBZK1sk-yt', 'exq-smp-wedgy-youtube', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 1660,
            exitstart: 5000,
            exitdone: 6660
        },
        values: {
            alpha: 1,
            color1: '#bb0000',
            color2: '#fff',
            text1: 'Casey Neistat',
            text2: 'SUBSCRIBE ME ON',
            fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
            fontFamily2: 'PT_SANS:NORMAL:NORMAL',
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700
        },
        values: {
            color1: '#bb0000',
            color2: '#fff',
            text2: 'SUBSCRIBE',
            shadow: false
        }
    }, {
        backgroundColor: '#FFEA67',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-wedgy-youtube.png?v=2'
    }), createTemplateFromDef('defId-HJSyaloxZ-fb', 'exq-smp-flat-facebook', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            color1: '#3b5998',
            color2: '#FFF',
            textColor1: '#3b5998',
            text1: 'Casey Neistat',
            alpha: 1,
            shadow: false
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#3b5998',
            color2: '#FFF',
            textColor1: '#3b5998',
            shadow: false
        }
    }, {
        backgroundColor: '#A8AFE9',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-flat-facebook.png?v=2'
    }), createTemplateFromDef('defId-HJSyaloxZ-tw', 'exq-smp-flat-twitter', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            color1: '#0084b4',
            color2: '#FFF',
            textColor1: '#0084b4',
            text1: 'caseyneistat',
            alpha: 1,
            shadow: false
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#0084b4',
            color2: '#FFF',
            textColor1: '#0084b4',
            shadow: false
        }
    }, {
        backgroundColor: '#99D9EF',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-flat-twitter.png?v=2'
    }), createTemplateFromDef('defId-HJSyaloxZ-sc', 'exq-smp-flat-snapchat', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            color1: '#fffc00',
            color2: '#FFF',
            textColor1: '#fffc00',
            text1: 'caseyneistat',
            alpha: 1,
            shadow: true
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.79, 0.79)'
        },
        values: {
            color1: '#fffc00',
            color2: '#FFF',
            textColor1: '#fffc00',
            shadow: true
        }
    }, {
        backgroundColor: '#F8FFAA',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-flat-snapchat.png?v=2'
    }), createTemplateFromDef('defId-HJSyaloxZ-ig', 'exq-smp-flat-instagram', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            color1: '#b93894',
            color2: '#FFF',
            textColor1: '#b93894',
            text1: 'caseyneistat',
            alpha: 1,
            shadow: false
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#b93894',
            color2: '#FFF',
            textColor1: '#b93894',
            shadow: false
        }
    }, {
        backgroundColor: '#C89BB6',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-flat-instagram.png?v=2'
    }), createTemplateFromDef('defId-HJSyaloxZ-yt', 'exq-smp-flat-youtube', {
        space: {
            x: 40,
            y: 815,
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        time: {
            enterstart: 0,
            enterdone: 3000,
            exitstart: 4000,
            exitdone: 6000
        },
        values: {
            fontFamily1: 'EDO:NORMAL:NORMAL',
            color1: '#bb0000',
            color2: '#FFF',
            textColor1: '#bb0000',
            text1: 'casey neistat',
            alpha: 1,
            shadow: false
        },
        tags: ['socialMedia']
    }, {
        space: {
            width: 700,
            transform: 'scale(0.8, 0.8)'
        },
        values: {
            color1: '#bb0000',
            color2: '#FFF',
            textColor1: '#bb0000',
            shadow: false
        }
    }, {
        backgroundColor: '#EF8E9B',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-flat-youtube.png?v=2'
    }), createTemplateFromDef('defId-r1ikFdy1b', 'exq-smp-fireworks-instagram', {
        space: {
            width: 400,
            transform: 'scale(0.5, 0.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 3500
        },
        values: {
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            textColor1: '#BC2A8D',
            text1: 'ROSANE',
            alpha: 1
        },
        tags: ['socialMedia']
    }, {
        values: {
            textColor1: '#BC2A8D'
        }
    }, {
        backgroundColor: '#FFF',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-fireworks-instagram.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-Hk9HfRvkZ', 'exq-smp-fireworks-twitter', {
        space: {
            width: 400,
            transform: 'scale(0.5, 0.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 3500
        },
        values: {
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            textColor1: '#1DA1F2',
            text1: '@ROSANE',
            alpha: 1
        },
        tags: ['socialMedia']
    }, {
        values: {
            textColor1: '#1DA1F2'
        }
    }, {
        backgroundColor: '#E8DBFF',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-fireworks-twitter.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-HkSjE0wyW', 'exq-smp-fireworks-snapchat', {
        space: {
            width: 400,
            transform: 'scale(0.5, 0.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 3500
        },
        values: {
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            textColor1: '#FFFC00',
            text1: '@ROSANE',
            alpha: 1
        },
        tags: ['socialMedia']
    }, {
        values: {
            textColor1: '#FFFC00'
        }
    }, {
        backgroundColor: '#C4005B',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-fireworks-snapchat.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-Sy1P8AvJW', 'exq-smp-fireworks-facebook', {
        space: {
            width: 400,
            transform: 'scale(0.5, 0.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 3500
        },
        values: {
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            textColor1: '#3B5998',
            text1: 'ROSANE',
            alpha: 1
        },
        tags: ['socialMedia']
    }, {
        values: {
            textColor1: '#3B5998'
        }
    }, {
        backgroundColor: '#FFEA67',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-fireworks-facebook.png?v=2',
        preventLazyRender: true
    }), createTemplateFromDef('defId-HJss3Aw1W', 'exq-smp-fireworks-youtube', {
        space: {
            width: 400,
            transform: 'scale(0.5, 0.5)'
        },
        time: {
            enterstart: 0,
            enterdone: 1000,
            exitstart: 3000,
            exitdone: 3500
        },
        values: {
            fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
            textColor1: '#E62D27',
            text1: 'ROSANE',
            alpha: 1
        },
        tags: ['socialMedia']
    }, {
        values: {
            textColor1: '#E62D27'
        }
    }, {
        backgroundColor: '#FFEA67',
        previewImage: staticBaseUrl + '/images/template-previews/exq-smp-fireworks-youtube.png?v=2',
        preventLazyRender: true
    })]));

    textSubtitles.items.forEach(function (item) {
        item.type = _TemplateTypes2.default.SUBTITLE_TEXT;
    });
    textBasic.items.forEach(function (item) {
        item.type = _TemplateTypes2.default.BASIC_TEXT;
    });
    textPresets.items.forEach(function (item) {
        item.type = _TemplateTypes2.default.PRESET_TEXT;
    });

    // const shapes = TemplateConfig.images.find((grp) => grp.id === 'shapes');
    // const icons = TemplateConfig.images.find((grp) => grp.id === 'icons');

    // const IMAGES_COLOR = '#EFD954';

    // shapes.items.push.apply(shapes.items, [
    //     createTemplateFromDef('defId-HJ5p8T9s', '', {
    //         space: {
    //             width: 250,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-rJoHrT9o', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HyTgPpci', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HJfRI65j', '', {
    //         space: {
    //             width: 250,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-S1u08Tqs', '', {
    //         space: {
    //             width: 350,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-S1CA8p9s', '', {
    //         space: {
    //             width: 350,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-r1vkwa9s', '', {
    //         space: {
    //             width: 350,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-SJBlwp5i', '', {
    //         space: {
    //             width: 250,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-BkQl1lXQl', '', {
    //         space: {
    //             width: 450,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HJvnLpqj', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-S1o-v69i', '', {
    //         space: {
    //             width: 205,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HyVGvpqs', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-Sy6qM6co', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-BkEpL65s', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-rknn8T5o', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-SJQ-Daco', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-ryEQM6qi', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-SkehLpci', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-Sk_viB25', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HyPgfp5j', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-H161Dp5s', '', {
    //         space: {
    //             width: 315,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-By6Q1eQ7e', '', {
    //         space: {
    //             width: 450,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-Syr4yxXQx', '', {
    //         space: {
    //             width: 450,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    // ]);

    // shapes.items.forEach((item) => {
    //     item.type = TemplateTypes.SHAPES;
    //     item.name = ShapeIconNameMapping[item.defId];
    // });

    // icons.items.push.apply(icons.items, [
    //     createTemplateFromDef('defId-rykmPT5o', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-ryUQPpqo', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-B1T7wT9i', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-SkmEDp5j', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HJFEP6co', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-SJ4rv6ci', '', {
    //         space: {
    //             width: 300,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-Hk9BP65o', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-Syk8PT9j', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-HkU8wa9o', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    //     createTemplateFromDef('defId-H1hUw65i', '', {
    //         space: {
    //             width: 200,
    //         },
    //         time: {
    //             enterAnimDefId: 'animDefId-FADE-IN',
    //             exitAnimDefId: 'animDefId-FADE-OUT',
    //         },
    //         values: {
    //             color1: IMAGES_COLOR,
    //         },
    //     }),
    // ]);

    // icons.items.forEach((item) => {
    //     item.type = TemplateTypes.ICONS;
    //     item.name = ShapeIconNameMapping[item.defId];
    // });
}

exports.default = TemplateConfig;
exports.createTemplateFromDef = createTemplateFromDef;
exports.loadTemplates = loadTemplates;

},{"../../edit/components/utility/pluginUtils/general":200,"../constants":61,"../constants/PluginService":65,"../constants/TemplateTypes":67,"cloneextend":412,"deepmerge":549,"shortid":1163}],43:[function(require,module,exports){
module.exports=[
    {
        "value": "en",
        "label": "English",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "This is a preview of how your subtitle text would appear after adding content."
    },
    {
        "value": "af",
        "label": "Afrikaans",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Wie heuning wil eet, moet steke verdra."
    },
    {
        "value": "sq",
        "label": "Albanian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Çdo njeri ndërton fatin e vet"
    },
    {
        "value": "am",
        "label": "Amharic",
        "defaultFontKey": "NOTO_SANS_ETHIOPIC:NORMAL:NORMAL",
        "previewText": "ሁሉም ደህና ነው በጥሩ ሁኔታ ያበቃል"
    },
    {
        "value": "ar",
        "label": "Arabic",
        "defaultFontKey": "NOTO_SANS_ARABIC:NORMAL:NORMAL",
        "previewText": "لا يوجد طريق مختصر إلى مكان يستحق الذهاب إليه"
    },
    {
        "value": "hy",
        "label": "Armenian",
        "defaultFontKey": "NOTO_SANS_ARMENIAN:NORMAL:NORMAL",
        "previewText": "ամեն ինչ լավ է որ լավ է ավարտվում"
    },
    {
        "value": "az",
        "label": "Azerbaijani",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Həmişə unutmayın ki, siz tamamilə unikalsınız. Eynilə hamı kimi."
    },
    {
        "value": "eu",
        "label": "Basque",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Aberats izatea baino, izen ona hobe"
    },
    {
        "value": "be",
        "label": "Belarusian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Вы сутыкнецеся са шматлікімі паразамі ў жыцці, але ніколі не дазваляйце сябе перамагчы"
    },
    {
        "value": "bn",
        "label": "Bengali",
        "defaultFontKey": "NOTO_SANS_BENGALI:NORMAL:NORMAL",
        "previewText": "ভাগ্য তাদেরই সাথ দেয় যারা কর্মে বিশ্বাস করে ভাগ্যে নয়।"
    },
    {
        "value": "bs",
        "label": "Bosnian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ne zaboravi ko je bio uz tebe kad niko drugi nije"
    },
    {
        "value": "bg",
        "label": "Bulgarian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Няма значение колко бавно вървиш, стига да не се отказваш от пътя си."
    },
    {
        "value": "ca",
        "label": "Catalan",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "De l'arbre dolent no esperis bon fruit"
    },
    {
        "value": "ceb",
        "label": "Cebuano",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Unaha usa og silhig ang imong tugkaran, ayha manghinlo sa uban"
    },
    {
        "value": "zh",
        "label": "Chinese (Simplified)",
        "defaultFontKey": "NOTO_SANS_SC:NORMAL:NORMAL",
        "previewText": "我们在年轻时养成的习惯是我们在老年时所遵循的"
    },
    {
        "value": "zh-TW",
        "label": "Chinese (Traditional)",
        "defaultFontKey": "NOTO_SANS_TC:NORMAL:NORMAL",
        "previewText": "我們在年輕時養成的習慣是我們在老年時所遵循的"
    },
    {
        "value": "co",
        "label": "Corsican",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "U mondu he bellu basta a sapellu piglia"
    },
    {
        "value": "hr",
        "label": "Croatian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Bez muke nema nauke"
    },
    {
        "value": "cs",
        "label": "Czech",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Bez práce nejsou koláče."
    },
    {
        "value": "da",
        "label": "Danish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Man lærer at nyde udsigten, når man har stået tilstrækkeligt længe ved afgrunden"
    },
    {
        "value": "nl",
        "label": "Dutch",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Wees de verandering die je in de wereld wil zien gebeuren."
    },
    {
        "value": "eo",
        "label": "Esperanto",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Amikon montras malfeliĉo"
    },
    {
        "value": "et",
        "label": "Estonian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "kes otsib, see leiab"
    },
    {
        "value": "fi",
        "label": "Finnish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ei kysyvä tieltä eksy."
    },
    {
        "value": "fr",
        "label": "French",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Le bonheur n’est pas quelque chose de prêt à l’emploi. Il vient de vos propres actions."
    },
    {
        "value": "fy",
        "label": "Frisian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Wy moatte leare sa lang as wy libje"
    },
    {
        "value": "gl",
        "label": "Galician",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "La acción es la clave fundamental para todo éxito"
    },
    {
        "value": "ka",
        "label": "Georgian",
        "defaultFontKey": "NOTO_SANS_GEORGIAN:NORMAL:NORMAL",
        "previewText": "ვარდი უეკლოდ ვის მოუკრეფავს"
    },
    {
        "value": "de",
        "label": "German",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Anfangen ist leicht, Beharren eine Kunst."
    },
    {
        "value": "el",
        "label": "Greek",
        "defaultFontKey": "NOTO_SANS_GR:NORMAL:NORMAL",
        "previewText": "Επιτυχημένος είναι ο άνθρωπος που μπορεί να θέσει σταθερά θεμέλια με τα τούβλα που οι άλλοι έχουν πετάξει πάνω του."
    },
    {
        "value": "gu",
        "label": "Gujarati",
        "defaultFontKey": "NOTO_SANS_GUJARATI:NORMAL:NORMAL",
        "previewText": "ખુદમાં વિશ્વાસ હોવો એ સફળતા નું પહેલું રહસ્ય છે."
    },
    {
        "value": "ht",
        "label": "Haitian Creole",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Sa ou fè se li ou wè"
    },
    {
        "value": "ha",
        "label": "Hausa",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Komi da nashi rana"
    },
    {
        "value": "haw",
        "label": "Hawaiian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "`A`ohe loa i ka hana a ke aloha"
    },
    {
        "value": "he",
        "label": "Hebrew",
        "defaultFontKey": "NOTO_SANS_HEBREW:NORMAL:NORMAL",
        "previewText": "אושר אינו דבר שמגיע מן המוכן, הוא נובע מפעילויותיך"
    },
    {
        "value": "hi",
        "label": "Hindi",
        "defaultFontKey": "NOTO_SANS_DEVANAGARI:NORMAL:NORMAL",
        "previewText": "अगर सूरज के तरह जलना है तो रोज उगना पड़ेगा।"
    },
    {
        "value": "hmn",
        "label": "Hmong",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Thov kom koj tau txais koob hmoo tas hnub"
    },
    {
        "value": "hu",
        "label": "Hungarian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Az idő minden sebet begyógyít."
    },
    {
        "value": "is",
        "label": "Icelandic",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Af góðu upphafi vonast góður endir"
    },
    {
        "value": "ig",
        "label": "Igbo",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ka anyasị eteka, chi ga-efo"
    },
    {
        "value": "id",
        "label": "Indonesian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Keberhasilan bukanlah milik orang yang pintar. Keberhasilan adalah kepunyaan mereka yang senantiasa berusaha."
    },
    {
        "value": "ga",
        "label": "Irish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "An té a bhíónn siúlach, bíonn scéalach"
    },
    {
        "value": "it",
        "label": "Italian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Siamo angeli con un’ala sola: possiamo volare solo se abbracciati."
    },
    {
        "value": "ja",
        "label": "Japanese",
        "defaultFontKey": "NOTO_SANS_JP:NORMAL:NORMAL",
        "previewText": "若い頃に身につけた習慣は、老年になっても続くものです"
    },
    {
        "value": "jv",
        "label": "Javanese",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Tanpa ngarep-arep ganjaran, nyambut gawe kanthi tekun."
    },
    {
        "value": "kn",
        "label": "Kannada",
        "defaultFontKey": "NOTO_SANS_KANNADA:NORMAL:NORMAL",
        "previewText": "ಕಷ್ಟ ಆದರೂ ಪರವಾಗಿಲ್ಲ, ನೋಯಿಸುವ ಮುಂದೆ ನಕ್ಕೊಂಡೆ ಬದುಕಬೇಕು"
    },
    {
        "value": "kk",
        "label": "Kazakh",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Жалғыз мүмкін емес сапар - сіз ешқашан бастамайтын сапар."
    },
    {
        "value": "km",
        "label": "Khmer",
        "defaultFontKey": "NOTO_SANS_KHMER:NORMAL:NORMAL",
        "previewText": "គោលបំណងនៃជីវិតរបស់យើងគឺដើម្បីសុភមង្គល"
    },
    {
        "value": "rw",
        "label": "Kinyarwanda",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Utiteze ibihembo, kora ushishikaye."
    },
    {
        "value": "ko",
        "label": "Korean",
        "defaultFontKey": "NOTO_SANS_KR:NORMAL:NORMAL",
        "previewText": "우리가 젊었을 때 개발한 습관은 우리가 노년기에 따라야 하는 것입니다."
    },
    {
        "value": "ku",
        "label": "Kurdish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Rêhevalekî baş riya herî dirêj kurt dike."
    },
    {
        "value": "ky",
        "label": "Kyrgyz",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Баштоо жолу - сүйлөшүүнү таштап, ишти баштоо"
    },
    {
        "value": "lo",
        "label": "Lao",
        "defaultFontKey": "NOTO_SANS_LAO:NORMAL:NORMAL",
        "previewText": "ວິທີເລີ່ມຕົ້ນແມ່ນເຊົາເວົ້າ ແລະເລີ່ມເຮັດ"
    },
    {
        "value": "la",
        "label": "Latin",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Memento vivere."
    },
    {
        "value": "lv",
        "label": "Latvian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ne viss ir zelts, kas spīd."
    },
    {
        "value": "lt",
        "label": "Lithuanian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Gera pradžia pusė darbo."
    },
    {
        "value": "lb",
        "label": "Luxembourgish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Schéinen Dag nach"
    },
    {
        "value": "mk",
        "label": "Macedonian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Добриот пријател се препознава во време на неволја."
    },
    {
        "value": "mg",
        "label": "Malagasy",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Mirary tontolo andro finaritra"
    },
    {
        "value": "ms",
        "label": "Malay",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Semoga hari anda indah"
    },
    {
        "value": "ml",
        "label": "Malayalam",
        "defaultFontKey": "NOTO_SANS_MALAYALAM:NORMAL:NORMAL",
        "previewText": "ദൃഢ നിശ്ചയം ചെയ്തവർക്ക് എന്തിനെയും മറികടക്കാൻ കഴിയും."
    },
    {
        "value": "mt",
        "label": "Maltese",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Fejn tħobb il-qalb jimxu r-riġlejn"
    },
    {
        "value": "mi",
        "label": "Maori",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ka noho ora te tangata kaha, ko te tangata mangere ka mate"
    },
    {
        "value": "mr",
        "label": "Marathi",
        "defaultFontKey": "NOTO_SANS_DEVANAGARI:NORMAL:NORMAL",
        "previewText": "शहाणा माणूस प्रत्येकवेळी एकांतात आणि आणि कमजोर व्यक्ती नेहमी घोळक्यात दिसतो."
    },
    {
        "value": "mn",
        "label": "Mongolian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Өндөр барихыг хүссэн хүн гүн ухах ёстой"
    },
    {
        "value": "my",
        "label": "Myanmar (Burmese)",
        "defaultFontKey": "NOTO_SANS_MYANMAR:NORMAL:NORMAL",
        "previewText": "အောင်မြင်မှုရဲ့လျှို့ဝှက်ချက်ဆိုတာမရှိပါဘူး။ဒါဟာပြင်ဆင်မှု၊ ကြိုးစားအားထုတ်မှု၊ ကျရှုံးမှုကနေ သင်ယူခြင်းရဲ့ရလဒ်ပါ။",
        "enabled": false
    },
    {
        "value": "ne",
        "label": "Nepali",
        "defaultFontKey": "NOTO_SANS_DEVANAGARI:NORMAL:NORMAL",
        "previewText": "सफल हुने मान्छेले गुनासाे गर्दैन तर असफल हुने मान्छे गुनासाे गर्न कहिल्यै छाेड्दैन ।"
    },
    {
        "value": "no",
        "label": "Norwegian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Bedre sent enn aldri"
    },
    {
        "value": "ny",
        "label": "Nyanja (Chichewa)",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Kuliko mochedwa kuposa kale"
    },
    {
        "value": "or",
        "label": "Odia (Oriya)",
        "defaultFontKey": "NOTO_SANS_ORIYA:NORMAL:NORMAL",
        "previewText": "ମହାନଙ୍କ ପାଇଁ ଯିବାକୁ ଭଲ ଛାଡିବାକୁ ଭୟ କର ନାହିଁ |"
    },
    {
        "value": "ps",
        "label": "Pashto",
        "defaultFontKey": "NOTO_SANS_ARABIC:NORMAL:NORMAL",
        "previewText": "باور وکړئ چې تاسو کولی شئ او تاسو په نیمه لاره کې یاست."
    },
    {
        "value": "fa",
        "label": "Persian",
        "defaultFontKey": "NOTO_SANS_ARABIC:NORMAL:NORMAL",
        "previewText": "تا زمانی که متوقف نشوید، مهم نیست که چقدر آهسته حرکت می کنید."
    },
    {
        "value": "pl",
        "label": "Polish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Proście, a będzie wam dane, szukajcie, a znajdziecie."
    },
    {
        "value": "pt",
        "label": "Portuguese (Portugal, Brazil)",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Mais vale um pássaro na mão do que dois voando."
    },
    {
        "value": "pa",
        "label": "Punjabi",
        "defaultFontKey": "NOTO_SANS_GURMUKHI:NORMAL:NORMAL",
        "previewText": "ਤੁਸੀਂ ਉਹ ਬਣ ਜਾਂਦੇ ਹੋ ਜੋ ਤੁਸੀਂ ਮੰਨਦੇ ਹੋ।"
    },
    {
        "value": "ro",
        "label": "Romanian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Bine faci, bine găsești"
    },
    {
        "value": "ru",
        "label": "Russian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "необходимость – мать изобретательства"
    },
    {
        "value": "sm",
        "label": "Samoan",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "O le ala i le pule o le tautau"
    },
    {
        "value": "gd",
        "label": "Scots Gaelic",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Chan eil thu tuilleach 's sean airson ionnsachadh fhathast"
    },
    {
        "value": "sr",
        "label": "Serbian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Највежа слава у ћивоту не лећи у не падању, веж у подизању сваког пада."
    },
    {
        "value": "st",
        "label": "Sesotho",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "U ka atleha moo u kileng ua hlōleha"
    },
    {
        "value": "sn",
        "label": "Shona",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Unogona kubudirira pawakambokundikana"
    },
    {
        "value": "sd",
        "label": "Sindhi",
        "defaultFontKey": "NOTO_SANS_ARABIC:NORMAL:NORMAL",
        "previewText": "هر جاءِ تي پيار پکيڙيو، ڪو به توهان وٽ اچڻ نه ڏيو بغير ڪنهن خوشيءَ کان سواءِ."
    },
    {
        "value": "si",
        "label": "Sinhala (Sinhalese)",
        "defaultFontKey": "NOTO_SANS_SINHALA:NORMAL:NORMAL",
        "previewText": "ඔබ යන සෑම තැනකම ආදරය පතුරුවන්න. කිසිවකු සතුටින් ඔබ වෙත නොඑනු ඇත."
    },
    {
        "value": "sk",
        "label": "Slovak",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Dobrý počiatok polovica práce"
    },
    {
        "value": "sl",
        "label": "Slovenian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Dober pocitek je pol dela."
    },
    {
        "value": "so",
        "label": "Somali",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Iskaashato ma kufto"
    },
    {
        "value": "es",
        "label": "Spanish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "De músico, poeta y loco, todos tenemos un poco."
    },
    {
        "value": "su",
        "label": "Sundanese",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Gawé babarengan teu gagal"
    },
    {
        "value": "sw",
        "label": "Swahili",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Lisilo budi hutendwa"
    },
    {
        "value": "sv",
        "label": "Swedish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "För att lyckas i livet behöver du två saker: okunnighet och självförtroende"
    },
    {
        "value": "tl",
        "label": "Tagalog (Filipino)",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ang pag-abot sa iyong mga pangarap ang pinakamalaking abentura ng buhay"
    },
    {
        "value": "tg",
        "label": "Tajik",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ба ҳар куҷое, ки меравӣ, муҳаббатро паҳн кун. Бигзор ҳеҷ кас ба назди ту наояд, бе он ки хушбахттар бошад."
    },
    {
        "value": "ta",
        "label": "Tamil",
        "defaultFontKey": "NOTO_SANS_TAMIL:NORMAL:NORMAL",
        "previewText": "நீங்கள் நிறுத்தாத வரை எவ்வளவு மெதுவாகச் சென்றாலும் பரவாயில்லை."
    },
    {
        "value": "tt",
        "label": "Tatar",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Киләчәк үз хыялларының матурлыгына ышанган кешеләргә карый."
    },
    {
        "value": "te",
        "label": "Telugu",
        "defaultFontKey": "NOTO_SANS_TELUGU:NORMAL:NORMAL",
        "previewText": "జీవితం అంటే నిన్ను నువ్వు చూసుకోవటం కాదు, నిన్ను నువ్వు రూపు దిద్దుకోవటం."
    },
    {
        "value": "th",
        "label": "Thai",
        "defaultFontKey": "NOTO_SANS_THAI:NORMAL:NORMAL",
        "previewText": "ไม่มีทางจะข้ามมหาสมุทรได้ หากยังไม่กล้าพอจะออกไปไกลจนไม่เห็นฝั่ง"
    },
    {
        "value": "tr",
        "label": "Turkish",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Her kışın bir baharı, her gecenin bir sabahı vardır."
    },
    {
        "value": "tk",
        "label": "Turkmen",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Her möwsümde bahar bolýar, gijesinde daň bar."
    },
    {
        "value": "uk",
        "label": "Ukrainian",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Людина створена для щастя, як птах для польоту"
    },
    {
        "value": "ur",
        "label": "Urdu",
        "defaultFontKey": "NOTO_SANS_ARABIC:NORMAL:NORMAL",
        "previewText": "ہمیشہ یاد رکھیں کہ آپ بالکل منفرد ہیں۔ بالکل ہر کسی کی طرح."
    },
    {
        "value": "ug",
        "label": "Uyghur",
        "defaultFontKey": "NOTO_SANS_ARABIC:NORMAL:NORMAL",
        "previewText": "ئېسىڭىزدە بولسۇنكى ، سىز مۇتلەق ئۆزگىچە. باشقىلارغا ئوخشاش."
    },
    {
        "value": "uz",
        "label": "Uzbek",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Kuningiz yaxshi o'tsin"
    },
    {
        "value": "vi",
        "label": "Vietnamese",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Luôn nhớ rằng bạn hoàn toàn độc đáo. Cũng giống như những người khác."
    },
    {
        "value": "cy",
        "label": "Welsh",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Mewn pob daioni y mae gwobr"
    },
    {
        "value": "xh",
        "label": "Xhosa",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ithemba liyaphilisa."
    },
    {
        "value": "yi",
        "label": "Yiddish",
        "defaultFontKey": "NOTO_SANS_HEBREW:NORMAL:NORMAL",
        "previewText": "די געוווינהייטן וואָס מיר אַנטוויקלען אין יוגנט זענען וואָס מיר נאָכגיין אין עלטער."
    },
    {
        "value": "yo",
        "label": "Yoruba",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Ifẹ bẹrẹ ni ile"
    },
    {
        "value": "zu",
        "label": "Zulu",
        "defaultFontKey": "NOTO_SANS:NORMAL:NORMAL",
        "previewText": "Kuhlonishwa kabili "
    }
]

},{}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "v": "4.6.8", "fr": 60, "ip": 0, "op": 103, "w": 3840, "h": 2160, "nm": "Lower third 01 Full", "ddd": 0, "assets": [], "layers": [{ "ddd": 0, "ind": 1, "ty": 3, "nm": "NULL CONTROL", "ks": { "o": { "a": 0, "k": 0 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [1799.392, 1568.3, 0] }, "a": { "a": 0, "k": [60, 60, 0] }, "s": { "a": 0, "k": [100, 100, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "color1", "mn": "ADBE Color Control", "ix": 1, "en": 1, "ef": [{ "ty": 2, "nm": "Color", "mn": "ADBE Color Control-0001", "ix": 1, "v": { "a": 1, "k": [{ "i": { "x": 0, "y": 0 }, "o": { "x": 0, "y": 0 }, "s": [0.3294118, 0.3294118, 0.3294118, 1], "e": [0.3294118, 0.3294118, 0.3294119, 1], "t": 0 }, { "t": 2500 }] } }] }, { "ty": 5, "nm": "color2", "mn": "ADBE Color Control", "ix": 2, "en": 1, "ef": [{ "ty": 2, "nm": "Color", "mn": "ADBE Color Control-0001", "ix": 1, "v": { "a": 1, "k": [{ "i": { "x": 0, "y": 0 }, "o": { "x": 0, "y": 0 }, "s": [0.999999, 1, 1, 1], "e": [1, 1, 1, 1], "t": 0 }, { "t": 2500 }] } }] }], "ip": 0, "op": 907, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "line3", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 1, "k": [{ "i": { "x": 0, "y": 1 }, "o": { "x": 0.34, "y": 0 }, "n": "0_1_0p34_0", "t": 3, "s": [210.608, -154.3, 0], "e": [630.608, -154.3, 0], "to": [0, 0, 0], "ti": [0, 0, 0] }, { "i": { "x": 0, "y": 1 }, "o": { "x": 0.34, "y": 0 }, "n": "0_1_0p34_0", "t": 27, "s": [630.608, -154.3, 0], "e": [630.608, -121.7, 0], "to": [0, 0, 0], "ti": [0, 0, 0] }, { "t": 44 }] }, "a": { "a": 0, "k": [562, -177, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0, 0, 0], "y": [1, 1, 0] }, "o": { "x": [0.34, 0.34, 0.34], "y": [0, 0, 0.34] }, "n": ["0_1_0p34_0", "0_1_0p34_0", "0_0_0p34_0p34"], "t": 3, "s": [0, 0, 100], "e": [141, 10, 100] }, { "i": { "x": [0, 0, 0], "y": [0, 0, 0] }, "o": { "x": [0.34, 0.34, 0.34], "y": [0.34, 0.34, 0.34] }, "n": ["0_0_0p34_0p34", "0_0_0p34_0p34", "0_0_0p34_0p34"], "t": 13, "s": [141, 10, 100], "e": [141, 10, 100] }, { "i": { "x": [0.191, 0.363, 0], "y": [0.191, 1, 0] }, "o": { "x": [0.34, 0.34, 0.34], "y": [0.34, 0, 0.34] }, "n": ["0p191_0p191_0p34_0p34", "0p363_1_0p34_0", "0_0_0p34_0p34"], "t": 27, "s": [141, 10, 100], "e": [141, 100, 100] }, { "t": 57 }] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [1, 0, 0, 1], "x": "var $bm_rt;\n$bm_rt = thisComp.layer('NULL CONTROL').effect('color2')('Color');" } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "shapes": [{ "ty": "gr", "it": [{ "ty": "rc", "d": 1, "s": { "a": 0, "k": [11, 293] }, "p": { "a": 0, "k": [0, 0] }, "r": { "a": 0, "k": 0 }, "nm": "Rectangle Path 1", "mn": "ADBE Vector Shape - Rect" }, { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [567.5, -30.5], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Rectangle 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 0, "op": 900, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "box1", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [631.392, 25.7, 0] }, "a": { "a": 0, "k": [572, 528, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0, 0, 0], "y": [1, 0, 0] }, "o": { "x": [0.34, 0.34, 0.34], "y": [0, 0.34, 0.34] }, "n": ["0_1_0p34_0", "0_0_0p34_0p34", "0_0_0p34_0p34"], "t": 0, "s": [0, 76.5, 100], "e": [84.2, 76.5, 100] }, { "t": 66 }] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [1, 0, 0, 1], "x": "var $bm_rt;\n$bm_rt = thisComp.layer('NULL CONTROL').effect('color1')('Color');" } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "shapes": [{ "ty": "gr", "it": [{ "ty": "rc", "d": 1, "s": { "a": 0, "k": [2304, 384] }, "p": { "a": 0, "k": [0, 0] }, "r": { "a": 0, "k": 0 }, "nm": "Rectangle Path 1", "mn": "ADBE Vector Shape - Rect" }, { "ty": "fl", "c": { "a": 0, "k": [0.2156863, 0.2156863, 0.2156863, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [-580, 528], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Rectangle 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 0, "op": 891, "st": -9, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "line2", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 180 }, "p": { "a": 0, "k": [-150.392, 29.7, 0] }, "a": { "a": 0, "k": [-580, 528, 0] }, "s": { "a": 0, "k": [100, 100, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [1, 0, 0, 1], "x": "var $bm_rt;\n$bm_rt = thisComp.layer('NULL CONTROL').effect('color2')('Color');" } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "shapes": [{ "ty": "gr", "it": [{ "ty": "rc", "d": 1, "s": { "a": 0, "k": [2027, 322] }, "p": { "a": 0, "k": [185, 0] }, "r": { "a": 0, "k": 0 }, "nm": "Rectangle Path 1", "mn": "ADBE Vector Shape - Rect" }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0], "y": [1] }, "o": { "x": [0.34], "y": [0] }, "n": ["0_1_0p34_0"], "t": 14, "s": [8], "e": [56.74] }, { "t": 77 }], "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0], "y": [1] }, "o": { "x": [0.34], "y": [0] }, "n": ["0_1_0p34_0"], "t": 0, "s": [8], "e": [56.74] }, { "t": 65 }], "ix": 2 }, "o": { "a": 0, "k": -27.9, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 9 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [-580, 538], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Rectangle 1", "np": 4, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 0, "op": 891, "st": -9, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 6, "ty": 4, "nm": "line1", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [-511.392, 25.7, 0] }, "a": { "a": 0, "k": [-580, 528, 0] }, "s": { "a": 0, "k": [100, 100, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [1, 0, 0, 1], "x": "var $bm_rt;\n$bm_rt = thisComp.layer('NULL CONTROL').effect('color2')('Color');" } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "shapes": [{ "ty": "gr", "it": [{ "ty": "rc", "d": 1, "s": { "a": 0, "k": [2027, 322] }, "p": { "a": 0, "k": [185, 0] }, "r": { "a": 0, "k": 0 }, "nm": "Rectangle Path 1", "mn": "ADBE Vector Shape - Rect" }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0], "y": [1] }, "o": { "x": [0.34], "y": [0] }, "n": ["0_1_0p34_0"], "t": 9, "s": [8], "e": [56.74] }, { "t": 72 }], "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0], "y": [1] }, "o": { "x": [0.34], "y": [0] }, "n": ["0_1_0p34_0"], "t": 0, "s": [8], "e": [56.74] }, { "t": 65 }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 9 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [-580, 538], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Rectangle 1", "np": 4, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 0, "op": 891, "st": -9, "bm": 0, "sr": 1 }] };

exports.default = v;

},{}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "v": "4.6.8", "fr": 60, "ip": 0, "op": 300, "w": 1920, "h": 1080, "nm": "LowerThird4_Full", "ddd": 0, "assets": [], "layers": [{ "ddd": 0, "ind": 1, "ty": 3, "nm": "PositionCtr", "ks": { "o": { "a": 0, "k": 0 }, "r": { "a": 0, "k": 90 }, "p": { "a": 0, "k": [251.925, 970.5, 0] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [100, 100, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Color1", "mn": "ADBE Color Control", "ix": 1, "en": 1, "ef": [{ "ty": 2, "nm": "Color", "mn": "ADBE Color Control-0001", "ix": 1, "v": { "a": 1, "k": [{ "i": { "x": 0, "y": 0 }, "o": { "x": 0, "y": 0 }, "s": [1, 0, 0, 1], "e": [0.9999, 0, 0, 1], "t": 0 }, { "t": 2500 }] } }] }, { "ty": 5, "nm": "Color2", "mn": "ADBE Color Control", "ix": 2, "en": 1, "ef": [{ "ty": 2, "nm": "Color", "mn": "ADBE Color Control-0001", "ix": 1, "v": { "a": 1, "k": [{ "i": { "x": 0, "y": 0 }, "o": { "x": 0, "y": 0 }, "s": [0, 0.2533089, 1, 1], "e": [0, 0.2533088, 1, 1], "t": 0 }, { "t": 2500 }] } }] }], "ip": 0, "op": 300, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 1, "nm": "Background Mask", "parent": 1, "td": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": -90 }, "p": { "s": true, "x": { "a": 0, "k": -49.41 }, "y": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 0, "s": [-858], "e": [0] }, { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 60, "s": [0], "e": [0] }, { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 240, "s": [0], "e": [-858] }, { "t": 300 }], "x": "var $bm_rt;\nvar p = 0.81;\nvar a = 50;\nvar s = 1.70158;\nfunction easeandwizz_outExpo(t, b, c, d) {\n    var OUT_EXPO_CORRECTION = 1.000976;\n    return t == d ? b + c : c * OUT_EXPO_CORRECTION * (-Math.pow(2, -10 * t / d) + 1) + b;\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key(sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    var dim = 1;\n    try {\n        key(1)[1].length;\n        dim = 2;\n        key(1)[2].length;\n        dim = 3;\n    } catch (e) {\n    }\n    t = sub(time, key1.time);\n    d = sub(key2.time, key1.time);\n    sX = key1[0];\n    eX = sub(key2[0], key1[0]);\n    if (dim >= 2) {\n        sY = key1[1];\n        eY = sub(key2[1], key1[1]);\n        if (dim >= 3) {\n            sZ = key1[2];\n            eZ = sub(key2[2], key1[2]);\n        }\n    }\n    if (time < key1.time || time > key2.time) {\n        return value;\n    } else {\n        val1 = easeandwizz_outExpo(t, sX, eX, d, a, p, s);\n        switch (dim) {\n        case 1:\n            return val1;\n            break;\n        case 2:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            return [\n                val1,\n                val2\n            ];\n            break;\n        case 3:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            val3 = easeandwizz_outExpo(t, sZ, eZ, d, a, p, s);\n            return [\n                val1,\n                val2,\n                val3\n            ];\n            break;\n        default:\n            return null;\n        }\n    }\n}\n$bm_rt = easeAndWizz() || value;" } }, "a": { "a": 0, "k": [0, 540, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 0, "s": [0, 13.3, 100], "e": [44.679, 13.3, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 60, "s": [44.679, 13.3, 100], "e": [44.679, 13.3, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 240, "s": [44.679, 13.3, 100], "e": [0, 13.3, 100] }, { "t": 300 }], "x": "var $bm_rt;\nvar p = 0.81;\nvar a = 50;\nvar s = 1.70158;\nfunction easeandwizz_outExpo(t, b, c, d) {\n    var OUT_EXPO_CORRECTION = 1.000976;\n    return t == d ? b + c : c * OUT_EXPO_CORRECTION * (-Math.pow(2, -10 * t / d) + 1) + b;\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key(sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    var dim = 1;\n    try {\n        key(1)[1].length;\n        dim = 2;\n        key(1)[2].length;\n        dim = 3;\n    } catch (e) {\n    }\n    t = sub(time, key1.time);\n    d = sub(key2.time, key1.time);\n    sX = key1[0];\n    eX = sub(key2[0], key1[0]);\n    if (dim >= 2) {\n        sY = key1[1];\n        eY = sub(key2[1], key1[1]);\n        if (dim >= 3) {\n            sZ = key1[2];\n            eZ = sub(key2[2], key1[2]);\n        }\n    }\n    if (time < key1.time || time > key2.time) {\n        return value;\n    } else {\n        val1 = easeandwizz_outExpo(t, sX, eX, d, a, p, s);\n        switch (dim) {\n        case 1:\n            return val1;\n            break;\n        case 2:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            return [\n                val1,\n                val2\n            ];\n            break;\n        case 3:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            val3 = easeandwizz_outExpo(t, sZ, eZ, d, a, p, s);\n            return [\n                val1,\n                val2,\n                val3\n            ];\n            break;\n        default:\n            return null;\n        }\n    }\n}\n$bm_rt = easeAndWizz() || value;" } }, "ao": 0, "sw": 1920, "sh": 1080, "sc": "#f7f7f7", "ip": 0, "op": 288, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 1, "nm": "SolidLine", "parent": 5, "tt": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "s": true, "x": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 0, "s": [955.5], "e": [9.5] }, { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 60, "s": [9.5], "e": [9.5] }, { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 206.4, "s": [9.5], "e": [955.5] }, { "t": 266.400390625 }], "x": "var $bm_rt;\nvar p = 0.81;\nvar a = 50;\nvar s = 1.70158;\nfunction easeandwizz_inOutExpo(t, b, c, d) {\n    if (t == 0)\n        return b;\n    if (t == d)\n        return sum(b, c);\n    if ((t /= d / 2) < 1)\n        return sum(mul(div(c, 2), Math.pow(2, mul(10, sub(t, 1)))), b);\n    return sum(mul(div(c, 2), sum($bm_neg(Math.pow(2, mul(-10, --t))), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key(sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    var dim = 1;\n    try {\n        key(1)[1].length;\n        dim = 2;\n        key(1)[2].length;\n        dim = 3;\n    } catch (e) {\n    }\n    t = sub(time, key1.time);\n    d = sub(key2.time, key1.time);\n    sX = key1[0];\n    eX = sub(key2[0], key1[0]);\n    if (dim >= 2) {\n        sY = key1[1];\n        eY = sub(key2[1], key1[1]);\n        if (dim >= 3) {\n            sZ = key1[2];\n            eZ = sub(key2[2], key1[2]);\n        }\n    }\n    if (time < key1.time || time > key2.time) {\n        return value;\n    } else {\n        val1 = easeandwizz_inOutExpo(t, sX, eX, d, a, p, s);\n        switch (dim) {\n        case 1:\n            return val1;\n            break;\n        case 2:\n            val2 = easeandwizz_inOutExpo(t, sY, eY, d, a, p, s);\n            return [\n                val1,\n                val2\n            ];\n            break;\n        case 3:\n            val2 = easeandwizz_inOutExpo(t, sY, eY, d, a, p, s);\n            val3 = easeandwizz_inOutExpo(t, sZ, eZ, d, a, p, s);\n            return [\n                val1,\n                val2,\n                val3\n            ];\n            break;\n        default:\n            return null;\n        }\n    }\n}\n$bm_rt = easeAndWizz() || value;" }, "y": { "a": 0, "k": 540 } }, "a": { "a": 0, "k": [960, 540, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 0, "s": [110, 103.236, 100], "e": [3, 103.236, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 60, "s": [3, 103.236, 100], "e": [3, 103.236, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 206.4, "s": [3, 103.236, 100], "e": [110, 103.236, 100] }, { "t": 266.400390625 }], "x": "var $bm_rt;\nvar p = 0.81;\nvar a = 50;\nvar s = 1.70158;\nfunction easeandwizz_inOutExpo(t, b, c, d) {\n    if (t == 0)\n        return b;\n    if (t == d)\n        return sum(b, c);\n    if ((t /= d / 2) < 1)\n        return sum(mul(div(c, 2), Math.pow(2, mul(10, sub(t, 1)))), b);\n    return sum(mul(div(c, 2), sum($bm_neg(Math.pow(2, mul(-10, --t))), 2)), b);\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key(sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    var dim = 1;\n    try {\n        key(1)[1].length;\n        dim = 2;\n        key(1)[2].length;\n        dim = 3;\n    } catch (e) {\n    }\n    t = sub(time, key1.time);\n    d = sub(key2.time, key1.time);\n    sX = key1[0];\n    eX = sub(key2[0], key1[0]);\n    if (dim >= 2) {\n        sY = key1[1];\n        eY = sub(key2[1], key1[1]);\n        if (dim >= 3) {\n            sZ = key1[2];\n            eZ = sub(key2[2], key1[2]);\n        }\n    }\n    if (time < key1.time || time > key2.time) {\n        return value;\n    } else {\n        val1 = easeandwizz_inOutExpo(t, sX, eX, d, a, p, s);\n        switch (dim) {\n        case 1:\n            return val1;\n            break;\n        case 2:\n            val2 = easeandwizz_inOutExpo(t, sY, eY, d, a, p, s);\n            return [\n                val1,\n                val2\n            ];\n            break;\n        case 3:\n            val2 = easeandwizz_inOutExpo(t, sY, eY, d, a, p, s);\n            val3 = easeandwizz_inOutExpo(t, sZ, eZ, d, a, p, s);\n            return [\n                val1,\n                val2,\n                val3\n            ];\n            break;\n        default:\n            return null;\n        }\n    }\n}\n$bm_rt = easeAndWizz() || value;" } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [0.0752941, 0.5697991, 0.8, 1], "x": "var $bm_rt;\n$bm_rt = thisComp.layer('PositionCtr').effect('Color1')('Color');" } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "sw": 1920, "sh": 1080, "sc": "#000000", "ip": 0, "op": 288, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 1, "nm": "Background Mask 2", "parent": 1, "td": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": -90 }, "p": { "s": true, "x": { "a": 0, "k": -49.41 }, "y": { "a": 1, "k": [{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 0, "s": [-858], "e": [0] }, { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 60, "s": [0], "e": [0] }, { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p833_0p833_0p167_0p167"], "t": 240, "s": [0], "e": [-858] }, { "t": 300 }], "x": "var $bm_rt;\nvar p = 0.81;\nvar a = 50;\nvar s = 1.70158;\nfunction easeandwizz_outExpo(t, b, c, d) {\n    var OUT_EXPO_CORRECTION = 1.000976;\n    return t == d ? b + c : c * OUT_EXPO_CORRECTION * (-Math.pow(2, -10 * t / d) + 1) + b;\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key(sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    var dim = 1;\n    try {\n        key(1)[1].length;\n        dim = 2;\n        key(1)[2].length;\n        dim = 3;\n    } catch (e) {\n    }\n    t = sub(time, key1.time);\n    d = sub(key2.time, key1.time);\n    sX = key1[0];\n    eX = sub(key2[0], key1[0]);\n    if (dim >= 2) {\n        sY = key1[1];\n        eY = sub(key2[1], key1[1]);\n        if (dim >= 3) {\n            sZ = key1[2];\n            eZ = sub(key2[2], key1[2]);\n        }\n    }\n    if (time < key1.time || time > key2.time) {\n        return value;\n    } else {\n        val1 = easeandwizz_outExpo(t, sX, eX, d, a, p, s);\n        switch (dim) {\n        case 1:\n            return val1;\n            break;\n        case 2:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            return [\n                val1,\n                val2\n            ];\n            break;\n        case 3:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            val3 = easeandwizz_outExpo(t, sZ, eZ, d, a, p, s);\n            return [\n                val1,\n                val2,\n                val3\n            ];\n            break;\n        default:\n            return null;\n        }\n    }\n}\n$bm_rt = easeAndWizz() || value;" } }, "a": { "a": 0, "k": [0, 540, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 0, "s": [0, 13.3, 100], "e": [44.679, 13.3, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 60, "s": [44.679, 13.3, 100], "e": [44.679, 13.3, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"], "t": 240, "s": [44.679, 13.3, 100], "e": [0, 13.3, 100] }, { "t": 300 }], "x": "var $bm_rt;\nvar p = 0.81;\nvar a = 50;\nvar s = 1.70158;\nfunction easeandwizz_outExpo(t, b, c, d) {\n    var OUT_EXPO_CORRECTION = 1.000976;\n    return t == d ? b + c : c * OUT_EXPO_CORRECTION * (-Math.pow(2, -10 * t / d) + 1) + b;\n}\nfunction easeAndWizz() {\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1;\n    var n = 0;\n    if (numKeys > 0) {\n        n = nearestKey(time).index;\n        if (key(n).time > time) {\n            n--;\n        }\n    }\n    try {\n        var key1 = key(n);\n        var key2 = key(sum(n, 1));\n    } catch (e) {\n        return null;\n    }\n    var dim = 1;\n    try {\n        key(1)[1].length;\n        dim = 2;\n        key(1)[2].length;\n        dim = 3;\n    } catch (e) {\n    }\n    t = sub(time, key1.time);\n    d = sub(key2.time, key1.time);\n    sX = key1[0];\n    eX = sub(key2[0], key1[0]);\n    if (dim >= 2) {\n        sY = key1[1];\n        eY = sub(key2[1], key1[1]);\n        if (dim >= 3) {\n            sZ = key1[2];\n            eZ = sub(key2[2], key1[2]);\n        }\n    }\n    if (time < key1.time || time > key2.time) {\n        return value;\n    } else {\n        val1 = easeandwizz_outExpo(t, sX, eX, d, a, p, s);\n        switch (dim) {\n        case 1:\n            return val1;\n            break;\n        case 2:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            return [\n                val1,\n                val2\n            ];\n            break;\n        case 3:\n            val2 = easeandwizz_outExpo(t, sY, eY, d, a, p, s);\n            val3 = easeandwizz_outExpo(t, sZ, eZ, d, a, p, s);\n            return [\n                val1,\n                val2,\n                val3\n            ];\n            break;\n        default:\n            return null;\n        }\n    }\n}\n$bm_rt = easeAndWizz() || value;" } }, "ao": 0, "sw": 1920, "sh": 1080, "sc": "#f7f7f7", "ip": 0, "op": 288, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 1, "nm": "Background", "parent": 1, "tt": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": -90 }, "p": { "a": 0, "k": [-49.41, 0, 0] }, "a": { "a": 0, "k": [0, 540, 0] }, "s": { "a": 0, "k": [44.679, 13.3, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [0.9686275, 0.9686275, 0.9686275, 1], "x": "var $bm_rt;\n$bm_rt = thisComp.layer('PositionCtr').effect('Color2')('Color');" } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "sw": 1920, "sh": 1080, "sc": "#f7f7f7", "ip": 0, "op": 288, "st": 0, "bm": 0, "sr": 1 }] };

exports.default = v;

},{}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 0, "ty": 4, "nm": "FB-fLogo-printpackaging Outlines - Group 1", "parent": 1, "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [290.163, 266.155, 0] }, "a": { "k": [290.163, 266.155, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-16.724, 0], [0, 0], [0, 0], [14.73, 0], [0, -34.473], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -11.662], [0, 0], [0, 0], [-3.691, -0.49], [-30.753, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[17.542, 113.292], [17.542, 9.937], [52.234, 9.937], [57.428, -30.343], [17.542, -30.343], [17.542, -56.06], [37.504, -75.669], [58.835, -75.679], [58.835, -111.705], [27.753, -113.292], [-24.054, -60.048], [-24.054, -30.343], [-58.835, -30.343], [-58.835, 9.937], [-24.054, 9.937], [-24.054, 113.292]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [290.163, 266.155], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 5285, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "FB-fLogo-printpackaging Outlines - Group 2", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [500, 500, 0] }, "a": { "k": [257, 246, 0] }, "s": { "k": [191, 191, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [0, 8.135], [0, 0], [8.135, 0], [0, 0], [0, -8.137], [0, 0], [-8.138, 0]], "o": [[8.135, 0], [0, 0], [0, -8.137], [0, 0], [-8.138, 0], [0, 0], [0, 8.135], [0, 0]], "v": [[118.716, 133.447], [133.447, 118.717], [133.447, -118.717], [118.716, -133.447], [-118.715, -133.447], [-133.446, -118.717], [-133.446, 118.717], [-118.715, 133.447]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [0.23, 0.35, 0.6, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [257, 246], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 2", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 5285, "st": 0, "bm": 0, "sr": 1 }] }, { "id": "comp_1", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [501.176, 781.879, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_Spirals", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 4 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 52.052, "s": [100], "e": [0] }, { "t": 70.0700700700701 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 14.014, "s": [-19.43, -54.264, 0], "e": [28.161, -150.437, 0], "to": [10.1970882415771, -42.1346244812012, 0], "ti": [-18.2750129699707, 30.565881729126, 0] }, { "t": 72.0720720720721 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 14.014014014014, "op": 88.0880880880881, "st": 14.014014014014, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 48.048, "s": [100], "e": [0] }, { "t": 66.0660660660661 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 10.01, "s": [-29.786, -65.914, 0], "e": [-20.383, -184.094, 0], "to": [8.25534057617188, -28.5423908233643, 0], "ti": [5.67320537567139, 51.2778625488281, 0] }, { "t": 68.0680680680681 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 10.01001001001, "op": 84.0840840840841, "st": 10.01001001001, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "spiral", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 8.514 }, "p": { "k": [1.93, 0, 0] }, "a": { "k": [-163, 282.001, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-15.521, 30.106], [38.729, 8.171], [11.662, -9.327], [-1.857, -6.365], [-5.521, 0.175], [-5.906, 34.615], [36.372, 18.345], [-1.726, -0.87], [-0.692, -30.667], [31.468, -14.379], [8.082, -0.257], [3.174, 2.304], [-2.886, 3.122], [-13.78, -2.278], [-4.101, -7.718], [0.874, -8.006], [6.701, -13.346], [31.569, -11.609], [-1.818, 0.669]], "o": [[31.836, -11.707], [12.233, -23.728], [-14.198, -2.995], [-4.522, 3.616], [1.934, 6.629], [37.065, -1.177], [6.311, -36.99], [-1.72, -0.867], [29.289, 14.773], [0.75, 33.222], [-7.344, 3.356], [-3.743, 0.119], [-4.972, -3.609], [9.968, -10.781], [8.253, 1.364], [3.873, 7.288], [-1.623, 14.863], [-15.054, 29.983], [-1.797, 0.661], [0, 0]], "v": [[-163.312, 281.901], [-89.439, 216.071], [-98.856, 131.371], [-141.883, 139.329], [-151.294, 156.813], [-134.672, 163.408], [-64.405, 95.138], [-105.805, -11.703], [-107.319, -9.112], [-65.851, 73.425], [-111.259, 154.771], [-134.672, 160.408], [-146.373, 158.441], [-143.04, 144.444], [-101.891, 133.84], [-81.527, 146.363], [-78.532, 170.482], [-91.371, 213.264], [-164.109, 279.008], [-163.312, 281.901]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 18.018, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 0, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "spiral2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -22.696 }, "p": { "k": [-24.07, 0, 0] }, "a": { "k": [-72.797, 280.997, 0] }, "s": { "k": [27.474, 27.474, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-10.438, 51.085], [6.946, 26.74], [-11.077, 26.999], [-23.243, 17.516], [1.544, -1.163], [13.524, -20.417], [-4.513, -25.374], [-0.6, -28.238], [17.872, -21.395], [29.981, -3.225], [-1.92, 0.207]], "o": [[51.698, -5.561], [5.644, -27.621], [-7.025, -27.042], [11.393, -27.769], [1.523, -1.148], [-19.331, 14.568], [-14.47, 21.845], [4.899, 27.546], [0.592, 27.852], [-19.362, 23.179], [-1.9, 0.204], [0, 0]], "v": [[-72.173, 278.563], [33.089, 183.321], [25.559, 102.393], [22.673, 19.601], [82.571, -45.016], [81.057, -47.606], [28.376, 2.624], [16.051, 74.616], [32.511, 156.996], [5.495, 234.286], [-72.173, 275.563], [-72.173, 278.563]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 24.024, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 6.006, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 6.00600600600601, "op": 84.0840840840841, "st": 6.00600600600601, "bm": 0, "sr": 1 }] }, { "id": "comp_2", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [556.545, 845.149, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_CIRCLE", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 3 } }] }, { "ty": 5, "nm": "Stroke_LINE", "mn": "ADBE Slider Control", "ix": 2, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 10 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 5", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-27.463, -88.529, 0], "e": [-53.111, -238.909, 0], "to": [-16.6939601898193, -59.6268119812012, 0], "ti": [37.7835807800293, 60.3297958374023, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [25, 25, 100], "e": [75, 75, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 16.016016016016, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-49.256, -60.41, 0], "e": [-119.191, -193.214, 0], "to": [-3.33719229698181, -28.6953563690186, 0], "ti": [7.55511236190796, 85.6373519897461, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [55, 55, 100], "e": [100, 100, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 4.004004004004, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 44.044, "s": [100], "e": [0] }, { "t": 62.0620620620621 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 6.006, "s": [-0.801, -111.287, 0], "e": [88.861, -254.063, 0], "to": [14.9435815811157, -23.7958908081055, 0], "ti": [-14.9435815811157, 23.7958908081055, 0] }, { "t": 64.0640640640641 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 6.00600600600601, "op": 80.0800800800801, "st": 6.00600600600601, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "Line 3", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 52.835 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 2.002, "s": [55.743, -72.768, 0], "e": [116.509, -124.817, 0], "to": [10.1277112960815, -8.67486763000488, 0], "ti": [-10.1277112960815, 8.67486763000488, 0] }, { "t": 46.046046046046 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 10.01001001001 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 6.917, "s": [0], "e": [100] }, { "t": 34.9974974974975 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 48.0480480480481, "st": -4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Line 2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -54.372 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 0, "s": [-109.558, -67.678, 0], "e": [-181.558, -115.678, 0], "to": [-12, -8, 0], "ti": [12, 8, 0] }, { "t": 44.044044044044 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -6.006, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 2.002, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 8.00800800800801 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 4.915, "s": [0], "e": [100] }, { "t": 32.9954954954955 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 0, "op": 40.04004004004, "st": -6.00600600600601, "bm": 0, "sr": 1 }] }], "layers": [{ "ddd": 0, "ind": 0, "ty": 0, "nm": "Facebook_Logo_v001", "refId": "comp_0", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [{ "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p2_1_0p167_0p167", "t": 0.1, "s": [960, 540, 0], "e": [960, 500, 0], "to": [0, -6.66666650772095, 0], "ti": [0, 6.66666650772095, 0] }, { "t": 57.599609375 }] }, "a": { "k": [500, 500, 0] }, "s": { "k": [{ "i": { "x": [0.16, 0.16, 0.16], "y": [1, 1, 0.16] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p16_1_0p167_0p167", "0p16_1_0p167_0p167", "0p16_0p16_0p167_0p167"], "t": 0.1, "s": [25, 25, 100], "e": [30, 30, 100] }, { "t": 7.599609375 }] } }, "ao": 0, "w": 1000, "h": 1000, "ip": 0, "op": 132.6, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 0, "nm": "Accent_Pop_02", "refId": "comp_1", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 325, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0.23, 0.35, 0.6, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 0, "nm": "Accent_Pop_01", "refId": "comp_2", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 426, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0.23, 0.35, 0.6, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }], "v": "4.5.0", "ddd": 0, "ip": 0, "op": 73, "fr": 60, "w": 1920, "h": 1080 };

exports.default = v;

},{}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 0, "ty": 4, "nm": "Circle", "parent": 2, "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [418.738, 231.799, 0] }, "a": { "k": [85.168, -88.707, 0] }, "s": { "k": [105.263, 105.263, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [41, 41] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [85.168, -88.707], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 180, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "Lines", "parent": 2, "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [322.772, 326.754, 0] }, "a": { "k": [322.772, 326.754, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[43.542, 0], [0, 43.542], [-43.543, 0], [0, -43.543]], "o": [[-43.543, 0], [0, -43.543], [43.542, 0], [0, 43.542]], "v": [[322.772, 407.068], [243.931, 328.227], [322.772, 249.386], [401.613, 328.227]], "c": true } }, "nm": "Path 3", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 33 }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [322.772, 328.227], "ix": 2 }, "a": { "k": [322.772, 328.227], "ix": 1 }, "s": { "k": [97, 97], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 7", "np": 2, "mn": "ADBE Vector Group" }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[52.017, 0], [0, 0], [0, -52.017], [0, 0], [-52.017, 0], [0, 0], [0, 52.017], [0, 0]], "o": [[0, 0], [-52.017, 0], [0, 0], [0, 52.017], [0, 0], [52.017, 0], [0, 0], [0, -52.017]], "v": [[397.006, 165.101], [248.538, 165.101], [160.076, 255.735], [160.076, 399.598], [249.196, 490.494], [396.348, 490.494], [485.469, 399.598], [485.469, 256.393]], "c": true } }, "nm": "Path 3", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 33 }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [322.772, 327.337], "ix": 2 }, "a": { "k": [322.772, 327.337], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 6", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 180, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "instagram-new-2016-seeklogo.com Outlines 2", "cl": "com", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [500, 500, 0] }, "a": { "k": [322.772, 326.754, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [20.021, -20.022], [5.553, -12.425], [0, -16.063], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-8.161, -15.424], [-7.791, -7.79], [-30.552, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-20.023, 20.022], [-5.198, 9.823], [0, 18.664], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [6.156, 13.773], [9.495, 9.495], [30.552, 0]], "o": [[0, 0], [0, 0], [0, 0], [-30.552, 0], [-9.496, 9.495], [-6.156, 13.773], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 18.664], [5.199, 9.823], [20.021, 20.022], [0, 0], [0, 0], [0, 0], [0, 0], [30.552, 0], [7.79, -7.79], [8.162, -15.424], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -16.063], [-5.554, -12.425], [-20.023, -20.022], [0, 0]], "v": [[113.23, -243.785], [-1.455, -243.785], [-116.362, -243.785], [-133.146, -243.785], [-211.379, -211.379], [-234.206, -178.246], [-243.785, -133.145], [-243.785, -124.346], [-243.785, -59.654], [-243.785, 44.277], [-243.785, 117.453], [-243.785, 133.147], [-231.003, 184.819], [-211.379, 211.38], [-133.146, 243.785], [-116.362, 243.785], [-1.455, 243.785], [113.23, 243.785], [133.146, 243.785], [211.38, 211.38], [231.002, 184.819], [243.785, 133.147], [243.785, 117.453], [243.785, 44.277], [243.785, -59.654], [243.785, -124.346], [243.785, -133.145], [234.207, -178.246], [211.38, -211.379], [133.146, -243.785]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "gf", "o": { "k": 100 }, "g": { "p": 5, "k": { "k": [0, 0.216, 0.443, 0.784, 0.064, 0.216, 0.443, 0.784, 0.128, 0.216, 0.443, 0.784, 0.564, 0.308, 0.222, 0.892, 1, 0.4, 0, 1, 0, 1, 0.5, 0.5, 1, 0] } }, "s": { "k": [-243, -890] }, "e": { "k": [18, -49] }, "t": 2, "h": { "k": 73 }, "a": { "k": 12 }, "nm": "Gradient Fill 2", "mn": "ADBE Vector Graphic - G-Fill" }, { "ty": "gf", "o": { "k": 100 }, "g": { "p": 7, "k": { "k": [0, 1, 0.867, 0.333, 0.05, 1, 0.867, 0.333, 0.1, 1, 0.867, 0.333, 0.3, 1, 0.598, 0.288, 0.5, 1, 0.329, 0.243, 0.75, 0.892, 0.273, 0.457, 1, 0.784, 0.216, 0.671] } }, "s": { "k": [-135, 282] }, "e": { "k": [139, -77] }, "t": 2, "h": { "k": 0 }, "a": { "k": 0 }, "nm": "Gradient Fill 1", "mn": "ADBE Vector Graphic - G-Fill" }, { "ty": "tr", "p": { "k": [324.772, 326.754], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 4", "np": 3, "mn": "ADBE Vector Group" }], "ip": 0, "op": 180, "st": 0, "bm": 0, "sr": 1 }] }, { "id": "comp_1", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [501.176, 781.879, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_Spirals", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 4 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 52.052, "s": [100], "e": [0] }, { "t": 70.0700700700701 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 14.014, "s": [-19.43, -54.264, 0], "e": [28.161, -150.437, 0], "to": [10.1970882415771, -42.1346244812012, 0], "ti": [-18.2750129699707, 30.565881729126, 0] }, { "t": 72.0720720720721 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 14.014014014014, "op": 88.0880880880881, "st": 14.014014014014, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 48.048, "s": [100], "e": [0] }, { "t": 66.0660660660661 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 10.01, "s": [-29.786, -65.914, 0], "e": [-20.383, -184.094, 0], "to": [8.25534057617188, -28.5423908233643, 0], "ti": [5.67320537567139, 51.2778625488281, 0] }, { "t": 68.0680680680681 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 10.01001001001, "op": 84.0840840840841, "st": 10.01001001001, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "spiral", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 8.514 }, "p": { "k": [1.93, 0, 0] }, "a": { "k": [-163, 282.001, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-15.521, 30.106], [38.729, 8.171], [11.662, -9.327], [-1.857, -6.365], [-5.521, 0.175], [-5.906, 34.615], [36.372, 18.345], [-1.726, -0.87], [-0.692, -30.667], [31.468, -14.379], [8.082, -0.257], [3.174, 2.304], [-2.886, 3.122], [-13.78, -2.278], [-4.101, -7.718], [0.874, -8.006], [6.701, -13.346], [31.569, -11.609], [-1.818, 0.669]], "o": [[31.836, -11.707], [12.233, -23.728], [-14.198, -2.995], [-4.522, 3.616], [1.934, 6.629], [37.065, -1.177], [6.311, -36.99], [-1.72, -0.867], [29.289, 14.773], [0.75, 33.222], [-7.344, 3.356], [-3.743, 0.119], [-4.972, -3.609], [9.968, -10.781], [8.253, 1.364], [3.873, 7.288], [-1.623, 14.863], [-15.054, 29.983], [-1.797, 0.661], [0, 0]], "v": [[-163.312, 281.901], [-89.439, 216.071], [-98.856, 131.371], [-141.883, 139.329], [-151.294, 156.813], [-134.672, 163.408], [-64.405, 95.138], [-105.805, -11.703], [-107.319, -9.112], [-65.851, 73.425], [-111.259, 154.771], [-134.672, 160.408], [-146.373, 158.441], [-143.04, 144.444], [-101.891, 133.84], [-81.527, 146.363], [-78.532, 170.482], [-91.371, 213.264], [-164.109, 279.008], [-163.312, 281.901]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 18.018, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 0, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "spiral2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -22.696 }, "p": { "k": [-24.07, 0, 0] }, "a": { "k": [-72.797, 280.997, 0] }, "s": { "k": [27.474, 27.474, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-10.438, 51.085], [6.946, 26.74], [-11.077, 26.999], [-23.243, 17.516], [1.544, -1.163], [13.524, -20.417], [-4.513, -25.374], [-0.6, -28.238], [17.872, -21.395], [29.981, -3.225], [-1.92, 0.207]], "o": [[51.698, -5.561], [5.644, -27.621], [-7.025, -27.042], [11.393, -27.769], [1.523, -1.148], [-19.331, 14.568], [-14.47, 21.845], [4.899, 27.546], [0.592, 27.852], [-19.362, 23.179], [-1.9, 0.204], [0, 0]], "v": [[-72.173, 278.563], [33.089, 183.321], [25.559, 102.393], [22.673, 19.601], [82.571, -45.016], [81.057, -47.606], [28.376, 2.624], [16.051, 74.616], [32.511, 156.996], [5.495, 234.286], [-72.173, 275.563], [-72.173, 278.563]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 24.024, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 6.006, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 6.00600600600601, "op": 84.0840840840841, "st": 6.00600600600601, "bm": 0, "sr": 1 }] }, { "id": "comp_2", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [556.545, 845.149, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_CIRCLE", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 3 } }] }, { "ty": 5, "nm": "Stroke_LINE", "mn": "ADBE Slider Control", "ix": 2, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 10 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 5", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-27.463, -88.529, 0], "e": [-53.111, -238.909, 0], "to": [-16.6939601898193, -59.6268119812012, 0], "ti": [37.7835807800293, 60.3297958374023, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [25, 25, 100], "e": [75, 75, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 16.016016016016, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-49.256, -60.41, 0], "e": [-119.191, -193.214, 0], "to": [-3.33719229698181, -28.6953563690186, 0], "ti": [7.55511236190796, 85.6373519897461, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [55, 55, 100], "e": [100, 100, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 4.004004004004, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 44.044, "s": [100], "e": [0] }, { "t": 62.0620620620621 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 6.006, "s": [-0.801, -111.287, 0], "e": [88.861, -254.063, 0], "to": [14.9435815811157, -23.7958908081055, 0], "ti": [-14.9435815811157, 23.7958908081055, 0] }, { "t": 64.0640640640641 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 6.00600600600601, "op": 80.0800800800801, "st": 6.00600600600601, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "Line 3", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 52.835 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 2.002, "s": [55.743, -72.768, 0], "e": [116.509, -124.817, 0], "to": [10.1277112960815, -8.67486763000488, 0], "ti": [-10.1277112960815, 8.67486763000488, 0] }, { "t": 46.046046046046 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 10.01001001001 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 6.917, "s": [0], "e": [100] }, { "t": 34.9974974974975 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 48.0480480480481, "st": -4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Line 2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -54.372 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 0, "s": [-109.558, -67.678, 0], "e": [-181.558, -115.678, 0], "to": [-12, -8, 0], "ti": [12, 8, 0] }, { "t": 44.044044044044 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -6.006, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 2.002, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 8.00800800800801 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 4.915, "s": [0], "e": [100] }, { "t": 32.9954954954955 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 0, "op": 40.04004004004, "st": -6.00600600600601, "bm": 0, "sr": 1 }] }], "layers": [{ "ddd": 0, "ind": 0, "ty": 0, "nm": "Instagram_Logo_v001", "refId": "comp_0", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [{ "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p2_1_0p167_0p167", "t": 0.1, "s": [960, 540, 0], "e": [960, 500, 0], "to": [0, -6.66666650772095, 0], "ti": [0, 6.66666650772095, 0] }, { "t": 57.599609375 }] }, "a": { "k": [500, 500, 0] }, "s": { "k": [{ "i": { "x": [0.16, 0.16, 0.16], "y": [1, 1, 0.16] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p16_1_0p167_0p167", "0p16_1_0p167_0p167", "0p16_0p16_0p167_0p167"], "t": 0.1, "s": [25, 25, 100], "e": [30, 30, 100] }, { "t": 7.599609375 }] } }, "ao": 0, "w": 1000, "h": 1000, "ip": 0, "op": 132.6, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 0, "nm": "Accent_Pop_02", "refId": "comp_1", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 325, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0.74, 0.16, 0.55, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 0, "nm": "Accent_Pop_01", "refId": "comp_2", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 426, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0.95, 0.55, 0.06, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }], "v": "4.5.0", "ddd": 0, "ip": 0, "op": 73, "fr": 60, "w": 1920, "h": 1080 };

exports.default = v;

},{}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "assets": [{ "id": "comp_3", "layers": [{ "ddd": 0, "ind": 0, "ty": 4, "nm": "snap-ghost-yellow Outlines - Group 1", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [499.484, 500.623, 0] }, "a": { "k": [215.587, 216.998, 0] }, "s": { "k": [125, 125, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [0, 0], [0.249, -0.005], [0, 0], [0.412, 0], [21.316, -47.792], [-1.378, -21.943], [-0.148, -2.595], [3.17, 0], [5.63, 2.639], [1.904, 0], [1.228, -6.466], [-14.968, -5.912], [-1.715, -0.542], [-2.537, -5.975], [2.344, -4.758], [0.046, -0.111], [43.919, -7.23], [-0.187, -3.417], [-0.416, -0.982], [-25.317, -3.929], [-0.539, -2.464], [-0.778, -2.644], [-5.096, 0], [-2.811, 0.552], [-7.23, 0], [-4.185, -0.694], [-8.037, -5.681], [-19.815, 0], [-0.541, 0.04], [-0.888, 0], [-11.503, 8.135], [-8.169, 1.358], [-4.011, 0], [-4.868, -0.951], [-1.793, 0], [0, 0], [0, 0], [-1.054, 3.609], [-0.541, 2.472], [-0.843, 1.137], [-3.289, 7.673], [-0.058, 1.025], [3.375, 0.555], [0.821, 1.912], [0.054, 0.106], [-1.312, 3.095], [-6.184, 1.96], [-1.337, 0.527], [0.116, 6.152], [5.982, 2.137], [0, 0], [2.339, 0], [2.216, -1.036], [4.037, -0.181], [0.999, 0.55], [-0.151, 2.395], [0, 0], [7.176, 16.089], [13.369, 0]], "o": [[0, 0], [-0.279, 0], [0, 0], [0, 0], [-13.331, 0], [-7.169, 16.078], [0.162, 2.588], [-1.103, 0.611], [-4.231, 0], [-1.495, -0.7], [-6.594, 0], [-0.886, 4.656], [1.351, 0.534], [6.183, 1.964], [1.313, 3.095], [-0.051, 0.108], [-0.823, 1.914], [-3.377, 0.557], [0.058, 1.016], [3.296, 7.706], [0.846, 1.145], [0.529, 2.43], [0.763, 2.599], [2.058, 0], [4.218, -0.824], [4.01, 0], [8.169, 1.361], [11.511, 8.139], [0.544, 0], [0.643, 0.028], [19.821, 0], [8.055, -5.689], [4.178, -0.694], [6.898, 0], [3.05, 0.597], [0, 0], [0, 0], [3.764, 0], [0.763, -2.59], [0.536, -2.456], [25.324, -3.932], [0.423, -0.982], [0.19, -3.419], [-43.94, -7.242], [-0.047, -0.11], [-2.346, -4.757], [2.535, -5.975], [1.73, -0.549], [10.954, -4.326], [-0.095, -4.832], [0, 0], [-2.012, -0.835], [-1.599, 0], [-5.21, 2.442], [-2.677, -0.125], [0.127, -2.227], [0, 0], [1.386, -21.958], [-21.325, -47.813], [0, 0]], "v": [[3.125, -151.874], [3.112, -151.874], [2.322, -151.868], [2.322, -151.868], [-3.27, -151.817], [-83.099, -100.312], [-87.171, -34.984], [-86.688, -27.115], [-92.975, -25.744], [-107.837, -29.719], [-112.959, -30.769], [-128.668, -19.965], [-112.502, -2.604], [-107.812, -1.015], [-89.745, 9.89], [-91.3, 21.727], [-91.449, 22.053], [-155.974, 76.292], [-161.577, 83.279], [-160.862, 86.289], [-118.342, 103.571], [-116.078, 111.222], [-114.225, 118.802], [-106.384, 124.508], [-99.086, 123.481], [-81.862, 121.529], [-69.511, 122.571], [-46.363, 134.52], [-2.001, 151.874], [-0.368, 151.817], [1.998, 151.874], [46.356, 134.523], [69.517, 122.571], [81.862, 121.529], [99.087, 123.357], [106.385, 124.258], [106.573, 124.261], [106.754, 124.261], [114.228, 118.663], [116.079, 111.16], [118.335, 103.542], [160.85, 86.299], [161.575, 83.272], [155.975, 76.289], [91.449, 22.049], [91.297, 21.723], [89.745, 9.89], [107.807, -1.011], [112.5, -2.604], [128.833, -18.396], [118.993, -29.676], [118.975, -29.682], [112.236, -30.973], [106.048, -29.719], [92.118, -25.769], [86.691, -27.119], [87.111, -34.033], [87.167, -34.964], [83.096, -100.342], [3.125, -151.874]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ind": 1, "ty": "sh", "ks": { "k": { "i": [[-0.257, 0], [-19.758, -44.295], [1.339, -21.228], [0.167, -3.121], [0, 0], [0, 0], [-7.519, -0.292], [0, 0], [0, 0], [-6.086, 2.852], [-1.261, 0], [-1.26, -0.531], [0, 0], [-0.038, -1.904], [11.306, -4.465], [1.685, -0.532], [3.742, -8.811], [-3.246, -6.587], [-47.264, -7.787], [0.128, -0.289], [31.679, -4.89], [1.41, -6.463], [0.711, -2.415], [0.785, 0], [0.141, 0], [0, 0], [2.473, 0.484], [7.861, 0], [4.533, -0.752], [8.353, -5.9], [17.686, 0], [0.756, 0.036], [0, 0], [0, 0], [0.448, 0], [11.21, 7.926], [9.692, 1.614], [4.388, 0], [4.493, -0.879], [1.402, 0], [0.242, 0.828], [0.504, 2.308], [4.953, 0.764], [0.804, 1.883], [0.011, 0.222], [-1.337, 3.125], [2.11, 4.97], [7.358, 2.339], [1.105, 0.438], [-0.439, 2.304], [-4.016, 0], [-0.586, -0.276], [-5.22, 0], [-0.388, 0.433], [0, 0], [0, 0], [0.213, 3.364], [-6.504, 14.585], [-12.317, 0], [0, 0]], "o": [[12.173, 0.002], [6.503, 14.582], [-0.212, 3.366], [0, 0], [0, 0], [0.358, 0.403], [0, 0], [0, 0], [4.971, -0.187], [0.893, -0.42], [1.44, 0], [0, 0], [3.188, 1.117], [0.019, 1.083], [-1.104, 0.438], [-7.357, 2.339], [-2.108, 4.973], [1.337, 3.116], [-0.013, 0.219], [-0.803, 1.887], [-4.959, 0.765], [-0.503, 2.31], [-0.215, 0.73], [-0.107, 0], [0, 0], [-1.405, 0], [-4.49, -0.878], [-4.387, 0], [-9.694, 1.614], [-11.212, 7.929], [-0.767, 0], [0, 0], [0, 0], [-0.434, 0.036], [-17.682, 0], [-8.35, -5.903], [-4.535, -0.752], [-7.859, 0], [-2.472, 0.486], [-1.146, 0], [-0.71, -2.417], [-1.411, -6.462], [-31.682, -4.892], [-0.128, -0.292], [47.26, -7.787], [3.246, -6.59], [-3.739, -8.814], [-1.686, -0.53], [-9.552, -3.772], [0.506, -2.656], [0.904, 0], [6.525, 3.053], [8.216, 0], [0, 0], [0, 0], [-0.167, -3.115], [-1.337, -21.228], [19.681, -44.132], [0.304, 0], [0.23, -0.003]], "v": [[3.125, -145.174], [76.979, -97.611], [80.48, -35.38], [79.896, -25.631], [79.823, -24.293], [80.72, -23.296], [91.981, -19.068], [92.107, -19.065], [92.23, -19.068], [108.889, -23.649], [112.236, -24.272], [116.461, -23.472], [116.651, -23.396], [122.133, -18.265], [110.036, -8.837], [105.79, -7.406], [83.576, 7.267], [85.288, 24.686], [154.885, 82.9], [154.691, 83.657], [117.117, 96.949], [109.532, 109.729], [107.796, 116.785], [106.754, 117.558], [106.385, 117.558], [106.385, 117.558], [100.371, 116.782], [81.862, 114.828], [68.419, 115.962], [42.484, 129.053], [1.997, 145.174], [-0.282, 145.113], [-0.481, 145.104], [-0.682, 145.121], [-2.001, 145.174], [-42.487, 129.057], [-68.419, 115.962], [-81.862, 114.828], [-100.371, 116.904], [-106.384, 117.805], [-107.796, 116.911], [-109.531, 109.794], [-117.117, 96.98], [-154.692, 83.675], [-154.884, 82.906], [-85.29, 24.689], [-83.577, 7.274], [-105.79, -7.406], [-110.037, -8.837], [-122.085, -18.713], [-112.959, -24.068], [-110.68, -23.649], [-92.975, -19.042], [-80.714, -23.298], [-79.823, -24.293], [-79.896, -25.627], [-80.481, -35.367], [-76.978, -97.584], [-3.26, -145.116], [2.397, -145.169]], "c": true } }, "nm": "Path 2", "mn": "ADBE Vector Shape - Group" }, { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [0.03, 0.03, 0.03, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [215.588, 216.998], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 4, "mn": "ADBE Vector Group" }], "ip": 0, "op": 600, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "snap-ghost-yellow Outlines - Group 2", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [499.486, 500.622, 0] }, "a": { "k": [215.589, 216.998, 0] }, "s": { "k": [125, 125, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[18.754, 0], [0.801, 0.038], [0, 0], [0.534, 0], [11.636, 8.227], [8.934, 1.488], [4.194, 0], [4.351, -0.851], [1.733, 0], [0.852, 2.914], [0.515, 2.365], [2.551, 0.392], [1.898, 4.444], [0.037, 0.63], [-1.687, 0.275], [-0.851, 1.984], [-0.025, 0.055], [1.712, 4.034], [6.772, 2.148], [1.239, 0.49], [-0.531, 2.795], [-5.147, 0], [-1.045, -0.488], [-4.727, 0], [-0.349, 0.36], [0.211, 3.334], [-6.837, 15.328], [-12.83, 0], [0, 0], [0, 0], [-20.503, -45.972], [1.363, -21.595], [0, 0], [0.153, -2.798], [-5.922, -0.227], [0, 0], [-5.676, 2.659], [-1.258, 0], [-1.617, -0.675], [0, 0], [-0.064, -3.362], [11.858, -4.684], [1.663, -0.528], [3.135, -7.392], [-2.797, -5.673], [-0.021, -0.058], [-45.732, -7.536], [0.093, -1.708], [0.273, -0.627], [29.746, -4.596], [1.45, -6.64], [0.735, -2.497], [2.271, 0], [0, 0], [2.84, 0.558], [7.184, 0], [4.362, -0.722], [8.02, -5.669]], "o": [[-0.815, 0], [0, 0], [-0.51, 0.039], [-18.748, 0], [-8.035, -5.678], [-4.359, -0.722], [-7.554, 0], [-2.644, 0.517], [-1.811, 0], [-0.742, -2.525], [-1.329, -6.088], [-29.736, -4.593], [-0.269, -0.635], [-0.096, -1.707], [45.711, -7.528], [0.023, -0.055], [2.798, -5.669], [-3.137, -7.393], [-1.657, -0.524], [-13.514, -5.342], [0.906, -4.762], [1.411, 0], [6.079, 2.848], [6.532, 0], [-0.166, -3.094], [-1.361, -21.612], [20.492, -45.947], [0.329, 0], [0, 0], [12.86, 0], [6.839, 15.336], [0, 0], [-0.189, 3.007], [0.327, 0.333], [0, 0], [4.5, -0.172], [1.664, -0.777], [1.921, 0], [0, 0], [4.591, 1.627], [0.06, 3.167], [-1.229, 0.483], [-6.78, 2.151], [-1.714, 4.032], [0.025, 0.055], [0.851, 1.982], [1.688, 0.279], [-0.038, 0.641], [-1.887, 4.412], [-2.43, 0.373], [-0.527, 2.417], [-0.634, 2.166], [0, 0], [-1.575, 0], [-5.036, -0.985], [-4.195, 0], [-8.924, 1.488], [-11.66, 8.246]], "v": [[1.998, 148.524], [-0.42, 148.463], [-0.422, 148.463], [-2.001, 148.524], [-44.419, 131.791], [-68.97, 119.266], [-81.862, 118.178], [-99.726, 120.195], [-106.384, 121.157], [-111.01, 117.851], [-112.803, 110.516], [-117.627, 100.293], [-157.771, 84.993], [-158.229, 83.091], [-155.429, 79.601], [-88.369, 23.37], [-88.296, 23.207], [-86.662, 8.582], [-106.802, -4.208], [-111.269, -5.718], [-125.376, -19.339], [-112.959, -27.42], [-109.26, -26.682], [-92.975, -22.391], [-83.243, -25.496], [-83.826, -35.155], [-80.037, -98.948], [-3.26, -148.464], [2.365, -148.52], [3.125, -148.524], [80.038, -98.976], [83.822, -35.168], [83.765, -34.229], [83.241, -25.501], [92.112, -22.416], [92.119, -22.416], [107.467, -26.682], [112.236, -27.623], [117.721, -26.576], [117.819, -26.536], [125.482, -18.329], [111.267, -5.718], [106.804, -4.208], [86.662, 8.581], [88.294, 23.204], [88.368, 23.37], [155.431, 79.594], [158.232, 83.087], [157.765, 85], [117.628, 100.263], [112.806, 110.443], [111.01, 117.73], [106.755, 120.91], [106.385, 120.91], [99.729, 120.07], [81.863, 118.178], [68.965, 119.266], [44.444, 131.772]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [215.588, 216.998], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 2", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 600, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "snap-ghost-yellow Outlines - Group 3", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [500, 500.623, 0] }, "a": { "k": [216, 216.998, 0] }, "s": { "k": [125, 125, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [0, -38.023], [0, 0], [38.011, 0], [0, 0], [0, 38.013], [0, 0], [-38.016, 0]], "o": [[38.011, 0], [0, 0], [0, 38.013], [0, 0], [-38.016, 0], [0, 0], [0, -38.023], [0, 0]], "v": [[147.166, -216.002], [216, -147.159], [216, 147.166], [147.166, 216.002], [-147.161, 216.002], [-216, 147.166], [-216, -147.159], [-147.161, -216.002]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 0.99, 0, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [216, 216.998], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 3", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 600, "st": 0, "bm": 0, "sr": 1 }] }, { "id": "comp_4", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [501.176, 781.879, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_Spirals", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 4 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 52.052, "s": [100], "e": [0] }, { "t": 70.0700700700701 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 14.014, "s": [-19.43, -54.264, 0], "e": [28.161, -150.437, 0], "to": [10.1970882415771, -42.1346244812012, 0], "ti": [-18.2750129699707, 30.565881729126, 0] }, { "t": 72.0720720720721 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 14.014014014014, "op": 88.0880880880881, "st": 14.014014014014, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 48.048, "s": [100], "e": [0] }, { "t": 66.0660660660661 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 10.01, "s": [-29.786, -65.914, 0], "e": [-20.383, -184.094, 0], "to": [8.25534057617188, -28.5423908233643, 0], "ti": [5.67320537567139, 51.2778625488281, 0] }, { "t": 68.0680680680681 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 10.01001001001, "op": 84.0840840840841, "st": 10.01001001001, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "spiral", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 8.514 }, "p": { "k": [1.93, 0, 0] }, "a": { "k": [-163, 282.001, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-15.521, 30.106], [38.729, 8.171], [11.662, -9.327], [-1.857, -6.365], [-5.521, 0.175], [-5.906, 34.615], [36.372, 18.345], [-1.726, -0.87], [-0.692, -30.667], [31.468, -14.379], [8.082, -0.257], [3.174, 2.304], [-2.886, 3.122], [-13.78, -2.278], [-4.101, -7.718], [0.874, -8.006], [6.701, -13.346], [31.569, -11.609], [-1.818, 0.669]], "o": [[31.836, -11.707], [12.233, -23.728], [-14.198, -2.995], [-4.522, 3.616], [1.934, 6.629], [37.065, -1.177], [6.311, -36.99], [-1.72, -0.867], [29.289, 14.773], [0.75, 33.222], [-7.344, 3.356], [-3.743, 0.119], [-4.972, -3.609], [9.968, -10.781], [8.253, 1.364], [3.873, 7.288], [-1.623, 14.863], [-15.054, 29.983], [-1.797, 0.661], [0, 0]], "v": [[-163.312, 281.901], [-89.439, 216.071], [-98.856, 131.371], [-141.883, 139.329], [-151.294, 156.813], [-134.672, 163.408], [-64.405, 95.138], [-105.805, -11.703], [-107.319, -9.112], [-65.851, 73.425], [-111.259, 154.771], [-134.672, 160.408], [-146.373, 158.441], [-143.04, 144.444], [-101.891, 133.84], [-81.527, 146.363], [-78.532, 170.482], [-91.371, 213.264], [-164.109, 279.008], [-163.312, 281.901]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 18.018, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 0, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "spiral2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -22.696 }, "p": { "k": [-24.07, 0, 0] }, "a": { "k": [-72.797, 280.997, 0] }, "s": { "k": [27.474, 27.474, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-10.438, 51.085], [6.946, 26.74], [-11.077, 26.999], [-23.243, 17.516], [1.544, -1.163], [13.524, -20.417], [-4.513, -25.374], [-0.6, -28.238], [17.872, -21.395], [29.981, -3.225], [-1.92, 0.207]], "o": [[51.698, -5.561], [5.644, -27.621], [-7.025, -27.042], [11.393, -27.769], [1.523, -1.148], [-19.331, 14.568], [-14.47, 21.845], [4.899, 27.546], [0.592, 27.852], [-19.362, 23.179], [-1.9, 0.204], [0, 0]], "v": [[-72.173, 278.563], [33.089, 183.321], [25.559, 102.393], [22.673, 19.601], [82.571, -45.016], [81.057, -47.606], [28.376, 2.624], [16.051, 74.616], [32.511, 156.996], [5.495, 234.286], [-72.173, 275.563], [-72.173, 278.563]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 24.024, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 6.006, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 6.00600600600601, "op": 84.0840840840841, "st": 6.00600600600601, "bm": 0, "sr": 1 }] }, { "id": "comp_5", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [556.545, 845.149, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_CIRCLE", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 3 } }] }, { "ty": 5, "nm": "Stroke_LINE", "mn": "ADBE Slider Control", "ix": 2, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 10 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 5", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-27.463, -88.529, 0], "e": [-53.111, -238.909, 0], "to": [-16.6939601898193, -59.6268119812012, 0], "ti": [37.7835807800293, 60.3297958374023, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [25, 25, 100], "e": [75, 75, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 16.016016016016, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-49.256, -60.41, 0], "e": [-119.191, -193.214, 0], "to": [-3.33719229698181, -28.6953563690186, 0], "ti": [7.55511236190796, 85.6373519897461, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [55, 55, 100], "e": [100, 100, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 4.004004004004, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 44.044, "s": [100], "e": [0] }, { "t": 62.0620620620621 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 6.006, "s": [-0.801, -111.287, 0], "e": [88.861, -254.063, 0], "to": [14.9435815811157, -23.7958908081055, 0], "ti": [-14.9435815811157, 23.7958908081055, 0] }, { "t": 64.0640640640641 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 6.00600600600601, "op": 80.0800800800801, "st": 6.00600600600601, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "Line 3", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 52.835 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 2.002, "s": [55.743, -72.768, 0], "e": [116.509, -124.817, 0], "to": [10.1277112960815, -8.67486763000488, 0], "ti": [-10.1277112960815, 8.67486763000488, 0] }, { "t": 46.046046046046 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 10.01001001001 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 6.917, "s": [0], "e": [100] }, { "t": 34.9974974974975 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 48.0480480480481, "st": -4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Line 2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -54.372 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 0, "s": [-109.558, -67.678, 0], "e": [-181.558, -115.678, 0], "to": [-12, -8, 0], "ti": [12, 8, 0] }, { "t": 44.044044044044 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -6.006, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 2.002, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 8.00800800800801 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 4.915, "s": [0], "e": [100] }, { "t": 32.9954954954955 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 0, "op": 40.04004004004, "st": -6.00600600600601, "bm": 0, "sr": 1 }] }], "layers": [{ "ddd": 0, "ind": 0, "ty": 0, "nm": "Snapchat_Logo_v001", "refId": "comp_3", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [{ "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p2_1_0p167_0p167", "t": 0.1, "s": [960, 540, 0], "e": [960, 500, 0], "to": [0, -6.66666650772095, 0], "ti": [0, 6.66666650772095, 0] }, { "t": 57.599609375 }] }, "a": { "k": [500, 500, 0] }, "s": { "k": [{ "i": { "x": [0.16, 0.16, 0.16], "y": [1, 1, 0.16] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p16_1_0p167_0p167", "0p16_1_0p167_0p167", "0p16_0p16_0p167_0p167"], "t": 0.1, "s": [25, 25, 100], "e": [30, 30, 100] }, { "t": 7.599609375 }] } }, "ao": 0, "w": 1000, "h": 1000, "ip": 0, "op": 132.6, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 0, "nm": "Accent_Pop_02", "refId": "comp_4", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 325, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0, 0, 0, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 0, "nm": "Accent_Pop_01", "refId": "comp_5", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 426, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0, 0, 0, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }], "v": "4.5.0", "ddd": 0, "ip": 0, "op": 73, "fr": 60, "w": 1920, "h": 1080 };

exports.default = v;

},{}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 0, "ty": 4, "nm": "Twitter_Logo_Blue Outlines", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [500, 500, 0] }, "a": { "k": [200, 200, 0] }, "s": { "k": [257, 257, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[-28.97, 0], [0, 67.775], [0.102, 2.199], [-6.868, 10.285], [10.375, -1.24], [-3.834, 11.976], [11.683, -2.301], [14.75, 0], [0, -28.317], [-0.879, -3.756], [25.295, 31.035], [0, -9.393], [-13.769, -9.19], [6.913, 3.846], [0, -0.225], [-23.467, -4.703], [4.68, 0], [3.124, 0.598], [-22.452, -0.418], [24.032, 0], [4.015, 0.474]], "o": [[94.344, 0], [0, -2.221], [10.014, -7.239], [-9.191, 4.082], [10.59, -6.348], [-9.912, 5.875], [-9.359, -9.969], [-28.328, 0], [0, 4.026], [-42.627, -2.143], [-4.409, 7.578], [0, 17.796], [-8.412, -0.259], [-0.011, 0.214], [0, 24.844], [-4.307, 1.172], [-3.304, 0], [6.53, 20.378], [-17.558, 13.757], [-4.139, 0], [22.701, 14.547]], "v": [[-46.377, 101.589], [99.559, -44.347], [99.412, -50.978], [125, -77.535], [95.544, -69.461], [118.098, -97.833], [85.53, -85.384], [48.091, -101.589], [-3.208, -50.301], [-1.878, -38.606], [-107.6, -92.195], [-114.546, -66.416], [-91.722, -23.721], [-114.952, -30.138], [-114.964, -29.484], [-73.814, 20.801], [-87.335, 22.605], [-96.977, 21.68], [-49.061, 57.305], [-112.765, 79.26], [-125, 78.55]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [0.11, 0.63, 0.95, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [200, 200], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "mn": "ADBE Vector Group" }], "ip": 0, "op": 600, "st": 0, "bm": 0, "sr": 1 }] }, { "id": "comp_1", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [501.176, 781.879, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_Spirals", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 4 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 52.052, "s": [100], "e": [0] }, { "t": 70.0700700700701 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 14.014, "s": [-19.43, -54.264, 0], "e": [28.161, -150.437, 0], "to": [10.1970882415771, -42.1346244812012, 0], "ti": [-18.2750129699707, 30.565881729126, 0] }, { "t": 72.0720720720721 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 14.014014014014, "op": 88.0880880880881, "st": 14.014014014014, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 48.048, "s": [100], "e": [0] }, { "t": 66.0660660660661 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 10.01, "s": [-29.786, -65.914, 0], "e": [-20.383, -184.094, 0], "to": [8.25534057617188, -28.5423908233643, 0], "ti": [5.67320537567139, 51.2778625488281, 0] }, { "t": 68.0680680680681 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 10.01001001001, "op": 84.0840840840841, "st": 10.01001001001, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "spiral", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 8.514 }, "p": { "k": [1.93, 0, 0] }, "a": { "k": [-163, 282.001, 0] }, "s": { "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-15.521, 30.106], [38.729, 8.171], [11.662, -9.327], [-1.857, -6.365], [-5.521, 0.175], [-5.906, 34.615], [36.372, 18.345], [-1.726, -0.87], [-0.692, -30.667], [31.468, -14.379], [8.082, -0.257], [3.174, 2.304], [-2.886, 3.122], [-13.78, -2.278], [-4.101, -7.718], [0.874, -8.006], [6.701, -13.346], [31.569, -11.609], [-1.818, 0.669]], "o": [[31.836, -11.707], [12.233, -23.728], [-14.198, -2.995], [-4.522, 3.616], [1.934, 6.629], [37.065, -1.177], [6.311, -36.99], [-1.72, -0.867], [29.289, 14.773], [0.75, 33.222], [-7.344, 3.356], [-3.743, 0.119], [-4.972, -3.609], [9.968, -10.781], [8.253, 1.364], [3.873, 7.288], [-1.623, 14.863], [-15.054, 29.983], [-1.797, 0.661], [0, 0]], "v": [[-163.312, 281.901], [-89.439, 216.071], [-98.856, 131.371], [-141.883, 139.329], [-151.294, 156.813], [-134.672, 163.408], [-64.405, 95.138], [-105.805, -11.703], [-107.319, -9.112], [-65.851, 73.425], [-111.259, 154.771], [-134.672, 160.408], [-146.373, 158.441], [-143.04, 144.444], [-101.891, 133.84], [-81.527, 146.363], [-78.532, 170.482], [-91.371, 213.264], [-164.109, 279.008], [-163.312, 281.901]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 18.018, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 0, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "spiral2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -22.696 }, "p": { "k": [-24.07, 0, 0] }, "a": { "k": [-72.797, 280.997, 0] }, "s": { "k": [27.474, 27.474, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": { "i": [[0, 0], [-10.438, 51.085], [6.946, 26.74], [-11.077, 26.999], [-23.243, 17.516], [1.544, -1.163], [13.524, -20.417], [-4.513, -25.374], [-0.6, -28.238], [17.872, -21.395], [29.981, -3.225], [-1.92, 0.207]], "o": [[51.698, -5.561], [5.644, -27.621], [-7.025, -27.042], [11.393, -27.769], [1.523, -1.148], [-19.331, 14.568], [-14.47, 21.845], [4.899, 27.546], [0.592, 27.852], [-19.362, 23.179], [-1.9, 0.204], [0, 0]], "v": [[-72.173, 278.563], [33.089, 183.321], [25.559, 102.393], [22.673, 19.601], [82.571, -45.016], [81.057, -47.606], [28.376, 2.624], [16.051, 74.616], [32.511, 156.996], [5.495, 234.286], [-72.173, 275.563], [-72.173, 278.563]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 24.024, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 1 }, "e": { "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 6.006, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 6.00600600600601, "op": 84.0840840840841, "st": 6.00600600600601, "bm": 0, "sr": 1 }] }, { "id": "comp_2", "layers": [{ "ddd": 0, "ind": 0, "ty": 3, "nm": "CONTROL", "ks": { "o": { "k": 0 }, "r": { "k": 0 }, "p": { "k": [556.545, 845.149, 0] }, "a": { "k": [0, 0, 0] }, "s": { "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_CIRCLE", "mn": "ADBE Slider Control", "ix": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 3 } }] }, { "ty": 5, "nm": "Stroke_LINE", "mn": "ADBE Slider Control", "ix": 2, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "k": 10 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 4, "nm": "circle 5", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-27.463, -88.529, 0], "e": [-53.111, -238.909, 0], "to": [-16.6939601898193, -59.6268119812012, 0], "ti": [37.7835807800293, 60.3297958374023, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [25, 25, 100], "e": [75, 75, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 16.016016016016, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 4", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-49.256, -60.41, 0], "e": [-119.191, -193.214, 0], "to": [-3.33719229698181, -28.6953563690186, 0], "ti": [7.55511236190796, 85.6373519897461, 0] }, { "t": 62.0620620620621 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [55, 55, 100], "e": [100, 100, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 4.004004004004, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "circle 3", "parent": 0, "ks": { "o": { "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 44.044, "s": [100], "e": [0] }, { "t": 62.0620620620621 }] }, "r": { "k": 31.712 }, "p": { "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 6.006, "s": [-0.801, -111.287, 0], "e": [88.861, -254.063, 0], "to": [14.9435815811157, -23.7958908081055, 0], "ti": [-14.9435815811157, 23.7958908081055, 0] }, { "t": 64.0640640640641 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "k": [9.559, 9.559] }, "p": { "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "k": [0, -0.5], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "mn": "ADBE Vector Group" }], "ip": 6.00600600600601, "op": 80.0800800800801, "st": 6.00600600600601, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "Line 3", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": 52.835 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 2.002, "s": [55.743, -72.768, 0], "e": [116.509, -124.817, 0], "to": [10.1277112960815, -8.67486763000488, 0], "ti": [-10.1277112960815, 8.67486763000488, 0] }, { "t": 46.046046046046 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 10.01001001001 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 6.917, "s": [0], "e": [100] }, { "t": 34.9974974974975 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 48.0480480480481, "st": -4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Line 2", "parent": 0, "ks": { "o": { "k": 100 }, "r": { "k": -54.372 }, "p": { "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 0, "s": [-109.558, -67.678, 0], "e": [-181.558, -115.678, 0], "to": [-12, -8, 0], "ti": [12, 8, 0] }, { "t": 44.044044044044 }] }, "a": { "k": [0, 0, 0] }, "s": { "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ks": { "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -6.006, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 2.002, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 8.00800800800801 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "fillEnabled": true, "c": { "k": [1, 1, 1, 1] }, "o": { "k": 100 }, "w": { "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "k": [0, 0], "ix": 2 }, "a": { "k": [0, 0], "ix": 1 }, "s": { "k": [100, 100], "ix": 3 }, "r": { "k": 0, "ix": 6 }, "o": { "k": 100, "ix": 7 }, "sk": { "k": 0, "ix": 4 }, "sa": { "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 4.915, "s": [0], "e": [100] }, { "t": 32.9954954954955 }], "ix": 1 }, "e": { "k": 100, "ix": 2 }, "o": { "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 0, "op": 40.04004004004, "st": -6.00600600600601, "bm": 0, "sr": 1 }] }], "layers": [{ "ddd": 0, "ind": 0, "ty": 0, "nm": "Twitter_Logo_v001", "refId": "comp_0", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [{ "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p2_1_0p167_0p167", "t": 0.1, "s": [960, 540, 0], "e": [960, 500, 0], "to": [0, -6.66666650772095, 0], "ti": [0, 6.66666650772095, 0] }, { "t": 57.599609375 }] }, "a": { "k": [500, 500, 0] }, "s": { "k": [{ "i": { "x": [0.16, 0.16, 0.16], "y": [1, 1, 0.16] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p16_1_0p167_0p167", "0p16_1_0p167_0p167", "0p16_0p16_0p167_0p167"], "t": 0.1, "s": [25, 25, 100], "e": [30, 30, 100] }, { "t": 7.599609375 }] } }, "ao": 0, "w": 1000, "h": 1000, "ip": 0, "op": 132.6, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 1, "ty": 0, "nm": "Accent_Pop_02", "refId": "comp_1", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 325, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0.11, 0.63, 0.95, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 0, "nm": "Accent_Pop_01", "refId": "comp_2", "ks": { "o": { "k": 100 }, "r": { "k": 0 }, "p": { "k": [960, 426, 0] }, "a": { "k": [500, 500, 0] }, "s": { "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "ef": [{ "ty": 3, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "k": [0.11, 0.63, 0.95, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }], "v": "4.5.0", "ddd": 0, "ip": 0, "op": 73, "fr": 60, "w": 1920, "h": 1080 };

exports.default = v;

},{}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var v = { "v": "4.6.8", "fr": 60, "ip": 0, "op": 73, "w": 1920, "h": 1080, "nm": "Youtube_Full", "ddd": 0, "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 1, "ty": 4, "nm": "YouTube_Play_Button_v001 Outlines", "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [500, 500, 0] }, "a": { "a": 0, "k": [500, 500, 0] }, "s": { "a": 0, "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0]], "v": [[-73.387, 92.209], [-73.418, -107.528], [118.667, -7.312]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [21.312, 21.576], [13.893, 1.659], [0, 0], [0, 0], [99.483, -7.196], [27.044, -28.308], [0, 0], [0, -57.528], [0, 0], [0, 0], [-21.314, -21.577], [-15.821, -2.969], [0, 0], [-99.475, 7.19], [-27.03, 28.316], [0, 0], [0, 57.521], [0, 0]], "o": [[0, 0], [-27.03, -28.308], [-99.475, -7.196], [0, 0], [0, 0], [-13.893, 1.659], [-21.314, 21.576], [0, 0], [0, 0], [0, 57.521], [0, 0], [27.044, 28.316], [56.873, 5.454], [0, 0], [13.893, -1.658], [21.312, -21.577], [0, 0], [0, 0], [0, -57.528]], "v": [[348.349, -142.132], [320.088, -212.697], [248.859, -242.803], [0.154, -249.999], [-0.154, -249.999], [-248.857, -242.803], [-320.085, -212.697], [-348.333, -142.132], [-355.445, -27.075], [-355.445, 26.859], [-348.333, 141.908], [-320.085, 212.474], [-241.699, 242.856], [0.001, 249.999], [248.859, 242.587], [320.088, 212.474], [348.349, 141.908], [355.445, 26.859], [355.445, -27.075]], "c": true } }, "nm": "Path 2", "mn": "ADBE Vector Shape - Group" }, { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge" }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-500.499, 499.493], [499.501, 499.493], [499.501, -500.507], [-500.499, -500.507]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-500.499, -500.507], [499.501, -500.507], [499.501, 499.493], [-500.499, 499.493]], "c": true } }, "nm": "Path 2", "mn": "ADBE Vector Shape - Group" }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "ix": 4, "mn": "ADBE Vector Group" }, { "ty": "fl", "c": { "a": 0, "k": [0.902, 0.176, 0.153, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [500.499, 500.507], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 5, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0]], "v": [[-96.043, -56.24], [72.408, 56.24], [96.042, 43.976]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-523.123, 550.781], [476.877, 550.781], [476.877, -449.219], [-523.123, -449.219]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ind": 1, "ty": "sh", "ix": 2, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-523.123, -449.219], [476.877, -449.219], [476.877, 550.781], [-523.123, 550.781]], "c": true } }, "nm": "Path 2", "mn": "ADBE Vector Shape - Group" }, { "ind": 2, "ty": "sh", "ix": 3, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-96.043, 56.24], [96.044, 56.24], [96.044, -56.24], [-96.043, -56.24]], "c": true } }, "nm": "Path 3", "mn": "ADBE Vector Shape - Group" }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 3, "cix": 2, "ix": 2, "mn": "ADBE Vector Group" }, { "ty": "mm", "mm": 4, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge" }, { "ty": "fl", "c": { "a": 0, "k": [0.9281557, 0.9281557, 0.9281557, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [523.123, 449.219], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 2", "np": 4, "cix": 2, "ix": 2, "mn": "ADBE Vector Group" }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0]], "v": [[-96.043, 99.868], [96.042, 0.347], [-96.043, -99.868]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [523.123, 492.847], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 3", "np": 2, "cix": 2, "ix": 3, "mn": "ADBE Vector Group" }], "ip": 0, "op": 600, "st": 0, "bm": 0, "sr": 1 }] }, { "id": "comp_1", "layers": [{ "ddd": 0, "ind": 1, "ty": 3, "nm": "CONTROL", "ks": { "o": { "a": 0, "k": 0 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [501.176, 781.879, 0] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_Spirals", "mn": "ADBE Slider Control", "ix": 1, "en": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "a": 0, "k": 4 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 4", "parent": 1, "ks": { "o": { "a": 1, "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 52.052, "s": [100], "e": [0] }, { "t": 70.0700700700701 }] }, "r": { "a": 0, "k": 31.712 }, "p": { "a": 1, "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 14.014, "s": [-19.43, -54.264, 0], "e": [28.161, -150.437, 0], "to": [10.1970882415771, -42.1346244812012, 0], "ti": [-18.2750129699707, 30.565881729126, 0] }, { "t": 72.0720720720721 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [9.559, 9.559] }, "p": { "a": 0, "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [0, -0.5], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 14.014014014014, "op": 88.0880880880881, "st": 14.014014014014, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "circle 3", "parent": 1, "ks": { "o": { "a": 1, "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 48.048, "s": [100], "e": [0] }, { "t": 66.0660660660661 }] }, "r": { "a": 0, "k": 31.712 }, "p": { "a": 1, "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 10.01, "s": [-29.786, -65.914, 0], "e": [-20.383, -184.094, 0], "to": [8.25534057617188, -28.5423908233643, 0], "ti": [5.67320537567139, 51.2778625488281, 0] }, { "t": 68.0680680680681 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [60, 60, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [9.559, 9.559] }, "p": { "a": 0, "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [0, -0.5], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 10.01001001001, "op": 84.0840840840841, "st": 10.01001001001, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "spiral", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 8.514 }, "p": { "a": 0, "k": [1.93, 0, 0] }, "a": { "a": 0, "k": [-163, 282.001, 0] }, "s": { "a": 0, "k": [40, 40, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-15.521, 30.106], [38.729, 8.171], [11.662, -9.327], [-1.857, -6.365], [-5.521, 0.175], [-5.906, 34.615], [36.372, 18.345], [-1.726, -0.87], [-0.692, -30.667], [31.468, -14.379], [8.082, -0.257], [3.174, 2.304], [-2.886, 3.122], [-13.78, -2.278], [-4.101, -7.718], [0.874, -8.006], [6.701, -13.346], [31.569, -11.609], [-1.818, 0.669]], "o": [[31.836, -11.707], [12.233, -23.728], [-14.198, -2.995], [-4.522, 3.616], [1.934, 6.629], [37.065, -1.177], [6.311, -36.99], [-1.72, -0.867], [29.289, 14.773], [0.75, 33.222], [-7.344, 3.356], [-3.743, 0.119], [-4.972, -3.609], [9.968, -10.781], [8.253, 1.364], [3.873, 7.288], [-1.623, 14.863], [-15.054, 29.983], [-1.797, 0.661], [0, 0]], "v": [[-163.312, 281.901], [-89.439, 216.071], [-98.856, 131.371], [-141.883, 139.329], [-151.294, 156.813], [-134.672, 163.408], [-64.405, 95.138], [-105.805, -11.703], [-107.319, -9.112], [-65.851, 73.425], [-111.259, 154.771], [-134.672, 160.408], [-146.373, 158.441], [-143.04, 144.444], [-101.891, 133.84], [-81.527, 146.363], [-78.532, 170.482], [-91.371, 213.264], [-164.109, 279.008], [-163.312, 281.901]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 18.018, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 0, "s": [0], "e": [50] }, { "t": 44.044044044044 }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "spiral2", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": -22.696 }, "p": { "a": 0, "k": [-24.07, 0, 0] }, "a": { "a": 0, "k": [-72.797, 280.997, 0] }, "s": { "a": 0, "k": [27.474, 27.474, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-10.438, 51.085], [6.946, 26.74], [-11.077, 26.999], [-23.243, 17.516], [1.544, -1.163], [13.524, -20.417], [-4.513, -25.374], [-0.6, -28.238], [17.872, -21.395], [29.981, -3.225], [-1.92, 0.207]], "o": [[51.698, -5.561], [5.644, -27.621], [-7.025, -27.042], [11.393, -27.769], [1.523, -1.148], [-19.331, 14.568], [-14.47, 21.845], [4.899, 27.546], [0.592, 27.852], [-19.362, 23.179], [-1.9, 0.204], [0, 0]], "v": [[-72.173, 278.563], [33.089, 183.321], [25.559, 102.393], [22.673, 19.601], [82.571, -45.016], [81.057, -47.606], [28.376, 2.624], [16.051, 74.616], [32.511, 156.996], [5.495, 234.286], [-72.173, 275.563], [-72.173, 278.563]], "c": true } }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_Spirals')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p36_1_0p333_0"], "t": 24.024, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.31], "y": [1] }, "o": { "x": [0.69], "y": [0] }, "n": ["0p31_1_0p69_0"], "t": 6.006, "s": [0], "e": [50] }, { "t": 50.05005005005 }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 6.00600600600601, "op": 84.0840840840841, "st": 6.00600600600601, "bm": 0, "sr": 1 }] }, { "id": "comp_2", "layers": [{ "ddd": 0, "ind": 1, "ty": 3, "nm": "CONTROL", "ks": { "o": { "a": 0, "k": 0 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [556.545, 845.149, 0] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [250, 250, 100] } }, "ao": 0, "ef": [{ "ty": 5, "nm": "Stroke_CIRCLE", "mn": "ADBE Slider Control", "ix": 1, "en": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "a": 0, "k": 3 } }] }, { "ty": 5, "nm": "Stroke_LINE", "mn": "ADBE Slider Control", "ix": 2, "en": 1, "ef": [{ "ty": 0, "nm": "Slider", "mn": "ADBE Slider Control-0001", "ix": 1, "v": { "a": 0, "k": 10 } }] }], "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "circle 5", "parent": 1, "ks": { "o": { "a": 1, "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "a": 0, "k": 31.712 }, "p": { "a": 1, "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-27.463, -88.529, 0], "e": [-53.111, -238.909, 0], "to": [-16.6939601898193, -59.6268119812012, 0], "ti": [37.7835807800293, 60.3297958374023, 0] }, { "t": 62.0620620620621 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [25, 25, 100], "e": [75, 75, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [9.559, 9.559] }, "p": { "a": 0, "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [0, -0.5], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 16.016016016016, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "circle 4", "parent": 1, "ks": { "o": { "a": 1, "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 38.038, "s": [100], "e": [0] }, { "t": 64.0640640640641 }] }, "r": { "a": 0, "k": 31.712 }, "p": { "a": 1, "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 4.004, "s": [-49.256, -60.41, 0], "e": [-119.191, -193.214, 0], "to": [-3.33719229698181, -28.6953563690186, 0], "ti": [7.55511236190796, 85.6373519897461, 0] }, { "t": 62.0620620620621 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0.25, 0.25, 0.25], "y": [1, 1, 0.25] }, "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0.333] }, "n": ["0p25_1_0p333_0", "0p25_1_0p333_0", "0p25_0p25_0p333_0p333"], "t": 12.012, "s": [55, 55, 100], "e": [100, 100, 100] }, { "t": 38.038038038038 }] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [9.559, 9.559] }, "p": { "a": 0, "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 3, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_CIRCLE')('ADBE Slider Control-0001');" }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [0, -0.5], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 4.004004004004, "op": 78.0780780780781, "st": 4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "circle 3", "parent": 1, "ks": { "o": { "a": 1, "k": [{ "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "n": ["0p667_1_0p333_0"], "t": 44.044, "s": [100], "e": [0] }, { "t": 62.0620620620621 }] }, "r": { "a": 0, "k": 31.712 }, "p": { "a": 1, "k": [{ "i": { "x": 0.1, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p1_1_0p167_0p167", "t": 6.006, "s": [-0.801, -111.287, 0], "e": [88.861, -254.063, 0], "to": [14.9435815811157, -23.7958908081055, 0], "ti": [-14.9435815811157, 23.7958908081055, 0] }, { "t": 64.0640640640641 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [100, 100, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [9.559, 9.559] }, "p": { "a": 0, "k": [0, 0] }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 0 }, "lc": 1, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "fl", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "r": 1, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill" }, { "ty": "tr", "p": { "a": 0, "k": [0, -0.5], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }], "ip": 6.00600600600601, "op": 80.0800800800801, "st": 6.00600600600601, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Line 3", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 52.835 }, "p": { "a": 1, "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 2.002, "s": [55.743, -72.768, 0], "e": [116.509, -124.817, 0], "to": [10.1277112960815, -8.67486763000488, 0], "ti": [-10.1277112960815, 8.67486763000488, 0] }, { "t": 46.046046046046 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 1, "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 4.004, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 10.01001001001 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 6.917, "s": [0], "e": [100] }, { "t": 34.9974974974975 }], "ix": 1 }, "e": { "a": 0, "k": 100, "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 2.002002002002, "op": 48.0480480480481, "st": -4.004004004004, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 6, "ty": 4, "nm": "Line 2", "parent": 1, "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": -54.372 }, "p": { "a": 1, "k": [{ "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.333, "y": 0 }, "n": "0p25_1_0p333_0", "t": 0, "s": [-109.558, -67.678, 0], "e": [-181.558, -115.678, 0], "to": [-12, -8, 0], "ti": [12, 8, 0] }, { "t": 44.044044044044 }] }, "a": { "a": 0, "k": [0, 0, 0] }, "s": { "a": 0, "k": [30, 30, 100] } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 1, "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.75, "y": 0 }, "n": "0p833_0p833_0p75_0", "t": -6.006, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 206]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }] }, { "i": { "x": 0.25, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p25_1_0p167_0p167", "t": 2.002, "s": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4.021, 194.502]], "c": false }], "e": [{ "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[4, 206], [4, 4]], "c": false }] }, { "t": 8.00800800800801 }] }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group" }, { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1] }, "o": { "a": 0, "k": 100 }, "w": { "a": 0, "k": 10, "x": "var $bm_rt;\n$bm_rt = thisComp.layer('CONTROL').effect('Stroke_LINE')('ADBE Slider Control-0001');" }, "lc": 2, "lj": 1, "ml": 4, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke" }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 3, "cix": 2, "ix": 1, "mn": "ADBE Vector Group" }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0.25], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "n": ["0p25_1_0p167_0p167"], "t": 4.915, "s": [0], "e": [100] }, { "t": 32.9954954954955 }], "ix": 1 }, "e": { "a": 0, "k": 100, "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim" }], "ip": 0, "op": 40.04004004004, "st": -6.00600600600601, "bm": 0, "sr": 1 }] }], "layers": [{ "ddd": 0, "ind": 1, "ty": 0, "nm": "YouTube_Play_Button_v001", "refId": "comp_0", "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 1, "k": [{ "i": { "x": 0.2, "y": 1 }, "o": { "x": 0.167, "y": 0.167 }, "n": "0p2_1_0p167_0p167", "t": 0.1, "s": [960, 540, 0], "e": [960, 500, 0], "to": [0, -6.66666650772095, 0], "ti": [0, 6.66666650772095, 0] }, { "t": 57.599609375 }] }, "a": { "a": 0, "k": [500, 500, 0] }, "s": { "a": 1, "k": [{ "i": { "x": [0.16, 0.16, 0.16], "y": [1, 1, 0.16] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "n": ["0p16_1_0p167_0p167", "0p16_1_0p167_0p167", "0p16_0p16_0p167_0p167"], "t": 0.1, "s": [25, 25, 100], "e": [30, 30, 100] }, { "t": 7.599609375 }] } }, "ao": 0, "w": 1000, "h": 1000, "ip": 0, "op": 132.6, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 2, "ty": 0, "nm": "Accent_Pop_02", "refId": "comp_1", "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [960, 325, 0] }, "a": { "a": 0, "k": [500, 500, 0] }, "s": { "a": 0, "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [0.9019608, 0.1764706, 0.1529412, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }, { "ddd": 0, "ind": 3, "ty": 0, "nm": "Accent_Pop_01", "refId": "comp_2", "ks": { "o": { "a": 0, "k": 100 }, "r": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [960, 426, 0] }, "a": { "a": 0, "k": [500, 500, 0] }, "s": { "a": 0, "k": [60, 60, 100] } }, "ao": 0, "ef": [{ "ty": 21, "nm": "Fill", "mn": "ADBE Fill", "ix": 1, "en": 1, "ef": [{ "ty": 10, "nm": "Fill Mask", "mn": "ADBE Fill-0001", "ix": 1, "v": { "a": 0, "k": 0 } }, { "ty": 7, "nm": "All Masks", "mn": "ADBE Fill-0007", "ix": 2, "v": { "a": 0, "k": 0 } }, { "ty": 2, "nm": "Color", "mn": "ADBE Fill-0002", "ix": 3, "v": { "a": 0, "k": [0.9019608, 0.1764706, 0.1529412, 1] } }, { "ty": 7, "nm": "Invert", "mn": "ADBE Fill-0006", "ix": 4, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Horizontal Feather", "mn": "ADBE Fill-0003", "ix": 5, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Vertical Feather", "mn": "ADBE Fill-0004", "ix": 6, "v": { "a": 0, "k": 0 } }, { "ty": 0, "nm": "Opacity", "mn": "ADBE Fill-0005", "ix": 7, "v": { "a": 0, "k": 1 } }] }], "w": 1000, "h": 1000, "ip": 0, "op": 78.0780780780781, "st": 0, "bm": 0, "sr": 1 }] };

exports.default = v;

},{}],51:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../../utils/GeneralUtils');

var _SMP1Instagram = require('./SMP-1-Instagram');

var _SMP1Instagram2 = _interopRequireDefault(_SMP1Instagram);

var _SMP1Twitter = require('./SMP-1-Twitter');

var _SMP1Twitter2 = _interopRequireDefault(_SMP1Twitter);

var _SMP1Snapchat = require('./SMP-1-Snapchat');

var _SMP1Snapchat2 = _interopRequireDefault(_SMP1Snapchat);

var _SMP1Facebook = require('./SMP-1-Facebook');

var _SMP1Facebook2 = _interopRequireDefault(_SMP1Facebook);

var _SMP1Youtube = require('./SMP-1-Youtube');

var _SMP1Youtube2 = _interopRequireDefault(_SMP1Youtube);

var _ModernOpenersLt = require('./Modern-Openers-Lt4');

var _ModernOpenersLt2 = _interopRequireDefault(_ModernOpenersLt);

var _CleanLowerThirdsLt = require('./Clean-Lower-Thirds-Lt1');

var _CleanLowerThirdsLt2 = _interopRequireDefault(_CleanLowerThirdsLt);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Modern Openers - Lower Thirds
// import Modern_Openers_Lt1 from './Modern-Openers-Lt1'
var animations = {
    SMP_1_Instagram: _SMP1Instagram2.default,
    SMP_1_Twitter: _SMP1Twitter2.default,
    SMP_1_Snapchat: _SMP1Snapchat2.default,
    SMP_1_Facebook: _SMP1Facebook2.default,
    SMP_1_Youtube: _SMP1Youtube2.default,

    // Modern_Openers_Lt1 : Modern_Openers_Lt1,
    Modern_Openers_Lt4: _ModernOpenersLt2.default,

    Clean_Lower_Thirds_Lt1: _CleanLowerThirdsLt2.default
};

// Clean Lower Thirds


// Social Media Pack 1
exports.default = (0, _GeneralUtils.deepFreeze)(animations);

},{"../../utils/GeneralUtils":77,"./Clean-Lower-Thirds-Lt1":44,"./Modern-Openers-Lt4":45,"./SMP-1-Facebook":46,"./SMP-1-Instagram":47,"./SMP-1-Snapchat":48,"./SMP-1-Twitter":49,"./SMP-1-Youtube":50}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var v = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"500\" viewBox=\"6 -10 500 500\">\n    <path d=\"M375.717 112.553H138.283c-8.137 0-14.73 6.594-14.73 14.73v237.434c0 8.135 6.594 14.73 14.73 14.73h127.826V276.092h-34.781v-40.28h34.781v-29.705c0-34.473 21.055-53.244 51.807-53.244 14.73 0 27.391 1.097 31.08 1.587v36.026l-21.328.01c-16.725 0-19.963 7.947-19.963 19.609v25.717h39.887l-5.193 40.28h-34.693v103.355h68.012c8.135 0 14.73-6.596 14.73-14.73V127.283c-.001-8.137-6.596-14.73-14.731-14.73z\" fill=\"#fff\"/>\n</svg>\n";

exports.default = v;

},{}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var v = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"132.004\" height=\"132\" viewBox=\"0 0 131 131\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n        <linearGradient id=\"_B1pxDbZxZ_b\">\n            <stop offset=\"0\" stop-color=\"#3771c8\"/>\n            <stop stop-color=\"#3771c8\" offset=\".128\"/>\n            <stop offset=\"1\" stop-color=\"#60f\" stop-opacity=\"0\"/>\n        </linearGradient>\n        <linearGradient id=\"_B1pxDbZxZ_a\">\n            <stop offset=\"0\" stop-color=\"#fd5\"/>\n            <stop offset=\".1\" stop-color=\"#fd5\"/>\n            <stop offset=\".5\" stop-color=\"#ff543e\"/>\n            <stop offset=\"1\" stop-color=\"#c837ab\"/>\n        </linearGradient>\n        <radialGradient id=\"_B1pxDbZxZ_c\" cx=\"158.429\" cy=\"578.088\" r=\"65\" xlink:href=\"#_B1pxDbZxZ_a\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"matrix(0 -1.98198 1.8439 0 -1031.402 454.004)\" fx=\"158.429\" fy=\"578.088\"/>\n        <radialGradient id=\"_B1pxDbZxZ_d\" cx=\"147.694\" cy=\"473.455\" r=\"65\" xlink:href=\"#_B1pxDbZxZ_b\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"matrix(.17394 .86872 -3.5818 .71718 1648.348 -458.493)\" fx=\"147.694\" fy=\"473.455\"/>\n    </defs>\n    <path fill=\"url(#_B1pxDbZxZ_c)\" d=\"M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z\" transform=\"translate(1.004 1)\"/>\n    <path fill=\"url(#_B1pxDbZxZ_d)\" d=\"M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z\" transform=\"translate(1.004 1)\"/>\n    <path fill=\"#fff\" d=\"M66.004 18c-13.036 0-14.672.057-19.792.29-5.11.234-8.598 1.043-11.65 2.23-3.157 1.226-5.835 2.866-8.503 5.535-2.67 2.668-4.31 5.346-5.54 8.502-1.19 3.053-2 6.542-2.23 11.65C18.06 51.327 18 52.964 18 66s.058 14.667.29 19.787c.235 5.11 1.044 8.598 2.23 11.65 1.227 3.157 2.867 5.835 5.536 8.503 2.667 2.67 5.345 4.314 8.5 5.54 3.054 1.187 6.543 1.996 11.652 2.23 5.12.233 6.755.29 19.79.29 13.037 0 14.668-.057 19.788-.29 5.11-.234 8.602-1.043 11.656-2.23 3.156-1.226 5.83-2.87 8.497-5.54 2.67-2.668 4.31-5.346 5.54-8.502 1.18-3.053 1.99-6.542 2.23-11.65.23-5.12.29-6.752.29-19.788 0-13.036-.06-14.672-.29-19.792-.24-5.11-1.05-8.598-2.23-11.65-1.23-3.157-2.87-5.835-5.54-8.503-2.67-2.67-5.34-4.31-8.5-5.535-3.06-1.187-6.55-1.996-11.66-2.23-5.12-.233-6.75-.29-19.79-.29zm-4.306 8.65c1.278-.002 2.704 0 4.306 0 12.816 0 14.335.046 19.396.276 4.68.214 7.22.996 8.912 1.653 2.24.87 3.837 1.91 5.516 3.59 1.68 1.68 2.72 3.28 3.592 5.52.657 1.69 1.44 4.23 1.653 8.91.23 5.06.28 6.58.28 19.39s-.05 14.33-.28 19.39c-.214 4.68-.996 7.22-1.653 8.91-.87 2.24-1.912 3.835-3.592 5.514-1.68 1.68-3.275 2.72-5.516 3.59-1.69.66-4.232 1.44-8.912 1.654-5.06.23-6.58.28-19.396.28-12.817 0-14.336-.05-19.396-.28-4.68-.216-7.22-.998-8.913-1.655-2.24-.87-3.84-1.91-5.52-3.59-1.68-1.68-2.72-3.276-3.592-5.517-.657-1.69-1.44-4.23-1.653-8.91-.23-5.06-.276-6.58-.276-19.398s.046-14.33.276-19.39c.214-4.68.996-7.22 1.653-8.912.87-2.24 1.912-3.84 3.592-5.52 1.68-1.68 3.28-2.72 5.52-3.592 1.692-.66 4.233-1.44 8.913-1.655 4.428-.2 6.144-.26 15.09-.27zm29.928 7.97c-3.18 0-5.76 2.577-5.76 5.758 0 3.18 2.58 5.76 5.76 5.76 3.18 0 5.76-2.58 5.76-5.76 0-3.18-2.58-5.76-5.76-5.76zm-25.622 6.73c-13.613 0-24.65 11.037-24.65 24.65 0 13.613 11.037 24.645 24.65 24.645C79.617 90.645 90.65 79.613 90.65 66S79.616 41.35 66.003 41.35zm0 8.65c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16z\"/>\n</svg>\n";

exports.default = v;

},{}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var v = "\n<svg height=\"512\" version=\"1.1\" viewBox=\"0 0 512 512\" width=\"512\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:svg=\"http://www.w3.org/2000/svg\">\n    <g>\n        <g transform=\"matrix(1.418485,0,0,1.418485,-507.62367,-651.3318)\">\n            <path style=\"fill:#ffffff\" d=\"m 679.333,552.19 c -10.375,4.604 -21.521,7.711 -33.224,9.111 11.939,-7.16 21.114,-18.501 25.436,-32.004 -11.178,6.63 -23.563,11.439 -36.744,14.035 -10.547,-11.246 -25.588,-18.269 -42.223,-18.269 -31.953,0 -57.859,25.906 -57.859,57.855 0,4.533 0.513,8.946 1.501,13.186 -48.085,-2.419 -90.71,-25.446 -119.245,-60.454 -4.981,8.545 -7.833,18.48 -7.833,29.089 0,20.072 10.21,37.777 25.735,48.152 -9.479,-0.302 -18.398,-2.902 -26.204,-7.234 -0.003,0.238 -0.003,0.482 -0.003,0.726 0,28.029 19.944,51.41 46.407,56.734 -4.855,1.315 -9.968,2.027 -15.238,2.027 -3.733,0 -7.354,-0.373 -10.883,-1.041 7.36,22.98 28.728,39.709 54.039,40.176 -19.795,15.52 -44.742,24.77 -71.854,24.77 -4.665,0 -9.27,-0.275 -13.799,-0.816 25.609,16.422 56.018,26.001 88.688,26.001 106.412,0 164.606,-88.156 164.606,-164.606 0,-2.514 -0.058,-5.007 -0.165,-7.49 11.295,-8.159 21.11,-18.344 28.862,-29.948 l 0,0 z\" />\n        </g>\n    </g>\n</svg>\n";

exports.default = v;

},{}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var v = "<svg\n\tversion=\"1.1\"\n\tx=\"0px\"\n\ty=\"0px\"\n\tviewBox=\"0 0 300 300\"\n\tenable-background=\"new 0 0 400 400\"\n\txml:space=\"preserve\"\n\twidth=\"300\"\n\theight=\"300\">\n\t<g id=\"g5355\">\n\t\t<rect\n\t\t\twidth=\"300\"\n\t\t\theight=\"300\"\n\t\t\tid=\"rect4\"\n\t\t\tstyle=\"fill:#ff0000;fill-opacity:1\"\n\t\t\tx=\"0\"\n\t\t\ty=\"0\"\n\t\t\try=\"49.137924\"\n\t\t/>\n\t\t<g transform=\"matrix(5.9026317,0,0,5.9026317,521.39665,-711.31763)\" id=\"g4167\">\n\t\t\t<path\n\t\t\t\tstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none\"\n\t\t\t\td=\"m 149.9375,79.222656 c 0,0 -63.218849,5.9e-5 -79.085938,4.123047 -8.495787,2.373802 -15.491408,9.3695 -17.865234,17.990237 -4.122953,15.8671 -4.123047,48.72656 -4.123047,48.72656 0,0 9.4e-5,32.9842 4.123047,48.60156 2.373826,8.62062 9.244506,15.49138 17.865234,17.86524 15.99203,4.24788 79.085938,4.24804 79.085938,4.24804 0,0 63.34418,-5e-5 79.21094,-4.12304 8.62079,-2.37381 15.49133,-9.11966 17.74023,-17.86524 4.24793,-15.74232 4.24805,-48.60156 4.24805,-48.60156 0,0 0.12484,-32.98446 -4.24805,-48.85156 -2.2489,-8.620737 -9.11944,-15.491334 -17.74023,-17.740237 -15.86676,-4.372847 -79.21094,-4.373047 -79.21094,-4.373047 z m -20.11523,40.480464 52.59961,30.35938 -52.59961,30.23438 0,-60.59376 z\"\n\t\t\t\ttransform=\"matrix(0.16941596,0,0,0.16941596,-88.332912,120.50856)\"\n\t\t\t\tid=\"path4156\"\n\t\t\t/>\n\t\t</g>\n\t</g>\n</svg>";

exports.default = v;

},{}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var v = "\n<svg\n\txmlns=\"http://www.w3.org/2000/svg\"\n\txmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\tversion=\"1.1\"\n\tid=\"Layer_1\"\n\tx=\"0px\"\n\ty=\"0px\"\n\twidth=\"266.893px\"\n\theight=\"266.895px\"\n\tviewBox=\"0 0 266.893 266.895\"\n\tenable-background=\"new 0 0 266.893 266.895\"\n\txml:space=\"preserve\">\n\t<path\n\t\tid=\"Blue_1_\"\n\t\tfill=\"#3C5A99\"\n\t\td=\"M248.082,262.307c7.854,0,14.223-6.369,14.223-14.225V18.812  c0-7.857-6.368-14.224-14.223-14.224H18.812c-7.857,0-14.224,6.367-14.224,14.224v229.27c0,7.855,6.366,14.225,14.224,14.225  H248.082z\"\n\t/>\n\t<path\n\t\tid=\"f\"\n\t\tfill=\"#FFFFFF\"\n\t\td=\"M182.409,262.307v-99.803h33.499l5.016-38.895h-38.515V98.777c0-11.261,3.127-18.935,19.275-18.935  l20.596-0.009V45.045c-3.562-0.474-15.788-1.533-30.012-1.533c-29.695,0-50.025,18.126-50.025,51.413v28.684h-33.585v38.895h33.585  v99.803H182.409z\"\n\t/>\n</svg>\n";

exports.default = v;

},{}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var v = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" width=\"266.893px\" height=\"266.895px\" viewBox=\"0 0 266.893 266.895\" enable-background=\"new 0 0 266.893 266.895\" xml:space=\"preserve\">\n\t<path id=\"Blue_1_\" fill=\"#34a1f2\" d=\"M248.082,262.307c7.854,0,14.223-6.369,14.223-14.225V18.812  c0-7.857-6.368-14.224-14.223-14.224H18.812c-7.857,0-14.224,6.367-14.224,14.224v229.27c0,7.855,6.366,14.225,14.224,14.225  H248.082z\"/>\n    <g transform=\"matrix(0.8,0,0,0.8,-300,-380.3318)\">\n        <path style=\"fill:#ffffff\" d=\"m 679.333,552.19 c -10.375,4.604 -21.521,7.711 -33.224,9.111 11.939,-7.16 21.114,-18.501 25.436,-32.004 -11.178,6.63 -23.563,11.439 -36.744,14.035 -10.547,-11.246 -25.588,-18.269 -42.223,-18.269 -31.953,0 -57.859,25.906 -57.859,57.855 0,4.533 0.513,8.946 1.501,13.186 -48.085,-2.419 -90.71,-25.446 -119.245,-60.454 -4.981,8.545 -7.833,18.48 -7.833,29.089 0,20.072 10.21,37.777 25.735,48.152 -9.479,-0.302 -18.398,-2.902 -26.204,-7.234 -0.003,0.238 -0.003,0.482 -0.003,0.726 0,28.029 19.944,51.41 46.407,56.734 -4.855,1.315 -9.968,2.027 -15.238,2.027 -3.733,0 -7.354,-0.373 -10.883,-1.041 7.36,22.98 28.728,39.709 54.039,40.176 -19.795,15.52 -44.742,24.77 -71.854,24.77 -4.665,0 -9.27,-0.275 -13.799,-0.816 25.609,16.422 56.018,26.001 88.688,26.001 106.412,0 164.606,-88.156 164.606,-164.606 0,-2.514 -0.058,-5.007 -0.165,-7.49 11.295,-8.159 21.11,-18.344 28.862,-29.948 l 0,0 z\"/>\n    </g>\n</svg>\n";

exports.default = v;

},{}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\">\n<g data-name=\"5\"><path d=\"M55,7H9a4,4,0,0,0-4,4V53a4,4,0,0,0,4,4H55a4,4,0,0,0,4-4V11A4,4,0,0,0,55,7ZM57,53a2,2,0,0,1-2,2H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9H55a2,2,0,0,1,2,2Z\"/><path d=\"M52 19.41H11.88a1 1 0 0 0-1 1V50a1 1 0 0 0 1 1H52a1 1 0 0 0 1-1V20.41A1 1 0 0 0 52 19.41zM51 49H12.88V21.41H51zM52.13 12.4H46.35a1 1 0 0 0-1 1v3.42a1 1 0 0 0 1 1h5.78a1 1 0 0 0 1-1V13.4A1 1 0 0 0 52.13 12.4zm-1 3.42H47.35V14.4h3.78zM36.33 17.82h5.78a1 1 0 0 0 1-1V13.4a1 1 0 0 0-1-1H36.33a1 1 0 0 0-1 1v3.42A1 1 0 0 0 36.33 17.82zm1-3.42h3.78v1.42H37.33z\"/><path d=\"M22 35.69h3v4.16a1 1 0 0 0 2 0V31a1 1 0 0 0-2 0v2.69H23V31a1 1 0 0 0-1-1h0a1 1 0 0 0-1 1v3.69a1 1 0 0 0 1 1zM38 35.69h3v4.16a1 1 0 0 0 2 0V31a1 1 0 0 0-2 0v2.69H39V31a1 1 0 0 0-1-1h0a1 1 0 0 0-1 1v3.69a1 1 0 0 0 1 1zM30 40.85h4a1 1 0 0 0 1-1V31a1 1 0 0 0-1-1H30a1 1 0 0 0-1 1v8.85A1 1 0 0 0 30 40.85zM31 32h2v6.85H31z\"/>\n</g></svg>";

exports.default = svg;

},{}],59:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GeneralUtils = require('../../utils/GeneralUtils');

var _SMP_2_Instagram_Icon = require('./SMP_2_Instagram_Icon');

var _SMP_2_Instagram_Icon2 = _interopRequireDefault(_SMP_2_Instagram_Icon);

var _SMP_2_Facebook_Icon = require('./SMP_2_Facebook_Icon');

var _SMP_2_Facebook_Icon2 = _interopRequireDefault(_SMP_2_Facebook_Icon);

var _SMP_2_Twitter_Icon = require('./SMP_2_Twitter_Icon');

var _SMP_2_Twitter_Icon2 = _interopRequireDefault(_SMP_2_Twitter_Icon);

var _SMP_3_Twitter_Icon = require('./SMP_3_Twitter_Icon');

var _SMP_3_Twitter_Icon2 = _interopRequireDefault(_SMP_3_Twitter_Icon);

var _SMP_2_Youtube_Icon = require('./SMP_2_Youtube_Icon');

var _SMP_2_Youtube_Icon2 = _interopRequireDefault(_SMP_2_Youtube_Icon);

var _SMP_3_Facebook_Icon = require('./SMP_3_Facebook_Icon');

var _SMP_3_Facebook_Icon2 = _interopRequireDefault(_SMP_3_Facebook_Icon);

var _error_placeholder = require('./error_placeholder');

var _error_placeholder2 = _interopRequireDefault(_error_placeholder);

var _loading_placeholder = require('./loading_placeholder');

var _loading_placeholder2 = _interopRequireDefault(_loading_placeholder);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Social Media Pack 2
var svgs = {
    SMP_2_Instagram_Icon: _SMP_2_Instagram_Icon2.default,
    SMP_2_Facebook_Icon: _SMP_2_Facebook_Icon2.default,
    SMP_3_Facebook_Icon: _SMP_3_Facebook_Icon2.default,
    SMP_2_Twitter_Icon: _SMP_2_Twitter_Icon2.default,
    SMP_2_Youtube_Icon: _SMP_2_Youtube_Icon2.default,
    SMP_3_Twitter_Icon: _SMP_3_Twitter_Icon2.default,
    error_placeholder: _error_placeholder2.default,
    loading_placeholder: _loading_placeholder2.default
};

exports.default = (0, _GeneralUtils.deepFreeze)(svgs);

},{"../../utils/GeneralUtils":77,"./SMP_2_Facebook_Icon":52,"./SMP_2_Instagram_Icon":53,"./SMP_2_Twitter_Icon":54,"./SMP_2_Youtube_Icon":55,"./SMP_3_Facebook_Icon":56,"./SMP_3_Twitter_Icon":57,"./error_placeholder":58,"./loading_placeholder":60}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"white\" data-name=\"Layer 1\" viewBox=\"0 0 24 24\">\n<path d=\"M6.8042,15A.99956.99956,0,0,0,5.438,14.63379l-1.73242,1a1.00016,1.00016,0,0,0,1,1.73242l1.73242-1A1.00073,1.00073,0,0,0,6.8042,15ZM3.70557,8.36621l1.73242,1a1.00016,1.00016,0,1,0,1-1.73242l-1.73242-1a1.00016,1.00016,0,0,0-1,1.73242ZM6,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H5A1,1,0,0,0,6,12ZM17.1958,9a1.0006,1.0006,0,0,0,1.36621.36621l1.73242-1a1.00016,1.00016,0,1,0-1-1.73242l-1.73242,1A1.00073,1.00073,0,0,0,17.1958,9ZM15,6.8042A1.0006,1.0006,0,0,0,16.36621,6.438l1-1.73242a1.00016,1.00016,0,1,0-1.73242-1l-1,1.73242A1.00073,1.00073,0,0,0,15,6.8042Zm5.29443,8.82959-1.73242-1a1.00016,1.00016,0,1,0-1,1.73242l1.73242,1a1.00016,1.00016,0,0,0,1-1.73242ZM16.36621,17.562a1.00016,1.00016,0,1,0-1.73242,1l1,1.73242a1.00016,1.00016,0,1,0,1.73242-1ZM21,11H19a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Zm-9,7a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V19A1,1,0,0,0,12,18Zm-3-.8042a.99954.99954,0,0,0-1.36621.36621l-1,1.73242a1.00016,1.00016,0,0,0,1.73242,1l1-1.73242A1.00073,1.00073,0,0,0,9,17.1958ZM12,2a1,1,0,0,0-1,1V5a1,1,0,0,0,2,0V3A1,1,0,0,0,12,2Z\"/></svg>";

exports.default = svg;

},{}],61:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SupportedEditorWorkflows = exports.USE_UPLOAD_PAGE = exports.getSourceView = exports.ShopifyVideoTypes = exports.ShopifyAdPlatforms = exports.ShopifySegments = exports.UserSegmentsWithReligion = exports.UserSegments = exports.AiCreatorUIState = exports.FormatSelectUIState = exports.RemoveMemberModalUIState = exports.AddMemberModalUIState = exports.CollaboratorRole = exports.CustomFormatUIState = exports.FormatClassification = exports.FontClassification = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var FontClassification = exports.FontClassification = (0, _keymirror2.default)({
    SANS_SERIF: null,
    SERIF: null,
    SLAB_SERIF: null,
    DISPLAY: null
});

var FormatClassification = exports.FormatClassification = (0, _keymirror2.default)({
    YOUTUBE: null,
    FACEBOOK: null,
    LINKEDIN: null,
    TWITTER: null,
    INSTAGRAM: null
});

var CustomFormatUIState = exports.CustomFormatUIState = (0, _keymirror2.default)({
    OPEN: null,
    CREATING: null,
    CREATION_SUCCESS: null,
    CREATION_FAILED: null,
    CLOSED: null,
    CF_LIMIT_REACHED: null
});

var CollaboratorRole = exports.CollaboratorRole = (0, _keymirror2.default)({
    ADMIN: null,
    PRODUCER: null,
    EDITOR: null
});

var AddMemberModalUIState = exports.AddMemberModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    INVITE_SUCCESS: null,
    INVITE_ERROR: null,
    INVITE_PENDING: null,
    INVITE_ACCEPTED: null
});

var RemoveMemberModalUIState = exports.RemoveMemberModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    REMOVE_SUCCESS: null,
    REMOVE_ERROR: null
});

var FormatSelectUIState = exports.FormatSelectUIState = (0, _keymirror2.default)({
    OPEN: null,
    CLOSED: null
});

var AiCreatorUIState = exports.AiCreatorUIState = (0, _keymirror2.default)({
    OPEN: null,
    CLOSED: null,
    CREATING_PROJECT: null
});

var UserSegments = exports.UserSegments = [{
    id: 'e-commerce',
    name: 'E-Commerce'
}, {
    id: 'education',
    name: 'Education'
}, {
    id: 'fitness',
    name: 'Fitness'
}, {
    id: 'health-wellness',
    name: 'Health & Wellness'
}, {
    id: 'entertainment',
    name: 'Media & Entertainment'
}, {
    id: 'charity',
    name: 'Nonprofit or Charity'
}, {
    id: 'real-estate',
    name: 'Real Estate'
}, {
    id: 'marketing',
    name: 'Agency/Freelancers'
}, {
    id: 'fashion',
    name: 'Fashion & Beauty'
}, {
    id: 'creators',
    name: 'Creators'
}, {
    id: 'travel-hospitality',
    name: 'Travel & Hospitality'
}, {
    id: 'government',
    name: 'Government'
}, {
    id: 'food-beverage',
    name: 'Food & Beverages'
}, {
    id: 'technology',
    name: 'Software/Technology'
}, {
    id: 'other',
    name: 'Other'
}];

var UserSegmentsWithReligion = exports.UserSegmentsWithReligion = [{
    id: 'personal',
    name: 'Personal'
}, {
    id: 'religion',
    name: 'Religious Organization'
}, {
    id: 'education',
    name: 'Education'
}, {
    id: 'charity',
    name: 'Nonprofit or Charity'
}, {
    id: 'marketing',
    name: 'Advertising / Marketing / News Agency'
}, {
    id: 'small-business',
    name: 'Small business'
}, {
    id: 'large-business',
    name: 'Large Company'
}];

var ShopifySegments = exports.ShopifySegments = [{
    id: 'home-decor',
    name: 'Home & Decor'
}, {
    id: 'craft-books',
    name: 'Crafts & Books'
}, {
    id: 'fashion',
    name: 'Fashion Accessories'
}, {
    id: 'food-beverage',
    name: 'Food & Drink'
}, {
    id: 'electronics',
    name: 'Electronics'
}, {
    id: 'artwork',
    name: 'Artwork'
}, {
    id: 'merchandise',
    name: 'Merchandise'
}, {
    id: 'other',
    name: 'Other'
}];

var ShopifyAdPlatforms = exports.ShopifyAdPlatforms = [{
    id: 'facebook',
    name: 'Facebook'
}, {
    id: 'instagram',
    name: 'Instagram'
}, {
    id: 'google',
    name: 'Google'
}, {
    id: 'none',
    name: "I don't run them"
}];

var ShopifyVideoTypes = exports.ShopifyVideoTypes = [{
    id: 'product-in-focus',
    name: 'Product in focus'
}, {
    id: 'promo-offer',
    name: 'Promotional Offer'
}, {
    id: 'how-to',
    name: 'How to videos'
}, {
    id: 'testimonial',
    name: 'Customer Testimonials'
}, {
    id: 'insta-stories',
    name: 'Instagram Stories'
}, {
    id: 'other',
    name: 'Others'
}];

var getSourceView = exports.getSourceView = function getSourceView() {
    return typeof sourceView === 'undefined' ? '' : sourceView;
};

var USE_UPLOAD_PAGE = exports.USE_UPLOAD_PAGE = false;

var SupportedEditorWorkflows = exports.SupportedEditorWorkflows = (0, _keymirror2.default)({
    fitness: null
});

},{"keymirror":677}],62:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReviewActionType = exports.WorkflowInfoActionType = exports.CustomFormatActionType = exports.AiCreatorActionType = exports.FormatSelectActionType = exports.RemoveMemberActionType = exports.AddMemberActionType = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var AddMemberActionType = exports.AddMemberActionType = (0, _keymirror2.default)({
    OPEN_ADD_MEMBER_MODAL: null,
    CLOSE_ADD_MEMBER_MODAL: null,
    ADD_MEMBER_SUCCESS: null,
    ADD_MEMBER_ERROR: null,
    ADD_MEMBER_INVITE_PENDING: null,
    ADD_MEMBER_INVITE_ACCEPTED: null
});

var RemoveMemberActionType = exports.RemoveMemberActionType = (0, _keymirror2.default)({
    OPEN_REMOVE_MEMBER_MODAL: null,
    CLOSE_REMOVE_MEMBER_MODAL: null,
    REMOVE_MEMBER_SUCCESS: null,
    REMOVE_MEMBER_ERROR: null
});

var FormatSelectActionType = exports.FormatSelectActionType = (0, _keymirror2.default)({
    OPEN_FORMAT_SELECT: null,
    CLOSE_FORMAT_SELECT: null,
    SET_SELECTED_FORMAT_ID: null,
    CLEAR_SELECTED_FORMAT_ID: null
});

var AiCreatorActionType = exports.AiCreatorActionType = (0, _keymirror2.default)({
    OPEN_AI_CREATOR: null,
    CLOSE_AI_CREATOR: null,
    CREATE_PROJECT: null
});

var CustomFormatActionType = exports.CustomFormatActionType = (0, _keymirror2.default)({
    FORMAT_CREATOR_SUCCESS: null,
    FORMAT_CREATOR_FAIL: null,
    FORMAT_REMOVED: null,
    FORMAT_CREATOR_OPEN: null,
    FORMAT_CREATOR_PROCESSING: null,
    FORMAT_CREATOR_CLOSE: null,
    FORMAT_LIMIT_REACHED: null
});

var WorkflowInfoActionType = exports.WorkflowInfoActionType = (0, _keymirror2.default)({
    SET_OPEN_FITNESS_EDITOR: null,
    CLEAR_OPEN_FITNESS_EDITOR: null,
    SET_USE_AI_CREATOR: null,
    CLEAR_USE_AI_CREATOR: null
});

var ReviewActionType = exports.ReviewActionType = (0, _keymirror2.default)({
    REVIEW_SUBMITTED: null,
    SUBMITTING_REVIEW: null,
    REVIEW_SUBMIT_ERROR: null
});

},{"keymirror":677}],63:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var personalSource = keymirror({
    personal: null,
    zoom: null,
    gdrive: null,
    shopify: null
});

var stockSource = keymirror({
    unsplash: null,
    pixabay: null,
    videoTemplate: null,
    typito_template_page_stock: null,
    'typito-template-page-stock': null
});

var SupportedMediaType = keymirror({
    video: null,
    image: null,
    audio: null
});

module.exports = {
    personalSource: personalSource,
    stockSource: stockSource,
    SupportedMediaType: SupportedMediaType
};

},{"keymirror":677}],64:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeControlMode = exports.FailedUploadPlaceholder = exports.SEEK_BOUNDARY = exports.OVERLAY_CUE_ANIM_DURATION = exports.ZOOM_OFFSET_DURATION = exports.MARKER_HEIGHT = exports.TIMELINE_PLUS_BUTTON_WIDTH = exports.ZOOM_SCROLL_DELAY = exports.CLIP_ADDITION_DELAY = exports.USER_ANIMATION_DELAY = exports.TIMER_UPDATE_INTERVAL = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var TIMER_UPDATE_INTERVAL = exports.TIMER_UPDATE_INTERVAL = 200;

var USER_ANIMATION_DELAY = exports.USER_ANIMATION_DELAY = 30; // millisecond

var CLIP_ADDITION_DELAY = exports.CLIP_ADDITION_DELAY = 60;

var ZOOM_SCROLL_DELAY = exports.ZOOM_SCROLL_DELAY = 1000;

var TIMELINE_PLUS_BUTTON_WIDTH = exports.TIMELINE_PLUS_BUTTON_WIDTH = 75;

var MARKER_HEIGHT = exports.MARKER_HEIGHT = 30;

var ZOOM_OFFSET_DURATION = exports.ZOOM_OFFSET_DURATION = 30000;

var OVERLAY_CUE_ANIM_DURATION = exports.OVERLAY_CUE_ANIM_DURATION = 60;

var SEEK_BOUNDARY = exports.SEEK_BOUNDARY = 5; // 30 miliseconds

var FailedUploadPlaceholder = exports.FailedUploadPlaceholder = {
    baseUrl: '/images/common/upload_fail_placeholder.png',
    uploadFailedPlaceholder: true,
    deleted: true,
    fullPngUrl: '/images/common/upload_fail_placeholder.png',
    height: 1920,
    id: 'upload-failed-placeholder',
    originalFileName: 'Upload Failed!',
    previewUrl: '/images/common/upload_fail_placeholder.png',
    snapshotUrl: '/images/common/upload_fail_placeholder.png',
    width: 1080
};

var TimeControlMode = exports.TimeControlMode = (0, _keymirror2.default)({
    NORMAL_OVERLAY: null,
    SEQUENCE_OVERLAY: null
});

},{"keymirror":677}],65:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var SupportedPlugins = keymirror({
    iconscout: null,
    captions: null,
    typitofoundry: null
});

var SupportedPluginAssetType = keymirror({
    svg: null
});

module.exports = {
    SupportedPlugins: SupportedPlugins,
    SupportedPluginAssetType: SupportedPluginAssetType
};

},{"keymirror":677}],66:[function(require,module,exports){
'use strict';

var SolidImageId = 'SOLID-IMAGE';
var SolidImageZIndex = 9999;
var SolidImageUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var SolidImageData = {
    baseUrl: SolidImageUrl,
    fullPngUrl: SolidImageUrl,
    previewUrl: SolidImageUrl,
    thumbUrl: SolidImageUrl,
    height: 1920,
    width: 1920,
    id: SolidImageId
};

module.exports = {
    SolidImageId: SolidImageId,
    SolidImageZIndex: SolidImageZIndex,
    SolidImageUrl: SolidImageUrl,
    SolidImageData: SolidImageData
};

},{}],67:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SupportedAssetTypes = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _keymirror2.default)({
    SUBTITLE_TEXT: null, // -- Styles which are used in subtitle
    BASIC_TEXT: null, // -- Text style that are basic
    PRESET_TEXT: null, // Text Style with cool styles,
    SHAPES: null, // Overlays in elements section
    ICONS: null // Overlays in elements section
});
var SupportedAssetTypes = exports.SupportedAssetTypes = (0, _keymirror2.default)({
    svg: null
});

},{"keymirror":677}],68:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackVtSearched = exports.trackVtSelectedTemplateCategory = exports.trackVtSwitchedFormatOnDetailPage = exports.trackVtFavouriteMarked = exports.trackVtPlayedTemplate = exports.trackVtAppliedAllSequences = exports.trackSequenceUsed = exports.vtFormats = exports.vtPages = exports.sequenceTypes = exports.eventTypes = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _TrackUtils = require('../utils/TrackUtils');

var tracker = _interopRequireWildcard(_TrackUtils);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

/** CONSTANTS  */

var eventTypes = exports.eventTypes = {
    SEQUENCE_USED: 'Sequence Used',
    VT_APPLIED_ALL_SEQUENCES: 'VT: Applied All Sequences',
    VT_PLAYED_TEMPLATE: 'VT: Played Template',
    VT_FAVOURITE_MARKED: 'VT: Favourite Marked',
    VT_SWITCHED_FORMAT_ON_DETAIL_PAGE: 'VT: Switched Format on Detail Page',
    VT_SELECTED_TEMPLATE_CATEGORY: 'VT: Selected Template Category',
    VT_SEARCHED: 'VT: Searched'
};

var sequenceTypes = exports.sequenceTypes = {
    USER_CREATED: 'user-created',
    VIDEO_TEMPLATE: 'video-template'
};

var vtPages = exports.vtPages = {
    TEMPLATE_HOME_PAGE: 'template-home-page',
    DETAIL_PAGE: 'detail-page',
    SEARCH_PAGE: 'search-page',
    EXPLORE_PAGE: 'explore-page',
    EDIT_PAGE: 'edit-page',
    EXPORT_PAGE: 'export-page',
    SHARE_PAGE: 'share-page'
};

var vtFormats = exports.vtFormats = {
    SQUARE: 'square',
    WIDESCREEN: 'widescreen',
    VERTICAL: 'vertical'

    /***********************/

    /** Use requestIdleCallback to process events when the browser is not busy */

};var eventsToProcess = [];

var isScheduled = false;

var schedulePendingEvents = function schedulePendingEvents() {
    if (!!isScheduled) return;

    isScheduled = true;

    if (!!window.requestIdleCallback) {
        requestIdleCallback(processEvents, { timeout: 3000 });
    } else {
        processEvents();
    }
};

var processEvents = function processEvents(deadline) {
    isScheduled = false;

    // If there is no deadline, just run as long as necessary.
    // This will be the case if requestIdleCallback doesn’t exist.
    if (typeof deadline === 'undefined') deadline = { timeRemaining: function timeRemaining() {
            return Number.MAX_VALUE;
        }

        // Go for as long as there is time remaining and work to do.
    };while (deadline.timeRemaining() > 0 && eventsToProcess.length > 0) {

        var evt = eventsToProcess.pop();
        var target = evt.target,
            type = evt.type,
            data = evt.data;

        switch (target) {

            case 'freshchat':
                tracker.trackOnFreshChat(type, data);
                break;

            case 'posthog':
                tracker.trackOnPostHog(type, data);
                break;

            default:
                break;
        }
    }

    // Check if there are more events still to send.
    if (eventsToProcess.length > 0) schedulePendingEvents();
};

var trackOnPostHog = function trackOnPostHog(type, data) {
    eventsToProcess.push({ type: type, data: data, target: 'posthog' });
    schedulePendingEvents();
};

var trackOnFreshChat = function trackOnFreshChat(type, data) {
    eventsToProcess.push({ type: type, data: data, target: 'freshchat' });
};

/***********************/

/** TRACKING FUNCTIONS */

var trackSequenceUsed = exports.trackSequenceUsed = async function trackSequenceUsed(projectId, sequenceId) {
    var sequenceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sequenceType.USER_CREATED;
    var extraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    try {
        var data = _extends({
            projectId: projectId,
            sequenceId: sequenceId,
            sequenceType: sequenceType
        }, extraData);

        if (analyticsEnabled) {

            trackOnFreshChat(eventTypes.SEQUENCE_USED, data);

            trackOnPostHog(eventTypes.SEQUENCE_USED, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

var trackVtAppliedAllSequences = exports.trackVtAppliedAllSequences = async function trackVtAppliedAllSequences(projectId, vtId) {
    var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {
        var data = _extends({
            projectId: projectId,
            vtId: vtId
        }, extraData);

        if (analyticsEnabled) {

            trackOnPostHog(eventTypes.VT_APPLIED_ALL_SEQUENCES, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

var trackVtPlayedTemplate = exports.trackVtPlayedTemplate = async function trackVtPlayedTemplate(vtId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vtPages.EDIT_PAGE;
    var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {
        var data = _extends({
            vtId: vtId,
            page: page
        }, extraData);

        if (analyticsEnabled) {

            trackOnPostHog(eventTypes.VT_PLAYED_TEMPLATE, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

var trackVtFavouriteMarked = exports.trackVtFavouriteMarked = async function trackVtFavouriteMarked(vtId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vtPages.EDIT_PAGE;
    var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {
        var data = _extends({
            vtId: vtId,
            page: page
        }, extraData);

        if (analyticsEnabled) {

            trackOnPostHog(eventTypes.VT_FAVOURITE_MARKED, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

var trackVtSwitchedFormatOnDetailPage = exports.trackVtSwitchedFormatOnDetailPage = async function trackVtSwitchedFormatOnDetailPage(vtId, oldFormat, newFormat) {
    var extraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    try {
        var data = _extends({
            vtId: vtId,
            oldFormat: oldFormat,
            newFormat: newFormat
        }, extraData);

        if (analyticsEnabled) {

            trackOnPostHog(eventTypes.VT_SWITCHED_FORMAT_ON_DETAIL_PAGE, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

var trackVtSelectedTemplateCategory = exports.trackVtSelectedTemplateCategory = async function trackVtSelectedTemplateCategory(categoryId) {
    var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
        var data = _extends({
            categoryId: categoryId
        }, extraData);

        if (analyticsEnabled) {

            trackOnPostHog(eventTypes.VT_SELECTED_TEMPLATE_CATEGORY, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

var trackVtSearched = exports.trackVtSearched = async function trackVtSearched(searchText) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {

        if (!page) {
            page = vtPages.DETAIL_PAGE;
            if (window.location.search.match(/^\?search=/)) page = vtPages.SEARCH_PAGE;else if (window.location.pathname.match(/^\/video-templates\/?$/)) page = vtPages.EXPLORE_PAGE;else if (window.location.pathname.match(/^\/video-templates\/category\//)) page = vtPages.EXPLORE_PAGE;
        }

        var data = _extends({
            searchText: searchText,
            page: page
        }, extraData);

        if (analyticsEnabled) {

            trackOnPostHog(eventTypes.VT_SEARCHED, data);
        }
    } catch (err) {
        console.log('Error logging data - ' + err);
    }
};

/************************/

},{"../utils/TrackUtils":90}],69:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _events = require('events');

var _WaitMode = require('./enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _PlaybackState = require('./enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _TimeUtils = require('../utils/TimeUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var EV_WAIT_MODE_CHANGE = 'EV_WAIT_MODE_CHANGE';
var EV_PLAYBACK_STATE_CHANGE = 'EV_PLAYBACK_STATE_CHANGE';

var FADE_DURATION = 2;

function toGSAPEase(ease) {
    if (ease === 'linear') {
        return Linear.easeNone;
    }
    console.warn('unknown ease', ease);
    return Quad.easeOut;
}

var AudioController = function () {
    function AudioController() {
        var _this = this;

        _classCallCheck(this, AudioController);

        this._emitter = new _events.EventEmitter();

        this._audio = null;
        this.playbackState = null;
        this.waitMode = null;

        this.corePlayerWaitMode = null;
        this._corePlayerDuration = null;

        this.audioClip = null;

        this._volumeTransitionList = [];

        this._onCanPlayFunc = function () {
            return _this._onCanPlay();
        };
        this._onSeekingFunc = function () {
            return _this._onSeeking();
        };
        this._onSeekedFunc = function () {
            return _this._onSeeked();
        };

        this._timeline = new TimelineMax({ paused: true, onComplete: function onComplete() {
                return _this._onComplete();
            } });
        this._volumeTimeline = new TimelineMax({ paused: true,
            onUpdate: function onUpdate() {
                // console.log('time', this._volumeTimeline.time(), 'volume', this._audio.volume);
            }
        });
    }

    _createClass(AudioController, [{
        key: 'attachAudio',
        value: function attachAudio(audioClip, audioNodeEl, audioSource, audioDuration, totalVideoDuration) {
            var _this2 = this;

            this._audio = audioNodeEl;

            this.audioClip = audioClip;
            this.audioClip.trimStart = audioClip.trimStart || 0;

            this.duration = audioDuration;
            this.currentTime = 0;
            this.playbackState = _PlaybackState2.default.PAUSED;
            this.waitMode = _WaitMode2.default.LOADING;
            this._corePlayerDuration = totalVideoDuration;
            this._corePlayerTime = 0;
            this._audio.loop = false;

            this._initializeAudio(audioSource);

            this._timeline.set({}, {}, audioDuration);
            this._timeline.time((0, _TimeUtils._toGSAPtime)(0));

            this._updateVolumeTimeline();

            this._tickerSyncCallback = function () {
                return _this2._onTickerSync();
            };
            window.TweenMax.ticker.addEventListener('tick', this._tickerSyncCallback);
        }
    }, {
        key: 'detachAudio',
        value: function detachAudio() {

            this._timeline.kill();
            this._timeline = null;

            this._volumeTimeline.kill();
            this._volumeTimeline = null;

            window.TweenMax.ticker.removeEventListener('tick', this._tickerSyncCallback);
            this._tickerSyncCallback = null;

            if (this._audio) {
                this._removeListeners();
                this._audio.pause();
                $(this._audio).remove();
                this._audio = null;
            }

            this.waitMode = _WaitMode2.default.LOADING;
            this.playbackState = _PlaybackState2.default.PAUSED;
            this.corePlayerWaitMode = null;
            this._corePlayerDuration = null;
        }
    }, {
        key: '_initializeAudio',
        value: function _initializeAudio(audioSource) {
            this._audio.src = audioSource;

            this._addListeners();
            this._fireWaitModeChange();
        }
    }, {
        key: '_addListeners',
        value: function _addListeners() {
            this._audio.addEventListener("canplay", this._onCanPlayFunc, false);
            this._audio.addEventListener("seeking", this._onSeekingFunc, false);
            this._audio.addEventListener("seeked", this._onSeekedFunc, false);
        }
    }, {
        key: '_removeListeners',
        value: function _removeListeners() {

            this._audio.removeEventListener("canplay", this._onCanPlayFunc, false);
            this._audio.removeEventListener("seeking", this._onSeekingFunc, false);
            this._audio.removeEventListener("seeked", this._onSeekedFunc, false);

            this._emitter.removeAllListeners(EV_WAIT_MODE_CHANGE);
            this._emitter.removeAllListeners(EV_PLAYBACK_STATE_CHANGE);
        }
    }, {
        key: 'time',
        value: function time() {
            return (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
        }
    }, {
        key: 'doPause',
        value: function doPause() {
            this._updatePlaybackState(_PlaybackState2.default.PAUSED);
        }
    }, {
        key: 'doPlay',
        value: function doPlay() {
            this._updatePlaybackState(_PlaybackState2.default.PLAYING);
        }
    }, {
        key: 'doSeek',
        value: function doSeek(time) {
            var seekTime = (0, _TimeUtils._toGSAPtime)(time);
            var loopCount = 0;
            if (this.audioClip.clipLooping) {
                seekTime = (0, _TimeUtils._toGSAPtime)(time % this.duration);
                loopCount = Math.floor(time / this.duration);
            }

            if (this.waitMode == _WaitMode2.default.NONE) {
                this._audio.currentTime = this.audioClip.trimStart / 1000 + seekTime;
            } else {
                this._needAudioSeek = true;
            }

            this._timeline.seek(seekTime);
            this._volumeTimeline.seek((0, _TimeUtils._toGSAPtime)(time + loopCount * this.duration));
        }
    }, {
        key: 'doUpdateClip',
        value: function doUpdateClip(newAudioClip) {
            this.audioClip = newAudioClip;
            this.audioClip.trimStart = this.audioClip.trimStart || 0;

            this._updateVolumeTimeline();
        }
    }, {
        key: 'doSetVolumeTransitionList',
        value: function doSetVolumeTransitionList(volumeTransitionList) {
            this._volumeTransitionList = volumeTransitionList;
            this._updateVolumeTimeline();
        }
    }, {
        key: 'updateCorePlayerWaitMode',
        value: function updateCorePlayerWaitMode(newCorePlayerWaitMode) {

            if (this.corePlayerWaitMode != newCorePlayerWaitMode) {
                var oldCorePlayerWaitMode = this.corePlayerWaitMode;

                this.corePlayerWaitMode = newCorePlayerWaitMode;

                this._updatePlaying(this.waitMode, oldCorePlayerWaitMode);
            }
        }
    }, {
        key: 'updateCorePlayerDuration',
        value: function updateCorePlayerDuration(newDuration) {
            if (this._corePlayerDuration != newDuration) {
                this._corePlayerDuration = newDuration;
                this._updateVolumeTimeline();
            }
        }
    }, {
        key: '_switchPlayback',
        value: function _switchPlayback(wasPlaying, shouldPlay) {
            if (wasPlaying && !shouldPlay) {
                this._audio.pause();
                this._timeline.pause();
                this._volumeTimeline.pause();
            } else if (!wasPlaying && shouldPlay) {
                this._audio.play();
                this._timeline.play();
                // console.log('seeking vol to', this.time())
                // this._volumeTimeline.seek(this.time()/1000)
                this._volumeTimeline.play();
            }
        }
    }, {
        key: 'setVideoTime',
        value: function setVideoTime(time) {
            this._corePlayerTime = time;
        }
    }, {
        key: '_updatePlaybackState',
        value: function _updatePlaybackState(newPlaybackState) {
            if (this.playbackState == newPlaybackState) {
                return;
            }

            var wasPlaying = this._activelyPlaying();

            this.playbackState = newPlaybackState;

            var shouldPlay = this._activelyPlaying();
            this._switchPlayback(wasPlaying, shouldPlay);

            this._firePlaybackStateChange();
        }
    }, {
        key: '_activelyPlaying',
        value: function _activelyPlaying() {
            return this.waitMode === _WaitMode2.default.NONE && this.playbackState == _PlaybackState2.default.PLAYING;
        }
    }, {
        key: '_updatePlaying',
        value: function _updatePlaying(oldWaitMode, oldCorePlayerWaitMode) {

            if (this.waitMode == oldWaitMode && this.corePlayerWaitMode == oldCorePlayerWaitMode) {
                return;
            }

            var wasPlaying = oldWaitMode === _WaitMode2.default.NONE && oldCorePlayerWaitMode === _WaitMode2.default.NONE && this.playbackState === _PlaybackState2.default.PLAYING;
            var shouldPlay = this.waitMode === _WaitMode2.default.NONE && this.corePlayerWaitMode === _WaitMode2.default.NONE && this.playbackState === _PlaybackState2.default.PLAYING;

            this._switchPlayback(wasPlaying, shouldPlay);
        }
    }, {
        key: '_updateWaitMode',
        value: function _updateWaitMode(newWaitMode) {

            if (this.waitMode == newWaitMode) {
                return;
            }
            var oldWaitMode = this.waitMode;
            this.waitMode = newWaitMode;

            this._updatePlaying(oldWaitMode, this.corePlayerWaitMode);
            this._fireWaitModeChange();
        }
    }, {
        key: '_updateVolumeTimeline',
        value: function _updateVolumeTimeline() {
            var _this3 = this;

            this._volumeTimeline.clear();

            if (!this.audioClip) {
                return;
            }

            if (this.audioClip.clipLooping !== this._audio.loop) {
                this._audio.loop = this.audioClip.clipLooping;
            }

            var transitionList = this._volumeTransitionList;

            if (transitionList.length === 0) {
                return;
            }

            transitionList.forEach(function (t) {
                if (t.type === 'set') {
                    _this3._volumeTimeline.set(_this3._audio, { volume: t.to }, (0, _TimeUtils._toGSAPtime)(t.time));
                } else if (t.type === 'fromTo') {
                    // When from and to volumes are equal using fromTo() is not behaving correctly 
                    // hence using set() for such transitions
                    if (t.from === t.to) _this3._volumeTimeline.set(_this3._audio, { volume: t.from }, (0, _TimeUtils._toGSAPtime)(t.time));else _this3._volumeTimeline.fromTo(_this3._audio, (0, _TimeUtils._toGSAPtime)(t.duration), { volume: t.from }, { volume: t.to, ease: toGSAPEase(t.ease) }, (0, _TimeUtils._toGSAPtime)(t.time));
                }
            });

            var loopCount = Math.floor(this._corePlayerTime / this.duration);
            this._volumeTimeline.seek(this._timeline.time() + (0, _TimeUtils._toGSAPtime)(loopCount * this.duration));
            this._volumeTimeline.render(this._volumeTimeline.time(), false, true);

            if (this.playbackState == _PlaybackState2.default.PLAYING) {
                this._volumeTimeline.play();
            } else {
                this._volumeTimeline.pause();
            }
        }
    }, {
        key: '_fireWaitModeChange',
        value: function _fireWaitModeChange() {
            this._emitter.emit(EV_WAIT_MODE_CHANGE);
        }
    }, {
        key: '_firePlaybackStateChange',
        value: function _firePlaybackStateChange() {
            this._emitter.emit(EV_PLAYBACK_STATE_CHANGE);
        }
    }, {
        key: 'setWaitModeListener',
        value: function setWaitModeListener(callback) {
            this._emitter.on(EV_WAIT_MODE_CHANGE, callback);
        }
    }, {
        key: 'setPlaybackStateListener',
        value: function setPlaybackStateListener(callback) {
            this._emitter.on(EV_PLAYBACK_STATE_CHANGE, callback);
        }
    }, {
        key: 'clearWaitModeListener',
        value: function clearWaitModeListener() {
            this._emitter.removeAllListeners(EV_WAIT_MODE_CHANGE);
        }
    }, {
        key: 'clearPlaybackStateListener',
        value: function clearPlaybackStateListener() {
            this._emitter.removeAllListeners(EV_PLAYBACK_STATE_CHANGE);
        }
    }, {
        key: '_onCanPlay',
        value: function _onCanPlay() {
            this._updateWaitMode(_WaitMode2.default.NONE);
        }
    }, {
        key: '_onSeeking',
        value: function _onSeeking() {
            this._updateWaitMode(_WaitMode2.default.SEEKING);
        }
    }, {
        key: '_onSeeked',
        value: function _onSeeked() {
            this._updateWaitMode(_WaitMode2.default.NONE);
        }
    }, {
        key: '_onTickerSync',
        value: function _onTickerSync() {
            if (this.waitMode === _WaitMode2.default.NONE) {

                var audioTime = this._audio.currentTime - this.audioClip.trimStart / 1000;
                var timelineTime = this._timeline.time();

                if (audioTime !== timelineTime) {
                    if (this._needAudioSeek) {
                        this._audio.currentTime = this._timeline.time() + this.audioClip.trimStart / 1000;
                        this._needAudioSeek = false;
                    } else {
                        this._timeline.seek(audioTime);

                        var loopCount = Math.floor(this._corePlayerTime / this.duration);
                        this._volumeTimeline.seek(audioTime + (0, _TimeUtils._toGSAPtime)(loopCount * this.duration));
                    }
                }
            } else if (this._audio.readyState > 3) {
                this._onCanPlay();
            }
        }
    }, {
        key: '_onComplete',
        value: function _onComplete() {
            if (this.audioClip && !this.audioClip.clipLooping) {
                console.log('audio complete');
                this._updatePlaybackState(_PlaybackState2.default.ENDED);
            }
        }
    }]);

    return AudioController;
}();

exports.default = AudioController;

},{"../utils/TimeUtils":89,"./enums/PlaybackState":96,"./enums/WaitMode":100,"events":629}],70:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = require('events');

var _WaitMode = require('./enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _PlaybackState = require('./enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _TimeUtils = require('../utils/TimeUtils');

var _ClipBoxCover = require('../components/ClipBoxCover.react');

var _ClipBoxCover2 = _interopRequireDefault(_ClipBoxCover);

var _SolidImage = require('../../common/constants/SolidImage');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var EV_WAIT_MODE_CHANGE = 'EV_WAIT_MODE_CHANGE';
var EV_PLAYBACK_STATE_CHANGE = 'EV_PLAYBACK_STATE_CHANGE';

var DEBUG = false;

var dlog = DEBUG ? function () {
    var _console;

    return (_console = console).log.apply(_console, arguments);
} : function () {};

var checkIfDeleted = function checkIfDeleted(cb) {
    return function () {
        if (!this.deleted) {
            return cb.apply(undefined, arguments);
        }
    };
};

var BaseSingleClipController = function () {
    function BaseSingleClipController() {
        var _this = this;

        _classCallCheck(this, BaseSingleClipController);

        this._emitter = new _events.EventEmitter();

        this._timeline = new window.TimelineMax({
            paused: true,
            onComplete: function onComplete() {
                return _this._onComplete();
            }
        });

        this.waitMode = null;
        this.playbackState = null;
        this.corePlayerWaitMode = null;

        this._needPlayerSeek = false;

        this.visible = false;

        this.cropping = false;
        this.updateWaitModeCallback = function () {};

        var funcArrForDeleteCheck = [
        // 'updateDisplay',
        'doSetVolume', 'doSetSpeed', '_onPlaybackRateChanged',
        // '_onSeekPlayerToTime',
        '_onInternalPlayerPlayback', '_onInternalPlayerPause', '_onSetAnimType'];

        funcArrForDeleteCheck.forEach(function (fn) {
            _this[fn] = checkIfDeleted(_this[fn].bind(_this)).bind(_this);
        });
    }

    _createClass(BaseSingleClipController, [{
        key: 'createDisplayElement',
        value: function createDisplayElement(id) {
            var _onCreateNode2 = this._onCreateNode(id),
                containerEl = _onCreateNode2.containerEl,
                displayEl = _onCreateNode2.displayEl,
                clipBoxEl = _onCreateNode2.clipBoxEl;

            this.displayEl = displayEl;
            this.clipBoxEl = clipBoxEl;
            this.containerEl = containerEl;
        }
    }, {
        key: 'attach',
        value: function attach(clip, canvas, clipType, id, width, height) {
            var _this2 = this;

            this.clip = clip;
            this.canvas = canvas;
            this.clipType = clipType;
            this.clipId = id;
            this.nativeWidth = width;
            this.nativeHeight = height;

            for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
                args[_key - 6] = arguments[_key];
            }

            var _args$ = args[0],
                _args$$deleted = _args$.deleted,
                deleted = _args$$deleted === undefined ? false : _args$$deleted,
                originalFileName = _args$.originalFileName,
                snapshotUrl = _args$.snapshotUrl,
                _args$$uploadFailedPl = _args$.uploadFailedPlaceholder,
                uploadFailedPlaceholder = _args$$uploadFailedPl === undefined ? false : _args$$uploadFailedPl;

            this.deleted = deleted;

            this.uploadFailedPlaceholder = uploadFailedPlaceholder;

            this._onAttach.apply(this, args);

            this._timeline.set({}, {}, (0, _TimeUtils._toGSAPtime)(this._getDuration()));
            this._timeline.time((0, _TimeUtils._toGSAPtime)(0));

            this.doHide();
            this.doSetVolume(0);

            this.waitMode = _WaitMode2.default.LOADING;
            this.playbackState = _PlaybackState2.default.PAUSED;
            this.corePlayerWaitMode = _WaitMode2.default.NONE;

            this._tickerSyncCallback = function () {
                return _this2._onTickerSync();
            };
            window.TweenMax.ticker.addEventListener('tick', this._tickerSyncCallback);

            this.updateDisplay();

            if (deleted) {
                this.updateDeletedClip(clip);
            }
        }
    }, {
        key: 'setCropping',
        value: function setCropping(isCropping) {
            this.cropping = isCropping;
            this.updateDisplay();
        }
    }, {
        key: 'kill',
        value: function kill() {
            window.TweenMax.ticker.removeEventListener('tick', this._tickerSyncCallback);
            this._tickerSyncCallback = null;

            _reactDom2.default.unmountComponentAtNode(this.clipBoxEl.get(0));

            this._onKill();

            this._emitter.removeAllListeners(EV_WAIT_MODE_CHANGE);
            this._emitter.removeAllListeners(EV_PLAYBACK_STATE_CHANGE);

            this.removeDeletedMediaNode();
            this.displayEl.remove();

            this.waitMode = null;
            this.playbackState = null;

            this._timeline.kill();
            this._timeline = null;

            this.clipId = null;
            this.nativeWidth = -1;
            this.nativeHeight = -1;
        }
    }, {
        key: 'updateDisplay',
        value: function updateDisplay() {
            var cropping = this.cropping,
                clip = this.clip,
                canvas = this.canvas,
                clipBoxEl = this.clipBoxEl,
                containerEl = this.containerEl;

            containerEl.css('overflow', cropping ? 'visible' : 'hidden');
            clipBoxEl.css('overflow', cropping ? 'visible' : 'hidden');
            // TODO - Move this out under the main React Tree , keep under sync and batched
            _reactDom2.default.render(_react2.default.createElement(_ClipBoxCover2.default, { isCropping: cropping, clipBox: clip.clipBox, canvas: canvas }), clipBoxEl.get(0));

            this._updateTimelines();
        }
    }, {
        key: 'updateDeletedClip',
        value: function updateDeletedClip(clip) {
            var _getDeletedNodeParams2 = this._getDeletedNodeParams(clip),
                originalFileName = _getDeletedNodeParams2.originalFileName,
                snapshotUrl = _getDeletedNodeParams2.snapshotUrl;

            this.addDeletedMediaNode({ originalFileName: originalFileName, snapshotUrl: snapshotUrl });

            this._updateWaitMode(_WaitMode2.default.NONE);
            this.removeTransitions();
            this.doSetSpeed(1);
            this.setCropping(false);
            this.doSetAnimType('NONE');
            this.deleted = true;
        }
    }, {
        key: 'addWaitModeListener',
        value: function addWaitModeListener(callback) {
            this._emitter.on(EV_WAIT_MODE_CHANGE, callback);
        }
    }, {
        key: 'addPlaybackStateListener',
        value: function addPlaybackStateListener(callback) {
            this._emitter.on(EV_PLAYBACK_STATE_CHANGE, callback);
        }
    }, {
        key: 'doShow',
        value: function doShow() {
            this.visible = true;
            this._doShow();
        }
    }, {
        key: '_doShow',
        value: function _doShow() {
            this.containerEl.css('transform', 'scale(1,1)');
        }
    }, {
        key: 'doHide',
        value: function doHide() {
            this.visible = false;
            this._doHide();
        }
    }, {
        key: '_doHide',
        value: function _doHide() {
            this.containerEl.css('transform', 'scale(0)');
        }
    }, {
        key: 'doSetVolume',
        value: function doSetVolume(newVolume) {
            this._onSetVolume(newVolume);
        }
    }, {
        key: 'enterStart',
        value: function enterStart() {
            return this._enterStart();
        }
    }, {
        key: 'enterDone',
        value: function enterDone() {
            return this._enterDone();
        }
    }, {
        key: 'exitStart',
        value: function exitStart() {
            return this._exitStart();
        }
    }, {
        key: 'exitDone',
        value: function exitDone() {
            return this._exitDone();
        }
    }, {
        key: 'enterStartWithTransition',
        value: function enterStartWithTransition() {
            return this._enterStartWithTransition();
        }
    }, {
        key: 'exitDoneWithTransition',
        value: function exitDoneWithTransition() {
            return this._exitDoneWithTransition();
        }
    }, {
        key: 'doSetSpeed',
        value: function doSetSpeed(newSpeed) {
            var changeInDuration = this._onSetSpeed(newSpeed) || 0;
            this._refreshTimeline();
            return changeInDuration;
        }
    }, {
        key: '_doUpdateClipTimeData',
        value: function _doUpdateClipTimeData(newClip) {}
        // no needed to to be implemented by all , but can if some general time update method is needed


        /**
         * Returns the duration difference, later the return might change as well
         * But it will be something related to time data
         *
         * @param {*} newClip
         * @return {*} 
         * @memberof BaseSingleClipController
         */

    }, {
        key: 'doUpdateClipTimeData',
        value: function doUpdateClipTimeData(newClip) {
            var retValue = this._doUpdateClipTimeData(newClip);
            this.clip = newClip;
            this._refreshTimeline();
            return retValue;
        }
    }, {
        key: 'doUpdateClip',
        value: function doUpdateClip(newClip, zIndex) {
            this.clip = newClip;

            var isDeleted = this._checkIfClipDeleted(newClip);

            this.uploadFailedPlaceholder = this._checkIfUploadFailedPlaceholder(newClip);

            if (isDeleted) {
                if (!this.deleted) {
                    this.updateDeletedClip(newClip);
                }
                this.deleted = true;
            } else {
                if (this.deleted) {
                    this.removeDeletedMediaNode();
                }
                this.deleted = false;
            }

            this._onUpdateClip(newClip, isDeleted);

            if (!!zIndex) {
                this.containerEl.css('zIndex', zIndex);
            }
            if (!!this.clip.hidePadding) {
                this.containerEl.css('zIndex', _SolidImage.SolidImageZIndex);
            }
            if (!!newClip.solidImageColor) {
                // should apply bg color for solid image placeHolder
                // ideally only solid image placeholders should have this attribute
                this._applyBgColor(newClip.solidImageColor);
            }
            this.updateDisplay();
        }
    }, {
        key: 'doUpdateCanvas',
        value: function doUpdateCanvas(newCanvas) {
            this.canvas = newCanvas;
            this.updateDisplay();
        }
    }, {
        key: 'getSpeed',
        value: function getSpeed() {
            if (this.deleted) return 1;
            return this._getSpeed();
        }
    }, {
        key: 'doSetAnimType',
        value: function doSetAnimType(newAnimType) {
            this._onSetAnimType(newAnimType);
        }
    }, {
        key: 'doSetTransitionType',
        value: function doSetTransitionType(kind, transition) {
            this._onSetTransitionType(kind, transition);
            this.clip.transitions[kind] = transition;

            this._refreshTimeline();
        }
    }, {
        key: 'updateTime',
        value: function updateTime(newTime) {
            this._onUpdateTime(newTime);
        }
    }, {
        key: 'removeTransitions',
        value: function removeTransitions() {
            var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';

            this._onRemoveTransition(kind);
            this._refreshTimeline();
        }
    }, {
        key: 'doPlay',
        value: function doPlay() {
            if (this.playbackState == _PlaybackState2.default.ENDED) {
                this._timeline.seek((0, _TimeUtils._toGSAPtime)(0));
                this._onSeekToBeginning();
            }
            this._updatePlaybackState(_PlaybackState2.default.PLAYING);
        }
    }, {
        key: 'doPause',
        value: function doPause() {
            this._updatePlaybackState(_PlaybackState2.default.PAUSED);
        }
    }, {
        key: 'doSeek',
        value: function doSeek(time) {
            if (time < 0) {
                return;
            }
            if (this.waitMode === _WaitMode2.default.NONE) {
                this._onSeekPlayerToTime(time);
            } else {
                this._needPlayerSeek = true;
            }
            !!this._timeline && this._timeline.time((0, _TimeUtils._toGSAPtime)(time));
        }
    }, {
        key: 'updateCorePlayerWaitMode',
        value: function updateCorePlayerWaitMode(newCorePlayerWaitMode) {
            this._updateCorePlayerWaitMode(newCorePlayerWaitMode);
        }
    }, {
        key: 'doChangeClipBounds',
        value: function doChangeClipBounds() {
            this._refreshTimeline();

            var newTime = this._onChangeClip.apply(this, arguments);

            this._timeline.seek(newTime);
        }
    }, {
        key: '_refreshTimeline',
        value: function _refreshTimeline() {
            this._timeline.clear();
            this._timeline.set({}, {}, (0, _TimeUtils._toGSAPtime)(this._getDuration()));
            this._updateTimelines();
        }
    }, {
        key: 'getDisplayEl',
        value: function getDisplayEl() {
            return this.displayEl;
        }
    }, {
        key: 'getContainerEl',
        value: function getContainerEl() {
            return this.containerEl;
        }
    }, {
        key: 'timelineTime',
        value: function timelineTime() {
            return (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
        }
    }, {
        key: 'duration',
        value: function duration() {
            return this._getDuration();
        }
    }, {
        key: 'addDeletedMediaNode',
        value: function addDeletedMediaNode(_ref) {
            var originalFileName = _ref.originalFileName,
                snapshotUrl = _ref.snapshotUrl;

            var classes = 'deleted-asset ' + (this.uploadFailedPlaceholder ? 'upload-failed' : '');
            var name = this.uploadFailedPlaceholder ? 'Upload Failed!' : originalFileName;

            this.containerEl.append('<img src=' + snapshotUrl + ' alt="' + originalFileName + '" class="deleted-asset-snapshot"/>');
            this.containerEl.append('<div class="' + classes + '" data-text="' + name + '"></div>');
        }
    }, {
        key: 'removeDeletedMediaNode',
        value: function removeDeletedMediaNode() {
            var _this3 = this;

            var deletedAssetNodes = this.containerEl[0].querySelectorAll('[class^="deleted-asset"]');

            if (!!deletedAssetNodes && deletedAssetNodes.length > 0) {
                deletedAssetNodes.forEach(function (node) {
                    return _this3.containerEl[0].removeChild(node);
                });
            }
        }
    }, {
        key: '_checkIfClipDeleted',
        value: function _checkIfClipDeleted(clip) {
            switch (clip.clipType) {
                case 'image':
                    {
                        return clip.clipImage.deleted;
                    }
                case 'video':
                    {
                        return clip.clipVideo.deleted;
                    }
            }
            return false;
        }
    }, {
        key: '_checkIfUploadFailedPlaceholder',
        value: function _checkIfUploadFailedPlaceholder(clip) {
            switch (clip.clipType) {
                case 'image':
                    {
                        return clip.clipImage.uploadFailedPlaceholder;
                    }
                case 'video':
                    {
                        return clip.clipVideo.uploadFailedPlaceholder;
                    }
            }
            return false;
        }
    }, {
        key: '_getDeletedNodeParams',
        value: function _getDeletedNodeParams(clip) {
            switch (clip.clipType) {
                case 'image':
                    {
                        var _clip$clipImage = clip.clipImage,
                            originalFileName = _clip$clipImage.originalFileName,
                            snapshotUrl = _clip$clipImage.snapshotUrl;

                        return { originalFileName: originalFileName, snapshotUrl: snapshotUrl };
                    }
                case 'video':
                    {
                        var _clip$clipVideo = clip.clipVideo,
                            _originalFileName = _clip$clipVideo.originalFileName,
                            _snapshotUrl = _clip$clipVideo.snapshotUrl;

                        return { originalFileName: _originalFileName, snapshotUrl: _snapshotUrl };
                    }
            }
            return { originalFileName: '', snapshotUrl: '' };
        }

        /* private methods */

    }, {
        key: '_onComplete',
        value: function _onComplete() {
            this._updatePlaybackState(_PlaybackState2.default.ENDED);
        }
    }, {
        key: '_activelyPlaying',
        value: function _activelyPlaying() {
            return this._canPlay() && this.playbackState == _PlaybackState2.default.PLAYING;
        }
    }, {
        key: '_fireWaitModeChange',
        value: function _fireWaitModeChange() {
            this._emitter.emit(EV_WAIT_MODE_CHANGE);
        }
    }, {
        key: '_firePlaybackStateChange',
        value: function _firePlaybackStateChange() {
            this._emitter.emit(EV_PLAYBACK_STATE_CHANGE);
        }
    }, {
        key: '_onTickerSync',
        value: function _onTickerSync() {
            if (this.waitMode === _WaitMode2.default.NONE) {
                var playerTime = this._getPlayerTime();
                var timelineTime = this.timelineTime();

                if (playerTime !== timelineTime) {
                    if (this._needPlayerSeek) {
                        this._onSeekPlayerToTime(timelineTime);
                        this._needPlayerSeek = false;
                    } else {
                        this._timeline.seek((0, _TimeUtils._toGSAPtime)(playerTime));
                    }
                }
            }
        }
    }, {
        key: '_canPlay',
        value: function _canPlay() {
            if (this.corePlayerWaitMode === null) {
                return this.waitMode === _WaitMode2.default.NONE;
            } else {
                return this.waitMode === _WaitMode2.default.NONE && this.corePlayerWaitMode === _WaitMode2.default.NONE;
            }
        }
    }, {
        key: '_updateWaitMode',
        value: function _updateWaitMode(newWaitMode) {
            if (this.waitMode === newWaitMode) {
                return;
            }

            dlog('_updateWaitMode', this.clipId, this.waitMode, '->', newWaitMode);

            var wasPlaying = this._canPlay() && this.playbackState === _PlaybackState2.default.PLAYING;
            var oldWaitMode = this.waitMode;
            this.waitMode = newWaitMode;

            var shouldPlay = this._canPlay() && this.playbackState === _PlaybackState2.default.PLAYING;

            dlog('_updateWaitMode', this.clipId, 'wasPlaying', wasPlaying, '->', 'shouldPlay', shouldPlay);

            this._handleUpdateWaitMode(newWaitMode, oldWaitMode);
            this.updateWaitModeCallback(newWaitMode);
            this._fireWaitModeChange();
            this._changePlayback(wasPlaying, shouldPlay);
        }
    }, {
        key: '_updateCorePlayerWaitMode',
        value: function _updateCorePlayerWaitMode(newCorePlayerWaitMode) {
            if (this.corePlayerWaitMode === newCorePlayerWaitMode) {
                return;
            }

            dlog('_updateCorePlayerWaitMode', this.clipId, this.corePlayerWaitMode, '->', newCorePlayerWaitMode);

            var wasPlaying = this._canPlay() && this.playbackState === _PlaybackState2.default.PLAYING;

            this.corePlayerWaitMode = newCorePlayerWaitMode;

            var shouldPlay = this._canPlay() && this.playbackState === _PlaybackState2.default.PLAYING;

            dlog('_updateCorePlayerWaitMode', this.clipId, 'wasPlaying', wasPlaying, '->', 'shouldPlay', shouldPlay);

            this._changePlayback(wasPlaying, shouldPlay);

            this._handleCorePlayerWaitMode(newCorePlayerWaitMode);
        }
    }, {
        key: '_changePlayback',
        value: function _changePlayback(wasPlaying, shouldPlay) {
            if (wasPlaying && !shouldPlay) {
                this._onPlayerPause();
                this._timeline.pause();
            } else if (!wasPlaying && shouldPlay) {
                this._onPlayerPlay();
                this._timeline.play();
            }
        }
    }, {
        key: '_updatePlaybackState',
        value: function _updatePlaybackState(newPlaybackState) {
            if (this.playbackState === newPlaybackState) {
                return;
            }

            dlog('_updatePlaybackState', this.clipId, this.playbackState, '->', newPlaybackState);

            var wasPlaying = this._activelyPlaying();

            this.playbackState = newPlaybackState;

            var shouldPlay = this._activelyPlaying();

            dlog('_updatePlaybackState', this.clipId, 'wasPlaying', wasPlaying, '->', 'shouldPlay', shouldPlay);

            this._changePlayback(wasPlaying, shouldPlay);

            this._firePlaybackStateChange();
        }
    }, {
        key: 'changeUrlFromUserLand',
        value: function changeUrlFromUserLand() {
            this._changeUrlFromUserLand();
        }

        /* Sub classes should implement */

    }, {
        key: '_onCreateNode',
        value: function _onCreateNode(id) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onAttach',
        value: function _onAttach() {
            throw new Error('Needs override');
        }
    }, {
        key: '_onKill',
        value: function _onKill() {
            throw new Error('Needs override');
        }
    }, {
        key: '_updateTimelines',
        value: function _updateTimelines() {
            throw new Error('Needs override');
        }
    }, {
        key: '_onSetVolume',
        value: function _onSetVolume(newVolume) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onSetSpeed',
        value: function _onSetSpeed(newSpeed) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onUpdateClip',
        value: function _onUpdateClip(newClip) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onSetAnimType',
        value: function _onSetAnimType(newAnimType) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onSetTransitionType',
        value: function _onSetTransitionType(kind, transition) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onRemoveTransition',
        value: function _onRemoveTransition(kind) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onInternalPlayerPlayback',
        value: function _onInternalPlayerPlayback() {}
    }, {
        key: '_onInternalPlayerPause',
        value: function _onInternalPlayerPause() {}
    }, {
        key: '_onPlayerPlay',
        value: function _onPlayerPlay() {
            throw new Error('Needs override');
        }
    }, {
        key: '_onPlaybackRateChanged',
        value: function _onPlaybackRateChanged() {
            // only implemented in video controller
        }
    }, {
        key: '_onPlayerPause',
        value: function _onPlayerPause() {
            throw new Error('Needs override');
        }
    }, {
        key: '_onSeekToBeginning',
        value: function _onSeekToBeginning() {
            throw new Error('Needs override');
        }
    }, {
        key: '_onSeekPlayerToTime',
        value: function _onSeekPlayerToTime(time) {
            throw new Error('Needs override');
        }
    }, {
        key: '_onChangeClip',
        value: function _onChangeClip() {
            // Should return new seek time
            throw new Error('Needs override');
        }
    }, {
        key: '_getDuration',
        value: function _getDuration() {
            throw new Error('Needs override');
        }
    }, {
        key: '_getClipTimeline',
        value: function _getClipTimeline() {
            throw new Error('Needs override');
        }
    }, {
        key: '_getPlayerTime',
        value: function _getPlayerTime() {
            throw new Error('Needs override');
        }
    }, {
        key: '_enterStart',
        value: function _enterStart() {
            throw new Error('Needs override');
        }
    }, {
        key: '_enterDone',
        value: function _enterDone() {
            throw new Error('Needs override');
        }
    }, {
        key: '_exitStart',
        value: function _exitStart() {
            throw new Error('Needs override');
        }
    }, {
        key: '_exitDone',
        value: function _exitDone() {
            throw new Error('Needs override');
        }
    }, {
        key: '_enterStartWithTransition',
        value: function _enterStartWithTransition() {
            throw new Error('Needs override');
        }
    }, {
        key: '_exitDoneWithTransition',
        value: function _exitDoneWithTransition() {
            throw new Error('Needs override');
        }
    }, {
        key: '_applyBgColor',
        value: function _applyBgColor(bgColor) {
            throw new Error('Needs override');
        }

        /**
         * Implement it to make sure we can switch the player link however we want to detect
         * whenever new media is getting loaded with the server links
         * links must be switched !!!
         *
         * @memberof BaseSingleClipController
         */

    }, {
        key: '_changeUrlFromUserLand',
        value: function _changeUrlFromUserLand() {
            throw new Error('Needs override');
        }

        // to support new features going forwards
        // each controller will determine how to rotate or apply unique transform to its content
        // and apply effects
        // videos and images might have different requirements
        // this keeps the implementation isolated to themselves

    }, {
        key: 'applyTranform',
        value: function applyTranform(_ref2) {
            var rotateDeg = _ref2.rotateDeg,
                scaleX = _ref2.scaleX,
                scaleY = _ref2.scaleY;

            throw new Error('Needs override');
        }

        /**
         * Applies the height width and top left for the display element
         *
         * @param {*} {height , width , top , left}
         * @memberof BaseSingleClipController
         */

    }, {
        key: 'applyDimensions',
        value: function applyDimensions(_ref3) {
            var height = _ref3.height,
                width = _ref3.width,
                top = _ref3.top,
                left = _ref3.left;

            throw new Error('Needs override');
        }

        /**
         * Need not implement but can be used by controllers to set liteners for
         * after update time
         *
         *
         * @param {*} newTime
         * @memberof BaseSingleClipController
         */

    }, {
        key: '_onUpdateTime',
        value: function _onUpdateTime(newTime) {
            this.time = _extends({}, this.time, newTime);
            this.clip.time = _extends({}, this.clip.time, newTime);
        }
    }, {
        key: 'attachUpdateWaitModeCallback',
        value: function attachUpdateWaitModeCallback() {
            var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            this.updateWaitModeCallback = cb;
        }

        /**
         * handle the core player notification , can attach more functionality
         * executed before updating the wait mode. Because the notification should trickle down
         *
         * @param {*} newCorePlayerWaitMode
         * @memberof BaseSingleClipController
         */

    }, {
        key: '_handleCorePlayerWaitMode',
        value: function _handleCorePlayerWaitMode(newCorePlayerWaitMode) {}

        /**
         * handles the self controller wait mode updates , can add more functionality
         * executed after updating self wait mode. Because the notification should bubble up
         *
         * @memberof BaseSingleClipController
         */

    }, {
        key: '_handleUpdateWaitMode',
        value: function _handleUpdateWaitMode(newWaitMode, oldWaitMode) {}
    }]);

    return BaseSingleClipController;
}();

exports.default = BaseSingleClipController;

},{"../../common/constants/SolidImage":66,"../components/ClipBoxCover.react":8,"../utils/TimeUtils":89,"./enums/PlaybackState":96,"./enums/WaitMode":100,"events":629,"react":1107,"react-dom":1016}],71:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _RangedValue = require('./RangedValue');

var _RangedValue2 = _interopRequireDefault(_RangedValue);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var areColorsEqual = function areColorsEqual(c1, c2) {
    var cc1 = (0, _color2.default)(c1);
    var cc2 = (0, _color2.default)(c2);
    if (cc1.valpha !== cc2.valpha) {
        return false;
    }
    return cc1.hex().toString() === cc2.hex().toString();
};

var ColorRange = function () {
    function ColorRange() {
        var textColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000';

        _classCallCheck(this, ColorRange);

        var _textColor$split = textColor.split('$$$'),
            _textColor$split2 = _slicedToArray(_textColor$split, 2),
            defaultColor = _textColor$split2[0],
            _textColor$split2$ = _textColor$split2[1],
            colorRange = _textColor$split2$ === undefined ? '[]' : _textColor$split2$;

        this.rangedValue = new _RangedValue2.default(colorRange, 'color', areColorsEqual);
        this.defaultColor = defaultColor;
    }

    _createClass(ColorRange, [{
        key: 'insertAtIndex',
        value: function insertAtIndex(index) {
            this.rangedValue.insertAtIndex(index);
        }
    }, {
        key: 'removeAtIndex',
        value: function removeAtIndex(index) {
            this.rangedValue.removeAtIndex(index);
        }
    }, {
        key: 'getSelectionColors',
        value: function getSelectionColors() {
            var _this = this;

            var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            // selection - start is inclusive, end is not

            if (this.rangedValue.empty) {
                return [this.defaultColor];
            }

            var colorsUsed = [];

            if (!selection) {
                selection = { start: 0, end: this.rangedValue.length };
            }

            if (selection.start === selection.end) {
                // Not selection
                colorsUsed.push(this.getColorForIndex(selection.start - 1));
            } else {
                this.rangedValue.forEachIndex({ start: selection.start, end: selection.end - 1 }, function (color) {
                    if (!color) {
                        color = _this.defaultColor;
                    }

                    if (!colorsUsed.find(function (c) {
                        return areColorsEqual(c, color);
                    })) {
                        colorsUsed.push(color);
                    }
                });
            }

            return colorsUsed.map(function (c) {
                return _this.convertToHex(c);
            });
        }
    }, {
        key: 'getCueBackground',
        value: function getCueBackground() {
            return this._getPickerGradient(this.getSelectionColors());
        }
    }, {
        key: '_getPickerGradient',
        value: function _getPickerGradient(colors) {
            colors = colors.map(function (c) {
                return (0, _color2.default)(c).hex();
            });

            var percentPerColor = 100 / colors.length;

            var linearGrad = colors.reduce(function (p, c, ci) {
                return p + ', ' + c + ' ' + ci * percentPerColor + '%, ' + c + ' ' + (ci + 1) * percentPerColor + '%';
            }, 'linear-gradient(to right');

            linearGrad += ')';

            return linearGrad;
        }
    }, {
        key: 'getColorForIndex',
        value: function getColorForIndex(index) {
            return this.rangedValue.getValueForIndex(index) || this.defaultColor;
        }
    }, {
        key: 'addColor',
        value: function addColor(color, currentFocus) {
            var start = currentFocus.start,
                end = currentFocus.end,
                length = currentFocus.length;

            this.rangedValue.setLength(length);

            var atleastOneCharSelected = start < end;
            var allCharsSelected = end - start === length;

            if (allCharsSelected) {
                this.rangedValue.resetRanges();
                this.defaultColor = color;
            } else if (atleastOneCharSelected) {
                this.rangedValue.addRange(color, start, end - 1);
            } else if (this.rangedValue.hasRangeAtIndex(start - 1)) {
                this.rangedValue.setValueForRangeAtIndex(start - 1, color);
            } else {
                this.defaultColor = color;
            }
        }
    }, {
        key: 'replaceColor',
        value: function replaceColor(targetColor, newColorVal) {
            var _this2 = this;

            var newColorValInHex = this.convertToHex(newColorVal);
            var targetColorValInHex = this.convertToHex(targetColor);

            if (areColorsEqual(this.defaultColor, targetColorValInHex)) {
                this.defaultColor = newColorValInHex;
            }

            this.rangedValue.forEachRange(function (start, end, color) {
                if (areColorsEqual(color, targetColorValInHex)) {
                    _this2.rangedValue.setValueForRangeAtIndex(start, newColorValInHex);
                }
            });
        }
    }, {
        key: 'convertToHex',
        value: function convertToHex(c) {
            return (0, _color2.default)(c).hex();
        }
    }, {
        key: 'toString',
        value: function toString() {
            var textColor = this.defaultColor;
            if (!this.rangedValue.empty) {
                textColor += '$$$' + this.rangedValue.toString();
            }
            return textColor;
        }
    }]);

    return ColorRange;
}();

exports.default = ColorRange;

},{"./RangedValue":84,"color":418}],72:[function(require,module,exports){
"use strict";

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

/**
 * Binary Searches the content based on the predicate provided
 * predicate is passed the first and last of the Two - Halves slices of list
 * finds multiple items based on a range predicate of left and right extrene elements
 *
 * @param {Array} [list=[]]
 * @param {Function<[any , any] , boolean>} [predicate=() => {}]
 * @return {*}
 */
function findItemsFromSorted() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            first = _ref2[0],
            last = _ref2[1];
    };

    if (list.length == 0) return [null, -1];

    var resultArray = [];
    var resultIndex = [];

    var slist = list;
    var leftIndex = 0;
    var rightIndex = slist.length - 1;
    while (leftIndex < rightIndex) {
        var midIndex = Math.floor(leftIndex + (rightIndex - leftIndex) / 2);

        var leftH = [slist[leftIndex], slist[midIndex]];
        var rightH = [slist[midIndex + 1], slist[rightIndex]];

        var leftHalfP = predicate(leftH);
        var rightHalfP = predicate(rightH);

        if (leftHalfP && rightHalfP) {
            break;
        }
        if (leftHalfP) {
            rightIndex = midIndex;
        } else if (rightHalfP) {
            leftIndex = midIndex + 1;
        } else return [null, -1]; // possibly unsorted list
    }

    if (predicate([slist[leftIndex], slist[rightIndex]])) {
        // check if slist is 1 then make sure predicate suffices
        for (var i = leftIndex; i <= rightIndex; i++) {
            resultArray.push(slist[i]);
            resultIndex.push(i);
        }
        // console.log([resultArray , resultIndex])
        return [resultArray, resultIndex];
    } else return [null, -1]; // return null if it doesnt
}

var clamp = function clamp(value, max, min) {
    return Math.min(Math.max(value, min), max);
};

function findItems() {
    var targetArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var toFind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (t, f) {
        return t === f;
    };

    var items = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = targetArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var target = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = toFind[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var id = _step2.value;

                    if (comparator(target, id)) items.push(target);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return items;
}
var truncateDecimal = function truncateDecimal(value, afterDecimal) {
    value = Math.round(value * Math.pow(10, afterDecimal)) / Math.pow(10, afterDecimal);
    return value;
};

module.exports = {
    findItemsFromSorted: findItemsFromSorted,
    clamp: clamp,
    findItems: findItems,
    truncateDecimal: truncateDecimal
};

},{}],73:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();
// import _ from 'lodash'


exports.createClipController = createClipController;

var _events = require('events');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _cloneextend = require('cloneextend');

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _ResizeSensor = require('css-element-queries/src/ResizeSensor');

var _ResizeSensor2 = _interopRequireDefault(_ResizeSensor);

var _GeneralUtils = require('./GeneralUtils');

var _WaitMode = require('./enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _PlaybackState = require('./enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _SingleVideoClipController = require('./SingleVideoClipController');

var _SingleVideoClipController2 = _interopRequireDefault(_SingleVideoClipController);

var _SingleImageClipController = require('./SingleImageClipController');

var _SingleImageClipController2 = _interopRequireDefault(_SingleImageClipController);

var _AudioController = require('./AudioController');

var _AudioController2 = _interopRequireDefault(_AudioController);

var _TimeUtils = require('./TimeUtils');

var _ReelHelpers = require('./ReelHelpers');

var ReelHelpers = _interopRequireWildcard(_ReelHelpers);

var _FramePaddingBox = require('../components/FramePaddingBox.react');

var _FramePaddingBox2 = _interopRequireDefault(_FramePaddingBox);

var _SingleCompositeClipController = require('./SingleCompositeClipController');

var _SingleCompositeClipController2 = _interopRequireDefault(_SingleCompositeClipController);

var _Player = require('../constants/Player');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var EV_WAIT_MODE_CHANGE = 'EV_WAIT_MODE_CHANGE';
var EV_PLAYBACK_STATE_CHANGE = 'EV_PLAYBACK_STATE_CHANGE';
var EV_CURRENT_TIME_CHANGE = 'EV_CURRENT_TIME_CHANGE';
var EV_DURATION_CHANGE = 'EV_DURATION_CHANGE';
var EV_CLIP_CHANGE = 'EV_CLIP_CHANGE';

var CLIP_SEEK_DEBOUNCE = 16;

var LABEL_UPDATE_UNIT_TIMEOUT = 5; // fps based time

var clipValue = function clipValue(value, max, min) {
    return Math.min(Math.max(value, min), max);
};

function createClipController(clipItem) {
    var clipType = clipItem.clipType;

    if (clipType === 'video') {
        return new _SingleVideoClipController2.default();
    }
    if (clipType === 'image') {
        return new _SingleImageClipController2.default();
    }
    if (clipType === 'composite') {
        if (!clipItem.childClips || clipItem.childClips.length === 0) {
            throw new Error('Composite clip initialized with 0 child clip, illegal ops');
        }
        var allClipControllers = clipItem.childClips.map(function (clip) {
            return createClipController(clip);
        });
        return new _SingleCompositeClipController2.default(allClipControllers);
    }
    throw new Error('[John Oliver] says Hwott are you even tohking about?');
}

function createFrameBox() {
    return window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden').css('zIndex', 9999);
}

var CorePlayerController = function () {
    function CorePlayerController() {
        var _this = this;

        _classCallCheck(this, CorePlayerController);

        this._fireTimeDataReset = function () {
            _this._updateAllVolumes();
            // We need to update labels
            _this._updateAllLabelsAndCallbacks();

            _this._fireDurationChange();

            _this._fireCurrentTimeChange();
        };

        this._disableClipChangeCallbackGuard = function () {
            var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            var executeWithNoGuardStatement = false;

            if (!_this._insideDisableClipChangeCallbackGuard) {
                _this._insideDisableClipChangeCallbackGuard = true;
            } else {
                executeWithNoGuardStatement = true;
            }

            if (executeWithNoGuardStatement) {
                fn(); // when the guard function is called inside the guard function again
            } else {
                _this._disableClipChangeCallback = true;

                fn();

                _this._disableClipChangeCallback = false;

                _this._insideDisableClipChangeCallbackGuard = false;
            }
        };

        this.__clipSeek = function (newTime) {
            _this._disableClipChangeCallbackGuard(function () {
                var newClipControllers = _this._clipControllersOnTime(newTime);
                var newClipIds = _this._clipIdsOnTime(newTime);

                // calc the relative time within the clip. Will need to pass this value to the new clip controller
                // const newClipRelativeTime = newTime - this._durationUntilClip(newClipController.clipId)

                // If the current and new controllers aren't the same, we have to make the switch
                if (!_this._arraysEqual(_this._currentClipIds, newClipIds)) {
                    // Pause the current clips
                    // currentClipControllers.forEach(cc => cc.doPause)

                    // switch the active clips
                    _this._changeCurrentClips(newTime);

                    // // Let's also seek all the controllers after the new index to their 0 times
                    // // since if the user plays back from the new seek position, it's best to have those frames ready
                    // TODO evaluate this frame being ready logic
                    // Object.values(this._clipControllers)
                    //     .filter((cc) => !newClipIds.includes(cc.clipId))
                    //     .forEach((cc) => cc.doSeek(0));
                }

                // Seek the new clip to the relative time we calculated earlier
                newClipControllers.forEach(function (cc) {
                    var seekToTime = Math.max(0, newTime - cc.enterStartWithTransition());
                    cc.doSeek(seekToTime);
                });

                if (_this.addedAudio) {
                    _this._audioController.doSeek(newTime);
                }
            });
        };

        this._timeline = new window.TimelineMax({ paused: true });
        this._timeline.set({}, {}, 100000); // High value

        this._emitter = new _events.EventEmitter();

        this.waitMode = _WaitMode2.default.LOADING;
        this.playbackState = _PlaybackState2.default.PAUSED;

        this._videoNodeContainer = null;
        this._canvas = null;
        this._frameType = '';
        this._customFormat = {};
        this._frameColor = '#000';

        this._currentClipIndex = -1;
        this._volume = 0;
        this._volumeMode = 'project';

        this.isCropping = false;
        this.croppingClipId = null;

        this.addedAudio = false;

        this._disableClipChangeCallback = false;

        this._videoDurationLimit = -1;

        window.timeline = this._timeline;

        // costly call
        // this._updateAllLabelsAndCallbacks = debounce(
        //     this._updateAllLabelsAndCallbacks.bind(this),
        //     LABEL_UPDATE_UNIT_TIMEOUT
        // ); // timing will be dynamic

        // THROTTLED SINCE THIS UPDATE NEED NOT BE DONE FREQUENTLY
        this._onTimer = (0, _throttle2.default)(this._onTimer.bind(this), _Player.TIMER_UPDATE_INTERVAL);
    }

    // called once when component is mounted
    /**
     * Attach Video called on the first load of the script , attaches the existing
     * video controllers
     *
     * @param {HTMLElement} videoNodeContainerEl
     * @param {Object} initialReel
     * @param {Object} [customFormat={}]
     * @memberof CorePlayerController
     */

    _createClass(CorePlayerController, [{
        key: 'attachVideo',
        value: function attachVideo(videoNodeContainerEl, initialReel) {
            var _this2 = this;

            var customFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            this._videoNodeContainer = window.$(videoNodeContainerEl);

            this.frameBoxEl = createFrameBox();

            this._videoNodeContainer.append(this.frameBoxEl);

            var clips = (0, _cloneextend.clone)(initialReel.clips);
            var audioClip = initialReel.audioClip;

            this._currentClipIndex = -1;

            this._currentClipIds = [];

            this._volume = initialReel.volume;
            this._volumeMode = initialReel.volumeMode;
            this._canvas = initialReel.canvas;
            this._frameType = initialReel.frameType;
            this._customFormat = customFormat;
            this._frameColor = initialReel.frameColor;
            this._videoDurationLimit = initialReel.isVideoDurationLimited ? initialReel.videoDurationLimit : -1;

            // testing code
            // const compositeClips = clips.map((clip , index) => {
            //     const prevClips =  clone(clips).splice(0 , index)
            //     const enterTime =ReelHelpers.getReelLastExitDone(prevClips)
            //     const prevOffSet = ReelHelpers.getTotalTimeOffset(prevClips)
            //     const composite = ReelHelpers.createNewCompositeClip([clone(clip)] , enterTime , prevOffSet)
            //     composite.clipBox = {...(this._canvas) , x:0 , y:0}
            //     composite.isSelected = false
            //     return composite
            // })

            // const compositeClips = ReelHelpers.createNewCompositeClip(clone(clips) , 0 , 0)
            // compositeClips.transitions['enter'] = clips[0].transitions['enter']
            // compositeClips.transitions['exit'] = clips[clips.length -1].transitions['exit']
            // compositeClips.clipBox = {...(this._canvas) , x:0 , y:0}
            // compositeClips.isSelected = false

            // console.log({clips , compositeClips})
            this._initializePlayer(clips);

            if (audioClip) {
                this._initializeAudioController(audioClip);
            }

            // MOVING INSIDE TICKER
            // this._interval = setInterval(() => this._onTimer(), TIMER_UPDATE_INTERVAL); // should be put under a scheduler with microTask priority

            this._tickerSyncCallback = function () {
                return _this2._onTickerSync();
            };
            window.TweenMax.ticker.addEventListener('tick', this._tickerSyncCallback);

            // Setup the resize sensor
            this.resizeSensor = new _ResizeSensor2.default(videoNodeContainerEl, function () {
                _this2._updatePlayerDimensions();
            });

            this._updatePlayerDimensions();

            this.doSeek(0); // seek to the beggining of the video on start
        }
    }, {
        key: 'detachVideo',
        value: function detachVideo() {
            // remove the resize sensor
            if (this.resizeSensor) {
                this.resizeSensor.detach();
                this.resizeSensor = null;
            }

            window.TweenMax.ticker.removeEventListener('tick', this._tickerSyncCallback);
            this._tickerSyncCallback = null;

            this._currentClipIndex = -1;
            this._currentClipIds = [];
            this._volume = 0;

            this._destroyAudioController();

            Object.values(this._clipControllers).forEach(function (cc) {
                return cc.kill();
            });
            this._clipControllers = {};

            _reactDom2.default.unmountComponentAtNode(this.frameBoxEl.get(0));

            this._videoNodeContainer.empty();
            this._videoNodeContainer = null;

            this.waitMode = _WaitMode2.default.LOADING;
            this.playbackState = _PlaybackState2.default.PAUSED;

            clearInterval(this._interval);
            this._interval = -1;
        }
    }, {
        key: 'setClipChangeListener',
        value: function setClipChangeListener(callback) {
            this._emitter.on(EV_CLIP_CHANGE, callback);
        }
    }, {
        key: 'setWaitModeListener',
        value: function setWaitModeListener(callback) {
            this._emitter.on(EV_WAIT_MODE_CHANGE, callback);
        }
    }, {
        key: 'setPlaybackStateListener',
        value: function setPlaybackStateListener(callback) {
            this._emitter.on(EV_PLAYBACK_STATE_CHANGE, callback);
        }
    }, {
        key: 'setCurrentTimeListener',
        value: function setCurrentTimeListener(callback) {
            this._emitter.on(EV_CURRENT_TIME_CHANGE, callback);
        }
    }, {
        key: 'setDurationListener',
        value: function setDurationListener(callback) {
            this._emitter.on(EV_DURATION_CHANGE, callback);
        }
    }, {
        key: 'clearClipChangeListener',
        value: function clearClipChangeListener() {
            this._emitter.removeAllListeners(EV_CLIP_CHANGE);
        }
    }, {
        key: 'clearWaitModeListener',
        value: function clearWaitModeListener() {
            this._emitter.removeAllListeners(EV_WAIT_MODE_CHANGE);
        }
    }, {
        key: 'clearPlaybackStateListener',
        value: function clearPlaybackStateListener() {
            this._emitter.removeAllListeners(EV_PLAYBACK_STATE_CHANGE);
        }
    }, {
        key: 'clearCurrentTimeListener',
        value: function clearCurrentTimeListener() {
            this._emitter.removeAllListeners(EV_CURRENT_TIME_CHANGE);
        }
    }, {
        key: 'clearDurationListener',
        value: function clearDurationListener() {
            this._emitter.removeAllListeners(EV_DURATION_CHANGE);
        }
    }, {
        key: 'time',
        value: function time() {
            return (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
        }
    }, {
        key: 'duration',
        value: function duration() {
            if (this._videoDurationLimit > 0) {
                return Math.min(this.totalDuration(), this._videoDurationLimit);
            }
            return this.totalDuration();
        }

        /**
         * Return the actual duration of the clips playback in milliseconds.
         */

    }, {
        key: 'totalDuration',
        value: function totalDuration() {
            // const clips = Object.values(this._clipControllers).map( cc => cc.clip)
            // return getReelDuration(clips)
            // const totalDuration = Math.max.apply(Math, Object.values(this._clipControllers).map(cc => cc.exitDone() ))
            // console.log('totalDuration', totalDuration)
            var clips = this._getAllClips();
            var duration = (0, _ReelHelpers.getReelDuration)(clips);
            return duration;
            // return Object.values(this._clipControllers).reduce((p, c) => p + c.duration(), 0)
        }
    }, {
        key: 'doSetVideoDurationLimit',
        value: function doSetVideoDurationLimit(duration) {
            this._videoDurationLimit = duration;
            // We need to update labels
            this._updateAllLabelsAndCallbacks();

            this._fireDurationChange();
        }
    }, {
        key: 'doClipTimeDataUpdate',

        // TODO -- make it more generic to support Duration + Time move updates as well
        // We don't know what else feature might come up for composite clips
        value: function doClipTimeDataUpdate(clip) {
            var _this3 = this;

            this._disableClipChangeCallbackGuard(function () {
                var clipController = _this3._clipControllers[clip.clipId];

                var changeInDuration = clipController.doUpdateClipTimeData(clip);

                var adjustAfterTime = clipController.enterStartWithTransition() + 1;

                _this3._adjustClipsAfterTime(adjustAfterTime, changeInDuration);

                // duration change might mute unmute , time changes may as well
                _this3._fireTimeDataReset();
            });
        }
    }, {
        key: 'doSetSpeed',
        value: function doSetSpeed(clipId, speed) {
            var _this4 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                var clipController = _this4._clipControllers[clipId];

                var adjustAfterTime = clipController.enterStartWithTransition() + 1;

                var changeInDuration = clipController.doSetSpeed(speed);

                _this4._adjustClipsAfterTime(adjustAfterTime, changeInDuration);

                // Speed changes might mute/unmute certain clips
                _this4._fireTimeDataReset();
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doSetVolumeMode',
        value: function doSetVolumeMode(volumeMode) {
            this._volumeMode = volumeMode;
            this._updateAllVolumes();
        }
    }, {
        key: 'doUpdateClip',
        value: function doUpdateClip(clip) {
            var clips = Array.isArray(clip) ? clip : [clip];

            for (var i = 0; i < clips.length; i++) {
                this._clipControllers[clips[i].clipId].doUpdateClip(clips[i]);
            }

            // Speed changes might mute/unmute certain clips
            this._updateAllVolumes();

            this._updatePlayerDimensions();
        }
    }, {
        key: 'doSetCropping',
        value: function doSetCropping(isCropping, clipId) {
            if (this.isCropping === isCropping) {
                return;
            }
            var wasCropping = this.isCropping;
            var willBeCropping = isCropping;

            if (wasCropping && !willBeCropping) {
                var controller = this._clipControllers[this.croppingClipId];
                controller.setCropping(false);
            } else if (!wasCropping && willBeCropping) {
                var _controller = this._clipControllers[clipId];
                _controller.setCropping(true);
            }

            this.isCropping = isCropping;
            this.croppingClipId = clipId;

            this._updateFrameBox();
        }
    }, {
        key: 'doSetVolume',
        value: function doSetVolume(volume) {
            this._volume = volume;
            this._updateAllVolumes();
        }
    }, {
        key: 'doUpdateAudio',
        value: function doUpdateAudio(newAudioClip) {
            if (this.addedAudio) {
                this._audioController.doUpdateClip(newAudioClip);
                this._updateAllVolumes();
            }
        }
    }, {
        key: 'doReelChangeFrame',
        value: function doReelChangeFrame(canvas, frameType) {
            var customFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            this._canvas = canvas;
            this._frameType = frameType;
            this._customFormat = customFormat;

            Object.values(this._clipControllers).forEach(function (cc) {
                return cc.doUpdateCanvas(canvas);
            });

            this._updatePlayerDimensions();
        }
    }, {
        key: 'doReelChangeFrameColor',
        value: function doReelChangeFrameColor(frameColor) {
            this._frameColor = frameColor;

            this._updateFrameBox();
        }
    }, {
        key: 'doPlay',
        value: function doPlay() {
            var _this5 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                var currentClipControllers = _this5._currentClipControllers();

                if (_this5.playbackState === _PlaybackState2.default.PLAYING) {
                    // Awesome. Already in play state. Although one wonders who's asking.
                } else if (_this5.playbackState === _PlaybackState2.default.PAUSED) {
                    if (_this5.addedAudio) {
                        _this5._audioController.doPlay();
                    }
                    currentClipControllers.forEach(function (ccc) {
                        return ccc.doPlay();
                    });
                    _this5._updatePlaybackState(_PlaybackState2.default.PLAYING);
                } else if (_this5.playbackState === _PlaybackState2.default.ENDED) {
                    // Sitting pretty at the end. We gotta switch back up front.

                    // this._changeCurrentClipIndex(0);

                    var newTime = 0;

                    _this5._changeCurrentClips(newTime);

                    _this5._timeline.time((0, _TimeUtils._toGSAPtime)(newTime));

                    _this5._fireCurrentTimeChange();

                    // Seek every other clip to it's zero
                    // for (let i = 0; i < Object.values(this._clipControllers).length; i++) {
                    // }
                    Object.values(_this5._clipControllers).forEach(function (cc) {
                        return cc.doSeek(newTime);
                    });

                    // Start playing first clip
                    _this5._clipControllersOnTime(newTime).forEach(function (cc) {
                        return cc.doPlay();
                    });

                    // Play audio from start
                    if (_this5.addedAudio) {
                        _this5._audioController.doSeek(newTime);
                        _this5._audioController.doPlay();
                    }
                    _this5._updatePlaybackState(_PlaybackState2.default.PLAYING);
                }
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doPause',
        value: function doPause() {
            var _this6 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                var currentClipControllers = _this6._currentClipControllers();

                if (_this6.playbackState === _PlaybackState2.default.PLAYING) {
                    if (_this6.addedAudio) {
                        _this6._audioController.doPause();
                    }
                    Object.values(_this6._clipControllers).forEach(function (cc) {
                        return cc.doPause();
                    });
                    // currentClipControllers.forEach(cc => cc.doPause());
                    _this6._updatePlaybackState(_PlaybackState2.default.PAUSED);
                } else if (_this6.playbackState === _PlaybackState2.default.PAUSED) {
                    // Awesome. Already paused. Although one wonders who's asking.
                } else if (_this6.playbackState === _PlaybackState2.default.ENDED) {
                    // Ignore
                }
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doSeek',
        value: function doSeek(time) {
            var _this7 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                _this7.doPause(); // Keeping it above since , disableClipChangeCallback is used internall
                // TODO - find better way to manage configuration context

                // This method is used to seek to a specific time of the full video without affecting playback state

                // First make a note of the current time and target time we are to seek to
                var newTime = time;

                // Note down the old playback state.
                // We need to use this later to make sure we're at the same state after the seek
                // const oldPlaybackState = this.playbackState;

                // // get the controllers we'll have to deal with.
                // // The current one and the would be controller after seeking, which is based on the time we're seeking to
                // const currentClipControllers = this._currentClipControllers();

                // Set the player timeline value to the new time
                _this7._timeline.time((0, _TimeUtils._toGSAPtime)(newTime));

                _this7._fireCurrentTimeChange();

                _this7._updateWaitMode();

                // Always pause after seek
                // newClipControllers.map(cc => cc.doPause())
                // if(this.addedAudio) {
                //     this._audioController.doPause()
                // }

                // this._updatePlaybackState(PlaybackState.PAUSED)
                // This sepparates the process of UI seek vs the actual video element Seek
                _this7.__clipSeek(newTime);

                // this._updatePlaybackState(this._inferPlaybackStateFromControllers(newClipControllers));
            });

            // this._disableClipChangeCallback = false
        }
    }, {
        key: 'doSetClipAnimType',
        value: function doSetClipAnimType(clipId, animType) {
            var controller = this._clipControllers[clipId];
            controller.doSetAnimType(animType);

            // Removed doSeek to prevent play head from moving to the front of Clip on changing animation
            // this.doSeek(time)
        }
    }, {
        key: 'doRemoveTransitions',
        value: function doRemoveTransitions(clipId) {
            var _this8 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                var clipController = _this8._clipControllers[clipId];

                if (clipController) {
                    var _getAdjacentClipIds = (0, _ReelHelpers.getAdjacentClipIds)(_this8._getAllClips(), clipId),
                        leftClipId = _getAdjacentClipIds.leftClipId,
                        rightClipId = _getAdjacentClipIds.rightClipId;

                    clipController.removeTransitions();

                    if (leftClipId) {
                        var leftClipController = _this8._clipControllers[leftClipId];
                        leftClipController.removeTransitions('exit');
                    }

                    if (rightClipId) {
                        var rightClipController = _this8._clipControllers[rightClipId];
                        rightClipController.removeTransitions('enter');
                    }

                    // We need to update labels
                    _this8._updateAllLabelsAndCallbacks();

                    _this8._fireDurationChange();
                }
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doSetClipTransitionType',
        value: function doSetClipTransitionType(transitionType, leftClipId, rightClipId) {
            var _this9 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                var leftClipController = _this9._clipControllers[leftClipId] || {
                    doSetTransitionType: function doSetTransitionType() {
                        console.log('first clip , cant set !!');
                    }
                };
                var rightClipController = _this9._clipControllers[rightClipId] || {
                    doSetTransitionType: function doSetTransitionType() {
                        console.log('last clip , cant set !!');
                    },
                    enterStartWithTransition: function enterStartWithTransition() {
                        console.log('last clip , cant set !!');
                    }
                };

                var _getTransitionsFromTy = (0, _ReelHelpers.getTransitionsFromTypes)(transitionType),
                    enterTransition = _getTransitionsFromTy.enterTransition,
                    exitTransition = _getTransitionsFromTy.exitTransition;

                leftClipController.doSetTransitionType('exit', exitTransition);
                rightClipController.doSetTransitionType('enter', enterTransition);

                // We need to update labels
                _this9._updateAllLabelsAndCallbacks();

                _this9._fireDurationChange();

                // const time = rightClipController.enterStartWithTransition();

                // TODO -- removing this decision should be on the action dispatcher
                // this.doSeek(time);

                _this9._updatePlayerDimensions();
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doSetAudio',
        value: function doSetAudio(audioClip) {
            this._destroyAudioController();

            this._initializeAudioController(audioClip);

            this._updateAllVolumes();

            this._updateWaitMode();
        }
    }, {
        key: 'doClearAudio',
        value: function doClearAudio() {
            this._destroyAudioController();

            this._updateAllVolumes();

            this._updateWaitMode();
        }
    }, {
        key: '_updateTimingForCostlyMethods',
        value: function _updateTimingForCostlyMethods() {
            var totalReels = Object.keys(this._clipControllers).length;
            var totalWait = totalReels * LABEL_UPDATE_UNIT_TIMEOUT;
            // this._updateAllLabelsAndCallbacks = debounce(
            //     this._updateAllLabelsAndCallbacks.bind(this),
            //     totalWait
            // );
        }
    }, {
        key: 'doReelAdd',
        value: function doReelAdd(clip) {
            var _this10 = this;

            var insertTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                _this10.doPause(); // Necessary since u don't want to add when playback is going on

                // const oldPlaybackState = this.playbackState

                var clips = Array.isArray(clip) ? clip : [clip];
                var firstClip = clips[0];
                var lastClip = clips[clips.length - 1];

                // NEED CHANGE
                var _firstClip$time = firstClip.time,
                    enterStart = _firstClip$time.enterStart,
                    _firstClip$time$prevO = _firstClip$time.prevOffset,
                    prevOffset = _firstClip$time$prevO === undefined ? 0 : _firstClip$time$prevO,
                    _firstClip$time$curre = _firstClip$time.currentOffset,
                    currentOffset = _firstClip$time$curre === undefined ? 0 : _firstClip$time$curre;
                var exitDone = lastClip.time.exitDone;

                var clipDuration = exitDone - enterStart;

                _this10._adjustClipsAfterTime(enterStart + prevOffset + currentOffset, clipDuration);

                // this._initializeClipPlayer(clip)
                clips.forEach(function (clip) {
                    _this10._initializeClipPlayer(clip);
                });

                var addTime = _this10._clipControllers[firstClip.clipId].enterStartWithTransition();

                var currentClipControllers = _this10._currentClipControllers();
                currentClipControllers.forEach(function (cc) {
                    return cc.doHide();
                }); // stop playback and hide

                _this10._updateAllLabelsAndCallbacks();

                _this10._updateTimingForCostlyMethods();

                _this10._fireDurationChange();

                _this10._changeCurrentClips(addTime);

                var newClipControllers = _this10._clipControllersOnTime(addTime);

                // this._timeline.time(_toGSAPtime(addTime));
                newClipControllers.forEach(function (cc) {
                    return cc.doSeek(0);
                });

                _this10._updateWaitMode();

                if (_this10.addedAudio) {
                    _this10._audioController.updateCorePlayerDuration(_this10.duration());
                }

                _this10._updateAllVolumes();

                _this10._updateWaitMode();
                // this._fireCurrentTimeChange();

                // TODO -- verify not needed , since it's a clip addition
                _this10._updatePlayerDimensions();

                // this.doSeek(addTime);
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doReelSplit',
        value: function doReelSplit(bsClipId, asClip, asClipDuplicate, currentTime) {
            var _this11 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                _this11.doPause();

                // This method is used to split a clip into two. It's assumed that
                // asClip.clipId will be the same as bsClipId. and asClipDuplicate is the clip
                // that's added just after the clip.
                // It's also assumed that the split happens at the current time.

                if (bsClipId !== asClip.clipId) {
                    throw new Error('Reel split needs the first clip to have the same id as replaced clip');
                }

                // bs - before split, as - after split
                // asClip - The first clip of the new clips.
                // This would have it's clipDuration to reflect the timing of the split
                // asClipDuplicate - The second of the new clips.
                // This would have a new clip id and it's clipStart and clipDuration would be based on the timing of the split

                var oldPlaybackState = _this11.playbackState;

                // The index of the first clip
                // const asClipIndex = this._playerIndexForId(bsClipId)

                // We can reuse the previous controller (of the clip being replaced) and just update the clip bounds
                var asClipController = _this11._clipControllers[bsClipId];
                asClipController.doChangeClipBounds({
                    clipStart: asClip.clipStart,
                    clipDuration: asClip.clipDuration,
                    time: asClip.time,
                    transitions: asClip.transitions
                });

                // Now we need to add a new controller for the second clip
                _this11._initializeClipPlayer(asClipDuplicate);

                // We need to update labels
                _this11._updateAllLabelsAndCallbacks();

                _this11._fireDurationChange();

                _this11._updateAllVolumes();

                // At this point, the current clip index might still be the first of the two clips.
                // But we may very well set the current clip to be the second clip to avoid having to switch clips
                // just after the user starts playing.
                // So, let's set the second of the new clips as the current clip and seek to its starting time
                // const newCurrentClipIndex = asClipIndex + 1

                // this.doSeek(currentTime);

                _this11._disableClipChangeCallback = true; // reseting to true because doSeek will set it to false

                // We just added a new clip - it would definitely be in loading,
                // so let's set the player wait mode also to be LOADING
                _this11._updateWaitMode();
                // this._updatePlaybackState(PlaybackState.PAUSED)

                _this11._updatePlayerDimensions();
            });

            // Pause playback

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doReelRemove',
        value: function doReelRemove(clip) {
            var _this12 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                var clips = Array.isArray(clip) ? clip : [clip];

                var firstClip = clips[0];
                var lastClip = clips[clips.length - 1];

                var time = _this12._clipControllers[firstClip.clipId].enterStartWithTransition();

                var totalDuration = 0;
                // Get the current index of the clip we're deleting
                // const delClipIndex = this._playerIndexForId(clipId)

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = clips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _clip = _step.value;

                        var deletedClipController = _this12._clipControllers[_clip.clipId];
                        var clipDuration = deletedClipController.duration();
                        delete _this12._clipControllers[_clip.clipId];
                        deletedClipController.kill();

                        totalDuration += clipDuration;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this12._adjustClipsAfterTime(time, -totalDuration);

                _this12._updateAllLabelsAndCallbacks();

                _this12._updateTimingForCostlyMethods();

                _this12._fireDurationChange();

                if (_this12.addedAudio) {
                    _this12._audioController.updateCorePlayerDuration(_this12.duration());
                }

                // We definitely updated this
                // this._fireCurrentTimeChange();

                _this12._updateAllVolumes();

                // Pause the playback as the current clip is deleted
                // this._updatePlaybackState(newPlaybackState);
                _this12._updateWaitMode();

                // this.doSeek(time);
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: '_getAllClips',
        value: function _getAllClips() {
            return Object.values(this._clipControllers).map(function (cc) {
                return cc.clip;
            });
        }
    }, {
        key: 'doReelMove',
        value: function doReelMove(clipId, newIndex) {
            var _this13 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                // This method is used to change the position of the clip referred by clipId.
                // The newIndex is the position of the clip after the move

                // Save previous playback state
                // const oldPlaybackState = this.playbackState;

                var currentTime = _this13.time();

                // const currentClips = this._clipControllers
                // const allClips = this._getAllClips()
                // currentClips.sort((a, b) => a.enterStart - b.enterStart);

                var newClips = (0, _ReelHelpers.moveClip)(_this13._getAllClips(), clipId, newIndex);

                // const currentPlaybackRelativeTime = this.time() - this._currentClipControllers()[0]

                newClips.forEach(function (c, i) {
                    return _this13._clipControllers[c.clipId].doUpdateClip(c, i + 1);
                });

                // console.log(Object.values(this._clipControllers).map( cc => cc.clip ))
                // Add the labels and callbacks at the left and right boundaries
                _this13._updateAllLabelsAndCallbacks();
                _this13._updateAllVolumes();

                _this13._fireDurationChange();

                // if (oldPlaybackState === PlaybackState.ENDED
                //     && this._currentClipIndex !== (Object.values(this._clipControllers).length - 1)) {

                //     this._updatePlaybackState(PlaybackState.PAUSED)
                // }

                // This is good to do any time we shake up the ordering of clips
                // for (let i = this._currentClipIndex + 1; i < Object.values(this._clipControllers).length; i++) {
                // }

                // Object.values(this._clipControllers).map(cc => {
                //     if(cc.enterStart > currentTime)
                //         cc.doSeek(0)
                // });

                // this._changeCurrentClips(currentTime)

                // this._timeline.time(_toGSAPtime(currentTime))

                // const currentClipControllers = this._currentClipControllers()

                // currentClipControllers.forEach(cc => cc.doSeek(currentTime - cc.enterStart()))

                // We definitely updated this
                // this._fireCurrentTimeChange();

                // Why not
                // this._updateWaitMode()
                // this._updatePlaybackState(Object.values(this._clipControllers)[this._currentClipIndex].playbackState);
                // this._updatePlaybackState(oldPlaybackState)

                // TODO - disabling seek because a move does not requires this
                // Move need not do a seek. There is no change in currentTime
                // this.doSeek(currentTime);

                // Note down the clipId that was playing
                // Save relative time w.r.t current playing clip

                // const playingClipId = Object.values(this._clipControllers)[this._currentClipIndex].clipId

                // const playingClipRelTime = this.time() - this._durationUntilClip(playingClipId)

                // Get the current index of the clip we're moving
                // const moveClipOldIndex = this._playerIndexForId(clipId)

                // Remove the controller from the list
                // const [ moveClipController ] = Object.values(this._clipControllers).splice(moveClipOldIndex, 1)

                // Add it at the new index
                // Object.values(this._clipControllers).splice(newIndex, 0, moveClipController)

                // update the current clip index to the one that was playing.
                // We already know that this is visible, so we don't need to use this._changeCurrentClipIndex()
                // this._currentClipIndex = this._playerIndexForId(playingClipId)

                // Update the global time to the new time of the frame that was playing before the move

                // In case the playback was ENDED before but after the move the playing clip isn't at the end anymore
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'doReelTrim',
        value: function doReelTrim(clipId, newClipStart, newClipDuration, newTime) {
            var _this14 = this;

            // this._disableClipChangeCallback = true;

            this._disableClipChangeCallbackGuard(function () {
                // This method is used to trim a certain clip to new bounds

                // Pause playback
                _this14.doPause(); // needed

                // Get the clip index and controller
                // const clipIndex = this._playerIndexForId(clipId)
                var clipController = _this14._clipControllers[clipId];

                var adjustmentOffset = newTime.exitDone - clipController.exitDone();
                var adjustAfterTime = clipController.enterStartWithTransition() + 1;

                // const currentClipId = currentClipController.clipId
                // let currentClipAbsTime = this.time() - this._durationUntilClip(currentClipId)
                //     + currentClipController.clipStart

                // Update the clip bounds
                clipController.doChangeClipBounds({
                    clipStart: newClipStart,
                    clipDuration: newClipDuration,
                    time: newTime
                });

                _this14._adjustClipsAfterTime(adjustAfterTime, adjustmentOffset);

                var currentTime = _this14.time();

                _this14._changeCurrentClips(currentTime);

                _this14._updateAllLabelsAndCallbacks(); // does the duration change as well

                if (_this14.addedAudio) {
                    _this14._audioController.updateCorePlayerDuration(_this14.duration());
                }

                _this14._updateAllVolumes();

                _this14._fireDurationChange();

                _this14._updateWaitMode();

                _this14.doSeek(currentTime);
                // This seek is needed otherwise the seek from Video makes the play head Jump
                // Since the trim causes the Video to also do seek
            });

            // this._disableClipChangeCallback = false;
        }
    }, {
        key: 'addChildTimeline',
        value: function addChildTimeline(timeline) {
            this._timeline.add(timeline, (0, _TimeUtils._toGSAPtime)(0));

            this._timeline.render(this._timeline.time(), false, true);
        }
    }, {
        key: 'removeChildTimeline',
        value: function removeChildTimeline(timeline) {
            this._timeline.remove(timeline);

            this._timeline.render(this._timeline.time(), false, true);
        }
    }, {
        key: 'forceRender',
        value: function forceRender() {
            this._timeline.render(this._timeline.time(), false, true);
        }

        /* All intended private stuff */

    }, {
        key: '_initializePlayer',
        value: function _initializePlayer(clips) {
            var _this15 = this;

            this._clipControllers = {};

            // currently not changing the timing information
            // we will only experiment with sending the data to first clip

            clips.forEach(function (cc) {
                _this15._initializeClipPlayer(cc);
            });

            // Set the timeline extent to a very high value
            // Note that we won't be using the onComplete callback from timelinemax
            this._timeline.set({}, {}, 1000000); // Make sure the timeline is long enough

            this._updateTimingForCostlyMethods();

            this._updateAllLabelsAndCallbacks();

            this._updateAllVolumes();

            this._fireDurationChange();

            // Show first player
            // this._changeCurrentClipIndex(0);
            this._changeCurrentClips(0);

            // const this._currentClipControllers().map(cc => cc.doPause())
            // const currentClipController = Object.values(this._clipControllers)[this._currentClipIndex];

            this._updateWaitMode();
            this._updatePlaybackState(this._inferPlaybackStateFromControllers(this._currentClipControllers()));

            this._fireCurrentTimeChange();
        }
    }, {
        key: '_initializeMultipleClipPlayer',
        value: function _initializeMultipleClipPlayer() {
            var _this16 = this;

            var multipleInputClip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var clips = multipleInputClip;
            clips.forEach(function (clip) {
                _this16._initializeClipPlayer(clip);
            });
        }
    }, {
        key: '_initializeClipPlayer',
        value: function _initializeClipPlayer(inputClip) {
            var _this17 = this;

            // const clip = _.cloneDeep(inputClip) // overdoing mutation
            var clip = inputClip;
            var clipController = createClipController(clip);

            var clipWidth = -1;
            var clipHeight = -1;
            var extraParams = {};
            if (clip.clipType === 'video') {
                var _clip$clipVideo = clip.clipVideo,
                    _clip$clipVideo$dashU = _clip$clipVideo.dashUrl,
                    dashUrl = _clip$clipVideo$dashU === undefined ? '' : _clip$clipVideo$dashU,
                    width = _clip$clipVideo.width,
                    height = _clip$clipVideo.height,
                    _clip$clipVideo$canPl = _clip$clipVideo.canPlay,
                    canPlay = _clip$clipVideo$canPl === undefined ? true : _clip$clipVideo$canPl,
                    _clip$clipVideo$isOff = _clip$clipVideo.isOffline,
                    isOffline = _clip$clipVideo$isOff === undefined ? false : _clip$clipVideo$isOff,
                    _clip$clipVideo$isUse = _clip$clipVideo.isUserSpace,
                    isUserSpace = _clip$clipVideo$isUse === undefined ? false : _clip$clipVideo$isUse,
                    _clip$clipVideo$userS = _clip$clipVideo.userSpaceUrl,
                    userSpaceUrl = _clip$clipVideo$userS === undefined ? '' : _clip$clipVideo$userS,
                    _clip$clipVideo$delet = _clip$clipVideo.deleted,
                    deleted = _clip$clipVideo$delet === undefined ? false : _clip$clipVideo$delet,
                    _clip$clipVideo$origi = _clip$clipVideo.originalFileName,
                    originalFileName = _clip$clipVideo$origi === undefined ? '' : _clip$clipVideo$origi,
                    _clip$clipVideo$snaps = _clip$clipVideo.snapshotUrl,
                    snapshotUrl = _clip$clipVideo$snaps === undefined ? '' : _clip$clipVideo$snaps,
                    _clip$clipVideo$uploa = _clip$clipVideo.uploadFailedPlaceholder,
                    uploadFailedPlaceholder = _clip$clipVideo$uploa === undefined ? false : _clip$clipVideo$uploa;
                var _clip$speed = clip.speed,
                    speed = _clip$speed === undefined ? 1 : _clip$speed,
                    clipVolume = clip.clipVolume,
                    musicVolume = clip.musicVolume;

                clipWidth = width;
                clipHeight = height;

                extraParams = {
                    clipStart: clip.clipStart,
                    clipDuration: clip.clipDuration,
                    time: clip.time,
                    transitions: JSON.parse(JSON.stringify(clip.transitions || {})),
                    clipDashUrl: dashUrl,
                    clipVolume: clipVolume,
                    musicVolume: musicVolume,
                    speed: speed,

                    /// New userSpace data --
                    canPlay: canPlay,
                    isOffline: isOffline,
                    isUserSpace: isUserSpace,
                    userSpaceUrl: userSpaceUrl,
                    deleted: deleted,
                    uploadFailedPlaceholder: uploadFailedPlaceholder,
                    originalFileName: originalFileName,
                    snapshotUrl: snapshotUrl
                };
            } else if (clip.clipType === 'image') {
                var _clip$clipImage = clip.clipImage,
                    previewUrl = _clip$clipImage.previewUrl,
                    fullPngUrl = _clip$clipImage.fullPngUrl,
                    _width = _clip$clipImage.width,
                    _height = _clip$clipImage.height,
                    _clip$clipImage$canPl = _clip$clipImage.canPlay,
                    _canPlay = _clip$clipImage$canPl === undefined ? true : _clip$clipImage$canPl,
                    _clip$clipImage$isOff = _clip$clipImage.isOffline,
                    _isOffline = _clip$clipImage$isOff === undefined ? false : _clip$clipImage$isOff,
                    _clip$clipImage$isUse = _clip$clipImage.isUserSpace,
                    _isUserSpace = _clip$clipImage$isUse === undefined ? false : _clip$clipImage$isUse,
                    _clip$clipImage$userS = _clip$clipImage.userSpaceUrl,
                    _userSpaceUrl = _clip$clipImage$userS === undefined ? '' : _clip$clipImage$userS,
                    _clip$clipImage$delet = _clip$clipImage.deleted,
                    _deleted = _clip$clipImage$delet === undefined ? false : _clip$clipImage$delet,
                    _clip$clipImage$origi = _clip$clipImage.originalFileName,
                    _originalFileName = _clip$clipImage$origi === undefined ? '' : _clip$clipImage$origi,
                    _clip$clipImage$snaps = _clip$clipImage.snapshotUrl,
                    _snapshotUrl = _clip$clipImage$snaps === undefined ? '' : _clip$clipImage$snaps,
                    _clip$clipImage$uploa = _clip$clipImage.uploadFailedPlaceholder,
                    _uploadFailedPlaceholder = _clip$clipImage$uploa === undefined ? false : _clip$clipImage$uploa;

                var clipAnimType = clip.clipAnimType,
                    _musicVolume = clip.musicVolume;

                clipWidth = _width;
                clipHeight = _height;

                extraParams = {
                    clipDuration: clip.clipDuration,
                    time: clip.time,
                    transitions: JSON.parse(JSON.stringify(clip.transitions || {})),
                    clipPreviewUrl: window.RENDER_MODE ? fullPngUrl : previewUrl,
                    clipAnimType: clipAnimType,
                    musicVolume: _musicVolume,
                    bgColor: clip.solidImageColor ? clip.solidImageColor : undefined,

                    // New user space data
                    canPlay: _canPlay,
                    isOffline: _isOffline,
                    isUserSpace: _isUserSpace,
                    userSpaceUrl: _userSpaceUrl,
                    deleted: _deleted,
                    originalFileName: _originalFileName,
                    uploadFailedPlaceholder: _uploadFailedPlaceholder,
                    snapshotUrl: _snapshotUrl
                };
            } else if (clip.clipType === 'composite') {
                var _clip$speed2 = clip.speed,
                    _speed = _clip$speed2 === undefined ? 1 : _clip$speed2,
                    _clipVolume = clip.clipVolume,
                    _musicVolume2 = clip.musicVolume,
                    _clip$deleted = clip.deleted,
                    _deleted2 = _clip$deleted === undefined ? false : _clip$deleted,
                    _clip$name = clip.name,
                    name = _clip$name === undefined ? '' : _clip$name,
                    _snapshotUrl2 = clip.snapshotUrl;

                extraParams = {
                    clipStart: clip.clipStart,
                    clipDuration: clip.clipDuration,
                    time: clip.time,
                    transitions: JSON.parse(JSON.stringify(clip.transitions || {})),
                    musicVolume: _musicVolume2,
                    clipVolume: _clipVolume,
                    speed: _speed,
                    deleted: _deleted2,
                    name: name,
                    originalFileName: name,
                    snapshotUrl: _snapshotUrl2
                };
            } else {
                throw new Error('Unknown clip type: ' + clip.clipType + ' ');
            }

            clipController.createDisplayElement(clip.clipId);
            if (clip.hidePadding) {
                clipController.getContainerEl().css('zIndex', 9999);
            }
            this._videoNodeContainer.append(clipController.getContainerEl());

            clipController.attach(clip, this._canvas, clip.clipType, clip.clipId, clipWidth, clipHeight, extraParams);

            clipController.addWaitModeListener(function () {
                return _this17._onClipWaitModeChange(clip.clipId);
            });
            clipController.addPlaybackStateListener(function () {
                return _this17._onClipPlaybackStateChange(clip.clipId);
            });

            this._clipControllers[clip.clipId] = clipController;
            // this._currentClipIds.push(clip.clipId)
            // if (insertIndex === -1) {
            //     Object.values().push(clipController);
            // } else {
            //     Object.values(this._clipControllers).splice(insertIndex, 0, clipController);
            // }
        }
    }, {
        key: '_initializeAudioController',
        value: function _initializeAudioController(audioClip) {
            var _this18 = this;

            if (this.addedAudio) {
                return;
            }

            var newAudio = {
                id: audioClip.clipId,
                duration: audioClip.clipDuration
            };

            if (audioClip.clipAudio) {
                newAudio.previewUrl = audioClip.clipAudio.previewUrl;
            }

            var newAudioNodeEl = this._createNewAudioNode(newAudio.id);
            this._audioController = new _AudioController2.default();

            this._audioController.audioClip = audioClip;

            this._audioController.attachAudio(audioClip, window.$(newAudioNodeEl).find('audio').get(0), newAudio.previewUrl, newAudio.duration, this.duration());

            this.addedAudio = true;

            this._audioController.setWaitModeListener(function () {
                return _this18._onAudioWaitModeChange();
            });

            this._audioController.doSeek(this.time());

            this._updateAllVolumes();

            this._updateWaitMode();

            if (this.playbackState === _PlaybackState2.default.PLAYING) {
                this._audioController.doPlay();
            } else if (this.playbackState === _PlaybackState2.default.PAUSED) {
                this._audioController.doPause();
            }
        }
    }, {
        key: '_destroyAudioController',
        value: function _destroyAudioController() {
            if (!this.addedAudio) {
                return;
            }

            this._audioController.clearWaitModeListener();
            this._audioController.detachAudio();
            this._audioController = null;

            this.addedAudio = false;

            this._updateWaitMode();
        }
    }, {
        key: '_updateFrameBox',
        value: function _updateFrameBox() {
            var canvas = this._canvas,
                frameType = this._frameType,
                frameColor = this._frameColor,
                frameBoxEl = this.frameBoxEl,
                isCropping = this.isCropping,
                customFormat = this._customFormat;

            var contentBox = (0, _ReelHelpers.getContentBox)({ canvas: canvas, frameType: frameType, customFormat: customFormat });
            // TODO -- MOve it outside , the intermingling of React and CorePlayer should be avoided
            _reactDom2.default.render(_react2.default.createElement(_FramePaddingBox2.default, {
                isCropping: isCropping,
                contentBox: contentBox,
                canvas: canvas,
                frameColor: frameColor
            }), frameBoxEl.get(0));
        }
    }, {
        key: '_updatePlayerDimensions',
        value: function _updatePlayerDimensions() {
            var _this19 = this;

            var _videoNodeContainer$g = this._videoNodeContainer.get(0),
                containerWidth = _videoNodeContainer$g.clientWidth,
                containerHeight = _videoNodeContainer$g.clientHeight;

            // const frameType = this._frameType

            this._updateFrameBox();

            Object.values(this._clipControllers).forEach(function (cc) {
                var canvas = _this19._canvas;

                var _cc$clip$clipBox = cc.clip.clipBox,
                    clipBox = _cc$clip$clipBox === undefined ? null : _cc$clip$clipBox;

                var clipElLeft = 0;
                var clipElTop = 0;
                var clipElWidth = 0;
                var clipElHeight = 0;
                var clipElRotate = 0;

                var scaleX = 1;
                var scaleY = 1;

                if (clipBox && canvas) {
                    var containerScaleX = containerWidth / canvas.width;
                    var containerScaleY = containerHeight / canvas.height;

                    clipElLeft = clipBox.x * containerScaleX;
                    clipElTop = clipBox.y * containerScaleY;
                    clipElWidth = clipBox.width / clipBox.sar * containerScaleX;
                    clipElHeight = clipBox.height * containerScaleY;
                    clipElRotate = clipBox.rotateDeg || 0;

                    scaleX = clipBox.sar;
                    scaleY = 1;
                }

                cc.applyDimensions({
                    height: clipElHeight,
                    width: clipElWidth,
                    top: clipElTop,
                    left: clipElLeft
                });

                cc.applyTranform({
                    rotateDeg: clipElRotate,
                    scaleX: scaleX,
                    scaleY: scaleY
                });
            });
        }
    }, {
        key: '_createNewAudioNode',
        value: function _createNewAudioNode(audioId) {
            var vWrapper = window.$('<div>').css('overflow', 'hidden');

            var v = window.$('<audio>').css('position', 'absolute').css('width', '0px').css('height', '0px').attr('preload', 'true').attr('id', 'audio-' + audioId);

            vWrapper.append(v);

            return vWrapper.get(0);
        }
    }, {
        key: '_activelyPlaying',
        value: function _activelyPlaying() {
            return this.waitMode === _WaitMode2.default.NONE && this.playbackState === _PlaybackState2.default.PLAYING;
        }
    }, {
        key: '_getWaitMode',
        value: function _getWaitMode() {
            // First if anything isn't loaded, the overall thing isn't loaded too
            if (this.addedAudio && this._audioController.waitMode === _WaitMode2.default.LOADING) {
                return _WaitMode2.default.LOADING;
            }

            var currentClipControllers = this._currentClipControllers();

            for (var i = 0; i < currentClipControllers.length; i++) {
                if (currentClipControllers[i].waitMode === _WaitMode2.default.LOADING) {
                    return _WaitMode2.default.LOADING;
                }
            }

            // const currentClipController = Object.values(this._clipControllers)[this._currentClipIndex]
            var videoWaitMode = this._inferWaitModeFromControllers(currentClipControllers);
            var audioWaitMode = this.addedAudio ? this._audioController.waitMode : _WaitMode2.default.NONE;

            if (videoWaitMode === _WaitMode2.default.SEEKING || audioWaitMode === _WaitMode2.default.SEEKING) {
                return _WaitMode2.default.SEEKING;
            }
            if (videoWaitMode === _WaitMode2.default.BUFFERING || audioWaitMode === _WaitMode2.default.BUFFERING) {
                return _WaitMode2.default.BUFFERING;
            }

            return _WaitMode2.default.NONE;
        }
    }, {
        key: '_fireWaitModeChange',
        value: function _fireWaitModeChange() {
            this._emitter.emit(EV_WAIT_MODE_CHANGE);
        }
    }, {
        key: '_firePlaybackStateChange',
        value: function _firePlaybackStateChange() {
            this._emitter.emit(EV_PLAYBACK_STATE_CHANGE);
        }
    }, {
        key: '_fireCurrentTimeChange',
        value: function _fireCurrentTimeChange() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var newTime = (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
            var maxTime = this._lastKnownDuration ? this._lastKnownDuration : newTime;
            newTime = clipValue(newTime, maxTime, 0);

            if ((force === true || this._lastKnownCurrentTime !== newTime) && !isNaN(newTime)) {
                this._lastKnownCurrentTime = newTime;
                this._emitter.emit(EV_CURRENT_TIME_CHANGE, newTime);
            }
        }
    }, {
        key: '_fireDurationChange',
        value: function _fireDurationChange() {
            var currentDuration = this.duration();
            if (this._lastKnownDuration !== currentDuration && !isNaN(currentDuration)) {
                this._lastKnownDuration = currentDuration;
                this._emitter.emit(EV_DURATION_CHANGE, currentDuration);
            }
        }
    }, {
        key: '_onTickerSync',
        value: function _onTickerSync() {
            if (this.waitMode === _WaitMode2.default.NONE && !this._disableClipChangeCallback && this.playbackState === _PlaybackState2.default.PLAYING) {
                // Get time from video
                var currentClipControllers = this._currentClipControllers();

                var currentClipController = currentClipControllers[currentClipControllers.length - 1];

                if (!currentClipController) {
                    return;
                }

                // const { enterStart, exitDone, currentOffset, totalOffset } = getClipTime(this._getAllClips(), currentClipController.clipId)

                // let videoTime = currentClipController.timelineTime() + enterStart + totalOffset

                var currentClipTime = currentClipController.timelineTime();
                var currentClipStartTime = currentClipController.enterStartWithTransition();

                var videoTime = currentClipTime + currentClipStartTime;

                if (this._videoDurationLimit > 0) {
                    videoTime = Math.min(this._videoDurationLimit, videoTime);
                }

                var timelineTime = (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
                var shouldSyncVideo = Math.abs(videoTime - timelineTime) > 30 || timelineTime > this.duration();

                if (shouldSyncVideo) {
                    // console.log('syncing video', 'videoTime => ',videoTime, 'timelineTime => ', timelineTime)
                    // currentClipController._timeline.seek(_toGSAPtime(timelineTime))
                    this._timeline.time((0, _TimeUtils._toGSAPtime)(videoTime));
                }
                if (this.addedAudio) {
                    // this._audioController.setVideoTime(timelineTime)
                    this._audioController.setVideoTime(videoTime);
                }

                // const shouldFadeOut = (this.duration() - timelineTime == 3000)
                // if(this.addedAudio && shouldFadeOut){
                //     this._audioController.doFadeOut()
                // }

                // const shouldSyncAudio = Math.abs(videoTime - audioTime) > 30

                // TODO - verify this once
                if (shouldSyncVideo || this.playbackState === _PlaybackState2.default.PLAYING) {
                    this._onTimer(); // Fire update if out of sync or if playing
                }
            }
        }
    }, {
        key: '_updateAllVolumes',
        value: function _updateAllVolumes() {
            var _this20 = this;

            Object.keys(this._clipControllers).forEach(function (clipId) {
                var controller = _this20._clipControllers[clipId];
                if (_this20._currentClipIds.includes(clipId)) {
                    // For current clip
                    var volume = _this20._volume;
                    // if (this._volumeMode === 'clip' && (controller.clipType === 'video' || controller.clipType === 'composite')) {
                    //     volume = controller.getSpeed() === 1 ? controller.clipVolume : 0
                    // }

                    // Removed the this._volumeMode comparison, clip volume will always be changable at clip level
                    if (controller.clipType === 'video' || controller.clipType === 'composite') {
                        volume = controller.getSpeed() === 1 ? controller.clipVolume : 0;
                    }
                    controller.doSetVolume(volume);
                } else {
                    // Mute every clip other than the current clip
                    controller.doSetVolume(0);
                }
            });
            // const currentClipControllers = this._currentClipControllers().forEach()

            if (this.addedAudio) {
                var clips = Object.values(this._clipControllers).map(function (c) {
                    if (c.clipType === 'video') {
                        return {
                            clipId: c.clipId,
                            clipType: c.clipType,
                            clipStart: c.clipStart,
                            clipDuration: c.clipDuration,
                            clipVolume: c.clipVolume,
                            musicVolume: c.musicVolume,
                            speed: c._speed,
                            time: c.time
                        };
                    }
                    if (c.clipType === 'image') {
                        return {
                            clipId: c.clipId,
                            clipType: c.clipType,
                            clipDuration: c.clipDuration,
                            musicVolume: c.musicVolume,
                            speed: 1,
                            clipAnimType: c.clipAnimType,
                            time: c.time
                        };
                    }
                    if (c.clipType === 'composite') {
                        return {
                            clipId: c.clipId,
                            clipType: c.clipType,
                            clipStart: c.clipStart,
                            clipDuration: c.clipDuration,
                            clipVolume: c.clipVolume,
                            musicVolume: c.musicVolume,
                            speed: c._speed,
                            time: c.time
                        };
                    }
                });

                var _audioController$audi = this._audioController.audioClip,
                    clipFadeIn = _audioController$audi.clipFadeIn,
                    clipFadeOut = _audioController$audi.clipFadeOut,
                    clipLooping = _audioController$audi.clipLooping,
                    clipVolume = _audioController$audi.clipVolume,
                    clipDuration = _audioController$audi.clipDuration;
                // debug
                // console.log({
                //     clips ,
                //     audiocontrol : this._audioController.audioClip
                // })

                var volumeTransitionList = (0, _ReelHelpers.getVolumeTransitionListForReelAudio)({
                    clips: clips,
                    volumeMode: this._volumeMode,
                    clipFadeIn: clipFadeIn,
                    clipFadeOut: clipFadeOut,
                    clipLooping: clipLooping,
                    clipVolume: clipVolume,
                    clipDuration: clipDuration
                });

                this._audioController.doSetVolumeTransitionList(volumeTransitionList);
            }
        }
    }, {
        key: '_updateAllLabelsAndCallbacks',
        value: function _updateAllLabelsAndCallbacks() {
            var _this21 = this;

            this._updateClipTimes();

            // First remove any existing labels and callbacks
            var labels = this._timeline.getLabelsArray();
            for (var i = 0; i < labels.length; i++) {
                var labelName = labels[i].name;

                if (labelName === 'complete') {
                    this._timeline.removeCallback(this._onComplete, 'complete');
                    this._timeline.removeLabel('complete');
                } else {
                    this._timeline.removeCallback(this._onClipBorder, labelName);
                    this._timeline.removeLabel(labelName);
                }
            }

            var totalDuration = this.duration();

            // Add label for complete again at the new total duration
            this._timeline.addLabel('complete', (0, _TimeUtils._toGSAPtime)(totalDuration));
            this._timeline.addCallback(this._onComplete, 'complete', ['complete'], this);

            var cumulativeDuration = 0;
            // Add labels to boundaries between clips
            Object.keys(this._clipControllers).forEach(function (clipId) {
                var controller = _this21._clipControllers[clipId];

                var startLabel = 'clipStart::::' + clipId;
                var endLabel = 'clipEnd::::' + clipId;

                // Get adjustment offset for all clips
                _this21._timeline.addLabel(endLabel, (0, _TimeUtils._toGSAPtime)(controller.exitDoneWithTransition()));
                _this21._timeline.addCallback(_this21._onClipBorder, endLabel, [endLabel], _this21);

                _this21._timeline.addLabel(startLabel, (0, _TimeUtils._toGSAPtime)(Math.max(0, controller.enterStartWithTransition() - 1)));
                _this21._timeline.addCallback(_this21._onClipBorder, startLabel, [startLabel], _this21);
            });
        }
    }, {
        key: '_updateWaitMode',
        value: function _updateWaitMode() {
            this._notifyCurrentControllers();

            var oldWaitMode = this.waitMode;
            var newWaitMode = this._getWaitMode();

            if (oldWaitMode === newWaitMode) {
                return;
            }

            var wasPlaying = this.waitMode === _WaitMode2.default.NONE && this.playbackState === _PlaybackState2.default.PLAYING;

            this.waitMode = newWaitMode;

            this._notifyCurrentControllers();

            var shouldPlay = newWaitMode === _WaitMode2.default.NONE && this.playbackState === _PlaybackState2.default.PLAYING;

            this._changePlayback(wasPlaying, shouldPlay);

            this._fireWaitModeChange();
        }
    }, {
        key: '_changePlayback',
        value: function _changePlayback(wasPlaying, shouldPlay) {
            if (wasPlaying && !shouldPlay) {
                this._timeline.pause();
            } else if (!wasPlaying && shouldPlay) {
                this._timeline.play();
            }
        }
    }, {
        key: '_notifyCurrentControllers',
        value: function _notifyCurrentControllers() {
            var _this22 = this;

            var currentClipControllers = this._currentClipControllers();

            currentClipControllers.forEach(function (cc) {
                return cc.updateCorePlayerWaitMode(_this22.waitMode);
            });
            if (this.addedAudio) {
                this._audioController.updateCorePlayerWaitMode(this.waitMode);
            }
        }
    }, {
        key: '_updatePlaybackState',
        value: function _updatePlaybackState(newPlaybackState) {
            if (this.playbackState === newPlaybackState) {
                return;
            }

            var wasPlaying = this._activelyPlaying();

            this.playbackState = newPlaybackState;

            var shouldPlay = this._activelyPlaying();

            this._changePlayback(wasPlaying, shouldPlay);

            this._firePlaybackStateChange();
        }
    }, {
        key: '_updateClipTimes',
        value: function _updateClipTimes() {
            var _this23 = this;

            var clipTimeMap = (0, _ReelHelpers.getClipTimes)(this._getAllClips());

            Object.keys(this._clipControllers).forEach(function (clipId) {
                var clipController = _this23._clipControllers[clipId];
                var clipTime = clipTimeMap[clipId];

                var _clipTime$currentOffs = clipTime.currentOffset,
                    currentOffset = _clipTime$currentOffs === undefined ? 0 : _clipTime$currentOffs,
                    _clipTime$prevOffset = clipTime.prevOffset,
                    prevOffset = _clipTime$prevOffset === undefined ? 0 : _clipTime$prevOffset;

                clipController.updateTime({ currentOffset: currentOffset, prevOffset: prevOffset });
            });
        }
    }, {
        key: '_onTimer',
        value: function _onTimer() {
            // TODO - wrap the function with a incremental id system ,
            // to register and avoid old time change calls
            this._fireCurrentTimeChange();
        }
    }, {
        key: '_onClipWaitModeChange',
        value: function _onClipWaitModeChange(clipId) {
            this._updateWaitMode();
        }
    }, {
        key: '_onAudioWaitModeChange',
        value: function _onAudioWaitModeChange() {
            this._updateWaitMode();
        }
    }, {
        key: '_onClipPlaybackStateChange',
        value: function _onClipPlaybackStateChange(clipId) {
            var clipController = this._clipControllers[clipId];

            if (clipController.clipId === clipId) {
                // Ignore ENDED events. 'ENDED' events of clips aren't used to determine reelplayer's playback status
                if (clipController.playbackState !== _PlaybackState2.default.ENDED) {
                    this._updatePlaybackState(clipController.playbackState);
                }
            }
        }

        /**
         * Changes the current Clip
         *
         * @param {number} time
         * @return {*}
         * @memberof CorePlayerController
         */

    }, {
        key: '_changeCurrentClips',
        value: function _changeCurrentClips(time) {
            var newClipIds = this._clipIdsOnTime(time);
            if (this._arraysEqual(this._currentClipIds, newClipIds)) {
                // Do nothing
                return;
            }
            // Hide currently playing clip controllers
            // this._currentClipControllers().map(ccc => ccc.doPause());

            this._currentClipControllers().map(function (ccc) {
                return ccc.doHide();
            });

            var currentClipController = this._clipControllersOnTime(time);
            var currentClipIds = currentClipController.map(function (cc) {
                return cc.clip.clipId;
            });

            currentClipController.map(function (cc) {
                return cc.doShow();
            });

            this._currentClipIds = newClipIds;

            this._updateAllVolumes();

            this._emitter.emit(EV_CLIP_CHANGE, { currentClipIds: currentClipIds });
        }
    }, {
        key: '_onComplete',
        value: function _onComplete() {
            if (this.addedAudio) {
                this._audioController.doPause();
            }
            // Pause the currentClipControllers
            // const currentClipControllers = this._currentClipControllers()
            this._currentClipControllers().map(function (cc) {
                return cc.doPause();
            });

            this._updatePlaybackState(_PlaybackState2.default.ENDED);
            if (this._videoDurationLimit > 0) {
                this.doSeek(Math.min(this.totalDuration(), this._videoDurationLimit));
            }
        }
    }, {
        key: '_onClipBorder',
        value: function _onClipBorder(label) {
            var _this24 = this;

            if (!this._disableClipChangeCallback) {
                var _splitClipChangeLabel2 = this._splitClipChangeLabel(label),
                    _splitClipChangeLabel3 = _slicedToArray(_splitClipChangeLabel2, 2),
                    action = _splitClipChangeLabel3[0],
                    clipId = _splitClipChangeLabel3[1];

                var oldPlaybackState = this.playbackState;
                // this._updatePlaybackState(PlaybackState.PAUSED);

                var oldClipIds = this._currentClipIds;
                if (action === 'clipStart') {
                    // console.log('clipEntering', clipId)
                    // if olderIds are present in thi
                    if (!oldClipIds.includes(clipId)) {
                        // this._currentClipIds.push(clipId)
                        var clipController = this._clipControllers[clipId];

                        this._changeCurrentClips(this.time());
                        var newClipIds = this._currentClipIds;

                        if (oldPlaybackState === _PlaybackState2.default.PLAYING) {
                            clipController.doPlay();
                            if (this.addedAudio) {
                                this._audioController.doPlay();
                            }
                        } else if (clipController) {
                            clipController.doPause();
                            if (this.addedAudio) {
                                this._audioController.doPause();
                            }
                        }

                        // const seekToTime = this.time() - clipController.enterStartWithTransition()
                        // clipController.doSeek(seekToTime);

                        // TODO - Needs faster methods the playback switch should be a non block instant action
                        oldClipIds.filter(function (cId) {
                            return !newClipIds.includes(cId);
                        }).forEach(function (cId) {
                            // console.log('pausing old clip ',cId)
                            var clipController = _this24._clipControllers[cId];
                            if (clipController) {
                                // clipController.doSeek(0);
                                setTimeout(function () {
                                    !!clipController && clipController.doSeek(0);
                                }, 10);
                                clipController.doPause();
                            }
                        });
                    }
                } else {
                    // console.log('clipEnding', clipId)
                    // clipEnd action
                    if (oldClipIds.includes(clipId)) {
                        // this._currentClipIds.push(clipId)
                        // console.log('ending old clip ',clipId)
                        var _clipController = this._clipControllers[clipId];
                        this._changeCurrentClips(this.time());
                        // clipController.doSeek(0)
                        setTimeout(function () {
                            return !!_clipController && _clipController.doSeek(0);
                        }, 10);
                        _clipController.doPause();
                    }
                }
                this._updateWaitMode();
                this._updatePlaybackState(oldPlaybackState);
            }
        }
    }, {
        key: '_getClipChangeLabel',
        value: function _getClipChangeLabel(clip1Id, clip2Id) {
            return clip1Id + '::::' + clip2Id;
        }
    }, {
        key: '_splitClipChangeLabel',
        value: function _splitClipChangeLabel(label) {
            return label.split('::::');
        }
    }, {
        key: '_currentClipControllers',
        value: function _currentClipControllers() {
            var _this25 = this;

            return this._currentClipIds.filter(function (id) {
                return _this25._clipControllers.hasOwnProperty(id);
            }).map(function (id) {
                return _this25._clipControllers[id];
            });
        }
    }, {
        key: '_clipControllersOnTime',
        value: function _clipControllersOnTime(time) {
            return Object.values(this._clipControllers).filter(function (cc) {
                return cc.enterStartWithTransition() <= time && cc.exitDoneWithTransition() > time;
            });
        }
    }, {
        key: '_clipIdsOnTime',
        value: function _clipIdsOnTime(time) {
            var _this26 = this;

            return Object.keys(this._clipControllers).filter(function (k) {
                return _this26._clipControllers[k].enterStartWithTransition() <= time && _this26._clipControllers[k].exitDoneWithTransition() > time;
            });
        }
    }, {
        key: '_inferPlaybackStateFromControllers',
        value: function _inferPlaybackStateFromControllers(controllers) {
            // TODO infer playback states
            if (controllers.length > 0) {
                return controllers[0].playbackState;
            }
            return this.playbackState;
        }
    }, {
        key: '_inferWaitModeFromControllers',
        value: function _inferWaitModeFromControllers(controllers) {
            // TODO infer playback states
            if (controllers.length > 0) {
                return controllers[controllers.length - 1].waitMode;
            }
            return _WaitMode2.default.NONE;
        }
    }, {
        key: '_adjustClipsAfterTime',
        value: function _adjustClipsAfterTime(time, adjustmentOffset) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.values(this._clipControllers)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var cc = _step2.value;

                    if (cc.enterStartWithTransition() >= time) {
                        var newTime = {
                            enterStart: cc.enterStart() + adjustmentOffset,
                            enterDone: cc.enterDone() + adjustmentOffset,
                            exitStart: cc.exitStart() + adjustmentOffset,
                            exitDone: cc.exitDone() + adjustmentOffset
                        };
                        cc.doChangeClipBounds({ time: newTime });
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: '_arraysEqual',
        value: function _arraysEqual(_arr1, _arr2) {
            if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) return false;

            var arr1 = _arr1.concat().sort();
            var arr2 = _arr2.concat().sort();

            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) return false;
            }

            return true;
        }
    }]);

    return CorePlayerController;
}();

exports.default = CorePlayerController;

},{"../components/FramePaddingBox.react":11,"../constants/Player":64,"./AudioController":69,"./GeneralUtils":77,"./ReelHelpers":85,"./SingleCompositeClipController":86,"./SingleImageClipController":87,"./SingleVideoClipController":88,"./TimeUtils":89,"./enums/PlaybackState":96,"./enums/WaitMode":100,"cloneextend":412,"css-element-queries/src/ResizeSensor":546,"events":629,"lodash/throttle":869,"react":1107,"react-dom":1016}],74:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.analyzeBoxIntersectionRange = analyzeBoxIntersectionRange;
exports.analyzeBoxIntersection = analyzeBoxIntersection;

var _GeneralUtils = require('./GeneralUtils');

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function toRatioPercent(num, den) {
    return num / den * 100;
}

var getRatioConverter = function getRatioConverter(refSize, toValue) {
    return function (obj) {
        var den = function den(k) {
            return k === 'x' || k === 'width' ? refSize.width : refSize.height;
        };

        return Object.keys(obj).reduce(function (p, k) {
            if (typeof obj[k] === 'number') {
                return _extends({}, p, _defineProperty({}, k, toValue(toRatioPercent(obj[k], den(k)))));
            }
            return _extends({}, p, _defineProperty({}, k, obj[k]));
        }, {});
    };
};

var toCSSKeyedObj = function toCSSKeyedObj(obj) {
    return Object.keys(obj).reduce(function (p, k) {
        if (k === 'x') {
            return _extends({}, p, { left: obj[k] });
        } else if (k === 'y') {
            return _extends({}, p, { top: obj[k] });
        }
        return _extends({}, p, _defineProperty({}, k, obj[k]));
    }, {});
};

function calcRotatedSourceBox(sourceBox) {
    var sourceHeight = sourceBox.height,
        sourceWidth = sourceBox.width,
        rotateDeg = sourceBox.rotateDeg,
        x = sourceBox.x,
        y = sourceBox.y;

    var radVal = (0, _GeneralUtils.degreeToRadian)(rotateDeg);
    var sinVal = (0, _GeneralUtils.absoluteSinVal)(radVal);
    var cosVal = (0, _GeneralUtils.absoluteCosVal)(radVal);

    var newSourceHeight = sourceWidth * sinVal + sourceHeight * cosVal;
    var newSourceWidth = sourceWidth * cosVal + sourceHeight * sinVal;

    var newX = x - (newSourceWidth - sourceWidth) / 2;
    var newY = y - (newSourceHeight - sourceHeight) / 2;

    return _extends({}, sourceBox, {
        height: newSourceHeight,
        width: newSourceWidth,
        x: newX,
        y: newY
    });
}

function analyzeBoxIntersectionRange(sourceBox, targetBox) {
    if (sourceBox.rotateDeg) {
        sourceBox = calcRotatedSourceBox(sourceBox);
    }

    var gridLinesV = [sourceBox.x, targetBox.x, sourceBox.x + sourceBox.width, targetBox.x + targetBox.width].sort(function (a, b) {
        return a - b;
    });
    var gridLinesH = [sourceBox.y, targetBox.y, sourceBox.y + sourceBox.height, targetBox.y + targetBox.height].sort(function (a, b) {
        return a - b;
    });

    return [gridLinesV, gridLinesH];
}

function analyzeBoxIntersection(sourceBox, targetBox, toValue) {
    if (sourceBox.rotateDeg) {
        sourceBox = calcRotatedSourceBox(sourceBox);
    }
    var gridLinesV = [sourceBox.x, targetBox.x, sourceBox.x + sourceBox.width, targetBox.x + targetBox.width].sort(function (a, b) {
        return a - b;
    });
    var gridLinesH = [sourceBox.y, targetBox.y, sourceBox.y + sourceBox.height, targetBox.y + targetBox.height].sort(function (a, b) {
        return a - b;
    });

    var rc = getRatioConverter(targetBox, toValue);

    var partInBox = function partInBox(part, box) {
        return !(box.x >= part.x + part.width || box.x + box.width <= part.x || box.y >= part.y + part.height || box.y + box.height <= part.y);
    };

    var pr = function pr(rect) {
        return _extends({}, toCSSKeyedObj(rc(rect)), {
            inSource: partInBox(rect, sourceBox),
            inTarget: partInBox(rect, targetBox)
        });
    };

    var boxes = [];

    boxes.push(pr({
        type: 'tl',
        x: gridLinesV[0],
        y: gridLinesH[0],
        width: gridLinesV[1] - gridLinesV[0],
        height: gridLinesH[1] - gridLinesH[0]
    }));

    boxes.push(pr({
        type: 'tc',
        x: gridLinesV[1],
        y: gridLinesH[0],
        width: gridLinesV[2] - gridLinesV[1],
        height: gridLinesH[1] - gridLinesH[0]
    }));

    boxes.push(pr({
        type: 'tr',
        x: gridLinesV[2],
        y: gridLinesH[0],
        width: gridLinesV[3] - gridLinesV[2],
        height: gridLinesH[1] - gridLinesH[0]
    }));

    boxes.push(pr({
        type: 'ml',
        x: gridLinesV[0],
        y: gridLinesH[1],
        width: gridLinesV[1] - gridLinesV[0],
        height: gridLinesH[2] - gridLinesH[1]
    }));

    boxes.push(pr({
        type: 'mc',
        x: gridLinesV[1],
        y: gridLinesH[1],
        width: gridLinesV[2] - gridLinesV[1],
        height: gridLinesH[2] - gridLinesH[1]
    }));

    boxes.push(pr({
        type: 'mr',
        x: gridLinesV[2],
        y: gridLinesH[1],
        width: gridLinesV[3] - gridLinesV[2],
        height: gridLinesH[2] - gridLinesH[1]
    }));

    boxes.push(pr({
        type: 'bl',
        x: gridLinesV[0],
        y: gridLinesH[2],
        width: gridLinesV[1] - gridLinesV[0],
        height: gridLinesH[3] - gridLinesH[2]
    }));

    boxes.push(pr({
        type: 'bc',
        x: gridLinesV[1],
        y: gridLinesH[2],
        width: gridLinesV[2] - gridLinesV[1],
        height: gridLinesH[3] - gridLinesH[2]
    }));

    boxes.push(pr({
        type: 'br',
        x: gridLinesV[2],
        y: gridLinesH[2],
        width: gridLinesV[3] - gridLinesV[2],
        height: gridLinesH[3] - gridLinesH[2]
    }));

    return boxes;
}

},{"./GeneralUtils":77}],75:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}(); /*
      * FARE WARNING DO NOT TOUCH THIS MODULE - WIP EXPERIMENTAL
      * Used by 
      * 1. New Timeline Editor 
      * 2. clickDragDetect
      * 3. ALL OF LEFT PANEL and LAZYLOAD system
      * 4. WindowEvent Wrapper
      *
      * THE BATCHING SYSTEM IS SIMILAR TO HOW REACT SYNTHETIC EVENT WORKS
      * IT DOES NOT USES A FRAME BUDGET FOR FLUSHING CHANGES AS OF YET
      * 
      * IT USES REACT BATCH TO BATCH IN SEVERAL SAME ELEMENT SAME EVENT
      * ONCE POST MESSAGE SCHEDULER IS DONE -- WE CAN USE POST MESSAGE SCHEDULER
      * TO BATCH MULTIPLE EVENTS
      * 
      * 
      */

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _reactRedux = require('react-redux');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _GeneralUtils = require('../utils/GeneralUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DEBUG = false && !("production" === 'production');;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var emptyFunc = function emptyFunc() {};

/**
 * A minimalistic implementation for chaining multiple
 * event listeners callbacks in a dynamic linked list
 * Why linked list - because we want instant delete as events listeners
 * will be quicly removed and we want to avoid any null/undefined check
 *
 *
 *
 *
 * @export
 * @class EventListenerList
 */

var EventListenerList = function () {
    function EventListenerList(_ref) {
        var _this = this;

        var eventName = _ref.eventName,
            _ref$throttleT = _ref.throttleT,
            throttleT = _ref$throttleT === undefined ? 16 : _ref$throttleT,
            _ref$attributeName = _ref.attributeName,
            attributeName = _ref$attributeName === undefined ? null : _ref$attributeName,
            _ref$plainAdd = _ref.plainAdd,
            plainAdd = _ref$plainAdd === undefined ? false : _ref$plainAdd,
            _ref$useBatch = _ref.useBatch,
            useBatch = _ref$useBatch === undefined ? false : _ref$useBatch,
            _ref$useCapture = _ref.useCapture,
            useCapture = _ref$useCapture === undefined ? false : _ref$useCapture,
            _ref$frameBudget = _ref.frameBudget,
            frameBudget = _ref$frameBudget === undefined ? 30 : _ref$frameBudget;

        _classCallCheck(this, EventListenerList);

        this.__runRafCallBacks = function (id, rafStart, e) {
            var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

            return new Promise(function (resolve) {
                var rafId = _fastdom2.default.measure(function () {
                    var returnValue = [];
                    while (rafStart) {
                        if (rafStart.prepareInRaf) {
                            var v = rafStart.prepareInRaf(e);
                            returnValue.push(v);
                        }
                        rafStart = rafStart.next;
                    }
                    dlog('Executed Rafs : ' + returnValue.length + ' -- ' + _this.attributeName);
                    resolve(returnValue);
                    callback(returnValue);
                });
                // this.currentRunningPrepareRafId[id] = {
                //     rafId,
                //     event : e,
                //     executeStatus : false
                // }
            });
        };

        this.__itereateInBatches = function (id, start, e) {
            var budget = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 16;

            var i = 0;
            var batchedOperation = function batchedOperation() {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                (0, _reactRedux.batch)(function () {
                    while (start) {
                        if (start.callback) {
                            start.callback(e, { rafResult: result[i] });
                            i++;
                        }
                        start = start.next;
                        // TODO -- turning off batching
                        // if((i % 33) === 0){ // Avoiding measuring time , in lieu of speculation
                        //     const elapsed = currentEpoch() - time;
                        //     if (elapsed > budget) {
                        //         break;
                        //     }
                        // }
                    }
                });
            };

            _this.__runRafCallBacks(id, start, e, function () {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                batchedOperation(result);
            });
        };

        this.allTargetElements = {}; // TODO - change it to Map , requires a Babel upgrade
        this.allEventListeners = {}; // TODO - change it to Map requires a Babel upgrade + polyfills

        // this.currentRunningPrepareRafId = {}


        this.eventName = eventName;
        this.throttleT = throttleT;
        this.attributeName = attributeName || 'event-listener-' + (0, _shortid2.default)();
        this.plainAdd = plainAdd;
        this.useBatch = useBatch;
        this.frameBudget = frameBudget;

        this.useCapture = useCapture;

        if (!window.listenerId) {
            window.listenerId = {};
        }
    }

    _createClass(EventListenerList, [{
        key: '__addCallBack',
        value: function __addCallBack(id) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref2$prepareInRaf = _ref2.prepareInRaf,
                prepareInRaf = _ref2$prepareInRaf === undefined ? null : _ref2$prepareInRaf;

            var object = {
                callback: callback,
                next: null,
                prev: null,
                elementId: id,
                prepareInRaf: prepareInRaf
            };

            this.allTargetElements[id].prev = object;
            object.next = this.allTargetElements[id];
            this.allTargetElements[id] = object;
            dlog('added on callback for element ' + id);
            return object;
        }
    }, {
        key: '__removeListenerFromElement',
        value: function __removeListenerFromElement(id) {
            var start = this.allTargetElements[id];
            if (!!start && start.next == null && start.prev == null) {
                var element = start.element;

                var eventListenerFunc = this.allEventListeners[id];

                if (this.plainAdd) {
                    element['on' + this.eventName] = null;
                } else {
                    // useCapture to be specified in removal also since both bubble phase and capture phase
                    // has different function references even if the same function is given
                    element.removeEventListener(this.eventName, eventListenerFunc, this.useCapture);
                }

                this.__removeAttribute(element, this.attributeName);

                // const {rafId , event , executeStatus = true} = this.currentRunningPrepareRafId[id] || {}

                // fastdom.clear(rafId)

                delete this.allEventListeners[id];
                delete this.allTargetElements[id];
                // delete this.currentRunningPrepareRafId[id]
                dlog('removed all event callback - ' + this.attributeName + ' ' + id);
                return null;
            }
        }

        /**
         *
         *
         * @param {string} id
         * @param {Event} e
         * @return {*}
         * @memberof EventListenerList
         */

    }, {
        key: '__iterateOnEntries',
        value: function __iterateOnEntries(id, e) {
            var start = this.allTargetElements[id];

            if (!start) {
                dlog('undefined target for execution ' + id);
            }

            if (start.next == null && start.prev == null) {
                return this.__removeListenerFromElement(id);
            }

            var result = null; // useBatch will run it asynchrnously -- so result will be null

            if (this.useBatch) {
                this.__itereateInBatches(id, start, e, this.frameBudget);
            } else {
                var i = 0;
                var rafStart = start;
                var rafPromise = this.__runRafCallBacks(id, rafStart, e);

                while (start) {
                    if (start.callback) {
                        (function () {
                            i++;
                            var index = i;
                            var data = {
                                rafResult: rafPromise.then(function (data) {
                                    return data[index];
                                })
                            };
                            if (!result) result = start.callback(e, data);else start.callback(e, data);
                        })();
                    }
                    start = start.next;
                }
                // this.currentRunningPrepareRafId[id].executeStatus = true
                dlog('processed callbacks :' + i + ' from id: ' + id);
            }

            return result;
        }

        /**
         * Iterates in batches while using batch
         *
         * Useful when there is a large number of listeners attached to the Loop
         * Especially if its making React updates , then having them batches together and broken down
         * Should help
         *
         * @param {Object} start
         * @param {Event} e
         * @param {number} [budget=10]
         * @memberof EventListenerList
         */

    }, {
        key: '__firstTimeEventAddition',
        value: function __firstTimeEventAddition(element) {
            var _this2 = this;

            var id = _shortid2.default.generate();
            this.__setAttributeName(element, this.attributeName, id);
            dlog('element added first time', element, id);
            this.allTargetElements[id] = {
                callback: null,
                next: null,
                prev: null,
                element: element,
                elementId: id
            };

            var evh = function evh(e) {
                dlog('event triggered for -- ' + _this2.eventName + ' --' + _this2.attributeName);
                return _this2.__iterateOnEntries(id, e);
            };
            var listener = this.throttleT == null ? evh : (0, _GeneralUtils.throttle)(evh, this.throttleT);

            this.allEventListeners[id] = listener;

            if (this.plainAdd) {
                element['on' + this.eventName] = this.allEventListeners[id];
            } else {
                element.addEventListener(this.eventName, this.allEventListeners[id], this.useCapture);
            }

            return id;
        }

        /**
         *
         *
         * @param {Element} element
         * @param {string} name
         * @param {string} value
         * @memberof EventListenerList
         */

    }, {
        key: '__setAttributeName',
        value: function __setAttributeName(element, name, value) {
            if (element === window) {
                window.listenerId[name] = value;
            } else {
                element.setAttribute(name, value);
            }
        }

        /**
         *
         *
         * @param {Element} element
         * @param {string} name
         * @memberof EventListenerList
         */

    }, {
        key: '__removeAttribute',
        value: function __removeAttribute(element, name) {
            if (element === window) {
                delete window.listenerId[name];
            } else {
                element.removeAttribute(name);
            }
        }

        /**
         *
         *
         * @param {Element} element
         * @param {string} name
         * @return {string}
         * @memberof EventListenerList
         */

    }, {
        key: '__getAttributeName',
        value: function __getAttributeName(element, name) {
            if (element === window) {
                return window.listenerId[name];
            } else {
                return element.getAttribute(this.attributeName);
            }
        }

        /**
         *
         *
         * @param {HTMLElement} element
         * @param {Function} callback
         * @memberof EventListenerList
         * @returns {{
         *  callback : Function,
         *  next : Object|null ,
         *  prev : Object|null
         * }}
         */

    }, {
        key: 'addEventListener',
        value: function addEventListener(element) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref3$prepareInRaf = _ref3.prepareInRaf,
                prepareInRaf = _ref3$prepareInRaf === undefined ? null : _ref3$prepareInRaf;

            if (!callback) {
                dlog('empty callback provided');
                return;
            }
            var id = this.__getAttributeName(element, this.attributeName);
            if (!id) {
                id = this.__firstTimeEventAddition(element);
            }
            return this.__addCallBack(id, callback, { prepareInRaf: prepareInRaf });
        }

        /**
         *
         *
         *
         * @param {*} object
         * @param {*} [callback=null]
         * @return {*}
         * @memberof EventListenerList
         */

    }, {
        key: 'removeEventListener',
        value: function removeEventListener() {
            var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (object !== null && object.prev == null && object.next == null) {
                var _elementId = object.elementId;

                dlog('remove called on recieving empty head - ' + _elementId);
                return this.__removeListenerFromElement(_elementId);
            }
            var elementId = object.elementId;

            // const {rafId , event , executeStatus = true} = this.currentRunningPrepareRafId[elementId] || {}
            // // capture scheduled event and cancel it
            // fastdom.clear(rafId)

            var prev = object.prev;
            var next = object.next;
            if (prev) prev.next = next;
            if (next) next.prev = prev;
            if (prev == null) {
                // It was the first element getting deleted
                this.allTargetElements[elementId] = next;
            }

            if (this.allTargetElements[elementId].next === null && this.allTargetElements[elementId].prev === null) {
                dlog('remove called on reaching empty head state after removal');
                // last element being assigned , empty node
                this.__removeListenerFromElement(elementId);
            }

            // manually dereferecing for safety
            object.next = undefined;
            object.prev = undefined;
            object.callback = undefined;
            object.elementId = undefined;

            dlog('removed one callback from id : ' + elementId);

            // // once node deleted , restart the event in case the event was pending for execution
            // if(executeStatus !== undefined && executeStatus === false)
            //     this.__iterateOnEntries(elementId, event)

            return null;
        }
    }]);

    return EventListenerList;
}();

exports.default = EventListenerList;

},{"../utils/GeneralUtils":77,"fastdom":634,"react-redux":1079,"shortid":1163}],76:[function(require,module,exports){
(function (Buffer){(function (){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _fontkit = require('fontkit');

var _fontkit2 = _interopRequireDefault(_fontkit);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _TranslationLanguages = require('../config/TranslationLanguages.json');

var _TranslationLanguages2 = _interopRequireDefault(_TranslationLanguages);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var opentype = require('opentype.js'); // God knows why import isn't working

var FontManager = function () {
    function FontManager() {
        _classCallCheck(this, FontManager);
    }

    _createClass(FontManager, [{
        key: 'setup',
        value: function setup(fontConfig) {
            this.fontConfigKeyList = fontConfig.fontConfigKeyList;
            this.fontConfigMap = fontConfig.fontConfigMap;
            this.fontDefaultKey = fontConfig.fontDefaultKey;

            this.customFontKeyList = fontConfig.customFontKeyList || [];
            this.customFontConfigMap = fontConfig.customFontConfigMap || {};

            this.uploadedFontKeyList = [];
            this.uploadedFontConfigMap = {};
            this.uploadedFontSprite = '';

            this.LOADED_FONTS = {};
            this.LOADING_FONTS = {};
        }
    }, {
        key: 'isCustomFont',
        value: function isCustomFont(fontKey) {
            return this.customFontKeyList.includes(fontKey);
        }
    }, {
        key: 'isUploadedFont',
        value: function isUploadedFont(fontKey) {
            return this.uploadedFontKeyList.includes(fontKey);
        }
    }, {
        key: 'getFontConfig',
        value: function getFontConfig(fontKey) {
            if (this.isCustomFont(fontKey)) {
                return this.customFontConfigMap[fontKey];
            } else if (this.isUploadedFont(fontKey)) {
                return this.uploadedFontConfigMap[fontKey];
            }
            return this.fontConfigMap[fontKey];
        }
    }, {
        key: 'getFontKeyList',
        value: function getFontKeyList() {
            return this.fontConfigKeyList;
        }
    }, {
        key: 'getCustomFontKeyList',
        value: function getCustomFontKeyList() {
            return this.customFontKeyList;
        }
    }, {
        key: 'getUploadedFontKeyList',
        value: function getUploadedFontKeyList() {
            return this.uploadedFontKeyList;
        }
    }, {
        key: 'getFontDefaultKey',
        value: function getFontDefaultKey() {
            var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

            var key = this.fontDefaultKey;
            if (lang !== 'en') {
                var language = _TranslationLanguages2.default.find(function (l) {
                    return l.value === lang;
                });
                if (language) {
                    key = language.defaultFontKey;
                }
            }
            return key;
        }
    }, {
        key: 'getFontLabel',
        value: function getFontLabel(fontKey) {
            return this.getFontConfig(fontKey).label;
        }
    }, {
        key: 'getFontWoffUrl',
        value: function getFontWoffUrl(fontKey) {
            return this.getFontConfig(fontKey).woffUrl;
        }
    }, {
        key: 'getFontDirection',
        value: function getFontDirection(fontKey) {
            return this.getFontConfig(fontKey).direction;
        }
    }, {
        key: 'getFontScript',
        value: function getFontScript(fontKey) {
            return this.getFontConfig(fontKey).script;
        }
    }, {
        key: 'getFontBaselineCorrection',
        value: function getFontBaselineCorrection(fontKey) {
            return this.getFontConfig(fontKey).baselineCorrection || 0;
        }
    }, {
        key: 'shouldUseOpentype',
        value: function shouldUseOpentype(fontKey) {
            return !!this.getFontConfig(fontKey).useOpentype;
        }
    }, {
        key: 'loadDefaultFontP',
        value: function loadDefaultFontP() {
            return this.loadFontP(this.getFontDefaultKey());
        }
    }, {
        key: 'isFontDeleted',
        value: function isFontDeleted(fontKey) {
            return !!this.getFontConfig(fontKey).deleted;
        }
    }, {
        key: 'isFontVisible',
        value: function isFontVisible(fontKey) {
            return !!this.getFontConfig(fontKey).variant && !!this.getFontConfig(fontKey).variant.visible;
        }
    }, {
        key: 'getFontCategory',
        value: function getFontCategory(fontKey) {
            // if condition for storing in the export editData
            if (!!this.isCustomFont(fontKey) || !!this.isUploadedFont(fontKey)) return null;
            return this.fontConfigMap[fontKey].variant.category;
        }
    }, {
        key: 'isPremiumFont',
        value: function isPremiumFont(fontKey) {
            return !!this.getFontConfig(fontKey).isPremiumFont;
        }
    }, {
        key: 'loadCustomFonts',
        value: function loadCustomFonts() {
            var _this = this;

            this.customFontKeyList.forEach(function (fk) {
                _this.loadFontP(fk);
            });
        }
    }, {
        key: 'loadFontP',
        value: function loadFontP(fontKey) {
            var _this2 = this;

            if (!!this.LOADED_FONTS[fontKey]) {
                return _bluebird2.default.resolve(true);
            }
            if (!!this.LOADING_FONTS[fontKey]) {
                return this.LOADING_FONTS[fontKey]; // Promise
            }
            // Should load

            var woffUrl = this.getFontWoffUrl(fontKey);
            // const useFontKit = this.isCustomFont(fontKey)
            var useOpentype = this.shouldUseOpentype(fontKey);

            var p = void 0;

            if (useOpentype) {
                p = _bluebird2.default.promisify(opentype.load)(woffUrl).then(function (font) {
                    _this2.LOADED_FONTS[fontKey] = font;
                    delete _this2.LOADING_FONTS[fontKey];
                }).then(function () {
                    window.dispatchEvent(new CustomEvent('fontLoaded', { detail: fontKey }));
                    return _bluebird2.default.resolve(true);
                });
            } else {
                p = _bluebird2.default.resolve(fetch(woffUrl)).then(function (res) {
                    return res.arrayBuffer();
                }).then(function (ab) {
                    var font = _fontkit2.default.create(new Buffer(ab));

                    _this2.LOADED_FONTS[fontKey] = font;
                    delete _this2.LOADING_FONTS[fontKey];
                }).then(function () {
                    window.dispatchEvent(new CustomEvent('fontLoaded', { detail: fontKey }));
                    return _bluebird2.default.resolve(true);
                });
            }

            this.LOADING_FONTS[fontKey] = p;

            return p;
        }
    }, {
        key: 'isLoaded',
        value: function isLoaded(fontKey) {
            return !!this.LOADED_FONTS[fontKey];
        }
    }, {
        key: 'getFont',
        value: function getFont(fontKey) {
            return this.LOADED_FONTS[fontKey];
        }
    }, {
        key: 'getDefaultFont',
        value: function getDefaultFont() {
            var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

            return this.LOADED_FONTS[this.getFontDefaultKey(lang)];
        }
    }, {
        key: 'searchFonts',
        value: function searchFonts() {
            var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

            return this.filterFonts(q, category, this.fontConfigMap, this.fontConfigKeyList);
        }
    }, {
        key: 'searchCustomFonts',
        value: function searchCustomFonts() {
            var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

            return this.filterCustomAndUploadedFonts(q, category, this.customFontConfigMap, this.customFontKeyList);
        }
    }, {
        key: 'searchUploadedFonts',
        value: function searchUploadedFonts() {
            var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

            return this.filterCustomAndUploadedFonts(q, category, this.uploadedFontConfigMap, this.uploadedFontKeyList);
        }
    }, {
        key: 'filterFonts',
        value: function filterFonts(query, category, configMap, fontKeyList) {
            var _this3 = this;

            var searchText = query.trim().toLowerCase();

            return fontKeyList.filter(function (fk) {
                if (!_this3.isFontDeleted(fk) && _this3.isFontVisible(fk)) {
                    if (category !== 'all' && _this3.getFontCategory(fk) !== category) return false;
                    var fontLabel = configMap[fk].label.toLowerCase();
                    if (fontLabel.indexOf(searchText) >= 0) {
                        return true;
                    }
                }
                return false;
            });
        }
    }, {
        key: 'filterCustomAndUploadedFonts',
        value: function filterCustomAndUploadedFonts(query, category, configMap, fontKeyList) {
            var _this4 = this;

            var searchText = query.trim().toLowerCase();

            return fontKeyList.filter(function (fk) {
                if (!_this4.isFontDeleted(fk)) {
                    if (category !== 'all') return false;
                    var fontLabel = configMap[fk].label.toLowerCase();
                    if (fontLabel.indexOf(searchText) >= 0) {
                        return true;
                    }
                }
                return false;
            });
        }
    }, {
        key: 'getRegularFontKey',
        value: function getRegularFontKey(fontKey) {
            if (!this.isCustomFont(fontKey) && !this.isUploadedFont(fontKey) && !!this.fontConfigMap[fontKey].variant && !!this.fontConfigMap[fontKey].variant.regularFont) {
                return this.getFontConfig(fontKey).variant.regularFont;
            }
            return null;
        }
    }, {
        key: 'getItalicFontKey',
        value: function getItalicFontKey(fontKey) {
            if (!this.isCustomFont(fontKey) && !this.isUploadedFont(fontKey) && !!this.fontConfigMap[fontKey].variant && !!this.fontConfigMap[fontKey].variant.italicFont) {
                return this.getFontConfig(fontKey).variant.italicFont;
            }
            return null;
        }
    }, {
        key: 'getBoldFontKey',
        value: function getBoldFontKey(fontKey) {
            if (!this.isCustomFont(fontKey) && !this.isUploadedFont(fontKey) && !!this.fontConfigMap[fontKey].variant && !!this.fontConfigMap[fontKey].variant.boldFont) {
                return this.getFontConfig(fontKey).variant.boldFont;
            }
            return null;
        }
    }, {
        key: 'getBoldItalicFontKey',
        value: function getBoldItalicFontKey(fontKey) {
            if (!this.isCustomFont(fontKey) && !this.isUploadedFont(fontKey) && !!this.fontConfigMap[fontKey].variant && !!this.fontConfigMap[fontKey].variant.boldItalicFont) {
                return this.getFontConfig(fontKey).variant.boldItalicFont;
            }
            return null;
        }
    }, {
        key: 'getVariantObject',
        value: function getVariantObject(fontKey) {
            var fontFamily = {};
            var category = this.getFontCategory(fontKey);
            fontFamily.category = !!category ? category : 'OTHERS';
            if (fontKey == this.getItalicFontKey(fontKey)) {
                fontFamily.bold = false;
                fontFamily.italic = true;
            } else if (fontKey == this.getBoldFontKey(fontKey)) {
                fontFamily.bold = true;
                fontFamily.italic = false;
            } else if (fontKey == this.getBoldItalicFontKey(fontKey)) {
                fontFamily.bold = true;
                fontFamily.italic = true;
            } else {
                fontFamily.bold = false;
                fontFamily.italic = false;
            }
            return fontFamily;
        }
    }]);

    return FontManager;
}();

var FontManagerInstance = new FontManager();

exports.default = FontManagerInstance;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../config/TranslationLanguages.json":43,"bluebird":389,"buffer":404,"fontkit":635,"opentype.js":887}],77:[function(require,module,exports){
'use strict';
var _typeof2 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i)
                    break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i['return'])
                    _i['return']();
            } finally {
                if (_d)
                    throw _e;
            }
        }
        return _arr;
    }
    return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError('Invalid attempt to destructure non-iterable instance');
        }
    };
}();
var _typeof = typeof Symbol === 'function' && _typeof2(Symbol.iterator) === 'symbol' ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
};
var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
        if (keys.indexOf(i) >= 0)
            continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i))
            continue;
        target[i] = obj[i];
    }
    return target;
}
function _toArray(arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
}
var checkShallowChange = require('react-addons-shallow-compare');
var deepmerge = require('deepmerge');
var currentEpoch = function () {
    if (typeof window !== 'undefined' && window.performance)
        return window.performance.now.bind(performance);
    return Date.now;
}();
function firstAlphaUpperCase(name) {
    if (!name)
        return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}
function replaceHiphenBySpace() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!name)
        return '';
    return name.split('-').join(' ');
}
var getIn = function getIn(obj, searchKeyPath) {
    if (!searchKeyPath || searchKeyPath.length == 0) {
        throw new Error('No search key path given');
    }
    if (searchKeyPath.length == 1) {
        return obj[searchKeyPath];
    }
    var _searchKeyPath = _toArray(searchKeyPath), firstKey = _searchKeyPath[0], restSearchKeyPath = _searchKeyPath.slice(1);
    var subObj = obj[firstKey], otherProps = _objectWithoutProperties(obj, [firstKey]);
    return getIn(subObj, restSearchKeyPath);
};
var updateIn = function updateIn(obj, searchKeyPath, newValue) {
    if (!searchKeyPath || searchKeyPath.length == 0) {
        throw new Error('No search key path given');
    }
    if (searchKeyPath.length == 1) {
        return _extends({}, obj, _defineProperty({}, searchKeyPath[0], newValue));
    }
    var _searchKeyPath2 = _toArray(searchKeyPath), firstKey = _searchKeyPath2[0], restSearchKeyPath = _searchKeyPath2.slice(1);
    var subObj = obj[firstKey], otherProps = _objectWithoutProperties(obj, [firstKey]);
    return _extends({}, otherProps, _defineProperty({}, firstKey, updateIn(subObj, restSearchKeyPath, newValue)));
};
var swapKeyIn = function swapKeyIn(obj, searchKeyPath, oldKey, newKey) {
    if (!searchKeyPath) {
        throw new Error('No search key path given');
    }
    if (searchKeyPath.length == 0) {
        var val = obj[oldKey], _otherProps = _objectWithoutProperties(obj, [oldKey]);
        return _extends({}, _otherProps, _defineProperty({}, newKey, val));
    }
    var _searchKeyPath3 = _toArray(searchKeyPath), firstKey = _searchKeyPath3[0], restSearchKeyPath = _searchKeyPath3.slice(1);
    var subObj = obj[firstKey], otherProps = _objectWithoutProperties(obj, [firstKey]);
    return _extends({}, otherProps, _defineProperty({}, firstKey, swapKeyIn(subObj, restSearchKeyPath, oldKey, newKey)));
};
var removeIn = function removeIn(obj, searchKeyPath) {
    if (!searchKeyPath || searchKeyPath.length == 0) {
        throw new Error('No search key path given');
    }
    if (searchKeyPath.length == 1) {
        var tempval = obj[searchKeyPath[0]], restObj = _objectWithoutProperties(obj, [searchKeyPath[0]]);
        return restObj;
    }
    var _searchKeyPath4 = _toArray(searchKeyPath), firstKey = _searchKeyPath4[0], restSearchKeyPath = _searchKeyPath4.slice(1);
    var subObj = obj[firstKey], otherProps = _objectWithoutProperties(obj, [firstKey]);
    return _extends({}, otherProps, _defineProperty({}, firstKey, removeIn(subObj, restSearchKeyPath)));
};
var excludeFunctions = function excludeFunctions(obj) {
    var result = {};
    for (var prop in obj) {
        if (typeof obj[prop] !== 'function') {
            result[prop] = obj[prop];
        }
    }
    return result;
};
var checkShallowChangeNoFunc = function checkShallowChangeNoFunc(inst, nextProps, nextState) {
    var instance = {
        props: excludeFunctions(inst.props),
        state: excludeFunctions(inst.state)
    };
    return checkShallowChange(instance, excludeFunctions(nextProps), excludeFunctions(nextState));
};
var checkShallowChangePropsAndState = function checkShallowChangePropsAndState(inst, nextProps, nextState) {
    var shouldExcludeFuncs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (shouldExcludeFuncs) {
        inst = {
            props: excludeFunctions(inst.props),
            state: excludeFunctions(inst.state)
        };
        return checkShallowChange(inst, excludeFunctions(nextProps), excludeFunctions(nextState));
    }
    return checkShallowChange(inst, nextProps, nextState);
};
var shallowEqual = function shallowEqual(left, right) {
    var leftKeys = Object.keys(left);
    var rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
        return false;
    }
    for (var i = 0; i < leftKeys.length; i++) {
        if (left[leftKeys[i]] !== right[leftKeys[i]]) {
            return false;
        }
    }
    return true;
};
var deepFreeze = function deepFreeze(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    var propNamesLen = propNames.length;
    while (propNamesLen--) {
        var name = propNames[propNamesLen];
        var prop = obj[name];
        if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object' && prop !== null)
            deepFreeze(prop);
    }
    return Object.freeze(obj);
};
var deepmergeAll = function deepmergeAll() {
    for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
        objs[_key] = arguments[_key];
    }
    return objs.reduce(function (p, c) {
        return deepmerge(p, c);
    });
};
var assertKeys = function assertKeys(o) {
    for (var _len2 = arguments.length, keys = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        keys[_key2 - 1] = arguments[_key2];
    }
    var i = keys.findIndex(function (k) {
        return o[k] === undefined;
    });
    if (i !== -1)
        throw Error('Assertion Error');
};
var hasKey = function hasKey(o, key) {
    return o.hasOwnProperty(key);
};
var findClosestValueIndex = function findClosestValueIndex(targetValue, availableValues) {
    if (availableValues.length < 1) {
        throw new Error('Need at least one value');
    }
    var minIndex = -1;
    var minDistance = 0;
    for (var i = 0; i < availableValues.length; i++) {
        var distance = Math.abs(availableValues[i] - targetValue);
        if (minIndex === -1 || minDistance > distance) {
            minIndex = i;
            minDistance = distance;
        }
    }
    return minIndex;
};
function range(start, edge, step) {
    if (arguments.length == 1) {
        edge = start;
        start = 0;
    }
    edge = edge || 0;
    step = step || 1;
    var ret = [];
    for (; (edge - start) * step > 0; start += step) {
        ret.push(start);
    }
    return ret;
}
function isAnyOfValues(varToCheck) {
    var values = Array.prototype.slice.call(arguments);
    for (var i = 1; i < values.length; i++) {
        if (values[i] == varToCheck) {
            return true;
        }
    }
    return false;
}
function listToMap(arr) {
    var keyFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
        return v.id;
    };
    var valueFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
        return v;
    };
    return arr.reduce(function (p, c) {
        p[keyFunc(c)] = valueFunc(c);
        return p;
    }, {});
}
function replaceFourByteChar(value) {
    var fourByteRegex = new RegExp('(?:[\uD800-\uDBFF][\uDC00-\uDFFF])', 'gi');
    var replaceVal = '\xBF';
    return value.replace(fourByteRegex, replaceVal);
}
function getAspectRatio(width, height) {
    if (!width || !height) {
        return width + ':' + height;
    }
    var gcd = function gcd(a, b) {
        return b ? gcd(b, a % b) : a;
    };
    var canvasGCD = gcd(width, height);
    return width / canvasGCD + ':' + height / canvasGCD;
}
function degreeToRadian() {
    var degree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var pi = Math.PI;
    return (degree % 360 * pi / 180).toFixed(2);
}
function absoluteCosVal() {
    var radian = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return Math.abs(Math.cos(radian));
}
function absoluteSinVal() {
    var radian = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return Math.abs(Math.sin(radian));
}
function debounce(func, wait) {
    var timeout = void 0;
    return function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(undefined, args);
            clearTimeout(timeout);
        }, wait);
        return timeout;
    };
}
function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    var timeout = null;
    var sleep = false;
    var value = void 0;
    return function () {
        if (!timeout) {
            value = func.apply(undefined, arguments);
            timeout = currentEpoch();
            return value;
        }
        var currentCallTime = currentEpoch();
        var elapsedTime = currentCallTime - timeout;
        sleep = elapsedTime < wait;
        if (!sleep) {
            value = func.apply(undefined, arguments);
            timeout = currentEpoch();
            return value;
        }
        return value;
    };
}
var exposedPromise = function exposedPromise() {
    var resolve = null;
    var reject = null;
    var promise = null;
    var refresh = function refresh() {
        promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
    };
    refresh();
    return [
        function () {
            return resolve;
        },
        function () {
            return reject;
        },
        function () {
            return promise;
        },
        refresh
    ];
};
function asyncDebounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    var _exposedPromise = exposedPromise(), _exposedPromise2 = _slicedToArray(_exposedPromise, 4), getResolve = _exposedPromise2[0], getReject = _exposedPromise2[1], getPromise = _exposedPromise2[2], refresh = _exposedPromise2[3];
    var currentPromise = Promise.resolve();
    var timeout = null;
    return function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            currentPromise = currentPromise.then(async function () {
                var cr = null;
                try {
                    cr = getResolve();
                    refresh();
                    var data = await fn.apply(undefined, args);
                    cr(data);
                } catch (err) {
                    cr = getReject();
                    refresh();
                    cr(err);
                }
            });
        }, wait);
        return getPromise();
    };
}
function executeSuccesiveWithDelay(list) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    };
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var _loop = function _loop(i) {
        var index = i;
        setTimeout(function () {
            callback(list[index]);
        }, time * i);
    };
    for (var i = 0; i < list.length; i++) {
        _loop(i);
    }
}
async function asyncProcessArray(chunkList) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    };
    var _ref = arguments[2];
    var _ref$delay = _ref.delay, delay = _ref$delay === undefined ? 0 : _ref$delay, _ref$afterProcessing = _ref.afterProcessing, afterProcessing = _ref$afterProcessing === undefined ? function () {
        } : _ref$afterProcessing, _ref$afterChunk = _ref.afterChunk, afterChunk = _ref$afterChunk === undefined ? function () {
        } : _ref$afterChunk;
    var resultList = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        var _loop2 = async function _loop2() {
            var chunk = _step.value;
            await new Promise(function (resolve, reject) {
                var st = setTimeout(async function () {
                    try {
                        var res = await action(chunk);
                        resultList.push(res);
                        afterChunk([
                            chunk,
                            res
                        ]);
                        clearTimeout(st);
                        resolve();
                    } catch (err) {
                        reject(err);
                    }
                }, delay);
            });
        };
        for (var _iterator = chunkList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            await _loop2();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    afterProcessing(chunkList, resultList);
}
function getChunks(array) {
    var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var chunkMetric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (data) {
        return 1;
    };
    var chunks = [];
    var chunk = [];
    var cost = 0;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for (var _iterator2 = array[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var obj = _step2.value;
            var m = chunkMetric(obj);
            cost += m;
            if (cost > threshold) {
                chunks.push(chunk);
                chunk = [];
                chunk.push(obj);
                cost = m;
            } else {
                chunk.push(obj);
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    if (chunk.length !== 0) {
        chunks.push(chunk);
    }
    return chunks;
}
var convertMbtoGb = function convertMbtoGb(size) {
    if (isNaN(size))
        return 0;
    var fractionDigits = size < 10 ? 3 : 2;
    return Math.round((parseInt(size, 10) / 1024).toFixed(fractionDigits) * 1000) / 1000;
};
function handleFrenzyCall(func, handler) {
    var threashHold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
    var numberOfCalls = 0;
    var timeout = function timeout() {
        return setTimeout(function () {
            numberOfCalls = 0;
        }, duration);
    };
    return function () {
        func();
        numberOfCalls++;
        if (numberOfCalls == 1)
            timeout();
        if (numberOfCalls >= threashHold) {
            handler();
        }
    };
}
function getThrottledDispatch() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    };
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    var functionToCall = throttle(function (callback) {
        callback();
    }, timeout);
    return function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }
        return function (dispatch) {
            functionToCall(function () {
                return dispatch(func.apply(undefined, args));
            });
        };
    };
}
function breadthFirstWalkObject(obj) {
    var operator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (object, type) {
    };
    var shouldVisit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (key, value) {
        return true;
    };
    var childQ = [];
    childQ.push({
        key: 'root',
        value: obj,
        parent: []
    });
    while (childQ.length !== 0) {
        var currentEntry = childQ.shift();
        var value = currentEntry.value;
        var canVisit = shouldVisit(currentEntry.key, value);
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !canVisit) {
            var keys = Object.keys(value);
            var childCount = keys.length;
            if (childCount === 0)
                continue;
            for (var i = 0; i < childCount; i += 1) {
                childQ.push({
                    key: keys[i],
                    value: value[keys[i]],
                    parent: currentEntry.parent.concat(currentEntry.key)
                });
            }
        }
        canVisit && operator(currentEntry, _typeof(currentEntry.value));
    }
}
var memoizeOne = function memoizeOne() {
    var previousDep = [];
    var prevValue = null;
    var firstexec = true;
    var executor = function executor() {
        var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        };
        var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (firstexec) {
            prevValue = func();
            firstexec = false;
            return prevValue;
        }
        if (!deps) {
            prevValue = func();
            return prevValue;
        }
        if (previousDep.length !== deps.length) {
            previousDep = deps;
            prevValue = func();
            return prevValue;
        }
        for (var i = 0; i < previousDep.length; i++) {
            if (previousDep[i] !== deps[i]) {
                previousDep = deps;
                prevValue = func();
                return prevValue;
            }
        }
        return prevValue;
    };
    return executor;
};
var memoize = function memoize(func) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }
        if (args.length === 0) {
            var k = args[0];
            if ((typeof k === 'undefined' ? 'undefined' : _typeof(k)) === 'object')
                return JSON.stringify(k);
            return k;
        }
        return JSON.stringify(args);
    };
    var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
    var clearTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
    var cache = Object.create(null);
    var CLEAR_GAP_TIME = clearTime;
    var lastTimeCacheUpdated = 0;
    if (!func) {
        throw Error('no function provided!!');
    }
    var runFunction = function runFunction() {
        var keyV = key.apply(undefined, arguments);
        var entry = cache[keyV];
        if (entry !== undefined) {
            entry.time = currentEpoch();
            return entry.value;
        }
        var value = func.apply(undefined, arguments);
        var currentTime = currentEpoch();
        if (currentTime - lastTimeCacheUpdated > CLEAR_GAP_TIME && Object.keys(cache).length >= maxSize) {
            var allSortedKeys = Object.keys(cache).sort(function (key1, key2) {
                return cache[key2].time - cache[key1].time;
            });
            allSortedKeys.splice(0, maxSize);
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for (var _iterator3 = allSortedKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var k = _step3.value;
                    delete cache[k];
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
        lastTimeCacheUpdated = currentTime;
        cache[keyV] = {
            value: value,
            time: currentTime
        };
        return value;
    };
    var memoFunc = function memoFunc() {
        var result = runFunction.apply(undefined, arguments);
        return result;
    };
    memoFunc.clear = function () {
        var keyV = key.apply(undefined, arguments);
        delete cache[keyV];
    };
    return memoFunc;
};
var memoizeAsync = function memoizeAsync(func) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }
        return JSON.stringify(args);
    };
    var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
    var cache = {};
    var CLEAR_GAP_TIME = 10000;
    var lastTimeCacheUpdated = 0;
    if (!func) {
        throw Error('no function provided!!');
    }
    var memoFunc = async function memoFunc() {
        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
        }
        var result = await Promise.resolve(async function () {
            var keyV = key.apply(undefined, args);
            var entry = cache[keyV];
            if (entry !== undefined) {
                entry.time = currentEpoch();
                return entry.value;
            }
            var value = await func.apply(undefined, args);
            var currentTime = currentEpoch();
            if (currentTime - lastTimeCacheUpdated > CLEAR_GAP_TIME && Object.keys(cache).length >= maxSize) {
                var allSortedKeys = Object.keys(cache).sort(function (key1, key2) {
                    return cache[key2].time - cache[key1].time;
                });
                allSortedKeys.splice(0, maxSize);
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;
                try {
                    for (var _iterator4 = allSortedKeys[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var _key9 = _step4.value;
                        delete cache[_key9];
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            lastTimeCacheUpdated = currentTime;
            cache[keyV] = {
                value: value,
                time: currentTime
            };
            return value;
        }());
        return result;
    };
    memoFunc.clear = function () {
        var keyV = key.apply(undefined, arguments);
        delete cache[keyV];
    };
    return memoFunc;
};
var createDlog = function createDlog(DEBUG) {
    DEBUG = DEBUG && !("production" === 'production');
    var dlog = function dlog() {
        var _console;
        if (DEBUG)
            (_console = console).log.apply(_console, arguments);
    };
    return dlog;
};
var debugState = function debugState(DEBUG) {
    return DEBUG && !("production" === 'production');
};
var createList = function createList(start, end) {
    var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var list = [];
    for (var i = start; i < end; i += skip) {
        list.push(i);
    }
    return list;
};
var pickRandomFromArray = function pickRandomFromArray() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var num = Math.random();
    var index = Math.round((arr.length - 1) * num);
    return arr[index];
};
var validateEmailAddress = function validateEmailAddress(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
var unionArray = function unionArray() {
    var arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var set = new Set();
    for (var i = 0; i < arr1.length; i += 1) {
        set.add(arr1[i]);
    }
    for (var _i = 0; _i < arr2.length; _i += 1) {
        set.add(arr2[_i]);
    }
    return set.values();
};
var setNestedProperty = function setNestedProperty(nestedKey, value, object) {
    var sep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    if (!object)
        return;
    var currentObjvalue = object;
    var allKeys = nestedKey.split(sep);
    var i = 0;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;
    try {
        for (var _iterator5 = allKeys[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var key = _step5.value;
            if (i === allKeys.length - 1) {
                currentObjvalue[key] = value;
                return object;
            }
            var v = currentObjvalue[key];
            if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
                currentObjvalue = v;
            } else {
                currentObjvalue[key] = {};
                currentObjvalue = currentObjvalue[key];
            }
            i += 1;
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }
    return object;
};
var accessNestedProperty = function accessNestedProperty(nestedKey, object) {
    var sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!object)
        return;
    var objectValue = object;
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;
    try {
        for (var _iterator6 = nestedKey.split(sep)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var key = _step6.value;
            if (objectValue && (typeof objectValue === 'undefined' ? 'undefined' : _typeof(objectValue)) === 'object') {
                objectValue = objectValue[key];
            } else {
                return;
            }
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }
    return objectValue;
};
var getFileNameAndExtension = function getFileNameAndExtension(fileName) {
    var arr = fileName.split('.');
    var name = '', extension = '';
    if (arr.length === 1) {
        name = arr[0];
    } else if (arr[0] === '' && arr.length === 2) {
        name = arr[1];
    } else {
        extension = arr.pop();
        name = arr.join('.');
    }
    return {
        name: name,
        extension: extension
    };
};
var milliSecToMinutesAndSeconds = function milliSecToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = (millis % 60000 / 1000).toFixed(0);
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};
module.exports = {
    createList: createList,
    getThrottledDispatch: getThrottledDispatch,
    throttle: throttle,
    asyncProcessArray: asyncProcessArray,
    getChunks: getChunks,
    debounce: debounce,
    asyncDebounce: asyncDebounce,
    getIn: getIn,
    updateIn: updateIn,
    swapKeyIn: swapKeyIn,
    removeIn: removeIn,
    checkShallowChangeNoFunc: checkShallowChangeNoFunc,
    checkShallowChangePropsAndState: checkShallowChangePropsAndState,
    deepFreeze: deepFreeze,
    deepmergeAll: deepmergeAll,
    assertKeys: assertKeys,
    hasKey: hasKey,
    findClosestValueIndex: findClosestValueIndex,
    range: range,
    isAnyOfValues: isAnyOfValues,
    listToMap: listToMap,
    replaceFourByteChar: replaceFourByteChar,
    getAspectRatio: getAspectRatio,
    degreeToRadian: degreeToRadian,
    absoluteCosVal: absoluteCosVal,
    absoluteSinVal: absoluteSinVal,
    firstAlphaUpperCase: firstAlphaUpperCase,
    executeSuccesiveWithDelay: executeSuccesiveWithDelay,
    convertMbtoGb: convertMbtoGb,
    handleFrenzyCall: handleFrenzyCall,
    memoizeAsync: memoizeAsync,
    createDlog: createDlog,
    debugState: debugState,
    memoizeOne: memoizeOne,
    pickRandomFromArray: pickRandomFromArray,
    replaceHiphenBySpace: replaceHiphenBySpace,
    validateEmailAddress: validateEmailAddress,
    breadthFirstWalkObject: breadthFirstWalkObject,
    shallowEqual: shallowEqual,
    memoize: memoize,
    unionArray: unionArray,
    setNestedProperty: setNestedProperty,
    accessNestedProperty: accessNestedProperty,
    getFileNameAndExtension: getFileNameAndExtension,
    milliSecToMinutesAndSeconds: milliSecToMinutesAndSeconds
};
},{"deepmerge":549,"react-addons-shallow-compare":900}],78:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _RangedValue = require('./RangedValue');

var _RangedValue2 = _interopRequireDefault(_RangedValue);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var areColorsEqual = function areColorsEqual(c1, c2) {
    var cc1 = (0, _color2.default)(c1);
    var cc2 = (0, _color2.default)(c2);
    if (cc1.valpha !== cc2.valpha) {
        return false;
    }
    return cc1.string() === cc2.string();
};

var HighlightColorRange = function () {
    function HighlightColorRange(highlightColor) {
        _classCallCheck(this, HighlightColorRange);

        this.fullRangeColor = null;
        this.rangedValue = null;

        // Check if JSON and array
        if (_RangedValue2.default.isRangedValue(highlightColor)) {
            this.rangedValue = new _RangedValue2.default(highlightColor, 'color', areColorsEqual);
        } else {
            this.fullRangeColor = highlightColor;
        }
    }

    _createClass(HighlightColorRange, [{
        key: 'insertAtIndex',
        value: function insertAtIndex(index) {
            if (this.rangedValue) {
                this.rangedValue.insertAtIndex(index);
            }
        }
    }, {
        key: 'removeAtIndex',
        value: function removeAtIndex(index) {
            if (this.rangedValue) {
                this.rangedValue.removeAtIndex(index);
            }
        }
    }, {
        key: 'forEachRange',
        value: function forEachRange(fn) {
            if (this.rangedValue) {
                this.rangedValue.forEachRange(function (start, end, color) {
                    return fn(start, end, color);
                });
            } else {
                fn(-1, -1, this.fullRangeColor);
            }
        }
    }, {
        key: 'getSelectionColors',
        value: function getSelectionColors() {
            var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            // selection - start is inclusive, end is not

            if (this.fullRangeColor) {
                return [this.fullRangeColor];
            }

            if (this.rangedValue.empty) {
                return [];
            }

            var colorsUsed = [];

            if (!selection) {
                selection = { start: 0, end: this.rangedValue.length };
            }

            if (selection.start === selection.end) {
                // Not selection
                if (this.rangedValue.hasRangeAtIndex(selection.start)) {
                    colorsUsed.push(this.rangedValue.getValueForIndex(selection.start));
                }
            } else {
                this.rangedValue.forEachIndex({ start: selection.start, end: selection.end - 1 }, function (color) {
                    if (!!color && !colorsUsed.find(function (c) {
                        return areColorsEqual(c, color);
                    })) {
                        colorsUsed.push(color);
                    }
                });
            }

            return colorsUsed;
        }
    }, {
        key: 'getColorForIndex',
        value: function getColorForIndex(index) {
            if (this.fullRangeColor) {
                return this.fullRangeColor;
            }

            if (this.rangedValue.hasRangeAtIndex(index)) {
                return this.rangedValue.getValueForIndex(index);
            }
            return '';
        }
    }, {
        key: 'hasRangeAtIndex',
        value: function hasRangeAtIndex(index) {
            if (this.fullRangeColor) {
                return true;
            }
            return this.rangedValue.hasRangeAtIndex(index);
        }
    }, {
        key: 'addColor',
        value: function addColor(color, currentFocus) {
            if (this.fullRangeColor) {
                this.fullRangeColor = color;
                return;
            }

            var _ref = currentFocus || { length: this.rangedValue.length },
                _ref$start = _ref.start,
                start = _ref$start === undefined ? 0 : _ref$start,
                length = _ref.length,
                _ref$end = _ref.end,
                end = _ref$end === undefined ? length : _ref$end;

            // console.log('color before add', this.toString());

            this.rangedValue.setLength(length);

            var atleastOneCharSelected = start < end;
            var allCharsSelected = end - start === length;

            if (allCharsSelected) {
                this.rangedValue.resetRanges();
            }
            if (atleastOneCharSelected) {
                this.rangedValue.addRange(color, start, end - 1);
            } else if (this.rangedValue.hasRangeAtIndex(start - 1)) {
                this.rangedValue.setValueForRangeAtIndex(start - 1, color);
            } else {
                this.rangedValue.resetRanges();
                this.rangedValue.addRange(color, 0, length - 1);
            }

            // console.log('color after add', this.toString());
        }
    }, {
        key: 'removeColor',
        value: function removeColor(currentFocus) {
            this.rangedValue.removeRangeAtFocus(currentFocus);
        }
    }, {
        key: 'toString',
        value: function toString() {
            if (this.fullRangeColor) {
                return this.fullRangeColor;
            }
            return this.rangedValue.toString();
        }
    }]);

    return HighlightColorRange;
}();

exports.default = HighlightColorRange;

},{"./RangedValue":84,"color":418}],79:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Based on the gist matrix3d.js - https://gist.github.com/f5io/7466669

var Matrix3D = {};

Matrix3D._deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

Matrix3D.create = function () {
    var out,
        args = Array.prototype.slice.call(arguments);
    if (args.length > 0 && args.length < 16) throw 'Invalid arguments supplied!';
    if (args.length === 0) {
        out = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
    } else {
        out = new Float32Array(args);
    }
    return out;
};

Matrix3D.fromTransform = function (str) {
    var r = str.match(/([\d.-]+(?!\w))+/g);
    if (r) {
        return new Float32Array([r[0], r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8], r[9], r[10], r[11], r[12], r[13], r[14], r[15]]);
    } else {
        return;
    }
};

Matrix3D.identity = function (out) {
    out[0] = out[5] = out[10] = out[15] = 1;
    out[1] = out[2] = out[3] = out[4] = out[6] = out[7] = out[8] = out[9] = out[11] = out[12] = out[13] = out[14] = 0;
};

Matrix3D.multiply = function (mx1, mx2, out) {
    var a1 = mx1[0],
        b1 = mx1[1],
        c1 = mx1[2],
        d1 = mx1[3],
        e1 = mx1[4],
        f1 = mx1[5],
        g1 = mx1[6],
        h1 = mx1[7],
        i1 = mx1[8],
        j1 = mx1[9],
        k1 = mx1[10],
        l1 = mx1[11],
        m1 = mx1[12],
        n1 = mx1[13],
        o1 = mx1[14],
        p1 = mx1[15];

    var a2 = mx2[0],
        b2 = mx2[1],
        c2 = mx2[2],
        d2 = mx2[3],
        e2 = mx2[4],
        f2 = mx2[5],
        g2 = mx2[6],
        h2 = mx2[7],
        i2 = mx2[8],
        j2 = mx2[9],
        k2 = mx2[10],
        l2 = mx2[11],
        m2 = mx2[12],
        n2 = mx2[13],
        o2 = mx2[14],
        p2 = mx2[15];

    out[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
    out[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
    out[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
    out[3] = 0;
    out[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
    out[5] = e1 * b2 + f1 * f2 + g1 * f2 + h1 * n2;
    out[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
    out[7] = 0;
    out[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
    out[9] = i1 * b2 + j1 * f2 + k1 * f2 + l1 * n2;
    out[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
    out[11] = 0;
    out[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
    out[13] = m1 * b2 + n1 * f2 + o1 * f2 + p1 * n2;
    out[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
    out[15] = 1;
};

Matrix3D.isEqual = function (mx1, mx2) {
    var a1 = mx1[0],
        b1 = mx1[1],
        c1 = mx1[2],
        d1 = mx1[3],
        e1 = mx1[4],
        f1 = mx1[5],
        g1 = mx1[6],
        h1 = mx1[7],
        i1 = mx1[8],
        j1 = mx1[9],
        k1 = mx1[10],
        l1 = mx1[11],
        m1 = mx1[12],
        n1 = mx1[13],
        o1 = mx1[14],
        p1 = mx1[15];

    var a2 = mx2[0],
        b2 = mx2[1],
        c2 = mx2[2],
        d2 = mx2[3],
        e2 = mx2[4],
        f2 = mx2[5],
        g2 = mx2[6],
        h2 = mx2[7],
        i2 = mx2[8],
        j2 = mx2[9],
        k2 = mx2[10],
        l2 = mx2[11],
        m2 = mx2[12],
        n2 = mx2[13],
        o2 = mx2[14],
        p2 = mx2[15];

    if (a1 === a2 && b1 === b2 && c1 === c2 && d1 === d2 && e1 === e2 && f1 === f2 && g1 === g2 && h1 === h2 && i1 === i2 && j1 === j2 && k1 === k2 && l1 === l2 && m1 === m2 && n1 === n2 && o1 === o2 && p1 === p2) {
        return true;
    } else {
        return false;
    }
};

Matrix3D.translate = function (out, tx, ty, tz) {
    out[12] = tx;
    out[13] = ty || out[13];
    out[14] = tz || out[14];
};

Matrix3D.translateX = function (out, tx) {
    out[12] = tx;
};

Matrix3D.translateY = function (out, ty) {
    out[13] = ty;
};

Matrix3D.translateZ = function (out, tz) {
    out[14] = tz;
};

Matrix3D.scale = function (out, sx, sy, sz) {
    out[0] = sx;
    out[5] = sy || out[5];
    out[10] = sz || out[10];
};

Matrix3D.scaleX = function (out, sx) {
    out[0] = sx;
};

Matrix3D.scaleY = function (out, sy) {
    out[5] = sy;
};

Matrix3D.scaleZ = function (out, sz) {
    out[10] = sz;
};

Matrix3D.rotate = function (out, deg) {
    var rad = Matrix3D._deg2rad(deg),
        cos = Math.cos(rad),
        sin = Math.sin(rad);

    out[0] = cos;
    out[1] = sin;
    out[4] = -sin;
    out[5] = cos;
};

Matrix3D.rotateX = function (out, deg) {
    var rad = Matrix3D._deg2rad(deg),
        cos = Math.cos(rad),
        sin = Math.sin(rad);

    out[5] = cos;
    out[6] = sin;
    out[9] = -sin;
    out[10] = cos;
};

Matrix3D.rotateY = function (out, deg) {
    var rad = Matrix3D._deg2rad(deg),
        cos = Math.cos(rad),
        sin = Math.sin(rad);

    out[0] = cos;
    out[2] = sin;
    out[8] = -sin;
    out[10] = cos;
};

Matrix3D.rotateZ = function (out, deg) {
    Matrix3D.rotate(out, deg);
};

Matrix3D.skew = function (out, xdeg, ydeg) {
    var xrad = Matrix3D._deg2rad(xdeg),
        yrad = ydeg ? Matrix3D._deg2rad(ydeg) : 0,
        xtan = Math.tan(xrad),
        ytan = Math.tan(yrad);

    out[4] = xtan;
    out[1] = ytan;
};

Matrix3D.skewX = function (out, xdeg) {
    var rad = Matrix3D._deg2rad(xdeg),
        tan = Math.tan(rad);

    out[4] = tan;
};

Matrix3D.skewY = function (out, ydeg) {
    var rad = Matrix3D._deg2rad(ydeg),
        tan = Math.tan(rad);

    out[1] = tan;
};

Matrix3D.toTransform = function (mx) {
    return 'matrix(' + mx[0] + ',' + mx[1] + ',' + mx[4] + ',' + mx[5] + ',' + mx[12] + ',' + mx[13] + ')';
};

Matrix3D.toTransform3D = function (mx) {
    return 'matrix3d(' + mx[0] + ',' + mx[1] + ',' + mx[2] + ',' + mx[3] + ',' + mx[4] + ',' + mx[5] + ',' + mx[6] + ',' + mx[7] + ',' + mx[8] + ',' + mx[9] + ',' + mx[10] + ',' + mx[11] + ',' + mx[12] + ',' + mx[13] + ',' + mx[14] + ',' + mx[15] + ')';
};

exports.default = Matrix3D;

},{}],80:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isImageReady = isImageReady;
exports.imageReadyForExport = imageReadyForExport;
exports.isMediaDeleted = isMediaDeleted;
exports.isImageSnapshotReady = isImageSnapshotReady;
exports.isSequencePreviewReady = isSequencePreviewReady;
exports.isVideoReady = isVideoReady;
exports.isVideoSnapshotReady = isVideoSnapshotReady;
exports.isAudioReady = isAudioReady;
exports.getClientVideoUploadStatus = getClientVideoUploadStatus;

var _GeneralUtils = require('./GeneralUtils');

var _ImageUploadStatus = require('./enums/ImageUploadStatus');

var _ImageUploadStatus2 = _interopRequireDefault(_ImageUploadStatus);

var _VideoUploadStatus = require('./enums/VideoUploadStatus');

var _VideoUploadStatus2 = _interopRequireDefault(_VideoUploadStatus);

var _AudioUploadStatus = require('./enums/AudioUploadStatus');

var _AudioUploadStatus2 = _interopRequireDefault(_AudioUploadStatus);

var _SequencePreviewStatus = require('./enums/SequencePreviewStatus');

var _SequencePreviewStatus2 = _interopRequireDefault(_SequencePreviewStatus);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function isImageReady(imageData) {
    return imageData.uploadStatus === _ImageUploadStatus2.default.READY;
}

function imageReadyForExport(imageData) {
    return imageData.uploadStatus === _ImageUploadStatus2.default.READY || imageData.uploadStatus === _ImageUploadStatus2.default.PREPARING_PREVIEWS;
}

function isMediaDeleted(imageData) {
    return imageData.deleted;
}

function isImageSnapshotReady(imageData) {
    return imageData.uploadStatus === _ImageUploadStatus2.default.READY;
}

function isSequencePreviewReady(sequenceData) {
    return sequenceData.previewStatus === _SequencePreviewStatus2.default.PREVIEW_READY;
}

function isVideoReady(videoData) {
    var vus = videoData.uploadStatus;

    if ((0, _GeneralUtils.isAnyOfValues)(vus, _VideoUploadStatus2.default.UPLOADED, _VideoUploadStatus2.default.SAVED_TO_STORAGE, _VideoUploadStatus2.default.PREPARING_PREVIEWS, _VideoUploadStatus2.default.SNAPSHOT_READY, _VideoUploadStatus2.default.THUMBS_READY)) {
        return false;
    }
    if ((0, _GeneralUtils.isAnyOfValues)(vus, _VideoUploadStatus2.default.PREVIEW_360_READY, _VideoUploadStatus2.default.PREVIEW_ALL_READY, _VideoUploadStatus2.default.TRANSCODED_READY)) {
        return true;
    }
    throw new Error('no such video upload status ' + vus);
}

function isVideoSnapshotReady(videoData) {
    var vus = videoData.uploadStatus;

    if ((0, _GeneralUtils.isAnyOfValues)(vus, _VideoUploadStatus2.default.UPLOADED, _VideoUploadStatus2.default.SAVED_TO_STORAGE, _VideoUploadStatus2.default.PREPARING_PREVIEWS)) {
        return false;
    }
    if ((0, _GeneralUtils.isAnyOfValues)(vus, _VideoUploadStatus2.default.SNAPSHOT_READY, _VideoUploadStatus2.default.THUMBS_READY, _VideoUploadStatus2.default.PREVIEW_360_READY, _VideoUploadStatus2.default.PREVIEW_ALL_READY, _VideoUploadStatus2.default.TRANSCODED_READY)) {
        return true;
    }
    throw new Error('no such video upload status ' + vus);
}

function isAudioReady(audioData) {
    var aus = audioData.uploadStatus;

    if ((0, _GeneralUtils.isAnyOfValues)(aus, _AudioUploadStatus2.default.UPLOADED, _AudioUploadStatus2.default.SAVED_TO_STORAGE, _AudioUploadStatus2.default.PREPARING_PREVIEWS)) {
        return false;
    }
    if ((0, _GeneralUtils.isAnyOfValues)(aus, _AudioUploadStatus2.default.PREVIEW_READY, _AudioUploadStatus2.default.TRANSCODED_READY)) {
        return true;
    }
    throw new Error('no such audio upload status ' + aus);
}

function getClientVideoUploadStatus(vus) {
    if ((0, _GeneralUtils.isAnyOfValues)(vus, _VideoUploadStatus2.default.UPLOADING, _VideoUploadStatus2.default.UPLOADED, _VideoUploadStatus2.default.SAVED_TO_STORAGE, _VideoUploadStatus2.default.PREPARING_PREVIEWS, _VideoUploadStatus2.default.SNAPSHOT_READY, _VideoUploadStatus2.default.THUMBS_READY)) {
        return 'PROCESSING';
    }
    if ((0, _GeneralUtils.isAnyOfValues)(vus, _VideoUploadStatus2.default.PREVIEW_360_READY, _VideoUploadStatus2.default.PREVIEW_ALL_READY, _VideoUploadStatus2.default.TRANSCODED_READY)) {
        return 'COMPLETED';
    }
    console.log('unknown state passed');
    return 'PROCESSING';
}

},{"./GeneralUtils":77,"./enums/AudioUploadStatus":93,"./enums/ImageUploadStatus":95,"./enums/SequencePreviewStatus":97,"./enums/VideoUploadStatus":99}],81:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var Observable = function Observable(_ref) {
    var _this = this;

    var _ref$useBatch = _ref.useBatch,
        useBatch = _ref$useBatch === undefined ? true : _ref$useBatch;

    _classCallCheck(this, Observable);

    this.subscribe = function (topic) {
        var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        if (fn && typeof fn === 'function') if (!_this.listeners[topic]) {
            _this.listeners[topic] = {
                name: topic,
                callbacks: []
            };
        }
        var callbacks = _this.listeners[topic].callbacks;

        callbacks.push({
            index: ++_this.runningId,
            callback: fn
        });
        fn.index = _this.runningId;
        // dlog(`Subscribed :`, {
        //     fn , idnex : fn.index
        // })
        return _this.runningId;
    };

    this.removeSubscriptionById = function (topic, runningId) {
        var object = _this.listeners[topic];
        if (!object) return;
        var callbacks = object.callbacks;

        var index = callbacks.findIndex(function (cb) {
            return cb.index === runningId;
        });
        callbacks.splice(index, 1);
    };

    this.removeSubscription = function (topic) {
        var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        if (!fn) {
            return;
        }

        var object = _this.listeners[topic];

        if (!object) return;

        var callbacks = object.callbacks;

        // dlog(`Atempting to remove : ${fn.index}`, callbacks)

        var index = callbacks.findIndex(function (cb) {
            return cb.index === fn.index;
        });
        callbacks.splice(index, 1);
        // dlog(`Removing callback on topic : ${topic} : ${fn.index}`)
    };

    this.emit = function (topic, data) {
        var object = _this.listeners[topic];

        // dlog(`data reciened :`, data)

        if (!object) return;

        var callbacks = object.callbacks;

        var runner = function runner() {
            var iter = callbacks.length;
            while (iter--) {
                if (callbacks[iter]) {
                    callbacks[iter].callback(data);
                }
            }
        };

        if (_this.useBatch) {
            (0, _reactRedux.batch)(runner);
        } else {
            runner();
        }
    };

    this.useBatch = useBatch;
    this.listeners = {};
    this.runningId = 0;
};

exports.default = Observable;

},{"react-redux":1079}],82:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ObserverListener = exports.ObserverPoolListener = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var shortid = require('shortid');

var _require = require('./GeneralUtils'),
    throttle = _require.throttle;

var DEBUG = false && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};
var THROTTLE = 50;

var ObserverPoolListener = exports.ObserverPoolListener = function () {
    function ObserverPoolListener(_ref) {
        var _ref$throttleT = _ref.throttleT,
            throttleT = _ref$throttleT === undefined ? DEBOUNCE : _ref$throttleT,
            _ref$eventAttributeNa = _ref.eventAttributeName,
            eventAttributeName = _ref$eventAttributeNa === undefined ? 'event-' + shortid() : _ref$eventAttributeNa,
            _ref$observerCreator = _ref.observerCreator,
            observerCreator = _ref$observerCreator === undefined ? function (callback, containerElement) {
            throw new Error('no method given , cannot instantiate Observer');
        } : _ref$observerCreator;

        _classCallCheck(this, ObserverPoolListener);

        this.GlobalObserver = {};
        this.observerCreator = observerCreator;
        this.throttleT = throttleT;
        this.eventAttributeName = eventAttributeName;

        this.containerKey = this.eventAttributeName + '-container';
        this.itemKey = this.eventAttributeName + '-item';
    }

    /**
     *
     * Adds the callback for the Observer of
     *
     *
     * @param {Function} callback
     * @param {HTMLElement} targetElement
     * @param {HTMLElement} containerElement
     * @param {Function} observerCreator // executes once when first time creating the listener
     * @param {{
     *  useRaf: boolean ,
     *  getBoundingBox : boolean
     * }} listenerArg
     * @memberof ObserverPoolListener
     */

    _createClass(ObserverPoolListener, [{
        key: 'addCallback',
        value: function addCallback(callback, targetElement, containerElement) {
            var _this = this;

            var _observerCreator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var listenerArg = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            if (!callback || typeof callback !== 'function') {
                return;
            }
            var containerId = containerElement === window ? null : containerElement.getAttribute(this.containerKey);

            if (!containerId) {
                containerId = shortid();
                if (containerElement === window) window['window-' + this.eventAttributeName] = containerId;else containerElement.setAttribute(this.containerKey, containerId);
            }

            if (!this.GlobalObserver[containerId]) {
                this.GlobalObserver[containerId] = new ObserverListener(_extends({
                    throttleT: this.throttleT,
                    eventAttributeName: this.itemKey,
                    observerCreator: function observerCreator(cb) {
                        var fn = _observerCreator || _this.observerCreator;
                        return fn(cb, containerElement);
                    }
                }, listenerArg));
            }

            return this.GlobalObserver[containerId].addCallback(callback, targetElement);
        }

        /**
         *
         *
         * @param {Function} callback
         * @param {HTMLElement} targetElement
         * @param {HTMLElement} containerElement
         * @memberof ObserverPoolListener
         */

    }, {
        key: 'removeCallback',
        value: function removeCallback(object, targetElement, containerElement) {
            if (!containerElement) return null;
            var containerId = containerElement === window ? window['window-' + this.eventAttributeName] : containerElement.getAttribute(this.containerKey);
            if (!containerId) return null;

            var listener = this.GlobalObserver[containerId];
            if (!listener) return null;
            return listener.removeCallback(object, targetElement);
        }
    }]);

    return ObserverPoolListener;
}();

/**
 * Class to wrap Event Pooling for Observers
 *
 * @class ObserverListener
 */

var ObserverListener =
/**
 * Creates an instance of ObserverListener.
 * @param {{
 *         throttleT : number | null,
 *         eventAttributeName : string,
 *         observerCreator : Function,
 *         useRaf :boolean,
 *         getBoundingBox : boolean,
 *         useBatch : boolean
 *     }} {
 *         throttleT = DEBOUNCE, // provide null for avoiding debounce
 *         eventAttributeName = `event-${shortid()}`,
 *         observerCreator = () => {
 *             throw new Error(`no method given , cannot instantiate Observer`);
 *         },
 *         useRaf = false,
 *         getBoundingBox = false,
 *     }
 * @memberof ObserverListener
 */
exports.ObserverListener = function ObserverListener(_ref2) {
    var _ref2$throttleT = _ref2.throttleT,
        throttleT = _ref2$throttleT === undefined ? THROTTLE : _ref2$throttleT,
        _ref2$eventAttributeN = _ref2.eventAttributeName,
        eventAttributeName = _ref2$eventAttributeN === undefined ? 'event-' + shortid() : _ref2$eventAttributeN,
        _ref2$observerCreator = _ref2.observerCreator,
        observerCreator = _ref2$observerCreator === undefined ? function () {
        throw new Error('no method given , cannot instantiate Observer');
    } : _ref2$observerCreator,
        _ref2$useRaf = _ref2.useRaf,
        useRaf = _ref2$useRaf === undefined ? false : _ref2$useRaf,
        _ref2$useBatch = _ref2.useBatch,
        useBatch = _ref2$useBatch === undefined ? false : _ref2$useBatch,
        _ref2$getBoundingBox = _ref2.getBoundingBox,
        getBoundingBox = _ref2$getBoundingBox === undefined ? false : _ref2$getBoundingBox;

    _classCallCheck(this, ObserverListener);

    _initialiseProps.call(this);

    var callback = void 0;
    if (throttleT == null) callback = this._callback;else callback = throttle(this._callback, throttleT);

    this.GlobalObserver = observerCreator(callback);
    this.eventAttributeName = eventAttributeName;
    this.allEventListeners = {};
    this.useRaf = useRaf;
    this.getBoundingBox = getBoundingBox;
    this.useBatch = useBatch;
    this.runningId = 0;
}

/**
 *
 *  Goes through all the target of ResizeObserver gets the attribute and starts the listener qeue for that instance
 *
 * @param {Array<ResizeObserverEntry | IntersectionObserverEntry>} entries
 * @param {ResizeObserver | IntersectionObserver} observer
 */

/**
 * Goes through all the callbacks of a given element,
 * helps in reducing number of listener instantiated for one elements
 *
 *
 * @param {string} id
 * @param {Element} element
 */

/**
 *
 *  Adds a resize callback for the given element
 *
 * @param {Function} callback
 * @param {Element} element
 * @return {*}
 */
;

/**
 * Function for doing testing on the List for any errors
 * @param {*} head
 */

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this._callback = function (entries, observer) {
        dlog('all entries from ' + _this2.eventAttributeName + ' Hook:', {
            entries: entries
        });

        var op = function op() {
            var totalEntries = entries.length;
            for (var i = 0; i < totalEntries; i++) {
                var entry = entries[i];

                var element = entry.target;
                var id = element.getAttribute(_this2.eventAttributeName);

                if (!!id) {
                    var elementBoundingBox = void 0;
                    var elementContainerBoundingBox = entry.rootBounds;
                    var intersectionRatio = entry.intersectionRatio;
                    var isIntersecting = entry.isIntersecting;
                    if (_this2.getBoundingBox) {
                        elementBoundingBox = entry.boundingClientRect || element.getBoundingClientRect();
                    }

                    _this2.__listenerCallbacks(id, element, observer, elementBoundingBox, elementContainerBoundingBox, intersectionRatio, isIntersecting);
                }
            }
        };
        if (_this2.useRaf) _fastdom2.default.measure(op);else op();
    };

    this.__listenerCallbacks = function (id, element, observer, boundingBox, containerBoundingBox, intersectionRatio, isIntersecting) {
        var start = _this2.allEventListeners[id];
        if (start.next == null && start.prev == null) return;

        dlog('start entry : ', start);
        // TODO Use IdleCallBack and qeueuMicroTask to execute this in BATCHES with Priority
        // Using Batch since lot of element can hook to it and launch updates

        var runner = function runner() {
            while (start) {
                if (start.callback) {
                    var data = {
                        observer: observer,
                        element: element,
                        elementBox: boundingBox,
                        containerBoundingBox: containerBoundingBox,
                        intersectionRatio: intersectionRatio,
                        isIntersecting: isIntersecting,
                        firstLoad: false
                    };

                    start.callback(data);
                }
                start = start.next;
            }
        };
        if (_this2.useBatch) (0, _reactRedux.batch)(runner);else {
            runner();
        }

        // Why use a object list ?
        // We want to optimize specifically for the use case of deletion.
        // Addition is O(1) in array vs linkedlist
        // Deletion which will be more frequent when we have large number of elemnets i.e LazyLoaders listening
        // We need to reliably delete things quickly

        // Other alternative
        // - Events , non blocking but delayed
        // - Raf / RIC schedule todo ..
    };

    this.addCallback = function (callback, element) {
        var id = element.getAttribute(_this2.eventAttributeName);
        if (!id) {
            id = shortid.generate();

            dlog(_this2.eventAttributeName + ' element added first time', element, id);

            element.setAttribute(_this2.eventAttributeName, id);
            // create empty node
            _this2.allEventListeners[id] = {
                callback: null,
                next: null,
                prev: null,
                observer: null,
                id: -1
            };

            var obs = _this2.GlobalObserver;
            _this2.allEventListeners[id].observer = obs;
        }

        // create object with callback
        var object = {
            callback: callback,
            element: element,
            next: null,
            prev: null,
            observer: null,
            id: ++_this2.runningId
        };
        // If it's the empty linked list
        if (_this2.allEventListeners[id].prev === null && _this2.allEventListeners[id].next === null) {
            dlog('adding observer for the first entry ' + _this2.eventAttributeName, element);
            _this2.GlobalObserver.observe(element);
        }

        // Add at the front of the qeue
        _this2.allEventListeners[id].prev = object;
        object.next = _this2.allEventListeners[id];
        object.observer = _this2.allEventListeners[id].observer;
        _this2.allEventListeners[id] = object;

        dlog('added ' + _this2.eventAttributeName + ' callback to : ' + id + ' : all observers :', _this2.allEventListeners[id]);

        return object;
    };

    this.removeCallback = function (object, element) {
        if (object.prev == null && object.next == null) {
            // can tear down the observer here which means we just set it up again
            return null;
        }
        var id = element.getAttribute(_this2.eventAttributeName);

        if (!!id) {
            // prev <-> object <-> next
            var prev = object.prev; //
            var next = object.next; //
            if (prev) prev.next = next; // prev -> next
            if (next) next.prev = prev; // next <- prev

            // prev <-x object x->next
            object.next = null;
            object.prev = null;

            // head -> next
            if (prev == null) {
                _this2.allEventListeners[id] = next;
            }
            // else head -> prev -> next

            // head -> empty-node
            if (_this2.allEventListeners[id].next === null && _this2.allEventListeners[id].prev === null) {
                // last element being assigned , empty node
                _this2.GlobalObserver.unobserve(element);
                dlog('all listener removed from ' + _this2.eventAttributeName, element, _this2.allEventListeners[id]);
            }

            if (DEBUG) {
                validateRemove(_this2.allEventListeners[id], object);
            }

            dlog('remove ' + _this2.eventAttributeName + ' ' + (object.prev == null ? 'last' : '') + ' callback : ' + id + ' ', _this2.allEventListeners[id], 'recieved object : ', object);

            return null;
        }

        return object;
    };
};

function validateRemove(head, object) {
    var start = head;
    dlog('Validating List');
    while (start) {
        if (start.id === object.id) {
            dlog('WARNING -- ' + object + ' still present');
            return;
        }
        if (start.prev === null && head !== start) {
            dlog('WARNING -- ' + head + ' head is inconsistent , prev of head is not null');
            return;
        }

        if (start.next && start.next.prev !== start) {
            dlog('WARNING -- ' + start.next.prev + ' not point to ' + start + ' ');
            return;
        }
        start = start.next;
    }
    dlog('Validation done : Success !!');
}

},{"./GeneralUtils":77,"fastdom":634,"react-redux":1079,"shortid":1163}],83:[function(require,module,exports){
'use strict';

// 'use strict';

var keymirror = require('keymirror');

var PlanType = keymirror({
    SUB: null,
    LIC: null,
    PPV: null,
    OFFER: null
});

function checkIsPaidWorkspace(planType) {
    return planType === PlanType.SUB || planType === PlanType.LIC;
}

module.exports = {
    checkIsPaidWorkspace: checkIsPaidWorkspace
};

},{"keymirror":677}],84:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _cloneextend = require('cloneextend');

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _toArray(arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var RangedValue = function () {
    _createClass(RangedValue, null, [{
        key: 'isRangedValue',
        value: function isRangedValue(rangeStr) {
            try {
                if (!rangeStr) {
                    rangeStr = '[]';
                }
                return Array.isArray(JSON.parse(rangeStr));
            } catch (err) {}
            return false;
        }
    }]);

    function RangedValue(rangeStr, valueKey) {
        var equalityFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v1, v2) {
            return v1 === v2;
        };

        _classCallCheck(this, RangedValue);

        if (!rangeStr) {
            rangeStr = '[]';
        }

        var _JSON$parse = JSON.parse(rangeStr),
            _JSON$parse2 = _toArray(_JSON$parse),
            _JSON$parse2$ = _JSON$parse2[0],
            length = _JSON$parse2$ === undefined ? 0 : _JSON$parse2$,
            rangeValues = _JSON$parse2.slice(1);

        this.length = length;
        this.ranges = rangeValues || [];

        this.valueKey = valueKey;
        this.valueEqualityFunc = equalityFunc;

        this.log();
    }

    _createClass(RangedValue, [{
        key: 'resetRanges',
        value: function resetRanges() {
            this.ranges = [];
        }
    }, {
        key: 'setLength',
        value: function setLength(l) {
            this.length = l;
        }
    }, {
        key: 'forEachIndex',
        value: function forEachIndex(_ref, fn) {
            var start = _ref.start,
                end = _ref.end;

            // start and end should be both inclusive indices
            for (var i = start; i <= end; i++) {
                fn(this.getValueForIndex(i), i, end - start + 1);
            }
        }
    }, {
        key: 'mapIndex',
        value: function mapIndex(_ref2, fn) {
            var start = _ref2.start,
                end = _ref2.end;

            // start and end should be both inclusive indices
            var results = [];
            for (var i = start; i <= end; i++) {
                results.push(fn(this.getValueForIndex(i), i, end - start + 1));
            }
            return results;
        }
    }, {
        key: 'forEachRange',
        value: function forEachRange(fn) {
            var _this = this;

            this.ranges.forEach(function (r, i) {
                return fn(r.start, r.end, r[_this.valueKey], i, _this.ranges.length);
            });
        }
    }, {
        key: 'sortOnStartIndex',
        value: function sortOnStartIndex() {
            this.ranges.sort(function (a, b) {
                return a.start - b.start;
            });
        }
    }, {
        key: 'hasRangeAtIndex',
        value: function hasRangeAtIndex(index) {
            return this.ranges.findIndex(function (r) {
                return r.start <= index && r.end >= index;
            }) !== -1;
        }
    }, {
        key: 'getValueForIndex',
        value: function getValueForIndex(index) {
            if (this.empty) {
                return null;
            }
            var matchedRange = this.ranges.find(function (r) {
                return r.start <= index && r.end >= index;
            });

            if (!!matchedRange) {
                return matchedRange[this.valueKey];
            }

            return null;
        }
    }, {
        key: 'setValueForRangeAtIndex',
        value: function setValueForRangeAtIndex(index, value) {
            this.log('before setValueForRangeAtIndex', index, value);

            if (this.empty) {
                return;
            }
            var matchedRange = this.ranges.find(function (r) {
                return r.start <= index && r.end >= index;
            });

            if (!!matchedRange) {
                matchedRange[this.valueKey] = value;
            }

            this.log('after setValueForRangeAtIndex', index, value);
        }
    }, {
        key: 'removeAtIndex',
        value: function removeAtIndex(index) {
            this.log('before removeAtIndex', index);

            var matchedRange = this.ranges.find(function (r) {
                return r.start <= index && r.end >= index;
            });

            if (!!matchedRange) {
                if (matchedRange.end - matchedRange.start === 0) {
                    this.ranges.splice(this.ranges.indexOf(matchedRange), 1);
                } else {
                    matchedRange.end -= 1;
                }
            }

            // Adjust ranges after the current index
            var rangesAfter = this.ranges.filter(function (r) {
                return r.start > index;
            });

            rangesAfter.forEach(function (r) {
                r.start -= 1;
                r.end -= 1;
            });

            this.length -= 1;

            this.log('after removeAtIndex', index);
        }
        /**
         * Will remove/divide the (highlighted)color range for the selected text
         *
         * @param {Object} currentFocus
         * @memberof RangedValue
         */

    }, {
        key: 'removeRangeAtFocus',
        value: function removeRangeAtFocus(currentFocus) {
            this.log('before remove range atFocus', currentFocus.start);

            var _ref3 = currentFocus || { length: this.rangedValue.length },
                _ref3$start = _ref3.start,
                start = _ref3$start === undefined ? 0 : _ref3$start,
                length = _ref3.length,
                _ref3$end = _ref3.end,
                end = _ref3$end === undefined ? length : _ref3$end;

            var matchedRange = this.ranges.find(function (r) {
                return r.start <= start && r.end >= start;
            });

            if (!!matchedRange) {
                var cloneMatched = (0, _cloneextend.clone)(matchedRange),
                    useClone = false;

                if (start == end || matchedRange.start >= start && matchedRange.end <= end) {
                    this.ranges.splice(this.ranges.indexOf(matchedRange), 1);
                } else {
                    // if the selection is made between the start and end point, then the matched range will be divided into 2 pieces and second will be pushed into ranges

                    if (matchedRange.start >= start) {
                        matchedRange.start = end;
                    } else if (matchedRange.start < start) {
                        matchedRange.end = start - 1;
                        useClone = true;
                    }
                    if (cloneMatched.end > end && useClone) {
                        // push the second part of the divided range
                        cloneMatched.start = end;
                        this.ranges.push(cloneMatched);
                    }
                }
            }
            this.log('after remove range atFocus', currentFocus.start);
        }
    }, {
        key: 'insertAtIndex',
        value: function insertAtIndex(index) {
            this.log('before insertAtIndex', index);

            var matchedRange = this.ranges.find(function (r) {
                return r.start < index && r.end >= index - 1;
            });

            if (!!matchedRange) {
                if (matchedRange.end - matchedRange.start === 0) {
                    this.ranges.splice[(this.ranges.indexOf(matchedRange), 1)];
                } else {
                    matchedRange.end += 1;
                }
            }

            //Adjust ranges after the current index
            var rangesAfter = this.ranges.filter(function (r) {
                return r.start >= index;
            });

            rangesAfter.forEach(function (r) {
                r.start += 1;
                r.end += 1;
            });

            this.length += 1;
            this.log('after insertAtIndex', index);
        }
    }, {
        key: 'addRange',
        value: function addRange(value, rangeStart, rangeEnd) {
            var _this2 = this;

            this.log('before addRange', rangeStart, rangeEnd, value);

            this.sortOnStartIndex();

            var ranges = this.ranges;

            var needToAdd = true;
            var toRemove = [];

            ranges.forEach(function (r, i, arr) {
                var rangeOverlaps = !(r.end < rangeStart || r.start > rangeEnd);

                if (rangeOverlaps) {
                    if (_this2.valueEqualityFunc(r[_this2.valueKey], value)) {
                        needToAdd = false;
                        r.start = Math.min(r.start, rangeStart);
                        r.end = Math.max(r.end, rangeEnd);
                    } else {
                        if (r.start >= rangeStart && r.end <= rangeEnd) {
                            toRemove.push(r);
                        } else if (r.start < rangeStart) {
                            if (r.end <= rangeEnd) {
                                r.end = rangeStart - 1;
                            } else {
                                var _arr$push;

                                //break range
                                arr.push((_arr$push = {}, _defineProperty(_arr$push, _this2.valueKey, r[_this2.valueKey]), _defineProperty(_arr$push, 'start', rangeEnd + 1), _defineProperty(_arr$push, 'end', r.end), _arr$push));
                                r.end = rangeStart - 1;
                            }
                        } else if (r.end > rangeEnd) {
                            r.start = rangeEnd + 1;
                        }
                    }
                }
            });
            toRemove.forEach(function (r) {
                ranges.splice(ranges.indexOf(r), 1);
            });
            if (needToAdd) {
                var _ranges$push;

                ranges.push((_ranges$push = {}, _defineProperty(_ranges$push, this.valueKey, value), _defineProperty(_ranges$push, 'start', rangeStart), _defineProperty(_ranges$push, 'end', rangeEnd), _ranges$push));
            }
            this.log('after addRange', rangeStart, rangeEnd, value);
        }
    }, {
        key: 'log',
        value: function log() {
            if (window.DEBUG) {
                var _console;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                (_console = console).log.apply(_console, ['RangedValue'].concat(args));
                console.log('RangedValue', this.toString());
            }
        }
    }, {
        key: 'toString',
        value: function toString() {
            return JSON.stringify([this.length].concat(this.ranges));
        }
    }, {
        key: 'empty',
        get: function get() {
            return !this.ranges || this.ranges.length == 0;
        }
    }]);

    return RangedValue;
}();

exports.default = RangedValue;

},{"cloneextend":412}],85:[function(require,module,exports){
'use strict';

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var shortid = require('shortid');
var cloner = require('cloneextend');

var _require = require('lodash'),
    memoize = _require.memoize,
    cloneDeep = _require.cloneDeep;

var floor = Math.floor,
    max = Math.max,
    min = Math.min;

var _require2 = require('./GeneralUtils'),
    deepFreeze = _require2.deepFreeze,
    degreeToRadian = _require2.degreeToRadian,
    absoluteCosVal = _require2.absoluteCosVal,
    absoluteSinVal = _require2.absoluteSinVal;

var _require3 = require('../constants/SolidImage'),
    SolidImageId = _require3.SolidImageId,
    SolidImageData = _require3.SolidImageData;

var TransitionType = require('./enums/TransitionType');

var CUSTOM_FORMAT_FRAME_TYPE = 'custom-format-';
var MAX_ZOOM_FACTOR = 5;
var MIN_CLIP_DURATION = 1000; // 1 sec
var MAX_IMAGE_CLIP_DURATION = 10000 * 1000; // 2.5 hours
var MIN_CLIP_DURATION_CROSS_DISOLVE = 2000; // 2 sec
var MIN_CLIP_DURATION_FOR_SPLIT = 1000; // 1000 milliseconds

var FrameTypes = deepFreeze({
    DEFAULT: {
        deprecated: true,

        name: 'Default',
        aspect_ratio_label: 'Auto',
        size: 'original',
        content_box: 'fill',
        fit_constraint: 'fill'
    },
    'SQUARE-CROPPED': {
        deprecated: true,

        name: 'Square Simple',
        aspect_ratio_label: '1:1',
        size: { width: 1080, height: 1080 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'SQUARE-PADDED': {
        deprecated: true,

        name: 'Square Letterbox',
        aspect_ratio_label: '1:1',
        size: { width: 1080, height: 1080 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    'BEST-FIT': {
        deprecated: true,

        name: 'Best Fit',
        aspect_ratio_label: 'Auto',
        size: 'auto',
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    VERTICAL: {
        deprecated: true,

        name: 'Mobile',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'VERTICAL-PADDED': {
        deprecated: true,

        name: 'Mobile Letterbox',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    'VERTICAL-PADDED-TOP': {
        deprecated: true,

        name: 'Mobile Letterbox Top',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: 'fill',
        fit_constraint: 'contain',
        fit_align: 'center top'
    },
    WIDESCREEN: {
        deprecated: true,

        name: 'Widescreen',
        aspect_ratio_label: '16:9',
        size: { width: 1920, height: 1080 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'FB-VERTICAL': {
        deprecated: true,

        name: 'FB Mobile',
        aspect_ratio_label: '4:5',
        size: { width: 1000, height: 1250 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'FB-VERTICAL-PADDED': {
        deprecated: true,

        name: 'FB Mobile Letterbox',
        aspect_ratio_label: '4:5',
        size: { width: 1000, height: 1250 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    'FB-LANDSCAPE': {
        deprecated: true,

        name: 'FB Landscape',
        aspect_ratio_label: '5:4',
        size: { width: 1250, height: 1000 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'FB-LANDSCAPE-PADDED': {
        deprecated: true,

        name: 'FB Landscape Letterbox',
        aspect_ratio_label: '5:4',
        size: { width: 1250, height: 1000 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    'BILLBOARD-MIDDLE-TOP': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Triple Play Top Board',
        aspect_ratio_label: '544:4160',
        size: { width: 544, height: 4160 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-BOTTOM-LEFT': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Triple Play Bottom Left Board',
        aspect_ratio_label: '2240:560',
        size: { width: 2240, height: 560 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-BOTTOM-RIGHT': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Triple Play Bottom Right Board',
        aspect_ratio_label: '2240:560',
        size: { width: 2240, height: 560 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-PLACE-TOP': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Crossroads Top Board',
        aspect_ratio_label: '640:1696',
        size: { width: 640, height: 1696 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-PLACE-BOTTOM': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Crossroads Bottom Board',
        aspect_ratio_label: '1056:672',
        size: { width: 1056, height: 672 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-TOP': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Waterfall Top Board',
        aspect_ratio_label: '416:1584',
        size: { width: 416, height: 1584 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-MIDDLE': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Waterfall Middle Board',
        aspect_ratio_label: '416:1376',
        size: { width: 416, height: 1376 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-BOTTOM': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Waterfall Bottom Board',
        aspect_ratio_label: '1344:1696',
        size: { width: 1344, height: 1696 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-COMMUTER-TOP': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Commuter top board',
        aspect_ratio_label: '760:200',
        size: { width: 760, height: 200 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-COMMUTER-LEFT': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Commuter left side board',
        aspect_ratio_label: '300:256',
        size: { width: 300, height: 256 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-COMMUTER-RIGHT': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Commuter right side board',
        aspect_ratio_label: '370:618',
        size: { width: 370, height: 618 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    'BILLBOARD-COMMUTER-CENTER': {
        customFrame: true,
        customKey: 'billboard',

        name: 'Commuter center board',
        aspect_ratio_label: '600:256',
        size: { width: 600, height: 256 },
        content_box: 'fill',
        fit_constraint: 'cover'
    },
    ft_square: {
        name: 'Square Simple',
        aspect_ratio_label: '1:1',
        size: { width: 1080, height: 1080 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_square_letterbox: {
        name: 'Square Letterbox',
        aspect_ratio_label: '1:1',
        size: { width: 1080, height: 1080 },
        content_box: { x: 0, y: 216, width: 1080, height: 648 },
        fit_constraint: 'contain'
    },
    ft_mobile: {
        name: 'Mobile',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_mobile_letterbox: {
        name: 'Mobile Letterbox',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: { x: 0, y: 420, width: 1080, height: 1080 },
        fit_constraint: 'contain'
    },
    ft_mobile_letterbox_top: {
        name: 'Mobile Letterbox Top',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: { x: 0, y: 0, width: 1080, height: 1080 },
        fit_constraint: 'contain'
    },
    ft_mobile_letterbox_bottom: {
        name: 'Mobile Letterbox Bottom',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: { x: 0, y: 840, width: 1080, height: 1080 },
        fit_constraint: 'contain'
    },
    ft_curejoy_mobile_letterbox_bottom: {
        customFrame: true,
        customKey: 'curejoy',

        name: 'Mobile Letterbox Bottom',
        aspect_ratio_label: '9:16',
        size: { width: 1080, height: 1920 },
        content_box: { x: 0, y: 840, width: 1080, height: 1080 },
        fit_constraint: 'contain'
    },
    ft_widescreen_4x3: {
        name: 'Widescreen',
        aspect_ratio_label: '4:3',
        size: { width: 1920, height: 1440 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_widescreen: {
        name: 'Widescreen',
        aspect_ratio_label: '16:9',
        size: { width: 1920, height: 1080 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_facebook_mobile: {
        customFrame: true,
        customKey: 'facebook',

        name: 'FB Mobile',
        aspect_ratio_label: '4:5',
        size: { width: 1536, height: 1920 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_facebook_cover: {
        name: 'FB Cover',
        aspect_ratio_label: '21:9',
        size: { width: 1920, height: 822 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_facebook_mobile_2x3: {
        name: 'FB Mobile',
        aspect_ratio_label: '2:3',
        size: { width: 1280, height: 1920 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_facebook_mobile_letterbox: {
        customFrame: true,
        customKey: 'facebook',

        name: 'FB Mobile Letterbox',
        aspect_ratio_label: '4:5',
        size: { width: 1536, height: 1920 },
        content_box: { x: 0, y: 192, width: 1536, height: 1536 },
        fit_constraint: 'contain'
    },
    ft_facebook_landscape: {
        customFrame: true,
        customKey: 'facebook',

        name: 'FB Landscape',
        aspect_ratio_label: '5:4',
        size: { width: 1250, height: 1000 },
        content_box: 'fill',
        fit_constraint: 'contain'
    },
    ft_facebook_landscape_letterbox: {
        customFrame: true,
        customKey: 'facebook',

        name: 'FB Landscape Letterbox',
        aspect_ratio_label: '5:4',
        size: { width: 1250, height: 1000 },
        content_box: { x: 0, y: 200, width: 1250, height: 600 },
        fit_constraint: 'contain'
    }
});

/**
 * Returns a frame type information for a single frametype
 * the frametype provided MUST BE OF VALID frameType in list above
 * supported by Typito
 *
 * @param {*} frameType
 */
var getFrameTypeInfo = function getFrameTypeInfo(frameType) {
    return FrameTypes[frameType];
};

var DEFAULT_FORMAT_TYPE_ID = 'standard_widescreen_16x9';

var FormatGroups = deepFreeze({
    instagram: {
        label: 'Instagram',
        iconId: 'instagram-logo'
    },
    facebook: {
        label: 'Facebook',
        iconId: 'facebook-logo'
    },
    youtube: {
        label: 'YouTube',
        iconId: 'youtube-logo'
    },
    linkedin: {
        label: 'LinkedIn',
        iconId: 'linkedin-logo'
    },
    twitter: {
        label: 'Twitter',
        iconId: 'twitter-logo'
        // 'standard' : {
        //     'label' : 'Standard'
        // },
        // 'billboard' : {
        //     'label' : 'Billboard',
        //     'custom' : true
        // }
    } });

var newFormatTypes = deepFreeze({
    insta_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'insta_widescreen_16x9.png',
        useCase: 'Best for Video Posts, & IGTV',
        groupId: 'instagram',
        pixels: '1920 x 1080'
    },
    insta_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'insta_vertical_9x16.png',
        useCase: 'Best for Video Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_letterbox_9x16: {
        frameType: 'ft_mobile_letterbox',
        label: 'Vertical Letterbox',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'insta_vertical_letterbox_9x16.png',
        useCase: 'Best for Video Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_letterbox_top_9x16: {
        frameType: 'ft_mobile_letterbox_top',
        label: 'Vertical Letterbox Top',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'insta_vertical_letterbox_top_9x16.png',
        useCase: 'Best for Video Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_letterbox_bottom_9x16: {
        frameType: 'ft_mobile_letterbox_bottom',
        label: 'Vertical Letterbox Bottom',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'insta_vertical_letterbox_bottom_9x16.png',
        useCase: 'Best for Video Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_4x5: {
        frameType: 'ft_facebook_mobile',
        label: 'Vertical',
        size: '4:5',
        sar: 4 / 5,
        previewFileName: 'insta_vertical_4x5.png',
        useCase: 'Best for Portrait Video Post & In-feed Ads',
        groupId: 'instagram',
        pixels: '1080 x 1350'
    },
    insta_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: 'insta_square_1x1.png',
        useCase: 'Best for Square Video Post & In-feed Ads',
        groupId: 'instagram',
        pixels: '1080 X 1080'
    },
    fb_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'fb_widescreen_16x9.png',
        useCase: 'Best for Feed, Stories, Marketplace, & In-stream Ads',
        groupId: 'facebook',
        pixels: '1920 x 1080'
    },
    fb_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'fb_vertical_9x16.png',
        useCase: 'Best for Feed, Stories, Marketplace, & In-stream Ads',
        groupId: 'facebook',
        type: 'story',
        pixels: '1080 X 1920 '
    },
    fb_vertical_4x5: {
        frameType: 'ft_facebook_mobile',
        label: 'Vertical',
        size: '4:5',
        sar: 4 / 5,
        previewFileName: 'fb_vertical_4x5.png',
        useCase: 'Best for Feed, Stories, Marketplace, & In-stream Ads',
        groupId: 'facebook',
        pixels: '1080 X 1350'
    },
    fb_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: 'fb_square_1x1.png',
        useCase: 'Best for Search Result Video Ads ',
        groupId: 'facebook',
        pixels: '1080 X 1080'
    },
    fb_square_letterbox_1x1: {
        frameType: 'ft_square_letterbox',
        label: 'Square Letterbox',
        size: '1:1',
        sar: 1,
        previewFileName: 'fb_square_letterbox_1x1.png',
        useCase: 'Feed, Instant Articles',
        groupId: 'facebook'
    },
    linkedin_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'linkedin_widescreen_16x9.png',
        useCase: 'Best for Videos & Ads',
        groupId: 'linkedin',
        pixels: '1920 x 1080'
    },
    linkedin_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'fb_vertical_9x16.png',
        useCase: 'Best for Videos & Ads',
        groupId: 'linkedin',
        type: 'story',
        pixels: '1080 X 1920 '
    },
    linkedin_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: 'linkedin_square_1x1.png',
        useCase: 'Best for Videos & Ads',
        groupId: 'linkedin',
        pixels: '1080 X 1080'
    },
    twitter_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'twitter_widescreen_16x9.png',
        useCase: 'Best for In-feed Videos, & Video Ads',
        groupId: 'twitter',
        pixels: '1280 x 720'
    },
    twitter_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: 'twitter_square_1x1.png',
        useCase: 'Best for Video Ads, & Carousel Ads',
        groupId: 'twitter',
        pixels: '720 x 720'
    },
    youtube_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'youtube_widescreen_16x9.png',
        useCase: 'Best for Standard Videos, & Video Ads',
        groupId: 'youtube',
        pixels: '1920 x 1080'
    },
    youtube_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'youtube_vertical_9x16.png',
        useCase: 'Best for YouTube Shorts ',
        groupId: 'youtube',
        type: 'story',
        pixels: '1080 X 1920 '
    }
});

var linkPrefix = 'https://storage.googleapis.com/typito-srijith-app-public/format-sample-media';

var previewDataLinks = deepFreeze({
    facebook: {
        '16_9': {
            previewImage: '',
            previewVideo: '/Facebook16_9.webm'
        },
        '1_1': {
            previewImage: '',
            previewVideo: '/Facebook1_1%26Twitter1_1.webm'
        },
        '4_5': {
            previewImage: '',
            previewVideo: '/Facebook4_5.webm'
        },
        '9_16': {
            previewImage: '',
            previewVideo: '/Facebook9_16.webm'
        }
    },
    instagram: {
        '16_9': {
            previewImage: '',
            previewVideo: '/Instagram16_9.webm'
        },
        '1_1': {
            previewImage: '',
            previewVideo: '/Instagram1_1.webm'
        },
        '4_5': {
            previewImage: '',
            previewVideo: '/Instagram4_5.webm'
        },
        '9_16': {
            previewImage: '',
            previewVideo: '/Instagram9_16.webm'
        }
    },
    linkedin: {
        '16_9': {
            previewImage: '',
            previewVideo: '/LinkedIn16_9.webm'
        },
        '1_1': {
            previewImage: '',
            previewVideo: '/LinkedIn1_1.webm'
        }
    },
    youtube: {
        '16_9': {
            previewImage: '',
            previewVideo: '/YouTube16_9.webm'
        },
        '9_16': {
            previewImage: '',
            previewVideo: '/YouTube9_16.webm'
        }
    }
});

var FormatTypes = deepFreeze({
    fb_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: _extends({}, previewDataLinks.facebook['16_9']),
        useCase: 'Best for Feed, Stories, Marketplace, & In-stream Ads',
        groupId: 'facebook',
        pixels: '1920 x 1080'
    },
    fb_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.facebook['9_16']),
        useCase: 'Best for Feed, Stories, Marketplace, & In-stream Ads',
        groupId: 'facebook',
        type: 'story',
        pixels: '1080 X 1920'
    },
    fb_vertical_4x5: {
        frameType: 'ft_facebook_mobile',
        label: 'Vertical',
        size: '4:5',
        sar: 4 / 5,
        previewFileName: _extends({}, previewDataLinks.facebook['4_5']),
        useCase: 'Best for Feed, Stories, Marketplace, & In-stream Ads',
        groupId: 'facebook',
        pixels: '1080 X 1350',
        trending: true
    },
    fb_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: _extends({}, previewDataLinks.facebook['1_1']),
        useCase: 'Best for Search Result Video Ads ',
        groupId: 'facebook',
        pixels: '1080 X 1080'
    },
    fb_square_letterbox_1x1: {
        frameType: 'ft_square_letterbox',
        label: 'Square Letterbox',
        size: '1:1',
        sar: 1,
        previewFileName: _extends({}, previewDataLinks.facebook['16_9']),
        useCase: 'Best for Feed, Instant Articles',
        groupId: 'facebook',
        pixels: '1080 X 1080'
    },
    fb_vertical_2x3: {
        frameType: 'ft_facebook_mobile_2x3',
        label: 'Vertical',
        size: '2:3',
        sar: 2 / 3,
        previewFileName: _extends({}, previewDataLinks.facebook['4_5']),
        useCase: 'Best for Feed',
        groupId: 'facebook',
        pixels: '600 X 900'
    },
    fb_cover_16x9: {
        frameType: 'ft_facebook_cover',
        label: 'Cover',
        size: '21:9',
        sar: 21 / 9,
        previewFileName: _extends({}, previewDataLinks.facebook['16_9']),
        useCase: 'Best for Facebook Cover Videos',
        groupId: 'facebook',
        pixels: '820 x 312'
    },
    insta_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: _extends({}, previewDataLinks.instagram['16_9']),
        useCase: 'Best for Video Posts, & IGTV',
        groupId: 'instagram',
        pixels: '1920 x 1080'
    },
    insta_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.instagram['9_16']),
        useCase: 'Best for Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920',
        trending: true
    },
    insta_vertical_letterbox_9x16: {
        frameType: 'ft_mobile_letterbox',
        label: 'Vertical Letterbox',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.instagram['1_1']),
        useCase: 'Best for Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_letterbox_top_9x16: {
        frameType: 'ft_mobile_letterbox_top',
        label: 'Vertical Letterbox Top',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.instagram['1_1']),
        useCase: 'Best for Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_letterbox_bottom_9x16: {
        frameType: 'ft_mobile_letterbox_bottom',
        label: 'Vertical Letterbox Bottom',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.instagram['1_1']),
        useCase: 'Best for Stories, Reels, Ads, & IGTV',
        groupId: 'instagram',
        type: 'story',
        pixels: '1080 x 1920'
    },
    insta_vertical_4x5: {
        frameType: 'ft_facebook_mobile',
        label: 'Vertical',
        size: '4:5',
        sar: 4 / 5,
        previewFileName: _extends({}, previewDataLinks.instagram['4_5']),
        useCase: 'Best for Portrait Video Post & In-feed Ads',
        groupId: 'instagram',
        pixels: '1080 x 1350'
    },
    insta_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: _extends({}, previewDataLinks.instagram['1_1']),
        useCase: 'Best for Square Video Post & In-feed Ads',
        groupId: 'instagram',
        pixels: '1080 X 1080'
    },
    youtube_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: _extends({}, previewDataLinks.youtube['16_9']),
        useCase: 'Best for Videos & Ads',
        groupId: 'youtube',
        pixels: '1920 x 1080',
        trending: true
    },
    youtube_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.youtube['9_16']),
        useCase: 'Best for YouTube Shorts ',
        groupId: 'youtube',
        type: 'story',
        pixels: '1080 X 1920 '
    },
    twitter_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'twitter_widescreen_16x9.png',
        useCase: 'Feed',
        groupId: 'twitter'
    },
    twitter_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: 'twitter_square_1x1.png',
        useCase: 'Feed',
        groupId: 'twitter'
    },
    linkedin_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: _extends({}, previewDataLinks.linkedin['16_9']),
        useCase: 'Best for Videos & Ads',
        groupId: 'linkedin',
        pixels: '1920 x 1080'
    },
    linkedin_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: _extends({}, previewDataLinks.facebook['9_16']),
        useCase: 'Best for Videos & Ads',
        groupId: 'linkedin',
        type: 'story',
        pixels: '1080 X 1920 '
    },
    linkedin_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: _extends({}, previewDataLinks.linkedin['1_1']),
        useCase: 'Best for Videos & Ads',
        groupId: 'linkedin',
        pixels: '1080 X 1080',
        trending: true
    },
    linkedin_vertical_2x3: {
        frameType: 'ft_facebook_mobile_2x3',
        label: 'Vertical',
        size: '2:3',
        sar: 2 / 3,
        previewFileName: _extends({}, previewDataLinks.instagram['4_5']),
        useCase: 'Best for Video Posts',
        groupId: 'linkedin',
        pixels: '600 X 900',
        trending: true
    },
    linkedin_vertical_4x5: {
        frameType: 'ft_facebook_mobile',
        label: 'Vertical',
        size: '4:5',
        sar: 4 / 5,
        previewFileName: _extends({}, previewDataLinks.instagram['4_5']),
        useCase: 'Best for Video post',
        groupId: 'linkedin',
        pixels: '1080 X 1350'
    },
    standard_square_1x1: {
        frameType: 'ft_square',
        label: 'Square',
        size: '1:1',
        sar: 1,
        previewFileName: 'standard_square_1x1.png',
        groupId: 'standard'
    },
    standard_vertical_4x5: {
        frameType: 'ft_facebook_mobile',
        label: 'Vertical',
        size: '4:5',
        sar: 4 / 5,
        previewFileName: 'standard_vertical_4x5.png',
        groupId: 'standard'
    },
    standard_vertical_2x3: {
        frameType: 'ft_facebook_mobile_2x3',
        label: 'Vertical',
        size: '2:3',
        sar: 2 / 3,
        previewFileName: 'standard_vertical_2x3.png',
        groupId: 'standard'
    },
    standard_vertical_9x16: {
        frameType: 'ft_mobile',
        label: 'Vertical',
        size: '9:16',
        sar: 9 / 16,
        previewFileName: 'standard_vertical_9x16.png',
        groupId: 'standard'
    },
    standard_widescreen_4x3: {
        frameType: 'ft_widescreen_4x3',
        label: 'Widescreen',
        size: '4:3',
        sar: 4 / 3,
        previewFileName: 'standard_widescreen_4x3.png',
        groupId: 'standard'
    },
    standard_widescreen_16x9: {
        frameType: 'ft_widescreen',
        label: 'Widescreen',
        size: '16:9',
        sar: 16 / 9,
        previewFileName: 'standard_widescreen_16x9.png',
        groupId: 'standard'
    },
    billboard_triple_play_top_board: {
        frameType: 'BILLBOARD-MIDDLE-TOP',
        label: 'Triple Play Top Board',
        size: '544 x 4160',
        sar: 544 / 4160,
        groupId: 'billboard'
    },
    billboard_triple_play_bottom_left_board: {
        frameType: 'BILLBOARD',
        label: 'Triple Play Bottom Left Board',
        size: '2240 x 560',
        sar: 2240 / 560,
        groupId: 'billboard'
    },
    billboard_triple_play_bottom_right_board: {
        frameType: 'BILLBOARD-BOTTOM-RIGHT',
        label: 'Triple Play Bottom Right Board',
        size: '2240 x 560',
        sar: 2240 / 560,
        groupId: 'billboard'
    },
    billboard_crossroads_top_board: {
        frameType: 'BILLBOARD-PLACE-TOP',
        label: 'Crossroads Top Board',
        size: '640 x 1696',
        sar: 640 / 1696,
        groupId: 'billboard'
    },
    billboard_crossroads_bottom_board: {
        frameType: 'BILLBOARD-PLACE-BOTTOM',
        label: 'Crossroads Bottom Board',
        size: '1056 x 672',
        sar: 1056 / 672,
        groupId: 'billboard'
    },
    billboard_waterfall_top_board: {
        frameType: 'BILLBOARD-TOP',
        label: 'Waterfall Top Board',
        size: '416 x 1584',
        sar: 416 / 1584,
        groupId: 'billboard'
    },
    billboard_waterfall_middle_board: {
        frameType: 'BILLBOARD-MIDDLE',
        label: 'Waterfall Middle Board',
        size: '416 x 1376',
        sar: 416 / 1376,
        groupId: 'billboard'
    },
    billboard_waterfall_bottom_board: {
        frameType: 'BILLBOARD-BOTTOM',
        label: 'Waterfall Bottom Board',
        size: '1344 x 1696',
        sar: 1344 / 1696,
        groupId: 'billboard'
    },
    billboard_commuter_top_board: {
        frameType: 'BILLBOARD-COMMUTER-TOP',
        label: 'Commuter Top Board',
        size: '760 x 200',
        sar: 760 / 200,
        groupId: 'billboard'
    },
    billboard_commuter_left_board: {
        frameType: 'BILLBOARD-COMMUTER-LEFT',
        label: 'Commuter Left Side Board',
        size: '300 x 256',
        sar: 300 / 256,
        groupId: 'billboard'
    },
    billboard_commuter_right_board: {
        frameType: 'BILLBOARD-COMMUTER-RIGHT',
        label: 'Commuter Right Side Board',
        size: '370 x 618',
        sar: 370 / 618,
        groupId: 'billboard'
    },
    billboard_commuter_center_board: {
        frameType: 'BILLBOARD-COMMUTER-CENTER',
        label: 'Commuter Center Board',
        size: '600 x 256',
        sar: 600 / 256,
        groupId: 'billboard'
    }
});

// const FormatTypes = deepFreeze({
//     'fb_widescreen_16x9' : {
//         'frameType' : 'ft_widescreen',
//         'label' : 'Widescreen',
//         'size' : '16:9',
//         'sar' : 16/9,
//         'previewFileName' : 'fb_widescreen_16x9.png',
//         'useCase' : 'Feed, In-Stream (5 - 15 sec), Instant Articles',
//         'groupId' : 'facebook',
//     },
//     'fb_vertical_4x5' : {
//         'frameType' : 'ft_facebook_mobile',
//         'label' : 'Vertical',
//         'size' : '4:5',
//         'sar' : 4/5,
//         'previewFileName' : 'fb_vertical_4x5.png',
//         'useCase' : 'Feed',
//         'groupId' : 'facebook'
//     },
//     'fb_vertical_2x3' : {
//         'frameType' : 'ft_facebook_mobile_2x3',
//         'label' : 'Vertical',
//         'size' : '2:3',
//         'sar' : 2/3,
//         'previewFileName' : 'fb_vertical_2x3.png',
//         'useCase' : 'Feed',
//         'groupId' : 'facebook'
//     },
//     'fb_vertical_9x16' : {
//         'frameType' : 'ft_mobile',
//         'label' : 'Vertical',
//         'size' : '9:16',
//         'sar' :9/16,
//         'previewFileName' : 'fb_vertical_9x16.png',
//         'useCase' : 'Feed',
//         'groupId' : 'facebook'
//     },
//     'fb_square_1x1' : {
//         'frameType' : 'ft_square',
//         'label' : 'Square',
//         'size' : '1:1',
//         'sar' : 1,
//         'previewFileName' : 'fb_square_1x1.png',
//         'useCase' : 'Feed, Carousel video ad, In-Stream (5 - 15 sec)',
//         'groupId' : 'facebook'
//     },
//     'fb_square_letterbox_1x1' : {
//         'frameType' : 'ft_square_letterbox',
//         'label' : 'Square Letterbox',
//         'size' : '1:1',
//         'sar' : 1,
//         'previewFileName' : 'fb_square_letterbox_1x1.png',
//         'useCase' : 'Feed, Instant Articles',
//         'groupId' : 'facebook'
//     },
//     'fb_cover_16x9' : {
//         'frameType' : 'ft_facebook_cover',
//         'label' : 'Cover',
//         'size' : '21:9',
//         'sar' : 21/9,
//         'previewFileName' : 'fb_cover_16x9.png',
//         'useCase' : 'Facebook cover video (820 x 312)',
//         'groupId' : 'facebook'
//     },
//     'insta_square_1x1' : {
//         'frameType' : 'ft_square',
//         'label' : 'Square',
//         'size' : '1:1',
//         'sar' : 1,
//         'previewFileName' : 'insta_square_1x1.png',
//         'useCase' : 'Feed',
//         'groupId' : 'instagram'
//     },
//     'insta_vertical_4x5' : {
//         'frameType' : 'ft_facebook_mobile',
//         'label' : 'Vertical',
//         'size' : '4:5',
//         'sar' : 4/5,
//         'previewFileName' : 'insta_vertical_4x5.png',
//         'useCase' : 'Feed',
//         'groupId' : 'instagram'
//     },
//     'insta_vertical_9x16' : {
//         'frameType' : 'ft_mobile',
//         'label' : 'Vertical',
//         'size' : '9:16',
//         'sar' : 9/16,
//         'previewFileName' : 'insta_vertical_9x16.png',
//         'useCase' : 'Story, IGTV (900x1600)',
//         'groupId' : 'instagram',
//         'type' : 'story',
//     },
//     'insta_vertical_letterbox_9x16' : {
//         'frameType' : 'ft_mobile_letterbox',
//         'label' : 'Vertical Letterbox',
//         'size' : '9:16',
//         'sar' : 9/16,
//         'previewFileName' : 'insta_vertical_letterbox_9x16.png',
//         'useCase' : 'Story, IGTV',
//         'groupId' : 'instagram',
//         'type' : 'story',
//         'paddingTop' : '25%',
//         'paddingBottom' : '25%'
//     },
//     'insta_vertical_letterbox_top_9x16' : {
//         'frameType' : 'ft_mobile_letterbox_top',
//         'label' : 'Vertical Letterbox Top',
//         'size' : '9:16',
//         'sar' : 9/16,
//         'previewFileName' : 'insta_vertical_letterbox_top_9x16.png',
//         'useCase' : 'Story, IGTV',
//         'groupId' : 'instagram',
//         'type' : 'story',
//         'paddingTop' : '50%',
//         'paddingBottom' : '0'
//     },
//     'insta_vertical_letterbox_bottom_9x16' : {
//         'frameType' : 'ft_mobile_letterbox_bottom',
//         'label' : 'Vertical Letterbox Bottom',
//         'size' : '9:16',
//         'sar' : 9/16,
//         'previewFileName' : 'insta_vertical_letterbox_bottom_9x16.png',
//         'useCase' : 'Story, IGTV',
//         'groupId' : 'instagram',
//         'type' : 'story',
//         'paddingTop' : '0',
//         'paddingBottom' : '50%'
//     },
//     'youtube_widescreen_16x9' : {
//         'frameType' : 'ft_widescreen',
//         'label' : 'Widescreen',
//         'size' : '16:9',
//         'sar' : 16/9,
//         'previewFileName' : 'youtube_widescreen_16x9.png',
//         'useCase' : 'Standard YouTube video, Skippable video ad, Non-skippable video ad, Mid-roll video ad, Bumper video ad',
//         'groupId' : 'youtube'
//     },
//     'twitter_widescreen_16x9' : {
//         'frameType' : 'ft_widescreen',
//         'label' : 'Widescreen',
//         'size' : '16:9',
//         'sar' : 16/9,
//         'previewFileName' : 'twitter_widescreen_16x9.png',
//         'useCase' : 'Feed',
//         'groupId' : 'twitter'
//     },
//     'twitter_square_1x1' : {
//         'frameType' : 'ft_square',
//         'label' : 'Square',
//         'size' : '1:1',
//         'sar' : 1,
//         'previewFileName' : 'twitter_square_1x1.png',
//         'useCase' : 'Feed',
//         'groupId' : 'twitter'
//     },
//     'linkedin_square_1x1' : {
//         'frameType' : 'ft_square',
//         'label' : 'Square',
//         'size' : '1:1',
//         'sar' : 1,
//         'previewFileName' : 'linkedin_square_1x1.png',
//         'useCase' : 'Video post, Video ad',
//         'groupId' : 'linkedin'
//     },
//     'linkedin_vertical_2x3' : {
//         'frameType' : 'ft_facebook_mobile_2x3',
//         'label' : 'Vertical',
//         'size' : '2:3',
//         'sar' : 2/3,
//         'previewFileName' : 'linkedin_vertical_2x3.png',
//         'useCase' : 'Video post',
//         'groupId' : 'linkedin'
//     },
//     'linkedin_vertical_4x5' : {
//         'frameType' : 'ft_facebook_mobile',
//         'label' : 'Vertical',
//         'size' : '4:5',
//         'sar' : 4/5,
//         'previewFileName' : 'linkedin_vertical_4x5.png',
//         'useCase' : 'Video post',
//         'groupId' : 'linkedin'
//     },
//     'linkedin_widescreen_16x9' : {
//         'frameType' : 'ft_widescreen',
//         'label' : 'Widescreen',
//         'size' : '16:9',
//         'sar' : 16/9,
//         'previewFileName' : 'linkedin_widescreen_16x9.png',
//         'useCase' : 'Video post, Video ad',
//         'groupId' : 'linkedin'
//     },
//     'standard_square_1x1' : {
//         'frameType' : 'ft_square',
//         'label' : 'Square',
//         'size' : '1:1',
//         'sar' : 1,
//         'previewFileName' : 'standard_square_1x1.png',
//         'groupId' : 'standard'
//     },
//     'standard_vertical_4x5' : {
//         'frameType' : 'ft_facebook_mobile',
//         'label' : 'Vertical',
//         'size' : '4:5',
//         'sar' : 4/5,
//         'previewFileName' : 'standard_vertical_4x5.png',
//         'groupId' : 'standard'
//     },
//     'standard_vertical_2x3' : {
//         'frameType' : 'ft_facebook_mobile_2x3',
//         'label' : 'Vertical',
//         'size' : '2:3',
//         'sar' : 2/3,
//         'previewFileName' : 'standard_vertical_2x3.png',
//         'groupId' : 'standard'
//     },
//     'standard_vertical_9x16' : {
//         'frameType' : 'ft_mobile',
//         'label' : 'Vertical',
//         'size' : '9:16',
//         'sar' : 9/16,
//         'previewFileName' : 'standard_vertical_9x16.png',
//         'groupId' : 'standard'
//     },
//     'standard_widescreen_4x3' : {
//         'frameType' : 'ft_widescreen_4x3',
//         'label' : 'Widescreen',
//         'size' : '4:3',
//         'sar' : 4/3,
//         'previewFileName' : 'standard_widescreen_4x3.png',
//         'groupId' : 'standard'
//     },
//     'standard_widescreen_16x9' : {
//         'frameType' : 'ft_widescreen',
//         'label' : 'Widescreen',
//         'size' : '16:9',
//         'sar' : 16/9,
//         'previewFileName' : 'standard_widescreen_16x9.png',
//         'groupId' : 'standard'
//     },
//     'billboard_triple_play_top_board' : {
//         'frameType' : 'BILLBOARD-MIDDLE-TOP',
//         'label' : 'Triple Play Top Board',
//         'size' : '544 x 4160',
//         'sar' : 544/4160,
//         'groupId' : 'billboard'
//     },
//     'billboard_triple_play_bottom_left_board' : {
//         'frameType' : 'BILLBOARD',
//         'label' : 'Triple Play Bottom Left Board',
//         'size' : '2240 x 560',
//         'sar' : 2240/560,
//         'groupId' : 'billboard'
//     },
//     'billboard_triple_play_bottom_right_board' : {
//         'frameType' : 'BILLBOARD-BOTTOM-RIGHT',
//         'label' : 'Triple Play Bottom Right Board',
//         'size' : '2240 x 560',
//         'sar' : 2240/560,
//         'groupId' : 'billboard'
//     },
//     'billboard_crossroads_top_board' : {
//         'frameType' : 'BILLBOARD-PLACE-TOP',
//         'label' : 'Crossroads Top Board',
//         'size' : '640 x 1696',
//         'sar' : 640/1696,
//         'groupId' : 'billboard'
//     },
//     'billboard_crossroads_bottom_board' : {
//         'frameType' : 'BILLBOARD-PLACE-BOTTOM',
//         'label' : 'Crossroads Bottom Board',
//         'size' : '1056 x 672',
//         'sar' : 1056/672,
//         'groupId' : 'billboard'
//     },
//     'billboard_waterfall_top_board' : {
//         'frameType' : 'BILLBOARD-TOP',
//         'label' : 'Waterfall Top Board',
//         'size' : '416 x 1584',
//         'sar' : 416/1584,
//         'groupId' : 'billboard'
//     },
//     'billboard_waterfall_middle_board' : {
//         'frameType' : 'BILLBOARD-MIDDLE',
//         'label' : 'Waterfall Middle Board',
//         'size' : '416 x 1376',
//         'sar' : 416/1376,
//         'groupId' : 'billboard'
//     },
//     'billboard_waterfall_bottom_board' : {
//         'frameType' : 'BILLBOARD-BOTTOM',
//         'label' : 'Waterfall Bottom Board',
//         'size' : '1344 x 1696',
//         'sar' : 1344/1696,
//         'groupId' : 'billboard'
//     },
//     'billboard_commuter_top_board' : {
//         'frameType' : 'BILLBOARD-COMMUTER-TOP',
//         'label' : 'Commuter Top Board',
//         'size' : '760 x 200',
//         'sar' : 760/200,
//         'groupId' : 'billboard'
//     },
//     'billboard_commuter_left_board' : {
//         'frameType' : 'BILLBOARD-COMMUTER-LEFT',
//         'label' : 'Commuter Left Side Board',
//         'size' : '300 x 256',
//         'sar' : 300/256,
//         'groupId' : 'billboard'
//     },
//     'billboard_commuter_right_board' : {
//         'frameType' : 'BILLBOARD-COMMUTER-RIGHT',
//         'label' : 'Commuter Right Side Board',
//         'size' : '370 x 618',
//         'sar' : 370/618,
//         'groupId' : 'billboard'
//     },
//     'billboard_commuter_center_board' : {
//         'frameType' : 'BILLBOARD-COMMUTER-CENTER',
//         'label' : 'Commuter Center Board',
//         'size' : '600 x 256',
//         'sar' : 600/256,
//         'groupId' : 'billboard'
//     },
//     ...newFormatTypes,
// })

var IMAGE_ANIMATIONS = ['ZOOM_IN', 'ZOOM_OUT', 'FROM_LEFT', 'FROM_RIGHT', 'FROM_BOTTOM_LEFT', 'FROM_TOP_RIGHT'];

function computeSizeForAR(targetAR) {
    // Logic - Calculate a video size which has a min edge and max edge as desired.
    //        If when trying to satisfy min edge, we can't satisfy max edge, prioritize max edge
    //        If we can satisfy both, use size based on min edge
    var MAX_EDGE = 1920;
    var MIN_EDGE = 1080;

    var width = floor(max(MIN_EDGE * targetAR, MIN_EDGE) / 2) * 2;
    var height = floor(max(MIN_EDGE / targetAR, MIN_EDGE) / 2) * 2;

    if (width > MAX_EDGE || height > MAX_EDGE) {
        width = floor(min(MAX_EDGE * targetAR, MAX_EDGE) / 2) * 2;
        height = floor(min(MAX_EDGE / targetAR, MAX_EDGE) / 2) * 2;
    }

    return { width: width, height: height };
}

function capOutputCanvasSize(canvas) {
    // Make sure we don't have insane sizes to output. Let's support max 1.5 * Full HD
    // const MAX_EDGE = 2880
    var MAX_EDGE = 4160;

    if (MAX_EDGE >= canvas.width && MAX_EDGE >= canvas.height) {
        return canvas;
    }

    var canvasAR = canvas.width / canvas.height;

    var width = floor(min(canvas.width, MAX_EDGE * canvasAR) / 2) * 2;
    var height = floor(min(canvas.height, MAX_EDGE / canvasAR) / 2) * 2;

    return { width: width, height: height };
}

function getBestFitCanvasRatio(clips) {
    var aar = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = clips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var clip = _step.value;

            var width = 1;
            var height = 1;
            if (clip.clipType === 'image') {
                width = clip.clipImage.width;
                height = clip.clipImage.height;
            } else if (clip.clipType === 'video') {
                width = clip.clipVideo.width;
                height = clip.clipVideo.height;
            }
            aar += width / height;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return aar / clips.length;
}

function getNativeSizeForClip(c) {
    var sizeObj = null;
    if (c.clipType === 'video') {
        sizeObj = c.clipVideo;
    } else if (c.clipType === 'image') {
        sizeObj = c.clipImage;
    } else {
        throw new Error('Unknown clip type ' + c.clipType);
    }
    return { width: sizeObj.width, height: sizeObj.height };
}

function quantifyFrameParams(frameType, canvas) {
    var customFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var frameParams = void 0;

    var isCustomFormat = customFormat && customFormat.frameDetails;

    if (isCustomFormat) {
        frameParams = customFormat.frameDetails;
    } else {
        frameParams = FrameTypes[frameType];
    }

    var _frameParams = frameParams,
        content_box = _frameParams.content_box,
        size = _frameParams.size,
        _frameParams$fit_alig = _frameParams.fit_align,
        fit_align = _frameParams$fit_alig === undefined ? 'center center' : _frameParams$fit_alig;

    if (typeof content_box === 'string') {
        if (typeof size === 'string') {
            size = canvas;
        }
        if (content_box === 'fill') {
            content_box = _extends({ x: 0, y: 0 }, size);
        } else {
            throw new Error('Unsupported content_box value ' + content_box);
        }
    }
    var sf = 1;
    if (size.width !== canvas.width || size.height !== canvas.height) {
        // Assuming no distortion
        sf = canvas.width / size.width;
    }

    content_box = {
        x: content_box.x * sf,
        y: content_box.y * sf,
        width: content_box.width * sf,
        height: content_box.height * sf
    };

    var _fit_align$split$map = fit_align.split(' ').map(function (v) {
        return v.trim();
    }),
        _fit_align$split$map2 = _slicedToArray(_fit_align$split$map, 2),
        align_horizontal = _fit_align$split$map2[0],
        align_vertical = _fit_align$split$map2[1];

    if (align_horizontal === 'left') {
        align_horizontal = 0;
    } else if (align_horizontal === 'center') {
        align_horizontal = 0.5;
    } else if (align_horizontal === 'right') {
        align_horizontal = 1;
    } else {
        throw new Error('Unsupported align_horizontal value ' + align_horizontal);
    }

    if (align_vertical === 'top') {
        align_vertical = 0;
    } else if (align_vertical === 'center') {
        align_vertical = 0.5;
    } else if (align_vertical === 'bottom') {
        align_vertical = 1;
    } else {
        throw new Error('Unsupported align_vertical value ' + align_vertical);
    }

    fit_align = [align_horizontal, align_vertical];

    return _extends({}, frameParams, { content_box: content_box, size: size, fit_align: fit_align });
}

function calcRotatedClipBox() {
    var rotateDeg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var clip = arguments[1];
    var frameType = arguments[2];
    var canvas = arguments[3];
    var customFormat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var _getNativeSizeForClip = getNativeSizeForClip(clip),
        width = _getNativeSizeForClip.width,
        height = _getNativeSizeForClip.height;

    var _quantifyFrameParams = quantifyFrameParams(frameType, canvas, customFormat),
        content_box = _quantifyFrameParams.content_box;

    var _calcDefaultClipBox = calcDefaultClipBox(clip, frameType, canvas, customFormat),
        cb_height = _calcDefaultClipBox.height,
        cb_width = _calcDefaultClipBox.width,
        cb_x = _calcDefaultClipBox.x,
        cb_y = _calcDefaultClipBox.y,
        _calcDefaultClipBox$s = _calcDefaultClipBox.sar,
        dsar = _calcDefaultClipBox$s === undefined ? 1 : _calcDefaultClipBox$s;

    var clip_ar = width / height;

    var newCBWidth = content_box.width;
    var newCBHeight = content_box.height;

    if (rotateDeg) {
        var radVal = degreeToRadian(rotateDeg);
        var sinVal = absoluteSinVal(radVal);
        var cosVal = absoluteCosVal(radVal);

        newCBWidth = content_box.width * cosVal + content_box.height * sinVal;
        newCBHeight = content_box.width * sinVal + content_box.height * cosVal;
    }

    var rcb_width = max(newCBWidth, newCBHeight * clip_ar);
    var rcb_height = max(newCBHeight, newCBWidth / clip_ar);
    var rcb_x = cb_x + (cb_width - rcb_width) / 2;
    var rcb_y = cb_y + (cb_height - rcb_height) / 2;

    return { width: rcb_width, height: rcb_height, x: rcb_x, y: rcb_y, sar: dsar };
}

function calcDefaultClipBox(clip, frameType, canvas) {
    var customFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var initialCropBox = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    // COMPOSITE NEED TESTING
    if (!!clip.clipImageId && clip.clipImageId == SolidImageId || clip.clipType === 'composite') {
        return { x: 0, y: 0, width: canvas.width, height: canvas.height, sar: 1 };
    }

    var _getNativeSizeForClip2 = getNativeSizeForClip(clip),
        width = _getNativeSizeForClip2.width,
        height = _getNativeSizeForClip2.height;

    var _quantifyFrameParams2 = quantifyFrameParams(frameType, canvas, customFormat),
        content_box = _quantifyFrameParams2.content_box,
        size = _quantifyFrameParams2.size,
        fit_constraint = _quantifyFrameParams2.fit_constraint,
        fit_align = _quantifyFrameParams2.fit_align;

    var _fit_align = _slicedToArray(fit_align, 2),
        align_horizontal = _fit_align[0],
        align_vertical = _fit_align[1];

    var clip_ar = width / height;

    var cb_x = 0;
    var cb_y = 0;
    var cb_width = 0;
    var cb_height = 0;
    var cb_sar = 1;
    if (fit_constraint === 'cover' || initialCropBox && fit_constraint === 'contain') {
        cb_width = Math.max(content_box.width, content_box.height * clip_ar);
        cb_height = Math.max(content_box.height, content_box.width / clip_ar);

        cb_x = content_box.x + Math.min(0, align_horizontal * (content_box.width - cb_width));
        cb_y = content_box.y + Math.min(0, align_vertical * (content_box.height - cb_height));
    } else if (fit_constraint === 'contain') {
        cb_width = Math.min(content_box.width, content_box.height * clip_ar);
        cb_height = Math.min(content_box.height, content_box.width / clip_ar);

        cb_x = content_box.x + Math.max(0, align_horizontal * (content_box.width - cb_width));
        cb_y = content_box.y + Math.max(0, align_vertical * (content_box.height - cb_height));
    } else if (fit_constraint === 'fill') {
        cb_width = content_box.width;
        cb_height = content_box.height;

        cb_x = content_box.x;
        cb_y = content_box.y;

        cb_sar = cb_width / cb_height / clip_ar;
    } else {
        throw new Error('Unsupported fit_constraint value ' + fit_constraint);
    }

    return { x: cb_x, y: cb_y, width: cb_width, height: cb_height, sar: cb_sar };
}

function getClipBoxLimits(newSize, frameType, canvas) {
    var customFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var _quantifyFrameParams3 = quantifyFrameParams(frameType, canvas, customFormat),
        content_box = _quantifyFrameParams3.content_box,
        fit_constraint = _quantifyFrameParams3.fit_constraint,
        fit_align = _quantifyFrameParams3.fit_align;

    var newWidth = newSize.width,
        newHeight = newSize.height,
        _newSize$rotateDeg = newSize.rotateDeg,
        rotateDeg = _newSize$rotateDeg === undefined ? 0 : _newSize$rotateDeg;

    var minX = 0;
    var minY = 0;
    var maxX = 0;
    var maxY = 0;
    if (fit_constraint === 'cover') {
        minX = content_box.width - newWidth + content_box.x;
        minY = content_box.height - newHeight + content_box.y;
        maxX = content_box.x;
        maxY = content_box.y;
    } else if (fit_constraint === 'contain') {
        minX = Math.min(content_box.x + content_box.width - newWidth, content_box.x);
        minY = Math.min(content_box.y + content_box.height - newHeight, content_box.y);

        maxX = Math.max(content_box.x + content_box.width - newWidth, content_box.x);
        maxY = Math.max(content_box.y + content_box.height - newHeight, content_box.y);
    } else if (fit_constraint === 'fill') {
        minX = content_box.x;
        minY = content_box.y;

        maxX = content_box.x + content_box.width;
        maxY = content_box.y + content_box.height;
    } else {
        throw new Error('Unsupported fit_constraint value ' + fit_constraint);
    }

    return { minX: minX, maxX: maxX, minY: minY, maxY: maxY };
}

function updateReelWithFormat(reel, newFormatId) {
    var customFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var forceReset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var isCustomFormat = customFormat && customFormat.frameDetails;

    var newFrameType = void 0;
    var newFrameParams = void 0;
    if (isCustomFormat) {
        newFrameType = customFormat.frameType;
        newFrameParams = customFormat.frameDetails;
    } else if (!FormatTypes.hasOwnProperty(newFormatId)) {
        throw new Error('Unknown format ' + newFormatId);
    } else {
        newFrameType = FormatTypes[newFormatId].frameType;
        newFrameParams = FrameTypes[newFrameType];
    }
    if (!forceReset && newFrameType === reel.frameType) {
        return reel;
    }

    var newCanvas = null;
    if (newFrameParams.size === 'original') {
        // For original, we use the original canvas
        newCanvas = reel.origCanvas;
    } else if (newFrameParams.size === 'auto') {
        // For auto, we compute based on clips' dimensions
        newCanvas = computeSizeForAR(getBestFitCanvasRatio(reel.clips));
    } else {
        newCanvas = newFrameParams.size;
    }

    var newClips = reel.clips.map(function (c) {
        if (c.clipType === 'composite') {
            c.childClips = c.childClips.map(function (cc) {
                var _cc$clipBox = cc.clipBox,
                    _cc$clipBox$isRotateM = _cc$clipBox.isRotateManual,
                    isRotateManual = _cc$clipBox$isRotateM === undefined ? true : _cc$clipBox$isRotateM,
                    _cc$clipBox$rotateDeg = _cc$clipBox.rotateDeg,
                    rotateDeg = _cc$clipBox$rotateDeg === undefined ? 0 : _cc$clipBox$rotateDeg;

                var clipBox = calcRotatedClipBox(rotateDeg, cc, newFrameType, newCanvas, customFormat);
                return _extends({}, cc, {
                    clipBox: _extends({}, clipBox, {
                        isRotateManual: isRotateManual,
                        rotateDeg: rotateDeg
                    })
                });
            });
        }

        return _extends({}, c, { clipBox: calcDefaultClipBox(c, newFrameType, newCanvas, customFormat) });
    });

    return _extends({}, reel, {
        canvas: newCanvas,
        formatId: newFormatId,
        frameType: newFrameType,
        clips: newClips
    });
}

function updateReelWithFrameType(reel, newFrameType) {
    var customFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var forceReset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var isCustomFormat = customFormat && customFormat.frameDetails;

    var newFrameParams = void 0;
    if (isCustomFormat) {
        newFrameParams = customFormat.frameDetails;
    } else if (!FrameTypes.hasOwnProperty(newFrameType)) {
        throw new Error('Unknown frameType ' + newFrameType);
    } else {
        newFrameParams = FrameTypes[newFrameType];
    }

    if (!forceReset && newFrameType === reel.frameType) {
        return reel;
    }

    var newCanvas = null;
    if (newFrameParams.size === 'original') {
        // For original, we use the original canvas
        newCanvas = reel.origCanvas;
    } else if (newFrameParams.size === 'auto') {
        // For auto, we compute based on clips' dimensions
        newCanvas = computeSizeForAR(getBestFitCanvasRatio(reel.clips));
    } else {
        newCanvas = newFrameParams.size;
    }

    // const newClips = reel.clips.map(c => ({ ...c, clipBox : calcDefaultClipBox(c, newFrameType, newCanvas, customFormat) }))

    var newClips = reel.clips.map(function (c) {
        if (c.clipType === 'composite') {
            c.childClips = c.childClips.map(function (cc) {
                // TODO confirm from Rajat about rotate values during review.
                var clipBox = calcRotatedClipBox(rotateDeg, cc, newFrameType, newCanvas, customFormat);
                return _extends({}, cc, {
                    clipBox: _extends({}, clipBox, {
                        isRotateManual: isRotateManual,
                        rotateDeg: rotateDeg
                    })
                });
            });
        }

        return _extends({}, c, { clipBox: calcDefaultClipBox(c, newFrameType, newCanvas, customFormat) });
    });

    return _extends({}, reel, { canvas: newCanvas, frameType: newFrameType, clips: newClips });
}

function getContentBox(_ref) {
    var frameType = _ref.frameType,
        canvas = _ref.canvas,
        _ref$customFormat = _ref.customFormat,
        customFormat = _ref$customFormat === undefined ? {} : _ref$customFormat;

    if (!frameType) {
        return {};
    }

    var _quantifyFrameParams4 = quantifyFrameParams(frameType, canvas, customFormat),
        content_box = _quantifyFrameParams4.content_box;

    return content_box;
}

function allFrameTypes() {
    return Object.keys(FrameTypes);
}

function allFormatTypes() {
    var customGroupIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return Object.keys(FormatGroups).filter(function (fgKey) {
        return !FormatGroups[fgKey].custom || customGroupIds.includes(fgKey);
    }).map(function (fgKey) {
        var group = FormatGroups[fgKey];
        var formats = Object.keys(FormatTypes).filter(function (ftKey) {
            return FormatTypes[ftKey].groupId === fgKey;
        }).map(function (ftKey) {
            return _extends({
                id: ftKey
            }, FormatTypes[ftKey]);
        });
        var label = group.label,
            iconId = group.iconId,
            _group$custom = group.custom,
            custom = _group$custom === undefined ? false : _group$custom;

        return {
            id: fgKey,
            label: label,
            iconId: iconId,
            custom: custom,
            formats: formats
        };
    });
}

function buildCustomFormatAppData(customFormat) {
    return {
        id: customFormat.id,
        formatKey: customFormat.id,
        frameType: customFormat.frameType,
        label: customFormat.label,
        iconId: customFormat.iconId,
        groupId: 'custom',
        deleted: customFormat.deleted,
        frameDetails: {
            customFrame: true,
            customKey: customFormat.id,
            name: customFormat.label,
            aspect_ratio_label: customFormat.size,
            size: { width: customFormat.width, height: customFormat.height },
            content_box: {
                x: customFormat.x,
                y: customFormat.y,
                width: customFormat.contentWidth,
                height: customFormat.contentHeight
            },
            fit_constraint: 'contain'
        }
    };
}

function customFormatTypes() {
    var customFormats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var formats = customFormats.map(function (format) {
        return _extends({}, format, {
            id: format.formatKey,
            frameType: getCustomFrameTypeFromKey(format.formatKey),
            sar: format.width / format.height,
            groupId: 'custom'
        });
    });

    return {
        id: 'custom',
        label: 'Custom',
        iconId: null,
        custom: true,
        formats: formats
    };
}

function getFormatData(formatId) {
    return FormatTypes[formatId];
}

/**
 * Returns the label of the passed formatId.
 * @param {*} formatId
 * @param {*} customFormats
 */
var getFormatLabel = memoize(function (formatId) {
    var customFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (FormatTypes[formatId]) {
        return FormatTypes[formatId].label;
    }

    if (customFormats) {
        customFormats.forEach(function (ft) {
            if (ft.formatKey == formatId) {
                return ft.label;
            }
        });
    }

    return null;
}, function (formatId, customFormats) {
    return formatId + '$-$' + (!!customFormats && customFormats.toString());
});

function getCustomFrameTypeFromKey(formatKey) {
    return CUSTOM_FORMAT_FRAME_TYPE + formatKey;
}

function getCustomFormatData(formatData) {
    return {
        frameType: getCustomFrameTypeFromKey(formatData.formatKey),
        label: formatData.label,
        size: formatData.size,
        sar: formatData.width / formatData.height,
        useCase: formatData.useCase,
        groupId: 'custom'
    };
}

function newFrameTypes() {
    return Object.keys(FrameTypes).filter(function (k) {
        return !FrameTypes[k].deprecated && !FrameTypes[k].customFrame;
    });
}

function customFrameTypes(showFbFrames, showBillboardFrames, showCurejoyFrames) {
    return Object.keys(FrameTypes).filter(function (k) {
        var _FrameTypes$k = FrameTypes[k],
            _FrameTypes$k$customF = _FrameTypes$k.customFrame,
            customFrame = _FrameTypes$k$customF === undefined ? false : _FrameTypes$k$customF,
            customKey = _FrameTypes$k.customKey;

        return !!customFrame && (showFbFrames && customKey == 'facebook' || showBillboardFrames && customKey == 'billboard' || showCurejoyFrames && customKey == 'curejoy');
    });
}

function deprecatedFrameTypes() {
    return Object.keys(FrameTypes).filter(function (k) {
        return !!FrameTypes[k].deprecated;
    });
}

function nameForFrameType(frameType) {
    return FrameTypes[frameType].name;
}

function aspectRatioLabelForFrameType(frameType) {
    return FrameTypes[frameType].aspect_ratio_label;
}

function replaceClipWithImage(selectedClip, timeOffset) {
    var selectedImageMedia = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var clipAnimType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : IMAGE_ANIMATIONS[0];

    // const clipAnimType = IMAGE_ANIMATIONS[Math.floor(Math.random() * IMAGE_ANIMATIONS.length)]
    var _selectedClip$time = selectedClip.time,
        enterStart = _selectedClip$time.enterStart,
        enterDone = _selectedClip$time.enterDone,
        exitStart = _selectedClip$time.exitStart,
        exitDone = _selectedClip$time.exitDone;

    var clip = {
        clipId: shortid.generate(),
        clipType: 'image',
        clipImageId: selectedImageMedia ? selectedImageMedia.id : SolidImageId,
        clipStart: 0,
        clipDuration: selectedClip.clipDuration,
        musicVolume: selectedClip.musicVolume,
        speed: selectedClip.speed,
        clipAnimType: clipAnimType,
        time: {
            enterStart: enterStart,
            enterDone: enterDone,
            exitStart: exitStart,
            exitDone: exitDone,
            currentOffset: 0,
            prevOffset: timeOffset
        },
        transitions: {},
        clipImage: selectedImageMedia ? selectedImageMedia.imageData : SolidImageData,
        isSelected: false
    };
    return clip;
}

function replaceClipWithVideo(selectedClip, timeOffset, selectedVideoMedia) {
    var timeRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var _selectedClip$time2 = selectedClip.time,
        enterStart = _selectedClip$time2.enterStart,
        enterDone = _selectedClip$time2.enterDone,
        clipDuration = selectedClip.clipDuration;

    var duration = Math.floor(clipDuration);
    var clipStart = 0;

    if (timeRange) {
        var _timeRange$startTime = timeRange.startTime,
            startTime = _timeRange$startTime === undefined ? 0 : _timeRange$startTime,
            durationInSec = timeRange.duration;

        if (durationInSec) {
            duration = Math.floor(durationInSec * 1000);
        }
        clipStart = Math.floor(startTime * 1000);
    }

    if (duration > selectedVideoMedia.videoData.duration) {
        duration = selectedVideoMedia.videoData.duration;
        clipStart = 0;
    }

    var clip = {
        clipId: shortid.generate(),
        clipType: 'video',
        clipVideoId: selectedVideoMedia.id,
        clipStart: clipStart,
        clipVolume: typeof selectedClip.clipVolume !== 'undefined' ? selectedClip.clipVolume : 1,
        musicVolume: selectedClip.musicVolume,
        speed: selectedClip.speed,
        clipDuration: duration,
        time: {
            enterStart: enterStart,
            enterDone: enterDone,
            exitStart: Math.floor(enterStart + duration),
            exitDone: Math.floor(enterDone + duration),
            currentOffset: 0,
            prevOffset: timeOffset
        },
        transitions: {},
        clipVideo: selectedVideoMedia.videoData,
        isSelected: false
    };
    return clip;
}

/**
 * verified is clip is solid image clip
 *
 * @param {*} clip
 * @return {*}
 */
function checkIsSolidImageClip(clip) {
    return clip.clipImageId && clip.clipImageId === SolidImageId;
}

function createNewSolidImageClip() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#555555';
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4000;
    var hidePadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var enterTime = arguments[3];
    var timeOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var stripped = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var speed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
    var asPlaceholder = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    var clipAnimType = IMAGE_ANIMATIONS[Math.floor(Math.random() * IMAGE_ANIMATIONS.length)];
    var _clipDuration = Math.floor(duration);

    var clip = {
        clipId: shortid.generate(),
        clipType: 'image',
        clipImageId: SolidImageId,
        solidImageColor: color,
        hidePadding: !!hidePadding,
        clipStart: 0,
        clipDuration: _clipDuration,
        musicVolume: 1,
        speed: speed,
        clipAnimType: asPlaceholder !== null ? 'NONE' : clipAnimType,
        time: {
            enterStart: Math.floor(enterTime),
            enterDone: Math.floor(enterTime),
            exitStart: Math.floor(enterTime + _clipDuration),
            exitDone: Math.floor(enterTime + _clipDuration),
            currentOffset: 0,
            prevOffset: timeOffset
        },
        transitions: {},
        isSelected: false,

        // TODO remove below  -- placeholder refactor effort

        isPlaceholder: asPlaceholder !== null,

        thumbUrl: (asPlaceholder || {}).thumbUrl,
        ptitle: (asPlaceholder || {}).title,
        pheight: (asPlaceholder || {}).height,
        pwidth: (asPlaceholder || {}).width,
        ptype: (asPlaceholder || {}).type,
        pMediaId: '',
        pduration: (asPlaceholder || {}).duration,
        placeHolderError: false
    };

    return stripped ? clip : _extends({}, clip, { clipImage: SolidImageData });
}

function adjustClipList2Time() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _ref2 = arguments[1];
    var time = _ref2.time,
        transitions = _ref2.transitions;
    var relative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var childClips = cloneDeep(clips);
    var enterStartTime = time.enterStart;

    if (!relative) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = childClips[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var cc = _step2.value;

                cc.time.enterStart = Math.floor(cc.time.enterStart + enterStartTime);
                cc.time.enterDone = Math.floor(cc.time.enterDone + enterStartTime);
                cc.time.exitStart = Math.floor(cc.time.exitStart + enterStartTime);
                cc.time.exitDone = Math.floor(cc.time.exitDone + enterStartTime);
                cc.time.prevOffset += time.prevOffset; // negative value added
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    // TO - DO testing
    if (!relative) childClips[0].time.currentOffset = time.currentOffset;
    if (transitions.enter !== undefined) childClips[0].transitions.enter = transitions.enter;
    if (transitions.exit !== undefined) childClips[childClips.length - 1].transitions.exit = transitions.exit;
    return childClips;
}

/**
 * provided list of clips , creates a zero position project with first and last clip
 * acting as if its a project  clip , no enter no exit for first an last clips and
 * start time of 0
 *
 * @param {*} [clips=[]]
 * @return {*}
 */
function adjustClipList2ZeroOffset() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var childClips = cloneDeep(clips);

    // in respect to its parent composite controller the child should have no prevOffset , if requires will be handled by controller
    var firstPrevOffset = childClips[0].time.prevOffset;
    var firstCurrentOffset = childClips[0].time.currentOffset;
    var fisrtClipEnterStart = childClips[0].time.enterStart;
    childClips[0].time.currentOffset = 0;
    delete childClips[0].transitions.enter; // there should be no enter transition , of no sorts
    // if the enter transition is required will be provided by the Composite Controller

    var li = childClips.length - 1;
    delete childClips[li].transitions.exit; // we dont need exit animation , relative to parent
    // // if required will be added back from the parent

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = childClips[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var cc = _step3.value;

            // creating 0 offset fo start time for the child clips respect to composite clip
            cc.time.enterStart = Math.floor(Math.max(cc.time.enterStart - fisrtClipEnterStart, 0));
            cc.time.enterDone = Math.floor(Math.max(cc.time.enterDone - fisrtClipEnterStart, 0));
            cc.time.exitStart = Math.floor(Math.max(cc.time.exitStart - fisrtClipEnterStart, 0));
            cc.time.exitDone = Math.floor(Math.max(cc.time.exitDone - fisrtClipEnterStart, 0));

            cc.time.prevOffset = Math.min(cc.time.prevOffset - firstPrevOffset, 0); // prevOffset is negative and is additive of previous clips
            // currentOffset is local to a clip and can be left and not used
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return childClips;
}

/**
 *
 *
 * @param {Array} clips -> Child clips which needs to be added in composite clips
 * @param {number} enterTime -> enterStart time for newly created composite clip
 * @param {number} timeOffset -> total previous offset of all the clips before this composite clip
 * @param {string} sequenceId
 * @return {*}
 */
function createNewCompositeClip() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var enterTime = arguments[1];
    var timeOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var sequenceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var sequenceName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    if (clips.length == 0) throw new Error('Child Clips for Composite clip cannot be empty , illegal operation !!');

    // creating relative timings
    // creates a relative offset for the clips
    var adjustedClips = fixTimelineGap(clips);
    var childClips = adjustClipList2ZeroOffset(adjustedClips.fixedClips);

    // const totalDuration = getTotalDuration(childClips)
    // Total duration is the actual length of the clips playback
    var totalDuration = getReelDuration(childClips);

    var clip = {
        clipId: shortid.generate(),
        clipType: 'composite',
        clipStart: 0,
        clipVolume: 1,
        musicVolume: 1,
        speed: 1,
        name: sequenceName,
        sequenceId: sequenceId,
        clipDuration: totalDuration, // derivative
        time: {
            enterStart: Math.floor(enterTime),
            enterDone: Math.floor(enterTime),
            exitStart: Math.floor(enterTime + totalDuration),
            exitDone: Math.floor(enterTime + totalDuration),
            currentOffset: 0,
            prevOffset: timeOffset
        },
        transitions: {},
        childClips: childClips
    };
    // // ADDING TRANSITION OF CHILD ...
    // const transitions = {}

    // if(clips[0].transitions['enter'] !== undefined)
    //     transitions['enter'] = cloneDeep(clips[0].transitions['enter'])
    // if(clips[clips.length - 1].transitions['exit'] !== undefined)
    //     transitions['exit'] = cloneDeep(clips[clips.length - 1].transitions['exit'])

    // clip.transitions = transitions
    return clip;
}

/**
 * Creates a valid image + video clip list from composite clips provided
 *
 * @param {*} compositeClip
 * @param {number} [enterTime=0]
 * @param {number} [timeOffset=0]
 * @return {*}
 */
function createClipListFromCompositeClip(compositeClip) {
    var relative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var childClips = compositeClip.childClips,
        time = compositeClip.time,
        transitions = compositeClip.transitions;

    var _newChildClips = adjustClipList2Time(childClips, { time: time, transitions: transitions }, relative);

    return _newChildClips;
}

/**
 * Prepares the project reel data into an export friendly format
 * gets rid of composite clips and flattens the data
 *
 * @param {*} reelClips
 * @return {*}
 */
function flattenProjectClips(reelClips) {
    var clips = reelClips.flatMap(function (clip) {
        if (clip.clipType === 'composite') return createClipListFromCompositeClip(clip, false);
        return clip;
    });

    return clips;
}

function fixTimelineGap() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var startTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var modifyClip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (c) {
        return c;
    };

    clips.sort(function (a, b) {
        return a.time.enterStart - b.time.enterStart;
    });

    var timelineGapPresent = false;

    var time = void 0;
    if (startTime) {
        time = startTime;
    } else if (clips.length === 0) {
        time = 0;
    } else {
        time = modifyClip(clips[0]).time.enterStart;
    }

    var fixedClips = [];

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = clips[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var c = _step4.value;

            var modifiedClip = modifyClip(c);
            var _modifiedClip$speed = modifiedClip.speed,
                speed = _modifiedClip$speed === undefined ? 1 : _modifiedClip$speed,
                clipDuration = modifiedClip.clipDuration;

            if (!timelineGapPresent) {
                timelineGapPresent = Math.floor(modifiedClip.time.enterStart) !== time || Math.floor(modifiedClip.time.exitDone) !== Math.floor(time + clipDuration / speed);
            }

            var ctime = _extends({}, modifiedClip.time, {
                enterStart: time,
                enterDone: time,
                exitStart: Math.floor(time + clipDuration / speed),
                exitDone: Math.floor(time + clipDuration / speed)
            });

            time = Math.floor(time + clipDuration / speed);
            fixedClips.push(_extends({}, modifiedClip, {
                time: ctime
            }));
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    return {
        timelineGapPresent: timelineGapPresent,
        fixedClips: fixedClips
    };
}

function createNewVideoClip(videoData, enterTime) {
    var timeOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var stripped = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var clipStart = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var clipDuration = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    var _clipDuration = Math.floor(clipDuration || videoData.duration);
    var _clipStart = Math.floor(clipStart);

    var clip = {
        clipId: shortid.generate(),
        clipType: 'video',
        clipVideoId: videoData.id,
        clipStart: _clipStart,
        clipVolume: 1,
        musicVolume: 1,
        speed: 1,
        clipDuration: _clipDuration,
        time: {
            enterStart: Math.floor(enterTime),
            enterDone: Math.floor(enterTime),
            exitStart: Math.floor(enterTime + _clipDuration),
            exitDone: Math.floor(enterTime + _clipDuration),
            currentOffset: 0,
            prevOffset: timeOffset
        },
        transitions: {}
    };
    return stripped ? clip : _extends({}, clip, { clipVideo: videoData });
}

function createNewImageClip(imageData, enterTime) {
    var timeOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var stripped = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var clipAnimType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : IMAGE_ANIMATIONS[0];
    var clipDuration = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 4000;

    // clipAnimType = IMAGE_ANIMATIONS[Math.floor(Math.random() * IMAGE_ANIMATIONS.length)]

    var clip = {
        clipId: shortid.generate(),
        clipType: 'image',
        clipImageId: imageData.id,
        clipStart: 0,
        clipDuration: clipDuration,
        musicVolume: 1,
        speed: 1,
        clipAnimType: clipAnimType,
        time: {
            enterStart: Math.floor(enterTime),
            enterDone: Math.floor(enterTime),
            exitStart: Math.floor(enterTime + clipDuration),
            exitDone: Math.floor(enterTime + clipDuration),
            currentOffset: 0,
            prevOffset: timeOffset
        },
        transitions: {}
    };
    return stripped ? clip : _extends({}, clip, { clipImage: imageData });
}

function createNewAudioClip(audioData) {
    var stripped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var clip = {
        clipId: shortid.generate(),
        clipType: 'audio',
        clipAudioId: audioData.id,
        clipStart: 0,
        clipVolume: 0.75,
        clipFadeIn: true,
        clipFadeOut: true,
        clipLooping: true,
        clipDuration: Math.floor(audioData.duration)
    };
    return stripped ? clip : _extends({}, clip, { clipAudio: audioData });
}

function getMaxClipBoxSize(clip, frameType, canvas) {
    var customFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var _calcDefaultClipBox2 = calcDefaultClipBox(clip, frameType, canvas, customFormat, false),
        width = _calcDefaultClipBox2.width,
        height = _calcDefaultClipBox2.height;

    return { width: width * MAX_ZOOM_FACTOR, height: height * MAX_ZOOM_FACTOR };
}

function getMinClipBoxSize(clip, frameType, canvas) {
    var customFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var _calcDefaultClipBox3 = calcDefaultClipBox(clip, frameType, canvas, customFormat, false),
        width = _calcDefaultClipBox3.width,
        height = _calcDefaultClipBox3.height;

    return { width: width, height: height };
}

function getMediaInstKey(mediaType) {
    switch (mediaType) {
        case 'video':
            return 'videoData';
        case 'image':
            return 'imageData';
        case 'audio':
            return 'audioData';
    }

    return null;
}
// TODO -- verifiy for SVG media Asset
function hydrateClips(reel, projectMedia) {
    var otherMedia = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var findData = function findData(type, mediaId) {
        // Check project media first
        var mediaItem = [].concat(_toConsumableArray(projectMedia), _toConsumableArray(otherMedia)).find(function (m) {
            return m.mediaType === type && m.id === mediaId;
        });
        return mediaItem[getMediaInstKey(type)];
    };

    return _extends({}, reel, {
        clips: reel.clips.map(function (c) {
            var extra = {};
            if (c.clipType === 'video') {
                extra.clipVideo = findData('video', c.clipVideoId);
            } else if (c.clipType === 'image') {
                extra.clipImage = findData('image', c.clipImageId);
            }
            return _extends({}, c, extra);
        }),
        audioClip: reel.audioClip ? findData('audio', reel.audioClip.clipAudioId) : null
    });
}

/**
 *
 *
 * @param {{
 *         audioDurationInOverlay: number,
 *         audioLooping: boolean,
 *         audioVolume: number,
 *         audioDuration: number,
 *         audioStart: number,
 *         totalProjectDuration: number,
 *         audioEnd: number,
 *         isTimerOverlay: boolean,
 *     }}
 * @param {boolean} [tweensOnly=false]
 * @returns {*}
 */
function getVolumeTransitionListForOverlayAudio(_ref3) {
    var _ref3$audioDurationIn = _ref3.audioDurationInOverlay,
        audioDurationInOverlay = _ref3$audioDurationIn === undefined ? 0 : _ref3$audioDurationIn,
        _ref3$audioLooping = _ref3.audioLooping,
        audioLooping = _ref3$audioLooping === undefined ? false : _ref3$audioLooping,
        _ref3$audioVolume = _ref3.audioVolume,
        audioVolume = _ref3$audioVolume === undefined ? 100 : _ref3$audioVolume,
        _ref3$audioDuration = _ref3.audioDuration,
        audioDuration = _ref3$audioDuration === undefined ? 0 : _ref3$audioDuration,
        _ref3$audioStart = _ref3.audioStart,
        audioStart = _ref3$audioStart === undefined ? 0 : _ref3$audioStart,
        _ref3$totalProjectDur = _ref3.totalProjectDuration,
        totalProjectDuration = _ref3$totalProjectDur === undefined ? 0 : _ref3$totalProjectDur,
        _ref3$audioEnd = _ref3.audioEnd,
        audioEnd = _ref3$audioEnd === undefined ? 0 : _ref3$audioEnd,
        _ref3$clipFadeOut = _ref3.clipFadeOut,
        clipFadeOut = _ref3$clipFadeOut === undefined ? false : _ref3$clipFadeOut,
        _ref3$clipFadeIn = _ref3.clipFadeIn,
        clipFadeIn = _ref3$clipFadeIn === undefined ? false : _ref3$clipFadeIn;
    var tweensOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var ranges = [];

    if (clipFadeOut || clipFadeIn) {
        var numRepeats = 1;

        if (audioLooping) {
            numRepeats = Math.ceil(audioDurationInOverlay / audioDuration);
        }

        for (var i = 0; i < numRepeats; i++) {
            var duration = Math.floor(audioDuration);
            var start = audioStart + i * duration;

            ranges.push({
                start: start,
                duration: duration,
                fadeIn: false,
                fadeInFromVolume: 0,
                fadeOut: false,
                fadeOutToVolume: 0,
                volume: audioVolume
            });
        }
    } else {
        ranges.push({
            start: audioStart,
            duration: audioDurationInOverlay,
            fadeIn: false,
            fadeInFromVolume: 0,
            fadeOut: false,
            fadeOutToVolume: 0,
            volume: audioVolume
        });
    }

    if (totalProjectDuration > audioEnd) {
        ranges.push({
            start: audioEnd,
            duration: totalProjectDuration - audioEnd,
            volume: 0
        });
    }

    return volumeRangesToTransitionList(ranges, tweensOnly);
}

function getVolumeTransitionListForReelAudio(_ref4) {
    var clips = _ref4.clips,
        volumeMode = _ref4.volumeMode,
        clipFadeIn = _ref4.clipFadeIn,
        clipFadeOut = _ref4.clipFadeOut,
        clipLooping = _ref4.clipLooping,
        clipVolume = _ref4.clipVolume,
        clipDuration = _ref4.clipDuration;
    var tweensOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var ranges = [];

    var SMOOTH_REPEAT = true;
    var SMOOTH_VOLUME_CHANGE = true;
    var SMOOTH_START = clipFadeIn;
    var SMOOTH_END = clipFadeOut;

    var reelDuration = getReelDuration(clips);

    var audioTotalDuration = clipLooping ? reelDuration : Math.min(clipDuration, reelDuration);

    var numRepeats = clipLooping ? Math.ceil(reelDuration / clipDuration) : 1;

    var _loop = function _loop(i) {
        var audioStart = i * clipDuration;
        var audioDuration = Math.min(clipDuration, reelDuration - audioStart);

        if (volumeMode === 'project') {
            ranges.push({
                start: audioStart,
                duration: audioDuration,
                fadeIn: i === 0 ? SMOOTH_START : SMOOTH_REPEAT,
                fadeInFromVolume: 0,
                fadeOut: i === numRepeats - 1 ? SMOOTH_END : SMOOTH_REPEAT,
                fadeOutToVolume: 0,
                volume: clipVolume
            });
        } else {
            clips.forEach(function (c, j) {
                var _c$time = c.time,
                    enterStart = _c$time.enterStart,
                    exitDone = _c$time.exitDone,
                    _c$time$prevOffset = _c$time.prevOffset,
                    prevOffset = _c$time$prevOffset === undefined ? 0 : _c$time$prevOffset;

                var clipStart = Math.floor(enterStart + prevOffset);
                var clipEnd = Math.floor(clipStart + c.clipDuration);
                if (clipEnd < audioStart) {
                    return;
                }

                if (clipStart > audioStart + audioDuration) {
                    return;
                }

                var rangeStart = Math.max(clipStart, audioStart);
                var rangeEnd = Math.min(clipEnd, audioStart + audioDuration);

                ranges.push({
                    start: rangeStart,
                    duration: rangeEnd - rangeStart,
                    fadeIn: i === 0 && j === 0 ? SMOOTH_START : SMOOTH_REPEAT,
                    fadeInFromVolume: rangeStart === audioStart ? 0 : -1,
                    fadeOut: i === numRepeats - 1 ? SMOOTH_END : SMOOTH_REPEAT,
                    fadeOutToVolume: rangeEnd === audioStart + audioDuration ? 0 : -1,
                    volume: c.musicVolume
                });
            });
        }
    };

    for (var i = 0; i < numRepeats; i++) {
        _loop(i);
    }

    return volumeRangesToTransitionList(ranges, tweensOnly);
}

/**
 *
 * Returns the tweenmax time ranges from the time range created from the clips list
 * Expects : A sorted list of clips , but does sorts it anyway
 *
 *
 * @param {Array<>} [ranges=[]]
 * @param {boolean} tweensOnly
 * @return {*}
 */
function volumeRangesToTransitionList() {
    var ranges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var tweensOnly = arguments[1];

    if (ranges.length === 0) {
        return [];
    }

    var FADE_DURATION = 2000;
    var CROSS_FADE_DURATION = 1000;

    var transitionList = [];

    ranges.sort(function (a, b) {
        return a.start - b.start;
    });

    var totalDuration = ranges.reduce(function (p, r) {
        return p + r.duration;
    }, 0);

    // Let's iterate through each boundary and decide the transition required
    var left_range = null;
    var right_range = null;
    for (var i = 0; i <= ranges.length; i++) {
        left_range = i > 0 ? ranges[i - 1] : { volume: 0, start: -1, duration: -1, fadeOut: false };
        right_range = i < ranges.length ? ranges[i] : {
            volume: 0,
            start: ranges[0].start + totalDuration,
            duration: -1,
            fadeIn: false
        };

        var fadeDuration = i === 0 || i === ranges.length ? FADE_DURATION : CROSS_FADE_DURATION;

        if (!left_range.fadeOut) {
            if (!right_range.fadeIn) {
                transitionList.push({
                    type: 'set',
                    to: right_range.volume,
                    time: right_range.start
                });
            } else {
                transitionList.push({
                    type: 'fromTo',
                    from: right_range.fadeInFromVolume !== -1 ? right_range.fadeInFromVolume : left_range.volume,
                    to: right_range.volume,
                    ease: 'linear',
                    time: right_range.start,
                    duration: fadeDuration / 2
                });
            }
        } else if (!right_range.fadeIn) {
            transitionList.push({
                type: 'fromTo',
                from: left_range.volume,
                to: left_range.fadeOutToVolume !== -1 ? left_range.fadeOutToVolume : right_range.volume,
                ease: 'linear',
                time: right_range.start - fadeDuration / 2,
                duration: fadeDuration / 2
            });
        } else {
            var interVolume = -1;
            if (left_range.fadeOutToVolume !== -1 && right_range.fadeInFromVolume !== -1) {
                interVolume = (left_range.fadeOutToVolume + right_range.fadeInFromVolume) / 2;
            } else if (left_range.fadeOutToVolume !== -1) {
                interVolume = left_range.fadeOutToVolume;
            } else if (right_range.fadeInFromVolume !== -1) {
                interVolume = right_range.fadeInFromVolume;
            }
            if (interVolume !== -1) {
                transitionList.push({
                    type: 'fromTo',
                    from: left_range.volume,
                    to: interVolume,
                    ease: 'linear',
                    time: right_range.start - fadeDuration / 2,
                    duration: fadeDuration / 2
                });
                transitionList.push({
                    type: 'fromTo',
                    from: interVolume,
                    to: right_range.volume,
                    ease: 'linear',
                    time: right_range.start,
                    duration: fadeDuration / 2
                });
            } else {
                transitionList.push({
                    type: 'fromTo',
                    from: left_range.volume,
                    to: right_range.volume,
                    ease: 'linear',
                    time: right_range.start - fadeDuration / 2,
                    duration: fadeDuration
                });
            }
        }
    }

    // Check for transition durations exceeding next transition time
    transitionList = transitionList.map(function (t, i) {
        if (i < transitionList.length - 1 && t.time + t.duration > transitionList[i + 1].time) {
            t.duration = transitionList[i + 1].time - t.time;
        }
        return t;
    });

    if (!tweensOnly) {
        return transitionList;
    }

    var tweenList = [];
    var lastFilledTime = 0;
    var lastValue = 0;
    for (var _i = 0; _i < transitionList.length; _i++) {
        var transition = transitionList[_i];
        var type = transition.type,
            time = transition.time;

        if (time > lastFilledTime) {
            tweenList.push({
                type: 'fromTo',
                from: lastValue,
                to: lastValue,
                ease: 'linear',
                time: lastFilledTime,
                duration: time - lastFilledTime
            });
            lastFilledTime = time;
        }
        var nextTime = _i < transitionList.length - 1 ? transitionList[_i + 1].time : transitionList[0].time + totalDuration;

        if (type === 'set') {
            tweenList.push({
                type: 'fromTo',
                from: transition.to,
                to: transition.to,
                ease: 'linear',
                time: time,
                duration: nextTime - time
            });
            lastFilledTime = nextTime;
            lastValue = transition.to;
        } else if (type === 'fromTo') {
            tweenList.push({
                type: 'fromTo',
                from: transition.from,
                to: transition.to,
                ease: transition.ease,
                time: time,
                duration: transition.duration
            });
            tweenList.push({
                type: 'fromTo',
                from: transition.to,
                to: transition.to,
                ease: 'linear',
                time: time + transition.duration,
                duration: nextTime - (time + transition.duration)
            });
            lastFilledTime = nextTime;
            lastValue = transition.to;
        }
    }
    if (lastFilledTime < totalDuration) {
        tweenList.push({
            type: 'fromTo',
            from: lastValue,
            to: lastValue,
            ease: 'linear',
            time: lastFilledTime,
            duration: totalDuration - lastFilledTime
        });
    }
    return tweenList;
}

function getTotalDuration(clips) {
    return clips.reduce(function (p, c) {
        if (c.clipType === 'image') {
            return p + c.clipDuration;
        }
        if (c.clipType === 'video') {
            return p + c.clipDuration / c.speed;
        }
        if (c.clipType === 'composite') {
            return p + c.clipDuration / c.speed;
        }
        return p;
    }, 0);
}

function getDurationUntilClip(clips, clipId) {
    var index = clips.findIndex(function (c) {
        return c.clipId === clipId;
    });
    return getReelDuration(clips.slice(0, index));
}

function getFormatFrameType(formatId) {
    return FormatTypes[formatId] ? FormatTypes[formatId].frameType : getCustomFrameTypeFromKey(formatId);
}

function getFormatGroupLabel(formatId) {
    return FormatGroups[FormatTypes[formatId].groupId].label;
}

function getCustomFormatGroupLabel() {
    return 'Custom';
}

function getFormatFromFrameType(frameType) {
    if (FrameTypes[frameType] && !FrameTypes[frameType].deprecated) {
        return Object.keys(FormatTypes).find(function (ftKey) {
            return FormatTypes[ftKey].frameType == frameType;
        });
    }
    return null;
}

/**
 * the actual duration of the clips playback in milliseconds.
 * @param {Array <>} clips
 */
function getReelDuration(clips) {
    if (clips.length > 0) {
        var totalAdjustment = 0;
        var clipCount = clips.length;
        // ALERT : MICRO _ OPTIMIZATION , SINCE ITS A TICKER METHOD -- DO NOT MEMOIZE
        // Converting to while loop , since it gets called inside ticker sync
        while (clipCount--) {
            var _clips$clipCount$tran = clips[clipCount].transitions;
            _clips$clipCount$tran = _clips$clipCount$tran === undefined ? {} : _clips$clipCount$tran;
            var enterTransition = _clips$clipCount$tran.enter,
                exitTransition = _clips$clipCount$tran.exit;

            if (enterTransition) {
                var _enterTransition$posi = enterTransition.position,
                    position = _enterTransition$posi === undefined ? 0 : _enterTransition$posi;

                if (position < 0) {
                    totalAdjustment += position;
                }
            }
            if (exitTransition) {
                var _exitTransition$posit = exitTransition.position,
                    _position = _exitTransition$posit === undefined ? 0 : _exitTransition$posit,
                    _exitTransition$durat = exitTransition.duration,
                    duration = _exitTransition$durat === undefined ? 0 : _exitTransition$durat;

                totalAdjustment += _position + duration;
            }
        }

        var lastExitDone = getReelLastExitDone(clips);

        return lastExitDone + totalAdjustment;
    }
    return 0;
}

/**
 * the duration of the template overlay.
 * @param {Array <>} clips
 */
function getTemplateDuration(overlay) {
    var _overlay$time = overlay.time;
    _overlay$time = _overlay$time === undefined ? {} : _overlay$time;
    var enterOverlay = _overlay$time.enterstart,
        exitOverlay = _overlay$time.exitdone;

    return exitOverlay - enterOverlay;
}

function getReelLastExitDone(clips) {
    if (clips.length > 0) {
        if (clips[0].hasOwnProperty('time')) {
            return Math.max.apply(Math, clips.map(function (c) {
                return c.time.exitDone;
            }));
        }
        return clips.reduce(function (accumulativeTime, c) {
            if (c.inputType === 'image') {
                return accumulativeTime + c.clipDuration;
            }
            if (c.inputType === 'video') {
                return accumulativeTime + c.clipEnd - c.clipStart;
            }
            return accumulativeTime;
        }, 0);
    }
    return 0;
}

function getReelLastEnterStart(clips, playerHeadTime) {
    if (clips.length > 0) {
        if (clips[0].hasOwnProperty('time')) {
            return Math.max.apply(Math, clips.map(function (c) {
                return c.time.enterStart;
            }));
        }
        return clips.reduce(function (accumulativeTime, c) {
            if (c.time.enterStart < playerHeadTime && c.time.exitDone < playerHeadTime) {
                if (c.inputType === 'image') {
                    return accumulativeTime + c.clipDuration;
                }
                if (c.inputType === 'video') {
                    return accumulativeTime + c.clipEnd - c.clipStart;
                }
            }
            return accumulativeTime;
        }, 0);
    }
    return 0;
}

function getTotalTimeOffset(clips) {
    if (clips.length > 0) {
        var clipOffsets = clips.map(function (c) {
            var _c$time2 = c.time,
                _c$time2$prevOffset = _c$time2.prevOffset,
                prevOffset = _c$time2$prevOffset === undefined ? 0 : _c$time2$prevOffset,
                _c$time2$currentOffse = _c$time2.currentOffset,
                currentOffset = _c$time2$currentOffse === undefined ? 0 : _c$time2$currentOffse;

            return prevOffset + currentOffset;
        });

        return Math.min.apply(Math, clipOffsets);
    }
    return 0;
}

function getSelectedClip(clips, playerHeadTime) {
    var selectedClipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var selectedClip = null;
    if (clips.length > 0) {
        if (selectedClipId) {
            selectedClip = clips.find(function (clip) {
                return clip.clipId === selectedClipId;
            });
        } else {
            var selectedClips = clips.filter(function (clip) {
                return clip.isSelected;
            });
            selectedClip = selectedClips.length > 0 ? selectedClips[0] : null;
        }

        if (!selectedClip) {
            selectedClip = clips.filter(function (clip) {
                return clip.time.enterStart <= playerHeadTime && clip.time.exitDone >= playerHeadTime;
            });
            selectedClip = selectedClip.length > 0 ? selectedClip[0] : null;
        }
    }
    return selectedClip;
}

function getReelLastExitDoneAfterSelectedClip(clips, player) {
    var selectedClipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (clips.length > 0) {
        var playerHeadTime = player.time;

        var selectedClip = getSelectedClip(clips, playerHeadTime, selectedClipId);

        if (!selectedClip) {
            var lastExit = getReelLastExitDone(clips);
            return lastExit;
        }

        if (selectedClip.hasOwnProperty('time')) {
            return selectedClip.time.exitDone;
        }
        return clips.reduce(function (accumulativeTime, c) {
            if (c.time.enterStart < playerHeadTime && c.time.exitDone < playerHeadTime || c.time.enterStart <= playerHeadTime && c.time.exitDone > playerHeadTime) {
                if (c.inputType === 'image') {
                    return accumulativeTime + c.clipDuration;
                }
                if (c.inputType === 'video') {
                    return accumulativeTime + c.clipEnd - c.clipStart;
                }
            }
            return accumulativeTime;
        }, 0);
    }
    return 0;
}

function getReelLastExitDoneBeforeSelectedClip(clips, player) {
    var selectedClipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (clips.length > 0) {
        var playerHeadTime = player.time;

        var selectedClip = getSelectedClip(clips, playerHeadTime, selectedClipId);

        if (!selectedClip) {
            var lastEnterStart = getReelLastEnterStart(clips, playerHeadTime);
            return lastEnterStart;
        }

        if (selectedClip.hasOwnProperty('time')) {
            return selectedClip.time.enterStart;
        }
        return clips.reduce(function (accumulativeTime, c) {
            if (c.time.enterStart < playerHeadTime && c.time.exitDone < playerHeadTime) {
                if (c.inputType === 'image') {
                    return accumulativeTime + c.clipDuration;
                }
                if (c.inputType === 'video') {
                    return accumulativeTime + c.clipEnd - c.clipStart;
                }
                if (c.inputType === 'composite') {
                    return accumulativeTime + c.clipDuration;
                }
            }
            return accumulativeTime;
        }, 0);
    }
    return 0;
}

var getClipsAfterTime = function getClipsAfterTime(clips, time) {
    return clips.filter(function (c) {
        var _c$time3 = c.time,
            enterStart = _c$time3.enterStart,
            _c$time3$currentOffse = _c$time3.currentOffset,
            currentOffset = _c$time3$currentOffse === undefined ? 0 : _c$time3$currentOffse,
            _c$time3$prevOffset = _c$time3.prevOffset,
            prevOffset = _c$time3$prevOffset === undefined ? 0 : _c$time3$prevOffset;

        return enterStart + currentOffset + prevOffset >= time;
    });
};

var getClipsBeforeTime = function getClipsBeforeTime(clips, time) {
    return clips.filter(function (c) {
        var _c$time4 = c.time,
            exitDone = _c$time4.exitDone,
            _c$time4$currentOffse = _c$time4.currentOffset,
            currentOffset = _c$time4$currentOffse === undefined ? 0 : _c$time4$currentOffse,
            _c$time4$prevOffset = _c$time4.prevOffset,
            prevOffset = _c$time4$prevOffset === undefined ? 0 : _c$time4$prevOffset;

        return exitDone + currentOffset + prevOffset <= time;
    });
};

/**
 * Takes a time range and list of clips and returns the clip contained in
 * [startTime , endTime] , inclusive
 *
 * @param {*} clips
 * @param {*} startTime
 * @param {*} endTime
 * @return {*}
 */
var getClipsInTimeRange = function getClipsInTimeRange(clips, startTime, endTime) {
    return clips.filter(function (c) {
        var _c$time5 = c.time,
            enterStart = _c$time5.enterStart,
            _c$time5$currentOffse = _c$time5.currentOffset,
            currentOffset = _c$time5$currentOffse === undefined ? 0 : _c$time5$currentOffse,
            _c$time5$prevOffset = _c$time5.prevOffset,
            prevOffset = _c$time5$prevOffset === undefined ? 0 : _c$time5$prevOffset,
            exitDone = _c$time5.exitDone;

        return enterStart + currentOffset + prevOffset <= endTime && exitDone + currentOffset + prevOffset >= startTime;
    });
};

/**
 * Gets current Clip , needs update.
 * Better Query structure, should optimize
 *
 * @param {*} clips
 * @param {*} currentTime
 * @return {*}
 */
function getClipAtTime(clips, currentTime) {
    return _getCurrentClip(clips, currentTime);
}

function _getCurrentClip(clips, currentTime) {
    var currentClip = null;

    var clipTimes = getClipTimes(clips);

    for (var i = 0; i < clips.length; i++) {
        var clip = clips[i];
        var clipTime = clipTimes[clip.clipId];

        var enterStart = clipTime.enterStart,
            exitDone = clipTime.exitDone,
            prevOffset = clipTime.prevOffset,
            currentOffset = clipTime.currentOffset;

        if (currentTime >= enterStart + currentOffset + prevOffset && currentTime <= exitDone + currentOffset + prevOffset) {
            currentClip = clip;
            break;
        }

        if (i === clips.length - 1 && currentClip === null) {
            // Last clip
            currentClip = clip;
        }
    }
    return currentClip;
}

function getTotalTimeOffsetAfterSelectedClip(clips, player) {
    var selectedClipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (clips.length > 0) {
        var afterTime = player.time;

        if (selectedClipId) {
            // If a selected clip is passed, get time offset after the selected clip
            var selectedClip = clips.find(function (clip) {
                return clip.clipId === selectedClipId;
            });
            afterTime = selectedClip.time.exitDone + selectedClip.time.currentOffset + selectedClip.time.prevOffset;
        }

        return getTotalTimeOffset(getClipsAfterTime(clips, afterTime));
    }
    return 0;
}

function getTotalTimeOffsetBeforeSelectedClip(clips, player) {
    var selectedClipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (clips.length > 0) {
        var beforeTime = player.time;

        if (selectedClipId) {
            // If a selected clip is passed, get time offset before the selected clip
            var selectedClip = clips.find(function (clip) {
                return clip.clipId === selectedClipId;
            });
            beforeTime = Math.floor(selectedClip.time.enterStart + selectedClip.time.currentOffset + selectedClip.time.prevOffset);
        }
        return getTotalTimeOffset(getClipsBeforeTime(clips, beforeTime));
    }
    return 0;
}

function getOverlayIdsStartingOnClip(allOverlays, clip) {
    var clipOverlaysIds = [];
    var _clip$time = clip.time,
        enterStart = _clip$time.enterStart,
        exitDone = _clip$time.exitDone,
        _clip$time$currentOff = _clip$time.currentOffset,
        currentOffset = _clip$time$currentOff === undefined ? 0 : _clip$time$currentOff,
        _clip$time$prevOffset = _clip$time.prevOffset,
        prevOffset = _clip$time$prevOffset === undefined ? 0 : _clip$time$prevOffset;

    var clipEnterStart = Math.floor(enterStart + currentOffset + prevOffset);
    var clipExitDone = Math.floor(exitDone + currentOffset + prevOffset);

    clipOverlaysIds = Object.keys(allOverlays).filter(function (key) {
        return allOverlays[key].time.enterstart >= clipEnterStart && allOverlays[key].time.enterstart <= clipExitDone;
    });
    return clipOverlaysIds;
}

function moveOverlays(overlays, leftClip, rightClip) {
    var movedOverlays = cloner.clone(overlays);

    var leftClipDuration = Math.floor(leftClip.time.exitDone - leftClip.time.enterStart);
    var rightClipDuration = Math.floor(rightClip.time.exitDone - rightClip.time.enterStart);

    var leftClipOverlaysIds = getOverlayIdsStartingOnClip(overlays, leftClip);
    var rightClipOverlaysIds = getOverlayIdsStartingOnClip(overlays, rightClip);

    leftClipOverlaysIds.forEach(function (overlayId) {
        var o = cloner.clone(overlays[overlayId]);

        o.time = _extends({}, overlays[overlayId].time, {
            enterstart: Math.floor(Math.max(0, o.time.enterstart + rightClipDuration)),
            enterdone: Math.floor(Math.max(0, o.time.enterdone + rightClipDuration)),
            exitstart: Math.floor(Math.max(0, o.time.exitstart + rightClipDuration)),
            exitdone: Math.floor(Math.max(0, o.time.exitdone + rightClipDuration))
        });

        movedOverlays[overlayId] = o;
    });

    rightClipOverlaysIds.forEach(function (overlayId) {
        var o = cloner.clone(overlays[overlayId]);

        o.time = _extends({}, overlays[overlayId].time, {
            enterstart: Math.floor(Math.max(0, o.time.enterstart - leftClipDuration)),
            enterdone: Math.floor(Math.max(0, o.time.enterdone - leftClipDuration)),
            exitstart: Math.floor(Math.max(0, o.time.exitstart - leftClipDuration)),
            exitdone: Math.floor(Math.max(0, o.time.exitdone - leftClipDuration))
        });

        movedOverlays[overlayId] = o;
    });
    return movedOverlays;
}

function moveOverlaysOnClipMove(overlays, clips, clipId, newIndex) {
    var newClips = cloner.clone(clips);
    newClips.sort(function (a, b) {
        return a.time.enterStart - b.time.enterStart;
    });

    var oldIndex = newClips.findIndex(function (c) {
        return c.clipId === clipId;
    });

    var movedOverlays = cloner.clone(overlays);

    if (oldIndex > newIndex) {
        for (var i = oldIndex; i > newIndex; i--) {
            var leftClip = cloner.clone(newClips[i - 1]); // 1
            var rightClip = cloner.clone(newClips[i]); // 2

            movedOverlays = moveOverlays(movedOverlays, leftClip, rightClip);
        }
    } else if (oldIndex < newIndex) {
        for (var _i2 = oldIndex; _i2 < newIndex; _i2++) {
            var _leftClip = cloner.clone(newClips[_i2]);
            var _rightClip = cloner.clone(newClips[_i2 + 1]);
            movedOverlays = moveOverlays(movedOverlays, _leftClip, _rightClip);
        }
    }

    return movedOverlays;
}

function moveClip(clips, clipId, newIndex) {
    var newClips = cloner.clone(clips);
    newClips.sort(function (a, b) {
        return a.time.enterStart - b.time.enterStart;
    });

    var oldIndex = newClips.findIndex(function (c) {
        return c.clipId === clipId;
    });

    if (oldIndex > newIndex) {
        for (var i = oldIndex; i > newIndex; i--) {
            var leftClip = cloner.clone(newClips[i - 1]); // 1
            var rightClip = cloner.clone(newClips[i]); // 2

            var rightClipDuration = Math.floor(rightClip.time.exitDone - rightClip.time.enterStart);
            var leftClipDuration = Math.floor(leftClip.time.exitDone - leftClip.time.enterStart);

            newClips[i] = _extends({}, leftClip, {
                time: _extends({}, leftClip.time, {
                    enterStart: Math.floor(leftClip.time.enterStart + rightClipDuration),
                    enterDone: Math.floor(leftClip.time.enterDone + rightClipDuration),
                    exitStart: Math.floor(leftClip.time.exitStart + rightClipDuration),
                    exitDone: Math.floor(leftClip.time.exitDone + rightClipDuration)
                })
            });
            newClips[i - 1] = _extends({}, rightClip, {
                time: _extends({}, rightClip.time, {
                    enterStart: Math.floor(rightClip.time.enterStart - leftClipDuration),
                    enterDone: Math.floor(rightClip.time.enterDone - leftClipDuration),
                    exitStart: Math.floor(rightClip.time.exitStart - leftClipDuration),
                    exitDone: Math.floor(rightClip.time.exitDone - leftClipDuration)
                })
            });
        }
    } else if (oldIndex < newIndex) {
        for (var _i3 = oldIndex; _i3 < newIndex; _i3++) {
            var _leftClip2 = cloner.clone(newClips[_i3]);
            var _rightClip2 = cloner.clone(newClips[_i3 + 1]);

            var _leftClipDuration = Math.floor(_leftClip2.time.exitDone - _leftClip2.time.enterStart);
            var _rightClipDuration = Math.floor(_rightClip2.time.exitDone - _rightClip2.time.enterStart);

            newClips[_i3] = _extends({}, _rightClip2, {
                time: _extends({}, _rightClip2.time, {
                    enterStart: Math.floor(_rightClip2.time.enterStart - _leftClipDuration),
                    enterDone: Math.floor(_rightClip2.time.enterDone - _leftClipDuration),
                    exitStart: Math.floor(_rightClip2.time.exitStart - _leftClipDuration),
                    exitDone: Math.floor(_rightClip2.time.exitDone - _leftClipDuration)
                })
            });
            newClips[_i3 + 1] = _extends({}, _leftClip2, {
                time: _extends({}, _leftClip2.time, {
                    enterStart: Math.floor(_leftClip2.time.enterStart + _rightClipDuration),
                    enterDone: Math.floor(_leftClip2.time.enterDone + _rightClipDuration),
                    exitStart: Math.floor(_leftClip2.time.exitStart + _rightClipDuration),
                    exitDone: Math.floor(_leftClip2.time.exitDone + _rightClipDuration)
                })
            });
        }
    }
    return newClips;
}

function getAdjacentClipIds(clips, clipId) {
    var newClips = cloner.clone(clips);
    newClips.sort(function (a, b) {
        return a.time.enterStart - b.time.enterStart;
    });

    var clipIndex = newClips.findIndex(function (c) {
        return c.clipId == clipId;
    });

    var leftClipId = null;
    var rightClipId = null;

    if (clipIndex !== -1) {
        if (clipIndex > 0) {
            leftClipId = newClips[clipIndex - 1].clipId;
        }
        if (clipIndex < clips.length - 1) {
            rightClipId = newClips[clipIndex + 1].clipId;
        }
    }

    return { leftClipId: leftClipId, rightClipId: rightClipId };
}

function getTransitionBetweenClips(clips, leftClipId, rightClipId) {
    var allTransitions = getAllTransitions(clips);

    var transition = allTransitions[leftClipId + '::::' + rightClipId];

    if (!transition) {
        return TransitionType.NONE;
    }

    return transition.transitionType;
}

function getAllTransitions(clips) {
    var newClips = cloner.clone(clips);
    newClips.sort(function (a, b) {
        return a.time.enterStart - b.time.enterStart;
    });

    var clipTransitions = {};
    var clipTimes = getClipTimes(newClips);

    newClips.forEach(function (c, i) {
        var hasEnterTransition = c.transitions.hasOwnProperty('enter');
        var hasExitTransition = c.transitions.hasOwnProperty('exit');

        if (hasExitTransition && i < newClips.length - 1) {
            var leftClip = newClips[i];
            var rightClip = newClips[i + 1];

            var leftClipTime = clipTimes[leftClip.clipId];
            var rightClipTime = clipTimes[rightClip.clipId];

            var transitionKey = leftClip.clipId + '::::' + rightClip.clipId;

            if (leftClip.transitions.hasOwnProperty('exit') && rightClip.transitions.hasOwnProperty('enter') && !clipTransitions.hasOwnProperty('transitionKey')) {
                var startTime = Math.floor(Math.min(leftClipTime.exitDone + leftClipTime.currentOffset + leftClipTime.prevOffset, rightClipTime.enterStart + rightClipTime.currentOffset + rightClipTime.prevOffset));
                var endTime = Math.floor(Math.max(leftClipTime.exitDone + leftClipTime.currentOffset + leftClipTime.prevOffset, rightClipTime.enterStart + rightClipTime.currentOffset + rightClipTime.prevOffset));

                var leftTransition = leftClip.transitions.exit;
                var rightTransition = rightClip.transitions.enter;

                clipTransitions[transitionKey] = {
                    start: startTime,
                    end: endTime,
                    transitionType: leftTransition.transitionType
                };
            }
        }

        if (hasEnterTransition && i > 0) {
            var _leftClip3 = newClips[i - 1];
            var _rightClip3 = newClips[i];

            var _leftClipTime = clipTimes[_leftClip3.clipId];
            var _rightClipTime = clipTimes[_rightClip3.clipId];

            var _transitionKey = _leftClip3.clipId + '::::' + _rightClip3.clipId;

            if (_leftClip3.transitions.hasOwnProperty('exit') && _rightClip3.transitions.hasOwnProperty('enter') && !clipTransitions.hasOwnProperty('transitionKey')) {
                var _startTime = Math.floor(Math.min(_leftClipTime.exitDone + _leftClipTime.currentOffset + _leftClipTime.prevOffset, _rightClipTime.enterStart + _rightClipTime.currentOffset + _rightClipTime.prevOffset));
                var _endTime = Math.floor(Math.max(_leftClipTime.exitDone + _leftClipTime.currentOffset + _leftClipTime.prevOffset, _rightClipTime.enterStart + _rightClipTime.currentOffset + _rightClipTime.prevOffset));

                var _leftTransition = _leftClip3.transitions.exit;
                var _rightTransition = _rightClip3.transitions.enter;

                clipTransitions[_transitionKey] = {
                    start: _startTime,
                    end: _endTime,
                    transitionType: _leftTransition.transitionType
                };
            }
        }
    });

    return clipTransitions;
}

function getClipTime(clips, clipId) {
    var clip = clips.find(function (c) {
        return c.clipId === clipId;
    });

    var _clip$time2 = clip.time,
        enterStart = _clip$time2.enterStart,
        exitDone = _clip$time2.exitDone,
        transitions = clip.transitions;

    var offset = 0;

    if (transitions.hasOwnProperty('enter')) {
        var _transitions$enter = transitions.enter,
            _transitions$enter$po = _transitions$enter.position,
            position = _transitions$enter$po === undefined ? 0 : _transitions$enter$po,
            _transitions$enter$du = _transitions$enter.duration,
            duration = _transitions$enter$du === undefined ? 0 : _transitions$enter$du;

        if (position < 0) {
            enterStart += position;
            exitDone += position;
            offset += position;
        }
    }

    if (transitions.hasOwnProperty('exit')) {
        var _transitions$exit = transitions.exit,
            _transitions$exit$pos = _transitions$exit.position,
            _position2 = _transitions$exit$pos === undefined ? 0 : _transitions$exit$pos,
            _transitions$exit$dur = _transitions$exit.duration,
            _duration = _transitions$exit$dur === undefined ? 0 : _transitions$exit$dur;

        exitDone += _position2 + _duration;
    }

    var totalAdjustment = clips.filter(function (c) {
        return c.time.enterStart < clip.time.enterStart;
    }).reduce(function (total, c) {
        var _c$transitions = c.transitions,
            enterTransition = _c$transitions.enter,
            exitTransition = _c$transitions.exit;

        var totalAdjustment = 0;
        if (enterTransition) {
            var _enterTransition$posi2 = enterTransition.position,
                _position3 = _enterTransition$posi2 === undefined ? 0 : _enterTransition$posi2;

            if (_position3 < 0) {
                totalAdjustment += _position3;
            }
        }
        if (exitTransition) {
            var _exitTransition$posit2 = exitTransition.position,
                _position4 = _exitTransition$posit2 === undefined ? 0 : _exitTransition$posit2,
                _exitTransition$durat2 = exitTransition.duration,
                _duration2 = _exitTransition$durat2 === undefined ? 0 : _exitTransition$durat2;

            totalAdjustment += _position4 + _duration2;
        }
        return total + totalAdjustment;
    }, 0);

    // enterStart += totalAdjustment
    // exitDone += totalAdjustment

    return { enterStart: enterStart, exitDone: exitDone, currentOffset: offset, totalOffset: totalAdjustment };
}

function getClipTimes(clips) {
    var clipTimeMap = {};

    clips.forEach(function (clip) {
        // const clip = clips.find(c => c.clipId == clipId)

        var _clip$time3 = clip.time,
            enterStart = _clip$time3.enterStart,
            exitDone = _clip$time3.exitDone,
            transitions = clip.transitions;

        var offset = 0;

        if (transitions.hasOwnProperty('enter')) {
            var _transitions$enter2 = transitions.enter,
                _transitions$enter2$p = _transitions$enter2.position,
                position = _transitions$enter2$p === undefined ? 0 : _transitions$enter2$p,
                _transitions$enter2$d = _transitions$enter2.duration,
                duration = _transitions$enter2$d === undefined ? 0 : _transitions$enter2$d;

            if (position < 0) {
                // enterStart += position
                // exitDone += position
                offset += position;
            }
        }

        // if(transitions.hasOwnProperty('exit')){
        //     const { position = 0, duration = 0 } = transitions.exit
        //     exitDone += position + duration
        // }

        var totalAdjustment = clips.filter(function (c) {
            return c.time.enterStart < clip.time.enterStart;
        }).reduce(function (total, c) {
            var _c$transitions2 = c.transitions,
                enterTransition = _c$transitions2.enter,
                exitTransition = _c$transitions2.exit;

            var totalAdjustment = 0;
            if (enterTransition) {
                var _enterTransition$posi3 = enterTransition.position,
                    _position5 = _enterTransition$posi3 === undefined ? 0 : _enterTransition$posi3;

                if (_position5 < 0) {
                    totalAdjustment += _position5;
                }
            }
            if (exitTransition) {
                var _exitTransition$posit3 = exitTransition.position,
                    _position6 = _exitTransition$posit3 === undefined ? 0 : _exitTransition$posit3,
                    _exitTransition$durat3 = exitTransition.duration,
                    _duration3 = _exitTransition$durat3 === undefined ? 0 : _exitTransition$durat3;

                totalAdjustment += _position6 + _duration3;
            }
            return total + totalAdjustment;
        }, 0);

        // enterStart += totalAdjustment
        // exitDone += totalAdjustment

        clipTimeMap[clip.clipId] = {
            enterStart: enterStart,
            exitDone: exitDone,
            currentOffset: offset,
            prevOffset: totalAdjustment
        };
    });

    return clipTimeMap;
}

function getTransitionsFromTypes(transitionType) {
    var transitionDuration = 1000;
    var exitTransition = {};
    var enterTransition = {};

    if (transitionType === TransitionType.NONE) {
        exitTransition = {
            position: 0,
            duration: 0,
            transitionType: transitionType,
            transitionAnimation: 'NONE'
        };
        enterTransition = {
            position: 0,
            duration: 0,
            transitionType: transitionType,
            transitionAnimation: 'NONE'
        };
    } else if (transitionType === TransitionType.FADE_TO_BLACK) {
        exitTransition = {
            position: -transitionDuration / 2,
            duration: transitionDuration / 2,
            transitionType: transitionType,
            transitionAnimation: 'FADE_OUT'
        };
        enterTransition = {
            position: 0,
            duration: transitionDuration / 2,
            transitionType: transitionType,
            transitionAnimation: 'FADE_IN'
        };
    } else if (transitionType === TransitionType.CROSS_DISSOLVE) {
        exitTransition = {
            position: -transitionDuration,
            duration: transitionDuration,
            transitionType: transitionType,
            transitionAnimation: 'FADE_OUT'
        };
        enterTransition = {
            position: -transitionDuration,
            duration: transitionDuration,
            transitionType: transitionType,
            transitionAnimation: 'FADE_IN'
        };
    } else if (transitionType === TransitionType.FROM_BOTTOM || transitionType === TransitionType.FROM_RIGHT) {
        transitionDuration = 500;
        exitTransition = {
            position: 0,
            duration: 0,
            transitionType: transitionType,
            transitionAnimation: transitionType
        };
        enterTransition = {
            position: -transitionDuration,
            duration: transitionDuration,
            transitionType: transitionType,
            transitionAnimation: transitionType
        };
    }

    return {
        enterTransition: enterTransition,
        exitTransition: exitTransition
    };
}

function getTransitionLabel(transitionType) {
    switch (transitionType) {
        case TransitionType.NONE:
            return 'None';
        case TransitionType.CROSS_DISSOLVE:
            return 'Cross Dissolve';
        case TransitionType.FADE_TO_BLACK:
            return 'Fade to Black';
        case TransitionType.FROM_BOTTOM:
            return 'From Bottom';
        case TransitionType.FROM_RIGHT:
            return 'From Right';
        default:
            return 'None';
    }
}

function getSolidImageId() {
    return SolidImageId;
}

var toGSAPtime = function toGSAPtime(time) {
    return time / 1000;
};

var getAnimationLessRangesFromAnimRanges = function getAnimationLessRangesFromAnimRanges(animationTimeRanges, projectDuration) {
    var animationLessTimeRanges = [];
    var lastVal = 0;

    animationTimeRanges.forEach(function (ar) {
        var start = ar.start,
            end = ar.end;

        if (lastVal < start) {
            animationLessTimeRanges.push({ start: lastVal, end: start });
        }
        lastVal = end;
    });

    if (lastVal < toGSAPtime(projectDuration)) {
        animationLessTimeRanges.push({ start: lastVal, end: toGSAPtime(projectDuration) });
    }

    return animationLessTimeRanges;
};

var mergeRanges = function mergeRanges(ranges) {
    var result = [];
    var last = void 0;

    ranges.forEach(function (r) {
        if (!last || r.start > last.end) result.push(last = r);else if (r.end > last.end) last.end = r.end;
    });

    return result;
};

var getAnimationLessTimeRangesForProject = function getAnimationLessTimeRangesForProject(overlays, projectDuration) {
    var animationTimeRanges = [];
    var timePadInMs = 100;
    var byIsOverlayVisible = function byIsOverlayVisible(overlay) {
        return !overlay.hide;
    };
    overlays = overlays.filter(byIsOverlayVisible);
    overlays.forEach(function (overlay) {
        var _overlay$time2 = overlay.time,
            enterstart = _overlay$time2.enterstart,
            enterdone = _overlay$time2.enterdone,
            exitstart = _overlay$time2.exitstart,
            exitdone = _overlay$time2.exitdone;

        if (enterstart === enterdone) {
            enterdone += 1;
        }

        if (exitstart === exitdone) {
            exitdone += 1;
        }

        animationTimeRanges.push({
            start: toGSAPtime(Math.min(projectDuration, Math.max(0, enterstart - timePadInMs))),
            end: toGSAPtime(Math.min(projectDuration, enterdone + timePadInMs))
        });

        animationTimeRanges.push({
            start: toGSAPtime(Math.min(projectDuration, Math.max(0, exitstart - timePadInMs))),
            end: toGSAPtime(Math.min(projectDuration, exitdone + timePadInMs))
        });
    });

    animationTimeRanges.sort(function (a, b) {
        return a.start - b.start || a.end - b.end;
    });

    animationTimeRanges = mergeRanges(animationTimeRanges);

    var animationLessTimeRanges = getAnimationLessRangesFromAnimRanges(animationTimeRanges, projectDuration);

    return { animationTimeRanges: animationTimeRanges, animationLessTimeRanges: animationLessTimeRanges };
};

function convertVideoThumbnailBaseUrlToFullUrl(url) {
    return url + '/thumb_256x144_32_0.jpg?v=1';
}
// TODO -- micro optimisation , use numbers to signify clip hash property
function computeUniqueClipOrderHash() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var it = clips.length;
    var hash = '';
    while (it--) {
        hash = clips[it].clipId + '#--#' + hash;
    }
    return hash;
}

var getMinDurationForClip = function getMinDurationForClip(enter, exit) {
    if (enter.transitionType === 'CROSS_DISSOLVE' || exit.transitionType === 'CROSS_DISSOLVE') {
        return MIN_CLIP_DURATION_CROSS_DISOLVE;
    }
    return MIN_CLIP_DURATION;
};

var getSourceAndTargetLanguage = function getSourceAndTargetLanguage() {
    var toolData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var slang = 'en-US',
        tlang = 'en';

    if (toolData.tool === 'captions') {
        slang = toolData.slang || slang;
        tlang = toolData.tlang || tlang;
    }

    return {
        slang: slang,
        tlang: tlang
    };
};

module.exports = {
    getMinDurationForClip: getMinDurationForClip,
    computeUniqueClipOrderHash: computeUniqueClipOrderHash,
    convertVideoThumbnailBaseUrlToFullUrl: convertVideoThumbnailBaseUrlToFullUrl,
    flattenProjectClips: flattenProjectClips,
    createClipListFromCompositeClip: createClipListFromCompositeClip,
    getClipsInTimeRange: getClipsInTimeRange,
    getClipAtTime: getClipAtTime,
    getContentBox: getContentBox,
    getVolumeTransitionListForReelAudio: getVolumeTransitionListForReelAudio,
    getVolumeTransitionListForOverlayAudio: getVolumeTransitionListForOverlayAudio,
    computeSizeForAR: computeSizeForAR,
    capOutputCanvasSize: capOutputCanvasSize,
    getMaxClipBoxSize: getMaxClipBoxSize,
    getMinClipBoxSize: getMinClipBoxSize,
    getClipBoxLimits: getClipBoxLimits,
    calcDefaultClipBox: calcDefaultClipBox,
    getTotalDuration: getTotalDuration,
    updateReelWithFrameType: updateReelWithFrameType,
    allFrameTypes: allFrameTypes,
    newFrameTypes: newFrameTypes,
    customFrameTypes: customFrameTypes,
    deprecatedFrameTypes: deprecatedFrameTypes,
    nameForFrameType: nameForFrameType,
    aspectRatioLabelForFrameType: aspectRatioLabelForFrameType,
    createNewVideoClip: createNewVideoClip,
    createNewImageClip: createNewImageClip,
    createNewAudioClip: createNewAudioClip,
    hydrateClips: hydrateClips,
    allFormatTypes: allFormatTypes,
    getFormatData: getFormatData,
    getFormatFrameType: getFormatFrameType,
    getFormatGroupLabel: getFormatGroupLabel,
    updateReelWithFormat: updateReelWithFormat,
    getFormatFromFrameType: getFormatFromFrameType,
    getReelDuration: getReelDuration,
    getTemplateDuration: getTemplateDuration,
    customFormatTypes: customFormatTypes,
    getCustomFormatData: getCustomFormatData,
    getCustomFormatGroupLabel: getCustomFormatGroupLabel,
    getCustomFrameTypeFromKey: getCustomFrameTypeFromKey,
    moveClip: moveClip,
    getAdjacentClipIds: getAdjacentClipIds,
    getTransitionBetweenClips: getTransitionBetweenClips,
    getAllTransitions: getAllTransitions,
    getTransitionsFromTypes: getTransitionsFromTypes,
    getClipTime: getClipTime,
    getClipTimes: getClipTimes,
    getTransitionLabel: getTransitionLabel,
    getReelLastExitDone: getReelLastExitDone,
    getTotalTimeOffset: getTotalTimeOffset,
    getBestFitCanvasRatio: getBestFitCanvasRatio,
    moveOverlaysOnClipMove: moveOverlaysOnClipMove,
    calcRotatedClipBox: calcRotatedClipBox,
    getReelLastExitDoneBeforeSelectedClip: getReelLastExitDoneBeforeSelectedClip,
    getReelLastExitDoneAfterSelectedClip: getReelLastExitDoneAfterSelectedClip,
    getTotalTimeOffsetBeforeSelectedClip: getTotalTimeOffsetBeforeSelectedClip,
    getTotalTimeOffsetAfterSelectedClip: getTotalTimeOffsetAfterSelectedClip,
    getSelectedClip: getSelectedClip,
    createNewSolidImageClip: createNewSolidImageClip,
    replaceClipWithImage: replaceClipWithImage,
    replaceClipWithVideo: replaceClipWithVideo,
    getSolidImageId: getSolidImageId,
    createNewCompositeClip: createNewCompositeClip,
    getAnimationLessTimeRangesForProject: getAnimationLessTimeRangesForProject,
    toGSAPtime: toGSAPtime,
    getFrameTypeInfo: getFrameTypeInfo,
    adjustClipList2Time: adjustClipList2Time,
    adjustClipList2ZeroOffset: adjustClipList2ZeroOffset,
    buildCustomFormatAppData: buildCustomFormatAppData,
    checkIsSolidImageClip: checkIsSolidImageClip,
    IMAGE_ANIMATIONS: IMAGE_ANIMATIONS,
    MIN_CLIP_DURATION_CROSS_DISOLVE: MIN_CLIP_DURATION_CROSS_DISOLVE,
    MIN_CLIP_DURATION: MIN_CLIP_DURATION,
    MIN_CLIP_DURATION_FOR_SPLIT: MIN_CLIP_DURATION_FOR_SPLIT,
    MAX_IMAGE_CLIP_DURATION: MAX_IMAGE_CLIP_DURATION,
    getFormatLabel: getFormatLabel,
    getDurationUntilClip: getDurationUntilClip,
    fixTimelineGap: fixTimelineGap,
    getSourceAndTargetLanguage: getSourceAndTargetLanguage
};

},{"../constants/SolidImage":66,"./GeneralUtils":77,"./enums/TransitionType":98,"cloneextend":412,"lodash":860,"shortid":1163}],86:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WaitMode = require('./enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _TimeUtils = require('./TimeUtils');

var _DashJSPlayer = require('./players/DashJSPlayer');

var _DashJSPlayer2 = _interopRequireDefault(_DashJSPlayer);

var _PlayerEvents = require('./players/PlayerEvents');

var _PlayerEvents2 = _interopRequireDefault(_PlayerEvents);

var _PlaybackState = require('./enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _ReelHelpers = require('./ReelHelpers');

var _GeneralUtils = require('./GeneralUtils');

var _BaseSingleClipController = require('./BaseSingleClipController');

var _BaseSingleClipController2 = _interopRequireDefault(_BaseSingleClipController);

var _CommonAlgorithms = require('./CommonAlgorithms');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _require = require('cloneextend'),
    clone = _require.clone;

var DEBUG = false;

var dlog = DEBUG ? function () {
    var _console;

    return (_console = console).log.apply(_console, arguments);
} : function () {};

var SingleCompositeClipController = function (_BaseSingleClipContro) {
    _inherits(SingleCompositeClipController, _BaseSingleClipContro);

    function SingleCompositeClipController() {
        var allClipControllers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, SingleCompositeClipController);

        var _this = _possibleConstructorReturn(this, (SingleCompositeClipController.__proto__ || Object.getPrototypeOf(SingleCompositeClipController)).call(this));

        if (allClipControllers.length === 0) throw Error('Child Clip Controller List cannot be empty !!');

        _this._clipControllers = {};

        _this.allClipControllers = allClipControllers;
        _this._transitionTimeline = new TimelineMax({ paused: true });

        _this._updateAllLabelsAndCallbacks = (0, _GeneralUtils.debounce)(_this._updateAllLabelsAndCallbacks.bind(_this), 500);
        return _this;
    }

    _createClass(SingleCompositeClipController, [{
        key: '_updatePlayerDimensions',
        value: function _updatePlayerDimensions() {
            var _this2 = this;

            var _videoNodeContainer$g = this._videoNodeContainer.get(0),
                containerWidth = _videoNodeContainer$g.clientWidth,
                containerHeight = _videoNodeContainer$g.clientHeight;

            Object.values(this.allClipControllers).forEach(function (cc) {
                var canvas = _this2.canvas;
                var _cc$clip$clipBox = cc.clip.clipBox,
                    clipBox = _cc$clip$clipBox === undefined ? null : _cc$clip$clipBox;

                var clipElLeft = 0;
                var clipElTop = 0;
                var clipElWidth = 0;
                var clipElHeight = 0;
                var clipElRotate = 0;

                var scaleX = 1;
                var scaleY = 1;

                if (clipBox && canvas) {
                    var containerScaleX = containerWidth / canvas.width;
                    var containerScaleY = containerHeight / canvas.height;

                    clipElLeft = clipBox.x * containerScaleX;
                    clipElTop = clipBox.y * containerScaleY;
                    clipElWidth = clipBox.width / clipBox.sar * containerScaleX;
                    clipElHeight = clipBox.height * containerScaleY;
                    clipElRotate = clipBox.rotateDeg || 0;

                    scaleX = clipBox.sar;
                    scaleY = 1;
                }

                cc.applyDimensions({
                    height: clipElHeight,
                    width: clipElWidth,
                    top: clipElTop,
                    left: clipElLeft
                });

                cc.applyTranform({
                    rotateDeg: clipElRotate,
                    scaleX: scaleX,
                    scaleY: scaleY
                });
            });
        }
    }, {
        key: 'applyDimensions',
        value: function applyDimensions(_ref) {
            var height = _ref.height,
                width = _ref.width,
                top = _ref.top,
                left = _ref.left;

            this._updatePlayerDimensions();
        }

        // transform applied in video clip can be done directly in the displayEl
        // will apply transform for every clip or no clip
        // requirement not specified currentlu doing nothing

    }, {
        key: 'applyTranform',
        value: function applyTranform(_ref2) {
            var rotateDeg = _ref2.rotateDeg,
                scaleX = _ref2.scaleX,
                scaleY = _ref2.scaleY;

            this.displayEl.css('webkitTransform', 'scale(' + scaleX + ', ' + scaleY + ')').css('msTransform', 'scale(' + scaleX + ', ' + scaleY + ')').css('transform', 'scale(' + scaleX + ', ' + scaleY + ')');

            this._updatePlayerDimensions(); // constly all controllers updation of dimension
        }

        // apply for all or do nothing

    }, {
        key: '_applyBgColor',
        value: function _applyBgColor(bgColor) {
            // do nothing :)
        }
    }, {
        key: '_onCreateNode',
        value: function _onCreateNode(id) {
            var containerEl = window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden');

            // container display element , dimension should not change
            var displayEl = window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').attr('id', 'composite-player-' + id);

            containerEl.append(displayEl);

            var clipBoxEl = window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden').attr('class', 'clipbox');

            containerEl.append(clipBoxEl);

            this._videoNodeContainer = displayEl;

            return { containerEl: containerEl, displayEl: displayEl, clipBoxEl: clipBoxEl };
        }
    }, {
        key: '__initializeSingleClipController',
        value: function __initializeSingleClipController(inputClip, index) {
            var _this3 = this;

            var clip = _lodash2.default.cloneDeep(inputClip);
            var clipController = this.allClipControllers[index];

            var clipWidth = -1;
            var clipHeight = -1;
            var extraParams = {};
            if (clip.clipType === 'video') {
                var _clip$clipVideo = clip.clipVideo,
                    dashUrl = _clip$clipVideo.dashUrl,
                    width = _clip$clipVideo.width,
                    height = _clip$clipVideo.height,
                    _clip$clipVideo$canPl = _clip$clipVideo.canPlay,
                    canPlay = _clip$clipVideo$canPl === undefined ? true : _clip$clipVideo$canPl,
                    _clip$clipVideo$isOff = _clip$clipVideo.isOffline,
                    isOffline = _clip$clipVideo$isOff === undefined ? false : _clip$clipVideo$isOff,
                    _clip$clipVideo$isUse = _clip$clipVideo.isUserSpace,
                    isUserSpace = _clip$clipVideo$isUse === undefined ? false : _clip$clipVideo$isUse,
                    _clip$clipVideo$userS = _clip$clipVideo.userSpaceUrl,
                    userSpaceUrl = _clip$clipVideo$userS === undefined ? '' : _clip$clipVideo$userS,
                    _clip$clipVideo$delet = _clip$clipVideo.deleted,
                    deleted = _clip$clipVideo$delet === undefined ? false : _clip$clipVideo$delet,
                    _clip$clipVideo$origi = _clip$clipVideo.originalFileName,
                    originalFileName = _clip$clipVideo$origi === undefined ? '' : _clip$clipVideo$origi,
                    _clip$clipVideo$snaps = _clip$clipVideo.snapshotUrl,
                    snapshotUrl = _clip$clipVideo$snaps === undefined ? '' : _clip$clipVideo$snaps;
                var _clip$speed = clip.speed,
                    speed = _clip$speed === undefined ? 1 : _clip$speed,
                    clipVolume = clip.clipVolume,
                    musicVolume = clip.musicVolume;

                clipWidth = width;
                clipHeight = height;

                extraParams = {
                    clipStart: clip.clipStart,
                    clipDuration: clip.clipDuration,
                    time: clip.time,
                    transitions: JSON.parse(JSON.stringify(clip.transitions || {})),
                    clipDashUrl: dashUrl,
                    clipVolume: clipVolume,
                    musicVolume: musicVolume,
                    speed: speed,

                    canPlay: canPlay,
                    isOffline: isOffline,
                    isUserSpace: isUserSpace,
                    userSpaceUrl: userSpaceUrl,
                    deleted: deleted,
                    originalFileName: originalFileName,
                    snapshotUrl: snapshotUrl
                };
            } else if (clip.clipType === 'image') {
                var _clip$clipImage = clip.clipImage,
                    previewUrl = _clip$clipImage.previewUrl,
                    fullPngUrl = _clip$clipImage.fullPngUrl,
                    _width = _clip$clipImage.width,
                    _height = _clip$clipImage.height,
                    _clip$clipImage$canPl = _clip$clipImage.canPlay,
                    _canPlay = _clip$clipImage$canPl === undefined ? true : _clip$clipImage$canPl,
                    _clip$clipImage$isOff = _clip$clipImage.isOffline,
                    _isOffline = _clip$clipImage$isOff === undefined ? false : _clip$clipImage$isOff,
                    _clip$clipImage$isUse = _clip$clipImage.isUserSpace,
                    _isUserSpace = _clip$clipImage$isUse === undefined ? false : _clip$clipImage$isUse,
                    _clip$clipImage$userS = _clip$clipImage.userSpaceUrl,
                    _userSpaceUrl = _clip$clipImage$userS === undefined ? '' : _clip$clipImage$userS,
                    _clip$clipImage$delet = _clip$clipImage.deleted,
                    _deleted = _clip$clipImage$delet === undefined ? false : _clip$clipImage$delet,
                    _clip$clipImage$origi = _clip$clipImage.originalFileName,
                    _originalFileName = _clip$clipImage$origi === undefined ? '' : _clip$clipImage$origi,
                    _clip$clipImage$snaps = _clip$clipImage.snapshotUrl,
                    _snapshotUrl = _clip$clipImage$snaps === undefined ? '' : _clip$clipImage$snaps;

                var clipAnimType = clip.clipAnimType,
                    _musicVolume = clip.musicVolume;

                clipWidth = _width;
                clipHeight = _height;

                extraParams = {
                    clipDuration: clip.clipDuration,
                    time: clip.time,
                    transitions: JSON.parse(JSON.stringify(clip.transitions || {})),
                    clipPreviewUrl: window.RENDER_MODE ? fullPngUrl : previewUrl,
                    clipAnimType: clipAnimType,
                    musicVolume: _musicVolume,
                    bgColor: clip.solidImageColor ? clip.solidImageColor : undefined,

                    canPlay: _canPlay,
                    isOffline: _isOffline,
                    isUserSpace: _isUserSpace,
                    userSpaceUrl: _userSpaceUrl,
                    deleted: _deleted,
                    originalFileName: _originalFileName,
                    snapshotUrl: _snapshotUrl
                };
            } else if (clip.clipType === 'composite') {
                throw new Error('Composite clip cannot contain composite clip , should be flattened ');
            } else {
                throw new Error('Unknown clip type: ' + clip.clipType + ' ');
            }

            clipController.createDisplayElement(clip.clipId);

            if (clip.hidePadding) {
                clipController.getContainerEl().css('zIndex', 9999);
            }
            // will require its own parent
            this._videoNodeContainer.append(clipController.getContainerEl());

            clipController.attach(clip, this.canvas, clip.clipType, clip.clipId, clipWidth, clipHeight, extraParams);
            // the below ensures all wait mode for child clips are bubbled up to the parent
            clipController.attachUpdateWaitModeCallback(function () {
                return _this3._receiveChildWaitMode.apply(_this3, arguments);
            });

            // FIX MAY BE , MAY NOT BE -> No More Events bubbling UP , Playback state need not bubble up
            // clipController.addPlaybackStateListener(() => this._receivePlayBackStateChange(clip.clipId))

            this._clipControllers[clip.clipId] = clipController;
        }

        /**
         * Triggers the wait mode event for the Composite controller based of on child controller state
         * avoids the Playback.finish or other such ending events since it would mean playback finished
         *
         * @param {*} childWaitMode
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_receiveChildWaitMode',
        value: function _receiveChildWaitMode(childWaitMode) {
            this._updateWaitMode(childWaitMode); // fires the wait mode listeners
        }
    }, {
        key: '_receivePlayBackStateChange',
        value: function _receivePlayBackStateChange(clipId) {
            var clipController = this._clipControllers[clipId];

            if (clipController.clipId == clipId) {
                // Ignore ENDED events. 'ENDED' events of clips aren't used to determine reelplayer's playback status
                // Ignore pause as well since , child clips can only trigger wait modes which in turn will pause them. But they
                // cannot pause stuff around. Also the pause was for some reason stoping video playback unnecesarily
                if (clipController.playbackState !== _PlaybackState2.default.ENDED) {
                    this._updatePlaybackState(clipController.playbackState);
                }
            }
        }

        // no need to override , now receiveChlilWaitMode will filter the events and fire off to parennts
        // addWaitModeListener(callback) {

        //     // trickle the listener down to its children
        //     // this.allClipControllers.forEach(clipController => {
        //     //     clipController.addWaitModeListener(callback)
        //     // })
        //     // this._emitter.on(EV_WAIT_MODE_CHANGE, callback);
        // }

        // addPlaybackStateListener(callback){
        //     this.allClipControllers.forEach(clipController => {

        //         // TO-DO
        //         // this play back state should not be propagted here , the blackstate listener should be propagated only by the
        //         // sequence needs to be handled
        //         clipController.addPlaybackStateListener(callback)
        //     })
        // }

        /**
         * _onAttach will be handling multi clip instantiation and not single clip
         *
         * @param {*} { clipStart, clipDuration, time, transitions, clipDashUrl, speed = 1, clipVolume, musicVolume }
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onAttach',
        value: function _onAttach(_ref3) {
            var _this4 = this;

            var clipStart = _ref3.clipStart,
                clipDuration = _ref3.clipDuration,
                time = _ref3.time,
                transitions = _ref3.transitions,
                _ref3$speed = _ref3.speed,
                speed = _ref3$speed === undefined ? 1 : _ref3$speed,
                clipVolume = _ref3.clipVolume,
                musicVolume = _ref3.musicVolume;

            if (!this.clip.childClips || this.clip.childClips.length == 0) {
                throw new Error('empty child clips for composide: ' + this.clip.clipId);
            }

            this.defaultChildClips = clone(this.clip.childClips); // holds the original time information for all child clips

            // time adjusted for the child clips for the main timeline
            this.clip.childClips = (0, _ReelHelpers.adjustClipList2Time)(this.defaultChildClips, { time: time, transitions: transitions });

            this.clip.childClips.forEach(function (cclip, index) {
                return _this4.__initializeSingleClipController(cclip, index);
            });

            this.clipStart = clipStart;
            this.clipDuration = clipDuration;

            this.time = time;
            this.transitions = transitions;
            this._speed = speed;
            this.clipVolume = clipVolume;
            this.musicVolume = musicVolume;

            this._currentClipIds = [];

            this.seekTo = clipStart;

            this._disableClipChangeCallback = false; // not used yet , but used to disable currentClip change
            // so that unwanted seek or modifying action does not triggers clip change and gets to inconsistent state

            this._onSetSpeed(this._speed);
            this._updateTransitionTimeline();
            this._updateAllLabelsAndCallbacks();
            this._changeCurrentClips(0);
        }
    }, {
        key: '_onKill',
        value: function _onKill() {
            this.allClipControllers.forEach(function (cc) {
                cc.kill();
            });

            this._transitionTimeline.kill();
            this._transitionTimeline = null;

            this.clipStart = 0;
            this.clipDuration = 0;
            this.transitions = {};
            this.time = {};
        }

        // unsupported

    }, {
        key: '_onStartCropping',
        value: function _onStartCropping() {}

        // unsupported

    }, {
        key: '_onEndCropping',
        value: function _onEndCropping() {}

        /**
         * Overrides all the volume of the child clips
         *
         * @param {*} newVolume
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onSetVolume',
        value: function _onSetVolume() {
            var _this5 = this;

            // Global Volume no more supported  --

            this.allClipControllers.forEach(function (cc, index) {
                var clip = _this5.clip.childClips[index];
                cc.doSetVolume(clip.clipVolume);
            });
        }
    }, {
        key: '_adjustClipsAfterTime',
        value: function _adjustClipsAfterTime(time, adjustmentOffset) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.values(this.allClipControllers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var cc = _step.value;

                    if (cc.enterStartWithTransition() >= time) {
                        var newTime = {
                            enterStart: cc.enterStart() + adjustmentOffset,
                            enterDone: cc.enterDone() + adjustmentOffset,
                            exitStart: cc.exitStart() + adjustmentOffset,
                            exitDone: cc.exitDone() + adjustmentOffset
                        };
                        cc.doChangeClipBounds({ time: newTime });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * - Only Supports Clip Speed change
         * - time and others can be added without any issues
         *
         * @param {*} clip
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_doUpdateClipTimeData',
        value: function _doUpdateClipTimeData(clip) {
            var oldDuration = this.clip.clipDuration;
            this.clipDuration = clip.clipDuration;
            this.time = clip.time;
            this._speed = clip.speed;

            this.clip.childClips = (0, _ReelHelpers.adjustClipList2Time)(clip.childClips, {
                time: clip.time,
                transitions: clip.transitions
            });

            this.allClipControllers.forEach(function (clipController, index) {
                var childClip = clip.childClips[index];
                clipController.doSetSpeed(childClip.speed);
                clipController.doChangeClipBounds({ time: childClip.time });
            });

            this._onUpdateClip(clip);

            this._updateTransitionTimeline();
            this._updateAllLabelsAndCallbacks();
            return this.clipDuration - oldDuration;
        }

        /**
         *
         *
         * @param {*} newSpeed
         * @return {*}
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onSetSpeed',
        value: function _onSetSpeed(newSpeed) {
            return 0;
            // this._disableClipChangeCallback = true

            // this.allClipControllers.forEach(v => v.doSetSpeed(newSpeed))

            // const currentClipDuration = this.clipDuration / this._speed

            // this._speed = newSpeed

            // const newClipDuration = this.clipDuration / newSpeed

            // const newTime = clone(this.time)

            // newTime.exitStart = this.time.enterStart + newClipDuration
            // newTime.exitDone = this.time.enterStart + newClipDuration

            // this.time = newTime
            // this.clipDuration = newClipDuration

            // this.clip.time = newTime
            // this.clip.clipDuration = newClipDuration

            // if(newSpeed !== 1){
            //     //Mute audio if speed is changed
            //     this._onSetVolume(0)
            // }

            // this._disableClipChangeCallback = false

            // return newClipDuration - currentClipDuration // changeInDuration
        }
    }, {
        key: '_onRemoveTransition',
        value: function _onRemoveTransition(kind) {
            if (kind == 'all') {
                this.transitions = {};
                this.clip.transitions = {};
                delete this.clip.childClips[0].transitions.enter;
                delete this.clip.childClips[this.clip.childClips.length - 1].transitions.exit;
                this.allClipControllers[0].removeTransitions('enter');
                this.allClipControllers[this.allClipControllers.length - 1].removeTransitions('exit');
            } else {
                delete this.transitions[kind];
                delete this.clip.transitions[kind];
                if (kind === 'enter') {
                    delete this.clip.childClips[0].transitions.enter;
                    this.allClipControllers[0].removeTransitions('enter');
                } else if (kind === 'exit') {
                    delete this.clip.childClips[this.clip.childClips.length - 1].transitions.exit;
                    this.allClipControllers[this.allClipControllers.length - 1].removeTransitions('exit');
                }
            }
            this._updateTransitionTimeline();
            // because a clear is triggered at this point
            // this._updateAllLabelsAndCallbacks()
        }
    }, {
        key: '_onUpdateClip',
        value: function _onUpdateClip(newClip) {
            var _this6 = this;

            this.clipVolume = newClip.clipVolume;
            this.musicVolume = newClip.musicVolume;
            this.time = newClip.time;
            this.transitions = newClip.transitions;

            this.clip.childClips = newClip.childClips;

            this.allClipControllers.forEach(function (cc, index) {
                cc.doUpdateClip(_this6.clip.childClips[index]);
                cc.doSetVolume(_this6.clip.childClips[index].clipVolume);
                cc.doSetAnimType(_this6.clip.childClips[index].clipAnimType);
            });

            this._updatePlayerDimensions();

            this._updateAllLabelsAndCallbacks();
        }
    }, {
        key: '_getSpeed',
        value: function _getSpeed() {
            return this._speed;
        }
    }, {
        key: '_onSetAnimType',
        value: function _onSetAnimType() /* newAnimType */{
            //
        }
    }, {
        key: '_onSetTransitionType',
        value: function _onSetTransitionType(kind, transition) {
            this.clip.transitions[kind] = transition;
            this.transitions[kind] = transition;

            if (kind === 'enter') {
                this.clip.childClips[0].transitions.enter = transition;
                var controller = this.allClipControllers[0];
                controller.doSetTransitionType('enter', transition);
            } else if (kind === 'exit') {
                this.clip.childClips[this.clip.childClips.length - 1].transitions.exit = transition;
                var _controller = this.allClipControllers[this.allClipControllers.length - 1];
                _controller.doSetTransitionType('exit', transition);
            }

            this._updateTransitionTimeline();
            // because the entire time line is cleared with this one action
            this._updateAllLabelsAndCallbacks();
        }
    }, {
        key: '_updateTimelines',
        value: function _updateTimelines() {
            this._updateTransitionTimeline();
            this._updateAllLabelsAndCallbacks();
        }
    }, {
        key: '_changeCurrentClips',
        value: function _changeCurrentClips(time) {
            var _this7 = this;

            // TODO safety check
            // if (time < 0 || time > this.totalDuration()) {
            // console.warn('Attempted to change tim switch to %d from %d when no: of players is %d',
            //     index, this._currentClipIndex, Object.values(this._clipControllers).length);
            // return;
            var _clipControllersOnTim = this._clipControllersOnTime(time),
                _clipControllersOnTim2 = _slicedToArray(_clipControllersOnTim, 1),
                currentPlayingControllers = _clipControllersOnTim2[0];

            var newClipIds = currentPlayingControllers.map(function (cc) {
                return cc.clip.clipId;
            });
            if (_lodash2.default.isEqual(this._currentClipIds, newClipIds)) {
                // Do nothing
                return;
            }
            // Hide currently playing clip controllers
            // this._currentClipIds.map(id => this._clipControllers[id]).map(ccc => ccc.doPause());

            this._currentClipIds.map(function (id) {
                return _this7._clipControllers[id];
            }).forEach(function (cc) {
                return cc.doHide();
            });

            if (this.visible) currentPlayingControllers.forEach(function (ccc) {
                return ccc.doShow();
            });

            this._currentClipIds = newClipIds;

            /// TO - DO --> Volume fix if necessary , since volume is kept to one master volume of the clip itself and the original set volume
        }
    }, {
        key: '_splitClipChangeLabel',
        value: function _splitClipChangeLabel(label) {
            return label.split('::::');
        }

        /**
         * Useful for playback , triggered when Child clip reaches the border zone
         *
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onClipBorder',
        value: function _onClipBorder(label) {
            var _this8 = this;

            if (!this._disableClipChangeCallback) {
                var _splitClipChangeLabel2 = this._splitClipChangeLabel(label),
                    _splitClipChangeLabel3 = _slicedToArray(_splitClipChangeLabel2, 2),
                    action = _splitClipChangeLabel3[0],
                    clipId = _splitClipChangeLabel3[1];

                var oldPlaybackState = this.playbackState;
                // this._updatePlaybackState(PlaybackState.PAUSED);

                var oldClipIds = this._currentClipIds;
                // start the current clip
                if (action == 'child-clipStart') {
                    if (!oldClipIds.includes(clipId)) {
                        var clipController = this._clipControllers[clipId];
                        this._changeCurrentClips(this._getPlayerTime());
                        var newClipIds = this._currentClipIds;
                        if (oldPlaybackState === _PlaybackState2.default.PLAYING) {
                            clipController.doPlay();
                        } else if (clipController) {
                            clipController.doPause();
                        }
                        oldClipIds.filter(function (cId) {
                            return !newClipIds.includes(cId);
                        }).forEach(function (cId) {
                            // console.log('pausing old clip ',cId)
                            var clipController = _this8._clipControllers[cId];
                            if (clipController) {
                                // clipController.doSeek(0);
                                var st = setTimeout(function () {
                                    clipController.doSeek(0);
                                    clearTimeout(st);
                                }, 100);
                                clipController.doPause();
                            }
                        });
                    }
                } else if (oldClipIds.includes(clipId)) {
                    // this._currentClipIds.push(clipId)
                    // console.log('ending old clip ',clipId)
                    var _clipController = this._clipControllers[clipId];
                    this._changeCurrentClips(this._getPlayerTime());
                    if (_clipController) {
                        // clipController.doSeek(0);
                        setTimeout(function () {
                            if (_clipController) _clipController.doSeek(0);
                        }, 100);
                        _clipController.doPause();
                    }
                }

                this._updatePlaybackState(oldPlaybackState);
            }
        }

        /**
         * Private method to be overriden
         *
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onComplete',
        value: function _onComplete() {
            // stop playback of child clips and seek them to 0
            this.allClipControllers.forEach(function (cc) {
                cc.doPause();
                cc.doSeek(0);
            });
            this._updatePlaybackState(_PlaybackState2.default.ENDED);
        }
    }, {
        key: '_updateAllLabelsAndCallbacks',
        value: function _updateAllLabelsAndCallbacks() {
            // this._updateClipTimes()
            // updates all clip times but wont be needed in our case
            // as clip update does the job of updating clip times

            // this._fireDurationChange()
            // not needed because durations here never change

            // remove all the labels for playback control
            if (this._timeline === null) return;

            var labels = this._timeline.getLabelsArray();
            for (var i = 0; i < labels.length; i++) {
                var labelName = labels[i].name;

                this._timeline.removeCallback(this._onClipBorder, labelName);
                this._timeline.removeLabel(labelName);
            }

            var clipsIds = Object.keys(this._clipControllers);
            var len = clipsIds.length;
            for (var _i = 0; _i < len; _i++) {
                var clipId = clipsIds[_i];
                var controller = this._clipControllers[clipId];

                var startLabel = 'child-clipStart::::' + clipId;
                var endLabel = 'child-clipEnd::::' + clipId;

                // Get adjustment offset for all clips
                this._timeline.addLabel(endLabel, (0, _TimeUtils._toGSAPtime)(controller.exitDoneWithTransition()));
                this._timeline.addCallback(this._onClipBorder, endLabel, [endLabel], this);

                this._timeline.addLabel(startLabel, (0, _TimeUtils._toGSAPtime)(Math.max(0, controller.enterStartWithTransition() - 1)));
                // all time relative to the current clip timeline i.e for first clip the timeline time label start will be 0
                this._timeline.addCallback(this._onClipBorder, startLabel, [startLabel], this);
            }
            // Add labels to boundaries between clips
        }
    }, {
        key: '_onPlayerPlay',
        value: function _onPlayerPlay() {
            dlog('playing composite-clip', this.clipId);

            var _clipControllersOnTim3 = this._clipControllersOnTime(this._getPlayerTime()),
                _clipControllersOnTim4 = _slicedToArray(_clipControllersOnTim3, 2),
                controllers = _clipControllersOnTim4[0],
                li = _clipControllersOnTim4[1];

            controllers.forEach(function (cc) {
                return cc.doPlay();
            });
            for (var i = li + 1; i < this.allClipControllers.length; i++) {
                this.allClipControllers[i].doSeek(0);
            }

            dlog('playing composite-clip result', this.clipId, 'time :', this._timeline.time());
        }
    }, {
        key: '_onPlayerPause',
        value: function _onPlayerPause() {
            dlog('pausing composite-clip', this.clipId);
            // this.allClipControllers.forEach((cc) => {
            //     cc.doPause()
            // })

            var _clipControllersOnTim5 = this._clipControllersOnTime(this._getPlayerTime()),
                _clipControllersOnTim6 = _slicedToArray(_clipControllersOnTim5, 2),
                controllers = _clipControllersOnTim6[0],
                li = _clipControllersOnTim6[1];
            // controllers.forEach(cc => cc.doPause())


            for (var i = 0; i < controllers.length; i++) {
                controllers[i].doPause();
            }

            for (var _i2 = li + 1; _i2 < this.allClipControllers.length; _i2++) {
                this.allClipControllers[_i2].doSeek(0);
            }
            dlog('pausing composite-clip result', this.clipId);
        }
    }, {
        key: '_onSeekToBeginning',
        value: function _onSeekToBeginning() {
            dlog('seeking composite to beginning', this.clipId);
            // seek to beggining for all the clips -> keeps the frame ready
            this.allClipControllers.forEach(function (cc) {
                return cc._onSeekToBeginning();
            });
            // this._player.seek(_toGSAPtime(this.clipStart))
            // this._transitionTimeline.seek(_toGSAPtime(0))
            // this._forceRender()
        }
    }, {
        key: '_clipControllersOnTime',
        value: function _clipControllersOnTime(time) {
            time = (0, _CommonAlgorithms.clamp)(time, this.duration(), 0);

            // console.log(this.allClipControllers)
            // new mthod returns a range of items in the time frame , faster binary search

            var _allClipControllers$f = this.allClipControllers.findItemsFromSorted(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    first = _ref5[0],
                    last = _ref5[1];

                return first.enterStartWithTransition() <= time && last.exitDoneWithTransition() > time;
            }),
                _allClipControllers$f2 = _slicedToArray(_allClipControllers$f, 2),
                ccs = _allClipControllers$f2[0],
                index = _allClipControllers$f2[1];

            // const ccs = this.allClipControllers.filter((cc , index) =>{
            //     const cond = cc.enterStartWithTransition() <= time && cc.exitDoneWithTransition() > time
            //     if(cond)
            //         lastIndex = index
            //     return cond
            // })


            return [[ccs[0]], index[0]];
        }

        /**
         * time provided relative to the current Composite clip
         *
         * @param {*} time
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onSeekPlayerToTime',
        value: function _onSeekPlayerToTime(time) {
            this._disableClipChangeCallback = true;
            dlog('seeking composite-clip', this.clipId, time);

            // this.doPause()

            var _clipControllersOnTim7 = this._clipControllersOnTime(time),
                _clipControllersOnTim8 = _slicedToArray(_clipControllersOnTim7, 2),
                controllers = _clipControllersOnTim8[0],
                li = _clipControllersOnTim8[1];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {

                for (var _iterator2 = controllers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var cc = _step2.value;

                    var newTime = Math.max(time - cc.enterStartWithTransition(), 0);
                    cc.doSeek(newTime);
                }

                // // seek all other items after the paused item to 0 , pre cache the frame
                // for(let i = li+1 ; i < this.allClipControllers.length; i++){
                //     this.allClipControllers[i].doSeek(0)
                // }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this._changeCurrentClips(time);

            // this._player.seek((_toGSAPtime(time * this._getSpeed() + this.clipStart)))
            // this._transitionTimeline.seek(_toGSAPtime(time))
            // this._forceRender()

            dlog('seeked composite-clip current clips: ', controllers.map(function (cc) {
                return cc.clipId;
            }), ' child-clips afterwards ');
            this._disableClipChangeCallback = false;
        }

        // _forceRender() {
        //     this._transitionTimeline.render(this._transitionTimeline.time(), false, true)
        // }

    }, {
        key: '_enterStart',
        value: function _enterStart() {
            return this.time.enterStart;
        }
    }, {
        key: '_enterDone',
        value: function _enterDone() {
            return this.time.enterDone;
        }
    }, {
        key: '_exitStart',
        value: function _exitStart() {
            return this.time.exitStart;
        }
    }, {
        key: '_exitDone',
        value: function _exitDone() {
            return this.time.exitDone;
        }
    }, {
        key: '_enterStartWithTransition',
        value: function _enterStartWithTransition() {
            var _time = this.time,
                enterStart = _time.enterStart,
                _time$currentOffset = _time.currentOffset,
                currentOffset = _time$currentOffset === undefined ? 0 : _time$currentOffset,
                _time$prevOffset = _time.prevOffset,
                prevOffset = _time$prevOffset === undefined ? 0 : _time$prevOffset;

            return enterStart + currentOffset + prevOffset;
        }
    }, {
        key: '_exitDoneWithTransition',
        value: function _exitDoneWithTransition() {
            var _time2 = this.time,
                exitDone = _time2.exitDone,
                _time2$currentOffset = _time2.currentOffset,
                currentOffset = _time2$currentOffset === undefined ? 0 : _time2$currentOffset,
                _time2$prevOffset = _time2.prevOffset,
                prevOffset = _time2$prevOffset === undefined ? 0 : _time2$prevOffset;

            return exitDone + currentOffset + prevOffset;
        }
    }, {
        key: '_updateChildControllersTime',
        value: function _updateChildControllersTime() {
            var _this9 = this;

            // time adjusted for the child clips for the main timeline
            this.clip.childClips.forEach(function (clip, index) {
                _this9.allClipControllers[index]._onUpdateClip(clip);
            });
            this._updateAllLabelsAndCallbacks();
        }

        /**
         * Used to handle changing clip time and transition data
         *
         * @param {*} {
         *                     // clipStart : newClipStart = this.clipStart,
         *                     // clipDuration : newClipDuration =  this.clipDuration,
         *                     time : newTime, transitions: newTransitions }
         * @return {*}
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_onChangeClip',
        value: function _onChangeClip(_ref6) {
            var newTime = _ref6.time,
                newTransitions = _ref6.transitions;

            // TODO Set transition in/out here
            // const oldTime = this.timelineTime();
            // const oldTimeFromVideoStart = oldTime + this.clipStart;

            // this._player.seek(_toGSAPtime(newTimeFromVideoStart));
            // this._transitionTimeline.seek(_toGSAPtime(newTimeFromVideoStart));

            this.time = _extends({}, this.time, newTime);

            this.clip.time = _extends({}, this.clip.time, newTime);

            if (newTransitions) {
                this.transitions = newTransitions;
                this.clip.transitions = newTransitions;
            }

            // updated child clip transitions as well
            this._updateTransitionTimeline();

            return 0;
        }
    }, {
        key: '_getDuration',
        value: function _getDuration() {
            // return this.clipDuration / this._getSpeed()
            return this._exitDoneWithTransition() - this._enterStartWithTransition();
        }
    }, {
        key: '_getPlayerTime',
        value: function _getPlayerTime() {
            // const playerTime = _fromGSAPtime(this._player.time())

            // return Math.max(0, playerTime - this.clipStart) / this._getSpeed()
            return (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
        }

        /**
         * For composite clip , there will be no change in transition
         * any adjustment so sequried will be exclusive for its child components relative to their own
         * GSAP timelines
         * @memberof SingleCompositeClipController
         */

    }, {
        key: '_updateTransitionTimeline',
        value: function _updateTransitionTimeline() {
            // register the effect of the composite clip to the first and last element
            var hasEnterTransition = this.transitions.hasOwnProperty('enter');
            var hasExitTransition = this.transitions.hasOwnProperty('exit');

            if (hasEnterTransition) {
                var _transitions$enter = this.transitions.enter,
                    _transitions$enter$tr = _transitions$enter.transitionAnimation,
                    enterTransitionType = _transitions$enter$tr === undefined ? 'NONE' : _transitions$enter$tr,
                    _transitions$enter$du = _transitions$enter.duration,
                    enterDuration = _transitions$enter$du === undefined ? 0 : _transitions$enter$du;

                if (enterDuration > 0) {
                    // this._setTransition(enterTransitionType, enterDuration, 0) // sets up the transition for first clip
                    // set up the transition for first clip
                    var clipController = this.allClipControllers[0];

                    // The callee for _updateTransitionTimeline will set up the time for the child controllers
                    //
                    clipController.doSetTransitionType('enter', this.transitions.enter);
                    clipController._updateTransitionTimeline();
                }
            }

            if (hasExitTransition) {
                var _transitions$exit = this.transitions.exit,
                    _transitions$exit$tra = _transitions$exit.transitionAnimation,
                    exitTransitionType = _transitions$exit$tra === undefined ? 'NONE' : _transitions$exit$tra,
                    _transitions$exit$pos = _transitions$exit.position,
                    position = _transitions$exit$pos === undefined ? 0 : _transitions$exit$pos,
                    _transitions$exit$dur = _transitions$exit.duration,
                    exitDuration = _transitions$exit$dur === undefined ? 0 : _transitions$exit$dur;

                var exitTransitionStartTime = this._getDuration() - exitDuration; // timing will only work if childClip is adjusted to the real timeline time

                if (exitDuration > 0) {
                    // this._setTransition(exitTransitionType, exitDuration, exitTransitionStartTime) // sets up the transition for the last clip
                    var _clipController2 = this.allClipControllers[this.allClipControllers.length - 1];
                    // clipController._setTransition(exitTransitionType , exitDuration , exitTransitionStartTime)
                    _clipController2.doSetTransitionType('exit', this.transitions.exit);
                    _clipController2._updateTransitionTimeline();
                }
            }
        }

        // unsuded for now as _setTransition for composite is not a a defined operation

    }, {
        key: '_setTransition',
        value: function _setTransition(transitionType, transitionDuration, transitionStart) {
            var vars = { opacity: 1 };
            var startVars = clone(vars);
            var endVars = clone(vars);
            var ease = Linear.easeNone;

            if (transitionType === 'FADE_IN') {
                startVars.opacity = 0;
            } else if (transitionType === 'FADE_OUT') {
                endVars.opacity = 0;
            } else if (transitionType === 'FROM_BOTTOM') {
                startVars.top = '100%';
                endVars.top = '0%';
            } else if (transitionType === 'FROM_RIGHT') {
                startVars.left = '100%';
                endVars.left = '0%';
            } else if (transitionType === 'TO_TOP') {
                endVars.top = '-100%';
            } else if (transitionType === 'TO_LEFT') {
                endVars.left = '-100%';
            }

            // this._transitionTimeline.fromTo(this.displayEl, _toGSAPtime(transitionDuration), { css : startVars }, { css : endVars, ease: ease }, _toGSAPtime(transitionStart))

            // const clipPathStr = this._getClipPathString();
            // this._transitionTimeline.set(this.displayEl, { css : { 'clipPath': clipPathStr } }, _toGSAPtime(transitionStart))
            // this._transitionTimeline.set(this.displayEl, { css : { 'clipPath': 'none' } }, _toGSAPtime(transitionStart + transitionDuration))
        }

        // _getClipPathString() {
        //     const ZOOM_FACTOR = 0.85;
        //     const clipBox = this.clip.clipBox;
        //     const canvas = this.canvas;

        //     const clipPath = {
        //         top: (Math.abs(clipBox.y) / clipBox.height) * 100 * ZOOM_FACTOR,
        //         right: ((clipBox.width - canvas.width - Math.abs(clipBox.x)) / clipBox.width) * 100 * ZOOM_FACTOR,
        //         bottom: ((clipBox.height - canvas.height - Math.abs(clipBox.y)) / clipBox.height) * 100 * ZOOM_FACTOR,
        //         left: (Math.abs(clipBox.x) / clipBox.width) * 100 * ZOOM_FACTOR
        //     };

        //     return `inset(${clipPath.top}% ${clipPath.right}% ${clipPath.bottom}% ${clipPath.left}%)`;
        // }

        // NOT APPLICABLE TILL NOW
        // _onSeeking() {
        //     dlog('_onSeeking', this.clipId, 'current wait mode', this.waitMode);
        //     if (this.waitMode !== WaitMode.BUFFERING) {
        //         dlog('_onSeeking updating to seeking', this.clipId, 'current wait mode', this.waitMode);
        //         this._updateWaitMode(WaitMode.SEEKING)
        //     }
        // }
        // _onSeeked() {
        //     dlog('_onSeeked', this.clipId, 'current wait mode', this.waitMode);
        //     if (this.waitMode === WaitMode.LOADING || this.waitMode === WaitMode.SEEKING) {
        //         dlog('_onSeeked updating to none', this.clipId, 'current wait mode', this.waitMode);
        //         this._updateWaitMode(WaitMode.NONE)
        //     }
        // }
        // _onBufferEmpty() {
        //     dlog('_onBufferEmpty', this.clipId, 'current wait mode', this.waitMode);
        //     this._updateWaitMode(WaitMode.BUFFERING)
        // }
        // _onBufferLoaded() {
        //     dlog('_onBufferLoaded', this.clipId, 'current wait mode', this.waitMode);
        //     if (this.waitMode === WaitMode.BUFFERING) {
        //         dlog('_onBufferLoaded updating to none', this.clipId, 'current wait mode', this.waitMode);
        //         this._updateWaitMode(WaitMode.NONE)
        //     }
        //     if(!!this.seekTo){
        //         this._player.seek(_toGSAPtime(this.seekTo))
        //         this.seekTo = null
        //     }
        // }
        // _onCanPlay() {
        //     dlog('_onCanPlay', this.clipId, 'current wait mode', this.waitMode);
        //     if (this.waitMode === WaitMode.LOADING || this.waitMode === WaitMode.SEEKING) {
        //         dlog('_onCanPlay updating to none', this.clipId, 'current wait mode', this.waitMode);
        //         this._updateWaitMode(WaitMode.NONE)
        //     }
        // }

    }, {
        key: '_onPlaybackRateChanged',
        value: function _onPlaybackRateChanged() {
            this._onSetSpeed(this._speed);
        }

        // update composite timeline , update prevoffset and current offset for all the child clip as well
        // childoffset no other timing information should be updatable
        // composite clips are immutable in for their timing info

    }, {
        key: '_onUpdateTime',
        value: function _onUpdateTime(newTime) {
            var currentOffset = newTime.currentOffset,
                prevOffset = newTime.prevOffset;

            this.time = _extends({}, this.time, { currentOffset: currentOffset, prevOffset: prevOffset });
            this.clip.time = _extends({}, this.clip.time, { currentOffset: currentOffset, prevOffset: prevOffset });
        }

        // takes care of updating the core player wait mode for all children

    }, {
        key: '_handleCorePlayerWaitMode',
        value: function _handleCorePlayerWaitMode(corePlayerWaitMode) {
            this.allClipControllers.forEach(function (cc) {
                cc.updateCorePlayerWaitMode(corePlayerWaitMode);
            });
        }
    }, {
        key: '_handleUpdateWaitMode',
        value: function _handleUpdateWaitMode() {}
    }, {
        key: '_doShow',
        value: function _doShow() {
            this.containerEl.css('transform', 'scale(1,1)');
            var time = this._getPlayerTime();

            var _clipControllersOnTim9 = this._clipControllersOnTime(time),
                _clipControllersOnTim10 = _slicedToArray(_clipControllersOnTim9, 1),
                cc = _clipControllersOnTim10[0];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = cc[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var c = _step3.value;

                    c.doShow();
                }
                // show the clips that are currently under the time
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: '_doHide',
        value: function _doHide() {
            this.containerEl.css('transform', 'scale(0)');
            this.allClipControllers.forEach(function (cc) {
                return cc.doHide();
            });
        }
    }]);

    return SingleCompositeClipController;
}(_BaseSingleClipController2.default);

exports.default = SingleCompositeClipController;

},{"./BaseSingleClipController":70,"./CommonAlgorithms":72,"./GeneralUtils":77,"./ReelHelpers":85,"./TimeUtils":89,"./enums/PlaybackState":96,"./enums/WaitMode":100,"./players/DashJSPlayer":112,"./players/PlayerEvents":113,"cloneextend":412,"lodash":860}],87:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _WaitMode = require('./enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _PlaybackState = require('./enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _TimeUtils = require('./TimeUtils');

var _BaseSingleClipController = require('./BaseSingleClipController');

var _BaseSingleClipController2 = _interopRequireDefault(_BaseSingleClipController);

var _PlayerRegistry = require('./players/PlayerRegistry');

var _PlayerRegistry2 = _interopRequireDefault(_PlayerRegistry);

var _DisplayGridHelpers = require('./DisplayGridHelpers');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _require = require('cloneextend'),
    clone = _require.clone;

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var SingleImageClipController = function (_BaseSingleClipContro) {
    _inherits(SingleImageClipController, _BaseSingleClipContro);

    function SingleImageClipController() {
        _classCallCheck(this, SingleImageClipController);

        var _this = _possibleConstructorReturn(this, (SingleImageClipController.__proto__ || Object.getPrototypeOf(SingleImageClipController)).call(this));

        _this._getClipPathString = function () {
            var clipBox = _this.clip.clipBox;
            var canvas = _this.canvas;
            // TODO -- memoize using memoize once

            var _analyzeBoxIntersecti = (0, _DisplayGridHelpers.analyzeBoxIntersectionRange)(clipBox, _extends({}, canvas, {
                x: 0,
                y: 0
            })),
                _analyzeBoxIntersecti2 = _slicedToArray(_analyzeBoxIntersecti, 2),
                gridLinesV = _analyzeBoxIntersecti2[0],
                gridLinesH = _analyzeBoxIntersecti2[1];

            var left = gridLinesV[0];
            var right = gridLinesV[2] - gridLinesV[3];
            var top = gridLinesH[0];
            var bottom = gridLinesH[2] - gridLinesH[3];

            var clipPath = 'inset(' + top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px )';

            return clipPath;
        };

        _this._animationTimeline = new TimelineMax({ paused: true });
        _this._transitionTimeline = new TimelineMax({ paused: true });
        return _this;
    }

    _createClass(SingleImageClipController, [{
        key: '_onCreateNode',
        value: function _onCreateNode(id) {
            var containerEl = $('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden');

            // used for rotation
            var rotateEl = $('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'visible');

            // //use for animation and size changes during it
            var posSizeEl = $('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'visible');

            // // used to contain the image.
            var viewerContainer = $('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'visible');

            this._rotateEl = rotateEl;
            this._posSizeEl = posSizeEl;
            this._viewerContainer = viewerContainer;
            this._containerEl = containerEl;

            // top level controller for displaying correct dimension
            var displayEl = $('<div>').css('position', 'absolute').css('width', '0px').css('height', '0px').css('overflow', 'visible').attr('id', 'viewer-' + id);

            rotateEl.append(viewerContainer);
            posSizeEl.append(rotateEl);
            displayEl.append(posSizeEl);
            containerEl.append(displayEl);
            // displayEl.append(posSizeEl) // animate and size
            // posSizeEl.append(rotateEl) // rotate and transform
            // rotateEl.append(viewerContainer) // contain image

            var clipBoxEl = window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden').attr('class', 'clipbox');

            containerEl.append(clipBoxEl);

            return { containerEl: containerEl, displayEl: displayEl, clipBoxEl: clipBoxEl };
        }

        // TODO batch all the changes as single change

    }, {
        key: 'applyTranform',
        value: function applyTranform(_ref) {
            var rotateDeg = _ref.rotateDeg,
                scaleX = _ref.scaleX,
                scaleY = _ref.scaleY;

            this.displayEl.css('webkitTransform', 'scale(' + scaleX + ', ' + scaleY + ')').css('msTransform', 'scale(' + scaleX + ', ' + scaleY + ')').css('transform', 'scale(' + scaleX + ', ' + scaleY + ')');

            this._rotateEl.css('webkitTransform', 'rotate(' + rotateDeg + 'deg)').css('msTransform', 'rotate(' + rotateDeg + 'deg)').css('transform', 'rotate(' + rotateDeg + 'deg)');
        }
    }, {
        key: '_applyBgColor',
        value: function _applyBgColor(bgColor) {
            this._viewerEl.css('background', bgColor);
        }
    }, {
        key: '_onAttach',
        value: function _onAttach(_ref2) {
            var _this2 = this;

            var time = _ref2.time,
                transitions = _ref2.transitions,
                clipPreviewUrl = _ref2.clipPreviewUrl,
                clipAnimType = _ref2.clipAnimType,
                musicVolume = _ref2.musicVolume,
                _ref2$bgColor = _ref2.bgColor,
                bgColor = _ref2$bgColor === undefined ? null : _ref2$bgColor,
                _ref2$canPlay = _ref2.canPlay,
                canPlay = _ref2$canPlay === undefined ? true : _ref2$canPlay,
                _ref2$isOffline = _ref2.isOffline,
                isOffline = _ref2$isOffline === undefined ? false : _ref2$isOffline,
                _ref2$isUserSpace = _ref2.isUserSpace,
                isUserSpace = _ref2$isUserSpace === undefined ? false : _ref2$isUserSpace,
                _ref2$userSpaceUrl = _ref2.userSpaceUrl,
                userSpaceUrl = _ref2$userSpaceUrl === undefined ? '' : _ref2$userSpaceUrl,
                _ref2$deleted = _ref2.deleted,
                deleted = _ref2$deleted === undefined ? false : _ref2$deleted,
                _ref2$originalFileNam = _ref2.originalFileName,
                originalFileName = _ref2$originalFileNam === undefined ? '' : _ref2$originalFileNam;

            this.clipDuration = time.exitDone - time.enterStart;
            this.time = time;
            this.clipPreviewUrl = clipPreviewUrl;
            this.clipAnimType = deleted ? null : clipAnimType;
            this.transitions = transitions;
            this.musicVolume = musicVolume;
            this.clipStart = 0;

            this._viewerEl = $('<img>').css('position', 'absolute').css('left', '0%').css('top', '0%').css('width', '100%').css('height', '100%');

            if (bgColor) {
                this._viewerEl.css('background', bgColor);
            }

            this.mediaState = {
                canPlay: canPlay,
                isOffline: isOffline,
                isUserSpace: isUserSpace,
                userSpaceUrl: userSpaceUrl,
                clipPreviewUrl: clipPreviewUrl
            };

            var _AllSourcePlayerRegis = _PlayerRegistry2.default.identifySource({
                canPlay: canPlay,
                isOffline: isOffline,
                isUserSpace: isUserSpace,
                userSpaceUrl: userSpaceUrl,
                systemSpaceUrl: clipPreviewUrl
            }),
                _AllSourcePlayerRegis2 = _slicedToArray(_AllSourcePlayerRegis, 2),
                url = _AllSourcePlayerRegis2[0],
                useOldPlayer = _AllSourcePlayerRegis2[1];

            if (!deleted) {
                this._viewerEl.get(0).onload = function () {
                    return _this2._onImageLoad();
                };
                this._viewerEl.get(0).onerror = function (err) {
                    return _this2._onImageLoadError(err);
                };
                this._viewerEl.get(0).src = url;
            }

            // rotate element have viewer as child
            this._viewerContainer.append(this._viewerEl);
            // this.displayEl.append(this._viewerEl)

            this._updateTimelines();
        }
    }, {
        key: '_onKill',
        value: function _onKill() {
            this._animationTimeline.kill();
            this._animationTimeline = null;

            this._transitionTimeline.kill();
            this._transitionTimeline = null;

            this.clipDuration = 0;
            this.time = {};
            this.transitions = {};
            this.clipPreviewUrl = null;
        }
    }, {
        key: '_onSetVolume',
        value: function _onSetVolume(newVolume) {
            // [John Oliver says] Hwott are you even tohking about?
            // [Bob Ros says] You can do it but it won't make sense
        }
    }, {
        key: '_onSetSpeed',
        value: function _onSetSpeed(newSpeed) {
            // [John Oliver says] Hwott are you even tohking about?
            return 0;
        }
    }, {
        key: '_onUpdateClip',
        value: function _onUpdateClip(newClip) {
            // Nothing

            var musicVolume = newClip.musicVolume,
                time = newClip.time,
                transitions = newClip.transitions,
                _newClip$clipImage = newClip.clipImage;
            _newClip$clipImage = _newClip$clipImage === undefined ? {} : _newClip$clipImage;
            var _newClip$clipImage$ca = _newClip$clipImage.canPlay,
                canPlay = _newClip$clipImage$ca === undefined ? true : _newClip$clipImage$ca,
                _newClip$clipImage$is = _newClip$clipImage.isOffline,
                isOffline = _newClip$clipImage$is === undefined ? false : _newClip$clipImage$is,
                _newClip$clipImage$is2 = _newClip$clipImage.isUserSpace,
                isUserSpace = _newClip$clipImage$is2 === undefined ? false : _newClip$clipImage$is2,
                _newClip$clipImage$us = _newClip$clipImage.userSpaceUrl,
                userSpaceUrl = _newClip$clipImage$us === undefined ? '' : _newClip$clipImage$us,
                fullPngUrl = _newClip$clipImage.fullPngUrl,
                previewUrl = _newClip$clipImage.previewUrl,
                _newClip$clipImage$de = _newClip$clipImage.deleted,
                deleted = _newClip$clipImage$de === undefined ? false : _newClip$clipImage$de,
                _newClip$clipImage$or = _newClip$clipImage.originalFileName,
                originalFileName = _newClip$clipImage$or === undefined ? '' : _newClip$clipImage$or;

            this.musicVolume = musicVolume;
            this.time = time;
            this.transitions = transitions;
            this.clipDuration = time.exitDone - time.enterStart;

            var clipPreviewUrl = window.RENDER_MODE ? fullPngUrl : previewUrl;

            dlog('recieved updated params', 'old: ', this.mediaState, 'new : ', {
                canPlay: canPlay,
                isOffline: isOffline,
                isUserSpace: isUserSpace,
                userSpaceUrl: userSpaceUrl,
                fullPngUrl: fullPngUrl,
                previewUrl: previewUrl,
                clipPreviewUrl: clipPreviewUrl
            });

            if (clipPreviewUrl !== this.mediaState.clipPreviewUrl) {
                // Content remains USER SPACE as long as the Content was first added
                var _AllSourcePlayerRegis3 = _PlayerRegistry2.default.identifySource({
                    canPlay: canPlay,
                    isOffline: isOffline,
                    isUserSpace: isUserSpace,
                    userSpaceUrl: userSpaceUrl,
                    systemSpaceUrl: clipPreviewUrl
                }),
                    _AllSourcePlayerRegis4 = _slicedToArray(_AllSourcePlayerRegis3, 2),
                    url = _AllSourcePlayerRegis4[0],
                    useOldPlayer = _AllSourcePlayerRegis4[1];

                dlog('changing clip url to new url  ', 'typito url :', clipPreviewUrl, 'currently used :', url);

                this._viewerEl.get(0).src = url;
            }

            this.mediaState = {
                canPlay: canPlay,
                isOffline: isOffline,
                isUserSpace: isUserSpace,
                userSpaceUrl: userSpaceUrl
            };

            this._forceRender();
        }
    }, {
        key: '_getSpeed',
        value: function _getSpeed() {
            return 1;
        }
    }, {
        key: '_enterStart',
        value: function _enterStart() {
            return this.time.enterStart;
        }
    }, {
        key: '_enterDone',
        value: function _enterDone() {
            return this.time.enterDone;
        }
    }, {
        key: '_exitStart',
        value: function _exitStart() {
            return this.time.exitStart;
        }
    }, {
        key: '_exitDone',
        value: function _exitDone() {
            return this.time.exitDone;
        }
    }, {
        key: '_enterStartWithTransition',
        value: function _enterStartWithTransition() {
            var _time = this.time,
                enterStart = _time.enterStart,
                _time$currentOffset = _time.currentOffset,
                currentOffset = _time$currentOffset === undefined ? 0 : _time$currentOffset,
                _time$prevOffset = _time.prevOffset,
                prevOffset = _time$prevOffset === undefined ? 0 : _time$prevOffset;
            // if(this.transitions.hasOwnProperty('enter')){
            //     const { position = 0, duration = 0 } = this.transitions.enter
            //     if (position < 0) {
            //         enterStart = enterStart + position
            //     }
            // }

            return enterStart + currentOffset + prevOffset;
        }
    }, {
        key: '_exitDoneWithTransition',
        value: function _exitDoneWithTransition() {
            var _time2 = this.time,
                exitDone = _time2.exitDone,
                _time2$currentOffset = _time2.currentOffset,
                currentOffset = _time2$currentOffset === undefined ? 0 : _time2$currentOffset,
                _time2$prevOffset = _time2.prevOffset,
                prevOffset = _time2$prevOffset === undefined ? 0 : _time2$prevOffset;

            // if(this.transitions.hasOwnProperty('exit')){
            //     const { position = 0, duration = 0 } = this.transitions.exit
            //     exitDone = exitDone + position + duration
            // }

            return exitDone + currentOffset + prevOffset;
        }
    }, {
        key: '_onSetAnimType',
        value: function _onSetAnimType(newAnimType) {
            this.clipAnimType = newAnimType;
            this._updateTimelines();
        }
    }, {
        key: '_onSetTransitionType',
        value: function _onSetTransitionType(kind, transition) {
            this.transitions[kind] = transition;
            this._updateTimelines();
        }
    }, {
        key: '_onRemoveTransition',
        value: function _onRemoveTransition(kind) {
            if (kind == 'all') {
                this.transitions = {};
            } else {
                delete this.transitions[kind];
            }
            this._updateTimelines();
        }
    }, {
        key: '_onPlayerPlay',
        value: function _onPlayerPlay() {
            this._animationTimeline.play();
            this._transitionTimeline.play();
        }
    }, {
        key: '_onPlayerPause',
        value: function _onPlayerPause() {
            this._animationTimeline.pause();
            this._transitionTimeline.pause();
        }
    }, {
        key: '_onSeekToBeginning',
        value: function _onSeekToBeginning() {
            this._animationTimeline.seek((0, _TimeUtils._toGSAPtime)(0));
            this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(0));
        }
    }, {
        key: '_onSeekPlayerToTime',
        value: function _onSeekPlayerToTime(time) {
            this._animationTimeline.seek((0, _TimeUtils._toGSAPtime)(time));
            this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(time));
            this._forceRender();
        }
    }, {
        key: '_forceRender',
        value: function _forceRender() {
            this._animationTimeline.render(this._animationTimeline.time(), false, true);
            this._transitionTimeline.render(this._transitionTimeline.time(), false, true);
        }
    }, {
        key: '_onChangeClip',
        value: function _onChangeClip(_ref3) {
            var newTime = _ref3.time,
                newTransitions = _ref3.transitions;

            var oldTime = this.timelineTime();
            var newClipDuration = newTime.exitDone - newTime.enterStart;

            var newSeekTime = void 0;

            if (oldTime > newClipDuration) {
                newSeekTime = 0;
            } else {
                newSeekTime = oldTime;
            }

            if (!this.deleted) {
                this._animationTimeline.seek((0, _TimeUtils._toGSAPtime)(newSeekTime));
                this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(newSeekTime));
            }

            this.time = newTime;
            if (newTransitions) {
                this.transitions = newTransitions;
                this.clip.transitions = newTransitions;
            }

            this._updateTimelines();

            this.clipDuration = newClipDuration;
            this.clip.time = newTime;
            // this.clip.transitions = newTransitions;
            this.clip.clipDuration = newClipDuration;

            return newSeekTime;
        }
    }, {
        key: '_getDuration',
        value: function _getDuration() {
            return this._exitDoneWithTransition() - this._enterStartWithTransition();
        }
    }, {
        key: '_getPlayerTime',
        value: function _getPlayerTime() {
            return (0, _TimeUtils._fromGSAPtime)(this._animationTimeline.time());
        }

        /* Private */

    }, {
        key: '_updateTransitionTimeline',
        value: function _updateTransitionTimeline() {
            var restoreTime = this.timelineTime();

            this._transitionTimeline.clear();

            this._transitionTimeline.set({}, {}, (0, _TimeUtils._toGSAPtime)(this._getDuration()));

            // reset opacity to 1
            $(this._viewerEl).css({ opacity: 1 });

            var hasEnterTransition = this.transitions.hasOwnProperty('enter');
            var hasExitTransition = this.transitions.hasOwnProperty('exit');

            if (hasEnterTransition) {
                var _transitions$enter = this.transitions.enter,
                    _transitions$enter$tr = _transitions$enter.transitionAnimation,
                    enterTransitionType = _transitions$enter$tr === undefined ? 'NONE' : _transitions$enter$tr,
                    _transitions$enter$du = _transitions$enter.duration,
                    enterDuration = _transitions$enter$du === undefined ? 0 : _transitions$enter$du;

                this._setTransition(enterTransitionType, enterDuration, 0);
            }

            if (hasExitTransition) {
                var _transitions$exit = this.transitions.exit,
                    _transitions$exit$tra = _transitions$exit.transitionAnimation,
                    exitTransitionType = _transitions$exit$tra === undefined ? 'NONE' : _transitions$exit$tra,
                    _transitions$exit$pos = _transitions$exit.position,
                    position = _transitions$exit$pos === undefined ? 0 : _transitions$exit$pos,
                    _transitions$exit$dur = _transitions$exit.duration,
                    exitDuration = _transitions$exit$dur === undefined ? 0 : _transitions$exit$dur;

                var exitTransitionStartTime = this._getDuration() - exitDuration;

                this._setTransition(exitTransitionType, exitDuration, exitTransitionStartTime);
            }

            this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(restoreTime));
            this._forceRender();
        }
    }, {
        key: '_setTransition',
        value: function _setTransition(transitionType, transitionDuration, transitionStart) {
            var vars = { opacity: 1 };

            var startVars = clone(vars);
            var endVars = clone(vars);
            var ease = Linear.easeNone;

            if (transitionType === 'FADE_IN') {
                startVars.opacity = 0;
            } else if (transitionType === 'FADE_OUT') {
                endVars.opacity = 0;
            } else if (transitionType === 'FROM_BOTTOM') {
                var _getStartAndEndCrop2 = this._getStartAndEndCrop(),
                    startCrop = _getStartAndEndCrop2.startCrop,
                    endCrop = _getStartAndEndCrop2.endCrop;

                startVars = _extends({}, startVars, startCrop);
                endVars = _extends({}, endVars, startCrop);
                startVars.top = '100%';
                // ease = Circ.easeInOut
            } else if (transitionType === 'FROM_RIGHT') {
                var _getStartAndEndCrop3 = this._getStartAndEndCrop(),
                    _startCrop = _getStartAndEndCrop3.startCrop,
                    _endCrop = _getStartAndEndCrop3.endCrop;

                startVars = _extends({}, startVars, _startCrop);
                endVars = _extends({}, endVars, _startCrop);
                startVars.left = '100%';
                // ease = Circ.easeInOut
            }

            this._transitionTimeline.fromTo(this._viewerEl, (0, _TimeUtils._toGSAPtime)(transitionDuration), { css: startVars }, { css: endVars, ease: ease }, (0, _TimeUtils._toGSAPtime)(transitionStart));

            // const clipPathStr = this._getClipPathString();

            // this._transitionTimeline.set(this._viewerEl, { css : { 'clipPath': clipPathStr } }, _toGSAPtime(transitionStart))
            // this._transitionTimeline.set(this._viewerEl, { css : { 'clipPath': 'none' } }, _toGSAPtime(transitionStart + transitionDuration))
        }
    }, {
        key: '_getStartAndEndCrop',
        value: function _getStartAndEndCrop() {
            var animType = this.clipAnimType;

            // TODO change the left top width , height to scale and transform for GPU accelaration if possible
            var crop = { left: 0, top: 0, width: 100, height: 100 };
            var startCrop = clone(crop);
            var endCrop = clone(crop);

            var ZOOM_FACTOR = 0.85;

            if (animType === 'ZOOM_IN') {
                endCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                endCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                endCrop.left = Math.floor((crop.width - endCrop.width) / 2);
                endCrop.top = Math.floor((crop.height - endCrop.height) / 2);
            } else if (animType === 'ZOOM_OUT') {
                startCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                startCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                startCrop.left = Math.floor((crop.width - startCrop.width) / 2);
                startCrop.top = Math.floor((crop.height - startCrop.height) / 2);
            } else if (animType === 'FROM_RIGHT') {
                startCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                startCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                startCrop.top = Math.floor((crop.height - startCrop.height) / 2);

                endCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                endCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                endCrop.left = Math.floor((crop.width - endCrop.width) / 2);
                endCrop.top = Math.floor((crop.height - endCrop.height) / 2);
            } else if (animType === 'FROM_LEFT') {
                startCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                startCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                startCrop.left = crop.width - startCrop.width;
                startCrop.top = Math.floor((crop.height - startCrop.height) / 2);

                endCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                endCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                endCrop.left = Math.floor((crop.width - endCrop.width) / 2);
                endCrop.top = Math.floor((crop.height - endCrop.height) / 2);
            } else if (animType === 'FROM_TOP_RIGHT') {
                startCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                startCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                startCrop.top = crop.height - startCrop.height;

                endCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                endCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                endCrop.left = Math.floor((crop.width - endCrop.width) / 2);
                endCrop.top = Math.floor((crop.height - endCrop.height) / 2);
            } else if (animType === 'FROM_BOTTOM_LEFT') {
                startCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                startCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                startCrop.left = crop.width - startCrop.width;

                endCrop.width = Math.ceil(crop.width / ZOOM_FACTOR);
                endCrop.height = Math.ceil(crop.height / ZOOM_FACTOR);

                endCrop.left = Math.floor((crop.width - endCrop.width) / 2);
                endCrop.top = Math.floor((crop.height - endCrop.height) / 2);
            }

            Object.keys(startCrop).forEach(function (k) {
                startCrop[k] = startCrop[k] + '%';
            });
            Object.keys(endCrop).forEach(function (k) {
                endCrop[k] = endCrop[k] + '%';
            });

            return { startCrop: startCrop, endCrop: endCrop };
        }
    }, {
        key: '_updateAnimationTimeline',
        value: function _updateAnimationTimeline() {
            var restoreTime = this.timelineTime();

            this._animationTimeline.clear();

            this._animationTimeline.set({}, {}, (0, _TimeUtils._toGSAPtime)(this._getDuration()));

            var _getStartAndEndCrop4 = this._getStartAndEndCrop(),
                startCrop = _getStartAndEndCrop4.startCrop,
                endCrop = _getStartAndEndCrop4.endCrop;

            var animationTimeStart = 0;
            var animationDuration = this._getDuration();

            if (this.transitions.hasOwnProperty('enter')) {
                var _transitions$enter2 = this.transitions.enter,
                    _transitions$enter2$d = _transitions$enter2.duration,
                    enterDuration = _transitions$enter2$d === undefined ? 0 : _transitions$enter2$d,
                    transitionType = _transitions$enter2.transitionType;

                if (transitionType == 'FROM_BOTTOM' || transitionType == 'FROM_RIGHT') {
                    animationTimeStart = enterDuration;
                    animationDuration -= enterDuration;
                }
            }
            if (this.transitions.hasOwnProperty('exit')) {
                var _transitions$exit2 = this.transitions.exit,
                    _transitions$exit2$du = _transitions$exit2.duration,
                    exitDuration = _transitions$exit2$du === undefined ? 0 : _transitions$exit2$du,
                    _transitionType = _transitions$exit2.transitionType;

                if (_transitionType == 'FROM_BOTTOM' || _transitionType == 'FROM_RIGHT') {
                    animationDuration -= exitDuration;
                }
            }

            this._animationTimeline.fromTo(this._posSizeEl, (0, _TimeUtils._toGSAPtime)(animationDuration), { css: startCrop }, { css: endCrop, ease: Linear.easeNone }, (0, _TimeUtils._toGSAPtime)(animationTimeStart));

            this._animationTimeline.seek((0, _TimeUtils._toGSAPtime)(restoreTime));

            this._forceRender();
        }
    }, {
        key: '_onImageLoad',
        value: function _onImageLoad() {
            this._updateWaitMode(_WaitMode2.default.NONE);
        }
    }, {
        key: '_updateTimelines',
        value: function _updateTimelines() {
            this._updateAnimationTimeline();
            this._updateTransitionTimeline();
        }
    }, {
        key: '_onImageLoadError',
        value: function _onImageLoadError(err) {
            console.error(err);
        }

        // TODO batch all changes as single change

    }, {
        key: 'applyDimensions',
        value: function applyDimensions(_ref4) {
            var height = _ref4.height,
                width = _ref4.width,
                top = _ref4.top,
                left = _ref4.left;

            var insetCss = this._getClipPathString();

            this.displayEl.css('left', left + 'px').css('top', top + 'px').css('width', width + 'px').css('height', height + 'px').css('clip-path', insetCss);
        }
    }]);

    return SingleImageClipController;
}(_BaseSingleClipController2.default);

exports.default = SingleImageClipController;

},{"./BaseSingleClipController":70,"./DisplayGridHelpers":74,"./TimeUtils":89,"./enums/PlaybackState":96,"./enums/WaitMode":100,"./players/PlayerRegistry":114,"cloneextend":412}],88:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _WaitMode = require('./enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _TimeUtils = require('./TimeUtils');

var _DashJSPlayer = require('./players/DashJSPlayer');

var _DashJSPlayer2 = _interopRequireDefault(_DashJSPlayer);

var _PlayerEvents = require('./players/PlayerEvents');

var _PlayerEvents2 = _interopRequireDefault(_PlayerEvents);

var _BaseSingleClipController = require('./BaseSingleClipController');

var _BaseSingleClipController2 = _interopRequireDefault(_BaseSingleClipController);

var _PlayerRegistry = require('./players/PlayerRegistry');

var _PlayerRegistry2 = _interopRequireDefault(_PlayerRegistry);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _require = require('cloneextend'),
    clone = _require.clone;

var DEBUG = false;

var dlog = DEBUG ? function () {
    var _console;

    return (_console = console).log.apply(_console, arguments);
} : function () {};

var SingleVideoClipController = function (_BaseSingleClipContro) {
    _inherits(SingleVideoClipController, _BaseSingleClipContro);

    function SingleVideoClipController() {
        _classCallCheck(this, SingleVideoClipController);

        var _this = _possibleConstructorReturn(this, (SingleVideoClipController.__proto__ || Object.getPrototypeOf(SingleVideoClipController)).call(this));

        _this._transitionTimeline = new TimelineMax({ paused: true });
        return _this;
    }

    _createClass(SingleVideoClipController, [{
        key: '_onCreateNode',
        value: function _onCreateNode(id) {
            var containerEl = window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden');

            // TODO change it to a containetr element
            // const displayEl = window.$('<video>')
            //     .css('position', 'absolute')
            //     .css('width', '0px')
            //     .css('height', '0px')
            //     .attr('id', 'player-' + id)
            var displayEl = window.$('<div>').css('position', 'absolute').css('width', '0px').css('height', '0px').attr('id', 'player-' + id);

            containerEl.append(displayEl);

            var clipBoxEl = window.$('<div>').css('position', 'absolute').css('width', '100%').css('height', '100%').css('overflow', 'hidden').attr('class', 'clipbox');

            containerEl.append(clipBoxEl);

            return { containerEl: containerEl, displayEl: displayEl, clipBoxEl: clipBoxEl };
        }

        // transform applied in video clip can be done directly in the displayEl

    }, {
        key: 'applyTranform',
        value: function applyTranform(_ref) {
            var rotateDeg = _ref.rotateDeg,
                scaleX = _ref.scaleX,
                scaleY = _ref.scaleY;

            this.displayEl.css('webkitTransform', 'scale(' + scaleX + ', ' + scaleY + ') rotate(' + rotateDeg + 'deg)').css('msTransform', 'scale(' + scaleX + ', ' + scaleY + ') rotate(' + rotateDeg + 'deg)').css('transform', 'scale(' + scaleX + ', ' + scaleY + ') rotate(' + rotateDeg + 'deg)');
        }
    }, {
        key: '_applyBgColor',
        value: function _applyBgColor(bgColor) {
            // do nothing :)
        }
    }, {
        key: '_onAttach',
        value: function _onAttach(_ref2) {
            var _this2 = this;

            var clipStart = _ref2.clipStart,
                clipDuration = _ref2.clipDuration,
                time = _ref2.time,
                transitions = _ref2.transitions,
                _ref2$clipDashUrl = _ref2.clipDashUrl,
                clipDashUrl = _ref2$clipDashUrl === undefined ? '' : _ref2$clipDashUrl,
                _ref2$speed = _ref2.speed,
                speed = _ref2$speed === undefined ? 1 : _ref2$speed,
                clipVolume = _ref2.clipVolume,
                musicVolume = _ref2.musicVolume,
                _ref2$canPlay = _ref2.canPlay,
                canPlay = _ref2$canPlay === undefined ? true : _ref2$canPlay,
                _ref2$isOffline = _ref2.isOffline,
                isOffline = _ref2$isOffline === undefined ? false : _ref2$isOffline,
                _ref2$isUserSpace = _ref2.isUserSpace,
                isUserSpace = _ref2$isUserSpace === undefined ? false : _ref2$isUserSpace,
                _ref2$userSpaceUrl = _ref2.userSpaceUrl,
                userSpaceUrl = _ref2$userSpaceUrl === undefined ? '' : _ref2$userSpaceUrl,
                _ref2$deleted = _ref2.deleted,
                deleted = _ref2$deleted === undefined ? false : _ref2$deleted,
                _ref2$snapshotUrl = _ref2.snapshotUrl,
                snapshotUrl = _ref2$snapshotUrl === undefined ? '' : _ref2$snapshotUrl,
                originalFileName = _ref2.originalFileName;

            this.clipStart = clipStart;
            // this.clipDuration = time.exitDone - time.enterStart
            this.clipDuration = clipDuration;
            this.clipDashUrl = clipDashUrl;
            this.time = time;
            this.transitions = transitions;
            this._speed = speed;
            this.clipVolume = clipVolume;
            this.musicVolume = musicVolume;

            var _AllSourcePlayerRegis = _PlayerRegistry2.default.identifySource({
                canPlay: canPlay,
                isOffline: isOffline,
                isUserSpace: isUserSpace,
                userSpaceUrl: userSpaceUrl,
                systemSpaceUrl: clipDashUrl
            }),
                _AllSourcePlayerRegis2 = _slicedToArray(_AllSourcePlayerRegis, 2),
                url = _AllSourcePlayerRegis2[0],
                useOldPlayer = _AllSourcePlayerRegis2[1];

            dlog('Creating ClipId : ' + this.clipId + ' : type : ' + this.clipType + ' with url : ' + url + ':', {
                clip: this.clip
            });

            this.mediaState = {
                canPlay: canPlay,
                isOffline: isOffline,
                isUserSpace: isUserSpace,
                userSpaceUrl: userSpaceUrl,
                clipDashUrl: clipDashUrl
            };

            if (!this.deleted) {
                // const player = new DashJSPlayer(this.displayEl.get(0), clipDashUrl)
                var player = _PlayerRegistry2.default.createNewInstance(this.displayEl.get(0), url, { clipId: this.clipId }, useOldPlayer);

                // Start from clipStart
                player.seek((0, _TimeUtils._toGSAPtime)(clipStart));

                this.seekTo = clipStart;

                player.on(_PlayerEvents2.default.BUFFER_EMPTY, function () {
                    return _this2._onBufferEmpty();
                });
                player.on(_PlayerEvents2.default.BUFFER_LOADED, function () {
                    return _this2._onBufferLoaded();
                });
                player.on(_PlayerEvents2.default.CAN_PLAY, function () {
                    return _this2._onCanPlay();
                });
                player.on(_PlayerEvents2.default.PLAYBACK_SEEKING, function () {
                    return _this2._onSeeking();
                });
                player.on(_PlayerEvents2.default.PLAYBACK_SEEKED, function () {
                    return _this2._onSeeked();
                });
                player.on(_PlayerEvents2.default.PLAYBACK_RATE_CHANGED, function () {
                    return _this2._onPlaybackRateChanged();
                });

                this._player = player;

                this._onSetSpeed(this._speed);
            }
            this._updateTransitionTimeline();
        }
    }, {
        key: '_onKill',
        value: function _onKill() {
            if (this._player) {
                this._player.kill();
            }
            this._player = null;

            this._transitionTimeline.kill();
            this._transitionTimeline = null;

            this.clipStart = 0;
            this.clipDuration = 0;
            this.transitions = {};
            this.time = {};
        }
    }, {
        key: '_onStartCropping',
        value: function _onStartCropping() {}
    }, {
        key: '_onEndCropping',
        value: function _onEndCropping() {}
    }, {
        key: '_onSetVolume',
        value: function _onSetVolume(newVolume) {
            if (newVolume === 0 || this._speed === 1) {
                // set volume only if video is playing at normal speed
                // this.displayEl.get(0).volume = newVolume
                this._player.setVolume(newVolume);
            }
        }
    }, {
        key: '_onSetSpeed',
        value: function _onSetSpeed(newSpeed) {
            var currentClipDuration = this.clipDuration / this._speed;

            this._player.setPlaybackRate(newSpeed);
            this._speed = newSpeed;

            var newClipDuration = this.clipDuration / newSpeed;

            var newTime = clone(this.time);

            newTime.exitStart = this.time.enterStart + newClipDuration;
            newTime.exitDone = this.time.enterStart + newClipDuration;

            this.time = newTime;
            // this.clipDuration = newClipDuration

            this.clip.time = newTime;
            // this.clip.clipDuration = newClipDuration

            if (newSpeed !== 1) {
                // Mute audio if speed is changed
                this._onSetVolume(0);
            }

            return newClipDuration - currentClipDuration; // changeInDuration
        }
    }, {
        key: '_onRemoveTransition',
        value: function _onRemoveTransition(kind) {
            if (kind == 'all') {
                this.transitions = {};
                this.clip.transitions = {};
            } else {
                delete this.transitions[kind];
                delete this.clip.transitions[kind];
            }
            this._updateTransitionTimeline();
        }
    }, {
        key: '_onUpdateClip',
        value: function _onUpdateClip(newClip) {
            this.clipVolume = newClip.clipVolume;
            this.musicVolume = newClip.musicVolume;
            this.time = newClip.time;
            this.transitions = newClip.transitions;
            this.clipStart = newClip.clipStart;
            this.clipDuration = newClip.clipDuration;

            if (this.deleted) {
                // we're assuming once a clip is deleted, only it's snapshot image is
                // persisted and rest of the data is deleted.
                // thus we need to set player to null to avoid playing deleted clip.
                this._player = null;
            } else {
                var _newClip$clipVideo = newClip.clipVideo,
                    _newClip$clipVideo$ca = _newClip$clipVideo.canPlay,
                    canPlay = _newClip$clipVideo$ca === undefined ? true : _newClip$clipVideo$ca,
                    _newClip$clipVideo$is = _newClip$clipVideo.isOffline,
                    isOffline = _newClip$clipVideo$is === undefined ? false : _newClip$clipVideo$is,
                    _newClip$clipVideo$is2 = _newClip$clipVideo.isUserSpace,
                    isUserSpace = _newClip$clipVideo$is2 === undefined ? false : _newClip$clipVideo$is2,
                    _newClip$clipVideo$us = _newClip$clipVideo.userSpaceUrl,
                    userSpaceUrl = _newClip$clipVideo$us === undefined ? '' : _newClip$clipVideo$us,
                    dashUrl = _newClip$clipVideo.dashUrl;

                var clipDashUrl = dashUrl;

                dlog('recieved updated params', 'old: ', this.mediaState, 'new : ', {
                    canPlay: canPlay,
                    isOffline: isOffline,
                    isUserSpace: isUserSpace,
                    userSpaceUrl: userSpaceUrl,
                    clipDashUrl: clipDashUrl
                });

                if (clipDashUrl !== this.mediaState.clipDashUrl) {
                    // remember might not be dashUrl but rather be the original one also
                    dlog('changing clip url to new url ', clipDashUrl);

                    var _AllSourcePlayerRegis3 = _PlayerRegistry2.default.identifySource({
                        canPlay: canPlay,
                        isOffline: isOffline,
                        isUserSpace: isUserSpace,
                        userSpaceUrl: userSpaceUrl,
                        systemSpaceUrl: clipDashUrl
                    }),
                        _AllSourcePlayerRegis4 = _slicedToArray(_AllSourcePlayerRegis3, 2),
                        url = _AllSourcePlayerRegis4[0],
                        useOldPlayer = _AllSourcePlayerRegis4[1];

                    dlog('current url :', url, 'using old player (not considered currently) :', useOldPlayer);
                    this._player.changeUrl(url);
                }

                this.mediaState = {
                    canPlay: canPlay,
                    isOffline: isOffline,
                    isUserSpace: isUserSpace,
                    userSpaceUrl: userSpaceUrl,
                    clipDashUrl: clipDashUrl
                };
            }
        }
    }, {
        key: '_getSpeed',
        value: function _getSpeed() {
            return this._player.getPlaybackRate();
        }
    }, {
        key: '_onSetAnimType',
        value: function _onSetAnimType() /* newAnimType */{
            //
        }
    }, {
        key: '_onSetTransitionType',
        value: function _onSetTransitionType(kind, transition) {
            this.transitions[kind] = transition;
            this._updateTransitionTimeline();
        }
    }, {
        key: '_updateTimelines',
        value: function _updateTimelines() {
            this._updateTransitionTimeline();
        }
    }, {
        key: '_onInternalPlayerPlayback',
        value: function _onInternalPlayerPlayback() {
            this._player.play();
        }
    }, {
        key: '_onInternalPlayerPause',
        value: function _onInternalPlayerPause() {
            this._player.pause();
        }
    }, {
        key: '_onPlayerPlay',
        value: function _onPlayerPlay() {
            dlog('playing video', this.clipId);
            this._onInternalPlayerPlayback();
            this._transitionTimeline.play();
            dlog('playing video result', this.clipId, !!this._player && !this._player.isPaused());
        }
    }, {
        key: '_onPlayerPause',
        value: function _onPlayerPause() {
            dlog('pausing video', this.clipId);
            this._onInternalPlayerPause();
            this._transitionTimeline.pause();
            dlog('pausing video result', this.clipId, !!this._player && this._player.isPaused());
        }
    }, {
        key: '_onSeekToBeginning',
        value: function _onSeekToBeginning() {
            dlog('seeking video to beginning', this.clipId);

            // TODO -- confirm getting rid of them
            if (!this.deleted) {
                this._player.seek((0, _TimeUtils._toGSAPtime)(this.clipStart));
            }

            this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(0));
            this._forceRender();
        }
    }, {
        key: '_onSeekPlayerToTime',
        value: function _onSeekPlayerToTime(time) {
            dlog('seeking video', this.clipId, time);
            if (!this.deleted) {
                this._player.seek((0, _TimeUtils._toGSAPtime)(time * this._getSpeed() + this.clipStart));
            }
            this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(time));
            this._forceRender();
        }
    }, {
        key: '_forceRender',
        value: function _forceRender() {
            this._transitionTimeline.render(this._transitionTimeline.time(), false, true);
        }
    }, {
        key: '_enterStart',
        value: function _enterStart() {
            return this.time.enterStart;
        }
    }, {
        key: '_enterDone',
        value: function _enterDone() {
            return this.time.enterDone;
        }
    }, {
        key: '_exitStart',
        value: function _exitStart() {
            return this.time.exitStart;
        }
    }, {
        key: '_exitDone',
        value: function _exitDone() {
            return this.time.exitDone;
        }
    }, {
        key: '_enterStartWithTransition',
        value: function _enterStartWithTransition() {
            var _time = this.time,
                enterStart = _time.enterStart,
                _time$currentOffset = _time.currentOffset,
                currentOffset = _time$currentOffset === undefined ? 0 : _time$currentOffset,
                _time$prevOffset = _time.prevOffset,
                prevOffset = _time$prevOffset === undefined ? 0 : _time$prevOffset;

            return enterStart + currentOffset + prevOffset;
        }
    }, {
        key: '_exitDoneWithTransition',
        value: function _exitDoneWithTransition() {
            var _time2 = this.time,
                exitDone = _time2.exitDone,
                _time2$currentOffset = _time2.currentOffset,
                currentOffset = _time2$currentOffset === undefined ? 0 : _time2$currentOffset,
                _time2$prevOffset = _time2.prevOffset,
                prevOffset = _time2$prevOffset === undefined ? 0 : _time2$prevOffset;

            return exitDone + currentOffset + prevOffset;
        }
    }, {
        key: '_onChangeClip',
        value: function _onChangeClip(_ref3) {
            var _ref3$clipStart = _ref3.clipStart,
                newClipStart = _ref3$clipStart === undefined ? this.clipStart : _ref3$clipStart,
                _ref3$clipDuration = _ref3.clipDuration,
                newClipDuration = _ref3$clipDuration === undefined ? this.clipDuration : _ref3$clipDuration,
                newTime = _ref3.time,
                newTransitions = _ref3.transitions;

            // TODO Set transition in/out here
            var oldTime = this.timelineTime();
            var oldTimeFromVideoStart = oldTime + this.clipStart;

            var newTimeFromVideoStart = void 0;
            if (oldTimeFromVideoStart < newClipStart || oldTimeFromVideoStart > newClipStart + newClipDuration) {
                newTimeFromVideoStart = newClipStart;
            } else {
                newTimeFromVideoStart = oldTimeFromVideoStart;
            }

            if (!this.deleted) {
                this._player.seek((0, _TimeUtils._toGSAPtime)(newTimeFromVideoStart));
                this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(newTimeFromVideoStart));
            }

            this.clipStart = newClipStart;
            this.clipDuration = newClipDuration;
            this.time = _extends({}, this.time, newTime);

            this.clip.time = _extends({}, this.clip.time, newTime);

            this.clip.clipStart = newClipStart;
            this.clip.clipDuration = newClipDuration;

            if (newTransitions) {
                this.transitions = newTransitions;
                this.clip.transitions = newTransitions;
            }

            this._updateTransitionTimeline();

            return newTimeFromVideoStart - newClipStart;
        }
    }, {
        key: '_getDuration',
        value: function _getDuration() {
            // return this.clipDuration / this._getSpeed()
            return this._exitDoneWithTransition() - this._enterStartWithTransition();
        }
    }, {
        key: '_getPlayerTime',
        value: function _getPlayerTime() {
            if (this._player) {
                var playerTime = (0, _TimeUtils._fromGSAPtime)(this._player.time());

                return Math.max(0, playerTime - this.clipStart) / this._getSpeed();
            }
            return (0, _TimeUtils._fromGSAPtime)(this._timeline.time());
        }
    }, {
        key: '_updateTransitionTimeline',
        value: function _updateTransitionTimeline() {
            var restoreTime = this.timelineTime();

            this._transitionTimeline.clear();
            this._transitionTimeline.set({}, {}, (0, _TimeUtils._toGSAPtime)(this._getDuration()));

            // reset opacity to 1
            $(this.displayEl).css({ opacity: 1 });

            var hasEnterTransition = this.transitions.hasOwnProperty('enter');
            var hasExitTransition = this.transitions.hasOwnProperty('exit');

            if (hasEnterTransition) {
                var _transitions$enter = this.transitions.enter,
                    _transitions$enter$tr = _transitions$enter.transitionAnimation,
                    enterTransitionType = _transitions$enter$tr === undefined ? 'NONE' : _transitions$enter$tr,
                    _transitions$enter$du = _transitions$enter.duration,
                    enterDuration = _transitions$enter$du === undefined ? 0 : _transitions$enter$du;

                if (enterDuration > 0) {
                    this._setTransition(enterTransitionType, enterDuration, 0);
                }
            }

            if (hasExitTransition) {
                var _transitions$exit = this.transitions.exit,
                    _transitions$exit$tra = _transitions$exit.transitionAnimation,
                    exitTransitionType = _transitions$exit$tra === undefined ? 'NONE' : _transitions$exit$tra,
                    _transitions$exit$pos = _transitions$exit.position,
                    position = _transitions$exit$pos === undefined ? 0 : _transitions$exit$pos,
                    _transitions$exit$dur = _transitions$exit.duration,
                    exitDuration = _transitions$exit$dur === undefined ? 0 : _transitions$exit$dur;

                var exitTransitionStartTime = this._getDuration() - exitDuration;

                if (exitDuration > 0) {
                    this._setTransition(exitTransitionType, exitDuration, exitTransitionStartTime);
                }
            }

            this._transitionTimeline.seek((0, _TimeUtils._toGSAPtime)(restoreTime));
            this._forceRender();
        }
    }, {
        key: '_setTransition',
        value: function _setTransition(transitionType, transitionDuration, transitionStart) {
            var vars = { opacity: 1 };
            var startVars = clone(vars);
            var endVars = clone(vars);
            var ease = Linear.easeNone;

            if (transitionType === 'FADE_IN') {
                startVars.opacity = 0;
            } else if (transitionType === 'FADE_OUT') {
                endVars.opacity = 0;
            } else if (transitionType === 'FROM_BOTTOM') {
                startVars.top = '100%';
                endVars.top = '0%';
            } else if (transitionType === 'FROM_RIGHT') {
                startVars.left = '100%';
                endVars.left = '0%';
            } else if (transitionType === 'TO_TOP') {
                endVars.top = '-100%';
            } else if (transitionType === 'TO_LEFT') {
                endVars.left = '-100%';
            }

            this._transitionTimeline.fromTo(this.displayEl, (0, _TimeUtils._toGSAPtime)(transitionDuration), { css: startVars }, { css: endVars, ease: ease }, (0, _TimeUtils._toGSAPtime)(transitionStart));

            // const clipPathStr = this._getClipPathString();
            // this._transitionTimeline.set(this.displayEl, { css : { 'clipPath': clipPathStr } }, _toGSAPtime(transitionStart))
            // this._transitionTimeline.set(this.displayEl, { css : { 'clipPath': 'none' } }, _toGSAPtime(transitionStart + transitionDuration))
        }
    }, {
        key: '_getClipPathString',
        value: function _getClipPathString() {
            var ZOOM_FACTOR = 0.85;
            var clipBox = this.clip.clipBox;
            var canvas = this.canvas;

            var clipPath = {
                top: Math.abs(clipBox.y) / clipBox.height * 100 * ZOOM_FACTOR,
                right: (clipBox.width - canvas.width - Math.abs(clipBox.x)) / clipBox.width * 100 * ZOOM_FACTOR,
                bottom: (clipBox.height - canvas.height - Math.abs(clipBox.y)) / clipBox.height * 100 * ZOOM_FACTOR,
                left: Math.abs(clipBox.x) / clipBox.width * 100 * ZOOM_FACTOR
            };

            return 'inset(' + clipPath.top + '% ' + clipPath.right + '% ' + clipPath.bottom + '% ' + clipPath.left + '%)';
        }
    }, {
        key: '_onSeeking',
        value: function _onSeeking() {
            dlog('_onSeeking', this.clipId, 'current wait mode', this.waitMode);
            if (this.waitMode !== _WaitMode2.default.BUFFERING) {
                dlog('_onSeeking updating to seeking', this.clipId, 'current wait mode', this.waitMode);
                this._updateWaitMode(_WaitMode2.default.SEEKING);
            }
        }
    }, {
        key: '_onSeeked',
        value: function _onSeeked() {
            dlog('_onSeeked', this.clipId, 'current wait mode', this.waitMode);
            if (this.waitMode === _WaitMode2.default.LOADING || this.waitMode === _WaitMode2.default.SEEKING) {
                dlog('_onSeeked updating to none', this.clipId, 'current wait mode', this.waitMode);
                this._updateWaitMode(_WaitMode2.default.NONE);
            }
        }
    }, {
        key: '_onBufferEmpty',
        value: function _onBufferEmpty() {
            dlog('_onBufferEmpty', this.clipId, 'current wait mode', this.waitMode);
            this._updateWaitMode(_WaitMode2.default.BUFFERING);
        }
    }, {
        key: '_onBufferLoaded',
        value: function _onBufferLoaded() {
            dlog('_onBufferLoaded', this.clipId, 'current wait mode', this.waitMode);
            if (this.waitMode === _WaitMode2.default.BUFFERING) {
                dlog('_onBufferLoaded updating to none', this.clipId, 'current wait mode', this.waitMode);
                this._updateWaitMode(_WaitMode2.default.NONE);
            }
            if (this.seekTo) {
                this._player.seek((0, _TimeUtils._toGSAPtime)(this.seekTo));
                this.seekTo = null;
            }
        }
    }, {
        key: '_onCanPlay',
        value: function _onCanPlay() {
            dlog('_onCanPlay', this.clipId, 'current wait mode', this.waitMode);
            if (this.waitMode === _WaitMode2.default.LOADING || this.waitMode === _WaitMode2.default.SEEKING) {
                dlog('_onCanPlay updating to none', this.clipId, 'current wait mode', this.waitMode);
                this._updateWaitMode(_WaitMode2.default.NONE);
            }
        }
    }, {
        key: '_onPlaybackRateChanged',
        value: function _onPlaybackRateChanged() {
            if (this._player.getPlaybackRate() != this._speed) {
                this._onSetSpeed(this._speed);
            }
        }
    }, {
        key: 'applyDimensions',
        value: function applyDimensions(_ref4) {
            var height = _ref4.height,
                width = _ref4.width,
                top = _ref4.top,
                left = _ref4.left;

            this.displayEl.css('left', left + 'px').css('top', top + 'px').css('width', width + 'px').css('height', height + 'px');
        }
    }]);

    return SingleVideoClipController;
}(_BaseSingleClipController2.default);

exports.default = SingleVideoClipController;

},{"./BaseSingleClipController":70,"./TimeUtils":89,"./enums/WaitMode":100,"./players/DashJSPlayer":112,"./players/PlayerEvents":113,"./players/PlayerRegistry":114,"cloneextend":412}],89:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._toGSAPtime = exports._fromGSAPtime = exports.getApproxDiffInMonths = exports.getFormattedTime = exports.getFormattedTimeMemoized = exports.toMDYFormat = exports.toSimpleDate = exports.toReadableDate = undefined;

var _lodash = require('lodash');

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var MONTHS_SIMPLE = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var toReadableDate = exports.toReadableDate = function toReadableDate(dateStr) {
    var resetTimeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var d = new Date(dateStr);

    if (resetTimeZone) {
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    }

    var dateMonth = d.getDate();
    var dateMonthStr = '';
    if (dateMonth === 1 || dateMonth === 21 || dateMonth === 31) {
        dateMonthStr = dateMonth + 'st';
    } else if (dateMonth === 2 || dateMonth === 22) {
        dateMonthStr = dateMonth + 'nd';
    } else if (dateMonth === 3 || dateMonth === 23) {
        dateMonthStr = dateMonth + 'rd';
    } else {
        dateMonthStr = dateMonth + 'th';
    }

    var monthStr = MONTHS[d.getMonth()];

    var yearStr = d.getFullYear();

    return dateMonthStr + ' ' + monthStr + ' ' + yearStr;
};

var toSimpleDate = exports.toSimpleDate = function toSimpleDate(dateStr) {
    var resetTimeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var d = new Date(dateStr);

    if (resetTimeZone) {
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    }

    var dateMonth = d.getDate();
    var dateMonthStr = '' + dateMonth;

    var monthStr = MONTHS_SIMPLE[d.getMonth()];

    var yearStr = d.getFullYear();

    return dateMonthStr + ' ' + monthStr + ', ' + yearStr;
};

var toMDYFormat = exports.toMDYFormat = function toMDYFormat(dateStr) {
    var resetTimeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var d = new Date(dateStr);

    if (resetTimeZone) {
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    }

    var dateMonth = d.getDate();
    var dateMonthStr = '' + dateMonth;

    var monthStr = MONTHS[d.getMonth()];

    var yearStr = d.getFullYear();

    return monthStr + ' ' + dateMonthStr + ', ' + yearStr;
};

var getFormattedTimeMemoized = exports.getFormattedTimeMemoized = (0, _lodash.memoize)(function (time) {
    var timeInt = Math.floor(time);

    var secs = timeInt % 60;

    var mins = Math.floor(timeInt / 60) % 60;

    var hours = Math.floor(timeInt / (60 * 60));

    var ft = '';

    if (hours > 0) {
        ft = hours + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
    } else {
        ft = mins + ':' + (secs < 10 ? '0' + secs : secs);
    }
    return ft;
}, function (time) {
    return '' + Math.floor(time);
});

/**
 *
 * Require Time in seconds, no floating point
 *
 * @param {Number} time // time in Seconds
 * @return {*}
 */
var getFormattedTime = exports.getFormattedTime = function getFormattedTime(time) {
    var currentTime = Math.round(time * 10) / 10; // roudning it to get distinct values
    return getFormattedTimeMemoized(currentTime);
};

var getApproxDiffInMonths = exports.getApproxDiffInMonths = function getApproxDiffInMonths(fromDate, toDate) {
    var oneMonth = 30 * 24 * 60 * 60 * 1000; // days*hours*minutes*seconds*milliseconds
    return Math.round(Math.abs((fromDate - toDate) / oneMonth));
};

var _fromGSAPtime = exports._fromGSAPtime = function _fromGSAPtime(time) {
    return Math.round(time * 1000);
};
var _toGSAPtime = exports._toGSAPtime = function _toGSAPtime(time) {
    return time / 1000;
};

},{"lodash":860}],90:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateUserOnFreshChat = exports.trackOnFreshChat = exports.trackOnSmartlook = exports.trackOnPostHog = exports.trackOnHeap = exports.trackOnIntercom = exports.trackOn = exports.trackOnAll = exports.ALL_INTEGRATIONS = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.trackClipSelectOnFreshChat = trackClipSelectOnFreshChat;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ALL_INTEGRATIONS = exports.ALL_INTEGRATIONS = (0, _keymirror2.default)({
    Intercom: null,
    PostHog: null,
    FreshChat: null,
    Smartlook: null
});

var trackOnAll = exports.trackOnAll = function trackOnAll(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof analytics !== 'undefined') {
        analytics.track(event, data);
    }
};

var trackOn = exports.trackOn = function trackOn(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var integrations = arguments[2];

    if (typeof analytics !== 'undefined') {
        if (typeof integrations === 'undefined') {
            analytics.track(event, data);
        } else {
            analytics.track(event, data, { integrations: integrations });
        }
    }
};

var trackOnIntercom = exports.trackOnIntercom = function trackOnIntercom(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof analytics !== 'undefined') {
        analytics.track(event, data, {
            integrations: {
                All: false,
                Intercom: true
            }
        });
    }
};
var trackOnHeap = exports.trackOnHeap = function trackOnHeap(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof analytics !== 'undefined') {
        analytics.track(event, data, {
            integrations: {
                All: false,
                Heap: true,
                PostHog: true
            }
        });
    }
};

var trackOnPostHog = exports.trackOnPostHog = function trackOnPostHog(event, data) {
    if (typeof analytics !== 'undefined') {
        analytics.track(event, data, {
            integrations: {
                All: false,
                PostHog: true
            }
        });
    }
};

var trackOnSmartlook = exports.trackOnSmartlook = function trackOnSmartlook(event, data) {
    if (typeof analytics !== 'undefined') {
        analytics.track(event, data, {
            integrations: {
                All: false,
                Smartlook: true
            }
        });
    }
};

var trackOnFreshChat = exports.trackOnFreshChat = function trackOnFreshChat(event, data) {
    if (typeof analytics !== 'undefined' && analyticsEnabled && window.fcWidget) {
        analytics.track(event, data, {
            integrations: {
                All: false,
                FreshChat: true
            }
        });
    }
};

var updateUserOnFreshChat = exports.updateUserOnFreshChat = function updateUserOnFreshChat() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!!window.fcWidget && !!analyticsEnabled) {
        fcWidget.user.update(_extends({}, data));
    }
};
/// // FROM LEGACY CODE ///////////

function trackClipSelectOnFreshChat() {
    // if(window.Intercom && intercomEnabled){
    //     Intercom('trackEvent', 'editor-selected-clip')
    //     setTimeout(function(){
    //         Intercom("update", {last_request_at: parseInt((new Date()).getTime()/1000)})
    //     }, 500)
    // }
    // if(analyticsEnabled && window.Intercom){
    //     tracker.trackOnIntercom('editor-selected-clip')
    //     setTimeout(function(){
    //         Intercom("update", {last_request_at: parseInt((new Date()).getTime()/1000)})
    //     }, 2000)
    // }

    if (analyticsEnabled && window.fcWidget) {
        trackOnFreshChat('editor-selected-clip');
        setTimeout(function () {
            updateUserOnFreshChat({ last_request_at: parseInt(new Date().getTime() / 1000) });
        }, 2000);
    }
}

},{"keymirror":677}],91:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _GeneralUtils = require('../GeneralUtils');

var _Observable = require('../Observable');

var _Observable2 = _interopRequireDefault(_Observable);

var _dataSvgs = require('../../config/data-svgs');

var _dataSvgs2 = _interopRequireDefault(_dataSvgs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DEBUG = false;
var dlog = (0, _GeneralUtils.createDlog)(DEBUG);

var SVGManager = function () {
    function SVGManager() {
        var _this = this;

        _classCallCheck(this, SVGManager);

        this.getSvgData = function (id) {
            var index = _this.svgStringMap[id];
            var data = _this.svgStringMap[index];
            if (!data) return null;
            return data;
        };

        this.onSvgLoad = function (id) {
            var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (svgItem) {};

            var index = _this.svgStringMap[id];

            if (!_this.svgStringCache[index]) {
                return;
            }

            if (_this.svgStringCache[index].loaded) {
                return func(_this.svgStringCache[index]);
            }

            var executer = function executer() {
                func(_this.svgStringCache[index]);
                _this.observer.removeSubscription('loaded-' + index, executer);
            };
            return _this.observer.subscribe('loaded-' + index, executer);
        };

        this.index = -1;
        this.svgStringCache = [];
        this.svgStringMap = {};

        this.defaultSvg = this.observer = new _Observable2.default({
            useBatch: true
        });
    }

    /**
     * Grabs the data
     *
     * @param {*} id
     * @memberof SVGManager
     */

    /**
     *
     * Fire once the data is loaded ,
     * need to hook again if data is needed
     * will fire immediately
     *
     * @param {string} id
     * @param {({
     *  id : string ,
     *  url : string ,
     *  svgString : string ,
     *  loaded : boolean,
     *  error : boolean
     * }) => {}} [func=(svgItem) => {}]
     * @memberof SVGManager
     */

    _createClass(SVGManager, [{
        key: 'addItem',
        value: async function addItem(url) {
            var _this2 = this;

            var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _shortid2.default)();
            var svgString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            this.index++;
            var svgcacheData = {
                id: id,
                index: this.index,
                url: url,
                svgString: svgString,
                loaded: svgString !== '',
                error: false
            };
            this.svgStringCache.push(svgcacheData);

            this.svgStringMap[url] = this.index;
            this.svgStringMap[id] = this.index;

            var index = this.index;

            if (svgcacheData.loaded) {
                return Promise.resolve(function () {
                    _this2.observer.emit('loaded-' + index, _this2.svgStringCache[index]);
                    return _this2.svgStringCache[index];
                }());
            }

            var requestP = _axios2.default.get(url).then(function (response) {
                // dlog(this.svgStringCache);
                var string = response.data;
                _this2.svgStringCache[index].svgString = string;
                _this2.svgStringCache[index].loaded = true;

                _this2.observer.emit('loaded-' + index, _this2.svgStringCache[index]);

                // dlog(`Loaded SVG Data from Manager :`, this.svgStringCache[index]);
                return _this2.svgStringCache[index];
            }).catch(function (err) {
                if (svgString === '') {
                    // dlog(`failed to download resource :`, err);
                    _this2.svgStringCache[index].error = true;
                    _this2.svgStringCache[index].svgString = _dataSvgs2.default['error_placeholder'];
                }
                dlog('Failed to get the SVG from URL ');
                return _this2.svgStringCache[index];
            });
            return requestP;
        }
    }]);

    return SVGManager;
}();

var mgr = new SVGManager();

if (DEBUG) {
    window.svgManager = mgr;
}

exports.default = mgr;

},{"../../config/data-svgs":59,"../GeneralUtils":77,"../Observable":81,"axios":335,"shortid":1163}],92:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _SVGManager = require('./SVGManager');

var _SVGManager2 = _interopRequireDefault(_SVGManager);

var _dataSvgs = require('../../config/data-svgs');

var _dataSvgs2 = _interopRequireDefault(_dataSvgs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var AssetManager = function () {
    function AssetManager() {
        var _this = this;

        _classCallCheck(this, AssetManager);

        this.waitOnAllAssetLoad = function () {
            return Promise.all(_this.allAssetLoadP);
        };

        this.createIdForAsset = function (asset) {
            return asset.assetSource + '-' + asset.assetType + '-' + asset.id;
        };

        this.allAssetLoadP = [];
    }

    _createClass(AssetManager, [{
        key: 'registerAssetForImport',

        /**
         *
         *
         * @param {{
         *      assetSource:string ,
         *      assetType : "svg" | "image" | "video" ,
         *      assetUrl : string ,
         *      id : string ,
         *      assetSource : string,
         *      svgString: string | undefined
         * }} asset
         * @memberof AssetManager
         */
        value: async function registerAssetForImport(asset) {
            if (asset.assetType === 'svg') {
                var svgString = !!asset.svgString ? asset.svgString : '';

                var pr = _SVGManager2.default.addItem(asset.assetUrl, this.createIdForAsset(asset), svgString);
                this.allAssetLoadP.push(pr);
                return pr;
            }
        }

        /**
         *
         *
         * @param {{
         *      assetSource:string ,
         *      assetType : string ,
         *      originalAssetUrl : string ,
         *      id : string ,
         *      assetSource : string,
         * }} asset
         * @memberof AssetManager
         */

    }]);

    return AssetManager;
}();

exports.default = new AssetManager();

},{"../../config/data-svgs":59,"./SVGManager":91}],93:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var AudioUploadStatus = keymirror({
    UPLOADED: null,
    SAVED_TO_STORAGE: null,
    PREPARING_PREVIEWS: null,
    PREVIEW_READY: null,
    TRANSCODED_READY: null
});

module.exports = AudioUploadStatus;

},{"keymirror":677}],94:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var EditorMode = (0, _keymirror2.default)({
    REEL: null,
    OVERLAY: null
});

exports.default = EditorMode;

},{"keymirror":677}],95:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var ImageUploadStatus = keymirror({
    UPLOADED: null,
    SAVED_TO_STORAGE: null,
    PREPARING_PREVIEWS: null,
    READY: null
});

module.exports = ImageUploadStatus;

},{"keymirror":677}],96:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var PlaybackState = (0, _keymirror2.default)({
    PLAYING: null,
    PAUSED: null,
    ENDED: null
});

exports.default = PlaybackState;

},{"keymirror":677}],97:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var SequencePreviewStatus = keymirror({
    THUMB_READY: null,
    RENDERING_PREVIEW: null,
    PREVIEW_READY: null
});

module.exports = SequencePreviewStatus;

},{"keymirror":677}],98:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var TransitionType = keymirror({
    NONE: null,
    FADE_TO_BLACK: null,
    CROSS_DISSOLVE: null,
    FROM_BOTTOM: null,
    FROM_RIGHT: null
});

module.exports = TransitionType;

},{"keymirror":677}],99:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var VideoUploadStatus = keymirror({
    UPLOADING: null,
    UPLOADED: null,
    SAVED_TO_STORAGE: null,
    PREPARING_PREVIEWS: null,
    SNAPSHOT_READY: null,
    THUMBS_READY: null,
    PREVIEW_360_READY: null,
    PREVIEW_ALL_READY: null,
    TRANSCODED_READY: null
});

module.exports = VideoUploadStatus;

},{"keymirror":677}],100:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var WaitMode = (0, _keymirror2.default)({
    LOADING: null,
    SEEKING: null,
    BUFFERING: null,
    NONE: null
});

exports.default = WaitMode;

},{"keymirror":677}],101:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportError = reportError;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* eslint-disable max-classes-per-file */
var DEBUG = true;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};
/**
 *
 *
 * @export
 * @param {Error} errorObj
 */
function reportError(errorObj) {
    if (window.reportCustomError) {
        reportCustomError(errorObj);
    }
    dlog(errorObj.stack);
}

var MissingOverlayDataError = exports.MissingOverlayDataError = function (_Error) {
    _inherits(MissingOverlayDataError, _Error);

    function MissingOverlayDataError() {
        var _ref;

        _classCallCheck(this, MissingOverlayDataError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = MissingOverlayDataError.__proto__ || Object.getPrototypeOf(MissingOverlayDataError)).call.apply(_ref, [this].concat(args)));

        _this.name = MissingOverlayDataError.name;
        return _this;
    }

    return MissingOverlayDataError;
}(Error);

var ApplyToTimeLineFailedError = exports.ApplyToTimeLineFailedError = function (_Error2) {
    _inherits(ApplyToTimeLineFailedError, _Error2);

    function ApplyToTimeLineFailedError() {
        var _ref2;

        _classCallCheck(this, ApplyToTimeLineFailedError);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var _this2 = _possibleConstructorReturn(this, (_ref2 = ApplyToTimeLineFailedError.__proto__ || Object.getPrototypeOf(ApplyToTimeLineFailedError)).call.apply(_ref2, [this].concat(args)));

        _this2.name = ApplyToTimeLineFailedError.name;
        return _this2;
    }

    return ApplyToTimeLineFailedError;
}(Error);

var OverlayAdditionFailedError = exports.OverlayAdditionFailedError = function (_Error3) {
    _inherits(OverlayAdditionFailedError, _Error3);

    function OverlayAdditionFailedError() {
        var _ref3;

        _classCallCheck(this, OverlayAdditionFailedError);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        var _this3 = _possibleConstructorReturn(this, (_ref3 = OverlayAdditionFailedError.__proto__ || Object.getPrototypeOf(OverlayAdditionFailedError)).call.apply(_ref3, [this].concat(args)));

        _this3.name = OverlayAdditionFailedError.name;
        return _this3;
    }

    return OverlayAdditionFailedError;
}(Error);

var ErrorWrapper = exports.ErrorWrapper = function (_Error4) {
    _inherits(ErrorWrapper, _Error4);

    /**
     * Creates an instance of ReduxGenericActionError.
     * @param {string} message
     * @param {Error} error
     * @memberof ErrorWrapper
     */
    function ErrorWrapper(message, error) {
        _classCallCheck(this, ErrorWrapper);

        var _this4 = _possibleConstructorReturn(this, (ErrorWrapper.__proto__ || Object.getPrototypeOf(ErrorWrapper)).call(this, message));

        _this4.name = ErrorWrapper.name;
        _this4.originalError = error;

        _this4.prevStack = error ? error.stack : '';
        _this4.stack = _this4.stack + ' \n ' + _this4.prevStack;
        return _this4;
    }

    return ErrorWrapper;
}(Error);

/**
 * Use it to report generic errors from redux
 *
 * @export
 * @class ReduxGenericActionError
 * @extends {ErrorWrapper}
 */

var ReduxGenericActionError = exports.ReduxGenericActionError = function (_ErrorWrapper) {
    _inherits(ReduxGenericActionError, _ErrorWrapper);

    function ReduxGenericActionError() {
        var _ref4;

        _classCallCheck(this, ReduxGenericActionError);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        var _this5 = _possibleConstructorReturn(this, (_ref4 = ReduxGenericActionError.__proto__ || Object.getPrototypeOf(ReduxGenericActionError)).call.apply(_ref4, [this].concat(args)));

        _this5.name = ReduxGenericActionError.name;
        return _this5;
    }

    return ReduxGenericActionError;
}(ErrorWrapper);

var ClientUnsupportedMediaUpload = exports.ClientUnsupportedMediaUpload = function (_ErrorWrapper2) {
    _inherits(ClientUnsupportedMediaUpload, _ErrorWrapper2);

    function ClientUnsupportedMediaUpload() {
        var _ref5;

        _classCallCheck(this, ClientUnsupportedMediaUpload);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        var _this6 = _possibleConstructorReturn(this, (_ref5 = ClientUnsupportedMediaUpload.__proto__ || Object.getPrototypeOf(ClientUnsupportedMediaUpload)).call.apply(_ref5, [this].concat(args)));

        _this6.name = ClientUnsupportedMediaUpload.name;
        return _this6;
    }

    return ClientUnsupportedMediaUpload;
}(ErrorWrapper);

var ReelDataInconsistenError = exports.ReelDataInconsistenError = function (_Error5) {
    _inherits(ReelDataInconsistenError, _Error5);

    function ReelDataInconsistenError() {
        var _ref6;

        _classCallCheck(this, ReelDataInconsistenError);

        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        var _this7 = _possibleConstructorReturn(this, (_ref6 = ReelDataInconsistenError.__proto__ || Object.getPrototypeOf(ReelDataInconsistenError)).call.apply(_ref6, [this].concat(args)));

        _this7.name = ReelDataInconsistenError.name;
        return _this7;
    }

    return ReelDataInconsistenError;
}(Error);

var OverlayTimingDataInconsistent = exports.OverlayTimingDataInconsistent = function (_Error6) {
    _inherits(OverlayTimingDataInconsistent, _Error6);

    function OverlayTimingDataInconsistent() {
        var _ref7;

        _classCallCheck(this, OverlayTimingDataInconsistent);

        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        var _this8 = _possibleConstructorReturn(this, (_ref7 = OverlayTimingDataInconsistent.__proto__ || Object.getPrototypeOf(OverlayTimingDataInconsistent)).call.apply(_ref7, [this].concat(args)));

        _this8.name = OverlayTimingDataInconsistent.name;
        return _this8;
    }

    return OverlayTimingDataInconsistent;
}(Error);

var ReactRenderError = exports.ReactRenderError = function (_ErrorWrapper3) {
    _inherits(ReactRenderError, _ErrorWrapper3);

    function ReactRenderError() {
        var _ref8;

        _classCallCheck(this, ReactRenderError);

        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
        }

        var _this9 = _possibleConstructorReturn(this, (_ref8 = ReactRenderError.__proto__ || Object.getPrototypeOf(ReactRenderError)).call.apply(_ref8, [this].concat(args)));

        _this9.name = ReactRenderError.name;
        return _this9;
    }

    return ReactRenderError;
}(ErrorWrapper);

var StockDataRetrivalFailing = exports.StockDataRetrivalFailing = function (_ErrorWrapper4) {
    _inherits(StockDataRetrivalFailing, _ErrorWrapper4);

    function StockDataRetrivalFailing() {
        var _ref9;

        _classCallCheck(this, StockDataRetrivalFailing);

        for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
        }

        var _this10 = _possibleConstructorReturn(this, (_ref9 = StockDataRetrivalFailing.__proto__ || Object.getPrototypeOf(StockDataRetrivalFailing)).call.apply(_ref9, [this].concat(args)));

        _this10.name = StockDataRetrivalFailing.name;
        return _this10;
    }

    return StockDataRetrivalFailing;
}(ErrorWrapper);

var ProjectSyncUpdateFailed = exports.ProjectSyncUpdateFailed = function (_ErrorWrapper5) {
    _inherits(ProjectSyncUpdateFailed, _ErrorWrapper5);

    function ProjectSyncUpdateFailed() {
        var _ref10;

        _classCallCheck(this, ProjectSyncUpdateFailed);

        for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            args[_key10] = arguments[_key10];
        }

        var _this11 = _possibleConstructorReturn(this, (_ref10 = ProjectSyncUpdateFailed.__proto__ || Object.getPrototypeOf(ProjectSyncUpdateFailed)).call.apply(_ref10, [this].concat(args)));

        _this11.name = ProjectSyncUpdateFailed.name;
        return _this11;
    }

    return ProjectSyncUpdateFailed;
}(ErrorWrapper);

var OverlayPositionFailed = exports.OverlayPositionFailed = function (_Error7) {
    _inherits(OverlayPositionFailed, _Error7);

    function OverlayPositionFailed() {
        var _ref11;

        _classCallCheck(this, OverlayPositionFailed);

        for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            args[_key11] = arguments[_key11];
        }

        var _this12 = _possibleConstructorReturn(this, (_ref11 = OverlayPositionFailed.__proto__ || Object.getPrototypeOf(OverlayPositionFailed)).call.apply(_ref11, [this].concat(args)));

        _this12.name = OverlayPositionFailed.name;
        return _this12;
    }

    return OverlayPositionFailed;
}(Error);

var InvalidTimeValue = exports.InvalidTimeValue = function (_Error8) {
    _inherits(InvalidTimeValue, _Error8);

    function InvalidTimeValue() {
        var _ref12;

        _classCallCheck(this, InvalidTimeValue);

        for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            args[_key12] = arguments[_key12];
        }

        var _this13 = _possibleConstructorReturn(this, (_ref12 = InvalidTimeValue.__proto__ || Object.getPrototypeOf(InvalidTimeValue)).call.apply(_ref12, [this].concat(args)));

        _this13.name = InvalidTimeValue.name;
        return _this13;
    }

    return InvalidTimeValue;
}(Error);

var PluginApiError = exports.PluginApiError = function (_Error9) {
    _inherits(PluginApiError, _Error9);

    function PluginApiError() {
        var _ref13;

        _classCallCheck(this, PluginApiError);

        for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            args[_key13] = arguments[_key13];
        }

        var _this14 = _possibleConstructorReturn(this, (_ref13 = PluginApiError.__proto__ || Object.getPrototypeOf(PluginApiError)).call.apply(_ref13, [this].concat(args)));

        _this14.name = PluginApiError.name;
        return _this14;
    }

    return PluginApiError;
}(Error);

var UploadFailingError = exports.UploadFailingError = function (_ErrorWrapper6) {
    _inherits(UploadFailingError, _ErrorWrapper6);

    function UploadFailingError() {
        var _ref14;

        _classCallCheck(this, UploadFailingError);

        for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
            args[_key14] = arguments[_key14];
        }

        var _this15 = _possibleConstructorReturn(this, (_ref14 = UploadFailingError.__proto__ || Object.getPrototypeOf(UploadFailingError)).call.apply(_ref14, [this].concat(args)));

        _this15.name = UploadFailingError.name;
        return _this15;
    }

    return UploadFailingError;
}(ErrorWrapper);

var MissingTemplateError = exports.MissingTemplateError = function (_ErrorWrapper7) {
    _inherits(MissingTemplateError, _ErrorWrapper7);

    function MissingTemplateError() {
        var _ref15;

        _classCallCheck(this, MissingTemplateError);

        for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
            args[_key15] = arguments[_key15];
        }

        var _this16 = _possibleConstructorReturn(this, (_ref15 = MissingTemplateError.__proto__ || Object.getPrototypeOf(MissingTemplateError)).call.apply(_ref15, [this].concat(args)));

        _this16.name = MissingTemplateError.name;
        return _this16;
    }

    return MissingTemplateError;
}(ErrorWrapper);

var MissingProjectData = exports.MissingProjectData = function (_Error10) {
    _inherits(MissingProjectData, _Error10);

    function MissingProjectData() {
        var _ref16;

        _classCallCheck(this, MissingProjectData);

        for (var _len16 = arguments.length, args = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
            args[_key16] = arguments[_key16];
        }

        var _this17 = _possibleConstructorReturn(this, (_ref16 = MissingProjectData.__proto__ || Object.getPrototypeOf(MissingProjectData)).call.apply(_ref16, [this].concat(args)));

        _this17.name = MissingProjectData.name;
        return _this17;
    }

    return MissingProjectData;
}(Error);

var MissingProjectDataForExport = exports.MissingProjectDataForExport = function (_Error11) {
    _inherits(MissingProjectDataForExport, _Error11);

    function MissingProjectDataForExport() {
        var _ref17;

        _classCallCheck(this, MissingProjectDataForExport);

        for (var _len17 = arguments.length, args = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            args[_key17] = arguments[_key17];
        }

        var _this18 = _possibleConstructorReturn(this, (_ref17 = MissingProjectDataForExport.__proto__ || Object.getPrototypeOf(MissingProjectDataForExport)).call.apply(_ref17, [this].concat(args)));

        _this18.name = MissingProjectDataForExport.name;
        return _this18;
    }

    return MissingProjectDataForExport;
}(Error);

var WorkspaceMediaRetrivalFailingError = exports.WorkspaceMediaRetrivalFailingError = function (_Error12) {
    _inherits(WorkspaceMediaRetrivalFailingError, _Error12);

    function WorkspaceMediaRetrivalFailingError() {
        var _ref18;

        _classCallCheck(this, WorkspaceMediaRetrivalFailingError);

        for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
            args[_key18] = arguments[_key18];
        }

        var _this19 = _possibleConstructorReturn(this, (_ref18 = WorkspaceMediaRetrivalFailingError.__proto__ || Object.getPrototypeOf(WorkspaceMediaRetrivalFailingError)).call.apply(_ref18, [this].concat(args)));

        _this19.name = WorkspaceMediaRetrivalFailingError.name;
        return _this19;
    }

    return WorkspaceMediaRetrivalFailingError;
}(Error);

var WorkspaceUpdateError = exports.WorkspaceUpdateError = function (_Error13) {
    _inherits(WorkspaceUpdateError, _Error13);

    function WorkspaceUpdateError() {
        var _ref19;

        _classCallCheck(this, WorkspaceUpdateError);

        for (var _len19 = arguments.length, args = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
            args[_key19] = arguments[_key19];
        }

        var _this20 = _possibleConstructorReturn(this, (_ref19 = WorkspaceUpdateError.__proto__ || Object.getPrototypeOf(WorkspaceUpdateError)).call.apply(_ref19, [this].concat(args)));

        _this20.name = WorkspaceUpdateError.name;
        return _this20;
    }

    return WorkspaceUpdateError;
}(Error);

var ProjectsRetrivalFailingError = exports.ProjectsRetrivalFailingError = function (_Error14) {
    _inherits(ProjectsRetrivalFailingError, _Error14);

    function ProjectsRetrivalFailingError() {
        var _ref20;

        _classCallCheck(this, ProjectsRetrivalFailingError);

        for (var _len20 = arguments.length, args = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
            args[_key20] = arguments[_key20];
        }

        var _this21 = _possibleConstructorReturn(this, (_ref20 = ProjectsRetrivalFailingError.__proto__ || Object.getPrototypeOf(ProjectsRetrivalFailingError)).call.apply(_ref20, [this].concat(args)));

        _this21.name = ProjectsRetrivalFailingError.name;
        return _this21;
    }

    return ProjectsRetrivalFailingError;
}(Error);

var ReduxBatchError = exports.ReduxBatchError = function (_Error15) {
    _inherits(ReduxBatchError, _Error15);

    function ReduxBatchError() {
        var _ref21;

        _classCallCheck(this, ReduxBatchError);

        for (var _len21 = arguments.length, args = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
            args[_key21] = arguments[_key21];
        }

        var _this22 = _possibleConstructorReturn(this, (_ref21 = ReduxBatchError.__proto__ || Object.getPrototypeOf(ReduxBatchError)).call.apply(_ref21, [this].concat(args)));

        _this22.name = ReduxBatchError.name;
        return _this22;
    }

    return ReduxBatchError;
}(Error);

var PaymentError = exports.PaymentError = function (_Error16) {
    _inherits(PaymentError, _Error16);

    function PaymentError() {
        var _ref22;

        _classCallCheck(this, PaymentError);

        for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
            args[_key22] = arguments[_key22];
        }

        var _this23 = _possibleConstructorReturn(this, (_ref22 = PaymentError.__proto__ || Object.getPrototypeOf(PaymentError)).call.apply(_ref22, [this].concat(args)));

        _this23.name = ReduxBatchError.name;
        return _this23;
    }

    return PaymentError;
}(Error);

},{}],102:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.useBatchedState = useBatchedState;

var _react = require('react');

var _polyfill = require('../scheduler/polyfill');

/**
 *
 * Caution -- Not to be overused -- After REACT 18 it will be OBSOLETE , u can swithc to useTransition then
 * - React is smart enough to use Transaction inside it's Synthetic Events and
 *   setState inside effects
 * - But there are time when u would do the same inside a RAF or Window Events
 *   where there is no batching. Thousands of such setState may or may be batched by react
 *   What's more inconsistent here is React priority of DOM flush.
 * - Use this in such cases to batch all the calls of setState inside one single Batch
 *   "raf" - Will use batch every setState done under one RAF - React doesn;t used RAF so this might be handy
 *    -- Warning , once React goes async this might not hold true , but the idea of batching will still work
 *   "idle" - LOWEST Priority , if u have UI chnages that u can delay significantly , - this is the type u want
 *   "timeout" -- Oldest in the book , u want to break task up , use this . Has a timeout of 1ms to collect bunch of setState
 *   and batches all of them together If ur code ends up in a loop of calling setState - This is a good place for this
 *
 *
 * @export
 * @param {any} [initialState]
 *
 * @param {idle  | raf | timeout} [batchType]
 *
 * @return {*}
 */
function useBatchedState() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var batchType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'idle';

    var _useState = (0, _react.useState)(initialState),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var modifiedSetState = React.useCallback(function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return (0, _polyfill.qeueReduxBatchedOperation)(function () {
            return setState.apply(undefined, args);
        }, batchType);
    }, []);

    return [state, modifiedSetState];
}

},{"../scheduler/polyfill":126,"react":1107}],103:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useDebouncedEffect;

var _polyfill = require('../scheduler/polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var DEBUG = true && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var buildExecuter = function buildExecuter(callbackRef, cleanUpFuncRef) {
    return function () {
        cleanUpFuncRef.current = null;
        if (callbackRef.current) cleanUpFuncRef.current = callbackRef.current();
    };
};

/**
 *
 * Usage
 * - This hook debounces your calles function
 * - Your function need not be referentially consistent
 * - The hook will make sure to always call the latest assigned function
 * - But remember since it's a debounce for hook i.e your functions whatever be the current
 *   reference
 * - You can schedule microtask using this as well although microtask are not cancellable know that
 * - U can use Raf / IdleCallback -- however raf callbacks might not be cancelled - depends strictlt on execution order
 * - Post message based scheduler also added , Can use for faster response time that plays well with user events
 *
 *
 *
 * @export
 * @param {Function} [callback=() => {}]
 * @param {Array<any>} [deps=[]]
 * @param {{
 *  timeout : number,
 *  type : 'raf' | 'st' | 'idle' | 'mt' | 'pm'
 * }} [config]
 */
function useDebouncedEffect() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _ref = arguments[2];
    var _ref$timeout = _ref.timeout,
        timeout = _ref$timeout === undefined ? 16 : _ref$timeout,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'st' : _ref$type;

    var timeoutRef = (0, _react.useRef)(null);
    var idleCallbackRef = (0, _react.useRef)(null);
    var rafCallbackRef = (0, _react.useRef)(null);
    var postMessageCallbackRef = (0, _react.useRef)(null);

    var callbackRef = (0, _react.useRef)(callback);
    var cleanUpFuncRef = (0, _react.useRef)(null);
    callbackRef.current = callback;

    var executor = _react2.default.useCallback(buildExecuter(callbackRef, cleanUpFuncRef), []);

    var cancelTask = function cancelTask() {
        switch (type) {
            case 'raf':
                cancelAnimationFrame(rafCallbackRef.current);
                break;
            case 'st':
                clearTimeout(timeoutRef.current);
                break;
            case 'idle':
                (0, _polyfill.cancelLocalIdleCallback)(idleCallbackRef.current);
                break;
            case 'pm':
                _polyfill.Scheduler.cancelTask(postMessageCallbackRef.current);
                break;
            default:
        }
    };

    (0, _react.useEffect)(function () {
        return cancelTask;
    }, [type]);

    (0, _react.useEffect)(function () {
        cancelTask();
        switch (type) {
            case 'raf':
                {
                    rafCallbackRef.current = requestAnimationFrame(executor);
                    break;
                }
            case 'st':
                {
                    timeoutRef.current = setTimeout(executor, timeout);
                    // dlog(`Scheduled update : ${timeoutRef.current} for ${timeout}`)
                    break;
                }
            case 'mt':
                {
                    (0, _polyfill.localMicrotask)(executor);
                    break;
                }
            case 'idle':
                {
                    idleCallbackRef.current = (0, _polyfill.localIdleCallback)(executor);
                    break;
                }
            case 'pm':
                {
                    postMessageCallbackRef.current = _polyfill.Scheduler.postTask(executor);
                    break;
                }
            default:
        }
        return function () {
            var cleanupfunc = cleanUpFuncRef.current;
            if (cleanupfunc && typeof cleanupfunc === 'function') {
                cleanupfunc();
            }
        };
    }, deps);
}

},{"../scheduler/polyfill":126,"react":1107}],104:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.default = useEnhancedState;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function useEnhancedState(state) {
    var _useState = (0, _react.useState)(state),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setState = _useState2[1];

    var canCallSetStateRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(function () {
        canCallSetStateRef.current = true;
        return function () {
            canCallSetStateRef.current = false;
        };
    }, []);

    var newSetState = _react2.default.useCallback(function () {
        if (canCallSetStateRef.current) {
            setState.apply(undefined, arguments);
        }
    }, [setState]);
    return [value, newSetState];
}

},{"react":1107}],105:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUseEventObserver = undefined;
exports.default = useEvent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Observable = require('../Observable');

var _Observable2 = _interopRequireDefault(_Observable);

var _usePropRef = require('./usePropRef.react');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var DEBUG = false && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var Observer = new _Observable2.default({
    useBatch: true
});

var getUseEventObserver = exports.getUseEventObserver = function getUseEventObserver() {
    return Observer;
};

/**
 *
 *
 * @export
 * @param {{
 *  topic : string ,
 *  callback :
 * }} { topic, callback }
 * @param {*} [deps=[]]
 * @param {boolean} [shouldObserve=true]
 * @return {*}
 */
function useEvent(_ref) {
    var topic = _ref.topic,
        callback = _ref.callback;
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var shouldObserve = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var callbackRef = (0, _usePropRef.usePropRef)(callback);
    var callbackObs = _react2.default.useCallback(function () {
        return callbackRef.current && callbackRef.current.apply(callbackRef, arguments);
    }, []);
    var callbackIndexRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function () {
        if (!!topic && shouldObserve) {
            callbackIndexRef.current = Observer.subscribe(topic, callbackObs);
        }
        return function () {
            if (callbackIndexRef.current) {
                callbackObs.index = callbackIndexRef.current;
                Observer.removeSubscription(topic, callbackObs);
                callbackIndexRef.current = null;
            }
        };
    }, [shouldObserve, topic].concat(_toConsumableArray(deps)));

    (0, _react.useEffect)(function () {
        return function () {
            if (callbackIndexRef.current) {
                callbackObs.index = callbackIndexRef.current;
                Observer.removeSubscription(topic, callbackObs);
                callbackIndexRef.current = null;
            }
        };
    }, []);

    var emitFunction = _react2.default.useCallback(function (data) {
        if (!!topic) {
            Observer.emit(topic, data);
        }
    }, [topic]);

    return emitFunction;
}

},{"../Observable":81,"./usePropRef.react":107,"react":1107,"react-redux":1079}],106:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.observerPool = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.default = useIntersectionDetector;

var _react = require('react');

var _ObserverListener = require('../ObserverListener');

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};
// DEBOUNCE BECAUSE RAPID LAYOUT SHIFT GIVES BAD VALUE -- for intersection it sould be smaller

var observerPool = exports.observerPool = new _ObserverListener.ObserverPoolListener({
    throttleT: null,
    eventAttributeName: 'intersection-event',
    observerCreator: function observerCreator(callback) {
        return new IntersectionObserver(callback, {
            root: null,
            threshold: 0
        });
    }
});

/**
 *
 *
 * @param {HTMLElement|window} boundingElement
 */
var getBoundingBox = function getBoundingBox(boundingElement) {
    if (boundingElement === window) {
        return {
            x: 0,
            y: 0,
            height: window.innerHeight,
            width: window.innerWidth,
            left: 0,
            top: 0,
            isWindow: true
        };
    } else return boundingElement.getBoundingClientRect();
};

/**
 *
 *
 * @param {DOMRect} elementBox
 * @param {DOMRect | {x:number , y:number , height:number , width:number , left:number , top:number , isWindow:boolean}} boundingElementBox
 */
var getRelativePosition = function getRelativePosition(elementBox, boundingElementBox) {
    var x = elementBox.left - boundingElementBox.left,
        y = elementBox.top - boundingElementBox.top;

    return {
        x: x,
        y: y,
        elementPos: elementBox,
        boundingElementPos: boundingElementBox
    };
};

/**
 *
 *
 * Attach intersection observer for target container specified by css
 * for the target element. pool the event listener for same target element
 *
 * NOTE : This is not deboubced , since intersection observer needs to trigger at precise moments
 * so debouncing will not work in favour. However events are pooled are triggered under a RAF callback
 *
 *
 * @export
 * @param {(arguments:
 *          {
 *          observer: IntersectionObserver,
 *          element : HTMLElement,
 *          elementBox: DOMRect,
 *          containerElement : HTMLELement,
 *          containerBoundingBox : DOMRect,
 *          intersectionRatio : number,
 *          isIntersecting : boolean,
 *          useWindow : boolean,
 *          currPos : { x:number , y:number , elementPos:number , boundingElementPos:number }
 *          }) => {}} callback
 * @param {Array<any>} [deps=[]]
 * @param {{
 *      root : HTMLElement,
 *      rootMargin : string ,
 *      threshold : number
 * }} [options={
 *         root: null,
 *         rootMargin : "0px 0px 0px 0px",
 *         threshold : 0
 *     }]
 * @param {{
 *      targetContainer : string ,
 *      targetElement : string ,
 *      shouldObserve : boolean
 * }} [{ targetContainer = null, targetElement = null, shouldObserve = true }={}]
 * @return {React.MutableRefObject}
 */
function useIntersectionDetector() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        rootMargin: '0px',
        threshold: 0
    };

    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref$targetContainer = _ref.targetContainer,
        targetContainer = _ref$targetContainer === undefined ? null : _ref$targetContainer,
        _ref$targetElement = _ref.targetElement,
        targetElement = _ref$targetElement === undefined ? null : _ref$targetElement,
        _ref$shouldObserve = _ref.shouldObserve,
        shouldObserve = _ref$shouldObserve === undefined ? true : _ref$shouldObserve;

    var intersectionObj = (0, _react.useRef)(null);
    var container = (0, _react.useRef)(null);
    var element = (0, _react.useRef)(null);

    (0, _react.useEffect)(function () {
        if (!element.current) element.current = document.querySelector(targetElement);

        if (!element.current) return function () {};

        if (shouldObserve) {
            if (!container.current) {
                container.current = document.querySelector(targetContainer);
                if (!container.current) {
                    container.current = window;
                }
            }

            options = _extends({
                root: container.current === window ? null : container.current,
                threshold: 0
            }, options);

            intersectionObj.current = observerPool.addCallback(function () {
                var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var element = values.element,
                    boundingBox = values.elementBox,
                    containerBoundingBox = values.containerBoundingBox,
                    intersectionRatio = values.intersectionRatio;

                var currPos = getRelativePosition(boundingBox, containerBoundingBox || getBoundingBox(container.current));

                var data = _extends({
                    currPos: currPos,
                    containerElement: container.current,
                    useWindow: container.current === window,
                    intersectionRatio: intersectionRatio
                }, values);
                // dlog(`callback data passing :` , data)

                callback(data);
            }, element.current, container.current, function (cb) {
                return new IntersectionObserver(cb, options);
            }, {
                useRaf: true,
                getBoundingBox: true
            });
            dlog('mounted : ', intersectionObj.current, element.current);
        }

        return function () {
            if (intersectionObj.current) {
                observerPool.removeCallback(intersectionObj.current, element.current, container.current);
                dlog('removed , ', intersectionObj.current, element.current);
                intersectionObj.current = null;
            }
        };
    }, [shouldObserve].concat(_toConsumableArray(deps)));

    (0, _react.useEffect)(function () {
        return function () {
            if (intersectionObj.current) {
                observerPool.removeCallback(intersectionObj.current, element.current, container.current);
                dlog('demounted , ', intersectionObj.current, element.current);
                intersectionObj.current = null;
            }
        };
    }, []);

    return element;
}

},{"../ObserverListener":82,"react":1107}],107:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAsyncEffect = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.usePropRef = usePropRef;
exports.usePrevPropRef = usePrevPropRef;
exports.useReduceRef = useReduceRef;
exports.useFirstRenderRef = useFirstRenderRef;
exports.useFunctionRef = useFunctionRef;
exports.useStatePromise = useStatePromise;
exports.useRefCallBack = useRefCallBack;
exports.useForceUpdate = useForceUpdate;

var _react = require('react');

var _polyfill = require('../scheduler/polyfill');

var _useBatchedState3 = require('./useBatchedState.react');

function usePropRef(prop) {
    var ref = (0, _react.useRef)(null);
    ref.current = prop;
    return ref;
}

/**
 *
 *
 * @export
 * @param {any} prop
 * @return {[any , any]} [oldProp , newProp]
 */
function usePrevPropRef(prop) {
    var oldRef = (0, _react.useRef)(null);
    var newRef = usePropRef(prop);
    (0, _react.useEffect)(function () {
        oldRef.current = newRef.current;
    }, [prop]);
    return [oldRef.current, newRef.current];
}

function useReduceRef() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (acc) {};
    var value = arguments[1];

    var ref = (0, _react.useRef)(value);
    var newValue = func(ref.current);
    ref.current = newValue;
    return ref.current;
}

function useFirstRenderRef() {
    var ref = (0, _react.useRef)(true);
    // can use Effect , but need not
    if (ref.current) {
        (0, _polyfill.localMicrotask)(function () {
            ref.current = !ref.current;
        });
    }
    return ref.current;
}

function useFunctionRef() {
    var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var ref = (0, _react.useRef)(seed);
    var updateFunction = (0, _react.useCallback)(function (r) {
        ref.current = r;
    }, []);
    return [ref, updateFunction];
}
function useStatePromise() {
    var funcP = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : async function () {};
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _useBatchedState = (0, _useBatchedState3.useBatchedState)([null, seed], 'timeout'),
        _useBatchedState2 = _slicedToArray(_useBatchedState, 2),
        _useBatchedState2$ = _slicedToArray(_useBatchedState2[0], 2),
        err = _useBatchedState2$[0],
        value = _useBatchedState2$[1],
        setState = _useBatchedState2[1];

    (0, _react.useMemo)(function () {
        return Promise.resolve(funcP(seed)).then(function (v) {
            return setState([null, v]);
        }).catch(function (err) {
            return setState([err, null]);
        });
    }, []);
    return [err, value];
}

function useRefCallBack() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        var selfArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var propArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    };
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var newRefArgs = usePropRef(args);
    var functionRef = usePropRef(func);
    var newFunction = (0, _react.useCallback)(function () {
        var selfArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (newRefArgs.current && functionRef.current) {
            functionRef.current(selfArg, newRefArgs.current);
        }
    }, []);
    return newFunction;
}

function useForceUpdate() {
    var _useState = (0, _react.useState)(0),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var update = (0, _react.useCallback)(function (fn) {
        if (fn && typeof fn === 'function') {
            setState(function (d) {
                fn(d);
                return d + 1;
            });
        } else {
            setState(function (d) {
                return d + 1;
            });
        }
    }, []);

    return update;
}

var useAsyncEffect = exports.useAsyncEffect = function useAsyncEffect() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var init = arguments[1];

    var triggered = (0, _react.useRef)(false);

    var _useState3 = (0, _react.useState)(init),
        _useState4 = _slicedToArray(_useState3, 2),
        state = _useState4[0],
        setState = _useState4[1];

    if (!triggered.current) {
        triggered.current = true;
        Promise.resolve(func()).then(setState).catch(setState);
    }
    return state;
};

},{"../scheduler/polyfill":126,"./useBatchedState.react":102,"react":1107}],108:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResizeObserverPool = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.default = useResizeDetector;
exports.ResizeMeasure = ResizeMeasure;

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ObserverListener = require('../ObserverListener');

var _polyfill = require('../scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var DEBUG = true && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};
var THROTTLE = 50; // DEBOUNCE BECAUSE RAPID LAYOUT SHIFT GIVES BAD VALUE

// // TODO Super important - HIGHLY UNOPTIMIZED RIGHT NOW - Should be USING SAME RESIZE OBSERVER GLOBALLY

var ResizeObserverPool = exports.ResizeObserverPool = new _ObserverListener.ObserverListener({
    throttleT: null,
    getBoundingBox: true,
    useBatch: true,
    eventAttributeName: 'resize-observer',
    observerCreator: function observerCreator(callback) {
        return new ResizeObserver(callback);
    }
});

/**
 *
 *
 *
 * - Allows user to create a hook using the resize observer api
 * - uses an internal linked list of listener to dynamically remove and add listeners when needed
 * - does not repeates listener for one targetContainer - handled by same listener
 * - pass a callback and use it for firing events
 *
 * - Removed itself relibaly whenever the component using it gets demounted
 *
 *
 * usage exmaple
 *
 * useResizeDetector(() => {
 *
 *  // some event here
 * } , [..deps array] , { .. other args})
 *
 * shouldObserve = can detach listener while the hook is still active
 * fireOnLoad = will fire callback once as soon as the HTML element is rendered , useful in certain cases
 *
 * @export
 * @param {(arguments : {element: HTMLElement, elementBox: DOMRect , firstLoad : boolean}) => {}} [callback]
 * @param {Array<any>} [deps=[]]
 * @param {{
 *    targetContainer : string,
 *    shouldObserve : boolean,
 *    fireOnLoad : boolean,
 *    targetContainerRef : React.MutableRefObject,
 *    avoidWindow : boolean
 * }} [config]
 *
 * @returns {React.MutableRefObject}
 */
function useResizeDetector() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$targetContainerR = _ref.targetContainerRef,
        targetContainerRef = _ref$targetContainerR === undefined ? null : _ref$targetContainerR,
        _ref$targetContainer = _ref.targetContainer,
        targetContainer = _ref$targetContainer === undefined ? null : _ref$targetContainer,
        _ref$shouldObserve = _ref.shouldObserve,
        shouldObserve = _ref$shouldObserve === undefined ? true : _ref$shouldObserve,
        _ref$fireOnLoad = _ref.fireOnLoad,
        fireOnLoad = _ref$fireOnLoad === undefined ? false : _ref$fireOnLoad,
        id = _ref.id,
        _ref$avoidWindow = _ref.avoidWindow,
        avoidWindow = _ref$avoidWindow === undefined ? true : _ref$avoidWindow;

    var resizeObj = (0, _react.useRef)(null);
    var element = targetContainerRef || (0, _react.useRef)(null);

    var elementBox = (0, _react.useRef)(null);

    (0, _react.useLayoutEffect)(function () {

        if (!element.current) {
            element.current = element.current || document.querySelector(targetContainer);
            if (!element.current && !avoidWindow) {
                element.current = document.querySelector('body');
            }
        }

        var currElement = element.current;

        if (fireOnLoad && !resizeObj.current && currElement) {
            // fires when loaded firs time and the resizeObject is not created yet
            if (!elementBox.current) {
                _fastdom2.default.measure(function () {
                    elementBox.current = currElement.getBoundingClientRect();
                    callback({ element: currElement, elementBox: elementBox.current, firstLoad: true });
                });
            } else {
                (0, _polyfill.qeueReduxBatchedOperation)(function () {
                    return callback({ element: currElement, elementBox: elementBox.current, firstLoad: true });
                });
            }
        }

        // TODO -- check impact
        // if (resizeObj.current) {
        //     // remove existing observer , add a new one
        //     ResizeObserverPool.removeCallback(resizeObj.current, element.current);
        // }

        if (shouldObserve && currElement) {
            resizeObj.current = ResizeObserverPool.addCallback(function (_ref2) {
                var element = _ref2.element,
                    eb = _ref2.elementBox,
                    firstLoad = _ref2.firstLoad,
                    otherProps = _objectWithoutProperties(_ref2, ['element', 'elementBox', 'firstLoad']);

                elementBox.current = eb;
                callback(_extends({ element: element, elementBox: elementBox.current, firstLoad: firstLoad }, otherProps));
            }, currElement);
        }

        return function () {
            var removerElement = currElement;
            if (resizeObj.current) {
                ResizeObserverPool.removeCallback(resizeObj.current, removerElement); // remove and keep a reference
                resizeObj.current = null;
            }
            // TODO -- validate , creates a wasted document search
            // if (element.current) {
            //     element.current = null; // clearing of the refrence ,
            // }
        };
    }, [shouldObserve, targetContainer].concat(_toConsumableArray(deps)));

    (0, _react.useEffect)(function () {
        return function () {
            var removerElement = element.current;
            if (resizeObj.current) {
                ResizeObserverPool.removeCallback(resizeObj.current, removerElement); // remove and keep a reference
                resizeObj.current = null;
            }
        };
    }, []);

    return element;
}

if (DEBUG) {
    window.ResizeObserverPool = ResizeObserverPool;
}

/**
 *
 * 
 * Usage
 * - use it as a wrapper div that Accepts function as a child
 *  <ResizeMeasure>
 *      ({ ...args}) => {
 *          /// your component
 *      }
 *  </ResizeMeasure>
 * 
 * - If u do not pass a target reference expect empty data for function arguments
 *   because measure cannot do anything without a reference and it will default to body
 * - remeber not to use both ref in component argument as well as the child function, 
 *   it will get into indeterminate state
 * 
 * 
 * - this is not memoized , it's a function that behaves like a components
 * 
 *
 * @param {{
 *  deps : Array<any>
 *  callback : (args: {element: HTMLElement, elementBox: DOMRect , firstLoad : boolean , resizeRef : React.MutableRefObject}) => {}
 *  targetContainerRef : React.MutableRefObject, 
 *  targetContainer : String, 
 *  shouldObserve : boolean, 
 *  fireOnLoad : boolean,
 *  children : (args: {element: HTMLElement, elementBox: DOMRect , firstLoad : boolean , resizeRef : React.MutableRefObject}) => React.ReactElement,
 *  seedState : any,
 *  avoidWindow : boolean
 * }} [props]
 * @return {*} 
 */
function ResizeMeasure(_ref3) {
    var _ref3$deps = _ref3.deps,
        deps = _ref3$deps === undefined ? [] : _ref3$deps,
        _ref3$callback = _ref3.callback,
        callback = _ref3$callback === undefined ? function () {} : _ref3$callback,
        _ref3$targetContainer = _ref3.targetContainerRef,
        targetContainerRef = _ref3$targetContainer === undefined ? null : _ref3$targetContainer,
        _ref3$targetContainer2 = _ref3.targetContainer,
        targetContainer = _ref3$targetContainer2 === undefined ? null : _ref3$targetContainer2,
        _ref3$shouldObserve = _ref3.shouldObserve,
        shouldObserve = _ref3$shouldObserve === undefined ? true : _ref3$shouldObserve,
        _ref3$fireOnLoad = _ref3.fireOnLoad,
        fireOnLoad = _ref3$fireOnLoad === undefined ? false : _ref3$fireOnLoad,
        _ref3$children = _ref3.children,
        children = _ref3$children === undefined ? function () {} : _ref3$children,
        _ref3$seedState = _ref3.seedState,
        seedState = _ref3$seedState === undefined ? null : _ref3$seedState,
        _ref3$avoidWindow = _ref3.avoidWindow,
        avoidWindow = _ref3$avoidWindow === undefined ? true : _ref3$avoidWindow;

    var _useState = (0, _react.useState)(seedState),
        _useState2 = _slicedToArray(_useState, 2),
        resizeData = _useState2[0],
        setResizeData = _useState2[1];

    var resizeRef = useResizeDetector(function (args) {
        setResizeData(args);
        callback(args);
    }, [].concat(_toConsumableArray(deps)), {
        targetContainerRef: targetContainerRef,
        fireOnLoad: fireOnLoad,
        shouldObserve: shouldObserve,
        targetContainer: targetContainer,
        avoidWindow: avoidWindow
    });

    return children(_extends({}, resizeData, { resizeRef: resizeRef }));
}

},{"../ObserverListener":82,"../scheduler/polyfill":126,"fastdom":634,"react":1107}],109:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ElementScrollListener = undefined;
exports.default = useScrollPosition;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _GeneralUtils = require('../GeneralUtils');

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _EventListenerList = require('../EventListenerList');

var _EventListenerList2 = _interopRequireDefault(_EventListenerList);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var DEBUG = false;
var THROTTLE = 16;
// since scroll register should cancel only when scrolled really fast
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var ElementScrollListener = exports.ElementScrollListener = new _EventListenerList2.default({
    eventName: 'scroll',
    throttleT: THROTTLE,
    attributeName: 'scroll-event-listener-id',
    useBatch: true
});

window.GlobalElementScrollListener = ElementScrollListener;

/**
 *  Using FastDom to call this function
 *
 *
 * @param {*} {element , useWindow}
 * @return {*}
 */
function getScrollPosition(_ref) {
    var element = _ref.element,
        useWindow = _ref.useWindow,
        boundingElement = _ref.boundingElement;

    var target = element ? element.current : null;
    var position = null;
    var boundingElementPosition = {};
    var x = 0;
    var y = 0;

    if (target) {
        if (element && element.current) {
            position = target.getBoundingClientRect();
            x = position.left;
            y = position.top;
        }
    }

    if (boundingElement && !useWindow) {
        boundingElementPosition = boundingElement.getBoundingClientRect(); // Memoize this one , why call repeatedly ??
        x = x - boundingElementPosition.left;
        y = y - boundingElementPosition.top;
    }

    return useWindow ? { x: window.scrollX, y: window.scrollY, elementPos: position } : {
        x: x,
        y: y,
        elementPos: position,
        boundingElementPos: boundingElementPosition
    };
}

/**
 *
 * Hook for detecting scroll and sending the result of relative X , Y position
 *
 *
 *
 * why a hook ?
 * - easy functional component use
 * - written for efficiency ( single listener qeue , dynamic deletion , easy teardown with hooks )
 * - how to use it ,
 *  Interface is same as any hook. Takes a callback , which returns the x and y whenevr a scroll happen
 *  deps array deteremines if the hook needs to be reattached .
 *
 *
 * How it works, and why should u use it ?
 *
 * - build around idea of batching long running task
 * - frame budget is kept at 16ms
 * - has debounce support , but can drop it if u want batching support
 * - uses requestFrameAnimation synced using fastdom to synced request for reading data
 *
 *
 *
 *
 * @export
 * @param {Function} [callback=({x = 0  , y = 0 }) => {}]
 * @param {Array} [deps=[]]
 * @param {{
 *  shouldObserve : boolean,
 *  element : React.Ref,
 *  useWindow : boolean,
 *  debounceT : number,
 *  boundingElement : string
 *
 * }}
 */
function useScrollPosition() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_ref2) {
        var _ref2$x = _ref2.x,
            x = _ref2$x === undefined ? 0 : _ref2$x,
            _ref2$y = _ref2.y,
            y = _ref2$y === undefined ? 0 : _ref2$y;
    };
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        shouldObserve = _ref3.shouldObserve,
        _ref3$element = _ref3.element,
        element = _ref3$element === undefined ? null : _ref3$element,
        _ref3$useWindow = _ref3.useWindow,
        useWindow = _ref3$useWindow === undefined ? true : _ref3$useWindow,
        _ref3$debounceT = _ref3.debounceT,
        debounceT = _ref3$debounceT === undefined ? 16 : _ref3$debounceT,
        _ref3$boundingElement = _ref3.boundingElement,
        boundingElement = _ref3$boundingElement === undefined ? null : _ref3$boundingElement;

    var position = (0, _react.useRef)(null);

    var observer = (0, _react.useRef)(null);

    // const fastdomId = useRef(null)

    (0, _react.useLayoutEffect)(function () {
        var currentPositionP = Promise.resolve();

        var unmountFn = null;

        if (!position.current) {
            currentPositionP = new Promise(function (resolve) {
                _fastdom2.default.measure(function () {
                    position.current = getScrollPosition({ useWindow: useWindow });
                    resolve();
                });
            });
        }

        // this is to ensure two things
        // 1. Its a micro task that happens after we get first measurements
        // 2. this ensures that we use fastdom for reading scroll position
        currentPositionP.then(function () {
            boundingElement = document.querySelector(boundingElement); // look for element
            boundingElement = boundingElement || window; // if not found switch to window

            if (boundingElement == window) useWindow = true;

            var onScrollCallback = void 0;

            var doInsideRaf = function doInsideRaf() {
                return getScrollPosition({ element: element, useWindow: useWindow, boundingElement: boundingElement });
            };

            if (debounceT == null) {
                onScrollCallback = function onScrollCallback(e, _ref4) {
                    var currPos = _ref4.rafResult;

                    var _position = position;
                    unmountFn = callback({
                        prevPos: position.current,
                        currPos: currPos,
                        useWindow: useWindow,
                        boundingElement: boundingElement
                    });
                    _position.current = currPos;
                };
            } else {
                onScrollCallback = (0, _GeneralUtils.debounce)(function (e, _ref5) {
                    var currPos = _ref5.rafResult;

                    // fastdom.clear(fastdomId.current)
                    // fastdomId.current =  fastdom.measure(() => {

                    var _position = position;
                    unmountFn = callback({
                        prevPos: position.current,
                        currPos: currPos,
                        useWindow: useWindow,
                        boundingElement: boundingElement
                    });
                    _position.current = currPos;
                    // })
                }, debounceT);
            }

            // TODO -- evaluate if removal is required removes any event listener if preexisting for this hook
            // if (observer.current) {
            //     observer.current = ElementScrollListener.removeEventListener(observer.current);
            // }
            // if shouldObserve , attach the observer
            if (shouldObserve) {
                observer.current = ElementScrollListener.addEventListener(boundingElement, onScrollCallback, {
                    prepareInRaf: doInsideRaf
                });
            }
        });

        return function () {
            // fastdom.clear(fastdomId.current)
            // tear doen remove listener from linked list
            if (observer.current) observer.current = ElementScrollListener.removeEventListener(observer.current);
            // Cleanup action will run everytime cleanup happens - may run during state / prop / dep changes also
            if (unmountFn) {
                unmountFn();
            }
        };
    }, [shouldObserve].concat(_toConsumableArray(deps)));

    // Compoent Unmounted callback
    (0, _react.useEffect)(function () {
        return function () {
            dlog('Component Demounting , running cleanup for scroll object :', observer.current);
            // fastdom.clear(fastdomId.current)
            // tear doen remove listener from linked list
            if (observer.current) {
                observer.current = ElementScrollListener.removeEventListener(observer.current);
            }
        };
    }, []);
}

},{"../EventListenerList":75,"../GeneralUtils":77,"fastdom":634,"lodash":860,"react":1107,"shortid":1163}],110:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _BasePlayer2 = require('./BasePlayer');

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PlayerEvents = require('./PlayerEvents');

var _PlayerEvents2 = _interopRequireDefault(_PlayerEvents);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _polyfill = require('../scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var roundSeconds = function roundSeconds(sec) {
    return Math.ceil(sec * 1000);
};

var initError = new Error('call initialize() first to instantiate the player and set up reliably');
var emptyFunc = function emptyFunc() {};

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
        msg[_key] = arguments[_key];
    }

    return DEBUG && (_console = console).log.apply(_console, ['log:'].concat(msg));
};

var CustomPlayerEvents = (0, _keymirror2.default)({
    DURATION_FIRED: null,
    ERROR: null
});

/**
 * React Specific implementation , which  hypothetically supports all sources
 * So far the implementation only uses the file implementation of React player
 * Tha react player is also specified the same way to keep things consistent
 * It also reduced the import size
 *
 *
 *
 *
 * @export
 * @class AllSourcePlayer
 * @extends {BasePlayer}
 */

var AllSourcePlayer = function (_BasePlayer) {
    _inherits(AllSourcePlayer, _BasePlayer);

    _createClass(AllSourcePlayer, null, [{
        key: 'canPlay',

        /**
         *
         *
         * @static
         * @param {string} url
         * @return {boolean}
         * @memberof AllSourcePlayer
         */
        value: function canPlay(url) {
            return _reactPlayer2.default.canPlay(url);
        }

        /**
         * Creates an instance of AllSourcePlayer.
         *
         * @param {Element} videoContainerEl
         * @param {string} url
         * @param {Object} metaData
         * @memberof AllSourcePlayer
         */

    }]);

    function AllSourcePlayer(videoContainerEl, url) {
        var metaData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, AllSourcePlayer);

        var _this = _possibleConstructorReturn(this, (AllSourcePlayer.__proto__ || Object.getPrototypeOf(AllSourcePlayer)).call(this, videoContainerEl, url, metaData));

        _initialiseProps.call(_this);

        _this.uniquePlayerId = _shortid2.default.generate();

        _this.metaData = metaData;

        var mediaPlayerRef = _react2.default.createRef();

        _this.mediaPlayerRef = mediaPlayerRef;

        var ev = new _events2.default();

        _this.eventListener = ev;

        _this.eventHandlers = [];

        _this.videoContainerEl = videoContainerEl;

        _this.onFirstLoad = false;

        _this.fullVideoDuration = null;

        _this.__initialized = false;

        _this.playing = false;

        _this.loop = false;

        _this.speed = 1;

        _this.volume = 1;

        _this.currentPlayerTime = null;

        _this.sourceUrl = url;

        _this.buffering = false;

        _this.attributesForFilePlayer = {
            //  -- common across all the implementation
            /**
             *
             *
             * @param {import('react').SyntheticEvent} ev
             */
            onRateChange: function onRateChange(ev) {
                if (_this.checkShouldFallBackToNative()) {
                    dlog('fired playback rate change from Video Element', ev);
                    _this.eventListener.emit(_PlayerEvents2.default.PLAYBACK_RATE_CHANGED);
                }
            },

            onSeeked: function onSeeked(ev) {
                if (_this.checkShouldFallBackToNative()) {
                    dlog('fired on seeked from Video Element', ev);
                    _this.__onSeeked(ev);
                }
            },
            /**
             *
             *
             * @param {import('react').SyntheticEvent} ev
             */
            onSeeking: function onSeeking(ev) {
                if (_this.checkShouldFallBackToNative()) {
                    dlog('fired on seeking from Video Element', ev);
                    _this.onSeeking();
                }
            },

            /**
             * The onProgress fires when browser loads a resources
             * this means it can be used for relaibly querying insde the browser buffer status
             *
             *
             * @param {import('react').SyntheticEvent} ev
             */
            onProgress: function onProgress(ev) {
                if (_this.checkShouldFallBackToNative()) {
                    dlog('fired onProgress from Video Element', ev, _this.metaData);
                    _this.__handleVideoElementBufferedRanges();
                }
            }

            // /**
            //  * The timeupdate event is fired when the time indicated by the currentTime attribute has been updated.
            //  * Constly method should not be used unless necessary
            //  *
            //  *
            //  * @param {import('react').SyntheticEvent} ev
            //  */
            // onTimeUpdate : (ev) => {
            //     dlog(`fired onTimeupdate from Video Element` , ev)
            // }
        };

        _this.config = {
            file: {
                dashVersion: '2.9.2',
                forceVideo: true,
                attributes: _this.attributesForFilePlayer
            }
        };
        _this.currentPlayerTime = { loadedSeconds: 0, played: 0, playedSeconds: 0, loaded: 0 };

        _this.canPlay = _reactPlayer2.default.canPlay(_this.sourceUrl);

        dlog('Inspecting play this content : ' + _this.canPlay + ' !! : url : ' + _this.sourceUrl);

        /// Doing a last attempt at it
        return _this;
    }

    /**
     * Checks whether a dashPlayer Exist , if it does , we will not use native events at all
     *
     * @memberof AllSourcePlayer
     */

    /**
     * Used for looping and syncing media ,
     * Can also be used for firing onSeeked -> Since Seek success does fire this one
     *
     * Can also be used for buffer possibly -> Not in API Spec
     *
     * @param {*} data
     * @memberof AllSourcePlayer
     */

    // Attached by player when seek is completed -> onSeeked eqivalent


    // fired when waiting evennt is fired


    // This is called when playing is active ,
    // Might not fire if not playing --- we need to clear buffering reliably


    // Happens when unsynced play and pause hits together and play is interrupted by pause


    // Attached with play request event


    // Atctached with pause


    /**
     * Used for handling playback errors.
     * Under new Chrome DOM spec , play pause are async
     * i.e Video Player Must wait to get the Play Event resolved before doing a pause
     * The legacy core player controller , does lot of play pause with no respect for this new API standard
     * so it leads to error , which might lead to bad calls
     *
     * This often stops the playback itself. Strangely this is more prevanlent with newer Dash
     * and definitely with file system files 😢
     *
     * Future solution - Play - Pause being async on Core Player End
     *
     * @memberof AllSourcePlayer
     */

    _createClass(AllSourcePlayer, [{
        key: '__handleDashAttach',

        /**
         * This is responsible for handling Dash specific buffers and events
         *
         * @memberof AllSourcePlayer
         */
        value: function __handleDashAttach() {
            this.dashPlayer = this.playerInstance.getInternalPlayer('dash');
            // Drop down to dash EVENTS -- Will be used when content is dash
            this.__handleDashEvents(_PlayerEvents2.default.BUFFER_EMPTY);
            this.__handleDashEvents(_PlayerEvents2.default.BUFFER_LOADED);
            this.__handleDashEvents(_PlayerEvents2.default.PLAYBACK_SEEKING);
            this.__handleDashEvents(_PlayerEvents2.default.PLAYBACK_SEEKED);
        }
    }, {
        key: '__handleDashEvents',
        value: function __handleDashEvents(event) {
            var _this2 = this;

            if (!!this.dashPlayer) {
                dlog('Using Dash Fallbacks for buffer and seeked ---');

                if (event === _PlayerEvents2.default.BUFFER_EMPTY) {
                    this.dashPlayer.on(dashjs.MediaPlayer.events['BUFFER_EMPTY'], function () {
                        dlog('dashJs -- buffering started');
                        _this2.onBuffer();
                    });
                    return;
                }

                if (event === _PlayerEvents2.default.BUFFER_LOADED) {
                    this.dashPlayer.on(dashjs.MediaPlayer.events['BUFFER_LOADED'], function () {
                        dlog('dashJs -- buffering complete');
                        _this2.onBuffered();
                    });
                    return;
                }

                if (event === _PlayerEvents2.default.CAN_PLAY) {
                    this.dashPlayer.on(dashjs.MediaPlayer.events['CAN_PLAY'], function () {
                        dlog('dashJs -- can play');
                        _this2.eventListener.emit(_PlayerEvents2.default.CAN_PLAY);
                    });
                    return;
                }

                if (event === _PlayerEvents2.default.PLAYBACK_SEEKING) {
                    this.dashPlayer.on(dashjs.MediaPlayer.events['PLAYBACK_SEEKING'], function () {
                        dlog('dashJs -- playback seeking');
                        _this2.eventListener.emit(_PlayerEvents2.default.PLAYBACK_SEEKING);
                    });
                    return;
                }

                if (event === _PlayerEvents2.default.PLAYBACK_SEEKED) {
                    this.dashPlayer.on(dashjs.MediaPlayer.events['PLAYBACK_SEEKED'], function () {
                        dlog('dashJs --- seeking complete');
                        _this2.__onSeeked();
                    });
                    return;
                }
                //else if (event === PlayerEvents.PLAYBACK_RATE_CHANGED) {
                //     this._player.on(dashjs.MediaPlayer.events['PLAYBACK_RATE_CHANGED'], handler);
                // }
            }
        }
    }, {
        key: '__handleDashDetach',
        value: function __handleDashDetach() {
            if (!!this.dashPlayer) {
                this.dashPlayer = null;
            }
        }
    }, {
        key: '__handleVideoElementBufferedRanges',
        value: function __handleVideoElementBufferedRanges() {
            if (this.videoElement) {
                var bufferTimeRanges = this.videoElement.buffered;
                var seekableTimeRanges = this.videoElement.seekable;
                var currentTime = this.videoElement.currentTime;
                // detect buffering state
                if (seekableTimeRanges.length !== 0) {
                    var start = seekableTimeRanges.length !== 0 ? seekableTimeRanges.start(seekableTimeRanges.length - 1) : 0;
                    var end = seekableTimeRanges.length !== 0 ? seekableTimeRanges.end(seekableTimeRanges.length - 1) : 0;

                    var bstart = bufferTimeRanges.length !== 0 ? bufferTimeRanges.start(bufferTimeRanges.length - 1) : 0;
                    var bend = bufferTimeRanges.length !== 0 ? bufferTimeRanges.end(bufferTimeRanges.length - 1) : 0;

                    dlog('time ranged', { start: start, end: end, currentTime: currentTime }, this.metaData);

                    if (start === end) {
                        return;
                    }

                    if (start <= currentTime && currentTime <= end) {
                        if (this.buffering) {
                            dlog('fired complete buffering from Video Element');
                            this.__onBuffered();
                            return;
                        }
                    }

                    if (bstart <= currentTime && currentTime <= bend) {
                        if (this.buffering) {
                            dlog('fired complete buffering from Video Element');
                            this.__onBuffered();
                            return;
                        }
                    }

                    if (this.videoElement.networkState === 'NETWORK_IDLE') {
                        if (this.buffering) {
                            dlog('fired complete buffering from Video Element');
                            this.__onBuffered();
                            return;
                        }
                    }

                    if (this.videoElement.networkState === 'NETWORK_LOADING') {
                        if (!this.buffering) {
                            dlog('fired buffering started');
                            this.onBuffer();
                            return;
                        }
                    }
                }
            }
        }

        /**
         * To wrap the Functional API into the Object oriented API we use
         *
         * @memberof AllSourcePlayer
         */

    }, {
        key: '__render',
        value: function __render() {
            _reactDom2.default.render(_react2.default.createElement(_reactPlayer2.default, {
                key: this.uniquePlayerId,
                ref: this.mediaPlayerRef,
                config: this.config,
                controls: false,
                height: '100%',
                width: '100%',
                onReady: this.onReady,
                onBuffer: this.onBuffer,
                onBufferEnd: this.onBuffered,
                onDuration: this.onDuration,
                onPlay: this.onPlay,
                onPause: this.onPause,
                playing: this.playing,
                playbackRate: this.speed,
                loop: this.loop,
                onStart: this.onStart,
                onSeek: this.onSeeking,
                onEnded: this.onEnded,
                onError: this.onError,
                volume: this.volume
                // progressInterval={100}
                , onProgress: this.onProgress,
                stopOnUnmount: true,
                url: this.sourceUrl
            }), this.videoContainerEl, this.__afterRender);
        }
    }, {
        key: 'changeUrl',
        value: function changeUrl(url) {
            var _this3 = this;

            this.pause();
            dlog('Change url ordered current url : ', this.sourceUrl, 'new url : ', url);
            (0, _polyfill.localMicrotask)(function () {
                _this3.onFirstLoad = false;
                _this3.sourceUrl = url;
                _this3.__render();
            });
        }
    }, {
        key: 'kill',
        value: function kill() {
            var _this4 = this;

            this.eventHandlers.forEach(function (_ref) {
                var event = _ref.event;

                _this4.eventListener.removeAllListeners(event);
            });

            this.eventHandlers = [];
            this.eventListener = null;

            this.__handleDashDetach();

            _reactDom2.default.unmountComponentAtNode(this.videoContainerEl);
        }

        /**
         *
         *
         * @param {PlayerEvents} event
         * @param {Function} handler
         * @memberof AllSourcePlayer
         */

    }, {
        key: 'on',
        value: function on(event, handler) {
            this.eventHandlers.push({
                event: event,
                handler: handler
            });
            this.eventListener.on(event, handler);
        }
    }, {
        key: 'setPlaybackRate',
        value: function setPlaybackRate(rate) {
            if (!this.__initialized) throw initError;
            this.speed = rate;
            this.__render();
        }
    }, {
        key: 'getPlaybackRate',
        value: function getPlaybackRate() {
            if (!this.__initialized) throw initError;

            if (this.videoElement) {
                if (this.videoElement.getPlaybackRate) {
                    dlog('Getting playback rate from Youtube ');
                    return this.videoElement.getPlaybackRat();
                }
                if (this.videoElement.playbackRate !== undefined) {
                    return this.videoElement.playbackRate;
                }
            }
            return this.speed;
        }
    }, {
        key: 'seek',
        value: async function seek(time) {
            if (!this.__initialized) throw initError;
            if (!this.playerInstance) return;

            var isLegalTime = !isNaN(time);
            if (isLegalTime) {
                dlog('Seek fired : ', time);
                this.playerInstance.seekTo(time, 'seconds');
            } else {
                dlog('Avoided seek bad timing : ', time);
            }
        }
    }, {
        key: 'play',
        value: function play() {
            if (!this.__initialized) throw initError;
            // if(!this.playing){
            this.playing = true;
            this.__render();
            // }
        }
    }, {
        key: 'pause',
        value: function pause() {
            if (!this.__initialized) throw initError;
            this.playing = false;
            this.__render();
        }
    }, {
        key: 'isPaused',
        value: function isPaused() {
            if (!this.__initialized) throw initError;
            if (!this.playerInstance) return !this.playing;
            var internalPlayer = this.playerInstance.getInternalPlayer();
            var paused = !this.playing;
            if (!!internalPlayer) {
                if (internalPlayer.paused !== undefined) {
                    paused = internalPlayer.paused;
                }
            }
            return paused;
        }
    }, {
        key: 'time',
        value: function time() {
            if (!this.__initialized) throw initError;
            if (this.playerInstance) {
                return this.playerInstance.getCurrentTime();
            } else {
                return this.currentPlayerTime.playedSeconds;
            }
        }
    }, {
        key: 'setVolume',
        value: function setVolume() {
            var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            if (number === this.volume) return;
            this.volume = number;
            this.__render();
        }

        /**
         * The loop works only on the entire duration of the media.
         * It doesn't respect the start and end time you define on a media.
         *
         * @param {boolean} loop
         * @memberof AllSourcePlayer
         */

    }, {
        key: 'setLoop',
        value: function setLoop() {
            var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.loop = loop;
        }
    }]);

    return AllSourcePlayer;
}(_BasePlayer3.default);

var _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.checkShouldFallBackToNative = function () {
        return !(_this5.dashPlayer || _this5.hlsPlayer);
    };

    this.checkForIncreasedBufferLoaded = function (_ref2) {
        var loadedSeconds = _ref2.loadedSeconds,
            loaded = _ref2.loaded;

        if (loaded && loadedSeconds) {
            if (loaded >= _this5.currentPlayerTime.loaded || loadedSeconds >= _this5.currentPlayerTime.loadedSeconds) {
                return true;
            }
        }
        return false;
    };

    this.onProgress = function (data) {
        dlog('onProgress fired :', data);
        if (_this5.checkForIncreasedBufferLoaded(data)) {
            if (_this5.buffering) {
                _this5.__onBuffered(data);
            }
        }

        // detect seeked successfull here
        // this.__onSeeked(data) // --- seek ends up firing op progress
        _this5.currentPlayerTime = data; // keeps updating everytime
    };

    this.onReady = function (instance) {
        if (!_this5.onFirstLoad) {
            _this5.playerInstance = instance;
            _this5.videoElement = _this5.playerInstance.getInternalPlayer();
            _this5.__handleDashAttach();
            dlog('on Ready fired : loaded first time , can play', instance);
            _this5.onFirstLoad = true;
            _this5.eventListener.emit(_PlayerEvents2.default.CAN_PLAY);
        } else {
            dlog('on Ready fired : loaded ');
            if (_this5.buffering) _this5.__onBuffered();
            // onReady is attached to canPlay -- ideally should fire ??
            // if not we have several fallbacks at play
        }
    };

    this.onSeeking = function () {
        _this5.__onSeeked.apply(_this5, arguments); // onseek should fire the Seeked
    };

    this.onBuffer = function (event) {
        dlog('buffer request fired :', event);
        _this5.buffering = true;
        _this5.eventListener.emit(_PlayerEvents2.default.BUFFER_EMPTY);
    };

    this.onBuffered = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        dlog.apply(undefined, ['buffering done fired: '].concat(args));
        _this5.__onBuffered.apply(_this5, args);
    };

    this.onError = function () {
        var _eventListener;

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        dlog.apply(undefined, ['error fired , possible failure in video playback '].concat(args));
        (_eventListener = _this5.eventListener).emit.apply(_eventListener, [CustomPlayerEvents.ERROR].concat(args));
        _this5.onErrorHandle();
    };

    this.__onSeeked = function (ev) {
        dlog('seek end Notified --', ev);
        _this5.eventListener.emit(_PlayerEvents2.default.PLAYBACK_SEEKED);
    };

    this.__onBuffered = function (ev) {
        _this5.buffering = false;
        dlog('buffer end Notified --');
        _this5.eventListener.emit(_PlayerEvents2.default.BUFFER_LOADED);
    };

    this.onPlay = function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        dlog.apply(undefined, ['onPlay fired :'].concat(args));
    };

    this.onPause = function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        dlog.apply(undefined, ['onPause fired :'].concat(args));
    };

    this.onStart = function () {
        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        dlog.apply(undefined, ['First time video started : onStart fired'].concat(args));
    };

    this.onEnded = function () {
        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        dlog.apply(undefined, ['Playback end reached '].concat(args));
    };

    this.onDuration = function (duration) {
        dlog('onDuration fired :');
        _this5.fullVideoDuration = duration;
        _this5.eventListener.emit(CustomPlayerEvents.DURATION_FIRED, { duration: duration });
    };

    this.onErrorHandle = function () {
        // Will playback on if playing was going on
        // In case of buffer respective events for same would fire and should stop the main
        if (_this5.playing) {
            _this5.__render();
        }
    };

    this.initialize = function () {
        _this5.__initialized = true;
        _this5.__render();
    };

    this.onErrorListener = function () {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunc;

        _this5.eventHandlers.push({
            event: CustomPlayerEvents.ERROR,
            handler: callback
        });
        _this5.eventListener.once(CustomPlayerEvents.ERROR, callback);
    };

    this.onDurationListener = function () {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunc;

        _this5.eventHandlers.push({
            event: CustomPlayerEvents.DURATION_FIRED,
            handler: callback
        });
        _this5.eventListener.once(CustomPlayerEvents.DURATION_FIRED, callback);
    };

    this.afterRenderListener = function () {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunc;

        _this5.afterRenderCallback = callback;
    };

    this.__afterRender = function () {
        dlog('Render finished for Video Element , ready for interaction');
        if (_this5.afterRenderCallback) {
            _this5.afterRenderCallback(_this5);
        }
    };
};

exports.default = AllSourcePlayer;

},{"../scheduler/polyfill":126,"./BasePlayer":111,"./PlayerEvents":113,"events":629,"keymirror":677,"react":1107,"react-dom":1016,"react-player":1047,"shortid":1163}],111:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _tracing = require("scheduler/tracing");

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var unImplementedError = new Error("Unimplemented");

var BasePlayer = function () {
    function BasePlayer() {
        _classCallCheck(this, BasePlayer);
    }

    _createClass(BasePlayer, [{
        key: "initialize",
        value: function initialize() {
            // For derived implementation that does lazy initialization
        }
    }, {
        key: "kill",
        value: function kill() {
            throw unImplementedError;
        }
    }, {
        key: "on",
        value: function on(event, handler) {
            throw unImplementedError;
        }
    }, {
        key: "setPlaybackRate",
        value: function setPlaybackRate(rate) {
            throw unImplementedError;
        }
    }, {
        key: "getPlaybackRate",
        value: function getPlaybackRate() {
            throw unImplementedError;
        }
    }, {
        key: "seek",
        value: function seek(time) {
            throw unImplementedError;
        }
    }, {
        key: "play",
        value: function play() {
            throw unImplementedError;
        }
    }, {
        key: "pause",
        value: function pause() {
            throw unImplementedError;
        }
    }, {
        key: "isPaused",
        value: function isPaused() {
            throw unImplementedError;
        }
    }, {
        key: "time",
        value: function time() {
            throw unImplementedError;
        }
    }, {
        key: "setVolume",
        value: function setVolume() {
            var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            throw unImplementedError;
        }
    }]);

    return BasePlayer;
}();

exports.default = BasePlayer;

},{"scheduler/tracing":1162}],112:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _BasePlayer2 = require('./BasePlayer');

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

var _PlayerEvents = require('./PlayerEvents');

var _PlayerEvents2 = _interopRequireDefault(_PlayerEvents);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var DashJSPlayer = function (_BasePlayer) {
    _inherits(DashJSPlayer, _BasePlayer);

    /**
     * Creates an instance of DashJSPlayer.
     * @param {Element} videoElContainer
     * @param {string} dashUrl
     * @memberof DashJSPlayer
     */
    function DashJSPlayer(videoElContainer, dashUrl) {
        _classCallCheck(this, DashJSPlayer);

        var _this = _possibleConstructorReturn(this, (DashJSPlayer.__proto__ || Object.getPrototypeOf(DashJSPlayer)).call(this, videoElContainer, dashUrl));

        var player = dashjs.MediaPlayer().create();
        // player.getDebug().setLogToBrowserConsole(false);

        var videoEl = document.createElement('video');

        videoEl.style.height = "100%";
        videoEl.style.width = "100%";

        player.initialize(videoEl, dashUrl, false);

        player.setConfig({
            'debug': {
                // 'logLevel': dashjs.Debug.LOG_LEVEL_DEBUG
                'logLevel': dashjs.Debug.LOG_LEVEL_NONE

            }
        });

        videoElContainer.appendChild(videoEl);

        _this._player = player;

        _this.videoEl = videoEl;

        return _this;
    }

    _createClass(DashJSPlayer, [{
        key: 'kill',
        value: function kill() {
            this._player.reset();
            this._player = null;
        }
    }, {
        key: 'on',
        value: function on(event, handler) {
            if (event === _PlayerEvents2.default.BUFFER_EMPTY) {
                this._player.on(dashjs.MediaPlayer.events['BUFFER_EMPTY'], handler);
            } else if (event === _PlayerEvents2.default.BUFFER_LOADED) {
                this._player.on(dashjs.MediaPlayer.events['BUFFER_LOADED'], handler);
            } else if (event === _PlayerEvents2.default.CAN_PLAY) {
                this._player.on(dashjs.MediaPlayer.events['CAN_PLAY'], handler);
            } else if (event === _PlayerEvents2.default.PLAYBACK_SEEKING) {
                this._player.on(dashjs.MediaPlayer.events['PLAYBACK_SEEKING'], handler);
            } else if (event === _PlayerEvents2.default.PLAYBACK_SEEKED) {
                this._player.on(dashjs.MediaPlayer.events['PLAYBACK_SEEKED'], handler);
            } else if (event === _PlayerEvents2.default.PLAYBACK_RATE_CHANGED) {
                this._player.on(dashjs.MediaPlayer.events['PLAYBACK_RATE_CHANGED'], handler);
            } else {
                throw new Error('Unknown player event ' + event);
            }
        }
    }, {
        key: 'setPlaybackRate',
        value: function setPlaybackRate(rate) {
            this._player.setPlaybackRate(rate);
        }
    }, {
        key: 'getPlaybackRate',
        value: function getPlaybackRate() {
            return this._player.getPlaybackRate();
        }
    }, {
        key: 'seek',
        value: function seek(time) {
            this._player.seek(time);
        }
    }, {
        key: 'play',
        value: function play() {
            this._player.play();
        }
    }, {
        key: 'pause',
        value: function pause() {
            this._player.pause();
        }
    }, {
        key: 'isPaused',
        value: function isPaused() {
            return this._player.isPaused();
        }
    }, {
        key: 'time',
        value: function time() {
            return this._player.time();
        }
    }, {
        key: 'setVolume',
        value: function setVolume() {
            var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            try {
                this._player.setVolume(number);
            } catch (err) {
                dlog('volume setup error dashJs , trying with native element:', err);
                this.videoEl.volume = number;
            }
        }
    }]);

    return DashJSPlayer;
}(_BasePlayer3.default);

exports.default = DashJSPlayer;

},{"./BasePlayer":111,"./PlayerEvents":113}],113:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var PlayerEvents = (0, _keymirror2.default)({
    BUFFER_EMPTY: null,
    BUFFER_LOADED: null,
    CAN_PLAY: null,
    PLAYBACK_SEEKING: null,
    PLAYBACK_SEEKED: null,
    PLAYBACK_RATE_CHANGED: null
});

exports.default = PlayerEvents;

},{"keymirror":677}],114:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SupportedMediaType = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _file = require('react-player/file');

var _file2 = _interopRequireDefault(_file);

var _BasePlayer = require('./BasePlayer');

var _BasePlayer2 = _interopRequireDefault(_BasePlayer);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _AllSourcePlayer = require('./AllSourcePlayer');

var _AllSourcePlayer2 = _interopRequireDefault(_AllSourcePlayer);

var _DashJSPlayer = require('./DashJSPlayer');

var _DashJSPlayer2 = _interopRequireDefault(_DashJSPlayer);

var _UploadNotification = require('../../../edit/components/notificationSystem/UploadNotification.react');

var _polyfill = require('../scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var roundSeconds = function roundSeconds(sec) {
    return Math.ceil(sec * 1000);
};

var initError = new Error('call initialize() first to instantiate the player and set up reliably');
var emptyFunc = function emptyFunc() {};

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
        msg[_key] = arguments[_key];
    }

    return DEBUG && (_console = console).log.apply(_console, ['log:'].concat(msg));
};

var CustomPlayerEvents = (0, _keymirror2.default)({
    DURATION_FIRED: null,
    ERROR: null
});

var UnsupportedMediaList = ['video/quicktime'];

var SupportedMediaType = exports.SupportedMediaType = (0, _keymirror2.default)({
    video: null,
    image: null
});

var BuildAllSourcePlayerRegistry = function () {
    function BuildAllSourcePlayerRegistry() {
        _classCallCheck(this, BuildAllSourcePlayerRegistry);

        // keeps meta info respective to links that has been already processed
        this.videoInstancesData = {};
        this.fileNameToUrl = {};

        this.snapTimeout = 4000;
    }

    /**
     *
     *
     * @param {Element} videoContainerEl
     * @param {string} url
     * @return {BasePlayer}
     * @memberof BuildAllSourcePlayerRegistry
     */

    _createClass(BuildAllSourcePlayerRegistry, [{
        key: 'createNewInstance',
        value: function createNewInstance(videoContainerEl, url, metaData) {
            var useOldPlayer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            if (useOldPlayer) return new _DashJSPlayer2.default(videoContainerEl, url);
            var temp = new _AllSourcePlayer2.default(videoContainerEl, url, metaData);
            temp.initialize();
            return temp;
        }
    }, {
        key: 'canPlay',
        value: function canPlay(url) {
            return _file2.default.canPlay(url);
        }

        /**
         *
         * Adds meta data information
         * cross checkes with Name to verify or rewrite the existing data completely
         *
         * @param {string} [url=""]
         * @param {Object} [data={}]
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: '_addMetaInformationForUrl',
        value: function _addMetaInformationForUrl() {
            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (!!data.fileName) {
                var existingFileUrl = this.fileNameToUrl[data.fileName];
                if (!!existingFileUrl && !!data.lastModified) {
                    var earlierData = this.videoInstancesData[existingFileUrl];
                    if (earlierData.lastModified >= data.lastModified) {
                        return;
                    } else {
                        URL.revokeObjectURL(earlierData.url); // clearing stale data pointers to the file
                        delete this.fileNameToUrl[data.fileName];
                        delete this.videoInstancesData[existingFileUrl];
                    }
                }
            }

            this.videoInstancesData[url] = data;
            this.fileNameToUrl[data.fileName] = data.url;
            dlog('added new video/image to registry :' + url + '  data : ', data);
        }

        /**
         *
         * Takes in either file url or
         *
         *
         * @param {string} [url=""]
         * @return {{ width : number ,
         *            height : number ,
         *            url : string ,
         *            duration : number ,
         *            fileName : string ,
         *            lastModified : number ,
         *            thumbnail : string } | null}
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: 'getVideoMetaDataByUrl',
        value: function getVideoMetaDataByUrl() {
            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return this.videoInstancesData[url];
        }

        /**
         *
         *
         * @param {string} [name=""]
         * @return {{ width : number ,
         *            height : number ,
         *            url : string ,
         *            duration : number ,
         *            fileName : string ,
         *            lastModified : number ,
         *            thumbnail : string } | null}
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: 'getMetadataByName',
        value: function getMetadataByName() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var fileUrl = this.fileNameToUrl[name];
            if (!!fileUrl) {
                return this.videoInstancesData[fileUrl];
            }
            dlog('no such file exist , where did it go ?? !!');
            return null;
        }
    }, {
        key: 'probeImageMetadata',
        value: function probeImageMetadata(url, _ref, callback, errorCallback) {
            var fileName = _ref.fileName,
                lastModified = _ref.lastModified;

            var _this = this;

            var image = new Image();
            var canvas = document.createElement('canvas');
            image.onerror = function () {
                // no idea why would this trigger possibly should be logged in sentry about this one
                errorCallback(new Error('failed to grab image metadata or snapshot'), null);
                image.onload = null;
                image.onerror = null;
                image.src = '';
            };

            image.onload = function () {
                var height = image.naturalHeight;
                var width = image.naturalWidth;

                var ar = height / width;

                var MAX_EDGE = 240;
                var canvasWidth = MAX_EDGE;
                var canvasHeight = MAX_EDGE * ar;

                canvas.width = canvasWidth;
                canvas.height = canvasHeight;

                canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);

                canvas.toBlob(function (blob) {
                    var metadata = {
                        height: height,
                        width: width,
                        url: url,
                        fileName: fileName,
                        lastModified: lastModified,
                        duration: 0,
                        thumbnail: URL.createObjectURL(blob),
                        mediaType: SupportedMediaType.image,
                        thumbnailBlob: blob
                    };

                    dlog('metadata grabbed for ' + fileName + ' url: ' + url, metadata);
                    _this._addMetaInformationForUrl(url, metadata);
                    callback(null, metadata);

                    image.onload = null;
                    image.onerror = null;
                    image.src = null;
                });
            };

            image.src = url;
        }
    }, {
        key: 'probeVideoMetadata',
        value: function probeVideoMetadata(url, _ref2, callback, errorCallback) {
            var fileName = _ref2.fileName,
                lastModified = _ref2.lastModified,
                poorSupport = _ref2.poorSupport;

            var _this2 = this,
                _arguments = arguments;

            var video = document.createElement('video');

            var imageIsAlreadySnapped = false;

            var snappingImageP = Promise.resolve();

            var timeupdate = function timeupdate() {
                snappingImageP = snappingImageP.then(function () {
                    return !imageIsAlreadySnapped && snapImage().then(function (success) {
                        if (success) {
                            video.removeEventListener('timeupdate', timeupdate);
                            video.pause();
                        }
                    });
                }).catch(function (err) {
                    if (video) {
                        video.removeEventListener('timeupdate', timeupdate);
                        video.pause();
                    }
                });
            };

            var loadedData = function loadedData() {
                snappingImageP = snappingImageP.then(function () {
                    return snapImage().then(function (success) {
                        if (success) {
                            video.removeEventListener('timeupdate', timeupdate);
                        }
                    });
                }).catch(function (err) {
                    if (video) {
                        video.removeEventListener('timeupdate', timeupdate);
                    }
                });
            };

            video.addEventListener('loadeddata', loadedData);

            var onError = function onError(error) {
                clearTimeout(timeout);

                dlog('video error fired , removing all resources for :' + fileName + ' url: ' + url, error);
                video.removeEventListener('timeupdate', timeupdate);
                video.removeEventListener('loadeddata', loadedData);
                video.removeAttribute('src');
                video.pause();
                // unset src
                // video.load() // resets everything
                if (!_this2.videoInstancesData[url]) {
                    errorCallback(url);
                }
                callback(error, null);
            };

            var timeout = setTimeout(function () {
                dlog('Timeout called', { imageIsAlreadySnapped: imageIsAlreadySnapped });
                if (!imageIsAlreadySnapped) {
                    onError(new Error('Video Snap took long time , possibly older format of video used'));
                }
            }, 4000);

            var snapImage = function snapImage() {
                return Promise.resolve(function () {
                    clearTimeout(timeout);
                    // we know play and all event has fired so no timeout needed
                    imageIsAlreadySnapped = true;

                    dlog('Snap Image fired', _arguments);

                    var canvas = document.createElement('canvas');

                    dlog('Video dimensions and other stuff', {
                        height: video.videoHeight,
                        width: video.videoWidth,
                        video: video
                    });

                    // Crafting defaults
                    var videoHeight = video.videoHeight;
                    var videoWidth = video.videoWidth;
                    // FALL BACK VALUES -- HOPE FULL THEY WORK
                    if (!videoHeight) videoHeight = 1080;
                    if (!videoWidth) videoWidth = 1920;

                    // if (!video.videoHeight) {
                    //     return
                    // }

                    // by now duration should be available
                    var ar = videoWidth / videoHeight;

                    var MAX_EDGE = 240;
                    var canvasWidth = Math.min(MAX_EDGE, ar * MAX_EDGE);
                    var canvasHeight = Math.min(MAX_EDGE, MAX_EDGE / ar);

                    canvas.width = canvasWidth;
                    canvas.height = canvasHeight;

                    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

                    // TODO - change to Blobs url i.e asynchrnouse
                    return new Promise(function (resolve, reject) {
                        try {
                            canvas.toBlob(function (blob) {
                                dlog('Blob capture fired', blob);

                                var image = blob;

                                var imageUrl = URL.createObjectURL(blob);

                                var success = image.size > 100;

                                var duration = Math.floor(video.duration * 1000) || 4000; // fail safe incase things go wrong

                                var videoMetaData = {
                                    height: videoHeight,
                                    width: videoWidth,
                                    url: url,
                                    duration: duration,
                                    fileName: fileName,
                                    lastModified: lastModified,
                                    thumbnail: imageUrl,
                                    thumbnailBlob: blob,
                                    mediaType: SupportedMediaType.video,
                                    canPlay: !poorSupport
                                };
                                dlog('metadata grabbed for ' + fileName + ' url: ' + url, videoMetaData);
                                _this2._addMetaInformationForUrl(url, videoMetaData);
                                try {
                                    if (success) {
                                        callback(null, videoMetaData);
                                        // URL.revokeObjectURL(url) // no more needed for nor
                                    } else {
                                        callback(new Error('image could not be created from video file : ' + url), null);
                                    }
                                } catch (err) {
                                    dlog('failed to call callback for metadat :', err);
                                }

                                video.removeEventListener('timeupdate', timeupdate);
                                video.removeEventListener('loadeddata', loadedData);
                                video.removeAttribute('src');
                                video.load();

                                resolve(success);
                            });
                        } catch (err) {
                            dlog('Something went wrong when capturing Canvas data :', err);
                            reject();
                            callback(new Error('image could not be created from video file : ' + url), null);
                        }
                    });
                }()).catch(function (err) {
                    clearTimeout(timeout);
                    imageIsAlreadySnapped = true;
                    // we know play and all event has fired so no timeout needed
                    callback(new Error('Failed at snaping image issue : ' + err), null);
                });
            };

            video.onerror = onError;

            video.addEventListener('timeupdate', timeupdate);
            video.preload = 'metadata';
            video.src = url;
            // Load video in Safari / IE11
            video.muted = true;
            video.playsInline = true;
            video.play();
        }

        /**
         *
         *
         * @param {*} {fileName , lastModified , url}
         * @param {*} callback
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: 'probeUserHostedVideo',
        value: function probeUserHostedVideo(_ref3, callback) {
            var fileName = _ref3.fileName,
                lastModified = _ref3.lastModified,
                url = _ref3.url;

            this.probeVideoMetadata(url, { fileName: fileName, lastModified: lastModified }, callback, function () {
                dlog('Could not get metadata for hosted url :  ' + url);
            });
        }

        /**
         *
         * Useful for probing user space videos that come from specified link or user uploaded files
         * the user uploaded files can also be converted to link and stashed away
         *
         *
         * @param {File} file
         * @param {Function} callback
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: 'probeUserLandVideo',
        value: function probeUserLandVideo(file, callback) {
            dlog('File send for Probing :', file);

            var url = URL.createObjectURL(file);
            var meta = this.getMetadataByName(file.name);

            var fileType = file.type;

            var poorSupport = false;

            if (UnsupportedMediaList.includes(fileType)) {
                (0, _UploadNotification.dispatchUploadFailureNotification)({
                    message: 'Please wait for the QuickTime MOV file to be processed before you preview or edit the file',
                    title: 'Processing QuickTime MOV',
                    id: _UploadNotification.UploadNotficationIds.POOR_MEDIA_PLAYBACK_SUPPORT,
                    duration: Infinity
                });

                poorSupport = true;
            }

            if (!!meta) {
                dlog('used cached data for :' + file.name);
                return callback(null, meta);
            }

            this.probeVideoMetadata(url, { fileName: file.name, lastModified: file.lastModified, poorSupport: poorSupport }, callback, function () {
                dlog('Revoked url ' + url + ', because the metadata was never generated');
                URL.revokeObjectURL(url);
            });
        }

        /**
         *
         *
         * @param {File} file
         * @param {Function} callback
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: 'probeUserLandImage',
        value: function probeUserLandImage(file, callback) {
            var url = URL.createObjectURL(file);
            var meta = this.getMetadataByName(file.name);

            if (!!meta) {
                dlog('used cached data for :' + file.name);
                return callback(null, meta);
            }

            this.probeImageMetadata(url, { fileName: file.name, lastModified: file.lastModified }, callback, function () {
                dlog('Revoking url :' + url + ' because the metaata was never generated');
                URL.revokeObjectURL(url);
            });
        }

        /**
         *
         *
         * @param {*} {canPlay = true,isOffline = false, isUserSpace = false,userSpaceUrl ='', dashUrl = ''}
         * @return {[string , boolean]}
         * @memberof BuildAllSourcePlayerRegistry
         */

    }, {
        key: 'identifySource',
        value: function identifySource(_ref4) {
            var _ref4$canPlay = _ref4.canPlay,
                canPlay = _ref4$canPlay === undefined ? true : _ref4$canPlay,
                _ref4$isOffline = _ref4.isOffline,
                isOffline = _ref4$isOffline === undefined ? false : _ref4$isOffline,
                _ref4$isUserSpace = _ref4.isUserSpace,
                isUserSpace = _ref4$isUserSpace === undefined ? false : _ref4$isUserSpace,
                _ref4$userSpaceUrl = _ref4.userSpaceUrl,
                userSpaceUrl = _ref4$userSpaceUrl === undefined ? '' : _ref4$userSpaceUrl,
                _ref4$systemSpaceUrl = _ref4.systemSpaceUrl,
                systemSpaceUrl = _ref4$systemSpaceUrl === undefined ? '' : _ref4$systemSpaceUrl;

            if (canPlay) {
                if (isOffline || isUserSpace) return [userSpaceUrl, false];
                return [systemSpaceUrl, true];
            }
            throw new Error('Media cannot be played.');
        }
    }]);

    return BuildAllSourcePlayerRegistry;
}();

var AllSourcePlayerRegistry = new BuildAllSourcePlayerRegistry();

exports.default = AllSourcePlayerRegistry;

if (DEBUG) {
    window.AllSourcePlayerRegistry = AllSourcePlayerRegistry;
}

},{"../../../edit/components/notificationSystem/UploadNotification.react":195,"../scheduler/polyfill":126,"./AllSourcePlayer":110,"./BasePlayer":111,"./DashJSPlayer":112,"keymirror":677,"react-player/file":1043}],115:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _bodymovin = require('bodymovin');

var _bodymovin2 = _interopRequireDefault(_bodymovin);

var _cloneextend = require('cloneextend');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var BodyMovinLayerInfo = function () {
    function BodyMovinLayerInfo(l) {
        _classCallCheck(this, BodyMovinLayerInfo);

        this.layer = l;

        var aData = {
            wrapper: document.createElement('div'),
            animType: 'svg',
            loop: false,
            prerender: true,
            autoplay: false,
            animationData: (0, _cloneextend.clone)(this.layer.meta.animationData)
        };

        this.anim = _bodymovin2.default.loadAnimation(aData);

        this.time = null;

        this.width = 1;
        this.height = 1;

        this.computedStatic = false;
        this.computedStaticValues = {};
    }

    _createClass(BodyMovinLayerInfo, [{
        key: 'updateTimeValues',
        value: function updateTimeValues(time) {
            this.time = time;
        }
    }, {
        key: 'updateLayerSize',
        value: function updateLayerSize(width, height) {
            this.width = width;
            this.height = height;
        }
    }, {
        key: 'updateCurrentTime',
        value: function updateCurrentTime(currentTime) {
            if (this.time === null) {
                return;
            }

            if (this.currentTime === currentTime) {
                return;
            }

            this.currentTime = currentTime;

            var _time = this.time,
                enterstart = _time.enterstart,
                enterdone = _time.enterdone,
                exitstart = _time.exitstart,
                exitdone = _time.exitdone;
            var _layer$meta = this.layer.meta,
                animationData = _layer$meta.animationData,
                _layer$meta$timeSlice = _layer$meta.timeSlice,
                timeSlice = _layer$meta$timeSlice === undefined ? "-1 -1" : _layer$meta$timeSlice,
                _layer$meta$outTimeSl = _layer$meta.outTimeSlice,
                outTimeSlice = _layer$meta$outTimeSl === undefined ? null : _layer$meta$outTimeSl,
                _layer$meta$mappings = _layer$meta.mappings,
                mappings = _layer$meta$mappings === undefined ? {} : _layer$meta$mappings;
            var compFrameRate = animationData.fr,
                compIp = animationData.ip,
                compOp = animationData.op;

            var _timeSlice$split$map = timeSlice.split(' ').map(toFloat),
                _timeSlice$split$map2 = _slicedToArray(_timeSlice$split$map, 2),
                tSliceStart = _timeSlice$split$map2[0],
                tSliceEnd = _timeSlice$split$map2[1];

            var animNumFrames = 0;
            var startFrame = -1,
                endFrame = -1;
            if (tSliceStart === -1 && tSliceEnd === -1) {
                startFrame = compIp;
                endFrame = compOp;
            } else {
                // NOTE : Assume both are positive values
                if (tSliceStart === -1 || tSliceEnd === -1) {
                    throw new Error('Case not supported');
                }
                startFrame = Math.floor(tSliceStart * compFrameRate / 1000);
                endFrame = Math.floor(tSliceEnd * compFrameRate / 1000);
            }

            animNumFrames = endFrame - startFrame;

            var seekFrame = 0;

            if (currentTime < enterstart) {
                seekFrame = startFrame;
            } else if (currentTime >= enterstart && currentTime < enterdone) {
                seekFrame = startFrame + Math.floor((currentTime - enterstart) / (enterdone - enterstart) * animNumFrames);
            } else if (currentTime >= enterdone && currentTime < exitstart) {
                seekFrame = endFrame;
            } else {

                // Exit

                if (!!outTimeSlice) {
                    var _outTimeSlice$split$m = outTimeSlice.split(' ').map(toFloat),
                        _outTimeSlice$split$m2 = _slicedToArray(_outTimeSlice$split$m, 2),
                        tOutSliceStart = _outTimeSlice$split$m2[0],
                        toOutSliceEnd = _outTimeSlice$split$m2[1];

                    var outStartFrame = Math.floor(tOutSliceStart * compFrameRate / 1000);
                    var outEndFrame = Math.floor(toOutSliceEnd * compFrameRate / 1000);

                    var outAnimNumFrames = outEndFrame - outStartFrame;

                    if (currentTime >= exitstart && currentTime < exitdone) {
                        seekFrame = outStartFrame + Math.floor((currentTime - exitstart) / (exitdone - exitstart) * outAnimNumFrames);
                    } else {
                        seekFrame = outEndFrame;
                    }
                } else {
                    if (currentTime >= exitstart && currentTime < exitdone) {
                        seekFrame = endFrame - Math.ceil((currentTime - exitstart) / (exitdone - exitstart) * animNumFrames);
                    } else {
                        seekFrame = startFrame;
                    }
                }
            }

            this.anim.goToAndStop(seekFrame, 1);
        }
    }, {
        key: 'doComputeStatic',
        value: function doComputeStatic() {
            var _this = this;

            var oldCurrentTime = this.currentTime;

            var _layer$meta2 = this.layer.meta,
                animationData = _layer$meta2.animationData,
                _layer$meta2$timeSlic = _layer$meta2.timeSlice,
                timeSlice = _layer$meta2$timeSlic === undefined ? "-1 -1" : _layer$meta2$timeSlic,
                _layer$meta2$reverseM = _layer$meta2.reverseMappings,
                reverseMappings = _layer$meta2$reverseM === undefined ? {} : _layer$meta2$reverseM;

            if (!!reverseMappings) {
                return;
            }

            var compFrameRate = animationData.fr,
                compOp = animationData.op;

            var _timeSlice$split$map3 = timeSlice.split(' ').map(toFloat),
                _timeSlice$split$map4 = _slicedToArray(_timeSlice$split$map3, 2),
                tSliceStart = _timeSlice$split$map4[0],
                tSliceEnd = _timeSlice$split$map4[1];

            var endFrame = 0;
            if (tSliceEnd === -1) {
                endFrame = compOp;
            } else {
                endFrame = Math.floor(tSliceEnd * compFrameRate / 1000);
            }

            this.anim.goToAndStop(endFrame, 1);

            Object.keys(reverseMappings).forEach(function (rmKey) {
                _this.computedStaticValues[rmKey] = _this.getReverseMappingValue(rmKey, false); // Don't pass true as 2nd argument
            });

            this.currentTime = -1; // Just to make sure updateCurrentTime works
            this.updateCurrentTime(oldCurrentTime);
        }
    }, {
        key: 'getReverseMappingValue',
        value: function getReverseMappingValue(rmKey) {
            var useStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (useStatic) {
                if (!this.computedStatic) {
                    this.doComputeStatic();
                    this.computedStatic = true;
                }
                return this.computedStaticValues[rmKey];
            }

            var _layer$meta3 = this.layer.meta,
                animationData = _layer$meta3.animationData,
                viewBox = _layer$meta3.viewBox,
                reverseMappings = _layer$meta3.reverseMappings;
            var width = this.width,
                height = this.height;
            var compWidth = animationData.w,
                compHeight = animationData.h;

            var _viewBox$split$map = viewBox.split(' ').map(toFloat),
                _viewBox$split$map2 = _slicedToArray(_viewBox$split$map, 4),
                vb_x = _viewBox$split$map2[0],
                vb_y = _viewBox$split$map2[1],
                vb_w = _viewBox$split$map2[2],
                vb_h = _viewBox$split$map2[3];

            var wrapperScaleX = width / vb_w,
                wrapperScaleY = height / vb_h;

            var _reverseMappings$rmKe = reverseMappings[rmKey],
                exp = _reverseMappings$rmKe.exp,
                _reverseMappings$rmKe2 = _reverseMappings$rmKe.type,
                type = _reverseMappings$rmKe2 === undefined ? null : _reverseMappings$rmKe2,
                _reverseMappings$rmKe3 = _reverseMappings$rmKe.scaleMode,
                scaleMode = _reverseMappings$rmKe3 === undefined ? null : _reverseMappings$rmKe3,
                _reverseMappings$rmKe4 = _reverseMappings$rmKe.offset,
                offset = _reverseMappings$rmKe4 === undefined ? 0 : _reverseMappings$rmKe4;

            var obj = this.anim.renderer;
            for (var i = 0; i < exp.length; i++) {
                obj = obj[exp[i]];
            }

            var value = obj;
            if (type === 'distance_x') {
                value = (toFloat(value) + offset - vb_x) * wrapperScaleX;
            } else if (type === 'distance_y') {
                value = (toFloat(value) + offset - vb_y) * wrapperScaleY;
            }
            return value;
        }
    }]);

    return BodyMovinLayerInfo;
}();

exports.default = BodyMovinLayerInfo;

var toFloat = function toFloat(v) {
    var defaultV = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (typeof v !== 'number') {
        v = parseFloat(v);
        if (isNaN(v) || !isFinite(v)) {
            v = defaultV;
        }
    }
    return v;
};

},{"bodymovin":390,"cloneextend":412}],116:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DefAttrDependencyGraph = function () {
    function DefAttrDependencyGraph() {
        _classCallCheck(this, DefAttrDependencyGraph);

        this.attrs = {}; // Holds all attr keys. Each attr node will hold refs to it's dependencies

        this.nonLiveResolveOrder = [];
        this.liveResolveOrder = [];

        this.needsUpdate = false; // Need to update l
    }

    _createClass(DefAttrDependencyGraph, [{
        key: "checkAndAddAttr",
        value: function checkAndAddAttr(attrKey, isLive) {
            var isKeyframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (!this.attrs.hasOwnProperty(attrKey)) {
                this.attrs[attrKey] = { outEdges: [], isLive: isLive, isKeyframe: isKeyframe, dependsOnLive: false };
                this.needsUpdate = true;
            }
        }
    }, {
        key: "addAttrDependencyLink",
        value: function addAttrDependencyLink(fromAttrKey, toAttrKey) {
            this.attrs[fromAttrKey].outEdges.push(toAttrKey);
            this.needsUpdate = true;
        }
    }, {
        key: "getResolveOrder",
        value: function getResolveOrder() {
            if (this.needsUpdate) {
                this._updateResolveOrder();

                this.needsUpdate = false;
            }
            // TODO -- confirm what this is ??
            return {
                nonLiveResolveOrder: this.nonLiveResolveOrder,
                liveResolveOrder: this.liveResolveOrder
            };
        }
    }, {
        key: "doesAttrKeyDependOnLive",
        value: function doesAttrKeyDependOnLive(attrKey) {
            try {
                if (this.needsUpdate) {
                    this._updateResolveOrder();

                    this.needsUpdate = false;
                }
                return !!(this.attrs[attrKey] || {}).dependsOnLive;
            } catch (e) {
                console.log(e);
                throw e;
            }
        }
    }, {
        key: "getKeyframesLiveDependency",
        value: function getKeyframesLiveDependency() {
            var _this = this;

            if (this.needsUpdate) {
                this._updateResolveOrder();

                this.needsUpdate = false;
            }
            var kf = Object.keys(this.attrs).find(function (k) {
                var _attrs$k = _this.attrs[k],
                    _attrs$k$isKeyframe = _attrs$k.isKeyframe,
                    isKeyframe = _attrs$k$isKeyframe === undefined ? false : _attrs$k$isKeyframe,
                    dependsOnLive = _attrs$k.dependsOnLive;

                return isKeyframe && dependsOnLive;
            });

            return !!kf;
        }
    }, {
        key: "_updateResolveOrder",
        value: function _updateResolveOrder() {
            var _this2 = this;

            var visitedNodes = {};
            var resolveOrder = [];
            Object.keys(this.attrs).forEach(function (attrKey) {
                _this2._prepareResolveOrderForAttr(attrKey, resolveOrder, visitedNodes);
            });

            this.nonLiveResolveOrder = resolveOrder.filter(function (ak) {
                return !_this2.attrs[ak].dependsOnLive;
            });
            this.liveResolveOrder = resolveOrder.filter(function (ak) {
                return !_this2.attrs[ak].dependsOnLive;
            });
        }
    }, {
        key: "_prepareResolveOrderForAttr",
        value: function _prepareResolveOrderForAttr(attrKey, resolveOrder, visitedNodes) {
            var _this3 = this;

            if (visitedNodes[attrKey]) {
                return;
            }
            var _attrs$attrKey = this.attrs[attrKey],
                depAttrKeys = _attrs$attrKey.outEdges,
                isLive = _attrs$attrKey.isLive;

            depAttrKeys.forEach(function (depAttrKey) {
                _this3._prepareResolveOrderForAttr(depAttrKey, resolveOrder, visitedNodes);
            });

            resolveOrder.push(attrKey);
            this.attrs[attrKey].dependsOnLive = isLive || !!depAttrKeys.find(function (k) {
                return _this3.attrs[k].dependsOnLive;
            });

            visitedNodes[attrKey] = true;
        }
    }]);

    return DefAttrDependencyGraph;
}();

exports.default = DefAttrDependencyGraph;

},{}],117:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _dependencyGraph = require('dependency-graph');

var _GeneralUtils = require('../GeneralUtils');

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
} /* eslint-disable no-restricted-syntax */

/**
 * Keeps all data for one single node
 *
 * @class AttrNode
 */
var AttrNode = function AttrNode(name, value) {
    var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var isSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var _this = this;

    var nameSplit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (n) {
        return n.split('__');
    };
    var keySplit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (layerAttr) {
        return layerAttr ? layerAttr.split('.') : [];
    };

    _classCallCheck(this, AttrNode);

    this.isNodeDirty = function () {
        return _this.isDirty;
    };

    this.setDirtyCallback = function (func) {
        _this.dirtyCallback = func;
    };

    this.setNodeDirty = function () {
        var dirty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        _this.isDirty = dirty;
        _this.dirtyCallback && _this.dirtyCallback(_this, dirty);
    };

    this.name = name;

    var _nameSplit = nameSplit(name),
        _nameSplit2 = _slicedToArray(_nameSplit, 3),
        prefix = _nameSplit2[0],
        layerId = _nameSplit2[1],
        layerAttr = _nameSplit2[2];

    var layerKeys = keySplit(layerAttr);

    this.resolvedKeyData = {
        prefix: prefix,
        layerId: layerId,
        layerAttr: layerAttr,
        layerKeys: layerKeys
    };

    this.value = value;
    this.deps = deps;
    this.isSource = isSource;
    this.isDirty = false;
    this.dirtyCallback = null;
    this.sourceDependents = []; // will be present only if it's a source
};

/**
 *
 *  Class primarily responsible for figuring out the resolution order
 *  and identify the attributes that needs to resolved on each update
 *
 *  How does it work ?
 *  -- creates a dependency graph by topological sort of all the nodes
 *  -- order these nodes
 *  -- create callbacks for setting dirty when Source Node changes to set Dependency node as dirty
 *  -- anything set to dirty is used for the update
 *  -- updateSourceValue , takes a callback for the evaluation  and provides
 *     the callback with the complete execution order and the update order as well.
 *  -- for first render run the complete execution is required
 *  -- for updates use update order
 *
 *
 *
 * @export
 * @class DefAttrExecutionOrder
 */

var DefAttrExecutionOrder = function () {
    function DefAttrExecutionOrder() {
        var _this2 = this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$attrNameSplit = _ref.attrNameSplit,
            attrNameSplit = _ref$attrNameSplit === undefined ? function (n) {
            return n.split('__');
        } : _ref$attrNameSplit,
            _ref$attrKeySplit = _ref.attrKeySplit,
            attrKeySplit = _ref$attrKeySplit === undefined ? function (layerAttr) {
            return layerAttr ? layerAttr.split('.') : [];
        } : _ref$attrKeySplit;

        _classCallCheck(this, DefAttrExecutionOrder);

        this._createNode = function (name, value) {
            var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var isSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return new AttrNode(name, value, deps, isSource, _this2.attrNameSplit, _this2.attrKeySplit);
        };

        this.updateSourceValues = function () {
            var newSourceValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var onUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref2$extraParams = _ref2.extraParams,
                extraParams = _ref2$extraParams === undefined ? {} : _ref2$extraParams,
                _ref2$forced = _ref2.forced,
                forced = _ref2$forced === undefined ? false : _ref2$forced;

            var keysToReset = [];
            var changedValues = {};
            var keys = Object.keys(newSourceValues);
            for (var i = 0, len = keys.length; i < len; i += 1) {
                var key = keys[i];
                if (_this2.currentSourceValues[key] !== newSourceValues[key]) {
                    _this2.currentSourceValues[key] = newSourceValues[key];
                    changedValues[key] = newSourceValues[key];
                    if (_this2.nodes.hasOwnProperty(key)) {
                        _this2.nodes[key].setNodeDirty(true);
                        keysToReset.push(key);
                    }
                }
            }

            var value = void 0;

            if (_this2._firstSourceValueUpdate || forced) {
                value = onUpdate(_this2.updateOrder, changedValues, _this2._firstSourceValueUpdate, _this2.currentCompiledOrder, newSourceValues, extraParams);
                _this2._firstSourceValueUpdate = false;
            } else {
                var onlyDirtyNode = function onlyDirtyNode(node) {
                    return node.isDirty;
                };
                value = onUpdate(_this2.updateOrder.filter(onlyDirtyNode), changedValues, _this2._firstSourceValueUpdate, _this2.currentCompiledOrder, newSourceValues, extraParams);
            }
            for (var _i2 = 0, _len = keysToReset.length; _i2 < _len; _i2 += 1) {
                var _key = keysToReset[_i2];
                if (_this2.nodes.hasOwnProperty(_key)) {
                    _this2.nodes[_key].setNodeDirty(false);
                }
            }

            return value;
        };

        this.compileGraph = function () {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.values(_this2.nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _node = _step.value;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = _node.deps[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var dep = _step4.value;

                            _this2.graph.addDependency(_node.name, dep);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var compiledOrder = _this2.graph.overallOrder();
            var uniqueSourcNodeDependants = {};
            for (var i = 0, len = compiledOrder.length; i < len; i += 1) {
                var node = _this2.nodes[compiledOrder[i]];
                node.index = i;
                if (node.isSource) {
                    _this2.currentSourceValues[node.name] = null;
                    node.sourceDependents = _this2.graph.dependantsOf(node.name);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = node.sourceDependents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var nodeName = _step2.value;

                            uniqueSourcNodeDependants[nodeName] = true;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    var dirtyCallback = function dirtyCallback(obj, dirty) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = obj.sourceDependents[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var nodeName = _step3.value;

                                _this2.nodes[nodeName].isDirty = dirty;
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    };
                    node.setDirtyCallback(dirtyCallback);
                }
            }

            var nonSourceNode = function nonSourceNode(node) {
                return !node.isSource;
            };
            var getNode = function getNode(key) {
                return _this2.nodes[key];
            };
            var byOrderIndex = function byOrderIndex(key1, key2) {
                return _this2.nodes[key1].index - _this2.nodes[key2].index;
            };
            _this2.updateOrder = Object.keys(uniqueSourcNodeDependants).sort(byOrderIndex).map(getNode).filter(nonSourceNode); // gives the order for updats only
            _this2.currentCompiledOrder = compiledOrder.map(getNode).filter(nonSourceNode); // currently compiled graph == has all nodes with or without dependencies
        };

        this.needsReorder = true;
        this.graph = new _dependencyGraph.DepGraph({
            circular: true
        });
        this.attrNameSplit = attrNameSplit;
        this.attrKeySplit = attrKeySplit;
        this.nodes = {};
        this.executionOrder = [];
        this.dependenciesOff = {};

        this.currentSourceValues = {};
        this._firstSourceValueUpdate = true;
    }

    _createClass(DefAttrExecutionOrder, [{
        key: 'addNode',

        /**
         * IsSource : For source values which are not dependent on any value , generally these are either static or 
         * user provided values
         *
         * 
         * @param {*} [{ nodeName, value, dependentNames = [], isSource = false }={}]
         * @memberof DefAttrExecutionOrder
         */
        value: function addNode() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                nodeName = _ref3.nodeName,
                value = _ref3.value,
                _ref3$dependentNames = _ref3.dependentNames,
                dependentNames = _ref3$dependentNames === undefined ? [] : _ref3$dependentNames,
                _ref3$isSource = _ref3.isSource,
                isSource = _ref3$isSource === undefined ? false : _ref3$isSource;

            if (!this.nodes.hasOwnProperty(nodeName)) {
                var node = this._createNode(nodeName, value, dependentNames, isSource);
                this.nodes[nodeName] = node;
                this.graph.addNode(nodeName, node);
            } else {
                var _node2 = this.nodes[nodeName];
                _node2.deps = (0, _GeneralUtils.unionArray)(_node2.deps, dependentNames);
            }
        }
    }, {
        key: 'addSourceNode',
        value: function addSourceNode() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                nodeName = _ref4.nodeName,
                value = _ref4.value;

            this.addNode({ nodeName: nodeName, value: value, dependentNames: [], isSource: true });
        }

        /**
         *
         *
         * @param {*} [newSourceValues={}]
         * @param {(execNodesOrder:AttrNode[] , diff:Object , firstRender:boolean , compiledOrder:AttrNode[], sourceValues , extraParams) => {}} [onUpdate=(execNodesOrder = [], diff) => {}]
         * @param {{extraParams : Object , forced : boolean}} [{ extraParams = {}, forced = false }={}]
         * @memberof DefAttrExecutionOrder
         */

    }]);

    return DefAttrExecutionOrder;
}();

exports.default = DefAttrExecutionOrder;

},{"../GeneralUtils":77,"dependency-graph":551}],118:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefAttrValueRegistry = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}(); /* eslint-disable no-restricted-syntax */

var _deepFreeze = require('deep-freeze');

var _deepFreeze2 = _interopRequireDefault(_deepFreeze);

var _exprEval = require('expr-eval');

var _GeneralUtils = require('../GeneralUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DEBUG = true && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var defConverterFunc = function defConverterFunc(v) {
    return v;
};

var DefAttrValueStore = function () {
    function DefAttrValueStore() {
        _classCallCheck(this, DefAttrValueStore);

        this.__defValueTokenCache = {};
        this.__perserCache = {};
        this.__defValueTokenSymbolCache = {};
    }

    _createClass(DefAttrValueStore, [{
        key: 'createDefAttrValue',
        value: function createDefAttrValue(value) {
            var converterFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defConverterFunc;

            if (!this.__defValueTokenCache[value]) {
                // dlog(`creating new value resolver cache :`, {value , converterFunc})
                var _needsEval = hasExpression(value);

                var _tokens = [];

                if (_needsEval) {
                    var iterTokens = iterableTokenize(value);
                    var iter = iterTokens.length;
                    while (iter--) {
                        var token = iterTokens[iter];
                        var type = token.type,
                            content = token.content;

                        if (!this.__perserCache[content]) {
                            var _expr = _exprEval.Parser.parse(content);
                            this.__perserCache[content] = _expr;
                            this.__defValueTokenSymbolCache[content] = _expr.variables();
                        }

                        var expr = this.__perserCache[content];
                        var vars = this.__defValueTokenSymbolCache[content];
                        _tokens.push(_extends({}, token, { expr: expr }, { vars: vars }));
                    }
                }

                this.__defValueTokenCache[value] = {
                    needsEval: _needsEval,
                    tokens: _tokens
                };
                // dlog(`new value resolver cache :`, {
                //     needsEval , tokens
                // })
            }

            var _defValueTokenCache$ = this.__defValueTokenCache[value],
                tokens = _defValueTokenCache$.tokens,
                needsEval = _defValueTokenCache$.needsEval;

            // dlog(`creating new object of DefAttrValue :`, {value}, `pre-resolved values :`, {tokens , needsEval})

            var object = new DefAttrValue(value, converterFunc);

            // console.log({
            //     tokens , needsEval
            // })

            object.initializeWithArgs({
                needsEval: needsEval,
                tokens: tokens
            });

            // object.initialize()

            return object;
        }
    }]);

    return DefAttrValueStore;
}();

var DefAttrValueRegistry = exports.DefAttrValueRegistry = new DefAttrValueStore();

var DefAttrValue = function () {
    /**
     * Creates an instance of DefAttrValue.
     * @param {string} value
     * @param {Function} [converterFunc=defConverterFunc]
     * @memberof DefAttrValue
     */
    function DefAttrValue(value) {
        var _this = this;

        var converterFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defConverterFunc;

        _classCallCheck(this, DefAttrValue);

        this.__memoizeResolvedValue = function () {
            var prevValue = null;
            var prevVariableValues = _this.allVariables().reduce(function (acc, k) {
                acc[k] = null;
                return acc;
            }, {});
            return function () {
                for (var _len = arguments.length, dicts = Array(_len), _key = 0; _key < _len; _key++) {
                    dicts[_key] = arguments[_key];
                }

                if (!_this.needsEval) {
                    return _this.converterFunc(_this.rawValue);
                }

                var requiredVariableValues = {};
                var keys = _this.allVariables();

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = dicts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var dict = _step2.value;

                                if (dict[key]) {
                                    requiredVariableValues[key] = dict[key];
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if ((0, _GeneralUtils.shallowEqual)(requiredVariableValues, prevVariableValues) && prevValue) {
                    return prevValue;
                }
                prevVariableValues = requiredVariableValues;
                prevValue = _this._resolve.apply(_this, dicts);
                return prevValue;
            };
        };

        this.rawValue = (0, _deepFreeze2.default)(value);
        this.converterFunc = converterFunc || defConverterFunc;
    }

    _createClass(DefAttrValue, [{
        key: 'initializeWithArgs',
        value: function initializeWithArgs(_ref) {
            var needsEval = _ref.needsEval,
                tokens = _ref.tokens;

            this.needsEval = needsEval;
            this.tokens = tokens;

            this.resolve = this.__memoizeResolvedValue();

            return this;
        }
    }, {
        key: 'initialize',
        value: function initialize() {
            this.needsEval = hasExpression(this.rawValue);

            this.tokens = [];

            if (this.needsEval) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = iterableTokenize(this.rawValue)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var token = _step3.value;
                        var type = token.type,
                            content = token.content;

                        var expr = _exprEval.Parser.parse(content);
                        this.tokens.push(_extends({}, token, { expr: expr }));
                    }

                    // this.tokens = tokenize(this.rawValue).map(token => {
                    //     const { type, content } = token
                    //     if (type === 'expr') {
                    //         // console.log(`parsing ${content}`);
                    //         // try {
                    //             const expr = Parser.parse(content)
                    //             return { ...token, ...{ expr } }
                    //         // } catch(e) {
                    //         //     console.log(e);
                    //         //     throw e
                    //         // }
                    //     }
                    //     return token
                    // })
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            this.resolve = this.__memoizeResolvedValue();
            return this;
        }
    }, {
        key: 'needsEval',
        value: function needsEval() {
            return this.needsEval;
        }
    }, {
        key: '_resolve',
        value: function _resolve() {
            if (!this.needsEval) {
                return this.converterFunc(this.rawValue);
            }

            // dlog(`recieved for resolution :`, {
            //     value : this.rawValue ,
            //     inputs : dicts
            // })

            var finalResult = '';
            var currIndex = 0;
            var iter = this.tokens.length;

            for (var _len2 = arguments.length, dicts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                dicts[_key2] = arguments[_key2];
            }

            while (iter--) {
                var token = this.tokens[iter];
                var index = token.index,
                    content = token.content,
                    expr = token.expr;

                finalResult += this.rawValue.substr(currIndex, index - currIndex);
                currIndex = index + content.length + 3; // index expr was found + length of expre + ${ bracket character }
                var simplifiedExpr = expr;
                var dictLen = dicts.length;
                while (dictLen--) {
                    var dict = dicts[dictLen];
                    simplifiedExpr = simplifiedExpr.simplify(dict); // TODO evaluate incremental expression forming -- fast / slow ???
                }
                finalResult += simplifiedExpr.evaluate();
            }
            finalResult += this.rawValue.substr(currIndex);

            // AVOIDING MAPS and REDUCE HERE.
            // const valueStr = this.tokens
            //     .map((token) => {
            //         const { type, content } = token;
            //         if (type === 'expr') {
            //             return dicts.reduce((p, d) => p.simplify(d), token.expr).evaluate();
            //             // return token.expr.evaluate(dict)
            //         } else {
            //             return content;
            //         }
            //     })
            //     .join('');

            // console.log({
            //     currIndex  ,
            //     value : this.rawValue,
            //     ptokens : this._tokens ,
            //     tokens: this.tokens ,
            //     valueStr , finalResult
            // })

            return this.converterFunc(finalResult);
        }
    }, {
        key: 'allVariables',
        value: function allVariables() {
            if (!this.__allVars) {
                this.__allVars = this.variables({});
            }
            return this.__allVars;
        }
    }, {
        key: 'variables',
        value: function variables() {
            var knownDict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.needsEval) {
                return [];
            }

            var unknownVars = {};
            var iter = this.tokens.length;
            while (iter--) {
                var token = this.tokens[iter];
                var content = token.content,
                    vars = token.vars;

                var innerIter = vars.length;
                while (innerIter--) {
                    var v = vars[innerIter];
                    if (!(v in knownDict)) {
                        unknownVars[v] = true;
                    }
                }
            }

            // OLDER UNCACHED METHODS
            // this.tokens.forEach((token) => {
            //     const { type, content } = token;
            //     if (type === 'expr') {
            //         token.expr.variables().forEach((v) => {
            //             if (!(v in knownDict)) {
            //                 unknownVars[v] = true;
            //             }
            //         });
            //     }
            // });
            // dlog(`Called for validation of known / unknown values: `, {
            //     arg : knownDict ,
            //     unknownVars
            // })
            return Object.keys(unknownVars);
        }
    }]);

    return DefAttrValue;
}();

exports.default = DefAttrValue;

var hasExpression = function hasExpression(a) {
    return typeof a === 'string' && /\${(.[^}]+)}/.test(a);
};

var iterableTokenize = function iterableTokenize(a) {
    var tokens = [];

    var str = a;

    var re = /\${(.[^}]+)}/g;

    var regexIterator = str.matchAll(re);

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = regexIterator[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var entry = _step4.value;

            tokens.push({
                type: 'expr',
                content: entry[1],
                index: entry.index
            });
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    return tokens;
};

var tokenize = function tokenize(a) {
    var tokens = [];

    var str = a;

    var re = /\${(.[^}]+)}/g;

    var fullMatch = null;
    var matchedExp = null;
    var prevLastIndex = 0;
    var result = null;
    while ((result = re.exec(str)) !== null) {
        fullMatch = result[0];
        matchedExp = result[1];

        var fIndex = result.index;

        // Push the non-expression until the match
        if (fIndex - prevLastIndex > 0) {
            tokens.push({
                type: 'const',
                content: str.substr(prevLastIndex, fIndex - prevLastIndex)
            });
        }
        tokens.push({
            type: 'expr',
            content: str.substr(fIndex + 2, matchedExp.length)
        });

        prevLastIndex = re.lastIndex;
    }

    if (prevLastIndex !== str.length) {
        // There is a constant between these
        tokens.push({
            type: 'const',
            content: str.substr(prevLastIndex)
        });
    }

    return tokens;
};

},{"../GeneralUtils":77,"deep-freeze":548,"expr-eval":631}],119:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefModelRegistry = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}(); /* eslint-disable max-classes-per-file */
/* eslint-disable no-restricted-syntax */

var _deepFreeze = require('deep-freeze');

var _deepFreeze2 = _interopRequireDefault(_deepFreeze);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _cloneextend = require('cloneextend');

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _DefAttrValue = require('./DefAttrValue');

var _DefAttrValue2 = _interopRequireDefault(_DefAttrValue);

var _DefAttrDependencyGraph = require('./DefAttrDependencyGraph');

var _DefAttrDependencyGraph2 = _interopRequireDefault(_DefAttrDependencyGraph);

var _LayerUtils = require('./LayerUtils');

var _TimeUtils = require('../TimeUtils');

var _Timer = require('../scheduler/Timer');

var _Timer2 = _interopRequireDefault(_Timer);

var _DefAttrExecutionOrder = require('./DefAttrExecutionOrder');

var _DefAttrExecutionOrder2 = _interopRequireDefault(_DefAttrExecutionOrder);

var _GeneralUtils = require('../GeneralUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DEBUG = (0, _GeneralUtils.debugState)(true);
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var subAttrKeySeperator = '.';

var ProcessUpdateSteps = (0, _keymirror2.default)({
    PROCESS_ATTR_UPDATE: null,
    PARSE_CHARACTER_ANIMATION: null,
    UPDATE_LAYER_TIME_LINES: null
});

var AttrTypesForResolution = (0, _keymirror2.default)({
    attributes: null,
    animation: null,
    props: null
});

var combineMerge = function combineMerge(target, source, options) {
    var destination = target.slice();
    for (var i = 0; i < source.length; i += 1) {
        var index = i;
        var item = source[index];
        if (typeof destination[index] === 'undefined') {
            destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
        } else if (options.isMergeableObject(item)) {
            destination[index] = (0, _deepmerge2.default)(target[index], item, options);
        } else if (options.overWriteArrayPos) {
            destination[index] = item;
        } else if (target.indexOf(item) === -1) {
            destination.push(item);
        }
    }
    return destination;
};

var highlightColorMerge = function highlightColorMerge(target, source) {
    if (!target) return source;
    if (!source) return target;
    return source;
};

var customMerge = function customMerge(key) {
    if (key === 'highlightColor') return highlightColorMerge;
    if (key === 'highlightTextColor') return highlightColorMerge;
};

var overWriteMerge = function overWriteMerge(target, source) {
    var overWriteArrayPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return (0, _deepmerge2.default)(target, source, {
        arrayMerge: combineMerge,
        clone: false,
        overWriteArrayPos: overWriteArrayPos,
        customMerge: customMerge
    });
};

var ensureBefore = function ensureBefore(depOrder, targetId, beforeIds) {
    beforeIds.forEach(function (beforeId) {
        var targetIndex = depOrder.findIndex(function (d) {
            return d.l.id === targetId;
        });
        var beforeIndex = depOrder.findIndex(function (d) {
            return d.l.id === beforeId;
        });
        if (targetIndex < beforeIndex) {
            depOrder = depOrder.map(function (d) {
                if (d.l.id === targetId) {
                    return depOrder[beforeIndex];
                }
                if (d.l.id === beforeId) {
                    return depOrder[targetIndex];
                }
                return d;
            });
        }
    });
    return depOrder;
};

var DefModelStore = function () {
    function DefModelStore() {
        _classCallCheck(this, DefModelStore);

        this.defModelStore = {};
        this.overlayStore = {};
    }

    /**
     *
     *
     * @param {string} defId
     * @param {string} overlayId
     * @return {DefModel}
     * @memberof DefModelStore
     */

    _createClass(DefModelStore, [{
        key: 'getModelForOverlay',
        value: function getModelForOverlay(defId, overlayId) {
            if (defId.constructor === Object) {
                var def = defId;
                defId = def.id;
            }
            if (!this.defModelStore[defId]) {
                var model = new DefModel(defId);

                this.defModelStore[defId] = model;
            }
            if (overlayId && !this.overlayStore[overlayId]) {
                this.overlayStore[overlayId] = {
                    defId: defId,
                    overlayId: overlayId,
                    model: new DefModel(defId)
                };
            }
            return this.overlayStore[overlayId].model;
        }
    }, {
        key: 'removeModelForOverlay',
        value: function removeModelForOverlay(defId, overlayId) {
            var data = this.overlayStore[overlayId];
            if (data) {
                var _defId = data.defId,
                    _overlayId = data.overlayId,
                    model = data.model;

                model.detachParentTimeline();
                data.model = null;
                data.overlayId = null;
                data.defId = null;
                delete this.overlayStore[_overlayId];
            }
        }
    }, {
        key: 'getModelForDef',
        value: function getModelForDef(defId) {
            if (defId.constructor === Object) {
                var def = defId;
                defId = def.id;
            }
            if (!this.defModelStore[defId]) {
                var model = new DefModel(defId);

                this.defModelStore[defId] = model;
            }
            return this.defModelStore[defId];
        }
    }]);

    return DefModelStore;
}();

var DefModelRegistry = exports.DefModelRegistry = new DefModelStore();

if ((0, _GeneralUtils.debugState)(true)) {
    window.DefModelRegistry = DefModelRegistry;
}

var DefModel = function () {
    function DefModel(defId) {
        var _this = this;

        _classCallCheck(this, DefModel);

        this.getLayerIndexForId = function (id) {
            return _this.__layerObjectIndexLookup[id];
        };

        this.updateLayerTimelines = function () {
            var didAnythingChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var didTimeChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (didAnythingChange || didTimeChange) {
                _this._updateLayerTimelines();
            }
        };

        this._fillAnimationData = function (lindex, resolvedLayerAnimations, resolvedDef) {
            if (!resolvedLayerAnimations[lindex]) {
                if (resolvedDef.layers && resolvedDef.layers[lindex]) {
                    var animation = resolvedDef.layers[lindex].animation;

                    resolvedLayerAnimations[lindex] = animation;
                    // reusing the animation object from previous udpate cycle
                    // for updates these values will already be filled ,
                    // and dependency graph will make sure latest values are updated
                } else {
                    resolvedLayerAnimations[lindex] = {}; // initialising with empty animation object if its first rendet
                }
            }
        };

        this._fillLayerData = function (lindex, resolvedLayersAttrs, resolvedDef) {
            if (!resolvedLayersAttrs[lindex]) {
                var layers = resolvedDef.layers || [];
                var layer = layers[lindex];

                var _ref = layer || {},
                    _ref$attrs = _ref.attrs,
                    attrs = _ref$attrs === undefined ? {} : _ref$attrs; // same object as previously resolved layer


                resolvedLayersAttrs[lindex] = attrs; // since we are only resolving the attribute at this point
            }
        };

        this._processOneDefAttrNode = function (_ref2, node) {
            var resolvedLayersAttrs = _ref2.resolvedLayersAttrs,
                resolvedLayerAnimations = _ref2.resolvedLayerAnimations,
                resolvedDict = _ref2.resolvedDict,
                hasAnimationOverride = _ref2.hasAnimationOverride,
                resolvedDef = _ref2.resolvedDef;

            if (node.value.attrType === AttrTypesForResolution.animation && !hasAnimationOverride) {
                var _node$resolvedKeyData = node.resolvedKeyData,
                    layerAttr = _node$resolvedKeyData.layerAttr,
                    layerId = _node$resolvedKeyData.layerId,
                    prefix = _node$resolvedKeyData.prefix;

                var lindex = _this.getLayerIndexForId(layerId);
                _this._fillAnimationData(lindex, resolvedLayerAnimations, resolvedDef);
                // filling up the values for first render and every subsequent updates
                var layerAnimContainer = { animation: resolvedLayerAnimations[lindex] };
                var value = _this._resolveAttributeValue(node.value.resolveDictKey, prefix, layerId, layerAttr, node.value.attrNode, resolvedDict);
                // nested value inserion for updates
                (0, _GeneralUtils.setNestedProperty)(layerAttr, value, layerAnimContainer, subAttrKeySeperator);

                // nested value updates for those entries that requires this kind of sub attr update
                if (node.value.resolveDictParentKey) {
                    if (!resolvedDict[node.value.resolveDictParentKey]) {
                        resolvedDict[node.value.resolveDictParentKey] = {};
                    } else {
                        resolvedDict[node.value.resolveDictParentKey][node.value.selfKeyAsChild] = value;
                    }
                }
            } else {
                var _node$resolvedKeyData2 = node.resolvedKeyData,
                    _layerAttr = _node$resolvedKeyData2.layerAttr,
                    _layerId = _node$resolvedKeyData2.layerId,
                    layerKeys = _node$resolvedKeyData2.layerKeys,
                    _prefix = _node$resolvedKeyData2.prefix;

                if (_prefix && _layerId && _layerAttr) {
                    var _lindex = _this.getLayerIndexForId(_layerId);
                    _this._fillLayerData(_lindex, resolvedLayersAttrs, resolvedDef);
                    var attrs = resolvedLayersAttrs[_lindex];
                    _this._resolveAttributeValue(node.name, _prefix, _layerId, _layerAttr, node.value.attrNode, // contains the DefAttrnode
                    resolvedDict);

                    (0, _GeneralUtils.setNestedProperty)(_layerAttr, resolvedDict[node.name], attrs, subAttrKeySeperator);

                    if (layerKeys.length === 2) {
                        var key = _prefix + '__' + _layerId + '__' + layerKeys[0];
                        if (!resolvedDict[key]) {
                            resolvedDict[key] = attrs[layerKeys[0]];
                        }
                    }
                } else {
                    // Possibly a  non Attribute Value , which is a dependency
                    _this._resolveAttributeValue(node.name, null, null, null, node.value.attrNode, // contains the DefAttrnode
                    resolvedDict);
                }
            }
            return {
                resolvedLayersAttrs: resolvedLayersAttrs,
                resolvedLayerAnimations: resolvedLayerAnimations,
                resolvedDict: resolvedDict,
                hasAnimationOverride: hasAnimationOverride,
                resolvedDef: resolvedDef
            };
        };

        this._mergeResolvedAttributes = function (acc, l, index) {
            var resolvedLayers = acc.resolvedLayers,
                resolvedLayersAttrs = acc.resolvedLayersAttrs,
                resolvedLayerAnimations = acc.resolvedLayerAnimations,
                resolvedDef = acc.resolvedDef,
                firstUpdate = acc.firstUpdate,
                hasAnimationOverride = acc.hasAnimationOverride,
                resolvedDict = acc.resolvedDict;
            var _l$animation = l.animation;
            _l$animation = _l$animation === undefined ? {} : _l$animation;
            var enterkeyframes = _l$animation.enterkeyframes,
                exitkeyframes = _l$animation.exitkeyframes,
                _l$animation$highligh = _l$animation.highlights,
                highlights = _l$animation$highligh === undefined ? null : _l$animation$highligh,
                _l$animation$characte = _l$animation.characters,
                characters = _l$animation$characte === undefined ? null : _l$animation$characte,
                _l$animation$lines = _l$animation.lines,
                lines = _l$animation$lines === undefined ? null : _l$animation$lines;

            var lAttrs = overWriteMerge(((resolvedDef.layers || [])[index] || {}).attrs || {}, resolvedLayersAttrs[index] || {});

            var lAnimation = overWriteMerge(((resolvedDef.layers || [])[index] || {}).animation || {
                enterkeyframes: enterkeyframes, // either pick previous resolved values
                exitkeyframes: exitkeyframes // or for first update the resolvedValues
            }, resolvedLayerAnimations[index] || { enterkeyframes: {}, exitkeyframes: {} });

            if (highlights) {
                lAnimation.highlights = highlights;
            }
            if (characters) {
                lAnimation.characters = characters;
            }
            if (lines) {
                lAnimation.lines = lines;
            }

            // Using old Resolution System because -- resolveDef Needs to be filled up with animation Properties
            // Onece the animation properties are filled up this is no more relevant
            // Later updates are handled purely by the Dependeny Graph System
            if (!hasAnimationOverride && firstUpdate) {
                _this._resolveAnimationKeyframes(l, enterkeyframes, lAnimation.enterkeyframes, resolvedDict, function (attrKey, p) {
                    return 'l__' + l.id + '__' + attrKey + '__$animation__$ent__' + p;
                });
                _this._resolveAnimationKeyframes(l, exitkeyframes, lAnimation.exitkeyframes, resolvedDict, function (attrKey, p) {
                    return 'l__' + l.id + '__' + attrKey + '__$animation__$ex__' + p;
                });
            }

            resolvedLayers.push(_extends({}, l, { attrs: lAttrs, animation: lAnimation }));

            return acc;
        };

        this._processDefAttrNodeUpdate = function (execOrder, diff, firstUpdate, nodeOrder, souceValues, _ref3) {
            var resolvedDict = _ref3.resolvedDict,
                parsedDef = _ref3.parsedDef,
                resolvedDef = _ref3.resolvedDef,
                hasAnimationOverride = _ref3.hasAnimationOverride,
                precalcKeys = _ref3.precalcKeys;

            var nodesToExecute = firstUpdate ? nodeOrder : execOrder;

            // dlog(`Defmodel :`, this.defId, `ExecOrder:`, nodesToExecute, firstUpdate, diff, nodeOrder);

            /**
             * Execution Order consist of
             * - 1st update : all the nodes that are part of dependency graph
             * - 2nd update : execOrder only has those nodes which needs update
             *  , i.e we need to use previous values of resolvedDict and resolveDef
             *
             * - We loop over every node , which hold the Key and it's dependencies whith some value.
             *   value can be anything arbitrary. Useful for execution logic here
             *
             *
             */

            var _nodesToExecute$reduc = nodesToExecute.reduce(_this._processOneDefAttrNode, {
                // TODO -- potential micro optimiation prefil them based on layer renderer length
                resolvedLayersAttrs: [],
                resolvedLayerAnimations: [],
                resolvedDict: resolvedDict,
                hasAnimationOverride: hasAnimationOverride,
                resolvedDef: resolvedDef
            }),
                _nodesToExecute$reduc2 = _nodesToExecute$reduc.resolvedLayersAttrs,
                resolvedLayersAttrs = _nodesToExecute$reduc2 === undefined ? [] : _nodesToExecute$reduc2,
                _nodesToExecute$reduc3 = _nodesToExecute$reduc.resolvedLayerAnimations,
                resolvedLayerAnimations = _nodesToExecute$reduc3 === undefined ? [] : _nodesToExecute$reduc3;

            // Now time for precalc -- HOPING IT WOULD INLINE


            var resolvedPrecalc = precalcKeys.reduce(function (acc, key) {
                acc[key] = resolvedDict[key];
                return acc;
            }, {});

            // dlog(`After precalc :`, this.space, resolvedDict, scaleY, resolvedLayersAttrs, resolvedLayerAnimations);

            var _parsedDef$layers$red = parsedDef.layers.reduce(_this._mergeResolvedAttributes, {
                resolvedLayers: [],
                resolvedDef: resolvedDef,
                resolvedDict: resolvedDict,
                resolvedLayersAttrs: resolvedLayersAttrs,
                resolvedLayerAnimations: resolvedLayerAnimations,
                hasAnimationOverride: hasAnimationOverride,
                firstUpdate: firstUpdate
            }),
                resolvedLayers = _parsedDef$layers$red.resolvedLayers;
            // Now resolve all variables from attrs
            // resolving layer level animation

            var _pl = parsedDef.precalc,
                _ly = parsedDef.layers,
                _gl = parsedDef.global,
                otherArgs = _objectWithoutProperties(parsedDef, ['precalc', 'layers', 'global']);
            // add the resolvedGlobal animation keyframe states


            resolvedDef = _extends({}, otherArgs, resolvedDef, {
                precalc: resolvedPrecalc,
                layers: resolvedLayers
            });

            // dlog(`resolvedDef :`, this.resolvedDef);

            return {
                resolvedDict: resolvedDict,
                resolvedDef: resolvedDef
            };
        };

        this._updateLayersInfo = function () {
            var templateType = _this.def.meta.templateType;
            // HOPING IT WOULD INLINE , NO EXTERNAL THIS ACCESS

            _this.resolvedDef.layers.forEach(function (l) {
                var layerInfo = _this.getInfoForLayer(l.id);
                if (l.type === 'text') {
                    layerInfo.update(_extends({}, l.attrs, { templateType: templateType }));
                }
            });
        };

        this._globalParametersUpdate = function () {
            var _space = _this.space,
                _space$x = _space.x,
                ox = _space$x === undefined ? 0 : _space$x,
                _space$y = _space.y,
                oy = _space$y === undefined ? 0 : _space$y,
                ow = _space.width,
                oh = _space.height;
            var _canvas = _this.canvas,
                cw = _canvas.width,
                ch = _canvas.height;

            var hasEnterGroup = _this.groupSettings !== null && _this.groupSettings.enter !== null;
            var hasExitGroup = _this.groupSettings !== null && _this.groupSettings.exit !== null;

            var defaultGroupVars = {
                gx: ox,
                gy: oy,
                gw: ow,
                gh: oh
            };

            var entGS = null;
            if (hasEnterGroup) {
                entGS = _this.groupSettings.enter.space;
            }

            var enterGroupVars = {
                gx: hasEnterGroup ? entGS.x : ox,
                gy: hasEnterGroup ? entGS.y : oy,
                gw: hasEnterGroup ? entGS.width : ow,
                gh: hasEnterGroup ? entGS.height : oh
            };

            var exGS = null;
            if (hasExitGroup) {
                exGS = _this.groupSettings.exit.space;
            }

            var exitGroupVars = {
                gx: hasExitGroup ? exGS.x : ox,
                gy: hasExitGroup ? exGS.y : oy,
                gw: hasExitGroup ? exGS.width : ow,
                gh: hasExitGroup ? exGS.height : oh
            };

            var canvasVars = { cw: cw, ch: ch };
            var overlaySpaceVars = { ox: ox, oy: oy, ow: ow, oh: oh };

            var resolvedDictForGlobalDefault = _extends({}, defaultGroupVars, canvasVars, overlaySpaceVars);

            var resolvedDictForGlobalEnter = _extends({}, enterGroupVars, canvasVars, overlaySpaceVars);
            var resolvedDictForGlobalExit = _extends({}, exitGroupVars, canvasVars, overlaySpaceVars);

            var resolvedGlobalAttrs = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(_this.parsedDef.global.attrs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var k = _step.value;

                    _this._resolveValue(k, _this.parsedValues, resolvedDictForGlobalDefault, _this.depNodes, true, true);
                    _this._resolveValue(k, _this.parsedValues, resolvedDictForGlobalEnter, _this.depNodes, true, true);
                    _this._resolveValue(k, _this.parsedValues, resolvedDictForGlobalExit, _this.depNodes, true, true);

                    resolvedGlobalAttrs[k] = resolvedDictForGlobalDefault[k];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var hasAnimationOverride = !!_this.parsedDef.meta.canOverrideAnimation;

            var resolvedGlobalAnimation = {};
            var parsedEnterKeyframes = {};
            var parsedExitKeyframes = {};
            if (hasAnimationOverride) {
                var _time = _this.time,
                    enterAnimDefId = _time.enterAnimDefId,
                    exitAnimDefId = _time.exitAnimDefId;

                // First parse these animations
                // TODO -- create a cached Dependency Graph for these

                if (enterAnimDefId) {
                    var enterAnimDef = getAnimationDefForId(enterAnimDefId);
                    _this._parseGlobalAnimationKeyframes(enterAnimDef.keyframes, parsedEnterKeyframes);
                }

                if (exitAnimDefId) {
                    var exitAnimDef = getAnimationDefForId(exitAnimDefId);
                    _this._parseGlobalAnimationKeyframes(exitAnimDef.keyframes, parsedExitKeyframes);
                }
            } else {
                var _parsedDef$global = _this.parsedDef.global,
                    attrs = _parsedDef$global.attrs,
                    _parsedDef$global$ani = _parsedDef$global.animation,
                    _parsedDef$global$ani2 = _parsedDef$global$ani.enterkeyframes,
                    enterkeyframes = _parsedDef$global$ani2 === undefined ? {} : _parsedDef$global$ani2,
                    _parsedDef$global$ani3 = _parsedDef$global$ani.exitkeyframes,
                    exitkeyframes = _parsedDef$global$ani3 === undefined ? {} : _parsedDef$global$ani3;

                parsedEnterKeyframes = enterkeyframes;
                parsedExitKeyframes = exitkeyframes;
            }

            // Now resolve the keyframes
            var resolvedEnterKeyframes = {};
            var resolvedExitKeyframes = {};
            _this._resolveGlobalAnimationKeyframes(parsedEnterKeyframes, resolvedEnterKeyframes, resolvedDictForGlobalEnter, function (attrKey, p) {
                return attrKey + '__$animation__$ent__' + p;
            });
            _this._resolveGlobalAnimationKeyframes(parsedExitKeyframes, resolvedExitKeyframes, resolvedDictForGlobalExit, function (attrKey, p) {
                return attrKey + '__$animation__$ex__' + p;
            });

            resolvedGlobalAnimation = {
                enterkeyframes: resolvedEnterKeyframes,
                exitkeyframes: resolvedExitKeyframes
            };

            var resolvedGlobal = { attrs: resolvedGlobalAttrs, animation: resolvedGlobalAnimation };
            return resolvedGlobal;
        };

        this._setupCharacterLevelAnimation = function () {
            // Setup highlightAnimations
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = _this.resolvedDef.layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var l = _step2.value;

                    var layerInfo = _this.getInfoForLayer(l.id);
                    if (l.type === 'text' && !!l.animation.highlights) {
                        if (_this.layerTimelines[l.id].highlights) {
                            _this.layerTimelines[l.id].highlights.clear();
                        } else {
                            _this.layerTimelines[l.id].highlights = new TimelineMax();
                            _this.defTimeline.add(_this.layerTimelines[l.id].highlights, 0);
                        }

                        if (_this.detachedLayerTimelines[l.id].highlights) {
                            _this.detachedLayerTimelines[l.id].highlights.clear();
                        } else {
                            _this.detachedLayerTimelines[l.id].highlights = new TimelineMax();
                            _this.defDetachedTimeline.add(_this.detachedLayerTimelines[l.id].highlights, 0);
                        }
                        var _l$animation$highligh2 = l.animation.highlights,
                            _l$animation$highligh3 = _l$animation$highligh2.enter,
                            p_enter = _l$animation$highligh3 === undefined ? { type: 'none' } : _l$animation$highligh3,
                            _l$animation$highligh4 = _l$animation$highligh2.exit,
                            p_exit = _l$animation$highligh4 === undefined ? { type: 'none' } : _l$animation$highligh4;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {

                            for (var _iterator6 = layerInfo.highlightBlocks[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var hb = _step6.value;
                                var x = hb.x,
                                    y = hb.y,
                                    width = hb.width,
                                    height = hb.height;

                                hb.x_tweenObj = {};
                                hb.width_tweenObj = {};
                                hb.x_d_tweenObj = {};
                                hb.width_d_tweenObj = {};

                                var x_enterKfs = null;
                                var x_exitKfs = null;
                                var width_enterKfs = null;
                                var width_exitKfs = null;

                                if (p_enter.type === 'right_to_left') {
                                    var _x_enterKfs, _width_enterKfs;

                                    x_enterKfs = {}, width_enterKfs = {};
                                    if (p_enter.t_start !== 0) {
                                        x_enterKfs['0%'] = { v: x + width };
                                        width_enterKfs['0%'] = { v: 0 };
                                    }

                                    x_enterKfs = (_x_enterKfs = {}, _defineProperty(_x_enterKfs, p_enter.t_start + '%', { v: x + width }), _defineProperty(_x_enterKfs, p_enter.t_end + '%', { v: x, ease: '' + p_enter.ease }), _x_enterKfs);
                                    width_enterKfs = (_width_enterKfs = {}, _defineProperty(_width_enterKfs, p_enter.t_start + '%', { v: 0 }), _defineProperty(_width_enterKfs, p_enter.t_end + '%', { v: width, ease: '' + p_enter.ease }), _width_enterKfs);

                                    if (p_enter.t_end !== 100) {
                                        x_enterKfs['100%'] = { v: x };
                                        width_enterKfs['100%'] = { v: width };
                                    }
                                } else if (p_enter.type === 'left_to_right') {
                                    var _extends2;

                                    width_enterKfs = {};
                                    if (p_enter.t_start !== 0) {
                                        width_enterKfs['0%'] = { v: 0 };
                                    }
                                    width_enterKfs = _extends({}, width_enterKfs, (_extends2 = {}, _defineProperty(_extends2, p_enter.t_start + '%', { v: 0 }), _defineProperty(_extends2, p_enter.t_end + '%', { v: width, ease: '' + p_enter.ease }), _extends2));
                                    if (p_enter.t_end !== 100) {
                                        width_enterKfs['100%'] = { v: width };
                                    }
                                }

                                if (p_exit.type === 'right_to_left') {
                                    var _width_exitKfs;

                                    width_exitKfs = {};
                                    if (p_exit.t_start !== 0) {
                                        width_exitKfs['0%'] = { v: width };
                                    }

                                    width_exitKfs = (_width_exitKfs = {}, _defineProperty(_width_exitKfs, p_exit.t_start + '%', { v: width }), _defineProperty(_width_exitKfs, p_exit.t_end + '%', { v: 0, ease: '' + p_exit.ease }), _width_exitKfs);

                                    if (p_exit.t_end !== 100) {
                                        width_exitKfs['100%'] = { v: 0 };
                                    }
                                } else if (p_exit.type === 'left_to_right') {
                                    var _x_exitKfs, _width_exitKfs2;

                                    x_exitKfs = {}, width_exitKfs = {};
                                    if (p_exit.t_start !== 0) {
                                        x_exitKfs['0%'] = { v: x };
                                        width_exitKfs['0%'] = { v: width };
                                    }

                                    x_exitKfs = (_x_exitKfs = {}, _defineProperty(_x_exitKfs, p_exit.t_start + '%', { v: x }), _defineProperty(_x_exitKfs, p_exit.t_end + '%', { v: x + width, ease: '' + p_exit.ease }), _x_exitKfs);
                                    width_exitKfs = (_width_exitKfs2 = {}, _defineProperty(_width_exitKfs2, p_exit.t_start + '%', { v: width }), _defineProperty(_width_exitKfs2, p_exit.t_end + '%', { v: 0, ease: '' + p_exit.ease }), _width_exitKfs2);

                                    if (p_exit.t_end !== 100) {
                                        x_exitKfs['100%'] = { v: width };
                                        width_exitKfs['100%'] = { v: 0 };
                                    }
                                }

                                _this._updateAnimationForAttr(_this.layerTimelines[l.id].highlights, hb.x_tweenObj, _this.time, '', 'float', x, x_enterKfs, x_exitKfs);
                                _this._updateAnimationForAttr(_this.detachedLayerTimelines[l.id].highlights, hb.x_d_tweenObj, _this.time, '', 'float', x, x_enterKfs, x_exitKfs);

                                _this._updateAnimationForAttr(_this.layerTimelines[l.id].highlights, hb.width_tweenObj, _this.time, '', 'float', width, width_enterKfs, width_exitKfs);
                                _this._updateAnimationForAttr(_this.detachedLayerTimelines[l.id].highlights, hb.width_d_tweenObj, _this.time, '', 'float', width, width_enterKfs, width_exitKfs);
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    }
                }

                // Setup line animations
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = _this.resolvedDef.layers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _l = _step3.value;

                    var _layerInfo = _this.getInfoForLayer(_l.id);
                    if (_l.type === 'text' && !!_l.animation.lines) {
                        if (_this.layerTimelines[_l.id].lines) {
                            _this.layerTimelines[_l.id].lines.clear();
                        } else {
                            _this.layerTimelines[_l.id].lines = new TimelineMax();
                            _this.defTimeline.add(_this.layerTimelines[_l.id].lines, 0);
                        }

                        if (_this.detachedLayerTimelines[_l.id].lines) {
                            _this.detachedLayerTimelines[_l.id].lines.clear();
                        } else {
                            _this.detachedLayerTimelines[_l.id].lines = new TimelineMax();
                            _this.defDetachedTimeline.add(_this.detachedLayerTimelines[_l.id].lines, 0);
                        }

                        var _l$animation$lines2 = _l.animation.lines,
                            _l$animation$lines2$e = _l$animation$lines2.enter,
                            _p_enter = _l$animation$lines2$e === undefined ? { type: 'none' } : _l$animation$lines2$e,
                            _l$animation$lines2$e2 = _l$animation$lines2.exit,
                            _p_exit = _l$animation$lines2$e2 === undefined ? { type: 'none' } : _l$animation$lines2$e2;

                        var numLines = _layerInfo.textLayerLines.length;

                        var lineCounter = 0;

                        var _iteratorNormalCompletion7 = true;
                        var _didIteratorError7 = false;
                        var _iteratorError7 = undefined;

                        try {
                            for (var _iterator7 = _layerInfo.textLayerLines[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                var line = _step7.value;

                                line.yp_tweenObj = {};
                                line.yp_d_tweenObj = {};

                                var yp_enterKfs = null;
                                var yp_exitKfs = null;

                                if (_p_enter.type === 'slide_from_bottom') {
                                    var p_enter_time = _p_enter.t_end - _p_enter.t_start;
                                    var p_enter_line_time = p_enter_time / (1 + _p_enter.staggerFactor * (numLines - 1));

                                    var p_enter_line_start = lineCounter * (p_enter_time - p_enter_line_time) / (numLines - 1);
                                    var p_enter_line_end = p_enter_line_start + p_enter_line_time;

                                    yp_enterKfs = {};

                                    if (p_enter_line_start !== 0) {
                                        yp_enterKfs['0%'] = { v: 1 };
                                    }

                                    yp_enterKfs[p_enter_line_start + '%'] = { v: 1 };
                                    yp_enterKfs[p_enter_line_end + '%'] = { v: 0, ease: '' + _p_enter.ease };

                                    if (p_enter_line_end !== 100) {
                                        yp_enterKfs['100%'] = { v: 0 };
                                    }
                                }

                                _this._updateAnimationForAttr(_this.layerTimelines[_l.id].lines, line.yp_tweenObj, _this.time, '', 'float', 0, yp_enterKfs, yp_exitKfs);
                                _this._updateAnimationForAttr(_this.detachedLayerTimelines[_l.id].lines, line.yp_d_tweenObj, _this.time, '', 'float', 0, yp_enterKfs, yp_exitKfs);

                                lineCounter++;
                            }
                        } catch (err) {
                            _didIteratorError7 = true;
                            _iteratorError7 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                    _iterator7.return();
                                }
                            } finally {
                                if (_didIteratorError7) {
                                    throw _iteratorError7;
                                }
                            }
                        }
                    }
                }

                // Setup character animations
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = _this.resolvedDef.layers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _l2 = _step4.value;

                    var _layerInfo2 = _this.getInfoForLayer(_l2.id);
                    if (_l2.type === 'text' && !!_l2.animation.characters) {
                        if (_this.layerTimelines[_l2.id].characters) {
                            _this.layerTimelines[_l2.id].characters.clear();
                        } else {
                            _this.layerTimelines[_l2.id].characters = new TimelineMax();
                            _this.defTimeline.add(_this.layerTimelines[_l2.id].characters, 0);
                        }

                        if (_this.detachedLayerTimelines[_l2.id].characters) {
                            _this.detachedLayerTimelines[_l2.id].characters.clear();
                        } else {
                            _this.detachedLayerTimelines[_l2.id].characters = new TimelineMax();
                            _this.defDetachedTimeline.add(_this.detachedLayerTimelines[_l2.id].characters, 0);
                        }

                        var _l2$animation$charact = _l2.animation.characters,
                            _l2$animation$charact2 = _l2$animation$charact.enter,
                            _p_enter2 = _l2$animation$charact2 === undefined ? { type: 'none' } : _l2$animation$charact2,
                            _l2$animation$charact3 = _l2$animation$charact.exit,
                            _p_exit2 = _l2$animation$charact3 === undefined ? { type: 'none' } : _l2$animation$charact3;

                        // Calculate number of characters including new lines


                        var numChars = _layerInfo2.textLayerLines.reduce(function (p, line) {
                            return (
                                // Take into account new line chars
                                p + line.chars.length + (line.autoWrapsAtEnd ? 0 : 1)
                            );
                        }, 0);

                        var charCounter = 0;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = _layerInfo2.textLayerLines[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var _line = _step8.value;
                                var _iteratorNormalCompletion9 = true;
                                var _didIteratorError9 = false;
                                var _iteratorError9 = undefined;

                                try {
                                    for (var _iterator9 = _line.chars[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                        var c = _step9.value;

                                        c.xp_tweenObj = {};
                                        c.yp_tweenObj = {};
                                        c.alphap_tweenObj = {};
                                        c.xp_d_tweenObj = {};
                                        c.yp_d_tweenObj = {};
                                        c.alphap_d_tweenObj = {};

                                        var xp_enterKfs = null;
                                        var xp_exitKfs = null;
                                        var _yp_enterKfs = null;
                                        var _yp_exitKfs = null;
                                        var alphap_enterKfs = null;
                                        var alphap_exitKfs = null;

                                        if (_p_enter2.type === 'slide_from_top_left') {
                                            var _p_enter_time = _p_enter2.t_end - _p_enter2.t_start;
                                            var p_enter_char_time = _p_enter_time / (1 + _p_enter2.staggerFactor * (numChars - 1));

                                            var p_enter_char_start = charCounter * (_p_enter_time - p_enter_char_time) / (numChars - 1);
                                            var p_enter_char_end = p_enter_char_start + p_enter_char_time;

                                            xp_enterKfs = {}, _yp_enterKfs = {}, alphap_enterKfs = {};

                                            if (p_enter_char_start !== 0) {
                                                xp_enterKfs['0%'] = { v: -1 };
                                                _yp_enterKfs['0%'] = { v: -1 };
                                                alphap_enterKfs['0%'] = { v: 0 };
                                            }

                                            xp_enterKfs[p_enter_char_start + '%'] = { v: -1 };
                                            xp_enterKfs[p_enter_char_end + '%'] = { v: 0, ease: '' + _p_enter2.ease };

                                            _yp_enterKfs[p_enter_char_start + '%'] = { v: -1 };
                                            _yp_enterKfs[p_enter_char_end + '%'] = { v: 0, ease: '' + _p_enter2.ease };

                                            alphap_enterKfs[p_enter_char_start + '%'] = { v: 0 };
                                            alphap_enterKfs[p_enter_char_end + '%'] = {
                                                v: 1,
                                                ease: '' + _p_enter2.ease
                                            };

                                            if (p_enter_char_end !== 100) {
                                                xp_enterKfs['100%'] = { v: 0 };
                                                _yp_enterKfs['100%'] = { v: 0 };
                                                alphap_enterKfs['100%'] = { v: 1 };
                                            }
                                        }

                                        // TODO exit
                                        _this._updateAnimationForAttr(_this.layerTimelines[_l2.id].characters, c.xp_tweenObj, _this.time, '', 'float', 0, xp_enterKfs, xp_exitKfs);
                                        _this._updateAnimationForAttr(_this.detachedLayerTimelines[_l2.id].characters, c.xp_d_tweenObj, _this.time, '', 'float', 0, xp_enterKfs, xp_exitKfs);
                                        _this._updateAnimationForAttr(_this.layerTimelines[_l2.id].characters, c.yp_tweenObj, _this.time, '', 'float', 0, _yp_enterKfs, _yp_exitKfs);
                                        _this._updateAnimationForAttr(_this.detachedLayerTimelines[_l2.id].characters, c.yp_d_tweenObj, _this.time, '', 'float', 0, _yp_enterKfs, _yp_exitKfs);
                                        _this._updateAnimationForAttr(_this.layerTimelines[_l2.id].characters, c.alphap_tweenObj, _this.time, '', 'float', 1, alphap_enterKfs, alphap_exitKfs);
                                        _this._updateAnimationForAttr(_this.detachedLayerTimelines[_l2.id].characters, c.alphap_d_tweenObj, _this.time, '', 'float', 1, alphap_enterKfs, alphap_exitKfs);

                                        charCounter++;
                                    }
                                } catch (err) {
                                    _didIteratorError9 = true;
                                    _iteratorError9 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                            _iterator9.return();
                                        }
                                    } finally {
                                        if (_didIteratorError9) {
                                            throw _iteratorError9;
                                        }
                                    }
                                }

                                charCounter += _line.autoWrapsAtEnd ? 0 : 1;
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = _this.resolvedDef.layers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _l3 = _step5.value;

                    var _layerInfo3 = _this.getInfoForLayer(_l3.id);
                    if (_l3.type === 'bmae') {
                        _layerInfo3.updateTimeValues(_this.time);
                        _layerInfo3.updateLayerSize(_l3.attrs.width, _l3.attrs.height);
                        _layerInfo3.updateCurrentTime(_this.getTime());
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        };

        this._updateLayerAttributesBasedonTime = function (l) {
            var templateType = _this.def.meta.templateType;

            var layerInfo = _this.getInfoForLayer(l.id);
            // For Counter Layer Time data must be propogated
            if (l.type === 'text') {
                var _layerInfo$attrs$isCo = layerInfo.attrs.isCounterLayer,
                    isCounterLayer = _layerInfo$attrs$isCo === undefined ? false : _layerInfo$attrs$isCo;

                if (isCounterLayer) {
                    layerInfo.updateTimeValues(_this.time);
                    var counterText = layerInfo.updateCurrentTime(_this.getTime());
                    var prevText = _this.resolvedDict['l__' + l.id + '__text'];
                    if (!!counterText && prevText !== counterText) {
                        l.attrs.text = counterText;
                        _this.resolvedDict['l__' + l.id + '__text'] = counterText;
                        layerInfo.update(_extends({}, l.attrs, { templateType: templateType }));
                    }
                }
            }
        };

        this.updateTimeline = function () {
            _this._updateTime();
        };

        if (defId.constructor === Object) {
            this.def = (0, _deepFreeze2.default)((0, _cloneextend.clone)(defId));
            defId = this.def.id;
        } else {
            this.def = (0, _deepFreeze2.default)(getTemplateDefForId(defId));
        }

        // This is the timeline we might attach to a parent later
        this.defTimeline = new TimelineMax({
            onUpdate: function onUpdate() {
                return _this._onDefTimelineUpdate();
            }
        });
        this.defTimeline.set({}, {}, 100000); // High value
        this.defTimeline.pause();

        // This timeline will not be attached to another parent, or played.
        // Sole purpose is to seek and read values
        this.defDetachedTimeline = new TimelineMax();
        this.defDetachedTimeline.set({}, {}, 100000); // High value
        this.defDetachedTimeline.pause();

        this.rootTimeline = null;
        this.rootTimelineForceRenderFunc = null;
        this.previousRootTimelines = [];

        this.initialized = false;

        this.space = null;
        this.time = null;
        this.values = null;
        this.groupSettings = null;

        this.parsedDef = {};
        this.parsedValues = {};

        this.resolvedDef = {};
        this.resolvedDict = {};

        this.layerInfos = {};

        this.layerTimelines = null;
        this.detachedLayerTimelines = null;
        this.globalTimeline = null;
        this.detachedGlobalTimeline = null;

        this.__layerObjectIndexLookup = {};

        this.__selfDictLoopUp = {};

        this.dependenyExecutionGraph = new _DefAttrExecutionOrder2.default({
            attrNameSplit: function attrNameSplit(n) {
                return n.split('__');
            },
            attrKeySplit: function attrKeySplit(layerAttr) {
                return layerAttr ? layerAttr.split(subAttrKeySeperator) : [];
            }
        });

        this.defId = defId;

        this._processDef();
    }

    _createClass(DefModel, [{
        key: 'attachParentTimeline',
        value: function attachParentTimeline(rootTimeline, rootTimelineForceRenderFunc) {
            this.defTimeline.play();

            if (this.rootTimeline) {
                this.previousRootTimelines.push({
                    rootTimeline: this.rootTimeline,
                    rootTimelineForceRenderFunc: this.rootTimelineForceRenderFunc
                });
            }

            this.rootTimeline = rootTimeline;
            this.rootTimeline.add(this.defTimeline, 0);

            this.rootTimelineForceRenderFunc = rootTimelineForceRenderFunc;
        }
    }, {
        key: 'detachParentTimeline',
        value: function detachParentTimeline() {
            if (this.rootTimeline) {
                this.rootTimeline.remove(this.defTimeline);
                this.defTimeline.pause();
                this.rootTimeline = null;
                this.rootTimelineForceRenderFunc = null;
            }

            if (this.previousRootTimelines && this.previousRootTimelines.length > 0) {
                var lastRootTimeline = this.previousRootTimelines.pop();
                this.attachParentTimeline(lastRootTimeline.rootTimeline, lastRootTimeline.rootTimelineForceRenderFunc);
            }

            this._updateTime();
        }
    }, {
        key: 'seekToStatic',
        value: function seekToStatic() {
            if (this.rootTimeline) {
                throw new Error('Cannot seek timeline with a root');
            }
            var enterdone = this.time.enterdone;

            this.defTimeline.seek((0, _TimeUtils._toGSAPtime)(enterdone));
            this.defTimeline.render(this.defTimeline.time(), false, true);
        }
    }, {
        key: 'setStatic',
        value: function setStatic(useStatic) {
            if (useStatic) {
                var enterdone = this.time.enterdone;

                this._resolveLiveAttrsAtTime(enterdone);
            } else {
                this._resolveLiveAttrsAtTime(this.getTime());
            }
        }
    }, {
        key: 'update',
        value: function update(space, time, values, canvas) {
            var groupSettings = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var forceUpdate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

            var _ref4 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {},
                _ref4$canUpdateCharac = _ref4.canUpdateCharacterAnimation,
                canUpdateCharacterAnimation = _ref4$canUpdateCharac === undefined ? true : _ref4$canUpdateCharac,
                _ref4$canUpdateTimeli = _ref4.canUpdateTimeline,
                canUpdateTimeline = _ref4$canUpdateTimeli === undefined ? true : _ref4$canUpdateTimeli;

            if (!space || !time || !values || !canvas) {
                throw new Error('Null equivalent values shall not be entertained. Not anymore.');
            }

            var hasSpaceChanged = false;
            var hasTimeChanged = false;
            var hasValuesChanged = false;
            var hasGroupSettingsChanged = false;
            var hasCanvasChanged = false;

            if (!this.initialized) {
                hasSpaceChanged = true;
                hasTimeChanged = true;
                hasValuesChanged = true;
                hasCanvasChanged = true;
                hasGroupSettingsChanged = true;
            } else {
                hasSpaceChanged = this._didSpaceChange(this.space, space);
                hasTimeChanged = this._didTimeChange(this.time, time);
                hasValuesChanged = this._didValuesChange(this.values, values);
                hasCanvasChanged = this._didCanvasChange(this.canvas, canvas);
                hasGroupSettingsChanged = this._didGroupSettingsChange(this.groupSettings, groupSettings);
            }

            if (hasSpaceChanged) {
                this.space = space;
            }
            if (hasTimeChanged) {
                this.time = time;
            }
            if (hasValuesChanged) {
                this.values = values;
            }
            if (hasCanvasChanged) {
                this.canvas = canvas;
            }
            if (hasGroupSettingsChanged) {
                this.groupSettings = groupSettings;
            }

            this.initialized = true;

            var didAnythingChange = hasSpaceChanged || hasValuesChanged || hasGroupSettingsChanged || hasCanvasChanged;

            if (didAnythingChange || forceUpdate) {
                this._processUpdate({
                    hasSpaceChanged: hasSpaceChanged,
                    hasValuesChanged: hasValuesChanged,
                    hasGroupSettingsChanged: hasGroupSettingsChanged,
                    hasCanvasChanged: hasCanvasChanged,
                    forceUpdate: forceUpdate,
                    hasTimeChanged: hasTimeChanged
                });
            }

            if ((didAnythingChange || hasTimeChanged) && canUpdateTimeline || forceUpdate) {
                this._updateLayerTimelines();
            }

            if (didAnythingChange && canUpdateCharacterAnimation || forceUpdate) {
                this._setupCharacterLevelAnimation();
            }

            return {
                didAnyPropsChanged: didAnythingChange,
                hasTimeChanged: hasTimeChanged
            };
        }

        /**
         * TweenMax obj creation , fast enough to do no memoization -- Tweenmax takes care of it
         * Loops should be faste enough and that's it
         *
         * @param {boolean} [didAnythingChange=true]
         * @memberof DefModel
         */

    }, {
        key: 'setupCharacterLevelAnimation',
        value: function setupCharacterLevelAnimation() {
            var didAnythingChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var didTimeChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (didAnythingChange || didTimeChange) {
                this._setupCharacterLevelAnimation();
            }
        }
    }, {
        key: 'getLayerAttrValue',
        value: function getLayerAttrValue(layerId, attrKey) {
            var useStatic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (useStatic) {
                var layer = this.def.layers.find(function (l) {
                    return l.id === layerId;
                });
                if (!!layer && layer.type === 'bmae' && !!layer.meta.reverseMappings) {
                    if (layer.meta.reverseMappings.hasOwnProperty(attrKey)) {
                        return this.getInfoForLayer(layerId).getReverseMappingValue(attrKey, true);
                    }
                }
            }
            if (!useStatic && // TODO - These attributes keeps changing , can we build scene graph on top of this ?
            this.layerTimelines.hasOwnProperty(layerId) && this.layerTimelines[layerId].attrTweenObjs.hasOwnProperty(attrKey)) {
                // Should return tweened value
                var tweenObj = this.layerTimelines[layerId].attrTweenObjs[attrKey];
                var value = tweenObj[tweenObj.valueKey];
                if (value.constructor === Object) {
                    return (0, _cloneextend.clone)(value); // TODO - Is Clone Needed
                }
                return value;
            }

            var index = this.__layerObjectIndexLookup[layerId];

            // Should return resolved value
            return this.resolvedDef.layers[index].attrs[attrKey];
        }
    }, {
        key: 'getGlobalAttrValue',
        value: function getGlobalAttrValue(attrKey) {
            var useStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!useStatic && this.globalTimeline.attrTweenObjs.hasOwnProperty(attrKey)) {
                // Should return tweened value
                var tweenObj = this.globalTimeline.attrTweenObjs[attrKey];
                return tweenObj[tweenObj.valueKey];
            }
            // Should return resolved value
            return this.resolvedDef.global.attrs[attrKey];
        }
    }, {
        key: 'getCurrentPropValues',
        value: function getCurrentPropValues() {
            return this.values;
        }
    }, {
        key: 'getAttrsForLayer',
        value: function getAttrsForLayer(layerId) {
            var _this2 = this;

            var useStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var attrs = this.parsedDef.layers[this.__layerObjectIndexLookup[layerId]].attrs;

            var attrValues = {};
            Object.keys(attrs).forEach(function (attrKey) {
                attrValues[attrKey] = _this2.getLayerAttrValue(layerId, attrKey, useStatic);
            });
            return attrValues;
        }
    }, {
        key: 'getGlobalAttrs',
        value: function getGlobalAttrs() {
            var _this3 = this;

            var useStatic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var globalAttrValues = {};
            _LayerUtils.GLOBAL_ATTRS_LIST.forEach(function (attrKey) {
                globalAttrValues[attrKey] = _this3.getGlobalAttrValue(attrKey, useStatic);
            });
            return globalAttrValues;
        }
    }, {
        key: 'getLayerAttrValueAtTime',
        value: function getLayerAttrValueAtTime(layerId, attrKey, time) {
            if (this.detachedLayerTimelines.hasOwnProperty(layerId) && this.detachedLayerTimelines[layerId].attrTweenObjs.hasOwnProperty(attrKey)) {
                // Should return tweened value
                if ((0, _TimeUtils._fromGSAPtime)(this.defDetachedTimeline.time()) !== time) {
                    this.defDetachedTimeline.seek((0, _TimeUtils._toGSAPtime)(time));
                }
                this.defDetachedTimeline.render(this.defDetachedTimeline.time(), false, true);

                var tweenObj = this.detachedLayerTimelines[layerId].attrTweenObjs[attrKey];

                var value = tweenObj[tweenObj.valueKey];
                if (value.constructor === Object) {
                    return (0, _cloneextend.clone)(value);
                }
                return value;
            }
            // Should return resolved value
            return this.resolvedDef.layers.find(function (l) {
                return l.id === layerId;
            }).attrs[attrKey];
        }
    }, {
        key: 'getGlobalAttrValueAtTime',
        value: function getGlobalAttrValueAtTime(attrKey, time) {
            if (this.detachedGlobalTimeline.attrTweenObjs.hasOwnProperty(attrKey)) {
                // Should return tweened value
                if ((0, _TimeUtils._fromGSAPtime)(this.defDetachedTimeline.time()) !== time) {
                    this.defDetachedTimeline.seek((0, _TimeUtils._toGSAPtime)(time));
                }
                this.defDetachedTimeline.render(this.defDetachedTimeline.time(), false, true);

                var tweenObj = this.detachedGlobalTimeline.attrTweenObjs[attrKey];
                return tweenObj[tweenObj.valueKey];
            }
            // Should return resolved value
            return this.resolvedDef.global.attrs[attrKey];
        }
    }, {
        key: 'getAttrsForLayerAtTime',
        value: function getAttrsForLayerAtTime(layerId, time) {
            var _this4 = this;

            var _parsedDef$layers$fin = this.parsedDef.layers.find(function (l) {
                return l.id === layerId;
            }),
                attrs = _parsedDef$layers$fin.attrs;

            var attrValues = {};
            Object.keys(attrs).forEach(function (attrKey) {
                attrValues[attrKey] = _this4.getLayerAttrValueAtTime(layerId, attrKey, time);
            });
            return attrValues;
        }
    }, {
        key: 'getGlobalAttrsAtTime',
        value: function getGlobalAttrsAtTime(time) {
            var _this5 = this;

            var globalAttrValues = {};
            _LayerUtils.GLOBAL_ATTRS_LIST.forEach(function (attrKey) {
                globalAttrValues[attrKey] = _this5.getGlobalAttrValueAtTime(attrKey, time);
            });
            return globalAttrValues;
        }
    }, {
        key: 'getVisibility',
        value: function getVisibility() {
            var useStatic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var _time2 = this.time,
                enterstart = _time2.enterstart,
                exitdone = _time2.exitdone;

            var currentTime = this.getTime();

            return currentTime >= enterstart && currentTime <= exitdone;
        }
    }, {
        key: 'getInfoForLayer',
        value: function getInfoForLayer(layerId) {
            if (this.layerInfos.hasOwnProperty(layerId) && !!this.layerInfos[layerId]) {
                return this.layerInfos[layerId];
            }
            return null;
        }
    }, {
        key: 'getTime',
        value: function getTime() {
            return (0, _TimeUtils._fromGSAPtime)(this.defTimeline.time());
        }
    }, {
        key: 'getUsedFontKeys',
        value: function getUsedFontKeys() {
            var fontKeys = this.resolvedDef.layers.filter(function (l) {
                return l.type === 'text';
            }).map(function (l) {
                return l.attrs.fontFamily;
            });

            return fontKeys;
        }
    }, {
        key: '_didSpaceChange',
        value: function _didSpaceChange(oldSpace, newSpace) {
            if (oldSpace === newSpace) {
                return false;
            }
            if (oldSpace.x === newSpace.x && oldSpace.y === newSpace.y && oldSpace.width === newSpace.width && oldSpace.height === newSpace.height && oldSpace.zIndex === newSpace.zIndex && oldSpace.transform === newSpace.transform && oldSpace.rotateDeg === newSpace.rotateDeg) {
                return false;
            }
            return true;
        }
    }, {
        key: '_didTimeChange',
        value: function _didTimeChange(oldTime, newTime) {
            if (oldTime === newTime) {
                return false;
            }
            if (oldTime.enterstart === newTime.enterstart && oldTime.enterdone === newTime.enterdone && oldTime.exitstart === newTime.exitstart && oldTime.exitdone === newTime.exitdone && oldTime.enterAnimDefId === newTime.enterAnimDefId && oldTime.exitAnimDefId === newTime.exitAnimDefId) {
                return false;
            }
            return true;
        }
    }, {
        key: '_didValuesChange',
        value: function _didValuesChange(oldValues, newValues) {
            if (oldValues === newValues) {
                return false;
            }
            if (Object.keys(newValues).find(function (p) {
                return newValues[p] !== oldValues[p];
            })) {
                return true;
            }
            return false;
        }
    }, {
        key: '_didCanvasChange',
        value: function _didCanvasChange(oldCanvas, newCanvas) {
            if (oldCanvas === newCanvas) {
                return false;
            }
            if (oldCanvas.width === newCanvas.width && oldCanvas.height === newCanvas.height) {
                return false;
            }
            return true;
        }
    }, {
        key: '_didGroupSettingsChange',
        value: function _didGroupSettingsChange(oldGroupSettings, newGroupSettings) {
            if (oldGroupSettings === newGroupSettings) {
                return false;
            }
            if (oldGroupSettings === null || newGroupSettings === null) {
                return true;
            }
            return true;
        }
    }, {
        key: '_onDefTimelineUpdate',
        value: function _onDefTimelineUpdate() {
            this._resolveLiveAttrsAtTime(this.getTime());
        }
    }, {
        key: '_resolveLiveAttrsAtTime',
        value: function _resolveLiveAttrsAtTime(time) {
            var _this6 = this;

            var liveDict = (0, _cloneextend.clone)(this.resolvedDict);

            var _loop = function _loop(i, len) {
                var l = _this6.resolvedDef.layers[i];
                var layerInfo = _this6.getInfoForLayer(l.id);
                if (l.type === 'bmae') {
                    layerInfo.updateLayerSize(l.attrs.width, l.attrs.height);
                    layerInfo.updateCurrentTime(time);

                    var _l$meta = l.meta;
                    _l$meta = _l$meta === undefined ? {} : _l$meta;
                    var _l$meta$reverseMappin = _l$meta.reverseMappings,
                        reverseMappings = _l$meta$reverseMappin === undefined ? {} : _l$meta$reverseMappin;

                    Object.keys(reverseMappings).forEach(function (rmKey) {
                        liveDict['l__' + l.id + '__' + rmKey] = layerInfo.getReverseMappingValue(rmKey);
                    });
                } else if (l.type === 'text') {
                    var _layerInfo$attrs$isCo2 = layerInfo.attrs.isCounterLayer,
                        isCounterLayer = _layerInfo$attrs$isCo2 === undefined ? false : _layerInfo$attrs$isCo2;

                    if (isCounterLayer) {
                        var counterText = layerInfo.updateCurrentTime(time);
                        if (counterText) {
                            l.attrs.text = counterText;
                        }
                    }
                }
            };

            for (var i = 0, len = this.resolvedDef.layers.length; i < len; i += 1) {
                _loop(i, len);
            }
            // TODO -- check if live resolution is needed everytime ??
            // What is a live attr ? -- why is it needed ??
            this.resolvedDef.layers.forEach(function (l) {
                var attrs = l.attrs;

                Object.keys(attrs).forEach(function (attrKey) {
                    var depKey = 'l__' + l.id + '__' + attrKey;
                    if (_this6.dependencyGraph.doesAttrKeyDependOnLive(depKey)) {
                        _this6._resolveValue(depKey, _this6.parsedValues, liveDict, _this6.depNodes);
                        l.attrs[attrKey] = liveDict[depKey];
                    }
                });
            });
        }
    }, {
        key: '_processDef',
        value: function _processDef() {
            // First generate the parsed version of the def
            this._parseDef();

            // Then analyze evaluation dependency order and prepare
            this._prepareDepNodes();
        }
    }, {
        key: '_parseDef',
        value: function _parseDef() {
            var _this7 = this;

            // First generate a parsed def
            this.parsedDef = (0, _cloneextend.clone)(this.def);

            var parsedDefPrecalc = {};
            var parsedGlobal = {};
            var parsedDefLayers = [];
            var parsedValues = {};

            if (this.parsedDef.precalc) {
                var _iteratorNormalCompletion10 = true;
                var _didIteratorError10 = false;
                var _iteratorError10 = undefined;

                try {
                    for (var _iterator10 = Object.keys(this.parsedDef.precalc)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                        var k = _step10.value;

                        var converterFunc = null;
                        if (k === 'oh') {
                            converterFunc = _LayerUtils.floatConverter;
                        }
                        var value = _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(this.parsedDef.precalc[k], converterFunc);
                        this.dependenyExecutionGraph.addNode({
                            isSource: false,
                            nodeName: k,
                            value: {
                                attrNode: value,
                                attrType: AttrTypesForResolution.attributes
                            },
                            dependentNames: this._getDepVars(value, null, {})
                        });
                        parsedDefPrecalc[k] = value;
                        parsedValues[k] = value;
                    }
                } catch (err) {
                    _didIteratorError10 = true;
                    _iteratorError10 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion10 && _iterator10.return) {
                            _iterator10.return();
                        }
                    } finally {
                        if (_didIteratorError10) {
                            throw _iteratorError10;
                        }
                    }
                }
            }

            var props = this.parsedDef.props;

            var _arr = ['ow', 'oh', 'ox', 'oy', 'cw', 'ch'].concat(_toConsumableArray(Object.keys(props)));

            for (var _i = 0; _i < _arr.length; _i++) {
                var key = _arr[_i];
                this.dependenyExecutionGraph.addSourceNode({
                    nodeName: key,
                    value: {
                        attrType: AttrTypesForResolution.props,
                        attrNode: _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(key)
                    }
                });
            }

            var _parsedDef$global2 = this.parsedDef.global;
            _parsedDef$global2 = _parsedDef$global2 === undefined ? {} : _parsedDef$global2;
            var _parsedDef$global2$at = _parsedDef$global2.attrs,
                globalAttrs = _parsedDef$global2$at === undefined ? {} : _parsedDef$global2$at,
                _parsedDef$global2$an = _parsedDef$global2.animation;
            _parsedDef$global2$an = _parsedDef$global2$an === undefined ? {} : _parsedDef$global2$an;
            var _parsedDef$global2$an2 = _parsedDef$global2$an.enterkeyframes,
                enterkeyframes = _parsedDef$global2$an2 === undefined ? {} : _parsedDef$global2$an2,
                _parsedDef$global2$an3 = _parsedDef$global2$an.exitkeyframes,
                exitkeyframes = _parsedDef$global2$an3 === undefined ? {} : _parsedDef$global2$an3;

            var parsedGlobalAttrs = {};
            _LayerUtils.GLOBAL_ATTRS_LIST.forEach(function (k) {
                var v = globalAttrs.hasOwnProperty(k) ? globalAttrs[k] : _LayerUtils.GLOBAL_ATTR_DEFAULTS[k];
                var value = _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(v, (0, _LayerUtils.getGlobalAttrConverter)(k));
                parsedGlobalAttrs[k] = value;
                parsedValues[k] = value;
            });

            var parsedGlobalAnimation = { enterkeyframes: {}, exitkeyframes: {} };

            this._parseGlobalAnimationKeyframes(enterkeyframes, parsedGlobalAnimation.enterkeyframes);
            this._parseGlobalAnimationKeyframes(exitkeyframes, parsedGlobalAnimation.exitkeyframes);

            parsedGlobal.attrs = parsedGlobalAttrs;
            parsedGlobal.animation = parsedGlobalAnimation;

            parsedDefLayers = this.parsedDef.layers.map(function (l, index) {
                var lId = l.id,
                    _l$attrs = l.attrs,
                    attrs = _l$attrs === undefined ? {} : _l$attrs,
                    _l$animation2 = l.animation;
                _l$animation2 = _l$animation2 === undefined ? {} : _l$animation2;
                var _l$animation2$enterke = _l$animation2.enterkeyframes,
                    enterkeyframes = _l$animation2$enterke === undefined ? {} : _l$animation2$enterke,
                    _l$animation2$exitkey = _l$animation2.exitkeyframes,
                    exitkeyframes = _l$animation2$exitkey === undefined ? {} : _l$animation2$exitkey,
                    _l$animation2$highlig = _l$animation2.highlights,
                    highlights = _l$animation2$highlig === undefined ? null : _l$animation2$highlig,
                    _l$animation2$charact = _l$animation2.characters,
                    characters = _l$animation2$charact === undefined ? null : _l$animation2$charact,
                    _l$animation2$lines = _l$animation2.lines,
                    lines = _l$animation2$lines === undefined ? null : _l$animation2$lines;

                var lParsedAttrs = {};
                var lParsedAnimation = { enterkeyframes: {}, exitkeyframes: {} };

                _this7.__layerObjectIndexLookup[lId] = index;

                if (highlights) {
                    lParsedAnimation.highlights = highlights;
                }
                if (characters) {
                    lParsedAnimation.characters = characters;
                }
                if (lines) {
                    lParsedAnimation.lines = lines;
                }

                _this7.layerInfos[lId] = (0, _LayerUtils.createLayerInfo)(l);

                var layerAttrs = _LayerUtils.LAYER_ATTR_DEFAULTS[l.type];
                var layerAttrTypes = _LayerUtils.LAYER_ATTR_TYPES[l.type];
                // TODO -- Why oes BMAE layer need dynamic attributes -- Dynamic Prop would be a good choice though
                if (l.type === 'bmae') {
                    // Dynamic attrs supported
                    var dyLayerAttrs = {};
                    var dyLayerAttrTypes = {};
                    var _iteratorNormalCompletion11 = true;
                    var _didIteratorError11 = false;
                    var _iteratorError11 = undefined;

                    try {
                        for (var _iterator11 = Object.keys(attrs)[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                            var attrKey = _step11.value;

                            if (!layerAttrs.hasOwnProperty(attrKey)) {
                                // Dynamic attr
                                if (!!l.meta && !!l.meta.mappings && !!l.meta.mappings[attrKey]) {
                                    var defaultValue = null;
                                    var type = l.meta.mappings[attrKey].type;

                                    if (type === 'float') {
                                        defaultValue = 0;
                                    } else if (type === 'color') {
                                        defaultValue = '#fff';
                                    } else {
                                        throw new Error('Unknown mapping type');
                                    }
                                    dyLayerAttrTypes[attrKey] = type;
                                    dyLayerAttrs[attrKey] = defaultValue;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError11 = true;
                        _iteratorError11 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                _iterator11.return();
                            }
                        } finally {
                            if (_didIteratorError11) {
                                throw _iteratorError11;
                            }
                        }
                    }

                    if (dyLayerAttrs) {
                        layerAttrs = (0, _deepmerge2.default)(layerAttrs, dyLayerAttrs);
                    }
                    if (dyLayerAttrTypes) {
                        layerAttrTypes = (0, _deepmerge2.default)(layerAttrTypes, dyLayerAttrTypes);
                    }
                }
                var _iteratorNormalCompletion12 = true;
                var _didIteratorError12 = false;
                var _iteratorError12 = undefined;

                try {
                    for (var _iterator12 = Object.keys(layerAttrs)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                        var _attrKey = _step12.value;

                        var v = attrs.hasOwnProperty(_attrKey) ? attrs[_attrKey] : layerAttrs[_attrKey];

                        var attrType = layerAttrTypes[_attrKey];
                        if (attrType.constructor === Object) {
                            var parsedSubAttrs = {};
                            var _iteratorNormalCompletion13 = true;
                            var _didIteratorError13 = false;
                            var _iteratorError13 = undefined;

                            try {
                                for (var _iterator13 = Object.keys(v)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                                    var subAttrKey = _step13.value;

                                    var lukey = '' + _attrKey + subAttrKeySeperator + subAttrKey;
                                    var _value = _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(v[subAttrKey], (0, _LayerUtils.getLayerAttrConverter)(l.type, lukey, l.meta));
                                    parsedSubAttrs[subAttrKey] = _value;
                                    parsedValues['l__' + lId + '__' + _attrKey + subAttrKeySeperator + subAttrKey] = _value;
                                    _this7.dependenyExecutionGraph.addNode({
                                        nodeName: 'l__' + lId + '__' + _attrKey + subAttrKeySeperator + subAttrKey,
                                        isSource: false,
                                        value: {
                                            attrNode: _value,
                                            attrType: AttrTypesForResolution.attributes
                                        },
                                        dependentNames: _this7._getDepVars(_value, lId, {})
                                    });
                                }
                            } catch (err) {
                                _didIteratorError13 = true;
                                _iteratorError13 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                        _iterator13.return();
                                    }
                                } finally {
                                    if (_didIteratorError13) {
                                        throw _iteratorError13;
                                    }
                                }
                            }

                            lParsedAttrs[_attrKey] = parsedSubAttrs;
                            parsedValues['l__' + lId + '__' + _attrKey] = parsedSubAttrs;
                        } else {
                            var _value2 = _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(v, (0, _LayerUtils.getLayerAttrConverter)(l.type, _attrKey, l.meta));
                            lParsedAttrs[_attrKey] = _value2;
                            parsedValues['l__' + lId + '__' + _attrKey] = _value2;
                            _this7.dependenyExecutionGraph.addNode({
                                nodeName: 'l__' + lId + '__' + _attrKey,
                                value: {
                                    attrNode: _value2,
                                    attrType: AttrTypesForResolution.attributes
                                },
                                dependentNames: _this7._getDepVars(_value2, lId, {}),
                                isSource: false
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError12 = true;
                    _iteratorError12 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion12 && _iterator12.return) {
                            _iterator12.return();
                        }
                    } finally {
                        if (_didIteratorError12) {
                            throw _iteratorError12;
                        }
                    }
                }

                _this7._parseAnimationKeyframes(l, enterkeyframes, lParsedAnimation.enterkeyframes, 'l__' + lId + '__animation.enterkeyframes', function (attrKey, p) {
                    return 'l__' + l.id + '__' + attrKey + '__$animation__$ent__' + p;
                }, parsedValues);
                _this7._parseAnimationKeyframes(l, exitkeyframes, lParsedAnimation.exitkeyframes, 'l__' + lId + '__animation.exitkeyframes', function (attrKey, p) {
                    return 'l__' + l.id + '__' + attrKey + '__$animation__$ex__' + p;
                }, parsedValues);

                return _extends({}, l, { attrs: lParsedAttrs, animation: lParsedAnimation });
            });

            var layerRenderOrder = this.def.layers.map(function (l) {
                if (l.meta && l.meta.masks && l.meta.masks.length) {
                    return {
                        l: l,
                        deps: l.meta.masks.map(function (mask) {
                            return mask.mLayerId;
                        })
                    };
                }
                return {
                    l: l,
                    deps: []
                };
            });
            // TODO -- do topological sort
            this.def.layers.forEach(function (l) {
                if (l.meta && l.meta.masks && l.meta.masks.length) {
                    var maskLayerIds = l.meta.masks.map(function (mask) {
                        return mask.mLayerId;
                    });
                    layerRenderOrder = ensureBefore(layerRenderOrder, l.id, maskLayerIds);
                }
            });

            this.layerRenderOrder = layerRenderOrder;

            this.parsedDef.precalc = parsedDefPrecalc;
            this.parsedDef.global = parsedGlobal;
            this.parsedDef.layers = parsedDefLayers;
            this.parsedValues = parsedValues;

            this.dependenyExecutionGraph.compileGraph();
        }
    }, {
        key: '_parseAnimationKeyframes',
        value: function _parseAnimationKeyframes(l, src, dest) {
            var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            var _this8 = this;

            var resolveDictKeyCreator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var parsedValues = arguments[5];

            Object.keys(src).forEach(function (attrKey) {
                var kfs = src[attrKey];
                var lParsedKfs = {};
                Object.keys(kfs).forEach(function (p) {
                    var kf = kfs[p];
                    if (kf.hasOwnProperty('v')) {
                        var val = kf.v;
                        if (val.constructor === Object) {
                            var valObj = {};
                            Object.keys(val).forEach(function (subAttrKey) {
                                valObj[subAttrKey] = _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(val[subAttrKey], (0, _LayerUtils.getLayerAttrConverter)(l.type, [attrKey, subAttrKey].join(subAttrKeySeperator), l.meta));

                                _this8.dependenyExecutionGraph.addNode({
                                    nodeName: [prefix, attrKey, p, 'v', subAttrKey].join(subAttrKeySeperator),
                                    value: {
                                        attrNode: valObj[subAttrKey],
                                        attrType: AttrTypesForResolution.animation,
                                        resolveDictKey: resolveDictKeyCreator([attrKey, subAttrKey].join(subAttrKeySeperator), p),
                                        resolveDictParentKey: resolveDictKeyCreator(attrKey, p),
                                        selfKeyAsChild: subAttrKey
                                    },
                                    dependentNames: _this8._getDepVars(valObj[subAttrKey], l.id, {}),
                                    isSource: false
                                });
                            });

                            val = valObj;
                        } else {
                            val = _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(val, (0, _LayerUtils.getLayerAttrConverter)(l.type, attrKey, l.meta));
                            _this8.dependenyExecutionGraph.addNode({
                                nodeName: [prefix, attrKey, p, 'v'].join(subAttrKeySeperator),
                                value: {
                                    attrNode: val,
                                    attrType: AttrTypesForResolution.animation,
                                    resolveDictKey: resolveDictKeyCreator('' + attrKey, p)
                                },
                                dependentNames: _this8._getDepVars(val, l.id, {}),
                                isSource: false
                            });
                        }
                        lParsedKfs[p] = _extends({}, kf, { v: val });
                    } else {
                        var defaultValue = parsedValues['l__' + l.id + '__' + attrKey];
                        if (defaultValue instanceof _DefAttrValue2.default) {
                            _this8.dependenyExecutionGraph.addNode({
                                nodeName: [prefix, attrKey, p, 'v'].join(subAttrKeySeperator),
                                value: {
                                    attrNode: defaultValue,
                                    attrType: AttrTypesForResolution.animation
                                },
                                dependentNames: _this8._getDepVars(defaultValue, l.id, {}),
                                isSource: false
                            });
                        } else if (defaultValue) {
                            var _iteratorNormalCompletion14 = true;
                            var _didIteratorError14 = false;
                            var _iteratorError14 = undefined;

                            try {
                                for (var _iterator14 = Object.keys(defaultValue)[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                                    var subAttrKey = _step14.value;

                                    _this8.dependenyExecutionGraph.addNode({
                                        nodeName: [prefix, attrKey, p, 'v', subAttrKey].join(subAttrKeySeperator),
                                        value: {
                                            attrNode: defaultValue[subAttrKey],
                                            attrType: AttrTypesForResolution.animation
                                        },
                                        dependentNames: _this8._getDepVars(defaultValue[subAttrKey], l.id, {}),
                                        isSource: false
                                    });
                                }
                            } catch (err) {
                                _didIteratorError14 = true;
                                _iteratorError14 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                                        _iterator14.return();
                                    }
                                } finally {
                                    if (_didIteratorError14) {
                                        throw _iteratorError14;
                                    }
                                }
                            }
                        }
                        lParsedKfs[p] = kf;
                    }
                });
                dest[attrKey] = lParsedKfs;
            });
        }
    }, {
        key: '_parseGlobalAnimationKeyframes',
        value: function _parseGlobalAnimationKeyframes(src, dest) {
            Object.keys(src).forEach(function (attrKey) {
                var kfs = src[attrKey];
                var lParsedKfs = {};
                Object.keys(kfs).forEach(function (p) {
                    var kf = kfs[p];
                    if (kf.hasOwnProperty('v')) {
                        lParsedKfs[p] = _extends({}, kf, {
                            v: _DefAttrValue.DefAttrValueRegistry.createDefAttrValue(kf.v, (0, _LayerUtils.getGlobalAttrConverter)(attrKey))
                        });
                    } else {
                        lParsedKfs[p] = kf;
                    }
                });
                dest[attrKey] = lParsedKfs;
            });
        }
    }, {
        key: '_getDepVars',
        value: function _getDepVars(v, lId, knownKeysMap) {
            return v.variables(knownKeysMap).map(function (depVar) {
                if (depVar === 'calcSelfHeight' || depVar === 'calcSelfWidth') {
                    return ['l__' + lId + '__fontFamily', 'l__' + lId + '__fontSize', 'l__' + lId + '__maxLines', 'l__' + lId + '__align', 'l__' + lId + '__lineSpacing', 'l__' + lId + '__lineHeightFactor', 'l__' + lId + '__layoutAlgo', 'l__' + lId + '__text', 'l__' + lId + '__maxWidth', 'l__' + lId + '__maxHeight', 'l__' + lId + '__letterSpacingFactor', 'l__' + lId + '__isCounterLayer', 'l__' + lId + '__isAscendingTimer', 'l__' + lId + '__timeFormat', 'l__' + lId + '__highlightColor', 'l__' + lId + '__highlightEnabled', 'l__' + lId + '__highlightTextColor', 'l__' + lId + '__higherCalorieOffset', 'l__' + lId + '__higherCalorieLimit', 'l__' + lId + '__lowerCalorieOffset', 'l__' + lId + '__lowerCalorieLimit'];
                }
                if (depVar === 'calcSelfShadowColor') {
                    return ['l__' + lId + '__fill'];
                }
                if (depVar === 'calcInterColor') {
                    return [];
                }
                if (depVar.startsWith('l__')) {
                    var _depVar$split = depVar.split('__'),
                        _depVar$split2 = _slicedToArray(_depVar$split, 3),
                        _$1 = _depVar$split2[0],
                        layerId = _depVar$split2[1],
                        layerAttr = _depVar$split2[2];

                    if (layerId === 'self') {
                        return 'l__' + lId + '__' + layerAttr;
                    }
                }
                return depVar;
            }).reduce(function (p, c) {
                return p.concat(c);
            }, []);
        }
    }, {
        key: '_prepareDepNodes',
        value: function _prepareDepNodes() {
            var _this9 = this;

            var depNodes = {};
            var _parsedDef = this.parsedDef,
                precalc = _parsedDef.precalc,
                props = _parsedDef.props;

            if (Object.keys(precalc).length > 0) {
                var knownPrecalcKeys = ['ow', 'oh'].concat(_toConsumableArray(Object.keys(props)));
                var knownPrecalcKeysMap = {};
                knownPrecalcKeys.forEach(function (k) {
                    if (!precalc.hasOwnProperty(k)) {
                        knownPrecalcKeysMap[k] = true;
                    }
                });

                Object.keys(precalc).forEach(function (k) {
                    var depVars = precalc[k].variables(knownPrecalcKeysMap);
                    if (depVars.length > 0) {
                        depNodes[k] = { depVars: depVars };
                    }
                });
            }

            var knownKeys = ['ow', 'oh'].concat(_toConsumableArray(Object.keys(props)));
            var knownKeysMap = {};
            knownKeys.forEach(function (k) {
                knownKeysMap[k] = true;
            });

            this.liveDepKeys = {};

            this.parsedDef.layers.forEach(function (l) {
                var lId = l.id,
                    _l$attrs2 = l.attrs,
                    attrs = _l$attrs2 === undefined ? {} : _l$attrs2;

                Object.keys(attrs).forEach(function (attrKey) {
                    var parsedValue = attrs[attrKey];
                    if (parsedValue.constructor === Object) {
                        var depVars = [];
                        Object.keys(parsedValue).forEach(function (subAttrKey) {
                            var subDepVars = _this9._getDepVars(attrs[attrKey][subAttrKey], lId, knownKeysMap);

                            if (subDepVars.length > 0) {
                                var subDepKey = 'l__' + lId + '__' + attrKey + subAttrKeySeperator + subAttrKey;
                                depNodes[subDepKey] = { depVars: subDepVars, selfLayerId: lId };

                                depVars.push(subDepKey);
                            }
                        });
                        if (depVars.length > 0) {
                            var depKey = 'l__' + lId + '__' + attrKey;
                            depNodes[depKey] = { depVars: depVars, selfLayerId: lId };
                        }
                    } else {
                        var _depVars = _this9._getDepVars(attrs[attrKey], lId, knownKeysMap);

                        if (_depVars.length > 0) {
                            var _depKey = 'l__' + lId + '__' + attrKey;
                            depNodes[_depKey] = { depVars: _depVars, selfLayerId: lId };
                        }
                    }
                });

                if (l.type === 'bmae') {
                    var _l$meta$reverseMappin2 = l.meta.reverseMappings,
                        reverseMappings = _l$meta$reverseMappin2 === undefined ? {} : _l$meta$reverseMappin2;

                    Object.keys(reverseMappings).forEach(function (rmKey) {
                        _this9.liveDepKeys['l__' + lId + '__' + rmKey] = true;
                    });
                }
            });

            this.depNodes = depNodes;

            this.dependencyGraph = new _DefAttrDependencyGraph2.default();

            Object.keys(this.liveDepKeys).forEach(function (depKey) {
                _this9.dependencyGraph.checkAndAddAttr(depKey, true);
            });

            Object.keys(this.depNodes).forEach(function (depKey) {
                var depVars = _this9.depNodes[depKey].depVars;

                _this9.dependencyGraph.checkAndAddAttr(depKey, _this9.liveDepKeys.hasOwnProperty(depKey));
                depVars.forEach(function (depVar) {
                    _this9.dependencyGraph.checkAndAddAttr(depVar, _this9.liveDepKeys.hasOwnProperty(depVar));
                    _this9.dependencyGraph.addAttrDependencyLink(depKey, depVar);
                });
            });
        }
    }, {
        key: '_processUpdate',
        value: function _processUpdate() {
            var _this10 = this;

            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                hasTimeChanged = _ref5.hasTimeChanged,
                _ref5$forceUpdate = _ref5.forceUpdate,
                forceUpdate = _ref5$forceUpdate === undefined ? false : _ref5$forceUpdate;

            // const timer = new Timer(); -- Used for profiling

            var _getScaleFromTransfor = (0, _LayerUtils.getScaleFromTransformString)(this.space.transform),
                _getScaleFromTransfor2 = _slicedToArray(_getScaleFromTransfor, 2),
                scaleX = _getScaleFromTransfor2[0],
                scaleY = _getScaleFromTransfor2[1];

            var _parsedDef2 = this.parsedDef,
                precalc = _parsedDef2.precalc,
                props = _parsedDef2.props;
            /// CREATING THE INPUT ARGUMENTS FOR THE DEPENDENY GRAPH
            // First figure out which all values we know for sure

            var knownKeys = ['ow', 'oh', 'ox', 'oy', 'cw', 'ch'].concat(_toConsumableArray(Object.keys(props)));
            var precalcKeys = Object.keys(precalc);
            if (precalcKeys.length > 0) {
                knownKeys = knownKeys.filter(function (k) {
                    return !precalc.hasOwnProperty(k);
                });
            }

            var resolvedDictTemp = Object.assign(this.resolvedDict, {
                calcInterColor: function calcInterColor() {
                    return _this10._calcInterColor.apply(_this10, arguments);
                }
            });

            var propArgs = {};

            var defDefaultValues = this.def.defaults || {};
            for (var i = 0, len = knownKeys.length; i < len; i += 1) {
                var k = knownKeys[i];
                if (k === 'ow') {
                    resolvedDictTemp[k] = this.space.width / scaleX;
                } else if (k === 'oh') {
                    resolvedDictTemp[k] = this.space.height / scaleY;
                } else if (k === 'ox') {
                    resolvedDictTemp[k] = this.space.x / scaleX;
                } else if (k === 'oy') {
                    resolvedDictTemp[k] = this.space.y / scaleY;
                } else if (k === 'cw') {
                    resolvedDictTemp[k] = this.canvas.width / scaleX;
                } else if (k === 'ch') {
                    resolvedDictTemp[k] = this.canvas.height / scaleY;
                } else if (props.hasOwnProperty(k)) {
                    resolvedDictTemp[k] = this.values.hasOwnProperty(k) ? this.values[k] : defDefaultValues[k];
                }
                propArgs[k] = resolvedDictTemp[k];
            }
            // CREATION OF ARGUMENT DONE

            var _dependenyExecutionGr = this.dependenyExecutionGraph.updateSourceValues(propArgs, this._processDefAttrNodeUpdate, {
                extraParams: {
                    resolvedDict: resolvedDictTemp,
                    parsedDef: this.parsedDef,
                    resolvedDef: this.resolvedDef,
                    space: this.space,
                    hasAnimationOverride: !!this.parsedDef.meta.canOverrideAnimation,
                    precalcKeys: precalcKeys,
                    scaleY: scaleY
                },
                forced: forceUpdate
            }),
                updatedResolvedDict = _dependenyExecutionGr.resolvedDict,
                updatedResolvedDef = _dependenyExecutionGr.resolvedDef;

            // Fot AutoHeight Calculation updating the space value


            if (precalc.oh) {
                this.space = _extends({}, this.space, {
                    height: updatedResolvedDict.oh * scaleY
                });
            }

            this.resolvedDict = updatedResolvedDict;
            this.resolvedDef = updatedResolvedDef;

            // Updating all the Layer Attributes incase they have not been updated
            this._updateLayersInfo();
        }
    }, {
        key: '_resolveAttributeValue',

        /**
         *
         *
         * @param {string | undefined} prefix
         * @param {string | undefined} layerId
         * @param {string | undefined} attribute
         * @param {DefAttrValue} defAttrValueNode
         * @param {Object} resolvedDict
         * @memberof DefModel
         */
        value: function _resolveAttributeValue(key, prefix, layerId, attribute, defAttrValueNode, resolvedDict) {
            var _this11 = this;

            var selfDict = layerId ? this.__selfDictLoopUp[layerId] || {} : {};
            if (layerId) {
                if (!this.__selfDictLoopUp[layerId]) {
                    this.__selfDictLoopUp[layerId] = selfDict;
                }

                selfDict.calcSelfHeight = function () {
                    return _this11._calcHeight(layerId, resolvedDict);
                };
                selfDict.calcSelfWidth = function () {
                    return _this11._calcWidth(layerId, resolvedDict);
                };
                selfDict.calcSelfShadowColor = function () {
                    return _this11._calcShadowColor(layerId, resolvedDict);
                };
            }

            var value = defAttrValueNode.resolve(resolvedDict, selfDict);
            selfDict[prefix + '__self__' + attribute] = value; // once resolve and stash it
            resolvedDict[key] = value;
            return value;
        }
    }, {
        key: '_resolveValue',
        value: function _resolveValue(key, parsedValues, resolvedDict, depNodes) {
            var _this12 = this;

            var avoidDependencyResolution = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            var forceResolve = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

            try {
                // Might be resolved already
                if (resolvedDict.hasOwnProperty(key) && !forceResolve) {
                    return;
                }
                var selfLayerId = null;
                if (depNodes.hasOwnProperty(key)) {
                    // There is some dependency
                    var _depNodes$key = depNodes[key],
                        depVars = _depNodes$key.depVars,
                        _depNodes$key$selfLay = _depNodes$key.selfLayerId,
                        sLId = _depNodes$key$selfLay === undefined ? null : _depNodes$key$selfLay;

                    selfLayerId = sLId;
                    if (!avoidDependencyResolution) {
                        var _iteratorNormalCompletion15 = true;
                        var _didIteratorError15 = false;
                        var _iteratorError15 = undefined;

                        try {
                            for (var _iterator15 = depVars[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                                var depVarKey = _step15.value;

                                if (!resolvedDict.hasOwnProperty(depVarKey)) {
                                    this._resolveValue(depVarKey, parsedValues, resolvedDict, depNodes);
                                }
                            }
                        } catch (err) {
                            _didIteratorError15 = true;
                            _iteratorError15 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                                    _iterator15.return();
                                }
                            } finally {
                                if (_didIteratorError15) {
                                    throw _iteratorError15;
                                }
                            }
                        }
                    }
                }
                var daValue = parsedValues[key];
                var selfDict = {};
                if (selfLayerId !== null) {
                    // TODO -- cache them since these function do not change -- not caching can result in minor GC
                    selfDict.calcSelfHeight = function () {
                        return _this12._calcHeight(selfLayerId, resolvedDict);
                    };
                    selfDict.calcSelfWidth = function () {
                        return _this12._calcWidth(selfLayerId, resolvedDict);
                    };
                    selfDict.calcSelfShadowColor = function () {
                        return _this12._calcShadowColor(selfLayerId, resolvedDict);
                    };

                    var _iteratorNormalCompletion16 = true;
                    var _didIteratorError16 = false;
                    var _iteratorError16 = undefined;

                    try {
                        for (var _iterator16 = daValue.variables(resolvedDict)[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                            var k = _step16.value;

                            var _k$split = k.split('__'),
                                _k$split2 = _slicedToArray(_k$split, 3),
                                _$1 = _k$split2[0],
                                layerId = _k$split2[1],
                                layerAttr = _k$split2[2];

                            if (layerId === 'self') {
                                // Pick the value from the resolved dict, would be already calculated
                                selfDict[k] = resolvedDict[_$1 + '__' + selfLayerId + '__' + layerAttr];
                            }
                        }
                    } catch (err) {
                        _didIteratorError16 = true;
                        _iteratorError16 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion16 && _iterator16.return) {
                                _iterator16.return();
                            }
                        } finally {
                            if (_didIteratorError16) {
                                throw _iteratorError16;
                            }
                        }
                    }
                }
                resolvedDict[key] = daValue.resolve(_extends({}, resolvedDict, selfDict));
            } catch (e) {
                console.log('Resolve value failed for ' + key);
                throw e;
            }
        }
    }, {
        key: '_resolveAnimationKeyframes',
        value: function _resolveAnimationKeyframes(l, src, dest, resolvedDict, kfDepKeyGen) {
            var layerAttrTypes = _LayerUtils.LAYER_ATTR_TYPES[l.type];
            // TODO -- verify why below code here ?? For attrs make sense , but otherwise not
            // if (l.type === 'bmae') {
            //     // Dynamic attrs supported
            //     const dyLayerAttrTypes = {};
            //     for (const attrKey of Object.keys(attrs)) {
            //         if (!layerAttrTypes.hasOwnProperty(attrKey)) {
            //             // Dynamic attr
            //             if (!!l.meta && !!l.meta.mappings && !!l.meta.mappings[attrKey]) {
            //                 const { type } = l.meta.mappings[attrKey];
            //                 dyLayerAttrTypes[attrKey] = type;
            //             }
            //         }
            //     }

            //     if (dyLayerAttrTypes) {
            //         layerAttrTypes = deepmerge(layerAttrTypes, dyLayerAttrTypes);
            //     }
            // }
            var _iteratorNormalCompletion17 = true;
            var _didIteratorError17 = false;
            var _iteratorError17 = undefined;

            try {
                for (var _iterator17 = Object.keys(src)[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                    var attrKey = _step17.value;

                    // attribute that is animated
                    var depAttrKey = 'l__' + l.id + '__' + attrKey;

                    var attrType = layerAttrTypes[attrKey];

                    var defaultValue = resolvedDict[depAttrKey];

                    var kfs = src[attrKey];
                    var lResolvedKfs = {};
                    var _iteratorNormalCompletion18 = true;
                    var _didIteratorError18 = false;
                    var _iteratorError18 = undefined;

                    try {
                        for (var _iterator18 = Object.keys(kfs)[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                            var p = _step18.value;

                            var kf = kfs[p];
                            if (kf.hasOwnProperty('v')) {
                                if (attrType.constructor === Object) {
                                    var kfDepKey = kfDepKeyGen(attrKey, p);

                                    var value = (0, _cloneextend.clone)(defaultValue);
                                    var _iteratorNormalCompletion19 = true;
                                    var _didIteratorError19 = false;
                                    var _iteratorError19 = undefined;

                                    try {
                                        for (var _iterator19 = Object.keys(kf.v)[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                                            var subAttrKey = _step19.value;

                                            var kfSubDepKey = kfDepKeyGen('' + attrKey + subAttrKeySeperator + subAttrKey, p);
                                            this._resolveValue(kfSubDepKey, _extends({}, this.parsedValues, _defineProperty({}, kfSubDepKey, kf.v[subAttrKey])), resolvedDict, {}, true, true);
                                            value[subAttrKey] = resolvedDict[kfSubDepKey];
                                        }
                                    } catch (err) {
                                        _didIteratorError19 = true;
                                        _iteratorError19 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion19 && _iterator19.return) {
                                                _iterator19.return();
                                            }
                                        } finally {
                                            if (_didIteratorError19) {
                                                throw _iteratorError19;
                                            }
                                        }
                                    }

                                    resolvedDict[kfDepKey] = value;

                                    lResolvedKfs[p] = _extends({}, kf, { v: value });
                                } else {
                                    var _kfDepKey = kfDepKeyGen(attrKey, p);
                                    this._resolveValue(_kfDepKey, _extends({}, this.parsedValues, _defineProperty({}, _kfDepKey, kf.v)), resolvedDict, {}, true, true);
                                    lResolvedKfs[p] = _extends({}, kf, { v: resolvedDict[_kfDepKey] });
                                }
                            } else {
                                lResolvedKfs[p] = _extends({}, kf, { v: defaultValue });
                            }
                        }
                    } catch (err) {
                        _didIteratorError18 = true;
                        _iteratorError18 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion18 && _iterator18.return) {
                                _iterator18.return();
                            }
                        } finally {
                            if (_didIteratorError18) {
                                throw _iteratorError18;
                            }
                        }
                    }

                    dest[attrKey] = lResolvedKfs;
                }
            } catch (err) {
                _didIteratorError17 = true;
                _iteratorError17 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion17 && _iterator17.return) {
                        _iterator17.return();
                    }
                } finally {
                    if (_didIteratorError17) {
                        throw _iteratorError17;
                    }
                }
            }
        }
    }, {
        key: '_resolveGlobalAnimationKeyframes',
        value: function _resolveGlobalAnimationKeyframes(src, dest, resolvedDict, kfDepKeyGen) {
            var _this13 = this;

            Object.keys(src).forEach(function (attrKey) {
                var depAttrKey = attrKey;

                var kfs = src[attrKey];
                var lResolvedKfs = {};
                Object.keys(kfs).forEach(function (p) {
                    var kf = kfs[p];
                    if (kf.hasOwnProperty('v')) {
                        var kfDepKey = kfDepKeyGen(attrKey, p);

                        _this13._resolveValue(kfDepKey, _extends({}, _this13.parsedValues, _defineProperty({}, kfDepKey, kf.v)), resolvedDict, {});
                        lResolvedKfs[p] = _extends({}, kf, { v: resolvedDict[kfDepKey] });
                    } else {
                        lResolvedKfs[p] = _extends({}, kf, { v: resolvedDict[depAttrKey] });
                    }
                });
                dest[attrKey] = lResolvedKfs;
            });
        }
    }, {
        key: '_updateLayerTimelines',
        value: function _updateLayerTimelines() {
            var _this14 = this;

            var globalValues = this._globalParametersUpdate();

            this.resolvedDef = _extends({}, this.resolvedDef, {
                global: globalValues
            });

            if (this.layerTimelines === null) {
                this.layerTimelines = {};
                this.detachedLayerTimelines = {};

                this.resolvedDef.layers.forEach(function (l) {
                    _this14._updateLayerAttributesBasedonTime(l);

                    var attrs = l.attrs,
                        animation = l.animation;

                    var timelines = {};
                    var detachedTimelines = {};
                    var tweenObjs = {};
                    var detachedTweenObjs = {};

                    Object.keys(attrs).forEach(function (attrKey) {
                        var enterKfs = animation.enterkeyframes[attrKey];
                        var exitKfs = animation.exitkeyframes[attrKey];

                        if (enterKfs || exitKfs) {
                            var layerAttrTypes = _LayerUtils.LAYER_ATTR_TYPES[l.type];
                            if (l.type === 'bmae') {
                                // Dynamic attrs supported
                                var dyLayerAttrTypes = {};
                                Object.keys(attrs).forEach(function (attrKey) {
                                    if (!layerAttrTypes.hasOwnProperty(attrKey)) {
                                        // Dynamic attr
                                        if (!!l.meta && !!l.meta.mappings && !!l.meta.mappings[attrKey]) {
                                            var type = l.meta.mappings[attrKey].type;

                                            dyLayerAttrTypes[attrKey] = type;
                                        }
                                    }
                                });
                                if (dyLayerAttrTypes) {
                                    layerAttrTypes = (0, _deepmerge2.default)(layerAttrTypes, dyLayerAttrTypes);
                                }
                            }

                            var attrType = layerAttrTypes[attrKey];

                            var tweenObj = {};
                            var detachedTweenObj = {};
                            var timeline = new TimelineMax();
                            var dTimeline = new TimelineMax();

                            timelines[attrKey] = timeline;
                            detachedTimelines[attrKey] = dTimeline;
                            tweenObjs[attrKey] = tweenObj;
                            detachedTweenObjs[attrKey] = detachedTweenObj;

                            _this14._updateAnimationForAttr(timeline, tweenObj, _this14.time, attrKey, attrType, attrs[attrKey], enterKfs, exitKfs, attrs);

                            _this14._updateAnimationForAttr(dTimeline, detachedTweenObj, _this14.time, attrKey, attrType, attrs[attrKey], enterKfs, exitKfs, attrs);

                            _this14.defTimeline.add(timeline, 0);
                            _this14.defDetachedTimeline.add(dTimeline, 0);
                        }
                    });

                    _this14.layerTimelines[l.id] = {
                        attrTimelines: timelines,
                        attrTweenObjs: tweenObjs
                    };

                    _this14.detachedLayerTimelines[l.id] = {
                        attrTimelines: detachedTimelines,
                        attrTweenObjs: detachedTweenObjs
                    };
                });
            } else {
                this.resolvedDef.layers.forEach(function (l) {
                    _this14._updateLayerAttributesBasedonTime(l);

                    var attrs = l.attrs,
                        animation = l.animation;

                    Object.keys(attrs).forEach(function (attrKey) {
                        var enterKfs = animation.enterkeyframes[attrKey];
                        var exitKfs = animation.exitkeyframes[attrKey];

                        if (enterKfs || exitKfs) {
                            var layerAttrTypes = _LayerUtils.LAYER_ATTR_TYPES[l.type];
                            if (l.type === 'bmae') {
                                // Dynamic attrs supported
                                var dyLayerAttrTypes = {};
                                Object.keys(attrs).forEach(function (attrKey) {
                                    if (!layerAttrTypes.hasOwnProperty(attrKey)) {
                                        // Dynamic attr
                                        if (!!l.meta && !!l.meta.mappings && !!l.meta.mappings[attrKey]) {
                                            var type = l.meta.mappings[attrKey].type;

                                            dyLayerAttrTypes[attrKey] = type;
                                        }
                                    }
                                });
                                if (dyLayerAttrTypes) {
                                    layerAttrTypes = (0, _deepmerge2.default)(layerAttrTypes, dyLayerAttrTypes);
                                }
                            }

                            var attrType = layerAttrTypes[attrKey];

                            var layerTimeline = _this14.layerTimelines[l.id];
                            var detachedLayerTimeline = _this14.detachedLayerTimelines[l.id];

                            layerTimeline.attrTimelines[attrKey].clear();
                            detachedLayerTimeline.attrTimelines[attrKey].clear();

                            _this14._updateAnimationForAttr(layerTimeline.attrTimelines[attrKey], layerTimeline.attrTweenObjs[attrKey], _this14.time, attrKey, attrType, attrs[attrKey], enterKfs, exitKfs, attrs);

                            _this14._updateAnimationForAttr(detachedLayerTimeline.attrTimelines[attrKey], detachedLayerTimeline.attrTweenObjs[attrKey], _this14.time, attrKey, attrType, attrs[attrKey], enterKfs, exitKfs, attrs);
                        }
                    });
                });
            }

            // GLOBAL attrs
            if (this.globalTimeline === null) {
                this.globalTimeline = {
                    attrTimelines: {},
                    attrTweenObjs: {}
                };
                this.detachedGlobalTimeline = {
                    attrTimelines: {},
                    attrTweenObjs: {}
                };
            }

            var _resolvedDef$global = this.resolvedDef.global,
                globalAttrs = _resolvedDef$global.attrs,
                globalAnimation = _resolvedDef$global.animation;

            _LayerUtils.GLOBAL_ATTRS_LIST.forEach(function (attrKey) {
                var enterKfs = globalAnimation.enterkeyframes[attrKey];
                var exitKfs = globalAnimation.exitkeyframes[attrKey];
                if (enterKfs || exitKfs) {
                    var attrType = _LayerUtils.GLOBAL_ATTR_TYPES[attrKey];
                    // add and/or update timelines
                    var timeline = null;
                    var dTimeline = null;
                    var tweenObj = null;
                    var detachedTweenObj = null;
                    if (!_this14.globalTimeline.attrTimelines.hasOwnProperty(attrKey)) {
                        tweenObj = {}, detachedTweenObj = {};
                        timeline = new TimelineMax(), dTimeline = new TimelineMax();

                        _this14.globalTimeline.attrTimelines[attrKey] = timeline;
                        _this14.globalTimeline.attrTweenObjs[attrKey] = tweenObj;
                        _this14.detachedGlobalTimeline.attrTimelines[attrKey] = dTimeline;
                        _this14.detachedGlobalTimeline.attrTweenObjs[attrKey] = detachedTweenObj;

                        _this14.defTimeline.add(timeline, 0);
                        _this14.defDetachedTimeline.add(dTimeline, 0);
                    } else {
                        tweenObj = _this14.globalTimeline.attrTweenObjs[attrKey];
                        timeline = _this14.globalTimeline.attrTimelines[attrKey];
                        detachedTweenObj = _this14.detachedGlobalTimeline.attrTweenObjs[attrKey];
                        dTimeline = _this14.detachedGlobalTimeline.attrTimelines[attrKey];

                        timeline.clear();
                        dTimeline.clear();
                    }
                    _this14._updateAnimationForAttr(timeline, tweenObj, _this14.time, attrKey, attrType, globalAttrs[attrKey], enterKfs, exitKfs);

                    _this14._updateAnimationForAttr(dTimeline, detachedTweenObj, _this14.time, attrKey, attrType, globalAttrs[attrKey], enterKfs, exitKfs);
                } else {
                    // remove or cleanup
                    if (_this14.globalTimeline.attrTimelines.hasOwnProperty(attrKey)) {
                        var _timeline = _this14.globalTimeline.attrTimelines[attrKey];
                        var _dTimeline = _this14.detachedGlobalTimeline.attrTimelines[attrKey];

                        _timeline.clear();
                        _dTimeline.clear();

                        _this14.defTimeline.remove(_timeline);
                        _this14.defDetachedTimeline.remove(_dTimeline);

                        delete _this14.globalTimeline.attrTimelines[attrKey];
                        delete _this14.globalTimeline.attrTweenObjs[attrKey];
                        delete _this14.detachedGlobalTimeline.attrTimelines[attrKey];
                        delete _this14.detachedGlobalTimeline.attrTweenObjs[attrKey];
                    }
                }
            });
        }
    }, {
        key: '_updateTime',
        value: function _updateTime() {
            if (this.rootTimeline === null) {
                var seekTime = this.time.enterdone;
                if ((0, _TimeUtils._fromGSAPtime)(this.defTimeline.time()) !== seekTime) {
                    this.defTimeline.seek((0, _TimeUtils._toGSAPtime)(seekTime));
                    this.defTimeline.render();
                }
            } else if (this.rootTimelineForceRenderFunc) {
                this.rootTimelineForceRenderFunc();
            }
        }
    }, {
        key: '_updateAnimationForAttr',
        value: function _updateAnimationForAttr(timeline, tweenObj, timeParams, attrKey, attrType, attrValue, enterKfs, exitKfs) {
            var allAttrs = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
            var enterstart = timeParams.enterstart,
                enterdone = timeParams.enterdone,
                exitstart = timeParams.exitstart,
                exitdone = timeParams.exitdone;

            var hasEnterKfs = !!enterKfs;
            var hasExitKfs = !!exitKfs;

            var defaultValue = attrValue;

            var attrValueKey = 'value';
            if (attrType === 'path') {
                attrValueKey = 'morphSVG';
                tweenObj.valueKey = attrValueKey;
                tweenObj[attrValueKey] = (0, _cloneextend.clone)(defaultValue);
            } else if (attrType.constructor === Object && attrType.type === 'strokerangeprops') {
                attrValueKey = 'strokeRangeProps';
                tweenObj.valueKey = attrValueKey;
                tweenObj[attrValueKey] = _extends({}, (0, _cloneextend.clone)(defaultValue), { path: allAttrs.d });
            } else {
                tweenObj.valueKey = attrValueKey;
                tweenObj[attrValueKey] = (0, _cloneextend.clone)(defaultValue);
            }

            var keyframes = [];

            if (hasEnterKfs) {
                var hasPre = enterKfs.hasOwnProperty('pre');

                Object.keys(enterKfs).sort(function (p1, p2) {
                    if (p1 === 'pre' || p2 === 'pre') {
                        return p1 !== 'pre';
                    }
                    return (0, _LayerUtils.toFloat)(p1) > (0, _LayerUtils.toFloat)(p2);
                }).forEach(function (p) {
                    var v = enterKfs[p].v;

                    if (p === 'pre') {
                        keyframes.push({ v: v, time: 0, type: 'set' });
                    } else {
                        var percent = (0, _LayerUtils.toFloat)(p.substr(0, p.length - 1));

                        var time = Math.round((enterdone - enterstart) * (percent / 100)) + enterstart;

                        if (percent === 0) {
                            if (!hasPre) {
                                keyframes.push({ v: v, time: 0, type: 'set' });
                            }
                            keyframes.push({ v: v, time: time, type: 'set' });
                        } else {
                            keyframes.push(_extends({}, enterKfs[p], {
                                v: v,
                                time: time,
                                type: 'fromTo'
                            }));
                        }
                    }
                });
            } else {
                keyframes.push({ v: defaultValue, time: 0, type: 'set' });
                keyframes.push({ v: defaultValue, time: enterstart, type: 'set' });
            }

            if (hasExitKfs) {
                keyframes.push({ v: defaultValue, time: exitstart, type: 'set' });

                Object.keys(exitKfs).sort(function (p1, p2) {
                    if (p1 === 'pre' || p2 === 'pre') {
                        return p1 !== 'pre';
                    }
                    return (0, _LayerUtils.toFloat)(p1) > (0, _LayerUtils.toFloat)(p2);
                }).forEach(function (p) {
                    var v = exitKfs[p].v;

                    if (p === 'pre') {
                        keyframes.push({ v: v, time: exitstart, type: 'set' });
                    } else {
                        var percent = (0, _LayerUtils.toFloat)(p.substr(0, p.length - 1));

                        var time = Math.round((exitdone - exitstart) * (percent / 100)) + exitstart;

                        keyframes.push(_extends({}, exitKfs[p], {
                            v: v,
                            time: time,
                            type: 'fromTo'
                        }));
                    }
                });
            } else {
                keyframes.push({ v: defaultValue, time: exitstart, type: 'set' });
            }

            var prevKft = -1;
            var prevVal = null;
            keyframes.forEach(function (kf) {
                var v = kf.v,
                    time = kf.time,
                    type = kf.type,
                    kfParams = _objectWithoutProperties(kf, ['v', 'time', 'type']);

                var kft = time;
                var value = v;

                if (type === 'set') {
                    if (Array.isArray(value)) {
                        for (var i = 0; i < value.length; i++) {
                            var _timeline$set;

                            timeline.set(tweenObj[attrValueKey], (_timeline$set = {}, _defineProperty(_timeline$set, i, value[i]), _defineProperty(_timeline$set, 'immediateRender', false), _timeline$set), (0, _TimeUtils._toGSAPtime)(kft));
                        }
                    } else {
                        var _timeline$set2;

                        timeline.set(tweenObj, (_timeline$set2 = {}, _defineProperty(_timeline$set2, attrValueKey, value), _defineProperty(_timeline$set2, 'immediateRender', false), _timeline$set2), (0, _TimeUtils._toGSAPtime)(kft));
                    }
                } else if (type === 'fromTo') {
                    var duration = kft - prevKft;
                    var ease = (0, _LayerUtils.toEase)(kfParams.ease, 'Quad.easeOut');
                    if (Array.isArray(value)) {
                        for (var _i2 = 0; _i2 < value.length; _i2++) {
                            var _timeline$fromTo2;

                            timeline.fromTo(tweenObj[attrValueKey], (0, _TimeUtils._toGSAPtime)(duration), _defineProperty({}, _i2, prevVal[_i2]), (_timeline$fromTo2 = {}, _defineProperty(_timeline$fromTo2, _i2, value[_i2]), _defineProperty(_timeline$fromTo2, 'ease', ease), _defineProperty(_timeline$fromTo2, 'immediateRender', false), _timeline$fromTo2), (0, _TimeUtils._toGSAPtime)(prevKft));
                        }
                    } else {
                        var _timeline$fromTo4;

                        timeline.fromTo(tweenObj, (0, _TimeUtils._toGSAPtime)(duration), _defineProperty({}, attrValueKey, prevVal), (_timeline$fromTo4 = {}, _defineProperty(_timeline$fromTo4, attrValueKey, value), _defineProperty(_timeline$fromTo4, 'ease', ease), _defineProperty(_timeline$fromTo4, 'immediateRender', false), _timeline$fromTo4), (0, _TimeUtils._toGSAPtime)(prevKft));
                    }
                } else {
                    throw new Error('Unknown type of keyframe');
                }
                prevKft = kft;
                prevVal = value;
            });
        }
    }, {
        key: '_updateTextValues',
        value: function _updateTextValues(layerId, resolvedDict) {
            var fontFamily = resolvedDict['l__' + layerId + '__fontFamily'];
            var fontSize = resolvedDict['l__' + layerId + '__fontSize'];
            var maxLines = resolvedDict['l__' + layerId + '__maxLines'];
            var align = resolvedDict['l__' + layerId + '__align'];
            var lineSpacing = resolvedDict['l__' + layerId + '__lineSpacing'];
            var lineHeightFactor = resolvedDict['l__' + layerId + '__lineHeightFactor'];
            var letterSpacingFactor = resolvedDict['l__' + layerId + '__letterSpacingFactor'];
            var layoutAlgo = resolvedDict['l__' + layerId + '__layoutAlgo'];
            var text = resolvedDict['l__' + layerId + '__text'];

            var maxWidth = resolvedDict['l__' + layerId + '__maxWidth'];
            var maxHeight = resolvedDict['l__' + layerId + '__maxHeight'];
            var isCounterLayer = resolvedDict['l__' + layerId + '__isCounterLayer'];
            var isAscendingTimer = resolvedDict['l__' + layerId + '__isAscendingTimer'];
            var timeFormat = resolvedDict['l__' + layerId + '__timeFormat'];
            var lowerCalorieLimit = resolvedDict['l__' + layerId + '_lowerCalorieLimit'];
            var lowerCalorieOffset = resolvedDict['l__' + layerId + '__lowerCalorieOffset'];
            var higherCalorieLimit = resolvedDict['l__' + layerId + '__higherCalorieLimit'];
            var higherCalorieOffset = resolvedDict['l__' + layerId + '__higherCalorieOffset'];

            this.layerInfos[layerId].update({
                fontFamily: fontFamily,
                fontSize: fontSize,
                lineSpacing: lineSpacing,
                align: align,
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                maxLines: maxLines,
                text: text,
                lineHeightFactor: lineHeightFactor,
                layoutAlgo: layoutAlgo,
                letterSpacingFactor: letterSpacingFactor,
                isCounterLayer: isCounterLayer,
                isAscendingTimer: isAscendingTimer,
                timeFormat: timeFormat,
                lowerCalorieLimit: lowerCalorieLimit,
                lowerCalorieOffset: lowerCalorieOffset,
                higherCalorieLimit: higherCalorieLimit,
                higherCalorieOffset: higherCalorieOffset,
                templateType: this.def.meta.templateType
            });
        }
    }, {
        key: '_calcHeight',
        value: function _calcHeight(layerId, resolvedDict) {
            this._updateTextValues(layerId, resolvedDict);

            return this.layerInfos[layerId].totalHeight;
        }
    }, {
        key: '_calcWidth',
        value: function _calcWidth(layerId, resolvedDict) {
            this._updateTextValues(layerId, resolvedDict);

            return this.layerInfos[layerId].totalWidth;
        }
    }, {
        key: '_calcShadowColor',
        value: function _calcShadowColor(layerId, resolvedDict) {
            var fillColor = '#000';

            var _def$layers$find = this.def.layers.find(function (l) {
                return l.id === layerId;
            }),
                type = _def$layers$find.type;

            if (type === 'text') {
                fillColor = resolvedDict['l__' + layerId + '__fill'].defaultColor;
            } else {
                fillColor = resolvedDict['l__' + layerId + '__fill'];
            }

            var strokeColor = resolvedDict['l__' + layerId + '__stroke'];
            var strokeAlpha = resolvedDict['l__' + layerId + '__strokeAlpha'];
            var strokeWidth = resolvedDict['l__' + layerId + '__strokeWidth'];

            var useStrokeColor = strokeAlpha > 0 && strokeWidth > 0;
            var color = useStrokeColor ? strokeColor : fillColor;

            // console.log(`color ${color}`);

            var shadowColor = (0, _LayerUtils.calcBestShadowContrast)(color);

            // console.log(`shadowColor ${shadowColor}`);
            return shadowColor;
        }
    }, {
        key: '_calcInterColor',
        value: function _calcInterColor(color1, color2, color1Amt, color2Amt) {
            var clr1 = (0, _color2.default)(color1).rgb().object();
            var clr2 = (0, _color2.default)(color2).rgb().object();

            var resClr = (0, _color2.default)({
                r: clr1.r * color1Amt + clr2.r * color2Amt,
                g: clr1.g * color1Amt + clr2.g * color2Amt,
                b: clr1.b * color1Amt + clr2.b * color2Amt
            });
            return resClr;
        }
    }]);

    return DefModel;
}();

exports.default = DefModel;

},{"../GeneralUtils":77,"../TimeUtils":89,"../scheduler/Timer":125,"./DefAttrDependencyGraph":116,"./DefAttrExecutionOrder":117,"./DefAttrValue":118,"./LayerUtils":121,"cloneextend":412,"color":418,"deep-freeze":548,"deepmerge":549,"keymirror":677}],120:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
        } else {
            return get(parent, property, receiver);
        }
    } else if ("value" in desc) {
        return desc.value;
    } else {
        var getter = desc.get;if (getter === undefined) {
            return undefined;
        }return getter.call(receiver);
    }
};

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

exports.createLayerRenderer = createLayerRenderer;

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _snapsvg = require('snapsvg');

var _snapsvg2 = _interopRequireDefault(_snapsvg);

var _bodymovin = require('bodymovin');

var _bodymovin2 = _interopRequireDefault(_bodymovin);

var _cloneextend = require('cloneextend');

var _LayerUtils = require('./LayerUtils');

var _Matrix3D = require('../Matrix3D');

var _Matrix3D2 = _interopRequireDefault(_Matrix3D);

var _AllSourcePlayer = require('../players/AllSourcePlayer');

var _AllSourcePlayer2 = _interopRequireDefault(_AllSourcePlayer);

var _AudioRegistry = require('../../components/AudioRegistry');

var _AudioRegistry2 = _interopRequireDefault(_AudioRegistry);

var _GeneralUtils = require('../GeneralUtils');

var _SVGManager = require('../assetsManager/SVGManager');

var _SVGManager2 = _interopRequireDefault(_SVGManager);

var _polyfill = require('../scheduler/polyfill');

var _SVGCanvasRenderer = require('./SVGCanvasRenderer');

var _SVGCanvasRenderer2 = _interopRequireDefault(_SVGCanvasRenderer);

var _DefModel = require('./DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var dlog = (0, _GeneralUtils.createDlog)(true);

var PIXEL_RATIO = function () {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;

    var WWCGAW_FACTOR = window.RENDER_MODE ? 1 : 1; // 'What We Can Get Away With' factor, better for performance

    return (window.devicePixelRatio || 1) / backingStore * WWCGAW_FACTOR;
}();

function createLayerRenderer(layer, defModel, invalidateFunc) {
    var type = layer.type;

    if (type === 'rect') return new RectLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'ellipse') return new EllipseLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'path') return new PathLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'text') return new TextLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'bitmap') return new BitmapLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'bmae') return new BodymovinLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'svg') return new SvgLayerRenderer(layer, defModel, invalidateFunc);
    if (type === 'audio') return new AudioLayerRenderer(layer, defModel, invalidateFunc);

    throw new Error('Unknown layer type');
}

var getUseStatic = function getUseStatic(selected, paused) {
    if (window.LAYER_DEV_MODE) {
        return selected;
    }
    return paused;
};

var areColorsEqual = function areColorsEqual(c1, c2) {
    var cc1 = (0, _color2.default)(c1);
    var cc2 = (0, _color2.default)(c2);
    if (cc1.valpha !== cc2.valpha) {
        return false;
    }
    return cc1.hex().toString() === cc2.hex().toString();
};

/**
 * Does basic preset and calculation for settting up a layer
 *
 * @class BaseLayerRenderer
 */

var BaseLayerRenderer = function () {
    /**
     * Creates an instance of BaseLayerRenderer.
     * @param {*} layer
     * @param {DefModel} defModel
     * @param {() => {}} invalidateFunc
     * @param {() => HTMLCanvasElement} [canvasCreator=() => document.createElement('canvas')]
     * @memberof BaseLayerRenderer
     */
    function BaseLayerRenderer(layer, defModel, invalidateFunc) {
        var canvasCreator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
            return document.createElement('canvas');
        };

        _classCallCheck(this, BaseLayerRenderer);

        this.__destroy = function () {
            // implement if needed to cleanup layer resouces
        };

        this.layer = layer;
        this.defModel = defModel;
        this.invalidateFunc = invalidateFunc;

        var shy = !!(layer.meta && layer.meta.shy);
        var hasMask = !!(layer.meta && layer.meta.masks && layer.meta.masks.length);

        // We need a canvas for the layer. Create and dummy initialize
        var canvas = canvasCreator();
        canvas.setAttribute('layer-id', layer.id);
        canvas.width = 0;
        canvas.height = 0;
        (0, _LayerUtils.applyCss)(canvas, 'position', 'absolute');
        (0, _LayerUtils.applyCss)(canvas, 'width', '0px');
        (0, _LayerUtils.applyCss)(canvas, 'height', '0px');

        this.canvas = canvas;
        // this.canvasTemp = canvasTemp

        // Set some defaults for these
        this.displayScale = 0.292342342; // Arbitrary, but unlikely to be the next
        // value we receive
        this.reelCanvas = { width: 1, height: 1 };
        this.selected = false;
        this.paused = true;

        this.shy = shy;

        this.hasMask = hasMask;

        this.layerAttrsOrig = null;
        this.layerAttrs = null;
        this.globalAttrsOrig = null;
        this.globalAttrs = null;
        this.visible = false;
        this.space = null;

        this.layerInfo = null;
    }

    _createClass(BaseLayerRenderer, [{
        key: 'getCanvas',
        value: function getCanvas() {
            return this.canvas;
        }
    }, {
        key: 'isShy',
        value: function isShy() {
            return this.shy;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.__destroy();
            this.layerAttrsOrig = null;
            this.layerAttrs = null;
            this.globalAttrsOrig = null;
            this.globalAttrs = null;
            this.visible = false;
            this.space = null;

            this.layerInfo = null;

            this.canvas = null;
        }
    }, {
        key: 'invalidate',
        value: function invalidate() {
            this.dirty = true;

            this.invalidateFunc();
        }
    }, {
        key: 'update',
        value: function update(reelCanvas, displayScale, selected, paused) {
            var _this = this;

            var haveAttrsChanged = this.checkAttrDirty();

            var hasReelCanvasChanged = this.reelCanvas.width !== reelCanvas.width || this.reelCanvas.height !== reelCanvas.height;
            var hasSelectedChanged = this.selected !== selected;
            var hasPausedChanged = this.paused !== paused;

            var hasDisplayScaleChanged = this.displayScale !== displayScale;

            var useStatic = getUseStatic(selected, paused);

            this.layerAttrsOrig = this.defModel.getAttrsForLayer(this.layer.id, useStatic);
            this.layerAttrs = {};
            Object.keys(this.layerAttrsOrig).forEach(function (ak) {
                _this.layerAttrs[ak] = (0, _LayerUtils.convertLayerAttrValueForRender)(_this.layer.type, ak, _this.layerAttrsOrig[ak], _this.layer.meta);
            });

            this.globalAttrsOrig = this.defModel.getGlobalAttrs(useStatic);
            this.globalAttrs = {};
            Object.keys(this.globalAttrsOrig).forEach(function (ak) {
                _this.globalAttrs[ak] = (0, _LayerUtils.convertGlobalAttrValueForRender)(ak, _this.globalAttrsOrig[ak]); // convert each key based on property name to float or Path2d
            });

            this.visible = this.defModel.getVisibility(useStatic);
            this.space = this.defModel.space;
            this.layerInfo = this.defModel.getInfoForLayer(this.layer.id);

            this.selected = selected;
            this.paused = paused;
            this.reelCanvas = reelCanvas;
            this.displayScale = displayScale;

            this.dirty = haveAttrsChanged || hasReelCanvasChanged || hasDisplayScaleChanged || hasSelectedChanged || hasPausedChanged;
        }

        // TODO -- Similar to DefModel , this is doing lot of tallying
        // Easy to determine what has changed from DefModel , use DefModel to determine that

    }, {
        key: 'checkAttrDirty',
        value: function checkAttrDirty() {
            var useStatic = getUseStatic(this.selected, this.paused);

            var oldLayerAttrs = this.layerAttrsOrig;
            var oldGlobalAttrs = this.globalAttrsOrig;
            var oldVisible = this.visible;
            var oldSpace = this.space;
            var newLayerAttrs = this.defModel.getAttrsForLayer(this.layer.id, useStatic);
            var newGlobalAttrs = this.defModel.getGlobalAttrs(useStatic);
            var newVisible = this.defModel.getVisibility(useStatic);
            var newSpace = this.defModel.space;

            var hasLayerAttrsChanged = false;
            var hasGlobalAttrsChanged = false;
            var hasVisibilityChanged = false;
            var hasSpaceChanged = false;

            if (oldLayerAttrs === null) {
                hasLayerAttrsChanged = true;
                hasGlobalAttrsChanged = true;
                hasVisibilityChanged = true;
                hasSpaceChanged = true;
            } else {
                hasLayerAttrsChanged = Object.keys(oldLayerAttrs).find(function (attrKey) {
                    if (oldLayerAttrs[attrKey].constructor === Object) {
                        var changeFound = Object.keys(oldLayerAttrs[attrKey]).find(function (subAttrKey) {
                            return oldLayerAttrs[attrKey][subAttrKey] !== newLayerAttrs[attrKey][subAttrKey];
                        });
                        return !!changeFound;
                    }
                    return oldLayerAttrs[attrKey] !== newLayerAttrs[attrKey];
                });
                hasGlobalAttrsChanged = Object.keys(oldGlobalAttrs).find(function (attrKey) {
                    return oldGlobalAttrs[attrKey] !== newGlobalAttrs[attrKey];
                });
                hasVisibilityChanged = oldVisible !== newVisible;
                hasSpaceChanged = Object.keys(oldSpace).find(function (key) {
                    return oldSpace[key] !== newSpace[key];
                });
            }

            return hasSpaceChanged || hasGlobalAttrsChanged || hasVisibilityChanged || hasLayerAttrsChanged;
        }
    }, {
        key: 'invalidateIfChanged',
        value: function invalidateIfChanged() {
            var _this2 = this;

            var attrsDirty = this.checkAttrDirty();
            if (attrsDirty) {
                var useStatic = getUseStatic(this.selected, this.paused);

                this.layerAttrsOrig = this.defModel.getAttrsForLayer(this.layer.id, useStatic);
                this.layerAttrs = {};
                // TODO -- why copy all value why not reuse them ?? -- Change only what actually changed ??
                Object.keys(this.layerAttrsOrig).forEach(function (ak) {
                    _this2.layerAttrs[ak] = (0, _LayerUtils.convertLayerAttrValueForRender)(_this2.layer.type, ak, _this2.layerAttrsOrig[ak], _this2.layer.meta);
                });

                this.globalAttrsOrig = this.defModel.getGlobalAttrs(useStatic);
                // dlog(`Resolved Global Attrs :`, this.globalAttrs);
                this.globalAttrs = {};
                // TODO -- change only what actually have changed
                Object.keys(this.globalAttrsOrig).forEach(function (ak) {
                    _this2.globalAttrs[ak] = (0, _LayerUtils.convertGlobalAttrValueForRender)(ak, _this2.globalAttrsOrig[ak]);
                });

                this.visible = this.defModel.getVisibility(useStatic);
                this.space = this.defModel.space;
            }
            this.dirty = this.dirty || attrsDirty;
        }
    }, {
        key: 'renderLayer',
        value: function renderLayer() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var depLayerRenderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (!force && !this.dirty) {
                return;
            }

            var canvas = this.canvas,
                space = this.space,
                globalAttrs = this.globalAttrs,
                layerAttrs = this.layerAttrs,
                displayScale = this.displayScale;
            var visible = this.visible,
                selected = this.selected;

            var show = selected || visible;
            if (!show) {
                (0, _LayerUtils.applyCss)(canvas, 'visibility', 'hidden');
                this.dirty = false;
                return;
            }
            (0, _LayerUtils.applyCss)(canvas, 'visibility', 'visible');

            var ctx = canvas.getContext('2d');

            // First clear existing canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            var ol = space.x,
                ot = space.y,
                ow = space.width,
                oh = space.height,
                transform = space.transform,
                _space$rotateDeg = space.rotateDeg,
                rotateDeg = _space$rotateDeg === undefined ? 0 : _space$rotateDeg;

            var _getScaleFromTransfor = (0, _LayerUtils.getScaleFromTransformString)(transform),
                _getScaleFromTransfor2 = _slicedToArray(_getScaleFromTransfor, 2),
                scaleX = _getScaleFromTransfor2[0],
                scaleY = _getScaleFromTransfor2[1];

            var _getRenderOffsets = this.getRenderOffsets(layerAttrs),
                rOffLeft = _getRenderOffsets.leftOff,
                rOffTop = _getRenderOffsets.topOff,
                rOffRight = _getRenderOffsets.rightOff,
                rOffBottom = _getRenderOffsets.bottomOff;

            var w = (ow - rOffLeft + rOffRight) * displayScale;
            var h = (oh - rOffTop + rOffBottom) * displayScale;

            var cl = (ol + globalAttrs.gl_x + rOffLeft) * displayScale;
            var ct = (ot + globalAttrs.gl_y + rOffTop) * displayScale;

            // const xcOffset = (cl - Math.floor(cl)) * PIXEL_RATIO, ycOffset = (ct - Math.floor(ct)) * PIXEL_RATIO

            // Canvas Size is always maximised to the Overlay Size , minus the offset of the shadows

            (0, _LayerUtils.applyCss)(canvas, 'width', w + 'px'); // TODO - change to transform
            (0, _LayerUtils.applyCss)(canvas, 'height', h + 'px'); // TODO - change all of these to transform
            (0, _LayerUtils.applyCss)(canvas, 'left', cl + 'px'); // TODO - causing DOM reflow
            (0, _LayerUtils.applyCss)(canvas, 'top', ct + 'px'); // TODO - causing DOM reflow

            // Effective Canvas height and width
            var effCanvasWidth = w * PIXEL_RATIO;
            var effCanvasHeight = h * PIXEL_RATIO;

            // Do operations/drawing only if needed
            if (canvas.width !== effCanvasWidth) {
                canvas.width = effCanvasWidth;
            }
            if (canvas.height !== effCanvasHeight) {
                canvas.height = effCanvasHeight;
            }

            ctx.save();

            ctx.scale(PIXEL_RATIO * displayScale, PIXEL_RATIO * displayScale);

            ctx.translate(-rOffLeft, -rOffTop);

            // Apply gl transform

            var _globalAttrs$gl_trans = _slicedToArray(globalAttrs.gl_transformOrigin, 2),
                tOriginLeft = _globalAttrs$gl_trans[0],
                tOriginTop = _globalAttrs$gl_trans[1];

            tOriginLeft = (tOriginLeft - rOffLeft) * displayScale;
            tOriginTop = (tOriginTop - rOffTop) * displayScale;

            (0, _LayerUtils.applyCss)(canvas, 'transformOrigin', tOriginLeft + 'px ' + tOriginTop + 'px'); //

            var t_globalTranform = _Matrix3D2.default.fromTransform(globalAttrs.gl_transform);

            var rotateM = _Matrix3D2.default.create();

            _Matrix3D2.default.rotate(rotateM, rotateDeg);

            _Matrix3D2.default.multiply(rotateM, t_globalTranform, t_globalTranform);

            var f_tranformStr = _Matrix3D2.default.toTransform3D(t_globalTranform);

            (0, _LayerUtils.applyCss)(canvas, 'transform', f_tranformStr); // apply rotation on the global transform
            (0, _LayerUtils.applyCss)(canvas, 'perspective', globalAttrs.gl_transformPerspective + 'px');

            ctx.globalAlpha = globalAttrs.gl_alpha;

            var scaleM = { a: 1 / scaleX, b: 0, c: 0, d: 1 / scaleY, e: 0, f: 0 };
            // TODO If it's not dynamic cache the Clip path Value
            var clipPath2D = null;
            if (globalAttrs.gl_clipPath) {
                clipPath2D = new Path2D();
                clipPath2D.addPath(globalAttrs.gl_clipPath, scaleM);
            }

            ctx.scale(scaleX, scaleY);

            this.drawLayer(ctx, layerAttrs, clipPath2D);

            ctx.restore();
            // }

            var hasMask = this.hasMask;

            if (hasMask) {
                this.layer.meta.masks.forEach(function (mask) {
                    var mLayerId = mask.mLayerId,
                        mAlphaInv = mask.mAlphaInv;

                    var dlCanvas = depLayerRenderers.find(function (lr) {
                        return lr.layer.id === mLayerId;
                    }).getCanvas();
                    var dlCanvasLeft = parseFloat(dlCanvas.style.left); // TODO -- Horrible performance hit Memoize + avoid floats
                    var dlCanvasTop = parseFloat(dlCanvas.style.top);

                    var canvasLeft = parseFloat(canvas.style.left);
                    var canvasTop = parseFloat(canvas.style.top);

                    if (mAlphaInv === true) {
                        ctx.globalCompositeOperation = 'destination-out'; // TODO - sumbols possible ??
                    } else {
                        ctx.globalCompositeOperation = 'destination-in';
                    }

                    if (dlCanvas.width > 0 && dlCanvas.height > 0) {
                        ctx.drawImage(dlCanvas, (dlCanvasLeft - canvasLeft) * PIXEL_RATIO, (dlCanvasTop - canvasTop) * PIXEL_RATIO);
                    }
                });
            }

            ctx.restore();

            this.dirty = false;
        }
    }, {
        key: 'getRenderOffsets',
        value: function getRenderOffsets(attrs1, attrs2) {
            return { leftOff: 0, topOff: 0, rightOff: 0, bottomOff: 0 };
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            thr();
        }
    }]);

    return BaseLayerRenderer;
}();

var RectLayerRenderer = function (_BaseLayerRenderer) {
    _inherits(RectLayerRenderer, _BaseLayerRenderer);

    function RectLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, RectLayerRenderer);

        return _possibleConstructorReturn(this, (RectLayerRenderer.__proto__ || Object.getPrototypeOf(RectLayerRenderer)).call(this, layer, defModel, invalidateFunc));
    }

    _createClass(RectLayerRenderer, [{
        key: 'getRenderOffsets',
        value: function getRenderOffsets(layerAttrs) {
            var _getTransformedShadow = this.getTransformedShadowValues(layerAttrs),
                shadowEnabled = _getTransformedShadow.shadowEnabled,
                shadowOffsetX = _getTransformedShadow.shadowOffsetX,
                shadowOffsetY = _getTransformedShadow.shadowOffsetY,
                shadowBlur = _getTransformedShadow.shadowBlur;

            var _space = this.space,
                sWidth = _space.width,
                sHeight = _space.height,
                sTransform = _space.transform;

            var _getScaleFromTransfor3 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor4 = _slicedToArray(_getScaleFromTransfor3, 2),
                oScaleX = _getScaleFromTransfor4[0],
                oScaleY = _getScaleFromTransfor4[1];

            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height;
            var strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha;

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var strokeOffset = Math.ceil(strokeWidth / 2);

            var leftOff = x * oScaleX;
            var topOff = y * oScaleY;
            var rightOff = (x + width) * oScaleX - sWidth;
            var bottomOff = (y + height) * oScaleY - sHeight;

            if (!shadowEnabled && !shouldStroke) {
                return { leftOff: leftOff, topOff: topOff, rightOff: rightOff, bottomOff: bottomOff };
            }

            if (!shadowEnabled) {
                leftOff += -strokeOffset;
                topOff += -strokeOffset;
                rightOff += strokeOffset;
                bottomOff += strokeOffset;

                return { leftOff: leftOff, topOff: topOff, rightOff: rightOff, bottomOff: bottomOff };
            }

            shadowBlur = Math.abs(shadowBlur) * 1.5;

            return {
                leftOff: Math.min(shadowOffsetX - shadowBlur + leftOff, leftOff),
                topOff: Math.min(shadowOffsetY - shadowBlur + topOff, topOff),
                rightOff: Math.max(shadowOffsetX + shadowBlur + rightOff, rightOff),
                bottomOff: Math.max(shadowOffsetY + shadowBlur + bottomOff, bottomOff)
            };
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor5 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor6 = _slicedToArray(_getScaleFromTransfor5, 2),
                oScaleX = _getScaleFromTransfor6[0],
                oScaleY = _getScaleFromTransfor6[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height,
                cornerRadius = layerAttrs.cornerRadius;
            var fill = layerAttrs.fill,
                fillAlpha = layerAttrs.fillAlpha,
                stroke = layerAttrs.stroke,
                strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha,
                alpha = layerAttrs.alpha;
            var transform = layerAttrs.transform,
                clipPath = layerAttrs.clipPath;

            var glAlpha = ctx.globalAlpha;

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var shouldFill = fillAlpha > 0;

            if (shouldStroke) {
                ctx.lineWidth = strokeWidth;
                ctx.strokeStyle = (0, _color2.default)(stroke).alpha(strokeAlpha).string(); // TODO - chache it ??
            }

            if (shouldFill) {
                ctx.fillStyle = (0, _color2.default)(fill).alpha(fillAlpha).string(); // TODO - cache it ??
            }

            ctx.globalAlpha = glAlpha * alpha;

            if (clipPath2D) {
                ctx.clip(clipPath2D);
            }

            if (clipPath) {
                ctx.clip(clipPath);
            }

            var shadowEnabled = layerAttrs.shadowEnabled;

            if (shadowEnabled) {
                var _getTransformedShadow2 = this.getTransformedShadowValues(layerAttrs),
                    shadowColor = _getTransformedShadow2.shadowColor,
                    shadowAlpha = _getTransformedShadow2.shadowAlpha,
                    shadowOffsetX = _getTransformedShadow2.shadowOffsetX,
                    shadowOffsetY = _getTransformedShadow2.shadowOffsetY,
                    shadowBlur = _getTransformedShadow2.shadowBlur;

                ctx.shadowColor = (0, _color2.default)(shadowColor).alpha(shadowAlpha * glAlpha).string();
                ctx.shadowBlur = shadowBlur;
                ctx.shadowOffsetX = shadowOffsetX;
                ctx.shadowOffsetY = shadowOffsetY;
            }

            ctx.transform.apply(ctx, _toConsumableArray(transform));

            var path1 = new Path2D();
            // TODO path moves done repeatedly ?
            if (cornerRadius === 0) {
                path1.rect(x, y, width, height);
            } else {
                path1.moveTo(x + width - cornerRadius, y);
                path1.arcTo(x + width, y, x + width, y + height, cornerRadius);
                path1.arcTo(x + width, y + height, x + width - cornerRadius, y + height, cornerRadius);
                path1.lineTo(x + cornerRadius, y + height);
                path1.arcTo(x, y + height, x, y, cornerRadius);
                path1.arcTo(x, y, x + cornerRadius, y, cornerRadius);
                path1.closePath();
            }

            if (shouldFill) {
                ctx.fill(path1);
            }
            if (shouldStroke) {
                ctx.stroke(path1);
            }
        }
    }]);

    return RectLayerRenderer;
}(BaseLayerRenderer);

var EllipseLayerRenderer = function (_BaseLayerRenderer2) {
    _inherits(EllipseLayerRenderer, _BaseLayerRenderer2);

    function EllipseLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, EllipseLayerRenderer);

        return _possibleConstructorReturn(this, (EllipseLayerRenderer.__proto__ || Object.getPrototypeOf(EllipseLayerRenderer)).call(this, layer, defModel, invalidateFunc));
    }

    _createClass(EllipseLayerRenderer, [{
        key: 'getRenderOffsets',
        value: function getRenderOffsets(layerAttrs) {
            var _getTransformedShadow3 = this.getTransformedShadowValues(layerAttrs),
                shadowEnabled = _getTransformedShadow3.shadowEnabled,
                shadowOffsetX = _getTransformedShadow3.shadowOffsetX,
                shadowOffsetY = _getTransformedShadow3.shadowOffsetY,
                shadowBlur = _getTransformedShadow3.shadowBlur;

            var strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha;

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            if (!shadowEnabled && !shouldStroke) {
                return _get(EllipseLayerRenderer.prototype.__proto__ || Object.getPrototypeOf(EllipseLayerRenderer.prototype), 'getRenderOffsets', this).call(this, layerAttrs);
            }

            var strokeOffset = Math.ceil(strokeWidth / 2);

            if (!shadowEnabled) {
                return {
                    leftOff: -strokeOffset,
                    topOff: -strokeOffset,
                    rightOff: strokeOffset,
                    bottomOff: strokeOffset
                };
            }

            shadowBlur = Math.abs(shadowBlur) * 1.5;

            return {
                leftOff: Math.min(shadowOffsetX - shadowBlur - strokeOffset, 0),
                topOff: Math.min(shadowOffsetY - shadowBlur - strokeOffset, 0),
                rightOff: Math.max(shadowOffsetX + shadowBlur + strokeOffset, 0),
                bottomOff: Math.max(shadowOffsetY + shadowBlur + strokeOffset, 0)
            };
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor7 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor8 = _slicedToArray(_getScaleFromTransfor7, 2),
                oScaleX = _getScaleFromTransfor8[0],
                oScaleY = _getScaleFromTransfor8[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            var fill = layerAttrs.fill,
                fillAlpha = layerAttrs.fillAlpha,
                stroke = layerAttrs.stroke,
                strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha,
                alpha = layerAttrs.alpha;
            var transform = layerAttrs.transform;

            var glAlpha = ctx.globalAlpha;

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var shouldFill = fillAlpha > 0;

            if (shouldStroke) {
                ctx.lineWidth = strokeWidth;
                ctx.strokeStyle = (0, _color2.default)(stroke).alpha(strokeAlpha).string();
            }

            if (shouldFill) {
                ctx.fillStyle = (0, _color2.default)(fill).alpha(fillAlpha).string();
            }

            ctx.globalAlpha = glAlpha * alpha;

            ctx.transform.apply(ctx, _toConsumableArray(transform));

            if (clipPath2D) {
                ctx.clip(clipPath2D);
            }

            var shadowEnabled = layerAttrs.shadowEnabled;

            if (shadowEnabled) {
                var _getTransformedShadow4 = this.getTransformedShadowValues(layerAttrs),
                    shadowColor = _getTransformedShadow4.shadowColor,
                    shadowAlpha = _getTransformedShadow4.shadowAlpha,
                    shadowOffsetX = _getTransformedShadow4.shadowOffsetX,
                    shadowOffsetY = _getTransformedShadow4.shadowOffsetY,
                    shadowBlur = _getTransformedShadow4.shadowBlur;

                ctx.shadowColor = (0, _color2.default)(shadowColor).alpha(shadowAlpha * glAlpha).string();
                ctx.shadowBlur = shadowBlur;
                ctx.shadowOffsetX = shadowOffsetX;
                ctx.shadowOffsetY = shadowOffsetY;
            }

            var cx = layerAttrs.cx,
                cy = layerAttrs.cy,
                rx = layerAttrs.rx,
                ry = layerAttrs.ry;

            var path1 = new Path2D();
            path1.ellipse(cx, cy, rx, ry, 0, 0, 2 * Math.PI);

            if (shouldFill) {
                ctx.fill(path1);
            }

            if (shouldStroke) {
                ctx.stroke(path1);
            }
        }
    }]);

    return EllipseLayerRenderer;
}(BaseLayerRenderer);

var PathLayerRenderer = function (_BaseLayerRenderer3) {
    _inherits(PathLayerRenderer, _BaseLayerRenderer3);

    function PathLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, PathLayerRenderer);

        var _this5 = _possibleConstructorReturn(this, (PathLayerRenderer.__proto__ || Object.getPrototypeOf(PathLayerRenderer)).call(this, layer, defModel, invalidateFunc));

        _this5.lastPathStr = null;
        _this5.lastPathLength = 0.01;
        return _this5;
    }

    _createClass(PathLayerRenderer, [{
        key: '_calcLength',
        value: function _calcLength(pathStr) {
            try {
                // TODO - better way in today's data ???
                var svgStr = '<svg xmlns="http://www.w3.org/2000/svg">' + ('<path id="tp" d="' + pathStr + '"/></svg>');

                var pathEl = new DOMParser().parseFromString(svgStr, 'image/svg+xml').getElementById('tp');

                return pathEl.getTotalLength();
            } catch (err) {
                console.error(err); // Cannot calc length
                return 0.01;
            }
        }
    }, {
        key: '_getPathLength',
        value: function _getPathLength() {
            var pathStr = this.defModel.getLayerAttrValue(this.layer.id, 'd');

            if (this.lastPathStr === pathStr) {
                return this.lastPathLength;
            }
            var len = this._calcLength(pathStr);

            this.lastPathStr = pathStr;
            this.lastPathLength = len;

            return len;
        }
    }, {
        key: 'getRenderOffsets',
        value: function getRenderOffsets(layerAttrs) {
            var _getTransformedShadow5 = this.getTransformedShadowValues(layerAttrs),
                shadowEnabled = _getTransformedShadow5.shadowEnabled,
                shadowOffsetX = _getTransformedShadow5.shadowOffsetX,
                shadowOffsetY = _getTransformedShadow5.shadowOffsetY,
                shadowBlur = _getTransformedShadow5.shadowBlur;

            var strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha;

            var _layerAttrs$rotate = _slicedToArray(layerAttrs.rotate, 3),
                rotateAngle = _layerAttrs$rotate[0],
                rotateOriginX = _layerAttrs$rotate[1],
                rotateOriginY = _layerAttrs$rotate[2];

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var shouldRotate = rotateAngle != 0;

            if (!shadowEnabled && !shouldStroke && !shouldRotate) {
                return _get(PathLayerRenderer.prototype.__proto__ || Object.getPrototypeOf(PathLayerRenderer.prototype), 'getRenderOffsets', this).call(this, layerAttrs);
            }

            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height;

            var leftOff = 0;
            var topOff = 0;
            var rightOff = 0;
            var bottomOff = 0;

            var _space2 = this.space,
                sWidth = _space2.width,
                sHeight = _space2.height,
                sTransform = _space2.transform;

            var _getScaleFromTransfor9 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor10 = _slicedToArray(_getScaleFromTransfor9, 2),
                oScaleX = _getScaleFromTransfor10[0],
                oScaleY = _getScaleFromTransfor10[1];

            if (shouldRotate) {
                // let longestSide = Math.max(width,height)
                // let rotationOffset = 2 * Math.sqrt(2) * longestSide

                var rotationOffset = Math.max(width - height, height - width) + 100;

                leftOff = Math.min(leftOff, -rotationOffset * oScaleX);
                topOff = Math.min(topOff, -rotationOffset * oScaleY);
                rightOff = Math.max(rightOff, rotationOffset * oScaleX);
                bottomOff = Math.max(bottomOff, rotationOffset * oScaleY);

                // let m = new Snap.Matrix()
                // m.rotate(rotateAngle, rotateOriginX, rotateOriginY)
                //
                // let rotatedPath = Snap.path.map(`M${x},${y}h${width}v${height}h${-width}z${this.layerAttrsOrig.d}`, m)
                //
                // const bbox = Snap.path.getBBox(rotatedPath)
                //
                // leftOff = Math.min(leftOff, Math.floor(bbox.x * oScaleX))
                // topOff = Math.min(topOff, Math.floor(bbox.y * oScaleY))
                // rightOff = Math.max(rightOff, Math.ceil(bbox.x2 * oScaleX - sWidth))
                // bottomOff = Math.max(bottomOff, Math.ceil(bbox.y2 * oScaleY - sHeight))
            }

            var strokeLeftOff = 0;
            var strokeTopOff = 0;
            var strokeRightOff = 0;
            var strokeBottomOff = 0;

            if (shouldStroke) {
                var viewBox = layerAttrs.viewBox;

                var _viewBox = _slicedToArray(viewBox, 4),
                    vbx = _viewBox[0],
                    vby = _viewBox[1],
                    vbwidth = _viewBox[2],
                    vbheight = _viewBox[3];

                var ow = sWidth / oScaleX;
                var oh = sHeight / oScaleY;

                var bbox = _snapsvg2.default.path.getBBox(this.layerAttrsOrig.d);

                var bboxXScale = width / vbwidth * oScaleX;
                var bboxYScale = height / vbheight * oScaleY;

                var bbox_x = (bbox.x - vbx) * bboxXScale;
                var bbox_y = (bbox.y - vby) * bboxYScale;
                var bbox_x2 = (bbox.x2 - vbx) * bboxXScale;
                var bbox_y2 = (bbox.y2 - vby) * bboxYScale;
                var bbox_w = bbox.w * bboxXScale;
                var bbox_h = bbox.h * bboxYScale;

                bbox_x += x;
                bbox_y += y;
                bbox_x2 += x;
                bbox_y2 += y;

                var MIN_OFFSET = 15;

                var strokeOffsetH = Math.ceil(strokeWidth * oScaleX * 2.1 / 2);
                var strokeOffsetV = Math.ceil(strokeWidth * oScaleY * 2.1 / 2);

                strokeOffsetH = strokeOffsetH < MIN_OFFSET ? MIN_OFFSET : strokeOffsetH;
                strokeOffsetV = strokeOffsetV < MIN_OFFSET ? MIN_OFFSET : strokeOffsetV;

                strokeLeftOff = bbox_x - strokeOffsetH;
                strokeTopOff = bbox_y - strokeOffsetV;
                strokeRightOff = strokeOffsetH + (bbox_x2 - sWidth);
                strokeBottomOff = strokeOffsetV + (bbox_y2 - sHeight);

                if (!shadowEnabled) {
                    return {
                        leftOff: Math.min(leftOff, strokeLeftOff),
                        topOff: Math.min(topOff, strokeTopOff),
                        rightOff: Math.max(rightOff, strokeRightOff),
                        bottomOff: Math.max(bottomOff, strokeBottomOff)
                    };
                }
            }

            if (shadowEnabled) {
                shadowBlur = Math.abs(shadowBlur) * 3;
                return {
                    leftOff: Math.min(leftOff, shadowOffsetX - shadowBlur + strokeLeftOff),
                    topOff: Math.min(topOff, shadowOffsetY - shadowBlur + strokeTopOff),
                    rightOff: Math.max(rightOff, shadowOffsetX + shadowBlur + strokeRightOff),
                    bottomOff: Math.max(bottomOff, shadowOffsetY + shadowBlur + strokeBottomOff)
                };
            }

            return { leftOff: leftOff, topOff: topOff, rightOff: rightOff, bottomOff: bottomOff };
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor11 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor12 = _slicedToArray(_getScaleFromTransfor11, 2),
                oScaleX = _getScaleFromTransfor12[0],
                oScaleY = _getScaleFromTransfor12[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'getStrokeDash',
        value: function getStrokeDash(trimStart, trimEnd, pathLength) {
            trimStart = trimStart === -1 ? 0 : trimStart;
            trimEnd = trimEnd === -1 ? 100 : trimEnd;

            var offset = trimStart / 100 * pathLength;
            var dashFirst = Math.max((trimEnd - trimStart) / 100, 0) * pathLength;
            var dashSecond = pathLength;

            return [-offset, [dashFirst, dashSecond]];
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            var fill = layerAttrs.fill,
                fillAlpha = layerAttrs.fillAlpha,
                stroke = layerAttrs.stroke,
                strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha,
                alpha = layerAttrs.alpha;
            var transform = layerAttrs.transform;

            var glAlpha = ctx.globalAlpha;

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var shouldFill = fillAlpha > 0;

            if (shouldFill) {
                ctx.fillStyle = (0, _color2.default)(fill).alpha(fillAlpha).string();
            }

            ctx.globalAlpha = glAlpha * alpha;

            if (clipPath2D) {
                ctx.clip(clipPath2D);
            }

            var clipPath = layerAttrs.clipPath;

            if (clipPath) {
                ctx.clip(clipPath);
            }

            var shadowEnabled = layerAttrs.shadowEnabled;

            if (shadowEnabled) {
                var _getTransformedShadow6 = this.getTransformedShadowValues(layerAttrs),
                    shadowColor = _getTransformedShadow6.shadowColor,
                    shadowAlpha = _getTransformedShadow6.shadowAlpha,
                    shadowOffsetX = _getTransformedShadow6.shadowOffsetX,
                    shadowOffsetY = _getTransformedShadow6.shadowOffsetY,
                    shadowBlur = _getTransformedShadow6.shadowBlur;

                ctx.shadowColor = (0, _color2.default)(shadowColor).alpha(shadowAlpha * glAlpha).string();
                ctx.shadowBlur = shadowBlur;
                ctx.shadowOffsetX = shadowOffsetX;
                ctx.shadowOffsetY = shadowOffsetY;
            }

            ctx.transform.apply(ctx, _toConsumableArray(transform));

            ctx.save();

            if (shouldStroke) {
                var strokeTrimStart = layerAttrs.strokeTrimStart,
                    strokeTrimEnd = layerAttrs.strokeTrimEnd;
                var _layerAttrs$strokeRan = layerAttrs.strokeRangeProps,
                    strokeDashoffset = _layerAttrs$strokeRan.strokeDashoffset,
                    strokeDasharray = _layerAttrs$strokeRan.strokeDasharray;
                var strokeCap = layerAttrs.strokeCap;

                if (strokeTrimStart !== -1 || strokeTrimEnd !== -1) {
                    var len = this._getPathLength();

                    var _getStrokeDash = this.getStrokeDash(strokeTrimStart, strokeTrimEnd, len),
                        _getStrokeDash2 = _slicedToArray(_getStrokeDash, 2),
                        dashoffset = _getStrokeDash2[0],
                        dasharray = _getStrokeDash2[1];

                    ctx.lineDashOffset = dashoffset;
                    ctx.setLineDash(dasharray);
                } else {
                    ctx.lineDashOffset = strokeDashoffset;
                    ctx.setLineDash(strokeDasharray);
                }

                ctx.lineWidth = strokeWidth;
                ctx.strokeStyle = (0, _color2.default)(stroke).alpha(strokeAlpha).string();

                ctx.lineCap = strokeCap;
            }

            var d = layerAttrs.d,
                viewBox = layerAttrs.viewBox;

            var _viewBox2 = _slicedToArray(viewBox, 4),
                vbx = _viewBox2[0],
                vby = _viewBox2[1],
                vbwidth = _viewBox2[2],
                vbheight = _viewBox2[3];

            var _space3 = this.space,
                sWidth = _space3.width,
                sHeight = _space3.height,
                sTransform = _space3.transform;

            var _getScaleFromTransfor13 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor14 = _slicedToArray(_getScaleFromTransfor13, 2),
                oScaleX = _getScaleFromTransfor14[0],
                oScaleY = _getScaleFromTransfor14[1];

            var ow = sWidth / oScaleX;
            var oh = sHeight / oScaleY;

            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height;

            var _layerAttrs$rotate2 = _slicedToArray(layerAttrs.rotate, 3),
                rotateAngleInDegree = _layerAttrs$rotate2[0],
                rotateOriginX = _layerAttrs$rotate2[1],
                rotateOriginY = _layerAttrs$rotate2[2];

            var shouldRotate = rotateAngleInDegree != 0;
            if (shouldRotate) {
                ctx.translate(rotateOriginX, rotateOriginY);
                ctx.rotate(rotateAngleInDegree * Math.PI / 180);
                ctx.translate(-rotateOriginX, -rotateOriginY);
            }

            var _layerAttrs$translate = _slicedToArray(layerAttrs.translate, 2),
                translateX = _layerAttrs$translate[0],
                translateY = _layerAttrs$translate[1];

            ctx.translate(translateX, translateY);

            var _layerAttrs$scale = _slicedToArray(layerAttrs.scale, 4),
                _layerAttrs$scale$ = _layerAttrs$scale[0],
                scaleX = _layerAttrs$scale$ === undefined ? 1 : _layerAttrs$scale$,
                _layerAttrs$scale$2 = _layerAttrs$scale[1],
                scaleY = _layerAttrs$scale$2 === undefined ? 1 : _layerAttrs$scale$2,
                _layerAttrs$scale$3 = _layerAttrs$scale[2],
                scaleOriginX = _layerAttrs$scale$3 === undefined ? 0 : _layerAttrs$scale$3,
                _layerAttrs$scale$4 = _layerAttrs$scale[3],
                scaleOriginY = _layerAttrs$scale$4 === undefined ? 0 : _layerAttrs$scale$4;

            ctx.translate(scaleOriginX, scaleOriginY);
            ctx.scale(scaleX, scaleY);
            ctx.translate(-scaleOriginX, -scaleOriginY);

            ctx.translate(x, y);

            var scaleWidth = width / vbwidth;
            var scaleHeight = height / vbheight;

            ctx.scale(scaleWidth, scaleHeight);
            ctx.translate(-vbx, -vby);

            if (shouldFill) {
                ctx.fill(d);
            }

            if (shouldStroke) {
                ctx.stroke(d);
            }
            ctx.restore();
        }
    }]);

    return PathLayerRenderer;
}(BaseLayerRenderer);
// HIGHEST PRIORITY FOR OPTIMISING RENDER AND DOM FLUSH ACTIVITY
// TEXT LAYER IS THE MOST COMMON LAYER


var TextLayerRenderer = function (_BaseLayerRenderer4) {
    _inherits(TextLayerRenderer, _BaseLayerRenderer4);

    function TextLayerRenderer(layer, defModel) {
        _classCallCheck(this, TextLayerRenderer);

        return _possibleConstructorReturn(this, (TextLayerRenderer.__proto__ || Object.getPrototypeOf(TextLayerRenderer)).call(this, layer, defModel));
    }

    _createClass(TextLayerRenderer, [{
        key: 'getRenderOffsets',
        value: function getRenderOffsets(layerAttrs) {
            var _getTransformedShadow7 = this.getTransformedShadowValues(layerAttrs),
                shadowEnabled = _getTransformedShadow7.shadowEnabled,
                shadowOffsetX = _getTransformedShadow7.shadowOffsetX,
                shadowOffsetY = _getTransformedShadow7.shadowOffsetY,
                shadowBlur = _getTransformedShadow7.shadowBlur;

            var enterTextAnim = layerAttrs.enterTextAnim,
                exitTextAnim = layerAttrs.exitTextAnim,
                enterTextAnimType = layerAttrs.enterTextAnimType,
                exitTextAnimType = layerAttrs.exitTextAnimType;

            var _layerAttrs$rotate3 = _slicedToArray(layerAttrs.rotate, 3),
                rotateAngle = _layerAttrs$rotate3[0],
                _layerAttrs$rotate3$ = _layerAttrs$rotate3[1],
                rotateOriginX = _layerAttrs$rotate3$ === undefined ? 0 : _layerAttrs$rotate3$,
                _layerAttrs$rotate3$2 = _layerAttrs$rotate3[2],
                rotateOriginY = _layerAttrs$rotate3$2 === undefined ? 0 : _layerAttrs$rotate3$2;

            var shouldRotate = rotateAngle != 0;

            var hasCharacterDisplacement = this.layerInfo.getHasCharacterDisplacement();
            var hasLineDisplacement = this.layerInfo.getHasLineDisplacement();

            if (!shadowEnabled && !shouldRotate && enterTextAnim == 'none' && exitTextAnim == 'none' && !hasCharacterDisplacement && !hasLineDisplacement) {
                return _get(TextLayerRenderer.prototype.__proto__ || Object.getPrototypeOf(TextLayerRenderer.prototype), 'getRenderOffsets', this).call(this, layerAttrs);
            }

            var _space4 = this.space,
                sWidth = _space4.width,
                sHeight = _space4.height,
                sTransform = _space4.transform;

            var _getScaleFromTransfor15 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor16 = _slicedToArray(_getScaleFromTransfor15, 2),
                oScaleX = _getScaleFromTransfor16[0],
                oScaleY = _getScaleFromTransfor16[1];

            var x = layerAttrs.x,
                y = layerAttrs.y,
                maxWidth = layerAttrs.maxWidth,
                height = layerAttrs.height;

            var leftOff = 0;
            var topOff = 0;
            var rightOff = 0;
            var bottomOff = 0;

            if (shouldRotate) {
                // TODO -- convert to Matrix3D -- why use string parsing at all ??
                var m = new _snapsvg2.default.Matrix();
                m.rotate(rotateAngle, rotateOriginX, rotateOriginY);

                var rotatedPath = _snapsvg2.default.path.map('M' + x + ',' + y + 'h' + maxWidth + 'v' + height + 'h' + -maxWidth + 'z', m);

                var bbox = _snapsvg2.default.path.getBBox(rotatedPath);

                leftOff = Math.min(leftOff, Math.floor(bbox.x * oScaleX));
                topOff = Math.min(topOff, Math.floor(bbox.y * oScaleY));
                rightOff = Math.max(rightOff, Math.ceil(bbox.x2 * oScaleX - sWidth));
                bottomOff = Math.max(bottomOff, Math.ceil(bbox.y2 * oScaleY - sHeight));
            }
            // TODO - use SYmbols no string
            if (enterTextAnim == 'line' && enterTextAnimType == 'fromLeft' || exitTextAnim == 'line' && exitTextAnimType == 'toLeft') {
                leftOff = -(x + maxWidth);
            }
            if (enterTextAnim == 'line' && enterTextAnimType == 'fromTop' || exitTextAnim == 'line' && exitTextAnimType == 'toTop') {
                topOff = -(y + height);
            }
            if (enterTextAnim == 'line' && enterTextAnimType == 'fromRight' || exitTextAnim == 'line' && exitTextAnimType == 'toRight') {
                rightOff = sWidth + maxWidth;
            }
            if (enterTextAnim == 'line' && enterTextAnimType == 'fromBottom' || exitTextAnim == 'line' && exitTextAnimType == 'toBottom') {
                bottomOff = sHeight + height;
            }

            if (hasLineDisplacement) {
                bottomOff += 3 * height;
            }
            if (hasCharacterDisplacement) {
                leftOff += -3 * (x + maxWidth);
                topOff += -3 * (y + height);
                rightOff += 2 * maxWidth;
                bottomOff += height;
            }

            if (shadowEnabled) {
                shadowBlur = Math.abs(shadowBlur) * 2;
                return {
                    leftOff: Math.min(leftOff, shadowOffsetX - shadowBlur - leftOff),
                    topOff: Math.min(topOff, shadowOffsetY - shadowBlur - topOff),
                    rightOff: Math.max(rightOff, shadowOffsetX + shadowBlur + rightOff),
                    bottomOff: Math.max(bottomOff, shadowOffsetY + shadowBlur + rightOff)
                };
            }

            return { leftOff: leftOff, topOff: topOff, rightOff: rightOff, bottomOff: bottomOff };
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor17 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor18 = _slicedToArray(_getScaleFromTransfor17, 2),
                oScaleX = _getScaleFromTransfor18[0],
                oScaleY = _getScaleFromTransfor18[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            var fill = layerAttrs.fill,
                fillAlpha = layerAttrs.fillAlpha,
                stroke = layerAttrs.stroke,
                strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha,
                alpha = layerAttrs.alpha,
                transform = layerAttrs.transform;

            var glAlpha = ctx.globalAlpha;

            ctx.save();

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var shouldFill = fillAlpha > 0;

            if (shouldStroke) {
                ctx.lineWidth = strokeWidth;
                ctx.strokeStyle = (0, _color2.default)(stroke).alpha(strokeAlpha).string();
            }

            // if (shouldFill) {
            //     ctx.fillStyle = Color(fill).alpha(fillAlpha).string()
            // }

            ctx.globalAlpha = glAlpha * alpha;

            if (clipPath2D) {
                ctx.clip(clipPath2D);
            }

            var clipPath = layerAttrs.clipPath,
                clipPathRotate = layerAttrs.clipPathRotate;

            var _layerAttrs$clipPathR = _slicedToArray(layerAttrs.clipPathRotate, 3),
                clipPathRotateAngle = _layerAttrs$clipPathR[0],
                _layerAttrs$clipPathR2 = _layerAttrs$clipPathR[1],
                clipPathRotateOriginX = _layerAttrs$clipPathR2 === undefined ? 0 : _layerAttrs$clipPathR2,
                _layerAttrs$clipPathR3 = _layerAttrs$clipPathR[2],
                clipPathRotateOriginY = _layerAttrs$clipPathR3 === undefined ? 0 : _layerAttrs$clipPathR3;

            if (clipPath) {
                if (clipPathRotate != 0) {
                    // TODO -- cache in rotated clip path
                    var m = new _snapsvg2.default.Matrix();
                    m.rotate(clipPathRotateAngle, clipPathRotateOriginX, clipPathRotateOriginY);

                    var rotatedClipPath = _snapsvg2.default.path.map(this.layerAttrsOrig.clipPath, m);
                    ctx.clip((0, _LayerUtils.toPath)(rotatedClipPath.toString()));
                } else {
                    ctx.clip(clipPath);
                }
            }

            var x = layerAttrs.x,
                y = layerAttrs.y;

            var _layerAttrs$rotate4 = _slicedToArray(layerAttrs.rotate, 3),
                rotateAngleInDegree = _layerAttrs$rotate4[0],
                _layerAttrs$rotate4$ = _layerAttrs$rotate4[1],
                rotateOriginX = _layerAttrs$rotate4$ === undefined ? 0 : _layerAttrs$rotate4$,
                _layerAttrs$rotate4$2 = _layerAttrs$rotate4[2],
                rotateOriginY = _layerAttrs$rotate4$2 === undefined ? 0 : _layerAttrs$rotate4$2;

            var shouldRotate = rotateAngleInDegree !== 0;
            if (shouldRotate) {
                ctx.translate(rotateOriginX, rotateOriginY);
                ctx.rotate(rotateAngleInDegree * Math.PI / 180);
                ctx.translate(-rotateOriginX, -rotateOriginY);
            }

            var _layerAttrs$translate2 = _slicedToArray(layerAttrs.translate, 2),
                translateX = _layerAttrs$translate2[0],
                translateY = _layerAttrs$translate2[1];

            ctx.translate(translateX, translateY);

            var _layerAttrs$scale2 = _slicedToArray(layerAttrs.scale, 4),
                _layerAttrs$scale2$ = _layerAttrs$scale2[0],
                scaleX = _layerAttrs$scale2$ === undefined ? 1 : _layerAttrs$scale2$,
                _layerAttrs$scale2$2 = _layerAttrs$scale2[1],
                scaleY = _layerAttrs$scale2$2 === undefined ? 1 : _layerAttrs$scale2$2,
                _layerAttrs$scale2$3 = _layerAttrs$scale2[2],
                scaleOriginX = _layerAttrs$scale2$3 === undefined ? 0 : _layerAttrs$scale2$3,
                _layerAttrs$scale2$4 = _layerAttrs$scale2[3],
                scaleOriginY = _layerAttrs$scale2$4 === undefined ? 0 : _layerAttrs$scale2$4;

            ctx.translate(scaleOriginX, scaleOriginY);
            ctx.scale(scaleX, scaleY);
            ctx.translate(-scaleOriginX, -scaleOriginY);

            ctx.translate(x, y);

            var shadowEnabled = layerAttrs.shadowEnabled;

            if (shadowEnabled) {
                var _getTransformedShadow8 = this.getTransformedShadowValues(layerAttrs),
                    shadowColor = _getTransformedShadow8.shadowColor,
                    shadowAlpha = _getTransformedShadow8.shadowAlpha,
                    shadowOffsetX = _getTransformedShadow8.shadowOffsetX,
                    shadowOffsetY = _getTransformedShadow8.shadowOffsetY,
                    shadowBlur = _getTransformedShadow8.shadowBlur;

                ctx.shadowColor = (0, _color2.default)(shadowColor).alpha(shadowAlpha * glAlpha).string();
                ctx.shadowBlur = shadowBlur;
                ctx.shadowOffsetX = shadowOffsetX;
                ctx.shadowOffsetY = shadowOffsetY;
            }

            ctx.transform.apply(ctx, _toConsumableArray(transform));

            this.drawText(ctx, layerAttrs, shouldFill, shouldStroke);

            ctx.restore();
        }
    }, {
        key: 'drawText',
        value: function drawText(ctx, layerAttrs) {
            var _this7 = this;

            var shouldFill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var shouldStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var _layerInfo = this.layerInfo,
                textLayerLines = _layerInfo.textLayerLines,
                fontDirection = _layerInfo.fontDirection;

            // Get all attr values

            var lineSpacing = layerAttrs.lineSpacing,
                maxLines = layerAttrs.maxLines,
                colorRange = layerAttrs.fill,
                fillAlpha = layerAttrs.fillAlpha,
                stroke = layerAttrs.stroke,
                strokeAlpha = layerAttrs.strokeAlpha,
                bgAlpha = layerAttrs.bgAlpha,
                bgFill = layerAttrs.bgFill,
                fadeBackground = layerAttrs.fadeBackground;
            var enterTextAnim = layerAttrs.enterTextAnim,
                exitTextAnim = layerAttrs.exitTextAnim,
                enterTextAnimType = layerAttrs.enterTextAnimType,
                exitTextAnimType = layerAttrs.exitTextAnimType;
            var highlightEnabled = layerAttrs.highlightEnabled,
                highlightColor = layerAttrs.highlightColor,
                highlightTextColor = layerAttrs.highlightTextColor;

            var numLines = Math.min(textLayerLines.length, maxLines);

            // Calculate number of characters including new lines
            var numChars = textLayerLines.reduce(function (p, line) {
                return (
                    // Take into account new line chars
                    p + line.chars.length + (line.autoWrapsAtEnd ? 0 : 1)
                );
            }, 0);

            var lineYOffset = 0; // y offset to be used when drawing anything on the current line
            var charCounter = 0; // count of characters drawn so far

            // Check if we should add background
            var shouldAddBg = bgAlpha > 0;
            // If no background set, check if we need to add highlights
            var shouldHighlight = !shouldAddBg && highlightEnabled;

            var isRightToLeftFont = fontDirection === 'rtl';

            // const DEBUG_DRAW_LINE_BG = true

            var highlightPath = new Path2D();
            var highlightRects = [];
            if (shouldHighlight) {
                // TODO : move this to text layer utils
                // Calculate blocks to draw

                var highlightBlocks = this.layerInfo.getTweenedHighlightBoxes(getUseStatic(this.selected, this.paused));

                var _loop = function _loop(i) {
                    var _textLayerLines$i = textLayerLines[i],
                        lineHeight = _textLayerLines$i.lineHeight,
                        lineBaselineOffset = _textLayerLines$i.lineBaselineOffset,
                        lineHorizOffset = _textLayerLines$i.lineHorizOffset;

                    var _getTextTranslateFact = _this7.getTextTranslateFactor(layerAttrs, numLines, i),
                        _getTextTranslateFact2 = _getTextTranslateFact.translateX,
                        lineTranslateX = _getTextTranslateFact2 === undefined ? 0 : _getTextTranslateFact2,
                        _getTextTranslateFact3 = _getTextTranslateFact.translateY,
                        lineTranslateY = _getTextTranslateFact3 === undefined ? 0 : _getTextTranslateFact3;

                    highlightBlocks.filter(function (_ref) {
                        var lineIndex = _ref.lineIndex;
                        return i === lineIndex;
                    }).forEach(function (_ref2) {
                        var color = _ref2.color,
                            x = _ref2.x,
                            y = _ref2.y,
                            width = _ref2.width,
                            height = _ref2.height,
                            lineIndex = _ref2.lineIndex;

                        var r = {
                            x: x + lineHorizOffset + lineTranslateX,
                            y: y + lineYOffset + Math.floor(lineTranslateY) - lineBaselineOffset,
                            width: width,
                            height: height,
                            lineIndex: lineIndex,
                            color: color
                        };

                        highlightRects.push(r);

                        var hp = new Path2D();
                        hp.rect(r.x, r.y, r.width, r.height);

                        highlightPath.addPath(hp);
                    });

                    lineYOffset += lineHeight + lineSpacing;
                };

                for (var i = 0; i < numLines; i++) {
                    _loop(i);
                }
            }

            lineYOffset = 0;

            // Iterate through lines and draw each line

            var _loop2 = function _loop2(lineIndex) {
                // Get all calculated values for the line
                var _textLayerLines$lineI2 = textLayerLines[lineIndex],
                    lineHeight = _textLayerLines$lineI2.lineHeight,
                    lineWidth = _textLayerLines$lineI2.lineWidth,
                    lineBaselineOffset = _textLayerLines$lineI2.lineBaselineOffset,
                    lineHorizOffset = _textLayerLines$lineI2.lineHorizOffset,
                    chars = _textLayerLines$lineI2.chars,
                    autoWrapsAtEnd = _textLayerLines$lineI2.autoWrapsAtEnd;

                var isLastLine = lineIndex == numLines - 1;

                // For line by line fade animations, calculate the alpha factor
                var lineAlphaFactor = _this7.getTextAlphaFactor(layerAttrs, numLines, lineIndex);

                // Save before drawing each line
                ctx.save();

                // For line by line translate animations, calculate the translate values

                var _getTextTranslateFact7 = _this7.getTextTranslateFactor(layerAttrs, numLines, lineIndex),
                    _getTextTranslateFact8 = _getTextTranslateFact7.translateX,
                    lineTranslateX = _getTextTranslateFact8 === undefined ? 0 : _getTextTranslateFact8,
                    _getTextTranslateFact9 = _getTextTranslateFact7.translateY,
                    lineTranslateY = _getTextTranslateFact9 === undefined ? 0 : _getTextTranslateFact9;

                var _layerInfo$getTweened = _this7.layerInfo.getTweenedLineDisplacement(textLayerLines[lineIndex], getUseStatic(_this7.selected, _this7.paused)),
                    disp_yp = _layerInfo$getTweened.disp_yp;

                var disp_y = disp_yp * 3 * lineHeight;

                // move to the top left of the line content
                ctx.translate(lineHorizOffset + lineTranslateX, lineYOffset + Math.floor(lineTranslateY) - lineBaselineOffset + disp_y);

                if (shouldAddBg) {
                    // Add line background
                    // Save before adding line background
                    ctx.save();

                    // background to be drawn at a combined
                    var effectiveAlpha = lineAlphaFactor * bgAlpha;

                    var bg_color = (0, _color2.default)(bgFill);

                    if (fadeBackground && numLines > 1) {
                        // Do a differently faded background for each line

                        var bg_color_lum = bg_color.hsl().object().l;

                        // Based on luminosity, adjust the lighten factor
                        var lightenFactor = 0.4;
                        if (bg_color_lum < 30) {
                            lightenFactor = 0.6;
                        } else if (bg_color_lum < 50) {
                            lightenFactor = 0.5;
                        }

                        // set background fill for the line
                        ctx.fillStyle = bg_color.lighten(lineIndex / (numLines - 1) * lightenFactor).alpha(effectiveAlpha).string();
                    } else {
                        ctx.fillStyle = bg_color.alpha(effectiveAlpha).string();
                    }

                    var LINE_BG_PADDING_H = 50;

                    // Create the path for line background
                    var line_bg_path = new Path2D();
                    line_bg_path.rect(0, 0, lineWidth + LINE_BG_PADDING_H, Math.ceil(lineHeight));

                    // Apply x : horizontal offset, any line translations and padding adjustment,
                    //       y : line y from top of text area and any line translations
                    ctx.translate(-LINE_BG_PADDING_H / 2, 0);

                    // draw background
                    ctx.fill(line_bg_path);

                    // Restore after adding line background
                    ctx.restore();
                }

                if (shouldFill) {
                    // Fill characters

                    var _counter = charCounter;

                    chars.forEach(function (c, i) {
                        // Save before drawing each character
                        ctx.save();

                        // Get char alpha for any char by char fade animations
                        var charAlphaFactor = lineAlphaFactor;
                        if (enterTextAnim === 'char' || exitTextAnim === 'char') {
                            charAlphaFactor *= _this7.getTextAlphaFactor(layerAttrs, numChars, _counter + i);
                        }

                        var _layerInfo$getTweened2 = _this7.layerInfo.getTweenedCharacterDisplacement(c, getUseStatic(_this7.selected, _this7.paused)),
                            disp_xp = _layerInfo$getTweened2.disp_xp,
                            disp_yp = _layerInfo$getTweened2.disp_yp,
                            disp_alphap = _layerInfo$getTweened2.disp_alphap;

                        // const effectiveAlpha = charAlphaFactor * fillAlpha


                        var effectiveAlpha = charAlphaFactor * fillAlpha * disp_alphap;

                        // Translate to char's x and y relative to line's top left
                        // ctx.translate(c.x, c.y)
                        var disp_x = disp_xp * 1 * lineHeight * (1 - 2 * i / chars.length);
                        var disp_y = disp_yp * 1 * lineHeight;
                        ctx.translate(c.x + disp_x, c.y + disp_y);

                        var colorIndex = isRightToLeftFont ? _counter + (chars.length - i - 1) : _counter + i;

                        c.charPath2D.fill = (0, _color2.default)(colorRange.getColorForIndex(colorIndex)).alpha(effectiveAlpha).string();
                        c.charPath2D.stroke = null;
                        c.charPath2D.draw(ctx);

                        // Restore after drawing each character
                        ctx.restore();
                    });
                }

                if (shouldStroke) {
                    chars.forEach(function (c) {
                        // Save before drawing each character
                        ctx.save();

                        ctx.translate(c.x, c.y);

                        c.charPath2D.strokeWidth = ctx.lineWidth;
                        c.charPath2D.stroke = (0, _color2.default)(stroke).alpha(strokeAlpha).string();
                        c.charPath2D.fill = null;

                        c.charPath2D.draw(ctx);

                        // Restore after drawing each character
                        ctx.restore();
                    });
                }

                ctx.restore();

                // Add current line's height and spacing below it to y offset
                lineYOffset += lineHeight + lineSpacing;

                charCounter += chars.length + (autoWrapsAtEnd ? 0 : 1);
            };

            for (var lineIndex = 0; lineIndex < numLines; lineIndex += 1) {
                _loop2(lineIndex);
            }

            if (shouldHighlight) {
                // Add highlights

                ctx.shadowColor = 'rgba(0,0,0,0)';

                // Save before drawing highlights
                ctx.save();

                highlightRects.forEach(function (_ref3) {
                    var color = _ref3.color,
                        x = _ref3.x,
                        y = _ref3.y,
                        width = _ref3.width,
                        height = _ref3.height;

                    ctx.clearRect(x, y, width, height);

                    var blockRect = new Path2D();
                    blockRect.rect(x, y, width, height);

                    ctx.fillStyle = (0, _color2.default)(color).string();
                    ctx.fill(blockRect);
                });

                // Restore after drawing highlights
                ctx.restore();

                lineYOffset = 0;
                charCounter = 0;

                ctx.save();

                ctx.clip(highlightPath);

                // Iterate through lines and draw each line

                var _loop3 = function _loop3(lineIndex) {
                    // Get all calculated values for the line
                    var _textLayerLines$lineI = textLayerLines[lineIndex],
                        lineHeight = _textLayerLines$lineI.lineHeight,
                        lineWidth = _textLayerLines$lineI.lineWidth,
                        lineBaselineOffset = _textLayerLines$lineI.lineBaselineOffset,
                        lineHorizOffset = _textLayerLines$lineI.lineHorizOffset,
                        chars = _textLayerLines$lineI.chars,
                        autoWrapsAtEnd = _textLayerLines$lineI.autoWrapsAtEnd;

                    // Save before drawing each line

                    ctx.save();

                    // For line by line translate animations, calculate the translate values

                    var _getTextTranslateFact4 = _this7.getTextTranslateFactor(layerAttrs, numLines, lineIndex),
                        _getTextTranslateFact5 = _getTextTranslateFact4.translateX,
                        lineTranslateX = _getTextTranslateFact5 === undefined ? 0 : _getTextTranslateFact5,
                        _getTextTranslateFact6 = _getTextTranslateFact4.translateY,
                        lineTranslateY = _getTextTranslateFact6 === undefined ? 0 : _getTextTranslateFact6;

                    // move to the top left of the line content


                    ctx.translate(lineHorizOffset + lineTranslateX, lineYOffset + Math.floor(lineTranslateY) - lineBaselineOffset);

                    // Fill characters

                    var counter = charCounter;

                    chars.forEach(function (c, i) {
                        // Save before drawing each character
                        ctx.save();

                        // Get char alpha for any char by char fade animations
                        var charAlphaFactor = 1;
                        if (enterTextAnim == 'char' || exitTextAnim == 'char') {
                            charAlphaFactor = _this7.getTextAlphaFactor(layerAttrs, numChars, counter + i);
                        }

                        var effectiveAlpha = charAlphaFactor * fillAlpha;

                        // Translate to char's x and y relative to line's top left
                        ctx.translate(c.x, c.y);

                        ctx.save();

                        var colorIndex = isRightToLeftFont ? counter + (chars.length - i - 1) : counter + i;

                        var transparentColor = 'rgba(0,0,0,0)';

                        var highlightTextColorForChar = highlightTextColor.getColorForIndex(colorIndex);
                        var colorForChar = !!highlightTextColorForChar && areColorsEqual(highlightTextColorForChar, transparentColor) ? highlightTextColorForChar : colorRange.getColorForIndex(colorIndex);
                        var color = (0, _color2.default)(colorForChar);
                        c.charPath2D.fill = (0, _color2.default)(color).alpha(1).string();
                        c.charPath2D.stroke = null;
                        ctx.globalCompositeOperation = 'destination-out';
                        c.charPath2D.draw(ctx);

                        ctx.restore();

                        c.charPath2D.fill = (0, _color2.default)(color).alpha(color.valpha * effectiveAlpha).string();
                        c.charPath2D.stroke = null;
                        c.charPath2D.draw(ctx);

                        // Restore after drawing each character
                        ctx.restore();
                    });

                    ctx.restore();

                    // Add current line's height and spacing below it to y offset
                    lineYOffset += lineHeight + lineSpacing;

                    charCounter += chars.length + (autoWrapsAtEnd ? 0 : 1);
                };

                for (var lineIndex = 0; lineIndex < numLines; lineIndex++) {
                    _loop3(lineIndex);
                }

                ctx.restore();
            }
        }
    }, {
        key: 'getTextAlphaFactor',
        value: function getTextAlphaFactor(layerAttrs, numLines, currentLineIndex) {
            var enterTextAnim = layerAttrs.enterTextAnim,
                exitTextAnim = layerAttrs.exitTextAnim,
                enterTextAnimType = layerAttrs.enterTextAnimType,
                exitTextAnimType = layerAttrs.exitTextAnimType,
                visibleLineFactor = layerAttrs.visibleLineFactor;
            var _defModel$time = this.defModel.time,
                enterstart = _defModel$time.enterstart,
                enterdone = _defModel$time.enterdone,
                exitstart = _defModel$time.exitstart,
                exitdone = _defModel$time.exitdone;

            var currentTime = this.defModel.getTime();

            var isEntering = currentTime >= enterstart && currentTime <= enterdone;
            var isExiting = currentTime >= exitstart && currentTime <= exitdone;

            var textAlphaFactor = 1;

            if (isEntering && (enterTextAnim == 'line' || enterTextAnim == 'char') || isExiting && (exitTextAnim == 'line' || enterTextAnim == 'char')) {
                if (isEntering && enterTextAnimType == 'none' || isExiting && exitTextAnimType == 'none') {
                    textAlphaFactor = Math.max(0, Math.min(1, Math.ceil((visibleLineFactor - currentLineIndex / numLines) * numLines)));
                } else if (isEntering && enterTextAnimType == 'fade' || isExiting && exitTextAnimType == 'fade') {
                    textAlphaFactor = Math.max(0, Math.min(1, (visibleLineFactor - currentLineIndex / numLines) * numLines));
                }
            }
            return textAlphaFactor;
        }
    }, {
        key: 'getTextTranslateFactor',
        value: function getTextTranslateFactor(layerAttrs, numLines, currentLineIndex) {
            var enterTextAnim = layerAttrs.enterTextAnim,
                exitTextAnim = layerAttrs.exitTextAnim,
                enterTextAnimType = layerAttrs.enterTextAnimType,
                exitTextAnimType = layerAttrs.exitTextAnimType,
                visibleLineFactor = layerAttrs.visibleLineFactor;
            var _reelCanvas = this.reelCanvas,
                canvasWidth = _reelCanvas.width,
                canvasHeight = _reelCanvas.height;
            var _defModel$time2 = this.defModel.time,
                enterstart = _defModel$time2.enterstart,
                enterdone = _defModel$time2.enterdone,
                exitstart = _defModel$time2.exitstart,
                exitdone = _defModel$time2.exitdone;

            var currentTime = this.defModel.getTime();

            var isEntering = currentTime >= enterstart && currentTime <= enterdone;
            var isExiting = currentTime >= exitstart && currentTime <= exitdone;

            var translateX = 0;
            var translateY = 0;

            if (isEntering && enterTextAnim == 'line' || isExiting && exitTextAnim == 'line') {
                var offsetFactor = Math.max(0, Math.min(1, 1 - (visibleLineFactor - currentLineIndex / numLines) * numLines));

                if (isEntering && enterTextAnimType == 'fromLeft' || isExiting && exitTextAnimType == 'toLeft') {
                    translateX = -(canvasWidth * offsetFactor);
                } else if (isEntering && enterTextAnimType == 'fromRight' || isExiting && exitTextAnimType == 'toRight') {
                    translateX = canvasWidth * offsetFactor;
                } else if (isEntering && enterTextAnimType == 'fromTop' || isExiting && exitTextAnimType == 'toTop') {
                    translateY = -(canvasHeight * offsetFactor);
                } else if (isEntering && enterTextAnimType == 'fromBottom' || isExiting && exitTextAnimType == 'toBottom') {
                    translateY = canvasHeight * offsetFactor;
                }
            }

            return { translateX: translateX, translateY: translateY };
        }
    }]);

    return TextLayerRenderer;
}(BaseLayerRenderer);

var BitmapLayerRenderer = function (_BaseLayerRenderer5) {
    _inherits(BitmapLayerRenderer, _BaseLayerRenderer5);

    function BitmapLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, BitmapLayerRenderer);

        var _this8 = _possibleConstructorReturn(this, (BitmapLayerRenderer.__proto__ || Object.getPrototypeOf(BitmapLayerRenderer)).call(this, layer, defModel, invalidateFunc));

        _this8.currentBitmapRes = null;
        _this8.currentLoadingBitmapUrl = null;
        _this8.currentLoadedImage = null;
        _this8.currentImageId = null;

        _this8.onImageLoadedCallback = function () {
            return _this8.onImageLoad.apply(_this8, arguments);
        };
        return _this8;
    }

    _createClass(BitmapLayerRenderer, [{
        key: 'destroy',
        value: function destroy() {
            this.onImageLoadedCallback = function () {}; // no-op

            this.currentLoadedImage = null;
            this.currentBitmapRes = null;
            this.currentLoadingBitmapUrl = null;
            this.currentImageId = null;

            _get(BitmapLayerRenderer.prototype.__proto__ || Object.getPrototypeOf(BitmapLayerRenderer.prototype), 'destroy', this).call(this);
        }

        // getBitmapUrlForSize(imageId, width, height, cropEnabled) {
        //     // const baseUrl
        //     return getImageBaseUrlForId(imageId, width, height, cropEnabled)
        // }

    }, {
        key: 'prepareForRender',
        value: function prepareForRender() {
            var _this9 = this;

            if (window.RENDER_MODE) {
                var _imageId = this.defModel.getLayerAttrValue(this.layer.id, 'imageId', true);

                this.currentLoadedImage = getPreloadedBitmap(_imageId);
                return;
            }

            var _getScaleFromTransfor19 = (0, _LayerUtils.getScaleFromTransformString)(this.space.transform),
                _getScaleFromTransfor20 = _slicedToArray(_getScaleFromTransfor19, 2),
                scaleX = _getScaleFromTransfor20[0],
                scaleY = _getScaleFromTransfor20[1];

            var width = this.defModel.getLayerAttrValue(this.layer.id, 'width', true);
            var height = this.defModel.getLayerAttrValue(this.layer.id, 'height', true);
            var cropEnabled = this.defModel.getLayerAttrValue(this.layer.id, 'cropEnabled', true);
            var imageId = this.defModel.getLayerAttrValue(this.layer.id, 'imageId', true);

            var newBitmapRes = {
                width: scaleX * width * PIXEL_RATIO * this.displayScale,
                height: scaleY * height * PIXEL_RATIO * this.displayScale
            };

            var _getImageUrlForId = getImageUrlForId(imageId, newBitmapRes.width, newBitmapRes.height, cropEnabled),
                newBitmapUrl = _getImageUrlForId.imgUrl,
                isNewImgDeleted = _getImageUrlForId.deleted;

            var currentBitmapRes = this.currentBitmapRes,
                currentImageId = this.currentImageId;

            var shouldLoadNewBitmap = false;

            if (currentBitmapRes === null || currentImageId === null || currentImageId.length === 0) {
                shouldLoadNewBitmap = true;
            } else {
                var _getImageUrlForId2 = getImageUrlForId(currentImageId, currentBitmapRes.width, currentBitmapRes.height, cropEnabled),
                    currentUrl = _getImageUrlForId2.imgUrl,
                    isCurrentImgDeleted = _getImageUrlForId2.deleted;

                if (currentUrl !== newBitmapUrl || isNewImgDeleted !== isCurrentImgDeleted) {
                    shouldLoadNewBitmap = true;
                }
            }

            if (shouldLoadNewBitmap) {
                if (this.currentLoadingBitmapUrl !== newBitmapUrl) {
                    this.currentLoadingBitmapUrl = newBitmapUrl;
                    this.currentBitmapRes = newBitmapRes;
                    this.currentImageId = imageId;

                    // OLDER METHOD OF LOADING
                    // const image = new Image()
                    // // if(window.RENDER_MODE){
                    // //     image.crossOrigin = 'anonymous';
                    // // }
                    // image.onload = () => this.onImageLoadedCallback(newBitmapUrl, image)
                    // image.src = newBitmapUrl

                    (0, _LayerUtils.getImageParser)({
                        src: newBitmapUrl,
                        height: newBitmapRes.height,
                        width: newBitmapRes.width,
                        onload: function onload(url, img) {
                            return _this9.onImageLoad(url, img);
                        }
                    });
                }
            }
        }
    }, {
        key: 'onImageLoad',
        value: function onImageLoad(loadedUrl, loadedImage) {
            if (this.currentLoadingBitmapUrl !== loadedUrl) {
                // Ignore
                return;
            }
            this.currentLoadingBitmapUrl = null;
            this.currentLoadedImage = loadedImage;

            this.invalidate();
        }
    }, {
        key: 'getRenderOffsets',
        value: function getRenderOffsets(layerAttrs) {
            var _getTransformedShadow9 = this.getTransformedShadowValues(layerAttrs),
                shadowEnabled = _getTransformedShadow9.shadowEnabled,
                shadowOffsetX = _getTransformedShadow9.shadowOffsetX,
                shadowOffsetY = _getTransformedShadow9.shadowOffsetY,
                shadowBlur = _getTransformedShadow9.shadowBlur;

            if (!shadowEnabled) {
                return _get(BitmapLayerRenderer.prototype.__proto__ || Object.getPrototypeOf(BitmapLayerRenderer.prototype), 'getRenderOffsets', this).call(this, layerAttrs);
            }

            shadowBlur = Math.abs(shadowBlur) * 1.5;

            return {
                leftOff: Math.min(shadowOffsetX - shadowBlur, 0),
                topOff: Math.min(shadowOffsetY - shadowBlur, 0),
                rightOff: Math.max(shadowOffsetX + shadowBlur, 0),
                bottomOff: Math.max(shadowOffsetY + shadowBlur, 0)
            };
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor21 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor22 = _slicedToArray(_getScaleFromTransfor21, 2),
                oScaleX = _getScaleFromTransfor22[0],
                oScaleY = _getScaleFromTransfor22[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            this.prepareForRender();

            if (this.currentLoadedImage === null) {
                return;
            }

            var alpha = layerAttrs.alpha,
                transform = layerAttrs.transform,
                crop = layerAttrs.crop;
            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height;
            var cropX = layerAttrs.cropX,
                cropY = layerAttrs.cropY,
                cropWidth = layerAttrs.cropWidth,
                cropHeight = layerAttrs.cropHeight;

            var image = this.currentLoadedImage;

            var _defModel$values = this.defModel.values,
                _defModel$values$crop = _defModel$values.cropImageX,
                cropImageX = _defModel$values$crop === undefined ? 0 : _defModel$values$crop,
                _defModel$values$crop2 = _defModel$values.cropImageY,
                cropImageY = _defModel$values$crop2 === undefined ? 0 : _defModel$values$crop2,
                _defModel$values$crop3 = _defModel$values.cropImageWidth,
                cropImageWidth = _defModel$values$crop3 === undefined ? image.width : _defModel$values$crop3,
                _defModel$values$crop4 = _defModel$values.cropImageHeight,
                cropImageHeight = _defModel$values$crop4 === undefined ? image.height : _defModel$values$crop4,
                _defModel$values$imag = _defModel$values.imageInitialWidth,
                imageInitialWidth = _defModel$values$imag === undefined ? image.width : _defModel$values$imag,
                _defModel$values$imag2 = _defModel$values.imageInitialHeight,
                imageInitialHeight = _defModel$values$imag2 === undefined ? image.height : _defModel$values$imag2;

            var glAlpha = ctx.globalAlpha;

            ctx.globalAlpha = glAlpha * alpha;

            ctx.transform.apply(ctx, _toConsumableArray(transform));

            if (clipPath2D) {
                ctx.clip(clipPath2D);
            }

            if (crop) {
                if (crop === 'circle') {
                    var cropRadius = Math.min(width, height) / 2;
                    var offsetX = x + width / 2;
                    var offsetY = y + height / 2;

                    ctx.beginPath();
                    ctx.arc(offsetX, offsetY, cropRadius, 0, Math.PI * 2, true);
                    ctx.closePath();
                    ctx.clip();
                } else if (crop === 'square') {
                    var side = Math.min(width, height);
                    var _offsetX = x + (width - side) / 2;
                    var _offsetY = y + (height - side) / 2;

                    ctx.beginPath();
                    ctx.rect(_offsetX, _offsetY, side, side);
                    ctx.closePath();
                    ctx.clip();
                }
            }
            var shadowEnabled = layerAttrs.shadowEnabled;

            if (shadowEnabled) {
                var _getTransformedShadow10 = this.getTransformedShadowValues(layerAttrs),
                    shadowColor = _getTransformedShadow10.shadowColor,
                    shadowAlpha = _getTransformedShadow10.shadowAlpha,
                    shadowOffsetX = _getTransformedShadow10.shadowOffsetX,
                    shadowOffsetY = _getTransformedShadow10.shadowOffsetY,
                    shadowBlur = _getTransformedShadow10.shadowBlur;

                ctx.shadowColor = (0, _color2.default)(shadowColor).alpha(shadowAlpha * glAlpha).string();
                ctx.shadowBlur = shadowBlur;
                ctx.shadowOffsetX = shadowOffsetX;
                ctx.shadowOffsetY = shadowOffsetY;
            }

            var croppedX = image.x + image.width * cropX / 100;
            var croppedY = image.y + image.height * cropY / 100;
            var croppedWidth = image.width * cropWidth / 100;
            var croppedHeight = image.height * cropHeight / 100;
            var croppedImageX = cropImageX / imageInitialWidth * image.width;
            var croppedImageY = cropImageY / imageInitialHeight * image.height;
            var croppedImageWidth = cropImageWidth / imageInitialWidth * image.width;
            var croppedImageHeight = cropImageHeight / imageInitialHeight * image.height;

            if (!this.defModel.def.meta.placeholders) {
                ctx.drawImage(image, croppedImageX, croppedImageY, croppedImageWidth, croppedImageHeight, x, y, width, height);
            } else {
                ctx.drawImage(image, croppedX, croppedY, croppedWidth, croppedHeight, x, y, width, height);
            }
        }
    }]);

    return BitmapLayerRenderer;
}(BaseLayerRenderer);

var BodymovinLayerRenderer = function () {
    /**
     * Creates an instance of BodymovinLayerRenderer.
     * @param {*} layer
     * @param {DefModel} defModel
     * @param {() => {}} invalidateFunc
     * @memberof BodymovinLayerRenderer
     */
    function BodymovinLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, BodymovinLayerRenderer);

        this.layer = layer;
        this.defModel = defModel;
        this.invalidateFunc = invalidateFunc;

        var container = document.createElement('div');
        container.className = 'bm-container';
        (0, _LayerUtils.applyCss)(container, 'position', 'absolute');
        (0, _LayerUtils.applyCss)(container, 'width', '0px');
        (0, _LayerUtils.applyCss)(container, 'height', '0px');

        var wrapper = document.createElement('div');
        (0, _LayerUtils.applyCss)(wrapper, 'position', 'absolute');
        (0, _LayerUtils.applyCss)(wrapper, 'width', '100%');
        (0, _LayerUtils.applyCss)(wrapper, 'height', '100%');

        // const outWrapper = document.createElement('div')
        // applyCss(outWrapper, 'position', 'absolute')
        // applyCss(outWrapper, 'width', '100%')
        // applyCss(outWrapper, 'height', '100%')

        container.appendChild(wrapper);
        // container.appendChild(outWrapper)

        this.container = container;
        this.wrapper = wrapper;
        // this.outWrapper = outWrapper

        // Set some defaults for these
        this.displayScale = 0.292342342; // Arbitrary, but unlikely to be the next
        // value we receive
        this.reelCanvas = { width: 1, height: 1 };
        this.selected = false;
        this.paused = true;

        this.layerAttrsOrig = null;
        this.layerAttrs = null;
        this.globalAttrsOrig = null;
        this.globalAttrs = null;
        this.visible = false;
        this.space = null;

        this.anim = null;
        // this.outAnim = null

        this.forceRenderValue = 0.01;

        var aData = {
            wrapper: this.wrapper,
            animType: 'svg',
            loop: false,
            prerender: true,
            autoplay: false,
            animationData: (0, _cloneextend.clone)(this.layer.meta.animationData)
        };

        this.anim = _bodymovin2.default.loadAnimation(aData);
    }

    _createClass(BodymovinLayerRenderer, [{
        key: 'getCanvas',
        value: function getCanvas() {
            return this.container;
        }
    }, {
        key: 'isShy',
        value: function isShy() {
            return false;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.anim) {
                this.anim.stop();
                this.anim.destroy();
                this.anim = null;

                // if (this.outAnim) {
                //     this.outAnim.stop()
                //     this.outAnim.destroy()
                //     this.outAnim = null
                // }
            }

            this.layerAttrsOrig = null;
            this.layerAttrs = null;
            this.globalAttrsOrig = null;
            this.globalAttrs = null;
            this.visible = false;
            this.space = null;

            this.layerInfo = null;

            this.container = null;
            this.wrapper = null;
            // this.outWrapper = null
        }
    }, {
        key: 'invalidate',
        value: function invalidate() {
            this.dirty = true;

            this.invalidateFunc();
        }
    }, {
        key: 'update',
        value: function update(reelCanvas, displayScale, selected, paused) {
            var _this10 = this;

            var haveAttrsChanged = this.checkAttrDirty();

            var hasReelCanvasChanged = this.reelCanvas.width !== reelCanvas.width || this.reelCanvas.height !== reelCanvas.height;
            var hasSelectedChanged = this.selected !== selected;
            var hasPausedChanged = this.paused !== paused;

            var hasDisplayScaleChanged = this.displayScale !== displayScale;

            var useStatic = getUseStatic(selected, paused);

            this.layerAttrsOrig = this.defModel.getAttrsForLayer(this.layer.id, useStatic);
            this.layerAttrs = {};
            Object.keys(this.layerAttrsOrig).forEach(function (ak) {
                _this10.layerAttrs[ak] = (0, _LayerUtils.convertLayerAttrValueForRender)(_this10.layer.type, ak, _this10.layerAttrsOrig[ak], _this10.layer.meta);
            });

            this.globalAttrsOrig = this.defModel.getGlobalAttrs(useStatic);
            this.globalAttrs = {};
            Object.keys(this.globalAttrsOrig).forEach(function (ak) {
                _this10.globalAttrs[ak] = (0, _LayerUtils.convertGlobalAttrValueForRender)(ak, _this10.globalAttrsOrig[ak]);
            });

            this.visible = this.defModel.getVisibility(useStatic);
            this.space = this.defModel.space;
            this.layerInfo = this.defModel.getInfoForLayer(this.layer.id);

            this.selected = selected;
            this.paused = paused;
            this.reelCanvas = reelCanvas;
            this.displayScale = displayScale;

            this.dirty = haveAttrsChanged || hasReelCanvasChanged || hasDisplayScaleChanged || hasSelectedChanged || hasPausedChanged;
        }
    }, {
        key: 'checkAttrDirty',
        value: function checkAttrDirty() {
            var useStatic = getUseStatic(this.selected, this.paused);

            this.defModel.setStatic(useStatic);

            var oldLayerAttrs = this.layerAttrsOrig;
            var oldGlobalAttrs = this.globalAttrsOrig;
            var oldVisible = this.visible;
            var oldSpace = this.space;
            var newLayerAttrs = this.defModel.getAttrsForLayer(this.layer.id, useStatic);
            var newGlobalAttrs = this.defModel.getGlobalAttrs(useStatic);
            var newVisible = this.defModel.getVisibility(useStatic);
            var newSpace = this.defModel.space;

            var hasLayerAttrsChanged = false;
            var hasGlobalAttrsChanged = false;
            var hasVisibilityChanged = false;
            var hasSpaceChanged = false;

            if (oldLayerAttrs === null) {
                hasLayerAttrsChanged = true;
                hasGlobalAttrsChanged = true;
                hasVisibilityChanged = true;
                hasSpaceChanged = true;
            } else {
                hasLayerAttrsChanged = Object.keys(oldLayerAttrs).find(function (attrKey) {
                    if (oldLayerAttrs[attrKey].constructor === Object) {
                        var changeFound = Object.keys(oldLayerAttrs[attrKey]).find(function (subAttrKey) {
                            return oldLayerAttrs[attrKey][subAttrKey] !== newLayerAttrs[attrKey][subAttrKey];
                        });
                        return !!changeFound;
                    }
                    return oldLayerAttrs[attrKey] !== newLayerAttrs[attrKey];
                });
                hasGlobalAttrsChanged = Object.keys(oldGlobalAttrs).find(function (attrKey) {
                    return oldGlobalAttrs[attrKey] !== newGlobalAttrs[attrKey];
                });
                hasVisibilityChanged = oldVisible !== newVisible;
                hasSpaceChanged = Object.keys(oldSpace).find(function (key) {
                    return oldSpace[key] !== newSpace[key];
                });
            }

            return hasSpaceChanged || hasGlobalAttrsChanged || hasVisibilityChanged || hasLayerAttrsChanged;
        }
    }, {
        key: 'invalidateIfChanged',
        value: function invalidateIfChanged() {
            var _this11 = this;

            var attrsDirty = this.checkAttrDirty();
            if (attrsDirty) {
                var useStatic = getUseStatic(this.selected, this.paused);

                this.layerAttrsOrig = this.defModel.getAttrsForLayer(this.layer.id, useStatic);
                this.layerAttrs = {};
                Object.keys(this.layerAttrsOrig).forEach(function (ak) {
                    _this11.layerAttrs[ak] = (0, _LayerUtils.convertLayerAttrValueForRender)(_this11.layer.type, ak, _this11.layerAttrsOrig[ak], _this11.layer.meta);
                });

                this.globalAttrsOrig = this.defModel.getGlobalAttrs(useStatic);
                this.globalAttrs = {};
                Object.keys(this.globalAttrsOrig).forEach(function (ak) {
                    _this11.globalAttrs[ak] = (0, _LayerUtils.convertGlobalAttrValueForRender)(ak, _this11.globalAttrsOrig[ak]);
                });

                this.visible = this.defModel.getVisibility(useStatic);
                this.space = this.defModel.space;
            }
            this.dirty = this.dirty || attrsDirty;
        }
    }, {
        key: 'renderLayer',
        value: function renderLayer() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var depLayerRenderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (!force && !this.dirty) {
                return;
            }

            var container = this.container,
                wrapper = this.wrapper,
                space = this.space,
                globalAttrs = this.globalAttrs,
                layerAttrs = this.layerAttrs,
                displayScale = this.displayScale;
            var visible = this.visible,
                selected = this.selected;

            var show = selected || visible; // TODO - check for reflow ?
            if (!show) {
                (0, _LayerUtils.applyCss)(container, 'visibility', 'hidden');
                this.dirty = false;
                return;
            }
            (0, _LayerUtils.applyCss)(container, 'visibility', 'visible');

            var ol = space.x,
                ot = space.y,
                ow = space.width,
                oh = space.height,
                transform = space.transform,
                _space$rotateDeg2 = space.rotateDeg,
                rotateDeg = _space$rotateDeg2 === undefined ? 0 : _space$rotateDeg2;

            var _getScaleFromTransfor23 = (0, _LayerUtils.getScaleFromTransformString)(transform),
                _getScaleFromTransfor24 = _slicedToArray(_getScaleFromTransfor23, 2),
                scaleX = _getScaleFromTransfor24[0],
                scaleY = _getScaleFromTransfor24[1];
            // TODO - batch these and turn them into transform , all of them


            (0, _LayerUtils.applyCss)(container, 'width', ow + 'px');
            (0, _LayerUtils.applyCss)(container, 'height', oh + 'px');
            (0, _LayerUtils.applyCss)(container, 'left', (ol + globalAttrs.gl_x) * displayScale + 'px');
            (0, _LayerUtils.applyCss)(container, 'top', (ot + globalAttrs.gl_y) * displayScale + 'px');

            // TODO: For now, we're ignoring gl_transformOrigin for these layers.
            // Implement later.

            var _globalAttrs$gl_trans2 = _slicedToArray(globalAttrs.gl_transformOrigin, 2),
                tOriginLeft = _globalAttrs$gl_trans2[0],
                tOriginTop = _globalAttrs$gl_trans2[1];

            tOriginLeft *= displayScale;
            tOriginTop *= displayScale;

            (0, _LayerUtils.applyCss)(container, 'transformOrigin', 0 + 'px ' + 0 + 'px');

            var glTransformStr = globalAttrs.gl_transform;

            var glTransformMatrix = _Matrix3D2.default.fromTransform(glTransformStr);

            var contScaleMatrix = _Matrix3D2.default.create();

            _Matrix3D2.default.scale(contScaleMatrix, scaleX * displayScale, scaleY * displayScale, 1);

            var centreOffset = _Matrix3D2.default.create();
            _Matrix3D2.default.translate(centreOffset, tOriginLeft, tOriginTop, 0);

            var resetCentre = _Matrix3D2.default.create();

            _Matrix3D2.default.translate(resetCentre, -tOriginLeft, -tOriginTop, 0);

            var rotateM = _Matrix3D2.default.create();

            _Matrix3D2.default.rotateZ(rotateM, rotateDeg);

            _Matrix3D2.default.multiply(centreOffset, glTransformMatrix, glTransformMatrix);

            _Matrix3D2.default.multiply(rotateM, glTransformMatrix, glTransformMatrix); // rotate then

            _Matrix3D2.default.multiply(resetCentre, glTransformMatrix, glTransformMatrix); // translate

            _Matrix3D2.default.multiply(contScaleMatrix, glTransformMatrix, glTransformMatrix);

            glTransformStr = _Matrix3D2.default.toTransform(glTransformMatrix);

            // TODO - batch the operation
            (0, _LayerUtils.applyCss)(container, 'transform', glTransformStr);

            (0, _LayerUtils.applyCss)(container, 'perspective', globalAttrs.gl_transformPerspective + 'px');

            (0, _LayerUtils.applyCss)(container, 'opacity', globalAttrs.gl_alpha);

            var _layer$meta = this.layer.meta,
                animationData = _layer$meta.animationData,
                viewBox = _layer$meta.viewBox,
                _layer$meta$timeSlice = _layer$meta.timeSlice,
                timeSlice = _layer$meta$timeSlice === undefined ? '-1 -1' : _layer$meta$timeSlice,
                _layer$meta$outTimeSl = _layer$meta.outTimeSlice,
                outTimeSlice = _layer$meta$outTimeSl === undefined ? null : _layer$meta$outTimeSl,
                _layer$meta$mappings = _layer$meta.mappings,
                mappings = _layer$meta$mappings === undefined ? {} : _layer$meta$mappings;
            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height,
                alpha = layerAttrs.alpha;
            var compWidth = animationData.w,
                compHeight = animationData.h,
                compFrameRate = animationData.fr,
                compIp = animationData.ip,
                compOp = animationData.op;

            var _viewBox$split$map = viewBox.split(' ').map(_LayerUtils.toFloat),
                _viewBox$split$map2 = _slicedToArray(_viewBox$split$map, 4),
                vb_x = _viewBox$split$map2[0],
                vb_y = _viewBox$split$map2[1],
                vb_w = _viewBox$split$map2[2],
                vb_h = _viewBox$split$map2[3];

            var _timeSlice$split$map = timeSlice.split(' ').map(_LayerUtils.toFloat),
                _timeSlice$split$map2 = _slicedToArray(_timeSlice$split$map, 2),
                tSliceStart = _timeSlice$split$map2[0],
                tSliceEnd = _timeSlice$split$map2[1];

            var wrapperScaleX = width / vb_w;
            var wrapperScaleY = height / vb_h;
            // TODO - transform based and batch
            (0, _LayerUtils.applyCss)(wrapper, 'width', compWidth + 'px');
            (0, _LayerUtils.applyCss)(wrapper, 'height', compHeight + 'px');
            (0, _LayerUtils.applyCss)(wrapper, 'left', -vb_x + 'px');
            (0, _LayerUtils.applyCss)(wrapper, 'top', -vb_y + 'px');

            (0, _LayerUtils.applyCss)(wrapper, 'transformOrigin', vb_x + 'px ' + vb_y + 'px');

            var wrapperMatrix = new _snapsvg2.default.Matrix();
            wrapperMatrix.scale(wrapperScaleX, wrapperScaleY);
            wrapperMatrix.translate(x / wrapperScaleX, y / wrapperScaleY);

            (0, _LayerUtils.applyCss)(wrapper, 'transform', wrapperMatrix.toString());

            (0, _LayerUtils.applyCss)(wrapper, 'opacity', alpha);

            var anim = this.anim;

            // Already setup && data ready

            var currentTime = this.defModel.getTime();

            var useStatic = getUseStatic(this.selected, this.paused);

            var _defModel$time3 = this.defModel.time,
                enterstart = _defModel$time3.enterstart,
                enterdone = _defModel$time3.enterdone,
                exitstart = _defModel$time3.exitstart,
                exitdone = _defModel$time3.exitdone;

            var animNumFrames = 0;
            var startFrame = -1;
            var endFrame = -1;
            if (tSliceStart === -1 && tSliceEnd === -1) {
                startFrame = compIp;
                endFrame = compOp;
            } else {
                // NOTE : Assume both are positive values
                if (tSliceStart === -1 || tSliceEnd === -1) {
                    throw new Error('Case not supported');
                }
                startFrame = Math.floor(tSliceStart * compFrameRate / 1000);
                endFrame = Math.floor(tSliceEnd * compFrameRate / 1000);
            }

            animNumFrames = endFrame - startFrame;

            var seekFrame = 0;

            if (useStatic) {
                seekFrame = endFrame;
            } else if (currentTime < enterstart) {
                seekFrame = startFrame;
            } else if (currentTime >= enterstart && currentTime < enterdone) {
                seekFrame = startFrame + Math.floor((currentTime - enterstart) / (enterdone - enterstart) * animNumFrames);
            } else if (currentTime >= enterdone && currentTime < exitstart) {
                seekFrame = endFrame;
            } else {
                // Exit

                if (outTimeSlice) {
                    var _outTimeSlice$split$m = outTimeSlice.split(' ').map(_LayerUtils.toFloat),
                        _outTimeSlice$split$m2 = _slicedToArray(_outTimeSlice$split$m, 2),
                        tOutSliceStart = _outTimeSlice$split$m2[0],
                        toOutSliceEnd = _outTimeSlice$split$m2[1];

                    var outStartFrame = Math.floor(tOutSliceStart * compFrameRate / 1000);
                    var outEndFrame = Math.floor(toOutSliceEnd * compFrameRate / 1000);

                    var outAnimNumFrames = outEndFrame - outStartFrame;

                    if (currentTime >= exitstart && currentTime < exitdone) {
                        seekFrame = outStartFrame + Math.floor((currentTime - exitstart) / (exitdone - exitstart) * outAnimNumFrames);
                    } else {
                        seekFrame = outEndFrame;
                    }
                } else if (currentTime >= exitstart && currentTime < exitdone) {
                    seekFrame = endFrame - Math.ceil((currentTime - exitstart) / (exitdone - exitstart) * animNumFrames);
                } else {
                    seekFrame = startFrame;
                }
            }

            anim.goToAndStop(seekFrame, 1);

            Object.keys(mappings).forEach(function (attrKey) {
                var _mappings$attrKey = mappings[attrKey],
                    exp = _mappings$attrKey.exp,
                    type = _mappings$attrKey.type;

                var attrValue = layerAttrs[attrKey];

                if (type === 'color') {
                    var _Color$rgb$array = (0, _color2.default)(attrValue).rgb().array(),
                        _Color$rgb$array2 = _slicedToArray(_Color$rgb$array, 3),
                        r = _Color$rgb$array2[0],
                        g = _Color$rgb$array2[1],
                        b = _Color$rgb$array2[2];

                    attrValue = [r / 255, g / 255, b / 255, 1];
                }

                var obj = anim.animationData;
                for (var i = 0; i < exp.length - 1; i++) {
                    obj = obj[exp[i]];
                }
                obj[exp[exp.length - 1]] = attrValue;
            });
            if (Object.keys(mappings).length > 0) {
                anim.renderer.renderFrame(anim.currentFrame + anim.firstFrame + this.forceRenderValue);
                this.forceRenderValue *= -1;
            }
        }
    }]);

    return BodymovinLayerRenderer;
}();

var SvgLayerRenderer = function (_BaseLayerRenderer6) {
    _inherits(SvgLayerRenderer, _BaseLayerRenderer6);

    function SvgLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, SvgLayerRenderer);

        var svgCanvasPainter = new _SVGCanvasRenderer2.default({
            defaultHeight: 200,
            defaultWidth: 200,
            updateRate: 300,
            propertyConfigMap: layer.meta.layerProps,
            renderMode: !!window.RENDER_MODE
        });

        var _this12 = _possibleConstructorReturn(this, (SvgLayerRenderer.__proto__ || Object.getPrototypeOf(SvgLayerRenderer)).call(this, layer, defModel, invalidateFunc, function () {
            return svgCanvasPainter.getDisplayCanvas();
        }));

        _this12.__destroy = function () {
            _this12.svgCanvasPainter.cleanUp();
            _this12.svgCanvasPainter = null;
        };

        _this12.drawSVGToCanvas = function (updatedSvgString) {
            var beforePaint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
                var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_ref4) {
                    var height = _ref4.height,
                        width = _ref4.width,
                        force = _ref4.force;
                };
                var updateSvg = arguments[1];
            };

            var svgString = updatedSvgString || _this12.layer.meta.svgData;

            var props = _this12.defModel.getCurrentPropValues();

            var _this12$svgCanvasPain = _this12.svgCanvasPainter.updateSVGString(svgString, function () {
                return _this12.invalidate();
            }),
                svgViewBox = _this12$svgCanvasPain.svgViewBox,
                ht = _this12$svgCanvasPain.height,
                wd = _this12$svgCanvasPain.width,
                svgEl = _this12$svgCanvasPain.svgEl,
                update = _this12$svgCanvasPain.update;

            _this12.svgEl = svgEl;
            _this12.svgViewBox = svgViewBox;
            // invalidate function call will force a redraw

            var qeuePaintCall = function qeuePaintCall() {
                var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref5$x = _ref5.x,
                    x = _ref5$x === undefined ? 0 : _ref5$x,
                    _ref5$y = _ref5.y,
                    y = _ref5$y === undefined ? 0 : _ref5$y,
                    _ref5$height = _ref5.height,
                    height = _ref5$height === undefined ? ht : _ref5$height,
                    _ref5$width = _ref5.width,
                    width = _ref5$width === undefined ? wd : _ref5$width,
                    _ref5$scale = _ref5.scale,
                    scale = _ref5$scale === undefined ? 1 : _ref5$scale,
                    _ref5$force = _ref5.force,
                    force = _ref5$force === undefined ? false : _ref5$force;

                _this12.svgCanvasPainter.paintSVG(x, y, height, width, scale, force, props, function () {
                    return _this12.invalidate();
                });
            };
            beforePaint(qeuePaintCall, update);
        };

        _this12.previousSVGString = null;

        _this12.loadedSvg = null;

        _this12.svgCanvasPainter = svgCanvasPainter;

        // for lazy loading SVGs , soon to be the plight of all data
        var svgId = _this12.layer.attrs.svgId;

        if (svgId) {
            var data = _SVGManager2.default.getSvgData(svgId);
            // when data is available no need of 2nd render
            if (data && data.loaded) {
                _this12.loadedSvg = data.svgString;
            } else {
                // TODO -- refactor the onload outside to the renderer
                // Ideally all data hooks should be transparent to React end of things
                _SVGManager2.default.onSvgLoad(svgId, function (data) {
                    // dlog(`updating SVG layer`, data)
                    _this12.loadedSvg = data.svgString;
                    // this.invalidateFunc() // fired immediately if resource is available
                    (0, _polyfill.localMicrotask)(function () {
                        return _this12.invalidateFunc();
                    });
                    // this.appendSvgElement(data.svgString)
                });
            }
        }
        return _this12;
    }

    _createClass(SvgLayerRenderer, [{
        key: 'getRenderOffsets',
        value: function getRenderOffsets(layerAttrs) {
            var _getTransformedShadow11 = this.getTransformedShadowValues(layerAttrs),
                shadowEnabled = _getTransformedShadow11.shadowEnabled,
                shadowOffsetX = _getTransformedShadow11.shadowOffsetX,
                shadowOffsetY = _getTransformedShadow11.shadowOffsetY,
                shadowBlur = _getTransformedShadow11.shadowBlur;

            var _space5 = this.space,
                sWidth = _space5.width,
                sHeight = _space5.height,
                sTransform = _space5.transform;

            var _getScaleFromTransfor25 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor26 = _slicedToArray(_getScaleFromTransfor25, 2),
                oScaleX = _getScaleFromTransfor26[0],
                oScaleY = _getScaleFromTransfor26[1];

            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height;
            var strokeWidth = layerAttrs.strokeWidth,
                strokeAlpha = layerAttrs.strokeAlpha;

            var shouldStroke = strokeWidth > 0 && strokeAlpha > 0;

            var strokeOffset = Math.ceil(strokeWidth / 2);

            var leftOff = x * oScaleX;
            var topOff = y * oScaleY;
            var rightOff = (x + width) * oScaleX - sWidth;
            var bottomOff = (y + height) * oScaleY - sHeight;

            if (!shadowEnabled && !shouldStroke) {
                return { leftOff: leftOff, topOff: topOff, rightOff: rightOff, bottomOff: bottomOff };
            }

            if (!shadowEnabled) {
                leftOff += -strokeOffset;
                topOff += -strokeOffset;
                rightOff += strokeOffset;
                bottomOff += strokeOffset;

                return { leftOff: leftOff, topOff: topOff, rightOff: rightOff, bottomOff: bottomOff };
            }

            shadowBlur = Math.abs(shadowBlur) * 1.5;

            return {
                leftOff: Math.min(shadowOffsetX - shadowBlur + leftOff, leftOff),
                topOff: Math.min(shadowOffsetY - shadowBlur + topOff, topOff),
                rightOff: Math.max(shadowOffsetX + shadowBlur + rightOff, rightOff),
                bottomOff: Math.max(shadowOffsetY + shadowBlur + bottomOff, bottomOff)
            };
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor27 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor28 = _slicedToArray(_getScaleFromTransfor27, 2),
                oScaleX = _getScaleFromTransfor28[0],
                oScaleY = _getScaleFromTransfor28[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'getTransformedShadowValues',
        value: function getTransformedShadowValues(layerAttrs) {
            var sTransform = this.space.transform;

            var _getScaleFromTransfor29 = (0, _LayerUtils.getScaleFromTransformString)(sTransform),
                _getScaleFromTransfor30 = _slicedToArray(_getScaleFromTransfor29, 2),
                oScaleX = _getScaleFromTransfor30[0],
                oScaleY = _getScaleFromTransfor30[1];

            var shadowOffsetX = layerAttrs.shadowOffsetX,
                shadowOffsetY = layerAttrs.shadowOffsetY,
                shadowBlur = layerAttrs.shadowBlur;

            return _extends({}, layerAttrs, {
                shadowOffsetX: shadowOffsetX * oScaleX,
                shadowOffsetY: shadowOffsetY * oScaleY,
                shadowBlur: shadowBlur * Math.sqrt((oScaleX * oScaleX + oScaleY * oScaleY) / 2)
            });
        }
    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs, clipPath2D) {
            var _this13 = this;

            var x = layerAttrs.x,
                y = layerAttrs.y,
                width = layerAttrs.width,
                height = layerAttrs.height,
                alpha = layerAttrs.alpha,
                shadowEnabled = layerAttrs.shadowEnabled,
                rotate = layerAttrs.rotate,
                scale = layerAttrs.scale,
                translate = layerAttrs.translate;

            // Scale only when height / width or the overall overlay hight /

            this.drawSVGToCanvas(this.loadedSvg, function (qeuePaintCall, shouldUpdate) {
                var glAlpha = ctx.globalAlpha;

                ctx.globalAlpha = glAlpha * alpha;

                if (clipPath2D) {
                    ctx.clip(clipPath2D);
                }

                if (shadowEnabled) {
                    var _getTransformedShadow12 = _this13.getTransformedShadowValues(layerAttrs),
                        shadowColor = _getTransformedShadow12.shadowColor,
                        shadowAlpha = _getTransformedShadow12.shadowAlpha,
                        shadowOffsetX = _getTransformedShadow12.shadowOffsetX,
                        shadowOffsetY = _getTransformedShadow12.shadowOffsetY,
                        shadowBlur = _getTransformedShadow12.shadowBlur;

                    ctx.shadowColor = (0, _color2.default)(shadowColor).alpha(shadowAlpha * glAlpha).string();
                    ctx.shadowBlur = shadowBlur;
                    ctx.shadowOffsetX = shadowOffsetX;
                    ctx.shadowOffsetY = shadowOffsetY;
                }

                var _rotate = _slicedToArray(rotate, 3),
                    rotateAngleInDegree = _rotate[0],
                    rotateOriginX = _rotate[1],
                    rotateOriginY = _rotate[2];

                var shouldRotate = rotateAngleInDegree != 0;
                if (shouldRotate) {
                    ctx.translate(rotateOriginX, rotateOriginY);
                    ctx.rotate(rotateAngleInDegree * Math.PI / 180);
                    ctx.translate(-rotateOriginX, -rotateOriginY);
                }

                var _translate = _slicedToArray(translate, 2),
                    translateX = _translate[0],
                    translateY = _translate[1];

                ctx.translate(translateX, translateY);

                var _scale = _slicedToArray(scale, 4),
                    _scale$ = _scale[0],
                    scaleX = _scale$ === undefined ? 1 : _scale$,
                    _scale$2 = _scale[1],
                    scaleY = _scale$2 === undefined ? 1 : _scale$2,
                    _scale$3 = _scale[2],
                    scaleOriginX = _scale$3 === undefined ? 0 : _scale$3,
                    _scale$4 = _scale[3],
                    scaleOriginY = _scale$4 === undefined ? 0 : _scale$4;

                ctx.translate(scaleOriginX, scaleOriginY);
                ctx.scale(scaleX, scaleY);
                ctx.translate(-scaleOriginX, -scaleOriginY);

                var displayScale = _this13.displayScale,
                    space = _this13.space;
                var ow = space.width,
                    oh = space.height,
                    transform = space.transform,
                    _space$rotateDeg3 = space.rotateDeg,
                    rotateDeg = _space$rotateDeg3 === undefined ? 0 : _space$rotateDeg3;

                var _getScaleFromTransfor31 = (0, _LayerUtils.getScaleFromTransformString)(transform),
                    _getScaleFromTransfor32 = _slicedToArray(_getScaleFromTransfor31, 2),
                    ovScaleX = _getScaleFromTransfor32[0],
                    ovScaleY = _getScaleFromTransfor32[1];

                var layerScale = Math.max(ow * ovScaleX, oh * ovScaleY) / Math.max(height, width);

                qeuePaintCall({
                    width: width,
                    height: height,
                    scale: displayScale * PIXEL_RATIO * layerScale,
                    x: x,
                    y: y
                });
            });
        }
    }]);

    return SvgLayerRenderer;
}(BaseLayerRenderer);

/**
 * Layer for handling Audio inside the overlays
 *
 * @class AudioLayerRenderer
 * @extends {BaseLayerRenderer}
 */

var AudioLayerRenderer = function (_BaseLayerRenderer7) {
    _inherits(AudioLayerRenderer, _BaseLayerRenderer7);

    function AudioLayerRenderer(layer, defModel, invalidateFunc) {
        _classCallCheck(this, AudioLayerRenderer);

        var _this14 = _possibleConstructorReturn(this, (AudioLayerRenderer.__proto__ || Object.getPrototypeOf(AudioLayerRenderer)).call(this, layer, defModel, invalidateFunc));

        _this14.defModel = defModel;
        _this14.layer = layer;
        _this14.paused = true;
        _this14.container = null;
        _this14.player = null;
        _this14.audioClip = null;
        _this14.audioTimeline = null;

        if (!window.RENDER_MODE) {
            var volume = defModel.getLayerAttrValue(layer.id, 'volume');
            var audioId = defModel.getLayerAttrValue(layer.id, 'audioId');

            var audioUrl = '';

            var audioClip = _AudioRegistry2.default.getOverlayAudioById(audioId);

            if (!audioClip) {
                throw new Error('Invalid call. Cannot initialise audio layer');
            }

            // TODO - Control the audio layer state using GSAP timelinemax
            // Can create a AudioLayerPlayer which is managed by AudioManager.
            // CorePlayer can hook to this manager and we can play / pause
            // the project as soon as audio is buffered / starts buffering respectively.
            _this14.audioClip = audioClip;
            audioUrl = audioClip.previewUrl;

            var container = document.createElement('div');
            container.className = 'al-container';

            var player = new _AllSourcePlayer2.default(container, audioUrl);
            player.initialize();

            _this14.container = container;
            _this14.player = player;

            _this14.player.seek(0);
        }
        return _this14;
    }

    _createClass(AudioLayerRenderer, [{
        key: 'destroy',
        value: function destroy() {
            if (this.player) {
                this.player.kill();
            }

            this.layerAttrsOrig = null;
            this.layerAttrs = null;
            this.globalAttrsOrig = null;
            this.globalAttrs = null;
            this.visible = false;
            this.space = null;
            this.canvas = null;
        }

        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {Object} layerAttrs
         * @memberof AudioLayerRenderer
         */

    }, {
        key: 'drawLayer',
        value: function drawLayer(ctx, layerAttrs) {}
        // NOTHING TO DRAW


        /**
         * Updates the paused state of the core player.
         * TODO:  will be used to update the audio url once that functionality is implemented.
         *
         * @param {*} reelCanvas
         * @param {*} displayScale
         * @param {boolean} selected
         * @param {boolean} paused
         * @memberof AudioLayerRenderer
         */

    }, {
        key: 'update',
        value: function update(reelCanvas, displayScale, selected, paused) {
            this.paused = paused;
        }

        /**
         *
         *
         * @param {boolean} [force=false]
         * @param {Array<>} [depLayerRenderers=[]]
         * @returns {*}
         * @memberof AudioLayerRenderer
         */

    }, {
        key: 'renderLayer',
        value: function renderLayer() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var depLayerRenderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (!force && !this.dirty || window.RENDER_MODE) {
                return;
            }

            var currentTime = this.defModel.getTime();
            var _defModel$time4 = this.defModel.time,
                enterstart = _defModel$time4.enterstart,
                enterdone = _defModel$time4.enterdone,
                exitstart = _defModel$time4.exitstart,
                exitdone = _defModel$time4.exitdone;

            var audioDuration = this.defModel.getLayerAttrValue(this.layer.id, 'audioDuration');
            var exitOffset = this.defModel.getLayerAttrValue(this.layer.id, 'exitOffset');

            var audioEnter = Math.max(0, enterdone - audioDuration - exitOffset);
            var audioExit = Math.max(0, audioEnter + audioDuration);

            if (currentTime >= audioEnter && currentTime < audioExit && !this.paused) {
                this.player.setLoop(audioDuration > this.audioClip.duration);
                this.player.play();
            } else if (!this.player.isPaused()) {
                this.player.pause();
                this.player.seek(0);
            }
        }
    }]);

    return AudioLayerRenderer;
}(BaseLayerRenderer);

},{"../../components/AudioRegistry":7,"../GeneralUtils":77,"../Matrix3D":79,"../assetsManager/SVGManager":91,"../players/AllSourcePlayer":110,"../scheduler/polyfill":126,"./DefModel":119,"./LayerUtils":121,"./SVGCanvasRenderer":123,"bodymovin":390,"cloneextend":412,"color":418,"snapsvg":1173}],121:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tokenize = exports.hasExpression = exports.applyCss = exports.calcBestContrastRGB = exports.createLayerInfo = exports.getRotatedTransformString = exports.getScaledTransformString = exports.getScaleFromTransformString = exports.toTransformParams = exports.parseTransformString = exports.toEase = exports.SPACE_ATTR_LIST = exports.GLOBAL_ATTRS_LIST = exports.LAYER_ATTR_TYPES = exports.LAYER_ATTR_DEFAULTS = exports.GLOBAL_ATTR_TYPES = exports.GLOBAL_ATTR_DEFAULTS = exports.convertGlobalAttrValueForRender = exports.convertLayerAttrValueForRender = exports.calcBestShadowContrast = exports.ensureBefore = exports.toTransformOrigin = exports.toPath = exports.toColor = exports.toFloat = exports.getTypeConverter = exports.getLayerAttrConverter = exports.getGlobalAttrConverter = exports.defaultConverter = exports.pathConverter = exports.highlightColorRangeConverter = exports.colorRangeConverter = exports.colorConverter = exports.floatConverter = exports.SPACE_COORDINATE_LIST = exports.getImageIdProps = exports.getImageParser = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}(); /* eslint-disable no-restricted-syntax */

var _snapsvg = require('snapsvg');

var _snapsvg2 = _interopRequireDefault(_snapsvg);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _lodash = require('lodash');

var _fastMemoize = require('fast-memoize');

var _fastMemoize2 = _interopRequireDefault(_fastMemoize);

var _GeneralUtils = require('../GeneralUtils');

var _ColorRange = require('../ColorRange');

var _ColorRange2 = _interopRequireDefault(_ColorRange);

var _HighlightColorRange = require('../HighlightColorRange');

var _HighlightColorRange2 = _interopRequireDefault(_HighlightColorRange);

var _TextLayerUtils = require('./TextLayerUtils');

var _CounterTimeFormatType = require('../../../edit/constants/CounterTimeFormatType');

var _CounterTimeFormatType2 = _interopRequireDefault(_CounterTimeFormatType);

var _BodyMovinLayerInfo = require('./BodyMovinLayerInfo');

var _BodyMovinLayerInfo2 = _interopRequireDefault(_BodyMovinLayerInfo);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var SHOULD_USE_IMAGE = false;

var detectSvgAndS3Url = (0, _fastMemoize2.default)(function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var splits = url.split('.');
    var extension = splits[splits.length - 1];
    if (extension === 'svg') return true;
    if (splits.find(function (v) {
        return v === 's3';
    })) {
        return true;
    }
    return false;
}, function (url) {
    return url;
});

// TODO -- build image cache on top of this
var getImageParser = exports.getImageParser = function () {
    var bitMapSupport = !!window.createImageBitmap && !SHOULD_USE_IMAGE;

    dlog('Bit map support : ' + bitMapSupport);

    var useCreateBitMap = function useCreateBitMap(_ref) {
        var src = _ref.src,
            height = _ref.height,
            width = _ref.width,
            _ref$onload = _ref.onload,
            onload = _ref$onload === undefined ? function () {} : _ref$onload;

        if (detectSvgAndS3Url(src)) return useImage({ src: src, onload: onload });

        dlog('using createBitMap');

        return fetch(src, {
            method: 'GET',
            credentials: 'same-origin'
        }).then(function (response) {
            var blob = response.blob();
            return blob;
        }).then(function (blob) {
            return createImageBitmap(blob);
        }).then(function (bitmap) {
            bitmap.x = 0;
            bitmap.y = 0;
            onload(src, bitmap);
        }).catch(function (err) {
            console.log(err, src);
            useImage({
                src: src,
                onload: onload
            });
        });
    };

    var useImage = function useImage(_ref2) {
        var src = _ref2.src,
            _ref2$onload = _ref2.onload,
            onload = _ref2$onload === undefined ? function () {} : _ref2$onload;

        var img = new Image();
        return new Promise(function (resolve, reject) {
            img.onload = resolve;
            img.onerror = reject;
            img.src = src;
        }).then(function () {
            onload.apply(undefined, [src, img]);
        }).catch(function (err) {
            console.log(err);
        });
    };

    var creator = bitMapSupport ? useCreateBitMap : useImage;

    return function () {
        return creator.apply(undefined, arguments);
    };
}();

var toFloat = function toFloat(v) {
    var defaultV = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (typeof v !== 'number') {
        v = parseFloat(v);
        if (isNaN(v) || !isFinite(v)) {
            v = defaultV;
        }
    }
    return v;
};

var toColor = function toColor(v) {
    return (0, _color2.default)(v).rgb().string();
};

var toColorRange = function toColorRange(v) {
    return new _ColorRange2.default(v);
};
var toHighlightColorRange = function toHighlightColorRange(v) {
    return new _HighlightColorRange2.default(v);
};

var toBoolean = function toBoolean(v) {
    if (typeof v === 'boolean') {
        return v;
    }
    if (typeof v === 'string') {
        return v === 'true';
    }
    return !!v;
};

var toPath = (0, _lodash.memoize)(function (v) {
    if (v instanceof Path2D) {
        return v;
    }
    if (!v) {
        return null;
    }
    if (typeof v === 'string') {
        if (!v.trim()) {
            return null;
        }
    }
    return new Path2D(v);
});

var toStandardTransform = function toStandardTransform(v) {
    var _toTransformParams = toTransformParams(v),
        _toTransformParams2 = _slicedToArray(_toTransformParams, 6),
        a = _toTransformParams2[0],
        b = _toTransformParams2[1],
        c = _toTransformParams2[2],
        d = _toTransformParams2[3],
        e = _toTransformParams2[4],
        f = _toTransformParams2[5];

    return 'matrix(' + a + ', ' + b + ', ' + c + ', ' + d + ', ' + e + ', ' + f + ')';
};

var toTransformOrigin = function toTransformOrigin(v) {
    return v.split(' ').map(toFloat);
};

var toFloatArray = function toFloatArray(v) {
    var str = '' + v; // HACK FIX -- NOT SURE WHY CERTAIN THINGS WERE BREAKING -- TODO - investigate rotate for Path Layer is getting assigend as number
    return str.split(' ').map(toFloat);
};

var isAnyOfValues = function isAnyOfValues(v, list) {
    return !!list.find(function (lv) {
        return lv === v;
    });
};

/* Converters */
var floatConverter = function floatConverter(v) {
    return toFloat(v);
};
var colorConverter = function colorConverter(v) {
    return toColor(v);
};
var colorRangeConverter = function colorRangeConverter(v) {
    return toColorRange(v);
};
var highlightColorRangeConverter = function highlightColorRangeConverter(v) {
    return toHighlightColorRange(v);
};
var booleanConverter = function booleanConverter(v) {
    return toBoolean(v);
};
var transformConverter = function transformConverter(v) {
    return toStandardTransform(v);
};
var transformOriginConverter = function transformOriginConverter(v) {
    return toTransformOrigin(v);
};
var viewBoxConverter = function viewBoxConverter(v) {
    return toFloatArray(v);
};
var pathConverter = function pathConverter(v) {
    return toPath(v);
};

var defaultConverter = function defaultConverter(v) {
    return v;
};

var getTypeConverter = function getTypeConverter(type) {
    if (type === 'float') {
        return floatConverter;
    }
    if (type === 'color') {
        return colorConverter;
    }
    if (type === 'boolean') {
        return booleanConverter;
    }
    if (type === 'path') {
        return pathConverter;
    }
    return defaultConverter;
};

var getImageIdProps = exports.getImageIdProps = function getImageIdProps(defModelProps) {
    return Object.keys(defModelProps).filter(function (pk) {
        return defModelProps[pk] === 'imageId';
    });
};

var getLayerAttrConverter = function getLayerAttrConverter(layerType, attrKey) {
    var layerMeta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (layerType === 'rect') {
        if (isAnyOfValues(attrKey, ['x', 'y', 'width', 'height', 'cornerRadius', 'alpha', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return floatConverter;
        }
        if (isAnyOfValues(attrKey, ['fill', 'stroke', 'shadowColor'])) {
            return colorConverter;
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return transformConverter;
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return booleanConverter;
        }
    } else if (layerType === 'ellipse') {
        if (isAnyOfValues(attrKey, ['cx', 'cy', 'rx', 'ry', 'alpha', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return floatConverter;
        }
        if (isAnyOfValues(attrKey, ['fill', 'stroke', 'shadowColor'])) {
            return colorConverter;
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return transformConverter;
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return booleanConverter;
        }
    } else if (layerType === 'path') {
        if (isAnyOfValues(attrKey, ['x', 'y', 'width', 'height', 'alpha', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'strokeTrimStart', 'strokeTrimEnd', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return floatConverter;
        }
        if (isAnyOfValues(attrKey, ['fill', 'stroke', 'shadowColor'])) {
            return colorConverter;
        }
        if (isAnyOfValues(attrKey, ['viewBox'])) {
            return viewBoxConverter;
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return transformConverter;
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return booleanConverter;
        }
    } else if (layerType === 'text') {
        if (isAnyOfValues(attrKey, ['x', 'y', 'maxWidth', 'maxHeight', 'width', 'height', 'alpha', 'fontSize', 'maxLines', 'lineHeightFactor', 'lineSpacing', 'letterSpacingFactor', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'bgAlpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur', 'visibleLineFactor', 'lowerCalorieLimit', 'lowerCalorieOffset', 'higherCalorieLimit', 'higherCalorieOffset'])) {
            return floatConverter;
        }
        if (isAnyOfValues(attrKey, ['stroke', 'shadowColor', 'bgFill'])) {
            return colorConverter;
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return transformConverter;
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled', 'fadeBackground', 'highlightEnabled', 'isCounterLayer', 'isAscendingTimer'])) {
            return booleanConverter;
        }
        if (isAnyOfValues(attrKey, ['textColor'])) {
            return colorRangeConverter;
        }
        if (isAnyOfValues(attrKey, ['highlightColor', 'highlightTextColor'])) {
            return highlightColorRangeConverter;
        }
    } else if (layerType === 'bitmap') {
        if (isAnyOfValues(attrKey, ['width', 'x', 'y', 'height', 'alpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return floatConverter;
        }
        if (isAnyOfValues(attrKey, ['shadowColor'])) {
            return colorConverter;
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return transformConverter;
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return booleanConverter;
        }
    } else if (layerType === 'bmae') {
        if (isAnyOfValues(attrKey, ['width', 'height', 'x', 'y', 'alpha'])) {
            return floatConverter;
        }
        if (!!layerMeta && !!layerMeta.mappings && !!layerMeta.mappings[attrKey]) {
            var type = layerMeta.mappings[attrKey].type;

            if (type === 'float') {
                return floatConverter;
            }
            if (type === 'color') {
                return colorConverter;
            }
        }
    } else if (layerType === 'svg') {
        if (isAnyOfValues(attrKey, ['width', 'height', 'x', 'y', 'alpha'])) {
            return floatConverter;
        }
    } else if (layerType === 'audio') {
        if (isAnyOfValues(attrKey, ['volume', 'audioDuration', 'exitOffset'])) {
            return floatConverter;
        }
    }
    return defaultConverter;
};

var convertLayerAttrValueForRender = function convertLayerAttrValueForRender(layerType, attrKey, attrValue) {
    var layerMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (layerType === 'rect') {
        if (isAnyOfValues(attrKey, ['x', 'y', 'width', 'height', 'cornerRadius', 'alpha', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return toFloat(attrValue);
        }
        if (isAnyOfValues(attrKey, ['fill', 'stroke', 'shadowColor'])) {
            return toColor(attrValue);
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return toTransformParams(attrValue);
        }
        if (isAnyOfValues(attrKey, ['clipPath'])) {
            return toPath(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return toBoolean(attrValue);
        }
    } else if (layerType === 'ellipse') {
        if (isAnyOfValues(attrKey, ['cx', 'cy', 'rx', 'ry', 'alpha', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return toFloat(attrValue);
        }
        if (isAnyOfValues(attrKey, ['fill', 'stroke', 'shadowColor'])) {
            return toColor(attrValue);
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return toTransformParams(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return toBoolean(attrValue);
        }
    } else if (layerType === 'path') {
        if (isAnyOfValues(attrKey, ['x', 'y', 'width', 'height', 'alpha', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'strokeTrimStart', 'strokeTrimEnd', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return toFloat(attrValue);
        }
        if (isAnyOfValues(attrKey, ['d', 'clipPath'])) {
            return toPath(attrValue);
        }
        if (isAnyOfValues(attrKey, ['fill', 'stroke', 'shadowColor'])) {
            return toColor(attrValue);
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return toTransformParams(attrValue);
        }
        if (isAnyOfValues(attrKey, ['strokeRangeProps'])) {
            var obj = {};
            obj.strokeRangeStart = attrValue.strokeRangeStart;
            obj.strokeRangeEnd = attrValue.strokeRangeEnd;
            obj.strokeDashoffset = toFloat(attrValue.strokeDashoffset);
            obj.strokeDasharray = attrValue.strokeDasharray.split(' ').map(toFloat);

            return obj;
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return toBoolean(attrValue);
        }
        if (isAnyOfValues(attrKey, ['rotate', 'scale', 'translate'])) {
            return toFloatArray(attrValue);
        }
    } else if (layerType === 'text') {
        if (isAnyOfValues(attrKey, ['x', 'y', 'maxWidth', 'maxHeight', 'width', 'height', 'alpha', 'fontSize', 'maxLines', 'lineHeightFactor', 'lineSpacing', 'letterSpacingFactor', 'strokeWidth', 'strokeAlpha', 'fillAlpha', 'bgAlpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur', 'visibleLineFactor'])) {
            return toFloat(attrValue);
        }
        if (isAnyOfValues(attrKey, ['stroke', 'shadowColor', 'bgFill'])) {
            return toColor(attrValue);
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return toTransformParams(attrValue);
        }
        if (isAnyOfValues(attrKey, ['clipPath'])) {
            return toPath(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled', 'fadeBackground'])) {
            return toBoolean(attrValue);
        }
        if (isAnyOfValues(attrKey, ['clipPathRotate', 'rotate', 'scale', 'translate'])) {
            return toFloatArray(attrValue);
        }
        if (isAnyOfValues(attrKey, ['fill'])) {
            return toColorRange(attrValue);
        }
    } else if (layerType === 'bitmap') {
        if (isAnyOfValues(attrKey, ['width', 'height', 'x', 'y', 'alpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur', 'cropX', 'cropY', 'cropWidth', 'cropHeight'])) {
            return toFloat(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowColor'])) {
            return toColor(attrValue);
        }
        if (isAnyOfValues(attrKey, ['transform'])) {
            return toTransformParams(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled', 'cropEnabled'])) {
            return toBoolean(attrValue);
        }
    } else if (layerType === 'bmae') {
        if (isAnyOfValues(attrKey, ['width', 'height', 'x', 'y', 'alpha'])) {
            return toFloat(attrValue);
        }
        if (!!layerMeta && !!layerMeta.mappings && !!layerMeta.mappings[attrKey]) {
            var type = layerMeta.mappings[attrKey].type;

            if (type === 'float') {
                return toFloat(attrValue);
            }
            if (type === 'color') {
                return toColor(attrValue);
            }
        }
    } else if (layerType === 'svg') {
        if (isAnyOfValues(attrKey, ['width', 'height', 'x', 'y', 'alpha', 'shadowAlpha', 'shadowOffsetX', 'shadowOffsetY', 'shadowBlur'])) {
            return toFloat(attrValue);
        }
        if (isAnyOfValues(attrKey, ['rotate', 'scale', 'translate'])) {
            return toFloatArray(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowEnabled'])) {
            return toBoolean(attrValue);
        }
        if (isAnyOfValues(attrKey, ['shadowColor'])) {
            return toColor(attrValue);
        }
    }
    return attrValue;
};

var convertGlobalAttrValueForRender = function convertGlobalAttrValueForRender(glAttrKey, glAttrValue) {
    if (isAnyOfValues(glAttrKey, ['gl_x', 'gl_y', 'gl_alpha', 'gl_rotationX', 'gl_rotationY', 'gl_rotationZ', 'gl_transformPerspective'])) {
        return toFloat(glAttrValue);
    }
    if (isAnyOfValues(glAttrKey, ['gl_clipPath'])) {
        return toPath(glAttrValue);
    }
    return glAttrValue;
};

var GLOBAL_ATTRS_LIST = (0, _GeneralUtils.deepFreeze)(['gl_x', 'gl_y', 'gl_alpha', 'gl_transform', 'gl_transformOrigin', 'gl_transformPerspective', 'gl_clipPath']);

var getGlobalAttrConverter = function getGlobalAttrConverter(glAttrKey) {
    if (isAnyOfValues(glAttrKey, ['gl_x', 'gl_y', 'gl_alpha', 'gl_rotationX', 'gl_rotationY', 'gl_rotationZ', 'gl_scaleX', 'gl_scaleY', 'gl_scaleZ', 'gl_translateX', 'gl_translateY', 'gl_translateZ', 'gl_transformPerspective'])) {
        return floatConverter;
    }
    if (isAnyOfValues(glAttrKey, ['gl_transformOrigin'])) {
        return transformOriginConverter;
    }
    return defaultConverter;
};

var SPACE_ATTR_LIST = (0, _GeneralUtils.deepFreeze)(['height', 'transform', 'width', 'x', 'y', 'zIndex']);

var SPACE_COORDINATE_LIST = exports.SPACE_COORDINATE_LIST = (0, _GeneralUtils.deepFreeze)(['ow', 'oh', 'ox', 'oy', 'cw', 'ch']);

var GLOBAL_ATTR_DEFAULTS = (0, _GeneralUtils.deepFreeze)({
    gl_x: 0,
    gl_y: 0,
    gl_alpha: 1,
    gl_transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)',
    gl_transformOrigin: '${gw/2 + gx - ox} ${gh/2 + gy - oy}',
    gl_transformPerspective: 1000,
    gl_clipPath: 'M${-ox},${-oy}L${cw-ox},${-oy}L${cw-ox},${ch-oy}L${-ox},${ch-oy}Z'
});

var GLOBAL_ATTR_TYPES = (0, _GeneralUtils.deepFreeze)({
    gl_x: 'float',
    gl_y: 'float',
    gl_alpha: 'float',
    gl_transform: 'transform3d',
    gl_transformOrigin: 'position',
    gl_transformPerspective: 'float',
    gl_clipPath: 'path'
});

var LAYER_ATTR_DEFAULTS = (0, _GeneralUtils.deepFreeze)({
    rect: {
        x: 0,
        y: 0,
        width: '${ow}',
        height: '${oh}',
        cornerRadius: 0,
        fill: '#000',
        fillAlpha: 1,
        alpha: 1,
        stroke: '#000',
        strokeWidth: 0,
        strokeAlpha: 0,
        clipPath: '',
        transform: '',
        shadowEnabled: false,
        shadowColor: '#fff',
        shadowAlpha: 0.75,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        shadowBlur: 12
    },
    ellipse: {
        cx: '${ow/2}',
        cy: '${oh/2}',
        rx: '${ow/2}',
        ry: '${oh/2}',
        fill: '#000',
        fillAlpha: 1,
        alpha: 1,
        stroke: '#000',
        strokeWidth: 0,
        strokeAlpha: 0,
        transform: '',
        shadowEnabled: false,
        shadowColor: '#fff',
        shadowAlpha: 0.75,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        shadowBlur: 12
    },
    path: {
        d: 'M0,0L${ow},0L${ow},${oh}L0,${oh}Z',
        viewBox: '0 0 ${ow} ${oh}',
        clipPath: '',
        x: 0,
        y: 0,
        width: '${ow}',
        height: '${oh}',
        fill: '#000',
        fillAlpha: 1,
        alpha: 1,
        stroke: '#000',
        strokeWidth: 0,
        strokeAlpha: 0,
        strokeCap: 'butt',
        strokeRangeProps: {
            strokeRangeStart: '0%',
            strokeRangeEnd: '100%',
            strokeDashoffset: '0',
            strokeDasharray: '999999 0'
        },
        strokeTrimStart: -1,
        strokeTrimEnd: -1,
        transform: '',
        rotate: '0',
        scale: '1 1',
        translate: '0 0',
        shadowEnabled: false,
        shadowColor: '#fff',
        shadowAlpha: 0.75,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        shadowBlur: 12
    },
    text: {
        fontFamily: 'MERRIWEATHER:NORMAL:NORMAL',
        fontSize: 100,
        maxLines: 1000,
        lineSpacing: 0,
        lineHeightFactor: 1,
        letterSpacingFactor: 0,
        visibleLineFactor: 1,
        enterTextAnim: 'none',
        exitTextAnim: 'none',
        enterTextAnimType: 'none',
        exitTextAnimType: 'none',
        layoutAlgo: 'fixed',
        x: 0,
        y: 0,
        maxWidth: '${ow}',
        maxHeight: -1,
        width: -1,
        height: '${oh}',
        align: 'center',
        text: '',
        clipPath: '',
        clipPathRotate: '0',
        transform: '',
        rotate: '0',
        scale: '1 1',
        translate: '0 0',
        fill: '#000',
        fillAlpha: 1,
        bgAlpha: 0,
        bgFill: '#000',
        fadeBackground: false,
        alpha: 1,
        stroke: '#000',
        strokeWidth: 0,
        strokeAlpha: 0,
        shadowEnabled: false,
        shadowColor: '#fff',
        shadowAlpha: 1,
        shadowOffsetX: '${2*l__self__fontSize/50}',
        shadowOffsetY: '${2*l__self__fontSize/50}',
        shadowBlur: '${6*l__self__fontSize/50}',
        highlightEnabled: false,
        highlightColor: 'rgba(0,0,0,0)',
        highlightTextColor: '#fff',
        isCounterLayer: false,
        isAscendingTimer: false,
        timeFormat: _CounterTimeFormatType2.default.SECS,
        lowerCalorieLimit: 10,
        lowerCalorieOffset: 0,
        higherCalorieLimit: 15,
        higherCalorieOffset: 0
    },
    bitmap: {
        x: 0,
        y: 0,
        baseUrl: '',
        imageId: '',
        crop: 'none',
        width: '${ow}',
        height: '${oh}',
        alpha: 1,
        transform: '',
        shadowEnabled: false,
        shadowColor: '#444',
        shadowAlpha: 0.75,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        shadowBlur: 12,
        cropEnabled: false,
        cropX: 0,
        cropY: 0,
        cropWidth: 100,
        cropHeight: 100
    },
    bmae: {
        x: 0,
        y: 0,
        width: '${ow}',
        height: '${oh}',
        alpha: 1
    },
    svg: {
        x: 0,
        y: 0,
        width: '${ow}',
        height: '${oh}',
        alpha: 1,
        rotate: '0',
        scale: '1 1',
        translate: '0 0',
        svgId: '',
        shadowEnabled: false,
        shadowColor: '#444',
        shadowAlpha: 0.75,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        shadowBlur: 12,
        layerPropertyHash: ''
    },
    audio: {
        audioId: '',
        exitOffset: 0,
        volume: 100,
        audioDuration: 3000 // 3secs
    }
});

var LAYER_ATTR_TYPES = (0, _GeneralUtils.deepFreeze)({
    rect: {
        x: 'float',
        y: 'float',
        width: 'float',
        height: 'float',
        cornerRadius: 'float',
        fill: 'color',
        fillAlpha: 'float',
        alpha: 'float',
        stroke: 'color',
        strokeWidth: 'float',
        strokeAlpha: 'float',
        clipPath: 'path',
        transform: 'transform',
        shadowEnabled: 'boolean',
        shadowColor: 'color',
        shadowAlpha: 'float',
        shadowOffsetX: 'float',
        shadowOffsetY: 'float',
        shadowBlur: 'float'
    },
    ellipse: {
        cx: 'float',
        cy: 'float',
        rx: 'float',
        ry: 'float',
        fill: 'color',
        fillAlpha: 'float',
        alpha: 'float',
        stroke: 'color',
        strokeWidth: 'float',
        strokeAlpha: 'float',
        transform: 'transform',
        shadowEnabled: 'boolean',
        shadowColor: 'color',
        shadowAlpha: 'float',
        shadowOffsetX: 'float',
        shadowOffsetY: 'float',
        shadowBlur: 'float'
    },
    path: {
        d: 'path',
        viewBox: 'viewbox',
        clipPath: 'path',
        x: 'float',
        y: 'float',
        width: 'float',
        height: 'float',
        fill: 'color',
        fillAlpha: 'float',
        alpha: 'float',
        stroke: 'color',
        strokeWidth: 'float',
        strokeAlpha: 'float',
        strokeCap: 'string',
        strokeRangeProps: {
            type: 'strokerangeprops',
            strokeRangeStart: 'string',
            strokeRangeEnd: 'string',
            strokeDashoffset: 'string',
            strokeDasharray: 'string'
        },
        strokeTrimStart: 'float',
        strokeTrimEnd: 'float',
        transform: 'transform',
        rotate: 'rotate',
        translate: 'translate',
        scale: 'scale',
        shadowEnabled: 'boolean',
        shadowColor: 'color',
        shadowAlpha: 'float',
        shadowOffsetX: 'float',
        shadowOffsetY: 'float',
        shadowBlur: 'float'
    },
    text: {
        fontFamily: 'string',
        fontSize: 'float',
        maxLines: 'int',
        lineSpacing: 'float',
        lineHeightFactor: 'float',
        letterSpacingFactor: 'float',
        visibleLineFactor: 'float',
        enterTextAnim: 'string',
        exitTextAnim: 'string',
        enterTextAnimType: 'string',
        exitTextAnimType: 'string',
        layoutAlgo: 'string',
        x: 'float',
        y: 'float',
        maxWidth: 'float',
        maxHeight: 'float',
        width: 'float',
        height: 'float',
        align: 'align',
        text: 'string',
        clipPath: 'path',
        clipPathRotate: 'rotate',
        transform: 'transform',
        rotate: 'rotate',
        translate: 'translate',
        scale: 'scale',
        fill: 'textColor',
        fillAlpha: 'float',
        bgAlpha: 'float',
        bgFill: 'color',
        fadeBackground: 'boolean',
        alpha: 'float',
        stroke: 'color',
        strokeWidth: 'float',
        strokeAlpha: 'float',
        shadowEnabled: 'boolean',
        shadowColor: 'color',
        shadowAlpha: 'float',
        shadowOffsetX: 'float',
        shadowOffsetY: 'float',
        shadowBlur: 'float',
        highlightEnabled: 'boolean',
        highlightColor: 'highlightColor',
        highlightTextColor: 'highlightTextColor',
        isCounterLayer: 'boolean',
        isAscendingTimer: 'boolean',
        timeFormat: 'string',
        lowerCalorieLimit: 'int',
        lowerCalorieOffset: 'int',
        higherCalorieLimit: 'int',
        higherCalorieOffset: 'int'
    },
    bitmap: {
        baseUrl: 'string',
        imageId: 'string',
        crop: 'string',
        x: 'float',
        y: 'float',
        width: 'float',
        height: 'float',
        alpha: 'float',
        transform: 'transform',
        shadowEnabled: 'boolean',
        shadowColor: 'color',
        shadowAlpha: 'float',
        shadowOffsetX: 'float',
        shadowOffsetY: 'float',
        shadowBlur: 'float',
        cropEnabled: 'boolean',
        cropX: 'float',
        cropY: 'float',
        cropWidth: 'float',
        cropHeight: 'float'
    },
    bmae: {
        x: 'float',
        y: 'float',
        width: 'float',
        height: 'float',
        alpha: 'float'
    },
    svg: {
        x: 'float',
        y: 'float',
        width: 'float',
        height: 'float',
        alpha: 'float',
        rotate: 'rotate',
        translate: 'translate',
        scale: 'scale',
        svgId: 'string',
        shadowEnabled: 'boolean',
        shadowColor: 'color',
        shadowAlpha: 'float',
        shadowOffsetX: 'float',
        shadowOffsetY: 'float',
        shadowBlur: 'float',
        layerPropertyHash: 'string'
    },
    audio: {
        audioId: 'string',
        exitOffset: 'float',
        volume: 'float',
        audioDuration: 'float'
    }
});

var customEasesInitialized = false;
var elasticEaseOut = null;
var elasticEaseIn = null;

var initCustomEases = function initCustomEases() {
    CustomEase.create('Easy.easeInOut', 'M0,0 C0.208,0.132 0.21,0.4 0.284,0.62 0.369,0.874 0.638,1 1,1');
    CustomEase.create('Easy.easeInOutReverse', 'M0,0 C0.362,0 0.631,0.126 0.716,0.38 0.79,0.6 0.792,0.868 1,1');

    elasticEaseOut = Elastic.easeOut.config(1.1, 0.5);
    elasticEaseIn = Elastic.easeIn.config(1.1, 0.5);
};

var toEase = function toEase(e, defaultE) {
    if (!customEasesInitialized) {
        initCustomEases();
        customEasesInitialized = true;
    }

    if (e === 'easein') {
        return 'Quad.easeIn';
    }
    if (e === 'easeout') {
        return 'Quad.easeOut';
    }
    if (e === 'easeinout') {
        return 'Quad.easeInOut';
    }
    if (e === 'easyEaseInOut') {
        return 'Easy.easeInOut';
    }
    if (e === 'easyEaseInOutReverse') {
        return 'Easy.easeInOutReverse';
    }
    if (e === 'linear') {
        return 'Linear.easeNone';
    }
    if (e === 'elasticEaseOut') {
        return elasticEaseOut;
    }
    if (e === 'elasticEaseIn') {
        return elasticEaseIn;
    }
    return defaultE;
};

var parseTransformString = function parseTransformString(a) {
    var b = [];
    for (var i in a = a.match(/(\w+\((\-?\d+\.?\d*e?\-?\d*,?\s?)+\))+/g)) {
        var c = a[i].match(/[\w\.\-]+/g);
        var key = c.shift();
        b.push([key, c]);
    }
    return b;
};

var toTransformParams = function toTransformParams(tStr) {
    if (Array.isArray(tStr)) {
        // Probably already a matrix
        return tStr;
    }

    var tMatrix = new _snapsvg2.default.Matrix();

    var transformList = parseTransformString(tStr);
    transformList.forEach(function (t) {
        var _t = _slicedToArray(t, 2),
            type = _t[0],
            values = _t[1];

        if (type === 'translate') {
            tMatrix.translate(toFloat(values[0]), toFloat(values[1]));
        } else if (type === 'scale') {
            tMatrix.scale(toFloat(values[0], 1), toFloat(values[1], 1), toFloat(values[2], 0), toFloat(values[3], 0));
        } else if (type === 'skew') {
            tMatrix.skew(toFloat(values[0], 0), toFloat(values[1], 0));
        } else if (type === 'rotate') {
            tMatrix.rotate(toFloat(values[0]), toFloat(values[1], 0), toFloat(values[2], 0));
        } else if (type === 'matrix') {
            tMatrix.add(toFloat(values[0], 1), toFloat(values[1], 1), toFloat(values[2], 1), toFloat(values[3], 1), toFloat(values[4], 1), toFloat(values[5], 1));
        }
    });
    return [tMatrix.a, tMatrix.b, tMatrix.c, tMatrix.d, tMatrix.e, tMatrix.f];
};

var getScaleFromTransformString = function getScaleFromTransformString(tStr) {
    var tMatrixParams = toTransformParams(tStr);
    return [tMatrixParams[0], tMatrixParams[3]];
};

var getScaledTransformString = function getScaledTransformString(tStr, scaleX, scaleY) {
    var tMatrixParams = toTransformParams(tStr);

    var newMatrix = new (Function.prototype.bind.apply(_snapsvg2.default.Matrix, [null].concat(_toConsumableArray(tMatrixParams))))();
    newMatrix.scale(scaleX, scaleY);

    var a = newMatrix.a,
        b = newMatrix.b,
        c = newMatrix.c,
        d = newMatrix.d,
        e = newMatrix.e,
        f = newMatrix.f;

    return 'matrix(' + a + ', ' + b + ', ' + c + ', ' + d + ', ' + e + ', ' + f + ')';
};

var getRotatedTransformString = function getRotatedTransformString(tStr) {
    var rotateDeg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var tMatrixParams = toTransformParams(tStr);

    var newMatrix = new (Function.prototype.bind.apply(_snapsvg2.default.Matrix, [null].concat(_toConsumableArray(tMatrixParams))))();
    newMatrix.rotate(rotateDeg);

    var a = newMatrix.a,
        b = newMatrix.b,
        c = newMatrix.c,
        d = newMatrix.d,
        e = newMatrix.e,
        f = newMatrix.f;

    return 'matrix(' + a + ', ' + b + ', ' + c + ', ' + d + ', ' + e + ', ' + f + ')';
};

function createLayerInfo(l) {
    var type = l.type;

    if (type === 'text') {
        return new _TextLayerUtils.TextLayerInfo();
    }
    if (type === 'bmae') {
        return new _BodyMovinLayerInfo2.default(l);
    }
    return null;
}

var toRelLumV = function toRelLumV(v) {
    if (v <= 0.03928) {
        return v / 12.92;
    }
    return Math.pow((v + 0.055) / 1.055, 2.4);
};

var calcLum = function calcLum(rgbObj) {
    var r = rgbObj.r,
        g = rgbObj.g,
        b = rgbObj.b;

    var srgbR = r / 255;
    var srgbG = g / 255;
    var srgbB = b / 255;

    var R = toRelLumV(srgbR);
    var G = toRelLumV(srgbG);
    var B = toRelLumV(srgbB);

    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
};

var WHITE_LUM = calcLum({ r: 255, g: 255, b: 255 });
var BLACK_LUM = calcLum({ r: 0, g: 0, b: 0 });

var getColorFromLum = function getColorFromLum(lum) {
    // Output will be a grayscale color
    var GRAY = lum / (0.2126 + 0.7152 + 0.0722);

    var srgbGray = 0;
    if (GRAY < 0.03928 / 12.92) {
        srgbGray = GRAY * 12.92;
    } else {
        srgbGray = Math.pow(GRAY, 1 / 2.4) * 1.055 - 0.055;
    }

    var gray = Math.min(Math.max(Math.floor(srgbGray * 255), 0), 255);

    return { r: gray, g: gray, b: gray };
};

function calcBestContrastRGB(rgbObj) {
    // Method to achieve a contrast ratio between the shadow and the text more than 5:1 as provided here -
    // https://www.w3.org/TR/2014/NOTE-WCAG20-TECHS-20140916/G18

    var textL = calcLum(rgbObj);

    var contrastRatioWithWhite = (WHITE_LUM + 0.05) / (textL + 0.05);
    var contrastRatioWithBlack = (textL + 0.05) / (BLACK_LUM + 0.05);

    // console.log(`crWhite ${contrastRatioWithWhite} crBlack ${contrastRatioWithBlack}`);

    var MIN_TARGET_CONTRAST_RATIO = 12;
    var shadowL = 0;

    if (contrastRatioWithBlack > MIN_TARGET_CONTRAST_RATIO) {
        shadowL = (textL + 0.05) / MIN_TARGET_CONTRAST_RATIO - 0.05;
    } else {
        shadowL = BLACK_LUM;
    }

    return getColorFromLum(shadowL);
}
// TODO -- convert to for loop
var ensureBefore = function ensureBefore(depOrder, targetId, beforeIds) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var beforeId = _step.value;

            var targetIndex = depOrder.findIndex(function (d) {
                return d.layer.id === targetId;
            });
            var beforeIndex = depOrder.findIndex(function (d) {
                return d.layer.id === beforeId;
            });
            if (targetIndex < beforeIndex) {
                depOrder = depOrder.map(function (d) {
                    if (d.layer.id === targetId) {
                        return depOrder[beforeIndex];
                    }
                    if (d.layer.id === beforeId) {
                        return depOrder[targetIndex];
                    }
                    return d;
                });
            }
        };

        for (var _iterator = beforeIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return depOrder;
};

var calcBestShadowContrast = function calcBestShadowContrast(v) {
    return (0, _color2.default)(calcBestContrastRGB((0, _color2.default)(v).rgb().object())).rgb().string();
};

exports.floatConverter = floatConverter;
exports.colorConverter = colorConverter;
exports.colorRangeConverter = colorRangeConverter;
exports.highlightColorRangeConverter = highlightColorRangeConverter;
exports.pathConverter = pathConverter;
exports.defaultConverter = defaultConverter;
exports.getGlobalAttrConverter = getGlobalAttrConverter;
exports.getLayerAttrConverter = getLayerAttrConverter;
exports.getTypeConverter = getTypeConverter;
exports.toFloat = toFloat;
exports.toColor = toColor;
exports.toPath = toPath;
exports.toTransformOrigin = toTransformOrigin;
exports.ensureBefore = ensureBefore;
exports.calcBestShadowContrast = calcBestShadowContrast;
exports.convertLayerAttrValueForRender = convertLayerAttrValueForRender;
exports.convertGlobalAttrValueForRender = convertGlobalAttrValueForRender;
exports.GLOBAL_ATTR_DEFAULTS = GLOBAL_ATTR_DEFAULTS;
exports.GLOBAL_ATTR_TYPES = GLOBAL_ATTR_TYPES;
exports.LAYER_ATTR_DEFAULTS = LAYER_ATTR_DEFAULTS;
exports.LAYER_ATTR_TYPES = LAYER_ATTR_TYPES;
exports.GLOBAL_ATTRS_LIST = GLOBAL_ATTRS_LIST;
exports.SPACE_ATTR_LIST = SPACE_ATTR_LIST;
exports.toEase = toEase;
exports.parseTransformString = parseTransformString;
exports.toTransformParams = toTransformParams;
exports.getScaleFromTransformString = getScaleFromTransformString;
exports.getScaledTransformString = getScaledTransformString;
exports.getRotatedTransformString = getRotatedTransformString;
exports.createLayerInfo = createLayerInfo;
exports.calcBestContrastRGB = calcBestContrastRGB;
var applyCss = exports.applyCss = function applyCss(el, prop, value) {
    var applyProps = [prop];
    if (prop === 'transformOrigin') {
        applyProps = ['transformOrigin', 'webkitTransformOrigin', 'mozTransformOrigin', 'msTransformOrigin', 'oTransformOrigin'];
    } else if (prop === 'transform') {
        applyProps = ['transform', 'webkitTransform', 'mozTransform', 'msTransform', 'oTransform'];
    } else if (prop === 'perspective') {
        applyProps = ['perspective', 'webkitPerspective', 'mozPerspective', 'msPerspective', 'oPerspective'];
    }
    var len = applyProps.length;
    while (len--) {
        el.style[applyProps[len]] = value;
    }
};

var hasExpression = exports.hasExpression = function hasExpression(a) {
    return typeof a === 'string' && /\${(.[^}]+)}/.test(a);
};

var tokenize = exports.tokenize = function tokenize(a) {
    var tokens = [];

    var str = a;

    var re = /\${(.[^}]+)}/g;

    var fullMatch = null;
    var matchedExp = null;
    var prevLastIndex = 0;
    var result = null;
    while ((result = re.exec(str)) !== null) {
        fullMatch = result[0];
        matchedExp = result[1];

        var fIndex = result.index;

        // Push the non-expression until the match
        if (fIndex - prevLastIndex > 0) {
            tokens.push({
                type: 'const',
                content: str.substr(prevLastIndex, fIndex - prevLastIndex)
            });
        }
        tokens.push({
            type: 'expr',
            content: str.substr(fIndex + 2, matchedExp.length)
        });

        prevLastIndex = re.lastIndex;
    }

    if (prevLastIndex !== str.length) {
        // There is a constant between these
        tokens.push({
            type: 'const',
            content: str.substr(prevLastIndex)
        });
    }

    return tokens;
};

},{"../../../edit/constants/CounterTimeFormatType":201,"../ColorRange":71,"../GeneralUtils":77,"../HighlightColorRange":78,"./BodyMovinLayerInfo":115,"./TextLayerUtils":124,"color":418,"fast-memoize":633,"lodash":860,"snapsvg":1173}],122:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _LayerRenderers = require('./LayerRenderers');

var _DefModel = require('./DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _FontManager = require('../FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _Observable = require('../Observable');

var _Observable2 = _interopRequireDefault(_Observable);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var OverlayRenderView = function () {
    function OverlayRenderView(rootTimeline, forceRenderFunc) {
        var _this = this;

        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref$observeVisibilit = _ref.observeVisibility,
            observeVisibility = _ref$observeVisibilit === undefined ? true : _ref$observeVisibilit,
            _ref$allowPointerEven = _ref.allowPointerEvents,
            allowPointerEvents = _ref$allowPointerEven === undefined ? false : _ref$allowPointerEven;

        _classCallCheck(this, OverlayRenderView);

        this.onVisibilityChange = function () {
            var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (fn && typeof fn === 'function' && _this.observeVisibility) {
                _this.visibilityObserver.subscribe('visiblity', fn);
            }
        };

        this.updateIsVisible = function () {
            if (!_this.observeVisibility) return;
            var currentVisible = _this.isVisible();
            if (_this._visibilityStatus !== currentVisible) {
                _this.visibilityObserver.emit('visiblity', currentVisible);
                _this._visibilityStatus = currentVisible;
            }
        };

        this.updateTime = function () {
            if (_this.defModel) {
                return _this.defModel.updateTimeline();
            }
        };

        var rootDivEl = document.createElement('div');

        rootDivEl.className = 'overlay-root-div';

        Object.assign(rootDivEl.style, {
            position: 'absolute',
            overflow: 'visible',
            width: 0,
            height: 0,
            left: 0,
            top: 0,
            pointerEvents: allowPointerEvents ? 'auto' : 'none',
            cursor: allowPointerEvents ? 'pointer' : 'auto'
        });

        this.rootDivEl = rootDivEl;
        this.overlay = null;
        this.layerRenderers = [];

        this.defModel = null;

        this.rootTimeline = rootTimeline;
        this.forceRenderFunc = forceRenderFunc;
        this.timeline = null;

        this.visibilityObserver = new _Observable2.default({
            useBatch: false
        });

        this.observeVisibility = observeVisibility;

        this._visibilityStatus = false;
    }

    _createClass(OverlayRenderView, [{
        key: 'destroy',
        value: function destroy() {
            this.layerRenderers.forEach(function (lr) {
                return lr.destroy();
            });
            this.layerRenderers = [];

            this.defModel.detachParentTimeline();
            this.defModel = null;

            this.rootTimeline.remove(this.timeline);
            this.rootTimeline = null;
            this.timeline = null;

            this.rootDivEl.remove();
            this.rootDivEl = null;

            this.overlay = null;

            this.visibilityObserver = null;

            this._visibilityStatus = false;
        }
    }, {
        key: 'getDOMEl',
        value: function getDOMEl() {
            return this.rootDivEl;
        }
    }, {
        key: 'isFontKeyUsed',
        value: function isFontKeyUsed(fontKey) {
            if (this.defModel) {
                return !!this.defModel.getUsedFontKeys().find(function (fk) {
                    return fk === fontKey;
                });
            }
            return false;
        }
    }, {
        key: 'updateData',
        value: function updateData(overlay, reelCanvas, displayScale, selected, paused, overlayGroupSettings) {
            var _this2 = this;

            var forceUpdate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

            if (this.overlay === null) {
                this.timeline = new TimelineMax();
                this.rootTimeline.add(this.timeline, 0);

                this.defModel = _DefModel.DefModelRegistry.getModelForOverlay(overlay.defId, overlay.id);
                this.defModel.attachParentTimeline(this.timeline, this.forceRenderFunc);
                this.defModel.update(overlay.space, overlay.time, overlay.values, reelCanvas, overlayGroupSettings);

                this.defModel.getUsedFontKeys().map(function (fontKey) {
                    return _FontManager2.default.loadFontP(fontKey);
                });

                // Create a LayerRenderer for each layer

                this.defModel.def.layers.forEach(function (l) {
                    var layerRenderer = (0, _LayerRenderers.createLayerRenderer)(l, _this2.defModel, function () {
                        return _this2.checkAndRender();
                    });

                    _this2.layerRenderers[l.id] = layerRenderer;
                    if (!layerRenderer.isShy()) {
                        _this2.rootDivEl.appendChild(layerRenderer.getCanvas());
                    }
                });

                this.defModel.updateTimeline();

                this.timeline.eventCallback('onUpdate', function () {
                    _this2.updateIsVisible();
                    _this2.checkAndRender();
                });
            } else {
                if (this.overlay.id !== overlay.id) {
                    throw new Error('Attempted reuse of overlay render view for a different overlay');
                }

                this.defModel.update(overlay.space, overlay.time, overlay.values, reelCanvas, overlayGroupSettings, forceUpdate);

                this.updateIsVisible();

                this.defModel.getUsedFontKeys().map(function (fontKey) {
                    return _FontManager2.default.loadFontP(fontKey);
                });
            }

            this.overlay = overlay;

            this.checkAndRender({
                callback: function callback(lr) {
                    lr.update(reelCanvas, displayScale, selected, paused);
                },
                forcePaint: forceUpdate
            });
        }
    }, {
        key: 'isVisible',
        value: function isVisible() {
            if (this.defModel) {
                return this.defModel.getVisibility();
            }
            return false;
        }
    }, {
        key: 'checkAndRender',
        value: function checkAndRender() {
            var _this3 = this;

            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                callback = _ref2.callback,
                _ref2$forcePaint = _ref2.forcePaint,
                forcePaint = _ref2$forcePaint === undefined ? false : _ref2$forcePaint;

            var dirtyLayers = {};
            if (this.defModel) {
                var len = this.defModel.layerRenderOrder.length;
                for (var i = 0; i < len; i += 1) {
                    var _defModel$layerRender = this.defModel.layerRenderOrder[i],
                        l = _defModel$layerRender.l,
                        _defModel$layerRender2 = _defModel$layerRender.deps,
                        deps = _defModel$layerRender2 === undefined ? [] : _defModel$layerRender2;

                    var lr = this.layerRenderers[l.id];
                    if (callback) {
                        callback(lr);
                    }
                    lr.invalidateIfChanged();
                    dirtyLayers[l.id] = lr.dirty;
                    if (deps.length > 0) {
                        var shouldForce = !!deps.find(function (dlid) {
                            return dlid in dirtyLayers;
                        });
                        var depRenderers = deps.map(function (dlid) {
                            return _this3.layerRenderers[dlid];
                        });
                        lr.renderLayer(shouldForce || forcePaint, depRenderers);
                    } else {
                        lr.renderLayer(forcePaint);
                    }
                }
            }
        }
    }]);

    return OverlayRenderView;
}();

exports.default = OverlayRenderView;

},{"../FontManager":76,"../Observable":81,"./DefModel":119,"./LayerRenderers":120}],123:[function(require,module,exports){
'use strict';

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _svgson = require('svgson');

var _svgson2 = _interopRequireDefault(_svgson);

var _GeneralUtils = require('../GeneralUtils');

var _LayerUtils = require('./LayerUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var SVGCanvasPainter = function () {
    function SVGCanvasPainter() {
        var _this = this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$defaultHeight = _ref.defaultHeight,
            defaultHeight = _ref$defaultHeight === undefined ? 200 : _ref$defaultHeight,
            _ref$defaultWidth = _ref.defaultWidth,
            defaultWidth = _ref$defaultWidth === undefined ? 200 : _ref$defaultWidth,
            _ref$updateRate = _ref.updateRate,
            updateRate = _ref$updateRate === undefined ? 1500 : _ref$updateRate,
            _ref$propertyConfigMa = _ref.propertyConfigMap,
            propertyConfigMap = _ref$propertyConfigMa === undefined ? {} : _ref$propertyConfigMa,
            _ref$renderMode = _ref.renderMode,
            renderMode = _ref$renderMode === undefined ? false : _ref$renderMode;

        _classCallCheck(this, SVGCanvasPainter);

        _initialiseProps.call(this);

        this.defaultHeight = defaultHeight;
        this.defaultWidth = defaultWidth;

        this.cachedBuffer = Promise.resolve(null);

        this.paintPromiseLoop = Promise.resolve(null);

        this.updateRate = updateRate;

        var _createCanvas = this.__createCanvas({ defaultHeight: defaultHeight, defaultWidth: defaultWidth }),
            canvas = _createCanvas.canvas,
            ctx = _createCanvas.ctx;

        this.canvas = canvas;
        this.ctx = ctx;

        var _createCanvas2 = this.__createCanvas({
            defaultWidth: defaultWidth,
            defaultHeight: defaultHeight
        }),
            offScreenCanvas = _createCanvas2.canvas,
            offScreenCanvasCtx = _createCanvas2.ctx;

        this.offScreenCanvas = offScreenCanvas;
        this.offScreenCanvasCtx = offScreenCanvasCtx;
        this.offscreenCanvasUpdateCount = 0;

        var funcForDebounce = async function funcForDebounce(func) {
            var stringifiedSVG = _svgson2.default.stringify(_this.svgJSON);
            _this.cachedBuffer = _this.cachedBuffer.then(_this.cacheSVGImage(stringifiedSVG, func));
            var value = await _this.cachedBuffer;
            return value;
        };

        // debounces the repeated string parsing of the SVGString
        this.debouncedCacheSVGImage = !renderMode ? (0, _GeneralUtils.asyncDebounce)(funcForDebounce, this.updateRate) : funcForDebounce;

        this.propertyConfigMap = propertyConfigMap;

        this.noConfigMap = !this.propertyConfigMap;

        this.propertyConfigOperator = {};

        this.previousConfigProps = {};
    }

    _createClass(SVGCanvasPainter, [{
        key: 'checkAndSetNewConfigProps',
        value: function checkAndSetNewConfigProps(newConfigProps) {
            var isStale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.noConfigMap) {
                return false;
            }

            newConfigProps = Object.keys(this.propertyConfigMap).reduce(function (acc, key) {
                if (!!newConfigProps[key]) {
                    acc[key] = newConfigProps[key];
                }
                return acc;
            }, {});

            if (isStale || !(0, _GeneralUtils.shallowEqual)(newConfigProps, this.previousConfigProps)) {
                this.previousConfigProps = newConfigProps;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.entries(newConfigProps)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            key = _step$value[0],
                            value = _step$value[1];

                        var operator = this.propertyConfigOperator[key];
                        operator && operator(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return true;
            }
            return false;
        }
    }, {
        key: 'parseSVGString',
        value: function parseSVGString(svgString) {
            // TODO -- remove this and convert it to use the JSON data
            var svgEl = new DOMParser().parseFromString(svgString, 'image/svg+xml').children[0];

            var svgViewBox = null;

            if (!svgViewBox) {
                var viewBoxAttr = svgEl.getAttribute('viewBox');
                if (viewBoxAttr) {
                    svgViewBox = viewBoxAttr.split(' ').map(_LayerUtils.toFloat);
                    svgEl.setAttribute('width', svgViewBox[2]);
                    svgEl.setAttribute('height', svgViewBox[3]);
                }
            }

            if (!svgViewBox) {
                var _ref2 = [svgEl.getAttribute('height'), svgEl.getAttribute('width')],
                    _height = _ref2[0],
                    _width = _ref2[1];

                if (!_height && !_width) {
                    _width = this.defaultHeight;
                    _height = this.defaultWidth;
                    // do nothing
                } else if (!_width) {
                    _width = _height;
                    svgEl.setAttribute('width', _height);
                } else if (!_height) {
                    _height = _width;
                    svgEl.setAttribute('height', _width);
                }
                svgViewBox = [0, 0, _width, _height].map(_LayerUtils.toFloat);
                svgEl.setAttribute('viewBox', svgViewBox.join(' '));
            }

            var height = svgViewBox[3];
            var width = svgViewBox[2];

            var svgJSON = _svgson2.default.parseSync(svgString);

            this.propertyConfigOperator = this.buildPropertyConfigOperator(this.propertyConfigMap, svgJSON);

            return { svgEl: svgEl, svgViewBox: svgViewBox, height: height, width: width, svgJSON: svgJSON };
        }

        /**
         * On buffer load is called in case a layer Needs invalidation
         * or some side effect for re-rendering needs to be executed
         *
         * @param {*} svgString
         * @param {*} [onSVGBufferLoaded=() => {}]
         * @memberof SVGCanvasPainter
         */

    }, {
        key: 'updateSVGString',
        value: function updateSVGString(svgString) {
            var _this2 = this;

            var onSVGBufferLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            if (this.prevSvgString !== svgString && !!svgString) {
                this.prevSvgString = svgString;

                var _parseSVGString = this.parseSVGString(svgString),
                    svgEl = _parseSVGString.svgEl,
                    svgViewBox = _parseSVGString.svgViewBox,
                    height = _parseSVGString.height,
                    width = _parseSVGString.width,
                    svgJSON = _parseSVGString.svgJSON;

                this.svgJSON = svgJSON;
                this.svgEl = svgEl;
                this.svgViewBox = svgViewBox;
                this.svgHeight = height;
                this.svgWidth = width;
                this.sar = width / height;

                this.cachedBuffer = this.cacheSVGImage(svgString, function () {
                    _this2.stale = true;
                    onSVGBufferLoaded.apply(undefined, arguments);
                });

                return { svgViewBox: svgViewBox, height: height, width: width, svgEl: svgEl, update: true };
            }
            return {
                svgEl: this.svgEl,
                height: this.svgHeight,
                width: this.svgWidth,
                svgViewBox: this.svgViewBox,
                update: false
            };
        }
    }]);

    return SVGCanvasPainter;
}();

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.__createCanvas = function (_ref3) {
        var _ref3$defaultHeight = _ref3.defaultHeight,
            defaultHeight = _ref3$defaultHeight === undefined ? 200 : _ref3$defaultHeight,
            _ref3$defaultWidth = _ref3.defaultWidth,
            defaultWidth = _ref3$defaultWidth === undefined ? 200 : _ref3$defaultWidth;

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        ctx.imageSmoothingEnabled = false;
        return {
            canvas: canvas,
            ctx: ctx
        };
    };

    this.__editProperty = function (svgSon, path) {
        path = path.split('.');
        var cobj = svgSon;
        for (var i = 0; i < path.length - 1; i++) {
            if ((typeof cobj === 'undefined' ? 'undefined' : _typeof(cobj)) === 'object') {
                cobj = cobj[path[i]];
            } else {
                return null;
            }
        }
        var key = path[path.length - 1];
        return function (value) {
            cobj[key] = value;
        };
    };

    this.buildPropertyConfigOperator = function (propertyConfigMap, svgSon) {
        if (_this3.noConfigMap) {
            return null;
        }

        var propertyConfigOperator = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = Object.entries(propertyConfigMap)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    key = _step2$value[0],
                    value = _step2$value[1];

                propertyConfigOperator[key] = _this3.__editProperty(svgSon, value);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return propertyConfigOperator;
    };

    this.getDisplayCanvas = function () {
        return _this3.canvas;
    };

    this.cleanUp = function () {
        _this3.canvas = null;
        _this3.offScreenCanvas = null;
        _this3.offScreenCanvasCtx = null;
        _this3.ctx = null;
        _this3.svgEl = null;
        _this3.cachedBuffer = null;
    };

    this.cacheSVGImage = async function (svgString) {
        var onSVGBufferLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        var action = new Promise(function (resolve) {
            var blob = new Blob([svgString], { type: 'image/svg+xml' });
            var url = URL.createObjectURL(blob);

            var img = new Image();
            img.onload = function () {
                _this3.__currentCachedSVGImage = img;
                onSVGBufferLoaded(img);
                resolve(img);
                img.onload = null;
            };
            img.src = url;
        });
        return action;
    };

    this.__drawOnOffScreenCanvas = function (data, height, width) {
        _this3.offScreenCanvas.height = Math.floor(height);
        _this3.offScreenCanvas.width = Math.floor(width);
        _this3.offScreenCanvasCtx.drawImage(data, 0, 0, _this3.offScreenCanvas.width, _this3.offScreenCanvas.height);
    };

    this.paintSVG = function ()
    // // this is used to indicated caller to make it's transforms on canvas
    // // so that it's ready to be painted on
    // it's a hack because canvas state won't be saved as expected
    {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this3.svgHeight;
        var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this3.svgWidth;
        var scale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
        var force = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        var svgProps = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
        var onOffScreenCanvasUpdate = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function () {};

        var svgPropsChanged = _this3.checkAndSetNewConfigProps(svgProps, _this3.stale);

        if (_this3.previousHeight !== height || _this3.previousWidth !== width || _this3.previousScale !== scale || force || !_this3.__offScreenCanvasFilled || _this3.stale || svgPropsChanged) {
            _this3.previousHeight = height;
            _this3.previousWidth = width;
            _this3.previousScale = scale;

            var data = _this3.__currentCachedSVGImage; // current cached SVG image instance

            if (data) {
                // offscreen canvas acts the PreCreated Buffer , to copy contents from
                // When the height and width changes we copy the precreated

                var actualHeight = Math.max(height * scale, _this3.svgHeight);
                var actualWidth = Math.max(width * scale, _this3.svgWidth);

                // // update offscreen canvas if the updates are done for height / width or anything else
                // // it uses actual height and width by undoing the scaling because we need
                // // crisp images as the browser SVG would do.
                // this.__drawOnOffScreenCanvas(data, actualHeight, actualWidth);

                // // the content is no more stale and it will respect height width change
                _this3.stale = false;

                // // offscreencanvas updated , which means onscreen will be updated
                // if (!this.__offScreenCanvasFilled) {
                //     this.offscreenCanvasUpdateCount += 1;
                // }
                // this.__offScreenCanvasFilled = true;

                // repaint on the onscreen on (PRETTY FAST)
                if (!_this3.__offScreenCanvasFilled) {
                    _this3.ctx.drawImage(data, x, y, width, height);
                } else {
                    _this3.ctx.drawImage(_this3.offScreenCanvas, x, y, width, height);
                }

                // now change the height / width
                // increasing resolution and props of SVG is a costly operation
                // so we update it post doing a fake size update (pixelated version)
                _this3.svgJSON.attributes.height = height * scale;
                _this3.svgJSON.attributes.width = _this3.sar * height * scale;

                // now we trigger a recache of the offscreen cache.

                _this3.debouncedCacheSVGImage(function (img) {
                    // draw the updated content , on the off screen canvas
                    _this3.offscreenCanvasUpdateCount += 1;
                    _this3.__offScreenCanvasFilled = true;
                    _this3.__drawOnOffScreenCanvas(img, actualHeight, actualWidth);
                    // console.log(`Sync reflush of layer`)
                    onOffScreenCanvasUpdate(img);
                });
            }
        } else {
            // we copy offscreen canvas content to the target canvas
            // target canvas can have any drawing height or width , set up by the target
            // but the height and width is sepcified by offscreen canvas which will not be stretched and
            // will be redrawn in above block to maintain quality

            _this3.ctx.drawImage(_this3.offScreenCanvas, x, y, width, height);
        }
    };
};

exports.default = SVGCanvasPainter;

},{"../GeneralUtils":77,"./LayerUtils":121,"svgson":1198}],124:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextLayerInfo = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}(); /* eslint-disable max-classes-per-file */

var _FontManager = require('../FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _CounterTimeFormatType = require('../../../edit/constants/CounterTimeFormatType');

var _CounterTimeFormatType2 = _interopRequireDefault(_CounterTimeFormatType);

var _OverlayUtils = require('../../../edit/utils/OverlayUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var getFont = function getFont(fontKey) {
    if (_FontManager2.default.isLoaded(fontKey)) {
        return _FontManager2.default.getFont(fontKey);
    }
    return _FontManager2.default.getDefaultFont();
};

var getFontFeaturesFromScript = function getFontFeaturesFromScript(font, script) {
    if (script == 'latn') {
        return { liga: false };
    }

    // Info - https://helpx.adobe.com/in/fonts/using/open-type-syntax.html
    var disabledFeatures = ['aalt', 'smcp', 'dlig', 'c2sc', 'swsh', 'salt', 'lnum', 'ordn', 'sinf', 'frac', 'sups', 'subs'];
    var stylingSetsRegex = /ss[0-2][0-9]/; // Ignore all styling sets - ss01, ss02,..., ss20

    return font.getAvailableFeatures(script, 'default').filter(function (f) {
        return !(disabledFeatures.includes(f) || f.match(stylingSetsRegex));
    });
};

var getFontBaselineCorrection = function getFontBaselineCorrection(fontKey) {
    if (_FontManager2.default.isLoaded(fontKey)) {
        return _FontManager2.default.getFontBaselineCorrection(fontKey);
    }
    return _FontManager2.default.getFontBaselineCorrection(_FontManager2.default.getFontDefaultKey());
};

var shouldUseOpentype = function shouldUseOpentype(fontKey) {
    if (_FontManager2.default.isLoaded(fontKey)) {
        return _FontManager2.default.shouldUseOpentype(fontKey);
    }
    return _FontManager2.default.shouldUseOpentype(_FontManager2.default.getFontDefaultKey());
};

var isFontAvailable = function isFontAvailable(fontKey) {
    return _FontManager2.default.isLoaded(fontKey);
};

var getDefaultFontKey = function getDefaultFontKey() {
    return _FontManager2.default.getFontDefaultKey();
};

var getFontDirection = function getFontDirection(fontKey) {
    return _FontManager2.default.getFontDirection(fontKey);
};

var getFontScript = function getFontScript(fontKey) {
    return _FontManager2.default.getFontScript(fontKey);
};

var isCustomFont = function isCustomFont(fontKey) {
    return _FontManager2.default.isCustomFont(fontKey);
};

var fontCache = [];

var TextLayerInfo = function () {
    function TextLayerInfo() {
        _classCallCheck(this, TextLayerInfo);

        this.attrs = null;

        this.textLayerLines = [];
        this.highlightBlocks = [];

        this.totalHeight = 0;
        this.totalWidth = 0;

        this.wasFontLoaded = false;
        this.lastUsedFont = null;
        this.lastUsedFontFamily = null;

        this.fontDirection = 'ltr';
    }

    _createClass(TextLayerInfo, [{
        key: 'update',
        value: function update(_ref) {
            var fontFamily = _ref.fontFamily,
                fontSize = _ref.fontSize,
                lineSpacing = _ref.lineSpacing,
                maxWidth = _ref.maxWidth,
                maxHeight = _ref.maxHeight,
                align = _ref.align,
                maxLines = _ref.maxLines,
                text = _ref.text,
                lineHeightFactor = _ref.lineHeightFactor,
                layoutAlgo = _ref.layoutAlgo,
                letterSpacingFactor = _ref.letterSpacingFactor,
                _ref$highlightEnabled = _ref.highlightEnabled,
                highlightEnabled = _ref$highlightEnabled === undefined ? false : _ref$highlightEnabled,
                highlightColor = _ref.highlightColor,
                highlightTextColor = _ref.highlightTextColor,
                _ref$isCounterLayer = _ref.isCounterLayer,
                isCounterLayer = _ref$isCounterLayer === undefined ? false : _ref$isCounterLayer,
                _ref$isAscendingTimer = _ref.isAscendingTimer,
                isAscendingTimer = _ref$isAscendingTimer === undefined ? false : _ref$isAscendingTimer,
                templateType = _ref.templateType,
                _ref$timeFormat = _ref.timeFormat,
                timeFormat = _ref$timeFormat === undefined ? _CounterTimeFormatType2.default.SECS : _ref$timeFormat,
                _ref$lowerCalorieLimi = _ref.lowerCalorieLimit,
                lowerCalorieLimit = _ref$lowerCalorieLimi === undefined ? 0 : _ref$lowerCalorieLimi,
                _ref$lowerCalorieOffs = _ref.lowerCalorieOffset,
                lowerCalorieOffset = _ref$lowerCalorieOffs === undefined ? 0 : _ref$lowerCalorieOffs,
                _ref$higherCalorieLim = _ref.higherCalorieLimit,
                higherCalorieLimit = _ref$higherCalorieLim === undefined ? 0 : _ref$higherCalorieLim,
                _ref$higherCalorieOff = _ref.higherCalorieOffset,
                higherCalorieOffset = _ref$higherCalorieOff === undefined ? 0 : _ref$higherCalorieOff;
            var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var hasAttrsChanged = false;
            if (this.attrs === null || forceUpdate) {
                hasAttrsChanged = true;
            } else if (fontFamily !== this.attrs.fontFamily || fontSize !== this.attrs.fontSize || lineSpacing !== this.attrs.lineSpacing || maxWidth !== this.attrs.maxWidth || align !== this.attrs.align || maxLines !== this.attrs.maxLines || text !== this.attrs.text || lineHeightFactor !== this.attrs.lineHeightFactor || layoutAlgo !== this.attrs.layoutAlgo || maxHeight !== this.attrs.maxHeight || letterSpacingFactor !== this.attrs.letterSpacingFactor || isAscendingTimer !== this.attrs.isAscendingTimer || timeFormat !== this.attrs.timeFormat || higherCalorieOffset !== this.attrs.higherCalorieOffset || higherCalorieLimit !== this.attrs.higherCalorieLimit || lowerCalorieOffset !== this.attrs.lowerCalorieOffset || lowerCalorieLimit !== this.attrs.lowerCalorieLimit) {
                hasAttrsChanged = true;
            } else if (highlightEnabled !== this.attrs.highlightEnabled && (highlightColor !== this.attrs.highlightColor || highlightTextColor !== this.attrs.highlightTextColor)) {
                hasAttrsChanged = true;
            }

            var isFontLoaded = isFontAvailable(fontFamily);
            var font = getFont(fontFamily);
            var baselineCorrection = getFontBaselineCorrection(fontFamily);

            var wasLastFontDirectionEqual = !!this.lastUsedFontFamily && getFontDirection(fontFamily) === getFontDirection(this.lastUsedFontFamily);

            var currentFontFamily = isFontLoaded ? fontFamily : wasLastFontDirectionEqual ? this.lastUsedFontFamily : getDefaultFontKey();

            var currentFontDirection = getFontDirection(currentFontFamily);
            var currentFontScript = getFontScript(currentFontFamily);
            var useOpentype = shouldUseOpentype(currentFontFamily);

            if (hasAttrsChanged || !this.wasFontLoaded && isFontLoaded) {
                this.attrs = {
                    fontFamily: fontFamily,
                    fontSize: fontSize,
                    lineSpacing: lineSpacing,
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    align: align,
                    maxLines: maxLines,
                    text: text,
                    lineHeightFactor: lineHeightFactor,
                    layoutAlgo: layoutAlgo,
                    letterSpacingFactor: letterSpacingFactor,
                    fontDirection: currentFontDirection,
                    fontScript: currentFontScript,
                    highlightEnabled: highlightEnabled,
                    highlightColor: highlightColor,
                    highlightTextColor: highlightTextColor,
                    isCounterLayer: isCounterLayer,
                    isAscendingTimer: isAscendingTimer,
                    templateType: templateType,
                    timeFormat: timeFormat,
                    lowerCalorieLimit: lowerCalorieLimit,
                    lowerCalorieOffset: lowerCalorieOffset,
                    higherCalorieLimit: higherCalorieLimit,
                    higherCalorieOffset: higherCalorieOffset
                };

                font = isFontLoaded || !wasLastFontDirectionEqual ? font : this.lastUsedFont || font;

                this._recalculateLayout(font, baselineCorrection, currentFontFamily, useOpentype);
            }

            this.lastUsedFont = font;
            this.lastUsedFontFamily = currentFontFamily;
            this.wasFontLoaded = isFontLoaded;
            this.fontDirection = currentFontDirection;
        }
    }, {
        key: 'isFontRTL',
        value: function isFontRTL() {
            var _attrs$fontDirection = this.attrs.fontDirection,
                fontDirection = _attrs$fontDirection === undefined ? 'ltr' : _attrs$fontDirection;

            return fontDirection === 'rtl';
        }
    }, {
        key: 'isCalorieMeterTemplate',
        value: function isCalorieMeterTemplate(templateType) {
            return templateType === _OverlayUtils.TemplateType['calorie-meter'];
        }
    }, {
        key: 'getPositionForCoords',
        value: function getPositionForCoords(coordX, coordY) {
            // For x, y relative to the origin,
            // what would be the closest point (in terms of lineIndex and charIndex) where a cursor could be displayed

            var lineIndex = -1; // The index of the line
            var charIndex = -1; // The index of char just after (starts from 0)
            var x = -1;
            var y = -1;
            var lineHeight = -1;

            var attrs = this.attrs,
                textLayerLines = this.textLayerLines;
            var maxLines = attrs.maxLines,
                lineSpacing = attrs.lineSpacing;

            // The max number of lines we're concerned with

            var numLines = Math.min(textLayerLines.length, maxLines);

            for (var i = 0; i < numLines; i++) {
                var lh = textLayerLines[i].lineHeight;

                var effHeight = lh + lineSpacing;
                var lineLowerBoundY = y;
                var lineHigherBoundY = y + effHeight;

                // Check if the y coordinate is within these bounds
                if (coordY >= lineLowerBoundY && coordY <= lineHigherBoundY) {
                    // Note the line index and the height of this line
                    lineIndex = i;
                    lineHeight = lh;
                    break;
                }

                y += effHeight;
            }
            if (lineIndex === -1) {
                // Couldn't find a line that matched, let's assume the last line
                lineIndex = numLines - 1;
                lineHeight = textLayerLines[lineIndex].lineHeight;
            }

            var textLine = textLayerLines[lineIndex];
            var chars = textLine.chars,
                lineHorizOffset = textLine.lineHorizOffset;
            var _attrs$fontDirection2 = this.attrs.fontDirection,
                fontDirection = _attrs$fontDirection2 === undefined ? 'ltr' : _attrs$fontDirection2;

            var numChars = chars.length;

            var prevWidth = lineHorizOffset;
            for (var _i = 0; _i < numChars; _i++) {
                var glyphLowerBoundX = prevWidth;
                var glyphUpperBoundX = lineHorizOffset + chars[_i].lwic;

                if (coordX <= (glyphLowerBoundX + glyphUpperBoundX) / 2) {
                    charIndex = _i;
                    x = glyphLowerBoundX;
                    break;
                }

                prevWidth = glyphUpperBoundX;
            }

            if (charIndex == -1) {
                x = prevWidth;
                charIndex = numChars;
            }

            if (fontDirection === 'rtl') {
                charIndex = numChars - charIndex;
            }

            return { lineIndex: lineIndex, charIndex: charIndex, x: x, y: y, lineHeight: lineHeight };
        }
    }, {
        key: 'getPositionForTextIndex',
        value: function getPositionForTextIndex(textIndex) {
            var attrs = this.attrs,
                textLayerLines = this.textLayerLines;
            var lineSpacing = attrs.lineSpacing,
                _attrs$fontDirection3 = attrs.fontDirection,
                fontDirection = _attrs$fontDirection3 === undefined ? 'ltr' : _attrs$fontDirection3;

            var x = -1;
            var y = -1;
            var lineHeight = -1;
            var lineIndex = -1;
            var charIndex = -1;

            var found = false;
            for (var i = 0; i < textLayerLines.length; i++) {
                var interCharPositions = textLayerLines[i].interCharPositions;
                var _textLayerLines$i = textLayerLines[i],
                    lh = _textLayerLines$i.lineHeight,
                    lineHorizOffset = _textLayerLines$i.lineHorizOffset;

                var effHeight = lh + lineSpacing;

                for (var j = 0; j < interCharPositions.length; j++) {
                    var charPos = interCharPositions[j];
                    if (charPos >= textIndex) {
                        found = true;
                        // i, j is where we should get the positions

                        lineHeight = lh;
                        if (fontDirection == 'rtl') {
                            var _charIndex = interCharPositions.length - j;
                            x = lineHorizOffset + (_charIndex === 0 || _charIndex === 1 ? 0 : textLayerLines[i].chars[_charIndex - 2].lwic);
                        } else {
                            x = lineHorizOffset + (j === 0 ? 0 : textLayerLines[i].chars[j - 1].lwic);
                        }
                        lineIndex = i;
                        charIndex = j;
                    }
                    if (found) {
                        break;
                    }
                }
                if (found) {
                    break;
                }

                y += effHeight;
            }

            return { lineIndex: lineIndex, charIndex: charIndex, x: x, y: y, lineHeight: lineHeight };
        }
    }, {
        key: 'getSelectionInfoForRange',
        value: function getSelectionInfoForRange(startIndex, endIndex) {
            if (startIndex === endIndex) {
                return [];
            }
            // console.log('Selection info for range', startIndex, endIndex);
            var attrs = this.attrs,
                textLayerLines = this.textLayerLines;
            var text = attrs.text,
                lineSpacing = attrs.lineSpacing,
                _attrs$fontDirection4 = attrs.fontDirection,
                fontDirection = _attrs$fontDirection4 === undefined ? 'ltr' : _attrs$fontDirection4;

            var isSelectAll = text.length === endIndex - startIndex;

            var selectionInfoList = [];

            var y = 0;
            for (var i = 0; i < textLayerLines.length; i++) {
                var _textLayerLines$i2 = textLayerLines[i],
                    lh = _textLayerLines$i2.lineHeight,
                    interCharPositions = _textLayerLines$i2.interCharPositions,
                    chars = _textLayerLines$i2.chars,
                    lineHorizOffset = _textLayerLines$i2.lineHorizOffset;

                var effHeight = lh + lineSpacing;

                var lineFirstTextIndex = interCharPositions[0];
                var lineLastTextIndex = interCharPositions[interCharPositions.length - 1];

                var isLineWithinRange = lineLastTextIndex >= startIndex && lineFirstTextIndex <= endIndex;

                if (isLineWithinRange) {
                    var isLineWithStartIndex = lineFirstTextIndex <= startIndex && lineLastTextIndex >= startIndex;
                    var isLineWithEndIndex = lineFirstTextIndex <= endIndex && lineLastTextIndex >= endIndex;

                    var x = lineHorizOffset;
                    var lastX = lineHorizOffset + (chars.length === 0 ? 0 : chars[chars.length - 1].lwic);

                    if (!isSelectAll && fontDirection == 'rtl') {
                        x = lineHorizOffset + (chars.length === 0 ? 0 : chars[chars.length - 1].lwic);
                        lastX = lineHorizOffset;
                    }

                    if (isLineWithStartIndex) {
                        for (var j = 0; j < interCharPositions.length; j++) {
                            var posTextIndex = interCharPositions[j];
                            if (posTextIndex >= startIndex) {
                                if (!isSelectAll && fontDirection == 'rtl') {
                                    var charIndex = interCharPositions.length - j;
                                    x = lineHorizOffset + (charIndex === 0 || charIndex === 1 ? 0 : chars[charIndex - 2].lwic);
                                } else {
                                    x = lineHorizOffset + (j === 0 ? 0 : chars[j - 1].lwic);
                                }
                                break;
                            }
                        }
                    }
                    if (isLineWithEndIndex) {
                        for (var _j = 0; _j < interCharPositions.length; _j++) {
                            var _posTextIndex = interCharPositions[_j];
                            if (_posTextIndex >= endIndex) {
                                if (!isSelectAll && fontDirection == 'rtl') {
                                    var _charIndex2 = interCharPositions.length - _j;
                                    lastX = lineHorizOffset + (_charIndex2 === 0 || _charIndex2 === 1 ? 0 : chars[_charIndex2 - 2].lwic);
                                } else {
                                    lastX = lineHorizOffset + (_j === 0 ? 0 : chars[_j - 1].lwic);
                                }
                                break;
                            }
                        }
                    }

                    if (!isSelectAll && fontDirection == 'rtl') {
                        var temp = x;
                        x = lastX;
                        lastX = temp;
                    }

                    selectionInfoList.push({
                        x: x,
                        y: y,
                        lineHeight: lh,
                        lineWidth: lastX - x
                    });
                }

                y += effHeight;
            }

            // console.log(selectionInfoList);

            return selectionInfoList;
        }
    }, {
        key: 'getWordIndicesAtIndex',
        value: function getWordIndicesAtIndex(lineIndex, charIndex) {
            var _textLayerLines$lineI = this.textLayerLines[lineIndex],
                chars = _textLayerLines$lineI.chars,
                interCharPositions = _textLayerLines$lineI.interCharPositions;

            // find space before word

            var wordstart = interCharPositions[0];
            var wordend = interCharPositions[interCharPositions.length - 1];

            for (var i = charIndex; i >= 0 && i < chars.length; i--) {
                if (chars[i].c === ' ' || chars[i].c === '\t') {
                    wordstart = interCharPositions[Math.min(i + 1, interCharPositions.length - 1)];
                    break;
                }
            }

            for (var _i2 = charIndex + 1; _i2 < chars.length; _i2++) {
                if (chars[_i2].c === ' ' || chars[_i2].c === '\t') {
                    wordend = interCharPositions[_i2];
                    break;
                }
            }

            return { wordstart: wordstart, wordend: wordend };
        }
    }, {
        key: 'getTextIndexForCharPosition',
        value: function getTextIndexForCharPosition(lineIndex, charIndex) {
            return this.textLayerLines[lineIndex].interCharPositions[charIndex];
        }
    }, {
        key: 'getTweenedCharacterDisplacement',
        value: function getTweenedCharacterDisplacement(c) {
            var useStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var xp_obj_key = useStatic ? 'xp_d_tweenObj' : 'xp_tweenObj';
            var yp_obj_key = useStatic ? 'yp_d_tweenObj' : 'yp_tweenObj';
            var alphap_obj_key = useStatic ? 'alphap_d_tweenObj' : 'alphap_tweenObj';

            var has_disp = !!c[xp_obj_key] || !!c[yp_obj_key] || !!c[alphap_obj_key];

            return {
                disp_xp: c[xp_obj_key] ? c[xp_obj_key].value : 0,
                disp_yp: c[yp_obj_key] ? c[yp_obj_key].value : 0,
                disp_alphap: c[alphap_obj_key] ? c[alphap_obj_key].value : 1,
                has_disp: has_disp
            };
        }
    }, {
        key: 'getHasCharacterDisplacement',
        value: function getHasCharacterDisplacement() {
            var lineWithChars = this.textLayerLines.find(function (l) {
                return l.chars.length > 0;
            });
            if (!lineWithChars) {
                return false;
            }
            return this.getTweenedCharacterDisplacement(lineWithChars.chars[0]).has_disp;
        }
    }, {
        key: 'getTweenedLineDisplacement',
        value: function getTweenedLineDisplacement(l) {
            var useStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var yp_obj_key = useStatic ? 'yp_d_tweenObj' : 'yp_tweenObj';

            var has_disp = !!l[yp_obj_key];

            return {
                disp_yp: l[yp_obj_key] ? l[yp_obj_key].value : 0,
                has_disp: has_disp
            };
        }
    }, {
        key: 'getHasLineDisplacement',
        value: function getHasLineDisplacement() {
            if (!this.textLayerLines.length) {
                return false;
            }
            return this.getTweenedLineDisplacement(this.textLayerLines[0]).has_disp;
        }
    }, {
        key: 'getTweenedHighlightBoxes',
        value: function getTweenedHighlightBoxes() {
            var useStatic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var x_obj_key = useStatic ? 'x_d_tweenObj' : 'x_tweenObj';
            var y_obj_key = useStatic ? 'y_d_tweenObj' : 'y_tweenObj';
            var width_obj_key = useStatic ? 'width_d_tweenObj' : 'width_tweenObj';
            var height_obj_key = useStatic ? 'height_d_tweenObj' : 'height_tweenObj';

            var thbs = this.highlightBlocks.map(function (hb) {
                return _extends({}, hb, {
                    x: hb[x_obj_key] ? hb[x_obj_key].value : hb.x,
                    y: hb[y_obj_key] ? hb[y_obj_key].value : hb.y,
                    width: hb[width_obj_key] ? hb[width_obj_key].value : hb.width,
                    height: hb[height_obj_key] ? hb[height_obj_key].value : hb.height
                });
            });
            return thbs;
        }
    }, {
        key: '_calcHighlightBlocks',
        value: function _calcHighlightBlocks() {
            var _this = this;

            var _attrs = this.attrs,
                highlightEnabled = _attrs.highlightEnabled,
                highlightColorRange = _attrs.highlightColor,
                text = _attrs.text,
                _attrs$fontDirection5 = _attrs.fontDirection,
                fontDirection = _attrs$fontDirection5 === undefined ? 'ltr' : _attrs$fontDirection5;

            if (!highlightEnabled) {
                return;
            }

            var blocks = [];

            highlightColorRange.forEachRange(function (start, end, color) {
                var _getLineForCharIndex2 = _this._getLineForCharIndex(start === -1 ? 0 : start),
                    startLineIndex = _getLineForCharIndex2.lineIndex,
                    startLineCharIndex = _getLineForCharIndex2.lineCharIndex;

                var _getLineForCharIndex3 = _this._getLineForCharIndex(end === -1 ? text.length - 1 : end),
                    endLineIndex = _getLineForCharIndex3.lineIndex,
                    endLineCharIndex = _getLineForCharIndex3.lineCharIndex;

                for (var i = startLineIndex; i <= endLineIndex; i++) {
                    var line = _this.textLayerLines[i];

                    var blockStartCharIndex = void 0;
                    var blockEndCharIndex = void 0;

                    if (fontDirection == 'rtl') {
                        blockStartCharIndex = i === endLineIndex ? Math.max(endLineCharIndex, 0) : 0;
                        blockEndCharIndex = i === startLineIndex ? startLineCharIndex : line.chars.length - 1;
                    } else {
                        blockStartCharIndex = i === startLineIndex ? startLineCharIndex : 0;
                        blockEndCharIndex = i === endLineIndex ? Math.min(endLineCharIndex, line.chars.length - 1) : line.chars.length - 1;
                    }
                    var startChar = line.chars[blockStartCharIndex];
                    var endChar = line.chars[blockEndCharIndex];

                    if (startChar && endChar) {
                        blocks.push({
                            color: color,
                            x: startChar.x - 10,
                            width: endChar.lwic - startChar.x + 20,
                            y: startChar.y - line.lineBaseline,
                            height: line.lineHeight,
                            lineIndex: i
                        });
                    }
                }
            });

            this.highlightBlocks = blocks;
        }
    }, {
        key: 'updateTimeValues',
        value: function updateTimeValues(time) {
            var _ref2 = this.time || {},
                _ref2$enterstart = _ref2.enterstart,
                prevEnterStart = _ref2$enterstart === undefined ? 0 : _ref2$enterstart,
                _ref2$exitdone = _ref2.exitdone,
                prevExitDone = _ref2$exitdone === undefined ? 0 : _ref2$exitdone;

            var _ref3 = time || {},
                _ref3$enterstart = _ref3.enterstart,
                newEnterStart = _ref3$enterstart === undefined ? 0 : _ref3$enterstart,
                _ref3$exitdone = _ref3.exitdone,
                newExitDone = _ref3$exitdone === undefined ? 0 : _ref3$exitdone;

            var oldDuration = prevExitDone - prevEnterStart;
            var newDuration = newExitDone - newEnterStart;

            this.time = time;

            var shouldUpdate = oldDuration !== newDuration;
            if (shouldUpdate) {
                this.update(this.attrs, true);
            }
        }
    }, {
        key: 'getCounterDuration',
        value: function getCounterDuration(timeFormat) {
            if (!this || !this.attrs) {
                return '';
            }

            var _attrs2 = this.attrs,
                _attrs2$isCounterLaye = _attrs2.isCounterLayer,
                isCounterLayer = _attrs2$isCounterLaye === undefined ? false : _attrs2$isCounterLaye,
                _attrs2$isAscendingTi = _attrs2.isAscendingTimer,
                isAscendingTimer = _attrs2$isAscendingTi === undefined ? false : _attrs2$isAscendingTi,
                time = this.time;

            if (!isCounterLayer || !time) {
                return '';
            }

            timeFormat = timeFormat || this.attrs.timeFormat || _CounterTimeFormatType2.default.SECS;
            var maxTime = time.exitdone - time.enterstart;

            if (isAscendingTimer) {
                // Static text for ascending timers
                return this._timeToCounterText(0, maxTime, timeFormat);
            }

            return this._timeToCounterText(maxTime, maxTime, timeFormat);
        }

        /**
         * If ascending timer:
         * 1. return 0 if timeInMs < 200 ms
         * 2. return ceil value otherwise.
         *
         * If descending timer:
         * 1. Return ceil value if maxTimeInMs - timeInMs <= 200ms
         * 2. Return floor value otherwise.
         *
         * The motivation is to always display the 0th and maxTime sec but
         * the duration of these values will depend on the type of timer.
         * The last sec value (maxTime incase of ascending and 0th in case of descending)
         * duration should always be of 1 sec.
         *
         * @param {number} timeInMs
         * @param {number} maxTimeInMs
         * @returns {string} returns time in `secs` or `mm:ss` format depending on the format choosen.
         * @memberof TextLayerInfo
         */

    }, {
        key: '_timeToCounterText',
        value: function _timeToCounterText(timeInMs, maxTimeInMs, timeFormat) {
            var _attrs3 = this.attrs,
                isAscendingTimer = _attrs3.isAscendingTimer,
                templateType = _attrs3.templateType;

            return this.isCalorieMeterTemplate(templateType) ? this._timeToCalorieMeterText(timeInMs) : (0, _OverlayUtils.getDurationStringForFormat)(timeInMs, maxTimeInMs, timeFormat || this.attrs.timeFormat, isAscendingTimer);
        }
    }, {
        key: '_timeToCalorieMeterText',
        value: function _timeToCalorieMeterText(currentTimeInMs) {
            if (!this.attrs.isCounterLayer || !this.time) {
                return '';
            }

            var _attrs4 = this.attrs,
                lowerCalorieLimit = _attrs4.lowerCalorieLimit,
                lowerCalorieOffset = _attrs4.lowerCalorieOffset,
                higherCalorieLimit = _attrs4.higherCalorieLimit,
                higherCalorieOffset = _attrs4.higherCalorieOffset,
                templateType = _attrs4.templateType,
                _time = this.time,
                exitdone = _time.exitdone,
                enterstart = _time.enterstart;

            if (!this.isCalorieMeterTemplate(templateType)) {
                return '000 - 000';
            }

            var overlayTimeInMs = exitdone - enterstart;

            if (!currentTimeInMs && currentTimeInMs !== 0) {
                currentTimeInMs = overlayTimeInMs;
            }

            var currentTimeFraction = currentTimeInMs / overlayTimeInMs;

            var lowerValue = Math.ceil(Math.round(lowerCalorieOffset + lowerCalorieLimit * currentTimeFraction));

            var higherValue = Math.ceil(Math.round(higherCalorieOffset + higherCalorieLimit * currentTimeFraction));

            var lowerValueStr = '' + lowerValue;
            var higherValueStr = '' + higherValue;

            if (lowerValue < 10) {
                lowerValueStr = '00' + lowerValue;
            } else if (lowerValue < 100) {
                lowerValueStr = '0' + lowerValue;
            } else if (lowerValue < 1000) {
                lowerValueStr = '' + lowerValue;
            }

            if (higherValue < 10) {
                higherValueStr = '00' + higherValue;
            } else if (higherValue < 100) {
                higherValueStr = '0' + higherValue;
            } else if (higherValue < 1000) {
                higherValueStr = '' + higherValue;
            }

            return lowerValueStr + ' - ' + higherValueStr;
        }
    }, {
        key: 'updateCurrentTime',
        value: function updateCurrentTime() {
            var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.attrs.isCounterLayer || !this.time) {
                return '';
            }

            var _time2 = this.time,
                enterstart = _time2.enterstart,
                exitdone = _time2.exitdone;

            if (currentTime !== this.currentTime) {
                if (currentTime >= enterstart && currentTime <= exitdone) {
                    var timeElapsed = currentTime - enterstart;
                    var timeLeft = exitdone - currentTime;
                    var maxTime = exitdone - enterstart;

                    var _attrs$isAscendingTim = this.attrs.isAscendingTimer,
                        isAscendingTimer = _attrs$isAscendingTim === undefined ? false : _attrs$isAscendingTim;

                    var counter = isAscendingTimer ? timeElapsed : timeLeft;

                    var counterText = this._timeToCounterText(counter, maxTime);
                    var shouldUpdate = this.attrs.text !== counterText;

                    if (shouldUpdate) {
                        this.attrs.text = '' + counterText;
                        this.update(this.attrs, true);
                    }
                    this.currentTime = currentTime;
                    return counterText;
                }
            }
            return this.getCounterDuration();
        }
    }, {
        key: '_getLineForCharIndex',
        value: function _getLineForCharIndex(charIndex) {
            var textLayerLines = this.textLayerLines,
                _fontDirection = this.fontDirection,
                fontDirection = _fontDirection === undefined ? 'ltr' : _fontDirection;

            var count = 0;
            for (var i = 0; i < textLayerLines.length; i++) {
                var _textLayerLines$i3 = textLayerLines[i],
                    chars = _textLayerLines$i3.chars,
                    autoWrapsAtEnd = _textLayerLines$i3.autoWrapsAtEnd;

                var hasNewLine = !autoWrapsAtEnd;

                var lineIndex = i;
                var lineCharIndex = void 0;
                if (fontDirection == 'rtl') {
                    lineCharIndex = chars.length - (charIndex - count) - 1;
                } else {
                    lineCharIndex = charIndex - count;
                }

                if (charIndex >= count && charIndex < chars.length + count) {
                    return { lineIndex: lineIndex, lineCharIndex: lineCharIndex };
                }

                if (hasNewLine) {
                    if (charIndex === chars.length + count) {
                        return { lineIndex: lineIndex, lineCharIndex: lineCharIndex };
                    }
                }
                count += chars.length + (hasNewLine ? 1 : 0);
            }
            throw new Error('No char at ' + charIndex);
        }
    }, {
        key: '_recalculateLayout',
        value: function _recalculateLayout(font, baselineCorrection, currentFontFamily) {
            var useOpentype = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            // Clear everything before
            this.textLayerLines = [];

            this.totalHeight = 0;
            this.totalWidth = 0;

            this.updateCurrentTime(this.currentTime);

            var _attrs5 = this.attrs,
                fontSize = _attrs5.fontSize,
                lineSpacing = _attrs5.lineSpacing,
                maxWidth = _attrs5.maxWidth,
                maxHeight = _attrs5.maxHeight,
                align = _attrs5.align,
                maxLines = _attrs5.maxLines,
                text = _attrs5.text,
                lineHeightFactor = _attrs5.lineHeightFactor,
                layoutAlgo = _attrs5.layoutAlgo,
                letterSpacingFactor = _attrs5.letterSpacingFactor,
                fontScript = _attrs5.fontScript,
                fontDirection = _attrs5.fontDirection,
                isCounterLayer = _attrs5.isCounterLayer;

            var tlLines = null;

            // const useOpentype = !isCustomFont(currentFontFamily)

            if (isCounterLayer) {
                tlLines = wrapTextForMaxHeight(font, baselineCorrection, currentFontFamily, fontSize, lineSpacing, maxWidth, fontSize, align, text, { lineHeightFactor: lineHeightFactor, layoutAlgo: layoutAlgo, letterSpacingFactor: letterSpacingFactor }, fontScript, fontDirection, useOpentype);
            } else if (maxHeight !== -1) {
                tlLines = wrapTextForMaxHeight(font, baselineCorrection, currentFontFamily, fontSize, lineSpacing, maxWidth, maxHeight, align, text, { lineHeightFactor: lineHeightFactor, layoutAlgo: layoutAlgo, letterSpacingFactor: letterSpacingFactor }, fontScript, fontDirection, useOpentype);
            } else {
                tlLines = wrapText(font, baselineCorrection, currentFontFamily, fontSize, maxWidth, align, text, { lineHeightFactor: lineHeightFactor, layoutAlgo: layoutAlgo, letterSpacingFactor: letterSpacingFactor }, fontScript, fontDirection, useOpentype);
            }

            this.textLayerLines = tlLines;

            var numLines = Math.min(this.textLayerLines.length, maxLines);

            this.totalHeight = this.textLayerLines.slice(0, numLines).reduce(function (p, c) {
                return p + c.lineHeight;
            }, 0) + (numLines - 1) * lineSpacing;

            this.totalWidth = this.textLayerLines.slice(0, numLines).reduce(function (p, c) {
                return Math.max(p, c.lineWidth);
            }, 0);

            this._calcHighlightBlocks();
        }
    }]);

    return TextLayerInfo;
}();

var TextLayerChar = function TextLayerChar(c, g, lwic, charPath2D) {
    var x = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var y = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

    _classCallCheck(this, TextLayerChar);

    this.c = c; // The character
    this.g = g; // The glyph corresponding to this character
    this.lwic = lwic; // 'Line width including char' - The x position of the line after including the char in the line

    this.charPath2D = charPath2D;
    this.x = x;
    this.y = y;
    // if(charPath2D){
    //     this.path2D = new Path2D(charPath2D.toPathData())
    // }
};

var TextLayerLine = function () {
    function TextLayerLine() {
        _classCallCheck(this, TextLayerLine);

        this.lineHeight = 0;
        this.linePath2D = null;
        this.lineBaseline = 0;
        this.lineBaselineOffset = 0;
        this.lineWidth = 0;
        this.lineHorizOffset = 0;

        this.chars = [];

        this.interCharPositions = [];

        this.autoWrapsAtEnd = false;
    }

    _createClass(TextLayerLine, [{
        key: 'appendChar',
        value: function appendChar(tlChar) {
            this.chars.push(tlChar);
        }
    }, {
        key: 'addInterCharPosition',
        value: function addInterCharPosition(index) {
            this.interCharPositions.push(index);
        }
    }]);

    return TextLayerLine;
}();

var getCharPath = function getCharPath(glyph, fontFamily, char, fontSize) {
    var cacheKey = fontFamily + '_' + fontSize;
    var fontInCache = fontCache[cacheKey];

    if (fontInCache) {
        var _path = fontInCache[char];
        if (_path) {
            return _path;
        }
    } else {
        fontCache[cacheKey] = [];
    }
    // Get path from glyph
    var path = glyph.getPath(0, 0, fontSize);
    // Add path to cache
    fontCache[cacheKey][char] = path;

    return path;
};

var splitTextIntoLines = function splitTextIntoLines(text, maxWidth, letterSpacingFactor, font, fontScale, fontScript, fontDirection) {
    var allLines = [];

    var lines = text.split('\n');

    var fontFeatures = getFontFeaturesFromScript(font, fontScript);
    // split lines further to fit in the given width
    lines.forEach(function (line) {
        var currentLine = line;
        var maxLength = line.length;

        var currentLineGlyphRun = font.layout(currentLine, fontFeatures, fontScript, 'default', fontDirection);
        var currentLineWidth = (currentLineGlyphRun.advanceWidth + letterSpacingFactor * maxLength) * fontScale;

        if (currentLineWidth > maxWidth) {
            maxLength = Math.ceil(maxWidth / currentLineWidth * maxLength) + 1;
        }

        while (currentLineWidth > maxWidth && maxLength > 1) {
            maxLength -= 1;
            currentLine = line.substring(0, maxLength);
            currentLineGlyphRun = font.layout(currentLine, fontFeatures, fontScript, 'default', fontDirection);
            currentLineWidth = (currentLineGlyphRun.advanceWidth + letterSpacingFactor * maxLength) * fontScale;
        }

        if (maxLength < line.length) {
            if (line[maxLength] != ' ' || line[maxLength - 1] != ' ') {
                var lastSpaceIndex = line.substring(0, maxLength).lastIndexOf(' ');
                if (lastSpaceIndex > 0) {
                    maxLength = line.substring(0, maxLength).lastIndexOf(' ') + 1;
                    currentLine = line.substring(0, maxLength);
                }
            }

            allLines.push({
                textLine: currentLine,
                glyphRun: currentLineGlyphRun,
                autoWrapsAtEnd: true
            });

            var remainingText = line.substring(maxLength, line.length);
            var remainingLines = splitTextIntoLines(remainingText, maxWidth, letterSpacingFactor, font, fontScale, fontScript, fontDirection);

            Array.prototype.push.apply(allLines, remainingLines);
        } else {
            allLines.push({
                textLine: currentLine,
                glyphRun: currentLineGlyphRun,
                autoWrapsAtEnd: false
            });
        }
    });

    return allLines;
};

var wrapTextUsingFontKit = function wrapTextUsingFontKit(font, baselineCorrection, fontFamily, fontSize, maxWidth, align, text) {
    var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
    var fontScript = arguments[8];
    var fontDirection = arguments[9];
    var _options$layoutAlgo = options.layoutAlgo,
        layoutAlgo = _options$layoutAlgo === undefined ? 'fixed' : _options$layoutAlgo,
        _options$lineHeightFa = options.lineHeightFactor,
        lineHeightFactor = _options$lineHeightFa === undefined ? null : _options$lineHeightFa,
        _options$letterSpacin = options.letterSpacingFactor,
        letterSpacingFactor = _options$letterSpacin === undefined ? null : _options$letterSpacin;

    var fontScale = 1 / font.unitsPerEm * fontSize;

    var defaultBaseline = (font.ascent + baselineCorrection) * fontScale;
    var defaultLineHeight = 0;
    var defaultLineBaselineOffset = 0;
    if (layoutAlgo === 'fit') {
        defaultLineHeight = defaultBaseline - font.descent * fontScale;
        defaultLineBaselineOffset = 0;
    } else if (layoutAlgo === 'fixed') {
        if (lineHeightFactor !== null) {
            var defaultHeight = defaultBaseline - font.descent * fontScale;
            defaultLineHeight = fontSize * lineHeightFactor;
            defaultLineBaselineOffset = -(defaultLineHeight - defaultHeight) / 2;
        } else {
            defaultLineHeight = defaultBaseline - font.descent * fontScale;
            defaultLineBaselineOffset = 0;
        }
    }

    var textLayerLines = [new TextLayerLine()];

    var currentLineIndex = 0;
    var currentLineWidth = 0;
    var currentLinePath = null;
    var currentLineCharIndex = 0;
    var currentLinePrevG = null;

    if (text.length === 0) {
        var currentTextLayerLine = textLayerLines[0];

        currentTextLayerLine.lineHeight = defaultLineHeight;
        currentTextLayerLine.lineBaseline = defaultBaseline;
        currentTextLayerLine.lineBaselineOffset = defaultLineBaselineOffset;
        currentTextLayerLine.lineWidth = 0;
        currentTextLayerLine.linePath2D = null;
        if (align === 'left') {
            currentTextLayerLine.lineHorizOffset = 0;
        } else if (align === 'center') {
            currentTextLayerLine.lineHorizOffset = maxWidth / 2;
        } else if (align === 'right') {
            currentTextLayerLine.lineHorizOffset = maxWidth;
        } else {
            currentTextLayerLine.lineHorizOffset = 0;
        }

        currentTextLayerLine.addInterCharPosition(0);

        return textLayerLines;
    }

    var charCount = 0;

    var lines = splitTextIntoLines(text, maxWidth, letterSpacingFactor, font, fontScale, fontScript, fontDirection);

    var fontFeatures = getFontFeaturesFromScript(font, fontScript);

    lines.forEach(function (line, lineIndex) {
        var textLine = line.textLine,
            _line$autoWrapsAtEnd = line.autoWrapsAtEnd,
            autoWrapsAtEnd = _line$autoWrapsAtEnd === undefined ? false : _line$autoWrapsAtEnd;

        var glyphRun = font.layout(textLine, fontFeatures, fontScript, 'default', fontDirection);

        var isLastLine = lineIndex === lines.length - 1;

        glyphRun.glyphs.forEach(function (glyph, charIndex) {
            var kernAmt = 0;
            var charWidth = 0;

            // First get the character width if we were to append to the current line
            charWidth = glyph.advanceWidth * fontScale;

            if (currentLineCharIndex > 0) {
                // TODO figure out kerning
                kernAmt = letterSpacingFactor * fontScale;
                // kernAmt = (font.getKerningValue(g, currentLinePrevG) + letterSpacingFactor) * fontScale
            }

            var char = textLine.charAt(charIndex);

            var p = glyph.getScaledPath(fontSize);

            var x = currentLineWidth + kernAmt;
            var y = defaultBaseline;

            currentLineCharIndex += 1;
            currentLinePrevG = glyph;
            currentLineWidth += charWidth + kernAmt;

            var currentTextLayerLine = textLayerLines[currentLineIndex];

            var tlChar = new TextLayerChar(char, glyph, currentLineWidth, p, x, y);
            currentTextLayerLine.appendChar(tlChar);
            currentTextLayerLine.addInterCharPosition(charCount);
            charCount++;
        });

        // for every new line
        var currentTextLayerLine = textLayerLines[currentLineIndex];
        var currentTextLayerLineWidth = currentLineWidth;

        currentTextLayerLine.addInterCharPosition(charCount);

        if (!autoWrapsAtEnd) {
            charCount++;
        } else {
            currentTextLayerLine.autoWrapsAtEnd = true;
        }

        var lineHeight = defaultLineHeight;
        var lineBaselineOffset = defaultLineBaselineOffset;
        var linePath = null;
        var linePath2D = null;
        if (currentLinePath !== null) {
            if (layoutAlgo === 'fit') {
                var bbox = currentLinePath.getBoundingBox();
                lineHeight = bbox.y2 - bbox.y1;
                lineBaselineOffset = bbox.y1;
            }
        }
        currentTextLayerLine.lineHeight = lineHeight;
        currentTextLayerLine.lineBaseline = defaultBaseline;
        currentTextLayerLine.lineBaselineOffset = lineBaselineOffset;
        currentTextLayerLine.lineWidth = currentTextLayerLineWidth;
        currentTextLayerLine.linePath2D = linePath2D;
        if (align === 'left') {
            currentTextLayerLine.lineHorizOffset = 0;
        } else if (align === 'center') {
            currentTextLayerLine.lineHorizOffset = (maxWidth - currentTextLayerLineWidth) / 2;
        } else if (align === 'right') {
            currentTextLayerLine.lineHorizOffset = maxWidth - currentTextLayerLineWidth;
        } else {
            currentTextLayerLine.lineHorizOffset = 0;
        }

        if (!isLastLine) {
            currentLineWidth = 0;
            currentLineIndex += 1;

            textLayerLines.push(new TextLayerLine());
        }
    });
    return textLayerLines;
};

var wrapTextUsingOpentype = function wrapTextUsingOpentype(font, baselineCorrection, fontFamily, fontSize, maxWidth, align, text) {
    var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
    var _options$layoutAlgo2 = options.layoutAlgo,
        layoutAlgo = _options$layoutAlgo2 === undefined ? 'fixed' : _options$layoutAlgo2,
        _options$lineHeightFa2 = options.lineHeightFactor,
        lineHeightFactor = _options$lineHeightFa2 === undefined ? null : _options$lineHeightFa2,
        _options$letterSpacin2 = options.letterSpacingFactor,
        letterSpacingFactor = _options$letterSpacin2 === undefined ? null : _options$letterSpacin2;

    var fontScale = 1 / font.unitsPerEm * fontSize;

    var defaultBaseline = (font.ascender + baselineCorrection) * fontScale;
    var defaultLineHeight = 0;
    var defaultLineBaselineOffset = 0;
    if (layoutAlgo === 'fit') {
        defaultLineHeight = defaultBaseline - font.descender * fontScale;
        defaultLineBaselineOffset = 0;
    } else if (layoutAlgo === 'fixed') {
        if (lineHeightFactor !== null) {
            var defaultHeight = defaultBaseline - font.descender * fontScale;
            defaultLineHeight = fontSize * lineHeightFactor;
            defaultLineBaselineOffset = -(defaultLineHeight - defaultHeight) / 2;
        } else {
            defaultLineHeight = defaultBaseline - font.descender * fontScale;
            defaultLineBaselineOffset = 0;
        }
    }

    var textLayerLines = [new TextLayerLine()];

    var currentLineIndex = 0;
    var currentLineWidth = 0;
    var currentLinePath = null;
    var currentLineCharIndex = 0;
    var currentLinePrevG = null;

    if (text.length === 0) {
        var currentTextLayerLine = textLayerLines[0];

        currentTextLayerLine.lineHeight = defaultLineHeight;
        currentTextLayerLine.lineBaseline = defaultBaseline;
        currentTextLayerLine.lineBaselineOffset = defaultLineBaselineOffset;
        currentTextLayerLine.lineWidth = 0;
        currentTextLayerLine.linePath2D = null;
        if (align === 'left') {
            currentTextLayerLine.lineHorizOffset = 0;
        } else if (align === 'center') {
            currentTextLayerLine.lineHorizOffset = maxWidth / 2;
        } else if (align === 'right') {
            currentTextLayerLine.lineHorizOffset = maxWidth;
        } else {
            currentTextLayerLine.lineHorizOffset = 0;
        }

        currentTextLayerLine.addInterCharPosition(0);

        return textLayerLines;
    }

    // Iterate through each character
    for (var i = 0; i < text.length; i += 1) {
        var c = text[i];

        var isNewLine = c === '\n';
        var kernAmt = 0;
        var charWidth = 0;
        var g = null;
        if (!isNewLine) {
            g = font.charToGlyph(c);

            // First get the character width if we were to append to the current line
            charWidth = g.advanceWidth * fontScale;
            if (currentLineCharIndex > 0) {
                kernAmt = (font.getKerningValue(g, currentLinePrevG) + letterSpacingFactor) * fontScale;
            }
        }

        // Based on the char width, will we exceed the maxWidth if we add it to this line?
        var canAddCharToLine = !isNewLine && currentLineWidth + kernAmt + charWidth <= maxWidth;

        var isLastChar = i === text.length - 1;

        if (canAddCharToLine) {
            // If yes, go ahead
            var p = getCharPath(g, fontFamily, c, fontSize);
            var x = currentLineWidth + kernAmt;
            var y = defaultBaseline;
            // let p = g.getPath(currentLineWidth + kernAmt, defaultBaseline, fontSize)
            // let pbbox = p.getBoundingBox()
            // if (pbbox.y2 - pbbox.y1 > 0) {
            //     if (currentLinePath == null) {
            //         currentLinePath = p
            //     } else {
            //         currentLinePath.extend(p)
            //     }
            // }

            currentLineCharIndex += 1;
            currentLinePrevG = g;
            currentLineWidth += charWidth + kernAmt;

            var _currentTextLayerLine = textLayerLines[currentLineIndex];

            var tlChar = new TextLayerChar(c, g, currentLineWidth, p, x, y);
            _currentTextLayerLine.appendChar(tlChar);
            _currentTextLayerLine.addInterCharPosition(i);
        } else {
            var _currentTextLayerLine2 = textLayerLines[currentLineIndex];
            var currentTextLayerLineWidth = currentLineWidth;

            _currentTextLayerLine2.addInterCharPosition(i);

            currentLineWidth = 0;
            currentLineIndex += 1;

            if (!isNewLine) {
                _currentTextLayerLine2.autoWrapsAtEnd = true;
            }

            textLayerLines.push(new TextLayerLine());

            var newTextLayerLine = textLayerLines[currentLineIndex];

            // If not, we gotta close out this line
            // and push the character onto the next line

            var lineHeight = defaultLineHeight;
            var lineBaselineOffset = defaultLineBaselineOffset;
            var linePath = null;
            var linePath2D = null;
            if (currentLinePath !== null) {
                if (layoutAlgo === 'fit') {
                    var bbox = currentLinePath.getBoundingBox();
                    lineHeight = bbox.y2 - bbox.y1;
                    lineBaselineOffset = bbox.y1;
                }
                // linePath = currentLinePath.toPathData()
                // linePath2D = new Path2D(linePath)
            }
            _currentTextLayerLine2.lineHeight = lineHeight;
            _currentTextLayerLine2.lineBaseline = defaultBaseline;
            _currentTextLayerLine2.lineBaselineOffset = lineBaselineOffset;
            _currentTextLayerLine2.lineWidth = currentTextLayerLineWidth;
            _currentTextLayerLine2.linePath2D = linePath2D;
            if (align === 'left') {
                _currentTextLayerLine2.lineHorizOffset = 0;
            } else if (align === 'center') {
                _currentTextLayerLine2.lineHorizOffset = (maxWidth - currentTextLayerLineWidth) / 2;
            } else if (align === 'right') {
                _currentTextLayerLine2.lineHorizOffset = maxWidth - currentTextLayerLineWidth;
            } else {
                _currentTextLayerLine2.lineHorizOffset = 0;
            }

            if (!isNewLine) {
                // let p = g.getPath(currentLineWidth, defaultBaseline, fontSize)
                var _p = getCharPath(g, fontFamily, c, fontSize);
                var _x11 = currentLineWidth;
                var _y = defaultBaseline;
                // let pbbox = p.getBoundingBox()
                // if (pbbox.y2 - pbbox.y1 > 0) {
                //     currentLinePath = p
                // } else {
                //     currentLinePath = null
                // }

                currentLineWidth = charWidth; // No kern
                currentLineCharIndex = 1;
                currentLinePrevG = g;

                var _tlChar = new TextLayerChar(c, g, currentLineWidth, _p, _x11, _y);
                newTextLayerLine.appendChar(_tlChar);
                newTextLayerLine.addInterCharPosition(i);
            } else {
                currentLineWidth = 0;
                currentLinePrevG = null;
                currentLineCharIndex = 0;
                currentLinePath = null;
            }
        }

        if (isLastChar) {
            // if this is the last char, we should close out the line
            var _lineHeight = defaultLineHeight;
            var _lineBaselineOffset = defaultLineBaselineOffset;
            var _linePath = null;
            var _linePath2D = null;
            if (currentLinePath !== null) {
                if (layoutAlgo === 'fit') {
                    var _bbox = currentLinePath.getBoundingBox();
                    _lineHeight = _bbox.y2 - _bbox.y1;
                    _lineBaselineOffset = _bbox.y1;
                }
                // linePath = currentLinePath.toPathData()
                // linePath2D = new Path2D(linePath)
            }

            var _currentTextLayerLine3 = textLayerLines[currentLineIndex];

            _currentTextLayerLine3.lineHeight = _lineHeight;
            _currentTextLayerLine3.lineBaseline = defaultBaseline;
            _currentTextLayerLine3.lineBaselineOffset = _lineBaselineOffset;
            _currentTextLayerLine3.lineWidth = currentLineWidth;
            _currentTextLayerLine3.linePath2D = _linePath2D;
            if (align === 'left') {
                _currentTextLayerLine3.lineHorizOffset = 0;
            } else if (align === 'center') {
                _currentTextLayerLine3.lineHorizOffset = (maxWidth - currentLineWidth) / 2;
            } else if (align === 'right') {
                _currentTextLayerLine3.lineHorizOffset = maxWidth - currentLineWidth;
            } else {
                _currentTextLayerLine3.lineHorizOffset = 0;
            }

            _currentTextLayerLine3.addInterCharPosition(i + 1);
        }
    }
    return textLayerLines;
};

var wrapText = function wrapText(font, baselineCorrection, fontFamily, fontSize, maxWidth, align, text) {
    var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
    var fontScript = arguments[8];
    var fontDirection = arguments[9];
    var useOpentype = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : true;

    if (useOpentype) {
        return wrapTextUsingOpentype(font, baselineCorrection, fontFamily, fontSize, maxWidth, align, text, options);
    }
    return wrapTextUsingFontKit(font, baselineCorrection, fontFamily, fontSize, maxWidth, align, text, options, fontScript, fontDirection);
};

var wrapTextForMaxHeight = function wrapTextForMaxHeight(font, baselineCorrection, fontFamily, fontSize, lineSpacing, maxWidth, maxHeight, align, text) {
    var options = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
    var fontScript = arguments[10];
    var fontDirection = arguments[11];
    var useOpentype = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : true;
    var _options$layoutAlgo3 = options.layoutAlgo,
        layoutAlgo = _options$layoutAlgo3 === undefined ? 'fixed' : _options$layoutAlgo3,
        _options$lineHeightFa3 = options.lineHeightFactor,
        lineHeightFactor = _options$lineHeightFa3 === undefined ? null : _options$lineHeightFa3;

    if (layoutAlgo !== 'fixed') {
        throw new Error('Only layout type fixed is supported for fit height mode');
    }

    var fontAscent = 0;
    var fontDescent = 0;
    if (useOpentype) {
        fontAscent = font.ascender;
        fontDescent = font.descender;
    } else {
        fontAscent = font.ascent;
        fontDescent = font.descent;
    }

    var fontLineHeightInEm = (fontAscent + baselineCorrection + fontDescent) / font.unitsPerEm;
    if (lineHeightFactor === -1) {
        lineHeightFactor = fontLineHeightInEm;
    }

    // First let's get and store info we need for layout calculation
    var charsLayoutInfo = [];

    var prevG = null;
    var fontFeatures = getFontFeaturesFromScript(font, fontScript);
    for (var i = 0; i < text.length; i += 1) {
        var c = text[i];

        var isNewLine = c === '\n';
        var g = null;
        if (!isNewLine) {
            if (useOpentype) {
                g = font.charToGlyph(c);
            } else {
                g = font.layout(c, fontFeatures, fontScript, 'default', fontDirection);
            }
        }

        var advanceWidth = g !== null ? g.advanceWidth : 0;

        var kernOffset = 0;
        if (useOpentype && prevG !== null && g !== null) {
            kernOffset = font.getKerningValue(g, prevG);
        }

        charsLayoutInfo.push({
            c: c,
            g: g,
            advanceWidth: advanceWidth,
            kernOffset: kernOffset
        });

        prevG = g;
    }

    var userTextLines = text.split('\n');
    var minLines = userTextLines.length;

    if (text.length === 0) {
        // Can do an early return. Won't be longer than a line
        var _currentFontSize = fontSize;
        var lineHeight = 0;
        if (_currentFontSize !== -1) {
            lineHeight = _currentFontSize * lineHeightFactor;
        }
        if (_currentFontSize === -1 || lineHeight > maxHeight) {
            _currentFontSize = maxHeight / lineHeightFactor;
            lineHeight = maxHeight;
        }
        return wrapText(font, baselineCorrection, fontFamily, _currentFontSize, maxWidth, align, text, options, fontScript, fontDirection, useOpentype);
    }

    // Now we do the layout
    // First check if the defaultFontSize works to fit everything in min lines
    var currentFontSize = fontSize;
    var textHeightForCurrentFontSize = 0;
    if (currentFontSize !== -1) {
        textHeightForCurrentFontSize = currentFontSize * lineHeightFactor * minLines + (minLines - 1) * lineSpacing;
    }
    if (currentFontSize === -1 || textHeightForCurrentFontSize > maxHeight) {
        currentFontSize = (maxHeight - (minLines - 1) * lineSpacing) / (minLines * lineHeightFactor);
        textHeightForCurrentFontSize = maxHeight;
    }

    // Algorithm :
    // 1. For a certain font size, check if the layout takes up more than the max height available.
    //    If yes, break and decrement the font size by a small amount and try again.
    // 2. Repeat until the total height is less than or equal to the max height

    var MAX_RETRIES = 1000;
    var retries = 0;
    var solved = false;
    var minFontSize = 1;
    var maxFontSize = currentFontSize;
    var testFontSize = currentFontSize / 2;
    while (!solved && retries < MAX_RETRIES) {
        var textIndexOffset = 0;
        var totalHeight = 0;
        var exceededHeight = false;
        // Iterate through all user lines
        for (var _i3 = 0; _i3 < userTextLines.length; _i3++) {
            var userTextLine = userTextLines[_i3];

            // For each user line, try layout
            totalHeight += testFontSize * lineHeightFactor;

            if (totalHeight > maxHeight) {
                exceededHeight = true;
                break;
            }

            var currentLineWidth = 0;
            for (var ci = 0; ci < userTextLine.length; ci++) {
                var _c = userTextLine[ci];
                var charLayoutInfo = charsLayoutInfo[textIndexOffset + ci];

                var newLineWidth = currentLineWidth + (charLayoutInfo.advanceWidth + charLayoutInfo.kernOffset) * (testFontSize / font.unitsPerEm);

                if (newLineWidth > maxWidth) {
                    // Gotta push to a new line
                    var newLineHeight = testFontSize * lineHeightFactor + lineSpacing;
                    currentLineWidth = charLayoutInfo.advanceWidth * (testFontSize / font.unitsPerEm);

                    totalHeight += newLineHeight;
                } else {
                    currentLineWidth = newLineWidth;
                }

                if (totalHeight > maxHeight) {
                    exceededHeight = true;
                    break;
                }
            }

            if (totalHeight > maxHeight) {
                exceededHeight = true;
                break;
            }

            textIndexOffset += userTextLine.length + 1;
        }

        if (exceededHeight) {
            maxFontSize = testFontSize;
        } else {
            minFontSize = testFontSize;
        }

        if (maxFontSize - minFontSize < 0.1) {
            solved = true;
            currentFontSize = minFontSize;
        } else {
            retries++;
            testFontSize = (maxFontSize + minFontSize) / 2;
        }
    }

    if (!solved) {
        throw new Error('Cannot fit the text in given height');
    }

    return wrapText(font, baselineCorrection, fontFamily, currentFontSize, maxWidth, align, text, options, fontScript, fontDirection, useOpentype);
};

exports.TextLayerInfo = TextLayerInfo;

},{"../../../edit/constants/CounterTimeFormatType":201,"../../../edit/utils/OverlayUtils":231,"../FontManager":76}],125:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _polyfill = require('./polyfill');

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var Timer = function () {
    function Timer() {
        _classCallCheck(this, Timer);

        this.time = (0, _polyfill.currentEpoch)();
        this._lastTimeMarked = this.time;
    }

    _createClass(Timer, [{
        key: 'markTimeFromStart',
        value: function markTimeFromStart() {
            var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'marked-time from epoch';

            var currentTime = (0, _polyfill.currentEpoch)();
            var elapsedFromPrevTimeStamp = currentTime - this._lastTimeMarked;
            this._lastTimeMarked = currentTime;
            console.log(message + ' - ' + this._lastTimeMarked + ' elapsed from start : ' + (this._lastTimeMarked - this.time) + ' , elapsed from prev : ' + elapsedFromPrevTimeStamp);
        }
    }]);

    return Timer;
}();

exports.default = Timer;

},{"./polyfill":126}],126:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Scheduler = exports.createRafLoop = exports.doubleRaf = exports.currentEpoch = exports.waitOn = exports.cancelLocalIdleCallback = exports.localIdleCallback = exports.qeueBatchedOperation = exports.qeueReduxBatchedOperation = exports.localMicrotask = undefined;

var _reactRedux = require('react-redux');

var _GeneralUtils = require('../GeneralUtils');

/* eslint-disable no-restricted-syntax */
//* * WILL ADD MORE METHODS FOR BETTER SCHEDULING WORK IN BROWSER USING POST MESSAGES POSSIBLY */

var localMicrotask = exports.localMicrotask = function () {
    return window.queueMicrotask || Promise && function (cb) {
        return Promise.resolve().then(cb);
    } || function (cb) {
        var t = setTimeout(function () {
            cb();
            clearTimeout(t); // cleanup
        }, 0);
    };
}();

var qeueReduxBatchedOperation = exports.qeueReduxBatchedOperation = function () {
    // TODO -- make change to stop removing the callbacks
    var idleId = null;
    var taskArrayIdle = [];

    var FLUSH_TIME = 3;

    var debouncedExecutorIdle = function debouncedExecutorIdle() {
        return localIdleCallback(function (_ref) {
            var didTimeout = _ref.didTimeout;

            (0, _reactRedux.batch)(function () {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = taskArrayIdle[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ta = _step.value;

                        ta();
                    }
                    // console.log(`Executed :`, taskArrayIdle.length , `Idle tasks`)
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                taskArrayIdle.length = 0;
            });
        });
    };

    var rafId = null;
    var taskArrayRaf = [];
    var debouncedExecutorRaf = function debouncedExecutorRaf() {
        return requestAnimationFrame(function () {
            (0, _reactRedux.batch)(function () {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = taskArrayRaf[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var ta = _step2.value;

                        ta();
                    }
                    // console.log(`Executed :`, taskArrayRaf.length , `raf tasks`)
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                taskArrayRaf.length = 0;
            });
        });
    };

    var stId = null;
    var taskArrayTimeout = [];
    var debouncedExecutorTimeout = function debouncedExecutorTimeout() {
        return setTimeout(function () {
            (0, _reactRedux.batch)(function () {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = taskArrayTimeout[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var ta = _step3.value;

                        ta();
                    }
                    // console.log(`Executed :`, taskArrayTimeout.length , `Timeout tasks`)
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                taskArrayTimeout.length = 0;
            });
        }, FLUSH_TIME);
    };

    var microTaskArray = [];
    var debouncedMicroTask = function debouncedMicroTask() {
        return localMicrotask(function () {
            (0, _reactRedux.batch)(function () {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = microTaskArray[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var ta = _step4.value;

                        ta();
                    }
                    // console.log(`Executed :`, microTaskArray.length, `Timeout tasks`);
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                microTaskArray.length = 0;
            });
        });
    };

    /**
     *
     *
     *
     * @param {() => {}} [cb=null]
     * @param {idle  | raf | timeout | mt} [type="idle"]
     */
    var func = function func() {
        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'idle';

        if (cb) {
            switch (type) {
                case 'idle':
                    {
                        if (taskArrayIdle.length == 0) {
                            idleId = debouncedExecutorIdle();
                        }
                        taskArrayIdle.push(cb);
                        return idleId;
                    }
                case 'raf':
                    {
                        if (taskArrayRaf.length == 0) {
                            rafId = debouncedExecutorRaf();
                        }
                        taskArrayRaf.push(cb);

                        return rafId;
                    }
                case 'timeout':
                    {
                        if (taskArrayTimeout.length == 0) {
                            stId = debouncedExecutorTimeout();
                        }
                        taskArrayTimeout.push(cb);
                        return stId;
                    }
                case 'mt':
                    {
                        if (microTaskArray.length == 0) {
                            debouncedMicroTask();
                        }
                        microTaskArray.push(cb);
                    }
            }
        }
    };

    return func;
}();

var qeueBatchedOperation = exports.qeueBatchedOperation = function () {
    // TODO -- make change to stop removing the callbacks
    var idleId = null;
    var taskArrayIdle = [];

    var FLUSH_TIME = 3;

    var debouncedExecutorIdle = function debouncedExecutorIdle() {
        return localIdleCallback(function (_ref2) {
            var didTimeout = _ref2.didTimeout;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = taskArrayIdle[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var ta = _step5.value;

                    ta();
                }
                // console.log(`Executed :`, taskArrayIdle.length , `Idle tasks`)
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            taskArrayIdle.length = 0;
        });
    };

    var rafId = null;
    var taskArrayRaf = [];
    var debouncedExecutorRaf = function debouncedExecutorRaf() {
        return requestAnimationFrame(function () {
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = taskArrayRaf[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var ta = _step6.value;

                    ta();
                }
                // console.log(`Executed :`, taskArrayRaf.length , `raf tasks`)
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            taskArrayRaf.length = 0;
        });
    };

    var stId = null;
    var taskArrayTimeout = [];
    var debouncedExecutorTimeout = function debouncedExecutorTimeout() {
        return setTimeout(function () {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = taskArrayTimeout[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var ta = _step7.value;

                    ta();
                }
                // console.log(`Executed :`, taskArrayTimeout.length , `Timeout tasks`)
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            taskArrayTimeout.length = 0;
        }, FLUSH_TIME);
    };

    var microTaskArray = [];
    var debouncedMicroTask = function debouncedMicroTask() {
        return localMicrotask(function () {
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = microTaskArray[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var ta = _step8.value;

                    ta();
                }
                // console.log(`Executed :`, taskArrayTimeout.length , `Timeout tasks`)
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            microTaskArray.length = 0;
        });
    };

    /**
     *
     *
     *
     * @param {() => {}} [cb=null]
     * @param {idle  | raf | timeout | mt} [type="idle"]
     */
    var func = function func() {
        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'idle';

        if (cb) {
            switch (type) {
                case 'idle':
                    {
                        if (taskArrayIdle.length == 0) {
                            idleId = debouncedExecutorIdle();
                        }
                        taskArrayIdle.push(cb);
                        return idleId;
                    }
                case 'raf':
                    {
                        if (taskArrayRaf.length == 0) {
                            rafId = debouncedExecutorRaf();
                        }
                        taskArrayRaf.push(cb);

                        return rafId;
                    }
                case 'timeout':
                    {
                        if (taskArrayTimeout.length == 0) {
                            stId = debouncedExecutorTimeout();
                        }
                        taskArrayTimeout.push(cb);
                        return stId;
                    }
                case 'mt':
                    {
                        if (microTaskArray.length == 0) {
                            debouncedMicroTask();
                        }
                        microTaskArray.push(cb);
                    }
            }
        }
    };

    return func;
}();

var localIdleCallback = exports.localIdleCallback = function () {
    return window.requestIdleCallback || function (cb) {
        var t = setTimeout(function () {
            cb({ didTimeout: false, timeRemaining: function timeRemaining() {
                    return 16;
                } }); // poor mans polyfil
        }, 0);
        return t;
    };
}();

var cancelLocalIdleCallback = exports.cancelLocalIdleCallback = function () {
    return window.cancelIdleCallback || clearTimeout;
}();

/**
 * takes a predicate function and runs it repeatedly on intervals of
 * till to * interval
 * By default interval is 1second
 *
 * Will resolve the promise once predicate is met or reject is the max time out is reach
 *
 *
 * @param {Function} [func=() => {}]
 * @param {number} [to=60]
 * @return {*}
 */
var waitOn = exports.waitOn = function waitOn() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
    var intervals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
    return new Promise(function (resolve, reject) {
        if (func()) resolve();
        var timeout = void 0;
        var interval = setInterval(function () {
            if (func()) {
                clearInterval(interval);
                clearTimeout(timeout);
                resolve();
            }
        }, intervals);
        timeout = setTimeout(function () {
            clearInterval(interval);
            clearTimeout(timeout);
            reject();
        }, to * intervals);
    });
};

var currentEpoch = exports.currentEpoch = function () {
    if (performance) return performance.now.bind(performance);
    return Date.now;
}();

/**
 * Trick used by twitter at one , point to debounce costly setState
 * to paint the UI and then skip the partial update in the next frame
 *
 * @param {*} [fn=() => {}]
 */
var doubleRaf = exports.doubleRaf = function doubleRaf() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    requestAnimationFrame(function () {
        return requestAnimationFrame(function () {
            return fn();
        });
    });
};

var createRafLoop = exports.createRafLoop = function createRafLoop(fn) {
    var rafId = void 0;

    var callRafLoop = function callRafLoop() {
        rafId = requestAnimationFrame(function () {
            var shouldContinue = fn();
            // console.log(`raf loop continue ?:`, shouldContinue)
            if (shouldContinue) {
                callRafLoop();
            }
        });
    };

    callRafLoop();

    return function () {
        cancelAnimationFrame(rafId);
    };
};

var Scheduler = exports.Scheduler = function () {
    var currentCallCtx = 0;
    var taskQ = [];

    window.addEventListener('message', function (ev) {
        if (ev.target !== window) return;
        var data = ev.data;

        if (data && data.type === 'posttask') {
            for (var i = 0, len = taskQ.length; i < len; i += 1) {
                var func = taskQ[i];
                if (func) {
                    func();
                }
            }
            taskQ.length = 0;
        }
    }, true);

    return {
        postTask: function postTask() {
            var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            if (taskQ.length === 0) {
                currentCallCtx += 1;
                window.postMessage({ type: 'posttask', ctx: currentCallCtx }, '*');
            }
            taskQ.push(func);
            return currentCallCtx * 1000 + (taskQ.length - 1);
        },
        cancelTask: function cancelTask(id) {
            if (id) {
                var ctId = id % 1000;
                var ctx = Math.floor(id / 1000);
                if (ctx === currentCallCtx) {
                    taskQ[ctId] = null;
                }
            }
        }
    };
}();

// export function* generatorFilter(list = [], filterOp = () => true){
//     for(const li of list){
//         if(filterOp(li))
//             yield li
//     }
// }

// export function *generatorMap(list = [] , mapOp = (d) => d) {
//     for(const li of list){
//         yield mapOp(li)
//     }
// }

// export function *generatorReduce(list = [] , reduceOp = () => null , accumulator = null){
//     for(const li of list){
//         accumulator = reduceOp(accumulator , li)
//         yield accumulator
//     }
// }

// export function *generatorFlat(list = []){
//     for(const li of list){
//         if(Array.isArray(li))
//             yield *generatorFlat(li)
//         else
//             yield li
//     }
// }

},{"../GeneralUtils":77,"react-redux":1079}],127:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReverseIndexSearch = exports.filterElements = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _lunr = require('lunr');

var _lunr2 = _interopRequireDefault(_lunr);

var _Search2 = require('./Search');

var _Search3 = _interopRequireDefault(_Search2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TAG_IN_OR_MODE = true;

/**
 * TODO -- shallow memoize the filter elements function
 *
 * @export
 * @param {Array<any>} list
 * @param {Function} [extractIdfn=(data) => data]
 * @param {Object} [config={ strict : false, transform : null }]
 * @return {*}
 */
var filterElements = exports.filterElements = function filterElements(list) {
    var extractIdfn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (data) {
        return data;
    };
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { strict: false, transform: null, sortFunc: function sortFunc(a, b) {
            return a.score - b.score;
        } };

    var stashedList = list;
    var ids2Data = list.reduce(function (a, v, i) {
        var obj = a;
        obj[extractIdfn(v)] = config.transform ? config.transform(v) : v;
        return obj;
    }, {});

    var _processList = function _processList(newFilterList) {
        if (newFilterList === null || newFilterList === undefined) return config.strict ? [] : stashedList;
        var result = newFilterList.map(function (k) {
            return ids2Data[k.id];
        }).filter(function (v) {
            return v !== undefined;
        }).sort(config.sortFunc);

        return result;
    };

    return _processList;
};

var ReverseIndexSearch = exports.ReverseIndexSearch = function (_Search) {
    _inherits(ReverseIndexSearch, _Search);

    function ReverseIndexSearch(serializedIndex, config) {
        _classCallCheck(this, ReverseIndexSearch);

        var _this = _possibleConstructorReturn(this, (ReverseIndexSearch.__proto__ || Object.getPrototypeOf(ReverseIndexSearch)).call(this, serializedIndex));

        _this.index = _lunr2.default.Index.load(serializedIndex);
        _this.config = config;
        return _this;
    }

    _createClass(ReverseIndexSearch, [{
        key: '_doSearch',
        value: function _doSearch(queryString) {
            if (!!this.config.debug) {
                var startTime = Date.now();
                var result = this.index.search(queryString);
                console.log('Time taken to do Reverse Index Search query: ' + queryString + ' : ', Date.now() - startTime);
                return result;
            }
            return this.index.search(queryString);
        }
    }, {
        key: '_processResult',
        value: function _processResult(result) {
            return result.sort(function (a, b) {
                return b.score - a.score;
            }).map(function (v) {
                return { id: v.ref, score: v.score };
            });
        }

        /**
         *
         *
         * @param {string} query
         * @param {boolean} [strict=false]
         * @return {string}
         * @memberof ReverseIndexSearch
         */

    }, {
        key: '_buildStringQuery',
        value: function _buildStringQuery(query) {
            var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var tokens = query.trim().split(' ');
            var modTokens = tokens.map(function (v) {
                if (strict) return '+' + v;
                return v;
            });

            var _config$editDistanceC = this.config.editDistanceCount,
                editDistanceCount = _config$editDistanceC === undefined ? 3 : _config$editDistanceC;

            var editDistance = '~' + editDistanceCount;
            // if(modTokens[modTokens.length - 1].length > 3 && modTokens[modTokens.length - 1].length < 6 )
            //     editDistance = `~${5 - modTokens[modTokens.length - 1].length}`

            this.config.editDistance ? modTokens.push(tokens[tokens.length - 1] + editDistance) : null; // last term can be relaxed
            return modTokens.join(' ');
        }
    }, {
        key: 'queryString',
        value: async function queryString(query) {
            var newSearchString = this._buildStringQuery(query, false);

            if (this.config.debug) {
                console.log('QueryString Created : ' + newSearchString);
            }

            var result = this._doSearch(newSearchString);

            return this._processResult(result);
        }
    }, {
        key: '_buildTagQuery',
        value: function _buildTagQuery(tags) {
            var tagNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['tags'];

            return tags.map(function (tag, i) {
                var index = i;
                var token = tag.split(' ');
                return token.map(function (v) {
                    if (TAG_IN_OR_MODE) return tagNames[index] + ':' + v + '^1000';
                    return '+' + tagNames[index] + ':' + v;
                }).join(' ');
            }).join(' ');
        }
    }, {
        key: 'queryByTags',
        value: async function queryByTags(tags) {
            var tagNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['tags'];

            var queryString = this._buildTagQuery(tags, tagNames);
            if (this.config.debug) {
                console.log('QueryString Created : ' + queryString);
            }
            var result = this._doSearch(queryString);
            return this._processResult(result);
        }
    }, {
        key: 'queryByTagsString',
        value: async function queryByTagsString(_ref) {
            var _ref$query = _ref.query,
                query = _ref$query === undefined ? '' : _ref$query,
                _ref$tags = _ref.tags,
                tags = _ref$tags === undefined ? [] : _ref$tags,
                _ref$tagNames = _ref.tagNames,
                tagNames = _ref$tagNames === undefined ? ['tag'] : _ref$tagNames;
            var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var queryString = this._buildTagQuery(tags, tagNames);
            queryString += ' ' + this._buildStringQuery(query, strict);

            if (this.config.debug) {
                console.log('QueryString Created : ' + queryString);
            }

            var result = this._doSearch(queryString);
            return this._processResult(result);
        }
    }]);

    return ReverseIndexSearch;
}(_Search3.default);

},{"./Search":128,"lunr":874}],128:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var errorMessage = new Error('Unimplemented method');

var Search = function () {
    function Search() {
        _classCallCheck(this, Search);
    }

    _createClass(Search, [{
        key: 'queryString',

        /**
         * Query with natural language ,returns the matching unique filters and the references
         *
         * @param {string} query
         * @memberof Search
         */
        value: function queryString(query) {
            throw errorMessage;
        }

        /**
         * Find all entries from a tag
         * Each word in tag must exist in the respective tagName field
         * Tgs
         *
         * @param {Array<string>} tags
         * @param {Array<string>} tagNames
         * @memberof Search
         */

    }, {
        key: 'queryByTags',
        value: function queryByTags(tags) {
            var tagNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['tags'];

            throw errorMessage;
        }

        /**
         * The combination of above two
         * Tags are used for reducing search space
         * String is used for queries of nearest distances
         *
         * @param {*} {
         *         query= '',
         *         tags=[]
         *     }
         * @memberof Search
         */

    }, {
        key: 'queryByTagsString',
        value: function queryByTagsString(_ref) {
            var _ref$query = _ref.query,
                query = _ref$query === undefined ? '' : _ref$query,
                _ref$tags = _ref.tags,
                tags = _ref$tags === undefined ? [] : _ref$tags,
                _ref$tagNames = _ref.tagNames,
                tagNames = _ref$tagNames === undefined ? ['tags'] : _ref$tagNames;

            throw errorMessage;
        }
    }]);

    return Search;
}();

exports.default = Search;

},{}],129:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterElements = undefined;
exports.buildSearch = buildSearch;

var _ReverseIndexSearch = require('./ReverseIndexSearch');

/**
 * Builds a SearchIndex for the given JSON document
 * * each document is unique and may have multiple related content to it
 * * We expect a single uniform document to be presented for ease of search
 *
 * @export
 * @param {Object} dataJson
 * @return {ReverseIndexSearch} 
 */
function buildSearch(dataJson) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { editDistance: true };

  return new _ReverseIndexSearch.ReverseIndexSearch(dataJson, config);
}

var filterElements = exports.filterElements = _ReverseIndexSearch.filterElements;

},{"./ReverseIndexSearch":127}],130:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PREVIEW_WATERMARK_HEIGHT = exports.PREVIEW_WATERMARK_HEIGHT = 60;
var PREVIEW_WATERMARK_WIDTH = exports.PREVIEW_WATERMARK_WIDTH = 222;
var PREVIEW_WATERMARK_X = exports.PREVIEW_WATERMARK_X = 20;
var PREVIEW_WATERMARK_Y = exports.PREVIEW_WATERMARK_Y = 30;

var WATERMARK_OVERLAY_DEF = exports.WATERMARK_OVERLAY_DEF = {
    id: 'defId-userBitmap-watermark-typito',
    desc: 'User bitmap',
    meta: {
        canOverrideAnimation: true,
        // scaleOnly: true,
        nativeAspectRatio: 3.5238095238095237,
        imageId: 'watermark-typito',
        mappings: {}
    },
    props: {
        alpha: 'alpha',
        shadow: 'shadow',
        crop: 'crop',
        imageId: 'imageId'
    },
    defaults: {
        alpha: 1,
        shadow: false,
        crop: 'none',
        imageId: 'watermark-typito'
    },
    layers: [{
        id: 'b1',
        desc: 'Only bitmap',
        type: 'bitmap',
        attrs: {
            imageId: '${imageId}',
            alpha: '${alpha}',
            width: '${ow}',
            height: '${oh}',
            crop: '${crop}',
            shadowEnabled: '${shadow}'
        },
        animation: { enterkeyframes: {}, exitkeyframes: {} }
    }]
};

var WATERMARK_OVERLAY = exports.WATERMARK_OVERLAY = {
    values: {
        alpha: 1,
        shadow: false,
        crop: 'none',
        imageId: 'watermark-typito'
    },
    id: 'overlay-4',
    name: '',
    defId: 'defId-userBitmap-watermark-typito',
    space: {
        width: PREVIEW_WATERMARK_WIDTH,
        height: PREVIEW_WATERMARK_HEIGHT,
        transform: 'matrix(0.456298723824942, 0, 0, 0.456298723824942, 0, 0)',
        x: PREVIEW_WATERMARK_X,
        y: PREVIEW_WATERMARK_Y,
        zIndex: 99999
    },
    ready: true,
    displayPrefs: false,
    variant: {},
    time: {
        enterstart: 0,
        enterdone: 0,
        exitstart: 2000,
        exitdone: 2000,
        enterAnimDefId: 'animDefId-IN-NONE',
        exitAnimDefId: 'animDefId-OUT-NONE'
    }
};

var WATERMARK_IMAGE_DATA = exports.WATERMARK_IMAGE_DATA = {
    id: 'watermark-typito',
    mediaType: 'image',
    imageData: {
        id: 'watermark-typito',
        uploadStatus: 'READY',
        originalFileName: 'watermark-typito.png',
        si: 'gs_watermark-typito',
        height: 250,
        width: 925,
        baseUrl: 'https://typito-srijith-app-public.storage.googleapis.com/image/watermark-typito/renditions',
        fullPngUrl: 'https://typito-srijith-app-public.storage.googleapis.com/image/watermark-typito/renditions/thumb_native',
        previewUrl: 'https://typito-srijith-app-public.storage.googleapis.com/image/watermark-typito/renditions/preview_1080',
        source: 'personal',
        deleted: false,
        size: 15,
        thumbUrl: 'https://typito-srijith-app-public.storage.googleapis.com/image/watermark-typito/renditions/thumb_120',
        createdAt: '2021-07-06T19:42:25.000Z'
    }
};

var DEFAULT_WATERMARK_SIZE = exports.DEFAULT_WATERMARK_SIZE = 200;
var DEFAULT_WATERMARK_CANVAS_SIZE = exports.DEFAULT_WATERMARK_CANVAS_SIZE = 1080;

},{}],131:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildWorker = buildWorker;
/**
 *
 *
 * @export
 * @param {(data:any , done = (data:any) => {}) => {}} [fn=(data , done = () => {}) => {}]
 * @return {(data:any) => Promise<any>} 
 */
function buildWorker() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (data) {
        var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (data) {};
    };

    if (!fn) {
        console.log('no function provided');
        return;
    }

    var fnString = '(self.onmessage = (event) => {(' + fn + ')(event && event.data.message,(data , err) => event && self.postMessage({id:event.data.id , message: data , error: err}));})();';

    var blob = new Blob([fnString.replace('"use strict";', '')]);
    var blobUrl = window.URL.createObjectURL(blob, {
        type: 'application/javascript; charset=utf-8'
    });

    var worker = new Worker(blobUrl);

    var Queue = {};
    var count = 0;
    var sendMessage = function sendMessage(data, resolve, reject) {
        Queue[++count] = { resolve: resolve, reject: reject };
        worker.postMessage({
            id: count,
            message: data
        });
    };
    worker.onmessage = function (ev) {
        var _ev$data = ev.data,
            id = _ev$data.id,
            message = _ev$data.message,
            error = _ev$data.error;
        var _Queue$id = Queue[id],
            resolve = _Queue$id.resolve,
            reject = _Queue$id.reject;

        if (error) reject(error);else resolve(message);
        delete Queue[id];
    };
    worker.onerror = function (err) {
        console.log(err);
    };

    return function (data) {
        return new Promise(function (resolve, reject) {
            sendMessage(data, resolve, reject);
        });
    };
}

},{}],132:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ALIGN_MODES = ['left', 'center', 'right'];

var ALIGN_TITLES = {
    'left': 'Left',
    'center': 'Center',
    'right': 'Right'
};

var AlignmentSelect = function (_Component) {
    _inherits(AlignmentSelect, _Component);

    function AlignmentSelect(props) {
        _classCallCheck(this, AlignmentSelect);

        var _this = _possibleConstructorReturn(this, (AlignmentSelect.__proto__ || Object.getPrototypeOf(AlignmentSelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(AlignmentSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                selectedMode = _props.selectedMode,
                onAlignmentChange = _props.onAlignmentChange,
                otherProps = _objectWithoutProperties(_props, ['selectedMode', 'onAlignmentChange']);

            var alignmentModeNodes = ALIGN_MODES.map(function (alignMode) {
                return _react2.default.createElement(AlignmentButton, { key: 'align-' + alignMode,
                    alignMode: alignMode,
                    inactive: alignMode !== selectedMode,
                    title: ALIGN_TITLES[alignMode],
                    onClick: function onClick() {
                        return onAlignmentChange(alignMode);
                    }
                });
            });

            var allModeNodes = [];
            alignmentModeNodes.forEach(function (item, i) {
                allModeNodes.push(item);
                if (i !== alignmentModeNodes.length - 1) {
                    allModeNodes.push(_react2.default.createElement('div', { key: '' + i, className: 'separator group' }));
                }
            });

            var alignOptionsNode = null;

            if (this.state.open) {
                alignOptionsNode = _react2.default.createElement('div', { className: 'alignment-options' }, allModeNodes);
            }

            return _react2.default.createElement('div', { className: 'alignment-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement(AlignmentButton, _extends({ alignMode: selectedMode,
                cbRef: function cbRef(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps)), alignOptionsNode);
        }
    }]);

    return AlignmentSelect;
}(_react.Component);

AlignmentSelect.propTypes = {
    selectedMode: _propTypes2.default.string.isRequired,
    onAlignmentChange: _propTypes2.default.func.isRequired
};
exports.default = AlignmentSelect;

var AlignmentButton = function (_Component2) {
    _inherits(AlignmentButton, _Component2);

    function AlignmentButton() {
        _classCallCheck(this, AlignmentButton);

        return _possibleConstructorReturn(this, (AlignmentButton.__proto__ || Object.getPrototypeOf(AlignmentButton)).apply(this, arguments));
    }

    _createClass(AlignmentButton, [{
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                alignMode = _props2.alignMode,
                inactive = _props2.inactive,
                cbRef = _props2.cbRef,
                className = _props2.className,
                otherProps = _objectWithoutProperties(_props2, ['alignMode', 'inactive', 'cbRef', 'className']);

            var clsName = (0, _classnames2.default)(className, {
                'alignment-button': true,
                'inactive': inactive
            });

            var svgIconId = 'align-' + alignMode;

            return _react2.default.createElement('div', _extends({ className: clsName,
                ref: cbRef
            }, otherProps), _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: svgIconId }));
        }
    }]);

    return AlignmentButton;
}(_react.Component);

AlignmentButton.propTypes = {
    alignMode: _propTypes2.default.string.isRequired,
    inactive: _propTypes2.default.bool.isRequired,
    cbRef: _propTypes2.default.func
};
AlignmentButton.defaultProps = {
    inactive: false,
    cbRef: function cbRef() {/* no-op */}
};

},{"../../common/components/SVGIcon.react":13,"classnames":410,"prop-types":896,"react":1107}],133:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _DiscreteSlider = require('./DiscreteSlider.react');

var _DiscreteSlider2 = _interopRequireDefault(_DiscreteSlider);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DURATION_VALUES = [50, 200, 350, 500, 1000, 1500, 2000];
var DURATION_LABELS = ['Fast', '', '', 'Normal', '', '', 'Slow'];

var GroupModes = (0, _keymirror2.default)({
    SINGLE_UNATTACHED: null, // Single element that isn't part of any group
    SINGLE_ATTACHED: null, // Single element part of a group
    MULTIPLE_UNATTACHED: null, // Multiple elements, none of them part of any group
    MULTIPLE_ATTACHED_SAME: null, // Multiple elements, all of them part of the same group
    MULTIPLE_ATTACHED_VARIOUS: null // Multiple elements, with at least one of them part of a group but not all of them
    // part of the same group
});

var getAnimationOptions = function getAnimationOptions(kind, overlays) {
    return window.animationOptions(kind, overlays);
};

var getSingleItem = function getSingleItem(dict) {
    return Object.keys(dict).map(function (key) {
        return { key: key, value: dict[key] };
    })[0];
};

var analyzeGrouping = function analyzeGrouping(overlays, animgroups) {

    animgroups = animgroups.filter(function (grp) {
        return grp.members.find(function (id) {
            return !!overlays[id];
        });
    });

    var isSingle = Object.keys(overlays).length === 1;

    var isAttachedToAny = animgroups.length > 0;
    var isAttachedToSame = animgroups.length === 1;

    if (isSingle) {
        return isAttachedToAny ? GroupModes.SINGLE_ATTACHED : GroupModes.SINGLE_UNATTACHED;
    } else {
        if (!isAttachedToAny) {
            return GroupModes.MULTIPLE_UNATTACHED;
        } else {
            return isAttachedToSame ? GroupModes.MULTIPLE_ATTACHED_SAME : GroupModes.MULTIPLE_ATTACHED_VARIOUS;
        }
    }
};

var AnimationSelect = function (_Component) {
    _inherits(AnimationSelect, _Component);

    function AnimationSelect(props) {
        _classCallCheck(this, AnimationSelect);

        var _this = _possibleConstructorReturn(this, (AnimationSelect.__proto__ || Object.getPrototypeOf(AnimationSelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(AnimationSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                if (this.state.open) {
                    this.setState({ open: false });
                }
            }
        }
    }, {
        key: 'setGroupAnimationMode',
        value: function setGroupAnimationMode(enableGroupAnimation) {
            this.props.onSetGroupAnimation(this.props.kind, enableGroupAnimation);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                kind = _props.kind,
                selectedOverlays = _props.selectedOverlays,
                overlaymeta = _props.overlaymeta,
                onSetGroupAnimation = _props.onSetGroupAnimation,
                onAnimationTypeChange = _props.onAnimationTypeChange,
                onAnimationDurationChange = _props.onAnimationDurationChange,
                onAnimationManualModeChange = _props.onAnimationManualModeChange,
                changeSpeedOnly = _props.changeSpeedOnly,
                className = _props.className,
                otherProps = _objectWithoutProperties(_props, ['kind', 'selectedOverlays', 'overlaymeta', 'onSetGroupAnimation', 'onAnimationTypeChange', 'onAnimationDurationChange', 'onAnimationManualModeChange', 'changeSpeedOnly', 'className']);

            var animOptions = getAnimationOptions(kind, selectedOverlays);

            var animgroups = overlaymeta.animgroups.filter(function (grp) {
                return grp.kind === kind;
            });

            var multiSelected = Object.keys(selectedOverlays).length > 1;

            var groupMode = analyzeGrouping(selectedOverlays, animgroups);

            var disableEverything = false;
            var disableReason = '';
            var showGroupAnimateCheckbox = false;
            var checkGroupAnimateCheckbox = false;

            // console.log(`groupMode ${groupMode}`)

            if (groupMode === GroupModes.SINGLE_UNATTACHED) {
                disableEverything = false;
                showGroupAnimateCheckbox = false;
            } else if (groupMode === GroupModes.SINGLE_ATTACHED) {
                disableEverything = true;
                disableReason = 'Animating as part of a group';
            } else if (groupMode === GroupModes.MULTIPLE_UNATTACHED) {
                disableEverything = false;
                showGroupAnimateCheckbox = true;
                checkGroupAnimateCheckbox = false;
            } else if (groupMode === GroupModes.MULTIPLE_ATTACHED_SAME) {
                disableEverything = false;
                showGroupAnimateCheckbox = true;
                checkGroupAnimateCheckbox = true;
            } else if (groupMode === GroupModes.MULTIPLE_ATTACHED_VARIOUS) {
                disableEverything = true;
                disableReason = 'Selected elements are part of multiple groups';
                showGroupAnimateCheckbox = false;
            }

            var animationOptions = null;
            var disableLayer = null;

            if (this.state.open) {

                var selectedAnimId = null,
                    selectedDuration = 0,
                    selectedDurationIsManual = false;
                if (!disableEverything) {
                    var _getSingleItem = getSingleItem(selectedOverlays),
                        selectedOverlay = _getSingleItem.value;

                    var _selectedOverlay$time = selectedOverlay.time,
                        enterstart = _selectedOverlay$time.enterstart,
                        enterdone = _selectedOverlay$time.enterdone,
                        exitstart = _selectedOverlay$time.exitstart,
                        exitdone = _selectedOverlay$time.exitdone,
                        enterAnimDefId = _selectedOverlay$time.enterAnimDefId,
                        exitAnimDefId = _selectedOverlay$time.exitAnimDefId,
                        _selectedOverlay$time2 = _selectedOverlay$time.enterAnimTimeManual,
                        enterAnimTimeManual = _selectedOverlay$time2 === undefined ? false : _selectedOverlay$time2,
                        _selectedOverlay$time3 = _selectedOverlay$time.exitAnimTimeManual,
                        exitAnimTimeManual = _selectedOverlay$time3 === undefined ? false : _selectedOverlay$time3;

                    selectedAnimId = kind === 'enter' ? enterAnimDefId : exitAnimDefId;
                    selectedDurationIsManual = !!(kind === 'enter' ? enterAnimTimeManual : exitAnimTimeManual);
                    if (selectedAnimId == "animDefId-OUT-NONE" || selectedAnimId == "animDefId-IN-NONE") {
                        selectedDuration = 0;
                    } else {
                        selectedDuration = kind === 'enter' ? enterdone - enterstart : exitdone - exitstart;
                    }
                }

                var animationOptionNodes = null,
                    typeLabelNode = null;
                if (!changeSpeedOnly) {
                    typeLabelNode = _react2.default.createElement('div', { className: 'animation-options-label' }, 'Type');
                    animationOptionNodes = animOptions.map(function (_ref) {
                        var id = _ref.id,
                            displayName = _ref.displayName;

                        var animOptionClassname = (0, _classnames2.default)('animation-option', { 'selected': selectedAnimId && selectedAnimId === id });

                        var labelNodes = displayName.split(' ').map(function (l, i) {
                            return _react2.default.createElement('div', { key: i }, l);
                        });

                        return _react2.default.createElement('div', { key: id,
                            className: animOptionClassname,
                            onClick: function onClick() {
                                return onAnimationTypeChange(kind, id);
                            }
                        }, labelNodes);
                    });
                }

                if (disableEverything) {
                    disableLayer = _react2.default.createElement('div', { className: 'animation-options-disable-layer' }, disableReason);
                }

                var animationGroupSettings = null;
                if (showGroupAnimateCheckbox && !changeSpeedOnly) {
                    animationGroupSettings = _react2.default.createElement('div', { className: 'animation-group-settings' }, _react2.default.createElement('div', { className: 'animation-group-checkbox',
                        onClick: function onClick(e) {
                            return onSetGroupAnimation(kind, !checkGroupAnimateCheckbox);
                        }
                    }, _react2.default.createElement('input', { type: 'checkbox', value: checkGroupAnimateCheckbox }), _react2.default.createElement('div', { className: (0, _classnames2.default)('check-mark', { 'checked': checkGroupAnimateCheckbox }) })), _react2.default.createElement('div', { className: 'animation-group-label' }, 'Animate as a group'));
                }

                var attrsContainerClassname = (0, _classnames2.default)('animation-attrs-container', {
                    'disabled': showGroupAnimateCheckbox && !checkGroupAnimateCheckbox
                });

                animationOptions = _react2.default.createElement('div', { className: 'animation-options' }, animationGroupSettings, _react2.default.createElement('div', { className: attrsContainerClassname }, typeLabelNode, animationOptionNodes, _react2.default.createElement(AnimationDurationParent, {
                    values: DURATION_VALUES,
                    labels: DURATION_LABELS,
                    selectedAnimId: selectedAnimId,
                    onValueChange: function onValueChange(v) {
                        return onAnimationDurationChange(kind, v);
                    },
                    selectedDuration: selectedDuration,
                    selectedDurationIsManual: selectedDurationIsManual,
                    onDurationChange: function onDurationChange(v) {
                        return onAnimationDurationChange(kind, v);
                    },
                    onManualModeChange: function onManualModeChange() {
                        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }

                        return onAnimationManualModeChange.apply(undefined, [kind].concat(args));
                    }
                })), disableLayer);
            }

            var iconId = kind == 'enter' ? 'animation-in' : 'animation-out';
            var label = kind == 'enter' ? 'In' : 'Out';

            var classNames = (0, _classnames2.default)('animation-select', className);
            return _react2.default.createElement('div', { className: classNames,
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                } }, _react2.default.createElement('div', _extends({ className: 'animation-select-button',
                ref: function ref(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps), _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: iconId }), _react2.default.createElement('div', { className: 'anim-button-label' }, label)), animationOptions);
        }
    }]);

    return AnimationSelect;
}(_react.Component);

AnimationSelect.propTypes = {
    className: _propTypes2.default.string,
    kind: _propTypes2.default.oneOf(['enter', 'exit']).isRequired,
    selectedOverlays: _propTypes2.default.object.isRequired,
    overlaymeta: _propTypes2.default.object.isRequired,
    changeSpeedOnly: _propTypes2.default.bool,
    onAnimationTypeChange: _propTypes2.default.func.isRequired,
    onAnimationManualModeChange: _propTypes2.default.func.isRequired,
    onAnimationDurationChange: _propTypes2.default.func.isRequired,
    onSetGroupAnimation: _propTypes2.default.func.isRequired
};
AnimationSelect.defaultProps = {
    changeSpeedOnly: false,
    className: ''
};
exports.default = AnimationSelect;

var AnimationDurationParent = function (_Component2) {
    _inherits(AnimationDurationParent, _Component2);

    function AnimationDurationParent(props) {
        _classCallCheck(this, AnimationDurationParent);

        return _possibleConstructorReturn(this, (AnimationDurationParent.__proto__ || Object.getPrototypeOf(AnimationDurationParent)).call(this, props));
    }

    _createClass(AnimationDurationParent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var toggle = $(this.node);
            if (this.props.selectedAnimId == "animDefId-OUT-NONE" || this.props.selectedAnimId == "animDefId-IN-NONE") {
                TweenMax.to(toggle, 0.1, { maxHeight: "0px" });
            } else {
                TweenMax.to(toggle, 0.1, { maxHeight: "200px" });
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var toggle = $(this.node);
            if (nextProps.selectedAnimId == "animDefId-OUT-NONE" || nextProps.selectedAnimId == "animDefId-IN-NONE") {
                TweenMax.to(toggle, 0.4, { maxHeight: "0px" });
            } else {
                TweenMax.to(toggle, 0.4, { maxHeight: "200px" });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var divStyle = { overflow: 'hidden', background: "#424242", width: "250px", zIndex: "-1" };

            return _react2.default.createElement('div', { ref: function ref(n) {
                    return _this5.node = n;
                }, style: divStyle }, _react2.default.createElement('div', { className: 'animation-duration-label' }, 'Speed'), _react2.default.createElement(_DiscreteSlider2.default, {
                values: DURATION_VALUES,
                labels: DURATION_LABELS,
                currentValue: this.props.selectedDuration,
                onValueChange: this.props.onValueChange,
                disabled: this.props.selectedDurationIsManual,
                unit: 'ms'
            }), _react2.default.createElement(AnimationDurationManual, {
                selectedDuration: this.props.selectedDuration,
                selectedDurationIsManual: this.props.selectedDurationIsManual,
                onDurationChange: this.props.onDurationChange,
                onManualModeChange: this.props.onManualModeChange
            }));
        }
    }]);

    return AnimationDurationParent;
}(_react.Component);

AnimationDurationParent.propTypes = {
    selectedDuration: _propTypes2.default.number.isRequired,
    selectedDurationIsManual: _propTypes2.default.bool.isRequired,
    onDurationChange: _propTypes2.default.func.isRequired,
    onManualModeChange: _propTypes2.default.func.isRequired,
    values: _propTypes2.default.array.isRequired,
    labels: _propTypes2.default.array.isRequired,
    selectedAnimId: _propTypes2.default.any.isRequired,
    onValueChange: _propTypes2.default.func.isRequired,
    valueFormatter: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    dragState: _propTypes2.default.object,
    dragCallbacks: _propTypes2.default.object
};

var AnimationDurationManual = function (_Component3) {
    _inherits(AnimationDurationManual, _Component3);

    function AnimationDurationManual(props) {
        _classCallCheck(this, AnimationDurationManual);

        var _this6 = _possibleConstructorReturn(this, (AnimationDurationManual.__proto__ || Object.getPrototypeOf(AnimationDurationManual)).call(this, props));

        _this6.state = { editingDurationValue: props.selectedDuration + '' };
        return _this6;
    }

    _createClass(AnimationDurationManual, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.selectedDurationIsManual) {
                this.setState({ editingDurationValue: this.props.selectedDuration + '' });
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.selectedDuration != nextProps.selectedDuration) this.setState({ editingDurationValue: nextProps.selectedDuration + '' });
        }
    }, {
        key: 'tryChangeDurationFromInput',
        value: function tryChangeDurationFromInput(durationValue) {
            var _isDurationValid = this.isDurationValid(durationValue),
                durationValid = _isDurationValid.valid,
                newDuration = _isDurationValid.value;

            if (durationValid) {
                if (newDuration !== this.props.selectedDuration) {
                    this.props.onDurationChange(newDuration);
                }
            }
        }
    }, {
        key: 'onDurationInputChange',
        value: function onDurationInputChange(e) {

            var newDuration = e.target.value;

            this.setState({ editingDurationValue: newDuration });

            this.tryChangeDurationFromInput(newDuration);
        }
    }, {
        key: 'onDurationInputBlur',
        value: function onDurationInputBlur() {
            this.setState({ editingDurationValue: this.props.selectedDuration + '' });
        }
    }, {
        key: 'toggleManualMode',
        value: function toggleManualMode() {
            var _props2 = this.props,
                selectedDuration = _props2.selectedDuration,
                isManual = _props2.selectedDurationIsManual,
                onManualModeChange = _props2.onManualModeChange;

            if (!isManual) {
                onManualModeChange(true, selectedDuration);
                this.setState({ editingDurationValue: selectedDuration + '' });
            } else {
                var closestIndex = (0, _GeneralUtils.findClosestValueIndex)(selectedDuration, DURATION_VALUES);
                onManualModeChange(false, DURATION_VALUES[closestIndex]);
            }
        }
    }, {
        key: 'isDurationValid',
        value: function isDurationValid(testValue) {
            var valid = false;
            var value = -1;
            try {
                var n = ~~Number(testValue);
                if (String(n) === testValue && n > 0) {
                    valid = true;
                    value = n;
                }
            } catch (e) {}

            return { valid: valid, value: value };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var isManual = this.props.selectedDurationIsManual;
            var editingDurationValue = this.state.editingDurationValue;

            var _isDurationValid2 = this.isDurationValid(editingDurationValue),
                durationValid = _isDurationValid2.valid;

            var checkMarkClassname = (0, _classnames2.default)('check-mark', {
                'checked': isManual
            });

            var manualCustomLabelClsname = (0, _classnames2.default)('manual-custom-label', {
                'disabled': !isManual
            });
            var manualTimeTextClsname = (0, _classnames2.default)('manual-time-text', {
                'disabled': !isManual,
                'invalid': isManual && !durationValid
            });

            var manualTimeTextLabelClsname = (0, _classnames2.default)('manual-time-text-label', {
                'disabled': !isManual
            });

            return _react2.default.createElement('div', { className: 'animation-duration-manual' }, _react2.default.createElement('div', { className: 'manual-checkbox',
                onClick: function onClick(e) {
                    return _this7.toggleManualMode();
                }
            }, _react2.default.createElement('input', { type: 'checkbox', value: isManual }), _react2.default.createElement('div', { className: checkMarkClassname })), _react2.default.createElement('div', { className: manualCustomLabelClsname }, 'Custom'), _react2.default.createElement('input', { type: 'text', className: manualTimeTextClsname,
                value: isManual ? editingDurationValue : '',
                disabled: !isManual,
                onChange: function onChange(e) {
                    return _this7.onDurationInputChange(e);
                },
                onBlur: function onBlur(e) {
                    return _this7.onDurationInputBlur(e);
                }
            }), _react2.default.createElement('div', { className: manualTimeTextLabelClsname }, 'ms'));
        }
    }]);

    return AnimationDurationManual;
}(_react.Component);

AnimationDurationManual.propTypes = {
    selectedDuration: _propTypes2.default.number.isRequired,
    selectedDurationIsManual: _propTypes2.default.bool.isRequired,
    onDurationChange: _propTypes2.default.func.isRequired,
    onManualModeChange: _propTypes2.default.func.isRequired
};

},{"../../common/components/SVGIcon.react":13,"../../common/utils/GeneralUtils":77,"./DiscreteSlider.react":138,"classnames":410,"keymirror":677,"prop-types":896,"react":1107}],134:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _ColorPickerButton = require('../../common/components/colorselect/ColorPickerButton.react');

var _ColorPickerButton2 = _interopRequireDefault(_ColorPickerButton);

var _ColorButton = require('../../common/components/colorselect/ColorButton.react');

var _ColorButton2 = _interopRequireDefault(_ColorButton);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT_COLORS = ['#FFFFFF', '#FF5C5C', '#FFBD4A', '#FFF952', '#99E265', '#44D9E6', '#000000', '#5271FF', '#B760E6', '#FF63B1'];

var ColorSelect = function (_Component) {
    _inherits(ColorSelect, _Component);

    function ColorSelect(props) {
        _classCallCheck(this, ColorSelect);

        var _this = _possibleConstructorReturn(this, (ColorSelect.__proto__ || Object.getPrototypeOf(ColorSelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(ColorSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'onClickBrandColorUpgrade',
        value: function onClickBrandColorUpgrade() {
            window.open('/account#brandkit', '_blank');
        }
    }, {
        key: 'onColorChangeFinish',
        value: function onColorChangeFinish(colorHex, selectedColor) {
            this.props.onColorChangeFinish(colorHex, selectedColor);
            if (this.props.closeOnSelect) {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                selectedColor = _props.selectedColor,
                isDemo = _props.isDemo,
                isPaidWorkspace = _props.isPaidWorkspace,
                isCurrentTextSelected = _props.isCurrentTextSelected,
                projectColors = _props.projectColors,
                brandColors = _props.brandColors,
                recentColors = _props.recentColors,
                currentFocus = _props.currentFocus,
                isTextColor = _props.isTextColor,
                colorRange = _props.colorRange;

            var _props2 = this.props,
                onSelectColor = _props2.onSelectColor,
                onColorChangeIncremental = _props2.onColorChangeIncremental,
                otherProps = _objectWithoutProperties(_props2, ['onSelectColor', 'onColorChangeIncremental']);

            var defaultColorNodes = DEFAULT_COLORS.map(function (color, i) {
                var colorHex = (0, _color2.default)(color).rgb().string();

                return _react2.default.createElement(_ColorButton2.default, { key: i,
                    colorHex: colorHex,
                    isTextColor: false,
                    onClick: function onClick() {
                        return _this3.onColorChangeFinish(colorHex, selectedColor);
                    }
                });
            });

            var projectColorNodes = projectColors.map(function (color, i) {
                var colorHex = (0, _color2.default)(color).rgb().string();

                return _react2.default.createElement(_ColorButton2.default, { key: i,
                    colorHex: colorHex,
                    isTextColor: false,
                    onClick: function onClick() {
                        return _this3.onColorChangeFinish(colorHex, selectedColor);
                    }
                });
            });

            var colorHex = (0, _color2.default)(selectedColor).rgb().string();

            var projectColorConatainerNode = _react2.default.createElement('div', { className: 'project-colors' }, _react2.default.createElement('div', { className: 'project-colors-label' }, 'PROJECT COLORS'), _react2.default.createElement(_ColorPickerButton2.default, { key: 'picker',
                showActionButton: true,
                actionButtonLabel: 'Add to project',
                selectedColor: selectedColor,
                onClickActionButton: function onClickActionButton() {
                    return onSelectColor(selectedColor, "project");
                },
                onColorChangeIncremental: onColorChangeIncremental,
                onColorChangeFinish: this.props.onColorChangeFinish
            }), projectColorNodes);

            var recentColorConatainerNode = null;

            if (recentColors.length > 0) {
                var recentColorNodes = recentColors.map(function (color, i) {
                    var colorHex = (0, _color2.default)(color).rgb().string();

                    return _react2.default.createElement(_ColorButton2.default, { key: i,
                        colorHex: colorHex,
                        isTextColor: false,
                        onClick: function onClick() {
                            return _this3.onColorChangeFinish(colorHex, selectedColor);
                        }
                    });
                });

                recentColorConatainerNode = _react2.default.createElement('div', { className: 'recent-colors' }, _react2.default.createElement('div', { className: 'recent-colors-label' }, 'RECENT COLORS'), recentColorNodes);
            }
            // let brandColorConatainerNode = null

            var brandColorNodes = brandColors.map(function (color, i) {
                var colorHex = (0, _color2.default)(color).rgb().string();

                return _react2.default.createElement(_ColorButton2.default, { key: i,
                    colorHex: colorHex,
                    isTextColor: false,
                    onClick: function onClick() {
                        return _this3.onColorChangeFinish(colorHex, selectedColor);
                    }
                });
            });

            var brandColorConatainerNode = _react2.default.createElement('div', { className: 'brand-colors' }, _react2.default.createElement('div', { className: 'brand-colors-label' }, 'BRAND COLORS'), brandColors.length < 10 && _react2.default.createElement(_ColorPickerButton2.default, { key: 'picker',
                showActionButton: true,
                actionButtonLabel: 'Add to team colors',
                selectedColor: selectedColor,
                onClickActionButton: function onClickActionButton() {
                    return onSelectColor(selectedColor, "brand");
                },
                onColorChangeIncremental: onColorChangeIncremental,
                onColorChangeFinish: this.props.onColorChangeFinish
            }), brandColorNodes);

            var defaultColorConatainerNode = _react2.default.createElement('div', { className: 'default-colors' }, _react2.default.createElement('div', { className: 'default-palette-label' }, 'DEFAULT PALETTE'), defaultColorNodes);

            var colorSuggestions = null;

            if (this.state.open) {
                colorSuggestions = _react2.default.createElement('div', { className: 'color-suggestions-wrapper', style: this.props.customStyle || {} }, _react2.default.createElement('div', { className: 'color-suggestions' }, projectColorConatainerNode, !isDemo && brandColorConatainerNode, defaultColorConatainerNode, isDemo && _react2.default.createElement('div', { className: 'brand-colors-upgrade-container' }, _react2.default.createElement('div', { className: 'brand-color-upgrade-label' }, 'Create your palette!'), _react2.default.createElement('div', { className: 'learn-more-btn', onClick: function onClick() {
                        return _this3.onClickBrandColorUpgrade();
                    } }, 'Learn More'))));
            }

            return _react2.default.createElement('div', { className: 'color-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement(_ColorButton2.default, _extends({ colorHex: colorHex, currentFocus: currentFocus,
                isTextColor: isTextColor, isCurrentTextSelected: isCurrentTextSelected,
                colorRange: colorRange,
                cbRef: function cbRef(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps)), colorSuggestions);
        }
    }]);

    return ColorSelect;
}(_react.Component);

ColorSelect.propTypes = {
    selectedColor: _propTypes2.default.string.isRequired,
    projectColors: _propTypes2.default.array,
    recentColors: _propTypes2.default.array,
    brandColors: _propTypes2.default.array,
    isTextColor: _propTypes2.default.bool.isRequired,
    colorRange: _propTypes2.default.object,
    currentFocus: _propTypes2.default.object,
    onSelectColor: _propTypes2.default.func,
    onColorChangeIncremental: _propTypes2.default.func.isRequired,
    onColorChangeFinish: _propTypes2.default.func.isRequired,
    isCurrentTextSelected: _propTypes2.default.bool,
    isPaidWorkspace: _propTypes2.default.bool,
    closeOnSelect: _propTypes2.default.bool,
    isDemo: _propTypes2.default.bool
};
ColorSelect.defaultProps = {
    currentFocus: {},
    isCurrentTextSelected: false,
    isPaidWorkspace: false,
    isDemo: false,
    closeOnSelect: false,
    projectColors: [],
    recentColors: [],
    brandColors: [],
    onSelectColor: function onSelectColor() {}
};
exports.default = ColorSelect;

},{"../../common/components/SVGIcon.react":13,"../../common/components/colorselect/ColorButton.react":17,"../../common/components/colorselect/ColorPickerButton.react":18,"classnames":410,"color":418,"prop-types":896,"react":1107}],135:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CountTimerTypeSelect = function (_Component) {
    _inherits(CountTimerTypeSelect, _Component);

    function CountTimerTypeSelect() {
        _classCallCheck(this, CountTimerTypeSelect);

        return _possibleConstructorReturn(this, (CountTimerTypeSelect.__proto__ || Object.getPrototypeOf(CountTimerTypeSelect)).apply(this, arguments));
    }

    _createClass(CountTimerTypeSelect, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isAscendingTimer = _props.isAscendingTimer,
                onToggleTimerType = _props.onToggleTimerType,
                otherProps = _objectWithoutProperties(_props, ['isAscendingTimer', 'onToggleTimerType']);

            var timerIconClassname = (0, _classnames2.default)('timer-icon', {
                'count-up-disabled': !isAscendingTimer,
                'count-down-disabled': isAscendingTimer
            });

            return _react2.default.createElement('div', _extends({ className: 'count-timer-select'
            }, otherProps), _react2.default.createElement('div', { className: timerIconClassname,
                onClick: function onClick() {
                    return onToggleTimerType();
                }
            }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'timer-type' })));
        }
    }]);

    return CountTimerTypeSelect;
}(_react.Component);

CountTimerTypeSelect.propTypes = {
    isAscendingTimer: _propTypes2.default.bool.isRequired,
    onToggleTimerType: _propTypes2.default.func.isRequired
};
exports.default = CountTimerTypeSelect;

},{"../../common/components/SVGIcon.react":13,"classnames":410,"prop-types":896,"react":1107}],136:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CounterSelect = function (_Component) {
    _inherits(CounterSelect, _Component);

    function CounterSelect(props) {
        _classCallCheck(this, CounterSelect);

        var _this = _possibleConstructorReturn(this, (CounterSelect.__proto__ || Object.getPrototypeOf(CounterSelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(CounterSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                if (this.state.open) {
                    this.setState({ open: false });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                currentDuration = _props.currentDuration,
                selectedOverlays = _props.selectedOverlays,
                onCounterDurationChange = _props.onCounterDurationChange,
                onDisableOverlayMovement = _props.onDisableOverlayMovement,
                maxCounterValue = _props.maxCounterValue,
                otherProps = _objectWithoutProperties(_props, ['currentDuration', 'selectedOverlays', 'onCounterDurationChange', 'onDisableOverlayMovement', 'maxCounterValue']);

            var durationInSecs = Math.ceil(currentDuration / 1000);
            var durationLabel = durationInSecs + 's';

            var counterOptionsClsname = (0, _classnames2.default)('counter-options', {
                'open': this.state.open
            });

            return _react2.default.createElement('div', { className: 'counter-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                } }, _react2.default.createElement('div', _extends({ className: 'counter-select-button',
                ref: function ref(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps), _react2.default.createElement('div', { className: 'count-button-label' }, durationLabel)), _react2.default.createElement('div', { className: counterOptionsClsname }, _react2.default.createElement(CounterDurationManual, {
                maxCounterValue: maxCounterValue,
                show: this.state.open,
                selectedDuration: durationInSecs,
                onDisableOverlayMovement: onDisableOverlayMovement,
                onDurationChange: function onDurationChange(v) {
                    return onCounterDurationChange(v * 1000);
                }
            })));
        }
    }]);

    return CounterSelect;
}(_react.Component);

CounterSelect.propTypes = {
    maxCounterValue: _propTypes2.default.number.isRequired,
    currentDuration: _propTypes2.default.number.isRequired,
    selectedOverlays: _propTypes2.default.object.isRequired,
    onDisableOverlayMovement: _propTypes2.default.func.isRequired,
    onCounterDurationChange: _propTypes2.default.func.isRequired
};
exports.default = CounterSelect;

var CounterDurationManual = function (_Component2) {
    _inherits(CounterDurationManual, _Component2);

    function CounterDurationManual(props) {
        _classCallCheck(this, CounterDurationManual);

        var _this4 = _possibleConstructorReturn(this, (CounterDurationManual.__proto__ || Object.getPrototypeOf(CounterDurationManual)).call(this, props));

        _this4.state = { editingDurationValue: props.selectedDuration + '' };
        return _this4;
    }

    _createClass(CounterDurationManual, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ editingDurationValue: this.props.selectedDuration + '' });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.selectedDuration != nextProps.selectedDuration) this.setState({ editingDurationValue: nextProps.selectedDuration + '' });
        }
    }, {
        key: 'tryChangeDurationFromInput',
        value: function tryChangeDurationFromInput(durationValue) {
            var _isDurationValid = this.isDurationValid(durationValue),
                durationValid = _isDurationValid.valid,
                newDuration = _isDurationValid.value;

            if (durationValid) {
                if (newDuration !== this.props.selectedDuration) {
                    this.props.onDurationChange(newDuration);
                }
            }
        }
    }, {
        key: 'onDurationInputChange',
        value: function onDurationInputChange(e) {

            var newDuration = e.target.value;

            this.setState({ editingDurationValue: newDuration });

            this.tryChangeDurationFromInput(newDuration);
        }
    }, {
        key: 'onDurationInputBlur',
        value: function onDurationInputBlur() {
            this.setState({ editingDurationValue: this.props.selectedDuration + '' });
            this.props.onDisableOverlayMovement(false);
        }
    }, {
        key: 'isDurationValid',
        value: function isDurationValid(testValue) {
            var valid = false;
            var value = -1;
            try {
                var n = ~~Number(testValue);
                if (String(n) === testValue && n > 0 && n <= this.props.maxCounterValue) {
                    valid = true;
                    value = n;
                }
            } catch (e) {}

            return { valid: valid, value: value };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var show = this.props.show;

            if (!show) {
                return null;
            }

            var editingDurationValue = this.state.editingDurationValue;

            var _isDurationValid2 = this.isDurationValid(editingDurationValue),
                durationValid = _isDurationValid2.valid;

            var manualTimeTextClsname = (0, _classnames2.default)('manual-time-text', {
                'invalid': !durationValid
            });

            return _react2.default.createElement('div', { className: 'counter-duration-manual' }, _react2.default.createElement('div', { className: 'manual-custom-label' }, 'Duration'), _react2.default.createElement('input', { type: 'text', className: manualTimeTextClsname,
                value: editingDurationValue,
                onFocus: function onFocus() {
                    return _this5.props.onDisableOverlayMovement(true);
                },
                onChange: function onChange(e) {
                    return _this5.onDurationInputChange(e);
                },
                onBlur: function onBlur(e) {
                    return _this5.onDurationInputBlur(e);
                }
            }), _react2.default.createElement('div', { className: 'manual-time-text-label' }, 's'));
        }
    }]);

    return CounterDurationManual;
}(_react.Component);

CounterDurationManual.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    maxCounterValue: _propTypes2.default.number.isRequired,
    selectedDuration: _propTypes2.default.number.isRequired,
    onDisableOverlayMovement: _propTypes2.default.func.isRequired,
    onDurationChange: _propTypes2.default.func.isRequired
};

},{"classnames":410,"prop-types":896,"react":1107}],137:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CROP_MODES = ['none', 'square', 'circle'];

var CROP_TITLES = {
    'none': 'None',
    'square': 'Square',
    'circle': 'Circle'
};

var CropSelect = function (_Component) {
    _inherits(CropSelect, _Component);

    function CropSelect(props) {
        _classCallCheck(this, CropSelect);

        var _this = _possibleConstructorReturn(this, (CropSelect.__proto__ || Object.getPrototypeOf(CropSelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(CropSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                selectedMode = _props.selectedMode,
                onCropChange = _props.onCropChange,
                otherProps = _objectWithoutProperties(_props, ['selectedMode', 'onCropChange']);

            var cropModeNodes = CROP_MODES.map(function (cropMode) {
                return _react2.default.createElement(CropButton, { key: 'crop-' + cropMode,
                    cropMode: cropMode,
                    inactive: cropMode !== selectedMode,
                    title: CROP_TITLES[cropMode],
                    onClick: function onClick() {
                        return onCropChange(cropMode);
                    }
                });
            });

            var allModeNodes = [];
            cropModeNodes.forEach(function (item, i) {
                allModeNodes.push(item);
                if (i !== cropModeNodes.length - 1) {
                    allModeNodes.push(_react2.default.createElement('div', { key: '' + i, className: 'separator group' }));
                }
            });

            var cropOptionsNode = null;

            if (this.state.open) {
                cropOptionsNode = _react2.default.createElement('div', { className: 'crop-options' }, allModeNodes);
            }

            return _react2.default.createElement('div', { className: 'crop-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement(CropButton, _extends({ cropMode: 'none',
                cbRef: function cbRef(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps)), cropOptionsNode);
        }
    }]);

    return CropSelect;
}(_react.Component);

CropSelect.propTypes = {
    selectedMode: _propTypes2.default.string.isRequired,
    onCropChange: _propTypes2.default.func.isRequired
};
exports.default = CropSelect;

var CropButton = function (_Component2) {
    _inherits(CropButton, _Component2);

    function CropButton() {
        _classCallCheck(this, CropButton);

        return _possibleConstructorReturn(this, (CropButton.__proto__ || Object.getPrototypeOf(CropButton)).apply(this, arguments));
    }

    _createClass(CropButton, [{
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                cropMode = _props2.cropMode,
                inactive = _props2.inactive,
                cbRef = _props2.cbRef,
                className = _props2.className,
                otherProps = _objectWithoutProperties(_props2, ['cropMode', 'inactive', 'cbRef', 'className']);

            var clsName = (0, _classnames2.default)(className, {
                'crop-button': true,
                'inactive': inactive
            });

            var svgIconId = 'crop-' + cropMode;

            return _react2.default.createElement('div', _extends({ className: clsName,
                ref: cbRef
            }, otherProps), _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: svgIconId }));
        }
    }]);

    return CropButton;
}(_react.Component);

CropButton.propTypes = {
    cropMode: _propTypes2.default.string.isRequired,
    inactive: _propTypes2.default.bool.isRequired,
    cbRef: _propTypes2.default.func
};
CropButton.defaultProps = {
    inactive: false,
    cbRef: function cbRef() {/* no-op */}
};

},{"../../common/components/SVGIcon.react":13,"classnames":410,"prop-types":896,"react":1107}],138:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DiscreteSliderInner = function (_Component) {
    _inherits(DiscreteSliderInner, _Component);

    function DiscreteSliderInner(props) {
        _classCallCheck(this, DiscreteSliderInner);

        var _this = _possibleConstructorReturn(this, (DiscreteSliderInner.__proto__ || Object.getPrototypeOf(DiscreteSliderInner)).call(this, props));

        _this.state = { hovering: false, hoverLeftPercent: 0 };
        return _this;
    }

    _createClass(DiscreteSliderInner, [{
        key: 'onTrackMouseOver',
        value: function onTrackMouseOver(e) {

            this.setHoverFromMousePosition(e);
        }
    }, {
        key: 'onTrackMouseMove',
        value: function onTrackMouseMove(e) {

            this.setHoverFromMousePosition(e);
        }
    }, {
        key: 'onTrackMouseOut',
        value: function onTrackMouseOut(e) {

            this.setHoverFromMousePosition(e, false);
        }
    }, {
        key: 'onTrackClick',
        value: function onTrackClick(e) {
            var _props = this.props,
                values = _props.values,
                onValueChange = _props.onValueChange;

            var hoverLeftPercent = this.calcHoverLeftPercent(e);

            var index = this.percentToIndex(hoverLeftPercent);

            onValueChange(values[index]);
        }
    }, {
        key: 'setHoverFromMousePosition',
        value: function setHoverFromMousePosition(e) {
            var hovering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var values = this.props.values;

            var hoverLeftPercent = this.calcHoverLeftPercent(e);
            this.setState({ hovering: hovering, hoverLeftPercent: hoverLeftPercent });

            var closestHoverIndex = this.percentToIndex(hoverLeftPercent);
        }
    }, {
        key: 'calcHoverLeftPercent',
        value: function calcHoverLeftPercent(e) {
            var hoverPageX = e.pageX;
            var trackPageX = $(this.track).offset().left;
            var trackWidth = $(this.track).width();

            var hoverLeft = Math.max(0, Math.min(trackWidth, hoverPageX - trackPageX));
            var hoverLeftPercent = hoverLeft / trackWidth * 100;

            return hoverLeftPercent;
        }
    }, {
        key: 'percentToIndex',
        value: function percentToIndex(percent) {
            var values = this.props.values;

            return Math.round(percent / 100 * (values.length - 1));
        }
    }, {
        key: 'indexToPercent',
        value: function indexToPercent(index) {
            var values = this.props.values;

            return index / (values.length - 1) * 100;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                values = _props2.values,
                labels = _props2.labels,
                currentValue = _props2.currentValue,
                valueFormatter = _props2.valueFormatter,
                disabled = _props2.disabled,
                unit = _props2.unit;
            var _state = this.state,
                hovering = _state.hovering,
                hoverLeftPercent = _state.hoverLeftPercent;

            var numTicks = values.length;

            var ticks = values.map(function (v, i) {

                var tickStyles = {
                    position: 'absolute',
                    top: 0,
                    left: i / (numTicks - 1) * 100 + '%'
                };
                return _react2.default.createElement('span', { className: 'slider-tick',
                    key: 'tick-' + i,
                    style: tickStyles }, _react2.default.createElement('span', { className: 'slider-tick-label' }, valueFormatter(labels[i])));
            });

            var closestIndex = (0, _GeneralUtils.findClosestValueIndex)(currentValue, values);

            var knobStyles = {
                position: 'absolute',
                top: 0,
                left: this.indexToPercent(closestIndex) + '%'
            };

            var closestHoverIndex = this.percentToIndex(hoverLeftPercent);

            var knobGhostStyles = {
                position: 'absolute',
                top: 0,
                left: this.indexToPercent(closestHoverIndex) + '%'
            };

            var sliderOuterClsname = (0, _classnames2.default)('slider-outer', { disabled: disabled });

            var knobGhostClsname = (0, _classnames2.default)('slider-knob-ghost', {
                show: hovering
            });

            return _react2.default.createElement('div', { className: 'discrete-slider-root' }, _react2.default.createElement('div', { className: sliderOuterClsname }, _react2.default.createElement('div', { className: 'slider-inner' }, _react2.default.createElement('div', { className: 'slider-track',
                ref: function ref(c) {
                    _this2.track = c;
                },
                onMouseOver: function onMouseOver(e) {
                    return _this2.onTrackMouseOver(e);
                },
                onMouseMove: function onMouseMove(e) {
                    return _this2.onTrackMouseMove(e);
                },
                onMouseOut: function onMouseOut(e) {
                    return _this2.onTrackMouseOut(e);
                },
                onClick: function onClick(e) {
                    return _this2.onTrackClick(e);
                }
            }, _react2.default.createElement('div', { className: 'slider-track-bg' }), ticks, _react2.default.createElement('div', { className: knobGhostClsname,
                key: 'knob-ghost',
                style: knobGhostStyles }, _react2.default.createElement('span', { className: 'slider-value-label' }, values[closestHoverIndex] + ' ' + unit)), _react2.default.createElement('div', { className: 'slider-knob',
                key: 'knob',
                style: knobStyles }))), _react2.default.createElement('div', { className: 'slider-inner-disable-layer', style: { visibility: disabled ? 'visible' : 'hidden' } })));
        }
    }]);

    return DiscreteSliderInner;
}(_react.Component);

DiscreteSliderInner.propTypes = {
    values: _propTypes2.default.array.isRequired,
    labels: _propTypes2.default.array.isRequired,
    currentValue: _propTypes2.default.any.isRequired,
    onValueChange: _propTypes2.default.func.isRequired,
    unit: _propTypes2.default.string.isRequired,
    valueFormatter: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    dragState: _propTypes2.default.object,
    dragCallbacks: _propTypes2.default.object
};
DiscreteSliderInner.defaultProps = {
    valueFormatter: function valueFormatter(v) {
        return v;
    },
    disabled: false,
    unit: ''
};

var DiscreteSlider = (0, _ClickDragMixin2.default)(DiscreteSliderInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false
});

exports.default = DiscreteSlider;

},{"../../common/utils/GeneralUtils":77,"../mixins/ClickDragMixin.react":150,"classnames":410,"prop-types":896,"react":1107}],139:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _emojiMart = require('emoji-mart');

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _SVGFontLabel = require('../../common/components/SVGFontLabel.react');

var _SVGFontLabel2 = _interopRequireDefault(_SVGFontLabel);

var _HoverDiv = require('./HoverDiv.react');

var _HoverDiv2 = _interopRequireDefault(_HoverDiv);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EmojiSelect = function (_Component) {
    _inherits(EmojiSelect, _Component);

    function EmojiSelect(props) {
        _classCallCheck(this, EmojiSelect);

        var _this = _possibleConstructorReturn(this, (EmojiSelect.__proto__ || Object.getPrototypeOf(EmojiSelect)).call(this, props));

        _this.state = { open: false, hovering: false };
        return _this;
    }

    _createClass(EmojiSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                selectedEmoji = _props.selectedEmoji,
                className = _props.className;
            var _props2 = this.props,
                shouldShowEmoji = _props2.shouldShowEmoji,
                onEmojiSelect = _props2.onEmojiSelect;
            var open = this.state.open;

            var emojiOptionsStyles = {
                visibility: open ? 'visible' : 'hidden',
                opacity: open ? 1 : 0
            };

            return _react2.default.createElement('div', { className: 'emoji-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement(_HoverDiv2.default, { className: 'emoji-selected',
                cbRef: function cbRef(c) {
                    _this3.selectorButton = c;
                },
                onHover: function onHover(hovering) {
                    _this3.setState({ hovering: hovering });
                },
                title: 'Font'
            }, _react2.default.createElement(_emojiMart.Emoji, { emoji: selectedEmoji, set: 'twitter', size: 24 })), _react2.default.createElement('div', { className: 'emoji-options', style: emojiOptionsStyles }, _react2.default.createElement(_emojiMart.Picker, { emoji: 'point_up', title: "Pick your emoji\u2026",
                showSkinTones: false,
                sheetSize: 64,
                perLine: 7,
                skin: 1,
                set: 'twitter',
                emojisToShowFilter: function emojisToShowFilter(emoji) {
                    return shouldShowEmoji(emoji.unified.toLowerCase());
                },
                onSelect: function onSelect(emoji) {
                    return onEmojiSelect(emoji);
                } })));
        }
    }]);

    return EmojiSelect;
}(_react.Component);

EmojiSelect.propTypes = {
    selectedEmoji: _propTypes2.default.string.isRequired,
    shouldShowEmoji: _propTypes2.default.func.isRequired,
    onEmojiSelect: _propTypes2.default.func.isRequired
};
EmojiSelect.defaultProps = {
    selectedEmoji: 'grinning'
};
exports.default = EmojiSelect;

},{"../../common/components/SVGFontLabel.react":12,"../../common/components/SVGIcon.react":13,"./HoverDiv.react":142,"classnames":410,"emoji-mart":601,"prop-types":896,"react":1107}],140:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _SVGFontLabel = require('../../common/components/SVGFontLabel.react');

var _SVGFontLabel2 = _interopRequireDefault(_SVGFontLabel);

var _HoverDiv = require('./HoverDiv.react');

var _HoverDiv2 = _interopRequireDefault(_HoverDiv);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _constants = require('../../common/constants');

var _WorkspaceUpgradeModal = require('../../common/components/WorkspaceUpgradeModal.react');

var _WorkspaceUpgradeModal2 = _interopRequireDefault(_WorkspaceUpgradeModal);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FontFamilySelect = function (_Component) {
    _inherits(FontFamilySelect, _Component);

    function FontFamilySelect(props) {
        _classCallCheck(this, FontFamilySelect);

        var _this = _possibleConstructorReturn(this, (FontFamilySelect.__proto__ || Object.getPrototypeOf(FontFamilySelect)).call(this, props));

        _this.goBackToFonts = function () {
            _this.setState({ showFontIntermediateModal: false });
        };

        _this.searchFonts = function (e) {
            _this.setState({ searchText: e.target.value, fontCategorization: 'all' });
        };

        _this.chooseCategory = function (e) {
            _this.setState({ fontCategorization: e.target.value, searchText: '' });
            document.getElementById('familyContainer' + _this.props.ffp).scrollTop = 0;
        };

        _this.state = { open: false, hovering: false, showCategory: true, searchText: '', fontCategorization: "all", showFontIntermediateModal: false, showUpgradeModal: false };

        _this.classification = Object.keys(_constants.FontClassification);
        return _this;
    }

    _createClass(FontFamilySelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false, showFontIntermediateModal: false, hovering: false, showCategory: true, searchText: '', fontCategorization: "all", showUpgradeModal: false });
            }
            document.getElementById('fontSearchBoxInput' + this.props.ffp).focus();
        }
    }, {
        key: 'headerNode',
        value: function headerNode(headerText) {
            return _react2.default.createElement('div', { className: 'font-list-header' }, _react2.default.createElement('div', { className: 'headerLine' }), _react2.default.createElement('div', { className: 'header-text' }, headerText), _react2.default.createElement('div', { className: 'headerLine' }));
        }
    }, {
        key: 'onClickFontUpload',
        value: function onClickFontUpload() {
            var _props$activeWorkspac = this.props.activeWorkspace.fontLimit,
                fontLimit = _props$activeWorkspac === undefined ? 3 : _props$activeWorkspac;

            var customFontsCount = _FontManager2.default.searchCustomFonts().length + _FontManager2.default.searchUploadedFonts().length;

            if (customFontsCount >= fontLimit) {
                this.setState({ showUpgradeModal: true });
                return;
            }
            if (this.props.isDemo) {
                this.setState({ open: false });
                window.open('/account#brandkit', '_blank');
            } else if (this.props.isPaidWorkspace || this.state.showFontIntermediateModal) {
                this.setState({ showFontIntermediateModal: false });
                this.props.openFontUploadModal();
            } else {
                this.setState({ showFontIntermediateModal: true });
            }
        }
    }, {
        key: 'hideCategoryBox',
        value: function hideCategoryBox() {
            this.setState({ showCategory: false });
        }
    }, {
        key: 'showCategoryBox',
        value: function showCategoryBox() {
            this.setState({ showCategory: true, searchText: '' });
        }
    }, {
        key: 'onCloseUpgradeModal',
        value: function onCloseUpgradeModal() {
            this.setState({ showUpgradeModal: false });
        }
    }, {
        key: 'getCategoryTitle',
        value: function getCategoryTitle(t) {
            switch (t) {
                case 'SANS_SERIF':
                    return 'Sans Serif';
                case 'SERIF':
                    return 'Serif';
                case 'SLAB_SERIF':
                    return 'Slab';
                case 'DISPLAY':
                    return 'Display';
                default:
                    return t;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                selectedValue = _props.selectedValue,
                onFontSelect = _props.onFontSelect,
                className = _props.className,
                isDemo = _props.isDemo,
                isPaidWorkspace = _props.isPaidWorkspace,
                ffp = _props.ffp;
            var _state = this.state,
                open = _state.open,
                hovering = _state.hovering,
                searchText = _state.searchText,
                showFontIntermediateModal = _state.showFontIntermediateModal;

            var showFontOptionStyle = open && !showFontIntermediateModal;

            var showUploadIntermediateStyle = open && showFontIntermediateModal;

            var fontOptionsStyles = {
                visibility: showFontOptionStyle ? 'visible' : 'hidden',
                opacity: showFontOptionStyle ? 1 : 0
            };

            var fontUploadIntermediateStyles = {
                visibility: showUploadIntermediateStyle ? 'visible' : 'hidden',
                opacity: showUploadIntermediateStyle ? 1 : 0
            };

            var FONTS = _FontManager2.default.searchFonts(searchText, this.state.fontCategorization);

            var CUSTOM_FONTS = _FontManager2.default.searchCustomFonts(searchText, this.state.fontCategorization);

            var UPLOADED_FONTS = _FontManager2.default.searchUploadedFonts(searchText, this.state.fontCategorization);

            var hasCustomFonts = CUSTOM_FONTS.length > 0 || UPLOADED_FONTS.length > 0;

            return _react2.default.createElement('div', { className: (0, _classnames2.default)('font-family-select', className, { open: open }),
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement(_HoverDiv2.default, { className: 'font-selected',
                cbRef: function cbRef(c) {
                    _this3.selectorButton = c;
                },
                onHover: function onHover(hovering) {
                    _this3.setState({ hovering: hovering });
                },
                title: 'Font'
            }, _react2.default.createElement(_SVGFontLabel2.default, { fontKey: selectedValue })), _react2.default.createElement('span', { className: (0, _classnames2.default)('font-select-arrow', { hovering: hovering }) }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'font-select-arrow' })), _react2.default.createElement('div', { className: 'font-options-container', style: fontOptionsStyles }, _react2.default.createElement('div', { className: 'search-box', style: this.state.showCategory ? {} : { display: 'none' } }, _react2.default.createElement('div', { className: 'control-group' }, _react2.default.createElement('div', { className: 'form-control custom-input classification' }, _react2.default.createElement('div', { onClick: this.chooseCategory, title: 'All', key: 'all' }, _react2.default.createElement('input', { type: 'radio', id: 'radio-all-' + ffp, value: 'all',
                checked: this.state.fontCategorization === "all" }), _react2.default.createElement('label', { htmlFor: 'radio-all-' + ffp,
                className: (0, _classnames2.default)("all", { "active": this.state.fontCategorization === "all" }) }, 'ALL')), this.classification.map(function (t, index) {
                return _react2.default.createElement('div', { onClick: _this3.chooseCategory, title: _this3.getCategoryTitle(t), key: index }, _react2.default.createElement('input', { type: 'radio', id: 'radio-' + index + '-' + ffp, value: t,
                    checked: _this3.state.fontCategorization === t }), _react2.default.createElement('label', { htmlFor: 'radio-' + index + '-' + ffp,
                    className: (0, _classnames2.default)({ active: _this3.state.fontCategorization === t }) }, _react2.default.createElement(_SVGIcon2.default, { iconId: t })));
            }), _react2.default.createElement('div', { onClick: function onClick() {
                    return _this3.hideCategoryBox();
                }, title: 'Search', className: 'search' }, _react2.default.createElement('i', { className: 'glyphicon glyphicon-search' }))))), _react2.default.createElement('div', { className: 'search-box', style: !this.state.showCategory ? {} : { display: 'none' } }, _react2.default.createElement('input', { value: searchText, onChange: this.searchFonts, className: 'form-control input', id: 'fontSearchBoxInput' + ffp, placeholder: 'Search' }), _react2.default.createElement('div', { onClick: function onClick() {
                    return _this3.showCategoryBox();
                }, title: 'Close Search', className: 'close' }, _react2.default.createElement(_SVGIcon2.default, { iconId: 'cancel' }))), _react2.default.createElement('div', { className: 'font-list-header' }, _react2.default.createElement('div', { className: 'headerLine' })), _react2.default.createElement('div', { className: 'font-options', id: 'familyContainer' + ffp }, UPLOADED_FONTS.map(function (fontKey) {
                var clsName = (0, _classnames2.default)({
                    'font-option': true,
                    'selected': fontKey == selectedValue
                });
                return _react2.default.createElement('div', { className: clsName,
                    key: fontKey,
                    'data-font-key': fontKey,
                    onClick: function onClick() {
                        _this3.setState({ open: false });
                        onFontSelect(fontKey);
                    }
                }, _react2.default.createElement('div', { className: 'font-name-wrapper' }, _react2.default.createElement(_SVGFontLabel2.default, { className: 'font', fontKey: fontKey }), _react2.default.createElement(_SVGIcon2.default, { iconId: isPaidWorkspace ? "premium-star" : "premium-crown", className: 'premium-icon' })));
            }), CUSTOM_FONTS.map(function (fontKey) {
                var clsName = (0, _classnames2.default)({
                    'font-option': true,
                    'selected': fontKey == selectedValue
                });
                return _react2.default.createElement('div', { className: clsName,
                    key: fontKey,
                    'data-font-key': fontKey,
                    onClick: function onClick() {
                        _this3.setState({ open: false });
                        onFontSelect(fontKey);
                    }
                }, _react2.default.createElement('div', { className: 'font-name-wrapper' }, _react2.default.createElement(_SVGFontLabel2.default, { className: 'font', fontKey: fontKey }), _react2.default.createElement(_SVGIcon2.default, { iconId: isPaidWorkspace ? "premium-star" : "premium-crown", className: 'premium-icon' })));
            }), hasCustomFonts && _react2.default.createElement('div', { className: 'font-list-header' }, _react2.default.createElement('div', { className: 'headerLine' })), FONTS.map(function (fontKey) {

                var clsName = (0, _classnames2.default)({
                    'font-option': true,
                    'selected': fontKey == selectedValue
                });
                var isPremiumFont = _FontManager2.default.isPremiumFont(fontKey);
                return _react2.default.createElement('div', { className: clsName,
                    key: fontKey,
                    'data-font-key': fontKey,
                    onClick: function onClick() {
                        _this3.setState({ open: false });
                        onFontSelect(fontKey);
                    }
                }, _react2.default.createElement('div', { className: 'font-name-wrapper' }, _react2.default.createElement(_SVGFontLabel2.default, { className: 'font', fontKey: fontKey }), isPremiumFont && _react2.default.createElement(_SVGIcon2.default, { iconId: isPaidWorkspace ? "premium-star" : "premium-crown", className: 'premium-icon' })));
            })), _react2.default.createElement('div', { className: 'custom-font-upgrade-container', onClick: function onClick() {
                    return _this3.onClickFontUpload();
                } }, _react2.default.createElement('div', { className: 'font-upgrade-label' }, 'Upload your own fonts!'), (isDemo || !isPaidWorkspace) && _react2.default.createElement('i', { className: 'glyphicon glyphicon-arrow-right' }), isPaidWorkspace && _react2.default.createElement('i', { className: 'glyphicon glyphicon-plus' }))), _react2.default.createElement('div', { className: (0, _classnames2.default)({ "intermediate-font-upload": true, "intermediate-font-upload-sidebar": this.props.isSidebar }), style: fontUploadIntermediateStyles }, _react2.default.createElement('div', { className: 'header-intermediate' }, _react2.default.createElement('i', { className: 'glyphicon glyphicon-arrow-left', onClick: this.goBackToFonts }), 'CUSTOM FONTS'), _react2.default.createElement('div', { className: 'content-intermediate' }, _react2.default.createElement('div', { className: 'svg' }, _react2.default.createElement(_SVGIcon2.default, { iconId: 'intermediate-font' })), _react2.default.createElement('br', null), _react2.default.createElement('p', null, "Custom fonts is part of Typito\u2019s "), _react2.default.createElement('a', { href: 'https://help.typito.com/en/articles/2488761-brand-kit-on-typito', target: '_blank' }, ' Brand Kit. '), _react2.default.createElement('p', null, 'You are free to upload your own fonts and preview them with your current free plan. However, you will need to upgrade your plan to export the video.')), _react2.default.createElement('div', { className: 'button-wrapper' }, _react2.default.createElement('button', { className: 'btn btn-sm btn-typito-primary', onClick: function onClick() {
                    return _this3.onClickFontUpload();
                } }, _react2.default.createElement('i', { className: 'glyphicon glyphicon-upload' }), ' Upload a font'))), _react2.default.createElement(_WorkspaceUpgradeModal2.default, { show: this.state.showUpgradeModal,
                onHide: function onHide() {
                    return _this3.onCloseUpgradeModal();
                },
                reason: 'to add more custom fonts' }));
        }
    }]);

    return FontFamilySelect;
}(_react.Component);

FontFamilySelect.propTypes = {
    selectedValue: _propTypes2.default.string.isRequired,
    onFontSelect: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string,
    isDemo: _propTypes2.default.bool,
    isSidebar: _propTypes2.default.bool,
    isPaidWorkspace: _propTypes2.default.bool,
    ffp: _propTypes2.default.string
};
FontFamilySelect.defaultProps = {
    className: '',
    isDemo: false,
    isPaidWorkspace: false,
    ffp: 'fontFam'
};
exports.default = FontFamilySelect;

},{"../../common/components/SVGFontLabel.react":12,"../../common/components/SVGIcon.react":13,"../../common/components/WorkspaceUpgradeModal.react":16,"../../common/constants":61,"../../common/utils/FontManager":76,"./HoverDiv.react":142,"classnames":410,"prop-types":896,"react":1107}],141:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FontStyleButtonsModal = function (_Component) {
    _inherits(FontStyleButtonsModal, _Component);

    function FontStyleButtonsModal(props) {
        _classCallCheck(this, FontStyleButtonsModal);

        return _possibleConstructorReturn(this, (FontStyleButtonsModal.__proto__ || Object.getPrototypeOf(FontStyleButtonsModal)).call(this, props));
    }

    _createClass(FontStyleButtonsModal, [{
        key: 'onFontSelectClick',
        value: function onFontSelectClick(fontKey, regularFontKey, boldFontKey, italicFontKey, boldItalicFontKey, e) {
            e.preventDefault();
            var selectedKey = this.props.selectedValue;
            if (fontKey == boldFontKey) {
                if (selectedKey == regularFontKey) {
                    selectedKey = boldFontKey;
                } else if (selectedKey == boldFontKey) {
                    selectedKey = regularFontKey;
                } else if (selectedKey == italicFontKey) {
                    selectedKey = !!boldItalicFontKey ? boldItalicFontKey : boldFontKey;
                } else if (selectedKey == boldItalicFontKey) {
                    selectedKey = italicFontKey;
                }
            } else if (fontKey == italicFontKey) {
                if (selectedKey == regularFontKey) {
                    selectedKey = italicFontKey;
                } else if (selectedKey == boldFontKey) {
                    selectedKey = !!boldItalicFontKey ? boldItalicFontKey : italicFontKey;
                } else if (selectedKey == italicFontKey) {
                    selectedKey = regularFontKey;
                } else if (selectedKey == boldItalicFontKey) {
                    selectedKey = boldFontKey;
                }
            }
            this.props.onFontSelect(selectedKey);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                selectedValue = _props.selectedValue,
                ffp = _props.ffp;

            var regularFontKey = _FontManager2.default.getRegularFontKey(selectedValue);
            var italicFontKey = _FontManager2.default.getItalicFontKey(selectedValue);
            var boldFontKey = _FontManager2.default.getBoldFontKey(selectedValue);
            var boldItalicFontKey = _FontManager2.default.getBoldItalicFontKey(selectedValue);

            return _react2.default.createElement('div', { className: 'button-box' }, _react2.default.createElement('div', { className: 'control-group' }, _react2.default.createElement('div', { className: 'form-control custom-input style-options' }, _react2.default.createElement('div', { onClick: function onClick(e) {
                    return _this2.onFontSelectClick(boldFontKey, regularFontKey, boldFontKey, italicFontKey, boldItalicFontKey, e);
                },
                title: 'Bold', key: 'bold', className: (0, _classnames2.default)({ "click-disable": !boldFontKey })
            }, _react2.default.createElement('input', { type: 'checkbox', id: 'style-checkbox-2-' + ffp, value: 'BOLD',
                checked: selectedValue === (!!boldFontKey ? boldFontKey : "") || selectedValue === (!!boldItalicFontKey ? boldItalicFontKey : "")
            }), _react2.default.createElement('label', { htmlFor: 'style-checkbox-2-' + ffp }, _react2.default.createElement('span', { className: (0, _classnames2.default)("bold-button", { "line-through": !boldFontKey }) }, '\xA0B\xA0'))), _react2.default.createElement('div', { onClick: function onClick(e) {
                    return _this2.onFontSelectClick(italicFontKey, regularFontKey, boldFontKey, italicFontKey, boldItalicFontKey, e);
                },
                title: 'Italic', key: 'italic', className: (0, _classnames2.default)({ "click-disable": !italicFontKey })
            }, _react2.default.createElement('input', { type: 'checkbox', id: 'style-checkbox-3-' + ffp, value: 'ITALIC',
                checked: selectedValue === (!!italicFontKey ? italicFontKey : "") || selectedValue === (!!boldItalicFontKey ? boldItalicFontKey : "")
            }), _react2.default.createElement('label', { htmlFor: 'style-checkbox-3-' + ffp }, _react2.default.createElement('span', { className: (0, _classnames2.default)("italic-button", { "line-through": !italicFontKey }) }, '\xA0I\xA0'))))));
        }
    }]);

    return FontStyleButtonsModal;
}(_react.Component);

FontStyleButtonsModal.propTypes = {
    selectedValue: _propTypes2.default.string.isRequired,
    onFontSelect: _propTypes2.default.func.isRequired,
    ffp: _propTypes2.default.string
};
FontStyleButtonsModal.defaultProps = {
    ffp: 'fontFam'
};
exports.default = FontStyleButtonsModal;

},{"../../common/utils/FontManager":76,"classnames":410,"prop-types":896,"react":1107}],142:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _HoverMixin = require('../mixins/HoverMixin.react');

var _HoverMixin2 = _interopRequireDefault(_HoverMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var HoverDivInner = function (_Component) {
    _inherits(HoverDivInner, _Component);

    function HoverDivInner() {
        _classCallCheck(this, HoverDivInner);

        return _possibleConstructorReturn(this, (HoverDivInner.__proto__ || Object.getPrototypeOf(HoverDivInner)).apply(this, arguments));
    }

    _createClass(HoverDivInner, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                hovering = _props.hovering,
                onHover = _props.onHover,
                cbRef = _props.cbRef,
                otherProps = _objectWithoutProperties(_props, ['className', 'children', 'hovering', 'onHover', 'cbRef']);

            var clsName = (0, _classnames2.default)(className, {
                'hovering': hovering
            });

            return _react2.default.createElement('div', _extends({ className: clsName,
                ref: cbRef
            }, otherProps), children);
        }
    }]);

    return HoverDivInner;
}(_react.Component);

HoverDivInner.propTypes = {
    hovering: _propTypes2.default.bool.isRequired,
    cbRef: _propTypes2.default.func
};
HoverDivInner.defaultProps = {
    cbRef: function cbRef() {/* no-op */}
};

var HoverDiv = (0, _HoverMixin2.default)(HoverDivInner);

exports.default = HoverDiv;

},{"../mixins/HoverMixin.react":151,"classnames":410,"prop-types":896,"react":1107}],143:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var LetterSpacingSliderInner = function (_Component) {
    _inherits(LetterSpacingSliderInner, _Component);

    function LetterSpacingSliderInner(props) {
        _classCallCheck(this, LetterSpacingSliderInner);

        var _this = _possibleConstructorReturn(this, (LetterSpacingSliderInner.__proto__ || Object.getPrototypeOf(LetterSpacingSliderInner)).call(this, props));

        _this.dragData = {};
        _this._letterSpacingValue = _this.props.selectedLetterSpacing;
        _this._lastKnownLetterSpacingValue = _this.props.selectedLetterSpacing;
        return _this;
    }

    _createClass(LetterSpacingSliderInner, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._interval = setInterval(function () {
                return _this2._onTimer();
            }, 30);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this._interval);
        }
    }, {
        key: '_onTimer',
        value: function _onTimer() {
            this._fireCurrentLetterSpacingChange();
        }
    }, {
        key: '_fireCurrentLetterSpacingChange',
        value: function _fireCurrentLetterSpacingChange() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var newLetterSpacingValue = this._letterSpacingValue;
            if (force === true || this._lastKnownLetterSpacingValue != newLetterSpacingValue) {
                this._lastKnownLetterSpacingValue = newLetterSpacingValue;
                this.props.onLetterSpacingChangeIncremental(newLetterSpacingValue);
            }
        }
    }, {
        key: 'onPureClick',
        value: function onPureClick(e, clickLeftPercent) {
            this._letterSpacingValue = this.props.minLetterSpacing + clickLeftPercent * 10;
            this.props.onLetterSpacingChangeFinish(this._letterSpacingValue, this.props.selectedLetterSpacing);
            e.preventDefault();
        }
    }, {
        key: 'onDragStart',
        value: function onDragStart(e) {
            var dragPosition = this.props.minLetterSpacing + this.props.dragState.dragLeftPercent * 10;
            this._letterSpacingValue = dragPosition;
            this._startLetterSpacingValue = this.props.selectedLetterSpacing;
        }
    }, {
        key: 'onDragMove',
        value: function onDragMove(deltaX, deltaY) {
            var dragPosition = this.props.minLetterSpacing + this.props.dragState.dragLeftPercent * 10;
            this._letterSpacingValue = dragPosition;
        }
    }, {
        key: 'onDragEnd',
        value: function onDragEnd() {

            this.props.onLetterSpacingChangeFinish(this._letterSpacingValue, this._startLetterSpacingValue);
            this._startLetterSpacingValue = -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                dragCallbacks = _props.dragCallbacks,
                minLetterSpacing = _props.minLetterSpacing;

            var sliderLeft = Math.round((this.props.selectedLetterSpacing - minLetterSpacing) / 10);

            var cursorStyles = {
                left: Math.min(Math.max(0, sliderLeft), 100) + '%'
            };

            return _react2.default.createElement('div', { className: 'letter-spacing-slider-container',
                ref: dragCallbacks.refTrack,
                onMouseUp: dragCallbacks.onTrackMouseUp,
                onMouseDown: dragCallbacks.onTrackMouseDown }, _react2.default.createElement('div', { className: 'letter-spacing-slider',
                ref: function ref(c) {
                    _this3.sliderArea = c;
                }
            }, _react2.default.createElement('div', { className: 'letter-spacing-slider-cursor',
                ref: function ref(c) {
                    _this3.cursor = c;
                },
                onMouseDown: dragCallbacks.onHandleMouseDown,
                style: cursorStyles
            }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 12 12', preserveAspectRatio: 'none' }, _react2.default.createElement('circle', { cx: '6', cy: '6', r: '5', strokeWidth: '2', stroke: '#A5A5A5',
                fill: '#fff' })))));
        }
    }]);

    return LetterSpacingSliderInner;
}(_react.Component);

LetterSpacingSliderInner.propTypes = {
    selectedLetterSpacing: _propTypes2.default.number.isRequired,
    minLetterSpacing: _propTypes2.default.number.isRequired,
    onLetterSpacingChangeIncremental: _propTypes2.default.func.isRequired,
    onLetterSpacingChangeFinish: _propTypes2.default.func.isRequired,
    dragState: _propTypes2.default.object,
    dragCallbacks: _propTypes2.default.object
};

var LetterSpacingSlider = (0, _ClickDragMixin2.default)(LetterSpacingSliderInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false
});

exports.default = LetterSpacingSlider;

},{"../mixins/ClickDragMixin.react":150,"prop-types":896,"react":1107}],144:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var LineHeightSliderInner = function (_Component) {
    _inherits(LineHeightSliderInner, _Component);

    function LineHeightSliderInner(props) {
        _classCallCheck(this, LineHeightSliderInner);

        var _this = _possibleConstructorReturn(this, (LineHeightSliderInner.__proto__ || Object.getPrototypeOf(LineHeightSliderInner)).call(this, props));

        _this.dragData = {};
        _this._lineHeightValue = _this.props.selectedLineHeight;
        _this._lastKnownLineHeightValue = _this.props.selectedLineHeight;
        return _this;
    }

    _createClass(LineHeightSliderInner, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._interval = setInterval(function () {
                return _this2._onTimer();
            }, 30);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this._interval);
        }
    }, {
        key: '_onTimer',
        value: function _onTimer() {
            this._fireCurrentLineHeightChange();
        }
    }, {
        key: '_fireCurrentLineHeightChange',
        value: function _fireCurrentLineHeightChange() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var newLineHeightValue = this._lineHeightValue;
            if (force === true || this._lastKnownLineHeightValue != newLineHeightValue) {
                this._lastKnownLineHeightValue = newLineHeightValue;
                this.props.onLineHeightChangeIncremental(newLineHeightValue);
            }
        }
    }, {
        key: 'onPureClick',
        value: function onPureClick(e, clickLeftPercent) {
            this._lineHeightValue = this.props.minLineHeight + 2 * clickLeftPercent / 100;
            this.props.onLineHeightChangeFinish(this._lineHeightValue, this.props.selectedLineHeight);
            e.preventDefault();
        }
    }, {
        key: 'onDragStart',
        value: function onDragStart(e) {
            var dragPosition = this.props.minLineHeight + 2 * (this.props.dragState.dragLeftPercent / 100);
            this._lineHeightValue = dragPosition;
            this._startLineHeightValue = this.props.selectedLineHeight;
        }
    }, {
        key: 'onDragMove',
        value: function onDragMove(deltaX, deltaY) {
            var dragPosition = this.props.minLineHeight + 2 * (this.props.dragState.dragLeftPercent / 100);
            this._lineHeightValue = dragPosition;
        }
    }, {
        key: 'onDragEnd',
        value: function onDragEnd() {

            this.props.onLineHeightChangeFinish(this._lineHeightValue, this._startLineHeightValue);
            this._startLineHeightValue = -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                dragCallbacks = _props.dragCallbacks,
                minLineHeight = _props.minLineHeight;

            var sliderLeft = Math.round((this.props.selectedLineHeight - minLineHeight) / 2 * 100);

            var cursorStyles = {
                left: Math.min(Math.max(0, sliderLeft), 100) + '%'
            };

            return _react2.default.createElement('div', { className: 'line-height-slider-container',
                ref: dragCallbacks.refTrack,
                onMouseUp: dragCallbacks.onTrackMouseUp,
                onMouseDown: dragCallbacks.onTrackMouseDown }, _react2.default.createElement('div', { className: 'line-height-slider',
                ref: function ref(c) {
                    _this3.sliderArea = c;
                }
            }, _react2.default.createElement('div', { className: 'line-height-slider-cursor',
                ref: function ref(c) {
                    _this3.cursor = c;
                },
                onMouseDown: dragCallbacks.onHandleMouseDown,
                style: cursorStyles
            }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 12 12', preserveAspectRatio: 'none' }, _react2.default.createElement('circle', { cx: '6', cy: '6', r: '5', strokeWidth: '2', stroke: '#A5A5A5',
                fill: '#fff' })))));
        }
    }]);

    return LineHeightSliderInner;
}(_react.Component);

LineHeightSliderInner.propTypes = {
    selectedLineHeight: _propTypes2.default.number.isRequired,
    minLineHeight: _propTypes2.default.number.isRequired,
    onLineHeightChangeIncremental: _propTypes2.default.func.isRequired,
    onLineHeightChangeFinish: _propTypes2.default.func.isRequired,
    dragState: _propTypes2.default.object,
    dragCallbacks: _propTypes2.default.object
};

var LineHeightSlider = (0, _ClickDragMixin2.default)(LineHeightSliderInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false
});

exports.default = LineHeightSlider;

},{"../mixins/ClickDragMixin.react":150,"prop-types":896,"react":1107}],145:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _OpacitySlider = require('./OpacitySlider.react');

var _OpacitySlider2 = _interopRequireDefault(_OpacitySlider);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var OpacitySelect = function (_Component) {
    _inherits(OpacitySelect, _Component);

    function OpacitySelect(props) {
        _classCallCheck(this, OpacitySelect);

        var _this = _possibleConstructorReturn(this, (OpacitySelect.__proto__ || Object.getPrototypeOf(OpacitySelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(OpacitySelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                value = _props.value,
                onOpacityChangeIncremental = _props.onOpacityChangeIncremental,
                onOpacityChangeFinish = _props.onOpacityChangeFinish,
                otherProps = _objectWithoutProperties(_props, ['value', 'onOpacityChangeIncremental', 'onOpacityChangeFinish']);

            var iconId = 'opacity';

            var opacitySliderOuter = null;

            var opacityValue = Math.max(0, Math.min(100, Math.round(value * 100)));

            if (this.state.open) {
                opacitySliderOuter = _react2.default.createElement('div', { className: 'opacity-slider-outer' }, _react2.default.createElement('div', { className: 'opacity-slider-label' }, 'Opacity'), _react2.default.createElement(_OpacitySlider2.default, { selectedOpacity: value,
                    onOpacityChangeIncremental: onOpacityChangeIncremental,
                    onOpacityChangeFinish: onOpacityChangeFinish
                }), _react2.default.createElement('div', { className: 'opacity-slider-value-label' }, opacityValue, '%'));
            }

            return _react2.default.createElement('div', { className: 'opacity-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement('div', _extends({ className: 'opacity-select-button',
                ref: function ref(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps), _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: iconId })), opacitySliderOuter);
        }
    }]);

    return OpacitySelect;
}(_react.Component);

OpacitySelect.propTypes = {
    value: _propTypes2.default.number.isRequired,
    onOpacityChangeIncremental: _propTypes2.default.func.isRequired,
    onOpacityChangeFinish: _propTypes2.default.func.isRequired
};
exports.default = OpacitySelect;

},{"../../common/components/SVGIcon.react":13,"./OpacitySlider.react":146,"prop-types":896,"react":1107}],146:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var OpacitySliderInner = function (_Component) {
    _inherits(OpacitySliderInner, _Component);

    function OpacitySliderInner(props) {
        _classCallCheck(this, OpacitySliderInner);

        var _this = _possibleConstructorReturn(this, (OpacitySliderInner.__proto__ || Object.getPrototypeOf(OpacitySliderInner)).call(this, props));

        _this.dragData = {};
        _this._opacityValue = _this.props.selectedOpacity;
        _this._lastKnownOpacityValue = _this.props.selectedOpacity;
        return _this;
    }

    _createClass(OpacitySliderInner, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._interval = setInterval(function () {
                return _this2._onTimer();
            }, 30);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this._interval);
        }
    }, {
        key: '_onTimer',
        value: function _onTimer() {
            this._fireCurrentOpacityChange();
        }
    }, {
        key: '_fireCurrentOpacityChange',
        value: function _fireCurrentOpacityChange() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var newOpacityValue = this._opacityValue;
            if (force === true || this._lastKnownOpacityValue != newOpacityValue) {
                this._lastKnownOpacityValue = newOpacityValue;
                this.props.onOpacityChangeIncremental(newOpacityValue);
            }
        }
    }, {
        key: 'onPureClick',
        value: function onPureClick(e, clickLeftPercent) {
            this._opacityValue = clickLeftPercent / 100;
            this.props.onOpacityChangeFinish(this._opacityValue, this.props.selectedOpacity);
            e.preventDefault();
        }
    }, {
        key: 'onDragStart',
        value: function onDragStart(e) {
            var dragPosition = this.props.dragState.dragLeftPercent / 100;
            this._opacityValue = dragPosition;
            this._startOpacityValue = this.props.selectedOpacity;
        }
    }, {
        key: 'onDragMove',
        value: function onDragMove(deltaX, deltaY) {
            var dragPosition = this.props.dragState.dragLeftPercent / 100;
            this._opacityValue = dragPosition;
        }
    }, {
        key: 'onDragEnd',
        value: function onDragEnd() {

            this.props.onOpacityChangeFinish(this._opacityValue, this._startOpacityValue);
            this._startOpacityValue = -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var dragCallbacks = this.props.dragCallbacks;

            var sliderLeft = Math.round(this.props.selectedOpacity * 100);

            var cursorStyles = {
                left: Math.min(Math.max(0, sliderLeft), 100) + '%'
            };

            return _react2.default.createElement('div', { className: 'opacity-slider-container',
                ref: dragCallbacks.refTrack,
                onMouseUp: dragCallbacks.onTrackMouseUp,
                onMouseDown: dragCallbacks.onTrackMouseDown }, _react2.default.createElement('div', { className: 'opacity-slider',
                ref: function ref(c) {
                    _this3.sliderArea = c;
                }
            }, _react2.default.createElement('div', { className: 'opacity-slider-cursor',
                ref: function ref(c) {
                    _this3.cursor = c;
                },
                onMouseDown: dragCallbacks.onHandleMouseDown,
                style: cursorStyles
            }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 12 12', preserveAspectRatio: 'none' }, _react2.default.createElement('circle', { cx: '6', cy: '6', r: '5', strokeWidth: '2', stroke: '#A5A5A5',
                fill: '#fff' })))));
        }
    }]);

    return OpacitySliderInner;
}(_react.Component);

OpacitySliderInner.propTypes = {
    selectedOpacity: _propTypes2.default.number.isRequired,
    onOpacityChangeIncremental: _propTypes2.default.func.isRequired,
    onOpacityChangeFinish: _propTypes2.default.func.isRequired,
    dragState: _propTypes2.default.object,
    dragCallbacks: _propTypes2.default.object
};

var OpacitySlider = (0, _ClickDragMixin2.default)(OpacitySliderInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false
});

exports.default = OpacitySlider;

},{"../mixins/ClickDragMixin.react":150,"prop-types":896,"react":1107}],147:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMeasure = require('react-measure');

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _emojiMart = require('emoji-mart');

var _FontFamilySelect = require('./FontFamilySelect.react');

var _FontFamilySelect2 = _interopRequireDefault(_FontFamilySelect);

var _EmojiSelect = require('./EmojiSelect.react');

var _EmojiSelect2 = _interopRequireDefault(_EmojiSelect);

var _AlignmentSelect = require('./AlignmentSelect.react');

var _AlignmentSelect2 = _interopRequireDefault(_AlignmentSelect);

var _CropSelect = require('./CropSelect.react');

var _CropSelect2 = _interopRequireDefault(_CropSelect);

var _ColorSelect = require('./ColorSelect.react');

var _ColorSelect2 = _interopRequireDefault(_ColorSelect);

var _CounterSelect = require('./CounterSelect.react');

var _CounterSelect2 = _interopRequireDefault(_CounterSelect);

var _AnimationSelect = require('./AnimationSelect.react');

var _AnimationSelect2 = _interopRequireDefault(_AnimationSelect);

var _OpacitySelect = require('./OpacitySelect.react');

var _OpacitySelect2 = _interopRequireDefault(_OpacitySelect);

var _TextOptionSelect = require('./TextOptionSelect.react');

var _TextOptionSelect2 = _interopRequireDefault(_TextOptionSelect);

var _ShadowSelect = require('./ShadowSelect.react');

var _ShadowSelect2 = _interopRequireDefault(_ShadowSelect);

var _CountTimerTypeSelect = require('./CountTimerTypeSelect.react');

var _CountTimerTypeSelect2 = _interopRequireDefault(_CountTimerTypeSelect);

var _ColorSelectGroup = require('../../common/components/colorselect/ColorSelectGroup.react');

var _ColorSelectGroup2 = _interopRequireDefault(_ColorSelectGroup);

var _ColorRange = require('../../common/utils/ColorRange');

var _ColorRange2 = _interopRequireDefault(_ColorRange);

var _HighlightColorRange = require('../../common/utils/HighlightColorRange');

var _HighlightColorRange2 = _interopRequireDefault(_HighlightColorRange);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var fontFamilyProps = function fontFamilyProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'fontfamily';
    });
};
var colorProps = function colorProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'color';
    });
};
var textColorProps = function textColorProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'textColor';
    });
};
var highlightColorProps = function highlightColorProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'highlightColor';
    });
};
var highlightTextColorProps = function highlightTextColorProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'highlightTextColor';
    });
};
var alphaProps = function alphaProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'alpha';
    });
};
var shadowProps = function shadowProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'shadow';
    });
};
var alignmentProps = function alignmentProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'align';
    });
};
var cropProps = function cropProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'crop';
    });
};
var lineHeightProps = function lineHeightProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'lineHeight';
    });
};
var letterSpacingProps = function letterSpacingProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'letterSpacing';
    });
};
var textProps = function textProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'text';
    });
};
var emojiProps = function emojiProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'emojiId';
    });
};
var ascendingTimerProps = function ascendingTimerProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'isAscendingTimer';
    });
};

var showAnimationOptions = function showAnimationOptions(overlays) {
    return !Object.keys(overlays).map(function (oid) {
        return getTemplateDefForId(overlays[oid].defId);
    }).find(function (def) {
        return !def.meta.canOverrideAnimation;
    });
};

var showAnimationSpeedOptions = function showAnimationSpeedOptions(overlays) {
    return !Object.keys(overlays).map(function (oid) {
        return getTemplateDefForId(overlays[oid].defId);
    }).find(function (def) {
        return !def.meta.canOverrideAnimationSpeed;
    });
};

var showCounterSelectOptions = function showCounterSelectOptions(overlays) {
    return !Object.keys(overlays).map(function (oid) {
        return getTemplateDefForId(overlays[oid].defId);
    }).find(function (def) {
        return !def.meta.containsCounter;
    });
};

var getSingleItem = function getSingleItem(dict) {
    return Object.keys(dict).map(function (key) {
        return { key: key, value: dict[key] };
    })[0];
};

var EMOJI_IMAGE_ID_PREFIX = 'emoji_';

var LETTER_SPACING_DEFAULT = 0;
var LINE_HEIGHT_DEFAULT = 1.5;
var BAR_WIDTH_RIGHT_MARGIN = 250;

var PropertiesBar = function (_Component) {
    _inherits(PropertiesBar, _Component);

    function PropertiesBar(props) {
        _classCallCheck(this, PropertiesBar);

        var _this = _possibleConstructorReturn(this, (PropertiesBar.__proto__ || Object.getPrototypeOf(PropertiesBar)).call(this, props));

        _this.state = { dimensions: { width: BAR_WIDTH_RIGHT_MARGIN, height: -1 } };
        return _this;
    }

    _createClass(PropertiesBar, [{
        key: 'updateVariantObject',
        value: function updateVariantObject(overlay, ffps) {
            var variant = {};
            if (ffps.length > 0) {
                ffps.forEach(function (ffp) {
                    var selectedFontFamily = overlay.values[ffp];
                    variant[ffp] = _FontManager2.default.getVariantObject(selectedFontFamily);
                });
            }
            this.props.onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                variant: variant
            }), overlay);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var newOverlaysList = Object.keys(this.props.overlays);
            var prevOverlaysList = Object.keys(prevProps.overlays);
            if (newOverlaysList.length > prevOverlaysList.length) {
                var overlays = this.props.overlays;

                var noOfNewOverlays = newOverlaysList.length - prevOverlaysList.length;
                for (var i = 0; i < noOfNewOverlays; i++) {
                    var overlay = overlays[newOverlaysList[newOverlaysList.length - (1 + i)]];
                    var def = getTemplateDefForId(overlay.defId);
                    var ffps = fontFamilyProps(def);
                    this.updateVariantObject(overlay, ffps);
                }
            }
        }
    }, {
        key: 'expandNodes',
        value: function expandNodes(items) {
            var _this2 = this;

            var isgroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var expandedNodes = [];
            items.forEach(function (item, i) {
                if (Array.isArray(item)) {
                    var nodes = _this2.expandNodes(item, true);
                    expandedNodes = [].concat(_toConsumableArray(expandedNodes), _toConsumableArray(nodes));
                } else {
                    expandedNodes.push(item);
                }
                if (i !== items.length - 1) {
                    var sepClsName = (0, _classnames2.default)('separator', {
                        'group': isgroup
                    });
                    expandedNodes.push(_react2.default.createElement('div', { key: Math.floor(Math.random() * 10000) + '', className: sepClsName }));
                }
            });
            return expandedNodes;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var barWidth = this.state.dimensions.width;
            var _props = this.props,
                canvasWidth = _props.canvas.width,
                displayScale = _props.displayScale,
                isOverlayMode = _props.isOverlayMode,
                isPlaying = _props.isPlaying,
                isCropping = _props.isCropping,
                projectDuration = _props.projectDuration;
            var _props2 = this.props,
                selectedOverlays = _props2.selectedOverlays,
                overlaymeta = _props2.overlaymeta,
                currentFocus = _props2.currentFocus,
                selectedRect = _props2.selectedRect,
                projectColors = _props2.projectColors,
                brandColors = _props2.brandColors,
                recentColors = _props2.recentColors,
                overlays = _props2.overlays;
            var _props3 = this.props,
                onDelete = _props3.onDelete,
                onCopy = _props3.onCopy,
                onSelectColor = _props3.onSelectColor,
                onOverlayChangeIncremental = _props3.onOverlayChangeIncremental,
                onOverlayChangeFinish = _props3.onOverlayChangeFinish,
                onDisableOverlayMovement = _props3.onDisableOverlayMovement;
            var _props4 = this.props,
                onSetOutTimeFinish = _props4.onSetOutTimeFinish,
                onSetGroupAnimation = _props4.onSetGroupAnimation,
                onAnimationTypeChange = _props4.onAnimationTypeChange,
                onAnimationDurationChange = _props4.onAnimationDurationChange,
                onAnimationManualModeChange = _props4.onAnimationManualModeChange;
            var _props5 = this.props,
                disableCopy = _props5.disableCopy,
                disableDelete = _props5.disableDelete,
                isPaidWorkspace = _props5.isPaidWorkspace,
                isDemo = _props5.isDemo,
                activeWorkspace = _props5.activeWorkspace,
                _openFontUploadModal = _props5.openFontUploadModal;

            var anySelected = Object.keys(selectedOverlays).length > 0;
            var multiSelected = Object.keys(selectedOverlays).length > 1;

            if (!anySelected || isPlaying || !isOverlayMode || isCropping) {
                return null;
            }

            var _getSingleItem = getSingleItem(selectedOverlays),
                overlay = _getSingleItem.value;

            var propertyNodes = [];

            var def = getTemplateDefForId(overlay.defId);

            var ffps = fontFamilyProps(def);
            var cps = colorProps(def);
            var tcps = textColorProps(def);
            var hcps = highlightColorProps(def);
            var htcps = highlightTextColorProps(def);
            var ops = alphaProps(def);
            var lhps = lineHeightProps(def);
            var lsps = letterSpacingProps(def);
            var aps = alignmentProps(def);
            var crps = cropProps(def);
            var shdps = shadowProps(def);
            var tps = textProps(def);
            var eps = emojiProps(def);
            var ctps = ascendingTimerProps(def);

            var _def$meta = def.meta,
                _def$meta$textEditors = _def$meta.textEditors,
                textEditors = _def$meta$textEditors === undefined ? {} : _def$meta$textEditors,
                _def$meta$textColors = _def$meta.textColors,
                textColorMap = _def$meta$textColors === undefined ? {} : _def$meta$textColors,
                _def$meta$highlightCo = _def$meta.highlightColors,
                highlightColorPropMap = _def$meta$highlightCo === undefined ? {} : _def$meta$highlightCo;

            // Counter Timer options

            if (Object.keys(selectedOverlays).length === 1 && showCounterSelectOptions(selectedOverlays)) {
                var _overlay$time = overlay.time,
                    enterstart = _overlay$time.enterstart,
                    exitdone = _overlay$time.exitdone;

                var currentOverlayDuration = exitdone - enterstart;

                var onCounterDurationChange = function onCounterDurationChange(duration) {
                    //Atleast 1 sec and max project duration
                    var newDuration = Math.min(projectDuration, Math.max(1, enterstart + duration));
                    onSetOutTimeFinish(newDuration, currentOverlayDuration);
                };
                var maxCounterValue = Math.ceil((projectDuration - enterstart) / 1000);

                propertyNodes.push(_react2.default.createElement(_CounterSelect2.default, { title: 'Counter Duration',
                    maxCounterValue: maxCounterValue,
                    onDisableOverlayMovement: onDisableOverlayMovement,
                    currentDuration: currentOverlayDuration,
                    selectedOverlays: selectedOverlays,
                    onCounterDurationChange: onCounterDurationChange
                }));
            }

            // Timer type: ascending or descending
            if (!multiSelected && ctps.length > 0) {
                var _ctps = _slicedToArray(ctps, 1),
                    ctp = _ctps[0];

                var isAscendingTimer = overlay.values[ctp];

                var onToggleTimerType = function onToggleTimerType() {
                    return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, ctp, !isAscendingTimer) }), (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, ctp, isAscendingTimer) }));
                };

                var counterTitle = isAscendingTimer ? 'Set Countdown Timer' : 'Set Countup Timer';

                propertyNodes.push(_react2.default.createElement(_CountTimerTypeSelect2.default, { key: 'prop-timer-type-select', title: counterTitle,
                    isAscendingTimer: isAscendingTimer,
                    onToggleTimerType: onToggleTimerType }));
            }

            // Some text options
            if (!multiSelected && ffps.length > 0 && !this.props.hideFontProps) {

                ffps.forEach(function (ffp, i) {
                    var selectedFontFamily = overlay.values[ffp];

                    var onFontSelect = function onFontSelect(value) {
                        return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                            values: _defineProperty({}, ffp, value),
                            variant: _defineProperty({}, ffp, _FontManager2.default.getVariantObject(value))
                        }), overlay);
                    };

                    propertyNodes.push(_react2.default.createElement(_FontFamilySelect2.default, { key: 'prop-fontFamily-' + ffp, selectedValue: selectedFontFamily,
                        title: 'Font',
                        isDemo: isDemo,
                        onFontSelect: onFontSelect,
                        isPaidWorkspace: isPaidWorkspace,
                        openFontUploadModal: function openFontUploadModal() {
                            return _openFontUploadModal(ffp);
                        },
                        activeWorkspace: activeWorkspace,
                        ffp: ffp
                    }));
                });
            }

            if (!multiSelected && eps.length > 0) {
                eps.forEach(function (ep, i) {
                    var selectedEmojiUnifiedCode = overlay.values[ep].substring(EMOJI_IMAGE_ID_PREFIX.length);
                    var selectedEmoji = getEmojiIdForImageId(selectedEmojiUnifiedCode);

                    var onEmojiSelect = function onEmojiSelect(emoji) {
                        return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                            values: _defineProperty({}, ep, '' + EMOJI_IMAGE_ID_PREFIX + emoji.unified.toLowerCase())
                        }), overlay);
                    };

                    propertyNodes.push(_react2.default.createElement(_EmojiSelect2.default, { key: 'prop-emoji-' + ep,
                        shouldShowEmoji: function shouldShowEmoji(emojiUnifiedCode) {
                            return !!getEmojiIdForImageId(emojiUnifiedCode);
                        },
                        selectedEmoji: selectedEmoji,
                        onEmojiSelect: onEmojiSelect }));
                });
            }

            // Alignment
            if (!multiSelected && aps.length > 0) {
                var _aps = _slicedToArray(aps, 1),
                    ap = _aps[0];

                var alignment = overlay.values[ap];

                var onAlignmentChange = function onAlignmentChange(value) {
                    return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                        values: _defineProperty({}, ap, value)
                    }), overlay);
                };

                propertyNodes.push(_react2.default.createElement(_AlignmentSelect2.default, { key: 'prop-alignment',
                    selectedMode: alignment,
                    title: 'Alignment',
                    onAlignmentChange: onAlignmentChange }));
            }

            // Crop
            if (!multiSelected && crps.length > 0) {
                var _crps = _slicedToArray(crps, 1),
                    crp = _crps[0];

                var crop = overlay.values[crp];

                var onCropChange = function onCropChange(value) {
                    return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                        values: _defineProperty({}, crp, value)
                    }), overlay);
                };

                propertyNodes.push(_react2.default.createElement(_CropSelect2.default, { key: 'prop-crop',
                    selectedMode: crop,
                    title: 'Crop',
                    onCropChange: onCropChange }));
            }

            // Color option(s)
            if (!multiSelected) {

                var editorTextLayerIdToTextPropsMap = {};
                Object.keys(textEditors).forEach(function (prop) {
                    var textLayerId = textEditors[prop];
                    editorTextLayerIdToTextPropsMap[textLayerId] = prop; // 't1' => 'text1' and so on.
                });

                var groupedColorProps = {};
                Object.keys(textColorMap).forEach(function (textProp) {
                    var textColorProp = textColorMap[textProp];
                    var textLayerId = textEditors[textProp];

                    pushToArrayAtKey(groupedColorProps, textLayerId, { type: 'textColor', prop: textColorProp, textProp: textProp });
                });
                Object.keys(highlightColorPropMap).forEach(function (textProp) {
                    var textLayerId = textEditors[textProp];

                    var obj = highlightColorPropMap[textProp];
                    var highlightColorProp = obj.highlight || null;
                    var highlightTextColorProp = obj.highlightText || null;

                    if (highlightColorProp) {
                        pushToArrayAtKey(groupedColorProps, textLayerId, { type: 'highlightColor', prop: highlightColorProp, textProp: textProp });
                    }
                });

                Object.keys(groupedColorProps).forEach(function (textLayerId) {
                    var layerProps = groupedColorProps[textLayerId];

                    var renderLayerProp = function renderLayerProp(_ref) {
                        var type = _ref.type,
                            prop = _ref.prop,
                            textProp = _ref.textProp;

                        var color = overlay.values[prop];

                        var colorRange = null,
                            selectedColor = null;
                        if (type === 'highlightColor' || type === 'highlightTextColor') {

                            colorRange = new _HighlightColorRange2.default(color);

                            if (!!currentFocus) {
                                selectedColor = colorRange.getColorForIndex(currentFocus.start);
                            }

                            selectedColor = selectedColor || '';
                        } else {
                            colorRange = new _ColorRange2.default(color);

                            selectedColor = colorRange.defaultColor;
                            if (!!currentFocus) {
                                selectedColor = colorRange.getColorForIndex(currentFocus.start);
                            }
                        }

                        var isCurrentTextSelected = !!currentFocus && currentFocus.layer.prop === textProp;

                        var onColorChange = function onColorChange(value, incremental) {
                            var startValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                            var colorVal = value,
                                startColorVal = startValue;

                            if (type === 'textColor') {
                                if (currentFocus && isCurrentTextSelected) {
                                    colorRange.addColor(value, currentFocus);
                                    colorVal = colorRange.toString();
                                }
                            } else if (type === 'highlightColor' || type === 'highlightTextColor') {
                                if (!!currentFocus && currentFocus.start === currentFocus.end && !colorRange.hasRangeAtIndex(currentFocus.start)) {

                                    var text = overlay.values[textProp];

                                    text = text.replace(/\n/g, ' ');

                                    text += ' ';

                                    var startWordIndex = text.lastIndexOf(' ', currentFocus.start) + 1;
                                    var endWordIndex = text.indexOf(' ', currentFocus.start);

                                    if (startWordIndex < endWordIndex) {
                                        colorRange.addColor(value, { start: startWordIndex, end: endWordIndex, length: currentFocus.length });
                                        colorVal = colorRange.toString();
                                    } else {
                                        // Don't do anything in this case. We have very little to go by
                                        return;
                                    }
                                } else {
                                    colorRange.addColor(value, currentFocus);
                                    colorVal = colorRange.toString();
                                }
                            }

                            if (incremental) {
                                onOverlayChangeIncremental((0, _deepmerge2.default)(overlay, {
                                    values: _defineProperty({}, prop, colorVal)
                                }));
                            } else {
                                onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                                    values: _defineProperty({}, prop, colorVal)
                                }), overlay);
                            }
                        };

                        return _react2.default.createElement(_ColorSelect2.default, { key: 'prop-color-' + prop, selectedColor: selectedColor,
                            title: 'Color', isTextColor: true, isCurrentTextSelected: isCurrentTextSelected,
                            colorRange: colorRange, currentFocus: currentFocus, onSelectColor: onSelectColor,
                            projectColors: projectColors, recentColors: recentColors, brandColors: brandColors,
                            onColorChangeIncremental: function onColorChangeIncremental(value) {
                                return onColorChange(value, true);
                            },
                            isPaidWorkspace: isPaidWorkspace, isDemo: isDemo,
                            onColorChangeFinish: function onColorChangeFinish(value, startValue) {
                                return onColorChange(value, false, startValue);
                            }
                        });
                    };

                    // layerProps.map(renderLayerProp).forEach(node => propertyNodes.push(node))

                    if (layerProps.length > 1) {
                        var colors = [];
                        layerProps.forEach(function (_ref2) {
                            var type = _ref2.type,
                                prop = _ref2.prop;

                            var color = overlay.values[prop];
                            if (type === 'highlightColor' || type === 'highlightTextColor') {
                                new _HighlightColorRange2.default(color).getSelectionColors().forEach(function (c) {
                                    return colors.push(c);
                                });
                            } else {
                                new _ColorRange2.default(color).getSelectionColors().forEach(function (c) {
                                    return colors.push(c);
                                });
                            }
                        });

                        var isCurrentTextSelected = !!layerProps.find(function (_ref3) {
                            var textProp = _ref3.textProp;
                            return !!currentFocus && currentFocus.layer.prop === textProp;
                        });

                        var onClearHighlights = function onClearHighlights() {

                            var newValues = {};
                            layerProps.filter(function (_ref4) {
                                var type = _ref4.type;
                                return type === 'highlightColor' || type === 'highlightTextColor';
                            }).forEach(function (_ref5) {
                                var prop = _ref5.prop;

                                newValues[prop] = '';
                            });

                            onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                                values: newValues
                            }), overlay);
                        };

                        propertyNodes.push(_react2.default.createElement(_ColorSelectGroup2.default, { key: 'prop-colorgroup-' + textLayerId,
                            colors: colors,
                            isCurrentTextSelected: isCurrentTextSelected,
                            layerProps: layerProps,
                            renderLayerProp: renderLayerProp,
                            onClearHighlights: onClearHighlights
                        }));
                    } else {
                        propertyNodes.push(renderLayerProp(layerProps[0]));
                    }
                });

                cps.forEach(function (cp) {

                    var selectedColor = overlay.values[cp];

                    var onColorChange = function onColorChange(value, incremental) {
                        var startValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                        if (incremental) {
                            onOverlayChangeIncremental((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, cp, value) }));
                        } else {
                            onOverlayChangeFinish((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, cp, value) }), (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, cp, startValue) }));
                        }
                    };
                    propertyNodes.push(_react2.default.createElement(_ColorSelect2.default, { key: 'prop-color-' + cp, selectedColor: selectedColor,
                        title: 'Color', isTextColor: false, projectColors: projectColors,
                        onSelectColor: onSelectColor, recentColors: recentColors, brandColors: brandColors,
                        onColorChangeIncremental: function onColorChangeIncremental(value) {
                            return onColorChange(value, true);
                        },
                        isPaidWorkspace: isPaidWorkspace, isDemo: isDemo,
                        onColorChangeFinish: function onColorChangeFinish(value, startValue) {
                            return onColorChange(value, false, startValue);
                        }
                    }));
                });
            }

            // Opacity
            if (!multiSelected && ops.length > 0) {
                var _ops = _slicedToArray(ops, 1),
                    op = _ops[0];

                var opacity = overlay.values[op];

                var onOpacityChangeIncremental = function onOpacityChangeIncremental(value) {
                    return onOverlayChangeIncremental((0, _deepmerge2.default)(overlay, {
                        values: _defineProperty({}, op, value)
                    }));
                };

                var onOpacityChangeFinish = function onOpacityChangeFinish(value, startValue) {
                    return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, op, value) }), (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, op, startValue) }));
                };

                propertyNodes.push(_react2.default.createElement(_OpacitySelect2.default, { key: 'prop-opacity-select', title: 'Opacity', value: opacity,
                    onOpacityChangeIncremental: onOpacityChangeIncremental,
                    onOpacityChangeFinish: onOpacityChangeFinish
                }));
            }

            // Shadow
            if (!multiSelected && shdps.length > 0) {
                var _shdps = _slicedToArray(shdps, 1),
                    shdp = _shdps[0];

                var shadow = overlay.values[shdp];

                var onToggleShadow = function onToggleShadow() {
                    return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, shdp, !shadow) }), (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, shdp, shadow) }));
                };

                propertyNodes.push(_react2.default.createElement(_ShadowSelect2.default, { key: 'prop-shadow-select', title: 'Text Shadow',
                    enabled: shadow,
                    onToggleShadow: onToggleShadow }));
            }

            // Show animation options for non-composites
            var canOverrideAnimation = showAnimationOptions(selectedOverlays);
            var canOverrideAnimationSpeedOnly = Object.keys(selectedOverlays).length === 1 && showAnimationSpeedOptions(selectedOverlays);
            if (canOverrideAnimation || canOverrideAnimationSpeedOnly) {

                var animNodes = [];
                animNodes.push(_react2.default.createElement(_AnimationSelect2.default, { key: 'prop-animation-enter', kind: 'enter', title: 'Entry Animation',
                    selectedOverlays: selectedOverlays,
                    overlaymeta: overlaymeta,
                    onSetGroupAnimation: onSetGroupAnimation,
                    onAnimationTypeChange: onAnimationTypeChange,
                    onAnimationDurationChange: onAnimationDurationChange,
                    onAnimationManualModeChange: onAnimationManualModeChange,
                    changeSpeedOnly: canOverrideAnimationSpeedOnly
                }));

                animNodes.push(_react2.default.createElement(_AnimationSelect2.default, { key: 'prop-animation-exit', kind: 'exit', title: 'Exit Animation',
                    selectedOverlays: selectedOverlays,
                    overlaymeta: overlaymeta,
                    onSetGroupAnimation: onSetGroupAnimation,
                    onAnimationTypeChange: onAnimationTypeChange,
                    onAnimationDurationChange: onAnimationDurationChange,
                    onAnimationManualModeChange: onAnimationManualModeChange,
                    changeSpeedOnly: canOverrideAnimationSpeedOnly
                }));

                propertyNodes.push(animNodes);
            }

            if (!disableCopy) {
                // Some common options
                propertyNodes.push(_react2.default.createElement('div', { key: 'prop-copy', className: 'copy', title: 'Copy', onClick: function onClick() {
                        return onCopy();
                    } }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'copy' })));
            }

            if (!disableDelete) {
                propertyNodes.push(_react2.default.createElement('div', { key: 'prop-delete', className: 'delete', title: 'Delete', onClick: function onClick() {
                        return onDelete();
                    } }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'delete-overlay' })));
            }

            if (!multiSelected && (lsps.length > 0 || lhps.length > 0 || ffps.length > 0)) {
                propertyNodes.push(_react2.default.createElement(_TextOptionSelect2.default, { key: 'prop-text-option-select', title: 'Text Options',
                    overlay: overlay, letterSpacingProps: lsps, lineHeightProps: lhps, textProps: tps, fontFamilyProps: ffps,
                    onOverlayChangeIncremental: onOverlayChangeIncremental,
                    onOverlayChangeFinish: onOverlayChangeFinish
                }));
            }

            var allNodes = this.expandNodes(propertyNodes);

            var maxLeft = canvasWidth * displayScale - barWidth + 20;
            var propertyBarStyles = {
                left: Math.min(maxLeft, selectedRect.x * displayScale) + 'px',
                top: selectedRect.y * displayScale + 'px'
            };

            return _react2.default.createElement(_reactMeasure2.default, {
                bounds: true,
                onResize: function onResize(contentRect) {
                    _this3.setState({ dimensions: contentRect.bounds });
                }
            }, function (_ref6) {
                var measureRef = _ref6.measureRef;
                return _react2.default.createElement('div', { className: 'properties-bar',
                    style: propertyBarStyles,
                    ref: measureRef
                }, allNodes);
            });
        }
    }]);

    return PropertiesBar;
}(_react.Component);

PropertiesBar.propTypes = {
    displayScale: _propTypes2.default.number.isRequired,
    projectDuration: _propTypes2.default.number.isRequired,
    isOverlayMode: _propTypes2.default.bool.isRequired,
    selectedOverlays: _propTypes2.default.object.isRequired,
    overlaymeta: _propTypes2.default.object.isRequired,
    canvas: _propTypes2.default.object.isRequired,
    selectedRect: _propTypes2.default.object.isRequired,
    currentFocus: _propTypes2.default.object,
    onDelete: _propTypes2.default.func.isRequired,
    onCopy: _propTypes2.default.func.isRequired,
    projectColors: _propTypes2.default.array,
    recentColors: _propTypes2.default.array,
    brandColors: _propTypes2.default.array,
    onSelectColor: _propTypes2.default.func.isRequired,
    onOverlayChangeIncremental: _propTypes2.default.func.isRequired,
    onDisableOverlayMovement: _propTypes2.default.func.isRequired,
    onOverlayChangeFinish: _propTypes2.default.func.isRequired,
    onAnimationTypeChange: _propTypes2.default.func.isRequired,
    onAnimationDurationChange: _propTypes2.default.func.isRequired,
    onSetOutTimeFinish: _propTypes2.default.func.isRequired,
    onAnimationManualModeChange: _propTypes2.default.func.isRequired,
    onSetGroupAnimation: _propTypes2.default.func.isRequired,
    isPlaying: _propTypes2.default.bool.isRequired,
    disableDelete: _propTypes2.default.bool,
    disableCopy: _propTypes2.default.bool,
    isPaidWorkspace: _propTypes2.default.bool,
    hideFontProps: _propTypes2.default.bool,
    isDemo: _propTypes2.default.bool,
    overlays: _propTypes2.default.object.isRequired
};
PropertiesBar.defaultProps = {
    disableDelete: false,
    disableCopy: false,
    isDemo: false,
    hideFontProps: false
};
exports.default = PropertiesBar;

var pushToArrayAtKey = function pushToArrayAtKey(obj, key, value) {
    if (!obj[key]) {
        obj[key] = [];
    }
    obj[key].push(value);
};

},{"../../common/components/SVGIcon.react":13,"../../common/components/colorselect/ColorSelectGroup.react":19,"../../common/utils/ColorRange":71,"../../common/utils/FontManager":76,"../../common/utils/HighlightColorRange":78,"./AlignmentSelect.react":132,"./AnimationSelect.react":133,"./ColorSelect.react":134,"./CountTimerTypeSelect.react":135,"./CounterSelect.react":136,"./CropSelect.react":137,"./EmojiSelect.react":139,"./FontFamilySelect.react":140,"./OpacitySelect.react":145,"./ShadowSelect.react":148,"./TextOptionSelect.react":149,"classnames":410,"deepmerge":549,"emoji-mart":601,"prop-types":896,"react":1107,"react-measure":1030}],148:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ShadowSelect = function (_Component) {
    _inherits(ShadowSelect, _Component);

    function ShadowSelect() {
        _classCallCheck(this, ShadowSelect);

        return _possibleConstructorReturn(this, (ShadowSelect.__proto__ || Object.getPrototypeOf(ShadowSelect)).apply(this, arguments));
    }

    _createClass(ShadowSelect, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                enabled = _props.enabled,
                onToggleShadow = _props.onToggleShadow,
                otherProps = _objectWithoutProperties(_props, ['enabled', 'onToggleShadow']);

            var shadowIconClassname = (0, _classnames2.default)('shadow-icon', {
                'disabled': !enabled
            });

            return _react2.default.createElement('div', _extends({ className: 'shadow-select'
            }, otherProps), _react2.default.createElement('div', { className: shadowIconClassname,
                onClick: function onClick() {
                    return onToggleShadow();
                }
            }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'shadow' })));
        }
    }]);

    return ShadowSelect;
}(_react.Component);

ShadowSelect.propTypes = {
    enabled: _propTypes2.default.bool.isRequired,
    onToggleShadow: _propTypes2.default.func.isRequired
};
exports.default = ShadowSelect;

},{"../../common/components/SVGIcon.react":13,"classnames":410,"prop-types":896,"react":1107}],149:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _LetterSpacingSlider = require('./LetterSpacingSlider.react');

var _LetterSpacingSlider2 = _interopRequireDefault(_LetterSpacingSlider);

var _LineHeightSlider = require('./LineHeightSlider.react');

var _LineHeightSlider2 = _interopRequireDefault(_LineHeightSlider);

var _FontStyleButtonsModal = require('./FontStyleButtonsModal.react');

var _FontStyleButtonsModal2 = _interopRequireDefault(_FontStyleButtonsModal);

var _DefModel = require('../../common/utils/renderer/DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TextOptionSelect = function (_Component) {
    _inherits(TextOptionSelect, _Component);

    function TextOptionSelect(props) {
        _classCallCheck(this, TextOptionSelect);

        var _this = _possibleConstructorReturn(this, (TextOptionSelect.__proto__ || Object.getPrototypeOf(TextOptionSelect)).call(this, props));

        _this.state = { open: false };
        return _this;
    }

    _createClass(TextOptionSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var selectorRoot = $(this.selectorRoot);

            if ($(e.target).closest(selectorRoot).length) {

                var selectorButton = $(this.selectorButton);

                if ($(e.target).closest(selectorButton).length) {
                    this.setState({ open: !this.state.open });
                }
            } else {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'renderTextOptions',
        value: function renderTextOptions() {
            var _props = this.props,
                overlay = _props.overlay,
                letterSpacingProps = _props.letterSpacingProps,
                lineHeightProps = _props.lineHeightProps,
                textProps = _props.textProps,
                fontFamilyProps = _props.fontFamilyProps;
            var _props2 = this.props,
                onOverlayChangeIncremental = _props2.onOverlayChangeIncremental,
                onOverlayChangeFinish = _props2.onOverlayChangeFinish;

            var noOfTexts = Math.max(letterSpacingProps.length, lineHeightProps.length, fontFamilyProps.length);
            var templateDef = getTemplateDefForId(overlay.defId);

            var textOptions = [];

            var _loop = function _loop(textIndex) {
                var textFontFamilyProp = fontFamilyProps[textIndex];
                var styleButtonsOuter = null;
                if (!!textFontFamilyProp) {
                    var selectedFontFamily = overlay.values[textFontFamilyProp];
                    var onFontSelect = function onFontSelect(value) {
                        return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, {
                            values: _defineProperty({}, textFontFamilyProp, value),
                            variant: _defineProperty({}, textFontFamilyProp, _FontManager2.default.getVariantObject(value))
                        }), overlay);
                    };

                    styleButtonsOuter = _react2.default.createElement('div', { className: 'style-buttons-outer' }, _react2.default.createElement(_FontStyleButtonsModal2.default, { selectedValue: selectedFontFamily,
                        onFontSelect: onFontSelect,
                        ffp: textFontFamilyProp
                    }));
                }

                var textLetterSpacingProp = letterSpacingProps[textIndex];

                var letterSpacingSliderOuter = null;
                if (!!textLetterSpacingProp) {

                    var minLetterSpacing = -200,
                        maxLetterSpacing = 800;

                    var letterSpacing = overlay.values[textLetterSpacingProp] || templateDef.defaults[textLetterSpacingProp];
                    var letterSpacingValue = Math.max(minLetterSpacing, Math.min(maxLetterSpacing, Math.round(letterSpacing)));

                    var onLetterSpacingChangeIncremental = function onLetterSpacingChangeIncremental(value) {
                        return onOverlayChangeIncremental((0, _deepmerge2.default)(overlay, {
                            values: _defineProperty({}, textLetterSpacingProp, value)
                        }));
                    };

                    var onLetterSpacingChangeFinish = function onLetterSpacingChangeFinish(value, startValue) {
                        return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, textLetterSpacingProp, value) }), (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, textLetterSpacingProp, startValue) }));
                    };

                    letterSpacingSliderOuter = _react2.default.createElement('div', { className: 'letter-spacing-slider-outer', title: 'Letter Spacing' }, _react2.default.createElement('div', { className: 'letter-spacing-slider-label-container' }, _react2.default.createElement('div', { className: 'letter-spacing-slider-label' }, 'A'), _react2.default.createElement('div', { className: 'letter-spacing-slider-value-label' }, letterSpacingValue)), _react2.default.createElement(_LetterSpacingSlider2.default, { selectedLetterSpacing: letterSpacing,
                        minLetterSpacing: minLetterSpacing,
                        onLetterSpacingChangeIncremental: onLetterSpacingChangeIncremental,
                        onLetterSpacingChangeFinish: onLetterSpacingChangeFinish
                    }));
                }

                var textLineHeightProp = lineHeightProps[textIndex];

                var lineHeightSliderOuter = null;
                if (!!textLineHeightProp) {

                    var minLineHeight = 0.5,
                        maxLineHeight = 2.5;

                    var lineHeight = overlay.values[textLineHeightProp] || templateDef.defaults[textLineHeightProp];
                    var lineHeightValue = Math.max(minLineHeight, Math.min(maxLineHeight, +lineHeight.toFixed(2)));

                    var onLineHeightChangeIncremental = function onLineHeightChangeIncremental(value) {
                        return onOverlayChangeIncremental((0, _deepmerge2.default)(overlay, {
                            values: _defineProperty({}, textLineHeightProp, value)
                        }));
                    };

                    var onLineHeightChangeFinish = function onLineHeightChangeFinish(value, startValue) {
                        return onOverlayChangeFinish((0, _deepmerge2.default)(overlay, { values: _defineProperty({}, textLineHeightProp, value) }), (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, textLineHeightProp, startValue) }));
                    };

                    lineHeightSliderOuter = _react2.default.createElement('div', { className: 'line-height-slider-outer', title: 'Line Height' }, _react2.default.createElement('div', { className: 'line-height-slider-label-container' }, _react2.default.createElement('div', { className: 'line-height-slider-label' }, 'A'), _react2.default.createElement('div', { className: 'line-height-slider-value-label' }, lineHeightValue)), _react2.default.createElement(_LineHeightSlider2.default, { selectedLineHeight: lineHeight,
                        minLineHeight: minLineHeight,
                        onLineHeightChangeIncremental: onLineHeightChangeIncremental,
                        onLineHeightChangeFinish: onLineHeightChangeFinish
                    }));
                }

                var textLabel = 'TEXT ' + (textIndex + 1);
                var textProp = textProps[textIndex];
                var textContent = null;
                if (!!textProp) {
                    textContent = overlay.values[textProp];
                    if (!!textContent && textContent.length > 20) {
                        var text = textContent.substring(0, 20);
                        textContent = text + '...';
                    }
                }

                var sectionBreakNode = null;
                if (textIndex < noOfTexts - 1) {
                    sectionBreakNode = _react2.default.createElement('hr', null);
                }
                var textLabelNode = null;
                textLabelNode = _react2.default.createElement('div', { className: 'text-label' }, _react2.default.createElement('div', { className: 'left-content' }, textLabel), _react2.default.createElement('div', { className: 'right-content' }, textContent));

                textOptions.push(_react2.default.createElement('div', { key: 'text-option-' + textIndex }, textLabelNode, _react2.default.createElement('div', null, styleButtonsOuter, lineHeightSliderOuter, letterSpacingSliderOuter), sectionBreakNode));
            };

            for (var textIndex = 0; textIndex < noOfTexts; textIndex++) {
                _loop(textIndex);
            }
            return textOptions;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var otherProps = _objectWithoutProperties(this.props, []);

            var textOptionOuterClass = (0, _classnames2.default)('text-option-outer', {
                'hide': !this.state.open
            });

            return _react2.default.createElement('div', { className: 'text-option-select',
                ref: function ref(c) {
                    _this3.selectorRoot = c;
                }
            }, _react2.default.createElement('div', _extends({ className: 'text-option-select-button',
                ref: function ref(c) {
                    _this3.selectorButton = c;
                }
            }, otherProps), _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'more-dots' })), _react2.default.createElement('div', { className: textOptionOuterClass }, this.renderTextOptions()));
        }
    }]);

    return TextOptionSelect;
}(_react.Component);

TextOptionSelect.propTypes = {
    overlay: _propTypes2.default.object.isRequired,
    letterSpacingProps: _propTypes2.default.array.isRequired,
    lineHeightProps: _propTypes2.default.array.isRequired,
    textProps: _propTypes2.default.array.isRequired,
    onOverlayChangeIncremental: _propTypes2.default.func.isRequired,
    onOverlayChangeFinish: _propTypes2.default.func.isRequired,
    fontFamilyProps: _propTypes2.default.array.isRequired
};
exports.default = TextOptionSelect;

},{"../../common/components/SVGIcon.react":13,"../../common/utils/FontManager":76,"../../common/utils/renderer/DefModel":119,"./FontStyleButtonsModal.react":141,"./LetterSpacingSlider.react":143,"./LineHeightSlider.react":144,"classnames":410,"deepmerge":549,"prop-types":896,"react":1107}],150:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rafDebounce = require('../utils/rafDebounce');

var _rafDebounce2 = _interopRequireDefault(_rafDebounce);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT_PARAMS = {
    strictMouseDownTargetCheck: true,
    strictMouseUpTargetCheck: true,
    preventDefaultOnMouseDown: false,
    preventDefaultOnHandleMouseDown: true,

    debounceEvents: false,

    enableLogging: false

    // Usage Guide :
    // This mixin helps a component to detect a 'pure' click
    // ( i.e. without any dragging between mousedown and mouseup )
    // and also helps with drag behavior
    //
    // To use :
    // 1) attach 'clickDragMixinMouseDown' and 'clickDragMixinMouseUp' on the component
    // 2) override 'onPureClick()' to do something on pure click
    // 3) override 'onDragMove(deltaX, deltaY)' to respond to drag.
    //    deltaX, deltaY are the distances moved by the mouse since the drag started.
    // 4) By default, the mousedown and mouseup have strict checks to ignore if the event
    //    is in capture/bubbling phase ( only target phase is handled ). This is sometimes not desirable.
    //    This behavior can be controlled by defining a property on your component with name
    //    'clickDragMixinParams' as an object with optional properties 'strictMouseDownTargetCheck' and
    //    'strictMouseDownTargetCheck'. Setting these properties to false should help.

};var ClickDragMixin = function ClickDragMixin(ComposedComponent) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (_Component) {
        _inherits(_class, _Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.params = _extends({}, DEFAULT_PARAMS, params);
            _this.state = { dragging: false, dragLeftPercent: 0, rotating: false, startAngle: 0 };

            _this.track = null;
            _this.handle = null;

            _this._clickDragMixinDidMouseDown = false;
            _this._clickDragMixinDidDrag = false;
            _this._clickDragMixinDidRotate = false;
            _this._clickDragMixinFlagFireDragStart = false;
            _this._clickDragMixinFlagFireRotateStart = false;
            _this._clickDragMixinData = {};
            _this._clickDragMixinMouseMoveData = { lastX: 0, lastY: 0 };
            _this._startLeftPercent = 0;
            _this.R2D = 180 / Math.PI;
            return _this;
        }

        _createClass(_class, [{
            key: 'getClickDragMixinParamOrDefault',
            value: function getClickDragMixinParamOrDefault(param) {
                return this.params[param];
            }
        }, {
            key: 'isLoggingEnabled',
            value: function isLoggingEnabled() {
                return this.getClickDragMixinParamOrDefault('enableLogging');
            }
        }, {
            key: 'log',
            value: function log() {
                if (this.isLoggingEnabled()) {
                    console.log.apply(console, arguments);
                }
            }
        }, {
            key: 'debounceIfNeeded',
            value: function debounceIfNeeded(f) {
                var wrapFunc = function wrapFunc(fn) {
                    return fn;
                };

                if (this.getClickDragMixinParamOrDefault('debounceEvents')) {
                    wrapFunc = function wrapFunc(fn) {
                        return (0, _rafDebounce2.default)(fn);
                    };
                }
                return wrapFunc(f);
            }
        }, {
            key: '_windowMouseMove',
            value: function _windowMouseMove(e, isRotate) {

                this.log('windowMouseMove');

                if (e.clientX == this._clickDragMixinMouseMoveData.lastX && e.clientY == this._clickDragMixinMouseMoveData.lastY) {
                    return;
                }

                this._clickDragMixinMouseMoveData.lastX = e.clientX;
                this._clickDragMixinMouseMoveData.lastY = e.clientY;

                if (this._clickDragMixinFlagFireDragStart) {
                    this._clickDragMixinFlagFireDragStart = false;
                    this._onDragStart(e);
                } else if (this._clickDragMixinFlagFireRotateStart) {
                    this._clickDragMixinFlagFireRotateStart = false;
                    this._onRotateStart(e);
                }

                if (isRotate) {
                    this._clickDragMixinDidRotate = true;
                    this._onRotateMove(e);
                } else {
                    this._clickDragMixinDidDrag = true;
                    this._onDragMove(e.clientX - this._clickDragMixinData.mouseStartX, e.clientY - this._clickDragMixinData.mouseStartY);
                }
            }
        }, {
            key: '_windowMouseUp',
            value: function _windowMouseUp(e) {

                this.log('windowMouseUp');

                window.removeEventListener('mousemove', this._windowMouseMoveCallback, true);
                window.removeEventListener('mouseup', this._windowMouseUpCallback, false);

                this._windowMouseMoveCallback = null;
                this._windowMouseUpCallback = null;

                if (this._clickDragMixinDidDrag) {
                    this._onDragEnd();
                } else if (this._clickDragMixinDidRotate) {
                    this._onRotateEnd();
                }

                this._clickDragMixinDidMouseDown = false;
                this._clickDragMixinDidDrag = false;
                this._clickDragMixinDidRotate = false;
                this._clickDragMixinData = {};
            }
        }, {
            key: '_onDragStart',
            value: function _onDragStart(e) {

                this.log('onDragStart');

                if (this.track) {
                    var handlePageX = e.pageX;
                    var trackPageX = $(this.track).offset().left;
                    var trackWidth = $(this.track).width();

                    var handleLeft = Math.max(0, Math.min(trackWidth, handlePageX - trackPageX));

                    var dragLeftPercent = handleLeft / trackWidth * 100;

                    this._startLeftPercent = dragLeftPercent;

                    this.setState({ dragLeftPercent: dragLeftPercent, dragging: true });
                } else {
                    this.setState({ dragging: true });
                }

                if (this.compEl && this.compEl.onDragStart) {
                    this.compEl.onDragStart.bind(this.compEl)(e);
                }
            }
        }, {
            key: '_onDragMove',
            value: function _onDragMove(deltaX, deltaY) {

                this.log('onDragMove');

                if (this.track) {
                    var handleStartLeftPercent = this._startLeftPercent;

                    var trackWidth = $(this.track).width();

                    var handleStartLeft = handleStartLeftPercent / 100 * trackWidth;

                    var handleCurrentLeft = Math.max(0, Math.min(trackWidth, handleStartLeft + deltaX));

                    var dragLeftPercent = handleCurrentLeft / trackWidth * 100;

                    this.setState({ dragLeftPercent: dragLeftPercent });
                }

                if (this.compEl && this.compEl.onDragMove) {
                    this.compEl.onDragMove.bind(this.compEl)(deltaX, deltaY);
                }
            }
        }, {
            key: '_onDragEnd',
            value: function _onDragEnd() {

                this.log('onDragEnd');

                this.setState({ dragging: false });

                this._startLeftPercent = 0;

                if (this.compEl && this.compEl.onDragEnd) {
                    this.compEl.onDragEnd.bind(this.compEl)();
                }
            }
        }, {
            key: '_onRotateStart',
            value: function _onRotateStart(e) {

                this.log('onRotateStart');

                if (this.track) {
                    var parentElement = this.track.getBoundingClientRect();
                    if (parentElement) {
                        this._clickDragMixinData = {
                            center: {
                                x: parentElement.left + parentElement.width / 2,
                                y: parentElement.top + parentElement.height / 2
                            }
                        };
                        var x = e.clientX - this._clickDragMixinData.center.x;
                        var y = e.clientY - this._clickDragMixinData.center.y;
                        var startAngle = this.R2D * Math.atan2(y, x);

                        this.setState({ rotating: true, startAngle: startAngle });
                    }
                } else {
                    this.setState({ rotating: true });
                }

                if (this.compEl && this.compEl.onRotateStart) {
                    this.compEl.onRotateStart.bind(this.compEl)(e);
                }
            }
        }, {
            key: '_onRotateMove',
            value: function _onRotateMove(e) {

                this.log('onRotateMove');

                var deltaAngle = 0;

                if (this.track) {
                    var x = e.clientX - this._clickDragMixinData.center.x;
                    var y = e.clientY - this._clickDragMixinData.center.y;

                    deltaAngle = this.R2D * Math.atan2(y, x) - this.state.startAngle;

                    document.body.style.cursor = 'none'; // sets entire html body's cursor to none until mouse up event
                }

                if (this.compEl && this.compEl.onRotateMove) {
                    this.compEl.onRotateMove.bind(this.compEl)(e, deltaAngle);
                }
            }
        }, {
            key: '_onRotateEnd',
            value: function _onRotateEnd() {

                this.log('onRotateEnd');

                this.setState({ rotating: false, startAngle: 0 });

                document.body.style.cursor = 'auto';

                if (this.compEl && this.compEl.onRotateEnd) {
                    this.compEl.onRotateEnd.bind(this.compEl)();
                }
            }
        }, {
            key: '_onPureClick',
            value: function _onPureClick(e) {

                this.log('onPureClick');

                if (this.track) {
                    var trackPageX = $(this.track).offset().left;
                    var trackWidth = $(this.track).width();
                    var mouseX = e.pageX;

                    var clickLeftPercent = (mouseX - trackPageX) / trackWidth * 100;

                    if (this.compEl && this.compEl.onPureClick) {
                        this.compEl.onPureClick.bind(this.compEl)(e, clickLeftPercent);
                    }
                } else {
                    if (this.compEl && this.compEl.onPureClick) {
                        this.compEl.onPureClick.bind(this.compEl)(e);
                    }
                }
            }
        }, {
            key: 'trackMouseDown',
            value: function trackMouseDown(e) {
                var _this2 = this;

                var isRotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                this.log('trackMouseDown');

                if (e.defaultPrevented) {
                    return;
                }

                this.log('trackMouseDown will go through');

                this._clickDragMixinDidMouseDown = false;
                this._clickDragMixinDidDrag = false;
                this._clickDragMixinDidRotate = false;
                this._clickDragMixinFlagFireDragStart = false;
                this._clickDragMixinData = {};

                if (!this.getClickDragMixinParamOrDefault('strictMouseDownTargetCheck') || e.currentTarget == e.target) {
                    this._clickDragMixinDidMouseDown = true;

                    this._windowMouseMoveCallback = this.debounceIfNeeded(function (ev) {
                        return _this2._windowMouseMove(ev, isRotate);
                    });
                    this._windowMouseUpCallback = this.debounceIfNeeded(function (ev) {
                        return _this2._windowMouseUp(ev);
                    });

                    window.addEventListener('mousemove', this._windowMouseMoveCallback, true);
                    window.addEventListener('mouseup', this._windowMouseUpCallback, false);

                    this._clickDragMixinData = {
                        mouseStartX: e.clientX,
                        mouseStartY: e.clientY
                    };

                    this._clickDragMixinMouseMoveData.lastX = e.clientX;
                    this._clickDragMixinMouseMoveData.lastY = e.clientY;

                    if (this.getClickDragMixinParamOrDefault('preventDefaultOnMouseDown')) {
                        e.preventDefault();
                    }

                    this._clickDragMixinFlagFireDragStart = isRotate === false;
                    this._clickDragMixinFlagFireRotateStart = isRotate;
                }
            }
        }, {
            key: 'trackMouseUp',
            value: function trackMouseUp(e) {

                this.log('trackMouseUp');

                if (e.defaultPrevented) {
                    return;
                }

                if (this._clickDragMixinDidMouseDown && !this._clickDragMixinDidDrag && !this._clickDragMixinDidRotate) {
                    if (!this.getClickDragMixinParamOrDefault('strictMouseUpTargetCheck') || e.currentTarget == e.target) {
                        if (this._onPureClick) {
                            this._onPureClick(e);
                        }
                    }
                }
            }
        }, {
            key: 'handleMouseDown',
            value: function handleMouseDown(e) {

                this.log('handleMouseDown');

                this.trackMouseDown(e);

                if (this.getClickDragMixinParamOrDefault('preventDefaultOnHandleMouseDown')) {
                    e.preventDefault();
                }
            }
        }, {
            key: 'ignoreMouseDown',
            value: function ignoreMouseDown(e) {
                this.log('handleMouseDown');

                e.preventDefault();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this3 = this;

                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
                    ref: function ref(c) {
                        _this3.compEl = c;
                    },
                    dragState: this.state,
                    dragCallbacks: {
                        refTrack: function refTrack(c) {
                            _this3.track = c;
                        },
                        refHandle: function refHandle(c) {
                            _this3.handle = c;
                        },
                        onTrackMouseUp: function onTrackMouseUp(e) {
                            return _this3.trackMouseUp(e);
                        },
                        onTrackMouseDown: function onTrackMouseDown(e) {
                            return _this3.trackMouseDown(e);
                        },
                        onTrackRotateMouseDown: function onTrackRotateMouseDown(e) {
                            return _this3.trackMouseDown(e, true);
                        },
                        onHandleMouseDown: function onHandleMouseDown(e) {
                            return _this3.handleMouseDown(e);
                        },
                        onIgnoreMouseDown: function onIgnoreMouseDown(e) {
                            return _this3.ignoreMouseDown(e);
                        }
                    }
                }));
            }
        }]);

        return _class;
    }(_react.Component);
};

exports.default = ClickDragMixin;

},{"../utils/rafDebounce":152,"react":1107}],151:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var HoverMixin = function HoverMixin(ComposedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        _inherits(_class, _Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.state = { hovering: false };
            return _this;
        }

        _createClass(_class, [{
            key: "setHovering",
            value: function setHovering(hovering) {
                this.setState({ hovering: hovering });

                var onHover = this.props.onHover;

                if (onHover) {
                    onHover(hovering);
                }
            }
        }, {
            key: "render",
            value: function render() {
                var _this2 = this;

                var _props = this.props,
                    onMouseOver = _props.onMouseOver,
                    onMouseOut = _props.onMouseOut,
                    onHover = _props.onHover,
                    otherProps = _objectWithoutProperties(_props, ["onMouseOver", "onMouseOut", "onHover"]);

                var wrappedMouseOver = function wrappedMouseOver(e) {
                    _this2.setHovering(true);
                    if (onMouseOver) onMouseOver(e);
                };
                var wrappedMouseOut = function wrappedMouseOut(e) {
                    _this2.setHovering(false);
                    if (onMouseOut) onMouseOut(e);
                };

                return _react2.default.createElement(ComposedComponent, _extends({}, otherProps, {
                    onMouseOver: wrappedMouseOver,
                    onMouseOut: wrappedMouseOut,
                    hovering: this.state.hovering
                }));
            }
        }]);

        return _class;
    }(_react.Component), _class.propTypes = {
        onHover: _propTypes2.default.func
    }, _temp;
};

exports.default = HoverMixin;

},{"prop-types":896,"react":1107}],152:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var queuedCallbacks = [];
var haveScheduledRafCallback = false;

var queueCallback = function queueCallback(token, callback, args) {

    // Remove any previous callbacks with same token
    queuedCallbacks = queuedCallbacks.filter(function (_ref) {
        var oldToken = _ref.token;
        return oldToken == token;
    });

    queuedCallbacks = queuedCallbacks.concat({ token: token, callback: callback, args: args });

    if (!haveScheduledRafCallback) {
        haveScheduledRafCallback = true;
        (0, _raf2.default)(rafCallback);
    }
};

var rafCallback = function rafCallback(ts) {
    haveScheduledRafCallback = false;

    queuedCallbacks.forEach(function (_ref2) {
        var token = _ref2.token,
            callback = _ref2.callback,
            args = _ref2.args;

        try {
            callback.apply(undefined, _toConsumableArray(args));
        } catch (e) {
            console.log(e);
            throw e;
        }
    });

    queuedCallbacks = [];
};

var rafDebounce = function rafDebounce(callback) {
    var token = _shortid2.default.generate();
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return queueCallback(token, callback, args);
    };
};

exports.default = rafDebounce;

},{"raf":898,"shortid":1163}],153:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REEL_VOLUME_MODE_SET = exports.REEL_VOLUME_MODE_SET = 'REEL_VOLUME_MODE_SET';
var REEL_CLIP_VOLUME_SET = exports.REEL_CLIP_VOLUME_SET = 'REEL_CLIP_VOLUME_SET';
var REEL_CLIP_MUSIC_VOLUME_SET = exports.REEL_CLIP_MUSIC_VOLUME_SET = 'REEL_CLIP_MUSIC_VOLUME_SET';
var REEL_VIDEO_DURATION_LIMIT_SET = exports.REEL_VIDEO_DURATION_LIMIT_SET = 'REEL_VIDEO_DURATION_LIMIT_SET';
var REEL_SHOW_TRANSITION_BUTTONS = exports.REEL_SHOW_TRANSITION_BUTTONS = 'REEL_SHOW_TRANSITION_BUTTONS';
var REEL_SYNC_MEDIA_AND_TEXT = exports.REEL_SYNC_MEDIA_AND_TEXT = 'REEL_SYNC_MEDIA_AND_TEXT';

var REEL_CLIP_BOX_EDIT_START = exports.REEL_CLIP_BOX_EDIT_START = 'REEL_CLIP_BOX_EDIT_START';
var REEL_CLIP_BOX_EDIT_UPDATE = exports.REEL_CLIP_BOX_EDIT_UPDATE = 'REEL_CLIP_BOX_EDIT_UPDATE';
var REEL_CLIP_BOX_EDIT_COMMIT = exports.REEL_CLIP_BOX_EDIT_COMMIT = 'REEL_CLIP_BOX_EDIT_COMMIT';
var REEL_CLIP_BOX_EDIT_CANCEL = exports.REEL_CLIP_BOX_EDIT_CANCEL = 'REEL_CLIP_BOX_EDIT_CANCEL';

},{}],154:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeleteWarningModalActionTypes = undefined;
exports.openDeleteWarningModal = openDeleteWarningModal;
exports.closeDeleteWarningModal = closeDeleteWarningModal;
exports.handleDeleteAction = handleDeleteAction;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var DeleteWarningModalActionTypes = exports.DeleteWarningModalActionTypes = (0, _keymirror2.default)({
    OPEN_DELETE_WARNING_MODAL: null,
    CLOSE_DELETE_WARNING_MODAL: null
});

var deleteWarningModalCookie = 'dwa-4a89efcf';
var emptyFunc = function emptyFunc() {};

function openDeleteWarningModal() {
    return function (dispatch, getState) {
        if (!window.localStorage.getItem(deleteWarningModalCookie)) {
            window.localStorage.setItem(deleteWarningModalCookie, true);
            dispatch({ type: DeleteWarningModalActionTypes.OPEN_DELETE_WARNING_MODAL });
        }
    };
}

function closeDeleteWarningModal() {
    return function (dispatch, getState) {
        dispatch({ type: DeleteWarningModalActionTypes.CLOSE_DELETE_WARNING_MODAL });
    };
}

function handleDeleteAction() {
    var callbackFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunc;

    return function (dispatch, getState) {
        callbackFn();
        dispatch(openDeleteWarningModal());
    };
}

},{"keymirror":677}],155:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmptyProjectActionType = undefined;
exports.handleActionIfEmptyProject = handleActionIfEmptyProject;
exports.showEmptyProjectModal = showEmptyProjectModal;
exports.hideEmptyProjectModal = hideEmptyProjectModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var emptyFunc = function emptyFunc() {};

// Ignored in persistance middleware
var EmptyProjectActionType = exports.EmptyProjectActionType = (0, _keymirror2.default)({
    SHOW_EMPTY_PROJECT_MODAL: null,
    CLOSE_EMPTY_PROJECT_MODAL: null,
    UPDATE_EMPTY_PROJECT_STATE: null
});

/**
 * 1. if project is empty: opens the empty project modal 
 * 2. else: fires the passed callback.
 *
 * @param {function} callback
 */
function handleActionIfEmptyProject() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunc;

    return function (dispatch, getState) {
        var _getState = getState(),
            _getState$reel$clips = _getState.reel.clips,
            clips = _getState$reel$clips === undefined ? [] : _getState$reel$clips;

        var isEmptyProject = clips.length == 0;

        if (isEmptyProject) {
            dispatch(showEmptyProjectModal());
        } else {
            var dispatchAction = callback();
            if (!!dispatchAction) dispatch(dispatchAction);
        }
    };
}

function showEmptyProjectModal() {
    return { type: EmptyProjectActionType.SHOW_EMPTY_PROJECT_MODAL };
}

function hideEmptyProjectModal() {
    return { type: EmptyProjectActionType.CLOSE_EMPTY_PROJECT_MODAL };
}

},{"keymirror":677}],156:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createdAction = exports.ExportModalActionType = exports.ExportActionType = undefined;
exports.checkAndExportNew = checkAndExportNew;
exports.openActiveExport = openActiveExport;
exports.signUp = signUp;
exports.openExportModal = openExportModal;
exports.closeExportModal = closeExportModal;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _api = require('../api');

var _ProjectApi = require('../api/ProjectApi');

var _ProjectApi2 = _interopRequireDefault(_ProjectApi);

var _modeActions = require('./modeActions');

var _workspaceActions = require('./workspaceActions');

var _mediaActions = require('./mediaActions');

var _planDataSelector = require('../selectors/planDataSelector');

var _exportSelectors = require('../selectors/exportSelectors');

var _selector = require('../../pricing/selector');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ExportActionType = exports.ExportActionType = (0, _keymirror2.default)({
    CHECK: null,
    CREATING: null,
    CREATED: null,
    ERROR: null,
    OPEN_ACTIVE: null
});

var ExportErrorCodes = (0, _keymirror2.default)({
    EXPORT_DURATION_EXCEEDED: null,
    PROJECT_DURATION_EXCEEDED: null,
    INVALID_EDIT_DATA: null,
    CONTAINS_DELETED_MEDIA: null,
    UNKNOWN_ERROR: null
});

var ExportModalActionType = exports.ExportModalActionType = (0, _keymirror2.default)({
    OPEN_EXPORT_MODAL: null,
    CLOSE_EXPORT_MODAL: null
});

var checkAction = function checkAction() {
    return { type: ExportActionType.CHECK };
};

var creatingAction = function creatingAction() {
    return { type: ExportActionType.CREATING };
};

var createdAction = exports.createdAction = function createdAction() {
    return { type: ExportActionType.CREATED };
};

var errorAction = function errorAction(errorCode) {
    return { type: ExportActionType.ERROR, errorCode: errorCode };
};

var openActiveAction = function openActiveAction() {
    return { type: ExportActionType.OPEN_ACTIVE };
};

function checkAndExportNew() {
    return function (dispatch, getState) {
        var data = window.appManager.persistanceEngine.getEditDataFilter();
        return window.appManager.persistanceEngine.forceInstantSyncP(data).then(function (success) {
            if (success) {
                if (window.isNoSignupEditor) {
                    dispatch((0, _modeActions.startExportForNosignupUsers)({
                        postPaymentAction: 'export'
                    }));
                } else if (!window.appManager.isDemoMode()) {
                    dispatch(creatingAction());
                    var id = getState().project.id;

                    _bluebird2.default.try(function () {
                        return _ProjectApi2.default.exportVideoP(id);
                    }).then(function (result) {
                        var success = result.success,
                            exportId = result.exportId,
                            errorCode = result.errorCode,
                            errorMsg = result.errorMsg;

                        if (success) {
                            dispatch(createdAction());
                        } else {
                            if (errorCode === ExportErrorCodes.CONTAINS_DELETED_MEDIA) {
                                // update project media
                                dispatch((0, _mediaActions.updateProjectMedia)(result.projectMedia));
                            }
                            dispatch(errorAction(errorCode, errorMsg));
                        }
                    }).catch(function (err) {
                        console.error(err);
                        dispatch(errorAction(ExportErrorCodes.UNKNOWN_ERROR, 'Unkown Error occurred.'));
                    });

                    try {
                        (0, _api.trackDataP)({
                            type: 'TRACK_EXPORT_CLICK_TIME'
                        });
                    } catch (error) {
                        console.log('Error logging data to api ' + error);
                    }
                    return null;
                }
            }
        });
    };
}

function openActiveExport() {
    return function (dispatch, getState) {
        if (!window.appManager.isDemoMode()) {
            dispatch(openActiveAction());
        }
    };
}

function signUp() {
    return function (dispatch, getState) {
        var _getState = getState(),
            _getState$ui$afterSig = _getState.ui.afterSignUp,
            afterSignUp = _getState$ui$afterSig === undefined ? '' : _getState$ui$afterSig;

        if (afterSignUp === '') {
            window.location.assign('/login?signup=1');
        } else {
            window.location.assign('/login?signup=1&nextUrl=' + afterSignUp);
        }
    };
}

function openExportModal(data) {
    return function (dispatch, getState) {
        var state = getState();

        var _isProjectDurationExc = (0, _planDataSelector.isProjectDurationExceededSelector)(state),
            isProjectDurationExceeded = _isProjectDurationExc.isProjectDurationExceeded,
            isExportDurationExceeded = _isProjectDurationExc.isExportDurationExceeded;

        var shouldAccountForCaptionsInPaidPlan = false;
        var currentPlan = (0, _selector.getCurrentPlan)(state.pricingState);

        if (!!currentPlan && currentPlan.planVersion == 2) {
            var _currentPlan$planFeat = currentPlan.planFeatures;
            _currentPlan$planFeat = _currentPlan$planFeat === undefined ? {} : _currentPlan$planFeat;
            var _currentPlan$planFeat2 = _currentPlan$planFeat.captions,
                captions = _currentPlan$planFeat2 === undefined ? false : _currentPlan$planFeat2;

            shouldAccountForCaptionsInPaidPlan = !captions;
        }

        var premiumInstancesCount = (0, _exportSelectors.getPremiumInstancesCount)(shouldAccountForCaptionsInPaidPlan)(state);

        if (premiumInstancesCount || isExportDurationExceeded || isProjectDurationExceeded) {
            dispatch((0, _workspaceActions.updateWorkspaceInfo)());
            dispatch((0, _modeActions.setNosignupOptions)({
                postPaymentAction: 'export'
            }));
            if (!data) {
                data = { source: 'crown icon' };
            }
            dispatch((0, _workspaceActions.showPremiumInstances)(data));
        } else {
            dispatch({
                type: ExportModalActionType.OPEN_EXPORT_MODAL
            });
        }
    };
}

function closeExportModal() {
    return function (dispatch, getState) {
        dispatch({
            type: ExportModalActionType.CLOSE_EXPORT_MODAL
        });
    };
}

},{"../../pricing/selector":268,"../api":176,"../api/ProjectApi":177,"../selectors/exportSelectors":213,"../selectors/planDataSelector":218,"./mediaActions":161,"./modeActions":162,"./workspaceActions":175,"bluebird":389,"keymirror":677}],157:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.guardOverlayLayerUpdates = exports.guardOverlayUpdates = exports.unMountPropertiesPanel = exports.GuardActions = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var GuardActions = exports.GuardActions = (0, _keymirror2.default)({
    GUARD_OVERLAY_UPDATES: null,
    GUARD_OVERLAY_LAYER_UPDATES: null,
    UNMOUNT_PROPERTIES_PANEL: null
});

var unMountPropertiesPanel = exports.unMountPropertiesPanel = function () {
    var time = null;
    return function () {
        var unmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return function (dispatch, getState) {
            clearTimeout(time);
            if (!unmount) {
                dispatch({ type: GuardActions.UNMOUNT_PROPERTIES_PANEL, unmount: unmount });
            } else {
                time = setTimeout(function () {
                    dispatch({ type: GuardActions.UNMOUNT_PROPERTIES_PANEL, unmount: unmount });
                }, 200);
            }
        };
    };
}();

var guardOverlayUpdates = exports.guardOverlayUpdates = function () {
    var timeoutId = null;

    return function () {
        var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var maxDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
        return function (dispatch, getState) {
            var state = getState();
            var _state$operationGuard = state.operationGuards;
            _state$operationGuard = _state$operationGuard === undefined ? {} : _state$operationGuard;
            var _state$operationGuard2 = _state$operationGuard.disableOverlayUpdate,
                disableOverlayUpdate = _state$operationGuard2 === undefined ? false : _state$operationGuard2;

            clearTimeout(timeoutId);
            if (disable) {
                if (maxDuration !== Infinity) {
                    timeoutId = setTimeout(function () {
                        dispatch({ type: GuardActions.GUARD_OVERLAY_UPDATES, disable: false });
                    }, maxDuration);
                }
            }
            if (disableOverlayUpdate !== disable) {
                dispatch({ type: GuardActions.GUARD_OVERLAY_UPDATES, disable: disable });
            }
        };
    };
}();

// window.guardOverlayUpdates = guardOverlayUpdates;

var guardOverlayLayerUpdates = exports.guardOverlayLayerUpdates = function () {
    var timeoutId = null;

    return function () {
        var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var maxDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
        return function (dispatch, getState) {
            var state = getState();
            var _state$operationGuard3 = state.operationGuards.disableOverlayLayerUpdate,
                disableOverlayLayerUpdate = _state$operationGuard3 === undefined ? false : _state$operationGuard3;

            clearTimeout(timeoutId);
            if (disable) {
                if (maxDuration !== Infinity) {
                    timeoutId = setTimeout(function () {
                        dispatch({ type: GuardActions.GUARD_OVERLAY_LAYER_UPDATES, disable: false });
                    }, maxDuration);
                }
            }
            if (disableOverlayLayerUpdate !== disable) {
                dispatch({ type: GuardActions.GUARD_OVERLAY_LAYER_UPDATES, disable: disable });
            }
        };
    };
}();

},{"keymirror":677}],158:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeIdleModal = exports.openIdleModal = exports.IdleModalActionTypes = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _logActions = require('./logActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var IdleModalActionTypes = exports.IdleModalActionTypes = (0, _keymirror2.default)({
    OPEN_IDLE_MODAL: null,
    CLOSE_IDLE_MODAL: null
});

var openIdleModal = exports.openIdleModal = function openIdleModal(idleModalId) {
    return { type: IdleModalActionTypes.OPEN_IDLE_MODAL, idleModalId: idleModalId };
};

var closeIdleModal = exports.closeIdleModal = function closeIdleModal(idleModalId) {
    return { type: IdleModalActionTypes.CLOSE_IDLE_MODAL, idleModalId: idleModalId };
};

},{"./logActions":160,"keymirror":677}],159:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openCollectionShelfFromUploadModal = exports.openMyMediaShelfFromUploadModal = exports.openPhotosAndVideosFullView = exports.iconScoutOpenDropDown = exports.iconScoutGlobalExpandViewClick = exports.iconScoutSearchResultUpdate = exports.iconScoutSearchQueryUpdate = exports.iconScoutClearSearchQuery = exports.elementsSectionDropDownOpen = exports.elementsSectionGlobalExpandView = exports.elementsSectionSearchResultUpdate = exports.elementsSectionSearchQueryUpdate = exports.elementsSectionClearSearchQuery = exports.clearTextStyleSearchQuery = exports.updateTextStyleSearchQuery = exports.updateTextStyleSearchResults = exports.getTextStyleFilter = exports.getTextStyleEntries = exports.updateSearchResults = exports.clearSearch = exports.updateSearchRequest = exports.onGlobalExpandViewClick = exports.scrollToSequence = exports.scrollToClipBoard = exports.resetScrollTo = exports.openScrollDropDown = exports.iconScoutShelfAction = exports.elementsShelfAction = exports.textShelfAction = exports.collectionShelfAction = exports.audioShelfActions = exports.myMediaShelfActions = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _logActions = require('./logActions');

var _General = require('../constants/General');

var _projectMediaSelectors = require('../selectors/projectMediaSelectors');

var _SearchRegistry = require('../utils/search/SearchRegistry');

var _SearchRegistry2 = _interopRequireDefault(_SearchRegistry);

var _leftShelfSelector = require('../selectors/leftShelfSelector');

var _modeActions = require('./modeActions');

var _PluginService = require('../../common/constants/PluginService');

var _templateSelectors = require('../selectors/templateSelectors');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var getReadyProjectAudio = (0, _projectMediaSelectors.makeGetReadyProjectAudio)();
var getWorkspaceAndProjectMedia = (0, _projectMediaSelectors.makeGetWorkspaceAndProjectMedia)();

var myMediaShelfActions = exports.myMediaShelfActions = (0, _keymirror2.default)({
    MM_SET_GLOBAL_VIEW: null,
    MM_ON_SEARCH_REQUEST_UPDATE: null,
    MM_UPDATE_SEARCH_RESULTS: null,
    MM_SCROLL_TO_SECTION: null,
    MM_OPEN_SCROLL_DROP_DOWN: null
});

var audioShelfActions = exports.audioShelfActions = (0, _keymirror2.default)({
    AUDIO_SET_GLOBAL_VIEW: null,
    AUDIO_ON_SEARCH_REQUEST_UPDATE: null,
    AUDIO_UPDATE_SEARCH_RESULTS: null
});

var collectionShelfAction = exports.collectionShelfAction = (0, _keymirror2.default)({
    CC_SET_GLOBAL_VIEW: null,
    CC_ON_SEARCH_REQUEST_UPDATE: null,
    CC_UPDATE_SEARCH_RESULTS: null,
    CC_SCROLL_TO_SECTION: null,
    CC_OPEN_SCROLL_DROP_DOWN: null
});

var textShelfAction = exports.textShelfAction = (0, _keymirror2.default)({
    TS_ON_SEARCH_REQUEST_UPDATE: null,
    TS_UPDATE_SEARCH_RESULTS: null
});

var elementsShelfAction = exports.elementsShelfAction = (0, _keymirror2.default)({
    ES_SET_GLOBAL_VIEW: null,
    ES_ON_SEARCH_REQUEST_UPDATE: null,
    ES_ON_SEARCH_RESULT_UPDATE: null,
    ES_SCROLL_TO_SECTION: null,
    ES_OPEN_SCROLL_DROPDOWN: null
});

var iconScoutShelfAction = exports.iconScoutShelfAction = (0, _keymirror2.default)({
    IS_SET_GLOBAL_VIEW: null,
    IS_ON_SEARCH_REQUEST_UPDATE: null,
    IS_ON_SEARCH_RESULT_UPDATE: null,
    IS_SCROLL_TO_SECTION: null,
    IS_OPEN_SCROLL_DROPDOWN: null
});

/**
 * My Media Shelf Actions
 */

var openScrollDropDown = exports.openScrollDropDown = function openScrollDropDown(_ref) {
    var sectionIdentifier = _ref.sectionIdentifier;
    return {
        type: myMediaShelfActions.MM_OPEN_SCROLL_DROP_DOWN,
        sectionIdentifier: sectionIdentifier
    };
};

var resetScrollTo = exports.resetScrollTo = function resetScrollTo() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    return function () {
        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
        return function (dispatch, getState) {
            setTimeout(function () {
                dispatch({
                    type: myMediaShelfActions.MM_SCROLL_TO_SECTION,
                    scrollToSectionId: null
                });
            }, timeout);
            dispatch(fn());
        };
    };
};

var scrollToClipBoard = exports.scrollToClipBoard = resetScrollTo(function () {
    return {
        type: myMediaShelfActions.MM_SCROLL_TO_SECTION,
        scrollToSectionId: _General.Sections.VIDEOS.subSections.CLIPBOARD
    };
});

var scrollToSequence = exports.scrollToSequence = resetScrollTo(function () {
    return {
        type: myMediaShelfActions.MM_SCROLL_TO_SECTION,
        scrollToSectionId: _General.Sections.VIDEOS.subSections.SEQUENCE
    };
});

var onGlobalExpandViewClick = exports.onGlobalExpandViewClick = function onGlobalExpandViewClick(_ref2) {
    var sectionIdentifier = _ref2.sectionIdentifier;
    return function (dispatch, getState) {
        dispatch((0, _logActions.trackExpandViewClick)(sectionIdentifier, false));
        dispatch({
            type: myMediaShelfActions.MM_SET_GLOBAL_VIEW,
            sectionIdentifier: sectionIdentifier
        });
    };
};

var updateSearchRequest = exports.updateSearchRequest = function updateSearchRequest(data) {
    return {
        type: myMediaShelfActions.MM_ON_SEARCH_REQUEST_UPDATE,
        searchText: data.query,
        tagFilters: data.tags
    };
};

var clearSearch = exports.clearSearch = function clearSearch(query) {
    return {
        type: myMediaShelfActions.MM_ON_SEARCH_REQUEST_UPDATE,
        searchText: null,
        tagFilters: null
    };
};

var updateSearchResults = exports.updateSearchResults = function updateSearchResults(data) {
    return function (dispatch, getState) {
        var state = getState();

        var sequences = state.sequences;

        var workspaceMedia = getWorkspaceAndProjectMedia(state);
        var workspaceAudio = getReadyProjectAudio(state);

        var filterFunction = data.pipeline;

        var filteredSequence = filterFunction(sequences);
        var filteredWorkspaceMedia = filterFunction(workspaceMedia);
        var filteredWorkspaceAudio = filterFunction(workspaceAudio);

        dispatch({
            type: myMediaShelfActions.MM_UPDATE_SEARCH_RESULTS,
            searchResultSequence: filteredSequence,
            searchResultAudios: filteredWorkspaceAudio,
            searchResultClipBoardItems: null,
            searchResultPhotoVideos: filteredWorkspaceMedia
        });
    };
};

/**
 * Text Section Actions
 */

var getTextStyleEntries = exports.getTextStyleEntries = (0, _leftShelfSelector.createGetTextStyleEntries)(['subtitles']);
var getTextStyleFilter = exports.getTextStyleFilter = (0, _leftShelfSelector.createGetTextStyleFilter)(getTextStyleEntries);

var updateTextStyleSearchResults = exports.updateTextStyleSearchResults = function updateTextStyleSearchResults(filters) {
    return function (dispatch, getState) {
        var state = getState();

        var _getTextStyleFilter = getTextStyleFilter(state),
            _getTextStyleFilter$f = _getTextStyleFilter.filterFn,
            filterFn = _getTextStyleFilter$f === undefined ? {} : _getTextStyleFilter$f;

        var text = getTextStyleEntries(state);

        var searchResults = text.flatMap(function (entry) {
            var func = filterFn[entry.id];
            var result = func(filters);
            return result;
        });

        return dispatch({
            type: textShelfAction.TS_UPDATE_SEARCH_RESULTS,
            filters: filters,
            searchResults: searchResults
        });
    };
};

var updateTextStyleSearchQuery = exports.updateTextStyleSearchQuery = function updateTextStyleSearchQuery(data) {
    return {
        type: textShelfAction.TS_ON_SEARCH_REQUEST_UPDATE,
        searchText: data.query,
        tagFilters: data.tags
    };
};

var clearTextStyleSearchQuery = exports.clearTextStyleSearchQuery = function clearTextStyleSearchQuery() {
    return {
        type: textShelfAction.TS_ON_SEARCH_REQUEST_UPDATE,
        searchText: null,
        tagFilters: null
    };
};

var elementsSectionClearSearchQuery = exports.elementsSectionClearSearchQuery = function elementsSectionClearSearchQuery(data) {
    return {
        type: elementsShelfAction.ES_ON_SEARCH_REQUEST_UPDATE,
        searchText: null,
        tags: [],
        tagNames: []
    };
};

var elementsSectionSearchQueryUpdate = exports.elementsSectionSearchQueryUpdate = function elementsSectionSearchQueryUpdate(data) {
    return {
        type: elementsShelfAction.ES_ON_SEARCH_REQUEST_UPDATE,
        searchText: data.query,
        tags: data.tags,
        tagNames: data.tagNames
    };
};

var typitoFoundrySvgAssets = 'svg-assets-' + _PluginService.SupportedPlugins.typitofoundry;

var elementsSectionSearchResultUpdate = exports.elementsSectionSearchResultUpdate = function elementsSectionSearchResultUpdate(filterResult, foundrySVGFilterResult) {
    return function (dispatch, getState) {
        var state = getState();
        var filters = (0, _templateSelectors.getElementsShelfStaticFilter)(state);

        // memoize this point to avoid redoing filter operation
        var icons = filters.iconFilter(filterResult);
        var shapes = filters.shapeFilter(filterResult);
        var foundrySVGs = filters.foundrySVGFilter(foundrySVGFilterResult);

        dispatch({
            type: elementsShelfAction.ES_ON_SEARCH_RESULT_UPDATE,
            result: _defineProperty({
                icons: icons,
                shapes: shapes
            }, typitoFoundrySvgAssets, foundrySVGs),
            filterList: filterResult
        });
    };
};

var elementsSectionGlobalExpandView = exports.elementsSectionGlobalExpandView = function elementsSectionGlobalExpandView() {
    return {
        type: elementsShelfAction.ES_SET_GLOBAL_VIEW,
        sectionIdentifier: _General.Sections.IMAGES.subSections.GLOBAL
    };
};

var elementsSectionDropDownOpen = exports.elementsSectionDropDownOpen = function elementsSectionDropDownOpen(_ref3) {
    var sectionIdentifier = _ref3.sectionIdentifier;
    return {
        type: elementsShelfAction.ES_OPEN_SCROLL_DROPDOWN,
        sectionIdentifier: sectionIdentifier
    };
};

/**
 *
 * // HACK -Iconscout Actions , will not be Used for UI until Plugins is good for Prod
 */

var iconScoutClearSearchQuery = exports.iconScoutClearSearchQuery = function iconScoutClearSearchQuery(data) {
    return {
        type: iconScoutShelfAction.IS_ON_SEARCH_REQUEST_UPDATE,
        searchText: null,
        tags: [],
        tagNames: []
    };
};

var iconScoutSearchQueryUpdate = exports.iconScoutSearchQueryUpdate = function iconScoutSearchQueryUpdate(data) {
    return {
        type: iconScoutShelfAction.IS_ON_SEARCH_REQUEST_UPDATE,
        searchText: data.query,
        tags: data.tags,
        tagNames: data.tagNames
    };
};

var iconScoutSearchResultUpdate = exports.iconScoutSearchResultUpdate = function iconScoutSearchResultUpdate(result) {
    var resultObject = (result || []).reduce(function (acc, entry) {
        if (!acc[entry.style]) acc[entry.style] = [];
        acc[entry.style].push(entry);
        return acc;
    }, {});
    return {
        type: iconScoutShelfAction.IS_ON_SEARCH_RESULT_UPDATE,
        result: resultObject,
        allResult: result
    };
};

var iconScoutGlobalExpandViewClick = exports.iconScoutGlobalExpandViewClick = function iconScoutGlobalExpandViewClick(_ref4) {
    var sectionIdentifier = _ref4.sectionIdentifier;
    return {
        type: iconScoutShelfAction.IS_SET_GLOBAL_VIEW,
        sectionIdentifier: _General.Sections.PLUGINS.pluginsConstants.globalView
    };
};

var iconScoutOpenDropDown = exports.iconScoutOpenDropDown = function iconScoutOpenDropDown(_ref5) {
    var sectionIdentifier = _ref5.sectionIdentifier;
    return {
        type: iconScoutShelfAction.IS_OPEN_SCROLL_DROPDOWN,
        sectionIdentifier: sectionIdentifier
    };
};

/**
 * Combined actions below
 */

var openPhotosAndVideosFullView = exports.openPhotosAndVideosFullView = function openPhotosAndVideosFullView() {
    return function (dispatch, getState) {
        var _getState = getState(),
            _getState$ui = _getState.ui,
            isClipReplace = _getState$ui.isClipReplace,
            insertPos = _getState$ui.insertPos,
            _getState$ui$insertCl = _getState$ui.insertClipId,
            insertClipId = _getState$ui$insertCl === undefined ? null : _getState$ui$insertCl;

        dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.VIDEOS.id, true));
        dispatch(onGlobalExpandViewClick({ sectionIdentifier: _General.Sections.VIDEOS.subSections.PHOTOS_VIDEOS }));
        dispatch((0, _modeActions.setInsertPosForClip)(insertClipId, insertPos, isClipReplace));
    };
};

var openMyMediaShelfFromUploadModal = exports.openMyMediaShelfFromUploadModal = function openMyMediaShelfFromUploadModal() {
    return function (dispatch, getState) {
        // TODO -- build better Context setup
        var _getState2 = getState(),
            _getState2$ui = _getState2.ui,
            isClipReplace = _getState2$ui.isClipReplace,
            insertPos = _getState2$ui.insertPos,
            _getState2$ui$insertC = _getState2$ui.insertClipId,
            insertClipId = _getState2$ui$insertC === undefined ? null : _getState2$ui$insertC; // retains the replace context


        dispatch((0, _modeActions.changeSidebarSection)('VIDEOS', true));
        dispatch((0, _modeActions.setInsertPosForClip)(insertClipId, insertPos, isClipReplace));
    };
};

var openCollectionShelfFromUploadModal = exports.openCollectionShelfFromUploadModal = function openCollectionShelfFromUploadModal() {
    return function (dispatch, getState) {
        // TODO -- build better Context setup
        var _getState3 = getState(),
            _getState3$ui = _getState3.ui,
            isClipReplace = _getState3$ui.isClipReplace,
            insertPos = _getState3$ui.insertPos,
            _getState3$ui$insertC = _getState3$ui.insertClipId,
            insertClipId = _getState3$ui$insertC === undefined ? null : _getState3$ui$insertC; // retains the replace context


        dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.COLLECTIONS.id, true));
        dispatch((0, _modeActions.setInsertPosForClip)(insertClipId, insertPos, isClipReplace));
    };
};

},{"../../common/constants/PluginService":65,"../constants/General":203,"../selectors/leftShelfSelector":214,"../selectors/projectMediaSelectors":220,"../selectors/templateSelectors":225,"../utils/search/SearchRegistry":243,"./logActions":160,"./modeActions":162,"keymirror":677}],160:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackTemplateReplace = exports.trackConfigurationSave = exports.logFormatAddedFromNoSignup = exports.instructionNudgeActions = exports.idleNudgeActions = exports.logSubtitleActions = exports.logSubtitleAddition = exports.trackExpandViewClick = exports.trackOverlayAction = exports.trackTransitionAction = exports.trackHorizontalScroll = exports.trackIconUsed = exports.trackShapeUsed = exports.trackTextEffectUsed = exports.trackMusicAdded = exports.trackMediaPreviewed = exports.mediaInserted = exports.mediaReplaced = exports.trackStockMediaAdded = exports.trackMediaAdded = exports.trackInstantUploadAdd = exports.trackMediaUploaded = exports.idleNudgeActionTypes = exports.captionActionTypes = exports.exploreMediaTypes = exports.overlayActionType = exports.mediaSources = exports.musicSources = exports.scrollDirections = exports.leftPanelSections = exports.leftPanelTabs = exports.mediaReplacementTypes = exports.mediaAddDestinations = exports.mediaAddFromLocations = exports.mediaAddLocations = exports.mediaTypes = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _TrackUtils = require('../../common/utils/TrackUtils');

var _TransitionType = require('../constants/TransitionType');

var _TransitionType2 = _interopRequireDefault(_TransitionType);

var _idleModalActions = require('./idleModalActions');

var _ReelHelpers = require('../../common/utils/ReelHelpers');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/** Constants */

// const analyticsEnabled = analyticsEnabled // From global variable

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var eventTypes = {
    MEDIA_UPLOADED: 'Media Uploaded',
    MEDIA_ADDED: 'Media Added',
    STOCK_MEDIA_ADDED: 'Stock Media Added',
    MEDIA_REPLACED: 'Media Replaced',
    MEDIA_INSERTED: 'Media Inserted',
    MUSIC_ADDED: 'Music Added',
    TEXT_EFFECT_USED: 'Text Effect Used',
    SHAPE_USED: 'Shape Used',
    ICON_USED: 'Icon Used',
    HORIZONTAL_SCROLL: 'Horizontal Scroll',
    MEDIA_PREVIEWED: 'Media Previewed',
    TRANSITION_ADDED: 'Transition Added',
    TRANSITION_UPDATED: 'Transition Updated',
    OVERLAY_COPY: 'Overlay Copy',
    OVERLAY_SAVED: 'Overlay Saved',
    OVERLAY_PASTE: 'Overlay Paste',
    OVERLAY_ADDED: 'Overlay Added',
    CAPTION_ADDED: 'Captions added',
    CAPTION_THEME_SELECTED: 'Caption Theme Selected',
    CAPTION_FONT_UPDATED: 'Caption Font Updated',
    CAPTION_FONT_SIZE_UPDATED: 'Caption Font Size Selected',
    CAPTION_OPACITY_UPDATED: 'Caption Opacity Selected',
    CAPTION_ALIGNMENT_UPDATED: 'Caption Alignment Updated',
    CAPTION_BACKGROUND_COLOR_UPDATED: 'Caption Background Color Updated',
    CAPTION_TEXT_COLOR_UPDATED: 'Caption Text Color Updated',
    CAPTION_ANIMATION_UPDATED: 'Caption Animation Updated',
    CAPTION_POSITION_UPDATED: 'Caption Position Updated',
    CAPTION_LINE_HEIGHT_UPDATED: 'Caption Line Height Updated',
    CAPTION_LETTER_SPACING_UPDATED: 'Caption Letter Spacing Updated',
    EXPLORE_ALL_VIDEOS: 'Explore All Videos',
    EXPLORE_ALL_AUDIOS: 'Explore All Audios',
    EXPLORE_ALL_PHOTOS_AND_VIDEOS: 'Explore All Photos and Videos',
    EXPLORE_ALL_SEQUENCES: 'Explore All Sequences',
    EXPLORE_ALL_ICONS: 'Explore All Icons',
    EXPLORE_ALL_SHAPES: 'Explore All Shapes',
    EXPLORE_ALL_IMAGES: 'Explore All Images',
    EXPLORE_ALL_TEMPLATES: 'Explore All Templates',
    INACTIVITY_MODAL_OPENED: 'Inactivity Modal Opened',
    HELP_MODAL_OPENED: 'Help Modal Opened',
    ONBOARDIN_NUDGE_CLICKED: 'Onboarding nudge clicked',

    FORMAT_USED: 'Format Used',
    CONFIG_SAVE: 'Configuration Saved',
    TEMPLATE_REPLACED: 'Template Replaced'
};

var mediaTypes = exports.mediaTypes = {
    IMAGE: 'image',
    VIDEO: 'video',
    PLACEHOLDER: 'placeholder'
};

var mediaAddLocations = exports.mediaAddLocations = {
    ADD_AFTER: 'Add After',
    TO_LAST: 'To Last',
    INSERT_BEFORE: 'Insert Before',
    OVERLAY: 'overlay'
};

var mediaAddFromLocations = exports.mediaAddFromLocations = {
    LEFT_PANEL: 'Left Panel',
    PREVIEW_MODAL: 'Preview Modal'
};

var mediaAddDestinations = exports.mediaAddDestinations = {
    TIMELINE: 'timeline',
    OVERLAY: 'overlay'
};

var mediaReplacementTypes = exports.mediaReplacementTypes = {
    OVERLAY: 'overlay',
    TIMELINE: 'timeline',
    TIMELINE_CANVAS: 'timeline-canvas',
    LEFT_PANEL: 'left-panel'
};

// mapping of all left shelves
var leftPanelTabs = exports.leftPanelTabs = {
    VIDEOS: 'My Media',
    COLLECTIONS: 'Stock Media',
    IMAGES: 'Elements',
    TEXT: 'Text Effects',
    AUDIO: 'Music Library',
    STOCK_MEDIA: 'Stock',
    MY_MEDIA: 'My Media',
    MUSIC: 'Music'
};

// mapping of all sections inside all the left shelves
// TODO move the mapping data to a sepprate enum , use the same for both shelves and logging - to much maintainance to keep them sepparate
var leftPanelSections = exports.leftPanelSections = {
    PHOTOS_VIDEOS: 'Image and Videos',
    SEQUENCE: 'Sequences',
    VIDEOS: 'Videos',
    IMAGE: 'Image',
    PHOTOS: 'Images',
    VIDEO_TEMPLATES: 'Video Templates',
    AUDIO: 'Audio',
    CLIPBOARD: 'Clipboard',
    MUSIC_CATEGORY: 'Music Category',
    SHAPES: 'Shapes',
    ICONS: 'Icons'
};

var scrollDirections = exports.scrollDirections = {
    RTL: 'RTL',
    LTR: 'LTR'
};

var musicSources = exports.musicSources = {
    GALLERY: 'gallery',
    UPLOAD: 'upload'
};

var mediaSources = exports.mediaSources = {
    STOCK: 'Stock',
    UPLOADED: 'Uploaded'
};

var overlayActionType = exports.overlayActionType = {
    COPY: 'Copy',
    PASTE: 'Paste',
    SAVED: 'Saved',
    ADD: 'Add',
    DELETE: 'Delete'
};

var exploreMediaTypes = exports.exploreMediaTypes = {
    PHOTO_AND_VIDEO: 'Photos and Videos',
    VIDEO: 'Video',
    TEMPLATE: 'Template',
    IMAGE: 'Image',
    SHAPE: 'Shape',
    ICON: 'Icon',
    SEQUENCE: 'Sequence',
    AUDIO: 'Audio'
};

var captionActionTypes = exports.captionActionTypes = {
    BACKGROUND_COLOR: 'Background Color',
    TEXT_COLOR: 'Font Color',
    OPACITY: 'Opacity',
    LINE_HEIGHT: 'Line Height',
    LETTER_SPACING: 'Letter Spacing',
    THEME: 'Theme',
    FONT: 'Font',
    FONT_SIZE: 'Font Size',
    ANIMATION: 'Animation',
    ALIGNMENT: 'Alignment',
    POSITION: 'Position'
};

var idleNudgeActionTypes = exports.idleNudgeActionTypes = (0, _keymirror2.default)({
    INACTIVITY_MODAL_OPENED: null,
    INACTIVITY_MODAL_CLOSED: null,
    HELP_MODAL_OPENED: null,
    HELP_MODAL_CLOSED: null
});

/** Tracking functions */

var trackMediaUploaded = exports.trackMediaUploaded = function trackMediaUploaded(mediaType) {
    return async function (dispatch, getState) {
        try {
            var _getState = getState(),
                userId = _getState.ui.userId,
                _getState$project = _getState.project,
                projectId = _getState$project.id,
                editorType = _getState$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Media type': mediaType,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOn)(eventTypes.MEDIA_UPLOADED, data, {
                All: true,
                Smartlook: true
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackInstantUploadAdd = exports.trackInstantUploadAdd = function trackInstantUploadAdd(mediaType, location) {
    var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : mediaAddFromLocations.LEFT_PANEL;
    var destination = arguments[3];
    var currentState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'uploading';
    return async function (dispatch, getState) {
        try {
            var _getState2 = getState(),
                userId = _getState2.ui.userId,
                _getState2$project = _getState2.project,
                projectId = _getState2$project.id,
                editorType = _getState2$project.editorType,
                _getState2$shelfUISta = _getState2.shelfUIState.mymedia,
                _getState2$shelfUISta2 = _getState2$shelfUISta.searchText,
                searchText = _getState2$shelfUISta2 === undefined ? null : _getState2$shelfUISta2,
                _getState2$shelfUISta3 = _getState2$shelfUISta.tagFilters,
                tagFilters = _getState2$shelfUISta3 === undefined ? null : _getState2$shelfUISta3;

            var viaSearch = !!searchText;
            var viaFilters = !!tagFilters && tagFilters.length > 0;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Media type': mediaType,
                Location: location,
                From: from,
                Destination: destination,
                'Via search': !!viaSearch,
                'Via filters': !!viaFilters,
                'current state': currentState,
                'Editor type': editorType
            };

            dlog('track media addition for Instant Upload Media : ', data);

            if (!analyticsEnabled) return;

            (0, _TrackUtils.trackOn)(eventTypes.MEDIA_ADDED, data, {
                All: true,
                Smartlook: true
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackMediaAdded = exports.trackMediaAdded = function trackMediaAdded(mediaType, location, from, destination) {
    var viaSearch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var viaFilters = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return async function (dispatch, getState) {
        try {
            var _getState3 = getState(),
                userId = _getState3.ui.userId,
                _getState3$project = _getState3.project,
                projectId = _getState3$project.id,
                editorType = _getState3$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Media type': mediaType,
                Location: location,
                From: from,
                Destination: destination,
                'Via search': !!viaSearch,
                'Via filters': !!viaFilters,
                'current state': 'processed',
                'Editor type': editorType
            };

            dlog('track media addition for Workspace Media : ', data);

            if (!analyticsEnabled) return;

            (0, _TrackUtils.trackOn)(eventTypes.MEDIA_ADDED, data, {
                All: true,
                Smartlook: true
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackStockMediaAdded = exports.trackStockMediaAdded = function trackStockMediaAdded(mediaType, mediaId, destination, viaSearch, viaFilters) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState4 = getState(),
                userId = _getState4.ui.userId,
                _getState4$project = _getState4.project,
                projectId = _getState4$project.id,
                editorType = _getState4$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Media type': mediaType,
                'Media id': mediaId,
                Destination: destination,
                'Via search': !!viaSearch,
                'Via filters': !!viaFilters,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOnAll)(eventTypes.STOCK_MEDIA_ADDED, data);
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var mediaReplaced = exports.mediaReplaced = function mediaReplaced(replacedMedia, replacedBy, replacementType) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState5 = getState(),
                userId = _getState5.ui.userId,
                _getState5$project = _getState5.project,
                projectId = _getState5$project.id,
                editorType = _getState5$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Replace media': replacedMedia,
                'Replaced by': replacedBy,
                'Replacement type': replacementType,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOn)(eventTypes.MEDIA_REPLACED, data, {
                All: true,
                Smartlook: true
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var mediaInserted = exports.mediaInserted = function mediaInserted(mediaType) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState6 = getState(),
                userId = _getState6.ui.userId,
                _getState6$project = _getState6.project,
                projectId = _getState6$project.id,
                editorType = _getState6$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Media type': mediaType,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOn)(eventTypes.MEDIA_INSERTED, data, {
                All: true,
                Smartlook: true
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackMediaPreviewed = exports.trackMediaPreviewed = function trackMediaPreviewed() {
    var isStock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var mediaType = arguments[1];
    var currentState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'none';
    return async function (dispatch, getState) {
        try {
            // if (!analyticsEnabled && !DEBUG) return;

            var _getState7 = getState(),
                userId = _getState7.ui.userId,
                projectId = _getState7.project.id;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Media type': mediaType,
                Source: isStock ? mediaSources.STOCK : mediaSources.UPLOADED,
                'current state': currentState
            };

            dlog('Track Media Preview ', data);

            if (!analyticsEnabled) return;

            (0, _TrackUtils.trackOn)(eventTypes.MEDIA_PREVIEWED, data, { All: true, FreshChat: false });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackMusicAdded = exports.trackMusicAdded = function trackMusicAdded(source) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState8 = getState(),
                userId = _getState8.ui.userId,
                _getState8$project = _getState8.project,
                projectId = _getState8$project.id,
                editorType = _getState8$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                Source: source,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOnAll)(eventTypes.MUSIC_ADDED, data);
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackTextEffectUsed = exports.trackTextEffectUsed = function trackTextEffectUsed(_ref) {
    var templateTitle = _ref.templateTitle,
        viaSearch = _ref.viaSearch,
        viaFilters = _ref.viaFilters,
        templateType = _ref.templateType;
    return async function (dispatch, getState) {
        try {
            var _getState9 = getState(),
                userId = _getState9.ui.userId,
                _getState9$project = _getState9.project,
                projectId = _getState9$project.id,
                editorType = _getState9$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Template title': templateTitle,
                'Via search': !!viaSearch,
                'Via filters': !!viaFilters,
                'Editor type': editorType,
                'Template type': templateType
            };

            dlog('Effect used data track : ', data);

            if (!analyticsEnabled) return;
            (0, _TrackUtils.trackOn)(eventTypes.TEXT_EFFECT_USED, data, {
                All: true,
                Smartlook: true
            });

            // if (window.Intercom && intercomEnabled) {
            //     Intercom('trackEvent', 'editor-clicked-template');
            //     setTimeout(() => {
            //         Intercom('update', {
            //             last_request_at: parseInt(new Date().getTime() / 1000),
            //         });
            //     }, 500);
            // }
            if (analyticsEnabled && window.fcWidget) {
                (0, _TrackUtils.trackOnFreshChat)('editor-clicked-template');
                setTimeout(function () {
                    (0, _TrackUtils.updateUserOnFreshChat)({
                        last_request_at: parseInt(new Date().getTime() / 1000)
                    });
                }, 2000);
            }
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackShapeUsed = exports.trackShapeUsed = function trackShapeUsed(shapeTitle, viaSearch, viaFilters) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState10 = getState(),
                userId = _getState10.ui.userId,
                _getState10$project = _getState10.project,
                projectId = _getState10$project.id,
                editorType = _getState10$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Shape title': shapeTitle,
                'Via search': !!viaSearch,
                'Via filters': !!viaFilters,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOnAll)(eventTypes.SHAPE_USED, data);
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackIconUsed = exports.trackIconUsed = function trackIconUsed(iconTitle, viaSearch, viaFilters) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState11 = getState(),
                userId = _getState11.ui.userId,
                _getState11$project = _getState11.project,
                projectId = _getState11$project.id,
                editorType = _getState11$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Icon title': iconTitle,
                'Via search': !!viaSearch,
                'Via filters': !!viaFilters,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOnAll)(eventTypes.ICON_USED, data);
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackHorizontalScroll = exports.trackHorizontalScroll = function trackHorizontalScroll(tab, section, pos, prevPos) {
    return async function (dispatch, getState) {
        try {
            var direction = pos < prevPos ? scrollDirections.RTL : scrollDirections.LTR;

            var _getState12 = getState(),
                userId = _getState12.ui.userId,
                projectId = _getState12.project.id;

            var data = {
                'User id': userId,
                'Project id': projectId,
                Tab: leftPanelTabs[tab],
                Section: leftPanelSections[section] || section,
                Direction: direction
            };

            dlog('tracking data for ' + trackHorizontalScroll.name + ' : data : ', data);

            (0, _TrackUtils.trackOn)(eventTypes.HORIZONTAL_SCROLL, data, { All: true, FreshChat: false });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackTransitionAction = exports.trackTransitionAction = function trackTransitionAction(newTransition, oldTransition) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState13 = getState(),
                userId = _getState13.ui.userId,
                _getState13$project = _getState13.project,
                projectId = _getState13$project.id,
                editorType = _getState13$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Editor type': editorType
            };

            var eventType = '';

            if (oldTransition == _TransitionType2.default.NONE) {
                eventType = eventTypes.TRANSITION_ADDED;
                data = _extends({}, data, {
                    Transition: newTransition
                });
            } else {
                eventType = eventTypes.TRANSITION_UPDATED;
                data = _extends({}, data, {
                    'New Transition': newTransition,
                    'Old Transition': oldTransition
                });
            }

            (0, _TrackUtils.trackOn)(eventType, data, {
                All: true,
                FreshChat: false,
                Smartlook: eventType === eventTypes.TRANSITION_ADDED
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackOverlayAction = exports.trackOverlayAction = function trackOverlayAction(action, overlayCount) {
    return async function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState14 = getState(),
                userId = _getState14.ui.userId,
                projectId = _getState14.project.id;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Overlay count': overlayCount
            };

            var eventType = '';

            switch (action) {
                case overlayActionType.ADD:
                    eventType = eventTypes.OVERLAY_ADDED;
                    break;
                case overlayActionType.COPY:
                    {
                        eventType = eventTypes.OVERLAY_COPY;
                        break;
                    }
                case overlayActionType.PASTE:
                    {
                        eventType = eventTypes.OVERLAY_PASTE;
                        break;
                    }
                case overlayActionType.SAVED:
                    {
                        eventType = eventTypes.OVERLAY_SAVED;
                        break;
                    }
            }

            (0, _TrackUtils.trackOn)(eventType, data, {
                All: true,
                FreshChat: false,
                Smartlook: eventType === eventTypes.OVERLAY_ADDED
            });
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackExpandViewClick = exports.trackExpandViewClick = function trackExpandViewClick(mediaType) {
    var isStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var _getState15 = getState(),
            userId = _getState15.ui.userId,
            id = _getState15.project.id;

        var source = isStock ? mediaSources.STOCK : mediaSources.UPLOADED;

        var event = null;
        switch (leftPanelSections[mediaType]) {
            case leftPanelSections.AUDIO:
                event = eventTypes.EXPLORE_ALL_AUDIOS;
                break;
            case leftPanelSections.VIDEOS:
                event = eventTypes.EXPLORE_ALL_VIDEOS;
                break;
            case leftPanelSections.PHOTOS_VIDEOS:
                event = eventTypes.EXPLORE_ALL_PHOTOS_AND_VIDEOS;
                break;
            case leftPanelSections.SEQUENCE:
                event = eventTypes.EXPLORE_ALL_SEQUENCES;
                break;
            case leftPanelSections.IMAGE:
            case leftPanelSections.PHOTOS:
                event = eventTypes.EXPLORE_ALL_IMAGES;
                break;
            case leftPanelSections.VIDEO_TEMPLATES:
                event = eventTypes.EXPLORE_ALL_TEMPLATES;
                break;
            case leftPanelSections.SHAPES:
                event = eventTypes.EXPLORE_ALL_SHAPES;
                break;
            case leftPanelSections.ICONS:
                event = eventTypes.EXPLORE_ALL_ICONS;
                break;
            default:
                event = 'Explore all ' + mediaType;
        }

        var data = {
            'User id': userId,
            'Project id': id,
            Source: source,
            'Media type': mediaType
        };
        dlog('logged data for ' + trackExpandViewClick.name + ' :', data);
        (0, _TrackUtils.trackOn)(event, data, { All: true, FreshChat: false });
    };
};

var logSubtitleAddition = exports.logSubtitleAddition = function logSubtitleAddition() {
    var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        var _getState16 = getState(),
            userId = _getState16.ui.userId,
            _getState16$project = _getState16.project,
            id = _getState16$project.id,
            editorType = _getState16$project.editorType;

        var event = eventTypes.CAPTION_ADDED;

        var data = _extends({
            'User id': userId,
            'Project id': id,
            'Editor type': editorType
        }, property);

        (0, _TrackUtils.trackOn)(event, data, { All: true, Smartlook: true });
    };
};

var logSubtitleActions = exports.logSubtitleActions = function logSubtitleActions(action) {
    var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (dispatch, getState) {
        var _getState17 = getState(),
            userId = _getState17.ui.userId,
            _getState17$project = _getState17.project,
            id = _getState17$project.id,
            editorType = _getState17$project.editorType;

        var event = null;
        switch (action) {
            case captionActionTypes.ALIGNMENT:
                event = eventTypes.CAPTION_ALIGNMENT_UPDATED;
                break;
            case captionActionTypes.POSITION:
                event = eventTypes.CAPTION_POSITION_UPDATED;
                break;
            case captionActionTypes.THEME:
                event = eventTypes.CAPTION_THEME_SELECTED;
                break;
            case captionActionTypes.TEXT_COLOR:
                event = eventTypes.CAPTION_TEXT_COLOR_UPDATED;
                break;
            case captionActionTypes.BACKGROUND_COLOR:
                event = eventTypes.CAPTION_BACKGROUND_COLOR_UPDATED;
                break;
            case captionActionTypes.FONT:
                event = eventTypes.CAPTION_FONT_UPDATED;
                break;
            case captionActionTypes.FONT_SIZE:
                event = eventTypes.CAPTION_FONT_SIZE_UPDATED;
                break;
            case captionActionTypes.OPACITY:
                event = eventTypes.CAPTION_OPACITY_UPDATED;
                break;
            case captionActionTypes.ANIMATION:
                event = eventTypes.CAPTION_ANIMATION_UPDATED;
                break;
            case captionActionTypes.LETTER_SPACING:
                event = eventTypes.CAPTION_LETTER_SPACING_UPDATED;
                break;
            case captionActionTypes.LINE_HEIGHT:
                event = eventTypes.CAPTION_LINE_HEIGHT_UPDATED;
                break;
            default:
        }

        var data = _extends({
            'User id': userId,
            'Project id': id,
            'Editor type': editorType
        }, property);

        (0, _TrackUtils.trackOn)(event, data, { All: true, FreshChat: false });
    };
};

var idleNudgeActions = exports.idleNudgeActions = function idleNudgeActions(action) {
    var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (dispatch, getState) {
        var _getState18 = getState(),
            userId = _getState18.ui.userId,
            _getState18$project = _getState18.project,
            id = _getState18$project.id,
            editorType = _getState18$project.editorType;

        var event = '';
        switch (action.type) {
            case idleNudgeActionTypes.INACTIVITY_MODAL_OPENED:
                event = eventTypes.INACTIVITY_MODAL_OPENED;
                break;
            case idleNudgeActionTypes.HELP_MODAL_OPENED:
                event = eventTypes.HELP_MODAL_OPENED;
                break;
            default:
                event = 'idle event';
        }

        var data = _extends({
            'Editor type': editorType
        }, property);
        (0, _TrackUtils.trackOn)(event, data, { All: true, FreshChat: false });
    };
};

var instructionNudgeActions = exports.instructionNudgeActions = function instructionNudgeActions(action) {
    var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (dispatch, getState) {
        var _getState19 = getState(),
            userId = _getState19.ui.userId,
            _getState19$project = _getState19.project,
            id = _getState19$project.id,
            editorType = _getState19$project.editorType;

        var event = eventTypes.ONBOARDIN_NUDGE_CLICKED;

        var data = _extends({
            'Editor type': editorType
        }, property);
        (0, _TrackUtils.trackOn)(event, data, { All: true, Freshchat: false });
    };
};

var logFormatAddedFromNoSignup = exports.logFormatAddedFromNoSignup = function logFormatAddedFromNoSignup(message, formatId) {
    return function (dispatch, getState) {
        var formatData = (0, _ReelHelpers.getFormatData)(formatId);
        var data = null;
        if (formatData) {
            var _getState20 = getState(),
                userId = _getState20.ui.userId,
                _getState20$project = _getState20.project,
                id = _getState20$project.id,
                editorType = _getState20$project.editorType;

            data = {
                aspectRatio: formatData.size,
                label: formatData.label,
                pixels: formatData.pixels,
                message: message,
                'Editor type': editorType
            };
        }

        dlog({
            event: eventTypes.FORMAT_USED,
            data: data
        });
        (0, _TrackUtils.trackOnPostHog)(eventTypes.FORMAT_USED, data);
    };
};

var trackConfigurationSave = exports.trackConfigurationSave = function trackConfigurationSave() {
    return function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState21 = getState(),
                userId = _getState21.ui.userId,
                _getState21$project = _getState21.project,
                projectId = _getState21$project.id,
                editorType = _getState21$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Editor type': editorType
            };

            (0, _TrackUtils.trackOnAll)(eventTypes.CONFIG_SAVE, data);
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

var trackTemplateReplace = exports.trackTemplateReplace = function trackTemplateReplace(replaceKey, replaceStyleGroup) {
    return function (dispatch, getState) {
        try {
            if (!analyticsEnabled) return;

            var _getState22 = getState(),
                userId = _getState22.ui.userId,
                _getState22$project = _getState22.project,
                projectId = _getState22$project.id,
                editorType = _getState22$project.editorType;

            var data = {
                'User id': userId,
                'Project id': projectId,
                'Editor type': editorType,
                'Template type group': replaceStyleGroup,
                'Template type': replaceKey
            };

            (0, _TrackUtils.trackOnAll)(eventTypes.TEMPLATE_REPLACED, data);
        } catch (err) {
            console.log('Error logging data - ' + err);
        }
    };
};

/** ********************************* */

},{"../../common/utils/ReelHelpers":85,"../../common/utils/TrackUtils":90,"../constants/TransitionType":209,"./idleModalActions":158,"keymirror":677}],161:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MediaActionType = undefined;
exports.addVideoToProjectMedia = addVideoToProjectMedia;
exports.addImageToProjectMedia = addImageToProjectMedia;
exports.addVideoToWorkspaceMedia = addVideoToWorkspaceMedia;
exports.addImageToWorkspaceMedia = addImageToWorkspaceMedia;
exports.addAudioDataToWorkspaceMedia = addAudioDataToWorkspaceMedia;
exports.addMediaFromWorkspaceToProjectMedia = addMediaFromWorkspaceToProjectMedia;
exports.addMediaToWorkspace = addMediaToWorkspace;
exports.addAudioToProjectMedia = addAudioToProjectMedia;
exports.addImageToWorkspaceImages = addImageToWorkspaceImages;
exports.clearProjectAudio = clearProjectAudio;
exports.removeMedia = removeMedia;
exports.removeAudio = removeAudio;
exports.removeProjectMedia = removeProjectMedia;
exports.updateWorkspaceMedia = updateWorkspaceMedia;
exports.updateProjectMedia = updateProjectMedia;
exports.updateWorkspaceProjects = updateWorkspaceProjects;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _workspaceActions = require('./workspaceActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var MediaActionType = exports.MediaActionType = (0, _keymirror2.default)({
    ADD_MULTIPLE_MEDIA: null,

    MEDIA_ADD_VIDEO: null,

    MEDIA_ADD_IMAGE: null,
    MEDIA_ADD_AUDIO: null,
    MEDIA_REMOVE_AUDIO: null,
    USER_IMAGES_ADD_IMAGE: null,
    MEDIA_CLEAR_AUDIO: null,
    MEDIA_REMOVE: null,
    PROJECT_MEDIA_REMOVE: null,
    WORKSPACE_MEDIA_ADD_IMAGE: null,
    WORKSPACE_MEDIA_ADD_VIDEO: null,
    WORKSPACE_MEDIA_ADD_AUDIO: null,

    WORKSPACE_ADD_MEDIA: null,

    PROJECT_FROM_WORKSPACE_MEDIA: null,
    WORKSPACE_MEDIA_UPDATING: null,
    WORKSPACE_MEDIA_UPDATED: null,

    PROJECT_MEDIA_UPDATING: null,
    PROJECT_MEDIA_UPDATED: null,

    ADD_ASSET_SVG: null
});

function addVideoToProjectMedia(videoData) {
    var uploadObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return { type: MediaActionType.MEDIA_ADD_VIDEO, videoData: videoData, uploadObj: uploadObj };
}

function addImageToProjectMedia(imageData) {
    var uploadObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return { type: MediaActionType.MEDIA_ADD_IMAGE, imageData: imageData, uploadObj: uploadObj };
}

/**
 * Add a video data to the list of WorkspaceMedia
 * after uploading
 *
 * @export
 * @param {*} videoData
 * @return {*}
 */
function addVideoToWorkspaceMedia(videoData) {
    return { type: MediaActionType.WORKSPACE_MEDIA_ADD_VIDEO, videoData: videoData };
}

/**
 * Add a Image data to the list of workspacemedia
 *
 * @export
 * @param {*} imageData
 * @return {*}
 */
function addImageToWorkspaceMedia(imageData) {
    return { type: MediaActionType.WORKSPACE_MEDIA_ADD_IMAGE, imageData: imageData };
}

/**
 * Add Audio data to workspace media
 *
 * @export
 * @param {*} audioData
 * @return {*}
 */
function addAudioDataToWorkspaceMedia(audioData) {
    return { type: MediaActionType.WORKSPACE_MEDIA_ADD_AUDIO, audioData: audioData };
}

/**
 * Use only when , adding media to project media ..
 * from the workspace content
 *
 * @export
 * @param {*} mediaData
 * @return {*}
 */
function addMediaFromWorkspaceToProjectMedia(mediaData) {
    return { type: MediaActionType.PROJECT_FROM_WORKSPACE_MEDIA, data: mediaData };
}

/**
 * Adds to workspace media , this is for lazy loads
 * and template dependencies
 *
 * @export
 * @param {*} mediaData
 * @return {*}
 */
function addMediaToWorkspace(mediaData) {
    return { type: MediaActionType.WORKSPACE_ADD_MEDIA, data: mediaData };
}

function addAudioToProjectMedia(audioData) {
    var uploadObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return { type: MediaActionType.MEDIA_ADD_AUDIO, audioData: audioData, uploadObj: uploadObj };
}

function addImageToWorkspaceImages(imageData) {
    var uploadObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return { type: MediaActionType.USER_IMAGES_ADD_IMAGE, imageData: imageData, uploadObj: uploadObj };
}

function clearProjectAudio() {
    return { type: MediaActionType.MEDIA_CLEAR_AUDIO };
}

function removeMedia(id) {
    return function (dispatch, getState) {
        var deletedMediaIds = Array.isArray(id) ? id : [id];

        // update image registry for all deleted medias.
        if (!!window.updateImageRegistryForId) {
            deletedMediaIds.forEach(function (mediaId) {
                updateImageRegistryForId(mediaId, { deleted: true });
            });
        }

        dispatch({ type: MediaActionType.MEDIA_REMOVE, id: id });
    };
}

function removeAudio(audioId) {
    return function (dispatch, getState) {
        var deletedMediaIds = Array.isArray(audioId) ? audioId : [audioId];
        deletedMediaIds.forEach(function (id) {
            dispatch({ type: MediaActionType.MEDIA_REMOVE_AUDIO, id: id });
        });
    };
}

function removeProjectMedia(id) {
    return { type: MediaActionType.PROJECT_MEDIA_REMOVE, id: id };
}

function updateWorkspaceMedia(workspaceMedia) {
    return { type: MediaActionType.WORKSPACE_MEDIA_UPDATED, workspaceMedia: workspaceMedia };
}

function updateProjectMedia(projectMedia) {
    return { type: MediaActionType.PROJECT_MEDIA_UPDATED, projectMedia: projectMedia };
}

function updateWorkspaceProjects() {
    var projects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return { type: _workspaceActions.MediaLibraryModalActionType.PROJECT_DETAILS_UPDATED, projects: projects };
}

},{"./workspaceActions":175,"keymirror":677}],162:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLeftPanelPropertyToExpand = exports.closePropertiesPanel = exports.openPropertiesPanel = exports.switchProjectProperties = exports.toggleShelfOpen = exports.ModeActionType = undefined;
exports.switchMode = switchMode;
exports.changeSidebarSection = changeSidebarSection;
exports.setInsertPosForClip = setInsertPosForClip;
exports.setReplaceOverlayMedia = setReplaceOverlayMedia;
exports.clearReplaceInsert = clearReplaceInsert;
exports.closeShelfOnSelectedPresent = closeShelfOnSelectedPresent;
exports._closeShelf = _closeShelf;
exports.closeShelf = closeShelf;
exports.openAudioLibrary = openAudioLibrary;
exports.openSelectedProjectMedia = openSelectedProjectMedia;
exports.openCropClipModal = openCropClipModal;
exports.closeCropClipModal = closeCropClipModal;
exports.openSubtitleShelf = openSubtitleShelf;
exports.setCaptionEditStyleOpen = setCaptionEditStyleOpen;
exports.setCaptionEditStyleClose = setCaptionEditStyleClose;
exports.openAudioProperties = openAudioProperties;
exports.closeAudioProperties = closeAudioProperties;
exports.switchPropertiesPanel = switchPropertiesPanel;
exports.closeProjectProperties = closeProjectProperties;
exports.openDeleteWatermarkModal = openDeleteWatermarkModal;
exports.closeDeleteWatermarkModal = closeDeleteWatermarkModal;
exports.openHideWatermarkModal = openHideWatermarkModal;
exports.closeHideWatermarkModal = closeHideWatermarkModal;
exports.openReplaceWatermarkModal = openReplaceWatermarkModal;
exports.closeReplaceWatermarkModal = closeReplaceWatermarkModal;
exports.upgradeTypito = upgradeTypito;
exports.startExportForNosignupUsers = startExportForNosignupUsers;
exports.openPageLeaveModal = openPageLeaveModal;
exports.closePageLeaveModal = closePageLeaveModal;
exports.openPageReturnModal = openPageReturnModal;
exports.closePageReturnModal = closePageReturnModal;
exports.setNosignupOptions = setNosignupOptions;
exports.clearNosignupOptions = clearNosignupOptions;
exports.selectWatermarkPreview = selectWatermarkPreview;
exports.unselectWatermarkPreview = unselectWatermarkPreview;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _reactRedux = require('react-redux');

var _EditorMode = require('../../common/utils/enums/EditorMode');

var _EditorMode2 = _interopRequireDefault(_EditorMode);

var _reelActions = require('./reelActions');

var _overlayActions = require('./overlayActions');

var _exportActions = require('../../export/actions/exportActions');

var _General = require('../constants/General');

var _loginActions = require('../../login/loginActions');

var _pricingActions = require('../../pricing/actions/pricingActions');

var _workspaceActions = require('./workspaceActions');

var _notificationSystemAction = require('./notificationSystemAction');

var _signUpModalActions = require('./signUpModalActions');

var _PropertiesPanelType = require('../constants/PropertiesPanelType');

var _PropertiesPanelType2 = _interopRequireDefault(_PropertiesPanelType);

var _guardActions = require('./guardActions');

var _InstructionNudge = require('../components/notificationSystem/InstructionNudge.react');

var _reelSelectors = require('../selectors/reelSelectors');

var _TrackUtils = require('../../common/utils/TrackUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// TODO include this actions to be ignored for Persistence Engine
var ModeActionType = exports.ModeActionType = (0, _keymirror2.default)({
    SWITCH_EDITOR_MODE: null,
    CHANGE_SIDEBAR_SECTION: null,
    OPEN_CROP_CLIP_MODAL: null,
    CLOSE_CROP_CLIP_MODAL: null,
    SET_INSERT_PROPERTY: null,
    SET_CAPTION_EDITSTYLE: null,
    SET_REPLACE_OVERLAY: null,
    CLEAR_REPLACE_AND_INSERT: null,
    CLOSE_AUDIO_PROPERTIES: null,
    OPEN_AUDIO_PROPERTIES: null,
    SWITCH_PROPERTY_PANEL: null,
    OPEN_DELETE_WATERMARK_MODAL: null,
    CLOSE_DELETE_WATERMARK_MODAL: null,
    OPEN_HIDE_WATERMARK_MODAL: null,
    CLOSE_HIDE_WATERMARK_MODAL: null,
    OPEN_REPLACE_WATERMARK_MODAL: null,
    CLOSE_REPLACE_WATERMARK_MODAL: null,
    OPEN_SIGNUP_MODAL: null,
    CLOSE_SIGNUP_MODAL: null,
    OPEN_PAGE_LEAVE_MODAL: null,
    CLOSE_PAGE_LEAVE_MODAL: null,
    OPEN_PAGE_RETURN_MODAL: null,
    CLOSE_PAGE_RETURN_MODAL: null,
    SET_NOSIGNUP_OPTIONS: null,
    CLEAR_NOSIGNUP_OPTIONS: null,

    // default watermark selection and unselection
    SELECT_WATERMARK_PREVIEW: null,
    UNSELECT_WATERMARK_PREVIEW: null,

    OPEN_EXPORT_MODAL: null,

    TOGGLE_SHELF: null,
    CLOSE_PROPERTIES_PANEL: null,
    OPEN_PROPERTIES_PANEL: null,
    SET_LEFT_PANEL_PROPERTY_TO_EXPAND: null
});

function switchMode() {
    return function (dispatch, getState) {
        var _getState = getState(),
            mode = _getState.mode;

        var newMode = mode.currentMode == _EditorMode2.default.REEL ? _EditorMode2.default.OVERLAY : _EditorMode2.default.REEL;

        dispatch((0, _overlayActions.selectClear)());

        dispatch({ type: ModeActionType.SWITCH_EDITOR_MODE, newMode: newMode });

        if (window.updateCurrentMode) {
            var isOverlayMode = newMode === _EditorMode2.default.OVERLAY;
            window.updateCurrentMode(isOverlayMode);
        }
    };
}

var toggleShelfOpen = exports.toggleShelfOpen = function toggleShelfOpen() {
    var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function (dispatch, getState) {
        var _getState2 = getState(),
            _getState2$ui$openShe = _getState2.ui.openShelf,
            openShelf = _getState2$ui$openShe === undefined ? false : _getState2$ui$openShe;

        if (openShelf == open) return;
        dispatch({ type: ModeActionType.TOGGLE_SHELF, open: open });
        dispatch((0, _guardActions.unMountPropertiesPanel)(open));
    };
};

/**
 * @param {string} sidebarSectionKey
 * @param {boolean} keepShelfOpen
 * @param {{
 *     selectedAction: string | undefined;
 *     sidebarSubSectionKey: string | undefined;
 * }}
 * @export
 * @returns {any}
 */
function changeSidebarSection(sidebarSectionKey, keepShelfOpen) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$selectedAction = _ref.selectedAction,
        selectedAction = _ref$selectedAction === undefined ? null : _ref$selectedAction,
        _ref$sidebarSubSectio = _ref.sidebarSubSectionKey,
        sidebarSubSectionKey = _ref$sidebarSubSectio === undefined ? null : _ref$sidebarSubSectio;

    return function (dispatch, getState) {
        var state = getState();

        var currentSidebarSectionKey = state.ui.selectedSidebarKey;
        var openShelf = true;
        var showPropertiesPanel = !!state.ui.showPropertiesPanel;
        var showAudioProperties = state.ui.showAudioProperties || false;

        if (currentSidebarSectionKey === sidebarSectionKey) openShelf = !state.ui.openShelf;

        if (keepShelfOpen) openShelf = true;
        (0, _notificationSystemAction.clearSideBarNotificationBadgeCount)(sidebarSectionKey);

        if (!keepShelfOpen || sidebarSectionKey !== _General.Sections.COLLECTIONS.id) {
            (0, _InstructionNudge.dismissEmptyProjectStockMediaNudge)();
        }

        dispatch({
            type: ModeActionType.CHANGE_SIDEBAR_SECTION,
            showAudioProperties: showAudioProperties,
            sidebarSectionKey: sidebarSectionKey,
            sidebarSubSectionKey: sidebarSubSectionKey,
            openShelf: openShelf,
            showPropertiesPanel: showPropertiesPanel,
            selectedAction: selectedAction
        });
        dispatch(closePropertiesPanel());
        dispatch((0, _guardActions.unMountPropertiesPanel)(openShelf));
    };
}

function setInsertPosForClip() {
    var clipId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isClipReplace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var replaceSequenceClipId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var replaceSequenceChildClip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    return function (dispatch, getState) {
        var state = getState();

        if (replaceSequenceChildClip) {
            var selectedClip = (0, _reelSelectors.getCurrentClipSelected)(state);

            if (!!selectedClip && selectedClip.clipType === 'composite') {
                var selectedChildClip = (0, _reelSelectors.getSelectedSequenceInnerClip)(state);

                if (selectedChildClip) {
                    clipId = selectedClip.clipId;
                    replaceSequenceClipId = !!selectedChildClip && selectedChildClip.clipId;
                }
            }
        }

        dispatch({
            type: ModeActionType.SET_INSERT_PROPERTY,
            clipId: clipId,
            position: position,
            isClipReplace: isClipReplace,
            replaceSequenceClipId: replaceSequenceClipId
        });
    };
}

function setReplaceOverlayMedia() {
    return {
        type: ModeActionType.SET_REPLACE_OVERLAY,
        replaceOverlayMedia: true,
        isClipReplace: false,
        replaceSequenceClipId: null
    };
}

function clearReplaceInsert() {
    return { type: ModeActionType.CLEAR_REPLACE_AND_INSERT };
}

function closeShelfOnSelectedPresent() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected;

        dispatch(closePropertiesPanel());
    };
}

function _closeShelf(getState) {
    var state = getState();

    var currentSidebarSectionKey = state.ui.selectedSidebarKey;
    var showAudioProperties = state.ui.showAudioProperties || false;
    return {
        type: ModeActionType.CHANGE_SIDEBAR_SECTION,
        sidebarSectionKey: currentSidebarSectionKey,
        sidebarSubSectionKey: null,
        openShelf: false,
        showPropertiesPanel: true,
        showAudioProperties: showAudioProperties
    };
}

function closeShelf() {
    return function (dispatch, getState) {
        dispatch(_closeShelf(getState));
    };
}

function openAudioLibrary(sidebarSectionKey) {
    return function (dispatch, getState) {
        var state = getState();
        var showAudioProperties = state.ui.showAudioProperties || false;
        dispatch({
            type: ModeActionType.CHANGE_SIDEBAR_SECTION,
            sidebarSectionKey: _General.Sections.AUDIO.id,
            openShelf: true,
            showAudioProperties: showAudioProperties
        });
    };
}

// export function openSelectedAudio (sidebarSectionKey) {
//     return (dispatch, getState) => {
//         dispatch({ type: ModeActionType.CHANGE_SIDEBAR_SECTION, sidebarSectionKey: 'AUDIO', showAudioProperties: true, openShelf: false })
//     }
// }

// export function closeSelectedAudio (sidebarSectionKey) {
//     return (dispatch, getState) => {
//         const state = getState()
//         let currentSidebarSectionKey = state.ui.selectedSidebarKey
//         dispatch({ type: ModeActionType.CHANGE_SIDEBAR_SECTION, sidebarSectionKey: currentSidebarSectionKey, showAudioProperties: false, openShelf: state.ui.openShelf })
//     }
// }

function openSelectedProjectMedia() {
    var openShelf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        dispatch({
            type: ModeActionType.CHANGE_SIDEBAR_SECTION,
            sidebarSectionKey: _General.Sections.VIDEOS.id,
            openShelf: openShelf
        });
        dispatch(closePropertiesPanel());
    };
}

function openCropClipModal() {
    return { type: ModeActionType.OPEN_CROP_CLIP_MODAL };
}

function closeCropClipModal() {
    return { type: ModeActionType.CLOSE_CROP_CLIP_MODAL };
}

function openSubtitleShelf() {
    var showAppearanceTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return {
        type: ModeActionType.CHANGE_SIDEBAR_SECTION,
        sidebarSectionKey: _General.Sections.SUBTITLES.id,
        openShelf: true,
        showAppearanceTab: showAppearanceTab
    };
}

function setCaptionEditStyleOpen() {
    return {
        type: ModeActionType.SET_CAPTION_EDITSTYLE,
        captionEditStyle: true
    };
}
function setCaptionEditStyleClose() {
    return {
        type: ModeActionType.SET_CAPTION_EDITSTYLE,
        captionEditStyle: false
    };
}
function openAudioProperties() {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _reelActions.unselectAllClips)());
            dispatch((0, _overlayActions.selectClear)());
            dispatch(unselectWatermarkPreview());
            dispatch({ type: ModeActionType.OPEN_AUDIO_PROPERTIES });
            dispatch(closeShelf());
            dispatch(openPropertiesPanel());
        });
    };
}
function closeAudioProperties() {
    return { type: ModeActionType.CLOSE_AUDIO_PROPERTIES };
}
function switchPropertiesPanel(selectedTab) {
    return { type: ModeActionType.SWITCH_PROPERTY_PANEL, selectedTab: selectedTab };
}

function closeProjectProperties() {
    return { type: ModeActionType.SWITCH_PROPERTY_PANEL, selectedTab: _PropertiesPanelType2.default.OPTIONS };
}

function openDeleteWatermarkModal() {
    return function (dispatch, getState) {
        var containsWatermark = getState().project.containsWatermark;

        if (!containsWatermark) return dispatch((0, _reelActions.hideWatermark)());
        return dispatch({ type: ModeActionType.OPEN_DELETE_WATERMARK_MODAL });
    };
}
function closeDeleteWatermarkModal() {
    return { type: ModeActionType.CLOSE_DELETE_WATERMARK_MODAL };
}

function openHideWatermarkModal() {
    return function (dispatch, getState) {
        var containsWatermark = getState().project.containsWatermark;

        if (!containsWatermark) return dispatch((0, _reelActions.hideWatermark)());
        return dispatch({ type: ModeActionType.OPEN_HIDE_WATERMARK_MODAL });
    };
}
function closeHideWatermarkModal() {
    return { type: ModeActionType.CLOSE_HIDE_WATERMARK_MODAL };
}

function openReplaceWatermarkModal() {
    return function (dispatch, getState) {
        var containsWatermark = getState().project.containsWatermark;

        if (!containsWatermark) return dispatch((0, _overlayActions.replaceWatermarkOverlay)());
        return dispatch({ type: ModeActionType.OPEN_REPLACE_WATERMARK_MODAL });
    };
}
function closeReplaceWatermarkModal() {
    return { type: ModeActionType.CLOSE_REPLACE_WATERMARK_MODAL };
}

function upgradeTypito() {
    var triggerAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        var state = getState();

        // temp data for logging
        window.upgradeTriggerAction = triggerAction;

        if (window.isNoSignupEditor) {
            dispatch(setNosignupOptions({ postPaymentAction: 'export' }));
            return dispatch((0, _pricingActions.openPlanModal)(triggerAction));
        }
        dispatch((0, _exportActions.justRemoveWatermark)());
    };
}

function startExportForNosignupUsers(_ref2) {
    var options = _ref2.options,
        source = _ref2.source;

    return function (dispatch, getState) {
        if ((0, _loginActions.isUpgradeNeeded)(getState())) {
            dispatch(setNosignupOptions({ postPaymentAction: 'export' }));
            return dispatch((0, _workspaceActions.showPremiumInstances)(source));
        }

        dispatch((0, _signUpModalActions.openSignupModal)({ options: options, source: source }));
    };
}

function openPageLeaveModal() {
    return { type: ModeActionType.OPEN_PAGE_LEAVE_MODAL };
}
function closePageLeaveModal() {
    return { type: ModeActionType.CLOSE_PAGE_LEAVE_MODAL };
}

function openPageReturnModal() {
    return { type: ModeActionType.OPEN_PAGE_RETURN_MODAL };
}
function closePageReturnModal() {
    return { type: ModeActionType.CLOSE_PAGE_RETURN_MODAL };
}

function setNosignupOptions(options) {
    return { type: ModeActionType.SET_NOSIGNUP_OPTIONS, options: options };
}
function clearNosignupOptions() {
    return { type: ModeActionType.CLEAR_NOSIGNUP_OPTIONS };
}

function selectWatermarkPreview() {
    return function (dispatch, getState) {
        var containsWatermark = getState().project.containsWatermark;

        if (!containsWatermark) return;

        (0, _reactRedux.batch)(function () {
            dispatch((0, _reelActions.unselectAllClips)());
            dispatch((0, _overlayActions.selectClear)());
            dispatch(closeAudioProperties());
            dispatch({ type: ModeActionType.SELECT_WATERMARK_PREVIEW });
            dispatch(closeShelf());
        });
    };
}

function unselectWatermarkPreview() {
    return { type: ModeActionType.UNSELECT_WATERMARK_PREVIEW };
}

var switchProjectProperties = exports.switchProjectProperties = function switchProjectProperties(selectedTab) {
    return {
        type: ModeActionType.SWITCH_PROPERTY_PANEL,
        selectedTab: selectedTab
    };
};

var openPropertiesPanel = exports.openPropertiesPanel = function openPropertiesPanel() {
    return {
        type: ModeActionType.OPEN_PROPERTIES_PANEL
    };
};

var closePropertiesPanel = exports.closePropertiesPanel = function closePropertiesPanel() {
    return {
        type: ModeActionType.CLOSE_PROPERTIES_PANEL
    };
};

var setLeftPanelPropertyToExpand = exports.setLeftPanelPropertyToExpand = function setLeftPanelPropertyToExpand(propToExpand) {
    return {
        type: ModeActionType.SET_LEFT_PANEL_PROPERTY_TO_EXPAND,
        propToExpand: propToExpand
    };
};

},{"../../common/utils/TrackUtils":90,"../../common/utils/enums/EditorMode":94,"../../export/actions/exportActions":246,"../../login/loginActions":262,"../../pricing/actions/pricingActions":265,"../components/notificationSystem/InstructionNudge.react":194,"../constants/General":203,"../constants/PropertiesPanelType":206,"../selectors/reelSelectors":221,"./guardActions":157,"./notificationSystemAction":163,"./overlayActions":165,"./reelActions":170,"./signUpModalActions":172,"./workspaceActions":175,"keymirror":677,"react-redux":1079}],163:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notificationOnFirstClipAdd = exports.incrementIfShelfClosed = exports.clearSideBarNotificationBadgeCount = exports.increaseSideBarNotificationBadgeCount = exports.decreaseSideBarNotificationBadgeCount = undefined;

var _polyfill = require('../../common/utils/scheduler/polyfill');

var _IconNotificationBadge = require('../../common/components/notificationSystem/IconNotificationBadge.react');

var _InstructionNudge = require('../components/notificationSystem/InstructionNudge.react');

var DEBUG = false;

var decreaseSideBarNotificationBadgeCount = exports.decreaseSideBarNotificationBadgeCount = function decreaseSideBarNotificationBadgeCount(tabId, contentId) {
    (0, _IconNotificationBadge.decreaseNotificationBadgeCounter)(tabId, contentId);
};

var increaseSideBarNotificationBadgeCount = exports.increaseSideBarNotificationBadgeCount = function increaseSideBarNotificationBadgeCount(tabId, contentId) {
    (0, _IconNotificationBadge.increaseNotificationBadgeCounter)(tabId, contentId);
};

var clearSideBarNotificationBadgeCount = exports.clearSideBarNotificationBadgeCount = function clearSideBarNotificationBadgeCount(tabId) {
    (0, _IconNotificationBadge.clearNotificationBadgeCounter)(tabId);
};

if (DEBUG) {
    window.decreaseSideBarNotificationBadgeCount = decreaseSideBarNotificationBadgeCount;
    window.increaseSideBarNotificationBadgeCount = increaseSideBarNotificationBadgeCount;
    window.clearSideBarNotificationBadgeCount = clearSideBarNotificationBadgeCount;
}

var incrementIfShelfClosed = exports.incrementIfShelfClosed = function incrementIfShelfClosed(tabId, contentId) {
    return function (dispatch, getState) {
        var state = getState();
        var currentTabId = state.ui.selectedSidebarKey;
        if (tabId !== currentTabId) (0, _IconNotificationBadge.increaseNotificationBadgeCounter)(tabId, contentId);
    };
};

/**
 *
 * Dispatches a tutorial Nudge for User
 * use microtask to schedule the function call after current call stack
 *
 *
 *
 */
var notificationOnFirstClipAdd = exports.notificationOnFirstClipAdd = function notificationOnFirstClipAdd(func) {
    return function (dispatch, getState) {
        var state = getState();
        var oldClips = state.reel.clips;
        // const index = nudgeIdsVisited.findIndex((id) => id === NudgeIds.FIRST_CLIP_TIMELINE_MESSAGE);
        var index = -1;

        if (func) dispatch(func);

        if (oldClips.length === 0 && index < 0) {
            // Since first timeline area is lazilly loaded , the scheduling is done ,
            // based on localIdltask , where the shocase of the nudge is done inside a microtask
            (0, _polyfill.qeueReduxBatchedOperation)(function () {
                (0, _InstructionNudge.dismissEmptyProjectStockMediaNudge)();
            });
        }
    };
};

},{"../../common/components/notificationSystem/IconNotificationBadge.react":24,"../../common/utils/scheduler/polyfill":126,"../components/notificationSystem/InstructionNudge.react":194}],164:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.completeOnboardingStep = exports.onboardingActions = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _userApi = require('../../common/api/userApi');

var _OnboardingSteps = require('../constants/OnboardingSteps');

var _OnboardingSteps2 = _interopRequireDefault(_OnboardingSteps);

var _onboardingSelector = require('../selectors/onboardingSelector');

var _constants = require('../../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var onboardingActions = exports.onboardingActions = (0, _keymirror2.default)({
    MARK_ONBAORDING_STEP: null
});

var completeOnboardingStep = exports.completeOnboardingStep = function completeOnboardingStep(stepId) {
    var userClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState, _ref) {
        var appManager = _ref.appManager;

        var fitnessWorkflowExist = appManager.shouldContainFitnessWorkflow();

        var prevOnboarding = getState().onboarding;

        var _getState = getState(),
            id = _getState.project.id;

        if (!prevOnboarding) {
            // Onboarding should be disabled
            // How did you even end up in this block?
            // TODO gonna report you to the authorities (error.log)
            return;
        }

        var _prevOnboarding$stepI = prevOnboarding.stepInformation;
        _prevOnboarding$stepI = _prevOnboarding$stepI === undefined ? {} : _prevOnboarding$stepI;
        var _prevOnboarding$stepI2 = _prevOnboarding$stepI[stepId];
        _prevOnboarding$stepI2 = _prevOnboarding$stepI2 === undefined ? {} : _prevOnboarding$stepI2;
        var _prevOnboarding$stepI3 = _prevOnboarding$stepI2.completed,
            completed = _prevOnboarding$stepI3 === undefined ? false : _prevOnboarding$stepI3;

        if (completed) return;
        dispatch({
            type: onboardingActions.MARK_ONBAORDING_STEP,
            stepId: stepId,
            state: true,
            userClick: userClick
        });

        var newOnboarding = getState().onboarding;

        if (fitnessWorkflowExist) {
            newOnboarding.workflow = _constants.SupportedEditorWorkflows.fitness;
            newOnboarding.projectId = id;
        }

        (0, _userApi.saveOnboardingData)(newOnboarding);
    };
};

},{"../../common/api/userApi":5,"../../common/constants":61,"../constants/OnboardingSteps":204,"../selectors/onboardingSelector":216,"keymirror":677}],165:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.doAdjustOverlays = exports.replaceWatermarkOverlay = exports.deleteWatermarkOverlay = exports.updateWatermarkOverlaysDebounced = exports.addWatermarkOverlay = exports.createOverlays = exports.findTemplate = exports.setOverlayAudioData = exports.setCounterDurationInOverlay = exports.OverlayActionType = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.removeOverlayMetaEntryForSequence = removeOverlayMetaEntryForSequence;
exports.getRemoveUpdatedOverlaysForSequence = getRemoveUpdatedOverlaysForSequence;
exports.getRemoveOverlayMetaEntryForSequence = getRemoveOverlayMetaEntryForSequence;
exports.addOverlayFromImageId = addOverlayFromImageId;
exports.replaceImageOverlaysWithImageId = replaceImageOverlaysWithImageId;
exports.replaceImageOverlay = replaceImageOverlay;
exports.addOverlayAction = addOverlayAction;
exports.addOverlays = addOverlays;
exports.addSubtitles = addSubtitles;
exports.replaceOverlayStyle = replaceOverlayStyle;
exports.verifyReplaceSequenceTemplateClipData = verifyReplaceSequenceTemplateClipData;
exports.replaceSequenceTemplatesAction = replaceSequenceTemplatesAction;
exports.replaceSequenceTemplates = replaceSequenceTemplates;
exports.getRemoveSequenceTemplatesData = getRemoveSequenceTemplatesData;
exports.removeSequenceTemplates = removeSequenceTemplates;
exports.createSequenceTemplatesFromSequenceData = createSequenceTemplatesFromSequenceData;
exports.addSequenceTemplates = addSequenceTemplates;
exports.addTextOverlay = addTextOverlay;
exports.addImageOverlay = addImageOverlay;
exports.addShapesIconOverlay = addShapesIconOverlay;
exports.addSvgAssetOverlay = addSvgAssetOverlay;
exports.addWorkspaceImageOverlay = addWorkspaceImageOverlay;
exports.addWorkspaceTemplateOverlay = addWorkspaceTemplateOverlay;
exports.selectSequenceOverlay = selectSequenceOverlay;
exports.selectOnly = selectOnly;
exports.selectAdd = selectAdd;
exports.quickSelect = quickSelect;
exports.moveSingleIncremental = moveSingleIncremental;
exports.moveSingleFinish = moveSingleFinish;
exports.moveMultipleIncremental = moveMultipleIncremental;
exports.moveMultipleFinish = moveMultipleFinish;
exports.multipleOverlayChangeIncrementalById = multipleOverlayChangeIncrementalById;
exports.multipleOverlayChangeFinishById = multipleOverlayChangeFinishById;
exports.changeMultipleOverlays = changeMultipleOverlays;
exports.changeSpaceForMultipleOverlays = changeSpaceForMultipleOverlays;
exports.changeMultiOverlays = changeMultiOverlays;
exports.changeMultipleOverlaysFinish = changeMultipleOverlaysFinish;
exports.resizeIncremental = resizeIncremental;
exports.resizeFinish = resizeFinish;
exports.selectClear = selectClear;
exports.clickVideo = clickVideo;
exports.setInTimeIncremental = setInTimeIncremental;
exports.setInTimeIncrementalForSelected = setInTimeIncrementalForSelected;
exports.setInTimeFinish = setInTimeFinish;
exports.setInTimeFinishForSelected = setInTimeFinishForSelected;
exports.setOutTimeIncremental = setOutTimeIncremental;
exports.setOutTimeFinish = setOutTimeFinish;
exports.setOutTimeIncrementalForSelected = setOutTimeIncrementalForSelected;
exports.setOutTimeFinishForSelected = setOutTimeFinishForSelected;
exports.deleteOverlays = deleteOverlays;
exports.deleteOverlaysWithWarning = deleteOverlaysWithWarning;
exports.getSequenceOverlayMetaEntriesToRemove = getSequenceOverlayMetaEntriesToRemove;
exports.deleteSelectedOverlays = deleteSelectedOverlays;
exports.deleteOverlayById = deleteOverlayById;
exports.copySelectedOverlays = copySelectedOverlays;
exports.pasteCopiedTemplate = pasteCopiedTemplate;
exports.saveWorkspaceTemplate = saveWorkspaceTemplate;
exports.deleteWorkspaceTemplate = deleteWorkspaceTemplate;
exports.deleteWorkspaceImage = deleteWorkspaceImage;
exports.deleteProjectMedia = deleteProjectMedia;
exports.deleteWorkspaceMedia = deleteWorkspaceMedia;
exports.setChangeColor = setChangeColor;
exports.changeOverlayIncremental = changeOverlayIncremental;
exports.changeOverlayFinish = changeOverlayFinish;
exports.changeOverlayFinishById = changeOverlayFinishById;
exports.changeOverlayFinishFromCurrent = changeOverlayFinishFromCurrent;
exports.changeOverlay = changeOverlay;
exports.changeOverlayText = changeOverlayText;
exports.setFocus = setFocus;
exports.onAnimationTypeChange = onAnimationTypeChange;
exports.onAnimationDurationChange = onAnimationDurationChange;
exports.onAnimationManualModeChange = onAnimationManualModeChange;
exports.pushOverlayBack = pushOverlayBack;
exports.pushOverlayForward = pushOverlayForward;
exports.setSelectingRect = setSelectingRect;
exports.endSelectingRect = endSelectingRect;
exports.clickOutsideVideo = clickOutsideVideo;
exports.onSetGroupAnimation = onSetGroupAnimation;
exports.multiSelect = multiSelect;
exports.selectAnimGroup = selectAnimGroup;
exports.removeAnimGroup = removeAnimGroup;
exports.updateWorkspaceTemplates = updateWorkspaceTemplates;
exports.removeWorkspaceImage = removeWorkspaceImage;
exports.addBitmapTemplate = addBitmapTemplate;
exports.fontLoaded = fontLoaded;
exports.filterTemplates = filterTemplates;
exports.adjustOverlayTimeline = adjustOverlayTimeline;
exports.loadMoreTemplates = loadMoreTemplates;
exports.disableOverlayMovement = disableOverlayMovement;
exports.multipleAlignCenterHorizontal = multipleAlignCenterHorizontal;
exports.multipleAlignCenterVertical = multipleAlignCenterVertical;
exports.multipleAlignLeft = multipleAlignLeft;
exports.multipleAlignRight = multipleAlignRight;
exports.multipleAlignTop = multipleAlignTop;
exports.multipleAlignBottom = multipleAlignBottom;
exports.changeMultipleOverlayEnterTime = changeMultipleOverlayEnterTime;
exports.changeMultipleOverlayShadow = changeMultipleOverlayShadow;
exports.changeMultipleOverlayOpacity = changeMultipleOverlayOpacity;
exports.changeMultipleOverlayRotate = changeMultipleOverlayRotate;
exports.changeMultipleOverlayFontFamily = changeMultipleOverlayFontFamily;
exports.changeMultipleOverlayColor = changeMultipleOverlayColor;
exports.hideSelectedOverlays = hideSelectedOverlays;
exports.hideOverlayByIds = hideOverlayByIds;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _cloneextend = require('cloneextend');

var _reactRedux = require('react-redux');

var _diffMatchPatch = require('diff-match-patch');

var _diffMatchPatch2 = _interopRequireDefault(_diffMatchPatch);

var _TrackUtils = require('../../common/utils/TrackUtils');

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _EditorMode = require('../../common/utils/enums/EditorMode');

var _EditorMode2 = _interopRequireDefault(_EditorMode);

var _LayerUtils = require('../../common/utils/renderer/LayerUtils');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _PropertiesPanelType = require('../constants/PropertiesPanelType');

var _PropertiesPanelType2 = _interopRequireDefault(_PropertiesPanelType);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _ColorRange = require('../../common/utils/ColorRange');

var _ColorRange2 = _interopRequireDefault(_ColorRange);

var _HighlightColorRange = require('../../common/utils/HighlightColorRange');

var _HighlightColorRange2 = _interopRequireDefault(_HighlightColorRange);

var _OverlayUtils = require('../utils/OverlayUtils');

var _ReelHelpers = require('../../common/utils/ReelHelpers');

var _mediaActions = require('./mediaActions');

var _logActions = require('./logActions');

var _sequenceSelectors = require('../selectors/sequenceSelectors');

var _api = require('../api');

var _playerActions = require('./playerActions');

var _reelActions = require('./reelActions');

var reelActions = _interopRequireWildcard(_reelActions);

var _modeActions = require('./modeActions');

var modeActions = _interopRequireWildcard(_modeActions);

var _uiActions = require('./uiActions');

var _emptyProjectActions = require('./emptyProjectActions');

var _workspaceActions = require('./workspaceActions');

var _reelSelectors = require('../selectors/reelSelectors');

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _watermarkUtils = require('../../common/utils/watermarkUtils');

var _General = require('../constants/General');

var _leftShelf = require('./leftShelf');

var _errorReporting = require('../../common/utils/errorReporting');

var _guardActions = require('./guardActions');

var _onboardingActions = require('./onboardingActions');

var _CommonAlgorithms = require('../../common/utils/CommonAlgorithms');

var _general = require('../components/utility/pluginUtils/general');

var _pluginActions = require('./pluginActions');

var _projectAssetSelectors = require('../selectors/projectAssetSelectors');

var _overlaySelectors = require('../selectors/overlaySelectors');

var _deleteWarningActions = require('./deleteWarningActions');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var getOverlayToSequenceClipIdMap = (0, _sequenceSelectors.makeGetOverlayToSequenceClipIdMap)();

var DEBUG = false;

var dlog = (0, _GeneralUtils.createDlog)(true);

var MAX_OVERLAYS_ADD_ONCE = 30;

var shadowProps = function shadowProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'shadow';
    });
};
var alphaProps = function alphaProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'alpha';
    });
};

var OverlayActionType = exports.OverlayActionType = (0, _keymirror2.default)({
    OV_ADD: null,
    SUB_ADD: null,
    OV_DELETE: null,
    OV_COPY: null,
    OV_SAVE: null,
    OV_REPLACE: null,
    SELECT: null,
    SELECT_ADD: null,
    SELECT_SET: null,
    SELECT_CLEAR: null,
    MOVE_SINGLE_INCR: null,
    MOVE_SINGLE_FINISH: null,
    MOVE_MULTIPLE_INCR: null,
    MOVE_MULTIPLE_FINISH: null,
    RESIZE_INCR: null,
    RESIZE_FINISH: null,
    CHANGE_TEXT: null,
    CHANGE_OVERLAY: null,
    CHANGE_OVERLAY_INCR: null,
    CHANGE_OVERLAY_FINISH: null,

    CHANGE_SPACE_FOR_OVERLAYS: null,

    CHANGE_OVERLAY_MULTIPLE: null,

    CHANGE_MULTI_OVERLAYS: null,

    SET_SELECTED_COLOR: null,
    SET_FOCUS: null,
    CHANGE_ZINDEX: null,
    SET_IN_TIME_INCR: null,
    SET_IN_TIME_FINISH: null,

    MULTI_SET_TIME_RANGE: null,

    SET_OUT_TIME_INCR: null,
    SET_OUT_TIME_FINISH: null,
    SET_IN_ANIM: null,
    SET_IN_ANIM_DURATION: null,
    SET_IN_ANIM_DURATION_MANUAL_MODE: null,
    SET_OUT_ANIM: null,
    SET_OUT_ANIM_DURATION: null,
    SET_OUT_ANIM_DURATION_MANUAL_MODE: null,
    UPDATE_ANIM_GROUPS: null,
    SET_SELECTING_RECT: null,
    END_SELECTING_RECT: null,
    TEMPLATES_LOAD: null,

    TEMPLATES_UPDATE_ID: null,
    TEMPLATES_BITMAP_ADD: null,

    TEMPLATES_SVG_ADD: null,

    FONT_LOAD: null,
    FILTER_TEMPLATES: null,
    OVERLAYS_ADJUST: null,
    REMOVE_IMAGE: null,
    ADJUST_OVERLAY_TIMES: null,

    LOAD_MORE_TEMPLATES: null,

    DISABLE_OVERLAY_MOVEMENT: null,

    SHOW_SAVED_TEMPLATE: null,

    CHANGE_MULTIPLE_OVERLAY: null,
    CHANGE_MULTIPLE_OVERLAY_FINISH: null,

    SEQUENCE_UPDATE_OVERLAYMETA: null,

    SEQUENCE_OVERLAY_CHANGE_CLIPID: null,

    SEQUENCE_OVERLAY_UPDATE: null,

    REFRESH_OVERLAY_DATA: null,

    HIDE_OVERLAY: null,

    ADD_TIME_OFFSET_FOR_PROGRESS_BAR: null
});

var getOverlayIdToSequenceClipIdMap = (0, _sequenceSelectors.makeGetOverlayToSequenceClipIdMap)();

/// ////////// Sequence actions //////////////

/**
 * This will be required to Undo Break APART ,
 * // TODO create BREAK APART EVENT HANDLE THAT IN OVERLAY META INSTEAD OF GENERIC EVENT
 *
 * @export
 * @param {*} [clipId=null]
 * @return {*}
 */
function removeOverlayMetaEntryForSequence() {
    var clipId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        var _getState = getState(),
            _getState$overlaymeta = _getState.overlaymeta.sequenceOverlays,
            sequenceOverlays = _getState$overlaymeta === undefined ? {} : _getState$overlaymeta;

        if (!sequenceOverlays[clipId]) return;

        var data = sequenceOverlays[clipId],
            other = _objectWithoutProperties(sequenceOverlays, [clipId]);

        dispatch({
            type: OverlayActionType.SEQUENCE_UPDATE_OVERLAYMETA,
            sequenceOverlayMetaEntries: other,
            previousSequenceOverlayMetaEntries: sequenceOverlays
        });
    };
}

function getRemoveUpdatedOverlaysForSequence() {
    var clipId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var state = arguments[1];

    var overlays = (0, _overlaySelectors.getNonWaterMarkOverlays)(state);
    var sequenceOverlays = (state.overlaymeta.sequenceOverlays || {})[clipId];
    var editedOverlays = Object.keys(sequenceOverlays || {}).map(function (key) {
        var data = overlays[key];

        var hide = data.hide,
            otherData = _objectWithoutProperties(data, ['hide']);

        return otherData;
    });

    var originalOverlays = Object.keys(sequenceOverlays || {}).map(function (key) {
        var data = overlays[key];
        return data;
    }, {});

    return {
        type: OverlayActionType.CHANGE_MULTIPLE_OVERLAY,
        overlays: editedOverlays,
        originalOverlays: originalOverlays
    };
}

function getRemoveOverlayMetaEntryForSequence() {
    var clipId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var state = arguments[1];
    var _state$overlaymeta$se = state.overlaymeta.sequenceOverlays,
        sequenceOverlays = _state$overlaymeta$se === undefined ? {} : _state$overlaymeta$se;

    if (!sequenceOverlays[clipId]) return;

    var data = sequenceOverlays[clipId],
        other = _objectWithoutProperties(sequenceOverlays, [clipId]);

    return {
        type: OverlayActionType.SEQUENCE_UPDATE_OVERLAYMETA,
        sequenceOverlayMetaEntries: other,
        previousSequenceOverlayMetaEntries: sequenceOverlays
    };
}

function addOverlayFromImageId(clipId) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$overlayCrop = _ref.overlayCrop,
        overlayCrop = _ref$overlayCrop === undefined ? 'none' : _ref$overlayCrop,
        position = _ref.position;

    return function (dispatch, getState) {
        var category = 'workspaceImages';

        var _getState2 = getState(),
            images = _getState2.templates.images;

        var _images$find = images.find(function (def) {
            return def.id === category;
        }),
            items = _images$find.items;

        var template = items.find(function (item) {
            var imageId = item.values.imageId;

            return imageId === clipId;
        });
        dispatch(addImageOverlay(category, template.id, { overlayCrop: overlayCrop, position: position }));

        try {
            var location = _logActions.mediaAddLocations.OVERLAY;

            var from = _logActions.mediaAddFromLocations.LEFT_PANEL;
            if (window.mediaAddFromLocation == _logActions.mediaAddFromLocations.PREVIEW_MODAL) from = _logActions.mediaAddFromLocations.PREVIEW_MODAL;

            var viaSearch = window.mediaAddedFromSearch == true;
            var viaFilters = window.mediaAddedFromFilters == true;

            // Clean up
            window.mediaAddFromLocation = null;
            window.mediaAddedFromFilters = null;
            window.mediaAddedFromSearch = null;

            dispatch((0, _logActions.trackMediaAdded)(_logActions.mediaTypes.IMAGE, location, from, _logActions.mediaAddDestinations.OVERLAY, viaSearch, viaFilters));
        } catch (err) {
            console.log('Error logging ' + err);
        }
    };
}

function performReplaceMediaId(targetOverlays, selectedTemplate) {
    var newOverlays = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = targetOverlays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var overlay = _step.value;
            var imageId = selectedTemplate.values.imageId,
                _selectedTemplate$spa = selectedTemplate.space,
                width = _selectedTemplate$spa.width,
                height = _selectedTemplate$spa.height,
                defId = selectedTemplate.defId;
            var _overlay$changeDefId = overlay.changeDefId,
                changeDefId = _overlay$changeDefId === undefined ? false : _overlay$changeDefId;

            var otherProps = {};
            if (changeDefId) {
                otherProps.defId = defId;
            }

            var newOverlay = (0, _deepmerge2.default)(overlay, _extends({}, otherProps, {
                values: {
                    imageId: imageId
                }
            }));

            delete overlay.changeDefId;

            newOverlays.push(newOverlay);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return newOverlays;
}

/**
 * Used for replacing the media id of local data based overlay images
 *
 * @export
 * @param {*} targetId
 * @param {*} newId
 * @return {*}
 */
function replaceImageOverlaysWithImageId(targetId, newId) {
    return function (dispatch, getState) {
        var state = getState();

        var overlays = state.overlays,
            templates = state.templates;

        var workspaceTemplates = (templates.images.find(function (grp) {
            return grp.id === 'workspaceImages';
        }) || {}).items || [];
        var clickedTemplate = workspaceTemplates.find(function (wi) {
            return wi.values.imageId === newId;
        });

        var imageDefIdForMediaId = (0, _OverlayUtils.getImageDefId)(targetId);

        if (!clickedTemplate) {
            throw new Error('Tried to replace overlays with image id : ' + targetId + ' but could not find image id : ' + newId);
        }

        var targetOverlays = Object.keys(overlays).filter(function (key) {
            var overlay = overlays[key];
            var _overlay$values$image = overlay.values.imageId,
                imageId = _overlay$values$image === undefined ? null : _overlay$values$image;

            if (imageId) return imageId === targetId;
            return false;
        }).map(function (key) {
            var overlay = overlays[key];

            var defId = overlay.defId;

            if (defId === imageDefIdForMediaId && !overlay.isWatermark) overlay.changeDefId = true;

            return overlay;
        });

        if (targetOverlays.length == 0) {
            dlog('no overlays found with mediaId : ' + targetId);
            return;
        }

        dlog('all overlays to replace :', targetOverlays);

        var newOverlayData = performReplaceMediaId(targetOverlays, clickedTemplate);

        dispatch(changeMultiOverlays(newOverlayData, targetOverlays));
    };
}

function replaceImageOverlay(clipId) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$targetOverlayId = _ref2.targetOverlayId,
        targetOverlayId = _ref2$targetOverlayId === undefined ? null : _ref2$targetOverlayId,
        overlayCrop = _ref2.overlayCrop;

    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            overlays = state.overlays,
            templates = state.templates,
            canvas = state.reel.canvas;

        var overlayId = targetOverlayId;
        if (!overlayId) {
            var selectedOverlayIds = Object.keys(selected);
            if (selectedOverlayIds.length !== 1) return;
            overlayId = selectedOverlayIds[0];
        }

        var overlay = overlays[overlayId];
        var animSettings = (0, _overlaySelectors.getAnimGroupSettingsForAllOverlays)(state);
        var defModel = _DefModel.DefModelRegistry.getModelForOverlay(overlay.defId, overlay.id);
        defModel.update(overlay.space, overlay.time, overlay.values, canvas, animSettings[overlay.id], false, false);
        // defModel.seekToStatic();

        var imageIdProps = Object.keys(defModel.def.props).filter(function (pk) {
            return defModel.def.props[pk] === 'imageId';
        });
        var workspaceImages = (templates.images.find(function (grp) {
            return grp.id === 'workspaceImages';
        }) || {}).items || [];
        var clickedTemplate = workspaceImages.find(function (wi) {
            return wi.values.imageId === clipId;
        });

        if (imageIdProps.length === 1 && !!clickedTemplate && !!clickedTemplate.values.imageId) {
            var _extends3;

            var imageId = clickedTemplate.values.imageId,
                _clickedTemplate$spac = clickedTemplate.space,
                width = _clickedTemplate$spac.width,
                height = _clickedTemplate$spac.height,
                transform = _clickedTemplate$spac.transform;
            var placeholders = defModel.def.meta.placeholders;

            var prop = imageIdProps[0];

            if (overlay.isWatermark) {
                var _values;

                var resizeFactor = 1;
                if (width > height) {
                    if (width > _watermarkUtils.DEFAULT_WATERMARK_SIZE) {
                        resizeFactor = _watermarkUtils.DEFAULT_WATERMARK_SIZE / width;
                    }
                } else if (height > _watermarkUtils.DEFAULT_WATERMARK_SIZE) {
                    resizeFactor = _watermarkUtils.DEFAULT_WATERMARK_SIZE / height;
                }

                var canvasResizeFactor = canvas.height / _watermarkUtils.DEFAULT_WATERMARK_CANVAS_SIZE;
                resizeFactor *= canvasResizeFactor;

                var newWidth = width * resizeFactor;
                var newHeight = height * resizeFactor;

                var _newOverlay = (0, _deepmerge2.default)(overlay, {
                    values: (_values = {}, _defineProperty(_values, prop, imageId), _defineProperty(_values, 'cropImageX', 0), _defineProperty(_values, 'cropImageY', 0), _defineProperty(_values, 'isInitialImageDimensionChanged', true), _defineProperty(_values, 'imageInitialWidth', width), _defineProperty(_values, 'imageInitialHeight', height), _defineProperty(_values, 'cropImageWidth', width), _defineProperty(_values, 'cropImageHeight', height), _values),
                    space: {
                        transform: '',
                        width: width,
                        height: height
                    }
                });

                dispatch(changeOverlayFinish(_newOverlay, overlay, null, 'replaceImage'));
                dispatch(reelActions.watermarkReplaced());
                return;
            }

            var extraParam = {
                cropImageX: 0,
                cropImageY: 0,
                isInitialImageDimensionChanged: false,
                imageInitialWidth: width,
                imageInitialHeight: height,
                cropImageWidth: width,
                cropImageHeight: height
            };
            if (overlayCrop) {
                extraParam.crop = overlayCrop;
            }

            if (!placeholders || !placeholders[prop]) {
                var spaceValues = getSpaceValuesForReplace(clickedTemplate, overlay);

                var _newOverlay2 = (0, _deepmerge2.default)(overlay, {
                    values: _extends(_defineProperty({}, prop, imageId), extraParam),
                    space: spaceValues
                });

                dispatch(changeOverlayFinish(_newOverlay2, overlay, null, 'replaceImage'));
                return;
            }

            var layerId = placeholders[prop];

            var _getScaleFromTransfor = (0, _LayerUtils.getScaleFromTransformString)(overlay.space.transform),
                _getScaleFromTransfor2 = _slicedToArray(_getScaleFromTransfor, 2),
                scaleX = _getScaleFromTransfor2[0],
                scaleY = _getScaleFromTransfor2[1];

            var _defModel$getAttrsFor = defModel.getAttrsForLayer(layerId, true),
                lw = _defModel$getAttrsFor.width,
                lh = _defModel$getAttrsFor.height;

            var targetAspectRatio = lw * scaleX / (lh * scaleY);

            var cropX = 0;
            var cropY = 0;
            var cropWidth = 100;
            var cropHeight = 100;

            if (height < width) {
                var _newWidth = height * targetAspectRatio;
                var difference = (width - _newWidth) / 2;
                cropX = difference / width * 100;
                cropWidth = _newWidth / width * 100;
            } else {
                var _newHeight = width / targetAspectRatio;
                var _difference = (height - _newHeight) / 2;
                cropY = _difference / height * 100;
                cropHeight = _newHeight / height * 100;
            }

            var newOverlay = (0, _deepmerge2.default)(overlay, {
                values: _extends((_extends3 = {}, _defineProperty(_extends3, prop, imageId), _defineProperty(_extends3, 'cropX', cropX), _defineProperty(_extends3, 'cropY', cropY), _defineProperty(_extends3, 'cropWidth', cropWidth), _defineProperty(_extends3, 'cropHeight', cropHeight), _extends3), extraParam)
            });

            dispatch(changeOverlayFinish(newOverlay, overlay, null, 'replaceImage'));

            try {
                var mediaReplacementType = _logActions.mediaReplacementTypes.LEFT_PANEL;
                if (window.mediaReplacementType) mediaReplacementType = window.mediaReplacementType;

                window.mediaReplacementType = null;

                dispatch((0, _logActions.mediaReplaced)(_logActions.mediaTypes.IMAGE, _logActions.mediaTypes.IMAGE, mediaReplacementType));
            } catch (err) {
                console.log('Error logging data : ' + err);
            }
        }
    };
}

// overlay duration should be integer value for counter overlays.
var setCounterDurationInOverlay = exports.setCounterDurationInOverlay = function setCounterDurationInOverlay(overlay, projectDuration) {
    var def = getTemplateDefForId(overlay.defId);

    if (def.meta.containsCounter) {
        var newOverlayDuration = Math.floor(Math.max(1, Math.ceil(Math.round((overlay.time.exitdone - overlay.time.enterstart) / 1000))) * 1000);

        var newEndTime = Math.floor(overlay.time.enterstart + newOverlayDuration);

        if (newEndTime > projectDuration && newOverlayDuration > 1000) {
            newEndTime = Math.floor(newEndTime - Math.ceil(newEndTime - projectDuration));
        }

        overlay.time = _extends({}, overlay.time, {
            enterdone: newEndTime,
            exitstart: newEndTime,
            exitdone: newEndTime
        });
    }
};

var setOverlayAudioData = exports.setOverlayAudioData = function setOverlayAudioData(overlay) {
    if (_OverlayUtils.overlaysWithAudio[overlay.defId]) {
        var audioDuration1 = overlay.values.audioDuration1,
            _overlay$time = overlay.time,
            exitdone = _overlay$time.exitdone,
            enterstart = _overlay$time.enterstart;

        var newDuration = Math.floor(Math.max(0, Math.min(audioDuration1, exitdone - enterstart - 1000)));
        overlay.values = _extends({}, overlay.values, {
            audioDuration1: newDuration
        });
    }
};

var findTemplate = exports.findTemplate = function findTemplate(type, templates, templateId, groupId) {
    return templates[type].find(function (grp) {
        return groupId === grp.id;
    }).items.find(function (t) {
        return templateId === t.id;
    });
};

var createOverlays = exports.createOverlays = function createOverlays(template, player, overlays, reel, dispatch, type, position) {
    // if the video was playing, pause it
    var playbackState = player.playbackState,
        duration = player.duration;

    if (playbackState === _PlaybackState2.default.PLAYING) {
        dispatch((0, _playerActions.pause)());
    }

    var _createOverlaysFromTe = (0, _OverlayUtils.createOverlaysFromTemplate)(template, overlays, reel.canvas, type, null, position),
        createdOverlays = _createOverlaysFromTe.overlays,
        overlaymeta = _createOverlaysFromTe.overlaymeta;

    var minStartTime = 999999999;
    var maxEndTime = duration;
    createdOverlays.forEach(function (o) {
        var enterstart = o.time.enterstart;

        minStartTime = Math.min(minStartTime, enterstart);
    });

    // Set the start time as the current time
    // Set default color on add
    createdOverlays.forEach(function (o) {
        var _o$time = o.time,
            enterstart = _o$time.enterstart,
            enterdone = _o$time.enterdone,
            exitstart = _o$time.exitstart,
            exitdone = _o$time.exitdone;

        var defaultDuration = exitdone - enterstart;

        var durationOffset = player.time;

        // ensures that the overlay duration is min(default overlay duration, reel duration)
        if (durationOffset + defaultDuration > player.duration) {
            durationOffset = Math.max(0, player.duration - defaultDuration);
        }

        o.time.enterstart = Math.floor(enterstart - minStartTime + durationOffset);
        o.time.enterdone = Math.floor(enterdone - minStartTime + durationOffset);
        o.time.exitstart = Math.floor(Math.min(maxEndTime, exitstart - minStartTime + durationOffset));
        o.time.exitdone = Math.floor(Math.min(maxEndTime, exitdone - minStartTime + durationOffset));

        setCounterDurationInOverlay(o, player.duration);
        setOverlayAudioData(o);
    });

    return { overlays: createdOverlays, overlaymeta: overlaymeta };
};

function getSpaceValuesForReplace(template, overlay) {
    var _template$space = template.space,
        templateWidth = _template$space.width,
        templateHeight = _template$space.height;

    var scale = 1;
    if (templateWidth > templateHeight) {
        scale = overlay.space.width / templateWidth;
    } else {
        scale = overlay.space.height / templateHeight;
    }

    return _extends({}, template.space, {
        x: overlay.space.x,
        y: overlay.space.y,
        width: templateWidth,
        height: templateHeight,
        transform: ''
    });
}

function addOverlayAction(overlays) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$shouldSelectAll = _ref3.shouldSelectAll,
        shouldSelectAll = _ref3$shouldSelectAll === undefined ? true : _ref3$shouldSelectAll,
        _ref3$sequenceOverlay = _ref3.sequenceOverlayMetaEntries,
        sequenceOverlayMetaEntries = _ref3$sequenceOverlay === undefined ? null : _ref3$sequenceOverlay,
        selectedOverlayIds = _ref3.selectedOverlayIds;

    return {
        type: OverlayActionType.OV_ADD,
        overlays: overlays,
        shouldSelectAll: shouldSelectAll,
        sequenceOverlayMetaEntries: sequenceOverlayMetaEntries,
        selectedOverlayIds: selectedOverlayIds
    };
}

/**
 *
 *
 * @export
 * @param {*} overlays
 * @param {{
 *   shouldClearSelect: boolean,
 *   shouldSelectAll : boolean,
 *   afterProcessing : Function,
 * }}
 * @return {*}
 */
function addOverlays(overlays) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$shouldClearSele = _ref4.shouldClearSelect,
        shouldClearSelect = _ref4$shouldClearSele === undefined ? false : _ref4$shouldClearSele,
        _ref4$shouldSelectAll = _ref4.shouldSelectAll,
        shouldSelectAll = _ref4$shouldSelectAll === undefined ? true : _ref4$shouldSelectAll,
        _ref4$afterProcessing = _ref4.afterProcessing,
        afterProcessing = _ref4$afterProcessing === undefined ? null : _ref4$afterProcessing,
        _ref4$sequenceOverlay = _ref4.sequenceOverlayMetaEntries,
        sequenceOverlayMetaEntries = _ref4$sequenceOverlay === undefined ? null : _ref4$sequenceOverlay;

    return function (dispatch) {
        (0, _reactRedux.batch)(function () {
            dispatch(addOverlayAction(overlays, {
                shouldSelectAll: shouldSelectAll,
                sequenceOverlayMetaEntries: sequenceOverlayMetaEntries
            }));

            dispatch((0, _logActions.trackOverlayAction)(_logActions.overlayActionType.ADD, overlays.length));

            if (shouldClearSelect) dispatch(selectClear());
            // TODO -- better recognition of this ???
            if (window.isNoSignupEditor) {
                dispatch((0, _onboardingActions.completeOnboardingStep)('ADD_TEXT'));
            }
        });

        if (afterProcessing) afterProcessing(overlays);
    };
}

function addSubtitles(subtitles) {
    var autoSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        dispatch({ type: OverlayActionType.SUB_ADD, subtitles: subtitles, autoSelect: autoSelect });
        if (window.isNoSignupEditor) {
            dispatch((0, _onboardingActions.completeOnboardingStep)('ADD_TEXT'));
        }
        if (autoSelect) {
            dispatch((0, _playerActions.seek)(subtitles[0].time.enterstart));
        }
    };
}

/**
 * 1. deletes the overlays with id: `replaceOverlayIds`
 * 2. creates `n (replaceOverlayIds.length)` new overlay using the `template`.
 * 3. adds the `sequenceOverlayMetaEntryForNewOverlay` for these new overlay inside the overlaymeta
 * 4. It selects only the overlay added at the position where the cursor is
 *
 * PS: It preserves the time values from the overlay to be replaced.
 *
 * @param {string} replaceOverlayId
 * @param {object} template
 * @param {object} sequenceOverlayMetaEntryForNewOverlay
 */
function replaceOverlayStyle(replaceOverlayIds, template, sequenceOverlayMetaEntryForNewOverlay) {
    return function (dispatch, getState) {
        var state = getState();
        var overlays = state.overlays,
            canvas = state.reel.canvas,
            time = state.player.time;

        var sequenceOverlayMetaEntries = {};
        var sourceOverlays = [];
        var newOverlays = [];
        var overlayIdsMapForDelete = {};
        var selectedOverlayIds = {};

        var overlayToSequenceClipMap = getOverlayToSequenceClipIdMap(state);

        var _template$values = template.values,
            color = _template$values.color,
            color1 = _template$values.color1,
            color2 = _template$values.color2,
            startFraction = _template$values.startFraction,
            endFraction = _template$values.endFraction,
            lowerCalorieLimit = _template$values.lowerCalorieLimit,
            higherCalorieLimit = _template$values.higherCalorieLimit,
            lowerCalorieOffset = _template$values.lowerCalorieOffset,
            higherCalorieOffset = _template$values.higherCalorieOffset,
            templateValues = _objectWithoutProperties(_template$values, ['color', 'color1', 'color2', 'startFraction', 'endFraction', 'lowerCalorieLimit', 'higherCalorieLimit', 'lowerCalorieOffset', 'higherCalorieOffset']);

        replaceOverlayIds.forEach(function (replaceOverlayId) {
            var sequenceClipId = overlayToSequenceClipMap[replaceOverlayId];

            var sourceOverlay = overlays[replaceOverlayId];

            if (template) {
                var newOverlay = (0, _OverlayUtils.createOverlayFromTemplate)(template, overlays, canvas);
                // preserve the time and space values from the old overlay
                newOverlay.time = sourceOverlay.time;
                newOverlay.space = _extends({}, newOverlay.space, sourceOverlay.space);
                newOverlay.values = _extends({}, newOverlay.values, templateValues);

                if (newOverlay.time.enterstart <= time && newOverlay.time.enterdone >= time) {
                    selectedOverlayIds[newOverlay.id] = true;
                }

                if (sequenceClipId && sequenceOverlayMetaEntryForNewOverlay) {
                    sequenceOverlayMetaEntries[sequenceClipId] = _defineProperty({}, newOverlay.id, sequenceOverlayMetaEntryForNewOverlay);
                }
                newOverlays.push(newOverlay);
            }

            sourceOverlays.push(sourceOverlay);
            overlayIdsMapForDelete[replaceOverlayId] = true;
        });

        var sequenceOverlayMetaEntriesForDelete = getSequenceOverlayMetaEntriesToRemove(state, function () {
            return overlayIdsMapForDelete;
        });

        dispatch(deleteOverlays(sourceOverlays, sequenceOverlayMetaEntriesForDelete));

        if (newOverlays && newOverlays.length > 0) {
            dispatch(addOverlayAction(newOverlays, {
                sequenceOverlayMetaEntries: sequenceOverlayMetaEntries,
                shouldSelectAll: false,
                selectedOverlayIds: selectedOverlayIds
            }));
        }
    };
}

/// ////////////////// SEQUENCE TEMPLATES OVERLAY ADDITION /////////////////////

function verifyReplaceSequenceTemplateClipData(oldClipId, state) {
    var _state$overlaymeta$se2 = state.overlaymeta.sequenceOverlays,
        sequenceOverlays = _state$overlaymeta$se2 === undefined ? {} : _state$overlaymeta$se2,
        overlays = state.overlays,
        _state$reel$clips = state.reel.clips,
        clips = _state$reel$clips === undefined ? [] : _state$reel$clips;

    var overlayIdM = sequenceOverlays[oldClipId];
    var clipsObject = (0, _reelSelectors.getClipsObjects)(state);
    if (overlayIdM == undefined) return; // invalid sequence id
    if (clipsObject[oldClipId] == undefined) return; // invalid old clipId
    return true;
}

function replaceSequenceTemplatesAction(oldClipId, newClipId) {
    return {
        type: OverlayActionType.SEQUENCE_OVERLAY_CHANGE_CLIPID,
        oldClipId: oldClipId,
        newClipId: newClipId
    };
}

function replaceSequenceTemplates(oldClipId, newClipId) {
    return function (dispatch, getState) {
        var state = getState();

        var verified = verifyReplaceSequenceTemplateClipData(oldClipId, state);

        if (!verified) return;

        dispatch(replaceSequenceTemplatesAction(oldClipId, newClipId));
    };
}

function getRemoveSequenceTemplatesData() {
    var clipId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var state = arguments[1];
    var _state$overlaymeta$se3 = state.overlaymeta.sequenceOverlays,
        sequenceOverlays = _state$overlaymeta$se3 === undefined ? {} : _state$overlaymeta$se3,
        overlays = state.overlays,
        _state$reel$clips2 = state.reel.clips,
        clips = _state$reel$clips2 === undefined ? [] : _state$reel$clips2;

    clipId = Array.isArray(clipId) ? clipId : [clipId];

    var overlayToRemoveList = [];
    var sequenceOverlayMetaEntries = {};
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = clipId[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var id = _step2.value;

            var overlayIdM = sequenceOverlays[id];
            if (overlayIdM == undefined) continue;
            var overlayIds = Object.keys(overlayIdM);
            var overlays2Remove = overlayIds.map(function (id) {
                return overlays[id];
            }).filter(function (o) {
                return !!o;
            });
            overlayToRemoveList = [].concat(_toConsumableArray(overlays2Remove), _toConsumableArray(overlayToRemoveList));

            sequenceOverlayMetaEntries[id] = overlayIdM;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return {
        overlayToRemoveList: overlayToRemoveList,
        sequenceOverlayMetaEntries: sequenceOverlayMetaEntries
    };
}

function removeSequenceTemplates() {
    var clipId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var doBatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return function (dispatch, getState) {
        var state = getState();

        var _getRemoveSequenceTem = getRemoveSequenceTemplatesData(clipId, state),
            overlayToRemoveList = _getRemoveSequenceTem.overlayToRemoveList,
            sequenceOverlayMetaEntries = _getRemoveSequenceTem.sequenceOverlayMetaEntries;

        var doBatchOp = function doBatchOp() {
            dispatch((0, _reelActions.unselectAllClips)());
            dispatch(selectClear());
            dispatch(deleteOverlays(overlayToRemoveList, sequenceOverlayMetaEntries));
        };
        if (doBatch) (0, _reactRedux.batch)(doBatchOp);else doBatchOp();
    };
}

function createSequenceTemplatesFromSequenceData() {
    var sequenceData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var clipData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _ref5 = arguments[2];
    var state = _ref5.state;
    var reel = state.reel;

    var overlays = _extends({}, state.overlays);
    var type = 'sequence';

    var allOverlays = [];
    var clipIdToOverlays = {};

    for (var i = 0; i < sequenceData.length; i++) {
        var _sequenceData$i = sequenceData[i],
            _sequenceData$i$overl = _sequenceData$i.overlays,
            seqOverlays = _sequenceData$i$overl === undefined ? [] : _sequenceData$i$overl,
            seqCanvas = _sequenceData$i.canvas,
            _sequenceData$i$seque = _sequenceData$i.sequenceMetaData;
        _sequenceData$i$seque = _sequenceData$i$seque === undefined ? {} : _sequenceData$i$seque;
        var overlayMapping = _sequenceData$i$seque.overlayMapping;
        var _clipData$i = clipData[i],
            startTime = _clipData$i.startTime,
            maxDuration = _clipData$i.maxDuration,
            clipId = _clipData$i.clipId;

        if (seqOverlays.length === 0) continue;

        var overlayIds = {};

        var _createOverlaysFromTe2 = (0, _OverlayUtils.createOverlaysFromTemplate)(seqOverlays, overlays, reel.canvas, type, seqCanvas),
            _createOverlaysFromTe3 = _createOverlaysFromTe2.overlays,
            createdOverlays = _createOverlaysFromTe3 === undefined ? [] : _createOverlaysFromTe3,
            overlaymeta = _createOverlaysFromTe2.overlaymeta;

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {

            for (var _iterator3 = createdOverlays[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var o = _step3.value;

                o.time.enterstart = Math.floor(Math.max(o.time.enterstart + startTime, startTime));
                o.time.enterdone = Math.floor(Math.max(o.time.enterdone + startTime, startTime));
                o.time.exitstart = Math.floor(Math.min(o.time.exitstart + startTime, startTime + maxDuration));
                o.time.exitdone = Math.floor(Math.min(o.time.exitdone + startTime, startTime + maxDuration));

                overlays[o.id] = o; // adding more and more overlays as they get created

                overlayIds[o.id] = overlayMapping && overlaymeta[o.id] ? overlayMapping[overlaymeta[o.id]] || true : true;
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        allOverlays = [].concat(_toConsumableArray(allOverlays), _toConsumableArray(createdOverlays));
        clipIdToOverlays[clipId] = overlayIds;
    }

    return { allOverlays: allOverlays, clipIdToOverlays: clipIdToOverlays };
}

/**
 * @param {any} [sequenceData] Default is `[]`
 * @param {{{clipId , startTime , maxDuration} []}} [clipData] Default is `[]`
 * @param {boolean} [doBatch] Default is `true`
 * @export
 * @returns {any}
 */
function addSequenceTemplates() {
    var sequenceData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var clipData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function (dispatch, getState) {
        var _createSequenceTempla = createSequenceTemplatesFromSequenceData(sequenceData, clipData, {
            state: getState()
        }),
            allOverlays = _createSequenceTempla.allOverlays,
            clipIdToOverlays = _createSequenceTempla.clipIdToOverlays;

        dispatch(addOverlays(allOverlays, {
            shouldClearSelect: true,
            shouldSelectAll: false,
            sequenceOverlayMetaEntries: clipIdToOverlays
        })); // adds the overlay to the screen
    };
}

var transformPipeline = (0, _OverlayUtils.buildTransformPipeline)([_OverlayUtils.randomizeOverlayPosition, _OverlayUtils.randomizeColor], [_OverlayUtils.ignoreOverlayTypeForPipeline, _OverlayUtils.ignoreOverlayGroupdIdForPipeline]);

/**
 *
 * Creates and adds overlay based on passed templateId , groupId and extraParams for Config
 * - Also registers any Assets that was previously unregistered
 *
 *
 *
 * @param {'text'|'images'|'workspaceTemplates'} type
 * @param {*} templateId
 * @param {*} groupId
 * @param {string} [extraParams={ crop: 'none' }]
 * @return {*}
 */
var createAndAddOverlay = function createAndAddOverlay(type, templateId, groupId) {
    var extraParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { crop: 'none' };
    return function (dispatch, getState, _ref6) {
        var appManager = _ref6.appManager;

        try {
            var _getState3 = getState(),
                templates = _getState3.templates,
                overlays = _getState3.overlays,
                overlaymeta = _getState3.overlaymeta,
                player = _getState3.player,
                reel = _getState3.reel,
                _getState3$copyData$c = _getState3.copyData.copiedTemplate,
                copiedTemplate = _getState3$copyData$c === undefined ? null : _getState3$copyData$c,
                workspaceImages = _getState3.workspaceImages;

            var template = null;
            // TODO -- take them in sepparate functions for readability
            if (templateId == 'copied' && !!copiedTemplate) {
                template = copiedTemplate;
                var overlayCount = getOverlayCountInWorkspaceTemplate(copiedTemplate);
                dispatch((0, _logActions.trackOverlayAction)(_logActions.overlayActionType.PASTE, overlayCount));
            } else {
                template = findTemplate(type, templates, templateId, groupId);

                if (template && groupId === 'saved') {
                    [template].flatMap(function (v) {
                        if (v.isgroup) return v.children;
                        return v;
                    }).map(function (_ref7) {
                        var defId = _ref7.defId;
                        return (0, _general.extractServiceAndIdFromDefId)(defId);
                    }).forEach(function (data) {
                        if (data) {
                            var id = data.id,
                                service = data.service;

                            dispatch((0, _pluginActions.registerPluginInternalAsset)({
                                id: id,
                                plugin: service
                            }));
                        }
                    });
                }

                if (template && groupId === 'workspaceImages') {
                    // TODO when improvement sprint PR is merged change it to the constant ENUM

                    var _template = template,
                        _template$isgroup = _template.isgroup,
                        isgroup = _template$isgroup === undefined ? false : _template$isgroup;

                    if (!isgroup) {
                        var _template2 = template,
                            _template2$values = _template2.values;
                        _template2$values = _template2$values === undefined ? {} : _template2$values;
                        var imageId = _template2$values.imageId,
                            defId = _template2.defId;

                        var workspaceEntry = workspaceImages.find(function (v) {
                            return v.id === imageId;
                        });
                        if (workspaceEntry) {
                            dispatch((0, _mediaActions.addMediaFromWorkspaceToProjectMedia)(workspaceEntry));
                        }
                    } else {
                        var _template3 = template,
                            _template3$children = _template3.children,
                            children = _template3$children === undefined ? [] : _template3$children;

                        var imageIds = children.map(function (overlay) {
                            var _overlay$values = overlay.values;
                            _overlay$values = _overlay$values === undefined ? {} : _overlay$values;
                            var imageId = _overlay$values.imageId;

                            return imageIds;
                        });
                        var workspaceEntries = (0, _CommonAlgorithms.findItems)(workspaceImages, imageIds, function (w, im) {
                            return w.id === im;
                        });
                        if (workspaceEntries.length !== 0) {
                            workspaceEntries.forEach(function (workspaceEntry) {
                                return dispatch((0, _mediaActions.addMediaFromWorkspaceToProjectMedia)(workspaceEntry));
                            });
                        }
                    }
                }
            }

            var _createOverlays = createOverlays(template, player, overlays, reel, dispatch, type, extraParams.position),
                createdOverlays = _createOverlays.overlays,
                createdOverlayMeta = _createOverlays.overlaymeta;

            var _createdOverlayMeta$a = createdOverlayMeta.animgroups,
                createdAnimGroups = _createdOverlayMeta$a === undefined ? [] : _createdOverlayMeta$a;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {

                for (var _iterator4 = createdOverlays[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _overlays = _step4.value;
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = Object.keys(extraParams)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var key = _step5.value;

                            if (_overlays.values[key]) {
                                _overlays.values[key] = extraParams[key];
                            }
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            if (!extraParams.position) {
                createdOverlays = transformPipeline({
                    overlays: createdOverlays,
                    canvas: reel.canvas,
                    type: type,
                    groupId: groupId
                });
            }

            (0, _reactRedux.batch)(function () {
                dispatch((0, _reelActions.unselectAllClips)());
                dispatch(modeActions.closeAudioProperties());
                dispatch(modeActions.unselectWatermarkPreview());
                dispatch(addOverlays(createdOverlays));
                dispatch(updateAnimGroups([].concat(_toConsumableArray(overlaymeta.animgroups), _toConsumableArray(createdAnimGroups))));
                dispatch((0, _workspaceActions.updateUserWorkflows)(createdOverlays));
            });

            (0, _TrackUtils.trackOnPostHog)('Template Clicked', { 'template-name': template.name || '' });

            if (window.startTrackingModeTimes) {
                var _getState4 = getState(),
                    currentMode = _getState4.mode.currentMode;

                var isOverlayMode = currentMode === _EditorMode2.default.OVERLAY;
                window.startTrackingModeTimes(isOverlayMode);
            }
        } catch (err) {
            dlog('failed to add overlay', err);
            (0, _errorReporting.reportError)(new _errorReporting.OverlayAdditionFailedError('Args : ' + JSON.stringify({
                type: type,
                templateId: templateId,
                groupId: groupId,
                extraParams: extraParams
            })));
        }
    };
};

var addWatermarkOverlay = exports.addWatermarkOverlay = function addWatermarkOverlay() {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            duration = _getState5.player.duration,
            canvas = _getState5.reel.canvas;

        var watermarkOverlay = (0, _cloneextend.clone)(_watermarkUtils.WATERMARK_OVERLAY);

        var canvasResizeFactor = canvas.height / _watermarkUtils.DEFAULT_WATERMARK_CANVAS_SIZE;

        watermarkOverlay.space.height = canvasResizeFactor * watermarkOverlay.space.height;
        watermarkOverlay.space.width = canvasResizeFactor * watermarkOverlay.space.width;
        watermarkOverlay.space.x = canvasResizeFactor * watermarkOverlay.space.x;
        watermarkOverlay.space.y = canvasResizeFactor * watermarkOverlay.space.y;

        watermarkOverlay.isWatermark = true;
        watermarkOverlay.time.exitstart = duration;
        watermarkOverlay.time.exitdone = duration;

        dispatch(addOverlays([watermarkOverlay], {
            shouldClearSelect: true,
            shouldSelectAll: false
        }));
        dispatch(reelActions.defaultWatermarkAdded());
    };
};
// TODO - verify and optimise , if after the recent refactor its not needed
// Do not fire this needlessly , Useless state update needs to go away
var updateWatermarkOverlaysDebounced = exports.updateWatermarkOverlaysDebounced = (0, _GeneralUtils.debounce)(function (dispatch, getState) {
    var state = getState();
    var duration = state.player.duration;

    var watermarkOverlays = Object.values(state.overlays).filter(function (o) {
        return !!o.isWatermark;
    }).map(function (o) {
        return _extends({}, o, {
            time: _extends({}, o.time, {
                exitstart: duration,
                exitdone: duration
            })
        });
    });
    if (watermarkOverlays.length > 0) {
        dispatch(changeMultipleOverlays(watermarkOverlays));
    }
}, 200);

var deleteWatermarkOverlay = exports.deleteWatermarkOverlay = function deleteWatermarkOverlay() {
    return function (dispatch, getState) {
        var watermarkOverlays = Object.values(getState().overlays).filter(function (o) {
            return !!o.isWatermark;
        });

        dispatch(deleteOverlays(watermarkOverlays));
        dispatch(reelActions.watermarkDeleted());
    };
};

var replaceWatermarkOverlay = exports.replaceWatermarkOverlay = function replaceWatermarkOverlay() {
    return function (dispatch, getState) {
        var state = getState();
        var watermarkOverlays = Object.values(state.overlays).filter(function (o) {
            return !!o.isWatermark;
        });
        if (watermarkOverlays.length < 1) {
            console.log('Error: no watermark overlay found for replace');
            return;
        }

        var watermarkOverlay = watermarkOverlays[0];

        dispatch(selectOnly(watermarkOverlay.id));
        dispatch(modeActions.changeSidebarSection(_General.Sections.VIDEOS.id, true));
        dispatch(modeActions.setReplaceOverlayMedia(true));
    };
};

var doAdjustOverlays = exports.doAdjustOverlays = function doAdjustOverlays(newCanvas, oldCanvas) {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            overlays = _getState6.overlays;

        if (oldCanvas.width != newCanvas.width || oldCanvas.height != newCanvas.height) {
            var adjustedOverlays = (0, _OverlayUtils.adjustOverlays)(overlays, newCanvas, oldCanvas);

            dispatch({
                type: OverlayActionType.OVERLAYS_ADJUST,
                adjustedOverlays: adjustedOverlays
            });
        }
        return null;
    };
};

function addTextOverlay(groupId, templateId) {
    var trackingData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return function (dispatch, getState) {
        dispatch((0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
            dispatch(createAndAddOverlay('text', templateId, groupId));
            dispatch((0, _logActions.trackTextEffectUsed)(trackingData));
        }));
    };
}

function addImageOverlay(groupId, templateId) {
    var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref8$overlayCrop = _ref8.overlayCrop,
        overlayCrop = _ref8$overlayCrop === undefined ? 'none' : _ref8$overlayCrop,
        position = _ref8.position;

    return (0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
        return createAndAddOverlay('images', templateId, groupId, {
            crop: overlayCrop,
            position: position
        });
    });
}

function addShapesIconOverlay(groupId, templateId) {
    return (0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
        return createAndAddOverlay('images', templateId, groupId);
    });
}

function addSvgAssetOverlay(templateId) {
    return (0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
        return createAndAddOverlay('images', templateId, 'svg-assets');
    });
}

function addWorkspaceImageOverlay(templateId) {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            overlays = state.overlays,
            templates = state.templates,
            canvas = state.reel.canvas,
            selectedAction = state.ui.selectedAction;

        var selectedOverlayIds = Object.keys(selected);
        if (selectedOverlayIds.length === 1) {
            var overlay = overlays[selectedOverlayIds[0]];

            var defModel = _DefModel.DefModelRegistry.getModelForOverlay(overlay.defId, overlay.id);
            var animSettings = (0, _overlaySelectors.getAnimGroupSettingsForAllOverlays)(state);
            defModel.update(overlay.space, overlay.time, overlay.values, canvas, animSettings[overlay.id]);
            // defModel.seekToStatic();

            var imageIdProps = Object.keys(defModel.def.props).filter(function (pk) {
                return defModel.def.props[pk] === 'imageId';
            });
            var workspaceImages = (templates.images.find(function (grp) {
                return grp.id === 'workspaceImages';
            }) || {}).items || [];
            var clickedTemplate = workspaceImages.find(function (wi) {
                return wi.id === templateId;
            });

            if (imageIdProps.length === 1 && !!clickedTemplate && !!clickedTemplate.values.imageId) {
                var _values3;

                var imageId = clickedTemplate.values.imageId,
                    _clickedTemplate$spac2 = clickedTemplate.space,
                    width = _clickedTemplate$spac2.width,
                    height = _clickedTemplate$spac2.height;
                var placeholders = defModel.def.meta.placeholders;

                var prop = imageIdProps[0];

                if (!placeholders || !placeholders[prop]) {
                    // The selected overlay is an image overlay
                    if (selectedAction === 'replace') {
                        // if the replace option is active then replace image
                        var _newOverlay3 = (0, _deepmerge2.default)(overlay, {
                            values: _defineProperty({}, prop, imageId)
                        });

                        dispatch(changeOverlayFinish(_newOverlay3, overlay));
                    } else {
                        // add new image overlay
                        dispatch(addImageOverlay('workspaceImages', templateId));
                    }
                    return;
                }

                var layerId = placeholders[prop];

                var _getScaleFromTransfor3 = (0, _LayerUtils.getScaleFromTransformString)(overlay.space.transform),
                    _getScaleFromTransfor4 = _slicedToArray(_getScaleFromTransfor3, 2),
                    scaleX = _getScaleFromTransfor4[0],
                    scaleY = _getScaleFromTransfor4[1];

                var _defModel$getAttrsFor2 = defModel.getAttrsForLayer(layerId, true),
                    lw = _defModel$getAttrsFor2.width,
                    lh = _defModel$getAttrsFor2.height;

                var targetAspectRatio = lw * scaleX / (lh * scaleY);

                var cropX = 0;
                var cropY = 0;
                var cropWidth = 100;
                var cropHeight = 100;

                if (height < width) {
                    var newWidth = height * targetAspectRatio;
                    var difference = (width - newWidth) / 2;
                    cropX = difference / width * 100;
                    cropWidth = newWidth / width * 100;
                } else {
                    var newHeight = width / targetAspectRatio;
                    var _difference2 = (height - newHeight) / 2;
                    cropY = _difference2 / height * 100;
                    cropHeight = newHeight / height * 100;
                }

                var newOverlay = (0, _deepmerge2.default)(overlay, {
                    values: (_values3 = {}, _defineProperty(_values3, prop, imageId), _defineProperty(_values3, 'cropX', cropX), _defineProperty(_values3, 'cropY', cropY), _defineProperty(_values3, 'cropWidth', cropWidth), _defineProperty(_values3, 'cropHeight', cropHeight), _values3)
                });

                dispatch(changeOverlayFinish(newOverlay, overlay));
            } else {
                dispatch(addImageOverlay('workspaceImages', templateId));
            }
        } else {
            dispatch(addImageOverlay('workspaceImages', templateId));
        }
    };
}

function addWorkspaceTemplateOverlay(groupId, templateId) {
    return (0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
        return createAndAddOverlay('workspaceTemplates', templateId, groupId);
    });
}

/**
 *
 *
 * @export
 * @param {*} id
 * @return {*}
 */
function selectSequenceOverlay(id) {
    var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        var state = getState();
        var overlays = state.overlays,
            currentTime = state.player.time;

        var sequenceOverlayIdToClipId = getOverlayIdToSequenceClipIdMap(state);
        var clipId = sequenceOverlayIdToClipId[id];
        var overlaySelectAction = add ? OverlayActionType.SELECT_ADD : OverlayActionType.SELECT;

        if (clipId && overlays[id] && !overlays[id].hide) {
            var overlay = overlays[id];

            var _overlay$time2 = overlay.time,
                enterstart = _overlay$time2.enterstart,
                enterdone = _overlay$time2.enterdone;

            var delta = 1;

            dispatch([{ type: overlaySelectAction, id: id }, modeActions.switchPropertiesPanel(_PropertiesPanelType2.default.OPTIONS), modeActions.closeAudioProperties(), modeActions.unselectWatermarkPreview(), { type: reelActions.ReelActionType.CLIP_SELECT, clipId: clipId }]);

            if (currentTime < enterstart || currentTime > enterdone) {
                dispatch((0, _playerActions.seek)(enterstart + delta));
            }
        }
    };
}

function selectOnly(id) {
    return function (dispatch, getState) {
        var state = getState();
        // Close shelf when watermark is selected
        var overlays = state.overlays;

        var selectedOverlay = overlays[id];

        var sequenceOverlayIdToClipId = getOverlayIdToSequenceClipIdMap(state);
        var clipId = sequenceOverlayIdToClipId[id];

        if (selectedOverlay && !!selectedOverlay.isWatermark) dispatch(modeActions.closeShelf());

        dispatch([{ type: OverlayActionType.SELECT, id: id }, modeActions.switchPropertiesPanel(_PropertiesPanelType2.default.OPTIONS), modeActions.closeAudioProperties(), modeActions.unselectWatermarkPreview(), clipId ? { type: reelActions.ReelActionType.CLIP_SELECT, clipId: clipId } : (0, _reelActions.unselectAllClips)()]);
    };
}

function selectAdd(id) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch({ type: OverlayActionType.SELECT_ADD, id: id });
            dispatch((0, _reelActions.unselectAllClips)());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());
        });
    };
}

function quickSelect(id) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _playerActions.pause)(false));

            dispatch(selectOnly(id));

            var _getState7 = getState(),
                overlays = _getState7.overlays;

            var overlay = overlays[id];

            var enterstart = overlay.time.enterstart;

            // adding delta of 1ms ,
            // too keep the overlay visible when unselected

            var delta = 1;
            dispatch((0, _playerActions.seek)(enterstart + delta));
        });
    };
}

function moveSingleIncremental(movedOverlay) {
    return { type: OverlayActionType.MOVE_SINGLE_INCR, movedOverlay: movedOverlay };
}

function moveSingleFinish(movedOverlay, startOverlay) {
    return {
        type: OverlayActionType.MOVE_SINGLE_FINISH,
        movedOverlay: movedOverlay,
        startOverlay: startOverlay
    };
}

function moveMultipleIncremental(movedOverlays) {
    return { type: OverlayActionType.MOVE_MULTIPLE_INCR, movedOverlays: movedOverlays };
}

function moveMultipleFinish(movedOverlays, startOverlays) {
    return {
        type: OverlayActionType.MOVE_MULTIPLE_FINISH,
        movedOverlays: movedOverlays,
        startOverlays: startOverlays
    };
}

function multipleOverlayChangeIncrementalById(overlayIds, newOverlayData) {
    return function (dispatch, getState) {
        var _getState8 = getState(),
            overlays = _getState8.overlays;

        var selectedOverlays = overlayIds.map(function (oId) {
            return overlays[oId];
        }).filter(function (o) {
            return !!o;
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, newOverlayData);
        });

        dispatch(changeMultipleOverlays(newOverlays));
    };
}

function multipleOverlayChangeFinishById(overlayIds, newOverlayData, oldOverlayData) {
    return function (dispatch, getState) {
        var _getState9 = getState(),
            overlays = _getState9.overlays;

        var selectedOverlays = overlayIds.map(function (oId) {
            return overlays[oId];
        }).filter(function (o) {
            return !!o;
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, newOverlayData);
        });

        var startOverlays = selectedOverlays;

        if (oldOverlayData) {
            startOverlays = startOverlays.map(function (o) {
                return (0, _deepmerge2.default)(o, oldOverlayData);
            });
        }

        dispatch(changeMultipleOverlaysFinish(newOverlays, startOverlays));
    };
}

function changeMultipleOverlays(newOverlays) {
    return {
        type: OverlayActionType.CHANGE_MULTIPLE_OVERLAY,
        overlays: newOverlays
    };
}

function changeSpaceForMultipleOverlays(newOverlays) {
    return {
        type: OverlayActionType.CHANGE_SPACE_FOR_OVERLAYS,
        overlays: newOverlays
    };
}

function changeMultiOverlays() {
    var overlays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var startOverlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return {
        type: OverlayActionType.CHANGE_MULTI_OVERLAYS,
        overlays: overlays,
        startOverlays: startOverlays
    };
}

function changeMultipleOverlaysFinish(newOverlays, startOverlays) {
    return {
        type: OverlayActionType.CHANGE_MULTIPLE_OVERLAY_FINISH,
        newOverlays: newOverlays,
        startOverlays: startOverlays
    };
}

function resizeIncremental(resizedOverlays) {
    return { type: OverlayActionType.RESIZE_INCR, resizedOverlays: resizedOverlays };
}

function resizeFinish(resizedOverlays, startOverlays) {
    return function (dispatch, getState) {
        var workspaceId = getState().workspaceInfo.activeWorkspace.workspaceId;

        dispatch({ type: OverlayActionType.RESIZE_FINISH, resizedOverlays: resizedOverlays, startOverlays: startOverlays });

        (0, _TrackUtils.trackOnPostHog)('Overlay/Overlays Resized', { workspaceId: workspaceId });
    };
}

function selectClear() {
    return { type: OverlayActionType.SELECT_CLEAR };
}

function clickVideo() {
    return function (dispatch, getState) {
        var _getState10 = getState(),
            selected = _getState10.selection.selected,
            player = _getState10.player,
            _getState10$reel$clip = _getState10.reel.clips,
            clips = _getState10$reel$clip === undefined ? [] : _getState10$reel$clip;

        var _getSelectedClip = (0, _ReelHelpers.getSelectedClip)(clips, player.time),
            clipId = _getSelectedClip.clipId;

        if (!clipId) return;

        (0, _reactRedux.batch)(function () {
            dispatch(selectClear());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());
            dispatch({ type: reelActions.ReelActionType.CLIP_SELECT, clipId: clipId });
        });
    };
}

function setInTimeIncremental(ids, time) {
    return { type: OverlayActionType.SET_IN_TIME_INCR, ids: ids, time: time };
}

function setInTimeIncrementalForSelected(time) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000));
            dispatch(setInTimeIncremental(getState().selection.selected, time));
        });
    };
}

function setInTimeFinish(ids, time, oldTime) {
    return { type: OverlayActionType.SET_IN_TIME_FINISH, ids: ids, time: time, oldTime: oldTime };
}

function setInTimeFinishForSelected(time, oldTime) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _guardActions.guardOverlayUpdates)(false));
            dispatch(setInTimeFinish(getState().selection.selected, time, oldTime));
        });
    };
}

function setOutTimeIncremental(ids, time) {
    return { type: OverlayActionType.SET_OUT_TIME_INCR, ids: ids, time: time };
}

function setOutTimeFinish(ids, time, oldTime) {
    return { type: OverlayActionType.SET_OUT_TIME_FINISH, ids: ids, time: time, oldTime: oldTime };
}

function setOutTimeIncrementalForSelected(time) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000));
            dispatch(setOutTimeIncremental(getState().selection.selected, time));
        });
    };
}

function setOutTimeFinishForSelected(time, oldTime) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _guardActions.guardOverlayUpdates)(false));
            dispatch(setOutTimeFinish(getState().selection.selected, time, oldTime));
        });
    };
}

function deleteOverlays(overlays) {
    var sequenceOverlayMetaEntries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return { type: OverlayActionType.OV_DELETE, overlays: overlays, sequenceOverlayMetaEntries: sequenceOverlayMetaEntries };
}

function deleteOverlaysWithWarning(overlays) {
    var sequenceOverlayMetaEntries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch, getState) {
        if (overlays && overlays.length > 0) {
            dispatch((0, _deleteWarningActions.handleDeleteAction)(function () {
                return dispatch(deleteOverlays(overlays, sequenceOverlayMetaEntries));
            }));
        }
    };
}

function getSequenceOverlayMetaEntriesToRemove(state) {
    var getOverlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var sequenceOverlays = state.overlaymeta.sequenceOverlays;

    var selected = getOverlays(state);

    var overlayToSeqClipMap = getOverlayIdToSequenceClipIdMap(state);
    var clipsObj = (0, _reelSelectors.getClipsObjects)(state);

    var sequenceOverlayMetaEntries = null;

    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = Object.keys(selected)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var overlayId = _step6.value;

            // expecting selected overlays is subset of valid overlays on screen
            var seqClipid = overlayToSeqClipMap[overlayId];
            if (clipsObj[seqClipid]) {
                // if valid clip then only do something
                if (!sequenceOverlayMetaEntries) {
                    sequenceOverlayMetaEntries = {};
                }

                if (!sequenceOverlayMetaEntries[seqClipid]) {
                    sequenceOverlayMetaEntries[seqClipid] = {};
                }

                var metaValue = true;
                if (sequenceOverlays && sequenceOverlays[seqClipid]) {
                    metaValue = sequenceOverlays[seqClipid][overlayId] || true;
                }
                sequenceOverlayMetaEntries[seqClipid] = _defineProperty({}, overlayId, metaValue);
            }
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    return sequenceOverlayMetaEntries;
}

function deleteSelectedOverlays() {
    return function (dispatch, getState) {
        var state = getState();

        var selectedOverlays = (0, _overlaySelectors.getSelectedOverlays)(state);
        var sequenceOverlayIdToClipId = getOverlayIdToSequenceClipIdMap(state);

        var delOverlays = [];
        var hideOverlays = {};

        selectedOverlays.forEach(function (ov) {
            if (sequenceOverlayIdToClipId[ov.id]) {
                hideOverlays[ov.id] = true;
            } else {
                delOverlays.push(ov);
            }
        });

        var sequenceOverlayMetaEntries = getSequenceOverlayMetaEntriesToRemove(state, function (state) {
            return state.selection.selected;
        });

        dispatch([deleteOverlaysWithWarning(delOverlays, sequenceOverlayMetaEntries), hideOverlayByIds(hideOverlays, true), reelActions.selectClip()]);
    };
}

// Mostly for testing
function deleteOverlayById(id) {
    return function (dispatch, getState) {
        var delOverlays = [getState().overlays[id]];

        dispatch({ type: OverlayActionType.OV_DELETE, overlays: delOverlays });
    };
}

function copySelectedOverlays() {
    return function (dispatch, getState) {
        var _getState11 = getState(),
            selected = _getState11.selection.selected,
            overlays = _getState11.overlays,
            overlaymeta = _getState11.overlaymeta,
            canvas = _getState11.reel.canvas;

        var copyOverlays = Object.keys(selected).map(function (id) {
            return overlays[id];
        });

        var overlayCount = copyOverlays.length;

        var template = (0, _OverlayUtils.createTemplateFromOverlays)(copyOverlays, overlaymeta, canvas);

        dispatch({ type: OverlayActionType.OV_COPY, template: template });
        dispatch((0, _logActions.trackOverlayAction)(_logActions.overlayActionType.COPY, overlayCount));

        // setTimeout(() => dispatch(closeCopyBanner()), 3000);
    };
}

function pasteCopiedTemplate() {
    return function (dispatch, getState) {
        dispatch(createAndAddOverlay('workspaceTemplates', 'copied'));
    };
}

function getOverlayCountInWorkspaceTemplate(template) {
    var count = 0;
    if (template) {
        if (template.hasOwnProperty('children')) {
            count = template.children.length;
        } else {
            count = 1;
        }
    }
    return count;
}

function saveWorkspaceTemplate() {
    return function (dispatch, getState) {
        var _getState12 = getState(),
            template = _getState12.copyData.copiedTemplate;

        dispatch({ type: OverlayActionType.OV_SAVE, template: template });

        var oldTemplateId = template.id;

        var overlayCount = getOverlayCountInWorkspaceTemplate(template);

        if (!window.appManager.isDemoMode()) {
            // Fire an api request to update
            (0, _api.saveWorkspaceTemplateP)(template).then(function (newTemplateId) {
                if (newTemplateId) {
                    var grpId = 'saved';

                    // show saved Template
                    var savedGrp = getState().templates.workspaceTemplates.find(function (grp) {
                        return grp.id == grpId;
                    });

                    var itemIndex = savedGrp.items.findIndex(function (t) {
                        return t.id === oldTemplateId;
                    });

                    (0, _reactRedux.batch)(function () {
                        dispatch({
                            type: OverlayActionType.TEMPLATES_UPDATE_ID,
                            oldTemplateId: oldTemplateId,
                            newTemplateId: newTemplateId
                        });

                        dispatch({
                            type: OverlayActionType.SHOW_SAVED_TEMPLATE,
                            templateId: newTemplateId,
                            highlight: true
                        });

                        dispatch(modeActions.openSelectedProjectMedia(true));

                        dispatch((0, _leftShelf.scrollToClipBoard)(1000));

                        dispatch((0, _uiActions.closeCopyBanner)());

                        dispatch((0, _logActions.trackOverlayAction)(_logActions.overlayActionType.SAVED, overlayCount));
                    });

                    setTimeout(function () {
                        // clear the saved element highlight and auto close banner after 3 secs
                        dispatch({
                            type: OverlayActionType.SHOW_SAVED_TEMPLATE,
                            templateId: null,
                            highlight: false
                        });
                    }, 3000);
                }
            }).catch(function (err) {
                console.log(err); /* Nothing */
            });

            return null;
        }
    };
}

function deleteWorkspaceTemplate(groupId, templateId) {
    return function (dispatch, getState) {
        var _getState13 = getState(),
            templates = _getState13.templates;

        var grpId = 'saved';

        var savedGrp = templates.workspaceTemplates.find(function (grp) {
            return grp.id == grpId;
        });

        var restTemplates = savedGrp.items.filter(function (t) {
            return t.id !== templateId;
        });

        dispatch(updateWorkspaceTemplates(restTemplates));

        if (!window.appManager.isDemoMode()) {
            (0, _api.deleteWorkspaceTemplateP)(templateId).then(function () {
                /* Nothing */
            }).catch(function (err) {
                console.log(err); /* Nothing */
            });

            return null;
        }
    };
}

function deleteWorkspaceImage(mediaId) {
    return function (dispatch) {
        var medias = [{ id: mediaId, type: 'image' }];
        deleteMedia(medias, function () {
            (0, _reactRedux.batch)(function () {
                dispatch(removeWorkspaceImage(mediaId));
                dispatch((0, _workspaceActions.updateWorkspaceInfo)(false));
            });
        });
    };
}

function deleteProjectMedia(mediaId, mediaType) {
    return function (dispatch) {
        var medias = [{ id: mediaId, mediaType: mediaType }];

        deleteMedia(medias, 'options-dropdown', function () {
            (0, _reactRedux.batch)(function () {
                dispatch((0, _mediaActions.removeMedia)(mediaId));
                dispatch((0, _mediaActions.removeAudio)(mediaId));
                dispatch((0, _workspaceActions.updateWorkspaceInfo)(false));
            });
        });
    };
}

/**
 * Deletes media selected in workspace modal.
 * @param {Array<{id: string, mediaType: 'image|video|audio'}>} medias
 */
function deleteWorkspaceMedia(medias, successCb) {
    return function (dispatch, getState) {
        if (!window.appManager.isDemoMode()) {
            var state = getState();
            var _state$modalUIState$m = state.modalUIState.mediaLibraryModal.triggerAction,
                triggerAction = _state$modalUIState$m === undefined ? '' : _state$modalUIState$m;

            deleteMedia(medias, triggerAction, function () {
                (0, _reactRedux.batch)(function () {
                    dispatch((0, _mediaActions.removeMedia)(medias.map(function (m) {
                        return m.id;
                    })));
                    dispatch({
                        type: _workspaceActions.MediaLibraryModalActionType.MEDIA_LIB_UPDATE_DELETE_STATE,
                        status: true
                    });
                    dispatch((0, _workspaceActions.updateWorkspaceInfo)(false));

                    if (successCb) {
                        successCb();
                    }
                    setTimeout(function () {
                        dispatch({
                            type: _workspaceActions.MediaLibraryModalActionType.MEDIA_LIB_UPDATE_DELETE_STATE,
                            status: false
                        }, 300);
                    });
                });
            });
        }
    };
}

/**
 *
 * @param {Array<{id, mediaType}>} medias
 * @param {function} successCb
 * @param {function} errorCb
 */
function deleteMedia() {
    var medias = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var triggerAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var successCb = arguments[2];
    var errorCb = arguments[3];

    if (!window.appManager.isDemoMode()) {
        (0, _api.deleteMediaP)(medias, triggerAction).then(function (res) {
            if (res.success) {
                if (successCb) {
                    successCb();
                }
            } else if (errorCb) {
                errorCb();
            }
        }).catch(function (err) {
            console.log(err);
            if (errorCb) {
                errorCb();
            }
        });
        return null;
    }
}

function setChangeColor(color) {
    return {
        type: OverlayActionType.SET_SELECTED_COLOR,
        changedColor: color,
        selectedColorInOverlay: color
    };
}

function changeOverlayIncremental(overlay) {
    var changedColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return {
        type: OverlayActionType.CHANGE_OVERLAY_INCR,
        overlay: overlay,
        changedColor: changedColor
    };
}

function changeOverlayFinish(overlay, startOverlay, changedColor) {
    var changeType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return {
        type: OverlayActionType.CHANGE_OVERLAY_FINISH,
        overlay: overlay,
        startOverlay: startOverlay,
        changedColor: changedColor,
        changeType: changeType
    };
}

function changeOverlayFinishById(overlayId, newValues, oldValues, changedColor) {
    var changeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    return function (dispatch, getState) {
        var overlay = getState().overlays[overlayId];

        var startOverlay = overlay;

        if (oldValues) {
            startOverlay = (0, _deepmerge2.default)(overlay, oldValues);
        }

        var newOverlay = (0, _deepmerge2.default)(overlay, newValues);

        dispatch({
            type: OverlayActionType.CHANGE_OVERLAY_FINISH,
            overlay: newOverlay,
            startOverlay: startOverlay,
            changedColor: changedColor,
            changeType: changeType
        });
    };
}

function changeOverlayFinishFromCurrent(overlay) {
    return function (dispatch, getState) {
        var startOverlay = getState().overlays[overlay.id];

        dispatch(changeOverlayFinish(overlay, startOverlay));
    };
}

function changeOverlay(overlay) {
    return { type: OverlayActionType.CHANGE_OVERLAY, overlay: overlay };
}

/**
 *
 * @param {string} overlayId
 * @param {string} textProp
 * @param {string} newValue
 */
function changeOverlayText(overlayId, textProp, newValue) {
    return function (dispatch, getState) {
        var newText = (0, _GeneralUtils.replaceFourByteChar)(newValue || '');

        var _getState14 = getState(),
            overlays = _getState14.overlays;

        var overlay = overlays[overlayId];

        if (!overlay) {
            return;
        }

        var currentText = overlay.values[textProp];

        var def = getTemplateDefForId(overlay.defId);

        var _def$meta = def.meta,
            textColors = _def$meta.textColors,
            highlightColors = _def$meta.highlightColors;

        var updateValues = _defineProperty({}, textProp, newText);

        var colorPropsToUpdate = [];

        if (textColors) {
            colorPropsToUpdate.push({
                prop: textColors[textProp],
                colorRange: new _ColorRange2.default(overlay.values[textColors[textProp]])
            });
        }
        if (highlightColors) {
            var _highlightColors$text = highlightColors[textProp],
                highlight = _highlightColors$text.highlight,
                highlightText = _highlightColors$text.highlightText;

            if (highlight) {
                colorPropsToUpdate.push({
                    prop: highlight,
                    colorRange: new _HighlightColorRange2.default(overlay.values[highlight])
                });
            }
            if (highlightText) {
                colorPropsToUpdate.push({
                    prop: highlightText,
                    colorRange: new _HighlightColorRange2.default(overlay.values[highlightText])
                });
            }
        }

        if (colorPropsToUpdate.length > 0) {
            var dmp = new _diffMatchPatch2.default();
            var diffs = dmp.diff_main(currentText, newText);

            var charCounter = 0;

            diffs.forEach(function (diff) {
                var _diff = _slicedToArray(diff, 2),
                    type = _diff[0],
                    value = _diff[1];

                var _loop = function _loop(i) {
                    if (type === -1) {
                        colorPropsToUpdate.forEach(function (_ref9) {
                            var colorRange = _ref9.colorRange;

                            colorRange.removeAtIndex(i);
                        });
                    } else if (type === 1) {
                        colorPropsToUpdate.forEach(function (_ref10) {
                            var colorRange = _ref10.colorRange;

                            colorRange.insertAtIndex(i);
                        });
                    }
                };

                for (var i = charCounter + value.length - 1; i >= charCounter; i--) {
                    _loop(i);
                }
                if (type !== -1) {
                    charCounter += value.length;
                }
            });

            colorPropsToUpdate.forEach(function (_ref11) {
                var prop = _ref11.prop,
                    colorRange = _ref11.colorRange;

                updateValues[prop] = colorRange.toString();
            });
        }

        dispatch(changeOverlayFinish((0, _deepmerge2.default)(overlay, {
            values: updateValues
        }), overlay));
    };
}

function setFocus(uid, start, end, length) {
    return { type: OverlayActionType.SET_FOCUS, uid: uid, start: start, end: end, length: length };
}

function onAnimationTypeChange(kind, animDefId) {
    return function (dispatch, getState) {
        var _getState15 = getState(),
            selected = _getState15.selection.selected,
            overlays = _getState15.overlays;

        var type = kind === 'enter' ? OverlayActionType.SET_IN_ANIM : OverlayActionType.SET_OUT_ANIM;

        dispatch({ type: type, ids: selected, animDefId: animDefId });

        type = kind === 'enter' ? OverlayActionType.SET_IN_ANIM_DURATION : OverlayActionType.SET_OUT_ANIM_DURATION;
        if (animDefId == 'animDefId-OUT-NONE' || animDefId == 'animDefId-IN-NONE') {
            var duration = 0;
            dispatch({ type: type, ids: selected, duration: duration });
        } else {
            var _duration = 200;
            if (Object.keys(selected).length) {
                var times = overlays[Object.keys(selected)[0]].time;
                _duration = kind === 'enter' ? Math.floor(times.enterdone - times.enterstart) : Math.floor(times.exitdone - times.exitstart);
                _duration = !_duration ? 200 : _duration;
            }
            dispatch({ type: type, ids: selected, duration: _duration });
        }

        (0, _TrackUtils.trackOnPostHog)('Overlay Change Animation', { animationKind: kind, animationId: animDefId });
    };
}

function onAnimationDurationChange(kind, duration) {
    return function (dispatch, getState) {
        var _getState16 = getState(),
            selected = _getState16.selection.selected;

        var type = kind === 'enter' ? OverlayActionType.SET_IN_ANIM_DURATION : OverlayActionType.SET_OUT_ANIM_DURATION;

        dispatch({ type: type, ids: selected, duration: duration });
    };
}

function onAnimationManualModeChange(kind, isManual, duration) {
    return function (dispatch, getState) {
        var _getState17 = getState(),
            selected = _getState17.selection.selected;

        var type = kind === 'enter' ? OverlayActionType.SET_IN_ANIM_DURATION_MANUAL_MODE : OverlayActionType.SET_OUT_ANIM_DURATION_MANUAL_MODE;

        dispatch({ type: type, ids: selected, isManual: isManual, duration: duration });
    };
}

function changeZIndex(overlay, zIndex) {
    return { type: OverlayActionType.CHANGE_ZINDEX, overlay: overlay, zIndex: zIndex };
}

function pushOverlayBack(selectedOverlays) {
    var _selectedOverlays = _slicedToArray(selectedOverlays, 1),
        overlay = _selectedOverlays[0];

    return function (dispatch, getState) {
        var _getState18 = getState(),
            allOverlays = _getState18.overlays,
            time = _getState18.player.time;

        var _overlayOverlap = (0, _OverlayUtils.overlayOverlap)(overlay, allOverlays, time),
            overlappers = _overlayOverlap.overlappers,
            canGoBack = _overlayOverlap.canGoBack;

        if (canGoBack) {
            var overlaysBehind = overlappers.filter(function (oo) {
                return oo.space.zIndex < overlay.space.zIndex;
            });

            var targetZIndex = Math.max.apply(Math, _toConsumableArray(overlaysBehind.map(function (o) {
                return o.space.zIndex;
            })));

            dispatch(changeZIndex(overlay, targetZIndex));
        }
    };
}

function pushOverlayForward(selectedOverlays) {
    var _selectedOverlays2 = _slicedToArray(selectedOverlays, 1),
        overlay = _selectedOverlays2[0];

    return function (dispatch, getState) {
        var _getState19 = getState(),
            allOverlays = _getState19.overlays,
            time = _getState19.player.time;

        var _overlayOverlap2 = (0, _OverlayUtils.overlayOverlap)(overlay, allOverlays, time),
            overlappers = _overlayOverlap2.overlappers,
            canGoForward = _overlayOverlap2.canGoForward;

        if (canGoForward) {
            var overlaysInFront = overlappers.filter(function (oo) {
                return oo.space.zIndex > overlay.space.zIndex;
            });

            var targetZIndex = Math.min.apply(Math, _toConsumableArray(overlaysInFront.map(function (o) {
                return o.space.zIndex;
            })));

            dispatch(changeZIndex(overlay, targetZIndex));
        }
    };
}

function setSelectingRect(rect) {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            _state$player = state.player,
            playbackState = _state$player.playbackState,
            time = _state$player.time;

        var overlays = (0, _overlaySelectors.getHideFilteredValidTemplateOverlays)(state);

        if (playbackState == _PlaybackState2.default.PLAYING) {
            dispatch((0, _playerActions.pause)());
        }

        var anyselected = Object.keys(selected).length > 0;

        if (anyselected) {
            dispatch(selectClear());
        }

        var selectingOverlays = (0, _OverlayUtils.rectOverlappingOverlaysAtTime)(rect, overlays, time);

        dispatch({
            type: OverlayActionType.SET_SELECTING_RECT,
            selectingRect: rect,
            selectingOverlays: selectingOverlays
        });
    };
}

function endSelectingRect() {
    return function (dispatch, getState) {
        dispatch({ type: OverlayActionType.END_SELECTING_RECT });
        dispatch((0, _reelActions.unselectAllClips)());
    };
}

function clickOutsideVideo() {
    return function (dispatch, getState) {
        var _getState20 = getState(),
            selected = _getState20.selection.selected;

        var anyselected = Object.keys(selected).length > 0;

        if (anyselected) {
            dispatch(selectClear());
        }
        dispatch(modeActions.closePropertiesPanel());
    };
}

function updateAnimGroups(animgroups) {
    return { type: OverlayActionType.UPDATE_ANIM_GROUPS, animgroups: animgroups };
}

function onSetGroupAnimation(kind, enable) {
    return function (dispatch, getState) {
        var _getState21 = getState(),
            selected = _getState21.selection.selected,
            overlays = _getState21.overlays,
            animgroups = _getState21.overlaymeta.animgroups;

        var sOverlays = Object.keys(selected).map(function (oid) {
            return overlays[oid];
        });

        if (enable) {
            // First make sure these elements aren't part of other groups. Just guarding against bugs
            animgroups = animgroups.map(function (grp) {
                if (grp.kind === kind) {
                    var members = grp.members.filter(function (oid) {
                        return !selected[oid];
                    });
                    return _extends({}, grp, { members: members });
                }
                return grp;
            }).filter(function (grp) {
                return grp.members.length > 1;
            });

            var newanimgroup = {
                id: 'animgrp-' + _shortid2.default.generate(),
                kind: kind,
                members: Object.keys(selected)
            };

            animgroups = [].concat(_toConsumableArray(animgroups), [newanimgroup]);

            dispatch(updateAnimGroups(animgroups));

            // All these need to start/end at the same time and share start/end anim settings
            // Will use values from the first entering or last exiting overlay
            if (kind === 'enter') {
                sOverlays = sOverlays.sort(function (o1, o2) {
                    return o1.time.enterstart - o2.time.enterstart;
                });

                var _sOverlays = sOverlays,
                    _sOverlays2 = _slicedToArray(_sOverlays, 1),
                    sOverlay = _sOverlays2[0];

                var enterduration = Math.floor(sOverlay.time.enterdone - sOverlay.time.enterstart);
                var newenterstart = Math.floor(sOverlay.time.enterstart);

                sOverlays = sOverlays.map(function (o) {
                    return (0, _deepmerge2.default)(o, {
                        time: {
                            enterstart: newenterstart,
                            enterdone: Math.floor(newenterstart + enterduration),
                            enterAnimDefId: sOverlay.time.enterAnimDefId,
                            enterAnimTimeManual: sOverlay.time.enterAnimTimeManual
                        }
                    });
                });

                sOverlays.forEach(function (o) {
                    return dispatch(changeOverlay(o));
                });
            } else {
                sOverlays = sOverlays.sort(function (o1, o2) {
                    return o2.time.exitdone - o1.time.exitdone;
                });

                var _sOverlays3 = sOverlays,
                    _sOverlays4 = _slicedToArray(_sOverlays3, 1),
                    _sOverlay = _sOverlays4[0];

                var exitduration = _sOverlay.time.exitdone - _sOverlay.time.exitstart;
                var newexitdone = _sOverlay.time.exitdone;

                sOverlays = sOverlays.map(function (o) {
                    return (0, _deepmerge2.default)(o, {
                        time: {
                            exitstart: newexitdone - exitduration,
                            exitdone: newexitdone,
                            exitAnimDefId: _sOverlay.time.exitAnimDefId,
                            exitAnimTimeManual: _sOverlay.time.exitAnimTimeManual
                        }
                    });
                });

                sOverlays.forEach(function (o) {
                    return dispatch(changeOverlay(o));
                });
            }
        } else {
            // find the group with these elements
            // the group will contain one of these elements
            animgroups = animgroups.filter(function (grp) {
                if (grp.kind === kind) {
                    return !sOverlays.some(function (overlay) {
                        return grp.members.includes(overlay.id);
                    });
                }
                return true;
            });

            dispatch(updateAnimGroups(animgroups));
        }
    };
}

function multiSelect() {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var seekToFirstOverlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _ref12 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref12$unselectClips = _ref12.unselectClips,
        unselectClips = _ref12$unselectClips === undefined ? true : _ref12$unselectClips;

    return function (dispatch, getState) {
        var firstEnterStart = null;
        if (seekToFirstOverlay) {
            var _getState22 = getState(),
                overlays = _getState22.overlays;

            firstEnterStart = Object.values(ids.reduce(function (acc, id) {
                acc[id] = overlays[id];
                return acc;
            }, {})).reduce(function (acc, _ref13) {
                var enterstart = _ref13.time.enterstart;
                return Math.min(enterstart, acc);
            }, Infinity);
        }

        dispatch([(0, _playerActions.pause)(), {
            type: OverlayActionType.SELECT_SET,
            ids: ids
        }, modeActions.closeProjectProperties(), modeActions.closeAudioProperties(), modeActions.unselectWatermarkPreview()]);
        if (unselectClips) {
            (0, _reelActions.unselectAllClips)();
        }
        if (seekToFirstOverlay) {
            dispatch((0, _playerActions.seek)(firstEnterStart));
        }
    };
}

function selectAnimGroup(grpId) {
    return function (dispatch, getState) {
        var _getState23 = getState(),
            animgroups = _getState23.overlaymeta.animgroups;

        var animgroup = animgroups.find(function (grp) {
            return grp.id === grpId;
        });

        dispatch({
            type: OverlayActionType.SELECT_SET,
            ids: animgroup.members
        });
    };
}

function removeAnimGroup(grpId) {
    return function (dispatch, getState) {
        var _getState24 = getState(),
            animgroups = _getState24.overlaymeta.animgroups;

        animgroups = animgroups.filter(function (grp) {
            return grp.id !== grpId;
        });

        dispatch(updateAnimGroups(animgroups));
    };
}

function updateWorkspaceTemplates(templates) {
    return { type: OverlayActionType.TEMPLATES_LOAD, templates: templates };
}

function removeWorkspaceImage(mediaId) {
    return { type: OverlayActionType.REMOVE_IMAGE, mediaId: mediaId };
}

/**
 * Takes in single or muliple entry of bitmapdef and updates save method to call in batch
 *
 * @param {Array} bitmapTemplate
 * @export
 * @returns {any}
 */
function addBitmapTemplate(bitmapTemplate) {
    return { type: OverlayActionType.TEMPLATES_BITMAP_ADD, bitmapTemplate: bitmapTemplate };
}

function fontLoaded() {
    return { type: OverlayActionType.FONT_LOAD };
}

function filterTemplates(filterName) {
    return { type: OverlayActionType.FILTER_TEMPLATES, filterName: filterName };
}

function adjustOverlayTimeline(afterTime, adjustment) {
    return function (dispatch, getState) {
        var _getState25 = getState(),
            overlays = _getState25.overlays,
            _getState25$reel$sync = _getState25.reel.syncMediaAndText,
            syncMediaAndText = _getState25$reel$sync === undefined ? false : _getState25$reel$sync;

        if (syncMediaAndText) {
            var movedOverlays = Object.keys(overlays).map(function (overlayId) {
                var o = (0, _cloneextend.clone)(overlays[overlayId]);
                if (o.time.enterstart >= afterTime) {
                    o.time = _extends({}, o.time, {
                        enterstart: Math.max(0, Math.floor(o.time.enterstart + adjustment)),
                        enterdone: Math.max(0, Math.floor(o.time.enterdone + adjustment)),
                        exitstart: Math.max(0, Math.floor(o.time.exitstart + adjustment)),
                        exitdone: Math.max(0, Math.floor(o.time.exitdone + adjustment))
                    });
                }
                return o;
            });

            dispatch({
                type: OverlayActionType.ADJUST_OVERLAY_TIMES,
                movedOverlays: movedOverlays
            });
        }
    };
}

function loadMoreTemplates() {
    return { type: OverlayActionType.LOAD_MORE_TEMPLATES };
}

function disableOverlayMovement(disable) {
    return { type: OverlayActionType.DISABLE_OVERLAY_MOVEMENT, disable: disable };
}

// ------------- multi selected overlay control --------------------------------

function multipleAlignCenterHorizontal() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            canvas = state.reel.canvas;

        var selectedOverlays = Object.keys(selected).map(function (oid) {
            return state.overlays[oid];
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    x: canvas.width / 2 - o.space.width / 2
                }
            });
        });

        dispatch(moveMultipleFinish(newOverlays, selectedOverlays));
    };
}
function multipleAlignCenterVertical() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            canvas = state.reel.canvas;

        var selectedOverlays = Object.keys(selected).map(function (oid) {
            return state.overlays[oid];
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    y: canvas.height / 2 - o.space.height / 2
                }
            });
        });

        dispatch(moveMultipleFinish(newOverlays, selectedOverlays));
    };
}
function multipleAlignLeft() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            canvas = state.reel.canvas;

        var selectedOverlays = Object.keys(selected).map(function (oid) {
            return state.overlays[oid];
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    x: 0
                }
            });
        });

        dispatch(moveMultipleFinish(newOverlays, selectedOverlays));
    };
}
function multipleAlignRight() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            canvas = state.reel.canvas;

        var selectedOverlays = Object.keys(selected).map(function (oid) {
            return state.overlays[oid];
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    x: canvas.width - o.space.width
                }
            });
        });

        dispatch(moveMultipleFinish(newOverlays, selectedOverlays));
    };
}
function multipleAlignTop() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            canvas = state.reel.canvas;

        var selectedOverlays = Object.keys(selected).map(function (oid) {
            return state.overlays[oid];
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    y: 0
                }
            });
        });

        dispatch(moveMultipleFinish(newOverlays, selectedOverlays));
    };
}
function multipleAlignBottom() {
    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected,
            canvas = state.reel.canvas;

        var selectedOverlays = Object.keys(selected).map(function (oid) {
            return state.overlays[oid];
        });

        var newOverlays = selectedOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    y: canvas.height - o.space.height
                }
            });
        });

        dispatch(moveMultipleFinish(newOverlays, selectedOverlays));
    };
}
function changeMultipleOverlayEnterTime(ids, enterTimes) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000));
            dispatch({ type: OverlayActionType.MULTI_SET_TIME_RANGE, ids: ids, enterTimes: enterTimes });
        });
    };
}
/**
 *
 * @param {boolean} shadowEnabled
 */
function changeMultipleOverlayShadow() {
    var shadowEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        var state = getState();
        var selectedOverlays = (0, _overlaySelectors.getSelectedOverlaysFilteredByHidden)(state);

        var newOverlays = selectedOverlays.map(function (overlay) {
            var def = getTemplateDefForId(overlay.defId);
            var ops = shadowProps(def);
            if (ops.length > 0) {
                var _ops = _slicedToArray(ops, 1),
                    op = _ops[0];

                return (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, op, shadowEnabled) });
            }
            return overlay;
        });

        dispatch(changeMultipleOverlaysFinish(newOverlays, selectedOverlays));
    };
}

/**
 *
 * @param {number} newOpacity
 * @param {number} startOpacity
 */
function changeMultipleOverlayOpacity() {
    var newOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var startOpacity = arguments[1];

    return function (dispatch, getState) {
        var state = getState();
        var selectedOverlays = (0, _overlaySelectors.getSelectedOverlaysFilteredByHidden)(state);

        var newOverlays = selectedOverlays.map(function (overlay) {
            var def = getTemplateDefForId(overlay.defId);
            var ops = alphaProps(def);
            if (ops.length > 0) {
                var _ops2 = _slicedToArray(ops, 1),
                    op = _ops2[0];

                return (0, _deepmerge2.default)(overlay, { values: _defineProperty({}, op, newOpacity) });
            }
            return overlay;
        });

        if (startOpacity) {
            dispatch(changeMultipleOverlaysFinish(newOverlays, selectedOverlays));
        } else {
            dispatch(changeMultipleOverlays(newOverlays));
        }
    };
}

/**
 * @param {number} rotateVal
 */
function changeMultipleOverlayRotate() {
    var rotateVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return function (dispatch, getState) {
        var state = getState();
        var selectedOverlays = (0, _overlaySelectors.getSelectedOverlaysFilteredByHidden)(state);

        var newRotateValue = rotateVal % 360;
        if (newRotateValue < 0) {
            newRotateValue += 360;
        } else if (newRotateValue > 360) {
            newRotateValue %= 360;
        }

        var newOverlays = selectedOverlays.map(function (overlay) {
            var def = getTemplateDefForId(overlay.defId);
            var ops = alphaProps(def);
            if (ops.length > 0) {
                return (0, _deepmerge2.default)(overlay, { space: { rotateDeg: newRotateValue } });
            }
            return overlay;
        });

        dispatch(changeMultipleOverlaysFinish(newOverlays, selectedOverlays));
    };
}

/**
 *
 * @param {*} overlayPropMap
 * @param {*} newFont
 */
function changeMultipleOverlayFontFamily(overlaysPropMap, newFont) {
    return function (dispatch, getState) {
        var state = getState();
        var overlays = state.overlays;

        var startOverlays = overlaysPropMap.map(function (_ref14) {
            var overlayId = _ref14.overlayId;

            if (overlays[overlayId]) {
                return overlays[overlayId];
            }
            return null;
        }).filter(function (o) {
            return !!o;
        });

        var newOverlays = overlaysPropMap.map(function (_ref15) {
            var overlayId = _ref15.overlayId,
                prop = _ref15.prop;

            if (overlays[overlayId]) {
                return (0, _deepmerge2.default)(overlays[overlayId], {
                    values: _defineProperty({}, prop, newFont),
                    variant: _defineProperty({}, prop, _FontManager2.default.getVariantObject(newFont))
                });
            }
            return null;
        }).filter(function (o) {
            return !!o;
        });

        dispatch(changeMultipleOverlaysFinish(newOverlays, startOverlays));
    };
}

/**
 *
 * @param {*} overlayPropMap
 * @param {*} newFont
 */
function changeMultipleOverlayColor(overlaysPropMap, newColor, oldColor) {
    var incremental = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return function (dispatch, getState) {
        var state = getState();
        var overlays = state.overlays;

        var startOverlays = overlaysPropMap.map(function (_ref16) {
            var overlayId = _ref16.overlayId;

            if (overlays[overlayId]) {
                return overlays[overlayId];
            }
            return null;
        }).filter(function (o) {
            return !!o;
        });

        var newOverlays = overlaysPropMap.map(function (_ref17) {
            var overlayId = _ref17.overlayId,
                prop = _ref17.prop;

            if (overlays[overlayId]) {
                var overlay = overlays[overlayId];

                var initialColorValue = overlay.values[prop];
                var colorRange = new _ColorRange2.default(initialColorValue);

                colorRange.replaceColor(oldColor, newColor);
                var colorVal = colorRange.toString();

                return (0, _deepmerge2.default)(overlays[overlayId], {
                    values: _defineProperty({}, prop, colorVal)
                });
            }
            return null;
        }).filter(function (o) {
            return !!o;
        });

        if (incremental) {
            dispatch(changeMultipleOverlays(newOverlays));
        } else {
            dispatch(changeMultipleOverlaysFinish(newOverlays, startOverlays));
        }
    };
}

function hideSelectedOverlays() {
    var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        var state = getState();
        var selected = state.selection.selected;

        if (hide) {
            dispatch(selectClear());
        }
        dispatch({ type: OverlayActionType.HIDE_OVERLAY, overlays: selected, hide: hide });
    };
}

function hideOverlayByIds(overlayIdsMap) {
    var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        if (hide) {
            dispatch(selectClear());
            dispatch(reelActions.selectClip());
        }
        dispatch({ type: OverlayActionType.HIDE_OVERLAY, overlays: overlayIdsMap, hide: hide });
    };
}

},{"../../common/utils/ColorRange":71,"../../common/utils/CommonAlgorithms":72,"../../common/utils/FontManager":76,"../../common/utils/GeneralUtils":77,"../../common/utils/HighlightColorRange":78,"../../common/utils/ReelHelpers":85,"../../common/utils/TrackUtils":90,"../../common/utils/enums/EditorMode":94,"../../common/utils/enums/PlaybackState":96,"../../common/utils/errorReporting":101,"../../common/utils/renderer/DefModel":119,"../../common/utils/renderer/LayerUtils":121,"../../common/utils/watermarkUtils":130,"../api":176,"../components/utility/pluginUtils/general":200,"../constants/General":203,"../constants/PropertiesPanelType":206,"../selectors/overlaySelectors":217,"../selectors/projectAssetSelectors":219,"../selectors/reelSelectors":221,"../selectors/sequenceSelectors":223,"../utils/OverlayUtils":231,"./deleteWarningActions":154,"./emptyProjectActions":155,"./guardActions":157,"./leftShelf":159,"./logActions":160,"./mediaActions":161,"./modeActions":162,"./onboardingActions":164,"./playerActions":166,"./pluginActions":167,"./reelActions":170,"./uiActions":174,"./workspaceActions":175,"cloneextend":412,"deepmerge":549,"diff-match-patch":553,"keymirror":677,"react-redux":1079,"shortid":1163}],166:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.throttledSeek = exports.PlayerActionType = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.togglePlay = togglePlay;
exports.play = play;
exports.pause = pause;
exports.seek = seek;
exports.rewind = rewind;
exports.forward = forward;
exports.seekToPrevFrame = seekToPrevFrame;
exports.seekToNextFrame = seekToNextFrame;
exports.setVolume = setVolume;
exports.dragStart = dragStart;
exports.dragMove = dragMove;
exports.dragEnd = dragEnd;
exports.playPreviewAudio = playPreviewAudio;
exports.stopPreviewAudio = stopPreviewAudio;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _reactRedux = require('react-redux');

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _guardActions = require('./guardActions');

var _reelActions = require('./reelActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// TODO add as events to be ignored by Persistence engne
var PlayerActionType = exports.PlayerActionType = (0, _keymirror2.default)({
    PLAY: null,
    PAUSE: null,
    SEEK: null,
    REWIND: null,
    SET_VOLUME: null,
    DRAG_START: null,
    DRAG_MOVE: null,
    DRAG_END: null,
    PREVIEW_AUDIO_PLAY: null,
    PREVIEW_AUDIO_STOP: null
});

function togglePlay() {
    return function (dispatch, getState) {
        var playing = getState().player.playbackState === _PlaybackState2.default.PLAYING;
        dispatch((0, _reelActions.unselectAllClips)());
        dispatch(playing ? pause() : play());
    };
}
function play() {
    return function (dispatch, getState) {
        dispatch(stopPreviewAudio());

        dispatch({ type: PlayerActionType.PLAY });
        dispatch((0, _reelActions.unselectAllClips)());
    };
}

function pause() {
    var shouldSelectClip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return function (dispatch, getState) {
        if (getState().player.playbackState === _PlaybackState2.default.PLAYING) {
            dispatch({ type: PlayerActionType.PAUSE });
        }

        var _getState = getState(),
            selected = _getState.selection.selected;

        if (shouldSelectClip && Object.keys(selected).length == 0) {
            dispatch((0, _reelActions.selectClip)());
        }
    };
}

var throttledSeek = exports.throttledSeek = (0, _GeneralUtils.getThrottledDispatch)(seek, 16);

function seek(time) {
    var selectNewClip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var timeDifference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 33;

    time = Math.floor(time);

    return function (dispatch, getState) {
        var shouldSelectClip = false;
        var clipId = null;
        if (selectNewClip) {
            var state = getState();
            var clips = state.reel.clips;

            var _clips$findItemsFromS = clips.findItemsFromSorted(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    firstClip = _ref2[0],
                    lastClip = _ref2[1];

                return firstClip.time.enterStart <= time && lastClip.time.exitDone >= time;
            }),
                _clips$findItemsFromS2 = _slicedToArray(_clips$findItemsFromS, 1),
                currentClip = _clips$findItemsFromS2[0];

            var _clips$findItemsFromS3 = clips.findItemsFromSorted(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    firstClip = _ref4[0],
                    lastClip = _ref4[1];

                return firstClip.time.enterStart <= time - timeDifference && lastClip.time.exitDone >= time - timeDifference;
            }),
                _clips$findItemsFromS4 = _slicedToArray(_clips$findItemsFromS3, 1),
                prevClipForwards = _clips$findItemsFromS4[0];

            var _clips$findItemsFromS5 = clips.findItemsFromSorted(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2),
                    firstClip = _ref6[0],
                    lastClip = _ref6[1];

                return firstClip.time.enterStart <= time + timeDifference && lastClip.time.exitDone >= time + timeDifference;
            }),
                _clips$findItemsFromS6 = _slicedToArray(_clips$findItemsFromS5, 1),
                prevClipBackwards = _clips$findItemsFromS6[0];

            if (prevClipBackwards && prevClipForwards && currentClip) {
                if (prevClipForwards[0].isSelected && prevClipForwards[0].clipId !== currentClip[0].clipId) {
                    // SWITCH CLIPS WHEN MOVING FORRWARDS
                    shouldSelectClip = true;
                    clipId = currentClip[0].clipId;
                } else if (prevClipBackwards[0].isSelected && prevClipBackwards[0].clipId !== currentClip[0].clipId) {
                    // SWITCH CLIPS WHEN MOVING BACKWARDS
                    shouldSelectClip = true;
                    clipId = currentClip[0].clipId;
                } else if (!prevClipForwards[0].isSelected && !prevClipBackwards[0].isSelected && !currentClip[0].isSelected) {
                    // NOTHING IS SELECTED when MOVING FAST
                    shouldSelectClip = true;
                    clipId = currentClip[0].clipId;
                }
            }
        }

        (0, _reactRedux.batch)(function () {
            if (clipId && shouldSelectClip) dispatch((0, _reelActions.selectClip)(false, clipId));
            dispatch({ type: PlayerActionType.SEEK, time: time });
        });
    };
}

function rewind() {
    return function (dispatch, getState) {
        var _getState$player = getState().player,
            playbackState = _getState$player.playbackState,
            time = _getState$player.time;

        dispatch(seek(Math.max(time - 1000, 0)));
    };
}

function forward() {
    return function (dispatch, getState) {
        var _getState$player2 = getState().player,
            playbackState = _getState$player2.playbackState,
            time = _getState$player2.time,
            duration = _getState$player2.duration;

        dispatch(seek(Math.min(time + 1000, duration)));
    };
}

function seekToPrevFrame() {
    return function (dispatch, getState) {
        var _getState$player3 = getState().player,
            playbackState = _getState$player3.playbackState,
            time = _getState$player3.time;

        if (playbackState === _PlaybackState2.default.PLAYING) {
            dispatch(pause());
        }

        dispatch(seek(Math.max(time - 16, 0)));
    };
}

function seekToNextFrame() {
    return function (dispatch, getState) {
        var _getState$player4 = getState().player,
            playbackState = _getState$player4.playbackState,
            time = _getState$player4.time,
            duration = _getState$player4.duration;

        if (playbackState === _PlaybackState2.default.PLAYING) {
            dispatch(pause());
        }

        dispatch(seek(Math.min(time + 16, duration)));
    };
}

function setVolume(volume) {
    return { type: PlayerActionType.SET_VOLUME, volume: volume };
}

var dragStartAction = function dragStartAction(dragWasPlayingBefore) {
    return { type: PlayerActionType.DRAG_START, dragWasPlayingBefore: dragWasPlayingBefore };
};

function dragStart() {
    return function (dispatch, getState) {
        var playbackState = getState().player.playbackState;

        if (playbackState == _PlaybackState2.default.PLAYING) {
            // Pause the video
            dispatch(pause());

            dispatch(dragStartAction(true));
        } else {
            dispatch(dragStartAction(false));
        }
    };
}

/**
 * Used when dragging handle bar uses seekBar with select clip routine
 *
 * @export
 * @param {*} time
 * @return {*}
 */
function dragMove(time) {
    return function (dispatch, getState) {
        var _getState2 = getState(),
            player = _getState2.player;

        if (player.dragWasPlayingBefore && time >= player.duration) {
            dispatch(seek(time - 1, false));
        } else {
            dispatch(seek(time, false));
        }
    };
}

function dragEnd() {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            player = _getState3.player;

        if (player.dragWasPlayingBefore) {
            dispatch(play());
        }

        dispatch({ type: PlayerActionType.DRAG_END });
    };
}

function playPreviewAudio(playingAudioId) {
    return function (dispatch, getState) {
        // Pause main player (safe to call even if not playing)
        dispatch(pause(false));

        dispatch({ type: PlayerActionType.PREVIEW_AUDIO_PLAY, playingAudioId: playingAudioId });
    };
}

function stopPreviewAudio() {
    return { type: PlayerActionType.PREVIEW_AUDIO_STOP };
}

},{"../../common/utils/GeneralUtils":77,"../../common/utils/enums/PlaybackState":96,"./guardActions":157,"./reelActions":170,"keymirror":677,"react-redux":1079}],167:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerPluginInternalAsset = exports.registerIconScoutPluginAsset = exports.addIconscoutItem = exports.togglePlugin = exports.disablePlugin = exports.enablePlugin = exports.PluginActionsEnums = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _reactRedux = require('react-redux');

var _PluginsApi = require('../../common/api/PluginsApi');

var _PluginService = require('../../common/constants/PluginService');

var _TemplateTypes = require('../../common/constants/TemplateTypes');

var _assetsManager = require('../../common/utils/assetsManager');

var _assetsManager2 = _interopRequireDefault(_assetsManager);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _general = require('../components/utility/pluginUtils/general');

var _General = require('../constants/General');

var _miscSelectors = require('../selectors/miscSelectors');

var _projectAssetSelectors = require('../selectors/projectAssetSelectors');

var _emptyProjectActions = require('./emptyProjectActions');

var _modeActions = require('./modeActions');

var _overlayActions = require('./overlayActions');

var _projectAssetAction = require('./projectAssetAction');

var _uiActions = require('./uiActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var dlog = (0, _GeneralUtils.createDlog)(true);

var WAIT_FOR_RESPONSE = true;

var PluginActionsEnums = exports.PluginActionsEnums = (0, _keymirror2.default)({
    ENABLED_PLUGIN: null,
    ENABLING_PLGIN: null
});

var pluginControlApi = new _PluginsApi.PluginControlApi();

var enablePlugin = exports.enablePlugin = function enablePlugin(plugin) {
    var waitForResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WAIT_FOR_RESPONSE;
    return function (dispatch, getState) {
        var _getState = getState(),
            id = _getState.userData.id,
            _getState$pluginServi = _getState.pluginService[plugin];

        _getState$pluginServi = _getState$pluginServi === undefined ? {} : _getState$pluginServi;
        var _getState$pluginServi2 = _getState$pluginServi.enabled,
            enabled = _getState$pluginServi2 === undefined ? false : _getState$pluginServi2,
            _getState$pluginServi3 = _getState$pluginServi.serviceDown,
            serviceDown = _getState$pluginServi3 === undefined ? true : _getState$pluginServi3;

        if (enabled) {
            dispatch((0, _modeActions.changeSidebarSection)((0, _general.getPluginShelfEntryKey)(plugin, true)));
            return;
        }
        dispatch(togglePlugin(plugin, waitForResponse));
    };
};

var disablePlugin = exports.disablePlugin = function disablePlugin(plugin) {
    var waitForResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WAIT_FOR_RESPONSE;
    return function (dispatch, getState) {
        var _getState2 = getState(),
            id = _getState2.userData.id,
            _getState2$pluginServ = _getState2.pluginService[plugin];

        _getState2$pluginServ = _getState2$pluginServ === undefined ? {} : _getState2$pluginServ;
        var _getState2$pluginServ2 = _getState2$pluginServ.enabled,
            enabled = _getState2$pluginServ2 === undefined ? false : _getState2$pluginServ2,
            _getState2$pluginServ3 = _getState2$pluginServ.serviceDown,
            serviceDown = _getState2$pluginServ3 === undefined ? true : _getState2$pluginServ3;

        if (!enabled) return;
        dispatch(togglePlugin(plugin, waitForResponse));
    };
};

var togglePlugin = exports.togglePlugin = function togglePlugin(plugin) {
    var waitForResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WAIT_FOR_RESPONSE;
    return function (dispatch, getState) {
        var _getState3 = getState(),
            id = _getState3.userData.id,
            _getState3$pluginServ = _getState3.pluginService[plugin];

        _getState3$pluginServ = _getState3$pluginServ === undefined ? {} : _getState3$pluginServ;
        var _getState3$pluginServ2 = _getState3$pluginServ.enabled,
            enabled = _getState3$pluginServ2 === undefined ? false : _getState3$pluginServ2,
            _getState3$pluginServ3 = _getState3$pluginServ.serviceDown,
            serviceDown = _getState3$pluginServ3 === undefined ? true : _getState3$pluginServ3;

        if (Object.keys(_PluginService.SupportedPlugins).includes(plugin) && !serviceDown) {
            (0, _reactRedux.batch)(function () {
                dispatch({
                    type: PluginActionsEnums.ENABLING_PLGIN,
                    plugin: plugin,
                    enabling: true
                });
                pluginControlApi.togglePlugin(id, plugin).then(function (enableState) {
                    if (waitForResponse) {
                        var newEnable = enableState && !serviceDown;
                        dispatch({
                            type: PluginActionsEnums.ENABLED_PLUGIN,
                            plugin: plugin,
                            enabled: newEnable
                        });
                        if (!newEnable) {
                            dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.PLUGINS.id, true));
                        } else {
                            dispatch((0, _modeActions.changeSidebarSection)((0, _general.getPluginShelfEntryKey)(plugin, true)));
                        }
                    }
                });

                if (!waitForResponse) {
                    var newEnable = !enabled && !serviceDown;
                    dispatch({
                        type: PluginActionsEnums.ENABLED_PLUGIN,
                        plugin: plugin,
                        enabling: false,
                        enabled: newEnable
                    });
                    if (!newEnable) {
                        dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.PLUGINS.id, true));
                    } else {
                        dispatch((0, _modeActions.changeSidebarSection)((0, _general.getPluginShelfEntryKey)(plugin, true)));
                    }
                }
            });
        } else {
            dlog('Failed to toggle : ' + plugin);
        }
    };
};

var findSVGTemplateForDefId = function findSVGTemplateForDefId(templates, defId) {
    var svgGroup = templates.images.find(function (grp) {
        return grp.id === 'svg-assets';
    });
    return svgGroup.items.find(function (svg) {
        return svg.defId === defId;
    });
};

var addIconscoutItem = exports.addIconscoutItem = function addIconscoutItem(uuid) {
    return (0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
        return function (dispatch, getState, _ref) {
            var appManager = _ref.appManager;

            var state = getState();
            var _state$projectAssets = state.projectAssets,
                projectAssets = _state$projectAssets === undefined ? [] : _state$projectAssets,
                templates = state.templates;

            var asset = projectAssets.find(function (item) {
                return item.mediaType === _TemplateTypes.SupportedAssetTypes.svg && item.source === _PluginService.SupportedPlugins.iconscout && item.assetData.originalAssetId === uuid;
            });

            if (!asset) {
                dispatch((0, _uiActions.setDownlodingIconScoutItem)(uuid, true));
                dispatch(registerIconScoutPluginAsset({
                    uuid: uuid,
                    onResponse: function onResponse(assetData) {
                        // dlog(assetData);
                        dispatch((0, _projectAssetAction.addSVGToProjectAssets)({
                            assetData: assetData,
                            source: _PluginService.SupportedPlugins.iconscout
                        }));
                        var definition = appManager.registerUserSVGDef(assetData, dispatch);
                        dispatch((0, _overlayActions.addSvgAssetOverlay)(definition.id));
                        dispatch((0, _uiActions.setDownlodingIconScoutItem)(uuid, false));
                        _assetsManager2.default.registerAssetForImport(assetData); // makes sure that this resource is cached in user's browser for subsequent request
                        // more to be done here ??
                    },
                    onFailure: function onFailure() {}
                }));
            } else {
                dispatch((0, _uiActions.setDownlodingIconScoutItem)(uuid, true));
                // dlog(`asset found , `, { asset });
                // more to be done here
                var defId = (0, _general.createDefIdName)(asset.assetData);
                var definition = findSVGTemplateForDefId(templates, defId);
                dispatch((0, _overlayActions.addSvgAssetOverlay)(definition.id));
                dispatch((0, _uiActions.setDownlodingIconScoutItem)(uuid, false));
            }
        };
    });
};

var registerIconScoutPluginAsset = exports.registerIconScoutPluginAsset = function registerIconScoutPluginAsset(_ref2) {
    var uuid = _ref2.uuid,
        _ref2$onResponse = _ref2.onResponse,
        onResponse = _ref2$onResponse === undefined ? function () {} : _ref2$onResponse,
        _ref2$onFailure = _ref2.onFailure,
        onFailure = _ref2$onFailure === undefined ? function (err) {
        throw err;
    } : _ref2$onFailure;
    return function (dispatch, getState) {
        var state = getState();

        var _getWorkspaceData = (0, _miscSelectors.getWorkspaceData)(state),
            workspaceId = _getWorkspaceData.workspaceId;

        var _getUserData = (0, _miscSelectors.getUserData)(state),
            userId = _getUserData.id;

        var _getProjectData = (0, _miscSelectors.getProjectData)(state),
            projectId = _getProjectData.id;

        pluginControlApi.registerIconScoutAsset(userId, projectId, workspaceId, uuid).then(function (assetData) {
            onResponse(assetData);
        }).catch(function (err) {
            onFailure(err);
        });
    };
};

var registerPluginInternalAsset = exports.registerPluginInternalAsset = function registerPluginInternalAsset(_ref3) {
    var plugin = _ref3.plugin,
        id = _ref3.id,
        _ref3$onResponse = _ref3.onResponse,
        onResponse = _ref3$onResponse === undefined ? function () {} : _ref3$onResponse,
        _ref3$onFailure = _ref3.onFailure,
        onFailure = _ref3$onFailure === undefined ? function () {} : _ref3$onFailure;
    return function (dispatch, getState, _ref4) {
        var appManager = _ref4.appManager;

        var state = getState();

        var _getWorkspaceData2 = (0, _miscSelectors.getWorkspaceData)(state),
            workspaceId = _getWorkspaceData2.workspaceId;

        var _getUserData2 = (0, _miscSelectors.getUserData)(state),
            userId = _getUserData2.id;

        var _getProjectData2 = (0, _miscSelectors.getProjectData)(state),
            projectId = _getProjectData2.id;

        if (!Object.keys(_PluginService.SupportedPlugins).includes(plugin)) return;

        // dlog({
        //     plugin , id , userId , projectId , workspaceId
        // })

        var assetData = (0, _projectAssetSelectors.getProjectAssetsObject)(state);

        if (assetData[id]) return;

        pluginControlApi.registerInternalAsset(plugin, id, userId, projectId, workspaceId).then(function (assetData) {
            dispatch((0, _projectAssetAction.addSVGToProjectAssets)({
                assetData: assetData,
                source: plugin
            }));
            appManager.registerUserSVGDef(assetData, dispatch);
            _assetsManager2.default.registerAssetForImport(assetData);
            onResponse(assetData);
        }).catch(function (err) {
            onFailure(err);
        });
    };
};

},{"../../common/api/PluginsApi":3,"../../common/constants/PluginService":65,"../../common/constants/TemplateTypes":67,"../../common/utils/GeneralUtils":77,"../../common/utils/assetsManager":92,"../components/utility/pluginUtils/general":200,"../constants/General":203,"../selectors/miscSelectors":215,"../selectors/projectAssetSelectors":219,"./emptyProjectActions":155,"./modeActions":162,"./overlayActions":165,"./projectAssetAction":169,"./uiActions":174,"keymirror":677,"react-redux":1079}],168:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProjectActionType = undefined;
exports.changeProjectName = changeProjectName;
exports.deleteCurrentProject = deleteCurrentProject;
exports.saveCurrentProject = saveCurrentProject;
exports.markRemovedProjectWatermark = markRemovedProjectWatermark;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _api = require('../api');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

/*
    action types
*/

var ProjectActionType = exports.ProjectActionType = (0, _keymirror2.default)({
    CHANGE_NAME: null,
    SAVING_PROJECT: null,
    SAVED_PROJECT: null,
    SAVE_PROJECT: null,
    UPDATE_PROJECT_UPDATED_AT: null,
    PROJECT_WATERMARK_REMOVED: null
});

function changeProjectName(name) {
    return function (dispatch, getState) {
        //  Dispatch immediately. We aren't waiting for the API call reponse
        var res = dispatch({ type: ProjectActionType.CHANGE_NAME, name: name });

        // Need id to update name
        var id = getState().project.id;

        if (!window.appManager.isDemoMode()) {
            // Fire an api request to update
            (0, _api.updateProjectNameP)(id, name).then(function () {
                /* Nothing */
            }).catch(function (err) {
                console.log(err); /* Nothing */
            });

            return res;
        }
    };
}

function deleteCurrentProject() {
    return function (dispatch, getState) {
        var _getState = getState(),
            projectId = _getState.project.id;

        if (!projectId) {
            console.log('Could not delete project. Could not find projectId');
            return;
        }

        (0, _api.deleteProjectP)(projectId).then(function () {
            window.location.href = '/';
        }).catch(function (err) {
            console.log('Could not delete project', err);
        });
    };
}

function saveCurrentProject() {
    if (appManager.isDemoMode()) return;
    return function (dispatch, getState) {
        appManager.persistanceEngine.forceServerSyncP().then(function (data) {
            //done for user feedback
            setTimeout(function () {
                dispatch({ type: ProjectActionType.SAVED_PROJECT });
            }, 500);
        });
    };
}

function markRemovedProjectWatermark() {
    return { type: ProjectActionType.PROJECT_WATERMARK_REMOVED };
}

},{"../api":176,"keymirror":677}],169:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addSVGToProjectAssets = exports.AssetActions = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var AssetActions = exports.AssetActions = (0, _keymirror2.default)({
    ADD_ASSET_SVG: null
});

var addSVGToProjectAssets = exports.addSVGToProjectAssets = function addSVGToProjectAssets(_ref) {
    var assetData = _ref.assetData,
        _ref$source = _ref.source,
        source = _ref$source === undefined ? 'personal' : _ref$source;

    return { assetData: assetData, type: AssetActions.ADD_ASSET_SVG, source: source };
};

},{"keymirror":677}],170:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.adjustTransitionsForAllClip = exports.AudioTrimModalActionType = exports.ClipActionType = exports.UserSpaceContentAdd = exports.ReelActionType = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.updateClipsMediaData = updateClipsMediaData;
exports.multiDeleteClip = multiDeleteClip;
exports.createSequenceRemoveActionData = createSequenceRemoveActionData;
exports.deleteClip = deleteClip;
exports.cleanProject = cleanProject;
exports.deleteCurrentClipWithWarning = deleteCurrentClipWithWarning;
exports.selectClip = selectClip;
exports.selectSequenceInnerClip = selectSequenceInnerClip;
exports.unselectAllClips = unselectAllClips;
exports.addClip = addClip;
exports.minimalAddClip = minimalAddClip;
exports.updatePlaceholderClipColorForInnerClip = updatePlaceholderClipColorForInnerClip;
exports.updatePlaceholderClipColor = updatePlaceholderClipColor;
exports.replaceClipWithSolidImage = replaceClipWithSolidImage;
exports.replaceSequenceInnerClipWithSolidImage = replaceSequenceInnerClipWithSolidImage;
exports.replaceSequenceInnerClipWithMedia = replaceSequenceInnerClipWithMedia;
exports.replaceClipWithMedia = replaceClipWithMedia;
exports.addNewSolidImageClip = addNewSolidImageClip;
exports.updateProjectMedia = updateProjectMedia;
exports.replaceMultiClipWithSequence = replaceMultiClipWithSequence;
exports.createDataForAddMultipleNewCompositeClip = createDataForAddMultipleNewCompositeClip;
exports.setupAddMultipleNewCompositeClip = setupAddMultipleNewCompositeClip;
exports.addMultipleNewCompositeClip = addMultipleNewCompositeClip;
exports.createCompositeClipFromState = createCompositeClipFromState;
exports.reverseCompositeClipAdd = reverseCompositeClipAdd;
exports.setupAddNewCompositeClipWithClipData = setupAddNewCompositeClipWithClipData;
exports.addNewCompositeClip = addNewCompositeClip;
exports.replaceSequenceInnerClipWithUserSpaceMedia = replaceSequenceInnerClipWithUserSpaceMedia;
exports.addNewUserSpaceClip = addNewUserSpaceClip;
exports.addNewClip = addNewClip;
exports.splitClip = splitClip;
exports.cropCurrentClip = cropCurrentClip;
exports.moveClip = moveClip;
exports.trimToVideoDurationLimit = trimToVideoDurationLimit;
exports.trimClipIncemental = trimClipIncemental;
exports.trimClipFinish = trimClipFinish;
exports.changeFormat = changeFormat;
exports.changeFrameType = changeFrameType;
exports.changeFrameColor = changeFrameColor;
exports.setAudio = setAudio;
exports.switchAudioLooping = switchAudioLooping;
exports.openAudioTrimModal = openAudioTrimModal;
exports.closeAudoTrimModal = closeAudoTrimModal;
exports.trimAudio = trimAudio;
exports.clearAudio = clearAudio;
exports.setAudioVolume = setAudioVolume;
exports.setVideoVolume = setVideoVolume;
exports.setVideoSpeedInnerClip = setVideoSpeedInnerClip;
exports.setVideoSpeed = setVideoSpeed;
exports.setClipAnimTypeForSequenceInnerClip = setClipAnimTypeForSequenceInnerClip;
exports.setClipAnimType = setClipAnimType;
exports.addColor = addColor;
exports.addProjectColor = addProjectColor;
exports.addBrandColor = addBrandColor;
exports.setVolumeMode = setVolumeMode;
exports.setClipVolume = setClipVolume;
exports.setMusicVolume = setMusicVolume;
exports.startCroppingClip = startCroppingClip;
exports.updateCroppingClip = updateCroppingClip;
exports.updateRotateClip = updateRotateClip;
exports.finishCroppingClip = finishCroppingClip;
exports.undoCroppingClip = undoCroppingClip;
exports.cancelCroppingClip = cancelCroppingClip;
exports.setVideoDurationLimit = setVideoDurationLimit;
exports.setTransition = setTransition;
exports.updateVolumeForInnerClip = updateVolumeForInnerClip;
exports.updateRotateForInnerClip = updateRotateForInnerClip;
exports.showTransitionButtons = showTransitionButtons;
exports.setSyncMediaAndText = setSyncMediaAndText;
exports.replaceClip = replaceClip;
exports.showWatermark = showWatermark;
exports.hideWatermark = hideWatermark;
exports.replaceWatermark = replaceWatermark;
exports.watermarkReplaced = watermarkReplaced;
exports.watermarkDeleted = watermarkDeleted;
exports.defaultWatermarkAdded = defaultWatermarkAdded;
exports.clickOutSideReelArea = clickOutSideReelArea;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _cloneextend = require('cloneextend');

var _reactRedux = require('react-redux');

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _underscore = require('underscore');

var _TrackUtils = require('../../common/utils/TrackUtils');

var _EditorMode = require('../../common/utils/enums/EditorMode');

var _EditorMode2 = _interopRequireDefault(_EditorMode);

var _PropertiesPanelType = require('../constants/PropertiesPanelType');

var _PropertiesPanelType2 = _interopRequireDefault(_PropertiesPanelType);

var _ReelHelpers = require('../../common/utils/ReelHelpers');

var _overlayActions = require('./overlayActions');

var _mediaActions = require('./mediaActions');

var _logActions = require('./logActions');

var _subtitleActions = require('./subtitleActions');

var _ActionTypes = require('./ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _accountApis = require('../../account/accountApis');

var accountApis = _interopRequireWildcard(_accountApis);

var _workspaceApi = require('../../common/api/workspaceApi');

var _modeActions = require('./modeActions');

var modeActions = _interopRequireWildcard(_modeActions);

var _TransitionType = require('../constants/TransitionType');

var _TransitionType2 = _interopRequireDefault(_TransitionType);

var _ReelUtils = require('../utils/ReelUtils');

var _TransitionType3 = require('../../common/utils/enums/TransitionType');

var _SolidImage = require('../../common/constants/SolidImage');

var _reelSelectors = require('../selectors/reelSelectors');

var _emptyProjectActions = require('./emptyProjectActions');

var _PlayerRegistry = require('../../common/utils/players/PlayerRegistry');

var _PlayerRegistry2 = _interopRequireDefault(_PlayerRegistry);

var _miscSelectors = require('../selectors/miscSelectors');

var _exportActions = require('../../export/actions/exportActions');

var _ExportPageApi = require('../../export/apis/ExportPageApi');

var _pricingActions = require('../../pricing/actions/pricingActions');

var _projectActions = require('./projectActions');

var _sequenceActions = require('./sequenceActions');

var _polyfill = require('../../common/utils/scheduler/polyfill');

var _playerActions = require('./playerActions');

var _uiActions = require('./uiActions');

var _guardActions = require('./guardActions');

var _sequenceSelectors = require('../selectors/sequenceSelectors');

var _onboardingActions = require('./onboardingActions');

var _notificationSystemAction = require('./notificationSystemAction');

var _MediaConstants = require('../../../../constants/MediaConstants');

var _CommonAlgorithms = require('../../common/utils/CommonAlgorithms');

var _CommonAlgorithms2 = _interopRequireDefault(_CommonAlgorithms);

var _deleteWarningActions = require('./deleteWarningActions');

var _General = require('../constants/General');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var DEBUG = false;

var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var getOverlayToSequenceClipMap = (0, _sequenceSelectors.makeGetOverlayToSequenceClipIdMap)();

var UploadActionType = (0, _keymirror2.default)({
    UPLOAD_STARTED: null,
    UPLOAD_THUMBNAIL_READY: null,
    UPLOAD_PROGRESS: null,
    UPLOAD_COMPLETE: null,
    UPLOAD_ERROR: null,
    UPLOAD_CLEAR: null,
    UPLOADS_SHOW: null,
    UPLOADS_SUBTITLES_LOADED: null
});

var ReelActionType = exports.ReelActionType = (0, _keymirror2.default)({
    CLIP_ADD: null,
    CLIP_DELETE: null,
    CLIP_TRIM_INCR: null,
    CLIP_TRIM_FINISH: null,
    CLIP_SPLIT: null,
    CLIP_MOVE: null,
    CLIP_SELECT: null,
    CLIP_UNSELECT_ALL: null,
    CLIP_SET_ANIMTYPE: null,
    CLIP_COLOR_UPDATE: null,
    VIDEO_VOLUME_SET: null,
    VIDEO_SET_SPEED: null,
    FRAME_CHANGE: null,
    FORMAT_CHANGE: null,
    FORMAT_CHANGE_DONE: null,
    FRAME_COLOR_CHANGE: null,
    AUDIO_CLIP_SET: null,
    AUDIO_CLIP_CLEAR: null,
    AUDIO_CLIP_VOLUME_SET: null,
    AUDIO_CLIP_TRIM: null,
    AUDIO_CLIP_SWITCH_LOOPING: null,
    ADD_PROJECT_COLOR: null,
    SET_TRANSITION: null,
    REMOVE_TRANSITIONS: null,
    REFRESH_CLIP_TIMES: null,
    ADD_BRAND_COLOR: null,
    CLIP_REPLACE: null,

    CLIP_UPDATE: null, // used for updating the videoData/id of multiple clips

    HIDE_WATERMARK: null,
    SHOW_WATERMARK: null,
    WATERMARK_DELETED: null,
    WATERMARK_REPLACED: null,
    DEFAULT_WATERMARK_ADDED: null,

    REFRESH_EDIT_TIMELINE: null,

    COMPOSITE_CLIP_UPDATE: null,

    COMPOSITE_CLIP_DURATION_UPDATE: null
});

var UserSpaceContentAdd = exports.UserSpaceContentAdd = (0, _keymirror2.default)({
    UNABLE_TO_ADD: null
});

var ClipActionType = exports.ClipActionType = (0, _keymirror2.default)({
    ADD_CLIP_END: null,
    ADD_CLIP_BEFORE: null,
    ADD_CLIP_AFTER: null,
    REPLACE_CLIP: null
});

var AudioTrimModalActionType = exports.AudioTrimModalActionType = {
    CLOSED: 'AUDIO_TRIM_MODAL_CLOSE',
    OPEN: 'AUDIO_TRIM_MODAL_OPEN'
};

function isMediaDeleted(media) {
    if (media.mediaType == _MediaConstants.SupportedReelClipTypes.image) {
        return !!media.imageData.deleted;
    }
    if (media.mediaType == _MediaConstants.SupportedReelClipTypes.video) {
        return !!media.videoData.deleted;
    }
    if (media.mediaType == 'audio') {
        return !!media.audioData.deleted;
    }
    return false;
}

/**
 *  This method updates the CLIP DATA with the new updated uploaded media metadata
 *  The metadata is responsible for identifying the media as a typito source....
 *  - Useful to update the clip which are using local media data . Can be intermediate or non intermediate
 *  - Useful to update multiple clips together ....
 *
 *
 * @export
 * @param {*} previousId
 * @param {*} mediaData
 * @return {*}
 */
function updateClipsMediaData(previousId, mediaData) {
    var clean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return function (dispatch, getState) {
        var state = getState();
        var _state$reel$clips = state.reel.clips,
            clips = _state$reel$clips === undefined ? [] : _state$reel$clips;

        var clipsToChange = {};
        for (var i = 0; i < clips.length; i++) {
            var clip = _extends({}, clips[i]);
            if (clip.clipType === _MediaConstants.SupportedReelClipTypes.video || clip.clipType === _MediaConstants.SupportedReelClipTypes.image) {
                var mediaType = clip.clipType;
                var item = clip.clipImage || clip.clipVideo;
                if (item.id == previousId) {
                    if (mediaType === _MediaConstants.SupportedReelClipTypes.video) {
                        if (clean) clip.clipVideo = _extends({}, mediaData);else clip.clipVideo = _extends({}, item, mediaData); // combines the data of previous offline data with current new online data

                        clip.clipVideoId = mediaData.id || clip.clipVideoId;
                    } else if (mediaType === _MediaConstants.SupportedReelClipTypes.image) {
                        if (clean) clip.clipImage = _extends({}, mediaData);else clip.clipImage = _extends({}, item, mediaData); // combines the data of previous offline data with current new online data

                        clip.clipImageId = mediaData.id || clip.clipImageId;
                    }
                    clipsToChange[clip.clipId] = clip;
                }
            }
        }
        dlog('clips to update :', clips, clipsToChange, mediaData);
        dispatch({ type: ReelActionType.CLIP_UPDATE, clips: clipsToChange });
    };
}

function multiDeleteClip() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var useBatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return function (dispatch, getState) {
        var firstClip = clips[0];
        var lastClip = clips[clips.length - 1];

        var _firstClip$time = firstClip.time,
            enterStart = _firstClip$time.enterStart,
            _firstClip$time$prevO = _firstClip$time.prevOffset,
            prevOffset = _firstClip$time$prevO === undefined ? 0 : _firstClip$time$prevO;
        var exitDone = lastClip.time.exitDone;

        var adjustment = enterStart - exitDone; // Negative duration
        var afterTime = exitDone + prevOffset;

        var batchOp = function batchOp() {
            dispatch(adjustTransitionsByRemove(firstClip.clipId, {
                adjustOverlayTimeline: false,
                refreshTimeline: false
            }));
            if (firstClip !== lastClip) dispatch(adjustTransitionsByRemove(lastClip.clipId, {
                adjustOverlayTimeline: false,
                refreshTimeline: false
            }));

            dispatch((0, _overlayActions.adjustOverlayTimeline)(afterTime, adjustment));
            dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });

            var compositeClips = clips.filter(function (clip) {
                return clip.clipType === _MediaConstants.SupportedReelClipTypes.composite;
            });
            var clipIdsForSequence = compositeClips.map(function (clip) {
                return clip.clipId;
            });
            if (clipIdsForSequence.length !== 0) {
                dispatch(createSequenceRemoveActionData({
                    clipIdsForSequence: clipIdsForSequence,
                    state: getState(),
                    clips: clips
                }));
            }
            dispatch({ type: ReelActionType.CLIP_DELETE, clip: clips });
        };

        if (useBatch) (0, _reactRedux.batch)(batchOp);else batchOp();
    };
}

function createSequenceRemoveActionData(_ref) {
    var clipIdsForSequence = _ref.clipIdsForSequence,
        state = _ref.state,
        clips = _ref.clips;

    var _getRemoveSequenceTem = (0, _overlayActions.getRemoveSequenceTemplatesData)(clipIdsForSequence, state),
        overlayToRemoveList = _getRemoveSequenceTem.overlayToRemoveList,
        sequenceOverlayMetaEntries = _getRemoveSequenceTem.sequenceOverlayMetaEntries;

    var overlayActionData = (0, _overlayActions.deleteOverlays)(overlayToRemoveList, sequenceOverlayMetaEntries);
    return {
        type: _sequenceActions.SequenceActionType.REMOVE_SEQUENCE_ENTITIES,
        overlayActionData: overlayActionData,
        clipActionData: { type: ReelActionType.CLIP_DELETE, clip: clips }
    };
}

function deleteClip(clip) {
    var useBatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return function (dispatch, getState) {
        var state = getState();
        var prevTime = state.player.time;

        dispatch(clickOutSideReelArea());

        if (Array.isArray(clip)) return dispatch(multiDeleteClip(clip, useBatch));

        var _clip$time = clip.time,
            enterStart = _clip$time.enterStart,
            exitDone = _clip$time.exitDone,
            _clip$time$prevOffset = _clip$time.prevOffset,
            prevOffset = _clip$time$prevOffset === undefined ? 0 : _clip$time$prevOffset;

        var adjustment = enterStart - exitDone; // Negative duration
        var afterTime = exitDone + prevOffset;

        var batchOp = function batchOp() {
            /// Handle stock media deletion

            dispatch(adjustTransitionsByRemove(clip.clipId, {
                adjustOverlayTimeline: false,
                refreshTimeline: true
            }));
            dispatch((0, _overlayActions.adjustOverlayTimeline)(afterTime, adjustment));
            if (clip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
                dispatch(createSequenceRemoveActionData({
                    clipIdsForSequence: clip.clipId,
                    clips: clip,
                    state: getState()
                }));
            } else {
                dispatch({ type: ReelActionType.CLIP_DELETE, clip: clip });
            }

            var newState = getState();
            var duration = newState.player.duration;

            var newCurrenTime = _CommonAlgorithms2.default.clamp(prevTime, duration, 0);
            dispatch((0, _playerActions.seek)(newCurrenTime));
            dispatch((0, _uiActions.snapScrollTimeToTimeline)(true));
            (0, _polyfill.localIdleCallback)(function () {
                return dispatch((0, _uiActions.snapScrollTimeToTimeline)(false));
            });
        };

        if (useBatch) (0, _reactRedux.batch)(batchOp);else batchOp();
    };
}

function cleanProject() {
    return function (dispatch, getState) {
        var _getState = getState(),
            overlays = _getState.overlays,
            _getState$reel$clips = _getState.reel.clips,
            clips = _getState$reel$clips === undefined ? [] : _getState$reel$clips,
            sequenceOverlays = _getState.overlaymeta.sequenceOverlays;

        (0, _reactRedux.batch)(function () {
            dispatch(clearAudio());
            // GUARD AGAINST WEIRD EMPTY PROJECTS
            if (clips.length === 1) dispatch(deleteClip(clips));
            var ovList = Object.values(overlays);

            // TODO -- remove this check during watermark refactor
            ovList = ovList.filter(function (ov) {
                return !ov.isWatermark;
            });

            // TODO -- account for Sequence Data here , send the sequence list as well
            dispatch((0, _overlayActions.deleteOverlays)(ovList, sequenceOverlays));
        });
    };
}

/**
 * Deletes the selected clip.
 * track the event on posthog
 *
 * @param {{from: string}} trackData
 */
function deleteCurrentClipWithWarning() {
    var trackData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch, getState) {
        dispatch((0, _deleteWarningActions.handleDeleteAction)(function () {
            var _getState2 = getState(),
                _getState2$reel$clips = _getState2.reel.clips,
                clips = _getState2$reel$clips === undefined ? [] : _getState2$reel$clips,
                time = _getState2.player.time;

            var clip = _getCurrentClip(clips, time);

            if (!clip || !clip.clipId) {
                throw new Error("Couldn't get a clip id to delete");
            }

            dispatch(deleteClip(clip));

            (0, _TrackUtils.trackOnPostHog)('Reel action', { actionType: 'delete' });
            (0, _TrackUtils.trackOnPostHog)('Media removed', _extends({ clipType: clip.clipType }, trackData));
        }));
    };
}

function isAnyClipSelected() {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return clips.some(function (c) {
        return c.isSelected;
    });
}

function selectClip() {
    var shouldCheckForSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var clipIdToSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (dispatch, getState) {
        var state = getState();
        var _state$reel$clips2 = state.reel.clips,
            clips = _state$reel$clips2 === undefined ? [] : _state$reel$clips2,
            time = state.player.time;

        var isEmptyProject = clips.length === 0;

        if (!isEmptyProject) {
            var shouldContinue = true;

            var someClipSelected = (0, _reelSelectors.getCurrentClipSelected)(state);

            if (shouldCheckForSelected) {
                shouldContinue = !!someClipSelected;
            }

            if (shouldContinue) {
                var clipId = clipIdToSelect || _getCurrentClip(clips, time).clipId;

                if (!clipId) {
                    throw new Error("Couldn't get a clip id to select");
                }

                if (someClipSelected && someClipSelected.clipId === clipId) return;

                (0, _reactRedux.batch)(function () {
                    // Remove overlay selection, if any
                    dispatch((0, _overlayActions.clickOutsideVideo)());

                    if (!someClipSelected) {
                        dispatch(modeActions.closeShelf());
                    }

                    dispatch([modeActions.closeAudioProperties(), modeActions.unselectWatermarkPreview(), modeActions.switchPropertiesPanel(_PropertiesPanelType2.default.OPTIONS), { type: ReelActionType.CLIP_SELECT, clipId: clipId }]);
                });
            }
        }
    };
}

function selectSequenceInnerClip() {
    var clipIdToSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        var state = getState();
        var _state$reel$clips3 = state.reel.clips,
            clips = _state$reel$clips3 === undefined ? [] : _state$reel$clips3;

        var isEmptyProject = clips.length === 0;

        if (!isEmptyProject) {
            var selectedClip = (0, _reelSelectors.getCurrentClipSelected)(state);

            if (!selectedClip || selectedClip.clipType !== 'composite') {
                throw new Error('No clip is selected');
            }

            var childClips = selectedClip.childClips;

            var innerClipIndex = childClips.find(function (c) {
                return c.clipId === clipIdToSelect;
            });

            if (innerClipIndex === -1) {
                throw new Error('Inner clip for given id is not present');
            }

            var reelDurationUntilSelectedClip = (0, _ReelHelpers.getDurationUntilClip)(clips, selectedClip.clipId);

            var reelDurationUntilInnerClip = (0, _ReelHelpers.getDurationUntilClip)(childClips, clipIdToSelect);

            var newDuration = reelDurationUntilSelectedClip + reelDurationUntilInnerClip + 150;

            (0, _reactRedux.batch)(function () {
                dispatch((0, _playerActions.seek)(newDuration));
                dispatch((0, _uiActions.snapScrollTimeToTimeline)(true));
            });
        }
    };
}

function unselectAllClips() {
    return { type: ReelActionType.CLIP_UNSELECT_ALL };
}

// adds clip to the reel
/**
 * Costly method for adding single clips
 * DO NOT USE IF U INTENT TO LOOP
 * PADD IN A ARRAY OF CLIPS INSTEAD
 * OR BETTER USE minimalClipAdd and adjust ur own overlayTiming
 *
 * @export
 * @param {*} clip
 * @return {*}
 */
function addClip(clip) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$adjustTransitio = _ref2.adjustTransition,
        adjustTransition = _ref2$adjustTransitio === undefined ? false : _ref2$adjustTransitio;

    return function (dispatch) {
        return dispatch((0, _notificationSystemAction.notificationOnFirstClipAdd)(function (dispatch, getState) {
            (0, _reactRedux.batch)(function () {
                dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000));

                dispatch(unselectAllClips());

                var clips = Array.isArray(clip) ? clip : [clip];

                var _clips$0$time = clips[0].time,
                    enterStart = _clips$0$time.enterStart,
                    _clips$0$time$prevOff = _clips$0$time.prevOffset,
                    prevOffset = _clips$0$time$prevOff === undefined ? 0 : _clips$0$time$prevOff;
                var exitDone = clips[clips.length - 1].time.exitDone;

                var adjustment = exitDone - enterStart; // duration
                var afterTime = enterStart + prevOffset;

                dispatch((0, _overlayActions.adjustOverlayTimeline)(afterTime, adjustment));
                // NEW INTERACTION SYSTEM , CAN REMOVE

                dispatch({ type: ReelActionType.CLIP_ADD, clip: clip });
                if (adjustTransition) {
                    dispatch(adjustTransitionsByRemove(clip.clipId, {
                        adjustOverlayTimeline: true,
                        refreshTimeline: true
                    }));
                }

                // dispatch(modeActions._closeShelf(getState));
                dispatch(modeActions.closeAudioProperties());
                dispatch(modeActions.unselectWatermarkPreview());

                setTimelinePosition(clips[0], dispatch);

                (0, _polyfill.localIdleCallback)(function () {
                    (0, _reactRedux.batch)(function () {
                        dispatch((0, _guardActions.guardOverlayUpdates)(false));
                        dispatch((0, _uiActions.snapScrollTimeToTimeline)(false));
                    });
                });

                var _getState3 = getState(),
                    _getState3$reel = _getState3.reel,
                    oldCanvas = _getState3$reel.canvas,
                    frameType = _getState3$reel.frameType,
                    reelClips = _getState3$reel.clips,
                    viaFeature = _getState3.ui.viaFeature;

                var shouldFit = frameType === 'BEST-FIT';

                if (shouldFit) {
                    var newCanvas = getState().reel.canvas;

                    dispatch({ type: ReelActionType.FRAME_CHANGE, frameType: frameType });
                    dispatch((0, _overlayActions.doAdjustOverlays)(newCanvas, oldCanvas));
                }

                // switch to captions panel if user landed from captions landing page and this is the first media user has added.
                if (reelClips.length === 1 && viaFeature === 'captions') {
                    dispatch(modeActions.changeSidebarSection(_General.Sections.SUBTITLES.id));
                }
            });
        }));
    };
}

function minimalAddClip(clip) {
    var extraparam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _extends({ type: ReelActionType.CLIP_ADD, clip: clip }, extraparam);
}

function updatePlaceholderClipColorForInnerClip(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === undefined ? '#000000' : _ref3$color,
        _ref3$clipId = _ref3.clipId,
        clipId = _ref3$clipId === undefined ? null : _ref3$clipId,
        _ref3$sequenceInnerCl = _ref3.sequenceInnerClipId,
        sequenceInnerClipId = _ref3$sequenceInnerCl === undefined ? null : _ref3$sequenceInnerCl;

    return function (dispatch, getState) {
        var state = getState();
        var clipsObj = (0, _reelSelectors.getClipsObjects)(state);

        var selectedClip = clipsObj[clipId];
        if (!selectedClip || !selectedClip.childClips) return;

        var innerClip = selectedClip.childClips.find(function (c) {
            return c.clipId === sequenceInnerClipId;
        });
        if (innerClip && innerClip.clipImageId === (0, _ReelHelpers.getSolidImageId)()) {
            var shouldUpdate = true;
            var newChildClips = selectedClip.childClips.map(function (clip) {
                if (clip.clipId === sequenceInnerClipId) {
                    if (clip.solidImageColor === color) {
                        shouldUpdate = false;
                        return clip;
                    }
                    return _extends({}, clip, {
                        solidImageColor: color
                    });
                }
                return clip;
            });

            var newClip = _extends({}, selectedClip, {
                childClips: newChildClips
            });

            if (shouldUpdate) {
                dispatch({
                    type: ReelActionType.COMPOSITE_CLIP_UPDATE,
                    newClip: newClip,
                    oldClip: selectedClip
                });
            }
        }
    };
}

function updatePlaceholderClipColor() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000000';
    var clipId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var sequenceInnerClipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch, getState) {
        var _getState4 = getState(),
            reel = _getState4.reel,
            player = _getState4.player;

        if (sequenceInnerClipId) {
            return dispatch(updatePlaceholderClipColorForInnerClip({
                clipId: clipId,
                color: color,
                sequenceInnerClipId: sequenceInnerClipId
            }));
        }

        var selectedClip = reel.clips.find(function (clip) {
            return clip.clipId == clipId;
        });
        if (!!selectedClip && selectedClip.clipImageId === (0, _ReelHelpers.getSolidImageId)()) {
            var oldValue = selectedClip.solidImageColor;

            if (oldValue !== color) {
                selectedClip.solidImageColor = color;
                dispatch({
                    type: ReelActionType.CLIP_COLOR_UPDATE,
                    clip: selectedClip,
                    oldValue: oldValue,
                    newValue: color
                });
            }
        }
    };
}

function replaceClipWithSolidImage() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000000';
    var hidePadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var clipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch(unselectAllClips());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());

            var state = getState();

            var projectMedia = state.projectMedia,
                reel = state.reel,
                player = state.player,
                customFormats = state.customFormats,
                workspaceMedia = state.workspaceMedia;

            var selectedClip = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time, clipId);
            // console.log(selectedClip)
            if (!selectedClip) {
                selectedClip = reel.clips.find(function (c) {
                    return c.time.exitDone == player.time;
                });
                if (!selectedClip) {
                    throw new Error('Cannot find selected clip');
                }
            }

            var customFormat = customFormats.formats.find(function (i) {
                return i.id === reel.formatId;
            });
            var timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player);
            var replacingClips = [];
            var deletingClips = [];
            if (selectedClip.clipType == _MediaConstants.SupportedReelClipTypes.image || selectedClip.clipType == _MediaConstants.SupportedReelClipTypes.video || selectedClip.clipType == _MediaConstants.SupportedReelClipTypes.composite) {
                var replacingClip = (0, _ReelHelpers.replaceClipWithImage)(selectedClip, timeOffset);
                replacingClip = _extends({}, replacingClip, {
                    hidePadding: hidePadding,
                    solidImageColor: color,
                    clipBox: (0, _ReelHelpers.calcDefaultClipBox)(replacingClip, reel.frameType, reel.canvas, customFormat)
                });
                replacingClips.push(replacingClip);
            }

            deletingClips.push(selectedClip);
            var clipActionData = replaceClip(deletingClips, replacingClips);

            if (selectedClip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
                dispatch(createReplaceSequenceAction({
                    selectedClip: selectedClip,
                    clipActionData: clipActionData,
                    state: state
                }));
            } else {
                dispatch(clipActionData);
            }
        });
    };
}

function replaceSequenceInnerClipWithSolidImage(innerClipId, providedSequenceId) {
    var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#000000';
    var hidePadding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return function (dispatch, getState) {
        var _getState5 = getState(),
            reel = _getState5.reel,
            player = _getState5.player,
            customFormats = _getState5.customFormats;

        (0, _reactRedux.batch)(function () {
            dispatch(unselectAllClips());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());
        });

        var sequence = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time, providedSequenceId);
        if (!sequence) {
            console.log('Couldn\'t find selected sequence');
            return;
        }

        var selectedClip = sequence.childClips.find(function (c) {
            return c.clipId === innerClipId;
        });
        if (!selectedClip) throw new Error('Cannot find Sequence inner clip');

        var updatedClip = null;

        if (selectedClip.clipType == _MediaConstants.SupportedReelClipTypes.image || selectedClip.clipType == _MediaConstants.SupportedReelClipTypes.video) {
            updatedClip = _extends({}, selectedClip, {

                clipType: _MediaConstants.SupportedReelClipTypes.image,
                clipImageId: _SolidImage.SolidImageId,
                clipStart: 0,
                clipImage: _SolidImage.SolidImageData,

                clipVideo: null,
                clipVideoId: null
            });

            var customFormat = customFormats.formats.find(function (i) {
                return i.id === reel.formatId;
            });
            updatedClip = _extends({}, updatedClip, {
                hidePadding: hidePadding,
                solidImageColor: color,
                clipBox: (0, _ReelHelpers.calcDefaultClipBox)(updatedClip, reel.frameType, reel.canvas, customFormat),
                thumbUrl: asPlaceholder.thumbUrl
            });

            // OLD CODE
            // if (asPlaceholder) {
            //     updatedClip.clipAnimType = 'NONE';
            //     dispatch({
            //         type: UploadActionType.STOCK_MEDIA_PLACEHOLDER_ADDED,
            //         data: { clip: updatedClip, uploadObj: asPlaceholder },
            //     });
            // }
        }

        var updatedClipList = sequence.childClips.map(function (clip) {
            if (clip.clipId === updatedClip.clipId) return updatedClip;
            return clip;
        });
        // TODO -- use manual intervention to launch custom event
        // Since we need it to be one shot
        dispatch(addNewCompositeClip({
            clips: updatedClipList,
            sequenceId: sequence.clipId,
            sequenceName: sequence.name,
            actionType: ClipActionType.REPLACE_CLIP,
            retainOverlay: true
        }));
    };
}

function replaceSequenceInnerClipWithMedia(mediaId, providedSequenceId, innerClipId) {
    var _ref4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref4$clipBox = _ref4.clipBox,
        clipBox = _ref4$clipBox === undefined ? null : _ref4$clipBox,
        _ref4$animation = _ref4.animation,
        animation = _ref4$animation === undefined ? 'NONE' : _ref4$animation,
        _ref4$timeRange = _ref4.timeRange,
        timeRange = _ref4$timeRange === undefined ? {} : _ref4$timeRange;

    return function (dispatch, getState) {
        var _getState6 = getState(),
            projectMedia = _getState6.projectMedia,
            reel = _getState6.reel,
            player = _getState6.player,
            workspaceMedia = _getState6.workspaceMedia;

        (0, _reactRedux.batch)(function () {
            dispatch(unselectAllClips());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());
        });

        var selectedMedia = projectMedia.find(function (m) {
            return m.id === mediaId;
        });
        if (!selectedMedia) {
            selectedMedia = workspaceMedia.find(function (m) {
                return m.id === mediaId;
            });
            if (selectedMedia) {
                dispatch((0, _mediaActions.addMediaFromWorkspaceToProjectMedia)(selectedMedia));
            } else {
                throw new Error('Cannot find media to add');
            }
        }

        var sequence = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time, providedSequenceId);
        if (!sequence) {
            console.log('Couldn\'t find selected sequence');
            return;
        }

        var selectedClip = sequence.childClips.find(function (c) {
            return c.clipId === innerClipId;
        });
        if (!selectedClip) throw new Error('Cannot find Sequence inner clip');

        var updatedClip = createUpdatedClipFromExistingClip(selectedMedia, selectedClip, animation, timeRange, clipBox);

        // delete unneeded values from clip (for the placeholder)
        delete updatedClip.thumbUrl;
        delete updatedClip.ptitle;
        delete updatedClip.pheight;
        delete updatedClip.pwidth;
        delete updatedClip.ptype;
        delete updatedClip.pMediaId;
        delete updatedClip.pduration;
        delete updatedClip.placeHolderError;
        delete updatedClip.isPlaceholder;
        delete updatedClip.solidImageColor;
        delete updatedClip.hidePadding;
        delete updatedClip.isSelected;

        var updatedClipList = sequence.childClips.map(function (clip) {
            if (clip.clipId === updatedClip.clipId) return updatedClip;
            return clip;
        });

        dispatch(addNewCompositeClip({
            clips: updatedClipList,
            sequenceId: sequence.clipId,
            sequenceName: sequence.name,
            actionType: ClipActionType.REPLACE_CLIP,
            retainOverlay: true
        }));
        dispatch(modeActions.clearReplaceInsert());
    };
}

function createUpdatedClipFromExistingClip(selectedMedia, selectedClip, animation, timeRange, clipBox) {
    var updatedClip = null;
    if (selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.image) {
        updatedClip = _extends({}, selectedClip, {
            clipAnimType: animation,
            clipType: _MediaConstants.SupportedReelClipTypes.image,
            clipImageId: selectedMedia ? selectedMedia.id : _SolidImage.SolidImageId,
            clipStart: 0,
            clipImage: selectedMedia ? selectedMedia.imageData : _SolidImage.SolidImageData,

            clipVideo: null,
            clipVideoId: null
        });
    } else if (selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.video) {
        updatedClip = _extends({}, selectedClip, {

            clipType: _MediaConstants.SupportedReelClipTypes.video,
            clipVideoId: selectedMedia.id,
            clipStart: 0,
            clipVideo: selectedMedia.videoData,

            clipImageId: null,
            clipImage: null
        });

        var _ref5 = timeRange || {},
            _ref5$startTime = _ref5.startTime,
            startTime = _ref5$startTime === undefined ? 0 : _ref5$startTime,
            _ref5$duration = _ref5.duration,
            duration = _ref5$duration === undefined ? null : _ref5$duration;

        updatedClip.clipStart = Math.floor(startTime * 1000);

        if (!duration) {
            if (updatedClip.clipDuration > selectedMedia.videoData.duration - startTime) {
                duration = selectedMedia.videoData.duration - startTime;
            } else {
                duration = updatedClip.clipDuration;
            }
        }

        updatedClip.clipDuration = Math.floor(duration);

        updatedClip.speed = 1;
        var delta = updatedClip.time.exitDone - updatedClip.time.exitStart;
        updatedClip.time.exitStart = updatedClip.time.enterStart + updatedClip.clipDuration / updatedClip.speed;
        updatedClip.time.exitDone = updatedClip.time.exitStart + delta;
    }

    // Enter start is edited here itself , since this is now one of the clip being used
    // for creatinga new Sequence Instance
    // the new sequence instance creation fixes any timeline defects
    if (clipBox) {
        updatedClip.clipBox = clipBox;
    }
    return updatedClip;
}

function replaceClipWithMedia(_ref6) {
    var mediaId = _ref6.mediaId,
        _ref6$providedClipId = _ref6.providedClipId,
        providedClipId = _ref6$providedClipId === undefined ? undefined : _ref6$providedClipId,
        _ref6$sequenceInnerCl = _ref6.sequenceInnerClipId,
        sequenceInnerClipId = _ref6$sequenceInnerCl === undefined ? null : _ref6$sequenceInnerCl,
        _ref6$clipBox = _ref6.clipBox,
        clipBox = _ref6$clipBox === undefined ? null : _ref6$clipBox,
        _ref6$timeRange = _ref6.timeRange,
        timeRange = _ref6$timeRange === undefined ? {} : _ref6$timeRange,
        _ref6$animation = _ref6.animation,
        animation = _ref6$animation === undefined ? _ReelHelpers.IMAGE_ANIMATIONS[0] : _ref6$animation;

    return function (dispatch, getState) {
        var replaceSequenceClipId = sequenceInnerClipId;
        if (!replaceSequenceClipId) replaceSequenceClipId = getState().ui.replaceSequenceClipId; // COOL HACK

        // Replace sequence inner clip
        if (replaceSequenceClipId != null) {
            // The clip inside a sequence need to be replaced
            return dispatch(replaceSequenceInnerClipWithMedia(mediaId, providedClipId, replaceSequenceClipId, {
                clipBox: clipBox,
                timeRange: timeRange,
                animation: animation
            }));
        }

        (0, _reactRedux.batch)(function () {
            dispatch(unselectAllClips());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());

            var state = getState();

            var projectMedia = state.projectMedia,
                reel = state.reel,
                player = state.player,
                customFormats = state.customFormats,
                workspaceMedia = state.workspaceMedia;

            // Find media to replace with

            var selectedMedia = projectMedia.find(function (m) {
                return m.id === mediaId;
            });
            if (!selectedMedia) {
                selectedMedia = workspaceMedia.find(function (m) {
                    return m.id === mediaId;
                });
                if (selectedMedia) {
                    dispatch((0, _mediaActions.addMediaFromWorkspaceToProjectMedia)(selectedMedia));
                } else {
                    throw new Error('Cannot find media to add');
                }
            }

            // Find clip to be replaced
            var selectedClip = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time, providedClipId);
            if (!selectedClip && selectedClip.clipId != providedClipId) {
                throw new Error('Cannot find selected clip');
            }

            var customFormat = customFormats.formats.find(function (i) {
                return i.id === reel.formatId;
            });
            var timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player);
            var replacingClips = [];
            var deletingClips = [];

            if (selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.image) {
                var replacingClip = (0, _ReelHelpers.replaceClipWithImage)(selectedClip, timeOffset, selectedMedia, animation);
                if (!clipBox) {
                    clipBox = (0, _ReelHelpers.calcDefaultClipBox)(replacingClip, reel.frameType, reel.canvas, customFormat);
                }
                replacingClip = _extends({}, replacingClip, { clipBox: clipBox });
                replacingClips.push(replacingClip);
            } else if (selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.video) {
                var _replacingClip = (0, _ReelHelpers.replaceClipWithVideo)(selectedClip, timeOffset, selectedMedia, timeRange);
                if (!clipBox) {
                    clipBox = (0, _ReelHelpers.calcDefaultClipBox)(_replacingClip, reel.frameType, reel.canvas, customFormat);
                }
                _replacingClip = _extends({}, _replacingClip, { clipBox: clipBox });
                replacingClips.push(_replacingClip);
                if (selectedMedia.videoData.duration < selectedClip.clipDuration) {
                    var solidClipDuration = selectedClip.clipDuration - selectedMedia.videoData.duration;
                    var _clip = (0, _ReelHelpers.createNewSolidImageClip)('#000000', solidClipDuration, true, _replacingClip.time.exitDone, timeOffset, false, selectedClip.speed);
                    _clip = _extends({}, _clip, {
                        clipBox: {
                            x: 0,
                            y: 0,
                            sar: 1,
                            width: reel.canvas.width,
                            height: reel.canvas.height
                        }
                    });
                    replacingClips.push(_clip);
                }
            }

            deletingClips.push(selectedClip);
            var clipActionData = replaceClip(deletingClips, replacingClips);

            if (selectedClip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
                dispatch(createReplaceSequenceAction({
                    selectedClip: selectedClip,
                    clipActionData: clipActionData,
                    state: state
                }));
            } else {
                dispatch(clipActionData);
            }

            (0, _polyfill.localIdleCallback)(function () {
                try {
                    var replaceClipType = _logActions.mediaTypes.VIDEO;
                    if (selectedClip.clipImage) replaceClipType = _logActions.mediaTypes.IMAGE;else if (selectedClip.clipType === _MediaConstants.SupportedReelClipTypes.composite) replaceClipType = _MediaConstants.SupportedReelClipTypes.composite;

                    var mediaReplacementType = _logActions.mediaReplacementTypes.LEFT_PANEL;
                    if (window.mediaReplacementType) mediaReplacementType = window.mediaReplacementType;

                    window.mediaReplacementType = null;

                    // track data
                    if (!selectedClip.isPlaceholder) dispatch((0, _logActions.mediaReplaced)(replaceClipType, selectedMedia.mediaType, mediaReplacementType));
                } catch (err) {
                    console.log('Error logging data : ' + err);
                }
            });

            var clip = replacingClips[0];
            if (clip) {
                setTimelinePosition(clip, dispatch);
            }
        });
    };
}

function addNewSolidImageClip(clipId) {
    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000000';
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4000;
    var hidePadding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var actionType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ClipActionType.ADD_CLIP_END;
    var asPlaceholder = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    return function (dispatch, getState) {
        if (asPlaceholder === null) {
            dispatch(modeActions.closeShelf());
        }

        dispatch(unselectAllClips());

        var _getState7 = getState(),
            projectMedia = _getState7.projectMedia,
            reel = _getState7.reel,
            player = _getState7.player,
            customFormats = _getState7.customFormats,
            workspaceMedia = _getState7.workspaceMedia;

        var enterTime = null;
        var timeOffset = null;
        var clipTransition = null;
        var rightClipId = null;
        var leftClipId = null;
        var adjustTransition = _TransitionType2.default.NONE;

        if (!!clipId && actionType !== ClipActionType.ADD_CLIP_END) {
            var _getAdjacentClipIds = (0, _ReelHelpers.getAdjacentClipIds)(reel.clips, clipId);

            rightClipId = _getAdjacentClipIds.rightClipId;
            leftClipId = _getAdjacentClipIds.leftClipId;
        }

        if (actionType === ClipActionType.ADD_CLIP_END) {
            enterTime = (0, _ReelHelpers.getReelLastExitDone)(reel.clips);
            timeOffset = (0, _ReelHelpers.getTotalTimeOffset)(reel.clips);
        } else if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
            enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(reel.clips, player, clipId);
            timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player, clipId);

            clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, leftClipId, clipId);
        } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
            enterTime = (0, _ReelHelpers.getReelLastExitDoneAfterSelectedClip)(reel.clips, player, clipId);
            timeOffset = (0, _ReelHelpers.getTotalTimeOffsetAfterSelectedClip)(reel.clips, player, clipId);

            clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, clipId, rightClipId);
        }

        var clip = (0, _ReelHelpers.createNewSolidImageClip)(color, duration, hidePadding, enterTime, timeOffset, false, 1, asPlaceholder);

        clip = _extends({}, clip, {
            clipBox: { x: 0, y: 0, sar: 1, width: reel.canvas.width, height: reel.canvas.height }
        });

        // clip.isSelected = true;

        if (asPlaceholder) {
            dispatch({
                type: UploadActionType.STOCK_MEDIA_PLACEHOLDER_ADDED,
                data: { clip: clip, uploadObj: asPlaceholder }
            });
        }

        dispatch(addClip(clip));

        try {
            if (!asPlaceholder && actionType === ClipActionType.ADD_CLIP_AFTER || actionType === ClipActionType.ADD_CLIP_BEFORE) dispatch((0, _logActions.mediaInserted)(_logActions.mediaTypes.PLACEHOLDER));
        } catch (err) {
            console.log('Error logging ' + err);
        }

        if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
            // set the transition between old left clip and new clip to None
            // set the transition between new clip and selected clip to current transition

            dispatch(setTransition(clipTransition, clip.clipId, clipId));
            dispatch(setTransition(adjustTransition, leftClipId, clip.clipId));
        } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
            // set the transition between old right clip and new clip to None
            // set the transition between new clip and selected clip to current transition

            dispatch(setTransition(clipTransition, clipId, clip.clipId));
            dispatch(setTransition(adjustTransition, clip.clipId, rightClipId));
        }

        if (window.startTrackingModeTimes) {
            var _getState8 = getState(),
                currentMode = _getState8.mode.currentMode;

            var isOverlayMode = currentMode === _EditorMode2.default.OVERLAY;
            window.startTrackingModeTimes(isOverlayMode);
        }
    };
}

function updateProjectMedia() {
    var projectMedia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return function (dispatch, getState) {
        if (projectMedia.length > 0) {
            var newData = projectMedia.map(function (pm) {
                var source = pm.source,
                    sourceId = pm.sourceId;

                var newitem = {};
                newitem.source = source;
                newitem.sourceId = sourceId;

                switch (pm.mediaType) {
                    case _MediaConstants.SupportedReelClipTypes.video:
                        {
                            newitem.id = pm.videoData.id;
                            newitem.videoData = pm.videoData;
                            newitem.mediaType = _MediaConstants.SupportedReelClipTypes.video;
                            return newitem;
                        }
                    case _MediaConstants.SupportedReelClipTypes.image:
                        {
                            newitem.id = pm.imageData.id;
                            newitem.imageData = pm.imageData;
                            newitem.mediaType = _MediaConstants.SupportedReelClipTypes.image;
                            return newitem;
                        }
                    case 'audio':
                        {
                            newitem.id = pm.audioData.id;
                            newitem.audioData = pm.audioData;
                            newitem.mediaType = 'audio';
                            return newitem;
                        }
                    default:
                        {}
                }
            });

            dispatch({ type: _mediaActions.MediaActionType.ADD_MULTIPLE_MEDIA, data: newData });
        }
    };
}

/**
 * Replaces multiple clips with a sequence , useful for resequencing operation
 * - Apply to timeline
 * - Merge clips back again with its corresponding sequence
 *
 *
 * @export
 * @param {*} [clips=[]]
 * @param {*} sequenceId
 * @param {*} [removeClipIds=[]]
 * @param {*} [callback=() => {}]
 * @return {*}
 */
function replaceMultiClipWithSequence(_ref7) {
    var _ref7$clips = _ref7.clips,
        clips = _ref7$clips === undefined ? [] : _ref7$clips,
        sequenceId = _ref7.sequenceId,
        _ref7$sequenceName = _ref7.sequenceName,
        sequenceName = _ref7$sequenceName === undefined ? '' : _ref7$sequenceName,
        _ref7$removeClipIds = _ref7.removeClipIds,
        removeClipIds = _ref7$removeClipIds === undefined ? [] : _ref7$removeClipIds,
        _ref7$getOverlayActio = _ref7.getOverlayActionData,
        getOverlayActionData = _ref7$getOverlayActio === undefined ? function () {} : _ref7$getOverlayActio;

    return function (dispatch, getState) {
        if (clips.length === 0 || removeClipIds.length === 0) {
            throw new Error('No clips for composite clip or no clips for replacement');
        }

        var state = getState();
        var reel = state.reel,
            player = state.player,
            customFormats = state.customFormats;

        // const clipsObject = getClipsObjects(state)

        var selectedClips = reel.clips.filter(function (clip) {
            return removeClipIds.includes(clip.clipId);
        });

        var firstClip = selectedClips[0];

        var enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(reel.clips, player, firstClip.clipId);
        var timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player, firstClip.clipId);

        var compositeClip = (0, _ReelHelpers.createNewCompositeClip)(clips, enterTime, timeOffset, sequenceId, sequenceName);

        var customFormat = customFormats.formats.find(function (i) {
            return i.id === reel.formatId;
        });

        compositeClip = _extends({}, compositeClip, {
            clipBox: (0, _ReelHelpers.calcDefaultClipBox)(compositeClip, reel.frameType, reel.canvas, customFormat)
        });

        var compositeClipActionData = replaceClip(selectedClips, [compositeClip]);
        // delete the composite clip stuff
        /// TODO MUlti delete overlays from the selected clips if they are sequences
        var compositeClips = selectedClips.filter(function (clip) {
            return clip.clipType === _MediaConstants.SupportedReelClipTypes.composite;
        });
        if (compositeClips.length !== 0) {
            var compositeIds = compositeClips.map(function (clip) {
                return clip.clipId;
            });

            var _getRemoveSequenceTem2 = (0, _overlayActions.getRemoveSequenceTemplatesData)(compositeIds, state),
                overlayToRemoveList = _getRemoveSequenceTem2.overlayToRemoveList,
                sequenceOverlayMetaEntries = _getRemoveSequenceTem2.sequenceOverlayMetaEntries;

            // can be deepmerged with removal list and then given as replaceoverlay action
            // const removeOverlayAction = deleteOverlays(overlayToRemoveList , sequenceOverlayMetaEntries)

            var _getOverlayActionData = getOverlayActionData(compositeClip),
                overlayToAdd = _getOverlayActionData.overlayToAdd,
                overlayToDelete = _getOverlayActionData.overlayToDelete;

            var replaceOverlayAction = {
                overlayActionData: (0, _overlayActions.deleteOverlays)((0, _deepmerge2.default)(overlayToDelete.overlays, overlayToRemoveList), (0, _deepmerge2.default)(overlayToDelete.sequenceOverlayMetaEntries, sequenceOverlayMetaEntries))
            };

            dispatch({
                type: _sequenceActions.SequenceActionType.ADD_SEQUENCE_ENTITIES,
                compositeClipActionData: compositeClipActionData,
                overlayActionData: overlayToAdd,
                replaceOverlayAction: replaceOverlayAction
            });
        } else {
            var _getOverlayActionData2 = getOverlayActionData(compositeClip),
                _overlayToAdd = _getOverlayActionData2.overlayToAdd,
                _overlayToDelete = _getOverlayActionData2.overlayToDelete;

            var _replaceOverlayAction = {
                overlayActionData: _overlayToDelete
            };

            dispatch({
                type: _sequenceActions.SequenceActionType.ADD_SEQUENCE_ENTITIES,
                compositeClipActionData: compositeClipActionData,
                overlayActionData: _overlayToAdd,
                replaceOverlayAction: _replaceOverlayAction
            });
        }
    };
}

/**
 * Creates multiple clip addition data and functions required
 * for adding content to timeline
 *
 * @param {*} {
 *     sequenceClipArgs = [],
 *     actionType = ClipActionType.ADD_CLIP_END,
 *     insertClipId = null,
 *     state
 * }
 * @return {*}
 */
function createDataForAddMultipleNewCompositeClip() {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref8$sequenceClipArg = _ref8.sequenceClipArgs,
        sequenceClipArgs = _ref8$sequenceClipArg === undefined ? [] : _ref8$sequenceClipArg,
        _ref8$actionType = _ref8.actionType,
        actionType = _ref8$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref8$actionType,
        _ref8$insertClipId = _ref8.insertClipId,
        insertClipId = _ref8$insertClipId === undefined ? null : _ref8$insertClipId,
        state = _ref8.state,
        dispatch = _ref8.dispatch;

    var _state$reel = state.reel,
        _state$reel$clips4 = _state$reel.clips,
        clips = _state$reel$clips4 === undefined ? [] : _state$reel$clips4,
        formatId = _state$reel.formatId,
        frameType = _state$reel.frameType,
        _state$reel$canvas = _state$reel.canvas,
        canvas = _state$reel$canvas === undefined ? {} : _state$reel$canvas,
        player = state.player,
        customFormats = state.customFormats;

    var isEmptyProject = clips.length === 0;

    var selectedClip = null;

    if (insertClipId) {
        selectedClip = (0, _reelSelectors.getClipsObjects)(state)[insertClipId];
    } else {
        selectedClip = (0, _ReelHelpers.getSelectedClip)(clips, player.time);
    }

    if (!selectedClip) {
        if (isEmptyProject) {
            selectedClip = {};
        } else {
            throw new Error('No clip selected to add to.');
        }
    }

    var _selectedClip = selectedClip,
        clipId = _selectedClip.clipId;

    var sequenceClips = [];
    var enterTime = null;
    var timeOffset = null;
    var rightClipId = null;
    var leftClipId = null;
    var clipTransition = void 0;
    var clipTransitionLeft = void 0;
    var clipTransitionRight = void 0;
    var adjustTransition = _TransitionType2.default.NONE;

    if (!!clipId && actionType !== ClipActionType.ADD_CLIP_END) {
        var _getAdjacentClipIds2 = (0, _ReelHelpers.getAdjacentClipIds)(clips, clipId);

        rightClipId = _getAdjacentClipIds2.rightClipId;
        leftClipId = _getAdjacentClipIds2.leftClipId;
    }

    if (actionType === ClipActionType.ADD_CLIP_END) {
        enterTime = (0, _ReelHelpers.getReelLastExitDone)(clips);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffset)(clips);
    } else if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(clips, player, insertClipId);

        clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(clips, leftClipId, clipId);
    } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneAfterSelectedClip)(clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetAfterSelectedClip)(clips, player, insertClipId);
        clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(clips, clipId, rightClipId);
    } else if (actionType === ClipActionType.REPLACE_CLIP) {
        // add before the clip and then delete the selected clip
        enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(clips, player, insertClipId);
        if (leftClipId) clipTransitionLeft = (0, _ReelHelpers.getTransitionBetweenClips)(clips, leftClipId, insertClipId); // left side transition
        if (rightClipId) clipTransitionRight = (0, _ReelHelpers.getTransitionBetweenClips)(clips, insertClipId, rightClipId); //  right side transition
    }

    var customFormat = customFormats.formats.find(function (i) {
        return i.id === formatId;
    });

    var firstClip = (0, _ReelHelpers.createNewCompositeClip)(sequenceClipArgs[0].clips, enterTime, timeOffset, sequenceClipArgs[0].sequenceId, sequenceClipArgs[0].sequenceName);

    // TO-DO change clips cannvas
    firstClip = _extends({}, firstClip, {
        clipBox: (0, _ReelHelpers.calcDefaultClipBox)(firstClip, frameType, canvas, customFormat)
    }); // updates the composite clip not children

    /// / CHNAGE THE FORMAT HERE ,
    firstClip.childClips = firstClip.childClips.map(function (cc) {
        var _cc$clipBox = cc.clipBox,
            _cc$clipBox$isRotateM = _cc$clipBox.isRotateManual,
            isRotateManual = _cc$clipBox$isRotateM === undefined ? true : _cc$clipBox$isRotateM,
            _cc$clipBox$rotateDeg = _cc$clipBox.rotateDeg,
            rotateDeg = _cc$clipBox$rotateDeg === undefined ? 0 : _cc$clipBox$rotateDeg;

        var clipBox = (0, _ReelHelpers.calcRotatedClipBox)(rotateDeg, cc, frameType, canvas, customFormat);
        return _extends({}, cc, {
            clipBox: _extends({}, clipBox, {
                isRotateManual: isRotateManual,
                rotateDeg: rotateDeg
            })
        });
    });

    sequenceClips = sequenceClipArgs.splice(1).reduce(function (prevClips, seqClip) {
        var currentClipsEnterTime = prevClips[prevClips.length - 1].time.exitDone;
        var currentClipsPrevOffset = timeOffset;
        var clip = (0, _ReelHelpers.createNewCompositeClip)(seqClip.clips, currentClipsEnterTime, currentClipsPrevOffset, seqClip.sequenceId, seqClip.sequenceName);

        // TO-DO change clips cannvas
        clip = _extends({}, clip, { clipBox: (0, _ReelHelpers.calcDefaultClipBox)(clip, frameType, canvas, customFormat) }); // updates the composite clip not children

        /// / CHNAGE THE FORMAT HERE ,
        clip.childClips = clip.childClips.map(function (cc) {
            var _cc$clipBox2 = cc.clipBox,
                _cc$clipBox2$isRotate = _cc$clipBox2.isRotateManual,
                isRotateManual = _cc$clipBox2$isRotate === undefined ? true : _cc$clipBox2$isRotate,
                _cc$clipBox2$rotateDe = _cc$clipBox2.rotateDeg,
                rotateDeg = _cc$clipBox2$rotateDe === undefined ? 0 : _cc$clipBox2$rotateDe;

            var clipBox = (0, _ReelHelpers.calcRotatedClipBox)(rotateDeg, cc, frameType, canvas, customFormat);
            return _extends({}, cc, {
                clipBox: _extends({}, clipBox, {
                    isRotateManual: isRotateManual,
                    rotateDeg: rotateDeg
                })
            });
        });
        prevClips.push(clip);
        return prevClips;
    }, [firstClip]);

    // sequenceClips[sequenceClipLen - 1].isSelected = true;

    var batchOp = function batchOp() {
        dispatch(unselectAllClips());

        if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
            // set the transition between old left clip and new clip to None
            // set the transition between new clip and selected clip to current transition
            var _firstClip = sequenceClips[0];
            var lastClip = sequenceClips[sequenceClips.length - 1];
            dispatch(setTransition(clipTransition, lastClip.clipId, clipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
            if (leftClipId) {
                dispatch(setTransition(adjustTransition, leftClipId, _firstClip.clipId, {
                    adjustOverlayTime: false,
                    refreshClipTimes: false
                }));
            }
        } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
            // set the transition between old right clip and new clip to None
            // set the transition between new clip and selected clip to current transition
            var _firstClip2 = sequenceClips[0];
            var _lastClip = sequenceClips[sequenceClips.length - 1];
            dispatch(setTransition(clipTransition, clipId, _firstClip2.clipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
            if (rightClipId) {
                dispatch(setTransition(adjustTransition, _lastClip.clipId, rightClipId, {
                    adjustOverlayTime: false,
                    refreshClipTimes: false
                }));
            }
        } else if (actionType === ClipActionType.REPLACE_CLIP) {
            // currently setting to NONE
            var _firstClip3 = sequenceClips[0];
            var _lastClip2 = sequenceClips[sequenceClips.length - 1];
            if (leftClipId) dispatch(setTransition(adjustTransition, leftClipId, _firstClip3.clipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
            if (rightClipId) dispatch(setTransition(adjustTransition, _lastClip2.clipId, rightClipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
        }

        // const { enterStart, prevOffset = 0 } = sequenceClips[0].time;
        // const { exitDone } = sequenceClips[sequenceClips.length - 1].time;

        // const adjustment = exitDone - enterStart; //duration
        // const afterTime = enterStart + prevOffset;

        // DONT KNOW ITS EFFECT
        // dispatch(adjustOverlayTimeline(afterTime, adjustment))

        dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });
    };

    return {
        selectedClip: selectedClip,
        sequenceClips: sequenceClips,
        adjustmentOp: batchOp
    };
}

function setupAddMultipleNewCompositeClip(_ref9) {
    var sequenceClips = _ref9.sequenceClips,
        selectedClip = _ref9.selectedClip,
        _ref9$actionType = _ref9.actionType,
        actionType = _ref9$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref9$actionType,
        _ref9$addStepCallback = _ref9.addStepCallback,
        addStepCallback = _ref9$addStepCallback === undefined ? function () {} : _ref9$addStepCallback,
        _ref9$useBatch = _ref9.useBatch,
        useBatch = _ref9$useBatch === undefined ? true : _ref9$useBatch,
        batchOp = _ref9.batchOp,
        state = _ref9.state;

    var clipActionData = void 0;

    var replaceOverlayAction = {
        overlayActionData: null
    };
    var nbatchOp = function nbatchOp() {
        if (ClipActionType.REPLACE_CLIP === actionType) {
            if (selectedClip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
                var _getRemoveSequenceTem3 = (0, _overlayActions.getRemoveSequenceTemplatesData)(selectedClip.clipId, state),
                    overlayToRemoveList = _getRemoveSequenceTem3.overlayToRemoveList,
                    sequenceOverlayMetaEntries = _getRemoveSequenceTem3.sequenceOverlayMetaEntries;

                replaceOverlayAction.overlayActionData = (0, _overlayActions.deleteOverlays)(overlayToRemoveList, sequenceOverlayMetaEntries);
            }
            clipActionData = replaceClip([selectedClip], sequenceClips);
        } else {
            clipActionData = minimalAddClip(sequenceClips);
        }

        addStepCallback(clipActionData, replaceOverlayAction);
    };

    // USE BATCH if provided
    if (useBatch) (0, _reactRedux.batch)(nbatchOp);else nbatchOp();

    if (useBatch) (0, _reactRedux.batch)(batchOp);else batchOp();
}

/**
 *
 * Used for Multiple Composite clip additions in one single Go
 *
 * has customisable params of
 * useBatch for using batching
 * maxSequenceProcess used for controlling how many innerclips should be
 * added in one go, ideal assumption for best performance every sequence => one clip
 * above assumption will never happen so customize the value based on
 * how many total clips do u want to allow
 *
 * clips = sum (  sequence.chilipClips[0 : batch_size] )
 *
 *
 *  Usage alert , when using Replace as an action
 * - If u provide overlay action it will launch a sequence add to add ur overlay data
 * - if getOverlayActionData is ommited then it becomes a sequence replace
 *
 *
 *
 * @export
 * @param {*}
 * @param {*}     [sequenceClipArgs = []]
 * @param {*}     [actionType = ClipActionType.ADD_CLIP_END]
 * @param {*}     [insertClipId = null]
 * @param {*}     [retainOverlay = false]
 * @param {*}     [callback = () => {}]
 * @param {*}     [useBatch = true]
 * @param {*}     [maxSequenceProcess = 10]
 *
 * @return {*}
 */
function addMultipleNewCompositeClip(_ref10) {
    var _ref10$sequenceClipAr = _ref10.sequenceClipArgs,
        sequenceClipArgs = _ref10$sequenceClipAr === undefined ? [] : _ref10$sequenceClipAr,
        _ref10$actionType = _ref10.actionType,
        actionType = _ref10$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref10$actionType,
        _ref10$insertClipId = _ref10.insertClipId,
        insertClipId = _ref10$insertClipId === undefined ? null : _ref10$insertClipId,
        _ref10$retainOverlay = _ref10.retainOverlay,
        retainOverlay = _ref10$retainOverlay === undefined ? false : _ref10$retainOverlay,
        _ref10$afterProcessin = _ref10.afterProcessing,
        afterProcessing = _ref10$afterProcessin === undefined ? function () {} : _ref10$afterProcessin,
        _ref10$useBatch = _ref10.useBatch,
        useBatch = _ref10$useBatch === undefined ? true : _ref10$useBatch,
        _ref10$getOverlayActi = _ref10.getOverlayActionData,
        getOverlayActionData = _ref10$getOverlayActi === undefined ? function () {
        return null;
    } : _ref10$getOverlayActi;

    return async function (dispatch, getState) {
        var sequenceClipLen = sequenceClipArgs.length;

        if (sequenceClipLen === 0) throw new Error('Empty Sequence list provided');

        var state = getState();

        var _createDataForAddMult = createDataForAddMultipleNewCompositeClip({
            sequenceClipArgs: sequenceClipArgs,
            actionType: actionType,
            insertClipId: insertClipId,
            state: state,
            dispatch: dispatch
        }),
            selectedClip = _createDataForAddMult.selectedClip,
            sequenceClips = _createDataForAddMult.sequenceClips,
            batchOp = _createDataForAddMult.adjustmentOp;

        setupAddMultipleNewCompositeClip({
            sequenceClips: sequenceClips,
            selectedClip: selectedClip,
            actionType: actionType,
            retainOverlay: retainOverlay,
            batchOp: batchOp,
            useBatch: useBatch,
            state: state,
            addStepCallback: function addStepCallback(clipActionData, replaceOverlayAction) {
                // Below means a sequence is getting replaced
                // Possibly a Inner Clip Replace , hence it's a InnerClip entity replace
                var overlayActionData = getOverlayActionData(sequenceClips);

                dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000));
                if (actionType === ClipActionType.REPLACE_CLIP && !overlayActionData && (replaceOverlayAction.overlayActionData || replaceOverlayAction.overlayMetaActionData)) {
                    dispatch(_extends({
                        type: _sequenceActions.SequenceActionType.REPLACE_SEQUENCE_ENTITIES
                    }, replaceOverlayAction, {
                        clipActionData: clipActionData
                    }));

                    dispatch((0, _guardActions.guardOverlayUpdates)(false));
                    return;
                }

                if (overlayActionData) {
                    dispatch({
                        type: _sequenceActions.SequenceActionType.ADD_SEQUENCE_ENTITIES,
                        compositeClipActionData: clipActionData,
                        overlayActionData: overlayActionData,
                        replaceOverlayAction: replaceOverlayAction
                    });
                } else {
                    dispatch(clipActionData);
                }

                setTimelinePosition(sequenceClips[0], dispatch);

                dispatch((0, _guardActions.guardOverlayUpdates)(false));

                afterProcessing(sequenceClips);
            }
        });
    };
}

/**
 *
 *
 * @export
 * @param {{{
 *     clips : Array<Object>,
 *     sequenceId: string,
 *     sequenceName : string,
 *     actionType : string,
 *     insertClipId : string,
 *     state : Object,
 * }}}
 * @return {*}
 */
function createCompositeClipFromState(_ref11) {
    var _ref11$clips = _ref11.clips,
        clips = _ref11$clips === undefined ? [] : _ref11$clips,
        sequenceId = _ref11.sequenceId,
        _ref11$sequenceName = _ref11.sequenceName,
        sequenceName = _ref11$sequenceName === undefined ? '' : _ref11$sequenceName,
        _ref11$actionType = _ref11.actionType,
        actionType = _ref11$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref11$actionType,
        _ref11$insertClipId = _ref11.insertClipId,
        insertClipId = _ref11$insertClipId === undefined ? null : _ref11$insertClipId,
        _ref11$avoidClipBoxRe = _ref11.avoidClipBoxRecalculation,
        avoidClipBoxRecalculation = _ref11$avoidClipBoxRe === undefined ? false : _ref11$avoidClipBoxRe,
        state = _ref11.state;

    if (clips.length === 0) {
        throw new Error('No Child Clips provided for creating');
    }
    var reel = state.reel,
        player = state.player,
        customFormats = state.customFormats;

    var isEmptyProject = reel.clips.length === 0;

    var userCreatedSequenceEntry = (0, _sequenceSelectors.getUserCreatedSequenceData)(state)[sequenceId];

    var selectedClip = null;
    if (insertClipId) {
        selectedClip = (0, _reelSelectors.getClipsObjects)(state)[insertClipId];
    } else {
        selectedClip = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time);
    }

    if (!selectedClip) {
        if (isEmptyProject) {
            selectedClip = {};
        } else {
            throw new Error('No clip selected to add to.');
        }
    }

    // dispatch(unselectAllClips());

    var _selectedClip2 = selectedClip,
        clipId = _selectedClip2.clipId;

    var clip = null;
    var enterTime = null;
    var timeOffset = null;
    var rightClipId = null;
    var leftClipId = null;
    var clipTransition = void 0;
    var clipTransitionLeft = void 0;
    var clipTransitionRight = void 0;
    var adjustTransition = _TransitionType2.default.NONE;

    if (!!clipId && actionType !== ClipActionType.ADD_CLIP_END) {
        var _getAdjacentClipIds3 = (0, _ReelHelpers.getAdjacentClipIds)(reel.clips, clipId);

        rightClipId = _getAdjacentClipIds3.rightClipId;
        leftClipId = _getAdjacentClipIds3.leftClipId;
    }

    if (actionType === ClipActionType.ADD_CLIP_END) {
        enterTime = (0, _ReelHelpers.getReelLastExitDone)(reel.clips);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffset)(reel.clips);
    } else if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(reel.clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player, insertClipId);
        clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, leftClipId, clipId);
    } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneAfterSelectedClip)(reel.clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetAfterSelectedClip)(reel.clips, player, insertClipId);
        clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, clipId, rightClipId);
    } else if (actionType === ClipActionType.REPLACE_CLIP) {
        // add before the clip and then delete the selected clip
        enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(reel.clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player, insertClipId);
        if (leftClipId) clipTransitionLeft = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, leftClipId, insertClipId); // left side transition
        if (rightClipId) clipTransitionRight = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, insertClipId, rightClipId); //  right side transition
    }

    clip = (0, _ReelHelpers.createNewCompositeClip)(clips, enterTime, timeOffset, sequenceId, sequenceName);

    var customFormat = customFormats.formats.find(function (i) {
        return i.id === reel.formatId;
    });

    // TO-DO change clips cannvas
    clip = _extends({}, clip, {
        clipBox: (0, _ReelHelpers.calcDefaultClipBox)(clip, reel.frameType, reel.canvas, customFormat)
    }); // updates the composite clip not children

    var shouldChangeFormat = true;
    if (userCreatedSequenceEntry) {
        var _userCreatedSequenceE = userCreatedSequenceEntry.sequenceData;
        _userCreatedSequenceE = _userCreatedSequenceE === undefined ? {} : _userCreatedSequenceE;
        var canvas = _userCreatedSequenceE.canvas;

        if ((0, _underscore.isEqual)(state.reel.canvas, canvas)) shouldChangeFormat = false;
    }

    if (shouldChangeFormat && !avoidClipBoxRecalculation) {
        clip.childClips = clip.childClips.map(function (cc) {
            var _cc$clipBox3 = cc.clipBox,
                _cc$clipBox3$isRotate = _cc$clipBox3.isRotateManual,
                isRotateManual = _cc$clipBox3$isRotate === undefined ? true : _cc$clipBox3$isRotate,
                _cc$clipBox3$rotateDe = _cc$clipBox3.rotateDeg,
                rotateDeg = _cc$clipBox3$rotateDe === undefined ? 0 : _cc$clipBox3$rotateDe;

            var clipBox = (0, _ReelHelpers.calcRotatedClipBox)(rotateDeg, cc, reel.frameType, reel.canvas, customFormat);
            return _extends({}, cc, {
                clipBox: _extends({}, clipBox, {
                    isRotateManual: isRotateManual,
                    rotateDeg: rotateDeg
                })
            });
        });
    }
    /// / CHNAGE THE FORMAT HERE ,

    // Selected when adding
    // clip.isSelected = true;

    return {
        clip: clip,
        clipTransition: clipTransition,
        clipTransitionLeft: clipTransitionLeft,
        clipTransitionRight: clipTransitionRight,
        adjustTransition: adjustTransition,
        selectedClip: selectedClip,
        rightClipId: rightClipId,
        leftClipId: leftClipId
    };
}

function reverseCompositeClipAdd(compositeClipActionData) {
    var type = compositeClipActionData.type;

    if (type === ReelActionType.CLIP_REPLACE) {
        var replacingClips = compositeClipActionData.replacingClips,
            deletingClips = compositeClipActionData.deletingClips;

        return {
            type: ReelActionType.CLIP_REPLACE,
            deletingClips: replacingClips,
            replacingClips: deletingClips
        };
    }

    return {
        type: ReelActionType.CLIP_DELETE,
        clip: compositeClipActionData.clip
    };
}

function createReplaceSequenceAction(_ref12) {
    var selectedClip = _ref12.selectedClip,
        state = _ref12.state,
        clipActionData = _ref12.clipActionData;

    var replaceOverlayAction = {
        overlayActionData: null,
        overlayMetaActionData: null
    };

    var _getRemoveSequenceTem4 = (0, _overlayActions.getRemoveSequenceTemplatesData)(selectedClip.clipId, state),
        overlayToRemoveList = _getRemoveSequenceTem4.overlayToRemoveList,
        sequenceOverlayMetaEntries = _getRemoveSequenceTem4.sequenceOverlayMetaEntries;

    replaceOverlayAction.overlayActionData = (0, _overlayActions.deleteOverlays)(overlayToRemoveList, sequenceOverlayMetaEntries);

    return _extends({
        type: _sequenceActions.SequenceActionType.REPLACE_SEQUENCE_ENTITIES
    }, replaceOverlayAction, {
        clipActionData: clipActionData
    });
}

function setupAddNewCompositeClipWithClipData(_ref13) {
    var _ref13$clipAdditionDa = _ref13.clipAdditionData,
        clipAdditionData = _ref13$clipAdditionDa === undefined ? {} : _ref13$clipAdditionDa,
        dispatch = _ref13.dispatch,
        state = _ref13.state,
        _ref13$actionType = _ref13.actionType,
        actionType = _ref13$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref13$actionType,
        _ref13$retainOverlay = _ref13.retainOverlay,
        retainOverlay = _ref13$retainOverlay === undefined ? false : _ref13$retainOverlay,
        _ref13$addStepCallbac = _ref13.addStepCallback,
        addStepCallback = _ref13$addStepCallbac === undefined ? function () {} : _ref13$addStepCallbac,
        _ref13$useBatch = _ref13.useBatch,
        useBatch = _ref13$useBatch === undefined ? true : _ref13$useBatch;
    var clip = clipAdditionData.clip,
        selectedClip = clipAdditionData.selectedClip,
        clipTransition = clipAdditionData.clipTransition,
        clipTransitionLeft = clipAdditionData.clipTransitionLeft,
        clipTransitionRight = clipAdditionData.clipTransitionRight,
        adjustTransition = clipAdditionData.adjustTransition,
        rightClipId = clipAdditionData.rightClipId,
        leftClipId = clipAdditionData.leftClipId;

    var doBatchOp = function doBatchOp() {
        var clipActionData = void 0;

        var replaceOverlayAction = {
            overlayActionData: null,
            overlayMetaActionData: null
        };

        dispatch(unselectAllClips());
        if (ClipActionType.REPLACE_CLIP === actionType) {
            if (selectedClip.clipType === _MediaConstants.SupportedReelClipTypes.composite && !retainOverlay) {
                var _getRemoveSequenceTem5 = (0, _overlayActions.getRemoveSequenceTemplatesData)(selectedClip.clipId, state),
                    overlayToRemoveList = _getRemoveSequenceTem5.overlayToRemoveList,
                    sequenceOverlayMetaEntries = _getRemoveSequenceTem5.sequenceOverlayMetaEntries;

                replaceOverlayAction.overlayActionData = (0, _overlayActions.deleteOverlays)(overlayToRemoveList, sequenceOverlayMetaEntries);
            }
            if (retainOverlay) {
                var verified = (0, _overlayActions.verifyReplaceSequenceTemplateClipData)(selectedClip.clipId, state);
                if (verified) {
                    replaceOverlayAction.overlayMetaActionData = (0, _overlayActions.replaceSequenceTemplatesAction)(selectedClip.clipId, clip.clipId);
                }
            }
            clipActionData = replaceClip([selectedClip], [clip]); // pure events not thunks
        } else {
            clipActionData = minimalAddClip(clip); // pure events not thunks
        }

        // clipActionData.replaceOverlayActionData = replaceOverlayActionData
        // clipActionData.replaceOverlayMetaActionData = replaceOverlayMetaActionData

        addStepCallback(clipActionData, replaceOverlayAction);

        if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
            // set the transition between old left clip and new clip to None
            // set the transition between new clip and selected clip to current transition

            dispatch(setTransition(clipTransition, clip.clipId, selectedClip.clipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
            if (leftClipId) {
                dispatch(setTransition(adjustTransition, leftClipId, clip.clipId, {
                    adjustOverlayTime: false,
                    refreshClipTimes: false
                }));
            }
        } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
            // set the transition between old right clip and new clip to None
            // set the transition between new clip and selected clip to current transition

            dispatch(setTransition(clipTransition, selectedClip.clipId, clip.clipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
            if (rightClipId) {
                dispatch(setTransition(adjustTransition, clip.clipId, rightClipId, {
                    adjustOverlayTime: false,
                    refreshClipTimes: false
                }));
            }
        } else if (actionType === ClipActionType.REPLACE_CLIP) {
            // currently setting to NONE
            if (leftClipId) dispatch(setTransition(clipTransitionLeft, leftClipId, clip.clipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
            if (rightClipId) dispatch(setTransition(clipTransitionRight, clip.clipId, rightClipId, {
                adjustOverlayTime: false,
                refreshClipTimes: false
            }));
        }

        // const { enterStart, exitDone, prevOffset = 0 } = clip.time;

        // const adjustment = exitDone - enterStart; //duration
        // const afterTime = enterStart + prevOffset;

        // NOT SURE OF PERFORMANCE EFFECT
        // dispatch(adjustOverlayTimeline(afterTime, adjustment))

        dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });
    };

    if (useBatch) (0, _reactRedux.batch)(doBatchOp);else doBatchOp();
}

/**
 * takes a sequence clips and adds / replaces an existing sequence / image / video / placeholder etc
 * Remember to use it cautiously ,
 * The function will add the Provided Clips as a Composite Clip
 * Overlays must be handled sepparately
 *
 * getOverlays can be passed to prepare overlays from outside and
 * then use it to dispatch SEQUENCE_ADDITION event , if that is not provided
 * it will launch whichever action was created for CLIPS and the Overlays if its a
 *
 * Which will launch a batched addition event covered under UNDO-REDO
 *
 *
 * Usage alert , when using Replace as an action
 * - If u provide overlay action it will launch a sequence add to add ur overlay data
 * - if getOverlayActionData is ommited then it becomes a sequence replace
 *
 *
 * @export
 * @param {*} [clips = []]
 * @param {*} sequenceId
 * @param {*} [actionType=ClipActionType.ADD_CLIP_END]
 * @param {*} [insertClipId=null]
 * @param {*} [callback=() => {}]
 * @return {*}
 */
function addNewCompositeClip(_ref14) {
    var _ref14$clips = _ref14.clips,
        clips = _ref14$clips === undefined ? [] : _ref14$clips,
        sequenceId = _ref14.sequenceId,
        _ref14$sequenceName = _ref14.sequenceName,
        sequenceName = _ref14$sequenceName === undefined ? '' : _ref14$sequenceName,
        _ref14$actionType = _ref14.actionType,
        actionType = _ref14$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref14$actionType,
        _ref14$insertClipId = _ref14.insertClipId,
        insertClipId = _ref14$insertClipId === undefined ? null : _ref14$insertClipId,
        _ref14$retainOverlay = _ref14.retainOverlay,
        retainOverlay = _ref14$retainOverlay === undefined ? false : _ref14$retainOverlay,
        _ref14$callback = _ref14.callback,
        callback = _ref14$callback === undefined ? function () {} : _ref14$callback,
        _ref14$getOverlayActi = _ref14.getOverlayActionData,
        getOverlayActionData = _ref14$getOverlayActi === undefined ? function () {
        return null;
    } : _ref14$getOverlayActi,
        _ref14$useBatch = _ref14.useBatch,
        useBatch = _ref14$useBatch === undefined ? true : _ref14$useBatch;

    return function (dispatch, getState) {
        var state = getState();
        var clipAdditionData = createCompositeClipFromState({
            clips: clips,
            avoidClipBoxRecalculation: actionType === ClipActionType.REPLACE_CLIP,
            sequenceId: sequenceId,
            sequenceName: sequenceName,
            actionType: actionType,
            insertClipId: insertClipId,
            state: state
        });

        var clip = clipAdditionData.clip;

        setupAddNewCompositeClipWithClipData({
            clipAdditionData: clipAdditionData,
            dispatch: dispatch,
            addStepCallback: function addStepCallback(clipActionData, replaceOverlayAction) {
                // Below means a sequence is getting replaced
                // Possibly a Inner Clip Replace , hence it's a InnerClip entity replace

                var overlayActionData = getOverlayActionData(clip);

                if (actionType === ClipActionType.REPLACE_CLIP && !overlayActionData && (replaceOverlayAction.overlayActionData || replaceOverlayAction.overlayMetaActionData)) {
                    return dispatch(_extends({
                        type: _sequenceActions.SequenceActionType.REPLACE_SEQUENCE_ENTITIES
                    }, replaceOverlayAction, {
                        clipActionData: clipActionData
                    }));
                }

                if (overlayActionData) {
                    dispatch({
                        type: _sequenceActions.SequenceActionType.ADD_SEQUENCE_ENTITIES,
                        compositeClipActionData: clipActionData,
                        overlayActionData: overlayActionData,
                        replaceOverlayAction: replaceOverlayAction
                    });
                } else {
                    dispatch(clipActionData);
                }
                setTimelinePosition(clip, dispatch);
                callback(clip);
            },
            retainOverlay: retainOverlay,
            useBatch: useBatch,
            actionType: actionType,
            state: state
        });
    };
}

function setTimelinePosition(clip, dispatch) {
    // arbitrarily chosen
    // poyfill function
    var offset = 200; // clip.time.enterStart - (clip.time.prevOffset + clip.time.currentOffset)
    var _clip$time2 = clip.time,
        enterStart = _clip$time2.enterStart,
        currentOffset = _clip$time2.currentOffset,
        prevOffset = _clip$time2.prevOffset;

    var currenTime = Math.floor(enterStart + currentOffset + prevOffset + offset);
    // WARNING : Do not batch the below , Done for Sepparate UI behaviours , needs double rendering
    (0, _reactRedux.batch)(function () {
        dispatch((0, _playerActions.seek)(currenTime));
        dispatch((0, _uiActions.snapScrollTimeToTimeline)(true));
    });

    (0, _polyfill.localIdleCallback)(function () {
        return dispatch((0, _uiActions.snapScrollTimeToTimeline)(false));
    });
}

function buildNewClip(_ref15) {
    var reel = _ref15.reel,
        selectedMedia = _ref15.selectedMedia,
        selectedClip = _ref15.selectedClip,
        insertClipId = _ref15.insertClipId,
        player = _ref15.player,
        actionType = _ref15.actionType,
        customFormats = _ref15.customFormats,
        _ref15$clipBox = _ref15.clipBox,
        clipBox = _ref15$clipBox === undefined ? null : _ref15$clipBox,
        _ref15$timeRange = _ref15.timeRange,
        timeRange = _ref15$timeRange === undefined ? {} : _ref15$timeRange,
        animation = _ref15.animation;
    var clipId = selectedClip.clipId;

    var clip = null;
    var enterTime = null;
    var timeOffset = null;
    var rightClipId = null;
    var leftClipId = null;
    var clipTransition = void 0;
    var adjustTransition = _TransitionType2.default.NONE;

    if (!!clipId && actionType !== ClipActionType.ADD_CLIP_END) {
        var _getAdjacentClipIds4 = (0, _ReelHelpers.getAdjacentClipIds)(reel.clips, clipId);

        rightClipId = _getAdjacentClipIds4.rightClipId;
        leftClipId = _getAdjacentClipIds4.leftClipId;
    }

    if (actionType === ClipActionType.ADD_CLIP_END) {
        enterTime = (0, _ReelHelpers.getReelLastExitDone)(reel.clips);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffset)(reel.clips);
    } else if (actionType === ClipActionType.ADD_CLIP_BEFORE) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(reel.clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player, insertClipId);

        clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, leftClipId, clipId);
    } else if (actionType === ClipActionType.ADD_CLIP_AFTER) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneAfterSelectedClip)(reel.clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetAfterSelectedClip)(reel.clips, player, insertClipId);

        clipTransition = (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, clipId, rightClipId);
    } else if (actionType === ClipActionType.REPLACE_CLIP) {
        enterTime = (0, _ReelHelpers.getReelLastExitDoneBeforeSelectedClip)(reel.clips, player, insertClipId);
        timeOffset = (0, _ReelHelpers.getTotalTimeOffsetBeforeSelectedClip)(reel.clips, player, insertClipId);

        clipTransition = [(0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, leftClipId, clipId), (0, _ReelHelpers.getTransitionBetweenClips)(reel.clips, clipId, rightClipId)];
    }

    if (selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.video) {
        var videoData = selectedMedia.videoData;

        var clipStart = 0;
        var clipDuration = videoData.duration;

        if (actionType === ClipActionType.REPLACE_CLIP) {
            clipDuration = Math.floor(selectedClip.clipDuration);
        }

        if (timeRange) {
            var _ref16 = timeRange || {},
                _ref16$startTime = _ref16.startTime,
                startTime = _ref16$startTime === undefined ? 0 : _ref16$startTime,
                durationInSec = _ref16.duration;

            if (durationInSec) {
                clipDuration = Math.floor(durationInSec * 1000);
            }
            clipStart = Math.floor(startTime * 1000);
        }

        if (clipDuration > videoData.duration) {
            clipDuration = videoData.duration;
            clipStart = 0;
        }

        clip = (0, _ReelHelpers.createNewVideoClip)(videoData, enterTime, timeOffset, false, clipStart, clipDuration);
    } else if (selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.image) {
        var imageData = selectedMedia.imageData;

        var _clipDuration = 4000;

        if (actionType === ClipActionType.REPLACE_CLIP) {
            _clipDuration = Math.floor(selectedClip.clipDuration);
        }

        if (timeRange) {
            var _timeRange$duration = timeRange.duration,
                duration = _timeRange$duration === undefined ? 0 : _timeRange$duration;

            if (duration && !isNaN(duration)) {
                _clipDuration = Math.floor(duration * 1000);
            }
        }

        clip = (0, _ReelHelpers.createNewImageClip)(imageData, enterTime, timeOffset, false, animation, _clipDuration);
    } else {
        throw new Error('Unsupported media type');
    }

    if (!clipBox) {
        var customFormat = customFormats.formats.find(function (i) {
            return i.id === reel.formatId;
        });
        clip = _extends({}, clip, {
            clipBox: (0, _ReelHelpers.calcDefaultClipBox)(clip, reel.frameType, reel.canvas, customFormat)
        });
    } else {
        clip = _extends({}, clip, { clipBox: clipBox });
    }

    // Selected when adding
    // clip.isSelected = true;

    return {
        clip: clip,
        timeOffset: timeOffset,
        clipTransition: clipTransition,
        adjustTransition: adjustTransition,
        rightClipId: rightClipId,
        leftClipId: leftClipId
    };
}

function replaceSequenceInnerClipWithUserSpaceMedia(mediaId, providedSequenceId, innerClipId) {
    var _ref17 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref17$clipBox = _ref17.clipBox,
        clipBox = _ref17$clipBox === undefined ? null : _ref17$clipBox,
        _ref17$timeRange = _ref17.timeRange,
        timeRange = _ref17$timeRange === undefined ? {} : _ref17$timeRange,
        _ref17$animation = _ref17.animation,
        animation = _ref17$animation === undefined ? 'NONE' : _ref17$animation;

    return function (dispatch, getState) {
        var _getState9 = getState(),
            reel = _getState9.reel,
            player = _getState9.player,
            _getState9$localState = _getState9.localState.userSpaceMedia,
            userSpaceMedia = _getState9$localState === undefined ? [] : _getState9$localState;

        dispatch(unselectAllClips());

        // mediaId can , uploadId | workspaceId we will add whatever matches the list
        var selectedMedia = userSpaceMedia.find(function (obj) {
            if (obj.id === mediaId) return true;
            if (obj.uploadId === mediaId) return true;
            if (obj.workspaceId === mediaId) return true;
            return false;
        });

        if (!selectedMedia) {
            // if the media is not there there can be two reaons
            // 1 - local media is no more playable
            // 2 - there is a UI bug which shows the UploadedItem even after upload is done
            // NOTE : The userSpaceMedia will be verified and loaded everytime from the local media
            // verification will involve the verification of the availability of the file until stashed locally
            //
            return dispatch({
                type: UserSpaceContentAdd.UNABLE_TO_ADD,
                message: "Possibly local / video link is removed from it's source"
            });
        }

        var sequence = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time, providedSequenceId);
        if (!sequence) {
            console.log('Couldn\'t find selected sequence');
            return;
        }

        var selectedClip = sequence.childClips.find(function (c) {
            return c.clipId === innerClipId;
        });
        if (!selectedClip) throw new Error('Cannot find Sequence inner clip');

        var updatedClip = createUpdatedClipFromExistingClip(_defineProperty({
            id: selectedMedia.id,
            mediaType: selectedMedia.mediaType
        }, selectedMedia.mediaType === _PlayerRegistry.SupportedMediaType.image ? 'imageData' : 'videoData', selectedMedia), selectedClip, animation, timeRange, clipBox);

        // delete unneeded values from clip (for the placeholder)
        delete updatedClip.thumbUrl;
        delete updatedClip.ptitle;
        delete updatedClip.pheight;
        delete updatedClip.pwidth;
        delete updatedClip.ptype;
        delete updatedClip.pMediaId;
        delete updatedClip.pduration;
        delete updatedClip.placeHolderError;
        delete updatedClip.isPlaceholder;
        delete updatedClip.solidImageColor;
        delete updatedClip.hidePadding;
        delete updatedClip.isSelected;

        var updatedClipList = sequence.childClips.map(function (clip) {
            if (clip.clipId === updatedClip.clipId) return updatedClip;
            return clip;
        });

        dispatch(addNewCompositeClip({
            clips: updatedClipList,
            sequenceId: sequence.sequenceId,
            sequenceName: sequence.name,
            actionType: ClipActionType.REPLACE_CLIP,
            retainOverlay: true
        }));
        dispatch(modeActions.closeAudioProperties());
        dispatch(modeActions.unselectWatermarkPreview());
        dispatch(modeActions.clearReplaceInsert());
    };
}

/**
 * Used for adding any video/image that the user has added to the
 * editor but it does not exist on the backend
 */
function addNewUserSpaceClip(_ref18) {
    var mediaId = _ref18.mediaId,
        _ref18$actionType = _ref18.actionType,
        actionType = _ref18$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref18$actionType,
        _ref18$insertClipId = _ref18.insertClipId,
        insertClipId = _ref18$insertClipId === undefined ? null : _ref18$insertClipId,
        _ref18$clipBox = _ref18.clipBox,
        clipBox = _ref18$clipBox === undefined ? null : _ref18$clipBox,
        _ref18$timeRange = _ref18.timeRange,
        timeRange = _ref18$timeRange === undefined ? {} : _ref18$timeRange,
        _ref18$animation = _ref18.animation,
        animation = _ref18$animation === undefined ? undefined : _ref18$animation;

    return function (dispatch, getState) {
        var state = getState();
        var reel = state.reel,
            player = state.player,
            customFormats = state.customFormats,
            _state$localState$use = state.localState.userSpaceMedia,
            userSpaceMedia = _state$localState$use === undefined ? [] : _state$localState$use;

        var processState = 'uploading'; // for logging purpose

        var isEmptyProject = reel.clips.length === 0;

        // mediaId can , uploadId | workspaceId we will add whatever matches the list
        var selectedMedia = userSpaceMedia.find(function (obj) {
            if (obj.id === mediaId) return true;
            if (obj.uploadId === mediaId) return true;
            if (obj.workspaceId === mediaId) {
                processState = 'processing';
                return true;
            }
            return false;
        });

        if (!selectedMedia) {
            // if the media is not there there can be two reaons
            // 1 - local media is no more playable
            // 2 - there is a UI bug which shows the UploadedItem even after upload is done
            // NOTE : The userSpaceMedia will be verified and loaded everytime from the local media
            // verification will involve the verification of the availability of the file until stashed locally
            //
            return dispatch({
                type: UserSpaceContentAdd.UNABLE_TO_ADD,
                message: "Possibly local / video link is removed from it's source"
            });
        }

        var selectedClip = null;
        if (insertClipId) {
            selectedClip = reel.clips.find(function (c) {
                return c.clipId === insertClipId;
            });
        } else {
            selectedClip = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time);
        }

        if (!selectedClip) {
            if (isEmptyProject) {
                selectedClip = {};
            } else {
                throw new Error('No clip selected to add to.');
            }
        }

        // reformating the data
        var selectedMediaF = { id: selectedMedia.id, mediaType: selectedMedia.mediaType };
        var key = selectedMedia.mediaType === _MediaConstants.SupportedReelClipTypes.video ? 'videoData' : 'imageData';
        selectedMediaF[key] = selectedMedia;

        var replacingClips = [];

        var _buildNewClip = buildNewClip({
            reel: reel,
            selectedMedia: selectedMediaF,
            selectedClip: selectedClip,
            player: player,
            actionType: actionType,
            customFormats: customFormats,
            clipBox: clipBox,
            timeRange: timeRange,
            insertClipId: insertClipId,
            animation: animation
        }),
            clip = _buildNewClip.clip,
            clipTransition = _buildNewClip.clipTransition,
            adjustTransition = _buildNewClip.adjustTransition,
            timeOffset = _buildNewClip.timeOffset,
            rightClipId = _buildNewClip.rightClipId,
            leftClipId = _buildNewClip.leftClipId;

        replacingClips.push(clip);

        var newClipDuration = clip.clipDuration;
        var oldClipDuration = selectedClip.clipDuration;

        if (newClipDuration < oldClipDuration) {
            var solidClipDuration = oldClipDuration - newClipDuration;
            var placeholderClip = (0, _ReelHelpers.createNewSolidImageClip)('#000000', solidClipDuration, true, clip.time.exitDone, timeOffset, false, selectedClip.speed);
            placeholderClip = _extends({}, placeholderClip, {
                clipBox: {
                    x: 0,
                    y: 0,
                    sar: 1,
                    width: reel.canvas.width,
                    height: reel.canvas.height
                }
            });
            replacingClips.push(placeholderClip);
        }

        var _selectedClip3 = selectedClip,
            clipId = _selectedClip3.clipId;

        (0, _reactRedux.batch)(function () {
            dispatch(unselectAllClips()); // moved below otherwise selectedClip gave null sometimes

            var clipActionData = void 0;

            if (actionType === ClipActionType.REPLACE_CLIP) {
                clipActionData = replaceClip([selectedClip], replacingClips);
            } else {
                clipActionData = addClip(clip);
            }

            if (selectedClip.clipType === _MediaConstants.SupportedReelClipTypes.composite && actionType === ClipActionType.REPLACE_CLIP) {
                dispatch(createReplaceSequenceAction({
                    selectedClip: selectedClip,
                    clipActionData: clipActionData,
                    state: state
                }));
            } else {
                dispatch(clipActionData);
            }

            var locationForAdd = _logActions.mediaAddLocations.ADD_AFTER;

            if (actionType == ClipActionType.ADD_CLIP_BEFORE) {
                // set the transition between old left clip and new clip to None
                // set the transition between new clip and selected clip to current transition

                locationForAdd = _logActions.mediaAddLocations.INSERT_BEFORE;

                dispatch(setTransition(clipTransition, clip.clipId, clipId));
                if (leftClipId) {
                    dispatch(setTransition(adjustTransition, leftClipId, clip.clipId));
                }
            } else if (actionType == ClipActionType.ADD_CLIP_AFTER) {
                // set the transition between old right clip and new clip to None
                // set the transition between new clip and selected clip to current transition

                locationForAdd = _logActions.mediaAddLocations.ADD_AFTER;

                dispatch(setTransition(clipTransition, clipId, clip.clipId));
                if (rightClipId) {
                    dispatch(setTransition(adjustTransition, clip.clipId, rightClipId));
                }
            } else if (actionType == ClipActionType.REPLACE_CLIP) {
                var _clipTransition = _slicedToArray(clipTransition, 2),
                    leftTransition = _clipTransition[0],
                    rightTransition = _clipTransition[1];

                if (leftClipId) {
                    dispatch(setTransition(leftTransition, leftClipId, clip.clipId));
                }
                if (rightClipId) {
                    dispatch(setTransition(rightTransition, clip.clipId, rightClipId));
                }
            }

            dispatch((0, _logActions.trackInstantUploadAdd)(selectedMedia.mediaType, locationForAdd, _logActions.mediaAddFromLocations.PREVIEW_MODAL, _logActions.mediaAddDestinations.TIMELINE, processState));

            dispatch(adjustTransitionsForAllClip());
        });
    };
}

/**
 * Used for adding the clips
 * new method ads clips to reel ,
 * picks stuff from workspace media if needed
 *
 * @export
 * @param {*} mediaId
 * @param {*} [actionType=ClipActionType.ADD_CLIP_END]
 * * @param {*} insertClipId -> clipId for insert on Timeline action
 * @return {*}
 */
function addNewClip(_ref19) {
    var mediaId = _ref19.mediaId,
        _ref19$actionType = _ref19.actionType,
        actionType = _ref19$actionType === undefined ? ClipActionType.ADD_CLIP_END : _ref19$actionType,
        _ref19$insertClipId = _ref19.insertClipId,
        insertClipId = _ref19$insertClipId === undefined ? null : _ref19$insertClipId,
        _ref19$clipBox = _ref19.clipBox,
        clipBox = _ref19$clipBox === undefined ? null : _ref19$clipBox,
        _ref19$timeRange = _ref19.timeRange,
        timeRange = _ref19$timeRange === undefined ? {} : _ref19$timeRange,
        _ref19$animation = _ref19.animation,
        animation = _ref19$animation === undefined ? _ReelHelpers.IMAGE_ANIMATIONS[0] : _ref19$animation;

    return function (dispatch, getState) {
        var _getState10 = getState(),
            projectMedia = _getState10.projectMedia,
            reel = _getState10.reel,
            player = _getState10.player,
            customFormats = _getState10.customFormats,
            workspaceMedia = _getState10.workspaceMedia;

        var isEmptyProject = reel.clips.length == 0;

        var selectedMedia = projectMedia.find(function (m) {
            return m.id === mediaId && !isMediaDeleted(m);
        });

        /// Picks data from workspace media  ~ new convention wise , there are two sources
        // workspacemedia = all media uploaded in a workspace , common repo
        // project media = media that is exclusive to current project and only used here
        //
        if (!selectedMedia) {
            selectedMedia = workspaceMedia.find(function (m) {
                return m.id === mediaId && !isMediaDeleted(m);
            });
            if (selectedMedia) {
                dispatch((0, _mediaActions.addMediaFromWorkspaceToProjectMedia)(selectedMedia));
            }
            if (!selectedMedia) {
                throw new Error('Cannot find media to add');
            }
        }

        var selectedClip = null;
        if (insertClipId) {
            selectedClip = reel.clips.find(function (c) {
                return c.clipId === insertClipId;
            });
        } else if (!isEmptyProject) {
            selectedClip = (0, _ReelHelpers.getSelectedClip)(reel.clips, player.time);
        }

        if (!selectedClip) {
            if (isEmptyProject) {
                selectedClip = {};
            } else {
                throw new Error('No clip selected to add to.');
            }
        }

        var _buildNewClip2 = buildNewClip({
            reel: reel,
            selectedMedia: selectedMedia,
            selectedClip: selectedClip,
            player: player,
            actionType: actionType,
            customFormats: customFormats,
            clipBox: clipBox,
            timeRange: timeRange,
            insertClipId: insertClipId,
            animation: animation
        }),
            clip = _buildNewClip2.clip,
            clipTransition = _buildNewClip2.clipTransition,
            adjustTransition = _buildNewClip2.adjustTransition,
            rightClipId = _buildNewClip2.rightClipId,
            leftClipId = _buildNewClip2.leftClipId;

        var _selectedClip4 = selectedClip,
            clipId = _selectedClip4.clipId;

        // BELOW LIES THE OLD METHOD SOON TO BE PRUNED FROM TIMELINE :-p
        // let clip = null, enterTime = null, timeOffset = null
        // let rightClipId = null, leftClipId = null, clipTransition, adjustTransition = TransitionType.NONE;

        // if (!!clipId && actionType != ClipActionType.ADD_CLIP_END) {
        //     ({ rightClipId, leftClipId } = getAdjacentClipIds(reel.clips, clipId));
        // }

        // if (actionType == ClipActionType.ADD_CLIP_END) {
        //     enterTime = getReelLastExitDone(reel.clips)
        //     timeOffset = getTotalTimeOffset(reel.clips)
        // } else if (actionType == ClipActionType.ADD_CLIP_BEFORE) {
        //     enterTime = getReelLastExitDoneBeforeSelectedClip(reel.clips, player, insertClipId)
        //     timeOffset = getTotalTimeOffsetBeforeSelectedClip(reel.clips, player, insertClipId)

        //     clipTransition = getTransitionBetweenClips(reel.clips, leftClipId, clipId)

        // } else if (actionType == ClipActionType.ADD_CLIP_AFTER) {
        //     enterTime = getReelLastExitDoneAfterSelectedClip(reel.clips, player, insertClipId)
        //     timeOffset = getTotalTimeOffsetAfterSelectedClip(reel.clips, player, insertClipId)

        //     clipTransition = getTransitionBetweenClips(reel.clips, clipId, rightClipId)
        // }

        // if (selectedMedia.mediaType === SupportedReelClipTypes.video) {
        //     const { videoData } = selectedMedia

        //     let { startTime = 0 , duration = null} = timeRange || {}

        //     if(!!duration){
        //         duration = duration * 1000
        //     }
        //     startTime = startTime * 1000

        //     clip = createNewVideoClip(videoData, enterTime, timeOffset , false ,startTime , duration)

        // } else if (selectedMedia.mediaType === SupportedReelClipTypes.image) {
        //     const { imageData } = selectedMedia

        //     clip = createNewImageClip(imageData, enterTime, timeOffset ,false ,  animation)
        // } else {
        //     throw new Error(`Unsupported media type`)
        // }

        // if(!clipBox){
        //     let customFormat = customFormats.formats.find(i => i.id === reel.formatId)
        //     clip = { ...clip, clipBox: calcDefaultClipBox(clip, reel.frameType, reel.canvas, customFormat) }
        // }else{
        //     clip = { ...clip, clipBox}
        // }

        // Selected when adding
        // clip.isSelected = true;

        (0, _reactRedux.batch)(function () {
            dispatch(unselectAllClips()); // moved below otherwise selectedClip gave null sometimes

            dispatch(addClip(clip));

            if (actionType == ClipActionType.ADD_CLIP_BEFORE) {
                // set the transition between old left clip and new clip to None
                // set the transition between new clip and selected clip to current transition
                dispatch(setTransition(clipTransition, clip.clipId, clipId));
                if (leftClipId) {
                    dispatch(setTransition(adjustTransition, leftClipId, clip.clipId));
                }
            } else if (actionType == ClipActionType.ADD_CLIP_AFTER) {
                // set the transition between old right clip and new clip to None
                // set the transition between new clip and selected clip to current transition

                dispatch(setTransition(clipTransition, clipId, clip.clipId));
                if (rightClipId) {
                    dispatch(setTransition(adjustTransition, clip.clipId, rightClipId));
                }
            }
        });

        /// //////////////////// TODO LOGGING STUFF ------ MOVE OUT OF HERE

        try {
            if (!!insertClipId && actionType == ClipActionType.ADD_CLIP_AFTER || actionType == ClipActionType.ADD_CLIP_BEFORE) dispatch((0, _logActions.mediaInserted)(selectedMedia.mediaType));else {
                var location = _logActions.mediaAddLocations.TO_LAST;
                if (actionType == ClipActionType.ADD_CLIP_BEFORE) location = _logActions.mediaAddLocations.INSERT_BEFORE;else if (actionType == ClipActionType.ADD_CLIP_AFTER) location = _logActions.mediaAddLocations.ADD_AFTER;

                var from = _logActions.mediaAddFromLocations.LEFT_PANEL;
                if (window.mediaAddFromLocation == _logActions.mediaAddFromLocations.PREVIEW_MODAL) from = _logActions.mediaAddFromLocations.PREVIEW_MODAL;

                var viaSearch = window.mediaAddedFromSearch == true;
                var viaFilters = window.mediaAddedFromFilters == true;

                // Clean up
                window.mediaAddFromLocation = null;
                window.mediaAddedFromFilters = null;
                window.mediaAddedFromSearch = null;

                dispatch((0, _logActions.trackMediaAdded)(selectedMedia.mediaType, location, from, _logActions.mediaAddDestinations.TIMELINE, viaSearch, viaFilters));
            }
        } catch (err) {
            console.log('Error logging ' + err);
        }

        // const newClipId = clip.clipId

        // const { reel : { clips } } = getState()

        // const newClipIndex = clips.findIndex(c => c.clipId === newClipId)

        // const timeUntilClip = clips.slice(0, newClipIndex).reduce((p, c) => p + c.clipDuration, 0)

        // const seekTime = timeUntilClip + clips[newClipIndex].clipDuration / 2

        // dispatch(seek(seekTime))

        if (window.startTrackingModeTimes) {
            var _getState11 = getState(),
                currentMode = _getState11.mode.currentMode;

            var isOverlayMode = currentMode === _EditorMode2.default.OVERLAY;
            window.startTrackingModeTimes(isOverlayMode);
        }
    };
}

function splitClip() {
    var atime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    return function (dispatch, getState) {
        var state = getState();
        var clips = state.reel.clips,
            ntime = state.player.time;

        var time = atime || ntime;

        var currentClip = (0, _reelSelectors.getCurrentClipSelected)(state); // select clip

        if (!currentClip) {
            throw new Error("Couldn't get a clip id to split");
        }

        // This is the 'before split' clip
        var bsClip = (0, _cloneextend.clone)(currentClip);

        var currentTime = time;

        // These are the 'after split clips'. The first one is the same clip repurposed,
        // the second one will have a new clip id
        var asClip = (0, _cloneextend.clone)(bsClip);
        var asClipDuplicate = (0, _cloneextend.clone)(bsClip);
        var _asClip$speed = asClip.speed,
            asClipSpeed = _asClip$speed === undefined ? 1 : _asClip$speed;

        // New clip id for the second clip

        asClipDuplicate.clipId = _shortid2.default.generate();

        var _bsClip$time = bsClip.time,
            bsEnterStart = _bsClip$time.enterStart,
            bsExitDone = _bsClip$time.exitDone,
            _bsClip$time$currentO = _bsClip$time.currentOffset,
            bsCurrentOffset = _bsClip$time$currentO === undefined ? 0 : _bsClip$time$currentO,
            _bsClip$time$prevOffs = _bsClip$time.prevOffset,
            bsPrevOffset = _bsClip$time$prevOffs === undefined ? 0 : _bsClip$time$prevOffs;

        // The clipStart for first after split clip will be the same as the before split clip
        // The clipDuration for first after split clip will be based on the current time

        var clipStartTime = bsEnterStart + bsPrevOffset + bsCurrentOffset;
        asClip.clipDuration = Math.floor((currentTime - clipStartTime) * asClipSpeed);

        asClip.time = {
            enterStart: bsEnterStart,
            enterDone: bsEnterStart,
            exitStart: bsEnterStart + asClip.clipDuration / asClipSpeed,
            exitDone: bsEnterStart + asClip.clipDuration / asClipSpeed,
            currentOffset: bsCurrentOffset,
            prevOffset: bsPrevOffset
        };

        delete asClip.transitions.exit;

        var removeTranistionCall = null;

        if (asClip.clipDuration < 2000) {
            asClip.time.currentOffset = 0;
            delete asClip.transitions.enter;
            removeTranistionCall = function removeTranistionCall() {
                return dispatch({ type: ReelActionType.REMOVE_TRANSITIONS, clipId: asClip.clipId });
            };
        }

        // The clipStart for the second after split clip will be from the end of the previous clip
        asClipDuplicate.clipStart = asClip.clipStart + asClip.clipDuration;
        asClipDuplicate.clipDuration = bsClip.clipDuration - asClip.clipDuration;

        asClipDuplicate.time = {
            enterStart: asClip.time.exitDone,
            enterDone: asClip.time.exitDone,
            exitStart: bsExitDone,
            exitDone: bsExitDone,
            currentOffset: 0,
            prevOffset: asClip.time.currentOffset + bsPrevOffset
        };

        delete asClipDuplicate.transitions.enter;

        var removeTranistionCallD = null;

        if (asClipDuplicate.clipDuration < 2000) {
            delete asClipDuplicate.transitions.exit;
            removeTranistionCallD = function removeTranistionCallD() {
                return dispatch({
                    type: ReelActionType.REMOVE_TRANSITIONS,
                    clipId: asClipDuplicate.clipId
                });
            };
        }

        (0, _reactRedux.batch)(function () {
            removeTranistionCall && removeTranistionCall();
            removeTranistionCallD && removeTranistionCallD();
            dispatch({
                type: ReelActionType.CLIP_SPLIT,
                bsClip: bsClip,
                asClip: asClip,
                asClipDuplicate: asClipDuplicate,
                currentTime: currentTime
            });
            dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });
            dispatch((0, _playerActions.seek)(currentTime));
        });
    };
}

function cropCurrentClip() {
    return function (dispatch, getState) {
        var _getState12 = getState(),
            clips = _getState12.reel.clips,
            time = _getState12.player.time;

        var _getCurrentClip2 = _getCurrentClip(clips, time),
            cropClipId = _getCurrentClip2.clipId,
            clipBox = _getCurrentClip2.clipBox;

        if (!cropClipId) {
            throw new Error("Couldn't get a clip id to crop");
        }

        dispatch(startCroppingClip(cropClipId, clipBox));
    };
}

/**
 * Use for adjusting the transitions of the present clips in the timine
 *
 */
var adjustTransitionsForAllClip = exports.adjustTransitionsForAllClip = function adjustTransitionsForAllClip() {
    return function (dispatch, getState) {
        var _getState13 = getState(),
            _getState13$reel$clip = _getState13.reel.clips,
            clips = _getState13$reel$clip === undefined ? [] : _getState13$reel$clip;

        var actions = [].concat(_toConsumableArray(clips)).splice(1, clips.length - 2).map(function (clip) {
            return adjustTransitionForClip(clip.clipId, {
                adjustOverlayTimeline: false,
                refreshTimeline: true
            });
        });
        dispatch([].concat(_toConsumableArray(actions), [{ type: ReelActionType.REFRESH_CLIP_TIMES }]));
    };
};

var applyTransitionsForAdjustment = function applyTransitionsForAdjustment(leftClipId, rightClipId, getState, dispatch, options) {
    var leftClip = getState().reel.clips.find(function (c) {
        return c.clipId == leftClipId;
    });
    var rightClip = getState().reel.clips.find(function (c) {
        return c.clipId == rightClipId;
    });

    var _ref20 = leftClip.transitions || {},
        _ref20$exit = _ref20.exit;

    _ref20$exit = _ref20$exit === undefined ? {} : _ref20$exit;
    var _ref20$exit$transitio = _ref20$exit.transitionType,
        leftTransitionType = _ref20$exit$transitio === undefined ? _TransitionType2.default.NONE : _ref20$exit$transitio;

    var _ref21 = rightClip.transitions || {},
        _ref21$enter = _ref21.enter;

    _ref21$enter = _ref21$enter === undefined ? {} : _ref21$enter;
    var _ref21$enter$transiti = _ref21$enter.transitionType,
        rightTransitionType = _ref21$enter$transiti === undefined ? _TransitionType2.default.NONE : _ref21$enter$transiti;

    var transitionType = leftTransitionType;
    var shouldResetTransition = false;

    if (leftTransitionType !== rightTransitionType) {
        shouldResetTransition = true;
    }

    var leftClipDuration = leftClip.clipDuration / leftClip.speed + (leftClip.time.currentOffset || 0);
    var rightClipDuration = rightClip.clipDuration / rightClip.speed + (rightClip.time.currentOffset || 0);

    if (leftTransitionType === _TransitionType2.default.CROSS_DISSOLVE && leftClipDuration < 2000) {
        transitionType = _TransitionType2.default.NONE;
        shouldResetTransition = true;
    }

    if (leftClipDuration < 1000 || rightClipDuration < 1000) {
        transitionType = _TransitionType2.default.NONE;
        shouldResetTransition = true;
    }

    if (shouldResetTransition) {
        dispatch(setTransition(transitionType, leftClip.clipId, rightClip.clipId, {
            adjustOverlayTime: options.adjustOverlayTime,
            refreshClipTimes: options.refreshTimeline
        }));
    }
};

function adjustTransitionForClip(clipId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { adjustOverlayTimeline: true, refreshTimeline: true };

    return function (dispatch, getState) {
        var _getAdjacentClipIds5 = (0, _ReelHelpers.getAdjacentClipIds)(getState().reel.clips, clipId),
            leftClipId = _getAdjacentClipIds5.leftClipId,
            rightClipId = _getAdjacentClipIds5.rightClipId;

        if (leftClipId) {
            applyTransitionsForAdjustment(leftClipId, clipId, getState, dispatch, options);
        }

        if (rightClipId) {
            applyTransitionsForAdjustment(clipId, rightClipId, getState, dispatch, options);
        }

        if (options.refreshTimeline) dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });
    };
}

/**
 * Used for removing the Left and Right transition of any clip
 *
 * @param {*} clipId
 * @param {boolean} [options={ adjustOverlayTimeline: true, refreshTimeline: true }]
 * @return {*}
 */
function adjustTransitionsByRemove(clipId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { adjustOverlayTimeline: true, refreshTimeline: true };

    return function (dispatch, getState) {
        var _getAdjacentClipIds6 = (0, _ReelHelpers.getAdjacentClipIds)(getState().reel.clips, clipId),
            leftClipId = _getAdjacentClipIds6.leftClipId,
            rightClipId = _getAdjacentClipIds6.rightClipId;

        dispatch({ type: ReelActionType.REMOVE_TRANSITIONS, clipId: clipId });

        if (!!leftClipId && !!rightClipId) {
            var leftClip = getState().reel.clips.find(function (c) {
                return c.clipId == leftClipId;
            });
            var rightClip = getState().reel.clips.find(function (c) {
                return c.clipId == rightClipId;
            });

            var _ref22 = leftClip.transitions || {},
                _ref22$exit = _ref22.exit;

            _ref22$exit = _ref22$exit === undefined ? {} : _ref22$exit;
            var _ref22$exit$transitio = _ref22$exit.transitionType,
                transitionType = _ref22$exit$transitio === undefined ? 'NONE' : _ref22$exit$transitio;

            if (transitionType !== 'NONE' && leftClip.clipDuration >= 2000 && rightClip.clipDuration >= 2000) {
                dispatch(setTransition(transitionType, leftClipId, rightClipId, {
                    adjustOverlayTime: options.adjustOverlayTimeline,
                    refreshClipTimes: options.refreshTimeline
                }));
                // false refresh clip because we want to avoid doing it as it already done below.
                // if below one is disabled some other dispatch takes responsibility of it
            }
        }
        if (options.refreshTimeline) dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });
    };
}

function moveClip(clipId, newIndex) {
    return function (dispatch, getState) {
        dispatch(adjustTransitionsByRemove(clipId));

        var state = getState();
        var _state$player = state.player,
            duration = _state$player.duration,
            currentTime = _state$player.time,
            _state$reel2 = state.reel,
            clips = _state$reel2.clips,
            _state$reel2$syncMedi = _state$reel2.syncMediaAndText,
            syncMediaAndText = _state$reel2$syncMedi === undefined ? false : _state$reel2$syncMedi,
            overlays = state.overlays;

        var oldIndex = clips.findIndex(function (clip) {
            return clip.clipId === clipId;
        });

        var enterStart = clips[oldIndex].time.enterStart;

        var offset = currentTime - enterStart;

        dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000));

        var overlayToSequenceClipMap = getOverlayToSequenceClipMap(state);
        var filteredOverlays = Object.keys(overlays).reduce(function (acc, key) {
            if (!overlayToSequenceClipMap[key]) {
                acc[key] = overlays[key];
            }
            return acc;
        }, {});

        if (syncMediaAndText) {
            var adjustedOverlays = (0, _ReelHelpers.moveOverlaysOnClipMove)(filteredOverlays, clips, clipId, newIndex);
            dispatch({ type: _overlayActions.OverlayActionType.OVERLAYS_ADJUST, adjustedOverlays: adjustedOverlays });
        }
        dispatch({ type: ReelActionType.CLIP_MOVE, clipId: clipId, newIndex: newIndex, oldIndex: oldIndex });

        var _getState14 = getState(),
            newClips = _getState14.reel.clips;

        var newEnterStart = newClips[newIndex].time.enterStart;

        dispatch((0, _playerActions.seek)(newEnterStart + offset));
        dispatch(adjustTransitionsForAllClip());
        dispatch((0, _guardActions.guardOverlayUpdates)(false));
    };
}

function trimToVideoDurationLimit() {
    return function (dispatch, getState) {
        var _getState15 = getState(),
            _getState15$reel = _getState15.reel,
            clips = _getState15$reel.clips,
            videoDurationLimit = _getState15$reel.videoDurationLimit;

        if (videoDurationLimit <= 0) {
            return;
        }

        var lastClip = _getCurrentClip(clips, videoDurationLimit - 1);
        var lastClipIndex = clips.findIndex(function (c) {
            return c.clipId === lastClip.clipId;
        });

        var durationUntilClip = 0;
        for (var i = 0; i < lastClipIndex; i++) {
            var _clips$i = clips[i],
                clipDuration = _clips$i.clipDuration,
                _clips$i$speed = _clips$i.speed,
                speed = _clips$i$speed === undefined ? 1 : _clips$i$speed;

            durationUntilClip += clipDuration / speed;
        }

        var newLastClipDuration = (videoDurationLimit - durationUntilClip - 1) * lastClip.speed;

        (0, _reactRedux.batch)(function () {
            // Remove clips after last clip
            clips.forEach(function (c, i) {
                if (i > lastClipIndex) {
                    dispatch({ type: ReelActionType.CLIP_DELETE, clip: c, index: i });
                }
            });

            // Trim last clip to max duration
            dispatch({
                type: ReelActionType.CLIP_TRIM_FINISH,
                clipId: lastClip.clipId,
                newClipStart: lastClip.clipStart,
                newClipDuration: newLastClipDuration,
                oldClipStart: lastClip.clipStart,
                oldClipDuration: lastClip.clipDuration,
                edgeType: 'right'
            });
        });
    };
}

function trimClip(incremental, edgeType, clipId, newClipStart, newClipDuration, newTime) {
    var oldClipStart = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var oldClipDuration = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var oldTime = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};

    newClipStart = Math.max(0, Math.floor(newClipStart));
    newClipDuration = Math.max(0, Math.floor(newClipDuration));

    return function (dispatch, getState) {
        if (incremental) {
            dispatch((0, _guardActions.guardOverlayUpdates)(true, 1000)); // Will disable the overlay updation for 50ms
            dispatch({
                type: ReelActionType.CLIP_TRIM_INCR,
                clipId: clipId,
                newClipStart: newClipStart,
                newClipDuration: newClipDuration,
                newTime: newTime
            });
        } else {
            var state = getState();
            var clipsObj = (0, _reelSelectors.getClipsObjects)(state);
            var clip = clipsObj[clipId];

            var _clip$time3 = clip.time,
                exitDone = _clip$time3.exitDone,
                _clip$time3$prevOffse = _clip$time3.prevOffset,
                prevOffset = _clip$time3$prevOffse === undefined ? 0 : _clip$time3$prevOffse,
                enterStart = _clip$time3.enterStart;

            var afterTime = exitDone + prevOffset;
            var adjustment = newClipDuration - oldClipDuration; // change in duration

            (0, _reactRedux.batch)(function () {
                dispatch((0, _overlayActions.adjustOverlayTimeline)(afterTime, adjustment));
                dispatch((0, _guardActions.guardOverlayUpdates)(false)); // Will disable the overlay updation for 50ms
                dispatch({
                    type: ReelActionType.CLIP_TRIM_FINISH,
                    clipId: clipId,
                    newClipStart: newClipStart,
                    newClipDuration: newClipDuration,
                    newTime: newTime,
                    oldClipStart: oldClipStart,
                    oldClipDuration: oldClipDuration,
                    oldTime: oldTime,
                    edgeType: edgeType
                });
            });
        }
    };
}

function trimClipIncemental(type, clipId, newClipStart, newClipDuration, newTime) {
    return function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch(trimClip(true, type, clipId, newClipStart, newClipDuration, newTime));
        });
    };
}

function trimClipFinish(type, clipId, newClipStart, newClipDuration, newTime, oldClipStart, oldClipDuration, oldTime) {
    return trimClip(false, type, clipId, newClipStart, newClipDuration, newTime, oldClipStart, oldClipDuration, oldTime);
}

function _getCurrentClip(clips, currentTime) {
    var cumulativeDuration = 0;
    var currentClip = null;

    var clipTimes = (0, _ReelHelpers.getClipTimes)(clips);

    for (var i = 0; i < clips.length; i++) {
        var clip = clips[i];
        var clipTime = clipTimes[clip.clipId];

        var enterStart = clipTime.enterStart,
            exitDone = clipTime.exitDone,
            prevOffset = clipTime.prevOffset,
            currentOffset = clipTime.currentOffset;

        // -- Clip with start time lesser than or equal current time and greater end time is condered
        // -- When start and end time of simultaneos clips is same the selection logic will default to one which satisfies above logic

        if (currentTime >= enterStart + currentOffset + prevOffset && currentTime < exitDone + currentOffset + prevOffset) {
            currentClip = clip;
            break;
        }

        if (i === clips.length - 1 && currentClip === null) {
            // Last clip
            currentClip = clip;
        }
    }
    return currentClip;
}

function changeFormat(formatId, forceSetOverlays) {
    return function (dispatch, getState) {
        var customFormat = getState().customFormats.formats.find(function (f) {
            return f.id === formatId;
        });

        (0, _reactRedux.batch)(function () {
            var _getState$reel = getState().reel,
                oldFormatId = _getState$reel.formatId,
                oldCanvas = _getState$reel.canvas;

            dispatch({ type: ReelActionType.FORMAT_CHANGE, formatId: formatId, oldFormatId: oldFormatId, customFormat: customFormat });

            var _getState$reel2 = getState().reel,
                newCanvas = _getState$reel2.canvas,
                newFrameType = _getState$reel2.frameType;

            // TODO marking it for removal , redudant event since , it does not changes any state info (reducer removed some time back)
            // only visible in ControlMiddleware

            dispatch({ type: ReelActionType.FRAME_CHANGE, frameType: newFrameType, customFormat: customFormat });
            if (forceSetOverlays) {
                dispatch({
                    type: _overlayActions.OverlayActionType.OVERLAYS_ADJUST,
                    adjustedOverlays: forceSetOverlays
                });
            } else {
                dispatch((0, _overlayActions.doAdjustOverlays)(newCanvas, oldCanvas));
            }
            dispatch((0, _subtitleActions.switchSubtitlePosition)());
            dispatch((0, _subtitleActions.changeSubtitleWidth)());
            dispatch({ type: ReelActionType.FORMAT_CHANGE_DONE });
            dispatch((0, _onboardingActions.completeOnboardingStep)('SELECT_FORMAT'));
        });
    };
}

function changeFrameType(frameType) {
    return function (dispatch, getState) {
        var _getState$reel3 = getState().reel,
            oldCanvas = _getState$reel3.canvas,
            oldFrameType = _getState$reel3.frameType;

        dispatch({ type: ReelActionType.FRAME_CHANGE, frameType: frameType, oldFrameType: oldFrameType });

        var newCanvas = getState().reel.canvas;

        dispatch((0, _overlayActions.doAdjustOverlays)(newCanvas, oldCanvas));
    };
}

function changeFrameColor(frameColor) {
    return function (dispatch, getState) {
        dispatch({ type: ReelActionType.FRAME_COLOR_CHANGE, frameColor: frameColor });
    };
}

/**
 * 1. applies the audio to the project.
 * 2. logs `trackMusicAdded` with passed source.
 *
 * @param {string} audioId
 * @param {boolean} isWorkspaceAudio
 * @param {string} source
 */
function setAudio(audioId, isWorkspaceAudio, source) {
    return function (dispatch, getState) {
        dispatch((0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
            var _getState16 = getState(),
                _getState16$defaultAu = _getState16.defaultAudios.reel,
                defaultReelAudios = _getState16$defaultAu === undefined ? [] : _getState16$defaultAu,
                projectMedia = _getState16.projectMedia,
                workspaceAudios = _getState16.workspaceAudios,
                _getState16$reel$audi = _getState16.reel.audioClip,
                audioClip = _getState16$reel$audi === undefined ? null : _getState16$reel$audi,
                audioTrimModalUIState = _getState16.ui.audioTrimModalUIState;

            if (!audioClip || audioId != audioClip.clipAudioId) {
                dispatch(openAudioTrimModal());
            } else {
                dispatch(closeAudoTrimModal());
            }

            var audioData = null;
            if (isWorkspaceAudio) {
                var audio = projectMedia.find(function (m) {
                    return m.mediaType === 'audio' && m.id === audioId;
                });
                if (audio) {
                    audioData = audio.audioData;
                } else {
                    audioData = workspaceAudios.find(function (audio) {
                        return audio.id === audioId;
                    });
                }
            } else {
                audioData = defaultReelAudios.find(function (a) {
                    return a.id === audioId;
                });
            }

            var newAudioClip = (0, _ReelHelpers.createNewAudioClip)(audioData, false);

            dispatch({
                type: ReelActionType.AUDIO_CLIP_SET,
                audioClip: newAudioClip
            });
            dispatch(modeActions.openAudioProperties());
            dispatch(modeActions.closeProjectProperties());
            dispatch((0, _logActions.trackMusicAdded)(source));
            dispatch((0, _onboardingActions.completeOnboardingStep)('ADD_MUSIC_TRACK', false));
            if (window.isNoSignupEditor) {
                dispatch((0, _onboardingActions.completeOnboardingStep)('ADD_MUSIC'));
            }
        }));
    };
}

function switchAudioLooping(flag) {
    return function (dispatch, getState) {
        var _getState17 = getState(),
            _getState17$reel$audi = _getState17.reel.audioClip,
            audioClip = _getState17$reel$audi === undefined ? null : _getState17$reel$audi;

        dispatch({
            type: ReelActionType.AUDIO_CLIP_SWITCH_LOOPING,
            audioClip: _extends({}, audioClip, { clipLooping: flag })
        });
    };
}

function openAudioTrimModal() {
    return { type: AudioTrimModalActionType.OPEN };
}

function closeAudoTrimModal() {
    return { type: AudioTrimModalActionType.CLOSED };
}

function trimAudio(start, end) {
    return function (dispatch, getState) {
        var _getState18 = getState(),
            audioClip = _getState18.reel.audioClip;

        var newAudioClip = _extends({}, audioClip, { trimStart: start });
        dispatch({ type: ReelActionType.AUDIO_CLIP_TRIM, audioClip: newAudioClip });
    };
}

function clearAudio() {
    return { type: ReelActionType.AUDIO_CLIP_CLEAR };
}

function setAudioVolume(volume) {
    volume = Math.min(1, Math.max(0, volume));

    return { type: ReelActionType.AUDIO_CLIP_VOLUME_SET, volume: volume };
}

function setVideoVolume(volume) {
    volume = Math.min(1, Math.max(0, volume));

    return { type: ReelActionType.VIDEO_VOLUME_SET, volume: volume };
}

function setVideoSpeedInnerClip(_ref23) {
    var clipId = _ref23.clipId,
        speed = _ref23.speed,
        sequenceInnerClipId = _ref23.sequenceInnerClipId;

    return function (dispatch, getState) {
        var state = getState();
        var currentTime = state.player.time;

        var clipsObject = (0, _reelSelectors.getClipsObjects)(state);

        var clip = clipsObject[clipId];

        if (!sequenceInnerClipId || !clip || !clip.childClips) {
            return;
        }

        var _fixTimelineGap = (0, _ReelHelpers.fixTimelineGap)(clip.childClips, 0, function (c) {
            if (c.clipId === sequenceInnerClipId) {
                return _extends({}, c, {
                    speed: speed
                });
            }
            return c;
        }),
            newChildClips = _fixTimelineGap.fixedClips;

        var newDuration = (0, _ReelHelpers.getReelDuration)(newChildClips);

        var _clip$time4 = clip.time,
            currentOffset = _clip$time4.currentOffset,
            prevOffset = _clip$time4.prevOffset,
            enterStart = _clip$time4.enterStart;

        var index = clip.index,
            oldClip = _objectWithoutProperties(clip, ['index']);

        var currentFraction = Math.max((currentTime - enterStart) / (clip.clipDuration / clip.speed), 0);

        var newClip = _extends({}, oldClip, {
            childClips: newChildClips,
            clipDuration: newDuration,
            time: {
                enterStart: Math.floor(enterStart),
                enterDone: Math.floor(enterStart),
                exitStart: Math.floor(enterStart + newDuration),
                exitDone: Math.floor(enterStart + newDuration),
                currentOffset: currentOffset,
                prevOffset: prevOffset
            }
        });
        dispatch([(0, _guardActions.guardOverlayUpdates)(true, 500), { type: ReelActionType.COMPOSITE_CLIP_DURATION_UPDATE, newClip: newClip, oldClip: oldClip }, (0, _playerActions.seek)(newClip.time.enterStart + (newClip.time.exitDone - newClip.time.enterStart) * currentFraction, true)]);
    };
}

function setVideoSpeed(clipId, speed, isManual) {
    var sequenceInnerClipId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return function (dispatch, getState) {
        var state = getState();
        var currentTime = state.player.time;

        var clipsObject = (0, _reelSelectors.getClipsObjects)(state);

        var clip = clipsObject[clipId];

        if (sequenceInnerClipId && clip.childClips) {
            return dispatch(setVideoSpeedInnerClip({ clipId: clipId, speed: speed, sequenceInnerClipId: sequenceInnerClipId }));
        }

        var oldSpeed = clip.speed;
        var oldIsManual = clip.isSpeedManual;

        var _clip$time5 = clip.time,
            exitDone = _clip$time5.exitDone,
            _clip$time5$prevOffse = _clip$time5.prevOffset,
            prevOffset = _clip$time5$prevOffse === undefined ? 0 : _clip$time5$prevOffse,
            enterStart = _clip$time5.enterStart;

        var afterTime = exitDone + prevOffset;
        var adjustment = clip.clipDuration / speed - clip.clipDuration / oldSpeed; // change in duration

        var currentFraction = Math.max((currentTime - enterStart) / (clip.clipDuration / oldSpeed), 0);

        dispatch((0, _guardActions.guardOverlayUpdates)(true, 500));
        dispatch((0, _overlayActions.adjustOverlayTimeline)(afterTime, adjustment));
        dispatch({
            type: ReelActionType.VIDEO_SET_SPEED,
            clipId: clipId,
            speed: speed,
            isManual: isManual,
            oldSpeed: oldSpeed,
            oldIsManual: oldIsManual,
            sequenceInnerClipId: sequenceInnerClipId
        });
        var newClipsObject = (0, _reelSelectors.getClipsObjects)(state);
        var newClip = newClipsObject[clipId];
        var _newClip$time = newClip.time,
            newExitDone = _newClip$time.exitDone,
            newEnterStart = _newClip$time.enterStart;

        dispatch((0, _playerActions.seek)(newEnterStart + (newExitDone - newEnterStart) * currentFraction, true));
    };
}

function setClipAnimTypeForSequenceInnerClip(clipId, animType, sequenceInnerClipId) {
    return function (dispatch, getState) {
        var state = getState();

        var clips = state.reel.clips;

        var clip = clips.find(function (cc) {
            return cc.clipId === clipId;
        });

        if (clip && clip.childClips) {
            var shouldUpdate = true;
            var newChildClips = clip.childClips.map(function (clip) {
                if (clip.clipId === sequenceInnerClipId) {
                    if (clip.clipAnimType === animType) {
                        shouldUpdate = false;
                        return clip;
                    }

                    return _extends({}, clip, {
                        clipAnimType: animType
                    });
                }
                return clip;
            });

            var newClip = _extends({}, clip, {
                childClips: newChildClips
            });

            if (shouldUpdate) {
                dispatch({
                    type: ReelActionType.COMPOSITE_CLIP_UPDATE,
                    newClip: newClip,
                    oldClip: clip
                });
            }
        }
    };
}

function setClipAnimType(clipId, animType, sequenceInnerClipId) {
    return function (dispatch, getState) {
        var oldAnimType = getState().reel.clips.find(function (c) {
            return c.clipId === clipId;
        }).clipAnimType;

        if (sequenceInnerClipId) {
            return dispatch(setClipAnimTypeForSequenceInnerClip(clipId, animType, sequenceInnerClipId));
        }

        dispatch({
            type: ReelActionType.CLIP_SET_ANIMTYPE,
            clipId: clipId,
            animType: animType,
            oldAnimType: oldAnimType
        });

        (0, _TrackUtils.trackOnPostHog)('Clip Animation Change', { animType: animType });
    };
}

function addColor(color) {
    var forType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'project';

    addToRecentColors(color);

    if (forType === 'project') {
        return addProjectColor(color);
    }
    if (forType === 'brand') {
        return addBrandColor(color);
    }
}

function addProjectColor(color) {
    return function (dispatch, getState) {
        dispatch({ type: ReelActionType.ADD_PROJECT_COLOR, color: color });
    };
}

function addBrandColor(color) {
    return function (dispatch, getState) {
        var _getState19 = getState(),
            _getState19$brandColo = _getState19.brandColors,
            brandColors = _getState19$brandColo === undefined ? [] : _getState19$brandColo,
            activeWorkspace = _getState19.workspaceInfo.activeWorkspace;

        var workspaceId = activeWorkspace.workspaceId;

        if (brandColors.indexOf(color) === -1) {
            return (0, _workspaceApi.addBrandColorP)(color).then(function () {
                // Do nothing
                dispatch({ type: ReelActionType.ADD_BRAND_COLOR, color: color });

                (0, _TrackUtils.trackOnPostHog)('Brand color added', {
                    workspaceId: workspaceId,
                    color: color
                });
            }).catch(function (err) {
                console.log('Could not add brand color');
                console.error(err);
            });
        }
    };
}

function addToRecentColors(color) {
    var recentColors = [];

    var recentColorsCookie = window.getCookie('recentColors');
    if (recentColorsCookie) {
        recentColors = JSON.parse(recentColorsCookie);
    }

    if (!recentColors.includes(color.toUpperCase())) {
        recentColors.unshift(color);
        recentColors = recentColors.slice(0, 10); // limit to 10 colors

        window.setCookie('recentColors', JSON.stringify(recentColors));
    }
}

function setVolumeMode(volumeMode) {
    return function (dispatch, getState) {
        dispatch({ type: ActionTypes.REEL_VOLUME_MODE_SET, volumeMode: volumeMode });

        // if(volumeMode == 'project') {
        //     dispatch(unselectAllClips())
        // } else {
        //     dispatch(selectClip())
        // }
    };
}

function setClipVolume() {
    var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        clipId = _ref24.clipId,
        volume = _ref24.volume,
        _ref24$sequenceInnerC = _ref24.sequenceInnerClipId,
        sequenceInnerClipId = _ref24$sequenceInnerC === undefined ? null : _ref24$sequenceInnerC;

    return function (dispatch, getState) {
        if (sequenceInnerClipId) {
            return dispatch(updateVolumeForInnerClip({
                clipId: clipId,
                sequenceInnerClipId: sequenceInnerClipId,
                volume: volume
            }));
        }
        dispatch({ type: ActionTypes.REEL_CLIP_VOLUME_SET, clipId: clipId, volume: volume });
    };
}

function setMusicVolume(clipId, volume) {
    return { type: ActionTypes.REEL_CLIP_MUSIC_VOLUME_SET, clipId: clipId, volume: volume };
}

function startCroppingClip(clipId, clipBox) {
    return { type: ActionTypes.REEL_CLIP_BOX_EDIT_START, clipId: clipId, clipBox: clipBox };
}

/**
 * Restritcts the user to create extremely large offsets that breaks the
 * ZoomPan temporary fix
 *
 * @param {*} {currentClip , newClipBox , canvas , frameType , customFormat}
 * @return {*}
 */
function restrictUpdateCrop4Clip(_ref25) {
    var currentClip = _ref25.currentClip,
        clipBox = _ref25.clipBox,
        canvas = _ref25.canvas,
        frameType = _ref25.frameType,
        customFormat = _ref25.customFormat;

    if (currentClip.clipType !== _MediaConstants.SupportedReelClipTypes.image || currentClip.clipAnimType === 'NONE') return false;

    var contentBox = (0, _ReelHelpers.getContentBox)({
        frameType: frameType,
        canvas: canvas,
        customFormat: customFormat
    });

    // below logic ripped straight out from the behind the show
    // Look into render logic you will know, not including detailas  for the prying eyes of malicious users

    var _computeClipBoxRender = (0, _ReelUtils.computeClipBoxRenderParams)(1, clipBox, contentBox),
        crop = _computeClipBoxRender.crop,
        dest = _computeClipBoxRender.dest,
        errCrop = _computeClipBoxRender.errCrop;

    // when there is an offset for normal viewports without letterboxes


    if (crop.width + crop.left > dest.width || crop.height + crop.top > dest.height || errCrop.errcl !== 0 || errCrop.errct !== 0) {
        return true;
    }
    return false;
}

function updateCroppingClip(clipBox) {
    return function (dispatch, getState) {
        var _getState20 = getState(),
            editingClipId = _getState20.clipBoxEditorData.editingClipId,
            customFormats = _getState20.customFormats;

        var _getState$reel4 = getState().reel,
            clips = _getState$reel4.clips,
            canvas = _getState$reel4.canvas,
            frameType = _getState$reel4.frameType,
            formatId = _getState$reel4.formatId;

        var index = clips.findIndex(function (v) {
            return v.clipId === editingClipId;
        });
        var currentClip = clips[index];

        var customFormat = customFormats.formats.find(function (i) {
            return i.id === formatId;
        });

        restrictUpdateCrop4Clip({ currentClip: currentClip, clipBox: clipBox, canvas: canvas, frameType: frameType, customFormat: customFormat }) ? null : dispatch({
            type: ActionTypes.REEL_CLIP_BOX_EDIT_UPDATE,
            clipId: editingClipId,
            clipBox: clipBox
        });
    };
}

function updateRotateClip(_ref26) {
    var rotateDeg = _ref26.rotateDeg,
        isCustom = _ref26.isCustom,
        _ref26$sequenceInnerC = _ref26.sequenceInnerClipId,
        sequenceInnerClipId = _ref26$sequenceInnerC === undefined ? null : _ref26$sequenceInnerC;

    return function (dispatch, getState) {
        var state = getState();

        var editingClip = (0, _reelSelectors.getCurrentClipSelected)(state);
        if (sequenceInnerClipId) {
            return dispatch(updateRotateForInnerClip({ editingClip: editingClip, sequenceInnerClipId: sequenceInnerClipId, rotateDeg: rotateDeg }));
        }

        if (!state.clipBoxEditorData.editingClipId) {
            dispatch(cropCurrentClip());
            state = getState();
        }

        var _state = state,
            _state$reel3 = _state.reel,
            canvas = _state$reel3.canvas,
            frameType = _state$reel3.frameType,
            formatId = _state$reel3.formatId,
            customFormats = _state.customFormats,
            clipBox = _state.clipBoxEditorData.clipBox;

        var customFormat = customFormats.formats.find(function (i) {
            return i.id === formatId;
        });

        var _calcRotatedClipBox = (0, _ReelHelpers.calcRotatedClipBox)(rotateDeg, editingClip, frameType, canvas, customFormat),
            height = _calcRotatedClipBox.height,
            width = _calcRotatedClipBox.width,
            x = _calcRotatedClipBox.x,
            y = _calcRotatedClipBox.y;

        var newClipBox = _extends({}, clipBox, {
            height: height,
            width: width,
            x: x,
            y: y,
            rotateDeg: rotateDeg,
            isRotateManual: isCustom
        });

        dispatch({
            type: ActionTypes.REEL_CLIP_BOX_EDIT_UPDATE,
            clipId: editingClip.clipId,
            clipBox: newClipBox
        });
        dispatch(finishCroppingClip());
    };
}

function finishCroppingClip() {
    return function (dispatch, getState) {
        var _getState$clipBoxEdit = getState().clipBoxEditorData,
            clipBox = _getState$clipBoxEdit.clipBox,
            editingClipId = _getState$clipBoxEdit.editingClipId;

        var oldClipBox = getState().reel.clips.find(function (c) {
            return c.clipId == editingClipId;
        }).clipBox;

        if (oldClipBox.rotateDeg !== clipBox.rotateDeg) {
            var rotateDeg = clipBox.rotateDeg,
                isRotateManual = clipBox.isRotateManual;

            (0, _TrackUtils.trackOnPostHog)('Reel action', {
                actionType: 'rotate',
                isMediaRotated: true,
                DegreeValue: rotateDeg,
                usedCustomAngle: isRotateManual
            });
        }

        dispatch({
            type: ActionTypes.REEL_CLIP_BOX_EDIT_COMMIT,
            clipId: editingClipId,
            clipBox: clipBox,
            oldClipBox: oldClipBox
        });
    };
}

function undoCroppingClip(editingClipId, clipBox) {
    return function (dispatch, getState) {
        var oldClipBox = getState().reel.clips.find(function (c) {
            return c.clipId == editingClipId;
        }).clipBox;
        dispatch({
            type: ActionTypes.REEL_CLIP_BOX_EDIT_COMMIT,
            clipId: editingClipId,
            clipBox: clipBox,
            oldClipBox: oldClipBox
        });
    };
}

function cancelCroppingClip() {
    return function (dispatch, getState) {
        var editingClipId = getState().clipBoxEditorData.editingClipId;

        if (editingClipId) dispatch({ type: ActionTypes.REEL_CLIP_BOX_EDIT_CANCEL, clipId: editingClipId });
    };
}

function setVideoDurationLimit(enable) {
    return function (dispatch, getState) {
        var _getState21 = getState(),
            _getState21$reel$vide = _getState21.reel.videoDurationLimit,
            videoDurationLimit = _getState21$reel$vide === undefined ? -1 : _getState21$reel$vide;

        dispatch({ type: ActionTypes.REEL_VIDEO_DURATION_LIMIT_SET, enable: enable, videoDurationLimit: videoDurationLimit });
    };
}

function setTransition(transitionType, leftClipId, rightClipId) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { adjustOverlayTime: true, refreshClipTimes: true };

    return function (dispatch, getState) {
        var state = getState();
        var clipsObj = (0, _reelSelectors.getClipsObjects)(state);
        var leftClip = clipsObj[leftClipId];
        var rightClip = clipsObj[rightClipId];

        if (leftClip && rightClip) {
            var _ref27 = leftClip.transitions || {},
                _ref27$exit = _ref27.exit;

            _ref27$exit = _ref27$exit === undefined ? {} : _ref27$exit;
            var _ref27$exit$transitio = _ref27$exit.transitionType,
                oldTransitionType = _ref27$exit$transitio === undefined ? 'NONE' : _ref27$exit$transitio; // fix for when leftClip is null i.e first clip

            var _ref28 = rightClip.time || {},
                enterStart = _ref28.enterStart,
                _ref28$prevOffset = _ref28.prevOffset,
                prevOffset = _ref28$prevOffset === undefined ? 0 : _ref28$prevOffset,
                _ref28$currentOffset = _ref28.currentOffset,
                oldOffset = _ref28$currentOffset === undefined ? 0 : _ref28$currentOffset;

            (0, _reactRedux.batch)(function () {
                dispatch({
                    type: ReelActionType.SET_TRANSITION,
                    transitionType: transitionType,
                    leftClipId: leftClipId,
                    rightClipId: rightClipId,
                    oldTransitionType: oldTransitionType
                });

                dispatch((0, _logActions.trackTransitionAction)(transitionType, oldTransitionType));

                if (options.refreshClipTimes) {
                    dispatch({ type: ReelActionType.REFRESH_CLIP_TIMES });
                }

                if (options.adjustOverlayTime) {
                    var newRightClip = getState().reel.clips.find(function (c) {
                        return c.clipId === rightClipId;
                    });

                    var _ref29 = newRightClip.time || {},
                        _ref29$currentOffset = _ref29.currentOffset,
                        newOffset = _ref29$currentOffset === undefined ? 0 : _ref29$currentOffset;

                    var afterTime = enterStart + prevOffset;
                    var adjustment = newOffset - oldOffset;

                    dispatch((0, _overlayActions.adjustOverlayTimeline)(afterTime, adjustment));
                }
            });
        }
    };
}

function updateVolumeForInnerClip(_ref30) {
    var clipId = _ref30.clipId,
        sequenceInnerClipId = _ref30.sequenceInnerClipId,
        volume = _ref30.volume;

    return function (dispatch, getState) {
        var state = getState();

        var clips = state.reel.clips;

        var clip = clips.find(function (c) {
            return c.clipId === clipId;
        });
        if (clip && clip.childClips) {
            var shouldUpdate = false;
            var newChildClips = clip.childClips.map(function (clip) {
                if (clip.clipId === sequenceInnerClipId) {
                    if (clip.clipVolume === volume) {
                        return clip;
                    }
                    shouldUpdate = true;

                    return _extends({}, clip, {
                        clipVolume: volume
                    });
                }
                return clip;
            });

            var newClip = _extends({}, clip, {
                childClips: newChildClips
            });
            if (shouldUpdate) {
                dispatch({
                    type: ReelActionType.COMPOSITE_CLIP_UPDATE,
                    newClip: newClip,
                    oldClip: clip
                });
            }
        }
    };
}

function updateRotateForInnerClip(_ref31) {
    var editingClip = _ref31.editingClip,
        sequenceInnerClipId = _ref31.sequenceInnerClipId,
        rotateDeg = _ref31.rotateDeg;

    return function (dispatch, getState) {
        var _getState22 = getState(),
            _getState22$reel = _getState22.reel,
            clips = _getState22$reel.clips,
            canvas = _getState22$reel.canvas,
            frameType = _getState22$reel.frameType,
            formatId = _getState22$reel.formatId,
            customFormats = _getState22.customFormats;

        var customFormat = customFormats.formats.find(function (i) {
            return i.id === formatId;
        });
        var childClips = editingClip.childClips.map(function (clip) {
            if (clip.clipId === sequenceInnerClipId) {
                var _calcRotatedClipBox2 = (0, _ReelHelpers.calcRotatedClipBox)(rotateDeg, clip, frameType, canvas, customFormat),
                    height = _calcRotatedClipBox2.height,
                    width = _calcRotatedClipBox2.width,
                    x = _calcRotatedClipBox2.x,
                    y = _calcRotatedClipBox2.y;

                var newClipBox = _extends({}, clip.clipBox, {
                    height: height,
                    width: width,
                    x: x,
                    y: y,
                    rotateDeg: rotateDeg
                });
                clip.clipBox = newClipBox;
                return clip;
            }
            return clip;
        });

        var newClip = _extends({}, editingClip, {
            childClips: childClips
        });

        dispatch({
            type: ReelActionType.COMPOSITE_CLIP_UPDATE,
            newClip: newClip,
            oldClip: editingClip
        });
    };
}

function showTransitionButtons(enable) {
    return function (dispatch, getState) {
        dispatch({ type: ActionTypes.REEL_SHOW_TRANSITION_BUTTONS, enable: enable });
    };
}

function setSyncMediaAndText(enable) {
    return function (dispatch, getState) {
        dispatch({ type: ActionTypes.REEL_SYNC_MEDIA_AND_TEXT, enable: enable });
    };
}

function replaceClip(deletingClips, replacingClips) {
    return { type: ReelActionType.CLIP_REPLACE, deletingClips: deletingClips, replacingClips: replacingClips };
}

function showWatermark() {
    return function (dispatch, getState) {
        dispatch((0, _overlayActions.addWatermarkOverlay)());
        dispatch({ type: ReelActionType.SHOW_WATERMARK });
    };
}

var redirectToAccountPage = function redirectToAccountPage() {
    window.location.assign('/account');
};
var upgradeProjectAndProceed = function upgradeProjectAndProceed(state, dispatch, onSuccess) {
    var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
    var containsWatermark = state.project.containsWatermark;

    var _getPlanInfo = (0, _miscSelectors.getPlanInfo)(state),
        subscriptionPaymentFailed = _getPlanInfo.subscriptionPaymentFailed,
        videosLeft = _getPlanInfo.subscriptionVideosLeft;

    if (!containsWatermark) onSuccess();else if (subscriptionPaymentFailed) {
        redirectToAccountPage();
    } else if (videosLeft > 0) {
        // for edit page
        var activeWorkspace = state.workspaceInfo.activeWorkspace;

        var canProduceVideo = activeWorkspace && (activeWorkspace.role === 'ADMIN' || activeWorkspace.role === 'PRODUCER');

        if (!canProduceVideo) dispatch((0, _exportActions.openRequestRoleChangeModal)());

        (0, _ExportPageApi.checkoutProjectUsingSubscriptionP)(state.project.id).then(function (result) {
            if (result.success) {
                var status = result.status;
                // dispatch

                if (status === 'checkout_success' || status === 'already_paid') {
                    dispatch((0, _projectActions.markRemovedProjectWatermark)());
                    dispatch((0, _pricingActions.fetchAndUpdateAccountData)());
                    onSuccess();
                    // dispatch(projectActions)
                    // dispatch(deleteWatermarkOverlay())
                    // dispatch({ type: ReelActionType.HIDE_WATERMARK })
                } else if (status === 'subscription_payment_failure' || status === 'exhausted_videos' || status === 'no_subscription_found') {
                    onError(status);
                } else {
                    onError('Unknown subscription status');
                }
            } else {
                var errorCode = result.errorCode;
                // dispatch

                onError(errorCode);
            }
        });
    } else {
        onError();
    }
};

function hideWatermark() {
    return function (dispatch, getState) {
        var state = getState();

        upgradeProjectAndProceed(state, dispatch, function () {
            dispatch((0, _overlayActions.deleteWatermarkOverlay)());
            dispatch({ type: ReelActionType.HIDE_WATERMARK });
        });
    };
}

function replaceWatermark() {
    return function (dispatch, getState) {
        var state = getState();

        upgradeProjectAndProceed(state, dispatch, function () {
            dispatch((0, _projectActions.markRemovedProjectWatermark)());
            dispatch((0, _overlayActions.replaceWatermarkOverlay)());
        });
    };
}

function watermarkReplaced() {
    return { type: ReelActionType.WATERMARK_REPLACED };
}

function watermarkDeleted() {
    return { type: ReelActionType.WATERMARK_DELETED };
}

function defaultWatermarkAdded() {
    return { type: ReelActionType.DEFAULT_WATERMARK_ADDED };
}

function clickOutSideReelArea() {
    return function (dispatch, getState) {
        dispatch([(0, _overlayActions.disableOverlayMovement)(false), unselectAllClips(), (0, _overlayActions.selectClear)(), cancelCroppingClip()]);
    };
}

},{"../../../../constants/MediaConstants":309,"../../account/accountApis":1,"../../common/api/workspaceApi":6,"../../common/constants/SolidImage":66,"../../common/utils/CommonAlgorithms":72,"../../common/utils/ReelHelpers":85,"../../common/utils/TrackUtils":90,"../../common/utils/enums/EditorMode":94,"../../common/utils/enums/TransitionType":98,"../../common/utils/players/PlayerRegistry":114,"../../common/utils/scheduler/polyfill":126,"../../export/actions/exportActions":246,"../../export/apis/ExportPageApi":249,"../../pricing/actions/pricingActions":265,"../constants/General":203,"../constants/PropertiesPanelType":206,"../constants/TransitionType":209,"../selectors/miscSelectors":215,"../selectors/reelSelectors":221,"../selectors/sequenceSelectors":223,"../utils/ReelUtils":233,"./ActionTypes":153,"./deleteWarningActions":154,"./emptyProjectActions":155,"./guardActions":157,"./logActions":160,"./mediaActions":161,"./modeActions":162,"./notificationSystemAction":163,"./onboardingActions":164,"./overlayActions":165,"./playerActions":166,"./projectActions":168,"./sequenceActions":171,"./subtitleActions":173,"./uiActions":174,"cloneextend":412,"deepmerge":549,"keymirror":677,"react-redux":1079,"shortid":1163,"underscore":1206}],171:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSequence = exports.sequenceDataMaptoMedia = exports.SequenceActionType = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.saveSequence = saveSequence;
exports.trackProcessingForSequencePreviews = trackProcessingForSequencePreviews;
exports.loadSequences = loadSequences;
exports.deleteSequence = deleteSequence;
exports.addSequence2ReelAndOverlay = addSequence2ReelAndOverlay;
exports.addStockSequenceToReelAndOverlay = addStockSequenceToReelAndOverlay;
exports.breakApartSequence = breakApartSequence;
exports.applySequence2Timeline = applySequence2Timeline;
exports.trackVideoTemplatePlayed = trackVideoTemplatePlayed;
exports.openSequenceCreateModal = openSequenceCreateModal;
exports.closeSequenceCreateModal = closeSequenceCreateModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _ProcessingTracker = require('../utils/ProcessingTracker');

var _ProcessingTracker2 = _interopRequireDefault(_ProcessingTracker);

var _api = require('../api');

var _sequenceSelectors = require('../selectors/sequenceSelectors');

var _reelActions = require('./reelActions');

var _sequeceDataSelectors = require('../selectors/sequeceDataSelectors');

var _overlayActions = require('./overlayActions');

var _ModelDataUtils = require('../../common/utils/ModelDataUtils');

var _modeActions = require('./modeActions');

var modeActions = _interopRequireWildcard(_modeActions);

var _PropertiesPanelType = require('../constants/PropertiesPanelType');

var _PropertiesPanelType2 = _interopRequireDefault(_PropertiesPanelType);

var _reelSelectors = require('../selectors/reelSelectors');

var _ReelHelpers = require('../../common/utils/ReelHelpers');

var _sequenceTracker = require('../../common/trackers/sequenceTracker');

var sequenceTracker = _interopRequireWildcard(_sequenceTracker);

var _leftShelf = require('./leftShelf');

var _errorReporting = require('../../common/utils/errorReporting');

var _General = require('../constants/General');

var _onboardingActions = require('./onboardingActions');

var _miscSelectors = require('../selectors/miscSelectors');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var _require = require('../../common/constants/SolidImage'),
    SolidImageId = _require.SolidImageId,
    SolidImageData = _require.SolidImageData;

var emptyFunc = function emptyFunc() {};

var SequenceActionType = exports.SequenceActionType = (0, _keymirror2.default)({
    ADD_SEQUENCES: null,
    PREVIEW_READY: null,
    REMOVE_SEQUENCES: null,
    CLEAR_SEQUENCES: null,
    HIGHLIGHT_SEQUENCE: null,
    UPDATE_STOCK_SEQUENCE: null,
    UPDATE_ADDING_STATE: null,

    OPEN_SEQUENCE_CREATE_MODAL: null,
    CLOSE_SEQUENCE_CREATE_MODAL: null,

    OPEN_FITNESS_SEQUENCE_CREATE_MODAL: null,
    CLOSE_FITNESS_SEQUENCE_CREATE_MODAL: null,

    ADD_SEQUENCE_ENTITIES: null, // Unifying event for ADDING MULTIPLE SEQUENCE ENTITY
    REMOVE_SEQUENCE_ENTITIES: null, // Unifying event for REMOVING MULTIPLE SEQUENCE ENTITY
    REPLACE_SEQUENCE_ENTITIES: null, // Unifying event for REPLACING SEQUENCE with SINGLE OR MULTIPLE CLIP
    REPLACE_CLIP_BY_SEQUENCE_ENTITIES: null, // Unifying event for REPLACING CLIP
    BREAK_APART: null,
    APPLY_SEQUENCE: null
});

var sequenceDataMaptoMedia = exports.sequenceDataMaptoMedia = function sequenceDataMaptoMedia(s) {
    s.mediaType = 'sequence';
    var _s$sequenceData$canva = s.sequenceData.canvas,
        height = _s$sequenceData$canva.height,
        width = _s$sequenceData$canva.width;

    s.height = height || 1080;
    s.width = width || 1920;
    s.createdTime = s.createdAt || Date.now();
    s.originalFileName = s.name || '';
    s.type = 'sequence';
    return s;
};

/**
 * Create a new sequence and add to saved sequences
 *
 * @param {{
 * sequenceData: {
 *      clips: Array<>,
 *      overlays: Array<>,
 *      canvas: {height: number, width: number},
 *      overlayMeta: Object,
 *      sequenceMetaData: Object},
 * name: string,
 * onSuccess: Function,
 * onError: Function,
 * showSavedSequence: boolean,
 * }}
 * @returns {*}
 */
function saveSequence(_ref) {
    var sequenceData = _ref.sequenceData,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name,
        _ref$onSuccess = _ref.onSuccess,
        onSuccess = _ref$onSuccess === undefined ? emptyFunc : _ref$onSuccess,
        _ref$onError = _ref.onError,
        onError = _ref$onError === undefined ? emptyFunc : _ref$onError,
        _ref$showSavedSequenc = _ref.showSavedSequence,
        showSavedSequence = _ref$showSavedSequenc === undefined ? true : _ref$showSavedSequenc;

    return function (dispatch, getState) {
        var _getState = getState(),
            projectId = _getState.project.id;

        if (window.appManager.isDemoMode()) {
            // In demo mode don't use API call, just add the sequence to state

            var sequence = {
                name: name,
                sequenceData: sequenceData,
                id: (0, _shortid2.default)(),
                thumbUrl: null,
                previewUrl: null
            };

            dispatch({
                type: SequenceActionType.ADD_SEQUENCES,
                sequences: [sequence]
            });

            if (showSavedSequence) dispatch(highlightSequence(sequence.id));

            onSuccess(sequence);
        } else {
            (0, _api.saveWorkspaceSequenceP)(projectId, sequenceData, name).then(function (sequence) {
                dispatch({
                    type: SequenceActionType.ADD_SEQUENCES,
                    sequences: [sequenceDataMaptoMedia(sequence)]
                });
                dispatch(trackProcessingForSequencePreviews(sequence));

                if (showSavedSequence) dispatch(highlightSequence(sequence.id));
                onSuccess(sequence);
            }).catch(function (err) {
                console.log(err);
                onError(err);
            });
        }
    };
}

function trackProcessingForSequencePreviews(sequenceData) {
    return function (dispatch, getState) {
        if (window.appManager.isDemoMode()) {
            return;
        }

        if ((0, _ModelDataUtils.isSequencePreviewReady)(sequenceData)) {
            return;
        }

        var processingTracker = new _ProcessingTracker2.default('SEQUENCE', sequenceData.id);

        processingTracker.onData(function (sequenceData) {
            if ((0, _ModelDataUtils.isSequencePreviewReady)(sequenceData)) {
                dispatch({ type: SequenceActionType.PREVIEW_READY, sequenceData: sequenceData });
                processingTracker.stopTracking();
            }
        }).startTracking();
    };
}

function highlightSequence(seqId) {
    return function (dispatch, getState) {
        dispatch(modeActions.changeSidebarSection(_General.Sections.VIDEOS.id, true));
        dispatch({ type: SequenceActionType.HIGHLIGHT_SEQUENCE, sequenceId: seqId });
        dispatch((0, _leftShelf.scrollToSequence)(1000));
        setTimeout(function () {
            dispatch({ type: SequenceActionType.HIGHLIGHT_SEQUENCE, sequenceId: null });
        }, 3000);
    };
}

function loadSequences() {
    var mapFunc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (data) {
        return data;
    };

    return function (dispatch, getState) {
        (0, _api.getWorkspaceSequencesP)().then(function (sequences) {
            dispatch({ type: SequenceActionType.CLEAR_SEQUENCES });

            var seqData = sequences.map(mapFunc);

            dispatch({
                type: SequenceActionType.ADD_SEQUENCES,
                sequences: seqData
            });
        }).catch(function (err) {
            console.log(err);
        });
    };
}

function deleteSequence(sequenceId) {
    return function (dispatch, getState) {
        (0, _api.deleteWorkspaceSequenceP)(sequenceId).then(function () {
            dispatch({
                type: SequenceActionType.REMOVE_SEQUENCES,
                sequenceIds: [sequenceId]
            });
        }).catch(function (err) {
            console.log(err);
        });
    };
}

var getSequenceClips = (0, _sequenceSelectors.makeGetSequenceClips)();
var getSequenceOverlays = (0, _sequenceSelectors.makeGetSequenceOverlays)();

var MIN_CLIP_DURATION = 500;

function createSequence(start, duration) {
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var overlays = arguments[3];
    var _onSuccess = arguments[4];
    var onError = arguments[5];
    var applyToTimeline = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

    return function (dispatch, getState) {
        var state = getState();

        start = Math.floor(start);
        duration = Math.floor(duration);

        var startTime = start;
        var sequenceDuration = duration;

        var totalPrevOffsetSum = 0;
        var sequenceClips = getSequenceClips(state, start, duration).map(function (c, index) {
            var replaceClip = {};

            var newEnterStart = c.time.enterStart;
            var newEnterDone = c.time.enterDone;
            var newExitStart = c.time.exitStart;
            var newExitDone = c.time.exitDone;

            if (newEnterStart < start) {
                newEnterStart = start;
                newEnterDone = start;

                if (newExitDone - newEnterStart < MIN_CLIP_DURATION) {
                    start -= newExitDone - newEnterStart;
                    return null;
                }
            }

            if (newExitDone > start + duration) {
                newExitDone = start + duration;
                newExitStart = start + duration;

                if (newExitDone - newEnterStart < MIN_CLIP_DURATION) {
                    duration -= newExitDone - newEnterStart;
                    return null;
                }
            }

            newExitStart = Math.min(newExitDone, Math.max(newExitStart, newEnterDone));
            newEnterDone = Math.max(newEnterStart, Math.min(newEnterDone, newExitStart));

            var prevOffset = totalPrevOffsetSum;
            var currentOffset = index === 0 ? 0 : Math.floor(c.time.currentOffset);
            totalPrevOffsetSum += currentOffset;

            var clipDuration = Math.floor((Math.floor(newExitDone - start) - Math.floor(newEnterStart - start)) * c.speed);

            var newClip = _extends({}, c, {
                clipDuration: clipDuration,
                time: _extends({}, c.time, {
                    enterStart: Math.floor(newEnterStart - start),
                    enterDone: Math.floor(newEnterDone - start),
                    exitStart: Math.floor(newExitStart - start),
                    exitDone: Math.floor(newExitDone - start),
                    currentOffset: Math.floor(currentOffset),
                    prevOffset: Math.floor(prevOffset)
                })
            });

            var replaceClipWithSolidImage = false;
            if (c.clipType === 'video') {
                if (c.clipVideo.deleted) {
                    replaceClipWithSolidImage = true;
                    delete newClip.clipVideo;
                } else {
                    var newClipStart = Math.floor(c.clipStart + (newEnterStart - c.time.enterStart));
                    newClip.clipStart = newClipStart;
                }
            } else if (c.clipType == 'image') {
                if (c.clipImage.deleted) {
                    replaceClipWithSolidImage = true;
                }
            }

            if (replaceClipWithSolidImage) {
                var enterTime = newEnterStart - start;

                replaceClip = {
                    clipType: 'image',
                    clipImageId: SolidImageId,
                    clipImage: SolidImageData,
                    solidImageColor: '#000',
                    hidePadding: true,
                    clipStart: 0,
                    musicVolume: 1,
                    speed: 1,
                    clipAnimType: 'NONE',
                    time: {
                        enterStart: Math.floor(enterTime),
                        enterDone: Math.floor(enterTime),
                        exitStart: Math.floor(enterTime + clipDuration),
                        exitDone: Math.floor(enterTime + clipDuration),
                        currentOffset: 0,
                        prevOffset: Math.floor(prevOffset)
                    },
                    transitions: {},
                    isSelected: false
                };

                newClip = _extends({}, newClip, replaceClip);
            }

            // delete unneeded values from clip (for the placeholder)
            delete newClip.thumbUrl;
            delete newClip.ptitle;
            delete newClip.pheight;
            delete newClip.pwidth;
            delete newClip.ptype;
            delete newClip.pMediaId;
            delete newClip.pduration;
            delete newClip.placeHolderError;

            return newClip;
        }).filter(function (c) {
            return c != null;
        });

        var sequenceOverlays = getSequenceOverlays(state, start, duration).filter(function (o) {
            return Object.keys(overlays).includes(o.id);
        });

        sequenceOverlays = sequenceOverlays.map(function (o) {
            if (o.isSubtitle) return null;

            var _o$values = o.values,
                oldValues = _o$values === undefined ? {} : _o$values;

            var newValues = _extends({}, oldValues);

            if (oldValues.imageId) {
                var _getImageUrlForId = getImageUrlForId(oldValues.imageId, 400, 400, true),
                    imgUrl = _getImageUrlForId.imgUrl,
                    isImgDeleted = _getImageUrlForId.deleted;

                if (isImgDeleted) {
                    newValues.imageId = 'placeholder';
                }
            }

            var newEnterStart = o.time.enterstart;
            var newEnterDone = o.time.enterdone;
            var newExitStart = o.time.exitstart;
            var newExitDone = o.time.exitdone;

            if (newEnterStart < start) {
                newEnterStart = start;
                newEnterDone = start;
            }

            if (newExitDone > start + duration) {
                newExitStart = start + duration;
                newExitDone = start + duration;
            }

            var newOverlayDuration = newExitDone - newEnterStart;
            if (newOverlayDuration < 500) return null;

            if (o.enterAnimationOnly) {
                newEnterDone = newExitDone;
                newExitStart = newExitDone;
            }

            return _extends({}, o, {
                values: newValues,
                time: _extends({}, o.time, {
                    enterstart: newEnterStart - start,
                    enterdone: newEnterDone - start,
                    exitstart: newExitStart - start,
                    exitdone: newExitDone - start
                })
            });
        }).filter(function (o) {
            return !!o;
        });

        var deletableOverlayIds = sequenceOverlays.map(function (o) {
            return o.id;
        });

        var sequenceOverlayIds = Object.values(overlays).map(function (o) {
            return o.id;
        });
        var overlaymeta = state.overlaymeta;

        var newOverlayMeta = void 0;

        if (!!overlaymeta && !!overlaymeta.animgroups) {
            var animgroups = overlaymeta.animgroups;

            var newAnimGroups = animgroups.map(function (animgroupItem) {
                var id = animgroupItem.id;
                var kind = animgroupItem.kind;

                var members = [];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = animgroupItem.members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var oid = _step.value;

                        if (sequenceOverlayIds.includes(oid)) {
                            members.push(oid);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (members.length > 0) {
                    return {
                        id: id,
                        kind: kind,
                        members: members
                    };
                }

                return null;
            }).filter(function (animgroupItem) {
                return animgroupItem != null;
            });

            if (newAnimGroups.length > 0) {
                newOverlayMeta = {
                    animgroups: newAnimGroups
                };
            }
        }

        var sequenceData = {
            clips: sequenceClips,
            overlays: sequenceOverlays,
            canvas: state.reel.canvas,
            overlaymeta: newOverlayMeta
        };

        // dispatch(applySequence2Timeline({sequenceData , id: 'abc'} ,  startTime , sequenceDuration))

        return dispatch(saveSequence({
            sequenceData: sequenceData,
            name: name,
            onSuccess: function onSuccess() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (applyToTimeline) dispatch(applySequence2Timeline.apply(undefined, args.concat([start, duration, deletableOverlayIds])));
                _onSuccess.apply(undefined, args);
            },
            onError: onError
        }));
    };
}

/**
 * Adds provided sequence Id to the reel and add corresponding overlays to timeline
 * makes the time offsets correct and changes names to make them unique.
 *
 * @export
 * @param {string} sequenceId
 * @return {*}
 */
exports.createSequence = createSequence;
function addSequence2ReelAndOverlay(sequenceId) {
    var clipActionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reelActions.ClipActionType.ADD_CLIP_END;
    var insertClipId = arguments[2];

    return function (dispatch, getState) {
        var state = getState();
        var sequenceObject = (0, _sequeceDataSelectors.getSequenceObject)(state);
        var projectId = state.project.id,
            projectMedia = state.projectMedia,
            workspaceMedia = state.workspaceMedia,
            _state$localState$use = state.localState.userSpaceMedia,
            userSpaceMedia = _state$localState$use === undefined ? [] : _state$localState$use;

        var sequence = sequenceObject[sequenceId];
        var sequenceData = sequence.sequenceData;
        // console.log(`adding sequence id : ${sequenceId} :` , sequence , clipId)

        // TODO ADD MEDIA DATA TO PROJECT

        // OLDER ADDITION LOGIC

        // hydrate the child clips from project and workspace media

        var sequenceClips = sequenceData.clips.map(function (clip) {
            var clipId = clip.clipVideoId;
            var sourceDataKey = 'videoData';
            var clipDataKey = 'clipVideo';

            if (clip.clipType !== 'video') {
                clipId = clip.clipImageId;
                sourceDataKey = 'imageData';
                clipDataKey = 'clipImage';
            }
            var selectedMedia = null;

            if (!selectedMedia) {
                var data = userSpaceMedia.find(function (m) {
                    return m.id === clipId;
                });
                if (data) {
                    selectedMedia = {
                        id: data.id,
                        mediaType: data.mediaType
                    };
                    if (data.mediaType === 'video') {
                        selectedMedia.videoData = data;
                    } else if (data.mediaType === 'image') {
                        selectedMedia.imageData = data;
                    }
                }
            }
            if (!selectedMedia) {
                selectedMedia = projectMedia.find(function (m) {
                    return m.id === clipId;
                });
            }

            if (!selectedMedia) {
                selectedMedia = workspaceMedia.find(function (m) {
                    return m.id === clipId;
                });
            }

            if (selectedMedia) {
                return _extends({}, clip, _defineProperty({}, clipDataKey, selectedMedia[sourceDataKey]));
            }
            if (!selectedMedia) {
                if (clipId !== SolidImageId) {
                    clip[clipDataKey].deleted = true;
                }
            }
            return clip;
        });

        (0, _reactRedux.batch)(function () {
            dispatch((0, _reelActions.addNewCompositeClip)({
                clips: sequenceClips,
                sequenceId: sequenceId,
                sequenceName: sequence.name,
                actionType: clipActionType,
                insertClipId: insertClipId,
                getOverlayActionData: function getOverlayActionData(clip) {
                    var clipId = clip.clipId;

                    var startTime = clip.time.enterStart;
                    var maxDuration = clip.clipDuration;

                    var _createSequenceTempla = (0, _overlayActions.createSequenceTemplatesFromSequenceData)([sequenceData], [{ clipId: clipId, startTime: startTime, maxDuration: maxDuration, type: 'sequence' }], { state: state }),
                        allOverlays = _createSequenceTempla.allOverlays,
                        clipIdToOverlays = _createSequenceTempla.clipIdToOverlays;

                    var overlayActionData = (0, _overlayActions.addOverlayAction)(allOverlays, {
                        shouldSelectAll: false,
                        sequenceOverlayMetaEntries: clipIdToOverlays
                    });

                    return overlayActionData;
                },
                useBatch: true
            }));

            dispatch(modeActions.clearReplaceInsert());
        });

        sequenceTracker.trackSequenceUsed(projectId, sequenceId, sequenceTracker.sequenceTypes.USER_CREATED);
    };
}

/**
 * Adds stock VT , same as normal sequences
 *
 * @param {*} [sequences=[]]
 * @param {*} clipActionType
 * @param {*} insertClipId
 * @param {*} { useBatch = true }
 * @return {*}
 */
function addStockSequence() {
    var sequences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var clipActionType = arguments[1];
    var insertClipId = arguments[2];
    var _ref2 = arguments[3];
    var _ref2$useBatch = _ref2.useBatch,
        useBatch = _ref2$useBatch === undefined ? true : _ref2$useBatch;

    return function (dispatch, getState, global) {
        var appManager = global.appManager;

        var state = getState();

        var projectId = state.project.id;

        var projectMedias = sequences.flatMap(function (seq) {
            var _seq$sequenceData = seq.sequenceData,
                _seq$sequenceData$pro = _seq$sequenceData.projectMedia,
                projectMedia = _seq$sequenceData$pro === undefined ? [] : _seq$sequenceData$pro,
                _seq$sequenceData$sho = _seq$sequenceData.shouldUpdateProjectMedia,
                shouldUpdateProjectMedia = _seq$sequenceData$sho === undefined ? true : _seq$sequenceData$sho;

            if (shouldUpdateProjectMedia) return projectMedia;
            return [];
        });

        var images = projectMedias.filter(function (pm) {
            return pm.mediaType == 'image';
        });

        // creates bitmapDef for all image

        var sequenceListData = [];
        var sequenceOverlayDataObj = {}; // used by sequences
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = sequences[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var sequence = _step2.value;
                var sequenceId = sequence.id,
                    sequenceData = sequence.sequenceData,
                    name = sequence.name;
                var _sequenceData$clips = sequenceData.clips,
                    clips = _sequenceData$clips === undefined ? [] : _sequenceData$clips;

                sequenceOverlayDataObj[sequenceId] = _extends({}, sequenceData);
                sequenceListData.push({
                    clips: clips,
                    sequenceId: sequenceId,
                    sequenceName: name
                });
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var batchOp = function batchOp() {
            appManager.createImageOverlayDefFromImages(images, true, false);

            if (projectMedias.length > 0) {
                dispatch((0, _reelActions.updateProjectMedia)(projectMedias));
            }

            dispatch([(0, _reelActions.addMultipleNewCompositeClip)({
                sequenceClipArgs: sequenceListData,
                actionType: clipActionType,
                insertClipId: insertClipId,
                getOverlayActionData: function getOverlayActionData(sequenceClips) {
                    var sequenceDataForOverlay = sequenceClips.map(function (item) {
                        return sequenceOverlayDataObj[item.sequenceId];
                    });

                    var seqClipData = sequenceClips.map(function (clipData) {
                        return {
                            clipId: clipData.clipId,
                            startTime: clipData.time.enterStart,
                            maxDuration: clipData.clipDuration,
                            type: 'sequence'
                        };
                    });

                    var _createSequenceTempla2 = (0, _overlayActions.createSequenceTemplatesFromSequenceData)(sequenceDataForOverlay, seqClipData, {
                        state: state
                    }),
                        allOverlays = _createSequenceTempla2.allOverlays,
                        clipIdToOverlays = _createSequenceTempla2.clipIdToOverlays;

                    var overlayActionData = (0, _overlayActions.addOverlayAction)(allOverlays, {
                        shouldSelectAll: false,
                        sequenceOverlayMetaEntries: clipIdToOverlays
                    });
                    return overlayActionData;
                },
                useBatch: true
            }), (0, _onboardingActions.completeOnboardingStep)('UPLOAD_MEDIA', true)]);
        };

        if (useBatch) (0, _reactRedux.batch)(batchOp);else batchOp();
    };
}

/**
 * Adds provided sequence Id to the reel and add corresponding overlays to timeline
 * makes the time offsets correct and changes names to make them unique.
 *
 * @export
 * @param {{vtId: Number, addAll: Boolean, format: String}} vtData
 * @param {string} sequenceId
 * @return {*}
 */
function addStockSequenceToReelAndOverlay(vtData) {
    var clipActionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reelActions.ClipActionType.ADD_CLIP_END;
    var clipId = arguments[2];

    return function (dispatch, getState) {
        var vtId = vtData.vtId,
            format = vtData.format,
            _vtData$addAll = vtData.addAll,
            addAll = _vtData$addAll === undefined ? false : _vtData$addAll,
            _vtData$orderId = vtData.orderId,
            orderId = _vtData$orderId === undefined ? null : _vtData$orderId;

        var _getState2 = getState(),
            _getState2$allVTSeque = _getState2.allVTSequences,
            allVTSequences = _getState2$allVTSeque === undefined ? {} : _getState2$allVTSeque,
            projectId = _getState2.project.id;

        if (addAll || !!orderId) {
            dispatch({ type: SequenceActionType.UPDATE_ADDING_STATE, value: true });

            var sequences = [];

            var selectedFormatData = allVTSequences[vtId].formatData[format];

            if (selectedFormatData.isSequenceLoaded) {
                if (addAll) {
                    sequences = Object.values(selectedFormatData.sequenceData).map(function (sd) {
                        return sd.sequenceInst;
                    }).sort(function (a, b) {
                        return parseInt(a.orderId, 10) - parseInt(b.orderId, 10);
                    });
                } else {
                    sequences = [selectedFormatData.sequenceData[orderId].sequenceInst];
                }

                dispatch(addStockSequence(sequences, clipActionType, clipId, {
                    addAll: addAll,
                    vtId: vtId,
                    isStock: true,
                    useBatch: true
                }));

                sequenceTracker.trackVtAppliedAllSequences(projectId, vtId);

                dispatch({ type: SequenceActionType.UPDATE_ADDING_STATE, value: false });
            } else {
                (0, _api.getVtSequencesP)(vtId, format, addAll, orderId).then(function (res) {
                    sequences = [];

                    if (orderId) {
                        sequences = [res.sequences[orderId]];
                    } else {
                        sequences = Object.values(res.sequences).sort(function (a, b) {
                            return parseInt(a.orderId, 10) - parseInt(b.orderId, 10);
                        });
                    }

                    (0, _reactRedux.batch)(function () {
                        dispatch({
                            type: SequenceActionType.UPDATE_STOCK_SEQUENCE,
                            sequences: res.sequences,
                            vtId: vtId,
                            format: format
                        });
                        dispatch(addStockSequence(sequences, clipActionType, clipId, {
                            addAll: addAll,
                            vtId: vtId,
                            useBatch: false
                        }));
                    });

                    sequenceTracker.trackSequenceUsed(projectId, sequences[0].id, sequenceTracker.sequenceTypes.VIDEO_TEMPLATE);

                    dispatch({ type: SequenceActionType.UPDATE_ADDING_STATE, value: false });
                });
            }
        } else {
            console.error('Invalid VT sequence request');
        }
    };
}

/**
 * Breaks apart the sequence into it's constituent clips adds the constituents to timeline with the property they have
 * removes the overlay meta for sequence overlay identification, disabling  any control restriction on top of them
 *
 * @export
 * @param {string} clipId
 * @return {*}
 */
function breakApartSequence(clipId) {
    return function (dispatch, getState) {
        var state = getState();

        var selectedClip = (0, _miscSelectors.getSelectedClip)(state);
        if (!selectedClip || selectedClip.clipType !== 'composite') return;
        var childClips = (0, _lodash.cloneDeep)(selectedClip.childClips);

        // TO DO TEST TRANSITION
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = childClips[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var childClip = _step3.value;

                childClip.clipId = _shortid2.default.generate();
                childClip.sequenceId = selectedClip.sequnceId;
                childClip.time.enterStart += selectedClip.time.enterStart;
                childClip.time.enterDone += selectedClip.time.enterStart;
                childClip.time.exitDone += selectedClip.time.enterStart;
                childClip.time.exitStart += selectedClip.time.enterStart;
                childClip.time.prevOffset -= selectedClip.time.prevOffset;
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        childClips[0].time.currentOffset = selectedClip.time.currentOffset;

        // AVOID FOR NOW
        if (selectedClip.transitions.enter) childClips[0].transitions.enter = selectedClip.transitions.enter;
        if (selectedClip.transitions.exit) childClips[childClips.length - 1].transitions.exit = selectedClip.transitions.exit;

        (0, _reactRedux.batch)(function () {
            var overlaysActionsData = (0, _overlayActions.getRemoveUpdatedOverlaysForSequence)(selectedClip.clipId, state);
            var overlayMetaActionData = (0, _overlayActions.getRemoveOverlayMetaEntryForSequence)(selectedClip.clipId, state);
            var compositeClipActionData = (0, _reelActions.replaceClip)([selectedClip], childClips);

            dispatch({
                type: SequenceActionType.BREAK_APART,
                overlayMetaActionData: overlayMetaActionData,
                compositeClipActionData: compositeClipActionData,
                overlaysActionsData: overlaysActionsData
            });

            // const { enterStart, prevOffset = 0 } = childClips[0].time
            // const { exitDone } = childClips[childClips.length - 1].time

            // const adjustment = exitDone - enterStart //duration
            // const afterTime = enterStart + prevOffset

            // DONT KNOW THE EFFECT OF THIS  on PERFORMANCE
            // dispatch(adjustOverlayTimeline(afterTime, adjustment))

            dispatch(modeActions.closeProjectProperties());
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());
            dispatch((0, _reelActions.unselectAllClips)());
            dispatch({ type: _reelActions.ReelActionType.REFRESH_CLIP_TIMES });
        });
    };
}

/**
 * Deletes a time range of the timeline and adds the sequence created out of the timerange
 * to replace the time range
 *
 * @export
 * @param {*} sequnceId
 * @return {*}
 */
function applySequence2Timeline(_ref3, start, duration) {
    var id = _ref3.id,
        sequenceData = _ref3.sequenceData,
        name = _ref3.name;
    var overlayId2Delete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    return function (dispatch, getState) {
        // console.log({
        //     id , sequenceData , start , duration
        // })
        // get initial list of clips
        var _getState3 = getState(),
            _getState3$reel$clips = _getState3.reel.clips,
            clips = _getState3$reel$clips === undefined ? [] : _getState3$reel$clips,
            overlays = _getState3.overlays;

        // record start time and end time


        var startTime = start;
        var endTime = start + duration;

        // get first and last clip
        var firstClip = (0, _ReelHelpers.getClipAtTime)(clips, startTime);
        var lastClip = (0, _ReelHelpers.getClipAtTime)(clips, endTime);
        // console.log({startTime , endTime , firstClip , lastClip})

        // UNSPECIFIED BEHAVIOUR , SPLICING OVERLAYS WILL GIVE BAD VISUALS SO WEE KEEP THE ORIGINAL ON IN SAME POSITION
        // FOR A CONTINUOUS ANIMATION EFFORT , USER CAN DELET THE REDUNDANT LATER
        var overlays2Del = overlayId2Delete.map(function (id) {
            return overlays[id];
        }).filter(function (o) {
            return !!o;
        }).filter(function (overlay) {
            var _overlay$time = overlay.time,
                enterstart = _overlay$time.enterstart,
                enterdone = _overlay$time.enterdone;

            if (enterstart < startTime || enterdone > start + duration)
                // if overlay goes beyond the range of sequence do not delete
                return false;
            return true;
        });

        (0, _reactRedux.batch)(function () {
            dispatch((0, _overlayActions.clickOutsideVideo)());
            dispatch(modeActions.switchPropertiesPanel(_PropertiesPanelType2.default.OPTIONS));
            dispatch(modeActions.closeAudioProperties());
            dispatch(modeActions.unselectWatermarkPreview());

            // do not trim if the time of the first clip or the last clipos exactly the start or end of the clip
            // we keep the composite clip for now ~ not clip immediately / user should be informed .
            // in this way the composite clip gets deleted
            if (firstClip.time.enterStart !== startTime && firstClip.time.exitDone !== startTime && firstClip.clipType !== 'composite') {
                dispatch((0, _reelActions.selectClip)(false, firstClip.clipId));
                dispatch((0, _reelActions.splitClip)(startTime));
            }
            //  do not trim if the time of the first clip or the last clipos exactly the start or end of the clip
            if (lastClip.time.exitDone !== endTime && lastClip.time.enterStart !== endTime && lastClip.clipType !== 'composite') {
                dispatch((0, _reelActions.selectClip)(false, lastClip.clipId));
                dispatch((0, _reelActions.splitClip)(endTime));
            }

            clips = getState().reel.clips;

            // get the clips which are in range of starttime and endtime , the offset is kept to ignore enterdone and enterstart of clips nearby
            var deletableClips = (0, _ReelHelpers.getClipsInTimeRange)(clips, startTime + 1, endTime - 1);

            var seqOverlayMeta = (0, _overlayActions.getSequenceOverlayMetaEntriesToRemove)(getState(), function () {
                return overlays2Del.reduce(function (acc, o) {
                    acc[o.id] = true;
                    return acc;
                }, {});
            });

            var addOverlays = function addOverlays(clip) {
                var clipId = clip.clipId;

                var startTime = clip.time.enterStart;
                var maxDuration = clip.clipDuration;

                var overlayToDelete = (0, _overlayActions.deleteOverlays)(overlays2Del, seqOverlayMeta);

                var _createSequenceTempla3 = (0, _overlayActions.createSequenceTemplatesFromSequenceData)([sequenceData], [{ clipId: clipId, startTime: startTime, maxDuration: maxDuration }], {
                    state: getState()
                }),
                    allOverlays = _createSequenceTempla3.allOverlays,
                    clipIdToOverlays = _createSequenceTempla3.clipIdToOverlays;

                var overlayToAdd = (0, _overlayActions.addOverlayAction)(allOverlays, {
                    shouldSelectAll: false,
                    sequenceOverlayMetaEntries: clipIdToOverlays
                });

                return { overlayToDelete: overlayToDelete, overlayToAdd: overlayToAdd };
            };

            var deletableClipsId = deletableClips.map(function (dc) {
                return dc.clipId;
            });
            // console.log(deletableClipsId)

            if (deletableClipsId.length !== 0) {
                dispatch((0, _reelActions.replaceMultiClipWithSequence)({
                    clips: sequenceData.clips,
                    sequenceId: id,
                    sequenceName: name,
                    removeClipIds: deletableClipsId,
                    getOverlayActionData: addOverlays
                }));
                dispatch((0, _reelActions.unselectAllClips)());
                dispatch({ type: _reelActions.ReelActionType.REFRESH_CLIP_TIMES });
            } else {
                (0, _errorReporting.reportError)(new _errorReporting.ApplyToTimeLineFailedError('selected data -- startTime' + startTime + ' duration:' + duration + ' firstClipTime: ' + JSON.stringify(firstClip.time) + ' lastClipTime : ' + JSON.stringify(lastClip.time)));
            }
            dispatch((0, _reelActions.unselectAllClips)());
        });
    };
}

/** Tracker actions */
// TODO  Need to refactor , this need not be part of this Action space
// It , if a function call requires state , a simple MiddleWare should do the job
// where the latest state is sent to the tracking specific function
// and all is inferred from it.
function trackVideoTemplatePlayed(vtId, page) {
    return async function (dispatch, getState) {
        try {
            var state = getState();
            var projectId = state.project.id;

            sequenceTracker.trackVtPlayedTemplate(vtId, page);
        } catch (err) {
            console.log('Error logging data ' + err);
        }
    };
}

/** ********************* */

function openSequenceCreateModal() {
    return {
        type: SequenceActionType.OPEN_SEQUENCE_CREATE_MODAL,
        open: true
    };
}

function closeSequenceCreateModal() {
    return {
        type: SequenceActionType.CLOSE_SEQUENCE_CREATE_MODAL
    };
}

},{"../../common/constants/SolidImage":66,"../../common/trackers/sequenceTracker":68,"../../common/utils/ModelDataUtils":80,"../../common/utils/ReelHelpers":85,"../../common/utils/errorReporting":101,"../api":176,"../constants/General":203,"../constants/PropertiesPanelType":206,"../selectors/miscSelectors":215,"../selectors/reelSelectors":221,"../selectors/sequeceDataSelectors":222,"../selectors/sequenceSelectors":223,"../utils/ProcessingTracker":232,"./leftShelf":159,"./modeActions":162,"./onboardingActions":164,"./overlayActions":165,"./reelActions":170,"keymirror":677,"lodash":860,"react-redux":1079,"shortid":1163}],172:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearNosignupError = exports.setNosignupError = exports.resetInvalidOTP = exports.onResetInvalidCounter = exports.onVerifyingOTP = exports.onInvalidOTP = exports.onShowNameSection = exports.onShowPasswordSection = exports.onShowMainSignUpSection = exports.onShowOTPSection = exports.signUpModalActionTypes = undefined;
exports.openSignupModal = openSignupModal;
exports.closeSignupModal = closeSignupModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _TrackUtils = require('../../common/utils/TrackUtils');

var _modeActions = require('./modeActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var signUpModalActionTypes = exports.signUpModalActionTypes = (0, _keymirror2.default)({
    OPEN_SIGN_UP_MODAL: null,
    CLOSE_SIGN_UP_MODAL: null,
    SHOW_SIGN_UP_OTP_SECTION: null,
    SHOW_MAIN_SIGN_UP_SECTION: null,
    SHOW_SIGN_UP_PASSWORD_SECTION: null,
    SHOW_SIGN_UP_NAME_SECTION: null,
    SIGN_UP_INVALID_OTP: null,
    VERIFYING_OTP: null,
    RESET_INVALID_COUNTER: null,
    // SIGN_UP_MODAL_LOGIN_ERROR : null,
    SIGN_UP_MODAL_LOGGED_IN: null,
    SIGN_UP_SET_INVALID_START_TIME: null,
    RESET_INVALID_OTP: null,
    SET_NO_SIGNUP_ERROR: null,
    CLEAR_NOSIGNUP_ERROR: null
});

function openSignupModal(_ref) {
    var options = _ref.options,
        source = _ref.source;

    return function (dispatch, getState) {
        // if (isUpgradeNeeded(getState())) {
        //     dispatch(setNosignupOptions({ postSignupAction: 'export' }))
        //     return dispatch(openPlanModal())
        // }
        (0, _TrackUtils.trackOn)('Signup popup shown', { via: source }, { All: true, Smartlook: false });
        dispatch({ type: signUpModalActionTypes.OPEN_SIGN_UP_MODAL, options: options, source: source });
        dispatch((0, _modeActions.setNosignupOptions)(options));
    };
}

function closeSignupModal() {
    return function (dispatch, getState) {
        dispatch({ type: signUpModalActionTypes.CLOSE_SIGN_UP_MODAL });
        dispatch((0, _modeActions.clearNosignupOptions)());
    };
}

var onShowOTPSection = exports.onShowOTPSection = function onShowOTPSection(isSignedIn) {
    return {
        type: signUpModalActionTypes.SHOW_SIGN_UP_OTP_SECTION,
        isSignedIn: isSignedIn
    };
};

var onShowMainSignUpSection = exports.onShowMainSignUpSection = function onShowMainSignUpSection() {
    return {
        type: signUpModalActionTypes.SHOW_MAIN_SIGN_UP_SECTION
    };
};

var onShowPasswordSection = exports.onShowPasswordSection = function onShowPasswordSection() {
    return {
        type: signUpModalActionTypes.SHOW_SIGN_UP_PASSWORD_SECTION
    };
};

var onShowNameSection = exports.onShowNameSection = function onShowNameSection() {
    return { type: signUpModalActionTypes.SHOW_SIGN_UP_NAME_SECTION };
};

var onInvalidOTP = exports.onInvalidOTP = function onInvalidOTP() {
    return { type: signUpModalActionTypes.SIGN_UP_INVALID_OTP };
};

var onVerifyingOTP = exports.onVerifyingOTP = function onVerifyingOTP() {
    return { type: signUpModalActionTypes.VERIFYING_OTP };
};

var onResetInvalidCounter = exports.onResetInvalidCounter = function onResetInvalidCounter() {
    return { type: signUpModalActionTypes.RESET_INVALID_COUNTER };
};

var resetInvalidOTP = exports.resetInvalidOTP = function resetInvalidOTP() {
    return { type: signUpModalActionTypes.RESET_INVALID_OTP };
};

var setNosignupError = exports.setNosignupError = function setNosignupError() {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown';
    return {
        type: signUpModalActionTypes.SET_NO_SIGNUP_ERROR,
        error: error
    };
};

var clearNosignupError = exports.clearNosignupError = function clearNosignupError() {
    return { type: signUpModalActionTypes.CLEAR_NOSIGNUP_ERROR };
};

},{"../../common/utils/TrackUtils":90,"./modeActions":162,"keymirror":677}],173:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSubtitlePreviewOverlay = exports.updateSubtitleUsageLimitLeft = exports.updateSubtitleTemplateLanguage = exports.ProcessingActionType = exports.SubtitleActionType = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.selectSubtitleTemplate = selectSubtitleTemplate;
exports.goToAppearanceSection = goToAppearanceSection;
exports.showCaptionsCustomizeFont = showCaptionsCustomizeFont;
exports.gotoTemplateSelection = gotoTemplateSelection;
exports.gotoModeSelection = gotoModeSelection;
exports.changeMode = changeMode;
exports.gotoLanguageSelection = gotoLanguageSelection;
exports.goToPreviousUIState = goToPreviousUIState;
exports.changeTranslationLanguage = changeTranslationLanguage;
exports.getOverlayPosition = getOverlayPosition;
exports.getDefaultWidthForFormatId = getDefaultWidthForFormatId;
exports.goToAddContent = goToAddContent;
exports.goToContentSection = goToContentSection;
exports.uploadSubtitleFile = uploadSubtitleFile;
exports.setEditingSubtitle = setEditingSubtitle;
exports.addSubtitlesManually = addSubtitlesManually;
exports.editSubtitle = editSubtitle;
exports.getFrameContentBox = getFrameContentBox;
exports.addSubtitle = addSubtitle;
exports.addSubtitleBetween = addSubtitleBetween;
exports.addSubtitlesOnProject = addSubtitlesOnProject;
exports.addSubtitleOnVideo = addSubtitleOnVideo;
exports.resetSubtitleContent = resetSubtitleContent;
exports.trackProcessingForVideoSpeechRecognition = trackProcessingForVideoSpeechRecognition;
exports.trackProcessingForAudioSpeechRecognition = trackProcessingForAudioSpeechRecognition;
exports.generateSpeechToText = generateSpeechToText;
exports.cancelSpeechToText = cancelSpeechToText;
exports.changeSubtitleValue = changeSubtitleValue;
exports.changeSubtitleFont = changeSubtitleFont;
exports.changeSubtitleColor = changeSubtitleColor;
exports.changeSubtitleFontSize = changeSubtitleFontSize;
exports.changeSubtitleAlignment = changeSubtitleAlignment;
exports.changeSubtitleAnimations = changeSubtitleAnimations;
exports.toggleSubtitleShadow = toggleSubtitleShadow;
exports.changeSubtitleWidth = changeSubtitleWidth;
exports.switchSubtitlePosition = switchSubtitlePosition;
exports.changeSubtitlePadding = changeSubtitlePadding;
exports.enableCaptions = enableCaptions;
exports.changeAnimationType = changeAnimationType;
exports.changeAnimationDuration = changeAnimationDuration;
exports.changeAnimationManualMode = changeAnimationManualMode;
exports.deleteSubtitles = deleteSubtitles;
exports.changeSubtitleLineHeight = changeSubtitleLineHeight;
exports.changeSubtitleLetterSpacing = changeSubtitleLetterSpacing;
exports.changeSubtitleOpacity = changeSubtitleOpacity;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _cloneextend = require('cloneextend');

var _reactRedux = require('react-redux');

var _FileUploadManager = require('../utils/FileUploadManager');

var _FileUploadManager2 = _interopRequireDefault(_FileUploadManager);

var _ProcessingTracker = require('../utils/ProcessingTracker');

var _ProcessingTracker2 = _interopRequireDefault(_ProcessingTracker);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _OverlayUtils = require('../utils/OverlayUtils');

var _overlayActions = require('./overlayActions');

var overlayActions = _interopRequireWildcard(_overlayActions);

var _ReelHelpers = require('../../common/utils/ReelHelpers');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _ColorRange = require('../../common/utils/ColorRange');

var _ColorRange2 = _interopRequireDefault(_ColorRange);

var _HighlightColorRange = require('../../common/utils/HighlightColorRange');

var _HighlightColorRange2 = _interopRequireDefault(_HighlightColorRange);

var _SubtitlePosition = require('../constants/SubtitlePosition');

var _SubtitlePosition2 = _interopRequireDefault(_SubtitlePosition);

var _api = require('../api');

var _subtitleSelectors = require('../selectors/subtitleSelectors');

var _miscSelectors = require('../selectors/miscSelectors');

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _modeActions = require('./modeActions');

var modeActions = _interopRequireWildcard(_modeActions);

var _reelActions = require('./reelActions');

var _logActions = require('./logActions');

var _emptyProjectActions = require('./emptyProjectActions');

var _TrackUtils = require('../../common/utils/TrackUtils');

var tracker = _interopRequireWildcard(_TrackUtils);

var _overlaySelectors = require('../selectors/overlaySelectors');

var _DemoCaptionData = require('../../common/config/DemoCaptionData.json');

var _DemoCaptionData2 = _interopRequireDefault(_DemoCaptionData);

var _TranslationLanguages = require('../../common/config/TranslationLanguages.json');

var _TranslationLanguages2 = _interopRequireDefault(_TranslationLanguages);

var _ReelUtils = require('../utils/ReelUtils');

var _SubtitleWidthForFormat = require('../constants/SubtitleWidthForFormat');

var _SubtitleWidthForFormat2 = _interopRequireDefault(_SubtitleWidthForFormat);

var _LayerUtils = require('../../common/utils/renderer/LayerUtils');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var DiffMatchPatch = require('diff-match-patch');

var defModelMap = {};

var SubtitleActionType = exports.SubtitleActionType = (0, _keymirror2.default)({
    SELECT_MODE: null,
    CHANGE_MODE: null,
    SELECT_LANGUAGE: null,
    CHANGE_LANGUAGE: null,
    SELECTING_TEMPLATE: null,
    SELECTED_TEMPLATE: null,
    CHANGE_POSITION: null,
    CHANGE_WIDTH: null,
    CHANGE_PADDING: null,
    ADDING_CONTENT: null,
    UPLOADING_SRT: null,
    SUBTITLE_LOADING_COMPLETE: null,
    SRT_UPLOAD_ERROR: null,
    EDIT_SUBTITLE: null,
    DELETE_ALL_SUBTITLE: null,
    ADD_SUBTITLE: null,
    TOGGLE_SUBTITLE_FOCUS: null,
    SRT_ADD_MANUALLY: null,
    AUTO_GENERATE: null,
    CHANGE_FONT: null,
    CHANGE_COLOR: null,
    CHANGE_FONT_SIZE: null,
    CHANGE_ALIGNNENT: null,
    SET_SUBTITLE_SHADOW: null,
    ENABLE_CAPTIONS: null,
    SHOW_CUSTOMIZE_FONT: null,
    HIDE_CUSTOMIZE_FONT: null,
    CHANGE_ANIMATION: null,
    CHANGE_ROTATE: null,

    CHANGE_OPACITY: null,
    CHANGE_OPACITY_INCR: null,
    CHANGE_OPACITY_FINISH: null,

    CHANGE_LETTER_SPACING: null,
    CHANGE_LETTER_SPACING_INCR: null,
    CHANGE_LETTER_SPACING_FINISH: null,

    CHANGE_LINE_HEIGHT: null,
    CHANGE_LINE_HEIGHT_INCR: null,
    CHANGE_LINE_HEIGHT_FINISH: null,

    UPDATE_SUBTITLE_TEMPALTES: null,
    UPDATE_PREVIEW_SUBTITLE: null,
    UPDATE_FREE_CAPTION_USAGE_LEFT: null,

    RETURN_TO_PREVIOUS_STATE: null
});

var ProcessingActionType = exports.ProcessingActionType = (0, _keymirror2.default)({
    PROCESSING_START: null,
    PROCESSING_DONE: null
});

function getSubtitleData(state) {
    return (0, _subtitleSelectors.getAllSubtitleOverlays)(state).filter(function (o) {
        return !o.isPreviewSubtitle;
    }).map(function (s) {
        return {
            text: s.values.text,
            startTime: s.time.enterstart,
            endTime: s.time.exitdone
        };
    });
}

var updateSubtitleTemplateLanguage = exports.updateSubtitleTemplateLanguage = function updateSubtitleTemplateLanguage(targetLanguage) {
    return function (dispatch, getState) {
        var languageData = _TranslationLanguages2.default.find(function (l) {
            return l.value === targetLanguage;
        });
        if (!languageData) {
            return;
        }

        var defaultFontKey = languageData.defaultFontKey,
            previewText = languageData.previewText;

        var _getState = getState(),
            templates = _getState.templates,
            overlays = _getState.overlays;

        var subtitleTemplates = templates.text.find(function (t) {
            return t.id === 'subtitles';
        });
        var updatedItems = subtitleTemplates.items.map(function (item) {
            return _extends({}, item, {
                values: _extends({}, item.values, {
                    fontFamily: defaultFontKey,
                    text: previewText
                })
            });
        });

        var previewOverlay = Object.values(overlays).find(function (o) {
            return o.isPreviewSubtitle;
        });

        if (previewOverlay) {
            previewOverlay.values.text = previewText;
            dispatch({ type: SubtitleActionType.UPDATE_PREVIEW_SUBTITLE, previewOverlay: previewOverlay });
        }

        dispatch({ type: SubtitleActionType.UPDATE_SUBTITLE_TEMPALTES, items: updatedItems });
    };
};

var updateSubtitleUsageLimitLeft = exports.updateSubtitleUsageLimitLeft = function updateSubtitleUsageLimitLeft(captionDurationLeftInMin) {
    return function (dispatch, getState) {
        dispatch({
            type: SubtitleActionType.UPDATE_FREE_CAPTION_USAGE_LEFT,
            captionDurationLeftInMin: captionDurationLeftInMin
        });
    };
};

function findSubtitleTemplateByName(templates, templateName) {
    var type = 'text';
    var groupId = 'subtitles';

    return templates[type].find(function (grp) {
        return groupId === grp.id;
    }).items.find(function (t) {
        return templateName === t.name;
    });
}

function runWithDelay(targetFunction) {
    return function (dispatch, getState) {
        dispatch({ type: ProcessingActionType.PROCESSING_START });
        setTimeout(function () {
            targetFunction();

            dispatch({ type: ProcessingActionType.PROCESSING_DONE });
        }, 50);
    };
}

/**
 *
 *
 * @export
 * @param {string} templateName
 * @param {function} cb
 */
function selectSubtitleTemplate(templateName, cb) {
    return function (dispatch, getState) {
        dispatch((0, _emptyProjectActions.handleActionIfEmptyProject)(function () {
            var state = getState();
            var oldTemplateName = state.subtitles.selectedTemplateName;
            var templates = state.templates;

            (0, _reactRedux.batch)(function () {
                dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.THEME, {
                    'Theme title': templateName
                }));

                dispatch({
                    type: SubtitleActionType.SELECTED_TEMPLATE,
                    templateName: templateName
                });

                // if(oldTemplateName === templateName){
                //     return
                // }

                var subtitleData = getSubtitleData(state);

                var hasSubtitles = subtitleData.length > 0;

                // If a subtitle is currently selected we will keep track of that subtitle
                // using it's starttime to select it
                // again when subtitles are recreated after theme change
                var selectedOverlayStartTime = null;

                var _getState2 = getState(),
                    selected = _getState2.selection.selected;

                var selectedOverlays = Object.keys(selected).map(function (oid) {
                    return state.overlays[oid];
                });
                if (selectedOverlays.length === 1 && !!selectedOverlays[0] && !!selectedOverlays[0].isSubtitle && !selectedOverlays[0].isPreviewSubtitle) selectedOverlayStartTime = selectedOverlays[0].time.enterstart;else {
                    var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
                    if (subtitleOverlays.length > 0) selectedOverlayStartTime = subtitleOverlays[0].time.enterstart;
                }

                dispatch(overlayActions.selectClear());
                dispatch({ type: SubtitleActionType.DELETE_ALL_SUBTITLE });

                if (oldTemplateName !== templateName) {
                    var _state$subtitles = state.subtitles,
                        subtitleShadow = _state$subtitles.subtitleShadow,
                        subtitleFont = _state$subtitles.subtitleFont,
                        subtitleAlignment = _state$subtitles.subtitleAlignment,
                        fontSize = _state$subtitles.fontSize,
                        subtitleTextColor = _state$subtitles.subtitleTextColor,
                        subtitleOtherColor = _state$subtitles.subtitleOtherColor,
                        subtitleLetterSpacing = _state$subtitles.subtitleLetterSpacing,
                        subtitleLineHeight = _state$subtitles.subtitleLineHeight;

                    var template = findSubtitleTemplateByName(templates, templateName);

                    if (!!template.values.textColor && template.values.textColor !== subtitleTextColor) {
                        var colorRange = new _ColorRange2.default(template.values.textColor);
                        var textColor = colorRange.defaultColor;
                        dispatch({
                            type: SubtitleActionType.CHANGE_COLOR,
                            color: textColor,
                            isTextColor: true
                        });
                    }

                    if (!!template.values.color && template.values.color !== subtitleOtherColor) {
                        var _colorRange = new _ColorRange2.default(template.values.color);
                        var color = _colorRange.defaultColor;
                        dispatch({
                            type: SubtitleActionType.CHANGE_COLOR,
                            color: color,
                            isTextColor: false
                        });
                    }

                    if (!!template.values.fontFamily && template.values.fontFamily !== subtitleFont) dispatch({
                        type: SubtitleActionType.CHANGE_FONT,
                        fontKey: template.values.fontFamily
                    });
                    // if (!!template.values.fontSize && template.values.fontSize !== fontSize)
                    //     dispatch({ type : SubtitleActionType.CHANGE_FONT_SIZE, fontSize: template.values.fontSize })
                    if (!!template.values.align && template.values.align !== subtitleAlignment) dispatch({
                        type: SubtitleActionType.CHANGE_ALIGNNENT,
                        alignment: template.values.align
                    });
                    if (template.values.shadow !== subtitleShadow) dispatch({
                        type: SubtitleActionType.SET_SUBTITLE_SHADOW,
                        isEnabled: !!template.values.shadow
                    });
                    dispatch({
                        type: SubtitleActionType.CHANGE_ROTATE,
                        subtitleRotate: 0
                    });
                    dispatch({
                        type: SubtitleActionType.CHANGE_OPACITY,
                        subtitleOpacity: 1
                    });
                    if (template.values.lineHeight != null && template.values.lineHeight !== subtitleLineHeight) dispatch({
                        type: SubtitleActionType.CHANGE_LINE_HEIGHT,
                        lineHeight: template.values.lineHeight
                    });
                    if (template.values.letterSpacing != null && template.values.letterSpacing !== subtitleLetterSpacing) dispatch({
                        type: SubtitleActionType.CHANGE_LETTER_SPACING,
                        letterSpacing: template.values.letterSpacing
                    });
                }

                if (hasSubtitles) {
                    dispatch(runWithDelay(function () {
                        dispatch(addSubtitlesOnProject(subtitleData, 0, selectedOverlayStartTime));
                    }));
                } else {
                    dispatch(goToAddContent());
                }

                dispatch((0, _reelActions.unselectAllClips)());

                if (cb) {
                    cb();
                }
            });
        }));
    };
}

function goToAppearanceSection() {
    var showCaptionsCustomizeFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        dispatch({ type: SubtitleActionType.SELECTED_TEMPLATE });

        if (showCaptionsCustomizeFont) {
            dispatch({ type: SubtitleActionType.SHOW_CUSTOMIZE_FONT });
        }
    };
}

function showCaptionsCustomizeFont() {
    return function (dispatch, getState) {
        dispatch({ type: SubtitleActionType.SHOW_CUSTOMIZE_FONT });
    };
}

function gotoTemplateSelection() {
    return function (dispatch) {
        dispatch({ type: SubtitleActionType.SELECTING_TEMPLATE });
    };
}

function gotoModeSelection() {
    return function (dispatch) {
        dispatch({ type: SubtitleActionType.SELECT_MODE });
    };
}

function changeMode(mode) {
    return function (dispatch) {
        dispatch({ type: SubtitleActionType.CHANGE_MODE, mode: mode });

        tracker.trackOn('Caption mode selected', { CaptionMode: mode }, {
            PostHog: true,
            Smartlook: true
        });
    };
}

function gotoLanguageSelection() {
    return function (dispatch) {
        dispatch({ type: SubtitleActionType.SELECT_LANGUAGE });
    };
}

function goToPreviousUIState() {
    return function (dispatch) {
        dispatch({ type: SubtitleActionType.RETURN_TO_PREVIOUS_STATE });
    };
}

function changeTranslationLanguage(sourceLang, targetLang) {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            overlays = _getState3.overlays,
            _getState3$subtitles = _getState3.subtitles,
            sourceLanguage = _getState3$subtitles.sourceLanguage,
            targetLanguage = _getState3$subtitles.targetLanguage,
            projectId = _getState3.project.id;

        dispatch({
            type: SubtitleActionType.CHANGE_LANGUAGE,
            sourceLang: sourceLang,
            targetLang: targetLang
        });

        dispatch((0, _overlayActions.selectClear)());

        var postProcessing = function postProcessing() {
            var fontKey = _FontManager2.default.getFontDefaultKey(targetLang);

            dispatch({
                type: SubtitleActionType.CHANGE_FONT,
                fontKey: fontKey
            });

            dispatch(updateSubtitleTemplateLanguage(targetLang));
            dispatch(changeSubtitleFont(fontKey));
        };

        var containsSubtitleData = Object.values(overlays).some(function (o) {
            return o.isSubtitle;
        });

        if (containsSubtitleData) {
            dispatch({ type: SubtitleActionType.AUTO_GENERATE });

            (0, _api.translateSubtitlesToLanguageP)({ projectId: projectId, targetLanguage: targetLang }).then(function (result) {
                var _result$translatedSub = result.translatedSubtitleData,
                    translatedSubtitleData = _result$translatedSub === undefined ? [] : _result$translatedSub;

                dispatch({ type: SubtitleActionType.DELETE_ALL_SUBTITLE });

                postProcessing();

                dispatch(addSubtitlesOnProject(translatedSubtitleData));

                dispatch({
                    type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE,
                    subtitleData: translatedSubtitleData
                });
            }).catch(function (err) {
                console.log(err); /* Nothing */
            });
        } else {
            postProcessing();
            dispatch(gotoTemplateSelection());
        }
    };
}

function getOverlayPosition(subtitlePosition, canvasHeight, overlayHeight, contentBox, subtitlePadding) {
    var overlayY = 0;
    var paddingInActual = 0;
    // Converting percentage value to actual padding in px
    if (subtitlePadding) {
        paddingInActual = canvasHeight / 2 * (subtitlePadding / 100);
    }

    if (subtitlePosition === _SubtitlePosition2.default.TOP) {
        overlayY = 0;
        overlayY = overlayY + paddingInActual;
    } else if (subtitlePosition === _SubtitlePosition2.default.MIDDLE) {
        overlayY = (canvasHeight - overlayHeight) / 2;
    } else {
        // bottom position
        overlayY = canvasHeight - overlayHeight - paddingInActual;
    }
    return overlayY;
}

function getDefaultWidthForFormatId(formats, formatId) {
    var selectedFormatInfo = (0, _ReelUtils.getFormatDetailsFromInput)(formats, formatId);
    if (!selectedFormatInfo) return 80;

    var width = _SubtitleWidthForFormat2.default[selectedFormatInfo.size] || 80;
    return width;
}

function goToAddContent() {
    return function (dispatch, getState) {
        dispatch({ type: SubtitleActionType.ADDING_CONTENT });
    };
}

function goToContentSection() {
    return function (dispatch, getState) {
        dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE });
    };
}

function uploadSubtitleFile(file) {
    return function (dispatch, getState) {
        var projectId = getState().project.id;

        var itemType = 'SUBTITLE';
        var uploader = new _FileUploadManager2.default(file, itemType, projectId);

        uploader.onStart(function (uploadId) {
            return dispatch({ type: SubtitleActionType.UPLOADING_SRT });
        }).onComplete(function (uploadId, _ref) {
            var subtitleData = _ref.data;

            dispatch(addSubtitlesOnProject(subtitleData));
            dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE, subtitleData: subtitleData });

            tracker.trackOnHeap('Captions: Uploaded SRT', { projectId: projectId });

            var trackingData = { mediaType: itemType, projectId: projectId };
            tracker.trackOnSmartlook('Media Uploaded', trackingData);

            var subtitleLoggingData = getSubtitleLoggingData(getState().subtitles);
            dispatch((0, _logActions.logSubtitleAddition)(_extends({
                source: 'SRT'
            }, subtitleLoggingData)));
        }).onError(function (uploadId, errorCode) {
            console.error(errorCode);
            dispatch({ type: SubtitleActionType.SRT_UPLOAD_ERROR, errorCode: errorCode });
        }).doUpload();
    };
}

function setEditingSubtitle(isEditing) {
    return { type: SubtitleActionType.TOGGLE_SUBTITLE_FOCUS, isEditing: isEditing };
}

function addSubtitlesManually() {
    return { type: SubtitleActionType.SRT_ADD_MANUALLY };
}

function editSubtitle(subtitleId, newText) {
    return function (dispatch, getState) {
        var state = getState();
        var _state$reel = state.reel,
            canvas = _state$reel.canvas,
            _state$reel$frameType = _state$reel.frameType,
            frameType = _state$reel$frameType === undefined ? '' : _state$reel$frameType,
            overlays = state.overlays,
            _state$subtitles2 = state.subtitles,
            subtitlePosition = _state$subtitles2.subtitlePosition,
            subtitlePadding = _state$subtitles2.subtitlePadding;

        var prop = 'text'; // assuming this for now

        var overlay = overlays[subtitleId];
        var currentText = overlay.values[prop];

        var defModel = defModelMap[overlay.defId];
        if (!defModel) {
            defModel = _DefModel.DefModelRegistry.getModelForOverlay(overlay.defId, overlay.id);
            defModelMap[overlay.defId] = defModel;
        }

        var _defModel$def$meta = defModel.def.meta,
            textColors = _defModel$def$meta.textColors,
            highlightColors = _defModel$def$meta.highlightColors;

        var updateValues = (0, _cloneextend.clone)(overlay.values);
        updateValues[prop] = newText;

        var colorPropsToUpdate = [];

        if (textColors) {
            colorPropsToUpdate.push({
                prop: textColors[prop],
                colorRange: new _ColorRange2.default(overlay.values[textColors[prop]])
            });
        }
        if (highlightColors) {
            var _highlightColors$prop = highlightColors[prop],
                highlight = _highlightColors$prop.highlight,
                highlightText = _highlightColors$prop.highlightText;

            if (highlight) {
                colorPropsToUpdate.push({
                    prop: highlight,
                    colorRange: new _HighlightColorRange2.default(overlay.values[highlight])
                });
            }
            if (highlightText) {
                colorPropsToUpdate.push({
                    prop: highlightText,
                    colorRange: new _HighlightColorRange2.default(overlay.values[highlightText])
                });
            }
        }

        if (colorPropsToUpdate.length > 0) {
            var dmp = new DiffMatchPatch();
            var diffs = dmp.diff_main(currentText, newText);

            var charCounter = 0;

            diffs.forEach(function (diff) {
                var _diff = _slicedToArray(diff, 2),
                    type = _diff[0],
                    value = _diff[1];

                var _loop = function _loop(i) {
                    if (type === -1) {
                        colorPropsToUpdate.forEach(function (_ref2) {
                            var prop = _ref2.prop,
                                colorRange = _ref2.colorRange;

                            colorRange.removeAtIndex(i);
                        });
                    } else if (type === 1) {
                        colorPropsToUpdate.forEach(function (_ref3) {
                            var prop = _ref3.prop,
                                colorRange = _ref3.colorRange;

                            colorRange.insertAtIndex(i);
                        });
                    }
                };

                for (var i = charCounter + value.length - 1; i >= charCounter; i--) {
                    _loop(i);
                }
                charCounter += value.length;
            });

            colorPropsToUpdate.forEach(function (_ref4) {
                var prop = _ref4.prop,
                    colorRange = _ref4.colorRange;

                updateValues[prop] = colorRange.toString();
            });
        }
        var animSettings = (0, _overlaySelectors.getAnimGroupSettingsForAllOverlays)(state);
        defModel.update(overlay.space, overlay.time, updateValues, canvas, animSettings[overlay.id], false, false);

        var contentBox = getFrameContentBox(getState());

        var overlayY = getOverlayPosition(subtitlePosition, canvas.height, defModel.space.height, contentBox, subtitlePadding);

        var newOverlay = (0, _deepmerge2.default)(overlay, {
            values: updateValues,
            space: { y: overlayY }
        });

        dispatch((0, _overlayActions.changeOverlayFinishFromCurrent)(newOverlay));
    };
}

function getFrameContentBox(state) {
    var contentBox = null;
    var _state$reel2 = state.reel,
        canvas = _state$reel2.canvas,
        _state$reel2$frameTyp = _state$reel2.frameType,
        frameType = _state$reel2$frameTyp === undefined ? '' : _state$reel2$frameTyp;

    if (frameType) {
        var customFormat = (0, _miscSelectors.getSelectedCustomFormat)(state);
        contentBox = (0, _ReelHelpers.getContentBox)({ canvas: canvas, frameType: frameType, customFormat: customFormat });
    }

    return contentBox;
}

function addSubtitle(text) {
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function (dispatch, getState) {
        var state = getState();

        var subtitles = (0, _subtitleSelectors.getNonPreviewSubtitleOverlayIds)(state);
        if (!subtitles || Object.keys(subtitles).length === 0) {
            var subtitleLoggingData = getSubtitleLoggingData(getState().subtitles);
            dispatch((0, _logActions.logSubtitleAddition)(_extends({
                source: 'Manual'
            }, subtitleLoggingData)));
        }

        dispatch(addSubtitleOnProject(_extends({ text: text }, time), 0, true));
    };
}

function addSubtitleBetween(afterSubtitleId, beforeSubtitleId) {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            overlays = _getState4.overlays,
            duration = _getState4.player.duration;

        var afterSubtitle = Object.values(overlays).find(function (o) {
            return o.id === afterSubtitleId;
        });

        var beforeSubtitle = void 0;
        if (beforeSubtitleId) {
            beforeSubtitle = Object.values(overlays).find(function (o) {
                return o.id === beforeSubtitleId;
            });
        }

        if (afterSubtitle) {
            var subtitleStartTime = afterSubtitle.time.exitdone + 1;

            var subtitleEndTime = beforeSubtitle ? beforeSubtitle.time.enterstart : duration;

            var subDuration = Math.max(2000, Math.min(4000, subtitleEndTime - subtitleStartTime));

            var subStartTime = subtitleStartTime;
            var subEndTime = subStartTime + subDuration;

            var sub = {
                text: '',
                startTime: subStartTime,
                endTime: subEndTime
            };

            dispatch(addSubtitleOnProject(sub, 0, true));
        }
    };
}

var alphaProps = function alphaProps(def) {
    return Object.keys(def.props).filter(function (pk) {
        return def.props[pk] === 'alpha';
    });
};

/**
 * Create a preview overlay for the selected subtitle template and returns
 * the overlay object (does not add to overlays list in state).
 *
 */
var createSubtitlePreviewOverlay = exports.createSubtitlePreviewOverlay = function createSubtitlePreviewOverlay(state) {
    var templates = state.templates,
        duration = state.player.duration,
        _state$reel3 = state.reel,
        canvas = _state$reel3.canvas,
        formatId = _state$reel3.formatId,
        subtitles = state.subtitles,
        overlays = state.overlays,
        formats = state.formats;
    var templateName = subtitles.selectedTemplateName,
        subtitlePosition = subtitles.subtitlePosition,
        subtitleWidth = subtitles.subtitleWidth,
        subtitlePadding = subtitles.subtitlePadding,
        subtitleShadow = subtitles.subtitleShadow,
        subtitleFont = subtitles.subtitleFont,
        subtitleAlignment = subtitles.subtitleAlignment,
        fontSize = subtitles.fontSize,
        subtitleTextColor = subtitles.subtitleTextColor,
        subtitleOtherColor = subtitles.subtitleOtherColor,
        subtitleOpacity = subtitles.subtitleOpacity,
        subtitleRotate = subtitles.subtitleRotate,
        subtitleEnterAnimDefId = subtitles.subtitleEnterAnimDefId,
        subtitleExitAnimDefId = subtitles.subtitleExitAnimDefId,
        subtitleEnterAnimManualMode = subtitles.subtitleEnterAnimManualMode,
        subtitleEnterAnimDuration = subtitles.subtitleEnterAnimDuration,
        subtitleExitAnimManualMode = subtitles.subtitleExitAnimManualMode,
        subtitleExitAnimDuration = subtitles.subtitleExitAnimDuration,
        subtitleLetterSpacing = subtitles.subtitleLetterSpacing,
        subtitleLineHeight = subtitles.subtitleLineHeight,
        _subtitles$targetLang = subtitles.targetLanguage,
        targetLanguage = _subtitles$targetLang === undefined ? 'en' : _subtitles$targetLang;

    // create initial overlay from the selected subtitle theme/template

    var template = findSubtitleTemplateByName(templates, templateName);
    var type = 'text';
    if (!template) return null;

    var _createOverlaysFromTe = (0, _OverlayUtils.createOverlaysFromTemplate)(template, overlays, canvas, type),
        createdOverlays = _createOverlaysFromTe.overlays;

    var contentBox = getFrameContentBox(state);

    var previewText = 'This is a preview of how your subtitle text would appear after adding content.';
    var languageData = _TranslationLanguages2.default.find(function (l) {
        return l.value === targetLanguage;
    });
    if (languageData) {
        previewText = languageData.previewText;
    }

    createdOverlays.forEach(function (o) {
        // Set time attribtutes
        o.time.enterstart = 0;
        o.time.enterdone = 0;
        o.time.exitstart = duration;
        o.time.exitdone = duration;

        // Set value attributes
        o.values.text = previewText;
        o.values.textColor = subtitleTextColor;
        o.values.color = subtitleOtherColor;
        o.values.fontSize = fontSize * 2;
        o.values.fontFamily = subtitleFont;
        o.values.align = subtitleAlignment;
        o.values.shadow = subtitleShadow;

        o.isSubtitle = true;
        o.isPreviewSubtitle = true;

        var def = getTemplateDefForId(o.defId);

        if (subtitleLetterSpacing != null) o.values.letterSpacing = subtitleLetterSpacing;

        if (subtitleLineHeight != null) o.values.lineHeight = subtitleLineHeight;

        var ops = alphaProps(def);
        if (ops.length > 0) {
            var _ops = _slicedToArray(ops, 1),
                op = _ops[0];

            o.values[op] = subtitleOpacity;
        }

        if (subtitleRotate) o.space.rotateDeg = subtitleRotate;

        if (subtitleEnterAnimDefId) {
            o.time.enterAnimDefId = subtitleEnterAnimDefId;
            o.time.enterAnimTimeManual = !!subtitleEnterAnimManualMode;
            if (subtitleEnterAnimDuration) o.time.enterdone === o.time.enterstart + subtitleEnterAnimDuration;
        }

        if (subtitleExitAnimDefId) {
            o.time.exitAnimDefId = subtitleExitAnimDefId;
            o.time.exitAnimTimeManual = !!subtitleExitAnimManualMode;
            if (subtitleExitAnimDuration) o.time.exitstart === o.time.exitdone - subtitleExitAnimDuration;
        }

        var defModel = defModelMap[o.defId];
        if (!defModel) {
            defModel = _DefModel.DefModelRegistry.getModelForOverlay(o.defId, o.id);
            defModelMap[o.defId] = defModel;
        }

        var animSettings = (0, _overlaySelectors.getAnimGroupSettingsForAllOverlays)(state);
        defModel.update(o.space, o.time, o.values, canvas, animSettings[o.id]);
        // defModel.seekToStatic();

        // Set space attributes
        o.space.y = getOverlayPosition(subtitlePosition, canvas.height, defModel.space.height, contentBox, subtitlePadding);
        var selectedWidth = subtitleWidth ? subtitleWidth : getDefaultWidthForFormatId(formats, formatId);
        o.space.width = selectedWidth * canvas.width / 100;
        o.space.x = (canvas.width - o.space.width) / 2;
    });

    return createdOverlays;
};

/**
 * @deprecated
 * Generate and add a preview subtitle to overlays in state.
 * Not used anymore.
 */
function addPreviewSubtitle() {
    return function (dispatch, getState) {
        var createdOverlays = createSubtitlePreviewOverlay(getState());
        dispatch((0, _overlayActions.addSubtitles)(createdOverlays));
    };
}

function addSubtitleOnProject(sub) {
    var clipTimeOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var autoSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return function (dispatch, getState) {
        var state = getState();
        var templates = state.templates,
            _state$reel4 = state.reel,
            canvas = _state$reel4.canvas,
            formatId = _state$reel4.formatId,
            subtitles = state.subtitles,
            overlays = state.overlays,
            projectDuration = state.player.duration,
            formats = state.formats;

        var subtitleOverlayData = getSubtitleData(state);

        subtitleOverlayData.sort(function (a, b) {
            return a.startTime - b.startTime;
        });

        var lastSubtitleTime = 0;

        if (subtitleOverlayData.length > 0) {
            lastSubtitleTime = subtitleOverlayData[subtitleOverlayData.length - 1].endTime + 1;
        }

        var templateId = subtitles.selectedTemplateId,
            subtitleFont = subtitles.subtitleFont,
            subtitleShadow = subtitles.subtitleShadow,
            templateName = subtitles.selectedTemplateName,
            subtitlePosition = subtitles.subtitlePosition,
            subtitleWidth = subtitles.subtitleWidth,
            subtitlePadding = subtitles.subtitlePadding,
            fontSize = subtitles.fontSize,
            subtitleAlignment = subtitles.subtitleAlignment,
            subtitleTextColor = subtitles.subtitleTextColor,
            subtitleOtherColor = subtitles.subtitleOtherColor,
            subtitleOpacity = subtitles.subtitleOpacity,
            subtitleRotate = subtitles.subtitleRotate,
            subtitleEnterAnimDefId = subtitles.subtitleEnterAnimDefId,
            subtitleExitAnimDefId = subtitles.subtitleExitAnimDefId,
            subtitleEnterAnimManualMode = subtitles.subtitleEnterAnimManualMode,
            subtitleEnterAnimDuration = subtitles.subtitleEnterAnimDuration,
            subtitleExitAnimManualMode = subtitles.subtitleExitAnimManualMode,
            subtitleExitAnimDuration = subtitles.subtitleExitAnimDuration,
            subtitleLetterSpacing = subtitles.subtitleLetterSpacing,
            subtitleLineHeight = subtitles.subtitleLineHeight;

        var template = findSubtitleTemplateByName(templates, templateName);

        var _sub$startTime = sub.startTime,
            startTime = _sub$startTime === undefined ? lastSubtitleTime : _sub$startTime;

        startTime += clipTimeOffset;

        var endTime = Math.min(startTime + 4000, projectDuration);

        if (sub.endTime) {
            endTime = clipTimeOffset + sub.endTime;
        }

        var text = sub.text;

        var type = 'text';

        var _createOverlaysFromTe2 = (0, _OverlayUtils.createOverlaysFromTemplate)(template, overlays, canvas, type),
            createdOverlays = _createOverlaysFromTe2.overlays;

        var contentBox = getFrameContentBox(getState());

        createdOverlays.forEach(function (o) {
            var _o$time = o.time,
                enterstart = _o$time.enterstart,
                enterdone = _o$time.enterdone,
                exitstart = _o$time.exitstart,
                exitdone = _o$time.exitdone;

            var enterAnimDuration = enterdone - enterstart;
            var exitAnimDuration = exitdone - exitstart;

            // Set time attribtutes
            o.time.enterstart = startTime;
            o.time.enterdone = Math.min(startTime + enterAnimDuration, endTime);
            o.time.exitstart = Math.max(endTime - exitAnimDuration, o.time.enterdone);
            o.time.exitdone = endTime;

            // Set value attributes
            o.values.text = text;
            o.values.textColor = subtitleTextColor;
            o.values.color = subtitleOtherColor;
            o.values.fontSize = fontSize * 2;
            o.values.fontFamily = subtitleFont;
            o.values.align = subtitleAlignment;
            o.values.shadow = subtitleShadow;

            o.isSubtitle = true;

            var def = getTemplateDefForId(o.defId);

            if (subtitleLetterSpacing != null) o.values.letterSpacing = subtitleLetterSpacing;

            if (subtitleLineHeight != null) o.values.lineHeight = subtitleLineHeight;

            var ops = alphaProps(def);
            if (ops.length > 0) {
                var _ops2 = _slicedToArray(ops, 1),
                    op = _ops2[0];

                o.values[op] = subtitleOpacity;
            }

            if (subtitleRotate) o.space.rotateDeg = subtitleRotate;

            if (subtitleEnterAnimDefId) {
                o.time.enterAnimDefId = subtitleEnterAnimDefId;
                o.time.enterAnimTimeManual = !!subtitleEnterAnimManualMode;
                if (subtitleEnterAnimDuration) o.time.enterdone === o.time.enterstart + subtitleEnterAnimDuration;
            }

            if (subtitleExitAnimDefId) {
                o.time.exitAnimDefId = subtitleExitAnimDefId;
                o.time.exitAnimTimeManual = !!subtitleExitAnimManualMode;
                if (subtitleExitAnimDuration) o.time.exitstart === o.time.exitdone - subtitleExitAnimDuration;
            }

            var defModel = defModelMap[o.defId];
            if (!defModel) {
                defModel = _DefModel.DefModelRegistry.getModelForOverlay(o.defId, o.id);
                defModelMap[o.defId] = defModel;
            }

            var animSettings = (0, _overlaySelectors.getAnimGroupSettingsForAllOverlays)(state);
            defModel.update(o.space, o.time, o.values, canvas, animSettings[o.id]);
            // defModel.seekToStatic();

            // Set space attributes
            o.space.y = getOverlayPosition(subtitlePosition, canvas.height, defModel.space.height, contentBox, subtitlePadding);

            var selectedWidth = subtitleWidth ? subtitleWidth : getDefaultWidthForFormatId(formats, formatId);
            o.space.width = selectedWidth * canvas.width / 100;
            o.space.x = (canvas.width - o.space.width) / 2;
            if (!subtitleWidth) {
                dispatch({ type: SubtitleActionType.CHANGE_WIDTH, width: selectedWidth });
            }
        });

        dispatch((0, _overlayActions.addSubtitles)(createdOverlays, autoSelect));
    };
}

function addSubtitlesOnProject(subtitleData) {
    var clipTimeOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var selectedOverlayStartTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

    return function (dispatch, getState) {
        subtitleData.forEach(function (sub) {
            dispatch(addSubtitleOnProject(sub, clipTimeOffset, sub.startTime === selectedOverlayStartTime));
        });

        dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE });
    };
}

function addSubtitleOnVideo(videoId, clipStart, clipDuration, subtitleData) {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            clips = _getState5.reel.clips,
            project = _getState5.project;

        var targetClips = clips.filter(function (c) {
            return c.clipVideoId === videoId && c.clipStart === clipStart && c.clipDuration === clipDuration;
        });

        targetClips.forEach(function (c) {
            var _c$time = c.time,
                enterStart = _c$time.enterStart,
                exitDone = _c$time.exitDone,
                speed = c.speed,
                clipStart = c.clipStart,
                clipDuration = c.clipDuration;

            if (speed === 1) {
                subtitleData.forEach(function (sub) {
                    dispatch(addSubtitleOnProject(sub, enterStart));
                });
            }
        });
    };
}

function resetSubtitleContent() {
    return function (dispatch, getState) {
        dispatch((0, _overlayActions.selectClear)());
        dispatch({ type: SubtitleActionType.DELETE_ALL_SUBTITLE });
        dispatch(changeMode('NONE'));
        dispatch(changeTranslationLanguage('en-US', 'en'));
        dispatch(changeTranslationLanguage('en-US', 'en'));
        dispatch(gotoModeSelection());
    };
}

function trackProcessingForVideoSpeechRecognition(videoTranscriptionData) {
    return function (dispatch, getState) {
        if (window.appManager.isDemoMode()) {
            return;
        }

        if (videoTranscriptionData.recognitionDone) {
            return;
        }

        var processingTracker = new _ProcessingTracker2.default('VIDEO_TRANSCRIPTION', videoTranscriptionData.id);

        processingTracker.onData(function (videoTranscriptionData) {
            if (videoTranscriptionData.recognitionDone) {
                var _videoTranscriptionDa = videoTranscriptionData.subtitleData,
                    subtitleData = _videoTranscriptionDa === undefined ? '[]' : _videoTranscriptionDa,
                    clipStart = videoTranscriptionData.clipStart,
                    clipDuration = videoTranscriptionData.clipDuration;

                subtitleData = JSON.parse(subtitleData);

                dispatch(addSubtitleOnVideo(videoTranscriptionData.videoId, clipStart, clipDuration, subtitleData));

                dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE, subtitleData: subtitleData });
                var subtitleLoggingData = getSubtitleLoggingData(getState().subtitles);
                dispatch((0, _logActions.logSubtitleAddition)(_extends({
                    mediaType: 'video',
                    videoId: videoTranscriptionData.videoId,
                    clipStart: clipStart,
                    clipDuration: clipDuration,
                    source: 'Auto-generate'
                }, subtitleLoggingData)));

                processingTracker.stopTracking();
            }
        }).startTracking();
    };
}

function getSubtitleLoggingData(subtitleState) {
    var sourceLanguage = subtitleState.sourceLanguage,
        targetLanguage = subtitleState.targetLanguage,
        selectedTemplateName = subtitleState.selectedTemplateName,
        subtitlePosition = subtitleState.subtitlePosition;

    var captionType = sourceLanguage.split('-')[0] !== targetLanguage ? 'Translation' : 'Transcription';
    return {
        'Caption Type': captionType,
        'Source Language': sourceLanguage,
        'Caption Language': targetLanguage,
        Theme: selectedTemplateName,
        'Default Position': subtitlePosition
    };
}

function trackProcessingForAudioSpeechRecognition(audioTranscriptionData) {
    return function (dispatch, getState) {
        if (window.appManager.isDemoMode()) {
            return;
        }

        var _getState6 = getState(),
            duration = _getState6.player.duration;

        if (audioTranscriptionData.recognitionDone) {
            return;
        }

        var processingTracker = new _ProcessingTracker2.default('AUDIO_TRANSCRIPTION', audioTranscriptionData.id);

        processingTracker.onData(function (audioTranscriptionData) {
            if (audioTranscriptionData.recognitionDone) {
                var _audioTranscriptionDa = audioTranscriptionData.subtitleData,
                    subtitleData = _audioTranscriptionDa === undefined ? '[]' : _audioTranscriptionDa,
                    audioId = audioTranscriptionData.audioId;

                subtitleData = JSON.parse(subtitleData);

                subtitleData = subtitleData.filter(function (sub) {
                    return sub.startTime < duration;
                });

                dispatch(addSubtitlesOnProject(subtitleData));

                dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE, subtitleData: subtitleData });
                var subtitleLoggingData = getSubtitleLoggingData(getState().subtitles);
                dispatch((0, _logActions.logSubtitleAddition)(_extends({
                    mediaType: 'audio',
                    audioId: audioId,
                    source: 'Auto-generate'
                }, subtitleLoggingData)));

                processingTracker.stopTracking();
            }
        }).startTracking();
    };
}

function generateSpeechToText() {
    var transcribeBackgroundAudio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        dispatch({ type: SubtitleActionType.AUTO_GENERATE });

        if (window.appManager.isDemoMode()) {
            setTimeout(function () {
                dispatch(addSubtitlesOnProject(_DemoCaptionData2.default));
                dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE });
            }, 5000);
            return;
        }

        var _getState7 = getState(),
            duration = _getState7.player.duration,
            _getState7$subtitles = _getState7.subtitles,
            sourceLanguage = _getState7$subtitles.sourceLanguage,
            targetLanguage = _getState7$subtitles.targetLanguage;

        var projectId = getState().project.id;

        (0, _api.generateSubtitlesP)({
            projectId: projectId,
            transcribeBackgroundAudio: transcribeBackgroundAudio,
            sourceLanguage: sourceLanguage,
            targetLanguage: targetLanguage
        }).then(function (result) {
            var _result$processingVid = result.processingVideoTranscriptionIds,
                processingVideoTranscriptionIds = _result$processingVid === undefined ? [] : _result$processingVid,
                _result$processingAud = result.processingAudioTranscriptionIds,
                processingAudioTranscriptionIds = _result$processingAud === undefined ? [] : _result$processingAud,
                _result$videosSubtitl = result.videosSubtitleData,
                videosSubtitleData = _result$videosSubtitl === undefined ? [] : _result$videosSubtitl,
                _result$audiosSubtitl = result.audiosSubtitleData,
                audiosSubtitleData = _result$audiosSubtitl === undefined ? {} : _result$audiosSubtitl;

            var isAnyVideoSubtitleAvailable = processingVideoTranscriptionIds.length > 0 || videosSubtitleData.length > 0;
            var isAnyAudioSubtitleAvailable = processingAudioTranscriptionIds.length > 0 || Object.keys(audiosSubtitleData).length > 0;

            if (!isAnyVideoSubtitleAvailable && !isAnyAudioSubtitleAvailable) {
                dispatch({
                    type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE,
                    subtitleData: []
                });
                return;
            }

            processingVideoTranscriptionIds.forEach(function (videoTranscriptionId) {
                var videoTranscriptionData = {
                    id: videoTranscriptionId,
                    recognitionDone: false
                };
                dispatch(trackProcessingForVideoSpeechRecognition(videoTranscriptionData));
            });

            processingAudioTranscriptionIds.forEach(function (audioTranscriptionId) {
                var audioTranscriptionData = {
                    id: audioTranscriptionId,
                    recognitionDone: false
                };
                dispatch(trackProcessingForAudioSpeechRecognition(audioTranscriptionData));
            });

            // Add already done data
            videosSubtitleData.forEach(function (vsd) {
                var videoId = vsd.videoId,
                    clipStart = vsd.clipStart,
                    clipDuration = vsd.clipDuration,
                    subtitleData = vsd.subtitleData;

                dispatch(addSubtitleOnVideo(videoId, clipStart, clipDuration, subtitleData));
                dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE, subtitleData: subtitleData });

                var subtitleLoggingData = getSubtitleLoggingData(getState().subtitles);

                dispatch((0, _logActions.logSubtitleAddition)(_extends({
                    mediaType: 'video',
                    videoId: videoId,
                    clipStart: clipStart,
                    clipDuration: clipDuration,
                    source: 'Auto-generate'
                }, subtitleLoggingData)));
            });

            // Add already done data
            Object.keys(audiosSubtitleData).forEach(function (audioId) {
                var subtitleData = audiosSubtitleData[audioId].filter(function (sub) {
                    return sub.startTime < duration;
                });

                dispatch(addSubtitlesOnProject(subtitleData));
                dispatch({ type: SubtitleActionType.SUBTITLE_LOADING_COMPLETE });

                var subtitleLoggingData = getSubtitleLoggingData(getState().subtitles);
                dispatch((0, _logActions.logSubtitleAddition)(_extends({
                    mediaType: 'audio',
                    audioId: audioId,
                    source: 'Auto-generate'
                }, subtitleLoggingData)));
            });
        }).catch(function (err) {
            console.log(err); /* Nothing */
        });

        return null;
    };
}

function cancelSpeechToText() {
    return function (dispatch, getState) {
        dispatch(goToAddContent());
        // TODO api to cancel speech to text
    };
}

function changeSubtitleValue(newOverlay, defModel) {
    return function (dispatch, getState) {
        var _getState$subtitles = getState().subtitles,
            subtitlePosition = _getState$subtitles.subtitlePosition,
            subtitlePadding = _getState$subtitles.subtitlePadding;

        var _getState8 = getState(),
            canvas = _getState8.reel.canvas;

        var contentBox = getFrameContentBox(getState());

        var updatedSpace = newOverlay.space;
        updatedSpace.y = getOverlayPosition(subtitlePosition, canvas.height, defModel.space.height, contentBox, subtitlePadding);
        newOverlay = (0, _deepmerge2.default)(newOverlay, {
            space: updatedSpace
        });

        dispatch((0, _overlayActions.changeOverlayFinishFromCurrent)(newOverlay));
    };
}

function changeSubtitleFont(fontKey) {
    return function (dispatch, getState) {
        var state = getState();
        var oldFontKey = state.subtitles.subtitleFont;

        dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.FONT, { Font: fontKey }));

        if (oldFontKey === fontKey) {
            return;
        }

        dispatch({ type: SubtitleActionType.CHANGE_FONT, fontKey: fontKey, oldFontKey: oldFontKey });

        // const subtitleOverlays = getAllSubtitleOverlays(getState())

        // const prop = 'fontFamily'

        // dispatch(runWithDelay(() => {
        //     subtitleOverlays.forEach(overlay => {
        //         overlay.values[prop] = fontKey
        //         overlay.variant = { [prop] : FontManager.getVariantObject(fontKey) }
        //         dispatch(changeOverlayFinishFromCurrent(overlay))
        //     })
        // }))

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var prop = 'fontFamily';
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = subtitleOverlays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var overlay = _step.value;

                overlay.values[prop] = fontKey;
                overlay.variant = _defineProperty({}, prop, _FontManager2.default.getVariantObject(fontKey));
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function changeSubtitleColor(color, isTextColor, oldColor) {
    return function (dispatch, getState) {
        var state = getState();

        var property = {};
        var action = '';
        if (isTextColor) {
            property['Text Color'] = color;
            action = _logActions.captionActionTypes.TEXT_COLOR;
        } else {
            property['Background Color'] = color;
            action = _logActions.captionActionTypes.BACKGROUND_COLOR;
        }

        // const subtitleOverlays = getAllSubtitleOverlays(getState())

        // const prop = isTextColor ? 'textColor' : 'color'

        // dispatch(runWithDelay(() => {
        //     subtitleOverlays.forEach(overlay => {
        //         overlay.values[prop] = color

        //         dispatch(changeOverlayFinishFromCurrent(overlay))
        //     })
        // }))

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var prop = isTextColor ? 'textColor' : 'color';
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = subtitleOverlays[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var overlay = _step2.value;

                overlay.values[prop] = color;
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        (0, _reactRedux.batch)(function () {
            dispatch((0, _logActions.logSubtitleActions)(action, property));
            dispatch({ type: SubtitleActionType.CHANGE_COLOR, color: color, isTextColor: isTextColor, oldColor: oldColor });
            dispatch(overlayActions.changeMultipleOverlays(newOverlays));
        });
    };
}

function changeSubtitleFontSize(fontSize, oldFontSize) {
    return function (dispatch, getState) {
        var state = getState();
        var _state$subtitles3 = state.subtitles,
            oldFontSize = _state$subtitles3.fontSize,
            subtitlePosition = _state$subtitles3.subtitlePosition;

        dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.FONT_SIZE, { 'Font Size': fontSize }));
        if (oldFontSize === fontSize) {
            return;
        }

        dispatch({ type: SubtitleActionType.CHANGE_FONT_SIZE, fontSize: fontSize, oldFontSize: oldFontSize });

        // const subtitleOverlays = getAllSubtitleOverlays(getState())

        // const prop = 'fontSize'

        // dispatch(runWithDelay(() => {
        //     subtitleOverlays.forEach(overlay => {
        //         overlay.values[prop] = fontSize * 2

        //         dispatch(changeOverlayFinishFromCurrent(overlay))
        //     })

        //     dispatch(switchSubtitlePosition())
        // }))

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var prop = 'fontSize';
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = subtitleOverlays[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var overlay = _step3.value;

                overlay.values[prop] = fontSize * 2;
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function changeSubtitleAlignment(alignment, oldAlignment) {
    return function (dispatch, getState) {
        var state = getState();
        var oldSubtitleAlignment = state.subtitles.subtitleAlignment;

        dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.ALIGNMENT, { Alignment: alignment }));

        if (oldSubtitleAlignment === alignment) {
            return;
        }

        dispatch({ type: SubtitleActionType.CHANGE_ALIGNNENT, alignment: alignment, oldAlignment: oldAlignment });

        // const subtitleOverlays = getAllSubtitleOverlays(getState())

        // const prop = 'align'

        // dispatch(runWithDelay(() => {
        //     subtitleOverlays.forEach(overlay => {
        //         overlay.values[prop] = alignment

        //         dispatch(changeOverlayFinishFromCurrent(overlay))
        //     })
        // }))

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var prop = 'align';
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = subtitleOverlays[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var overlay = _step4.value;

                overlay.values[prop] = alignment;
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function changeSubtitleAnimations(subtitleEnterAnimDefId, subtitleExitAnimDefId, subtitleEnterAnimManualMode, subtitleEnterAnimDuration, subtitleExitAnimManualMode, subtitleExitAnimDuration) {
    return function (dispatch, getState) {
        dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.ANIMATION, {
            'Enter Animation': subtitleEnterAnimDefId,
            'Exit Animation': subtitleExitAnimDefId
        }));
        dispatch({
            type: SubtitleActionType.CHANGE_ANIMATION,
            subtitleEnterAnimDefId: subtitleEnterAnimDefId,
            subtitleExitAnimDefId: subtitleExitAnimDefId,
            subtitleEnterAnimManualMode: subtitleEnterAnimManualMode,
            subtitleEnterAnimDuration: subtitleEnterAnimDuration,
            subtitleExitAnimManualMode: subtitleExitAnimManualMode,
            subtitleExitAnimDuration: subtitleExitAnimDuration
        });

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());

        dispatch(runWithDelay(function () {
            subtitleOverlays.forEach(function (o) {
                var def = getTemplateDefForId(o.defId);
                var ops = alphaProps(def);
                if (ops.length > 0) {
                    var _ops3 = _slicedToArray(ops, 1),
                        op = _ops3[0];

                    o.values[op] = subtitleOpacity;
                }

                if (subtitleEnterAnimDefId) {
                    o.time.enterAnimDefId = subtitleEnterAnimDefId;
                    o.time.enterAnimTimeManual = !!subtitleEnterAnimManualMode;
                    if (subtitleEnterAnimDuration) o.time.enterdone === o.time.enterstart + subtitleEnterAnimDuration;
                }

                if (subtitleExitAnimDefId) {
                    o.time.exitAnimDefId = subtitleExitAnimDefId;
                    o.time.exitAnimTimeManual = !!subtitleExitAnimManualMode;
                    if (subtitleExitAnimDuration) o.time.exitstart === o.time.exitdone - subtitleExitAnimDuration;
                }

                dispatch((0, _overlayActions.changeOverlayFinishFromCurrent)(o));
            });
        }));
    };
}

function toggleSubtitleShadow() {
    return function (dispatch, getState) {
        var _getState9 = getState(),
            _getState9$subtitles$ = _getState9.subtitles.subtitleShadow,
            isShadowEnabled = _getState9$subtitles$ === undefined ? true : _getState9$subtitles$;

        dispatch({ type: SubtitleActionType.SET_SUBTITLE_SHADOW, isEnabled: !isShadowEnabled });

        // const subtitleOverlays = getAllSubtitleOverlays(getState())

        // const prop = 'shadow'

        // dispatch(runWithDelay(() => {
        //     subtitleOverlays.forEach(overlay => {
        //         overlay.values[prop] = !isShadowEnabled

        //         dispatch(changeOverlayFinishFromCurrent(overlay))
        //     })
        // }))

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var prop = 'shadow';
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = subtitleOverlays[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var overlay = _step5.value;

                overlay.values[prop] = !isShadowEnabled;
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function changeSubtitleWidth(width) {
    return function (dispatch, getState) {
        var state = getState();

        var canvas = state.reel.canvas;

        if (!width) {
            width = getDefaultWidthForFormatId(state.formats, state.reel.formatId);
        }
        dispatch({ type: SubtitleActionType.CHANGE_WIDTH, width: width });

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = subtitleOverlays[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var overlay = _step6.value;

                overlay.space.width = canvas.width * width / 100;
                overlay.space.x = (canvas.width - overlay.space.width) / 2;
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function switchSubtitlePosition(position, oldPosition) {
    return function (dispatch, getState) {
        var state = getState();
        dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.POSITION, { Position: position }));
        var subtitlePadding = state.subtitles.subtitlePadding;

        if (!position) {
            position = state.subtitles.subtitlePosition;
        }

        dispatch({ type: SubtitleActionType.CHANGE_POSITION, position: position, oldPosition: oldPosition });

        var canvas = state.reel.canvas;

        // const subtitleOverlays = getAllSubtitleOverlays(getState())

        // let contentBox = getFrameContentBox(getState())

        // dispatch(runWithDelay(() => {
        //     subtitleOverlays.forEach(o => {
        //         o.space.y = getOverlayPosition(position, canvas.height, o.space.height, contentBox)

        //         dispatch(changeOverlayFinishFromCurrent(o))
        //     })
        // }))

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var contentBox = getFrameContentBox(getState());
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = subtitleOverlays[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var overlay = _step7.value;

                overlay.space.y = getOverlayPosition(position, canvas.height, overlay.space.height, contentBox, subtitlePadding);
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function changeSubtitlePadding() {
    var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    return function (dispatch, getState) {
        var state = getState();
        dispatch({ type: SubtitleActionType.CHANGE_PADDING, padding: padding });

        var canvas = state.reel.canvas,
            subtitlePosition = state.subtitles.subtitlePosition;

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
        var newOverlays = [];
        var contentBox = getFrameContentBox(getState());
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = subtitleOverlays[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var overlay = _step8.value;

                overlay.space.y = getOverlayPosition(subtitlePosition, canvas.height, overlay.space.height, contentBox, padding);
                newOverlays.push(overlay);
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }

        dispatch(overlayActions.changeMultipleOverlays(newOverlays));
    };
}

function enableCaptions() {
    return function (dispatch, getState) {
        var workspaceId = getState().workspaceInfo.activeWorkspace.workspaceId;

        var _getState10 = getState(),
            userId = _getState10.ui.userId;

        (0, _api.enableCaptionsP)().then(function (response) {
            if (response.success) {
                dispatch({ type: SubtitleActionType.ENABLE_CAPTIONS });
                try {
                    tracker.trackOn('Captions enabled', { workspaceId: workspaceId, userId: userId }, {
                        PostHog: true,
                        FreshChat: true,
                        Smartlook: true
                    });
                } catch (err) {
                    console.log('Could not log event Enable captions');
                    console.error(err);
                }
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
}

function changeAnimationType(kind, animDefId) {
    return function (dispatch, getState) {
        var _getState11 = getState(),
            overlays = _getState11.overlays;

        var subtitleOverlaysIds = (0, _subtitleSelectors.getSubtitleOverlayIds)(getState());

        var type = kind === 'enter' ? _overlayActions.OverlayActionType.SET_IN_ANIM : _overlayActions.OverlayActionType.SET_OUT_ANIM;

        dispatch({ type: type, ids: subtitleOverlaysIds, animDefId: animDefId });

        type = kind === 'enter' ? _overlayActions.OverlayActionType.SET_IN_ANIM_DURATION : _overlayActions.OverlayActionType.SET_OUT_ANIM_DURATION;
        if (animDefId === 'animDefId-OUT-NONE' || animDefId === 'animDefId-IN-NONE') {
            var duration = 0;
            dispatch({ type: type, ids: subtitleOverlaysIds, duration: duration });
        } else {
            var _duration = 200;
            if (Object.keys(subtitleOverlaysIds).length) {
                var times = overlays[Object.keys(subtitleOverlaysIds)[0]].time;
                _duration = kind === 'enter' ? times.enterdone - times.enterstart : times.exitdone - times.exitstart;
                _duration = !_duration ? 200 : _duration;
            }
            dispatch({ type: type, ids: subtitleOverlaysIds, duration: _duration });
        }
    };
}

function changeAnimationDuration(kind, duration) {
    return function (dispatch, getState) {
        var subtitleOverlaysIds = (0, _subtitleSelectors.getSubtitleOverlayIds)(getState());

        var type = kind === 'enter' ? _overlayActions.OverlayActionType.SET_IN_ANIM_DURATION : _overlayActions.OverlayActionType.SET_OUT_ANIM_DURATION;

        dispatch({ type: type, ids: subtitleOverlaysIds, duration: duration });
    };
}

function changeAnimationManualMode(kind, isManual, duration) {
    return function (dispatch, getState) {
        var subtitleOverlaysIds = (0, _subtitleSelectors.getSubtitleOverlayIds)(getState());

        var type = kind === 'enter' ? _overlayActions.OverlayActionType.SET_IN_ANIM_DURATION_MANUAL_MODE : _overlayActions.OverlayActionType.SET_OUT_ANIM_DURATION_MANUAL_MODE;

        dispatch({ type: type, ids: subtitleOverlaysIds, isManual: isManual, duration: duration });
    };
}

function deleteSubtitles() {
    return function (dispatch, getState) {
        dispatch((0, _overlayActions.selectClear)());
        dispatch({ type: SubtitleActionType.DELETE_ALL_SUBTITLE });
        dispatch(gotoModeSelection());
        dispatch(modeActions.openSubtitleShelf());
    };
}

function changeSubtitleLineHeight(lineHeight, incremental, startValue) {
    return function (dispatch, getState) {
        if (incremental) dispatch({
            type: SubtitleActionType.CHANGE_LINE_HEIGHT_INCR,
            subtitleLineHeight: lineHeight
        });else if (startValue) {
            (0, _reactRedux.batch)(function () {
                dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.LINE_HEIGHT, {
                    'Line Height': (+lineHeight).toFixed(2)
                }));
                dispatch({
                    type: SubtitleActionType.CHANGE_LINE_HEIGHT_FINISH,
                    subtitleLineHeight: lineHeight,
                    startValue: startValue
                });
            });
        } else dispatch({
            type: SubtitleActionType.CHANGE_LINE_HEIGHT,
            subtitleLineHeight: lineHeight
        });

        updateAllSubtitlesLineHeightDebounced(getState, dispatch, lineHeight);
    };
}
function updateAllSubtitlesLineHeight(getState, dispatch, lineHeight) {
    var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
    var newOverlays = [];
    var prop = 'lineHeight';
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
        for (var _iterator9 = subtitleOverlays[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var overlay = _step9.value;

            overlay.values[prop] = lineHeight;
            newOverlays.push(overlay);
        }
    } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
            }
        } finally {
            if (_didIteratorError9) {
                throw _iteratorError9;
            }
        }
    }

    dispatch(overlayActions.changeMultipleOverlays(newOverlays));
}
var updateAllSubtitlesLineHeightDebounced = (0, _GeneralUtils.debounce)(function (getState, dispatch, lineHeight) {
    updateAllSubtitlesLineHeight(getState, dispatch, lineHeight);
}, 200);

function changeSubtitleLetterSpacing(letterSpacing, incremental, startValue) {
    return function (dispatch, getState) {
        if (incremental) dispatch({
            type: SubtitleActionType.CHANGE_LETTER_SPACING_INCR,
            subtitleLetterSpacing: letterSpacing
        });else if (startValue) {
            (0, _reactRedux.batch)(function () {
                dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.LETTER_SPACING, {
                    'Letter Spacing': (+letterSpacing).toFixed(2)
                }));
                dispatch({
                    type: SubtitleActionType.CHANGE_LETTER_SPACING_FINISH,
                    subtitleLetterSpacing: letterSpacing,
                    startValue: startValue
                });
            });
        } else dispatch({
            type: SubtitleActionType.CHANGE_LETTER_SPACING,
            subtitleLetterSpacing: letterSpacing
        });

        updateAllSubtitlesLetterSpacingDebounced(getState, dispatch, letterSpacing);
    };
}

function updateAllSubtitlesLetterSpacing(getState, dispatch, letterSpacing) {
    var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
    var newOverlays = [];
    var prop = 'letterSpacing';
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
        for (var _iterator10 = subtitleOverlays[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var overlay = _step10.value;

            overlay.values[prop] = letterSpacing;
            newOverlays.push(overlay);
        }
    } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
            }
        } finally {
            if (_didIteratorError10) {
                throw _iteratorError10;
            }
        }
    }

    dispatch(overlayActions.changeMultipleOverlays(newOverlays));
}

var updateAllSubtitlesLetterSpacingDebounced = (0, _GeneralUtils.debounce)(function (getState, dispatch, letterSpacing) {
    updateAllSubtitlesLetterSpacing(getState, dispatch, letterSpacing);
}, 200);

function changeSubtitleOpacity() {
    var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var incremental = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var startValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return function (dispatch, getState) {
        if (incremental) dispatch({ type: SubtitleActionType.CHANGE_OPACITY_INCR, subtitleOpacity: opacity });else if (startValue) {
            (0, _reactRedux.batch)(function () {
                dispatch((0, _logActions.logSubtitleActions)(_logActions.captionActionTypes.OPACITY, { Opacity: opacity }));
                dispatch({
                    type: SubtitleActionType.CHANGE_OPACITY_FINISH,
                    subtitleOpacity: opacity,
                    startValue: startValue
                });
            });
        } else dispatch({ type: SubtitleActionType.CHANGE_OPACITY, subtitleOpacity: opacity });

        updateAllSubtitlessOpacityDebounced(getState, dispatch, opacity);
    };
}

var updateAllSubtitlessOpacityDebounced = (0, _GeneralUtils.debounce)(function (getState, dispatch, opacity) {
    updateAllSubtitlesOpacity(getState, dispatch, opacity);
}, 200);

function updateAllSubtitlesOpacity(getState, dispatch, opacity) {
    var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(getState());
    var newOverlays = [];
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
        for (var _iterator11 = subtitleOverlays[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var overlay = _step11.value;

            var def = getTemplateDefForId(overlay.defId);
            var ops = alphaProps(def);
            if (ops.length > 0) {
                var _ops4 = _slicedToArray(ops, 1),
                    op = _ops4[0];

                overlay.values[op] = opacity;
            }
            newOverlays.push(overlay);
        }
    } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
            }
        } finally {
            if (_didIteratorError11) {
                throw _iteratorError11;
            }
        }
    }

    dispatch(overlayActions.changeMultipleOverlays(newOverlays));
}

},{"../../common/config/DemoCaptionData.json":41,"../../common/config/TranslationLanguages.json":43,"../../common/utils/ColorRange":71,"../../common/utils/FontManager":76,"../../common/utils/GeneralUtils":77,"../../common/utils/HighlightColorRange":78,"../../common/utils/ReelHelpers":85,"../../common/utils/TrackUtils":90,"../../common/utils/renderer/DefModel":119,"../../common/utils/renderer/LayerUtils":121,"../api":176,"../constants/SubtitlePosition":207,"../constants/SubtitleWidthForFormat":208,"../selectors/miscSelectors":215,"../selectors/overlaySelectors":217,"../selectors/subtitleSelectors":224,"../utils/FileUploadManager":229,"../utils/OverlayUtils":231,"../utils/ProcessingTracker":232,"../utils/ReelUtils":233,"./emptyProjectActions":155,"./logActions":160,"./modeActions":162,"./overlayActions":165,"./reelActions":170,"cloneextend":412,"deepmerge":549,"diff-match-patch":553,"keymirror":677,"react-redux":1079}],174:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UIActionType = undefined;
exports.closeFreeProjectModal = closeFreeProjectModal;
exports.closeCopyBanner = closeCopyBanner;
exports.changeStockMediaAddingId = changeStockMediaAddingId;
exports.snapScrollTimeToTimeline = snapScrollTimeToTimeline;
exports.setDownlodingIconScoutItem = setDownlodingIconScoutItem;
exports.setUISelectionMode = setUISelectionMode;
exports.setDraggingMedia = setDraggingMedia;
exports.toggleDnDIntroModal = toggleDnDIntroModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _userApi = require('../../common/api/userApi');

var UserApi = _interopRequireWildcard(_userApi);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// TODO ignore in persistence engine
var UIActionType = exports.UIActionType = (0, _keymirror2.default)({
    FREE_PROJECT_MODAL_SHOW: null,
    FREE_PROJECT_MODAL_CLOSE: null,

    HIDE_COPY_BANNER: null,

    CHANGE_STOCK_MEDIA_ADDING_ID: null,

    SYNC_TIMELINE_SCROLL_TO_CURRENT_TIME: null,

    CHANGE_CURRENT_DOWNLOADING_ICONSCOUT_ID: null,

    CHANGE_UI_SELECTION_MODE: null,

    DRAGGING_MEDIA: null,

    TOGGLE_DND_INTRO_MODAL: null
});

function closeFreeProjectModal() {
    return function (dispatch) {
        dispatch({ type: UIActionType.FREE_PROJECT_MODAL_CLOSE });
    };
}

function closeCopyBanner() {
    return { type: UIActionType.HIDE_COPY_BANNER };
}

function changeStockMediaAddingId(id) {
    return { type: UIActionType.CHANGE_STOCK_MEDIA_ADDING_ID, id: id };
}

function snapScrollTimeToTimeline() {
    var shouldSnap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return { type: UIActionType.SYNC_TIMELINE_SCROLL_TO_CURRENT_TIME, shouldSnap: shouldSnap };
}

function setDownlodingIconScoutItem(currentIconscoutAssetDownloading) {
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return {
        type: UIActionType.CHANGE_CURRENT_DOWNLOADING_ICONSCOUT_ID,
        currentIconscoutAssetDownloading: currentIconscoutAssetDownloading,
        state: state
    };
}

function setUISelectionMode(mode) {
    return { type: UIActionType.CHANGE_UI_SELECTION_MODE, mode: mode };
}

function setDraggingMedia(isDragging) {
    return { type: UIActionType.DRAGGING_MEDIA, isDragging: isDragging };
}

function toggleDnDIntroModal(show) {
    return function (dispatch) {
        dispatch({ type: UIActionType.TOGGLE_DND_INTRO_MODAL, show: show });

        if (show) {
            UserApi.saveDndIntroShown();
        }
    };
}

},{"../../common/api/userApi":5,"keymirror":677}],175:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MediaLibraryModalActionType = exports.FormatSelectUIState = exports.FormatSelectActionType = exports.ReviewPremiumInstanceUIState = exports.ReviewInstanceActionType = exports.WorkspaceActionType = exports.WorkspaceMediaActionsType = exports.UserActionType = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.updateWorkspaceInfo = updateWorkspaceInfo;
exports.updateStorageUsedInfo = updateStorageUsedInfo;
exports.resetUpgradeStatus = resetUpgradeStatus;
exports.showPremiumInstances = showPremiumInstances;
exports.closePremiumInstances = closePremiumInstances;
exports.upgradePlanFromPremiumInstancesModal = upgradePlanFromPremiumInstancesModal;
exports.openFormatSelector = openFormatSelector;
exports.closeFormatSelector = closeFormatSelector;
exports.fetchWorkspaceMedia = fetchWorkspaceMedia;
exports.fetchWorkspaceProjectsDetail = fetchWorkspaceProjectsDetail;
exports.fetchProjectMedia = fetchProjectMedia;
exports.openMediaLibraryModal = openMediaLibraryModal;
exports.closeMediaLibraryModal = closeMediaLibraryModal;
exports.updateUserWorkflows = updateUserWorkflows;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _workspaceApi = require('../../common/api/workspaceApi');

var _api = require('../api');

var _WorkspaceUpdateStatus = require('../constants/WorkspaceUpdateStatus');

var _WorkspaceUpdateStatus2 = _interopRequireDefault(_WorkspaceUpdateStatus);

var _mediaActions = require('./mediaActions');

var _projectActions = require('../../home/actions/projectActions');

var _pricingActions = require('../../pricing/actions/pricingActions');

var _errorReporting = require('../../common/utils/errorReporting');

var _TrackUtils = require('../../common/utils/TrackUtils');

var _overlaySelectors = require('../selectors/overlaySelectors');

var _subtitleSelectors = require('../selectors/subtitleSelectors');

var _miscSelectors = require('../selectors/miscSelectors');

var _planDataSelector = require('../selectors/planDataSelector');

var _OverlayUtils = require('../utils/OverlayUtils');

var _userApi = require('../../common/api/userApi');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var UserActionType = exports.UserActionType = (0, _keymirror2.default)({
    UPDATE_USER_WORKFLOW_DATA: null
});

var WorkspaceMediaActionsType = exports.WorkspaceMediaActionsType = (0, _keymirror2.default)({
    ADD_DURING_UPLOAD: null
});

// Ignored in persistance middleware
var WorkspaceActionType = exports.WorkspaceActionType = (0, _keymirror2.default)({
    UPDATE_WORKSPACES: null,
    INITIAL: null,
    UPDATING: null,
    UPDATED: null,
    UPDATE_STORAGE_USED_INFO: null
});

// Ignored in persistance middleware
var ReviewInstanceActionType = exports.ReviewInstanceActionType = (0, _keymirror2.default)({
    REVIEW_PREMIUM_INSTANCE_OPEN: null,
    REVIEW_PREMIUM_INSTANCE_CLOSED: null
});

// Ignored in persistance middleware
var ReviewPremiumInstanceUIState = exports.ReviewPremiumInstanceUIState = (0, _keymirror2.default)({
    OPEN: null,
    CLOSED: null
});

// Ignored in persistance middleware
var FormatSelectActionType = exports.FormatSelectActionType = (0, _keymirror2.default)({
    FORMAT_SELECT_OPEN: null,
    FORMAT_SELECT_CLOSED: null
});

// Ignored in persistance middleware
var FormatSelectUIState = exports.FormatSelectUIState = (0, _keymirror2.default)({
    OPEN: null,
    CLOSED: null
});

// Ignored in persistance middleware
var MediaLibraryModalActionType = exports.MediaLibraryModalActionType = (0, _keymirror2.default)({
    MEDIA_LIB_OPEN: null,
    MEDIA_LIB_CLOSE: null,
    MEDIA_LIB_UPDATE_DELETE_STATE: null,

    PROJECT_DETAILS_UPDATING: null,
    PROJECT_DETAILS_UPDATED: null
});

function updateWorkspaceInfo() {
    var updateUpgradeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return async function (dispatch, getState) {
        if (updateUpgradeState) {
            dispatch({ type: _WorkspaceUpdateStatus2.default.UPDATING });
        }
        try {
            var workspaces = await (0, _workspaceApi.getWorkspaceDataP)();

            dispatch({ type: WorkspaceActionType.UPDATE_WORKSPACES, workspaces: workspaces });
            if (updateUpgradeState) {
                dispatch({ type: _WorkspaceUpdateStatus2.default.UPDATED });
            }
        } catch (err) {
            (0, _errorReporting.reportError)(new _errorReporting.WorkspaceUpdateError(err));
        }
    };
}

function updateStorageUsedInfo(fileSizeInBytes) {
    return { type: WorkspaceActionType.UPDATE_STORAGE_USED_INFO, fileSizeInBytes: fileSizeInBytes };
}

function resetUpgradeStatus() {
    return function (dispatch, getState) {
        dispatch({ type: _WorkspaceUpdateStatus2.default.INITIAL });
    };
}

function showPremiumInstances() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        source = _ref.source;

    return function (dispatch, getState) {
        (0, _TrackUtils.trackOn)('Premium instances modal shown', { via: source }, { All: true, Smartlook: false });
        dispatch({ type: ReviewInstanceActionType.REVIEW_PREMIUM_INSTANCE_OPEN });
    };
}

function closePremiumInstances() {
    return function (dispatch, getState) {
        dispatch({ type: ReviewInstanceActionType.REVIEW_PREMIUM_INSTANCE_CLOSED });
    };
}

function upgradePlanFromPremiumInstancesModal() {
    return function (dispatch, getState) {
        var state = getState();

        var _state$ui$isCaptionsD = state.ui.isCaptionsDemo,
            isCaptionsDemo = _state$ui$isCaptionsD === undefined ? false : _state$ui$isCaptionsD;

        var uniqueCustomFontsInNonCaptions = (0, _overlaySelectors.getUniqueCustomFontInNonCaptionOverlays)(state);
        var uniqueCustomFontsInCaptions = (0, _overlaySelectors.getUniqueCustomFontInCaptions)(state);

        var subtitleOverlays = (0, _subtitleSelectors.getAllSubtitleOverlays)(state);
        var subtitleCount = subtitleOverlays.length;

        var customFormat = (0, _miscSelectors.getSelectedCustomFormat)(state);

        var _isProjectDurationExc = (0, _planDataSelector.isProjectDurationExceededSelector)(state),
            isProjectDurationExceeded = _isProjectDurationExc.isProjectDurationExceeded,
            isExportDurationExceeded = _isProjectDurationExc.isExportDurationExceeded;

        var trackingData = {
            hasCustomFormat: !!customFormat,
            customFontInstances: uniqueCustomFontsInNonCaptions.toString(),
            customFontsUnique: uniqueCustomFontsInNonCaptions.length,
            hasCaptions: subtitleCount > 0,
            captionOverlayCount: subtitleCount,
            customCaptionsFont: uniqueCustomFontsInCaptions.toString(),
            isProjectDurationExceeded: isProjectDurationExceeded,
            isExportDurationExceeded: isExportDurationExceeded
        };

        (0, _TrackUtils.trackOnPostHog)('Clicked upgrade on review instances popup', trackingData);

        if (isCaptionsDemo) {
            window.open('/pricing', '_blank');
        } else {
            dispatch((0, _pricingActions.openPlanModal)(JSON.stringify(trackingData)));
        }
    };
}

function openFormatSelector() {
    return function (dispatch, getState) {
        dispatch({ type: FormatSelectActionType.FORMAT_SELECT_OPEN });
    };
}

function closeFormatSelector() {
    return function (dispatch, getState) {
        dispatch({ type: FormatSelectActionType.FORMAT_SELECT_CLOSED });
    };
}

function fetchWorkspaceMedia() {
    return async function (dispatch, getState) {
        dispatch({ type: _mediaActions.MediaActionType.WORKSPACE_MEDIA_UPDATING });
        try {
            var workspaceMedia = await (0, _api.getWorkspaceMediaP)();
            dispatch((0, _mediaActions.updateWorkspaceMedia)(workspaceMedia));
        } catch (err) {
            (0, _errorReporting.reportError)(new _errorReporting.WorkspaceMediaRetrivalFailingError('Couldn\'t fetch workspace media: ' + err));
        }
    };
}

function fetchWorkspaceProjectsDetail() {
    return async function (dispatch, getState) {
        dispatch({ type: MediaLibraryModalActionType.PROJECT_DETAILS_UPDATING });

        try {
            var _ref2 = await (0, _projectActions.searchProjects)(false, undefined, true),
                _ref3 = _slicedToArray(_ref2, 2),
                totalProjectsCount = _ref3[0],
                projects = _ref3[1];

            dispatch((0, _mediaActions.updateWorkspaceProjects)(projects));
        } catch (err) {
            (0, _errorReporting.reportError)(new _errorReporting.ProjectsRetrivalFailingError(err));
        }
    };
}

function fetchProjectMedia() {
    return async function (dispatch, getState) {
        dispatch({ type: _mediaActions.MediaActionType.PROJECT_MEDIA_UPDATING });

        var _getState = getState(),
            projectId = _getState.project.id;

        try {
            var projectMedia = await (0, _api.getProjectMediaP)(projectId);

            dispatch((0, _mediaActions.updateProjectMedia)(projectMedia));
        } catch (err) {
            (0, _errorReporting.reportError)(new _errorReporting.WorkspaceMediaRetrivalFailingError('Couldn\'t fetch project media: ' + err));
        }
    };
}

function openMediaLibraryModal() {
    var triggerAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return function (dispatch, getState) {
        dispatch({ type: MediaLibraryModalActionType.MEDIA_LIB_OPEN, triggerAction: triggerAction });
        (0, _reactRedux.batch)(function () {
            dispatch(fetchWorkspaceMedia());
            dispatch(fetchWorkspaceProjectsDetail());
        });
    };
}

function closeMediaLibraryModal() {
    return { type: MediaLibraryModalActionType.MEDIA_LIB_CLOSE };
}

function updateUserWorkflows(overlays) {
    var templateWorkflowMap = {
        'Calorie Meter': 'fitness',
        'Progress Bar': 'fitness',
        Timer: 'fitness'
    };

    return function (dispatch, getState) {
        var _getState2 = getState(),
            userWorkflows = _getState2.userData.userWorkflows;

        var newWorkflowsSet = new Set();

        overlays.forEach(function (ov) {
            var templateType = (0, _OverlayUtils.getTemplateType)(ov.defId);
            var workflow = templateWorkflowMap[templateType];
            if (workflow) {
                if (!userWorkflows || !userWorkflows.includes(workflow)) {
                    newWorkflowsSet.add(templateWorkflowMap[templateType]);
                }
            }
        });

        var newWorkflowsList = Array.from(newWorkflowsSet);

        if (newWorkflowsList && newWorkflowsList.length > 0) {
            (0, _userApi.saveUserWorkflow)(newWorkflowsList).then(function (updatedUserserWorkflows) {
                dispatch({
                    type: UserActionType.UPDATE_USER_WORKFLOW_DATA,
                    userWorkflows: updatedUserserWorkflows
                });
            });
        }
    };
}

},{"../../common/api/userApi":5,"../../common/api/workspaceApi":6,"../../common/utils/TrackUtils":90,"../../common/utils/errorReporting":101,"../../home/actions/projectActions":253,"../../pricing/actions/pricingActions":265,"../api":176,"../constants/WorkspaceUpdateStatus":210,"../selectors/miscSelectors":215,"../selectors/overlaySelectors":217,"../selectors/planDataSelector":218,"../selectors/subtitleSelectors":224,"../utils/OverlayUtils":231,"./mediaActions":161,"keymirror":677,"lodash":860,"react-redux":1079}],176:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.updateProjectNameP = updateProjectNameP;
exports.saveWorkspaceTemplateP = saveWorkspaceTemplateP;
exports.deleteWorkspaceTemplateP = deleteWorkspaceTemplateP;
exports.saveWorkspaceSequenceP = saveWorkspaceSequenceP;
exports.deleteWorkspaceSequenceP = deleteWorkspaceSequenceP;
exports.deleteMediaP = deleteMediaP;
exports.getProjectMediaP = getProjectMediaP;
exports.getWorkspaceMediaP = getWorkspaceMediaP;
exports.getWorkspaceTemplatesP = getWorkspaceTemplatesP;
exports.getWorkspaceSequencesP = getWorkspaceSequencesP;
exports.getVtSequencesP = getVtSequencesP;
exports.updateProjectEditTimeP = updateProjectEditTimeP;
exports.generateSubtitlesP = generateSubtitlesP;
exports.translateSubtitlesToLanguageP = translateSubtitlesToLanguageP;
exports.enableCaptionsP = enableCaptionsP;
exports.deleteProjectP = deleteProjectP;
exports.trackDataP = trackDataP;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function updateProjectNameP(id, name) {
    return _bluebird2.default.resolve($.ajax('/api/project/update', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ id: id, name: name })
    })).then(function (response) {
        if (response.success) {
            return;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't update project name");
            }
        }
    });
}

function saveWorkspaceTemplateP(template) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/createTemplate', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ templateData: JSON.stringify(template) })
    })).then(function (response) {
        if (response.success) {
            return response.id;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't save workspace template");
            }
        }
    });
}

function deleteWorkspaceTemplateP(templateId) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/deleteTemplate', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ templateId: templateId })
    })).then(function (response) {
        if (response.success) {
            return;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't delete workspace template");
            }
        }
    });
}

function saveWorkspaceSequenceP(projectId, sequence, name) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/createSequence', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ projectId: projectId, sequenceData: JSON.stringify(sequence), name: name })
    })).then(function (response) {
        if (response.success) {
            return response.sequence;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't save workspace template");
            }
        }
    });
}

function deleteWorkspaceSequenceP(sequenceId) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/deleteSequence', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ sequenceId: sequenceId })
    })).then(function (response) {
        if (response.success) {
            return;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't delete workspace template");
            }
        }
    });
}

function deleteMediaP(medias) {
    var triggerAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return _axios2.default.post('/api/workspace/deleteMedia', { medias: medias, sourceView: (0, _constants.getSourceView)(), triggerAction: triggerAction }).then(function (response) {
        if (response.data.success) {
            return response.data;
        } else {
            if (response.data.needLogin) {
                window.location.href = response.data.loginUrl;
            } else {
                throw new Error("couldn't delete media");
            }
        }
    });
}

function getProjectMediaP(projectId) {
    return _axios2.default.post('/api/project/getProjectMedia', { projectId: projectId }).then(function (res) {
        if (!!res.data.success) {
            return res.data.projectMedia;
        } else {
            if (res.data.needLogin) {
                window.location.href = res.data.loginUrl;
            } else {
                throw new Error('Error fetching project media');
            }
        }
    });
}

function getWorkspaceMediaP() {
    return _axios2.default.get('/api/workspace/getWorkspaceMedia').then(function (res) {
        if (!!res.data.success) {
            return res.data.workspaceMedia;
        } else {
            if (response.data.needLogin) {
                window.location.href = response.data.loginUrl;
            } else {
                throw new Error("couldn't delete media");
            }
        }
    });
}

function getWorkspaceTemplatesP() {
    return _bluebird2.default.resolve($.ajax('/api/workspace/getWorkspaceTemplates', {
        method: 'GET'
    })).then(function (response) {
        if (response.success) {
            return { templates: response.templates, images: response.images, projectAssets: response.projectAssets };
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't fetch workspace templates");
            }
        }
    });
}

function getWorkspaceSequencesP() {
    return _bluebird2.default.resolve($.ajax('/api/workspace/getWorkspaceSequences', {
        method: 'GET'
    })).then(function (response) {
        if (response.success) {
            return response.sequences;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't fetch workspace sequences");
            }
        }
    });
}

function getVtSequencesP(vtId, format) {
    var addAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var orderId = arguments[3];

    return _axios2.default.post('/api/videoTemplate/getSequenceData', {
        vtId: vtId,
        format: format,
        addAll: addAll,
        orderId: orderId
    }).then(function (res) {
        var _res$data = res.data,
            success = _res$data.success,
            errorCode = _res$data.errorCode,
            sequences = _res$data.sequences;

        if (!success) {
            var err = new Error('Get video template sequence Error');
            err.errorCode = errorCode;
            throw err;
        }
        return res.data;
    }).catch(function (err) {
        if (err) {
            if (!err.errorCode) err.errorCode = 'get_sequence_error';
            throw err;
        }
    });
}

function updateProjectEditTimeP(projectId) {
    return _bluebird2.default.resolve($.ajax('/api/project/updateProjectEditTime', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ projectId: projectId })
    })).then(function (response) {
        if (response.success) {
            return true;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't update project edit time");
            }
        }
        return;
    }).catch(function (err) {
        console.error('Error while updating project edit time', err);
        throw err;
    });
}

function generateSubtitlesP(data) {
    return _bluebird2.default.resolve($.ajax('/api/project/generateSubtitles', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data)
    })).then(function (response) {
        if (response.success) {
            return response;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't generate subtitles");
            }
        }
    });
}

function translateSubtitlesToLanguageP(data) {
    return _bluebird2.default.resolve($.ajax('/api/project/translateSubtitlesToLanguage', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data)
    })).then(function (response) {
        if (response.success) {
            return response;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            } else {
                throw new Error("couldn't translate subtitles");
            }
        }
    });
}

function enableCaptionsP() {
    return _bluebird2.default.resolve($.ajax('/api/project/enableCaptions', {
        method: 'POST',
        contentType: 'application/json'
    })).then(function (response) {
        if (response.success) {
            return response;
        } else {
            if (response.needLogin) {
                window.location.href = responseData.loginUrl;
            }
            return response;
        }
    });
}

function deleteProjectP(project_id) {
    return _bluebird2.default.resolve($.ajax('/api/project/delete', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            id: project_id
        })
    })).then(function (responseData) {
        if (responseData.success) {
            return true;
        } else {
            throw new Error('Creation unsuccessful');
        }
    });
}

function trackDataP(data) {
    return _axios2.default.post('/api/trackData', _extends({}, data)).then(function (res) {
        return true;
    }).catch(function (err) {
        console.log('Error logging data to api ' + err);
    });
}

},{"../common/constants":61,"axios":335,"bluebird":389}],177:[function(require,module,exports){
'use strict';

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _errorReporting = require('../../common/utils/errorReporting');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ProjectApi = {
    updateProjectEditDataP: function updateProjectEditDataP(data) {
        var id = data.id,
            editDataSyncCounter = data.editDataSyncCounter,
            editData = data.editData,
            sessionSeedEditDataSyncCounter = data.sessionSeedEditDataSyncCounter,
            shouldUpdateMediaMapping = data.shouldUpdateMediaMapping;

        return _axios2.default.post('/api/project/update', {
            id: id,
            editData: editData,
            editDataSyncCounter: editDataSyncCounter,
            shouldUpdateMediaMapping: shouldUpdateMediaMapping,
            sessionSeedEditDataSyncCounter: sessionSeedEditDataSyncCounter
        }).then(function (res) {
            if (res.data.success) {
                return editDataSyncCounter;
            }
            if (res.data.needLogin) {
                window.location.href = res.data.loginUrl;
            } else {
                (0, _errorReporting.reportError)(new _errorReporting.ProjectSyncUpdateFailed('Failed to sync to backend', new Error('response :' + JSON.stringify(res))));
                throw new Error("couldn't update project edit data");
            }
        }).catch(function (err) {
            console.error(err);
        });
    },
    exportVideoP: function exportVideoP(projectId) {
        return _axios2.default.post('/api/export/exportVideo', { projectId: projectId }).then(function (res) {
            return res.data;
        });
    },
    updateProjectMediaMapping: function updateProjectMediaMapping(projectId) {
        return _axios2.default.post('/api/project/updateProjectMediaMapping', {
            projectId: projectId
        }).then(function (res) {
            if (res.data.success) {
                return res.data;
            }
        }).catch(function (err) {
            console.error('Failed to update project media mapping', err);
        });
    }
};

module.exports = ProjectApi;

},{"../../common/utils/errorReporting":101,"axios":335}],178:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.uploadFileToGCloudP = uploadFileToGCloudP;
exports.uploadSnapshot = uploadSnapshot;
exports.uploadFile = uploadFile;
exports.uploadFileP = uploadFileP;
exports.importItemFromService = importItemFromService;
exports.importItemFromUnsplash = importItemFromUnsplash;
exports.importVideoFromPixabay = importVideoFromPixabay;
exports.searchVideos = searchVideos;
exports.searchShopifyProducts = searchShopifyProducts;
exports.importImageFromShopify = importImageFromShopify;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _UploadTracker = require('../utils/UploadTracker');

var _UploadTracker2 = _interopRequireDefault(_UploadTracker);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function getPage() {
    var page_path = !!window ? window.location.pathname : '';

    var page = 'unknown';
    if (page_path.startsWith('/edit')) {
        page = 'edit';
    } else if (page_path.startsWith('/upload')) {
        page = 'upload';
    }

    return page;
}

// Upload file directly to gcloud using signed  url and wait for
// notification from server on validation status
function uploadFileToGCloudP(file, params, onProgressCallback) {
    params = _extends({}, params, { page: getPage() });

    return new _bluebird2.default(function (resolve, reject) {
        // Get signed url
        var urlReq = _superagent2.default.post('/api/getUploadUrl').send(params);

        urlReq.end(function (err, res) {
            if (err) {
                console.log('upload error : ', err);
                err.errorCode = 'signedurl_error';
                return reject(err);
            }

            if (!res.body.success) {
                var _err = new Error('Upload Error');
                _err.errorCode = res.body.error_code || 'signedurl_error';
                if (_err.errorCode == 'unknown') _err.errorCode = 'signedurl_error';

                return reject(_err);
            }

            var url = res.body.uploadUrl;
            var id = res.body.id;

            // Perform upload
            var r = _superagent2.default.put(url).send(file);

            r.on('progress', function (ev) {
                onProgressCallback(ev.percent);
            }).end(function (err, res) {
                if (err) {
                    console.log('upload error : ', JSON.stringify(err));
                    err.errorCode = 'upload_error';
                    return reject(err);
                }

                var uploadTracker = new _UploadTracker2.default(id);
                uploadTracker.onData(function (data) {
                    uploadTracker.stopTracking();
                    if (!data.success) {
                        var _err2 = new Error('Upload Error');
                        _err2.errorCode = data.error_code;
                        return reject(_err2);
                    }
                    return resolve({ type: data.type, data: data.data });
                }).startTracking();
            });
        });
    });
}

function uploadSnapshot(file, params) {
    var onProgressCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var formData = new FormData();

    formData.set('file', file);

    Object.keys(params).forEach(function (k) {
        formData.set(k, params[k]);
    });

    var cancelTokenSource = _axios2.default.CancelToken.source();

    var cancelRequest = function cancelRequest(msg) {
        return cancelTokenSource.cancel(msg);
    };

    var request = _axios2.default.post('/api/uploadSnapshot', formData, {
        onUploadProgress: function onUploadProgress(progressEvent) {
            var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
            onProgressCallback(percentCompleted);
        },
        cancelToken: cancelTokenSource.token
    }).catch(function (err) {
        // console.log(err)
    });

    return { cancelRequest: cancelRequest, request: request };
}

function uploadFile(file, params, onProgressCallback) {
    params = _extends({}, params, { page: getPage() });

    var formData = new FormData();
    formData.set('file', file);

    Object.keys(params).forEach(function (k) {
        formData.set(k, params[k]);
    });

    var cancelTokenSource = _axios2.default.CancelToken.source();

    var cancelRequest = function cancelRequest(msg) {
        return cancelTokenSource.cancel(msg);
    };

    var request = _axios2.default.post('/api/uploadFile', formData, {
        onUploadProgress: function onUploadProgress(progressEvent) {
            var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
            onProgressCallback(percentCompleted);
        },
        cancelToken: cancelTokenSource.token
    }).then(function (res) {
        if (!res.data.success) {
            var err = new Error('Upload Error');
            err.errorCode = res.data.error_code;
            throw err;
        }
        // Success

        return {
            type: res.data.type,
            data: res.data.data
        };
    }).catch(function (err) {
        if (err) {
            err.errorCode = 'upload_error';
            throw err;
        }
    });

    return { request: request, cancelRequest: cancelRequest };
}

function uploadFileP(file, params, onProgressCallback) {
    params = _extends({}, params, { page: getPage() });

    return new _bluebird2.default(function (resolve, reject) {
        var r = _superagent2.default.post('/api/uploadFile').attach('file', file);

        Object.keys(params).forEach(function (k) {
            r.field(k, params[k]);
        });

        r.on('progress', function (ev) {
            onProgressCallback(ev.percent);
        }).end(function (err, res) {
            if (err) {
                err.errorCode = 'upload_error';
                return reject(err);
            }

            if (!res.body.success) {
                var _err3 = new Error('Upload Error');
                _err3.errorCode = res.body.error_code;
                return reject(_err3);
            }

            // Success
            return resolve({
                type: res.body.type,
                data: res.body.data
            });
        });
    });
}

function importItemFromService(item, service, itemType, projectId) {
    return _axios2.default.post('/api/importFromServices', {
        item: item,
        service: service,
        itemType: itemType,
        projectId: projectId,
        page: getPage()
    }).then(function (res) {
        if (!res.data.success) {
            var err = new Error('Upload Error');
            err.errorCode = res.data.error_code;
            throw err;
        }
        // Success

        return {
            type: res.data.type,
            data: res.data.data
        };
    }).catch(function (err) {
        if (err) {
            err.errorCode = 'upload_error';
            throw err;
        }
    });
}

function importItemFromUnsplash(itemId, itemType, projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        var r = _superagent2.default.post('/api/importFromUnsplash').send({
            itemId: itemId,
            itemType: itemType,
            projectId: projectId,
            page: getPage()
        }).end(function (err, res) {
            if (err) {
                err.errorCode = 'upload_error';
                return reject(err);
            }

            if (!res.body.success) {
                var _err4 = new Error('Upload Error');
                _err4.errorCode = res.body.error_code;
                return reject(_err4);
            }

            // Success
            return resolve({
                type: res.body.type,
                data: res.body.data
            });
        });
    });
}

function importVideoFromPixabay(itemId, itemType, projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        var r = _superagent2.default.post('/api/importFromPixabay').send({
            itemId: itemId,
            itemType: itemType,
            projectId: projectId,
            page: getPage()
        }).end(function (err, res) {
            if (err) {
                err.errorCode = 'upload_error';
                return reject(err);
            }

            if (!res.body.success) {
                var _err5 = new Error('Upload Error');
                _err5.errorCode = res.body.error_code;
                return reject(_err5);
            }

            // Success
            return resolve({
                type: res.body.type,
                data: res.body.data
            });
        });
    });
}

function searchVideos(searchText) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/searchVideos').query({ searchText: searchText, page: page }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (!res.body.success) {
                return reject(new Error('Failed to search video'));
            }
            return resolve({
                data: res.body
            });
        });
    });
}

function searchShopifyProducts(searchText, lastProductId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/searchShopifyProducts').query({ searchText: searchText, lastProductId: lastProductId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (!res.body.success) {
                return reject(new Error('Failed to search shopify products'));
            }
            return resolve({
                data: res.body
            });
        });
    });
}

function importImageFromShopify(itemUrl, itemType, projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        var r = _superagent2.default.post('/api/importFromShopify').send({
            itemUrl: itemUrl,
            itemType: itemType,
            projectId: projectId,
            page: getPage()
        }).end(function (err, res) {
            if (err) {
                err.errorCode = 'upload_error';
                return reject(err);
            }

            if (!res.body.success) {
                var _err6 = new Error('Upload Error');
                _err6.errorCode = res.body.error_code;
                return reject(_err6);
            }

            // Success
            return resolve({
                type: res.body.type,
                data: res.body.data
            });
        });
    });
}

},{"../utils/UploadTracker":234,"axios":335,"bluebird":389,"superagent":1193}],179:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Guide = _react2.default.memo(function (_ref) {
    var left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height,
        className = _ref.className;

    var style = {
        transform: 'translate(' + left + 'px, ' + top + 'px)',
        width: width + 'px',
        height: height + 'px'
    };

    return _react2.default.createElement('div', { className: className, style: style });
});

var AlignmentGuides = _react2.default.memo(function (_ref2) {
    var allGuides = _ref2.allGuides,
        visibleGuides = _ref2.visibleGuides,
        displayScale = _ref2.displayScale;

    if (!allGuides) {
        return null;
    }

    var guides = Object.keys(allGuides).map(function (guideId) {
        if (visibleGuides.includes(guideId)) {
            var guide = allGuides[guideId];

            var left = Math.floor(guide.x * displayScale);
            var top = Math.floor(guide.y * displayScale);
            var width = Math.floor(guide.w * displayScale);
            var height = Math.floor(guide.h * displayScale);

            var guideCls = guide.orientation === 'vertical' ? 'show vertical-guide' : 'show horizontal-guide';

            return _react2.default.createElement(Guide, {
                key: '' + guideId,
                className: guideCls,
                left: left,
                top: top,
                width: width,
                height: height
            });
        }
    });
    return _react2.default.createElement('div', { className: 'alignment-guides' }, guides);
});

exports.default = AlignmentGuides;

},{"react":1107}],180:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _HoverMixin = require('../mixins/HoverMixin.react');

var _HoverMixin2 = _interopRequireDefault(_HoverMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var HoverDivInner = _react2.default.memo(function (props) {
    var className = props.className,
        children = props.children,
        hovering = props.hovering,
        onHover = props.onHover,
        cbRef = props.cbRef,
        otherProps = _objectWithoutProperties(props, ['className', 'children', 'hovering', 'onHover', 'cbRef']);

    var clsName = (0, _classnames2.default)(className, {
        hovering: hovering
    });

    return _react2.default.createElement('div', _extends({ className: clsName, ref: cbRef }, otherProps), children);
});

var HoverDiv = (0, _HoverMixin2.default)(HoverDivInner);

exports.default = HoverDiv;

},{"../mixins/HoverMixin.react":212,"classnames":410,"react":1107}],181:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

var _usePropRef = require('../../common/utils/hooks/usePropRef.react');

var _HoverDiv = require('./HoverDiv.react');

var _HoverDiv2 = _interopRequireDefault(_HoverDiv);

var _ResizeHandles = require('./ResizeHandles.react');

var _ResizeHandles2 = _interopRequireDefault(_ResizeHandles);

var _RotateOverlayNode = require('./RotateOverlayNode.react');

var _RotateOverlayNode2 = _interopRequireDefault(_RotateOverlayNode);

var _OverlayDimensionLabel = require('./OverlayDimensionLabel.react');

var _OverlayDimensionLabel2 = _interopRequireDefault(_OverlayDimensionLabel);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var MultiOverlaySelectionBoxInner = _react2.default.forwardRef(function (props, ref) {
    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isRotating = _useState2[0],
        setIsRotating = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isMouseDown = _useState4[0],
        setIsMouseDown = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isDragEvent = _useState6[0],
        setIsDragEvent = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isResizing = _useState8[0],
        setIsResizing = _useState8[1];

    var disableMovement = props.disableMovement,
        dragCallbacks = props.dragCallbacks,
        onMultiDragStart = props.onMultiDragStart,
        onMultiDragMove = props.onMultiDragMove,
        onMultiRotateMove = props.onMultiRotateMove,
        onMultiDragEnd = props.onMultiDragEnd,
        onSelect = props.onSelect;
    var displayScale = props.displayScale,
        selectedRect = props.selectedRect,
        zIndex = props.zIndex,
        show = props.show,
        isPlaying = props.isPlaying,
        blockMouseEvents = props.blockMouseEvents,
        canvas = props.canvas,
        hideResizeHandles = props.hideResizeHandles,
        borderColor = props.borderColor,
        isTextOverlay = props.isTextOverlay,
        isImageOverlay = props.isImageOverlay,
        isMultiSelected = props.isMultiSelected;

    var onPureClick = (0, _react.useCallback)(function (e) {
        e.preventDefault();
    }, []);

    var onMultiDragStartRef = (0, _usePropRef.usePropRef)(onMultiDragStart);
    var onMultiDragMoveRef = (0, _usePropRef.usePropRef)(onMultiDragMove);
    var onMultiDragEndRef = (0, _usePropRef.usePropRef)(onMultiDragEnd);

    var onDragStart = (0, _react.useCallback)(function (e) {
        !disableMovement && onMultiDragStartRef.current(e);
    }, [disableMovement]);

    var onDragMove = (0, _react.useCallback)(function (deltaX, deltaY) {
        !disableMovement && onMultiDragMoveRef.current(deltaX, deltaY);
    }, [disableMovement]);

    var onDragEnd = (0, _react.useCallback)(function () {
        !disableMovement && onMultiDragEndRef.current();
    }, [disableMovement]);

    var onRotateStart = (0, _react.useCallback)(function (e) {
        onMultiDragStartRef.current(e);
        setIsRotating(true);
    }, []);

    var onRotateMove = (0, _react.useCallback)(function (e, deltaAngle) {
        onMultiRotateMove(deltaAngle);
    }, []);

    var onRotateEnd = (0, _react.useCallback)(function () {
        onMultiDragEndRef.current();
        setIsRotating(false);
    }, []);

    var rotateBtnPos = (0, _react.useMemo)(function () {
        var y = selectedRect.y,
            srHeight = selectedRect.height,
            rotateDeg = selectedRect.rotateDeg;

        var position = 'bottom';

        if (Math.abs(rotateDeg) > 110) {
            position = 'top';
        }

        if ((y + srHeight) * displayScale + 40 >= canvas.height * displayScale) {
            position = 'right';
            if (rotateDeg < -30 && rotateDeg > -110) {
                position = 'bottom';
            } else if (rotateDeg < 130 && rotateDeg > 30) {
                position = 'top';
            }
        }

        return position;
    }, [canvas.height, Math.floor(selectedRect.y), Math.floor(selectedRect.height), selectedRect.rotateDeg, displayScale]);

    (0, _react.useImperativeHandle)(ref, function () {
        return {
            onPureClick: onPureClick,
            onDragStart: onDragStart,
            onDragMove: onDragMove,
            onDragEnd: onDragEnd,
            onRotateStart: onRotateStart,
            onRotateMove: onRotateMove,
            onRotateEnd: onRotateEnd
        };
    });

    var x = selectedRect.x,
        y = selectedRect.y,
        width = selectedRect.width,
        height = selectedRect.height,
        _selectedRect$rotateD = selectedRect.rotateDeg,
        rotateDeg = _selectedRect$rotateD === undefined ? 0 : _selectedRect$rotateD;

    var _map = [x, y, width, height].map(function (v) {
        return v * displayScale;
    }),
        _map2 = _slicedToArray(_map, 4),
        left = _map2[0],
        top = _map2[1],
        adjustedWidth = _map2[2],
        adjustedHeight = _map2[3];

    var showResizeHandles = show && !isPlaying && !hideResizeHandles;

    var imoNodeStyles = {
        visibility: show ? 'visible' : 'hidden',
        width: adjustedWidth + 'px',
        height: adjustedHeight + 'px',
        transform: 'translate(' + left + 'px, ' + top + 'px) rotate(' + rotateDeg + 'deg)',
        border: '1px solid ' + borderColor,
        zIndex: zIndex
    };

    var moverStyles = (0, _react.useMemo)(function () {
        var styles = {};
        if (isPlaying) {
            styles.pointerEvents = 'none';
            styles.cursor = 'auto';
        } else if (blockMouseEvents) {
            styles.pointerEvents = 'auto';
        }
        return styles;
    }, [isPlaying, blockMouseEvents]);

    var imoNodeClsName = (0, _classnames2.default)('imo-node', {
        playing: isPlaying
    });
    /*
    onMouseUp() will check if the previous action is drag or simple click ,if its not a drag action it will set 
    "multiple-overlay-select" hover div pointer-events to 'none' for enabling click on single-overlay div  
    and then find the corresponding element under mouse pointer using x and y coordinate.From the above received 
    dom element we fetch its div id which is set as its corresponding overlay-id and pass this id to onSelect().
    */
    var onMouseUp = function onMouseUp(e) {
        if (!isDragEvent) {
            $('#multiple-overlay-select').css('pointer-events', 'none');
            if (document.elementFromPoint(e.clientX, e.clientY).id) onSelect(document.elementFromPoint(e.clientX, e.clientY).id, false);else $('#multiple-overlay-select').css('pointer-events', 'auto');
        }
        setIsMouseDown(false);
        setIsDragEvent(false);
        dragCallbacks.onTrackMouseUp(e);
    };

    return _react2.default.createElement('div', { className: imoNodeClsName, style: imoNodeStyles }, _react2.default.createElement(_HoverDiv2.default, {
        id: 'multiple-overlay-select',
        className: 'imo-node-mover',
        style: moverStyles,
        cbRef: dragCallbacks.refTrack,
        onMouseDown: function onMouseDown(e) {
            setIsMouseDown(true);
            dragCallbacks.onTrackMouseDown(e);
        },
        onMouseUp: onMouseUp,
        onMouseMove: function onMouseMove() {
            if (isMouseDown) setIsDragEvent(true);
        }
    }), _react2.default.createElement(_ResizeHandles2.default, {
        show: showResizeHandles,
        isMultiSelected: isMultiSelected,
        isImageOverlay: isImageOverlay,
        isTextOverlay: isTextOverlay,
        resizeMode: props.resizeMode,
        canChangeLineSpacing: props.canChangeLineSpacing,
        canChangeLineHeight: props.canChangeLineHeight,
        onResizeStart: function onResizeStart() {
            setIsResizing(true);
            props.onResizeStart();
        },
        onResizeMove: props.onResizeMove,
        onResizeEnd: function onResizeEnd() {
            setIsResizing(false);
            props.onResizeEnd();
        }
    }), _react2.default.createElement(_RotateOverlayNode2.default, {
        show: showResizeHandles,
        isMultiSelected: isMultiSelected,
        isImageOverlay: isImageOverlay,
        onMouseDown: dragCallbacks.onTrackRotateMouseDown,
        onMouseUp: dragCallbacks.onTrackMouseUp,
        rotateVal: rotateDeg,
        rotateBtnPos: rotateBtnPos,
        isRotating: isRotating
    }), isResizing && _react2.default.createElement(_OverlayDimensionLabel2.default, {
        rotateVal: rotateDeg,
        width: parseInt(adjustedWidth),
        height: parseInt(adjustedHeight)
    }));
});

var MultiOverlaySelectionBox = (0, _ClickDragMixin2.default)(MultiOverlaySelectionBoxInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false,
    preventDefaultOnMouseDown: true
});

exports.default = MultiOverlaySelectionBox;

},{"../../common/utils/hooks/usePropRef.react":107,"../mixins/ClickDragMixin.react":211,"./HoverDiv.react":180,"./OverlayDimensionLabel.react":182,"./ResizeHandles.react":187,"./RotateOverlayNode.react":188,"classnames":410,"react":1107}],182:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var OverlayDimensionLabel = function OverlayDimensionLabel(props) {
    var dimensionLabelStyle = {
        transform: 'rotate(' + props.rotateVal * -1 + 'deg)'
    };
    var dimensionLabelClassName = (0, _classnames2.default)('overlay-dimension-label', {
        rotate90Clockwise: props.rotateVal === 90,
        rotate180Clockwise: props.rotateVal === 180,
        rotate90Anticlockwise: props.rotateVal === -90,
        rotate180Anticlockwise: props.rotateVal === -180

    });

    return _react2.default.createElement('div', {
        className: dimensionLabelClassName,
        style: dimensionLabelStyle
    }, 'w: ' + props.width + ' h: ' + props.height);
};

exports.default = OverlayDimensionLabel;

},{"classnames":410,"react":1107}],183:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayPreview$propT;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _OverlayUtils = require('../utils/OverlayUtils');

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _OverlayRenderer = require('./OverlayRenderer.react');

var _OverlayRenderer2 = _interopRequireDefault(_OverlayRenderer);

var _CommonRenderGuards = require('./utility/memoRules/CommonRenderGuards.react');

var _ErrorGuardWrapper = require('../../common/components/ErrorGuardWrapper.react');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEBUG = true && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var OverlayPreview = function (_Component) {
    _inherits(OverlayPreview, _Component);

    function OverlayPreview(props) {
        _classCallCheck(this, OverlayPreview);

        var _this = _possibleConstructorReturn(this, (OverlayPreview.__proto__ || Object.getPrototypeOf(OverlayPreview)).call(this, props));

        _this.timeline = null;
        _this.timelineAttached = false;

        _this.forceRenderFunc = function () {
            return _this.onForceRender();
        };
        _this.sortedOverlayMemo = (0, _GeneralUtils.memoizeOne)();
        _this.rootStyleMemo = (0, _GeneralUtils.memoizeOne)();
        return _this;
    }

    _createClass(OverlayPreview, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _GeneralUtils.checkShallowChangeNoFunc)(this, nextProps, nextState);
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            if (this.timeline === null) {
                this.timeline = new TimelineMax();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.attachTimeline();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.detachTimeline();

            this.timeline.kill();
            this.timeline = null;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!prevProps.isOverlayMode && this.props.isOverlayMode) {
                this.attachTimeline();
                this.onForceRender();
            } else if (prevProps.isOverlayMode && !this.props.isOverlayMode) {
                this.detachTimeline();
            }
        }
    }, {
        key: 'attachTimeline',
        value: function attachTimeline() {
            if (!this.timelineAttached) {
                this.props.corePlayer.addChildTimeline(this.timeline, 0);
                this.timelineAttached = true;
            }
        }
    }, {
        key: 'detachTimeline',
        value: function detachTimeline() {
            if (this.timelineAttached) {
                this.props.corePlayer.removeChildTimeline(this.timeline);
                this.timelineAttached = false;
            }
        }
    }, {
        key: 'onForceRender',
        value: function onForceRender() {
            this.props.corePlayer.forceRender();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                canvas = _props.canvas,
                displayScale = _props.displayScale,
                playbackState = _props.playbackState,
                isOverlayMode = _props.isOverlayMode;
            var _props2 = this.props,
                selected = _props2.selection.selected,
                overlays = _props2.overlays,
                animgroups = _props2.overlaymeta.animgroups;

            var playing = playbackState == _PlaybackState2.default.PLAYING;

            var rootStyles = this.rootStyleMemo(function () {
                return {
                    overflow: playing ? 'hidden' : 'visible',
                    visibility: isOverlayMode ? 'visible' : 'hidden',
                    opacity: isOverlayMode ? 1 : 0
                };
            }, [playing, isOverlayMode]);

            var sortedOverlayIdList = this.sortedOverlayMemo(function () {
                return Object.keys(overlays).sort(function (oid1, oid2) {
                    return overlays[oid1].space.zIndex > overlays[oid2].space.zIndex;
                });
            }, [overlays]);

            return _react2.default.createElement('div', { className: 'fill-parent-size', style: rootStyles }, sortedOverlayIdList.map(function (oid) {
                var propGroupSettings = (_this2.props.overlayGroupSettings || {})[oid];

                var overlayGroupSettings = propGroupSettings || (0, _OverlayUtils.getAnimGroupSettings)(overlays[oid], overlays, animgroups);

                return _react2.default.createElement(_CommonRenderGuards.ReduxUpdateGuard, {
                    key: oid,
                    shouldUpdate: function shouldUpdate(state) {
                        var _state$operationGuard = state.operationGuards;
                        _state$operationGuard = _state$operationGuard === undefined ? {} : _state$operationGuard;
                        var _state$operationGuard2 = _state$operationGuard.disableOverlayUpdate,
                            disableOverlayUpdate = _state$operationGuard2 === undefined ? false : _state$operationGuard2;
                        // Skipping update when in view
                        // const currentTime = Math.floor(this.timeline.time() * 1000)
                        // const {time : {enterstart , exitdone}} = overlays[oid]
                        // // update when in View
                        // if(currentTime >= enterstart && currentTime <= exitdone)
                        //     return true
                        // dlog(`Current Time : `, {
                        //     currentTime
                        // })
                        // Other wise just guard against rendering

                        return !disableOverlayUpdate;
                    }
                }, function () {
                    return _react2.default.createElement(_OverlayRenderer2.default, {
                        key: oid,
                        rootTimeline: _this2.timeline,
                        onForceRender: _this2.forceRenderFunc,
                        overlay: overlays[oid],
                        canvas: canvas,
                        paused: !playing,
                        selected: !!selected[oid],
                        overlayGroupSettings: overlayGroupSettings,
                        displayScale: displayScale
                    });
                });
            }));
        }
    }]);

    return OverlayPreview;
}(_react.Component);

OverlayPreview.propTypes = (_OverlayPreview$propT = {
    corePlayer: _propTypes2.default.object.isRequired,
    displayScale: _propTypes2.default.number.isRequired,
    playbackState: _propTypes2.default.string.isRequired,
    isOverlayMode: _propTypes2.default.bool.isRequired,
    overlays: _propTypes2.default.object.isRequired,
    overlaymeta: _propTypes2.default.object.isRequired,
    selection: _propTypes2.default.object.isRequired,

    canvas: _propTypes2.default.object.isRequired
}, _defineProperty(_OverlayPreview$propT, 'selection', _propTypes2.default.object.isRequired), _defineProperty(_OverlayPreview$propT, 'overlayGroupSettings', _propTypes2.default.object), _OverlayPreview$propT);
exports.default = (0, _ErrorGuardWrapper.CreateErrorGuard)(OverlayPreview, {
    defaultFallbackComponent: null,
    id: 'error-guard-overlay-preview'
});

},{"../../common/components/ErrorGuardWrapper.react":10,"../../common/utils/GeneralUtils":77,"../../common/utils/enums/PlaybackState":96,"../utils/OverlayUtils":231,"./OverlayRenderer.react":184,"./utility/memoRules/CommonRenderGuards.react":199,"prop-types":896,"react":1107}],184:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _OverlayRenderView = require('../../common/utils/renderer/OverlayRenderView');

var _OverlayRenderView2 = _interopRequireDefault(_OverlayRenderView);

var _usePropRef = require('../../common/utils/hooks/usePropRef.react');

var _WindowEvents = require('../utils/WindowEvents');

var _WindowEvents2 = _interopRequireDefault(_WindowEvents);

var _ErrorGuardWrapper = require('../../common/components/ErrorGuardWrapper.react');

var _useEnhancedState3 = require('../../common/utils/hooks/useEnhancedState.react');

var _useEnhancedState4 = _interopRequireDefault(_useEnhancedState3);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var isFontKeyUsed = function isFontKeyUsed(overlayRenderView, fontKey) {
    if (overlayRenderView) {
        return overlayRenderView.isFontKeyUsed(fontKey);
    }
    return false;
};

var getVisibility = function getVisibility(overlay, currentTime, overlayRenderView) {
    var enterstart = overlay.enterstart,
        exitdone = overlay.exitdone;

    var isVisible = !!overlayRenderView.current && overlayRenderView.current.isVisible();

    var shouldBeVisible = currentTime >= enterstart && currentTime <= exitdone;

    return { isVisible: isVisible, shouldBeVisible: shouldBeVisible };
};

var updateOverlayRendererView = function updateOverlayRendererView(overlayRenderView, propsRef) {
    var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var props = propsRef.current;
    if (overlayRenderView.current) {
        overlayRenderView.current.updateData(props.overlay, props.canvas, props.displayScale, props.selected, props.paused, props.overlayGroupSettings, forceUpdate);
    }
};

var OverlayRenderer = _react2.default.memo(function (props) {
    var propsRef = (0, _usePropRef.usePropRef)(props);

    var overlay = props.overlay,
        canvas = props.canvas,
        displayScale = props.displayScale,
        _props$selected = props.selected,
        selected = _props$selected === undefined ? false : _props$selected,
        _props$paused = props.paused,
        paused = _props$paused === undefined ? false : _props$paused,
        _props$overlayGroupSe = props.overlayGroupSettings,
        overlayGroupSettings = _props$overlayGroupSe === undefined ? null : _props$overlayGroupSe,
        rootTimeline = props.rootTimeline,
        _props$removeIfNotVis = props.removeIfNotVisibile,
        removeIfNotVisibile = _props$removeIfNotVis === undefined ? false : _props$removeIfNotVis,
        onForceRender = props.onForceRender,
        _props$allowPointerEv = props.allowPointerEvents,
        allowPointerEvents = _props$allowPointerEv === undefined ? false : _props$allowPointerEv;

    var rootEl = (0, _react.useRef)(null);
    var overlayRenderView = (0, _react.useRef)(null);

    var _useEnhancedState = (0, _useEnhancedState4.default)(false),
        _useEnhancedState2 = _slicedToArray(_useEnhancedState, 2),
        isVisible = _useEnhancedState2[0],
        setVisible = _useEnhancedState2[1];

    (0, _react.useEffect)(function () {
        overlayRenderView.current = new _OverlayRenderView2.default(rootTimeline, onForceRender, { allowPointerEvents: allowPointerEvents });

        var handleFontLoaded = function handleFontLoaded(event) {
            var fontKey = event.detail;

            if (isFontKeyUsed(overlayRenderView.current, fontKey)) {
                updateOverlayRendererView(overlayRenderView, propsRef, true);
            }
        };

        _WindowEvents2.default.addEventListener('fontLoaded', handleFontLoaded);

        return function () {
            _WindowEvents2.default.removeEventListener('fontLoaded', handleFontLoaded);
        };
    }, []);

    (0, _react.useEffect)(function () {
        if (removeIfNotVisibile && overlayRenderView.current) {
            overlayRenderView.current.onVisibilityChange(function (visible) {
                setVisible(visible); // Sets up visiblity whenever visible nodes changes
            });
        }
    }, [removeIfNotVisibile]);

    (0, _react.useEffect)(function () {
        var root = rootEl.current;
        var overlayRenderer = overlayRenderView.current;
        if (root && overlayRenderer) {
            root.appendChild(overlayRenderer.getDOMEl());
        }
        return function () {
            if (root && overlayRenderer) {
                root.removeChild(overlayRenderer.getDOMEl());
            }
        };
    }, [isVisible, removeIfNotVisibile]);

    var spaceChange = overlay.space,
        timeChange = overlay.time,
        valueChange = overlay.values,
        hide = overlay.hide;
    // hide icnlusion for Sequence Overlays with hide feature

    (0, _react.useLayoutEffect)(function () {
        // To update render view on overlay update
        updateOverlayRendererView(overlayRenderView, propsRef);
    }, [canvas, spaceChange, displayScale]);

    (0, _react.useEffect)(function () {
        updateOverlayRendererView(overlayRenderView, propsRef);
    }, [timeChange, valueChange, hide, selected, paused, overlayGroupSettings]);

    // Unmount logic , done after all the useEffect because execution order matters ,
    // started with the new functional component refactor
    (0, _react.useEffect)(function () {
        return function () {
            if (overlayRenderView.current) {
                overlayRenderView.current.destroy();
            }
        };
    }, []);

    var memoizedStyle = _react2.default.useMemo(function () {
        return {
            zIndex: overlay.space.zIndex
        };
    }, [overlay.space.zIndex]);

    var _randomIdSuffix = (0, _react.useRef)('-' + _shortid2.default.generate());
    var wrapperId = 'overlay-wrapper-' + (overlay.id + _randomIdSuffix.current);
    if (removeIfNotVisibile && !isVisible) {
        return null; // Now it works , since it's now build on top of visibility checks built on top of listener
    }

    return _react2.default.createElement('div', {
        className: 'fill-parent-size no-mouse-events',
        ref: rootEl,
        id: wrapperId,
        style: memoizedStyle
    });
});

exports.default = (0, _ErrorGuardWrapper.CreateErrorGuard)(OverlayRenderer, {
    defaultFallbackComponent: null,
    id: 'overlay-renderer-failed'
});

},{"../../common/components/ErrorGuardWrapper.react":10,"../../common/utils/GeneralUtils":77,"../../common/utils/hooks/useEnhancedState.react":104,"../../common/utils/hooks/usePropRef.react":107,"../../common/utils/renderer/OverlayRenderView":122,"../utils/WindowEvents":235,"prop-types":896,"react":1107,"react-dom":1016,"shortid":1163}],185:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

var _OverlayUtils = require('../utils/OverlayUtils');

var _reactContext = require('../utils/reactContext');

var _HoverDiv = require('./HoverDiv.react');

var _HoverDiv2 = _interopRequireDefault(_HoverDiv);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var OverlaySelectionBoxInner = _react2.default.forwardRef(function (props, ref) {
    var appManager = (0, _react.useContext)(_reactContext.AppManagerContext);

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        hovering = _useState2[0],
        setHovering = _useState2[1];

    var onPureClick = (0, _react.useCallback)(function (e) {
        var modifier = !!(e.getModifierState('Shift') || e.getModifierState('Meta') || e.getModifierState('Control'));

        props.onSelect(props.overlay.id, modifier);

        e.preventDefault();
    }, []);

    var onDragStartFuncRef = (0, _react.useRef)(props.onDragStart);
    var onDragMoveFuncRef = (0, _react.useRef)(props.onDragMove);
    var onDragEndFuncRef = (0, _react.useRef)(props.onDragEnd);

    onDragStartFuncRef.current = props.onDragStart;
    onDragMoveFuncRef.current = props.onDragMove;
    onDragEndFuncRef.current = props.onDragEnd;

    var onDragStart = (0, _react.useCallback)(function (e) {
        if (props.canDrag) {
            onDragStartFuncRef.current(props.overlay.id, e);
        }
    }, []);

    var onDragMove = (0, _react.useCallback)(function (deltaX, deltaY) {
        if (props.canDrag) {
            onDragMoveFuncRef.current(props.overlay.id, deltaX, deltaY);
        }
    }, []);

    var onDragEnd = (0, _react.useCallback)(function () {
        if (props.canDrag) {
            onDragEndFuncRef.current(props.overlay.id);
        }
    }, []);

    (0, _react.useImperativeHandle)(ref, function () {
        return {
            onPureClick: onPureClick,
            onDragStart: onDragStart,
            onDragMove: onDragMove,
            onDragEnd: onDragEnd
        };
    });

    var dragState = props.dragState,
        dragCallbacks = props.dragCallbacks,
        displayScale = props.displayScale,
        overlay = props.overlay,
        anySelected = props.anySelected,
        selected = props.selected,
        selecting = props.selecting,
        isPlaying = props.isPlaying,
        _props$hideBorders = props.hideBorders,
        hideBorders = _props$hideBorders === undefined ? false : _props$hideBorders;

    var showSelected = !hideBorders && selected;

    var isImageOverlay = false;
    var isTextOverlay = false;
    if (!!overlay) {
        var def = appManager.getTemplateDefForId(overlay.defId);
        var textLayerValueMap = overlay && (0, _OverlayUtils.getLayerPropValueMap)(overlay, 'text', true);

        if ((0, _OverlayUtils.detectIsImageTemplate)(def) && Object.keys(textLayerValueMap).length === 0) {
            isImageOverlay = true;
        } else if (Object.keys(textLayerValueMap).length !== 0) {
            isTextOverlay = true;
        }
    }

    var showHovering = !selected && !hideBorders && hovering || selecting || !selected && dragState.dragging;

    var borderClassname = (0, _classnames2.default)({
        'fill-parent-size': true,
        'select-border': true,
        selected: showSelected,
        hovering: showHovering,
        playing: isPlaying,
        'image-overlay': isImageOverlay || !isTextOverlay
    });

    var moverStyles = {};
    if (isPlaying) {
        moverStyles.pointerEvents = 'none';
        moverStyles.cursor = 'auto';
    }

    var _overlay$space = overlay.space,
        x = _overlay$space.x,
        y = _overlay$space.y,
        width = _overlay$space.width,
        height = _overlay$space.height,
        _overlay$space$rotate = _overlay$space.rotateDeg,
        rotateDeg = _overlay$space$rotate === undefined ? 0 : _overlay$space$rotate;

    var boxRootStyles = {
        position: 'absolute',
        width: width * displayScale + 'px',
        height: height * displayScale + 'px',
        transform: 'translate(' + x * displayScale + 'px, ' + y * displayScale + 'px) rotate(' + rotateDeg + 'deg)'
    };

    var overlayMoverClsname = (0, _classnames2.default)('overlay-mover', {
        spread: anySelected
    });

    var _useDrop = (0, _reactDnd.useDrop)({
        accept: ['image'],
        drop: function drop() {
            return {
                name: 'overlay-replace',
                overlayId: overlay.id
            };
        },
        canDrop: function canDrop() {
            return overlay.defId.startsWith('defId-userBitmap');
        },
        collect: function collect(monitor) {
            return {
                draggingItem: monitor.getItem(),
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop()
            };
        }
    }),
        _useDrop2 = _slicedToArray(_useDrop, 2),
        _useDrop2$ = _useDrop2[0],
        draggingItem = _useDrop2$.draggingItem,
        isOver = _useDrop2$.isOver,
        canDrop = _useDrop2$.canDrop,
        overlayDropRef = _useDrop2[1];

    var overlayDropStyles = {};

    if (canDrop && isOver) {
        if (draggingItem && draggingItem.preview) {
            overlayDropStyles.backgroundImage = 'url(' + draggingItem.preview + ')';
            overlayDropStyles.border = 'none';
        } else {
            //In case no preview is available
            overlayDropStyles.background = 'rgba(0, 0, 0, 0.4)';
        }
    }

    var isDragging = (0, _reactRedux.useSelector)(function (state) {
        return state.ui.isDraggingMedia;
    });

    var dropArea = null;
    if (isDragging && canDrop) {
        dropArea = _react2.default.createElement('div', {
            ref: overlayDropRef,
            style: overlayDropStyles,
            className: (0, _classnames2.default)('overlay-replace-drop-area', {
                hovering: isOver && canDrop
            })
        });
    }

    return _react2.default.createElement('div', { className: 'overlay-node', style: boxRootStyles }, _react2.default.createElement('div', { className: borderClassname }), _react2.default.createElement(_HoverDiv2.default, {
        id: props.overlay.id,
        className: overlayMoverClsname,
        style: moverStyles,
        cbRef: dragCallbacks.refTrack,
        onMouseDown: dragCallbacks.onTrackMouseDown,
        onMouseUp: dragCallbacks.onTrackMouseUp,
        onHover: setHovering
    }), dropArea);
});

var OverlaySelectionBox = (0, _ClickDragMixin2.default)(OverlaySelectionBoxInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false,
    preventDefaultOnMouseDown: true
});

exports.default = OverlaySelectionBox;

},{"../mixins/ClickDragMixin.react":211,"../utils/OverlayUtils":231,"../utils/reactContext":237,"./HoverDiv.react":180,"classnames":410,"react":1107,"react-dnd":1001,"react-redux":1079}],186:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProgressBar = function (_Component) {
    _inherits(ProgressBar, _Component);

    function ProgressBar(props) {
        _classCallCheck(this, ProgressBar);

        return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));
    }

    _createClass(ProgressBar, [{
        key: 'getDeterminateBarInside',
        value: function getDeterminateBarInside() {
            var progress = this.props.progress;
            if (progress < 0) progress = 0;
            if (progress > 100) progress = 100;

            var progressBarStyle = {
                width: progress + '%'
            };

            return _react2.default.createElement('div', { className: 'progress-bar-done', style: progressBarStyle });
        }
    }, {
        key: 'getIndeterminateBarInside',
        value: function getIndeterminateBarInside() {
            return _react2.default.createElement('div', { className: 'progress-bar-indeterminate' });
        }
    }, {
        key: 'getProgressInsideBar',
        value: function getProgressInsideBar() {
            if (this.props.isIndeterminate) {
                return this.getIndeterminateBarInside();
            }
            return this.getDeterminateBarInside();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { className: 'progress-bar-component' }, this.getProgressInsideBar());
        }
    }]);

    return ProgressBar;
}(_react.Component);

ProgressBar.propTypes = {
    progress: _propTypes2.default.number.isRequired,
    isIndeterminate: _propTypes2.default.bool.isRequired
};
exports.default = ProgressBar;

},{"prop-types":896,"react":1107}],187:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResizeMode = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

var _OverlayHandleTypes = require('../constants/OverlayHandleTypes');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ResizeMode = exports.ResizeMode = (0, _keymirror2.default)({
    SCALE_ONLY: null,
    SCALE_AND_WIDTH: null,
    SCALE_AND_WIDTH_AND_HEIGHT: null,
    NONE: null
});

var showHeightHandles = function showHeightHandles(resizeMode) {
    return resizeMode === ResizeMode.SCALE_AND_WIDTH_AND_HEIGHT;
};

var showWidthHandles = function showWidthHandles(resizeMode) {
    return resizeMode === ResizeMode.SCALE_AND_WIDTH || resizeMode === ResizeMode.SCALE_AND_WIDTH_AND_HEIGHT;
};

var showScaleHandles = function showScaleHandles(resizeMode) {
    return resizeMode !== ResizeMode.NONE;
};

var ResizeHandles = _react2.default.memo(function (props) {
    var show = props.show,
        _props$resizeMode = props.resizeMode,
        resizeMode = _props$resizeMode === undefined ? ResizeMode.NONE : _props$resizeMode,
        _props$canChangeLineS = props.canChangeLineSpacing,
        canChangeLineSpacing = _props$canChangeLineS === undefined ? false : _props$canChangeLineS,
        _props$canChangeLineH = props.canChangeLineHeight,
        canChangeLineHeight = _props$canChangeLineH === undefined ? false : _props$canChangeLineH,
        isMultiSelected = props.isMultiSelected,
        isImageOverlay = props.isImageOverlay,
        isTextOverlay = props.isTextOverlay;

    var scaleHandles = null,
        bottomHandle = null,
        topHandle = null,
        rightHandle = null,
        leftHandle = null;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isDragTR = _useState2[0],
        setIsDragTR = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isDragTL = _useState4[0],
        setIsDragTL = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isDragBR = _useState6[0],
        setIsDragBR = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isDragBL = _useState8[0],
        setIsDragBL = _useState8[1];

    var scaleHandlesVisible = showScaleHandles(resizeMode);
    var bottomHandleVisible = showHeightHandles(resizeMode);
    var rightHandleVisible = showWidthHandles(resizeMode);

    var topRightHandleClsName = (0, _classnames2.default)('resizehandle tr', {
        isDraggingTR: isDragTR,
        isImageOverlay: isImageOverlay || !isTextOverlay && !isMultiSelected,
        isMultiSelected: isMultiSelected
    });
    var topLeftHandleClsName = (0, _classnames2.default)('resizehandle tl', {
        isDraggingTL: isDragTL,
        isImageOverlay: isImageOverlay || !isTextOverlay && !isMultiSelected,
        isMultiSelected: isMultiSelected
    });
    var bottomRightHandleClsName = (0, _classnames2.default)('resizehandle br', {
        isDraggingBR: isDragBR,
        isImageOverlay: isImageOverlay || !isTextOverlay && !isMultiSelected,
        isMultiSelected: isMultiSelected
    });
    var bottomLeftHandleClsName = (0, _classnames2.default)('resizehandle bl', {
        isDraggingBL: isDragBL,
        isImageOverlay: isImageOverlay || !isTextOverlay && !isMultiSelected,
        isMultiSelected: isMultiSelected
    });

    if (canChangeLineSpacing) {
        bottomHandle = _react2.default.createElement(ResizeHandle, {
            className: 'resizehandle bls',
            onDragStart: props.onResizeStart,
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.BOTTOM_LINE_SPACING, deltaX, deltaY);
            },
            onDragEnd: props.onResizeEnd
        });
    } else if (canChangeLineHeight) {
        bottomHandle = _react2.default.createElement(ResizeHandle, {
            className: 'resizehandle blh',
            onDragStart: props.onResizeStart,
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.BOTTOM_LINE_HEIGHT, deltaX, deltaY);
            },
            onDragEnd: props.onResizeEnd
        });
    } else if (bottomHandleVisible) {
        bottomHandle = _react2.default.createElement(ResizeHandle, {
            className: 'resizehandle b',
            onDragStart: props.onResizeStart,
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.BOTTOM, deltaX, deltaY);
            },
            onDragEnd: props.onResizeEnd
        });
        topHandle = _react2.default.createElement(ResizeHandle, {
            className: 'resizehandle t',
            onDragStart: props.onResizeStart,
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.TOP, deltaX, deltaY);
            },
            onDragEnd: props.onResizeEnd
        });
    }

    if (rightHandleVisible) {
        rightHandle = _react2.default.createElement(ResizeHandle, {
            className: 'resizehandle r',
            onDragStart: props.onResizeStart,
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.RIGHT, deltaX, deltaY);
            },
            onDragEnd: props.onResizeEnd
        });
        leftHandle = _react2.default.createElement(ResizeHandle, {
            className: 'resizehandle l',
            onDragStart: props.onResizeStart,
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.LEFT, deltaX, deltaY);
            },
            onDragEnd: props.onResizeEnd
        });
    }

    if (scaleHandlesVisible) {
        scaleHandles = _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(ResizeHandle, {
            className: topLeftHandleClsName,
            onDragStart: function onDragStart() {
                setIsDragTL(true);
                props.onResizeStart();
            },
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.TOP_LEFT, deltaX, deltaY);
            },
            onDragEnd: function onDragEnd() {
                setIsDragTL(false);
                props.onResizeEnd();
            }
        }), _react2.default.createElement(ResizeHandle, {
            className: topRightHandleClsName,
            onDragStart: function onDragStart() {
                setIsDragTR(true);
                props.onResizeStart();
            },
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.TOP_RIGHT, deltaX, deltaY);
            },
            onDragEnd: function onDragEnd() {
                setIsDragTR(false);
                props.onResizeEnd();
            }
        }), _react2.default.createElement(ResizeHandle, {
            className: bottomLeftHandleClsName,
            onDragStart: function onDragStart() {
                setIsDragBL(true);
                props.onResizeStart();
            },
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.BOTTOM_LEFT, deltaX, deltaY);
            },
            onDragEnd: function onDragEnd() {
                setIsDragBL(false);
                props.onResizeEnd();
            }
        }), _react2.default.createElement(ResizeHandle, {
            className: bottomRightHandleClsName,
            onDragStart: function onDragStart() {
                setIsDragBR(true);
                props.onResizeStart();
            },
            onDragMove: function onDragMove(deltaX, deltaY) {
                return props.onResizeMove(_OverlayHandleTypes.BOTTOM_RIGHT, deltaX, deltaY);
            },
            onDragEnd: function onDragEnd() {
                setIsDragBR(false);
                props.onResizeEnd();
            }
        }));
    }

    var resizeHandlesContainerStyles = {
        opacity: show ? 1 : 0
    };

    return _react2.default.createElement('div', { className: 'resizehandles-container', style: resizeHandlesContainerStyles }, scaleHandles, bottomHandle, topHandle, rightHandle, leftHandle);
});

var ResizeHandleInner = _react2.default.forwardRef(function (props, ref) {
    var className = props.className,
        dragCallbacks = props.dragCallbacks;

    var onPureClick = function onPureClick(e) {
        e.preventDefault();
    };
    var onDragStart = function onDragStart(e) {
        props.onDragStart(e);
    };
    var onDragMove = function onDragMove(deltaX, deltaY) {
        props.onDragMove(deltaX, deltaY);
    };
    var onDragEnd = function onDragEnd() {
        props.onDragEnd();
    };

    (0, _react.useImperativeHandle)(ref, function () {
        return {
            onPureClick: onPureClick,
            onDragStart: onDragStart,
            onDragMove: onDragMove,
            onDragEnd: onDragEnd
        };
    });

    return _react2.default.createElement('div', {
        className: className,
        ref: dragCallbacks.refTrack,
        onMouseDown: dragCallbacks.onTrackMouseDown,
        onMouseUp: dragCallbacks.onTrackMouseUp
    });
});

var ResizeHandle = (0, _ClickDragMixin2.default)(ResizeHandleInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false,
    preventDefaultOnMouseDown: true
});

exports.default = ResizeHandles;

},{"../constants/OverlayHandleTypes":205,"../mixins/ClickDragMixin.react":211,"classnames":410,"keymirror":677,"react":1107}],188:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var RotateOverlayNode = function RotateOverlayNode(props) {
    var show = props.show,
        onMouseDown = props.onMouseDown,
        onMouseUp = props.onMouseUp,
        rotateVal = props.rotateVal,
        rotateBtnPos = props.rotateBtnPos,
        _props$isRotating = props.isRotating,
        isRotating = _props$isRotating === undefined ? false : _props$isRotating;

    if (!show) {
        return null;
    }

    var rotateOverlayNodeCls = (0, _classnames2.default)('rotate-overlay-node', {
        visible: !!show
    });

    var rotateIconClsnames = (0, _classnames2.default)('rotate-btn-pos', {
        top: rotateBtnPos === 'top',
        right: rotateBtnPos === 'right',
        bottom: rotateBtnPos === 'bottom'
    });

    var rotateLabelClsnames = (0, _classnames2.default)('rotate-label', {
        top: rotateBtnPos === 'top',
        right: rotateBtnPos === 'right',
        bottom: rotateBtnPos === 'bottom'
    });

    var rotateLabelStyle = {
        transform: 'rotate(' + rotateVal * -1 + 'deg)'
    };

    var rotateNode = (0, _react.useMemo)(function () {
        if (isRotating) {
            return _react2.default.createElement('div', { id: 'rotate-overlay-cursor' });
        }
        return _react2.default.createElement(_SVGIcon2.default, {
            iconId: 'rotate-overlay-icon',
            width: '20px',
            height: '20px',
            fill: 'none',
            className: 'rotate-overlay',
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp
        });
    }, [isRotating, onMouseDown, onMouseUp]);

    return _react2.default.createElement('div', { className: rotateOverlayNodeCls }, _react2.default.createElement('div', { className: rotateIconClsnames }, rotateNode), isRotating && _react2.default.createElement('div', { className: rotateLabelClsnames, style: rotateLabelStyle }, rotateVal, '\xB0'));
};

exports.default = RotateOverlayNode;

},{"../../common/components/SVGIcon.react":13,"classnames":410,"react":1107}],189:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _usePropRef = require('../../common/utils/hooks/usePropRef.react');

var _OverlayUtils = require('../utils/OverlayUtils');

var _LayerUtils = require('../../common/utils/renderer/LayerUtils');

var _reactContext = require('../utils/reactContext');

var _OverlaySelectionBox = require('./OverlaySelectionBox.react');

var _OverlaySelectionBox2 = _interopRequireDefault(_OverlaySelectionBox);

var _MultiOverlaySelectionBox = require('./MultiOverlaySelectionBox.react');

var _MultiOverlaySelectionBox2 = _interopRequireDefault(_MultiOverlaySelectionBox);

var _ResizeHandles = require('./ResizeHandles.react');

var _CommonRenderGuards = require('./utility/memoRules/CommonRenderGuards.react');

var _AlignmentGuides = require('./AlignmentGuides.react');

var _AlignmentGuides2 = _interopRequireDefault(_AlignmentGuides);

var _OverlayHandleTypes = require('../constants/OverlayHandleTypes');

var _OverlayHandleTypes2 = _interopRequireDefault(_OverlayHandleTypes);

var _hooks = require('./timelineeditor/hooks');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _CommonAlgorithms = require('../../common/utils/CommonAlgorithms');

var _AllTemplateDefs = require('../../common/config/AllTemplateDefs');

var _AllTemplateDefs2 = _interopRequireDefault(_AllTemplateDefs);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var DEBUG = false;
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var SNAP_GUIDE_THRESHOLD = 10;
var SNAP_ANGLE_THRESHOLD = 3;

var CANVAS_GUIDE_ID = (0, _keymirror2.default)({
    VERTICAL_CENTER: null,
    HORIZONTAL_CENTER: null,
    HORIZONTAL_TOP: null,
    HORIZONTAL_BOTTOM: null
});

var overlayGuideKey = function overlayGuideKey(overlayId, guideType) {
    return overlayId + '_' + guideType;
};

var snapToAngle = function snapToAngle(rotateDeg) {
    var newRotateDeg = Math.round(rotateDeg);
    var sign = rotateDeg < 0 ? -1 : 1;
    var mod = newRotateDeg % 90;

    if (Math.abs(mod) <= SNAP_ANGLE_THRESHOLD) {
        newRotateDeg -= mod;
    } else if (90 - Math.abs(mod) <= SNAP_ANGLE_THRESHOLD) {
        newRotateDeg += (90 - Math.abs(mod)) * sign;
    }

    if (newRotateDeg < -180) {
        newRotateDeg += 360;
    } else if (newRotateDeg > 180) {
        newRotateDeg = (360 - newRotateDeg) * -1;
    }

    return newRotateDeg % 360;
};

var extractDelta = function extractDelta(type, resizeDeltaX, resizeDeltaY, initialRect, canvas) {
    var cw = canvas.width,
        ch = canvas.height;
    var iX = initialRect.x,
        iY = initialRect.y,
        iW = initialRect.width,
        iH = initialRect.height;

    if (type === _OverlayHandleTypes2.default.BOTTOM || type === _OverlayHandleTypes2.default.BOTTOM_LINE_SPACING || type === _OverlayHandleTypes2.default.BOTTOM_LINE_HEIGHT) {
        var minDeltaY = -iH;
        var maxDeltaY = ch - (iY + iH);
        var deltaY = Math.max(minDeltaY, Math.min(resizeDeltaY, maxDeltaY));

        return { deltaX: 0, deltaY: deltaY };
    }

    if (type === _OverlayHandleTypes2.default.TOP) {
        var _minDeltaY = -iY;
        var _maxDeltaY = iH;
        var _deltaY = -Math.max(_minDeltaY, Math.min(resizeDeltaY, _maxDeltaY));
        return { deltaX: 0, deltaY: _deltaY };
    }

    if (type === _OverlayHandleTypes2.default.RIGHT) {
        var minDeltaX = -iW;
        var maxDeltaX = cw - (iX + iW);

        var deltaX = Math.max(minDeltaX, Math.min(resizeDeltaX, maxDeltaX));

        return { deltaX: deltaX, deltaY: 0 };
    }

    if (type === _OverlayHandleTypes2.default.LEFT) {
        var _minDeltaX = -iX;
        var _maxDeltaX = iW;
        var _deltaX = -Math.max(_minDeltaX, Math.min(resizeDeltaX, _maxDeltaX));

        return { deltaX: _deltaX, deltaY: 0 };
    }

    if (type === _OverlayHandleTypes2.default.TOP_LEFT || type === _OverlayHandleTypes2.default.TOP_RIGHT || type === _OverlayHandleTypes2.default.BOTTOM_LEFT || type === _OverlayHandleTypes2.default.BOTTOM_RIGHT) {
        var newRight = iX + iW + resizeDeltaX;
        var newBottom = iY + iH + resizeDeltaY;

        var originPoint = { x: iX, y: iY };
        var diagnoalOppositePoint = { x: iX + iW, y: iY + iH };
        var newPoint = { x: newRight, y: newBottom };

        var angle = calculateAngle(originPoint, diagnoalOppositePoint, newPoint);

        var currentPointDistanceFromOrigin = Math.sqrt(Math.pow(newPoint.x - originPoint.x, 2) + Math.pow(newPoint.y - originPoint.y, 2));

        var diagonalLength = Math.sqrt(iW * iW + iH * iH);

        var newDiagonalLength = currentPointDistanceFromOrigin * Math.cos(angle);
        var minDiaginalLength = 5; // arbitrary
        var effectiveGrowthFactor = Math.max(newDiagonalLength, minDiaginalLength) / diagonalLength;

        var maxGrowthFactor = void 0;
        if (type === _OverlayHandleTypes2.default.BOTTOM_RIGHT) {
            maxGrowthFactor = Math.min((cw - iX) / iW, (ch - iY) / iH);
            effectiveGrowthFactor = Math.min(effectiveGrowthFactor, maxGrowthFactor);
        } else if (type === _OverlayHandleTypes2.default.TOP_RIGHT) {
            maxGrowthFactor = Math.min((cw - iX) / iW, (iY + iH) / iH);
            effectiveGrowthFactor = Math.min(effectiveGrowthFactor, maxGrowthFactor);
        }

        newRight = iX + iW * effectiveGrowthFactor;
        newBottom = iY + iH * effectiveGrowthFactor;

        var _deltaX2 = newRight - (iX + iW);
        var _deltaY2 = newBottom - (iY + iH);

        dlog('resizeDeltaX, resizeDeltaY', resizeDeltaX, resizeDeltaY, '---- deltaX, deltaY', _deltaX2, _deltaY2);
        return { deltaX: _deltaX2, deltaY: _deltaY2 };
    }
};

/**
 * gets angle between vectors created by joining (diagonalOpp and origin) and (point and origin)
 */
var calculateAngle = function calculateAngle(origin, diagonalOppPoint, point) {
    var tanThetaDiagonal = (diagonalOppPoint.x - origin.x) / (diagonalOppPoint.y - origin.y);
    var tanThetaPoint = (point.x - origin.x) / (point.y - origin.y);

    // tan(a - b) = tan(a) - tan(b) / 1 + tan(a) * tan(b)
    // we are interested in 'a - b' here

    var tanAngle = (tanThetaDiagonal - tanThetaPoint) / (1 + tanThetaDiagonal * tanThetaPoint);

    return Math.atan(tanAngle);
};

var findSnappingGuides = function findSnappingGuides(width, height, xSnapMap, ySnapMap, alignmentPoints) {
    var left = alignmentPoints.left,
        top = alignmentPoints.top,
        right = alignmentPoints.right,
        bottom = alignmentPoints.bottom,
        centerV = alignmentPoints.centerV,
        centerH = alignmentPoints.centerH;

    var newX = left;
    var newY = top;
    var minGapX = SNAP_GUIDE_THRESHOLD;
    var minGapY = SNAP_GUIDE_THRESHOLD;
    var xGuide = void 0;
    var yGuide = void 0;

    Object.keys(xSnapMap).forEach(function (guideId) {
        var _xSnapMap$guideId = xSnapMap[guideId],
            guidePos = _xSnapMap$guideId.pos,
            _xSnapMap$guideId$avo = _xSnapMap$guideId.avoid,
            avoid = _xSnapMap$guideId$avo === undefined ? [] : _xSnapMap$guideId$avo;

        if (!avoid.includes('LEFT') && Math.abs(left - guidePos) <= minGapX) {
            xGuide = guideId;
            minGapX = Math.abs(left - guidePos);
            newX = guidePos;
        }
        if (!avoid.includes('RIGHT') && Math.abs(right - guidePos) <= minGapX) {
            xGuide = guideId;
            minGapX = Math.abs(right - guidePos);
            newX = guidePos - width;
        }
        if (!avoid.includes('CENTER_V') && Math.abs(centerV - guidePos) <= minGapX) {
            xGuide = guideId;
            minGapX = Math.abs(centerV - guidePos);
            newX = guidePos - width / 2;
        }
    });

    Object.keys(ySnapMap).forEach(function (guideId) {
        var _ySnapMap$guideId = ySnapMap[guideId],
            guidePos = _ySnapMap$guideId.pos,
            _ySnapMap$guideId$avo = _ySnapMap$guideId.avoid,
            avoid = _ySnapMap$guideId$avo === undefined ? [] : _ySnapMap$guideId$avo;

        if (!avoid.includes('TOP') && Math.abs(top - guidePos) <= minGapY) {
            minGapY = Math.abs(top - guidePos);
            yGuide = guideId;
            newY = guidePos;
        }
        if (!avoid.includes('BOTTOM') && Math.abs(bottom - guidePos) <= minGapY) {
            yGuide = guideId;
            minGapY = Math.abs(bottom - guidePos);
            newY = guidePos - height;
        }
        if (!avoid.includes('CENTER_H') && Math.abs(centerH - guidePos) <= minGapY) {
            yGuide = guideId;
            minGapY = Math.abs(centerH - guidePos);
            newY = guidePos - height / 2;
        }
    });

    return {
        xGuide: xGuide,
        yGuide: yGuide,
        newX: newX,
        newY: newY
    };
};

var snapToGuides = function snapToGuides(selectionRect, xSnapMap, ySnapMap) {
    var x = selectionRect.x,
        y = selectionRect.y,
        width = selectionRect.width,
        height = selectionRect.height;

    var alignmentPoints = {
        left: x,
        top: y,
        right: x + width,
        bottom: y + height,
        centerV: x + width / 2,
        centerH: y + height / 2
    };

    var _findSnappingGuides = findSnappingGuides(width, height, xSnapMap, ySnapMap, alignmentPoints),
        newX = _findSnappingGuides.newX,
        newY = _findSnappingGuides.newY,
        xGuide = _findSnappingGuides.xGuide,
        yGuide = _findSnappingGuides.yGuide;

    return { newX: newX, newY: newY, xGuide: xGuide, yGuide: yGuide };
};

var getSnapMaps = function getSnapMaps(cw, ch, relevantOverlays, selectedOverlayIds) {
    var xSnapMap = {};
    var ySnapMap = {};

    xSnapMap[CANVAS_GUIDE_ID.VERTICAL_CENTER] = {
        pos: cw / 2
    };

    ySnapMap[CANVAS_GUIDE_ID.HORIZONTAL_CENTER] = {
        pos: ch / 2
    };
    ySnapMap[CANVAS_GUIDE_ID.HORIZONTAL_TOP] = { pos: ch * 0.1 };
    ySnapMap[CANVAS_GUIDE_ID.HORIZONTAL_BOTTOM] = { pos: ch * 0.9 };

    relevantOverlays.filter(function (o) {
        return !selectedOverlayIds.includes(o.id);
    }).forEach(function (overlay) {
        var overlayId = overlay.id,
            _overlay$space = overlay.space,
            gOverlayX = _overlay$space.x,
            gOverlayY = _overlay$space.y,
            gOverlayWidth = _overlay$space.width,
            gOverlayHeight = _overlay$space.height;

        xSnapMap[overlayGuideKey(overlayId, 'LEFT')] = { pos: gOverlayX, avoid: ['CENTER_V'] };
        xSnapMap[overlayGuideKey(overlayId, 'RIGHT')] = {
            pos: gOverlayX + gOverlayWidth,
            avoid: ['CENTER_V']
        };
        xSnapMap[overlayGuideKey(overlayId, 'CENTER_V')] = {
            pos: gOverlayX + gOverlayWidth / 2,
            avoid: ['LEFT', 'RIGHT']
        };

        ySnapMap[overlayGuideKey(overlayId, 'TOP')] = { pos: gOverlayY, avoid: ['CENTER_H'] };
        ySnapMap[overlayGuideKey(overlayId, 'BOTTOM')] = {
            pos: gOverlayY + gOverlayHeight,
            avoid: ['CENTER_H']
        };
        ySnapMap[overlayGuideKey(overlayId, 'CENTER_H')] = {
            pos: gOverlayY + gOverlayHeight / 2,
            avoid: ['TOP', 'BOTTOM']
        };
    });

    return {
        xSnapMap: xSnapMap,
        ySnapMap: ySnapMap
    };
};

var getCanvasGuides = function getCanvasGuides(cw, ch, displayScale) {
    var guides = {};

    guides[CANVAS_GUIDE_ID.VERTICAL_CENTER] = {
        x: cw / 2,
        y: 0,
        w: 2 / displayScale,
        h: ch,
        orientation: 'vertical'
    };
    guides[CANVAS_GUIDE_ID.HORIZONTAL_CENTER] = {
        x: 0,
        y: ch / 2,
        w: cw,
        h: 2 / displayScale,
        orientation: 'horizontal'
    };
    guides[CANVAS_GUIDE_ID.HORIZONTAL_TOP] = {
        x: 0,
        y: ch * 0.1,
        w: cw,
        h: 2 / displayScale,
        orientation: 'horizontal'
    };
    guides[CANVAS_GUIDE_ID.HORIZONTAL_BOTTOM] = {
        x: 0,
        y: ch * 0.9,
        w: cw,
        h: 2 / displayScale,
        orientation: 'horizontal'
    };

    return guides;
};

var getOverlayGuides = function getOverlayGuides(selectedOverlayIds, draggingRect, relevantOverlays, displayScale) {
    var guides = {};
    var x = draggingRect.x,
        y = draggingRect.y,
        width = draggingRect.width,
        height = draggingRect.height;

    // Target overlay/s dimensions

    var tOverlayLeft = x;
    var tOverlayRight = x + width;
    var tOverlayTop = y;
    var tOverlayBottom = y + height;

    relevantOverlays.filter(function (o) {
        return !selectedOverlayIds.includes(o.id);
    }).forEach(function (overlay) {
        var overlayId = overlay.id,
            _overlay$space2 = overlay.space,
            gOverlayX = _overlay$space2.x,
            gOverlayY = _overlay$space2.y,
            gOverlayWidth = _overlay$space2.width,
            gOverlayHeight = _overlay$space2.height;

        // Guide overlay boundaries

        var gOverlayLeft = gOverlayX;
        var gOverlayRight = gOverlayX + gOverlayWidth;
        var gOverlayTop = gOverlayY;
        var gOverlayBottom = gOverlayY + gOverlayHeight;
        var gOverlayVCenter = gOverlayX + gOverlayWidth / 2;
        var gOverlayHCenter = gOverlayY + gOverlayHeight / 2;

        if (Math.abs(tOverlayLeft - gOverlayRight) < Math.abs(tOverlayLeft - gOverlayLeft)) {
            guides[overlayGuideKey(overlayId, 'LEFT')] = {
                x: gOverlayRight,
                y: Math.min(tOverlayTop, gOverlayTop),
                w: 1 / displayScale,
                h: Math.max(tOverlayBottom, gOverlayBottom) - Math.min(tOverlayTop, gOverlayTop),
                orientation: 'vertical'
            };
        } else {
            guides[overlayGuideKey(overlayId, 'LEFT')] = {
                x: gOverlayLeft,
                y: Math.min(tOverlayTop, gOverlayTop),
                w: 1 / displayScale,
                h: Math.max(tOverlayBottom, gOverlayBottom) - Math.min(tOverlayTop, gOverlayTop),
                orientation: 'vertical'
            };
        }

        if (Math.abs(tOverlayRight - gOverlayRight) < Math.abs(tOverlayRight - gOverlayLeft)) {
            guides[overlayGuideKey(overlayId, 'RIGHT')] = {
                x: gOverlayRight,
                y: Math.min(tOverlayTop, gOverlayTop),
                w: 1 / displayScale,
                h: Math.max(tOverlayBottom, gOverlayBottom) - Math.min(tOverlayTop, gOverlayTop),
                orientation: 'vertical'
            };
        } else {
            guides[overlayGuideKey(overlayId, 'RIGHT')] = {
                x: gOverlayLeft,
                y: Math.min(tOverlayTop, gOverlayTop),
                w: 1 / displayScale,
                h: Math.max(tOverlayBottom, gOverlayBottom) - Math.min(tOverlayTop, gOverlayTop),
                orientation: 'vertical'
            };
        }

        guides[overlayGuideKey(overlayId, 'CENTER_V')] = {
            x: gOverlayVCenter,
            y: Math.min(tOverlayTop, gOverlayTop),
            w: 1 / displayScale,
            h: Math.max(tOverlayBottom, gOverlayBottom) - Math.min(tOverlayTop, gOverlayTop),
            orientation: 'vertical'
        };

        if (Math.abs(tOverlayTop - gOverlayTop) < Math.abs(tOverlayTop - gOverlayBottom)) {
            guides[overlayGuideKey(overlayId, 'TOP')] = {
                x: Math.min(tOverlayLeft, gOverlayLeft),
                y: gOverlayTop,
                w: Math.max(tOverlayRight, gOverlayRight) - Math.min(tOverlayLeft, gOverlayLeft),
                h: 1 / displayScale,
                orientation: 'horizontal'
            };
        } else {
            guides[overlayGuideKey(overlayId, 'TOP')] = {
                x: Math.min(tOverlayLeft, gOverlayLeft),
                y: gOverlayBottom,
                w: Math.max(tOverlayRight, gOverlayRight) - Math.min(tOverlayLeft, gOverlayLeft),
                h: 1 / displayScale,
                orientation: 'horizontal'
            };
        }

        if (Math.abs(tOverlayBottom - gOverlayBottom) < Math.abs(tOverlayBottom - gOverlayTop)) {
            guides[overlayGuideKey(overlayId, 'BOTTOM')] = {
                x: Math.min(tOverlayLeft, gOverlayLeft),
                y: gOverlayBottom,
                w: Math.max(tOverlayRight, gOverlayRight) - Math.min(tOverlayLeft, gOverlayLeft),
                h: 1 / displayScale,
                orientation: 'horizontal'
            };
        } else {
            guides[overlayGuideKey(overlayId, 'BOTTOM')] = {
                x: Math.min(tOverlayLeft, gOverlayLeft),
                y: gOverlayTop,
                w: Math.max(tOverlayRight, gOverlayRight) - Math.min(tOverlayLeft, gOverlayLeft),
                h: 1 / displayScale,
                orientation: 'horizontal'
            };
        }

        guides[overlayGuideKey(overlayId, 'CENTER_H')] = {
            x: Math.min(tOverlayLeft, gOverlayLeft),
            y: gOverlayHCenter,
            w: Math.max(tOverlayRight, gOverlayRight) - Math.min(tOverlayLeft, gOverlayLeft),
            h: 1 / displayScale,
            orientation: 'horizontal'
        };
    });

    return guides;
};

var SelectionLayer = function SelectionLayer(props) {
    var appManager = (0, _react.useContext)(_reactContext.AppManagerContext);

    var displayScale = props.displayScale,
        _props$selection = props.selection,
        selected = _props$selection.selected,
        selecting = _props$selection.selecting,
        playbackState = props.playbackState,
        relevantOverlays = props.relevantOverlays,
        canvas = props.canvas,
        disableMovement = props.disableMovement,
        _props$canvas = props.canvas,
        cw = _props$canvas.width,
        ch = _props$canvas.height;
    var onMoveSingleIncremental = props.onMoveSingleIncremental,
        onMoveMultipleIncremental = props.onMoveMultipleIncremental;

    var localData = (0, _react.useRef)({});

    var overlaysRef = (0, _usePropRef.usePropRef)(props.overlays);

    var borderColor = '#EF67C9';
    var isImageOverlay = false;
    var isMultiSelected = false;
    var isTextOverlay = false;
    if (props.selectedOverlays.length > 0) {
        if (props.selectedOverlays.length > 1) {
            borderColor = '#ffffff';
            isMultiSelected = true;
        } else {
            var _props$selectedOverla = _slicedToArray(props.selectedOverlays, 1),
                selectedOverlay = _props$selectedOverla[0];

            var def = appManager.getTemplateDefForId(selectedOverlay.defId);
            var textLayerValueMap = selectedOverlay && (0, _OverlayUtils.getLayerPropValueMap)(selectedOverlay, 'text', true);

            if ((0, _OverlayUtils.detectIsImageTemplate)(def) && Object.keys(textLayerValueMap).length === 0) {
                //Check If Image Overlay
                borderColor = '#0ED4FF';
                isImageOverlay = true;
            } else if (Object.keys(textLayerValueMap).length !== 0) {
                //Check if text overlay
                isTextOverlay = true;
                borderColor = '#EF67C9';
            } else {
                //Set border color for element items
                borderColor = '#0ED4FF';
            }
        }
    }

    var selectedOverlayRef = (0, _react.useRef)(props.selectedOverlays);
    selectedOverlayRef.current = props.selectedOverlays;

    var _useState = (0, _react.useState)(getCanvasGuides(cw, ch, displayScale, relevantOverlays)),
        _useState2 = _slicedToArray(_useState, 2),
        canvasGuides = _useState2[0],
        setCanvasGuides = _useState2[1];

    var _useState3 = (0, _react.useState)([]),
        _useState4 = _slicedToArray(_useState3, 2),
        visibleGuides = _useState4[0],
        setVisibleGuides = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        dragging = _useState6[0],
        setDragging = _useState6[1];

    var _useState7 = (0, _react.useState)([]),
        _useState8 = _slicedToArray(_useState7, 2),
        selectedOverlayIds = _useState8[0],
        setSelectedOverlayIds = _useState8[1];

    (0, _react.useEffect)(function () {
        setCanvasGuides(getCanvasGuides(cw, ch, displayScale));
    }, [cw, ch, displayScale]);

    var _useMemo = (0, _react.useMemo)(function () {
        return getSnapMaps(cw, ch, relevantOverlays, selectedOverlayIds);
    }, [cw, ch, relevantOverlays, selectedOverlayIds]),
        xSnapMap = _useMemo.xSnapMap,
        ySnapMap = _useMemo.ySnapMap;

    var onDragStart = function onDragStart(oid) {
        var _props$onMoveSingleSt = props.onMoveSingleStart,
            onMoveSingleStart = _props$onMoveSingleSt === undefined ? function () {} : _props$onMoveSingleSt;

        localData.current = {
            startOverlay: overlaysRef.current[oid],
            selectionRect: overlaysRef.current[oid].space
        };

        onMoveSingleStart(oid);
        setDragging(true);
        setSelectedOverlayIds([oid]);
    };

    var onDragMove = function onDragMove(oid, dragDeltaX, dragDeltaY) {
        var startOverlay = localData.current.startOverlay;

        if (!!startOverlay && !!startOverlay.isWatermark && !!props.containsWatermark) {
            return;
        }

        var _startOverlay$space = startOverlay.space,
            startX = _startOverlay$space.x,
            startY = _startOverlay$space.y,
            startWidth = _startOverlay$space.width,
            startHeight = _startOverlay$space.height;

        var maxDeltaX = (cw - (startX + startWidth)) * displayScale;
        var maxDeltaY = (ch - (startY + startHeight)) * displayScale;
        var minDeltaX = -startX * displayScale;
        var minDeltaY = -startY * displayScale;

        var deltaX = Math.max(minDeltaX, Math.min(dragDeltaX, maxDeltaX));
        var deltaY = Math.max(minDeltaY, Math.min(dragDeltaY, maxDeltaY));

        var selectionRect = {
            x: startX + deltaX / displayScale,
            y: startY + deltaY / displayScale,
            width: startWidth,
            height: startHeight
        };

        var _snapToGuides = snapToGuides(selectionRect, xSnapMap, ySnapMap),
            newX = _snapToGuides.newX,
            newY = _snapToGuides.newY,
            xGuide = _snapToGuides.xGuide,
            yGuide = _snapToGuides.yGuide;

        if (setVisibleGuides) {
            var guidesToShow = [xGuide, yGuide].filter(function (g) {
                return !!g;
            });
            setVisibleGuides(guidesToShow);
        }

        var currentOverlay = (0, _deepmerge2.default)(startOverlay, {
            space: {
                x: newX,
                y: newY
            }
        });

        localData.current = { startOverlay: startOverlay, currentOverlay: currentOverlay, selectionRect: selectionRect };

        onMoveSingleIncremental(currentOverlay);
    };

    var onDragEnd = function onDragEnd(oid) {
        if (!!localData.current.startOverlay.isWatermark && !!props.containsWatermark) {
            return;
        }

        props.onMoveSingleFinish(localData.current.currentOverlay, localData.current.startOverlay);
        localData.current = {};
        setDragging(false);
    };

    var onSelect = function onSelect(oid, add) {
        var onSelectAdd = props.onSelectAdd,
            onSelectOnly = props.onSelectOnly;

        if (add) {
            onSelectAdd(oid);
        } else {
            onSelectOnly(oid);
        }
    };

    var onMultiDragStart = function onMultiDragStart() {
        if (disableMovement) {
            return;
        }

        var _props$onMoveMultiple = props.onMoveMultipleStart,
            onMoveMultipleStart = _props$onMoveMultiple === undefined ? function () {} : _props$onMoveMultiple;

        var selectedOverlayList = selectedOverlayRef.current;

        var startSelectedRect = (0, _OverlayUtils.overlayRectUnion)(selectedOverlayList);

        localData.current = {
            startOverlays: selectedOverlayList,
            startSelectedRect: startSelectedRect,
            currentOverlays: selectedOverlayList,
            selectionRect: startSelectedRect
        };

        onMoveMultipleStart(selectedOverlayList);
        setDragging(true);
        setSelectedOverlayIds(selectedOverlayList.map(function (o) {
            return o.id;
        }));
    };

    var onMultiDragMove = function onMultiDragMove(dragDeltaX, dragDeltaY) {
        if (disableMovement) {
            return;
        }

        var _localData$current = localData.current,
            startOverlays = _localData$current.startOverlays,
            startSelectedRect = _localData$current.startSelectedRect;
        var startRectX = startSelectedRect.x,
            startRectY = startSelectedRect.y,
            startRectWidth = startSelectedRect.width,
            startRectHeight = startSelectedRect.height;

        var maxDeltaX = (cw - (startRectX + startRectWidth)) * displayScale;
        var maxDeltaY = (ch - (startRectY + startRectHeight)) * displayScale;
        var minDeltaX = -startRectX * displayScale;
        var minDeltaY = -startRectY * displayScale;

        var deltaX = Math.max(minDeltaX, Math.min(dragDeltaX, maxDeltaX));
        var deltaY = Math.max(minDeltaY, Math.min(dragDeltaY, maxDeltaY));

        var selectionRect = {
            x: startRectX + deltaX / displayScale,
            y: startRectY + deltaY / displayScale,
            width: startRectWidth,
            height: startRectHeight
        };

        var _snapToGuides2 = snapToGuides(selectionRect, xSnapMap, ySnapMap),
            newRectX = _snapToGuides2.newX,
            newRectY = _snapToGuides2.newY,
            xGuide = _snapToGuides2.xGuide,
            yGuide = _snapToGuides2.yGuide;

        if (setVisibleGuides) {
            var guidesToShow = [xGuide, yGuide].filter(function (g) {
                return !!g;
            });
            setVisibleGuides(guidesToShow);
        }

        var newDeltaX = newRectX - startRectX;
        var newDeltaY = newRectY - startRectY;

        var currentOverlays = startOverlays.map(function (o) {
            var _o$space = o.space,
                x = _o$space.x,
                y = _o$space.y;

            return (0, _deepmerge2.default)(o, {
                space: {
                    x: x + newDeltaX,
                    y: y + newDeltaY
                }
            });
        });

        localData.current = { startOverlays: startOverlays, startSelectedRect: startSelectedRect, currentOverlays: currentOverlays, selectionRect: selectionRect };

        onMoveMultipleIncremental(currentOverlays);
    };

    var onMultiDragEnd = function onMultiDragEnd() {
        if (disableMovement) {
            return;
        }
        var _localData$current2 = localData.current,
            currentOverlays = _localData$current2.currentOverlays,
            startOverlays = _localData$current2.startOverlays;

        props.onMoveMultipleFinish(currentOverlays, startOverlays);
        localData.current = {};
        setDragging(false);
    };

    var onMultiRotateMove = function onMultiRotateMove(deltaAngle) {
        if (disableMovement) return;

        var _localData$current3 = localData.current,
            startOverlays = _localData$current3.startOverlays,
            startSelectedRect = _localData$current3.startSelectedRect;
        var _startSelectedRect$ro = startSelectedRect.rotateDeg,
            startAngle = _startSelectedRect$ro === undefined ? 0 : _startSelectedRect$ro;

        var newRotateDeg = snapToAngle(startAngle + deltaAngle);

        var currentOverlays = startOverlays.map(function (o) {
            return (0, _deepmerge2.default)(o, {
                space: {
                    rotateDeg: newRotateDeg
                }
            });
        });

        localData.current = _extends({}, localData.current, {
            startOverlays: startOverlays,
            startSelectedRect: startSelectedRect,
            currentOverlays: currentOverlays
        });

        onMoveMultipleIncremental(currentOverlays);
    };

    var onResizeStart = function onResizeStart() {
        var selectedOverlayList = selectedOverlayRef.current;

        var startSelectionRect = (0, _OverlayUtils.overlayRectUnion)(selectedOverlayList);
        localData.current = {
            startSelectedRect: startSelectionRect,
            selectionRect: startSelectionRect,
            startOverlays: selectedOverlayList,
            currentOverlays: selectedOverlayList
        };
    };

    var onResizeMove = function onResizeMove(resizeType, resizeDeltaX, resizeDeltaY) {
        var canvas = props.canvas,
            onResizeIncremental = props.onResizeIncremental;
        var _localData$current4 = localData.current,
            startOverlays = _localData$current4.startOverlays,
            startSelectedRect = _localData$current4.startSelectedRect;

        var _extractDelta = extractDelta(resizeType, resizeDeltaX / displayScale, resizeDeltaY / displayScale, startSelectedRect, canvas),
            deltaX = _extractDelta.deltaX,
            deltaY = _extractDelta.deltaY;

        var startRectX = startSelectedRect.x,
            startRectY = startSelectedRect.y,
            startRectWidth = startSelectedRect.width,
            startRectHeight = startSelectedRect.height;

        var resizeFactorX = (startRectWidth + deltaX) / startRectWidth;
        var resizeFactorY = (startRectHeight + deltaY) / startRectHeight;

        var currentOverlays = startOverlays.map(function (o) {
            var _o$space2 = o.space,
                x = _o$space2.x,
                y = _o$space2.y,
                width = _o$space2.width,
                height = _o$space2.height,
                transform = _o$space2.transform;

            var scale = (0, _LayerUtils.getScaleFromTransformString)(transform);
            var _o$values = o.values,
                _o$values$lineSpacing = _o$values.lineSpacing,
                lineSpacing = _o$values$lineSpacing === undefined ? 0 : _o$values$lineSpacing,
                _o$values$cropImageX = _o$values.cropImageX,
                cropImageX = _o$values$cropImageX === undefined ? 0 : _o$values$cropImageX,
                _o$values$cropImageY = _o$values.cropImageY,
                cropImageY = _o$values$cropImageY === undefined ? 0 : _o$values$cropImageY,
                _o$values$cropImageWi = _o$values.cropImageWidth,
                cropImageWidth = _o$values$cropImageWi === undefined ? width / scale[0] : _o$values$cropImageWi,
                _o$values$cropImageHe = _o$values.cropImageHeight,
                cropImageHeight = _o$values$cropImageHe === undefined ? height / scale[1] : _o$values$cropImageHe;

            var newImageX = cropImageX;
            var newImageY = cropImageY;
            var newImageWidth = cropImageWidth;
            var newImageHeight = cropImageHeight;

            var relX = x - startRectX;
            var relY = y - startRectY;

            //offSetX is used for finding newX value while resize using left handle since position of x changes
            var offSetX = 0;
            if (resizeType === _OverlayHandleTypes2.default.LEFT) {
                offSetX = deltaX;
            }
            //offSetY is used for finding newY value while resize using top handle since position of y changes
            var offSetY = 0;
            if (resizeType === _OverlayHandleTypes2.default.TOP) {
                offSetY = deltaY;
            }

            var newX = relX * resizeFactorX + startRectX - offSetX;
            var newY = relY * resizeFactorY + startRectY - offSetY;

            var newWidth = resizeFactorX * width;
            var newHeight = resizeFactorY * height;

            var updatedImageX = cropImageX;
            var updatedImageY = cropImageY;

            // TODO: Change the implementation of taking imageInitialWidth and imageInitialHeight 
            // since this value will never change, it is not a good practice to use from here
            // can use the value from registry - Currently both the values are different
            // Might have to change the implementation somehow

            if (resizeType === _OverlayHandleTypes2.default.RIGHT || resizeType === _OverlayHandleTypes2.default.LEFT) {
                var defModel = _DefModel.DefModelRegistry.getModelForOverlay(o.defId, o.id);

                if (!defModel.values.isInitialImageDimensionChanged) {
                    var newOverlay = (0, _deepmerge2.default)(o, {
                        values: {
                            isInitialImageDimensionChanged: true,
                            imageInitialWidth: width / scale[0],
                            imageInitialHeight: height / scale[1]
                        }
                    });

                    defModel.update(newOverlay.space, newOverlay.time, newOverlay.values, canvas);
                }
                var updatedImageWidth = cropImageWidth + deltaX * cropImageWidth / width;
                if (resizeType === _OverlayHandleTypes2.default.RIGHT) {
                    if (deltaX > 0 && updatedImageWidth > defModel.values.imageInitialWidth - cropImageX) {
                        newImageWidth = defModel.values.imageInitialWidth - cropImageX;
                        var zoomFactor = newWidth / newImageWidth;
                        var maxImageHeight = defModel.values.imageInitialHeight * zoomFactor;
                        newImageHeight = newHeight * defModel.values.imageInitialHeight / maxImageHeight;
                        newImageY = cropImageY + (cropImageHeight - newImageHeight) / 2;
                    } else {
                        newImageWidth = updatedImageWidth;
                    }
                }

                if (resizeType === _OverlayHandleTypes2.default.LEFT) {
                    var _updatedImageWidth = cropImageWidth + deltaX * cropImageWidth / width;
                    var _updatedImageX = cropImageX - deltaX * cropImageWidth / width;

                    if (deltaX > 0 && _updatedImageX <= 0) {
                        newImageX = 0;
                        var widthdiff = defModel.values.imageInitialWidth - cropImageX - cropImageWidth;
                        newImageWidth = defModel.values.imageInitialWidth - widthdiff;

                        var _zoomFactor = newWidth / newImageWidth;
                        var _maxImageHeight = defModel.values.imageInitialHeight * _zoomFactor;
                        newImageHeight = newHeight * defModel.values.imageInitialHeight / _maxImageHeight;
                        newImageY = cropImageY + (cropImageHeight - newImageHeight) / 2;
                    } else {
                        newImageWidth = _updatedImageWidth;
                        newImageX = cropImageX - deltaX * cropImageWidth / width;
                    }
                }

                return (0, _deepmerge2.default)(o, {
                    space: {
                        width: newWidth,
                        x: newX,
                        y: newY
                    },
                    values: {
                        cropImageX: newImageX,
                        cropImageY: newImageY,
                        isInitialImageDimensionChanged: true,
                        imageInitialWidth: defModel.values.imageInitialWidth,
                        imageInitialHeight: defModel.values.imageInitialHeight,
                        cropImageWidth: newImageWidth,
                        cropImageHeight: newImageHeight
                    }
                });
            }
            if (resizeType === _OverlayHandleTypes2.default.TOP_LEFT || resizeType === _OverlayHandleTypes2.default.TOP_RIGHT || resizeType === _OverlayHandleTypes2.default.BOTTOM_LEFT || resizeType === _OverlayHandleTypes2.default.BOTTOM_RIGHT) {
                var transformScale = 1;

                if (resizeType === _OverlayHandleTypes2.default.BOTTOM_RIGHT) {
                    transformScale = resizeFactorX;
                } else if (resizeType === _OverlayHandleTypes2.default.TOP_RIGHT) {
                    transformScale = resizeFactorY;

                    newHeight = height * resizeFactorY;
                    newY = y - (newHeight - height);
                } else if (resizeType === _OverlayHandleTypes2.default.TOP_LEFT || resizeType === _OverlayHandleTypes2.default.BOTTOM_LEFT) {
                    transformScale = 1 / resizeFactorX;

                    newWidth = width / resizeFactorX;
                    newHeight = height / resizeFactorY;
                    newX = x - (newWidth - width);

                    if (resizeType === _OverlayHandleTypes2.default.TOP_LEFT) {
                        newY = y - (newHeight - height);
                    }
                }

                return (0, _deepmerge2.default)(o, {
                    space: {
                        transform: (0, _LayerUtils.getScaledTransformString)(transform, transformScale, transformScale),
                        x: newX,
                        y: newY,
                        width: newWidth,
                        height: newHeight
                    },
                    values: {
                        cropImageX: updatedImageX,
                        cropImageY: updatedImageY
                    }
                });
            }
            if (resizeType === _OverlayHandleTypes2.default.BOTTOM || resizeType === _OverlayHandleTypes2.default.TOP) {
                var _defModel = _DefModel.DefModelRegistry.getModelForOverlay(o.defId, o.id);
                if (!_defModel.values.isInitialImageDimensionChanged) {
                    var _newOverlay = (0, _deepmerge2.default)(o, {
                        values: {
                            isInitialImageDimensionChanged: true,
                            imageInitialWidth: width / scale[0],
                            imageInitialHeight: height / scale[1]
                        }
                    });

                    _defModel.update(_newOverlay.space, _newOverlay.time, _newOverlay.values, canvas);
                }

                var updatedImageHeight = cropImageHeight + deltaY * cropImageHeight / height;
                if (resizeType === _OverlayHandleTypes2.default.BOTTOM) {
                    if (deltaY > 0 && updatedImageHeight > _defModel.values.imageInitialHeight - cropImageY) {
                        newImageHeight = _defModel.values.imageInitialHeight - cropImageY;
                        var _zoomFactor2 = newHeight / newImageHeight;
                        var maxImageWidth = _defModel.values.imageInitialWidth * _zoomFactor2;
                        newImageWidth = newWidth * _defModel.values.imageInitialWidth / maxImageWidth;
                        newImageX = cropImageX + (cropImageWidth - newImageWidth) / 2;
                    } else {
                        newImageHeight = updatedImageHeight;
                    }
                }

                if (resizeType === _OverlayHandleTypes2.default.TOP) {
                    var _updatedImageY = cropImageY - deltaY * cropImageHeight / height;
                    if (deltaY > 0 && _updatedImageY <= 0) {
                        newImageY = 0;
                        var heightDiff = _defModel.values.imageInitialHeight - cropImageY - cropImageHeight;
                        newImageHeight = _defModel.values.imageInitialHeight - heightDiff;
                        var _zoomFactor3 = newHeight / newImageHeight;
                        var _maxImageWidth = _defModel.values.imageInitialWidth * _zoomFactor3;
                        newImageWidth = newWidth * _defModel.values.imageInitialWidth / _maxImageWidth;
                        newImageX = cropImageX + (cropImageWidth - newImageWidth) / 2;
                    } else {
                        newImageHeight = updatedImageHeight;
                        newImageY = cropImageY - deltaY * cropImageHeight / height;
                    }
                }

                return (0, _deepmerge2.default)(o, {
                    space: {
                        height: newHeight,
                        x: newX,
                        y: newY
                    },
                    values: {
                        cropImageX: newImageX,
                        cropImageY: newImageY,
                        isInitialImageDimensionChanged: true,
                        imageInitialWidth: _defModel.values.imageInitialWidth,
                        imageInitialHeight: _defModel.values.imageInitialHeight,
                        cropImageWidth: newImageWidth,
                        cropImageHeight: newImageHeight
                    }
                });
            }
            if (resizeType === _OverlayHandleTypes2.default.BOTTOM_LINE_SPACING) {
                var newLineSpacing = Math.min(Math.max(0, lineSpacing + deltaY), 200);

                return (0, _deepmerge2.default)(o, {
                    values: {
                        lineSpacing: newLineSpacing
                    }
                });
            }
            if (resizeType === _OverlayHandleTypes2.default.BOTTOM_LINE_HEIGHT) {
                var _def = getTemplateDefForId(o.defId);
                var _def$meta = _def.meta;
                _def$meta = _def$meta === undefined ? {} : _def$meta;
                var _def$meta$variableLin = _def$meta.variableLineHeightProp,
                    variableLineHeightProp = _def$meta$variableLin === undefined ? 'lineHeight' : _def$meta$variableLin;

                var lineHeight = o.values[variableLineHeightProp];

                var newLineHeight = Math.min(Math.max(0.5, lineHeight + deltaY / 100), 2.5);

                return (0, _deepmerge2.default)(o, {
                    values: _defineProperty({}, variableLineHeightProp, newLineHeight)
                });
            }
            return o;
        });

        localData.current = _extends({}, localData.current, { currentOverlays: currentOverlays });

        onResizeIncremental(currentOverlays);
    };

    var onResizeEnd = function onResizeEnd() {
        var _localData$current5 = localData.current,
            currentOverlays = _localData$current5.currentOverlays,
            startOverlays = _localData$current5.startOverlays;

        props.onResizeFinish(currentOverlays, startOverlays);

        localData.current = {};
    };

    var isPlaying = playbackState === _PlaybackState2.default.PLAYING;

    var selectedOverlayList = selectedOverlayRef.current;

    var anySelected = Object.keys(selected).length > 0;

    var selectionBoxNodes = relevantOverlays.map(function (o) {
        if (o.isPreviewSubtitle) {
            return null;
        }

        var oSelected = !!selected[o.id];
        var oSelecting = !!selecting[o.id];

        return _react2.default.createElement(_OverlaySelectionBox2.default, {
            key: o.id,
            displayScale: displayScale,
            overlay: o,
            anySelected: anySelected,
            selected: oSelected,
            selecting: oSelecting,
            isPlaying: isPlaying,
            onDragStart: onDragStart,
            onDragMove: onDragMove,
            onDragEnd: onDragEnd,
            onSelect: onSelect,
            canDrag: !disableMovement
        });
    });

    var MOSBZIndex = (0, _OverlayUtils.getHighestZIndex)(overlaysRef.current) + 20;
    var showMOSB = selectedOverlayList.length > 0;
    var blockMouseEvents = selectedOverlayList.length > 1;

    var resizeMode = _ResizeHandles.ResizeMode.NONE;
    var canChangeLineSpacing = false;
    var canChangeLineHeight = false;
    if (selectedOverlayList.length > 0) {
        if (selectedOverlayList.length === 1) {
            var _selectedOverlayList = _slicedToArray(selectedOverlayList, 1),
                _selectedOverlay = _selectedOverlayList[0];

            var _def2 = getTemplateDefForId(_selectedOverlay.defId);

            var _def2$meta = _def2.meta;
            _def2$meta = _def2$meta === undefined ? {} : _def2$meta;
            var _def2$meta$autoHeight = _def2$meta.autoHeight,
                autoHeight = _def2$meta$autoHeight === undefined ? false : _def2$meta$autoHeight,
                _def2$meta$scaleOnly = _def2$meta.scaleOnly,
                scaleOnly = _def2$meta$scaleOnly === undefined ? false : _def2$meta$scaleOnly,
                _def2$meta$variableLi = _def2$meta.variableLineSpacing,
                variableLineSpacing = _def2$meta$variableLi === undefined ? false : _def2$meta$variableLi,
                _def2$meta$variableLi2 = _def2$meta.variableLineHeight,
                variableLineHeight = _def2$meta$variableLi2 === undefined ? false : _def2$meta$variableLi2;

            canChangeLineSpacing = variableLineSpacing;
            canChangeLineHeight = variableLineHeight;

            if (scaleOnly === true) {
                resizeMode = _ResizeHandles.ResizeMode.SCALE_ONLY;
            } else if (autoHeight === true) {
                resizeMode = _ResizeHandles.ResizeMode.SCALE_AND_WIDTH;
            } else {
                resizeMode = _ResizeHandles.ResizeMode.SCALE_AND_WIDTH_AND_HEIGHT;
            }
        } else {
            resizeMode = _ResizeHandles.ResizeMode.SCALE_ONLY;
        }
    }

    var selectedRect = selectedOverlayList.length !== 0 ? (0, _OverlayUtils.overlayRectUnion)(selectedOverlayList) : { x: 0, y: 0, width: 0, height: 0, rotateDeg: 0 };

    var MOSBNode = _react2.default.createElement(_MultiOverlaySelectionBox2.default, {
        borderColor: borderColor,
        displayScale: displayScale,
        zIndex: MOSBZIndex,
        show: showMOSB,
        isTextOverlay: isTextOverlay,
        isImageOverlay: isImageOverlay,
        isMultiSelected: isMultiSelected,
        isPlaying: isPlaying,
        resizeMode: resizeMode,
        canvas: canvas,
        canChangeLineSpacing: canChangeLineSpacing,
        canChangeLineHeight: canChangeLineHeight,
        blockMouseEvents: blockMouseEvents,
        selectedRect: selectedRect,
        onMultiDragStart: onMultiDragStart,
        onMultiDragMove: onMultiDragMove,
        onMultiDragEnd: onMultiDragEnd,
        hideResizeHandles: disableMovement,
        disableMovement: disableMovement,
        onMultiRotateMove: onMultiRotateMove,
        onResizeStart: onResizeStart,
        onResizeMove: onResizeMove,
        onResizeEnd: onResizeEnd,
        onSelect: onSelect
    });

    var guides = null;
    if (!isPlaying && dragging && visibleGuides.length > 0) {
        var overlayGuides = getOverlayGuides(selectedOverlayIds, localData.current.selectionRect, relevantOverlays, displayScale);

        guides = _react2.default.createElement(_AlignmentGuides2.default, {
            allGuides: _extends({}, canvasGuides, overlayGuides),
            visibleGuides: visibleGuides,
            displayScale: displayScale
        });
    }

    return _react2.default.createElement(_hooks.PreventClipSelectCloseDiv, { className: 'selection-layer-root fill-parent-size' }, selectionBoxNodes, MOSBNode, guides);
};

exports.default = function (props) {
    return _react2.default.createElement(_CommonRenderGuards.ReduxUpdateGuard, {
        shouldUpdate: function shouldUpdate(state) {
            var _state$operationGuard = state.operationGuards;
            _state$operationGuard = _state$operationGuard === undefined ? {} : _state$operationGuard;
            var _state$operationGuard2 = _state$operationGuard.disableOverlayUpdate,
                disableOverlayUpdate = _state$operationGuard2 === undefined ? false : _state$operationGuard2;

            return !disableOverlayUpdate;
        }
    }, function () {
        return _react2.default.createElement(SelectionLayer, props);
    });
};

},{"../../common/config/AllTemplateDefs":29,"../../common/utils/CommonAlgorithms":72,"../../common/utils/enums/PlaybackState":96,"../../common/utils/hooks/usePropRef.react":107,"../../common/utils/renderer/DefModel":119,"../../common/utils/renderer/LayerUtils":121,"../constants/OverlayHandleTypes":205,"../utils/OverlayUtils":231,"../utils/reactContext":237,"./AlignmentGuides.react":179,"./MultiOverlaySelectionBox.react":181,"./OverlaySelectionBox.react":185,"./ResizeHandles.react":187,"./timelineeditor/hooks":196,"./utility/memoRules/CommonRenderGuards.react":199,"deepmerge":549,"keymirror":677,"react":1107}],190:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TextEditorAreaInner = function (_Component) {
    _inherits(TextEditorAreaInner, _Component);

    function TextEditorAreaInner() {
        _classCallCheck(this, TextEditorAreaInner);

        return _possibleConstructorReturn(this, (TextEditorAreaInner.__proto__ || Object.getPrototypeOf(TextEditorAreaInner)).apply(this, arguments));
    }

    _createClass(TextEditorAreaInner, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._documentClickCallback = function (e) {
                return _this2.onDocumentClick(e);
            };
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            if ($(e.target).closest($(this.textEditorRoot)).length === 0) {
                this.props.onClickOutside(this.props.uid);
            }
        }
    }, {
        key: 'onPureClick',
        value: function onPureClick(e) {
            this.props.onClick(this.props.uid, e);
            this.props.onChangeFocus(this.props.uid);

            e.preventDefault();
        }
    }, {
        key: 'onDragStart',
        value: function onDragStart(e) {
            var areaOffset = $(this.textEditorRoot).offset();

            var clickRelX = e.pageX - areaOffset.left;
            var clickRelY = e.pageY - areaOffset.top;

            this.props.onDragStart(this.props.uid, clickRelX, clickRelY);
        }
    }, {
        key: 'onDragMove',
        value: function onDragMove(deltaX, deltaY) {
            this.props.onDragMove(this.props.uid, deltaX, deltaY);
        }
    }, {
        key: 'onDragEnd',
        value: function onDragEnd() {
            this.props.onDragEnd(this.props.uid);
            this.props.onChangeFocus(this.props.uid);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                displayScale = _props.displayScale,
                rect = _props.rect,
                isFocused = _props.isFocused,
                _props$cursorRect = _props.cursorRect,
                cRect = _props$cursorRect === undefined ? null : _props$cursorRect,
                _props$cursorColor = _props.cursorColor,
                cursorColor = _props$cursorColor === undefined ? 'white' : _props$cursorColor,
                uid = _props.uid;
            var _props$selectionRects = this.props.selectionRects,
                sRects = _props$selectionRects === undefined ? null : _props$selectionRects;
            var dragCallbacks = this.props.dragCallbacks;

            var offsetForResizeHandler = 5; //Leaving space for width reszie handler (right)

            var textEditorAreaStyles = {
                left: rect.x * displayScale + 'px',
                top: rect.y * displayScale + 'px',
                width: (rect.width - offsetForResizeHandler) * displayScale + 'px',
                height: rect.height * displayScale + 'px',
                transform: 'rotate(' + (rect.rotateDeg || 0) + 'deg)'
            };

            var editorCursorNode = null;
            var editorSelectionNodes = null;

            if (isFocused) {
                var hasSelection = sRects !== null && sRects.length > 0;

                if (hasSelection) {
                    editorSelectionNodes = sRects.map(function (sRect, i) {
                        var textSelectionStyles = {
                            left: Math.floor(sRect.x * displayScale) + 'px',
                            top: Math.floor(sRect.y * displayScale) + 'px',
                            width: Math.ceil(sRect.width * displayScale) + 'px',
                            height: Math.ceil(sRect.height * displayScale) + 'px'
                        };
                        return _react2.default.createElement('div', {
                            key: i + '',
                            className: 'text-editor-selection',
                            style: textSelectionStyles
                        });
                    });
                } else {
                    var textCursorStyles = {
                        left: Math.floor(cRect.x * displayScale) + 'px',
                        top: Math.floor(cRect.y * displayScale) + 'px',
                        width: Math.ceil(cRect.width * displayScale) + 'px',
                        height: Math.ceil(cRect.height * displayScale) + 'px',
                        backgroundColor: cursorColor
                    };

                    editorCursorNode = _react2.default.createElement('div', { className: 'text-editor-cursor', style: textCursorStyles });
                }
            }

            return _react2.default.createElement('div', {
                className: 'text-editor-area',
                style: textEditorAreaStyles,
                ref: function ref(c) {
                    _this3.textEditorRoot = c;
                    dragCallbacks.refTrack(c);
                },
                onMouseDown: dragCallbacks.onTrackMouseDown,
                onMouseUp: dragCallbacks.onTrackMouseUp
            }, editorSelectionNodes, editorCursorNode);
        }
    }]);

    return TextEditorAreaInner;
}(_react.Component);

TextEditorAreaInner.propTypes = {
    dragState: _propTypes2.default.object.isRequired, // injected
    dragCallbacks: _propTypes2.default.object.isRequired, // injected
    uid: _propTypes2.default.string.isRequired,
    displayScale: _propTypes2.default.number.isRequired,
    rect: _propTypes2.default.object.isRequired,
    isFocused: _propTypes2.default.bool.isRequired,
    onChangeFocus: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    onClickOutside: _propTypes2.default.func.isRequired,
    onDragStart: _propTypes2.default.func.isRequired,
    onDragMove: _propTypes2.default.func.isRequired,
    onDragEnd: _propTypes2.default.func.isRequired,
    cursorRect: _propTypes2.default.object,
    selectionRects: _propTypes2.default.array,
    cursorColor: _propTypes2.default.string
};

var TextEditorArea = (0, _ClickDragMixin2.default)(TextEditorAreaInner, {
    strictMouseDownTargetCheck: false,
    strictMouseUpTargetCheck: false,
    preventDefaultOnMouseDown: true
});

exports.default = TextEditorArea;

},{"../mixins/ClickDragMixin.react":211,"prop-types":896,"react":1107}],191:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

exports.default = TextEditorLayerWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _OverlayUtils = require('../utils/OverlayUtils');

var _LayerUtils = require('../../common/utils/renderer/LayerUtils');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _ColorRange = require('../../common/utils/ColorRange');

var _ColorRange2 = _interopRequireDefault(_ColorRange);

var _HighlightColorRange = require('../../common/utils/HighlightColorRange');

var _HighlightColorRange2 = _interopRequireDefault(_HighlightColorRange);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _TextEditorArea = require('./TextEditorArea.react');

var _TextEditorArea2 = _interopRequireDefault(_TextEditorArea);

var _CommonRenderGuards = require('./utility/memoRules/CommonRenderGuards.react');

var _hooks = require('./timelineeditor/hooks');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DiffMatchPatch = require('diff-match-patch');

var TextEditorLayer = function (_PureComponent) {
    _inherits(TextEditorLayer, _PureComponent);

    function TextEditorLayer(props) {
        _classCallCheck(this, TextEditorLayer);

        var _this = _possibleConstructorReturn(this, (TextEditorLayer.__proto__ || Object.getPrototypeOf(TextEditorLayer)).call(this, props));

        _this.state = {
            focusUID: null,
            editorValue: '',
            textAlign: '',
            cursorRect: null,
            selectionRects: null,
            selectionStart: -1,
            selectionEnd: -1,
            isFontRTL: false
        };

        _this.localDragData = { dragUid: null, startX: -1, startY: -1, startSelectionIndex: -1 };

        _this.defModels = {};

        _this.onTextEditorAreaClickFunc = function () {
            return _this.onTextEditorAreaClick.apply(_this, arguments);
        };
        _this.onTextEditorAreaClickOutsideFunc = function () {
            return _this.onTextEditorAreaClickOutside.apply(_this, arguments);
        };
        _this.onTextEditorAreaDragStartFunc = function () {
            return _this.onTextEditorAreaDragStart.apply(_this, arguments);
        };
        _this.onTextEditorAreaDragMoveFunc = function () {
            return _this.onTextEditorAreaDragMove.apply(_this, arguments);
        };
        _this.onTextEditorAreaDragEndFunc = function () {
            return _this.onTextEditorAreaDragEnd.apply(_this, arguments);
        };
        _this.onChangeFocusFunc = function () {
            return _this.onChangeFocus.apply(_this, arguments);
        };

        var editableOverlays = props.editableOverlays,
            canvas = props.canvas;

        Object.keys(editableOverlays).forEach(function (oid) {
            return _this.onAddedOverlay(editableOverlays[oid], canvas);
        });

        _this.onFontLoadedListenerFunc = function (e) {
            var fontKey = e.detail;

            var _this$props = _this.props,
                editableOverlays = _this$props.editableOverlays,
                canvas = _this$props.canvas;

            Object.keys(editableOverlays).forEach(function (oid) {
                var defModel = _this.defModels[oid];
                var isFontKeyUsed = defModel.getUsedFontKeys().find(function (fk) {
                    return fk === fontKey;
                });
                if (isFontKeyUsed) {
                    _this.onUpdatedOverlay(editableOverlays[oid], canvas, true);
                }
            });
        };
        return _this;
    }

    _createClass(TextEditorLayer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('fontLoaded', this.onFontLoadedListenerFunc);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('fontLoaded', this.onFontLoadedListenerFunc);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var _overlaysDiff = (0, _OverlayUtils.overlaysDiff)(this.props.editableOverlays, nextProps.editableOverlays),
                addedOverlays = _overlaysDiff.addedOverlays,
                deletedOverlays = _overlaysDiff.deletedOverlays,
                updatedOverlays = _overlaysDiff.updatedOverlays;

            Object.keys(addedOverlays).forEach(function (oid) {
                return _this2.onAddedOverlay(addedOverlays[oid], nextProps.canvas);
            });
            Object.keys(updatedOverlays).forEach(function (oid) {
                return _this2.onUpdatedOverlay(updatedOverlays[oid], nextProps.canvas);
            });
            Object.keys(deletedOverlays).forEach(function (oid) {
                return _this2.onDeletedOverlay(deletedOverlays[oid]);
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var wasFocused = prevState.focusUID !== null;
            var shouldBeFocused = this.state.focusUID !== null;

            if (wasFocused && !shouldBeFocused) {
                this.props.setFocus(null, -1, -1, 0);
                $(this.textSanitizerInput).blur();
            } else if (!wasFocused && shouldBeFocused) {
                this.props.setFocus(this.state.focusUID, this.state.selectionStart, this.state.selectionEnd, this.textSanitizerInput.value.length);
                $(this.textSanitizerInput).focus();
                this.textSanitizerInput.setSelectionRange(this.state.selectionStart, this.state.selectionEnd);
            }
        }
    }, {
        key: 'onAddedOverlay',
        value: function onAddedOverlay(overlay, canvas) {
            var defModel = _DefModel.DefModelRegistry.getModelForOverlay(overlay.defId, overlay.id);
            // defModel.update(overlay.space, overlay.time, overlay.values, canvas);
            // defModel.seekToStatic();

            this.defModels[overlay.id] = defModel;
        }
    }, {
        key: 'onDeletedOverlay',
        value: function onDeletedOverlay(overlay) {
            delete this.defModels[overlay.id];

            if (this.state.focusUID !== null) {
                var _state$focusUID$split = this.state.focusUID.split('$-$'),
                    _state$focusUID$split2 = _slicedToArray(_state$focusUID$split, 3),
                    oid = _state$focusUID$split2[0],
                    prop = _state$focusUID$split2[1],
                    layerId = _state$focusUID$split2[2];

                if (oid === overlay.id) {
                    this.setState({
                        focusUID: null,
                        editorValue: '',
                        textAlign: '',
                        cursorRect: null,
                        selectionRects: null,
                        selectionStart: -1,
                        selectionEnd: -1,
                        isFontRTL: false
                    });
                }
            }
        }
    }, {
        key: 'onUpdatedOverlay',
        value: function onUpdatedOverlay(overlay, canvas) {
            var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.defModels[overlay.id].update(overlay.space, overlay.time, overlay.values, canvas, null, forceUpdate);
            // this.defModels[overlay.id].seekToStatic();
            var _state = this.state,
                focusUID = _state.focusUID,
                selectionStart = _state.selectionStart,
                selectionEnd = _state.selectionEnd;

            if (focusUID !== null) {
                this.setCursorPositionForSelection(selectionStart, selectionEnd);
            }
        }
    }, {
        key: 'onTextEditorAreaClick',
        value: function onTextEditorAreaClick(uid, e) {
            var _this3 = this;

            var _uid$split = uid.split('$-$'),
                _uid$split2 = _slicedToArray(_uid$split, 3),
                oid = _uid$split2[0],
                prop = _uid$split2[1],
                layerId = _uid$split2[2];

            var _e$nativeEvent$detail = e.nativeEvent.detail,
                detail = _e$nativeEvent$detail === undefined ? 1 : _e$nativeEvent$detail;

            detail = (detail - 1) % 3 + 1;

            var displayScale = this.props.displayScale;

            var defModel = this.defModels[oid];

            var transform = defModel.space.transform;

            var _getScaleFromTransfor = (0, _LayerUtils.getScaleFromTransformString)(transform),
                _getScaleFromTransfor2 = _slicedToArray(_getScaleFromTransfor, 2),
                scaleX = _getScaleFromTransfor2[0],
                scaleY = _getScaleFromTransfor2[1];

            var areaOffset = $(e.target).offset();

            var clickRelX = e.pageX - areaOffset.left;
            var clickRelY = e.pageY - areaOffset.top;

            clickRelX = clickRelX / scaleX / displayScale;
            clickRelY = clickRelY / scaleY / displayScale;

            var resolvedAttrs = defModel.getAttrsForLayer(layerId, true);

            var textLayerInfo = defModel.getInfoForLayer(layerId);

            var _textLayerInfo$getPos = textLayerInfo.getPositionForCoords(clickRelX, clickRelY),
                lineIndex = _textLayerInfo$getPos.lineIndex,
                charIndex = _textLayerInfo$getPos.charIndex,
                x = _textLayerInfo$getPos.x,
                y = _textLayerInfo$getPos.y,
                lineHeight = _textLayerInfo$getPos.lineHeight;

            var selectionStart = -1;
            var selectionEnd = -1;
            if (detail === 3) {
                // Select all
                selectionStart = 0;
                selectionEnd = resolvedAttrs.text.length;
            } else if (detail === 2) {
                var _textLayerInfo$getWor = textLayerInfo.getWordIndicesAtIndex(lineIndex, charIndex),
                    wordstart = _textLayerInfo$getWor.wordstart,
                    wordend = _textLayerInfo$getWor.wordend;

                selectionStart = wordstart;
                selectionEnd = wordend;
            } else {
                var textIndex = textLayerInfo.getTextIndexForCharPosition(lineIndex, charIndex);
                selectionStart = textIndex;
                selectionEnd = textIndex;
            }

            var cursorRect = this.getCursorRect({ x: x, y: y, lineHeight: lineHeight }, scaleX, scaleY);

            var selectionInfoList = textLayerInfo.getSelectionInfoForRange(selectionStart, selectionEnd);

            var selectionRects = selectionInfoList.map(function (si) {
                return _this3.getSelectionRect(si, scaleX, scaleY);
            });

            selectionRects = selectionRects.length !== 0 ? selectionRects : null;

            this.setState({
                focusUID: uid,
                editorValue: resolvedAttrs.text,
                cursorRect: cursorRect,
                textAlign: resolvedAttrs.align,
                selectionRects: selectionRects,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
                isFontRTL: textLayerInfo.isFontRTL()
            });

            var _textSanitizerInput = this.textSanitizerInput,
                currSelectionStart = _textSanitizerInput.selectionStart,
                currSelectionEnd = _textSanitizerInput.selectionEnd;

            this.textSanitizerInput.focus();

            if (selectionStart !== currSelectionStart || selectionEnd !== currSelectionEnd) {
                this.textSanitizerInput.setSelectionRange(selectionStart, selectionEnd);
            }
        }
    }, {
        key: 'onTextEditorAreaClickOutside',
        value: function onTextEditorAreaClickOutside(uid) {
            // if (this.state.focusUID === uid) {
            //     this.setState({ focusUID : null, editorValue : '', textAlign : '',
            //         cursorRect : null, selectionRects : null, selectionStart : -1, selectionEnd : -1 })
            //     this.textSanitizerInput.blur()
            // }
        }
    }, {
        key: 'onTextEditorAreaDragStart',
        value: function onTextEditorAreaDragStart(uid, clickRelX, clickRelY) {
            var _uid$split3 = uid.split('$-$'),
                _uid$split4 = _slicedToArray(_uid$split3, 3),
                oid = _uid$split4[0],
                prop = _uid$split4[1],
                layerId = _uid$split4[2];

            var displayScale = this.props.displayScale;

            var defModel = this.defModels[oid];

            var transform = defModel.space.transform;

            var _getScaleFromTransfor3 = (0, _LayerUtils.getScaleFromTransformString)(transform),
                _getScaleFromTransfor4 = _slicedToArray(_getScaleFromTransfor3, 2),
                scaleX = _getScaleFromTransfor4[0],
                scaleY = _getScaleFromTransfor4[1];

            var scaledClickRelX = clickRelX / scaleX / displayScale;
            var scaledClickRelY = clickRelY / scaleY / displayScale;

            var resolvedAttrs = defModel.getAttrsForLayer(layerId, true);

            var textLayerInfo = defModel.getInfoForLayer(layerId);

            var _textLayerInfo$getPos2 = textLayerInfo.getPositionForCoords(scaledClickRelX, scaledClickRelY),
                lineIndex = _textLayerInfo$getPos2.lineIndex,
                charIndex = _textLayerInfo$getPos2.charIndex,
                x = _textLayerInfo$getPos2.x,
                y = _textLayerInfo$getPos2.y,
                lineHeight = _textLayerInfo$getPos2.lineHeight;

            // console.log('dragstart lineIndex and charIndex', lineIndex, charIndex);

            var textIndex = textLayerInfo.getTextIndexForCharPosition(lineIndex, charIndex);

            // console.log('dragstart textIndex', textIndex);

            var cursorRect = this.getCursorRect({ x: x, y: y, lineHeight: lineHeight }, scaleX, scaleY);

            this.setState({
                focusUID: uid,
                editorValue: resolvedAttrs.text,
                cursorRect: cursorRect,
                textAlign: resolvedAttrs.align,
                selectionStart: textIndex,
                selectionEnd: textIndex,
                isFontRTL: textLayerInfo.isFontRTL()
            });

            var _textSanitizerInput2 = this.textSanitizerInput,
                selectionStart = _textSanitizerInput2.selectionStart,
                selectionEnd = _textSanitizerInput2.selectionEnd;

            this.textSanitizerInput.focus();
            if (selectionStart !== textIndex || selectionEnd !== textIndex) {
                this.textSanitizerInput.setSelectionRange(textIndex, textIndex);
            }

            this.localDragData = {
                dragUid: uid,
                startX: clickRelX,
                startY: clickRelY,
                startSelectionIndex: textIndex
            };
        }
    }, {
        key: 'onTextEditorAreaDragMove',
        value: function onTextEditorAreaDragMove(uid, deltaX, deltaY) {
            var _this4 = this;

            var _localDragData = this.localDragData,
                dragUid = _localDragData.dragUid,
                startX = _localDragData.startX,
                startY = _localDragData.startY,
                startSelectionIndex = _localDragData.startSelectionIndex;

            if (dragUid !== uid) {
                // Could do something else here
                return;
            }

            var _uid$split5 = uid.split('$-$'),
                _uid$split6 = _slicedToArray(_uid$split5, 3),
                oid = _uid$split6[0],
                prop = _uid$split6[1],
                layerId = _uid$split6[2];

            var displayScale = this.props.displayScale;

            var defModel = this.defModels[oid];

            var transform = defModel.space.transform;

            var _getScaleFromTransfor5 = (0, _LayerUtils.getScaleFromTransformString)(transform),
                _getScaleFromTransfor6 = _slicedToArray(_getScaleFromTransfor5, 2),
                scaleX = _getScaleFromTransfor6[0],
                scaleY = _getScaleFromTransfor6[1];

            var clickRelX = startX + deltaX;
            var clickRelY = startY + deltaY;

            clickRelX = clickRelX / scaleX / displayScale;
            clickRelY = clickRelY / scaleY / displayScale;

            var resolvedAttrs = defModel.getAttrsForLayer(layerId, true);

            var textLayerInfo = defModel.getInfoForLayer(layerId);

            var _textLayerInfo$getPos3 = textLayerInfo.getPositionForCoords(clickRelX, clickRelY),
                lineIndex = _textLayerInfo$getPos3.lineIndex,
                charIndex = _textLayerInfo$getPos3.charIndex;

            // console.log('dragmove lineIndex and charIndex', lineIndex, charIndex);

            var textIndex = textLayerInfo.getTextIndexForCharPosition(lineIndex, charIndex);

            // console.log('dragstart textIndex', textIndex);

            var selectionStart = Math.min(startSelectionIndex, textIndex);
            var selectionEnd = Math.max(startSelectionIndex, textIndex);

            var _textLayerInfo$getPos4 = textLayerInfo.getPositionForTextIndex(textIndex),
                x = _textLayerInfo$getPos4.x,
                y = _textLayerInfo$getPos4.y,
                lineHeight = _textLayerInfo$getPos4.lineHeight;

            var cursorRect = this.getCursorRect({ x: x, y: y, lineHeight: lineHeight }, scaleX, scaleY);

            var selectionInfoList = textLayerInfo.getSelectionInfoForRange(selectionStart, selectionEnd);

            var selectionRects = selectionInfoList.map(function (si) {
                return _this4.getSelectionRect(si, scaleX, scaleY);
            });

            selectionRects = selectionRects.length !== 0 ? selectionRects : null;

            this.setState({
                focusUID: uid,
                editorValue: resolvedAttrs.text,
                cursorRect: cursorRect,
                selectionRects: selectionRects,
                textAlign: resolvedAttrs.align,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
                isFontRTL: textLayerInfo.isFontRTL()
            });

            var _textSanitizerInput3 = this.textSanitizerInput,
                currSelectionStart = _textSanitizerInput3.selectionStart,
                currSelectionEnd = _textSanitizerInput3.selectionEnd;

            this.textSanitizerInput.focus();
            if (selectionStart !== currSelectionStart || selectionEnd !== currSelectionEnd) {
                this.textSanitizerInput.setSelectionRange(selectionStart, selectionEnd);
            }
        }
    }, {
        key: 'onTextEditorAreaDragEnd',
        value: function onTextEditorAreaDragEnd() {
            this.localDragData = { dragUid: null, startX: -1, startY: -1, startSelectionIndex: -1 };
        }
    }, {
        key: 'onChangeFocus',
        value: function onChangeFocus() {
            var focusUID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.focusUID;
            var _textSanitizerInput4 = this.textSanitizerInput,
                selectionStart = _textSanitizerInput4.selectionStart,
                selectionEnd = _textSanitizerInput4.selectionEnd,
                value = _textSanitizerInput4.value;

            this.props.setFocus(focusUID, selectionStart, selectionEnd, value.length);
        }
    }, {
        key: 'computeColorRange',
        value: function computeColorRange(textColor, currentText, newText) {
            var dmp = new DiffMatchPatch();
            var diffs = dmp.diff_main(currentText, newText);

            var colorRange = new _ColorRange2.default(textColor);

            var charCounter = 0;
            diffs.forEach(function (diff) {
                var _diff = _slicedToArray(diff, 2),
                    type = _diff[0],
                    value = _diff[1];

                for (var i = charCounter + value.length - 1; i >= charCounter; i--) {
                    if (type == -1) {
                        colorRange.removeAtIndex(i);
                    } else if (type == 1) {
                        colorRange.insertAtIndex(i);
                    }
                }
                charCounter += value.length;
            });
            return colorRange;
        }
    }, {
        key: 'onTextInputChange',
        value: function onTextInputChange(e) {
            var textSanitizer = e.target;

            var newText = (0, _GeneralUtils.replaceFourByteChar)(textSanitizer.value || '');

            var _props = this.props,
                editableOverlays = _props.editableOverlays,
                canvas = _props.canvas,
                changeOverlayValue = _props.changeOverlayValue,
                changeSubtitleValue = _props.changeSubtitleValue;
            var _state2 = this.state,
                focusUID = _state2.focusUID,
                selectionStart = _state2.selectionStart,
                selectionEnd = _state2.selectionEnd;

            if (focusUID !== null) {
                var _focusUID$split = focusUID.split('$-$'),
                    _focusUID$split2 = _slicedToArray(_focusUID$split, 3),
                    oid = _focusUID$split2[0],
                    prop = _focusUID$split2[1],
                    layerId = _focusUID$split2[2];

                var defModel = this.defModels[oid];

                var overlay = editableOverlays[oid];
                var currentText = overlay.values[prop];

                var _defModel$def$meta = defModel.def.meta,
                    textColors = _defModel$def$meta.textColors,
                    highlightColors = _defModel$def$meta.highlightColors;

                var updateValues = _defineProperty({}, prop, newText);

                var colorPropsToUpdate = [];

                if (textColors) {
                    colorPropsToUpdate.push({
                        prop: textColors[prop],
                        colorRange: new _ColorRange2.default(overlay.values[textColors[prop]])
                    });
                }
                if (highlightColors) {
                    var _highlightColors$prop = highlightColors[prop],
                        highlight = _highlightColors$prop.highlight,
                        highlightText = _highlightColors$prop.highlightText;

                    if (highlight) {
                        colorPropsToUpdate.push({
                            prop: highlight,
                            colorRange: new _HighlightColorRange2.default(overlay.values[highlight])
                        });
                    }
                    if (highlightText) {
                        colorPropsToUpdate.push({
                            prop: highlightText,
                            colorRange: new _HighlightColorRange2.default(overlay.values[highlightText])
                        });
                    }
                }

                if (colorPropsToUpdate.length > 0) {
                    var dmp = new DiffMatchPatch();
                    var diffs = dmp.diff_main(currentText, newText);

                    var charCounter = 0;

                    diffs.forEach(function (diff) {
                        var _diff2 = _slicedToArray(diff, 2),
                            type = _diff2[0],
                            value = _diff2[1];

                        var _loop = function _loop(i) {
                            if (type == -1) {
                                colorPropsToUpdate.forEach(function (_ref) {
                                    var prop = _ref.prop,
                                        colorRange = _ref.colorRange;

                                    colorRange.removeAtIndex(i);
                                });
                            } else if (type == 1) {
                                colorPropsToUpdate.forEach(function (_ref2) {
                                    var prop = _ref2.prop,
                                        colorRange = _ref2.colorRange;

                                    colorRange.insertAtIndex(i);
                                });
                            }
                        };

                        for (var i = charCounter + value.length - 1; i >= charCounter; i--) {
                            _loop(i);
                        }

                        if (type != -1) {
                            charCounter += value.length;
                        }
                    });

                    colorPropsToUpdate.forEach(function (_ref3) {
                        var prop = _ref3.prop,
                            colorRange = _ref3.colorRange;

                        updateValues[prop] = colorRange.toString();
                    });
                }

                var newOverlay = (0, _deepmerge2.default)(overlay, {
                    values: updateValues
                });

                // defModel.update(newOverlay.space, newOverlay.time, newOverlay.values, canvas);

                if (newOverlay.isSubtitle) {
                    changeSubtitleValue(newOverlay, defModel);
                } else {
                    changeOverlayValue(newOverlay);
                }

                this.setState({ editorValue: newText });

                var _selectionStart = textSanitizer.selectionStart,
                    _selectionEnd = textSanitizer.selectionEnd;

                this.setCursorPositionForSelection(_selectionStart, _selectionEnd);
            }
        }
    }, {
        key: 'onTextInputKeyUp',
        value: function onTextInputKeyUp(e) {
            var _textSanitizerInput5 = this.textSanitizerInput,
                selectionStart = _textSanitizerInput5.selectionStart,
                selectionEnd = _textSanitizerInput5.selectionEnd;

            this.onChangeFocus();

            this.setCursorPositionForSelection(selectionStart, selectionEnd);
        }
    }, {
        key: 'onTextInputBlur',
        value: function onTextInputBlur(e) {
            if (this.state.focusUID !== null) {
                this.setState({
                    focusUID: null,
                    editorValue: '',
                    textAlign: '',
                    cursorRect: null,
                    selectionRects: null,
                    selectionStart: -1,
                    selectionEnd: -1
                });
            }
        }
    }, {
        key: 'getCursorRect',
        value: function getCursorRect(_ref4, scaleX, scaleY) {
            var x = _ref4.x,
                y = _ref4.y,
                lineHeight = _ref4.lineHeight;

            return {
                x: (x - 1) * scaleX,
                y: (y - 4) * scaleY,
                width: 2 * scaleX,
                height: (lineHeight + 8) * scaleY
            };
        }
    }, {
        key: 'getSelectionRect',
        value: function getSelectionRect(_ref5, scaleX, scaleY) {
            var x = _ref5.x,
                y = _ref5.y,
                lineHeight = _ref5.lineHeight,
                lineWidth = _ref5.lineWidth;

            return {
                x: (x - 1) * scaleX,
                y: (y - 4) * scaleY,
                width: (lineWidth + 2) * scaleX,
                height: (lineHeight + 8) * scaleY
            };
        }
    }, {
        key: 'setCursorPositionForSelection',
        value: function setCursorPositionForSelection(selectionStart, selectionEnd) {
            var _this5 = this;

            var focusUID = this.state.focusUID;

            if (focusUID !== null) {
                var _focusUID$split3 = focusUID.split('$-$'),
                    _focusUID$split4 = _slicedToArray(_focusUID$split3, 3),
                    oid = _focusUID$split4[0],
                    prop = _focusUID$split4[1],
                    layerId = _focusUID$split4[2];

                var defModel = this.defModels[oid];

                var transform = defModel.space.transform;

                var _getScaleFromTransfor7 = (0, _LayerUtils.getScaleFromTransformString)(transform),
                    _getScaleFromTransfor8 = _slicedToArray(_getScaleFromTransfor7, 2),
                    scaleX = _getScaleFromTransfor8[0],
                    scaleY = _getScaleFromTransfor8[1];

                var textLayerInfo = defModel.getInfoForLayer(layerId);

                var _textLayerInfo$getPos5 = textLayerInfo.getPositionForTextIndex(selectionStart),
                    x = _textLayerInfo$getPos5.x,
                    y = _textLayerInfo$getPos5.y,
                    lineHeight = _textLayerInfo$getPos5.lineHeight;

                var cursorRect = this.getCursorRect({ x: x, y: y, lineHeight: lineHeight }, scaleX, scaleY);

                var selectionInfoList = textLayerInfo.getSelectionInfoForRange(selectionStart, selectionEnd);

                var selectionRects = selectionInfoList.map(function (si) {
                    return _this5.getSelectionRect(si, scaleX, scaleY);
                });

                selectionRects = selectionRects.length !== 0 ? selectionRects : null;

                this.setState({ cursorRect: cursorRect, selectionRects: selectionRects, selectionStart: selectionStart, selectionEnd: selectionEnd });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var _props2 = this.props,
                displayScale = _props2.displayScale,
                isPlaying = _props2.isPlaying,
                editableOverlays = _props2.editableOverlays;
            var _state3 = this.state,
                focusUID = _state3.focusUID,
                editorValue = _state3.editorValue,
                textAlign = _state3.textAlign,
                cursorRect = _state3.cursorRect,
                selectionRects = _state3.selectionRects,
                isFontRTL = _state3.isFontRTL;

            var textEditorNodes = [];

            // For all editable overlays we know
            Object.keys(editableOverlays).forEach(function (oid) {
                // get the def model
                var defModel = _this6.defModels[oid];

                // Get the scale of the overlay
                var _defModel$space = defModel.space,
                    x = _defModel$space.x,
                    y = _defModel$space.y,
                    transform = _defModel$space.transform,
                    _defModel$space$rotat = _defModel$space.rotateDeg,
                    rotateDeg = _defModel$space$rotat === undefined ? 0 : _defModel$space$rotat;

                var _getScaleFromTransfor9 = (0, _LayerUtils.getScaleFromTransformString)(transform),
                    _getScaleFromTransfor10 = _slicedToArray(_getScaleFromTransfor9, 2),
                    scaleX = _getScaleFromTransfor10[0],
                    scaleY = _getScaleFromTransfor10[1];

                var textEditors = defModel.def.meta.textEditors;

                // For all text editors described for the overlay, we need to create an editor area

                Object.keys(textEditors).forEach(function (prop) {
                    var layerId = textEditors[prop];

                    var resolvedAttrs = defModel.getAttrsForLayer(layerId, true);

                    // This will contain all details about how to position all chars and lines in the text
                    // const textLayerInfo = defModel.getInfoForLayer(layerId)

                    var lx = resolvedAttrs.x,
                        ly = resolvedAttrs.y,
                        lw = resolvedAttrs.maxWidth,
                        lh = resolvedAttrs.height,
                        fill = resolvedAttrs.fill,
                        alpha = resolvedAttrs.alpha;

                    var _ref6 = _this6.textSanitizerInput || {},
                        _ref6$selectionStart = _ref6.selectionStart,
                        selectionStart = _ref6$selectionStart === undefined ? 0 : _ref6$selectionStart;

                    // This is the box where the text will display. This is our hit area


                    var rect = {
                        x: x + lx * scaleX,
                        y: y + ly * scaleY,
                        width: lw * scaleX,
                        height: lh * scaleY,
                        rotateDeg: rotateDeg
                    };

                    var uid = oid + '$-$' + prop + '$-$' + layerId;

                    // Is this the editor currently in focus?
                    var isFocused = focusUID === uid;

                    var currentCursorRect = null;
                    var currentSelectionRects = null;

                    if (isFocused) {
                        currentCursorRect = cursorRect;
                        currentSelectionRects = selectionRects;
                    }

                    var colorRange = new _ColorRange2.default(fill);
                    var cursorFill = colorRange.getColorForIndex(Math.max(selectionStart - 1, 0));

                    var cursorAlpha = 0.4 + alpha * 0.6;
                    var cursorColor = (0, _color2.default)(cursorFill).alpha(cursorAlpha).rgb().string();

                    textEditorNodes.push(_react2.default.createElement(_TextEditorArea2.default, {
                        key: uid,
                        uid: uid,
                        displayScale: displayScale,
                        rect: rect,
                        isFocused: isFocused,
                        cursorRect: currentCursorRect,
                        cursorColor: cursorColor,
                        selectionRects: currentSelectionRects,
                        onClick: _this6.onTextEditorAreaClickFunc,
                        onChangeFocus: _this6.onChangeFocusFunc,
                        onClickOutside: _this6.onTextEditorAreaClickOutsideFunc,
                        onDragStart: _this6.onTextEditorAreaDragStartFunc,
                        onDragMove: _this6.onTextEditorAreaDragMoveFunc,
                        onDragEnd: _this6.onTextEditorAreaDragEndFunc
                    }));
                });
            });

            var onChange = function onChange(e) {
                return _this6.onTextInputChange(e);
            };

            var onKeyUp = function onKeyUp(e) {
                return _this6.onTextInputKeyUp(e);
            };

            // const onBlur = e => this.onTextInputBlur(e)
            var onBlur = function onBlur(e) {};
            var textSanitizerStyles = {
                textAlign: textAlign,
                opacity: 0,
                pointerEvents: 'none'
            };

            if (isFontRTL) {
                textSanitizerStyles.direction = 'rtl';
                textSanitizerStyles.unicodeBidi = 'bidi-override';
            }

            var rootStyles = {
                visibility: isPlaying ? 'hidden' : 'visible'
            };
            return _react2.default.createElement(_hooks.PreventClipSelectCloseDiv, { className: 'fill-parent-size', style: rootStyles }, textEditorNodes, _react2.default.createElement('textarea', {
                className: 'textedit-sanitizer',
                style: textSanitizerStyles,
                value: editorValue,
                ref: function ref(c) {
                    return _this6.textSanitizerInput = c;
                },
                spellCheck: 'false',
                onChange: onChange,
                onKeyUp: onKeyUp,
                onBlur: onBlur
            }));
        }
    }]);

    return TextEditorLayer;
}(_react.PureComponent);

TextEditorLayer.propTypes = {
    displayScale: _propTypes2.default.number.isRequired,
    isPlaying: _propTypes2.default.bool.isRequired,
    editableOverlays: _propTypes2.default.object.isRequired,
    canvas: _propTypes2.default.object.isRequired,
    changeOverlayValue: _propTypes2.default.func.isRequired,
    changeSubtitleValue: _propTypes2.default.func,
    subtitlePosition: _propTypes2.default.string,
    setFocus: _propTypes2.default.func.isRequired
};
function TextEditorLayerWrapper(props) {
    return _react2.default.createElement(_CommonRenderGuards.ReduxUpdateGuard, {
        shouldUpdate: function shouldUpdate(state) {
            var _state$operationGuard = state.operationGuards;
            _state$operationGuard = _state$operationGuard === undefined ? {} : _state$operationGuard;
            var _state$operationGuard2 = _state$operationGuard.disableOverlayUpdate,
                disableOverlayUpdate = _state$operationGuard2 === undefined ? false : _state$operationGuard2;

            return !disableOverlayUpdate;
        }
    }, function () {
        return _react2.default.createElement(TextEditorLayer, props);
    });
}

},{"../../common/utils/ColorRange":71,"../../common/utils/GeneralUtils":77,"../../common/utils/HighlightColorRange":78,"../../common/utils/renderer/DefModel":119,"../../common/utils/renderer/LayerUtils":121,"../utils/OverlayUtils":231,"./TextEditorArea.react":190,"./timelineeditor/hooks":196,"./utility/memoRules/CommonRenderGuards.react":199,"color":418,"deepmerge":549,"diff-match-patch":553,"prop-types":896,"react":1107}],192:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClickDragMixin = require('../mixins/ClickDragMixin.react');

var _ClickDragMixin2 = _interopRequireDefault(_ClickDragMixin);

var _playerActions = require('../actions/playerActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var VideoInteractiveLayerInner = function (_PureComponent) {
    _inherits(VideoInteractiveLayerInner, _PureComponent);

    function VideoInteractiveLayerInner() {
        _classCallCheck(this, VideoInteractiveLayerInner);

        return _possibleConstructorReturn(this, (VideoInteractiveLayerInner.__proto__ || Object.getPrototypeOf(VideoInteractiveLayerInner)).apply(this, arguments));
    }

    _createClass(VideoInteractiveLayerInner, [{
        key: 'onDragStart',
        value: function onDragStart(e) {
            var pageX = e.pageX,
                pageY = e.pageY;

            var _pageToCanvasCoords = this.pageToCanvasCoords(pageX, pageY),
                l = _pageToCanvasCoords.x,
                t = _pageToCanvasCoords.y;

            this.dragStartPos = { startX: pageX, startY: pageY, l: l, t: t };
        }
    }, {
        key: 'onDragMove',
        value: function onDragMove(deltaX, deltaY) {
            var _dragStartPos = this.dragStartPos,
                l = _dragStartPos.l,
                t = _dragStartPos.t,
                startX = _dragStartPos.startX,
                startY = _dragStartPos.startY;

            var _pageToCanvasCoords2 = this.pageToCanvasCoords(startX + deltaX, startY + deltaY),
                r = _pageToCanvasCoords2.x,
                b = _pageToCanvasCoords2.y;

            if (r < l) {
                var _ref = [l, r];
                r = _ref[0];
                l = _ref[1];
            }
            if (b < t) {
                var _ref2 = [t, b];
                b = _ref2[0];
                t = _ref2[1];
            }

            this.props.onSetSelectingRect({
                x: l,
                y: t,
                width: r - l,
                height: b - t
            });
        }
    }, {
        key: 'onDragEnd',
        value: function onDragEnd() {
            this.props.onEndSelectingRect();
        }
    }, {
        key: 'onPureClick',
        value: function onPureClick() {
            // Temp solution: Need a better fix for this
            // Delaying the event to fire all document click listeners
            // before the video is selected.
            setTimeout(this.props.onVideoClick, 0);
        }
    }, {
        key: 'pageToCanvasCoords',
        value: function pageToCanvasCoords(x, y) {
            var _$$offset = $(this.rootEl).offset(),
                left = _$$offset.left,
                top = _$$offset.top;

            var displayScale = this.props.displayScale;

            return {
                x: (x - left) / displayScale,
                y: (y - top) / displayScale
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var dragCallbacks = this.props.dragCallbacks;

            return _react2.default.createElement('div', {
                className: 'video-interactive-layer fill-parent-size',
                ref: function ref(c) {
                    _this2.rootEl = c;
                    dragCallbacks.refTrack(c);
                },
                onMouseDown: dragCallbacks.onTrackMouseDown,
                onMouseUp: dragCallbacks.onTrackMouseUp
            });
        }
    }]);

    return VideoInteractiveLayerInner;
}(_react.PureComponent);

VideoInteractiveLayerInner.propTypes = {
    displayScale: _propTypes2.default.number.isRequired,
    onVideoClick: _propTypes2.default.func.isRequired,
    dragCallbacks: _propTypes2.default.object.isRequired,
    onSetSelectingRect: _propTypes2.default.func.isRequired,
    onEndSelectingRect: _propTypes2.default.func.isRequired
};

var VideoInteractiveLayer = (0, _ClickDragMixin2.default)(VideoInteractiveLayerInner, {
    preventDefaultOnMouseDown: true
});

exports.default = VideoInteractiveLayer;

},{"../actions/playerActions":166,"../mixins/ClickDragMixin.react":211,"prop-types":896,"react":1107}],193:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlCommandStream = require('../utils/ControlCommandStream');

var _ControlCommandStream2 = _interopRequireDefault(_ControlCommandStream);

var _CorePlayerController = require('../../common/utils/CorePlayerController');

var _CorePlayerController2 = _interopRequireDefault(_CorePlayerController);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var VideoPreview = function (_Component) {
    _inherits(VideoPreview, _Component);

    /**
     * Creates an instance of VideoPreview.
     * @param {{
     *      corePlayer : CorePlayerController
     * }} props
     * @memberof VideoPreview
     */
    function VideoPreview(props) {
        _classCallCheck(this, VideoPreview);

        var _this = _possibleConstructorReturn(this, (VideoPreview.__proto__ || Object.getPrototypeOf(VideoPreview)).call(this, props));

        _this._videoCommandCallback = _this.onVideoCommand.bind(_this);
        _this._reelCommandCallback = _this.onReelCommand.bind(_this);
        _this._reelAudioCommandCallback = _this.onReelAudioCommand.bind(_this);
        return _this;
    }

    _createClass(VideoPreview, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            // No updates whatsoever. Sacred and painfully-built and stateful DOM at work here.
            // TODO -- verify what's so sacred about it and rip it out. We are having multiple remounts here for some reason
            return false;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // Subscribe to video commands
            _ControlCommandStream2.default.subscribeToCommand('VIDEO_PLAY', this._videoCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('VIDEO_PAUSE', this._videoCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('VIDEO_SEEK', this._videoCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('VIDEO_SET_VOLUME', this._videoCommandCallback);

            // Subscribe to reel related commands
            _ControlCommandStream2.default.subscribeToCommand('REEL_ADD_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_REMOVE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_REPLACE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_SPLIT_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_MOVE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_TRIM_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_SET_ANIMTYPE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_SET_CLIP_TRANSITION', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_REMOVE_TRANSITIONS', this._reelCommandCallback);

            _ControlCommandStream2.default.subscribeToCommand('REEL_CHANGE_FRAME', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_CHANGE_FORMAT', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_CHANGE_FRAME_COLOR', this._reelCommandCallback);

            _ControlCommandStream2.default.subscribeToCommand('REEL_VIDEO_VOLUME_SET', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_VIDEO_SET_SPEED', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_VOLUME_MODE_SET', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_UPDATE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_VIDEO_DURATION_LIMIT_SET', this._reelCommandCallback);

            _ControlCommandStream2.default.subscribeToCommand('REEL_SET_CROPPING', this._reelCommandCallback);

            _ControlCommandStream2.default.subscribeToCommand('REEL_UPDATE_CLIP_TIMEDATA', this._reelCommandCallback);

            // Subscribe to reel audio commands
            _ControlCommandStream2.default.subscribeToCommand('REEL_AUDIO_SET_CLIP', this._reelAudioCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_AUDIO_CLEAR_CLIP', this._reelAudioCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('REEL_UPDATE_AUDIO_CLIP', this._reelAudioCommandCallback);
            _ControlCommandStream2.default.subscribeToCommand('AUDIO_SWITCH_LOOPING', this._reelAudioCommandCallback);

            // Setup of player controller and connect to it
            var videoNodeContainerEl = $(this._videoNodeContainer).find('.video-node-container').get(0);

            var _props = this.props,
                corePlayer = _props.corePlayer,
                initialReel = _props.initialReel,
                customFormat = _props.customFormat;

            corePlayer.setWaitModeListener(function () {
                return _this2.props.onWaitModeChange(corePlayer.waitMode);
            });
            corePlayer.setPlaybackStateListener(function () {
                return _this2.props.onPlaybackStateChange(corePlayer.playbackState);
            });
            corePlayer.setCurrentTimeListener(function (time) {
                return _this2.props.onCurrentTimeChange(time);
            });
            corePlayer.setDurationListener(function (duration) {
                return _this2.props.onDurationChange(duration);
            });

            corePlayer.setClipChangeListener(function (data) {
                var _data$currentClipIds = data.currentClipIds,
                    currentClipIds = _data$currentClipIds === undefined ? [] : _data$currentClipIds;

                if (currentClipIds.length !== 0) _this2.props.onChangeClip(currentClipIds[0]);
            });

            corePlayer.attachVideo(videoNodeContainerEl, // The container div
            initialReel, // list of initial clip data
            customFormat // if custom format is used
            );
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            _ControlCommandStream2.default.unsubscribeFromCommand('VIDEO_PLAY', this._videoCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('VIDEO_PAUSE', this._videoCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('VIDEO_SEEK', this._videoCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('VIDEO_SET_VOLUME', this._videoCommandCallback);

            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_ADD_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_REMOVE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_REPLACE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_SPLIT_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_MOVE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_TRIM_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_SET_ANIMTYPE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_SET_CLIP_TRANSITION', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_REMOVE_TRANSITIONS', this._reelCommandCallback);

            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_CHANGE_FRAME', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_CHANGE_FORMAT', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_CHANGE_FRAME_COLOR', this._reelCommandCallback);

            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_VIDEO_VOLUME_SET', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_VIDEO_SET_SPEED', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_VOLUME_MODE_SET', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_UPDATE_CLIP', this._reelCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_VIDEO_DURATION_LIMIT_SET', this._reelCommandCallback);

            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_UPDATE_CLIP_TIMEDATA', this._reelCommandCallback);

            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_SET_CROPPING', this._reelCommandCallback);

            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_AUDIO_SET_CLIP', this._reelAudioCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_AUDIO_CLEAR_CLIP', this._reelAudioCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('REEL_UPDATE_AUDIO_CLIP', this._reelAudioCommandCallback);
            _ControlCommandStream2.default.unsubscribeFromCommand('AUDIO_SWITCH_LOOPING', this._reelAudioCommandCallback);

            var corePlayer = this.props.corePlayer;

            corePlayer.clearWaitModeListener();
            corePlayer.clearPlaybackStateListener();
            corePlayer.clearCurrentTimeListener();
            corePlayer.clearDurationListener();
            corePlayer.clearClipChangeListener(); // new
            corePlayer.detachVideo();
        }
    }, {
        key: 'onVideoCommand',
        value: function onVideoCommand(commandType, args) {
            var corePlayer = this.props.corePlayer;

            if (commandType == 'VIDEO_PLAY') {

                corePlayer.doPlay();
            } else if (commandType == 'VIDEO_PAUSE') {

                corePlayer.doPause();
            } else if (commandType == 'VIDEO_SEEK') {
                var time = args.time;

                corePlayer.doSeek(time);
            } else if (commandType == 'VIDEO_SET_VOLUME') {
                var volume = args.volume;

                corePlayer.doSetVolume(volume);
                this.props.onVolumeChange(volume);
            }
        }
    }, {
        key: 'onReelCommand',
        value: function onReelCommand(commandType, args) {
            var corePlayer = this.props.corePlayer;

            if (commandType === 'REEL_ADD_CLIP') {

                // insertTime not always available and technically not required either
                var clip = args.clip,
                    insertTime = args.insertTime;

                corePlayer.doReelAdd(clip, insertTime);
            } else if (commandType === 'REEL_REMOVE_CLIP') {
                var _clip = args.clip;

                corePlayer.doReelRemove(_clip);
            } else if (commandType === 'REEL_REPLACE_CLIP') {
                var deletingClips = args.deletingClips,
                    replacingClips = args.replacingClips;

                corePlayer.doReelRemove(deletingClips);
                corePlayer.doReelAdd(replacingClips);
            } else if (commandType === 'REEL_SPLIT_CLIP') {
                var bsClipId = args.bsClipId,
                    asClip = args.asClip,
                    asClipDuplicate = args.asClipDuplicate,
                    currentTime = args.currentTime;

                corePlayer.doReelSplit(bsClipId, asClip, asClipDuplicate, currentTime);
            } else if (commandType === 'REEL_MOVE_CLIP') {
                var clipId = args.clipId,
                    newIndex = args.newIndex;

                corePlayer.doReelMove(clipId, newIndex);
            } else if (commandType === 'REEL_TRIM_CLIP') {
                var _clipId = args.clipId,
                    newClipStart = args.newClipStart,
                    newClipDuration = args.newClipDuration,
                    newTime = args.newTime;

                corePlayer.doReelTrim(_clipId, newClipStart, newClipDuration, newTime);
            } else if (commandType === 'REEL_CHANGE_FRAME') {
                var canvas = args.canvas,
                    frameType = args.frameType,
                    customFormat = args.customFormat;

                corePlayer.doReelChangeFrame(canvas, frameType, customFormat);
            } else if (commandType === 'REEL_CHANGE_FRAME_COLOR') {
                var frameColor = args.frameColor;

                corePlayer.doReelChangeFrameColor(frameColor);
            } else if (commandType === 'REEL_VIDEO_VOLUME_SET') {
                var volume = args.volume;

                corePlayer.doSetVolume(volume);
            } else if (commandType === 'REEL_VIDEO_SET_SPEED') {
                var _clipId2 = args.clipId,
                    speed = args.speed;

                corePlayer.doSetSpeed(_clipId2, speed);
            } else if (commandType === 'REEL_VOLUME_MODE_SET') {
                var volumeMode = args.volumeMode;

                corePlayer.doSetVolumeMode(volumeMode);
            } else if (commandType === 'REEL_VIDEO_DURATION_LIMIT_SET') {
                var duration = args.duration;

                corePlayer.doSetVideoDurationLimit(duration);
            } else if (commandType === 'REEL_UPDATE_CLIP') {
                var _clip2 = args.clip;

                corePlayer.doUpdateClip(_clip2);
            } else if (commandType === 'REEL_SET_ANIMTYPE_CLIP') {
                var _clipId3 = args.clipId,
                    animType = args.animType;

                corePlayer.doSetClipAnimType(_clipId3, animType);
            } else if (commandType === 'REEL_SET_CLIP_TRANSITION') {
                var transitionType = args.transitionType,
                    leftClipId = args.leftClipId,
                    rightClipId = args.rightClipId;

                corePlayer.doSetClipTransitionType(transitionType, leftClipId, rightClipId);
            } else if (commandType === 'REEL_REMOVE_TRANSITIONS') {
                var _clipId4 = args.clipId;

                corePlayer.doRemoveTransitions(_clipId4);
            } else if (commandType === 'REEL_SET_CROPPING') {
                var isCropping = args.isCropping,
                    _clipId5 = args.clipId;

                corePlayer.doSetCropping(isCropping, _clipId5);
            } else if (commandType === 'REEL_UPDATE_CLIP_TIMEDATA') {
                var _clip3 = args.clip;

                corePlayer.doClipTimeDataUpdate(_clip3);
            }
        }
    }, {
        key: 'onReelAudioCommand',
        value: function onReelAudioCommand(commandType, args) {
            var corePlayer = this.props.corePlayer;

            if (commandType === 'REEL_AUDIO_SET_CLIP') {
                var audioClip = args.audioClip;

                corePlayer.doSetAudio(audioClip);
            } else if (commandType === 'REEL_AUDIO_CLEAR_CLIP') {
                corePlayer.doClearAudio();
            } else if (commandType === 'REEL_UPDATE_AUDIO_CLIP') {
                var _audioClip = args.audioClip;

                corePlayer.doUpdateAudio(_audioClip);
            } else if (commandType === 'AUDIO_SWITCH_LOOPING') {
                var _audioClip2 = args.audioClip;

                corePlayer.doUpdateAudio(_audioClip2);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var videoNodeContainerHTML = "<div class='video-node-container fill-parent-size prevent-clip-select-close'></div>";

            // Only called the first time
            return _react2.default.createElement('div', { ref: function ref(el) {
                    _this3._videoNodeContainer = el;
                },
                className: 'fill-parent-size',
                dangerouslySetInnerHTML: { __html: videoNodeContainerHTML }
            });
        }
    }]);

    return VideoPreview;
}(_react.Component);

VideoPreview.propTypes = {
    corePlayer: _propTypes2.default.object.isRequired,
    initialReel: _propTypes2.default.object.isRequired,
    customFormat: _propTypes2.default.object,
    onWaitModeChange: _propTypes2.default.func.isRequired,
    onPlaybackStateChange: _propTypes2.default.func.isRequired,
    onCurrentTimeChange: _propTypes2.default.func.isRequired,
    onDurationChange: _propTypes2.default.func.isRequired,
    onVolumeChange: _propTypes2.default.func.isRequired,
    onChangeClip: _propTypes2.default.func.isRequired
};
VideoPreview.defaultProps = {
    onChangeClip: function onChangeClip() {} };
exports.default = VideoPreview;

},{"../../common/utils/CorePlayerController":73,"../utils/ControlCommandStream":227,"prop-types":896,"react":1107}],194:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dismissFirstClipTimelineNudge = exports.showFirstClipTimelineNudge = exports.dismissEmptyProjectStockMediaNudge = exports.showEmptyProjectStockMediaNudge = exports.dismissShowMyMediaPanel = exports.showMyMediaPanelBlueBanner = exports.dismissPropertiesPanelBlueBanner = exports.showPropertiesPanelBlueBanner = exports.dismissAddAudioTrackInstruction = exports.showAddAudioTrackInstruction = exports.NudgeIds = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NudgeCard = require('../../../common/components/notificationSystem/NudgeCard.react');

var _NudgeBanner = require('../../../common/components/notificationSystem/NudgeBanner.react');

var _reactRedux = require('react-redux');

var _modeActions = require('../../actions/modeActions');

var _logActions = require('../../actions/logActions');

var _General = require('../../constants/General');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var DEBUG = false;

var NudgeIds = exports.NudgeIds = (0, _keymirror2.default)({
    ADD_AUDIO_TRACK: null,

    MY_MEDIA_PANEL_MESSAGE: null,

    PROPERTIES_PANEL_MESSAGE: null,
    EMPTY_PROJECT_STOCK_MEDIA: null,
    FIRST_CLIP_TIMELINE_MESSAGE: null
});

var onCloseNudge = function onCloseNudge(nudgeId, name, action) {
    (0, _logActions.instructionNudgeActions)(null, { name: name, action: action });
    (0, _NudgeCard.dismissNudge)(nudgeId);
};

var showAddAudioTrackInstruction = exports.showAddAudioTrackInstruction = function showAddAudioTrackInstruction(onClose) {
    return (0, _NudgeCard.showNudgeTooltip)(_react2.default.createElement('div', { style: { width: '300px', padding: '0px 10px' } }, _react2.default.createElement('h4', { style: { margin: '20px 0px 10px 0px' } }, _react2.default.createElement('span', { style: { padding: 5 } }, '\uD83C\uDFA4'), 'Make some noise!'), _react2.default.createElement('p', null, 'Add an audio track to this movie. You can choose from our collection of free tracks or upload your own.')), {
        onClose: onClose,
        persist: true,
        id: NudgeIds.ADD_AUDIO_TRACK,
        place: 'top'
    });
};

var dismissAddAudioTrackInstruction = exports.dismissAddAudioTrackInstruction = function dismissAddAudioTrackInstruction() {
    return (0, _NudgeCard.dismissNudge)(NudgeIds.ADD_AUDIO_TRACK);
};

var showPropertiesPanelBlueBanner = exports.showPropertiesPanelBlueBanner = function showPropertiesPanelBlueBanner() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Find more ways to modify this Media Clip Below';
    var onClose = arguments[1];
    return (0, _NudgeBanner.showNudgeBanner)(_react2.default.createElement('div', {
        style: {
            fontSize: '9.0pt',
            textAlign: 'left',
            width: '100%',
            height: '40px',
            padding: '12px 0px 0px 5px'
        }
    }, message), {
        onClose: onClose,
        duration: 8000,
        direction: 'vertical',
        id: NudgeIds.PROPERTIES_PANEL_MESSAGE
    });
};

var dismissPropertiesPanelBlueBanner = exports.dismissPropertiesPanelBlueBanner = function dismissPropertiesPanelBlueBanner() {
    return (0, _NudgeBanner.dismissNudgeBanner)(NudgeIds.PROPERTIES_PANEL_MESSAGE);
};

var showMyMediaPanelBlueBanner = exports.showMyMediaPanelBlueBanner = function showMyMediaPanelBlueBanner() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Replace media with photos and videos';
    var onClose = arguments[1];

    (0, _NudgeBanner.showNudgeBanner)(_react2.default.createElement('div', {
        style: {
            fontSize: '10.0pt',
            textAlign: 'left',
            width: '100%',
            height: '30px',
            padding: '6px 9px 0px 5px'
        }
    }, message), { onClose: onClose, duration: 5000, direction: 'vertical', id: NudgeIds.MY_MEDIA_PANEL_MESSAGE });
};

var dismissShowMyMediaPanel = exports.dismissShowMyMediaPanel = function dismissShowMyMediaPanel() {
    return (0, _NudgeBanner.dismissNudgeBanner)(NudgeIds.MY_MEDIA_PANEL_MESSAGE);
};

var showEmptyProjectStockMediaNudge = exports.showEmptyProjectStockMediaNudge = function showEmptyProjectStockMediaNudge(onClose, customPosition) {
    var nudgeId = NudgeIds.EMPTY_PROJECT_STOCK_MEDIA;
    var eventName = 'onboarding-stock-shelf-1';

    (0, _NudgeCard.showNudgeTooltip)(_react2.default.createElement('div', { className: 'nudge-component empty-project-stock-media' }, _react2.default.createElement('h4', null, 'Free stock media'), _react2.default.createElement('p', null, 'High-quality images and videos to add to your project. Search for topics like \u2018real-estate\u2019, \u2018fitness\u2019 etc.', ' '), _react2.default.createElement('div', { onClick: function onClick() {
            return onCloseNudge(nudgeId, eventName, 'Got it!');
        }, className: 'nudge-button' }, 'Okay')), {
        onClose: function onClose() {
            return onCloseNudge(nudgeId, eventName, 'cross-icon');
        },
        persist: true,
        id: nudgeId,
        place: 'right',
        customPosition: customPosition
    });
};

var dismissEmptyProjectStockMediaNudge = exports.dismissEmptyProjectStockMediaNudge = function dismissEmptyProjectStockMediaNudge() {
    return (0, _NudgeCard.dismissNudge)(NudgeIds.EMPTY_PROJECT_STOCK_MEDIA);
};

var showFirstClipTimelineNudge = exports.showFirstClipTimelineNudge = function showFirstClipTimelineNudge(onClose) {
    var customPosition = function customPosition(_ref) {
        var left = _ref.left,
            top = _ref.top;
        return {
            left: left,
            top: top + 10
        };
    };
    var eventName = 'onboarding-timeline-1';
    var nudgeId = NudgeIds.FIRST_CLIP_TIMELINE_MESSAGE;
    (0, _NudgeCard.showNudgeTooltip)(_react2.default.createElement(FirstClipTimelineNudgeComponent, { eventName: eventName, nudgeId: nudgeId }), {
        onClose: function onClose() {
            return onCloseNudge(nudgeId, eventName, 'cross-icon');
        },
        persist: true,
        id: nudgeId,
        place: 'top',
        customPosition: customPosition
    });
};

var dismissFirstClipTimelineNudge = exports.dismissFirstClipTimelineNudge = function dismissFirstClipTimelineNudge() {
    return (0, _NudgeCard.dismissNudge)(NudgeIds.FIRST_CLIP_TIMELINE_MESSAGE);
};

var FirstClipTimelineNudgeComponent = function FirstClipTimelineNudgeComponent(_ref2) {
    var eventName = _ref2.eventName,
        nudgeId = _ref2.nudgeId;

    var dispatch = (0, _reactRedux.useDispatch)();

    var onOpenTextAffect = function onOpenTextAffect() {
        dismissFirstClipTimelineNudge();
        (0, _logActions.instructionNudgeActions)(null, { name: eventName, action: 'text effects overlays' });
        dispatch((0, _modeActions.changeSidebarSection)('TEXT'), true);
    };

    var onOpenMusicShelf = function onOpenMusicShelf() {
        dismissFirstClipTimelineNudge();
        (0, _logActions.instructionNudgeActions)(null, { name: eventName, action: 'music' });
        dispatch((0, _modeActions.changeSidebarSection)('AUDIO'), true);
    };

    var onOpenElementsSection = function onOpenElementsSection() {
        dismissFirstClipTimelineNudge();
        (0, _logActions.instructionNudgeActions)(null, { name: eventName, action: 'elements' });
        dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.IMAGES.id), true);
    };

    return _react2.default.createElement('div', { className: 'nudge-component first-clip-timeline' }, _react2.default.createElement('h4', null, 'What\u2019s next?'), _react2.default.createElement('p', null, 'Add all the media you need to build your video. Add', ' ', _react2.default.createElement('span', { className: 'nudge-link nudge-text-overlays', onClick: onOpenTextAffect }, 'text effects'), ' ', ',', ' ', _react2.default.createElement('span', { className: 'nudge-link nudge-elements', onClick: onOpenElementsSection }, 'elements'), ', and', ' ', _react2.default.createElement('span', { className: 'nudge-link nudge-music-track', onClick: onOpenMusicShelf }, 'music'), ' ', 'to make your video stand out.'), _react2.default.createElement('div', { onClick: function onClick() {
            return onCloseNudge(nudgeId, eventName, 'Got It!');
        }, className: 'nudge-button' }, 'Okay'));
};

if (DEBUG) {
    window.showAddAudioTrackInstruction = showAddAudioTrackInstruction;
    window.dismissAddAudioTrackInstruction = dismissAddAudioTrackInstruction;
    window.showPropertiesPanelBlueBanner = showPropertiesPanelBlueBanner;
    window.dismissPropertiesPanelBlueBanner = dismissPropertiesPanelBlueBanner;
    window.showMyMediaPanelBlueBanner = showMyMediaPanelBlueBanner;
    window.dismissShowMyMediaPanel = dismissShowMyMediaPanel;
    window.showEmptyProjectStockMediaNudge = showEmptyProjectStockMediaNudge;
    window.showFirstClipTimelineNudge = showFirstClipTimelineNudge;
}

},{"../../../common/components/notificationSystem/NudgeBanner.react":26,"../../../common/components/notificationSystem/NudgeCard.react":27,"../../actions/logActions":160,"../../actions/modeActions":162,"../../constants/General":203,"keymirror":677,"react":1107,"react-redux":1079}],195:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUploadingProjectMedia = exports.UploadNotficationIds = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.UploadingNotificationCard = UploadingNotificationCard;
exports.UploadingNotification = UploadingNotification;
exports.UploadFailedNotification = UploadFailedNotification;
exports.dispatchUploadingNotification = dispatchUploadingNotification;
exports.dispatchUploadFailureNotification = dispatchUploadFailureNotification;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _NotificationCard = require('../../../common/components/notificationSystem/NotificationCard.react');

var _SVGIcon = require('../../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _modeActions = require('../../actions/modeActions');

var _General = require('../../constants/General');

var _projectMediaSelectors = require('../../selectors/projectMediaSelectors');

var _ProgressBar = require('../ProgressBar.react');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _LazyImageElem = require('../utility/LazyImageElem.react');

var _LazyImageElem2 = _interopRequireDefault(_LazyImageElem);

var _ModelDataUtils = require('../../../common/utils/ModelDataUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var UploadNotficationIds = exports.UploadNotficationIds = (0, _keymirror2.default)({
    POOR_MEDIA_PLAYBACK_SUPPORT: null
});

var getUploadingProjectMedia = exports.getUploadingProjectMedia = (0, _projectMediaSelectors.makeGetUploadingAndErrorProjectMedia)();

function UploadingNotificationCard(_ref) {
    var _ref$imageElement = _ref.imageElement,
        imageElement = _ref$imageElement === undefined ? null : _ref$imageElement,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? null : _ref$onClick,
        children = _ref.children;

    return _react2.default.createElement('div', { className: 'uploading-notification-container', onClick: onClick }, _react2.default.createElement('div', { className: 'image-container' }, imageElement), _react2.default.createElement('div', { className: 'content-container' }, children));
}

function UploadingNotification(_ref2) {
    var _ref2$closeNotificati = _ref2.closeNotification,
        closeNotification = _ref2$closeNotificati === undefined ? null : _ref2$closeNotificati,
        _ref2$clearOnComplete = _ref2.clearOnCompleteTimeout,
        clearOnCompleteTimeout = _ref2$clearOnComplete === undefined ? Infinity : _ref2$clearOnComplete;

    var uploadList = (0, _reactRedux.useSelector)(function (state) {
        return getUploadingProjectMedia(state).filter(function (u) {
            return !u.isIndeterminate;
        });
    });
    // list that has received response from backend

    var initialUploadList = (0, _react.useRef)(uploadList.length);

    // Runs only when the component is initialised , if the upload list is empty , notfication is closed
    (0, _react.useEffect)(function () {
        // When there is no data which is in progress and response from server is not received
        if (initialUploadList.length === 0 && !!closeNotification) closeNotification();
    }, []);

    if (initialUploadList.length === 0) return null;

    var dispatch = (0, _reactRedux.useDispatch)();

    var openMyMediaShelf = function openMyMediaShelf() {
        if (closeNotification) closeNotification();
        dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.VIDEOS.id, true));
    };

    var uploadingList = uploadList.filter(function (u) {
        return !u.error && u.percent < 100;
    });
    var uploadedList = uploadList.filter(function (u) {
        return !u.error && u.percent === 100 && (0, _ModelDataUtils.getClientVideoUploadStatus)(u.uploadStatus) === 'PROCESSING';
    });

    var erroredList = uploadList.filter(function (u) {
        return u.error;
    });

    var totalFilesUploading = uploadingList.length;
    var totalFileUploaded = uploadedList.length;
    var totalErroredFile = erroredList.length;

    var _useState = (0, _react.useState)({
        totalFileUploaded: uploadedList, // will be used only for showing total uploads done till now
        totalFileUploading: uploadingList
        // will keep increasing until USER DISMISSES NOTIFICATION
    }),
        _useState2 = _slicedToArray(_useState, 2),
        uploadState = _useState2[0],
        setUploadState = _useState2[1];

    // Keeping internal state
    // Use only when all the files move from uploading to uploaded state


    (0, _react.useEffect)(function () {
        // if uploads are cleared off one by one then we may reach this point
        // so it's better to close this notification in such cases

        var unaccountedUploaded = (0, _lodash.differenceBy)(uploadedList, uploadState.totalFileUploaded, 'id');
        var newUploadedList = (0, _lodash.unionBy)(unaccountedUploaded, uploadState.totalFileUploaded, 'id');

        var unaccountedUploading = (0, _lodash.differenceBy)(uploadingList, uploadState.totalFileUploading, 'id');
        var newUploadingList = (0, _lodash.unionBy)(unaccountedUploading, uploadState.totalFileUploading, 'id');

        if (unaccountedUploaded.length !== 0) {
            setUploadState({
                totalFileUploaded: newUploadedList,
                totalFileUploading: newUploadingList
            });
        }

        if (uploadingList.length === 0) {
            // if there is nothing being uploaded right now , look into the past records
            // if the uploaded length is lesser than uploadingList , that means something was cleared off
            // from the uploading list

            if (newUploadedList.length < newUploadingList.length && newUploadedList.length === 0) {
                closeNotification();
            }
        }

        if (uploadingList.length === 0 && uploadedList.length === 0 && erroredList.length !== 0) {
            // error incoming
            closeNotification();
        }
    }, [totalFileUploaded, totalFilesUploading, totalErroredFile]);

    var text = 'Uploading ' + totalFilesUploading + '/' + (uploadState.totalFileUploaded.length + totalFilesUploading) + ' files...';

    var showProgress = true;

    var lastUpload = uploadList[0] || { thumbnail: null };

    if (totalFilesUploading === 1) {
        var upload = uploadingList[0];
        text = 'Uploading ' + upload.name;
    } else if (totalFilesUploading === 0) {
        if (uploadState.totalFileUploaded.length > 1) text = 'Uploaded ' + uploadState.totalFileUploaded.length + ' media files';else if (uploadState.totalFileUploaded.length === 1) text = 'Uploaded ' + uploadState.totalFileUploaded.length + ' media file';
        showProgress = false;
    }

    var totalProgress = uploadingList.reduce(function (acc, v) {
        return acc + v.percent;
    }, 0) / uploadList.length;

    var imageElement = showProgress ? _react2.default.createElement(_LazyImageElem2.default, { src: lastUpload.thumbnail, height: '100%', width: '100%' }) : _react2.default.createElement(_SVGIcon2.default, { height: '100%', width: '100%', iconId: 'upload-done-icon' });

    var clearNotificationRef = (0, _react.useRef)(null);

    (0, _react.useEffect)(function () {
        clearTimeout(clearNotificationRef.current);
        if (clearOnCompleteTimeout !== Infinity) {
            if (!showProgress) {
                clearNotificationRef.current = setTimeout(function () {
                    closeNotification();
                }, clearOnCompleteTimeout);
            }
        }
    }, [clearOnCompleteTimeout, showProgress]);

    return _react2.default.createElement(UploadingNotificationCard, { imageElement: imageElement }, _react2.default.createElement('div', { className: 'header' }, text), showProgress && _react2.default.createElement(_ProgressBar2.default, { isIndeterminate: false, progress: totalProgress }), !showProgress && _react2.default.createElement('div', { className: 'view-media-prompt', onClick: openMyMediaShelf }, 'Click to view uploads'));
}

function UploadFailedNotification(_ref3) {
    var _ref3$title = _ref3.title,
        title = _ref3$title === undefined ? 'Unable to upload file' : _ref3$title,
        message = _ref3.message,
        thumbnail = _ref3.thumbnail,
        closeNotification = _ref3.closeNotification;

    var dispatch = (0, _reactRedux.useDispatch)();

    var openMyMediaShelf = function openMyMediaShelf() {
        if (closeNotification) closeNotification();
        dispatch((0, _modeActions.changeSidebarSection)(_General.Sections.VIDEOS.id, true));
    };

    var imageElement = thumbnail ? _react2.default.createElement(_LazyImageElem2.default, { src: thumbnail, height: '100%', width: '100%' }) : _react2.default.createElement(_SVGIcon2.default, { iconId: 'warning-sign', height: '70%', width: '70%' });

    return _react2.default.createElement(UploadingNotificationCard, { imageElement: imageElement }, _react2.default.createElement('div', { className: 'header' }, title), _react2.default.createElement('div', { className: 'view-media-prompt', onClick: openMyMediaShelf }, message));
}

function dispatchUploadingNotification() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$notificationPro = _ref4.notificationProps,
        notificationProps = _ref4$notificationPro === undefined ? {} : _ref4$notificationPro,
        _ref4$duration = _ref4.duration,
        duration = _ref4$duration === undefined ? null : _ref4$duration;

    var notifId = void 0;
    var closeNotification = function closeNotification() {
        _NotificationCard.notify.dismiss(notifId);
    };

    notifId = (0, _NotificationCard.notifyWithComponent)(_react2.default.createElement(UploadingNotification, _extends({}, notificationProps, {
        closeNotification: closeNotification,
        clearOnCompleteTimeout: 60000
    })), {
        id: 'upload-progress',
        duration: duration || 4000
    });

    return notifId;
}

function dispatchUploadFailureNotification() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        message = _ref5.message,
        thumbnail = _ref5.thumbnail,
        _ref5$duration = _ref5.duration,
        duration = _ref5$duration === undefined ? null : _ref5$duration,
        id = _ref5.id,
        onClose = _ref5.onClose,
        title = _ref5.title,
        height = _ref5.height;

    var notifId = void 0;
    var closeNotification = function closeNotification() {
        _NotificationCard.notify.dismiss(notifId);
    };

    var style = {};

    if (height) {
        style.height = height;
    }

    notifId = (0, _NotificationCard.notifyWithComponent)(_react2.default.createElement(UploadFailedNotification, {
        title: title,
        message: message,
        thumbnail: thumbnail,
        closeNotification: closeNotification
    }), {
        duration: duration || 4000,
        id: id,
        onClose: onClose,
        persist: true,
        style: style
    });

    return notifId;
}

},{"../../../common/components/SVGIcon.react":13,"../../../common/components/notificationSystem/NotificationCard.react":25,"../../../common/utils/ModelDataUtils":80,"../../actions/modeActions":162,"../../constants/General":203,"../../selectors/projectMediaSelectors":220,"../ProgressBar.react":186,"../utility/LazyImageElem.react":197,"keymirror":677,"lodash":860,"react":1107,"react-redux":1079}],196:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTimelineOutSideClick = exports.PreventClipSelectCloseDiv = exports.useSnapScrollToTime = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Player = require('../../../common/constants/Player');

var _CommonAlgorithms = require('../../../common/utils/CommonAlgorithms');

var _reelSelectors = require('../../selectors/reelSelectors');

var _WindowEvents = require('../../utils/WindowEvents');

var _WindowEvents2 = _interopRequireDefault(_WindowEvents);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
} /**
   * File includes Hooks which specifically handles some behavioril changes.
   * This is done to avoid using effect to send internal state update back to outside store
   *
   * If ur component needs to react to the store change in certain way these hooks are ur choice
   * It's better than having UI Actions to have to go through all the middlewares to trigger something on store
   *
   * Why avoid store though ? Because middlewares are unpredictable , news ones are added old ones removed
   * every now and then u may just have something executing taking CPU cycles compared to internal state update
   * which is more in control
   *
   * Remember this is only done for Ui Interaction states which are rapidly updated when user interacts
   * e.g scroll drag etc related states
   *
   */

var DEBUG = true && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var useSnapScrollToTime = exports.useSnapScrollToTime = function useSnapScrollToTime() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_ref) {
        var time = _ref.time,
            duration = _ref.duration;
    };

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        var _state$ui$snapTimelin = state.ui.snapTimelineScrollToCurrentTime,
            snapTimelineScrollToCurrentTime = _state$ui$snapTimelin === undefined ? false : _state$ui$snapTimelin,
            _state$player = state.player,
            time = _state$player.time,
            duration = _state$player.duration;

        return {
            snapTimelineScrollToCurrentTime: snapTimelineScrollToCurrentTime,
            time: time,
            duration: duration
        };
    }, function (left, right) {
        if (left.snapTimelineScrollToCurrentTime !== right.snapTimelineScrollToCurrentTime) return false;

        return true;
    }),
        snapTimelineScrollToCurrentTime = _useSelector.snapTimelineScrollToCurrentTime,
        time = _useSelector.time,
        duration = _useSelector.duration;

    (0, _react.useEffect)(function () {
        if (snapTimelineScrollToCurrentTime) {
            func({ time: time, duration: duration });
        }
    }, [snapTimelineScrollToCurrentTime]);
};

/**
 * Use it to prevent Clip Deselection ,
 *
 * @param {React.HTMLAttributes<HTMLDivElement> & {disable : boolean}} { className, disable = false, ...otherProps }
 * @param {React.MutableRefObject} ref
 */
var PreventClipSelectCloseDiv = _react2.default.forwardRef(function (_ref2, ref) {
    var className = _ref2.className,
        _ref2$disable = _ref2.disable,
        disable = _ref2$disable === undefined ? false : _ref2$disable,
        otherProps = _objectWithoutProperties(_ref2, ['className', 'disable']);

    return _react2.default.createElement('div', _extends({
        ref: ref,
        className: (0, _classnames2.default)(className, {
            'prevent-clip-select-close': !disable
        })
    }, otherProps));
});

/**
 *
 * Use this hook anywhere to disable enable the Click Outside capcity of Timeline
 * Click is Pooled but is registered on Window so be aware of same
 * It is costly but not that much
 *
 *
 * @param {*} [func=(event) => {}]
 * @return {*}
 */
exports.PreventClipSelectCloseDiv = PreventClipSelectCloseDiv;
var useTimelineOutSideClick = exports.useTimelineOutSideClick = function useTimelineOutSideClick() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (event) {};

    var anySelected = (0, _reactRedux.useSelector)(function (state) {
        var isAnySelected = (0, _reelSelectors.anyClipSelected)(state);
        return isAnySelected;
    }, _reactRedux.shallowEqual);
    var functionRef = (0, _react.useRef)(null);

    functionRef.current = func;
    var callBack = _react2.default.useCallback(function (event) {
        noClipSelectCloseArea.current = document.querySelectorAll('.prevent-clip-select-close');

        var shouldFire = true;

        if (canvasAreaDomRef.current.contains(event.target) && shouldFire) {
            // console.log(`clicked on canvas area`)
            shouldFire = false;
        }

        if (event.path && shouldFire) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = event.path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var element = _step.value;

                    if (!element.classList) continue;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = element.classList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var cls = _step2.value;

                            if (cls === 'prevent-clip-select-close') {
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        if (noClipSelectCloseArea.current && shouldFire) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = noClipSelectCloseArea.current[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _element = _step3.value;

                    if (_element.contains(event.target)) {
                        // console.log(`clicked on prevent clip select zone`)
                        shouldFire = false;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }

        if (shouldFire) {
            functionRef.current(event);
        }
    }, []);

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        disable = _useState2[0],
        setDisable = _useState2[1];

    var callbackRef = (0, _react.useRef)(null);

    var canvasAreaDomRef = (0, _react.useRef)(null);
    var noClipSelectCloseArea = (0, _react.useRef)(null);

    (0, _react.useEffect)(function () {
        canvasAreaDomRef.current = document.querySelector('.player-canvas-content');

        if (anySelected && !disable) {
            // console.log(`attached`)
            callbackRef.current = _WindowEvents2.default.addEventListener('mousedown', callBack);
            // console.log(callBack ,  callBack.refObj )
        }
        return function () {
            if (callbackRef.current) {
                // console.log(`detached`)
                _WindowEvents2.default.removeEventListener('mousedown', callBack);
                callbackRef.current = null;
            }
        };
    }, [anySelected, disable]);

    var enableListener = _react2.default.useCallback(function () {
        return setDisable(false);
    }, []);
    var disableListener = _react2.default.useCallback(function () {
        return setDisable(true);
    }, []);

    return {
        enableListener: enableListener,
        disableListener: disableListener
    };
};

},{"../../../common/constants/Player":64,"../../../common/utils/CommonAlgorithms":72,"../../selectors/reelSelectors":221,"../../utils/WindowEvents":235,"classnames":410,"react":1107,"react-redux":1079}],197:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LazyRectPlaceholder = require('../../../common/components/loaders/LazyRectPlaceholder.react');

var _LazyRectPlaceholder2 = _interopRequireDefault(_LazyRectPlaceholder);

var _LazyLoad = require('./LazyLoad.react');

var _LazyLoad2 = _interopRequireDefault(_LazyLoad);

var _workerUtils = require('../../../common/utils/workerUtils');

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _reactRedux = require('react-redux');

var _polyfill = require('../../../common/utils/scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var USE_WORKER = false;

var urlReg = /\((.*?)\)/;
var clearQ = /('|")/g;

var parseUrl = function parseUrl(url) {
    return url.match(urlReg)[1].replace(clearQ, '');
};

function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
    if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
    }

    // default offset is center
    offsetX = typeof offsetX === 'number' ? offsetX : 0.5;
    offsetY = typeof offsetY === 'number' ? offsetY : 0.5;

    // keep bounds [0.0, 1.0]
    if (offsetX < 0) offsetX = 0;
    if (offsetY < 0) offsetY = 0;
    if (offsetX > 1) offsetX = 1;
    if (offsetY > 1) offsetY = 1;

    var iw = img.width,
        ih = img.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r,

    // new prop. width
    nh = ih * r,

    // new prop. height
    cx,
        cy,
        cw,
        ch,
        ar = 1;

    // decide which gap to fill
    if (nw < w) ar = w / nw;
    if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
    nw *= ar;
    nh *= ar;

    // calc source rectangle
    cw = iw / (nw / w);
    ch = ih / (nh / h);

    cx = (iw - cw) * offsetX;
    cy = (ih - ch) * offsetY;

    // make sure source rectangle is valid
    if (cx < 0) cx = 0;
    if (cy < 0) cy = 0;
    if (cw > iw) cw = iw;
    if (ch > ih) ch = ih;

    // fill image in dest. rectangle
    ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
}

/** @type {*} */
var ImageWorker = USE_WORKER ? (0, _workerUtils.buildWorker)(function (url, done) {
    if (!url) return done(null, new Error('Invalid Image Url : ' + url));
    var imageBitmapMap = {};
    var bm = imageBitmapMap[url];
    if (!!bm) done(bm);

    /**
     *
     *
     * @param {ImageBitmap} bitmap
     */
    var processImage = function processImage(bitmap) {
        imageBitmapMap[url] = bitmap;
        done(bitmap);
    };

    fetch(url, {
        method: 'GET',
        credentials: 'same-origin'
    }).then(function (response) {
        var blob = response.blob();
        return blob;
    }).then(function (blob) {
        return createImageBitmap(blob);
    }).then(processImage).catch(function (err) {
        done(null, err);
    });
}) : function () {
    throw new Error('Enable Worker in LazyImage file to use worker , IT IS HIGH EXPERIMENTAL RIGHT NOW -- ONLY USE WITH LARGE IMAGES -- WARNING DOES NOT USE TRANSFERABLE OBJECT YET');
};

var getUnique = function getUnique(arr) {
    var store = {};
    var it = arr.length;
    while (it--) {
        store[arr[it]] = true;
    }
    arr = Object.keys(store);
    return arr;
};

/**
 *
 * Lazy Image Element , is a wrapper on image or valid html element with background image
 * How to use ?
 * 1. pass style and type and the src for the image to be loaded and sized
 * 2. Optionally can pass type also , any valid react html element is accepted
 * 3. can pass ptype for placeholder type , that can set the type for placeholder
 * 4. when setting src ideally u should be using image element which is the default
 * 5. if using backgroundImage dont specify src it will be attached accordingly based on element type
 * 6. If u want just pass ur own Placeholder and that will be used , remembering styling responsibility is on u
 *
 *
 * EXPERIMENTAL SUPPORT FOR WEB WORKERS ADDED
 * - What does it do ?
 *    Loads ur data of the main thread. In case of large images , leads to off thread image decoding
 * - What to improve ?
 *   - use of transferable object
 *   - use of Offscreen canvas
 *
 *
 * @param {*} props
 * @return {*}
 */
function LazyImageElem(props) {
    var _props$debug = props.debug,
        debug = _props$debug === undefined ? false : _props$debug;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        loaded = _useState2[0],
        setLoaded = _useState2[1];

    var imgRef = (0, _react.useRef)(null);

    var src = props.src,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        _props$placeHolder = props.placeHolder,
        placeHolder = _props$placeHolder === undefined ? null : _props$placeHolder,
        _props$imageRef = props.imageRef,
        imageRef = _props$imageRef === undefined ? null : _props$imageRef,
        _props$height = props.height,
        height = _props$height === undefined ? null : _props$height,
        _props$width = props.width,
        width = _props$width === undefined ? null : _props$width,
        _props$elementRef = props.elementRef,
        elementRef = _props$elementRef === undefined ? null : _props$elementRef,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$ptype = props.ptype,
        ptype = _props$ptype === undefined ? 'div' : _props$ptype,
        _props$dynamicLoad = props.dynamicLoad,
        dynamicLoad = _props$dynamicLoad === undefined ? false : _props$dynamicLoad,
        _props$useWorker = props.useWorker,
        useWorker = _props$useWorker === undefined ? false : _props$useWorker,
        otherProps = _objectWithoutProperties(props, ['src', 'style', 'placeHolder', 'imageRef', 'height', 'width', 'elementRef', 'className', 'ptype', 'dynamicLoad', 'useWorker']);

    var _props$type = props.type,
        type = _props$type === undefined ? 'img' : _props$type;

    var loaderStyle = _react2.default.useMemo(function () {
        return dynamicLoad ? {
            height: '100%',
            width: '100%',
            position: 'relative'
        } : _extends({ height: height, width: width }, style);
    }, [dynamicLoad, height, width, style]);

    delete loaderStyle.backgroundColor; // TODO check impact

    var lazyLoader = _react2.default.useMemo(function () {
        var lazyLoader = void 0;
        if (placeHolder) {
            lazyLoader = _react2.default.cloneElement(placeHolder);
            var _lazyLoader$props = lazyLoader.props,
                _style = _lazyLoader$props.style,
                innerClassName = _lazyLoader$props.className;

            lazyLoader = _react2.default.cloneElement(placeHolder, {
                style: _extends({}, loaderStyle, _style),
                className: className + ' ' + innerClassName
            });
        } else {
            lazyLoader = _react2.default.createElement(_LazyRectPlaceholder2.default, { style: loaderStyle, className: className, type: ptype });
        }
        return lazyLoader;
    }, [loaderStyle, className, ptype]);

    var imgStyle = _extends({
        height: height,
        width: width }, style);

    // imageSrc just picks any source css url string or simple url

    var _React$useMemo = _react2.default.useMemo(function () {
        var imageSrc = src || style.backgroundImage && parseUrl(style.backgroundImage); // grabbing whichever data is specified
        var multiImg = Array.isArray(imageSrc);
        return { imageSrc: imageSrc, multiImg: multiImg };
    }, [style && style.backgroundImage, src]),
        imageSrc = _React$useMemo.imageSrc,
        multiImg = _React$useMemo.multiImg;

    if (multiImg) type = 'div';else if (useWorker) type = 'canvas';

    var imageElementToShow = _react2.default.useMemo(function () {
        // TODO -- memoise them properly
        var elemProps = _extends({
            ref: imgRef,
            style: imgStyle,
            className: className,
            loading: 'lazy'
        }, otherProps);

        // TODO -- memoise this
        if (multiImg) {
            var url = '';
            var it = imageSrc.length;
            while (it--) {
                url = ',url(' + imageSrc[it] + ')' + url;
            }
            elemProps.style['backgroundImage'] = url.substring(1);
        } else if (useWorker) {
            elemProps.style['backgroundImage'] = 'unset';
            elemProps.src = null;
        } else if (type !== 'img') {
            elemProps.style['backgroundImage'] = 'url(' + imageSrc + ')';
        } else {
            elemProps.src = imageSrc;
        }
        var img = _react2.default.createElement(type, elemProps);
        return img;
    }, [style, className, imageSrc, height, width]);

    var img = loaded ? imageElementToShow : null;

    // TODO attach one off listener for listening to the size or the boundingClientRect
    // to know whether to load the image or not

    var bitmapRef = (0, _react.useRef)(null);

    var deps = _react2.default.useMemo(function () {
        return (multiImg ? [].concat(_toConsumableArray(imageSrc)) : [imageSrc]).join(' ');
    }, [imageSrc]);

    var componentMounted = (0, _react.useRef)(true);

    (0, _react.useEffect)(function () {
        if (elementRef) {
            elementRef.current = imgRef.current;
        }

        if (multiImg) {
            var uniqueImages = getUnique(imageSrc);

            Promise.all(uniqueImages.map(function (imgSrc) {
                return new Promise(function (resolve, reject) {
                    if (imageRef) {
                        imageRef.current = imgObject;
                    }

                    if (!!imageSrc && !useWorker) {
                        imgObject.onload = function (ev) {
                            imgObject.onload = null;
                            resolve(ev);
                        };
                        imgObject.src = imgSrc;
                    }
                });
            })).then(function () {
                (0, _polyfill.qeueReduxBatchedOperation)(function () {
                    if (componentMounted.current) {
                        setLoaded(true);
                    }
                }, 'raf'); // since it should be painted quickly as soon as available
            });
        } else {
            var _imgObject = new Image();

            if (imageRef) {
                imageRef.current = _imgObject;
            }

            if (!!imageSrc && !useWorker) {
                _imgObject.onload = function (ev) {
                    _imgObject.onload = null;

                    (0, _polyfill.qeueReduxBatchedOperation)(function () {
                        if (componentMounted.current) {
                            setLoaded(true);
                        }
                    }, 'raf'); // it should be painted quickly
                };
                _imgObject.src = imageSrc;
            }
        }

        if (useWorker && !multiImg) {
            ImageWorker(imageSrc).then(function (imagebitmap) {
                bitmapRef.current = imagebitmap;
            });
        }

        return function () {
            if (imageRef && imageRef.current) {
                imageRef.current.onload = null;
            }
        };
    }, [deps]); // setting useEffect

    (0, _react.useEffect)(function () {
        componentMounted.current = true;
        return function () {
            componentMounted.current = false;
            if (imageRef && imageRef.current) {
                imageRef.current.onload = null;
            }
        };
    }, []);

    // TODO -- not used as of now , more testing required
    (0, _react.useEffect)(function () {
        if (loaded && useWorker && imgRef.current && bitmapRef.current && componentMounted.current) {
            _fastdom2.default.mutate(function () {
                var rect = imgRef.current.getBoundingClientRect();
                var bitmap = bitmapRef.current;
                var canvas2d = imgRef.current.getContext('2d');
                imgRef.current.height = rect.height;
                imgRef.current.width = rect.width;
                // console.log(rect, imgRef.current, bitmap);
                drawImageProp(canvas2d, bitmap, 0, 0, rect.width, rect.height, 0, 0);
            });
        }
    }, [loaded]);

    return _react2.default.createElement(_react.Fragment, null, loaded && !debug ? img : lazyLoader);
}

/**
 *
 *
 * @param {{
 *     once: boolean,
 *     src : string | Array<string>,
 *     style : CSSStyleDeclaration,
 *     unmountIfInvisible : boolean,
 *     placeHolder : React.ReactElement,
 *     scrollContainer : string,
 *     dynamicLoad : boolean,
 *     imageRef : React.MutableRefObject,
 *     elementRef : React.MutableRefObject,
 *     width : number,
 *     height : number,
 *     className : string,
 *     ptype : 'div'|'img'|'span'| string,
 *     useWorker : boolean,
 *     type : 'div'|'img'|'span'| string,
 * }} [params]
 * @return {*}
 */
var MemoizedLazyImageElem = function MemoizedLazyImageElem(_ref) {
    var _ref$once = _ref.once,
        once = _ref$once === undefined ? true : _ref$once,
        _ref$src = _ref.src,
        src = _ref$src === undefined ? null : _ref$src,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$unmountIfInvisib = _ref.unmountIfInvisible,
        unmountIfInvisible = _ref$unmountIfInvisib === undefined ? false : _ref$unmountIfInvisib,
        _ref$placeHolder = _ref.placeHolder,
        placeHolder = _ref$placeHolder === undefined ? null : _ref$placeHolder,
        _ref$scrollContainer = _ref.scrollContainer,
        scrollContainer = _ref$scrollContainer === undefined ? null : _ref$scrollContainer,
        _ref$dynamicLoad = _ref.dynamicLoad,
        dynamicLoad = _ref$dynamicLoad === undefined ? false : _ref$dynamicLoad,
        _ref$imageRef = _ref.imageRef,
        imageRef = _ref$imageRef === undefined ? null : _ref$imageRef,
        _ref$elementRef = _ref.elementRef,
        elementRef = _ref$elementRef === undefined ? null : _ref$elementRef,
        otherProps = _objectWithoutProperties(_ref, ['once', 'src', 'style', 'unmountIfInvisible', 'placeHolder', 'scrollContainer', 'dynamicLoad', 'imageRef', 'elementRef']);

    if (!dynamicLoad) {
        return (
            // <div style={lazyStyle} >
            _react2.default.createElement(LazyImageElem, _extends({}, otherProps, {
                placeHolder: placeHolder,
                src: src,
                imageRef: imageRef,
                elementRef: elementRef,
                dynamicLoad: dynamicLoad,
                style: style
            }))
            // </div>

        );
    }

    var top = style.top,
        left = style.left,
        bottom = style.bottom,
        right = style.right,
        position = style.position,
        height = style.height,
        width = style.width,
        otherStyle = _objectWithoutProperties(style, ['top', 'left', 'bottom', 'right', 'position', 'height', 'width']);

    var lazyStyle = {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        position: position,
        height: height,
        width: width
    };
    otherStyle.position = 'relative';
    otherStyle.height = '100%';
    otherStyle.width = '100%';

    return _react2.default.createElement(_LazyLoad2.default, {
        once: once,
        unmountIfInvisible: unmountIfInvisible,
        style: lazyStyle,
        scrollContainer: scrollContainer,
        debounce: 100
    }, _react2.default.createElement(LazyImageElem, _extends({}, otherProps, { src: src, imageRef: imageRef, elementRef: elementRef, style: otherStyle })));
};

exports.default = _react2.default.memo(MemoizedLazyImageElem, function (prevProps, nextProps) {
    return prevProps.height === nextProps.height && prevProps.width === nextProps.width && prevProps.src === nextProps.src && (0, _reactRedux.shallowEqual)(prevProps.style, nextProps.style) && prevProps.className === nextProps.className;
});

},{"../../../common/components/loaders/LazyRectPlaceholder.react":22,"../../../common/utils/scheduler/polyfill":126,"../../../common/utils/workerUtils":131,"./LazyLoad.react":198,"fastdom":634,"react":1107,"react-redux":1079}],198:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _useScrollPosition = require('../../../common/utils/hooks/useScrollPosition.react');

var _useScrollPosition2 = _interopRequireDefault(_useScrollPosition);

var _useResizeDetector = require('../../../common/utils/hooks/useResizeDetector.react');

var _useResizeDetector2 = _interopRequireDefault(_useResizeDetector);

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _useIntersectionDetector = require('../../../common/utils/hooks/useIntersectionDetector.react');

var _useIntersectionDetector2 = _interopRequireDefault(_useIntersectionDetector);

var _polyfill = require('../../../common/utils/scheduler/polyfill');

var _useEnhancedState3 = require('../../../common/utils/hooks/useEnhancedState.react');

var _useEnhancedState4 = _interopRequireDefault(_useEnhancedState3);

var _usePropRef = require('../../../common/utils/hooks/usePropRef.react');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

/**
 *
 *
 * @param {{
 *  elementRect: DOMRect,
 *  boundingElementRect : DOMRect,
 *  offsetX : number,
 *  offsetY : number
 * }} {elementRect , boundingElement , offsetX , offsetY}
 */
function isElementInsideBoundingElement(_ref) {
    var elementRect = _ref.elementRect,
        boundingElementRect = _ref.boundingElementRect,
        offsetX = _ref.offsetX,
        offsetY = _ref.offsetY;

    // not visible at all so dont give true
    if (boundingElementRect.width == 0 || boundingElementRect.height == 0) return false;

    var relX = elementRect.left - boundingElementRect.left;
    var relY = elementRect.top - boundingElementRect.top;

    if (relX >= 0 - offsetX && relX < boundingElementRect.width + offsetX && relY >= 0 - offsetY && relY < boundingElementRect.height + offsetY) {
        return true;
    }

    return false;
}

/**
 *
 *
 * @param {{
 *  elementRect: DOMRect,
 *  offsetX : number,
 *  offsetY : number
 * }} {elementRect , offsetX , offsetY}
 * @return {*}
 */
function isElementInsideWindow(_ref2) {
    var elementRect = _ref2.elementRect,
        offsetX = _ref2.offsetX,
        offsetY = _ref2.offsetY;

    var x = elementRect.left;
    var y = elementRect.top;
    if (x >= 0 - offsetX && x < window.innerWidth + offsetX && y >= 0 - offsetY && y < window.innerHeight + offsetY) {
        return true;
    }
}

function bringInViewMinimal(_ref3) {
    var setInView = _ref3.setInView;

    setInView(true);
}

function bringInView(_ref4) {
    var scrollContainer = _ref4.scrollContainer,
        containerRef = _ref4.containerRef,
        setInView = _ref4.setInView,
        offset = _ref4.offset,
        useWindowRef = _ref4.useWindowRef,
        boundingElemRef = _ref4.boundingElemRef,
        _ref4$elementPos = _ref4.elementPos,
        elementPos = _ref4$elementPos === undefined ? null : _ref4$elementPos,
        _ref4$boundingElement = _ref4.boundingElementPos,
        boundingElementPos = _ref4$boundingElement === undefined ? null : _ref4$boundingElement,
        unmountIfInvisible = _ref4.unmountIfInvisible,
        _ref4$useRaf = _ref4.useRaf,
        useRaf = _ref4$useRaf === undefined ? false : _ref4$useRaf,
        _ref4$callback = _ref4.callback,
        callback = _ref4$callback === undefined ? function () {} : _ref4$callback;

    // useWindow may trigger based on whether element request was found or not
    if (!boundingElemRef.current && !useWindowRef.current)
        // store the current
        boundingElemRef.current = document.querySelector(scrollContainer);

    var boundingElement = boundingElemRef.current;
    var element = containerRef.current;

    if (element) {
        var op = function op() {
            elementPos = elementPos || element.getBoundingClientRect();
            boundingElementPos = boundingElementPos || boundingElement.getBoundingClientRect();

            if (!useWindowRef.current) {
                var isInside = isElementInsideBoundingElement({
                    elementRect: elementPos,
                    boundingElementRect: boundingElementPos,
                    offsetX: offset[0],
                    offsetY: offset[1]
                });
                callback(isInside);

                if (isInside) {
                    // inside the view of the bounding element
                    (0, _polyfill.qeueReduxBatchedOperation)(function () {
                        return setInView(true);
                    }, 'timeout');
                    return true;
                } else {
                    if (unmountIfInvisible) {
                        (0, _polyfill.qeueReduxBatchedOperation)(function () {
                            return setInView(false);
                        }, 'timeout');
                    }
                }
            } else {
                var _isInside = isElementInsideWindow({
                    elementRect: elementPos,
                    offsetX: offset[0],
                    offsetY: offset[1]
                });

                callback(_isInside);

                if (_isInside) {
                    (0, _polyfill.qeueReduxBatchedOperation)(function () {
                        return setInView(true);
                    }, 'timeout');
                } else {
                    if (unmountIfInvisible) {
                        (0, _polyfill.qeueReduxBatchedOperation)(function () {
                            return setInView(false);
                        }, 'timeout');
                    }
                }
            }
        };

        if (useRaf) {
            _fastdom2.default.measure(op);
        } else {
            op();
        }
    }
}

/**
 * Lazy load component, it latches to the scroll component it is pointed to , or
 * to the document component , this allows to load child component only when its in view
 * or user can view it
 *
 * Usage
 *
 * - use with any elemnt inside a scrollable list
 * - specify debounce value for creating a async debounce loading of content
 * - if debounce is null then content is called synchronously inside proper batching to avoid frame skips
 * - Intersection Observer is a new addition nd stopping the laoding by intersection observer is still work in progress
 *
 * Experimental
 * - Intersection Observer is good for detection of loading in. but not loading out
 * - Currently if u turn on Intersection Observer better to use it with once option
 * - Great for loading images and other artifacts
 *
 * for faster once load use - once = true , useInterSectionObserver = true , useScrollEvent = false
 *
 *
 * @export
 * @param {{
 *  once : boolean,
 *  unmountIfInvisible: boolean,
 *  onElementInView : Function,
 *  scrollContainer : string,
 *  className : string,
 *  style : Object,
 *  throttle : number,
 *  avoidOnWindow : boolean ,
 *  offset : number | Array<number>
 *  useIntersectionObserverApi : boolean,
 *  index : number
 * }} {
 *     once = true ,
 *     unmountIfInvisible = false, // unmount component if out of view , override the once
 *     children = [],
 *     onElementInView = () => {},
 *     scrollContainer = null , throttle = 16  , style = {},
 *     className = "" ,
 *     avoidOnWindow = true, // avoid using window
 *     offset = 0,
 *
 *     useIntersectionObserverApi = true
 *     index : number // used by LazyListRenderer internally
 * }
 * @return {*}
 */
function LazyLoad(_ref5) {
    var _ref5$once = _ref5.once,
        once = _ref5$once === undefined ? true : _ref5$once,
        _ref5$unmountIfInvisi = _ref5.unmountIfInvisible,
        unmountIfInvisible = _ref5$unmountIfInvisi === undefined ? false : _ref5$unmountIfInvisi,
        _ref5$children = _ref5.children,
        children = _ref5$children === undefined ? [] : _ref5$children,
        _ref5$onElementInView = _ref5.onElementInView,
        onElementInView = _ref5$onElementInView === undefined ? function () {} : _ref5$onElementInView,
        _ref5$scrollContainer = _ref5.scrollContainer,
        scrollContainer = _ref5$scrollContainer === undefined ? null : _ref5$scrollContainer,
        _ref5$debounce = _ref5.debounce,
        debounceT = _ref5$debounce === undefined ? null : _ref5$debounce,
        _ref5$style = _ref5.style,
        style = _ref5$style === undefined ? {} : _ref5$style,
        _ref5$className = _ref5.className,
        className = _ref5$className === undefined ? '' : _ref5$className,
        _ref5$avoidOnWindow = _ref5.avoidOnWindow,
        avoidOnWindow = _ref5$avoidOnWindow === undefined ? false : _ref5$avoidOnWindow,
        _ref5$offset = _ref5.offset,
        offset = _ref5$offset === undefined ? 0 : _ref5$offset,
        _ref5$placeholder = _ref5.placeholder,
        placeholder = _ref5$placeholder === undefined ? null : _ref5$placeholder,
        _ref5$debug = _ref5.debug,
        debug = _ref5$debug === undefined ? false : _ref5$debug,
        _ref5$useInterSection = _ref5.useInterSectionObserver,
        useInterSectionObserver = _ref5$useInterSection === undefined ? false : _ref5$useInterSection,
        _ref5$useScrollEvent = _ref5.useScrollEvent,
        useScrollEvent = _ref5$useScrollEvent === undefined ? true : _ref5$useScrollEvent,
        _ref5$innerRef = _ref5.innerRef,
        innerRef = _ref5$innerRef === undefined ? null : _ref5$innerRef,
        _ref5$index = _ref5.index,
        index = _ref5$index === undefined ? null : _ref5$index;

    var boundingElemRef = (0, _react.useRef)(null);

    var _useEnhancedState = (0, _useEnhancedState4.default)(false),
        _useEnhancedState2 = _slicedToArray(_useEnhancedState, 2),
        inView = _useEnhancedState2[0],
        setInView = _useEnhancedState2[1];
    // will use document if bounding element is not provided


    var shouldObserve = once && !unmountIfInvisible ? !inView : true;
    var useWindowRef = (0, _react.useRef)(scrollContainer == null && !avoidOnWindow);

    offset = typeof offset === 'number' ? [offset, offset] : offset;

    // const rootMargin = `${offset[0]}px ${offset[1]}px ${offset[0]}px ${offset[1]}px`;

    var containerRef = (0, _react.useRef)(null);

    // TODO -- better control intersection observer behaviour
    // Scroll has been working good till now , but combining with intersection observer can
    // reduce the amount of computation done -- BUT IT DOESNT WORK PROPERLY AS OF YET
    // const containerRef = useIntersectionDetector(
    //     ({ useWindow, element, intersectionRatio, currPos, containerElement, isIntersecting }) => {
    //         const { elementPos, boundingElementPos } = currPos;

    //         useWindowRef.current = useWindow;

    //         if (isIntersecting && !inView) {
    //             bringInView({
    //                 scrollContainer,
    //                 containerRef,
    //                 boundingElemRef,
    //                 setInView,
    //                 offset,
    //                 useWindowRef,
    //                 elementPos,
    //                 unmountIfInvisible,
    //                 boundingElementPos,
    //                 useRaf: true,
    //                 callback: (isInside) => {
    //                     onElementInView({ currPos, useWindow, isInside });
    //                 },
    //             });
    //         }
    //     },
    //     [scrollContainer, inView],
    //     {
    //         rootMargin: rootMargin,
    //         threshold: [0, 0.1, 0.2, 0.5, 0.8, 0.9, 1],
    //     },
    //     {
    //         targetContainer: scrollContainer,
    //         shouldObserve: shouldObserve && !inView && useInterSectionObserver, // instersection observer when it is out of vide
    //     }
    // );

    var elementBoundingBoxRef = (0, _react.useRef)(null);

    var pushData = (0, _usePropRef.usePropRef)(function (_ref6) {
        var isInside = _ref6.isInside;

        if (innerRef) {
            if (typeof innerRef === 'function') {
                innerRef({
                    elementBoundingBoxRef: elementBoundingBoxRef,
                    containerRef: containerRef,
                    index: index,
                    isInside: isInside
                });
            } else {
                innerRef.current = {
                    elementBoundingBoxRef: elementBoundingBoxRef,
                    containerRef: containerRef,
                    index: index,
                    isInside: isInside
                };
            }
        }
    });

    (0, _useScrollPosition2.default)(function (_ref7) {
        var currPos = _ref7.currPos,
            prevPos = _ref7.prevPos,
            useWindow = _ref7.useWindow;

        useWindowRef.current = useWindow;
        var elementPos = currPos.elementPos,
            boundingElementPos = currPos.boundingElementPos;

        elementBoundingBoxRef.current = elementPos;
        bringInView({
            scrollContainer: scrollContainer,
            containerRef: containerRef,
            boundingElemRef: boundingElemRef,
            setInView: setInView,
            offset: offset,
            useWindowRef: useWindowRef,
            elementPos: elementPos,
            unmountIfInvisible: unmountIfInvisible,
            boundingElementPos: boundingElementPos,
            callback: function callback(isInside) {
                onElementInView({ currPos: currPos, prevPos: prevPos, useWindow: useWindow, isInside: isInside });
                pushData.current({ isInside: isInside });
            }
        });
    }, [scrollContainer, inView], {
        boundingElement: scrollContainer,
        element: containerRef,
        debounceT: debounceT, // To use frame budget driven batches
        shouldObserve: shouldObserve && useScrollEvent, // scroll will be listened when it is in view
        useWindow: useWindowRef.current
    });

    // WE DONT USE ANY POSITION INFO FROM SCROLL BECAUSE - Resize will be triggered a very few times
    // So it's safe to use getBoudingClientRect inside there
    (0, _useResizeDetector2.default)(function (_ref8) {
        var elementBox = _ref8.elementBox;

        elementBoundingBoxRef.current = elementBox;
        if (!inView) {
            bringInView({
                scrollContainer: scrollContainer,
                containerRef: containerRef,
                boundingElemRef: boundingElemRef,
                setInView: setInView,
                offset: offset,
                unmountIfInvisible: unmountIfInvisible,
                useWindowRef: useWindowRef,
                callback: function callback(isInside) {
                    pushData.current({ isInside: isInside }); // triggers as soon as new load happens or resize happens
                }
            });
        }
    }, [scrollContainer, inView], {
        // change inscase scrollContainet changes or inView changes  -> reinitialise then
        targetContainer: scrollContainer,
        shouldObserve: !inView, // should observe only if not in view , otherwise not useful
        fireOnLoad: true
    });

    return _react2.default.createElement('div', { style: style, ref: containerRef, className: 'lazy-loader ' + (className || '') }, inView && !debug ? children : placeholder);
}

/**
 *
 *
 * @param {{
 *  once : boolean,
 *  unmountIfInvisible: boolean,
 *  onElementInView : Function,
 *  scrollContainer : string,
 *  className : string,
 *  style : Object,
 *  throttle : number,
 *  avoidOnWindow : boolean ,
 *  offset : number | Array<number>
 *  useIntersectionObserverApi : boolean
 * }} props
 * @param {React.MutableRefObject | ({elementBoundingBoxRef : React.MutableRefObject<DOMRect>}) => {}} ref
 * @return {*}
 */
var LazyLoadForward = function LazyLoadForward(props, ref) {
    return _react2.default.createElement(LazyLoad, _extends({ innerRef: ref }, props));
};

var forward = _react2.default.forwardRef(LazyLoadForward);

var LazyLoadMemo = _react2.default.memo(forward, function (prevProps, nextProps) {
    var prevChildren = prevProps.children,
        prevOtherProps = _objectWithoutProperties(prevProps, ['children']);

    var nextChildren = nextProps.children,
        nextOtherProps = _objectWithoutProperties(nextProps, ['children']);

    if (!(0, _reactRedux.shallowEqual)(prevOtherProps, nextOtherProps)) return false;

    prevChildren = _react2.default.Children.toArray(prevChildren);
    nextChildren = _react2.default.Children.toArray(nextChildren);

    if (prevChildren.length !== nextChildren.length) return false;

    for (var i = 0; i < prevChildren.length; i++) {
        if (!(0, _reactRedux.shallowEqual)(_react2.default.cloneElement(prevChildren[i]).props, _react2.default.cloneElement(nextChildren[i]).props)) return false;
    }
    return true;
});

exports.default = LazyLoadMemo;

},{"../../../common/utils/hooks/useEnhancedState.react":104,"../../../common/utils/hooks/useIntersectionDetector.react":106,"../../../common/utils/hooks/usePropRef.react":107,"../../../common/utils/hooks/useResizeDetector.react":108,"../../../common/utils/hooks/useScrollPosition.react":109,"../../../common/utils/scheduler/polyfill":126,"fastdom":634,"react":1107,"react-redux":1079}],199:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AvoidMount = exports.DebounceRender = exports.ReduxUpdateGuard = exports.ReduxRenderGuard = exports.RenderOnChildrenCountChange = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _useDebouncedEffect = require('../../../../common/utils/hooks/useDebouncedEffect.react');

var _useDebouncedEffect2 = _interopRequireDefault(_useDebouncedEffect);

var _usePropRef = require('../../../../common/utils/hooks/usePropRef.react');

var _polyfill = require('../../../../common/utils/scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

/**
 * Expects a single child , will block render if the the previous and  current count of children
 * of the child has not changed
 *
 * @export
 */
var RenderOnChildrenCountChange = exports.RenderOnChildrenCountChange = _react2.default.memo(function (props) {
    var children = _react2.default.Children.toArray(props.children);
    return children;
}, function (prevProps, nextProps) {
    var prevChildren = _react2.default.Children.toArray(prevProps.children);
    var nextChildren = _react2.default.Children.toArray(nextProps.children);
    return prevChildren.length === nextChildren.length;
});

/**
 *
 * Unmounts and remounts based on Redux data and applied shouldRender function logic
 * Why use it ?
 * - To avoid Hooks being used / called or the equality being checked only to
 *   have null returned at the end
 * - Composition of Logic of unmounting done at top and the content inside it
 *
 * @param {{
 *     shouldRender : (state) => boolean,
 *     children : () => React.ReactElement,
 *     placeholder : React.ReactElement
 * }}
 * @return {*}
 */
var ReduxRenderGuard = exports.ReduxRenderGuard = function ReduxRenderGuard(_ref) {
    var shouldRender = _ref.shouldRender,
        children = _ref.children,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === undefined ? null : _ref$placeholder;

    var canRender = (0, _reactRedux.useSelector)(shouldRender, _reactRedux.shallowEqual);
    var childrenRef = (0, _react.useRef)(children);
    childrenRef.current = children;
    var Component = _react2.default.useMemo(function () {
        return function () {
            return childrenRef.current && childrenRef.current();
        };
    }, []);

    return canRender ? _react2.default.createElement(Component, null) : placeholder;
};

/**
 *
 * Use it cautiously , this Component can read from redux state
 * and block updating ur components
 *
 * What kind of update is blocks
 * - Effect based updated , as the component tree traversal stops
 * - Props based updates
 *
 * What it cannot stop
 * - setStates , on events
 * - mapStateToProps of Redux , (may stop in future if they use functional HOC component)
 *
 * @param {{
 *     shouldUpdate : (state) => boolean,
 *     children : () => React.ReactElement,
 * }} {shouldUpdate , children }
 * @return {*}
 */
var ReduxUpdateGuard = exports.ReduxUpdateGuard = function ReduxUpdateGuard(_ref2) {
    var shouldUpdate = _ref2.shouldUpdate,
        children = _ref2.children;

    var canUpdate = (0, _reactRedux.useSelector)(shouldUpdate, _reactRedux.shallowEqual);
    var childrenRef = (0, _usePropRef.usePropRef)(children);
    var oldChildRef = (0, _react.useRef)(children);

    if (canUpdate) {
        oldChildRef.current = childrenRef.current;
    }
    var Component = _react2.default.useMemo(function () {
        return function () {
            return oldChildRef.current && oldChildRef.current();
        };
    }, []);
    return _react2.default.createElement(Component, null);
};

/**
 *
 * Use it when you don't want the incoming props for the children
 * or the incoming Scope variables of the new children being used
 * for rendering.
 *
 * In case of rapidly updating component use it to make sure
 * the children components are not rapidly updated
 *
 * Use it only when th child component has a constly render method
 * Something like Overlays
 *
 *
 *
 * @param {{
 *      onRequestRender : () => {}
 *      children : ({renderRequestCount , totalRenderDone  }) => React.ReactElement,
 *      placeholder : React.ReactElement,
 *      deps : Array<any>,
 *      timeout : number,
 *      type : 'raf' | 'st' | 'idle' | 'mt',
 *      runOnMountOnly : boolean
 * }}
 */
var DebounceRender = exports.DebounceRender = function DebounceRender(_ref3) {
    var _ref3$onRequestRender = _ref3.onRequestRender,
        onRequestRender = _ref3$onRequestRender === undefined ? function () {} : _ref3$onRequestRender,
        children = _ref3.children,
        _ref3$placeholder = _ref3.placeholder,
        placeholder = _ref3$placeholder === undefined ? null : _ref3$placeholder,
        _ref3$deps = _ref3.deps,
        deps = _ref3$deps === undefined ? null : _ref3$deps,
        timeout = _ref3.timeout,
        type = _ref3.type,
        _ref3$runOnMountOnly = _ref3.runOnMountOnly,
        runOnMountOnly = _ref3$runOnMountOnly === undefined ? false : _ref3$runOnMountOnly;

    var _useState = (0, _react.useState)(0),
        _useState2 = _slicedToArray(_useState, 2),
        renderCount = _useState2[0],
        setState = _useState2[1];

    var forceUpdate = function forceUpdate(value) {
        return setState(value);
    };
    var renderRequestRef = (0, _react.useRef)(0);

    var componentMounted = (0, _react.useRef)(false);

    renderRequestRef.current += 1;

    var childRef = (0, _react.useRef)(placeholder);

    var depList = [runOnMountOnly && componentMounted.current ? true : renderCount !== renderRequestRef.current].concat(_toConsumableArray(deps || []));

    var unMounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(function () {
        return function () {
            unMounted.current = true;
        };
    }, []);

    (0, _useDebouncedEffect2.default)(function () {
        if (componentMounted.current && runOnMountOnly) return;
        if (renderCount !== renderRequestRef.current) {
            onRequestRender();
            componentMounted.current = true;
            childRef.current = children({
                renderRequestCount: renderRequestRef.current,
                totalRenderDone: renderCount
            });
            (0, _polyfill.qeueReduxBatchedOperation)(function () {
                if (!unMounted.current) forceUpdate(renderRequestRef.current + 1);
            }, 'raf');
        }
    }, depList, {
        timeout: timeout,
        type: type
    });

    if (runOnMountOnly && componentMounted.current) {
        childRef.current = children({
            renderRequestCount: renderRequestRef.current,
            totalRenderDone: renderRequestRef.current
        });
    }

    return childRef.current;
};

/**
 * Use it when you want to mount on some boolean condition
 * but never unmount it after wards even when boolean changed
 *
 * It's lazy mounting technique where a component is mounted when
 * required , but never unmounted , since re-mounting can be costly
 *
 * But if the remounting is not costly then you can set `canUnmount`
 * to true so as to unmount the component whenevr the
 * `shouldMount` turns to false.
 *
 * @param {{
 *   shouldMount : boolean ,
 *   placeholder : React.ReactElement,
 *   canUnmount : boolean ,
 *   children : React.ReactElement
 * }} {
 *     shouldMount = false,
 *     placeholder = null,
 *     canUnmount = false,
 *     children,
 * }
 * @return {*}
 */
var AvoidMount = exports.AvoidMount = function AvoidMount(_ref4) {
    var _ref4$shouldMount = _ref4.shouldMount,
        shouldMount = _ref4$shouldMount === undefined ? false : _ref4$shouldMount,
        _ref4$placeholder = _ref4.placeholder,
        placeholder = _ref4$placeholder === undefined ? null : _ref4$placeholder,
        _ref4$canUnmount = _ref4.canUnmount,
        canUnmount = _ref4$canUnmount === undefined ? false : _ref4$canUnmount,
        children = _ref4.children;

    var shouldMountRef = (0, _react.useRef)(shouldMount);

    if (!shouldMountRef.current || canUnmount) {
        shouldMountRef.current = shouldMount;
    }

    return shouldMountRef.current ? children : placeholder;
};

},{"../../../../common/utils/hooks/useDebouncedEffect.react":103,"../../../../common/utils/hooks/usePropRef.react":107,"../../../../common/utils/scheduler/polyfill":126,"react":1107,"react-redux":1079}],200:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPreviewHeightWidthForSVG = exports.extractServiceAndIdFromDefId = exports.createSvgId = exports.createDefIdName = exports.getPluginTemplateEntryId = exports.getPluginShelfEntryKey = undefined;

var _PluginService = require('../../../../common/constants/PluginService');

var _General = require('../../../constants/General');

var getPluginShelfEntryKey = exports.getPluginShelfEntryKey = function getPluginShelfEntryKey() {
    var pluginServiceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (pluginServiceName === _PluginService.SupportedPlugins.captions) return _General.Sections.SUBTITLES.id;
    return pluginServiceName.toUpperCase();
};

var getPluginTemplateEntryId = exports.getPluginTemplateEntryId = function getPluginTemplateEntryId() {
    var pluginServiceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var assetType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (pluginServiceName === _PluginService.SupportedPlugins.iconscout) return 'iconscout-plugin-svg';

    console.error('What !! plugin do you want ?? It does not exist ');
    return null;
};

var createDefIdName = exports.createDefIdName = function createDefIdName(assetData) {
    return 'defId-userAsset' + assetData.assetType + '-' + assetData.assetSource + '-' + assetData.id;
};

var createSvgId = exports.createSvgId = function createSvgId(assetData) {
    return assetData.assetSource + '-' + assetData.id;
};

var definitionIdRegex = new RegExp('defId-userAsset(svg|image)-(iconscout|captions)-(.*)');

var extractServiceAndIdFromDefId = exports.extractServiceAndIdFromDefId = function extractServiceAndIdFromDefId(defId) {
    var matches = defId.match(definitionIdRegex);
    if (!!matches) {
        return {
            service: matches[2],
            id: matches[3]
        };
    }
};

var getPreviewHeightWidthForSVG = exports.getPreviewHeightWidthForSVG = function getPreviewHeightWidthForSVG(svgData) {
    var _svgData$generatedMet = svgData.generatedMetaData,
        generatedMetaData = _svgData$generatedMet === undefined ? {} : _svgData$generatedMet;
    var _generatedMetaData$he = generatedMetaData.height,
        height = _generatedMetaData$he === undefined ? 200 : _generatedMetaData$he,
        _generatedMetaData$wi = generatedMetaData.width,
        width = _generatedMetaData$wi === undefined ? 200 : _generatedMetaData$wi,
        _generatedMetaData$as = generatedMetaData.aspectRatio,
        aspectRatio = _generatedMetaData$as === undefined ? 1 : _generatedMetaData$as;

    if (height > width) return {
        width: 200 * aspectRatio
    };
    return {
        width: 200
    };
};

},{"../../../../common/constants/PluginService":65,"../../../constants/General":203}],201:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var CounterTimeFormatType = keymirror({
    SECS: null,
    MINS: null
});

module.exports = CounterTimeFormatType;

},{"keymirror":677}],202:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PossibleFormatsForFitnessTemplates = exports.FitnessTemplateConfigsByFormat = exports.getTemplateStyleGroup = exports.DefaultFitnessTemplateSelectionMap = exports.FitnessTemplateIdsMap = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Specific for Fitness editor.
// Each template is configured with own text and other properties.
// Copied the whole value object for each template so that any changes made in future to a template is consciously made here.
var FitnessTemplateIdsMap = {
    primaryText: {
        key: 'primaryText',
        label: 'Title text',
        desc: '',
        templates: {
            '81uPP2ZvS-virtual-fitness-class': {
                values: {
                    alpha: 1,
                    color1: '#F30000',
                    color2: '#F30000',
                    textColor1: 'rgb(255, 255, 255)',
                    textColor2: 'rgb(255, 255, 255)',
                    text1: '30 MIN',
                    text2: 'HIIT WORKOUT',
                    fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                    lineHeight1: 1.2199999999999998,
                    letterSpacing1: 0,
                    fontFamily2: 'POPPINS:MEDIUM:NORMAL',
                    lineHeight2: 1.2,
                    letterSpacing2: 0,
                    align: 'center',
                    lineSpacing1: 0,
                    lineSpacing2: 0
                }
            },
            'GLB0tFs5WD-nonprofit-branded-outro': {
                values: {
                    alpha: 1,
                    text1: 'PHOENIX YOGA STUDIO',
                    textColor1: '#FFFFFF',
                    fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                    shadow: true,
                    lineHeight1: 1.4,
                    letterSpacing1: 0,
                    cropX: 0,
                    cropY: 0,
                    cropWidth: 100,
                    cropHeight: 100,
                    imageId: 'placeholder'
                }
            },
            'ByolJSU0G-travel-royale': {
                values: {
                    alpha: 1,
                    text1: 'with Amanda',
                    text2: 'MORNING YOGA FLOW',
                    color1: '#FFC941',
                    textColor1: '#FFC941',
                    textColor2: '#FFF',
                    fontFamily1: 'OREGANO:NORMAL:NORMAL',
                    fontFamily2: 'CABIN:MEDIUM:NORMAL',
                    shadow: true,
                    lineHeight1: 0.8066666666666668,
                    lineHeight2: 1.2,
                    letterSpacing1: 0,
                    letterSpacing2: 0
                }
            },
            'rJplkHIAz-fashionistas-dream': {
                values: {
                    alpha: 0.70234375,
                    text1: 'BEGINNER',
                    text2: 'Cardio Workout',
                    color1: '#fff',
                    color2: '#004E7F',
                    textColor1: '#ED474D',
                    textColor2: '#FFF',
                    fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                    fontFamily2: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                    shadow: true,
                    lineHeight1: 1.2,
                    lineHeight2: 1.2,
                    letterSpacing1: 0,
                    letterSpacing2: 0
                }
            },
            'H1tfJBLCM-vintage-wedding': {
                values: {
                    textColor1: '#FFADE3',
                    alpha: 1,
                    text1: 'Dancing Heart Studio',
                    fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                    align: 'center',
                    shadow: true,
                    lineHeight: 1.42,
                    letterSpacing: 33.333333333333314
                }
            },
            'rk2D1BI0z-fitness-linear': {
                values: {
                    color1: '#FF5C5C',
                    textColor1: '#FFFFFF',
                    textColor2: '#FFFFFF',
                    alpha: 1,
                    shadow: true,
                    text1: 'CARDIO DANCE\nCELEBS LOVE',
                    text2: 'POPSUGAR FITNESS',
                    fontFamily1: 'EDO:NORMAL:NORMAL',
                    fontFamily2: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
                    lineHeight1: 1.2,
                    lineHeight2: 1.5,
                    letterSpacing1: 0,
                    letterSpacing2: 0
                }
            }
        },
        defaultTemplateId: '81uPP2ZvS-virtual-fitness-class',
        isRequired: true,
        replaceType: 'local'
    },
    secondaryText: {
        key: 'secondaryText',
        label: 'Steps and Descriptions',
        desc: '',
        templates: {
            'X6GYtjnqU0-work-out-challenge': {
                values: {
                    alpha: 1,
                    color1: '#4DAA18',
                    color2: '#FFF',
                    color3: '#FF0',
                    textColor1: '#000',
                    textColor2: '#FFFFFF',
                    text1: 'UP NEXT',
                    text2: 'STEP IN & OUT',
                    fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                    lineHeight1: 1.2,
                    letterSpacing1: 0,
                    fontFamily2: 'POPPINS:EXTRA_BOLD:NORMAL',
                    lineHeight2: 1.2,
                    letterSpacing2: 0,
                    lineSpacing1: 0,
                    lineSpacing2: 0,
                    align: 'left'
                }
            },
            'HklvkBL0f-logo-lower-third': {
                values: {
                    color1: '#f2d147',
                    alpha: 1,
                    text1: 'WARRIOR STRETCH',
                    textColor1: '#FFF',
                    fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                    text2: 'ADVANCED: Hold for 45 secs ',
                    textColor2: '#FFF',
                    fontFamily2: 'WELLFLEET:NORMAL:NORMAL',
                    shadow: false,
                    lineHeight1: 1.5,
                    letterSpacing1: 0,
                    lineHeight2: 1,
                    letterSpacing2: 0,
                    cropX: 0,
                    cropY: 0,
                    cropWidth: 100,
                    cropHeight: 100,
                    imageId: 'placeholder'
                }
            },
            'CRzZDRomd-yoga-challenge': {
                values: {
                    alpha: 1,
                    color1: '#FFFFFF',
                    text1: 'Full Body Stretch',
                    textColor1: 'rgb(255, 255, 255)',
                    fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                    lineHeight1: 1.2,
                    letterSpacing1: 0,
                    text2: '20 min | Yoga for \nstress & anxiety relief',
                    textColor2: 'rgb(255, 144, 174)',
                    fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
                    lineHeight2: 1.2333333333333334,
                    letterSpacing2: 0,
                    shadow: true,
                    lineSpacing1: 0,
                    lineSpacing2: 0
                }
            },
            'mzt3ccsznP-fitness-challenge': {
                values: {
                    alpha: 1,
                    text1: 'MOUNTAIN CLIMBERS',
                    text2: '45 SECS EXERCISE | 15 SECS REST',
                    color1: '#C8EAF4',
                    color2: '#004E7F',
                    textColor1: '#004E7F',
                    textColor2: '#FFFFFF',
                    fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                    fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                    shadow: true,
                    lineHeight1: 1.2466666666666666,
                    lineHeight2: 1.2,
                    letterSpacing1: 0,
                    letterSpacing2: 0
                }
            },
            'rkWHb1S8CG-fitness-rep': {
                values: {
                    color1: '#C8FF09',
                    textColor1: '#FFFFFF$$$[38,{"color":"hsl(73.39999999999998, 100%, 51.7%)","start":26,"end":37}]',
                    text1: 'SIDE CRUNCH\nW/ LEG RAISE\n(45 SECONDS)',
                    alpha: 1,
                    fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            '3QZbp8qL54-workout-preview-list': {
                values: {
                    textColor1: 'rgb(255, 255, 255)',
                    textColor2: '#0c0c0c',
                    color1: '#FA8334',
                    color2: '#ffffff',
                    alpha: 0.6999999999999998,
                    text1: 'NEXT REP GOAL',
                    text2: '           LEVEL 1: 10 REPS           \n           LEVEL 2: 50 REPS           \n           LEVEL 3: 20 REPS           ',
                    fontFamily1: 'ALFA_SLAB_ONE:NORMAL:NORMAL',
                    fontFamily2: 'ARCHIVO_NARROW:BOLD:NORMAL',
                    align: 'center',
                    shadow: false,
                    lineHeight1: 1.4066666666666667,
                    letterSpacing1: 46.666666666666686,
                    lineHeight2: 1.3,
                    letterSpacing2: 0
                }
            }
        },
        defaultTemplateId: 'X6GYtjnqU0-work-out-challenge',
        isRequired: true,
        replaceType: 'local'
    },
    paragraph: {
        key: 'paragraph',
        label: 'Paragraphs',
        desc: '',
        templates: {
            'rkhb1SLRG-travel-insider-caption': {
                values: {
                    textColor1: '#fff',
                    alpha: 1,
                    text1: "This is episode 4 of the Get Toned Challenge! It's a 30 minute full body workout, and you can do this with or without equipment!",
                    fontFamily1: 'OPEN_SANS:SEMI_BOLD:NORMAL',
                    align: 'center',
                    shadow: true,
                    lineHeight: 1.15390625,
                    letterSpacing: -30.20833333333337
                }
            },
            '8y5tOoome-event-experience-caption': {
                values: {
                    color1: 'rgb(255, 249, 82)',
                    textColor1: '#000000$$$[122,{"color":"rgb(0, 0, 0)","start":33,"end":35}]',
                    alpha: 0.9005208333333333,
                    align: 'center',
                    text1: 'Please consult a health professional before starting any workout. Especially if you have any underlying health conditions.',
                    fontFamily1: 'PORT_LLIGAT_SLAB:NORMAL:NORMAL',
                    lineHeight: 1.2091145833333332,
                    letterSpacing: 0,
                    lineSpacing: 0
                }
            },
            'rJRD1HICf-cnn-caption': {
                values: {
                    alpha: 1,
                    text1: 'Warm Up & Cool down\n\n- Shortened but built in. \n- Add extra time for both as needed.',
                    color1: '#CB0714',
                    textColor1: '#FFF',
                    fontFamily1: 'CHIVO:NORMAL:NORMAL',
                    lineHeight1: 1.18,
                    letterSpacing1: 0,
                    shadow: true,
                    align: 'right',
                    lineSpacing1: 0
                }
            },
            'BJy8JH8RG-bbc-social': {
                values: {
                    alpha: 1,
                    align: 'center',
                    color1: '#CF0914',
                    textColor1: '#FFF',
                    text1: 'Swap stretching for a dynamic warmup. \nIt’s a good idea to move through about five to ten minutes.\n ',
                    fontFamily1: 'ANONYMOUS_PRO:NORMAL:NORMAL',
                    lineHeight1: 1.2
                }
            },
            'HyRSUR9g7-line-by-line-one': {
                values: {
                    text1: 'This episode is sponsored by FitnessShark.\nUse code FIT50 to shop now and \nreceive 50% at checkout.',
                    alpha: 1,
                    color1: '#F3BC28',
                    fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                    letterSpacing: 0,
                    lineHeight: 1.5513020833333335,
                    lineSpacing: 23.190184049079754,
                    shadow: false,
                    textColor1: '#000000'
                }
            },
            'HyfE1rIRz-insider-social-media': {
                values: {
                    align: 'center',
                    alpha: 0.8,
                    color1: '#00ABF1',
                    fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                    letterSpacing: 0,
                    lineHeight: 1.42,
                    text1: 'Take a 30 second break\nHit PAUSE to take a longer break',
                    textColor1: '#FFFFFF'
                }
            }
        },
        defaultTemplateId: 'rkhb1SLRG-travel-insider-caption',
        isRequired: true,
        replaceType: 'local'
    },
    stepTimers: {
        key: 'stepTimers',
        label: 'Timers',
        desc: '',
        templates: {
            'DcJn2SvgL-timed-workout-template': {
                values: {
                    alpha: 0.85,
                    text1: 'JUMPING JACKS',
                    textColor1: 'rgb(255, 255, 255)',
                    color1: '#FFFFFF',
                    color2: '#0A6986',
                    color3: '#FD7669',
                    fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                    isAscendingTimer: false,
                    shadow: false,
                    timeFormat: 'SECS',
                    letterSpacing: 0,
                    lineHeight: 1.2
                }
            },
            'usyHTVlb98-workout-progress-template': {
                values: {
                    alpha: 0.85,
                    text1: 'HIGH KNEES',
                    textColor1: 'rgb(255, 196, 12)',
                    color1: '#FFC40C',
                    color2: '#3B8EA5',
                    fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                    isAscendingTimer: false,
                    shadow: false,
                    timeFormat: 'SECS',
                    letterSpacing: 0,
                    lineHeight: 1.2
                }
            },
            'KCBG5OhpKl-bold-timer-template': {
                values: {
                    alpha: 0.85,
                    text1: 'LUNGES',
                    textColor1: 'hsl(133.3, 61.9%, 32.4%)',
                    color1: '#FFFFFF',
                    color2: '#168119',
                    fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                    isAscendingTimer: false,
                    shadow: false,
                    timeFormat: 'MINS',
                    letterSpacing: 0,
                    lineHeight: 1.2
                }
            },
            'uZWVio6YCz-power-boost-timer': {
                values: {
                    alpha: 1,
                    color1: 'hsl(0, 100%, 73.8%)',
                    color2: 'rgb(255, 255, 255)',
                    fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                    isAscendingTimer: true,
                    timeFormat: 'SECS',
                    shadow: true
                }
            }
        },
        defaultTemplateId: 'DcJn2SvgL-timed-workout-template',
        isRequired: true,
        replaceType: 'local'
    },
    restTimers: {
        key: 'restTimers',
        label: 'Rest Timers',
        desc: '',
        templates: {
            '3MpNR8ZrU-workout-counter': {
                values: {
                    alpha: 1,
                    color1: 'rgb(255, 255, 255)',
                    color2: 'rgb(82, 113, 255)',
                    fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                    isAscendingTimer: false,
                    timeFormat: 'SECS',
                    shadow: true
                }
            },
            'OSDdRUfyz-workout-counter-template': {
                values: {
                    alpha: 0.85,
                    text1: 'SIDE PLANK',
                    textColor1: '#FFFFFF',
                    color1: '#FFFFFF',
                    color2: '#7ABBA6',
                    color3: '#E2782E',
                    fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                    isAscendingTimer: false,
                    shadow: false,
                    timeFormat: 'SECS',
                    letterSpacing: 0,
                    lineHeight: 1.2
                }
            },
            'vHDeoEX1p-count-it-up-timer': {
                values: {
                    alpha: 1,
                    color1: 'rgb(255, 255, 255)',
                    color2: 'hsl(14.600000000000023, 100%, 68.5%)',
                    fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                    isAscendingTimer: true,
                    timeFormat: 'SECS',
                    shadow: false
                }
            },
            'Ef1qyyqbb-rhythm-countup-timer': {
                values: {
                    alpha: 1,
                    color1: 'rgb(76, 233, 192)',
                    textColor1: 'rgb(76, 233, 192)',
                    color2: 'rgb(0, 0, 0)',
                    fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                    isAscendingTimer: true,
                    timeFormat: 'SECS',
                    shadow: true
                }
            }
        },
        defaultTemplateId: '3MpNR8ZrU-workout-counter',
        isRequired: true,
        replaceType: 'local'
    },
    facebook: {
        key: 'facebook',
        label: 'Facebook',
        desc: '',
        templates: {
            'Byt7kSLRG-facebook-sharp': {
                values: {
                    alpha: 1,
                    text1: 'Athleanx',
                    color1: '#3b5998',
                    color2: '#fff',
                    fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                    fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight1: 0.8,
                    lineHeight2: 0.8,
                    letterSpacing1: 0,
                    letterSpacing2: 0,
                    text2: 'LIKE ME ON'
                }
            },
            'B1smJHU0M-facebook-monochrome': {
                values: {
                    alpha: 0.3,
                    text1: 'ATHLEANX',
                    color1: '#fff',
                    color2: '#000',
                    textColor1: '#fff',
                    fontFamily1: 'ALADIN:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'H1qQyrL0G-facebook-block': {
                values: {
                    alpha: 1,
                    text1: 'Jeff Cavaliere',
                    color1: '#3b5998',
                    color2: '#FFF',
                    textColor1: '#3b5998',
                    fontFamily1: 'EDO:NORMAL:NORMAL',
                    shadow: false,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'B1h7yrUAM-facebook-logo': {
                values: {
                    textColor1: '#3B5998',
                    text1: 'ATHLEANX',
                    alpha: 1,
                    fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            }
        },
        defaultTemplateId: 'Byt7kSLRG-facebook-sharp',
        isRequired: true,
        replaceType: 'global'
    },
    instagram: {
        key: 'instagram',
        label: 'Instagram',
        desc: '',
        templates: {
            'S1CMJSUCM-instagram-sharp': {
                values: {
                    alpha: 1,
                    text1: 'ATHLEAN-X',
                    color1: '#b93894',
                    color2: '#fff',
                    fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                    fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight1: 0.8,
                    lineHeight2: 0.8,
                    letterSpacing1: 0,
                    letterSpacing2: 0,
                    text2: 'FOLLOW ME ON'
                }
            },
            'ry2MJHIAG-instagram-monochrome': {
                values: {
                    alpha: 0.3,
                    text1: 'ATHLEANX',
                    color1: '#fff',
                    color2: '#000',
                    textColor1: '#fff',
                    fontFamily1: 'ALADIN:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'B1ym1HL0M-instagram-block': {
                values: {
                    alpha: 1,
                    text1: 'athleanx',
                    color1: '#b93894',
                    color2: '#FFFFFF',
                    textColor1: '#b93894',
                    fontFamily1: 'EDO:NORMAL:NORMAL',
                    shadow: false,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'HyeQkBUCf-instagram-logo': {
                values: {
                    textColor1: '#BC2A8D',
                    text1: 'ATHLEANX',
                    alpha: 1,
                    fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'H1mDyHICG-instagram-edge': {
                values: {
                    color1: '#267fc6',
                    alpha: 1,
                    text1: '@ATHLEANX',
                    textColor1: '#FFF',
                    fontFamily1: 'ALEGREYA:BOLD:NORMAL',
                    lineHeight1: 1.2,
                    letterSpacing1: 0,
                    text2: 'Follow Us',
                    textColor2: '#FFF',
                    fontFamily2: 'ALEGREYA:BOLD:NORMAL',
                    lineHeight2: 1.2,
                    letterSpacing2: 0,
                    shadow: false
                }
            }
        },
        defaultTemplateId: 'S1CMJSUCM-instagram-sharp',
        isRequired: true,
        replaceType: 'global'
    },
    youTube: {
        key: 'youTube',
        label: 'YouTube',
        desc: '',
        templates: {
            'ByobkHL0M-youtube-sharp': {
                values: {
                    alpha: 1,
                    text1: 'ATHLEAN-X',
                    color1: '#bb0000',
                    color2: '#fff',
                    fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                    fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight1: 0.8,
                    lineHeight2: 0.8,
                    letterSpacing1: 0,
                    letterSpacing2: 0,
                    text2: 'SUBSCRIBE'
                }
            },
            'r1kfyBIRM-youtube-monochrome': {
                values: {
                    alpha: 0.3,
                    text1: 'ATHLEAN-X',
                    color1: '#fff',
                    color2: '#000000',
                    textColor1: '#fff',
                    fontFamily1: 'ALADIN:NORMAL:NORMAL',
                    shadow: true,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'S1xz1H80G-youtube-block': {
                values: {
                    alpha: 1,
                    text1: 'Jeff Cavaliere',
                    color1: '#bb0000',
                    color2: '#FFF',
                    textColor1: '#bb0000',
                    fontFamily1: 'EDO:NORMAL:NORMAL',
                    shadow: false,
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            },
            'ryab1HLRz-youtube-logo': {
                values: {
                    textColor1: '#F8140D',
                    text1: ' ATHLEAN-X',
                    alpha: 1,
                    fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                    lineHeight: 1.2,
                    letterSpacing: 0
                }
            }
        },
        defaultTemplateId: 'ByobkHL0M-youtube-sharp',
        isRequired: true,
        replaceType: 'global'
    },
    progressBar: {
        key: 'progressBar',
        label: 'Progress Bars',
        desc: '',
        templates: {
            '5HfnPL2R9o-vertical-progress-bar': {
                values: {
                    alpha: 0.85,
                    color1: '#5390D9',
                    isAscendingTimer: false,
                    roundEdges: false
                }
            },
            'FJL78OcKA-horizontal-progress-bar': {
                values: {
                    alpha: 0.85,
                    color1: '#F1AD88',
                    isAscendingTimer: false,
                    roundEdges: false
                }
            },
            '4CnARRMB3-vertical-rounded-progress-bar': {
                values: {
                    alpha: 0.85,
                    color1: '#FF4D6D',
                    isAscendingTimer: false,
                    roundEdges: true
                }
            },
            'HgIuhIke6m-horizontal-rounded-progress-bar': {
                values: {
                    alpha: 0.8,
                    color1: '#FF2E2E',
                    isAscendingTimer: false,
                    roundEdges: true
                }
            }
        },
        defaultTemplateId: '5HfnPL2R9o-vertical-progress-bar',
        isRequired: false,
        replaceType: 'global'
    },
    calorieMeter: {
        key: 'calorieMeter',
        label: 'Calorie Meter',
        desc: '',
        templates: {
            '0SnABHmB8-calorie-meter': {
                values: {
                    alpha: 0.85
                }
            },
            'a8m98xKZp-calorie-meter': {
                values: {
                    alpha: 1
                }
            }
        },
        defaultTemplateId: '0SnABHmB8-calorie-meter',
        isRequired: false,
        replaceType: 'global'
    },
    image: {
        key: 'image',
        label: '',
        desc: '',
        templates: {
            'defId-userBitmap-typito-square-logo': {
                values: {
                    alpha: 1,
                    crop: 'none',
                    imageId: 'typito-square-logo',
                    shadow: false
                }
            }
        },
        defaultTemplateId: null,
        isRequired: false,
        replaceType: 'local'
    },
    icon: {
        key: 'icon',
        label: '',
        desc: '',
        templates: {
            'defId-userAssetsvg-iconscout-fitness-promotion-icon': {
                values: {
                    alpha: 1,
                    shadow: false
                }
            }
        },
        defaultTemplateId: null,
        isRequired: false,
        replaceType: 'local'
    }
};

var PossibleFormatsForFitnessTemplates = (0, _keymirror2.default)({
    '16:9': null,
    '1:1': null,
    '9:16': null,
    '4:5': null
});

var FitnessTemplateConfigsByFormat = {
    'HklvkBL0f-logo-lower-third': {
        '16:9': {
            values: {
                color1: '#f2d147',
                alpha: 1,
                text1: 'WARRIOR STRETCH',
                textColor1: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                text2: 'ADVANCED: Hold for 45 secs ',
                textColor2: '#FFF',
                fontFamily2: 'WELLFLEET:NORMAL:NORMAL',
                shadow: false,
                lineHeight1: 1.5,
                letterSpacing1: 0,
                lineHeight2: 1,
                letterSpacing2: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 154.7288917667796,
                width: 1059.684514479443,
                transform: 'matrix(0.6189155670671185, 0, 0, 0.6189155670671185, 0, 0)',
                x: 139.9206219367513,
                y: 817.2711082332204
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                color1: '#f2d147',
                alpha: 1,
                text1: 'WARRIOR STRETCH',
                textColor1: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                text2: 'ADVANCED: Hold for 45 secs ',
                textColor2: '#FFF',
                fontFamily2: 'WELLFLEET:NORMAL:NORMAL',
                shadow: false,
                lineHeight1: 1.5,
                letterSpacing1: 0,
                lineHeight2: 1,
                letterSpacing2: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 172.99173603603438,
                width: 890.2896142876308,
                transform: 'matrix(0.6919669441441375, 0, 0, 0.6919669441441375, 0, 0)',
                x: 74.96532386157334,
                y: 1555.0082639639656
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                color1: '#f2d147',
                alpha: 1,
                text1: 'WARRIOR STRETCH',
                textColor1: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                text2: 'ADVANCED: Hold for 45 secs ',
                textColor2: '#FFF',
                fontFamily2: 'WELLFLEET:NORMAL:NORMAL',
                shadow: false,
                lineHeight1: 1.5,
                letterSpacing1: 0,
                lineHeight2: 1,
                letterSpacing2: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 103.9488044675565,
                width: 520.5601147512535,
                transform: 'matrix(0.415795217870226, 0, 0, 0.415795217870226, 0, 0)',
                x: 78.933287645977,
                y: 887.3101814119625
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                color1: '#f2d147',
                alpha: 1,
                text1: 'WARRIOR STRETCH',
                textColor1: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                text2: 'ADVANCED: Hold for 45 secs ',
                textColor2: '#FFF',
                fontFamily2: 'WELLFLEET:NORMAL:NORMAL',
                shadow: false,
                lineHeight1: 1.5,
                letterSpacing1: 0,
                lineHeight2: 1,
                letterSpacing2: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 184.79787460898933,
                width: 957.2816439860491,
                transform: 'matrix(0.7391914984359573, 0, 0, 0.7391914984359573, 0, 0)',
                x: 121.26947341712624,
                y: 1571.0372542630607
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    '81uPP2ZvS-virtual-fitness-class': {
        '16:9': {
            values: {
                alpha: 1,
                color1: '#F30000',
                color2: '#F30000',
                textColor1: 'rgb(255, 255, 255)',
                textColor2: 'rgb(255, 255, 255)',
                text1: '30 MIN',
                text2: 'HIIT WORKOUT',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                lineHeight1: 1.2199999999999998,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:MEDIUM:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                align: 'center',
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 322.34761791613334,
                width: 942.6125896675078,
                transform: 'matrix(1.9006345395998432, 0, 0, 1.9006345395998432, 0, 0)',
                x: 488.6937051662461,
                y: 217.65238208386666,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: '#F30000',
                color2: '#F30000',
                textColor1: 'rgb(255, 255, 255)',
                textColor2: 'rgb(255, 255, 255)',
                text1: '30 MIN',
                text2: 'HIIT WORKOUT',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                lineHeight1: 1.2199999999999998,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:MEDIUM:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                align: 'center',
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 308.17414197117364,
                width: 1080,
                transform: 'matrix(1.8170645163394674, 0, 0, 1.8170645163394674, 0, 0)',
                x: 0,
                y: 487.529823274381,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: '#F30000',
                color2: '#F30000',
                textColor1: 'rgb(255, 255, 255)',
                textColor2: 'rgb(255, 255, 255)',
                text1: '30 MIN',
                text2: 'HIIT WORKOUT',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                lineHeight1: 1.2199999999999998,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:MEDIUM:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                align: 'center',
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 232.83142207057745,
                width: 680.8483063492531,
                transform: 'matrix(1.3728267810765182, 0, 0, 1.3728267810765182, 0, 0)',
                x: 199.57584682537345,
                y: 233.8198957671873,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: '#F30000',
                color2: '#F30000',
                textColor1: 'rgb(255, 255, 255)',
                textColor2: 'rgb(255, 255, 255)',
                text1: '30 MIN',
                text2: 'HIIT WORKOUT',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                lineHeight1: 1.2199999999999998,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:MEDIUM:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                align: 'center',
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 397.14135382084623,
                width: 1510.5771439640566,
                transform: 'matrix(2.3416353409248014, 0, 0, 2.3416353409248014, 0, 0)',
                x: 12.711428017971684,
                y: 423.1418799751578,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'rJplkHIAz-fashionistas-dream': {
        '16:9': {
            values: {
                alpha: 0.70234375,
                text1: 'BEGINNER',
                text2: 'Cardio Workout',
                color1: '#fff',
                color2: '#004E7F',
                textColor1: '#ED474D',
                textColor2: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                fontFamily2: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 312.1773722179839,
                width: 970.5840771621283,
                transform: 'matrix(1.1149191864927996, 0, 0, 1.1149191864927996, 0, 0)',
                x: 474.70796141893584,
                y: 174.92968928543291
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.70234375,
                text1: 'BEGINNER',
                text2: 'Cardio Workout',
                color1: '#fff',
                color2: '#004E7F',
                textColor1: '#ED474D',
                textColor2: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                fontFamily2: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 286.1232465269216,
                width: 892.2925779361251,
                transform: 'matrix(1.0218687375961486, 0, 0, 1.0218687375961486, 0, 0)',
                x: 93.85371103193745,
                y: 498.55527099650703,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.70234375,
                text1: 'BEGINNER',
                text2: 'Cardio Workout',
                color1: '#fff',
                color2: '#004E7F',
                textColor1: '#ED474D',
                textColor2: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                fontFamily2: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 216.91255930762333,
                width: 696.9604573896016,
                transform: 'matrix(0.7746877118129405, 0, 0, 0.7746877118129405, 0, 0)',
                x: 191.51977130519919,
                y: 235.37622035113816,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.70234375,
                text1: 'BEGINNER',
                text2: 'Cardio Workout',
                color1: '#fff',
                color2: '#004E7F',
                textColor1: '#ED474D',
                textColor2: '#FFF',
                fontFamily1: 'POPPINS:MEDIUM:NORMAL',
                fontFamily2: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 388.3304049206389,
                width: 1243.4109850841155,
                transform: 'matrix(1.3868943032879961, 0, 0, 1.3868943032879961, 0, 0)',
                x: 146.29450745794225,
                y: 418.88904299803716,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'ByolJSU0G-travel-royale': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'with Amanda',
                text2: 'MORNING YOGA FLOW',
                color1: '#FFC941',
                textColor1: '#FFC941',
                textColor2: '#FFF',
                fontFamily1: 'OREGANO:NORMAL:NORMAL',
                fontFamily2: 'CABIN:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 0.8066666666666668,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 435.0148084138451,
                width: 1490.9698587094804,
                transform: 'matrix(1.2769514924085472, 0, 0, 1.2769514924085472, 0, 0)',
                x: 214.5150706452598,
                y: 145.36275524638043
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'with Amanda',
                text2: 'MORNING YOGA FLOW',
                color1: '#FFC941',
                textColor1: '#FFC941',
                textColor2: '#FFF',
                fontFamily1: 'OREGANO:NORMAL:NORMAL',
                fontFamily2: 'CABIN:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 0.8066666666666668,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 322.0889356672879,
                width: 1021.2293511644565,
                transform: 'matrix(0.9454665430546612, 0, 0, 0.9454665430546612, 0, 0)',
                x: 29.385324417771756,
                y: 432.50710465075446,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'with Amanda',
                text2: 'MORNING YOGA FLOW',
                color1: '#FFC941',
                textColor1: '#FFC941',
                textColor2: '#FFF',
                fontFamily1: 'OREGANO:NORMAL:NORMAL',
                fontFamily2: 'CABIN:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 0.8066666666666668,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 239.99521071238118,
                width: 792.4745836763707,
                transform: 'matrix(0.7044869198993576, 0, 0, 0.7044869198993576, 0, 0)',
                x: 143.76270816181466,
                y: 300.0047892876188,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'with Amanda',
                text2: 'MORNING YOGA FLOW',
                color1: '#FFC941',
                textColor1: '#FFC941',
                textColor2: '#FFF',
                fontFamily1: 'OREGANO:NORMAL:NORMAL',
                fontFamily2: 'CABIN:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 0.8066666666666668,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 400.9328838593823,
                width: 1408.1174487677986,
                transform: 'matrix(1.1769067040882062, 0, 0, 1.1769067040882062, 0, 0)',
                x: 63.94127561610071,
                y: 559.0671161406177,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'rkhb1SLRG-travel-insider-caption': {
        '16:9': {
            values: {
                textColor1: '#fff',
                alpha: 1,
                text1: "This is episode 4 of the Get Toned Challenge! It's a 30 minute full body workout, and you can do this with or without equipment!",
                fontFamily1: 'OPEN_SANS:SEMI_BOLD:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.15390625,
                letterSpacing: -30.20833333333337
            },
            space: {
                height: 193.5805737810827,
                width: 1603.8753058666239,
                transform: 'matrix(0.7456048580148525, 0, 0, 0.7456048580148525, 0, 0)',
                x: 158.06234706668806,
                y: 586.0243766669207
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                textColor1: '#fff',
                alpha: 1,
                text1: "This is episode 4 of the Get Toned Challenge! It's a 30 minute full body workout, and you can do this with or without equipment!",
                fontFamily1: 'OPEN_SANS:SEMI_BOLD:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.15390625,
                letterSpacing: -30.20833333333337
            },
            space: {
                height: 272.074121144026,
                width: 979.3081484316306,
                transform: 'matrix(0.7859509705808018, 0, 0, 0.7859509705808018, 0, 0)',
                x: 50.345925784184715,
                y: 1059.5487074547655
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                textColor1: '#fff',
                alpha: 1,
                text1: "This is episode 4 of the Get Toned Challenge! It's a 30 minute full body workout, and you can do this with or without equipment!",
                fontFamily1: 'OPEN_SANS:SEMI_BOLD:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.15390625,
                letterSpacing: -30.20833333333337
            },
            space: {
                height: 126.41116377000832,
                width: 853.5856257704896,
                transform: 'matrix(0.486891716318696, 0, 0, 0.486891716318696, 0, 0)',
                x: 113.20718711475519,
                y: 532.0489205152403
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                textColor1: '#fff',
                alpha: 1,
                text1: "This is episode 4 of the Get Toned Challenge! It's a 30 minute full body workout, and you can do this with or without equipment!",
                fontFamily1: 'OPEN_SANS:SEMI_BOLD:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.15390625,
                letterSpacing: -30.20833333333337
            },
            space: {
                height: 205.93302274563388,
                width: 1390.553356560787,
                transform: 'matrix(0.7931821834481648, 0, 0, 0.7931821834481648, 0, 0)',
                x: 72.72332171960647,
                y: 1170.5957053959976
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'BJy8JH8RG-bbc-social': {
        '16:9': {
            values: {
                alpha: 1,
                align: 'center',
                color1: '#CF0914',
                textColor1: '#FFF',
                text1: 'Swap stretching for a dynamic warmup. \nIt’s a good idea to move through about five to ten minutes.\n ',
                fontFamily1: 'ANONYMOUS_PRO:NORMAL:NORMAL',
                lineHeight1: 1.2,
                shadow: false
            },
            space: {
                height: 237.8119210979183,
                width: 1299.4572866523188,
                transform: 'matrix(0.6193018778591622, 0, 0, 0.6193018778591622, 0, 0)',
                x: 310.2713566738406,
                y: 598.1558466211087
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                align: 'center',
                color1: '#CF0914',
                textColor1: '#FFF',
                text1: 'Swap stretching for a dynamic warmup. \nIt’s a good idea to move through about five to ten minutes.\n ',
                fontFamily1: 'ANONYMOUS_PRO:NORMAL:NORMAL',
                lineHeight1: 1.2,
                shadow: false
            },
            space: {
                height: 432.8924181873361,
                width: 945.2115820434317,
                transform: 'matrix(0.7515493371307919, 0, 0, 0.7515493371307919, 0, 0)',
                x: 67.39420897828415,
                y: 1058.824413387492
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                align: 'center',
                color1: '#CF0914',
                textColor1: '#FFF',
                text1: 'Swap stretching for a dynamic warmup. \nIt’s a good idea to move through about five to ten minutes.\n ',
                fontFamily1: 'ANONYMOUS_PRO:NORMAL:NORMAL',
                lineHeight1: 1.2,
                shadow: false
            },
            space: {
                height: 178.72950421554913,
                width: 829.8276496207532,
                transform: 'matrix(0.46544141722799254, 0, 0, 0.46544141722799254, 0, 0)',
                x: 125.08617518962342,
                y: 526.1264492570012
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                align: 'center',
                color1: '#CF0914',
                textColor1: '#FFF',
                text1: 'Swap stretching for a dynamic warmup. \nIt’s a good idea to move through about five to ten minutes.\n ',
                fontFamily1: 'ANONYMOUS_PRO:NORMAL:NORMAL',
                lineHeight1: 1.2,
                shadow: false
            },
            space: {
                height: 294.9280198285438,
                width: 1369.3286207881258,
                transform: 'matrix(0.7680417183034995, 0, 0, 0.7680417183034995, 0, 0)',
                x: 83.33568960593709,
                y: 1146.667471330661
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'usyHTVlb98-workout-progress-template': {
        '16:9': {
            values: {
                alpha: 0.85,
                text1: 'HIGH KNEES',
                textColor1: 'rgb(255, 196, 12)',
                color1: '#FFC40C',
                color2: '#3B8EA5',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 191.68760764383495,
                width: 538.5842365351195,
                transform: 'matrix(0.8337783970235622, 0, 0, 0.8337783970235622, 0, 0)',
                x: 1279.802876958402,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.85,
                text1: 'HIGH KNEES',
                textColor1: 'rgb(255, 196, 12)',
                color1: '#FFC40C',
                color2: '#3B8EA5',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 179.10296460282376,
                width: 503.2251935191323,
                transform: 'matrix(0.7790393159174731, 0, 0, 0.7790393159174731, 0, 0)',
                x: 540,
                y: 60.21977869565557
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.85,
                text1: 'HIGH KNEES',
                textColor1: 'rgb(255, 196, 12)',
                color1: '#FFC40C',
                color2: '#3B8EA5',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 115.67096717909284,
                width: 325.0004541930764,
                transform: 'matrix(0.5031308741457441, 0, 0, 0.5031308741457441, 0, 0)',
                x: 704.514613223505,
                y: 46.025768579203245
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.85,
                text1: 'HIGH KNEES',
                textColor1: 'rgb(255, 196, 12)',
                color1: '#FFC40C',
                color2: '#3B8EA5',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 187.7399139446489,
                width: 527.4924105001201,
                transform: 'matrix(0.8166072206240781, 0, 0, 0.8166072206240781, 0, 0)',
                x: 934.0997067448681,
                y: 93.03803285485526
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'KCBG5OhpKl-bold-timer-template': {
        '16:9': {
            values: {
                alpha: 0.85,
                text1: 'LUNGES',
                textColor1: 'hsl(133.3, 61.9%, 32.4%)',
                color1: '#FFFFFF',
                color2: '#168119',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: false,
                timeFormat: 'MINS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 176.67062746548973,
                width: 580.6530140628591,
                transform: 'matrix(0.7684594449267755, 0, 0, 0.7684594449267755, 0, 0)',
                x: 1233.2877149229407,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.85,
                text1: 'LUNGES',
                textColor1: 'hsl(133.3, 61.9%, 32.4%)',
                color1: '#FFFFFF',
                color2: '#168119',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: false,
                timeFormat: 'MINS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 154.8890754166923,
                width: 523.4226846425062,
                transform: 'matrix(0.6737168177159668, 0, 0, 0.6737168177159668, 0, 0)',
                x: 482.0689655172414,
                y: 80.23658621966001
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.85,
                text1: 'LUNGES',
                textColor1: 'hsl(133.3, 61.9%, 32.4%)',
                color1: '#FFFFFF',
                color2: '#168119',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: false,
                timeFormat: 'MINS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 114.59566537246377,
                width: 387.2575948709229,
                transform: 'matrix(0.498453662991262, 0, 0, 0.498453662991262, 0, 0)',
                x: 646.0997067448681,
                y: 47.101070385832315
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.85,
                text1: 'LUNGES',
                textColor1: 'hsl(133.3, 61.9%, 32.4%)',
                color1: '#FFFFFF',
                color2: '#168119',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: false,
                timeFormat: 'MINS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 194.04898569834808,
                width: 655.7572945227777,
                transform: 'matrix(0.8440496192129319, 0, 0, 0.8440496192129319, 0, 0)',
                x: 768,
                y: 91.37217347420865
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    '3MpNR8ZrU-workout-counter': {
        '16:9': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'rgb(82, 113, 255)',
                textColor1: '#fff',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: false,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 251.08539062980995,
                width: 251.08539062980998,
                transform: 'matrix(0.8369513020993665, 0, 0, 0.8369513020993665, 0, 0)',
                x: 1544.206735209013,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'rgb(82, 113, 255)',
                textColor1: '#fff',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: false,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 238.48849841025427,
                width: 238.48849841025435,
                transform: 'matrix(0.7949616613675142, 0, 0, 0.7949616613675142, 0, 0)',
                x: 776.8639133603997,
                y: 84.13506113970048
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'rgb(82, 113, 255)',
                textColor1: '#fff',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: false,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 165.57219414887155,
                width: 165.57219414887157,
                transform: 'matrix(0.5519073138295718, 0, 0, 0.5519073138295718, 0, 0)',
                x: 856.1186408353719,
                y: 90.69872763342696
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'rgb(82, 113, 255)',
                textColor1: '#fff',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: false,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 294.3505673757716,
                width: 294.3505673757717,
                transform: 'matrix(0.9811685579192387, 0, 0, 0.9811685579192387, 0, 0)',
                x: 1143.26837520959,
                y: 118.62050518373508
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'OSDdRUfyz-workout-counter-template': {
        '16:9': {
            values: {
                alpha: 0.85,
                text1: 'SIDE PLANK',
                textColor1: '#FFFFFF',
                color1: '#FFFFFF',
                color2: '#7ABBA6',
                color3: '#E2782E',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 159.82420009306557,
                width: 633.8327251554056,
                transform: 'matrix(0.7103297781914025, 0, 0, 0.7103297781914025, 0, 0)',
                x: 1169.7957947974285,
                y: 108,
                rotateDeg: 0
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.85,
                text1: 'SIDE PLANK',
                textColor1: '#FFFFFF',
                color1: '#FFFFFF',
                color2: '#7ABBA6',
                color3: '#E2782E',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 165.5515934714437,
                width: 629.270116636521,
                transform: 'matrix(0.7357848598730832, 0, 0, 0.7357848598730832, 0, 0)',
                x: 398.2865523359213,
                y: 63.73110350854296,
                rotateDeg: 0
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.85,
                text1: 'SIDE PLANK',
                textColor1: '#FFFFFF',
                color1: '#FFFFFF',
                color2: '#7ABBA6',
                color3: '#E2782E',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 112.81749655187275,
                width: 428.82510355349064,
                transform: 'matrix(0.5014110957861011, 0, 0, 0.5014110957861011, 0, 0)',
                x: 608.2449693505148,
                y: 45.120098522848295,
                rotateDeg: 0
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.85,
                text1: 'SIDE PLANK',
                textColor1: '#FFFFFF',
                color1: '#FFFFFF',
                color2: '#7ABBA6',
                color3: '#E2782E',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 184.3408186231611,
                width: 700.6889272610798,
                transform: 'matrix(0.8192925272140494, 0, 0, 0.8192925272140494, 0, 0)',
                x: 768,
                y: 99.82959068841944,
                rotateDeg: 0
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'Ef1qyyqbb-rhythm-countup-timer': {
        '16:9': {
            values: {
                alpha: 1,
                color1: 'rgb(76, 233, 192)',
                textColor1: 'rgb(76, 233, 192)',
                color2: 'rgb(0, 0, 0)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: true,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 258.7465369697717,
                width: 258.7465369697716,
                transform: 'matrix(0.8624884565659056, 0, 0, 0.8624884565659056, 0, 0)',
                x: 1539.6471107080447,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: 'rgb(76, 233, 192)',
                textColor1: 'rgb(76, 233, 192)',
                color2: 'rgb(0, 0, 0)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: true,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 266.2067292672846,
                width: 266.2067292672845,
                transform: 'matrix(0.8873557642242819, 0, 0, 0.8873557642242819, 0, 0)',
                x: 772.9721563632139,
                y: 56.86803519061584
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: 'rgb(76, 233, 192)',
                textColor1: 'rgb(76, 233, 192)',
                color2: 'rgb(0, 0, 0)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: true,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 167.93764481169796,
                width: 167.93764481169794,
                transform: 'matrix(0.5597921493723266, 0, 0, 0.5597921493723266, 0, 0)',
                x: 856.1186408353719,
                y: 90.69872763342696
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: 'rgb(76, 233, 192)',
                textColor1: 'rgb(76, 233, 192)',
                color2: 'rgb(0, 0, 0)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                shadow: true,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 287.29481593112564,
                width: 287.2948159311256,
                transform: 'matrix(0.9576493864370854, 0, 0, 0.9576493864370854, 0, 0)',
                x: 1146.7962509319132,
                y: 122.14838090605804
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'rk2D1BI0z-fitness-linear': {
        '16:9': {
            values: {
                color1: '#FF5C5C',
                textColor1: '#FFFFFF',
                textColor2: '#FFFFFF',
                alpha: 1,
                shadow: true,
                text1: 'CARDIO DANCE\nCELEBS LOVE',
                text2: 'POPSUGAR FITNESS',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                fontFamily2: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                lineHeight2: 1.5,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 407.98402951686325,
                width: 808.9828687024832,
                transform: 'matrix(0.8947018191159282, 0, 0, 0.8947018191159282, 0, 0)',
                x: 555.5085656487583,
                y: 184.72937180671397
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                color1: '#FF5C5C',
                textColor1: '#FFFFFF',
                textColor2: '#FFFFFF',
                alpha: 1,
                shadow: true,
                text1: 'CARDIO DANCE\nCELEBS LOVE',
                text2: 'POPSUGAR FITNESS',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                fontFamily2: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                lineHeight2: 1.5,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 430.8926699038759,
                width: 832.1153369759913,
                transform: 'matrix(0.9449400655786753, 0, 0, 0.9449400655786753, 0, 0)',
                x: 123.94233151200433,
                y: 518.3753553805491
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                color1: '#FF5C5C',
                textColor1: '#FFFFFF',
                textColor2: '#FFFFFF',
                alpha: 1,
                shadow: true,
                text1: 'CARDIO DANCE\nCELEBS LOVE',
                text2: 'POPSUGAR FITNESS',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                fontFamily2: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                lineHeight2: 1.5,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 294.70697768165513,
                width: 589.7078093044834,
                transform: 'matrix(0.6462872317580156, 0, 0, 0.6462872317580156, 0, 0)',
                x: 245.14609534775832,
                y: 200.05862763904994
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                color1: '#FF5C5C',
                textColor1: '#FFFFFF',
                textColor2: '#FFFFFF',
                alpha: 1,
                shadow: true,
                text1: 'CARDIO DANCE\nCELEBS LOVE',
                text2: 'POPSUGAR FITNESS',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                fontFamily2: 'FIRA_SANS:EXTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                lineHeight2: 1.5,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 523.9235158784979,
                width: 1048.369438763526,
                transform: 'matrix(1.1489550786809166, 0, 0, 1.1489550786809166, 0, 0)',
                x: 243.815280618237,
                y: 318.492657433335
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'mzt3ccsznP-fitness-challenge': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'MOUNTAIN CLIMBERS',
                text2: '45 SECS EXERCISE | 15 SECS REST',
                color1: '#C8EAF4',
                color2: '#004E7F',
                textColor1: '#004E7F',
                textColor2: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2466666666666666,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 156.43015760392814,
                width: 815.9738546754663,
                transform: 'matrix(0.6609724969180062, 0, 0, 0.6609724969180062, 0, 0)',
                x: 984.1172614976545,
                y: 815.5698423960719,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'MOUNTAIN CLIMBERS',
                text2: '45 SECS EXERCISE | 15 SECS REST',
                color1: '#C8EAF4',
                color2: '#004E7F',
                textColor1: '#004E7F',
                textColor2: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2466666666666666,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 171.42713238841174,
                width: 911.9956276896781,
                transform: 'matrix(0.7243399960073735, 0, 0, 0.7243399960073735, 0, 0)',
                x: 110.26978001185586,
                y: 1556.5728676115882,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'MOUNTAIN CLIMBERS',
                text2: '45 SECS EXERCISE | 15 SECS REST',
                color1: '#C8EAF4',
                color2: '#004E7F',
                textColor1: '#004E7F',
                textColor2: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2466666666666666,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 86.47074788210979,
                width: 460.0260349269631,
                transform: 'matrix(0.36536935724835123, 0, 0, 0.36536935724835123, 0, 0)',
                x: 540,
                y: 887.3101814119625,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'MOUNTAIN CLIMBERS',
                text2: '45 SECS EXERCISE | 15 SECS REST',
                color1: '#C8EAF4',
                color2: '#004E7F',
                textColor1: '#004E7F',
                textColor2: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                shadow: true,
                lineHeight1: 1.2466666666666666,
                lineHeight2: 1.2,
                letterSpacing1: 0,
                letterSpacing2: 0
            },
            space: {
                height: 184.06841236507614,
                width: 979.2474792868782,
                transform: 'matrix(0.7777538550637021, 0, 0, 0.7777538550637021, 0, 0)',
                x: 406.0888519852434,
                y: 1571.0372542630607,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    '3QZbp8qL54-workout-preview-list': {
        '16:9': {
            values: {
                textColor1: 'rgb(255, 255, 255)',
                textColor2: '#0c0c0c',
                color1: '#FA8334',
                color2: '#ffffff',
                alpha: 0.6999999999999998,
                text1: 'NEXT REP GOAL',
                text2: '           LEVEL 1: 10 REPS           \n           LEVEL 2: 50 REPS           \n           LEVEL 3: 20 REPS           ',
                fontFamily1: 'ALFA_SLAB_ONE:NORMAL:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:BOLD:NORMAL',
                align: 'center',
                shadow: false,
                lineHeight1: 1.4066666666666667,
                letterSpacing1: 46.666666666666686,
                lineHeight2: 1.3,
                letterSpacing2: 0
            },
            space: {
                height: 253.0522894067336,
                width: 583.665671993174,
                transform: 'matrix(0.6358097723787276, 0, 0, 0.6358097723787276, 0, 0)',
                x: 139.9206219367513,
                y: 718.9477105932664
            },
            variant: {
                fontFamily1: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                textColor1: 'rgb(255, 255, 255)',
                textColor2: '#0c0c0c',
                color1: '#FA8334',
                color2: '#ffffff',
                alpha: 0.6999999999999998,
                text1: 'NEXT REP GOAL',
                text2: '           LEVEL 1: 10 REPS           \n           LEVEL 2: 50 REPS           \n           LEVEL 3: 20 REPS           ',
                fontFamily1: 'ALFA_SLAB_ONE:NORMAL:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:BOLD:NORMAL',
                align: 'center',
                shadow: false,
                lineHeight1: 1.4066666666666667,
                letterSpacing1: 46.666666666666686,
                lineHeight2: 1.3,
                letterSpacing2: 0
            },
            space: {
                height: 278.281395328836,
                width: 641.8566612797501,
                transform: 'matrix(0.6991994857508442, 0, 0, 0.6991994857508442, 0, 0)',
                x: 103.41565494700377,
                y: 1449.718604671164
            },
            variant: {
                fontFamily1: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                textColor1: 'rgb(255, 255, 255)',
                textColor2: '#0c0c0c',
                color1: '#FA8334',
                color2: '#ffffff',
                alpha: 0.6999999999999998,
                text1: 'NEXT REP GOAL',
                text2: '           LEVEL 1: 10 REPS           \n           LEVEL 2: 50 REPS           \n           LEVEL 3: 20 REPS           ',
                fontFamily1: 'ALFA_SLAB_ONE:NORMAL:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:BOLD:NORMAL',
                align: 'center',
                shadow: false,
                lineHeight1: 1.4066666666666667,
                letterSpacing1: 46.666666666666686,
                lineHeight2: 1.3,
                letterSpacing2: 0
            },
            space: {
                height: 170.1664217785292,
                width: 392.4892327624848,
                transform: 'matrix(0.42755382356414373, 0, 0, 0.42755382356414373, 0, 0)',
                x: 78.28875230202596,
                y: 813.0962361990519
            },
            variant: {
                fontFamily1: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                textColor1: 'rgb(255, 255, 255)',
                textColor2: '#0c0c0c',
                color1: '#FA8334',
                color2: '#ffffff',
                alpha: 0.6999999999999998,
                text1: 'NEXT REP GOAL',
                text2: '           LEVEL 1: 10 REPS           \n           LEVEL 2: 50 REPS           \n           LEVEL 3: 20 REPS           ',
                fontFamily1: 'ALFA_SLAB_ONE:NORMAL:NORMAL',
                fontFamily2: 'ARCHIVO_NARROW:BOLD:NORMAL',
                align: 'center',
                shadow: false,
                lineHeight1: 1.4066666666666667,
                letterSpacing1: 46.666666666666686,
                lineHeight2: 1.3,
                letterSpacing2: 0
            },
            space: {
                height: 302.51808316182974,
                width: 697.7586360221952,
                transform: 'matrix(0.7600956863362556, 0, 0, 0.7600956863362556, 0, 0)',
                x: 140.62259564935903,
                y: 1490.5484081792204
            },
            variant: {
                fontFamily1: {
                    category: 'SLAB_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'rJRD1HICf-cnn-caption': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'Warm Up & Cool down\n\n- Shortened but built in. \n- Add extra time for both as needed.',
                color1: '#CB0714',
                textColor1: '#FFF',
                fontFamily1: 'CHIVO:NORMAL:NORMAL',
                lineHeight1: 1.18,
                letterSpacing1: 0,
                shadow: true,
                align: 'right',
                lineSpacing1: 0
            },
            space: {
                height: 258.189785700964,
                width: 894.2017796443286,
                transform: 'matrix(0.6493706883827063, 0, 0, 0.6493706883827063, 0, 0)',
                x: 412.63942888831843,
                y: 580.9348899012908
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'Warm Up & Cool down\n\n- Shortened but built in. \n- Add extra time for both as needed.',
                color1: '#CB0714',
                textColor1: '#FFF',
                fontFamily1: 'CHIVO:NORMAL:NORMAL',
                lineHeight1: 1.18,
                letterSpacing1: 0,
                shadow: true,
                align: 'right',
                lineSpacing1: 0
            },
            space: {
                height: 408.7764168057982,
                width: 895.2354586125756,
                transform: 'matrix(0.8308463756215412, 0, 0, 0.8308463756215412, 0, 0)',
                x: 115.52210984050504,
                y: 1096.8063365394569
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'Warm Up & Cool down\n\n- Shortened but built in. \n- Add extra time for both as needed.',
                color1: '#CB0714',
                textColor1: '#FFF',
                fontFamily1: 'CHIVO:NORMAL:NORMAL',
                lineHeight1: 1.18,
                letterSpacing1: 0,
                shadow: true,
                align: 'right',
                lineSpacing1: 0
            },
            space: {
                height: 202.8593966665683,
                width: 700.4055211126397,
                transform: 'matrix(0.5102097501674253, 0, 0, 0.5102097501674253, 0, 0)',
                x: 189.79723944368016,
                y: 455.60068761868035
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'Warm Up & Cool down\n\n- Shortened but built in. \n- Add extra time for both as needed.',
                color1: '#CB0714',
                textColor1: '#FFF',
                fontFamily1: 'CHIVO:NORMAL:NORMAL',
                lineHeight1: 1.18,
                letterSpacing1: 0,
                shadow: true,
                align: 'right',
                lineSpacing1: 0
            },
            space: {
                height: 332.01108776292017,
                width: 1146.3230333962933,
                transform: 'matrix(0.8350379470898396, 0, 0, 0.8350379470898396, 0, 0)',
                x: 194.83848330185333,
                y: 1044.5176403787113
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'DcJn2SvgL-timed-workout-template': {
        '16:9': {
            values: {
                alpha: 0.85,
                text1: 'JUMPING JACKS',
                textColor1: 'rgb(255, 255, 255)',
                color1: '#FFFFFF',
                color2: '#0A6986',
                color3: '#FD7669',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 158.34645523206953,
                width: 650.0415525475398,
                transform: 'matrix(0.7037620232536423, 0, 0, 0.7037620232536423, 0, 0)',
                x: 103.69643929675468,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.85,
                text1: 'JUMPING JACKS',
                textColor1: 'rgb(255, 255, 255)',
                color1: '#FFFFFF',
                color2: '#0A6986',
                color3: '#FD7669',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 167.0960647469199,
                width: 800.5604365268962,
                transform: 'matrix(0.7426491766529772, 0, 0, 0.7426491766529772, 0, 0)',
                x: 217.79383838231033,
                y: 108.45196762654005
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.85,
                text1: 'JUMPING JACKS',
                textColor1: 'rgb(255, 255, 255)',
                color1: '#FFFFFF',
                color2: '#0A6986',
                color3: '#FD7669',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 107.3934715165922,
                width: 427.8534244470519,
                transform: 'matrix(0.4773043178515209, 0, 0, 0.4773043178515209, 0, 0)',
                x: 617.5953079178886,
                y: 54.3032642417039
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.85,
                text1: 'JUMPING JACKS',
                textColor1: 'rgb(255, 255, 255)',
                color1: '#FFFFFF',
                color2: '#0A6986',
                color3: '#FD7669',
                fontFamily1: 'IBM_PLEX_SANS:MEDIUM:NORMAL',
                isAscendingTimer: false,
                shadow: false,
                timeFormat: 'SECS',
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100,
                letterSpacing: 0,
                lineHeight: 1.2
            },
            space: {
                height: 177.5558935990083,
                width: 809.4733363244668,
                transform: 'matrix(0.7891373048844813, 0, 0, 0.7891373048844813, 0, 0)',
                x: 623.1724137931035,
                y: 103.22205320049585
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'uZWVio6YCz-power-boost-timer': {
        '16:9': {
            values: {
                alpha: 1,
                color1: 'hsl(0, 100%, 73.8%)',
                color2: 'rgb(255, 255, 255)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 325.01508342055035,
                width: 325.01508342055035,
                transform: 'matrix(1.0833836114018345, 0, 0, 1.0833836114018345, 0, 0)',
                x: 1508.2910176691498,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: 'hsl(0, 100%, 73.8%)',
                color2: 'rgb(255, 255, 255)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 300.278078924496,
                width: 300.27807892449596,
                transform: 'matrix(1.00092692974832, 0, 0, 1.00092692974832, 0, 0)',
                x: 751.5694284068823,
                y: 54.12349411631746
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: 'hsl(0, 100%, 73.8%)',
                color2: 'rgb(255, 255, 255)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 206.82352379055027,
                width: 206.82352379055018,
                transform: 'matrix(0.6894117459685009, 0, 0, 0.6894117459685009, 0, 0)',
                x: 845.95851013568,
                y: 49.447397991748225
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: 'hsl(0, 100%, 73.8%)',
                color2: 'rgb(255, 255, 255)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: true,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 341.9560828420162,
                width: 341.9560828420161,
                transform: 'matrix(1.1398536094733873, 0, 0, 1.1398536094733873, 0, 0)',
                x: 1131.3849615795018,
                y: 71.01498971749048
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'vHDeoEX1p-count-it-up-timer': {
        '16:9': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'hsl(14.600000000000023, 100%, 68.5%)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: false,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 312.43366373206914,
                width: 312.43366373206914,
                transform: 'matrix(1.0414455457735639, 0, 0, 1.0414455457735639, 0, 0)',
                x: 1523.2004555808658,
                y: 108
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'hsl(14.600000000000023, 100%, 68.5%)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: false,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 341.4786801310424,
                width: 341.4786801310423,
                transform: 'matrix(1.1382622671034746, 0, 0, 1.1382622671034746, 0, 0)',
                x: 672.3144233172335,
                y: 64.80412579633938
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'hsl(14.600000000000023, 100%, 68.5%)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: false,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 212.66826783764085,
                width: 212.66826783764085,
                transform: 'matrix(0.7088942261254695, 0, 0, 0.7088942261254695, 0, 0)',
                x: 845.95851013568,
                y: 49.447397991748225
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: 'rgb(255, 255, 255)',
                color2: 'hsl(14.600000000000023, 100%, 68.5%)',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                isAscendingTimer: true,
                timeFormat: 'SECS',
                shadow: false,
                audioId1: 'COUNTDOWN_BEEP_1',
                volume1: 100,
                audioDuration1: 3000,
                audioId2: 'COUNTDOWN_BEEP_END_1',
                volume2: 100
            },
            space: {
                height: 341.4786801310424,
                width: 341.4786801310423,
                transform: 'matrix(1.1382622671034746, 0, 0, 1.1382622671034746, 0, 0)',
                x: 1131.3849615795018,
                y: 71.01498971749048
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'ry2MJHIAG-instagram-monochrome': {
        '16:9': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 103.68052334176302,
                width: 331.9455800024156,
                transform: 'matrix(0.41472209336705207, 0, 0, 0.41472209336705207, 0, 0)',
                x: 141.33653411166722,
                y: 868.319476658237
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 151.7798266407785,
                width: 485.9412449227575,
                transform: 'matrix(0.6071193065631141, 0, 0, 0.6071193065631141, 0, 0)',
                x: 54.058755077242495,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 105.93591955827335,
                width: 339.16650039415543,
                transform: 'matrix(0.42374367823309345, 0, 0, 0.42374367823309345, 0, 0)',
                x: 85.73030932944191,
                y: 877.3741446725317
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 188.33052365915265,
                width: 602.9626673673874,
                transform: 'matrix(0.7533220946366106, 0, 0, 0.7533220946366106, 0, 0)',
                x: 121.92755104631738,
                y: 1571.0372542630607
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'S1CMJSUCM-instagram-sharp': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#b93894',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'FOLLOW ME ON'
            },
            space: {
                height: 101.78510959818755,
                width: 346.54463384596954,
                transform: 'matrix(0.3960510101096792, 0, 0, 0.3960510101096792, 0, 0)',
                x: 138.87639743740755,
                y: 870.2148904018125
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#b93894',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'FOLLOW ME ON'
            },
            space: {
                height: 142.33990915263644,
                width: 484.6203132628677,
                transform: 'matrix(0.553851786586134, 0, 0, 0.553851786586134, 0, 0)',
                x: 55.37968673713232,
                y: 1663.009035591013
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#b93894',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'FOLLOW ME ON'
            },
            space: {
                height: 109.16631263238979,
                width: 371.6751889235064,
                transform: 'matrix(0.42477164448400695, 0, 0, 0.42477164448400695, 0, 0)',
                x: 75.40601384561697,
                y: 876.0980239755422
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#b93894',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'FOLLOW ME ON'
            },
            space: {
                height: 194.07344467980406,
                width: 660.755891419567,
                transform: 'matrix(0.7551495901937901, 0, 0, 0.7551495901937901, 0, 0)',
                x: 107.24410858043302,
                y: 1574.3990937799151
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'B1ym1HL0M-instagram-block': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'athleanx',
                color1: '#b93894',
                color2: '#FFFFFF',
                textColor1: '#b93894',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 82.54063499186118,
                width: 393.6931159870668,
                transform: 'matrix(0.5502708999457412, 0, 0, 0.5502708999457412, 0, 0)',
                x: 131.91343963553533,
                y: 864.8874520939138
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'athleanx',
                color1: '#b93894',
                color2: '#FFFFFF',
                textColor1: '#b93894',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 101.51500110821986,
                width: 484.1949314984842,
                transform: 'matrix(0.6767666740547991, 0, 0, 0.6767666740547991, 0, 0)',
                x: 55.80506850151579,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'athleanx',
                color1: '#b93894',
                color2: '#FFFFFF',
                textColor1: '#b93894',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 78.15680638509413,
                width: 372.783619175932,
                transform: 'matrix(0.5210453759006275, 0, 0, 0.5210453759006275, 0, 0)',
                x: 56.205226763222804,
                y: 889.5742805667111
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'athleanx',
                color1: '#b93894',
                color2: '#FFFFFF',
                textColor1: '#b93894',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 138.94543357350068,
                width: 662.7264340905458,
                transform: 'matrix(0.9263028904900045, 0, 0, 0.9263028904900045, 0, 0)',
                x: 79.93632250769465,
                y: 1603.987381809051
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'HyeQkBUCf-instagram-logo': {
        '16:9': {
            values: {
                textColor1: '#BC2A8D',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 151.52718867734023,
                width: 233.1187518112926,
                transform: 'matrix(0.29139843976411584, 0, 0, 0.29139843976411584, 0, 0)',
                x: 73.26392810064083,
                y: 820.4728113226597
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                textColor1: '#BC2A8D',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 191.9603495921754,
                width: 267.1711220885711,
                transform: 'matrix(0.3691545184464911, 0, 0, 0.3691545184464911, 0, 0)',
                x: 22.52199413489736,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                textColor1: '#BC2A8D',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 120.64001642450957,
                width: 167.9072195138036,
                transform: 'matrix(0.23200003158559532, 0, 0, 0.23200003158559532, 0, 0)',
                x: 30.439882697947212,
                y: 867.8726783968716
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                textColor1: '#BC2A8D',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 214.47114031023924,
                width: 298.5017235800953,
                transform: 'matrix(0.4124445005966139, 0, 0, 0.4124445005966139, 0, 0)',
                x: 43.29227761485826,
                y: 1571.0372542630607
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'H1mDyHICG-instagram-edge': {
        '16:9': {
            values: {
                color1: '#267fc6',
                alpha: 1,
                text1: '@ATHLEANX',
                textColor1: '#FFF',
                fontFamily1: 'ALEGREYA:BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: 'Follow Us',
                textColor2: '#FFF',
                fontFamily2: 'ALEGREYA:BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                shadow: false
            },
            space: {
                height: 102.31101395835339,
                width: 477.462716759268,
                transform: 'matrix(0.5115550697917669, 0, 0, 0.5115550697917669, 0, 0)',
                x: 131.91343963553533,
                y: 869.6889860416466
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                color1: '#267fc6',
                alpha: 1,
                text1: '@ATHLEANX',
                textColor1: '#FFF',
                fontFamily1: 'ALEGREYA:BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: 'Follow Us',
                textColor2: '#FFF',
                fontFamily2: 'ALEGREYA:BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                shadow: false
            },
            space: {
                height: 115.5527048039425,
                width: 519.6547036951794,
                transform: 'matrix(0.5777635240197125, 0, 0, 0.5777635240197125, 0, 0)',
                x: 70.00046871861375,
                y: 1728
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                color1: '#267fc6',
                alpha: 1,
                text1: '@ATHLEANX',
                textColor1: '#FFF',
                fontFamily1: 'ALEGREYA:BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: 'Follow Us',
                textColor2: '#FFF',
                fontFamily2: 'ALEGREYA:BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                shadow: false
            },
            space: {
                height: 83.86367784498105,
                width: 377.14525796054505,
                transform: 'matrix(0.4193183892249053, 0, 0, 0.4193183892249053, 0, 0)',
                x: 68.56842754931871,
                y: 886.8756109481914
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                color1: '#267fc6',
                alpha: 1,
                text1: '@ATHLEANX',
                textColor1: '#FFF',
                fontFamily1: 'ALEGREYA:BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: 'Follow Us',
                textColor2: '#FFF',
                fontFamily2: 'ALEGREYA:BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                shadow: false
            },
            space: {
                height: 149.09098283552186,
                width: 670.4804585965245,
                transform: 'matrix(0.7454549141776093, 0, 0, 0.7454549141776093, 0, 0)',
                x: 97.5195414034755,
                y: 1599.1897469316825
            },
            variant: {
                fontFamily1: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'ByobkHL0M-youtube-sharp': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#bb0000',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'SUBSCRIBE'
            },
            space: {
                height: 101.61231498364032,
                width: 361.1179183121808,
                transform: 'matrix(0.3953786575238923, 0, 0, 0.3953786575238923, 0, 0)',
                x: 141.33653411166722,
                y: 870.3876850163597
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#bb0000',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'SUBSCRIBE'
            },
            space: {
                height: 140.33633190343866,
                width: 498.7384063506107,
                transform: 'matrix(0.54605576616124, 0, 0, 0.54605576616124, 0, 0)',
                x: 41.26159364938928,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#bb0000',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'SUBSCRIBE'
            },
            space: {
                height: 108.43980427629903,
                width: 385.38199221956665,
                transform: 'matrix(0.4219447637210079, 0, 0, 0.4219447637210079, 0, 0)',
                x: 64.21092614782906,
                y: 874.2069892473114
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'ATHLEAN-X',
                color1: '#bb0000',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'SUBSCRIBE'
            },
            space: {
                height: 192.78187426897605,
                width: 685.1235417236741,
                transform: 'matrix(0.7501240243929029, 0, 0, 0.7501240243929029, 0, 0)',
                x: 91.32220607691244,
                y: 1576.667752796785
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'ryab1HLRz-youtube-logo': {
        '16:9': {
            values: {
                textColor1: '#F8140D',
                text1: ' ATHLEAN-X',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 145.03617204174265,
                width: 248.7360618017173,
                transform: 'matrix(0.2789157154648897, 0, 0, 0.2789157154648897, 0, 0)',
                x: 78.62549666454191,
                y: 828.6110467008662
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                textColor1: '#F8140D',
                text1: ' ATHLEAN-X',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 166.5764564489192,
                width: 285.67750501622794,
                transform: 'matrix(0.3203393393248446, 0, 0, 0.3203393393248446, 0, 0)',
                x: 0,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                textColor1: '#F8140D',
                text1: ' ATHLEAN-X',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 117.18044647382112,
                width: 200.96367937562806,
                transform: 'matrix(0.225347012449656, 0, 0, 0.225347012449656, 0, 0)',
                x: 11.87683284457478,
                y: 869.4562561094816
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                textColor1: '#F8140D',
                text1: ' ATHLEAN-X',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 208.32079373123756,
                width: 357.2687633344499,
                transform: 'matrix(0.4006169110216107, 0, 0, 0.4006169110216107, 0, 0)',
                x: 16.89149560117302,
                y: 1571.0372542630607
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'r1kfyBIRM-youtube-monochrome': {
        '16:9': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEAN-X',
                color1: '#fff',
                color2: '#000000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 102.03302635118696,
                width: 337.0272462529759,
                transform: 'matrix(0.40813210540474787, 0, 0, 0.40813210540474787, 0, 0)',
                x: 141.33653411166722,
                y: 869.966973648813
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEAN-X',
                color1: '#fff',
                color2: '#000000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 147.67438136080037,
                width: 487.7860813501525,
                transform: 'matrix(0.5906975254432014, 0, 0, 0.5906975254432014, 0, 0)',
                x: 52.21391864984753,
                y: 1662.9144595721193
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEAN-X',
                color1: '#fff',
                color2: '#000000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 112.12834510263988,
                width: 370.373287241092,
                transform: 'matrix(0.44851338041055955, 0, 0, 0.44851338041055955, 0, 0)',
                x: 77.033390948635,
                y: 874.2069892473116
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEAN-X',
                color1: '#fff',
                color2: '#000000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 199.3392801824709,
                width: 658.4413995397191,
                transform: 'matrix(0.7973571207298836, 0, 0, 0.7973571207298836, 0, 0)',
                x: 109.5586004602809,
                y: 1571.0372542630607
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'S1xz1H80G-youtube-block': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#bb0000',
                color2: '#FFF',
                textColor1: '#bb0000',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 85.02655668439073,
                width: 517.9289838660436,
                transform: 'matrix(0.5668437112292715, 0, 0, 0.5668437112292715, 0, 0)',
                x: 131.91343963553533,
                y: 886.9734433156093
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#bb0000',
                color2: '#FFF',
                textColor1: '#bb0000',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 81.757114489228,
                width: 498.0135722584104,
                transform: 'matrix(0.5450474299281867, 0, 0, 0.5450474299281867, 0, 0)',
                x: 41.98642774158958,
                y: 1668.7305867620785
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#bb0000',
                color2: '#FFF',
                textColor1: '#bb0000',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 63.8378936992307,
                width: 388.8608066126815,
                transform: 'matrix(0.4255859579948713, 0, 0, 0.4255859579948713, 0, 0)',
                x: 53.92399173414819,
                y: 895.9043568131998
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#bb0000',
                color2: '#FFF',
                textColor1: '#bb0000',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 113.48958879863235,
                width: 691.308100644767,
                transform: 'matrix(0.756597258657549, 0, 0, 0.756597258657549, 0, 0)',
                x: 76.69189935523298,
                y: 1615.2408506916975
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'Byt7kSLRG-facebook-sharp': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'Athleanx',
                color1: '#3b5998',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'LIKE ME ON'
            },
            space: {
                height: 109.09478320711764,
                width: 371.4316548880463,
                transform: 'matrix(0.4244933198720531, 0, 0, 0.4244933198720531, 0, 0)',
                x: 131.91343963553533,
                y: 862.9052167928824
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'Athleanx',
                color1: '#3b5998',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'LIKE ME ON'
            },
            space: {
                height: 146.50953049665264,
                width: 498.8164948815998,
                transform: 'matrix(0.5700759941503994, 0, 0, 0.5700759941503994, 0, 0)',
                x: 41.183505118400205,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'Athleanx',
                color1: '#3b5998',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'LIKE ME ON'
            },
            space: {
                height: 101.53136068679828,
                width: 345.6807027274262,
                transform: 'matrix(0.39506366025991546, 0, 0, 0.39506366025991546, 0, 0)',
                x: 78.20703947928033,
                y: 877.3741446725313
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'Athleanx',
                color1: '#3b5998',
                color2: '#fff',
                fontFamily1: 'ARCHIVO_NARROW:MEDIUM:NORMAL',
                fontFamily2: 'PT_SANS:NORMAL:NORMAL',
                shadow: true,
                lineHeight1: 0.8,
                lineHeight2: 0.8,
                letterSpacing1: 0,
                letterSpacing2: 0,
                text2: 'LIKE ME ON'
            },
            space: {
                height: 180.50019677653026,
                width: 614.5434715154244,
                transform: 'matrix(0.7023353960176275, 0, 0, 0.7023353960176275, 0, 0)',
                x: 111.22778948164313,
                y: 1582.2982513305092
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'H1qQyrL0G-facebook-block': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#3b5998',
                color2: '#FFF',
                textColor1: '#3b5998',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 83.84521750839787,
                width: 516.3818646000173,
                transform: 'matrix(0.5589681167226525, 0, 0, 0.5589681167226525, 0, 0)',
                x: 131.91343963553533,
                y: 888.1547824916022
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#3b5998',
                color2: '#FFF',
                textColor1: '#3b5998',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 82.537038935694,
                width: 508.3251177672602,
                transform: 'matrix(0.55024692623796, 0, 0, 0.55024692623796, 0, 0)',
                x: 31.674882232739776,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#3b5998',
                color2: '#FFF',
                textColor1: '#3b5998',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 61.03003363199616,
                width: 375.86881518120515,
                transform: 'matrix(0.4068668908799744, 0, 0, 0.4068668908799744, 0, 0)',
                x: 70.16398102349358,
                y: 893.972508669301
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'Jeff Cavaliere',
                color1: '#3b5998',
                color2: '#FFF',
                textColor1: '#3b5998',
                fontFamily1: 'EDO:NORMAL:NORMAL',
                shadow: false,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 108.49783756799319,
                width: 668.2112269888091,
                transform: 'matrix(0.7233189171199546, 0, 0, 0.7233189171199546, 0, 0)',
                x: 99.78877301119087,
                y: 1614.6217032582952
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'B1smJHU0M-facebook-monochrome': {
        '16:9': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 108.30083485900616,
                width: 359.51863006066105,
                transform: 'matrix(0.4332033394360246, 0, 0, 0.4332033394360246, 0, 0)',
                x: 141.33653411166722,
                y: 863.6991651409938
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 149.7971508069003,
                width: 497.2710184108848,
                transform: 'matrix(0.5991886032276013, 0, 0, 0.5991886032276013, 0, 0)',
                x: 42.72898158911522,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 106.4055611149196,
                width: 353.22702371292587,
                transform: 'matrix(0.42562224445967844, 0, 0, 0.42562224445967844, 0, 0)',
                x: 88.56885965503037,
                y: 876.6540586828485
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 0.3,
                text1: 'ATHLEANX',
                color1: '#fff',
                color2: '#000',
                textColor1: '#fff',
                fontFamily1: 'ALADIN:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 189.1654419820793,
                width: 627.9591532674237,
                transform: 'matrix(0.7566617679283172, 0, 0, 0.7566617679283172, 0, 0)',
                x: 125.96460039826542,
                y: 1578.2028491930996
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'B1h7yrUAM-facebook-logo': {
        '16:9': {
            values: {
                textColor1: '#3B5998',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 147.5184436571256,
                width: 226.951451780193,
                transform: 'matrix(0.28368931472524156, 0, 0, 0.28368931472524156, 0, 0)',
                x: 77.10680110246926,
                y: 824.4815563428745
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                textColor1: '#3B5998',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 192.4445985256776,
                width: 296.0686131164267,
                transform: 'matrix(0.37008576639553387, 0, 0, 0.37008576639553387, 0, 0)',
                x: 0,
                y: 1659.6656915280896
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                textColor1: '#3B5998',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 118.5976120406126,
                width: 182.4578646778653,
                transform: 'matrix(0.22807233084733192, 0, 0, 0.22807233084733192, 0, 0)',
                x: 3.9589442815249263,
                y: 867.8726783968716
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                textColor1: '#3B5998',
                text1: 'ATHLEANX',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 210.84019918331128,
                width: 324.3695372050939,
                transform: 'matrix(0.40546192150636784, 0, 0, 0.40546192150636784, 0, 0)',
                x: 5.63049853372434,
                y: 1571.0372542630607
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'FJL78OcKA-horizontal-progress-bar': {
        '16:9': {
            values: {
                alpha: 0.85,
                color1: '#F1AD88',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 37.37218675076477,
                width: 1783.1467463890515,
                transform: 'matrix(0.7474437350152954, 0, 0, 0.7474437350152954, 0, 0)',
                x: 68.42662680547426,
                y: 987.9216203473244
            },
            variant: {}
        },
        '9:16': {
            values: {
                alpha: 0.85,
                color1: '#F1AD88',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 62.80558235598366,
                width: 1020.9301247398721,
                transform: 'matrix(1.2561116471196732, 0, 0, 1.2561116471196732, 0, 0)',
                x: 29.53493763006395,
                y: 1823.8710852443799
            },
            variant: {}
        },
        '1:1': {
            values: {
                alpha: 0.85,
                color1: '#F1AD88',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 35.32814007524081,
                width: 878.3201159872924,
                transform: 'matrix(0.7065628015048162, 0, 0, 0.7065628015048162, 0, 0)',
                x: 100.8399420063538,
                y: 1019.5931745995238
            },
            variant: {}
        },
        '4:5': {
            values: {
                alpha: 0.85,
                color1: '#F1AD88',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 62.80558235598366,
                width: 1223.6280719539484,
                transform: 'matrix(1.2561116471196732, 0, 0, 1.2561116471196732, 0, 0)',
                x: 156.1859640230258,
                y: 1812.6100881769312
            },
            variant: {}
        }
    },
    'HgIuhIke6m-horizontal-rounded-progress-bar': {
        '16:9': {
            values: {
                alpha: 0.8,
                color1: '#FF2E2E',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 28.428831749559375,
                width: 1793.2074305411663,
                transform: 'matrix(0.5685766349911875, 0, 0, 0.5685766349911875, 0, 0)',
                x: 63.396284729416834,
                y: 67.27048487914222
            },
            variant: {}
        },
        '9:16': {
            values: {
                alpha: 0.8,
                color1: '#FF2E2E',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 47.489561330387026,
                width: 1014.8116096489708,
                transform: 'matrix(0.9497912266077405, 0, 0, 0.9497912266077405, 0, 0)',
                x: 32.594195175514585,
                y: 44.73739165147353
            },
            variant: {}
        },
        '1:1': {
            values: {
                alpha: 0.8,
                color1: '#FF2E2E',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 26.712878248342705,
                width: 874.8784512486604,
                transform: 'matrix(0.5342575649668541, 0, 0, 0.5342575649668541, 0, 0)',
                x: 104.28160674498577,
                y: 29.915515941783724
            },
            variant: {}
        },
        '4:5': {
            values: {
                alpha: 0.8,
                color1: '#FF2E2E',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 47.489561330387026,
                width: 1217.509556863047,
                transform: 'matrix(0.9497912266077405, 0, 0, 0.9497912266077405, 0, 0)',
                x: 159.2452215684765,
                y: 44.73739165147339
            },
            variant: {}
        }
    },
    '5HfnPL2R9o-vertical-progress-bar': {
        '16:9': {
            values: {
                alpha: 0.85,
                color1: '#5390D9',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 1000.7597001854509,
                width: 28.0644562547499,
                transform: 'matrix(0.7016114063687475, 0, 0, 0.7016114063687475, 0, 0)',
                x: 1838.0796531618705,
                y: 39.62014990727454
            },
            variant: {}
        },
        '9:16': {
            values: {
                alpha: 0.85,
                color1: '#5390D9',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 1281.4843328301963,
                width: 35.93685976083557,
                transform: 'matrix(0.8984214940208894, 0, 0, 0.8984214940208894, 0, 0)',
                x: 988.5174590224827,
                y: 70.43582205737695
            },
            variant: {}
        },
        '1:1': {
            values: {
                alpha: 0.85,
                color1: '#5390D9',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 871.2748199149326,
                width: 20.214483615470005,
                transform: 'matrix(0.5053620903867503, 0, 0, 0.5053620903867503, 0, 0)',
                x: 1025.2659587497058,
                y: 39.62014990727454
            },
            variant: {}
        },
        '4:5': {
            values: {
                alpha: 0.85,
                color1: '#5390D9',
                isAscendingTimer: false,
                roundEdges: false
            },
            space: {
                height: 1281.4843328301963,
                width: 35.93685976083557,
                transform: 'matrix(0.8984214940208894, 0, 0, 0.8984214940208894, 0, 0)',
                x: 1458.1560302218038,
                y: 70.43582205737695
            },
            variant: {}
        }
    },
    '4CnARRMB3-vertical-rounded-progress-bar': {
        '16:9': {
            values: {
                alpha: 0.85,
                color1: '#FF4D6D',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 1000.7597001854509,
                width: 28.0644562547499,
                transform: 'matrix(0.7016114063687475, 0, 0, 0.7016114063687475, 0, 0)',
                x: 1838.0796531618705,
                y: 39.62014990727454
            },
            variant: {}
        },
        '9:16': {
            values: {
                alpha: 0.85,
                color1: '#FF4D6D',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 1281.4843328301963,
                width: 35.93685976083557,
                transform: 'matrix(0.8984214940208894, 0, 0, 0.8984214940208894, 0, 0)',
                x: 988.5174590224827,
                y: 70.43582205737695
            },
            variant: {}
        },
        '1:1': {
            values: {
                alpha: 0.85,
                color1: '#FF4D6D',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 871.2748199149326,
                width: 20.214483615470005,
                transform: 'matrix(0.5053620903867503, 0, 0, 0.5053620903867503, 0, 0)',
                x: 1025.2659587497058,
                y: 39.62014990727454
            },
            variant: {}
        },
        '4:5': {
            values: {
                alpha: 0.85,
                color1: '#FF4D6D',
                isAscendingTimer: false,
                roundEdges: true
            },
            space: {
                height: 1281.4843328301963,
                width: 35.93685976083557,
                transform: 'matrix(0.8984214940208894, 0, 0, 0.8984214940208894, 0, 0)',
                x: 1458.1560302218038,
                y: 70.43582205737695
            },
            variant: {}
        }
    },
    '0SnABHmB8-calorie-meter': {
        '16:9': {
            values: {
                color1: '#fff',
                textColor1: '#fff',
                text1: 'KCAL',
                alpha: 1,
                isAscendingTimer: true
            },
            space: {
                height: 56.835894013910305,
                transform: 'matrix(0.7578119201854707, 0, 0, 0.7578119201854707, 0, 0)',
                width: 445.90545493318893,
                x: 1409.5702783079382,
                y: 157.93759507472106
            },
            variant: {}
        },
        '9:16': {
            values: {
                color1: '#fff',
                textColor1: '#fff',
                text1: 'KCAL',
                alpha: 1,
                isAscendingTimer: true
            },
            space: {
                height: 108.13452675473926,
                transform: 'matrix(1.44179369006319, 0, 0, 1.44179369006319, 0, 0)',
                width: 848.3683802836995,
                x: 205.2279091786043,
                y: 243.8548698764272
            },
            variant: {}
        },
        '1:1': {
            values: {
                color1: '#fff',
                textColor1: '#fff',
                text1: 'KCAL',
                alpha: 1,
                isAscendingTimer: true
            },
            space: {
                height: 60.82567129954083,
                transform: 'matrix(0.8110089506605443, 0, 0, 0.8110089506605443, 0, 0)',
                width: 477.20721390958096,
                x: 565.2279091786042,
                y: 169.4760566131826
            },
            variant: {}
        },
        '4:5': {
            values: {
                color1: '#fff',
                textColor1: '#fff',
                text1: 'KCAL',
                alpha: 1,
                isAscendingTimer: true
            },
            space: {
                height: 94.97143862682371,
                transform: 'matrix(1.2662858483576496, 0, 0, 1.2662858483576496, 0, 0)',
                width: 745.097500114782,
                x: 687.5482500027883,
                y: 315.89743589743586
            },
            variant: {}
        }
    },
    'a8m98xKZp-calorie-meter': {
        '16:9': {
            values: {
                alpha: 0.85,
                color1: '#fff',
                color2: '#2f80ed',
                text1: 'CALORIES',
                textColor1: '#fff',
                isAscendingTimer: true
            },
            space: {
                height: 111.84940049683813,
                transform: 'matrix(0.6391394314105036, 0, 0, 0.6391394314105036, 0, 0)',
                width: 498.59522225519845,
                x: 1368.4615384615383,
                y: 108
            },
            variant: {}
        },
        '9:16': {
            values: {
                alpha: 0.85,
                color1: '#fff',
                color2: '#2f80ed',
                text1: 'CALORIES',
                textColor1: '#fff',
                isAscendingTimer: true
            },
            space: {
                height: 102.33003675221251,
                transform: 'matrix(0.8898264065409783, 0, 0, 0.8898264065409783, 0, 0)',
                width: 694.1571324409333,
                x: 319.37168987190773,
                y: 333.6510973103869
            },
            variant: {}
        },
        '1:1': {
            values: {
                alpha: 0.85,
                color1: '#fff',
                color2: '#2f80ed',
                text1: 'CALORIES',
                textColor1: '#fff',
                isAscendingTimer: true
            },
            space: {
                height: 57.56064567311954,
                transform: 'matrix(0.5005273536793003, 0, 0, 0.5005273536793003, 0, 0)',
                width: 390.463386998025,
                x: 617.5953079178886,
                y: 185.3511560301961
            },
            variant: {}
        },
        '4:5': {
            values: {
                alpha: 0.85,
                color1: '#fff',
                color2: '#2f80ed',
                text1: 'CALORIES',
                textColor1: '#fff',
                isAscendingTimer: true
            },
            space: {
                height: 102.33003675221251,
                transform: 'matrix(0.8898264065409783, 0, 0, 0.8898264065409783, 0, 0)',
                width: 694.1571324409333,
                x: 775.3716898719077,
                y: 317.0993731724559
            },
            variant: {}
        }
    },
    'GLB0tFs5WD-nonprofit-branded-outro': {
        '16:9': {
            values: {
                alpha: 1,
                text1: 'PHOENIX YOGA STUDIO',
                textColor1: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                shadow: true,
                lineHeight1: 1.4,
                letterSpacing1: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 320.17089223946294,
                width: 1293.664730878643,
                transform: 'matrix(0.9416790948219498, 0, 0, 0.9416790948219498, 0, 0)',
                x: 313.1676345606785,
                y: 159.2131244651688,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                text1: 'PHOENIX YOGA STUDIO',
                textColor1: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                shadow: true,
                lineHeight1: 1.4,
                letterSpacing1: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 264.602985851081,
                width: 1066.0823841641702,
                transform: 'matrix(0.7782440760325912, 0, 0, 0.7782440760325912, 0, 0)',
                x: 6.958807917914896,
                y: 684.665039433344,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                text1: 'PHOENIX YOGA STUDIO',
                textColor1: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                shadow: true,
                lineHeight1: 1.4,
                letterSpacing1: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 181.02856527318772,
                width: 729.3620056762131,
                transform: 'matrix(0.5324369566858462, 0, 0, 0.5324369566858462, 0, 0)',
                x: 164.91120979547532,
                y: 267.82560139347896,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                text1: 'PHOENIX YOGA STUDIO',
                textColor1: '#FFFFFF',
                fontFamily1: 'MONTSERRAT:SEMI_BOLD:NORMAL',
                shadow: true,
                lineHeight1: 1.4,
                letterSpacing1: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 100,
                cropHeight: 100,
                imageId: 'placeholder'
            },
            space: {
                height: 321.828560485667,
                width: 1296.643565646601,
                transform: 'matrix(0.9465545896637266, 0, 0, 0.9465545896637266, 0, 0)',
                x: 119.67821717669949,
                y: 519.8028069521522,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            }
        }
    },
    'rkWHb1S8CG-fitness-rep': {
        '16:9': {
            values: {
                color1: '#C8FF09',
                textColor1: '#FFFFFF$$$[38,{"color":"hsl(73.39999999999998, 100%, 51.7%)","start":26,"end":37}]',
                text1: 'SIDE CRUNCH \nW/ LEG RAISE\n(45 SECONDS)',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 197.88072505236232,
                width: 403.35712139068175,
                transform: 'matrix(0.47114458345800553, 0, 0, 0.47114458345800553, 0, 0)',
                x: 149.76116863379002,
                y: 774.1192749476377
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                color1: '#C8FF09',
                textColor1: '#FFFFFF$$$[38,{"color":"hsl(73.39999999999998, 100%, 51.7%)","start":26,"end":37}]',
                text1: 'SIDE CRUNCH \nW/ LEG RAISE\n(45 SECONDS)',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 293.3375423393607,
                width: 597.9348753776419,
                transform: 'matrix(0.6984227198556208, 0, 0, 0.6984227198556208, 0, 0)',
                x: 87.83487660162342,
                y: 1434.6624576606393
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                color1: '#C8FF09',
                textColor1: '#FFFFFF$$$[38,{"color":"hsl(73.39999999999998, 100%, 51.7%)","start":26,"end":37}]',
                text1: 'SIDE CRUNCH \nW/ LEG RAISE\n(45 SECONDS)',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 177.5630540939152,
                width: 361.9418836559619,
                transform: 'matrix(0.42276917641408385, 0, 0, 0.42276917641408385, 0, 0)',
                x: 87.57264543004764,
                y: 794.4369459060848
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                color1: '#C8FF09',
                textColor1: '#FFFFFF$$$[38,{"color":"hsl(73.39999999999998, 100%, 51.7%)","start":26,"end":37}]',
                text1: 'SIDE CRUNCH \nW/ LEG RAISE\n(45 SECONDS)',
                alpha: 1,
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                shadow: true,
                lineHeight: 1.2,
                letterSpacing: 0
            },
            space: {
                height: 315.6676517225159,
                width: 643.4522376105989,
                transform: 'matrix(0.7515896469583713, 0, 0, 0.7515896469583713, 0, 0)',
                x: 124.5477623894011,
                y: 1483.7645269903335
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'H1tfJBLCM-vintage-wedding': {
        '16:9': {
            values: {
                textColor1: '#FFADE3',
                alpha: 1,
                text1: 'Dancing Heart Studio',
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.42,
                letterSpacing: 33.333333333333314
            },
            space: {
                height: 217.29193091562007,
                width: 1742.3357390042606,
                transform: 'matrix(2.0402998208039445, 0, 0, 2.0402998208039445, 0, 0)',
                x: 88.83213049786968,
                y: 281.7731791830891
            }
        },
        '9:16': {
            values: {
                textColor1: '#FFADE3',
                alpha: 1,
                text1: 'Dancing Heart Studio',
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.42,
                letterSpacing: 33.333333333333314
            },
            space: {
                height: 132.04627090519466,
                width: 1023.7649045666888,
                transform: 'matrix(1.239871088311687, 0, 0, 1.239871088311687, 0, 0)',
                x: 28.117547716655622,
                y: 637.9342883045282,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            }
        },
        '1:1': {
            values: {
                textColor1: '#FFADE3',
                alpha: 1,
                text1: 'Dancing Heart Studio',
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.42,
                letterSpacing: 33.333333333333314
            },
            space: {
                height: 111.99391537265996,
                width: 815.3651069952994,
                transform: 'matrix(1.0515860598371827, 0, 0, 1.0515860598371827, 0, 0)',
                x: 132.31744650235032,
                y: 297.7660837651123,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                textColor1: '#FFADE3',
                alpha: 1,
                text1: 'Dancing Heart Studio',
                fontFamily1: 'RIGHTEOUS:NORMAL:NORMAL',
                align: 'center',
                shadow: true,
                lineHeight: 1.42,
                letterSpacing: 33.333333333333314
            },
            space: {
                height: 194.9911494554663,
                width: 1436.002436130878,
                transform: 'matrix(1.830902811788416, 0, 0, 1.830902811788416, 0, 0)',
                x: 49.99878193456095,
                y: 626.5952151633138,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'X6GYtjnqU0-work-out-challenge': {
        '16:9': {
            values: {
                alpha: 1,
                color1: '#4DAA18',
                color2: '#FFF',
                color3: '#FF0',
                textColor1: '#000',
                textColor2: '#FFFFFF',
                text1: 'UP NEXT',
                text2: 'STEP IN & OUT',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:EXTRA_BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                lineSpacing1: 0,
                lineSpacing2: 0,
                align: 'left'
            },
            space: {
                height: 158.77528260217693,
                width: 635.4881330407648,
                transform: 'matrix(0.8445493755434943, 0, 0, 0.8445493755434943, 0, 0)',
                x: 139.9206219367513,
                y: 817.2711082332204,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: '#4DAA18',
                color2: '#FFF',
                color3: '#FF0',
                textColor1: '#000',
                textColor2: '#FFFFFF',
                text1: 'UP NEXT',
                text2: 'STEP IN & OUT',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:EXTRA_BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                lineSpacing1: 0,
                lineSpacing2: 0,
                align: 'left'
            },
            space: {
                height: 198.25656579178914,
                width: 685.0515067303609,
                transform: 'matrix(1.054556201020155, 0, 0, 1.054556201020155, 0, 0)',
                x: 88.44783263199487,
                y: 1529.7434342082108,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: '#4DAA18',
                color2: '#FFF',
                color3: '#FF0',
                textColor1: '#000',
                textColor2: '#FFFFFF',
                text1: 'UP NEXT',
                text2: 'STEP IN & OUT',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:EXTRA_BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                lineSpacing1: 0,
                lineSpacing2: 0,
                align: 'left'
            },
            space: {
                height: 117.47530623474404,
                width: 405.92166629295514,
                transform: 'matrix(0.6248686501848087, 0, 0, 0.6248686501848087, 0, 0)',
                x: 73.90238062786598,
                y: 887.3101814119625,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: '#4DAA18',
                color2: '#FFF',
                color3: '#FF0',
                textColor1: '#000',
                textColor2: '#FFFFFF',
                text1: 'UP NEXT',
                text2: 'STEP IN & OUT',
                fontFamily1: 'LILITA_ONE:NORMAL:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                fontFamily2: 'POPPINS:EXTRA_BOLD:NORMAL',
                lineHeight2: 1.2,
                letterSpacing2: 0,
                lineSpacing1: 0,
                lineSpacing2: 0,
                align: 'left'
            },
            space: {
                height: 205.4008799063748,
                width: 709.737817265427,
                transform: 'matrix(1.0925578718424191, 0, 0, 1.0925578718424191, 0, 0)',
                x: 142.7196607404381,
                y: 1571.0372542630607,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'DISPLAY',
                    bold: false,
                    italic: false
                },
                fontFamily2: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                }
            }
        }
    },
    'CRzZDRomd-yoga-challenge': {
        '16:9': {
            values: {
                alpha: 1,
                color1: '#FFFFFF',
                text1: 'Full Body Stretch',
                textColor1: 'rgb(255, 255, 255)',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: '20 min | Yoga for \nstress & anxiety relief',
                textColor2: 'rgb(255, 144, 174)',
                fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
                lineHeight2: 1.2333333333333334,
                letterSpacing2: 0,
                shadow: true,
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 179.48260317986058,
                width: 483.7109119610679,
                transform: 'matrix(0.5638196958529651, 0, 0, 0.5638196958529651, 0, 0)',
                x: 139.9206219367513,
                y: 792.5173968201394,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                alpha: 1,
                color1: '#FFFFFF',
                text1: 'Full Body Stretch',
                textColor1: 'rgb(255, 255, 255)',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: '20 min | Yoga for \nstress & anxiety relief',
                textColor2: 'rgb(255, 144, 174)',
                fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
                lineHeight2: 1.2333333333333334,
                letterSpacing2: 0,
                shadow: true,
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 277.1063569969179,
                width: 687.4141199340958,
                transform: 'matrix(0.8704911738123075, 0, 0, 0.8704911738123075, 0, 0)',
                x: 80.51680822025082,
                y: 1450.8936430030822,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                alpha: 1,
                color1: '#FFFFFF',
                text1: 'Full Body Stretch',
                textColor1: 'rgb(255, 255, 255)',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: '20 min | Yoga for \nstress & anxiety relief',
                textColor2: 'rgb(255, 144, 174)',
                fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
                lineHeight2: 1.2333333333333334,
                letterSpacing2: 0,
                shadow: true,
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 162.89671569790013,
                width: 404.09575469563146,
                transform: 'matrix(0.5117174315117281, 0, 0, 0.5117174315117281, 0, 0)',
                x: 79.61637701169234,
                y: 825.1160801564027,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                alpha: 1,
                color1: '#FFFFFF',
                text1: 'Full Body Stretch',
                textColor1: 'rgb(255, 255, 255)',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                lineHeight1: 1.2,
                letterSpacing1: 0,
                text2: '20 min | Yoga for \nstress & anxiety relief',
                textColor2: 'rgb(255, 144, 174)',
                fontFamily2: 'CORMORANT:MEDIUM:NORMAL',
                lineHeight2: 1.2333333333333334,
                letterSpacing2: 0,
                shadow: true,
                lineSpacing1: 0,
                lineSpacing2: 0
            },
            space: {
                height: 289.59416124071134,
                width: 718.3924527922337,
                transform: 'matrix(0.9097198782430722, 0, 0, 0.9097198782430722, 0, 0)',
                x: 119.98877887932053,
                y: 1486.5797762571956,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: true,
                    italic: false
                },
                fontFamily2: {
                    category: 'SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    'HyfE1rIRz-insider-social-media': {
        '16:9': {
            values: {
                align: 'center',
                alpha: 0.8,
                color1: '#00ABF1',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.42,
                text1: 'Take a 30 second break\nHit PAUSE to take a longer break',
                textColor1: '#FFFFFF'
            },
            space: {
                height: 156.3031254915071,
                width: 1193.7408744066265,
                transform: 'matrix(0.8687277491494966, 0, 0, 0.8687277491494966, 0, 0)',
                x: 363.12956279668674,
                y: 588.3152999240699
            }
        },
        '9:16': {
            values: {
                align: 'center',
                alpha: 0.8,
                color1: '#00ABF1',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.42,
                text1: 'Take a 30 second break\nHit PAUSE to take a longer break',
                textColor1: '#FFFFFF'
            },
            space: {
                height: 138.54828558999995,
                width: 979.2415793367832,
                transform: 'matrix(0.7700469194754663, 0, 0, 0.7700469194754663, 0, 0)',
                x: 50.37921033160842,
                y: 1269.1462743715078
            }
        },
        '1:1': {
            values: {
                align: 'center',
                alpha: 0.8,
                color1: '#00ABF1',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.42,
                text1: 'Take a 30 second break\nHit PAUSE to take a longer break',
                textColor1: '#FFFFFF'
            },
            space: {
                height: 109.04459116810318,
                width: 770.7132370412701,
                transform: 'matrix(0.6060663338913246, 0, 0, 0.6060663338913246, 0, 0)',
                x: 154.64338147936496,
                y: 549.4154931171454
            }
        },
        '4:5': {
            values: {
                align: 'center',
                alpha: 0.8,
                color1: '#00ABF1',
                fontFamily1: 'MONTSERRAT:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.42,
                text1: 'Take a 30 second break\nHit PAUSE to take a longer break',
                textColor1: '#FFFFFF'
            },
            space: {
                height: 174.67483385025625,
                width: 1234.5794063168187,
                transform: 'matrix(0.9708371138876595, 0, 0, 0.9708371138876595, 0, 0)',
                x: 150.71029684159066,
                y: 1201.8538942913754
            }
        }
    },
    'HyRSUR9g7-line-by-line-one': {
        '16:9': {
            values: {
                text1: 'This episode is sponsored by FitnessShark.\nUse code FIT50 to shop now and \nreceive 50% at checkout.',
                alpha: 1,
                color1: '#F3BC28',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.5513020833333335,
                lineSpacing: 23.190184049079754,
                shadow: false,
                textColor1: '#000000'
            },
            space: {
                height: 259.93859172179566,
                width: 1514.4484590776842,
                transform: 'matrix(0.8217537103079546, 0, 0, 0.8217537103079546, 0, 0)',
                x: 202.7757704611579,
                y: 564.6013667425968,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '9:16': {
            values: {
                text1: 'This episode is sponsored by FitnessShark.\nUse code FIT50 to shop now and \nreceive 50% at checkout.',
                alpha: 1,
                color1: '#F3BC28',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.5513020833333335,
                lineSpacing: 23.190184049079754,
                shadow: false,
                textColor1: '#000000'
            },
            space: {
                height: 351.47253928834306,
                width: 948.4591157895771,
                transform: 'matrix(0.8183439731938527, 0, 0, 0.8183439731938527, 0, 0)',
                x: 65.77044210521143,
                y: 960,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '1:1': {
            values: {
                text1: 'This episode is sponsored by FitnessShark.\nUse code FIT50 to shop now and \nreceive 50% at checkout.',
                alpha: 1,
                color1: '#F3BC28',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.5513020833333335,
                lineSpacing: 23.190184049079754,
                shadow: false,
                textColor1: '#000000'
            },
            space: {
                height: 151.32539526826497,
                width: 866.7711108612223,
                transform: 'matrix(0.47839070067212225, 0, 0, 0.47839070067212225, 0, 0)',
                x: 106.61444456938887,
                y: 540,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        },
        '4:5': {
            values: {
                text1: 'This episode is sponsored by FitnessShark.\nUse code FIT50 to shop now and \nreceive 50% at checkout.',
                alpha: 1,
                color1: '#F3BC28',
                fontFamily1: 'LATO:ULTRA_BOLD:NORMAL',
                letterSpacing: 0,
                lineHeight: 1.5513020833333335,
                lineSpacing: 23.190184049079754,
                shadow: false,
                textColor1: '#000000'
            },
            space: {
                height: 279.2003971973443,
                width: 1448.5284738041003,
                transform: 'matrix(0.8826467851373468, 0, 0, 0.8826467851373468, 0, 0)',
                x: 43.73576309794987,
                y: 1130.5694760820045,
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                }
            },
            variant: {
                fontFamily1: {
                    category: 'SANS_SERIF',
                    bold: false,
                    italic: false
                }
            }
        }
    },
    '8y5tOoome-event-experience-caption': {
        '16:9': {
            values: {
                color1: 'rgb(255, 249, 82)',
                textColor1: '#000000$$$[122,{"color":"rgb(0, 0, 0)","start":33,"end":35}]',
                alpha: 0.9005208333333333,
                align: 'center',
                text1: 'Please consult a health professional before starting any workout. Especially if you have any underlying health conditions.',
                fontFamily1: 'PORT_LLIGAT_SLAB:NORMAL:NORMAL',
                lineHeight: 1.2091145833333332,
                letterSpacing: 0,
                lineSpacing: 0
            },
            space: {
                height: 217.7147093051,
                width: 1559.7554156554334,
                transform: 'matrix(0.8002723179281443, 0, 0, 0.8002723179281443, 0, 0)',
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                },
                x: 180.12229217228332,
                y: 557.6095080172735
            }
        },
        '9:16': {
            values: {
                color1: 'rgb(255, 249, 82)',
                textColor1: '#000000$$$[122,{"color":"rgb(0, 0, 0)","start":33,"end":35}]',
                alpha: 0.9005208333333333,
                align: 'center',
                text1: 'Please consult a health professional before starting any workout. Especially if you have any underlying health conditions.',
                fontFamily1: 'PORT_LLIGAT_SLAB:NORMAL:NORMAL',
                lineHeight: 1.2091145833333332,
                letterSpacing: 0,
                lineSpacing: 0
            },
            space: {
                height: 251.6146594557062,
                width: 847.4084310989256,
                transform: 'matrix(0.6936609177327245, 0, 0, 0.6936609177327245, 0, 0)',
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                },
                x: 116.29578445053721,
                y: 1476.3853405442937
            }
        },
        '1:1': {
            values: {
                color1: 'rgb(255, 249, 82)',
                textColor1: '#000000$$$[122,{"color":"rgb(0, 0, 0)","start":33,"end":35}]',
                alpha: 0.9005208333333333,
                align: 'center',
                text1: 'Please consult a health professional before starting any workout. Especially if you have any underlying health conditions.',
                fontFamily1: 'PORT_LLIGAT_SLAB:NORMAL:NORMAL',
                lineHeight: 1.2091145833333332,
                letterSpacing: 0,
                lineSpacing: 0
            },
            space: {
                height: 147.66996918098022,
                width: 880.8247977918521,
                transform: 'matrix(0.5428029594418974, 0, 0, 0.5428029594418974, 0, 0)',
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                },
                x: 99.58760110407394,
                y: 540
            }
        },
        '4:5': {
            values: {
                color1: 'rgb(255, 249, 82)',
                textColor1: '#000000$$$[122,{"color":"rgb(0, 0, 0)","start":33,"end":35}]',
                alpha: 0.9005208333333333,
                align: 'center',
                text1: 'Please consult a health professional before starting any workout. Especially if you have any underlying health conditions.',
                fontFamily1: 'PORT_LLIGAT_SLAB:NORMAL:NORMAL',
                lineHeight: 1.2091145833333332,
                letterSpacing: 0,
                lineSpacing: 0
            },
            space: {
                height: 225.8084737058422,
                width: 1278.4417526039408,
                transform: 'matrix(0.8300232503222861, 0, 0, 0.8300232503222861, 0, 0)',
                referenceCanvas: {
                    width: 1920,
                    height: 1080
                },
                x: 128.7791236980296,
                y: 1157.9255420631148
            }
        }
    },
    'defId-userBitmap-typito-square-logo': {
        '16:9': {
            space: {
                height: 315.76923076923066,
                transform: 'matrix(0.7894230769230768, 0, 0, 0.7894230769230768, 0, 0)',
                width: 315.76923076923066,
                x: 802.1153846153846,
                y: 167.53969049515288
            },
            values: {
                alpha: 1,
                crop: 'none',
                imageId: 'typito-square-logo',
                shadow: false
            }
        }
    },
    'defId-userAssetsvg-iconscout-fitness-promotion-icon': {
        '16:9': {
            space: {
                height: 657.3103448275862,
                transform: 'matrix(1.014367816091954, 0, 0, 1.014367816091954, 0, 0)',
                width: 657.310344827586,
                x: 631.344827586207,
                y: 211.34482758620692
            },
            values: {
                alpha: 1,
                shadow: false
            }
        }
    }
};

// used for categorization of above ids map for template config
var DefaultFitnessTemplateSelectionMap = {
    textEffects: {
        key: 'textEffects',
        label: 'Text Effects',
        types: ['primaryText', 'secondaryText', 'paragraph']
    },
    timers: {
        key: 'timers',
        label: 'Timers',
        types: ['stepTimers', 'restTimers']
    },
    socialMedia: {
        key: 'socialMedia',
        label: 'Social Media',
        types: ['instagram', 'youTube', 'facebook']
    },
    extras: {
        key: 'extras',
        label: 'More',
        types: ['progressBar', 'calorieMeter']
    }
};

var getTemplateStyleGroup = function getTemplateStyleGroup(style) {
    return Object.keys(DefaultFitnessTemplateSelectionMap).find(function (tt) {
        return DefaultFitnessTemplateSelectionMap[tt].types.includes(style);
    });
};

exports.FitnessTemplateIdsMap = FitnessTemplateIdsMap;
exports.DefaultFitnessTemplateSelectionMap = DefaultFitnessTemplateSelectionMap;
exports.getTemplateStyleGroup = getTemplateStyleGroup;
exports.FitnessTemplateConfigsByFormat = FitnessTemplateConfigsByFormat;
exports.PossibleFormatsForFitnessTemplates = PossibleFormatsForFitnessTemplates;

},{"keymirror":677}],203:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CAPTION_FREE_LIMIT_IN_MINS = exports.CAPTION_FREE_LIMIT = exports.OVERLAY_PROPERTIES_KEYS = exports.MIN_CAPTION_DURATION_MS = exports.DefaultTabLineup = exports.Sections = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _PluginService = require('../../common/constants/PluginService');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// FILE TO BE USED FOR CONSISTENT NAMING
// OF EACH SECTION
// ID has to be same as the key
var Sections = exports.Sections = {
    ONBOARDING: {
        id: 'ONBOARDING',
        title: 'Guide',
        iconId: 'bulb-progression',
        showHelpIcon: true
    },

    'ONBOARDING-FITNESS': {
        id: 'ONBOARDING',
        title: 'Guide',
        iconId: 'fitness-guide'
    },

    TEXT: {
        id: 'TEXT',
        title: 'Text',
        iconId: 'text-effects',
        header: 'Text Effects',
        showHelpIcon: true,
        topNormal: 60,
        topSmall: 60,
        enabled: true,
        subSections: (0, _keymirror2.default)({
            STYLE_TEXT: null,
            GLOBAL: null
        })
    },
    AUDIO: {
        id: 'AUDIO',
        title: 'Music',
        iconId: 'music',
        header: 'Music Library',
        topNormal: 180,
        topSmall: 180,
        enabled: true
    },
    SUBTITLES: {
        id: 'SUBTITLES',
        title: 'Subtitles',
        iconId: 'captions',
        header: 'Subtitles',
        topNormal: 300,
        topSmall: 300,
        enabled: false
    },
    IMAGES: {
        id: 'IMAGES', // TODO change this to elements without breaking everything
        title: 'Elements',
        iconId: 'elements',
        header: 'Elements',
        topNormal: 120,
        topSmall: 120,
        subSections: (0, _keymirror2.default)({
            GLOBAL: null,
            SHAPES: null,
            ICONS: null
        }),
        enabled: true
    },
    PLUGINS: {
        id: 'PLUGINS',
        title: 'Plugins',
        iconId: 'plugins',
        enabled: true,
        pluginsConstants: {
            // has only dynamic stuff
            globalView: 'GLOBAL'
        }
    },
    VIDEOS: {
        id: 'VIDEOS',
        title: 'My Media',
        iconId: 'my-media',
        header: 'My Media',
        topNormal: 240,
        topSmall: 240,
        enabled: true,
        subSections: (0, _keymirror2.default)({
            PHOTOS_VIDEOS: null,
            AUDIO: null,
            CLIPBOARD: null,
            SEQUENCE: null,
            GLOBAL: null
        }),
        subSectionsProperties: {
            PHOTOS_VIDEOS: {
                name: 'Photos & Videos'
            },
            AUDIO: {
                name: 'Audio'
            },
            CLIPBOARD: {
                name: 'Clipboard'
            },
            SEQUENCE: {
                name: 'Sequence'
            },
            GLOBAL: {
                name: 'My Media'
            }
        }
    },
    COLLECTIONS: {
        id: 'COLLECTIONS',
        title: 'Stock',
        iconId: 'stock-media',
        header: 'Stock Media',
        topNormal: 240,
        topSmall: 240,
        enabled: true,
        subSections: (0, _keymirror2.default)({
            GLOBAL: null,
            PHOTOS: null,
            VIDEOS: null,
            VIDEO_TEMPLATES: null,
            RECENTLY_USED: null
        }),
        subSectionsProperties: {
            PHOTOS: {
                name: 'Images'
            },
            VIDEOS: {
                name: 'Videos'
            },
            RECENTLY_USED: {
                name: 'Recently Used'
            },
            VIDEO_TEMPLATES: {
                name: 'Templates'
            },
            GLOBAL: {
                name: 'Stock Media'
            }
        }
    },

    HELP: {
        id: 'HELP',
        title: '',
        iconId: 'intro-video'
    },
    PLACEHOLDER: {
        duration: {
            max: 3600,
            min: 1
        }
    }
};

var DefaultTabLineup = exports.DefaultTabLineup = [Sections.ONBOARDING.id, Sections.VIDEOS.id, Sections.COLLECTIONS.id, Sections.TEXT.id, Sections.IMAGES.id, Sections.AUDIO.id,
// HACK PROD -  DISABLING PLUGIN TAB UNTIL PLUGIN IS READY FOR PROD and RE-ENABLING PLUGIN HERE
// THIS WILL ENABLED PLUGIN BY DEFAULT
Sections.SUBTITLES.id];

var MIN_CAPTION_DURATION_MS = exports.MIN_CAPTION_DURATION_MS = 500;

var OVERLAY_PROPERTIES_KEYS = exports.OVERLAY_PROPERTIES_KEYS = (0, _keymirror2.default)({
    ALL: null,
    FONT: null,
    TIMER: null
});

var CAPTION_FREE_LIMIT = exports.CAPTION_FREE_LIMIT = 30 * 60 * 1000; // 30 mins in MS

var CAPTION_FREE_LIMIT_IN_MINS = exports.CAPTION_FREE_LIMIT_IN_MINS = 30; // 30 mins

},{"../../common/constants/PluginService":65,"keymirror":677}],204:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = [{
    stepIndex: 1,
    id: 'SELECT_FORMAT',
    label: 'Choose a video format',
    desc: 'Pick an appropriate video format to design your video',
    completedDesc: function completedDesc(_ref) {
        var formatLabel = _ref.formatLabel;
        return 'Awesome, you\u2019ve chosen ' + formatLabel + '. You can try out other formats if needed. ';
    },
    CTALabel: 'Choose a format',
    completedCTA: 'Change selected format', // null for avoiding Completed CTA
    canMarkComplete: false,
    defaultComplete: false,
    avoidCTA: false,
    avoidShow: false,
    avoidPersist: false
}, {
    stepIndex: 2,
    id: 'UPLOAD_MEDIA',
    label: 'Add media',
    desc: function desc(_ref2) {
        var openCollection = _ref2.openCollection;
        return _react2.default.createElement(_react.Fragment, null, 'Add photos and video clips to design a stunning video. Or, browse our', ' ', _react2.default.createElement('a', { href: '#', onClick: openCollection }, _react2.default.createElement('u', null, 'stock media ')), 'for high-quality media.');
    },
    completedDesc: function completedDesc(_ref3) {
        var fileName = _ref3.fileName;
        return 'You have successfully added ' + fileName + '. You can add multiple images and video clips to the project.';
    },
    CTALabel: 'Add media',
    completedCTA: 'Add more media',
    canMarkComplete: false,
    defaultComplete: false,
    avoidCTA: false,
    avoidShow: false,
    avoidPersist: false,
    modalProperty: {
        partial: true
    }
}, {
    stepIndex: 3,
    id: 'EDIT_VIDEO',
    label: 'Edit video',
    desc: function desc(_ref4) {
        var openTextShelf = _ref4.openTextShelf,
            openElements = _ref4.openElements,
            openMusic = _ref4.openMusic;
        return _react2.default.createElement(_react.Fragment, null, 'Make your video stand out. You can add', ' ', _react2.default.createElement('a', { href: '#', onClick: openTextShelf }, _react2.default.createElement('u', null, 'text effects')), ',', ' ', _react2.default.createElement('a', { href: '#', onClick: openElements }, _react2.default.createElement('u', null, 'elements')), ', and', ' ', _react2.default.createElement('a', { href: '#', onClick: openMusic }, _react2.default.createElement('u', null, 'music')), '.');
    },
    completedDesc: 'Well done. You can edit and personalize the video to match your style or brand.',
    CTALabel: 'Add text effect',
    completedCTA: 'Add more text effects',
    canMarkComplete: true,
    defaultComplete: false,
    avoidCTA: false,
    avoidShow: false,
    avoidPersist: false
},

/// WILL NOT BE SHOWN OLDER STATES ALREADY IN DATABASE , will be use as substep of EDIT_VIDEO
{
    stepIndex: 4,
    id: 'ADD_TEXT',
    label: 'Add a text effect',
    desc: 'Make your message stand out. Explore a collection of titles, lower-thirds, CTAs, and stylized text effects to add to your video.',
    completedDesc: 'Well done. Customize the way your text appears to make your video stand out. Edit the text to match your video style or brand.',
    CTALabel: 'Add Text Effect',
    completedCTA: 'Add more Text Effect',
    canMarkComplete: true,
    defaultComplete: false,
    avoidCTA: false,
    avoidShow: true,
    avoidPersist: false
}, {
    stepIndex: 5,
    id: 'ADD_MUSIC',
    label: 'Add music to your video',
    completedDesc: 'Nicely done. Replace this track with another track if needed.',
    desc: 'Use audio to enhance your video. Upload an audio track or choose royalty-free music from our Music Library.',
    CTALabel: 'Add music',
    completedCTA: 'Replace music',
    canMarkComplete: true,
    defaultComplete: false,
    avoidCTA: false,
    avoidShow: true,
    avoidPersist: false
},

/// / SUBSTEP ENDS

{
    stepIndex: 6,
    id: 'EXPORT',
    label: 'Preview and export',
    desc: 'You’re almost done. Preview your video to make any final changes before you export.',
    CTALabel: 'Export video',
    canMarkComplete: false,
    defaultComplete: false,
    avoidCTA: false,
    avoidShow: false,
    avoidPersist: false,
    modalProperty: {
        canShowError: true,
        partial: true
    }
}];

},{"react":1107}],205:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var OverlayHandleTypes = keymirror({
    TOP_LEFT: null, //tl
    TOP_RIGHT: null, //tr
    BOTTOM_LEFT: null, //bl
    BOTTOM_RIGHT: null, //br
    BOTTOM: null, //b
    TOP: null, //t
    RIGHT: null, //r
    LEFT: null, //l
    BOTTOM_LINE_HEIGHT: null, //blh
    BOTTOM_LINE_SPACING: null //bls
});

module.exports = OverlayHandleTypes;

},{"keymirror":677}],206:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _keymirror2.default)({
    OPTIONS: 'Options',
    PROJECT: 'Project'
});

},{"keymirror":677}],207:[function(require,module,exports){
'use strict';

var keymirror = require('keymirror');

var SubtitlePosition = keymirror({
    BOTTOM: null,
    MIDDLE: null,
    TOP: null
});

module.exports = SubtitlePosition;

},{"keymirror":677}],208:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SubtitleWidthMap = exports.SubtitleWidthMap = {
    '1:1': 80,
    '16:9': 50,
    '9:16': 72
};

module.exports = SubtitleWidthMap;

},{}],209:[function(require,module,exports){
arguments[4][98][0].apply(exports,arguments)
},{"dup":98,"keymirror":677}],210:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkspaceUpgradeStatus = undefined;

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var WorkspaceUpgradeStatus = exports.WorkspaceUpgradeStatus = (0, _keymirror2.default)({
    INITIAL: null,
    UPDATING: null,
    UPDATED: null
});

module.exports = WorkspaceUpgradeStatus;

},{"keymirror":677}],211:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _fastdom = require("fastdom");

var _fastdom2 = _interopRequireDefault(_fastdom);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CommonAlgorithms = require("../../common/utils/CommonAlgorithms");

var _rafDebounce = require("../utils/rafDebounce");

var _rafDebounce2 = _interopRequireDefault(_rafDebounce);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT_PARAMS = {
    strictMouseDownTargetCheck: true,
    strictMouseUpTargetCheck: true,
    preventDefaultOnMouseDown: false,
    preventDefaultOnHandleMouseDown: true,

    debounceEvents: false,

    enableLogging: false,

    useDefaults: false

    // Usage Guide :
    // This mixin helps a component to detect a 'pure' click
    // ( i.e. without any dragging between mousedown and mouseup )
    // and also helps with drag behavior
    //
    // To use :
    // 1) attach 'clickDragMixinMouseDown' and 'clickDragMixinMouseUp' on the component
    // 2) override 'onPureClick()' to do something on pure click
    // 3) override 'onDragMove(deltaX, deltaY)' to respond to drag.
    //    deltaX, deltaY are the distances moved by the mouse since the drag started.
    // 4) By default, the mousedown and mouseup have strict checks to ignore if the event
    //    is in capture/bubbling phase ( only target phase is handled ). This is sometimes not desirable.
    //    This behavior can be controlled by defining a property on your component with name
    //    'clickDragMixinParams' as an object with optional properties 'strictMouseDownTargetCheck' and
    //    'strictMouseDownTargetCheck'. Setting these properties to false should help.

};var ClickDragMixin = function ClickDragMixin(ComposedComponent) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (_Component) {
        _inherits(_class, _Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.params = _extends({}, DEFAULT_PARAMS, params);
            _this.state = { dragging: false, dragLeftPercent: 0, rotating: false, startAngle: 0 };

            _this.track = null;
            _this.handle = null;

            _this._clickDragMixinDidMouseDown = false;
            _this._clickDragMixinDidDrag = false;
            _this._clickDragMixinDidRotate = false;
            _this._clickDragMixinFlagFireDragStart = false;
            _this._clickDragMixinFlagFireRotateStart = false;
            _this._clickDragMixinData = {};
            _this._clickDragMixinMouseMoveData = { lastX: 0, lastY: 0 };
            _this._startLeftPercent = 0;
            _this.R2D = 180 / Math.PI;

            _this.dragCallbacks = {
                refTrack: function refTrack(c) {
                    _this.track = c;
                },
                refHandle: function refHandle(c) {
                    _this.handle = c;
                },
                onTrackMouseUp: function onTrackMouseUp(e) {
                    return _this.trackMouseUp(e);
                },
                onTrackMouseDown: function onTrackMouseDown(e) {
                    return _this.trackMouseDown(e);
                },
                onTrackRotateMouseDown: function onTrackRotateMouseDown(e) {
                    return _this.trackMouseDown(e, true);
                },
                onHandleMouseDown: function onHandleMouseDown(e) {
                    return _this.handleMouseDown(e);
                },
                onIgnoreMouseDown: function onIgnoreMouseDown(e) {
                    return _this.ignoreMouseDown(e);
                }
            };
            return _this;
        }

        _createClass(_class, [{
            key: "getClickDragMixinParamOrDefault",
            value: function getClickDragMixinParamOrDefault(param) {
                return this.params[param];
            }
        }, {
            key: "isLoggingEnabled",
            value: function isLoggingEnabled() {
                return this.getClickDragMixinParamOrDefault('enableLogging');
            }
        }, {
            key: "log",
            value: function log() {
                if (this.isLoggingEnabled()) {
                    console.log.apply(console, arguments);
                }
            }
        }, {
            key: "debounceIfNeeded",
            value: function debounceIfNeeded(f) {
                var wrapFunc = function wrapFunc(fn) {
                    return fn;
                };

                if (this.getClickDragMixinParamOrDefault('debounceEvents')) {
                    wrapFunc = function wrapFunc(fn) {
                        var id = null;
                        return function () {
                            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                                args[_key] = arguments[_key];
                            }

                            _fastdom2.default.clear(id);
                            id = _fastdom2.default.measure(function () {
                                fn.apply(undefined, args);
                            });
                        };
                    };
                }
                return wrapFunc(f);
            }
        }, {
            key: "_windowMouseMove",
            value: function _windowMouseMove(e, isRotate) {

                this.log('windowMouseMove');

                if (e.clientX == this._clickDragMixinMouseMoveData.lastX && e.clientY == this._clickDragMixinMouseMoveData.lastY) {
                    return;
                }

                this._clickDragMixinMouseMoveData.lastX = e.clientX;
                this._clickDragMixinMouseMoveData.lastY = e.clientY;

                if (this._clickDragMixinFlagFireDragStart) {
                    this._clickDragMixinFlagFireDragStart = false;
                    this._onDragStart(e);
                } else if (this._clickDragMixinFlagFireRotateStart) {
                    this._clickDragMixinFlagFireRotateStart = false;
                    this._onRotateStart(e);
                }

                if (isRotate) {
                    this._clickDragMixinDidRotate = true;
                    this._onRotateMove(e);
                } else {
                    this._clickDragMixinDidDrag = true;

                    // Fixes missing clientX data , happens in certain cases when browser goas out of focus
                    if (!this._clickDragMixinData.mouseStartX && this.params.useDefaults) {
                        this._clickDragMixinData.mouseStartX = 0;
                    }

                    // Fixes missing clinetY data , happens in certain cases when browser goas out of focus
                    if (!this._clickDragMixinData.mouseStartY && this.params.useDefaults) {
                        this._clickDragMixinData.mouseStartY = 0;
                    }

                    this._onDragMove(e.clientX - this._clickDragMixinData.mouseStartX, e.clientY - this._clickDragMixinData.mouseStartY);
                }
            }
        }, {
            key: "_windowMouseUp",
            value: function _windowMouseUp(e) {

                this.log('windowMouseUp');

                window.removeEventListener('mousemove', this._windowMouseMoveCallback, true);
                window.removeEventListener('mouseup', this._windowMouseUpCallback, false);

                this._windowMouseMoveCallback = null;
                this._windowMouseUpCallback = null;

                if (this._clickDragMixinDidDrag) {
                    this._onDragEnd();
                } else if (this._clickDragMixinDidRotate) {
                    this._onRotateEnd();
                }

                this._clickDragMixinDidMouseDown = false;
                this._clickDragMixinDidDrag = false;
                this._clickDragMixinDidRotate = false;
                this._clickDragMixinData = {};
            }
        }, {
            key: "_onDragStart",
            value: function _onDragStart(e) {

                this.log('onDragStart');

                if (this.track) {
                    var handlePageX = e.pageX;
                    var trackBox = this.track.getBoundingClientRect();
                    var trackPageX = trackBox.left;
                    var trackWidth = trackBox.width;

                    var handleLeft = Math.max(0, Math.min(trackWidth, handlePageX - trackPageX));

                    var dragLeftPercent = handleLeft / trackWidth * 100;

                    this._startLeftPercent = dragLeftPercent;

                    this.setState({ dragLeftPercent: dragLeftPercent, dragging: true });
                } else {
                    this.setState({ dragging: true });
                }

                if (this.compEl && this.compEl.onDragStart) {
                    this.compEl.onDragStart.bind(this.compEl)(e);
                }
            }
        }, {
            key: "_onDragMove",
            value: function _onDragMove(deltaX, deltaY) {

                this.log('onDragMove');

                if (this.track) {
                    var handleStartLeftPercent = this._startLeftPercent;

                    var trackBox = this.track.getBoundingClientRect();
                    var trackWidth = trackBox.width;

                    var handleStartLeft = handleStartLeftPercent / 100 * trackWidth;

                    var handleCurrentLeft = Math.max(0, Math.min(trackWidth, handleStartLeft + deltaX));

                    var dragLeftPercent = (0, _CommonAlgorithms.clamp)(handleCurrentLeft / trackWidth * 100, 100, 0);

                    this.setState({ dragLeftPercent: dragLeftPercent });
                }

                if (this.compEl && this.compEl.onDragMove) {
                    this.compEl.onDragMove.bind(this.compEl)(deltaX, deltaY);
                }
            }
        }, {
            key: "_onDragEnd",
            value: function _onDragEnd() {

                this.log('onDragEnd');

                this.setState({ dragging: false });

                this._startLeftPercent = 0;

                if (this.compEl && this.compEl.onDragEnd) {
                    this.compEl.onDragEnd.bind(this.compEl)();
                }
            }
        }, {
            key: "_onRotateStart",
            value: function _onRotateStart(e) {

                this.log('onRotateStart');

                if (this.track) {

                    var parentElement = this.track.getBoundingClientRect();
                    if (parentElement) {
                        this._clickDragMixinData = {
                            center: {
                                x: parentElement.left + parentElement.width / 2,
                                y: parentElement.top + parentElement.height / 2
                            }
                        };
                        var x = e.clientX - this._clickDragMixinData.center.x;
                        var y = e.clientY - this._clickDragMixinData.center.y;
                        var startAngle = this.R2D * Math.atan2(y, x);

                        this.setState({ rotating: true, startAngle: startAngle });
                    }
                } else {
                    this.setState({ rotating: true });
                }

                if (this.compEl && this.compEl.onRotateStart) {
                    this.compEl.onRotateStart.bind(this.compEl)(e);
                }
            }
        }, {
            key: "_onRotateMove",
            value: function _onRotateMove(e) {

                this.log('onRotateMove');

                var deltaAngle = 0;

                // Applying defaults 
                if (!this._clickDragMixinData.center && this.params.useDefaults) {
                    this._clickDragMixinData.center = {};
                }

                if (!this._clickDragMixinData.center.x && this.params.useDefaults) {
                    this._clickDragMixinData.center.x = 0;
                }

                if (!this._clickDragMixinData.center.y && this.params.useDefaults) {
                    this._clickDragMixinData.center.y = 0;
                }

                if (this.track) {
                    var x = e.clientX - this._clickDragMixinData.center.x;
                    var y = e.clientY - this._clickDragMixinData.center.y;

                    deltaAngle = this.R2D * Math.atan2(y, x) - this.state.startAngle;

                    document.body.style.cursor = 'none'; // sets entire html body's cursor to none until mouse up event
                }

                if (this.compEl && this.compEl.onRotateMove) {
                    this.compEl.onRotateMove.bind(this.compEl)(e, deltaAngle);
                }
            }
        }, {
            key: "_onRotateEnd",
            value: function _onRotateEnd() {

                this.log('onRotateEnd');

                this.setState({ rotating: false, startAngle: 0 });

                document.body.style.cursor = 'auto';

                if (this.compEl && this.compEl.onRotateEnd) {
                    this.compEl.onRotateEnd.bind(this.compEl)();
                }
            }
        }, {
            key: "_onPureClick",
            value: function _onPureClick(e) {

                this.log('onPureClick');

                if (this.track) {
                    var trackBox = this.track.getBoundingClientRect();

                    var trackPageX = trackBox.left;
                    var trackWidth = trackBox.width;
                    var mouseX = e.pageX;

                    var clickLeftPercent = (mouseX - trackPageX) / trackWidth * 100;

                    if (this.compEl && this.compEl.onPureClick) {
                        this.compEl.onPureClick.bind(this.compEl)(e, clickLeftPercent);
                    }
                } else {
                    if (this.compEl && this.compEl.onPureClick) {
                        this.compEl.onPureClick.bind(this.compEl)(e);
                    }
                }
            }
        }, {
            key: "trackMouseDown",
            value: function trackMouseDown(e) {
                var _this2 = this;

                var isRotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                this.log('trackMouseDown');

                if (e.defaultPrevented) {
                    return;
                }

                this.log('trackMouseDown will go through');

                this._clickDragMixinDidMouseDown = false;
                this._clickDragMixinDidDrag = false;
                this._clickDragMixinDidRotate = false;
                this._clickDragMixinFlagFireDragStart = false;
                this._clickDragMixinData = {};

                if (!this.getClickDragMixinParamOrDefault('strictMouseDownTargetCheck') || e.currentTarget == e.target) {
                    this._clickDragMixinDidMouseDown = true;

                    this._windowMouseMoveCallback = this.debounceIfNeeded(function (ev) {
                        return _this2._windowMouseMove(ev, isRotate);
                    });
                    this._windowMouseUpCallback = this.debounceIfNeeded(function (ev) {
                        return _this2._windowMouseUp(ev);
                    });

                    window.addEventListener('mousemove', this._windowMouseMoveCallback, true);
                    window.addEventListener('mouseup', this._windowMouseUpCallback, false);

                    this._clickDragMixinData = {
                        mouseStartX: e.clientX,
                        mouseStartY: e.clientY
                    };

                    this._clickDragMixinMouseMoveData.lastX = e.clientX;
                    this._clickDragMixinMouseMoveData.lastY = e.clientY;

                    if (this.getClickDragMixinParamOrDefault('preventDefaultOnMouseDown')) {
                        e.preventDefault();
                    }

                    this._clickDragMixinFlagFireDragStart = isRotate === false;
                    this._clickDragMixinFlagFireRotateStart = isRotate;
                }
            }
        }, {
            key: "trackMouseUp",
            value: function trackMouseUp(e) {

                this.log('trackMouseUp');

                if (e.defaultPrevented) {
                    return;
                }

                if (this._clickDragMixinDidMouseDown && !this._clickDragMixinDidDrag && !this._clickDragMixinDidRotate) {
                    if (!this.getClickDragMixinParamOrDefault('strictMouseUpTargetCheck') || e.currentTarget == e.target) {
                        if (this._onPureClick) {
                            this._onPureClick(e);
                        }
                    }
                }
            }
        }, {
            key: "handleMouseDown",
            value: function handleMouseDown(e) {

                this.log('handleMouseDown');

                this.trackMouseDown(e);

                if (this.getClickDragMixinParamOrDefault('preventDefaultOnHandleMouseDown')) {
                    e.preventDefault();
                }
            }
        }, {
            key: "ignoreMouseDown",
            value: function ignoreMouseDown(e) {
                this.log('handleMouseDown');

                e.preventDefault();
            }
        }, {
            key: "render",
            value: function render() {
                var _this3 = this;

                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
                    ref: function ref(c) {
                        _this3.compEl = c;
                    },
                    dragState: this.state,
                    dragCallbacks: this.dragCallbacks
                }));
            }
        }]);

        return _class;
    }(_react.Component);
};

exports.default = ClickDragMixin;

},{"../../common/utils/CommonAlgorithms":72,"../utils/rafDebounce":236,"fastdom":634,"react":1107}],212:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var HoverMixin = function HoverMixin(ComposedComponent) {
    return function (props) {
        var onMouseOver = props.onMouseOver,
            onMouseOut = props.onMouseOut,
            onHover = props.onHover,
            otherProps = _objectWithoutProperties(props, ['onMouseOver', 'onMouseOut', 'onHover']);

        var _useState = (0, _react.useState)(false),
            _useState2 = _slicedToArray(_useState, 2),
            hovering = _useState2[0],
            setHovering = _useState2[1];

        var handleHover = function handleHover(isHovering) {
            setHovering(isHovering);
            if (onHover) {
                onHover(isHovering);
            }
        };

        var wrappedMouseOver = (0, _react.useCallback)(function (e) {
            handleHover(true);
            if (onMouseOver) onMouseOver(e);
        }, []);

        var wrappedMouseOut = (0, _react.useCallback)(function (e) {
            handleHover(false);
            if (onMouseOut) onMouseOut(e);
        }, []);

        return _react2.default.createElement(ComposedComponent, _extends({}, otherProps, {
            onMouseOver: wrappedMouseOver,
            onMouseOut: wrappedMouseOut,
            hovering: hovering
        }));
    };
};

exports.default = HoverMixin;

},{"react":1107}],213:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPremiumInstancesCount = undefined;

var _reselect = require('reselect');

var _overlaySelectors = require('./overlaySelectors');

var _miscSelectors = require('./miscSelectors');

var _subtitleSelectors = require('./subtitleSelectors');

var getPlanConfig = function getPlanConfig(state) {
    return state.workspaceInfo.activeWorkspace.planConfig || {};
};
var getActiveWorkspace = function getActiveWorkspace(state) {
    return state.workspaceInfo.activeWorkspace;
};

var getPremiumInstancesCount = exports.getPremiumInstancesCount = function getPremiumInstancesCount() {
    var shouldAccountForCaptionsInPaidPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (0, _reselect.createSelector)([_overlaySelectors.getUniqueCustomFontInCaptions, _overlaySelectors.getCustomFontUsedInOverlays, _miscSelectors.getSelectedCustomFormat, _subtitleSelectors.getNonPreviewSubtitleOverlayIds, getActiveWorkspace], function (uniqueCaptionCustomFont, _ref, selectedCustomFormat, nonPreviewSubtitleOverlayIds, activeWorkspace) {
        var customFontsInNonCaptionOverlays = _ref.customFontsInNonCaptionOverlays;

        var hasUsedCaptions = nonPreviewSubtitleOverlayIds && Object.keys(nonPreviewSubtitleOverlayIds).length > 0;

        var premiumInstancesCount = 0;

        if (activeWorkspace && !activeWorkspace.isPaidWorkspace) {
            premiumInstancesCount = customFontsInNonCaptionOverlays ? Object.keys(customFontsInNonCaptionOverlays).length : 0;

            if (!!selectedCustomFormat && Object.keys(selectedCustomFormat).length > 0) {
                premiumInstancesCount += 1;
            }
            if (hasUsedCaptions) {
                premiumInstancesCount += 1;
            }
            if (uniqueCaptionCustomFont && Object.keys(uniqueCaptionCustomFont).length > 0) {
                premiumInstancesCount += 1;
            }
        } else if (shouldAccountForCaptionsInPaidPlan && hasUsedCaptions) {
            premiumInstancesCount += 1;
        }

        return premiumInstancesCount;
    });
};

},{"./miscSelectors":215,"./overlaySelectors":217,"./subtitleSelectors":224,"reselect":1136}],214:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDynamicPluginSections = exports.createGetTextStyleEntries = exports.createGetTextStyleFromId = exports.createGetTextStyleForRender = exports.createGetTextStyleFilter = exports.getStaticIcons = exports.getStaticShapes = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _PluginService = require('../../common/constants/PluginService');

var _general = require('../components/utility/pluginUtils/general');

var _General = require('../constants/General');

var _SearchRegistry = require('../utils/search/SearchRegistry');

var _SearchRegistry2 = _interopRequireDefault(_SearchRegistry);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var getTextTemplates = function getTextTemplates(state) {
    return state.templates.text;
};
var getImageTemplates = function getImageTemplates(state) {
    return state.templates.images;
};

var getPluginServices = function getPluginServices(state) {
    return state.pluginService;
};

var getStaticShapes = exports.getStaticShapes = (0, _reselect.createSelector)([getImageTemplates], function (images) {
    var shapes = (images.find(function (grp) {
        return grp.id === 'shapes';
    }) || {}).items || [];
    return shapes;
});

var getStaticIcons = exports.getStaticIcons = (0, _reselect.createSelector)([getImageTemplates], function (images) {
    var shapes = (images.find(function (grp) {
        return grp.id === 'icons';
    }) || {}).items || [];
    return shapes;
});

var createGetTextStyleFilter = exports.createGetTextStyleFilter = function createGetTextStyleFilter(selectText) {
    return (0, _reselect.createSelector)([selectText], function (text) {
        var data = text.reduce(function (acc, v, i) {
            acc.index2Id[i] = v.id;
            acc.id2Index[v.id] = i;
            acc.filterFn[v.id] = _SearchRegistry2.default.filterElements(v.items, function (data) {
                return data.name + ' ' + data.defId;
            });
            return acc;
        }, { index2Id: {}, id2Index: {}, filterFn: {} });
        return data;
    });
};

var createGetTextStyleForRender = exports.createGetTextStyleForRender = function createGetTextStyleForRender(getText) {
    return (0, _reselect.createSelector)([getText], function (text) {
        return text.flatMap(function (entry) {
            return entry.items;
        });
    });
};

var createGetTextStyleFromId = exports.createGetTextStyleFromId = function createGetTextStyleFromId(getText) {
    return (0, _reselect.createSelector)([getText], function (text) {
        return text.flatMap(function (entry) {
            return entry.items;
        }).reduce(function (acc, template) {
            acc[template.id] = template;
            return acc;
        }, {});
    });
};
var createGetTextStyleEntries = function createGetTextStyleEntries() {
    var exclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return (0, _reselect.createSelector)([getTextTemplates], function (text) {
        return text.filter(function (entry) {
            return !exclude.includes(entry.id);
        }).map(function (entry) {
            var _entry$items = entry.items,
                items = _entry$items === undefined ? [] : _entry$items,
                id = entry.id,
                otherProps = _objectWithoutProperties(entry, ['items', 'id']);

            items.forEach(function (item) {
                item.group = id;
            });
            return _extends({}, otherProps, {
                items: items,
                id: id
            });
        });
    });
};

exports.createGetTextStyleEntries = createGetTextStyleEntries;
var createDynamicPluginSections = exports.createDynamicPluginSections = (0, _reselect.createSelector)([getPluginServices], function (pluginServices) {
    var dynamicSections = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(pluginServices)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (pluginServices[key].serviceDown) {
                continue;
            }

            var id = void 0;
            if (key === _PluginService.SupportedPlugins.captions) id = _General.Sections.SUBTITLES.id;else {
                id = (0, _general.getPluginShelfEntryKey)(key);
            }
            dynamicSections[id] = _extends({}, pluginServices[key], {
                id: id
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return dynamicSections;
});

},{"../../common/constants/PluginService":65,"../components/utility/pluginUtils/general":200,"../constants/General":203,"../utils/search/SearchRegistry":243,"reselect":1136}],215:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPlanInfo = exports.getCurrentHoveredClip = exports.getEditingClip = exports.getSelectedClip = exports.getSelectedCustomFormat = exports.getUserData = exports.getProjectData = exports.getWorkspaceData = exports.getCurrentUploadingItemToHighlight = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _PlanUtils = require('../../common/utils/PlanUtils');

var getCustomFormats = function getCustomFormats(state) {
    return state.customFormats.formats;
};
var getSelectedFormatId = function getSelectedFormatId(state) {
    return state.reel.formatId;
};
var getAllClips = function getAllClips(state) {
    return state.reel.clips;
};
var getEditingClipId = function getEditingClipId(state) {
    return state.clipBoxEditorData.editingClipId;
};
var getClipBox = function getClipBox(state) {
    return state.clipBoxEditorData.clipBox;
};

var getClips = function getClips(state) {
    return state.reel.clips;
};
var getCurrentTime = function getCurrentTime(state) {
    return state.player.time;
};
var getCurrentUploadingHighlightItem = function getCurrentUploadingHighlightItem(state) {
    return state.ui.uploadingItemHighlightIds;
};

var getCurrentHoveredClip = (0, _reselect.createSelector)([getClips, getCurrentTime], function (clips, playerHeadTime) {
    var selectedClip = null;
    if (clips.length > 0) {
        selectedClip = clips.filter(function (clip) {
            return clip.isSelected;
        });
        selectedClip = selectedClip.length > 0 ? selectedClip[0] : null;
        if (!selectedClip) {
            selectedClip = clips.filter(function (clip) {
                return clip.time.enterStart <= playerHeadTime && clip.time.exitDone >= playerHeadTime;
            });
            selectedClip = selectedClip.length > 0 ? selectedClip[0] : null;
        }
    }
    return selectedClip;
});

var getSelectedCustomFormat = (0, _reselect.createSelector)([getCustomFormats, getSelectedFormatId], function (customFormats, selectedFormatId) {
    return customFormats.find(function (f) {
        return selectedFormatId === f.id;
    }) || {};
});

var getSelectedClip = (0, _reselect.createSelector)([getAllClips], function (allClips) {
    return allClips.find(function (clip) {
        return clip.isSelected;
    });
});

var getEditingClip = (0, _reselect.createSelector)([getAllClips, getEditingClipId, getClipBox], function (allClips, editingClipId, clipBox) {
    var editingClip = null;

    if (editingClipId) {
        editingClip = allClips.find(function (c) {
            return c.clipId === editingClipId;
        });
        editingClip = _extends({}, editingClip, { clipBox: clipBox });
    }

    return editingClip;
});

/**
 * Extract plan details from active workspace in state
 *
 * @param {*} state
 * @returns
 */
var getPlanInfo = function getPlanInfo(state) {
    var _state$workspaceInfo$ = state.workspaceInfo.activeWorkspace,
        planType = _state$workspaceInfo$.planType,
        planMeta = _state$workspaceInfo$.planMeta,
        planVersion = _state$workspaceInfo$.planVersion,
        planConfig = _state$workspaceInfo$.planConfig;

    var isSubscriptionUser = (0, _PlanUtils.checkIsPaidWorkspace)(planType);

    var subscriptionVideosLeft = -1;
    var subscriptionPaymentFailed = false;
    var videoCredits = 0;

    if (isSubscriptionUser) {
        try {
            if (planConfig.hasOwnProperty('videosLeft')) {
                subscriptionVideosLeft = planConfig.videosLeft || 0;
            }
            subscriptionPaymentFailed = planMeta.status === 'past_due' || planMeta.status === 'unpaid';
        } catch (e) {}
    } else {
        try {
            videoCredits = planMeta.videoCredits || 0;
        } catch (e) {}
    }

    return {
        isSubscriptionUser: isSubscriptionUser,
        subscriptionVideosLeft: subscriptionVideosLeft,
        subscriptionPaymentFailed: subscriptionPaymentFailed,
        videoCredits: videoCredits,
        planType: planType,
        planConfig: planConfig
    };
};

var getCurrentUploadingItemToHighlight = exports.getCurrentUploadingItemToHighlight = (0, _reselect.createSelector)([getCurrentUploadingHighlightItem], function () {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (!ids) return {};
    return ids.reduce(function (acc, v) {
        acc[v] = true;
        return acc;
    }, {});
});

var getWorkspaceData = exports.getWorkspaceData = function getWorkspaceData(state) {
    return state.workspaceInfo.activeWorkspace;
};
var getProjectData = exports.getProjectData = function getProjectData(state) {
    return state.project;
};
var getUserData = exports.getUserData = function getUserData(state) {
    return state.userData;
};

exports.getSelectedCustomFormat = getSelectedCustomFormat;
exports.getSelectedClip = getSelectedClip;
exports.getEditingClip = getEditingClip;
exports.getCurrentHoveredClip = getCurrentHoveredClip;
exports.getPlanInfo = getPlanInfo;

},{"../../common/utils/PlanUtils":83,"reselect":1136}],216:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProgressPercentCreator = exports.getStepsFromInformation = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _OnboardingSteps = require('../constants/OnboardingSteps');

var _OnboardingSteps2 = _interopRequireDefault(_OnboardingSteps);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var getOnboardingInfo = function getOnboardingInfo(state) {
    return state.onboarding.stepInformation;
};

var createOnboardingData = function createOnboardingData(onboardingSteps) {
    return function (stepObject) {
        var content = onboardingSteps.filter(function (v) {
            return !v.avoidShow;
        }).sort(function (v1, v2) {
            return v1.stepIndex - v2.stepIndex;
        }).map(function (step) {
            var stepData = step;
            if (stepObject && stepObject[step.id]) {
                stepData = stepObject[step.id];
            }

            var _stepData = stepData,
                _stepData$completed = _stepData.completed,
                completed = _stepData$completed === undefined ? false : _stepData$completed,
                _stepData$defaultComp = _stepData.defaultComplete,
                defaultComplete = _stepData$defaultComp === undefined ? false : _stepData$defaultComp;

            return _extends({}, step, {
                isComplete: completed || defaultComplete
            });
        });
        for (var index = 1; index < content.length; index++) {
            var step = content[index];
            var prevStep = content[index - 1];
            if (step.modalProperty) {
                step.modalProperty = _extends({}, step.modalProperty, {
                    partial: step.modalProperty.partial && prevStep.isComplete
                });
            }
        }

        return content;
    };
};

var getStepsFromInformation = exports.getStepsFromInformation = (0, _reselect.createSelector)([getOnboardingInfo], createOnboardingData(_OnboardingSteps2.default));

var getProgressPercentCreator = exports.getProgressPercentCreator = function getProgressPercentCreator(getOnboardingStepInfo) {
    return (0, _reselect.createSelector)([getOnboardingStepInfo], function (stepInfo) {
        return stepInfo.reduce(function (acc, info) {
            if (info.isComplete) acc += 1;
            return acc;
        }, 0) / stepInfo.length * 100;
    });
};

},{"../constants/OnboardingSteps":204,"reselect":1136}],217:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUniqueCustomFontInNonCaptionOverlays = exports.getUniqueCustomFontInCaptions = exports.getCustomFontUsedInOverlays = exports.getOverlayRectUnionWithWatermark = exports.getOverlayRectUnion = exports.getAnimGroupSettingsForAllOverlays = exports.getHideFilteredValidTemplateOverlays = exports.hasDeletedMediaInOverlaysInProjectDurationSelector = exports.getRelevantOverlays = exports.hasDeletedMediaInOverlaysSelector = exports.getSelectedNonSequenceAndNonWatermarkOverlaysFilteredByHidden = exports.getSelectedNonSequenceAndNonWatermarkOverlays = exports.getSelectedNonSequenceOverlayKeys = exports.getNonSequenceSelectedOverlaysTimeInfoFilteredByHidden = exports.getNonSequenceSelectedOverlaysTimeInfo = exports.getNonWatermarkOverlaySelectionData = exports.getAnyNonSequenceOverlaysPresent = exports.isOverlaysAddedSelector = exports.getCurrentlySelectedDeepEqual = exports.makeGetSequenceOverlaysCueDataForSelectedClipFilteredByHidden = exports.makeGetNonSequenceOverlayCueDataFilterredByHidden = exports.makeGetSequenceOverlaysCueDataForSelectedClip = exports.makeGetNonSequenceOverlayCueData = exports.getCurrentSelectedSequenceOverlaysSelectedFiltersByHidden = exports.getCurrentSelectedSequenceOverlaysSelected = exports.getCurrentSelectedSequenceOverlaySelectedTimeInfoFilteredByHidden = exports.getCurrentSelectedSequenceOverlaySelectedTimeInfo = exports.getCurrentSelectedSequenceOverlayTimeInfoFilteredByHidden = exports.getCurrentSelectedSequenceOverlayTimeInfo = exports.getSequenceOverlaysTimeInfoFilteredByHidden = exports.getSequenceOverlayTimeInfo = exports.getNonSequenceOverlaysTimeInfoFilteredByHidden = exports.getNonSequenceOverlaysTimeInfo = exports.getOverlaysTimeInfo = exports.getSelectedOverlaysObject = exports.getSelctedOverlaysObjectWithWatermark = exports.getSelectedOverlaysWithWatermark = exports.getSelectedOverlaysFilteredByHidden = exports.getSelectedOverlaysWithWatermarkFilteredByHidden = exports.getSelectedOverlays = exports.getSelectedOverlayIds = exports.getSelectedOverlayTimes = exports.getTextEditableOverlaysWithHideFiltered = exports.getTextEditableOverlays = exports.getNonWaterMarkOverlaysFilteredByHidden = exports.getNonWaterMarkOverlays = exports.getOverlaysWithValidTemplate = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _sequenceSelectors = require('./sequenceSelectors');

var _reelSelectors = require('./reelSelectors');

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _OverlayUtils = require('../utils/OverlayUtils');

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _workflowSelector = require('./workflowSelector');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// deep equal of fast-deep-equal benchmarked faster
// 0.13ms vs 83microseconds
var deepEqualCreateSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _fastDeepEqual2.default);

var getOverlays = function getOverlays(state) {
    return state.overlays;
};
var getSelected = function getSelected(state) {
    return state.selection.selected;
};
var getCurrentTime = function getCurrentTime(state) {
    return state.player.time;
};
var getIsPlaying = function getIsPlaying(state) {
    return state.player.playbackState === _PlaybackState2.default.PLAYING;
};
var getSelection = function getSelection(state) {
    return state.selection;
};
var getWorkspaceMedia = function getWorkspaceMedia(state) {
    return state.workspaceMedia;
};

var getAnimGroups = function getAnimGroups(state) {
    return state.overlaymeta.animgroups;
};

var getOverlaysWithValidTemplate = exports.getOverlaysWithValidTemplate = (0, _reselect.createSelector)([getOverlays], function (overlays) {
    return Object.keys(overlays).reduce(function (acc, key) {
        var overlay = overlays[key];
        if (overlay.templateDefMissing) {
            return acc;
        }
        acc[key] = overlays[key];
        return acc;
    }, {});
});

var getNonWaterMarkOverlays = exports.getNonWaterMarkOverlays = (0, _reselect.createSelector)([getOverlaysWithValidTemplate], function (overlays) {
    return Object.keys(overlays).reduce(function (acc, key) {
        if (!overlays[key].isWatermark) acc[key] = overlays[key];
        return acc;
    }, {});
});

var getNonWaterMarkOverlaysFilteredByHidden = exports.getNonWaterMarkOverlaysFilteredByHidden = (0, _reselect.createSelector)([getNonWaterMarkOverlays], function (overlays) {
    return Object.values(overlays).reduce(function (acc, ov) {
        if (!ov.hide) {
            acc[ov.id] = ov;
        }
        return acc;
    }, {});
});

var getTextEditableOverlays = exports.getTextEditableOverlays = (0, _reselect.createSelector)([getNonWaterMarkOverlays, getSelected], function (overlays, selected) {
    var editableOverlays = {};
    if (Object.keys(selected).length === 1) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(selected)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var oid = _step.value;

                var overlay = overlays[oid];
                if (overlay) {
                    // text layer not needed for watermark
                    var def = getTemplateDefForId(overlay.defId);
                    var _def$meta$textEditors = def.meta.textEditors,
                        textEditors = _def$meta$textEditors === undefined ? {} : _def$meta$textEditors;

                    if (Object.keys(textEditors).length > 0) {
                        editableOverlays[oid] = overlay;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return editableOverlays;
    }
    return editableOverlays;
});

var getTextEditableOverlaysWithHideFiltered = exports.getTextEditableOverlaysWithHideFiltered = (0, _reselect.createSelector)([getTextEditableOverlays], function (overlays) {
    return filterOverlaysOnHide(overlays);
});

var getSelectedOverlayTimes = exports.getSelectedOverlayTimes = (0, _reselect.createSelector)([getNonWaterMarkOverlays, getSelected], function (overlays, selected) {
    var isTextOverlay = false;

    var overlayTimes = Object.keys(selected).map(function (oid) {
        return overlays[oid];
    }).map(function (o) {
        var _o$time = o.time,
            enterstart = _o$time.enterstart,
            exitdone = _o$time.exitdone;

        var _ref = window.getTemplateDefForId(o.defId) || {},
            _ref$meta = _ref.meta,
            meta = _ref$meta === undefined ? {} : _ref$meta;

        if (!!meta.textEditors && Object.keys(meta.textEditors).length > 0) {
            isTextOverlay = true;
        }

        return { inTime: enterstart, outTime: exitdone, id: o.id };
    });

    return [overlayTimes, isTextOverlay];
});

var getSelectedOverlayIds = exports.getSelectedOverlayIds = (0, _reselect.createSelector)([getSelected], function (selectedOverlayIds) {
    return Object.keys(selectedOverlayIds);
});

/**
 * // TODO - Change the damn name to specific type it returns conflicts with
 * method from other file in misc
 *
 *
 * Returns a List of Selected Overlays excluding the Watermark overlay
 */
var getSelectedOverlays = exports.getSelectedOverlays = (0, _reselect.createSelector)([getSelectedOverlayIds, getOverlaysWithValidTemplate], // TODO -- check if non watermark overlays satisfies this
function () {
    var selectedOverlaIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var overlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return selectedOverlaIds.map(function (id) {
        return overlays[id];
    }).filter(function (o) {
        return !!o;
    }).sort(function (o1, o2) {
        return o1.space.zIndex - o2.space.zIndex;
    });
});

var getSelectedOverlaysWithWatermarkFilteredByHidden = exports.getSelectedOverlaysWithWatermarkFilteredByHidden = (0, _reselect.createSelector)([getSelectedOverlays], function (overlays) {
    return overlays.filter(function (ov) {
        return !ov.hide;
    });
});

/**
 * Returns a List of Selected Overlays excluding the hidden and Watermark overlay
 */
var getSelectedOverlaysFilteredByHidden = exports.getSelectedOverlaysFilteredByHidden = (0, _reselect.createSelector)([getSelectedOverlayIds, getNonWaterMarkOverlaysFilteredByHidden], function () {
    var selectedOverlaIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var overlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return selectedOverlaIds.map(function (id) {
        return overlays[id];
    }).filter(function (o) {
        return !!o;
    }).sort(function (o1, o2) {
        return o1.space.zIndex - o2.space.zIndex;
    });
});

var getSelectedOverlaysWithWatermark = exports.getSelectedOverlaysWithWatermark = (0, _reselect.createSelector)([getSelectedOverlayIds, getOverlaysWithValidTemplate], // TODO -- check if non watermark overlays satisfies this
function () {
    var selectedOverlaIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var overlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return selectedOverlaIds.map(function (id) {
        return overlays[id];
    }).filter(function (o) {
        return !!o;
    });
});

var getSelctedOverlaysObjectWithWatermark = exports.getSelctedOverlaysObjectWithWatermark = (0, _reselect.createSelector)([getSelectedOverlayIds, getOverlaysWithValidTemplate], function (selectedOverlaIds, overlays) {
    return selectedOverlaIds.reduce(function (acc, id) {
        if (overlays[id]) {
            acc[id] = overlays[id];
        }
        return acc;
    }, {});
});

var getSelectedOverlaysObject = exports.getSelectedOverlaysObject = (0, _reselect.createSelector)([getSelectedOverlayIds, getNonWaterMarkOverlays], function (selectedOverlaIds, overlays) {
    return selectedOverlaIds.reduce(function (acc, id) {
        if (overlays[id]) {
            acc[id] = overlays[id];
        }
        return acc;
    }, {});
});

/**
 * No need to optimise here , Loops are fast only if
 * number of overlays goes beyond 1800 we may see 4ms time
 * benchmarked on M1 machine  ¯\_( ͡❛ ͜ʖ ͡❛)_/¯
 */
var getOverlayTimeInfoFunc = function getOverlayTimeInfoFunc(overlays) {
    var timeInfoList = [];

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Object.keys(overlays)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            if (!overlays[key].isPreviewSubtitle && !overlays[key].isWatermark) {
                var overlay = overlays[key];
                var id = overlay.id,
                    defId = overlay.defId,
                    hide = overlay.hide,
                    _overlay$time = overlay.time,
                    enterstart = _overlay$time.enterstart,
                    exitdone = _overlay$time.exitdone;

                var def = getTemplateDefForId(defId);

                var isTextOverlay = false;
                var isGlobalOverlay = false;
                if (!!def && !!def.meta.textEditors && Object.keys(def.meta.textEditors).length > 0) {
                    isTextOverlay = true;
                }
                isGlobalOverlay = _OverlayUtils.FitnessGlobalTemplateDefIds.includes(defId);
                // if (def.meta.mappings.primaryColor) {
                //     let primaryColor = values[def.meta.mappings.primaryColor]

                //     if( primaryColor !== undefined )
                //         cueBackground = new ColorRange(primaryColor).getCueBackground()
                // }

                var containsCounter = !!def && !!def.meta.containsCounter;
                timeInfoList.push({
                    isTextOverlay: isTextOverlay,
                    isGlobalOverlay: isGlobalOverlay,
                    containsCounter: containsCounter,
                    hide: hide,
                    start: enterstart,
                    end: exitdone,
                    id: id
                });
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return timeInfoList.sort(function (_ref2, _ref3) {
        var s1 = _ref2.start;
        var s2 = _ref3.start;
        return s1 - s2;
    });
};

var getOverlayToSequenceClipMap = (0, _sequenceSelectors.makeGetOverlayToSequenceClipIdMap)();

var getOverlaysTimeInfo = exports.getOverlaysTimeInfo = (0, _reselect.createSelector)([getNonWaterMarkOverlays], getOverlayTimeInfoFunc);

// uses deep selector as inputs input will not change unless absolutely necessary
var getNonSequenceOverlaysTimeInfo = exports.getNonSequenceOverlaysTimeInfo = deepEqualCreateSelector([getOverlaysTimeInfo, getOverlayToSequenceClipMap], function (timeInfo, overlayToSequenceClipMap) {
    return timeInfo.filter(function (_ref4) {
        var id = _ref4.id;
        return !overlayToSequenceClipMap[id];
    });
});

var getNonSequenceOverlaysTimeInfoFilteredByHidden = exports.getNonSequenceOverlaysTimeInfoFilteredByHidden = deepEqualCreateSelector([getOverlaysTimeInfo, getOverlayToSequenceClipMap], function (timeInfo, overlayToSequenceClipMap) {
    return timeInfo.filter(function (_ref5) {
        var id = _ref5.id,
            hide = _ref5.hide;
        return !overlayToSequenceClipMap[id] && !hide;
    });
});

var getSequenceOverlayTimeInfo = exports.getSequenceOverlayTimeInfo = deepEqualCreateSelector([getOverlaysTimeInfo, getOverlayToSequenceClipMap], function (timeInfo, overlayToSequenceClipMap) {
    return timeInfo.filter(function (_ref6) {
        var id = _ref6.id;
        return !!overlayToSequenceClipMap[id];
    });
});

var getSequenceOverlaysTimeInfoFilteredByHidden = exports.getSequenceOverlaysTimeInfoFilteredByHidden = deepEqualCreateSelector([getOverlaysTimeInfo, getOverlayToSequenceClipMap], function (timeInfo, overlayToSequenceClipMap) {
    return timeInfo.filter(function (_ref7) {
        var id = _ref7.id,
            hide = _ref7.hide;
        return !!overlayToSequenceClipMap[id] && !hide;
    });
});

var getCurrentSelectedSequenceOverlayTimeInfo = exports.getCurrentSelectedSequenceOverlayTimeInfo = (0, _reselect.createSelector)([_sequenceSelectors.getCurrentSelectedSequenceOverlays, getSequenceOverlayTimeInfo], function (overlays, timeInfo) {
    return timeInfo.filter(function (info) {
        return overlays[info.id];
    });
});

var getCurrentSelectedSequenceOverlayTimeInfoFilteredByHidden = exports.getCurrentSelectedSequenceOverlayTimeInfoFilteredByHidden = (0, _reselect.createSelector)([_sequenceSelectors.getCurrentSelectedSequenceOverlays, _workflowSelector.getAllGlobalOverlaysIfSelected, getSequenceOverlaysTimeInfoFilteredByHidden], function (overlays, globalOverlays, timeInfo) {
    return timeInfo.filter(function (info) {
        return overlays[info.id] || globalOverlays[info.id];
    }).map(function (o) {
        return _extends({}, o, overlays[o.id] || globalOverlays[o.id]);
    });
});

var getCurrentSelectedSequenceOverlaySelectedTimeInfo = exports.getCurrentSelectedSequenceOverlaySelectedTimeInfo = (0, _reselect.createSelector)([getCurrentSelectedSequenceOverlayTimeInfo, getSelected], function (timeInfo, selected) {
    return timeInfo.filter(function (info) {
        return selected[info.id];
    });
});

var getCurrentSelectedSequenceOverlaySelectedTimeInfoFilteredByHidden = exports.getCurrentSelectedSequenceOverlaySelectedTimeInfoFilteredByHidden = (0, _reselect.createSelector)([getCurrentSelectedSequenceOverlayTimeInfoFilteredByHidden, getSelected], function (timeInfo, selected) {
    return timeInfo.filter(function (info) {
        return selected[info.id];
    });
});

var getCurrentSelectedSequenceOverlaysSelected = exports.getCurrentSelectedSequenceOverlaysSelected = (0, _reselect.createSelector)([_sequenceSelectors.getCurrentSelectedSequenceOverlays, getSelected], function (overlays, selected) {
    return Object.values(overlays).reduce(function (acc, overlay) {
        if (selected[overlay.id]) {
            acc[overlay.id] = overlay;
        }
        return acc;
    }, {});
});

var getCurrentSelectedSequenceOverlaysSelectedFiltersByHidden = exports.getCurrentSelectedSequenceOverlaysSelectedFiltersByHidden = (0, _reselect.createSelector)([_sequenceSelectors.getCurrentSelectedSequenceOverlays, getSelected], function (overlays, selected) {
    return Object.values(overlays).reduce(function (acc, overlay) {
        if (selected[overlay.id] && !overlays[overlay.id].hide) {
            acc[overlay.id] = overlay;
        }
        return acc;
    }, {});
});

var checkIntersect = function checkIntersect(rect1, rect2) {
    var x1 = rect1.x,
        y1 = rect1.y,
        w1 = rect1.width,
        h1 = rect1.height;
    var x2 = rect2.x,
        y2 = rect2.y,
        w2 = rect2.width,
        h2 = rect2.height;

    // If one rectangle is on left side of other

    if (x1 >= x2 + w2 || x2 >= x1 + w1) return false;

    // If one rectangle is above other
    if (y1 >= y2 + h2 || y2 >= y1 + h1) return false;

    return true;
};

var findNextRect = function findNextRect(start, end, otherRects, minHeight) {
    var found = false;

    var currentRect = {
        x: start,
        y: 0,
        width: end - start,
        height: minHeight
    };

    while (!found) {
        var overlapRect = otherRects.some(function (r) {
            return checkIntersect(r, currentRect);
        });

        if (!overlapRect) {
            found = true;
            break;
        } else {
            currentRect.y += minHeight;
        }
    }

    return currentRect;
};

var getVerticalMetrics = function getVerticalMetrics(cueRects, maxHeight) {
    var totalHeight = cueRects.map(function (rect) {
        return rect.y + rect.height;
    }).reduce(function (v1, v2) {
        return Math.max(v1, v2);
    }, 0);

    var scaleY = 1;
    if (totalHeight >= maxHeight) {
        scaleY = maxHeight / totalHeight;
    }
    return { scaleY: scaleY, totalHeight: totalHeight };
};

var buildOverlayCueData = function buildOverlayCueData(maxHeight, minHeight) {
    return function (overlayTimeInfos) {
        var totalEntries = overlayTimeInfos.length;

        var cueRects = [];

        for (var i = 0; i < totalEntries; i++) {
            var _overlayTimeInfos$i = overlayTimeInfos[i],
                start = _overlayTimeInfos$i.start,
                end = _overlayTimeInfos$i.end,
                id = _overlayTimeInfos$i.id,
                isTextOverlay = _overlayTimeInfos$i.isTextOverlay,
                isGlobalOverlay = _overlayTimeInfos$i.isGlobalOverlay,
                _overlayTimeInfos$i$i = _overlayTimeInfos$i.isGlobalSelected,
                isGlobalSelected = _overlayTimeInfos$i$i === undefined ? false : _overlayTimeInfos$i$i;

            var _findNextRect = findNextRect(start, end, cueRects, minHeight),
                x = _findNextRect.x,
                y = _findNextRect.y,
                width = _findNextRect.width,
                height = _findNextRect.height;

            cueRects.push({
                x: x,
                y: y,
                width: width,
                height: height,
                isTextOverlay: isTextOverlay,
                isGlobalOverlay: isGlobalOverlay,
                isGlobalSelected: isGlobalSelected,
                id: id,
                start: start,
                end: end
            });
        }

        var _getVerticalMetrics = getVerticalMetrics(cueRects, maxHeight),
            totalHeight = _getVerticalMetrics.totalHeight,
            scaleY = _getVerticalMetrics.scaleY;

        return {
            cueRects: cueRects,
            totalHeight: totalHeight,
            scaleY: scaleY
        };
    };
};

var makeGetNonSequenceOverlayCueData = exports.makeGetNonSequenceOverlayCueData = function makeGetNonSequenceOverlayCueData(maxHeight, minHeight) {
    return (0, _reselect.createSelector)([getNonSequenceOverlaysTimeInfo], buildOverlayCueData(maxHeight, minHeight));
};

var makeGetSequenceOverlaysCueDataForSelectedClip = exports.makeGetSequenceOverlaysCueDataForSelectedClip = function makeGetSequenceOverlaysCueDataForSelectedClip(maxHeight, minHeight) {
    return (0, _reselect.createSelector)([getCurrentSelectedSequenceOverlayTimeInfo], buildOverlayCueData(maxHeight, minHeight));
};

var makeGetNonSequenceOverlayCueDataFilterredByHidden = exports.makeGetNonSequenceOverlayCueDataFilterredByHidden = function makeGetNonSequenceOverlayCueDataFilterredByHidden(maxHeight, minHeight) {
    return (0, _reselect.createSelector)([getNonSequenceOverlaysTimeInfoFilteredByHidden], buildOverlayCueData(maxHeight, minHeight));
};

var makeGetSequenceOverlaysCueDataForSelectedClipFilteredByHidden = exports.makeGetSequenceOverlaysCueDataForSelectedClipFilteredByHidden = function makeGetSequenceOverlaysCueDataForSelectedClipFilteredByHidden(maxHeight, minHeight) {
    return (0, _reselect.createSelector)([getCurrentSelectedSequenceOverlayTimeInfoFilteredByHidden], buildOverlayCueData(maxHeight, minHeight));
};

var getCurrentlySelectedDeepEqual = exports.getCurrentlySelectedDeepEqual = deepEqualCreateSelector([function (state) {
    return state.selection.selected;
}], function (selected) {
    return selected;
});

/*
 * Returns true if user has added any overlay
 */
var isOverlaysAddedSelector = exports.isOverlaysAddedSelector = (0, _reselect.createSelector)([getNonWaterMarkOverlays], function (overlays) {
    var overlaysList = Object.values(overlays);

    if (!!overlaysList && (overlaysList.length == 0 || overlaysList.length == 1 && overlaysList[0].isWatermark)) {
        return false;
    }

    return true;
});

var getAnyNonSequenceOverlaysPresent = exports.getAnyNonSequenceOverlaysPresent = (0, _reselect.createSelector)([getNonWaterMarkOverlays, getOverlayToSequenceClipMap], function (overlays, overlayToSequenceClipMap) {
    var present = false;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = Object.keys(overlays)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            if (!overlayToSequenceClipMap[key]) {
                // if any overlay is not present in the map
                present = true;
                break;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return present;
});

var getNonWatermarkOverlaySelectionData = exports.getNonWatermarkOverlaySelectionData = (0, _reselect.createSelector)([getSelected, getNonWaterMarkOverlays], function (selected, overlays) {
    return Object.keys(selected).reduce(function (acc, key) {
        if (overlays[key]) acc[key] = overlays[key];
        return acc;
    }, {});
});

var getNonSequenceSelectedOverlaysTimeInfo = exports.getNonSequenceSelectedOverlaysTimeInfo = (0, _reselect.createSelector)([getNonSequenceOverlaysTimeInfo, getSelected], function (timeInfo, selected) {
    return timeInfo.filter(function (_ref8) {
        var id = _ref8.id;
        return !!selected[id];
    });
});

var getNonSequenceSelectedOverlaysTimeInfoFilteredByHidden = exports.getNonSequenceSelectedOverlaysTimeInfoFilteredByHidden = (0, _reselect.createSelector)([getNonSequenceOverlaysTimeInfoFilteredByHidden, getSelected], function (timeInfo, selected) {
    return timeInfo.filter(function (_ref9) {
        var id = _ref9.id;
        return !!selected[id];
    });
});

var getSelectedNonSequenceOverlayKeys = exports.getSelectedNonSequenceOverlayKeys = deepEqualCreateSelector([getSelected, getOverlayToSequenceClipMap], function () {
    var overlays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var overlayToSequenceMap = arguments[1];
    return Object.keys(overlays).reduce(function (acc, key) {
        if (!overlayToSequenceMap[key]) {
            acc[key] = true;
        }
        return acc;
    }, {});
});

var getSelectedNonSequenceAndNonWatermarkOverlays = exports.getSelectedNonSequenceAndNonWatermarkOverlays = (0, _reselect.createSelector)([getNonWatermarkOverlaySelectionData, getOverlayToSequenceClipMap], function (overlays, overlayToSequenceMap) {
    return Object.keys(overlays).reduce(function (acc, key) {
        if (!overlayToSequenceMap[key]) {
            acc[key] = overlays[key];
        }
        return acc;
    }, {});
});

var getSelectedNonSequenceAndNonWatermarkOverlaysFilteredByHidden = exports.getSelectedNonSequenceAndNonWatermarkOverlaysFilteredByHidden = (0, _reselect.createSelector)([getNonWatermarkOverlaySelectionData, getOverlayToSequenceClipMap], function (overlays, overlayToSequenceMap) {
    return Object.keys(overlays).reduce(function (acc, key) {
        if (!overlayToSequenceMap[key] && !overlays[key].hide) {
            acc[key] = overlays[key];
        }
        return acc;
    }, {});
});

var hasDeletedMediaInOverlaysSelector = exports.hasDeletedMediaInOverlaysSelector = (0, _reselect.createSelector)([getOverlaysWithValidTemplate], function () {
    var overlays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.values(overlays).some(function (ov) {
        var _ov$values = ov.values;
        _ov$values = _ov$values === undefined ? {} : _ov$values;
        var imageId = _ov$values.imageId;

        if (imageId) {
            var _getImageUrlForId = getImageUrlForId(imageId),
                _getImageUrlForId$del = _getImageUrlForId.deleted,
                deleted = _getImageUrlForId$del === undefined ? false : _getImageUrlForId$del;

            return deleted;
        }
        return false;
    });
});

var getRelevantOverlays = exports.getRelevantOverlays = (0, _reselect.createSelector)([getNonWaterMarkOverlaysFilteredByHidden, getCurrentTime, getIsPlaying, getSelection], function (overlays, currentTime, isPlaying, selection) {
    var selected = selection.selected,
        selecting = selection.selecting;

    var relevantOverlayIds = _extends({}, selected);

    if (!isPlaying) {
        relevantOverlayIds = _extends({}, relevantOverlayIds, selecting);

        Object.keys(overlays).forEach(function (oid) {
            var overlay = overlays[oid];
            var isOverlayCurrentlyVisible = currentTime >= overlay.time.enterstart && currentTime <= overlay.time.exitdone;

            if (isOverlayCurrentlyVisible) {
                relevantOverlayIds[oid] = true;
            } else {
                relevantOverlayIds[oid] = false;
            }
        });
    }

    var relevantOverlayList = Object.keys(relevantOverlayIds).map(function (oid) {
        if (relevantOverlayIds[oid]) return overlays[oid];
        return null;
    }).filter(function (o) {
        return !!o;
    }).sort(function (o1, o2) {
        return o1.space.zIndex - o2.space.zIndex;
    });

    return relevantOverlayList;
});

/**
 * Checks whether any overlay within the project duration contains deleted media.
 */
var hasDeletedMediaInOverlaysInProjectDurationSelector = exports.hasDeletedMediaInOverlaysInProjectDurationSelector = (0, _reselect.createSelector)([getOverlaysWithValidTemplate, _reelSelectors.getReelDurationInfo, getWorkspaceMedia], function () {
    var overlays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reelDuration = arguments[1];
    var workspaceMedia = arguments[2];
    return Object.values(overlays).some(function (ov) {
        var _ov$values2 = ov.values;
        _ov$values2 = _ov$values2 === undefined ? {} : _ov$values2;
        var imageId = _ov$values2.imageId,
            enterstart = ov.time.enterstart;

        if (!!imageId && enterstart < reelDuration) {
            var _getImageUrlForId2 = getImageUrlForId(imageId),
                _getImageUrlForId2$de = _getImageUrlForId2.deleted,
                deleted = _getImageUrlForId2$de === undefined ? false : _getImageUrlForId2$de;

            return deleted;
        }
        return false;
    });
});

var filterOverlaysOnHide = function filterOverlaysOnHide(overlays) {
    return Object.values(overlays).reduce(function (acc, overlay) {
        if (!overlay.hide) {
            acc[overlay.id] = overlay;
        }
        return acc;
    }, {});
};

var getHideFilteredValidTemplateOverlays = exports.getHideFilteredValidTemplateOverlays = (0, _reselect.createSelector)([getOverlaysWithValidTemplate], function (overlays) {
    return filterOverlaysOnHide(overlays);
});

var _getAnim = (0, _reselect.createSelector)([getOverlaysWithValidTemplate, getAnimGroups], function (overlays, animGroup) {
    return Object.values(overlays).reduce(function (acc, ov) {
        acc[ov.id] = (0, _OverlayUtils.getAnimGroupSettings)(ov, overlays, animGroup);
        return acc;
    }, {});
});

var getAnimGroupSettingsForAllOverlays = exports.getAnimGroupSettingsForAllOverlays = deepEqualCreateSelector([_getAnim], function (anim) {
    return anim;
});

var getOverlayRectUnion = exports.getOverlayRectUnion = (0, _reselect.createSelector)([getSelectedOverlays], function (overlays) {
    return overlays.length > 0 ? (0, _OverlayUtils.overlayRectUnion)(overlays) : {};
});

var getOverlayRectUnionWithWatermark = exports.getOverlayRectUnionWithWatermark = (0, _reselect.createSelector)([getSelctedOverlaysObjectWithWatermark], function (overlays) {
    return Object.keys(overlays).length > 0 ? (0, _OverlayUtils.overlayRectUnion)(Object.values(overlays)) : {};
});

/**
 * customFontsInNonCaptionOverlays, customFontsInCaptions -> {[overlayId]: {[fontFamilyKey]: {fontFamily, fontFamilyLabel}}}
 */
var getCustomFontUsedInOverlays = exports.getCustomFontUsedInOverlays = (0, _reselect.createSelector)([getNonWaterMarkOverlaysFilteredByHidden], function (overlays) {
    var customFontsInNonCaptionOverlays = {}; // for overlays excluding captions
    var customFontsInCaptions = {};

    Object.keys(overlays).forEach(function (oId) {
        var overlay = overlays[oId];

        var overlayFontFamilies = {};

        if (overlay.values.hasOwnProperty('fontFamily')) {
            overlayFontFamilies.fontFamily = overlay.values.fontFamily;
        }

        if (overlay.values.hasOwnProperty('fontFamily1')) {
            overlayFontFamilies.fontFamily1 = overlay.values.fontFamily1;
        }

        if (overlay.values.hasOwnProperty('fontFamily2')) {
            overlayFontFamilies.fontFamily2 = overlay.values.fontFamily2;
        }

        Object.keys(overlayFontFamilies).forEach(function (fontFamilyKey) {
            var fontFamily = overlayFontFamilies[fontFamilyKey];
            var fontFamilyLabel = _FontManager2.default.getFontLabel(fontFamily);

            if ((0, _OverlayUtils.checkIsCustomFont)(fontFamily)) {
                if (!overlay.isSubtitle) {
                    if (!customFontsInNonCaptionOverlays[oId]) {
                        customFontsInNonCaptionOverlays[oId] = {};
                    }
                    customFontsInNonCaptionOverlays[oId][fontFamilyKey] = {
                        fontFamily: fontFamily,
                        fontFamilyLabel: fontFamilyLabel
                    };
                } else if (overlay.isSubtitle && !overlay.isPreviewSubtitle) {
                    if (!customFontsInCaptions[oId]) {
                        customFontsInCaptions[oId] = {};
                    }
                    customFontsInCaptions[oId][fontFamilyKey] = { fontFamily: fontFamily, fontFamilyLabel: fontFamilyLabel };
                }
            }
        });
    });

    return { customFontsInNonCaptionOverlays: customFontsInNonCaptionOverlays, customFontsInCaptions: customFontsInCaptions };
});

/**
 * returns the array of unique custom fonts used in captions
 */
var getUniqueCustomFontInCaptions = exports.getUniqueCustomFontInCaptions = (0, _reselect.createSelector)([getCustomFontUsedInOverlays], function (_ref10) {
    var customFontsInCaptions = _ref10.customFontsInCaptions;

    var captionCustomFontValues = {};
    Object.values(customFontsInCaptions).forEach(function (customFontsValueInCaption) {
        Object.values(customFontsValueInCaption).forEach(function (_ref11) {
            var fontFamilyLabel = _ref11.fontFamilyLabel;

            captionCustomFontValues[fontFamilyLabel] = true;
        });
    });

    return Object.keys(captionCustomFontValues);
});

/**
 * returns the array of unique custom fonts used in overlays excluding the captions
 */
var getUniqueCustomFontInNonCaptionOverlays = exports.getUniqueCustomFontInNonCaptionOverlays = (0, _reselect.createSelector)([getCustomFontUsedInOverlays], function (_ref12) {
    var customFontsInNonCaptionOverlays = _ref12.customFontsInNonCaptionOverlays;

    var nonCaptionCustomFontValues = {};
    Object.values(customFontsInNonCaptionOverlays).forEach(function (customFontValueInNonCaptionOverlays) {
        Object.values(customFontValueInNonCaptionOverlays).forEach(function (_ref13) {
            var fontFamilyLabel = _ref13.fontFamilyLabel;

            nonCaptionCustomFontValues[fontFamilyLabel] = true;
        });
    });

    return Object.keys(nonCaptionCustomFontValues);
});

},{"../../common/utils/FontManager":76,"../../common/utils/enums/PlaybackState":96,"../utils/OverlayUtils":231,"./reelSelectors":221,"./sequenceSelectors":223,"./workflowSelector":226,"fast-deep-equal":632,"reselect":1136}],218:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProjectDurationExceededSelector = exports.getStorageLimitInGBSelector = exports.canDeleteMediaSelector = exports.getStorageUsedStrSelector = undefined;

var _reselect = require('reselect');

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var getPlanConfig = function getPlanConfig(state) {
    return state.workspaceInfo.activeWorkspace.planConfig || {};
};

// in KB
var getUsedStorage = function getUsedStorage(state) {
    return Math.floor(state.workspaceInfo.activeWorkspace.storageUsedInMb || 0);
};

// in millisecs
var getProjectDuration = function getProjectDuration(state) {
    return state.player && state.player.duration;
};

var getProjectDurationInSecs = function getProjectDurationInSecs(state) {
    return Math.floor(getProjectDuration(state) / 1000);
};

var getStorageUsedStrSelector = exports.getStorageUsedStrSelector = (0, _reselect.createSelector)([getPlanConfig, getUsedStorage], function (planConfig, storageUsedInMb) {
    var storageUsedStr = '';

    var usedStorageSize = (0, _GeneralUtils.convertMbtoGb)(storageUsedInMb);

    if (planConfig.hasOwnProperty('storageLimitInMb')) {
        var storageLimitSize = (0, _GeneralUtils.convertMbtoGb)(planConfig.storageLimitInMb);

        storageUsedStr = usedStorageSize + '/' + storageLimitSize + ' GB';
    } else {
        storageUsedStr = usedStorageSize + ' GB';
    }

    return storageUsedStr;
});

var canDeleteMediaSelector = exports.canDeleteMediaSelector = (0, _reselect.createSelector)([getUsedStorage], function (storageUsedInMb) {
    return storageUsedInMb > 0;
});

var getStorageLimitInGBSelector = exports.getStorageLimitInGBSelector = (0, _reselect.createSelector)([getPlanConfig], function (planConfig) {
    return planConfig.hasOwnProperty('storageLimitInMb') ? (0, _GeneralUtils.convertMbtoGb)(planConfig.storageLimitInMb) : null;
});

var isProjectDurationExceededSelector = exports.isProjectDurationExceededSelector = (0, _reselect.createSelector)([getPlanConfig, getProjectDurationInSecs], function (planConfig, projectDuration) {
    var projectDurationInMins = parseFloat((projectDuration / 60).toFixed(2));
    var res = {
        isExportDurationExceeded: false,
        isProjectDurationExceeded: false,
        projectDurationInMins: projectDurationInMins
    };

    if (planConfig.hasOwnProperty('projectDurationLimitInMin')) {
        var projectDurationLimitInMin = planConfig.projectDurationLimitInMin;

        res.isProjectDurationExceeded = projectDurationInMins > projectDurationLimitInMin;
        res.projectDurationLimitInMins = projectDurationLimitInMin;
    }

    if (planConfig.hasOwnProperty('exportDurationLeftInMin')) {
        var exportDurationLeftInMin = planConfig.exportDurationLeftInMin,
            exportDurationLimitInMin = planConfig.exportDurationLimitInMin;

        res.isExportDurationExceeded = projectDurationInMins > exportDurationLeftInMin;
        res.exportDurationLeftInMin = Math.floor(planConfig.exportDurationLeftInMin);
        res.exportDurationLimitInMin = exportDurationLimitInMin;
    }

    return res;
});

},{"../../common/utils/GeneralUtils":77,"reselect":1136}],219:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProjectAssetsObject = undefined;

var _reselect = require('reselect');

var getProjectAssets = function getProjectAssets(state) {
    return state.projectAssets;
};

var getProjectAssetsObject = exports.getProjectAssetsObject = (0, _reselect.createSelector)([getProjectAssets], function () {
    var projectAsstes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return projectAsstes.reduce(function (acc, v) {
        acc[v.id] = v.assetData;
        return acc;
    }, {});
});

},{"reselect":1136}],220:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWorkspaceAndUploadingMedia = exports.makeGetUploadingAndErrorProjectMedia = exports.makeGetfilterMediaList = exports.getProjectMediaMap = exports.makeGetWorkspaceStockMedia = exports.makeGetReadyProjectAudio = exports.makeGetAllPersonalWorkspaceMedia = exports.makeGetReadyWorkspaceMedia = exports.makeGetErrorProjectMedia = exports.makeGetReadyProjectMedia = exports.makeGetUploadingProjectMedia = exports.makeGetWorkspaceAndProjectMedia = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _unionBy = require('lodash/unionBy');

var _unionBy2 = _interopRequireDefault(_unionBy);

var _ModelDataUtils = require('../../common/utils/ModelDataUtils');

var _MediaSourceType = require('../../common/constants/MediaSourceType');

var _VideoUploadStatus = require('../../common/utils/enums/VideoUploadStatus');

var _VideoUploadStatus2 = _interopRequireDefault(_VideoUploadStatus);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var getProjectMedia = function getProjectMedia(state) {
    return state.projectMedia;
};
var getWorkspaceMedia = function getWorkspaceMedia(state) {
    return state.workspaceMedia;
};
var getWorkspaceAudio = function getWorkspaceAudio(state) {
    return state.workspaceAudios;
};
var getUploads = function getUploads(state) {
    return state.uploads;
};

var isUserMedia = function isUserMedia(source) {
    return !_MediaSourceType.stockSource[source];
};

var checkIsDemoMode = function checkIsDemoMode() {
    return !!window.appManager && !!window.appManager.isDemoMode && window.appManager.isDemoMode();
};

var uploadObjToUploadItem = function uploadObjToUploadItem(ui) {
    var isIndeterminate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        id: ui.uploadId,
        mediaId: ui.mediaId,
        mediaType: ui.mediaType,
        createdTime: ui.createdTime,
        thumbnail: ui.thumbnail,
        isIndeterminate: ui.isIndeterminate || isIndeterminate,
        name: ui.name,
        percent: ui.percent,
        sortTime: ui.sortTime,
        error: ui.error,
        deleted: !!ui.deleted,
        type: ui.type,
        source: ui.source,
        size: ui.size,
        originalFileName: ui.originalFileName,
        snapshotUrl: ui.snapshotUrl,
        uploadStatus: ui.uploadStatus
    };
};

var processingMediaObjToUploadItem = function processingMediaObjToUploadItem(m) {
    var uploadObj = null;
    if (m.uploadObj) {
        uploadObj = m.uploadObj;
        uploadObj.mediaId = m.id;
        uploadObj.deleted = !!m.deleted;
        uploadObj.uploadStatus = m.uploadStatus;
    } else {
        var snapshotUrl = null;
        var name = '';
        var originalFileName = '';
        var sortTime = null;
        var type = null;
        var source = null;
        var size = 0;
        var createdTime = '';
        var uploadStatus = void 0;

        if (m.mediaType === 'video') {
            snapshotUrl = m.videoData.snapshotUrl; // WITH INSTANT UPLOAD THIS LINK IS A VALID SIGNED URL
            name = m.videoData.originalFileName;
            originalFileName = m.videoData.originalFileName;
            sortTime = new Date(m.videoData.createdAt);
            type = 'video';
            source = m.videoData.source;
            size = m.videoData.size;
            createdTime = m.videoData.createdAt;
            uploadStatus = m.videoData.uploadStatus;
        } else if (m.mediaType === 'image') {
            snapshotUrl = m.imageData.thumbUrl; // WITH INSTANT UPLOAD THIS LINK IS NOW A VALID SIGNED URL
            name = m.imageData.originalFileName;
            originalFileName = m.imageData.originalFileName;
            sortTime = new Date(m.imageData.createdAt);
            type = 'image';
            source = m.imageData.source;
            size = m.imageData.size;
            createdTime = m.imageData.createdAt;
            uploadStatus = m.imageData.uploadStatus;
        }
        uploadObj = {
            uploadStatus: uploadStatus,
            uploadId: m.id,
            mediaId: m.id,
            mediaType: m.mediaType,
            thumbnail: snapshotUrl,
            snapshotUrl: snapshotUrl,
            name: name,
            originalFileName: originalFileName,
            type: type,
            isIndeterminate: true,
            percent: 100,
            sortTime: sortTime,
            error: null,
            source: source,
            deleted: !!m.deleted,
            originalData: m,
            size: size,
            createdTime: createdTime
        };
    }
    return uploadObjToUploadItem(uploadObj, true);
};

// PRE COMPUTE THE STOCK VERSION -- CREATE THREE LIST

/**
 *
 * Usage
 * - noPersonalFilter = Stock media will not be filtered out , All media will be shows
 * - onlyStock = Personal media like , Zoom , Shopify and user uploads will be filetred out
 *
 * @param {boolean} [noPersonalFilter=false]
 * @param {boolean} [onlyStock=false]
 * @return {*}
 */
var makeGetUploadingProjectMedia = function makeGetUploadingProjectMedia() {
    var noPersonalFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var onlyStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, _reselect.createSelector)([getUploads, getProjectMedia], function (uploads, projectMedia) {
        var uploadItems = uploads.filter(function (ui) {
            var isPersonal = (isUserMedia(ui.source) ? !onlyStock : onlyStock) || checkIsDemoMode() || noPersonalFilter;
            return isPersonal;
        }).filter(function (ui) {
            return ui.itemType === 'PROJECT_MEDIA';
        }).filter(function (ui) {
            return !ui.error;
        }).map(function (ui) {
            return uploadObjToUploadItem(ui, ui.isIndeterminate);
        });

        // Spoof upload items from still processing media
        var processingItems = projectMedia.filter(function (m) {
            var isPersonal = (isUserMedia((m.videoData || m.imageData || {}).source) ? !onlyStock : onlyStock) || checkIsDemoMode() || noPersonalFilter;
            if (m.mediaType === 'video' && !m.videoData.deleted) {
                return !(0, _ModelDataUtils.isVideoReady)(m.videoData) && isPersonal; // Note the negation
            }
            if (m.mediaType === 'image' && !m.imageData.deleted) {
                return !(0, _ModelDataUtils.isImageReady)(m.imageData) && isPersonal; // Note the negation
            }
            return false;
        }).map(processingMediaObjToUploadItem);
        return uploadItems.concat(processingItems).concat() // copy
        .sort(function (a, b) {
            return b.sortTime - a.sortTime;
        });
    });
};

var makeGetErrorProjectMedia = function makeGetErrorProjectMedia() {
    return (0, _reselect.createSelector)([getUploads], function (uploads) {
        var uploadItems = uploads.filter(function (ui) {
            return ui.itemType === 'PROJECT_MEDIA';
        }).filter(function (ui) {
            return !!ui.error;
        }).map(function (ui) {
            return uploadObjToUploadItem(ui);
        });

        return uploadItems.concat() // copy
        .sort(function (a, b) {
            return b.sortTime - a.sortTime;
        });
    });
};

var makeGetReadyProjectAudio = function makeGetReadyProjectAudio() {
    return (0, _reselect.createSelector)([getProjectMedia, getWorkspaceAudio], function (projectMedia, workspaceAudios) {
        var projectAudios = projectMedia.filter(function (m) {
            if (m.mediaType === 'audio') {
                return (0, _ModelDataUtils.isAudioReady)(m.audioData);
            }
            return false;
        }).map(function (m) {
            var dataTrans = _extends({
                id: m.id,
                type: m.mediaType
            }, m.audioData, {
                sortTime: new Date(m.audioData.createdAt)
            });
            return dataTrans;
        }).concat() // copy
        .sort(function (a, b) {
            return b.sortTime - a.sortTime;
        });

        return (0, _unionBy2.default)(projectAudios, workspaceAudios, 'id');
    });
};

var makeGetReadyProjectMedia = function makeGetReadyProjectMedia() {
    var noPersonalFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (0, _reselect.createSelector)([getProjectMedia], function (projectMedia) {
        return (
            // Pass only completed uploads
            getReadyProjectMedia(projectMedia, noPersonalFilter)
        );
    });
};

var getProjectMediaMap = (0, _reselect.createSelector)([getProjectMedia], function () {
    var projectMedia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var map = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = projectMedia[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var pm = _step.value;

            map[pm.id] = mediaToUItemFormat(pm, true);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return map;
});

var getWorkspaceMediaExcludingTypitoStockMedia = (0, _reselect.createSelector)([getWorkspaceMedia], function (workspaceMedia) {
    return workspaceMedia.filter(function (m) {
        return (m.videoData || m.imageData || {}).source !== _MediaSourceType.stockSource['typito-template-page-stock'];
    });
});

var makeGetAllPersonalWorkspaceMedia = function makeGetAllPersonalWorkspaceMedia() {
    var noPersonalFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var onlyStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, _reselect.createSelector)([getWorkspaceMediaExcludingTypitoStockMedia], function (workspaceMedia) {
        var result = getReadyWorkspaceMedia(workspaceMedia, {
            noPersonalFilter: noPersonalFilter,
            onlyStock: onlyStock
        });
        return result.sort(function (a, b) {
            return b.sortTime - a.sortTime;
        });
    });
};

var makeGetReadyWorkspaceMedia = function makeGetReadyWorkspaceMedia() {
    return (0, _reselect.createSelector)([getWorkspaceMedia], function (workspaceMedia) {
        return (
            // Pass only completed uploads
            getReadyWorkspaceMedia(workspaceMedia)
        );
    });
};
// TODO - precompute and reduce the number of loops here
var makeGetWorkspaceAndProjectMedia = function makeGetWorkspaceAndProjectMedia() {
    var noPersonalFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var onlyStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, _reselect.createSelector)([getWorkspaceMedia, getProjectMedia], function (workspaceMedia, projectMedia) {
        var result = (0, _unionBy2.default)(getReadyProjectMedia(projectMedia, noPersonalFilter, onlyStock), getReadyWorkspaceMedia(workspaceMedia, {
            noPersonalFilter: noPersonalFilter,
            onlyStock: onlyStock
        }), 'id');
        return result.sort(function (a, b) {
            return b.sortTime - a.sortTime;
        });
    });
};

var makeGetfilterMediaList = function makeGetfilterMediaList() {
    var filterFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return true;
    };
    return (0, _reselect.createSelector)([function (shouldFilter) {
        var mediaList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return shouldFilter;
    }, function (shouldFilter) {
        var mediaList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return mediaList;
    }], function (shouldFilter) {
        var mediaList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var result = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = mediaList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var media = _step2.value;

                // preferring for loop for avoiding useless function calls for large workspace
                if (!shouldFilter || filterFn(media)) result.push(media);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return result;
    });
};

var makeGetWorkspaceStockMedia = function makeGetWorkspaceStockMedia() {
    return (0, _reselect.createSelector)([getWorkspaceMediaExcludingTypitoStockMedia], function (workspaceMedia) {
        return getReadyWorkspaceMedia(workspaceMedia, { onlyStock: true });
    });
};

function mediaToUItemFormat(mediaItem) {
    var isProjectMedia = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var m = mediaItem;
    var snapshotUrl = null;
    var duration = null;
    var sortTime = null;
    var height = null;
    var width = null;
    var source = null;
    var originalFileName = null;
    var createdTime = null;
    var previewUrl = null;
    var thumbUrl = null;
    var size = 0;
    var mappedProjects = null;
    var mappedSequences = null;

    if (m.mediaType === 'video' && m.videoData) {
        snapshotUrl = m.videoData.snapshotUrl;
        duration = m.videoData.duration;
        sortTime = new Date(m.videoData.createdAt);
        height = m.videoData.height;
        width = m.videoData.width;
        originalFileName = m.videoData.originalFileName;
        previewUrl = m.videoData.dashUrl;
        createdTime = m.videoData.createdAt;
        thumbUrl = m.videoData.thumbStripUrl;
        size = m.videoData.size;
        mappedProjects = m.mappedProjects;
        mappedSequences = m.mappedSequences;
    } else if (m.mediaType === 'image' && m.imageData) {
        snapshotUrl = m.imageData.thumbUrl;
        sortTime = new Date(m.imageData.createdAt);
        height = m.imageData.height;
        width = m.imageData.width;
        originalFileName = m.imageData.originalFileName;
        createdTime = m.imageData.createdAt;
        source = m.imageData.source;
        previewUrl = m.imageData.previewUrl;
        thumbUrl = m.imageData.thumbUrl;
        size = m.imageData.size;
        mappedProjects = m.mappedProjects;
        mappedSequences = m.mappedSequences;
    }

    var _ref = mediaItem.videoData || mediaItem.imageData || {},
        _ref$isUserSpace = _ref.isUserSpace,
        isUserSpace = _ref$isUserSpace === undefined ? false : _ref$isUserSpace,
        _ref$isThumbnailUpdat = _ref.isThumbnailUpdated,
        isThumbnailUpdated = _ref$isThumbnailUpdat === undefined ? false : _ref$isThumbnailUpdat,
        _ref$userSpaceUrl = _ref.userSpaceUrl,
        userSpaceUrl = _ref$userSpaceUrl === undefined ? '' : _ref$userSpaceUrl,
        _ref$userSpaceThumbna = _ref.userSpaceThumbnailUrl,
        userSpaceThumbnailUrl = _ref$userSpaceThumbna === undefined ? '' : _ref$userSpaceThumbna;

    return {
        id: m.id,
        type: m.mediaType,
        createdTime: createdTime,
        size: size,
        snapshotUrl: snapshotUrl,
        duration: duration,
        sortTime: sortTime,
        height: height,
        width: width,
        source: source,
        originalFileName: originalFileName,
        previewUrl: previewUrl,
        isCurrProjectMedia: isProjectMedia,
        thumbUrl: thumbUrl,
        isUserSpace: isUserSpace,
        userSpaceUrl: userSpaceUrl,
        userSpaceThumbnailUrl: userSpaceThumbnailUrl,
        isThumbnailUpdated: isThumbnailUpdated,
        mappedProjects: mappedProjects,
        mappedSequences: mappedSequences
    };
}

/**
 * This selector will be used in other pages too.
 *
 * @param {Array<object>} workspaceMedia
 * @param {{ noPersonalFilter: boolean,
 * onlyStock: boolean,
 * noReadyFilter: boolean }} filterObj
 */
function getReadyWorkspaceMedia(workspaceMedia) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$noPersonalFilte = _ref2.noPersonalFilter,
        noPersonalFilter = _ref2$noPersonalFilte === undefined ? false : _ref2$noPersonalFilte,
        _ref2$onlyStock = _ref2.onlyStock,
        onlyStock = _ref2$onlyStock === undefined ? false : _ref2$onlyStock,
        _ref2$noReadyFilter = _ref2.noReadyFilter,
        noReadyFilter = _ref2$noReadyFilter === undefined ? false : _ref2$noReadyFilter;

    return workspaceMedia.filter(function (m) {
        var isUM = isUserMedia((m.videoData || m.imageData || {}).source);
        var isPersonal = (isUM ? !onlyStock : onlyStock) || checkIsDemoMode() || noPersonalFilter;

        if (m.mediaType === 'video' && !m.videoData.deleted) {
            return isPersonal && (noReadyFilter ? true : (0, _ModelDataUtils.isVideoReady)(m.videoData));
        }
        if (m.mediaType === 'image' && !m.imageData.deleted) {
            return isPersonal && (noReadyFilter ? true : (0, _ModelDataUtils.isImageReady)(m.imageData));
        }
        return false;
    }).map(function (m) {
        return mediaToUItemFormat(m, false);
    })
    // .concat() // copy
    .sort(function (a, b) {
        return b.sortTime - a.sortTime;
    });
}

function getReadyProjectMedia(projectMedia) {
    var noPersonalFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var onlyStock = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return projectMedia.filter(function (m) {
        var isPersonal = (isUserMedia((m.videoData || m.imageData || {}).source) ? !onlyStock : onlyStock) || checkIsDemoMode() || noPersonalFilter;
        if (m.mediaType === 'video' && !m.videoData.deleted) {
            return isPersonal && (0, _ModelDataUtils.isVideoReady)(m.videoData);
        }
        if (m.mediaType === 'image' && !m.imageData.deleted) {
            return isPersonal && (0, _ModelDataUtils.isImageReady)(m.imageData);
        }
        return false;
    }).map(function (m) {
        return mediaToUItemFormat(m, true);
    })
    // .concat() // copy
    .sort(function (a, b) {
        return b.sortTime - a.sortTime;
    });
}

exports.makeGetWorkspaceAndProjectMedia = makeGetWorkspaceAndProjectMedia;
exports.makeGetUploadingProjectMedia = makeGetUploadingProjectMedia;
exports.makeGetReadyProjectMedia = makeGetReadyProjectMedia;
exports.makeGetErrorProjectMedia = makeGetErrorProjectMedia;
exports.makeGetReadyWorkspaceMedia = makeGetReadyWorkspaceMedia;
exports.makeGetAllPersonalWorkspaceMedia = makeGetAllPersonalWorkspaceMedia;
exports.makeGetReadyProjectAudio = makeGetReadyProjectAudio;
exports.makeGetWorkspaceStockMedia = makeGetWorkspaceStockMedia;
exports.getProjectMediaMap = getProjectMediaMap;
exports.makeGetfilterMediaList = makeGetfilterMediaList;

/**
 *
 * Usage
 * - noPersonalFilter = Stock media will not be filtered out , All media will be shows
 * - onlyStock = Personal media like , Zoom , Shopify and user uploads will be filetred out
 *
 * @param {boolean} [noPersonalFilter=false]
 * @param {boolean} [onlyStock=false]
 * @return {*}
 */

var makeGetUploadingAndErrorProjectMedia = exports.makeGetUploadingAndErrorProjectMedia = function makeGetUploadingAndErrorProjectMedia() {
    var noPersonalFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var onlyStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, _reselect.createSelector)([getUploads, getProjectMedia], function (uploads, projectMedia) {
        var uploadItems = uploads.filter(function (ui) {
            var isPersonal = (isUserMedia(ui.source) ? !onlyStock : onlyStock) || checkIsDemoMode() || noPersonalFilter;
            return isPersonal;
        }).filter(function (ui) {
            return ui.itemType === 'PROJECT_MEDIA';
        }).map(function (ui) {
            ui.uploadStatus = _VideoUploadStatus2.default.UPLOADING;
            return uploadObjToUploadItem(ui, ui.isIndeterminate);
        });

        // Spoof upload items from still processing media
        var processingItems = projectMedia.filter(function (m) {
            var isPersonal = (isUserMedia((m.videoData || m.imageData || {}).source) ? !onlyStock : onlyStock) || checkIsDemoMode() || noPersonalFilter;
            if (m.mediaType === 'video' && !m.videoData.deleted) {
                return !(0, _ModelDataUtils.isVideoReady)(m.videoData) && isPersonal; // Note the negation
            }
            if (m.mediaType === 'image' && !m.imageData.deleted) {
                return !(0, _ModelDataUtils.isImageReady)(m.imageData) && isPersonal; // Note the negation
            }
            return false;
        }).map(processingMediaObjToUploadItem);
        return uploadItems.concat(processingItems).concat() // copy
        .sort(function (a, b) {
            return b.sortTime - a.sortTime;
        });
    });
};

// New selector for sepparating workspace media , which are instant ready for usage
// and uploading content which are not
var getWorkspaceAndUploadingMedia = exports.getWorkspaceAndUploadingMedia = (0, _reselect.createSelector)([function (state) {
    return state.uploadingProjectMedia;
}, function (state) {
    return state.currentProjectMedia;
}], function (uploadingProjectMedia, workspaceMedia) {
    var indeterminateMedia = uploadingProjectMedia.filter(function (m) {
        return m.isIndeterminate;
    }).map(function (m) {
        return _extends({}, m, { fromUploadingData: true, id: m.mediaId });
    }); // TODO account for playable media as well
    var uploadingMedia = uploadingProjectMedia.filter(function (m) {
        return !m.isIndeterminate;
    });

    return {
        workspaceMedia: [].concat(_toConsumableArray(workspaceMedia), _toConsumableArray(indeterminateMedia)).sort(function (a, b) {
            return a.createdTime - b.createdTime;
        }),
        uploadingMedia: uploadingMedia
    };
});

},{"../../common/constants/MediaSourceType":63,"../../common/utils/ModelDataUtils":80,"../../common/utils/enums/VideoUploadStatus":99,"lodash/unionBy":873,"reselect":1136}],221:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelectedClipAndInnerClip = exports.getSelectedSequenceInnerClip = exports.minMaxTimeOfCurrentSelectedClip = exports.getCurrentOverlayTimelineMode = exports.hasDeletedMediaInClipsSelector = exports.isSelectedClipDeletedSelector = exports.isSelectedClipSolidImageSelector = exports.getAdjacentClipIdsSelector = exports.canBreakApartClip = exports.isEmptyProjectSelector = exports.getReelDurationInfo = exports.getClipTimesInfo = exports.getMediaUsedObject = exports.getClipsObjects = exports.makeGetClipsObjects = exports.isCursorOnClipBoundarySelector = exports.isReelPlaying = exports.anyClipSelected = exports.getCurrentClipSelected = exports.makeGetCurrentClipSelected = undefined;

var _reselect = require('reselect');

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _WaitMode = require('../../common/utils/enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _ReelHelpers = require('../../common/utils/ReelHelpers');

var _SolidImage = require('../../common/constants/SolidImage');

var _Player = require('../../common/constants/Player');

var _MediaConstants = require('../../../../constants/MediaConstants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var getClips = function getClips(state) {
    return state.reel.clips;
};
var getCurrentTime = function getCurrentTime(state) {
    return state.player.time;
};
var getPlayBackState = function getPlayBackState(state) {
    return state.player.playbackState;
};
var getWaitMode = function getWaitMode(state) {
    return state.player.waitMode;
};

var makeGetCurrentClipSelected = exports.makeGetCurrentClipSelected = function makeGetCurrentClipSelected() {
    return (0, _reselect.createSelector)([getClips], function (clips) {
        var clip = clips.find(function (cc) {
            return cc.isSelected;
        }); // return empty object // TODO use some
        return clip;
    });
};

// TODO -- refactor new placves where it is used
var getCurrentClipSelected = exports.getCurrentClipSelected = makeGetCurrentClipSelected();

var anyClipSelected = exports.anyClipSelected = (0, _reselect.createSelector)([getCurrentClipSelected], function (clips) {
    return !!clips;
});

var isReelPlaying = exports.isReelPlaying = (0, _reselect.createSelector)([getPlayBackState, getWaitMode], function (playbackState, waitMode) {
    return playbackState === _PlaybackState2.default.PLAYING && waitMode === _WaitMode2.default.NONE;
});

function checkClipBoundary(time, clips) {
    if (time == 0) {
        return true;
    }

    for (var i = 0; i < clips.length; i++) {
        var clip = clips[i];
        var _clip$time = clip.time,
            enterStart = _clip$time.enterStart,
            exitDone = _clip$time.exitDone,
            _clip$time$prevOffset = _clip$time.prevOffset,
            prevOffset = _clip$time$prevOffset === undefined ? 0 : _clip$time$prevOffset,
            _clip$time$currentOff = _clip$time.currentOffset,
            currentOffset = _clip$time$currentOff === undefined ? 0 : _clip$time$currentOff;

        if (time == enterStart + prevOffset + currentOffset || time == exitDone + prevOffset + currentOffset) {
            return true;
        }
    }
    return false;
}

var isCursorOnClipBoundarySelector = exports.isCursorOnClipBoundarySelector = (0, _reselect.createSelector)([getClips, getCurrentTime], function (clips, time) {
    return checkClipBoundary(time, clips);
});

var makeGetClipsObjects = exports.makeGetClipsObjects = function makeGetClipsObjects() {
    return (0, _reselect.createSelector)([getClips], function () {
        var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var clipsObject = clips.reduce(function (acc, clip, index) {
            clip.index = index;
            acc[clip.clipId] = clip;
            return acc;
        }, {});
        return clipsObject;
    });
};

var getClipsObjects = exports.getClipsObjects = makeGetClipsObjects();

var getMediaUsedObject = exports.getMediaUsedObject = (0, _reselect.createSelector)([getClips], function () {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var isUsedObject = clips.reduce(function (acc, clip) {
        var id = clip.clipVideoId || clip.clipImageId || 'unused';
        if (acc[id] !== undefined) acc[id] += 1;else acc[id] = 0;
        return acc;
    }, {});

    return isUsedObject;
});

/**
 * Caches in the clip time info for clip list. Its a costly O-N operation need
 * not compute every time
 */
var getClipTimesInfo = exports.getClipTimesInfo = (0, _reselect.createSelector)([getClips], function () {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return (0, _ReelHelpers.getClipTimes)(clips);
});

var getReelDurationInfo = exports.getReelDurationInfo = (0, _reselect.createSelector)([getClips], function () {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return (0, _ReelHelpers.getReelDuration)(clips);
});

/*
 * Returns true if no clips added to timeline.
 */
var isEmptyProjectSelector = exports.isEmptyProjectSelector = (0, _reselect.createSelector)([getClips], function () {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return clips.length === 0;
});

// export const getClipUnderPlayhead = createSelector([clips] , )

var canBreakApartClip = exports.canBreakApartClip = (0, _reselect.createSelector)([getCurrentClipSelected], function (selectedClip) {
    if (!!selectedClip && selectedClip.clipType === 'composite') return true;
    return false;
});

var getAdjacentClipIdsSelector = exports.getAdjacentClipIdsSelector = (0, _reselect.createSelector)([getClips, function (_, clipId) {
    return clipId;
}], function (clips, targetId) {
    var clipIndex = clips.findIndex(function (c) {
        return c.clipId === targetId;
    });

    var leftClipId = null;
    var rightClipId = null;
    if (clipIndex !== -1) {
        if (clipIndex > 0) {
            leftClipId = clips[clipIndex - 1].clipId;
        }
        if (clipIndex < clips.length - 1) {
            rightClipId = clips[clipIndex + 1].clipId;
        }
    }
    return { leftClipId: leftClipId, rightClipId: rightClipId };
});
var isSelectedClipSolidImageSelector = exports.isSelectedClipSolidImageSelector = (0, _reselect.createSelector)([getCurrentClipSelected], function (selectedClip) {
    return !!selectedClip && selectedClip.clipType === 'image' && selectedClip.clipImageId === _SolidImage.SolidImageId;
});

var isSelectedClipDeletedSelector = exports.isSelectedClipDeletedSelector = (0, _reselect.createSelector)([getCurrentClipSelected], function (selectedClip) {
    if (selectedClip) {
        var isImageDeleted = selectedClip.clipType === 'image' && selectedClip.clipImage.deleted;

        var isVideoDeleted = selectedClip.clipType === 'video' && selectedClip.clipVideo.deleted;

        var isCompositeClipDeleted = selectedClip.clipType === 'composite' && selectedClip.deleted;

        return isImageDeleted || isVideoDeleted || isCompositeClipDeleted;
    }
    return false;
});

function isVideoClipDeleted(c) {
    return c.clipType === 'video' && c.clipVideo.deleted;
}

function isImageClipDeleted(c) {
    return c.clipType === 'image' && c.clipImage.deleted;
}

var hasDeletedMediaInClipsSelector = exports.hasDeletedMediaInClipsSelector = (0, _reselect.createSelector)([getClips], function () {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return clips.some(function (c) {
        if (isImageClipDeleted(c)) {
            return true;
        }
        if (isVideoClipDeleted(c)) {
            return true;
        }
        if (c.clipType === 'composite') {
            if (c.deleted) return true;
            return c.childClips.some(function (c) {
                if (isImageClipDeleted(c)) {
                    return true;
                }
                if (isVideoClipDeleted(c)) {
                    return true;
                }
                return false;
            });
        }
        return false;
    });
});

var getCurrentOverlayTimelineMode = exports.getCurrentOverlayTimelineMode = (0, _reselect.createSelector)([getCurrentClipSelected], function (currentClip) {
    var currentTimeControlMode = _Player.TimeControlMode.NORMAL_OVERLAY;
    if (currentClip && currentClip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
        currentTimeControlMode = _Player.TimeControlMode.SEQUENCE_OVERLAY;
    }
    return currentTimeControlMode;
});

var minMaxTimeOfCurrentSelectedClip = exports.minMaxTimeOfCurrentSelectedClip = (0, _reselect.createSelector)([getCurrentClipSelected], function (clipSelected) {
    if (clipSelected) {
        var _clipSelected$time = clipSelected.time,
            enterStart = _clipSelected$time.enterStart,
            prevOffset = _clipSelected$time.prevOffset,
            currentOffset = _clipSelected$time.currentOffset,
            clipDuration = clipSelected.clipDuration,
            speed = clipSelected.speed;

        var trueUIDuration = clipDuration / speed + currentOffset;
        var trueUIStart = enterStart + prevOffset;

        return {
            minTime: trueUIStart,
            duration: trueUIDuration,
            maxTIme: trueUIStart + trueUIDuration
        };
    }
    return null;
});

/**
 * selector to get the sequence inner clip at the playhead position
 */
var getSelectedSequenceInnerClip = exports.getSelectedSequenceInnerClip = (0, _reselect.createSelector)([getCurrentClipSelected, getClips, getCurrentTime], function (selectedClip, clips, playerTime) {
    if (!!selectedClip && selectedClip.clipType === 'composite') {
        var totalTimeUntilSelectedClip = (0, _ReelHelpers.getDurationUntilClip)(clips, selectedClip.clipId);

        var childClips = selectedClip.childClips;

        var reelDurationUntilInnerClip = totalTimeUntilSelectedClip + (0, _ReelHelpers.getDurationUntilClip)(childClips, childClips[0].clipId);

        for (var i = 1; i < childClips.length; i++) {
            var cc = childClips[i];
            var reelDurationUntilCurrentInnerClip = (0, _ReelHelpers.getDurationUntilClip)(childClips, cc.clipId);

            if (reelDurationUntilInnerClip <= playerTime && totalTimeUntilSelectedClip + reelDurationUntilCurrentInnerClip >= playerTime) {
                return childClips[i - 1];
            }
            reelDurationUntilInnerClip = totalTimeUntilSelectedClip + reelDurationUntilCurrentInnerClip;
        }
        return childClips[childClips.length - 1];
    }
    return null;
});

/**
 * selector to get the selected clip and the inner clip of the selected sequence.
 */
var getSelectedClipAndInnerClip = exports.getSelectedClipAndInnerClip = (0, _reselect.createSelector)([getCurrentClipSelected, getSelectedSequenceInnerClip], function (selectedClip, sequenceInnerChildClip) {
    return {
        selectedClip: selectedClip,
        sequenceInnerChildClip: sequenceInnerChildClip
    };
});

},{"../../../../constants/MediaConstants":309,"../../common/constants/Player":64,"../../common/constants/SolidImage":66,"../../common/utils/ReelHelpers":85,"../../common/utils/enums/PlaybackState":96,"../../common/utils/enums/WaitMode":100,"reselect":1136}],222:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSequenceObject = undefined;

var _reselect = require('reselect');

var getSeq = function getSeq(state) {
    return state.sequences;
};

var getSequenceObject = exports.getSequenceObject = (0, _reselect.createSelector)([getSeq], function () {
    var sequences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return sequences.reduce(function (a, v) {
        a[v.id] = v;
        return a;
    }, {});
});

},{"reselect":1136}],223:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserCreatedSequenceData = exports.getSequenceOverlaysForClipId = exports.makeGetSequenceOverlaysForSelectedClips = exports.getSelectedClipId = exports.getCurrentSelectedSequenceOverlaysFilterdByHidden = exports.getCurrentSelectedSequenceOverlays = exports.getSelectedSeqeuenceOverlaysFunc = exports.getSelectedSequenceOverlayIdFunc = exports.makeGetOverlaysFromSequenceId = exports.makeGetOverlayToSequenceClipIdMapSelected = exports.makeGetOverlayToSequenceClipIdMap = exports.makeGetSequenceOverlays = exports.makeGetSequenceClips = exports.makeGetUnpackedClips = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _errorReporting = require('../../common/utils/errorReporting');

var _reelSelectors = require('./reelSelectors');

var _MediaConstants = require('../../../../constants/MediaConstants');

var _constants = require('../../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var getClips = function getClips(state) {
    return state.reel.clips;
};
var getOverlays = function getOverlays(state) {
    return state.overlays;
};
var getOverlayMeta = function getOverlayMeta(state) {
    return state.overlaymeta;
};

var getSequences = function getSequences(state) {
    return state.sequences;
};

var getStartTime = function getStartTime(state, start, duration) {
    return start;
};
var getDuration = function getDuration(state, start, duration) {
    return duration;
};
var getSequenceOverlays = function getSequenceOverlays(state) {
    return state.overlaymeta.sequenceOverlays;
};

var getSelectedOverlays = function getSelectedOverlays(state) {
    return state.selection.selected;
};

var deepEqualCreateSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _fastDeepEqual2.default);

// TODO -- below are some common selectors , shared across , take them to common file
var getOverlaysWithValidTemplate = (0, _reselect.createSelector)([getOverlays], function (overlays) {
    return Object.keys(overlays).reduce(function (acc, key) {
        var overlay = overlays[key];
        if (overlay.templateDefMissing) {
            return acc;
        }
        acc[key] = overlays[key];
        return acc;
    }, {});
});

var getNonWaterMarkOverlays = (0, _reselect.createSelector)([getOverlaysWithValidTemplate], function (overlays) {
    return Object.keys(overlays).reduce(function (acc, key) {
        if (!overlays[key].isWatermark) acc[key] = overlays[key];
        return acc;
    }, {});
});

var getNonWaterMarkOverlaysFilteredByHidden = (0, _reselect.createSelector)([getNonWaterMarkOverlays], function (overlays) {
    return Object.values(overlays).reduce(function (acc, ov) {
        if (!ov.hide) {
            acc[ov.id] = ov;
        }
        return acc;
    }, {});
});

var makeGetUnpackedClips = exports.makeGetUnpackedClips = function makeGetUnpackedClips() {
    return (0, _reselect.createSelector)([getClips], function (clips) {
        var newClips = [];

        clips.forEach(function (clip) {
            if (clip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
                if (clip.childClips && clip.childClips.length > 0) {
                    clip.childClips.forEach(function (c) {
                        var _c$time = c.time,
                            enterStart = _c$time.enterStart,
                            enterDone = _c$time.enterDone,
                            exitStart = _c$time.exitStart,
                            exitDone = _c$time.exitDone;

                        newClips.push(_extends({}, c, {
                            time: _extends({}, c.time, {
                                enterStart: clip.time.enterStart + enterStart,
                                enterDone: clip.time.enterStart + enterDone,
                                exitStart: clip.time.enterStart + exitStart,
                                exitDone: clip.time.enterStart + exitDone
                            })
                        }));
                    });
                }
            } else {
                newClips.push(_extends({}, clip));
            }
        });

        return newClips;
    });
};

var makeGetSequenceClips = exports.makeGetSequenceClips = function makeGetSequenceClips() {
    var getUnpackedClips = makeGetUnpackedClips();

    return (0, _reselect.createSelector)([getUnpackedClips, getStartTime, getDuration], function (clips, start, duration) {
        return clips.filter(function (c) {
            var _c$time2 = c.time,
                enterStart = _c$time2.enterStart,
                exitDone = _c$time2.exitDone;

            return exitDone >= start && enterStart <= start + duration;
        });
    });
};

var MIN_OVERLAY_DURATION = 500;

// Retrieve overlays between 2 times in timeline
var makeGetSequenceOverlays = exports.makeGetSequenceOverlays = function makeGetSequenceOverlays() {
    return (0, _reselect.createSelector)([getOverlays, getStartTime, getDuration], function (overlays, start, duration) {
        return Object.values(overlays).filter(function (o) {
            var _o$time = o.time,
                enterstart = _o$time.enterstart,
                exitdone = _o$time.exitdone;

            return exitdone >= start + MIN_OVERLAY_DURATION && enterstart <= start + duration - MIN_OVERLAY_DURATION;
        });
    });
};
// TODO -- check for frequent updation of this , clipsObject updates very frequently because of selection logic
// Might require deep equal checks somewhere , can be picked in sepparate sprint
var makeGetOverlayToSequenceClipIdMap = exports.makeGetOverlayToSequenceClipIdMap = function makeGetOverlayToSequenceClipIdMap() {
    return (0, _reselect.createSelector)([getNonWaterMarkOverlays, getOverlayMeta, _reelSelectors.getClipsObjects],
    // TODO Use overlays to validate that the overlay itself exist or not
    function (overlays, overlaymeta, clipsObject) {
        if (!overlaymeta) return {};

        var sequenceOverlays = overlaymeta.sequenceOverlays;

        if (!sequenceOverlays) return {};

        var overlaySequenceMap = {};

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(sequenceOverlays)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var clipId = _step.value;

                // checking to ensure the data is valid , if clip is deleted the over lay data inside it is also invalid
                if (!!clipsObject[clipId] && clipsObject[clipId].clipType === _MediaConstants.SupportedReelClipTypes.composite) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = Object.keys(sequenceOverlays[clipId])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _oid = _step2.value;

                            if (sequenceOverlays[clipId][_oid]) {
                                overlaySequenceMap[_oid] = clipId;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return overlaySequenceMap;
    });
};

var getOverlayToSequenceClipIdMap = makeGetOverlayToSequenceClipIdMap();

var makeGetOverlayToSequenceClipIdMapSelected = exports.makeGetOverlayToSequenceClipIdMapSelected = function makeGetOverlayToSequenceClipIdMapSelected() {
    return (0, _reselect.createSelector)([getOverlayToSequenceClipIdMap, getSelectedOverlays], function () {
        return Object.keys(getSelectedOverlays).reduce(function (acc, key) {
            if (getOverlayToSequenceClipIdMap[key]) {
                acc[key] = getOverlayToSequenceClipIdMap[key];
            }
            return acc;
        }, {});
    });
};

// Get overlays in a sequence in timeline
var makeGetOverlaysFromSequenceId = exports.makeGetOverlaysFromSequenceId = function makeGetOverlaysFromSequenceId(clipId) {
    return (0, _reselect.createSelector)([getNonWaterMarkOverlays, getOverlayMeta], function (overlays, overlaymeta) {
        var overlayIds = [];
        if (!!overlaymeta && !!overlaymeta.sequenceOverlays) {
            var overlayIdsMap = overlaymeta.sequenceOverlays[clipId] || {};
            overlayIds = Object.keys(overlayIdsMap).filter(function (oid) {
                return overlayIdsMap[oid] === true;
            });
        }

        var sequenceOverlays = {};
        overlayIds.forEach(function (oid) {
            if (overlays[oid]) sequenceOverlays[oid] = overlays[oid];
        });

        return sequenceOverlays;
    });
};

var getSelectedSequenceOverlayIdFunc = exports.getSelectedSequenceOverlayIdFunc = (0, _reselect.createSelector)([getSelectedOverlays, getSequenceOverlays], function (selectedOverlays, sequenceOverlayMap) {
    return function (clipId) {
        var sequenceOverlayMapForClip = sequenceOverlayMap[clipId];
        if (!sequenceOverlayMapForClip) return {};
        return Object.keys(selectedOverlays).reduce(function (acc, key) {
            if (sequenceOverlayMapForClip[key]) {
                acc[key] = true;
            }
            return acc;
        }, {});
    };
});

var getSelectedSeqeuenceOverlaysFunc = exports.getSelectedSeqeuenceOverlaysFunc = (0, _reselect.createSelector)([getSelectedSequenceOverlayIdFunc, getNonWaterMarkOverlays], function (selectFunc, overlays) {
    return function (clipId) {
        var selectedSequenceOverlayIds = selectFunc(clipId);
        return Object.keys(selectedSequenceOverlayIds).reduce(function (acc, key) {
            if (overlays[key]) acc[key] = overlays[key];
            return acc;
        }, {});
    };
});

var filterOverlaysForCurrentSequence = function filterOverlaysForCurrentSequence() {
    var sequenceOverlayMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var currentClipId = arguments[1];
    var overlays = arguments[2];

    sequenceOverlayMap = sequenceOverlayMap || {};
    var sequnceOverlays = sequenceOverlayMap[currentClipId];
    if (!sequnceOverlays) return {};
    return Object.keys(sequnceOverlays).reduce(function (acc, key) {
        if (overlays[key]) {
            acc[key] = overlays[key];
        }
        return acc;
    }, {});
};

var getCurrentSelectedSequenceOverlays = exports.getCurrentSelectedSequenceOverlays = (0, _reselect.createSelector)([getSequenceOverlays, _reelSelectors.getCurrentClipSelected, getNonWaterMarkOverlays], function () {
    var sequenceOverlayMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var currentClip = arguments[1];
    var overlays = arguments[2];

    var _ref = currentClip || {},
        clipId = _ref.clipId;

    return filterOverlaysForCurrentSequence(sequenceOverlayMap, clipId, overlays);
});

var getCurrentSelectedSequenceOverlaysFilterdByHidden = exports.getCurrentSelectedSequenceOverlaysFilterdByHidden = (0, _reselect.createSelector)([getSequenceOverlays, _reelSelectors.getCurrentClipSelected, getNonWaterMarkOverlaysFilteredByHidden], function () {
    var sequenceOverlayMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var currentClip = arguments[1];
    var overlays = arguments[2];

    var _ref2 = currentClip || {},
        clipId = _ref2.clipId;

    return filterOverlaysForCurrentSequence(sequenceOverlayMap, clipId, overlays);
});

// only for memoization purposes
var getSelectedClipId = exports.getSelectedClipId = (0, _reselect.createSelector)([_reelSelectors.getCurrentClipSelected], function (selectedClip) {
    return selectedClip ? selectedClip.clipId : null;
});

// SOLVED THE ISSUE OF POOR PERFORMANCE WITH TIMELINE DRAG FOR CLIP
var makeGetSequenceOverlaysForSelectedClips = exports.makeGetSequenceOverlaysForSelectedClips = function makeGetSequenceOverlaysForSelectedClips() {
    return (0, _reselect.createSelector)([getSequenceOverlays, getSelectedClipId, getOverlays], function (sequenceOverlays, clipId, overlays) {
        var result = {};
        if (clipId) {
            var _sov = sequenceOverlays[clipId];
            if (_sov === undefined) return result;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Object.keys(_sov)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var id = _step3.value;

                    var overlayData = overlays[id];
                    if (overlayData) {
                        result[id] = overlayData;
                    } else {
                        // reporting error , new refactor can cause issues if sequences were made in past few days
                        (0, _errorReporting.reportError)(new _errorReporting.MissingOverlayDataError('Sequence Overlays : ' + JSON.stringify({
                            sequenceOverlays: sequenceOverlays,
                            clipId: clipId,
                            overlays: Object.keys(overlays)
                        })));
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
        return result;
    });
};

var getSequenceOverlaysForClipId = exports.getSequenceOverlaysForClipId = (0, _reselect.createSelector)([getSequenceOverlays, getNonWaterMarkOverlays], function () {
    var sequenceOverlayMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var overlays = arguments[1];
    return function (clipId) {
        return filterOverlaysForCurrentSequence(sequenceOverlayMap, clipId, overlays);
    };
});

var getUserCreatedSequenceData = exports.getUserCreatedSequenceData = (0, _reselect.createSelector)([getSequences], function (sequences) {
    return sequences.reduce(function (acc, sequence) {
        acc[sequence.id] = sequence;
        return acc;
    }, {});
});

},{"../../../../constants/MediaConstants":309,"../../common/constants":61,"../../common/utils/errorReporting":101,"./reelSelectors":221,"fast-deep-equal":632,"reselect":1136}],224:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSubtitleTemplates = exports.getSubtitlesForAnimation = exports.getSubtitleData = exports.getSelectedTemplate = exports.getNonPreviewSubtitleOverlayIds = exports.getSubtitleOverlayIds = exports.getAllSubtitleOverlays = undefined;

var _reselect = require('reselect');

var _cloneextend = require('cloneextend');

var _fs = require('fs');

var getOverlays = function getOverlays(state) {
    return state.overlays;
};
var getSelectedTemplateName = function getSelectedTemplateName(state) {
    return state.subtitles.selectedTemplateName;
};
var getTextTemplates = function getTextTemplates(state) {
    return state.templates.text;
};
var getProjectDuration = function getProjectDuration(state) {
    return state.player.duration;
};

var getAllSubtitleOverlays = (0, _reselect.createSelector)([getOverlays], function (overlays) {
    return Object.values((0, _cloneextend.clone)(overlays)).filter(function (o) {
        return o.isSubtitle;
    });
});

var getSubtitleOverlayIds = (0, _reselect.createSelector)([getOverlays], function (overlays) {
    var subtitleOverlaysIds = {};

    Object.keys(overlays).filter(function (oid) {
        if (overlays[oid].isSubtitle) {
            subtitleOverlaysIds[oid] = true;
        }
    });

    return subtitleOverlaysIds;
});

var getNonPreviewSubtitleOverlayIds = (0, _reselect.createSelector)([getOverlays], function (overlays) {
    var subtitleOverlaysIds = {};

    Object.keys(overlays).forEach(function (oid) {
        if (overlays[oid].isSubtitle && !overlays[oid].isPreviewSubtitle) {
            subtitleOverlaysIds[oid] = true;
        }
    });

    return subtitleOverlaysIds;
});

var getSelectedTemplate = (0, _reselect.createSelector)([getSelectedTemplateName, getTextTemplates], function (selectedTemplateName, textTemplates) {
    var selectedTemplate = null;
    var subtitleTemplates = textTemplates.find(function (t) {
        return t.id == 'subtitles';
    });

    if (subtitleTemplates && subtitleTemplates.items && subtitleTemplates.items.length > 0) {
        selectedTemplate = subtitleTemplates.items.find(function (t) {
            return t.name == selectedTemplateName;
        });
    }

    return selectedTemplate;
});

var getSubtitleTemplates = (0, _reselect.createSelector)([getTextTemplates], function (textTemplates) {
    var subtitleTemplates = textTemplates.find(function (t) {
        return t.id == 'subtitles';
    });

    if (subtitleTemplates && subtitleTemplates.items) {
        return subtitleTemplates.items;
    }

    return [];
});

var getSubtitleData = (0, _reselect.createSelector)([getOverlays, getProjectDuration], function (overlays, projectDuration) {
    var subtitleData = Object.values(overlays).filter(function (o) {
        return o.isSubtitle && !o.isPreviewSubtitle && o.time.enterstart < projectDuration;
    });

    var lastSubtitleEndTime = 0;
    if (subtitleData.length > 0) {
        subtitleData.sort(function (a, b) {
            return a.time.enterstart - b.time.enterstart;
        });
        lastSubtitleEndTime = subtitleData[subtitleData.length - 1].time.exitdone;
    }

    return { subtitleData: subtitleData, lastSubtitleEndTime: lastSubtitleEndTime };
});

var getSubtitlesForAnimation = (0, _reselect.createSelector)([getOverlays], function (overlays) {
    var selectedSubtitlesForAnimation = {};

    var subOid = Object.keys(overlays).find(function (oid) {
        return overlays[oid].isSubtitle;
    });
    selectedSubtitlesForAnimation[subOid] = overlays[subOid];

    return selectedSubtitlesForAnimation;
});

exports.getAllSubtitleOverlays = getAllSubtitleOverlays;
exports.getSubtitleOverlayIds = getSubtitleOverlayIds;
exports.getNonPreviewSubtitleOverlayIds = getNonPreviewSubtitleOverlayIds;
exports.getSelectedTemplate = getSelectedTemplate;
exports.getSubtitleData = getSubtitleData;
exports.getSubtitlesForAnimation = getSubtitlesForAnimation;
exports.getSubtitleTemplates = getSubtitleTemplates;

},{"cloneextend":412,"fs":403,"reselect":1136}],225:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getElementsShelfStaticFilter = exports.getTemplateMapWithOverlays = exports.getWorkspaceImageTemplates = exports.getTemplateCategory = exports.getTimerTemplates = exports.getSocialMediaTemplates = exports.getCounterTemplates = exports.getWorkspaceTemplateImagesObject = exports.getStaticShapeObject = exports.getStaticIconObject = exports.getSVGTemplatesObject = exports.getWorkspaceTemplateImages = exports.getFoundrySVGAssets = exports.getSVGAssets = exports.getStaticIcons = exports.getStaticShapes = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _leftShelfSelector = require('./leftShelfSelector');

var _TemplateTypes = require('../../common/constants/TemplateTypes');

var _TemplateTypes2 = _interopRequireDefault(_TemplateTypes);

var _overlaySelectors = require('./overlaySelectors');

var _TemplateMapping = require('../constants/FitnessEditor/TemplateMapping');

var _PluginService = require('../../common/constants/PluginService');

var _SearchRegistry = require('../utils/search/SearchRegistry');

var _SearchRegistry2 = _interopRequireDefault(_SearchRegistry);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var getTextTemplates = function getTextTemplates(state) {
    return state.templates.text;
};
var getImageTemplates = function getImageTemplates(state) {
    return state.templates.images;
};

var getTextStyleEntries = (0, _leftShelfSelector.createGetTextStyleEntries)(['subtitles']);

var getStaticShapes = exports.getStaticShapes = (0, _reselect.createSelector)([getImageTemplates], function (images) {
    var shapes = (images.find(function (grp) {
        return grp.id === 'shapes';
    }) || {}).items || [];
    return shapes;
});

var getStaticIcons = exports.getStaticIcons = (0, _reselect.createSelector)([getImageTemplates], function (images) {
    var shapes = (images.find(function (grp) {
        return grp.id === 'icons';
    }) || {}).items || [];
    return shapes;
});

var getSVGAssets = exports.getSVGAssets = (0, _reselect.createSelector)([getImageTemplates], function (images) {
    var svgAssets = (images.find(function (grp) {
        return grp.id === 'svg-assets';
    }) || {}).items || [];
    return svgAssets;
});

var getFoundrySVGAssets = exports.getFoundrySVGAssets = (0, _reselect.createSelector)([getSVGAssets], function (assets) {
    return assets.map(function (template) {
        var templateWithMeta = getTemplateDefForId(template.defId);
        var meta = templateWithMeta.meta;

        template.meta = meta;
        return template;
    }).filter(function (template) {
        return template.meta.source === _PluginService.SupportedPlugins.typitofoundry;
    });
});

var getWorkspaceTemplateImages = exports.getWorkspaceTemplateImages = (0, _reselect.createSelector)([getImageTemplates], function (images) {
    var shapes = (images.find(function (grp) {
        return grp.id === 'workspaceImages';
    }) || {}).items || [];
    return shapes;
});

var getSVGTemplatesObject = exports.getSVGTemplatesObject = (0, _reselect.createSelector)([getSVGAssets], function (templates) {
    return templates.reduce(function (acc, v) {
        acc[v.defId] = v;
        return acc;
    }, {});
});

var getStaticIconObject = exports.getStaticIconObject = (0, _reselect.createSelector)([getStaticIcons], function (templates) {
    return templates.reduce(function (acc, v) {
        acc[v.defId] = v;
        return acc;
    }, {});
});

var getStaticShapeObject = exports.getStaticShapeObject = (0, _reselect.createSelector)([getStaticShapes], function (templates) {
    return templates.reduce(function (acc, v) {
        acc[v.defId] = v;
        return acc;
    }, {});
});

var getWorkspaceTemplateImagesObject = exports.getWorkspaceTemplateImagesObject = (0, _reselect.createSelector)([getWorkspaceTemplateImages], function (templates) {
    return templates.reduce(function (acc, v) {
        acc[v.defId] = v;
        return acc;
    }, {});
});

var getCounterTemplates = (0, _reselect.createSelector)([getTextTemplates], function (text) {
    var _text$filter$ = text.filter(function (entry) {
        return entry.id === 'presets';
    })[0],
        _text$filter$$items = _text$filter$.items,
        items = _text$filter$$items === undefined ? [] : _text$filter$$items,
        id = _text$filter$.id,
        otherProps = _objectWithoutProperties(_text$filter$, ['items', 'id']);

    return items.filter(function (item) {
        var def = getTemplateDefForId(item.defId);
        if (def) {
            var _def$meta$containsCou = def.meta.containsCounter,
                containsCounter = _def$meta$containsCou === undefined ? false : _def$meta$containsCou;

            return containsCounter;
        }
        return false;
    }).map(function (item) {
        return _extends({}, item, {
            group: id
        });
    });
});

exports.getCounterTemplates = getCounterTemplates;
var getSocialMediaTemplates = (0, _reselect.createSelector)([getTextTemplates], function (textTemplates) {
    var _textTemplates$filter = textTemplates.filter(function (entry) {
        return entry.id === 'presets';
    })[0],
        _textTemplates$filter2 = _textTemplates$filter.items,
        items = _textTemplates$filter2 === undefined ? [] : _textTemplates$filter2,
        id = _textTemplates$filter.id,
        otherProps = _objectWithoutProperties(_textTemplates$filter, ['items', 'id']);

    return items.filter(function (o) {
        var def = getTemplateDefForId(o.defId);
        if (def) {
            var templateType = def.meta.templateType;

            return templateType === 'social-media';
        }
        return false;
    }).map(function (item) {
        return _extends({}, item, {
            group: id
        });
    });
});

exports.getSocialMediaTemplates = getSocialMediaTemplates;
var getTimerTemplates = exports.getTimerTemplates = (0, _reselect.createSelector)([getCounterTemplates], function (counterTemplates) {
    return function (templateTypeValue) {
        return counterTemplates.filter(function (o) {
            var def = getTemplateDefForId(o.defId);
            if (def) {
                var templateType = def.meta.templateType;

                return templateType === templateTypeValue;
            }
            return false;
        });
    };
});

// TODO -- add selectors for templates
var getTemplateCategory = exports.getTemplateCategory = (0, _reselect.createSelector)([_overlaySelectors.getSelectedOverlays, getSVGTemplatesObject, getStaticIconObject], function (overlays, svgTemplateObject, staticIconObject) {
    var ovList = Object.values(overlays);
    if (ovList.length === 1) {
        var overlay = ovList[0];
        if (svgTemplateObject[overlay.defId] || staticIconObject[overlay.defId]) return _TemplateTypes2.default.ICONS;
    }
    return null;
});

var getWorkspaceImageTemplates = exports.getWorkspaceImageTemplates = (0, _reselect.createSelector)([getWorkspaceTemplateImages], function () {
    var templates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    templates = templates || [];
    return templates.filter(function (i) {
        return !i.deleted;
    });
});

var getTextStyleForRender = (0, _leftShelfSelector.createGetTextStyleForRender)(getTextStyleEntries);

var getTemplateMapWithOverlays = exports.getTemplateMapWithOverlays = (0, _reselect.createSelector)([getTextStyleForRender], function () {
    var defaultTemplates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var templateMapWithOverlays = _extends({}, _TemplateMapping.FitnessTemplateIdsMap);
    Object.keys(templateMapWithOverlays).forEach(function (elementKey) {
        var _templateMapWithOverl = templateMapWithOverlays[elementKey],
            templates = _templateMapWithOverl.templates,
            defaultTemplateId = _templateMapWithOverl.defaultTemplateId,
            _templateMapWithOverl2 = _templateMapWithOverl.isRequired,
            isRequired = _templateMapWithOverl2 === undefined ? false : _templateMapWithOverl2;

        var overlays = defaultTemplates.filter(function (t) {
            return templates[t.id];
        }).map(function (t) {
            var configTemplate = templates[t.id];

            // merge all the properties defined in the configured template with the original template
            Object.keys(configTemplate).forEach(function (propertyKey) {
                t[propertyKey] = _extends({}, t[propertyKey], configTemplate[propertyKey]);
            });
            return t;
        });
        if (defaultTemplateId) {
            var defaultTemplate = overlays.find(function (o) {
                return o.id === defaultTemplateId;
            });
            var restOfTemplates = overlays.filter(function (o) {
                return o.id !== defaultTemplateId;
            });
            overlays = [defaultTemplate].concat(_toConsumableArray(restOfTemplates));
        }

        templateMapWithOverlays[elementKey].overlays = overlays;
    });
    return templateMapWithOverlays;
});

var getElementsShelfStaticFilter = exports.getElementsShelfStaticFilter = (0, _reselect.createSelector)([getStaticShapes, getStaticIcons, getFoundrySVGAssets], function (shapes, icons, svgs) {
    var shapeFilter = _SearchRegistry2.default.filterElements(shapes, function (data) {
        return data.defId;
    });

    var iconFilter = _SearchRegistry2.default.filterElements(icons, function (data) {
        return data.defId;
    });

    var foundrySVGFilter = _SearchRegistry2.default.filterElements(svgs, function (data) {
        return data.defId;
    });

    return {
        shapeFilter: shapeFilter,
        iconFilter: iconFilter,
        foundrySVGFilter: foundrySVGFilter
    };
});

},{"../../common/constants/PluginService":65,"../../common/constants/TemplateTypes":67,"../constants/FitnessEditor/TemplateMapping":202,"../utils/search/SearchRegistry":243,"./leftShelfSelector":214,"./overlaySelectors":217,"reselect":1136}],226:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFitnessSequencesInReelFilteredByType = exports.getFitnessSequences = exports.getWorkflowSpecificSequenceData = exports.getAllGlobalOverlaysIfSelected = exports.getFitnessSequenceClipAndOverlayProgressBarInfo = exports.getCurrentFitnessSequenceClipAndOverlayProgressBarInfo = exports.getGlobalOverlaysInFitnessSequencesAddedToReel = exports.getDurationRangesOfClip = undefined;

var _constants = require('../../common/constants');

var _OverlayUtils = require('../utils/OverlayUtils');

var _MediaConstants = require('../../../../constants/MediaConstants');

var _require = require('reselect'),
    createSelector = _require.createSelector;

var getClips = function getClips(state) {
    return state.reel.clips;
};

var getSequences = function getSequences(state) {
    return state.sequences;
};

var getSequenceOverlays = function getSequenceOverlays(state) {
    return state.overlaymeta.sequenceOverlays;
};

var getOverlays = function getOverlays(state) {
    return state.overlays;
};

var getSelectedOverlays = function getSelectedOverlays(state) {
    return state.selection.selected;
};

var getDurationRangesOfClip = exports.getDurationRangesOfClip = createSelector([getClips], function () {
    var clips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (mediaId) {
        var currentClips = clips.flatMap(function (c) {
            return c.clipType === 'composite' ? c.childClips : c;
        }).filter(function (clip) {
            return clip.clipType === 'video';
        }).filter(function (clip) {
            return clip.clipVideo.id === mediaId;
        }).map(function (clip) {
            return [clip.clipStart, clip.clipStart + clip.clipDuration];
        }) // [start, end]
        .sort(function (a, b) {
            return a[0] - b[0];
        });

        return currentClips;
    };
});

var getSequencesObject = createSelector([getSequences], function () {
    var sequences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return sequences.reduce(function (acc, v) {
        acc[v.id] = v;
        return acc;
    }, {});
});

var getGlobalOverlaysInFitnessSequencesAddedToReel = exports.getGlobalOverlaysInFitnessSequencesAddedToReel = createSelector([getClips, getSequencesObject, getSequenceOverlays, getOverlays], function (clips, sequencesObject, sequenceOverlays, overlays) {
    var fitnessClips = clips.filter(function (clip) {
        if (clip.clipType === _MediaConstants.SupportedReelClipTypes.composite) {
            var sequenceInfo = sequencesObject[clip.sequenceId] || {};
            var _sequenceInfo$sequenc = sequenceInfo.sequenceData;
            _sequenceInfo$sequenc = _sequenceInfo$sequenc === undefined ? {} : _sequenceInfo$sequenc;
            var _sequenceInfo$sequenc2 = _sequenceInfo$sequenc.sequenceMetaData;
            _sequenceInfo$sequenc2 = _sequenceInfo$sequenc2 === undefined ? {} : _sequenceInfo$sequenc2;
            var _sequenceInfo$sequenc3 = _sequenceInfo$sequenc2.workflow,
                workflow = _sequenceInfo$sequenc3 === undefined ? null : _sequenceInfo$sequenc3;

            if (workflow === _constants.SupportedEditorWorkflows.fitness) return true;
        }
        return false;
    });

    if (fitnessClips.length === 0) return [];

    var globalOverlays = {};

    fitnessClips.forEach(function (clip) {
        var sequenceOverlay = sequenceOverlays[clip.clipId];
        if (sequenceOverlay) {
            Object.keys(sequenceOverlay).forEach(function (oId) {
                var overlay = overlays[oId];
                if (_OverlayUtils.FitnessGlobalTemplateDefIds.includes(overlay.defId)) {
                    globalOverlays[oId] = overlay;
                }
            });
        }
    });

    return globalOverlays;
});

var getCurrentFitnessSequenceClipAndOverlayProgressBarInfo = exports.getCurrentFitnessSequenceClipAndOverlayProgressBarInfo = createSelector([getGlobalOverlaysInFitnessSequencesAddedToReel], function (globalOverlays) {
    return function () {
        var filterHiddenOverlays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (globalOverlays && Object.values(globalOverlays).length > 0) {
            return Object.values(globalOverlays).filter(function (o) {
                var def = getTemplateDefForId(o.defId);
                var isProgressBar = (0, _OverlayUtils.detectProgressTemplate)(def);
                return o && isProgressBar && filterHiddenOverlays ? !o.hide : true;
            }).map(function (v) {
                return {
                    id: v.id,
                    startFraction: v.values.startFraction,
                    endFraction: v.values.endFraction
                };
            });
        }
        return [];
    };
});

var getFitnessSequenceClipAndOverlayProgressBarInfo = exports.getFitnessSequenceClipAndOverlayProgressBarInfo = createSelector([getGlobalOverlaysInFitnessSequencesAddedToReel], function (globalOverlays) {
    if (!globalOverlays || Object.values(globalOverlays).length === 0) return [];

    var globalOverlaysValues = Object.values(globalOverlays).filter(function (o) {
        var def = getTemplateDefForId(o.defId);
        var isProgressBar = (0, _OverlayUtils.detectProgressTemplate)(def);
        return o && isProgressBar && !o.hide;
    });

    var totalTime = globalOverlaysValues.reduce(function (acc, v) {
        var _v$time = v.time,
            enterstart = _v$time.enterstart,
            enterdone = _v$time.enterdone;

        acc += enterdone - enterstart;
        return acc;
    }, 0);

    var result = [];

    var timeTillNow = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = globalOverlaysValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entry = _step.value;
            var _entry$time = entry.time,
                enterstart = _entry$time.enterstart,
                enterdone = _entry$time.enterdone,
                _entry$values$isAscen = entry.values.isAscendingTimer,
                isAscendingTimer = _entry$values$isAscen === undefined ? false : _entry$values$isAscen,
                id = entry.id;

            var duration = enterdone - enterstart;

            var start = isAscendingTimer ? timeTillNow : totalTime - timeTillNow;
            var end = isAscendingTimer ? timeTillNow + duration : totalTime - (timeTillNow + duration);

            var startFraction = parseFloat((start / totalTime).toFixed(3));
            var endFraction = parseFloat((end / totalTime).toFixed(3));
            if (!isAscendingTimer) {
                result.push({ id: id, startFraction: endFraction, endFraction: startFraction });
            } else {
                result.push({ id: id, startFraction: startFraction, endFraction: endFraction });
            }

            timeTillNow += duration;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
});

var getAllGlobalOverlaysIfSelected = exports.getAllGlobalOverlaysIfSelected = createSelector([getSelectedOverlays, getGlobalOverlaysInFitnessSequencesAddedToReel], function (selectedOverlays, globalOverlays) {
    var globalOverlaySelectedId = Object.keys(selectedOverlays).find(function (oId) {
        return !!globalOverlays[oId];
    });

    if (globalOverlaySelectedId) {
        var globalOverlaySelected = globalOverlays[globalOverlaySelectedId];
        Object.keys(globalOverlays).forEach(function (oId) {
            globalOverlays[oId].isGlobalSelected = globalOverlaySelected.defId === globalOverlays[oId].defId;
        });
        return globalOverlays;
    }

    return {};
});

var getWorkflowSpecificSequenceData = exports.getWorkflowSpecificSequenceData = function getWorkflowSpecificSequenceData(workflow) {
    return createSelector([getSequences], function (sequences) {
        if (workflow && _constants.SupportedEditorWorkflows[workflow]) {
            return sequences.reduce(function (p, sequence) {
                var id = sequence.id,
                    _sequence$sequenceDat = sequence.sequenceData;
                _sequence$sequenceDat = _sequence$sequenceDat === undefined ? {} : _sequence$sequenceDat;
                var sequenceMetaData = _sequence$sequenceDat.sequenceMetaData;

                if (!p[id] && sequenceMetaData && sequenceMetaData.workflow === workflow) {
                    p[id] = sequence;
                }
                return p;
            }, {});
        }
        return sequences;
    });
};

var getFitnessSequences = exports.getFitnessSequences = getWorkflowSpecificSequenceData(_constants.SupportedEditorWorkflows.fitness);

var getFitnessSequencesInReelFilteredByType = exports.getFitnessSequencesInReelFilteredByType = createSelector([getFitnessSequences, getClips], function (fitnessSequences, clips) {
    return function (typeId) {
        var fitnessSequencesFilteredByTypeId = Object.values(fitnessSequences).reduce(function (p, sequence) {
            var id = sequence.id,
                _sequence$sequenceDat2 = sequence.sequenceData;
            _sequence$sequenceDat2 = _sequence$sequenceDat2 === undefined ? {} : _sequence$sequenceDat2;
            var sequenceMetaData = _sequence$sequenceDat2.sequenceMetaData;

            if (!p[id] && sequenceMetaData && (sequenceMetaData.workflowStepType === typeId || sequenceMetaData.workflowSubStep === typeId)) {
                p[id] = sequence;
            }
            return p;
        }, {});

        return clips.filter(function (c) {
            return c.clipType === 'composite' && fitnessSequencesFilteredByTypeId[c.sequenceId];
        });
    };
});

},{"../../../../constants/MediaConstants":309,"../../common/constants":61,"../utils/OverlayUtils":231,"reselect":1136}],227:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _events = require('events');

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CommandEmitter = function (_EventEmitter) {
    _inherits(CommandEmitter, _EventEmitter);

    function CommandEmitter() {
        _classCallCheck(this, CommandEmitter);

        return _possibleConstructorReturn(this, (CommandEmitter.__proto__ || Object.getPrototypeOf(CommandEmitter)).apply(this, arguments));
    }

    _createClass(CommandEmitter, [{
        key: 'fireCommand',
        value: function fireCommand(commandType, args) {
            // We fire the command type as the first param for convenience
            this.emit(commandType, commandType, args);
        }
    }, {
        key: 'subscribeToCommand',
        value: function subscribeToCommand(commandType, callback) {
            this.on(commandType, callback);
        }
    }, {
        key: 'unsubscribeFromCommand',
        value: function unsubscribeFromCommand(commandType, callback) {
            this.removeListener(commandType, callback);
        }
    }]);

    return CommandEmitter;
}(_events.EventEmitter);

var ControlCommandStream = new CommandEmitter();

exports.default = ControlCommandStream;

},{"events":629}],228:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var io = require('socket.io-client');

var EV_IMAGE_UPDATE = 'EV_IMAGE_UPDATE';
var EV_VIDEO_UPDATE = 'EV_VIDEO_UPDATE';
var EV_AUDIO_UPDATE = 'EV_AUDIO_UPDATE';
var EV_VIDEO_TRANSCRIPTION_UPDATE = 'EV_VIDEO_TRANSCRIPTION_UPDATE';
var EV_AUDIO_TRANSCRIPTION_UPDATE = 'EV_AUDIO_TRANSCRIPTION_UPDATE';
var EV_UPLOAD = 'EV_UPLOAD';
var EV_SEQUENCE_PREVIEW_UPDATE = 'EV_SEQUENCE_PREVIEW_UPDATE';

var EditIOClient = function () {
    function EditIOClient() {
        _classCallCheck(this, EditIOClient);

        this._emitter = new EventEmitter();
    }

    _createClass(EditIOClient, [{
        key: 'addImageUpdateCallback',
        value: function addImageUpdateCallback(callback) {
            this._emitter.on(EV_IMAGE_UPDATE, callback);
            return this;
        }
    }, {
        key: 'removeImageUpdateCallback',
        value: function removeImageUpdateCallback(callback) {
            this._emitter.removeListener(EV_IMAGE_UPDATE, callback);
            return this;
        }
    }, {
        key: 'addVideoUpdateCallback',
        value: function addVideoUpdateCallback(callback) {
            this._emitter.on(EV_VIDEO_UPDATE, callback);
            return this;
        }
    }, {
        key: 'removeVideoUpdateCallback',
        value: function removeVideoUpdateCallback(callback) {
            this._emitter.removeListener(EV_VIDEO_UPDATE, callback);
            return this;
        }
    }, {
        key: 'addAudioUpdateCallback',
        value: function addAudioUpdateCallback(callback) {
            this._emitter.on(EV_AUDIO_UPDATE, callback);
            return this;
        }
    }, {
        key: 'removeAudioUpdateCallback',
        value: function removeAudioUpdateCallback(callback) {
            this._emitter.removeListener(EV_AUDIO_UPDATE, callback);
            return this;
        }
    }, {
        key: 'addVideoTrascriptionUpdateCallback',
        value: function addVideoTrascriptionUpdateCallback(callback) {
            this._emitter.on(EV_VIDEO_TRANSCRIPTION_UPDATE, callback);
            return this;
        }
    }, {
        key: 'removeVideoTrascriptionUpdateCallback',
        value: function removeVideoTrascriptionUpdateCallback(callback) {
            this._emitter.removeListener(EV_VIDEO_TRANSCRIPTION_UPDATE, callback);
            return this;
        }
    }, {
        key: 'addAudioTrascriptionUpdateCallback',
        value: function addAudioTrascriptionUpdateCallback(callback) {
            this._emitter.on(EV_AUDIO_TRANSCRIPTION_UPDATE, callback);
            return this;
        }
    }, {
        key: 'removeAudioTrascriptionUpdateCallback',
        value: function removeAudioTrascriptionUpdateCallback(callback) {
            this._emitter.removeListener(EV_AUDIO_TRANSCRIPTION_UPDATE, callback);
            return this;
        }
    }, {
        key: 'addUploadTrackerCallback',
        value: function addUploadTrackerCallback(callback) {
            this._emitter.on(EV_UPLOAD, callback);
            return this;
        }
    }, {
        key: 'removeUploadTrackerCallback',
        value: function removeUploadTrackerCallback(callback) {
            this._emitter.removeListener(EV_UPLOAD, callback);
            return this;
        }
    }, {
        key: 'addSequencePreviewUpdateCallback',
        value: function addSequencePreviewUpdateCallback(callback) {
            this._emitter.on(EV_SEQUENCE_PREVIEW_UPDATE, callback);
            return this;
        }
    }, {
        key: 'removeSequencePreviewUpdateCallback',
        value: function removeSequencePreviewUpdateCallback(callback) {
            this._emitter.removeListener(EV_SEQUENCE_PREVIEW_UPDATE, callback);
            return this;
        }
    }, {
        key: 'start',
        value: function start() {
            var _this = this;

            this.socket = io('/clients', { transports: ['polling'] });

            this.socket.on('update', function (args) {
                var to = args.to;

                if (to == 'uploadimage') {
                    var imageData = args.data;
                    _this._emitter.emit(EV_IMAGE_UPDATE, imageData);
                }

                if (to == 'upload') {
                    var videoData = args.data;
                    _this._emitter.emit(EV_VIDEO_UPDATE, videoData);
                }

                if (to == 'uploadaudio') {
                    var audioData = args.data;
                    _this._emitter.emit(EV_AUDIO_UPDATE, audioData);
                }

                if (to == 'videospeechrecognition') {
                    var videoTrascriptionData = args.data;
                    _this._emitter.emit(EV_VIDEO_TRANSCRIPTION_UPDATE, videoTrascriptionData);
                }

                if (to == 'audiospeechrecognition') {
                    var audioTrascriptionData = args.data;
                    _this._emitter.emit(EV_AUDIO_TRANSCRIPTION_UPDATE, audioTrascriptionData);
                }

                if (to == 'uploadtracker') {
                    var data = args.data;

                    _this._emitter.emit(EV_UPLOAD, data);
                }

                if (to == 'sequence') {
                    var sequenceData = args.data;
                    _this._emitter.emit(EV_SEQUENCE_PREVIEW_UPDATE, sequenceData);
                }
            });

            return this;
        }
    }, {
        key: 'subscribeToImageUpdates',
        value: function subscribeToImageUpdates(imageId) {
            this.socket.emit('subscribe', { to: 'uploadimage', id: imageId });

            return this;
        }
    }, {
        key: 'subscribeToVideoUpdates',
        value: function subscribeToVideoUpdates(videoId) {
            this.socket.emit('subscribe', { to: 'upload', id: videoId });

            return this;
        }
    }, {
        key: 'subscribeToAudioUpdates',
        value: function subscribeToAudioUpdates(audioId) {
            this.socket.emit('subscribe', { to: 'uploadaudio', id: audioId });

            return this;
        }
    }, {
        key: 'subscribeToVideoSpeechRecognitionUpdates',
        value: function subscribeToVideoSpeechRecognitionUpdates(videoTranscriptionId) {
            this.socket.emit('subscribe', { to: 'videospeechrecognition', id: videoTranscriptionId });

            return this;
        }
    }, {
        key: 'subscribeToAudioSpeechRecognitionUpdates',
        value: function subscribeToAudioSpeechRecognitionUpdates(audioTranscriptionId) {
            this.socket.emit('subscribe', { to: 'audiospeechrecognition', id: audioTranscriptionId });

            return this;
        }
    }, {
        key: 'subscribeToUploadTracker',
        value: function subscribeToUploadTracker(id) {
            this.socket.emit('subscribe', { to: 'uploadtracker', id: id });

            return this;
        }
    }, {
        key: 'subscribeToSequencePreviewUpdates',
        value: function subscribeToSequencePreviewUpdates(sequenceId) {
            this.socket.emit('subscribe', { to: 'sequence', id: sequenceId });

            return this;
        }
    }]);

    return EditIOClient;
}();

var client = new EditIOClient();

exports.default = client;

},{"events":629,"socket.io-client":1174}],229:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _UploadApi = require('../api/UploadApi');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DEBUG = false;

var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var CancelFuncMap = {};

var FileUploadManager = function () {
    function FileUploadManager(file, itemType, projectId) {
        var uploadId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
            _ref$snapShotBlob = _ref.snapShotBlob,
            snapShotBlob = _ref$snapShotBlob === undefined ? null : _ref$snapShotBlob,
            _ref$sendSnapShot = _ref.sendSnapShot,
            sendSnapShot = _ref$sendSnapShot === undefined ? false : _ref$sendSnapShot,
            _ref$mediaType = _ref.mediaType,
            mediaType = _ref$mediaType === undefined ? null : _ref$mediaType;

        _classCallCheck(this, FileUploadManager);

        this.file = file;
        this.itemType = itemType;
        this.projectId = projectId;

        this.snapShotBlob = snapShotBlob;
        this.sendSnapShot = sendSnapShot;
        this.mediaType = mediaType;

        this.uploadId = uploadId || _shortid2.default.generate();

        this._onStartCallback = function (uploadId) {}; /* no-op */
        this._onProgressCallback = function (uploadId, progress) {}; /* no-op */
        this._onCompleteCallback = function (uploadId, data) {}; /* no-op */
        this._onErrorCallback = function (uploadId, errorCode) {}; /* no-op */
    }
    /** Public methods */

    _createClass(FileUploadManager, [{
        key: 'getUploadId',
        value: function getUploadId() {
            return this.uploadId;
        }
    }, {
        key: 'onStart',
        value: function onStart(callback) {
            this._onStartCallback = callback;return this;
        }
    }, {
        key: 'onProgress',
        value: function onProgress(callback) {
            this._onProgressCallback = callback;return this;
        }
    }, {
        key: 'onComplete',
        value: function onComplete(callback) {
            this._onCompleteCallback = callback;return this;
        }
    }, {
        key: 'onError',
        value: function onError(callback) {
            this._onErrorCallback = callback;return this;
        }
    }, {
        key: '_doSnapshotUpload',
        value: function _doSnapshotUpload(_ref2) {
            var _this = this;

            var type = _ref2.type,
                data = _ref2.data;

            if (this.sendSnapShot && this.snapShotBlob && this.mediaType) {

                var snapeShotFile = new File([this.snapShotBlob], data.originalFileName + '-' + data.id + '-snapshot');

                dlog('doing snapshot upload for :', data);

                var _uploadSnapshot = (0, _UploadApi.uploadSnapshot)(snapeShotFile, {
                    mediaId: data.id,
                    type: type
                }),
                    request = _uploadSnapshot.request,
                    cancelRequest = _uploadSnapshot.cancelRequest;

                request.then(function (r) {
                    dlog('response from SnapShot upload ' + _this.mediaType + ' ' + data.id + ' : ', r.data);
                });
            }
        }
    }, {
        key: 'doUpload',
        value: function doUpload() {
            var _this2 = this;

            if (this._onStartCallback) {
                this._onStartCallback(this.uploadId);
            }

            var _uploadFile = (0, _UploadApi.uploadFile)(this.file, { itemType: this.itemType, projectId: this.projectId }, function (percent) {
                if (_this2._onProgressCallback) {
                    _this2._onProgressCallback(_this2.uploadId, percent);
                }
            }),
                request = _uploadFile.request,
                _uploadFile$cancelReq = _uploadFile.cancelRequest,
                cancelRequest = _uploadFile$cancelReq === undefined ? function () {} : _uploadFile$cancelReq;

            CancelFuncMap[this.uploadId] = cancelRequest;

            request.then(function (result) {

                _this2._doSnapshotUpload(result);

                if (_this2._onCompleteCallback) {
                    _this2._onCompleteCallback(_this2.uploadId, result);
                }
            }).catch(function (err) {
                dlog('failed to upload error :', err);
                if (_this2._onErrorCallback) {
                    _this2._onErrorCallback(_this2.uploadId, err.message || err.errorCode || 'unknown_error', err);
                } else {
                    console.error(err);
                }
            });

            return cancelRequest;
        }
    }]);

    return FileUploadManager;
}();

FileUploadManager.cancelRequest = function (uploadId, message) {
    var fn = CancelFuncMap[uploadId];
    if (!!fn) {
        fn(message);
    }
};

exports.default = FileUploadManager;

},{"../api/UploadApi":178,"shortid":1163}],230:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overlayRectUnion = exports.checkIntersect = exports.getUnionRect = exports.overlayRect = exports.overlaySize = undefined;

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _cloneextend = require('cloneextend');

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var overlaySize = exports.overlaySize = function overlaySize(overlay) {
    var _overlay$space = overlay.space,
        width = _overlay$space.width,
        height = _overlay$space.height;

    return { width: width, height: height };
};

var overlayRect = exports.overlayRect = function overlayRect(overlay) {
    var _overlay$space2 = overlay.space,
        x = _overlay$space2.x,
        y = _overlay$space2.y,
        width = _overlay$space2.width,
        height = _overlay$space2.height;

    return { x: x, y: y, width: width, height: height };
};

var getUnionRect = exports.getUnionRect = function getUnionRect(rect1, rect2) {

    if (rect1 == null || rect2 == null) {
        return !rect1 ? rect2 : rect1;
    }

    var x1 = rect1.x,
        y1 = rect1.y,
        w1 = rect1.width,
        h1 = rect1.height,
        r1 = rect1.rotateDeg;
    var x2 = rect2.x,
        y2 = rect2.y,
        w2 = rect2.width,
        h2 = rect2.height,
        r2 = rect2.rotateDeg;

    var newH1 = h1,
        newH2 = h2,
        newW1 = w1,
        newW2 = w2,
        newX1 = x1,
        newX2 = x2,
        newY1 = y1,
        newY2 = y2;

    if (r1 !== r2) {
        var radVal1 = (0, _GeneralUtils.degreeToRadian)(r1);
        var sinVal1 = (0, _GeneralUtils.absoluteSinVal)(radVal1);
        var cosVal1 = (0, _GeneralUtils.absoluteCosVal)(radVal1);

        newH1 = w1 * sinVal1 + h1 * cosVal1;
        newW1 = w1 * cosVal1 + h1 * sinVal1;

        newX1 = x1 - (newW1 - w1) / 2;
        newY1 = y1 - (newH1 - h1) / 2;

        var radVal2 = (0, _GeneralUtils.degreeToRadian)(r2);
        var sinVal2 = (0, _GeneralUtils.absoluteSinVal)(radVal2);
        var cosVal2 = (0, _GeneralUtils.absoluteCosVal)(radVal2);

        newH2 = w2 * sinVal2 + h2 * cosVal2;
        newW2 = w2 * cosVal2 + h2 * sinVal2;

        newX2 = x2 - (newW2 - w2) / 2;
        newY2 = y2 - (newH2 - h2) / 2;
    }

    return {
        x: Math.min(newX1, newX2),
        y: Math.min(newY1, newY2),
        width: Math.max(newX1 + newW1, newX2 + newW2) - Math.min(newX1, newX2),
        height: Math.max(newY1 + newH1, newY2 + newH2) - Math.min(newY1, newY2),
        rotateDeg: (r1 + r2) / 2
    };
};

var checkIntersect = exports.checkIntersect = function checkIntersect(rect1, rect2) {
    if (!rect1 || !rect2) {
        return false; // Should throw ideally?
    }

    var x1 = rect1.x,
        y1 = rect1.y,
        w1 = rect1.width,
        h1 = rect1.height;
    var x2 = rect2.x,
        y2 = rect2.y,
        w2 = rect2.width,
        h2 = rect2.height;

    if (x1 > x2 + w2 || x2 > x1 + w1) return false;

    // If one rectangle is above other
    if (y2 > y1 + h1 || y1 > y2 + h2) return false;

    return true;
};

var overlayRectUnion = exports.overlayRectUnion = function overlayRectUnion(overlays) {

    var overlayList = overlays;

    if (!Array.isArray(overlays)) {
        overlayList = Object.keys(overlays).map(function (oid) {
            return overlays[oid];
        });
    }

    return overlayList.map(function (o) {
        var _o$space = o.space,
            _o$space$x = _o$space.x,
            x = _o$space$x === undefined ? 0 : _o$space$x,
            _o$space$y = _o$space.y,
            y = _o$space$y === undefined ? 0 : _o$space$y,
            width = _o$space.width,
            height = _o$space.height,
            _o$space$rotateDeg = _o$space.rotateDeg,
            rotateDeg = _o$space$rotateDeg === undefined ? 0 : _o$space$rotateDeg;

        return { x: x, y: y, width: width, height: height, rotateDeg: rotateDeg };
    }).reduce(function (res, r) {
        return getUnionRect(res, r);
    });
};

},{"../../common/utils/GeneralUtils":77,"cloneextend":412,"color":418,"deepmerge":549}],231:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTemplateType = exports.extractTimerText = exports.detectIsImageTemplate = exports.extractImageTitle = exports.extractTextFromOverlay = exports.detectIsTextEditor = exports.detectSocialMediaTemplate = exports.detectCalorieMeterTemplate = exports.detectProgressTemplate = exports.detectIsTimerTemplate = exports.checkIsCustomFont = exports.getDurationStringForFormat = exports.secondsToString = exports.getLayerPropValueMap = exports.overlaysWithAudio = exports.getCategoryNameForType = exports.ignoreOverlayGroupdIdForPipeline = exports.ignoreOverlayTypeForPipeline = exports.buildTransformPipeline = exports.randomizeColor = exports.randomizeOverlayPosition = exports.overlaysDiff = exports.overlayOverlap = exports.rectOverlappingOverlaysAtTime = exports.overlayMove = exports.createTemplateFromOverlays = exports.adjustOverlays = exports.createOverlaysFromTemplate = exports.createOverlayFromTemplate = exports.calcHeightIfNeeded = exports.getHighestZIndex = exports.getImageDefId = exports.FitnessGlobalTemplateDefIds = exports.TemplateType = exports.SupportedTemplateCategories = exports.MIN_OVERLAY_DURATION = exports.overlayRectUnion = exports.overlayRect = exports.overlaySize = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

exports.getAnimGroupSettings = getAnimGroupSettings;

var _cloneextend = require('cloneextend');

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _randomcolor = require('randomcolor');

var _randomcolor2 = _interopRequireDefault(_randomcolor);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _fastMemoize = require('fast-memoize');

var _fastMemoize2 = _interopRequireDefault(_fastMemoize);

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _TemplateConfig = require('../../common/config/TemplateConfig');

var _LayerUtils = require('../../common/utils/renderer/LayerUtils');

var _OverlayReadUtils = require('./OverlayReadUtils');

var _CommonAlgorithms = require('../../common/utils/CommonAlgorithms');

var _TemplateTypes = require('../../common/constants/TemplateTypes');

var _TemplateTypes2 = _interopRequireDefault(_TemplateTypes);

var _CounterTimeFormatType = require('../constants/CounterTimeFormatType');

var _CounterTimeFormatType2 = _interopRequireDefault(_CounterTimeFormatType);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

exports.overlaySize = _OverlayReadUtils.overlaySize;
exports.overlayRect = _OverlayReadUtils.overlayRect;
exports.overlayRectUnion = _OverlayReadUtils.overlayRectUnion;

var MAX_PIXEL_OFFSET = 100;

var MIN_OVERLAY_DURATION = exports.MIN_OVERLAY_DURATION = 200;

var SupportedTemplateCategories = exports.SupportedTemplateCategories = (0, _keymirror2.default)({
    SVG: null,
    TEXT: null,
    TIMER: null,
    PROGRESS: null,
    SOCIAL: null,
    IMAGE: null,
    ELEMENTS: null
});

var TemplateType = exports.TemplateType = (0, _keymirror2.default)({
    timer: null,
    'progress-bar': null,
    'calorie-meter': null,
    'social-media': null,
    text: null,
    image: null,
    caption: null
});

var FitnessGlobalTemplateDefIds = exports.FitnessGlobalTemplateDefIds = ['defId-IzYujIxyL', 'defId-ZnlFA1XfB', 'defId-g8m5vHKwu', 'defId-a8m98xKZp'];

// current session id
var getNextOverlayId = function () {
    var index = -1;
    return function (currOverlays) {
        if (index == -1) {
            var firstMaxId = Object.keys(currOverlays).map(function (oid) {
                return parseInt(oid.split('-')[1], 10);
            }).reduce(function (res, id) {
                return Math.max(id, res);
            }, 0);

            index = firstMaxId;
        }
        index++;
        return 'overlay-' + index;
    };
}();

var _getNextOverlayId = function _getNextOverlayId(currOverlays) {
    var currMaxId = Object.keys(currOverlays).map(function (oid) {
        return parseInt(oid.split('-')[1], 10);
    }).reduce(function (res, id) {
        return Math.max(id, res);
    }, 0);

    return 'overlay-' + (currMaxId + 1);
};

var getImageDefId = exports.getImageDefId = function getImageDefId(id) {
    return 'defId-userBitmap-' + id;
};

var getHighestZIndex = exports.getHighestZIndex = function getHighestZIndex(overlays) {
    var skipWatermark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var overlayIds = Object.keys(overlays);
    if (skipWatermark) overlayIds = overlayIds.filter(function (oid) {
        return !overlays[oid].isWatermark;
    });

    var maxZIndex = overlayIds.map(function (oid) {
        return overlays[oid].space.zIndex;
    }).reduce(function (res, zIndex) {
        return Math.max(res, zIndex);
    }, 0);

    return maxZIndex;
};

var calcHeightIfNeeded = exports.calcHeightIfNeeded = function calcHeightIfNeeded(overlay) {
    var def = getTemplateDefForId(overlay.defId);

    if (def.meta.autoHeight) {
        // TODO STOP USING DEFMODEL EVETRYWHERE
        var defModel = new _DefModel2.default(overlay.defId);
        defModel.update(overlay.space, overlay.time, overlay.values, { width: 1920, height: 1080 });

        return defModel.space.height;
    }
    if (!overlay.space.height && !!def.meta.nativeAspectRatio) {
        return overlay.space.width / def.meta.nativeAspectRatio;
    }
    return overlay.space.height;
};

var createOverlayFromTemplate = function createOverlayFromTemplate(template, overlays, canvas) {
    var _template$previewOver = template.previewOverrides,
        previewOverrides = _template$previewOver === undefined ? {} : _template$previewOver,
        templ = _objectWithoutProperties(template, ['previewOverrides']);

    var overlay = (0, _cloneextend.clone)(templ);

    overlay.id = getNextOverlayId(overlays);

    var highestZIndex = getHighestZIndex(overlays, true);

    var _overlay$space = overlay.space,
        width = _overlay$space.width,
        height = _overlay$space.height;

    var def = getTemplateDefForId(overlay.defId);

    var defDefaultValues = def.defaults || {};

    overlay = (0, _deepmerge2.default)({
        values: defDefaultValues,
        space: {
            height: calcHeightIfNeeded(overlay)
        },
        templateId: template.id
    }, overlay);

    var fillSpace = {};
    if ((0, _GeneralUtils.hasKey)(overlay.space, 'x')) {
        fillSpace.x = overlay.space.x;
    }
    if ((0, _GeneralUtils.hasKey)(overlay.space, 'y')) {
        fillSpace.y = overlay.space.y;
    }

    overlay = (0, _GeneralUtils.deepmergeAll)(overlay, {
        space: {
            x: (canvas.width - overlay.space.width) / 2,
            y: (canvas.height - overlay.space.height) / 2,
            zIndex: highestZIndex + 1
        }
    }, {
        space: fillSpace
    });
    return overlay;
};

exports.createOverlayFromTemplate = createOverlayFromTemplate;
var createOverlaysFromTemplate = exports.createOverlaysFromTemplate = function createOverlaysFromTemplate(template, currOverlays, canvas, type) {
    var seqCanvas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var position = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    var overlays = [];
    var overlaymeta = {};

    var referenceCanvas = _TemplateConfig.REFERENCE_CANVAS;
    if (type === 'workspaceTemplates' && !!template.space.referenceCanvas) {
        referenceCanvas = template.space.referenceCanvas;
    }

    if (type === 'sequence' && !!seqCanvas) {
        referenceCanvas = seqCanvas;
    }

    if (template.isgroup) {
        // treat group
        var _template$space = template.space,
            grpX = _template$space.x,
            grpY = _template$space.y,
            grpWidth = _template$space.width,
            grpHeight = _template$space.height;
        var animgroups = template.meta.animgroups;

        var childIdToOverlayIdMap = {};

        template.children.forEach(function (o) {
            o = (0, _deepmerge2.default)(o, {
                space: {
                    x: o.space.x + grpX,
                    y: o.space.y + grpY
                }
            });

            var childId = o.id;

            o = createOverlayFromTemplate(o, currOverlays, canvas);

            if (canvas.width != referenceCanvas.width || canvas.height != referenceCanvas.height) {
                o = adjustOverlaySpace(o, canvas, referenceCanvas, true, template.space);
            }

            // Would have got a new id by now
            childIdToOverlayIdMap[childId] = o.id;

            currOverlays = _extends({}, currOverlays, _defineProperty({}, o.id, o));

            overlays.push(o);
        });

        animgroups = animgroups.map(function (grp) {
            return _extends({}, grp, {
                members: grp.members.map(function (cid) {
                    return childIdToOverlayIdMap[cid];
                })
            });
        });

        overlaymeta = { animgroups: animgroups };
    } else {
        var templates = Array.isArray(template) ? template : [template];

        templates.sort(function (a, b) {
            return a.space.zIndex - b.space.zIndex;
        });

        // Overlay max side to be 60% of the canvas size
        var maxWidth = 0.6 * canvas.width;
        var maxHeight = 0.6 * canvas.height;

        templates.forEach(function (template, i) {
            if (position) {
                var _template$space2 = template.space,
                    templateWidth = _template$space2.width,
                    templateHeight = _template$space2.height;

                var scale = 1;
                if (templateWidth > templateHeight) {
                    scale = maxWidth / templateWidth;
                } else {
                    scale = maxHeight / templateHeight;
                }

                var spaceValues = _extends({}, template.space, {
                    width: templateWidth * scale,
                    height: templateHeight * scale
                });

                if (position.x + spaceValues.width > canvas.width) {
                    position.x = canvas.width - spaceValues.width;
                }
                if (position.y + spaceValues.height > canvas.height) {
                    position.y = canvas.height - spaceValues.height;
                }

                spaceValues = _extends({}, spaceValues, position);

                template = (0, _deepmerge2.default)(template, {
                    space: spaceValues
                });
            }

            var overlay = createOverlayFromTemplate(template, currOverlays, canvas);

            if (!position && (canvas.width != referenceCanvas.width || canvas.height != referenceCanvas.height)) {
                overlay = adjustOverlaySpace(overlay, canvas, referenceCanvas, false, null);
            }

            currOverlays = _extends({}, currOverlays, _defineProperty({}, overlay.id, overlay));

            overlays.push(overlay);

            // temp work for sequence overlays.
            if (type === 'sequence') {
                overlaymeta[overlay.id] = template.id;
            }
        });
    }

    return { overlays: overlays, overlaymeta: overlaymeta };
};

var adjustOverlays = exports.adjustOverlays = function adjustOverlays(overlays, newCanvas, oldCanvas) {
    var adjustedOverlays = {};
    Object.keys(overlays).forEach(function (overlayId) {
        adjustedOverlays[overlayId] = adjustOverlaySpace(overlays[overlayId], newCanvas, oldCanvas);
    });

    return adjustedOverlays;
};

var adjustOverlaySpace = function adjustOverlaySpace(overlay, newCanvas, oldCanvas, isGroup, template) {
    if (newCanvas.width != oldCanvas.width || newCanvas.height != oldCanvas.height) {
        var widthTransformFactor = newCanvas.width / oldCanvas.width;
        var heightTransformFactor = newCanvas.height / oldCanvas.height;

        var resizeFactor = heightTransformFactor;
        // if (newCanvas.width > oldCanvas.width) {
        //     resizeFactor = Math.min(widthTransformFactor, heightTransformFactor)
        // } else {
        //     resizeFactor = Math.max(widthTransformFactor, heightTransformFactor)
        // }

        var newX = widthTransformFactor * overlay.space.x;
        var newY = heightTransformFactor * overlay.space.y;

        var newWidth = resizeFactor * overlay.space.width;
        var newHeight = resizeFactor * overlay.space.height;
        var transform = (0, _LayerUtils.getScaledTransformString)(overlay.space.transform, resizeFactor, resizeFactor);

        if (isGroup) {
            var rescaledTemplate = {
                width: resizeFactor * template.width,
                height: resizeFactor * template.height,
                x: widthTransformFactor * template.x,
                y: heightTransformFactor * template.y
            };

            newX = (overlay.space.x - template.x) / template.width * rescaledTemplate.width + rescaledTemplate.x;
            newY = (overlay.space.y - template.y) / template.height * rescaledTemplate.height + rescaledTemplate.y;
        }
        if (overlay.space.width === oldCanvas.width) {
            newX = 0;
            newWidth = newCanvas.width;

            var resizeRatio = newWidth / overlay.space.width;
            if (resizeRatio * overlay.space.height > newCanvas.height) {
                resizeRatio = newCanvas.height / overlay.space.height;
                newHeight = resizeRatio * overlay.space.height;
                newWidth = resizeRatio * overlay.space.width;
            } else {
                newHeight = resizeRatio * overlay.space.height;
            }
        } else if (newX + newWidth > newCanvas.width) {
            // Overlay spilling out
            if (newWidth < newCanvas.width) {
                // align right
                newX = newCanvas.width - newWidth;
            } else {
                // overlay width is more than canvas
                // Try changing height
                newX = 0;
                newWidth = newCanvas.width;

                var _resizeRatio = newWidth / overlay.space.width;
                if (_resizeRatio * overlay.space.height > newCanvas.height) {
                    _resizeRatio = newCanvas.height / overlay.space.height;
                    newHeight = _resizeRatio * overlay.space.height;
                    newWidth = _resizeRatio * overlay.space.width;
                } else {
                    newHeight = _resizeRatio * overlay.space.height;
                }
            }
        }
        var adjustedOverlay = (0, _deepmerge2.default)(overlay, {
            space: {
                x: newX,
                y: newY,
                width: newWidth,
                height: newHeight,
                transform: transform
            }
        });
        // TODO stop USING DEFMODEL EVERYWHERE (ㆆ_ㆆ)
        var defModel = _DefModel.DefModelRegistry.getModelForOverlay(adjustedOverlay.defId, adjustedOverlay.id);
        defModel.update(adjustedOverlay.space, adjustedOverlay.time, adjustedOverlay.values, newCanvas);
        // defModel.seekToStatic();

        var overlayHeight = defModel.space.height;

        if (newY + overlayHeight > newCanvas.height) {
            // Overlay spilling out
            if (overlayHeight < newCanvas.height) {
                // align bottom
                newY = newCanvas.height - overlayHeight;
            } else {
                // overlay height is more than canvas
                // Try changing height

                defModel.update(adjustedOverlay.space, adjustedOverlay.time, adjustedOverlay.values, newCanvas);
                resizeFactor = newCanvas.height / defModel.space.height;

                transform = (0, _LayerUtils.getScaledTransformString)(overlay.space.transform, resizeFactor, resizeFactor);
            }

            adjustedOverlay = (0, _deepmerge2.default)(adjustedOverlay, {
                space: {
                    y: newY,
                    height: newHeight,
                    transform: transform
                }
            });
        }
        return adjustedOverlay;
    }
    return overlay;
};

var createTemplateFromOverlays = exports.createTemplateFromOverlays = function createTemplateFromOverlays(overlays, overlaymeta, canvas) {
    if (overlays == null || overlays.length === 0) {
        throw new Error('Cannot create template');
    }

    if (overlays.length === 1) {
        // Single overlay - straight forward
        var _overlays = overlays,
            _overlays2 = _slicedToArray(_overlays, 1),
            overlay = _overlays2[0];

        var _template = (0, _cloneextend.clone)(overlay);
        _template.id = _shortid2.default.generate();
        _template.space.referenceCanvas = canvas;

        delete _template.space.zIndex; // No z-index needed
        // delete template.time.start // When pasting it will be a new time
        // Choosing to keep the x,y so that we can choose to paste at same location if needed

        return _template;
    }
    // Multiple overlays - Need to create a 'group' template

    // Clone first
    overlays = (0, _cloneextend.clone)(overlays);
    overlaymeta = (0, _cloneextend.clone)(overlaymeta);

    var template = {
        id: _shortid2.default.generate(),
        isgroup: true,
        children: [],
        space: {},
        time: {},
        meta: { animgroups: [] }
    };

    var rect = (0, _OverlayReadUtils.overlayRectUnion)(overlays);

    var groupStart = overlays.reduce(function (o1, o2) {
        return o1.time.enterstart < o2.time.enterstart ? o1 : o2;
    }).time.enterstart;

    template.space = (0, _deepmerge2.default)(rect, {
        transform: ''
    });

    // We'll sort and later get rid of the z-indices. It will be implicit now
    var sortedOverlays = overlays.sort(function (o1, o2) {
        return o1.space.zIndex - o2.space.zIndex;
    });

    var overlayIdsMap = {};
    overlays.forEach(function (o) {
        overlayIdsMap[o.id] = true;
    });

    overlaymeta.animgroups = overlaymeta.animgroups.map(function (grp) {
        var members = grp.members.filter(function (oid) {
            return !!overlayIdsMap[oid];
        });
        return _extends({}, grp, { members: members });
    }).filter(function (grp) {
        return grp.members.length > 1;
    });

    var overlayToChildIdMap = {};

    sortedOverlays.forEach(function (o) {
        overlayToChildIdMap[o.id] = 'child-' + _shortid2.default.generate();
    });

    template.children = sortedOverlays.map(function (o) {
        var _o$space = o.space,
            x = _o$space.x,
            y = _o$space.y;
        var _o$time = o.time,
            enterstart = _o$time.enterstart,
            enterdone = _o$time.enterdone,
            exitstart = _o$time.exitstart,
            exitdone = _o$time.exitdone;

        x -= rect.x;
        y -= rect.y;

        // Implicit ordering
        delete o.space.zIndex;

        enterstart -= groupStart;
        enterdone -= groupStart;
        exitstart -= groupStart;
        exitdone -= groupStart;

        o = (0, _deepmerge2.default)(o, {
            space: { x: x, y: y },
            time: { enterstart: enterstart, enterdone: enterdone, exitstart: exitstart, exitdone: exitdone },
            id: overlayToChildIdMap[o.id]
        });

        return o;
    });

    overlaymeta.animgroups = overlaymeta.animgroups.map(function (grp) {
        var members = grp.members.map(function (oid) {
            return overlayToChildIdMap[oid];
        });
        return _extends({}, grp, { members: members });
    });

    template.meta = overlaymeta;
    template.space.referenceCanvas = canvas;

    return template;
};

var overlayMove = exports.overlayMove = function overlayMove(overlay, _ref) {
    var x = _ref.x,
        y = _ref.y;
    return (0, _deepmerge2.default)(overlay, {
        space: { x: x, y: y }
    });
};

var overlappingOverlays = function overlappingOverlays(overlay, allOverlays, currentTime) {
    var rect = (0, _OverlayReadUtils.overlayRect)(overlay);

    return Object.keys(allOverlays).map(function (oid) {
        return allOverlays[oid];
    }).filter(function (tOverlay) {
        // ignore watermark
        if (tOverlay.isWatermark) return false;

        // Ignore self
        if (tOverlay.id === overlay.id) {
            return false;
        }
        var _tOverlay$time = tOverlay.time,
            enterstart = _tOverlay$time.enterstart,
            exitdone = _tOverlay$time.exitdone;

        // Ignore ones not visible at current time

        if (exitdone < currentTime || enterstart > currentTime) {
            return false;
        }

        return (0, _OverlayReadUtils.checkIntersect)((0, _OverlayReadUtils.overlayRect)(tOverlay), rect);
    });
};

var rectOverlappingOverlaysAtTime = exports.rectOverlappingOverlaysAtTime = function rectOverlappingOverlaysAtTime(rect, overlays, currentTime) {
    var overlappingOverlays = {};
    Object.keys(overlays).filter(function (oid) {
        return !overlays[oid].isSubtitle;
    }).forEach(function (oid) {
        var overlay = overlays[oid];
        var space = overlay.space,
            _overlay$time = overlay.time,
            enterstart = _overlay$time.enterstart,
            exitdone = _overlay$time.exitdone;

        // Ignore ones not visible at current time

        if (enterstart <= currentTime && exitdone >= currentTime && (0, _OverlayReadUtils.checkIntersect)(space, rect)) {
            overlappingOverlays[oid] = overlay;
        }
    });
    return overlappingOverlays;
};

var overlayOverlap = exports.overlayOverlap = function overlayOverlap(overlay, allOverlays, currentTime) {
    var overlappers = overlappingOverlays(overlay, allOverlays, currentTime);

    return {
        overlappers: overlappers,
        hasOverlap: overlappers.length > 0,
        canGoForward: overlappers.filter(function (oo) {
            return oo.space.zIndex > overlay.space.zIndex;
        }).length > 0,
        canGoBack: overlappers.filter(function (oo) {
            return oo.space.zIndex < overlay.space.zIndex;
        }).length > 0
    };
};

var overlaysDiff = exports.overlaysDiff = function overlaysDiff(oldOverlays, newOverlays) {
    var addedOverlays = {};
    var deletedOverlays = {};
    var updatedOverlays = {};

    Object.keys(oldOverlays).forEach(function (oid) {
        if (!(oid in newOverlays)) {
            // Deleted
            deletedOverlays[oid] = oldOverlays[oid];
        } else if (oldOverlays[oid] !== newOverlays[oid]) {
            // Check if updated
            updatedOverlays[oid] = newOverlays[oid];
        }
    });

    Object.keys(newOverlays).forEach(function (oid) {
        if (!(oid in oldOverlays)) {
            // Added
            addedOverlays[oid] = newOverlays[oid];
        }
    });

    return { addedOverlays: addedOverlays, deletedOverlays: deletedOverlays, updatedOverlays: updatedOverlays };
};

var randomizeOverlayPosition = exports.randomizeOverlayPosition = function () {
    return (
        /// Closure to put in logic for random ness of the randomization of the layer placement

        function (_ref2) {
            var overlay = _ref2.overlay,
                _ref2$canvas = _ref2.canvas,
                canvas = _ref2$canvas === undefined ? { height: 1080, width: 1920 } : _ref2$canvas;
            var _overlay$space2 = overlay.space,
                x = _overlay$space2.x,
                y = _overlay$space2.y;

            var newX = (0, _CommonAlgorithms.clamp)(x + 20 + Math.floor(MAX_PIXEL_OFFSET * Math.random()), canvas.width, 0);
            var newY = (0, _CommonAlgorithms.clamp)(y + 20 + Math.floor(MAX_PIXEL_OFFSET * Math.random()), canvas.height, 0);
            overlay.space.x = newX;
            overlay.space.y = newY;

            return overlay;
        }
    );
}();

var randomizeColor = exports.randomizeColor = function randomizeColor(_ref3) {
    var overlay = _ref3.overlay;

    if (overlay.type === _TemplateTypes2.default.ICONS || overlay.type === _TemplateTypes2.default.SHAPES) {
        var _overlay$values = overlay.values;
        _overlay$values = _overlay$values === undefined ? {} : _overlay$values;
        var color1 = _overlay$values.color1;

        if (color1) {
            overlay.values.color1 = (0, _randomcolor2.default)({
                format: 'hex'
            });
        }
    }
    return overlay;
};

var buildTransformPipeline = function buildTransformPipeline() {
    var functionArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filterFunctionArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return function (_ref4) {
        var _ref4$overlays = _ref4.overlays,
            overlays = _ref4$overlays === undefined ? [] : _ref4$overlays,
            otherData = _objectWithoutProperties(_ref4, ['overlays']);

        return overlays.map(function (overlay) {
            var shouldTransform = filterFunctionArray.reduce(function (a, fn) {
                return a && fn(_extends({
                    overlay: overlay
                }, otherData));
            }, true);

            var transformedOverlay = shouldTransform ? functionArray.reduce(function (a, fn) {
                return fn(_extends({
                    overlay: overlay
                }, otherData));
            }, overlay) : overlay;
            return overlay;
        });
    };
};

exports.buildTransformPipeline = buildTransformPipeline;
var ignoreOverlayTypeForPipeline = exports.ignoreOverlayTypeForPipeline = function ignoreOverlayTypeForPipeline(_ref5) {
    var type = _ref5.type;

    if (type === 'workspaceTemplates') return false;
    return true;
};

var ignoreOverlayGroupdIdForPipeline = exports.ignoreOverlayGroupdIdForPipeline = function ignoreOverlayGroupdIdForPipeline(_ref6) {
    var groupId = _ref6.groupId;

    if (groupId === 'svg-assets') return false;
    return true;
};

var getCategoryNameForType = exports.getCategoryNameForType = function getCategoryNameForType(category) {
    if (category === _TemplateTypes2.default.ICONS) return 'icon';
    if (category === _TemplateTypes2.default.PRESET_TEXT) return 'text';
    if (category === _TemplateTypes2.default.SHAPES) return 'shape';

    return 'template';
};

function getAnimGroupSettings(overlay, allOverlays, animgroups) {
    var enterAnimGroups = animgroups.filter(function (grp) {
        if (grp.kind !== 'enter') {
            return false;
        }
        return !!grp.members.find(function (oid) {
            return oid === overlay.id;
        });
    });

    var exitAnimGroups = animgroups.filter(function (grp) {
        if (grp.kind !== 'exit') {
            return false;
        }
        return !!grp.members.find(function (oid) {
            return oid === overlay.id;
        });
    });

    if (enterAnimGroups.length === 0 && exitAnimGroups.length === 0) {
        return null;
    }

    var enterSettings = null;
    if (enterAnimGroups.length > 0) {
        enterSettings = {
            space: (0, _OverlayReadUtils.overlayRectUnion)(enterAnimGroups[0].members.map(function (oid) {
                return allOverlays[oid];
            }))
        };
    }

    var exitSettings = null;
    if (exitAnimGroups.length > 0) {
        exitSettings = {
            space: (0, _OverlayReadUtils.overlayRectUnion)(exitAnimGroups[0].members.map(function (oid) {
                return allOverlays[oid];
            }))
        };
    }

    return { enter: enterSettings, exit: exitSettings };
}
var overlaysWithAudio = exports.overlaysWithAudio = {
    'defId-0G2V5Ey0N': 'timer',
    'defId-oWm7tEZbb': 'timer',
    'defId-d3qv8ja2b': 'timer',
    'defId-ZRaU2irIU': 'timer',
    'defId-6EglX08N_': 'timer',
    'defId-5tgtQy3zF': 'timer',
    'defId-a3m5eMKuu': 'timer',
    'defId-Yl0eKjoPE': 'timer',
    'defId-u2ytfIbGg': 'timer',
    'defId-Eb65en7aN': 'timer'
};

var getLayerPropValueMap = exports.getLayerPropValueMap = function getLayerPropValueMap(overlay, layerType) {
    var uniqueValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var defId = overlay.defId,
        values = overlay.values;

    var layerPropValueMap = {};

    var usedProps = {};

    var def = getTemplateDefForId(defId);

    var _def$layers = def.layers,
        layers = _def$layers === undefined ? [] : _def$layers,
        _def$defaults = def.defaults,
        defaults = _def$defaults === undefined ? {} : _def$defaults;

    layers.forEach(function (layer) {
        if (layer.type === layerType) {
            var _layer$attrs = layer.attrs,
                attrs = _layer$attrs === undefined ? {} : _layer$attrs,
                id = layer.id;

            var layerAttrs = _LayerUtils.LAYER_ATTR_DEFAULTS[layer.type];

            Object.keys(layerAttrs).forEach(function (attrKey) {
                if (attrs[attrKey]) {
                    var v = attrs[attrKey];

                    if ((0, _LayerUtils.hasExpression)(v)) {
                        (0, _LayerUtils.tokenize)(v).forEach(function (token) {
                            var type = token.type,
                                content = token.content;

                            if (type === 'expr' && values[content] !== undefined) {
                                if (uniqueValues && usedProps[content]) return;
                                if (!layerPropValueMap[id]) {
                                    layerPropValueMap[id] = {};
                                }
                                layerPropValueMap[id][attrKey] = {
                                    prop: content,
                                    value: values[content] || defaults[content]
                                };

                                if (uniqueValues) {
                                    usedProps[content] = true;
                                }
                            }
                        });
                    }
                }
            });
        }
    });

    return layerPropValueMap;
};

var secondsToString = exports.secondsToString = (0, _fastMemoize2.default)(function (seconds) {
    var minutes = Math.floor(seconds / 60);
    seconds = Math.ceil(seconds % 60);

    var secondStr = '' + seconds;
    var minutesStr = '' + minutes;

    if (seconds < 10) secondStr = '0' + seconds;
    if (minutes < 10) minutesStr = '0' + minutes;

    return minutesStr + ':' + secondStr;
}, function (seconds) {
    return seconds;
});

var getDurationStringForFormat = exports.getDurationStringForFormat = function getDurationStringForFormat(timeInMs, maxTimeInMs, timeFormat, isAscendingTimer) {
    var secs = 0;

    if (isAscendingTimer) {
        if (timeInMs > 200) {
            secs = Math.ceil(timeInMs / 1000);
        }
    } else if (maxTimeInMs - timeInMs <= 200) {
        secs = Math.ceil(maxTimeInMs / 1000);
    } else {
        secs = Math.floor(timeInMs / 1000);
    }

    if (timeFormat === _CounterTimeFormatType2.default.SECS) {
        return '' + secs;
    }
    if (_CounterTimeFormatType2.default.MINS) {
        return secondsToString(secs);
    }
};

var checkIsCustomFont = exports.checkIsCustomFont = function checkIsCustomFont(fontFamily) {
    return fontFamily.indexOf('CF_') !== -1 || _FontManager2.default.isPremiumFont(fontFamily);
};

var detectIsTimerTemplate = exports.detectIsTimerTemplate = function detectIsTimerTemplate(def) {
    var templateType = def.meta.templateType;

    return templateType === TemplateType.timer;
};

var detectProgressTemplate = exports.detectProgressTemplate = function detectProgressTemplate(def) {
    var templateType = def.meta.templateType;

    return templateType === TemplateType['progress-bar'];
};

var detectCalorieMeterTemplate = exports.detectCalorieMeterTemplate = function detectCalorieMeterTemplate(def) {
    var templateType = def.meta.templateType;

    return templateType === TemplateType['calorie-meter'];
};

var detectSocialMediaTemplate = exports.detectSocialMediaTemplate = function detectSocialMediaTemplate(def) {
    var templateType = def.meta.templateType;

    return templateType === TemplateType['social-media'];
};

var detectIsTextEditor = exports.detectIsTextEditor = function detectIsTextEditor(def) {
    var _def$meta$textEditors = def.meta.textEditors,
        textEditors = _def$meta$textEditors === undefined ? {} : _def$meta$textEditors;

    return !!textEditors && Object.keys(textEditors).length > 0;
};

var extractTextFromOverlay = exports.extractTextFromOverlay = function extractTextFromOverlay(overlay, def) {
    var _def$meta$textEditors2 = def.meta.textEditors,
        textEditors = _def$meta$textEditors2 === undefined ? {} : _def$meta$textEditors2;

    var text1 = overlay.values[Object.keys(textEditors)[0]];
    return text1;
};

var extractImageTitle = exports.extractImageTitle = function extractImageTitle(overlay, registry) {
    var imageId = overlay.values.imageId;

    var title = registry[imageId] && registry[imageId].imageData && registry[imageId].imageData.originalFileName || imageId;
    var data = (title || '').split('.');
    if (data.length > 1) {
        return data.slice(0, data.length - 1).join('.');
    }
    return title;
};

var detectIsImageTemplate = exports.detectIsImageTemplate = function detectIsImageTemplate(def) {
    var imageLayers = def.layers.filter(function (l) {
        return l.type === 'bitmap';
    });
    return !!imageLayers && Object.keys(imageLayers).length > 0;
};

var extractTimerText = exports.extractTimerText = function extractTimerText(overlay) {
    var _overlay$time2 = overlay.time,
        _overlay$time2$enters = _overlay$time2.enterstart,
        enterstart = _overlay$time2$enters === undefined ? 0 : _overlay$time2$enters,
        _overlay$time2$exitdo = _overlay$time2.exitdone,
        exitdone = _overlay$time2$exitdo === undefined ? 0 : _overlay$time2$exitdo,
        _overlay$values2 = overlay.values,
        _overlay$values2$time = _overlay$values2.timeFormat,
        timeFormat = _overlay$values2$time === undefined ? 'SECS' : _overlay$values2$time,
        _overlay$values2$isAs = _overlay$values2.isAscendingTimer,
        isAscendingTimer = _overlay$values2$isAs === undefined ? true : _overlay$values2$isAs;

    var duration = exitdone - enterstart;
    return getDurationStringForFormat(duration, duration, timeFormat, isAscendingTimer);
};

/**
 *
 * @param {string} defId
 * @returns {'Text'|'Timer'|'Image'|'Progress Bar'}
 */
var getTemplateType = exports.getTemplateType = function getTemplateType(defId) {
    var def = getTemplateDefForId(defId);

    var templateType = 'Text';
    if (def && detectCalorieMeterTemplate(def)) {
        templateType = 'Calorie Meter';
    } else if (def && detectProgressTemplate(def)) {
        templateType = 'Progress Bar';
    } else if (def && detectIsTimerTemplate(def)) {
        templateType = 'Timer';
    } else if (def && detectIsImageTemplate(def)) {
        templateType = 'Image';
    }

    return templateType;
};

},{"../../common/config/TemplateConfig":42,"../../common/constants/TemplateTypes":67,"../../common/utils/CommonAlgorithms":72,"../../common/utils/FontManager":76,"../../common/utils/GeneralUtils":77,"../../common/utils/renderer/DefModel":119,"../../common/utils/renderer/LayerUtils":121,"../constants/CounterTimeFormatType":201,"./OverlayReadUtils":230,"cloneextend":412,"deepmerge":549,"fast-memoize":633,"keymirror":677,"randomcolor":899,"shortid":1163}],232:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _EditIOClient = require('./EditIOClient');

var _EditIOClient2 = _interopRequireDefault(_EditIOClient);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var ProcessingTracker = function () {
    function ProcessingTracker(itemType, itemId) {
        _classCallCheck(this, ProcessingTracker);

        this.itemType = itemType;
        this.itemId = itemId;

        this._dataCallback = function () {
            /* no-op */
        };
    }

    _createClass(ProcessingTracker, [{
        key: 'startTracking',
        value: function startTracking() {
            if (this.itemType === 'IMAGE') {
                _EditIOClient2.default.addImageUpdateCallback(this._dataCallback).subscribeToImageUpdates(this.itemId);
            } else if (this.itemType === 'VIDEO') {
                _EditIOClient2.default.addVideoUpdateCallback(this._dataCallback).subscribeToVideoUpdates(this.itemId);
            } else if (this.itemType === 'AUDIO') {
                _EditIOClient2.default.addAudioUpdateCallback(this._dataCallback).subscribeToAudioUpdates(this.itemId);
            } else if (this.itemType === 'VIDEO_TRANSCRIPTION') {
                _EditIOClient2.default.addVideoTrascriptionUpdateCallback(this._dataCallback).subscribeToVideoSpeechRecognitionUpdates(this.itemId);
            } else if (this.itemType === 'AUDIO_TRANSCRIPTION') {
                _EditIOClient2.default.addAudioTrascriptionUpdateCallback(this._dataCallback).subscribeToAudioSpeechRecognitionUpdates(this.itemId);
            } else if (this.itemType === 'SEQUENCE') {
                _EditIOClient2.default.addSequencePreviewUpdateCallback(this._dataCallback).subscribeToSequencePreviewUpdates(this.itemId);
            } else {
                throw new Error('Unknown itemType ' + this.itemType);
            }
            return this;
        }
    }, {
        key: 'stopTracking',
        value: function stopTracking() {
            if (this.itemType === 'IMAGE') {
                _EditIOClient2.default.removeImageUpdateCallback(this._dataCallback);
            } else if (this.itemType === 'VIDEO') {
                _EditIOClient2.default.removeVideoUpdateCallback(this._dataCallback);
            } else if (this.itemType === 'AUDIO') {
                _EditIOClient2.default.removeAudioUpdateCallback(this._dataCallback);
            } else if (this.itemType === 'VIDEO_TRANSCRIPTION') {
                _EditIOClient2.default.removeVideoTrascriptionUpdateCallback(this._dataCallback);
            } else if (this.itemType === 'AUDIO_TRANSCRIPTION') {
                _EditIOClient2.default.removeAudioTrascriptionUpdateCallback(this._dataCallback);
            } else if (this.itemType === 'SEQUENCE') {
                _EditIOClient2.default.removeSequencePreviewUpdateCallback(this._dataCallback);
            } else {
                throw new Error('Unknown itemType ' + itemType);
            }
            return this;
        }
    }, {
        key: 'onData',
        value: function onData(callback) {
            var _this = this;

            this._dataCallback = function (itemData) {
                if (itemData.id !== _this.itemId) {
                    return;
                }
                callback(itemData);
            };
            return this;
        }
    }]);

    return ProcessingTracker;
}();

exports.default = ProcessingTracker;

},{"./EditIOClient":228}],233:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestFitCanvasRatio = getBestFitCanvasRatio;
exports.getFormatDetailsFromInput = getFormatDetailsFromInput;
exports.calcNewCanvas = calcNewCanvas;
exports.computeClipBoxRenderParams = computeClipBoxRenderParams;

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var ceil = Math.ceil,
    floor = Math.floor,
    round = Math.round,
    max = Math.max,
    min = Math.min,
    random = Math.random,
    PI = Math.PI,
    abs = Math.abs,
    sin = Math.sin,
    cos = Math.cos;

function computeSizeForAR(targetAR) {
  // Logic - Calculate a video size which has a min edge and max edge as desired.
  //        If when trying to satisfy min edge, we can't satisfy max edge, prioritize max edge
  //        If we can satisfy both, use size based on min edge
  var MAX_EDGE = 1920,
      MIN_EDGE = 1080;

  var width = floor(max(MIN_EDGE * targetAR, MIN_EDGE) / 2) * 2;
  var height = floor(max(MIN_EDGE / targetAR, MIN_EDGE) / 2) * 2;

  if (width > MAX_EDGE || height > MAX_EDGE) {
    width = floor(min(MAX_EDGE * targetAR, MAX_EDGE) / 2) * 2;
    height = floor(min(MAX_EDGE / targetAR, MAX_EDGE) / 2) * 2;
  }

  return { width: width, height: height };
}

function getBestFitCanvasRatio(clips) {
  var aar = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = clips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var clip = _step.value;

      var width = 1;
      var height = 1;
      if (clip.clipType === 'image') {
        width = clip.clipImage.width;
        height = clip.clipImage.height;
      } else if (clip.clipType === 'video') {
        width = clip.clipVideo.width;
        height = clip.clipVideo.height;
      }
      aar += width / height;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return aar / clips.length;
}

function getFormatDetailsFromInput(formats, formatId) {
  var formatList = [];
  formats.forEach(function (format) {
    return formatList = [].concat(_toConsumableArray(formatList), _toConsumableArray(format.formats));
  });
  return formatList.find(function (format) {
    return format.id === formatId;
  });
}

function calcNewCanvas(origCanvas, frameType, bestFitAspectRatio) {

  var targetAspectRatio = 0.1; // Something that isn't zero but obviously
  if (frameType === 'DEFAULT') {
    targetAspectRatio = origCanvas.width / origCanvas.height;
  } else if (frameType === 'SQUARE-CROPPED' || frameType === 'SQUARE-PADDED') {
    targetAspectRatio = 1;
  } else if (frameType === 'BEST-FIT') {
    targetAspectRatio = bestFitAspectRatio;
  } else if (frameType === 'VERTICAL' || frameType === 'VERTICAL-PADDED' || frameType === 'VERTICAL-PADDED-TOP') {
    targetAspectRatio = 9 / 16;
  } else if (frameType === 'WIDESCREEN') {
    targetAspectRatio = 16 / 9;
  } else if (frameType === 'FB-VERTICAL' || frameType === 'FB-VERTICAL-PADDED') {
    targetAspectRatio = 4 / 5;
  } else if (frameType === 'FB-LANDSCAPE' || frameType === 'FB-LANDSCAPE-PADDED') {
    targetAspectRatio = 5 / 4;
  }

  var width = 1920,
      height = 1080;

  if (targetAspectRatio != 0.1) {
    return computeSizeForAR(targetAspectRatio);
  } else if (frameType === 'BILLBOARD-MIDDLE-TOP') {
    // width = 238
    // height = 1820
    width = 544;
    height = 4160;
  } else if (frameType === 'BILLBOARD-BOTTOM-LEFT' || frameType === 'BILLBOARD-BOTTOM-RIGHT') {
    // width = 1920
    // height = 480
    width = 2240;
    height = 560;
  } else if (frameType === 'BILLBOARD-PLACE-TOP') {
    // targetAspectRatio = 640/1696
    width = 640;
    height = 1696;
  } else if (frameType === 'BILLBOARD-PLACE-BOTTOM') {
    // targetAspectRatio = 1056/672
    width = 1056;
    height = 672;
  } else if (frameType === 'BILLBOARD-TOP') {
    // targetAspectRatio = 416/1584
    width = 416;
    height = 1584;
  } else if (frameType === 'BILLBOARD-MIDDLE') {
    // targetAspectRatio = 416/1376
    width = 416;
    height = 1376;
  } else if (frameType === 'BILLBOARD-BOTTOM') {
    // targetAspectRatio = 1344/1696
    width = 1344;
    height = 1696;
  }

  return { width: width, height: height };
}

/**
 * Returns the crop box and  for the Video
 *
 * @param {*} upscaleFactor
 * @param {*} clipBox
 * @param {*} contentBox
 */
function computeClipBoxRenderParams(upscaleFactor, clipBox, contentBox) {
  var SF = upscaleFactor;

  var scaled = {
    width: ceil(SF * clipBox.width),
    height: ceil(SF * clipBox.height),
    clipWidth: clipBox.width,
    clipHeight: clipBox.height
  };

  var _ref = [clipBox.width, clipBox.height],
      ow = _ref[0],
      oh = _ref[1];
  var _clipBox$rotateDeg = clipBox.rotateDeg,
      rotateDeg = _clipBox$rotateDeg === undefined ? 0 : _clipBox$rotateDeg;

  var rotationInDegrees = Number.parseInt(rotateDeg, 10) * PI / 180;

  /**
   * Formula explanation:
   * => iw = the minimum width of output media width for the rotated content to be contained within (calculated by ffmpeg)
   * => (iw - clipBox.width) / 2 = centre offset in x direction that is required to reset the centre to its original position when rotation takes place
   *
   * Note: rotation increases the H/W based of on angle and minimum container box of the source media, so to rotate media with same origin when
   * there is no rotation , we do this offset change
   *
   * => (iw - clipBox.width)/2 - clibBox.x = the x offset set automatically or the user after rotation to bring media to contentbox viewport
   * => (iw - clipbox.width)/2 - clipbox.x + contentBox.x = The contentbox may have its own padding i.e letterbox , this extract padding is for that
   *
   * Note: Content box is padding is relevant for Y axis. as currently we have letterbox working in Y axis only
   *
   * below logic applies for Y axis in ih  and also X in iw(input height)
   */

  // can be calculated by FFMPEG also -- micro optimisation
  var ih = ceil(ow * abs(sin(rotationInDegrees)) + oh * abs(cos(rotationInDegrees)));

  var iw = ceil(ow * abs(cos(rotationInDegrees)) + oh * abs(sin(rotationInDegrees)));

  scaled.sih = ih * SF;
  scaled.siw = iw * SF;

  var smallerContentH = ih < contentBox.height;
  var smallerContentW = iw < contentBox.width;

  var cropLeft = (iw - ceil(clipBox.width)) / 2 - ceil(clipBox.x) + contentBox.x;
  var cropTop = (ih - ceil(clipBox.height)) / 2 - ceil(clipBox.y) + contentBox.y;

  // calculating amount of blank space required , which cannot be done using
  // contentBox.x / y is added because if we dont in case of letter box the video will be overlayed from
  // left top corner, because thats the default.
  // overlay offset allows us to control where to put the video or media
  var deltaLeft = contentBox.x;
  var deltaTop = contentBox.y;

  // error crop left and top
  var errCrop = {
    errcl: 0, errct: 0
    // if x offset > 0
    // x offset + width > iw then use overlay for offset + contentbox padding
    // else
    // - x offset as that will add as padding region
    // when the cropLeft is negative the crop stops at x = 0 we need to compensate for same in overlay calculation
  };if (cropLeft < 0) {
    deltaLeft -= cropLeft;
    errCrop.errcl = -cropLeft;
  }
  if (cropTop < 0) {
    deltaTop -= cropTop;
    errCrop.errcl = -cropTop;
  }

  if (!smallerContentH && ih < cropTop + ceil(contentBox.height)) {
    // the below offset based on the size difference only makes sense when contentBox is smaller than rotatedCanvas
    deltaTop += ih - (cropTop + ceil(contentBox.height));
  }

  if (!smallerContentW && iw < cropLeft + ceil(contentBox.width)) {
    // the below offset value is applied only when there is a massive black space on the right
    // i.e User dragged container inside the contentbox region boundary
    deltaLeft += iw - (cropLeft + ceil(contentBox.width));
  }

  var cropWidth = floor(min(contentBox.width, iw));
  var cropHeight = floor(min(contentBox.height, ih));

  // since crop can be negative which makes 0 sense we set them 0
  // crop can also go beyond the max width and height which makes no sense so we set iw and ih
  // cropLeft can be min 0 or maximum of the dimension, as its crop placement not h/w

  if (cropLeft < 0) {
    cropLeft = 0;
  } else if (cropLeft + ceil(contentBox.width) > iw) {
    cropLeft = iw;
  }

  if (cropTop < 0) {
    cropTop = 0;
  } else if (cropTop + ceil(contentBox.height) > ih) {
    cropTop = ih;
  }

  // In case of LetterBoxes and smaller container , the logic of minium crop being contentBox height
  // will not work
  // To handle that we calculate what is the length of the extending visible part and set crop length accoridngly
  // (overlayOffSet + cropoffset) + ( rotatedCanvasHeight - cropOffset )
  // cropTop + deltaTop + (ih - cropTop ) = deltaTop + ih
  if (smallerContentH && deltaTop + ih > contentBox.height) {
    var extendingPart = deltaTop + ih - contentBox.height;
    cropHeight -= extendingPart / 2;
  }

  if (smallerContentW && deltaLeft + iw > contentBox.width) {
    var _extendingPart = deltaLeft + iw - contentBox.width;
    cropWidth -= _extendingPart / 2;
  }

  // used bu Crop
  var crop = {
    left: cropLeft,
    top: cropTop,
    width: cropWidth,
    height: cropHeight
  };

  // this is used by overlay
  // Overlay placement calculation effects where the cropped image is put
  // Crop alone cannot get the correct offset for weird shaped in video placement since crop x/y values greater or smaller the H/W will clip to max(H) and min(0)
  // This requires the overlay to take care of the placement and also blank space
  // One example : Try a 80deg rotate and moving video to extreme left with instagram top letterbox. Crop alone will fail here and overlay positioning would come in effect
  //
  var dest = {
    left: ceil(deltaLeft),
    top: ceil(deltaTop),
    // the height and width is used for the zoom pan filter calulation
    // this is the height and width
    width: ceil(iw),
    height: ceil(ih)
  };

  return { crop: crop, dest: dest, scaled: scaled, rotateDeg: clipBox.rotateDeg, errCrop: errCrop };
}

},{}],234:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _EditIOClient = require('./EditIOClient');

var _EditIOClient2 = _interopRequireDefault(_EditIOClient);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var UploadTracker = function () {
    function UploadTracker(id) {
        _classCallCheck(this, UploadTracker);

        this.id = id;

        this._dataCallback = function () {/* no-op */};
    }

    _createClass(UploadTracker, [{
        key: 'startTracking',
        value: function startTracking() {
            _EditIOClient2.default.addUploadTrackerCallback(this._dataCallback).subscribeToUploadTracker(this.id);
            return this;
        }
    }, {
        key: 'stopTracking',
        value: function stopTracking() {
            _EditIOClient2.default.removeUploadTrackerCallback(this._dataCallback);
            return this;
        }
    }, {
        key: 'onData',
        value: function onData(callback) {
            var _this = this;

            this._dataCallback = function (itemData) {
                if (_this.id !== itemData.id) {
                    return;
                }
                callback(itemData);
            };
            return this;
        }
    }]);

    return UploadTracker;
}();

exports.default = UploadTracker;

},{"./EditIOClient":228}],235:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _EventListenerList = require('../../common/utils/EventListenerList');

var _EventListenerList2 = _interopRequireDefault(_EventListenerList);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var WindowEvents = function () {
    function WindowEvents() {
        var _this = this;

        _classCallCheck(this, WindowEvents);

        this._eventMapObject = {};
        this.eventMap = function (name) {
            if (!_this._eventMapObject[name]) {
                _this._eventMapObject[name] = new _EventListenerList2.default({
                    eventName: name,
                    throttleT: null,
                    plainAdd: false,
                    useBatch: false,
                    useCapture: false,
                    attributeName: 'window-events-' + name
                });
            }
            return _this._eventMapObject[name];
        };

        this.functionTokenMap = [];
    }

    /**
     *
     *
     * @param {WindowEventMap} eventName
     * @param {Function} callback
     * @memberof WindowEvents
     */

    _createClass(WindowEvents, [{
        key: 'addEventListener',
        value: function addEventListener(eventName, callback) {
            var refObj = this.eventMap(eventName).addEventListener(window, callback);
            callback.refObj = refObj;
            return refObj;
        }

        /**
         *
         *
         * @param {WindowEventMap} eventName
         * @param {Function} callback
         * @return {*}
         * @memberof WindowEvents
         */

    }, {
        key: 'removeEventListener',
        value: function removeEventListener(eventName, callback) {
            var refObj = callback.refObj || null;
            this.eventMap(eventName).removeEventListener(refObj);
            return null;
        }
    }]);

    return WindowEvents;
}();

exports.default = new WindowEvents();

},{"../../common/utils/EventListenerList":75}],236:[function(require,module,exports){
arguments[4][152][0].apply(exports,arguments)
},{"dup":152,"raf":898,"shortid":1163}],237:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppManagerContext = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var AppManagerContext = exports.AppManagerContext = _react2.default.createContext(null);

},{"react":1107}],238:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _lodash = require('lodash');

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _polyfill = require('../../../common/utils/scheduler/polyfill');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var INDEX_LOADED = Symbol('INDEX_LOADED');

var BaseSearch = function () {
    function BaseSearch(args) {
        _classCallCheck(this, BaseSearch);

        if (args) {
            this.config = args.config; // default configs
        }
        this.__debug = this.config.debug;
        this.INDEX_LOADED_EVENT = INDEX_LOADED;
        this._buildIndexDone = false;
        this._eventEmitter = new _events2.default();
    }

    _createClass(BaseSearch, [{
        key: 'search',
        value: async function search(_ref) {
            var _ref$query = _ref.query,
                query = _ref$query === undefined ? '' : _ref$query,
                _ref$tags = _ref.tags,
                tags = _ref$tags === undefined ? [] : _ref$tags,
                _ref$tagNames = _ref.tagNames,
                tagNames = _ref$tagNames === undefined ? ['tags'] : _ref$tagNames;

            throw new Error('unimplemented');
        }
    }, {
        key: 'getTagList',
        value: function getTagList(tagName) {
            throw new Error('unimplemented');
        }
    }, {
        key: 'getFilterTags',
        value: function getFilterTags() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            throw new Error('unimplemented');
        }
    }, {
        key: '_isIndexLoaded',
        value: function _isIndexLoaded() {
            throw new Error('unimplemeted');
        }
    }, {
        key: 'isIndexLoaded',
        value: function isIndexLoaded() {
            return this._isIndexLoaded();
        }
    }, {
        key: 'isOnlineSearch',
        value: function isOnlineSearch() {
            throw new Error('unimplemeted');
        }
    }, {
        key: 'addEventListenerOnce',
        value: function addEventListenerOnce(eventType) {
            var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (cb) {
                // TODO -- re-enable for other listeners
                if (this._buildIndexDone) {
                    cb();
                    return;
                }
                this._eventEmitter.once(eventType, function () {
                    cb();
                });
            }
        }
    }, {
        key: 'buildIndexInfo',
        value: async function buildIndexInfo() {
            var _this = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (this._buildIndexDone) return;
            try {
                await new Promise(function (resolve, reject) {
                    (0, _polyfill.localIdleCallback)(function () {
                        Promise.resolve(_this._buildIndexInfo.apply(_this, args)).then(resolve).catch(reject);
                    });
                });

                this.getFilterTags(true); // forces to reflush the cache usefull for

                if (this.config.throttle) {
                    // change this throttle to the internal one
                    this.search = (0, _lodash.throttle)(this.search.bind(this), Number.parseInt(this.config.throttle) || 50);
                }
                if (this.config.useWorker) {}
                this._buildIndexDone = true;
                this._eventEmitter.emit(INDEX_LOADED);
            } catch (err) {
                if (this.__debug) console.error('failed building index for :', this.constructor.name, err);
            }
        }
    }, {
        key: 'setDefaultSearchText',
        value: function setDefaultSearchText() {
            // No errors not everyon needs to implement
        }
    }, {
        key: 'getDefaultSearch',
        value: async function getDefaultSearch() {
            // nope again not needed by all , but should have some defined type or string

            var otherArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        }
    }, {
        key: '_buildIndexInfo',
        value: function _buildIndexInfo() {
            throw new Error('unimplemented');
        }
    }, {
        key: 'getSearchInstance',
        value: function getSearchInstance(id) {
            return this;
        }
    }]);

    return BaseSearch;
}();

exports.default = BaseSearch;

},{"../../../common/utils/scheduler/polyfill":126,"events":629,"lodash":860}],239:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TypitoFoundrySVGSearch = undefined;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _OfflineSearch2 = require("./OfflineSearch");

var _OfflineSearch3 = _interopRequireDefault(_OfflineSearch2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TypitoFoundrySVGSearch = exports.TypitoFoundrySVGSearch = function (_OfflineSearch) {
    _inherits(TypitoFoundrySVGSearch, _OfflineSearch);

    function TypitoFoundrySVGSearch() {
        _classCallCheck(this, TypitoFoundrySVGSearch);

        return _possibleConstructorReturn(this, (TypitoFoundrySVGSearch.__proto__ || Object.getPrototypeOf(TypitoFoundrySVGSearch)).apply(this, arguments));
    }

    _createClass(TypitoFoundrySVGSearch, [{
        key: "getCategorizedResults",
        value: function getCategorizedResults(resultList) {
            var _this2 = this;

            var getId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (entry) {
                return entry.id;
            };

            if (resultList === null) return null;
            var resultSet = resultList.reduce(function (acc, entry) {
                if (!acc[_this2.index2FilterTags[getId(entry)].category[0]]) {
                    acc[_this2.index2FilterTags[getId(entry)].category[0]] = [];
                }
                acc[_this2.index2FilterTags[getId(entry)].category[0]].push(entry);
                return acc;
            }, {});
            return resultSet;
        }
    }, {
        key: "getAllCategories",
        value: function getAllCategories() {
            return Object.keys(this.filterable.category);
        }
    }]);

    return TypitoFoundrySVGSearch;
}(_OfflineSearch3.default);

},{"./OfflineSearch":241}],240:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _PluginsApi = require('../../../common/api/PluginsApi');

var _GeneralUtils = require('../../../common/utils/GeneralUtils');

var _BaseSearch2 = require('./BaseSearch');

var _BaseSearch3 = _interopRequireDefault(_BaseSearch2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEBUG = false && !("production" === 'production');
var dlog = function dlog() {
    var _console;

    return DEBUG && (_console = console).log.apply(_console, arguments);
};

var PAGE_SIZE = 30; // based on 20 icons per row

var IconScoutSearch = function (_BaseSearch) {
    _inherits(IconScoutSearch, _BaseSearch);

    function IconScoutSearch() {
        var _ref;

        _classCallCheck(this, IconScoutSearch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = IconScoutSearch.__proto__ || Object.getPrototypeOf(IconScoutSearch)).call.apply(_ref, [this].concat(args)));

        _this.checkEmptyQuery = function (_ref2) {
            var _ref2$query = _ref2.query,
                query = _ref2$query === undefined ? '' : _ref2$query,
                _ref2$tags = _ref2.tags,
                tags = _ref2$tags === undefined ? [] : _ref2$tags,
                _ref2$tagNames = _ref2.tagNames,
                tagNames = _ref2$tagNames === undefined ? ['sort'] : _ref2$tagNames;

            var isQueryEmpty = false;

            if (Array.isArray(query)) {
                isQueryEmpty = query.length == 0;
            } else {
                isQueryEmpty = query === '';
            }
            return isQueryEmpty && tags.join('').length === 0 && tagNames.join(' ').length === 0;
        };

        _this.prepareSearchData = function (_ref3) {
            var tags = _ref3.tags,
                tagNames = _ref3.tagNames;

            var sort = 'relevant';
            var styles = _this.filters.styles;

            var sortIndex = tagNames.findIndex(function (v) {
                return v === 'sort';
            });
            var styleIndex = tagNames.findIndex(function (v) {
                return v === 'styles';
            });

            if (sortIndex > -1) {
                var sortTag = tags[sortIndex].split(' ')[0]; // only once accepted
                if (sortTag) {
                    sort = sortTag;
                }
            }

            if (styleIndex > -1) {
                var styleTags = tags[styleIndex].split(' ');

                if (styleTags.length == 0) {
                    styles = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = styleTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var entry = _step.value;

                            styles.push(entry);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    styles = styleTags;
                }
            }
            return { sort: sort, styles: styles };
        };

        _this.updateSearchResults = function (searchQuery, results) {
            if (!(0, _isEqual2.default)(searchQuery, _this.oldQuery)) {
                _this.oldQuery = searchQuery;
                _this.searchResultsUpdates = {
                    list: [],
                    page: 0
                };
            }
            var _this$searchResultsUp = _this.searchResultsUpdates,
                list = _this$searchResultsUp.list,
                page = _this$searchResultsUp.page;

            _this.searchResultsUpdates = {
                list: [].concat(_toConsumableArray(list), _toConsumableArray(results)),
                page: page + 1
            };
            return _this.searchResultsUpdates.list;
        };

        _this.checkSameQuery = function (searchQuery, more) {
            var eq2 = more === false;
            var eq1 = (0, _isEqual2.default)(searchQuery, _this.oldQuery);
            if (eq1 && eq2) {
                return true;
            }
            return false;
        };

        _this.oldQuery = {};

        _this.pageSize = PAGE_SIZE;

        _this.searchResultsUpdates = {
            list: [],
            page: 0
        };

        _this.assetTypes = (0, _keymirror2.default)({
            svg: null
        });

        _this.iconScoutApi = undefined;

        _this.defaultSearchTextList = [];

        _this.acceptForeignTags = _this.config.foreignTags;
        return _this;
    }

    _createClass(IconScoutSearch, [{
        key: '_buildIndexInfo',
        value: function _buildIndexInfo(indexData) {
            var _this2 = this;

            var _indexData$pluginServ = indexData.pluginServiceDataForSearch;
            _indexData$pluginServ = _indexData$pluginServ === undefined ? {} : _indexData$pluginServ;
            var _indexData$pluginServ2 = _indexData$pluginServ.iconscout;
            _indexData$pluginServ2 = _indexData$pluginServ2 === undefined ? {} : _indexData$pluginServ2;
            var _indexData$pluginServ3 = _indexData$pluginServ2.serviceDown,
                serviceDown = _indexData$pluginServ3 === undefined ? true : _indexData$pluginServ3,
                _indexData$pluginServ4 = _indexData$pluginServ2.enabled,
                enabled = _indexData$pluginServ4 === undefined ? false : _indexData$pluginServ4,
                _indexData$pluginServ5 = _indexData$pluginServ2.clientId,
                clientId = _indexData$pluginServ5 === undefined ? '' : _indexData$pluginServ5,
                _indexData$pluginServ6 = _indexData$pluginServ2.proxyUrl,
                proxyUrl = _indexData$pluginServ6 === undefined ? '' : _indexData$pluginServ6,
                _indexData$pluginServ7 = _indexData$pluginServ2.useProxy,
                useProxy = _indexData$pluginServ7 === undefined ? true : _indexData$pluginServ7,
                _indexData$pluginServ8 = _indexData$pluginServ2.serviceBaseUrl,
                serviceBaseUrl = _indexData$pluginServ8 === undefined ? '' : _indexData$pluginServ8,
                _indexData$pluginServ9 = _indexData$pluginServ2.meta;
            _indexData$pluginServ9 = _indexData$pluginServ9 === undefined ? {} : _indexData$pluginServ9;
            var _indexData$pluginServ10 = _indexData$pluginServ9.pricePlan,
                pricePlan = _indexData$pluginServ10 === undefined ? 'free' : _indexData$pluginServ10;

            if (this.config.debug) {
                dlog('IconScout configs :', {
                    clientId: clientId,
                    proxyUrl: proxyUrl,
                    useProxy: useProxy,
                    serviceBaseUrl: serviceBaseUrl,
                    pricePlan: pricePlan,
                    serviceDown: serviceDown,
                    enabled: enabled
                });
            }

            this.clientId = clientId;
            this.proxyUrl = proxyUrl;
            this.useProxy = useProxy;
            this.serviceBaseUrl = serviceBaseUrl;

            this.serviceDown = serviceDown;

            this.baseUrl = useProxy ? this.proxyUrl : this.serviceBaseUrl;

            this.pricePlan = pricePlan;

            this.iconScoutApi = new _PluginsApi.IconScoutApi({
                clientId: clientId,
                requestUrl: this.baseUrl,
                priceSegment: this.pricePlan
            });

            this.filters = this.iconScoutApi.filters;

            this.filterNames = Object.keys(this.filters);

            if (this.config.debug) {
                window.iconScoutApi = this.iconScoutApi;
            }

            this.search = (0, _GeneralUtils.memoizeAsync)(this.search.bind(this), function () {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                return JSON.stringify(args) + '-page:' + _this2.searchResultsUpdates.page;
            });
        }
    }, {
        key: 'isOnlineSearch',
        value: function isOnlineSearch() {
            true;
        }
    }, {
        key: 'getTagList',
        value: function getTagList(tagName) {
            var list = this.filters[tagName];
            return list;
        }
    }, {
        key: 'getFilterTags',
        value: function getFilterTags() {
            return this.filterNames;
        }
    }, {
        key: '_isIndexLoaded',
        value: function _isIndexLoaded() {
            if (this.serviceDown) return false;
            if (!!this.iconScoutApi) {
                return true;
            }
            return false;
        }

        // change API convention to default Search Data , but Text works too

    }, {
        key: 'setDefaultSearchText',
        value: function setDefaultSearchText(multiSearchString) {
            this.defaultSearchTextList = multiSearchString;
        }
    }, {
        key: 'getDefaultSearch',
        value: async function getDefaultSearch(otherArgs) {
            var result = await this.search(_extends({
                query: this.defaultSearchTextList,
                userSearch: false
            }, otherArgs));

            return result;
        }
    }, {
        key: 'search',

        // APPLY MEMOIZATION ON THIS FUNCTION TO AVOID FUNCTION CALLS OF SAME THING
        value: async function search(_ref4) {
            var _ref4$query = _ref4.query,
                query = _ref4$query === undefined ? '' : _ref4$query,
                _ref4$tags = _ref4.tags,
                tags = _ref4$tags === undefined ? ['popular'] : _ref4$tags,
                _ref4$tagNames = _ref4.tagNames,
                tagNames = _ref4$tagNames === undefined ? ['sort'] : _ref4$tagNames,
                _ref4$more = _ref4.more,
                more = _ref4$more === undefined ? false : _ref4$more,
                _ref4$userSearch = _ref4.userSearch,
                userSearch = _ref4$userSearch === undefined ? true : _ref4$userSearch;

            if (tags.length == 0 && tagNames.length == 0) {
                if (userSearch) {
                    tags = ['relevant'];
                    tagNames = ['sort'];
                } else {
                    tags = ['popular'];
                    tagNames = ['sort'];
                }
            }

            if (this.acceptForeignTags) {
                var newTags = [];
                var newTagNames = [];
                var newQuery = Array.isArray(query) ? [].concat(_toConsumableArray(query)) : query;
                for (var i = 0; i < tagNames.length; i++) {
                    if (!this.getFilterTags().includes(tagNames[i])) {
                        if (Array.isArray(newQuery)) {
                            for (var j = 0; j < newQuery.length; j++) {
                                newQuery[j] += tags[i];
                            }
                        } else {
                            newQuery += tags[i];
                        }
                    } else {
                        newTags.push(tags[i]);
                        newTagNames.push(tagNames[i]);
                    }
                }
                tags = newTags;
                tagNames = newTagNames;
                query = newQuery;
            }

            try {
                // dlog(`Query Recieved :`,{
                //     query , tags , tagNames
                // })
                if (!this.isIndexLoaded() || this.checkEmptyQuery({
                    query: query,
                    tags: tags,
                    tagNames: tagNames
                })) {
                    return {
                        relevantTags: this.filters,
                        result: []
                    };
                }

                if (this.checkSameQuery({ query: query, tags: tags, tagNames: tagNames }, more)) {
                    return {
                        relevantTags: {},
                        result: this.searchResultsUpdates.list
                    };
                } else if (!more) {
                    this.searchResultsUpdates.page = 0;
                }

                var _prepareSearchData = this.prepareSearchData({
                    tagNames: tagNames,
                    tags: tags
                }),
                    sort = _prepareSearchData.sort,
                    styles = _prepareSearchData.styles;

                var searchResult = void 0;
                if (Array.isArray(query)) {
                    searchResult = await this.iconScoutApi.searchIconsV3MultiQuery({
                        page: this.searchResultsUpdates.page + 1,
                        perPage: PAGE_SIZE,
                        queryList: query,
                        sort: sort,
                        styles: styles
                    });
                } else {
                    searchResult = await this.iconScoutApi.searchIconsV3({
                        page: this.searchResultsUpdates.page + 1,
                        perPage: PAGE_SIZE,
                        query: query,
                        sort: sort,
                        styles: styles
                    });
                }

                var newResult = this.updateSearchResults({ query: query, tagNames: tagNames, tags: tags }, searchResult);

                return {
                    relevantTags: this.filters,
                    result: newResult
                };

                // Check for same search
            } catch (err) {
                console.log('failed to grab data from IconScout !! err :', err);
            }

            return {
                relevantTags: this.filters,
                result: this.searchResultsUpdates.list // return stash result
            };
        }
    }]);

    return IconScoutSearch;
}(_BaseSearch3.default);

exports.default = IconScoutSearch;

},{"../../../common/api/PluginsApi":3,"../../../common/utils/GeneralUtils":77,"./BaseSearch":238,"keymirror":677,"lodash/isEqual":845}],241:[function(require,module,exports){
'use strict';

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _search2 = require('../../../common/utils/search');

var _BaseSearch2 = require('./BaseSearch');

var _BaseSearch3 = _interopRequireDefault(_BaseSearch2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _polyfill = require('../../../common/utils/scheduler/polyfill');

var _GeneralUtils = require('../../../common/utils/GeneralUtils');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Search class base for implementing basic methods
 * extended by registry of each type
 * @class BaseSearch
 */
var OfflineSearch = function (_BaseSearch) {
    _inherits(OfflineSearch, _BaseSearch);

    function OfflineSearch(_ref) {
        var indexField = _ref.indexField,
            _ref$config = _ref.config,
            config = _ref$config === undefined ? { editDistance: true, editDistanceCount: 3, useRIT: true, debug: false, maxRecommend: 20, throttle: 50, purifyTags: false } : _ref$config;

        _classCallCheck(this, OfflineSearch);

        var _this = _possibleConstructorReturn(this, (OfflineSearch.__proto__ || Object.getPrototypeOf(OfflineSearch)).call(this, { indexField: indexField, config: config }));

        _this._purifyTags = function () {
            var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [''];
            var tagNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['tags'];

            tags = tags || [''];
            tagNames = tagNames || ['tags'];

            var newTags = [];
            var newTagNames = [];
            var ownFilters = _this.getFilterTags();
            for (var i = 0; i < tagNames.length; i++) {
                if (ownFilters.includes(tagNames[i])) {
                    if (tagNames[i]) newTagNames.push(tagNames[i]);
                    if (tags[i]) {
                        newTags.push(tags[i]);
                    }
                }
            }

            return {
                tags: newTags,
                tagNames: newTagNames
            };
        };

        _this.indexField = indexField;
        _this.defaultText = '';
        _this.filterElements = _search2.filterElements.bind(_this);

        _this.purifyTags = _this.config.purifyTags;

        _this.dlog = function () {
            var _console;

            return _this.__debug && (_console = console).log.apply(_console, arguments);
        };
        return _this;
    }

    /**
     * new  idleTimeCallback based search dispatch ,
     * gives better UI responsiveness
     *
     * @param {*} args
     * @return {*}
     * @memberof OfflineSearch
     */

    _createClass(OfflineSearch, [{
        key: '_raiSearch',
        value: async function _raiSearch() {
            var _this2 = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (this.config.debug) console.log('Using idlecallback');
            return new Promise(function (resolve, reject) {
                (0, _polyfill.localIdleCallback)(function () {
                    _this2._search.apply(_this2, args).then(resolve).catch(reject);
                });
            });
        }
    }, {
        key: '_buildIndexInfo',
        value: function _buildIndexInfo(indexData) {
            try {
                var _indexData$indexField = indexData[this.indexField],
                    index = _indexData$indexField.index,
                    filterable = _indexData$indexField.filterable;

                this.index = (0, _search2.buildSearch)(index, this.config);

                var index2FilterTags = filterable.index2FilterTags,
                    filterData = _objectWithoutProperties(filterable, ['index2FilterTags']);

                this.index2FilterTags = index2FilterTags;

                this.filterable = filterData;
                // all the filterable props
                this.filterTagNames = Object.keys(this.filterable);

                var _tagResults = Object.assign({}, this.filterable);
                Object.keys(_tagResults).forEach(function (k) {
                    _tagResults[k] = [];
                });

                this.indexLoaded = true;

                this.tagResultsCopy = _tagResults; // optimization precaching

                this.processResults = this.config.useRIT && !!window.requestIdleCallback ? this._processResultGenrator.bind(this) : this._processResult.bind(this);
            } catch (err) {
                if (this.config.debug) console.log('failed to buildIndexInfo : ' + this.constructor.name);
            }

            var searchFn = this._search.bind(this);
            // Search is created and instantiated here and only for Offline controller
            // change the searchFn memoize to the internal async one
            this.search = (0, _GeneralUtils.memoizeAsync)(searchFn, function (_ref2) {
                var _ref2$query = _ref2.query,
                    query = _ref2$query === undefined ? '' : _ref2$query,
                    _ref2$tags = _ref2.tags,
                    tags = _ref2$tags === undefined ? [] : _ref2$tags,
                    _ref2$tagNames = _ref2.tagNames,
                    tagNames = _ref2$tagNames === undefined ? ['tags'] : _ref2$tagNames;

                return query.trim() + tags.toString() + tagNames.toString();
            });
        }
    }, {
        key: 'isIndexLoaded',
        value: function isIndexLoaded() {
            return this.indexLoaded === true;
        }
    }, {
        key: 'setDefaultSearchText',
        value: function setDefaultSearchText(data) {
            this.defaultText = data;
        }
    }, {
        key: 'getDefaultSearch',
        value: async function getDefaultSearch() {
            var otherArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.search(_extends({
                query: this.defaultText
            }, otherArgs));
        }
    }, {
        key: 'getTagList',
        value: function getTagList(tagName) {
            var obj = this.filterable[tagName] || {};
            return Object.keys(obj).sort(function (k1, k2) {
                return obj[k1] - obj[k2];
            });
        }

        /**
         * //TODO add a new async generator method that can use
         * a postMessage + requestIdleTime scheduler
         * to convert task into chunks
         *
         * //TODO Write Polyfill for Async reduce / map /filter using browser idleCallback to schedule task
         *
         * @param {*} result
         * @memberof OfflineSearch
         */

    }, {
        key: '_processResultGenrator',
        value: async function _processResultGenrator(result) {
            var _this3 = this;

            var tagResults = Object.assign({}, this.tagResultsCopy);
            return new Promise(function (resolve, reject) {
                window.requestIdleCallback(function (idleDeadline) {
                    _this3._processChunk(result, 0, tagResults, idleDeadline, resolve, reject);
                });
            });
        }
    }, {
        key: '_processChunk',
        value: function _processChunk(result, index, tagResults, idleDeadline, resolve, reject) {
            var _this4 = this;

            // TODO
            // build up the tagResults data // used for autoprediction - union can be optimised

            if (this.config.debug) {
                console.log('process query result index :', index, 'idleDeadline :', idleDeadline.timeRemaining());
            }
            try {
                for (var i = index; i < result.length; i++) {
                    if (this.config.debug) console.log('time remainining :', idleDeadline.timeRemaining());
                    if (idleDeadline.timeRemaining() == 0) {
                        var _ret = function () {
                            var ind = i;
                            window.requestIdleCallback(function (idleDeadline) {
                                _this4._processChunk(result, ind, tagResults, idleDeadline, resolve, reject);
                            });
                            return {
                                v: void 0
                            };
                        }();

                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                    }

                    var r = result[i];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.keys(tagResults)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var trk = _step.value;

                            tagResults[trk] = _lodash2.default.union(tagResults[trk], this.index2FilterTags[r.id][trk]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                var finalResult = {
                    relevantTags: tagResults,
                    result: result
                };

                if (this.config.debug) {
                    console.log('prepared result in context of index:', index, 'total data :', result.length);
                    console.log(finalResult);
                }
                resolve(finalResult);
            } catch (err) {
                reject(err);
            }
        }
    }, {
        key: '_processResult',
        value: async function _processResult(result) {
            var _this5 = this;

            var tagResults = Object.assign({}, this.tagResultsCopy); // optimisation , using precomputed

            var relevantTags = result.reduce(function (a, r) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = Object.keys(tagResults)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var trk = _step2.value;

                        tagResults[trk] = _lodash2.default.union(tagResults[trk], _this5.index2FilterTags[r.id][trk]); //TODO removed map should optimize some of the Jank
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return tagResults;
            }, tagResults);

            // TODO test responsiveness of UI
            // Object.values(tagResults).forEach(value => {
            //     value.sort((a, b) => {
            //         return b.score - a.score
            //     })

            //     for (let i = 0; i < value.length; i++){
            //         value[i] = value[i].t
            //     }
            // })

            return {
                relevantTags: relevantTags,
                result: result
            };
        }
    }, {
        key: 'isOnlineSearch',
        value: function isOnlineSearch() {
            return false;
        }

        /**
         * returns the tags on which filter can be applied
         * return undefined if registry is not initialised yet
         *
         * @return {Array<string> | undefined}
         * @memberof BaseSearch
         */

    }, {
        key: 'getFilterTags',
        value: function getFilterTags() {
            return this.filterTagNames;
        }
    }, {
        key: '_search',

        /**
         * tags is list of space sepparated search tags
         * tagNames is categories
         *
         * @param {*} {
         *         query='',
         *         tags=[],
         *         tagNames =['tag']
         *     }
         * @return {*}
         * @memberof OfflineSearch
         */
        value: async function _search(_ref3) {
            var _ref3$query = _ref3.query,
                query = _ref3$query === undefined ? '' : _ref3$query,
                _ref3$tags = _ref3.tags,
                tags = _ref3$tags === undefined ? [] : _ref3$tags,
                _ref3$tagNames = _ref3.tagNames,
                tagNames = _ref3$tagNames === undefined ? ['tags'] : _ref3$tagNames;

            if (this.purifyTags) {
                var data = this._purifyTags(tags, tagNames);
                tags = data.tags;
                tagNames = data.tagNames;
            }

            if (this.index === undefined) {
                if (this.__debug) console.log('failed to engage all indexes and bring this user search results !!! inside', this.constructor.name);
                return [];
            }

            if (query === '' && tags.length === 0) {
                return null;
            }

            // only text query mode
            if (query !== '' && tags.length === 0) {
                var result = await this.index.queryString(query);
                var _result = this.processResults(result);
                this.dlog('results with query by string :', _result);
                return _result;
            }

            if (query !== '' && tags.length !== 0) {
                if (tagNames.length === 0) tagNames = ['tags'];
                var _result2 = await this.index.queryByTagsString({
                    query: query,
                    tags: tags,
                    tagNames: tagNames
                });
                var _result3 = this.processResults(_result2);
                this.dlog('results with query by string and tag :', _result3);
                return _result3;
            }

            // when there is no string query only tags
            if (query === '' && tags.length !== 0) {
                if (tagNames.length === 0) tagNames = ['tags'];
                var _result4 = await this.index.queryByTags(tags, tagNames);
                var _result5 = this.processResults(_result4);
                this.dlog('results with query by tag only :', _result5);
                return _result5;
            }
        }
    }]);

    return OfflineSearch;
}(_BaseSearch3.default);

exports.default = OfflineSearch;

},{"../../../common/utils/GeneralUtils":77,"../../../common/utils/scheduler/polyfill":126,"../../../common/utils/search":129,"./BaseSearch":238,"lodash":860}],242:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _BaseSearch2 = require('./BaseSearch');

var _BaseSearch3 = _interopRequireDefault(_BaseSearch2);

var _search = require('../../../common/utils/search');

var _lodash = require('lodash');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 *
 *
 * @export
 * @class SearchComposite
 * @extends {BaseSearch}
 */
var SearchComposite = function (_BaseSearch) {
    _inherits(SearchComposite, _BaseSearch);

    /**
     * Creates an instance of SearchComposite.
     * @param {{
     *  searchInstances : Array<BaseSearch>
     * }} [config={ indentifier : [] , searchInstances :[]  , instanceConfig: [] , config:{} }]
     * @memberof SearchComposite
     */
    function SearchComposite() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indentifier: [], searchInstances: [], instanceConfig: [], config: {} };

        _classCallCheck(this, SearchComposite);

        var _this = _possibleConstructorReturn(this, (SearchComposite.__proto__ || Object.getPrototypeOf(SearchComposite)).call(this, config));

        _this.searchInstances = config.searchInstances;
        _this.identifier = config.identifier;
        _this.getTagList = (0, _lodash.memoize)(_this._getTagList.bind(_this), function (tagName) {
            return tagName;
        });
        _this.instanceConfig = config.instanceConfig;
        _this.offlineFilter = _search.filterElements.bind(_this);
        _this.mediaTypes = config.config.mediaTypes;
        return _this;
    }

    _createClass(SearchComposite, [{
        key: 'getMediaTypes',
        value: function getMediaTypes() {
            return this.mediaTypes;
        }
    }, {
        key: 'getSearchInstance',
        value: function getSearchInstance(id) {
            if (!this.identifier) {
                return this;
            }
            var index = this.identifier.findIndex(function (v) {
                return v === id;
            });
            if (index > -1) return this.searchInstances[index];
            return this;
        }
    }, {
        key: '__processMultiResult',
        value: function __processMultiResult(results) {
            var _this2 = this;

            var combinedResult = results.reduce(function (acc, instRes, index) {
                var relevantTags = acc.relevantTags,
                    result = acc.result; //used for combining results

                if (!!instRes) {
                    var _ref = instRes || {},
                        _ref$relevantTags = _ref.relevantTags,
                        instRT = _ref$relevantTags === undefined ? {} : _ref$relevantTags;

                    relevantTags = (0, _lodash.merge)(instRT, relevantTags);
                }
                result[_this2.identifier[index]] = instRes === null ? null : instRes.result;
                return {
                    relevantTags: relevantTags,
                    result: result
                };
            }, {
                relevantTags: {},
                result: {}
            });

            return combinedResult;
        }

        /**
         *
         *
         * @param {*} {
         *         query='',
         *         tags=[],
         *         tagNames =['tags'],
         *         more = false
         *     }
         * @return {*}
         * @memberof SearchComposite
         */

    }, {
        key: 'search',
        value: async function search(_ref2) {
            var _ref2$query = _ref2.query,
                query = _ref2$query === undefined ? '' : _ref2$query,
                _ref2$tags = _ref2.tags,
                tags = _ref2$tags === undefined ? [] : _ref2$tags,
                _ref2$tagNames = _ref2.tagNames,
                tagNames = _ref2$tagNames === undefined ? ['tags'] : _ref2$tagNames,
                _ref2$more = _ref2.more,
                more = _ref2$more === undefined ? false : _ref2$more;

            var results = await Promise.all(this.searchInstances.map(function (inst) {
                var instanceFilters = inst.getFilterTags();
                var instTags = [];
                var instTagNames = [];
                var len = tagNames ? tagNames.length : 0;
                // passing tag names to individual Search Instance so that tagNames and tags don't inetrefere with non
                // intended instances
                for (var i = 0; i < len; i++) {
                    if (instanceFilters.includes(tagNames[i])) {
                        if (tags[i]) {
                            instTags.push(tags[i]);
                        }
                        instTagNames.push(tagNames[i]);
                    }
                }

                return inst.search({ query: query, tags: instTags, tagNames: instTagNames, more: more });
            }));

            return this.__processMultiResult(results);
        }
    }, {
        key: '_getTagList',
        value: function _getTagList(tagName) {
            return this.searchInstances.reduce(function (acc, instance) {
                var tagList = instance.getTagList(tagName);
                return (0, _lodash.union)(tagList, acc);
            }, []);
        }
    }, {
        key: 'getFilterTags',
        value: function getFilterTags() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this._filterTagNames || force) {
                this._filterTagNames = this.searchInstances.reduce(function (acc, instance) {
                    var res = instance.getFilterTags();
                    return (0, _lodash.union)(acc, res);
                }, []);
            }

            return this._filterTagNames;
        }
    }, {
        key: 'setDefaultSearchText',
        value: function setDefaultSearchText(data) {
            var _this3 = this;

            this.defaultText = data;

            this.searchInstances.forEach(function (instance, index) {
                var _instanceConfig$index = _this3.instanceConfig[index].noDefault,
                    noDefault = _instanceConfig$index === undefined ? false : _instanceConfig$index;

                if (!noDefault) instance.setDefaultSearchText(data);
            });
        }
    }, {
        key: 'getDefaultSearch',
        value: async function getDefaultSearch(otherArgs) {
            var results = await Promise.all(this.searchInstances.map(function (inst) {
                return inst.getDefaultSearch(otherArgs);
            }));

            return this.__processMultiResult(results);
        }
    }, {
        key: 'isIndexLoaded',
        value: function isIndexLoaded() {
            // if(this._indexLoaded == undefined)

            this._indexLoaded = true;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.searchInstances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var instance = _step.value;

                    this._indexLoaded = this._indexLoaded && instance.isIndexLoaded();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return this._indexLoaded;
        }
    }, {
        key: 'isOnlineSearch',
        value: function isOnlineSearch() {
            // if(this._isOnlineSearch == undefined)

            this._onlineSearch = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.searchInstances[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var instance = _step2.value;

                    this._onlineSearch = this._onlineSearch || instance.isOnlineSearch();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return this._onlineSearch;
        }
    }, {
        key: '_buildIndexInfo',
        value: function _buildIndexInfo() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            // DOESNT MATTERS ITS GETTING COMPONENTS WHOSE INDEXES ARE ALREADY BUILT
            return Promise.all(this.searchInstances.map(function (searchInstance) {
                return searchInstance.buildIndexInfo.apply(searchInstance, args);
            }));
        }
    }]);

    return SearchComposite;
}(_BaseSearch3.default);

exports.default = SearchComposite;

},{"../../../common/utils/search":129,"./BaseSearch":238,"lodash":860}],243:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _search = require('../../../common/utils/search');

var _OfflineSearch6 = require('./OfflineSearch');

var _OfflineSearch7 = _interopRequireDefault(_OfflineSearch6);

var _StockSearch = require('./StockSearch');

var _StockSearch2 = _interopRequireDefault(_StockSearch);

var _WorkspaceMediaSearch = require('./WorkspaceMediaSearch');

var _WorkspaceMediaSearch2 = _interopRequireDefault(_WorkspaceMediaSearch);

var _SearchComposite3 = require('./SearchComposite');

var _SearchComposite4 = _interopRequireDefault(_SearchComposite3);

var _IconScoutSearch = require('./IconScoutSearch');

var _IconScoutSearch2 = _interopRequireDefault(_IconScoutSearch);

var _FoundrySearch = require('./FoundrySearch');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var DEBUG = false;

var CollectionSearchTypes = (0, _keymirror2.default)({
    STOCK: null,
    VT: null
});

var ElementsSearchTypes = (0, _keymirror2.default)({
    COUNTERS: null,
    SHAPES: null,
    ICONSCOUT: null,
    TYPITOFOUNDRY: null
});

var SearchRegistry = function () {
    _createClass(SearchRegistry, [{
        key: 'getCollectSearchTypes',
        value: function getCollectSearchTypes() {
            return CollectionSearchTypes;
        }
    }, {
        key: 'getElementsSearchTypes',
        value: function getElementsSearchTypes() {
            return ElementsSearchTypes;
        }
    }]);

    function SearchRegistry() {
        _classCallCheck(this, SearchRegistry);

        // the class extension gives named identity , to be used inside the base search
        this._templateSearch = new (function (_OfflineSearch) {
            _inherits(TemplateSearch, _OfflineSearch);

            function TemplateSearch() {
                _classCallCheck(this, TemplateSearch);

                return _possibleConstructorReturn(this, (TemplateSearch.__proto__ || Object.getPrototypeOf(TemplateSearch)).apply(this, arguments));
            }

            return TemplateSearch;
        }(_OfflineSearch7.default))({
            indexField: 'textTemplateIndex',
            config: {
                editDistance: true,
                useRIT: true,
                debug: DEBUG,
                maxRecommend: 20,
                throttle: 50,
                editDistanceCount: 1
            }
        });
        this._counterTemplateSearch = new (function (_OfflineSearch2) {
            _inherits(CounterTemplateSearch, _OfflineSearch2);

            function CounterTemplateSearch() {
                _classCallCheck(this, CounterTemplateSearch);

                return _possibleConstructorReturn(this, (CounterTemplateSearch.__proto__ || Object.getPrototypeOf(CounterTemplateSearch)).apply(this, arguments));
            }

            return CounterTemplateSearch;
        }(_OfflineSearch7.default))({
            indexField: 'counterTemplateIndex',
            config: {
                editDistance: true,
                useRIT: true,
                debug: DEBUG,
                maxRecommend: 20,
                throttle: 50,
                editDistanceCount: 1
            }
        });
        this._audioSearch = new (function (_OfflineSearch3) {
            _inherits(AudioSearch, _OfflineSearch3);

            function AudioSearch() {
                _classCallCheck(this, AudioSearch);

                return _possibleConstructorReturn(this, (AudioSearch.__proto__ || Object.getPrototypeOf(AudioSearch)).apply(this, arguments));
            }

            return AudioSearch;
        }(_OfflineSearch7.default))({
            indexField: 'audioIndex',
            config: {
                editDistance: true,
                useRIT: true,
                debug: DEBUG,
                maxRecommend: 20,
                throttle: 50
            }
        });

        this._shapeSearch = new (function (_OfflineSearch4) {
            _inherits(ShapeSearch, _OfflineSearch4);

            function ShapeSearch() {
                _classCallCheck(this, ShapeSearch);

                return _possibleConstructorReturn(this, (ShapeSearch.__proto__ || Object.getPrototypeOf(ShapeSearch)).apply(this, arguments));
            }

            return ShapeSearch;
        }(_OfflineSearch7.default))({
            indexField: 'shapeIndex',
            config: {
                editDistance: true,
                useRIT: true,
                debug: DEBUG,
                maxRecommend: 20,
                throttle: 50,
                purifyTags: true
            }
        });

        this._videoTemplateSearch = new (function (_OfflineSearch5) {
            _inherits(VideoTemplateSearch, _OfflineSearch5);

            function VideoTemplateSearch() {
                _classCallCheck(this, VideoTemplateSearch);

                return _possibleConstructorReturn(this, (VideoTemplateSearch.__proto__ || Object.getPrototypeOf(VideoTemplateSearch)).apply(this, arguments));
            }

            return VideoTemplateSearch;
        }(_OfflineSearch7.default))({
            indexField: 'videoTemplateIndex',
            config: {
                editDistance: true,
                useRIT: true,
                debug: DEBUG,
                maxRecommend: 20,
                throttle: 50,
                editDistanceCount: 1
            }
        });

        this._workspaceSearch = new _WorkspaceMediaSearch2.default({
            config: { throttle: 50, debug: DEBUG }
        });

        this._stockMediaSearch = new _StockSearch2.default({
            config: { throttle: 50, debug: DEBUG }
        });

        this._collectionSearch = new (function (_SearchComposite) {
            _inherits(StockSectionSearch, _SearchComposite);

            function StockSectionSearch() {
                _classCallCheck(this, StockSectionSearch);

                return _possibleConstructorReturn(this, (StockSectionSearch.__proto__ || Object.getPrototypeOf(StockSectionSearch)).apply(this, arguments));
            }

            return StockSectionSearch;
        }(_SearchComposite4.default))({
            // list of configurations
            searchInstances: [this._stockMediaSearch, this._videoTemplateSearch],
            identifier: [CollectionSearchTypes.STOCK, CollectionSearchTypes.VT],
            instanceConfig: [{ noDefault: false }, { noDefault: true }],
            config: {
                throttle: 50,
                debug: DEBUG,
                mediaTypes: (0, _keymirror2.default)({
                    image: null,
                    video: null,
                    sequence: null
                })
            }
        });

        this._collectionSearch.CollectionSearchTypes = this.getCollectSearchTypes();

        this._iconScoutPluginSearch = new _IconScoutSearch2.default({
            config: { debug: DEBUG, foreignTags: true }
        });

        this._typitoFoundrySVGSearch = new _FoundrySearch.TypitoFoundrySVGSearch({
            indexField: 'foundrySVGIndex',
            config: {
                editDistance: true,
                useRIT: true,
                debug: DEBUG,
                maxRecommend: 20,
                throttle: 50,
                purifyTags: true
            }
        });

        this._elementSearch = new (function (_SearchComposite2) {
            _inherits(ElementSectionSearch, _SearchComposite2);

            function ElementSectionSearch() {
                _classCallCheck(this, ElementSectionSearch);

                return _possibleConstructorReturn(this, (ElementSectionSearch.__proto__ || Object.getPrototypeOf(ElementSectionSearch)).apply(this, arguments));
            }

            return ElementSectionSearch;
        }(_SearchComposite4.default))({
            searchInstances: [this._counterTemplateSearch, this._shapeSearch, this._iconScoutPluginSearch, this._typitoFoundrySVGSearch],
            identifier: [ElementsSearchTypes.COUNTERS, ElementsSearchTypes.SHAPES, ElementsSearchTypes.ICONSCOUT, ElementsSearchTypes.TYPITOFOUNDRY],
            instanceConfig: [{ noDefault: true }, { noDefault: true }, { noDefault: false }, { noDefault: true }],
            config: {
                throttle: 50,
                debug: DEBUG,
                mediaTypes: (0, _keymirror2.default)({
                    timer: null,
                    progressBar: null,
                    shapes: null,
                    icons: null,
                    svg: null
                })
            }
        });

        this.searchHandlers = [this._templateSearch, this._audioSearch,
        // this._stockMediaSearch ,
        this._workspaceSearch,
        // this._videoTemplateSearch ,
        this._collectionSearch, this._shapeSearch, this._iconScoutPluginSearch, this._elementSearch];
        this.filterElements = _search.filterElements;
    }

    /**
     *
     *
     * @return {WorkspaceMediaSearch}
     * @memberof SearchRegistry
     */

    _createClass(SearchRegistry, [{
        key: 'getWorkspaceSearch',
        value: function getWorkspaceSearch() {
            return this._workspaceSearch;
        }

        /**
         *
         *
         * @return {SearchComposite}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getCollectionSearch',
        value: function getCollectionSearch() {
            return this._collectionSearch;
        }

        /**
         *
         *
         * @return {OfflineSearch}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getTemplateSearch',
        value: function getTemplateSearch() {
            return this._templateSearch;
        }

        /**
         *
         *
         * @return {OfflineSearch}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getCounterTemplateSearch',
        value: function getCounterTemplateSearch() {
            return this._counterTemplateSearch;
        }

        /**
         *
         *
         * @return {OfflineSearch}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getVideoTemplateSearch',
        value: function getVideoTemplateSearch() {
            return this._videoTemplateSearch;
        }

        /**
         *
         *
         * @return {OfflineSearch}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getAudioSearch',
        value: function getAudioSearch() {
            return this._audioSearch;
        }

        /**
         *
         *
         * @return {OfflineSearch}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getShapeSearch',
        value: function getShapeSearch() {
            return this._shapeSearch;
        }
    }, {
        key: 'getElementsSearch',
        value: function getElementsSearch() {
            return this._elementSearch;
        }

        /**
         *
         *
         * @return {StockMediaSearch}
         * @memberof SearchRegistry
         */

    }, {
        key: 'getStockMediaSearch',
        value: function getStockMediaSearch() {
            return this._stockMediaSearch;
        }
    }, {
        key: 'getIconscoutPluginSearch',
        value: function getIconscoutPluginSearch() {
            return this._iconScoutPluginSearch;
        }
    }, {
        key: 'log',
        value: function log(m) {
            this.debug ? console.log(m) : null;
        }
    }, {
        key: 'parseSearchData',
        value: async function parseSearchData(_ref) {
            var url = _ref.url,
                _ref$pluginServiceDat = _ref.pluginServiceDataForSearch,
                pluginServiceDataForSearch = _ref$pluginServiceDat === undefined ? {} : _ref$pluginServiceDat,
                _ref$debug = _ref.debug,
                debug = _ref$debug === undefined ? false : _ref$debug;

            this.debug = debug || DEBUG;
            try {
                this.log('sending request for index');
                var response = await _axios2.default.get(url);
                var index = response.data;
                index.pluginServiceDataForSearch = pluginServiceDataForSearch;
                this.enable = true;
                this.indexData = index;
                this.log('recieved index');
                if (this.debug) {
                    console.log(this.indexData);
                    window.SearchRegistry = this;
                }
                this.log('building index !!');

                await this.__buildIndex();

                this.log('building index done !!');
            } catch (err) {
                console.log('failed to build search data, search will not work :', err);
                this.enable = false;
            }
        }
    }, {
        key: '__buildIndex',
        value: async function __buildIndex() {
            var _this8 = this;

            await Promise.all(this.searchHandlers.map(function (v) {
                return v.buildIndexInfo(_this8.indexData);
            }));
        }
    }]);

    return SearchRegistry;
}();

exports.default = new SearchRegistry();

},{"../../../common/utils/search":129,"./FoundrySearch":239,"./IconScoutSearch":240,"./OfflineSearch":241,"./SearchComposite":242,"./StockSearch":244,"./WorkspaceMediaSearch":245,"axios":335,"keymirror":677,"lodash":860}],244:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _BaseSearch2 = require('./BaseSearch');

var _BaseSearch3 = _interopRequireDefault(_BaseSearch2);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _unsplashJs = require('unsplash-js');

var _lodash = require('lodash');

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _UploadApi = require('../../api/UploadApi');

var _errorReporting = require('../../../common/utils/errorReporting');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PAGE_SIZE = 30;

var StockSearch = function (_BaseSearch) {
    _inherits(StockSearch, _BaseSearch);

    function StockSearch() {
        var _ref;

        _classCallCheck(this, StockSearch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = StockSearch.__proto__ || Object.getPrototypeOf(StockSearch)).call.apply(_ref, [this].concat(args)));

        _this.unsplash = undefined;

        _this.filterTagNames = [
            // 'type'
        ];

        _this.unsplash = null;

        // once unsplash is upgraded these can be included
        _this.filterable = {
            // type : ['Photo' , 'Video'],
            // below can be included with unsplash upgrade
            // proportion : ['landscape','portrait', 'squarish'],
            // color : 'black_and_white, black, white, yellow, orange, red, purple, magenta, green, teal, and blue'.split(',').map(v => v.trim())
        };

        _this.oldQuery = {};

        _this.pageSize = PAGE_SIZE;

        _this.searchResultsUpdates = {
            list: [],
            page: 0
        };

        _this.mediaTypes = (0, _keymirror2.default)({
            image: null,
            video: null
        });

        _this.defaultText = '';
        return _this;
    }

    _createClass(StockSearch, [{
        key: 'setDefaultSearchText',
        value: function setDefaultSearchText(data) {
            this.defaultText = data;
        }
    }, {
        key: 'getMediaTypes',
        value: function getMediaTypes() {
            return this.mediaTypes;
        }
    }, {
        key: 'isOnlineSearch',
        value: function isOnlineSearch() {
            return true;
        }
    }, {
        key: 'updateResults',
        value: function updateResults(searchQuery, results) {
            if (!(0, _lodash.isEqual)(searchQuery, this.oldQuery)) {
                this.oldQuery = searchQuery; // should be a new object every time ideally
                this.searchResultsUpdates = {
                    list: [],
                    page: 0
                };
            }

            var _searchResultsUpdates = this.searchResultsUpdates,
                list = _searchResultsUpdates.list,
                page = _searchResultsUpdates.page;

            this.searchResultsUpdates = {
                list: [].concat(_toConsumableArray(list), _toConsumableArray(results)),
                page: page + 1
            };
        }
    }, {
        key: 'getTagList',
        value: function getTagList(tagName) {
            var obj = this.filterable[tagName] || {};
            return Object.keys(obj).sort(function (k1, k2) {
                return obj[k1] - obj[k2];
            });
        }
    }, {
        key: 'getFilterTags',
        value: function getFilterTags() {
            return this.filterTagNames;
        }
    }, {
        key: 'isIndexLoaded',
        value: function isIndexLoaded() {
            if (window.unsplashConfig.enabled) {
                return this.unsplash !== null;
            }
            return true;
        }

        // doesnt build any index info

    }, {
        key: '_buildIndexInfo',
        value: function _buildIndexInfo() {
            var disableWebImage = !window.unsplashConfig || !window.unsplashConfig.enabled || !window.unsplashConfig.proxyUrl;
            var disableWebVideo = !window.pixabayConfig || !window.pixabayConfig.enabled || !window.pixabayConfig.accessKey;

            var unsplashOption = {};
            // accessKey is only served in dev mode , if not present we resort to using Proxy url
            // proxy is always served
            if (!disableWebImage) {
                if (!!window.unsplashConfig.accessKey) {
                    unsplashOption.accessKey = window.unsplashConfig.accessKey;
                } else {
                    unsplashOption.apiUrl = window.unsplashConfig.proxyUrl;
                }
                if (this.config.debug) {
                    console.log('Unsplash options :', unsplashOption);
                }
                this.unsplash = (0, _unsplashJs.createApi)(unsplashOption);
                this.unsplash.appName = window.unsplashConfig.appName;
            }

            if (this.config.debug) {
                console.log('Status of online search : ', {
                    disableWebImage: disableWebImage,
                    disableWebVideo: disableWebVideo,
                    unsplash: this.unsplash
                });
            }
        }
    }, {
        key: 'checkEmptyQuery',
        value: function checkEmptyQuery(_ref2) {
            var _ref2$query = _ref2.query,
                query = _ref2$query === undefined ? '' : _ref2$query,
                _ref2$tags = _ref2.tags,
                tags = _ref2$tags === undefined ? [] : _ref2$tags,
                _ref2$tagNames = _ref2.tagNames,
                tagNames = _ref2$tagNames === undefined ? ['tags'] : _ref2$tagNames;

            return query === '' && tags.join('').length === 0 && tagNames.join(' ').length === 0;
        }
    }, {
        key: 'sameSearch',
        value: function sameSearch(searchQuery, more) {
            var eq2 = more === false;
            var eq1 = (0, _lodash.isEqual)(searchQuery, this.oldQuery);

            if (eq1 && eq2) {
                return true;
            }
            return false;
        }
    }, {
        key: 'getDefaultSearch',
        value: async function getDefaultSearch(args) {
            return this.search(_extends({
                query: this.defaultText
            }, args));
        }
    }, {
        key: 'searchImages',
        value: function searchImages(query) {
            var _this2 = this;

            if (!this.unsplash) {
                return [];
            }
            return this.unsplash.search.getPhotos({
                query: query,
                page: this.searchResultsUpdates.page,
                perPage: this.pageSize
            }).then(function (res) {
                if (res.errors) {
                    console.log('error in retriving Unsplash data :', res.errors);
                    (0, _errorReporting.reportError)(new _errorReporting.StockDataRetrivalFailing('images-unsplash', res.errors));
                    return { results: [] };
                }

                if (_this2.config.debug) {
                    console.log('Usplash Api reponse :', res.response);
                }

                return res.response;
            }).catch(function (err) {
                _this2.config.debug && console.log('Error in unsplash request :', err);
                return [];
            });
        }

        // This search result need not be filtered , it was only true for offline search
        // The other one should be renamed
        /**
         *
         *
         * @param {*} {
         *         query='',
         *         tags=[],
         *         tagNames =['tags']
         *     }
         * @return {Array<{id,entry}>}
         * @memberof StockSearch
         */

    }, {
        key: 'search',
        value: async function search(_ref3) {
            var _this3 = this;

            var _ref3$query = _ref3.query,
                query = _ref3$query === undefined ? '' : _ref3$query,
                _ref3$tags = _ref3.tags,
                tags = _ref3$tags === undefined ? [] : _ref3$tags,
                _ref3$tagNames = _ref3.tagNames,
                tagNames = _ref3$tagNames === undefined ? [] : _ref3$tagNames,
                _ref3$more = _ref3.more,
                more = _ref3$more === undefined ? false : _ref3$more;

            try {
                if (!this.isIndexLoaded() || this.checkEmptyQuery({ query: query, tags: tags, tagNames: tagNames })) {
                    return {
                        relevantTags: {},
                        result: []
                    };
                }

                if (this.sameSearch({ query: query, tags: tags, tagNames: tagNames }, more)) {
                    return {
                        relevantTags: {},
                        result: this.searchResultsUpdates.list
                    };
                } else if (!more) {
                    // If its not the same search , and
                    // more of same same search is not required than
                    // get thepage number adjusted to 0
                    //
                    this.searchResultsUpdates.page = 0;
                    // this reset is also done in UpdateSearch , but doing makes sure
                    // that after a request for query is fired multiple times with high Page count
                    // the next request firing should not have the old page count , it should reset to 0
                }

                var imageSearchData = [],
                    videoSearchData = [];

                var searchImagePromise = _bluebird2.default.try(function () {
                    return _this3.searchImages(query);
                }).catch(function (err) {
                    console.error('Error fetching image stock data');
                    console.error(err);
                });

                var searchVideoPromise = _bluebird2.default.try(function () {
                    return (0, _UploadApi.searchVideos)(query, Math.max(_this3.searchResultsUpdates.page, 1));
                }).catch(function (err) {
                    console.error('Error fetching video stock data');
                    console.error(err);
                });

                var _ref4 = await _bluebird2.default.all([searchImagePromise, searchVideoPromise]),
                    _ref5 = _slicedToArray(_ref4, 2),
                    imageResults = _ref5[0],
                    videoResults = _ref5[1];

                if (imageResults && imageResults.results) {
                    imageSearchData = imageResults.results.map(function (i) {
                        return {
                            id: i.id,
                            modId: 'image_' + i.id,
                            type: _this3.mediaTypes.image,
                            snapshotUrl: i.urls.small,
                            viewUrl: i.urls.regular,
                            highResUrl: i.urls.raw,
                            metadata: i
                        };
                    });
                }

                if (videoResults && videoResults.data) {
                    var _videoResults$data = videoResults.data,
                        success = _videoResults$data.success,
                        _videoResults$data$vi = _videoResults$data.videos,
                        videos = _videoResults$data$vi === undefined ? [] : _videoResults$data$vi;

                    if (success) {
                        videoSearchData = videos.map(function (v) {
                            return {
                                id: v.id,
                                modId: 'video_' + v.id,
                                duration: v.duration,
                                type: _this3.mediaTypes.video,
                                snapshotUrl: v.thumbnail_image_url,
                                viewUrl: v.thumbnail_video_url,
                                highResUrl: v.full_video_url,
                                metadata: v
                            };
                        });
                    }
                }

                var results = [].concat(_toConsumableArray(imageSearchData), _toConsumableArray(videoSearchData));

                this.updateResults({ query: query, tags: tags, tagNames: tagNames }, results);
            } catch (err) {
                console.error('Failed to fetch stock data. Err :', err);
            }
            return {
                relevantTags: {},
                result: this.searchResultsUpdates.list
            };
        }
    }]);

    return StockSearch;
}(_BaseSearch3.default);

exports.default = StockSearch;

},{"../../../common/utils/errorReporting":101,"../../api/UploadApi":178,"./BaseSearch":238,"bluebird":389,"keymirror":677,"lodash":860,"unsplash-js":1211}],245:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _BaseSearch2 = require('./BaseSearch');

var _BaseSearch3 = _interopRequireDefault(_BaseSearch2);

var _lodash = require('lodash');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _editDistance = require('edit-distance');

var _editDistance2 = _interopRequireDefault(_editDistance);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var supportedTags = (0, _keymirror2.default)({
    TYPE: null,
    PROPORTION: null,
    RECENCY: null
});

var insert = function insert(node) {
    return 1;
};
var remove = function remove(node) {
    return 0;
};
var update = function update(stringA, stringB) {
    return stringA !== stringB ? 1 : 0;
};

// TODO This function needs an update to add the rest of the levenstein information
var stringMatch = (0, _lodash.memoize)(function (stringA, stringB) {
    return _editDistance2.default.levenshtein(stringA, stringB, insert, remove, update).distance;
}, function (stringA, stringB) {
    return stringA + stringB;
});

var indexData = {};
indexData[supportedTags.TYPE] = {
    PHOTO: function PHOTO(mediaItem) {
        return mediaItem.type === 'image';
    },
    VIDEO: function VIDEO(mediaItem) {
        return mediaItem.type === 'video';
    },
    SEQUENCE: function SEQUENCE(mediaItem) {
        return mediaItem.type === 'sequence';
    }
    // AUDIO : 0 // soon to be added Sequences
};

indexData[supportedTags.PROPORTION] = {
    POTRAIT: function POTRAIT(mediaItem) {
        if (mediaItem.height >= mediaItem.width) return true;
        return false;
    },
    LANDSCAPE: function LANDSCAPE(mediaItem) {
        if (mediaItem.height < mediaItem.width) return true;
        return false;
    }
};

var checkBefore = function checkBefore(time, range) {
    return Date.now() - new Date(time) > range;
};

indexData[supportedTags.RECENCY] = {
    YEAR: function YEAR(mediaItem) {
        return !checkBefore(mediaItem.createdTime, 1000 * 60 * 60 * 24 * 365);
    }, // does not account for leap year
    MONTH: function MONTH(mediaItem) {
        return !checkBefore(mediaItem.createdTime, 1000 * 60 * 60 * 24 * 30);
    },
    WEEK: function WEEK(mediaItem) {
        return !checkBefore(mediaItem.createdTime, 1000 * 60 * 60 * 24 * 7);
    }
};

var WorkspaceMediaSearch = function (_BaseSearch) {
    _inherits(WorkspaceMediaSearch, _BaseSearch);

    function WorkspaceMediaSearch(args) {
        _classCallCheck(this, WorkspaceMediaSearch);

        var _this = _possibleConstructorReturn(this, (WorkspaceMediaSearch.__proto__ || Object.getPrototypeOf(WorkspaceMediaSearch)).call(this, args));

        _this.indexLoaded = true;
        _this.filterable = indexData;
        _this.filterTagNames = Object.keys(_this.filterable);

        _this.audioList = [];
        _this.videoList = [];
        _this.imageList = [];

        _this.page = 0;

        _this.prevSearch = undefined;
        _this.prevQueryObj = undefined;

        _this.createPipeline = (0, _lodash.memoize)(_this._createPipeline, function (tags, tagNames, searchStr) {
            return tags.toString() + tagNames.toString() + searchStr;
        });
        return _this;
    }

    _createClass(WorkspaceMediaSearch, [{
        key: '_buildIndexInfo',
        value: async function _buildIndexInfo() {
            // this.baseUrl = '/api/workspace/wsquery'
            // console.log(baseUrl)
            // axios.post('http://localhost:3000/api/workspace/wsquery' ,
            //     { query : "cancer"}).then(response => {
            //     const data = response.data
            //     console.log(data)
            // })
        }
    }, {
        key: '_createPipeline',
        value: function _createPipeline() {
            var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var _this2 = this;

            var tagNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var searchStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var filters = [];
            try {
                var _loop = function _loop(i) {
                    var name = tagNames[i];
                    var taglist = tags[i].split(' ');
                    taglist.forEach(function (li) {
                        filters.push(_this2.filterable[name][li]);
                        // console.log(li , name)
                    });
                };

                for (var i = 0; i < tagNames.length; i++) {
                    _loop(i);
                }
            } catch (err) {
                console.log(err, 'something broke');
            }

            var filterFn = function filterFn(item) {
                // console.log(item)
                var filterState = filters.length === 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var fn = _step.value;

                        filterState = filterState || fn(item);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return filterState;
            };

            var computeMetric = function computeMetric(item) {
                return stringMatch(item.originalFileName.toLowerCase().trim(), searchStr.toLowerCase().trim());
            };

            var sortFn = function sortFn(itemA, itemB) {
                return itemA.metric - itemB.metric;
            };
            // Using edit distance for rellative ranking
            return function () {
                var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                if (!items) {
                    return [];
                }
                items = items.filter(filterFn);
                if (searchStr.trim() !== '') {
                    // console.log(searchStr)

                    var intermediate = (0, _lodash.sortBy)(items, function (item) {
                        return computeMetric(item);
                    });
                    // items.map(value => ({value , metric: computeMetric(value)})).sort(sortFn)
                    // console.log(intermediate)
                    items = intermediate;
                    //intermediate.map(obj => obj.value)
                }

                return items;
            };
        }
    }, {
        key: 'sameSearch',
        value: function sameSearch(obj) {
            if ((0, _lodash.isEqual)(obj, this.prevQueryObj)) return true;
            this.prevQueryObj = obj;
        }

        // afterSerch(data){
        //     this.audioList = unionBy( data.audios.map((v , i) => { return { ...v , score: data.audios.length - i}}) , this.audioList , 'id' )
        //     this.videoList = unionBy( data.videos.map((v , i) => { return { ...v , score: data.videos.length - i}}) , this.videoList , 'id' )
        //     this.imageList = unionBy( data.images.map((v , i) => { return { ...v , score: data.images.length - i}}) , this.imageList , 'id')
        //     this.page+=1/// reset the query for page
        // }

        // resetResults(){
        //     this.audioList = []
        //     this.imageList = []
        //     this.videoList = []
        // }

    }, {
        key: 'getDefaultSearch',
        value: function getDefaultSearch() {
            var otherArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.search(_extends({}, otherArgs));
        }
    }, {
        key: 'search',
        value: async function search(_ref) {
            var _ref$query = _ref.query,
                query = _ref$query === undefined ? '' : _ref$query,
                _ref$tags = _ref.tags,
                tags = _ref$tags === undefined ? [] : _ref$tags,
                _ref$tagNames = _ref.tagNames,
                tagNames = _ref$tagNames === undefined ? [] : _ref$tagNames,
                more = _ref.more;

            // console.log({
            //     prevSearch: this.prevSearch,
            //     query : query,
            //     more,
            //     tags,
            //     tagNames
            // })

            // if(this.sameSearch({query , tags , tagNames})){
            //     return {
            //         relevantTags : {},
            //         result: {
            //             pipeline: this.createPipeline(tags , tagNames),
            //             audios: this.audioList,
            //             videos:this.videoList,
            //             images: this.imageList,

            //         }
            //     }
            // }

            var _ref2 = await Promise.all([this.createPipeline(tags, tagNames, query)]

            // axios.post(`${this.baseUrl}` ,
            // {   query: query ,
            //     page:this.page,
            //     tags,
            //     tagNames
            // })
            // .catch(err => {
            //     console.log(err)
            //     return []
            // })
            ),
                _ref3 = _slicedToArray(_ref2, 2),
                pipeline = _ref3[0],
                result = _ref3[1];

            // const data = result.data.package.result

            // this.afterSerch(data)
            // change tags here

            // this.prevSearch = query

            return {
                relevantTags: {},
                result: {
                    pipeline: pipeline
                    // audios: this.audioList,
                    // videos:this.videoList,
                    // images: this.imageList
                }
            };
        }
    }, {
        key: 'getTagList',
        value: function getTagList(tagName) {
            var obj = this.filterable[tagName] || {};
            return Object.keys(obj).sort(function (k1, k2) {
                return obj[k1] - obj[k2];
            });
        }
    }, {
        key: 'getFilterTags',
        value: function getFilterTags() {
            return this.filterTagNames;
        }
    }, {
        key: 'isIndexLoaded',
        value: function isIndexLoaded() {
            return true;
        }
    }, {
        key: 'isOnlineSearch',
        value: function isOnlineSearch() {
            return true;
        }
    }]);

    return WorkspaceMediaSearch;
}(_BaseSearch3.default);

exports.default = WorkspaceMediaSearch;

},{"./BaseSearch":238,"axios":335,"edit-distance":584,"keymirror":677,"lodash":860}],246:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequestRoleChangeActionType = exports.ShopifyActionType = exports.WatermarkActionType = exports.VideoCreditActionType = exports.CreditActionType = exports.SubscriptionActionType = exports.PaymentActionType = exports.ActivationActionType = exports.ExportActionType = undefined;
exports.backToProject = backToProject;
exports.goHome = goHome;
exports.cancelExport = cancelExport;
exports.updateSrtAvailable = updateSrtAvailable;
exports.updateStatus = updateStatus;
exports.updatePercent = updatePercent;
exports.updateThumbnail = updateThumbnail;
exports.trackVideoPublished = trackVideoPublished;
exports.fetchDownloadUrl = fetchDownloadUrl;
exports.fetchWatermarkedDownloadUrl = fetchWatermarkedDownloadUrl;
exports.fetchSubtitleDownloadUrl = fetchSubtitleDownloadUrl;
exports.initiateDownloadVideo = initiateDownloadVideo;
exports.requestNotify = requestNotify;
exports.openPaymentFlow = openPaymentFlow;
exports.openPayFromSubscriptionFlow = openPayFromSubscriptionFlow;
exports.openPayUsingCreditsFlow = openPayUsingCreditsFlow;
exports.openPayUsingVideoCreditsFlow = openPayUsingVideoCreditsFlow;
exports.subscriptionCheckoutSuccess = subscriptionCheckoutSuccess;
exports.subscriptionCheckoutFailed = subscriptionCheckoutFailed;
exports.stripeTokenReceived = stripeTokenReceived;
exports.payUsingSavedCard = payUsingSavedCard;
exports.watermarkRemoved = watermarkRemoved;
exports.paymentSuccess = paymentSuccess;
exports.paymentFailed = paymentFailed;
exports.paymentClearError = paymentClearError;
exports.abortPayment = abortPayment;
exports.openActivationModal = openActivationModal;
exports.openWatermarkModal = openWatermarkModal;
exports.closeWatermarkModal = closeWatermarkModal;
exports.resendActivationMail = resendActivationMail;
exports.closeActivationModal = closeActivationModal;
exports.accountActivated = accountActivated;
exports.updatePlanInfo = updatePlanInfo;
exports.makePayment = makePayment;
exports.useWatermarkedVersion = useWatermarkedVersion;
exports.checkoutUsingSubscription = checkoutUsingSubscription;
exports.checkoutUsingCredits = checkoutUsingCredits;
exports.checkoutUsingVideoCredits = checkoutUsingVideoCredits;
exports.initPaymentForProject = initPaymentForProject;
exports.doWithVideo = doWithVideo;
exports.proceedWithAction = proceedWithAction;
exports.checkActivationAndProceed = checkActivationAndProceed;
exports.downloadVideo = downloadVideo;
exports.downloadSubtitle = downloadSubtitle;
exports.publishToYoutube = publishToYoutube;
exports.postToFacebook = postToFacebook;
exports.justRemoveWatermark = justRemoveWatermark;
exports.updateIntercomData = updateIntercomData;
exports.creditCheckoutSuccess = creditCheckoutSuccess;
exports.videoCreditCheckoutSuccess = videoCreditCheckoutSuccess;
exports.creditCheckoutFailed = creditCheckoutFailed;
exports.videoCreditCheckoutFailed = videoCreditCheckoutFailed;
exports.hideShopifyReviewModal = hideShopifyReviewModal;
exports.openRequestRoleChangeModal = openRequestRoleChangeModal;
exports.RoleChangeRequest = RoleChangeRequest;
exports.closeRequestRoleChangeModal = closeRequestRoleChangeModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _notifyjs = require('notifyjs');

var _notifyjs2 = _interopRequireDefault(_notifyjs);

var _ExportPageApi = require('../apis/ExportPageApi');

var _constants = require('../constants');

var _utils = require('../utils');

var _youtubeActions = require('./youtubeActions');

var _facebookActions = require('./facebookActions');

var facebookActions = _interopRequireWildcard(_facebookActions);

var _trackingUtils = require('../trackingUtils');

var _userApi = require('../../common/api/userApi');

var _TrackUtils = require('../../common/utils/TrackUtils');

var _constants2 = require('../../common/constants');

var _pricingActions = require('../../pricing/actions/pricingActions');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Notify = _notifyjs2.default.default;

var ExportActionType = exports.ExportActionType = (0, _keymirror2.default)({
    UPDATE_EXPORT_STATUS: null,
    UPDATE_EXPORT_PERCENT: null,
    UPDATE_EXPORT_THUMBNAIL: null,
    DOWNLOAD_STARTING: null,
    DOWNLOAD_STARTED: null,
    SUBTITLE_DOWNLOAD_STARTING: null,
    SUBTITLE_DOWNLOAD_STARTED: null,
    NOTIFY_STATE_CHANGE: null,
    UPDATE_USER_PLAN_INFO: null,
    UPDATE_SRT_AVAILABLE: null
});

var ActivationActionType = exports.ActivationActionType = (0, _keymirror2.default)({
    ACTIVATION_OPEN: null,
    SENDING_ACTIVATION_MAIL: null,
    ACTIVATION_CLOSE: null,
    ACTIVATION_ERROR: null,
    ALREADY_ACTIVATED: null,
    ACCOUNT_ACTIVATED: null,
    MAIL_SENT: null
});

var PaymentActionType = exports.PaymentActionType = {
    PAYMENT_CHECKING: 'OTP_PAYMENT_CHECKING',
    PAYMENT_OPEN_FLOW: 'OTP_PAYMENT_OPEN_FLOW',
    PAYMENT_USE_TOKEN: 'OTP_PAYMENT_USE_TOKEN',
    PAYMENT_USE_SAVED_CARD: 'OTP_PAYMENT_USE_SAVED_CARD',
    PAYMENT_SUCCESS: 'OTP_PAYMENT_SUCCESS',
    PAYMENT_FAILED: 'OTP_PAYMENT_ERROR',
    PAYMENT_COMPLETE_FLOW: 'OTP_PAYMENT_COMPLETE_FLOW',
    PAYMENT_ABORT_FLOW: 'OTP_PAYMENT_ABORT_FLOW',
    PAYMENT_CLEARING_ERROR: 'OTP_PAYMENT_CLEARING_ERROR'
};

var SubscriptionActionType = exports.SubscriptionActionType = (0, _keymirror2.default)({
    SUBSCRIPTION_CHECKING: null,
    CHECKOUT_SUCCESS: null,
    SUBSCRIPTION_COMPLETE_FLOW: null,
    CHECKOUT_FAILED: null
});

var CreditActionType = exports.CreditActionType = (0, _keymirror2.default)({
    CREDIT_CHECKING: null,
    CREDIT_CHECKOUT_SUCCESS: null,
    CREDIT_COMPLETE_FLOW: null,
    CREDIT_CHECKOUT_FAILED: null
});

var VideoCreditActionType = exports.VideoCreditActionType = (0, _keymirror2.default)({
    VIDEO_CREDIT_CHECKING: null,
    VIDEO_CREDIT_CHECKOUT_SUCCESS: null,
    VIDEO_CREDIT_COMPLETE_FLOW: null,
    VIDEO_CREDIT_CHECKOUT_FAILED: null
});

var WatermarkActionType = exports.WatermarkActionType = (0, _keymirror2.default)({
    WTM_WATERMARK_REMOVED: null,
    WTM_CLOSE_MODAL: null,
    WTM_OPEN_MODAL: null
});

var ShopifyActionType = exports.ShopifyActionType = (0, _keymirror2.default)({
    SHOW_REVIEW_MODAL: null,
    RECEIVED_EXTRA_CREDITS: null,
    HIDE_REVIEW_MODAL: null
});

var RequestRoleChangeActionType = exports.RequestRoleChangeActionType = (0, _keymirror2.default)({
    OPEN: null,
    CLOSE: null,
    REQUEST_SUCCESS: null,
    REQUEST_ERROR: null
});

function backToProject() {
    return function (dispatch, getState) {
        var _getState = getState(),
            projectId = _getState.projectData.projectId;

        window.location.href = '/edit/' + projectId;
    };
}

function goHome() {
    return function (dispatch, getState) {
        window.location.href = '/home';
    };
}

function cancelExport() {
    return function (dispatch, getState) {
        var _getState2 = getState(),
            exportId = _getState2.exportdata.exportId,
            _getState2$projectDat = _getState2.projectData,
            projectId = _getState2$projectDat.projectId,
            workspaceId = _getState2$projectDat.workspaceId;

        tracker.trackOnHeap('Clicked on Cancel export', {
            workspaceId: workspaceId,
            projectId: projectId,
            exportId: exportId
        });
        dispatch(backToProject());

        (0, _ExportPageApi.cancelExportP)(exportId).catch(function (err) {
            console.error(err);
        });
    };
}

function updateSrtAvailable(srtAvailable) {
    return { type: ExportActionType.UPDATE_SRT_AVAILABLE, srtAvailable: srtAvailable };
}

function updateStatus(status) {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            _getState3$projectDat = _getState3.projectData,
            projectId = _getState3$projectDat.projectId,
            projectName = _getState3$projectDat.projectName,
            _getState3$userData$n = _getState3.userData.needSegmentationInfo,
            needSegmentationInfo = _getState3$userData$n === undefined ? false : _getState3$userData$n,
            _getState3$exportdata = _getState3.exportdata.isProgressPage,
            isProgressPage = _getState3$exportdata === undefined ? false : _getState3$exportdata;

        dispatch({ type: ExportActionType.UPDATE_EXPORT_STATUS, status: status });

        var uiStatus = (0, _utils.exsToUIState)(status);

        if (uiStatus == _constants.ExportUIState.READY && !needSegmentationInfo && isProgressPage) {
            var _getState4 = getState(),
                notifyState = _getState4.uiState.notifyState,
                oldStatus = _getState4.exportdata.exportStatus;

            if (notifyState == _constants.ExportNotifyState.SCHEDULED) {
                setTimeout(function () {
                    if (document.visibilityState != 'visible') {
                        var notification = new Notify('Export Ready!', {
                            body: 'Check out your video for ' + projectName,
                            icon: '/images/logo-icon@2x.png',
                            notifyClick: function notifyClick() {
                                window.focus();
                                notification.close();
                            }
                        });
                        notification.show();
                    }
                }, 2000);
            }

            if (isProgressPage) {
                (0, _TrackUtils.trackOnSmartlook)('Export Completed', {
                    'Project id': projectId,
                    'Project Name': projectName
                });
                window.location.assign('/export/' + projectId);
            }
        } else if (uiStatus != _constants.ExportUIState.READY || needSegmentationInfo) {
            if (!isProgressPage) {
                window.location.assign('/progress/' + projectId);
            }
        }
    };
}

function updatePercent(percent) {
    return { type: ExportActionType.UPDATE_EXPORT_PERCENT, percent: percent };
}

function updateThumbnail(url) {
    return { type: ExportActionType.UPDATE_EXPORT_THUMBNAIL, url: url };
}

function trackVideoPublished() {
    var publishType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var projectId = arguments[1];

    (0, _TrackUtils.trackOnSmartlook)('Video Published', {
        type: publishType,
        'Project Id': projectId
    });

    if (typeof ga !== 'undefined') {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Conversion',
            eventAction: 'Video Published',
            eventLabel: publishType
        });
    }
}

function fetchDownloadUrl() {
    return function (dispatch, getState) {
        var _getState$exportdata = getState().exportdata,
            exportId = _getState$exportdata.exportId,
            projectId = _getState$exportdata.projectId,
            _getState$exportdata$ = _getState$exportdata.shouldReceiveVideoCredits,
            shouldReceiveVideoCredits = _getState$exportdata$ === undefined ? false : _getState$exportdata$;

        dispatch({ type: ExportActionType.DOWNLOAD_STARTING });

        (0, _ExportPageApi.getDownloadUrlP)(exportId).then(function (downloadUrl) {
            trackVideoPublished('download', projectId);
            // This will initiate the download
            window.location.assign(downloadUrl);
        }).catch(function (err) {
            console.error(err);
        }).finally(function () {
            dispatch({ type: ExportActionType.DOWNLOAD_STARTED });

            if (shouldReceiveVideoCredits) {
                (0, _ExportPageApi.addShopifyVideoCreditsP)().then(function (result) {
                    var success = result.success,
                        _result$error_code = result.error_code,
                        error_code = _result$error_code === undefined ? '' : _result$error_code;

                    if (success) {
                        setTimeout(function () {
                            dispatch({ type: ShopifyActionType.RECEIVED_EXTRA_CREDITS });
                            dispatch({ type: ShopifyActionType.SHOW_REVIEW_MODAL });
                            if (typeof tracker !== 'undefined') {
                                tracker.trackOnHeap('Shopify Review Modal Opened');
                            }
                        }, 3000);
                    } else {
                        console.error(error_code);
                    }
                }).catch(function (err) {
                    console.error(err);
                });
            }
        });
    };
}

function fetchWatermarkedDownloadUrl() {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            exportId = _getState5.exportdata.exportId,
            projectId = _getState5.projectData.projectId;

        dispatch({ type: ExportActionType.DOWNLOAD_STARTING });

        (0, _ExportPageApi.getWatermarkedDownloadUrlP)(exportId).then(function (downloadUrl) {
            trackVideoPublished('download', projectId);
            // This will initiate the download
            window.location.assign(downloadUrl);
        }).catch(function (err) {
            console.error(err);
        }).finally(function () {
            dispatch({ type: ExportActionType.DOWNLOAD_STARTED });
        });
    };
}

function fetchSubtitleDownloadUrl() {
    return function (dispatch, getState) {
        var exportId = getState().exportdata.exportId;

        dispatch({ type: ExportActionType.SUBTITLE_DOWNLOAD_STARTING });

        (0, _ExportPageApi.getSubtitleDownloadUrlP)(exportId).then(function (downloadUrl) {
            // This will initiate the download
            window.location.assign(downloadUrl);
        }).catch(function (err) {
            console.error(err);
        }).finally(function () {
            dispatch({ type: ExportActionType.SUBTITLE_DOWNLOAD_STARTED });
        });
    };
}

function initiateDownloadVideo() {
    return function (dispatch, getState) {
        dispatch({
            type: PaymentActionType.PAYMENT_CHECKING,
            postCheckAction: 'download'
        });
    };
}

function requestNotify() {
    return function (dispatch, getState) {
        dispatch({
            type: ExportActionType.NOTIFY_STATE_CHANGE,
            ens: _constants.ExportNotifyState.REQUESTED
        });

        if (Notify.needsPermission) {
            Notify.requestPermission(function () {
                // Permission granted
                dispatch({
                    type: ExportActionType.NOTIFY_STATE_CHANGE,
                    ens: _constants.ExportNotifyState.SCHEDULED
                });
            }, function () {
                // Permission denied
                dispatch({
                    type: ExportActionType.NOTIFY_STATE_CHANGE,
                    ens: _constants.ExportNotifyState.PERMISSION_DENIED
                });
            });
        } else {
            dispatch({
                type: ExportActionType.NOTIFY_STATE_CHANGE,
                ens: _constants.ExportNotifyState.SCHEDULED
            });
        }
    };
}

function openPaymentFlow(postCheckAction, postCheckActionArgs, errorType, errorMessage) {
    return {
        type: PaymentActionType.PAYMENT_OPEN_FLOW,
        postCheckAction: postCheckAction,
        postPaymentActionArgs: postCheckActionArgs,
        errorType: errorType,
        errorMessage: errorMessage
    };
}

function openPayFromSubscriptionFlow(postCheckAction, postCheckActionArgs) {
    return {
        type: SubscriptionActionType.SUBSCRIPTION_CHECKING,
        postCheckAction: postCheckAction,
        postSubscriptionCheckoutActionArgs: postCheckActionArgs
    };
}

function openPayUsingCreditsFlow(postCheckAction, postCheckActionArgs) {
    return {
        type: CreditActionType.CREDIT_CHECKING,
        postCheckAction: postCheckAction,
        postCreditCheckoutActionArgs: postCheckActionArgs
    };
}

function openPayUsingVideoCreditsFlow(postCheckAction, postCheckActionArgs) {
    return {
        type: VideoCreditActionType.VIDEO_CREDIT_CHECKING,
        postCheckAction: postCheckAction,
        postCreditCheckoutActionArgs: postCheckActionArgs
    };
}

function subscriptionCheckoutSuccess() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        (0, _TrackUtils.trackOnSmartlook)('Removed watermark', {
            'Removed via': 'Subscription',
            'PPV cost': 'NA',
            'Credits used': 0,
            sourceView: (0, _constants2.getSourceView)()
        });

        dispatch({ type: SubscriptionActionType.CHECKOUT_SUCCESS });

        dispatch(updateIntercomData());

        dispatch(watermarkRemoved());

        dispatch({ type: SubscriptionActionType.SUBSCRIPTION_COMPLETE_FLOW });

        dispatch(checkActivationAndProceed(postCheckAction));
    };
}

function subscriptionCheckoutFailed(errorType) {
    var postCheckAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var postSubscriptionCheckoutActionArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return {
        type: SubscriptionActionType.CHECKOUT_FAILED,
        errorType: errorType,
        postCheckAction: postCheckAction,
        postSubscriptionCheckoutActionArgs: postSubscriptionCheckoutActionArgs
    };
}

function stripeTokenReceived(paymentData) {
    var tokenId = paymentData.tokenId,
        _paymentData$shouldSa = paymentData.shouldSaveToken,
        shouldSaveToken = _paymentData$shouldSa === undefined ? false : _paymentData$shouldSa,
        _paymentData$cardLast = paymentData.cardLast4,
        cardLast4 = _paymentData$cardLast === undefined ? null : _paymentData$cardLast,
        _paymentData$cardBran = paymentData.cardBrand,
        cardBrand = _paymentData$cardBran === undefined ? null : _paymentData$cardBran;

    return {
        type: PaymentActionType.PAYMENT_USE_TOKEN,
        tokenId: tokenId,
        shouldSaveToken: shouldSaveToken,
        cardLast4: cardLast4,
        cardBrand: cardBrand
    };
}

function payUsingSavedCard() {
    return { type: PaymentActionType.PAYMENT_USE_SAVED_CARD };
}

function watermarkRemoved() {
    return { type: WatermarkActionType.WTM_WATERMARK_REMOVED };
}

function paymentSuccess() {
    var alreadyPaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        if (!alreadyPaid) {
            (0, _TrackUtils.trackOnSmartlook)('Removed watermark', {
                'Removed via': 'Subscription',
                'PPV cost': 'NA',
                'Credits used': 0,
                sourceView: (0, _constants2.getSourceView)()
            });
        }
        dispatch({ type: PaymentActionType.PAYMENT_SUCCESS });

        dispatch(updateIntercomData());

        dispatch(watermarkRemoved());

        setTimeout(function () {
            // To show the payment success UI for a while
            dispatch({ type: PaymentActionType.PAYMENT_COMPLETE_FLOW });

            dispatch(checkActivationAndProceed(postCheckAction));
        }, 2000);
    };
}

function paymentFailed(errorType, errorMessage) {
    var postCheckAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var postPaymentActionArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return {
        type: PaymentActionType.PAYMENT_FAILED,
        errorType: errorType,
        errorMessage: errorMessage,
        postCheckAction: postCheckAction,
        postPaymentActionArgs: postPaymentActionArgs
    };
}

function paymentClearError() {
    return function (dispatch, getState) {
        var state = getState();
        var _state$uiState = state.uiState,
            postCheckAction = _state$uiState.postCheckAction,
            postPaymentActionArgs = _state$uiState.postPaymentActionArgs;

        var projectId = void 0;
        if (state.projectData) projectId = projectData.projectId;else projectId = state.project.id;

        dispatch({ type: PaymentActionType.PAYMENT_CLEARING_ERROR });

        (0, _ExportPageApi.clearPaymentErrorP)(projectId).then(function (response) {
            if (response.success) {
                dispatch(openPaymentFlow(postCheckAction, postPaymentActionArgs));
            }
        });
    };
}

function abortPayment() {
    return { type: PaymentActionType.PAYMENT_ABORT_FLOW };
}
function openActivationModal(postCheckAction) {
    return { type: ActivationActionType.ACTIVATION_OPEN, postCheckAction: postCheckAction };
}

function openWatermarkModal(postWatermarkCheckAction) {
    return function (dispatch, getState) {
        var state = getState();

        var isShopifyUser = false;

        var activeWorkspace = state.workspaceInfo.activeWorkspace;
        var planType = activeWorkspace.planType,
            planConfig = activeWorkspace.planConfig;

        var isPpvEnabled = planConfig.hasOwnProperty('ppvEnabled') && !!planConfig.ppvEnabled;

        if (state.userData) {
            // planType = state.planInfo.planType;
            isShopifyUser = state.userData.isShopifyUser;
        } else if (state.project) {
            // TODO better differentiator for edit page
            // planType = state.workspaceInfo.activeWorkspace.planType;
            isShopifyUser = state.ui.isShopifyUser;
        }

        if (!isPpvEnabled && planType === 'PPV' && !postWatermarkCheckAction) {
            dispatch((0, _pricingActions.openPlanModal)(postWatermarkCheckAction));
        } else {
            dispatch({
                type: WatermarkActionType.WTM_OPEN_MODAL,
                postCheckAction: postWatermarkCheckAction
            });
        }
    };
}

function closeWatermarkModal() {
    return { type: WatermarkActionType.WTM_CLOSE_MODAL };
}

function resendActivationMail() {
    return function (dispatch, getState) {
        dispatch({ type: ActivationActionType.SENDING_ACTIVATION_MAIL });
        var userEmail = getState().userData.userEmail;

        (0, _ExportPageApi.resendActivationMailP)(userEmail).then(function (response) {
            if (response.success) {
                var result = response.result;

                if (result == 'invalid_email' || result == 'user_unknown' || result == 'email_send_error' || result == 'invalid_format_email') {
                    dispatch({ type: ActivationActionType.ACTIVATION_ERROR });
                } else if (result == 'already_activated') {
                    dispatch({ type: ActivationActionType.ALREADY_ACTIVATED });
                } else if (result == 'email_send_success') {
                    dispatch({ type: ActivationActionType.MAIL_SENT });
                }
            } else {
                dispatch({ type: ActivationActionType.ACTIVATION_ERROR });
                logger.error('Error sending activation mail');
                throw new Error(response.message);
            }
        }).catch(function (err) {
            logger.error(err);
        });
    };
}
function closeActivationModal() {
    return { type: ActivationActionType.ACTIVATION_CLOSE };
}

function accountActivated() {
    return function (dispatch, getState) {
        dispatch(closeActivationModal());
        dispatch({ type: ActivationActionType.ACCOUNT_ACTIVATED });
    };
}

function updatePlanInfo(planInfo) {
    return { type: ExportActionType.UPDATE_USER_PLAN_INFO, planInfo: planInfo };
}

function makePayment() {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        dispatch({
            type: PaymentActionType.PAYMENT_OPEN_FLOW,
            postCheckAction: action
        });
    };
}

function useWatermarkedVersion() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        dispatch(closeWatermarkModal());

        dispatch(checkActivationAndProceed(postCheckAction));
    };
}

function checkoutUsingSubscription() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        dispatch(closeWatermarkModal());

        dispatch({
            type: SubscriptionActionType.SUBSCRIPTION_CHECKING,
            postCheckAction: postCheckAction
        });
    };
}

function checkoutUsingCredits() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        dispatch(closeWatermarkModal());

        dispatch({
            type: CreditActionType.CREDIT_CHECKING,
            postCheckAction: postCheckAction
        });
    };
}

function checkoutUsingVideoCredits() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        dispatch(closeWatermarkModal());

        dispatch({
            type: VideoCreditActionType.VIDEO_CREDIT_CHECKING,
            postCheckAction: postCheckAction
        });
    };
}

function initPaymentForProject() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        dispatch(closeWatermarkModal());

        dispatch(makePayment(postCheckAction));
    };
}

function doWithBrandedVideo() {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        if (!action) {
            // Nothing (just removed branding probably)
        } else if (action === 'download') {
            dispatch(fetchWatermarkedDownloadUrl());
        } else if (action === 'downloadSubtitle') {
            dispatch(fetchSubtitleDownloadUrl());
        } else if (action === 'ytpublish') {
            dispatch((0, _youtubeActions.openYoutubePublishModal)());
        } else if (action === 'fbupload') {
            dispatch(facebookActions.openFacebookUploadModal());
        }
    };
}

function doWithVideo() {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        if (!action) {
            // Nothing (just removed branding probably)
        } else if (action === 'download') {
            dispatch(fetchDownloadUrl());
        } else if (action === 'downloadSubtitle') {
            dispatch(fetchSubtitleDownloadUrl());
        } else if (action === 'ytpublish') {
            dispatch((0, _youtubeActions.openYoutubePublishModal)());
        } else if (action === 'fbupload') {
            dispatch(facebookActions.openFacebookUploadModal());
        }
    };
}

function proceedWithAction() {
    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        var state = getState();
        var containsWatermark = true;
        if (state.exportdata) {
            containsWatermark = state.exportdata.containsWatermark;
        } else if (state.project) {
            // for Edit page
            containsWatermark = state.project.containsWatermark;
        }

        if (containsWatermark) {
            dispatch(doWithBrandedVideo(action));
        } else {
            dispatch(doWithVideo(action));
        }
    };
}

function checkActivationAndProceed() {
    var postActivationCheckAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        var state = getState();
        var containsWatermark = true;

        if (state.exportdata) {
            containsWatermark = state.exportdata.containsWatermark;
        } else if (state.project) {
            // for Edit page
            containsWatermark = state.project.containsWatermark;
        }
        // const { containsWatermark } = getState().exportdata;

        var isActivated = true;
        if (state.userData) isActivated = state.userData.isActivated;else if (state.ui) isActivated = state.ui.isActivated;

        if (isActivated) {
            // Proceed with action
            dispatch(proceedWithAction(postActivationCheckAction));
        } else {
            // open activation modal
            dispatch(openActivationModal(postActivationCheckAction));
        }
    };
}

function checkWatermarkAndProceed() {
    var postWatermarkCheckAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return function (dispatch, getState) {
        var state = getState();
        var containsWatermark = true;

        if (state.exportdata) {
            containsWatermark = state.exportdata.containsWatermark;
        } else if (state.project) {
            // for Edit page
            containsWatermark = state.project.containsWatermark;
        }

        if (!containsWatermark) {
            // proceed to watermark check
            dispatch(checkActivationAndProceed(postWatermarkCheckAction));
        } else {
            // proceed to payment request
            dispatch(openWatermarkModal(postWatermarkCheckAction));
        }
    };
}

function downloadVideo() {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            _getState6$userData$c = _getState6.userData.canProduceVideo,
            canProduceVideo = _getState6$userData$c === undefined ? false : _getState6$userData$c;

        if (canProduceVideo) {
            dispatch(checkWatermarkAndProceed('download'));
        } else {
            dispatch(openRequestRoleChangeModal('Download Video'));
        }
    };
}

function downloadSubtitle() {
    return function (dispatch, getState) {
        return dispatch(checkActivationAndProceed('downloadSubtitle'));
    };
}

function publishToYoutube() {
    return function (dispatch, getState) {
        var _getState7 = getState(),
            _getState7$userData$c = _getState7.userData.canProduceVideo,
            canProduceVideo = _getState7$userData$c === undefined ? false : _getState7$userData$c;

        if (canProduceVideo) {
            dispatch(checkWatermarkAndProceed('ytpublish'));
        } else {
            dispatch(openRequestRoleChangeModal('Publish Video'));
        }
    };
}

function postToFacebook() {
    return function (dispatch, getState) {
        var _getState8 = getState(),
            _getState8$userData$c = _getState8.userData.canProduceVideo,
            canProduceVideo = _getState8$userData$c === undefined ? false : _getState8$userData$c;

        if (canProduceVideo) {
            dispatch(checkWatermarkAndProceed('fbupload'));
        } else {
            dispatch(openRequestRoleChangeModal('Publish Video'));
        }
    };
}

function justRemoveWatermark() {
    return function (dispatch, getState) {
        var state = getState();
        var canProduceVideo = false;
        if (!!state.userData.canProduceVideo) {
            canProduceVideo = !!state.userData.canProduceVideo;
        } else if (state.project) {
            // TODO better differentiator for edit page
            var activeWorkspace = state.workspaceInfo.activeWorkspace;

            canProduceVideo = activeWorkspace && (activeWorkspace.role === 'ADMIN' || activeWorkspace.role === 'PRODUCER');
        }

        if (canProduceVideo) {
            dispatch(checkWatermarkAndProceed(null));
        } else {
            dispatch(openRequestRoleChangeModal('Remove Watermark'));
        }
    };
}

function updateIntercomData() {
    return function (dispatch, getState) {
        return (0, _userApi.getAccountDetailsP)().then(function (accountData) {
            var _accountData$ppvData = accountData.ppvData,
                _accountData$ppvData$ = _accountData$ppvData.ppvLifetimeVideos,
                ppvLifetimeVideos = _accountData$ppvData$ === undefined ? 0 : _accountData$ppvData$,
                _accountData$ppvData$2 = _accountData$ppvData.ppvLifetimeSpend,
                ppvLifetimeSpend = _accountData$ppvData$2 === undefined ? 0 : _accountData$ppvData$2,
                planType = accountData.planData.planType,
                _accountData$userData = accountData.userData.isUserEligibleForLicense,
                isUserEligibleForLicense = _accountData$userData === undefined ? false : _accountData$userData;

            var isPaidWorkspace = planType == 'SUB' || planType == 'LIC';

            // if (!!window.Intercom && intercomEnabled) {
            //     window.Intercom('update', {
            //         ppvLifetimeVideos,
            //         ppvLifetimeSpend,
            //         userEligibleForLicense: isUserEligibleForLicense && !isPaidWorkspace,
            //     });
            // }

            (0, _TrackUtils.updateUserOnFreshChat)({
                ppvLifetimeVideos: ppvLifetimeVideos,
                ppvLifetimeSpend: ppvLifetimeSpend,
                userEligibleForLicense: isUserEligibleForLicense && !isPaidWorkspace
            });
        }).catch(function (err) {
            logger.error('Error updating Intercom data ' + err);
        });
    };
}

function creditCheckoutSuccess() {
    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        (0, _TrackUtils.trackOnSmartlook)('Removed watermark', {
            'Removed via': 'One time payment',
            'PPV cost': '$15',
            'Credits used': '$15',
            sourceView: (0, _constants2.getSourceView)()
        });
        dispatch({ type: CreditActionType.CREDIT_CHECKOUT_SUCCESS });

        dispatch(updateIntercomData());

        dispatch(watermarkRemoved());

        dispatch({ type: CreditActionType.CREDIT_COMPLETE_FLOW });

        dispatch(checkActivationAndProceed(postCheckAction));
    };
}

function videoCreditCheckoutSuccess() {
    var alreadyPaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch, getState) {
        var postCheckAction = getState().uiState.postCheckAction;

        if (!alreadyPaid) {
            (0, _TrackUtils.trackOnSmartlook)('Removed watermark', {
                'Removed via': 'Video Credits',
                'PPV cost': 0,
                'Credits used': 0,
                sourceView: (0, _constants2.getSourceView)()
            });
        }
        dispatch({ type: VideoCreditActionType.VIDEO_CREDIT_CHECKOUT_SUCCESS });

        dispatch(updateIntercomData());

        dispatch(watermarkRemoved());

        dispatch({ type: VideoCreditActionType.VIDEO_CREDIT_COMPLETE_FLOW });

        dispatch(checkActivationAndProceed(postCheckAction));
    };
}

function creditCheckoutFailed(errorType) {
    var postCheckAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var postCreditCheckoutActionArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return {
        type: CreditActionType.CREDIT_CHECKOUT_FAILED,
        errorType: errorType,
        postCheckAction: postCheckAction,
        postCreditCheckoutActionArgs: postCreditCheckoutActionArgs
    };
}

function videoCreditCheckoutFailed(errorType) {
    var postCheckAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var postCreditCheckoutActionArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return {
        type: VideoCreditActionType.VIDEO_CREDIT_CHECKOUT_FAILED,
        errorType: errorType,
        postCheckAction: postCheckAction,
        postCreditCheckoutActionArgs: postCreditCheckoutActionArgs
    };
}

function hideShopifyReviewModal() {
    return { type: ShopifyActionType.HIDE_REVIEW_MODAL };
}

function openRequestRoleChangeModal(rrcModalMsg) {
    return function (dispatch, getState) {
        dispatch({ type: RequestRoleChangeActionType.OPEN, rrcModalMsg: rrcModalMsg });
    };
}

function RoleChangeRequest() {
    return function (dispatch, getState) {
        var state = getState();

        var workspaceId = void 0;
        if (!!state.workspaceInfo && !!state.workspaceInfo.activeWorkspace && !!state.workspaceInfo.activeWorkspace.workspaceId) workspaceId = state.workspaceInfo.activeWorkspace.workspaceId;else {
            var wId = state.projectData.workspaceId;

            workspaceId = wId;
        }

        return (0, _ExportPageApi.roleChangeRequestP)(workspaceId).then(function (res) {
            if (res.success) {
                dispatch({ type: RequestRoleChangeActionType.REQUEST_SUCCESS });

                tracker.trackOnHeap('Role Change Requested', {
                    workspaceId: workspaceId,
                    newRole: res.data.newRole,
                    oldRole: res.data.oldRole
                });
            } else {
                dispatch({ type: RequestRoleChangeActionType.REQUEST_ERROR });
            }
        }).catch(function () {
            dispatch({ type: RequestRoleChangeActionType.REQUEST_ERROR });
        });
    };
}

function closeRequestRoleChangeModal() {
    return function (dispatch, getState) {
        dispatch({ type: RequestRoleChangeActionType.CLOSE });
    };
}

},{"../../common/api/userApi":5,"../../common/constants":61,"../../common/utils/TrackUtils":90,"../../pricing/actions/pricingActions":265,"../apis/ExportPageApi":249,"../constants":250,"../trackingUtils":251,"../utils":252,"./facebookActions":247,"./youtubeActions":248,"keymirror":677,"notifyjs":878}],247:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FacebookActionType = undefined;
exports.uploadDone = uploadDone;
exports.uploadErrored = uploadErrored;
exports.updateFacebookData = updateFacebookData;
exports.appAuthorized = appAuthorized;
exports.updateUsername = updateUsername;
exports.updateUserAccounts = updateUserAccounts;
exports.updateProfilePic = updateProfilePic;
exports.appAuthFailed = appAuthFailed;
exports.pagePostingAuthorized = pagePostingAuthorized;
exports.pageAuthFailed = pageAuthFailed;
exports.loginForTimeline = loginForTimeline;
exports.loginForPages = loginForPages;
exports.loggingInTimeline = loggingInTimeline;
exports.loggingInPage = loggingInPage;
exports.post = post;
exports.postWatermarkVersion = postWatermarkVersion;
exports.initiatePost = initiatePost;
exports.openFacebookUploadModal = openFacebookUploadModal;
exports.closeFacebookUploadModal = closeFacebookUploadModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _TrackUtils = require('../../common/utils/TrackUtils');

var _ExportPageApi = require('../apis/ExportPageApi');

var _constants = require('../constants');

var _exportActions = require('./exportActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var FacebookActionType = exports.FacebookActionType = (0, _keymirror2.default)({
    FB_START_FLOW: null,
    FB_APP_AUTHORIZED: null,
    FB_APP_AUTH_FAILED: null,
    FB_PAGE_POSTING_AUTHORIZED: null,
    FB_PAGE_AUTH_FAILED: null,
    FB_LOGIN_TIMELINE: null,
    FB_LOGIN_PAGE: null,
    FB_LOGGING_IN_TIMELINE: null,
    FB_LOGGING_IN_PAGE: null,
    FB_LOGIN_FAILED: null,
    FB_OPEN: null,
    FB_CLOSE: null,
    UPDATE_FACEBOOK_DATA: null,
    UPLOAD_INITIATED: null,
    UPLOAD_DONE: null,
    UPLOAD_ERRORED: null,
    FB_UPDATE_USERNAME: null,
    FB_UPDATE_PROFILE_PIC: null,
    FB_UPDATE_ACCOUNTS: null,
    FB_OPEN_MODAL: null,
    FB_CLOSE_MODAL: null
});

function uploadInitiated() {
    return { type: FacebookActionType.UPLOAD_INITIATED };
}

function uploadDone(videoId) {
    return { type: FacebookActionType.UPLOAD_DONE, videoId: videoId };
}

function uploadErrored(errorType) {
    return { type: FacebookActionType.UPLOAD_ERRORED, errorType: errorType };
}

function updateFacebookData(status, videoId, videoUserId) {
    return { type: FacebookActionType.UPDATE_FACEBOOK_DATA, status: status, videoId: videoId, videoUserId: videoUserId };
}

function appAuthorized(userID, accessToken) {
    return { type: FacebookActionType.FB_APP_AUTHORIZED, userID: userID, accessToken: accessToken };
}

function updateUsername(name) {
    return { type: FacebookActionType.FB_UPDATE_USERNAME, name: name };
}

function updateUserAccounts(accounts) {
    return { type: FacebookActionType.FB_UPDATE_ACCOUNTS, accounts: accounts };
}

function updateProfilePic(profilePicUrl) {
    return { type: FacebookActionType.FB_UPDATE_PROFILE_PIC, profilePicUrl: profilePicUrl };
}

function appAuthFailed() {
    return { type: FacebookActionType.FB_APP_AUTH_FAILED };
}

function pagePostingAuthorized(userID, accessToken) {
    return { type: FacebookActionType.FB_PAGE_POSTING_AUTHORIZED, userID: userID, accessToken: accessToken };
}

function pageAuthFailed() {
    return { type: FacebookActionType.FB_PAGE_AUTH_FAILED };
}

function loginForTimeline() {
    return { type: FacebookActionType.FB_LOGIN_TIMELINE };
}

function loginForPages() {
    return { type: FacebookActionType.FB_LOGIN_PAGE };
}

function loggingInTimeline() {
    return { type: FacebookActionType.FB_LOGGING_IN_TIMELINE };
}

function loggingInPage() {
    return { type: FacebookActionType.FB_LOGGING_IN_PAGE };
}
function post(_ref) {
    var title = _ref.title,
        desc = _ref.desc,
        id = _ref.id,
        accessToken = _ref.accessToken;

    return function (dispatch, getState) {
        var _getState = getState(),
            exportId = _getState.exportdata.exportId,
            projectId = _getState.projectData.projectId;
        // const { accessToken, userID } = getState().facebookdata

        (0, _exportActions.trackVideoPublished)('facebook', projectId);
        dispatch(uploadInitiated());
        (0, _ExportPageApi.uploadVideoToFacebookP)(exportId, id, accessToken, title, desc);

        return null;
    };
}

function postWatermarkVersion(_ref2) {
    var title = _ref2.title,
        desc = _ref2.desc,
        id = _ref2.id,
        accessToken = _ref2.accessToken;

    return function (dispatch, getState) {
        var _getState2 = getState(),
            exportId = _getState2.exportdata.exportId,
            projectId = _getState2.projectData.projectId;
        // const { accessToken, userID } = getState().facebookdata

        (0, _exportActions.trackVideoPublished)('facebook', projectId);
        dispatch(uploadInitiated());
        (0, _ExportPageApi.uploadWatermarkedVideoToFacebookP)(exportId, id, accessToken, title, desc);

        return null;
    };
}

function initiatePost() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    return function (dispatch, getState) {
        var containsWatermark = getState().exportdata.containsWatermark;

        if (containsWatermark) {
            dispatch(postWatermarkVersion.apply(undefined, args));
        } else {
            dispatch(post.apply(undefined, args));
        }
    };
}

function openFacebookUploadModal() {
    return function (dispatch, getState) {
        dispatch({ type: FacebookActionType.FB_OPEN_MODAL });
        dispatch({ type: FacebookActionType.FB_START_FLOW });
    };
}

function closeFacebookUploadModal() {
    return { type: FacebookActionType.FB_CLOSE_MODAL };
}

},{"../../common/utils/TrackUtils":90,"../apis/ExportPageApi":249,"../constants":250,"./exportActions":246,"keymirror":677}],248:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YoutubeActionType = undefined;
exports.publishStarted = publishStarted;
exports.publishDone = publishDone;
exports.publishErrored = publishErrored;
exports.updateYoutubeData = updateYoutubeData;
exports.signIn = signIn;
exports.publish = publish;
exports.initiatePublish = initiatePublish;
exports.publishWatermarkVersion = publishWatermarkVersion;
exports.showWatermarkYoutubeModal = showWatermarkYoutubeModal;
exports.appAuthorized = appAuthorized;
exports.appAuthFailed = appAuthFailed;
exports.openYoutubePublishModal = openYoutubePublishModal;
exports.closeYoutubePublishModal = closeYoutubePublishModal;
exports.openMultipleUploadModal = openMultipleUploadModal;
exports.closeMultipleUploadModal = closeMultipleUploadModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _TrackUtils = require('../../common/utils/TrackUtils');

var _ExportPageApi = require('../apis/ExportPageApi');

var _constants = require('../constants');

var _exportActions = require('./exportActions');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var YoutubeActionType = exports.YoutubeActionType = (0, _keymirror2.default)({
    APP_AUTHORIZED: null,
    APP_AUTH_FAILED: null,
    YT_SIGN_IN: null,
    UPDATE_YOUTUBE_DATA: null,
    PUBLISH_INITIATED: null,
    PUBLISH_STARTED: null,
    PUBLISH_DONE: null,
    PUBLISH_ERRORED: null,
    YTP_OPEN_MODAL: null,
    YTP_CLOSE_MODAL: null,
    MEM_OPEN_MODAL: null,
    MEM_CLOSE_MODAL: null
});

function publishInitiated() {
    return { type: YoutubeActionType.PUBLISH_INITIATED };
}

function publishStarted() {
    return { type: YoutubeActionType.PUBLISH_STARTED };
}

function publishDone(videoId) {
    return { type: YoutubeActionType.PUBLISH_DONE, videoId: videoId };
}

function publishErrored(errorType) {
    return { type: YoutubeActionType.PUBLISH_ERRORED, errorType: errorType };
}

function updateYoutubeData(status, percent, videoId, errorType, publishMeta) {
    return {
        type: YoutubeActionType.UPDATE_YOUTUBE_DATA,
        status: status,
        percent: percent,
        videoId: videoId,
        errorType: errorType,
        publishMeta: publishMeta
    };
}

function signIn() {
    return { type: YoutubeActionType.YT_SIGN_IN };
}

function publish(_ref) {
    var title = _ref.title,
        desc = _ref.desc,
        showedLove = _ref.showedLove,
        privacy = _ref.privacy,
        tags = _ref.tags;

    return function (dispatch, getState) {
        var _getState = getState(),
            exportId = _getState.exportdata.exportId,
            projectId = _getState.projectData.projectId;

        (0, _exportActions.trackVideoPublished)('youtube', projectId);
        dispatch(publishInitiated());

        (0, _ExportPageApi.uploadVideoToYoutubeP)(exportId, title, desc, showedLove, privacy, tags);

        return null;
    };
}

// export function initiatePublish(...args) {
//     return (dispatch, getState) => {
//
//         const { exportId } = getState().exportdata
//
//         dispatch({ type : PaymentActionType.PAYMENT_CHECKING, postCheckAction : 'ytpublish', postCheckActionArgs : args })
//
//         return null;
//
//     }
// }

function initiatePublish() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    return function (dispatch, getState) {
        var containsWatermark = getState().exportdata.containsWatermark;

        if (containsWatermark) {
            dispatch(publishWatermarkVersion.apply(undefined, args));
        } else {
            dispatch(publish.apply(undefined, args));
        }
    };
}

function publishWatermarkVersion(_ref2) {
    var title = _ref2.title,
        desc = _ref2.desc,
        showedLove = _ref2.showedLove,
        privacy = _ref2.privacy,
        tags = _ref2.tags;

    return function (dispatch, getState) {
        var _getState2 = getState(),
            exportId = _getState2.exportdata.exportId,
            projectId = _getState2.projectData.projectId,
            _getState2$audioShare = _getState2.audioShareData,
            audioShareData = _getState2$audioShare === undefined ? null : _getState2$audioShare;

        var codeText = '\n';

        if (audioShareData) {
            var soundStripYoutubeShareCode = !!audioShareData && audioShareData.youtubeCode;
            if (soundStripYoutubeShareCode) {
                codeText += 'Music claim code: ' + soundStripYoutubeShareCode;
            }
        }

        (0, _exportActions.trackVideoPublished)('youtube', projectId);
        dispatch(publishInitiated());

        desc += codeText;

        (0, _ExportPageApi.uploadWatermarkedVideoToYoutubeP)(exportId, title, desc, showedLove, privacy, tags);

        return null;
    };
}

function showWatermarkYoutubeModal() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    return function (dispatch, getState) {
        var containsWatermark = getState().exportdata.containsWatermark;

        if (containsWatermark) {
            dispatch({
                type: _exportActions.WatermarkActionType.WTM_OPEN_MODAL,
                postCheckAction: 'ytpublish',
                postPaymentActionArgs: args
            });
        } else {
            dispatch(initiatePublish.apply(undefined, args));
        }
    };
}

function appAuthorized(email, serviceUserId) {
    return { type: YoutubeActionType.APP_AUTHORIZED, email: email, serviceUserId: serviceUserId };
}

function appAuthFailed() {
    var authFailureMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return { type: YoutubeActionType.APP_AUTH_FAILED, authFailureMsg: authFailureMsg };
}

function openYoutubePublishModal() {
    return { type: YoutubeActionType.YTP_OPEN_MODAL };
}

function closeYoutubePublishModal() {
    return { type: YoutubeActionType.YTP_CLOSE_MODAL };
}

function openMultipleUploadModal() {
    return { type: YoutubeActionType.MEM_OPEN_MODAL };
}

function closeMultipleUploadModal() {
    return { type: YoutubeActionType.MEM_CLOSE_MODAL };
}

},{"../../common/utils/TrackUtils":90,"../apis/ExportPageApi":249,"../constants":250,"./exportActions":246,"keymirror":677}],249:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.roleChangeRequestP = exports.resendActivationMailP = exports.addShopifyVideoCreditsP = exports.checkoutProjectUsingVideoCreditsP = exports.checkoutProjectUsingCreditsP = exports.checkoutProjectUsingSubscriptionP = exports.makeProjectPaymentWithSavedCardP = exports.makeProjectPaymentWithTokenP = exports.clearPaymentErrorP = exports.checkProjectPaymentStatusP = exports.getSubtitleDownloadUrlP = exports.getWatermarkedDownloadUrlP = exports.getDownloadUrlP = exports.cancelExportP = exports.updateYoutubeAuthCodeP = exports.uploadWatermarkedVideoToYoutubeP = exports.uploadVideoToYoutubeP = exports.uploadWatermarkedVideoToFacebookP = exports.uploadVideoToFacebookP = undefined;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var uploadVideoToFacebookP = exports.uploadVideoToFacebookP = function uploadVideoToFacebookP(exportId, userID, accessToken, title, desc) {
    return new _bluebird2.default(function (resolve, reject) {
        var url = '/api/export/facebookUpload/';

        var postParams = {};

        postParams.exportId = exportId;
        postParams.fbUserID = userID;
        postParams.accessToken = accessToken;

        if (title) {
            postParams.title = title;
        }
        if (desc) {
            postParams.desc = desc;
        }

        _superagent2.default.post(url).send(postParams).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve();
            }
            return reject(new Error('facebook upload failed'));
        });
    });
};
var uploadWatermarkedVideoToFacebookP = exports.uploadWatermarkedVideoToFacebookP = function uploadWatermarkedVideoToFacebookP(exportId, userID, accessToken, title, desc) {
    return new _bluebird2.default(function (resolve, reject) {
        var url = '/api/export/facebookUploadWatermarked/';

        var postParams = {};

        postParams.exportId = exportId;
        postParams.fbUserID = userID;
        postParams.accessToken = accessToken;

        if (title) {
            postParams.title = title;
        }
        if (desc) {
            postParams.desc = desc;
        }

        _superagent2.default.post(url).send(postParams).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve();
            }
            return reject(new Error('facebook publish failed'));
        });
    });
};

var uploadVideoToYoutubeP = exports.uploadVideoToYoutubeP = function uploadVideoToYoutubeP(exportId, title, desc, showedLove, privacy, tags) {
    return new _bluebird2.default(function (resolve, reject) {
        var url = '/api/export/youtubePublish/' + exportId;

        var postParams = {};
        if (title) {
            postParams.title = title;
        }
        if (desc) {
            postParams.desc = desc;
        }
        if (privacy) {
            postParams.privacy = privacy;
        }
        if (tags) {
            postParams.tags = JSON.stringify(tags);
        }
        if (showedLove) {
            postParams.showedLove = showedLove;
        }

        _superagent2.default.post(url).send(postParams).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve();
            }
            return reject(new Error('youtube publish failed'));
        });
    });
};

var uploadWatermarkedVideoToYoutubeP = exports.uploadWatermarkedVideoToYoutubeP = function uploadWatermarkedVideoToYoutubeP(exportId, title, desc, showedLove, privacy, tags) {
    return new _bluebird2.default(function (resolve, reject) {
        var url = '/api/export/youtubePublishWatermarked/' + exportId;

        var postParams = {};
        if (title) {
            postParams.title = title;
        }
        if (desc) {
            postParams.desc = desc;
        }
        if (privacy) {
            postParams.privacy = privacy;
        }
        if (tags) {
            postParams.tags = JSON.stringify(tags);
        }
        if (showedLove) {
            postParams.showedLove = showedLove;
        }

        _superagent2.default.post(url).send(postParams).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve();
            }
            return reject(new Error('youtube publish failed'));
        });
    });
};

var updateYoutubeAuthCodeP = exports.updateYoutubeAuthCodeP = function updateYoutubeAuthCodeP(authCode) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/export/updateAuthCode').send({ code: authCode }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve(res.body.accessToken);
            }
            return reject(new Error('update auth code'));
        });
    });
};

var cancelExportP = exports.cancelExportP = function cancelExportP(exportId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/export/cancelExport').send({ exportId: exportId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var getDownloadUrlP = exports.getDownloadUrlP = function getDownloadUrlP(exportId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/export/getDownloadUrl/' + exportId).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve(res.body.downloadUrl);
            }
            if (res.body.needLogin) {
                window.location.href = res.body.loginUrl;
            }
            if (res.body.errorReason) {
                if (res.body.errorReason === 'PROJECT_NOT_PAID') {
                    console.log('Trying to download unpaid project');
                    return reject(new Error('PROJECT_NOT_PAID'));
                }
                if (res.body.errorReason === 'ACCOUNT_NOT_ACTIVATED') {
                    console.log('Trying to download from unactivated account');
                    return reject(new Error('ACCOUNT_NOT_ACTIVATED'));
                }
            } else {
                return reject(new Error('getting download url'));
            }
        });
    });
};

var getWatermarkedDownloadUrlP = exports.getWatermarkedDownloadUrlP = function getWatermarkedDownloadUrlP(exportId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/export/getWatermarkedDownloadUrl/' + exportId).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve(res.body.downloadUrl);
            }
            if (res.body.needLogin) {
                window.location.href = res.body.loginUrl;
            }
            if (!!res.body.errorReason && res.body.errorReason === 'ACCOUNT_NOT_ACTIVATED') {
                console.log('Trying to download from unactivated account');
                return reject(new Error('ACCOUNT_NOT_ACTIVATED'));
            }
            return reject(new Error('getting download url'));
        });
    });
};

var getSubtitleDownloadUrlP = exports.getSubtitleDownloadUrlP = function getSubtitleDownloadUrlP(exportId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/export/getSubtitleDownloadUrl/' + exportId).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve(res.body.downloadUrl);
            }
            if (res.body.needLogin) {
                window.location.href = res.body.loginUrl;
            }
            if (!!res.body.errorReason && res.body.errorReason === 'ACCOUNT_NOT_ACTIVATED') {
                console.log('Trying to download from unactivated account');
                return reject(new Error('ACCOUNT_NOT_ACTIVATED'));
            }
            return reject(new Error('getting subtitle download url'));
        });
    });
};

var checkProjectPaymentStatusP = exports.checkProjectPaymentStatusP = function checkProjectPaymentStatusP(projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/project/paymentStatus').query({ projectId: projectId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var clearPaymentErrorP = exports.clearPaymentErrorP = function clearPaymentErrorP(projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/project/paymentErrorClear').send({ projectId: projectId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var makeProjectPaymentWithTokenP = exports.makeProjectPaymentWithTokenP = function makeProjectPaymentWithTokenP(projectId, stripeToken, cardLast4, cardBrand, saveCard) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/project/processPayment').send({ projectId: projectId, stripeToken: stripeToken, cardLast4: cardLast4, cardBrand: cardBrand, saveCard: saveCard, useSavedCard: false }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var makeProjectPaymentWithSavedCardP = exports.makeProjectPaymentWithSavedCardP = function makeProjectPaymentWithSavedCardP(projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/project/processPayment').send({
            projectId: projectId,
            stripeToken: null,
            cardLast4: null,
            saveCard: false,
            useSavedCard: true
        }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var checkoutProjectUsingSubscriptionP = exports.checkoutProjectUsingSubscriptionP = function checkoutProjectUsingSubscriptionP(projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/project/checkoutUsingSubscription').send({ projectId: projectId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var checkoutProjectUsingCreditsP = exports.checkoutProjectUsingCreditsP = function checkoutProjectUsingCreditsP(projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/project/checkoutUsingCredits').send({ projectId: projectId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var checkoutProjectUsingVideoCreditsP = exports.checkoutProjectUsingVideoCreditsP = function checkoutProjectUsingVideoCreditsP(projectId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/project/checkoutUsingVideoCredits').send({ projectId: projectId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var addShopifyVideoCreditsP = exports.addShopifyVideoCreditsP = function addShopifyVideoCreditsP() {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/workspace/addShopifyVideoCredits').end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var resendActivationMailP = exports.resendActivationMailP = function resendActivationMailP(email) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/user/requestactivationlink').send({ email: email }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            return resolve(res.body);
        });
    });
};

var roleChangeRequestP = exports.roleChangeRequestP = function roleChangeRequestP(workspaceId) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/workspace/requestRoleChange').send({ workspaceId: workspaceId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (!res.body.success) {
                return reject(new Error('Failed to send role change request to owner'));
            }
            return resolve(res.body);
        });
    });
};

},{"bluebird":389,"superagent":1193}],250:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequestRoleChangeModalUIState = exports.WatermarkUIState = exports.FacebookAuthorizationStatus = exports.VideoCreditUIState = exports.CreditUIState = exports.SubscriptionUIState = exports.PaymentUIState = exports.FacebookUploadStatus = exports.YoutubePublishStatus = exports.ExportNotifyState = exports.ActivationUIState = exports.ExportStatus = exports.ExportUIState = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ExportUIState = exports.ExportUIState = (0, _keymirror2.default)({
    IN_QUEUE: null,
    IN_PROGRESS: null,
    READY: null,
    CANCELLED: null
});

var ExportStatus = exports.ExportStatus = (0, _keymirror2.default)({
    WAITING_FOR_INPUT: null,
    READY_TO_START: null,
    IN_RENDERER_QUEUE: null,
    RENDERING_GRAPHICS: null,
    GRAPHICS_READY: null,
    IN_EXPORTER_QUEUE: null,
    EXPORTING: null,
    EXPORT_UPLOADING: null,
    EXPORT_READY: null,
    IN_PREVIEW_QUEUE: null,
    PREPARING_PREVIEWS: null,
    SNAPSHOT_READY: null,
    PREVIEW_DASH_360_READY: null,
    THUMBS_READY: null,
    PREVIEW_DASH_ALL_READY: null,
    PREVIEW_ALL_READY: null,
    CANCELLED: null
});

var ActivationUIState = exports.ActivationUIState = (0, _keymirror2.default)({
    OPEN: null,
    MAIL_SENT: null,
    CLOSED: null,
    ERROR: null,
    SENDING_MAIL: null,
    ALREADY_ACTIVATED: null
});

var ExportNotifyState = exports.ExportNotifyState = (0, _keymirror2.default)({
    AVAILABLE: null,
    UNSUPPORTED: null,
    REQUESTED: null,
    SCHEDULED: null,
    PERMISSION_DENIED: null
});

var YoutubePublishStatus = exports.YoutubePublishStatus = (0, _keymirror2.default)({
    NOT_YET: null,
    IN_PUBLISH_QUEUE: null,
    PUBLISHING: null,
    READY: null,
    ERROR: null
});

var FacebookUploadStatus = exports.FacebookUploadStatus = (0, _keymirror2.default)({
    NOT_YET: null,
    INITIATED: null,
    IN_UPLOAD_QUEUE: null,
    PUBLISHING: null,
    SUCCESS: null,
    ERROR: null
});

var PaymentUIState = exports.PaymentUIState = {
    CLOSED: 'OTP_CLOSED',
    CHECKING: 'OTP_CHECKING',
    WAITING_TOKEN: 'OTP_WAITING_TOKEN',
    PROCESSING_TOKEN: 'OTP_PROCESSING_TOKEN',
    PAYMENT_SUCCESS: 'OTP_PAYMENT_SUCCESS',
    PAYMENT_ERROR: 'OTP_PAYMENT_ERROR'
};

var SubscriptionUIState = exports.SubscriptionUIState = (0, _keymirror2.default)({
    CLOSED: null,
    SUBSCRIPTION_CHECKING: null,
    CHECKOUT_SUCCESS: null,
    CHECKOUT_FAILED: null
});

var CreditUIState = exports.CreditUIState = (0, _keymirror2.default)({
    CLOSED: null,
    CREDIT_CHECKING: null,
    CREDIT_CHECKOUT_SUCCESS: null,
    CREDIT_CHECKOUT_FAILED: null
});

var VideoCreditUIState = exports.VideoCreditUIState = (0, _keymirror2.default)({
    CLOSED: null,
    VIDEO_CREDIT_CHECKING: null,
    VIDEO_CREDIT_CHECKOUT_SUCCESS: null,
    VIDEO_CREDIT_CHECKOUT_FAILED: null
});

var FacebookAuthorizationStatus = exports.FacebookAuthorizationStatus = (0, _keymirror2.default)({
    AUTHORIZED: null,
    CHECKING: null,
    NOT_AUTHORIZED: null
});

var WatermarkUIState = exports.WatermarkUIState = (0, _keymirror2.default)({
    OPEN: null,
    CLOSED: null
});

var RequestRoleChangeModalUIState = exports.RequestRoleChangeModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    REQUEST_SUCCESS: null,
    REQUEST_ERROR: null
});

},{"keymirror":677}],251:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeGAMeta = mergeGAMeta;

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function mergeGAMeta(action, eventAction) {
    var eventValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return (0, _deepmerge2.default)(action, {
        meta: { ga: { eventAction: eventAction, eventValue: eventValue } }
    });
}

},{"deepmerge":549}],252:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exsToUIState = undefined;

var _constants = require('./constants');

var exsToUIState = exports.exsToUIState = function exsToUIState(exs) {
    if (exs == _constants.ExportStatus.CANCELLED) {
        return _constants.ExportUIState.CANCELLED;
    }

    if (exs == _constants.ExportStatus.WAITING_FOR_INPUT || exs == _constants.ExportStatus.READY_TO_START || exs == _constants.ExportStatus.IN_RENDERER_QUEUE) {
        return _constants.ExportUIState.IN_QUEUE;
    }

    if (exs == _constants.ExportStatus.RENDERING_GRAPHICS || exs == _constants.ExportStatus.GRAPHICS_READY || exs == _constants.ExportStatus.IN_EXPORTER_QUEUE || exs == _constants.ExportStatus.EXPORTING || exs == _constants.ExportStatus.EXPORT_UPLOADING || exs == _constants.ExportStatus.EXPORT_READY || exs == _constants.ExportStatus.IN_PREVIEW_QUEUE || exs == _constants.ExportStatus.PREPARING_PREVIEWS || exs == _constants.ExportStatus.SNAPSHOT_READY) {
        return _constants.ExportUIState.IN_PROGRESS;
    }

    if (exs == _constants.ExportStatus.PREVIEW_DASH_360_READY || exs == _constants.ExportStatus.THUMBS_READY || exs == _constants.ExportStatus.PREVIEW_DASH_ALL_READY || exs == _constants.ExportStatus.PREVIEW_ALL_READY) {
        return _constants.ExportUIState.READY;
    }

    throw new Error('Unknown status');
};

},{"./constants":250}],253:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchProjects = exports.UIActionType = exports.ProjectsActionType = undefined;

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.createProject = createProject;
exports.createAiProject = createAiProject;
exports.youtubeClicked = youtubeClicked;
exports.exportClicked = exportClicked;
exports.editProject = editProject;
exports.updateProjects = updateProjects;
exports.deleteClicked = deleteClicked;
exports.changeProjectName = changeProjectName;
exports.copyProject = copyProject;
exports.search = search;
exports.updateTotalProjectsCount = updateTotalProjectsCount;
exports.sort = sort;
exports.loadMoreProjects = loadMoreProjects;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _reactRedux = require('react-redux');

var _ProjectApi = require('../api/ProjectApi');

var _workspaceApi = require('../../common/api/workspaceApi');

var _workspaceActions = require('./workspaceActions');

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _TrackUtils = require('../../common/utils/TrackUtils');

var _ProjectApi2 = require('../../common/api/ProjectApi');

var ProjectApi = _interopRequireWildcard(_ProjectApi2);

var _constants = require('../../common/constants');

var _errorReporting = require('../../common/utils/errorReporting');

var _workspaceActions2 = require('../../pricing/actions/workspaceActions');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ProjectsActionType = exports.ProjectsActionType = (0, _keymirror2.default)({
    PROJECT_CREATE: null,
    YOUTUBE_CLICK: null,
    DELETE_CLICK: null,
    EXPORT_CLICK: null,
    PROJECT_RENAME: null,
    PROJECT_COPY: null,
    UPDATE_PROJECTS: null,
    UPDATE_TOTAL_PROJECTS_COUNT: null
});

var UIActionType = exports.UIActionType = (0, _keymirror2.default)({
    REFRESH_PROJECTS_ON_SORT: null,
    SEARCH_TOUCH: null,
    RESET_UIPROJECT_COUNT: null,

    COPYING_PROJECT: null,
    COPY_PROJECT_COMPLETE: null,
    CHANGE_PROJECT_SORTING: null,
    UPDATE_SEARCH_TEXT: null,

    OPEN_ADD_MEMBER_MODAL: null,
    CLOSE_ADD_MEMBER_MODAL: null,
    ADD_MEMBER_SUCCESS: null,
    ADD_MEMBER_ERROR: null,
    ADD_MEMBER_INVITE_PENDING: null,
    ADD_MEMBER_INVITE_ACCEPTED: null,

    OPEN_EDIT_MEMBER_MODAL: null,
    CLOSE_EDIT_MEMBER_MODAL: null,
    UPDATE_MEMBER_ROLE_SUCCESS: null,
    UPDATE_MEMBER_ROLE_ERROR: null,

    SAVE_SEGMENTATION_INFO: null,
    UPDATE_SEGMENTATION_UI_STATE: null,
    LOAD_MORE_PROJECTS: null,
    UI_UPDATE_ACCOUNT_DATA: null
});

function createProject(formatId) {
    var openFitnessEditor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch) {
        if (_constants.USE_UPLOAD_PAGE) {
            // TODO -- Remove it and make it back to the renderEdit when removing upload page
            window.open('/upload', '_blank');
        } else {
            if (openFitnessEditor) {
                dispatch((0, _workspaceActions2.clearOpenFitnessEditor)());
            }
            ProjectApi.createProjectRenderEdit(formatId, false, false, openFitnessEditor ? _constants.SupportedEditorWorkflows.fitness : undefined).then(function (response) {
                var trackingData = {
                    'Project id': response.projectId,
                    'Workspace id': response.workspaceId,
                    Type: 'Create'
                };
                if (response.success) {
                    (0, _TrackUtils.trackOnSmartlook)('Project Created', trackingData);
                }

                return (0, _workspaceApi.getWorkspaceDataP)().then(function (workspaces) {
                    dispatch((0, _workspaceActions.updateWorkspaces)(workspaces));
                });
            }).catch(function (err) {
                console.log('Could not create project', err);
            });
        }
    };
}

function createAiProject(prompt) {
    return async function (dispatch, getState) {
        var _getState = getState(),
            _getState$pricingStat = _getState.pricingState;

        _getState$pricingStat = _getState$pricingStat === undefined ? {} : _getState$pricingStat;
        var _getState$pricingStat2 = _getState$pricingStat.workflowInfo;
        _getState$pricingStat2 = _getState$pricingStat2 === undefined ? {} : _getState$pricingStat2;
        var _getState$pricingStat3 = _getState$pricingStat2.useAICreator,
            useAICreator = _getState$pricingStat3 === undefined ? false : _getState$pricingStat3,
            _getState$pricingStat4 = _getState$pricingStat.formatSelection.formatId,
            formatId = _getState$pricingStat4 === undefined ? null : _getState$pricingStat4;

        if (useAICreator) {
            dispatch((0, _workspaceActions2.clearUseAICreator)());
        }
        if (formatId) {
            dispatch((0, _workspaceActions2.clearSelectedFormatId)());
        }

        try {
            var response = await ProjectApi.createAiProjectRenderEdit(formatId, prompt);

            if (!response.success) {
                console.error('Failed to create project with Ai: formatId:' + formatId + ' prompt: ' + prompt);
                return;
            }

            var trackingData = {
                'Project id': response.projectId,
                'Workspace id': response.workspaceId,
                Type: 'Create'
            };

            (0, _TrackUtils.trackOnSmartlook)('Project Created', trackingData);

            var workspaces = await (0, _workspaceApi.getWorkspaceDataP)();
            dispatch((0, _workspaceActions.updateWorkspaces)(workspaces));
            dispatch((0, _workspaceActions2.closeAiCreatorModal)());

            window.open('/edit/' + response.projectId, '_blank');
        } catch (err) {
            console.error('Could not create project', err);
        }
    };
}

function youtubeClicked(youtubeId) {
    window.open('https://www.youtube.com/watch?v=' + youtubeId, '_blank');
}

function exportClicked(projectId) {
    window.open('/export/' + projectId, '_blank');
}

function editProject(projectId) {
    window.open('/edit/' + projectId, '_blank');
}

/**
 * Updates project by comparing length (no old writes, or less number of project write)
 * if clean is true , its a forced clean up of the project space
 *
 * @export
 * @param {Array<Object>} projects
 * @param {boolean} [clean=false]
 * @returns
 */
function updateProjects(projects) {
    var clean = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        dispatch({ type: ProjectsActionType.UPDATE_PROJECTS, projects: projects, clean: clean });
    };
}

function deleteClicked(projectId) {
    return function (dispatch, getState) {
        dispatch({ type: ProjectsActionType.DELETE_CLICK, projectId: projectId });

        (0, _ProjectApi.deleteProjectP)(projectId).then(function () {
            /* Nothing */
        }).catch(function (err) {
            console.log('Could not delete project', err);
        });
    };
}

function changeProjectName(projectId, projectName) {
    return function (dispatch, getState) {
        dispatch({
            type: ProjectsActionType.PROJECT_RENAME,
            projectId: projectId,
            projectName: projectName
        });

        (0, _ProjectApi.renameProjectP)(projectId, projectName).then(function () {
            /* Nothing */
        }).catch(function (err) {
            console.log('Could not rename project', err);
        });
    };
}

function copyProject(projectId, projectName) {
    return function (dispatch, getState) {
        dispatch({ type: UIActionType.COPYING_PROJECT, projectName: projectName });

        (0, _ProjectApi.copyProjectP)(projectId).then(function (response) {
            dispatch({ type: UIActionType.COPY_PROJECT_COMPLETE });
            var trackingData = {
                'Project id': response.projectId,
                'Workspace id': response.workspaceId,
                Type: 'Copy'
            };
            if (response.success) {
                (0, _TrackUtils.trackOnSmartlook)('Project Created', trackingData);
                dispatch({
                    type: ProjectsActionType.PROJECT_COPY,
                    project: response.projectTileData
                });
            }

            return (0, _workspaceApi.getWorkspaceDataP)().then(function (workspaces) {
                dispatch((0, _workspaceActions.updateWorkspaces)(workspaces));
            });
        }).catch(function (err) {
            console.log('Could not copy project', err);
        });
    };
}

// debounced version of the getAllProjectsPaginated
var searchProjects = exports.searchProjects = (0, _GeneralUtils.asyncDebounce)(_ProjectApi.getAllProjectsPaginated, 400);

/**
 * Search for search bar text
 *
 * @export
 * @param {string} searchText
 * @returns
 */
function search(searchText) {
    return async function (dispatch, getState) {
        (0, _reactRedux.batch)(function () {
            dispatch({ type: UIActionType.UPDATE_SEARCH_TEXT, searchText: searchText }); // update the search text at the very beggining
            dispatch({ type: UIActionType.SEARCH_TOUCH }); // search is touched , so search will always render now
            dispatch({ type: UIActionType.RESET_UIPROJECT_COUNT }); // this resets the total count of project to show back to 15 projects
            dispatch({ type: UIActionType.REFRESH_PROJECTS_ON_SORT, data: true }); // starts the refresh icon in page
        });

        var _getState2 = getState(),
            projects = _getState2.projects,
            pageSize = _getState2.projectSpaceConstants.pageSize;

        var pageNumber = Math.ceil((projects ? projects.length : 0) / pageSize) - 1;
        pageNumber = pageNumber < 0 ? 0 : pageNumber;

        try {
            var _ref = await searchProjects(true, pageNumber, true, searchText),
                _ref2 = _slicedToArray(_ref, 2),
                totalProjectsCount = _ref2[0],
                _projects = _ref2[1];

            (0, _reactRedux.batch)(function () {
                dispatch(updateTotalProjectsCount(totalProjectsCount));
                dispatch({ type: UIActionType.REFRESH_PROJECTS_ON_SORT, data: false });
                dispatch(updateProjects(_projects, true));
                // requires clean update, with all old data deleted along with new data being updated
                // search also resets the project count and space
            });
        } catch (err) {
            (0, _errorReporting.reportError)(new _errorReporting.ProjectsRetrivalFailingError(err)); // keep showing the loader, hinting at something is wrong. Possibly on user end (internet down)
        }
    };
}

/**
 * Update the totalProjectCount
 * primarily used to update the state of the
 * total project in the backend
 *
 * @export
 * @param {number} count
 * @returns
 */
function updateTotalProjectsCount(count) {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            _getState3$projectSpa = _getState3.projectSpaceConstants,
            pageSize = _getState3$projectSpa.pageSize,
            totalProjectsCount = _getState3$projectSpa.totalProjectsCount;

        if (count != totalProjectsCount) dispatch({ type: ProjectsActionType.UPDATE_TOTAL_PROJECTS_COUNT, data: count });
    };
}

/**
 *
 *
 * @export
 * @param {*} sortField
 * @returns
 */
function sort(sortField) {
    return async function (dispatch, getState) {
        var _getState4 = getState(),
            projectSorting = _getState4.uiState.projectSorting;

        // if same field is click again wont rerender + no network request


        if (projectSorting == sortField) return;
        try {
            //TO-DO , club request under single request (request coalescing in HTTP2.0)
            // or having update api return project list also
            await (0, _ProjectApi.saveProjectSortingP)(sortField); // request for saving Project sorting state
            //
            dispatch({ type: UIActionType.REFRESH_PROJECTS_ON_SORT, data: true }); // starts the refresh icon in page

            var _getState5 = getState(),
                projects = _getState5.projects,
                pageSize = _getState5.projectSpaceConstants.pageSize,
                _getState5$uiState$se = _getState5.uiState.searchText,
                searchText = _getState5$uiState$se === undefined ? '' : _getState5$uiState$se;

            var pageNumber = Math.ceil((projects ? projects.length : 0) / pageSize) - 1;
            pageNumber = pageNumber < 0 ? 0 : pageNumber;

            try {
                var _ref3 = await (0, _ProjectApi.getAllProjectsPaginated)(true, pageNumber, true, searchText),
                    _ref4 = _slicedToArray(_ref3, 2),
                    totalProjectsCount = _ref4[0],
                    _projects2 = _ref4[1];

                (0, _reactRedux.batch)(function () {
                    dispatch(updateTotalProjectsCount(totalProjectsCount));
                    dispatch({ type: UIActionType.REFRESH_PROJECTS_ON_SORT, data: false });
                    dispatch(updateProjects(_projects2));
                    dispatch({ type: UIActionType.CHANGE_PROJECT_SORTING, sorting: sortField }); // trigger rerdener (UI-changes), grooups projects
                });
            } catch (err) {
                (0, _errorReporting.reportError)(new _errorReporting.ProjectsRetrivalFailingError(err));
            }
        } catch (err) {
            console.log('Could not save project sorting', err);
        }
    };
    return;
}

/**
 * Used for creating dispatch of loading more Projects
 * inside /homePage React component ProjectGridContainer
 *
 * @export
 * @returns
 */
function loadMoreProjects() {
    return async function (dispatch, getState) {
        var _getState6 = getState(),
            projects = _getState6.projects,
            _getState6$projectSpa = _getState6.projectSpaceConstants,
            pageSize = _getState6$projectSpa.pageSize,
            totalProjectsCount = _getState6$projectSpa.totalProjectsCount,
            _getState6$uiState$se = _getState6.uiState.searchText,
            searchText = _getState6$uiState$se === undefined ? '' : _getState6$uiState$se;
        // start the spinner


        dispatch({ type: UIActionType.LOAD_MORE_PROJECTS, spinner: true });

        var pageNumber = Math.floor((projects ? projects.length : 0) / pageSize);
        // restrict any extra clicks end condition
        if (projects.length == totalProjectsCount) {
            dispatch({ type: UIActionType.LOAD_MORE_PROJECTS, spinner: false });
            return;
        }

        try {
            var _ref5 = await (0, _ProjectApi.getAllProjectsPaginated)(true, pageNumber, false, searchText),
                _ref6 = _slicedToArray(_ref5, 2),
                _totalProjectsCount = _ref6[0],
                data = _ref6[1];

            (0, _reactRedux.batch)(function () {
                dispatch({
                    type: ProjectsActionType.UPDATE_PROJECTS,
                    projects: data,
                    append: true
                });
                dispatch({ type: UIActionType.LOAD_MORE_PROJECTS, spinner: false });
                //update total project count
                dispatch(updateTotalProjectsCount(_totalProjectsCount));
            });
        } catch (err) {
            (0, _errorReporting.reportError)(new _errorReporting.ProjectsRetrivalFailingError(err));
        }
    };
}

},{"../../common/api/ProjectApi":4,"../../common/api/workspaceApi":6,"../../common/constants":61,"../../common/utils/GeneralUtils":77,"../../common/utils/TrackUtils":90,"../../common/utils/errorReporting":101,"../../pricing/actions/workspaceActions":266,"../api/ProjectApi":255,"./workspaceActions":254,"keymirror":677,"react-redux":1079}],254:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomFormatActionType = exports.WorkspaceActionType = undefined;
exports.createWorkspace = createWorkspace;
exports.switchWorkspace = switchWorkspace;
exports.addUserToWorkspace = addUserToWorkspace;
exports.closeAddMemberModal = closeAddMemberModal;
exports.openAddMemberModal = openAddMemberModal;
exports.closeEditMemberModal = closeEditMemberModal;
exports.openEditMemberModal = openEditMemberModal;
exports.updateUserRole = updateUserRole;
exports.removeUserFromWorkspace = removeUserFromWorkspace;
exports.updateWorkspaces = updateWorkspaces;
exports.updateSegmentationUIState = updateSegmentationUIState;
exports.saveSegmentationInfo = saveSegmentationInfo;
exports.submitShopifyInfo = submitShopifyInfo;
exports.updateAccountData = updateAccountData;
exports.createCustomFormat = createCustomFormat;
exports.closeCustomFormatModal = closeCustomFormatModal;
exports.openCustomFormatModal = openCustomFormatModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _WorkspaceApi = require('../api/WorkspaceApi');

var _workspaceApi = require('../../common/api/workspaceApi');

var _accountApis = require('../../account/accountApis');

var _projectActions = require('./projectActions');

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _constants = require('../../common/constants');

var _ActionTypes = require('../../common/constants/ActionTypes');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var WorkspaceActionType = exports.WorkspaceActionType = (0, _keymirror2.default)({
    SWITCH_WORKSPACE: null,
    CREATE_WORKSPACE: null,
    UPDATE_WORKSPACES: null,
    UPDATE_ACCOUNT: null
});

var CustomFormatActionType = exports.CustomFormatActionType = (0, _keymirror2.default)({
    FORMAT_CREATOR_SUCCESS: null,
    FORMAT_CREATOR_FAIL: null,
    FORMAT_CREATOR_OPEN: null,
    FORMAT_CREATOR_PROCESSING: null,
    FORMAT_CREATOR_CLOSE: null,
    FORMAT_LIMIT_REACHED: null
});

function createWorkspace(workspaceName) {
    return function (dispatch, getState) {
        return (0, _WorkspaceApi.createWorkspaceP)(workspaceName).then(function () {
            window.location.reload();
        }).catch(function (err) {
            console.log('Could not create workspace');
            console.error(err);
        });
    };
}

function switchWorkspace(newWorkspaceId) {
    return function (dispatch, getState) {
        return (0, _workspaceApi.switchWorkspaceP)(newWorkspaceId).then(function () {
            window.location.reload();
        }).catch(function (err) {
            console.log('Could not switch workspace');
            console.error(err);
        });
    };
}

/**
 *
 * @param {number} workspaceId
 * @param {Array<{inviteeEmail: string, inviteeRole: string}>} inviteeData
 * Assuming that the above array only consists of non invited emails.
 */
function addUserToWorkspace(workspaceId) {
    var inviteeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function (dispatch, getState) {
        var _getState = getState(),
            _getState$workspaceIn = _getState.workspaceInfo,
            allWorkspaces = _getState$workspaceIn.allWorkspaces,
            selectedWorkspace = _getState$workspaceIn.activeWorkspace;

        if (!!inviteeData && inviteeData.length > 0) {
            return (0, _workspaceApi.addUserToWorkspaceP)(workspaceId, inviteeData).then(function () {
                inviteeData.forEach(function (_ref) {
                    var inviteeEmail = _ref.inviteeEmail,
                        inviteeRole = _ref.inviteeRole;

                    var trackingData = {
                        workspaceId: workspaceId,
                        workspaceName: selectedWorkspace.workspaceName,
                        addedUserEmail: inviteeEmail,
                        role: inviteeRole
                    };

                    tracker.trackOnHeap('Added workspace member', trackingData);
                });

                dispatch({ type: _projectActions.UIActionType.ADD_MEMBER_SUCCESS, inviteeData: inviteeData });
            }).catch(function (err) {
                dispatch({ type: _projectActions.UIActionType.ADD_MEMBER_ERROR });
                console.log('Could not invite user to workspace');
                console.error(err);
            });
        }
    };
}

function closeAddMemberModal() {
    return { type: _projectActions.UIActionType.CLOSE_ADD_MEMBER_MODAL };
}

function openAddMemberModal() {
    return function (dispatch, getState) {
        dispatch({ type: _projectActions.UIActionType.OPEN_ADD_MEMBER_MODAL });
    };
}

function closeEditMemberModal() {
    return { type: _projectActions.UIActionType.CLOSE_EDIT_MEMBER_MODAL };
}

function openEditMemberModal(user) {
    return { type: _projectActions.UIActionType.OPEN_EDIT_MEMBER_MODAL, selectedUser: user };
}

function updateUserRole(userId, workspaceId, role) {
    return function (dispatch, getState) {
        return (0, _WorkspaceApi.updateUserRoleP)(userId, workspaceId, role).then(function () {
            dispatch({ type: _projectActions.UIActionType.UPDATE_MEMBER_ROLE_SUCCESS, userId: userId, workspaceId: workspaceId, role: role });
        }).catch(function (err) {
            dispatch({ type: _projectActions.UIActionType.UPDATE_MEMBER_ROLE_ERROR });
            console.log('Could not update user role');
            console.error(err);
        });
    };
}

function removeUserFromWorkspace(email, workspaceId) {
    return function (dispatch, getState) {
        return (0, _workspaceApi.removeUserFromWorkspaceP)(email, workspaceId).then(function () {
            dispatch({ type: _ActionTypes.RemoveMemberActionType.REMOVE_MEMBER_SUCCESS, emails: email, workspaceId: workspaceId });
        }).catch(function (err) {
            dispatch({ type: _ActionTypes.RemoveMemberActionType.REMOVE_MEMBER_ERROR });
            console.log('Could not remove user from workspace');
            console.error(err);
        });
    };
}

function updateWorkspaces(workspaces) {
    return function (dispatch, getState) {
        dispatch({ type: WorkspaceActionType.UPDATE_WORKSPACES, workspaces: workspaces });
    };
}

function updateSegmentationUIState(needSegmentationInfo) {
    return function (dispatch, getState) {
        dispatch({ type: _projectActions.UIActionType.UPDATE_SEGMENTATION_UI_STATE, needSegmentationInfo: needSegmentationInfo });
    };
}

function saveSegmentationInfo(organizationType, organizationName, phoneNumber) {
    return function (dispatch, getState) {
        dispatch({ type: _projectActions.UIActionType.SAVE_SEGMENTATION_INFO, organizationName: organizationName });

        return (0, _WorkspaceApi.saveSegmentationInfoP)(organizationType, organizationName, phoneNumber).then(function () {
            var _getState2 = getState(),
                selectedWorkspace = _getState2.workspaceInfo.activeWorkspace,
                userData = _getState2.account.userData;

            var trackingData = {
                organizationType: organizationType,
                user_id: userData.id,
                workspace_id: selectedWorkspace.workspaceId,
                Location: '/home'
            };

            tracker.trackOn('Segmentation info filled', trackingData, {
                PostHog: true,
                Smartlook: true
            });

            return (0, _accountApis.renameWorkspaceP)(selectedWorkspace.workspaceId, organizationName);
        }).catch(function (err) {
            console.log('Could not remove save user segmentation info');
            console.error(err);
        });
    };
}

function submitShopifyInfo(organizationType, selectedVideoTypes, adPlatforms) {
    return function (dispatch, getState) {
        dispatch({ type: _projectActions.UIActionType.SAVE_SEGMENTATION_INFO });

        return (0, _WorkspaceApi.saveShopifyInfoP)(organizationType, selectedVideoTypes, adPlatforms).then(function () {
            var _getState3 = getState(),
                selectedWorkspace = _getState3.workspaceInfo.activeWorkspace,
                userData = _getState3.account.userData;

            var trackingData = {
                organizationType: organizationType,
                user_id: userData.id,
                workspace_id: selectedWorkspace.workspaceId,
                Location: '/home'
            };

            tracker.trackOn('Segmentation info filled', trackingData, {
                PostHog: true,
                Smartlook: true
            });
        }).catch(function (err) {
            console.log('Could not remove save shopify segmentation info');
            console.error(err);
        });
    };
}

function updateAccountData(accountData) {
    return function (dispatch, getState) {
        dispatch({ type: WorkspaceActionType.UPDATE_ACCOUNT, accountData: accountData });
    };
}

function createCustomFormat(formatObj) {
    return function (dispatch, getState) {
        dispatch({ type: CustomFormatActionType.FORMAT_CREATOR_PROCESSING });

        var selectedWorkspace = getState().workspaceInfo.activeWorkspace;

        var workspaceId = selectedWorkspace.workspaceId;
        return (0, _WorkspaceApi.createCustomFormatP)(formatObj).then(function (res) {
            if (!res.success) {
                if (res.errorCode && res.errorCode == 'CUSTOM_FORMAT_LIMIT_REACHED') {
                    dispatch({ type: CustomFormatActionType.FORMAT_LIMIT_REACHED });
                } else {
                    dispatch({ type: CustomFormatActionType.FORMAT_CREATOR_FAIL });
                }
            } else {
                var customFormat = res.customFormat;

                var trackingData = {
                    workspaceId: workspaceId,
                    formatName: formatObj.name,
                    height: formatObj.height,
                    width: formatObj.width,
                    useCase: formatObj.useCase,
                    hasPadding: formatObj.hasPadding,
                    aspectRatio: (0, _GeneralUtils.getAspectRatio)(formatObj.width, formatObj.height),
                    sourceView: (0, _constants.getSourceView)()
                };

                tracker.trackOn('Custom Format added', trackingData, {
                    PostHog: true,
                    Smartlook: true
                });

                dispatch({ type: CustomFormatActionType.FORMAT_CREATOR_SUCCESS, customFormat: customFormat });
            }
        }).catch(function (err) {
            dispatch({ type: CustomFormatActionType.FORMAT_CREATOR_FAIL });
            console.log('Could not create custom format');
            console.error(err);
        });
    };
}

function closeCustomFormatModal() {
    return function (dispatch) {
        dispatch({ type: CustomFormatActionType.FORMAT_CREATOR_CLOSE });
    };
}

function openCustomFormatModal() {
    return function (dispatch) {
        dispatch({ type: CustomFormatActionType.FORMAT_CREATOR_OPEN });
    };
}

},{"../../account/accountApis":1,"../../common/api/workspaceApi":6,"../../common/constants":61,"../../common/constants/ActionTypes":62,"../../common/utils/GeneralUtils":77,"../api/WorkspaceApi":256,"./projectActions":253,"keymirror":677}],255:[function(require,module,exports){
'use strict';

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Promise = require('bluebird');

var ProjectApi = {
    deleteProjectP: function deleteProjectP(project_id) {
        return Promise.resolve($.ajax('/api/project/delete', {
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                id: project_id
            })
        })).then(function (responseData) {
            if (responseData.success) {
                return true;
            } else {
                throw new Error('Creation unsuccessful');
            }
        });
    },

    renameProjectP: function renameProjectP(project_id, name) {
        return Promise.resolve($.ajax('/api/project/update', {
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                id: project_id,
                name: name
            })
        })).then(function (responseData) {
            if (responseData.success) {
                return true;
            } else {
                throw new Error('Creation unsuccessful');
            }
        });
    },
    copyProjectP: function copyProjectP(project_id) {
        return Promise.resolve($.ajax('/api/project/createDuplicateProject', {
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                projectId: project_id
            })
        })).then(function (responseData) {
            if (responseData.success) {
                return responseData;
            } else {
                throw new Error('Creation unsuccessful');
            }
        });
    },
    saveProjectSortingP: function saveProjectSortingP(sortField) {
        var sorting = '';

        switch (sortField) {
            case _constants.ProjectSortField.MOST_RECENT_ADDED:
                sorting = 'create_date_desc';
                break;
            case _constants.ProjectSortField.MOST_RECENT_MODIFIED:
                sorting = 'modified_date_desc';
                break;
            case _constants.ProjectSortField.ALPHABETICAL:
                sorting = 'name_asc';
                break;
            default:
                sorting = 'create_date_desc';
        }

        return Promise.resolve($.ajax('/api/project/saveProjectSorting', {
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                sorting: sorting
            })
        })).then(function (responseData) {
            if (responseData.success) {
                return responseData;
            } else {
                throw new Error('Sorting save unsuccessful');
            }
        });
    },
    getProjectsP: function getProjectsP() {
        return new Promise(function (resolve, reject) {
            _superagent2.default.get('/api/project/getAllProjects').end(function (err, res) {
                if (err) {
                    return reject(err);
                }
                if (!res.body.success) {
                    return reject(new Error('Failed to get projects'));
                }

                try {
                    return resolve({
                        projects: JSON.parse(res.body.projects)
                    });
                } catch (err) {
                    return reject(err);
                }
            });
        });
    },

    /**
     *
     * Gets the pages of fixed size if pagination is set to true.
     * @param {boolean} pagination
     * @param {number} pageNumber
     * @param {boolean} all
     * @param {string} queryString
     * @returns
     */
    getAllProjectsPaginated: async function getAllProjectsPaginated() {
        var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var pageNumber = arguments[1];
        var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var queryString = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

        try {
            var data = (await _axios2.default.get('/api/project/getAllProjectsPaginated', {
                params: {
                    pagination: pagination,
                    page: pageNumber,
                    all: all,
                    queryString: queryString
                }
            })).data;
            return [data.totalProjectsCount, data.videoList];
        } catch (err) {
            console.log(err);
            return [];
        }
    }
};

module.exports = ProjectApi;

},{"../constants":257,"axios":335,"bluebird":389,"superagent":1193}],256:[function(require,module,exports){
'use strict';

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Promise = require('bluebird');

var WorkspaceApi = {
    createWorkspaceP: function createWorkspaceP(workspaceName) {
        return new Promise(function (resolve, reject) {
            _superagent2.default.post('/api/workspace/createWorkspace').send({
                workspaceName: workspaceName
            }).end(function (err, res) {
                if (err) {
                    return reject(err);
                }
                if (!res.body.success) {
                    return reject(new Error('Failed to create workspace'));
                }
                try {
                    return resolve(res.body.workspaceData);
                } catch (err) {
                    return reject(err);
                }
            });
        });
    },
    removeUserFromWorkspaceP: function removeUserFromWorkspaceP(email, workspaceId) {
        return new Promise(function (resolve, reject) {
            _superagent2.default.post('/api/workspace/removeMember').send({
                memberEmail: email,
                workspaceId: workspaceId
            }).end(function (err, res) {
                if (err) {
                    return reject(err);
                }
                if (!res.body.success) {
                    return reject(new Error('Failed to remove user from workspace'));
                }
                return resolve();
            });
        });
    },
    saveShopifyInfoP: function saveShopifyInfoP(organizationType, selectedVideoTypes, adPlatforms) {
        return new Promise(function (resolve, reject) {
            _superagent2.default.post('/api/user/saveShopifyInfo').send({
                organizationType: organizationType,
                videoTypes: selectedVideoTypes,
                adPlatforms: adPlatforms
            }).end(function (err, res) {
                if (err) {
                    return reject(err);
                }
                if (!res.body.success) {
                    return reject(new Error('Failed to save user shopify info'));
                }
                return resolve();
            });
        });
    },
    saveSegmentationInfoP: function saveSegmentationInfoP(organizationType, organizationName, phoneNumber) {
        return new Promise(function (resolve, reject) {
            _superagent2.default.post('/api/user/saveSegmentationInfo').send({
                organizationType: organizationType,
                organizationName: organizationName,
                phoneNumber: phoneNumber
            }).end(function (err, res) {
                if (err) {
                    return reject(err);
                }
                if (!res.body.success) {
                    return reject(new Error('Failed to save user segmentation info'));
                }
                return resolve();
            });
        });
    },
    updateUserRoleP: function updateUserRoleP(userId, workspaceId, role) {
        return new Promise(function (resolve, reject) {
            _superagent2.default.post('/api/workspace/updateMemberRole').send({
                workspaceId: workspaceId,
                targetUserId: userId,
                newRole: role
            }).end(function (err, res) {
                if (err) {
                    return reject(err);
                }
                if (!res.body.success) {
                    return reject(new Error('Failed to update user role'));
                }
                return resolve();
            });
        });
    },
    createCustomFormatP: function createCustomFormatP(formatObj) {
        return new Promise(function (resolve, reject) {
            _superagent2.default.post('/api/createFormat').send({
                formatObj: formatObj,
                sourceView: (0, _constants.getSourceView)()
            }).then(function (response) {
                resolve(response.body);
            }).catch(function (err) {
                console.error('Error while creating format', err);
                return {
                    success: false
                };
            });
        });
    }
};

module.exports = WorkspaceApi;

},{"../../common/constants":61,"axios":335,"bluebird":389,"superagent":1193}],257:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomFormatUIState = exports.EditMemberModalUIState = exports.AddMemberModalUIState = exports.CollaboratorRole = exports.ProjectSortField = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ProjectSortField = exports.ProjectSortField = (0, _keymirror2.default)({
    MOST_RECENT_ADDED: null,
    MOST_RECENT_MODIFIED: null,
    ALPHABETICAL: null
});

var CollaboratorRole = exports.CollaboratorRole = (0, _keymirror2.default)({
    ADMIN: null,
    PRODUCER: null,
    EDITOR: null
});

var AddMemberModalUIState = exports.AddMemberModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    INVITE_SUCCESS: null,
    INVITE_ERROR: null,
    INVITE_PENDING: null,
    INVITE_ACCEPTED: null
});

var EditMemberModalUIState = exports.EditMemberModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    UPDATE_SUCCESS: null,
    UPDATE_ERROR: null,
    REMOVE_SUCCESS: null,
    REMOVE_ERROR: null
});

var CustomFormatUIState = exports.CustomFormatUIState = (0, _keymirror2.default)({
    OPEN: null,
    CREATING: null,
    CREATION_SUCCESS: null,
    CREATION_FAILED: null,
    CLOSED: null,
    CF_LIMIT_REACHED: null
});

},{"keymirror":677}],258:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buyPacksWithSavedCardP = exports.buyPacksWithTokenP = exports.newLicenseWithSavedCardP = exports.newLicenseWithTokenP = undefined;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var newLicenseWithTokenP = exports.newLicenseWithTokenP = function newLicenseWithTokenP(activeWorkspaceId, stripeToken, licenseId, cardLast4, cardBrand, addedPacks) {
    return _axios2.default.post('/api/payment/newLicense', {
        activeWorkspaceId: activeWorkspaceId,
        licenseId: licenseId,
        stripeToken: stripeToken,
        cardLast4: cardLast4,
        cardBrand: cardBrand,
        useSavedCard: false,
        addedPacks: addedPacks,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var newLicenseWithSavedCardP = exports.newLicenseWithSavedCardP = function newLicenseWithSavedCardP(activeWorkspaceId, licenseId, addedPacks) {
    return _axios2.default.post('/api/payment/newLicense', {
        activeWorkspaceId: activeWorkspaceId,
        licenseId: licenseId,
        stripeToken: null,
        cardLast4: null,
        cardBrand: false,
        useSavedCard: true,
        addedPacks: addedPacks,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var buyPacksWithTokenP = exports.buyPacksWithTokenP = function buyPacksWithTokenP(activeWorkspaceId, stripeToken, cardLast4, cardBrand, addedPacks) {
    return _axios2.default.post('/api/payment/buyLicensePacks', {
        activeWorkspaceId: activeWorkspaceId,
        stripeToken: stripeToken,
        cardLast4: cardLast4,
        cardBrand: cardBrand,
        useSavedCard: false,
        addedPacks: addedPacks,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var buyPacksWithSavedCardP = exports.buyPacksWithSavedCardP = function buyPacksWithSavedCardP(activeWorkspaceId, addedPacks) {
    return _axios2.default.post('/api/payment/buyLicensePacks', {
        activeWorkspaceId: activeWorkspaceId,
        stripeToken: null,
        cardLast4: null,
        cardBrand: false,
        useSavedCard: true,
        addedPacks: addedPacks,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

},{"../common/constants":61,"axios":335}],259:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LicenseModalActionType = exports.PaymentHeaderActionType = exports.PlanType = exports.WorkspaceActionType = exports.UIActionType = exports.PlanChangeActionType = exports.AddonActionType = exports.LicensePaymentActionType = undefined;
exports.buyAddonPacks = buyAddonPacks;
exports.purchasePlan = purchasePlan;
exports.triggerPostLoginAction = triggerPostLoginAction;
exports.changePlanComplete = changePlanComplete;
exports.changePlanFailed = changePlanFailed;
exports.onConfirmChangePlanModal = onConfirmChangePlanModal;
exports.switchToFreePlan = switchToFreePlan;
exports.changePackQuantity = changePackQuantity;
exports.resetCart = resetCart;
exports.changeView = changeView;
exports.openLicenseModal = openLicenseModal;
exports.closeLicenseModal = closeLicenseModal;
exports.hidePaymentConfirmationHeader = hidePaymentConfirmationHeader;
exports.showPaymentConfirmationHeader = showPaymentConfirmationHeader;
exports.closeLicensePaymentModal = closeLicensePaymentModal;
exports.closeChangePlanModal = closeChangePlanModal;
exports.stripeTokenReceived = stripeTokenReceived;
exports.payUsingSavedCard = payUsingSavedCard;
exports.paymentSuccess = paymentSuccess;
exports.updateAccountData = updateAccountData;
exports.updateIntercomData = updateIntercomData;
exports.fetchAndUpdateAccountData = fetchAndUpdateAccountData;
exports.paymentError = paymentError;
exports.paymentClearError = paymentClearError;
exports.changeWorkspace = changeWorkspace;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _LicensePageApi = require('../license/LicensePageApi');

var LicensePageApi = _interopRequireWildcard(_LicensePageApi);

var _PricingPageApi = require('../pricing/PricingPageApi');

var PricingPageApi = _interopRequireWildcard(_PricingPageApi);

var _userApi = require('../common/api/userApi');

var UserApi = _interopRequireWildcard(_userApi);

var _workspaceApi = require('../common/api/workspaceApi');

var _PlanUtils = require('../common/utils/PlanUtils');

var _constants = require('./constants');

var _TrackUtils = require('../common/utils/TrackUtils');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var LicensePaymentActionType = exports.LicensePaymentActionType = (0, _keymirror2.default)({
    LICENSE_PAYMENT_OPEN: null,
    LICENSE_PAYMENT_CLOSE: null,
    NEW_LICENSE_USE_TOKEN: null,
    NEW_LICENSE_USE_SAVED_CARD: null,
    LICENSE_PAYMENT_SUCCESS: null,
    LICENSE_PAYMENT_ERROR: null,
    LICENSE_PAYMENT_COMPLETE_FLOW: null,
    LICENSE_PLAN_SELECT: null,
    ADDON_PACK_SELECT: null,
    FREE_PLAN_SELECT: null,
    LICENSE_PAYMENT_CLEARING_ERROR: null
});

var AddonActionType = exports.AddonActionType = (0, _keymirror2.default)({
    ADD_PACK: null,
    ADD_LICENSE: null,
    RESET_CART: null
});

var PlanChangeActionType = exports.PlanChangeActionType = (0, _keymirror2.default)({
    CHANGE_PLAN_OPEN: null,
    CHANGE_PLAN_CLOSE: null,
    CHANGE_PLAN_CONFIRM: null,
    CHANGE_PLAN_COMPLETE: null,
    CHANGE_PLAN_FAILED: null
});

var UIActionType = exports.UIActionType = (0, _keymirror2.default)({
    UI_UPDATE_ACCOUNT_DATA: null,
    CHANGE_WORKSPACE: null,
    CHANGE_SIDEBAR_KEY: null
});

var WorkspaceActionType = exports.WorkspaceActionType = (0, _keymirror2.default)({
    UPDATE_WORKSPACES: null
});

var PlanType = exports.PlanType = (0, _keymirror2.default)({
    FREE: null,
    LICENSE: null,
    PACK: null,
    CUSTOM: null
});

var PaymentHeaderActionType = exports.PaymentHeaderActionType = (0, _keymirror2.default)({
    HIDE_PAYMENT_LIC_HEADER: null,
    SHOW_PAYMENT_LIC_HEADER: null
});

var LicenseModalActionType = exports.LicenseModalActionType = (0, _keymirror2.default)({
    CLOSE_MODAL: null,
    OPEN_MODAL: null
});

var ValidationErrorCodes = (0, _keymirror2.default)({
    INCONSISTENT_WORKSPACE: null
});

function buyAddonPacks(cartCost) {
    return function (dispatch, getState) {
        var _getState$licenseStat = getState().licenseState,
            isLoggedIn = _getState$licenseStat.uiState.isLoggedIn,
            _getState$licenseStat2 = _getState$licenseStat.workspaceInfo.activeWorkspace,
            activeWorkspace = _getState$licenseStat2 === undefined ? {} : _getState$licenseStat2;

        if (activeWorkspace.planType != 'SUB') {
            dispatch({ type: LicensePaymentActionType.ADDON_PACK_SELECT, cartCost: cartCost });

            if (isLoggedIn) {
                dispatch(triggerPostLoginAction());
            } else if (!!window.openLoginForm) {
                window.openLoginForm(cartCost);
            }
        }
    };
}

function purchasePlan(newPlanId, cartCost) {
    return function (dispatch, getState) {
        var isLoggedIn = getState().licenseState.uiState.isLoggedIn;

        dispatch({ type: LicensePaymentActionType.LICENSE_PLAN_SELECT, newPlanId: newPlanId, cartCost: cartCost });

        if (isLoggedIn) {
            dispatch(triggerPostLoginAction());
        } else if (!!window.openLoginForm) {
            window.openLoginForm(newPlanId, cartCost);
        }
    };
}

function isDowngrade(licensePlans, oldPlanId, newCartCost) {
    var previousPlan = licensePlans.find(function (licensePlan) {
        return licensePlan.planId === oldPlanId;
    });

    if (!!previousPlan && previousPlan.cartCost > newCartCost) {
        return true;
    }
    return false;
}

function triggerPostLoginAction() {
    return function (dispatch, getState) {
        var selectedPlanType = getState().licenseState.uiState.selectedPlanType;
        var planType = getState().licenseState.planData.planType;
        var activeWorkspace = getState().licenseState.workspaceInfo.activeWorkspace;

        dispatch(closeLicenseModal());

        if (activeWorkspace.role == 'ADMIN') {
            if (selectedPlanType === PlanType.LICENSE) {
                if (!(0, _PlanUtils.checkIsPaidWorkspace)(planType)) {
                    //Buy new plan
                    dispatch({ type: LicensePaymentActionType.LICENSE_PAYMENT_OPEN });
                }
            } else if (selectedPlanType === PlanType.FREE) {
                if ((0, _PlanUtils.checkIsPaidWorkspace)(planType)) {
                    dispatch({ type: PlanChangeActionType.CHANGE_PLAN_OPEN, changeOperation: 'cancel' });
                } else {
                    //Go to home
                    window.location.href = '/home';
                }
            } else if (selectedPlanType === PlanType.CUSTOM) {
                // dispatch({ type : LicensePaymentActionType.LICENSE_PAYMENT_OPEN })
            } else if (selectedPlanType === PlanType.PACK) {
                dispatch({ type: LicensePaymentActionType.LICENSE_PAYMENT_OPEN });
            }
        }

        return;
    };
}

function changePlanComplete() {
    return function (dispatch, getState) {
        dispatch(fetchAndUpdateAccountData());
        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_COMPLETE });
    };
}

function changePlanFailed() {
    return function (dispatch, getState) {
        dispatch(fetchAndUpdateAccountData());
        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_FAILED });
    };
}

function onConfirmChangePlanModal() {
    return function (dispatch, getState) {
        var _getState$licenseStat3 = getState().licenseState,
            selectedPlanType = _getState$licenseStat3.uiState.selectedPlanType,
            _getState$licenseStat4 = _getState$licenseStat3.workspaceInfo.activeWorkspace,
            activeWorkspace = _getState$licenseStat4 === undefined ? {} : _getState$licenseStat4;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_CONFIRM });

        if (selectedPlanType === PlanType.FREE) {
            _bluebird2.default.try(function () {
                return PricingPageApi.cancelSubscriptionP(activeWorkspaceId);
            }).then(function (result) {
                if (!!result.success) {
                    var status = result.status,
                        errorType = result.errorType,
                        errorMessage = result.errorMessage;

                    if (status === 'cancellation_success' || status === 'already_cancelled') {
                        dispatch(showPaymentConfirmationHeader());
                        dispatch(changePlanComplete());
                    } else {
                        dispatch(changePlanFailed());
                        throw new Error('Error cancelling user plan');
                    }
                } else {
                    if (result.status == ValidationErrorCodes.INCONSISTENT_WORKSPACE) {
                        window.location.reload();
                    } else {
                        dispatch(changePlanFailed());
                        throw new Error('Error cancelling user plan');
                    }
                }
            }).catch(function (err) {
                console.error(err);
            });
        }
    };
}

function switchToFreePlan() {
    return function (dispatch, getState) {
        var isLoggedIn = getState().licenseState.uiState.isLoggedIn;

        dispatch({ type: LicensePaymentActionType.FREE_PLAN_SELECT });

        if (isLoggedIn) {
            dispatch(triggerPostLoginAction());
        } else if (!!window.openLoginForm) {
            window.openLoginForm();
        }
    };
}

function changePackQuantity(packId, changedQuantity, packType) {
    return function (dispatch, getState) {
        var _getState$licenseStat5 = getState().licenseState.workspaceInfo;
        _getState$licenseStat5 = _getState$licenseStat5 === undefined ? {} : _getState$licenseStat5;
        var _getState$licenseStat6 = _getState$licenseStat5.activeWorkspace;
        _getState$licenseStat6 = _getState$licenseStat6 === undefined ? {} : _getState$licenseStat6;
        var _getState$licenseStat7 = _getState$licenseStat6.planType,
            planType = _getState$licenseStat7 === undefined ? 'PPV' : _getState$licenseStat7;

        if (!planType || planType !== 'SUB') {
            dispatch({ type: AddonActionType.ADD_PACK, packId: packId, changedQuantity: changedQuantity, packType: packType });
        }
    };
}

function resetCart() {
    return function (dispatch, getState) {
        var _getState$licenseStat8 = getState().licenseState.pricingData.addonPacks,
            addonPacks = _getState$licenseStat8 === undefined ? {} : _getState$licenseStat8;

        dispatch({ type: AddonActionType.RESET_CART, addonPacks: addonPacks });
    };
}

function changeView(selectedSidebarKey) {
    return { type: UIActionType.CHANGE_SIDEBAR_KEY, selectedSidebarKey: selectedSidebarKey };
}

function openLicenseModal() {
    var showCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return { type: LicenseModalActionType.OPEN_MODAL, showCancel: showCancel };
}

function closeLicenseModal() {
    return { type: LicenseModalActionType.CLOSE_MODAL };
}

function hidePaymentConfirmationHeader() {
    return { type: PaymentHeaderActionType.HIDE_PAYMENT_LIC_HEADER };
}

function showPaymentConfirmationHeader() {
    return { type: PaymentHeaderActionType.SHOW_PAYMENT_LIC_HEADER };
}

function closeLicensePaymentModal() {
    return function (dispatch, getState) {
        var licensePaymentModalUIState = getState().licenseState.uiState.licensePaymentModalUIState;

        if (licensePaymentModalUIState == _constants.LicensePaymentModalUIState.LICENSE_SUCCESS || _constants.LicensePaymentModalUIState.LICENSE_PAYMENT_SUCCESS) {
            resetCart();
        }
        dispatch({ type: LicensePaymentActionType.LICENSE_PAYMENT_CLOSE });
    };
}

function closeChangePlanModal() {
    return { type: PlanChangeActionType.CHANGE_PLAN_CLOSE };
}

function getVideosAndSeatsFromPacks(addedPacks) {
    var addonVideos = 0,
        addonMembers = 0;
    Object.keys(addedPacks).map(function (k) {
        addedPacks[k].map(function (i) {
            if (k == 'video') {
                addonVideos += i.quantity * i.videos;
            } else if (k == 'member') {
                addonMembers += i.quantity * i.memberLimit;
            }
        });
    });
    return { addonVideos: addonVideos, addonMembers: addonMembers };
}

function stripeTokenReceived(paymentData) {
    return function (dispatch, getState) {
        var _getState$licenseStat9 = getState().licenseState.uiState,
            licensePlanId = _getState$licenseStat9.newPlanId,
            selectedPlanType = _getState$licenseStat9.selectedPlanType,
            cartCost = _getState$licenseStat9.cartCost;
        var _getState$licenseStat10 = getState().licenseState,
            _getState$licenseStat11 = _getState$licenseStat10.pricingData.licensePlans,
            licensePlans = _getState$licenseStat11 === undefined ? [] : _getState$licenseStat11,
            _getState$licenseStat12 = _getState$licenseStat10.cartInfo.addedPacks,
            addedPacks = _getState$licenseStat12 === undefined ? {} : _getState$licenseStat12;
        var _getState$licenseStat13 = getState().licenseState.workspaceInfo.activeWorkspace,
            activeWorkspace = _getState$licenseStat13 === undefined ? {} : _getState$licenseStat13;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        var _ref = licensePlans.find(function (lp) {
            return lp.planId == licensePlanId;
        }) || {},
            _ref$planName = _ref.planName,
            planName = _ref$planName === undefined ? '' : _ref$planName,
            _ref$videos = _ref.videos,
            videos = _ref$videos === undefined ? 0 : _ref$videos,
            _ref$memberLimit = _ref.memberLimit,
            memberLimit = _ref$memberLimit === undefined ? 0 : _ref$memberLimit;

        var _getVideosAndSeatsFro = getVideosAndSeatsFromPacks(addedPacks),
            addonVideos = _getVideosAndSeatsFro.addonVideos,
            addonMembers = _getVideosAndSeatsFro.addonMembers;

        var totalCost = cartCost,
            totalVideos = videos + addonVideos,
            totalMembers = memberLimit + addonMembers;

        dispatch({ type: LicensePaymentActionType.NEW_LICENSE_USE_TOKEN });

        var tokenId = paymentData.tokenId,
            _paymentData$cardLast = paymentData.cardLast4,
            cardLast4 = _paymentData$cardLast === undefined ? null : _paymentData$cardLast,
            _paymentData$cardBran = paymentData.cardBrand,
            cardBrand = _paymentData$cardBran === undefined ? null : _paymentData$cardBran;

        var newItemWithToken = function newItemWithToken() {
            return LicensePageApi.newLicenseWithTokenP(activeWorkspaceId, tokenId, licensePlanId, cardLast4, cardBrand, addedPacks);
        };

        if (selectedPlanType === PlanType.PACK) {
            newItemWithToken = function newItemWithToken() {
                return LicensePageApi.buyPacksWithTokenP(activeWorkspaceId, tokenId, cardLast4, cardBrand, addedPacks);
            };
            totalVideos -= videos;
            totalMembers -= memberLimit;
            planName = '';
        }

        _bluebird2.default.try(function () {
            return newItemWithToken();
        }).then(function (result) {
            return _handleLicenseResult(dispatch, result, { planName: planName, totalCost: totalCost, totalVideos: totalVideos, totalMembers: totalMembers, addedPacks: addedPacks });
        }).catch(function (err) {
            console.error(err);
        });
    };
}
function payUsingSavedCard() {
    return function (dispatch, getState) {
        var _getState$licenseStat14 = getState().licenseState.uiState,
            licensePlanId = _getState$licenseStat14.newPlanId,
            selectedPlanType = _getState$licenseStat14.selectedPlanType,
            cartCost = _getState$licenseStat14.cartCost;
        var _getState$licenseStat15 = getState().licenseState,
            _getState$licenseStat16 = _getState$licenseStat15.pricingData.licensePlans,
            licensePlans = _getState$licenseStat16 === undefined ? [] : _getState$licenseStat16,
            _getState$licenseStat17 = _getState$licenseStat15.cartInfo.addedPacks,
            addedPacks = _getState$licenseStat17 === undefined ? {} : _getState$licenseStat17;
        var _getState$licenseStat18 = getState().licenseState.workspaceInfo.activeWorkspace,
            activeWorkspace = _getState$licenseStat18 === undefined ? {} : _getState$licenseStat18;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        var _ref2 = licensePlans.find(function (lp) {
            return lp.planId == licensePlanId;
        }) || {},
            _ref2$planName = _ref2.planName,
            planName = _ref2$planName === undefined ? '' : _ref2$planName,
            _ref2$videos = _ref2.videos,
            videos = _ref2$videos === undefined ? 0 : _ref2$videos,
            _ref2$memberLimit = _ref2.memberLimit,
            memberLimit = _ref2$memberLimit === undefined ? 0 : _ref2$memberLimit;

        var _getVideosAndSeatsFro2 = getVideosAndSeatsFromPacks(addedPacks),
            addonVideos = _getVideosAndSeatsFro2.addonVideos,
            addonMembers = _getVideosAndSeatsFro2.addonMembers;

        var totalCost = cartCost,
            totalVideos = videos + addonVideos,
            totalMembers = memberLimit + addonMembers;

        dispatch({ type: LicensePaymentActionType.NEW_LICENSE_USE_SAVED_CARD });

        var newItemWithSavedCard = function newItemWithSavedCard() {
            return LicensePageApi.newLicenseWithSavedCardP(activeWorkspaceId, licensePlanId, addedPacks);
        };

        if (selectedPlanType === PlanType.PACK) {
            newItemWithSavedCard = function newItemWithSavedCard() {
                return LicensePageApi.buyPacksWithSavedCardP(activeWorkspaceId, addedPacks);
            };
            totalVideos -= videos;
            totalMembers -= memberLimit;
            planName = '';
        }

        _bluebird2.default.try(function () {
            return newItemWithSavedCard();
        }).then(function (result) {
            return _handleLicenseResult(dispatch, result, { planName: planName, totalCost: totalCost, totalVideos: totalVideos, totalMembers: totalMembers, addedPacks: addedPacks });
        }).catch(function (err) {
            console.error(err);
        });
    };
}

function paymentSuccess() {
    return function (dispatch, getState) {
        dispatch(fetchAndUpdateAccountData());

        dispatch({ type: LicensePaymentActionType.LICENSE_PAYMENT_SUCCESS });

        dispatch(showPaymentConfirmationHeader());

        setTimeout(function () {
            dispatch({ type: LicensePaymentActionType.LICENSE_PAYMENT_COMPLETE_FLOW });
        }, 2000);

        if (typeof qp !== 'undefined') {
            qp('track', 'Purchase');
        }
        if (typeof gtag !== 'undefined') {
            var _getState$licenseStat19 = getState().licenseState.uiState.cartCost,
                cartCost = _getState$licenseStat19 === undefined ? 0 : _getState$licenseStat19;

            gtag('event', 'conversion', {
                send_to: 'AW-869749754/GPNhCLuH8-kBEPqn3Z4D',
                value: cartCost,
                currency: 'USD'
            });
        }
    };
}

function updateAccountData(isLoggedIn, accountData) {
    return { type: UIActionType.UI_UPDATE_ACCOUNT_DATA, isLoggedIn: isLoggedIn, accountData: accountData };
}

function updateIntercomData(accountData) {
    return function (dispatch, getState) {
        try {
            var _accountData$ppvData = accountData.ppvData,
                _accountData$ppvData$ = _accountData$ppvData.ppvLifetimeVideos,
                ppvLifetimeVideos = _accountData$ppvData$ === undefined ? 0 : _accountData$ppvData$,
                _accountData$ppvData$2 = _accountData$ppvData.ppvLifetimeSpend,
                ppvLifetimeSpend = _accountData$ppvData$2 === undefined ? 0 : _accountData$ppvData$2,
                planType = accountData.planData.planType,
                _accountData$userData = accountData.userData.isUserEligibleForLicense,
                isUserEligibleForLicense = _accountData$userData === undefined ? false : _accountData$userData;

            var isPaidWorkspace = (0, _PlanUtils.checkIsPaidWorkspace)(planType);

            // if (!!window.Intercom && intercomEnabled) {
            //     window.Intercom('update', {
            //         ppvLifetimeVideos,
            //         ppvLifetimeSpend,
            //         userEligibleForLicense: isUserEligibleForLicense && !isPaidWorkspace
            //     });
            // }

            (0, _TrackUtils.updateUserOnFreshChat)({
                ppvLifetimeVideos: ppvLifetimeVideos,
                ppvLifetimeSpend: ppvLifetimeSpend,
                userEligibleForLicense: isUserEligibleForLicense && !isPaidWorkspace
            });
        } catch (err) {
            logger.error('Error updating Intercom data ' + err);
        }
    };
}

function fetchAndUpdateAccountData() {
    return function (dispatch, getState) {
        _bluebird2.default.try(function () {
            return UserApi.getAccountDetailsP();
        }).then(function (accountData) {
            dispatch(updateAccountData(accountData.isLoggedIn, accountData));
            dispatch({ type: WorkspaceActionType.UPDATE_WORKSPACES, workspaces: accountData.workspaces });
            dispatch(updateIntercomData(accountData));
        }).catch(function (err) {
            console.error(err);
        });
        return null;
    };
}

function paymentError(errorType, errorMessage) {
    return { type: LicensePaymentActionType.LICENSE_PAYMENT_ERROR, errorType: errorType, errorMessage: errorMessage };
}

function paymentClearError() {
    return function (dispatch, getState) {
        dispatch({ type: LicensePaymentActionType.LICENSE_PAYMENT_CLEARING_ERROR });
    };
}

function _handleLicenseResult(dispatch, result, cartInfo) {
    if (!!result.success) {
        var status = result.status,
            errorType = result.errorType,
            errorMessage = result.errorMessage;
        var planName = cartInfo.planName,
            totalCost = cartInfo.totalCost,
            totalVideos = cartInfo.totalVideos,
            totalMembers = cartInfo.totalMembers,
            addedPacks = cartInfo.addedPacks;
        var _addedPacks$video = addedPacks.video,
            videoPacks = _addedPacks$video === undefined ? [] : _addedPacks$video,
            _addedPacks$member = addedPacks.member,
            memberPacks = _addedPacks$member === undefined ? [] : _addedPacks$member;

        videoPacks = videoPacks.filter(function (vp) {
            return vp.quantity > 0;
        });
        memberPacks = memberPacks.filter(function (mp) {
            return mp.quantity > 0;
        });

        if (status === 'subscription_success') {
            // if(fullStoryEnabled && typeof Fullstory !== "undefined") {
            //     Fullstory.event('License started', {
            //         'Plan': planName,
            //         'Total Cost': totalCost,
            //         'Total Videos': totalVideos,
            //         'Total Members': totalMembers,
            //         'Video Packs': JSON.stringify(videoPacks.map(vp => ({ 'Pack': vp.packName, 'Cost': vp.cost, 'Quantity': vp.quantity }))),
            //         'Member Packs': JSON.stringify( memberPacks.map( mp => ({ 'Pack': mp.packName, 'Cost': mp.cost, 'Quantity': mp.quantity })))
            //     });
            // }
            dispatch(paymentSuccess());
        } else if (status === 'already_subscribed') {
            //Might be an entry point to upgrade/downgrade
            dispatch(paymentSuccess());
        } else if (status === 'payment_error') {
            dispatch(paymentError(errorType, errorMessage));
        } else if (status === 'payment_success' || status == 'add_members_success') {
            // if(fullStoryEnabled && typeof Fullstory !== "undefined") {
            //     Fullstory.event('Addon Packs Added', {
            //         'Total Cost': totalCost,
            //         'Total Videos': totalVideos,
            //         'Total Members': totalMembers,
            //         'Video Packs': JSON.stringify(videoPacks.map(vp => ({ 'Pack': vp.packName, 'Cost': vp.cost, 'Quantity': vp.quantity }))),
            //         'Member Packs': JSON.stringify( memberPacks.map( mp => ({ 'Pack': mp.packName, 'Cost': mp.cost, 'Quantity': mp.quantity })))
            //     });
            // }
            dispatch(paymentSuccess());
        } else {
            throw new Error('Unknown payment status');
        }
    } else {
        var errorCode = result.errorCode;

        if (errorCode == ValidationErrorCodes.INCONSISTENT_WORKSPACE) {
            window.location.reload();
        } else if (errorCode == 'add_members_failed') {
            dispatch(paymentSuccess());
        } else {
            throw new Error('Error getting payment status');
        }
    }
}

function changeWorkspace(workspaceId) {
    return function (dispatch, getState) {
        var _getState$licenseStat20 = getState().licenseState,
            activeWorkspace = _getState$licenseStat20.workspaceInfo.activeWorkspace,
            triggerPostSwitchAction = _getState$licenseStat20.uiState.triggerPostSwitchAction;

        if (activeWorkspace.workspaceId !== workspaceId) {
            return (0, _workspaceApi.switchWorkspaceP)(workspaceId).then(function () {
                window.location.reload();
            }).catch(function (err) {
                console.log('Could not switch workspace');
                console.error(err);
            });
        } else if (triggerPostSwitchAction) {
            dispatch(triggerPostLoginAction());
        }
    };
}

},{"../common/api/userApi":5,"../common/api/workspaceApi":6,"../common/utils/PlanUtils":83,"../common/utils/TrackUtils":90,"../license/LicensePageApi":258,"../pricing/PricingPageApi":264,"./constants":260,"bluebird":389,"keymirror":677}],260:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LicenseModalUIState = exports.ChangePlanModalUIState = exports.LicensePaymentModalUIState = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var LicensePaymentModalUIState = exports.LicensePaymentModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    CHECKING: null,
    WAITING_TOKEN: null,
    PROCESSING_TOKEN: null,
    LICENSE_PAYMENT_SUCCESS: null,
    LICENSE_PAYMENT_ERROR: null,
    LICENSE_SUCCESS: null
});

var ChangePlanModalUIState = exports.ChangePlanModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    PROCESSING: null,
    COMPLETE: null,
    FAILED: null
});

var LicenseModalUIState = exports.LicenseModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null
});

},{"keymirror":677}],261:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgotPasswordFormMode = exports.UpdateEmailFormMode = exports.ActivationFormMode = exports.ResetPasswordFormMode = exports.SignupFormMode = exports.LoginFormMode = exports.FormType = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var FormType = exports.FormType = (0, _keymirror2.default)({
    LOGIN: null,
    SIGNUP: null,
    FORGOT_PASSWORD: null,
    RESET_PASSWORD: null,
    ACTIVATION: null,
    UPDATE_EMAIL: null
});

var LoginFormMode = exports.LoginFormMode = (0, _keymirror2.default)({
    NONE: null,
    SIGNING_IN: null,
    SUCCESS: null,
    UNKNOWN_EMAIL: null,
    WRONG_PASSWORD: null,
    PASSWORD_NOT_SET: null,
    UNKNOWN_ERROR: null,
    INVALID_FORMAT_EMAIL: null,
    RATE_LIMIT_EXCEEDED: null
});

var SignupFormMode = exports.SignupFormMode = (0, _keymirror2.default)({
    NONE: null,
    SIGNING_UP: null,
    SUCCESS: null,
    INVALID_EMAIL: null,
    ALREADY_SIGNED_UP: null,
    SIGNUP_FAILED: null,
    INVALID_CAPTCHA: null,
    INVALID_FORMAT_EMAIL: null,
    INVALID_PASSWORD: null,
    RATE_LIMIT_EXCEEDED: null
});

var ResetPasswordFormMode = exports.ResetPasswordFormMode = (0, _keymirror2.default)({
    NONE: null,
    SETTING: null,
    SUCCESS: null,
    INVALID_TOKEN: null,
    ERROR: null
});

var ActivationFormMode = exports.ActivationFormMode = (0, _keymirror2.default)({
    NONE: null,
    REQUESTING: null,
    SUCCESS: null,
    ALREADY_ACTIVATED: null,
    TOKEN_EXPIRED: null,
    TOKEN_INVALID: null,
    INVALID_EMAIL: null,
    INVALID_USER: null,
    EMAIL_SEND_ERROR: null,
    ACTIVATION_FAILED: null,
    ERROR: null
});

var UpdateEmailFormMode = exports.UpdateEmailFormMode = (0, _keymirror2.default)({
    SUCCESS: null,
    TOKEN_EXPIRED: null,
    TOKEN_INVALID: null,
    EMAIL_UPDATATION_FAILED: null
});

var ForgotPasswordFormMode = exports.ForgotPasswordFormMode = (0, _keymirror2.default)({
    NONE: null,
    REQUESTING: null,
    UNKNOWN_EMAIL: null,
    SUCCESS: null,
    ERROR: null,
    RATE_LIMIT_EXCEEDED: null
});

},{"keymirror":677}],262:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.verifyOTPToken = exports.userOTPAuth = exports.LoginActionType = exports.isUpgradeNeeded = undefined;
exports.changeFullName = changeFullName;
exports.changeEmail = changeEmail;
exports.changePassword = changePassword;
exports.logout = logout;
exports.login = login;
exports.socialSignup = socialSignup;
exports.signup = signup;
exports.requestNewPassword = requestNewPassword;
exports.requestActivationLink = requestActivationLink;
exports.setNewPassword = setNewPassword;
exports.switchToForgotPassword = switchToForgotPassword;
exports.switchToSignUp = switchToSignUp;
exports.switchToLogin = switchToLogin;
exports.visitorSignup = visitorSignup;
exports.visitorSignin = visitorSignin;
exports.visitorSignupFromGoogle = visitorSignupFromGoogle;
exports.visitorSignupFromFacebook = visitorSignupFromFacebook;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _loginApis = require('./loginApis');

var loginApis = _interopRequireWildcard(_loginApis);

var _constants = require('./constants');

var _GeneralUtils = require('../common/utils/GeneralUtils');

var _ProjectApi = require('../edit/api/ProjectApi');

var _exportActions = require('../edit/actions/exportActions');

var _signUpModalActions = require('../edit/actions/signUpModalActions');

var _TrackUtils = require('../common/utils/TrackUtils');

var _planDataSelector = require('../edit/selectors/planDataSelector');

var _exportSelectors = require('../edit/selectors/exportSelectors');

var _selector = require('../pricing/selector');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Only on editor
var isUpgradeNeeded = exports.isUpgradeNeeded = function isUpgradeNeeded(state) {
    var isPaidWorkspace = state.workspaceInfo.activeWorkspace.isPaidWorkspace,
        _state$ui$freePremium = state.ui.freePremiumProjectData.isFreePremiumProject,
        isFreePremiumProject = _state$ui$freePremium === undefined ? false : _state$ui$freePremium;

    var _isProjectDurationExc = (0, _planDataSelector.isProjectDurationExceededSelector)(state),
        isProjectDurationExceeded = _isProjectDurationExc.isProjectDurationExceeded,
        isExportDurationExceeded = _isProjectDurationExc.isExportDurationExceeded;

    var shouldAccountForCaptionsInPaidPlan = false;
    var currentPlan = (0, _selector.getCurrentPlan)(state.pricingState);

    if (!!currentPlan && currentPlan.planVersion == 2) {
        var _currentPlan$planFeat = currentPlan.planFeatures;
        _currentPlan$planFeat = _currentPlan$planFeat === undefined ? {} : _currentPlan$planFeat;
        var _currentPlan$planFeat2 = _currentPlan$planFeat.captions,
            captions = _currentPlan$planFeat2 === undefined ? false : _currentPlan$planFeat2;

        shouldAccountForCaptionsInPaidPlan = !captions;
    }

    var premiumInstancesCount = (0, _exportSelectors.getPremiumInstancesCount)(shouldAccountForCaptionsInPaidPlan)(state);

    return isProjectDurationExceeded || isExportDurationExceeded || !isPaidWorkspace && premiumInstancesCount > 0 && !isFreePremiumProject;
};

var LoginActionType = exports.LoginActionType = (0, _keymirror2.default)({
    CHANGE_FULL_NAME: null,
    CHANGE_EMAIL: null,
    CHANGE_PASSWORD: null,
    CHANGE_FORMTYPE: null,
    CHANGE_FORMMODE: null
});

var actionChangeFormType = function actionChangeFormType(formtype) {
    var formmode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (formmode) {
        return { type: LoginActionType.CHANGE_FORMTYPE, formtype: formtype, formmode: formmode };
    }
    return { type: LoginActionType.CHANGE_FORMTYPE, formtype: formtype };
};

var actionChangeFormMode = function actionChangeFormMode(formmode) {
    return { type: LoginActionType.CHANGE_FORMMODE, formmode: formmode };
};

var validateInput = function validateInput(val) {
    return (0, _GeneralUtils.replaceFourByteChar)(val);
};

function changeFullName(fullname) {
    fullname = validateInput(fullname);
    return { type: LoginActionType.CHANGE_FULL_NAME, fullname: fullname };
}

function changeEmail(email) {
    email = validateInput(email);
    return { type: LoginActionType.CHANGE_EMAIL, email: email };
}

function changePassword(password) {
    return { type: LoginActionType.CHANGE_PASSWORD, password: password };
}

function logout() {
    return function (dispatch, getState) {
        loginApis.logoutUserP().then(function (response) {
            if (response.success) {
                window.location.reload();
            }
        });
        return null;
    };
}

function login() {
    return function (dispatch, getState) {
        var _getState = getState(),
            email = _getState.email,
            password = _getState.password,
            planId = _getState.planId,
            planCost = _getState.planCost,
            pla = _getState.pla,
            nextUrl = _getState.nextUrl;

        dispatch(actionChangeFormMode(_constants.LoginFormMode.SIGNING_IN));

        loginApis.loginUserP({ email: email, password: password }).then(function (response) {
            var result = response.result,
                redirectUrl = response.redirectUrl;

            if (response.success) {
                if (result == 'invalid_email' || result == 'user_unknown') {
                    dispatch(actionChangeFormMode(_constants.LoginFormMode.UNKNOWN_EMAIL));
                } else if (result == 'password_not_set') {
                    dispatch(actionChangeFormMode(_constants.LoginFormMode.PASSWORD_NOT_SET));
                } else if (result == 'invalid_format_email') {
                    dispatch(actionChangeFormMode(_constants.LoginFormMode.INVALID_FORMAT_EMAIL));
                } else if (result == 'user_unverified') {
                    dispatch(actionChangeFormType(_constants.FormType.ACTIVATION, _constants.ActivationFormMode.NONE));
                } else if (result == 'wrong_password') {
                    dispatch(actionChangeFormMode(_constants.LoginFormMode.WRONG_PASSWORD));
                } else if (result == 'logged_in') {
                    var mode = typeof window.embeddedModeFor === 'function' ? window.embeddedModeFor() : '';
                    if (mode === 'pricing' || mode === 'license') {
                        window.onLoginComplete(planId, planCost);
                    } else if (mode === 'template' || mode === 'lang-demo') {
                        window.onLoginComplete(pla);
                    } else if (mode === 'search') {
                        window.onLoginComplete();
                    } else {
                        dispatch(actionChangeFormMode(_constants.LoginFormMode.SUCCESS));
                        setTimeout(function () {
                            if (nextUrl !== undefined && nextUrl.trim() !== '') {
                                window.location.href = nextUrl;
                            } else window.location.href = redirectUrl;
                        }, 1000);
                    }
                }
            } else {
                if (result == 'request_limit_exceeded') {
                    dispatch(actionChangeFormMode(_constants.LoginFormMode.RATE_LIMIT_EXCEEDED));
                } else {
                    dispatch(actionChangeFormMode(_constants.LoginFormMode.UNKNOWN_ERROR));
                }
            }
        });
        return null;
    };
}

function socialSignup() {
    var postUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var isSignup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        var _getState2 = getState(),
            tp_su_source = _getState2.tp_su_source,
            nextUrl = _getState2.nextUrl;

        window.location.href = postUrl + '?nextUrl=' + encodeURIComponent(nextUrl) + '&tp_su_source=' + encodeURIComponent(tp_su_source) + '&isSignup=' + isSignup;
    };
}

function signup(recaptchaToken) {
    var optOutNewsletter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        var _getState3 = getState(),
            fullname = _getState3.fullname,
            email = _getState3.email,
            password = _getState3.password,
            referralCode = _getState3.referralCode,
            affiliateCode = _getState3.affiliateCode,
            tp_su_source = _getState3.tp_su_source,
            nextUrl = _getState3.nextUrl,
            planId = _getState3.planId,
            planCost = _getState3.planCost,
            pla = _getState3.pla;

        dispatch(actionChangeFormMode(_constants.SignupFormMode.SIGNING_UP));

        if (!recaptchaToken) {
            dispatch(actionChangeFormMode(_constants.SignupFormMode.INVALID_CAPTCHA));
            return;
        }

        dispatch(actionChangeFormMode(_constants.SignupFormMode.SIGNING_UP));

        loginApis.createNewUserP({
            fullname: fullname,
            email: email,
            password: password,
            referralCode: referralCode,
            affiliateCode: affiliateCode,
            tp_su_source: tp_su_source,
            recaptchaToken: recaptchaToken,
            optOutNewsletter: optOutNewsletter
        }).then(function (response) {
            var result = response.result;

            if (response.success) {
                if (result == 'invalid_email') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.INVALID_EMAIL));
                } else if (result == 'email_already_claimed') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.ALREADY_SIGNED_UP));
                } else if (result == 'invalid_format_email') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.INVALID_FORMAT_EMAIL));
                } else if (result == 'create_user_failed') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.SIGNUP_FAILED));
                } else if (result == 'invalid_captcha') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.INVALID_CAPTCHA));
                } else if (result == 'invalid_password') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.INVALID_PASSWORD));
                } else if (result == 'user_created') {
                    var trackingData = {
                        Name: '' + fullname,
                        'Via graphics': '' + (tp_su_source === 'graphics'),
                        'Via Language Demo': '' + (tp_su_source === 'lang-demo'),
                        Type: '' + recaptchaToken,
                        'Received initial credits': false
                    };
                    trackSignup(trackingData);

                    var mode = typeof window.embeddedModeFor === 'function' ? window.embeddedModeFor() : '';
                    if (mode === 'pricing' || mode === 'license') {
                        window.onLoginComplete(planId, planCost);
                    } else if (mode === 'template' || mode === 'lang-demo') {
                        window.onLoginComplete(pla);
                    } else if (mode === 'search') {
                        window.onLoginComplete();
                    } else {
                        dispatch(actionChangeFormMode(_constants.SignupFormMode.SUCCESS));
                        setTimeout(function () {
                            window.location.href = nextUrl || '/home?ft=1';
                        }, 1000);
                    }
                }
            } else {
                if (result == 'request_limit_exceeded') {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.RATE_LIMIT_EXCEEDED));
                } else {
                    dispatch(actionChangeFormMode(_constants.SignupFormMode.SIGNUP_FAILED));
                }
            }
        });

        return null;
    };
}

function trackSignup(trackingData) {
    if (typeof qp !== 'undefined') {
        qp('track', 'CompleteRegistration');
    }
    if (typeof ga !== 'undefined') {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Conversion',
            eventAction: 'User Signed up',
            eventLabel: 'Typito App',
            eventValue: '3'
        });
    }
    if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', { send_to: 'AW-869749754/DSOPCJvT2c4BEPqn3Z4D' });
    }

    (0, _TrackUtils.trackOnSmartlook)('User Signed up', trackingData);
}

function requestNewPassword() {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            email = _getState4.email;

        dispatch(actionChangeFormMode(_constants.ForgotPasswordFormMode.REQUESTING));

        loginApis.forgotPasswordP(email).then(function (response) {
            var result = response.result;

            if (response.success) {
                if (result == 'invalid_email' || result == 'user_unknown' || result == 'invalid_format_email') {
                    dispatch(actionChangeFormMode(_constants.ForgotPasswordFormMode.UNKNOWN_EMAIL));
                } else if (result == 'email_send_success') {
                    dispatch(actionChangeFormMode(_constants.ForgotPasswordFormMode.SUCCESS));
                } else if (result == 'email_send_error') {
                    dispatch(actionChangeFormMode(_constants.ForgotPasswordFormMode.ERROR));
                }
            } else {
                if (result == 'request_limit_exceeded') {
                    dispatch(actionChangeFormMode(_constants.ForgotPasswordFormMode.RATE_LIMIT_EXCEEDED));
                } else {
                    dispatch(actionChangeFormMode(_constants.ForgotPasswordFormMode.ERROR));
                }
            }
        });
        return null;
    };
}

function requestActivationLink() {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            email = _getState5.email;

        dispatch(actionChangeFormMode(_constants.ActivationFormMode.REQUESTING));

        loginApis.requestActivationLinkP(email).then(function (response) {
            if (response.success) {
                var result = response.result;

                if (result == 'invalid_email') {
                    dispatch(actionChangeFormMode(_constants.ActivationFormMode.INVALID_EMAIL));
                } else if (result == 'user_unknown') {
                    dispatch(actionChangeFormMode(_constants.ActivationFormMode.INVALID_USER));
                } else if (result == 'already_activated') {
                    dispatch(actionChangeFormMode(_constants.ActivationFormMode.ALREADY_ACTIVATED));
                } else if (result == 'email_send_success') {
                    dispatch(actionChangeFormMode(_constants.ActivationFormMode.SUCCESS));
                } else if (result == 'email_send_error') {
                    dispatch(actionChangeFormMode(_constants.ActivationFormMode.EMAIL_SEND_ERROR));
                }
            } else {
                dispatch(actionChangeFormMode(_constants.ActivationFormMode.ERROR));
            }
        });
        return null;
    };
}

function setNewPassword() {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            email = _getState6.email,
            password = _getState6.password,
            token = _getState6.token;

        var validEmail = false;
        if (email && email.trim() != '') {
            validEmail = true;
        }
        var validPassword = false;
        if (password && password.trim() != '') {
            validPassword = true;
        }

        if (!validEmail || !validPassword) {
            return;
        }

        dispatch(actionChangeFormMode(_constants.ResetPasswordFormMode.SETTING));

        loginApis.setPasswordP(email, password, token).then(function (response) {
            if (response.success) {
                var result = response.result;

                if (result == 'password_set_success') {
                    dispatch(actionChangeFormMode(_constants.ResetPasswordFormMode.SUCCESS));
                } else {
                    dispatch(actionChangeFormMode(_constants.ResetPasswordFormMode.ERROR));
                }
            } else {
                dispatch(actionChangeFormMode(_constants.ResetPasswordFormMode.ERROR));
            }
        });
        return null;
    };
}

function switchToForgotPassword() {
    return actionChangeFormType(_constants.FormType.FORGOT_PASSWORD);
}

function switchToSignUp() {
    return actionChangeFormType(_constants.FormType.SIGNUP);
}

function switchToLogin() {
    return function (dispatch, getState) {
        var _getState7 = getState(),
            formtype = _getState7.formtype;

        if (formtype === _constants.FormType.ACTIVATION) {
            window.location.assign('/login');
        } else if (formtype === _constants.FormType.RESET_PASSWORD) {
            window.location.assign('/login');
        } else {
            return dispatch(actionChangeFormType(_constants.FormType.LOGIN));
        }
    };
}

function visitorSignup(email, fullname, password) {
    return async function (dispatch, getState) {
        var onError = function onError(error) {
            return dispatch((0, _signUpModalActions.setNosignupError)(error));
        };
        var recaptchaToken = null;

        var _getState8 = getState(),
            _getState8$userData = _getState8.userData;

        _getState8$userData = _getState8$userData === undefined ? {} : _getState8$userData;
        var organizationType = _getState8$userData.organizationType;

        var response = await loginApis.createNewUserP({
            fullname: fullname,
            email: email,
            password: password,
            organizationType: organizationType,
            usedOTP: true
        });

        if (response.success) {
            var result = response.result;

            if (result == 'invalid_email') {
                onError(_constants.SignupFormMode.INVALID_EMAIL);
            } else if (result == 'email_already_claimed') {
                onError(_constants.SignupFormMode.ALREADY_SIGNED_UP);
            } else if (result == 'invalid_format_email') {
                onError(_constants.SignupFormMode.INVALID_FORMAT_EMAIL);
            } else if (result == 'create_user_failed') {
                onError(_constants.SignupFormMode.SIGNUP_FAILED);
            } else if (result == 'invalid_captcha') {
                onError(_constants.SignupFormMode.INVALID_CAPTCHA);
            } else if (result == 'user_created') {
                trackSignup();

                // const trackingData = {'Name': `${fullname}`, 'Via graphics' : `${false}`, "Via Language Demo": `${false}`, 'Type' : `${recaptchaToken}`,'Received initial credits': false}
                // // if(fullStoryEnabled && typeof Fullstory !== "undefined") {
                // //     Fullstory.event("Create new user", trackingData);
                // // }

                var state = getState();
                var _id = state.project.id;
                var _state$workspaceInfo$ = state.workspaceInfo.activeWorkspace,
                    workspaceId = _state$workspaceInfo$.workspaceId,
                    workspaceName = _state$workspaceInfo$.workspaceName,
                    role = _state$workspaceInfo$.role;
                var nosignupPostLoginOptions = state.ui.nosignupPostLoginOptions;

                await window.appManager.persistanceEngine.forceServerSyncP();

                if (!!nosignupPostLoginOptions && !!nosignupPostLoginOptions.postSignupAction) {
                    switch (nosignupPostLoginOptions.postSignupAction) {
                        case 'export':
                            if (isUpgradeNeeded(state)) {
                                window.location.href = '/edit/' + _id + '?openPremiumModal=true';
                            } else {
                                var exportId = await (0, _ProjectApi.exportVideoP)(_id);

                                // Make the redirect middleware to redirect to export page
                                dispatch((0, _exportActions.createdAction)());
                            }
                            break;
                        case 'payment':
                            window.location.href = '/edit/' + _id + '?openPayment=true&planId=' + nosignupPostLoginOptions.planId + ('&postPaymentAction=' + (nosignupPostLoginOptions.postPaymentAction || null));
                            break;
                        case 'free-trial':
                            window.location.href = '/edit/' + _id + '?startTrial=true';
                            break;
                        default:
                            window.location.href = '/edit/' + _id;
                            break;
                    }
                } else {
                    window.location.href = '/edit/' + _id;
                }
            }
        } else {
            onError('signup_failed');
        }
    };
}

function visitorSignin(email, password) {
    var otpToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return async function (dispatch, getState) {
        var onError = function onError(error) {
            return dispatch((0, _signUpModalActions.setNosignupError)(error));
        };
        var response = await loginApis.loginUserP({ email: email, password: password, otpToken: otpToken });
        if (response.success) {
            var result = response.result,
                redirectUrl = response.redirectUrl;

            if (result == 'invalid_email' || result == 'user_unknown') {
                onError(_constants.LoginFormMode.UNKNOWN_EMAIL);
            } else if (result == 'password_not_set') {
                onError(_constants.LoginFormMode.PASSWORD_NOT_SET);
            } else if (result == 'invalid_format_email') {
                onError(_constants.LoginFormMode.INVALID_FORMAT_EMAIL);
            } else if (result == 'user_unverified') {
                await window.appManager.persistanceEngine.forceServerSyncP();
                window.location.href = '/edit/' + id;
            } else if (result == 'wrong_password') {
                onError(_constants.LoginFormMode.WRONG_PASSWORD);
            } else if (result == 'logged_in') {
                var state = getState();
                var _id2 = state.project.id;
                var _state$workspaceInfo$2 = state.workspaceInfo.activeWorkspace,
                    workspaceId = _state$workspaceInfo$2.workspaceId,
                    workspaceName = _state$workspaceInfo$2.workspaceName,
                    role = _state$workspaceInfo$2.role;
                var nosignupPostLoginOptions = state.ui.nosignupPostLoginOptions;

                await window.appManager.persistanceEngine.forceServerSyncP();

                if (!!nosignupPostLoginOptions && !!nosignupPostLoginOptions.postSignupAction) {
                    switch (nosignupPostLoginOptions.postSignupAction) {
                        case 'export':
                            if (isUpgradeNeeded(state)) {
                                window.location.href = '/edit/' + _id2 + '?openPremiumModal=true';
                            } else {
                                var exportId = await (0, _ProjectApi.exportVideoP)(_id2);

                                // Make the redirect middleware to redirect to export page
                                dispatch((0, _exportActions.createdAction)());
                            }
                            break;
                        case 'payment':
                            window.location.href = '/edit/' + _id2 + '?openPayment=true&planId=' + nosignupPostLoginOptions.planId + ('&postPaymentAction=' + (nosignupPostLoginOptions.postPaymentAction || null));
                            break;
                        case 'free-trial':
                            window.location.href = '/edit/' + _id2 + '?startTrial=true';
                            break;
                        default:
                            window.location.href = '/edit/' + _id2;
                            break;
                    }
                } else {
                    window.location.href = '/edit/' + _id2;
                }
            } else if (result === 'wrong_otp') {
                dispatch((0, _signUpModalActions.onInvalidOTP)());
            }
        } else {
            onError(_constants.LoginFormMode.UNKNOWN_ERROR);
        }
    };
}

function visitorSignupFromGoogle(options) {
    return async function (dispatch, getState) {
        var tp_su_source = '';
        var postUrl = '/auth/googlelogin';

        // if(fullStoryEnabled && typeof Fullstory !== "undefined")
        //     Fullstory.event("User sign-up", { 'Signup via': 'Facebook' });

        var _getState$ui = getState().ui,
            postSignupAction = _getState$ui.postSignupAction,
            nosignupPostLoginOptions = _getState$ui.nosignupPostLoginOptions;

        await window.appManager.persistanceEngine.forceServerSyncP();

        var redirectUrl = postUrl + '?tp_su_source=' + encodeURIComponent(tp_su_source) + ('&isSignup=' + true) + ('&isVisitorSignup=' + true) + ('&postSignupAction=' + (postSignupAction || nosignupPostLoginOptions && nosignupPostLoginOptions.postSignupAction || null)) + ('&planId=' + (nosignupPostLoginOptions && nosignupPostLoginOptions.planId || null)) + ('&postPaymentAction=' + (nosignupPostLoginOptions && nosignupPostLoginOptions.postPaymentAction || null));
        window.location.href = redirectUrl;
    };
}

function visitorSignupFromFacebook(options) {
    return async function (dispatch, getState) {
        var tp_su_source = '';
        var postUrl = '/auth/facebooklogin';

        // if(fullStoryEnabled && typeof Fullstory !== "undefined")
        //     Fullstory.event("User sign-up", { 'Signup via': 'Google' });

        var _getState$ui2 = getState().ui,
            postSignupAction = _getState$ui2.postSignupAction,
            nosignupPostLoginOptions = _getState$ui2.nosignupPostLoginOptions;

        await window.appManager.persistanceEngine.forceServerSyncP();

        var redirectUrl = postUrl + '?tp_su_source=' + encodeURIComponent(tp_su_source) + ('&isSignup=' + true) + ('&isVisitorSignup=' + true) + ('&postSignupAction=' + (postSignupAction || null)) + ('&planId=' + (nosignupPostLoginOptions && nosignupPostLoginOptions.planId || null)) + ('&postPaymentAction=' + (nosignupPostLoginOptions && nosignupPostLoginOptions.postPaymentAction || null));

        window.location.href = redirectUrl;
    };
}

var userOTPAuth = exports.userOTPAuth = function userOTPAuth(email, generateOTP) {
    var isSignIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var allowOTPEntry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return async function (dispatch, getState) {
        var onError = function onError(error) {
            return dispatch((0, _signUpModalActions.setNosignupError)(error));
        };
        if (!allowOTPEntry) {
            dispatch((0, _signUpModalActions.onShowOTPSection)());
            return;
        }
        var response = await loginApis.generateOTPMailP(email, generateOTP);
        if (response.success) {
            switch (response.result) {
                case 'otp_mail_sent':
                    dispatch((0, _signUpModalActions.onShowOTPSection)(isSignIn || response.userExists));
                    return;
                case 'otp_mail_not_sent':
                    onError('Mail Not Sent');
                    return;
                case 'user_exists':
                    dispatch((0, _signUpModalActions.onShowPasswordSection)());

                default:
                    break;
            }
        } else {
            onError('Server Error');
        }
    };
};

var verifyOTPToken = exports.verifyOTPToken = function verifyOTPToken(otpToken, email) {
    var onError = function onError(error) {
        return dispatch((0, _signUpModalActions.setNosignupError)(error));
    };
    return async function (dispatch, getState) {
        var response = await loginApis.verifyOTPTokenP(otpToken, email);
        if (response.success) {
            switch (response.result) {
                case 'no_otp_generated':
                    onError(response.result);
                    return;
                case 'valid_otp':
                    dispatch((0, _signUpModalActions.onShowNameSection)());
                    return;
                case 'invalid_otp':
                    dispatch((0, _signUpModalActions.onInvalidOTP)());
                    return;
                default:
                    onError(response.result);
            }
        } else {
            onError('Server Error');
        }
    };
};

},{"../common/utils/GeneralUtils":77,"../common/utils/TrackUtils":90,"../edit/actions/exportActions":156,"../edit/actions/signUpModalActions":172,"../edit/api/ProjectApi":177,"../edit/selectors/exportSelectors":213,"../edit/selectors/planDataSelector":218,"../pricing/selector":268,"./constants":261,"./loginApis":263,"keymirror":677}],263:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createUserUsingGoogleToken = exports.verifyOTPTokenP = exports.generateOTPMailP = exports.signinVisitorUserP = exports.signupVisitorUserP = exports.logoutUserP = exports.setPasswordP = exports.forgotPasswordP = exports.requestActivationLinkP = exports.loginUserP = exports.createNewUserP = undefined;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var createNewUserP = exports.createNewUserP = function createNewUserP(_ref) {
    var fullname = _ref.fullname,
        email = _ref.email,
        password = _ref.password,
        organizationType = _ref.organizationType,
        _ref$usedOTP = _ref.usedOTP,
        usedOTP = _ref$usedOTP === undefined ? false : _ref$usedOTP,
        referralCode = _ref.referralCode,
        affiliateCode = _ref.affiliateCode,
        tp_su_source = _ref.tp_su_source,
        recaptchaToken = _ref.recaptchaToken,
        _ref$optOutNewsletter = _ref.optOutNewsletter,
        optOutNewsletter = _ref$optOutNewsletter === undefined ? false : _ref$optOutNewsletter;
    return _axios2.default.post('/api/user/createnewuser', {
        fullname: fullname,
        email: email,
        password: password,
        organizationType: organizationType,
        usedOTP: usedOTP,
        referralCode: referralCode,
        affiliateCode: affiliateCode,
        recaptchaToken: recaptchaToken,
        tp_su_source: tp_su_source,
        optOutNewsletter: optOutNewsletter
    }).then(function (res) {
        return res && res.data;
    }).catch(function (err) {
        return console.log('Failed creating a new user ' + err);
    });
};

var loginUserP = exports.loginUserP = function loginUserP(_ref2) {
    var email = _ref2.email,
        password = _ref2.password,
        otpToken = _ref2.otpToken;
    return _axios2.default.post('/api/user/loginuser', { email: email, password: password, otpToken: otpToken }).then(function (res) {
        return res && res.data;
    }).catch(function (err) {
        return console.log('Failed logging in a user ' + err);
    });
};

var requestActivationLinkP = exports.requestActivationLinkP = function requestActivationLinkP(email) {
    return _axios2.default.post('/api/user/requestactivationlink', { email: email }).then(function (res) {
        return res && res.data;
    }).catch(function (err) {
        return console.log('Failed to request activation link ' + err);
    });
};

var forgotPasswordP = exports.forgotPasswordP = function forgotPasswordP(email) {
    return _axios2.default.post('/api/user/forgotpassword', { email: email }).then(function (res) {
        return res && res.data;
    }).catch(function (err) {
        return console.log('Failed to request forgot-paswword link ' + err);
    });
};

var setPasswordP = exports.setPasswordP = function setPasswordP(email, password, token) {
    return _axios2.default.post('/api/user/setpassword', { email: email, password: password, token: token }).then(function (res) {
        return res && res.data;
    }).catch(function (err) {
        return console.log('Failed to set password ' + err);
    });
};

var logoutUserP = exports.logoutUserP = function logoutUserP() {
    return _axios2.default.post('/api/user/logoutuser').then(function (res) {
        if (typeof analytics !== 'undefined') {
            analytics.reset();
        }

        return res.data;
    }).catch(function (err) {
        return console.log('Failed to logout user ' + err);
    });
};

var signupVisitorUserP = exports.signupVisitorUserP = async function signupVisitorUserP(fullname, email, password, organizationType) {
    var res = await _axios2.default.post('/api/user/visitorSignup', {
        fullname: fullname,
        email: email,
        password: password,
        organizationType: organizationType
    });
    return res && res.data;
};

var signinVisitorUserP = exports.signinVisitorUserP = async function signinVisitorUserP(email, password, otpToken) {
    var res = await _axios2.default.post('/api/user/visitorSignin', {
        email: email,
        password: password,
        otpToken: otpToken
    });
    return res && res.data;
};

var generateOTPMailP = exports.generateOTPMailP = async function generateOTPMailP(email, generateOTP) {
    var res = await _axios2.default.post('/api/user/generateOTPToken', {
        email: email,
        generateOTP: generateOTP
    });
    return res && res.data;
};

var verifyOTPTokenP = exports.verifyOTPTokenP = async function verifyOTPTokenP(otpToken, email) {
    var res = await _axios2.default.post('/api/user/verifyOTPToken', {
        otpToken: otpToken,
        email: email
    });
    return res && res.data;
};

var createUserUsingGoogleToken = exports.createUserUsingGoogleToken = function createUserUsingGoogleToken(_ref3) {
    var idToken = _ref3.idToken,
        tp_su_source = _ref3.tp_su_source,
        _ref3$isSignup = _ref3.isSignup,
        isSignup = _ref3$isSignup === undefined ? false : _ref3$isSignup,
        _ref3$isVisitorSignup = _ref3.isVisitorSignup,
        isVisitorSignup = _ref3$isVisitorSignup === undefined ? false : _ref3$isVisitorSignup,
        postSignupAction = _ref3.postSignupAction,
        planId = _ref3.planId,
        postPaymentAction = _ref3.postPaymentAction;
    return _axios2.default.post('/auth/googletokenlogin', {
        id_token: idToken
    }, {
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            tp_su_source: tp_su_source,
            isSignup: isSignup,
            isVisitorSignup: isVisitorSignup,
            postSignupAction: postSignupAction,
            planId: planId,
            postPaymentAction: postPaymentAction
        }
    }).then(function (response) {
        var _response$data = response.data,
            redirectLink = _response$data.redirectLink,
            success = _response$data.success;

        if (success) {
            window.location.href = redirectLink;
        }
    }).catch(function (err) {
        console.error('Error while signing up user using google token: ' + err);
        throw err;
    });
};

},{"axios":335}],264:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestFreeTrialFromAdminP = exports.startOfferPlanP = exports.cancelShopifySubscriptionP = exports.newShopifySubscriptionP = exports.sendCustomPlanRequest = exports.pauseSubscriptionP = exports.cancelSubscriptionP = exports.changeSubscriptionP = exports.buySubscriptionPacksWithSavedCardP = exports.buySubscriptionPacksWithTokenP = exports.newSubscriptionWithSavedCardP = exports.newSubscriptionWithTokenP = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../common/constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var newSubscriptionWithTokenP = exports.newSubscriptionWithTokenP = function newSubscriptionWithTokenP(activeWorkspaceId, stripeToken, subscriptionPlanId, cardLast4, cardBrand) {
    var planQuantity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var triggerAction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    var apiCallParams = {
        activeWorkspaceId: activeWorkspaceId,
        stripeToken: stripeToken,
        subscriptionPlanId: subscriptionPlanId,
        cardLast4: cardLast4,
        cardBrand: cardBrand,
        planQuantity: planQuantity,
        triggerAction: triggerAction,
        useSavedCard: false
    };

    return callNewSubscriptionApi(apiCallParams).then(function (res) {
        return res;
    }).catch(function (err) {
        throw err;
    });
};

var newSubscriptionWithSavedCardP = exports.newSubscriptionWithSavedCardP = function newSubscriptionWithSavedCardP(activeWorkspaceId, subscriptionPlanId) {
    var planQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var triggerAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var apiCallParams = {
        activeWorkspaceId: activeWorkspaceId,
        subscriptionPlanId: subscriptionPlanId,
        planQuantity: planQuantity,
        triggerAction: triggerAction,
        useSavedCard: true
    };

    return callNewSubscriptionApi(apiCallParams).then(function (res) {
        return res;
    }).catch(function (err) {
        throw err;
    });
};

var buySubscriptionPacksWithTokenP = exports.buySubscriptionPacksWithTokenP = function buySubscriptionPacksWithTokenP(activeWorkspaceId, stripeToken, cardLast4, cardBrand, addedPacks) {
    var triggerAction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    return _axios2.default.post('/api/payment/buySubscriptionPacks', {
        activeWorkspaceId: activeWorkspaceId,
        addedPacks: addedPacks,
        stripeToken: stripeToken,
        cardLast4: cardLast4,
        cardBrand: cardBrand,
        useSavedCard: false,
        sourceView: (0, _constants.getSourceView)(),
        triggerAction: triggerAction
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var buySubscriptionPacksWithSavedCardP = exports.buySubscriptionPacksWithSavedCardP = function buySubscriptionPacksWithSavedCardP(activeWorkspaceId, addedPacks) {
    var triggerAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return _axios2.default.post('/api/payment/buySubscriptionPacks', {
        activeWorkspaceId: activeWorkspaceId,
        addedPacks: addedPacks,
        stripeToken: null,
        cardLast4: null,
        cardBrand: false,
        useSavedCard: true,
        sourceView: (0, _constants.getSourceView)(),
        triggerAction: triggerAction
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var changeSubscriptionP = exports.changeSubscriptionP = function changeSubscriptionP(activeWorkspaceId, newPlanId) {
    var planQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var triggerAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return _axios2.default.post('/api/payment/changeSubscription', {
        activeWorkspaceId: activeWorkspaceId,
        newPlanId: newPlanId,
        planQuantity: planQuantity,
        sourceView: (0, _constants.getSourceView)(),
        triggerAction: triggerAction
    }).then(function (res) {
        var stripe = Stripe(window.stripePublishableKey);
        if (res.data.clientSecret) {
            return stripe.confirmCardPayment(res.data.clientSecret, {
                setup_future_usage: 'off_session'
            }).then(function (result) {
                if (!!window.checkPaymentStatus) {
                    window.checkPaymentStatus();
                } else {
                    console.error('Failed to check payment status');
                }
                if (!!result.error) {
                    return {
                        success: true,
                        status: 'change_plan_failed',
                        errorType: result.error.type,
                        errorMessage: result.error.message
                    };
                }
                return res.data;
            });
        }
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var cancelSubscriptionP = exports.cancelSubscriptionP = function cancelSubscriptionP(activeWorkspaceId) {
    return _axios2.default.post('/api/payment/cancelSubscription', {
        activeWorkspaceId: activeWorkspaceId,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var pauseSubscriptionP = exports.pauseSubscriptionP = function pauseSubscriptionP(activeWorkspaceId) {
    return _axios2.default.post('/api/payment/pauseSubscription', {
        activeWorkspaceId: activeWorkspaceId,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var sendCustomPlanRequest = exports.sendCustomPlanRequest = function sendCustomPlanRequest(formData) {
    return _axios2.default.post('/api/admin/customPlanRequest', formData).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var newShopifySubscriptionP = exports.newShopifySubscriptionP = function newShopifySubscriptionP(activeWorkspaceId, subscriptionPlanId) {
    return _axios2.default.post('/api/shopify/newSubscription', {
        workspaceId: activeWorkspaceId,
        subscriptionPlanId: subscriptionPlanId,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        var _res$data = res.data,
            success = _res$data.success,
            confirmationUrl = _res$data.confirmationUrl;

        if (success) {
            window.location.href = confirmationUrl;
        }
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var cancelShopifySubscriptionP = exports.cancelShopifySubscriptionP = function cancelShopifySubscriptionP(workspaceId) {
    return _axios2.default.post('/api/shopify/cancelSubscription', {
        workspaceId: workspaceId,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var startOfferPlanP = exports.startOfferPlanP = function startOfferPlanP(_ref) {
    var workspaceId = _ref.workspaceId,
        offerPlanId = _ref.offerPlanId,
        triggerAction = _ref.triggerAction,
        editorType = _ref.editorType;
    return _axios2.default.post('/api/payment/startTrial', {
        workspaceId: workspaceId,
        offerPlanId: offerPlanId,
        triggerAction: triggerAction,
        editorType: editorType,
        sourceView: (0, _constants.getSourceView)()
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var requestFreeTrialFromAdminP = exports.requestFreeTrialFromAdminP = function requestFreeTrialFromAdminP(_ref2) {
    var projectId = _ref2.projectId,
        workspaceId = _ref2.workspaceId,
        offerPlanId = _ref2.offerPlanId;
    return _axios2.default.post('/api/workspace/requestFreeTrial', {
        projectId: projectId,
        workspaceId: workspaceId,
        offerPlanId: offerPlanId
    }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

var callNewSubscriptionApi = function callNewSubscriptionApi(apiCallParams) {
    return _axios2.default.post('/api/payment/newSubscription', _extends({}, apiCallParams, {
        sourceView: (0, _constants.getSourceView)()
    })).then(function (res) {
        var stripe = Stripe(window.stripePublishableKey);
        if (res.data.clientSecret) {
            return stripe.confirmCardPayment(res.data.clientSecret, {
                setup_future_usage: 'off_session'
            }).then(function (result) {
                if (!!window.checkPaymentStatus) {
                    window.checkPaymentStatus();
                } else {
                    console.error('Failed to check payment status');
                }
                if (!!result.error) {
                    return {
                        success: true,
                        status: 'payment_error',
                        errorType: result.error.type,
                        errorMessage: result.error.message
                    };
                }
                return res.data;
            });
        }
        return res.data;
    }).catch(function (err) {
        throw err;
    });
};

},{"../common/constants":61,"axios":335}],265:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WatermarkActionType = exports.TopupModalActionType = exports.WorkspaceActionType = exports.PaymentHeaderActionType = exports.PricingModalActionType = exports.UIActionType = exports.CustomPlanRequestActionType = exports.PlanChangeActionType = exports.ShopifyPaymentActionType = exports.SubscriptionPaymentActionType = undefined;
exports.purchasePlan = purchasePlan;
exports.purchaseAddon = purchaseAddon;
exports.setPlanQuantity = setPlanQuantity;
exports.triggerPostLoginAction = triggerPostLoginAction;
exports.openSubscriptionPaymentModal = openSubscriptionPaymentModal;
exports.skipPause = skipPause;
exports.changePlanComplete = changePlanComplete;
exports.changePlanFailed = changePlanFailed;
exports.pauseSubscriptionPlan = pauseSubscriptionPlan;
exports.onConfirmChangePlanModal = onConfirmChangePlanModal;
exports.switchToFreePlan = switchToFreePlan;
exports.closeSubscriptionPaymentModal = closeSubscriptionPaymentModal;
exports.closeCustomRequestPlanModal = closeCustomRequestPlanModal;
exports.onConfirmSendRequestPlanModal = onConfirmSendRequestPlanModal;
exports.purchaseCustomPlan = purchaseCustomPlan;
exports.closeChangePlanModal = closeChangePlanModal;
exports.stripeTokenReceived = stripeTokenReceived;
exports.payUsingSavedCard = payUsingSavedCard;
exports.buyShopifyPlan = buyShopifyPlan;
exports.paymentSuccess = paymentSuccess;
exports.updateAccountData = updateAccountData;
exports.updateIntercomData = updateIntercomData;
exports.fetchAndUpdateAccountData = fetchAndUpdateAccountData;
exports.paymentError = paymentError;
exports.paymentClearError = paymentClearError;
exports.showWorkspaceSelectModal = showWorkspaceSelectModal;
exports.closeWorkspaceSelectModal = closeWorkspaceSelectModal;
exports.changeWorkspace = changeWorkspace;
exports.openTopupModal = openTopupModal;
exports.closeTopupModal = closeTopupModal;
exports.openPricingModal = openPricingModal;
exports.closePricingModal = closePricingModal;
exports.hidePaymentConfirmationHeader = hidePaymentConfirmationHeader;
exports.showPaymentConfirmationHeader = showPaymentConfirmationHeader;
exports.showUpgradePlans = showUpgradePlans;
exports.openPlanModal = openPlanModal;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _PricingPageApi = require('../PricingPageApi');

var PricingPageApi = _interopRequireWildcard(_PricingPageApi);

var _userApi = require('../../common/api/userApi');

var UserApi = _interopRequireWildcard(_userApi);

var _workspaceApi = require('../../common/api/workspaceApi');

var _constants = require('../../common/constants');

var _TrackUtils = require('../../common/utils/TrackUtils');

var _PlanUtils = require('../../common/utils/PlanUtils');

var _selector = require('../selector');

var _constants2 = require('../constants');

var _overlaySelectors = require('../../edit/selectors/overlaySelectors');

var _subtitleSelectors = require('../../edit/selectors/subtitleSelectors');

var _miscSelectors = require('../../edit/selectors/miscSelectors');

var _LicenseActions = require('../../licenseModal/LicenseActions');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var SubscriptionPaymentActionType = exports.SubscriptionPaymentActionType = (0, _keymirror2.default)({
    SUBSCRIPTION_PAYMENT_OPEN: null,
    SUBSCRIPTION_PAYMENT_CLOSE: null,
    NEW_SUBSCRIPTION_USE_TOKEN: null,
    NEW_SUBSCRIPTION_USE_SAVED_CARD: null,
    PAYMENT_SUCCESS: null,
    PAYMENT_ERROR: null,
    PAYMENT_COMPLETE_FLOW: null,
    SUBSCRIPTION_PLAN_SELECT: null,
    SUBSCRIPTION_ADDON_SELECT: null,
    FREE_PLAN_SELECT: null,
    ADDON_SELECT: null,
    PAYMENT_CLEARING_ERROR: null
});

var ShopifyPaymentActionType = exports.ShopifyPaymentActionType = (0, _keymirror2.default)({
    REDIRECTING_TO_SHOPIFY: null,
    SHOPIFY_PAYMENT_SUCCESS: null,
    SHOPIFY_PAYMENT_ERROR: null
});

var PlanChangeActionType = exports.PlanChangeActionType = (0, _keymirror2.default)({
    CHANGE_PLAN_OPEN: null,
    CHANGE_PLAN_CLOSE: null,
    CHANGE_PLAN_CONFIRM: null,
    CHANGE_PLAN_COMPLETE: null,
    CHANGE_PLAN_FAILED: null
});

var CustomPlanRequestActionType = exports.CustomPlanRequestActionType = (0, _keymirror2.default)({
    CUSTOM_PLAN_REQUEST_OPEN: null,
    CUSTOM_PLAN_REQUEST_CLOSE: null,
    CUSTOM_PLAN_REQUEST_PROCESSING: null,
    CUSTOM_PLAN_REQUEST_CONFIRM: null,
    CUSTOM_PLAN_REQUEST_COMPLETE: null,
    CUSTOM_PLAN_REQUEST_FAILED: null
});

var UIActionType = exports.UIActionType = (0, _keymirror2.default)({
    UI_UPDATE_ACCOUNT_DATA: null,
    CLOSE_WORKSPACE_SELECT: null,
    SHOW_WORKSPACE_SELECT: null,
    CHANGE_WORKSPACE: null,
    CHANGE_SEAT_COUNT: null,
    SHOW_UPGRADE_PRICING: null
});

var PricingModalActionType = exports.PricingModalActionType = (0, _keymirror2.default)({
    CLOSE_PRICING_MODAL: null,
    OPEN_PRICING_MODAL: null
});

var PaymentHeaderActionType = exports.PaymentHeaderActionType = (0, _keymirror2.default)({
    HIDE_PAYMENT_SUB_HEADER: null,
    SHOW_PAYMENT_SUB_HEADER: null
});

var WorkspaceActionType = exports.WorkspaceActionType = (0, _keymirror2.default)({
    UPDATE_WORKSPACES: null
});

var TopupModalActionType = exports.TopupModalActionType = (0, _keymirror2.default)({
    OPEN_TOPUP_MODAL: null,
    CLOSE_TOPUP_MODAL: null
});

var WatermarkActionType = exports.WatermarkActionType = (0, _keymirror2.default)({
    WTM_WATERMARK_REMOVED: null
});

var ValidationErrorCodes = (0, _keymirror2.default)({
    INCONSISTENT_WORKSPACE: null
});

function purchasePlan(newPlanId, planCost) {
    var planQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var isLoggedIn = state.uiState.isLoggedIn,
            allWorkspaces = state.workspaceInfo.allWorkspaces;

        dispatch({
            type: SubscriptionPaymentActionType.SUBSCRIPTION_PLAN_SELECT,
            newPlanId: newPlanId,
            planCost: planCost,
            planQuantity: planQuantity,
            planType: _constants2.PlanType.SUBSCRIPTION
        });

        if (isLoggedIn) {
            // TODO -> remove if not needed once confirmed
            // if(allWorkspaces.length > 1) {
            //     dispatch(showWorkspaceSelectModal())
            // } else {
            // }
            dispatch(triggerPostLoginAction());
        } else if (window.openLoginForm) {
            window.openLoginForm(newPlanId, planCost);
        }
    };
}

function purchaseAddon(newPlanId, planCost) {
    var planQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);
        var isLoggedIn = state.uiState.isLoggedIn,
            planType = state.planData.planType;

        if (!(0, _PlanUtils.checkIsPaidWorkspace)(planType)) {
            return;
        }

        dispatch({
            type: SubscriptionPaymentActionType.SUBSCRIPTION_ADDON_SELECT,
            newPlanId: newPlanId,
            planCost: planCost,
            planQuantity: planQuantity,
            planType: _constants2.PlanType.ADDON
        });

        if (isLoggedIn) {
            dispatch(triggerPostLoginAction());
        } else if (window.openLoginForm) {
            window.openLoginForm(newPlanId, planCost);
        }
    };
}

function isDowngrade(currentPlanInst, selectedPlanInst) {
    var planVersion = selectedPlanInst.planVersion;

    var keyMetric = _constants2.PlanKeyMetric[planVersion];

    if (!!currentPlanInst && !!selectedPlanInst) {
        if (selectedPlanInst[keyMetric] < currentPlanInst[keyMetric]) {
            return true;
        }
        if (selectedPlanInst[keyMetric] == currentPlanInst[keyMetric]) {
            return selectedPlanInst.planCost < currentPlanInst.planCost;
        }
    }
    return false;
}

function setPlanQuantity() {
    var planQuantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return { type: UIActionType.CHANGE_SEAT_COUNT, planQuantity: planQuantity };
}

function triggerPostLoginAction() {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var _state$cartInfo = state.cartInfo,
            selectedPlanType = _state$cartInfo.selectedPlanType,
            newPlanCost = _state$cartInfo.planCost,
            newPlanId = _state$cartInfo.newPlanId,
            _state$cartInfo$planQ = _state$cartInfo.planQuantity,
            planQuantity = _state$cartInfo$planQ === undefined ? 1 : _state$cartInfo$planQ,
            _state$planData = state.planData,
            planType = _state$planData.planType,
            currentPlanMeta = _state$planData.meta,
            _state$planData$canPa = _state$planData.canPause,
            canPause = _state$planData$canPa === undefined ? false : _state$planData$canPa,
            activeWorkspace = state.workspaceInfo.activeWorkspace,
            subscriptionPlansMap = state.pricingData.subscriptionPlansMap;

        var subscriptionPlanList = [];
        Object.values(subscriptionPlansMap).forEach(function (map) {
            subscriptionPlanList = [].concat(_toConsumableArray(subscriptionPlanList), _toConsumableArray(map.subscriptionPlans));
        });

        if (activeWorkspace.role == 'ADMIN') {
            if (selectedPlanType === _constants2.PlanType.SUBSCRIPTION) {
                if (planType !== 'SUB') {
                    if (planType === 'LIC') {
                        // Request to cancel License Plan
                        dispatch({
                            type: PlanChangeActionType.CHANGE_PLAN_OPEN,
                            changeOperation: 'cancelLicense'
                        });
                    } else {
                        // Buy new plan
                        dispatch(openSubscriptionPaymentModal());
                    }
                } else if (newPlanId !== currentPlanMeta.subscriptionPlanId) {
                    var currentPlanInst = subscriptionPlanList.find(function (sp) {
                        return sp.planId === currentPlanMeta.subscriptionPlanId;
                    });

                    var selectedPlanInst = subscriptionPlanList.find(function (sp) {
                        return sp.planId === newPlanId;
                    });
                    var changeOperation = isDowngrade(currentPlanInst, selectedPlanInst) ? 'downgrade' : 'upgrade';

                    dispatch({
                        type: PlanChangeActionType.CHANGE_PLAN_OPEN,
                        changeOperation: changeOperation
                    });
                }
            } else if (selectedPlanType === _constants2.PlanType.FREE) {
                if ((0, _PlanUtils.checkIsPaidWorkspace)(planType)) {
                    // disabling pause option
                    // if(canPause){
                    //     dispatch({ type : PlanChangeActionType.CHANGE_PLAN_OPEN, changeOperation : 'pause' })
                    // } else {
                    dispatch({
                        type: PlanChangeActionType.CHANGE_PLAN_OPEN,
                        changeOperation: 'cancel'
                    });
                    // }
                } else {
                    // Go to home
                    window.location.href = '/home';
                }
            } else if (selectedPlanType === _constants2.PlanType.CUSTOM) {
                // dispatch(openSubscriptionPaymentModal())
            } else if (selectedPlanType === _constants2.PlanType.ADDON) {
                // Buy new plan
                dispatch(openSubscriptionPaymentModal());
            }
        }
    };
}

function openSubscriptionPaymentModal() {
    return {
        type: SubscriptionPaymentActionType.SUBSCRIPTION_PAYMENT_OPEN
    };
}

function skipPause() {
    return function (dispatch, getState) {
        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_OPEN, changeOperation: 'cancel' });
    };
}

function changePlanComplete() {
    return function (dispatch, getState) {
        dispatch(fetchAndUpdateAccountData());
        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_COMPLETE });
    };
}

function changePlanFailed() {
    return function (dispatch, getState) {
        dispatch(fetchAndUpdateAccountData());
        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_FAILED });
    };
}

function pauseSubscriptionPlan() {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var _state$workspaceInfo$ = state.workspaceInfo.activeWorkspace,
            activeWorkspace = _state$workspaceInfo$ === undefined ? {} : _state$workspaceInfo$;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        _bluebird2.default.try(function () {
            return PricingPageApi.pauseSubscriptionP(activeWorkspaceId);
        }).then(function (result) {
            if (result.success) {
                var status = result.status;
                // TODO modify

                if (status === 'subscription_pause_success' || status === 'already_paused') {
                    dispatch(changePlanComplete());
                } else {
                    dispatch(changePlanFailed());
                    throw new Error('Error pausing user plan');
                }
            } else if (result.status === ValidationErrorCodes.INCONSISTENT_WORKSPACE) {
                window.location.reload();
            } else {
                dispatch(changePlanFailed());
                throw new Error('Error pausing user plan');
            }
        }).catch(function (err) {
            console.error(err);
        });
    };
}

function onConfirmChangePlanModal() {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var _state$cartInfo2 = state.cartInfo,
            selectedPlanType = _state$cartInfo2.selectedPlanType,
            newPlanId = _state$cartInfo2.newPlanId,
            _state$workspaceInfo$2 = state.workspaceInfo.activeWorkspace,
            activeWorkspace = _state$workspaceInfo$2 === undefined ? {} : _state$workspaceInfo$2,
            _state$pricingData$is = state.pricingData.isShopifyUser,
            isShopifyUser = _state$pricingData$is === undefined ? false : _state$pricingData$is,
            _state$modalUIState$s = state.modalUIState.subscriptionModal.triggerAction,
            triggerAction = _state$modalUIState$s === undefined ? '' : _state$modalUIState$s;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        dispatch({ type: PlanChangeActionType.CHANGE_PLAN_CONFIRM });

        if (selectedPlanType === _constants2.PlanType.FREE) {
            _bluebird2.default.try(function () {
                if (isShopifyUser) {
                    return PricingPageApi.cancelShopifySubscriptionP(activeWorkspaceId);
                }
                return PricingPageApi.cancelSubscriptionP(activeWorkspaceId);
            }).then(function (result) {
                if (result.success) {
                    var status = result.status;

                    if (status === 'cancellation_success' || status === 'already_cancelled') {
                        (0, _TrackUtils.trackOnSmartlook)('Subscription cancelled (initiated)', {
                            sourceView: (0, _constants.getSourceView)(),
                            triggerAction: triggerAction
                        });
                        dispatch(changePlanComplete());
                    } else {
                        dispatch(changePlanFailed());
                        throw new Error('Error cancelling user plan');
                    }
                } else if (result.status === ValidationErrorCodes.INCONSISTENT_WORKSPACE) {
                    window.location.reload();
                } else {
                    dispatch(changePlanFailed());
                    throw new Error('Error cancelling user plan');
                }
            }).catch(function (err) {
                // Don't want to console log error object since that gives
                // out too much information to the end user.
                console.error('Error cancelling user plan');
            });
        } else if (selectedPlanType === _constants2.PlanType.SUBSCRIPTION) {
            var finalQuantity = (0, _selector.getPlanQuantity)(state);
            _bluebird2.default.try(function () {
                return PricingPageApi.changeSubscriptionP(activeWorkspaceId, newPlanId, finalQuantity, triggerAction);
            }).then(function (result) {
                if (result.success) {
                    var status = result.status,
                        _result$changeType = result.changeType,
                        changeType = _result$changeType === undefined ? '' : _result$changeType;

                    if (status === 'change_plan_successful') {
                        var eventName = changeType === 'upgrade' ? 'Subscription upgrade' : 'Subscription Downgrade';

                        dispatch(changePlanComplete());
                    } else {
                        dispatch(changePlanFailed());
                        throw new Error('Error changing user plan');
                    }
                } else if (result.errorCode == ValidationErrorCodes.INCONSISTENT_WORKSPACE) {
                    window.location.reload();
                } else {
                    dispatch(changePlanFailed());
                    throw new Error('Error changing user plan');
                }
            }).catch(function (err) {
                console.error(err);
            });
        }
    };
}

function switchToFreePlan() {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var isLoggedIn = state.uiState.isLoggedIn;

        dispatch(closePricingModal());
        dispatch({ type: SubscriptionPaymentActionType.FREE_PLAN_SELECT });

        if (isLoggedIn) {
            // if(allWorkspaces.length > 1) {
            //     dispatch(showWorkspaceSelectModal())
            // } else {
            dispatch(triggerPostLoginAction());
            // }
        } else if (window.openLoginForm) {
            window.openLoginForm();
        }
    };
}

function closeSubscriptionPaymentModal() {
    return { type: SubscriptionPaymentActionType.SUBSCRIPTION_PAYMENT_CLOSE };
}

function closeCustomRequestPlanModal() {
    return { type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_CLOSE };
}

function onConfirmSendRequestPlanModal(formData) {
    return function (dispatch, getState) {
        dispatch({ type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_PROCESSING });
        var errorMessage = '';
        var errorCode = false;
        var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
        if (!re.test(formData.email) || formData.email.length < 5) {
            console.log(re.test(formData.email));
            errorMessage += 'Invalid Email Address, \n';
            errorCode = true;
        }
        if (!parseInt(formData.videos, 10)) {
            errorMessage += ' Invalid Number of Videos, \n';
            errorCode = true;
        }
        if (formData.company.length < 2) {
            errorMessage += " Invalid Comapny's Name \n";
            errorCode = true;
        }
        if (errorCode) {
            dispatch({
                type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_FAILED,
                errorMessage: errorMessage
            });
        } else {
            _bluebird2.default.try(function () {
                return PricingPageApi.sendCustomPlanRequest(formData);
            }).then(function (result) {
                return _handleCustomPlanReqestResponse(dispatch, result);
            }).catch(function (err) {
                console.error(err);
                errorMessage = 'Something went wrong at our end. Please try again. Contact us via live chat if problem persists.';
                dispatch({
                    type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_FAILED,
                    errorMessage: errorMessage
                });
            });
        }
    };
}

function purchaseCustomPlan() {
    return { type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_OPEN };
}

function closeChangePlanModal() {
    return { type: PlanChangeActionType.CHANGE_PLAN_CLOSE };
}

function stripeTokenReceived(paymentData) {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);
        var _state$cartInfo3 = state.cartInfo,
            subscriptionPlanId = _state$cartInfo3.newPlanId,
            selectedPlanType = _state$cartInfo3.selectedPlanType,
            _state$workspaceInfo$3 = state.workspaceInfo.activeWorkspace,
            activeWorkspace = _state$workspaceInfo$3 === undefined ? {} : _state$workspaceInfo$3,
            _state$modalUIState$s2 = state.modalUIState.subscriptionModal.triggerAction,
            triggerAction = _state$modalUIState$s2 === undefined ? '' : _state$modalUIState$s2;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        dispatch({ type: SubscriptionPaymentActionType.NEW_SUBSCRIPTION_USE_TOKEN });

        var tokenId = paymentData.tokenId,
            _paymentData$cardLast = paymentData.cardLast4,
            cardLast4 = _paymentData$cardLast === undefined ? null : _paymentData$cardLast,
            _paymentData$cardBran = paymentData.cardBrand,
            cardBrand = _paymentData$cardBran === undefined ? null : _paymentData$cardBran;

        // const triggerAction = !!window.upgradeTriggerAction ? window.upgradeTriggerAction : null;

        window.upgradeTriggerAction = null;

        var finalQuantity = (0, _selector.getPlanQuantity)(state);

        _bluebird2.default.try(function () {
            var addedPacks = [];
            if (selectedPlanType === _constants2.PlanType.ADDON) {
                addedPacks.push({ planId: subscriptionPlanId, quantity: finalQuantity });

                return PricingPageApi.buySubscriptionPacksWithTokenP(activeWorkspaceId, tokenId, cardLast4, cardBrand, addedPacks, triggerAction);
            }
            return PricingPageApi.newSubscriptionWithTokenP(activeWorkspaceId, tokenId, subscriptionPlanId, cardLast4, cardBrand, finalQuantity, triggerAction);
        }).then(function (result) {
            return _handleSubscriptionResult(dispatch, result);
        }).catch(function (err) {
            console.error(err);
        });
    };
}
function payUsingSavedCard() {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var _state$cartInfo4 = state.cartInfo,
            subscriptionPlanId = _state$cartInfo4.newPlanId,
            selectedPlanType = _state$cartInfo4.selectedPlanType,
            _state$workspaceInfo$4 = state.workspaceInfo.activeWorkspace,
            activeWorkspace = _state$workspaceInfo$4 === undefined ? {} : _state$workspaceInfo$4,
            _state$modalUIState$s3 = state.modalUIState.subscriptionModal.triggerAction,
            triggerAction = _state$modalUIState$s3 === undefined ? '' : _state$modalUIState$s3;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        dispatch({ type: SubscriptionPaymentActionType.NEW_SUBSCRIPTION_USE_SAVED_CARD });

        // const triggerAction = !!window.upgradeTriggerAction ? window.upgradeTriggerAction : null;
        window.upgradeTriggerAction = null;

        var finalQuantity = (0, _selector.getPlanQuantity)(state);

        _bluebird2.default.try(function () {
            var addedPacks = [];
            if (selectedPlanType === _constants2.PlanType.ADDON) {
                addedPacks.push({ planId: subscriptionPlanId, quantity: finalQuantity });

                return PricingPageApi.buySubscriptionPacksWithSavedCardP(activeWorkspaceId, addedPacks, triggerAction);
            }
            return PricingPageApi.newSubscriptionWithSavedCardP(activeWorkspaceId, subscriptionPlanId, finalQuantity, triggerAction);
        }).then(function (result) {
            return _handleSubscriptionResult(dispatch, result);
        }).catch(function (err) {
            console.error(err);
        });
    };
}

function buyShopifyPlan(subscriptionPlanId) {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var _state$workspaceInfo$5 = state.workspaceInfo.activeWorkspace,
            activeWorkspace = _state$workspaceInfo$5 === undefined ? {} : _state$workspaceInfo$5;

        var activeWorkspaceId = activeWorkspace.workspaceId;

        dispatch({ type: ShopifyPaymentActionType.REDIRECTING_TO_SHOPIFY });

        _bluebird2.default.try(function () {
            return PricingPageApi.newShopifySubscriptionP(activeWorkspaceId, subscriptionPlanId);
        }).then(function () {
            (0, _TrackUtils.trackOnSmartlook)('Subscription started', {
                'Shopify User': 'true',
                sourceView: (0, _constants.getSourceView)()
            });
        }).catch(function (err) {
            console.error(err);
        });
    };
}

function paymentSuccess(status) {
    return function (dispatch, getState) {
        dispatch(fetchAndUpdateAccountData());

        dispatch({ type: SubscriptionPaymentActionType.PAYMENT_SUCCESS });

        setTimeout(function () {
            dispatch({ type: SubscriptionPaymentActionType.PAYMENT_COMPLETE_FLOW });
        }, 2000);

        var state = getRequiredPricingState(getState);

        var _state$planConfig = state.planConfig,
            planConfig = _state$planConfig === undefined ? {} : _state$planConfig,
            _state$cartInfo5 = state.cartInfo,
            _state$cartInfo5$plan = _state$cartInfo5.planCost,
            planCost = _state$cartInfo5$plan === undefined ? 0 : _state$cartInfo5$plan,
            newPlanId = _state$cartInfo5.newPlanId,
            subscriptionPlansMap = state.pricingData.subscriptionPlansMap;

        var subscriptionPlanList = [];
        Object.values(subscriptionPlansMap).forEach(function (map) {
            subscriptionPlanList = [].concat(_toConsumableArray(subscriptionPlanList), _toConsumableArray(map.subscriptionPlans));
        });

        var isPpvEnabled = planConfig.hasOwnProperty('ppvEnabled') && !!planConfig.ppvEnabled;
        if (!isPpvEnabled) {
            // to remove watermark in editor and export
            dispatch({ type: WatermarkActionType.WTM_WATERMARK_REMOVED });
        }

        var newPlanInst = subscriptionPlanList.find(function (sp) {
            return sp.planId == newPlanId;
        });

        if (typeof qp !== 'undefined') {
            qp('track', 'Purchase');
        }
        if (typeof gtag !== 'undefined') {
            gtag('event', 'conversion', {
                send_to: 'AW-869749754/MV31CKuo6M4BEPqn3Z4D',
                value: planCost,
                currency: 'USD'
            });
        }

        if (typeof ga !== 'undefined' && status === 'subscription_success') {
            var planDuration = newPlanInst.planDuration === 1 ? 'monthly' : 'annual';
            // only track new subscription event
            ga('send', {
                hitType: 'event',
                eventCategory: 'Conversion',
                eventAction: 'Subscription Started',
                eventLabel: newPlanInst.planName + '-' + planDuration,
                eventValue: planCost
            });
        }
    };
}

function updateAccountData(isLoggedIn, accountData) {
    return { type: UIActionType.UI_UPDATE_ACCOUNT_DATA, isLoggedIn: isLoggedIn, accountData: accountData };
}

function updateIntercomData(accountData) {
    return function (dispatch, getState) {
        try {
            var _accountData$ppvData = accountData.ppvData,
                _accountData$ppvData$ = _accountData$ppvData.ppvLifetimeVideos,
                ppvLifetimeVideos = _accountData$ppvData$ === undefined ? 0 : _accountData$ppvData$,
                _accountData$ppvData$2 = _accountData$ppvData.ppvLifetimeSpend,
                ppvLifetimeSpend = _accountData$ppvData$2 === undefined ? 0 : _accountData$ppvData$2,
                planType = accountData.planData.planType,
                _accountData$userData = accountData.userData.isUserEligibleForLicense,
                isUserEligibleForLicense = _accountData$userData === undefined ? false : _accountData$userData;

            var isPaidWorkspace = (0, _PlanUtils.checkIsPaidWorkspace)(planType);

            // if (!!window.Intercom && intercomEnabled) {
            //     window.Intercom('update', {
            //         ppvLifetimeVideos,
            //         ppvLifetimeSpend,
            //         userEligibleForLicense: isUserEligibleForLicense && !isPaidWorkspace,
            //     });
            // }

            (0, _TrackUtils.updateUserOnFreshChat)({
                ppvLifetimeVideos: ppvLifetimeVideos,
                ppvLifetimeSpend: ppvLifetimeSpend,
                userEligibleForLicense: isUserEligibleForLicense && !isPaidWorkspace
            });
        } catch (err) {
            logger.error('Error updating Intercom data ' + err);
        }
    };
}

function fetchAndUpdateAccountData() {
    return function (dispatch, getState) {
        _bluebird2.default.try(function () {
            return UserApi.getAccountDetailsP();
        }).then(function (accountData) {
            dispatch(updateAccountData(accountData.isLoggedIn, accountData));
            dispatch({
                type: WorkspaceActionType.UPDATE_WORKSPACES,
                workspaces: accountData.workspaces
            });
            dispatch(updateIntercomData(accountData));
        }).catch(function (err) {
            console.error(err);
        });
        return null;
    };
}

function paymentError(errorType, errorMessage) {
    return { type: SubscriptionPaymentActionType.PAYMENT_ERROR, errorType: errorType, errorMessage: errorMessage };
}

function paymentClearError() {
    return function (dispatch, getState) {
        dispatch({ type: SubscriptionPaymentActionType.PAYMENT_CLEARING_ERROR });
    };
}

function _handleSubscriptionResult(dispatch, result) {
    if (result.success) {
        var status = result.status,
            errorType = result.errorType,
            errorMessage = result.errorMessage;

        if (status === 'subscription_success') {
            (0, _TrackUtils.trackOnSmartlook)('Subscription started', {
                sourceView: (0, _constants.getSourceView)()
            });
            dispatch(paymentSuccess(status));
        } else if (status === 'already_subscribed') {
            // Might be an entry point to upgrade/downgrade
            dispatch(paymentSuccess(status));
        } else if (status === 'payment_success') {
            dispatch(paymentSuccess(status));
        } else if (status === 'payment_error') {
            dispatch(paymentError(errorType, errorMessage));
        } else {
            throw new Error('Unknown payment status');
        }
    } else {
        var errorCode = result.errorCode;

        if (errorCode === ValidationErrorCodes.INCONSISTENT_WORKSPACE) {
            window.location.reload();
        } else {
            throw new Error('Error getting payment status');
        }
    }
}

function _handleCustomPlanReqestResponse(dispatch, result) {
    if (result.success) {
        var status = result.status,
            errorType = result.errorType,
            errorMessage = result.errorMessage;

        if (status === 'request_success') {
            dispatch({ type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_CONFIRM });
        } else if (status === 'request_failed') {
            // Might be an entry point to upgrade/downgrade
            dispatch({
                type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_FAILED,
                errorMessage: errorMessage
            });
        } else {
            throw new Error('Unknown status');
            var _errorMessage = 'Unknown error occured. Please try after sometime.';
            dispatch({
                type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_FAILED,
                errorMessage: _errorMessage
            });
        }
    } else {
        var errorCode = result.errorCode,
            _errorMessage2 = result.errorMessage;

        dispatch({ type: CustomPlanRequestActionType.CUSTOM_PLAN_REQUEST_FAILED, errorMessage: _errorMessage2 });
        throw new Error('Error getting email status');
    }
}

function showWorkspaceSelectModal() {
    var triggerPostSwitchAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return function (dispatch) {
        dispatch({ type: UIActionType.SHOW_WORKSPACE_SELECT, triggerPostSwitchAction: triggerPostSwitchAction });
    };
}

function closeWorkspaceSelectModal() {
    return function (dispatch) {
        dispatch({ type: UIActionType.CLOSE_WORKSPACE_SELECT });
    };
}

function changeWorkspace(workspaceId) {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var activeWorkspace = state.workspaceInfo.activeWorkspace,
            triggerPostSwitchAction = state.uiState.triggerPostSwitchAction;

        if (activeWorkspace.workspaceId !== workspaceId) {
            return (0, _workspaceApi.switchWorkspaceP)(workspaceId).then(function () {
                window.location.reload();
            }).catch(function (err) {
                console.log('Could not switch workspace');
                console.error(err);
            });
        }
        if (triggerPostSwitchAction) {
            dispatch(triggerPostLoginAction());
        }
    };
}

function openTopupModal() {
    var triggerAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var isLoggedIn = state.uiState.isLoggedIn,
            planType = state.planData.planType;

        if (!(0, _PlanUtils.checkIsPaidWorkspace)(planType) || !isLoggedIn) {
            dispatch(openPricingModal());
        } else {
            dispatch({ type: TopupModalActionType.OPEN_TOPUP_MODAL, triggerAction: triggerAction });
        }
    };
}

function closeTopupModal() {
    return { type: TopupModalActionType.CLOSE_TOPUP_MODAL };
}

/**
 *
 * @param {string} triggerAction -> action that triggered opening of pricing modal
 * @param {boolean} showCancel -> shows plan cancel button on pricing modal if true.
 */
function openPricingModal() {
    var triggerAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var showCancel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        var showPlanWithFeatures = {};

        if ((0, _constants.getSourceView)() === 'edit') {
            var state = getState();

            var _getState = getState(),
                _getState$overlays = _getState.overlays,
                overlays = _getState$overlays === undefined ? {} : _getState$overlays,
                _getState$customForma = _getState.customFormats,
                customFormats = _getState$customForma === undefined ? [] : _getState$customForma,
                formatId = _getState.reel.formatId;

            // TODO: write selectors to get premium features which can be used here,
            // export and premium container and premium instance modal

            var captionsCount = (0, _subtitleSelectors.getNonPreviewSubtitleOverlayIds)(state);
            var hasUsedCaptions = captionsCount && Object.keys(captionsCount).length > 0;

            var selectedCustomFormat = (0, _miscSelectors.getSelectedCustomFormat)(state);
            var hasUsedCustomFormat = selectedCustomFormat && Object.keys(selectedCustomFormat).length > 0;

            var uniqueCustomFontsInCaptions = (0, _overlaySelectors.getUniqueCustomFontInCaptions)(state);
            var uniqueCustomFontsInNonCaptions = (0, _overlaySelectors.getUniqueCustomFontInNonCaptionOverlays)(state);
            var hasUsedCustomFont = uniqueCustomFontsInCaptions && uniqueCustomFontsInNonCaptions.length > 0 || uniqueCustomFontsInNonCaptions && uniqueCustomFontsInNonCaptions.length > 0;

            if (hasUsedCaptions) {
                showPlanWithFeatures.captions = true;
            }
            if (hasUsedCustomFont) {
                showPlanWithFeatures.customFont = true;
            }
            if (hasUsedCustomFormat) {
                showPlanWithFeatures.customFormat = true;
            }
        }

        dispatch({
            type: PricingModalActionType.OPEN_PRICING_MODAL,
            showCancel: showCancel,
            triggerAction: triggerAction,
            showPlanWithFeatures: showPlanWithFeatures
        });
    };
}

function closePricingModal() {
    return { type: PricingModalActionType.CLOSE_PRICING_MODAL };
}

function hidePaymentConfirmationHeader() {
    return { type: PaymentHeaderActionType.HIDE_PAYMENT_SUB_HEADER };
}

function showPaymentConfirmationHeader() {
    return { type: PaymentHeaderActionType.SHOW_PAYMENT_SUB_HEADER };
}

function showUpgradePlans() {
    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var _state$pricingData$is2 = state.pricingData.isUserEligibleForPlanVersionUpgrade,
            isUserEligibleForPlanVersionUpgrade = _state$pricingData$is2 === undefined ? false : _state$pricingData$is2;

        dispatch(closeChangePlanModal());

        if (isUserEligibleForPlanVersionUpgrade) {
            dispatch({ type: UIActionType.SHOW_UPGRADE_PRICING });
            dispatch(openPricingModal());
        }
    };
}

function openPlanModal() {
    var triggerAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var showCancel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);
        var _state$workspaceInfo$6 = state.workspaceInfo.activeWorkspace;
        _state$workspaceInfo$6 = _state$workspaceInfo$6 === undefined ? {} : _state$workspaceInfo$6;
        var _state$workspaceInfo$7 = _state$workspaceInfo$6.planType,
            planType = _state$workspaceInfo$7 === undefined ? 'PPV' : _state$workspaceInfo$7;

        var showLicenseDeal = planType === 'LIC';

        if (showLicenseDeal) {
            dispatch((0, _LicenseActions.openLicenseModal)(showCancel));
        } else {
            dispatch(openPricingModal(triggerAction, showCancel));
        }
    };
}

},{"../../common/api/userApi":5,"../../common/api/workspaceApi":6,"../../common/constants":61,"../../common/utils/PlanUtils":83,"../../common/utils/TrackUtils":90,"../../edit/selectors/miscSelectors":215,"../../edit/selectors/overlaySelectors":217,"../../edit/selectors/subtitleSelectors":224,"../../licenseModal/LicenseActions":259,"../PricingPageApi":264,"../constants":267,"../selector":268,"bluebird":389,"keymirror":677}],266:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addUserToWorkspace = addUserToWorkspace;
exports.removeUserFromWorkspace = removeUserFromWorkspace;
exports.openRemoveMemberModal = openRemoveMemberModal;
exports.closeRemoveMemberModal = closeRemoveMemberModal;
exports.closeAddMemberModal = closeAddMemberModal;
exports.openAddMemberModal = openAddMemberModal;
exports.openFormatSelectModal = openFormatSelectModal;
exports.closeFormatSelectModal = closeFormatSelectModal;
exports.setSelectedFormatId = setSelectedFormatId;
exports.clearSelectedFormatId = clearSelectedFormatId;
exports.openAiCreatorModal = openAiCreatorModal;
exports.setInitiatingAIProject = setInitiatingAIProject;
exports.closeAiCreatorModal = closeAiCreatorModal;
exports.setOpenFitnessEditor = setOpenFitnessEditor;
exports.clearOpenFitnessEditor = clearOpenFitnessEditor;
exports.setUseAICreator = setUseAICreator;
exports.clearUseAICreator = clearUseAICreator;
exports.closeCustomFormatModal = closeCustomFormatModal;
exports.openCustomFormatModal = openCustomFormatModal;
exports.createCustomFormat = createCustomFormat;
exports.removeCustomFormat = removeCustomFormat;

var _workspaceApi = require('../../common/api/workspaceApi');

var _ActionTypes = require('../../common/constants/ActionTypes');

var _GeneralUtils = require('../../common/utils/GeneralUtils');

var _constants = require('../../common/constants');

var _workspaceActions = require('../../home/actions/workspaceActions');

/**
 *
 * @param {number} workspaceId
 * @param {Array<{inviteeEmail: string, inviteeRole: string}>} inviteeData
 * Assuming that the above array only consists of non invited emails.
 */
function addUserToWorkspace(workspaceId) {
    var inviteeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function (dispatch, getState) {
        var state = getRequiredPricingState(getState);

        var activeWorkspace = state.workspaceInfo.activeWorkspace;

        if (!!inviteeData && inviteeData.length > 0) {
            return (0, _workspaceApi.addUserToWorkspaceP)(workspaceId, inviteeData).then(function () {
                inviteeData.forEach(function (_ref) {
                    var inviteeEmail = _ref.inviteeEmail,
                        inviteeRole = _ref.inviteeRole;

                    var trackingData = {
                        workspaceId: workspaceId,
                        workspaceName: activeWorkspace.workspaceName,
                        addedUserEmail: inviteeEmail,
                        role: inviteeRole
                    };

                    tracker.trackOnHeap('Added workspace member', trackingData);
                });

                dispatch({ type: _ActionTypes.AddMemberActionType.ADD_MEMBER_SUCCESS, inviteeData: inviteeData });
            }).catch(function (err) {
                dispatch({ type: _ActionTypes.AddMemberActionType.ADD_MEMBER_ERROR });
                console.log('Could not invite user to workspace');
                console.error(err);
            });
        }
    };
}

function removeUserFromWorkspace(emails, workspaceId) {
    return function (dispatch, getState) {
        return (0, _workspaceApi.removeUserFromWorkspaceP)(emails, workspaceId).then(function () {
            dispatch({
                type: _ActionTypes.RemoveMemberActionType.REMOVE_MEMBER_SUCCESS,
                emails: emails,
                workspaceId: workspaceId
            });
        }).catch(function (err) {
            dispatch({ type: _ActionTypes.RemoveMemberActionType.REMOVE_MEMBER_ERROR });
            console.log('Could not remove user from workspace');
            console.error(err);
        });
    };
}

function openRemoveMemberModal() {
    return { type: _ActionTypes.RemoveMemberActionType.OPEN_REMOVE_MEMBER_MODAL };
}

function closeRemoveMemberModal() {
    return { type: _ActionTypes.RemoveMemberActionType.CLOSE_REMOVE_MEMBER_MODAL };
}

function closeAddMemberModal() {
    return { type: _ActionTypes.AddMemberActionType.CLOSE_ADD_MEMBER_MODAL };
}

function openAddMemberModal() {
    return { type: _ActionTypes.AddMemberActionType.OPEN_ADD_MEMBER_MODAL };
}

function openFormatSelectModal() {
    return { type: _ActionTypes.FormatSelectActionType.OPEN_FORMAT_SELECT };
}

function closeFormatSelectModal() {
    return { type: _ActionTypes.FormatSelectActionType.CLOSE_FORMAT_SELECT };
}

function setSelectedFormatId(formatId) {
    return { type: _ActionTypes.FormatSelectActionType.SET_SELECTED_FORMAT_ID, formatId: formatId };
}

function clearSelectedFormatId() {
    return { type: _ActionTypes.FormatSelectActionType.CLEAR_SELECTED_FORMAT_ID };
}

function openAiCreatorModal() {
    return { type: _ActionTypes.AiCreatorActionType.OPEN_AI_CREATOR };
}

function setInitiatingAIProject() {
    return { type: _ActionTypes.AiCreatorActionType.CREATE_PROJECT };
}

function closeAiCreatorModal() {
    return { type: _ActionTypes.AiCreatorActionType.CLOSE_AI_CREATOR };
}

function setOpenFitnessEditor() {
    return { type: _ActionTypes.WorkflowInfoActionType.SET_OPEN_FITNESS_EDITOR };
}

function clearOpenFitnessEditor() {
    return { type: _ActionTypes.WorkflowInfoActionType.CLEAR_OPEN_FITNESS_EDITOR };
}

function setUseAICreator() {
    return { type: _ActionTypes.WorkflowInfoActionType.SET_USE_AI_CREATOR };
}

function clearUseAICreator() {
    return { type: _ActionTypes.WorkflowInfoActionType.CLEAR_USE_AI_CREATOR };
}

function closeCustomFormatModal() {
    return function (dispatch) {
        dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_CREATOR_CLOSE });
    };
}

function openCustomFormatModal() {
    return function (dispatch) {
        dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_CREATOR_OPEN });
    };
}

function createCustomFormat(formatObj) {
    return function (dispatch, getState) {
        dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_CREATOR_PROCESSING });

        var state = getRequiredPricingState(getState);

        var workspaceId = state.workspaceInfo.activeWorkspace.workspaceId;

        return (0, _workspaceApi.createCustomFormatP)(formatObj).then(function (res) {
            if (!res.success) {
                if (res.errorCode && res.errorCode == 'CUSTOM_FORMAT_LIMIT_REACHED') {
                    dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_LIMIT_REACHED });
                } else {
                    dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_CREATOR_FAIL });
                }
            } else {
                var customFormat = res.customFormat;

                var trackingData = {
                    workspaceId: workspaceId,
                    formatName: formatObj.name,
                    height: formatObj.height,
                    width: formatObj.width,
                    useCase: formatObj.useCase,
                    hasPadding: formatObj.hasPadding,
                    aspectRatio: (0, _GeneralUtils.getAspectRatio)(formatObj.width, formatObj.height),
                    sourceView: (0, _constants.getSourceView)()
                };

                tracker.trackOn('Custom Format Added', trackingData, {
                    PostHog: true,
                    Smartlook: true
                });

                dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_CREATOR_SUCCESS, customFormat: customFormat });
            }
        }).catch(function (err) {
            dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_CREATOR_FAIL });
            console.log('Could not create custom format');
            console.error(err);
        });
    };
}

function removeCustomFormat(formatKey) {
    return function (dispatch, getState) {
        dispatch({ type: _ActionTypes.CustomFormatActionType.FORMAT_REMOVED, formatKey: formatKey });
        var state = getRequiredPricingState(getState);

        var workspaceId = state.workspaceInfo.activeWorkspace.workspaceId;

        return (0, _workspaceApi.removeCustomFormatP)(formatKey).then(function (res) {
            // Do nothing
            var trackingData = {
                workspaceId: workspaceId,
                customFormatId: res.id,
                sourceView: (0, _constants.getSourceView)()
            };
            tracker.trackOn('Custom Format removed', trackingData, {
                Smartlook: true
            });
        }).catch(function (err) {
            console.log('Could not remove custom format');
            console.error(err);
        });
    };
}

},{"../../common/api/workspaceApi":6,"../../common/constants":61,"../../common/constants/ActionTypes":62,"../../common/utils/GeneralUtils":77,"../../home/actions/workspaceActions":254}],267:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PlanKeyMetric = exports.PlanDuration = exports.PlanType = exports.planVersions = exports.TopupModalUIState = exports.PricingModalUIState = exports.CustomPlanRequestModalUIState = exports.ChangePlanModalUIState = exports.SubscriptionModalUIState = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var SubscriptionModalUIState = exports.SubscriptionModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    CHECKING: null,
    WAITING_TOKEN: null,
    PROCESSING_TOKEN: null,
    PAYMENT_SUCCESS: null,
    PAYMENT_ERROR: null,
    SUBSCRIPTION_SUCCESS: null
});

var ChangePlanModalUIState = exports.ChangePlanModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    PROCESSING: null,
    COMPLETE: null,
    FAILED: null
});

var CustomPlanRequestModalUIState = exports.CustomPlanRequestModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null,
    CONFIRMED: null,
    PROCESSING: null,
    COMPLETE: null,
    FAILED: null
});

var PricingModalUIState = exports.PricingModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null
});

var TopupModalUIState = exports.TopupModalUIState = (0, _keymirror2.default)({
    CLOSED: null,
    OPEN: null
});

var planVersions = exports.planVersions = {
    v1: 1,
    v2: 2
};

var PlanType = exports.PlanType = (0, _keymirror2.default)({
    PPV: null,
    FREE: null,
    OFFER: null,
    SUBSCRIPTION: null,
    CUSTOM: null,
    ADDON: null
});

var PlanDuration = exports.PlanDuration = (0, _keymirror2.default)({
    annual: null,
    monthly: null
});

var PlanKeyMetric = exports.PlanKeyMetric = {
    1: 'videos',
    2: 'exportDurationLimitInMin'
};

},{"keymirror":677}],268:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canUpgradeSelector = exports.checkCanBuyBooster = exports.getPlanQuantity = exports.getCurrentPlan = exports.getSelectedPlan = exports.getNextBillingDate = exports.getSubscriptionAddonPacks = exports.getSubscriptionPlanList = undefined;

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _reselect = require('reselect');

var _TimeUtils = require('../common/utils/TimeUtils');

var _PlanUtils = require('../common/utils/PlanUtils');

var _FreePlan = require('../../../constants/FreePlan');

var _OfferPlan = require('../../../constants/OfferPlan');

var _constants = require('./constants');

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

var getSubscriptionPlansMap = function getSubscriptionPlansMap(state) {
    return state.pricingData.subscriptionPlansMap;
};

var getPlanVersion = function getPlanVersion(state) {
    return state.planData.planVersion;
};

var getSelectedPlanQuantity = function getSelectedPlanQuantity(state) {
    return state.cartInfo.planQuantity;
};

var getActiveWorkspace = function getActiveWorkspace(state) {
    return state.workspaceInfo.activeWorkspace;
};

var getSelectedPlanId = function getSelectedPlanId(state) {
    return state.cartInfo.newPlanId;
};
var getSelectedPlanType = function getSelectedPlanType(state) {
    return state.cartInfo.selectedPlanType;
};

var getCurrentPlanId = function getCurrentPlanId(state) {
    return !!state.planData && !!state.planData.meta && state.planData.meta.subscriptionPlanId;
};
var getCurrentPlanType = function getCurrentPlanType(state) {
    return !!state.workspaceInfo.activeWorkspace && state.workspaceInfo.activeWorkspace.planType;
};
var getCurrentOfferId = function getCurrentOfferId(state) {
    return !!state.planData && !!state.planData.meta && state.planData.meta.offerPlanId;
};

var getSubscriptionPlanList = exports.getSubscriptionPlanList = (0, _reselect.createSelector)([getSubscriptionPlansMap, getPlanVersion], function (subscriptionPlansMap, planVersion) {
    return !!subscriptionPlansMap && !!subscriptionPlansMap[planVersion] ? subscriptionPlansMap[planVersion].subscriptionPlans : [];
});

var getSubscriptionAddonPacks = exports.getSubscriptionAddonPacks = (0, _reselect.createSelector)([getSubscriptionPlansMap, getPlanVersion], function (subscriptionPlansMap, planVersion) {
    return !!subscriptionPlansMap && !!subscriptionPlansMap[planVersion] ? subscriptionPlansMap[planVersion].subscriptionAddonPacks : [];
});

var getNextBillingDate = exports.getNextBillingDate = (0, _reselect.createSelector)([getActiveWorkspace], function (workspace) {
    var planType = workspace.planType,
        planExpiryDate = workspace.planExpiryDate,
        _workspace$planMeta = workspace.planMeta;
    _workspace$planMeta = _workspace$planMeta === undefined ? {} : _workspace$planMeta;
    var _workspace$planMeta$p = _workspace$planMeta.paused,
        paused = _workspace$planMeta$p === undefined ? false : _workspace$planMeta$p,
        _workspace$planMeta$p2 = _workspace$planMeta.pauseMonthsLeft,
        pauseMonthsLeft = _workspace$planMeta$p2 === undefined ? 0 : _workspace$planMeta$p2,
        planInterval = _workspace$planMeta.planInterval,
        _workspace$planMeta$m = _workspace$planMeta.monthsLeft,
        monthsLeft = _workspace$planMeta$m === undefined ? 0 : _workspace$planMeta$m;

    var nextBillingDate = '';

    if ((0, _PlanUtils.checkIsPaidWorkspace)(planType)) {
        var planExpiry = new Date(planExpiryDate);

        if (planInterval === _constants.PlanDuration.annual) {
            planExpiry = planExpiry.setMonth(planExpiry.getMonth() + monthsLeft);
        } else if (!!paused && pauseMonthsLeft > 0) {
            planExpiry = planExpiry.setMonth(planExpiry.getMonth() + pauseMonthsLeft);
        }

        nextBillingDate = (0, _TimeUtils.toSimpleDate)(planExpiry);
    }

    return nextBillingDate;
});

var getSelectedPlan = exports.getSelectedPlan = (0, _reselect.createSelector)([getSubscriptionPlanList, getSubscriptionAddonPacks, getSelectedPlanId, getSelectedPlanType], function (subscriptionPlanList, subscriptionAddonPacks, newPlanId, newPlanType) {
    if (newPlanType === _constants.PlanType.FREE) {
        return _FreePlan.freePlan;
    }
    if (newPlanType === _constants.PlanType.ADDON) {
        return subscriptionAddonPacks.find(function (addonPack) {
            return addonPack.planId === newPlanId;
        });
    }
    return subscriptionPlanList.find(function (subscriptionPlan) {
        return subscriptionPlan.planId === newPlanId;
    });
});

var getCurrentPlan = exports.getCurrentPlan = (0, _reselect.createSelector)([getSubscriptionPlansMap, getCurrentPlanId, getCurrentPlanType, getPlanVersion, getCurrentOfferId], function (subscriptionPlansMap, currentPlanId, currentPlanType, planVersion, currentOfferId) {
    if (!!currentPlanType && currentPlanType === _constants.PlanType.PPV) {
        return _extends({}, _FreePlan.freePlan, { planVersion: planVersion });
    }
    if (!!currentPlanType && currentPlanType === _constants.PlanType.OFFER) {
        var currentOfferPlan = _OfferPlan.OfferPlans.find(function (plan) {
            return plan.planId === currentOfferId;
        });
        return _extends({}, currentOfferPlan, { planVersion: planVersion });
    }

    var allSubscriptions = [];

    if (subscriptionPlansMap) {
        Object.values(subscriptionPlansMap).forEach(function (map) {
            allSubscriptions = [].concat(_toConsumableArray(allSubscriptions), _toConsumableArray(map.subscriptionPlans));
        });
    }

    return allSubscriptions.find(function (subscriptionPlan) {
        return subscriptionPlan.planId === currentPlanId;
    });
});

var getPlanQuantity = exports.getPlanQuantity = (0, _reselect.createSelector)([getSelectedPlan, getSelectedPlanQuantity], function () {
    var selectedPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _FreePlan.freePlan;
    var planQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var _selectedPlan$planFea = selectedPlan.planFeatures;
    _selectedPlan$planFea = _selectedPlan$planFea === undefined ? {} : _selectedPlan$planFea;
    var _selectedPlan$planFea2 = _selectedPlan$planFea.canAddSeats,
        canAddSeats = _selectedPlan$planFea2 === undefined ? false : _selectedPlan$planFea2;

    return canAddSeats ? planQuantity : 1;
});

var checkCanBuyBooster = exports.checkCanBuyBooster = (0, _reselect.createSelector)([getCurrentPlanType], function (currentPlanType) {
    return (0, _PlanUtils.checkIsPaidWorkspace)(currentPlanType);
});

var canUpgradeSelector = exports.canUpgradeSelector = (0, _reselect.createSelector)([getCurrentPlan, getSubscriptionPlanList], function (currentPlan, subscriptionPlanList) {
    if (currentPlan) {
        var keyMetric = currentPlan.planVersion == 1 ? 'videos' : 'exportDurationLimitInMin';
        return subscriptionPlanList.some(function (s) {
            return s[keyMetric] > currentPlan[keyMetric];
        });
    }
    return true;
});

},{"../../../constants/FreePlan":308,"../../../constants/OfferPlan":310,"../common/utils/PlanUtils":83,"../common/utils/TimeUtils":89,"./constants":267,"reselect":1136}],269:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _file = require('react-player/file');

var _file2 = _interopRequireDefault(_file);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MEDIA_ASPECT_RATIO = 2.2 / 1;

var hoverPlayDisabled = function hoverPlayDisabled() {
    return window.useMobileBehavior && window.useMobileBehavior();
};

var staticBaseUrl = window.getStaticBaseUrl();

/**
 *
 *
 * @export
 * @class TemplateThumbComponent
 * @extends {Component}
 */

var TemplateThumbComponent = function (_Component) {
    _inherits(TemplateThumbComponent, _Component);

    function TemplateThumbComponent(props) {
        _classCallCheck(this, TemplateThumbComponent);

        var _this = _possibleConstructorReturn(this, (TemplateThumbComponent.__proto__ || Object.getPrototypeOf(TemplateThumbComponent)).call(this, props));

        _this.state = { playing: false, isRendered: false, isLoaded: false };

        _this.player = null;
        return _this;
    }

    _createClass(TemplateThumbComponent, [{
        key: 'onEnter',
        value: function onEnter() {
            if (hoverPlayDisabled()) {
                return;
            }
            this.setState({ playing: true });
        }
    }, {
        key: 'onLeave',
        value: function onLeave() {
            if (hoverPlayDisabled()) {
                return;
            }
            this.player.seekTo(0);
            this.setState({ playing: false });
        }
    }, {
        key: 'onHover',
        value: function onHover() {
            if (!this.state.isRendered) {
                this.setState({ isRendered: true });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            if (hoverPlayDisabled()) {
                this.player.seekTo(0);
                this.setState({ playing: true });
                e.preventDefault();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var t = this.props.template;

            var ar = this.props.autoAspectRatio ? MEDIA_ASPECT_RATIO : this.props.displayAspectRatio;

            var templateWrapperStyles = {
                paddingTop: 100 / ar + '%'
            };

            var vWidth = 100,
                vHeight = 100;
            if (ar > MEDIA_ASPECT_RATIO) {
                vWidth = 100;
                vHeight = 100 * ar / MEDIA_ASPECT_RATIO;
            } else {
                vHeight = 100;
                vWidth = 100 / ar * MEDIA_ASPECT_RATIO;
            }

            var videoStyles = {
                position: 'relative',
                width: vWidth + '%',
                height: vHeight + '%',
                left: '-' + (vWidth / 2 - 50) + '%',
                top: '-' + (vHeight / 2 - 50) + '%'
            };

            var playerNode = null;
            if (this.state.isRendered) {
                playerNode = _react2.default.createElement(_file2.default, {
                    className: 'react-player',
                    ref: function ref(c) {
                        _this2.player = c;
                    },
                    playing: this.state.playing,
                    onReady: function onReady() {
                        return _this2.setState({ isLoaded: true });
                    },
                    url: t.thumbnail_video_url,
                    width: '100%',
                    height: '100%',
                    config: {
                        file: {
                            attributes: {
                                style: videoStyles,
                                muted: true
                            }
                        }
                    }
                });
            }

            var linkHref = hoverPlayDisabled() ? 'javascript:;' : '/templates/' + t.id;

            var defaultTemplateUrl = staticBaseUrl + '/images/template-default.gif';

            return _react2.default.createElement('div', { className: 'template-tile', onMouseOver: function onMouseOver() {
                    return _this2.onHover();
                } }, _react2.default.createElement('div', { className: 'template-wrapper',
                style: templateWrapperStyles
            }, _react2.default.createElement('a', { href: linkHref,
                onClick: function onClick(e) {
                    return _this2.onClick(e);
                }
            }, _react2.default.createElement('div', { className: 'template-preview',
                onMouseEnter: function onMouseEnter(e) {
                    return _this2.onEnter();
                },
                onMouseLeave: function onMouseLeave(e) {
                    return _this2.onLeave();
                }
            }, _react2.default.createElement('div', { className: 'player-wrapper' }, playerNode, _react2.default.createElement('div', { className: 'poster-container' }, _react2.default.createElement('img', { className: 'poster', src: defaultTemplateUrl, 'data-src': t.thumbnail_image_url,
                style: _extends({}, videoStyles, {
                    visibility: this.state.isLoaded && this.state.playing ? 'hidden' : 'visible'
                }),
                alt: t.name
            })))))), _react2.default.createElement('div', { className: 'name', title: t.name }, t.name));
        }
    }]);

    return TemplateThumbComponent;
}(_react.Component);

TemplateThumbComponent.propTypes = {
    template: _propTypes2.default.object.isRequired,
    autoAspectRatio: _propTypes2.default.bool,
    displayAspectRatio: _propTypes2.default.number
};
TemplateThumbComponent.defaultProps = {
    autoAspectRatio: false,
    displayAspectRatio: MEDIA_ASPECT_RATIO
};
exports.default = TemplateThumbComponent;

},{"prop-types":896,"react":1107,"react-player/file":1043}],270:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var initializeDataLayer = exports.initializeDataLayer = function initializeDataLayer() {
    window.dataLayer = window.dataLayer || [];
};

var pushUserDataToDataLayer = exports.pushUserDataToDataLayer = function pushUserDataToDataLayer(userData) {
    if (window.dataLayer && userData) {
        window.dataLayer.push({
            event: "identify",
            userId: userData.id,
            userEmail: userData.email,
            firstName: userData.firstName,
            lastName: userData.lastName,
            userName: userData.firstName + " " + userData.lastName
        });
    }
};

var GTMAnalyticsService = exports.GTMAnalyticsService = {
    initializeDataLayer: initializeDataLayer,
    pushUserDataToDataLayer: pushUserDataToDataLayer
};

exports.default = GTMAnalyticsService;

},{}],271:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EDITOR_OVERLAY_SELECT = exports.EDITOR_OVERLAY_SELECT = 'EDITOR_OVERLAY_SELECT';
var EDITOR_OVERLAY_SELECT_CLEAR = exports.EDITOR_OVERLAY_SELECT_CLEAR = 'EDITOR_OVERLAY_SELECT_CLEAR';
var EDITOR_OVERLAY_TEXT_SET_FOCUS = exports.EDITOR_OVERLAY_TEXT_SET_FOCUS = 'EDITOR_OVERLAY_TEXT_SET_FOCUS';
var EDITOR_OVERLAY_CHANGE = exports.EDITOR_OVERLAY_CHANGE = 'EDITOR_OVERLAY_CHANGE';
var EDITOR_OVERLAY_MOVE = exports.EDITOR_OVERLAY_MOVE = 'EDITOR_OVERLAY_MOVE';
var EDITOR_OVERLAY_MOVE_MULTIPLE = exports.EDITOR_OVERLAY_MOVE_MULTIPLE = 'EDITOR_OVERLAY_MOVE_MULTIPLE';
var EDITOR_OVERLAY_RESIZE = exports.EDITOR_OVERLAY_RESIZE = 'EDITOR_OVERLAY_RESIZE';

var EDITOR_OVERLAY_SET_IN_ANIM = exports.EDITOR_OVERLAY_SET_IN_ANIM = 'EDITOR_OVERLAY_SET_IN_ANIM';
var EDITOR_OVERLAY_SET_IN_ANIM_DURATION = exports.EDITOR_OVERLAY_SET_IN_ANIM_DURATION = 'EDITOR_OVERLAY_SET_IN_ANIM_DURATION';
var EDITOR_OVERLAY_SET_IN_ANIM_DURATION_MANUAL_MODE = exports.EDITOR_OVERLAY_SET_IN_ANIM_DURATION_MANUAL_MODE = 'EDITOR_OVERLAY_SET_IN_ANIM_DURATION_MANUAL_MODE';
var EDITOR_OVERLAY_SET_OUT_TIME_FINISH = exports.EDITOR_OVERLAY_SET_OUT_TIME_FINISH = 'EDITOR_OVERLAY_SET_OUT_TIME_FINISH';

var EDITOR_OVERLAY_SET_OUT_ANIM = exports.EDITOR_OVERLAY_SET_OUT_ANIM = 'EDITOR_OVERLAY_SET_OUT_ANIM';
var EDITOR_OVERLAY_SET_OUT_ANIM_DURATION = exports.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION = 'EDITOR_OVERLAY_SET_OUT_ANIM_DURATION';
var EDITOR_OVERLAY_SET_OUT_ANIM_DURATION_MANUAL_MODE = exports.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION_MANUAL_MODE = 'EDITOR_OVERLAY_SET_OUT_ANIM_DURATION_MANUAL_MODE';

var EDITOR_FONT_LOADED = exports.EDITOR_FONT_LOADED = 'EDITOR_FONT_LOADED';
var EDITOR_REQUIRED_FONTS_LOADED = exports.EDITOR_REQUIRED_FONTS_LOADED = 'EDITOR_REQUIRED_FONTS_LOADED';

var EDITOR_VIDEO_EVENT_CHANGE_WAIT_MODE = exports.EDITOR_VIDEO_EVENT_CHANGE_WAIT_MODE = 'EDITOR_VIDEO_EVENT_CHANGE_WAIT_MODE';
var EDITOR_VIDEO_EVENT_CHANGE_PLAYBACK_STATE = exports.EDITOR_VIDEO_EVENT_CHANGE_PLAYBACK_STATE = 'EDITOR_VIDEO_EVENT_CHANGE_PLAYBACK_STATE';
var EDITOR_VIDEO_EVENT_CHANGE_CURRENT_TIME = exports.EDITOR_VIDEO_EVENT_CHANGE_CURRENT_TIME = 'EDITOR_VIDEO_EVENT_CHANGE_CURRENT_TIME';
var EDITOR_VIDEO_EVENT_CHANGE_DURATION = exports.EDITOR_VIDEO_EVENT_CHANGE_DURATION = 'EDITOR_VIDEO_EVENT_CHANGE_DURATION';
var EDITOR_VIDEO_EVENT_CHANGE_VOLUME = exports.EDITOR_VIDEO_EVENT_CHANGE_VOLUME = 'EDITOR_VIDEO_EVENT_CHANGE_VOLUME';

var EDITOR_VIDEO_PLAYER_PLAY = exports.EDITOR_VIDEO_PLAYER_PLAY = 'EDITOR_VIDEO_PLAYER_PLAY';
var EDITOR_VIDEO_PLAYER_PAUSE = exports.EDITOR_VIDEO_PLAYER_PAUSE = 'EDITOR_VIDEO_PLAYER_PAUSE';
var EDITOR_VIDEO_PLAYER_SEEK = exports.EDITOR_VIDEO_PLAYER_SEEK = 'EDITOR_VIDEO_PLAYER_SEEK';
var EDITOR_VIDEO_PLAYER_SET_VOLUME = exports.EDITOR_VIDEO_PLAYER_SET_VOLUME = 'EDITOR_VIDEO_PLAYER_SET_VOLUME';

var EDITOR_REEL_ADD_CLIP = exports.EDITOR_REEL_ADD_CLIP = 'EDITOR_REEL_ADD_CLIP';
var EDITOR_REEL_DELETE_CLIP = exports.EDITOR_REEL_DELETE_CLIP = 'EDITOR_REEL_DELETE_CLIP';

var EDITOR_BACKGROUND_SET = exports.EDITOR_BACKGROUND_SET = 'EDITOR_BACKGROUND_SET';

var HINT_OVERLAY_DISMISS = exports.HINT_OVERLAY_DISMISS = 'HINT_OVERLAY_DISMISS';
var HINT_PREVIEW_DISMISS = exports.HINT_PREVIEW_DISMISS = 'HINT_PREVIEW_DISMISS';
var HINT_BACKGROUND_DISMISS = exports.HINT_BACKGROUND_DISMISS = 'HINT_BACKGROUND_DISMISS';
var HINT_PREVIEW_SHOW = exports.HINT_PREVIEW_SHOW = 'HINT_PREVIEW_SHOW';
var HINT_BACKGROUND_SHOW = exports.HINT_BACKGROUND_SHOW = 'HINT_BACKGROUND_SHOW';

var API_USE_GRAPHIC_WORKING = exports.API_USE_GRAPHIC_WORKING = 'API_USE_GRAPHIC_WORKING';
var API_USE_GRAPHIC_PROJECT_READY = exports.API_USE_GRAPHIC_PROJECT_READY = 'API_USE_GRAPHIC_PROJECT_READY';
var API_USE_GRAPHIC_PROJECT_CLEAR = exports.API_USE_GRAPHIC_PROJECT_CLEAR = 'API_USE_GRAPHIC_PROJECT_CLEAR';
var API_USE_GRAPHIC_CLEAR = exports.API_USE_GRAPHIC_CLEAR = 'API_USE_GRAPHIC_CLEAR';
var API_SAVED_GRAPHIC = exports.API_SAVED_GRAPHIC = 'API_SAVED_GRAPHIC';
var API_SAVING_GRAPHIC = exports.API_SAVING_GRAPHIC = 'API_SAVING_GRAPHIC';
var API_EXPORTED_GRAPHIC = exports.API_EXPORTED_GRAPHIC = 'API_EXPORTED_GRAPHIC';
var API_START_EXPORTING_GRAPHIC = exports.API_START_EXPORTING_GRAPHIC = 'API_START_EXPORTING_GRAPHIC';
var API_RESET_GRAPHIC_EXPORT = exports.API_RESET_GRAPHIC_EXPORT = 'API_RESET_GRAPHIC_EXPORT';
var API_EXPORTING_GRAPHIC = exports.API_EXPORTING_GRAPHIC = 'API_EXPORTING_GRAPHIC';
var API_CANCELLED_GRAPHIC = exports.API_CANCELLED_GRAPHIC = 'API_CANCELLED_GRAPHIC';
var API_CANCELLING_GRAPHIC = exports.API_CANCELLING_GRAPHIC = 'API_CANCELLING_GRAPHIC';
var UPDATE_EXPORT_DURATION = exports.UPDATE_EXPORT_DURATION = 'UPDATE_EXPORT_DURATION';
var API_RESET_GRAPHIC_SAVE = exports.API_RESET_GRAPHIC_SAVE = 'API_RESET_GRAPHIC_SAVE';

var ACCOUNT_SESSION_UPDATE = exports.ACCOUNT_SESSION_UPDATE = 'ACCOUNT_SESSION_UPDATE';
var UPDATE_WORKSPACES = exports.UPDATE_WORKSPACES = 'UPDATE_WORKSPACES';

var PH_BEGIN_CROP = exports.PH_BEGIN_CROP = 'PH_BEGIN_CROP';
var PH_CANCEL_CROP = exports.PH_CANCEL_CROP = 'PH_CANCEL_CROP';
var PH_DONE_CROP = exports.PH_DONE_CROP = 'PH_DONE_CROP';

var SHOW_WORKSPACE_SELECT = exports.SHOW_WORKSPACE_SELECT = 'SHOW_WORKSPACE_SELECT';
var CHANGE_WORKSPACE = exports.CHANGE_WORKSPACE = 'CHANGE_WORKSPACE';
var CLOSE_WORKSPACE_SELECT = exports.CLOSE_WORKSPACE_SELECT = 'CLOSE_WORKSPACE_SELECT';

var SHOW_FORMAT_SELECT = exports.SHOW_FORMAT_SELECT = 'SHOW_FORMAT_SELECT';
var SELECT_FORMAT = exports.SELECT_FORMAT = 'SELECT_FORMAT';
var CLOSE_FORMAT_SELECT = exports.CLOSE_FORMAT_SELECT = 'CLOSE_FORMAT_SELECT';

var FORMAT_CREATOR_SUCCESS = exports.FORMAT_CREATOR_SUCCESS = 'FORMAT_CREATOR_SUCCESS';
var FORMAT_CREATOR_FAIL = exports.FORMAT_CREATOR_FAIL = 'FORMAT_CREATOR_FAIL';
var FORMAT_CREATOR_OPEN = exports.FORMAT_CREATOR_OPEN = 'FORMAT_CREATOR_OPEN';
var FORMAT_CREATOR_PROCESSING = exports.FORMAT_CREATOR_PROCESSING = 'FORMAT_CREATOR_PROCESSING';
var FORMAT_CREATOR_CLOSE = exports.FORMAT_CREATOR_CLOSE = 'FORMAT_CREATOR_CLOSE';
var FORMAT_LIMIT_REACHED = exports.FORMAT_LIMIT_REACHED = 'FORMAT_LIMIT_REACHED';

var UPDATE_TEMPLATE_EXPORT_PERCENT = exports.UPDATE_TEMPLATE_EXPORT_PERCENT = 'UPDATE_TEMPLATE_EXPORT_PERCENT';
var UPDATE_TEMPLATE_EXPORT_STATUS = exports.UPDATE_TEMPLATE_EXPORT_STATUS = 'UPDATE_TEMPLATE_EXPORT_STATUS';
var UPDATE_TEMPLATE_EXPORT_ID = exports.UPDATE_TEMPLATE_EXPORT_ID = 'UPDATE_TEMPLATE_EXPORT_ID';
var UPDATE_LAST_EXPORT_ID = exports.UPDATE_LAST_EXPORT_ID = 'UPDATE_LAST_EXPORT_ID';
var UPDATE_TEMPLATE_EXPORT_BALANCE = exports.UPDATE_TEMPLATE_EXPORT_BALANCE = 'UPDATE_TEMPLATE_EXPORT_BALANCE';
var DOWNLOAD_TEMPLATE_ERROR = exports.DOWNLOAD_TEMPLATE_ERROR = 'DOWNLOAD_TEMPLATE_ERROR';

},{}],272:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var io = require('socket.io-client');

var EV_TEMPLATE_EXPORT_UPDATE = 'EV_TEMPLATE_EXPORT_UPDATE';

var TemplateExportIOClient = function () {
    function TemplateExportIOClient(exportId) {
        _classCallCheck(this, TemplateExportIOClient);

        this._emitter = new EventEmitter();

        this.exportId = exportId;
    }

    _createClass(TemplateExportIOClient, [{
        key: 'addTemplateExportUpdateCallback',
        value: function addTemplateExportUpdateCallback(callback) {
            this._emitter.on(EV_TEMPLATE_EXPORT_UPDATE, callback);
            return this;
        }
    }, {
        key: 'start',
        value: function start() {
            var _this = this;

            this.socket = io('/clients', { transports: ['polling'] });

            this.socket.on('update', function (args) {
                var to = args.to;

                if (to == 'templateexport') {
                    var exportData = args.data;
                    _this._emitter.emit(EV_TEMPLATE_EXPORT_UPDATE, exportData);
                }
            });

            this.socket.emit('subscribe', { to: 'templateexport', id: this.exportId });
        }
    }]);

    return TemplateExportIOClient;
}();

exports.default = TemplateExportIOClient;

},{"events":629,"socket.io-client":1174}],273:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCustomFormatP = exports.cancelTemplateExportP = exports.getTemplateExportBalanceP = exports.getTemplateDownloadUrlP = exports.saveAndExportTemplateP = exports.saveTemplateP = exports.createProjectWithTemplateP = undefined;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _constants = require('../common/constants');

var _ActionTypes = require('./ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var createProjectWithTemplateP = exports.createProjectWithTemplateP = function createProjectWithTemplateP(formatId, templateId, config) {
    return _bluebird2.default.resolve($.ajax('/api/project/create', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ formatId: formatId, templateId: templateId, config: config })
    })).catch(function (err) {
        console.error('Error while creating project', err);
        throw err;
    });
};

var saveTemplateP = exports.saveTemplateP = function saveTemplateP(template, templateId, templateName) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/createTemplate', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            templateData: JSON.stringify(template),
            viaTemplatePage: true,
            templateId: templateId,
            templateName: templateName
        })
    })).then(function (responseData) {
        if (responseData.success) {
            return responseData;
        } else {
            if (responseData.needLogin) {
                window.location.href = responseData.loginUrl;
            }
        }
    }).catch(function (err) {
        console.error('Error while saving template', err);
        throw err;
    });
};

var saveAndExportTemplateP = exports.saveAndExportTemplateP = function saveAndExportTemplateP(template, templateId, templateName) {
    return _bluebird2.default.resolve($.ajax('/api/workspace/createAndExportTemplate', {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            templateData: JSON.stringify(template),
            viaTemplatePage: true,
            templateId: templateId,
            templateName: templateName
        })
    })).then(function (responseData) {
        if (responseData.success) {
            return responseData;
        } else {
            if (responseData.needLogin) {
                window.location.href = responseData.loginUrl;
            }
            if (responseData.result === 'request_limit_exceeded') {
                return responseData.result;
            }
        }
    }).catch(function (err) {
        throw err;
    });
};

var getTemplateDownloadUrlP = exports.getTemplateDownloadUrlP = function getTemplateDownloadUrlP(templateExportId, dispatch) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/export/getTemplateDownloadUrl/' + templateExportId).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                dispatch({ type: ActionTypes.DOWNLOAD_TEMPLATE_ERROR, errorState: false });
                return resolve(res.body.downloadUrl);
            }
            if (res.body.needLogin) {
                window.location.href = res.body.loginUrl;
            }
            if (res.body.errorReason) {
                if (res.body.errorReason === 'ACCOUNT_NOT_ACTIVATED') {
                    return reject(new Error('ACCOUNT_NOT_ACTIVATED'));
                }
            } else {
                dispatch({ type: ActionTypes.DOWNLOAD_TEMPLATE_ERROR, errorState: true });
            }
        });
    });
};

var getTemplateExportBalanceP = exports.getTemplateExportBalanceP = function getTemplateExportBalanceP() {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.get('/api/workspace/getTemplateExportBalance').end(function (err, res) {
            if (err) {
                return reject(err);
            }
            if (res.body.success) {
                return resolve(res.body.templateExportBalance);
            }
            if (res.body.needLogin) {
                window.location.href = res.body.loginUrl;
            } else {
                return reject(new Error('Error getting template export balance'));
            }
        });
    });
};

var cancelTemplateExportP = exports.cancelTemplateExportP = function cancelTemplateExportP(exportId, dispatch) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/export/cancelTemplateExport').send({ exportId: exportId }).end(function (err, res) {
            if (err) {
                return reject(err);
            }
            dispatch({ type: ActionTypes.API_CANCELLED_GRAPHIC });
            return resolve(res.body);
        });
    });
};

var createCustomFormatP = exports.createCustomFormatP = function createCustomFormatP(formatObj) {
    return new _bluebird2.default(function (resolve, reject) {
        _superagent2.default.post('/api/createFormat').send({
            formatObj: formatObj,
            sourceView: (0, _constants.getSourceView)()
        }).then(function (response) {
            resolve(response.body);
        }).catch(function (err) {
            console.error('Error while creating format', err);
            return {
                success: false
            };
        });
    });
};

},{"../common/constants":61,"./ActionTypes":271,"bluebird":389,"superagent":1193}],274:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResizeSensor = require('css-element-queries/src/ResizeSensor');

var _ResizeSensor2 = _interopRequireDefault(_ResizeSensor);

var _CorePlayerController = require('../../common/utils/CorePlayerController');

var _CorePlayerController2 = _interopRequireDefault(_CorePlayerController);

var _VideoPreviewContainer = require('../containers/editor/VideoPreviewContainer.react');

var _VideoPreviewContainer2 = _interopRequireDefault(_VideoPreviewContainer);

var _OverlayPreviewContainerReact = require('../containers/editor/OverlayPreviewContainer.react.js');

var _OverlayPreviewContainerReact2 = _interopRequireDefault(_OverlayPreviewContainerReact);

var _VideoInteractiveLayerContainer = require('../containers/editor/VideoInteractiveLayerContainer.react');

var _VideoInteractiveLayerContainer2 = _interopRequireDefault(_VideoInteractiveLayerContainer);

var _SelectionLayerContainerReact = require('../containers/editor/SelectionLayerContainer.react.js');

var _SelectionLayerContainerReact2 = _interopRequireDefault(_SelectionLayerContainerReact);

var _PropertiesBarContainerReact = require('../containers/editor/PropertiesBarContainer.react.js');

var _PropertiesBarContainerReact2 = _interopRequireDefault(_PropertiesBarContainerReact);

var _TextEditorLayerContainerReact = require('../containers/editor/TextEditorLayerContainer.react.js');

var _TextEditorLayerContainerReact2 = _interopRequireDefault(_TextEditorLayerContainerReact);

var _PlaceholderLayerContainerReact = require('../containers/editor/PlaceholderLayerContainer.react.js');

var _PlaceholderLayerContainerReact2 = _interopRequireDefault(_PlaceholderLayerContainerReact);

var _OverlayTutorialHintsLayerContainerReact = require('../containers/editor/OverlayTutorialHintsLayerContainer.react.js');

var _OverlayTutorialHintsLayerContainerReact2 = _interopRequireDefault(_OverlayTutorialHintsLayerContainerReact);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var GraphicsEditorRoot = function (_Component) {
	_inherits(GraphicsEditorRoot, _Component);

	function GraphicsEditorRoot(props) {
		_classCallCheck(this, GraphicsEditorRoot);

		// We don't expect this to change
		var _this = _possibleConstructorReturn(this, (GraphicsEditorRoot.__proto__ || Object.getPrototypeOf(GraphicsEditorRoot)).call(this, props));

		_this.corePlayer = new _CorePlayerController2.default();
		window.corePlayer = _this.corePlayer;

		_this.state = {
			scale: 1,
			left: 0,
			top: 0,
			width: 0,
			height: 0,
			rootWidth: 0
		};
		return _this;
	}

	_createClass(GraphicsEditorRoot, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			// Setup the resize sensor
			this.resizeSensor = new _ResizeSensor2.default(this.rootEl, function () {
				_this2.updateSize(_this2.rootEl.clientWidth, _this2.rootEl.clientHeight);
			});
			this.updateSize(this.rootEl.clientWidth, this.rootEl.clientHeight);

			this._documentClickCallback = function (e) {
				return _this2.onDocumentClick(e);
			};
			document.addEventListener('click', this._documentClickCallback);
			this.corePlayer.doSeek(0.5); // skips to first frame
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevProps.reelCanvas.width !== this.props.reelCanvas.width || prevProps.reelCanvas.height !== this.props.reelCanvas.height) {
				this.updateSize(this.rootEl.clientWidth, this.rootEl.clientHeight);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			// remove the resize sensor
			if (this.resizeSensor) {
				this.resizeSensor.detach();
				this.resizeSensor = null;
			}

			document.removeEventListener('click', this._documentClickCallback);
		}
	}, {
		key: 'onDocumentClick',
		value: function onDocumentClick(e) {
			var editorRoot = $(this.rootEl);

			if ($(e.target).closest(editorRoot).length <= 0) {

				this.props.onClickOutside();
			}
		}
	}, {
		key: 'updateSize',
		value: function updateSize(width, height) {
			var reelCanvas = this.props.reelCanvas;
			var canvasWidth = reelCanvas.width,
			    canvasHeight = reelCanvas.height;

			var scale = Math.min(width / canvasWidth, height / canvasHeight);

			var left = (width - scale * canvasWidth) / 2;
			var top = (height - scale * canvasHeight) / 2;

			this.setState({
				scale: scale,
				left: left,
				top: top,
				rootWidth: width,
				rootHeight: height
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props = this.props,
			    _props$reelCanvas = _props.reelCanvas,
			    canvasWidth = _props$reelCanvas.width,
			    canvasHeight = _props$reelCanvas.height,
			    isHoveringBackgrounds = _props.isHoveringBackgrounds,
			    hoveredBGSnapshotURL = _props.hoveredBGSnapshotURL;
			var _state = this.state,
			    left = _state.left,
			    top = _state.top,
			    scale = _state.scale,
			    rootWidth = _state.rootWidth,
			    rootHeight = _state.rootHeight;

			var playerCanvasStyles = {
				position: 'absolute',
				transform: 'scale(' + scale + ')',
				transformOrigin: 'top left',
				width: canvasWidth + 'px',
				height: canvasHeight + 'px',
				left: left + 'px',
				top: top + 'px',
				backgroundColor: 'transparent'
			};

			var scaledRootStyles = {
				position: 'absolute',
				left: left + 'px',
				top: top + 'px',
				width: canvasWidth * scale + 'px',
				height: canvasHeight * scale + 'px'
			};

			var hoveringBackgroundNode = null;
			if (isHoveringBackgrounds) {
				var hoveringBackgroundStyle = {
					position: 'absolute',
					left: left + 'px',
					top: top + 'px',
					width: canvasWidth * scale + 'px',
					height: canvasHeight * scale + 'px',
					backgroundImage: 'url(' + hoveredBGSnapshotURL + ')'
				};

				hoveringBackgroundNode = _react2.default.createElement('div', { className: 'no-mouse-events hovering-background', style: hoveringBackgroundStyle });
			}

			return _react2.default.createElement('div', { className: 'graphics-editor-root',
				ref: function ref(c) {
					_this3.rootEl = c;
				} }, _react2.default.createElement('div', {
				className: 'player-canvas-content',
				style: playerCanvasStyles,
				ref: function ref(c) {
					_this3.playerCanvasEl = c;
				} }, _react2.default.createElement(_VideoPreviewContainer2.default, { corePlayer: this.corePlayer }), _react2.default.createElement(_VideoInteractiveLayerContainer2.default, { displayScale: scale })), hoveringBackgroundNode, _react2.default.createElement('div', { className: 'no-mouse-events overlay-canvas-content', style: scaledRootStyles }, _react2.default.createElement(_OverlayPreviewContainerReact2.default, {
				displayScale: scale,
				corePlayer: this.corePlayer,
				isOverlayMode: true
			})), _react2.default.createElement('div', { className: 'no-mouse-events selection-canvas-content', style: scaledRootStyles }, _react2.default.createElement(_SelectionLayerContainerReact2.default, { displayScale: scale, isOverlayMode: true })), _react2.default.createElement('div', { className: 'no-mouse-events properties-text-canvas', style: scaledRootStyles }, _react2.default.createElement(_TextEditorLayerContainerReact2.default, { displayScale: scale })), _react2.default.createElement('div', { className: 'no-mouse-events properties-bar-canvas', style: scaledRootStyles }, _react2.default.createElement(_PlaceholderLayerContainerReact2.default, { displayScale: scale }), _react2.default.createElement(_PropertiesBarContainerReact2.default, { displayScale: scale, isOverlayMode: true,
				disableCopy: true, disableDelete: true
			}), _react2.default.createElement(_OverlayTutorialHintsLayerContainerReact2.default, { displayScale: scale })), this.props.children);
		}
	}]);

	return GraphicsEditorRoot;
}(_react.Component);

GraphicsEditorRoot.propTypes = {
	reelCanvas: _propTypes2.default.object.isRequired,
	isHoveringBackgrounds: _propTypes2.default.bool.isRequired,
	hoveredBGSnapshotURL: _propTypes2.default.string,
	onClickOutside: _propTypes2.default.func.isRequired
};
exports.default = GraphicsEditorRoot;

},{"../../common/utils/CorePlayerController":73,"../containers/editor/OverlayPreviewContainer.react.js":293,"../containers/editor/OverlayTutorialHintsLayerContainer.react.js":294,"../containers/editor/PlaceholderLayerContainer.react.js":295,"../containers/editor/PropertiesBarContainer.react.js":296,"../containers/editor/SelectionLayerContainer.react.js":297,"../containers/editor/TextEditorLayerContainer.react.js":298,"../containers/editor/VideoInteractiveLayerContainer.react":299,"../containers/editor/VideoPreviewContainer.react":300,"css-element-queries/src/ResizeSensor":546,"prop-types":896,"react":1107}],275:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ANIM_DUR = '0.2s';

var LoadingSpinner = function (_Component) {
    _inherits(LoadingSpinner, _Component);

    function LoadingSpinner() {
        _classCallCheck(this, LoadingSpinner);

        return _possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
    }

    _createClass(LoadingSpinner, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                children = _props.children,
                restProps = _objectWithoutProperties(_props, ['className', 'children']);

            return _react2.default.createElement('div', _extends({ className: (0, _classnames2.default)('loading-spinner', className) }, restProps), _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 120 120' }, _react2.default.createElement('g', { transform: 'rotate(-90 43 -17)' }, _react2.default.createElement('circle', { cx: '0', cy: '0', r: '8' }, _react2.default.createElement('animateTransform', { id: 'b', attributeName: 'transform', dur: ANIM_DUR, type: 'translate', values: '0 0; 14 0; 0 0', begin: '0;a.end' }))), _react2.default.createElement('g', { transform: 'rotate(-30 124.962 -145.406)' }, _react2.default.createElement('circle', { cx: '0', cy: '0', r: '8' }, _react2.default.createElement('animateTransform', { id: 'c', attributeName: 'transform', dur: ANIM_DUR, type: 'translate', values: '0 0; 14 0; 0 0', begin: 'b.end' }))), _react2.default.createElement('g', { transform: 'rotate(30 -98.962 205.406)' }, _react2.default.createElement('circle', { cx: '0', cy: '0', r: '8' }, _react2.default.createElement('animateTransform', { id: 'd', attributeName: 'transform', dur: ANIM_DUR, type: 'translate', values: '0 0; 14 0; 0 0', begin: 'c.end' }))), _react2.default.createElement('g', { transform: 'rotate(90 -17 77)' }, _react2.default.createElement('circle', { cx: '0', cy: '0', r: '8' }, _react2.default.createElement('animateTransform', { id: 'e', attributeName: 'transform', dur: ANIM_DUR, type: 'translate', values: '0 0; 14 0; 0 0', begin: 'd.end-0.02s' }))), _react2.default.createElement('g', { transform: 'rotate(150 4.962 42.594)' }, _react2.default.createElement('circle', { cx: '0', cy: '0', r: '8' }, _react2.default.createElement('animateTransform', { id: 'f', attributeName: 'transform', dur: ANIM_DUR, type: 'translate', values: '0 0; 14 0; 0 0', begin: 'e.end' }))), _react2.default.createElement('g', { transform: 'rotate(-150 21.038 17.406)' }, _react2.default.createElement('circle', { cx: '0', cy: '0', r: '8' }, _react2.default.createElement('animateTransform', { id: 'a', attributeName: 'transform', dur: ANIM_DUR, type: 'translate', values: '0 0; 14 0; 0 0', begin: 'f.end' })))));
        }
    }]);

    return LoadingSpinner;
}(_react.Component);

exports.default = LoadingSpinner;

},{"classnames":410,"prop-types":896,"react":1107}],276:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OverlayHintContainer = require('../containers/OverlayHintContainer.react');

var _OverlayHintContainer2 = _interopRequireDefault(_OverlayHintContainer);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var OverlayTutorialHintsLayer = function (_Component) {
    _inherits(OverlayTutorialHintsLayer, _Component);

    function OverlayTutorialHintsLayer() {
        _classCallCheck(this, OverlayTutorialHintsLayer);

        return _possibleConstructorReturn(this, (OverlayTutorialHintsLayer.__proto__ || Object.getPrototypeOf(OverlayTutorialHintsLayer)).apply(this, arguments));
    }

    _createClass(OverlayTutorialHintsLayer, [{
        key: 'render',
        value: function render() {
            var _props$overlayTargetB = this.props.overlayTargetBox,
                overlayTargetBox = _props$overlayTargetB === undefined ? null : _props$overlayTargetB;

            if (!overlayTargetBox) {
                return null;
            }

            var tutStyles = {
                position: 'absolute',
                left: overlayTargetBox.x + overlayTargetBox.width / 2 + 'px',
                top: overlayTargetBox.y + 'px'
            };

            return _react2.default.createElement('div', { className: 'fill-parent-size overlay-hint-layer' }, _react2.default.createElement(_OverlayHintContainer2.default, { position: 'above',
                targetSelector: '.overlay-node',
                animate: true,
                className: 'overlay-hint',
                style: {
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    left: overlayTargetBox.x + overlayTargetBox.width / 2 + 'px',
                    top: overlayTargetBox.y + 'px'
                }
            }, 'Click on the graphic', _react2.default.createElement('br', null), 'to select and customize'));
        }
    }]);

    return OverlayTutorialHintsLayer;
}(_react.Component);

OverlayTutorialHintsLayer.propTypes = {
    overlayTargetBox: _propTypes2.default.object
};
exports.default = OverlayTutorialHintsLayer;

},{"../containers/OverlayHintContainer.react":287,"prop-types":896,"react":1107}],277:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cropperjs = require('cropperjs');

var _cropperjs2 = _interopRequireDefault(_cropperjs);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PlaceholderArea = function (_Component) {
    _inherits(PlaceholderArea, _Component);

    function PlaceholderArea(props) {
        _classCallCheck(this, PlaceholderArea);

        var _this = _possibleConstructorReturn(this, (PlaceholderArea.__proto__ || Object.getPrototypeOf(PlaceholderArea)).call(this, props));

        _this.cropper = null;
        return _this;
    }

    _createClass(PlaceholderArea, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.isCropping) {
                this.onCroppingCancel();
            }
        }
    }, {
        key: 'onCroppingDone',
        value: function onCroppingDone(e) {
            var _cropper$getData = this.cropper.getData(),
                x = _cropper$getData.x,
                y = _cropper$getData.y,
                width = _cropper$getData.width,
                height = _cropper$getData.height;

            var _cropper$getCanvasDat = this.cropper.getCanvasData(),
                naturalWidth = _cropper$getCanvasDat.naturalWidth,
                naturalHeight = _cropper$getCanvasDat.naturalHeight;

            var xInCanvasPercent = x / naturalWidth * 100;
            var yInCanvasPercent = y / naturalHeight * 100;
            var widthInCanvasPercent = width / naturalWidth * 100;
            var heightInCanvasPercent = height / naturalHeight * 100;

            var cropData = {
                cropX: xInCanvasPercent,
                cropY: yInCanvasPercent,
                cropWidth: widthInCanvasPercent,
                cropHeight: heightInCanvasPercent
            };

            this.props.onCroppingDone(this.props.uid, cropData);
            this.destroyCropNode();
            e.stopProp;
        }
    }, {
        key: 'onCroppingCancel',
        value: function onCroppingCancel(e) {
            this.props.onCroppingCancel();
            this.destroyCropNode();
        }
    }, {
        key: 'onCroppingZoomIn',
        value: function onCroppingZoomIn(e) {
            this.cropper.zoom(0.1);
        }
    }, {
        key: 'onCroppingZoomOut',
        value: function onCroppingZoomOut(e) {
            this.cropper.zoom(-0.1);
        }
    }, {
        key: 'destroyCropNode',
        value: function destroyCropNode() {
            if (!!this.cropper) {
                this.cropper.destroy();
                this.cropper = null;
            }
        }
    }, {
        key: 'handleDoubleClick',
        value: function handleDoubleClick(e) {
            this.props.onCroppingStart();
            this.initializeCropper();
        }
    }, {
        key: 'onClickPlaceholderArea',
        value: function onClickPlaceholderArea() {
            if (!this.props.isCropping) {
                this.fileInput.click();
            }
        }
    }, {
        key: 'handleFileInput',
        value: function handleFileInput(e) {
            var _this2 = this;

            var inputFiles = e.target.files;
            var _props = this.props,
                onChangeImage = _props.onChangeImage,
                onCroppingStart = _props.onCroppingStart;

            var initializeCropper = function initializeCropper() {
                return _this2.initializeCropper();
            };

            if (inputFiles && inputFiles.length > 0) {
                var reader = new FileReader();

                var _inputFiles = _slicedToArray(inputFiles, 1),
                    file = _inputFiles[0];

                reader.addEventListener("load", function () {
                    onChangeImage(file, reader.result);
                    onCroppingStart();
                    initializeCropper();
                }, false);

                reader.readAsDataURL(file);
            }
            e.preventDefault();
        }
    }, {
        key: 'initializeCropper',
        value: function initializeCropper() {
            var _this3 = this;

            var _props2 = this.props,
                _props2$rect = _props2.rect,
                rectWidth = _props2$rect.width,
                rectHeight = _props2$rect.height,
                displayScale = _props2.displayScale,
                cropData = _props2.cropData;

            var boxWidth = rectWidth * displayScale;
            var boxHeight = rectHeight * displayScale;

            var cropCanvas = $(this.cropCanvas).get(0);

            var cropper = new _cropperjs2.default(cropCanvas, {
                aspectRatio: boxWidth / boxHeight,
                toggleDragModeOnDblclick: false,
                background: false,
                viewMode: 1,
                dragMode: 'move',
                autoCropArea: 1,
                minCropBoxWidth: 0,
                minCropBoxHeight: 0,
                minContainerWidth: 0,
                minContainerHeight: 0,
                minCanvasWidth: 0,
                minCanvasHeight: 0,
                restore: true,
                responsive: true,
                modal: true,
                guides: false,
                highlight: false,
                cropBoxMovable: false,
                cropBoxResizable: false,
                center: false,
                ready: function ready() {
                    var _cropper$getContainer = cropper.getContainerData(),
                        containerWidth = _cropper$getContainer.width,
                        containerHeight = _cropper$getContainer.height;

                    cropper.setCropBoxData({
                        left: containerWidth / 2,
                        top: containerHeight / 2,
                        width: boxWidth,
                        height: boxHeight
                    });
                    var naturalWidth = cropCanvas.naturalWidth,
                        naturalHeight = cropCanvas.naturalHeight;
                    var cropX = cropData.cropX,
                        cropY = cropData.cropY,
                        cropWidth = cropData.cropWidth,
                        cropHeight = cropData.cropHeight;

                    var widthRatio = naturalWidth / boxWidth;
                    var heightRatio = naturalHeight / boxHeight;
                    var minRatio = Math.min(widthRatio, heightRatio);

                    var offsetX = (naturalWidth / minRatio - boxWidth) / 2;
                    var offsetY = (naturalHeight / minRatio - boxHeight) / 2;

                    var _cropper$getCanvasDat2 = cropper.getCanvasData(),
                        canvasWidth = _cropper$getCanvasDat2.width,
                        canvasHeight = _cropper$getCanvasDat2.height;

                    var _cropper$getCropBoxDa = cropper.getCropBoxData(),
                        cropBoxLeft = _cropper$getCropBoxDa.left,
                        cropBoxTop = _cropper$getCropBoxDa.top;

                    var newCanvasWidth = boxWidth / cropWidth * 100;
                    var newCanvasHeight = boxHeight / cropHeight * 100;
                    var newCanvasLeft = cropBoxLeft - newCanvasWidth * cropX / 100;
                    var newCanvasTop = cropBoxTop - newCanvasHeight * cropY / 100;

                    var canvasData = {
                        left: newCanvasLeft,
                        top: newCanvasTop,
                        width: newCanvasWidth,
                        height: newCanvasHeight,
                        naturalWidth: naturalWidth,
                        naturalHeight: naturalHeight
                    };

                    cropper.setCanvasData(canvasData);
                    _this3.cropper = cropper;
                }
            });
        }
    }, {
        key: 'renderCropNode',
        value: function renderCropNode() {
            var _this4 = this;

            var _props3 = this.props,
                displayScale = _props3.displayScale,
                rect = _props3.rect,
                cropImageUrl = _props3.cropImageUrl,
                isCropping = _props3.isCropping;

            var cropControlStyles = {
                left: rect.x * displayScale + 'px',
                top: rect.y * displayScale + 'px'
            };

            var cropControlsNode = null;

            if (!!isCropping) {
                cropControlsNode = _react2.default.createElement('div', { className: 'crop-controls' }, _react2.default.createElement('div', { className: 'crop-done', title: 'Done', onClick: function onClick(e) {
                        return _this4.onCroppingDone(e);
                    } }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'crop-done' })), _react2.default.createElement('div', { className: 'crop-cancel', title: 'Cancel', onClick: function onClick(e) {
                        return _this4.onCroppingCancel(e);
                    } }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'crop-cancel' })), _react2.default.createElement('div', { className: 'zoom-in', title: 'Zoom In', onClick: function onClick(e) {
                        return _this4.onCroppingZoomIn(e);
                    } }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'zoom-in' })), _react2.default.createElement('div', { className: 'zoom-out', title: 'Zoom Out', onClick: function onClick(e) {
                        return _this4.onCroppingZoomOut(e);
                    } }, _react2.default.createElement(_SVGIcon2.default, { width: '100%', height: '100%', iconId: 'zoom-out' })));
            }
            var cropContainerStyles = {
                pointerEvents: isCropping ? 'auto' : 'none'
            };

            return _react2.default.createElement('div', { className: 'crop-wrapper' }, cropControlsNode, _react2.default.createElement('div', { className: 'crop-container', style: cropContainerStyles }, _react2.default.createElement('img', { style: { maxWidth: '100%', display: 'none' },
                ref: function ref(c) {
                    _this4.cropCanvas = c;
                }, src: cropImageUrl })));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props4 = this.props,
                displayScale = _props4.displayScale,
                rect = _props4.rect,
                showInfo = _props4.showInfo;

            var placeholderAreaStyles = {
                left: rect.x * displayScale + 'px',
                top: rect.y * displayScale + 'px',
                width: rect.width * displayScale + 'px',
                height: rect.height * displayScale + 'px'
            };

            var infoNode = null;
            if (showInfo) {
                var placeholderInfoStyles = {
                    left: rect.x * displayScale + 10 + 'px',
                    top: rect.y * displayScale + 10 + 'px',
                    width: rect.width * displayScale - 20 + 'px',
                    height: rect.height * displayScale - 20 + 'px',
                    lineHeight: (rect.height * displayScale - 20) / 3 + 'px',
                    fontSize: (rect.height * displayScale - 20) / 3 + 'px'
                };
                infoNode = _react2.default.createElement('div', { style: placeholderInfoStyles, className: 'placeholder-info' }, 'Click', _react2.default.createElement('br', null), 'to', _react2.default.createElement('br', null), 'add');
            }

            return _react2.default.createElement('div', null, _react2.default.createElement('input', {
                accept: '*/*',
                type: 'file',
                style: { visibility: 'hidden' },
                ref: function ref(c) {
                    _this5.fileInput = c;
                },
                onChange: function onChange(e) {
                    return _this5.handleFileInput(e);
                } }), infoNode, _react2.default.createElement('div', { className: 'placeholder-area',
                style: placeholderAreaStyles,
                onClick: function onClick() {
                    return _this5.onClickPlaceholderArea();
                }
            }, this.renderCropNode()));
        }
    }]);

    return PlaceholderArea;
}(_react.Component);

PlaceholderArea.propTypes = {
    uid: _propTypes2.default.string.isRequired,
    displayScale: _propTypes2.default.number.isRequired,
    rect: _propTypes2.default.object.isRequired,
    cropImageUrl: _propTypes2.default.string.isRequired,
    onCroppingStart: _propTypes2.default.func.isRequired,
    onCroppingDone: _propTypes2.default.func.isRequired,
    onCroppingCancel: _propTypes2.default.func.isRequired,
    cropData: _propTypes2.default.object.isRequired,
    onChangeImage: _propTypes2.default.func.isRequired,
    isCropping: _propTypes2.default.bool.isRequired,
    showInfo: _propTypes2.default.bool.isRequired
};
exports.default = PlaceholderArea;

},{"../../common/components/SVGIcon.react":13,"cropperjs":545,"prop-types":896,"react":1107}],278:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _OverlayUtils = require('../../edit/utils/OverlayUtils');

var _LayerUtils = require('../../common/utils/renderer/LayerUtils');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _PlaceholderArea = require('./PlaceholderArea.react');

var _PlaceholderArea2 = _interopRequireDefault(_PlaceholderArea);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PlaceholderLayer = function (_Component) {
    _inherits(PlaceholderLayer, _Component);

    function PlaceholderLayer(props) {
        _classCallCheck(this, PlaceholderLayer);

        var _this = _possibleConstructorReturn(this, (PlaceholderLayer.__proto__ || Object.getPrototypeOf(PlaceholderLayer)).call(this, props));

        _this.defModels = {};

        _this.onDropImageFunc = function () {
            return _this.onDropImage.apply(_this, arguments);
        };
        _this.onCroppingDoneFunc = function () {
            return _this.onCroppingDone.apply(_this, arguments);
        };

        var placeholderOverlays = props.placeholderOverlays,
            canvas = props.canvas;

        Object.keys(placeholderOverlays).forEach(function (oid) {
            return _this.onAddedOverlay(placeholderOverlays[oid], canvas);
        });

        _this.hasChangedImage = false;
        return _this;
    }

    _createClass(PlaceholderLayer, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var _overlaysDiff = (0, _OverlayUtils.overlaysDiff)(this.props.placeholderOverlays, nextProps.placeholderOverlays),
                addedOverlays = _overlaysDiff.addedOverlays,
                deletedOverlays = _overlaysDiff.deletedOverlays,
                updatedOverlays = _overlaysDiff.updatedOverlays;

            Object.keys(addedOverlays).forEach(function (oid) {
                return _this2.onAddedOverlay(addedOverlays[oid], nextProps.canvas);
            });
            Object.keys(updatedOverlays).forEach(function (oid) {
                return _this2.onUpdatedOverlay(updatedOverlays[oid], nextProps.canvas);
            });
            Object.keys(deletedOverlays).forEach(function (oid) {
                return _this2.onDeletedOverlay(deletedOverlays[oid]);
            });
        }
    }, {
        key: 'onAddedOverlay',
        value: function onAddedOverlay(overlay, canvas) {
            var defModel = new _DefModel2.default(overlay.defId);
            defModel.update(overlay.space, overlay.time, overlay.values, canvas);
            defModel.seekToStatic();

            this.defModels[overlay.id] = defModel;
        }
    }, {
        key: 'onDeletedOverlay',
        value: function onDeletedOverlay(overlay) {
            delete this.defModels[overlay.id];
        }
    }, {
        key: 'onUpdatedOverlay',
        value: function onUpdatedOverlay(overlay, canvas) {
            var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.defModels[overlay.id].update(overlay.space, overlay.time, overlay.values, canvas, null, forceUpdate);
            this.defModels[overlay.id].seekToStatic();
        }
    }, {
        key: 'onDropImage',
        value: function onDropImage(uid, imageId, targetAspectRatio, width, height) {
            var _values;

            var _props = this.props,
                placeholderOverlays = _props.placeholderOverlays,
                canvas = _props.canvas,
                changeOverlayValue = _props.changeOverlayValue;

            var _uid$split = uid.split('$-$'),
                _uid$split2 = _slicedToArray(_uid$split, 3),
                oid = _uid$split2[0],
                prop = _uid$split2[1],
                layerId = _uid$split2[2];

            var defModel = this.defModels[oid];
            var overlay = placeholderOverlays[oid];

            var cropX = 0,
                cropY = 0,
                cropWidth = 100,
                cropHeight = 100;

            if (height < width) {
                var newWidth = height * targetAspectRatio;
                var difference = (width - newWidth) / 2;
                cropX = difference / width * 100;
                cropWidth = newWidth / width * 100;
            } else {
                var newHeight = width / targetAspectRatio;
                var _difference = (height - newHeight) / 2;
                cropY = _difference / height * 100;
                cropHeight = newHeight / height * 100;
            }

            var newOverlay = (0, _deepmerge2.default)(overlay, {
                values: (_values = {}, _defineProperty(_values, prop, imageId), _defineProperty(_values, 'cropX', cropX), _defineProperty(_values, 'cropY', cropY), _defineProperty(_values, 'cropWidth', cropWidth), _defineProperty(_values, 'cropHeight', cropHeight), _values)
            });

            defModel.update(newOverlay.space, newOverlay.time, newOverlay.values, canvas);

            changeOverlayValue(newOverlay);
        }
    }, {
        key: 'onCroppingDone',
        value: function onCroppingDone(uid, cropData) {
            var _props2 = this.props,
                placeholderOverlays = _props2.placeholderOverlays,
                canvas = _props2.canvas,
                changeOverlayValue = _props2.changeOverlayValue,
                onCroppingDone = _props2.onCroppingDone;

            var _uid$split3 = uid.split('$-$'),
                _uid$split4 = _slicedToArray(_uid$split3, 3),
                oid = _uid$split4[0],
                prop = _uid$split4[1],
                layerId = _uid$split4[2];

            var cropX = cropData.cropX,
                cropY = cropData.cropY,
                cropWidth = cropData.cropWidth,
                cropHeight = cropData.cropHeight;

            var defModel = this.defModels[oid];
            var overlay = placeholderOverlays[oid];

            var newOverlay = (0, _deepmerge2.default)(overlay, {
                values: {
                    cropX: cropX,
                    cropY: cropY,
                    cropWidth: cropWidth,
                    cropHeight: cropHeight
                }
            });

            defModel.update(newOverlay.space, newOverlay.time, newOverlay.values, canvas);

            changeOverlayValue(newOverlay);
            onCroppingDone(cropData);
        }
    }, {
        key: 'onChangeImage',
        value: function onChangeImage(file, imageUrl) {
            this.props.onChangeImage(file, imageUrl);
            this.hasChangedImage = true;
        }
    }, {
        key: 'getSelectionRect',
        value: function getSelectionRect(_ref, scaleX, scaleY) {
            var x = _ref.x,
                y = _ref.y,
                lineHeight = _ref.lineHeight,
                lineWidth = _ref.lineWidth;

            return {
                x: (x - 1) * scaleX,
                y: (y - 4) * scaleY,
                width: (lineWidth + 2) * scaleX,
                height: (lineHeight + 8) * scaleY
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                displayScale = _props3.displayScale,
                isPlaying = _props3.isPlaying,
                placeholderOverlays = _props3.placeholderOverlays,
                isCropping = _props3.isCropping;

            var placeholderNodes = [];

            // For all placeholder overlays we know
            Object.keys(placeholderOverlays).forEach(function (oid) {
                // get the def model
                var defModel = _this3.defModels[oid];

                // Get the scale of the overlay
                var _defModel$space = defModel.space,
                    x = _defModel$space.x,
                    y = _defModel$space.y,
                    transform = _defModel$space.transform;

                var _getScaleFromTransfor = (0, _LayerUtils.getScaleFromTransformString)(transform),
                    _getScaleFromTransfor2 = _slicedToArray(_getScaleFromTransfor, 2),
                    scaleX = _getScaleFromTransfor2[0],
                    scaleY = _getScaleFromTransfor2[1];

                var placeholders = defModel.def.meta.placeholders;

                // For all text editors described for the overlay, we need to create an editor area

                Object.keys(placeholders).forEach(function (prop) {
                    var layerId = placeholders[prop];

                    var resolvedAttrs = defModel.getAttrsForLayer(layerId, true);

                    // This will contain all details about how to position all chars and lines in the text
                    // const textLayerInfo = defModel.getInfoForLayer(layerId)

                    var lx = resolvedAttrs.x,
                        ly = resolvedAttrs.y,
                        lw = resolvedAttrs.width,
                        lh = resolvedAttrs.height,
                        alpha = resolvedAttrs.alpha,
                        imageId = resolvedAttrs.imageId;
                    var cropX = resolvedAttrs.cropX,
                        cropY = resolvedAttrs.cropY,
                        cropWidth = resolvedAttrs.cropWidth,
                        cropHeight = resolvedAttrs.cropHeight;

                    // This is the box where the text will display. This is our hit area

                    var rect = {
                        x: x + lx * scaleX,
                        y: y + ly * scaleY,
                        width: lw * scaleX,
                        height: lh * scaleY
                    };

                    var cropData = {
                        cropX: cropX,
                        cropY: cropY,
                        cropWidth: cropWidth,
                        cropHeight: cropHeight
                    };

                    var uid = oid + '$-$' + prop + '$-$' + layerId;

                    var _getImageUrlForId = getImageUrlForId(imageId),
                        cropImageUrl = _getImageUrlForId.imgUrl,
                        isImgDeleted = _getImageUrlForId.deleted;

                    var showInfo = !(isPlaying || isCropping || _this3.hasChangedImage);

                    placeholderNodes.push(_react2.default.createElement(_PlaceholderArea2.default, {
                        key: uid,
                        uid: uid,
                        displayScale: displayScale,
                        rect: rect,
                        cropData: cropData,
                        cropImageUrl: cropImageUrl,
                        ref: function ref(c) {
                            return _this3.placeholder = c;
                        },
                        onDropImage: _this3.onDropImageFunc,
                        onCroppingDone: _this3.onCroppingDoneFunc,
                        onCroppingStart: _this3.props.onCroppingStart,
                        onCroppingCancel: _this3.props.onCroppingCancel,
                        isCropping: isCropping,
                        showInfo: showInfo,
                        onChangeImage: function onChangeImage(file, imageUrl) {
                            return _this3.onChangeImage(file, imageUrl);
                        }
                    }));
                });
            });

            var rootStyles = {
                visibility: isPlaying ? 'hidden' : 'visible'
            };

            return _react2.default.createElement('div', { className: 'fill-parent-size placeholder-layer', style: rootStyles }, placeholderNodes);
        }
    }]);

    return PlaceholderLayer;
}(_react.Component);

PlaceholderLayer.propTypes = {
    displayScale: _propTypes2.default.number.isRequired,
    isPlaying: _propTypes2.default.bool.isRequired,
    isCropping: _propTypes2.default.bool.isRequired,
    placeholderOverlays: _propTypes2.default.object.isRequired,
    canvas: _propTypes2.default.object.isRequired,
    changeOverlayValue: _propTypes2.default.func.isRequired,
    onCroppingDone: _propTypes2.default.func.isRequired,
    onChangeImage: _propTypes2.default.func.isRequired
};
exports.default = PlaceholderLayer;

},{"../../common/utils/renderer/DefModel":119,"../../common/utils/renderer/LayerUtils":121,"../../edit/utils/OverlayUtils":231,"./PlaceholderArea.react":277,"deepmerge":549,"prop-types":896,"react":1107}],279:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PreviewHintContainer = require('../containers/PreviewHintContainer.react');

var _PreviewHintContainer2 = _interopRequireDefault(_PreviewHintContainer);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MIN_PERCENTAGE = 0;
var MAX_PERCENTAGE = 100;
var MAX_X = 100;
var MAX_Y = 100;
var FULL_RADIUS = 50;
var CENTER_X = 50;
var CENTER_Y = 50;

var STROKE_WIDTH = 10;

var PreviewButton = function (_Component) {
    _inherits(PreviewButton, _Component);

    function PreviewButton() {
        _classCallCheck(this, PreviewButton);

        return _possibleConstructorReturn(this, (PreviewButton.__proto__ || Object.getPrototypeOf(PreviewButton)).apply(this, arguments));
    }

    _createClass(PreviewButton, [{
        key: 'getPathDescription',
        value: function getPathDescription() {
            var radius = this.getPathRadius();
            var rotation = 1;

            // Move to center of canvas
            // Relative move to top canvas
            // Relative arc to bottom of canvas
            // Relative arc to top of canvas
            return '\n        M ' + CENTER_X + ',' + CENTER_Y + '\n        m 0,-' + radius + '\n        a ' + radius + ',' + radius + ' ' + rotation + ' 1 1 0,' + 2 * radius + '\n        a ' + radius + ',' + radius + ' ' + rotation + ' 1 1 0,-' + 2 * radius + '\n        ';
        }
    }, {
        key: 'getPathStyles',
        value: function getPathStyles() {
            var diameter = Math.PI * 2 * this.getPathRadius();
            var truncatedPercentage = Math.min(Math.max(this.props.progress, MIN_PERCENTAGE), MAX_PERCENTAGE);
            var dashoffset = (100 - truncatedPercentage) / 100 * diameter;

            return {
                strokeDasharray: diameter + 'px ' + diameter + 'px',
                strokeDashoffset: dashoffset + 'px'
            };
        }
    }, {
        key: 'getPathRadius',
        value: function getPathRadius() {
            // the radius of the path is defined to be in the middle, so in order for the path to
            // fit perfectly inside the 100x100 viewBox, need to subtract half the strokeWidth
            return FULL_RADIUS - STROKE_WIDTH / 2;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var progressCls = (0, _classnames2.default)({
                'preview-progress': true,
                animating: this.props.playing
            });

            var playCls = (0, _classnames2.default)({
                'play': true,
                'show': !this.props.playing
            });
            var pauseCls = (0, _classnames2.default)({
                'pause': true,
                'show': this.props.playing
            });

            var pathDescription = this.getPathDescription();

            var previewButtonClsName = 'preview-button';

            return _react2.default.createElement('div', { className: previewButtonClsName,
                onClick: function onClick() {
                    return _this2.props.onClick();
                }
            }, _react2.default.createElement('div', { className: progressCls }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 ' + MAX_X + ' ' + MAX_Y, version: '1.1' }, _react2.default.createElement('path', { className: 'progress-ring-path-bg', strokeWidth: STROKE_WIDTH, d: pathDescription }), _react2.default.createElement('path', { className: 'progress-ring-path', strokeWidth: STROKE_WIDTH, fillOpacity: 0, d: pathDescription,
                style: this.getPathStyles() }))), _react2.default.createElement('div', { className: playCls }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 311 307', version: '1.1' }, _react2.default.createElement('g', { className: 'play-path' }, _react2.default.createElement('path', { d: 'M296.950405,131.191813 L36.8801921,2.7224473 C29.0154682,-1.2351398 19.6236144,-0.854607454 12.064336,3.71183921 C4.5050381,8.20218329 0,16.2695627 0,24.945821 L0,282.11288 C0,290.713017 4.5050381,298.780396 12.064336,303.27074 C16.187577,305.782281 20.7689667,307 25.426708,307 C29.3972458,307 33.2914319,306.086711 36.8801921,304.336254 L297.026776,175.714663 C305.578704,171.528749 311,162.928613 311,153.49129 C311,144.053967 305.502332,135.45383 296.950405,131.191813 Z' })))), _react2.default.createElement('div', { className: pauseCls }, _react2.default.createElement('svg', { width: '100%', height: '100%', viewBox: '0 0 311 354', version: '1.1' }, _react2.default.createElement('g', { className: 'pause-shapes', fill: '#EFD954' }, _react2.default.createElement('path', { d: 'M22.2142857,0 C9.97907921,0 0,9.93606594 0,22.1185345 L0,331.778017 C0,343.960486 9.97907921,353.896552 22.2142857,353.896552 L88.8571429,353.896552 C101.092349,353.896552 111.071429,343.960486 111.071429,331.778017 L111.071429,22.1185345 C111.071429,9.93606594 101.092349,0 88.8571429,0 L22.2142857,0 Z M222.142857,0 C209.907651,0 199.928571,9.93606594 199.928571,22.1185345 L199.928571,331.778017 C199.928571,343.960486 209.907651,353.896552 222.142857,353.896552 L288.785714,353.896552 C301.020921,353.896552 311,343.960486 311,331.778017 L311,22.1185345 C311,9.93606594 301.020921,0 288.785714,0 L222.142857,0 Z' })))), _react2.default.createElement(_PreviewHintContainer2.default, { position: 'left',
                style: {
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    position: 'absolute',
                    left: '0%',
                    top: '50%'
                }
            }, 'Play the animation'));
        }
    }]);

    return PreviewButton;
}(_react.Component);

PreviewButton.propTypes = {
    playing: _propTypes2.default.bool.isRequired,
    progress: _propTypes2.default.number.isRequired,
    onClick: _propTypes2.default.func.isRequired
};
exports.default = PreviewButton;

},{"../containers/PreviewHintContainer.react":289,"classnames":410,"prop-types":896,"react":1107}],280:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _LoadingSpinner = require('./LoadingSpinner.react');

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProjectReadyModal = function (_Component) {
    _inherits(ProjectReadyModal, _Component);

    function ProjectReadyModal() {
        _classCallCheck(this, ProjectReadyModal);

        return _possibleConstructorReturn(this, (ProjectReadyModal.__proto__ || Object.getPrototypeOf(ProjectReadyModal)).apply(this, arguments));
    }

    _createClass(ProjectReadyModal, [{
        key: 'handleOpenProjectClick',
        value: function handleOpenProjectClick() {
            window.open('/open/' + this.props.createdProjectId, '_blank');
            this.props.onHide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                show = _props.show,
                onHide = _props.onHide,
                creatingProject = _props.creatingProject,
                _props$createdProject = _props.createdProjectId,
                createdProjectId = _props$createdProject === undefined ? '' : _props$createdProject;

            return _react2.default.createElement(_reactModal2.default, { className: 'modal-pr', isOpen: show, onRequestClose: onHide,
                overlayClassName: 'ReactModal__Overlay', closeTimeoutMS: 300 }, _react2.default.createElement('div', { className: 'pr-dialog' }, _react2.default.createElement('div', { className: (0, _classnames2.default)('pr-loading', { show: creatingProject }) }, _react2.default.createElement(_LoadingSpinner2.default, null)), _react2.default.createElement('div', { className: (0, _classnames2.default)('pr-loaded', { show: !creatingProject }) }, _react2.default.createElement('div', { className: 'pr-message' }, 'We\'ve setup a new project using this template for you on TYPITO. Click on the button to open it.'), _react2.default.createElement('button', { className: 'pr-open-button',
                onClick: function onClick() {
                    return _this2.handleOpenProjectClick();
                }
            }, 'Continue'))));
        }
    }]);

    return ProjectReadyModal;
}(_react.Component);

ProjectReadyModal.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    onHide: _propTypes2.default.func.isRequired,
    creatingProject: _propTypes2.default.bool.isRequired,
    createdProjectId: _propTypes2.default.string
};
exports.default = ProjectReadyModal;

},{"./LoadingSpinner.react":275,"classnames":410,"prop-types":896,"react":1107,"react-modal":1041}],281:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TemplateSectionContainer = require('../containers/TemplateSectionContainer.react');

var _TemplateSectionContainer2 = _interopRequireDefault(_TemplateSectionContainer);

var _ProjectReadyModalContainer = require('../containers/ProjectReadyModalContainer.react');

var _ProjectReadyModalContainer2 = _interopRequireDefault(_ProjectReadyModalContainer);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TemplatePage = function (_Component) {
    _inherits(TemplatePage, _Component);

    function TemplatePage() {
        _classCallCheck(this, TemplatePage);

        return _possibleConstructorReturn(this, (TemplatePage.__proto__ || Object.getPrototypeOf(TemplatePage)).apply(this, arguments));
    }

    _createClass(TemplatePage, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', null, _react2.default.createElement(_TemplateSectionContainer2.default, null), _react2.default.createElement(_ProjectReadyModalContainer2.default, null));
        }
    }]);

    return TemplatePage;
}(_react.Component);

exports.default = TemplatePage;

},{"../containers/ProjectReadyModalContainer.react":290,"../containers/TemplateSectionContainer.react":291,"prop-types":896,"react":1107}],282:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _TemplateThumbComponent = require('../../search/components/TemplateThumbComponent.react');

var _TemplateThumbComponent2 = _interopRequireDefault(_TemplateThumbComponent);

var _LoadingSpinner = require('./LoadingSpinner.react');

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _SVGIcon = require('../../common/components/SVGIcon.react');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _GraphicsEditorRootContainer = require('../containers/GraphicsEditorRootContainer.react');

var _GraphicsEditorRootContainer2 = _interopRequireDefault(_GraphicsEditorRootContainer);

var _PreviewButtonContainer = require('../containers/PreviewButtonContainer.react');

var _PreviewButtonContainer2 = _interopRequireDefault(_PreviewButtonContainer);

var _BackgroundHintContainer = require('../containers/BackgroundHintContainer.react');

var _BackgroundHintContainer2 = _interopRequireDefault(_BackgroundHintContainer);

var _WorkspaceSelectModalContainer = require('../containers/WorkspaceSelectModalContainer.react');

var _WorkspaceSelectModalContainer2 = _interopRequireDefault(_WorkspaceSelectModalContainer);

var _SimpleFormatSelectModal = require('../../common/components/SimpleFormatSelectModal.react');

var _SimpleFormatSelectModal2 = _interopRequireDefault(_SimpleFormatSelectModal);

var _constants = require('../constants');

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MIN_EXPORT_DURATION_SEC = 1;
var MAX_EXPORT_DURATION_SEC = 100;

var TemplateSection = function (_Component) {
    _inherits(TemplateSection, _Component);

    function TemplateSection(props) {
        _classCallCheck(this, TemplateSection);

        var _this = _possibleConstructorReturn(this, (TemplateSection.__proto__ || Object.getPrototypeOf(TemplateSection)).call(this, props));

        _this.state = {
            showSaveInfo: false,
            isHoveringBackgrounds: false,
            hoveredBGSnapshotURL: '',
            templateDuration: _this.props.templateExportDuration / 1000
        };
        return _this;
    }

    _createClass(TemplateSection, [{
        key: 'onClickSaveTemplate',
        value: function onClickSaveTemplate() {
            this.setState({ showSaveInfo: false });
            this.props.onClickSaveTemplate();
        }
    }, {
        key: 'onClickTag',
        value: function onClickTag(tagId) {
            if (!!tagId) {
                window.open('/templates/tag/' + tagId, '_blank');
            }
        }
    }, {
        key: 'renderTemplateTags',
        value: function renderTemplateTags() {
            var _this2 = this;

            var templateTags = this.props.templateTags;

            var templateTagsNode = null;

            if (!!templateTags && templateTags.length > 0) {
                templateTagsNode = _react2.default.createElement('div', { className: 'template-tags' }, templateTags.map(function (tag) {
                    return _react2.default.createElement('span', {
                        key: tag.id,
                        className: 'template-tag',
                        onClick: function onClick() {
                            return _this2.onClickTag(tag.id);
                        }
                    }, tag.label);
                }));
            }
            return templateTagsNode;
        }
    }, {
        key: 'renderSaveTemplateNode',
        value: function renderSaveTemplateNode() {
            var _this3 = this;

            var saveTemplateNode = null;

            if (!!this.props.isLoggedIn) {
                var saveLabel = '',
                    disabled = false;

                switch (this.props.saveUIState) {
                    case _constants.SaveUIState.SAVING:
                        saveLabel = 'Saving...';
                        disabled = true;
                        break;
                    case _constants.SaveUIState.SAVED:
                        saveLabel = 'Saved';
                        disabled = true;
                        break;
                    default:
                        saveLabel = 'Save';
                        disabled = false;
                }

                var saveInfoNode = null;
                if (!disabled && this.state.showSaveInfo) {
                    saveInfoNode = _react2.default.createElement('div', { className: 'save-info' }, 'Template will be saved to Typito.');
                }

                saveTemplateNode = _react2.default.createElement('div', { className: 'save-wrapper' }, _react2.default.createElement('button', {
                    className: 'save-it',
                    disabled: disabled,
                    onMouseEnter: function onMouseEnter() {
                        return _this3.setState({ showSaveInfo: true });
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this3.setState({ showSaveInfo: false });
                    },
                    onClick: function onClick() {
                        return _this3.onClickSaveTemplate();
                    }
                }, saveLabel), saveInfoNode);
            }
            return saveTemplateNode;
        }
    }, {
        key: 'onHoverBackground',
        value: function onHoverBackground(snapshotUrl) {
            this.setState({
                isHoveringBackgrounds: true,
                hoveredBGSnapshotURL: snapshotUrl
            });
        }
    }, {
        key: 'onLeaveBackground',
        value: function onLeaveBackground() {
            this.setState({
                isHoveringBackgrounds: false,
                hoveredBGSnapshotURL: ''
            });
        }
    }, {
        key: 'onChangeTemplateDuration',
        value: function onChangeTemplateDuration(event) {
            var value = event.target.value;

            this.setState({
                templateDuration: value
            });

            if (value >= MIN_EXPORT_DURATION_SEC && value <= MAX_EXPORT_DURATION_SEC) {
                this.props.onSetExportDuration(value * 1000);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                customFormatGroups = _props.customFormatGroups,
                showFormatSelectModal = _props.showFormatSelectModal,
                template = _props.template,
                templateTags = _props.templateTags,
                similarTemplates = _props.similarTemplates,
                selectedBackgroundId = _props.selectedBackgroundId,
                backgrounds = _props.backgrounds,
                onClickBackground = _props.onClickBackground,
                customFormats = _props.customFormats;
            var _props2 = this.props,
                createProjectWithFormat = _props2.createProjectWithFormat,
                onCloseFormatSelectModal = _props2.onCloseFormatSelectModal,
                creatingProject = _props2.creatingProject,
                loadingBackground = _props2.loadingBackground,
                _props2$createdProjec = _props2.createdProjectId,
                createdProjectId = _props2$createdProjec === undefined ? null : _props2$createdProjec;
            var _template$config$canv = template.config.canvas,
                width = _template$config$canv.width,
                height = _template$config$canv.height;

            var aspectRatio = width / height;

            var previewWrapperStyles = {
                paddingTop: 100 / (width / height) + '%'
            };

            return _react2.default.createElement('div', { className: 'template-section' }, _react2.default.createElement('h1', null, template.name, ' Text Template'), this.renderTemplateTags(), _react2.default.createElement('div', { className: 'template-container' }, _react2.default.createElement('div', { className: 'preview-container' }, _react2.default.createElement('div', { className: 'preview-wrapper', style: previewWrapperStyles }, _react2.default.createElement(_GraphicsEditorRootContainer2.default, {
                isHoveringBackgrounds: this.state.isHoveringBackgrounds,
                hoveredBGSnapshotURL: this.state.hoveredBGSnapshotURL,
                onClickOutside: this.props.onClickOutsideEditor
            }, _react2.default.createElement(_PreviewButtonContainer2.default, null), _react2.default.createElement('div', {
                className: (0, _classnames2.default)('bg-loading', {
                    show: loadingBackground
                })
            }, _react2.default.createElement(_LoadingSpinner2.default, null)))), _react2.default.createElement('div', { className: 'background-selection' }, _react2.default.createElement('div', { className: 'title text-center' }, '- - - Try a background - - -'), backgrounds.map(function (video) {
                var selected = video.id === selectedBackgroundId;
                return _react2.default.createElement('div', {
                    key: video.id,
                    className: 'background-item-wrapper',
                    style: {
                        width: 100 / backgrounds.length + '%',
                        paddingTop: 56.25 / backgrounds.length + '%'
                    }
                }, _react2.default.createElement('div', {
                    className: (0, _classnames2.default)('background-item', {
                        selected: selected
                    }),
                    style: {
                        backgroundImage: 'url(' + video.snapshotUrl + ')'
                    },
                    onMouseEnter: function onMouseEnter() {
                        return _this4.onHoverBackground(video.snapshotUrl);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this4.onLeaveBackground();
                    },
                    onClick: function onClick() {
                        return onClickBackground(video.id);
                    }
                }, _react2.default.createElement('div', { className: 'hide-icon' }, _react2.default.createElement('svg', {
                    viewBox: '0 0 24 24',
                    version: '1.1',
                    width: '100%',
                    height: '100%'
                }, _react2.default.createElement('g', null, _react2.default.createElement('path', {
                    className: 'hide-path',
                    d: 'M 3.40625 2 L 2 3.40625 L 20.59375 22 L 22 20.59375 L 18.25 16.84375 C 20.929688 15.046875 22.695313 12.75 22.8125 12.59375 C 23.078125 12.238281 23.078125 11.761719 22.8125 11.40625 C 22.617188 11.144531 17.957031 5 12 5 C 10.386719 5 8.886719 5.460938 7.53125 6.125 Z M 12 7 C 14.761719 7 17 9.238281 17 12 C 17 13.027344 16.6875 13.957031 16.15625 14.75 L 14.3125 12.90625 C 14.425781 12.621094 14.5 12.324219 14.5 12 C 14.5 10.621094 13.382813 9.5 12 9.5 C 11.675781 9.5 11.378906 9.574219 11.09375 9.6875 L 9.25 7.84375 C 10.042969 7.3125 10.976563 7 12 7 Z M 4.90625 7.75 C 2.707031 9.425781 1.292969 11.265625 1.1875 11.40625 C 0.921875 11.761719 0.921875 12.238281 1.1875 12.59375 C 1.382813 12.855469 6.042969 19 12 19 C 13.226563 19 14.410156 18.730469 15.5 18.3125 L 13.8125 16.65625 C 13.246094 16.878906 12.644531 17 12 17 C 9.238281 17 7 14.761719 7 12 C 7 11.355469 7.121094 10.753906 7.34375 10.1875 Z M 9.53125 12.375 C 9.691406 13.460938 10.539063 14.308594 11.625 14.46875 Z '
                }))))));
            }), _react2.default.createElement(_BackgroundHintContainer2.default, {
                position: 'above',
                style: {
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    position: 'absolute',
                    // left : '25%',
                    // top : 'calc(50% + 17px)',
                    left: '12.5%',
                    top: '33px'
                }
            }, 'Click to change background')), _react2.default.createElement('div', {
                className: 'description-container',
                dangerouslySetInnerHTML: { __html: template.desc }
            })), _react2.default.createElement('div', { className: 'details-container' }, this.getDownloadTemplateNode(), _react2.default.createElement('div', { className: 'use-template-area' }, _react2.default.createElement('button', {
                className: 'get-it',
                disabled: creatingProject,
                onClick: function onClick() {
                    return _this4.props.onClickUseTemplate();
                }
            }, creatingProject ? 'Working...' : !!createdProjectId ? 'Open project' : 'Use this template'), this.renderSaveTemplateNode(), _react2.default.createElement(_WorkspaceSelectModalContainer2.default, null), _react2.default.createElement(_SimpleFormatSelectModal2.default, {
                show: showFormatSelectModal,
                onClose: onCloseFormatSelectModal,
                customFormatGroups: customFormatGroups,
                customFormats: customFormats,
                onClickCreate: function onClickCreate(formatId) {
                    return createProjectWithFormat(formatId);
                },
                selectedWorkspace: this.props.selectedWorkspace,
                customFormatUIState: this.props.customFormatUIState,
                createButtonText: this.props.createButtonText,
                openCustomFormatModal: function openCustomFormatModal() {
                    return _this4.props.openCustomFormatModal();
                },
                onCloseCustomFormatModal: function onCloseCustomFormatModal() {
                    return _this4.props.onCloseCustomFormatModal();
                },
                saveCustomFormat: function saveCustomFormat(customFormatObj) {
                    return _this4.props.saveCustomFormat(customFormatObj);
                },
                showTemplateColumn: false
            })), similarTemplates.length > 0 ? _react2.default.createElement('div', { className: 'similar-templates' }, _react2.default.createElement('div', { className: 'title text-center' }, '- - - Similar - - -'), _react2.default.createElement('div', { className: 'similar-templates-grid' }, similarTemplates.map(function (t) {
                return _react2.default.createElement(_TemplateThumbComponent2.default, { key: t.id, template: t });
            }))) : null)));
        }
    }, {
        key: 'getDownloadTemplateNode',
        value: function getDownloadTemplateNode() {
            var _this5 = this;

            var _props3 = this.props,
                templateExportPercent = _props3.templateExportPercent,
                isLoggedIn = _props3.isLoggedIn,
                lastExportId = _props3.lastExportId,
                hasTemplatePlan = _props3.hasTemplatePlan,
                templateExportBalance = _props3.templateExportBalance,
                freeTemplateUsage = _props3.freeTemplateUsage,
                saveAndExportUIState = _props3.saveAndExportUIState,
                onClickSaveAndExportTemplate = _props3.onClickSaveAndExportTemplate,
                onClickDownloadTemplate = _props3.onClickDownloadTemplate,
                onClickCancelExport = _props3.onClickCancelExport,
                downloadError = _props3.downloadError,
                isActiveWorkspacePaid = _props3.isActiveWorkspacePaid;
            var templateDuration = this.state.templateDuration;

            var canViewDownloadTemplate = !isLoggedIn || isLoggedIn && (hasTemplatePlan || !isActiveWorkspacePaid);

            if (!canViewDownloadTemplate) {
                return null;
            }

            var errorMessage = '';
            if (templateDuration < MIN_EXPORT_DURATION_SEC) {
                errorMessage = 'Duration can’t be less than 1s';
            } else if (templateDuration > MAX_EXPORT_DURATION_SEC) {
                errorMessage = 'Duration can’t be more than 100s';
            }

            var errorMessageNode = null;
            if (errorMessage) {
                errorMessageNode = _react2.default.createElement('div', { className: 'input-duration-error' }, _react2.default.createElement('span', null, _react2.default.createElement(_SVGIcon2.default, { width: '15px', height: '15px', iconId: 'error' })), _react2.default.createElement('span', { className: 'error-info' }, errorMessage));
            }
            var downloadErrorNode = null;
            if (downloadError) {
                downloadErrorNode = _react2.default.createElement('div', { className: 'download-error' }, ' Something went wrong, please try again later ');
            }

            var templateDownloadNode = null;

            var templateDurationCls = (0, _classnames2.default)('input-duration-limit', {
                error: !!errorMessage
            });

            var downloadBtnCls = (0, _classnames2.default)('download-wrapper', {
                disabled: isLoggedIn && (!!errorMessage || hasTemplatePlan && templateExportBalance <= 0 || saveAndExportUIState === _constants.SaveAndExportUIState.START_EXPORT)
            });

            var cancelExportBtnCls = (0, _classnames2.default)('cancel-button', {
                disabled: saveAndExportUIState === _constants.SaveAndExportUIState.EXPORT_CANCELLING
            });

            if (saveAndExportUIState === _constants.SaveAndExportUIState.EXPORTING || saveAndExportUIState === _constants.SaveAndExportUIState.EXPORT_CANCELLING) {
                templateDownloadNode = _react2.default.createElement('div', { className: 'after-template-download' }, _react2.default.createElement('div', { className: 'after-download-text-wrapper' }, _react2.default.createElement(_SVGIcon2.default, {
                    width: '20.4px',
                    height: '20.4px',
                    iconId: 'video_settings'
                }), _react2.default.createElement('div', { className: 'downloaded-text' }, 'Your video processing is in progress. While you wait,', ' ', _react2.default.createElement('a', { href: '/templates', target: '_blank' }, 'explore more templates'))), _react2.default.createElement('div', { className: 'download-wrapper download-progress' }, _react2.default.createElement('span', { className: 'download-cta-text' }, templateExportPercent, '%'), _react2.default.createElement('span', {
                    className: cancelExportBtnCls,
                    onClick: function onClick() {
                        onClickCancelExport();
                    }
                }, _react2.default.createElement(_SVGIcon2.default, { width: '16px', height: '16px', iconId: 'cancel-cross-export' })), _react2.default.createElement('div', {
                    className: 'template-download-progress-bar',
                    style: { width: templateExportPercent + '%' }
                })));
            } else {
                templateDownloadNode = _react2.default.createElement('div', { className: 'before-template-download' }, _react2.default.createElement('div', { className: 'input-download-duration-container' }, _react2.default.createElement('div', { className: 'input-download-duration-label' }, 'Video Duration'), _react2.default.createElement('input', {
                    className: templateDurationCls,
                    type: 'number',
                    min: MIN_EXPORT_DURATION_SEC,
                    max: MAX_EXPORT_DURATION_SEC,
                    name: 'duration',
                    value: templateDuration,
                    onChange: function onChange(e) {
                        return _this5.onChangeTemplateDuration(e);
                    }
                }), _react2.default.createElement('div', { className: 'sec-label' }, 'sec')), errorMessageNode, isLoggedIn && !hasTemplatePlan && freeTemplateUsage > 0 ? _react2.default.createElement('div', { className: downloadBtnCls }, _react2.default.createElement('a', { href: '/offer/black-friday-2023', target: '_blank' }, _react2.default.createElement('span', { className: 'download-cta-text' }, ' Get Lifetime Access'))) : _react2.default.createElement('div', { className: downloadBtnCls, onClick: onClickSaveAndExportTemplate }, _react2.default.createElement('span', { className: 'download-cta-text' }, ' Download')), isLoggedIn && hasTemplatePlan && _react2.default.createElement('div', { className: 'downloads-left-info-container' }, _react2.default.createElement('span', { className: 'downloads-left-info' }, templateExportBalance, ' downloads remaining for this month'), _react2.default.createElement('span', null, _react2.default.createElement(_SVGIcon2.default, {
                    width: '15px',
                    height: '15px',
                    iconId: 'info',
                    'data-tip': true,
                    'data-for': 'downloads-left-tooltip'
                })), _react2.default.createElement(_reactTooltip2.default, {
                    id: 'downloads-left-tooltip',
                    place: 'bottom',
                    className: 'downloads-left-tooltip',
                    effect: 'solid',
                    backgroundColor: 'white',
                    arrowColor: 'white'
                }, 'Only 20 templates can be downloaded in a month')), isLoggedIn && !hasTemplatePlan && freeTemplateUsage > 0 && _react2.default.createElement('div', { className: 'downloads-left-info-container' }, _react2.default.createElement('span', { className: 'downloads-left-info' }, 'Unlock 20 downloads every month')), lastExportId && _react2.default.createElement('div', {
                    className: 'previous-template-download-wrapper',
                    onClick: function onClick() {
                        return onClickDownloadTemplate(lastExportId);
                    }
                }, _react2.default.createElement(_SVGIcon2.default, { width: '15px', height: '15px', iconId: 'download' }), _react2.default.createElement('div', { className: 'previous-template-download-text' }, _react2.default.createElement('span', null, 'Download Previous version'))), downloadErrorNode);
            }

            return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('div', { className: 'download-template-wrapper' }, _react2.default.createElement('div', { className: 'download-template-header' }, 'Download Template Video'), templateDownloadNode), _react2.default.createElement('div', { className: 'or-heading' }, 'Or'));
        }
    }]);

    return TemplateSection;
}(_react.Component);

TemplateSection.propTypes = {
    template: _propTypes2.default.object.isRequired,
    templateTags: _propTypes2.default.array.isRequired,
    similarTemplates: _propTypes2.default.array.isRequired,
    selectedBackgroundId: _propTypes2.default.string.isRequired,
    backgrounds: _propTypes2.default.array.isRequired,
    creatingProject: _propTypes2.default.bool.isRequired,
    createdProjectId: _propTypes2.default.any,
    isLoggedIn: _propTypes2.default.bool,
    showFormatSelectModal: _propTypes2.default.bool,
    customFormatGroups: _propTypes2.default.array.isRequired,
    saveUIState: _propTypes2.default.string.isRequired,
    saveAndExportUIState: _propTypes2.default.string,
    templateExportPercent: _propTypes2.default.number,
    templateExportStatus: _propTypes2.default.string,
    templateExportId: _propTypes2.default.number,
    templateExportDuration: _propTypes2.default.number,
    lastExportId: _propTypes2.default.any,
    isActiveWorkspacePaid: _propTypes2.default.bool,
    onClickBackground: _propTypes2.default.func.isRequired,
    onClickOutsideEditor: _propTypes2.default.func.isRequired,
    onClickUseTemplate: _propTypes2.default.func.isRequired,
    onClickSaveTemplate: _propTypes2.default.func.isRequired,
    onClickSaveAndExportTemplate: _propTypes2.default.func,
    onClickCancelExport: _propTypes2.default.func,
    onSetExportDuration: _propTypes2.default.func.isRequired,
    onCloseFormatSelectModal: _propTypes2.default.func.isRequired,
    customFormats: _propTypes2.default.array.isRequired,
    customFormatUIState: _propTypes2.default.string.isRequired,
    createButtonText: _propTypes2.default.string,
    saveCustomFormat: _propTypes2.default.func.isRequired,
    onCloseCustomFormatModal: _propTypes2.default.func.isRequired,
    openCustomFormatModal: _propTypes2.default.func.isRequired,
    selectedWorkspace: _propTypes2.default.object.isRequired,
    hasTemplatePlan: _propTypes2.default.bool,
    templateExportBalance: _propTypes2.default.number,
    freeTemplateUsage: _propTypes2.default.number,
    onClickDownloadTemplate: _propTypes2.default.func.isRequired,
    downloadError: _propTypes2.default.bool
};
exports.default = TemplateSection;

},{"../../common/components/SVGIcon.react":13,"../../common/components/SimpleFormatSelectModal.react":14,"../../search/components/TemplateThumbComponent.react":269,"../constants":284,"../containers/BackgroundHintContainer.react":285,"../containers/GraphicsEditorRootContainer.react":286,"../containers/PreviewButtonContainer.react":288,"../containers/WorkspaceSelectModalContainer.react":292,"./LoadingSpinner.react":275,"classnames":410,"prop-types":896,"react":1107,"react-tooltip":1092}],283:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var emptyFunc = function emptyFunc() {};

var TutorialHint = function (_Component) {
    _inherits(TutorialHint, _Component);

    function TutorialHint(props) {
        _classCallCheck(this, TutorialHint);

        var _this = _possibleConstructorReturn(this, (TutorialHint.__proto__ || Object.getPrototypeOf(TutorialHint)).call(this, props));

        _this._documentClickCallback = function (e) {
            return _this.onDocumentClick(e);
        };
        return _this;
    }

    _createClass(TutorialHint, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._documentClickCallback);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            if (!this.props.show) {
                return;
            }
            var $rootEl = $(this.rootEl);

            var _props = this.props,
                targetSelector = _props.targetSelector,
                onClickTarget = _props.onClickTarget,
                onClickOutside = _props.onClickOutside;

            var didClickOutside = $(e.target).closest($rootEl).length <= 0;

            var didClickOnTarget = !!targetSelector && $(e.target).closest($(targetSelector)).length > 0;

            if (didClickOnTarget) {
                onClickTarget();
            } else if (didClickOutside) {
                onClickOutside();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                show = _props2.show,
                animate = _props2.animate,
                position = _props2.position,
                _props2$className = _props2.className,
                className = _props2$className === undefined ? '' : _props2$className,
                _props2$style = _props2.style,
                style = _props2$style === undefined ? {} : _props2$style,
                targetSelector = _props2.targetSelector,
                onClickOutside = _props2.onClickOutside,
                onClickTarget = _props2.onClickTarget,
                restProps = _objectWithoutProperties(_props2, ['show', 'animate', 'position', 'className', 'style', 'targetSelector', 'onClickOutside', 'onClickTarget']);

            var mergedClassName = (0, _classnames2.default)('tutorial-hint', position, className, { 'hint-show': show, animate: animate });

            return _react2.default.createElement('div', _extends({ ref: function ref(c) {
                    _this2.rootEl = c;
                },
                className: mergedClassName, style: style }, restProps));
        }
    }]);

    return TutorialHint;
}(_react.Component);

TutorialHint.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    animate: _propTypes2.default.bool,
    position: _propTypes2.default.oneOf(['above', 'below', 'left', 'right']),
    targetSelector: _propTypes2.default.string,
    onClickTarget: _propTypes2.default.func,
    onClickOutside: _propTypes2.default.func
};
TutorialHint.defaultProps = {
    animate: false,
    targetSelector: '',
    onClickTarget: emptyFunc,
    onClickOutside: emptyFunc
};
exports.default = TutorialHint;

},{"classnames":410,"prop-types":896,"react":1107}],284:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomFormatUIState = exports.SaveAndExportUIState = exports.SaveUIState = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var SaveUIState = exports.SaveUIState = (0, _keymirror2.default)({
    SAVE: null,
    SAVED: null,
    SAVING: null,
    SAVE_FAILED: null
});

var SaveAndExportUIState = exports.SaveAndExportUIState = (0, _keymirror2.default)({
    START_EXPORT: null,
    EXPORT: null,
    EXPORTING: null,
    EXPORTED: null,
    EXPORT_CANCELLING: null,
    EXPORT_FAILED: null
});

var CustomFormatUIState = exports.CustomFormatUIState = (0, _keymirror2.default)({
    OPEN: null,
    CREATING: null,
    CREATION_SUCCESS: null,
    CREATION_FAILED: null,
    CLOSED: null,
    CF_LIMIT_REACHED: null
});

},{"keymirror":677}],285:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _TutorialHint = require('../components/TutorialHint.react');

var _TutorialHint2 = _interopRequireDefault(_TutorialHint);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var backgroundHint = state.ui.hints.backgroundHint;

    var show = backgroundHint.shouldShow && backgroundHint.show;

    return _extends({}, ownProps, {
        show: show
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClickOutside: function onClickOutside() {
            return dispatch(editorActions.dismissBackgroundHint());
        }
    };
};

var BackgroundHintContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TutorialHint2.default);

exports.default = BackgroundHintContainer;

},{"../components/TutorialHint.react":283,"../editorActions":301,"react":1107,"react-redux":1079}],286:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _GraphicsEditorRoot = require('../components/GraphicsEditorRoot.react');

var _GraphicsEditorRoot2 = _interopRequireDefault(_GraphicsEditorRoot);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return _extends({
        reelCanvas: state.editor.reel.canvas
    }, ownProps);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {};
};

var GraphicsEditorRootContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_GraphicsEditorRoot2.default);

exports.default = GraphicsEditorRootContainer;

},{"../components/GraphicsEditorRoot.react":274,"react":1107,"react-redux":1079}],287:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _WaitMode = require('../../common/utils/enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _TutorialHint = require('../components/TutorialHint.react');

var _TutorialHint2 = _interopRequireDefault(_TutorialHint);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _state$editor = state.editor,
        waitMode = _state$editor.player.waitMode,
        initialFontsLoaded = _state$editor.initialFontsLoaded,
        overlayHint = state.ui.hints.overlayHint;

    var playerLoaded = waitMode === _WaitMode2.default.NONE;
    var requiredFontsLoaded = initialFontsLoaded;

    var show = overlayHint.shouldShow && overlayHint.show && playerLoaded && requiredFontsLoaded;

    return _extends({}, ownProps, {
        show: show
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClickTarget: function onClickTarget() {
            return dispatch(editorActions.overlayHintTargetClicked());
        },
        onClickOutside: function onClickOutside() {
            return dispatch(editorActions.overlayHintOutsideClicked());
        }
    };
};

var OverlayHintContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TutorialHint2.default);

exports.default = OverlayHintContainer;

},{"../../common/utils/enums/WaitMode":100,"../components/TutorialHint.react":283,"../editorActions":301,"react":1107,"react-redux":1079}],288:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _PreviewButton = require('../components/PreviewButton.react');

var _PreviewButton2 = _interopRequireDefault(_PreviewButton);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state) {
    var player = state.editor.player;

    var ended = player.playbackState === _PlaybackState2.default.ENDED;
    var playing = player.playbackState === _PlaybackState2.default.PLAYING;

    var timePercent = (player.duration > 0 ? player.time / player.duration : 0) * 100;

    var progress = ended ? 0 : timePercent;

    return {
        playing: playing,
        progress: progress
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClick: function onClick() {
            return dispatch(editorActions.previewClicked());
        }
    };
};

var PreviewButtonContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PreviewButton2.default);

exports.default = PreviewButtonContainer;

},{"../../common/utils/enums/PlaybackState":96,"../components/PreviewButton.react":279,"../editorActions":301,"react":1107,"react-redux":1079}],289:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _TutorialHint = require('../components/TutorialHint.react');

var _TutorialHint2 = _interopRequireDefault(_TutorialHint);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var previewHint = state.ui.hints.previewHint;

    var show = previewHint.shouldShow && previewHint.show;

    return _extends({}, ownProps, {
        show: show
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClickOutside: function onClickOutside() {
            return dispatch(editorActions.dismissPreviewHint());
        }
    };
};

var PreviewHintContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TutorialHint2.default);

exports.default = PreviewHintContainer;

},{"../components/TutorialHint.react":283,"../editorActions":301,"react":1107,"react-redux":1079}],290:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _ProjectReadyModal = require('../components/ProjectReadyModal.react');

var _ProjectReadyModal2 = _interopRequireDefault(_ProjectReadyModal);

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state) {
    var _state$ui = state.ui,
        createdProjectId = _state$ui.createdProjectId,
        creatingProject = _state$ui.creatingProject;

    return {
        show: creatingProject || !!createdProjectId,
        createdProjectId: createdProjectId,
        creatingProject: creatingProject
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onHide: function onHide() {
            return dispatch(editorActions.clearCreatedProject());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ProjectReadyModal2.default);

},{"../components/ProjectReadyModal.react":280,"../editorActions":301,"react":1107,"react-redux":1079}],291:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _selectors = require('../selectors');

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _TemplateSection = require('../components/TemplateSection.react');

var _TemplateSection2 = _interopRequireDefault(_TemplateSection);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state) {
    var customFormats = state.workspaceInfo.activeWorkspace ? state.workspaceInfo.activeWorkspace.customFormats : [];
    var selectedWorkspace = state.workspaceInfo.activeWorkspace ? state.workspaceInfo.activeWorkspace : {};
    return {
        template: (0, _selectors.getCurrentTemplate)(state),
        templateTags: (0, _selectors.getTemplateTags)(state),
        similarTemplates: (0, _selectors.getRelatedTemplates)(state),
        selectedBackgroundId: state.editor.selected_background,
        backgrounds: state.editor.backgrounds,
        creatingProject: state.ui.creatingProject,
        loadingBackground: state.ui.loadingBackground,
        createdProjectId: state.ui.createdProjectId,
        isLoggedIn: state.account.isLoggedIn,
        saveUIState: state.ui.saveUIState,
        saveAndExportUIState: state.ui.saveAndExportUIState,
        downloadError: state.ui.downloadError,
        templateExportPercent: state.exportData.templateExportPercent,
        templateExportStatus: state.exportData.templateExportStatus,
        templateExportId: state.exportData.templateExportId,
        templateExportDuration: state.ui.templateExportDuration,
        lastExportId: state.ui.lastExportId,
        isActiveWorkspacePaid: state.ui.isActiveWorkspacePaid,
        customFormatGroups: state.account.customFormatGroups || [],
        showFormatSelectModal: state.ui.showFormatSelectModal,
        customFormats: customFormats,
        customFormatUIState: state.ui.customFormatUIState,
        createButtonText: 'Create New Format',
        selectedWorkspace: selectedWorkspace,
        hasTemplatePlan: state.ui.hasTemplatePlan,
        freeTemplateUsage: state.ui.freeTemplateUsage,
        templateExportBalance: state.ui.templateExportBalance
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClickBackground: function onClickBackground(id) {
            return dispatch(editorActions.selectBackground(id));
        },
        onClickOutsideEditor: function onClickOutsideEditor() {
            return dispatch(editorActions.selectClear());
        },
        onClickUseTemplate: function onClickUseTemplate() {
            return dispatch(editorActions.useTemplate());
        },
        onClickSaveTemplate: function onClickSaveTemplate() {
            return dispatch(editorActions.initSaveTemplate());
        },
        onClickSaveAndExportTemplate: function onClickSaveAndExportTemplate() {
            return dispatch(editorActions.initSaveAndExportTemplate());
        },
        createProjectWithFormat: function createProjectWithFormat(formatId) {
            return dispatch(editorActions.createProjectWithFormat(formatId));
        },
        onCloseFormatSelectModal: function onCloseFormatSelectModal() {
            return dispatch(editorActions.closeFormatSelectModal());
        },
        onSetExportDuration: function onSetExportDuration(templateExportDuration) {
            return dispatch(editorActions.updateTemplateExportDuration(templateExportDuration));
        },
        openCustomFormatModal: function openCustomFormatModal() {
            return dispatch(editorActions.openCustomFormatModal());
        },
        onCloseCustomFormatModal: function onCloseCustomFormatModal() {
            return dispatch(editorActions.closeCustomFormatModal());
        },
        saveCustomFormat: function saveCustomFormat(customFormatObj) {
            return dispatch(editorActions.createCustomFormat(customFormatObj));
        },
        onClickDownloadTemplate: function onClickDownloadTemplate(exportId) {
            return dispatch(editorActions.fetchTemplateDownloadUrl(exportId));
        },
        onClickCancelExport: function onClickCancelExport() {
            return dispatch(editorActions.cancelTemplateExport());
        }
    };
};

var TemplateSectionContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TemplateSection2.default);

exports.default = TemplateSectionContainer;

},{"../components/TemplateSection.react":282,"../editorActions":301,"../selectors":307,"react":1107,"react-redux":1079}],292:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _WorkspaceSelectModal = require('../../common/components/WorkspaceSelectModal.react');

var _WorkspaceSelectModal2 = _interopRequireDefault(_WorkspaceSelectModal);

var _editorActions = require('../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state) {
    var _state$workspaceInfo = state.workspaceInfo,
        allWorkspaces = _state$workspaceInfo.allWorkspaces,
        activeWorkspace = _state$workspaceInfo.activeWorkspace,
        _state$ui = state.ui,
        showWorkspaceSelectModal = _state$ui.showWorkspaceSelectModal,
        postWorkspaceChangeAction = _state$ui.postWorkspaceChangeAction;

    var confirmButtonLabel = void 0;
    if (postWorkspaceChangeAction == 'SAVE_TEMPLATE') {
        confirmButtonLabel = 'Save in team';
    } else if (postWorkspaceChangeAction == 'USE_TEMPLATE') {
        confirmButtonLabel = 'Use in team';
    }

    return {
        show: showWorkspaceSelectModal,
        selectedWorkspace: activeWorkspace,
        allWorkspaces: allWorkspaces,
        confirmButtonLabel: confirmButtonLabel,
        heading: "Select Team",
        currentLabel: "Continue",
        activeButtonClass: "btn-continue",
        switchButtonClass: "btn-switch"
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClose: function onClose() {
            return dispatch(editorActions.closeWorkspaceSelectModal());
        },
        onConfirm: function onConfirm(workspaceId) {
            return dispatch(editorActions.changeWorkspace(workspaceId));
        }
    };
};

var WorkspaceSelectModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WorkspaceSelectModal2.default);

exports.default = WorkspaceSelectModalContainer;

},{"../../common/components/WorkspaceSelectModal.react":15,"../editorActions":301,"react-redux":1079}],293:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _OverlayPreview = require('../../../edit/components/OverlayPreview.react');

var _OverlayPreview2 = _interopRequireDefault(_OverlayPreview);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    // const { overlays, overlaymeta, reel : { canvas }, selection } = state
    //
    // const sortedOverlayIdList = Object.keys(overlays)
    //     .sort((oid1, oid2) => (overlays[oid1].space.zIndex > overlays[oid2].space.zIndex))
    //
    // const { playbackState } = state.player
    //
    // return { overlays, overlaymeta, sortedOverlayIdList, canvas, playbackState, selection, ...ownProps }

    var _state$editor = state.editor,
        overlays = _state$editor.overlays,
        overlaymeta = _state$editor.overlaymeta,
        canvas = _state$editor.reel.canvas,
        player = _state$editor.player,
        selection = _state$editor.selection;
    var playbackState = player.playbackState;

    return _extends({
        overlays: overlays,
        overlaymeta: overlaymeta,
        playbackState: playbackState,
        sortedOverlayIdList: Object.keys(overlays),
        canvas: canvas,
        selection: selection
    }, ownProps);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {};
};

var OverlayPreviewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_OverlayPreview2.default);

exports.default = OverlayPreviewContainer;

},{"../../../edit/components/OverlayPreview.react":183,"react":1107,"react-redux":1079}],294:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _WaitMode = require('../../../common/utils/enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _OverlayTutorialHintsLayer = require('../../components/OverlayTutorialHintsLayer.react');

var _OverlayTutorialHintsLayer2 = _interopRequireDefault(_OverlayTutorialHintsLayer);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var overlays = state.editor.overlays;
    var displayScale = ownProps.displayScale;

    var overlayId = Object.keys(overlays)[0];
    var overlay = overlays[overlayId];

    var targetRect = {};
    targetRect.x = overlay.space.x * displayScale;
    targetRect.y = overlay.space.y * displayScale;
    targetRect.width = overlay.space.width * displayScale;
    targetRect.height = overlay.space.height * displayScale;

    return {
        overlayTargetBox: targetRect
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {};
};

var OverlayTutorialHintsLayerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_OverlayTutorialHintsLayer2.default);

exports.default = OverlayTutorialHintsLayerContainer;

},{"../../../common/utils/enums/WaitMode":100,"../../components/OverlayTutorialHintsLayer.react":276,"react":1107,"react-redux":1079}],295:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

// import * as overlayActions from '../actions/overlayActions'
// import * as placeholderActions from '../actions/placeholderActions'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _PlaybackState = require('../../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _editorActions = require('../../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _PlaceholderLayer = require('../../components/PlaceholderLayer.react');

var _PlaceholderLayer2 = _interopRequireDefault(_PlaceholderLayer);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _state$editor = state.editor,
        selected = _state$editor.selection.selected,
        overlays = _state$editor.overlays,
        canvas = _state$editor.reel.canvas,
        _state$editor$player = _state$editor.player,
        playbackState = _state$editor$player.playbackState,
        playerTime = _state$editor$player.time,
        isCropping = _state$editor.placeholderData.isCropping;

    var isPlaying = playbackState === _PlaybackState2.default.PLAYING;

    var placeholderOverlays = {};

    if (Object.keys(selected).length === 1) {
        Object.keys(selected).forEach(function (oid) {
            var overlay = overlays[oid];
            var def = getTemplateDefForId(overlay.defId);
            var _def$meta$placeholder = def.meta.placeholders,
                placeholders = _def$meta$placeholder === undefined ? {} : _def$meta$placeholder;

            if (Object.keys(placeholders).length > 0) {
                placeholderOverlays[oid] = overlay;
            }
        });
    }

    return _extends({
        isPlaying: isPlaying,
        isCropping: isCropping,
        placeholderOverlays: placeholderOverlays,
        canvas: canvas
    }, ownProps);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {

    return {
        changeOverlayValue: function changeOverlayValue(overlay) {
            return dispatch(editorActions.changeOverlay(overlay));
        },
        onCroppingStart: function onCroppingStart() {
            return dispatch(editorActions.onCroppingStart());
        },
        onCroppingDone: function onCroppingDone(cropData) {
            return dispatch(editorActions.onCroppingDone(cropData));
        },
        onCroppingCancel: function onCroppingCancel() {
            return dispatch(editorActions.onCroppingCancel());
        },
        onChangeImage: function onChangeImage() {
            return dispatch(editorActions.changePlaceholderImage.apply(editorActions, arguments));
        }
    };
};

var PlaceholderLayerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PlaceholderLayer2.default);

exports.default = PlaceholderLayerContainer;

},{"../../../common/utils/enums/PlaybackState":96,"../../components/PlaceholderLayer.react":278,"../../editorActions":301,"react":1107,"react-redux":1079}],296:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _OverlayUtils = require('../../../edit/utils/OverlayUtils');

var _PropertiesBar = require('../../../edit-old/components/PropertiesBar.react');

var _PropertiesBar2 = _interopRequireDefault(_PropertiesBar);

var _PlaybackState = require('../../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _editorActions = require('../../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _state$editor = state.editor,
        _state$editor$selecti = _state$editor.selection,
        selected = _state$editor$selecti.selected,
        focus = _state$editor$selecti.focus,
        canvas = _state$editor.reel.canvas,
        overlays = _state$editor.overlays,
        overlaymeta = _state$editor.overlaymeta,
        _state$editor$player = _state$editor.player,
        playbackState = _state$editor$player.playbackState,
        projectDuration = _state$editor$player.duration,
        isCropping = _state$editor.placeholderData.isCropping;

    var selectedOverlays = {};

    Object.keys(selected).forEach(function (oid) {
        selectedOverlays[oid] = overlays[oid];
    });

    var anySelected = Object.keys(selected).length > 0;

    var selectedRect = anySelected ? (0, _OverlayUtils.overlayRectUnion)(Object.keys(selected).map(function (oid) {
        return overlays[oid];
    })) : {};

    var currentFocus = null;
    if (focus && focus.uid && Object.keys(selected).length == 1) {
        var _focus$uid$split = focus.uid.split('$-$'),
            _focus$uid$split2 = _slicedToArray(_focus$uid$split, 3),
            oid = _focus$uid$split2[0],
            prop = _focus$uid$split2[1],
            layerId = _focus$uid$split2[2];

        currentFocus = {
            layer: {
                oid: oid,
                prop: prop,
                layerId: layerId
            },
            start: focus.start,
            end: focus.end,
            length: focus.length
        };
    }

    var isPlaying = playbackState == _PlaybackState2.default.PLAYING;

    return _extends({
        selectedOverlays: selectedOverlays,
        overlaymeta: overlaymeta,
        canvas: canvas,
        currentFocus: currentFocus,
        selectedRect: selectedRect,
        isPlaying: isPlaying,
        isCropping: isCropping,
        projectDuration: projectDuration,
        isDemo: true,
        overlays: overlays
    }, ownProps);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {

    return {
        onDelete: function onDelete() {},
        onCopy: function onCopy() {},
        onSelectColor: function onSelectColor(color) {},
        onOverlayChangeIncremental: function onOverlayChangeIncremental(overlay) {
            return dispatch(editorActions.changeOverlay(overlay));
        },
        onOverlayChangeFinish: function onOverlayChangeFinish(overlay, startOverlay) {
            return dispatch(editorActions.changeOverlay(overlay));
        },
        onSetGroupAnimation: function onSetGroupAnimation(kind, enable) {},
        onSetOutTimeFinish: function onSetOutTimeFinish(time) {
            return dispatch(editorActions.setOutTimeFinishForSelected(time));
        },
        onAnimationTypeChange: function onAnimationTypeChange(kind, animDefId) {
            return dispatch(editorActions.changeAnimationType(kind, animDefId));
        },
        onAnimationDurationChange: function onAnimationDurationChange(kind, duration) {
            return dispatch(editorActions.changeAnimationDuration(kind, duration));
        },
        onAnimationManualModeChange: function onAnimationManualModeChange(kind, isManual, duration) {
            return dispatch(editorActions.changeAnimationManualMode(kind, isManual, duration));
        },
        onDisableOverlayMovement: function onDisableOverlayMovement() {}
        // onDelete : () => dispatch(overlayActions.deleteSelectedOverlays()),
        // onCopy : () => dispatch(overlayActions.copyOverlays()),
        // onSelectColor : (color) => dispatch(reelActions.addProjectColor(color)),
        // onOverlayChangeIncremental : overlay => dispatch(overlayActions.changeOverlayIncremental(overlay)),
        // onOverlayChangeFinish : (overlay, startOverlay) => dispatch(overlayActions.changeOverlayFinish(overlay, startOverlay)),
        // onSetGroupAnimation : (kind, enable) => dispatch(overlayActions.onSetGroupAnimation(kind, enable)),
        // onAnimationTypeChange : (kind, animDefId) => dispatch(overlayActions.onAnimationTypeChange(kind, animDefId)),
        // onAnimationDurationChange : (kind, duration) => dispatch(overlayActions.onAnimationDurationChange(kind, duration)),
        // onAnimationManualModeChange : (kind, isManual, duration) => dispatch(overlayActions.onAnimationManualModeChange(kind, isManual, duration))
    };
};

var PropertiesBarContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PropertiesBar2.default);

exports.default = PropertiesBarContainer;

},{"../../../common/utils/enums/PlaybackState":96,"../../../edit-old/components/PropertiesBar.react":147,"../../../edit/utils/OverlayUtils":231,"../../editorActions":301,"react":1107,"react-redux":1079}],297:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _SelectionLayer = require('../../../edit/components/SelectionLayer.react');

var _SelectionLayer2 = _interopRequireDefault(_SelectionLayer);

var _editorActions = require('../../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _overlaySelectors = require('../../../edit/selectors/overlaySelectors');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _state$editor = state.editor,
        selection = _state$editor.selection,
        _state$editor$player = _state$editor.player,
        playbackState = _state$editor$player.playbackState,
        time = _state$editor$player.time,
        canvas = _state$editor.reel.canvas;

    var selectedOverlays = (0, _overlaySelectors.getSelectedOverlays)(state.editor);
    var relevantOverlays = (0, _overlaySelectors.getRelevantOverlays)(state.editor);
    var overlays = (0, _overlaySelectors.getOverlaysWithValidTemplate)(state.editor);

    return _extends({
        overlays: overlays,
        selection: selection,
        selectedOverlays: selectedOverlays,
        relevantOverlays: relevantOverlays,
        playbackState: playbackState,
        time: time,
        canvas: canvas,
        disableMovement: false,
        containsWatermark: false
    }, ownProps);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        // onSelectAdd : (id) => dispatch(overlayActions.selectAdd(id)),
        // onSelectOnly : (id) => dispatch(overlayActions.selectOnly(id)),
        // onMoveSingleIncremental : (movedOverlay) => dispatch(overlayActions.moveSingleIncremental(movedOverlay)),
        // onMoveSingleFinish : (movedOverlay, startOverlay) => dispatch(overlayActions.moveSingleFinish(movedOverlay, startOverlay)),
        // onMoveMultipleIncremental : (movedOverlays) => dispatch(overlayActions.moveMultipleIncremental(movedOverlays)),
        // onMoveMultipleFinish : (movedOverlays, startOverlays) => dispatch(overlayActions.moveMultipleFinish(movedOverlays, startOverlays)),
        // onResizeIncremental : (resizedOverlays) => dispatch(overlayActions.resizeIncremental(resizedOverlays)),
        // onResizeFinish : (resizedOverlays, startOverlays) => dispatch(overlayActions.resizeFinish(resizedOverlays, startOverlays))
        onSelectAdd: function onSelectAdd(id) {
            return dispatch(editorActions.selectOverlay(id));
        },
        onSelectOnly: function onSelectOnly(id) {
            return dispatch(editorActions.selectOverlay(id));
        },
        onMoveSingleIncremental: function onMoveSingleIncremental(movedOverlay) {
            return dispatch(editorActions.moveOverlay(movedOverlay));
        },
        onMoveSingleFinish: function onMoveSingleFinish(movedOverlay, startOverlay) {
            return dispatch(editorActions.moveOverlay(movedOverlay));
        },
        onMoveMultipleIncremental: function onMoveMultipleIncremental(movedOverlays) {
            return dispatch(editorActions.moveOverlayMultiple(movedOverlays));
        },
        onMoveMultipleFinish: function onMoveMultipleFinish(movedOverlays, startOverlays) {
            return dispatch(editorActions.moveOverlayMultiple(movedOverlays));
        },
        onResizeIncremental: function onResizeIncremental(resizedOverlays) {
            return dispatch(editorActions.resizeOverlays(resizedOverlays));
        },
        onResizeFinish: function onResizeFinish(resizedOverlays, startOverlays) {
            return dispatch(editorActions.resizeOverlays(resizedOverlays));
        }
    };
};

var SelectionLayerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SelectionLayer2.default);

exports.default = SelectionLayerContainer;

},{"../../../edit/components/SelectionLayer.react":189,"../../../edit/selectors/overlaySelectors":217,"../../editorActions":301,"react":1107,"react-redux":1079}],298:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _PlaybackState = require('../../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _editorActions = require('../../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _TextEditorLayer = require('../../../edit/components/TextEditorLayer.react');

var _TextEditorLayer2 = _interopRequireDefault(_TextEditorLayer);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _state$editor = state.editor,
        selected = _state$editor.selection.selected,
        overlays = _state$editor.overlays,
        canvas = _state$editor.reel.canvas,
        playbackState = _state$editor.player.playbackState;

    var isPlaying = playbackState === _PlaybackState2.default.PLAYING;

    var editableOverlays = {};

    if (Object.keys(selected).length === 1) {
        Object.keys(selected).forEach(function (oid) {
            var overlay = overlays[oid];
            var def = getTemplateDefForId(overlay.defId);
            var _def$meta$textEditors = def.meta.textEditors,
                textEditors = _def$meta$textEditors === undefined ? {} : _def$meta$textEditors;

            if (Object.keys(textEditors).length > 0) {
                editableOverlays[oid] = overlay;
            }
        });
    }

    return _extends({
        isPlaying: isPlaying,
        editableOverlays: editableOverlays,
        canvas: canvas
    }, ownProps);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {

    return {
        changeOverlayValue: function changeOverlayValue(overlay) {
            return dispatch(editorActions.changeOverlay(overlay));
        },
        setFocus: function setFocus(uid, start, end, length) {
            return dispatch(editorActions.setFocus(uid, start, end, length));
        }
    };
};

var TextEditorLayerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TextEditorLayer2.default);

exports.default = TextEditorLayerContainer;

},{"../../../common/utils/enums/PlaybackState":96,"../../../edit/components/TextEditorLayer.react":191,"../../editorActions":301,"react":1107,"react-redux":1079}],299:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _VideoInteractiveLayer = require('../../../edit/components/VideoInteractiveLayer.react');

var _VideoInteractiveLayer2 = _interopRequireDefault(_VideoInteractiveLayer);

var _editorActions = require('../../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var emptyFunc = function emptyFunc() {};

var mapStateToProps = function mapStateToProps(_, ownProps) {
    return ownProps;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {

    return {
        onSetSelectingRect: emptyFunc,
        onEndSelectingRect: emptyFunc,
        onVideoClick: function onVideoClick() {
            return dispatch(editorActions.clickVideo());
        }
    };
};

var VideoInteractiveLayerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VideoInteractiveLayer2.default);

exports.default = VideoInteractiveLayerContainer;

},{"../../../edit/components/VideoInteractiveLayer.react":192,"../../editorActions":301,"react":1107,"react-redux":1079}],300:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _editorActions = require('../../editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _VideoPreview = require('../../../edit/components/VideoPreview.react');

var _VideoPreview2 = _interopRequireDefault(_VideoPreview);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        initialReel: state.editor.reel,
        corePlayer: ownProps.corePlayer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onWaitModeChange: function onWaitModeChange(waitMode) {
            return dispatch(editorActions.eventChangeWaitMode(waitMode));
        },
        onPlaybackStateChange: function onPlaybackStateChange(playbackState) {
            return dispatch(editorActions.eventChangePlaybackState(playbackState));
        },
        onCurrentTimeChange: function onCurrentTimeChange(time) {
            return dispatch(editorActions.eventChangeCurrentTime(time));
        },
        onDurationChange: function onDurationChange(duration) {
            return dispatch(editorActions.eventChangeDuration(duration));
        },
        onVolumeChange: function onVolumeChange(volume) {
            return dispatch(editorActions.eventChangeVolume(volume));
        }
    };
};

var VideoPreviewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VideoPreview2.default);

exports.default = VideoPreviewContainer;

},{"../../../edit/components/VideoPreview.react":193,"../../editorActions":301,"react":1107,"react-redux":1079}],301:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

exports.selectOverlay = selectOverlay;
exports.changeOverlay = changeOverlay;
exports.selectClear = selectClear;
exports.setFocus = setFocus;
exports.moveOverlay = moveOverlay;
exports.moveOverlayMultiple = moveOverlayMultiple;
exports.resizeOverlays = resizeOverlays;
exports.clickVideo = clickVideo;
exports.changeAnimationType = changeAnimationType;
exports.changeAnimationDuration = changeAnimationDuration;
exports.changeAnimationManualMode = changeAnimationManualMode;
exports.setOutTimeFinishForSelected = setOutTimeFinishForSelected;
exports.eventChangeWaitMode = eventChangeWaitMode;
exports.eventChangePlaybackState = eventChangePlaybackState;
exports.eventChangeCurrentTime = eventChangeCurrentTime;
exports.eventChangeDuration = eventChangeDuration;
exports.eventChangeVolume = eventChangeVolume;
exports.togglePlay = togglePlay;
exports.pauseAndReset = pauseAndReset;
exports.play = play;
exports.pause = pause;
exports.seek = seek;
exports.rewind = rewind;
exports.forward = forward;
exports.seekToPrevFrame = seekToPrevFrame;
exports.seekToNextFrame = seekToNextFrame;
exports.setVolume = setVolume;
exports.addClip = addClip;
exports.deleteClip = deleteClip;
exports.selectBackground = selectBackground;
exports.previewClicked = previewClicked;
exports.showFormatSelectModal = showFormatSelectModal;
exports.closeFormatSelectModal = closeFormatSelectModal;
exports.createProjectWithFormat = createProjectWithFormat;
exports.useTemplate = useTemplate;
exports.initSaveTemplate = initSaveTemplate;
exports.cancelTemplateExport = cancelTemplateExport;
exports.initSaveAndExportTemplate = initSaveAndExportTemplate;
exports.createProject = createProject;
exports.clearCreatedProject = clearCreatedProject;
exports.fontLoaded = fontLoaded;
exports.requiredFontsLoaded = requiredFontsLoaded;
exports.sessionUpdate = sessionUpdate;
exports.changePlaceholderImage = changePlaceholderImage;
exports.onCroppingStart = onCroppingStart;
exports.onCroppingDone = onCroppingDone;
exports.onCroppingCancel = onCroppingCancel;
exports.overlayHintTargetClicked = overlayHintTargetClicked;
exports.overlayHintOutsideClicked = overlayHintOutsideClicked;
exports.showPreviewHint = showPreviewHint;
exports.showBackgroundHint = showBackgroundHint;
exports.dismissOverlayHint = dismissOverlayHint;
exports.dismissPreviewHint = dismissPreviewHint;
exports.dismissBackgroundHint = dismissBackgroundHint;
exports.closeWorkspaceSelectModal = closeWorkspaceSelectModal;
exports.updateWorkspaces = updateWorkspaces;
exports.changeWorkspace = changeWorkspace;
exports.createCustomFormat = createCustomFormat;
exports.closeCustomFormatModal = closeCustomFormatModal;
exports.openCustomFormatModal = openCustomFormatModal;
exports.updateStatus = updateStatus;
exports.updatePercent = updatePercent;
exports.updateExportId = updateExportId;
exports.updateTemplateExportDuration = updateTemplateExportDuration;
exports.fetchTemplateDownloadUrl = fetchTemplateDownloadUrl;
exports.getTemplateExportBalance = getTemplateExportBalance;

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _ActionTypes = require('./ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _PlaybackState = require('../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _OverlayUtils = require('../edit/utils/OverlayUtils');

var _ReelHelpers = require('../common/utils/ReelHelpers');

var _FileUploadManager = require('../edit/utils/FileUploadManager');

var _FileUploadManager2 = _interopRequireDefault(_FileUploadManager);

var _ProcessingTracker = require('../edit/utils/ProcessingTracker');

var _ProcessingTracker2 = _interopRequireDefault(_ProcessingTracker);

var _ModelDataUtils = require('../common/utils/ModelDataUtils');

var _GeneralUtils = require('../common/utils/GeneralUtils');

var _TemplateConfig = require('../common/config/TemplateConfig');

var _constants = require('../common/constants');

var _apis = require('./apis');

var _workspaceApi = require('../common/api/workspaceApi');

var _TrackUtils = require('../common/utils/TrackUtils');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function selectOverlay() {
    return { type: ActionTypes.EDITOR_OVERLAY_SELECT };
}

function changeOverlay(overlay) {
    return { type: ActionTypes.EDITOR_OVERLAY_CHANGE, overlay: overlay };
}

function selectClear() {
    return { type: ActionTypes.EDITOR_OVERLAY_SELECT_CLEAR };
}

function setFocus(uid, start, end, length) {
    return { type: ActionTypes.EDITOR_OVERLAY_TEXT_SET_FOCUS, uid: uid, start: start, end: end, length: length };
}

function moveOverlay(movedOverlay) {
    return { type: ActionTypes.EDITOR_OVERLAY_MOVE, movedOverlay: movedOverlay };
}

function moveOverlayMultiple(movedOverlays) {
    return { type: ActionTypes.EDITOR_OVERLAY_MOVE_MULTIPLE, movedOverlays: movedOverlays };
}

function resizeOverlays(resizedOverlays) {
    return { type: ActionTypes.EDITOR_OVERLAY_RESIZE, resizedOverlays: resizedOverlays };
}

function clickVideo() {
    return function (dispatch, getState) {
        var _getState$editor = getState().editor,
            selected = _getState$editor.selection.selected,
            player = _getState$editor.player;

        var anyselected = Object.keys(selected).length > 0;

        if (anyselected) {
            dispatch(selectClear());
        } else {
            dispatch(togglePlay());
        }
    };
}

function changeAnimationType(kind, animDefId) {
    return function (dispatch, getState) {
        var _getState$editor2 = getState().editor,
            selected = _getState$editor2.selection.selected,
            overlays = _getState$editor2.overlays;

        var type = kind === 'enter' ? ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM : ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM;

        dispatch({ type: type, ids: selected, animDefId: animDefId });

        type = kind === 'enter' ? ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION : ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION;
        if (animDefId == 'animDefId-OUT-NONE' || animDefId == 'animDefId-IN-NONE') {
            var duration = 0;
            dispatch({ type: type, ids: selected, duration: duration });
        } else {
            var _duration = 200;
            if (Object.keys(selected).length) {
                var times = overlays[Object.keys(selected)[0]].time;
                _duration = kind === 'enter' ? times.enterdone - times.enterstart : times.exitdone - times.exitstart;
                _duration = !_duration ? 200 : _duration;
            }
            dispatch({ type: type, ids: selected, duration: _duration });
        }
    };
}

function changeAnimationDuration(kind, duration) {
    return function (dispatch, getState) {
        var selected = getState().editor.selection.selected;

        var type = kind === 'enter' ? ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION : ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION;

        dispatch({ type: type, ids: selected, duration: duration });
    };
}

function changeAnimationManualMode(kind, isManual, duration) {
    return function (dispatch, getState) {
        var selected = getState().editor.selection.selected;

        var type = kind === 'enter' ? ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION_MANUAL_MODE : ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION_MANUAL_MODE;

        dispatch({ type: type, ids: selected, isManual: isManual, duration: duration });
    };
}

function setOutTimeFinishForSelected(time) {
    return function (dispatch, getState) {
        var selected = getState().editor.selection.selected;

        dispatch({ type: ActionTypes.EDITOR_OVERLAY_SET_OUT_TIME_FINISH, ids: selected, time: time });
    };
}

function eventChangeWaitMode(waitMode) {
    return { type: ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_WAIT_MODE, waitMode: waitMode };
}

function eventChangePlaybackState(playbackState) {
    return { type: ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_PLAYBACK_STATE, playbackState: playbackState };
}

function eventChangeCurrentTime(time) {
    return { type: ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_CURRENT_TIME, time: time };
}

function eventChangeDuration(duration) {
    return { type: ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_DURATION, duration: duration };
}

function eventChangeVolume(volume) {
    return { type: ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_VOLUME, volume: volume };
}

function togglePlay() {
    return function (dispatch, getState) {
        var playing = getState().editor.player.playbackState === _PlaybackState2.default.PLAYING;

        dispatch(playing ? pauseAndReset() : play());
    };
}

function pauseAndReset() {
    return function (dispatch, getState) {
        dispatch(pause());
        dispatch(seek(0));
    };
}

function play() {
    return function (dispatch, getState) {
        dispatch(dismissPreviewHint());
        dispatch({ type: ActionTypes.EDITOR_VIDEO_PLAYER_PLAY });
    };
}

function pause() {
    return function (dispatch, getState) {
        dispatch(dismissPreviewHint());
        dispatch({ type: ActionTypes.EDITOR_VIDEO_PLAYER_PAUSE });
    };
}

function seek(time) {
    time = Math.floor(time);
    return { type: ActionTypes.EDITOR_VIDEO_PLAYER_SEEK, time: time };
}

function rewind() {
    return function (dispatch, getState) {
        var _getState$player = getState().player,
            playbackState = _getState$player.playbackState,
            time = _getState$player.time;

        dispatch(seek(Math.max(time - 1000, 0)));
    };
}

function forward() {
    return function (dispatch, getState) {
        var _getState$player2 = getState().player,
            playbackState = _getState$player2.playbackState,
            time = _getState$player2.time,
            duration = _getState$player2.duration;

        dispatch(seek(Math.min(time + 1000, duration)));
    };
}

function seekToPrevFrame() {
    return function (dispatch, getState) {
        var _getState$player3 = getState().player,
            playbackState = _getState$player3.playbackState,
            time = _getState$player3.time;

        if (playbackState === _PlaybackState2.default.PLAYING) {
            dispatch(pause());
        }

        dispatch(seek(Math.max(time - 16, 0)));
    };
}

function seekToNextFrame() {
    return function (dispatch, getState) {
        var _getState$player4 = getState().player,
            playbackState = _getState$player4.playbackState,
            time = _getState$player4.time,
            duration = _getState$player4.duration;

        if (playbackState === _PlaybackState2.default.PLAYING) {
            dispatch(pause());
        }

        dispatch(seek(Math.min(time + 16, duration)));
    };
}

function setVolume(volume) {
    return { type: ActionTypes.EDITOR_VIDEO_PLAYER_SET_VOLUME, volume: volume };
}

function addClip(clip) {
    return { type: ActionTypes.EDITOR_REEL_ADD_CLIP, clip: clip };
}

function deleteClip(clip, clipIndex) {
    return { type: ActionTypes.EDITOR_REEL_DELETE_CLIP, clip: clip, index: clipIndex };
}

function selectBackground(new_bg_id) {
    return function (dispatch, getState) {
        var _getState$editor3 = getState().editor,
            backgrounds = _getState$editor3.backgrounds,
            empty_background = _getState$editor3.empty_background,
            reel = _getState$editor3.reel;
        var clips = reel.clips,
            canvas = reel.canvas,
            frameType = reel.frameType;

        var _clips = _slicedToArray(clips, 1),
            currentClip = _clips[0];

        var next_background = null;
        if (currentClip.clipVideoId === empty_background.id) {
            if (new_bg_id !== empty_background.id) {
                // current_background = empty_background
                next_background = backgrounds.find(function (b) {
                    return b.id === new_bg_id;
                });
            } else {
                // Nothing
                return;
            }
        } else {
            // current_background = backgrounds.find(b => b.id === currentClip.clipVideoId)

            if (new_bg_id === currentClip.clipVideoId) {
                return;
                // next_background = empty_background
            } else if (new_bg_id === empty_background.id) {
                next_background = empty_background;
            } else {
                next_background = backgrounds.find(function (b) {
                    return b.id === new_bg_id;
                });
            }
        }

        var newClip = {
            clipId: '' + _shortid2.default.generate(),
            clipType: 'video',
            clipVideoId: next_background.id,
            clipVideo: next_background,
            clipStart: currentClip.clipStart,
            clipVolume: 1,
            musicVolume: 1,
            clipDuration: currentClip.clipDuration,
            speed: currentClip.speed,
            time: {
                enterStart: 0,
                enterDone: 0,
                exitStart: currentClip.clipDuration,
                exitDone: currentClip.clipDuration
            },
            transitions: {}
        };

        newClip = _extends({}, newClip, { clipBox: (0, _ReelHelpers.calcDefaultClipBox)(newClip, frameType, canvas) });

        dispatch(pause());

        dispatch(addClip(newClip));
        dispatch(deleteClip(currentClip, 0));

        dispatch(seek(0));

        dispatch({ type: ActionTypes.EDITOR_BACKGROUND_SET, id: next_background.id });

        dispatch(dismissBackgroundHint());
    };
}

function previewClicked() {
    return function (dispatch, getState) {
        var player = getState().editor.player;

        if (player.playbackState === _PlaybackState2.default.ENDED) {
            dispatch(seek(0));
            dispatch(play());
        } else if (player.playbackState === _PlaybackState2.default.PAUSED) {
            dispatch(play());
        } else if (player.playbackState === _PlaybackState2.default.PLAYING) {
            dispatch(pauseAndReset());
        }
    };
}

function showFormatSelectModal() {
    return function (dispatch) {
        dispatch({ type: ActionTypes.SHOW_FORMAT_SELECT });
    };
}

function closeFormatSelectModal() {
    return function (dispatch) {
        dispatch({ type: ActionTypes.CLOSE_FORMAT_SELECT });
    };
}

function createProjectWithFormat(formatId) {
    return function (dispatch) {
        dispatch(closeFormatSelectModal());
        dispatch(createProject(formatId));
    };
}

function useTemplate() {
    return function (dispatch, getState) {
        var _getState = getState(),
            isLoggedIn = _getState.account.isLoggedIn,
            _getState$ui$createdP = _getState.ui.createdProjectId,
            createdProjectId = _getState$ui$createdP === undefined ? null : _getState$ui$createdP,
            allWorkspaces = _getState.workspaceInfo.allWorkspaces;

        if (isLoggedIn) {
            if (allWorkspaces.length === 1 || !!_jsCookie2.default.get(WORKPSPACE_SELECT_COOKIE_NAME)) {
                if (!!createdProjectId) {
                    window.open('/open/' + createdProjectId, '_blank');
                } else {
                    dispatch(showFormatSelectModal());
                    // dispatch(createProject())
                }
            } else {
                dispatch(showWorkspaceSelectModal('USE_TEMPLATE'));
            }
        } else if (!!window.openLoginForm) {
            window.openLoginForm('USE_TEMPLATE');
        }
    };
}

function saveTemplate() {
    return function (dispatch, getState) {
        var _getState2 = getState(),
            currentTemplateId = _getState2.ui.currentTemplateId,
            overlays = _getState2.editor.overlays,
            templates = _getState2.templates;

        var selectedTemplate = templates.find(function (t) {
            return t.id === currentTemplateId;
        });

        dispatch({ type: ActionTypes.API_SAVING_GRAPHIC });

        var overlay = Object.values(overlays)[0];
        var defId = overlay.defId,
            values = overlay.values;

        var def = getTemplateDefForId(defId);
        var imageprops = Object.keys(def.props).filter(function (p) {
            return def.props[p] === 'imageId';
        });

        var p = Promise.resolve();
        if (imageprops.length > 0) {
            p = Promise.all(imageprops.map(function (p) {
                var localImageFile = window.getLocalImageFile(values[p]);

                if (!!localImageFile) {
                    // custom file, needs to be uploaded
                    return Promise.resolve(localImageFile).then(uploadLocalImageP).then(waitUntilWorkspaceImageReady).then(function (imageData) {
                        var id = imageData.id;

                        overlay.values = _extends({}, values, _defineProperty({}, '' + p, id));
                    });
                }
            }));
        }

        p.then(function () {
            var template = (0, _OverlayUtils.createTemplateFromOverlays)([overlay], {}, selectedTemplate.config.canvas);

            (0, _apis.saveTemplateP)(template, currentTemplateId, selectedTemplate.name).then(function (response) {
                if (!response || !response.success) {
                    throw new Error('Error in response');
                } else if (response.success) {
                    var newTemplateId = response.id;
                    (0, _TrackUtils.trackOnSmartlook)('Template used/saved', {
                        templateId: '' + newTemplateId,
                        templateName: '' + selectedTemplate.name
                    });
                }
            }).catch(function (err) {
                console.error(err);
            }).finally(function () {
                dispatch({ type: ActionTypes.API_SAVED_GRAPHIC });
            });
        });
    };
}

function saveAndExportTemplate() {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            _getState3$ui = _getState3.ui,
            currentTemplateId = _getState3$ui.currentTemplateId,
            templateExportDuration = _getState3$ui.templateExportDuration,
            overlays = _getState3.editor.overlays,
            templates = _getState3.templates;

        var selectedTemplate = templates.find(function (t) {
            return t.id === currentTemplateId;
        });

        var overlay = Object.values(overlays)[0];
        var defId = overlay.defId,
            values = overlay.values;

        var def = getTemplateDefForId(defId);
        var imageprops = Object.keys(def.props).filter(function (p) {
            return def.props[p] === 'imageId';
        });

        var p = Promise.resolve();
        if (imageprops.length > 0) {
            p = Promise.all(imageprops.map(function (p) {
                var localImageFile = window.getLocalImageFile(values[p]);

                if (!!localImageFile) {
                    // custom file, needs to be uploaded
                    return Promise.resolve(localImageFile).then(uploadLocalImageP).then(waitUntilWorkspaceImageReady).then(function (imageData) {
                        var id = imageData.id;

                        overlay.values = _extends({}, values, _defineProperty({}, '' + p, id));
                    });
                }
            }));
        }

        p.then(function () {
            var template = (0, _OverlayUtils.createTemplateFromOverlays)([overlay], {}, selectedTemplate.config.canvas);

            template = adjustTemplateTimesForExport(template, templateExportDuration);
            (0, _apis.saveAndExportTemplateP)(template, currentTemplateId, selectedTemplate.name).then(function (response) {
                if (!response || !response.success) {
                    dispatch({ type: ActionTypes.API_RESET_GRAPHIC_EXPORT });
                    throw new Error('Error in response');
                } else if (response.success) {
                    dispatch({ type: ActionTypes.API_EXPORTING_GRAPHIC });
                    var exportId = response.exportId;
                    window.initializeTemplateExportIOClient(exportId);
                    var newTemplateId = response.id;
                    (0, _TrackUtils.trackOnSmartlook)('Template saved and downloaded', {
                        templateId: '' + newTemplateId,
                        templateName: '' + selectedTemplate.name
                    });
                }
            }).catch(function (err) {
                console.error(err);
            });
        });
    };
}

function initSaveTemplate() {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            allWorkspaces = _getState4.workspaceInfo.allWorkspaces;

        if (allWorkspaces.length === 1 || !!_jsCookie2.default.get(WORKPSPACE_SELECT_COOKIE_NAME)) {
            dispatch(saveTemplate());
        } else {
            dispatch(showWorkspaceSelectModal('SAVE_TEMPLATE'));
        }
    };
}

function cancelTemplateExport() {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            templateExportId = _getState5.exportData.templateExportId,
            workspaceId = _getState5.workspaceInfo.activeWorkspace;

        dispatch({ type: ActionTypes.API_CANCELLING_GRAPHIC });
        (0, _apis.cancelTemplateExportP)(templateExportId, dispatch).catch(function (err) {
            console.error(err);
        });
    };
}

function initSaveAndExportTemplate() {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            isLoggedIn = _getState6.account.isLoggedIn,
            activeWorkspace = _getState6.workspaceInfo.activeWorkspace,
            _getState6$ui = _getState6.ui,
            hasTemplatePlan = _getState6$ui.hasTemplatePlan,
            templateExportBalance = _getState6$ui.templateExportBalance,
            freeTemplateUsage = _getState6$ui.freeTemplateUsage;

        if (isLoggedIn) {
            dispatch({ type: ActionTypes.API_START_EXPORTING_GRAPHIC });
            if (hasTemplatePlan && templateExportBalance > 0 || freeTemplateUsage <= 0) {
                dispatch(saveAndExportTemplate());
            } else {
                console.error('Not allowed to download template');
            }
        } else if (!!window.openLoginForm) {
            window.openLoginForm();
        }
    };
}

function downloadTemplate() {
    return function (dispatch, getState) {
        var _getState7 = getState(),
            _getState7$userData$c = _getState7.userData.canProduceVideo,
            canProduceVideo = _getState7$userData$c === undefined ? false : _getState7$userData$c;

        if (canProduceVideo) {
            dispatch(checkWatermarkAndProceed('download'));
        } else {
            dispatch(openRequestRoleChangeModal('Download Video'));
        }
    };
}

function uploadLocalImageP(file) {
    return new Promise(function (resolve, reject) {
        var uploader = new _FileUploadManager2.default(file, 'IMAGE', '');

        uploader.onComplete(function (uploadId, _ref) {
            var type = _ref.type,
                data = _ref.data;

            var trackingData = {
                mediaType: type,
                mediaSource: 'personal',
                uploadId: uploadId,
                projectId: 'none'
            };
            (0, _TrackUtils.trackOnSmartlook)('Media Uploaded', trackingData);
            resolve(data);
        }).onError(function (uploadId, errorCode) {
            reject(new Error('Upload failed with ' + errorCode));
        }).doUpload();
    });
}

function waitUntilWorkspaceImageReady(imageData) {
    return new Promise(function (resolve, reject) {
        var processingTracker = new _ProcessingTracker2.default('IMAGE', imageData.id);
        processingTracker.onData(function (imageData) {
            if ((0, _ModelDataUtils.isImageReady)(imageData)) {
                resolve(imageData);

                processingTracker.stopTracking();
            } else {
                // Nothing
            }
        }).startTracking();
    });
}

function adjustTemplateTimesForExport(template, templateExportDuration) {
    var exitTime = template.time.exitdone - template.time.exitstart;
    var newExitDone = template.time.enterstart + templateExportDuration;
    var newExitStart = newExitDone - exitTime;
    template.time.exitstart = newExitStart;
    template.time.exitdone = newExitDone;
    if (template.values.hasOwnProperty('isAscendingTimer')) {
        template.time.enterdone = newExitStart;
    }
    return template;
}

function createProject(formatId) {
    return function (dispatch, getState) {
        var state = getState();
        var currentTemplateId = state.ui.currentTemplateId,
            _state$editor = state.editor,
            overlays = _state$editor.overlays,
            clips = _state$editor.reel.clips,
            templates = state.templates;

        var selectedTemplate = templates.find(function (t) {
            return t.id === currentTemplateId;
        });

        dispatch({ type: ActionTypes.API_USE_GRAPHIC_WORKING });

        var overlay = Object.values(overlays)[0];
        var defId = overlay.defId,
            space = overlay.space,
            time = overlay.time,
            values = overlay.values,
            _overlay$enterAnimati = overlay.enterAnimationOnly,
            enterAnimationOnly = _overlay$enterAnimati === undefined ? false : _overlay$enterAnimati,
            _overlay$variant = overlay.variant,
            variant = _overlay$variant === undefined ? {} : _overlay$variant;

        var def = getTemplateDefForId(defId);
        var imageprops = Object.keys(def.props).filter(function (p) {
            return def.props[p] === 'imageId';
        });

        var p = Promise.resolve();
        if (imageprops.length > 0) {
            p = Promise.all(imageprops.map(function (p) {
                var localImageFile = window.getLocalImageFile(values[p]);

                if (!!localImageFile) {
                    // custom file, needs to be uploaded
                    return Promise.resolve(localImageFile).then(uploadLocalImageP).then(waitUntilWorkspaceImageReady).then(function (imageData) {
                        var id = imageData.id;

                        values = _extends({}, values, _defineProperty({}, '' + p, id));
                        overlay.values = values;
                    });
                }
            }));
        }

        p.then(function () {
            //save the template
            var template = (0, _OverlayUtils.createTemplateFromOverlays)([overlay], {}, selectedTemplate.config.canvas);
            (0, _apis.saveTemplateP)(template, currentTemplateId, selectedTemplate.name).then(function (response) {
                if (!response || !response.success) {
                    throw new Error('Error in response when saving template');
                } else {
                    var newTemplateId = response.id;
                    (0, _TrackUtils.trackOnSmartlook)('Template used/saved', {
                        templateId: '' + newTemplateId,
                        templateName: '' + selectedTemplate.name
                    });
                }

                (0, _apis.createProjectWithTemplateP)(formatId, currentTemplateId, {
                    space: space,
                    time: time,
                    values: values,
                    enterAnimationOnly: enterAnimationOnly,
                    canvas: selectedTemplate.config.canvas,
                    variant: variant,
                    clips: clips
                }).then(function (response) {
                    if (!response || !response.success) {
                        throw new Error('Error in response when using the template');
                    }

                    var projectId = response.projectId,
                        workspaceId = response.workspaceId;

                    var trackingData = {
                        projectId: projectId,
                        workspaceId: workspaceId,
                        formatId: formatId,
                        Type: 'Original'
                    };
                    (0, _TrackUtils.trackOnSmartlook)('Project Created', trackingData);
                    dispatch({ type: ActionTypes.API_USE_GRAPHIC_PROJECT_READY, projectId: projectId });
                }).catch(function (err) {
                    console.error(err);
                }).finally(function () {
                    dispatch({ type: ActionTypes.API_USE_GRAPHIC_CLEAR });
                    dispatch({ type: ActionTypes.API_SAVED_GRAPHIC });
                });
            });
        });
    };
}

function clearCreatedProject() {
    return { type: ActionTypes.API_USE_GRAPHIC_PROJECT_CLEAR };
}

function fontLoaded(fontKey) {
    return { type: ActionTypes.EDITOR_FONT_LOADED, fontKey: fontKey };
}
function requiredFontsLoaded() {
    return { type: ActionTypes.EDITOR_REQUIRED_FONTS_LOADED };
}

function sessionUpdate(_ref2) {
    var isLoggedIn = _ref2.isLoggedIn,
        workspaces = _ref2.workspaces;

    return { type: ActionTypes.ACCOUNT_SESSION_UPDATE, isLoggedIn: isLoggedIn, workspaces: workspaces };
}

function changePlaceholderImage(file, imageUrl) {
    return function (dispatch, getState) {
        var imageId = _shortid2.default.generate();

        window.registerLocalImage(imageId, imageUrl, file);

        var _getState$editor4 = getState().editor,
            overlays = _getState$editor4.overlays,
            selected = _getState$editor4.selection.selected;

        var selectedOverlay = overlays[Object.keys(selected)[0]];

        var def = getTemplateDefForId(selectedOverlay.defId);

        var _def$meta$placeholder = def.meta.placeholders,
            placeholders = _def$meta$placeholder === undefined ? {} : _def$meta$placeholder;

        var prop = Object.keys(placeholders)[0];

        var newOverlay = (0, _deepmerge2.default)(selectedOverlay, {
            values: _defineProperty({}, prop, imageId)
        });

        dispatch(changeOverlay(newOverlay));
    };
}

function onCroppingStart() {
    return { type: ActionTypes.PH_BEGIN_CROP };
}

function onCroppingDone(cropData) {
    return { type: ActionTypes.PH_DONE_CROP, cropData: cropData };
}

function onCroppingCancel() {
    return { type: ActionTypes.PH_CANCEL_CROP };
}

function overlayHintTargetClicked() {
    return function (dispatch, getState) {
        dispatch(dismissOverlayHint());

        setTimeout(function () {
            dispatch(showPreviewHint());
            dispatch(showBackgroundHint());
        }, 5000);
    };
}

function overlayHintOutsideClicked() {
    return function (dispatch, getState) {
        dispatch(dismissOverlayHint());

        setTimeout(function () {
            dispatch(showPreviewHint());
            dispatch(showBackgroundHint());
        }, 0);
    };
}

function showPreviewHint() {
    return { type: ActionTypes.HINT_PREVIEW_SHOW };
}

function showBackgroundHint() {
    return { type: ActionTypes.HINT_BACKGROUND_SHOW };
}

function dismissOverlayHint() {
    return function (dispatch) {
        _jsCookie2.default.set(HINT_OVERLAY_COOKIE_NAME, true, { expires: 365 * 5 });
        dispatch({ type: ActionTypes.HINT_OVERLAY_DISMISS });
    };
}

function dismissPreviewHint() {
    return function (dispatch) {
        _jsCookie2.default.set(HINT_PREVIEW_COOKIE_NAME, true, { expires: 365 * 5 });
        dispatch({ type: ActionTypes.HINT_PREVIEW_DISMISS });
    };
}

function dismissBackgroundHint() {
    return function (dispatch) {
        _jsCookie2.default.set(HINT_BACKGROUND_COOKIE_NAME, true, { expires: 365 * 5 });
        dispatch({ type: ActionTypes.HINT_BACKGROUND_DISMISS });
    };
}

function showWorkspaceSelectModal(postWorkspaceChangeAction) {
    return function (dispatch) {
        dispatch({
            type: ActionTypes.SHOW_WORKSPACE_SELECT,
            postWorkspaceChangeAction: postWorkspaceChangeAction
        });
    };
}

function closeWorkspaceSelectModal() {
    return function (dispatch) {
        dispatch({ type: ActionTypes.CLOSE_WORKSPACE_SELECT });
    };
}

function updateWorkspaces(workspaces) {
    return { type: ActionTypes.UPDATE_WORKSPACES, workspaces: workspaces };
}

function changeWorkspace(workspaceId) {
    return function (dispatch, getState) {
        _jsCookie2.default.set(WORKPSPACE_SELECT_COOKIE_NAME, true, { expires: 1 });

        var _getState8 = getState(),
            activeWorkspace = _getState8.workspaceInfo.activeWorkspace;

        dispatch({ type: ActionTypes.CHANGE_WORKSPACE, workspaceId: workspaceId });

        if (activeWorkspace.workspaceId !== workspaceId) {
            return (0, _workspaceApi.switchWorkspaceP)(workspaceId).then(function () {
                return (0, _workspaceApi.getWorkspaceDataP)().then(function (workspaces) {
                    dispatch(updateWorkspaces(workspaces));
                    dispatch(postWorkspaceSwitchAction());
                });
            }).catch(function (err) {
                console.log('Could not switch workspace');
                console.error(err);
            });
        } else {
            dispatch(postWorkspaceSwitchAction());
        }
    };
}

function postWorkspaceSwitchAction() {
    return function (dispatch, getState) {
        var _getState9 = getState(),
            _getState9$ui = _getState9.ui,
            postWorkspaceChangeAction = _getState9$ui.postWorkspaceChangeAction,
            createdProjectId = _getState9$ui.createdProjectId;

        if (postWorkspaceChangeAction == 'USE_TEMPLATE') {
            if (!!createdProjectId) {
                window.open('/open/' + createdProjectId, '_blank');
            } else {
                dispatch(showFormatSelectModal());
                // dispatch(createProject())
            }
        } else if (postWorkspaceChangeAction == 'SAVE_TEMPLATE') {
            dispatch(saveTemplate());
        }
    };
}

function createCustomFormat(formatObj) {
    return function (dispatch, getState) {
        dispatch({ type: ActionTypes.FORMAT_CREATOR_PROCESSING });

        var workspaceId = getState().workspaceInfo.activeWorkspace.workspaceId;

        return (0, _apis.createCustomFormatP)(formatObj).then(function (res) {
            if (!res.success) {
                if (res.errorCode && res.errorCode == 'CUSTOM_FORMAT_LIMIT_REACHED') {
                    dispatch({ type: ActionTypes.FORMAT_LIMIT_REACHED });
                } else {
                    dispatch({ type: ActionTypes.FORMAT_CREATOR_FAIL });
                }
            } else {
                var customFormat = res.customFormat;

                var trackingData = {
                    workspaceId: workspaceId,
                    formatName: formatObj.name,
                    height: formatObj.height,
                    width: formatObj.width,
                    useCase: formatObj.useCase,
                    hasPadding: formatObj.hasPadding,
                    aspectRatio: (0, _GeneralUtils.getAspectRatio)(formatObj.width, formatObj.height),
                    sourceView: (0, _constants.getSourceView)()
                };

                (0, _TrackUtils.trackOn)('Custom Format added', trackingData, {
                    PostHog: true,
                    Smartlook: true
                });

                dispatch({ type: ActionTypes.FORMAT_CREATOR_SUCCESS, customFormat: customFormat });
            }
        }).catch(function (err) {
            dispatch({ type: ActionTypes.FORMAT_CREATOR_FAIL });
            console.log('Could not create custom format');
            console.error(err);
        });
    };
}

function closeCustomFormatModal() {
    return function (dispatch) {
        dispatch({ type: ActionTypes.FORMAT_CREATOR_CLOSE });
    };
}

function openCustomFormatModal() {
    return function (dispatch) {
        dispatch({ type: ActionTypes.FORMAT_CREATOR_OPEN });
    };
}

function updateStatus(status) {
    return function (dispatch, getState) {
        dispatch({ type: ActionTypes.UPDATE_TEMPLATE_EXPORT_STATUS, status: status });
    };
}

function updatePercent(percent) {
    return function (dispatch, getState) {
        if (percent == 100) {
            var exportId = getState().exportData.templateExportId;

            dispatch(fetchTemplateDownloadUrl(exportId));
            dispatch({ type: ActionTypes.UPDATE_LAST_EXPORT_ID, exportId: exportId });
            dispatch(getTemplateExportBalance());
            setTimeout(function () {
                return dispatch({ type: ActionTypes.API_EXPORTED_GRAPHIC });
            }, 2000);
        }
        dispatch({ type: ActionTypes.UPDATE_TEMPLATE_EXPORT_PERCENT, percent: percent });
    };
}

function updateExportId(exportId) {
    return { type: ActionTypes.UPDATE_TEMPLATE_EXPORT_ID, exportId: exportId };
}

function updateTemplateExportDuration(templateExportDuration) {
    return function (dispatch, getState) {
        dispatch({ type: ActionTypes.UPDATE_EXPORT_DURATION, templateExportDuration: templateExportDuration });
    };
}

function fetchTemplateDownloadUrl(exportId) {
    return function (dispatch, getState) {
        (0, _apis.getTemplateDownloadUrlP)(exportId, dispatch).then(function (downloadUrl) {
            // This will initiate the download
            window.location.assign(downloadUrl);
        }).catch(function (err) {
            console.error('Error getting template download url');
        }).finally(function () {});
    };
}

function getTemplateExportBalance() {
    return function (dispatch, getState) {
        (0, _apis.getTemplateExportBalanceP)().then(function (templateExportBalance) {
            dispatch({
                type: ActionTypes.UPDATE_TEMPLATE_EXPORT_BALANCE,
                templateExportBalance: templateExportBalance
            });
        }).catch(function (err) {
            console.error('Error getting template export balance');
        }).finally(function () {});
    };
}

},{"../common/api/workspaceApi":6,"../common/config/TemplateConfig":42,"../common/constants":61,"../common/utils/GeneralUtils":77,"../common/utils/ModelDataUtils":80,"../common/utils/ReelHelpers":85,"../common/utils/TrackUtils":90,"../common/utils/enums/PlaybackState":96,"../edit/utils/FileUploadManager":229,"../edit/utils/OverlayUtils":231,"../edit/utils/ProcessingTracker":232,"./ActionTypes":271,"./apis":273,"deepmerge":549,"js-cookie":675,"shortid":1163}],302:[function(require,module,exports){
'use strict';

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

// This adds TimelineMax into our global namespace.


var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _canvas5Polyfill = require('canvas-5-polyfill');

var _canvas5Polyfill2 = _interopRequireDefault(_canvas5Polyfill);

var _WaitMode = require('../common/utils/enums/WaitMode');

var _WaitMode2 = _interopRequireDefault(_WaitMode);

var _PlaybackState = require('../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _DefModel = require('../common/utils/renderer/DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _ReelHelpers = require('../common/utils/ReelHelpers');

var _FontManager = require('../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _TemplateConfig = require('../common/config/TemplateConfig');

var _TemplateConfig2 = _interopRequireDefault(_TemplateConfig);

var _AllTemplateDefs = require('../common/config/AllTemplateDefs');

var _AllTemplateDefs2 = _interopRequireDefault(_AllTemplateDefs);

var _DefaultAnimationDefs = require('../common/config/DefaultAnimationDefs');

var _DefaultAnimationDefs2 = _interopRequireDefault(_DefaultAnimationDefs);

var _userApi = require('../common/api/userApi');

var _TemplatePage = require('./components/TemplatePage.react');

var _TemplatePage2 = _interopRequireDefault(_TemplatePage);

var _reelControlMiddleware = require('./middlewares/reelControlMiddleware');

var _reelControlMiddleware2 = _interopRequireDefault(_reelControlMiddleware);

var _overlayDefMiddleware = require('./middlewares/overlayDefMiddleware');

var _overlayDefMiddleware2 = _interopRequireDefault(_overlayDefMiddleware);

var _playerControlMiddleware = require('./middlewares/playerControlMiddleware');

var _playerControlMiddleware2 = _interopRequireDefault(_playerControlMiddleware);

var _EditIOClient = require('../edit/utils/EditIOClient');

var _EditIOClient2 = _interopRequireDefault(_EditIOClient);

var _editorActions = require('./editorActions');

var editorActions = _interopRequireWildcard(_editorActions);

var _constants = require('./constants');

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _TrackUtils = require('../common/utils/TrackUtils');

var tracker = _interopRequireWildcard(_TrackUtils);

var _loginActions = require('../login/loginActions');

var loginActions = _interopRequireWildcard(_loginActions);

var _watermarkUtils = require('../common/utils/watermarkUtils');

var _AudioRegistry = require('../common/components/AudioRegistry');

var _AudioRegistry2 = _interopRequireDefault(_AudioRegistry);

var _reactContext = require('../edit/utils/reactContext');

var _TemplateExportIOClient = require('./TemplateExportIOClient');

var _TemplateExportIOClient2 = _interopRequireDefault(_TemplateExportIOClient);

var _GTMAnalyticsService = require('../services/GTMAnalyticsService');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

// Promises swallow all errors by default.
// This will print any such swallowed ones.
_bluebird2.default.onPossiblyUnhandledRejection(function (error) {
    console.log('Unhandled rejection in promise. Miss a .catch(handler) somewhere?');
    console.error(error);
});

var EMPTY_BACKGROUND_VIDEO = {
    id: 'empty-background',
    uploadStatus: 'TRANSCODED_READY',
    readyPercent: 100,
    dashUrl: window.getStaticBaseUrl() + '/videos/dark-gray/manifest.mpd',
    snapshotUrl: '',
    thumbStripUrl: '',
    si: '',
    width: 64,
    height: 36,
    duration: 20000,
    originalFileName: 'dark-gray.mp4',
    createdAt: new Date().toJSON()
};

var PREVIEW_DURATION = 6000;
var EMOJI_IMAGE_ID_PREFIX = 'emoji_';

window.HINT_OVERLAY_COOKIE_NAME = 'SJsz40rCz-ovh';
window.HINT_PREVIEW_COOKIE_NAME = 'SJsz40rCz-prh';
window.HINT_BACKGROUND_COOKIE_NAME = 'SJsz40rCz-bgh';
window.WORKPSPACE_SELECT_COOKIE_NAME = 'SJsz40rCz-wsm';

window.preInitialize = function (fontConfig) {
    _FontManager2.default.setup(fontConfig);
};

window.loadDefaultFont = function (done) {
    _FontManager2.default.loadDefaultFontP().then(function () {
        return done(null);
    }).catch(function (err) {
        return done(err);
    });

    return null;
};

window.renderApp = function (containerEl, allData, workspaces, accountData, _ref) {
    var images = _ref.images,
        bgVideos = _ref.bgVideos,
        emojiData = _ref.emojiData,
        defaultAudios = _ref.defaultAudios;
    var templatePlanData = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var lastExportId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var isActiveWorkspacePaid = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    (0, _GTMAnalyticsService.initializeDataLayer)();
    createTemplateRegistry();
    createAnimationRegistry();

    var appManager = {
        getTemplateDefForId: function getTemplateDefForId(defId) {
            return templateRegistry[defId];
        },
        getAnimationDefForId: function getAnimationDefForId(animDefId) {
            return animationRegistry[animDefId];
        },
        getImageUrlForId: function getImageUrlForId(imageId, width, height) {
            var forceFullSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var isEmoji = imageId.startsWith(EMOJI_IMAGE_ID_PREFIX);
            var returnObj = { imgUrl: '', deleted: false };

            if (!!localImageRegistry[imageId]) {
                returnObj.imgUrl = localImageRegistry[imageId].imageUrl; // data url
                return returnObj;
            }

            if (isEmoji) {
                var unifiedCode = imageId.substring(EMOJI_IMAGE_ID_PREFIX.length).toLowerCase();
                var emoji = emojiData[unifiedCode];
                if (!!emoji) {
                    returnObj.imgUrl = emoji.emoji_url;
                }
            } else if (!!imageRegistry[imageId]) {
                var _imageRegistry$imageI = imageRegistry[imageId],
                    thumbUrl = _imageRegistry$imageI.thumbUrl,
                    fullPngUrl = _imageRegistry$imageI.fullPngUrl,
                    snapshotUrl = _imageRegistry$imageI.snapshotUrl,
                    _imageRegistry$imageI2 = _imageRegistry$imageI.deleted,
                    deleted = _imageRegistry$imageI2 === undefined ? false : _imageRegistry$imageI2;

                returnObj.deleted = deleted;
                returnObj.imgUrl = deleted ? snapshotUrl : width > 240 || height > 240 || forceFullSize ? fullPngUrl : thumbUrl;
            }
            return returnObj;
        },
        getLocalImageFile: function getLocalImageFile(imageId) {
            if (!!localImageRegistry[imageId]) {
                return localImageRegistry[imageId].file;
            }
            return null;
        }
    };

    window.getTemplateDefForId = appManager.getTemplateDefForId;
    window.getAnimationDefForId = appManager.getAnimationDefForId;
    window.getImageUrlForId = appManager.getImageUrlForId;

    window.getLocalImageFile = appManager.getLocalImageFile;

    window.animationOptions = function (kind, overlays) {
        if (kind !== 'enter' && kind !== 'exit') {
            throw new Error('Unknown kind');
        }

        return Object.keys(animationRegistry).map(function (animDefId) {
            return animationRegistry[animDefId];
        }).filter(function (animDef) {
            return animDef.type === kind;
        }).filter(function (animDef) {
            return !animDef.flag;
        }).map(function (_ref2) {
            var id = _ref2.id,
                displayName = _ref2.displayName;
            return { id: id, displayName: displayName };
        });
    };
    window.getEmojiIdForImageId = function (emojiUnifiedCode) {
        var unifiedCode = emojiUnifiedCode.toLowerCase();
        var emoji = emojiData[unifiedCode];
        if (!!emoji) {
            return emoji.id;
        }
        return null;
    };

    images.forEach(registerImage);

    images.map(_AllTemplateDefs.createBitmapTemplateDefFromWorkspaceImage).forEach(function (def) {
        return templateRegistry[def.id] = def;
    });

    (0, _TemplateConfig.loadTemplates)();

    var tags = allData.tags,
        templates = allData.templates,
        currentTemplateId = allData.currentTemplateId;

    var loggerMiddleware = (0, _reduxLogger.createLogger)();

    var initialState = createInitialState(workspaces, accountData, templates, tags, currentTemplateId, bgVideos, defaultAudios, templatePlanData, lastExportId, isActiveWorkspacePaid);

    var middlewareEnhancer = (0, _redux.applyMiddleware)(_reduxThunk2.default, _playerControlMiddleware2.default, _reelControlMiddleware2.default, _overlayDefMiddleware2.default
    // loggerMiddleware
    );

    window.store = (0, _redux.createStore)(_reducers2.default, initialState, middlewareEnhancer);
    (0, _GTMAnalyticsService.pushUserDataToDataLayer)(accountData.userData);

    var isLoggedIn = accountData.isLoggedIn;
    var hasTemplatePlan = templatePlanData.hasTemplatePlan;
    _reactDom2.default.render(_react2.default.createElement(_reactRedux.Provider, { store: store }, _react2.default.createElement(_reactContext.AppManagerContext.Provider, { value: appManager }, _react2.default.createElement(_reactDnd.DndProvider, { backend: _reactDndHtml5Backend.HTML5Backend, debugMode: true }, _react2.default.createElement(_TemplatePage2.default, null)))), containerEl);

    // detect all fonts loading

    var _store$getState$edito = store.getState().editor,
        overlays = _store$getState$edito.overlays,
        canvas = _store$getState$edito.reel.canvas;

    var overlayId = Object.keys(overlays)[0];
    var overlay = overlays[overlayId];

    var defModel = new _DefModel2.default(overlay.defId);

    var textLayers = defModel.parsedDef.layers.filter(function (l) {
        return l.type === 'text';
    });

    var fontKeysToLoad = [];

    if (textLayers.length > 0) {
        defModel.update(overlay.space, overlay.time, overlay.values, canvas);

        fontKeysToLoad = defModel.getUsedFontKeys().filter(function (fk) {
            return _FontManager2.default.isLoaded(fk);
        });
        fontKeysToLoad.forEach(function (fk) {
            return _FontManager2.default.loadFontP(fk);
        });
    }

    var checkAndFireRequireFontsLoaded = function checkAndFireRequireFontsLoaded() {
        if (fontKeysToLoad.length === 0) {
            store.dispatch(editorActions.requiredFontsLoaded());
        }
    };

    checkAndFireRequireFontsLoaded();

    window.addEventListener('fontLoaded', function (e) {
        var fontKey = e.detail;
        store.dispatch(editorActions.fontLoaded(fontKey));

        fontKeysToLoad = fontKeysToLoad.filter(function (fk) {
            return fontKey === fk;
        });
        checkAndFireRequireFontsLoaded();
    });

    _EditIOClient2.default.start();
};

window.getAccountData = function () {
    return store.getState().account;
};

window.updateAccountData = function (accountData) {
    store.dispatch(editorActions.sessionUpdate(accountData));
};

window.getAccountDetailsP = _userApi.getAccountDetailsP;

window.doPostLogin = function (postLoginAction) {
    var useTemplateRequested = store.getState().ui.useTemplateRequested;

    if (postLoginAction === 'USE_TEMPLATE') {
        window.store.dispatch(editorActions.showFormatSelectModal());
    }
};

var templateRegistry = {},
    animationRegistry = {},
    imageRegistry = {},
    localImageRegistry = {};

function createTemplateRegistry() {
    _AllTemplateDefs2.default.forEach(function (def) {
        templateRegistry[def.id] = def;
    });

    templateRegistry[_watermarkUtils.WATERMARK_OVERLAY_DEF.id] = _watermarkUtils.WATERMARK_OVERLAY_DEF;
}
function createAnimationRegistry() {
    _DefaultAnimationDefs2.default.forEach(function (animDef) {
        animationRegistry[animDef.id] = animDef;
    });
}
function registerBitmapDef(def) {
    templateRegistry[def.id] = def;
}
window.registerImage = function (image) {
    imageRegistry[image.id] = image;
};
window.registerLocalImage = function (imageId, imageUrl, file) {
    localImageRegistry[imageId] = {
        imageUrl: imageUrl,
        file: file
    };
};

window.logoutUser = function () {
    store.dispatch(loginActions.logout());
};

window.initializeTemplateExportIOClient = function (exportId) {
    store.dispatch(editorActions.updateExportId(exportId));
    var exportIO = new _TemplateExportIOClient2.default(exportId).addTemplateExportUpdateCallback(function (exportData) {
        store.dispatch(editorActions.updateStatus(exportData.exportStatus));
        store.dispatch(editorActions.updatePercent(exportData.readyPercent));
    }).start();
};

var createInitialState = function createInitialState(workspaces, accountData, templates, tags, currentTemplateId, bgVideos, defaultAudios) {
    var templatePlanData = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
    var lastExportId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    var isActiveWorkspacePaid = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;

    var currentTemplate = templates.find(function (t) {
        return t.id === currentTemplateId;
    });

    // const bgClip = {
    //     clipId : "BvEAA3aW",
    //     clipType : "video",
    //     clipVideoId: "bg-video-1",
    //     clipVideo : BACKGROUND_VIDEOS[0],
    //     clipStart: 0,
    //     clipVolume : 1,
    //     musicVolume : 1,
    //     clipDuration: PREVIEW_DURATION,
    //     speed:1,
    // }

    var currentClip = {
        clipId: '' + _shortid2.default.generate(),
        clipType: 'video',
        clipVideoId: bgVideos[0].id,
        clipVideo: bgVideos[0],
        clipStart: 0,
        clipVolume: 1,
        musicVolume: 1,
        clipDuration: PREVIEW_DURATION,
        speed: 1,
        time: {
            enterStart: 0,
            enterDone: 0,
            exitStart: PREVIEW_DURATION,
            exitDone: PREVIEW_DURATION
        },
        transitions: {}
    };

    var reel = {
        clips: [],
        canvas: {
            width: currentTemplate.config.canvas.width,
            height: currentTemplate.config.canvas.height
        },
        volume: 1,
        volumeMode: 'project',
        audioClip: null,
        frameType: 'BEST-FIT',
        frameColor: '#000000'
    };

    currentClip = _extends({}, currentClip, {
        clipBox: (0, _ReelHelpers.calcDefaultClipBox)(currentClip, reel.frameType, reel.canvas)
    });

    reel.clips.push(currentClip);

    reel.origCanvas = reel.canvas;

    var time = currentTemplate.config.time;

    var enterTime = time.enterdone - time.enterstart;
    var exitTime = time.exitdone - time.exitstart;

    var newEnterstart = 0,
        newEnterdone = enterTime,
        newExitstart = PREVIEW_DURATION - exitTime,
        newExitdone = PREVIEW_DURATION;

    if (currentTemplate.config.enterAnimationOnly) {
        newEnterdone = PREVIEW_DURATION;
        newExitstart = newExitdone = newEnterdone;
    }

    var ffps = Object.keys(currentTemplate.config.values).filter(function (prop) {
        return prop.toLowerCase().includes('fontfamily');
    });
    var variant = {};
    if (ffps.length > 0) {
        ffps.forEach(function (ffp) {
            var selectedFontFamily = currentTemplate.config.values[ffp];
            variant[ffp] = _FontManager2.default.getVariantObject(selectedFontFamily);
        });
    }

    var overlay = {
        id: 'overlay-1',
        defId: currentTemplate.defId,
        space: currentTemplate.config.space,
        time: _extends({}, time, {
            enterstart: newEnterstart,
            enterdone: newEnterdone,
            exitstart: newExitstart,
            exitdone: newExitdone
        }),
        values: currentTemplate.config.values,
        enterAnimationOnly: !!currentTemplate.config.enterAnimationOnly,
        variant: variant
    };

    var placeholderData = {
        isCropping: false
    };

    var activeWorkspace = workspaces.find(function (w) {
        return w.active;
    });

    _AudioRegistry2.default.registerAudios(defaultAudios);

    return {
        templates: templates,
        tags: tags,
        editor: {
            selected_background: bgVideos[0].id,
            backgrounds: bgVideos,
            empty_background: EMPTY_BACKGROUND_VIDEO,
            player: {
                waitMode: _WaitMode2.default.LOADING,
                playbackState: _PlaybackState2.default.PAUSED,
                time: 0,
                duration: reel.clips.reduce(function (res, clip) {
                    var clipDuration = clip.clipDuration,
                        _clip$speed = clip.speed,
                        speed = _clip$speed === undefined ? 1 : _clip$speed;

                    return res + clipDuration / speed;
                }, 0),
                volume: 1,
                dragging: false,
                dragSeekTime: 0,
                dragWasPlayingBefore: false
            },
            overlays: _defineProperty({}, overlay.id, overlay),
            reel: reel,
            overlaymeta: {
                animgroups: []
            },
            selection: {
                selected: {},
                selecting: {},
                selectingRect: null
            },
            placeholderData: placeholderData,
            initialFontsLoaded: false
        },
        workspaceInfo: {
            allWorkspaces: workspaces,
            activeWorkspace: activeWorkspace
        },
        ui: {
            currentTemplateId: currentTemplateId,
            createdProjectId: '',
            creatingProject: false,
            loadingBackground: false,
            hints: {
                overlayHint: {
                    shouldShow: !_jsCookie2.default.get(HINT_OVERLAY_COOKIE_NAME),
                    show: true
                },
                previewHint: {
                    shouldShow: !_jsCookie2.default.get(HINT_PREVIEW_COOKIE_NAME),
                    show: false
                },
                backgroundHint: {
                    shouldShow: !_jsCookie2.default.get(HINT_BACKGROUND_COOKIE_NAME),
                    show: false
                }
            },
            saveUIState: _constants.SaveUIState.SAVE,
            saveAndExportUIState: _constants.SaveAndExportUIState.EXPORT,
            showWorkspaceSelectModal: false,
            postWorkspaceChangeAction: '',
            showFormatSelectModal: false,
            customFormatUIState: _constants.CustomFormatUIState.CLOSED,
            // Template defs have different times but for this preview page
            // we set enterStart to 0 and adjust other times accordingly. But
            // we do not update this on the currentTemplate object so we take
            // it from the local variable.
            templateExportDuration: newExitdone,
            hasTemplatePlan: !!templatePlanData.hasTemplatePlan || false,
            freeTemplateUsage: templatePlanData.freeTemplateUsage || 0,
            templateExportBalance: templatePlanData.templateExportBalance || 0,
            lastExportId: lastExportId,
            downloadError: false,
            isActiveWorkspacePaid: isActiveWorkspacePaid
        },
        exportData: {
            templateExportPercent: 0,
            templateExportStatus: null,
            templateExportId: null
        },
        account: accountData
    };
};

window.tracker = tracker;
window.sourceView = 'text-template';

},{"../common/api/userApi":5,"../common/components/AudioRegistry":7,"../common/config/AllTemplateDefs":29,"../common/config/DefaultAnimationDefs":40,"../common/config/TemplateConfig":42,"../common/utils/FontManager":76,"../common/utils/ReelHelpers":85,"../common/utils/TrackUtils":90,"../common/utils/enums/PlaybackState":96,"../common/utils/enums/WaitMode":100,"../common/utils/renderer/DefModel":119,"../common/utils/watermarkUtils":130,"../edit/utils/EditIOClient":228,"../edit/utils/reactContext":237,"../login/loginActions":262,"../services/GTMAnalyticsService":270,"./TemplateExportIOClient":272,"./components/TemplatePage.react":281,"./constants":284,"./editorActions":301,"./middlewares/overlayDefMiddleware":303,"./middlewares/playerControlMiddleware":304,"./middlewares/reelControlMiddleware":305,"./reducers":306,"bluebird":389,"canvas-5-polyfill":409,"gsap":640,"js-cookie":675,"react":1107,"react-dnd":1001,"react-dnd-html5-backend":968,"react-dom":1016,"react-redux":1079,"redux":1131,"redux-logger":1129,"redux-thunk":1130,"shortid":1163}],303:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _ActionTypes = require('../ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _editorActions = require('../editorActions');

var _DefModel = require('../../common/utils/renderer/DefModel');

var _DefModel2 = _interopRequireDefault(_DefModel);

var _FontManager = require('../../common/utils/FontManager');

var _FontManager2 = _interopRequireDefault(_FontManager);

var _overlayActions = require('../../edit/actions/overlayActions');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var overlayDefModels = {};

var initialized = false;

var overlayDefMiddleware = function overlayDefMiddleware(_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;

    return function (next) {
        return function (action) {

            var newFontLoaded = action.type === ActionTypes.EDITOR_FONT_LOADED;
            var newFontKey = newFontLoaded ? action.fontKey : null;

            var overlaysBefore = getState().editor.overlays;

            var result = next(action);

            var _getState$editor = getState().editor,
                overlaysAfter = _getState$editor.overlays,
                canvas = _getState$editor.reel.canvas;

            var overlayDefsToAdd = {};
            var overlayDefsToDelete = {};

            if (!initialized) {
                Object.keys(overlaysAfter).forEach(function (oid) {
                    var def = getTemplateDefForId(overlaysAfter[oid].defId);
                    if (!!def.meta.autoHeight) {
                        overlayDefsToAdd[oid] = new _DefModel2.default(def.id);
                    }
                });
                initialized = true;
            } else {
                Object.keys(overlaysBefore).forEach(function (oid) {
                    if (!(oid in overlaysAfter)) {
                        overlayDefsToDelete[oid] = true;
                    }
                });
                Object.keys(overlaysAfter).forEach(function (oid) {
                    if (!(oid in overlaysBefore)) {
                        var def = getTemplateDefForId(overlaysAfter[oid].defId);
                        if (!!def.meta.autoHeight) {
                            overlayDefsToAdd[oid] = new _DefModel2.default(overlaysAfter[oid].defId);
                        }
                    }
                });
            }

            Object.keys(overlayDefsToDelete).forEach(function (oid) {
                delete overlayDefModels[oid];
            });

            Object.keys(overlayDefsToAdd).forEach(function (oid) {
                overlayDefModels[oid] = overlayDefsToAdd[oid];
            });

            Object.keys(overlayDefModels).forEach(function (oid) {
                var defModel = overlayDefModels[oid];
                var overlay = overlaysAfter[oid];
                var space = overlay.space,
                    time = overlay.time,
                    values = overlay.values;

                var forceUpdate = newFontLoaded && defModel.getUsedFontKeys().find(function (fk) {
                    return fk === newFontKey;
                });

                overlayDefModels[oid].update(overlay.space, overlay.time, overlay.values, canvas, null, forceUpdate);

                // Check if values match
                var updatedSpace = overlayDefModels[oid].space;

                if (updatedSpace.height !== space.height) {
                    var updatedOverlay = (0, _deepmerge2.default)(overlay, {
                        space: updatedSpace
                    });
                    dispatch((0, _editorActions.changeOverlay)(updatedOverlay));
                }

                // defModel.getUsedFontKeys().forEach(fontKey => {
                //     FontManager.loadFontP(fontKey)
                //     return null
                // })
            });

            // The below optimization is not working on template page and crashing the page. Need to investigate that.
            // let updatedOverlaysList = []
            // for (let oid of Object.keys(overlayDefModels)) {
            //     const defModel = overlayDefModels[oid]
            //     const overlay = overlaysAfter[oid]
            //     const { space, time, values } = overlay

            //     const forceUpdate = newFontLoaded && defModel.getUsedFontKeys().find(fk => fk === newFontKey)

            //     overlayDefModels[oid].update(overlay.space, overlay.time, overlay.values, canvas, null, forceUpdate)

            //     // Check if values match
            //     const { space : updatedSpace } = overlayDefModels[oid]

            //     if (updatedSpace.height !== space.height) {
            //         const updatedOverlay = deepmerge(overlay, {
            //             space : updatedSpace
            //         })

            //         updatedOverlaysList.push(updatedOverlay)
            //     }
            // }
            // if (updatedOverlaysList.length > 0) {
            //     dispatch(changeMultipleOverlays(updatedOverlaysList))
            // }

            return result;
        };
    };
};

exports.default = overlayDefMiddleware;

},{"../../common/utils/FontManager":76,"../../common/utils/renderer/DefModel":119,"../../edit/actions/overlayActions":165,"../ActionTypes":271,"../editorActions":301,"deepmerge":549}],304:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PlaybackState = require('../../common/utils/enums/PlaybackState');

var _PlaybackState2 = _interopRequireDefault(_PlaybackState);

var _ActionTypes = require('../ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _ControlCommandStream = require('../../edit/utils/ControlCommandStream');

var _ControlCommandStream2 = _interopRequireDefault(_ControlCommandStream);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var playerControlMiddleware = function playerControlMiddleware(_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;

    return function (next) {
        return function (action) {

            // Should forward these actions to the player instead
            // of forwarding to the next middleware
            if (action.type == ActionTypes.EDITOR_VIDEO_PLAYER_PLAY) {
                _ControlCommandStream2.default.fireCommand('VIDEO_PLAY');
            } else if (action.type == ActionTypes.EDITOR_VIDEO_PLAYER_PAUSE) {
                _ControlCommandStream2.default.fireCommand('VIDEO_PAUSE');
            } else if (action.type == ActionTypes.EDITOR_VIDEO_PLAYER_SEEK) {
                _ControlCommandStream2.default.fireCommand('VIDEO_SEEK', { time: action.time });
            } else if (action.type == ActionTypes.EDITOR_VIDEO_PLAYER_SET_VOLUME) {
                _ControlCommandStream2.default.fireCommand('VIDEO_SET_VOLUME', { volume: action.volume });
            } else {
                return next(action);
            }
        };
    };
};

exports.default = playerControlMiddleware;

},{"../../common/utils/enums/PlaybackState":96,"../../edit/utils/ControlCommandStream":227,"../ActionTypes":271}],305:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ActionTypes = require('../ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _ControlCommandStream = require('../../edit/utils/ControlCommandStream');

var _ControlCommandStream2 = _interopRequireDefault(_ControlCommandStream);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

var reelControlMiddleware = function reelControlMiddleware(_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;

    return function (next) {
        return function (action) {

            var nextCalled = false;

            // Should forward these actions to the player instead
            // of forwarding to the next middleware
            if (action.type === ActionTypes.EDITOR_REEL_ADD_CLIP) {
                var clip = action.clip,
                    insertTime = action.insertTime;

                _ControlCommandStream2.default.fireCommand('REEL_ADD_CLIP', { clip: clip, insertTime: insertTime });
            } else if (action.type === ActionTypes.EDITOR_REEL_DELETE_CLIP) {
                var _clip = action.clip;

                _ControlCommandStream2.default.fireCommand('REEL_REMOVE_CLIP', { clip: _clip });
            }

            if (!nextCalled) {
                return next(action);
            }
        };
    };
};

exports.default = reelControlMiddleware;

},{"../../edit/utils/ControlCommandStream":227,"../ActionTypes":271}],306:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _redux = require('redux');

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _GeneralUtils = require('../common/utils/GeneralUtils');

var _ActionTypes = require('./ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _constants = require('./constants');

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var tags = function tags() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        default:
            {
                return state;
            }
    }
};

var templates = function templates() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        default:
            {
                return state;
            }
    }
};

var workspaceInfo = function workspaceInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.CHANGE_WORKSPACE:
            {
                var workspaceId = action.workspaceId;

                var allWorkspaces = state.allWorkspaces.map(function (w) {
                    if (workspaceId === w.workspaceId) {
                        w.active = true;
                        return w;
                    }
                    w.active = false;
                    return w;
                });

                var activeWorkspace = allWorkspaces.find(function (w) {
                    return !!w.active;
                });

                return {
                    allWorkspaces: allWorkspaces,
                    activeWorkspace: activeWorkspace
                };
            }
        case ActionTypes.UPDATE_WORKSPACES:
        case ActionTypes.ACCOUNT_SESSION_UPDATE:
            {
                var workspaces = action.workspaces;

                return {
                    allWorkspaces: workspaces,
                    activeWorkspace: workspaces.find(function (w) {
                        return !!w.active;
                    })
                };
            }
        case ActionTypes.FORMAT_CREATOR_SUCCESS:
            {
                var customFormat = action.customFormat;

                var customFormats = state.activeWorkspace ? Object.assign([], state.activeWorkspace.customFormats) : [];

                customFormats.push(customFormat);
                var _workspaces = state.allWorkspaces;
                _workspaces.map(function (workspace) {
                    if (!!workspace.active) {
                        workspace.customFormats = customFormats;
                    }
                });
                return _extends({}, state, {
                    allWorkspaces: _workspaces,
                    activeWorkspace: _extends({}, state.activeWorkspace, {
                        customFormats: customFormats
                    })
                });
            }
        default:
            {
                return state;
            }
    }
};

var exportData = function exportData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.UPDATE_TEMPLATE_EXPORT_PERCENT:
            {
                return _extends({}, state, { templateExportPercent: action.percent });
            }
        case ActionTypes.UPDATE_TEMPLATE_EXPORT_STATUS:
            {
                return _extends({}, state, { templateExportStatus: action.status });
            }
        case ActionTypes.UPDATE_TEMPLATE_EXPORT_ID:
            {
                return _extends({}, state, { templateExportId: action.exportId });
            }
        default:
            {
                return state;
            }
    }
};

var ui = function ui() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.API_USE_GRAPHIC_WORKING:
            {
                return _extends({}, state, { creatingProject: true });
            }
        case ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_WAIT_MODE:
            {
                var loadingBackground = false;
                if (action.waitMode !== 'NONE') {
                    loadingBackground = true;
                }
                return _extends({}, state, { loadingBackground: loadingBackground });
            }
        case ActionTypes.API_USE_GRAPHIC_PROJECT_READY:
            {
                return _extends({}, state, { createdProjectId: action.projectId });
            }
        case ActionTypes.API_USE_GRAPHIC_PROJECT_CLEAR:
            {
                return _extends({}, state, { createdProjectId: '' });
            }
        case ActionTypes.API_USE_GRAPHIC_CLEAR:
            {
                return _extends({}, state, { creatingProject: false });
            }
        case ActionTypes.API_SAVING_GRAPHIC:
            {
                return _extends({}, state, { saveUIState: _constants.SaveUIState.SAVING });
            }
        case ActionTypes.API_EXPORTING_GRAPHIC:
            {
                return _extends({}, state, { saveAndExportUIState: _constants.SaveAndExportUIState.EXPORTING });
            }
        case ActionTypes.API_RESET_GRAPHIC_EXPORT:
            {
                return _extends({}, state, { saveAndExportUIState: _constants.SaveAndExportUIState.EXPORT });
            }
        case ActionTypes.API_START_EXPORTING_GRAPHIC:
            {
                return _extends({}, state, { saveAndExportUIState: _constants.SaveAndExportUIState.START_EXPORT });
            }
        case ActionTypes.API_SAVED_GRAPHIC:
            {
                return _extends({}, state, { saveUIState: _constants.SaveUIState.SAVED });
            }
        case ActionTypes.API_EXPORTED_GRAPHIC:
            {
                return _extends({}, state, { saveAndExportUIState: _constants.SaveAndExportUIState.EXPORTED });
            }
        // TODO Maybe this is not needed and we can reuse the
        // above API_RESET_GRAPHIC_EXPORT action for this
        case ActionTypes.API_CANCELLED_GRAPHIC:
            {
                return _extends({}, state, { saveAndExportUIState: _constants.SaveAndExportUIState.EXPORT });
            }
        case ActionTypes.API_CANCELLING_GRAPHIC:
            {
                return _extends({}, state, { saveAndExportUIState: _constants.SaveAndExportUIState.EXPORT_CANCELLING });
            }
        case ActionTypes.DOWNLOAD_TEMPLATE_ERROR:
            {
                return _extends({}, state, { downloadError: action.errorState });
            }
        case ActionTypes.EDITOR_OVERLAY_CHANGE:
        case ActionTypes.EDITOR_OVERLAY_MOVE:
        case ActionTypes.EDITOR_OVERLAY_MOVE_MULTIPLE:
        case ActionTypes.EDITOR_OVERLAY_RESIZE:
        case ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM:
        case ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION:
        case ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION_MANUAL_MODE:
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_TIME_FINISH:
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM:
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION:
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION_MANUAL_MODE:
            {
                return _extends({}, state, { saveUIState: _constants.SaveUIState.SAVE });
            }
        case ActionTypes.HINT_OVERLAY_DISMISS:
            {
                return _extends({}, state, {
                    hints: _extends({}, state.hints, {
                        overlayHint: _extends({}, state.hints.overlayHint, {
                            shouldShow: false,
                            show: false
                        })
                    })
                });
            }
        case ActionTypes.HINT_PREVIEW_DISMISS:
            {
                return _extends({}, state, {
                    hints: _extends({}, state.hints, {
                        previewHint: _extends({}, state.hints.previewHint, {
                            shouldShow: false,
                            show: false
                        })
                    })
                });
            }
        case ActionTypes.HINT_BACKGROUND_DISMISS:
            {
                return _extends({}, state, {
                    hints: _extends({}, state.hints, {
                        backgroundHint: _extends({}, state.hints.backgroundHint, {
                            shouldShow: false,
                            show: false
                        })
                    })
                });
            }
        case ActionTypes.HINT_PREVIEW_SHOW:
            {
                return _extends({}, state, {
                    hints: _extends({}, state.hints, {
                        previewHint: _extends({}, state.hints.previewHint, {
                            show: true
                        })
                    })
                });
            }
        case ActionTypes.HINT_BACKGROUND_SHOW:
            {
                return _extends({}, state, {
                    hints: _extends({}, state.hints, {
                        backgroundHint: _extends({}, state.hints.backgroundHint, {
                            show: true
                        })
                    })
                });
            }
        case ActionTypes.SHOW_WORKSPACE_SELECT:
            {
                return _extends({}, state, {
                    showWorkspaceSelectModal: true,
                    postWorkspaceChangeAction: action.postWorkspaceChangeAction
                });
            }
        case ActionTypes.CLOSE_WORKSPACE_SELECT:
            {
                return _extends({}, state, {
                    showWorkspaceSelectModal: false
                });
            }
        case ActionTypes.SHOW_FORMAT_SELECT:
            {
                return _extends({}, state, {
                    showFormatSelectModal: true
                });
            }
        case ActionTypes.CLOSE_FORMAT_SELECT:
            {
                return _extends({}, state, {
                    showFormatSelectModal: false
                });
            }
        case ActionTypes.FORMAT_CREATOR_SUCCESS:
            {
                return _extends({}, state, {
                    customFormatUIState: _constants.CustomFormatUIState.CREATION_SUCCESS
                });
            }
        case ActionTypes.FORMAT_CREATOR_CLOSE:
            {
                return _extends({}, state, {
                    customFormatUIState: _constants.CustomFormatUIState.CLOSED
                });
            }
        case ActionTypes.FORMAT_CREATOR_OPEN:
            {
                return _extends({}, state, {
                    customFormatUIState: _constants.CustomFormatUIState.OPEN
                });
            }
        case ActionTypes.FORMAT_CREATOR_PROCESSING:
            {
                return _extends({}, state, {
                    customFormatUIState: _constants.CustomFormatUIState.CREATING
                });
            }
        case ActionTypes.FORMAT_CREATOR_FAIL:
            {
                return _extends({}, state, {
                    customFormatUIState: _constants.CustomFormatUIState.CREATION_FAILED
                });
            }
        case ActionTypes.FORMAT_LIMIT_REACHED:
            {
                return _extends({}, state, {
                    customFormatUIState: _constants.CustomFormatUIState.CF_LIMIT_REACHED
                });
            }
        case ActionTypes.UPDATE_EXPORT_DURATION:
            {
                return _extends({}, state, {
                    templateExportDuration: action.templateExportDuration
                });
            }
        case ActionTypes.UPDATE_TEMPLATE_EXPORT_BALANCE:
            {
                return _extends({}, state, {
                    templateExportBalance: action.templateExportBalance,
                    freeTemplateUsage: 1 // This brings the logic to FE but
                    // it's ok for now. If we scale this feature then we'll
                    // fix this and move the logic to BE and only set it when
                    // it's actually used and not when the user is downloading
                    // from their purchased quota.
                });
            }
        case ActionTypes.UPDATE_LAST_EXPORT_ID:
            {
                return _extends({}, state, {
                    lastExportId: action.exportId
                });
            }
        default:
            {
                return state;
            }
    }
};

var account = function account() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.ACCOUNT_SESSION_UPDATE:
            {
                var isLoggedIn = action.isLoggedIn;

                return _extends({}, state, { isLoggedIn: isLoggedIn });
            }
        default:
            {
                return state;
            }
    }
};

var editor = function editor() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.EDITOR_OVERLAY_SELECT:
            {
                var overlayid = Object.keys(state.overlays)[0];

                return _extends({}, state, {
                    selection: _extends({}, state.selection, {
                        selected: _defineProperty({}, overlayid, true),
                        focus: {
                            uid: null,
                            start: -1,
                            end: -1
                        }
                    })
                });
            }
        case ActionTypes.EDITOR_OVERLAY_TEXT_SET_FOCUS:
            {
                var uid = action.uid,
                    start = action.start,
                    end = action.end,
                    length = action.length;

                return _extends({}, state, {
                    selection: _extends({}, state.selection, {
                        focus: {
                            uid: uid,
                            start: start,
                            end: end,
                            length: length
                        }
                    })
                });
            }
        case ActionTypes.EDITOR_OVERLAY_CHANGE:
            {
                var overlay = action.overlay;

                var newoverlays = _extends({}, state.overlays, _defineProperty({}, overlay.id, overlay));

                return _extends({}, state, { overlays: newoverlays });
            }
        case ActionTypes.EDITOR_OVERLAY_SELECT_CLEAR:
            {
                return _extends({}, state, {
                    selection: _extends({}, state.selection, {
                        selected: {},
                        selecting: {},
                        selectingRect: null
                    })
                });
            }
        case ActionTypes.EDITOR_OVERLAY_MOVE:
            {
                var movedOverlay = action.movedOverlay;

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _defineProperty({}, movedOverlay.id, movedOverlay))
                });
            }
        case ActionTypes.EDITOR_OVERLAY_MOVE_MULTIPLE:
            {
                var movedOverlays = action.movedOverlays;

                var movedOverlayMap = {};
                movedOverlays.forEach(function (o) {
                    movedOverlayMap[o.id] = o;
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, movedOverlayMap)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_RESIZE:
            {
                var resizedOverlays = action.resizedOverlays;

                var resizedOverlayMap = {};
                resizedOverlays.forEach(function (o) {
                    resizedOverlayMap[o.id] = o;
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, resizedOverlayMap)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM:
            {
                var ids = action.ids,
                    animDefId = action.animDefId;

                var updatedOverlays = {};
                Object.keys(ids).forEach(function (oid) {
                    updatedOverlays[oid] = (0, _GeneralUtils.updateIn)(state.overlays[oid], ['time', 'enterAnimDefId'], animDefId);
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, updatedOverlays)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION:
            {
                var _ids = action.ids,
                    duration = action.duration;

                var _updatedOverlays = {};
                Object.keys(_ids).forEach(function (oid) {
                    var newenterdone = state.overlays[oid].time.enterstart + duration;
                    _updatedOverlays[oid] = (0, _GeneralUtils.updateIn)(state.overlays[oid], ['time', 'enterdone'], newenterdone);
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _updatedOverlays)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_IN_ANIM_DURATION_MANUAL_MODE:
            {
                var _ids2 = action.ids,
                    isManual = action.isManual,
                    _duration = action.duration;

                var _updatedOverlays2 = {};
                Object.keys(_ids2).forEach(function (oid) {
                    var overlay = state.overlays[oid];
                    if (isManual) {
                        overlay = (0, _GeneralUtils.updateIn)(overlay, ['time', 'enterAnimTimeManual'], true);
                    } else {
                        overlay = (0, _GeneralUtils.removeIn)(overlay, ['time', 'enterAnimTimeManual']);
                    }
                    var newenterdone = overlay.time.enterstart + _duration;
                    _updatedOverlays2[oid] = (0, _GeneralUtils.updateIn)(overlay, ['time', 'enterdone'], newenterdone);
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _updatedOverlays2)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM:
            {
                var _ids3 = action.ids,
                    _animDefId = action.animDefId;

                var _updatedOverlays3 = {};
                Object.keys(_ids3).forEach(function (oid) {
                    _updatedOverlays3[oid] = (0, _GeneralUtils.updateIn)(state.overlays[oid], ['time', 'exitAnimDefId'], _animDefId);
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _updatedOverlays3)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION:
            {
                var _ids4 = action.ids,
                    _duration2 = action.duration;

                var _updatedOverlays4 = {};
                Object.keys(_ids4).forEach(function (oid) {
                    var newexitstart = state.overlays[oid].time.exitdone - _duration2;
                    _updatedOverlays4[oid] = (0, _GeneralUtils.updateIn)(state.overlays[oid], ['time', 'exitstart'], newexitstart);
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _updatedOverlays4)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_ANIM_DURATION_MANUAL_MODE:
            {
                var _ids5 = action.ids,
                    _isManual = action.isManual,
                    _duration3 = action.duration;

                var _updatedOverlays5 = {};
                Object.keys(_ids5).forEach(function (oid) {
                    var overlay = state.overlays[oid];
                    if (_isManual) {
                        overlay = (0, _GeneralUtils.updateIn)(overlay, ['time', 'exitAnimTimeManual'], true);
                    } else {
                        overlay = (0, _GeneralUtils.removeIn)(overlay, ['time', 'exitAnimTimeManual']);
                    }
                    var newexitstart = overlay.time.exitdone - _duration3;
                    _updatedOverlays5[oid] = (0, _GeneralUtils.updateIn)(overlay, ['time', 'exitstart'], newexitstart);
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _updatedOverlays5)
                });
            }
        case ActionTypes.EDITOR_OVERLAY_SET_OUT_TIME_FINISH:
            {
                var _ids6 = action.ids,
                    time = action.time;

                var _updatedOverlays6 = {};

                Object.keys(_ids6).forEach(function (oid) {
                    var overlay = state.overlays[oid];
                    var _overlay = overlay,
                        enterstart = _overlay.time.enterstart,
                        _overlay$enterAnimati = _overlay.enterAnimationOnly,
                        enterAnimationOnly = _overlay$enterAnimati === undefined ? false : _overlay$enterAnimati;

                    if (enterAnimationOnly) {
                        var exitTime = Math.max(enterstart, time);

                        overlay = (0, _GeneralUtils.updateIn)(overlay, ['time', 'enterdone'], exitTime);
                        overlay = (0, _GeneralUtils.updateIn)(overlay, ['time', 'exitstart'], exitTime);
                        _updatedOverlays6[oid] = (0, _GeneralUtils.updateIn)(overlay, ['time', 'exitdone'], exitTime);
                    }
                });

                return _extends({}, state, {
                    overlays: _extends({}, state.overlays, _updatedOverlays6)
                });
            }
        case ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_WAIT_MODE:
            {
                return _extends({}, state, { player: _extends({}, state.player, { waitMode: action.waitMode }) });
            }
        case ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_PLAYBACK_STATE:
            {
                return _extends({}, state, { player: _extends({}, state.player, { playbackState: action.playbackState }) });
            }
        case ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_CURRENT_TIME:
            {
                return _extends({}, state, { player: _extends({}, state.player, { time: action.time }) });
            }
        case ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_DURATION:
            {
                return _extends({}, state, { player: _extends({}, state.player, { duration: action.duration }) });
            }
        case ActionTypes.EDITOR_VIDEO_EVENT_CHANGE_VOLUME:
            {
                return _extends({}, state, { player: _extends({}, state.player, { volume: action.volume }) });
            }
        case ActionTypes.EDITOR_REEL_ADD_CLIP:
            {
                var clip = action.clip;

                var newclips = [].concat(_toConsumableArray(state.reel.clips), [clip]);

                return _extends({}, state, { reel: _extends({}, state.reel, { clips: newclips }) });
            }
        case ActionTypes.EDITOR_REEL_DELETE_CLIP:
            {
                var _clip = action.clip;

                var clipDuration = _clip.time.exitDone - _clip.time.enterStart;

                var newClips = state.reel.clips.filter(function (c) {
                    return c.clipId !== _clip.clipId;
                }).map(function (c) {
                    if (c.time.enterStart >= _clip.time.exitDone) {
                        var enterStart = c.enterStart,
                            enterDone = c.enterDone,
                            exitStart = c.exitStart,
                            exitDone = c.exitDone;

                        c.time = {
                            enterStart: enterStart - clipDuration,
                            enterDone: enterDone - clipDuration,
                            exitStart: exitStart - clipDuration,
                            exitDone: exitDone - clipDuration
                        };
                    }
                    return c;
                });

                return _extends({}, state, { reel: _extends({}, state.reel, { clips: newClips }) });
            }
        case ActionTypes.EDITOR_BACKGROUND_SET:
            {
                var id = action.id;

                return _extends({}, state, { selected_background: id });
            }
        case ActionTypes.PH_BEGIN_CROP:
            {
                return _extends({}, state, { placeholderData: _extends({}, state.placeholderData, { isCropping: true }) });
            }
        case ActionTypes.PH_DONE_CROP:
            {
                var cropData = action.cropData;

                return _extends({}, state, {
                    placeholderData: _extends({}, state.placeholderData, { isCropping: false, cropData: cropData })
                });
            }
        case ActionTypes.PH_CANCEL_CROP:
            {
                return _extends({}, state, { placeholderData: _extends({}, state.placeholderData, { isCropping: false }) });
            }
        case ActionTypes.EDITOR_REQUIRED_FONTS_LOADED:
            {
                return _extends({}, state, { initialFontsLoaded: true });
            }
        default:
            {
                return state;
            }
    }
};

var app = (0, _redux.combineReducers)({
    tags: tags,
    templates: templates,
    workspaceInfo: workspaceInfo,
    ui: ui,
    editor: editor,
    account: account,
    exportData: exportData
});

exports.default = app;

},{"../common/utils/GeneralUtils":77,"./ActionTypes":271,"./constants":284,"deepmerge":549,"redux":1131}],307:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRelatedTemplates = exports.getCurrentTemplate = exports.getTemplateTags = undefined;

var _reselect = require('reselect');

var getCurrentTemplateId = function getCurrentTemplateId(state) {
    return state.ui.currentTemplateId;
};
var getTemplates = function getTemplates(state) {
    return state.templates;
};
var getTags = function getTags(state) {
    return state.tags;
};

var getCurrentTemplate = (0, _reselect.createSelector)([getCurrentTemplateId, getTemplates], function (currentTemplateId, templates) {
    return templates.find(function (t) {
        return t.id === currentTemplateId;
    });
});

var getTemplateTags = (0, _reselect.createSelector)([getCurrentTemplate, getTags], function (currentTemplate, tags) {
    return currentTemplate.tags.map(function (tid) {
        return tags.find(function (t) {
            return t.id === tid;
        });
    });
});

var getRelatedTemplates = (0, _reselect.createSelector)([getCurrentTemplate, getTemplates], function (currentTemplate, templates) {
    var related_templates = {};
    currentTemplate.tags.forEach(function (tid) {
        templates.forEach(function (tem) {
            if (tem.id === currentTemplate.id) {
                return;
            }
            if (!related_templates[tem.id]) {
                if (!!tem.tags.find(function (templateTagId) {
                    return tid === templateTagId;
                })) {
                    related_templates[tem.id] = true;
                }
            }
        });
    });
    // Could sort better
    return templates.filter(function (tem) {
        return !!related_templates[tem.id];
    }).slice(0, 2); // max 2
});

exports.getTemplateTags = getTemplateTags;
exports.getCurrentTemplate = getCurrentTemplate;
exports.getRelatedTemplates = getRelatedTemplates;

},{"reselect":1136}],308:[function(require,module,exports){
'use strict';

var freePlan = {
    planId: 'basic-free',
    planName: 'Free',
    planDescription: 'For creators trying their hand at video editing.',
    planCost: 0,
    // new pricing features
    planFeatures: {
        brandColor: false,
        customFont: false,
        multilingualSupport: false,
        customFormat: false,
        captions: false,
        canAddSeats: false,
        prioritySupport: false,
        watermarked: true
    },
    originalCost: 0,
    isCustom: false,
    isFreePlan: true,
    referralPlan: false,
    // new pricing metrics
    exportDurationLimitInMin: 30, // mins
    storageLimitInMb: 250, // 0.25GB in MB
    projectDurationLimitInMin: 5, // mins

    // old pricing metrics
    videos: 0,
    fontLimit: 0,
    customFormatLimit: 0,
    memberLimit: 1
};

var CAPTION_FREE_LIMIT = 30; // 30 mins

module.exports = {
    freePlan: freePlan,
    CAPTION_FREE_LIMIT: CAPTION_FREE_LIMIT
};

},{}],309:[function(require,module,exports){
'use strict';

var Keymirror = require('keymirror');

var SupportedReelClipTypes = Keymirror({
    composite: null,
    video: null,
    image: null
});

var FailedUploadPlaceholder = {
    baseUrl: '/images/common/upload_fail_placeholder.png',
    uploadFailedPlaceholder: true,
    deleted: true,
    fullPngUrl: '/images/common/upload_fail_placeholder.png',
    height: 1920,
    id: 'upload-failed-placeholder',
    originalFileName: 'Upload Failed!',
    previewUrl: '/images/common/upload_fail_placeholder.png',
    snapshotUrl: '/images/common/upload_fail_placeholder.png',
    width: 1080
};

module.exports = {
    SupportedReelClipTypes: SupportedReelClipTypes,
    FailedUploadPlaceholder: FailedUploadPlaceholder
};

},{"keymirror":677}],310:[function(require,module,exports){
'use strict';

var FitnessFreeTrialId = 1;

var OfferPlans = [{
    planId: 0,
    planName: 'Promotional Offer',
    planDescription: 'For creators trying their hand at video editing.',
    planCost: 0,
    // new pricing features
    planFeatures: {
        brandColor: true,
        customFont: true,
        multilingualSupport: true,
        customFormat: true,
        captions: false,
        canAddSeats: false,
        prioritySupport: false,
        watermarked: true
    },
    originalCost: 0,
    isCustom: false,
    isFreePlan: true,
    referralPlan: false,
    // old pricing metrics
    videos: 0,
    fontLimit: 5,
    customFormatLimit: 0,
    memberLimit: 6,
    planVersion: 1
}, {
    planId: 1, // workspace-plan-history table can't have plan ids in string.
    planName: 'Fitness trial',
    planDescription: 'For creators trying their hand at fitness video editing.',
    planCost: 0,
    // new pricing features
    planFeatures: {
        brandColor: true,
        customFont: true,
        multilingualSupport: true,
        customFormat: true,
        captions: true,
        canAddSeats: false,
        prioritySupport: true,
        watermarked: false
    },
    originalCost: 0,
    isCustom: false,
    isFreePlan: true,
    isFitnessTrial: true,
    referralPlan: false,
    // new pricing metrics
    exportDurationLimitInMin: 1200, // mins
    storageLimitInMb: 25600, // 25GB in MB
    projectDurationLimitInMin: 180, // mins
    memberLimit: 1,
    planVersion: 2
}];

var getFitnessOfferPlanId = function getFitnessOfferPlanId() {
    return FitnessFreeTrialId;
};

module.exports = {
    OfferPlans: OfferPlans,
    getFitnessOfferPlanId: getFitnessOfferPlanId,
    FitnessFreeTrialId: FitnessFreeTrialId
};

},{}],311:[function(require,module,exports){
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
module.exports = _assertThisInitialized;
},{}],312:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],313:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],314:[function(require,module,exports){
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
},{}],315:[function(require,module,exports){
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
},{}],316:[function(require,module,exports){
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
},{}],317:[function(require,module,exports){
var setPrototypeOf = require("./setPrototypeOf");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
},{"./setPrototypeOf":324}],318:[function(require,module,exports){
var setPrototypeOf = require("./setPrototypeOf");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;
},{"./setPrototypeOf":324}],319:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}],320:[function(require,module,exports){
var _typeof = require("@babel/runtime/helpers/typeof");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
},{"@babel/runtime/helpers/typeof":325}],321:[function(require,module,exports){
var defineProperty = require("./defineProperty");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

module.exports = _objectSpread2;
},{"./defineProperty":314}],322:[function(require,module,exports){
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
},{}],323:[function(require,module,exports){
var _typeof = require('@babel/runtime/helpers/typeof');
var assertThisInitialized = require('./assertThisInitialized');
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn;
},{"./assertThisInitialized":311,"@babel/runtime/helpers/typeof":325}],324:[function(require,module,exports){
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
},{}],325:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
},{}],326:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};
},{"react":1107}],327:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};
},{"react":1107}],328:[function(require,module,exports){
(function (process){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asap = asap;

var _raw = require("./raw");

var freeTasks = [];
/**
 * Calls a task as soon as possible after returning, in its own event, with
 * priority over IO events. An exception thrown in a task can be handled by
 * `process.on("uncaughtException") or `domain.on("error")`, but will otherwise
 * crash the process. If the error is handled, all subsequent tasks will
 * resume.
 *
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */

function asap(task) {
  var rawTask;

  if (freeTasks.length) {
    rawTask = freeTasks.pop();
  } else {
    rawTask = new RawTask();
  }

  rawTask.task = task;
  rawTask.domain = process.domain;
  (0, _raw.rawAsap)(rawTask);
}

var RawTask =
/** @class */
function () {
  function RawTask() {}

  RawTask.prototype.call = function () {
    if (this.domain) {
      this.domain.enter();
    }

    var threw = true;

    try {
      this.task.call();
      threw = false; // If the task throws an exception (presumably) Node.js restores the
      // domain stack for the next event.

      if (this.domain) {
        this.domain.exit();
      }
    } finally {
      // We use try/finally and a threw flag to avoid messing up stack traces
      // when we catch and release errors.
      if (threw) {
        // In Node.js, uncaught exceptions are considered fatal errors.
        // Re-throw them to interrupt flushing!
        // Ensure that flushing continues if an uncaught exception is
        // suppressed listening process.on("uncaughtException") or
        // domain.on("error").
        _raw.rawAsap.requestFlush();
      } // If the task threw an error, we do not want to exit the domain here.
      // Exiting the domain would prevent the domain from catching the error.


      this.task = null;
      this.domain = null;
      freeTasks.push(this);
    }
  };

  return RawTask;
}();
}).call(this)}).call(this,require('_process'))
},{"./raw":330,"_process":405}],329:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asap = require("./asap");

Object.keys(_asap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _asap[key];
    }
  });
});
},{"./asap":328}],330:[function(require,module,exports){
(function (process,setImmediate){(function (){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rawAsap = rawAsap;
var domain; // The domain module is executed on demand

var hasSetImmediate = typeof setImmediate === 'function'; // Use the fastest means possible to execute a task in its own turn, with
// priority over other events including network IO events in Node.js.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.

function rawAsap(task) {
  if (!queue.length) {
    requestFlush();
    flushing = true;
  } // Avoids a function call


  queue[queue.length] = task;
}

var queue = []; // Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.

var flushing = false; // The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.

var index = 0; // If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory excaustion, the task queue will periodically
// truncate already-completed tasks.

var capacity = 1024; // The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.

function flush() {
  while (index < queue.length) {
    var currentIndex = index; // Advance the index before calling the task. This ensures that we will
    // begin flushing on the next task the task throws an error.

    index = index + 1;
    queue[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
    // If we call `asap` within tasks scheduled by `asap`, the queue will
    // grow, but to avoid an O(n) walk for every task we execute, we don't
    // shift tasks off the queue after they have been executed.
    // Instead, we periodically shift 1024 tasks off the queue.

    if (index > capacity) {
      // Manually shift all values starting at the index back to the
      // beginning of the queue.
      for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
        queue[scan] = queue[scan + index];
      }

      queue.length -= index;
      index = 0;
    }
  }

  queue.length = 0;
  index = 0;
  flushing = false;
}

rawAsap.requestFlush = requestFlush;

function requestFlush() {
  // Ensure flushing is not bound to any domain.
  // It is not sufficient to exit the domain, because domains exist on a stack.
  // To execute code outside of any domain, the following dance is necessary.
  var parentDomain = process.domain;

  if (parentDomain) {
    if (!domain) {
      // Lazy execute the domain module.
      // Only employed if the user elects to use domains.
      domain = require('domain');
    }

    domain.active = process.domain = null;
  } // `setImmediate` is slower that `process.nextTick`, but `process.nextTick`
  // cannot handle recursion.
  // `requestFlush` will only be called recursively from `asap.js`, to resume
  // flushing after an error is thrown into a domain.
  // Conveniently, `setImmediate` was introduced in the same version
  // `process.nextTick` started throwing recursion errors.


  if (flushing && hasSetImmediate) {
    setImmediate(flush);
  } else {
    process.nextTick(flush);
  }

  if (parentDomain) {
    domain.active = process.domain = parentDomain;
  }
}
}).call(this)}).call(this,require('_process'),require("timers").setImmediate)
},{"_process":405,"domain":583,"timers":1201}],331:[function(require,module,exports){
(function (process){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.invariant = invariant;
function invariant(condition, format, ...args) {
    if (isProduction()) {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    }
    if (!condition) {
        let error;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function isProduction() {
    return typeof process !== 'undefined' && "production" === 'production';
}


}).call(this)}).call(this,require('_process'))
},{"_process":405}],332:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shallowEqual = shallowEqual;
function shallowEqual(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) {
        return !!compareResult;
    }
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
            return false;
        }
    }
    return true;
}


},{}],333:[function(require,module,exports){
module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}

},{}],334:[function(require,module,exports){
/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};

},{}],335:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":337}],336:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');
var defaults = require('../defaults');
var Cancel = require('../cancel/Cancel');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../cancel/Cancel":338,"../core/buildFullPath":343,"../core/createError":344,"../defaults":350,"./../core/settle":348,"./../helpers/buildURL":353,"./../helpers/cookies":355,"./../helpers/isURLSameOrigin":358,"./../helpers/parseHeaders":360,"./../utils":363}],337:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');
axios.VERSION = require('./env/data').version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":338,"./cancel/CancelToken":339,"./cancel/isCancel":340,"./core/Axios":341,"./core/mergeConfig":347,"./defaults":350,"./env/data":351,"./helpers/bind":352,"./helpers/isAxiosError":357,"./helpers/spread":361,"./utils":363}],338:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],339:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":338}],340:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],341:[function(require,module,exports){
'use strict';
var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');
var validators = validator.validators;
function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}
Axios.prototype.request = function request(config) {
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else {
        config = config || {};
    }
    config = mergeConfig(this.defaults, config);
    if (config.method) {
        config.method = config.method.toLowerCase();
    } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
    } else {
        config.method = 'get';
    }
    var transitional = config.transitional;
    if (transitional !== undefined) {
        validator.assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
    }
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
            return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            dispatchRequest,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
            promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
    }
    var newConfig = config;
    while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = dispatchRequest(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    }
    return promise;
};
Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
utils.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    Axios.prototype[method] = function (url, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
utils.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    Axios.prototype[method] = function (url, data, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = Axios;
},{"../helpers/buildURL":353,"../helpers/validator":362,"./../utils":363,"./InterceptorManager":342,"./dispatchRequest":345,"./mergeConfig":347}],342:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":363}],343:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":354,"../helpers/isAbsoluteURL":356}],344:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":346}],345:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');
var Cancel = require('../cancel/Cancel');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/Cancel":338,"../cancel/isCancel":340,"../defaults":350,"./../utils":363,"./transformData":349}],346:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

},{}],347:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

},{"../utils":363}],348:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":344}],349:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":350,"./../utils":363}],350:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))
},{"./adapters/http":336,"./adapters/xhr":336,"./core/enhanceError":346,"./helpers/normalizeHeaderName":359,"./utils":363,"_process":405}],351:[function(require,module,exports){
module.exports = {
  "version": "0.24.0"
};
},{}],352:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],353:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":363}],354:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],355:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":363}],356:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],357:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],358:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":363}],359:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":363}],360:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":363}],361:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],362:[function(require,module,exports){
'use strict';
var VERSION = require('../env/data').version;
var validators = {};
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function (type, i) {
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var deprecatedWarnings = {};
validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    return function (value, opt, opts) {
        if (validator === false) {
            throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        }
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') {
        throw new TypeError('options must be an object');
    }
    var keys = Object.keys(options);
    var i = keys.length;
    while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) {
                throw new TypeError('option ' + opt + ' must be ' + result);
            }
            continue;
        }
        if (allowUnknown !== true) {
            throw Error('Unknown option ' + opt);
        }
    }
}
module.exports = {
    assertOptions: assertOptions,
    validators: validators
};
},{"../env/data":351}],363:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":352}],364:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":423}],365:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":424}],366:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };
},{"core-js/library/fn/map":425}],367:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/number/epsilon"), __esModule: true };
},{"core-js/library/fn/number/epsilon":426}],368:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":427}],369:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":428}],370:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };
},{"core-js/library/fn/object/define-properties":429}],371:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":430}],372:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };
},{"core-js/library/fn/object/freeze":431}],373:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-descriptor":432}],374:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":433}],375:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":434}],376:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/set"), __esModule: true };
},{"core-js/library/fn/set":435}],377:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/string/from-code-point"), __esModule: true };
},{"core-js/library/fn/string/from-code-point":436}],378:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":437}],379:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":438}],380:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],381:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":371}],382:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":369,"../core-js/object/set-prototype-of":375,"../helpers/typeof":384}],383:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":384}],384:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":378,"../core-js/symbol/iterator":379}],385:[function(require,module,exports){

/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};


},{}],386:[function(require,module,exports){
/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();

},{}],387:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],388:[function(require,module,exports){
(function (global){(function (){
/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],389:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

Async.prototype.invokeLater = AsyncInvokeLater;
Async.prototype.invoke = AsyncInvoke;
Async.prototype.settlePromises = AsyncSettlePromises;


function _drainQueue(queue) {
    while (queue.length() > 0) {
        _drainQueueStep(queue);
    }
}

function _drainQueueStep(queue) {
    var fn = queue.shift();
    if (typeof fn !== "function") {
        fn._settlePromises();
    } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
}

Async.prototype._drainQueues = function () {
    _drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    _drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (!true) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (!true) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context,
    enableAsyncHooks, disableAsyncHooks) {
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var es5 = _dereq_("./es5");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

var deferUnhandledRejectionCheck;
(function() {
    var promises = [];

    function unhandledRejectionCheck() {
        for (var i = 0; i < promises.length; ++i) {
            promises[i]._notifyUnhandledRejection();
        }
        unhandledRejectionClear();
    }

    function unhandledRejectionClear() {
        promises.length = 0;
    }

    deferUnhandledRejectionCheck = function(promise) {
        promises.push(promise);
        setTimeout(unhandledRejectionCheck, 1);
    };

    es5.defineProperty(Promise, "_unhandledRejectionCheck", {
        value: unhandledRejectionCheck
    });
    es5.defineProperty(Promise, "_unhandledRejectionClear", {
        value: unhandledRejectionClear
    });
})();

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    deferUnhandledRejectionCheck(this);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var context = Promise._getContext();
    possiblyUnhandledRejection = util.contextBind(context, fn);
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var context = Promise._getContext();
    unhandledRejectionHandled = util.contextBind(context, fn);
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
        Context.activateLongStackTraces();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};


var legacyHandlers = {
    unhandledrejection: {
        before: function() {
            var ret = util.global.onunhandledrejection;
            util.global.onunhandledrejection = null;
            return ret;
        },
        after: function(fn) {
            util.global.onunhandledrejection = fn;
        }
    },
    rejectionhandled: {
        before: function() {
            var ret = util.global.onrejectionhandled;
            util.global.onrejectionhandled = null;
            return ret;
        },
        after: function(fn) {
            util.global.onrejectionhandled = fn;
        }
    }
};

var fireDomEvent = (function() {
    var dispatch = function(legacy, e) {
        if (legacy) {
            var fn;
            try {
                fn = legacy.before();
                return !util.global.dispatchEvent(e);
            } finally {
                legacy.after(fn);
            }
        } else {
            return !util.global.dispatchEvent(e);
        }
    };
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var eventData = {
                    detail: event,
                    cancelable: true
                };
                var domEvent = new CustomEvent(name, eventData);
                es5.defineProperty(
                    domEvent, "promise", {value: event.promise});
                es5.defineProperty(
                    domEvent, "reason", {value: event.reason});

                return dispatch(legacyHandlers[name], domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = new Event(name, {
                    cancelable: true
                });
                domEvent.detail = event;
                es5.defineProperty(domEvent, "promise", {value: event.promise});
                es5.defineProperty(domEvent, "reason", {value: event.reason});
                return dispatch(legacyHandlers[name], domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name, false, true,
                    event);
                return dispatch(legacyHandlers[name], domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
        var prev = config.asyncHooks;
        var cur = !!opts.asyncHooks;
        if (prev !== cur) {
            config.asyncHooks = cur;
            if (cur) {
                enableAsyncHooks();
            } else {
                disableAsyncHooks();
            }
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._dereferenceTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function longStackTracesDereferenceTrace() {
    this._trace = undefined;
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = (firstLineError.stack || "").split("\n");
    var lastStackLines = (lastLineError.stack || "").split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false,
    asyncHooks: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    asyncHooks: function() {
        return config.asyncHooks;
    },
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./es5":13,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (!true) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (!true) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var context = Promise._getContext();
                        holder.fn = util.contextBind(context, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var context = Promise._getContext();
    this._callback = util.contextBind(context, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
    if (util.isArray(promises)) {
        for (var i = 0; i < promises.length; ++i) {
            var maybePromise = promises[i];
            if (maybePromise instanceof Promise) {
                maybePromise.suppressUnhandledRejections();
            }
        }
    }
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");
util.setReflectHandler(reflectHandler);

var getDomain = function() {
    var domain = process.domain;
    if (domain === undefined) {
        return null;
    }
    return domain;
};
var getContextDefault = function() {
    return null;
};
var getContextDomain = function() {
    return {
        domain: getDomain(),
        async: null
    };
};
var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ?
    _dereq_("async_hooks").AsyncResource : null;
var getContextAsyncHooks = function() {
    return {
        domain: getDomain(),
        async: new AsyncResource("Bluebird::Promise")
    };
};
var getContext = util.isNode ? getContextDomain : getContextDefault;
util.notEnumerableProp(Promise, "_getContext", getContext);
var enableAsyncHooks = function() {
    getContext = getContextAsyncHooks;
    util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
};
var disableAsyncHooks = function() {
    getContext = getContextDomain;
    util.notEnumerableProp(Promise, "_getContext", getContextDomain);
};

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;

var debug = _dereq_("./debuggability")(Promise, Context,
    enableAsyncHooks, disableAsyncHooks);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];

        if (typeof fn !== "function") {
            throw new TypeError("The last argument to .catch() " +
                "must be a function, got " + util.toString(fn));
        }
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var context = getContext();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: util.contextBind(context, handler),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise,
                receiver, context);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    var bitField = this._bitField;
    this._bitField = bitField |
        (((bitField & 536870912) >> 2) ^
        134217728);
};

Promise.prototype._setNoAsyncGuarantee = function() {
    this._bitField = (this._bitField | 536870912) &
        (~134217728);
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    context
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 = util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 = util.contextBind(context, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                util.contextBind(context, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);


    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(maybePromise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
        this._dereferenceTrace();
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
        get: function () {
            return "Object";
        }
    });
}

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);
Promise.Promise = Promise;
Promise.version = "3.7.2";
_dereq_('./call_get.js')(Promise);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,"async_hooks":undefined}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
        values.suppressUnhandledRejections();
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (!true) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var context = Promise._getContext();
    this._fn = util.contextBind(context, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined &&
        this._eachValues !== null &&
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    for (var j = i; j < length; ++j) {
        var maybePromise = values[j];
        if (maybePromise instanceof Promise) {
            maybePromise.suppressUnhandledRejections();
        }
    }

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };

            value = value._then(gotAccum, undefined, undefined, ctx, undefined);

            if ((i & 127) === 0) {
                value._setNoAsyncGuarantee();
            }
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova)) &&
          ("classList" in document.documentElement)) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.allSettled = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var receiver = new FakeConstructor();
    function ic() {
        return typeof receiver.foo;
    }
    ic();
    ic();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if (classString(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

var reflectHandler;
function contextBind(ctx, cb) {
    if (ctx === null ||
        typeof cb !== "function" ||
        cb === reflectHandler) {
        return cb;
    }

    if (ctx.domain !== null) {
        cb = ctx.domain.bind(cb);
    }

    var async = ctx.async;
    if (async !== null) {
        var old = cb;
        cb = function() {
            var args = (new Array(2)).concat([].slice.call(arguments));;
            args[0] = old;
            args[1] = this;
            return async.runInAsyncScope.apply(async, args);
        };
    }
    return cb;
}

var ret = {
    setReflectHandler: function(fn) {
        reflectHandler = fn;
    },
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    contextBind: contextBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version;
    if (process.versions && process.versions.node) {
        version = process.versions.node.split(".").map(Number);
    } else if (process.version) {
        version = process.version.split(".").map(Number);
    }
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();
ret.nodeSupportsAsyncResource = ret.isNode && (function() {
    var supportsAsync = false;
    try {
        var res = _dereq_("async_hooks").AsyncResource;
        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
    } catch (e) {
        supportsAsync = false;
    }
    return supportsAsync;
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13,"async_hooks":undefined}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"_process":405,"timers":1201}],390:[function(require,module,exports){
(function (root, factory) { if(typeof define === "function" && define.amd) { define( factory); } else if(typeof module === "object" && module.exports) { module.exports = factory(); } else { root.bodymovin = factory(); } }(window, function() {var svgNS = "http://www.w3.org/2000/svg";
var subframeEnabled = true;
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cachedColors = {};
var bm_rounder = Math.round;
var bm_rnd;
var bm_pow = Math.pow;
var bm_sqrt = Math.sqrt;
var bm_abs = Math.abs;
var bm_floor = Math.floor;
var bm_max = Math.max;
var bm_min = Math.min;
var blitter = 10;

var BMMath = {};
(function(){
    var propertyNames = Object.getOwnPropertyNames(Math);
    var i, len = propertyNames.length;
    for(i=0;i<len;i+=1){
        BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
}());

function ProjectInterface(){return {}};

BMMath.random = Math.random;
BMMath.abs = function(val){
    var tOfVal = typeof val;
    if(tOfVal === 'object' && val.length){
        var absArr = Array.apply(null,{length:val.length});
        var i, len = val.length;
        for(i=0;i<len;i+=1){
            absArr[i] = Math.abs(val[i]);
        }
        return absArr;
    }
    return Math.abs(val);

}
var defaultCurveSegments = 150;
var degToRads = Math.PI/180;
var roundCorner = 0.5519;

function roundValues(flag){
    if(flag){
        bm_rnd = Math.round;
    }else{
        bm_rnd = function(val){
            return val;
        };
    }
}
roundValues(false);

function roundTo2Decimals(val){
    return Math.round(val*10000)/10000;
}

function roundTo3Decimals(val){
    return Math.round(val*100)/100;
}

function styleDiv(element){
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
}

function styleUnselectableDiv(element){
    element.style.userSelect = 'none';
    element.style.MozUserSelect = 'none';
    element.style.webkitUserSelect = 'none';
    element.style.oUserSelect = 'none';

}

function BMEnterFrameEvent(n,c,t,d){
    this.type = n;
    this.currentTime = c;
    this.totalTime = t;
    this.direction = d < 0 ? -1:1;
}

function BMCompleteEvent(n,d){
    this.type = n;
    this.direction = d < 0 ? -1:1;
}

function BMCompleteLoopEvent(n,c,t,d){
    this.type = n;
    this.currentLoop = c;
    this.totalLoops = t;
    this.direction = d < 0 ? -1:1;
}

function BMSegmentStartEvent(n,f,t){
    this.type = n;
    this.firstFrame = f;
    this.totalFrames = t;
}

function BMDestroyEvent(n,t){
    this.type = n;
    this.target = t;
}

function _addEventListener(eventName, callback){

    if (!this._cbs[eventName]){
        this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

}

function _removeEventListener(eventName,callback){

    if (!callback){
        this._cbs[eventName] = null;
    }else if(this._cbs[eventName]){
        var i = 0, len = this._cbs[eventName].length;
        while(i<len){
            if(this._cbs[eventName][i] === callback){
                this._cbs[eventName].splice(i,1);
                i -=1;
                len -= 1;
            }
            i += 1;
        }
        if(!this._cbs[eventName].length){
            this._cbs[eventName] = null;
        }
    }

}

function _triggerEvent(eventName, args){
    if (this._cbs[eventName]) {
        var len = this._cbs[eventName].length;
        for (var i = 0; i < len; i++){
            this._cbs[eventName][i](args);
        }
    }
}

function randomString(length, chars){
    if(chars === undefined){
        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
    }
    var i;
    var result = '';
    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
}

function HSVtoRGB(h, s, v) {
    var r, g, b, i, f, p, q, t;
    if (arguments.length === 1) {
        s = h.s, v = h.v, h = h.h;
    }
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v, g = t, b = p; break;
        case 1: r = q, g = v, b = p; break;
        case 2: r = p, g = v, b = t; break;
        case 3: r = p, g = q, b = v; break;
        case 4: r = t, g = p, b = v; break;
        case 5: r = v, g = p, b = q; break;
    }
    return [ r,
        g,
         b ];
}

function RGBtoHSV(r, g, b) {
    if (arguments.length === 1) {
        g = r.g, b = r.b, r = r.r;
    }
    var max = Math.max(r, g, b), min = Math.min(r, g, b),
        d = max - min,
        h,
        s = (max === 0 ? 0 : d / max),
        v = max / 255;

    switch (max) {
        case min: h = 0; break;
        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
        case g: h = (b - r) + d * 2; h /= 6 * d; break;
        case b: h = (r - g) + d * 4; h /= 6 * d; break;
    }

    return [
         h,
         s,
         v
    ];
}

function addSaturationToRGB(color,offset){
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[1] += offset;
    if (hsv[1] > 1) {
        hsv[1] = 1;
    }
    else if (hsv[1] <= 0) {
        hsv[1] = 0;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function addBrightnessToRGB(color,offset){
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[2] += offset;
    if (hsv[2] > 1) {
        hsv[2] = 1;
    }
    else if (hsv[2] < 0) {
        hsv[2] = 0;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function addHueToRGB(color,offset) {
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[0] += offset/360;
    if (hsv[0] > 1) {
        hsv[0] -= 1;
    }
    else if (hsv[0] < 0) {
        hsv[0] += 1;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}

var rgbToHex = (function(){
    var colorMap = [];
    var i;
    var hex;
    for(i=0;i<256;i+=1){
        hex = i.toString(16);
        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
    }

    return function(r, g, b) {
        if(r<0){
            r = 0;
        }
        if(g<0){
            g = 0;
        }
        if(b<0){
            b = 0;
        }
        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
}());

function fillToRgba(hex,alpha){
    if(!cachedColors[hex]){
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        cachedColors[hex] = parseInt(result[1], 16)+','+parseInt(result[2], 16)+','+parseInt(result[3], 16);
    }
    return 'rgba('+cachedColors[hex]+','+alpha+')';
}

var fillColorToString = (function(){

    var colorMap = [];
    return function(colorArr,alpha){
        if(alpha !== undefined){
            colorArr[3] = alpha;
        }
        if(!colorMap[colorArr[0]]){
            colorMap[colorArr[0]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]]){
            colorMap[colorArr[0]][colorArr[1]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]]){
            colorMap[colorArr[0]][colorArr[1]][colorArr[2]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]]){
            colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]] = 'rgba(' + colorArr.join(',')+')';
        }
        return colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]];
    };
}());

function RenderedFrame(tr,o) {
    this.tr = tr;
    this.o = o;
}

function LetterProps(o,sw,sc,fc,m,p){
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.props = p;
}

function iterateDynamicProperties(num){
    var i, len = this.dynamicProperties;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue(num);
    }
}

function reversePath(paths){
    var newI = [], newO = [], newV = [];
    var i, len, newPaths = {};
    var init = 0;
    if (paths.c) {
        newI[0] = paths.o[0];
        newO[0] = paths.i[0];
        newV[0] = paths.v[0];
        init = 1;
    }
    len = paths.i.length;
    var cnt = len - 1;

    for (i = init; i < len; i += 1) {
        newI.push(paths.o[cnt]);
        newO.push(paths.i[cnt]);
        newV.push(paths.v[cnt]);
        cnt -= 1;
    }

    newPaths.i = newI;
    newPaths.o = newO;
    newPaths.v = newV;

    return newPaths;
}
/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function(){

    function reset(){
        this.props[0] = 1;
        this.props[1] = 0;
        this.props[2] = 0;
        this.props[3] = 0;
        this.props[4] = 0;
        this.props[5] = 1;
        this.props[6] = 0;
        this.props[7] = 0;
        this.props[8] = 0;
        this.props[9] = 0;
        this.props[10] = 1;
        this.props[11] = 0;
        this.props[12] = 0;
        this.props[13] = 0;
        this.props[14] = 0;
        this.props[15] = 1;
        return this;
    }

    function rotate(angle) {
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
    }

    function rotateX(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(1, 0, 0, 0
            , 0, mCos, -mSin, 0
            , 0, mSin,  mCos, 0
            , 0, 0, 0, 1);
    }

    function rotateY(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos,  0,  mSin, 0
            , 0, 1, 0, 0
            , -mSin,  0,  mCos, 0
            , 0, 0, 0, 1);
    }

    function rotateZ(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
    }

    function shear(sx,sy){
        return this._t(1, sy, sx, 1, 0, 0);
    }

    function skew(ax, ay){
        return this.shear(Math.tan(ax), Math.tan(ay));
    }

    function skewFromAxis(ax, angle){
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, mSin,  0, 0
            , -mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1)
            ._t(1, 0,  0, 0
            , Math.tan(ax),  1, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1)
            ._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, Math.tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }

    function scale(sx, sy, sz) {
        sz = isNaN(sz) ? 1 : sz;
        if(sx == 1 && sy == 1 && sz == 1){
            return this;
        }
        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }

    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
        this.props[0] = a;
        this.props[1] = b;
        this.props[2] = c;
        this.props[3] = d;
        this.props[4] = e;
        this.props[5] = f;
        this.props[6] = g;
        this.props[7] = h;
        this.props[8] = i;
        this.props[9] = j;
        this.props[10] = k;
        this.props[11] = l;
        this.props[12] = m;
        this.props[13] = n;
        this.props[14] = o;
        this.props[15] = p;
        return this;
    }

    function translate(tx, ty, tz) {
        tz = tz || 0;
        if(tx !== 0 || ty !== 0 || tz !== 0){
            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
        }
        return this;
    }

    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {

        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
            if(m2 !== 0 || n2 !== 0 || o2 !== 0){

                this.props[12] = this.props[12] * a2 + this.props[13] * e2 + this.props[14] * i2 + this.props[15] * m2 ;
                this.props[13] = this.props[12] * b2 + this.props[13] * f2 + this.props[14] * j2 + this.props[15] * n2 ;
                this.props[14] = this.props[12] * c2 + this.props[13] * g2 + this.props[14] * k2 + this.props[15] * o2 ;
                this.props[15] = this.props[12] * d2 + this.props[13] * h2 + this.props[14] * l2 + this.props[15] * p2 ;
            }
            return this;
        }

        var a1 = this.props[0];
        var b1 = this.props[1];
        var c1 = this.props[2];
        var d1 = this.props[3];
        var e1 = this.props[4];
        var f1 = this.props[5];
        var g1 = this.props[6];
        var h1 = this.props[7];
        var i1 = this.props[8];
        var j1 = this.props[9];
        var k1 = this.props[10];
        var l1 = this.props[11];
        var m1 = this.props[12];
        var n1 = this.props[13];
        var o1 = this.props[14];
        var p1 = this.props[15];

        /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
        this.props[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
        this.props[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
        this.props[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
        this.props[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;

        this.props[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
        this.props[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
        this.props[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
        this.props[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;

        this.props[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
        this.props[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
        this.props[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
        this.props[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;

        this.props[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
        this.props[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
        this.props[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
        this.props[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;

        return this;
    }

    function clone(matr){
        var i;
        for(i=0;i<16;i+=1){
            matr.props[i] = this.props[i];
        }
    }

    function cloneFromProps(props){
        var i;
        for(i=0;i<16;i+=1){
            this.props[i] = props[i];
        }
    }

    function applyToPoint(x, y, z) {

        return {
            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
        };
        /*return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         };*/
    }
    function applyToX(x, y, z) {
        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }
    function applyToY(x, y, z) {
        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }
    function applyToZ(x, y, z) {
        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }

    function inversePoints(pts){
        //var determinant = this.a * this.d - this.b * this.c;
        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
        var a = this.props[5]/determinant;
        var b = - this.props[1]/determinant;
        var c = - this.props[4]/determinant;
        var d = this.props[0]/determinant;
        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
        var i, len = pts.length, retPts = [];
        for(i=0;i<len;i+=1){
            retPts[i] = [pts[i][0] * a + pts[i][1] * c + e, pts[i][0] * b + pts[i][1] * d + f, 0]
        }
        return retPts;
    }

    function applyToPointArray(x,y,z,dimensions){
        if(dimensions && dimensions === 2) {
            var arr = point_pool.newPoint();
            arr[0] = x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12]; 
            arr[1] = x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13]; 
            return arr;    
        }
        return [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
    }
    function applyToPointStringified(x, y) {
        return (bm_rnd(x * this.props[0] + y * this.props[4] + this.props[12]))+','+(bm_rnd(x * this.props[1] + y * this.props[5] + this.props[13]));
    }

    function toArray() {
        return [this.props[0],this.props[1],this.props[2],this.props[3],this.props[4],this.props[5],this.props[6],this.props[7],this.props[8],this.props[9],this.props[10],this.props[11],this.props[12],this.props[13],this.props[14],this.props[15]];
    }

    function toCSS() {
        if(isSafari){
            return "matrix3d(" + roundTo2Decimals(this.props[0]) + ',' + roundTo2Decimals(this.props[1]) + ',' + roundTo2Decimals(this.props[2]) + ',' + roundTo2Decimals(this.props[3]) + ',' + roundTo2Decimals(this.props[4]) + ',' + roundTo2Decimals(this.props[5]) + ',' + roundTo2Decimals(this.props[6]) + ',' + roundTo2Decimals(this.props[7]) + ',' + roundTo2Decimals(this.props[8]) + ',' + roundTo2Decimals(this.props[9]) + ',' + roundTo2Decimals(this.props[10]) + ',' + roundTo2Decimals(this.props[11]) + ',' + roundTo2Decimals(this.props[12]) + ',' + roundTo2Decimals(this.props[13]) + ',' + roundTo2Decimals(this.props[14]) + ',' + roundTo2Decimals(this.props[15]) + ')';
        } else {
            this.cssParts[1] = this.props.join(',');
            return this.cssParts.join('');
        }
    }

    function to2dCSS() {
        return "matrix(" + this.props[0] + ',' + this.props[1] + ',' + this.props[4] + ',' + this.props[5] + ',' + this.props[12] + ',' + this.props[13] + ")";
    }

    function toString() {
        return "" + this.toArray();
    }

    return function(){
        this.reset = reset;
        this.rotate = rotate;
        this.rotateX = rotateX;
        this.rotateY = rotateY;
        this.rotateZ = rotateZ;
        this.skew = skew;
        this.skewFromAxis = skewFromAxis;
        this.shear = shear;
        this.scale = scale;
        this.setTransform = setTransform;
        this.translate = translate;
        this.transform = transform;
        this.applyToPoint = applyToPoint;
        this.applyToX = applyToX;
        this.applyToY = applyToY;
        this.applyToZ = applyToZ;
        this.applyToPointArray = applyToPointArray;
        this.applyToPointStringified = applyToPointStringified;
        this.toArray = toArray;
        this.toCSS = toCSS;
        this.to2dCSS = to2dCSS;
        this.toString = toString;
        this.clone = clone;
        this.cloneFromProps = cloneFromProps;
        this.inversePoints = inversePoints;
        this._t = this.transform;

        this.props = [1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];

        this.cssParts = ['matrix3d(','',')'];
    }
}());

function Matrix() {


}

/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options == true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed == null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; }
        prng.quick = function() { return arc4.g(4) / 0x100000000; }
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); }
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    };

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date, global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
var BezierFactory = (function(){
    /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

        var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};

    function getBezierEasing(a,b,c,d,nm){
        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
        if(beziers[str]){
            return beziers[str];
        }
        var bezEasing = new BezierEasing([a,b,c,d]);
        beziers[str] = bezEasing;
        return bezEasing;
    }

// These values are established by empiricism with tests (tradeoff: performance VS precision)
    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;

    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

    var float32ArraySupported = typeof Float32Array === "function";

    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
    function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier (aT, aA1, aA2) {
        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
    }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope (aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide (aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }

    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }

    /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
    function BezierEasing (points) {
        this._p = points;
        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        this._precomputed = false;

        this.get = this.get.bind(this);
    }

    BezierEasing.prototype = {

        get: function (x) {
            var mX1 = this._p[0],
                mY1 = this._p[1],
                mX2 = this._p[2],
                mY2 = this._p[3];
            if (!this._precomputed) this._precompute();
            if (mX1 === mY1 && mX2 === mY2) return x; // linear
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) return 0;
            if (x === 1) return 1;
            return calcBezier(this._getTForX(x), mY1, mY2);
        },

        // Private part

        _precompute: function () {
            var mX1 = this._p[0],
                mY1 = this._p[1],
                mX2 = this._p[2],
                mY2 = this._p[3];
            this._precomputed = true;
            if (mX1 !== mY1 || mX2 !== mY2)
                this._calcSampleValues();
        },

        _calcSampleValues: function () {
            var mX1 = this._p[0],
                mX2 = this._p[2];
            for (var i = 0; i < kSplineTableSize; ++i) {
                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }
        },

        /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
        _getTForX: function (aX) {
            var mX1 = this._p[0],
                mX2 = this._p[2],
                mSampleValues = this._mSampleValues;

            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;

            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
                intervalStart += kSampleStepSize;
            }
            --currentSample;

            // Interpolate to provide an initial guess for t
            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;

            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) {
                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            } else if (initialSlope === 0.0) {
                return guessForT;
            } else {
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        }
    };

    return ob;

}())


function matrixManagerFunction(){

    var mat = new Matrix();

    var returnMatrix2D = function(rX, scaleX, scaleY, tX, tY){
        return mat.reset().translate(tX,tY).rotate(rX).scale(scaleX,scaleY).toCSS();
    };

    var getMatrix = function(animData){
        return returnMatrix2D(animData.tr.r[2],animData.tr.s[0],animData.tr.s[1],animData.tr.p[0],animData.tr.p[1]);
    };

    return {
        getMatrix : getMatrix
    };

}
var MatrixManager = matrixManagerFunction;
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if(!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
                    callback(currTime + timeToCall);
                },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    if(!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());
function createElement(parent,child,params){
    if(child){
        child.prototype = Object.create(parent.prototype);
        child.prototype.constructor = child;
        child.prototype._parent = parent.prototype;
    }else{
        var instance = Object.create(parent.prototype,params);
        var getType = {};
        if(instance && getType.toString.call(instance.init) === '[object Function]'){
            instance.init();
        }
        return instance;
    }
}

function extendPrototype(source,destination){
    for (var attr in source.prototype) {
        if (source.prototype.hasOwnProperty(attr)) destination.prototype[attr] = source.prototype[attr];
    }
}
function bezFunction(){

    var easingFunctions = [];
    var math = Math;

    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
        return det1 > -0.0001 && det1 < 0.0001;
    }

    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
        return pointOnLine2D(x1,y1, x2,y2, x3,y3) && pointOnLine2D(x1,z1, x2,z2, x3,z3);
    }

    /*function getEasingCurve(aa,bb,cc,dd,encodedFuncName) {
        if(!encodedFuncName){
            encodedFuncName = ('bez_' + aa+'_'+bb+'_'+cc+'_'+dd).replace(/\./g, 'p');
        }
        if(easingFunctions[encodedFuncName]){
            return easingFunctions[encodedFuncName];
        }
        var A0, B0, C0;
        var A1, B1, C1;
        easingFunctions[encodedFuncName] = function(tt) {
            var x = tt;
            var i = 0, z;
            while (++i < 20) {
                C0 = 3 * aa;
                B0 = 3 * (cc - aa) - C0;
                A0 = 1 - C0 - B0;
                z = (x * (C0 + x * (B0 + x * A0))) - tt;
                if (bm_abs(z) < 1e-3) break;
                x -= z / (C0 + x * (2 * B0 + 3 * A0 * x));
            }
            C1 = 3 * bb;
            B1 = 3 * (dd - bb) - C1;
            A1 = 1 - C1 - B1;
            var polyB = x * (C1 + x * (B1 + x * A1));
            //return c * polyB + b;
            return polyB;
        };
        return easingFunctions[encodedFuncName];
    }*/
    var getBezierLength = (function(){

        function Segment(l,p){
            this.l = l;
            this.p = p;
        }

        return function(pt1,pt2,pt3,pt4){
            var curveSegments = defaultCurveSegments;
            var k;
            var i, len;
            var ptCoord,perc,addedLength = 0;
            var ptDistance;
            var point = [],lastPoint = [];
            var lengthData = {
                addedLength: 0,
                segments: []
            };
            len = pt3.length;
            for(k=0;k<curveSegments;k+=1){
                perc = k/(curveSegments-1);
                ptDistance = 0;
                for(i=0;i<len;i+=1){
                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
                    point[i] = ptCoord;
                    if(lastPoint[i] !== null){
                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
                    }
                    lastPoint[i] = point[i];
                }
                if(ptDistance){
                    ptDistance = bm_sqrt(ptDistance);
                    addedLength += ptDistance;
                }
                lengthData.segments.push(new Segment(addedLength,perc));
            }
            lengthData.addedLength = addedLength;
            return lengthData;
        };
    }());

    function BezierData(length){
        this.segmentLength = 0;
        this.points = new Array(length);
    }

    function PointData(partial,point){
        this.partialLength = partial;
        this.point = point;
    }

    var buildBezierData = (function(){

        var storedData = {};

        return function (keyData){
            var pt1 = keyData.s;
            var pt2 = keyData.e;
            var pt3 = keyData.to;
            var pt4 = keyData.ti;
            var bezierName = (pt1.join('_')+'_'+pt2.join('_')+'_'+pt3.join('_')+'_'+pt4.join('_')).replace(/\./g, 'p');
            if(storedData[bezierName]){
                keyData.bezierData = storedData[bezierName];
                return;
            }
        var curveSegments = defaultCurveSegments;
        var k, i, len;
            var ptCoord,perc,addedLength = 0;
            var ptDistance;
            var point,lastPoint = null;
            if(pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
                curveSegments = 2;
            }
            var bezierData = new BezierData(curveSegments);
            len = pt3.length;
            for(k=0;k<curveSegments;k+=1){
            point = new Array(len);
                perc = k/(curveSegments-1);
                ptDistance = 0;
                for(i=0;i<len;i+=1){
                ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
                point[i] = ptCoord;
                    if(lastPoint !== null){
                    ptDistance += bm_pow(point[i] - lastPoint[i],2);
                    }
                }
            ptDistance = bm_sqrt(ptDistance);
                addedLength += ptDistance;
                bezierData.points[k] = new PointData(ptDistance,point);
                lastPoint = point;
            }
            bezierData.segmentLength = addedLength;
            keyData.bezierData = bezierData;
            storedData[bezierName] = bezierData;

        }
    }());

    function getDistancePerc(perc,bezierData){
        var segments = bezierData.segments;
        var len = segments.length;
        var initPos = bm_floor((len-1)*perc);
        var lengthPos = perc*bezierData.addedLength;
        var lPerc = 0;
        if(lengthPos == segments[initPos].l){
            return segments[initPos].p;
        }else{
            var dir = segments[initPos].l > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if(segments[initPos].l <= lengthPos && segments[initPos+1].l > lengthPos){
                    lPerc = (lengthPos - segments[initPos].l)/(segments[initPos+1].l-segments[initPos].l);
                    flag = false;
                }else{
                    initPos += dir;
                }
                if(initPos < 0 || initPos >= len - 1){
                    flag = false;
                }
            }
            return segments[initPos].p + (segments[initPos+1].p - segments[initPos].p)*lPerc;
        }
    }

    function SegmentPoints(){
        this.pt1 = new Array(2);
        this.pt2 = new Array(2);
        this.pt3 = new Array(2);
        this.pt4 = new Array(2);
    }

    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){

        var pts = new SegmentPoints();
        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
        var t0 = getDistancePerc(startPerc,bezierData);
        endPerc = endPerc > 1 ? 1 : endPerc;
        var t1 = getDistancePerc(endPerc,bezierData);
        var i, len = pt1.length;
        var u0 = 1 - t0;
        var u1 = 1 - t1;
        //Math.round(num * 100) / 100
        for(i=0;i<len;i+=1){
            pts.pt1[i] =  Math.round((u0*u0*u0* pt1[i] + (t0*u0*u0 + u0*t0*u0 + u0*u0*t0) * pt3[i] + (t0*t0*u0 + u0*t0*t0 + t0*u0*t0)* pt4[i] + t0*t0*t0* pt2[i])* 1000) / 1000;
            pts.pt3[i] = Math.round((u0*u0*u1*pt1[i] + (t0*u0*u1 + u0*t0*u1 + u0*u0*t1)* pt3[i] + (t0*t0*u1 + u0*t0*t1 + t0*u0*t1)* pt4[i] + t0*t0*t1* pt2[i])* 1000) / 1000;
            pts.pt4[i] = Math.round((u0*u1*u1* pt1[i] + (t0*u1*u1 + u0*t1*u1 + u0*u1*t1)* pt3[i] + (t0*t1*u1 + u0*t1*t1 + t0*u1*t1)* pt4[i] + t0*t1*t1* pt2[i])* 1000) / 1000;
            pts.pt2[i] = Math.round((u1*u1*u1* pt1[i] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[i] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[i] + t1*t1*t1* pt2[i])* 1000) / 1000;
        }
        return pts;
    }

    return {
        //getEasingCurve : getEasingCurve,
        getBezierLength : getBezierLength,
        getNewSegment : getNewSegment,
        buildBezierData : buildBezierData,
        pointOnLine2D : pointOnLine2D,
        pointOnLine3D : pointOnLine3D
    };
}

var bez = bezFunction();
function dataFunctionManager(){

    //var tCanvasHelper = document.createElement('canvas').getContext('2d');

    function completeLayers(layers, comps, fontManager){
        var layerData;
        var animArray, lastFrame;
        var i, len = layers.length;
        var j, jLen, k, kLen;
        for(i=0;i<len;i+=1){
            layerData = layers[i];
            if(!('ks' in layerData) || layerData.completed){
                continue;
            }
            layerData.completed = true;
            if(layerData.tt){
                layers[i-1].td = layerData.tt;
            }
            animArray = [];
            lastFrame = -1;
            if(layerData.hasMask){
                var maskProps = layerData.masksProperties;
                jLen = maskProps.length;
                for(j=0;j<jLen;j+=1){
                    if(maskProps[j].pt.k.i){
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                    }else{
                        kLen = maskProps[j].pt.k.length;
                        for(k=0;k<kLen;k+=1){
                            if(maskProps[j].pt.k[k].s){
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                            }
                            if(maskProps[j].pt.k[k].e){
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                            }
                        }
                    }
                }
            }
            if(layerData.ty===0){
                layerData.layers = findCompLayers(layerData.refId, comps);
                completeLayers(layerData.layers,comps, fontManager);
            }else if(layerData.ty === 4){
                completeShapes(layerData.shapes);
            }else if(layerData.ty == 5){
                completeText(layerData, fontManager);
            }
        }
    }

    function findCompLayers(id,comps){
        var i = 0, len = comps.length;
        while(i<len){
            if(comps[i].id === id){
                return comps[i].layers;
            }
            i += 1;
        }
    }

    function completeShapes(arr){
        var i, len = arr.length;
        var j, jLen;
        var hasPaths = false;
        for(i=len-1;i>=0;i-=1){
            if(arr[i].ty == 'sh'){
                if(arr[i].ks.k.i){
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                }else{
                    jLen = arr[i].ks.k.length;
                    for(j=0;j<jLen;j+=1){
                        if(arr[i].ks.k[j].s){
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                        }
                        if(arr[i].ks.k[j].e){
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                        }
                    }
                }
                hasPaths = true;
            }else if(arr[i].ty == 'gr'){
                completeShapes(arr[i].it);
            }
        }
        /*if(hasPaths){
            //mx: distance
            //ss: sensitivity
            //dc: decay
            arr.splice(arr.length-1,0,{
                "ty": "ms",
                "mx":20,
                "ss":10,
                 "dc":0.001,
                "maxDist":200
            });
        }*/
    }

    function convertPathsToAbsoluteValues(path){
        var i, len = path.i.length;
        for(i=0;i<len;i+=1){
            path.i[i][0] += path.v[i][0];
            path.i[i][1] += path.v[i][1];
            path.o[i][0] += path.v[i][0];
            path.o[i][1] += path.v[i][1];
        }
    }

    function checkVersion(minimum,animVersionString){
        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
        if(minimum[0]>animVersion[0]){
            return true;
        } else if(animVersion[0] > minimum[0]){
            return false;
        }
        if(minimum[1]>animVersion[1]){
            return true;
        } else if(animVersion[1] > minimum[1]){
            return false;
        }
        if(minimum[2]>animVersion[2]){
            return true;
        } else if(animVersion[2] > minimum[2]){
            return false;
        }
    }

    var checkText = (function(){
        var minimumVersion = [4,4,14];

        function updateTextLayer(textLayer){
            var documentData = textLayer.t.d;
            textLayer.t.d = {
                k: [
                    {
                        s:documentData,
                        t:0
                    }
                ]
            }
        }

        function iterateLayers(layers){
            var i, len = layers.length;
            for(i=0;i<len;i+=1){
                if(layers[i].ty === 5){
                    updateTextLayer(layers[i]);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }())

    var checkColors = (function(){
        var minimumVersion = [4,1,9];

        function iterateShapes(shapes){
            var i, len = shapes.length;
            var j, jLen;
            for(i=0;i<len;i+=1){
                if(shapes[i].ty === 'gr'){
                    iterateShapes(shapes[i].it);
                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
                    if(shapes[i].c.k && shapes[i].c.k[0].i){
                        jLen = shapes[i].c.k.length;
                        for(j=0;j<jLen;j+=1){
                            if(shapes[i].c.k[j].s){
                                shapes[i].c.k[j].s[0] /= 255;
                                shapes[i].c.k[j].s[1] /= 255;
                                shapes[i].c.k[j].s[2] /= 255;
                                shapes[i].c.k[j].s[3] /= 255;
                            }
                            if(shapes[i].c.k[j].e){
                                shapes[i].c.k[j].e[0] /= 255;
                                shapes[i].c.k[j].e[1] /= 255;
                                shapes[i].c.k[j].e[2] /= 255;
                                shapes[i].c.k[j].e[3] /= 255;
                            }
                        }
                    } else {
                        shapes[i].c.k[0] /= 255;
                        shapes[i].c.k[1] /= 255;
                        shapes[i].c.k[2] /= 255;
                        shapes[i].c.k[3] /= 255;
                    }
                }
            }
        }

        function iterateLayers(layers){
            var i, len = layers.length;
            for(i=0;i<len;i+=1){
                if(layers[i].ty === 4){
                    iterateShapes(layers[i].shapes);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }());

    var checkShapes = (function(){
        var minimumVersion = [4,4,18];



        function completeShapes(arr){
            var i, len = arr.length;
            var j, jLen;
            var hasPaths = false;
            for(i=len-1;i>=0;i-=1){
                if(arr[i].ty == 'sh'){
                    if(arr[i].ks.k.i){
                        arr[i].ks.k.c = arr[i].closed;
                    }else{
                        jLen = arr[i].ks.k.length;
                        for(j=0;j<jLen;j+=1){
                            if(arr[i].ks.k[j].s){
                                arr[i].ks.k[j].s[0].c = arr[i].closed;
                            }
                            if(arr[i].ks.k[j].e){
                                arr[i].ks.k[j].e[0].c = arr[i].closed;
                            }
                        }
                    }
                    hasPaths = true;
                }else if(arr[i].ty == 'gr'){
                    completeShapes(arr[i].it);
                }
            }
        }

        function iterateLayers(layers){
            var layerData;
            var i, len = layers.length;
            var j, jLen, k, kLen;
            for(i=0;i<len;i+=1){
                layerData = layers[i];
                if(layerData.hasMask){
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;
                    for(j=0;j<jLen;j+=1){
                        if(maskProps[j].pt.k.i){
                            maskProps[j].pt.k.c = maskProps[j].cl;
                        }else{
                            kLen = maskProps[j].pt.k.length;
                            for(k=0;k<kLen;k+=1){
                                if(maskProps[j].pt.k[k].s){
                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                }
                                if(maskProps[j].pt.k[k].e){
                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                }
                            }
                        }
                    }
                }
                if(layerData.ty === 4){
                    completeShapes(layerData.shapes);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }());

    /*function blitPaths(path){
        var i, len = path.i.length;
        for(i=0;i<len;i+=1){
            path.i[i][0] /= blitter;
            path.i[i][1] /= blitter;
            path.o[i][0] /= blitter;
            path.o[i][1] /= blitter;
            path.v[i][0] /= blitter;
            path.v[i][1] /= blitter;
        }
    }

    function blitShapes(arr){
        var i, len = arr.length;
        var j, jLen;
        var hasPaths = false;
        for(i=len-1;i>=0;i-=1){
            if(arr[i].ty == 'sh'){
                if(arr[i].ks.k.i){
                    blitPaths(arr[i].ks.k);
                }else{
                    jLen = arr[i].ks.k.length;
                    for(j=0;j<jLen;j+=1){
                        if(arr[i].ks.k[j].s){
                            blitPaths(arr[i].ks.k[j].s[0]);
                        }
                        if(arr[i].ks.k[j].e){
                            blitPaths(arr[i].ks.k[j].e[0]);
                        }
                    }
                }
                hasPaths = true;
            }else if(arr[i].ty == 'gr'){
                blitShapes(arr[i].it);
            }else if(arr[i].ty == 'rc'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].s);
            }else if(arr[i].ty == 'st'){
                blitProperty(arr[i].w);
            }else if(arr[i].ty == 'tr'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].sk);
                blitProperty(arr[i].a);
            }else if(arr[i].ty == 'el'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].s);
            }else if(arr[i].ty == 'rd'){
                blitProperty(arr[i].r);
            }else{

                //console.log(arr[i].ty );
            }
        }
    }

    function blitText(data, fontManager){

    }

    function blitValue(val){
        if(typeof(val) === 'number'){
            val /= blitter;
        } else {
            var i = val.length-1;
            while(i>=0){
                val[i] /= blitter;
                i-=1;
            }
        }
        return val;
    }

    function blitProperty(data){
        if(!data.k.length){
            data.k = blitValue(data.k);
        }else if(typeof(data.k[0]) === 'number'){
            data.k = blitValue(data.k);
        } else {
            var i, len = data.k.length;
            for(i=0;i<len;i+=1){
                if(data.k[i].s){
                    //console.log('pre S: ', data.k[i].s);
                    data.k[i].s = blitValue(data.k[i].s);
                    //console.log('post S: ', data.k[i].s);
                }
                if(data.k[i].e){
                    //console.log('pre E: ', data.k[i].e);
                    data.k[i].e = blitValue(data.k[i].e);
                    //console.log('post E: ', data.k[i].e);
                }
            }
        }
    }

    function blitLayers(layers,comps, fontManager){
        var layerData;
        var animArray, lastFrame;
        var i, len = layers.length;
        var j, jLen, k, kLen;
        for(i=0;i<len;i+=1){
            layerData = layers[i];
            if(!('ks' in layerData)){
                continue;
            }
            blitProperty(layerData.ks.a);
            blitProperty(layerData.ks.p);
            layerData.completed = true;
            if(layerData.tt){
                layers[i-1].td = layerData.tt;
            }
            animArray = [];
            lastFrame = -1;
            if(layerData.hasMask){
                var maskProps = layerData.masksProperties;
                jLen = maskProps.length;
                for(j=0;j<jLen;j+=1){
                    if(maskProps[j].pt.k.i){
                        blitPaths(maskProps[j].pt.k);
                    }else{
                        kLen = maskProps[j].pt.k.length;
                        for(k=0;k<kLen;k+=1){
                            if(maskProps[j].pt.k[k].s){
                                blitPaths(maskProps[j].pt.k[k].s[0]);
                            }
                            if(maskProps[j].pt.k[k].e){
                                blitPaths(maskProps[j].pt.k[k].e[0]);
                            }
                        }
                    }
                }
            }
            if(layerData.ty===0){
                layerData.w = Math.round(layerData.w/blitter);
                layerData.h = Math.round(layerData.h/blitter);
                blitLayers(layerData.layers,comps, fontManager);
            }else if(layerData.ty === 4){
                blitShapes(layerData.shapes);
            }else if(layerData.ty == 5){
                blitText(layerData, fontManager);
            }else if(layerData.ty == 1){
                layerData.sh /= blitter;
                layerData.sw /= blitter;
            } else {
            }
        }
    }

    function blitAnimation(animationData,comps, fontManager){
        blitLayers(animationData.layers,comps, fontManager);
    }*/

    function completeData(animationData, fontManager){
        if(animationData.__complete){
            return;
        }
        checkColors(animationData);
        checkText(animationData);
        checkShapes(animationData);
        completeLayers(animationData.layers, animationData.assets, fontManager);
        animationData.__complete = true;
        //blitAnimation(animationData, animationData.assets, fontManager);
    }

    function completeText(data, fontManager){
        var letters;
        var keys = data.t.d.k;
        var k, kLen = keys.length;
        for(k=0;k<kLen;k+=1){
            var documentData = data.t.d.k[k].s;
            letters = [];
            var i, len;
            var newLineFlag, index = 0, val;
            var anchorGrouping = data.t.m.g;
            var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
            var lineWidth = 0;
            var maxLineWidth = 0;
            var j, jLen;
            var fontData = fontManager.getFontByName(documentData.f);
            var charData, cLength = 0;
            var styles = fontData.fStyle.split(' ');

            var fWeight = 'normal', fStyle = 'normal';
            len = styles.length;
            for(i=0;i<len;i+=1){
                if (styles[i].toLowerCase() === 'italic') {
                    fStyle = 'italic';
                }else if (styles[i].toLowerCase() === 'bold') {
                    fWeight = '700';
                } else if (styles[i].toLowerCase() === 'black') {
                    fWeight = '900';
                } else if (styles[i].toLowerCase() === 'medium') {
                    fWeight = '500';
                } else if (styles[i].toLowerCase() === 'regular' || styles[i].toLowerCase() === 'normal') {
                    fWeight = '400';
                } else if (styles[i].toLowerCase() === 'light' || styles[i].toLowerCase() === 'thin') {
                    fWeight = '200';
                }
            }
            documentData.fWeight = fWeight;
            documentData.fStyle = fStyle;
            len = documentData.t.length;
            if(documentData.sz){
                var boxWidth = documentData.sz[0];
                var lastSpaceIndex = -1;
                for(i=0;i<len;i+=1){
                    newLineFlag = false;
                    if(documentData.t.charAt(i) === ' '){
                        lastSpaceIndex = i;
                    }else if(documentData.t.charCodeAt(i) === 13){
                        lineWidth = 0;
                        newLineFlag = true;
                    }
                    if(fontManager.chars){
                        charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
                    }else{
                        //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                        cLength = fontManager.measureText(documentData.t.charAt(i), documentData.f, documentData.s);
                    }
                    if(lineWidth + cLength > boxWidth){
                        if(lastSpaceIndex === -1){
                            //i -= 1;
                            documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i);
                            len += 1;
                        } else {
                            i = lastSpaceIndex;
                            documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i+1);
                        }
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    }else {
                        lineWidth += cLength;
                    }
                }
                len = documentData.t.length;
            }
            lineWidth = 0;
            cLength = 0;
            for (i = 0;i < len ;i += 1) {
                newLineFlag = false;
                if(documentData.t.charAt(i) === ' '){
                    val = '\u00A0';
                }else if(documentData.t.charCodeAt(i) === 13){
                    lineWidths.push(lineWidth);
                    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                    lineWidth = 0;
                    val = '';
                    newLineFlag = true;
                    currentLine += 1;
                }else{
                    val = documentData.t.charAt(i);
                }
                if(fontManager.chars){
                    charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                    cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
                }else{
                    //var charWidth = fontManager.measureText(val, documentData.f, documentData.s);
                    //tCanvasHelper.font = documentData.s + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
                    cLength = fontManager.measureText(val, documentData.f, documentData.s);
                }

                //
                lineWidth += cLength;
                letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine});
                if(anchorGrouping == 2){
                    currentSize += cLength;
                    if(val == '' || val == '\u00A0' || i == len - 1){
                        if(val == '' || val == '\u00A0'){
                            currentSize -= cLength;
                        }
                        while(currentPos<=i){
                            letters[currentPos].an = currentSize;
                            letters[currentPos].ind = index;
                            letters[currentPos].extra = cLength;
                            currentPos += 1;
                        }
                        index += 1;
                        currentSize = 0;
                    }
                }else if(anchorGrouping == 3){
                    currentSize += cLength;
                    if(val == '' || i == len - 1){
                        if(val == ''){
                            currentSize -= cLength;
                        }
                        while(currentPos<=i){
                            letters[currentPos].an = currentSize;
                            letters[currentPos].ind = index;
                            letters[currentPos].extra = cLength;
                            currentPos += 1;
                        }
                        currentSize = 0;
                        index += 1;
                    }
                }else{
                    letters[index].ind = index;
                    letters[index].extra = 0;
                    index += 1;
                }
            }
            documentData.l = letters;
            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
            lineWidths.push(lineWidth);
            if(documentData.sz){
                documentData.boxWidth = documentData.sz[0];
                documentData.justifyOffset = 0;
            }else{
                documentData.boxWidth = maxLineWidth;
                switch(documentData.j){
                    case 1:
                        documentData.justifyOffset = - documentData.boxWidth;
                        break;
                    case 2:
                        documentData.justifyOffset = - documentData.boxWidth/2;
                        break;
                    default:
                        documentData.justifyOffset = 0;
                }
            }
            documentData.lineWidths = lineWidths;

            var animators = data.t.a;
            jLen = animators.length;
            var based, ind, indexes = [];
            for(j=0;j<jLen;j+=1){
                if(animators[j].a.sc){
                    documentData.strokeColorAnim = true;
                }
                if(animators[j].a.sw){
                    documentData.strokeWidthAnim = true;
                }
                if(animators[j].a.fc || animators[j].a.fh || animators[j].a.fs || animators[j].a.fb){
                    documentData.fillColorAnim = true;
                }
                ind = 0;
                based = animators[j].s.b;
                for(i=0;i<len;i+=1){
                    letters[i].anIndexes[j] = ind;
                    if((based == 1 && letters[i].val != '') || (based == 2 && letters[i].val != '' && letters[i].val != '\u00A0') || (based == 3 && (letters[i].n || letters[i].val == '\u00A0' || i == len - 1)) || (based == 4 && (letters[i].n || i == len - 1))){
                        if(animators[j].s.rn === 1){
                            indexes.push(ind);
                        }
                        ind += 1;
                    }
                }
                data.t.a[j].s.totalChars = ind;
                var currentInd = -1, newInd;
                if(animators[j].s.rn === 1){
                    for(i = 0; i < len; i += 1){
                        if(currentInd != letters[i].anIndexes[j]){
                            currentInd = letters[i].anIndexes[j];
                            newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
                        }
                        letters[i].anIndexes[j] = newInd;
                    }
                }
            }
            if(jLen === 0 && !('m' in data.t.p)){
                data.singleShape = true;
            }
            documentData.yOffset = documentData.lh || documentData.s*1.2;
            documentData.ls = documentData.ls || 0;
            documentData.ascent = fontData.ascent*documentData.s/100;
        }

    }

    var moduleOb = {};
    moduleOb.completeData = completeData;

    return moduleOb;
}

var dataManager = dataFunctionManager();
var FontManager = (function(){

    var maxWaitingTime = 5000;

    function setUpNode(font, family){
        var parentNode = document.createElement('span');
        parentNode.style.fontFamily    = family;
        var node = document.createElement('span');
        // Characters that vary significantly among different fonts
        node.innerHTML = 'giItT1WQy@!-/#';
        // Visible - so we can measure it - but not on the screen
        parentNode.style.position      = 'absolute';
        parentNode.style.left          = '-10000px';
        parentNode.style.top           = '-10000px';
        // Large font size makes even subtle changes obvious
        parentNode.style.fontSize      = '300px';
        // Reset any font properties
        parentNode.style.fontVariant   = 'normal';
        parentNode.style.fontStyle     = 'normal';
        parentNode.style.fontWeight    = 'normal';
        parentNode.style.letterSpacing = '0';
        parentNode.appendChild(node);
        document.body.appendChild(parentNode);

        // Remember width with no applied web font
        var width = node.offsetWidth;
        node.style.fontFamily = font + ', '+family;
        return {node:node, w:width, parent:parentNode};
    }

    function checkLoadedFonts() {
        var i, len = this.fonts.length;
        var node, w;
        var loadedCount = len;
        for(i=0;i<len; i+= 1){
            if(this.fonts[i].loaded){
                loadedCount -= 1;
                continue;
            }
            if(this.fonts[i].fOrigin === 't'){
                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
                    this.typekitLoaded = 1;
                    try{window.Typekit.load({
                        async: true,
                        active: function() {
                            this.typekitLoaded = 2;
                        }.bind(this)
                    });}catch(e){}
                }
                if(this.typekitLoaded === 2) {
                    this.fonts[i].loaded = true;
                }
            } else if(this.fonts[i].fOrigin === 'n'){
                this.fonts[i].loaded = true;
            } else{
                node = this.fonts[i].monoCase.node;
                w = this.fonts[i].monoCase.w;
                if(node.offsetWidth !== w){
                    loadedCount -= 1;
                    this.fonts[i].loaded = true;
                }else{
                    node = this.fonts[i].sansCase.node;
                    w = this.fonts[i].sansCase.w;
                    if(node.offsetWidth !== w){
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    }
                }
                if(this.fonts[i].loaded){
                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                }
            }
        }

        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
            setTimeout(checkLoadedFonts.bind(this),20);
        }else{
            setTimeout(function(){this.loaded = true;}.bind(this),0);

        }
    };

    function createHelper(def, fontData){
        var tHelper = document.createElementNS(svgNS,'text');
        tHelper.style.fontSize = '100px';
        tHelper.style.fontFamily = fontData.fFamily;
        tHelper.textContent = '1';
        if(fontData.fClass){
            tHelper.style.fontFamily = 'inherit';
            tHelper.className = fontData.fClass;
        } else {
            tHelper.style.fontFamily = fontData.fFamily;
        }
        def.appendChild(tHelper);
        var tCanvasHelper = document.createElement('canvas').getContext('2d');
        tCanvasHelper.font = '100px '+ fontData.fFamily;
        return tCanvasHelper;
        return tHelper;
    }

    function addFonts(fontData, defs){
        if(!fontData){
            this.loaded = true;
            return;
        }
        if(this.chars){
            this.loaded = true;
            this.fonts = fontData.list;
            return;
        }

        var fontArr = fontData.list;
        var i, len = fontArr.length;
        for(i=0; i<len; i+= 1){
            fontArr[i].loaded = false;
            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
            if(!fontArr[i].fPath) {
                fontArr[i].loaded = true;
            }else if(fontArr[i].fOrigin === 'p'){
                var s = document.createElement('style');
                s.type = "text/css";
                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
                defs.appendChild(s);
            } else if(fontArr[i].fOrigin === 'g'){
                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
                var l = document.createElement('link');
                l.type = "text/css";
                l.rel = "stylesheet";
                l.href = fontArr[i].fPath;
                defs.appendChild(l);
            } else if(fontArr[i].fOrigin === 't'){
                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
                var sc = document.createElement('script');
                sc.setAttribute('src',fontArr[i].fPath);
                defs.appendChild(sc);
            }
            fontArr[i].helper = createHelper(defs,fontArr[i]);
            this.fonts.push(fontArr[i]);
        }
        checkLoadedFonts.bind(this)();
    }

    function addChars(chars){
        if(!chars){
            return;
        }
        if(!this.chars){
            this.chars = [];
        }
        var i, len = chars.length;
        var j, jLen = this.chars.length, found;
        for(i=0;i<len;i+=1){
            j = 0;
            found = false;
            while(j<jLen){
                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
                    found = true;
                }
                j += 1;
            }
            if(!found){
                this.chars.push(chars[i]);
                jLen += 1;
            }
        }
    }

    function getCharData(char, style, font){
        var i = 0, len = this.chars.length;
        while( i < len) {
            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
                return this.chars[i];
            }
            i+= 1;
        }
    }

    function measureText(char, fontName, size){
        var fontData = this.getFontByName(fontName);
        var tHelper = fontData.helper;
        //tHelper.textContent = char;
        return tHelper.measureText(char).width*size/100;
        //return tHelper.getComputedTextLength()*size/100;
    }

    function getFontByName(name){
        var i = 0, len = this.fonts.length;
        while(i<len){
            if(this.fonts[i].fName === name) {
                return this.fonts[i];
            }
            i += 1;
        }
        return 'sans-serif';
    }

    var Font = function(){
        this.fonts = [];
        this.chars = null;
        this.typekitLoaded = 0;
        this.loaded = false;
        this.initTime = Date.now();
    };
    Font.prototype.addChars = addChars;
    Font.prototype.addFonts = addFonts;
    Font.prototype.getCharData = getCharData;
    Font.prototype.getFontByName = getFontByName;
    Font.prototype.measureText = measureText;

    return Font;

}());
var PropertyFactory = (function(){

    var initFrame = -999999;

    function getValue(){
        if(this.elem.globalData.frameId === this.frameId){
            return;
        }
        this.mdf = false;
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        if(!(frameNum === this.lastFrame || (this.lastFrame !== initFrame && ((this.lastFrame >= this.keyframes[this.keyframes.length- 1].t-this.offsetTime && frameNum >= this.keyframes[this.keyframes.length- 1].t-this.offsetTime) || (this.lastFrame < this.keyframes[0].t-this.offsetTime && frameNum < this.keyframes[0].t-this.offsetTime))))){
            var i = this.lastFrame < frameNum ? this._lastIndex : 0;
            var len = this.keyframes.length- 1,flag = true;
            var keyData, nextKeyData;

            while(flag){
                keyData = this.keyframes[i];
                nextKeyData = this.keyframes[i+1];
                if(i == len-1 && frameNum >= nextKeyData.t - this.offsetTime){
                    if(keyData.h){
                        keyData = nextKeyData;
                    }
                    break;
                }
                if((nextKeyData.t - this.offsetTime) > frameNum){
                    break;
                }
                if(i < len - 1){
                    i += 1;
                }else{
                    flag = false;
                }
            }

            this._lastIndex = i;

            var k, kLen,perc,jLen, j, fnc;
            if(keyData.to){

                if(!keyData.bezierData){
                    bez.buildBezierData(keyData);
                }
                var bezierData = keyData.bezierData;
                if(frameNum >= nextKeyData.t-this.offsetTime || frameNum < keyData.t-this.offsetTime){
                    var ind = frameNum >= nextKeyData.t-this.offsetTime ? bezierData.points.length - 1 : 0;
                    kLen = bezierData.points[ind].point.length;
                    for(k = 0; k < kLen; k += 1){
                        this.pv[k] = bezierData.points[ind].point[k];
                        this.v[k] = this.mult ? this.pv[k]*this.mult : this.pv[k];
                        if(this.lastPValue[k] !== this.pv[k]) {
                            this.mdf = true;
                            this.lastPValue[k] = this.pv[k];
                        }
                    }
                    this._lastBezierData = null;
                }else{
                    if(keyData.__fnct){
                        fnc = keyData.__fnct;
                    }else{
                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
                        keyData.__fnct = fnc;
                    }
                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                    var distanceInLine = bezierData.segmentLength*perc;

                    var segmentPerc;
                    var addedLength =  (this.lastFrame < frameNum && this._lastBezierData === bezierData) ? this._lastAddedLength : 0;
                    j =  (this.lastFrame < frameNum && this._lastBezierData === bezierData) ? this._lastPoint : 0;
                    flag = true;
                    jLen = bezierData.points.length;
                    while(flag){
                        addedLength +=bezierData.points[j].partialLength;
                        if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
                            kLen = bezierData.points[j].point.length;
                            for(k=0;k<kLen;k+=1){
                                this.pv[k] = bezierData.points[j].point[k];
                                this.v[k] = this.mult ? this.pv[k]*this.mult : this.pv[k];
                                if(this.lastPValue[k] !== this.pv[k]) {
                                    this.mdf = true;
                                    this.lastPValue[k] = this.pv[k];
                                }
                            }
                            break;
                        }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
                            segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
                            kLen = bezierData.points[j].point.length;
                            for(k=0;k<kLen;k+=1){
                                this.pv[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
                                this.v[k] = this.mult ? this.pv[k] * this.mult : this.pv[k];
                                if(this.lastPValue[k] !== this.pv[k]) {
                                    this.mdf = true;
                                    this.lastPValue[k] = this.pv[k];
                                }
                            }
                            break;
                        }
                        if(j < jLen - 1){
                            j += 1;
                        }else{
                            flag = false;
                        }
                    }
                    this._lastPoint = j;
                    this._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                    this._lastBezierData = bezierData;
                }
            }else{
                var outX,outY,inX,inY, keyValue;
                len = keyData.s.length;
                for(i=0;i<len;i+=1){
                    if(keyData.h !== 1){
                        if(frameNum >= nextKeyData.t-this.offsetTime){
                            perc = 1;
                        }else if(frameNum < keyData.t-this.offsetTime){
                            perc = 0;
                        }else{
                            if(keyData.o.x instanceof Array){
                                if(!keyData.__fnct){
                                    keyData.__fnct = [];
                                }
                                if (!keyData.__fnct[i]) {
                                    outX = keyData.o.x[i] || keyData.o.x[0];
                                    outY = keyData.o.y[i] || keyData.o.y[0];
                                    inX = keyData.i.x[i] || keyData.i.x[0];
                                    inY = keyData.i.y[i] || keyData.i.y[0];
                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                                    keyData.__fnct[i] = fnc;
                                } else {
                                    fnc = keyData.__fnct[i];
                                }
                            } else {
                                if (!keyData.__fnct) {
                                    outX = keyData.o.x;
                                    outY = keyData.o.y;
                                    inX = keyData.i.x;
                                    inY = keyData.i.y;
                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                                    keyData.__fnct = fnc;
                                } else{
                                    fnc = keyData.__fnct;
                                }
                            }
                            perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                        }
                    }
                    if(this.sh && keyData.h !== 1){
                        var initP = keyData.s[i];
                        var endP = keyData.e[i];
                        if(initP-endP < -180){
                            initP += 360;
                        } else if(initP-endP > 180){
                            initP -= 360;
                        }
                        keyValue = initP+(endP-initP)*perc;
                    } else {
                        keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
                    }
                    if(len === 1){
                        this.v = this.mult ? keyValue*this.mult : keyValue;
                        this.pv = keyValue;
                        if(this.lastPValue != this.pv){
                            this.mdf = true;
                            this.lastPValue = this.pv;
                        }
                    }else{
                        this.v[i] = this.mult ? keyValue*this.mult : keyValue;
                        this.pv[i] = keyValue;
                        if(this.lastPValue[i] !== this.pv[i]){
                            this.mdf = true;
                            this.lastPValue[i] = this.pv[i];
                        }
                    }
                }
            }
        }
        this.lastFrame = frameNum;
        this.frameId = this.elem.globalData.frameId;
    }

    function getNoValue(){}

    function ValueProperty(elem,data, mult){
        this.mult = mult;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this.mdf = false;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.getValue = getNoValue;
    }

    function MultiDimensionalProperty(elem,data, mult){
        this.mult = mult;
        this.data = data;
        this.mdf = false;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        this.v = Array.apply(null, {length:data.k.length});
        this.pv = Array.apply(null, {length:data.k.length});
        this.lastValue = Array.apply(null, {length:data.k.length});
        var arr = Array.apply(null, {length:data.k.length});
        this.vel = arr.map(function () { return 0 });
        var i, len = data.k.length;
        for(i = 0;i<len;i+=1){
            this.v[i] = mult ? data.k[i] * mult : data.k[i];
            this.pv[i] = data.k[i];
        }
        this.getValue = getNoValue;
    }

    function KeyframedValueProperty(elem, data, mult){
        this.keyframes = data.k;
        this.offsetTime = elem.data.st;
        this.lastValue = -99999;
        this.lastPValue = -99999;
        this.frameId = -1;
        this._lastIndex = 0;
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult;
        this.elem = elem;
        this.comp = elem.comp;
        this.lastFrame = initFrame;
        this.v = mult ? data.k[0].s[0]*mult : data.k[0].s[0];
        this.pv = data.k[0].s[0];
        this.getValue = getValue;
    }

    function KeyframedMultidimensionalProperty(elem, data, mult){
        var i, len = data.k.length;
        var s, e,to,ti;
        for(i=0;i<len-1;i+=1){
            if(data.k[i].to && data.k[i].s && data.k[i].e ){
                s = data.k[i].s;
                e = data.k[i].e;
                to = data.k[i].to;
                ti = data.k[i].ti;
                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.keyframes = data.k;
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this.mult = mult;
        this.elem = elem;
        this.comp = elem.comp;
        this.getValue = getValue;
        this.frameId = -1;
        this._lastIndex = 0;
        this.v = Array.apply(null, {length:data.k[0].s.length});
        this.pv = Array.apply(null, {length:data.k[0].s.length});
        this.lastValue = Array.apply(null, {length:data.k[0].s.length});
        this.lastPValue = Array.apply(null, {length:data.k[0].s.length});
        this.lastFrame = initFrame;
    }

    var TransformProperty = (function() {
        function positionGetter() {
            return ExpressionValue(this.p);
        }
        function xPositionGetter() {
            return ExpressionValue(this.px);
        }
        function yPositionGetter() {
            return ExpressionValue(this.py);
        }
        function zPositionGetter() {
            return ExpressionValue(this.pz);
        }
        function anchorGetter() {
            return ExpressionValue(this.a);
        }
        function orientationGetter() {
            return ExpressionValue(this.or);
        }
        function rotationGetter() {
            return ExpressionValue(this.r, 1/degToRads);
        }
        function scaleGetter() {
            return ExpressionValue(this.s, 100);
        }
        function opacityGetter() {
            return ExpressionValue(this.o, 100);
        }
        function skewGetter() {
            return ExpressionValue(this.sk);
        }
        function skewAxisGetter() {
            return ExpressionValue(this.sa);
        }
        function applyToMatrix(mat) {
            var i, len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1) {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i].mdf) {
                    this.mdf = true;
                }
            }
            if (this.a) {
                mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            }
            if (this.s) {
                mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            }
            if (this.r) {
                mat.rotate(-this.r.v);
            } else {
                mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            }
            if (this.data.p.s) {
                if (this.data.p.z) {
                    mat.translate(this.px.v, this.py.v, -this.pz.v);
                } else {
                    mat.translate(this.px.v, this.py.v, 0);
                }
            } else {
                mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
        }
        function processKeys(){
            if (this.elem.globalData.frameId === this.frameId) {
                return;
            }

            this.mdf = false;
            var i, len = this.dynamicProperties.length;

            for(i = 0; i < len; i += 1) {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i].mdf) {
                    this.mdf = true;
                }
            }
            if (this.mdf) {
                this.v.reset();
                if (this.a) {
                    this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                }
                if(this.s) {
                    this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                }
                if (this.sk) {
                    this.v.skewFromAxis(-this.sk.v, this.sa.v);
                }
                if (this.r) {
                    this.v.rotate(-this.r.v);
                } else {
                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                }
                if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
                    var v1,v2;
                    if (this.p.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
                    } else if(this.p.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
                    } else {
                        v1 = this.p.pv;
                        v2 = this.p.getValueAtTime((this.p.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if(this.data.p.s){
                    if(this.data.p.z) {
                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    } else {
                        this.v.translate(this.px.v, this.py.v, 0);
                    }
                }else{
                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
            }
            //console.log(this.v.to2dCSS())
            this.frameId = this.elem.globalData.frameId;
        }

        function setInverted(){
            this.inverted = true;
            this.iv = new Matrix();
            if(!this.k){
                if(this.data.p.s){
                    this.iv.translate(this.px.v,this.py.v,-this.pz.v);
                }else{
                    this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
                if(this.r){
                    this.iv.rotate(-this.r.v);
                }else{
                    this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
                }
                if(this.s){
                    this.iv.scale(this.s.v[0],this.s.v[1],1);
                }
                if(this.a){
                    this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
                }
            }
        }

        function autoOrient(){
            //
            //var prevP = this.getValueAtTime();
        }

        return function TransformProperty(elem,data,arr){
            this.elem = elem;
            this.frameId = -1;
            this.type = 'transform';
            this.dynamicProperties = [];
            this.mdf = false;
            this.data = data;
            this.getValue = processKeys;
            this.applyToMatrix = applyToMatrix;
            this.setInverted = setInverted;
            this.autoOrient = autoOrient;
            this.v = new Matrix();
            if(data.p.s){
                this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this.dynamicProperties);
                this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this.dynamicProperties);
                if(data.p.z){
                    this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this.dynamicProperties);
                }
            }else{
                this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            }
            if(data.r) {
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this.dynamicProperties);
            } else if(data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this.dynamicProperties);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this.dynamicProperties);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this.dynamicProperties);
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this.dynamicProperties);
            }
            if(data.sk){
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this.dynamicProperties);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this.dynamicProperties);
            }
            if(data.a) {
                this.a = PropertyFactory.getProp(elem,data.a,1,0,this.dynamicProperties);
            }
            if(data.s) {
                this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this.dynamicProperties);
            }
            if(data.o){
                this.o = PropertyFactory.getProp(elem,data.o,0,0.01,arr);
            } else {
                this.o = {mdf:false,v:1};
            }
            if(this.dynamicProperties.length){
                arr.push(this);
            }else{
                if(this.a){
                    this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
                }
                if(this.s){
                    this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);
                }
                if(this.sk){
                    this.v.skewFromAxis(-this.sk.v,this.sa.v);
                }
                if(this.r){
                    this.v.rotate(-this.r.v);
                }else{
                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                }
                if(this.data.p.s){
                    if(data.p.z) {
                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    } else {
                        this.v.translate(this.px.v, this.py.v, 0);
                    }
                }else{
                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
            }
            Object.defineProperty(this, "position", { get: positionGetter});
            Object.defineProperty(this, "xPosition", { get: xPositionGetter});
            Object.defineProperty(this, "yPosition", { get: yPositionGetter});
            Object.defineProperty(this, "orientation", { get: orientationGetter});
            Object.defineProperty(this, "anchorPoint", { get: anchorGetter});
            Object.defineProperty(this, "rotation", { get: rotationGetter});
            Object.defineProperty(this, "scale", { get: scaleGetter});
            Object.defineProperty(this, "opacity", { get: opacityGetter});
            Object.defineProperty(this, "skew", { get: skewGetter});
            Object.defineProperty(this, "skewAxis", { get: skewAxisGetter});
        }
    }());

    function getProp(elem,data,type, mult, arr) {
        var p;
        if(type === 2){
            p = new TransformProperty(elem, data, arr);
        } else if(data.a === 0){
            if(type === 0) {
                p = new ValueProperty(elem,data,mult);
            } else {
                p = new MultiDimensionalProperty(elem,data, mult);
            }
        } else if(data.a === 1){
            if(type === 0) {
                p = new KeyframedValueProperty(elem,data,mult);
            } else {
                p = new KeyframedMultidimensionalProperty(elem,data, mult);
            }
        } else if(!data.k.length){
            p = new ValueProperty(elem,data, mult);
        }else if(typeof(data.k[0]) === 'number'){
            p = new MultiDimensionalProperty(elem,data, mult);
        }else{
            switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem,data,mult);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem,data,mult);
                    break;
            }
        }
        if(p.k){
            arr.push(p);
        }
        return p;
    }

    var getGradientProp = (function(){

        function getValue(forceRender){
            this.prop.getValue();
            this.cmdf = false;
            this.omdf = false;
            if(this.prop.mdf || forceRender){
                var i, len = this.data.p*4;
                var mult, val;
                for(i=0;i<len;i+=1){
                    mult = i%4 === 0 ? 100 : 255;
                    val = Math.round(this.prop.v[i]*mult);
                    if(this.c[i] !== val){
                        this.c[i] = val;
                        this.cmdf = true;
                    }
                }
                if(this.o.length){
                    len = this.prop.v.length;
                    for(i=this.data.p*4;i<len;i+=1){
                        mult = i%2 === 0 ? 100 : 1;
                        val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
                        if(this.o[i-this.data.p*4] !== val){
                            this.o[i-this.data.p*4] = val;
                            this.omdf = true;
                        }
                    }
                }
            }

        }

        function gradientProp(elem,data,arr){
            this.prop = getProp(elem,data.k,1,null,[]);
            this.data = data;
            this.k = this.prop.k;
            this.c = Array.apply(null,{length:data.p*4});
            var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
            this.o = Array.apply(null,{length:cLength});
            this.cmdf = false;
            this.omdf = false;
            this.getValue = getValue;
            if(this.prop.k){
                arr.push(this);
            }
            this.getValue(true);
        }

        return function getGradientProp(elem,data,arr){
            return new gradientProp(elem,data,arr);
        }
    }());




    var DashProperty = (function(){

        function processKeys(forceRender){
            var i = 0, len = this.dataProps.length;

            if(this.elem.globalData.frameId === this.frameId && !forceRender){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            while(i<len){
                if(this.dataProps[i].p.mdf){
                    this.mdf = true;
                    break;
                }
                i+=1;
            }
            if(this.mdf || forceRender){
                if(this.renderer === 'svg') {
                    this.dasharray = '';
                }
                for(i=0;i<len;i+=1){
                    if(this.dataProps[i].n != 'o'){
                        if(this.renderer === 'svg') {
                            this.dasharray += ' ' + this.dataProps[i].p.v;
                        }else{
                            this.dasharray[i] = this.dataProps[i].p.v;
                        }
                    }else{
                        this.dashoffset = this.dataProps[i].p.v;
                    }
                }
            }
        }

        return function(elem, data,renderer, dynamicProperties){
            this.elem = elem;
            this.frameId = -1;
            this.dataProps = new Array(data.length);
            this.renderer = renderer;
            this.mdf = false;
            this.k = false;
            if(this.renderer === 'svg'){
                this.dasharray = '';
            }else{

                this.dasharray = new Array(data.length - 1);
            }
            this.dashoffset = 0;
            var i, len = data.length, prop;
            for(i=0;i<len;i+=1){
                prop = PropertyFactory.getProp(elem,data[i].v,0, 0, dynamicProperties);
                this.k = prop.k ? true : this.k;
                this.dataProps[i] = {n:data[i].n,p:prop};
            }
            this.getValue = processKeys;
            if(this.k){
                dynamicProperties.push(this);
            }else{
                this.getValue(true);
            }

        }
    }());

    function getDashProp(elem, data,renderer, dynamicProperties) {
        return new DashProperty(elem, data,renderer, dynamicProperties);
    };

    var TextSelectorProp = (function(){
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function updateRange(){
            if(this.dynamicProperties.length){
                var i, len = this.dynamicProperties.length;
                for(i=0;i<len;i+=1){
                    this.dynamicProperties[i].getValue();
                    if(this.dynamicProperties[i].mdf){
                        this.mdf = true;
                    }
                }
            }
            var totalChars = this.data.totalChars;
            var divisor = this.data.r === 2 ? 1 : 100/totalChars;
            var o = this.o.v/divisor;
            var s = this.s.v/divisor + o;
            var e = (this.e.v/divisor) + o;
            if(s>e){
                var _s = s;
                s = e;
                e = _s;
            }
            this.finalS = s;
            this.finalE = e;
        }

        function getMult(ind){
            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
            var mult = 0;
            var s = this.finalS;
            var e = this.finalE;
            var type = this.data.sh;
            if(type == 2){
                if(e === s){
                    mult = ind >= e ? 1 : 0;
                }else{
                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                }
                mult = easer(mult);
            }else if(type == 3){
                if(e === s){
                    mult = ind >= e ? 0 : 1;
                }else{
                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                }

                mult = easer(mult);
            }else if(type == 4){
                if(e === s){
                    mult = 0;
                }else{
                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                    if(mult<.5){
                        mult *= 2;
                    }else{
                        mult = 1 - 2*(mult-0.5);
                    }
                }
                mult = easer(mult);
            }else if(type == 5){
                if(e === s){
                    mult = 0;
                }else{
                    var tot = e - s;
                    /*ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
                    ind = min(max(0,ind+0.5-s),e-s);
                    var x = -tot/2+ind;
                    var a = tot/2;
                    mult = Math.sqrt(1 - (x*x)/(a*a));
                }
                mult = easer(mult);
            }else if(type == 6){
                if(e === s){
                    mult = 0;
                }else{
                    ind = min(max(0,ind+0.5-s),e-s);
                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
                    /*
                     ind = Math.min(Math.max(s,ind),e-1);
                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
                }
                mult = easer(mult);
            }else {
                if(ind >= floor(s)){
                    if(ind-s < 0){
                        mult = 1 - (s - ind);
                    }else{
                        mult = max(0,min(e-ind,1));
                    }
                }
                mult = easer(mult);
            }
            return mult*this.a.v;
        }

        return function TextSelectorProp(elem,data, arr){
            this.mdf = false;
            this.k = false;
            this.data = data;
            this.dynamicProperties = [];
            this.getValue = updateRange;
            this.getMult = getMult;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this.dynamicProperties);
            if('e' in data){
                this.e = PropertyFactory.getProp(elem,data.e,0,0,this.dynamicProperties);
            }else{
                this.e = {v:data.r === 2 ? data.totalChars : 100};
            }
            this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this.dynamicProperties);
            this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this.dynamicProperties);
            this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this.dynamicProperties);
            this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this.dynamicProperties);
            if(this.dynamicProperties.length){
                arr.push(this);
            }else{
                this.getValue();
            }
        }
    }());

    function getTextSelectorProp(elem, data,arr) {
        return new TextSelectorProp(elem, data, arr);
    };

    var ob = {};
    ob.getProp = getProp;
    ob.getDashProp = getDashProp;
    ob.getTextSelectorProp = getTextSelectorProp;
    ob.getGradientProp = getGradientProp;
    return ob;
}());
function ShapePath(){
	this.c = false;
	this._length = 0;
	this._maxLength = 8;
	this.v = Array.apply(null,{length:this._maxLength});
	this.o = Array.apply(null,{length:this._maxLength});
	this.i = Array.apply(null,{length:this._maxLength});
};

ShapePath.prototype.setPathData = function(closed, len) {
	this.c = closed;
	while(len > this._maxLength){
		this.doubleArrayLength();
	}
	var i = 0;
	while(i < len){
		this.v[i] = point_pool.newPoint();
		this.o[i] = point_pool.newPoint();
		this.i[i] = point_pool.newPoint();
		i += 1;
	}
	this._length = len;
};

ShapePath.prototype.doubleArrayLength = function() {
	this.v = this.v.concat(Array.apply(null,{length:this._maxLength}))
	this.i = this.i.concat(Array.apply(null,{length:this._maxLength}))
	this.o = this.o.concat(Array.apply(null,{length:this._maxLength}))
	this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
	var arr;
	this._length = Math.max(this._length, pos + 1);
	if(this._length >= this._maxLength) {
		this.doubleArrayLength();
	}
	switch(type){
		case 'v':
			arr = this.v;
			break;
		case 'i':
			arr = this.i;
			break;
		case 'o':
			arr = this.o;
			break;
	}
	if(!arr[pos] || (arr[pos] && !replace)){
		arr[pos] = point_pool.newPoint();
	}
	arr[pos][0] = x;
	arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
	this.setXYAt(vX,vY,'v',pos, replace);
	this.setXYAt(oX,oY,'o',pos, replace);
	this.setXYAt(iX,iY,'i',pos, replace);
};
var ShapePropertyFactory = (function(){

    var initFrame = -999999;

    function interpolateShape() {
        if(this.elem.globalData.frameId === this.frameId){
            return;
        }
        this.mdf = false;
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        if(!((this.lastFrame !== initFrame && ((this.lastFrame < this.keyframes[0].t-this.offsetTime && frameNum < this.keyframes[0].t-this.offsetTime) || (this.lastFrame > this.keyframes[this.keyframes.length - 1].t-this.offsetTime && frameNum > this.keyframes[this.keyframes.length - 1].t-this.offsetTime))))){
            var keyPropS,keyPropE,isHold;
            if(frameNum < this.keyframes[0].t-this.offsetTime){
                keyPropS = this.keyframes[0].s[0];
                isHold = true;
                this._lastIndex = 0;
            }else if(frameNum >= this.keyframes[this.keyframes.length - 1].t-this.offsetTime){
                if(this.keyframes[this.keyframes.length - 2].h === 1){
                    keyPropS = this.keyframes[this.keyframes.length - 1].s[0];
                }else{
                    keyPropS = this.keyframes[this.keyframes.length - 2].e[0];
                }
                isHold = true;
            }else{
                var i = this.lastFrame < initFrame ? this._lastIndex : 0;
                var len = this.keyframes.length- 1,flag = true,keyData,nextKeyData, j, jLen, k, kLen;
                while(flag){
                    keyData = this.keyframes[i];
                    nextKeyData = this.keyframes[i+1];
                    if((nextKeyData.t - this.offsetTime) > frameNum){
                        break;
                    }
                    if(i < len - 1){
                        i += 1;
                    }else{
                        flag = false;
                    }
                }
                isHold = keyData.h === 1;
                this._lastIndex = i;

                var perc;
                if(!isHold){
                    if(frameNum >= nextKeyData.t-this.offsetTime){
                        perc = 1;
                    }else if(frameNum < keyData.t-this.offsetTime){
                        perc = 0;
                    }else{
                        var fnc;
                        if(keyData.__fnct){
                            fnc = keyData.__fnct;
                        }else{
                            fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
                            keyData.__fnct = fnc;
                        }
                        perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                    }
                    keyPropE = keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = this.v._length;
            kLen = keyPropS.i[0].length;
            var hasModified = false;
            var vertexValue;
            for(j=0;j<jLen;j+=1){
                for(k=0;k<kLen;k+=1){
                    if(isHold){
                        vertexValue = keyPropS.i[j][k];
                        if(this.v.i[j][k] !== vertexValue){
                            this.v.i[j][k] = vertexValue;
                            this.pv.i[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.o[j][k];
                        if(this.v.o[j][k] !== vertexValue){
                            this.v.o[j][k] = vertexValue;
                            this.pv.o[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.v[j][k];
                        if(this.v.v[j][k] !== vertexValue){
                            this.v.v[j][k] = vertexValue;
                            this.pv.v[j][k] = vertexValue;
                            hasModified = true;
                        }
                    }else{
                        vertexValue = keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
                        if(this.v.i[j][k] !== vertexValue){
                            this.v.i[j][k] = vertexValue;
                            this.pv.i[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
                        if(this.v.o[j][k] !== vertexValue){
                            this.v.o[j][k] = vertexValue;
                            this.pv.o[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
                        if(this.v.v[j][k] !== vertexValue){
                            this.v.v[j][k] = vertexValue;
                            this.pv.v[j][k] = vertexValue;
                            hasModified = true;
                        }
                    }
                }
            }
            this.mdf = hasModified;
            this.v.c = keyPropS.c;
            this.paths = this.localShapeCollection;
        }

        this.lastFrame = frameNum;
        this.frameId = this.elem.globalData.frameId;
    }

    function getShapeValue(){
        return this.v;
    }

    function resetShape(){
        this.paths = this.localShapeCollection;
        if(!this.k){
            this.mdf = false;
        }
    }

    function ShapeProperty(elem, data, type){
        this.comp = elem.comp;
        this.k = false;
        this.mdf = false;
        this.v = shape_pool.newShape();
        var pathData = type === 3 ? data.pt.k : data.ks.k;
        this.v.v = pathData.v;
        this.v.i = pathData.i;
        this.v.o = pathData.o;
        this.v.c = pathData.c;
        this.v._length = this.v.v.length;
        this.getValue = getShapeValue;
        this.pv = shape_pool.clone(this.v);
        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.reset = resetShape;
    }

    function KeyframedShapeProperty(elem,data,type){
        this.comp = elem.comp;
        this.elem = elem;
        this.offsetTime = elem.data.st;
        this._lastIndex = 0;
        this.getValue = interpolateShape;
        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
        this.k = true;
        this.kf = true;
        var i, len = this.keyframes[0].s[0].i.length;
        var jLen = this.keyframes[0].s[0].i[0].length;
        this.v = shape_pool.newShape();
        this.v.setPathData(this.keyframes[0].s[0].c, len);
        this.pv = shape_pool.clone(this.v);
        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.lastFrame = initFrame;
        this.reset = resetShape;
    }

    var EllShapeProperty = (function(){

        var cPoint = roundCorner;

        function convertEllToPath(){
            var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
            if(this.d !== 3){
                this.v.v[0][0] = p0;
                this.v.v[0][1] = p1-s1;
                this.v.v[1][0] = p0 + s0;
                this.v.v[1][1] = p1;
                this.v.v[2][0] = p0;
                this.v.v[2][1] = p1+s1;
                this.v.v[3][0] = p0 - s0;
                this.v.v[3][1] = p1;
                this.v.i[0][0] = p0 - s0*cPoint;
                this.v.i[0][1] = p1 - s1;
                this.v.i[1][0] = p0 + s0;
                this.v.i[1][1] = p1 - s1*cPoint;
                this.v.i[2][0] = p0 + s0*cPoint;
                this.v.i[2][1] = p1 + s1;
                this.v.i[3][0] = p0 - s0;
                this.v.i[3][1] = p1 + s1*cPoint;
                this.v.o[0][0] = p0 + s0*cPoint;
                this.v.o[0][1] = p1 - s1;
                this.v.o[1][0] = p0 + s0;
                this.v.o[1][1] = p1 + s1*cPoint;
                this.v.o[2][0] = p0 - s0*cPoint;
                this.v.o[2][1] = p1 + s1;
                this.v.o[3][0] = p0 - s0;
                this.v.o[3][1] = p1 - s1*cPoint;
            }else{
                this.v.v[0][0] = p0;
                this.v.v[0][1] = p1-s1;
                this.v.v[1][0] = p0 - s0;
                this.v.v[1][1] = p1;
                this.v.v[2][0] = p0;
                this.v.v[2][1] = p1+s1;
                this.v.v[3][0] = p0 + s0;
                this.v.v[3][1] = p1;
                this.v.i[0][0] = p0 + s0*cPoint;
                this.v.i[0][1] = p1 - s1;
                this.v.i[1][0] = p0 - s0;
                this.v.i[1][1] = p1 - s1*cPoint;
                this.v.i[2][0] = p0 - s0*cPoint;
                this.v.i[2][1] = p1 + s1;
                this.v.i[3][0] = p0 + s0;
                this.v.i[3][1] = p1 + s1*cPoint;
                this.v.o[0][0] = p0 - s0*cPoint;
                this.v.o[0][1] = p1 - s1;
                this.v.o[1][0] = p0 - s0;
                this.v.o[1][1] = p1 + s1*cPoint;
                this.v.o[2][0] = p0 + s0*cPoint;
                this.v.o[2][1] = p1 + s1;
                this.v.o[3][0] = p0 + s0;
                this.v.o[3][1] = p1 - s1*cPoint;
            }
        }

        function processKeys(frameNum){
            var i, len = this.dynamicProperties.length;
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue(frameNum);
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertEllToPath();
            }
        }

        return function EllShapeProperty(elem,data) {
            /*this.v = {
                v: Array.apply(null,{length:4}),
                i: Array.apply(null,{length:4}),
                o: Array.apply(null,{length:4}),
                c: true
            };*/
            this.v = shape_pool.newShape();
            this.v.setPathData(true, 4);
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.localShapeCollection.addShape(this.v);
            this.d = data.d;
            this.dynamicProperties = [];
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.mdf = false;
            this.getValue = processKeys;
            this.convertEllToPath = convertEllToPath;
            this.reset = resetShape;
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertEllToPath();
            }
        }
    }());

    var StarShapeProperty = (function() {

        function convertPolygonToPath(){
            var numPts = Math.floor(this.pt.v);
            var angle = Math.PI*2/numPts;
            /*this.v.v.length = numPts;
            this.v.i.length = numPts;
            this.v.o.length = numPts;*/
            var rad = this.or.v;
            var roundness = this.os.v;
            var perimSegment = 2*Math.PI*rad/(numPts*4);
            var i, currentAng = -Math.PI/ 2;
            var dir = this.data.d === 3 ? -1 : 1;
            currentAng += this.r.v;
            this.v._length = 0;
            for(i=0;i<numPts;i+=1){
                var x = rad * Math.cos(currentAng);
                var y = rad * Math.sin(currentAng);
                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
                x +=  + this.p.v[0];
                y +=  + this.p.v[1];
                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
                /*this.v.v[i] = [x,y];
                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];*/
                currentAng += angle*dir;
            }
            this.paths.length = 0;
            this.paths[0] = this.v;
        }

        function convertStarToPath() {
            var numPts = Math.floor(this.pt.v)*2;
            var angle = Math.PI*2/numPts;
            /*this.v.v.length = numPts;
            this.v.i.length = numPts;
            this.v.o.length = numPts;*/
            var longFlag = true;
            var longRad = this.or.v;
            var shortRad = this.ir.v;
            var longRound = this.os.v;
            var shortRound = this.is.v;
            var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
            var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
            var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
            currentAng += this.r.v;
            var dir = this.data.d === 3 ? -1 : 1;
            this.v._length = 0;
            for(i=0;i<numPts;i+=1){
                rad = longFlag ? longRad : shortRad;
                roundness = longFlag ? longRound : shortRound;
                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                var x = rad * Math.cos(currentAng);
                var y = rad * Math.sin(currentAng);
                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
                x +=  + this.p.v[0];
                y +=  + this.p.v[1];
                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);

                /*this.v.v[i] = [x,y];
                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                this.v._length = numPts;*/
                longFlag = !longFlag;
                currentAng += angle*dir;
            }
        }

        function processKeys() {
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            var i, len = this.dynamicProperties.length;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue();
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertToPath();
            }
        }

        return function StarShapeProperty(elem,data) {
            /*this.v = {
                v: [],
                i: [],
                o: [],
                c: true
            };*/
            this.v = shape_pool.newShape();
            this.v.setPathData(true, 0);
            this.elem = elem;
            this.comp = elem.comp;
            this.data = data;
            this.frameId = -1;
            this.d = data.d;
            this.dynamicProperties = [];
            this.mdf = false;
            this.getValue = processKeys;
            this.reset = resetShape;
            if(data.sy === 1){
                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this.dynamicProperties);
                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this.dynamicProperties);
                this.convertToPath = convertStarToPath;
            } else {
                this.convertToPath = convertPolygonToPath;
            }
            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this.dynamicProperties);
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this.dynamicProperties);
            this.or = PropertyFactory.getProp(elem,data.or,0,0,this.dynamicProperties);
            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this.dynamicProperties);
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertToPath();
            }
        }
    }());

    var RectShapeProperty = (function() {
        function processKeys(frameNum){
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            var i, len = this.dynamicProperties.length;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue(frameNum);
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertRectToPath();
            }

        }

        function convertRectToPath(){
            var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
            var round = bm_min(v0,v1,this.r.v);
            var cPoint = round*(1-roundCorner);
            this.v._length = 0;

            if(this.d === 2 || this.d === 1) {
                this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
                this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
                if(round!== 0){
                    this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
                } else {
                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
                }
            }else{
                this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
                if(round!== 0){
                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
                    this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
                    this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
                } else {
                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
                    this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);

                }
            }
        }

        return function RectShapeProperty(elem,data) {
            this.v = shape_pool.newShape();
            this.v.c = true;
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.d = data.d;
            this.dynamicProperties = [];
            this.mdf = false;
            this.getValue = processKeys;
            this.convertRectToPath = convertRectToPath;
            this.reset = resetShape;
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
            this.r = PropertyFactory.getProp(elem,data.r,0,0,this.dynamicProperties);
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertRectToPath();
            }
        }
    }());

    function getShapeProp(elem,data,type, arr){
        var prop;
        if(type === 3 || type === 4){
            var dataProp = type === 3 ? data.pt : data.ks;
            var keys = dataProp.k;
            if(dataProp.a === 1 || keys.length){
                prop = new KeyframedShapeProperty(elem, data, type);
            }else{
                prop = new ShapeProperty(elem, data, type);
            }
        }else if(type === 5){
            prop = new RectShapeProperty(elem, data);
        }else if(type === 6){
            prop = new EllShapeProperty(elem, data);
        }else if(type === 7){
            prop = new StarShapeProperty(elem, data);
        }
        if(prop.k){
            arr.push(prop);
        }
        return prop;
    }

    var ob = {};
    ob.getShapeProp = getShapeProp;
    return ob;
}());
var ShapeModifiers = (function(){
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;

    function registerModifier(nm,factory){
        if(!modifiers[nm]){
            modifiers[nm] = factory;
        }
    }

    function getModifier(nm,elem, data, dynamicProperties){
        return new modifiers[nm](elem, data, dynamicProperties);
    }

    return ob;
}());

function ShapeModifier(){}
ShapeModifier.prototype.initModifierProperties = function(){};
ShapeModifier.prototype.addShapeToModifier = function(){};
ShapeModifier.prototype.addShape = function(data){
    if(!this.closed){
        this.shapes.push({shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()});
        this.addShapeToModifier(data.sh);
    }
}
ShapeModifier.prototype.init = function(elem,data,dynamicProperties){
    this.elem = elem;
    this.frameId = -1;
    this.shapes = [];
    this.dynamicProperties = [];
    this.mdf = false;
    this.closed = false;
    this.k = false;
    this.isTrimming = false;
    this.comp = elem.comp;
    this.initModifierProperties(elem,data);
    if(this.dynamicProperties.length){
        this.k = true;
        dynamicProperties.push(this);
    }else{
        this.getValue(true);
    }
}
function TrimModifier(){};
extendPrototype(ShapeModifier,TrimModifier);
TrimModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
    if(this.mdf || forceRender){
        var o = (this.o.v%360)/360;
        if(o < 0){
            o += 1;
        }
        var s = this.s.v + o;
        var e = this.e.v + o;
        if(s == e){

        }
        if(s>e){
            var _s = s;
            s = e;
            e = _s;
        }
        this.sValue = s;
        this.eValue = e;
        this.oValue = o;
    }
}
TrimModifier.prototype.initModifierProperties = function(elem,data){
    this.sValue = 0;
    this.eValue = 0;
    this.oValue = 0;
    this.getValue = this.processKeys;
    this.s = PropertyFactory.getProp(elem,data.s,0,0.01,this.dynamicProperties);
    this.e = PropertyFactory.getProp(elem,data.e,0,0.01,this.dynamicProperties);
    this.o = PropertyFactory.getProp(elem,data.o,0,0,this.dynamicProperties);
    this.m = data.m;
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
};

TrimModifier.prototype.getSegmentsLength = function(shapeData){
    var closed = shapeData.c;
    var pathV = shapeData.v;
    var pathO = shapeData.o;
    var pathI = shapeData.i;
    var i, len = shapeData._length;
    var lengths = [];
    var totalLength = 0;
    for(i=0;i<len-1;i+=1){
        lengths[i] = bez.getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
        totalLength += lengths[i].addedLength;
    }
    if(closed){
        lengths[i] = bez.getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
        totalLength += lengths[i].addedLength;
    }
    return {lengths:lengths,totalLength:totalLength};
}

TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = []
    if(e <= 1){
        segments.push({
            s: s,
            e: e
        })
    }else if(s >= 1){
        segments.push({
            s: s - 1,
            e: e - 1
        })
    }else{
        segments.push({
            s: s,
            e: 1
        })
        segments.push({
            s: 0,
            e: e - 1
        })
    }
    var shapeSegments = [];
    var i, len = segments.length, segmentOb;
    for(i = 0; i < len; i += 1) {
        segmentOb = segments[i];
        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
            
        } else {
            var shapeS, shapeE;
            if(segmentOb.s * totalModifierLength <= addedLength) {
                shapeS = 0;
            } else {
                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
            }
            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
                shapeE = 1;
            } else {
                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
            }
            shapeSegments.push([shapeS, shapeE]);
        }
    }
    if(!shapeSegments.length){
        shapeSegments.push([0,0]);
    }
    return shapeSegments;
}

TrimModifier.prototype.processShapes = function(firstFrame){
    var shapePaths;
    var i, len = this.shapes.length;
    var j, jLen;
    var s = this.sValue;
    var e = this.eValue;
    var pathsData,pathData, totalShapeLength, totalModifierLength = 0;

    if(e === s){
        for(i=0;i<len;i+=1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape.mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
        }
    } else if(!((e === 1 && s === 0) || (e===0 && s === 1))){
        var segments = [], shapeData, localShapeCollection;
        for(i=0;i<len;i+=1){
            shapeData = this.shapes[i];
            if(!shapeData.shape.mdf && !this.mdf && !firstFrame && this.m !== 2){
                shapeData.shape.paths = shapeData.localShapeCollection;
            } else {
                shapePaths = shapeData.shape.paths;
                jLen = shapePaths._length;
                totalShapeLength = 0;
                if(!shapeData.shape.mdf && shapeData.pathsData){
                    totalShapeLength = shapeData.totalShapeLength;
                } else {
                    pathsData = [];
                    for(j=0;j<jLen;j+=1){
                        pathData = this.getSegmentsLength(shapePaths.shapes[j]);
                        pathsData.push(pathData);
                        totalShapeLength += pathData.totalLength;
                    }
                    shapeData.totalShapeLength = totalShapeLength;
                    shapeData.pathsData = pathsData;
                }

                totalModifierLength += totalShapeLength;
                shapeData.shape.mdf = true;
            }
        }
        var shapeS = s, shapeE = e, addedLength = 0;
        var j, jLen;
        for(i = len - 1; i >= 0; i -= 1){
            shapeData = this.shapes[i];
            if (shapeData.shape.mdf) {
                localShapeCollection = shapeData.localShapeCollection;
                localShapeCollection.releaseShapes();
                if(this.m === 2 && len > 1) {
                    var edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                    addedLength += shapeData.totalShapeLength;
                } else {
                    edges = [[shapeS, shapeE]]
                }
                jLen = edges.length;
                for (j = 0; j < jLen; j += 1) {
                    shapeS = edges[j][0];
                    shapeE = edges[j][1];
                    segments.length = 0;
                    if(shapeE <= 1){
                        segments.push({
                            s:shapeData.totalShapeLength * shapeS,
                            e:shapeData.totalShapeLength * shapeE
                        })
                    }else if(shapeS >= 1){
                        segments.push({
                            s:shapeData.totalShapeLength * (shapeS - 1),
                            e:shapeData.totalShapeLength * (shapeE - 1)
                        })
                    }else{
                        segments.push({
                            s:shapeData.totalShapeLength * shapeS,
                            e:shapeData.totalShapeLength
                        })
                        segments.push({
                            s:0,
                            e:shapeData.totalShapeLength*(shapeE - 1)
                        })
                    }
                    var newShapesData = this.addShapes(shapeData,segments[0]);
                    if (segments[0].s !== segments[0].e) {
                        var lastPos;
                        if(segments.length > 1){
                            if(shapeData.shape.v.c){
                                var lastShape = newShapesData.pop();
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData,segments[1], lastShape);
                            } else {
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData,segments[1]);
                            }
                        } 
                        this.addPaths(newShapesData, localShapeCollection);
                    }
                    
                }
                shapeData.shape.paths = localShapeCollection;
            }
        }
    } else if(this.mdf){
        for(i=0;i<len;i+=1){
            this.shapes[i].shape.mdf = true;
        }
    }
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
}

TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
    var i, len = newPaths.length;
    for(i = 0; i < len; i += 1) {
        localShapeCollection.addShape(newPaths[i])
    }
}

TrimModifier.prototype.addSegment = function(pt1,pt2,pt3,pt4,shapePath,pos, newShape) {
    /*console.log(pt1, 'vertex: v, at: ', pos);
    console.log(pt2, 'vertex: o, at: ', pos);
    console.log(pt3, 'vertex: i, at: ', pos + 1);
    console.log(pt4, 'vertex: v, at: ', pos + 1);
    console.log('newShape: ', newShape);*/
    shapePath.setXYAt(pt2[0],pt2[1],'o',pos);
    shapePath.setXYAt(pt3[0],pt3[1],'i',pos + 1);
    if(newShape){
        shapePath.setXYAt(pt1[0],pt1[1],'v',pos);
    }
    shapePath.setXYAt(pt4[0],pt4[1],'v',pos + 1);
}

TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath){
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i, len = shapeData.shape.paths._length, j, jLen;
    var addedLength = 0;
    var currentLengthData,segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;
    if(!shapePath){
        shapePath = shape_pool.newShape();
        segmentCount = 0;
        initPos = 0;
    } else {
        segmentCount = shapePath._length;
        initPos = shapePath._length;
    }
    shapes.push(shapePath);
    for(i=0;i<len;i+=1){
        lengths = pathsData[i].lengths;
        shapePath.c = shapePaths[i].c;
        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
        for(j=1;j<jLen;j+=1){
            currentLengthData = lengths[j-1];
            if(addedLength + currentLengthData.addedLength < shapeSegment.s){
                addedLength += currentLengthData.addedLength;
                shapePath.c = false;
            } else if(addedLength > shapeSegment.e){
                shapePath.c = false;
                break;
            } else {
                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength){
                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);
                    newShape = false;
                } else {
                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
                    newShape = false;
                    shapePath.c = false;
                }
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
        }
        if(shapePaths[i].c){
            currentLengthData = lengths[j-1];
            if(addedLength <= shapeSegment.e){
                var segmentLength = lengths[j-1].addedLength;
                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength){
                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);
                    newShape = false;
                }else{
                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0], (shapeSegment.s - addedLength)/segmentLength,(shapeSegment.e - addedLength)/segmentLength, lengths[j-1]);
                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
                    newShape = false;
                    shapePath.c = false;
                }
            } else {
                shapePath.c = false;
            }
            addedLength += currentLengthData.addedLength;
            segmentCount += 1;
        }
        if(shapePath._length){
            shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);
            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0],shapePath.v[shapePath._length - 1][1],'o',shapePath._length - 1);
        }
        if(addedLength > shapeSegment.e){
            break;
        }
        if(i<len-1){
            shapePath = shape_pool.newShape();
            newShape = true;
            shapes.push(shapePath);
            segmentCount = 0;
        }
    }
    return shapes;

}


ShapeModifiers.registerModifier('tm',TrimModifier);
function RoundCornersModifier(){};
extendPrototype(ShapeModifier,RoundCornersModifier);
RoundCornersModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
}
RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this.dynamicProperties);
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
};

RoundCornersModifier.prototype.processPath = function(path, round){
    var cloned_path = shape_pool.newShape();
    cloned_path.c = path.c;
    var i, len = path._length;
    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
    var vX,vY,oX,oY,iX,iY;
    for(i=0;i<len;i+=1){
        currentV = path.v[i];
        currentO = path.o[i];
        currentI = path.i[i];
        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
            if((i===0 || i === len - 1) && !path.c){
                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
                /*cloned_path.v[index] = currentV;
                cloned_path.o[index] = currentO;
                cloned_path.i[index] = currentI;*/
                index += 1;
            } else {
                if(i===0){
                    closerV = path.v[len-1];
                } else {
                    closerV = path.v[i-1];
                }
                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
                oX = vX-(vX-currentV[0])*roundCorner;
                oY = vY-(vY-currentV[1])*roundCorner;
                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
                /*newV = [currentV[0]+(closerV[0]-currentV[0])*newPosPerc,currentV[1]-(currentV[1]-closerV[1])*newPosPerc];
                newI = newV;
                newO = [newV[0]-(newV[0]-currentV[0])*roundCorner,newV[1]-(newV[1]-currentV[1])*roundCorner];
                cloned_path.v[index] = newV;
                cloned_path.i[index] = newI;
                cloned_path.o[index] = newO;*/
                index += 1;

                if(i === len - 1){
                    closerV = path.v[0];
                } else {
                    closerV = path.v[i+1];
                }
                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
                iX = vX-(vX-currentV[0])*roundCorner;
                iY = vY-(vY-currentV[1])*roundCorner;
                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);

                /*newV = [currentV[0]+(closerV[0]-currentV[0])*newPosPerc,currentV[1]+(closerV[1]-currentV[1])*newPosPerc];
                newI = [newV[0]-(newV[0]-currentV[0])*roundCorner,newV[1]-(newV[1]-currentV[1])*roundCorner];
                newO = newV;
                cloned_path.v[index] = newV;
                cloned_path.i[index] = newI;
                cloned_path.o[index] = newO;*/
                index += 1;
            }
        } else {
            /*cloned_path.v[index] = path.v[i];
            cloned_path.o[index] = path.o[i];
            cloned_path.i[index] = path.i[i];*/
            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
            index += 1;
        }
    }
    return cloned_path;
}

RoundCornersModifier.prototype.processShapes = function(firstFrame){
    var shapePaths;
    var i, len = this.shapes.length;
    var j, jLen;
    var rd = this.rd.v;

    if(rd !== 0){
        var shapeData, newPaths, localShapeCollection;
        for(i=0;i<len;i+=1){
            shapeData = this.shapes[i];
            newPaths = shapeData.shape.paths;
            localShapeCollection = shapeData.localShapeCollection;
            if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
                localShapeCollection.releaseShapes();
                shapeData.shape.mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j=0;j<jLen;j+=1){
                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
                }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }

    }
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
}


ShapeModifiers.registerModifier('rd',RoundCornersModifier);
function RepeaterModifier(){};
extendPrototype(ShapeModifier,RepeaterModifier);
RepeaterModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
};
RepeaterModifier.prototype.initModifierProperties = function(elem,data){
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem,data.c,0,null,this.dynamicProperties);
    this.o = PropertyFactory.getProp(elem,data.o,0,null,this.dynamicProperties);
    this.tr = PropertyFactory.getProp(elem,data.tr,2,null,this.dynamicProperties);
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
}

RepeaterModifier.prototype.processShapes = function(firstFrame){
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
    var i, len = this.shapes.length;
    var j, jLen;
    var shapeData, localShapeCollection, currentPath;
    var copies = Math.ceil(this.c.v);
    var offset = this.o.v;
    var offsetModulo = offset%1;
    var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    var k, pathData, shapeCollection, shapeCollectionList;
    var tMat = this.tr.v.props;
    var pProps = this.pMatrix.props;
    var rProps = this.rMatrix.props;
    var sProps = this.sMatrix.props;
    var iteration = 0;
    var l, lLen, tProps,transformers, maxLvl;
    for(i=0;i<len;i+=1){
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;
        if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
            localShapeCollection.releaseShapes();
            shapeData.shape.mdf = true;
            shapeCollection = shapeData.shape.paths;
            shapeCollectionList = shapeCollection.shapes;
            jLen = shapeCollection._length;
            iteration = 0;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();

            if(offset > 0) {
                while(iteration<roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if(offsetModulo){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if(roundOffset < 0) {
                while(iteration>roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if(offsetModulo){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            for(j=0;j<jLen;j+=1){
                currentPath = shapeCollectionList[j];
                for(k=0;k<copies;k+=1) {
                    if(k !== 0) {
                        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    }
                    if(shapeData.data.transformers) {
                        shapeData.data.lvl = 0;
                        maxLvl = 0;
                        lLen = shapeData.data.elements.length;
                        for(l = 0; l < lLen; l += 1) {
                            maxLvl = Math.max(maxLvl, shapeData.data.elements[l].st.lvl);
                        } 
                        transformers = shapeData.data.transformers;
                        lLen = transformers.length;
                        for(l = lLen - 1; l >= maxLvl; l -= 1) {
                            tProps = transformers[l].mProps.v.props;
                            this.matrix.transform(tProps[0],tProps[1],tProps[2],tProps[3],tProps[4],tProps[5],tProps[6],tProps[7],tProps[8],tProps[9],tProps[10],tProps[11],tProps[12],tProps[13],tProps[14],tProps[15]);
                        }
                    }
                    if(iteration !== 0){
                        this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
                        this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
                        this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
                    }
                    localShapeCollection.addShape(this.processPath(currentPath, this.matrix));
                    this.matrix.reset();
                    iteration += 1;
                }
            }
        }
        shapeData.shape.paths = localShapeCollection;
    }
};

RepeaterModifier.prototype.processPath = function(path, transform) {
    var clonedPath = shape_pool.clone(path, transform);
    return clonedPath;
};


ShapeModifiers.registerModifier('rp',RepeaterModifier);
function ShapeCollection(){
	this._length = 0;
	this._maxLength = 4;
	this.shapes = Array.apply(null,{length:this._maxLength});
};

ShapeCollection.prototype.addShape = function(shapeData){
	if(this._length === this._maxLength){
		this.shapes = this.shapes.concat(Array.apply(null,{length:this._maxLength}));
		this._maxLength *= 2;
	}
	this.shapes[this._length] = shapeData;
	this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function(){
	var i;
	for(i = 0; i < this._length; i += 1) {
		shape_pool.release(this.shapes[i]);
	}
	this._length = 0;
};
var ImagePreloader = (function(){

    function imageLoaded(){
        this.loadedAssets += 1;
        if(this.loadedAssets === this.totalImages){
        }
    }

    function getAssetsPath(assetData){
        var path = '';
        if(this.assetsPath){
            var imagePath = assetData.p;
            if(imagePath.indexOf('images/') !== -1){
                imagePath = imagePath.split('/')[1];
            }
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    }

    function loadImage(path){
        var img = document.createElement('img');
        img.addEventListener('load', imageLoaded.bind(this), false);
        img.addEventListener('error', imageLoaded.bind(this), false);
        img.src = path;
    }
    function loadAssets(assets){
        this.totalAssets = assets.length;
        var i;
        for(i=0;i<this.totalAssets;i+=1){
            if(!assets[i].layers){
                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
                this.totalImages += 1;
            }
        }
    }

    function setPath(path){
        this.path = path || '';
    }

    function setAssetsPath(path){
        this.assetsPath = path || '';
    }

    return function ImagePreloader(){
        this.loadAssets = loadAssets;
        this.setAssetsPath = setAssetsPath;
        this.setPath = setPath;
        this.assetsPath = '';
        this.path = '';
        this.totalAssets = 0;
        this.totalImages = 0;
        this.loadedAssets = 0;
    }
}());
var featureSupport = (function(){
	var ob = {
		maskType: true
	}
	if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	   ob.maskType = false;
	}
	return ob;
}());
var filtersFactory = (function(){
	var ob = {};
	ob.createFilter = createFilter;
	ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

	function createFilter(filId){
        	var fil = document.createElementNS(svgNS,'filter');
        	fil.setAttribute('id',filId);
                fil.setAttribute('filterUnits','objectBoundingBox');
                fil.setAttribute('x','0%');
                fil.setAttribute('y','0%');
                fil.setAttribute('width','100%');
                fil.setAttribute('height','100%');
                return fil;
	}

	function createAlphaToLuminanceFilter(){
                var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
                feColorMatrix.setAttribute('type','matrix');
                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 0 1');
                return feColorMatrix;
	}

	return ob;
}())
var pooling = (function(){

	function double(arr){
		return arr.concat(Array.apply(null,{length:arr.length}))
	}

	return {
		double: double
	}
}());
var point_pool = (function(){
	var ob = {
		newPoint: newPoint,
		release: release
		/*,getLength:function(){return _length}
		,getCont:function(){return cont}*/
	}

	var _length = 0;
	var _maxLength = 8;
	var pool = Array.apply(null,{length:_maxLength});

	//var cont = 0;

	function newPoint(){
		//window.bm_newPoint = window.bm_newPoint ? window.bm_newPoint + 1 : 1;
		var point;
		if(_length){
			_length -= 1;
			point = pool[_length];
			//window.bm_reuse = window.bm_reuse ? window.bm_reuse + 1 : 1;
		} else {
			point = [0.1,0.1];
			//cont++;
			//console.log('new');
			//window.bm_new = window.bm_new ? window.bm_new + 1 : 1;
			//point._tst = cont++;
		}
		return point;
	}

	function release(point) {
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = point;
		_length += 1;
		//window.bm_release = window.bm_release ? window.bm_release + 1 : 1;
		//console.log('release');
	}


	return ob;
}());
var shape_pool = (function(){
	var ob = {
		clone: clone,
		newShape: newShape,
		release: release,
		releaseArray: releaseArray
	}

	var _length = 0;
	var _maxLength = 4;
	var pool = Array.apply(null,{length:_maxLength});

	function newShape(){
		var shapePath;
		if(_length){
			_length -= 1;
			shapePath = pool[_length];
		} else {
			shapePath = new ShapePath();
		}
		return shapePath;
	}

	function release(shapePath) {
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		var len = shapePath._length, i;
		for(i = 0; i < len; i += 1) {
			point_pool.release(shapePath.v[i]);
			point_pool.release(shapePath.i[i]);
			point_pool.release(shapePath.o[i]);
			shapePath.v[i] = null;
			shapePath.i[i] = null;
			shapePath.o[i] = null;
		}
		shapePath._length = 0;
		shapePath.c = false;
		pool[_length] = shapePath;
		_length += 1;
	}

	function releaseArray(shapePathsCollection, length) {
		while(length--) {
			release(shapePathsCollection[length]);
		}
	}

	function clone(shape, transform) {
		var i, len = shape._length;
		var cloned = newShape();
		cloned._length = shape._length;
		cloned.c = shape.c;

		var pt;
		
		for(i = 0; i < len; i += 1) {
			if(transform){
				pt = transform.applyToPointArray(shape.v[i][0],shape.v[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'v',i);
				point_pool.release(pt);
				pt = transform.applyToPointArray(shape.o[i][0],shape.o[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'o',i);
				point_pool.release(pt);
				pt = transform.applyToPointArray(shape.i[i][0],shape.i[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'i',i);
				point_pool.release(pt);
			}else{
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
		}
		return cloned
	}


	return ob;
}());
var shapeCollection_pool = (function(){
	var ob = {
		newShapeCollection: newShapeCollection,
		release: release,
		clone: clone
	}

	var _length = 0;
	var _maxLength = 4;
	var pool = Array.apply(null,{length:_maxLength});

	var cont = 0;

	function newShapeCollection(){
		var shapeCollection;
		if(_length){
			_length -= 1;
			shapeCollection = pool[_length];
		} else {
			shapeCollection = new ShapeCollection();
		}
		return shapeCollection;
	}

	function release(shapeCollection) {
		var i, len = shapeCollection._length;
		for(i = 0; i < len; i += 1) {
			shape_pool.release(shapeCollection.shapes[i]);
		}
		shapeCollection._length = 0;

		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = shapeCollection;
		_length += 1;
	}

	function clone(shapeCollection, originCollection) {
		release(shapeCollection);
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = shapeCollection;
		_length += 1;
	}


	return ob;
}());
function BaseRenderer(){}
BaseRenderer.prototype.checkLayers = function(num){
    var i, len = this.layers.length, data;
    this.completeLayers = true;
    for (i = len - 1; i >= 0; i--) {
        if (!this.elements[i]) {
            data = this.layers[i];
            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
            {
                this.buildItem(i);
            }
        }
        this.completeLayers = this.elements[i] ? this.completeLayers:false;
    }
    this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function(layer){
    switch(layer.ty){
        case 2:
            return this.createImage(layer);
        case 0:
            return this.createComp(layer);
        case 1:
            return this.createSolid(layer);
        case 4:
            return this.createShape(layer);
        case 5:
            return this.createText(layer);
        case 13:
            return this.createCamera(layer);
        case 99:
            return null;
    }
    return this.createBase(layer);
};

BaseRenderer.prototype.createCamera = function(){
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
}

BaseRenderer.prototype.buildAllItems = function(){
    var i, len = this.layers.length;
    for(i=0;i<len;i+=1){
        this.buildItem(i);
    }
    this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function(newLayers){
    this.completeLayers = false;
    var i, len = newLayers.length;
    var j, jLen = this.layers.length;
    for(i=0;i<len;i+=1){
        j = 0;
        while(j<jLen){
            if(this.layers[j].id == newLayers[i].id){
                this.layers[j] = newLayers[i];
                break;
            }
            j += 1;
        }
    }
};

BaseRenderer.prototype.setProjectInterface = function(pInterface){
    this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function(){
    if(!this.globalData.progressiveLoad){
        this.buildAllItems();
    }
};
BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy){
    hierarchy = hierarchy || [];
    var elements = this.elements;
    var layers = this.layers;
    var i=0, len = layers.length;
    while(i<len){
        if(layers[i].ind == parentName){
            if(!elements[i] || elements[i] === true){
                this.buildItem(i);
                this.addPendingElement(element);
            } else if(layers[i].parent !== undefined){
                hierarchy.push(elements[i]);
                elements[i]._isParent = true;
                this.buildElementParenting(element,layers[i].parent, hierarchy);
            } else {
                hierarchy.push(elements[i]);
                elements[i]._isParent = true;
                element.setHierarchy(hierarchy);
            }


        }
        i += 1;
    }
};

BaseRenderer.prototype.addPendingElement = function(element){
    this.pendingElements.push(element);
};
function SVGRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.renderConfig = {
        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
        progressiveLoad: (config && config.progressiveLoad) || false
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;

}

extendPrototype(BaseRenderer,SVGRenderer);

SVGRenderer.prototype.createBase = function (data) {
    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createShape = function (data) {
    return new IShapeElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createText = function (data) {
    return new SVGTextElement(data, this.layerElement,this.globalData,this);

};

SVGRenderer.prototype.createImage = function (data) {
    return new IImageElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createComp = function (data) {
    return new ICompElement(data, this.layerElement,this.globalData,this);

};

SVGRenderer.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.configAnimation = function(animData){
    this.layerElement = document.createElementNS(svgNS,'svg');
    this.layerElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
    this.layerElement.setAttribute('width',animData.w);
    this.layerElement.setAttribute('height',animData.h);
    this.layerElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
    this.layerElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
    this.layerElement.style.width = '100%';
    this.layerElement.style.height = '100%';
    //this.layerElement.style.transform = 'translate3d(0,0,0)';
    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
    this.animationItem.wrapper.appendChild(this.layerElement);
    //Mask animation
    var defs = document.createElementNS(svgNS, 'defs');
    this.globalData.defs = defs;
    this.layerElement.appendChild(defs);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.globalData.frameId = 0;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.data = animData;
    this.globalData.frameRate = animData.fr;
    var maskElement = document.createElementNS(svgNS, 'clipPath');
    var rect = document.createElementNS(svgNS,'rect');
    rect.setAttribute('width',animData.w);
    rect.setAttribute('height',animData.h);
    rect.setAttribute('x',0);
    rect.setAttribute('y',0);
    var maskId = 'animationMask_'+randomString(10);
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    var maskedElement = document.createElementNS(svgNS,'g');
    maskedElement.setAttribute("clip-path", "url(#"+maskId+")");
    this.layerElement.appendChild(maskedElement);
    defs.appendChild(maskElement);
    this.layerElement = maskedElement;
    this.layers = animData.layers;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,defs);
    this.elements = Array.apply(null,{length:animData.layers.length});
};


SVGRenderer.prototype.destroy = function () {
    this.animationItem.wrapper.innerHTML = '';
    this.layerElement = null;
    this.globalData.defs = null;
    var i, len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i++) {
        if(this.elements[i]){
            this.elements[i].destroy();
        }
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem  = function(pos){
    var elements = this.elements;
    if(elements[pos] || this.layers[pos].ty == 99){
        return;
    }
    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);

    elements[pos] = element;
    if(expressionsPlugin){
        if(this.layers[pos].ty === 0){
            this.globalData.projectInterface.registerComposition(element);
        }
        element.initExpressions();
    }
    this.appendElementInPos(element,pos);
    if(this.layers[pos].tt){
        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
            this.buildItem(pos - 1);
            this.addPendingElement(element);
        } else {
            element.setMatte(elements[pos - 1].layerId);
        }
    }
};

SVGRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
        if(element.data.tt){
            var i = 0, len = this.elements.length;
            while(i<len){
                if(this.elements[i] === element){
                    element.setMatte(this.elements[i - 1].layerId);
                    break;
                }
                i += 1;
            }
        }
    }
};

SVGRenderer.prototype.renderFrame = function(num){
    if(this.renderedFrame == num || this.destroyed){
        return;
    }
    if(num === null){
        num = this.renderedFrame;
    }else{
        this.renderedFrame = num;
    }
    //clearPoints();
    /*console.log('-------');
    console.log('FRAME ',num);*/
    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    var i, len = this.layers.length;
    if(!this.completeLayers){
        this.checkLayers(num);
    }
    for (i = len - 1; i >= 0; i--) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(num - this.layers[i].st);
        }
    }
    for (i = len - 1; i >= 0; i--) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
};

SVGRenderer.prototype.appendElementInPos = function(element, pos){
    var newElement = element.getBaseElement();
    if(!newElement){
        return;
    }
    var i = 0;
    var nextElement;
    while(i<pos){
        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
            nextElement = this.elements[i].getBaseElement();
        }
        i += 1;
    }
    if(nextElement){
        this.layerElement.insertBefore(newElement, nextElement);
    } else {
        this.layerElement.appendChild(newElement);
    }
};

SVGRenderer.prototype.hide = function(){
    this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function(){
    this.layerElement.style.display = 'block';
};

SVGRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElementNS(svgNS,'g');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
            comp.initExpressions();
            //comp.compInterface = CompExpressionInterface(comp);
            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};

function MaskElement(data,element,globalData) {
    this.dynamicProperties = [];
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.paths = [];
    this.storedData = [];
    this.masksProperties = this.data.masksProperties;
    this.viewData = new Array(this.masksProperties.length);
    this.maskElement = null;
    this.firstFrame = true;
    var defs = this.globalData.defs;
    var i, len = this.masksProperties.length;


    var path, properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j, jLen;
    var layerId = randomString(10);
    var rect, expansor, feMorph,x;
    var maskType = 'clipPath', maskRef = 'clip-path';
    for (i = 0; i < len; i++) {

        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
            maskType = 'mask';
            maskRef = 'mask';
        }

        if((properties[i].mode == 's' || properties[i].mode == 'i') && count == 0){
            rect = document.createElementNS(svgNS, 'rect');
            rect.setAttribute('fill', '#ffffff');
            rect.setAttribute('width', this.element.comp.data.w);
            rect.setAttribute('height', this.element.comp.data.h);
            currentMasks.push(rect);
        } else {
            rect = null;
        }

        path = document.createElementNS(svgNS, 'path');
        if(properties[i].mode == 'n') {
            this.viewData[i] = {
                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null),
                elem: path
            };
            defs.appendChild(path);
            continue;
        }
        count += 1;

        if(properties[i].mode == 's'){
            path.setAttribute('fill', '#000000');
        }else{
            path.setAttribute('fill', '#ffffff');
        }
        path.setAttribute('clip-rule','nonzero');

        if(properties[i].x.k !== 0){
            maskType = 'mask';
            maskRef = 'mask';
            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.dynamicProperties);
            var filterID = 'fi_'+randomString(10);
            expansor = document.createElementNS(svgNS,'filter');
            expansor.setAttribute('id',filterID);
            feMorph = document.createElementNS(svgNS,'feMorphology');
            feMorph.setAttribute('operator','dilate');
            feMorph.setAttribute('in','SourceGraphic');
            feMorph.setAttribute('radius','0');
            expansor.appendChild(feMorph);
            defs.appendChild(expansor);
            if(properties[i].mode == 's'){
                path.setAttribute('stroke', '#000000');
            }else{
                path.setAttribute('stroke', '#ffffff');
            }
        }else{
            feMorph = null;
            x = null;
        }


        this.storedData[i] = {
             elem: path,
             x: x,
             expan: feMorph,
            lastPath: '',
            lastOperator:'',
            filterId:filterID,
            lastRadius:0
        };
        if(properties[i].mode == 'i'){
            jLen = currentMasks.length;
            var g = document.createElementNS(svgNS,'g');
            for(j=0;j<jLen;j+=1){
                g.appendChild(currentMasks[j]);
            }
            var mask = document.createElementNS(svgNS,'mask');
            mask.setAttribute('mask-type','alpha');
            mask.setAttribute('id',layerId+'_'+count);
            mask.appendChild(path);
            defs.appendChild(mask);
            g.setAttribute('mask','url(#'+layerId+'_'+count+')');

            currentMasks.length = 0;
            currentMasks.push(g);
        }else{
            currentMasks.push(path);
        }
        if(properties[i].inv && !this.solidPath){
            this.solidPath = this.createLayerSolidPath();
        }
        this.viewData[i] = {
            elem: path,
            lastPath: '',
            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null)
        };
        if(rect){
            this.viewData[i].invRect = rect;
        }
        if(!this.viewData[i].prop.k){
            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
        }
    }

    this.maskElement = document.createElementNS(svgNS, maskType);

    len = currentMasks.length;
    for(i=0;i<len;i+=1){
        this.maskElement.appendChild(currentMasks[i]);
    }

    this.maskElement.setAttribute('id', layerId);
    if(count > 0){
        this.element.maskedElement.setAttribute(maskRef, "url(#" + layerId + ")");
    }

    defs.appendChild(this.maskElement);
};

MaskElement.prototype.getMaskProperty = function(pos){
    return this.viewData[pos].prop;
};

MaskElement.prototype.prepareFrame = function(){
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();

    }
};

MaskElement.prototype.renderFrame = function (finalMat) {
    var i, len = this.masksProperties.length;
    for (i = 0; i < len; i++) {
        if(this.viewData[i].prop.mdf || this.firstFrame){
            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
        }
        if(this.viewData[i].op.mdf || this.firstFrame){
            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
        }
        if(this.masksProperties[i].mode !== 'n'){
            if(this.viewData[i].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame)){
                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
            }
            if(this.storedData[i].x && (this.storedData[i].x.mdf || this.firstFrame)){
                var feMorph = this.storedData[i].expan;
                if(this.storedData[i].x.v < 0){
                    if(this.storedData[i].lastOperator !== 'erode'){
                        this.storedData[i].lastOperator = 'erode';
                        this.storedData[i].elem.setAttribute('filter','url(#'+this.storedData[i].filterId+')');
                    }
                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
                }else{
                    if(this.storedData[i].lastOperator !== 'dilate'){
                        this.storedData[i].lastOperator = 'dilate';
                        this.storedData[i].elem.setAttribute('filter',null);
                    }
                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);

                }
            }
        }
    }
    this.firstFrame = false;
};

MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function(){
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w ;
    path += ' v' + this.globalData.compSize.h ;
    path += ' h-' + this.globalData.compSize.w ;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
};

MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    var i, len;
    len = pathNodes._length;
    for(i=1;i<len;i+=1){
        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[i][0])+','+bm_rnd(pathNodes.i[i][1]) + " "+bm_rnd(pathNodes.v[i][0])+','+bm_rnd(pathNodes.v[i][1]);
    }
        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    if(pathNodes.c && len > 1){
        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[0][0])+','+bm_rnd(pathNodes.i[0][1]) + " "+bm_rnd(pathNodes.v[0][0])+','+bm_rnd(pathNodes.v[0][1]);
    }
    //pathNodes.__renderedString = pathString;


    if(viewData.lastPath !== pathString){
        if(viewData.elem){
            if(!pathNodes.c){
                viewData.elem.setAttribute('d','');
            }else if(pathData.inv){
                viewData.elem.setAttribute('d',this.solidPath + pathString);
            }else{
                viewData.elem.setAttribute('d',pathString);
            }
        }
        viewData.lastPath = pathString;
    }
};

MaskElement.prototype.getMask = function(nm){
    var i = 0, len = this.masksProperties.length;
    while(i<len){
        if(this.masksProperties[i].nm === nm){
            return {
                maskPath: this.viewData[i].prop.pv
            }
        }
        i += 1;
    }
};

MaskElement.prototype.destroy = function(){
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.paths = null;
    this.masksProperties = null;
};
function BaseElement(){
};
BaseElement.prototype.checkMasks = function(){
    if(!this.data.hasMask){
        return false;
    }
    var i = 0, len = this.data.masksProperties.length;
    while(i<len) {
        if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
            return true;
        }
        i += 1;
    }
    return false;
}

BaseElement.prototype.checkParenting = function(){
    if(this.data.parent !== undefined){
        this.comp.buildElementParenting(this, this.data.parent);
    }
}

BaseElement.prototype.prepareFrame = function(num){
    if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
    {
        if(this.isVisible !== true){
            this.elemMdf = true;
            this.globalData.mdf = true;
            this.isVisible = true;
            this.firstFrame = true;
            if(this.data.hasMask){
                this.maskManager.firstFrame = true;
            }
        }
    }else{
        if(this.isVisible !== false){
            this.elemMdf = true;
            this.globalData.mdf = true;
            this.isVisible = false;
        }
    }
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        if(this.isVisible || (this._isParent && this.dynamicProperties[i].type === 'transform')){
            this.dynamicProperties[i].getValue();
            if(this.dynamicProperties[i].mdf){
                this.elemMdf = true;
                this.globalData.mdf = true;
            }
        }
    }
    if(this.data.hasMask && this.isVisible){
        this.maskManager.prepareFrame(num*this.data.sr);
    }
    
    /* TODO check this
    if(this.data.sy){
        if(this.data.sy[0].renderedData[num]){
            if(this.data.sy[0].renderedData[num].c){
                this.feFlood.setAttribute('flood-color','rgb('+Math.round(this.data.sy[0].renderedData[num].c[0])+','+Math.round(this.data.sy[0].renderedData[num].c[1])+','+Math.round(this.data.sy[0].renderedData[num].c[2])+')');
            }
            if(this.data.sy[0].renderedData[num].s){
                this.feMorph.setAttribute('radius',this.data.sy[0].renderedData[num].s);
            }
        }
    }
    */


    this.currentFrameNum = num*this.data.sr;
    return this.isVisible;
};

BaseElement.prototype.globalToLocal = function(pt){
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while(flag){
        if(comp.finalTransform){
            if(comp.data.hasMask){
                transforms.splice(0,0,comp.finalTransform);
            }
            comp = comp.comp;
        } else {
            flag = false;
        }
    }
    var i, len = transforms.length,ptNew;
    for(i=0;i<len;i+=1){
        ptNew = transforms[i].mat.applyToPointArray(0,0,0);
        //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
        pt = [pt[0] - ptNew[0],pt[1] - ptNew[1],0];
    }
    return pt;
};

BaseElement.prototype.initExpressions = function(){
    this.layerInterface = LayerExpressionInterface(this);
    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
    if(this.data.hasMask){
        this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if(this.data.ty === 0 || this.data.xt){
        this.compInterface = CompExpressionInterface(this);
    } else if(this.data.ty === 4){
        this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData,this.viewData,this.layerInterface);
    } else if(this.data.ty === 5){
        this.layerInterface.textInterface = TextExpressionInterface(this);
    }
}

BaseElement.prototype.setBlendMode = function(){
    var blendModeValue = '';
    switch(this.data.bm){
        case 1:
            blendModeValue = 'multiply';
            break;
        case 2:
            blendModeValue = 'screen';
            break;
        case 3:
            blendModeValue = 'overlay';
            break;
        case 4:
            blendModeValue = 'darken';
            break;
        case 5:
            blendModeValue = 'lighten';
            break;
        case 6:
            blendModeValue = 'color-dodge';
            break;
        case 7:
            blendModeValue = 'color-burn';
            break;
        case 8:
            blendModeValue = 'hard-light';
            break;
        case 9:
            blendModeValue = 'soft-light';
            break;
        case 10:
            blendModeValue = 'difference';
            break;
        case 11:
            blendModeValue = 'exclusion';
            break;
        case 12:
            blendModeValue = 'hue';
            break;
        case 13:
            blendModeValue = 'saturation';
            break;
        case 14:
            blendModeValue = 'color';
            break;
        case 15:
            blendModeValue = 'luminosity';
            break;
    }
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
}

BaseElement.prototype.init = function(){
    if(!this.data.sr){
        this.data.sr = 1;
    }
    this.dynamicProperties = [];
    if(this.data.ef){
        this.effects = new EffectsManager(this.data,this,this.dynamicProperties);
        //this.effect = this.effectsManager.bind(this.effectsManager);
    }
    //this.elemInterface = buildLayerExpressionInterface(this);
    this.hidden = false;
    this.firstFrame = true;
    this.isVisible = false;
    this._isParent = false;
    this.currentFrameNum = -99999;
    this.lastNum = -99999;
    if(this.data.ks){
        this.finalTransform = {
            mProp: PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),
            matMdf: false,
            opMdf: false,
            mat: new Matrix(),
            opacity: 1
        };
        if(this.data.ao){
            this.finalTransform.mProp.autoOriented = true;
        }
        this.finalTransform.op = this.finalTransform.mProp.o;
        this.transform = this.finalTransform.mProp;
        if(this.data.ty !== 11){
            this.createElements();
        }
        if(this.data.hasMask){
            this.addMasks(this.data);
        }
    }
    this.elemMdf = false;
};
BaseElement.prototype.getType = function(){
    return this.type;
};

BaseElement.prototype.resetHierarchy = function(){
    if(!this.hierarchy){
        this.hierarchy = [];
    }else{
        this.hierarchy.length = 0;
    }
};

BaseElement.prototype.getHierarchy = function(){
    if(!this.hierarchy){
        this.hierarchy = [];
    }
    return this.hierarchy;
};

BaseElement.prototype.setHierarchy = function(hierarchy){
    this.hierarchy = hierarchy;
};

BaseElement.prototype.getLayerSize = function(){
    if(this.data.ty === 5){
        return {w:this.data.textData.width,h:this.data.textData.height};
    }else{
        return {w:this.data.width,h:this.data.height};
    }
};

BaseElement.prototype.hide = function(){

};

BaseElement.prototype.mHelper = new Matrix();
function SVGBaseElement(data,parentContainer,globalData,comp, placeholder){
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.matteElement = null;
    this.transformedElement = null;
    this.parentContainer = parentContainer;
    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
    this.placeholder = placeholder;
    this.init();
};

createElement(BaseElement, SVGBaseElement);

SVGBaseElement.prototype.createElements = function(){
    this.layerElement = document.createElementNS(svgNS,'g');
    this.transformedElement = this.layerElement;
    if(this.data.hasMask){
        this.maskedElement = this.layerElement;
    }
    var layerElementParent = null;
    if(this.data.td){
        if(this.data.td == 3 || this.data.td == 1){
            var masker = document.createElementNS(svgNS,'mask');
            masker.setAttribute('id',this.layerId);
            masker.setAttribute('mask-type',this.data.td == 3 ? 'luminance':'alpha');
            masker.appendChild(this.layerElement);
            layerElementParent = masker;
            this.globalData.defs.appendChild(masker);
            ////// This is only for IE and Edge when mask if of type alpha
            if(!featureSupport.maskType && this.data.td == 1){
                masker.setAttribute('mask-type','luminance');
                var filId = randomString(10);
                var fil = filtersFactory.createFilter(filId);
                this.globalData.defs.appendChild(fil);
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                var gg = document.createElementNS(svgNS,'g');
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                masker.appendChild(gg);
                gg.setAttribute('filter','url(#'+filId+')');
            }
        }else if(this.data.td == 2){
            var maskGroup = document.createElementNS(svgNS,'mask');
            maskGroup.setAttribute('id',this.layerId);
            maskGroup.setAttribute('mask-type','alpha');
            var maskGrouper = document.createElementNS(svgNS,'g');
            maskGroup.appendChild(maskGrouper);
            var filId = randomString(10);
            var fil = filtersFactory.createFilter(filId);
            ////

            var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
            feColorMatrix.setAttribute('type','matrix');
            feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
            feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
            fil.appendChild(feColorMatrix);

            ////
            /*var feCTr = document.createElementNS(svgNS,'feComponentTransfer');
            feCTr.setAttribute('in','SourceGraphic');
            fil.appendChild(feCTr);
            var feFunc = document.createElementNS(svgNS,'feFuncA');
            feFunc.setAttribute('type','table');
            feFunc.setAttribute('tableValues','1.0 0.0');
            feCTr.appendChild(feFunc);*/
            this.globalData.defs.appendChild(fil);
            var alphaRect = document.createElementNS(svgNS,'rect');
            alphaRect.setAttribute('width',this.comp.data.w);
            alphaRect.setAttribute('height',this.comp.data.h);
            alphaRect.setAttribute('x','0');
            alphaRect.setAttribute('y','0');
            alphaRect.setAttribute('fill','#ffffff');
            alphaRect.setAttribute('opacity','0');
            maskGrouper.setAttribute('filter','url(#'+filId+')');
            maskGrouper.appendChild(alphaRect);
            maskGrouper.appendChild(this.layerElement);
            layerElementParent = maskGrouper;
            if(!featureSupport.maskType){
                maskGroup.setAttribute('mask-type','luminance');
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                var gg = document.createElementNS(svgNS,'g');
                maskGrouper.appendChild(alphaRect);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                maskGrouper.appendChild(gg);
            }
            this.globalData.defs.appendChild(maskGroup);
        }
    }else if(this.data.hasMask || this.data.tt){
        if(this.data.tt){
            this.matteElement = document.createElementNS(svgNS,'g');
            this.matteElement.appendChild(this.layerElement);
            layerElementParent = this.matteElement;
            this.baseElement = this.matteElement;
        }else{
            this.baseElement = this.layerElement;
        }
    }else{
        this.baseElement = this.layerElement;
    }
    if((this.data.ln || this.data.cl) && (this.data.ty === 4 || this.data.ty === 0)){
        if(this.data.ln){
            this.layerElement.setAttribute('id',this.data.ln);
        }
        if(this.data.cl){
            this.layerElement.setAttribute('class',this.data.cl);
        }
    }
    if(this.data.ty === 0){
            var cp = document.createElementNS(svgNS, 'clipPath');
            var pt = document.createElementNS(svgNS,'path');
            pt.setAttribute('d','M0,0 L'+this.data.w+',0'+' L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');
            var clipId = 'cp_'+randomString(8);
            cp.setAttribute('id',clipId);
            cp.appendChild(pt);
            this.globalData.defs.appendChild(cp);
        if(this.checkMasks()){
            var cpGroup = document.createElementNS(svgNS,'g');
            cpGroup.setAttribute('clip-path','url(#'+clipId+')');
            cpGroup.appendChild(this.layerElement);
            this.transformedElement = cpGroup;
            if(layerElementParent){
                layerElementParent.appendChild(this.transformedElement);
            } else {
                this.baseElement = this.transformedElement;
            }
        } else {
            this.layerElement.setAttribute('clip-path','url(#'+clipId+')');
        }
        
    }
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    if(this.layerElement !== this.parentContainer){
        this.placeholder = null;
    }
    /* Todo performance killer
    if(this.data.sy){
        var filterID = 'st_'+randomString(10);
        var c = this.data.sy[0].c.k;
        var r = this.data.sy[0].s.k;
        var expansor = document.createElementNS(svgNS,'filter');
        expansor.setAttribute('id',filterID);
        var feFlood = document.createElementNS(svgNS,'feFlood');
        this.feFlood = feFlood;
        if(!c[0].e){
            feFlood.setAttribute('flood-color','rgb('+c[0]+','+c[1]+','+c[2]+')');
        }
        feFlood.setAttribute('result','base');
        expansor.appendChild(feFlood);
        var feMorph = document.createElementNS(svgNS,'feMorphology');
        feMorph.setAttribute('operator','dilate');
        feMorph.setAttribute('in','SourceGraphic');
        feMorph.setAttribute('result','bigger');
        this.feMorph = feMorph;
        if(!r.length){
            feMorph.setAttribute('radius',this.data.sy[0].s.k);
        }
        expansor.appendChild(feMorph);
        var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
        feColorMatrix.setAttribute('result','mask');
        feColorMatrix.setAttribute('in','bigger');
        feColorMatrix.setAttribute('type','matrix');
        feColorMatrix.setAttribute('values','0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0');
        expansor.appendChild(feColorMatrix);
        var feComposite = document.createElementNS(svgNS,'feComposite');
        feComposite.setAttribute('result','drop');
        feComposite.setAttribute('in','base');
        feComposite.setAttribute('in2','mask');
        feComposite.setAttribute('operator','in');
        expansor.appendChild(feComposite);
        var feBlend = document.createElementNS(svgNS,'feBlend');
        feBlend.setAttribute('in','SourceGraphic');
        feBlend.setAttribute('in2','drop');
        feBlend.setAttribute('mode','normal');
        expansor.appendChild(feBlend);
        this.globalData.defs.appendChild(expansor);
        var cont = document.createElementNS(svgNS,'g');
        if(this.layerElement === this.parentContainer){
            this.layerElement = cont;
        }else{
            cont.appendChild(this.layerElement);
        }
        cont.setAttribute('filter','url(#'+filterID+')');
        if(this.data.td){
            cont.setAttribute('data-td',this.data.td);
        }
        if(this.data.td == 3){
            this.globalData.defs.appendChild(cont);
        }else if(this.data.td == 2){
            maskGrouper.appendChild(cont);
        }else if(this.data.td == 1){
            masker.appendChild(cont);
        }else{
            if(this.data.hasMask && this.data.tt){
                this.matteElement.appendChild(cont);
            }else{
                this.appendNodeToParent(cont);
            }
        }
    }*/
    if(this.data.ef){
        this.effectsManager = new SVGEffects(this);
    }
    this.checkParenting();
};


SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;

SVGBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3 || this.data.hd || !this.isVisible){
        return false;
    }

    this.lastNum = this.currentFrameNum;
    this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i = 0, len = this.hierarchy.length;
        if(!this.finalTransform.matMdf) {
            while(i < len) {
                if(this.hierarchy[i].finalTransform.mProp.mdf) {
                    this.finalTransform.matMdf = true;
                    break;
                }
                i += 1;
            }
        }
        
        if(this.finalTransform.matMdf) {
            mat = this.finalTransform.mProp.v.props;
            finalMat.cloneFromProps(mat);
            for(i=0;i<len;i+=1){
                mat = this.hierarchy[i].finalTransform.mProp.v.props;
                finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
            }
        }
        
    }else if(this.isVisible){
        finalMat = this.finalTransform.mProp.v;
    }
    if(this.finalTransform.matMdf && this.layerElement){
        this.transformedElement.setAttribute('transform',finalMat.to2dCSS());
    }
    if(this.finalTransform.opMdf && this.layerElement){
        this.transformedElement.setAttribute('opacity',this.finalTransform.op.v);
    }

    if(this.data.hasMask){
        this.maskManager.renderFrame(finalMat);
    }
    if(this.effectsManager){
        this.effectsManager.renderFrame(this.firstFrame);
    }
    return this.isVisible;
};

SVGBaseElement.prototype.destroy = function(){
    this.layerElement = null;
    this.parentContainer = null;
    if(this.matteElement) {
        this.matteElement = null;
    }
    if(this.maskManager) {
        this.maskManager.destroy();
    }
};

SVGBaseElement.prototype.getBaseElement = function(){
    return this.baseElement;
};
SVGBaseElement.prototype.addMasks = function(data){
    this.maskManager = new MaskElement(data,this,this.globalData);
};

SVGBaseElement.prototype.setMatte = function(id){
    if(!this.matteElement){
        return;
    }
    this.matteElement.setAttribute("mask", "url(#" + id + ")");
};

SVGBaseElement.prototype.setMatte = function(id){
    if(!this.matteElement){
        return;
    }
    this.matteElement.setAttribute("mask", "url(#" + id + ")");
};

SVGBaseElement.prototype.hide = function(){

};

function ITextElement(data, animationItem,parentContainer,globalData){
}
ITextElement.prototype.init = function(){
    this._parent.init.call(this);

    this.lettersChangedFlag = false;
    this.currentTextDocumentData = {};
    var data = this.data;
    this.viewData = {
        m:{
            a: PropertyFactory.getProp(this,data.t.m.a,1,0,this.dynamicProperties)
        }
    };
    var textData = this.data.t;
    if(textData.a.length){
        this.viewData.a = Array.apply(null,{length:textData.a.length});
        var i, len = textData.a.length, animatorData, animatorProps;
        for(i=0;i<len;i+=1){
            animatorProps = textData.a[i];
            animatorData = {
                a: {},
                s: {}
            };
            if('r' in animatorProps.a) {
                animatorData.a.r = PropertyFactory.getProp(this,animatorProps.a.r,0,degToRads,this.dynamicProperties);
            }
            if('rx' in animatorProps.a) {
                animatorData.a.rx = PropertyFactory.getProp(this,animatorProps.a.rx,0,degToRads,this.dynamicProperties);
            }
            if('ry' in animatorProps.a) {
                animatorData.a.ry = PropertyFactory.getProp(this,animatorProps.a.ry,0,degToRads,this.dynamicProperties);
            }
            if('sk' in animatorProps.a) {
                animatorData.a.sk = PropertyFactory.getProp(this,animatorProps.a.sk,0,degToRads,this.dynamicProperties);
            }
            if('sa' in animatorProps.a) {
                animatorData.a.sa = PropertyFactory.getProp(this,animatorProps.a.sa,0,degToRads,this.dynamicProperties);
            }
            if('s' in animatorProps.a) {
                animatorData.a.s = PropertyFactory.getProp(this,animatorProps.a.s,1,0.01,this.dynamicProperties);
            }
            if('a' in animatorProps.a) {
                animatorData.a.a = PropertyFactory.getProp(this,animatorProps.a.a,1,0,this.dynamicProperties);
            }
            if('o' in animatorProps.a) {
                animatorData.a.o = PropertyFactory.getProp(this,animatorProps.a.o,0,0.01,this.dynamicProperties);
            }
            if('p' in animatorProps.a) {
                animatorData.a.p = PropertyFactory.getProp(this,animatorProps.a.p,1,0,this.dynamicProperties);
            }
            if('sw' in animatorProps.a) {
                animatorData.a.sw = PropertyFactory.getProp(this,animatorProps.a.sw,0,0,this.dynamicProperties);
            }
            if('sc' in animatorProps.a) {
                animatorData.a.sc = PropertyFactory.getProp(this,animatorProps.a.sc,1,0,this.dynamicProperties);
            }
            if('fc' in animatorProps.a) {
                animatorData.a.fc = PropertyFactory.getProp(this,animatorProps.a.fc,1,0,this.dynamicProperties);
            }
            if('fh' in animatorProps.a) {
                animatorData.a.fh = PropertyFactory.getProp(this,animatorProps.a.fh,0,0,this.dynamicProperties);
            }
            if('fs' in animatorProps.a) {
                animatorData.a.fs = PropertyFactory.getProp(this,animatorProps.a.fs,0,0.01,this.dynamicProperties);
            }
            if('fb' in animatorProps.a) {
                animatorData.a.fb = PropertyFactory.getProp(this,animatorProps.a.fb,0,0.01,this.dynamicProperties);
            }
            if('t' in animatorProps.a) {
                animatorData.a.t = PropertyFactory.getProp(this,animatorProps.a.t,0,0,this.dynamicProperties);
            }
            animatorData.s = PropertyFactory.getTextSelectorProp(this,animatorProps.s,this.dynamicProperties);
            animatorData.s.t = animatorProps.s.t;
            this.viewData.a[i] = animatorData;
        }
    }else{
        this.viewData.a = [];
    }
    if(textData.p && 'm' in textData.p){
        this.viewData.p = {
            f: PropertyFactory.getProp(this,textData.p.f,0,0,this.dynamicProperties),
            l: PropertyFactory.getProp(this,textData.p.l,0,0,this.dynamicProperties),
            r: textData.p.r,
            m: this.maskManager.getMaskProperty(textData.p.m)
        };
        this.maskPath = true;
    } else {
        this.maskPath = false;
    }
};
ITextElement.prototype.prepareFrame = function(num) {
    var i = 0, len = this.data.t.d.k.length;
    var textDocumentData = this.data.t.d.k[i].s;
    i += 1;
    while(i<len){
        if(this.data.t.d.k[i].t > num){
            break;
        }
        textDocumentData = this.data.t.d.k[i].s;
        i += 1;
    }
    this.lettersChangedFlag = false;
    if(textDocumentData !== this.currentTextDocumentData){
        this.currentTextDocumentData = textDocumentData;
        this.lettersChangedFlag = true;
        this.buildNewText();
    }
    this._parent.prepareFrame.call(this, num);
}

ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
    var j,jLen = shapes.length;
    var k, kLen, pathNodes;
    var shapeStr = '';
    for(j=0;j<jLen;j+=1){
        kLen = shapes[j].ks.k.i.length;
        pathNodes = shapes[j].ks.k;
        for(k=1;k<kLen;k+=1){
            if(k==1){
                shapeStr += " M"+matrixHelper.applyToPointStringified(pathNodes.v[0][0],pathNodes.v[0][1]);
            }
            shapeStr += " C"+matrixHelper.applyToPointStringified(pathNodes.o[k-1][0],pathNodes.o[k-1][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.i[k][0],pathNodes.i[k][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.v[k][0],pathNodes.v[k][1]);
        }
        shapeStr += " C"+matrixHelper.applyToPointStringified(pathNodes.o[k-1][0],pathNodes.o[k-1][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.i[0][0],pathNodes.i[0][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.v[0][0],pathNodes.v[0][1]);
        shapeStr += 'z';
    }
    return shapeStr;
};

ITextElement.prototype.getMeasures = function(){

    var matrixHelper = this.mHelper;
    var renderType = this.renderType;
    var data = this.data;
    var xPos,yPos;
    var i, len;
    var documentData = this.currentTextDocumentData;
    var letters = documentData.l;
    if(this.maskPath) {
        var mask = this.viewData.p.m;
        if(!this.viewData.p.n || this.viewData.p.mdf){
            var paths = mask.v;
            if(this.viewData.p.r){
                paths = reversePath(paths);
            }
            var pathInfo = {
                tLength: 0,
                segments: []
            };
            len = paths.v.length - 1;
            var pathData;
            var totalLength = 0;
            for (i = 0; i < len; i += 1) {
                pathData = {
                    s: paths.v[i],
                    e: paths.v[i + 1],
                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
                };
                bez.buildBezierData(pathData);
                pathInfo.tLength += pathData.bezierData.segmentLength;
                pathInfo.segments.push(pathData);
                totalLength += pathData.bezierData.segmentLength;
            }
            i = len;
            if (mask.v.c) {
                pathData = {
                    s: paths.v[i],
                    e: paths.v[0],
                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
                };
                bez.buildBezierData(pathData);
                pathInfo.tLength += pathData.bezierData.segmentLength;
                pathInfo.segments.push(pathData);
                totalLength += pathData.bezierData.segmentLength;
            }
            this.viewData.p.pi = pathInfo;
        }
        var pathInfo = this.viewData.p.pi;

        var currentLength = this.viewData.p.f.v, segmentInd = 0, pointInd = 1, currentPoint, prevPoint, points;
        var segmentLength = 0, flag = true;
        var segments = pathInfo.segments;
        if (currentLength < 0 && mask.v.c) {
            if (pathInfo.tLength < Math.abs(currentLength)) {
                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
            }
            segmentInd = segments.length - 1;
            points = segments[segmentInd].bezierData.points;
            pointInd = points.length - 1;
            while (currentLength < 0) {
                currentLength += points[pointInd].partialLength;
                pointInd -= 1;
                if (pointInd < 0) {
                    segmentInd -= 1;
                    points = segments[segmentInd].bezierData.points;
                    pointInd = points.length - 1;
                }
            }

        }
        points = segments[segmentInd].bezierData.points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        var partialLength = currentPoint.partialLength;
        var perc, tanAngle;
    }


    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.s*1.2*.714;
    var firstLine = true;
    var renderedData = this.viewData, animatorProps, animatorSelector;
    var j, jLen;
    var lettersValue = Array.apply(null,{length:len}), letterValue;

    jLen = renderedData.a.length;
    var lastLetter;

    var mult, ind = -1, offf, xPathPos, yPathPos;
    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
    var elemOpacity;
    var sc,sw,fc,k;
    var lineLength = 0;
    var letterSw,letterSc,letterFc,letterM,letterP,letterO;
    for( i = 0; i < len; i += 1) {
        matrixHelper.reset();
        elemOpacity = 1;
        if(letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            currentLength = initPathPos ;
            firstLine = false;
            lineLength = 0;
            if(this.maskPath) {
                segmentInd = initSegmentInd;
                pointInd = initPointInd;
                points = segments[segmentInd].bezierData.points;
                prevPoint = points[pointInd - 1];
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
                segmentLength = 0;
            }
            lettersValue[i] = this.emptyProp;
        }else{
            if(this.maskPath) {
                if(currentLine !== letters[i].line){
                    switch(documentData.j){
                        case 1:
                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
                            break;
                        case 2:
                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
                            break;
                    }
                    currentLine = letters[i].line;
                }
                if (ind !== letters[i].ind) {
                    if (letters[ind]) {
                        currentLength += letters[ind].extra;
                    }
                    currentLength += letters[i].an / 2;
                    ind = letters[i].ind;
                }
                currentLength += renderedData.m.a.v[0] * letters[i].an / 200;
                var animatorOffset = 0;
                for (j = 0; j < jLen; j += 1) {
                    animatorProps = renderedData.a[j].a;
                    if ('p' in animatorProps) {
                        animatorSelector = renderedData.a[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                        if(mult.length){
                            animatorOffset += animatorProps.p.v[0] * mult[0];
                        } else{
                            animatorOffset += animatorProps.p.v[0] * mult;
                        }

                    }
                    if ('a' in animatorProps) {
                        animatorSelector = renderedData.a[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                        if(mult.length){
                            animatorOffset += animatorProps.a.v[0] * mult[0];
                        } else{
                            animatorOffset += animatorProps.a.v[0] * mult;
                        }

                    }
                }
                flag = true;
                while (flag) {
                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                        matrixHelper.translate(-renderedData.m.a.v[0]*letters[i].an/200, -(renderedData.m.a.v[1] * yOff / 100));
                        flag = false;
                    } else if (points) {
                        segmentLength += currentPoint.partialLength;
                        pointInd += 1;
                        if (pointInd >= points.length) {
                            pointInd = 0;
                            segmentInd += 1;
                            if (!segments[segmentInd]) {
                                if (mask.v.c) {
                                    pointInd = 0;
                                    segmentInd = 0;
                                    points = segments[segmentInd].bezierData.points;
                                } else {
                                    segmentLength -= currentPoint.partialLength;
                                    points = null;
                                }
                            } else {
                                points = segments[segmentInd].bezierData.points;
                            }
                        }
                        if (points) {
                            prevPoint = currentPoint;
                            currentPoint = points[pointInd];
                            partialLength = currentPoint.partialLength;
                        }
                    }
                }
                offf = letters[i].an / 2 - letters[i].add;
                matrixHelper.translate(-offf, 0, 0);
            } else {
                offf = letters[i].an/2 - letters[i].add;
                matrixHelper.translate(-offf,0,0);

                // Grouping alignment
                matrixHelper.translate(-renderedData.m.a.v[0]*letters[i].an/200, -renderedData.m.a.v[1]*yOff/100, 0);
            }

            lineLength += letters[i].l/2;
            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;
                if ('t' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                    if(this.maskPath) {
                        if(mult.length) {
                            currentLength += animatorProps.t*mult[0];
                        } else {
                            currentLength += animatorProps.t*mult;
                        }
                    }else{
                        if(mult.length) {
                            xPos += animatorProps.t.v*mult[0];
                        } else {
                            xPos += animatorProps.t.v*mult;
                        }
                    }
                }
            }
            lineLength += letters[i].l/2;
            if(documentData.strokeWidthAnim) {
                sw = documentData.sw || 0;
            }
            if(documentData.strokeColorAnim) {
                if(documentData.sc){
                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
                }else{
                    sc = [0,0,0];
                }
            }
            if(documentData.fillColorAnim) {
                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
            }
            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;
                if ('a' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);

                    if(mult.length){
                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
                    } else {
                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
                    }
                }
            }
            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;
                if ('s' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                    if(mult.length){
                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
                    } else {
                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
                    }
                }
            }
            for(j=0;j<jLen;j+=1) {
                animatorProps = renderedData.a[j].a;
                animatorSelector = renderedData.a[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                if ('sk' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                    } else {
                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                }
                if ('r' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                    } else {
                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                }
                if ('ry' in animatorProps) {

                    if(mult.length) {
                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
                    }else{
                        matrixHelper.rotateY(animatorProps.ry.v*mult);
                    }
                }
                if ('rx' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
                    } else {
                        matrixHelper.rotateX(animatorProps.rx.v*mult);
                    }
                }
                if ('o' in animatorProps) {
                    if(mult.length) {
                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
                    } else {
                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
                    }
                }
                if (documentData.strokeWidthAnim && 'sw' in animatorProps) {
                    if(mult.length) {
                        sw += animatorProps.sw.v*mult[0];
                    } else {
                        sw += animatorProps.sw.v*mult;
                    }
                }
                if (documentData.strokeColorAnim && 'sc' in animatorProps) {
                    for(k=0;k<3;k+=1){
                        if(mult.length) {
                            sc[k] = Math.round(255*(sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0]));
                        } else {
                            sc[k] = Math.round(255*(sc[k] + (animatorProps.sc.v[k] - sc[k])*mult));
                        }
                    }
                }
                if (documentData.fillColorAnim) {
                    if('fc' in animatorProps){
                        for(k=0;k<3;k+=1){
                            if(mult.length) {
                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
                            } else {
                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
                                //console.log('mult',mult);
                                //console.log(Math.round(fc[k] + (animatorProps.fc.v[k] - fc[k])*mult));
                            }
                        }
                    }
                    if('fh' in animatorProps){
                        if(mult.length) {
                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
                        } else {
                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
                        }
                    }
                    if('fs' in animatorProps){
                        if(mult.length) {
                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
                        } else {
                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
                        }
                    }
                    if('fb' in animatorProps){
                        if(mult.length) {
                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
                        } else {
                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
                        }
                    }
                }
            }

            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;

                if ('p' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                    if(this.maskPath) {
                        if(mult.length) {
                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                        } else {
                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        }
                    }else{
                        if(mult.length) {
                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        } else {
                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        }
                    }
                }
            }
            if(documentData.strokeWidthAnim){
                letterSw = sw < 0 ? 0 : sw;
            }
            if(documentData.strokeColorAnim){
                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
            }
            if(documentData.fillColorAnim){
                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
            }

            if(this.maskPath) {
                matrixHelper.translate(0,-documentData.ls);

                matrixHelper.translate(0, renderedData.m.a.v[1]*yOff/100 + yPos,0);
                if (data.t.p.p) {
                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
                    if (currentPoint.point[0] < prevPoint.point[0]) {
                        rot += 180;
                    }
                    matrixHelper.rotate(-rot * Math.PI / 180);
                }
                matrixHelper.translate(xPathPos, yPathPos, 0);
                currentLength -= renderedData.m.a.v[0]*letters[i].an/200;
                if(letters[i+1] && ind !== letters[i+1].ind){
                    currentLength += letters[i].an / 2;
                    currentLength += documentData.tr/1000*documentData.s;
                }
            }else{

                matrixHelper.translate(xPos,yPos,0);

                if(documentData.ps){
                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
                }
                switch(documentData.j){
                    case 1:
                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
                        break;
                    case 2:
                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
                        break;
                }
                matrixHelper.translate(0,-documentData.ls);
                matrixHelper.translate(offf,0,0);
                matrixHelper.translate(renderedData.m.a.v[0]*letters[i].an/200,renderedData.m.a.v[1]*yOff/100,0);
                xPos += letters[i].l + documentData.tr/1000*documentData.s;
            }
            if(renderType === 'html'){
                letterM = matrixHelper.toCSS();
            }else if(renderType === 'svg'){
                letterM = matrixHelper.to2dCSS();
            }else{
                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
            }
            letterO = elemOpacity;

            lastLetter = this.renderedLetters[i];
            if(lastLetter && (lastLetter.o !== letterO || lastLetter.sw !== letterSw || lastLetter.sc !== letterSc || lastLetter.fc !== letterFc)){
                this.lettersChangedFlag = true;
                letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
            }else{
                if((renderType === 'svg' || renderType === 'html') && (!lastLetter || lastLetter.m !== letterM)){
                    this.lettersChangedFlag = true;
                    letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM);
                }else if(renderType === 'canvas' && (!lastLetter || (lastLetter.props[0] !== letterP[0] || lastLetter.props[1] !== letterP[1] || lastLetter.props[4] !== letterP[4] || lastLetter.props[5] !== letterP[5] || lastLetter.props[12] !== letterP[12] || lastLetter.props[13] !== letterP[13]))){
                    this.lettersChangedFlag = true;
                    letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,null,letterP);
                } else {
                    letterValue = lastLetter;
                }
            }
            this.renderedLetters[i] = letterValue;
        }
    }
};

ITextElement.prototype.emptyProp = new LetterProps();

function SVGTextElement(data,parentContainer,globalData,comp, placeholder){
    this.textSpans = [];
    this.renderType = 'svg';
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, SVGTextElement);

SVGTextElement.prototype.init = ITextElement.prototype.init;
SVGTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape;
SVGTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
SVGTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;

SVGTextElement.prototype.createElements = function(){

    this._parent.createElements.call(this);


    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }
};

SVGTextElement.prototype.buildNewText = function(){
    var i, len;

    var documentData = this.currentTextDocumentData;
    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
    if(documentData.fc) {
        this.layerElement.setAttribute('fill', 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')');
    }else{
        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }
    if(documentData.sc){
        this.layerElement.setAttribute('stroke', 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')');
        this.layerElement.setAttribute('stroke-width', documentData.sw);
    }
    this.layerElement.setAttribute('font-size', documentData.s);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if(fontData.fClass){
        this.layerElement.setAttribute('class',fontData.fClass);
    } else {
        this.layerElement.setAttribute('font-family', fontData.fFamily);
        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
        this.layerElement.setAttribute('font-style', fStyle);
        this.layerElement.setAttribute('font-weight', fWeight);
    }



    var letters = documentData.l || [];
    len = letters.length;
    if(!len){
        return;
    }
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapes, shapeStr = '', singleShape = this.data.singleShape;
    if (singleShape) {
        var xPos = 0, yPos = 0, lineWidths = documentData.lineWidths, boxWidth = documentData.boxWidth, firstLine = true;
    }
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        if(this.globalData.fontManager.chars){
            if(!singleShape || i === 0){
                tSpan = this.textSpans[cnt] ? this.textSpans[cnt] : document.createElementNS(svgNS,'path');
            }
        }else{
            tSpan = this.textSpans[cnt] ? this.textSpans[cnt] : document.createElementNS(svgNS,'text');
        }
        tSpan.style.display = 'inherit';
        tSpan.setAttribute('stroke-linecap', 'butt');
        tSpan.setAttribute('stroke-linejoin','round');
        tSpan.setAttribute('stroke-miterlimit','4');
        //tSpan.setAttribute('visibility', 'hidden');
        if(singleShape && letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
        }
        matrixHelper.reset();
        if(this.globalData.fontManager.chars) {
            matrixHelper.scale(documentData.s / 100, documentData.s / 100);
        }
        if (singleShape) {
            if(documentData.ps){
                matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
            }
            matrixHelper.translate(0,-documentData.ls,0);
            switch(documentData.j){
                case 1:
                    matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line]),0,0);
                    break;
                case 2:
                    matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line])/2,0,0);
                    break;
            }
            matrixHelper.translate(xPos, yPos, 0);
        }
        if(this.globalData.fontManager.chars){
            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            var shapeData;
            if(charData){
                shapeData = charData.data;
            } else {
                shapeData = null;
            }
            if(shapeData && shapeData.shapes){
                shapes = shapeData.shapes[0].it;
                if(!singleShape){
                    shapeStr = '';
                }
                shapeStr += this.createPathShape(matrixHelper,shapes);
                if(!singleShape){

                    tSpan.setAttribute('d',shapeStr);
                }
            }
            if(!singleShape){
                this.layerElement.appendChild(tSpan);
            }
        }else{
            tSpan.textContent = letters[i].val;
            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
            this.layerElement.appendChild(tSpan);
            if(singleShape){
                tSpan.setAttribute('transform',matrixHelper.to2dCSS());
            }
        }
        if(singleShape) {
            xPos += letters[i].l;
            xPos += documentData.tr/1000*documentData.s;
        }
        //
        this.textSpans[cnt] = tSpan;
        cnt += 1;
    }
    if(!singleShape){
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    }
    if(singleShape && this.globalData.fontManager.chars){
        tSpan.setAttribute('d',shapeStr);
        this.layerElement.appendChild(tSpan);
    }
}

SVGTextElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        this.hidden = true;
    }
};

SVGTextElement.prototype.renderFrame = function(parentMatrix){

    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.layerElement.style.display = 'block';
    }

    if(this.data.singleShape){
        return;
    }
    this.getMeasures();
    if(!this.lettersChangedFlag){
        return;
    }
    var  i,len;
    var renderedLetters = this.renderedLetters;

    var letters = this.currentTextDocumentData.l;

    len = letters.length;
    var renderedLetter;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        this.textSpans[i].setAttribute('transform',renderedLetter.m);
        this.textSpans[i].setAttribute('opacity',renderedLetter.o);
        if(renderedLetter.sw){
            this.textSpans[i].setAttribute('stroke-width',renderedLetter.sw);
        }
        if(renderedLetter.sc){
            this.textSpans[i].setAttribute('stroke',renderedLetter.sc);
        }
        if(renderedLetter.fc){
            this.textSpans[i].setAttribute('fill',renderedLetter.fc);
        }
    }
    if(this.firstFrame) {
        this.firstFrame = false;
    }
}


SVGTextElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
};
function SVGTintFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f1');
    filter.appendChild(feColorMatrix);
    feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f2');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
        var feMerge = document.createElementNS(svgNS,'feMerge');
        filter.appendChild(feMerge);
        var feMergeNode;
        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
        feMergeNode.setAttribute('in','SourceGraphic');
        feMerge.appendChild(feMergeNode);
        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
        feMergeNode.setAttribute('in','f2');
        feMerge.appendChild(feMergeNode);
    }
}

SVGTintFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var colorBlack = this.filterManager.effectElements[0].p.v;
        var colorWhite = this.filterManager.effectElements[1].p.v;
        var opacity = this.filterManager.effectElements[2].p.v/100;
        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
    }
};
function SVGFillFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var color = this.filterManager.effectElements[2].p.v;
        var opacity = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
    }
};
function SVGStrokeEffect(elem, filterManager){
    this.initialized = false;
    this.filterManager = filterManager;
    this.elem = elem;
    this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function(){

    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
    var path,groupPath, i, len;
    if(this.filterManager.effectElements[1].p.v === 1){
        len = this.elem.maskManager.masksProperties.length;
        i = 0;
    } else {
        i = this.filterManager.effectElements[0].p.v - 1;
        len = i + 1;
    }
    groupPath = document.createElementNS(svgNS,'g'); 
    groupPath.setAttribute('fill','none');
    groupPath.setAttribute('stroke-linecap','round');
    groupPath.setAttribute('stroke-dashoffset',1);
    for(i;i<len;i+=1){
        path = document.createElementNS(svgNS,'path');
        groupPath.appendChild(path);
        this.paths.push({p:path,m:i});
    }
    if(this.filterManager.effectElements[10].p.v === 3){
        var mask = document.createElementNS(svgNS,'mask');
        var id = 'stms_' + randomString(10);
        mask.setAttribute('id',id);
        mask.setAttribute('mask-type','alpha');
        mask.appendChild(groupPath);
        this.elem.globalData.defs.appendChild(mask);
        var g = document.createElementNS(svgNS,'g');
        g.setAttribute('mask','url(#'+id+')');
        if(elemChildren[0]){
            g.appendChild(elemChildren[0]);
        }
        this.elem.layerElement.appendChild(g);
        this.masker = mask;
        groupPath.setAttribute('stroke','#fff');
    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
        if(this.filterManager.effectElements[10].p.v === 2){
            var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            while(elemChildren.length){
                this.elem.layerElement.removeChild(elemChildren[0]);
            }
        }
        this.elem.layerElement.appendChild(groupPath);
        this.elem.layerElement.removeAttribute('mask');
        groupPath.setAttribute('stroke','#fff');
    }
    this.initialized = true;
    this.pathMasker = groupPath;
}

SVGStrokeEffect.prototype.renderFrame = function(forceRender){
    if(!this.initialized){
        this.initialize();
    }
    var i, len = this.paths.length;
    var mask, path;
    for(i=0;i<len;i+=1){
        mask = this.elem.maskManager.viewData[this.paths[i].m];
        path = this.paths[i].p;
        if(forceRender || this.filterManager.mdf || mask.prop.mdf){
            path.setAttribute('d',mask.lastPath);
        }
        if(forceRender || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || mask.prop.mdf){
            var dasharrayValue;
            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
                var l = path.getTotalLength();
                dasharrayValue = '0 0 0 ' + l*s + ' ';
                var lineLength = l*(e-s);
                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
                var units = Math.floor(lineLength/segment);
                var j;
                for(j=0;j<units;j+=1){
                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
                }
                dasharrayValue += '0 ' + l*10 + ' 0 0';
            } else {
                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
            }
            path.setAttribute('stroke-dasharray',dasharrayValue);
        }
    }
    if(forceRender || this.filterManager.effectElements[4].p.mdf){
        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
    }
    
    if(forceRender || this.filterManager.effectElements[6].p.mdf){
        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
    }
    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
        if(forceRender || this.filterManager.effectElements[3].p.mdf){
            var color = this.filterManager.effectElements[3].p.v;
            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
        }
    }
};
function SVGTritoneFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f1');
    filter.appendChild(feColorMatrix);
    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
    filter.appendChild(feComponentTransfer);
    this.matrixFilter = feComponentTransfer;
    var feFuncR = document.createElementNS(svgNS,'feFuncR');
    feFuncR.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncR);
    this.feFuncR = feFuncR;
    var feFuncG = document.createElementNS(svgNS,'feFuncG');
    feFuncG.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncG);
    this.feFuncG = feFuncG;
    var feFuncB = document.createElementNS(svgNS,'feFuncB');
    feFuncB.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncB);
    this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var color1 = this.filterManager.effectElements[0].p.v;
        var color2 = this.filterManager.effectElements[1].p.v;
        var color3 = this.filterManager.effectElements[2].p.v;
        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0]
        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1]
        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2]
        this.feFuncR.setAttribute('tableValues', tableR);
        this.feFuncG.setAttribute('tableValues', tableG);
        this.feFuncB.setAttribute('tableValues', tableB);
        //var opacity = this.filterManager.effectElements[2].p.v/100;
        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
    }
};
function SVGProLevelsFilter(filter, filterManager){
    this.filterManager = filterManager;
    var effectElements = this.filterManager.effectElements;
    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    var feFuncR, feFuncG, feFuncB;
    
    if(effectElements[9].p.k || effectElements[9].p.v !== 0 || effectElements[10].p.k || effectElements[10].p.v !== 1 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 0 || effectElements[13].p.k || effectElements[13].p.v !== 1){
        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
    }
    if(effectElements[16].p.k || effectElements[16].p.v !== 0 || effectElements[17].p.k || effectElements[17].p.v !== 1 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 0 || effectElements[20].p.k || effectElements[20].p.v !== 1){
        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
    }
    if(effectElements[23].p.k || effectElements[23].p.v !== 0 || effectElements[24].p.k || effectElements[24].p.v !== 1 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 0 || effectElements[27].p.k || effectElements[27].p.v !== 1){
        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
    }
    if(effectElements[30].p.k || effectElements[30].p.v !== 0 || effectElements[31].p.k || effectElements[31].p.v !== 1 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 0 || effectElements[34].p.k || effectElements[34].p.v !== 1){
        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
    }
    
    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
        filter.appendChild(feComponentTransfer);
        feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    }

    if(effectElements[2].p.k || effectElements[2].p.v !== 0 || effectElements[3].p.k || effectElements[3].p.v !== 1 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 0 || effectElements[6].p.k || effectElements[6].p.v !== 1){

        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
        filter.appendChild(feComponentTransfer);
        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
    }
}

SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
    var feFunc = document.createElementNS(svgNS,type);
    feFunc.setAttribute('type','table');
    feComponentTransfer.appendChild(feFunc);
    return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
    var cnt = 0;
    var segments = 256;
    var perc;
    var min = Math.min(inputBlack, inputWhite);
    var max = Math.max(inputBlack, inputWhite);
    var table = Array.call(null,{length:segments});
    var colorValue;
    var pos = 0;
    var outputDelta = outputWhite - outputBlack; 
    var inputDelta = inputWhite - inputBlack; 
    while(cnt <= 256) {
        perc = cnt/256;
        if(perc <= min){
            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
        } else if(perc >= max){
            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
        } else {
            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
        }
        table[pos++] = colorValue;
        cnt += 256/(segments-1);
    }
    return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var val, cnt, perc, bezier;
        var effectElements = this.filterManager.effectElements;
        if(this.feFuncRComposed && (forceRender || effectElements[2].p.mdf || effectElements[3].p.mdf || effectElements[4].p.mdf || effectElements[5].p.mdf || effectElements[6].p.mdf)){
            val = this.getTableValue(effectElements[2].p.v,effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v);
            this.feFuncRComposed.setAttribute('tableValues',val);
            this.feFuncGComposed.setAttribute('tableValues',val);
            this.feFuncBComposed.setAttribute('tableValues',val);
        }

        if(this.feFuncR && (forceRender || effectElements[9].p.mdf || effectElements[10].p.mdf || effectElements[11].p.mdf || effectElements[12].p.mdf || effectElements[13].p.mdf)){
            val = this.getTableValue(effectElements[9].p.v,effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v);
            this.feFuncR.setAttribute('tableValues',val);
        }

        if(this.feFuncG && (forceRender || effectElements[16].p.mdf || effectElements[17].p.mdf || effectElements[18].p.mdf || effectElements[19].p.mdf || effectElements[20].p.mdf)){
            val = this.getTableValue(effectElements[16].p.v,effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v);
            this.feFuncG.setAttribute('tableValues',val);
        }

        if(this.feFuncB && (forceRender || effectElements[23].p.mdf || effectElements[24].p.mdf || effectElements[25].p.mdf || effectElements[26].p.mdf || effectElements[27].p.mdf)){
            val = this.getTableValue(effectElements[23].p.v,effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v);
            this.feFuncB.setAttribute('tableValues',val);
        }

        if(this.feFuncA && (forceRender || effectElements[30].p.mdf || effectElements[31].p.mdf || effectElements[32].p.mdf || effectElements[33].p.mdf || effectElements[34].p.mdf)){
            val = this.getTableValue(effectElements[30].p.v,effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v);
            this.feFuncA.setAttribute('tableValues',val);
        }
        
    }
};
function SVGDropShadowEffect(filter, filterManager){
    /*<feGaussianBlur in="SourceAlpha" stdDeviation="3"/> <!-- stdDeviation is how much to blur -->
  <feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
  <feMerge> 
    <feMergeNode/> <!-- this contains the offset blurred image -->
    <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
  </feMerge>*/
  /*<feFlood flood-color="#3D4574" flood-opacity="0.5" result="offsetColor"/>*/
    filter.setAttribute('x','-100%');
    filter.setAttribute('y','-100%');
    filter.setAttribute('width','400%');
    filter.setAttribute('height','400%');
    this.filterManager = filterManager;

    var feGaussianBlur = document.createElementNS(svgNS,'feGaussianBlur');
    feGaussianBlur.setAttribute('in','SourceAlpha');
    feGaussianBlur.setAttribute('result','drop_shadow_1');
    feGaussianBlur.setAttribute('stdDeviation','0');
    this.feGaussianBlur = feGaussianBlur;
    filter.appendChild(feGaussianBlur);

    var feOffset = document.createElementNS(svgNS,'feOffset');
    feOffset.setAttribute('dx','25');
    feOffset.setAttribute('dy','0');
    feOffset.setAttribute('in','drop_shadow_1');
    feOffset.setAttribute('result','drop_shadow_2');
    this.feOffset = feOffset;
    filter.appendChild(feOffset);
    var feFlood = document.createElementNS(svgNS,'feFlood');
    feFlood.setAttribute('flood-color','#00ff00');
    feFlood.setAttribute('flood-opacity','1');
    feFlood.setAttribute('result','drop_shadow_3');
    this.feFlood = feFlood;
    filter.appendChild(feFlood);

    var feComposite = document.createElementNS(svgNS,'feComposite');
    feComposite.setAttribute('in','drop_shadow_3');
    feComposite.setAttribute('in2','drop_shadow_2');
    feComposite.setAttribute('operator','in');
    feComposite.setAttribute('result','drop_shadow_4');
    filter.appendChild(feComposite);


    var feMerge = document.createElementNS(svgNS,'feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
    feMerge.appendChild(feMergeNode);
    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
    feMergeNode.setAttribute('in','SourceGraphic');
    this.feMergeNode = feMergeNode;
    this.feMerge = feMerge;
    this.originalNodeAdded = false;
    feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        if(forceRender || this.filterManager.effectElements[4].p.mdf){
            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
        }
        if(forceRender || this.filterManager.effectElements[0].p.mdf){
            var col = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
        }
        if(forceRender || this.filterManager.effectElements[1].p.mdf){
            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
        }
        if(forceRender || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf){
            var distance = this.filterManager.effectElements[3].p.v
            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads
            var x = distance * Math.cos(angle)
            var y = distance * Math.sin(angle)
            this.feOffset.setAttribute('dx', x);
            this.feOffset.setAttribute('dy', y);
        }
        /*if(forceRender || this.filterManager.effectElements[5].p.mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        }*/
    }
};
function SVGEffects(elem){
    var i, len = elem.data.ef.length;
    var filId = randomString(10);
    var fil = filtersFactory.createFilter(filId);
    var count = 0;
    this.filters = [];
    var filterManager;
    for(i=0;i<len;i+=1){
        if(elem.data.ef[i].ty === 20){
            count += 1;
            filterManager = new SVGTintFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 21){
            count += 1;
            filterManager = new SVGFillFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 22){
            filterManager = new SVGStrokeEffect(elem, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 23){
            count += 1;
            filterManager = new SVGTritoneFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 24){
            count += 1;
            filterManager = new SVGProLevelsFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 25){
            count += 1;
            filterManager = new SVGDropShadowEffect(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }
    }
    if(count){
        elem.globalData.defs.appendChild(fil);
        elem.layerElement.setAttribute('filter','url(#'+filId+')');
    }
}

SVGEffects.prototype.renderFrame = function(firstFrame){
    var i, len = this.filters.length;
    for(i=0;i<len;i+=1){
        this.filters[i].renderFrame(firstFrame);
    }
};
function ICompElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? Array.apply(null,{length:this.layers.length}) : [];
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.xt){
        this.layerElement = document.createElementNS(svgNS,'g');
        this.buildAllItems();
    } else if(!globalData.progressiveLoad){
        this.buildAllItems();
    }
}
createElement(SVGBaseElement, ICompElement);

ICompElement.prototype.hide = function(){
    if(!this.hidden){
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
        this.hidden = true;
    }
};

ICompElement.prototype.prepareFrame = function(num){
    this._parent.prepareFrame.call(this,num);
    if(this.isVisible===false && !this.data.xt){
        return;
    }

    if(this.tm){
        var timeRemapped = this.tm.v;
        if(timeRemapped === this.data.op){
            timeRemapped = this.data.op - 1;
        }
        this.renderedFrame = timeRemapped;
    } else {
        this.renderedFrame = num/this.data.sr;
    }
    var i,len = this.elements.length;
    if(!this.completeLayers){
        this.checkLayers(this.renderedFrame);
    }
    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
        }
    }
};

ICompElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    var i,len = this.layers.length;
    if(renderParent===false){
        this.hide();
        return;
    }

    this.hidden = false;
    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

ICompElement.prototype.setElements = function(elems){
    this.elements = elems;
};

ICompElement.prototype.getElements = function(){
    return this.elements;
};

ICompElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    var i,len = this.layers.length;
    for( i = 0; i < len; i+=1 ){
        if(this.elements[i]){
            this.elements[i].destroy();
        }
    }
};

ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers;
ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem;
ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems;
ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting;
ICompElement.prototype.createItem = SVGRenderer.prototype.createItem;
ICompElement.prototype.createImage = SVGRenderer.prototype.createImage;
ICompElement.prototype.createComp = SVGRenderer.prototype.createComp;
ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid;
ICompElement.prototype.createShape = SVGRenderer.prototype.createShape;
ICompElement.prototype.createText = SVGRenderer.prototype.createText;
ICompElement.prototype.createBase = SVGRenderer.prototype.createBase;
ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos;
ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements;
ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement;
function IImageElement(data,parentContainer,globalData,comp,placeholder){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data,parentContainer,globalData,comp,placeholder);
}
createElement(SVGBaseElement, IImageElement);

IImageElement.prototype.createElements = function(){

    var assetPath = this.globalData.getAssetsPath(this.assetData);

    this._parent.createElements.call(this);

    this.innerElem = document.createElementNS(svgNS,'image');
    this.innerElem.setAttribute('width',this.assetData.w+"px");
    this.innerElem.setAttribute('height',this.assetData.h+"px");
    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
    this.maskedElement = this.innerElem;
    this.layerElement.appendChild(this.innerElem);
    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }

};

IImageElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        this.hidden = true;
    }
};

IImageElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.layerElement.style.display = 'block';
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

IImageElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    this.innerElem =  null;
};
function IShapeElement(data,parentContainer,globalData,comp, placeholder){
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.viewData = [];
    this.shapeModifiers = [];
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, IShapeElement);

IShapeElement.prototype.lcEnum = {
    '1': 'butt',
    '2': 'round',
    '3': 'butt'
}

IShapeElement.prototype.ljEnum = {
    '1': 'miter',
    '2': 'round',
    '3': 'butt'
}

IShapeElement.prototype.buildExpressionInterface = function(){};

IShapeElement.prototype.createElements = function(){
    //TODO check if I can use symbol so i can set its viewBox
    this._parent.createElements.call(this);
    this.searchShapes(this.shapesData,this.viewData,this.layerElement,this.dynamicProperties, 0);
    if(!this.data.hd || this.data.td){
        styleUnselectableDiv(this.layerElement);
    }
    //this.elemInterface.registerShapeExpressionInterface(ShapeExpressionInterface.createShapeInterface(this.shapesData,this.viewData,this.elemInterface));
};

IShapeElement.prototype.setGradientData = function(pathElement,arr,data){

    var gradientId = 'gr_'+randomString(10);
    var gfill;
    if(arr.t === 1){
        gfill = document.createElementNS(svgNS,'linearGradient');
    } else {
        gfill = document.createElementNS(svgNS,'radialGradient');
    }
    gfill.setAttribute('id',gradientId);
    gfill.setAttribute('spreadMethod','pad');
    gfill.setAttribute('gradientUnits','userSpaceOnUse');
    var stops = [];
    var stop, j, jLen;
    jLen = arr.g.p*4;
    for(j=0;j<jLen;j+=4){
        stop = document.createElementNS(svgNS,'stop');
        gfill.appendChild(stop);
        stops.push(stop);
    }
    pathElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
    this.globalData.defs.appendChild(gfill);
    data.gf = gfill;
    data.cst = stops;
}

IShapeElement.prototype.setGradientOpacity = function(arr, data, styleOb){
    if((arr.g.k.k[0].s && arr.g.k.k[0].s.length > arr.g.p*4) || arr.g.k.k.length > arr.g.p*4){
        var opFill;
        var stop, j, jLen;
        var mask = document.createElementNS(svgNS,"mask");
        var maskElement = document.createElementNS(svgNS, 'path');
        mask.appendChild(maskElement);
        var opacityId = 'op_'+randomString(10);
        var maskId = 'mk_'+randomString(10);
        mask.setAttribute('id',maskId);
        if(arr.t === 1){
            opFill = document.createElementNS(svgNS,'linearGradient');
        } else {
            opFill = document.createElementNS(svgNS,'radialGradient');
        }
        opFill.setAttribute('id',opacityId);
        opFill.setAttribute('spreadMethod','pad');
        opFill.setAttribute('gradientUnits','userSpaceOnUse');
        jLen = arr.g.k.k[0].s ? arr.g.k.k[0].s.length : arr.g.k.k.length;
        var stops = [];
        for(j=arr.g.p*4;j<jLen;j+=2){
            stop = document.createElementNS(svgNS,'stop');
            stop.setAttribute('stop-color','rgb(255,255,255)');
            //stop.setAttribute('offset',Math.round(arr.y[j][0]*100)+'%');
            //stop.setAttribute('style','stop-color:rgb(255,255,255);stop-opacity:'+arr.y[j][1]);
            opFill.appendChild(stop);
            stops.push(stop);
        }
        maskElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
        this.globalData.defs.appendChild(opFill);
        this.globalData.defs.appendChild(mask);
        data.of = opFill;
        data.ost = stops;
        styleOb.msElem = maskElement;
        return maskId;
    }
};

IShapeElement.prototype.searchShapes = function(arr,data,container,dynamicProperties, level, transformers){
    transformers = transformers || [];
    var ownTransformers = [].concat(transformers);
    var i, len = arr.length - 1;
    var j, jLen;
    var ownArrays = [], ownModifiers = [], styleOb, currentTransform;
    for(i=len;i>=0;i-=1){
        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
            data[i] = {};
            styleOb = {
                type: arr[i].ty,
                d: '',
                ld: '',
                lvl: level,
                mdf: false
            };
            var pathElement = document.createElementNS(svgNS, "path");
            data[i].o = PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties);
            if(arr[i].ty == 'st' || arr[i].ty == 'gs') {
                pathElement.setAttribute('stroke-linecap', this.lcEnum[arr[i].lc] || 'round');
                ////pathElement.style.strokeLinecap = this.lcEnum[arr[i].lc] || 'round';
                pathElement.setAttribute('stroke-linejoin',this.ljEnum[arr[i].lj] || 'round');
                ////pathElement.style.strokeLinejoin = this.ljEnum[arr[i].lj] || 'round';
                pathElement.setAttribute('fill-opacity','0');
                ////pathElement.style.fillOpacity = 0;
                if(arr[i].lj == 1) {
                    pathElement.setAttribute('stroke-miterlimit',arr[i].ml);
                    ////pathElement.style.strokeMiterlimit = arr[i].ml;
                }

                data[i].w = PropertyFactory.getProp(this,arr[i].w,0,null,dynamicProperties);
                if(arr[i].d){
                    var d = PropertyFactory.getDashProp(this,arr[i].d,'svg',dynamicProperties);
                    if(!d.k){
                        pathElement.setAttribute('stroke-dasharray', d.dasharray);
                        ////pathElement.style.strokeDasharray = d.dasharray;
                        pathElement.setAttribute('stroke-dashoffset', d.dashoffset);
                        ////pathElement.style.strokeDashoffset = d.dashoffset;
                    }
                    data[i].d = d;
                }

            }
            if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
                data[i].c = PropertyFactory.getProp(this,arr[i].c,1,255,dynamicProperties);
                container.appendChild(pathElement);
            } else {
                data[i].g = PropertyFactory.getGradientProp(this,arr[i].g,dynamicProperties);
                if(arr[i].t == 2){
                    data[i].h = PropertyFactory.getProp(this,arr[i].h,1,0.01,dynamicProperties);
                    data[i].a = PropertyFactory.getProp(this,arr[i].a,1,degToRads,dynamicProperties);
                }
                data[i].s = PropertyFactory.getProp(this,arr[i].s,1,null,dynamicProperties);
                data[i].e = PropertyFactory.getProp(this,arr[i].e,1,null,dynamicProperties);
                this.setGradientData(pathElement,arr[i],data[i], styleOb);
                var maskId = this.setGradientOpacity(arr[i],data[i], styleOb);
                if(maskId){
                    pathElement.setAttribute('mask','url(#'+maskId+')');
                }
                data[i].elem = pathElement;
                container.appendChild(pathElement);
            }
            if(arr[i].r === 2) {
                pathElement.setAttribute('fill-rule', 'evenodd');
            }

            if(arr[i].ln){
                pathElement.setAttribute('id',arr[i].ln);
            }
            if(arr[i].cl){
                pathElement.setAttribute('class',arr[i].cl);
            }
            styleOb.pElem = pathElement;
            this.stylesList.push(styleOb);
            data[i].style = styleOb;
            ownArrays.push(styleOb);
        }else if(arr[i].ty == 'gr'){
            data[i] = {
                it: []
            };
            var g = document.createElementNS(svgNS,'g');
            container.appendChild(g);
            data[i].gr = g;
            this.searchShapes(arr[i].it,data[i].it,g,dynamicProperties, level + 1, ownTransformers);
        }else if(arr[i].ty == 'tr'){
            data[i] = {
                transform : {
                    op: PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties),
                    mProps: PropertyFactory.getProp(this,arr[i],2,null,dynamicProperties)
                },
                elements: []
            };
            currentTransform = data[i].transform;
            ownTransformers.push(currentTransform);
        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
            data[i] = {
                elements : [],
                caches:[],
                styles : [],
                transformers: ownTransformers,
                lStr: ''
            };
            var ty = 4;
            if(arr[i].ty == 'rc'){
                ty = 5;
            }else if(arr[i].ty == 'el'){
                ty = 6;
            }else if(arr[i].ty == 'sr'){
                ty = 7;
            }
            data[i].sh = ShapePropertyFactory.getShapeProp(this,arr[i],ty,dynamicProperties);
            data[i].lvl = level;
            this.shapes.push(data[i].sh);
            this.addShapeToModifiers(data[i]);
            jLen = this.stylesList.length;
            for(j=0;j<jLen;j+=1){
                if(!this.stylesList[j].closed){
                    data[i].elements.push({
                        ty:this.stylesList[j].type,
                        st: this.stylesList[j]
                    });
                }
            }
        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms' || arr[i].ty == 'rp'){
            var modifier = ShapeModifiers.getModifier(arr[i].ty);
            modifier.init(this,arr[i],dynamicProperties);
            this.shapeModifiers.push(modifier);
            ownModifiers.push(modifier);
            data[i] = modifier;
        }
    }
    len = ownArrays.length;
    for(i=0;i<len;i+=1){
        ownArrays[i].closed = true;
    }
    len = ownModifiers.length;
    for(i=0;i<len;i+=1){
        ownModifiers[i].closed = true;
    }
};

IShapeElement.prototype.addShapeToModifiers = function(data) {
    var i, len = this.shapeModifiers.length;
    for(i=0;i<len;i+=1){
        this.shapeModifiers[i].addShape(data);
    }
};

IShapeElement.prototype.renderModifiers = function() {
    if(!this.shapeModifiers.length){
        return;
    }
    var i, len = this.shapes.length;
    for(i=0;i<len;i+=1){
        this.shapes[i].reset();
    }


    len = this.shapeModifiers.length;

    for(i=len-1;i>=0;i-=1){
        this.shapeModifiers[i].processShapes(this.firstFrame);
    }
};

IShapeElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    this.globalToLocal([0,0,0]);
    if(this.hidden){
        this.layerElement.style.display = 'block';
        this.hidden = false;
    }
    this.renderModifiers();
    this.renderShape(null,null,true, null);
};

IShapeElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        var i, len = this.stylesList.length;
        for(i=len-1;i>=0;i-=1){
            if(this.stylesList[i].ld !== '0'){
                this.stylesList[i].ld = '0';
                this.stylesList[i].pElem.style.display = 'none';
                if(this.stylesList[i].pElem.parentNode){
                    this.stylesList[i].parent = this.stylesList[i].pElem.parentNode;
                    //this.stylesList[i].pElem.parentNode.removeChild(this.stylesList[i].pElem);
                }
            }
        }
        this.hidden = true;
    }
};

IShapeElement.prototype.renderShape = function(items,data,isMain, container){
    var i, len;
    if(!items){
        items = this.shapesData;
        len = this.stylesList.length;
        for(i=0;i<len;i+=1){
            this.stylesList[i].d = '';
            this.stylesList[i].mdf = false;
        }
    }
    if(!data){
        data = this.viewData;
    }
    ///
    ///
    len = items.length - 1;
    var ty;
    for(i=len;i>=0;i-=1){
        ty = items[i].ty;
        if(ty == 'tr'){
            if(this.firstFrame || data[i].transform.op.mdf && container){
                container.setAttribute('opacity',data[i].transform.op.v);
            }
            if(this.firstFrame || data[i].transform.mProps.mdf && container){
                container.setAttribute('transform',data[i].transform.mProps.v.to2dCSS());
            }
        }else if(ty == 'sh' || ty == 'el' || ty == 'rc' || ty == 'sr'){
            this.renderPath(items[i],data[i]);
        }else if(ty == 'fl'){
            this.renderFill(items[i],data[i]);
        }else if(ty == 'gf'){
            this.renderGradient(items[i],data[i]);
        }else if(ty == 'gs'){
            this.renderGradient(items[i],data[i]);
            this.renderStroke(items[i],data[i]);
        }else if(ty == 'st'){
            this.renderStroke(items[i],data[i]);
        }else if(ty == 'gr'){
            this.renderShape(items[i].it,data[i].it,false, data[i].gr);
        }else if(ty == 'tm'){
            //
        }
    }
    if(isMain) {
        len = this.stylesList.length;
        for (i = 0; i < len; i += 1) {
            if (this.stylesList[i].ld === '0') {
                this.stylesList[i].ld = '1';
                this.stylesList[i].pElem.style.display = 'block';
                //this.stylesList[i].parent.appendChild(this.stylesList[i].pElem);
            }
            if (this.stylesList[i].mdf || this.firstFrame) {
                this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d);
                if(this.stylesList[i].msElem){
                    this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
                }
            }
        }
        if (this.firstFrame) {
            this.firstFrame = false;
        }
    }

};

IShapeElement.prototype.renderPath = function(pathData,viewData){
    var len, i, j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = viewData.elements.length;
    var lvl = viewData.lvl;
    for(l=0;l<lLen;l+=1){
        redraw = viewData.sh.mdf || this.firstFrame;
        pathStringTransformed = 'M0 0';
        var paths = viewData.sh.paths;
        jLen = paths._length;
        if(viewData.elements[l].st.lvl < lvl){
            var mat = this.mHelper.reset(), props;
            var iterations = lvl - viewData.elements[l].st.lvl;
            var k = viewData.transformers.length-1;
            while(iterations > 0) {
                redraw = viewData.transformers[k].mProps.mdf || redraw;
                props = viewData.transformers[k].mProps.v.props;
                mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
                iterations --;
                k --;
            }
            if(redraw){
                for(j=0;j<jLen;j+=1){
                    pathNodes = paths.shapes[j];
                    if(pathNodes && pathNodes._length){
                        len = pathNodes._length;
                        for (i = 1; i < len; i += 1) {
                            if (i == 1) {
                                pathStringTransformed += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            }
                            pathStringTransformed += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
                        }
                        if (len == 1) {
                            pathStringTransformed += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                        }
                        if (pathNodes.c) {
                            pathStringTransformed += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            pathStringTransformed += 'z';
                        }
                    }
                }
                viewData.caches[l] = pathStringTransformed;
            } else {
                pathStringTransformed = viewData.caches[l];
            }
        } else {
            if(redraw){
                for(j=0;j<jLen;j+=1){
                    pathNodes = paths.shapes[j];
                    if(pathNodes && pathNodes._length){
                        len = pathNodes._length;
                        for (i = 1; i < len; i += 1) {
                            if (i == 1) {
                                //pathStringTransformed += " M" + groupTransform.mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                                pathStringTransformed += " M" + pathNodes.v[0].join(',');
                            }
                            //pathStringTransformed += " C" + groupTransform.mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
                            pathStringTransformed += " C" + pathNodes.o[i - 1].join(',') + " " + pathNodes.i[i].join(',') + " " + pathNodes.v[i].join(',');
                        }
                        if (len == 1) {
                            //pathStringTransformed += " M" + groupTransform.mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            pathStringTransformed += " M" + pathNodes.v[0].join(',');
                        }
                        if (pathNodes.c && len) {
                            //pathStringTransformed += " C" + groupTransform.mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            pathStringTransformed += " C" + pathNodes.o[i - 1].join(',') + " " + pathNodes.i[0].join(',') + " " + pathNodes.v[0].join(',');
                            pathStringTransformed += 'z';
                        }
                    }
                }
                viewData.caches[l] = pathStringTransformed;
            } else {
                pathStringTransformed = viewData.caches[l];
            }
        }
        viewData.elements[l].st.d += pathStringTransformed;
        viewData.elements[l].st.mdf = redraw || viewData.elements[l].st.mdf;
    }

};

IShapeElement.prototype.renderFill = function(styleData,viewData){
    var styleElem = viewData.style;

    if(viewData.c.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')');
        ////styleElem.pElem.style.fill = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('fill-opacity',viewData.o.v);
    }
};

IShapeElement.prototype.renderGradient = function(styleData,viewData){
    var gfill = viewData.gf;
    var opFill = viewData.of;
    var pt1 = viewData.s.v,pt2 = viewData.e.v;

    if(viewData.o.mdf || this.firstFrame){
        var attr = styleData.ty === 'gf' ? 'fill-opacity':'stroke-opacity';
        viewData.elem.setAttribute(attr,viewData.o.v);
    }
    //clippedElement.setAttribute('transform','matrix(1,0,0,1,-100,0)');
    if(viewData.s.mdf || this.firstFrame){
        var attr1 = styleData.t === 1 ? 'x1':'cx';
        var attr2 = attr1 === 'x1' ? 'y1':'cy';
        gfill.setAttribute(attr1,pt1[0]);
        gfill.setAttribute(attr2,pt1[1]);
        if(opFill){
            opFill.setAttribute(attr1,pt1[0]);
            opFill.setAttribute(attr2,pt1[1]);
        }
    }
    var stops, i, len, stop;
    if(viewData.g.cmdf || this.firstFrame){
        stops = viewData.cst;
        var cValues = viewData.g.c;
        len = stops.length;
        for(i=0;i<len;i+=1){
            stop = stops[i];
            stop.setAttribute('offset',cValues[i*4]+'%');
            stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');
        }
    }
    if(opFill && (viewData.g.omdf || this.firstFrame)){
        stops = viewData.ost;
        var oValues = viewData.g.o;
        len = stops.length;
        for(i=0;i<len;i+=1){
            stop = stops[i];
            stop.setAttribute('offset',oValues[i*2]+'%');
            stop.setAttribute('stop-opacity',oValues[i*2+1]);
        }
    }
    if(styleData.t === 1){
        if(viewData.e.mdf  || this.firstFrame){
            gfill.setAttribute('x2',pt2[0]);
            gfill.setAttribute('y2',pt2[1]);
            if(opFill){
                opFill.setAttribute('x2',pt2[0]);
                opFill.setAttribute('y2',pt2[1]);
            }
        }
    } else {
        var rad;
        if(viewData.s.mdf || viewData.e.mdf || this.firstFrame){
            rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
            gfill.setAttribute('r',rad);
            if(opFill){
                opFill.setAttribute('r',rad);
            }
        }
        if(viewData.e.mdf || viewData.h.mdf || viewData.a.mdf || this.firstFrame){
            if(!rad){
                rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
            }
            var ang = Math.atan2(pt2[1]-pt1[1], pt2[0]-pt1[0]);

            var percent = viewData.h.v >= 1 ? 0.99 : viewData.h.v <= -1 ? -0.99:viewData.h.v;
            var dist = rad*percent;
            var x = Math.cos(ang + viewData.a.v)*dist + pt1[0];
            var y = Math.sin(ang + viewData.a.v)*dist + pt1[1];
            gfill.setAttribute('fx',x);
            gfill.setAttribute('fy',y);
            if(opFill){
                opFill.setAttribute('fx',x);
                opFill.setAttribute('fy',y);
            }
        }
        //gfill.setAttribute('fy','200');
    }
};

IShapeElement.prototype.renderStroke = function(styleData,viewData){
    var styleElem = viewData.style;
    //TODO fix dashes
    var d = viewData.d;
    var dasharray,dashoffset;
    if(d && d.k && (d.mdf || this.firstFrame)){
        styleElem.pElem.setAttribute('stroke-dasharray', d.dasharray);
        ////styleElem.pElem.style.strokeDasharray = d.dasharray;
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset);
        ////styleElem.pElem.style.strokeDashoffset = d.dashoffset;
    }
    if(viewData.c && (viewData.c.mdf || this.firstFrame)){
        styleElem.pElem.setAttribute('stroke','rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')');
        ////styleElem.pElem.style.stroke = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('stroke-opacity',viewData.o.v);
    }
    if(viewData.w.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('stroke-width',viewData.w.v);
        if(styleElem.msElem){
            styleElem.msElem.setAttribute('stroke-width',viewData.w.v);
        }
        ////styleElem.pElem.style.strokeWidth = viewData.w.v;
    }
};

IShapeElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    this.shapeData = null;
    this.viewData = null;
    this.parentContainer = null;
    this.placeholder = null;
};

function ISolidElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, ISolidElement);

ISolidElement.prototype.createElements = function(){
    this._parent.createElements.call(this);

    var rect = document.createElementNS(svgNS,'rect');
    ////rect.style.width = this.data.sw;
    ////rect.style.height = this.data.sh;
    ////rect.style.fill = this.data.sc;
    rect.setAttribute('width',this.data.sw);
    rect.setAttribute('height',this.data.sh);
    rect.setAttribute('fill',this.data.sc);
    this.layerElement.appendChild(rect);
    this.innerElem = rect;
    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }
};

ISolidElement.prototype.hide = IImageElement.prototype.hide;
ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
ISolidElement.prototype.destroy = IImageElement.prototype.destroy;

var animationManager = (function(){
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var idled = true;
    var playingAnimationsNum = 0;

    function removeElement(ev){
        var i = 0;
        var animItem = ev.target;
        while(i<len) {
            if (registeredAnimations[i].animation === animItem) {
                registeredAnimations.splice(i, 1);
                i -= 1;
                len -= 1;
                if(!animItem.isPaused){
                    subtractPlayingCount();   
                }
            }
            i += 1;
        }
    }

    function registerAnimation(element, animationData){
        if(!element){
            return null;
        }
        var i=0;
        while(i<len){
            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
                return registeredAnimations[i].animation;
            }
            i+=1;
        }
        var animItem = new AnimationItem();
        setupAnimation(animItem, element);
        animItem.setData(element, animationData);
        return animItem;
    }

    function addPlayingCount(){
        playingAnimationsNum += 1;
        activate();
    }

    function subtractPlayingCount(){
        playingAnimationsNum -= 1;
        if(playingAnimationsNum === 0){
            idled = true;
        }
    }

    function setupAnimation(animItem, element){
        animItem.addEventListener('destroy',removeElement);
        animItem.addEventListener('_active',addPlayingCount);
        animItem.addEventListener('_idle',subtractPlayingCount);
        registeredAnimations.push({elem: element,animation:animItem});
        len += 1;
    }

    function loadAnimation(params){
        var animItem = new AnimationItem();
        setupAnimation(animItem, null);
        animItem.setParams(params);
        return animItem;
    }


    function setSpeed(val,animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.setSpeed(val, animation);
        }
    }

    function setDirection(val, animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.setDirection(val, animation);
        }
    }

    function play(animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.play(animation);
        }
    }

    function moveFrame (value, animation) {
        initTime = Date.now();
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.moveFrame(value,animation);
        }
    }

    function resume(nowTime) {

        var elapsedTime = nowTime - initTime;
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.advanceTime(elapsedTime);
        }
        initTime = nowTime;
        if(!idled) {
            requestAnimationFrame(resume);
        }
    }

    function first(nowTime){
        initTime = nowTime;
        requestAnimationFrame(resume);
    }

    function pause(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.pause(animation);
        }
    }

    function goToAndStop(value,isFrame,animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
        }
    }

    function stop(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.stop(animation);
        }
    }

    function togglePause(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.togglePause(animation);
        }
    }

    function destroy(animation) {
        var i;
        for(i=(len-1);i>=0;i-=1){
            registeredAnimations[i].animation.destroy(animation);
        }
    }

    function searchAnimations(animationData, standalone, renderer){
        var animElements = document.getElementsByClassName('bodymovin');
        var i, len = animElements.length;
        for(i=0;i<len;i+=1){
            if(renderer){
                animElements[i].setAttribute('data-bm-type',renderer);
            }
            registerAnimation(animElements[i], animationData);
        }
        if(standalone && len === 0){
            if(!renderer){
                renderer = 'svg';
            }
            var body = document.getElementsByTagName('body')[0];
            body.innerHTML = '';
            var div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.setAttribute('data-bm-type',renderer);
            body.appendChild(div);
            registerAnimation(div, animationData);
        }
    }

    function resize(){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.resize();
        }
    }

    function start(){
        requestAnimationFrame(first);
    }

    function activate(){
        if(idled){
            idled = false;
            requestAnimationFrame(first);
        }
    }

    //start();

    setTimeout(start,0);

    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.moveFrame = moveFrame;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize;
    moduleOb.start = start;
    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    return moduleOb;
}());
var AnimationItem = function () {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.pendingElements = 0;
    this.playCount = 0;
    this.prerenderFramesFlag = true;
    this.animationData = {};
    this.layers = [];
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = randomString(10);
    this.scaleMode = 'fit';
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.subframeEnabled = subframeEnabled;
    this.segments = [];
    this.pendingSegment = false;
    this._idle = true;
    this.projectInterface = ProjectInterface();
};

AnimationItem.prototype.setParams = function(params) {
    var self = this;
    if(params.context){
        this.context = params.context;
    }
    if(params.wrapper || params.container){
        this.wrapper = params.wrapper || params.container;
    }
    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
    switch(animType){
        case 'canvas':
            this.renderer = new CanvasRenderer(this, params.rendererSettings);
            break;
        case 'svg':
            this.renderer = new SVGRenderer(this, params.rendererSettings);
            break;
        case 'hybrid':
        case 'html':
        default:
            this.renderer = new HybridRenderer(this, params.rendererSettings);
            break;
    }
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;

    if(params.loop === '' || params.loop === null){
    }else if(params.loop === false){
        this.loop = false;
    }else if(params.loop === true){
        this.loop = true;
    }else{
        this.loop = parseInt(params.loop);
    }
    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name :  '';
    this.prerenderFramesFlag = 'prerender' in params ? params.prerender : true;
    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
    if(params.animationData){
        self.configAnimation(params.animationData);
    }else if(params.path){
        if(params.path.substr(-4) != 'json'){
            if (params.path.substr(-1, 1) != '/') {
                params.path += '/';
            }
            params.path += 'data.json';
        }

        var xhr = new XMLHttpRequest();
        if(params.path.lastIndexOf('\\') != -1){
            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
        }else{
            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
        }
        this.assetsPath = params.assetsPath;
        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
        xhr.open('GET', params.path, true);
        xhr.send();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if(xhr.status == 200){
                    self.configAnimation(JSON.parse(xhr.responseText));
                }else{
                    try{
                        var response = JSON.parse(xhr.responseText);
                        self.configAnimation(response);
                    }catch(err){
                    }
                }
            }
        };
    }
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
    var params = {
        wrapper: wrapper,
        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
    };
    var wrapperAttributes = wrapper.attributes;

    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';

    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
    if(loop === ''){
    }else if(loop === 'false'){
        params.loop = false;
    }else if(loop === 'true'){
        params.loop = true;
    }else{
        params.loop = parseInt(loop);
    }
    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== "false";

    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

    if(prerender === 'false'){
        params.prerender = false;
    }
    this.setParams(params);
};

AnimationItem.prototype.includeLayers = function(data) {
    if(data.op > this.animationData.op){
        this.animationData.op = data.op;
        this.totalFrames = Math.floor(data.op - this.animationData.ip);
        this.animationData.tf = this.totalFrames;
    }
    var layers = this.animationData.layers;
    var i, len = layers.length;
    var newLayers = data.layers;
    var j, jLen = newLayers.length;
    for(j=0;j<jLen;j+=1){
        i = 0;
        while(i<len){
            if(layers[i].id == newLayers[j].id){
                layers[i] = newLayers[j];
                break;
            }
            i += 1;
        }
    }
    if(data.chars || data.fonts){
        this.renderer.globalData.fontManager.addChars(data.chars);
        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }
    if(data.assets){
        len = data.assets.length;
        for(i = 0; i < len; i += 1){
            this.animationData.assets.push(data.assets[i]);
        }
    }
    //this.totalFrames = 50;
    //this.animationData.tf = 50;
    this.animationData.__complete = false;
    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
    this.renderer.includeLayers(data.layers);
    if(expressionsPlugin){
        expressionsPlugin.initExpressions(this);
    }
    this.renderer.renderFrame(null);
    this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function() {
    var segments = this.animationData.segments;
    if(!segments || segments.length === 0 || !this.autoloadSegments){
        this.trigger('data_ready');
        this.timeCompleted = this.animationData.tf;
        return;
    }
    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var xhr = new XMLHttpRequest();
    var self = this;
    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    xhr.open('GET', segmentPath, true);
    xhr.send();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if(xhr.status == 200){
                self.includeLayers(JSON.parse(xhr.responseText));
            }else{
                try{
                    var response = JSON.parse(xhr.responseText);
                    self.includeLayers(response);
                }catch(err){
                }
            }
        }
    };
};

AnimationItem.prototype.loadSegments = function() {
    var segments = this.animationData.segments;
    if(!segments) {
        this.timeCompleted = this.animationData.tf;
    }
    this.loadNextSegment();
};

AnimationItem.prototype.configAnimation = function (animData) {
    if(this.renderer && this.renderer.destroyed){
        return;
    }
    //console.log(JSON.parse(JSON.stringify(animData)));
    //animData.w = Math.round(animData.w/blitter);
    //animData.h = Math.round(animData.h/blitter);
    this.animationData = animData;
    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
    this.animationData.tf = this.totalFrames;
    this.renderer.configAnimation(animData);
    if(!animData.assets){
        animData.assets = [];
    }
    if(animData.comps) {
        animData.assets = animData.assets.concat(animData.comps);
        animData.comps = null;
    }
    this.renderer.searchExtraCompositions(animData.assets);

    this.layers = this.animationData.layers;
    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.firstFrame = Math.round(this.animationData.ip);
    this.frameMult = this.animationData.fr / 1000;
    this.trigger('config_ready');
    this.imagePreloader = new ImagePreloader();
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(animData.assets);
    this.loadSegments();
    this.updaFrameModifier();
    if(this.renderer.globalData.fontManager){
        this.waitForFontsLoaded();
    }else{
        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
        this.checkLoaded();
    }
};

AnimationItem.prototype.waitForFontsLoaded = (function(){
    function checkFontsLoaded(){
        if(this.renderer.globalData.fontManager.loaded){
            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
            //this.renderer.buildItems(this.animationData.layers);
            this.checkLoaded();
        }else{
            setTimeout(checkFontsLoaded.bind(this),20);
        }
    }

    return function(){
        checkFontsLoaded.bind(this)();
    }
}());

AnimationItem.prototype.addPendingElement = function () {
    this.pendingElements += 1;
}

AnimationItem.prototype.elementLoaded = function () {
    this.pendingElements--;
    this.checkLoaded();
};

AnimationItem.prototype.checkLoaded = function () {
    if (this.pendingElements === 0) {
        if(expressionsPlugin){
            expressionsPlugin.initExpressions(this);
        }
        this.renderer.initItems();
        setTimeout(function(){
            this.trigger('DOMLoaded');
        }.bind(this),0);
        this.isLoaded = true;
        this.gotoFrame();
        if(this.autoplay){
            this.play();
        }
    }
};

AnimationItem.prototype.resize = function () {
    this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function(flag){
    this.subframeEnabled = flag ? true : false;
}

AnimationItem.prototype.gotoFrame = function () {
    if(this.subframeEnabled){
        this.currentFrame = this.currentRawFrame;
    }else{
        this.currentFrame = Math.floor(this.currentRawFrame);
    }

    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
        this.currentFrame = this.timeCompleted;
    }
    this.trigger('enterFrame');
    this.renderFrame();
};

AnimationItem.prototype.renderFrame = function () {
    if(this.isLoaded === false){
        return;
    }
    //console.log('this.currentFrame:',this.currentFrame + this.firstFrame);
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
};

AnimationItem.prototype.play = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === true){
        this.isPaused = false;
        if(this._idle){
            this._idle = false;
            this.trigger('_active');
        }
    }
};

AnimationItem.prototype.pause = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === false){
        this.isPaused = true;
        if(!this.pendingSegment){
            this._idle = true;
            this.trigger('_idle');
        }
    }
};

AnimationItem.prototype.togglePause = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === true){
        this.play();
    }else{
        this.pause();
    }
};

AnimationItem.prototype.stop = function (name) {
    if(name && this.name != name){
        return;
    }
    this.pause();
    this.currentFrame = this.currentRawFrame = 0;
    this.playCount = 0;
    this.gotoFrame();
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if(name && this.name != name){
        return;
    }
    if(isFrame){
        this.setCurrentRawFrameValue(value);
    }else{
        this.setCurrentRawFrameValue(value * this.frameModifier);
    }
    this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    this.goToAndStop(value, isFrame, name);
    this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
    if(this.pendingSegment){
        this.pendingSegment = false;
        this.adjustSegment(this.segments.shift());
        if(this.isPaused){
            this.play();
        }
        return;
    }
    if (this.isPaused === true || this.isLoaded === false) {
        return;
    }
    this.setCurrentRawFrameValue(this.currentRawFrame + value * this.frameModifier);
};

AnimationItem.prototype.updateAnimation = function (perc) {
    this.setCurrentRawFrameValue(this.totalFrames * perc);
};

AnimationItem.prototype.moveFrame = function (value, name) {
    if(name && this.name != name){
        return;
    }
    this.setCurrentRawFrameValue(this.currentRawFrame+value);
};

AnimationItem.prototype.adjustSegment = function(arr){
    this.playCount = 0;
    if(arr[1] < arr[0]){
        if(this.frameModifier > 0){
            if(this.playSpeed < 0){
                this.setSpeed(-this.playSpeed);
            } else {
                this.setDirection(-1);
            }
        }
        this.totalFrames = arr[0] - arr[1];
        this.firstFrame = arr[1];
        this.setCurrentRawFrameValue(this.totalFrames - 0.01);
    } else if(arr[1] > arr[0]){
        if(this.frameModifier < 0){
            if(this.playSpeed < 0){
                this.setSpeed(-this.playSpeed);
            } else {
                this.setDirection(1);
            }
        }
        this.totalFrames = arr[1] - arr[0];
        this.firstFrame = arr[0];
        this.setCurrentRawFrameValue(0);
    }
    this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init,end) {
    var pendingFrame = -1;
    if(this.isPaused) {
        if (this.currentRawFrame + this.firstFrame < init) {
            pendingFrame = init;
        } else if (this.currentRawFrame + this.firstFrame > end) {
            pendingFrame = end - init - 0.01;
        }
    }

    this.firstFrame = init;
    this.totalFrames = end - init;
    if(pendingFrame !== -1) {
        this.goToAndStop(pendingFrame,true);
    }
}

AnimationItem.prototype.playSegments = function (arr,forceFlag) {
    if(typeof arr[0] === 'object'){
        var i, len = arr.length;
        for(i=0;i<len;i+=1){
            this.segments.push(arr[i]);
        }
    }else{
        this.segments.push(arr);
    }
    if(forceFlag){
        this.adjustSegment(this.segments.shift());
    }
    if(this.isPaused){
        this.play();
    }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
    if(forceFlag){
        this.adjustSegment(this.segments.shift());
    }
};
AnimationItem.prototype.checkSegments = function(){
    if(this.segments.length){
        this.pendingSegment = true;
    }
}

AnimationItem.prototype.remove = function (name) {
    if(name && this.name != name){
        return;
    }
    this.renderer.destroy();
};

AnimationItem.prototype.destroy = function (name) {
    if((name && this.name != name) || (this.renderer && this.renderer.destroyed)){
        return;
    }
    this.renderer.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function(value){
    this.currentRawFrame = value;
    //console.log(this.totalFrames);
    if (this.currentRawFrame >= this.totalFrames) {
        this.checkSegments();
        if(this.loop === false){
            this.currentRawFrame = this.totalFrames - 0.01;
            this.gotoFrame();
            this.pause();
            this.trigger('complete');
            return;
        }else{
            this.trigger('loopComplete');
            this.playCount += 1;
            if((this.loop !== true && this.playCount == this.loop) || this.pendingSegment){
                this.currentRawFrame = this.totalFrames - 0.01;
                this.gotoFrame();
                this.pause();
                this.trigger('complete');
                return;
            } else {
                this.currentRawFrame = this.currentRawFrame % this.totalFrames;
            }
        }
    } else if (this.currentRawFrame < 0) {
        this.checkSegments();
        this.playCount -= 1;
        if(this.playCount < 0){
            this.playCount = 0;
        }
        if(this.loop === false  || this.pendingSegment){
            this.currentRawFrame = 0;
            this.gotoFrame();
            this.pause();
            this.trigger('complete');
            return;
        }else{
            this.trigger('loopComplete');
            this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames;
            this.gotoFrame();
            return;
        }
    }

    this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
};

AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
};

AnimationItem.prototype.getPath = function () {
    return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';
    if(this.assetsPath){
        var imagePath = assetData.p;
        if(imagePath.indexOf('images/') !== -1){
            imagePath = imagePath.split('/')[1];
        }
        path = this.assetsPath + imagePath;
    } else {
        path = this.path;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
    }
    return path;
};

AnimationItem.prototype.getAssetData = function (id) {
    var i = 0, len = this.assets.length;
    while (i < len) {
        if(id == this.assets[i].id){
            return this.assets[i];
        }
        i += 1;
    }
};

AnimationItem.prototype.hide = function () {
    this.renderer.hide();
};

AnimationItem.prototype.show = function () {
    this.renderer.show();
};

AnimationItem.prototype.getAssets = function () {
    return this.assets;
};

AnimationItem.prototype.trigger = function(name){
    if(this._cbs && this._cbs[name]){
        switch(name){
            case 'enterFrame':
                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
                break;
            case 'loopComplete':
                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name,new BMDestroyEvent(name,this));
                break;
            default:
                this.triggerEvent(name);
        }
    }
    if(name === 'enterFrame' && this.onEnterFrame){
        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
    }
    if(name === 'loopComplete' && this.onLoopComplete){
        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
    }
    if(name === 'complete' && this.onComplete){
        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
    }
    if(name === 'segmentStart' && this.onSegmentStart){
        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
    }
    if(name === 'destroy' && this.onDestroy){
        this.onDestroy.call(this,new BMDestroyEvent(name,this));
    }
};

AnimationItem.prototype.addEventListener = _addEventListener;
AnimationItem.prototype.removeEventListener = _removeEventListener;
AnimationItem.prototype.triggerEvent = _triggerEvent;

function CanvasRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.renderConfig = {
        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
        context: (config && config.context) || null,
        progressiveLoad: (config && config.progressiveLoad) || false,
        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet'
    };
    this.renderConfig.dpr = (config && config.dpr) || 1;
    if (this.animationItem.wrapper) {
        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
    }
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.contextData = {
        saved : Array.apply(null,{length:15}),
        savedOp: Array.apply(null,{length:15}),
        cArrPos : 0,
        cTr : new Matrix(),
        cO : 1
    };
    var i, len = 15;
    for(i=0;i<len;i+=1){
        this.contextData.saved[i] = Array.apply(null,{length:16});
    }
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
}
extendPrototype(BaseRenderer,CanvasRenderer);

CanvasRenderer.prototype.createBase = function (data) {
    return new CVBaseElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createShape = function (data) {
    return new CVShapeElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createText = function (data) {
    return new CVTextElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createImage = function (data) {
    return new CVImageElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createComp = function (data) {
    return new CVCompElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createSolid = function (data) {
    return new CVSolidElement(data, this, this.globalData);
};

CanvasRenderer.prototype.ctxTransform = function(props){
    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
        return;
    }
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
        return;
    }
    this.transformMat.cloneFromProps(props);
    this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15])
    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
    this.contextData.cTr.cloneFromProps(this.transformMat.props);
    var trProps = this.contextData.cTr.props;
    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function(op){
    if(op === 1){
        return;
    }
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
        return;
    }
    this.contextData.cO *= op < 0 ? 0 : op;
    this.canvasContext.globalAlpha = this.contextData.cO;
};

CanvasRenderer.prototype.reset = function(){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.restore();
        return;
    }
    this.contextData.cArrPos = 0;
    this.contextData.cTr.reset();
    this.contextData.cO = 1;
};

CanvasRenderer.prototype.save = function(actionFlag){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.save();
        return;
    }
    if(actionFlag){
        this.canvasContext.save();
    }
    var props = this.contextData.cTr.props;
    if(this.contextData.saved[this.contextData.cArrPos] === null || this.contextData.saved[this.contextData.cArrPos] === undefined){
        this.contextData.saved[this.contextData.cArrPos] = new Array(16);
    }
    var i,arr = this.contextData.saved[this.contextData.cArrPos];
    for(i=0;i<16;i+=1){
        arr[i] = props[i];
    }
    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
    this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function(actionFlag){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.restore();
        return;
    }
    if(actionFlag){
        this.canvasContext.restore();
    }
    this.contextData.cArrPos -= 1;
    var popped = this.contextData.saved[this.contextData.cArrPos];
    var i,arr = this.contextData.cTr.props;
    for(i=0;i<16;i+=1){
        arr[i] = popped[i];
    }
    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
    popped = this.contextData.savedOp[this.contextData.cArrPos];
    this.contextData.cO = popped;
    this.canvasContext.globalAlpha = popped;
};

CanvasRenderer.prototype.configAnimation = function(animData){
    if(this.animationItem.wrapper){
        this.animationItem.container = document.createElement('canvas');
        this.animationItem.container.style.width = '100%';
        this.animationItem.container.style.height = '100%';
        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.animationItem.container);
        this.canvasContext = this.animationItem.container.getContext('2d');
    }else{
        this.canvasContext = this.renderConfig.context;
    }
    this.data = animData;
    this.globalData.canvasContext = this.canvasContext;
    this.globalData.renderer = this;
    this.globalData.isDashed = false;
    this.globalData.totalFrames = Math.floor(animData.tf);
    this.globalData.compWidth = animData.w;
    this.globalData.compHeight = animData.h;
    this.globalData.frameRate = animData.fr;
    this.globalData.frameId = 0;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.layers = animData.layers;
    this.transformCanvas = {};
    this.transformCanvas.w = animData.w;
    this.transformCanvas.h = animData.h;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,document.body);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
    this.globalData.transformCanvas = this.transformCanvas;
    this.elements = Array.apply(null,{length:animData.layers.length});

    this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
    var elementWidth,elementHeight;
    if(this.animationItem.wrapper && this.animationItem.container){
        elementWidth = this.animationItem.wrapper.offsetWidth;
        elementHeight = this.animationItem.wrapper.offsetHeight;
        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
    }else{
        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
    }
    var elementRel,animationRel;
    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
        var par = this.renderConfig.preserveAspectRatio.split(' ');
        var fillType = par[1] || 'meet';
        var pos = par[0] || 'xMidYMid';
        var xPos = pos.substr(0,4);
        var yPos = pos.substr(4);
        elementRel = elementWidth/elementHeight;
        animationRel = this.transformCanvas.w/this.transformCanvas.h;
        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
        }else{
            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
        }

        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
        } else {
            this.transformCanvas.tx = 0;
        }
        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
        } else {
            this.transformCanvas.ty = 0;
        }

    }else if(this.renderConfig.preserveAspectRatio == 'none'){
        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
        this.transformCanvas.tx = 0;
        this.transformCanvas.ty = 0;
    }else{
        this.transformCanvas.sx = this.renderConfig.dpr;
        this.transformCanvas.sy = this.renderConfig.dpr;
        this.transformCanvas.tx = 0;
        this.transformCanvas.ty = 0;
    }
    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
    var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    }
};

CanvasRenderer.prototype.destroy = function () {
    if(this.renderConfig.clearCanvas) {
        this.animationItem.wrapper.innerHTML = '';
    }
    var i, len = this.layers ? this.layers.length : 0;
    for (i = len - 1; i >= 0; i-=1) {
        this.elements[i].destroy();
    }
    this.elements.length = 0;
    this.globalData.canvasContext = null;
    this.animationItem.container = null;
    this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function(num){
    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === null){
        return;
    }
    this.renderedFrame = num;
    this.globalData.frameNum = num - this.animationItem.firstFrame;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    if(this.renderConfig.clearCanvas === true){
        this.reset();
        this.canvasContext.save();
        //this.canvasContext.canvas.width = this.canvasContext.canvas.width;
        this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w*this.transformCanvas.sx, this.transformCanvas.h*this.transformCanvas.sy);
    }else{
        this.save();
    }
    this.ctxTransform(this.transformCanvas.props);
    this.canvasContext.beginPath();
    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
    this.canvasContext.closePath();
    this.canvasContext.clip();

    //console.log('--------');
    //console.log('NEW: ',num);
    var i, len = this.layers.length;
    if(!this.completeLayers){
        this.checkLayers(num);
    }

    for (i = 0; i < len; i++) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(num - this.layers[i].st);
        }
    }
    for (i = len - 1; i >= 0; i-=1) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.renderConfig.clearCanvas !== true){
        this.restore();
    } else {
        this.canvasContext.restore();
    }
};

CanvasRenderer.prototype.buildItem = function(pos){
    var elements = this.elements;
    if(elements[pos] || this.layers[pos].ty == 99){
        return;
    }
    var element = this.createItem(this.layers[pos], this,this.globalData);
    elements[pos] = element;
    element.initExpressions();
    if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    }
};

CanvasRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
    }
};

CanvasRenderer.prototype.hide = function(){
    this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function(){
    this.animationItem.container.style.display = 'block';
};

CanvasRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElementNS(svgNS,'g');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],this.globalData.comp,this.globalData);
            comp.initExpressions();
            //comp.compInterface = CompExpressionInterface(comp);
            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};
function HybridRenderer(animationItem){
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;

}

extendPrototype(BaseRenderer,HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
    }
};

HybridRenderer.prototype.appendElementInPos = function(element, pos){
    var newElement = element.getBaseElement();
    if(!newElement){
        return;
    }
    var layer = this.layers[pos];
    if(!layer.ddd || !this.supports3d){
        var i = 0;
        var nextElement;
        while(i<pos){
            if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
                nextElement = this.elements[i].getBaseElement();
            }
            i += 1;
        }
        if(nextElement){
            if(!layer.ddd || !this.supports3d){
                this.layerElement.insertBefore(newElement, nextElement);
            }
        } else {
            if(!layer.ddd || !this.supports3d){
                this.layerElement.appendChild(newElement);
            }
        }
    } else {
        this.addTo3dContainer(newElement,pos);
    }
};


HybridRenderer.prototype.createBase = function (data) {
    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createShape = function (data) {
    if(!this.supports3d){
        return new IShapeElement(data, this.layerElement,this.globalData,this);
    }
    return new HShapeElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createText = function (data) {
    if(!this.supports3d){
        return new SVGTextElement(data, this.layerElement,this.globalData,this);
    }
    return new HTextElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createCamera = function (data) {
    this.camera = new HCameraElement(data, this.layerElement,this.globalData,this);
    return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
    if(!this.supports3d){
        return new IImageElement(data, this.layerElement,this.globalData,this);
    }
    return new HImageElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createComp = function (data) {
    if(!this.supports3d){
        return new ICompElement(data, this.layerElement,this.globalData,this);
    }
    return new HCompElement(data, this.layerElement,this.globalData,this);

};

HybridRenderer.prototype.createSolid = function (data) {
    if(!this.supports3d){
        return new ISolidElement(data, this.layerElement,this.globalData,this);
    }
    return new HSolidElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.getThreeDContainer = function(pos){
    var perspectiveElem = document.createElement('div');
    styleDiv(perspectiveElem);
    perspectiveElem.style.width = this.globalData.compSize.w+'px';
    perspectiveElem.style.height = this.globalData.compSize.h+'px';
    perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
    var container = document.createElement('div');
    styleDiv(container);
    container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    perspectiveElem.appendChild(container);
    this.resizerElem.appendChild(perspectiveElem);
    var threeDContainerData = {
        container:container,
        perspectiveElem:perspectiveElem,
        startPos: pos,
        endPos: pos
    };
    this.threeDElements.push(threeDContainerData);
    return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function(){
    var i, len = this.layers.length;
    var lastThreeDContainerData;
    for(i=0;i<len;i+=1){
        if(this.layers[i].ddd){
            if(!lastThreeDContainerData){
                lastThreeDContainerData = this.getThreeDContainer(i);
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
        } else {
            lastThreeDContainerData = null;
        }
    }
};

HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
    var i = 0, len = this.threeDElements.length;
    while(i<len){
        if(pos <= this.threeDElements[i].endPos){
            var j = this.threeDElements[i].startPos;
            var nextElement;
            while(j<pos){
                if(this.elements[j] && this.elements[j].getBaseElement){
                    nextElement = this.elements[j].getBaseElement();
                }
                j += 1;
            }
            if(nextElement){
                this.threeDElements[i].container.insertBefore(elem, nextElement);
            } else {
                this.threeDElements[i].container.appendChild(elem);
            }
            break;
        }
        i += 1;
    }
};

HybridRenderer.prototype.configAnimation = function(animData){
    var resizerElem = document.createElement('div');
    var wrapper = this.animationItem.wrapper;
    resizerElem.style.width = animData.w+'px';
    resizerElem.style.height = animData.h+'px';
    this.resizerElem = resizerElem;
    styleDiv(resizerElem);
    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
    wrapper.appendChild(resizerElem);

    resizerElem.style.overflow = 'hidden';
    var svg = document.createElementNS(svgNS,'svg');
    svg.setAttribute('width','1');
    svg.setAttribute('height','1');
    styleDiv(svg);
    this.resizerElem.appendChild(svg);
    var defs = document.createElementNS(svgNS,'defs');
    svg.appendChild(defs);
    this.globalData.defs = defs;
    this.data = animData;
    //Mask animation
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
    this.globalData.frameId = 0;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.globalData.frameRate = animData.fr;
    this.layers = animData.layers;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,svg);
    this.layerElement = this.resizerElem;
    this.build3dContainers();
    this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
    this.animationItem.wrapper.innerHTML = '';
    this.animationItem.container = null;
    this.globalData.defs = null;
    var i, len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i++) {
        this.elements[i].destroy();
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
    var elementWidth = this.animationItem.wrapper.offsetWidth;
    var elementHeight = this.animationItem.wrapper.offsetHeight;
    var elementRel = elementWidth/elementHeight;
    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
    var sx,sy,tx,ty;
    if(animationRel>elementRel){
        sx = elementWidth/(this.globalData.compSize.w);
        sy = elementWidth/(this.globalData.compSize.w);
        tx = 0;
        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
    }else{
        sx = elementHeight/(this.globalData.compSize.h);
        sy = elementHeight/(this.globalData.compSize.h);
        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
        ty = 0;
    }
    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function(){
    this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function(){
    this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function(){
    this.buildAllItems();
    if(this.camera){
        this.camera.setup();
    } else {
        var cWidth = this.globalData.compSize.w;
        var cHeight = this.globalData.compSize.h;
        var i, len = this.threeDElements.length;
        for(i=0;i<len;i+=1){
            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
        }
    }
};

HybridRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElement('div');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};
function CVBaseElement(data, comp,globalData){
    this.globalData = globalData;
    this.data = data;
    this.comp = comp;
    this.canvasContext = globalData.canvasContext;
    this.init();
}

createElement(BaseElement, CVBaseElement);

CVBaseElement.prototype.createElements = function(){
    this.checkParenting();
};

CVBaseElement.prototype.checkBlendMode = function(globalData){
    if(globalData.blendMode !== this.data.bm) {
        globalData.blendMode = this.data.bm;

        var blendModeValue = '';
        switch (this.data.bm) {
            case 0:
                blendModeValue = 'normal';
                break;
            case 1:
                blendModeValue = 'multiply';
                break;
            case 2:
                blendModeValue = 'screen';
                break;
            case 3:
                blendModeValue = 'overlay';
                break;
            case 4:
                blendModeValue = 'darken';
                break;
            case 5:
                blendModeValue = 'lighten';
                break;
            case 6:
                blendModeValue = 'color-dodge';
                break;
            case 7:
                blendModeValue = 'color-burn';
                break;
            case 8:
                blendModeValue = 'hard-light';
                break;
            case 9:
                blendModeValue = 'soft-light';
                break;
            case 10:
                blendModeValue = 'difference';
                break;
            case 11:
                blendModeValue = 'exclusion';
                break;
            case 12:
                blendModeValue = 'hue';
                break;
            case 13:
                blendModeValue = 'saturation';
                break;
            case 14:
                blendModeValue = 'color';
                break;
            case 15:
                blendModeValue = 'luminosity';
                break;
        }
        globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
};


CVBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3){
        return false;
    }
        this.checkBlendMode(this.data.ty === 0?this.parentGlobalData:this.globalData);

    if(!this.isVisible){
        return this.isVisible;
    }
    this.finalTransform.opMdf = this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i, len = this.hierarchy.length;
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for(i=0;i<len;i+=1){
            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        }
    }else{
        if(!parentTransform){
            finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
        }else{
            mat = this.finalTransform.mProp.v.props;
            finalMat.cloneFromProps(mat);
        }
    }

    if(parentTransform){
        mat = parentTransform.mat.props;
        finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        this.finalTransform.opacity *= parentTransform.opacity;
        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
    }

    if(this.data.hasMask){
        this.globalData.renderer.save(true);
        this.maskManager.renderFrame(this.data.ty === 0?null:finalMat);
    }
    if(this.data.hd){
        this.isVisible = false;
    }
    return this.isVisible;

};

CVBaseElement.prototype.addMasks = function(data){
    this.maskManager = new CVMaskElement(data,this,this.globalData);
};


CVBaseElement.prototype.destroy = function(){
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    if(this.maskManager) {
        this.maskManager.destroy();
    }
};

CVBaseElement.prototype.mHelper = new Matrix();

function CVCompElement(data, comp,globalData){
    this._parent.constructor.call(this,data, comp,globalData);
    var compGlobalData = {};
    for(var s in globalData){
        if(globalData.hasOwnProperty(s)){
            compGlobalData[s] = globalData[s];
        }
    }
    compGlobalData.renderer = this;
    compGlobalData.compHeight = this.data.h;
    compGlobalData.compWidth = this.data.w;
    this.renderConfig = {
        clearCanvas: true
    };
    this.contextData = {
        saved : Array.apply(null,{length:15}),
        savedOp: Array.apply(null,{length:15}),
        cArrPos : 0,
        cTr : new Matrix(),
        cO : 1
    };
    this.completeLayers = false;
    var i, len = 15;
    for(i=0;i<len;i+=1){
        this.contextData.saved[i] = Array.apply(null,{length:16});
    }
    this.transformMat = new Matrix();
    this.parentGlobalData = this.globalData;
    var cv = document.createElement('canvas');
    //document.body.appendChild(cv);
    compGlobalData.canvasContext = cv.getContext('2d');
    this.canvasContext = compGlobalData.canvasContext;
    cv.width = this.data.w;
    cv.height = this.data.h;
    this.canvas = cv;
    this.globalData = compGlobalData;
    this.layers = data.layers;
    this.pendingElements = [];
    this.elements = Array.apply(null,{length:this.layers.length});
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.xt || !globalData.progressiveLoad){
        this.buildAllItems();
    }
}
createElement(CVBaseElement, CVCompElement);

CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform;
CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity;
CVCompElement.prototype.save = CanvasRenderer.prototype.save;
CVCompElement.prototype.restore = CanvasRenderer.prototype.restore;
CVCompElement.prototype.reset =  function(){
    this.contextData.cArrPos = 0;
    this.contextData.cTr.reset();
    this.contextData.cO = 1;
};
CVCompElement.prototype.resize = function(transformCanvas){
    var maxScale = Math.max(transformCanvas.sx,transformCanvas.sy);
    this.canvas.width = this.data.w*maxScale;
    this.canvas.height = this.data.h*maxScale;
    this.transformCanvas = {
        sc:maxScale,
        w:this.data.w*maxScale,
        h:this.data.h*maxScale,
        props:[maxScale,0,0,0,0,maxScale,0,0,0,0,1,0,0,0,0,1]
    }
    var i,len = this.elements.length;
    for( i = 0; i < len; i+=1 ){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(transformCanvas);
        }
    }
};

CVCompElement.prototype.prepareFrame = function(num){
    this.globalData.frameId = this.parentGlobalData.frameId;
    this.globalData.mdf = false;
    this._parent.prepareFrame.call(this,num);
    if(this.isVisible===false && !this.data.xt){
        return;
    }
    var timeRemapped = num;
    if(this.tm){
        timeRemapped = this.tm.v;
        if(timeRemapped === this.data.op){
            timeRemapped = this.data.op - 1;
        }
    }
    this.renderedFrame = timeRemapped/this.data.sr;
    var i,len = this.elements.length;

    if(!this.completeLayers){
        this.checkLayers(num);
    }

    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(timeRemapped/this.data.sr - this.layers[i].st);
            if(this.elements[i].data.ty === 0 && this.elements[i].globalData.mdf){
                this.globalData.mdf = true;
            }
        }
    }
    if(this.globalData.mdf && !this.data.xt){
        this.canvasContext.clearRect(0, 0, this.data.w, this.data.h);
        this.ctxTransform(this.transformCanvas.props);
    }
};

CVCompElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this,parentMatrix)===false){
        return;
    }
    if(this.globalData.mdf){
        var i,len = this.layers.length;
        for( i = len - 1; i >= 0; i -= 1 ){
            if(this.completeLayers || this.elements[i]){
                this.elements[i].renderFrame();
            }
        }
    }
    if(this.data.hasMask){
        this.globalData.renderer.restore(true);
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
    this.parentGlobalData.renderer.save();
    this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity);
    this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h);
    this.parentGlobalData.renderer.restore();

    if(this.globalData.mdf){
        this.reset();
    }
};

CVCompElement.prototype.setElements = function(elems){
    this.elements = elems;
};

CVCompElement.prototype.getElements = function(){
    return this.elements;
};

CVCompElement.prototype.destroy = function(){
    var i,len = this.layers.length;
    for( i = len - 1; i >= 0; i -= 1 ){
        this.elements[i].destroy();
    }
    this.layers = null;
    this.elements = null;
    this._parent.destroy.call(this._parent);
};
CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers;
CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem;
CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements;
CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement;
CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems;
CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem;
CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage;
CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp;
CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid;
CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape;
CVCompElement.prototype.createText = CanvasRenderer.prototype.createText;
CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase;
CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting;
function CVImageElement(data, comp,globalData){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data, comp,globalData);
    this.globalData.addPendingElement();
}
createElement(CVBaseElement, CVImageElement);

CVImageElement.prototype.createElements = function(){
    var imageLoaded = function(){
        this.globalData.elementLoaded();
        if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
            var canvas = document.createElement('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');

            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w/this.assetData.h;
            var widthCrop, heightCrop;
            if(imgRel>canvasRel){
                heightCrop = imgH;
                widthCrop = heightCrop*canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop/canvasRel;
            }
            ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
            this.img = canvas;
        }
    }.bind(this);
    var imageFailed = function(){
        this.failed = true;
        this.globalData.elementLoaded();
    }.bind(this);

    this.img = new Image();
    this.img.addEventListener('load', imageLoaded, false);
    this.img.addEventListener('error', imageFailed, false);
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.img.src = assetPath;

    this._parent.createElements.call(this);

};

CVImageElement.prototype.renderFrame = function(parentMatrix){
    if(this.failed){
        return;
    }
    if(this._parent.renderFrame.call(this,parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    this.globalData.renderer.save();
    var finalMat = this.finalTransform.mat.props;
    this.globalData.renderer.ctxTransform(finalMat);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.drawImage(this.img,0,0);
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

CVImageElement.prototype.destroy = function(){
    this.img = null;
    this._parent.destroy.call(this._parent);
};

function CVMaskElement(data,element){
    this.data = data;
    this.element = element;
    this.dynamicProperties = [];
    this.masksProperties = this.data.masksProperties;
    this.viewData = new Array(this.masksProperties.length);
    var i, len = this.masksProperties.length;
    for (i = 0; i < len; i++) {
        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3,this.dynamicProperties,null);
    }
}

CVMaskElement.prototype.getMaskProperty = function(pos){
    return this.viewData[pos];
};

CVMaskElement.prototype.prepareFrame = function(num){
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue(num);
        if(this.dynamicProperties[i].mdf){
            this.element.globalData.mdf = true;
        }
    }
};

CVMaskElement.prototype.renderFrame = function (transform) {
    var ctx = this.element.canvasContext;
    var i, len = this.data.masksProperties.length;
    var pt,pt2,pt3,data, hasMasks = false;
    for (i = 0; i < len; i++) {
        if(this.masksProperties[i].mode === 'n'){
            continue;
        }
        if(hasMasks === false){
            ctx.beginPath();
            hasMasks = true;
        }
        if (this.masksProperties[i].inv) {
            ctx.moveTo(0, 0);
            ctx.lineTo(this.element.globalData.compWidth, 0);
            ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
            ctx.lineTo(0, this.element.globalData.compHeight);
            ctx.lineTo(0, 0);
        }
        data = this.viewData[i].v;
        pt = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0):data.v[0];
        ctx.moveTo(pt[0], pt[1]);
        var j, jLen = data._length;
        for (j = 1; j < jLen; j++) {
            pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
            pt2 = transform ? transform.applyToPointArray(data.i[j][0],data.i[j][1],0) : data.i[j];
            pt3 = transform ? transform.applyToPointArray(data.v[j][0],data.v[j][1],0) : data.v[j];
            ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
        }
        pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
        pt2 = transform ? transform.applyToPointArray(data.i[0][0],data.i[0][1],0) : data.i[0];
        pt3 = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0) : data.v[0];
        ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
    }
    if(hasMasks){
        ctx.clip();
    }
};

CVMaskElement.prototype.getMask = function(nm){
    var i = 0, len = this.masksProperties.length;
    while(i<len){
        if(this.masksProperties[i].nm === nm){
            return {
                maskPath: this.viewData[i].pv
            }
        }
        i += 1;
    }
};

CVMaskElement.prototype.destroy = function(){
    this.element = null;
};
function CVShapeElement(data, comp,globalData){
    this.shapes = [];
    this.stylesList = [];
    this.viewData = [];
    this.shapeModifiers = [];
    this.shapesData = data.shapes;
    this.firstFrame = true;
    this._parent.constructor.call(this,data, comp,globalData);
}
createElement(CVBaseElement, CVShapeElement);

CVShapeElement.prototype.lcEnum = {
    '1': 'butt',
    '2': 'round',
    '3': 'butt'
}

CVShapeElement.prototype.ljEnum = {
    '1': 'miter',
    '2': 'round',
    '3': 'butt'
};
CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),matMdf:false,opMdf:false};

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createElements = function(){

    this._parent.createElements.call(this);
    this.searchShapes(this.shapesData,this.viewData,this.dynamicProperties);
};
CVShapeElement.prototype.searchShapes = function(arr,data,dynamicProperties){
    var i, len = arr.length - 1;
    var j, jLen;
    var ownArrays = [], ownModifiers = [], styleElem;
    for(i=len;i>=0;i-=1){
        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
            styleElem = {
                type: arr[i].ty,
                elements: []
            };
            data[i] = {};
            if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
                data[i].c = PropertyFactory.getProp(this,arr[i].c,1,255,dynamicProperties);
                if(!data[i].c.k){
                    styleElem.co = 'rgb('+bm_floor(data[i].c.v[0])+','+bm_floor(data[i].c.v[1])+','+bm_floor(data[i].c.v[2])+')';
                }
            }
            data[i].o = PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties);
            if(arr[i].ty == 'st') {
                styleElem.lc = this.lcEnum[arr[i].lc] || 'round';
                styleElem.lj = this.ljEnum[arr[i].lj] || 'round';
                if(arr[i].lj == 1) {
                    styleElem.ml = arr[i].ml;
                }
                data[i].w = PropertyFactory.getProp(this,arr[i].w,0,null,dynamicProperties);
                if(!data[i].w.k){
                    styleElem.wi = data[i].w.v;
                }
                if(arr[i].d){
                    var d = PropertyFactory.getDashProp(this,arr[i].d,'canvas',dynamicProperties);
                    data[i].d = d;
                    if(!data[i].d.k){
                        styleElem.da = data[i].d.dasharray;
                        styleElem.do = data[i].d.dashoffset;
                    }
                }

            } else {

                styleElem.r = arr[i].r === 2 ? 'evenodd' : 'nonzero';
            }
            this.stylesList.push(styleElem);
            data[i].style = styleElem;
            ownArrays.push(data[i].style);
        }else if(arr[i].ty == 'gr'){
            data[i] = {
                it: []
            };
            this.searchShapes(arr[i].it,data[i].it,dynamicProperties);
        }else if(arr[i].ty == 'tr'){
            data[i] = {
                transform : {
                    mat: new Matrix(),
                    opacity: 1,
                    matMdf:false,
                    opMdf:false,
                    op: PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties),
                    mProps: PropertyFactory.getProp(this,arr[i],2,null,dynamicProperties)
                },
                elements: []
            };
        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
            data[i] = {
                nodes:[],
                trNodes:[],
                tr:[0,0,0,0,0,0]
            };
            var ty = 4;
            if(arr[i].ty == 'rc'){
                ty = 5;
            }else if(arr[i].ty == 'el'){
                ty = 6;
            }else if(arr[i].ty == 'sr'){
                ty = 7;
            }
            data[i].sh = ShapePropertyFactory.getShapeProp(this,arr[i],ty,dynamicProperties);
            this.shapes.push(data[i].sh);
            this.addShapeToModifiers(data[i]);
            jLen = this.stylesList.length;
            var hasStrokes = false, hasFills = false;
            for(j=0;j<jLen;j+=1){
                if(!this.stylesList[j].closed){
                    this.stylesList[j].elements.push(data[i]);
                    if(this.stylesList[j].type === 'st'){
                        hasStrokes = true;
                    }else{
                        hasFills = true;
                    }
                }
            }
            data[i].st = hasStrokes;
            data[i].fl = hasFills;
        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'rp'){
            var modifier = ShapeModifiers.getModifier(arr[i].ty);
            modifier.init(this,arr[i],dynamicProperties);
            this.shapeModifiers.push(modifier);
            ownModifiers.push(modifier);
            data[i] = modifier;
        }
    }
    len = ownArrays.length;
    for(i=0;i<len;i+=1){
        ownArrays[i].closed = true;
    }
    len = ownModifiers.length;
    for(i=0;i<len;i+=1){
        ownModifiers[i].closed = true;
    }
};

CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers;
CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers;

CVShapeElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    this.transformHelper.mat.reset();
    this.transformHelper.opacity = this.finalTransform.opacity;
    this.transformHelper.matMdf = false;
    this.transformHelper.opMdf = this.finalTransform.opMdf;
    this.renderModifiers();
    this.renderShape(this.transformHelper,null,null,true);
    if(this.data.hasMask){
        this.globalData.renderer.restore(true);
    }
};

CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
    var i, len;
    if(!items){
        items = this.shapesData;
        len = this.stylesList.length;
        for(i=0;i<len;i+=1){
            this.stylesList[i].d = '';
            this.stylesList[i].mdf = false;
        }
    }
    if(!data){
        data = this.viewData;
    }
    ///
    ///
    len = items.length - 1;
    var groupTransform,groupMatrix;
    groupTransform = parentTransform;
    for(i=len;i>=0;i-=1){
        if(items[i].ty == 'tr'){
            groupTransform = data[i].transform;
            var mtArr = data[i].transform.mProps.v.props;
            groupTransform.matMdf = groupTransform.mProps.mdf;
            groupTransform.opMdf = groupTransform.op.mdf;
            groupMatrix = groupTransform.mat;
            groupMatrix.cloneFromProps(mtArr);
            if(parentTransform){
                var props = parentTransform.mat.props;
                groupTransform.opacity = parentTransform.opacity;
                groupTransform.opacity *= data[i].transform.op.v;
                groupTransform.matMdf = parentTransform.matMdf ? true : groupTransform.matMdf;
                groupTransform.opMdf = parentTransform.opMdf ? true : groupTransform.opMdf;
                groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
            }else{
                groupTransform.opacity = groupTransform.op.o;
            }
        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
            this.renderPath(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'fl'){
            this.renderFill(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'st'){
            this.renderStroke(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'gr'){
            this.renderShape(groupTransform,items[i].it,data[i].it);
        }else if(items[i].ty == 'tm'){
            //
        }
    }
    if(!isMain){
        return;
    }
    len = this.stylesList.length;
    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type;
    renderer.save();
    renderer.ctxTransform(this.finalTransform.mat.props);
    for(i=0;i<len;i+=1){
        type = this.stylesList[i].type;
        if(type === 'st' && this.stylesList[i].wi === 0){
            continue;
        }
        renderer.save();
        elems = this.stylesList[i].elements;
        if(type === 'st'){
            ctx.strokeStyle = this.stylesList[i].co;
            ctx.lineWidth = this.stylesList[i].wi;
            ctx.lineCap = this.stylesList[i].lc;
            ctx.lineJoin = this.stylesList[i].lj;
            ctx.miterLimit = this.stylesList[i].ml || 0;
        }else{
            ctx.fillStyle = this.stylesList[i].co;
        }
        renderer.ctxOpacity(this.stylesList[i].coOp);
        if(type !== 'st'){
            ctx.beginPath();
        }
        jLen = elems.length;
        for(j=0;j<jLen;j+=1){
            if(type === 'st'){
                ctx.beginPath();
                if(this.stylesList[i].da){
                    ctx.setLineDash(this.stylesList[i].da);
                    ctx.lineDashOffset = this.stylesList[i].do;
                    this.globalData.isDashed = true;
                }else if(this.globalData.isDashed){
                    ctx.setLineDash(this.dashResetter);
                    this.globalData.isDashed = false;
                }
            }
            nodes = elems[j].trNodes;
            kLen = nodes.length;

            for(k=0;k<kLen;k+=1){
                if(nodes[k].t == 'm'){
                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
                }else if(nodes[k].t == 'c'){
                    ctx.bezierCurveTo(nodes[k].p1[0],nodes[k].p1[1],nodes[k].p2[0],nodes[k].p2[1],nodes[k].p3[0],nodes[k].p3[1]);
                }else{
                    ctx.closePath();
                }
            }
            if(type === 'st'){
                ctx.stroke();
            }
        }
        if(type !== 'st'){
            ctx.fill(this.stylesList[i].r);
        }
        renderer.restore();
    }
    renderer.restore();
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
CVShapeElement.prototype.renderPath = function(pathData,viewData,groupTransform){
    var len, i, j,jLen;
    var redraw = groupTransform.matMdf || viewData.sh.mdf || this.firstFrame;
    if(redraw) {
        var paths = viewData.sh.paths;
        jLen = paths._length;
        var pathStringTransformed = viewData.trNodes;
        pathStringTransformed.length = 0;
        for(j=0;j<jLen;j+=1){
            var pathNodes = paths.shapes[j];
            if(pathNodes && pathNodes.v){
                len = pathNodes._length;
                for (i = 1; i < len; i += 1) {
                    if (i == 1) {
                        pathStringTransformed.push({
                            t: 'm',
                            p: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                    }
                    pathStringTransformed.push({
                        t: 'c',
                        p1: groupTransform.mat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
                        p2: groupTransform.mat.applyToPointArray(pathNodes.i[i][0], pathNodes.i[i][1], 0),
                        p3: groupTransform.mat.applyToPointArray(pathNodes.v[i][0], pathNodes.v[i][1], 0)
                    });
                }
                if (len == 1) {
                    pathStringTransformed.push({
                        t: 'm',
                        p: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                }
                if (pathNodes.c && len) {
                    pathStringTransformed.push({
                        t: 'c',
                        p1: groupTransform.mat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
                        p2: groupTransform.mat.applyToPointArray(pathNodes.i[0][0], pathNodes.i[0][1], 0),
                        p3: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    pathStringTransformed.push({
                        t: 'z'
                    });
                }
                viewData.lStr = pathStringTransformed;
            }

        }

        if (viewData.st) {
            for (i = 0; i < 16; i += 1) {
                viewData.tr[i] = groupTransform.mat.props[i];
            }
        }
        viewData.trNodes = pathStringTransformed;

    }
};



CVShapeElement.prototype.renderFill = function(styleData,viewData, groupTransform){
    var styleElem = viewData.style;

    if(viewData.c.mdf || this.firstFrame){
        styleElem.co = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || groupTransform.opMdf || this.firstFrame){
        styleElem.coOp = viewData.o.v*groupTransform.opacity;
    }
};

CVShapeElement.prototype.renderStroke = function(styleData,viewData, groupTransform){
    var styleElem = viewData.style;
    //TODO fix dashes
    var d = viewData.d;
    var dasharray,dashoffset;
    if(d && (d.mdf  || this.firstFrame)){
        styleElem.da = d.dasharray;
        styleElem.do = d.dashoffset;
    }
    if(viewData.c.mdf || this.firstFrame){
        styleElem.co = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || groupTransform.opMdf || this.firstFrame){
        styleElem.coOp = viewData.o.v*groupTransform.opacity;
    }
    if(viewData.w.mdf || this.firstFrame){
        styleElem.wi = viewData.w.v;
    }
};


CVShapeElement.prototype.destroy = function(){
    this.shapesData = null;
    this.globalData = null;
    this.canvasContext = null;
    this.stylesList.length = 0;
    this.viewData.length = 0;
    this._parent.destroy.call(this._parent);
};


function CVSolidElement(data, comp,globalData){
    this._parent.constructor.call(this,data, comp,globalData);
}
createElement(CVBaseElement, CVSolidElement);

CVSolidElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    this.globalData.renderer.save();
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.fillStyle=this.data.sc;
    ctx.fillRect(0,0,this.data.sw,this.data.sh);
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
function CVTextElement(data, comp, globalData){
    this.textSpans = [];
    this.yOffset = 0;
    this.fillColorAnim = false;
    this.strokeColorAnim = false;
    this.strokeWidthAnim = false;
    this.stroke = false;
    this.fill = false;
    this.justifyOffset = 0;
    this.currentRender = null;
    this.renderType = 'canvas';
    this.values = {
        fill: 'rgba(0,0,0,0)',
        stroke: 'rgba(0,0,0,0)',
        sWidth: 0,
        fValue: ''
    }
    this._parent.constructor.call(this,data,comp, globalData);
}
createElement(CVBaseElement, CVTextElement);

CVTextElement.prototype.init = ITextElement.prototype.init;
CVTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
CVTextElement.prototype.getMult = ITextElement.prototype.getMult;
CVTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;

CVTextElement.prototype.tHelper = document.createElement('canvas').getContext('2d');

CVTextElement.prototype.createElements = function(){

    this._parent.createElements.call(this);
    //console.log('this.data: ',this.data);

};

CVTextElement.prototype.buildNewText = function(){
    var documentData = this.currentTextDocumentData;
    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});

    var hasFill = false;
    if(documentData.fc) {
        hasFill = true;
        this.values.fill = 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')';
    }else{
        this.values.fill = 'rgba(0,0,0,0)';
    }
    this.fill = hasFill;
    var hasStroke = false;
    if(documentData.sc){
        hasStroke = true;
        this.values.stroke = 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')';
        this.values.sWidth = documentData.sw;
    }
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    var i, len;
    var letters = documentData.l;
    var matrixHelper = this.mHelper;
    this.stroke = hasStroke;
    this.values.fValue = documentData.s + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
    len = documentData.t.length;
    this.tHelper.font = this.values.fValue;
    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
    if (singleShape) {
        var xPos = 0, yPos = 0, lineWidths = documentData.lineWidths, boxWidth = documentData.boxWidth, firstLine = true;
    }
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        var shapeData;
        if(charData){
            shapeData = charData.data;
        } else {
            shapeData = null;
        }
        matrixHelper.reset();
        if(singleShape && letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
        }

        if(shapeData && shapeData.shapes){
            shapes = shapeData.shapes[0].it;
            jLen = shapes.length;
            matrixHelper.scale(documentData.s/100,documentData.s/100);
            if(singleShape){
                if(documentData.ps){
                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
                }
                matrixHelper.translate(0,-documentData.ls,0);
                switch(documentData.j){
                    case 1:
                        matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line]),0,0);
                        break;
                    case 2:
                        matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line])/2,0,0);
                        break;
                }
                matrixHelper.translate(xPos,yPos,0);
            }
            commands = new Array(jLen);
            for(j=0;j<jLen;j+=1){
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k=1;k<kLen;k+=1){
                    if(k==1){
                        pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
                    }
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
                commands[j] = pathArr;
            }
        }else{
            commands = [];
        }
        if(singleShape){
            xPos += letters[i].l;
        }
        if(this.textSpans[cnt]){
            this.textSpans[cnt].elem = commands;
        } else {
            this.textSpans[cnt] = {elem: commands};
        }
        cnt +=1;
    }
}

CVTextElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    var finalMat = this.finalTransform.mat.props;
    this.globalData.renderer.save();
    this.globalData.renderer.ctxTransform(finalMat);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.font = this.values.fValue;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 4;

    if(!this.data.singleShape){
        this.getMeasures();
    }

    var  i,len, j, jLen, k, kLen;
    var renderedLetters = this.renderedLetters;

    var letters = this.currentTextDocumentData.l;

    len = letters.length;
    var renderedLetter;
    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        if(renderedLetter){
            this.globalData.renderer.save();
            this.globalData.renderer.ctxTransform(renderedLetter.props);
            this.globalData.renderer.ctxOpacity(renderedLetter.o);
        }
        if(this.fill){
            if(renderedLetter && renderedLetter.fc){
                if(lastFill !== renderedLetter.fc){
                    lastFill = renderedLetter.fc;
                    ctx.fillStyle = renderedLetter.fc;
                }
            }else if(lastFill !== this.values.fill){
                lastFill = this.values.fill;
                ctx.fillStyle = this.values.fill;
            }
            commands = this.textSpans[i].elem;
            jLen = commands.length;
            this.globalData.canvasContext.beginPath();
            for(j=0;j<jLen;j+=1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k = 2; k < kLen; k += 6) {
                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
            }
            this.globalData.canvasContext.closePath();
            this.globalData.canvasContext.fill();
            ///ctx.fillText(this.textSpans[i].val,0,0);
        }
        if(this.stroke){
            if(renderedLetter && renderedLetter.sw){
                if(lastStrokeW !== renderedLetter.sw){
                    lastStrokeW = renderedLetter.sw;
                    ctx.lineWidth = renderedLetter.sw;
                }
            }else if(lastStrokeW !== this.values.sWidth){
                lastStrokeW = this.values.sWidth;
                ctx.lineWidth = this.values.sWidth;
            }
            if(renderedLetter && renderedLetter.sc){
                if(lastStroke !== renderedLetter.sc){
                    lastStroke = renderedLetter.sc;
                    ctx.strokeStyle = renderedLetter.sc;
                }
            }else if(lastStroke !== this.values.stroke){
                lastStroke = this.values.stroke;
                ctx.strokeStyle = this.values.stroke;
            }
            commands = this.textSpans[i].elem;
            jLen = commands.length;
            this.globalData.canvasContext.beginPath();
            for(j=0;j<jLen;j+=1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k = 2; k < kLen; k += 6) {
                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
            }
            this.globalData.canvasContext.closePath();
            this.globalData.canvasContext.stroke();
            ///ctx.strokeText(letters[i].val,0,0);
        }
        if(renderedLetter) {
            this.globalData.renderer.restore();
        }
    }
    /*if(this.data.hasMask){
     this.globalData.renderer.restore(true);
     }*/
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
function HBaseElement(data,parentContainer,globalData,comp, placeholder){
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.matteElement = null;
    this.parentContainer = parentContainer;
    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
    this.placeholder = placeholder;
    this.init();
};

createElement(BaseElement, HBaseElement);
HBaseElement.prototype.checkBlendMode = function(){

};
HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;

/*HBaseElement.prototype.appendNodeToParent = function(node) {
    if(this.data.hd){
        return;
    }
    if(this.placeholder){
        var g = this.placeholder.phElement;
        g.parentNode.insertBefore(node, g);
        //g.parentNode.removeChild(g);
    }else{
        this.parentContainer.appendChild(node);
    }
};*/


HBaseElement.prototype.getBaseElement = function(){
    return this.baseElement;
};

HBaseElement.prototype.createElements = function(){
    if(this.data.hasMask){
        this.layerElement = document.createElementNS(svgNS,'svg');
        styleDiv(this.layerElement);
        //this.appendNodeToParent(this.layerElement);
        this.baseElement = this.layerElement;
        this.maskedElement = this.layerElement;
    }else{
        this.layerElement = this.parentContainer;
    }
    this.transformedElement = this.layerElement;
    if(this.data.ln && (this.data.ty === 4 || this.data.ty === 0)){
        if(this.layerElement === this.parentContainer){
            this.layerElement = document.createElementNS(svgNS,'g');
            //this.appendNodeToParent(this.layerElement);
            this.baseElement = this.layerElement;
        }
        this.layerElement.setAttribute('id',this.data.ln);
    }
    this.setBlendMode();
    if(this.layerElement !== this.parentContainer){
        this.placeholder = null;
    }
    this.checkParenting();
};

HBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3){
        return false;
    }

    if(this.currentFrameNum === this.lastNum || !this.isVisible){
        return this.isVisible;
    }
    this.lastNum = this.currentFrameNum;

    this.finalTransform.opMdf = this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;
    if(this.firstFrame){
        this.finalTransform.opMdf = true;
        this.finalTransform.matMdf = true;
    }

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i, len = this.hierarchy.length;

        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for(i=0;i<len;i+=1){
            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        }
    }else{
        if(this.isVisible && this.finalTransform.matMdf){
            if(!parentTransform){
                finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
            }else{
                mat = this.finalTransform.mProp.v.props;
                finalMat.cloneFromProps(mat);
            }
        }
    }
    if(this.data.hasMask){
        this.maskManager.renderFrame(finalMat);
    }

    if(parentTransform){
        mat = parentTransform.mat.props;
        finalMat.cloneFromProps(mat);
        this.finalTransform.opacity *= parentTransform.opacity;
        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
    }

    if(this.finalTransform.matMdf){
        this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = finalMat.toCSS();
        this.finalMat = finalMat;
    }
    if(this.finalTransform.opMdf){
        this.transformedElement.style.opacity = this.finalTransform.opacity;
    }
    return this.isVisible;
};

HBaseElement.prototype.destroy = function(){
    this.layerElement = null;
    this.transformedElement = null;
    this.parentContainer = null;
    if(this.matteElement) {
        this.matteElement = null;
    }
    if(this.maskManager) {
        this.maskManager.destroy();
        this.maskManager = null;
    }
};

HBaseElement.prototype.getDomElement = function(){
    return this.layerElement;
};
HBaseElement.prototype.addMasks = function(data){
    this.maskManager = new MaskElement(data,this,this.globalData);
};

HBaseElement.prototype.hide = function(){
};

HBaseElement.prototype.setMatte = function(){

}

HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
function HSolidElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(HBaseElement, HSolidElement);

HSolidElement.prototype.createElements = function(){
    var parent = document.createElement('div');
    styleDiv(parent);
    var cont = document.createElementNS(svgNS,'svg');
    styleDiv(cont);
    cont.setAttribute('width',this.data.sw);
    cont.setAttribute('height',this.data.sh);
    parent.appendChild(cont);
    this.layerElement = parent;
    this.transformedElement = parent;
    //this.appendNodeToParent(parent);
    this.baseElement = parent;
    this.innerElem = parent;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    var rect = document.createElementNS(svgNS,'rect');
    rect.setAttribute('width',this.data.sw);
    rect.setAttribute('height',this.data.sh);
    rect.setAttribute('fill',this.data.sc);
    cont.appendChild(rect);
    if(this.data.hasMask){
        this.maskedElement = rect;
    }
    this.checkParenting();
};



HSolidElement.prototype.hide = IImageElement.prototype.hide;
HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
HSolidElement.prototype.destroy = IImageElement.prototype.destroy;
function HCompElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = Array.apply(null,{length:this.layers.length});
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.hasMask) {
        this.supports3d = false;
    }
    if(this.data.xt){
        this.layerElement = document.createElement('div');
    }
    this.buildAllItems();

}
createElement(HBaseElement, HCompElement);

HCompElement.prototype.createElements = function(){
    var divElement = document.createElement('div');
    styleDiv(divElement);
    if(this.data.ln){
        divElement.setAttribute('id',this.data.ln);
    }
    divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
    if(this.data.hasMask){
        var compSvg = document.createElementNS(svgNS,'svg');
        styleDiv(compSvg);
        compSvg.setAttribute('width',this.data.w);
        compSvg.setAttribute('height',this.data.h);
        var g = document.createElementNS(svgNS,'g');
        compSvg.appendChild(g);
        divElement.appendChild(compSvg);
        this.maskedElement = g;
        this.baseElement = divElement;
        this.layerElement = g;
        this.transformedElement = divElement;
    }else{
        this.layerElement = divElement;
        this.baseElement = this.layerElement;
        this.transformedElement = divElement;
    }
    //this.appendNodeToParent(this.layerElement);
    this.checkParenting();
};

HCompElement.prototype.hide = ICompElement.prototype.hide;
HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame;
HCompElement.prototype.setElements = ICompElement.prototype.setElements;
HCompElement.prototype.getElements = ICompElement.prototype.getElements;
HCompElement.prototype.destroy = ICompElement.prototype.destroy;

HCompElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    var i,len = this.layers.length;
    if(renderParent===false){
        this.hide();
        return;
    }

    this.hidden = false;

    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers;
HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem;
HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements;
HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement;
HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems;
HCompElement.prototype.createItem = HybridRenderer.prototype.createItem;
HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
HCompElement.prototype.createImage = HybridRenderer.prototype.createImage;
HCompElement.prototype.createComp = HybridRenderer.prototype.createComp;
HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid;
HCompElement.prototype.createShape = HybridRenderer.prototype.createShape;
HCompElement.prototype.createText = HybridRenderer.prototype.createText;
HCompElement.prototype.createBase = HybridRenderer.prototype.createBase;
HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos;
function HShapeElement(data,parentContainer,globalData,comp, placeholder){
    this.shapes = [];
    this.shapeModifiers = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.viewData = [];
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.addedTransforms = {
        mdf: false,
        mats: [this.finalTransform.mat]
    };
    this.currentBBox = {
        x:999999,
        y: -999999,
        h: 0,
        w: 0
    };
}
createElement(HBaseElement, HShapeElement);
var parent = HShapeElement.prototype._parent;
extendPrototype(IShapeElement, HShapeElement);
HShapeElement.prototype._parent = parent;

HShapeElement.prototype.createElements = function(){
    var parent = document.createElement('div');
    styleDiv(parent);
    var cont = document.createElementNS(svgNS,'svg');
    styleDiv(cont);
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width',size.w);
    cont.setAttribute('height',size.h);
    if(this.data.hasMask){
        var g = document.createElementNS(svgNS,'g');
        parent.appendChild(cont);
        cont.appendChild(g);
        this.maskedElement = g;
        this.layerElement = g;
        this.shapesContainer = g;
    }else{
        parent.appendChild(cont);
        this.layerElement = cont;
        this.shapesContainer = document.createElementNS(svgNS,'g');
        this.layerElement.appendChild(this.shapesContainer);
    }
    if(!this.data.hd){
        //this.parentContainer.appendChild(parent);
        this.baseElement = parent;
    }
    this.innerElem = parent;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    this.searchShapes(this.shapesData,this.viewData,this.layerElement,this.dynamicProperties,0);
    this.buildExpressionInterface();
    this.layerElement = parent;
    this.transformedElement = parent;
    this.shapeCont = cont;
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    this.checkParenting();
};

HShapeElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.layerElement.style.display = 'block';
        this.hidden = false;
    }
    this.renderModifiers();
    this.addedTransforms.mdf = this.finalTransform.matMdf;
    this.addedTransforms.mats.length = 1;
    this.addedTransforms.mats[0] = this.finalTransform.mat;
    this.renderShape(null,null,true, null);

    if(this.isVisible && (this.elemMdf || this.firstFrame)){
        var boundingBox = this.shapeCont.getBBox();
        var changed = false;
        if(this.currentBBox.w !== boundingBox.width){
            this.currentBBox.w = boundingBox.width;
            this.shapeCont.setAttribute('width',boundingBox.width);
            changed = true;
        }
        if(this.currentBBox.h !== boundingBox.height){
            this.currentBBox.h = boundingBox.height;
            this.shapeCont.setAttribute('height',boundingBox.height);
            changed = true;
        }
        if(changed  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
            this.currentBBox.w = boundingBox.width;
            this.currentBBox.h = boundingBox.height;
            this.currentBBox.x = boundingBox.x;
            this.currentBBox.y = boundingBox.y;

            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        }
    }

};
function HTextElement(data,parentContainer,globalData,comp, placeholder){
    this.textSpans = [];
    this.textPaths = [];
    this.currentBBox = {
        x:999999,
        y: -999999,
        h: 0,
        w: 0
    }
    this.renderType = 'svg';
    this.isMasked = false;
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);

}
createElement(HBaseElement, HTextElement);

HTextElement.prototype.init = ITextElement.prototype.init;
HTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
HTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape;
HTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;

HTextElement.prototype.createElements = function(){
    this.isMasked = this.checkMasks();
    var parent = document.createElement('div');
    styleDiv(parent);
    this.layerElement = parent;
    this.transformedElement = parent;
    if(this.isMasked){
        this.renderType = 'svg';
        var cont = document.createElementNS(svgNS,'svg');
        styleDiv(cont);
        this.cont = cont;
        this.compW = this.comp.data.w;
        this.compH = this.comp.data.h;
        cont.setAttribute('width',this.compW);
        cont.setAttribute('height',this.compH);
        var g = document.createElementNS(svgNS,'g');
        cont.appendChild(g);
        parent.appendChild(cont);
        this.maskedElement = g;
        this.innerElem = g;
    } else {
        this.renderType = 'html';
        this.innerElem = parent;
    }
    this.baseElement = parent;

    this.checkParenting();

};

HTextElement.prototype.buildNewText = function(){
    var documentData = this.currentTextDocumentData;
    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
    if(documentData.fc) {
        this.innerElem.style.color = this.innerElem.style.fill = 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')';
        ////this.innerElem.setAttribute('fill', 'rgb(' + documentData.fc[0] + ',' + documentData.fc[1] + ',' + documentData.fc[2] + ')');
    }else{
        this.innerElem.style.color = this.innerElem.style.fill = 'rgba(0,0,0,0)';
        ////this.innerElem.setAttribute('fill', 'rgba(0,0,0,0)');
    }
    if(documentData.sc){
        ////this.innerElem.setAttribute('stroke', 'rgb(' + documentData.sc[0] + ',' + documentData.sc[1] + ',' + documentData.sc[2] + ')');
        this.innerElem.style.stroke = 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')';
        ////this.innerElem.setAttribute('stroke-width', documentData.sw);
        this.innerElem.style.strokeWidth = documentData.sw+'px';
    }
    ////this.innerElem.setAttribute('font-size', documentData.s);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if(!this.globalData.fontManager.chars){
        this.innerElem.style.fontSize = documentData.s+'px';
        this.innerElem.style.lineHeight = documentData.s+'px';
        if(fontData.fClass){
            this.innerElem.className = fontData.fClass;
        } else {
            ////this.innerElem.setAttribute('font-family', fontData.fFamily);
            this.innerElem.style.fontFamily = fontData.fFamily;
            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
            ////this.innerElem.setAttribute('font-style', fStyle);
            this.innerElem.style.fontStyle = fStyle;
            ////this.innerElem.setAttribute('font-weight', fWeight);
            this.innerElem.style.fontWeight = fWeight;
        }
    }
    var i, len;

    var letters = documentData.l;
    len = letters.length;
    var tSpan,tParent,tCont;
    var matrixHelper = this.mHelper;
    var shapes, shapeStr = '';
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        if(this.globalData.fontManager.chars){
            if(!this.textPaths[cnt]){
                tSpan = document.createElementNS(svgNS,'path');
                tSpan.setAttribute('stroke-linecap', 'butt');
                tSpan.setAttribute('stroke-linejoin','round');
                tSpan.setAttribute('stroke-miterlimit','4');
            } else {
                tSpan = this.textPaths[cnt];
            }
            if(!this.isMasked){
                if(this.textSpans[cnt]){
                    tParent = this.textSpans[cnt];
                    tCont = tParent.children[0];
                } else {

                    tParent = document.createElement('div');
                    tCont = document.createElementNS(svgNS,'svg');
                    tCont.appendChild(tSpan);
                    styleDiv(tParent);
                }
            }
        }else{
            if(!this.isMasked){
                if(this.textSpans[cnt]){
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = document.createElement('span');
                    styleDiv(tParent);
                    tSpan = document.createElement('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else {
                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : document.createElementNS(svgNS,'text');
            }
        }
        //tSpan.setAttribute('visibility', 'hidden');
        if(this.globalData.fontManager.chars){
            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            var shapeData;
            if(charData){
                shapeData = charData.data;
            } else {
                shapeData = null;
            }
            matrixHelper.reset();
            if(shapeData && shapeData.shapes){
                shapes = shapeData.shapes[0].it;
                matrixHelper.scale(documentData.s/100,documentData.s/100);
                shapeStr = this.createPathShape(matrixHelper,shapes);
                tSpan.setAttribute('d',shapeStr);
            }
            if(!this.isMasked){
                this.innerElem.appendChild(tParent);
                if(shapeData && shapeData.shapes){
                    document.body.appendChild(tCont);

                    var boundingBox = tCont.getBBox();
                    tCont.setAttribute('width',boundingBox.width);
                    tCont.setAttribute('height',boundingBox.height);
                    tCont.setAttribute('viewBox',boundingBox.x+' '+ boundingBox.y+' '+ boundingBox.width+' '+ boundingBox.height);
                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + boundingBox.x + 'px,' + boundingBox.y + 'px)';

                    letters[i].yOffset = boundingBox.y;
                    tParent.appendChild(tCont);

                } else{
                    tCont.setAttribute('width',1);
                    tCont.setAttribute('height',1);
                }
            }else{
                this.innerElem.appendChild(tSpan);
            }
        }else{
            tSpan.textContent = letters[i].val;
            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
            if(!this.isMasked){
                this.innerElem.appendChild(tParent);
                //
                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.s/1.2+'px,0)';
            } else {
                this.innerElem.appendChild(tSpan);
            }
        }
        //
        if(!this.isMasked){
            this.textSpans[cnt] = tParent;
        }else{
            this.textSpans[cnt] = tSpan;
        }
        this.textSpans[cnt].style.display = 'block';
        this.textPaths[cnt] = tSpan;
        cnt += 1;
    }
    while(cnt < this.textSpans.length){
        this.textSpans[cnt].style.display = 'none';
        cnt += 1;
    }
}

HTextElement.prototype.hide = SVGTextElement.prototype.hide;

HTextElement.prototype.renderFrame = function(parentMatrix){

    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.innerElem.style.display = 'block';
        this.layerElement.style.display = 'block';
    }

    if(this.data.singleShape){
        if(!this.firstFrame && !this.lettersChangedFlag){
            return;
        } else {
            // Todo Benchmark if using this is better than getBBox
             if(this.isMasked && this.finalTransform.matMdf){
                 this.cont.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
             }
        }
    }

    this.getMeasures();
    if(!this.lettersChangedFlag){
        return;
    }
    var  i,len;
    var renderedLetters = this.renderedLetters;

    var letters = this.currentTextDocumentData.l;

    len = letters.length;
    var renderedLetter;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        if(!this.isMasked){
            this.textSpans[i].style.transform = this.textSpans[i].style.webkitTransform = renderedLetter.m;
        }else{
            this.textSpans[i].setAttribute('transform',renderedLetter.m);
        }
        ////this.textSpans[i].setAttribute('opacity',renderedLetter.o);
        this.textSpans[i].style.opacity = renderedLetter.o;
        if(renderedLetter.sw){
            this.textPaths[i].setAttribute('stroke-width',renderedLetter.sw);
        }
        if(renderedLetter.sc){
            this.textPaths[i].setAttribute('stroke',renderedLetter.sc);
        }
        if(renderedLetter.fc){
            this.textPaths[i].setAttribute('fill',renderedLetter.fc);
            this.textPaths[i].style.color = renderedLetter.fc;
        }
    }
    if(this.isVisible && (this.elemMdf || this.firstFrame)){
        if(this.innerElem.getBBox){
            var boundingBox = this.innerElem.getBBox();

            if(this.currentBBox.w !== boundingBox.width){
                this.currentBBox.w = boundingBox.width;
                this.cont.setAttribute('width',boundingBox.width);
            }
            if(this.currentBBox.h !== boundingBox.height){
                this.currentBBox.h = boundingBox.height;
                this.cont.setAttribute('height',boundingBox.height);
            }
            if(this.currentBBox.w !== boundingBox.width || this.currentBBox.h !== boundingBox.height  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
                this.currentBBox.w = boundingBox.width;
                this.currentBBox.h = boundingBox.height;
                this.currentBBox.x = boundingBox.x;
                this.currentBBox.y = boundingBox.y;

                this.cont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
            }
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
}


HTextElement.prototype.destroy = SVGTextElement.prototype.destroy;
function HImageElement(data,parentContainer,globalData,comp, placeholder){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(HBaseElement, HImageElement);

HImageElement.prototype.createElements = function(){

    var assetPath = this.globalData.getAssetsPath(this.assetData);
    var img = new Image();

    if(this.data.hasMask){
        var parent = document.createElement('div');
        styleDiv(parent);
        var cont = document.createElementNS(svgNS,'svg');
        styleDiv(cont);
        cont.setAttribute('width',this.assetData.w);
        cont.setAttribute('height',this.assetData.h);
        parent.appendChild(cont);
        this.imageElem = document.createElementNS(svgNS,'image');
        this.imageElem.setAttribute('width',this.assetData.w+"px");
        this.imageElem.setAttribute('height',this.assetData.h+"px");
        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
        cont.appendChild(this.imageElem);
        this.layerElement = parent;
        this.transformedElement = parent;
        this.baseElement = parent;
        this.innerElem = parent;
        this.maskedElement = this.imageElem;
    } else {
        styleDiv(img);
        this.layerElement = img;
        this.baseElement = img;
        this.innerElem = img;
        this.transformedElement = img;
    }
    img.src = assetPath;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    this.checkParenting();
};

HImageElement.prototype.hide = HSolidElement.prototype.hide;
HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame;
HImageElement.prototype.destroy = HSolidElement.prototype.destroy;
function HCameraElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.pe = PropertyFactory.getProp(this,data.pe,0,0,this.dynamicProperties);
    if(data.ks.p.s){
        this.px = PropertyFactory.getProp(this,data.ks.p.x,1,0,this.dynamicProperties);
        this.py = PropertyFactory.getProp(this,data.ks.p.y,1,0,this.dynamicProperties);
        this.pz = PropertyFactory.getProp(this,data.ks.p.z,1,0,this.dynamicProperties);
    }else{
        this.p = PropertyFactory.getProp(this,data.ks.p,1,0,this.dynamicProperties);
    }
    if(data.ks.a){
        this.a = PropertyFactory.getProp(this,data.ks.a,1,0,this.dynamicProperties);
    }
    if(data.ks.or.k.length && data.ks.or.k[0].to){
        var i,len = data.ks.or.k.length;
        for(i=0;i<len;i+=1){
            data.ks.or.k[i].to = null;
            data.ks.or.k[i].ti = null;
        }
    }
    this.or = PropertyFactory.getProp(this,data.ks.or,1,degToRads,this.dynamicProperties);
    this.or.sh = true;
    this.rx = PropertyFactory.getProp(this,data.ks.rx,0,degToRads,this.dynamicProperties);
    this.ry = PropertyFactory.getProp(this,data.ks.ry,0,degToRads,this.dynamicProperties);
    this.rz = PropertyFactory.getProp(this,data.ks.rz,0,degToRads,this.dynamicProperties);
    this.mat = new Matrix();
}
createElement(HBaseElement, HCameraElement);

HCameraElement.prototype.setup = function() {
    var i, len = this.comp.threeDElements.length, comp;
    for(i=0;i<len;i+=1){
        //[perspectiveElem,container]
        comp = this.comp.threeDElements[i];
        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
        comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
        comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    }
};

HCameraElement.prototype.createElements = function(){
};

HCameraElement.prototype.hide = function(){
};

HCameraElement.prototype.renderFrame = function(){
    var mdf = this.firstFrame;
    var i, len;
    if(this.hierarchy){
        len = this.hierarchy.length;
        for(i=0;i<len;i+=1){
            mdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : mdf;
        }
    }
    if(mdf || (this.p && this.p.mdf) || (this.px && (this.px.mdf || this.py.mdf || this.pz.mdf)) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || (this.a && this.a.mdf)) {
        this.mat.reset();

        if(this.p){
            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
        }else{
            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
        }
        if(this.a){
            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);

        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
        this.mat.translate(0,0,this.pe.v);
        if(this.hierarchy){
            var mat;
            len = this.hierarchy.length;
            for(i=0;i<len;i+=1){
                mat = this.hierarchy[i].finalTransform.mProp.iv.props;
                this.mat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],-mat[12],-mat[13],mat[14],mat[15]);
            }
        }
        len = this.comp.threeDElements.length;
        var comp;
        for(i=0;i<len;i+=1){
            comp = this.comp.threeDElements[i];
            comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
        }
    }
    this.firstFrame = false;
};

HCameraElement.prototype.destroy = function(){
};
var Expressions = (function(){
    var ob = {};
    ob.initExpressions = initExpressions;


    function initExpressions(animation){
        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    }
   return ob;
}());

expressionsPlugin = Expressions;

(function addPropertyDecorator() {

    function getStaticValueAtTime() {
        return this.pv;
    }

    function getValueAtTime(frameNum, offsetTime) {
        frameNum *= this.elem.globalData.frameRate;
        var i = 0,len = this.keyframes.length- 1,dir= 1,flag = true;
        var keyData, nextKeyData;
        offsetTime = offsetTime === undefined ? this.offsetTime : 0;
        //console.log(this.offsetTime);
        var retVal = typeof this.pv === 'object' ? [this.pv.length] : 0;

        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i+1];
            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
                if(keyData.h){
                    keyData = nextKeyData;
                }
                break;
            }
            if((nextKeyData.t - offsetTime) > frameNum){
                break;
            }
            if(i < len - 1){
                i += dir;
            }else{
                flag = false;
            }
        }

        var k, kLen,perc,jLen, j = 0, fnc;
        if (keyData.to) {

            if (!keyData.bezierData) {
                bez.buildBezierData(keyData);
            }
            var bezierData = keyData.bezierData;
            if (frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime) {
                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1){
                    retVal[k] = bezierData.points[ind].point[k];
                }
            } else {
                if (keyData.__fnct) {
                    fnc = keyData.__fnct;
                } else {
                    //fnc = bez.getEasingCurve(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n);
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyData.__fnct = fnc;
                }
                perc = fnc((frameNum - (keyData.t - offsetTime)) / ((nextKeyData.t - offsetTime) - (keyData.t - offsetTime)));
                var distanceInLine = bezierData.segmentLength * perc;

                var segmentPerc;
                var addedLength = 0;
                dir = 1;
                flag = true;
                jLen = bezierData.points.length;
                while(flag) {
                    addedLength += bezierData.points[j].partialLength*dir;
                    if (distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for (k = 0; k < kLen; k += 1) {
                            retVal[k] = bezierData.points[j].point[k];
                        }
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
                        segmentPerc = (distanceInLine - addedLength) / (bezierData.points[j + 1].partialLength);
                        kLen = bezierData.points[j].point.length;
                        for (k = 0; k < kLen; k += 1) {
                            retVal[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        }
                        break;
                    }
                    if (j < jLen - 1 && dir == 1 || j > 0 && dir == -1) {
                        j += dir;
                    } else {
                        flag = false;
                    }
                }
            }
        } else {
            var outX,outY,inX,inY, isArray = false, keyValue;
            len = keyData.s.length;
            for(i=0;i<len;i+=1){
                if(keyData.h !== 1){
                    if(keyData.o.x instanceof Array){
                        isArray = true;
                        if(!keyData.__fnct){
                            keyData.__fnct = [];
                        }
                        if(!keyData.__fnct[i]){
                            outX = keyData.o.x[i] || keyData.o.x[0];
                            outY = keyData.o.y[i] || keyData.o.y[0];
                            inX = keyData.i.x[i] || keyData.i.x[0];
                            inY = keyData.i.y[i] || keyData.i.y[0];
                        }
                    }else{
                        isArray = false;
                        if(!keyData.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                        }
                    }
                    if(isArray){
                        if(keyData.__fnct[i]){
                            fnc = keyData.__fnct[i];
                        }else{
                            //fnc = bez.getEasingCurve(outX,outY,inX,inY);
                            fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                            keyData.__fnct[i] = fnc;
                        }
                    }else{
                        if(keyData.__fnct){
                            fnc = keyData.__fnct;
                        }else{
                            //fnc = bez.getEasingCurve(outX,outY,inX,inY);
                            fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                            keyData.__fnct = fnc;
                        }
                    }
                    if(frameNum >= nextKeyData.t-offsetTime){
                        perc = 1;
                    }else if(frameNum < keyData.t-offsetTime){
                        perc = 0;
                    }else{
                        perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
                    }
                }
                if(this.sh && keyData.h !== 1){
                    var initP = keyData.s[i];
                    var endP = keyData.e[i];
                    if(initP-endP < -180){
                        initP += 360;
                    } else if(initP-endP > 180){
                        initP -= 360;
                    }
                    keyValue = initP+(endP-initP)*perc;
                } else {
                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
                }
                if(len === 1){
                    retVal = keyValue;
                }else{
                    retVal[i] = keyValue;
                }
            }
        }
        return retVal;
    }

    function getVelocityAtTime(frameNum) {
        if(this.vel !== undefined){
            return this.vel;
        }
        var delta = -0.01;
        //frameNum += this.elem.data.st;
        var v1 = this.getValueAtTime(frameNum, 0);
        var v2 = this.getValueAtTime(frameNum + delta, 0);
        var velocity;
        if(v1.length){
            velocity = Array.apply(null,{length:v1.length});
            var i;
            for(i=0;i<v1.length;i+=1){
                //removing frameRate
                //if needed, don't add it here
                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i])/delta;
            }
        } else {
            velocity = (v2 - v1)/delta;
        }
        return velocity;
    };

    function setGroupProperty(propertyGroup){
        this.propertyGroup = propertyGroup;
    }

    function searchExpressions(elem,data,prop){
        if(data.x){
            prop.k = true;
            prop.x = true;
            if(prop.getValue) {
                prop.getPreValue = prop.getValue;
            }
            prop.getValue = ExpressionManager.initiateExpression.bind(prop)(elem,data,prop);
        }
    }

    var TextExpressionSelectorProp = (function(){

        function getValueProxy(index,total){
            this.textIndex = index+1;
            this.textTotal = total;
            this.getValue();
            return this.v;
        }

        return function TextExpressionSelectorProp(elem,data){
            this.pv = 1;
            this.comp = elem.comp;
            this.elem = elem;
            this.mult = .01;
            this.type = 'textSelector';
            this.textTotal = data.totalChars;
            this.selectorValue = 100;
            this.lastValue = [1,1,1];
            searchExpressions.bind(this)(elem,data,this);
            this.getMult = getValueProxy;
            this.getVelocityAtTime = getVelocityAtTime;
            if(this.kf){
                this.getValueAtTime = getValueAtTime.bind(this);
            } else {
                this.getValueAtTime = getStaticValueAtTime.bind(this);
            }
            this.setGroupProperty = setGroupProperty;
        }
    }());


    var propertyGetProp = PropertyFactory.getProp;
    PropertyFactory.getProp = function(elem,data,type, mult, arr){
        var prop = propertyGetProp(elem,data,type, mult, arr);
        prop.getVelocityAtTime = getVelocityAtTime;
        if(prop.kf){
            prop.getValueAtTime = getValueAtTime.bind(prop);
        } else {
            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
        }
        prop.setGroupProperty = setGroupProperty;
        var isAdded = prop.k;
        if(data.ix !== undefined){
            Object.defineProperty(prop,'propertyIndex',{
                get: function(){
                    return data.ix;
                }
            })
        }
        searchExpressions(elem,data,prop);
        if(!isAdded && prop.x){
            arr.push(prop);
        }

        return prop;
    }

    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
        prop.setGroupProperty = setGroupProperty;
        if(prop.kf){
            prop.getValueAtTime = getValueAtTime;
        } else {
            prop.getValueAtTime = getStaticValueAtTime;
        }
        var isAdded = prop.k;
        if(data.ix !== undefined){
            Object.defineProperty(prop,'propertyIndex',{
                get: function(){
                    return data.ix;
                }
            })
        }
        if(type === 3){
            searchExpressions(elem,data.pt,prop);
        } else if(type === 4){
            searchExpressions(elem,data.ks,prop);
        }
        if(!isAdded && prop.x){
            arr.push(prop);
        }
        return prop;
    }

    var propertyGetTextProp = PropertyFactory.getTextSelectorProp;
    PropertyFactory.getTextSelectorProp = function(elem, data,arr){
        if(data.t === 1){
            return new TextExpressionSelectorProp(elem, data,arr);
        } else {
            return propertyGetTextProp(elem,data,arr);
        }
    }
}());
var ExpressionManager = (function(){
    var ob = {};
    var Math = BMMath;

    function duplicatePropertyValue(value, mult){
        mult = mult || 1;

        if(typeof value === 'number'  || value instanceof Number){
            return value*mult;
        }else if(value.i){
            return JSON.parse(JSON.stringify(value));
        }else{
            var arr = Array.apply(null,{length:value.length});
            var i, len = value.length;
            for(i=0;i<len;i+=1){
                arr[i]=value[i]*mult;
            }
            return arr;
        }
    }

    function shapesEqual(shape1, shape2) {
        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
            return false;
        }
        var i, len = shape1._length;
        for(i = 0; i < len; i += 1) {
            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1]
                || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1]
                || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
                return false;
            }
        }
        return true;
    }

    function $bm_neg(a){
        var tOfA = typeof a;
        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
            return -a;
        }
        if(a.constructor === Array){
            var i, lenA = a.length;
            var retArr = [];
            for(i=0;i<lenA;i+=1){
                retArr[i] = -a[i];
            }
            return retArr;
        }
    }

    function sum(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        if(tOfA === 'string' || tOfB === 'string'){
            return a + b;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string'  || b instanceof Number)) {
            return a + b;
        }
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            a[0] = a[0] + b;
            return a;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b .constructor === Array){
            b[0] = a + b[0];
            return b;
        }
        if(a.constructor === Array && b.constructor === Array){
            var i = 0, lenA = a.length, lenB = b.length;
            var retArr = [];
            while(i<lenA || i < lenB){
                if(typeof a[i] === 'number' && typeof b[i] === 'number'){
                    retArr[i] = a[i] + b[i];
                }else{
                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
                }
                i += 1;
            }
            return retArr;
        }
        return 0;
    }
    var add = sum;

    function sub(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a - b;
        }
        if( a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            a[0] = a[0] - b;
            return a;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) &&  b.constructor === Array){
            b[0] = a - b[0];
            return b;
        }
        if(a.constructor === Array && b.constructor === Array){
            var i = 0, lenA = a.length, lenB = b.length;
            var retArr = [];
            while(i<lenA || i < lenB){
                if(typeof a[i] === 'number' && typeof b[i] === 'number'){
                    retArr[i] = a[i] - b[i];
                }else{
                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
                }
                i += 1;
            }
            return retArr;
        }
        return 0;
    }

    function mul(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        var arr;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a * b;
        }

        var i, len;
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            len = a.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a[i] * b;
            }
            return arr;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            len = b.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a * b[i];
            }
            return arr;
        }
        return 0;
    }

    function div(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        var arr;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a / b;
        }
        var i, len;
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number  )){
            len = a.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a[i] / b;
            }
            return arr;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            len = b.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a / b[i];
            }
            return arr;
        }
        return 0;
    }

    function clamp(num, min, max) {
        if(min > max){
            var mm = max;
            max = min;
            min = mm;
        }
        return Math.min(Math.max(num, min), max);
    }

    function radiansToDegrees(val) {
        return val/degToRads;
    }
    var radians_to_degrees = radiansToDegrees;

    function degreesToRadians(val) {
        return val*degToRads;
    }
    var degrees_to_radians = radiansToDegrees;

    var helperLengthArray = [0,0,0,0,0,0];

    function length(arr1,arr2){
        if(typeof arr1 === "number"){
            arr2 = arr2 || 0;
            return Math.abs(arr1 - arr2);
        }
        if(!arr2){
            arr2 = helperLengthArray;
        }
        var i,len = Math.min(arr1.length,arr2.length);
        var addedLength = 0;
        for(i=0;i<len;i+=1){
            addedLength += Math.pow(arr2[i]-arr1[i],2);
        }
        return Math.sqrt(addedLength);
    }

    function normalize(vec){
        return div(vec, length(vec));
    }

    function rgbToHsl(val){
        var r = val[0]; var g = val[1]; var b = val[2];
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min){
            h = s = 0; // achromatic
        }else{
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        return [h, s, l,val[3]];
    }
    function hslToRgb(val){
        var h = val[0];
        var s = val[1];
        var l = val[2];

        var r, g, b;

        if(s == 0){
            r = g = b = l; // achromatic
        }else{
            function hue2rgb(p, q, t){
                if(t < 0) t += 1;
                if(t > 1) t -= 1;
                if(t < 1/6) return p + (q - p) * 6 * t;
                if(t < 1/2) return q;
                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                return p;
            }

            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return [r, g , b, val[3]];
    }

    function linear(t, tMin, tMax, value1, value2){
        if(value1 === undefined || value2 === undefined){
            return linear(t,0,1,tMin,tMax);
        }
        if(t <= tMin) {
            return value1;
        }else if(t >= tMax){
            return value2;
        }
        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
        if(!value1.length){
            return value1 + (value2-value1)*perc;
        }
        var i, len = value1.length;
        var arr = Array.apply( null, { length: len } );
        for(i=0;i<len;i+=1){
            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
        }
        return arr;
    }
    function random(min,max){
        if(max === undefined){
            if(min === undefined){
                min = 0;
                max = 1;
            } else {
                max = min;
                min = undefined;
            }
        }
        if(max.length){
            var i, len = max.length;
            if(!min){
                min = Array.apply(null,{length:len});
            }
            var arr = Array.apply(null,{length:len});
            var rnd = BMMath.random();
            for(i=0;i<len;i+=1){
                arr[i] = min[i] + rnd*(max[i]-min[i])
            }
            return arr;
        }
        if(min === undefined){
            min = 0;
        }
        var rndm = BMMath.random();
        return min + rndm*(max-min);
    }

    function initiateExpression(elem,data,property){
        var val = data.x;
        var needsVelocity = /velocity(?![\w\d])/.test(val);
        var _needsRandom = val.indexOf('random') !== -1;
        var elemType = elem.data.ty;
        var transform,content,effect;
        var thisComp = elem.comp;
        var thisProperty = property;
        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
        var thisLayer,thisComp;
        var fn = new Function();
        //var fnStr = 'var fn = function(){'+val+';this.v = $bm_rt;}';
        //eval(fnStr);
        var fn = eval('[function(){' + val+';this.v = $bm_rt;}' + ']')[0];
        var bindedFn = fn.bind(this);
        var numKeys = property.kf ? data.k.length : 0;

        var wiggle = function wiggle(freq,amp){
            var i,j, len = this.pv.length ? this.pv.length : 1;
            var addedAmps = Array.apply(null,{len:len});
            for(j=0;j<len;j+=1){
                addedAmps[j] = 0;
            }
            freq = 5;
            var iterations = Math.floor(time*freq);
            i = 0;
            j = 0;
            while(i<iterations){
                //var rnd = BMMath.random();
                for(j=0;j<len;j+=1){
                    addedAmps[j] += -amp + amp*2*BMMath.random();
                    //addedAmps[j] += -amp + amp*2*rnd;
                }
                i += 1;
            }
            //var rnd2 = BMMath.random();
            var periods = time*freq;
            var perc = periods - Math.floor(periods);
            var arr = Array.apply({length:len});
            if(len>1){
                for(j=0;j<len;j+=1){
                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
                }
                return arr;
            } else {
                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
            }
        }.bind(this);

        var loopIn = function loopIn(type,duration, durationFlag) {
            if(!this.k){
                return this.pv;
            }
            var currentFrame = time*elem.comp.globalData.frameRate;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if(currentFrame>=firstKeyFrame){
                return this.pv;
            }else{
                var cycleDuration, lastKeyFrame;
                if(!durationFlag){
                    if(!duration || duration > keyframes.length - 1){
                        duration = keyframes.length - 1;
                    }
                    lastKeyFrame = keyframes[duration].t;
                    cycleDuration = lastKeyFrame - firstKeyFrame;
                } else {
                    if(!duration){
                        cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
                    } else {
                        cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
                    }
                    lastKeyFrame = firstKeyFrame + cycleDuration;
                }
                var i, len, ret;
                if(type === 'pingpong') {
                    var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
                    if(iterations % 2 === 0){
                        return this.getValueAtTime(((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    }
                } else if(type === 'offset'){
                    var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                    var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                    var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
                    if(this.pv.length){
                        ret = new Array(initV.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = current[i]-(endV[i]-initV[i])*repeats;
                        }
                        return ret;
                    }
                    return current-(endV-initV)*repeats;
                } else if(type === 'continue'){
                    var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                    var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                    if(this.pv.length){
                        ret = new Array(firstValue.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
                        }
                        return ret;
                    }
                    return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
                }
                return this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
            }
        }.bind(this);

        var loopInDuration = function loopInDuration(type,duration){
            return loopIn(type,duration,true);
        }.bind(this);

        var loopOut = function loopOut(type,duration,durationFlag){
            if(!this.k || !this.keyframes){
                return this.pv;
            }
            var currentFrame = time*elem.comp.globalData.frameRate;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if(currentFrame<=lastKeyFrame){
                return this.pv;
            }else{
                var cycleDuration, firstKeyFrame;
                if(!durationFlag){
                    if(!duration || duration > keyframes.length - 1){
                        duration = keyframes.length - 1;
                    }
                    firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                    cycleDuration = lastKeyFrame - firstKeyFrame;
                } else {
                    if(!duration){
                        cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
                    } else {
                        cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
                    }
                    firstKeyFrame = lastKeyFrame - cycleDuration;
                }
                var i, len, ret;
                if(type === 'pingpong') {
                    var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
                    if(iterations % 2 !== 0){
                        return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    }
                } else if(type === 'offset'){
                    var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                    var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                    var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
                    if(this.pv.length){
                        ret = new Array(initV.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = (endV[i]-initV[i])*repeats + current[i];
                        }
                        return ret;
                    }
                    return (endV-initV)*repeats + current;
                } else if(type === 'continue'){
                    var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                    var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                    if(this.pv.length){
                        ret = new Array(lastValue.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
                        }
                        return ret;
                    }
                    return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
                }
                return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
            }
        }.bind(this);
        var loop_out = loopOut;

        var loopOutDuration = function loopOutDuration(type,duration){
            return loopOut(type,duration,true);
        }.bind(this);

        var valueAtTime = function valueAtTime(t) {
            return this.getValueAtTime(t, 0);
        }.bind(this);

        var velocityAtTime = function velocityAtTime(t) {
            return this.getVelocityAtTime(t);
        }.bind(this);

        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

        function lookAt(elem1,elem2){
            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
            return [yaw,pitch,0];
        }

        function easeOut(t, val1, val2){
            return -(val2-val1) * t*(t-2) + val1;
        }

        function nearestKey(time){
            var i, len = data.k.length,index,keyTime;
            if(!data.k.length || typeof(data.k[0]) === 'number'){
                index = 0;
                keyTime = 0;
            } else {
                index = -1;
                time *= elem.comp.globalData.frameRate;
                for(i=0;i<len-1;i+=1){
                    if(time === data.k[i].t){
                        index = i + 1;
                        keyTime = data.k[i].t;
                        break;
                    }else if(time>data.k[i].t && time<data.k[i+1].t){
                        if(time-data.k[i].t > data.k[i+1].t - time){
                            index = i + 2;
                            keyTime = data.k[i+1].t;
                        } else {
                            index = i + 1;
                            keyTime = data.k[i].t;
                        }
                        break;
                    }
                }
                if(index === -1){
                    index = i + 1;
                    keyTime = data.k[i].t;
                }
            }
            var ob = {};
            ob.index = index;
            ob.time = keyTime/elem.comp.globalData.frameRate;
            return ob;
        }

        function key(ind){
            if(!data.k.length || typeof(data.k[0]) === 'number'){
                return {time:0};
            }
            ind -= 1;
            var ob = {
                time: data.k[ind].t/elem.comp.globalData.frameRate
            };
            var arr;
            if(ind === data.k.length - 1 && !data.k[ind].h){
                arr = data.k[ind-1].e;
            }else{
                arr = data.k[ind].s;
            }
            var i, len = arr.length;
            for(i=0;i<len;i+=1){
                ob[i] = arr[i];
            }
            return ob;
        }

        function framesToTime(frames,fps){
            if(!fps){
                fps = elem.comp.globalData.frameRate;
            }
            return frames/fps;
        }

        function timeToFrames(t,fps){
            if(!t){
                t = time;
            }
            if(!fps){
                fps = elem.comp.globalData.frameRate;
            }
            return t*fps;
        }

        var toworldMatrix = new Matrix();
        function toWorld(arr){
            toworldMatrix.reset();
            elem.finalTransform.mProp.applyToMatrix(toworldMatrix);
            if(elem.hierarchy && elem.hierarchy.length){
                var i, len = elem.hierarchy.length;
                for(i=0;i<len;i+=1){
                    elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toworldMatrix);
                }
                return toworldMatrix.applyToPointArray(arr[0],arr[1],arr[2]||0);
            }
            return toworldMatrix.applyToPointArray(arr[0],arr[1],arr[2]||0);
        }

        var fromworldMatrix = new Matrix();
        function fromWorld(arr){
            fromworldMatrix.reset();
            var pts = [];
            pts.push(arr);
            elem.finalTransform.mProp.applyToMatrix(fromworldMatrix);
            if(elem.hierarchy && elem.hierarchy.length){
                var i, len = elem.hierarchy.length;
                for(i=0;i<len;i+=1){
                    elem.hierarchy[i].finalTransform.mProp.applyToMatrix(fromworldMatrix);
                }
                return fromworldMatrix.inversePoints(pts)[0];
            }
            return fromworldMatrix.inversePoints(pts)[0];
        }

        function seedRandom(seed){
            BMMath.seedrandom(randSeed + seed);
        };

        var time,velocity, value,textIndex,textTotal,selectorValue;
        var index = elem.data.ind;
        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
        var parent;
        var randSeed = Math.floor(Math.random()*1000000);
        function execute(){
            if(_needsRandom){
                seedRandom(randSeed);
            }
            if(this.frameExpressionId === elem.globalData.frameId && this.type !== 'textSelector'){
                return;
            }
            if(this.lock){
                this.v = duplicatePropertyValue(this.pv,this.mult);
                return true;
            }
            if(this.type === 'textSelector'){
                textIndex = this.textIndex;
                textTotal = this.textTotal;
                selectorValue = this.selectorValue;
            }
            if(!thisLayer){
                thisLayer = elem.layerInterface;
                thisComp = elem.comp.compInterface;
            }
            if(!transform){
                transform = elem.layerInterface("ADBE Transform Group");
            }
            if(elemType === 4 && !content){
                content = thisLayer("ADBE Root Vectors Group");
            }
            if(!effect){
                effect = thisLayer(4);
            }
            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            if(hasParent && !parent){
                parent = elem.hierarchy[elem.hierarchy.length - 1].layerInterface;
            }
            this.lock = true;
            if(this.getPreValue){
                this.getPreValue();
            }
            value = this.pv;
            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
            if(needsVelocity){
                velocity = velocityAtTime(time);
            }
            bindedFn();
            this.frameExpressionId = elem.globalData.frameId;
            var i,len;
            if(this.mult){
                if(typeof this.v === 'number' || this.v instanceof Number || typeof this.v === 'string'){
                    this.v *= this.mult;
                }else if(this.v.length === 1){
                    this.v = this.v[0] * this.mult;
                }else{
                    len = this.v.length;
                    if(value === this.v){
                        this.v = len === 2 ? [value[0],value[1]] : [value[0],value[1],value[2]];
                    }
                    for(i = 0; i < len; i += 1){
                        this.v[i] *= this.mult;
                    }
                }
            }

            if(this.v.length === 1){
                this.v = this.v[0];
            }
            if(typeof this.v === 'number' || this.v instanceof Number || typeof this.v === 'string'){
                if(this.lastValue !== this.v){
                    this.lastValue = this.v;
                    this.mdf = true;
                }
            }else if(this.v._length){
                if(!shapesEqual(this.v,this.localShapeCollection.shapes[0])){
                    this.mdf = true;
                    this.localShapeCollection.releaseShapes();
                    this.localShapeCollection.addShape(shape_pool.clone(this.v));
                }
            }else{
                len = this.v.length;
                for(i = 0; i < len; i += 1){
                    if(this.v[i] !== this.lastValue[i]){
                        this.lastValue[i] = this.v[i];
                        this.mdf = true;
                    }
                }
            }
            this.lock = false;
        }
        return execute;
    }

    ob.initiateExpression = initiateExpression;
    return ob;
}());
var ShapeExpressionInterface = (function(){
    var ob = {
        createShapeInterface:createShapeInterface,
        createGroupInterface:createGroupInterface,
        createTrimInterface:createTrimInterface,
        createStrokeInterface:createStrokeInterface,
        createTransformInterface:createTransformInterface,
        createEllipseInterface:createEllipseInterface,
        createStarInterface:createStarInterface,
        createRectInterface:createRectInterface,
        createRoundedInterface:createRoundedInterface,
        createRepatearInterface:createRepatearInterface,
        createPathInterface:createPathInterface,
        createFillInterface:createFillInterface
    };
    function createShapeInterface(shapes,view,propertyGroup){
        return shapeInterfaceFactory(shapes,view,propertyGroup);
    }
    function createGroupInterface(shapes,view,propertyGroup){
        return groupInterfaceFactory(shapes,view,propertyGroup);
    }
    function createFillInterface(shape,view,propertyGroup){
        return fillInterfaceFactory(shape,view,propertyGroup);
    }
    function createStrokeInterface(shape,view,propertyGroup){
        return strokeInterfaceFactory(shape,view,propertyGroup);
    }
    function createTrimInterface(shape,view,propertyGroup){
        return trimInterfaceFactory(shape,view,propertyGroup);
    }
    function createTransformInterface(shape,view,propertyGroup){
        return transformInterfaceFactory(shape,view,propertyGroup);
    }
    function createEllipseInterface(shape,view,propertyGroup){
        return ellipseInterfaceFactory(shape,view,propertyGroup);
    }
    function createStarInterface(shape,view,propertyGroup){
        return starInterfaceFactory(shape,view,propertyGroup);
    }
    function createRectInterface(shape,view,propertyGroup){
        return rectInterfaceFactory(shape,view,propertyGroup);
    }
    function createRoundedInterface(shape,view,propertyGroup){
        return roundedInterfaceFactory(shape,view,propertyGroup);
    }
    function createRepatearInterface(shape,view,propertyGroup){
        return repeaterInterfaceFactory(shape,view,propertyGroup);
    }
    function createPathInterface(shape,view,propertyGroup){
        return pathInterfaceFactory(shape,view,propertyGroup);
    }

    function iterateElements(shapes,view, propertyGroup){
        var arr = [];
        var i, len = shapes ? shapes.length : 0;
        for(i=0;i<len;i+=1){
            if(shapes[i].ty == 'gr'){
                arr.push(ShapeExpressionInterface.createGroupInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'fl'){
                arr.push(ShapeExpressionInterface.createFillInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'st'){
                arr.push(ShapeExpressionInterface.createStrokeInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'tm'){
                arr.push(ShapeExpressionInterface.createTrimInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'tr'){
                //arr.push(ShapeExpressionInterface.createTransformInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'el'){
                arr.push(ShapeExpressionInterface.createEllipseInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'sr'){
                arr.push(ShapeExpressionInterface.createStarInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'sh'){
                arr.push(ShapeExpressionInterface.createPathInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rc'){
                arr.push(ShapeExpressionInterface.createRectInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rd'){
                arr.push(ShapeExpressionInterface.createRoundedInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rp'){
                arr.push(ShapeExpressionInterface.createRepatearInterface(shapes[i],view[i],propertyGroup));
            } else{
                //console.log(shapes[i].ty);
            }
        }
        return arr;
    }

    var shapeInterfaceFactory = (function(){
        return function(shapes,view,propertyGroup){
            var interfaces;
            function _interfaceFunction(value){
                if(typeof value === 'number'){
                    return interfaces[value-1];
                } else {
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i]._name === value){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                }
            }
            _interfaceFunction.propertyGroup = propertyGroup;
            interfaces = iterateElements(shapes, view, _interfaceFunction);
            return _interfaceFunction;
        }
    }());

    var contentsInterfaceFactory = (function(){
       return function(shape,view, propertyGroup){
           var interfaces;
           var interfaceFunction = function _interfaceFunction(value){
               var i = 0, len = interfaces.length;
                while(i<len){
                    if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
                       return interfaces[i];
                    }
                    i+=1;
                }
                if(typeof value === 'number'){
                   return interfaces[value-1];
                }
           };
           interfaceFunction.propertyGroup = function(val){
               if(val === 1){
                   return interfaceFunction;
               } else{
                   return propertyGroup(val-1);
               }
           };
           interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
           interfaceFunction.numProperties = interfaces.length;
           interfaceFunction.propertyIndex = shape.cix;

           return interfaceFunction;
       }
    }());

    var groupInterfaceFactory = (function(){
        return function(shape,view, propertyGroup){
            var interfaceFunction = function _interfaceFunction(value){
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    case 'ADBE Vector Transform Group':
                    case 3:
                    default:
                        return interfaceFunction.transform;
                }
                /*if(value === 'ADBE Vector Transform Group'){
                    return interfaceFunction.transform;
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i].ty === 'tr'){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                    return null;
                }
                if(typeof value === 'number'){
                    return interfaces[value-1];
                } else {
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i]._name === value){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                }*/
            }
            interfaceFunction.propertyGroup = function(val){
                if(val === 1){
                    return interfaceFunction;
                } else{
                    return propertyGroup(val-1);
                }
            };
            var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
            var transformInterface = ShapeExpressionInterface.createTransformInterface(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            //interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var fillInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){

            function interfaceFunction(val){
                if(val === 'Color' || val === 'color'){
                    return interfaceFunction.color;
                } else if(val === 'Opacity' || val === 'opacity'){
                    return interfaceFunction.opacity;
                }
            }
            Object.defineProperty(interfaceFunction, 'color', {
                get: function(){
                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
                }
            });
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.o, 100);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });

            view.c.setGroupProperty(propertyGroup);
            view.o.setGroupProperty(propertyGroup);
            return interfaceFunction;
        }
    }());

    var strokeInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val === 1){
                    return ob;
                } else{
                    return propertyGroup(val-1);
                }
            };
            function _dashPropertyGroup(val){
                if(val === 1){
                    return dashOb;
                } else{
                    return _propertyGroup(val-1);
                }
            };
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: function(){
                        return ExpressionValue(view.d.dataProps[i].p)
                    }
                });
            }
            var i, len = shape.d ? shape.d.length : 0;
            var dashOb = {}
            for (i = 0; i < len; i += 1) {
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }

            function interfaceFunction(val){
                if(val === 'Color' || val === 'color'){
                    return interfaceFunction.color;
                } else if(val === 'Opacity' || val === 'opacity'){
                    return interfaceFunction.opacity;
                } else if(val === 'Stroke Width' || val === 'stroke width'){
                    return interfaceFunction.strokeWidth;
                }
            }
            Object.defineProperty(interfaceFunction, 'color', {
                get: function(){
                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
                }
            });
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.o, 100);
                }
            });
            Object.defineProperty(interfaceFunction, 'strokeWidth', {
                get: function(){
                    return ExpressionValue(view.w);
                }
            });
            Object.defineProperty(interfaceFunction, 'dash', {
                get: function(){
                    return dashOb;
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });

            view.c.setGroupProperty(_propertyGroup);
            view.o.setGroupProperty(_propertyGroup);
            view.w.setGroupProperty(_propertyGroup);
            return interfaceFunction;
        }
    }());

    var trimInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            interfaceFunction.propertyIndex = shape.ix;

            view.s.setGroupProperty(_propertyGroup);
            view.e.setGroupProperty(_propertyGroup);
            view.o.setGroupProperty(_propertyGroup);

            function interfaceFunction(val){
                if(val === shape.e.ix || val === 'End' || val === 'end'){
                    return interfaceFunction.end;
                }
                if(val === shape.s.ix){
                    return interfaceFunction.start;
                }
                if(val === shape.o.ix){
                    return interfaceFunction.offset;
                }
            }
            interfaceFunction.propertyIndex = shape.ix;
            Object.defineProperty(interfaceFunction, 'start', {
                get: function(){
                    return ExpressionValue(view.s, 1 / view.s.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'end', {
                get: function(){
                    return ExpressionValue(view.e, 1 / view.e.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'offset', {
                get: function(){
                    return ExpressionValue(view.o);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var transformInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            view.transform.mProps.o.setGroupProperty(_propertyGroup);
            view.transform.mProps.p.setGroupProperty(_propertyGroup);
            view.transform.mProps.a.setGroupProperty(_propertyGroup);
            view.transform.mProps.s.setGroupProperty(_propertyGroup);
            view.transform.mProps.r.setGroupProperty(_propertyGroup);
            if(view.transform.mProps.sk){
                view.transform.mProps.sk.setGroupProperty(_propertyGroup);
                view.transform.mProps.sa.setGroupProperty(_propertyGroup);
            }
            view.transform.op.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.a.ix === value){
                    return interfaceFunction.anchorPoint;
                }
                if(shape.o.ix === value){
                    return interfaceFunction.opacity;
                }
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.s.ix === value){
                    return interfaceFunction.scale;
                }
                if(shape.sk && shape.sk.ix === value){
                    return interfaceFunction.skew;
                }
                if(shape.sa && shape.sa.ix === value){
                    return interfaceFunction.skewAxis;
                }
                if(value === 'Opacity') {
                    return interfaceFunction.opacity;
                }
                if(value === 'Position') {
                    return interfaceFunction.position;
                }
                if(value === 'Anchor Point') {
                    return interfaceFunction.anchorPoint;
                }
                if(value === 'Scale') {
                    return interfaceFunction.scale;
                }
                if(value === 'Rotation' || value === 'ADBE Vector Rotation') {
                    return interfaceFunction.rotation;
                }
                if(value === 'Skew') {
                    return interfaceFunction.skew;
                }
                if(value === 'Skew Axis') {
                    return interfaceFunction.skewAxis;
                }

            }
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'anchorPoint', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.a);
                }
            });
            var scaleArray = [];
            Object.defineProperty(interfaceFunction, 'scale', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'rotation', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'skew', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.sk);
                }
            });
            Object.defineProperty(interfaceFunction, 'skewAxis', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.sa);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var ellipseInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(_propertyGroup);
            prop.p.setGroupProperty(_propertyGroup);
            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.s.ix === value){
                    return interfaceFunction.size;
                }
            }
            Object.defineProperty(interfaceFunction, 'size', {
                get: function(){
                    return ExpressionValue(prop.s);
                }
            });
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var starInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(_propertyGroup);
            prop.os.setGroupProperty(_propertyGroup);
            prop.pt.setGroupProperty(_propertyGroup);
            prop.p.setGroupProperty(_propertyGroup);
            prop.r.setGroupProperty(_propertyGroup);
            if(shape.ir){
                prop.ir.setGroupProperty(_propertyGroup);
                prop.is.setGroupProperty(_propertyGroup);
            }

            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.pt.ix === value){
                    return interfaceFunction.points;
                }
                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
                    return interfaceFunction.outerRadius;
                }
                if(shape.os.ix === value){
                    return interfaceFunction.outerRoundness;
                }
                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
                    return interfaceFunction.innerRadius;
                }
                if(shape.is && shape.is.ix === value){
                    return interfaceFunction.innerRoundness;
                }

            }
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'rotation', {
                get: function(){
                    return ExpressionValue(prop.r, 1 / prop.r.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'points', {
                get: function(){
                    return ExpressionValue(prop.pt);
                }
            });
            Object.defineProperty(interfaceFunction, 'outerRadius', {
                get: function(){
                    return ExpressionValue(prop.or);
                }
            });
            Object.defineProperty(interfaceFunction, 'outerRoundness', {
                get: function(){
                    return ExpressionValue(prop.os);
                }
            });
            Object.defineProperty(interfaceFunction, 'innerRadius', {
                get: function(){
                    if(!prop.ir){
                        return 0;
                    }
                    return ExpressionValue(prop.ir);
                }
            });
            Object.defineProperty(interfaceFunction, 'innerRoundness', {
                get: function(){
                    if(!prop.is){
                        return 0;
                    }
                    return ExpressionValue(prop.is, 1 / prop.is.mult);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var rectInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(_propertyGroup);
            prop.s.setGroupProperty(_propertyGroup);
            prop.r.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.pt.ix === value){
                    return interfaceFunction.points;
                }
                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
                    return interfaceFunction.outerRadius;
                }
                if(shape.os.ix === value){
                    return interfaceFunction.outerRoundness;
                }
                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
                    return interfaceFunction.innerRadius;
                }
                if(shape.is && shape.is.ix === value){
                    return interfaceFunction.innerRoundness;
                }

            }
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'roundness', {
                get: function(){
                    return ExpressionValue(prop.r);
                }
            });
            Object.defineProperty(interfaceFunction, 'size', {
                get: function(){
                    return ExpressionValue(prop.s);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var roundedInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.r.ix === value || 'Round Corners 1' === value){
                    return interfaceFunction.radius;
                }

            }
            Object.defineProperty(interfaceFunction, 'radius', {
                get: function(){
                    return ExpressionValue(prop.rd);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var repeaterInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(_propertyGroup);
            prop.o.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.c.ix === value || 'Copies' === value){
                    return interfaceFunction.copies;
                } else if(shape.o.ix === value || 'Offset' === value){
                    return interfaceFunction.offset;
                }

            }
            Object.defineProperty(interfaceFunction, 'copies', {
                get: function(){
                    return ExpressionValue(prop.c);
                }
            });

            Object.defineProperty(interfaceFunction, 'offset', {
                get: function(){
                    return ExpressionValue(prop.o);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var pathInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            prop.setGroupProperty(_propertyGroup);

            function interfaceFunction(val){
                if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path'){
                    return interfaceFunction.path;
                }
            }
            Object.defineProperty(interfaceFunction, 'path', {
                get: function(){
                    if(prop.k){
                        prop.getValue();
                    }
                    return prop.v;
                    //return shape_pool.clone(prop.v);
                }
            });
            Object.defineProperty(interfaceFunction, 'shape', {
                get: function(){
                    if(prop.k){
                        prop.getValue();
                    }
                    return prop.v;
                    //return shape_pool.clone(prop.v);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'ix', { value: shape.ix });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
            return interfaceFunction;
        }
    }());


    return ob;
}())

var TextExpressionInterface = (function(){
	return function(elem){
        function _thisLayerFunction(){
        }
        Object.defineProperty(_thisLayerFunction, "sourceText", {
            get: function(){
            	if(!elem.currentTextDocumentData.t) {
            		return ''
            	}
                return elem.currentTextDocumentData.t;
            }
        });
        return _thisLayerFunction;
    }
}())
var LayerExpressionInterface = (function (){
    function toWorld(arr){
        var toWorldMat = new Matrix();
        toWorldMat.reset();
        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
        if(this._elem.hierarchy && this._elem.hierarchy.length){
            var i, len = this._elem.hierarchy.length;
            for(i=0;i<len;i+=1){
                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
        }
        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
    }


    return function(elem){

        var transformInterface = TransformExpressionInterface(elem.transform);

        function _registerMaskInterface(maskManager){
            _thisLayerFunction.mask = maskManager.getMask.bind(maskManager);
        }
        function _registerEffectsInterface(effects){
            _thisLayerFunction.effect = effects;
        }

        function _thisLayerFunction(name){
            switch(name){
                case "ADBE Root Vectors Group":
                case "Contents":
                case 2:
                    return _thisLayerFunction.shapeInterface;
                case 1:
                case "Transform":
                case "transform":
                case "ADBE Transform Group":
                    return transformInterface;
                case 4:
                case "ADBE Effect Parade":
                    return _thisLayerFunction.effect;
            }
        }
        _thisLayerFunction.toWorld = toWorld;
        _thisLayerFunction.toComp = toWorld;
        _thisLayerFunction._elem = elem;
        Object.defineProperty(_thisLayerFunction, 'hasParent', {
            get: function(){
                return !!elem.hierarchy;
            }
        });
        Object.defineProperty(_thisLayerFunction, 'parent', {
            get: function(){
                return elem.hierarchy[0].layerInterface;
            }
        });
        Object.defineProperty(_thisLayerFunction, "rotation", {
            get: function(){
                return transformInterface.rotation;
            }
        });
        Object.defineProperty(_thisLayerFunction, "scale", {
            get: function () {
                return transformInterface.scale;
            }
        });

        Object.defineProperty(_thisLayerFunction, "position", {
            get: function () {
                return transformInterface.position;
            }
        });

        Object.defineProperty(_thisLayerFunction, "anchorPoint", {
            get: function () {
                return transformInterface.anchorPoint;
            }
        });

        Object.defineProperty(_thisLayerFunction, "transform", {
            get: function () {
                return transformInterface;
            }
        });

        Object.defineProperty(_thisLayerFunction, "width", {
            get: function () {
                if(elem.data.ty === 0) {
                    return elem.data.w
                }
                return 100;
            }
        });

        Object.defineProperty(_thisLayerFunction, "height", {
            get: function () {
                if(elem.data.ty === 0) {
                    return elem.data.h
                }
                return 100;
            }
        });

        Object.defineProperty(_thisLayerFunction, "source", {
            get: function () {
                return elem.data.refId;
            }
        });

        Object.defineProperty(_thisLayerFunction, "_name", { value:elem.data.nm });
        Object.defineProperty(_thisLayerFunction, "content", {
            get: function(){
                return _thisLayerFunction.shapeInterface;
            }
        });

        Object.defineProperty(_thisLayerFunction, "active", {
            get: function(){
                return elem.isVisible;
            }
        });

        Object.defineProperty(_thisLayerFunction, "text", {
            get: function(){
                return _thisLayerFunction.textInterface;
            }
        });

        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
        return _thisLayerFunction;
    }
}());

var CompExpressionInterface = (function (){
    return function(comp){
        function _thisLayerFunction(name){
            var i=0, len = comp.layers.length;
            while(i<len){
                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
                    return comp.elements[i].layerInterface;
                }
                i += 1;
            }
            return {active:false}
        }
        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
        _thisLayerFunction.layer = _thisLayerFunction;
        _thisLayerFunction.pixelAspect = 1;
        _thisLayerFunction.height = comp.globalData.compSize.h;
        _thisLayerFunction.width = comp.globalData.compSize.w;
        _thisLayerFunction.pixelAspect = 1;
        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
        return _thisLayerFunction;
    }
}());
var TransformExpressionInterface = (function (){
    return function(transform){
        function _thisFunction(name){
            switch(name){
                case "scale":
                case "Scale":
                case "ADBE Scale":
                    return _thisFunction.scale;
                case "rotation":
                case "Rotation":
                case "ADBE Rotation":
                case "ADBE Rotate Z":
                    return _thisFunction.rotation;
                case "position":
                case "Position":
                case "ADBE Position":
                    return transform.position;
                case "anchorPoint":
                case "AnchorPoint":
                case "Anchor Point":
                case "ADBE AnchorPoint":
                    return _thisFunction.anchorPoint;
                case "opacity":
                case "Opacity":
                    return _thisFunction.opacity;
            }
        }

        Object.defineProperty(_thisFunction, "rotation", {
            get: function(){
                return transform.rotation;
            }
        });
        Object.defineProperty(_thisFunction, "scale", {
            get: function () {
                return transform.scale;
            }
        });

        Object.defineProperty(_thisFunction, "position", {
            get: function () {
                return transform.position;
            }
        });

        Object.defineProperty(_thisFunction, "xPosition", {
            get: function () {
                return transform.xPosition;
            }
        });

        Object.defineProperty(_thisFunction, "yPosition", {
            get: function () {
                return transform.yPosition;
            }
        });

        Object.defineProperty(_thisFunction, "anchorPoint", {
            get: function () {
                return transform.anchorPoint;
            }
        });

        Object.defineProperty(_thisFunction, "opacity", {
            get: function () {
                return transform.opacity;
            }
        });

        Object.defineProperty(_thisFunction, "skew", {
            get: function () {
                return transform.skew;
            }
        });

        Object.defineProperty(_thisFunction, "skewAxis", {
            get: function () {
                return transform.skewAxis;
            }
        });

        return _thisFunction;
    }
}());
var ProjectInterface = (function (){

    function registerComposition(comp){
        this.compositions.push(comp);
    }

    return function(){
        function _thisProjectFunction(name){
            var i = 0, len = this.compositions.length;
            while(i<len){
                if(this.compositions[i].data && this.compositions[i].data.nm === name){
                    this.compositions[i].prepareFrame(this.currentFrame);
                    return this.compositions[i].compInterface;
                }
                i+=1;
            }
        }

        _thisProjectFunction.compositions = [];
        _thisProjectFunction.currentFrame = 0;

        _thisProjectFunction.registerComposition = registerComposition;



        return _thisProjectFunction;
    }
}());
var EffectsExpressionInterface = (function (){
    var ob = {
        createEffectsInterface: createEffectsInterface
    };

    function createEffectsInterface(elem, propertyGroup){
        if(elem.effects){

            var effectElements = [];
            var effectsData = elem.data.ef;
            var i, len = elem.effects.effectElements.length;
            for(i=0;i<len;i+=1){
                effectElements.push(createGroupInterface(effectsData[i],elem.effects.effectElements[i],propertyGroup,elem));
            }

            return function(name){
                var effects = elem.data.ef, i = 0, len = effects.length;
                while(i<len) {
                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
                        return effectElements[i];
                    }
                    i += 1;
                }
            }
        }
    }

    function createGroupInterface(data,elements, propertyGroup, elem){
        var effectElements = [];
        var i, len = data.ef.length;
        for(i=0;i<len;i+=1){
            if(data.ef[i].ty === 5){
                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],propertyGroup, elem));
            } else {
                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem));
            }
        }
        var groupInterface = function(name){
            var effects = data.ef, i = 0, len = effects.length;
            while(i<len) {
                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
                    if(effects[i].ty === 5){
                        return effectElements[i];
                    } else {
                        return effectElements[i]();
                    }
                }
                i += 1;
            }
            return effectElements[0]();
        }
        if(data.mn === 'ADBE Color Control'){
            Object.defineProperty(groupInterface, 'color', {
                get: function(){
                    return effectElements[0]();
                }
            });
        }
        groupInterface.active = data.en !== 0;
        return groupInterface
    }

    function createValueInterface(element, type, elem){
        return function(){
            if(type === 10){
                return elem.comp.compInterface(element.p.v);
            }
            return ExpressionValue(element.p);
        }
    }

    return ob;

}());
var ExpressionValue = (function() {
	return function(elementProp, mult, type) {
        var expressionValue, arrayValue;
		if (elementProp.k) {
            elementProp.getValue();
        }
        var i, len, arrValue;
        if (type) {
        	if(type === 'color') {
        		len = 4;
		        expressionValue = Array.apply(null, {length: len});
		        arrValue = Array.apply(null, {length: len});
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = (mult && i < 3) ? elementProp.v[i] * mult : 1;
		        }
	        	expressionValue.value = arrValue;
        	}
        } else if (typeof elementProp.v === 'number' || elementProp.v instanceof Number){
            expressionValue = mult ? new Number(elementProp.v * mult) : new Number(elementProp.v);
            expressionValue.value = mult ? elementProp.v * mult : elementProp.v;
        } else {
        	len = elementProp.v.length;
	        expressionValue = Array.apply(null, {length: len});
	        arrValue = Array.apply(null, {length: len});
	        for (i = 0; i < len; i += 1) {
	            expressionValue[i] = arrValue[i] = mult ? elementProp.v[i] * mult : elementProp.v[i];
	        }
	        expressionValue.value = arrValue;
        }
        
        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
        expressionValue.key = function(pos) {
            if (!expressionValue.numKeys) {
                return 0;
            } else {
                return elementProp.keyframes[pos-1].t;
            }
        };
        expressionValue.valueAtTime = elementProp.getValueAtTime;
        expressionValue.propertyGroup = elementProp.propertyGroup;
        return expressionValue;
	}
}())
function SliderEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function AngleEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function ColorEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
}
function PointEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
}
function LayerIndexEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function MaskIndexEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function CheckboxEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function NoValueEffect(){
    this.p = {};
}
function EffectsManager(data,element,dynamicProperties){
    var effects = data.ef;
    this.effectElements = [];
    var i,len = effects.length;
    var effectItem;
    for(i=0;i<len;i++) {
        effectItem = new GroupEffect(effects[i],element,dynamicProperties);
        this.effectElements.push(effectItem);
    }
}

function GroupEffect(data,element,dynamicProperties){
    this.dynamicProperties = [];
    this.init(data,element,this.dynamicProperties);
    if(this.dynamicProperties.length){
        dynamicProperties.push(this);
    }
}

GroupEffect.prototype.getValue = function(){
    this.mdf = false;
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        this.mdf = this.dynamicProperties[i].mdf ? true : this.mdf;
    }
};

GroupEffect.prototype.init = function(data,element,dynamicProperties){
    this.data = data;
    this.mdf = false;
    this.effectElements = [];
    var i, len = this.data.ef.length;
    var eff, effects = this.data.ef;
    for(i=0;i<len;i+=1){
        switch(effects[i].ty){
            case 0:
                eff = new SliderEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 1:
                eff = new AngleEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 2:
                eff = new ColorEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 3:
                eff = new PointEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 4:
            case 7:
                eff = new CheckboxEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 10:
                eff = new LayerIndexEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 11:
                eff = new MaskIndexEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 5:
                eff = new EffectsManager(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 6:
                eff = new NoValueEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
        }
    }
};var bodymovinjs = {}; function play(animation){ animationManager.play(animation); } function pause(animation){ animationManager.pause(animation); } function togglePause(animation){ animationManager.togglePause(animation); } function setSpeed(value,animation){ animationManager.setSpeed(value, animation); } function setDirection(value,animation){ animationManager.setDirection(value, animation); } function stop(animation){ animationManager.stop(animation); } function moveFrame(value){ animationManager.moveFrame(value); } function searchAnimations(){ if(standalone === true){ animationManager.searchAnimations(animationData,standalone, renderer); }else{ animationManager.searchAnimations(); } } function registerAnimation(elem){ return animationManager.registerAnimation(elem); } function resize(){ animationManager.resize(); } function start(){ animationManager.start(); } function goToAndStop(val,isFrame, animation){ animationManager.goToAndStop(val,isFrame, animation); } function setSubframeRendering(flag){ subframeEnabled = flag; } function loadAnimation(params){ if(standalone === true){ params.animationData = JSON.parse(animationData); } return animationManager.loadAnimation(params); } function destroy(animation){ return animationManager.destroy(animation); } function setQuality(value){ if(typeof value === 'string'){ switch(value){ case 'high': defaultCurveSegments = 200; break; case 'medium': defaultCurveSegments = 50; break; case 'low': defaultCurveSegments = 10; break; } }else if(!isNaN(value) && value > 1){ defaultCurveSegments = value; } if(defaultCurveSegments >= 50){ roundValues(false); }else{ roundValues(true); } } function installPlugin(type,plugin){ if(type==='expressions'){ expressionsPlugin = plugin; } } function getFactory(name){ switch(name){ case "propertyFactory": return PropertyFactory;case "shapePropertyFactory": return ShapePropertyFactory; case "matrix": return Matrix; } } bodymovinjs.play = play; bodymovinjs.pause = pause; bodymovinjs.togglePause = togglePause; bodymovinjs.setSpeed = setSpeed; bodymovinjs.setDirection = setDirection; bodymovinjs.stop = stop; bodymovinjs.moveFrame = moveFrame; bodymovinjs.searchAnimations = searchAnimations; bodymovinjs.registerAnimation = registerAnimation; bodymovinjs.loadAnimation = loadAnimation; bodymovinjs.setSubframeRendering = setSubframeRendering; bodymovinjs.resize = resize; bodymovinjs.start = start; bodymovinjs.goToAndStop = goToAndStop; bodymovinjs.destroy = destroy; bodymovinjs.setQuality = setQuality; bodymovinjs.installPlugin = installPlugin; bodymovinjs.__getFactory = getFactory; bodymovinjs.version = '4.6.8'; function checkReady(){ if (document.readyState === "complete") { clearInterval(readyStateCheckInterval); searchAnimations(); } } function getQueryVariable(variable) { var vars = queryString.split('&'); for (var i = 0; i < vars.length; i++) { var pair = vars[i].split('='); if (decodeURIComponent(pair[0]) == variable) { return decodeURIComponent(pair[1]); } } } var standalone = '__[STANDALONE]__'; var animationData = '__[ANIMATIONDATA]__'; var renderer = ''; if(standalone) { var scripts = document.getElementsByTagName('script'); var index = scripts.length - 1; var myScript = scripts[index]; var queryString = myScript.src.replace(/^[^\?]+\??/,''); renderer = getQueryVariable('renderer'); } var readyStateCheckInterval = setInterval(checkReady, 100); return bodymovinjs; }));  
},{}],391:[function(require,module,exports){
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/

var BROTLI_READ_SIZE = 4096;
var BROTLI_IBUF_SIZE =  (2 * BROTLI_READ_SIZE + 32);
var BROTLI_IBUF_MASK =  (2 * BROTLI_READ_SIZE - 1);

var kBitMask = new Uint32Array([
  0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767,
  65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215
]);

/* Input byte buffer, consist of a ringbuffer and a "slack" region where */
/* bytes from the start of the ringbuffer are copied. */
function BrotliBitReader(input) {
  this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
  this.input_ = input;    /* input callback */
  
  this.reset();
}

BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;

BrotliBitReader.prototype.reset = function() {
  this.buf_ptr_ = 0;      /* next input will write here */
  this.val_ = 0;          /* pre-fetched bits */
  this.pos_ = 0;          /* byte position in stream */
  this.bit_pos_ = 0;      /* current bit-reading position in val_ */
  this.bit_end_pos_ = 0;  /* bit-reading end position from LSB of val_ */
  this.eos_ = 0;          /* input stream is finished */
  
  this.readMoreInput();
  for (var i = 0; i < 4; i++) {
    this.val_ |= this.buf_[this.pos_] << (8 * i);
    ++this.pos_;
  }
  
  return this.bit_end_pos_ > 0;
};

/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/
BrotliBitReader.prototype.readMoreInput = function() {
  if (this.bit_end_pos_ > 256) {
    return;
  } else if (this.eos_) {
    if (this.bit_pos_ > this.bit_end_pos_)
      throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
  } else {
    var dst = this.buf_ptr_;
    var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
    if (bytes_read < 0) {
      throw new Error('Unexpected end of input');
    }
    
    if (bytes_read < BROTLI_READ_SIZE) {
      this.eos_ = 1;
      /* Store 32 bytes of zero after the stream end. */
      for (var p = 0; p < 32; p++)
        this.buf_[dst + bytes_read + p] = 0;
    }
    
    if (dst === 0) {
      /* Copy the head of the ringbuffer to the slack region. */
      for (var p = 0; p < 32; p++)
        this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];

      this.buf_ptr_ = BROTLI_READ_SIZE;
    } else {
      this.buf_ptr_ = 0;
    }
    
    this.bit_end_pos_ += bytes_read << 3;
  }
};

/* Guarantees that there are at least 24 bits in the buffer. */
BrotliBitReader.prototype.fillBitWindow = function() {    
  while (this.bit_pos_ >= 8) {
    this.val_ >>>= 8;
    this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
    ++this.pos_;
    this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
    this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
  }
};

/* Reads the specified number of bits from Read Buffer. */
BrotliBitReader.prototype.readBits = function(n_bits) {
  if (32 - this.bit_pos_ < n_bits) {
    this.fillBitWindow();
  }
  
  var val = ((this.val_ >>> this.bit_pos_) & kBitMask[n_bits]);
  this.bit_pos_ += n_bits;
  return val;
};

module.exports = BrotliBitReader;

},{}],392:[function(require,module,exports){
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/

var CONTEXT_LSB6         = 0;
var CONTEXT_MSB6         = 1;
var CONTEXT_UTF8         = 2;
var CONTEXT_SIGNED       = 3;

/* Common context lookup table for all context modes. */
exports.lookup = new Uint8Array([
  /* CONTEXT_UTF8, last byte. */
  /* ASCII range. */
   0,  0,  0,  0,  0,  0,  0,  0,  0,  4,  4,  0,  0,  4,  0,  0,
   0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,
   8, 12, 16, 12, 12, 20, 12, 16, 24, 28, 12, 12, 32, 12, 36, 12,
  44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 32, 32, 24, 40, 28, 12,
  12, 48, 52, 52, 52, 48, 52, 52, 52, 48, 52, 52, 52, 52, 52, 48,
  52, 52, 52, 52, 52, 48, 52, 52, 52, 52, 52, 24, 12, 28, 12, 12,
  12, 56, 60, 60, 60, 56, 60, 60, 60, 56, 60, 60, 60, 60, 60, 56,
  60, 60, 60, 60, 60, 56, 60, 60, 60, 60, 60, 24, 12, 28, 12,  0,
  /* UTF8 continuation byte range. */
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  /* UTF8 lead byte range. */
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  /* CONTEXT_UTF8 second last byte. */
  /* ASCII range. */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1,
  1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1,
  1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0,
  /* UTF8 continuation byte range. */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  /* UTF8 lead byte range. */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  /* CONTEXT_SIGNED, second last byte. */
  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7,
  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
   0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
  48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 56,
  /* CONTEXT_LSB6, last byte. */
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
  /* CONTEXT_MSB6, last byte. */
   0,  0,  0,  0,  1,  1,  1,  1,  2,  2,  2,  2,  3,  3,  3,  3,
   4,  4,  4,  4,  5,  5,  5,  5,  6,  6,  6,  6,  7,  7,  7,  7,
   8,  8,  8,  8,  9,  9,  9,  9, 10, 10, 10, 10, 11, 11, 11, 11,
  12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15,
  16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19,
  20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23,
  24, 24, 24, 24, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27,
  28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31,
  32, 32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35,
  36, 36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39,
  40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43,
  44, 44, 44, 44, 45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47,
  48, 48, 48, 48, 49, 49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51,
  52, 52, 52, 52, 53, 53, 53, 53, 54, 54, 54, 54, 55, 55, 55, 55,
  56, 56, 56, 56, 57, 57, 57, 57, 58, 58, 58, 58, 59, 59, 59, 59,
  60, 60, 60, 60, 61, 61, 61, 61, 62, 62, 62, 62, 63, 63, 63, 63,
  /* CONTEXT_{M,L}SB6, second last byte, */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]);

exports.lookupOffsets = new Uint16Array([
  /* CONTEXT_LSB6 */
  1024, 1536,
  /* CONTEXT_MSB6 */
  1280, 1536,
  /* CONTEXT_UTF8 */
  0, 256,
  /* CONTEXT_SIGNED */
  768, 512,
]);

},{}],393:[function(require,module,exports){
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/

var BrotliInput = require('./streams').BrotliInput;
var BrotliOutput = require('./streams').BrotliOutput;
var BrotliBitReader = require('./bit_reader');
var BrotliDictionary = require('./dictionary');
var HuffmanCode = require('./huffman').HuffmanCode;
var BrotliBuildHuffmanTable = require('./huffman').BrotliBuildHuffmanTable;
var Context = require('./context');
var Prefix = require('./prefix');
var Transform = require('./transform');

var kDefaultCodeLength = 8;
var kCodeLengthRepeatCode = 16;
var kNumLiteralCodes = 256;
var kNumInsertAndCopyCodes = 704;
var kNumBlockLengthCodes = 26;
var kLiteralContextBits = 6;
var kDistanceContextBits = 2;

var HUFFMAN_TABLE_BITS = 8;
var HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */
var HUFFMAN_MAX_TABLE_SIZE = 1080;

var CODE_LENGTH_CODES = 18;
var kCodeLengthCodeOrder = new Uint8Array([
  1, 2, 3, 4, 0, 5, 17, 6, 16, 7, 8, 9, 10, 11, 12, 13, 14, 15,
]);

var NUM_DISTANCE_SHORT_CODES = 16;
var kDistanceShortCodeIndexOffset = new Uint8Array([
  3, 2, 1, 0, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2
]);

var kDistanceShortCodeValueOffset = new Int8Array([
  0, 0, 0, 0, -1, 1, -2, 2, -3, 3, -1, 1, -2, 2, -3, 3
]);

var kMaxHuffmanTableSize = new Uint16Array([
  256, 402, 436, 468, 500, 534, 566, 598, 630, 662, 694, 726, 758, 790, 822,
  854, 886, 920, 952, 984, 1016, 1048, 1080
]);

function DecodeWindowBits(br) {
  var n;
  if (br.readBits(1) === 0) {
    return 16;
  }
  
  n = br.readBits(3);
  if (n > 0) {
    return 17 + n;
  }
  
  n = br.readBits(3);
  if (n > 0) {
    return 8 + n;
  }
  
  return 17;
}

/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */
function DecodeVarLenUint8(br) {
  if (br.readBits(1)) {
    var nbits = br.readBits(3);
    if (nbits === 0) {
      return 1;
    } else {
      return br.readBits(nbits) + (1 << nbits);
    }
  }
  return 0;
}

function MetaBlockLength() {
  this.meta_block_length = 0;
  this.input_end = 0;
  this.is_uncompressed = 0;
  this.is_metadata = false;
}

function DecodeMetaBlockLength(br) {
  var out = new MetaBlockLength;  
  var size_nibbles;
  var size_bytes;
  var i;
  
  out.input_end = br.readBits(1);
  if (out.input_end && br.readBits(1)) {
    return out;
  }
  
  size_nibbles = br.readBits(2) + 4;
  if (size_nibbles === 7) {
    out.is_metadata = true;
    
    if (br.readBits(1) !== 0)
      throw new Error('Invalid reserved bit');
    
    size_bytes = br.readBits(2);
    if (size_bytes === 0)
      return out;
    
    for (i = 0; i < size_bytes; i++) {
      var next_byte = br.readBits(8);
      if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0)
        throw new Error('Invalid size byte');
      
      out.meta_block_length |= next_byte << (i * 8);
    }
  } else {
    for (i = 0; i < size_nibbles; ++i) {
      var next_nibble = br.readBits(4);
      if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0)
        throw new Error('Invalid size nibble');
      
      out.meta_block_length |= next_nibble << (i * 4);
    }
  }
  
  ++out.meta_block_length;
  
  if (!out.input_end && !out.is_metadata) {
    out.is_uncompressed = br.readBits(1);
  }
  
  return out;
}

/* Decodes the next Huffman code from bit-stream. */
function ReadSymbol(table, index, br) {
  var start_index = index;
  
  var nbits;
  br.fillBitWindow();
  index += (br.val_ >>> br.bit_pos_) & HUFFMAN_TABLE_MASK;
  nbits = table[index].bits - HUFFMAN_TABLE_BITS;
  if (nbits > 0) {
    br.bit_pos_ += HUFFMAN_TABLE_BITS;
    index += table[index].value;
    index += (br.val_ >>> br.bit_pos_) & ((1 << nbits) - 1);
  }
  br.bit_pos_ += table[index].bits;
  return table[index].value;
}

function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
  var symbol = 0;
  var prev_code_len = kDefaultCodeLength;
  var repeat = 0;
  var repeat_code_len = 0;
  var space = 32768;
  
  var table = [];
  for (var i = 0; i < 32; i++)
    table.push(new HuffmanCode(0, 0));
  
  BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);

  while (symbol < num_symbols && space > 0) {
    var p = 0;
    var code_len;
    
    br.readMoreInput();
    br.fillBitWindow();
    p += (br.val_ >>> br.bit_pos_) & 31;
    br.bit_pos_ += table[p].bits;
    code_len = table[p].value & 0xff;
    if (code_len < kCodeLengthRepeatCode) {
      repeat = 0;
      code_lengths[symbol++] = code_len;
      if (code_len !== 0) {
        prev_code_len = code_len;
        space -= 32768 >> code_len;
      }
    } else {
      var extra_bits = code_len - 14;
      var old_repeat;
      var repeat_delta;
      var new_len = 0;
      if (code_len === kCodeLengthRepeatCode) {
        new_len = prev_code_len;
      }
      if (repeat_code_len !== new_len) {
        repeat = 0;
        repeat_code_len = new_len;
      }
      old_repeat = repeat;
      if (repeat > 0) {
        repeat -= 2;
        repeat <<= extra_bits;
      }
      repeat += br.readBits(extra_bits) + 3;
      repeat_delta = repeat - old_repeat;
      if (symbol + repeat_delta > num_symbols) {
        throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
      }
      
      for (var x = 0; x < repeat_delta; x++)
        code_lengths[symbol + x] = repeat_code_len;
      
      symbol += repeat_delta;
      
      if (repeat_code_len !== 0) {
        space -= repeat_delta << (15 - repeat_code_len);
      }
    }
  }
  if (space !== 0) {
    throw new Error("[ReadHuffmanCodeLengths] space = " + space);
  }
  
  for (; symbol < num_symbols; symbol++)
    code_lengths[symbol] = 0;
}

function ReadHuffmanCode(alphabet_size, tables, table, br) {
  var table_size = 0;
  var simple_code_or_skip;
  var code_lengths = new Uint8Array(alphabet_size);
  
  br.readMoreInput();
  
  /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */
  simple_code_or_skip = br.readBits(2);
  if (simple_code_or_skip === 1) {
    /* Read symbols, codes & code lengths directly. */
    var i;
    var max_bits_counter = alphabet_size - 1;
    var max_bits = 0;
    var symbols = new Int32Array(4);
    var num_symbols = br.readBits(2) + 1;
    while (max_bits_counter) {
      max_bits_counter >>= 1;
      ++max_bits;
    }

    for (i = 0; i < num_symbols; ++i) {
      symbols[i] = br.readBits(max_bits) % alphabet_size;
      code_lengths[symbols[i]] = 2;
    }
    code_lengths[symbols[0]] = 1;
    switch (num_symbols) {
      case 1:
        break;
      case 3:
        if ((symbols[0] === symbols[1]) ||
            (symbols[0] === symbols[2]) ||
            (symbols[1] === symbols[2])) {
          throw new Error('[ReadHuffmanCode] invalid symbols');
        }
        break;
      case 2:
        if (symbols[0] === symbols[1]) {
          throw new Error('[ReadHuffmanCode] invalid symbols');
        }
        
        code_lengths[symbols[1]] = 1;
        break;
      case 4:
        if ((symbols[0] === symbols[1]) ||
            (symbols[0] === symbols[2]) ||
            (symbols[0] === symbols[3]) ||
            (symbols[1] === symbols[2]) ||
            (symbols[1] === symbols[3]) ||
            (symbols[2] === symbols[3])) {
          throw new Error('[ReadHuffmanCode] invalid symbols');
        }
        
        if (br.readBits(1)) {
          code_lengths[symbols[2]] = 3;
          code_lengths[symbols[3]] = 3;
        } else {
          code_lengths[symbols[0]] = 2;
        }
        break;
    }
  } else {  /* Decode Huffman-coded code lengths. */
    var i;
    var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
    var space = 32;
    var num_codes = 0;
    /* Static Huffman code for the code length code lengths */
    var huff = [
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 1),
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 5)
    ];
    for (i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i) {
      var code_len_idx = kCodeLengthCodeOrder[i];
      var p = 0;
      var v;
      br.fillBitWindow();
      p += (br.val_ >>> br.bit_pos_) & 15;
      br.bit_pos_ += huff[p].bits;
      v = huff[p].value;
      code_length_code_lengths[code_len_idx] = v;
      if (v !== 0) {
        space -= (32 >> v);
        ++num_codes;
      }
    }
    
    if (!(num_codes === 1 || space === 0))
      throw new Error('[ReadHuffmanCode] invalid num_codes or space');
    
    ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
  }
  
  table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
  
  if (table_size === 0) {
    throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
  }
  
  return table_size;
}

function ReadBlockLength(table, index, br) {
  var code;
  var nbits;
  code = ReadSymbol(table, index, br);
  nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
  return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}

function TranslateShortCodes(code, ringbuffer, index) {
  var val;
  if (code < NUM_DISTANCE_SHORT_CODES) {
    index += kDistanceShortCodeIndexOffset[code];
    index &= 3;
    val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
  } else {
    val = code - NUM_DISTANCE_SHORT_CODES + 1;
  }
  return val;
}

function MoveToFront(v, index) {
  var value = v[index];
  var i = index;
  for (; i; --i) v[i] = v[i - 1];
  v[0] = value;
}

function InverseMoveToFrontTransform(v, v_len) {
  var mtf = new Uint8Array(256);
  var i;
  for (i = 0; i < 256; ++i) {
    mtf[i] = i;
  }
  for (i = 0; i < v_len; ++i) {
    var index = v[i];
    v[i] = mtf[index];
    if (index) MoveToFront(mtf, index);
  }
}

/* Contains a collection of huffman trees with the same alphabet size. */
function HuffmanTreeGroup(alphabet_size, num_htrees) {
  this.alphabet_size = alphabet_size;
  this.num_htrees = num_htrees;
  this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[(alphabet_size + 31) >>> 5]);  
  this.htrees = new Uint32Array(num_htrees);
}

HuffmanTreeGroup.prototype.decode = function(br) {
  var i;
  var table_size;
  var next = 0;
  for (i = 0; i < this.num_htrees; ++i) {
    this.htrees[i] = next;
    table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
    next += table_size;
  }
};

function DecodeContextMap(context_map_size, br) {
  var out = { num_htrees: null, context_map: null };
  var use_rle_for_zeros;
  var max_run_length_prefix = 0;
  var table;
  var i;
  
  br.readMoreInput();
  var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;

  var context_map = out.context_map = new Uint8Array(context_map_size);
  if (num_htrees <= 1) {
    return out;
  }

  use_rle_for_zeros = br.readBits(1);
  if (use_rle_for_zeros) {
    max_run_length_prefix = br.readBits(4) + 1;
  }
  
  table = [];
  for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
    table[i] = new HuffmanCode(0, 0);
  }
  
  ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
  
  for (i = 0; i < context_map_size;) {
    var code;

    br.readMoreInput();
    code = ReadSymbol(table, 0, br);
    if (code === 0) {
      context_map[i] = 0;
      ++i;
    } else if (code <= max_run_length_prefix) {
      var reps = 1 + (1 << code) + br.readBits(code);
      while (--reps) {
        if (i >= context_map_size) {
          throw new Error("[DecodeContextMap] i >= context_map_size");
        }
        context_map[i] = 0;
        ++i;
      }
    } else {
      context_map[i] = code - max_run_length_prefix;
      ++i;
    }
  }
  if (br.readBits(1)) {
    InverseMoveToFrontTransform(context_map, context_map_size);
  }
  
  return out;
}

function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
  var ringbuffer = tree_type * 2;
  var index = tree_type;
  var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
  var block_type;
  if (type_code === 0) {
    block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
  } else if (type_code === 1) {
    block_type = ringbuffers[ringbuffer + ((indexes[index] - 1) & 1)] + 1;
  } else {
    block_type = type_code - 2;
  }
  if (block_type >= max_block_type) {
    block_type -= max_block_type;
  }
  block_types[tree_type] = block_type;
  ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
  ++indexes[index];
}

function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
  var rb_size = ringbuffer_mask + 1;
  var rb_pos = pos & ringbuffer_mask;
  var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
  var nbytes;

  /* For short lengths copy byte-by-byte */
  if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
    while (len-- > 0) {
      br.readMoreInput();
      ringbuffer[rb_pos++] = br.readBits(8);
      if (rb_pos === rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos = 0;
      }
    }
    return;
  }

  if (br.bit_end_pos_ < 32) {
    throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
  }

  /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */
  while (br.bit_pos_ < 32) {
    ringbuffer[rb_pos] = (br.val_ >>> br.bit_pos_);
    br.bit_pos_ += 8;
    ++rb_pos;
    --len;
  }

  /* Copy remaining bytes from br.buf_ to ringbuffer. */
  nbytes = (br.bit_end_pos_ - br.bit_pos_) >> 3;
  if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
    var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
    for (var x = 0; x < tail; x++)
      ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    
    nbytes -= tail;
    rb_pos += tail;
    len -= tail;
    br_pos = 0;
  }

  for (var x = 0; x < nbytes; x++)
    ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
  
  rb_pos += nbytes;
  len -= nbytes;

  /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */
  if (rb_pos >= rb_size) {
    output.write(ringbuffer, rb_size);
    rb_pos -= rb_size;    
    for (var x = 0; x < rb_pos; x++)
      ringbuffer[x] = ringbuffer[rb_size + x];
  }

  /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */
  while (rb_pos + len >= rb_size) {
    nbytes = rb_size - rb_pos;
    if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
      throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
    }
    output.write(ringbuffer, rb_size);
    len -= nbytes;
    rb_pos = 0;
  }

  /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */
  if (br.input_.read(ringbuffer, rb_pos, len) < len) {
    throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
  }

  /* Restore the state of the bit reader. */
  br.reset();
}

/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */
function JumpToByteBoundary(br) {
  var new_bit_pos = (br.bit_pos_ + 7) & ~7;
  var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
  return pad_bits == 0;
}

function BrotliDecompressedSize(buffer) {
  var input = new BrotliInput(buffer);
  var br = new BrotliBitReader(input);
  DecodeWindowBits(br);
  var out = DecodeMetaBlockLength(br);
  return out.meta_block_length;
}

exports.BrotliDecompressedSize = BrotliDecompressedSize;

function BrotliDecompressBuffer(buffer, output_size) {
  var input = new BrotliInput(buffer);
  
  if (output_size == null) {
    output_size = BrotliDecompressedSize(buffer);
  }
  
  var output_buffer = new Uint8Array(output_size);
  var output = new BrotliOutput(output_buffer);
  
  BrotliDecompress(input, output);
  
  if (output.pos < output.buffer.length) {
    output.buffer = output.buffer.subarray(0, output.pos);
  }
  
  return output.buffer;
}

exports.BrotliDecompressBuffer = BrotliDecompressBuffer;

function BrotliDecompress(input, output) {
  var i;
  var pos = 0;
  var input_end = 0;
  var window_bits = 0;
  var max_backward_distance;
  var max_distance = 0;
  var ringbuffer_size;
  var ringbuffer_mask;
  var ringbuffer;
  var ringbuffer_end;
  /* This ring buffer holds a few past copy distances that will be used by */
  /* some special distance codes. */
  var dist_rb = [ 16, 15, 11, 4 ];
  var dist_rb_idx = 0;
  /* The previous 2 bytes used for context. */
  var prev_byte1 = 0;
  var prev_byte2 = 0;
  var hgroup = [new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0)];
  var block_type_trees;
  var block_len_trees;
  var br;

  /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */
  var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;

  br = new BrotliBitReader(input);

  /* Decode window size. */
  window_bits = DecodeWindowBits(br);
  max_backward_distance = (1 << window_bits) - 16;

  ringbuffer_size = 1 << window_bits;
  ringbuffer_mask = ringbuffer_size - 1;
  ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
  ringbuffer_end = ringbuffer_size;

  block_type_trees = [];
  block_len_trees = [];
  for (var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
    block_type_trees[x] = new HuffmanCode(0, 0);
    block_len_trees[x] = new HuffmanCode(0, 0);
  }

  while (!input_end) {
    var meta_block_remaining_len = 0;
    var is_uncompressed;
    var block_length = [ 1 << 28, 1 << 28, 1 << 28 ];
    var block_type = [ 0 ];
    var num_block_types = [ 1, 1, 1 ];
    var block_type_rb = [ 0, 1, 0, 1, 0, 1 ];
    var block_type_rb_index = [ 0 ];
    var distance_postfix_bits;
    var num_direct_distance_codes;
    var distance_postfix_mask;
    var num_distance_codes;
    var context_map = null;
    var context_modes = null;
    var num_literal_htrees;
    var dist_context_map = null;
    var num_dist_htrees;
    var context_offset = 0;
    var context_map_slice = null;
    var literal_htree_index = 0;
    var dist_context_offset = 0;
    var dist_context_map_slice = null;
    var dist_htree_index = 0;
    var context_lookup_offset1 = 0;
    var context_lookup_offset2 = 0;
    var context_mode;
    var htree_command;

    for (i = 0; i < 3; ++i) {
      hgroup[i].codes = null;
      hgroup[i].htrees = null;
    }

    br.readMoreInput();
    
    var _out = DecodeMetaBlockLength(br);
    meta_block_remaining_len = _out.meta_block_length;
    if (pos + meta_block_remaining_len > output.buffer.length) {
      /* We need to grow the output buffer to fit the additional data. */
      var tmp = new Uint8Array( pos + meta_block_remaining_len );
      tmp.set( output.buffer );
      output.buffer = tmp;
    }    
    input_end = _out.input_end;
    is_uncompressed = _out.is_uncompressed;
    
    if (_out.is_metadata) {
      JumpToByteBoundary(br);
      
      for (; meta_block_remaining_len > 0; --meta_block_remaining_len) {
        br.readMoreInput();
        /* Read one byte and ignore it. */
        br.readBits(8);
      }
      
      continue;
    }
    
    if (meta_block_remaining_len === 0) {
      continue;
    }
    
    if (is_uncompressed) {
      br.bit_pos_ = (br.bit_pos_ + 7) & ~7;
      CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos,
                                    ringbuffer, ringbuffer_mask, br);
      pos += meta_block_remaining_len;
      continue;
    }
    
    for (i = 0; i < 3; ++i) {
      num_block_types[i] = DecodeVarLenUint8(br) + 1;
      if (num_block_types[i] >= 2) {
        ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
        ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
        block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
        block_type_rb_index[i] = 1;
      }
    }
    
    br.readMoreInput();
    
    distance_postfix_bits = br.readBits(2);
    num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
    distance_postfix_mask = (1 << distance_postfix_bits) - 1;
    num_distance_codes = (num_direct_distance_codes + (48 << distance_postfix_bits));
    context_modes = new Uint8Array(num_block_types[0]);

    for (i = 0; i < num_block_types[0]; ++i) {
       br.readMoreInput();
       context_modes[i] = (br.readBits(2) << 1);
    }
    
    var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
    num_literal_htrees = _o1.num_htrees;
    context_map = _o1.context_map;
    
    var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
    num_dist_htrees = _o2.num_htrees;
    dist_context_map = _o2.context_map;
    
    hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
    hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
    hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);

    for (i = 0; i < 3; ++i) {
      hgroup[i].decode(br);
    }

    context_map_slice = 0;
    dist_context_map_slice = 0;
    context_mode = context_modes[block_type[0]];
    context_lookup_offset1 = Context.lookupOffsets[context_mode];
    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
    htree_command = hgroup[1].htrees[0];

    while (meta_block_remaining_len > 0) {
      var cmd_code;
      var range_idx;
      var insert_code;
      var copy_code;
      var insert_length;
      var copy_length;
      var distance_code;
      var distance;
      var context;
      var j;
      var copy_dst;

      br.readMoreInput();
      
      if (block_length[1] === 0) {
        DecodeBlockType(num_block_types[1],
                        block_type_trees, 1, block_type, block_type_rb,
                        block_type_rb_index, br);
        block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
        htree_command = hgroup[1].htrees[block_type[1]];
      }
      --block_length[1];
      cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
      range_idx = cmd_code >> 6;
      if (range_idx >= 2) {
        range_idx -= 2;
        distance_code = -1;
      } else {
        distance_code = 0;
      }
      insert_code = Prefix.kInsertRangeLut[range_idx] + ((cmd_code >> 3) & 7);
      copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
      insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset +
          br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
      copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset +
          br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
      prev_byte1 = ringbuffer[pos-1 & ringbuffer_mask];
      prev_byte2 = ringbuffer[pos-2 & ringbuffer_mask];
      for (j = 0; j < insert_length; ++j) {
        br.readMoreInput();

        if (block_length[0] === 0) {
          DecodeBlockType(num_block_types[0],
                          block_type_trees, 0, block_type, block_type_rb,
                          block_type_rb_index, br);
          block_length[0] = ReadBlockLength(block_len_trees, 0, br);
          context_offset = block_type[0] << kLiteralContextBits;
          context_map_slice = context_offset;
          context_mode = context_modes[block_type[0]];
          context_lookup_offset1 = Context.lookupOffsets[context_mode];
          context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
        }
        context = (Context.lookup[context_lookup_offset1 + prev_byte1] |
                   Context.lookup[context_lookup_offset2 + prev_byte2]);
        literal_htree_index = context_map[context_map_slice + context];
        --block_length[0];
        prev_byte2 = prev_byte1;
        prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
        ringbuffer[pos & ringbuffer_mask] = prev_byte1;
        if ((pos & ringbuffer_mask) === ringbuffer_mask) {
          output.write(ringbuffer, ringbuffer_size);
        }
        ++pos;
      }
      meta_block_remaining_len -= insert_length;
      if (meta_block_remaining_len <= 0) break;

      if (distance_code < 0) {
        var context;
        
        br.readMoreInput();
        if (block_length[2] === 0) {
          DecodeBlockType(num_block_types[2],
                          block_type_trees, 2, block_type, block_type_rb,
                          block_type_rb_index, br);
          block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
          dist_context_offset = block_type[2] << kDistanceContextBits;
          dist_context_map_slice = dist_context_offset;
        }
        --block_length[2];
        context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
        dist_htree_index = dist_context_map[dist_context_map_slice + context];
        distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
        if (distance_code >= num_direct_distance_codes) {
          var nbits;
          var postfix;
          var offset;
          distance_code -= num_direct_distance_codes;
          postfix = distance_code & distance_postfix_mask;
          distance_code >>= distance_postfix_bits;
          nbits = (distance_code >> 1) + 1;
          offset = ((2 + (distance_code & 1)) << nbits) - 4;
          distance_code = num_direct_distance_codes +
              ((offset + br.readBits(nbits)) <<
               distance_postfix_bits) + postfix;
        }
      }

      /* Convert the distance code to the actual distance by possibly looking */
      /* up past distnaces from the ringbuffer. */
      distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
      if (distance < 0) {
        throw new Error('[BrotliDecompress] invalid distance');
      }

      if (pos < max_backward_distance &&
          max_distance !== max_backward_distance) {
        max_distance = pos;
      } else {
        max_distance = max_backward_distance;
      }

      copy_dst = pos & ringbuffer_mask;

      if (distance > max_distance) {
        if (copy_length >= BrotliDictionary.minDictionaryWordLength &&
            copy_length <= BrotliDictionary.maxDictionaryWordLength) {
          var offset = BrotliDictionary.offsetsByLength[copy_length];
          var word_id = distance - max_distance - 1;
          var shift = BrotliDictionary.sizeBitsByLength[copy_length];
          var mask = (1 << shift) - 1;
          var word_idx = word_id & mask;
          var transform_idx = word_id >> shift;
          offset += word_idx * copy_length;
          if (transform_idx < Transform.kNumTransforms) {
            var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
            copy_dst += len;
            pos += len;
            meta_block_remaining_len -= len;
            if (copy_dst >= ringbuffer_end) {
              output.write(ringbuffer, ringbuffer_size);
              
              for (var _x = 0; _x < (copy_dst - ringbuffer_end); _x++)
                ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
            }
          } else {
            throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
              " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
          }
        } else {
          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
        }
      } else {
        if (distance_code > 0) {
          dist_rb[dist_rb_idx & 3] = distance;
          ++dist_rb_idx;
        }

        if (copy_length > meta_block_remaining_len) {
          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
        }

        for (j = 0; j < copy_length; ++j) {
          ringbuffer[pos & ringbuffer_mask] = ringbuffer[(pos - distance) & ringbuffer_mask];
          if ((pos & ringbuffer_mask) === ringbuffer_mask) {
            output.write(ringbuffer, ringbuffer_size);
          }
          ++pos;
          --meta_block_remaining_len;
        }
      }

      /* When we get here, we must have inserted at least one literal and */
      /* made a copy of at least length two, therefore accessing the last 2 */
      /* bytes is valid. */
      prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
      prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
    }

    /* Protect pos from overflow, wrap it around at every GB of input data */
    pos &= 0x3fffffff;
  }

  output.write(ringbuffer, pos & ringbuffer_mask);
}

exports.BrotliDecompress = BrotliDecompress;

BrotliDictionary.init();

},{"./bit_reader":391,"./context":392,"./dictionary":396,"./huffman":397,"./prefix":398,"./streams":399,"./transform":400}],394:[function(require,module,exports){
var base64 = require('base64-js');
var fs = require('fs');

/**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */
exports.init = function() {
  var BrotliDecompressBuffer = require('./decode').BrotliDecompressBuffer;
  var compressed = base64.toByteArray(require('./dictionary.bin.js'));
  return BrotliDecompressBuffer(compressed);
};

},{"./decode":393,"./dictionary.bin.js":395,"base64-js":387,"fs":403}],395:[function(require,module,exports){
module.exports="W5/fcQLn5gKf2XUbAiQ1XULX+TZz6ADToDsgqk6qVfeC0e4m6OO2wcQ1J76ZBVRV1fRkEsdu//62zQsFEZWSTCnMhcsQKlS2qOhuVYYMGCkV0fXWEoMFbESXrKEZ9wdUEsyw9g4bJlEt1Y6oVMxMRTEVbCIwZzJzboK5j8m4YH02qgXYhv1V+PM435sLVxyHJihaJREEhZGqL03txGFQLm76caGO/ovxKvzCby/3vMTtX/459f0igi7WutnKiMQ6wODSoRh/8Lx1V3Q99MvKtwB6bHdERYRY0hStJoMjNeTsNX7bn+Y7e4EQ3bf8xBc7L0BsyfFPK43dGSXpL6clYC/I328h54/VYrQ5i0648FgbGtl837svJ35L3Mot/+nPlNpWgKx1gGXQYqX6n+bbZ7wuyCHKcUok12Xjqub7NXZGzqBx0SD+uziNf87t7ve42jxSKQoW3nyxVrWIGlFShhCKxjpZZ5MeGna0+lBkk+kaN8F9qFBAFgEogyMBdcX/T1W/WnMOi/7ycWUQloEBKGeC48MkiwqJkJO+12eQiOFHMmck6q/IjWW3RZlany23TBm+cNr/84/oi5GGmGBZWrZ6j+zykVozz5fT/QH/Da6WTbZYYPynVNO7kxzuNN2kxKKWche5WveitPKAecB8YcAHz/+zXLjcLzkdDSktNIDwZE9J9X+tto43oJy65wApM3mDzYtCwX9lM+N5VR3kXYo0Z3t0TtXfgBFg7gU8oN0Dgl7fZlUbhNll+0uuohRVKjrEd8egrSndy5/Tgd2gqjA4CAVuC7ESUmL3DZoGnfhQV8uwnpi8EGvAVVsowNRxPudck7+oqAUDkwZopWqFnW1riss0t1z6iCISVKreYGNvQcXv+1L9+jbP8cd/dPUiqBso2q+7ZyFBvENCkkVr44iyPbtOoOoCecWsiuqMSML5lv+vN5MzUr+Dnh73G7Q1YnRYJVYXHRJaNAOByiaK6CusgFdBPE40r0rvqXV7tksKO2DrHYXBTv8P5ysqxEx8VDXUDDqkPH6NNOV/a2WH8zlkXRELSa8P+heNyJBBP7PgsG1EtWtNef6/i+lcayzQwQCsduidpbKfhWUDgAEmyhGu/zVTacI6RS0zTABrOYueemnVa19u9fT23N/Ta6RvTpof5DWygqreCqrDAgM4LID1+1T/taU6yTFVLqXOv+/MuQOFnaF8vLMKD7tKWDoBdALgxF33zQccCcdHx8fKIVdW69O7qHtXpeGr9jbbpFA+qRMWr5hp0s67FPc7HAiLV0g0/peZlW7hJPYEhZyhpSwahnf93/tZgfqZWXFdmdXBzqxGHLrQKxoAY6fRoBhgCRPmmGueYZ5JexTVDKUIXzkG/fqp/0U3hAgQdJ9zumutK6nqWbaqvm1pgu03IYR+G+8s0jDBBz8cApZFSBeuWasyqo2OMDKAZCozS+GWSvL/HsE9rHxooe17U3s/lTE+VZAk4j3dp6uIGaC0JMiqR5CUsabPyM0dOYDR7Ea7ip4USZlya38YfPtvrX/tBlhHilj55nZ1nfN24AOAi9BVtz/Mbn8AEDJCqJgsVUa6nQnSxv2Fs7l/NlCzpfYEjmPrNyib/+t0ei2eEMjvNhLkHCZlci4WhBe7ePZTmzYqlY9+1pxtS4GB+5lM1BHT9tS270EWUDYFq1I0yY/fNiAk4bk9yBgmef/f2k6AlYQZHsNFnW8wBQxCd68iWv7/35bXfz3JZmfGligWAKRjIs3IpzxQ27vAglHSiOzCYzJ9L9A1CdiyFvyR66ucA4jKifu5ehwER26yV7HjKqn5Mfozo7Coxxt8LWWPT47BeMxX8p0Pjb7hZn+6bw7z3Lw+7653j5sI8CLu5kThpMlj1m4c2ch3jGcP1FsT13vuK3qjecKTZk2kHcOZY40UX+qdaxstZqsqQqgXz+QGF99ZJLqr3VYu4aecl1Ab5GmqS8k/GV5b95zxQ5d4EfXUJ6kTS/CXF/aiqKDOT1T7Jz5z0PwDUcwr9clLN1OJGCiKfqvah+h3XzrBOiLOW8wvn8gW6qE8vPxi+Efv+UH55T7PQFVMh6cZ1pZQlzJpKZ7P7uWvwPGJ6DTlR6wbyj3Iv2HyefnRo/dv7dNx+qaa0N38iBsR++Uil7Wd4afwDNsrzDAK4fXZwvEY/jdKuIKXlfrQd2C39dW7ntnRbIp9OtGy9pPBn/V2ASoi/2UJZfS+xuGLH8bnLuPlzdTNS6zdyk8Dt/h6sfOW5myxh1f+zf3zZ3MX/mO9cQPp5pOx967ZA6/pqHvclNfnUFF+rq+Vd7alKr6KWPcIDhpn6v2K6NlUu6LrKo8b/pYpU/Gazfvtwhn7tEOUuXht5rUJdSf6sLjYf0VTYDgwJ81yaqKTUYej/tbHckSRb/HZicwGJqh1mAHB/IuNs9dc9yuvF3D5Xocm3elWFdq5oEy70dYFit79yaLiNjPj5UUcVmZUVhQEhW5V2Z6Cm4HVH/R8qlamRYwBileuh07CbEce3TXa2JmXWBf+ozt319psboobeZhVnwhMZzOeQJzhpTDbP71Tv8HuZxxUI/+ma3XW6DFDDs4+qmpERwHGBd2edxwUKlODRdUWZ/g0GOezrbzOZauFMai4QU6GVHV6aPNBiBndHSsV4IzpvUiiYyg6OyyrL4Dj5q/Lw3N5kAwftEVl9rNd7Jk5PDij2hTH6wIXnsyXkKePxbmHYgC8A6an5Fob/KH5GtC0l4eFso+VpxedtJHdHpNm+Bvy4C79yVOkrZsLrQ3OHCeB0Ra+kBIRldUGlDCEmq2RwXnfyh6Dz+alk6eftI2n6sastRrGwbwszBeDRS/Fa/KwRJkCzTsLr/JCs5hOPE/MPLYdZ1F1fv7D+VmysX6NpOC8aU9F4Qs6HvDyUy9PvFGDKZ/P5101TYHFl8pjj6wm/qyS75etZhhfg0UEL4OYmHk6m6dO192AzoIyPSV9QedDA4Ml23rRbqxMPMxf7FJnDc5FTElVS/PyqgePzmwVZ26NWhRDQ+oaT7ly7ell4s3DypS1s0g+tOr7XHrrkZj9+x/mJBttrLx98lFIaRZzHz4aC7r52/JQ4VjHahY2/YVXZn/QC2ztQb/sY3uRlyc5vQS8nLPGT/n27495i8HPA152z7Fh5aFpyn1GPJKHuPL8Iw94DuW3KjkURAWZXn4EQy89xiKEHN1mk/tkM4gYDBxwNoYvRfE6LFqsxWJtPrDGbsnLMap3Ka3MUoytW0cvieozOmdERmhcqzG+3HmZv2yZeiIeQTKGdRT4HHNxekm1tY+/n06rGmFleqLscSERzctTKM6G9P0Pc1RmVvrascIxaO1CQCiYPE15bD7c3xSeW7gXxYjgxcrUlcbIvO0r+Yplhx0kTt3qafDOmFyMjgGxXu73rddMHpV1wMubyAGcf/v5dLr5P72Ta9lBF+fzMJrMycwv+9vnU3ANIl1cH9tfW7af8u0/HG0vV47jNFXzFTtaha1xvze/s8KMtCYucXc1nzfd/MQydUXn/b72RBt5wO/3jRcMH9BdhC/yctKBIveRYPrNpDWqBsO8VMmP+WvRaOcA4zRMR1PvSoO92rS7pYEv+fZfEfTMzEdM+6X5tLlyxExhqLRkms5EuLovLfx66de5fL2/yX02H52FPVwahrPqmN/E0oVXnsCKhbi/yRxX83nRbUKWhzYceXOntfuXn51NszJ6MO73pQf5Pl4in3ec4JU8hF7ppV34+mm9r1LY0ee/i1O1wpd8+zfLztE0cqBxggiBi5Bu95v9l3r9r/U5hweLn+TbfxowrWDqdJauKd8+q/dH8sbPkc9ttuyO94f7/XK/nHX46MPFLEb5qQlNPvhJ50/59t9ft3LXu7uVaWaO2bDrDCnRSzZyWvFKxO1+vT8MwwunR3bX0CkfPjqb4K9O19tn5X50PvmYpEwHtiW9WtzuV/s76B1zvLLNkViNd8ySxIl/3orfqP90TyTGaf7/rx8jQzeHJXdmh/N6YDvbvmTBwCdxfEQ1NcL6wNMdSIXNq7b1EUzRy1/Axsyk5p22GMG1b+GxFgbHErZh92wuvco0AuOLXct9hvw2nw/LqIcDRRmJmmZzcgUa7JpM/WV/S9IUfbF56TL2orzqwebdRD8nIYNJ41D/hz37Fo11p2Y21wzPcn713qVGhqtevStYfGH4n69OEJtPvbbLYWvscDqc3Hgnu166+tAyLnxrX0Y5zoYjV++1sI7t5kMr02KT/+uwtkc+rZLOf/qn/s3nYCf13Dg8/sB2diJgjGqjQ+TLhxbzyue2Ob7X6/9lUwW7a+lbznHzOYy8LKW1C/uRPbQY3KW/0gO9LXunHLvPL97afba9bFtc9hmz7GAttjVYlCvQAiOwAk/gC5+hkLEs6tr3AZKxLJtOEwk2dLxTYWsIB/j/ToWtIWzo906FrSG8iaqqqqqqiIiIiAgzMzMzNz+AyK+01/zi8n8S+Y1MjoRaQ80WU/G8MBlO+53VPXANrWm4wzGUVZUjjBJZVdhpcfkjsmcWaO+UEldXi1e+zq+HOsCpknYshuh8pOLISJun7TN0EIGW2xTnlOImeecnoGW4raxe2G1T3HEvfYUYMhG+gAFOAwh5nK8mZhwJMmN7r224QVsNFvZ87Z0qatvknklyPDK3Hy45PgVKXji52Wen4d4PlFVVYGnNap+fSpFbK90rYnhUc6n91Q3AY9E0tJOFrcfZtm/491XbcG/jsViUPPX76qmeuiz+qY1Hk7/1VPM405zWVuoheLUimpWYdVzCmUdKHebMdzgrYrb8mL2eeLSnRWHdonfZa8RsOU9F37w+591l5FLYHiOqWeHtE/lWrBHcRKp3uhtr8yXm8LU/5ms+NM6ZKsqu90cFZ4o58+k4rdrtB97NADFbwmEG7lXqvirhOTOqU14xuUF2myIjURcPHrPOQ4lmM3PeMg7bUuk0nnZi67bXsU6H8lhqIo8TaOrEafCO1ARK9PjC0QOoq2BxmMdgYB9G/lIb9++fqNJ2s7BHGFyBNmZAR8J3KCo012ikaSP8BCrf6VI0X5xdnbhHIO+B5rbOyB54zXkzfObyJ4ecwxfqBJMLFc7m59rNcw7hoHnFZ0b00zee+gTqvjm61Pb4xn0kcDX4jvHM0rBXZypG3DCKnD/Waa/ZtHmtFPgO5eETx+k7RrVg3aSwm2YoNXnCs3XPQDhNn+Fia6IlOOuIG6VJH7TP6ava26ehKHQa2T4N0tcZ9dPCGo3ZdnNltsHQbeYt5vPnJezV/cAeNypdml1vCHI8M81nSRP5Qi2+mI8v/sxiZru9187nRtp3f/42NemcONa+4eVC3PCZzc88aZh851CqSsshe70uPxeN/dmYwlwb3trwMrN1Gq8jbnApcVDx/yDPeYs5/7r62tsQ6lLg+DiFXTEhzR9dHqv0iT4tgj825W+H3XiRUNUZT2kR9Ri0+lp+UM3iQtS8uOE23Ly4KYtvqH13jghUntJRAewuzNLDXp8RxdcaA3cMY6TO2IeSFRXezeWIjCqyhsUdMYuCgYTZSKpBype1zRfq8FshvfBPc6BAQWl7/QxIDp3VGo1J3vn42OEs3qznws+YLRXbymyB19a9XBx6n/owcyxlEYyFWCi+kG9F+EyD/4yn80+agaZ9P7ay2Dny99aK2o91FkfEOY8hBwyfi5uwx2y5SaHmG+oq/zl1FX/8irOf8Y3vAcX/6uLP6A6nvMO24edSGPjQc827Rw2atX+z2bKq0CmW9mOtYnr5/AfDa1ZfPaXnKtlWborup7QYx+Or2uWb+N3N//2+yDcXMqIJdf55xl7/vsj4WoPPlxLxtVrkJ4w/tTe3mLdATOOYwxcq52w5Wxz5MbPdVs5O8/lhfE7dPj0bIiPQ3QV0iqm4m3YX8hRfc6jQ3fWepevMqUDJd86Z4vwM40CWHnn+WphsGHfieF02D3tmZvpWD+kBpNCFcLnZhcmmrhpGzzbdA+sQ1ar18OJD87IOKOFoRNznaHPNHUfUNhvY1iU+uhvEvpKHaUn3qK3exVVyX4joipp3um7FmYJWmA+WbIDshRpbVRx5/nqstCgy87FGbfVB8yDGCqS+2qCsnRwnSAN6zgzxfdB2nBT/vZ4/6uxb6oH8b4VBRxiIB93wLa47hG3w2SL/2Z27yOXJFwZpSJaBYyvajA7vRRYNKqljXKpt/CFD/tSMr18DKKbwB0xggBePatl1nki0yvqW5zchlyZmJ0OTxJ3D+fsYJs/mxYN5+Le5oagtcl+YsVvy8kSjI2YGvGjvmpkRS9W2dtXqWnVuxUhURm1lKtou/hdEq19VBp9OjGvHEQSmrpuf2R24mXGheil8KeiANY8fW1VERUfBImb64j12caBZmRViZHbeVMjCrPDg9A90IXrtnsYCuZtRQ0PyrKDjBNOsPfKsg1pA02gHlVr0OXiFhtp6nJqXVzcbfM0KnzC3ggOENPE9VBdmHKN6LYaijb4wXxJn5A0FSDF5j+h1ooZx885Jt3ZKzO5n7Z5WfNEOtyyPqQEnn7WLv5Fis3PdgMshjF1FRydbNyeBbyKI1oN1TRVrVK7kgsb/zjX4NDPIRMctVeaxVB38Vh1x5KbeJbU138AM5KzmZu3uny0ErygxiJF7GVXUrPzFxrlx1uFdAaZFDN9cvIb74qD9tzBMo7L7WIEYK+sla1DVMHpF0F7b3+Y6S+zjvLeDMCpapmJo1weBWuxKF3rOocih1gun4BoJh1kWnV/Jmiq6uOhK3VfKxEHEkafjLgK3oujaPzY6SXg8phhL4TNR1xvJd1Wa0aYFfPUMLrNBDCh4AuGRTbtKMc6Z1Udj8evY/ZpCuMAUefdo69DZUngoqE1P9A3PJfOf7WixCEj+Y6t7fYeHbbxUAoFV3M89cCKfma3fc1+jKRe7MFWEbQqEfyzO2x/wrO2VYH7iYdQ9BkPyI8/3kXBpLaCpU7eC0Yv/am/tEDu7HZpqg0EvHo0nf/R/gRzUWy33/HXMJQeu1GylKmOkXzlCfGFruAcPPhaGqZOtu19zsJ1SO2Jz4Ztth5cBX6mRQwWmDwryG9FUMlZzNckMdK+IoMJv1rOWnBamS2w2KHiaPMPLC15hCZm4KTpoZyj4E2TqC/P6r7/EhnDMhKicZZ1ZwxuC7DPzDGs53q8gXaI9kFTK+2LTq7bhwsTbrMV8Rsfua5lMS0FwbTitUVnVa1yTb5IX51mmYnUcP9wPr8Ji1tiYJeJV9GZTrQhF7vvdU2OTU42ogJ9FDwhmycI2LIg++03C6scYhUyUuMV5tkw6kGUoL+mjNC38+wMdWNljn6tGPpRES7veqrSn5TRuv+dh6JVL/iDHU1db4c9WK3++OrH3PqziF916UMUKn8G67nN60GfWiHrXYhUG3yVWmyYak59NHj8t1smG4UDiWz2rPHNrKnN4Zo1LBbr2/eF9YZ0n0blx2nG4X+EKFxvS3W28JESD+FWk61VCD3z/URGHiJl++7TdBwkCj6tGOH3qDb0QqcOF9Kzpj0HUb/KyFW3Yhj2VMKJqGZleFBH7vqvf7WqLC3XMuHV8q8a4sTFuxUtkD/6JIBvKaVjv96ndgruKZ1k/BHzqf2K9fLk7HGXANyLDd1vxkK/i055pnzl+zw6zLnwXlVYVtfmacJgEpRP1hbGgrYPVN6v2lG+idQNGmwcKXu/8xEj/P6qe/sB2WmwNp6pp8jaISMkwdleFXYK55NHWLTTbutSUqjBfDGWo/Yg918qQ+8BRZSAHZbfuNZz2O0sov1Ue4CWlVg3rFhM3Kljj9ksGd/NUhk4nH+a5UN2+1i8+NM3vRNp7uQ6sqexSCukEVlVZriHNqFi5rLm9TMWa4qm3idJqppQACol2l4VSuvWLfta4JcXy3bROPNbXOgdOhG47LC0CwW/dMlSx4Jf17aEU3yA1x9p+Yc0jupXgcMuYNku64iYOkGToVDuJvlbEKlJqsmiHbvNrIVZEH+yFdF8DbleZ6iNiWwMqvtMp/mSpwx5KxRrT9p3MAPTHGtMbfvdFhyj9vhaKcn3At8Lc16Ai+vBcSp1ztXi7rCJZx/ql7TXcclq6Q76UeKWDy9boS0WHIjUuWhPG8LBmW5y2rhuTpM5vsLt+HOLh1Yf0DqXa9tsfC+kaKt2htA0ai/L2i7RKoNjEwztkmRU0GfgW1TxUvPFhg0V7DdfWJk5gfrccpYv+MA9M0dkGTLECeYwUixRzjRFdmjG7zdZIl3XKB9YliNKI31lfa7i2JG5C8Ss+rHe0D7Z696/V3DEAOWHnQ9yNahMUl5kENWS6pHKKp2D1BaSrrHdE1w2qNxIztpXgUIrF0bm15YML4b6V1k+GpNysTahKMVrrS85lTVo9OGJ96I47eAy5rYWpRf/mIzeoYU1DKaQCTUVwrhHeyNoDqHel+lLxr9WKzhSYw7vrR6+V5q0pfi2k3L1zqkubY6rrd9ZLvSuWNf0uqnkY+FpTvFzSW9Fp0b9l8JA7THV9eCi/PY/SCZIUYx3BU2alj7Cm3VV6eYpios4b6WuNOJdYXUK3zTqj5CVG2FqYM4Z7CuIU0qO05XR0d71FHM0YhZmJmTRfLlXEumN82BGtzdX0S19t1e+bUieK8zRmqpa4Qc5TSjifmaQsY2ETLjhI36gMR1+7qpjdXXHiceUekfBaucHShAOiFXmv3sNmGQyU5iVgnoocuonQXEPTFwslHtS8R+A47StI9wj0iSrtbi5rMysczFiImsQ+bdFClnFjjpXXwMy6O7qfjOr8Fb0a7ODItisjnn3EQO16+ypd1cwyaAW5Yzxz5QknfMO7643fXW/I9y3U2xH27Oapqr56Z/tEzglj6IbT6HEHjopiXqeRbe5mQQvxtcbDOVverN0ZgMdzqRYRjaXtMRd56Q4cZSmdPvZJdSrhJ1D9zNXPqAEqPIavPdfubt5oke2kmv0dztIszSv2VYuoyf1UuopbsYb+uX9h6WpwjpgtZ6fNNawNJ4q8O3CFoSbioAaOSZMx2GYaPYB+rEb6qjQiNRFQ76TvwNFVKD+BhH9VhcKGsXzmMI7BptU/CNWolM7YzROvpFAntsiWJp6eR2d3GarcYShVYSUqhmYOWj5E96NK2WvmYNTeY7Zs4RUEdv9h9QT4EseKt6LzLrqEOs3hxAY1MaNWpSa6zZx8F3YOVeCYMS88W+CYHDuWe4yoc6YK+djDuEOrBR5lvh0r+Q9uM88lrjx9x9AtgpQVNE8r+3O6Gvw59D+kBF/UMXyhliYUtPjmvXGY6Dk3x+kEOW+GtdMVC4EZTqoS/jmR0P0LS75DOc/w2vnri97M4SdbZ8qeU7gg8DVbERkU5geaMQO3mYrSYyAngeUQqrN0C0/vsFmcgWNXNeidsTAj7/4MncJR0caaBUpbLK1yBCBNRjEv6KvuVSdpPnEMJdsRRtqJ+U8tN1gXA4ePHc6ZT0eviI73UOJF0fEZ8YaneAQqQdGphNvwM4nIqPnXxV0xA0fnCT+oAhJuyw/q8jO0y8CjSteZExwBpIN6SvNp6A5G/abi6egeND/1GTguhuNjaUbbnSbGd4L8937Ezm34Eyi6n1maeOBxh3PI0jzJDf5mh/BsLD7F2GOKvlA/5gtvxI3/eV4sLfKW5Wy+oio+es/u6T8UU+nsofy57Icb/JlZHPFtCgd/x+bwt3ZT+xXTtTtTrGAb4QehC6X9G+8YT+ozcLxDsdCjsuOqwPFnrdLYaFc92Ui0m4fr39lYmlCaqTit7G6O/3kWDkgtXjNH4BiEm/+jegQnihOtfffn33WxsFjhfMd48HT+f6o6X65j7XR8WLSHMFkxbvOYsrRsF1bowDuSQ18Mkxk4qz2zoGPL5fu9h2Hqmt1asl3Q3Yu3szOc+spiCmX4AETBM3pLoTYSp3sVxahyhL8eC4mPN9k2x3o0xkiixIzM3CZFzf5oR4mecQ5+ax2wCah3/crmnHoqR0+KMaOPxRif1oEFRFOO/kTPPmtww+NfMXxEK6gn6iU32U6fFruIz8Q4WgljtnaCVTBgWx7diUdshC9ZEa5yKpRBBeW12r/iNc/+EgNqmhswNB8SBoihHXeDF7rrWDLcmt3V8GYYN7pXRy4DZjj4DJuUBL5iC3DQAaoo4vkftqVTYRGLS3mHZ7gdmdTTqbgNN/PTdTCOTgXolc88MhXAEUMdX0iy1JMuk5wLsgeu0QUYlz2S4skTWwJz6pOm/8ihrmgGfFgri+ZWUK2gAPHgbWa8jaocdSuM4FJYoKicYX/ZSENkg9Q1ZzJfwScfVnR2DegOGwCvmogaWJCLQepv9WNlU6QgsmOwICquU28Mlk3d9W5E81lU/5Ez0LcX6lwKMWDNluNKfBDUy/phJgBcMnfkh9iRxrdOzgs08JdPB85Lwo+GUSb4t3nC+0byqMZtO2fQJ4U2zGIr49t/28qmmGv2RanDD7a3FEcdtutkW8twwwlUSpb8QalodddbBfNHKDQ828BdE7OBgFdiKYohLawFYqpybQoxATZrheLhdI7+0Zlu9Q1myRcd15r9UIm8K2LGJxqTegntqNVMKnf1a8zQiyUR1rxoqjiFxeHxqFcYUTHfDu7rhbWng6qOxOsI+5A1p9mRyEPdVkTlE24vY54W7bWc6jMgZvNXdfC9/9q7408KDsbdL7Utz7QFSDetz2picArzrdpL8OaCHC9V26RroemtDZ5yNM/KGkWMyTmfnInEvwtSD23UcFcjhaE3VKzkoaEMKGBft4XbIO6forTY1lmGQwVmKicBCiArDzE+1oIxE08fWeviIOD5TznqH+OoHadvoOP20drMPe5Irg3XBQziW2XDuHYzjqQQ4wySssjXUs5H+t3FWYMHppUnBHMx/nYIT5d7OmjDbgD9F6na3m4l7KdkeSO3kTEPXafiWinogag7b52taiZhL1TSvBFmEZafFq2H8khQaZXuitCewT5FBgVtPK0j4xUHPfUz3Q28eac1Z139DAP23dgki94EC8vbDPTQC97HPPSWjUNG5tWKMsaxAEMKC0665Xvo1Ntd07wCLNf8Q56mrEPVpCxlIMVlQlWRxM3oAfpgIc+8KC3rEXUog5g06vt7zgXY8grH7hhwVSaeuvC06YYRAwpbyk/Unzj9hLEZNs2oxPQB9yc+GnL6zTgq7rI++KDJwX2SP8Sd6YzTuw5lV/kU6eQxRD12omfQAW6caTR4LikYkBB1CMOrvgRr/VY75+NSB40Cni6bADAtaK+vyxVWpf9NeKJxN2KYQ8Q2xPB3K1s7fuhvWbr2XpgW044VD6DRs0qXoqKf1NFsaGvKJc47leUV3pppP/5VTKFhaGuol4Esfjf5zyCyUHmHthChcYh4hYLQF+AFWsuq4t0wJyWgdwQVOZiV0efRHPoK5+E1vjz9wTJmVkITC9oEstAsyZSgE/dbicwKr89YUxKZI+owD205Tm5lnnmDRuP/JnzxX3gMtlrcX0UesZdxyQqYQuEW4R51vmQ5xOZteUd8SJruMlTUzhtVw/Nq7eUBcqN2/HVotgfngif60yKEtoUx3WYOZlVJuJOh8u59fzSDPFYtQgqDUAGyGhQOAvKroXMcOYY0qjnStJR/G3aP+Jt1sLVlGV8POwr/6OGsqetnyF3TmTqZjENfnXh51oxe9qVUw2M78EzAJ+IM8lZ1MBPQ9ZWSVc4J3mWSrLKrMHReA5qdGoz0ODRsaA+vwxXA2cAM4qlfzBJA6581m4hzxItQw5dxrrBL3Y6kCbUcFxo1S8jyV44q//+7ASNNudZ6xeaNOSIUffqMn4A9lIjFctYn2gpEPAb3f7p3iIBN8H14FUGQ9ct2hPsL+cEsTgUrR47uJVN4n4wt/wgfwwHuOnLd4yobkofy8JvxSQTA7rMpDIc608SlZFJfZYcmbT0tAHpPE8MrtQ42siTUNWxqvWZOmvu9f0JPoQmg+6l7sZWwyfi6PXkxJnwBraUG0MYG4zYHQz3igy/XsFkx5tNQxw43qvI9dU3f0DdhOUlHKjmi1VAr2Kiy0HZwD8VeEbhh0OiDdMYspolQsYdSwjCcjeowIXNZVUPmL2wwIkYhmXKhGozdCJ4lRKbsf4NBh/XnQoS92NJEWOVOFs2YhN8c5QZFeK0pRdAG40hqvLbmoSA8xQmzOOEc7wLcme9JOsjPCEgpCwUs9E2DohMHRhUeyGIN6TFvrbny8nDuilsDpzrH5mS76APoIEJmItS67sQJ+nfwddzmjPxcBEBBCw0kWDwd0EZCkNeOD7NNQhtBm7KHL9mRxj6U1yWU2puzlIDtpYxdH4ZPeXBJkTGAJfUr/oTCz/iypY6uXaR2V1doPxJYlrw2ghH0D5gbrhFcIxzYwi4a/4hqVdf2DdxBp6vGYDjavxMAAoy+1+3aiO6S3W/QAKNVXagDtvsNtx7Ks+HKgo6U21B+QSZgIogV5Bt+BnXisdVfy9VyXV+2P5fMuvdpAjM1o/K9Z+XnE4EOCrue+kcdYHqAQ0/Y/OmNlQ6OI33jH/uD1RalPaHpJAm2av0/xtpqdXVKNDrc9F2izo23Wu7firgbURFDNX9eGGeYBhiypyXZft2j3hTvzE6PMWKsod//rEILDkzBXfi7xh0eFkfb3/1zzPK/PI5Nk3FbZyTl4mq5BfBoVoqiPHO4Q4QKZAlrQ3MdNfi3oxIjvsM3kAFv3fdufurqYR3PSwX/mpGy/GFI/B2MNPiNdOppWVbs/gjF3YH+QA9jMhlAbhvasAHstB0IJew09iAkmXHl1/TEj+jvHOpOGrPRQXbPADM+Ig2/OEcUcpgPTItMtW4DdqgfYVI/+4hAFWYjUGpOP/UwNuB7+BbKOcALbjobdgzeBQfjgNSp2GOpxzGLj70Vvq5cw2AoYENwKLUtJUX8sGRox4dVa/TN4xKwaKcl9XawQR/uNus700Hf17pyNnezrUgaY9e4MADhEDBpsJT6y1gDJs1q6wlwGhuUzGR7C8kgpjPyHWwsvrf3yn1zJEIRa5eSxoLAZOCR9xbuztxFRJW9ZmMYfCFJ0evm9F2fVnuje92Rc4Pl6A8bluN8MZyyJGZ0+sNSb//DvAFxC2BqlEsFwccWeAl6CyBcQV1bx4mQMBP1Jxqk1EUADNLeieS2dUFbQ/c/kvwItbZ7tx0st16viqd53WsRmPTKv2AD8CUnhtPWg5aUegNpsYgasaw2+EVooeNKmrW3MFtj76bYHJm5K9gpAXZXsE5U8DM8XmVOSJ1F1WnLy6nQup+jx52bAb+rCq6y9WXl2B2oZDhfDkW7H3oYfT/4xx5VncBuxMXP2lNfhUVQjSSzSRbuZFE4vFawlzveXxaYKVs8LpvAb8IRYF3ZHiRnm0ADeNPWocwxSzNseG7NrSEVZoHdKWqaGEBz1N8Pt7kFbqh3LYmAbm9i1IChIpLpM5AS6mr6OAPHMwwznVy61YpBYX8xZDN/a+lt7n+x5j4bNOVteZ8lj3hpAHSx1VR8vZHec4AHO9XFCdjZ9eRkSV65ljMmZVzaej2qFn/qt1lvWzNZEfHxK3qOJrHL6crr0CRzMox5f2e8ALBB4UGFZKA3tN6F6IXd32GTJXGQ7DTi9j/dNcLF9jCbDcWGKxoKTYblIwbLDReL00LRcDPMcQuXLMh5YzgtfjkFK1DP1iDzzYYVZz5M/kWYRlRpig1htVRjVCknm+h1M5LiEDXOyHREhvzCGpFZjHS0RsK27o2avgdilrJkalWqPW3D9gmwV37HKmfM3F8YZj2ar+vHFvf3B8CRoH4kDHIK9mrAg+owiEwNjjd9V+FsQKYR8czJrUkf7Qoi2YaW6EVDZp5zYlqiYtuXOTHk4fAcZ7qBbdLDiJq0WNV1l2+Hntk1mMWvxrYmc8kIx8G3rW36J6Ra4lLrTOCgiOihmow+YnzUT19jbV2B3RWqSHyxkhmgsBqMYWvOcUom1jDQ436+fcbu3xf2bbeqU/ca+C4DOKE+e3qvmeMqW3AxejfzBRFVcwVYPq4L0APSWWoJu+5UYX4qg5U6YTioqQGPG9XrnuZ/BkxuYpe6Li87+18EskyQW/uA+uk2rpHpr6hut2TlVbKgWkFpx+AZffweiw2+VittkEyf/ifinS/0ItRL2Jq3tQOcxPaWO2xrG68GdFoUpZgFXaP2wYVtRc6xYCfI1CaBqyWpg4bx8OHBQwsV4XWMibZZ0LYjWEy2IxQ1mZrf1/UNbYCJplWu3nZ4WpodIGVA05d+RWSS+ET9tH3RfGGmNI1cIY7evZZq7o+a0bjjygpmR3mVfalkT/SZGT27Q8QGalwGlDOS9VHCyFAIL0a1Q7JiW3saz9gqY8lqKynFrPCzxkU4SIfLc9VfCI5edgRhDXs0edO992nhTKHriREP1NJC6SROMgQ0xO5kNNZOhMOIT99AUElbxqeZF8A3xrfDJsWtDnUenAHdYWSwAbYjFqQZ+D5gi3hNK8CSxU9i6f6ClL9IGlj1OPMQAsr84YG6ijsJpCaGWj75c3yOZKBB9mNpQNPUKkK0D6wgLH8MGoyRxTX6Y05Q4AnYNXMZwXM4eij/9WpsM/9CoRnFQXGR6MEaY+FXvXEO3RO0JaStk6OXuHVATHJE+1W+TU3bSZ2ksMtqjO0zfSJCdBv7y2d8DMx6TfVme3q0ZpTKMMu4YL/t7ciTNtdDkwPogh3Cnjx7qk08SHwf+dksZ7M2vCOlfsF0hQ6J4ehPCaHTNrM/zBSOqD83dBEBCW/F/LEmeh0nOHd7oVl3/Qo/9GUDkkbj7yz+9cvvu+dDAtx8NzCDTP4iKdZvk9MWiizvtILLepysflSvTLFBZ37RLwiriqyRxYv/zrgFd/9XVHh/OmzBvDX4mitMR/lUavs2Vx6cR94lzAkplm3IRNy4TFfu47tuYs9EQPIPVta4P64tV+sZ7n3ued3cgEx2YK+QL5+xms6osk8qQbTyuKVGdaX9FQqk6qfDnT5ykxk0VK7KZ62b6DNDUfQlqGHxSMKv1P0XN5BqMeKG1P4Wp5QfZDUCEldppoX0U6ss2jIko2XpURKCIhfaOqLPfShdtS37ZrT+jFRSH2xYVV1rmT/MBtRQhxiO4MQ3iAGlaZi+9PWBEIXOVnu9jN1f921lWLZky9bqbM3J2MAAI9jmuAx3gyoEUa6P2ivs0EeNv/OR+AX6q5SW6l5HaoFuS6jr6yg9limu+P0KYKzfMXWcQSfTXzpOzKEKpwI3YGXZpSSy2LTlMgfmFA3CF6R5c9xWEtRuCg2ZPUQ2Nb6dRFTNd4TfGHrnEWSKHPuRyiJSDAZ+KX0VxmSHjGPbQTLVpqixia2uyhQ394gBMt7C3ZAmxn/DJS+l1fBsAo2Eir/C0jG9csd4+/tp12pPc/BVJGaK9mfvr7M/CeztrmCO5qY06Edi4xAGtiEhnWAbzLy2VEyazE1J5nPmgU4RpW4Sa0TnOT6w5lgt3/tMpROigHHmexBGAMY0mdcDbDxWIz41NgdD6oxgHsJRgr5RnT6wZAkTOcStU4NMOQNemSO7gxGahdEsC+NRVGxMUhQmmM0llWRbbmFGHzEqLM4Iw0H7577Kyo+Zf+2cUFIOw93gEY171vQaM0HLwpjpdRR6Jz7V0ckE7XzYJ0TmY9znLdzkva0vNrAGGT5SUZ5uaHDkcGvI0ySpwkasEgZPMseYcu85w8HPdSNi+4T6A83iAwDbxgeFcB1ZM2iGXzFcEOUlYVrEckaOyodfvaYSQ7GuB4ISE0nYJc15X/1ciDTPbPCgYJK55VkEor4LvzL9S2WDy4xj+6FOqVyTAC2ZNowheeeSI5hA/02l8UYkv4nk9iaVn+kCVEUstgk5Hyq+gJm6R9vG3rhuM904he/hFmNQaUIATB1y3vw+OmxP4X5Yi6A5I5jJufHCjF9+AGNwnEllZjUco6XhsO5T5+R3yxz5yLVOnAn0zuS+6zdj0nTJbEZCbXJdtpfYZfCeCOqJHoE2vPPFS6eRLjIJlG69X93nfR0mxSFXzp1Zc0lt/VafDaImhUMtbnqWVb9M4nGNQLN68BHP7AR8Il9dkcxzmBv8PCZlw9guY0lurbBsmNYlwJZsA/B15/HfkbjbwPddaVecls/elmDHNW2r4crAx43feNkfRwsaNq/yyJ0d/p5hZ6AZajz7DBfUok0ZU62gCzz7x8eVfJTKA8IWn45vINLSM1q+HF9CV9qF3zP6Ml21kPPL3CXzkuYUlnSqT+Ij4tI/od5KwIs+tDajDs64owN7tOAd6eucGz+KfO26iNcBFpbWA5732bBNWO4kHNpr9D955L61bvHCF/mwSrz6eQaDjfDEANqGMkFc+NGxpKZzCD2sj/JrHd+zlPQ8Iz7Q+2JVIiVCuCKoK/hlAEHzvk/Piq3mRL1rT/fEh9hoT5GJmeYswg1otiKydizJ/fS2SeKHVu6Z3JEHjiW8NaTQgP5xdBli8nC57XiN9hrquBu99hn9zqwo92+PM2JXtpeVZS0PdqR5mDyDreMMtEws+CpwaRyyzoYtfcvt9PJIW0fJVNNi/FFyRsea7peLvJrL+5b4GOXJ8tAr+ATk9f8KmiIsRhqRy0vFzwRV3Z5dZ3QqIU8JQ/uQpkJbjMUMFj2F9sCFeaBjI4+fL/oN3+LQgjI4zuAfQ+3IPIPFQBccf0clJpsfpnBxD84atwtupkGqKvrH7cGNl/QcWcSi6wcVDML6ljOgYbo+2BOAWNNjlUBPiyitUAwbnhFvLbnqw42kR3Yp2kv2dMeDdcGOX5kT4S6M44KHEB/SpCfl7xgsUvs+JNY9G3O2X/6FEt9FyAn57lrbiu+tl83sCymSvq9eZbe9mchL7MTf/Ta78e80zSf0hYY5eUU7+ff14jv7Xy8qjzfzzzvaJnrIdvFb5BLWKcWGy5/w7+vV2cvIfwHqdTB+RuJK5oj9mbt0Hy94AmjMjjwYNZlNS6uiyxNnwNyt3gdreLb64p/3+08nXkb92LTkkRgFOwk1oGEVllcOj5lv1hfAZywDows0944U8vUFw+A/nuVq/UCygsrmWIBnHyU01d0XJPwriEOvx/ISK6Pk4y2w0gmojZs7lU8TtakBAdne4v/aNxmMpK4VcGMp7si0yqsiolXRuOi1Z1P7SqD3Zmp0CWcyK4Ubmp2SXiXuI5nGLCieFHKHNRIlcY3Pys2dwMTYCaqlyWSITwr2oGXvyU3h1Pf8eQ3w1bnD7ilocVjYDkcXR3Oo1BXgMLTUjNw2xMVwjtp99NhSVc5aIWrDQT5DHPKtCtheBP4zHcw4dz2eRdTMamhlHhtfgqJJHI7NGDUw1XL8vsSeSHyKqDtqoAmrQqsYwvwi7HW3ojWyhIa5oz5xJTaq14NAzFLjVLR12rRNUQ6xohDnrWFb5bG9yf8aCD8d5phoackcNJp+Dw3Due3RM+5Rid7EuIgsnwgpX0rUWh/nqPtByMhMZZ69NpgvRTKZ62ViZ+Q7Dp5r4K0d7EfJuiy06KuIYauRh5Ecrhdt2QpTS1k1AscEHvapNbU3HL1F2TFyR33Wxb5MvH5iZsrn3SDcsxlnnshO8PLwmdGN+paWnQuORtZGX37uhFT64SeuPsx8UOokY6ON85WdQ1dki5zErsJGazcBOddWJEKqNPiJpsMD1GrVLrVY+AOdPWQneTyyP1hRX/lMM4ZogGGOhYuAdr7F/DOiAoc++cn5vlf0zkMUJ40Z1rlgv9BelPqVOpxKeOpzKdF8maK+1Vv23MO9k/8+qpLoxrIGH2EDQlnGmH8CD31G8QqlyQIcpmR5bwmSVw9/Ns6IHgulCRehvZ/+VrM60Cu/r3AontFfrljew74skYe2uyn7JKQtFQBQRJ9ryGic/zQOsbS4scUBctA8cPToQ3x6ZBQu6DPu5m1bnCtP8TllLYA0UTQNVqza5nfew3Mopy1GPUwG5jsl0OVXniPmAcmLqO5HG8Hv3nSLecE9oOjPDXcsTxoCBxYyzBdj4wmnyEV4kvFDunipS8SSkvdaMnTBN9brHUR8xdmmEAp/Pdqk9uextp1t+JrtXwpN/MG2w/qhRMpSNxQ1uhg/kKO30eQ/FyHUDkWHT8V6gGRU4DhDMxZu7xXij9Ui6jlpWmQCqJg3FkOTq3WKneCRYZxBXMNAVLQgHXSCGSqNdjebY94oyIpVjMYehAiFx/tqzBXFHZaL5PeeD74rW5OysFoUXY8sebUZleFTUa/+zBKVTFDopTReXNuZq47QjkWnxjirCommO4L/GrFtVV21EpMyw8wyThL5Y59d88xtlx1g1ttSICDwnof6lt/6zliPzgVUL8jWBjC0o2D6Kg+jNuThkAlaDJsq/AG2aKA//A76avw2KNqtv223P+Wq3StRDDNKFFgtsFukYt1GFDWooFVXitaNhb3RCyJi4cMeNjROiPEDb4k+G3+hD8tsg+5hhmSc/8t2JTSwYoCzAI75doq8QTHe+E/Tw0RQSUDlU+6uBeNN3h6jJGX/mH8oj0i3caCNsjvTnoh73BtyZpsflHLq6AfwJNCDX4S98h4+pCOhGKDhV3rtkKHMa3EG4J9y8zFWI4UsfNzC/Rl5midNn7gwoN9j23HGCQQ+OAZpTTPMdiVow740gIyuEtd0qVxMyNXhHcnuXRKdw5wDUSL358ktjMXmAkvIB73BLa1vfF9BAUZInPYJiwxqFWQQBVk7gQH4ojfUQ/KEjn+A/WR6EEe4CtbpoLe1mzHkajgTIoE0SLDHVauKhrq12zrAXBGbPPWKCt4DGedq3JyGRbmPFW32bE7T20+73BatV/qQhhBWfWBFHfhYWXjALts38FemnoT+9bn1jDBMcUMmYgSc0e7GQjv2MUBwLU8ionCpgV+Qrhg7iUIfUY6JFxR0Y+ZTCPM+rVuq0GNLyJXX6nrUTt8HzFBRY1E/FIm2EeVA9NcXrj7S6YYIChVQCWr/m2fYUjC4j0XLkzZ8GCSLfmkW3PB/xq+nlXsKVBOj7vTvqKCOMq7Ztqr3cQ+N8gBnPaAps+oGwWOkbuxnRYj/x/WjiDclVrs22xMK4qArE1Ztk1456kiJriw6abkNeRHogaPRBgbgF9Z8i/tbzWELN4CvbqtrqV9TtGSnmPS2F9kqOIBaazHYaJ9bi3AoDBvlZasMluxt0BDXfhp02Jn411aVt6S4TUB8ZgFDkI6TP6gwPY85w+oUQSsjIeXVminrwIdK2ZAawb8Se6XOJbOaliQxHSrnAeONDLuCnFejIbp4YDtBcQCwMsYiRZfHefuEJqJcwKTTJ8sx5hjHmJI1sPFHOr6W9AhZ2NAod38mnLQk1gOz2LCAohoQbgMbUK9RMEA3LkiF7Sr9tLZp6lkciIGhE2V546w3Mam53VtVkGbB9w0Yk2XiRnCmbpxmHr2k4eSC0RuNbjNsUfDIfc8DZvRvgUDe1IlKdZTzcT4ZGEb53dp8VtsoZlyXzLHOdAbsp1LPTVaHvLA0GYDFMbAW/WUBfUAdHwqLFAV+3uHvYWrCfhUOR2i89qvCBoOb48usAGdcF2M4aKn79k/43WzBZ+xR1L0uZfia70XP9soQReeuhZiUnXFDG1T8/OXNmssTSnYO+3kVLAgeiY719uDwL9FQycgLPessNihMZbAKG7qwPZyG11G1+ZA3jAX2yddpYfmaKBlmfcK/V0mwIRUDC0nJSOPUl2KB8h13F4dlVZiRhdGY5farwN+f9hEb1cRi41ZcGDn6Xe9MMSTOY81ULJyXIHSWFIQHstVYLiJEiUjktlHiGjntN5/btB8Fu+vp28zl2fZXN+dJDyN6EXhS+0yzqpl/LSJNEUVxmu7BsNdjAY0jVsAhkNuuY0E1G48ej25mSt+00yPbQ4SRCVkIwb6ISvYtmJRPz9Zt5dk76blf+lJwAPH5KDF+vHAmACLoCdG2Adii6dOHnNJnTmZtoOGO8Q1jy1veMw6gbLFToQmfJa7nT7Al89mRbRkZZQxJTKgK5Kc9INzmTJFp0tpAPzNmyL/F08bX3nhCumM/cR/2RPn9emZ3VljokttZD1zVWXlUIqEU7SLk5I0lFRU0AcENXBYazNaVzsVHA/sD3o9hm42wbHIRb/BBQTKzAi8s3+bMtpOOZgLdQzCYPfX3UUxKd1WYVkGH7lh/RBBgMZZwXzU9+GYxdBqlGs0LP+DZ5g2BWNh6FAcR944B+K/JTWI3t9YyVyRhlP4CCoUk/mmF7+r2pilVBjxXBHFaBfBtr9hbVn2zDuI0kEOG3kBx8CGdPOjX1ph1POOZJUO1JEGG0jzUy2tK4X0CgVNYhmkqqQysRNtKuPdCJqK3WW57kaV17vXgiyPrl4KEEWgiGF1euI4QkSFHFf0TDroQiLNKJiLbdhH0YBhriRNCHPxSqJmNNoketaioohqMglh6wLtEGWSM1EZbQg72h0UJAIPVFCAJOThpQGGdKfFovcwEeiBuZHN2Ob4uVM7+gwZLz1D9E7ta4RmMZ24OBBAg7Eh6dLXGofZ4U2TFOCQMKjwhVckjrydRS+YaqCw1kYt6UexuzbNEDyYLTZnrY1PzsHZJT4U+awO2xlqTSYu6n/U29O2wPXgGOEKDMSq+zTUtyc8+6iLp0ivav4FKx+xxVy4FxhIF/pucVDqpsVe2jFOfdZhTzLz2QjtzvsTCvDPU7bzDH2eXVKUV9TZ+qFtaSSxnYgYdXKwVreIgvWhT9eGDB2OvnWyPLfIIIfNnfIxU8nW7MbcH05nhlsYtaW9EZRsxWcKdEqInq1DiZPKCz7iGmAU9/ccnnQud2pNgIGFYOTAWjhIrd63aPDgfj8/sdlD4l+UTlcxTI9jbaMqqN0gQxSHs60IAcW3cH4p3V1aSciTKB29L1tz2eUQhRiTgTvmqc+sGtBNh4ky0mQJGsdycBREP+fAaSs1EREDVo5gvgi5+aCN7NECw30owbCc1mSpjiahyNVwJd1jiGgzSwfTpzf2c5XJvG/g1n0fH88KHNnf+u7ZiRMlXueSIsloJBUtW9ezvsx9grfsX/FNxnbxU1Lvg0hLxixypHKGFAaPu0xCD8oDTeFSyfRT6s8109GMUZL8m2xXp8X2dpPCWWdX84iga4BrTlOfqox4shqEgh/Ht4qRst52cA1xOIUuOxgfUivp6v5f8IVyaryEdpVk72ERAwdT4aoY1usBgmP+0m06Q216H/nubtNYxHaOIYjcach3A8Ez/zc0KcShhel0HCYjFsA0FjYqyJ5ZUH1aZw3+zWC0hLpM6GDfcAdn9fq2orPmZbW6XXrf+Krc9RtvII5jeD3dFoT1KwZJwxfUMvc5KLfn8rROW23Jw89sJ2a5dpB3qWDUBWF2iX8OCuKprHosJ2mflBR+Wqs86VvgI/XMnsqb97+VlKdPVysczPj8Jhzf+WCvGBHijAqYlavbF60soMWlHbvKT+ScvhprgeTln51xX0sF+Eadc/l2s2a5BgkVbHYyz0E85p0LstqH+gEGiR84nBRRFIn8hLSZrGwqjZ3E29cuGi+5Z5bp7EM8MWFa9ssS/vy4VrDfECSv7DSU84DaP0sXI3Ap4lWznQ65nQoTKRWU30gd7Nn8ZowUvGIx4aqyXGwmA/PB4qN8msJUODezUHEl0VP9uo+cZ8vPFodSIB4C7lQYjEFj8yu49C2KIV3qxMFYTevG8KqAr0TPlkbzHHnTpDpvpzziAiNFh8xiT7C/TiyH0EguUw4vxAgpnE27WIypV+uFN2zW7xniF/n75trs9IJ5amB1zXXZ1LFkJ6GbS/dFokzl4cc2mamVwhL4XU0Av5gDWAl+aEWhAP7t2VIwU+EpvfOPDcLASX7H7lZpXA2XQfbSlD4qU18NffNPoAKMNSccBfO9YVVgmlW4RydBqfHAV7+hrZ84WJGho6bNT0YMhxxLdOx/dwGj0oyak9aAkNJ8lRJzUuA8sR+fPyiyTgUHio5+Pp+YaKlHrhR41jY5NESPS3x+zTMe0S2HnLOKCOQPpdxKyviBvdHrCDRqO+l96HhhNBLXWv4yEMuEUYo8kXnYJM8oIgVM4XJ+xXOev4YbWeqsvgq0lmw4/PiYr9sYLt+W5EAuYSFnJEan8CwJwbtASBfLBBpJZiRPor/aCJBZsM+MhvS7ZepyHvU8m5WSmaZnxuLts8ojl6KkS8oSAHkq5GWlCB/NgJ5W3rO2Cj1MK7ahxsCrbTT3a0V/QQH+sErxV4XUWDHx0kkFy25bPmBMBQ6BU3HoHhhYcJB9JhP6NXUWKxnE0raXHB6U9KHpWdQCQI72qevp5fMzcm+AvC85rsynVQhruDA9fp9COe7N56cg1UKGSas89vrN+WlGLYTwi5W+0xYdKEGtGCeNJwXKDU0XqU5uQYnWsMwTENLGtbQMvoGjIFIEMzCRal4rnBAg7D/CSn8MsCvS+FDJJAzoiioJEhZJgAp9n2+1Yznr7H+6eT4YkJ9Mpj60ImcW4i4iHDLn9RydB8dx3QYm3rsX6n4VRrZDsYK6DCGwkwd5n3/INFEpk16fYpP6JtMQpqEMzcOfQGAHXBTEGzuLJ03GYQL9bmV2/7ExDlRf+Uvf1sM2frRtCWmal12pMgtonvSCtR4n1CLUZRdTHDHP1Otwqd+rcdlavnKjUB/OYXQHUJzpNyFoKpQK+2OgrEKpGyIgIBgn2y9QHnTJihZOpEvOKIoHAMGAXHmj21Lym39Mbiow4IF+77xNuewziNVBxr6KD5e+9HzZSBIlUa/AmsDFJFXeyrQakR3FwowTGcADJHcEfhGkXYNGSYo4dh4bxwLM+28xjiqkdn0/3R4UEkvcBrBfn/SzBc1XhKM2VPlJgKSorjDac96V2UnQYXl1/yZPT4DVelgO+soMjexXwYO58VLl5xInQUZI8jc3H2CPnCNb9X05nOxIy4MlecasTqGK6s2az4RjpF2cQP2G28R+7wDPsZDZC/kWtjdoHC7SpdPmqQrUAhMwKVuxCmYTiD9q/O7GHtZvPSN0CAUQN/rymXZNniYLlJDE70bsk6Xxsh4kDOdxe7A2wo7P9F5YvqqRDI6brf79yPCSp4I0jVoO4YnLYtX5nzspR5WB4AKOYtR1ujXbOQpPyYDvfRE3FN5zw0i7reehdi7yV0YDRKRllGCGRk5Yz+Uv1fYl2ZwrnGsqsjgAVo0xEUba8ohjaNMJNwTwZA/wBDWFSCpg1eUH8MYL2zdioxRTqgGQrDZxQyNzyBJPXZF0+oxITJAbj7oNC5JwgDMUJaM5GqlGCWc//KCIrI+aclEe4IA0uzv7cuj6GCdaJONpi13O544vbtIHBF+A+JeDFUQNy61Gki3rtyQ4aUywn6ru314/dkGiP8Iwjo0J/2Txs49ZkwEl4mx+iYUUO55I6pJzU4P+7RRs+DXZkyKUYZqVWrPF4I94m4Wx1tXeE74o9GuX977yvJ/jkdak8+AmoHVjI15V+WwBdARFV2IPirJgVMdsg1Pez2VNHqa7EHWdTkl3XTcyjG9BiueWFvQfXI8aWSkuuRmqi/HUuzqyvLJfNfs0txMqldYYflWB1BS31WkuPJGGwXUCpjiQSktkuBMWwHjSkQxeehqw1Kgz0Trzm7QbtgxiEPDVmWCNCAeCfROTphd1ZNOhzLy6XfJyG6Xgd5MCAZw4xie0Sj5AnY1/akDgNS9YFl3Y06vd6FAsg2gVQJtzG7LVq1OH2frbXNHWH/NY89NNZ4QUSJqL2yEcGADbT38X0bGdukqYlSoliKOcsSTuqhcaemUeYLLoI8+MZor2RxXTRThF1LrHfqf/5LcLAjdl4EERgUysYS2geE+yFdasU91UgUDsc2cSQ1ZoT9+uLOwdgAmifwQqF028INc2IQEDfTmUw3eZxvz7Ud1z3xc1PQfeCvfKsB9jOhRj7rFyb9XcDWLcYj0bByosychMezMLVkFiYcdBBQtvI6K0KRuOZQH2kBsYHJaXTkup8F0eIhO1/GcIwWKpr2mouB7g5TUDJNvORXPXa/mU8bh27TAZYBe2sKx4NSv5OjnHIWD2RuysCzBlUfeNXhDd2jxnHoUlheJ3jBApzURy0fwm2FwwsSU0caQGl0Kv8hopRQE211NnvtLRsmCNrhhpEDoNiZEzD2QdJWKbRRWnaFedXHAELSN0t0bfsCsMf0ktfBoXBoNA+nZN9+pSlmuzspFevmsqqcMllzzvkyXrzoA+Ryo1ePXpdGOoJvhyru+EBRsmOp7MXZ0vNUMUqHLUoKglg1p73sWeZmPc+KAw0pE2zIsFFE5H4192KwDvDxdxEYoDBDNZjbg2bmADTeUKK57IPD4fTYF4c6EnXx/teYMORBDtIhPJneiZny7Nv/zG+YmekIKCoxr6kauE2bZtBLufetNG0BtBY7f+/ImUypMBvdWu/Q7vTMRzw5aQGZWuc1V0HEsItFYMIBnoKGZ0xcarba/TYZq50kCaflFysYjA4EDKHqGdpYWdKYmm+a7TADmW35yfnOYpZYrkpVEtiqF0EujI00aeplNs2k+qyFZNeE3CDPL9P6b4PQ/kataHkVpLSEVGK7EX6rAa7IVNrvZtFvOA6okKvBgMtFDAGZOx88MeBcJ8AR3AgUUeIznAN6tjCUipGDZONm1FjWJp4A3QIzSaIOmZ7DvF/ysYYbM/fFDOV0jntAjRdapxJxL0eThpEhKOjCDDq2ks+3GrwxqIFKLe1WdOzII8XIOPGnwy6LKXVfpSDOTEfaRsGujhpS4hBIsMOqHbl16PJxc4EkaVu9wpEYlF/84NSv5Zum4drMfp9yXbzzAOJqqS4YkI4cBrFrC7bMPiCfgI3nNZAqkk3QOZqR+yyqx+nDQKBBBZ7QKrfGMCL+XpqFaBJU0wpkBdAhbR4hJsmT5aynlvkouoxm/NjD5oe6BzVIO9uktM+/5dEC5P7vZvarmuO/lKXz4sBabVPIATuKTrwbJP8XUkdM6uEctHKXICUJGjaZIWRbZp8czquQYfY6ynBUCfIU+gG6wqSIBmYIm9pZpXdaL121V7q0VjDjmQnXvMe7ysoEZnZL15B0SpxS1jjd83uNIOKZwu5MPzg2NhOx3xMOPYwEn2CUzbSrwAs5OAtrz3GAaUkJOU74XwjaYUmGJdZBS1NJVkGYrToINLKDjxcuIlyfVsKQSG/G4DyiO2SlQvJ0d0Ot1uOG5IFSAkq+PRVMgVMDvOIJMdqjeCFKUGRWBW9wigYvcbU7CQL/7meF2KZAaWl+4y9uhowAX7elogAvItAAxo2+SFxGRsHGEW9BnhlTuWigYxRcnVUBRQHV41LV+Fr5CJYV7sHfeywswx4XMtUx6EkBhR+q8AXXUA8uPJ73Pb49i9KG9fOljvXeyFj9ixgbo6CcbAJ7WHWqKHy/h+YjBwp6VcN7M89FGzQ04qbrQtgrOFybg3gQRTYG5xn73ArkfQWjCJROwy3J38Dx/D7jOa6BBNsitEw1wGq780EEioOeD+ZGp2J66ADiVGMayiHYucMk8nTK2zzT9CnEraAk95kQjy4k0GRElLL5YAKLQErJ5rp1eay9O4Fb6yJGm9U4FaMwPGxtKD6odIIHKoWnhKo1U8KIpFC+MVn59ZXmc7ZTBZfsg6FQ8W10YfTr4u0nYrpHZbZ1jXiLmooF0cOm0+mPnJBXQtepc7n0BqOipNCqI6yyloTeRShNKH04FIo0gcMk0H/xThyN4pPAWjDDkEp3lNNPRNVfpMI44CWRlRgViP64eK0JSRp0WUvCWYumlW/c58Vcz/yMwVcW5oYb9+26TEhwvbxiNg48hl1VI1UXTU//Eta+BMKnGUivctfL5wINDD0giQL1ipt6U7C9cd4+lgqY2lMUZ02Uv6Prs+ZEZer7ZfWBXVghlfOOrClwsoOFKzWEfz6RZu1eCs+K8fLvkts5+BX0gyrFYve0C3qHrn5U/Oh6D/CihmWIrY7HUZRhJaxde+tldu6adYJ+LeXupQw0XExC36RETdNFxcq9glMu4cNQSX9cqR/GQYp+IxUkIcNGWVU7ZtGa6P3XAyodRt0XeS3Tp01AnCh0ZbUh4VrSZeV9RWfSoWyxnY3hzcZ30G/InDq4wxRrEejreBxnhIQbkxenxkaxl+k7eLUQkUR6vKJ2iDFNGX3WmVA1yaOH+mvhBd+sE6vacQzFobwY5BqEAFmejwW5ne7HtVNolOUgJc8CsUxmc/LBi8N5mu9VsIA5HyErnS6zeCz7VLI9+n/hbT6hTokMXTVyXJRKSG2hd2labXTbtmK4fNH3IZBPreSA4FMeVouVN3zG5x9CiGpLw/3pceo4qGqp+rVp+z+7yQ98oEf+nyH4F3+J9IheDBa94Wi63zJbLBCIZm7P0asHGpIJt3PzE3m0S4YIWyXBCVXGikj8MudDPB/6Nm2v4IxJ5gU0ii0guy5SUHqGUYzTP0jIJU5E82RHUXtX4lDdrihBLdP1YaG1AGUC12rQKuIaGvCpMjZC9bWSCYnjDlvpWbkdXMTNeBHLKiuoozMGIvkczmP0aRJSJ8PYnLCVNhKHXBNckH79e8Z8Kc2wUej4sQZoH8qDRGkg86maW/ZQWGNnLcXmq3FlXM6ssR/3P6E/bHMvm6HLrv1yRixit25JsH3/IOr2UV4BWJhxXW5BJ6Xdr07n9kF3ZNAk6/Xpc5MSFmYJ2R7bdL8Kk7q1OU9Elg/tCxJ8giT27wSTySF0GOxg4PbYJdi/Nyia9Nn89CGDulfJemm1aiEr/eleGSN+5MRrVJ4K6lgyTTIW3i9cQ0dAi6FHt0YMbH3wDSAtGLSAccezzxHitt1QdhW36CQgPcA8vIIBh3/JNjf/Obmc2yzpk8edSlS4lVdwgW5vzbYEyFoF4GCBBby1keVNueHAH+evi+H7oOVfS3XuPQSNTXOONAbzJeSb5stwdQHl1ZjrGoE49I8+A9j3t+ahhQj74FCSWpZrj7wRSFJJnnwi1T9HL5qrCFW/JZq6P62XkMWTb+u4lGpKfmmwiJWx178GOG7KbrZGqyWwmuyKWPkNswkZ1q8uptUlviIi+AXh2bOOTOLsrtNkfqbQJeh24reebkINLkjut5r4d9GR/r8CBa9SU0UQhsnZp5cP+RqWCixRm7i4YRFbtZ4EAkhtNa6jHb6gPYQv7MKqkPLRmX3dFsK8XsRLVZ6IEVrCbmNDc8o5mqsogjAQfoC9Bc7R6gfw03m+lQpv6kTfhxscDIX6s0w+fBxtkhjXAXr10UouWCx3C/p/FYwJRS/AXRKkjOb5CLmK4XRe0+xeDDwVkJPZau52bzLEDHCqV0f44pPgKOkYKgTZJ33fmk3Tu8SdxJ02SHM8Fem5SMsWqRyi2F1ynfRJszcFKykdWlNqgDA/L9lKYBmc7Zu/q9ii1FPF47VJkqhirUob53zoiJtVVRVwMR34gV9iqcBaHbRu9kkvqk3yMpfRFG49pKKjIiq7h/VpRwPGTHoY4cg05X5028iHsLvUW/uz+kjPyIEhhcKUwCkJAwbR9pIEGOn8z6svAO8i89sJ3dL5qDWFYbS+HGPRMxYwJItFQN86YESeJQhn2urGiLRffQeLptDl8dAgb+Tp47UQPxWOw17OeChLN1WnzlkPL1T5O+O3Menpn4C3IY5LEepHpnPeZHbvuWfeVtPlkH4LZjPbBrkJT3NoRJzBt86CO0Xq59oQ+8dsm0ymRcmQyn8w71mhmcuEI5byuF+C88VPYly2sEzjlzAQ3vdn/1+Hzguw6qFNNbqenhZGbdiG6RwZaTG7jTA2X9RdXjDN9yj1uQpyO4Lx8KRAcZcbZMafp4wPOd5MdXoFY52V1A8M9hi3sso93+uprE0qYNMjkE22CvK4HuUxqN7oIz5pWuETq1lQAjqlSlqdD2Rnr/ggp/TVkQYjn9lMfYelk2sH5HPdopYo7MHwlV1or9Bxf+QCyLzm92vzG2wjiIjC/ZHEJzeroJl6bdFPTpZho5MV2U86fLQqxNlGIMqCGy+9WYhJ8ob1r0+Whxde9L2PdysETv97O+xVw+VNN1TZSQN5I6l9m5Ip6pLIqLm4a1B1ffH6gHyqT9p82NOjntRWGIofO3bJz5GhkvSWbsXueTAMaJDou99kGLqDlhwBZNEQ4mKPuDvVwSK4WmLluHyhA97pZiVe8g+JxmnJF8IkV/tCs4Jq/HgOoAEGR9tCDsDbDmi3OviUQpG5D8XmKcSAUaFLRXb2lmJTNYdhtYyfjBYZQmN5qT5CNuaD3BVnlkCk7bsMW3AtXkNMMTuW4HjUERSJnVQ0vsBGa1wo3Qh7115XGeTF3NTz8w0440AgU7c3bSXO/KMINaIWXd0oLpoq/0/QJxCQSJ9XnYy1W7TYLBJpHsVWD1ahsA7FjNvRd6mxCiHsm8g6Z0pnzqIpF1dHUtP2ITU5Z1hZHbu+L3BEEStBbL9XYvGfEakv1bmf+bOZGnoiuHEdlBnaChxYKNzB23b8sw8YyT7Ajxfk49eJIAvdbVkdFCe2J0gMefhQ0bIZxhx3fzMIysQNiN8PgOUKxOMur10LduigREDRMZyP4oGWrP1GFY4t6groASsZ421os48wAdnrbovNhLt7ScNULkwZ5AIZJTrbaKYTLjA1oJ3sIuN/aYocm/9uoQHEIlacF1s/TM1fLcPTL38O9fOsjMEIwoPKfvt7opuI9G2Hf/PR4aCLDQ7wNmIdEuXJ/QNL72k5q4NejAldPfe3UVVqzkys8YZ/jYOGOp6c+YzRCrCuq0M11y7TiN6qk7YXRMn/gukxrEimbMQjr3jwRM6dKVZ4RUfWQr8noPXLJq6yh5R3EH1IVOHESst/LItbG2D2vRsZRkAObzvQAAD3mb3/G4NzopI0FAiHfbpq0X72adg6SRj+8OHMShtFxxLZlf/nLgRLbClwl5WmaYSs+yEjkq48tY7Z2bE0N91mJwt+ua0NlRJIDh0HikF4UvSVorFj2YVu9YeS5tfvlVjPSoNu/Zu6dEUfBOT555hahBdN3Sa5Xuj2Rvau1lQNIaC944y0RWj9UiNDskAK1WoL+EfXcC6IbBXFRyVfX/WKXxPAwUyIAGW8ggZ08hcijKTt1YKnUO6QPvcrmDVAb0FCLIXn5id4fD/Jx4tw/gbXs7WF9b2RgXtPhLBG9vF5FEkdHAKrQHZAJC/HWvk7nvzzDzIXZlfFTJoC3JpGgLPBY7SQTjGlUvG577yNutZ1hTfs9/1nkSXK9zzKLRZ3VODeKUovJe0WCq1zVMYxCJMenmNzPIU2S8TA4E7wWmbNkxq9rI2dd6v0VpcAPVMxnDsvWTWFayyqvKZO7Z08a62i/oH2/jxf8rpmfO64in3FLiL1GX8IGtVE9M23yGsIqJbxDTy+LtaMWDaPqkymb5VrQdzOvqldeU0SUi6IirG8UZ3jcpRbwHa1C0Dww9G/SFX3gPvTJQE+kyz+g1BeMILKKO+olcHzctOWgzxYHnOD7dpCRtuZEXACjgqesZMasoPgnuDC4nUviAAxDc5pngjoAITIkvhKwg5d608pdrZcA+qn5TMT6Uo/QzBaOxBCLTJX3Mgk85rMfsnWx86oLxf7p2PX5ONqieTa/qM3tPw4ZXvlAp83NSD8F7+ZgctK1TpoYwtiU2h02HCGioH5tkVCqNVTMH5p00sRy2JU1qyDBP2CII/Dg4WDsIl+zgeX7589srx6YORRQMBfKbodbB743Tl4WLKOEnwWUVBsm94SOlCracU72MSyj068wdpYjyz1FwC2bjQnxnB6Mp/pZ+yyZXtguEaYB+kqhjQ6UUmwSFazOb+rhYjLaoiM+aN9/8KKn0zaCTFpN9eKwWy7/u4EHzO46TdFSNjMfn2iPSJwDPCFHc0I1+vjdAZw5ZjqR/uzi9Zn20oAa5JnLEk/EA3VRWE7J/XrupfFJPtCUuqHPpnlL7ISJtRpSVcB8qsZCm2QEkWoROtCKKxUh3yEcMbWYJwk6DlEBG0bZP6eg06FL3v6RPb7odGuwm7FN8fG4woqtB8e7M5klPpo97GoObNwt+ludTAmxyC5hmcFx+dIvEZKI6igFKHqLH01iY1o7903VzG9QGetyVx5RNmBYUU+zIuSva/yIcECUi4pRmE3VkF2avqulQEUY4yZ/wmNboBzPmAPey3+dSYtBZUjeWWT0pPwCz4Vozxp9xeClIU60qvEFMQCaPvPaA70WlOP9f/ey39macvpGCVa+zfa8gO44wbxpJUlC8GN/pRMTQtzY8Z8/hiNrU+Zq64ZfFGIkdj7m7abcK1EBtws1X4J/hnqvasPvvDSDYWN+QcQVGMqXalkDtTad5rYY0TIR1Eqox3czwPMjKPvF5sFv17Thujr1IZ1Ytl4VX1J0vjXKmLY4lmXipRAro0qVGEcXxEVMMEl54jQMd4J7RjgomU0j1ptjyxY+cLiSyXPfiEcIS2lWDK3ISAy6UZ3Hb5vnPncA94411jcy75ay6B6DSTzK6UTCZR9uDANtPBrvIDgjsfarMiwoax2OlLxaSoYn4iRgkpEGqEkwox5tyI8aKkLlfZ12lO11TxsqRMY89j5JaO55XfPJPDL1LGSnC88Re9Ai+Nu5bZjtwRrvFITUFHPR4ZmxGslQMecgbZO7nHk32qHxYkdvWpup07ojcMCaVrpFAyFZJJbNvBpZfdf39Hdo2kPtT7v0/f8R/B5Nz4f1t9/3zNM/7n6SUHfcWk5dfQFJvcJMgPolGCpOFb/WC0FGWU2asuQyT+rm88ZKZ78Cei/CAh939CH0JYbpZIPtxc2ufXqjS3pHH9lnWK4iJ7OjR/EESpCo2R3MYKyE7rHfhTvWho4cL1QdN4jFTyR6syMwFm124TVDDRXMNveI1Dp/ntwdz8k8kxw7iFSx6+Yx6O+1LzMVrN0BBzziZi9kneZSzgollBnVwBh6oSOPHXrglrOj+QmR/AESrhDpKrWT+8/AiMDxS/5wwRNuGQPLlJ9ovomhJWn8sMLVItQ8N/7IXvtD8kdOoHaw+vBSbFImQsv/OCAIui99E+YSIOMlMvBXkAt+NAZK8wB9Jf8CPtB+TOUOR+z71d/AFXpPBT6+A5FLjxMjLIEoJzrQfquvxEIi+WoUzGR1IzQFNvbYOnxb2PyQ0kGdyXKzW2axQL8lNAXPk6NEjqrRD1oZtKLlFoofrXw0dCNWASHzy+7PSzOUJ3XtaPZsxLDjr+o41fKuKWNmjiZtfkOzItvlV2MDGSheGF0ma04qE3TUEfqJMrXFm7DpK+27DSvCUVf7rbNoljPhha5W7KBqVq0ShUSTbRmuqPtQreVWH4JET5yMhuqMoSd4r/N8sDmeQiQQvi1tcZv7Moc7dT5X5AtCD6kNEGZOzVcNYlpX4AbTsLgSYYliiPyVoniuYYySxsBy5cgb3pD+EK0Gpb0wJg031dPgaL8JZt6sIvzNPEHfVPOjXmaXj4bd4voXzpZ5GApMhILgMbCEWZ2zwgdeQgjNHLbPIt+KqxRwWPLTN6HwZ0Ouijj4UF+Sg0Au8XuIKW0WxlexdrFrDcZJ8Shauat3X0XmHygqgL1nAu2hrJFb4wZXkcS+i36KMyU1yFvYv23bQUJi/3yQpqr/naUOoiEWOxckyq/gq43dFou1DVDaYMZK9tho7+IXXokBCs5GRfOcBK7g3A+jXQ39K4YA8PBRW4m5+yR0ZAxWJncjRVbITvIAPHYRt1EJ3YLiUbqIvoKHtzHKtUy1ddRUQ0AUO41vonZDUOW+mrszw+SW/6Q/IUgNpcXFjkM7F4CSSQ2ExZg85otsMs7kqsQD4OxYeBNDcSpifjMoLb7GEbGWTwasVObmB/bfPcUlq0wYhXCYEDWRW02TP5bBrYsKTGWjnWDDJ1F7zWai0zW/2XsCuvBQjPFcTYaQX3tSXRSm8hsAoDdjArK/OFp6vcWYOE7lizP0Yc+8p16i7/NiXIiiQTp7c7Xus925VEtlKAjUdFhyaiLT7VxDagprMFwix4wZ05u0qj7cDWFd0W9OYHIu3JbJKMXRJ1aYNovugg+QqRN7fNHSi26VSgBpn+JfMuPo3aeqPWik/wI5Rz3BWarPQX4i5+dM0npwVOsX+KsOhC7vDg+OJsz4Q5zlnIeflUWL6QYMbf9WDfLmosLF4Qev3mJiOuHjoor/dMeBpA9iKDkMjYBNbRo414HCxjsHrB4EXNbHzNMDHCLuNBG6Sf+J4MZ/ElVsDSLxjIiGsTPhw8BPjxbfQtskj+dyNMKOOcUYIRBEIqbazz3lmjlRQhplxq673VklMMY6597vu+d89ec/zq7Mi4gQvh87ehYbpOuZEXj5g/Q7S7BFDAAB9DzG35SC853xtWVcnZQoH54jeOqYLR9NDuwxsVthTV7V99n/B7HSbAytbEyVTz/5NhJ8gGIjG0E5j3griULUd5Rg7tQR+90hJgNQKQH2btbSfPcaTOfIexc1db1BxUOhM1vWCpLaYuKr3FdNTt/T3PWCpEUWDKEtzYrjpzlL/wri3MITKsFvtF8QVV/NhVo97aKIBgdliNc10dWdXVDpVtsNn+2UIolrgqdWA4EY8so0YvB4a+aLzMXiMAuOHQrXY0tr+CL10JbvZzgjJJuB1cRkdT7DUqTvnswVUp5kkUSFVtIIFYK05+tQxT6992HHNWVhWxUsD1PkceIrlXuUVRogwmfdhyrf6zzaL8+c0L7GXMZOteAhAVQVwdJh+7nrX7x4LaIIfz2F2v7Dg/uDfz2Fa+4gFm2zHAor8UqimJG3VTJtZEoFXhnDYXvxMJFc6ku2bhbCxzij2z5UNuK0jmp1mnvkVNUfR+SEmj1Lr94Lym75PO7Fs0MIr3GdsWXRXSfgLTVY0FLqba97u1In8NAcY7IC6TjWLigwKEIm43NxTdaVTv9mcKkzuzBkKd8x/xt1p/9BbP7Wyb4bpo1K1gnOpbLvKz58pWl3B55RJ/Z5mRDLPtNQg14jdOEs9+h/V5UVpwrAI8kGbX8KPVPDIMfIqKDjJD9UyDOPhjZ3vFAyecwyq4akUE9mDOtJEK1hpDyi6Ae87sWAClXGTiwPwN7PXWwjxaR79ArHRIPeYKTunVW24sPr/3HPz2IwH8oKH4OlWEmt4BLM6W5g4kMcYbLwj2usodD1088stZA7VOsUSpEVl4w7NMb1EUHMRxAxLF0CIV+0L3iZb+ekB1vSDSFjAZ3hfLJf7gFaXrOKn+mhR+rWw/eTXIcAgl4HvFuBg1LOmOAwJH3eoVEjjwheKA4icbrQCmvAtpQ0mXG0agYp5mj4Rb6mdQ+RV4QBPbxMqh9C7o8nP0Wko2ocnCHeRGhN1XVyT2b9ACsL+6ylUy+yC3QEnaKRIJK91YtaoSrcWZMMwxuM0E9J68Z+YyjA0g8p1PfHAAIROy6Sa04VXOuT6A351FOWhKfTGsFJ3RTJGWYPoLk5FVK4OaYR9hkJvezwF9vQN1126r6isMGXWTqFW+3HL3I/jurlIdDWIVvYY+s6yq7lrFSPAGRdnU7PVwY/SvWbZGpXzy3BQ2LmAJlrONUsZs4oGkly0V267xbD5KMY8woNNsmWG1VVgLCra8aQBBcI4DP2BlNwxhiCtHlaz6OWFoCW0vMR3ErrG7JyMjTSCnvRcsEHgmPnwA6iNpJ2DrFb4gLlhKJyZGaWkA97H6FFdwEcLT6DRQQL++fOkVC4cYGW1TG/3iK5dShRSuiBulmihqgjR45Vi03o2RbQbP3sxt90VxQ6vzdlGfkXmmKmjOi080JSHkLntjvsBJnv7gKscOaTOkEaRQqAnCA4HWtB4XnMtOhpRmH2FH8tTXrIjAGNWEmudQLCkcVlGTQ965Kh0H6ixXbgImQP6b42B49sO5C8pc7iRlgyvSYvcnH9FgQ3azLbQG2cUW96SDojTQStxkOJyOuDGTHAnnWkz29aEwN9FT8EJ4yhXOg+jLTrCPKeEoJ9a7lDXOjEr8AgX4BmnMQ668oW0zYPyQiVMPxKRHtpfnEEyaKhdzNVThlxxDQNdrHeZiUFb6NoY2KwvSb7BnRcpJy+/g/zAYx3fYSN5QEaVD2Y1VsNWxB0BSO12MRsRY8JLfAezRMz5lURuLUnG1ToKk6Q30FughqWN6gBNcFxP/nY/iv+iaUQOa+2Nuym46wtI/DvSfzSp1jEi4SdYBE7YhTiVV5cX9gwboVDMVgZp5YBQlHOQvaDNfcCoCJuYhf5kz5kwiIKPjzgpcRJHPbOhJajeoeRL53cuMahhV8Z7IRr6M4hW0JzT7mzaMUzQpm866zwM7Cs07fJYXuWvjAMkbe5O6V4bu71sOG6JQ4oL8zIeXHheFVavzxmlIyBkgc9IZlEDplMPr8xlcyss4pVUdwK1e7CK2kTsSdq7g5SHRAl3pYUB9Ko4fsh4qleOyJv1z3KFSTSvwEcRO/Ew8ozEDYZSqpfoVW9uhJfYrNAXR0Z3VmeoAD+rVWtwP/13sE/3ICX3HhDG3CMc476dEEC0K3umSAD4j+ZQLVdFOsWL2C1TH5+4KiSWH+lMibo+B55hR3Gq40G1n25sGcN0mEcoU2wN9FCVyQLBhYOu9aHVLWjEKx2JIUZi5ySoHUAI9b8hGzaLMxCZDMLhv8MkcpTqEwz9KFDpCpqQhVmsGQN8m24wyB82FAKNmjgfKRsXRmsSESovAwXjBIoMKSG51p6Um8b3i7GISs7kjTq/PZoioCfJzfKdJTN0Q45kQEQuh9H88M3yEs3DbtRTKALraM0YC8laiMiOOe6ADmTcCiREeAWZelBaEXRaSuj2lx0xHaRYqF65O0Lo5OCFU18A8cMDE4MLYm9w2QSr9NgQAIcRxZsNpA7UJR0e71JL+VU+ISWFk5I97lra8uGg7GlQYhGd4Gc6rxsLFRiIeGO4abP4S4ekQ1fiqDCy87GZHd52fn5aaDGuvOmIofrzpVwMvtbreZ/855OaXTRcNiNE0wzGZSxbjg26v8ko8L537v/XCCWP2MFaArJpvnkep0pA+O86MWjRAZPQRfznZiSIaTppy6m3p6HrNSsY7fDtz7Cl4V/DJAjQDoyiL2uwf1UHVd2AIrzBUSlJaTj4k6NL97a/GqhWKU9RUmjnYKpm2r+JYUcrkCuZKvcYvrg8pDoUKQywY9GDWg03DUFSirlUXBS5SWn/KAntnf0IdHGL/7mwXqDG+LZYjbEdQmqUqq4y54TNmWUP7IgcAw5816YBzwiNIJiE9M4lPCzeI/FGBeYy3p6IAmH4AjXXmvQ4Iy0Y82NTobcAggT2Cdqz6Mx4TdGoq9fn2etrWKUNFyatAHydQTVUQ2S5OWVUlugcNvoUrlA8cJJz9MqOa/W3iVno4zDHfE7zhoY5f5lRTVZDhrQbR8LS4eRLz8iPMyBL6o4PiLlp89FjdokQLaSBmKHUwWp0na5fE3v9zny2YcDXG/jfI9sctulHRbdkI5a4GOPJx4oAJQzVZ/yYAado8KNZUdEFs9ZPiBsausotXMNebEgr0dyopuqfScFJ3ODNPHgclACPdccwv0YJGQdsN2lhoV4HVGBxcEUeUX/alr4nqpcc1CCR3vR7g40zteQg/JvWmFlUE4mAiTpHlYGrB7w+U2KdSwQz2QJKBe/5eiixWipmfP15AFWrK8Sh1GBBYLgzki1wTMhGQmagXqJ2+FuqJ8f0XzXCVJFHQdMAw8xco11HhM347alrAu+wmX3pDFABOvkC+WPX0Uhg1Z5MVHKNROxaR84YV3s12UcM+70cJ460SzEaKLyh472vOMD3XnaK7zxZcXlWqenEvcjmgGNR2OKbI1s8U+iwiW+HotHalp3e1MGDy6BMVIvajnAzkFHbeVsgjmJUkrP9OAwnEHYXVBqYx3q7LvXjoVR0mY8h+ZaOnh053pdsGkmbqhyryN01eVHySr+CkDYkSMeZ1xjPNVM+gVLTDKu2VGsMUJqWO4TwPDP0VOg2/8ITbAUaMGb4LjL7L+Pi11lEVMXTYIlAZ/QHmTENjyx3kDkBdfcvvQt6tKk6jYFM4EG5UXDTaF5+1ZjRz6W7MdJPC+wTkbDUim4p5QQH3b9kGk2Bkilyeur8Bc20wm5uJSBO95GfYDI1EZipoRaH7uVveneqz43tlTZGRQ4a7CNmMHgXyOQQOL6WQkgMUTQDT8vh21aSdz7ERiZT1jK9F+v6wgFvuEmGngSvIUR2CJkc5tx1QygfZnAruONobB1idCLB1FCfO7N1ZdRocT8/Wye+EnDiO9pzqIpnLDl4bkaRKW+ekBVwHn46Shw1X0tclt/0ROijuUB4kIInrVJU4buWf4YITJtjOJ6iKdr1u+flgQeFH70GxKjhdgt/MrwfB4K/sXczQ+9zYcrD4dhY6qZhZ010rrxggWA8JaZyg2pYij8ieYEg1aZJkZK9O1Re7sB0iouf60rK0Gd+AYlp7soqCBCDGwfKeUQhCBn0E0o0GS6PdmjLi0TtCYZeqazqwN+yNINIA8Lk3iPDnWUiIPLGNcHmZDxfeK0iAdxm/T7LnN+gemRL61hHIc0NCAZaiYJR+OHnLWSe8sLrK905B5eEJHNlWq4RmEXIaFTmo49f8w61+NwfEUyuJAwVqZCLFcyHBKAcIVj3sNzfEOXzVKIndxHw+AR93owhbCxUZf6Gs8cz6/1VdrFEPrv330+9s6BtMVPJ3zl/Uf9rUi0Z/opexfdL3ykF76e999GPfVv8fJv/Y/+/5hEMon1tqNFyVRevV9y9/uIvsG3dbB8GRRrgaEXfhx+2xeOFt+cEn3RZanNxdEe2+B6MHpNbrRE53PlDifPvFcp4kO78ILR0T4xyW/WGPyBsqGdoA7zJJCu1TKbGfhnqgnRbxbB2B3UZoeQ2bz2sTVnUwokTcTU21RxN1PYPS3Sar7T0eRIsyCNowr9amwoMU/od9s2APtiKNL6ENOlyKADstAEWKA+sdKDhrJ6BOhRJmZ+QJbAaZ3/5Fq0/lumCgEzGEbu3yi0Y4I4EgVAjqxh4HbuQn0GrRhOWyAfsglQJAVL1y/6yezS2k8RE2MstJLh92NOB3GCYgFXznF4d25qiP4ZCyI4RYGesut6FXK6GwPpKK8WHEkhYui0AyEmr5Ml3uBFtPFdnioI8RiCooa7Z1G1WuyIi3nSNglutc+xY8BkeW3JJXPK6jd2VIMpaSxpVtFq+R+ySK9J6WG5Qvt+C+QH1hyYUOVK7857nFmyDBYgZ/o+AnibzNVqyYCJQvyDXDTK+iXdkA71bY7TL3bvuLxLBQ8kbTvTEY9aqkQ3+MiLWbEgjLzOH+lXgco1ERgzd80rDCymlpaRQbOYnKG/ODoFl46lzT0cjM5FYVvv0qLUbD5lyJtMUaC1pFlTkNONx6lliaX9o0i/1vws5bNKn5OuENQEKmLlcP4o2ZmJjD4zzd3Fk32uQ4uRWkPSUqb4LBe3EXHdORNB2BWsws5daRnMfNVX7isPSb1hMQdAJi1/qmDMfRUlCU74pmnzjbXfL8PVG8NsW6IQM2Ne23iCPIpryJjYbVnm5hCvKpMa7HLViNiNc+xTfDIaKm3jctViD8A1M9YPJNk003VVr4Zo2MuGW8vil8SLaGpPXqG7I4DLdtl8a4Rbx1Lt4w5Huqaa1XzZBtj208EJVGcmKYEuaeN27zT9EE6a09JerXdEbpaNgNqYJdhP1NdqiPKsbDRUi86XvvNC7rME5mrSQtrzAZVndtSjCMqd8BmaeGR4l4YFULGRBeXIV9Y4yxLFdyoUNpiy2IhePSWzBofYPP0eIa2q5JP4j9G8at/AqoSsLAUuRXtvgsqX/zYwsE+of6oSDbUOo4RMJw+DOUTJq+hnqwKim9Yy/napyZNTc2rCq6V9jHtJbxGPDwlzWj/Sk3zF/BHOlT/fSjSq7FqlPI1q6J+ru8Aku008SFINXZfOfnZNOvGPMtEmn2gLPt+H4QLA+/SYe4j398auzhKIp2Pok3mPC5q1IN1HgR+mnEfc4NeeHYwd2/kpszR3cBn7ni9NbIqhtSWFW8xbUJuUPVOeeXu3j0IGZmFNiwaNZ6rH4/zQ2ODz6tFxRLsUYZu1bfd1uIvfQDt4YD/efKYv8VF8bHGDgK22w2Wqwpi43vNCOXFJZCGMqWiPbL8mil6tsmOTXAWCyMCw73e2rADZj2IK6rqksM3EXF2cbLb4vjB14wa/yXK5vwU+05MzERJ5nXsXsW21o7M+gO0js2OyKciP5uF2iXyb2DiptwQeHeqygkrNsqVCSlldxBMpwHi1vfc8RKpP/4L3Lmpq6DZcvhDDfxTCE3splacTcOtXdK2g303dIWBVe2wD/Gvja1cClFQ67gw0t1ZUttsUgQ1Veky8oOpS6ksYEc4bqseCbZy766SvL3FodmnahlWJRgVCNjPxhL/fk2wyvlKhITH/VQCipOI0dNcRa5B1M5HmOBjTLeZQJy237e2mobwmDyJNHePhdDmiknvLKaDbShL+Is1XTCJuLQd2wmdJL7+mKvs294whXQD+vtd88KKk0DXP8B1Xu9J+xo69VOuFgexgTrcvI6SyltuLix9OPuE6/iRJYoBMEXxU4shQMf4Fjqwf1PtnJ/wWSZd29rhZjRmTGgiGTAUQqRz+nCdjeMfYhsBD5Lv60KILWEvNEHfmsDs2L0A252351eUoYxAysVaCJVLdH9QFWAmqJDCODUcdoo12+gd6bW2boY0pBVHWL6LQDK5bYWh1V8vFvi0cRpfwv7cJiMX3AZNJuTddHehTIdU0YQ/sQ1dLoF2xQPcCuHKiuCWOY30DHe1OwcClLAhqAKyqlnIbH/8u9ScJpcS4kgp6HKDUdiOgRaRGSiUCRBjzI5gSksMZKqy7Sd51aeg0tgJ+x0TH9YH2Mgsap9N7ENZdEB0bey2DMTrBA1hn56SErNHf3tKtqyL9b6yXEP97/rc+jgD2N1LNUH6RM9AzP3kSipr06RkKOolR7HO768jjWiH1X92jA7dkg7gcNcjqsZCgfqWw0tPXdLg20cF6vnQypg7gLtkazrHAodyYfENPQZsdfnjMZiNu4nJO97D1/sQE+3vNFzrSDOKw+keLECYf7RJwVHeP/j79833oZ0egonYB2FlFE5qj02B/LVOMJQlsB8uNg3Leg4qtZwntsOSNidR0abbZmAK4sCzvt8Yiuz2yrNCJoH5O8XvX/vLeR/BBYTWj0sOPYM/jyxRd5+/JziKAABaPcw/34UA3aj/gLZxZgRCWN6m4m3demanNgsx0P237/Q+Ew5VYnJPkyCY0cIVHoFn2Ay/e7U4P19APbPFXEHX94N6KhEMPG7iwB3+I+O1jd5n6VSgHegxgaSawO6iQCYFgDsPSMsNOcUj4q3sF6KzGaH/0u5PQoAj/8zq6Uc9MoNrGqhYeb2jQo0WlGlXjxtanZLS24/OIN5Gx/2g684BPDQpwlqnkFcxpmP/osnOXrFuu4PqifouQH0eF5qCkvITQbJw/Zvy5mAHWC9oU+cTiYhJmSfKsCyt1cGVxisKu+NymEQIAyaCgud/V09qT3nk/9s/SWsYtha7yNpzBIMM40rCSGaJ9u6lEkl00vXBiEt7p9P5IBCiavynEOv7FgLqPdeqxRiCwuFVMolSIUBcoyfUC2e2FJSAUgYdVGFf0b0Kn2EZlK97yyxrT2MVgvtRikfdaAW8RwEEfN+B7/eK8bBdp7URpbqn1xcrC6d2UjdsKbzCjBFqkKkoZt7Mrhg6YagE7spkqj0jOrWM+UGQ0MUlG2evP1uE1p2xSv4dMK0dna6ENcNUF+xkaJ7B764NdxLCpuvhblltVRAf7vK5qPttJ/9RYFUUSGcLdibnz6mf7WkPO3MkUUhR2mAOuGv8IWw5XG1ZvoVMnjSAZe6T7WYA99GENxoHkMiKxHlCuK5Gd0INrISImHQrQmv6F4mqU/TTQ8nHMDzCRivKySQ8dqkpQgnUMnwIkaAuc6/FGq1hw3b2Sba398BhUwUZSAIO8XZvnuLdY2n6hOXws+gq9BHUKcKFA6kz6FDnpxLPICa3qGhnc97bo1FT/XJk48LrkHJ2CAtBv0RtN97N21plfpXHvZ8gMJb7Zc4cfI6MbPwsW7AilCSXMFIEUEmir8XLEklA0ztYbGpTTGqttp5hpFTTIqUyaAIqvMT9A/x+Ji5ejA4Bhxb/cl1pUdOD6epd3yilIdO6j297xInoiBPuEDW2/UfslDyhGkQs7Wy253bVnlT+SWg89zYIK/9KXFl5fe+jow2rd5FXv8zDPrmfMXiUPt9QBO/iK4QGbX5j/7Rx1c1vzsY8ONbP3lVIaPrhL4+1QrECTN3nyKavGG0gBBtHvTKhGoBHgMXHStFowN+HKrPriYu+OZ05Frn8okQrPaaxoKP1ULCS/cmKFN3gcH7HQlVjraCeQmtjg1pSQxeuqXiSKgLpxc/1OiZsU4+n4lz4hpahGyWBURLi4642n1gn9qz9bIsaCeEPJ0uJmenMWp2tJmIwLQ6VSgDYErOeBCfSj9P4G/vI7oIF+l/n5fp956QgxGvur77ynawAu3G9MdFbJbu49NZnWnnFcQHjxRuhUYvg1U/e84N4JTecciDAKb/KYIFXzloyuE1eYXf54MmhjTq7B/yBToDzzpx3tJCTo3HCmVPYfmtBRe3mPYEE/6RlTIxbf4fSOcaKFGk4gbaUWe44hVk9SZzhW80yfW5QWBHxmtUzvMhfVQli4gZTktIOZd9mjJ5hsbmzttaHQB29Am3dZkmx3g/qvYocyhZ2PXAWsNQiIaf+Q8W/MWPIK7/TjvCx5q2XRp4lVWydMc2wIQkhadDB0xsnw/kSEyGjLKjI4coVIwtubTF3E7MJ6LS6UOsJKj82XVAVPJJcepfewbzE91ivXZvOvYfsmMevwtPpfMzGmC7WJlyW2j0jh7AF1JLmwEJSKYwIvu6DHc3YnyLH9ZdIBnQ+nOVDRiP+REpqv++typYHIvoJyICGA40d8bR7HR2k7do6UQTHF4oriYeIQbxKe4Th6+/l1BjUtS9hqORh3MbgvYrStXTfSwaBOmAVQZzpYNqsAmQyjY56MUqty3c/xH6GuhNvNaG9vGbG6cPtBM8UA3e8r51D0AR9kozKuGGSMgLz3nAHxDNnc7GTwpLj7/6HeWp1iksDeTjwCLpxejuMtpMnGJgsiku1sOACwQ9ukzESiDRN77YNESxR5LphOlcASXA5uIts1LnBIcn1J7BLWs49DMALSnuz95gdOrTZr0u1SeYHinno/pE58xYoXbVO/S+FEMMs5qyWkMnp8Q3ClyTlZP52Y9nq7b8fITPuVXUk9ohG5EFHw4gAEcjFxfKb3xuAsEjx2z1wxNbSZMcgS9GKyW3R6KwJONgtA64LTyxWm8Bvudp0M1FdJPEGopM4Fvg7G/hsptkhCfHFegv4ENwxPeXmYhxwZy7js+BeM27t9ODBMynVCLJ7RWcBMteZJtvjOYHb5lOnCLYWNEMKC59BA7covu1cANa2PXL05iGdufOzkgFqqHBOrgQVUmLEc+Mkz4Rq8O6WkNr7atNkH4M8d+SD1t/tSzt3oFql+neVs+AwEI5JaBJaxARtY2Z4mKoUqxds4UpZ0sv3zIbNoo0J4fihldQTX3XNcuNcZmcrB5LTWMdzeRuAtBk3cZHYQF6gTi3PNuDJ0nmR+4LPLoHvxQIxRgJ9iNNXqf2SYJhcvCtJiVWo85TsyFOuq7EyBPJrAdhEgE0cTq16FQXhYPJFqSfiVn0IQnPOy0LbU4BeG94QjdYNB0CiQ3QaxQqD2ebSMiNjaVaw8WaM4Z5WnzcVDsr4eGweSLa2DE3BWViaxhZFIcSTjgxNCAfelg+hznVOYoe5VqTYs1g7WtfTm3e4/WduC6p+qqAM8H4ZyrJCGpewThTDPe6H7CzX/zQ8Tm+r65HeZn+MsmxUciEWPlAVaK/VBaQBWfoG/aRL/jSZIQfep/89GjasWmbaWzeEZ2R1FOjvyJT37O9B8046SRSKVEnXWlBqbkb5XCS3qFeuE9xb9+frEknxWB5h1D/hruz2iVDEAS7+qkEz5Ot5agHJc7WCdY94Ws61sURcX5nG8UELGBAHZ3i+3VulAyT0nKNNz4K2LBHBWJcTBX1wzf+//u/j/9+//v87+9/l9Lbh/L/uyNYiTsWV2LwsjaA6MxTuzFMqmxW8Jw/+IppdX8t/Clgi1rI1SN0UC/r6tX/4lUc2VV1OQReSeCsjUpKZchw4XUcjHfw6ryCV3R8s6VXm67vp4n+lcPV9gJwmbKQEsmrJi9c2vkwrm8HFbVYNTaRGq8D91t9n5+U+aD/hNtN3HjC/nC/vUoGFSCkXP+NlRcmLUqLbiUBl4LYf1U/CCvwtd3ryCH8gUmGITAxiH1O5rnGTz7y1LuFjmnFGQ1UWuM7HwfXtWl2fPFKklYwNUpF2IL/TmaRETjQiM5SJacI+3Gv5MBU8lP5Io6gWkawpyzNEVGqOdx4YlO1dCvjbWFZWbCmeiFKPSlMKtKcMFLs/KQxtgAHi7NZNCQ32bBAW2mbHflVZ8wXKi1JKVHkW20bnYnl3dKWJeWJOiX3oKPBD6Zbi0ZvSIuWktUHB8qDR8DMMh1ZfkBL9FS9x5r0hBGLJ8pUCJv3NYH+Ae8p40mZWd5m5fhobFjQeQvqTT4VKWIYfRL0tfaXKiVl75hHReuTJEcqVlug+eOIIc4bdIydtn2K0iNZPsYWQvQio2qbO3OqAlPHDDOB7DfjGEfVF51FqqNacd6QmgFKJpMfLp5DHTv4wXlONKVXF9zTJpDV4m1sYZqJPhotcsliZM8yksKkCkzpiXt+EcRQvSQqmBS9WdWkxMTJXPSw94jqI3varCjQxTazjlMH8jTS8ilaW8014/vwA/LNa+YiFoyyx3s/KswP3O8QW1jtq45yTM/DX9a8M4voTVaO2ebvw1EooDw/yg6Y1faY+WwrdVs5Yt0hQ5EwRfYXSFxray1YvSM+kYmlpLG2/9mm1MfmbKHXr44Ih8nVKb1M537ZANUkCtdsPZ80JVKVKabVHCadaLXg+IV8i5GSwpZti0h6diTaKs9sdpUKEpd7jDUpYmHtiX33SKiO3tuydkaxA7pEc9XIQEOfWJlszj5YpL5bKeQyT7aZSBOamvSHl8xsWvgo26IP/bqk+0EJUz+gkkcvlUlyPp2kdKFtt7y5aCdks9ZJJcFp5ZWeaWKgtnXMN3ORwGLBE0PtkEIek5FY2aVssUZHtsWIvnljMVJtuVIjpZup/5VL1yPOHWWHkOMc6YySWMckczD5jUj2mlLVquFaMU8leGVaqeXis+aRRL8zm4WuBk6cyWfGMxgtr8useQEx7k/PvRoZyd9nde1GUCV84gMX8Ogu/BWezYPSR27llzQnA97oo0pYyxobYUJfsj+ysTm9zJ+S4pk0TGo9VTG0KjqYhTmALfoDZVKla2b5yhv241PxFaLJs3i05K0AAIdcGxCJZmT3ZdT7CliR7q+kur7WdQjygYtOWRL9B8E4s4LI8KpAj7bE0dg7DLOaX+MGeAi0hMMSSWZEz+RudXbZCsGYS0QqiXjH9XQbd8sCB+nIVTq7/T/FDS+zWY9q7Z2fdq1tdLb6v3hKKVDAw5gjj6o9r1wHFROdHc18MJp4SJ2Ucvu+iQ9EgkekW8VCM+psM6y+/2SBy8tNN4a3L1MzP+OLsyvESo5gS7IQOnIqMmviJBVc6zbVG1n8eXiA3j46kmvvtJlewwNDrxk4SbJOtP/TV/lIVK9ueShNbbMHfwnLTLLhbZuO79ec5XvfgRwLFK+w1r5ZWW15rVFZrE+wKqNRv5KqsLNfpGgnoUU6Y71NxEmN7MyqwqAQqoIULOw/LbuUB2+uE75gJt+kq1qY4LoxV+qR/zalupea3D5+WMeaRIn0sAI6DDWDh158fqUb4YhAxhREbUN0qyyJYkBU4V2KARXDT65gW3gRsiv7xSPYEKLwzgriWcWgPr0sbZnv7m1XHNFW6xPdGNZUdxFiUYlmXNjDVWuu7LCkX/nVkrXaJhiYktBISC2xgBXQnNEP+cptWl1eG62a7CPXrnrkTQ5BQASbEqUZWMDiZUisKyHDeLFOaJILUo5f6iDt4ZO8MlqaKLto0AmTHVVbkGuyPa1R/ywZsWRoRDoRdNMMHwYTsklMVnlAd2S0282bgMI8fiJpDh69OSL6K3qbo20KfpNMurnYGQSr/stFqZ7hYsxKlLnKAKhsmB8AIpEQ4bd/NrTLTXefsE6ChRmKWjXKVgpGoPs8GAicgKVw4K0qgDgy1A6hFq1WRat3fHF+FkU+b6H4NWpOU3KXTxrIb2qSHAb+qhm8hiSROi/9ofapjxhyKxxntPpge6KL5Z4+WBMYkAcE6+0Hd3Yh2zBsK2MV3iW0Y6cvOCroXlRb2MMJtdWx+3dkFzGh2Pe3DZ9QpSqpaR/rE1ImOrHqYYyccpiLC22amJIjRWVAherTfpQLmo6/K2pna85GrDuQPlH1Tsar8isAJbXLafSwOof4gg9RkAGm/oYpBQQiPUoyDk2BCQ1k+KILq48ErFo4WSRhHLq/y7mgw3+L85PpP6xWr6cgp9sOjYjKagOrxF148uhuaWtjet953fh1IQiEzgC+d2IgBCcUZqgTAICm2bR8oCjDLBsmg+ThyhfD+zBalsKBY1Ce54Y/t9cwfbLu9SFwEgphfopNA3yNxgyDafUM3mYTovZNgPGdd4ZFFOj1vtfFW3u7N+iHEN1HkeesDMXKPyoCDCGVMo4GCCD6PBhQ3dRZIHy0Y/3MaE5zU9mTCrwwnZojtE+qNpMSkJSpmGe0EzLyFelMJqhfFQ7a50uXxZ8pCc2wxtAKWgHoeamR2O7R+bq7IbPYItO0esdRgoTaY38hZLJ5y02oIVwoPokGIzxAMDuanQ1vn2WDQ00Rh6o5QOaCRu99fwDbQcN0XAuqkFpxT/cfz3slGRVokrNU0iqiMAJFEbKScZdmSkTUznC0U+MfwFOGdLgsewRyPKwBZYSmy6U325iUhBQNxbAC3FLKDV9VSOuQpOOukJ/GAmu/tyEbX9DgEp6dv1zoU0IqzpG6gssSjIYRVPGgU1QAQYRgIT8gEV0EXr1sqeh2I6rXjtmoCYyEDCe/PkFEi/Q48FuT29p557iN+LCwk5CK/CZ2WdAdfQZh2Z9QGrzPLSNRj5igUWzl9Vi0rCqH8G1Kp4QMLkuwMCAypdviDXyOIk0AHTM8HBYKh3b0/F+DxoNj4ZdoZfCpQVdnZarqoMaHWnMLNVcyevytGsrXQEoIbubqWYNo7NRHzdc0zvT21fWVirj7g36iy6pxogfvgHp1xH1Turbz8QyyHnXeBJicpYUctbzApwzZ1HT+FPEXMAgUZetgeGMwt4G+DHiDT2Lu+PT21fjJCAfV16a/Wu1PqOkUHSTKYhWW6PhhHUlNtWzFnA7MbY+r64vkwdpfNB2JfWgWXAvkzd42K4lN9x7Wrg4kIKgXCb4mcW595MCPJ/cTfPAMQMFWwnqwde4w8HZYJFpQwcSMhjVz4B8p6ncSCN1X4klxoIH4BN2J6taBMj6lHkAOs8JJAmXq5xsQtrPIPIIp/HG6i21xMGcFgqDXSRF0xQg14d2uy6HgKE13LSvQe52oShF5Jx1R6avyL4thhXQZHfC94oZzuPUBKFYf1VvDaxIrtV6dNGSx7DO0i1p6CzBkuAmEqyWceQY7F9+U0ObYDzoa1iKao/cOD/v6Q9gHrrr1uCeOk8fST9MG23Ul0KmM3r+Wn6Hi6WAcL7gEeaykicvgjzkjSwFsAXIR81Zx4QJ6oosVyJkCcT+4xAldCcihqvTf94HHUPXYp3REIaR4dhpQF6+FK1H0i9i7Pvh8owu3lO4PT1iuqu+DkL2Bj9+kdfGAg2TXw03iNHyobxofLE2ibjsYDPgeEQlRMR7afXbSGQcnPjI2D+sdtmuQ771dbASUsDndU7t58jrrNGRzISvwioAlHs5FA+cBE5Ccznkd8NMV6BR6ksnKLPZnMUawRDU1MZ/ib3xCdkTblHKu4blNiylH5n213yM0zubEie0o4JhzcfAy3H5qh2l17uLooBNLaO+gzonTH2uF8PQu9EyH+pjGsACTMy4cHzsPdymUSXYJOMP3yTkXqvO/lpvt0cX5ekDEu9PUfBeZODkFuAjXCaGdi6ew4qxJ8PmFfwmPpkgQjQlWqomFY6UkjmcnAtJG75EVR+NpzGpP1Ef5qUUbfowrC3zcSLX3BxgWEgEx/v9cP8H8u1Mvt9/rMDYf6sjwU1xSOPBgzFEeJLMRVFtKo5QHsUYT8ZRLCah27599EuqoC9PYjYO6aoAMHB8X1OHwEAYouHfHB3nyb2B+SnZxM/vw/bCtORjLMSy5aZoEpvgdGvlJfNPFUu/p7Z4VVK1hiI0/UTuB3ZPq4ohEbm7Mntgc1evEtknaosgZSwnDC2BdMmibpeg48X8Ixl+/8+xXdbshQXUPPvx8jT3fkELivHSmqbhblfNFShWAyQnJ3WBU6SMYSIpTDmHjdLVAdlADdz9gCplZw6mTiHqDwIsxbm9ErGusiVpg2w8Q3khKV/R9Oj8PFeF43hmW/nSd99nZzhyjCX3QOZkkB6BsH4H866WGyv9E0hVAzPYah2tkRfQZMmP2rinfOeQalge0ovhduBjJs9a1GBwReerceify49ctOh5/65ATYuMsAkVltmvTLBk4oHpdl6i+p8DoNj4Fb2vhdFYer2JSEilEwPd5n5zNoGBXEjreg/wh2NFnNRaIUHSOXa4eJRwygZoX6vnWnqVdCRT1ARxeFrNBJ+tsdooMwqnYhE7zIxnD8pZH+P0Nu1wWxCPTADfNWmqx626IBJJq6NeapcGeOmbtXvl0TeWG0Y7OGGV4+EHTtNBIT5Wd0Bujl7inXgZgfXTM5efD3qDTJ54O9v3Bkv+tdIRlq1kXcVD0BEMirmFxglNPt5pedb1AnxuCYMChUykwsTIWqT23XDpvTiKEru1cTcEMeniB+HQDehxPXNmkotFdwUPnilB/u4Nx5Xc6l8J9jH1EgKZUUt8t8cyoZleDBEt8oibDmJRAoMKJ5Oe9CSWS5ZMEJvacsGVdXDWjp/Ype5x0p9PXB2PAwt2LRD3d+ftNgpuyvxlP8pB84oB1i73vAVpwyrmXW72hfW6Dzn9Jkj4++0VQ4d0KSx1AsDA4OtXXDo63/w+GD+zC7w5SJaxsmnlYRQ4dgdjA7tTl2KNLnpJ+mvkoDxtt1a4oPaX3EVqj96o9sRKBQqU7ZOiupeAIyLMD+Y3YwHx30XWHB5CQiw7q3mj1EDlP2eBsZbz79ayUMbyHQ7s8gu4Lgip1LiGJj7NQj905/+rgUYKAA5qdrlHKIknWmqfuR+PB8RdBkDg/NgnlT89G72h2NvySnj7UyBwD+mi/IWs1xWbxuVwUIVXun5cMqBtFbrccI+DILjsVQg6eeq0itiRfedn89CvyFtpkxaauEvSANuZmB1p8FGPbU94J9medwsZ9HkUYjmI7OH5HuxendLbxTaYrPuIfE2ffXFKhoNBUp33HsFAXmCV/Vxpq5AYgFoRr5Ay93ZLRlgaIPjhZjXZZChT+aE5iWAXMX0oSFQEtwjiuhQQItTQX5IYrKfKB+queTNplR1Hoflo5/I6aPPmACwQCE2jTOYo5Dz1cs7Sod0KTG/3kEDGk3kUaUCON19xSJCab3kNpWZhSWkO8l+SpW70Wn3g0ciOIJO5JXma6dbos6jyisuxXwUUhj2+1uGhcvuliKtWwsUTw4gi1c/diEEpZHoKoxTBeMDmhPhKTx7TXWRakV8imJR355DcIHkR9IREHxohP4TbyR5LtFU24umRPRmEYHbpe1LghyxPx7YgUHjNbbQFRQhh4KeU1EabXx8FS3JAxp2rwRDoeWkJgWRUSKw6gGP5U2PuO9V4ZuiKXGGzFQuRuf+tkSSsbBtRJKhCi3ENuLlXhPbjTKD4djXVnfXFds6Zb+1XiUrRfyayGxJq1+SYBEfbKlgjiSmk0orgTqzSS+DZ5rTqsJbttiNtp+KMqGE2AHGFw6jQqM5vD6vMptmXV9OAjq49Uf/Lx9Opam+Hn5O9p8qoBBAQixzQZ4eNVkO9sPzJAMyR1y4/RCQQ1s0pV5KAU5sKLw3tkcFbI/JqrjCsK4Mw+W8aod4lioYuawUiCyVWBE/qPaFi5bnkgpfu/ae47174rI1fqQoTbW0HrU6FAejq7ByM0V4zkZTg02/YJK2N7hUQRCeZ4BIgSEqgD8XsjzG6LIsSbuHoIdz/LhFzbNn1clci1NHWJ0/6/O8HJMdIpEZbqi1RrrFfoo/rI/7ufm2MPG5lUI0IYJ4MAiHRTSOFJ2oTverFHYXThkYFIoyFx6rMYFgaOKM4xNWdlOnIcKb/suptptgTOTdVIf4YgdaAjJnIAm4qNNHNQqqAzvi53GkyRCEoseUBrHohZsjUbkR8gfKtc/+Oa72lwxJ8Mq6HDfDATbfbJhzeIuFQJSiw1uZprHlzUf90WgqG76zO0eCB1WdPv1IT6sNxxh91GEL2YpgC97ikFHyoaH92ndwduqZ6IYjkg20DX33MWdoZk7QkcKUCgisIYslOaaLyvIIqRKWQj16jE1DlQWJJaPopWTJjXfixEjRJJo8g4++wuQjbq+WVYjsqCuNIQW3YjnxKe2M5ZKEqq+cX7ZVgnkbsU3RWIyXA1rxv4kGersYJjD//auldXGmcEbcfTeF16Y1708FB1HIfmWv6dSFi6oD4E+RIjCsEZ+kY7dKnwReJJw3xCjKvi3kGN42rvyhUlIz0Bp+fNSV5xwFiuBzG296e5s/oHoFtUyUplmPulIPl+e1CQIQVtjlzLzzzbV+D/OVQtYzo5ixtMi5BmHuG4N/uKfJk5UIREp7+12oZlKtPBomXSzAY0KgtbPzzZoHQxujnREUgBU+O/jKKhgxVhRPtbqyHiUaRwRpHv7pgRPyUrnE7fYkVblGmfTY28tFCvlILC04Tz3ivkNWVazA+OsYrxvRM/hiNn8Fc4bQBeUZABGx5S/xFf9Lbbmk298X7iFg2yeimvsQqqJ+hYbt6uq+Zf9jC+Jcwiccd61NKQtFvGWrgJiHB5lwi6fR8KzYS7EaEHf/ka9EC7H8D+WEa3TEACHBkNSj/cXxFeq4RllC+fUFm2xtstYLL2nos1DfzsC9vqDDdRVcPA3Ho95aEQHvExVThXPqym65llkKlfRXbPTRiDepdylHjmV9YTWAEjlD9DdQnCem7Aj/ml58On366392214B5zrmQz/9ySG2mFqEwjq5sFl5tYJPw5hNz8lyZPUTsr5E0F2C9VMPnZckWP7+mbwp/BiN7f4kf7vtGnZF2JGvjK/sDX1RtcFY5oPQnE4lIAYV49U3C9SP0LCY/9i/WIFK9ORjzM9kG/KGrAuwFmgdEpdLaiqQNpCTGZVuAO65afkY1h33hrqyLjZy92JK3/twdj9pafFcwfXONmPQWldPlMe7jlP24Js0v9m8bIJ9TgS2IuRvE9ZVRaCwSJYOtAfL5H/YS4FfzKWKbek+GFulheyKtDNlBtrdmr+KU+ibHTdalzFUmMfxw3f36x+3cQbJLItSilW9cuvZEMjKw987jykZRlsH/UI+HlKfo2tLwemBEeBFtmxF2xmItA/dAIfQ+rXnm88dqvXa+GapOYVt/2waFimXFx3TC2MUiOi5/Ml+3rj/YU6Ihx2hXgiDXFsUeQkRAD6wF3SCPi2flk7XwKAA4zboqynuELD312EJ88lmDEVOMa1W/K/a8tGylZRMrMoILyoMQzzbDJHNZrhH77L9qSC42HVmKiZ5S0016UTp83gOhCwz9XItK9fgXfK3F5d7nZCBUekoLxrutQaPHa16Rjsa0gTrzyjqTnmcIcrxg6X6dkKiucudc0DD5W4pJPf0vuDW8r5/uw24YfMuxFRpD2ovT2mFX79xH6Jf+MVdv2TYqR6/955QgVPe3JCD/WjAYcLA9tpXgFiEjge2J5ljeI/iUzg91KQuHkII4mmHZxC3XQORLAC6G7uFn5LOmlnXkjFdoO976moNTxElS8HdxWoPAkjjocDR136m2l+f5t6xaaNgdodOvTu0rievnhNAB79WNrVs6EsPgkgfahF9gSFzzAd+rJSraw5Mllit7vUP5YxA843lUpu6/5jAR0RvH4rRXkSg3nE+O5GFyfe+L0s5r3k05FyghSFnKo4TTgs07qj4nTLqOYj6qaW9knJTDkF5OFMYbmCP+8H16Ty482OjvERV6OFyw043L9w3hoJi408sR+SGo1WviXUu8d7qS+ehKjpKwxeCthsm2LBFSFeetx0x4AaKPxtp3CxdWqCsLrB1s/j5TAhc1jNZsXWl6tjo/WDoewxzg8T8NnhZ1niUwL/nhfygLanCnRwaFGDyLw+sfZhyZ1UtYTp8TYB6dE7R3VsKKH95CUxJ8u8N+9u2/9HUNKHW3x3w5GQrfOPafk2w5qZq8MaHT0ebeY3wIsp3rN9lrpIsW9c1ws3VNV+JwNz0Lo9+V7zZr6GD56We6gWVIvtmam5GPPkVAbr74r6SwhuL+TRXtW/0pgyX16VNl4/EAD50TnUPuwrW6OcUO2VlWXS0inq872kk7GUlW6o/ozFKq+Sip6LcTtSDfDrPTcCHhx75H8BeRon+KG2wRwzfDgWhALmiWOMO6h3pm1UCZEPEjScyk7tdLx6WrdA2N1QTPENvNnhCQjW6kl057/qv7IwRryHrZBCwVSbLLnFRiHdTwk8mlYixFt1slEcPD7FVht13HyqVeyD55HOXrh2ElAxJyinGeoFzwKA91zfrdLvDxJSjzmImfvTisreI25EDcVfGsmxLVbfU8PGe/7NmWWKjXcdTJ11jAlVIY/Bv/mcxg/Q10vCHwKG1GW/XbJq5nxDhyLqiorn7Wd7VEVL8UgVzpHMjQ+Z8DUgSukiVwWAKkeTlVVeZ7t1DGnCgJVIdBPZAEK5f8CDyDNo7tK4/5DBjdD5MPV86TaEhGsLVFPQSI68KlBYy84FievdU9gWh6XZrugvtCZmi9vfd6db6V7FmoEcRHnG36VZH8N4aZaldq9zZawt1uBFgxYYx+Gs/qW1jwANeFy+LCoymyM6zgG7j8bGzUyLhvrbJkTYAEdICEb4kMKusKT9V3eIwMLsjdUdgijMc+7iKrr+TxrVWG0U+W95SGrxnxGrE4eaJFfgvAjUM4SAy8UaRwE9j6ZQH5qYAWGtXByvDiLSDfOD0yFA3UCMKSyQ30fyy1mIRg4ZcgZHLNHWl+c9SeijOvbOJxoQy7lTN2r3Y8p6ovxvUY74aOYbuVezryqXA6U+fcp6wSV9X5/OZKP18tB56Ua0gMyxJI7XyNT7IrqN8GsB9rL/kP5KMrjXxgqKLDa+V5OCH6a5hmOWemMUsea9vQl9t5Oce76PrTyTv50ExOqngE3PHPfSL//AItPdB7kGnyTRhVUUFNdJJ2z7RtktZwgmQzhBG/G7QsjZmJfCE7k75EmdIKH7xlnmDrNM/XbTT6FzldcH/rcRGxlPrv4qDScqE7JSmQABJWqRT/TUcJSwoQM+1jvDigvrjjH8oeK2in1S+/yO1j8xAws/T5u0VnIvAPqaE1atNuN0cuRliLcH2j0nTL4JpcR7w9Qya0JoaHgsOiALLCCzRkl1UUESz+ze/gIXHGtDwgYrK6pCFKJ1webSDog4zTlPkgXZqxlQDiYMjhDpwTtBW2WxthWbov9dt2X9XFLFmcF+eEc1UaQ74gqZiZsdj63pH1qcv3Vy8JYciogIVKsJ8Yy3J9w/GhjWVSQAmrS0BPOWK+RKV+0lWqXgYMnIFwpcZVD7zPSp547i9HlflB8gVnSTGmmq1ClO081OW/UH11pEQMfkEdDFzjLC1Cdo/BdL3s7cXb8J++Hzz1rhOUVZFIPehRiZ8VYu6+7Er7j5PSZu9g/GBdmNzJmyCD9wiswj9BZw+T3iBrg81re36ihMLjoVLoWc+62a1U/7qVX5CpvTVF7rocSAKwv4cBVqZm7lLDS/qoXs4fMs/VQi6BtVbNA3uSzKpQfjH1o3x4LrvkOn40zhm6hjduDglzJUwA0POabgdXIndp9fzhOo23Pe+Rk9GSLX0d71Poqry8NQDTzNlsa+JTNG9+UrEf+ngxCjGEsDCc0bz+udVRyHQI1jmEO3S+IOQycEq7XwB6z3wfMfa73m8PVRp+iOgtZfeSBl01xn03vMaQJkyj7vnhGCklsCWVRUl4y+5oNUzQ63B2dbjDF3vikd/3RUMifPYnX5Glfuk2FsV/7RqjI9yKTbE8wJY+74p7qXO8+dIYgjtLD/N8TJtRh04N9tXJA4H59IkMmLElgvr0Q5OCeVfdAt+5hkh4pQgfRMHpL74XatLQpPiOyHRs/OdmHtBf8nOZcxVKzdGclIN16lE7kJ+pVMjspOI+5+TqLRO6m0ZpNXJoZRv9MPDRcAfJUtNZHyig/s2wwReakFgPPJwCQmu1I30/tcBbji+Na53i1W1N+BqoY7Zxo+U/M9XyJ4Ok2SSkBtoOrwuhAY3a03Eu6l8wFdIG1cN+e8hopTkiKF093KuH/BcB39rMiGDLn6XVhGKEaaT/vqb/lufuAdpGExevF1+J9itkFhCfymWr9vGb3BTK4j598zRH7+e+MU9maruZqb0pkGxRDRE1CD4Z8LV4vhgPidk5w2Bq816g3nHw1//j3JStz7NR9HIWELO8TMn3QrP/zZp//+Dv9p429/ogv+GATR+n/UdF+ns9xNkXZQJXY4t9jMkJNUFygAtzndXwjss+yWH9HAnLQQfhAskdZS2l01HLWv7L7us5uTH409pqitvfSOQg/c+Zt7k879P3K9+WV68n7+3cZfuRd/dDPP/03rn+d+/nBvWfgDlt8+LzjqJ/vx3CnNOwiXhho778C96iD+1TBvRZYeP+EH81LE0vVwOOrmCLB3iKzI1x+vJEsrPH4uF0UB4TJ4X3uDfOCo3PYpYe0MF4bouh0DQ/l43fxUF7Y+dpWuvTSffB0yO2UQUETI/LwCZE3BvnevJ7c9zUlY3H58xzke6DNFDQG8n0WtDN4LAYN4nogKav1ezOfK/z+t6tsCTp+dhx4ymjWuCJk1dEUifDP+HyS4iP/Vg9B2jTo9L4NbiBuDS4nuuHW6H+JDQn2JtqRKGkEQPEYE7uzazXIkcxIAqUq1esasZBETlEZY7y7Jo+RoV/IsjY9eIMkUvr42Hc0xqtsavZvhz1OLwSxMOTuqzlhb0WbdOwBH9EYiyBjatz40bUxTHbiWxqJ0uma19qhPruvcWJlbiSSH48OLDDpaHPszvyct41ZfTu10+vjox6kOqK6v0K/gEPphEvMl/vwSv+A4Hhm36JSP9IXTyCZDm4kKsqD5ay8b1Sad/vaiyO5N/sDfEV6Z4q95E+yfjxpqBoBETW2C7xl4pIO2bDODDFurUPwE7EWC2Uplq+AHmBHvir2PSgkR12/Ry65O0aZtQPeXi9mTlF/Wj5GQ+vFkYyhXsLTjrBSP9hwk4GPqDP5rBn5/l8b0mLRAvRSzXHc293bs3s8EsdE3m2exxidWVB4joHR+S+dz5/W+v00K3TqN14CDBth8eWcsTbiwXPsygHdGid0PEdy6HHm2v/IUuV5RVapYmzGsX90mpnIdNGcOOq64Dbc5GUbYpD9M7S+6cLY//QmjxFLP5cuTFRm3vA5rkFZroFnO3bjHF35uU3s8mvL7Tp9nyTc4mymTJ5sLIp7umSnGkO23faehtz3mmTS7fbVx5rP7x3HXIjRNeq/A3xCs9JNB08c9S9BF2O3bOur0ItslFxXgRPdaapBIi4dRpKGxVz7ir69t/bc9qTxjvtOyGOfiLGDhR4fYywHv1WdOplxIV87TpLBy3Wc0QP0P9s4G7FBNOdITS/tep3o3h1TEa5XDDii7fWtqRzUEReP2fbxz7bHWWJdbIOxOUJZtItNZpTFRfj6vm9sYjRxQVO+WTdiOhdPeTJ+8YirPvoeL88l5iLYOHd3b/Imkq+1ZN1El3UikhftuteEYxf1Wujof8Pr4ICTu5ezZyZ4tHQMxlzUHLYO2VMOoNMGL/20S5i2o2obfk+8qqdR7xzbRDbgU0lnuIgz4LelQ5XS7xbLuSQtNS95v3ZUOdaUx/Qd8qxCt6xf2E62yb/HukLO6RyorV8KgYl5YNc75y+KvefrxY+lc/64y9kvWP0a0bDz/rojq+RWjO06WeruWqNFU7r3HPIcLWRql8ICZsz2Ls/qOm/CLn6++X+Qf7mGspYCrZod/lpl6Rw4xN/yuq8gqV4B6aHk1hVE1SfILxWu5gvXqbfARYQpspcxKp1F/c8XOPzkZvmoSw+vEqBLdrq1fr3wAPv5NnM9i8F+jdAuxkP5Z71c6uhK3enlnGymr7UsWZKC12qgUiG8XXGQ9mxnqz4GSIlybF9eXmbqj2sHX+a1jf0gRoONHRdRSrIq03Ty89eQ1GbV/Bk+du4+V15zls+vvERvZ4E7ZbnxWTVjDjb4o/k8jlw44pTIrUGxxuJvBeO+heuhOjpFsO6lVJ/aXnJDa/bM0Ql1cLbXE/Pbv3EZ3vj3iVrB5irjupZTzlnv677NrI9UNYNqbPgp/HZXS+lJmk87wec+7YOxTDo2aw2l3NfDr34VNlvqWJBknuK7oSlZ6/T10zuOoPZOeoIk81N+sL843WJ2Q4Z0fZ3scsqC/JV2fuhWi1jGURSKZV637lf53Xnnx16/vKEXY89aVJ0fv91jGdfG+G4+sniwHes4hS+udOr4RfhFhG/F5gUG35QaU+McuLmclb5ZWmR+sG5V6nf+PxYzlrnFGxpZaK8eqqVo0NfmAWoGfXDiT/FnUbWvzGDOTr8aktOZWg4BYvz5YH12ZbfCcGtNk+dDAZNGWvHov+PIOnY9Prjg8h/wLRrT69suaMVZ5bNuK00lSVpnqSX1NON/81FoP92rYndionwgOiA8WMf4vc8l15KqEEG4yAm2+WAN5Brfu1sq9suWYqgoajgOYt/JCk1gC8wPkK+XKCtRX6TAtgvrnuBgNRmn6I8lVDipOVB9kX6Oxkp4ZKyd1M6Gj8/v2U7k+YQBL95Kb9PQENucJb0JlW3b5tObN7m/Z1j1ev388d7o15zgXsI9CikAGAViR6lkJv7nb4Ak40M2G8TJ447kN+pvfHiOFjSUSP6PM+QfbAywKJCBaxSVxpizHseZUyUBhq59vFwrkyGoRiHbo0apweEZeSLuNiQ+HAekOnarFg00dZNXaPeoHPTRR0FmEyqYExOVaaaO8c0uFUh7U4e/UxdBmthlBDgg257Q33j1hA7HTxSeTTSuVnPZbgW1nodwmG16aKBDKxEetv7D9OjO0JhrbJTnoe+kcGoDJazFSO8/fUN9Jy/g4XK5PUkw2dgPDGpJqBfhe7GA+cjzfE/EGsMM+FV9nj9IAhrSfT/J3QE5TEIYyk5UjsI6ZZcCPr6A8FZUF4g9nnpVmjX90MLSQysIPD0nFzqwCcSJmIb5mYv2Cmk+C1MDFkZQyCBq4c/Yai9LJ6xYkGS/x2s5/frIW2vmG2Wrv0APpCdgCA9snFvfpe8uc0OwdRs4G9973PGEBnQB5qKrCQ6m6X/H7NInZ7y/1674/ZXOVp7OeuCRk8JFS516VHrnH1HkIUIlTIljjHaQtEtkJtosYul77cVwjk3gW1Ajaa6zWeyHGLlpk3VHE2VFzT2yI/EvlGUSz2H9zYE1s4nsKMtMqNyKNtL/59CpFJki5Fou6VXGm8vWATEPwrUVOLvoA8jLuwOzVBCgHB2Cr5V6OwEWtJEKokJkfc87h+sNHTvMb0KVTp5284QTPupoWvQVUwUeogZR3kBMESYo0mfukewRVPKh5+rzLQb7HKjFFIgWhj1w3yN/qCNoPI8XFiUgBNT1hCHBsAz8L7Oyt8wQWUFj92ONn/APyJFg8hzueqoJdNj57ROrFbffuS/XxrSXLTRgj5uxZjpgQYceeMc2wJrahReSKpm3QjHfqExTLAB2ipVumE8pqcZv8LYXQiPHHsgb5BMW8zM5pvQit+mQx8XGaVDcfVbLyMTlY8xcfmm/RSAT/H09UQol5gIz7rESDmnrQ4bURIB4iRXMDQwxgex1GgtDxKp2HayIkR+E/aDmCttNm2C6lytWdfOVzD6X2SpDWjQDlMRvAp1symWv4my1bPCD+E1EmGnMGWhNwmycJnDV2WrQNxO45ukEb08AAffizYKVULp15I4vbNK5DzWwCSUADfmKhfGSUqii1L2UsE8rB7mLuHuUJZOx4+WiizHBJ/hwboaBzhpNOVvgFTf5cJsHef7L1HCI9dOUUbb+YxUJWn6dYOLz+THi91kzY5dtO5c+grX7v0jEbsuoOGnoIreDIg/sFMyG+TyCLIcAWd1IZ1UNFxE8Uie13ucm40U2fcxC0u3WLvLOxwu+F7MWUsHsdtFQZ7W+nlfCASiAKyh8rnP3EyDByvtJb6Kax6/HkLzT9SyEyTMVM1zPtM0MJY14DmsWh4MgD15Ea9Hd00AdkTZ0EiG5NAGuIBzQJJ0JR0na+OB7lQA6UKxMfihIQ7GCCnVz694QvykWXTxpS2soDu+smru1UdIxSvAszBFD1c8c6ZOobA8bJiJIvuycgIXBQIXWwhyTgZDQxJTRXgEwRNAawGSXO0a1DKjdihLVNp/taE/xYhsgwe+VpKEEB4LlraQyE84gEihxCnbfoyOuJIEXy2FIYw+JjRusybKlU2g/vhTSGTydvCvXhYBdtAXtS2v7LkHtmXh/8fly1do8FI/D0f8UbzVb5h+KRhMGSAmR2mhi0YG/uj7wgxcfzCrMvdjitUIpXDX8ae2JcF/36qUWIMwN6JsjaRGNj+jEteGDcFyTUb8X/NHSucKMJp7pduxtD6KuxVlyxxwaeiC1FbGBESO84lbyrAugYxdl+2N8/6AgWpo/IeoAOcsG35IA/b3AuSyoa55L7llBLlaWlEWvuCFd8f8NfcTUgzJv6CbB+6ohWwodlk9nGWFpBAOaz5uEW5xBvmjnHFeDsb0mXwayj3mdYq5gxxNf3H3/tnCgHwjSrpSgVxLmiTtuszdRUFIsn6LiMPjL808vL1uQhDbM7aA43mISXReqjSskynIRcHCJ9qeFopJfx9tqyUoGbSwJex/0aDE3plBPGtNBYgWbdLom3+Q/bjdizR2/AS/c/dH/d3G7pyl1qDXgtOFtEqidwLqxPYtrNEveasWq3vPUUtqTeu8gpov4bdOQRI2kneFvRNMrShyVeEupK1PoLDPMSfWMIJcs267mGB8X9CehQCF0gIyhpP10mbyM7lwW1e6TGvHBV1sg/UyTghHPGRqMyaebC6pbB1WKNCQtlai1GGvmq9zUKaUzLaXsXEBYtHxmFbEZ2kJhR164LhWW2Tlp1dhsGE7ZgIWRBOx3Zcu2DxgH+G83WTPceKG0TgQKKiiNNOlWgvqNEbnrk6fVD+AqRam2OguZb0YWSTX88N+i/ELSxbaUUpPx4vJUzYg/WonSeA8xUK6u7DPHgpqWpEe6D4cXg5uK9FIYVba47V/nb+wyOtk+zG8RrS4EA0ouwa04iByRLSvoJA2FzaobbZtXnq8GdbfqEp5I2dpfpj59TCVif6+E75p665faiX8gS213RqBxTZqfHP46nF6NSenOneuT+vgbLUbdTH2/t0REFXZJOEB6DHvx6N6g9956CYrY/AYcm9gELJXYkrSi+0F0geKDZgOCIYkLU/+GOW5aGj8mvLFgtFH5+XC8hvAE3CvHRfl4ofM/Qwk4x2A+R+nyc9gNu/9Tem7XW4XRnyRymf52z09cTOdr+PG6+P/Vb4QiXlwauc5WB1z3o+IJjlbxI8MyWtSzT+k4sKVbhF3xa+vDts3NxXa87iiu+xRH9cAprnOL2h6vV54iQRXuOAj1s8nLFK8gZ70ThIQcWdF19/2xaJmT0efrkNDkWbpAQPdo92Z8+Hn/aLjbOzB9AI/k12fPs9HhUNDJ1u6ax2VxD3R6PywN7BrLJ26z6s3QoMp76qzzwetrDABKSGkfW5PwS1GvYNUbK6uRqxfyVGNyFB0E+OugMM8kKwmJmupuRWO8XkXXXQECyRVw9UyIrtCtcc4oNqXqr7AURBmKn6Khz3eBN96LwIJrAGP9mr/59uTOSx631suyT+QujDd4beUFpZ0kJEEnjlP+X/Kr2kCKhnENTg4BsMTOmMqlj2WMFLRUlVG0fzdCBgUta9odrJfpVdFomTi6ak0tFjXTcdqqvWBAzjY6hVrH9sbt3Z9gn+AVDpTcQImefbB4edirjzrsNievve4ZT4EUZWV3TxEsIW+9MT/RJoKfZZYSRGfC1CwPG/9rdMOM8qR/LUYvw5f/emUSoD7YSFuOoqchdUg2UePd1eCtFSKgxLSZ764oy4lvRCIH6bowPxZWwxNFctksLeil47pfevcBipkkBIc4ngZG+kxGZ71a72KQ7VaZ6MZOZkQJZXM6kb/Ac0/XkJx8dvyfJcWbI3zONEaEPIW8GbkYjsZcwy+eMoKrYjDmvEEixHzkCSCRPRzhOfJZuLdcbx19EL23MA8rnjTZZ787FGMnkqnpuzB5/90w1gtUSRaWcb0eta8198VEeZMUSfIhyuc4/nywFQ9uqn7jdqXh+5wwv+RK9XouNPbYdoEelNGo34KyySwigsrfCe0v/PlWPvQvQg8R0KgHO18mTVThhQrlbEQ0Kp/JxPdjHyR7E1QPw/ut0r+HDDG7BwZFm9IqEUZRpv2WpzlMkOemeLcAt5CsrzskLGaVOAxyySzZV/D2EY7ydNZMf8e8VhHcKGHAWNszf1EOq8fNstijMY4JXyATwTdncFFqcNDfDo+mWFvxJJpc4sEZtjXyBdoFcxbUmniCoKq5jydUHNjYJxMqN1KzYV62MugcELVhS3Bnd+TLLOh7dws/zSXWzxEb4Nj4aFun5x4kDWLK5TUF/yCXB/cZYvI9kPgVsG2jShtXkxfgT+xzjJofXqPEnIXIQ1lnIdmVzBOM90EXvJUW6a0nZ/7XjJGl8ToO3H/fdxnxmTNKBZxnkpXLVgLXCZywGT3YyS75w/PAH5I/jMuRspej8xZObU9kREbRA+kqjmKRFaKGWAmFQspC+QLbKPf0RaK3OXvBSWqo46p70ws/eZpu6jCtZUgQy6r4tHMPUdAgWGGUYNbuv/1a6K+MVFsd3T183+T8capSo6m0+Sh57fEeG/95dykGJBQMj09DSW2bY0mUonDy9a8trLnnL5B5LW3Nl8rJZNysO8Zb+80zXxqUGFpud3Qzwb7bf+8mq6x0TAnJU9pDQR9YQmZhlna2xuxJt0aCO/f1SU8gblOrbIyMsxTlVUW69VJPzYU2HlRXcqE2lLLxnObZuz2tT9CivfTAUYfmzJlt/lOPgsR6VN64/xQd4Jlk/RV7UKVv2Gx/AWsmTAuCWKhdwC+4HmKEKYZh2Xis4KsUR1BeObs1c13wqFRnocdmuheaTV30gvVXZcouzHKK5zwrN52jXJEuX6dGx3BCpV/++4f3hyaW/cQJLFKqasjsMuO3B3WlMq2gyYfdK1e7L2pO/tRye2mwzwZPfdUMrl5wdLqdd2Kv/wVtnpyWYhd49L6rsOV+8HXPrWH2Kup89l2tz6bf80iYSd+V4LROSOHeamvexR524q4r43rTmtFzQvArpvWfLYFZrbFspBsXNUqqenjxNNsFXatZvlIhk7teUPfK+YL32F8McTnjv0BZNppb+vshoCrtLXjIWq3EJXpVXIlG6ZNL0dh6qEm2WMwDjD3LfOfkGh1/czYc/0qhiD2ozNnH4882MVVt3JbVFkbwowNCO3KL5IoYW5wlVeGCViOuv1svZx7FbzxKzA4zGqBlRRaRWCobXaVq4yYCWbZf8eiJwt3OY+MFiSJengcFP2t0JMfzOiJ7cECvpx7neg1Rc5x+7myPJOXt2FohVRyXtD+/rDoTOyGYInJelZMjolecVHUhUNqvdZWg2J2t0jPmiLFeRD/8fOT4o+NGILb+TufCo9ceBBm3JLVn+MO2675n7qiEX/6W+188cYg3Zn5NSTjgOKfWFSAANa6raCxSoVU851oJLY11WIoYK0du0ec5E4tCnAPoKh71riTsjVIp3gKvBbEYQiNYrmH22oLQWA2AdwMnID6PX9b58dR2QKo4qag1D1Z+L/FwEKTR7osOZPWECPJIHQqPUsM5i/CH5YupVPfFA5pHUBcsesh8eO5YhyWnaVRPZn/BmdXVumZWPxMP5e28zm2uqHgFoT9CymHYNNrzrrjlXZM06HnzDxYNlI5b/QosxLmmrqDFqmogQdqk0WLkUceoAvQxHgkIyvWU69BPFr24VB6+lx75Rna6dGtrmOxDnvBojvi1/4dHjVeg8owofPe1cOnxU1ioh016s/Vudv9mhV9f35At+Sh28h1bpp8xhr09+vf47Elx3Ms6hyp6QvB3t0vnLbOhwo660cp7K0vvepabK7YJfxEWWfrC2YzJfYOjygPwfwd/1amTqa0hZ5ueebhWYVMubRTwIjj+0Oq0ohU3zfRfuL8gt59XsHdwKtxTQQ4Y2qz6gisxnm2UdlmpEkgOsZz7iEk6QOt8BuPwr+NR01LTqXmJo1C76o1N274twJvl+I069TiLpenK/miRxhyY8jvYV6W1WuSwhH9q7kuwnJMtm7IWcqs7HsnyHSqWXLSpYtZGaR1V3t0gauninFPZGtWskF65rtti48UV9uV9KM8kfDYs0pgB00S+TlzTXV6P8mxq15b9En8sz3jWSszcifZa/NuufPNnNTb031pptt0+sRSH/7UG8pzbsgtt3OG3ut7B9JzDMt2mTZuyRNIV8D54TuTrpNcHtgmMlYJeiY9XS83NYJicjRjtJSf9BZLsQv629QdDsKQhTK5CnXhpk7vMNkHzPhm0ExW/VCGApHfPyBagtZQTQmPHx7g5IXXsrQDPzIVhv2LB6Ih138iSDww1JNHrDvzUxvp73MsQBVhW8EbrReaVUcLB1R3PUXyaYG4HpJUcLVxMgDxcPkVRQpL7VTAGabDzbKcvg12t5P8TSGQkrj/gOrpnbiDHwluA73xbXts/L7u468cRWSWRtgTwlQnA47EKg0OiZDgFxAKQQUcsbGomITgeXUAAyKe03eA7Mp4gnyKQmm0LXJtEk6ddksMJCuxDmmHzmVhO+XaN2A54MIh3niw5CF7PwiXFZrnA8wOdeHLvvhdoqIDG9PDI7UnWWHq526T8y6ixJPhkuVKZnoUruOpUgOOp3iIKBjk+yi1vHo5cItHXb1PIKzGaZlRS0g5d3MV2pD8FQdGYLZ73aae/eEIUePMc4NFz8pIUfLCrrF4jVWH5gQneN3S8vANBmUXrEcKGn6hIUN95y1vpsvLwbGpzV9L0ZKTan6TDXM05236uLJcIEMKVAxKNT0K8WljuwNny3BNQRfzovA85beI9zr1AGNYnYCVkR1aGngWURUrgqR+gRrQhxW81l3CHevjvGEPzPMTxdsIfB9dfGRbZU0cg/1mcubtECX4tvaedmNAvTxCJtc2QaoUalGfENCGK7IS/O8CRpdOVca8EWCRwv2sSWE8CJPW5PCugjCXPd3h6U60cPD+bdhtXZuYB6stcoveE7Sm5MM2yvfUHXFSW7KzLmi7/EeEWL0wqcOH9MOSKjhCHHmw+JGLcYE/7SBZQCRggox0ZZTAxrlzNNXYXL5fNIjkdT4YMqVUz6p8YDt049v4OXGdg3qTrtLBUXOZf7ahPlZAY/O+7Sp0bvGSHdyQ8B1LOsplqMb9Se8VAE7gIdSZvxbRSrfl+Lk5Qaqi5QJceqjitdErcHXg/3MryljPSIAMaaloFm1cVwBJ8DNmkDqoGROSHFetrgjQ5CahuKkdH5pRPigMrgTtlFI8ufJPJSUlGgTjbBSvpRc0zypiUn6U5KZqcRoyrtzhmJ7/caeZkmVRwJQeLOG8LY6vP5ChpKhc8Js0El+n6FXqbx9ItdtLtYP92kKfaTLtCi8StLZdENJa9Ex1nOoz1kQ7qxoiZFKRyLf4O4CHRT0T/0W9F8epNKVoeyxUXhy3sQMMsJjQJEyMOjmOhMFgOmmlscV4eFi1CldU92yjwleirEKPW3bPAuEhRZV7JsKV3Lr5cETAiFuX5Nw5UlF7d2HZ96Bh0sgFIL5KGaKSoVYVlvdKpZJVP5+NZ7xDEkQhmDgsDKciazJCXJ6ZN2B3FY2f6VZyGl/t4aunGIAk/BHaS+i+SpdRfnB/OktOvyjinWNfM9Ksr6WwtCa1hCmeRI6icpFM4o8quCLsikU0tMoZI/9EqXRMpKGaWzofl4nQuVQm17d5fU5qXCQeCDqVaL9XJ9qJ08n3G3EFZS28SHEb3cdRBdtO0YcTzil3QknNKEe/smQ1fTb0XbpyNB5xAeuIlf+5KWlEY0DqJbsnzJlQxJPOVyHiKMx5Xu9FcEv1Fbg6Fhm4t+Jyy5JC1W3YO8dYLsO0PXPbxodBgttTbH3rt9Cp1lJIk2r3O1Zqu94eRbnIz2f50lWolYzuKsj4PMok4abHLO8NAC884hiXx5Fy5pWKO0bWL7uEGXaJCtznhP67SlQ4xjWIfgq6EpZ28QMtuZK7JC0RGbl9nA4XtFLug/NLMoH1pGt9IonAJqcEDLyH6TDROcbsmGPaGIxMo41IUAnQVPMPGByp4mOmh9ZQMkBAcksUK55LsZj7E5z5XuZoyWCKu6nHmDq22xI/9Z8YdxJy4kWpD16jLVrpwGLWfyOD0Wd+cBzFBxVaGv7S5k9qwh/5t/LQEXsRqI3Q9Rm3QIoaZW9GlsDaKOUyykyWuhNOprSEi0s1G4rgoiX1V743EELti+pJu5og6X0g6oTynUqlhH9k6ezyRi05NGZHz0nvp3HOJr7ebrAUFrDjbkFBObEvdQWkkUbL0pEvMU46X58vF9j9F3j6kpyetNUBItrEubW9ZvMPM4qNqLlsSBJqOH3XbNwv/cXDXNxN8iFLzUhteisYY+RlHYOuP29/Cb+L+xv+35Rv7xudnZ6ohK4cMPfCG8KI7dNmjNk/H4e84pOxn/sZHK9psfvj8ncA8qJz7O8xqbxESDivGJOZzF7o5PJLQ7g34qAWoyuA+x3btU98LT6ZyGyceIXjrqob2CAVql4VOTQPUQYvHV/g4zAuCZGvYQBtf0wmd5lilrvuEn1BXLny01B4h4SMDlYsnNpm9d7m9h578ufpef9Z4WplqWQvqo52fyUA7J24eZD5av6SyGIV9kpmHNqyvdfzcpEMw97BvknV2fq+MFHun9BT3Lsf8pbzvisWiIQvYkng+8Vxk1V+dli1u56kY50LRjaPdotvT5BwqtwyF+emo/z9J3yVUVGfKrxQtJMOAQWoQii/4dp9wgybSa5mkucmRLtEQZ/pz0tL/NVcgWAd95nEQ3Tg6tNbuyn3Iepz65L3huMUUBntllWuu4DbtOFSMSbpILV4fy6wlM0SOvi6CpLh81c1LreIvKd61uEWBcDw1lUBUW1I0Z+m/PaRlX+PQ/oxg0Ye6KUiIiTF4ADNk59Ydpt5/rkxmq9tV5Kcp/eQLUVVmBzQNVuytQCP6Ezd0G8eLxWyHpmZWJ3bAzkWTtg4lZlw42SQezEmiUPaJUuR/qklVA/87S4ArFCpALdY3QRdUw3G3XbWUp6aq9z0zUizcPa7351p9JXOZyfdZBFnqt90VzQndXB/mwf8LC9STj5kenVpNuqOQQP3mIRJj7eV21FxG8VAxKrEn3c+XfmZ800EPb9/5lIlijscUbB6da0RQaMook0zug1G0tKi/JBC4rw7/D3m4ARzAkzMcVrDcT2SyFtUdWAsFlsPDFqV3N+EjyXaoEePwroaZCiLqEzb8MW+PNE9TmTC01EzWli51PzZvUqkmyuROU+V6ik+Le/9qT6nwzUzf9tP68tYei0YaDGx6kAd7jn1cKqOCuYbiELH9zYqcc4MnRJjkeGiqaGwLImhyeKs+xKJMBlOJ05ow9gGCKZ1VpnMKoSCTbMS+X+23y042zOb5MtcY/6oBeAo1Vy89OTyhpavFP78jXCcFH0t7Gx24hMEOm2gsEfGabVpQgvFqbQKMsknFRRmuPHcZu0Su/WMFphZvB2r/EGbG72rpGGho3h+Msz0uGzJ7hNK2uqQiE1qmn0zgacKYYZBCqsxV+sjbpoVdSilW/b94n2xNb648VmNIoizqEWhBnsen+d0kbCPmRItfWqSBeOd9Wne3c6bcd6uvXOJ6WdiSsuXq0ndhqrQ4QoWUjCjYtZ0EAhnSOP1m44xkf0O7jXghrzSJWxP4a/t72jU29Vu2rvu4n7HfHkkmQOMGSS+NPeLGO5I73mC2B7+lMiBQQZRM9/9liLIfowupUFAbPBbR+lxDM6M8Ptgh1paJq5Rvs7yEuLQv/7d1oU2woFSb3FMPWQOKMuCuJ7pDDjpIclus5TeEoMBy2YdVB4fxmesaCeMNsEgTHKS5WDSGyNUOoEpcC2OFWtIRf0w27ck34/DjxRTVIcc9+kqZE6iMSiVDsiKdP/Xz5XfEhm/sBhO50p1rvJDlkyyxuJ9SPgs7YeUJBjXdeAkE+P9OQJm6SZnn1svcduI78dYmbkE2mtziPrcjVisXG78spLvbZaSFx/Rks9zP4LKn0Cdz/3JsetkT06A8f/yCgMO6Mb1Hme0JJ7b2wZz1qleqTuKBGokhPVUZ0dVu+tnQYNEY1fmkZSz6+EGZ5EzL7657mreZGR3jUfaEk458PDniBzsSmBKhDRzfXameryJv9/D5m6HIqZ0R+ouCE54Dzp4IJuuD1e4Dc5i+PpSORJfG23uVgqixAMDvchMR0nZdH5brclYwRoJRWv/rlxGRI5ffD5NPGmIDt7vDE1434pYdVZIFh89Bs94HGGJbTwrN8T6lh1HZFTOB4lWzWj6EVqxSMvC0/ljWBQ3F2kc/mO2b6tWonT2JEqEwFts8rz2h+oWNds9ceR2cb7zZvJTDppHaEhK5avWqsseWa2Dt5BBhabdWSktS80oMQrL4TvAM9b5HMmyDnO+OkkbMXfUJG7eXqTIG6lqSOEbqVR+qYdP7uWb57WEJqzyh411GAVsDinPs7KvUeXItlcMdOUWzXBH6zscymV1LLVCtc8IePojzXHF9m5b5zGwBRdzcyUJkiu938ApmAayRdJrX1PmVguWUvt2ThQ62czItTyWJMW2An/hdDfMK7SiFQlGIdAbltHz3ycoh7j9V7GxNWBpbtcSdqm4XxRwTawc3cbZ+xfSv9qQfEkDKfZTwCkqWGI/ur250ItXlMlh6vUNWEYIg9A3GzbgmbqvTN8js2YMo87CU5y6nZ4dbJLDQJj9fc7yM7tZzJDZFtqOcU8+mZjYlq4VmifI23iHb1ZoT9E+kT2dolnP1AfiOkt7PQCSykBiXy5mv637IegWSKj9IKrYZf4Lu9+I7ub+mkRdlvYzehh/jaJ9n7HUH5b2IbgeNdkY7wx1yVzxS7pbvky6+nmVUtRllEFfweUQ0/nG017WoUYSxs+j2B4FV/F62EtHlMWZXYrjGHpthnNb1x66LKZ0Qe92INWHdfR/vqp02wMS8r1G4dJqHok8KmQ7947G13a4YXbsGgHcBvRuVu1eAi4/A5+ZixmdSXM73LupB/LH7O9yxLTVXJTyBbI1S49TIROrfVCOb/czZ9pM4JsZx8kUz8dQGv7gUWKxXvTH7QM/3J2OuXXgciUhqY+cgtaOliQQVOYthBLV3xpESZT3rmfEYNZxmpBbb24CRao86prn+i9TNOh8VxRJGXJfXHATJHs1T5txgc/opYrY8XjlGQQbRcoxIBcnVsMjmU1ymmIUL4dviJXndMAJ0Yet+c7O52/p98ytlmAsGBaTAmMhimAnvp1TWNGM9BpuitGj+t810CU2UhorrjPKGtThVC8WaXw04WFnT5fTjqmPyrQ0tN3CkLsctVy2xr0ZWgiWVZ1OrlFjjxJYsOiZv2cAoOvE+7sY0I/TwWcZqMoyIKNOftwP7w++Rfg67ljfovKYa50if3fzE/8aPYVey/Nq35+nH2sLPh/fP5TsylSKGOZ4k69d2PnH43+kq++sRXHQqGArWdwhx+hpwQC6JgT2uxehYU4Zbw7oNb6/HLikPyJROGK2ouyr+vzseESp9G50T4AyFrSqOQ0rroCYP4sMDFBrHn342EyZTMlSyk47rHSq89Y9/nI3zG5lX16Z5lxphguLOcZUndL8wNcrkyjH82jqg8Bo8OYkynrxZvbFno5lUS3OPr8Ko3mX9NoRPdYOKKjD07bvgFgpZ/RF+YzkWvJ/Hs/tUbfeGzGWLxNAjfDzHHMVSDwB5SabQLsIZHiBp43FjGkaienYoDd18hu2BGwOK7U3o70K/WY/kuuKdmdrykIBUdG2mvE91L1JtTbh20mOLbk1vCAamu7utlXeGU2ooVikbU/actcgmsC1FKk2qmj3GWeIWbj4tGIxE7BLcBWUvvcnd/lYxsMV4F917fWeFB/XbINN3qGvIyTpCalz1lVewdIGqeAS/gB8Mi+sA+BqDiX3VGD2eUunTRbSY+AuDy4E3Qx3hAhwnSXX+B0zuj3eQ1miS8Vux2z/l6/BkWtjKGU72aJkOCWhGcSf3+kFkkB15vGOsQrSdFr6qTj0gBYiOlnBO41170gOWHSUoBVRU2JjwppYdhIFDfu7tIRHccSNM5KZOFDPz0TGMAjzzEpeLwTWp+kn201kU6NjbiMQJx83+LX1e1tZ10kuChJZ/XBUQ1dwaBHjTDJDqOympEk8X2M3VtVw21JksChA8w1tTefO3RJ1FMbqZ01bHHkudDB/OhLfe7P5GOHaI28ZXKTMuqo0hLWQ4HabBsGG7NbP1RiXtETz074er6w/OerJWEqjmkq2y51q1BVI+JUudnVa3ogBpzdhFE7fC7kybrAt2Z6RqDjATAUEYeYK45WMupBKQRtQlU+uNsjnzj6ZmGrezA+ASrWxQ6LMkHRXqXwNq7ftv28dUx/ZSJciDXP2SWJsWaN0FjPX9Yko6LobZ7aYW/IdUktI9apTLyHS8DyWPyuoZyxN1TK/vtfxk3HwWh6JczZC8Ftn0bIJay2g+n5wd7lm9rEsKO+svqVmi+c1j88hSCxbzrg4+HEP0Nt1/B6YW1XVm09T1CpAKjc9n18hjqsaFGdfyva1ZG0Xu3ip6N6JGpyTSqY5h4BOlpLPaOnyw45PdXTN+DtAKg7DLrLFTnWusoSBHk3s0d7YouJHq85/R09Tfc37ENXZF48eAYLnq9GLioNcwDZrC6FW6godB8JnqYUPvn0pWLfQz0lM0Yy8Mybgn84Ds3Q9bDP10bLyOV+qzxa4Rd9Dhu7cju8mMaONXK3UqmBQ9qIg7etIwEqM/kECk/Dzja4Bs1xR+Q/tCbc8IKrSGsTdJJ0vge7IG20W687uVmK6icWQ6cD3lwFzgNMGtFvO5qyJeKflGLAAcQZOrkxVwy3cWvqlGpvjmf9Qe6Ap20MPbV92DPV0OhFM4kz8Yr0ffC2zLWSQ1kqY6QdQrttR3kh1YLtQd1kCEv5hVoPIRWl5ERcUTttBIrWp6Xs5Ehh5OUUwI5aEBvuiDmUoENmnVw1FohCrbRp1A1E+XSlWVOTi7ADW+5Ohb9z1vK4qx5R5lPdGCPBJZ00mC+Ssp8VUbgpGAvXWMuWQQRbCqI6Rr2jtxZxtfP7W/8onz+yz0Gs76LaT5HX9ecyiZCB/ZR/gFtMxPsDwohoeCRtiuLxE1GM1vUEUgBv86+eehL58/P56QFGQ/MqOe/vC76L63jzmeax4exd/OKTUvkXg+fOJUHych9xt/9goJMrapSgvXrj8+8vk/N80f22Sewj6cyGqt1B6mztoeklVHHraouhvHJaG/OuBz6DHKMpFmQULU1bRWlyYE0RPXYYkUycIemN7TLtgNCJX6BqdyxDKkegO7nJK5xQ7OVYDZTMf9bVHidtk6DQX9Et+V9M7esgbsYBdEeUpsB0Xvw2kd9+rI7V+m47u+O/tq7mw7262HU1WlS9uFzsV6JxIHNmUCy0QS9e077JGRFbG65z3/dOKB/Zk+yDdKpUmdXjn/aS3N5nv4fK7bMHHmPlHd4E2+iTbV5rpzScRnxk6KARuDTJ8Q1LpK2mP8gj1EbuJ9RIyY+EWK4hCiIDBAS1Tm2IEXAFfgKPgdL9O6mAa06wjCcUAL6EsxPQWO9VNegBPm/0GgkZbDxCynxujX/92vmGcjZRMAY45puak2sFLCLSwXpEsyy5fnF0jGJBhm+fNSHKKUUfy+276A7/feLOFxxUuHRNJI2Osenxyvf8DAGObT60pfTTlhEg9u/KKkhJqm5U1/+BEcSkpFDA5XeCqxwXmPac1jcuZ3JWQ+p0NdWzb/5v1ZvF8GtMTFFEdQjpLO0bwPb0BHNWnip3liDXI2fXf05jjvfJ0NpjLCUgfTh9CMFYVFKEd4Z/OG/2C+N435mnK+9t1gvCiVcaaH7rK4+PjCvpVNiz+t2QyqH1O8x3JKZVl6Q+Lp/XK8wMjVMslOq9FdSw5FtUs/CptXH9PW+wbWHgrV17R5jTVOtGtKFu3nb80T+E0tv9QkzW3J2dbaw/8ddAKZ0pxIaEqLjlPrji3VgJ3GvdFvlqD8075woxh4fVt0JZE0KVFsAvqhe0dqN9b35jtSpnYMXkU+vZq+IAHad3IHc2s/LYrnD1anfG46IFiMIr9oNbZDWvwthqYNqOigaKd/XlLU4XHfk/PXIjPsLy/9/kAtQ+/wKH+hI/IROWj5FPvTZAT9f7j4ZXQyG4M0TujMAFXYkKvEHv1xhySekgXGGqNxWeWKlf8dDAlLuB1cb/qOD+rk7cmwt+1yKpk9cudqBanTi6zTbXRtV8qylNtjyOVKy1HTz0GW9rjt6sSjAZcT5R+KdtyYb0zyqG9pSLuCw5WBwAn7fjBjKLLoxLXMI+52L9cLwIR2B6OllJZLHJ8vDxmWdtF+QJnmt1rsHPIWY20lftk8fYePkAIg6Hgn532QoIpegMxiWgAOfe5/U44APR8Ac0NeZrVh3gEhs12W+tVSiWiUQekf/YBECUy5fdYbA08dd7VzPAP9aiVcIB9k6tY7WdJ1wNV+bHeydNtmC6G5ICtFC1ZwmJU/j8hf0I8TRVKSiz5oYIa93EpUI78X8GYIAZabx47/n8LDAAJ0nNtP1rpROprqKMBRecShca6qXuTSI3jZBLOB3Vp381B5rCGhjSvh/NSVkYp2qIdP/Bg=";

},{}],396:[function(require,module,exports){
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/

var data = require('./dictionary-data');
exports.init = function() {
  exports.dictionary = data.init();
};

exports.offsetsByLength = new Uint32Array([
     0,     0,     0,     0,     0,  4096,  9216, 21504, 35840, 44032,
 53248, 63488, 74752, 87040, 93696, 100864, 104704, 106752, 108928, 113536,
 115968, 118528, 119872, 121280, 122016,
]);

exports.sizeBitsByLength = new Uint8Array([
  0,  0,  0,  0, 10, 10, 11, 11, 10, 10,
 10, 10, 10,  9,  9,  8,  7,  7,  8,  7,
  7,  6,  6,  5,  5,
]);

exports.minDictionaryWordLength = 4;
exports.maxDictionaryWordLength = 24;

},{"./dictionary-data":394}],397:[function(require,module,exports){
function HuffmanCode(bits, value) {
  this.bits = bits;   /* number of bits used for this symbol */
  this.value = value; /* symbol value or table offset */
}

exports.HuffmanCode = HuffmanCode;

var MAX_LENGTH = 15;

/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */
function GetNextKey(key, len) {
  var step = 1 << (len - 1);
  while (key & step) {
    step >>= 1;
  }
  return (key & (step - 1)) + step;
}

/* Stores code in table[0], table[step], table[2*step], ..., table[end] */
/* Assumes that end is an integer multiple of step */
function ReplicateValue(table, i, step, end, code) {
  do {
    end -= step;
    table[i + end] = new HuffmanCode(code.bits, code.value);
  } while (end > 0);
}

/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */
function NextTableBitSize(count, len, root_bits) {
  var left = 1 << (len - root_bits);
  while (len < MAX_LENGTH) {
    left -= count[len];
    if (left <= 0) break;
    ++len;
    left <<= 1;
  }
  return len - root_bits;
}

exports.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
  var start_table = table;
  var code;            /* current table entry */
  var len;             /* current code length */
  var symbol;          /* symbol index in original or sorted table */
  var key;             /* reversed prefix code */
  var step;            /* step size to replicate values in current table */
  var low;             /* low bits for current root entry */
  var mask;            /* mask for low bits */
  var table_bits;      /* key length of current table */
  var table_size;      /* size of current table */
  var total_size;      /* sum of root table size and 2nd level table sizes */
  var sorted;          /* symbols sorted by code length */
  var count = new Int32Array(MAX_LENGTH + 1);  /* number of codes of each length */
  var offset = new Int32Array(MAX_LENGTH + 1);  /* offsets in sorted table for each length */

  sorted = new Int32Array(code_lengths_size);

  /* build histogram of code lengths */
  for (symbol = 0; symbol < code_lengths_size; symbol++) {
    count[code_lengths[symbol]]++;
  }

  /* generate offsets into sorted symbol table by code length */
  offset[1] = 0;
  for (len = 1; len < MAX_LENGTH; len++) {
    offset[len + 1] = offset[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (symbol = 0; symbol < code_lengths_size; symbol++) {
    if (code_lengths[symbol] !== 0) {
      sorted[offset[code_lengths[symbol]]++] = symbol;
    }
  }
  
  table_bits = root_bits;
  table_size = 1 << table_bits;
  total_size = table_size;

  /* special case code with only one value */
  if (offset[MAX_LENGTH] === 1) {
    for (key = 0; key < total_size; ++key) {
      root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
    }
    
    return total_size;
  }

  /* fill in root table */
  key = 0;
  symbol = 0;
  for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
    for (; count[len] > 0; --count[len]) {
      code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
      ReplicateValue(root_table, table + key, step, table_size, code);
      key = GetNextKey(key, len);
    }
  }

  /* fill in 2nd level tables and add pointers to root table */
  mask = total_size - 1;
  low = -1;
  for (len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1) {
    for (; count[len] > 0; --count[len]) {
      if ((key & mask) !== low) {
        table += table_size;
        table_bits = NextTableBitSize(count, len, root_bits);
        table_size = 1 << table_bits;
        total_size += table_size;
        low = key & mask;
        root_table[start_table + low] = new HuffmanCode((table_bits + root_bits) & 0xff, ((table - start_table) - low) & 0xffff);
      }
      code = new HuffmanCode((len - root_bits) & 0xff, sorted[symbol++] & 0xffff);
      ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
      key = GetNextKey(key, len);
    }
  }
  
  return total_size;
}

},{}],398:[function(require,module,exports){
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/

/* Represents the range of values belonging to a prefix code: */
/* [offset, offset + 2^nbits) */
function PrefixCodeRange(offset, nbits) {
  this.offset = offset;
  this.nbits = nbits;
}

exports.kBlockLengthPrefixCode = [
  new PrefixCodeRange(1, 2), new PrefixCodeRange(5, 2), new PrefixCodeRange(9, 2), new PrefixCodeRange(13, 2),
  new PrefixCodeRange(17, 3), new PrefixCodeRange(25, 3), new PrefixCodeRange(33, 3), new PrefixCodeRange(41, 3),
  new PrefixCodeRange(49, 4), new PrefixCodeRange(65, 4), new PrefixCodeRange(81, 4), new PrefixCodeRange(97, 4),
  new PrefixCodeRange(113, 5), new PrefixCodeRange(145, 5), new PrefixCodeRange(177, 5), new PrefixCodeRange(209, 5),
  new PrefixCodeRange(241, 6), new PrefixCodeRange(305, 6), new PrefixCodeRange(369, 7), new PrefixCodeRange(497, 8),
  new PrefixCodeRange(753, 9), new PrefixCodeRange(1265, 10), new PrefixCodeRange(2289, 11), new PrefixCodeRange(4337, 12),
  new PrefixCodeRange(8433, 13), new PrefixCodeRange(16625, 24)
];

exports.kInsertLengthPrefixCode = [
  new PrefixCodeRange(0, 0), new PrefixCodeRange(1, 0), new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0),
  new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0), new PrefixCodeRange(6, 1), new PrefixCodeRange(8, 1),
  new PrefixCodeRange(10, 2), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 3), new PrefixCodeRange(26, 3),
  new PrefixCodeRange(34, 4), new PrefixCodeRange(50, 4), new PrefixCodeRange(66, 5), new PrefixCodeRange(98, 5),
  new PrefixCodeRange(130, 6), new PrefixCodeRange(194, 7), new PrefixCodeRange(322, 8), new PrefixCodeRange(578, 9),
  new PrefixCodeRange(1090, 10), new PrefixCodeRange(2114, 12), new PrefixCodeRange(6210, 14), new PrefixCodeRange(22594, 24),
];

exports.kCopyLengthPrefixCode = [
  new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0), new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0),
  new PrefixCodeRange(6, 0), new PrefixCodeRange(7, 0), new PrefixCodeRange(8, 0), new PrefixCodeRange(9, 0),
  new PrefixCodeRange(10, 1), new PrefixCodeRange(12, 1), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 2),
  new PrefixCodeRange(22, 3), new PrefixCodeRange(30, 3), new PrefixCodeRange(38, 4), new PrefixCodeRange(54, 4),
  new PrefixCodeRange(70, 5), new PrefixCodeRange(102, 5), new PrefixCodeRange(134, 6), new PrefixCodeRange(198, 7),
  new PrefixCodeRange(326, 8), new PrefixCodeRange(582, 9), new PrefixCodeRange(1094, 10), new PrefixCodeRange(2118, 24),
];

exports.kInsertRangeLut = [
  0, 0, 8, 8, 0, 16, 8, 16, 16,
];

exports.kCopyRangeLut = [
  0, 8, 0, 8, 16, 0, 16, 8, 16,
];

},{}],399:[function(require,module,exports){
function BrotliInput(buffer) {
  this.buffer = buffer;
  this.pos = 0;
}

BrotliInput.prototype.read = function(buf, i, count) {
  if (this.pos + count > this.buffer.length) {
    count = this.buffer.length - this.pos;
  }
  
  for (var p = 0; p < count; p++)
    buf[i + p] = this.buffer[this.pos + p];
  
  this.pos += count;
  return count;
}

exports.BrotliInput = BrotliInput;

function BrotliOutput(buf) {
  this.buffer = buf;
  this.pos = 0;
}

BrotliOutput.prototype.write = function(buf, count) {
  if (this.pos + count > this.buffer.length)
    throw new Error('Output buffer is not large enough');
  
  this.buffer.set(buf.subarray(0, count), this.pos);
  this.pos += count;
  return count;
};

exports.BrotliOutput = BrotliOutput;

},{}],400:[function(require,module,exports){
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/

var BrotliDictionary = require('./dictionary');

var kIdentity       = 0;
var kOmitLast1      = 1;
var kOmitLast2      = 2;
var kOmitLast3      = 3;
var kOmitLast4      = 4;
var kOmitLast5      = 5;
var kOmitLast6      = 6;
var kOmitLast7      = 7;
var kOmitLast8      = 8;
var kOmitLast9      = 9;
var kUppercaseFirst = 10;
var kUppercaseAll   = 11;
var kOmitFirst1     = 12;
var kOmitFirst2     = 13;
var kOmitFirst3     = 14;
var kOmitFirst4     = 15;
var kOmitFirst5     = 16;
var kOmitFirst6     = 17;
var kOmitFirst7     = 18;
var kOmitFirst8     = 19;
var kOmitFirst9     = 20;

function Transform(prefix, transform, suffix) {
  this.prefix = new Uint8Array(prefix.length);
  this.transform = transform;
  this.suffix = new Uint8Array(suffix.length);
  
  for (var i = 0; i < prefix.length; i++)
    this.prefix[i] = prefix.charCodeAt(i);
  
  for (var i = 0; i < suffix.length; i++)
    this.suffix[i] = suffix.charCodeAt(i);
}

var kTransforms = [
     new Transform(         "", kIdentity,       ""           ),
     new Transform(         "", kIdentity,       " "          ),
     new Transform(        " ", kIdentity,       " "          ),
     new Transform(         "", kOmitFirst1,     ""           ),
     new Transform(         "", kUppercaseFirst, " "          ),
     new Transform(         "", kIdentity,       " the "      ),
     new Transform(        " ", kIdentity,       ""           ),
     new Transform(       "s ", kIdentity,       " "          ),
     new Transform(         "", kIdentity,       " of "       ),
     new Transform(         "", kUppercaseFirst, ""           ),
     new Transform(         "", kIdentity,       " and "      ),
     new Transform(         "", kOmitFirst2,     ""           ),
     new Transform(         "", kOmitLast1,      ""           ),
     new Transform(       ", ", kIdentity,       " "          ),
     new Transform(         "", kIdentity,       ", "         ),
     new Transform(        " ", kUppercaseFirst, " "          ),
     new Transform(         "", kIdentity,       " in "       ),
     new Transform(         "", kIdentity,       " to "       ),
     new Transform(       "e ", kIdentity,       " "          ),
     new Transform(         "", kIdentity,       "\""         ),
     new Transform(         "", kIdentity,       "."          ),
     new Transform(         "", kIdentity,       "\">"        ),
     new Transform(         "", kIdentity,       "\n"         ),
     new Transform(         "", kOmitLast3,      ""           ),
     new Transform(         "", kIdentity,       "]"          ),
     new Transform(         "", kIdentity,       " for "      ),
     new Transform(         "", kOmitFirst3,     ""           ),
     new Transform(         "", kOmitLast2,      ""           ),
     new Transform(         "", kIdentity,       " a "        ),
     new Transform(         "", kIdentity,       " that "     ),
     new Transform(        " ", kUppercaseFirst, ""           ),
     new Transform(         "", kIdentity,       ". "         ),
     new Transform(        ".", kIdentity,       ""           ),
     new Transform(        " ", kIdentity,       ", "         ),
     new Transform(         "", kOmitFirst4,     ""           ),
     new Transform(         "", kIdentity,       " with "     ),
     new Transform(         "", kIdentity,       "'"          ),
     new Transform(         "", kIdentity,       " from "     ),
     new Transform(         "", kIdentity,       " by "       ),
     new Transform(         "", kOmitFirst5,     ""           ),
     new Transform(         "", kOmitFirst6,     ""           ),
     new Transform(    " the ", kIdentity,       ""           ),
     new Transform(         "", kOmitLast4,      ""           ),
     new Transform(         "", kIdentity,       ". The "     ),
     new Transform(         "", kUppercaseAll,   ""           ),
     new Transform(         "", kIdentity,       " on "       ),
     new Transform(         "", kIdentity,       " as "       ),
     new Transform(         "", kIdentity,       " is "       ),
     new Transform(         "", kOmitLast7,      ""           ),
     new Transform(         "", kOmitLast1,      "ing "       ),
     new Transform(         "", kIdentity,       "\n\t"       ),
     new Transform(         "", kIdentity,       ":"          ),
     new Transform(        " ", kIdentity,       ". "         ),
     new Transform(         "", kIdentity,       "ed "        ),
     new Transform(         "", kOmitFirst9,     ""           ),
     new Transform(         "", kOmitFirst7,     ""           ),
     new Transform(         "", kOmitLast6,      ""           ),
     new Transform(         "", kIdentity,       "("          ),
     new Transform(         "", kUppercaseFirst, ", "         ),
     new Transform(         "", kOmitLast8,      ""           ),
     new Transform(         "", kIdentity,       " at "       ),
     new Transform(         "", kIdentity,       "ly "        ),
     new Transform(    " the ", kIdentity,       " of "       ),
     new Transform(         "", kOmitLast5,      ""           ),
     new Transform(         "", kOmitLast9,      ""           ),
     new Transform(        " ", kUppercaseFirst, ", "         ),
     new Transform(         "", kUppercaseFirst, "\""         ),
     new Transform(        ".", kIdentity,       "("          ),
     new Transform(         "", kUppercaseAll,   " "          ),
     new Transform(         "", kUppercaseFirst, "\">"        ),
     new Transform(         "", kIdentity,       "=\""        ),
     new Transform(        " ", kIdentity,       "."          ),
     new Transform(    ".com/", kIdentity,       ""           ),
     new Transform(    " the ", kIdentity,       " of the "   ),
     new Transform(         "", kUppercaseFirst, "'"          ),
     new Transform(         "", kIdentity,       ". This "    ),
     new Transform(         "", kIdentity,       ","          ),
     new Transform(        ".", kIdentity,       " "          ),
     new Transform(         "", kUppercaseFirst, "("          ),
     new Transform(         "", kUppercaseFirst, "."          ),
     new Transform(         "", kIdentity,       " not "      ),
     new Transform(        " ", kIdentity,       "=\""        ),
     new Transform(         "", kIdentity,       "er "        ),
     new Transform(        " ", kUppercaseAll,   " "          ),
     new Transform(         "", kIdentity,       "al "        ),
     new Transform(        " ", kUppercaseAll,   ""           ),
     new Transform(         "", kIdentity,       "='"         ),
     new Transform(         "", kUppercaseAll,   "\""         ),
     new Transform(         "", kUppercaseFirst, ". "         ),
     new Transform(        " ", kIdentity,       "("          ),
     new Transform(         "", kIdentity,       "ful "       ),
     new Transform(        " ", kUppercaseFirst, ". "         ),
     new Transform(         "", kIdentity,       "ive "       ),
     new Transform(         "", kIdentity,       "less "      ),
     new Transform(         "", kUppercaseAll,   "'"          ),
     new Transform(         "", kIdentity,       "est "       ),
     new Transform(        " ", kUppercaseFirst, "."          ),
     new Transform(         "", kUppercaseAll,   "\">"        ),
     new Transform(        " ", kIdentity,       "='"         ),
     new Transform(         "", kUppercaseFirst, ","          ),
     new Transform(         "", kIdentity,       "ize "       ),
     new Transform(         "", kUppercaseAll,   "."          ),
     new Transform( "\xc2\xa0", kIdentity,       ""           ),
     new Transform(        " ", kIdentity,       ","          ),
     new Transform(         "", kUppercaseFirst, "=\""        ),
     new Transform(         "", kUppercaseAll,   "=\""        ),
     new Transform(         "", kIdentity,       "ous "       ),
     new Transform(         "", kUppercaseAll,   ", "         ),
     new Transform(         "", kUppercaseFirst, "='"         ),
     new Transform(        " ", kUppercaseFirst, ","          ),
     new Transform(        " ", kUppercaseAll,   "=\""        ),
     new Transform(        " ", kUppercaseAll,   ", "         ),
     new Transform(         "", kUppercaseAll,   ","          ),
     new Transform(         "", kUppercaseAll,   "("          ),
     new Transform(         "", kUppercaseAll,   ". "         ),
     new Transform(        " ", kUppercaseAll,   "."          ),
     new Transform(         "", kUppercaseAll,   "='"         ),
     new Transform(        " ", kUppercaseAll,   ". "         ),
     new Transform(        " ", kUppercaseFirst, "=\""        ),
     new Transform(        " ", kUppercaseAll,   "='"         ),
     new Transform(        " ", kUppercaseFirst, "='"         )
];

exports.kTransforms = kTransforms;
exports.kNumTransforms = kTransforms.length;

function ToUpperCase(p, i) {
  if (p[i] < 0xc0) {
    if (p[i] >= 97 && p[i] <= 122) {
      p[i] ^= 32;
    }
    return 1;
  }
  
  /* An overly simplified uppercasing model for utf-8. */
  if (p[i] < 0xe0) {
    p[i + 1] ^= 32;
    return 2;
  }
  
  /* An arbitrary transform for three byte characters. */
  p[i + 2] ^= 5;
  return 3;
}

exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
  var prefix = kTransforms[transform].prefix;
  var suffix = kTransforms[transform].suffix;
  var t = kTransforms[transform].transform;
  var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
  var i = 0;
  var start_idx = idx;
  var uppercase;
  
  if (skip > len) {
    skip = len;
  }
  
  var prefix_pos = 0;
  while (prefix_pos < prefix.length) {
    dst[idx++] = prefix[prefix_pos++];
  }
  
  word += skip;
  len -= skip;
  
  if (t <= kOmitLast9) {
    len -= t;
  }
  
  for (i = 0; i < len; i++) {
    dst[idx++] = BrotliDictionary.dictionary[word + i];
  }
  
  uppercase = idx - len;
  
  if (t === kUppercaseFirst) {
    ToUpperCase(dst, uppercase);
  } else if (t === kUppercaseAll) {
    while (len > 0) {
      var step = ToUpperCase(dst, uppercase);
      uppercase += step;
      len -= step;
    }
  }
  
  var suffix_pos = 0;
  while (suffix_pos < suffix.length) {
    dst[idx++] = suffix[suffix_pos++];
  }
  
  return idx - start_idx;
}

},{"./dictionary":396}],401:[function(require,module,exports){
module.exports = require('./dec/decode').BrotliDecompressBuffer;

},{"./dec/decode":393}],402:[function(require,module,exports){

},{}],403:[function(require,module,exports){
arguments[4][402][0].apply(exports,arguments)
},{"dup":402}],404:[function(require,module,exports){
(function (global,Buffer){(function (){
'use strict';
var base64 = require('base64-js');
var ieee754 = require('ieee754');
var isArray = require('isarray');
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function () {
                return 42;
            }
        };
        return arr.foo() === 42 && typeof arr.subarray === 'function' && arr.subarray(1, 1).byteLength === 0;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) {
        throw new RangeError('Invalid typed array length');
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        if (that === null) {
            that = new Buffer(length);
        }
        that.length = length;
    }
    return that;
}
function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
        return new Buffer(arg, encodingOrOffset, length);
    }
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
            throw new Error('If encoding is specified then the first argument must be a string');
        }
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192;
Buffer._augment = function (arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
        throw new TypeError('"value" argument must not be a number');
    }
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length);
    }
    if (typeof value === 'string') {
        return fromString(that, value, encodingOrOffset);
    }
    return fromObject(that, value);
}
Buffer.from = function (value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
        Object.defineProperty(Buffer, Symbol.species, {
            value: null,
            configurable: true
        });
    }
}
function assertSize(size) {
    if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be a number');
    } else if (size < 0) {
        throw new RangeError('"size" argument must not be negative');
    }
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
        return createBuffer(that, size);
    }
    if (fill !== undefined) {
        return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    }
    return createBuffer(that, size);
}
Buffer.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) {
        for (var i = 0; i < size; ++i) {
            that[i] = 0;
        }
    }
    return that;
}
Buffer.allocUnsafe = function (size) {
    return allocUnsafe(null, size);
};
Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
    }
    if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding');
    }
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) {
        that = that.slice(0, actual);
    }
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for (var i = 0; i < length; i += 1) {
        that[i] = array[i] & 255;
    }
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength;
    if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('\'offset\' is out of bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('\'length\' is out of bounds');
    }
    if (byteOffset === undefined && length === undefined) {
        array = new Uint8Array(array);
    } else if (length === undefined) {
        array = new Uint8Array(array, byteOffset);
    } else {
        array = new Uint8Array(array, byteOffset, length);
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        that = array;
        that.__proto__ = Buffer.prototype;
    } else {
        that = fromArrayLike(that, array);
    }
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) {
            return that;
        }
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || isnan(obj.length)) {
                return createBuffer(that, 0);
            }
            return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray(obj.data)) {
            return fromArrayLike(that, obj.data);
        }
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
    if (length >= kMaxLength()) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
    }
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) {
        length = 0;
    }
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
        throw new TypeError('Arguments must be Buffers');
    }
    if (a === b)
        return 0;
    var x = a.length;
    var y = b.length;
    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
    }
    if (x < y)
        return -1;
    if (y < x)
        return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
        return true;
    default:
        return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
        return Buffer.alloc(0);
    }
    var i;
    if (length === undefined) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
            length += list[i].length;
        }
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
        }
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) {
        return string.length;
    }
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength;
    }
    if (typeof string !== 'string') {
        string = '' + string;
    }
    var len = string.length;
    if (len === 0)
        return 0;
    var loweredCase = false;
    for (;;) {
        switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase)
                return utf8ToBytes(string).length;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    if (start === undefined || start < 0) {
        start = 0;
    }
    if (start > this.length) {
        return '';
    }
    if (end === undefined || end > this.length) {
        end = this.length;
    }
    if (end <= 0) {
        return '';
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
        return '';
    }
    if (!encoding)
        encoding = 'utf8';
    while (true) {
        switch (encoding) {
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase)
                throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
        }
    }
}
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits');
    }
    for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
    }
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits');
    }
    for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits');
    }
    for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0)
        return '';
    if (arguments.length === 0)
        return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b))
        throw new TypeError('Argument must be a Buffer');
    if (this === b)
        return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max)
            str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) {
        throw new TypeError('Argument must be a Buffer');
    }
    if (start === undefined) {
        start = 0;
    }
    if (end === undefined) {
        end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
        thisStart = 0;
    }
    if (thisEnd === undefined) {
        thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index');
    }
    if (thisStart >= thisEnd && start >= end) {
        return 0;
    }
    if (thisStart >= thisEnd) {
        return -1;
    }
    if (start >= end) {
        return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
        return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
    }
    if (x < y)
        return -1;
    if (y < x)
        return 1;
    return 0;
};
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    if (buffer.length === 0)
        return -1;
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (isNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
    }
    if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir)
            return -1;
        else
            byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir)
            byteOffset = 0;
        else
            return -1;
    }
    if (typeof val === 'string') {
        val = Buffer.from(val, encoding);
    }
    if (Buffer.isBuffer(val)) {
        if (val.length === 0) {
            return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 255;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) {
                return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            } else {
                return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) {
                return -1;
            }
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) {
            return buf[i];
        } else {
            return buf.readUInt16BE(i * indexSize);
        }
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
            if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1)
                    foundIndex = i;
                if (i - foundIndex + 1 === valLength)
                    return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1)
                    i -= i - foundIndex;
                foundIndex = -1;
            }
        }
    } else {
        if (byteOffset + valLength > arrLength)
            byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
            var found = true;
            for (var j = 0; j < valLength; j++) {
                if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
            }
            if (found)
                return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
        length = remaining;
    } else {
        length = Number(length);
        if (length > remaining) {
            length = remaining;
        }
    }
    var strLen = string.length;
    if (strLen % 2 !== 0)
        throw new TypeError('Invalid hex string');
    if (length > strLen / 2) {
        length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed))
            return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined)
                encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else {
        throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    }
    var remaining = this.length - offset;
    if (length === undefined || length > remaining)
        length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds');
    }
    if (!encoding)
        encoding = 'utf8';
    var loweredCase = false;
    for (;;) {
        switch (encoding) {
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase)
                throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
    } else {
        return base64.fromByteArray(buf.slice(start, end));
    }
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch (bytesPerSequence) {
            case 1:
                if (firstByte < 128) {
                    codePoint = firstByte;
                }
                break;
            case 2:
                secondByte = buf[i + 1];
                if ((secondByte & 192) === 128) {
                    tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                    if (tempCodePoint > 127) {
                        codePoint = tempCodePoint;
                    }
                }
                break;
            case 3:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                    tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                    if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                        codePoint = tempCodePoint;
                    }
                }
                break;
            case 4:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                fourthByte = buf[i + 3];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                    tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                    if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                        codePoint = tempCodePoint;
                    }
                }
            }
        }
        if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
        } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
    }
    var res = '';
    var i = 0;
    while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
    }
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
    }
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0)
        start = 0;
    if (!end || end < 0 || end > len)
        end = len;
    var out = '';
    for (var i = start; i < end; ++i) {
        out += toHex(buf[i]);
    }
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0)
            start = 0;
    } else if (start > len) {
        start = len;
    }
    if (end < 0) {
        end += len;
        if (end < 0)
            end = 0;
    } else if (end > len) {
        end = len;
    }
    if (end < start)
        end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for (var i = 0; i < sliceLen; ++i) {
            newBuf[i] = this[i + start];
        }
    }
    return newBuf;
};
function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0)
        throw new RangeError('offset is not uint');
    if (offset + ext > length)
        throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 256)) {
        val += this[offset + i] * mul;
    }
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
    }
    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 256)) {
        val += this[offset + --byteLength] * mul;
    }
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 256)) {
        val += this[offset + i] * mul;
    }
    mul *= 128;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
    }
    mul *= 128;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 1, this.length);
    if (!(this[offset] & 128))
        return this[offset];
    return (255 - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 32768 ? val | 4294901760 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 32768 ? val | 4294901760 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 255;
    while (++i < byteLength && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT)
        value = Math.floor(value);
    this[offset] = value & 255;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0)
        value = 65535 + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
        buf[offset + i] = (value & 255 << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
    }
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
    } else {
        objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
    } else {
        objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0)
        value = 4294967295 + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
        buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 255;
    }
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 255;
    } else {
        objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
    } else {
        objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 255;
    while (++i < byteLength && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
            sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
            sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT)
        value = Math.floor(value);
    if (value < 0)
        value = 255 + value + 1;
    this[offset] = value & 255;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
    } else {
        objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
    } else {
        objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else {
        objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (value < 0)
        value = 4294967295 + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
    } else {
        objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
    if (offset < 0)
        throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    }
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 1.7976931348623157e+308, -1.7976931348623157e+308);
    }
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start)
        start = 0;
    if (!end && end !== 0)
        end = this.length;
    if (targetStart >= target.length)
        targetStart = target.length;
    if (!targetStart)
        targetStart = 0;
    if (end > 0 && end < start)
        end = start;
    if (end === start)
        return 0;
    if (target.length === 0 || this.length === 0)
        return 0;
    if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds');
    }
    if (start < 0 || start >= this.length)
        throw new RangeError('sourceStart out of bounds');
    if (end < 0)
        throw new RangeError('sourceEnd out of bounds');
    if (end > this.length)
        end = this.length;
    if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
    }
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) {
        for (i = len - 1; i >= 0; --i) {
            target[i + targetStart] = this[i + start];
        }
    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
        for (i = 0; i < len; ++i) {
            target[i + targetStart] = this[i + start];
        }
    } else {
        Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    }
    return len;
};
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) {
                val = code;
            }
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
            throw new TypeError('encoding must be a string');
        }
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
            throw new TypeError('Unknown encoding: ' + encoding);
        }
    } else if (typeof val === 'number') {
        val = val & 255;
    }
    if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index');
    }
    if (end <= start) {
        return this;
    }
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val)
        val = 0;
    var i;
    if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
            this[i] = val;
        }
    } else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for (i = 0; i < end - start; ++i) {
            this[i + start] = bytes[i % len];
        }
    }
    return this;
};
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    if (str.length < 2)
        return '';
    while (str.length % 4 !== 0) {
        str = str + '=';
    }
    return str;
}
function stringtrim(str) {
    if (str.trim)
        return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
    if (n < 16)
        return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
                if (codePoint > 56319) {
                    if ((units -= 3) > -1)
                        bytes.push(239, 191, 189);
                    continue;
                } else if (i + 1 === length) {
                    if ((units -= 3) > -1)
                        bytes.push(239, 191, 189);
                    continue;
                }
                leadSurrogate = codePoint;
                continue;
            }
            if (codePoint < 56320) {
                if ((units -= 3) > -1)
                    bytes.push(239, 191, 189);
                leadSurrogate = codePoint;
                continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
            if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
            if ((units -= 1) < 0)
                break;
            bytes.push(codePoint);
        } else if (codePoint < 2048) {
            if ((units -= 2) < 0)
                break;
            bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
            if ((units -= 3) < 0)
                break;
            bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
            if ((units -= 4) < 0)
                break;
            bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else {
            throw new Error('Invalid code point');
        }
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
    }
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
            break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
            break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val;
}
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)
},{"base64-js":387,"buffer":404,"ieee754":666,"isarray":674}],405:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],406:[function(require,module,exports){
var Buffer = require('buffer').Buffer;
var isBufferEncoding = Buffer.isEncoding || function (encoding) {
    switch (encoding && encoding.toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
    case 'raw':
        return true;
    default:
        return false;
    }
};
function assertEncoding(encoding) {
    if (encoding && !isBufferEncoding(encoding)) {
        throw new Error('Unknown encoding: ' + encoding);
    }
}
var StringDecoder = exports.StringDecoder = function (encoding) {
    this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
    assertEncoding(encoding);
    switch (this.encoding) {
    case 'utf8':
        this.surrogateSize = 3;
        break;
    case 'ucs2':
    case 'utf16le':
        this.surrogateSize = 2;
        this.detectIncompleteChar = utf16DetectIncompleteChar;
        break;
    case 'base64':
        this.surrogateSize = 3;
        this.detectIncompleteChar = base64DetectIncompleteChar;
        break;
    default:
        this.write = passThroughWrite;
        return;
    }
    this.charBuffer = new Buffer(6);
    this.charReceived = 0;
    this.charLength = 0;
};
StringDecoder.prototype.write = function (buffer) {
    var charStr = '';
    while (this.charLength) {
        var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
        buffer.copy(this.charBuffer, this.charReceived, 0, available);
        this.charReceived += available;
        if (this.charReceived < this.charLength) {
            return '';
        }
        buffer = buffer.slice(available, buffer.length);
        charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
        var charCode = charStr.charCodeAt(charStr.length - 1);
        if (charCode >= 55296 && charCode <= 56319) {
            this.charLength += this.surrogateSize;
            charStr = '';
            continue;
        }
        this.charReceived = this.charLength = 0;
        if (buffer.length === 0) {
            return charStr;
        }
        break;
    }
    this.detectIncompleteChar(buffer);
    var end = buffer.length;
    if (this.charLength) {
        buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
        end -= this.charReceived;
    }
    charStr += buffer.toString(this.encoding, 0, end);
    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end);
    if (charCode >= 55296 && charCode <= 56319) {
        var size = this.surrogateSize;
        this.charLength += size;
        this.charReceived += size;
        this.charBuffer.copy(this.charBuffer, size, 0, size);
        buffer.copy(this.charBuffer, 0, 0, size);
        return charStr.substring(0, end);
    }
    return charStr;
};
StringDecoder.prototype.detectIncompleteChar = function (buffer) {
    var i = buffer.length >= 3 ? 3 : buffer.length;
    for (; i > 0; i--) {
        var c = buffer[buffer.length - i];
        if (i == 1 && c >> 5 == 6) {
            this.charLength = 2;
            break;
        }
        if (i <= 2 && c >> 4 == 14) {
            this.charLength = 3;
            break;
        }
        if (i <= 3 && c >> 3 == 30) {
            this.charLength = 4;
            break;
        }
    }
    this.charReceived = i;
};
StringDecoder.prototype.end = function (buffer) {
    var res = '';
    if (buffer && buffer.length)
        res = this.write(buffer);
    if (this.charReceived) {
        var cr = this.charReceived;
        var buf = this.charBuffer;
        var enc = this.encoding;
        res += buf.slice(0, cr).toString(enc);
    }
    return res;
};
function passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
}
function utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
}
function base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
}
},{"buffer":404}],407:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":408,"get-intrinsic":638}],408:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"function-bind":637,"get-intrinsic":638}],409:[function(require,module,exports){
/**
 * Copyright 2014 Google Inc. All rights reserved.
 *
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 *
 * @fileoverview Description of this file.
 *
 * A polyfill for HTML Canvas features, including
 * Path2D support.
 */
if (CanvasRenderingContext2D.prototype.ellipse == undefined) {
  CanvasRenderingContext2D.prototype.ellipse = function(x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
    this.save();
    this.translate(x, y);
    this.rotate(rotation);
    this.scale(radiusX, radiusY);
    this.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
    this.restore();
  }
}

if (typeof Path2D !== 'function') {
  (function() {

    // Include the SVG path parser.
    parser = (function() {
      /*
       * Generated by PEG.js 0.8.0.
       *
       * http://pegjs.majda.cz/
       */
    
      function peg$subclass(child, parent) {
        function ctor() { this.constructor = child; }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
      }
    
      function SyntaxError(message, expected, found, offset, line, column) {
        this.message  = message;
        this.expected = expected;
        this.found    = found;
        this.offset   = offset;
        this.line     = line;
        this.column   = column;
    
        this.name     = "SyntaxError";
      }
    
      peg$subclass(SyntaxError, Error);
    
      function parse(input) {
        var options = arguments.length > 1 ? arguments[1] : {},
    
            peg$FAILED = {},
    
            peg$startRuleFunctions = { svg_path: peg$parsesvg_path },
            peg$startRuleFunction  = peg$parsesvg_path,
    
            peg$c0 = peg$FAILED,
            peg$c1 = [],
            peg$c2 = null,
            peg$c3 = function(d) { return ops; },
            peg$c4 = /^[Mm]/,
            peg$c5 = { type: "class", value: "[Mm]", description: "[Mm]" },
            peg$c6 = function(ch, args) {
                  var moveCh = ch
                  // If this is the first move cmd then force it to be absolute.
                  if (firstSubPath) {
                    moveCh = 'M';
                    firstSubPath = false;
                  }
                  ops.push({type: 'moveTo', args: makeAbsolute(moveCh, args[0])});
                  for (var i=1; i < args.length; i++) {
                    // The lineTo args are either abs or relative, depending on the
                    // original moveto command.
                    ops.push({type: 'lineTo', args: makeAbsolute(ch, args[i])});
                  }
                },
            peg$c7 = function(one, rest) { return concatSequence(one, rest); },
            peg$c8 = /^[Zz]/,
            peg$c9 = { type: "class", value: "[Zz]", description: "[Zz]" },
            peg$c10 = function() { ops.push({type: 'closePath', args: []}); },
            peg$c11 = /^[Ll]/,
            peg$c12 = { type: "class", value: "[Ll]", description: "[Ll]" },
            peg$c13 = function(ch, args) {
                  for (var i=0; i < args.length; i++) {
                    ops.push({type: 'lineTo', args: makeAbsolute(ch, args[i])});
                  }
                },
            peg$c14 = /^[Hh]/,
            peg$c15 = { type: "class", value: "[Hh]", description: "[Hh]" },
            peg$c16 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  ops.push({type: 'lineTo', args: makeAbsoluteFromX(ch, args[i])});
                }
              },
            peg$c17 = /^[Vv]/,
            peg$c18 = { type: "class", value: "[Vv]", description: "[Vv]" },
            peg$c19 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  ops.push({type: 'lineTo', args: makeAbsoluteFromY(ch, args[i])});
                }
              },
            peg$c20 = /^[Cc]/,
            peg$c21 = { type: "class", value: "[Cc]", description: "[Cc]" },
            peg$c22 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  ops.push({type: 'bezierCurveTo', args: makeAbsoluteMultiple(ch, args[i])});
                }
              },
            peg$c23 = function(cp1, cp2, last) { return cp1.concat(cp2, last); },
            peg$c24 = /^[Ss]/,
            peg$c25 = { type: "class", value: "[Ss]", description: "[Ss]" },
            peg$c26 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  ops.push({type: 'bezierCurveTo', args: makeReflected().concat(makeAbsoluteMultiple(ch, args[i]))});
                }
              },
            peg$c27 = function(cp1, last) { return cp1.concat(last); },
            peg$c28 = /^[Qq]/,
            peg$c29 = { type: "class", value: "[Qq]", description: "[Qq]" },
            peg$c30 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  ops.push({type: 'quadraticCurveTo', args: makeAbsoluteMultiple(ch, args[i])});
                }
              },
            peg$c31 = /^[Tt]/,
            peg$c32 = { type: "class", value: "[Tt]", description: "[Tt]" },
            peg$c33 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  var reflected = makeReflected();
                  ops.push({type: 'quadraticCurveTo', args: reflected.concat(makeAbsoluteMultiple(ch, args[i]))});
                  lastControl = reflected.slice(0);
                }
              },
            peg$c34 = /^[Aa]/,
            peg$c35 = { type: "class", value: "[Aa]", description: "[Aa]" },
            peg$c36 = function(ch, args) {
                for (var i=0; i < args.length; i++) {
                  var x1 = [lastCoord.slice()];
                  var x2 = [makeAbsolute(ch, args[i].slice(-2))];
                  absArgs = x1.concat(args[i].slice(0, -2), x2);
                  ellipseFromEllipticalArc.apply(this, absArgs);
                }
              },
            peg$c37 = function(rx, ry, xrot, large, sweep, last) { return [parseFloat(rx), parseFloat(ry), parseFloat(flatten(xrot).join('')), parseInt(large), parseInt(sweep), last[0], last[1]]; },
            peg$c38 = function(x, y) { return [x, y] },
            peg$c39 = function(number) { return parseFloat(flatten(number).join('')) },
            peg$c40 = "0",
            peg$c41 = { type: "literal", value: "0", description: "\"0\"" },
            peg$c42 = "1",
            peg$c43 = { type: "literal", value: "1", description: "\"1\"" },
            peg$c44 = ",",
            peg$c45 = { type: "literal", value: ",", description: "\",\"" },
            peg$c46 = ".",
            peg$c47 = { type: "literal", value: ".", description: "\".\"" },
            peg$c48 = /^[eE]/,
            peg$c49 = { type: "class", value: "[eE]", description: "[eE]" },
            peg$c50 = "+",
            peg$c51 = { type: "literal", value: "+", description: "\"+\"" },
            peg$c52 = "-",
            peg$c53 = { type: "literal", value: "-", description: "\"-\"" },
            peg$c54 = /^[0-9]/,
            peg$c55 = { type: "class", value: "[0-9]", description: "[0-9]" },
            peg$c56 = function(digits) { return digits.join('') },
            peg$c57 = /^[ \t\n\r]/,
            peg$c58 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
    
            peg$currPos          = 0,
            peg$reportedPos      = 0,
            peg$cachedPos        = 0,
            peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
            peg$maxFailPos       = 0,
            peg$maxFailExpected  = [],
            peg$silentFails      = 0,
    
            peg$result;
    
        if ("startRule" in options) {
          if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
          }
    
          peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
    
        function text() {
          return input.substring(peg$reportedPos, peg$currPos);
        }
    
        function offset() {
          return peg$reportedPos;
        }
    
        function line() {
          return peg$computePosDetails(peg$reportedPos).line;
        }
    
        function column() {
          return peg$computePosDetails(peg$reportedPos).column;
        }
    
        function expected(description) {
          throw peg$buildException(
            null,
            [{ type: "other", description: description }],
            peg$reportedPos
          );
        }
    
        function error(message) {
          throw peg$buildException(message, null, peg$reportedPos);
        }
    
        function peg$computePosDetails(pos) {
          function advance(details, startPos, endPos) {
            var p, ch;
    
            for (p = startPos; p < endPos; p++) {
              ch = input.charAt(p);
              if (ch === "\n") {
                if (!details.seenCR) { details.line++; }
                details.column = 1;
                details.seenCR = false;
              } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
                details.line++;
                details.column = 1;
                details.seenCR = true;
              } else {
                details.column++;
                details.seenCR = false;
              }
            }
          }
    
          if (peg$cachedPos !== pos) {
            if (peg$cachedPos > pos) {
              peg$cachedPos = 0;
              peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
            }
            advance(peg$cachedPosDetails, peg$cachedPos, pos);
            peg$cachedPos = pos;
          }
    
          return peg$cachedPosDetails;
        }
    
        function peg$fail(expected) {
          if (peg$currPos < peg$maxFailPos) { return; }
    
          if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
          }
    
          peg$maxFailExpected.push(expected);
        }
    
        function peg$buildException(message, expected, pos) {
          function cleanupExpected(expected) {
            var i = 1;
    
            expected.sort(function(a, b) {
              if (a.description < b.description) {
                return -1;
              } else if (a.description > b.description) {
                return 1;
              } else {
                return 0;
              }
            });
    
            while (i < expected.length) {
              if (expected[i - 1] === expected[i]) {
                expected.splice(i, 1);
              } else {
                i++;
              }
            }
          }
    
          function buildMessage(expected, found) {
            function stringEscape(s) {
              function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
    
              return s
                .replace(/\\/g,   '\\\\')
                .replace(/"/g,    '\\"')
                .replace(/\x08/g, '\\b')
                .replace(/\t/g,   '\\t')
                .replace(/\n/g,   '\\n')
                .replace(/\f/g,   '\\f')
                .replace(/\r/g,   '\\r')
                .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
                .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
                .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
                .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
            }
    
            var expectedDescs = new Array(expected.length),
                expectedDesc, foundDesc, i;
    
            for (i = 0; i < expected.length; i++) {
              expectedDescs[i] = expected[i].description;
            }
    
            expectedDesc = expected.length > 1
              ? expectedDescs.slice(0, -1).join(", ")
                  + " or "
                  + expectedDescs[expected.length - 1]
              : expectedDescs[0];
    
            foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
    
            return "Expected " + expectedDesc + " but " + foundDesc + " found.";
          }
    
          var posDetails = peg$computePosDetails(pos),
              found      = pos < input.length ? input.charAt(pos) : null;
    
          if (expected !== null) {
            cleanupExpected(expected);
          }
    
          return new SyntaxError(
            message !== null ? message : buildMessage(expected, found),
            expected,
            found,
            pos,
            posDetails.line,
            posDetails.column
          );
        }
    
        function peg$parsesvg_path() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parsewsp();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parsewsp();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parsemoveTo_drawTo_commandGroups();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parsewsp();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parsewsp();
              }
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c3(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsemoveTo_drawTo_commandGroups() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsemoveTo_drawTo_commandGroup();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = [];
            s4 = peg$parsewsp();
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parsewsp();
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsemoveTo_drawTo_commandGroups();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsemoveTo_drawTo_commandGroup() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsemoveto();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = [];
            s4 = peg$parsewsp();
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parsewsp();
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsedrawto_commands();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsedrawto_commands() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsedrawto_command();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = [];
            s4 = peg$parsewsp();
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parsewsp();
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsedrawto_commands();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsedrawto_command() {
          var s0;
    
          s0 = peg$parseclosepath();
          if (s0 === peg$FAILED) {
            s0 = peg$parselineto();
            if (s0 === peg$FAILED) {
              s0 = peg$parsehorizontal_lineto();
              if (s0 === peg$FAILED) {
                s0 = peg$parsevertical_lineto();
                if (s0 === peg$FAILED) {
                  s0 = peg$parsecurveto();
                  if (s0 === peg$FAILED) {
                    s0 = peg$parsesmooth_curveto();
                    if (s0 === peg$FAILED) {
                      s0 = peg$parsequadratic_bezier_curveto();
                      if (s0 === peg$FAILED) {
                        s0 = peg$parsesmooth_quadratic_bezier_curveto();
                        if (s0 === peg$FAILED) {
                          s0 = peg$parseelliptical_arc();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
    
          return s0;
        }
    
        function peg$parsemoveto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c4.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c5); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsemoveto_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c6(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsemoveto_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate_pair();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parselineto_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parseclosepath() {
          var s0, s1;
    
          s0 = peg$currPos;
          if (peg$c8.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c9); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c10();
          }
          s0 = s1;
    
          return s0;
        }
    
        function peg$parselineto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c11.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c12); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parselineto_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c13(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parselineto_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate_pair();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parselineto_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsehorizontal_lineto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c14.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c15); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecoordinate_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c16(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsecoordinate_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsecoordinate_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsevertical_lineto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c17.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c18); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecoordinate_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c19(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsecurveto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c20.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c21); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecurveto_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c22(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsecurveto_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsecurveto_argument();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsecurveto_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsecurveto_argument() {
          var s0, s1, s2, s3, s4, s5;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate_pair();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma_wsp();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecoordinate_pair();
              if (s3 !== peg$FAILED) {
                s4 = peg$parsecomma_wsp();
                if (s4 === peg$FAILED) {
                  s4 = peg$c2;
                }
                if (s4 !== peg$FAILED) {
                  s5 = peg$parsecoordinate_pair();
                  if (s5 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c23(s1, s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c0;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsesmooth_curveto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c24.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c25); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsesmooth_curveto_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c26(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsesmooth_curveto_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsesmooth_curveto_argument();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsesmooth_curveto_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsesmooth_curveto_argument() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate_pair();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma_wsp();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecoordinate_pair();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsequadratic_bezier_curveto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c28.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c29); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsequadratic_bezier_curveto_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsequadratic_bezier_curveto_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsequadratic_bezier_curveto_argument();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsequadratic_bezier_curveto_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsequadratic_bezier_curveto_argument() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate_pair();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma_wsp();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecoordinate_pair();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsesmooth_quadratic_bezier_curveto() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c31.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c32); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsesmooth_quadratic_bezier_curveto_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c33(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsesmooth_quadratic_bezier_curveto_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate_pair();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parsesmooth_quadratic_bezier_curveto_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parseelliptical_arc() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c34.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c35); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsewsp();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parseelliptical_arc_argument_sequence();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c36(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parseelliptical_arc_argument_sequence() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = peg$parseelliptical_arc_argument();
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parsecomma_wsp();
            if (s3 === peg$FAILED) {
              s3 = peg$c2;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parseelliptical_arc_argument_sequence();
              if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c7(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parseelliptical_arc_argument() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    
          s0 = peg$currPos;
          s1 = peg$parsenonnegative_number();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma_wsp();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsenonnegative_number();
              if (s3 !== peg$FAILED) {
                s4 = peg$parsecomma_wsp();
                if (s4 === peg$FAILED) {
                  s4 = peg$c2;
                }
                if (s4 !== peg$FAILED) {
                  s5 = peg$parsenumber();
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parsecomma_wsp();
                    if (s6 !== peg$FAILED) {
                      s7 = peg$parseflag();
                      if (s7 !== peg$FAILED) {
                        s8 = peg$parsecomma_wsp();
                        if (s8 === peg$FAILED) {
                          s8 = peg$c2;
                        }
                        if (s8 !== peg$FAILED) {
                          s9 = peg$parseflag();
                          if (s9 !== peg$FAILED) {
                            s10 = peg$parsecomma_wsp();
                            if (s10 === peg$FAILED) {
                              s10 = peg$c2;
                            }
                            if (s10 !== peg$FAILED) {
                              s11 = peg$parsecoordinate_pair();
                              if (s11 !== peg$FAILED) {
                                peg$reportedPos = s0;
                                s1 = peg$c37(s1, s3, s5, s7, s9, s11);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$c0;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$c0;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$c0;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$c0;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$c0;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c0;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c0;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c0;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsecoordinate_pair() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          s1 = peg$parsecoordinate();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma_wsp();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsecoordinate();
              if (s3 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c38(s1, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsecoordinate() {
          var s0, s1;
    
          s0 = peg$currPos;
          s1 = peg$parsenumber();
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c39(s1);
          }
          s0 = s1;
    
          return s0;
        }
    
        function peg$parsenonnegative_number() {
          var s0;
    
          s0 = peg$parsefloating_point_constant();
          if (s0 === peg$FAILED) {
            s0 = peg$parsedigit_sequence();
          }
    
          return s0;
        }
    
        function peg$parsenumber() {
          var s0, s1, s2;
    
          s0 = peg$currPos;
          s1 = peg$parsesign();
          if (s1 === peg$FAILED) {
            s1 = peg$c2;
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parsefloating_point_constant();
            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsesign();
            if (s1 === peg$FAILED) {
              s1 = peg$c2;
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parsedigit_sequence();
              if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          }
    
          return s0;
        }
    
        function peg$parseflag() {
          var s0;
    
          if (input.charCodeAt(peg$currPos) === 48) {
            s0 = peg$c40;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c41); }
          }
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 49) {
              s0 = peg$c42;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c43); }
            }
          }
    
          return s0;
        }
    
        function peg$parsecomma_wsp() {
          var s0, s1, s2, s3, s4;
    
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parsewsp();
          if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parsewsp();
            }
          } else {
            s1 = peg$c0;
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parsewsp();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parsewsp();
              }
              if (s3 !== peg$FAILED) {
                s1 = [s1, s2, s3];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsecomma();
            if (s1 !== peg$FAILED) {
              s2 = [];
              s3 = peg$parsewsp();
              while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsewsp();
              }
              if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          }
    
          return s0;
        }
    
        function peg$parsecomma() {
          var s0;
    
          if (input.charCodeAt(peg$currPos) === 44) {
            s0 = peg$c44;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c45); }
          }
    
          return s0;
        }
    
        function peg$parsefloating_point_constant() {
          var s0, s1, s2;
    
          s0 = peg$currPos;
          s1 = peg$parsefractional_constant();
          if (s1 !== peg$FAILED) {
            s2 = peg$parseexponent();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigit_sequence();
            if (s1 !== peg$FAILED) {
              s2 = peg$parseexponent();
              if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          }
    
          return s0;
        }
    
        function peg$parsefractional_constant() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          s1 = peg$parsedigit_sequence();
          if (s1 === peg$FAILED) {
            s1 = peg$c2;
          }
          if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 46) {
              s2 = peg$c46;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c47); }
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsedigit_sequence();
              if (s3 !== peg$FAILED) {
                s1 = [s1, s2, s3];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigit_sequence();
            if (s1 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 46) {
                s2 = peg$c46;
                peg$currPos++;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c47); }
              }
              if (s2 !== peg$FAILED) {
                s1 = [s1, s2];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          }
    
          return s0;
        }
    
        function peg$parseexponent() {
          var s0, s1, s2, s3;
    
          s0 = peg$currPos;
          if (peg$c48.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c49); }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) {
              s2 = peg$c2;
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsedigit_sequence();
              if (s3 !== peg$FAILED) {
                s1 = [s1, s2, s3];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c0;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
    
          return s0;
        }
    
        function peg$parsesign() {
          var s0;
    
          if (input.charCodeAt(peg$currPos) === 43) {
            s0 = peg$c50;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c51); }
          }
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 45) {
              s0 = peg$c52;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c53); }
            }
          }
    
          return s0;
        }
    
        function peg$parsedigit_sequence() {
          var s0, s1, s2;
    
          s0 = peg$currPos;
          s1 = [];
          if (peg$c54.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c55); }
          }
          if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              if (peg$c54.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c55); }
              }
            }
          } else {
            s1 = peg$c0;
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c56(s1);
          }
          s0 = s1;
    
          return s0;
        }
    
        function peg$parsewsp() {
          var s0;
    
          if (peg$c57.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c58); }
          }
    
          return s0;
        }
    
    
          // The last coordinate we are at in the path. In absolute coords.
          var lastCoord = [0, 0];
          // The last control point we encountered in the path. In absolute coords.
          var lastControl = [0, 0];
          // The list of operations we've parsed so far.
          var ops = [];
          // Have we parsed the first sub-path yet?
          var firstSubPath = true;
          // The letter of the last parsed command.
          var lastCh = '';

          // Flatten an array.
          function flatten(a) {
            var flat = [];
            for (var i = 0; i < a.length; i++) {
              if (a[i] instanceof Array) {
                flat.push.apply(flat, flatten(a[i]));
              } else {
                flat.push(a[i]);
              }
            }
            return flat;
          }

          // Convert a position into an absolute position.
          function makeAbsolute(c, coord) {
            if ('mlazhvcsqt'.indexOf(c) === -1) {
              lastCoord = coord;
            } else {
              lastCoord[0] += coord[0];
              lastCoord[1] += coord[1];
            }
            lastCh = c;
            return lastCoord.slice(0);
          }
    
          // Convert a sequence of coordinates into absolute coordinates.
          //
          // For arguments that take multiple coord pairs, such as bezier.
          function makeAbsoluteMultiple(c, seq) {
            var r = [];
            var lastPosCopy = lastCoord.slice(0);
            for (var i=0; i < seq.length; i+=2) {
              // Only the last point should update lastCoord.
              lastCoord = lastPosCopy.slice(0);
              var coord = makeAbsolute(c, seq.slice(i, i+2));
              r = r.concat(coord);
              // Record the last control point, it might be needed for
              // shorthand operations.
              if (i == seq.length-4) {
                lastControl = coord.slice(0);
              }
            }
            return r;
          }
    
          // Find the reflection of the last control point over
          // the last postion in the path.
          function makeReflected() {
            if ('CcSsQqTt'.indexOf(lastCh) == -1) {
              lastControl = lastCoord.slice(0);
            }
            // reflected = 2*lastCoord - lastControl
            // Note the result is absolute, not relative.
            var r = [0, 0];
            r[0] = 2*lastCoord[0] - lastControl[0];
            r[1] = 2*lastCoord[1] - lastControl[1];
            return r;
          }
    
          function makeAbsoluteFromX(c, x) {
            var coord = [x, 0];
            if (c == 'H') {
              coord[1] = lastCoord[1];
            }
            return makeAbsolute(c, coord);
          }
    
          function makeAbsoluteFromY(c, y) {
            var coord = [0, y];
            if (c == 'V') {
              coord[0] = lastCoord[0];
            }
            return makeAbsolute(c, coord);
          }
    
          function concatSequence(one, rest) {
            var r = [one];
            if (rest && rest.length > 1) {
              var rem = rest[1];
              for (var i = 0; i < rem.length; i++) {
                r.push(rem[i]);
              }
            }
            return r;
          }
    
          function mag(v) {
            return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
          }
    
          function dot(u, v) {
            return (u[0]*v[0] + u[1]*v[1]);
          }
    
          function ratio(u, v) {
            return dot(u,v) / (mag(u)*mag(v))
          }
    
          function angle(u, v) {
            var sign = 1.0;
            if ((u[0]*v[1] - u[1]*v[0]) < 0) {
              sign = -1.0;
            }
            return sign * Math.acos(ratio(u,v));
          }
    
          function rotClockwise(v, angle) {
            var cost = Math.cos(angle);
            var sint = Math.sin(angle);
            return [cost*v[0] + sint*v[1], -1 * sint*v[0] + cost*v[1]];
          }
    
          function rotCounterClockwise(v, angle) {
            var cost = Math.cos(angle);
            var sint = Math.sin(angle);
            return [cost*v[0] - sint*v[1], sint*v[0] + cost*v[1]];
          }
    
          function midPoint(u, v) {
            return [(u[0] - v[0])/2.0, (u[1] - v[1])/2.0];
          }
    
          function meanVec(u, v) {
            return [(u[0] + v[0])/2.0, (u[1] + v[1])/2.0];
          }
    
          function pointMul(u, v) {
            return [u[0]*v[0], u[1]*v[1]];
          }
    
          function scale(c, v) {
            return [c*v[0], c*v[1]];
          }
    
          function sum(u, v) {
            return [u[0] + v[0], u[1] + v[1]];
          }
    
          // Convert an SVG elliptical arc to a series of canvas commands.
          //
          // x1, x2: start and stop coordinates of the ellipse.
          // rx, ry: radii of the ellipse.
          // phi: rotation of the ellipse.
          // fA: large arc flag.
          // fS: sweep flag.
          function ellipseFromEllipticalArc(x1, rx, ry, phi, fA, fS, x2) {
            // Convert from endpoint to center parametrization, as detailed in:
            //   http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
            if (rx == 0 || ry == 0) {
              ops.push({type: 'lineTo', args: x2});
              return;
            }
            var phi = phi * (Math.PI / 180.0);
            rx = Math.abs(rx);
            ry = Math.abs(ry);
            var xPrime = rotClockwise(midPoint(x1, x2), phi);                // F.6.5.1
            var xPrime2 = pointMul(xPrime, xPrime);
            var rx2 = Math.pow(rx, 2);
            var ry2 = Math.pow(ry, 2);
    
            var lambda = Math.sqrt(xPrime2[0]/rx2 + xPrime2[1]/ry2);
            if (lambda > 1) {
              rx *= lambda;
              ry *= lambda;
              rx2 = Math.pow(rx, 2);
              ry2 = Math.pow(ry, 2);
            }
    
            var factor = Math.sqrt((rx2*ry2 - rx2*xPrime2[1] - ry2*xPrime2[0]) /
              (rx2*xPrime2[1] + ry2*xPrime2[0]));
            if (fA == fS) {
              factor *= -1.0;
            }
            var cPrime = scale(factor, [rx*xPrime[1]/ry, -ry*xPrime[0]/rx]); // F.6.5.2
            var c = sum(rotCounterClockwise(cPrime, phi), meanVec(x1, x2));  // F.6.5.3
            var x1UnitVector = [(xPrime[0] - cPrime[0])/rx, (xPrime[1] - cPrime[1])/ry];
            var x2UnitVector = [(-1.0*xPrime[0] - cPrime[0])/rx, (-1.0*xPrime[1] - cPrime[1])/ry];
            var theta = angle([1, 0], x1UnitVector);                         // F.6.5.5
            var deltaTheta = angle(x1UnitVector, x2UnitVector);              // F.6.5.6
            var start = theta;
            var end = theta+deltaTheta;
            ops.push(
              {type: 'save', args: []},
              {type: 'translate', args: [c[0], c[1]]},
              {type: 'rotate', args: [phi]},
              {type: 'scale', args: [rx, ry]},
              {type: 'arc', args: [0, 0, 1, start, end, 1-fS]},
              {type: 'restore', args: []}
              );
          }
    
    
        peg$result = peg$startRuleFunction();
    
        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
          return peg$result;
        } else {
          if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail({ type: "end", description: "end of input" });
          }
    
          throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
        }
      }
    
      return {
        SyntaxError: SyntaxError,
        parse:       parse
      };
    })();

    function Path_(arg) {
      this.ops_ = [];
      if (arg == undefined) {
        return;
      }
      if (typeof arg == 'string') {
        try {
          this.ops_ = parser.parse(arg);
        } catch(e) {
          // Treat an invalid SVG path as an empty path.
        }
      } else if (arg.hasOwnProperty('ops_')) {
        this.ops_ = arg.ops_.slice(0);
      } else {
        throw 'Error: ' + typeof arg + 'is not a valid argument to Path';
      }
    };

    // TODO(jcgregorio) test for arcTo and implement via something.


    // Path methods that map simply to the CanvasRenderingContext2D.
    var simple_mapping = [
      'closePath',
      'moveTo',
      'lineTo',
      'quadraticCurveTo',
      'bezierCurveTo',
      'rect',
      'arc',
      'arcTo',
      'ellipse',
      'isPointInPath',
      'isPointInStroke',
      ];

    function createFunction(name) {
      return function() {
        this.ops_.push({type: name, args: Array.prototype.slice.call(arguments, 0)});
      };
    }

    // Add simple_mapping methods to Path2D.
    for (var i=0; i<simple_mapping.length; i++) {
      var name = simple_mapping[i];
      Path_.prototype[name] = createFunction(name);
    }

    Path_.prototype['addPath'] = function(path, tr) {
      var hasTx = false;
      if (tr
          && tr.hasOwnProperty('a')
          && tr.hasOwnProperty('b')
          && tr.hasOwnProperty('c')
          && tr.hasOwnProperty('d')
          && tr.hasOwnProperty('e')
          && tr.hasOwnProperty('f')) {
        hasTx = true;
        this.ops_.push({type: 'save', args: []});
        this.ops_.push({type: 'transform', args: [tr.a, tr.b, tr.c, tr.d, tr.e, tr.f]});
      }
      this.ops_ = this.ops_.concat(path.ops_);
      if (hasTx) {
        this.ops_.push({type: 'restore', args: []});
      }
    }

    original_fill = CanvasRenderingContext2D.prototype.fill;
    original_stroke = CanvasRenderingContext2D.prototype.stroke;
    original_clip = CanvasRenderingContext2D.prototype.clip;
    original_is_point_in_path = CanvasRenderingContext2D.prototype.isPointInPath;
    original_is_point_in_stroke = CanvasRenderingContext2D.prototype.isPointInStroke;

    // Replace methods on CanvasRenderingContext2D with ones that understand Path2D.
    CanvasRenderingContext2D.prototype.fill = function(arg) {
      if (arg instanceof Path_) {
        this.beginPath();
        for (var i = 0, len = arg.ops_.length; i < len; i++) {
          var op = arg.ops_[i];
          CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
        }
        original_fill.apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        original_fill.apply(this, arguments);
      }
    }

    CanvasRenderingContext2D.prototype.stroke = function(arg) {
      if (arg instanceof Path_) {
        this.beginPath();
        for (var i = 0, len = arg.ops_.length; i < len; i++) {
          var op = arg.ops_[i];
          CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
        }
        original_stroke.call(this);
      } else {
        original_stroke.call(this);
      }
    }

    CanvasRenderingContext2D.prototype.clip = function(arg) {
      if (arg instanceof Path_) {
        // Note that we don't save and restore the context state, since the
        // clip region is part of the state. Not really a problem since the
        // HTML 5 spec doesn't say that clip(path) doesn't affect the current
        // path.
        this.beginPath();
        for (var i = 0, len = arg.ops_.length; i < len; i++) {
          var op = arg.ops_[i];
          CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
        }
        original_clip.apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        original_clip.apply(this, arguments);
      }
    }

    CanvasRenderingContext2D.prototype.isPointInPath = function(arg) {
      if (arg instanceof Path_) {
        this.beginPath();
        for (var i = 0, len = arg.ops_.length; i < len; i++) {
          var op = arg.ops_[i];
          CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
        }
        return original_is_point_in_path.apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        return original_is_point_in_path.apply(this, arguments);
      }
    }
    CanvasRenderingContext2D.prototype.isPointInStroke = function(arg) {
      if (arg instanceof Path_) {
        this.beginPath();
        for (var i = 0, len = arg.ops_.length; i < len; i++) {
          var op = arg.ops_[i];
          CanvasRenderingContext2D.prototype[op.type].apply(this, op.args);
        }
        return original_is_point_in_stroke.apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        return original_is_point_in_stroke.apply(this, arguments);
      }
    }

    // Set up externs.
    Path2D = Path_;
  })();
}

},{}],410:[function(require,module,exports){
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
		// register as 'classnames', consistent with npm package name
		define('classnames', [], function () {
			return classNames;
		});
	} else {
		window.classNames = classNames;
	}
}());

},{}],411:[function(require,module,exports){
(function (Buffer){(function (){
var clone = (function() {
'use strict';

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/
function clone(parent, circular, depth, prototype) {
  var filter;
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    filter = circular.filter;
    circular = circular.circular
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth == 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
};
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
};
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
};
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
};
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
};
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":404}],412:[function(require,module,exports){
function replace(a, b)
{
 if (!b)
 {
  return a;
 }
 var key;
 for (key in b)
 {
  if(b.hasOwnProperty(key))
  { 
   a[key] = b[key];
  }
 }
   
 return a;
} exports.replace=replace;

function add(a, b)
{
 if (!b)
 {
  return a;
 }
 var key;
 for (key in b)
 {
  if(b.hasOwnProperty(key))
  { 
   if(typeof a[key] === 'undefined' ||  a[key]===null)
   {
    a[key] = b[key];
   }
  }
 }
 return a;
} exports.add=add;


function extend(a, b, context, newobjs, aparent, aname, haveaparent) // context is anti circular references mechanism
{
 if (a==b){ return a;}
 if (!b)  { return a;}
 
 var key, clean_context=false, return_sublevel=false,b_pos;
 if(!haveaparent){ aparent={'a':a}; aname='a'; }
 if(!context){clean_context=true;context=[];newobjs=[];}
 b_pos=context.indexOf(b);
 if( b_pos==-1 ) {context.push(b);newobjs.push([aparent, aname]);} else { return newobjs[b_pos][0][ newobjs[b_pos][1] ]; }

 for (key in b)
 {
   if(b.hasOwnProperty(key))
   { 
   if(typeof a[key] === 'undefined')
   {   
    if(typeof b[key] === 'object')
    {
     if( b[key] instanceof Array ) // http://javascript.crockford.com/remedial.html
      {a[key] = extend([], b[key],context,newobjs,a,key,true);}
     else if(b[key]===null)
      {a[key] = null;}
     else if( b[key] instanceof Date )
      { a[key]= new b[key].constructor();a[key].setTime(b[key].getTime());  }
     else
      { a[key] = extend({}, b[key],context,newobjs,a,key,true); /*a[key].constructor = b[key].constructor;  a[key].prototype = b[key].prototype;*/ }
    }
    else
    {  a[key] = b[key]; }
   }
   else if(typeof a[key] === 'object' && a[key] !== null)
   {  a[key] = extend(a[key], b[key],context,newobjs,a,key,true); /*a[key].constructor = b[key].constructor;  a[key].prototype = b[key].prototype;*/ }
   else  
   {  a[key] = b[key]; }
  }
 }
 if(clean_context) {context=null;newobjs=null;}
 if(!haveaparent)
 {
  aparent=null;
  return a;
 }
 if(typeof a === 'object' && !(a instanceof Array) )
 {
  /*a.constructor = b.constructor;
  a.prototype   = b.prototype*/;
 } 
 return a;
} exports.extend=extend;

function extenduptolevel(a, b, levels, context, newobjs, aparent, aname, haveaparent)
{
 if (a==b){ return a;}
 if (!b){ return a;}

 var key, clean_context=false, return_sublevel=false;
 if(!haveaparent){ aparent={'a':a}; aname='a'; }
 if(!context){clean_context=true;context=[];newobjs=[];}
 b_pos=context.indexOf(b);
 if( b_pos==-1 ) {context.push(b);newobjs.push([aparent, aname]);} else { return newobjs[b_pos][0][ newobjs[b_pos][1] ]; }
 
 for (key in b)
 {
  if(b.hasOwnProperty(key))
  { 
   if(typeof a[key] === 'undefined')
   {
    if(typeof b[key] === 'object' && levels>0)
    {
     if( b[key] instanceof Array ) // http://javascript.crockford.com/remedial.html
     { a[key] = extenduptolevel([], b[key],levels-1,context,newobjs,a,key,true); }
     else if(b[key]===null)
     { a[key] = null; }
     else if( b[key] instanceof Date )
     { a[key]= new b[key].constructor();a[key].setTime(b[key].getTime());  }
     else
     { a[key] = extenduptolevel({}, b[key],levels-1,context,newobjs,a,key,true); }
    }
    else
    {  a[key] = b[key]; }
   }
   else if(typeof a[key] === 'object' && a[key] !== null && levels>0)
   {  a[key] = extenduptolevel(a[key], b[key],levels-1,context,newobjs,a,key,true); }
   else  
   {  a[key] = b[key]; }
  }
 }
 if(clean_context) {context=null;newobjs=null;}

 if(!haveaparent)
 {
  aparent=null;
  return a;
 }
 if(typeof a === 'object' && !(a instanceof Array) )
 {
  /*a.constructor = b.constructor;
  a.prototype   = b.prototype;*/
 } 
 return a;
} exports.extenduptolevel=extenduptolevel;

function clone(obj)
{
 if (typeof obj === 'object')
 {
  if (obj ===null ) { return null; }
  if (obj instanceof Array )
  { return extend([], obj); }
  else if( obj instanceof Date )
  {
   var t= new obj.constructor();
   t.setTime(obj.getTime());
   return t;
  }
  else
  { return extend({}, obj); }
 }
 return obj;
} exports.clone=clone;

function cloneextend(obj,exteddata)
{
 if (typeof obj === 'object')
 {
  if (obj ===null ) { return null; }
  return extend(clone(obj),exteddata);
 }
 return obj;
} exports.cloneextend=cloneextend;


function cloneuptolevel(obj,level) // clone only numlevels levels other levels leave references
{
 if (typeof obj === 'object')
 {
  if (obj ===null ) { return null; }
  if (obj instanceof Array ) { return extenduptolevel([], obj,level); }
  return extenduptolevel({}, obj,level);
 }
 return obj;
} exports.cloneuptolevel=cloneuptolevel;

function foreach(object, block, context)
{
 if (object)
 {
  if (typeof object === "object" && object instanceof Array)
   return object.forEach(object, block, context)
  else //if (typeof object === "object") // or (object instanceof Function)...
  {
   if(object)
   for (var key in object)
   {
    if(object.hasOwnProperty(key))
    {
     if(block.call(context, object[key], key, object)===false)break;
    }
   }
  }  
 }
} exports.foreach=foreach;

/*
 hasbugs and useless, yet interesting maybe developed later for dot pathed object transformation:
 
 {
  'foo.bar':'bluebar',
  'foo.color':'blue'
 }
 
 transforemed to
 
 {
  foo:
  {
   bar:'bluebar',
   color:'blue'
  }
 }
 
 like:
 
 var config={};
 cloneextend.dotpath(config,{
  'foo.bar':'bluebar',
  'foo.color':'blue'
 })
 
 //
 function dotpath(data,dotkeys,preserve)
 {
      if(!preserve)preserve=false;
      var create=!preserve;
      if(create) if(!data) data={};
      var keys= dotkeys.split("."),value=data;
      for (var i=0;i<keys.length;i++)
      {
          if(!value[keys[i]]) //should you create one?
          {
              if(create)
                  value[keys[i]]={};
              else
                  return undefined;
          }
          value = value[keys[i]];
      }
      return value;
 }
 */
},{}],413:[function(require,module,exports){
/* MIT license */
var cssKeywords = require('color-name');

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};

},{"color-name":416}],414:[function(require,module,exports){
var conversions = require('./conversions');
var route = require('./route');

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;

},{"./conversions":413,"./route":415}],415:[function(require,module,exports){
var conversions = require('./conversions');

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};


},{"./conversions":413}],416:[function(require,module,exports){
'use strict'

module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

},{}],417:[function(require,module,exports){
/* MIT license */
var colorNames = require('color-name');
var swizzle = require('simple-swizzle');

var reverseNames = {};

// create a list of reverse color names
for (var name in colorNames) {
	if (colorNames.hasOwnProperty(name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = module.exports = {
	to: {},
	get: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var keyword = /(\D+)/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha, 16) / 255;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		rgb = colorNames[match[1]];

		if (!rgb) {
			return null;
		}

		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = (parseFloat(match[1]) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = num.toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}

},{"color-name":416,"simple-swizzle":1172}],418:[function(require,module,exports){
'use strict';
var colorString = require('color-string');
var convert = require('color-convert');
var _slice = [].slice;
var skippedModels = [
    'keyword',
    'gray',
    'hex'
];
var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
    hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});
var limiters = {};
function Color(obj, model) {
    if (!(this instanceof Color)) {
        return new Color(obj, model);
    }
    if (model && model in skippedModels) {
        model = null;
    }
    if (model && !(model in convert)) {
        throw new Error('Unknown model: ' + model);
    }
    var i;
    var channels;
    if (!obj) {
        this.model = 'rgb';
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === 'string') {
        var result = colorString.get(obj);
        if (result === null) {
            throw new Error('Unable to parse color from string: ' + obj);
        }
        this.model = result.model;
        channels = convert[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || 'rgb';
        channels = convert[this.model].channels;
        var newArr = _slice.call(obj, 0, channels);
        this.color = zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
    } else if (typeof obj === 'number') {
        obj &= 16777215;
        this.model = 'rgb';
        this.color = [
            obj >> 16 & 255,
            obj >> 8 & 255,
            obj & 255
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ('alpha' in obj) {
            keys.splice(keys.indexOf('alpha'), 1);
            this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join('');
        if (!(hashedKeys in hashedModelKeys)) {
            throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
        }
        this.model = hashedModelKeys[hashedKeys];
        var labels = convert[this.model].labels;
        var color = [];
        for (i = 0; i < labels.length; i++) {
            color.push(obj[labels[i]]);
        }
        this.color = zeroArray(color);
    }
    if (limiters[this.model]) {
        channels = convert[this.model].channels;
        for (i = 0; i < channels; i++) {
            var limit = limiters[this.model][i];
            if (limit) {
                this.color[i] = limit(this.color[i]);
            }
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) {
        Object.freeze(this);
    }
}
Color.prototype = {
    toString: function () {
        return this.string();
    },
    toJSON: function () {
        return this[this.model]();
    },
    string: function (places) {
        var self = this.model in colorString.to ? this : this.rgb();
        self = self.round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return colorString.to[self.model](args);
    },
    percentString: function (places) {
        var self = this.rgb().round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return colorString.to.rgb.percent(args);
    },
    array: function () {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function () {
        var result = {};
        var channels = convert[this.model].channels;
        var labels = convert[this.model].labels;
        for (var i = 0; i < channels; i++) {
            result[labels[i]] = this.color[i];
        }
        if (this.valpha !== 1) {
            result.alpha = this.valpha;
        }
        return result;
    },
    unitArray: function () {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) {
            rgb.push(this.valpha);
        }
        return rgb;
    },
    unitObject: function () {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) {
            rgb.alpha = this.valpha;
        }
        return rgb;
    },
    round: function (places) {
        places = Math.max(places || 0, 0);
        return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function (val) {
        if (arguments.length) {
            return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        }
        return this.valpha;
    },
    red: getset('rgb', 0, maxfn(255)),
    green: getset('rgb', 1, maxfn(255)),
    blue: getset('rgb', 2, maxfn(255)),
    hue: getset([
        'hsl',
        'hsv',
        'hsl',
        'hwb',
        'hcg'
    ], 0, function (val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: getset('hsl', 1, maxfn(100)),
    lightness: getset('hsl', 2, maxfn(100)),
    saturationv: getset('hsv', 1, maxfn(100)),
    value: getset('hsv', 2, maxfn(100)),
    chroma: getset('hcg', 1, maxfn(100)),
    gray: getset('hcg', 2, maxfn(100)),
    white: getset('hwb', 1, maxfn(100)),
    wblack: getset('hwb', 2, maxfn(100)),
    cyan: getset('cmyk', 0, maxfn(100)),
    magenta: getset('cmyk', 1, maxfn(100)),
    yellow: getset('cmyk', 2, maxfn(100)),
    black: getset('cmyk', 3, maxfn(100)),
    x: getset('xyz', 0, maxfn(100)),
    y: getset('xyz', 1, maxfn(100)),
    z: getset('xyz', 2, maxfn(100)),
    l: getset('lab', 0, maxfn(100)),
    a: getset('lab', 1),
    b: getset('lab', 2),
    keyword: function (val) {
        if (arguments.length) {
            return new Color(val);
        }
        return convert[this.model].keyword(this.color);
    },
    hex: function (val) {
        if (arguments.length) {
            return new Color(val);
        }
        return colorString.to.hex(this.rgb().round().color);
    },
    rgbNumber: function () {
        var rgb = this.rgb().color;
        return (rgb[0] & 255) << 16 | (rgb[1] & 255) << 8 | rgb[2] & 255;
    },
    luminosity: function () {
        var rgb = this.rgb().color;
        var lum = [];
        for (var i = 0; i < rgb.length; i++) {
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function (color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
            return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function (color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
            return 'AAA';
        }
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    dark: function () {
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    light: function () {
        return !this.dark();
    },
    negate: function () {
        var rgb = this.rgb();
        for (var i = 0; i < 3; i++) {
            rgb.color[i] = 255 - rgb.color[i];
        }
        return rgb;
    },
    lighten: function (ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function (ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function (ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function (ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function (ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function (ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function () {
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return Color.rgb(val, val, val);
    },
    fade: function (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function (degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function (mixinColor, weight) {
        var color1 = this.rgb();
        var color2 = mixinColor.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        var w2 = 1 - w1;
        return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
Object.keys(convert).forEach(function (model) {
    if (skippedModels.indexOf(model) !== -1) {
        return;
    }
    var channels = convert[model].channels;
    Color.prototype[model] = function () {
        if (this.model === model) {
            return new Color(this);
        }
        if (arguments.length) {
            return new Color(arguments, model);
        }
        var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
        return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    Color[model] = function (color) {
        if (typeof color === 'number') {
            color = zeroArray(_slice.call(arguments), channels);
        }
        return new Color(color, model);
    };
});
function roundTo(num, places) {
    return Number(num.toFixed(places));
}
function roundToPlace(places) {
    return function (num) {
        return roundTo(num, places);
    };
}
function getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [model];
    model.forEach(function (m) {
        (limiters[m] || (limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function (val) {
        var result;
        if (arguments.length) {
            if (modifier) {
                val = modifier(val);
            }
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) {
            result = modifier(result);
        }
        return result;
    };
}
function maxfn(max) {
    return function (v) {
        return Math.max(0, Math.min(max, v));
    };
}
function assertArray(val) {
    return Array.isArray(val) ? val : [val];
}
function zeroArray(arr, length) {
    for (var i = 0; i < length; i++) {
        if (typeof arr[i] !== 'number') {
            arr[i] = 0;
        }
    }
    return arr;
}
module.exports = Color;
},{"color-convert":414,"color-string":417}],419:[function(require,module,exports){
/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};

},{}],420:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],421:[function(require,module,exports){

module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};
},{}],422:[function(require,module,exports){
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

'use strict'

/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */
var PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g
var TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/
var TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/

/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */
var QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g

/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */
var QUOTE_REGEXP = /([\\"])/g

/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */
var TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/

/**
 * Module exports.
 * @public
 */

exports.format = format
exports.parse = parse

/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */

function format (obj) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('argument obj is required')
  }

  var parameters = obj.parameters
  var type = obj.type

  if (!type || !TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid type')
  }

  var string = type

  // append parameters
  if (parameters && typeof parameters === 'object') {
    var param
    var params = Object.keys(parameters).sort()

    for (var i = 0; i < params.length; i++) {
      param = params[i]

      if (!TOKEN_REGEXP.test(param)) {
        throw new TypeError('invalid parameter name')
      }

      string += '; ' + param + '=' + qstring(parameters[param])
    }
  }

  return string
}

/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */

function parse (string) {
  if (!string) {
    throw new TypeError('argument string is required')
  }

  // support req/res-like objects as argument
  var header = typeof string === 'object'
    ? getcontenttype(string)
    : string

  if (typeof header !== 'string') {
    throw new TypeError('argument string is required to be a string')
  }

  var index = header.indexOf(';')
  var type = index !== -1
    ? header.substr(0, index).trim()
    : header.trim()

  if (!TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid media type')
  }

  var obj = new ContentType(type.toLowerCase())

  // parse parameters
  if (index !== -1) {
    var key
    var match
    var value

    PARAM_REGEXP.lastIndex = index

    while ((match = PARAM_REGEXP.exec(header))) {
      if (match.index !== index) {
        throw new TypeError('invalid parameter format')
      }

      index += match[0].length
      key = match[1].toLowerCase()
      value = match[2]

      if (value[0] === '"') {
        // remove quotes and escapes
        value = value
          .substr(1, value.length - 2)
          .replace(QESC_REGEXP, '$1')
      }

      obj.parameters[key] = value
    }

    if (index !== header.length) {
      throw new TypeError('invalid parameter format')
    }
  }

  return obj
}

/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */

function getcontenttype (obj) {
  var header

  if (typeof obj.getHeader === 'function') {
    // res-like
    header = obj.getHeader('content-type')
  } else if (typeof obj.headers === 'object') {
    // req-like
    header = obj.headers && obj.headers['content-type']
  }

  if (typeof header !== 'string') {
    throw new TypeError('content-type header is missing from object')
  }

  return header
}

/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring (val) {
  var str = String(val)

  // no need to quote tokens
  if (TOKEN_REGEXP.test(str)) {
    return str
  }

  if (str.length > 0 && !TEXT_REGEXP.test(str)) {
    throw new TypeError('invalid parameter value')
  }

  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"'
}

/**
 * Class to represent a content type.
 * @private
 */
function ContentType (type) {
  this.parameters = Object.create(null)
  this.type = type
}

},{}],423:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":453,"../../modules/es6.array.from":518,"../../modules/es6.string.iterator":533}],424:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');

},{"../modules/core.get-iterator":517,"../modules/es6.string.iterator":533,"../modules/web.dom.iterable":543}],425:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
require('../modules/es7.map.to-json');
require('../modules/es7.map.of');
require('../modules/es7.map.from');
module.exports = require('../modules/_core').Map;

},{"../modules/_core":453,"../modules/es6.map":520,"../modules/es6.object.to-string":530,"../modules/es6.string.iterator":533,"../modules/es7.map.from":535,"../modules/es7.map.of":536,"../modules/es7.map.to-json":537,"../modules/web.dom.iterable":543}],426:[function(require,module,exports){
require('../../modules/es6.number.epsilon');
module.exports = Math.pow(2, -52);

},{"../../modules/es6.number.epsilon":521}],427:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":453,"../../modules/es6.object.assign":522}],428:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

},{"../../modules/_core":453,"../../modules/es6.object.create":523}],429:[function(require,module,exports){
require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};

},{"../../modules/_core":453,"../../modules/es6.object.define-properties":524}],430:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":453,"../../modules/es6.object.define-property":525}],431:[function(require,module,exports){
require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;

},{"../../modules/_core":453,"../../modules/es6.object.freeze":526}],432:[function(require,module,exports){
require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};

},{"../../modules/_core":453,"../../modules/es6.object.get-own-property-descriptor":527}],433:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":453,"../../modules/es6.object.keys":528}],434:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;

},{"../../modules/_core":453,"../../modules/es6.object.set-prototype-of":529}],435:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
require('../modules/es7.set.to-json');
require('../modules/es7.set.of');
require('../modules/es7.set.from');
module.exports = require('../modules/_core').Set;

},{"../modules/_core":453,"../modules/es6.object.to-string":530,"../modules/es6.set":531,"../modules/es6.string.iterator":533,"../modules/es7.set.from":538,"../modules/es7.set.of":539,"../modules/es7.set.to-json":540,"../modules/web.dom.iterable":543}],436:[function(require,module,exports){
require('../../modules/es6.string.from-code-point');
module.exports = require('../../modules/_core').String.fromCodePoint;

},{"../../modules/_core":453,"../../modules/es6.string.from-code-point":532}],437:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":453,"../../modules/es6.object.to-string":530,"../../modules/es6.symbol":534,"../../modules/es7.symbol.async-iterator":541,"../../modules/es7.symbol.observable":542}],438:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":514,"../../modules/es6.string.iterator":533,"../../modules/web.dom.iterable":543}],439:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],440:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],441:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],442:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":472}],443:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":463}],444:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":505,"./_to-iobject":507,"./_to-length":508}],445:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":447,"./_ctx":455,"./_iobject":469,"./_to-length":508,"./_to-object":509}],446:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":471,"./_is-object":472,"./_wks":515}],447:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":446}],448:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":449,"./_wks":515}],449:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],450:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":441,"./_ctx":455,"./_descriptors":457,"./_for-of":463,"./_iter-define":475,"./_iter-step":477,"./_meta":480,"./_object-create":482,"./_object-dp":483,"./_redefine-all":495,"./_set-species":500,"./_validate-collection":512}],451:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":443,"./_classof":448}],452:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var meta = require('./_meta');
var fails = require('./_fails');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var setToStringTag = require('./_set-to-string-tag');
var dP = require('./_object-dp').f;
var each = require('./_array-methods')(0);
var DESCRIPTORS = require('./_descriptors');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":441,"./_array-methods":445,"./_descriptors":457,"./_export":461,"./_fails":462,"./_for-of":463,"./_global":464,"./_hide":466,"./_is-object":472,"./_meta":480,"./_object-dp":483,"./_redefine-all":495,"./_set-to-string-tag":501}],453:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],454:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":483,"./_property-desc":494}],455:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":439}],456:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],457:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":462}],458:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":464,"./_is-object":472}],459:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],460:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":488,"./_object-keys":491,"./_object-pie":492}],461:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":453,"./_ctx":455,"./_global":464,"./_has":465,"./_hide":466}],462:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],463:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":442,"./_ctx":455,"./_is-array-iter":470,"./_iter-call":473,"./_to-length":508,"./core.get-iterator-method":516}],464:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],465:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],466:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":457,"./_object-dp":483,"./_property-desc":494}],467:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":464}],468:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":457,"./_dom-create":458,"./_fails":462}],469:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":449}],470:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":478,"./_wks":515}],471:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":449}],472:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],473:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":442}],474:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":466,"./_object-create":482,"./_property-desc":494,"./_set-to-string-tag":501,"./_wks":515}],475:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":461,"./_hide":466,"./_iter-create":474,"./_iterators":478,"./_library":479,"./_object-gpo":489,"./_redefine":496,"./_set-to-string-tag":501,"./_wks":515}],476:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":515}],477:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],478:[function(require,module,exports){
module.exports = {};

},{}],479:[function(require,module,exports){
module.exports = true;

},{}],480:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":462,"./_has":465,"./_is-object":472,"./_object-dp":483,"./_uid":511}],481:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":457,"./_fails":462,"./_iobject":469,"./_object-gops":488,"./_object-keys":491,"./_object-pie":492,"./_to-object":509}],482:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":442,"./_dom-create":458,"./_enum-bug-keys":459,"./_html":467,"./_object-dps":484,"./_shared-key":502}],483:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":442,"./_descriptors":457,"./_ie8-dom-define":468,"./_to-primitive":510}],484:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":442,"./_descriptors":457,"./_object-dp":483,"./_object-keys":491}],485:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":457,"./_has":465,"./_ie8-dom-define":468,"./_object-pie":492,"./_property-desc":494,"./_to-iobject":507,"./_to-primitive":510}],486:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":487,"./_to-iobject":507}],487:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":459,"./_object-keys-internal":490}],488:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],489:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":465,"./_shared-key":502,"./_to-object":509}],490:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":444,"./_has":465,"./_shared-key":502,"./_to-iobject":507}],491:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":459,"./_object-keys-internal":490}],492:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],493:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":453,"./_export":461,"./_fails":462}],494:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],495:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":466}],496:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":466}],497:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":439,"./_ctx":455,"./_export":461,"./_for-of":463}],498:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":461}],499:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":442,"./_ctx":455,"./_is-object":472,"./_object-gopd":485}],500:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":453,"./_descriptors":457,"./_global":464,"./_object-dp":483,"./_wks":515}],501:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":465,"./_object-dp":483,"./_wks":515}],502:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":503,"./_uid":511}],503:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":453,"./_global":464,"./_library":479}],504:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":456,"./_to-integer":506}],505:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":506}],506:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],507:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":456,"./_iobject":469}],508:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":506}],509:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":456}],510:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":472}],511:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],512:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":472}],513:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":453,"./_global":464,"./_library":479,"./_object-dp":483,"./_wks-ext":514}],514:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":515}],515:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":464,"./_shared":503,"./_uid":511}],516:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":448,"./_core":453,"./_iterators":478,"./_wks":515}],517:[function(require,module,exports){
var anObject = require('./_an-object');
var get = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

},{"./_an-object":442,"./_core":453,"./core.get-iterator-method":516}],518:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":454,"./_ctx":455,"./_export":461,"./_is-array-iter":470,"./_iter-call":473,"./_iter-detect":476,"./_to-length":508,"./_to-object":509,"./core.get-iterator-method":516}],519:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":440,"./_iter-define":475,"./_iter-step":477,"./_iterators":478,"./_to-iobject":507}],520:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":452,"./_collection-strong":450,"./_validate-collection":512}],521:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":461}],522:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":461,"./_object-assign":481}],523:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":461,"./_object-create":482}],524:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":457,"./_export":461,"./_object-dps":484}],525:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":457,"./_export":461,"./_object-dp":483}],526:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":472,"./_meta":480,"./_object-sap":493}],527:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":485,"./_object-sap":493,"./_to-iobject":507}],528:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":491,"./_object-sap":493,"./_to-object":509}],529:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":461,"./_set-proto":499}],530:[function(require,module,exports){
arguments[4][402][0].apply(exports,arguments)
},{"dup":402}],531:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":452,"./_collection-strong":450,"./_validate-collection":512}],532:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":461,"./_to-absolute-index":505}],533:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":475,"./_string-at":504}],534:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":442,"./_descriptors":457,"./_enum-keys":460,"./_export":461,"./_fails":462,"./_global":464,"./_has":465,"./_hide":466,"./_is-array":471,"./_is-object":472,"./_library":479,"./_meta":480,"./_object-create":482,"./_object-dp":483,"./_object-gopd":485,"./_object-gopn":487,"./_object-gopn-ext":486,"./_object-gops":488,"./_object-keys":491,"./_object-pie":492,"./_property-desc":494,"./_redefine":496,"./_set-to-string-tag":501,"./_shared":503,"./_to-iobject":507,"./_to-object":509,"./_to-primitive":510,"./_uid":511,"./_wks":515,"./_wks-define":513,"./_wks-ext":514}],535:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":497}],536:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":498}],537:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":451,"./_export":461}],538:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":497}],539:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":498}],540:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":451,"./_export":461}],541:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":513}],542:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":513}],543:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":464,"./_hide":466,"./_iterators":478,"./_wks":515,"./es6.array.iterator":519}],544:[function(require,module,exports){
(function (Buffer){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

}).call(this)}).call(this,{"isBuffer":require("../../is-buffer/index.js")})
},{"../../is-buffer/index.js":671}],545:[function(require,module,exports){
/*!
 * Cropper.js v1.5.9
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-09-10T13:16:26.743Z
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Cropper = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper'; // Actions

  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw'; // Classes

  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys

  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes

  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none'; // Events

  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom'; // Mime types

  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps

  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
  // Inspired by the default width and height of a canvas element.

  var MIN_CONTAINER_WIDTH = 200;
  var MIN_CONTAINER_HEIGHT = 100;

  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3
    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'
    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: MIN_CONTAINER_WIDTH,
    minContainerHeight: MIN_CONTAINER_HEIGHT,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

  /**
   * Check if the given value is not a number.
   */

  var isNaN = Number.isNaN || WINDOW.isNaN;
  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */

  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */

  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */

  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }

    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }
  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */

  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length)
      /* array-like */
      ) {
          toArray(data).forEach(function (value, key) {
            callback.call(data, value, key, data);
          });
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */

  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }

    return target;
  };
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }
  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */

  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }

      style[property] = value;
    });
  }
  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */

  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }
  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */

  function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }
  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */

  function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */

  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    } // IE10-11 doesn't support the second parameter of `classList.toggle`


    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */

  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }
  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */

  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }

    if (element.dataset) {
      return element.dataset[name];
    }

    return element.getAttribute("data-".concat(toParamCase(name)));
  }
  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */

  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }
  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */

  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }
  var REGEXP_SPACES = /\s\s*/;

  var onceSupported = function () {
    var supported = false;

    if (IS_BROWSER) {
      var once = false;

      var listener = function listener() {};

      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },

        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }

    return supported;
  }();
  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;

        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];

          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }

          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }

      element.removeEventListener(event, handler, options);
    });
  }
  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */

  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
            listeners = _element$listeners === void 0 ? {} : _element$listeners;

        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          listener.apply(element, args);
        };

        if (!listeners[event]) {
          listeners[event] = {};
        }

        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }

        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }

      element.addEventListener(event, _handler, options);
    });
  }
  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */

  function dispatchEvent(element, type, data) {
    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }

    return element.dispatchEvent(event);
  }
  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */

  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }
  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */

  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }
  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */

  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }
  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */

  function getTransforms(_ref) {
    var rotate = _ref.rotate,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        translateX = _ref.translateX,
        translateY = _ref.translateY;
    var values = [];

    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }

    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    } // Rotate should come first before scale to match orientation transform


    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }

    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }
  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */

  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);

    var maxRatio = 0;
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;

        if (Math.abs(ratio) > Math.abs(maxRatio)) {
          maxRatio = ratio;
        }
      });
    });
    return maxRatio;
  }
  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */

  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
        pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      startX: pageX,
      startY: pageY
    }, end);
  }
  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */

  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
          startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */

  function getAdjustedSizes(_ref4) // or 'cover'
  {
    var aspectRatio = _ref4.aspectRatio,
        height = _ref4.height,
        width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }
  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */

  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
        height = _ref5.height,
        degree = _ref5.degree;
    degree = Math.abs(degree) % 180;

    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }

    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }
  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */

  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
        imageNaturalWidth = _ref6.naturalWidth,
        imageNaturalHeight = _ref6.naturalHeight,
        _ref6$rotate = _ref6.rotate,
        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
        _ref6$scaleX = _ref6.scaleX,
        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
        _ref6$scaleY = _ref6.scaleY,
        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
        naturalWidth = _ref7.naturalWidth,
        naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
        _ref8$maxWidth = _ref8.maxWidth,
        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
        _ref8$maxHeight = _ref8.maxHeight,
        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
        _ref8$minWidth = _ref8.minWidth,
        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
        _ref8$minHeight = _ref8.minHeight,
        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90

    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }
  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;

    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }
  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = []; // Chunk Typed Array for better performance (#435)

    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */

  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (error) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */

  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
          options = this.options,
          container = this.container,
          cropper = this.cropper;
      var minWidth = Number(options.minContainerWidth);
      var minHeight = Number(options.minContainerHeight);
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
        height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
          imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;

      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }

      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      canvasData.left = (containerData.width - canvasData.width) / 2;
      canvasData.top = (containerData.height - canvasData.height) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;

      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;

        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }

        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });

        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }

      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);

          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;

            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }

              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;

      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
            naturalWidth = _getRotatedSizes.width,
            naturalHeight = _getRotatedSizes.height;

        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }

      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }

      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }

      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);

      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));

      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
          canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };

      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true); // Initialize auto crop area

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"

      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData,
          limited = this.limited;
      var aspectRatio = options.aspectRatio;

      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height

        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        } // The minWidth/Height must be less than maxWidth/Height


        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }

      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData;

      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }

      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }

      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));

      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };

  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
          crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;

      if (!preview) {
        return;
      }

      var previews = preview;

      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }

      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img'); // Save the original size for recover

        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });

        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }

        img.src = url;
        img.alt = alt;
        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */

        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
          cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
          height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;

      if (!this.cropped || this.disabled) {
        return;
      }

      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };

  var events = {
    bind: function bind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }

      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }

      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }

      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }

      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };

  var handlers = {
    resize: function resize() {
      if (this.disabled) {
        return;
      }

      var options = this.options,
          container = this.container,
          containerData = this.containerData;
      var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed

      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
        var canvasData;
        var cropBoxData;

        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }

      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;

      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.wheeling) {
        return;
      }

      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
          button = event.button;

      if (this.disabled // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && ( // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey)) {
        return;
      }

      var options = this.options,
          pointers = this.pointers;
      var action;

      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }

      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }

      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }

      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      } // This line is required for preventing page zooming in iOS browsers


      event.preventDefault();
      this.action = action;
      this.cropping = false;

      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;

      if (this.disabled || !action) {
        return;
      }

      var pointers = this.pointers;
      event.preventDefault();

      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }

      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }

      var action = this.action,
          pointers = this.pointers;

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }

      if (!action) {
        return;
      }

      event.preventDefault();

      if (!Object.keys(pointers).length) {
        this.action = '';
      }

      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }

      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };

  var change = {
    change: function change(event) {
      var options = this.options,
          canvasData = this.canvasData,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData,
          pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
          top = cropBoxData.top,
          width = cropBoxData.width,
          height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset; // Locking aspect ratio in "free mode" by holding shift key

      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }

      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };

      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }

            break;

          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }

            break;

          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }

            break;

          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }

            break;
        }
      };

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;
        // Resize crop box

        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;

          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;

          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;

          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_SOUTH);
          height += range.y;

          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }

          break;
        // Move canvas

        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;
        // Zoom canvas

        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;
        // Create crop box

        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          } // Show the crop box if is hidden


          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;

            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }

          break;
      }

      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      } // Override


      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };

  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }

        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }

      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();

        if (this.cropped) {
          this.renderCropBox();
        }
      }

      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true); // Render canvas after crop box rendered

        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }

      return this;
    },

    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }

        if (hasSameSize) {
          this.url = url;
          this.image.src = url;

          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }

          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }

      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },

    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;

      if (!element[NAMESPACE]) {
        return this;
      }

      element[NAMESPACE] = undefined;

      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }

      this.uncreate();
      return this;
    },

    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
          left = _this$canvasData.left,
          top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },

    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);

      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }

        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }

        if (changed) {
          this.renderCanvas(true);
        }
      }

      return this;
    },

    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);

      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },

    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
          canvasData = this.canvasData;
      var width = canvasData.width,
          height = canvasData.height,
          naturalWidth = canvasData.naturalWidth,
          naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);

      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;

        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }

        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          }; // Zoom from the triggering point of the event

          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }

        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);

      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }

      return this;
    },

    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },

    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);

      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }

        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }
      }

      return this;
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });

        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData;
      var cropBoxData = {};

      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;

        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }

        var ratio = imageData.width / imageData.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }

      return this;
    },

    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },

    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },

    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};

      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;

      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }

        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }

        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;

      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }

        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }

        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }

        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }

      return this;
    },

    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }

      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.

      if (!this.cropped) {
        return source;
      }

      var _this$getData = this.getData(),
          initialX = _this$getData.x,
          initialY = _this$getData.y,
          initialWidth = _this$getData.width,
          initialHeight = _this$getData.height;

      var ratio = source.width / Math.floor(canvasData.naturalWidth);

      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }

      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
          width = _getAdjustedSizes.width,
          height = _getAdjustedSizes.height;

      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
          imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;

      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage


      var sourceWidth = source.width;
      var sourceHeight = source.height; // Source canvas parameters

      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight; // Destination canvas parameters

      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;

      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }

      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }

      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"

      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      } // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476


      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;

        if (this.ready) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }

      return this;
    },

    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
          dragBox = this.dragBox,
          face = this.face;

      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }

      return this;
    }
  };

  var AnotherCropper = WINDOW.Cropper;

  var Cropper = /*#__PURE__*/function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Cropper);

      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }

      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }

    _createClass(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;

        if (element[NAMESPACE]) {
          return;
        }

        element[NAMESPACE] = this;

        if (tagName === 'img') {
          this.isImg = true; // e.g.: "img/picture.jpg"

          url = element.getAttribute('src') || '';
          this.originalUrl = url; // Stop when it's a blank image

          if (!url) {
            return;
          } // e.g.: "https://example.com/img/picture.jpg"


          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }

        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;

        if (!url) {
          return;
        }

        this.url = url;
        this.imageData = {};
        var element = this.element,
            options = this.options;

        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        } // Only IE10+ supports Typed Arrays


        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        } // Detect the mime type of the image directly if it is a Data URL


        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }

          return;
        } // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.


        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.

        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;

        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };

        xhr.onload = function () {
          _this.read(xhr.response);
        };

        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error


        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        }

        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
            imageData = this.imageData; // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation

        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;

        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);

          var _parseOrientation = parseOrientation(orientation);

          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }

        if (options.rotatable) {
          imageData.rotate = rotate;
        }

        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }

        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
            url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;

        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          } // Bust cache when there is not a "crossOrigin" property (#519)


          crossOriginUrl = addTimestamp(url);
        }

        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');

        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }

        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.

        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);

        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.initialImageData = assign({}, _this2.imageData);
          _this2.sizing = false;
          _this2.sized = true;

          _this2.build();
        }; // Most modern browsers (excepts iOS WebKit)


        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }

        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;

        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);

          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };

        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)

        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }

        var element = this.element,
            options = this.options,
            image = this.image; // Create cropper elements

        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image); // Hide the original image

        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image

        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden

        if (!this.isImg) {
          removeClass(image, CLASS_HIDE);
        }

        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);

        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }

        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }

        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }

        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }

        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }

        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }

        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);

        if (options.autoCrop) {
          this.crop();
        }

        this.setData(options.data);

        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }

        this.ready = false;
        this.unbind();
        this.resetPreview();
        this.cropper.parentNode.removeChild(this.cropper);
        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }
      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);

    return Cropper;
  }();

  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  return Cropper;

})));

},{}],546:[function(require,module,exports){
/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */
;
(function() {

    /**
     * Class for dimension change detection.
     *
     * @param {Element|Element[]|Elements|jQuery} element
     * @param {Function} callback
     *
     * @constructor
     */
    var ResizeSensor = function(element, callback) {
        /**
         *
         * @constructor
         */
        function EventQueue() {
            this.q = [];
            this.add = function(ev) {
                this.q.push(ev);
            };

            var i, j;
            this.call = function() {
                for (i = 0, j = this.q.length; i < j; i++) {
                    this.q[i].call();
                }
            };
        }

        /**
         * @param {HTMLElement} element
         * @param {String}      prop
         * @returns {String|Number}
         */
        function getComputedStyle(element, prop) {
            if (element.currentStyle) {
                return element.currentStyle[prop];
            } else if (window.getComputedStyle) {
                return window.getComputedStyle(element, null).getPropertyValue(prop);
            } else {
                return element.style[prop];
            }
        }

        /**
         *
         * @param {HTMLElement} element
         * @param {Function}    resized
         */
        function attachResizeEvent(element, resized) {
            if (!element.resizedAttached) {
                element.resizedAttached = new EventQueue();
                element.resizedAttached.add(resized);
            } else if (element.resizedAttached) {
                element.resizedAttached.add(resized);
                return;
            }

            element.resizeSensor = document.createElement('div');
            element.resizeSensor.className = 'resize-sensor';
            var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
            var styleChild = 'position: absolute; left: 0; top: 0; transition: 0s;';

            element.resizeSensor.style.cssText = style;
            element.resizeSensor.innerHTML =
                '<div class="resize-sensor-expand" style="' + style + '">' +
                    '<div style="' + styleChild + '"></div>' +
                '</div>' +
                '<div class="resize-sensor-shrink" style="' + style + '">' +
                    '<div style="' + styleChild + ' width: 200%; height: 200%"></div>' +
                '</div>';
            element.appendChild(element.resizeSensor);

            if (!{fixed: 1, absolute: 1}[getComputedStyle(element, 'position')]) {
                element.style.position = 'relative';
            }

            var expand = element.resizeSensor.childNodes[0];
            var expandChild = expand.childNodes[0];
            var shrink = element.resizeSensor.childNodes[1];
            var shrinkChild = shrink.childNodes[0];

            var lastWidth, lastHeight;

            var reset = function() {
                expandChild.style.width = expand.offsetWidth + 10 + 'px';
                expandChild.style.height = expand.offsetHeight + 10 + 'px';
                expand.scrollLeft = expand.scrollWidth;
                expand.scrollTop = expand.scrollHeight;
                shrink.scrollLeft = shrink.scrollWidth;
                shrink.scrollTop = shrink.scrollHeight;
                lastWidth = element.offsetWidth;
                lastHeight = element.offsetHeight;
            };

            reset();

            var changed = function() {
                if (element.resizedAttached) {
                    element.resizedAttached.call();
                }
            };

            var addEvent = function(el, name, cb) {
                if (el.attachEvent) {
                    el.attachEvent('on' + name, cb);
                } else {
                    el.addEventListener(name, cb);
                }
            };

            var onScroll = function() {
              if (element.offsetWidth != lastWidth || element.offsetHeight != lastHeight) {
                  changed();
              }
              reset();
            };

            addEvent(expand, 'scroll', onScroll);
            addEvent(shrink, 'scroll', onScroll);
        }

        var elementType = Object.prototype.toString.call(element);
        var isCollectionTyped = ('[object Array]' === elementType
            || ('[object NodeList]' === elementType)
            || ('[object HTMLCollection]' === elementType)
            || ('undefined' !== typeof jQuery && element instanceof jQuery) //jquery
            || ('undefined' !== typeof Elements && element instanceof Elements) //mootools
        );

        if (isCollectionTyped) {
            var i = 0, j = element.length;
            for (; i < j; i++) {
                attachResizeEvent(element[i], callback);
            }
        } else {
            attachResizeEvent(element, callback);
        }

        this.detach = function() {
            if (isCollectionTyped) {
                var i = 0, j = element.length;
                for (; i < j; i++) {
                    ResizeSensor.detach(element[i]);
                }
            } else {
                ResizeSensor.detach(element);
            }
        };
    };

    ResizeSensor.detach = function(element) {
        if (element.resizeSensor) {
            element.removeChild(element.resizeSensor);
            delete element.resizeSensor;
            delete element.resizedAttached;
        }
    };

    // make available to common module loader
    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = ResizeSensor;
    }
    else {
        window.ResizeSensor = ResizeSensor;
    }

})();

},{}],547:[function(require,module,exports){
var objectKeys = require('object-keys');
var isArguments = require('is-arguments');
var is = require('object-is');
var isRegex = require('is-regex');
var flags = require('regexp.prototype.flags');
var isDate = require('is-date-object');

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;

},{"is-arguments":669,"is-date-object":672,"is-regex":673,"object-is":881,"object-keys":885,"regexp.prototype.flags":1133}],548:[function(require,module,exports){
module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};

},{}],549:[function(require,module,exports){
'use strict';

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;

},{}],550:[function(require,module,exports){
'use strict';

var keys = require('object-keys');
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

},{"object-keys":885}],551:[function(require,module,exports){
/**
 * A simple dependency graph
 */

/**
 * Helper for creating a Topological Sort using Depth-First-Search on a set of edges.
 *
 * Detects cycles and throws an Error if one is detected (unless the "circular"
 * parameter is "true" in which case it ignores them).
 *
 * @param edges The set of edges to DFS through
 * @param leavesOnly Whether to only return "leaf" nodes (ones who have no edges)
 * @param result An array in which the results will be populated
 * @param circular A boolean to allow circular dependencies
 */
function createDFS(edges, leavesOnly, result, circular) {
  var visited = {};
  return function (start) {
    if (visited[start]) {
      return;
    }
    var inCurrentPath = {};
    var currentPath = [];
    var todo = []; // used as a stack
    todo.push({ node: start, processed: false });
    while (todo.length > 0) {
      var current = todo[todo.length - 1]; // peek at the todo stack
      var processed = current.processed;
      var node = current.node;
      if (!processed) {
        // Haven't visited edges yet (visiting phase)
        if (visited[node]) {
          todo.pop();
          continue;
        } else if (inCurrentPath[node]) {
          // It's not a DAG
          if (circular) {
            todo.pop();
            // If we're tolerating cycles, don't revisit the node
            continue;
          }
          currentPath.push(node);
          throw new DepGraphCycleError(currentPath);
        }

        inCurrentPath[node] = true;
        currentPath.push(node);
        var nodeEdges = edges[node];
        // (push edges onto the todo stack in reverse order to be order-compatible with the old DFS implementation)
        for (var i = nodeEdges.length - 1; i >= 0; i--) {
          todo.push({ node: nodeEdges[i], processed: false });
        }
        current.processed = true;
      } else {
        // Have visited edges (stack unrolling phase)
        todo.pop();
        currentPath.pop();
        inCurrentPath[node] = false;
        visited[node] = true;
        if (!leavesOnly || edges[node].length === 0) {
          result.push(node);
        }
      }
    }
  };
}

/**
 * Simple Dependency Graph
 */
var DepGraph = (exports.DepGraph = function DepGraph(opts) {
  this.nodes = {}; // Node -> Node/Data (treated like a Set)
  this.outgoingEdges = {}; // Node -> [Dependency Node]
  this.incomingEdges = {}; // Node -> [Dependant Node]
  this.circular = opts && !!opts.circular; // Allows circular deps
});
DepGraph.prototype = {
  /**
   * The number of nodes in the graph.
   */
  size: function () {
    return Object.keys(this.nodes).length;
  },
  /**
   * Add a node to the dependency graph. If a node already exists, this method will do nothing.
   */
  addNode: function (node, data) {
    if (!this.hasNode(node)) {
      // Checking the arguments length allows the user to add a node with undefined data
      if (arguments.length === 2) {
        this.nodes[node] = data;
      } else {
        this.nodes[node] = node;
      }
      this.outgoingEdges[node] = [];
      this.incomingEdges[node] = [];
    }
  },
  /**
   * Remove a node from the dependency graph. If a node does not exist, this method will do nothing.
   */
  removeNode: function (node) {
    if (this.hasNode(node)) {
      delete this.nodes[node];
      delete this.outgoingEdges[node];
      delete this.incomingEdges[node];
      [this.incomingEdges, this.outgoingEdges].forEach(function (edgeList) {
        Object.keys(edgeList).forEach(function (key) {
          var idx = edgeList[key].indexOf(node);
          if (idx >= 0) {
            edgeList[key].splice(idx, 1);
          }
        }, this);
      });
    }
  },
  /**
   * Check if a node exists in the graph
   */
  hasNode: function (node) {
    return this.nodes.hasOwnProperty(node);
  },
  /**
   * Get the data associated with a node name
   */
  getNodeData: function (node) {
    if (this.hasNode(node)) {
      return this.nodes[node];
    } else {
      throw new Error("Node does not exist: " + node);
    }
  },
  /**
   * Set the associated data for a given node name. If the node does not exist, this method will throw an error
   */
  setNodeData: function (node, data) {
    if (this.hasNode(node)) {
      this.nodes[node] = data;
    } else {
      throw new Error("Node does not exist: " + node);
    }
  },
  /**
   * Add a dependency between two nodes. If either of the nodes does not exist,
   * an Error will be thrown.
   */
  addDependency: function (from, to) {
    if (!this.hasNode(from)) {
      throw new Error("Node does not exist: " + from);
    }
    if (!this.hasNode(to)) {
      throw new Error("Node does not exist: " + to);
    }
    if (this.outgoingEdges[from].indexOf(to) === -1) {
      this.outgoingEdges[from].push(to);
    }
    if (this.incomingEdges[to].indexOf(from) === -1) {
      this.incomingEdges[to].push(from);
    }
    return true;
  },
  /**
   * Remove a dependency between two nodes.
   */
  removeDependency: function (from, to) {
    var idx;
    if (this.hasNode(from)) {
      idx = this.outgoingEdges[from].indexOf(to);
      if (idx >= 0) {
        this.outgoingEdges[from].splice(idx, 1);
      }
    }

    if (this.hasNode(to)) {
      idx = this.incomingEdges[to].indexOf(from);
      if (idx >= 0) {
        this.incomingEdges[to].splice(idx, 1);
      }
    }
  },
  /**
   * Return a clone of the dependency graph. If any custom data is attached
   * to the nodes, it will only be shallow copied.
   */
  clone: function () {
    var source = this;
    var result = new DepGraph();
    var keys = Object.keys(source.nodes);
    keys.forEach(function (n) {
      result.nodes[n] = source.nodes[n];
      result.outgoingEdges[n] = source.outgoingEdges[n].slice(0);
      result.incomingEdges[n] = source.incomingEdges[n].slice(0);
    });
    return result;
  },
  /**
   * Get an array containing the direct dependencies of the specified node.
   *
   * Throws an Error if the specified node does not exist.
   */
  directDependenciesOf: function (node) {
    if (this.hasNode(node)) {
      return this.outgoingEdges[node].slice(0);
    } else {
      throw new Error("Node does not exist: " + node);
    }
  },
  /**
   * Get an array containing the nodes that directly depend on the specified node.
   *
   * Throws an Error if the specified node does not exist.
   */
  directDependantsOf: function (node) {
    if (this.hasNode(node)) {
      return this.incomingEdges[node].slice(0);
    } else {
      throw new Error("Node does not exist: " + node);
    }
  },
  /**
   * Get an array containing the nodes that the specified node depends on (transitively).
   *
   * Throws an Error if the graph has a cycle, or the specified node does not exist.
   *
   * If `leavesOnly` is true, only nodes that do not depend on any other nodes will be returned
   * in the array.
   */
  dependenciesOf: function (node, leavesOnly) {
    if (this.hasNode(node)) {
      var result = [];
      var DFS = createDFS(
        this.outgoingEdges,
        leavesOnly,
        result,
        this.circular
      );
      DFS(node);
      var idx = result.indexOf(node);
      if (idx >= 0) {
        result.splice(idx, 1);
      }
      return result;
    } else {
      throw new Error("Node does not exist: " + node);
    }
  },
  /**
   * get an array containing the nodes that depend on the specified node (transitively).
   *
   * Throws an Error if the graph has a cycle, or the specified node does not exist.
   *
   * If `leavesOnly` is true, only nodes that do not have any dependants will be returned in the array.
   */
  dependantsOf: function (node, leavesOnly) {
    if (this.hasNode(node)) {
      var result = [];
      var DFS = createDFS(
        this.incomingEdges,
        leavesOnly,
        result,
        this.circular
      );
      DFS(node);
      var idx = result.indexOf(node);
      if (idx >= 0) {
        result.splice(idx, 1);
      }
      return result;
    } else {
      throw new Error("Node does not exist: " + node);
    }
  },
  /**
   * Construct the overall processing order for the dependency graph.
   *
   * Throws an Error if the graph has a cycle.
   *
   * If `leavesOnly` is true, only nodes that do not depend on any other nodes will be returned.
   */
  overallOrder: function (leavesOnly) {
    var self = this;
    var result = [];
    var keys = Object.keys(this.nodes);
    if (keys.length === 0) {
      return result; // Empty graph
    } else {
      if (!this.circular) {
        // Look for cycles - we run the DFS starting at all the nodes in case there
        // are several disconnected subgraphs inside this dependency graph.
        var CycleDFS = createDFS(this.outgoingEdges, false, [], this.circular);
        keys.forEach(function (n) {
          CycleDFS(n);
        });
      }

      var DFS = createDFS(
        this.outgoingEdges,
        leavesOnly,
        result,
        this.circular
      );
      // Find all potential starting points (nodes with nothing depending on them) an
      // run a DFS starting at these points to get the order
      keys
        .filter(function (node) {
          return self.incomingEdges[node].length === 0;
        })
        .forEach(function (n) {
          DFS(n);
        });

      // If we're allowing cycles - we need to run the DFS against any remaining
      // nodes that did not end up in the initial result (as they are part of a
      // subgraph that does not have a clear starting point)
      if (this.circular) {
        keys
          .filter(function (node) {
            return result.indexOf(node) === -1;
          })
          .forEach(function (n) {
            DFS(n);
          });
      }

      return result;
    }
  },
  /**
   * Get an array of nodes that have no dependants (i.e. nothing depends on them).
   */
  entryNodes: function () {
    var self = this;
    return Object.keys(this.nodes).filter(function (node) {
      return self.incomingEdges[node].length === 0;
    });
  }
};

// Create some aliases
DepGraph.prototype.directDependentsOf = DepGraph.prototype.directDependantsOf;
DepGraph.prototype.dependentsOf = DepGraph.prototype.dependantsOf;

/**
 * Cycle error, including the path of the cycle.
 */
var DepGraphCycleError = (exports.DepGraphCycleError = function (cyclePath) {
  var message = "Dependency Cycle Found: " + cyclePath.join(" -> ");
  var instance = new Error(message);
  instance.cyclePath = cyclePath;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, DepGraphCycleError);
  }
  return instance;
});
DepGraphCycleError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(DepGraphCycleError, Error);

},{}],552:[function(require,module,exports){
'use strict';

var INITIAL_STATE = 1;
var FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */

class StateMachine {
  constructor(dfa) {
    this.stateTable = dfa.stateTable;
    this.accepting = dfa.accepting;
    this.tags = dfa.tags;
  }
  /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */


  match(str) {
    var self = this;
    return {
      *[Symbol.iterator]() {
        var state = INITIAL_STATE;
        var startRun = null;
        var lastAccepting = null;
        var lastState = null;

        for (var p = 0; p < str.length; p++) {
          var c = str[p];
          lastState = state;
          state = self.stateTable[state][c];

          if (state === FAIL_STATE) {
            // yield the last match if any
            if (startRun != null && lastAccepting != null && lastAccepting >= startRun) {
              yield [startRun, lastAccepting, self.tags[lastState]];
            } // reset the state as if we started over from the initial state


            state = self.stateTable[INITIAL_STATE][c];
            startRun = null;
          } // start a run if not in the failure state


          if (state !== FAIL_STATE && startRun == null) {
            startRun = p;
          } // if accepting, mark the potential match end


          if (self.accepting[state]) {
            lastAccepting = p;
          } // reset the state to the initial state if we get into the failure state


          if (state === FAIL_STATE) {
            state = INITIAL_STATE;
          }
        } // yield the last match if any


        if (startRun != null && lastAccepting != null && lastAccepting >= startRun) {
          yield [startRun, lastAccepting, self.tags[state]];
        }
      }

    };
  }
  /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */


  apply(str, actions) {
    for (var [start, end, tags] of this.match(str)) {
      for (var tag of tags) {
        if (typeof actions[tag] === 'function') {
          actions[tag](start, end, str.slice(start, end + 1));
        }
      }
    }
  }

}

module.exports = StateMachine;


},{}],553:[function(require,module,exports){
/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */

/**
 * Class containing the diff, match and patch methods.
 * @constructor
 */
var diff_match_patch = function() {

  // Defaults.
  // Redefine these in your program to override the defaults.

  // Number of seconds to map a diff before giving up (0 for infinity).
  this.Diff_Timeout = 1.0;
  // Cost of an empty edit operation in terms of edit characters.
  this.Diff_EditCost = 4;
  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
  this.Match_Threshold = 0.5;
  // How far to search for a match (0 = exact location, 1000+ = broad match).
  // A match this many characters away from the expected location will add
  // 1.0 to the score (0.0 is a perfect match).
  this.Match_Distance = 1000;
  // When deleting a large block of text (over ~64 characters), how close do
  // the contents have to be to match the expected contents. (0.0 = perfection,
  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
  // end points of a delete need to match.
  this.Patch_DeleteThreshold = 0.5;
  // Chunk size for context length.
  this.Patch_Margin = 4;

  // The number of bits in an int.
  this.Match_MaxBits = 32;
};


//  DIFF FUNCTIONS


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/**
 * Class representing one diff tuple.
 * ~Attempts to look like a two-element array (which is what this used to be).~
 * Constructor returns an actual two-element array, to allow destructing @JackuB
 * See https://github.com/JackuB/diff-match-patch/issues/14 for details
 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
 * @param {string} text Text to be deleted, inserted, or retained.
 * @constructor
 */
diff_match_patch.Diff = function(op, text) {
  return [op, text];
};

/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number=} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */
diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
    opt_deadline) {
  // Set a deadline by which time the diff must be complete.
  if (typeof opt_deadline == 'undefined') {
    if (this.Diff_Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
  }
  var deadline = opt_deadline;

  // Check for null inputs.
  if (text1 == null || text2 == null) {
    throw new Error('Null input. (diff_main)');
  }

  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [new diff_match_patch.Diff(DIFF_EQUAL, text1)];
    }
    return [];
  }

  if (typeof opt_checklines == 'undefined') {
    opt_checklines = true;
  }
  var checklines = opt_checklines;

  // Trim off common prefix (speedup).
  var commonlength = this.diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = this.diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = this.diff_compute_(text1, text2, checklines, deadline);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, commonprefix));
  }
  if (commonsuffix) {
    diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, commonsuffix));
  }
  this.diff_cleanupMerge(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
    deadline) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [new diff_match_patch.Diff(DIFF_INSERT, text2)];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [new diff_match_patch.Diff(DIFF_DELETE, text1)];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [new diff_match_patch.Diff(DIFF_INSERT, longtext.substring(0, i)),
             new diff_match_patch.Diff(DIFF_EQUAL, shorttext),
             new diff_match_patch.Diff(DIFF_INSERT,
                 longtext.substring(i + shorttext.length))];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [new diff_match_patch.Diff(DIFF_DELETE, text1),
            new diff_match_patch.Diff(DIFF_INSERT, text2)];
  }

  // Check to see if the problem can be split in two.
  var hm = this.diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([new diff_match_patch.Diff(DIFF_EQUAL, mid_common)],
                          diffs_b);
  }

  if (checklines && text1.length > 100 && text2.length > 100) {
    return this.diff_lineMode_(text1, text2, deadline);
  }

  return this.diff_bisect_(text1, text2, deadline);
};


/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  var a = this.diff_linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  var linearray = a.lineArray;

  var diffs = this.diff_main(text1, text2, false, deadline);

  // Convert the diff back to original text.
  this.diff_charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  this.diff_cleanupSemantic(diffs);

  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, ''));
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert,
                       count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          var subDiff =
              this.diff_main(text_delete, text_insert, false, deadline);
          for (var j = subDiff.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, subDiff[j]);
          }
          pointer = pointer + subDiff.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop();  // Remove the dummy entry at the end.

  return diffs;
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Bail out if deadline is reached.
    if ((new Date()).getTime() > deadline) {
      break;
    }

    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [new diff_match_patch.Diff(DIFF_DELETE, text1),
          new diff_match_patch.Diff(DIFF_INSERT, text2)];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
    deadline) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = this.diff_main(text1a, text2a, false, deadline);
  var diffsb = this.diff_main(text1b, text2b, false, deadline);

  return diffs.concat(diffsb);
};


/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */
diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4

  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';

  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */
  function diff_linesToCharsMunge_(text) {
    var chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    var lineStart = 0;
    var lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    var lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd == -1) {
        lineEnd = text.length - 1;
      }
      var line = text.substring(lineStart, lineEnd + 1);

      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
          (lineHash[line] !== undefined)) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        if (lineArrayLength == maxLines) {
          // Bail out at 65535 because
          // String.fromCharCode(65536) == String.fromCharCode(0)
          line = text.substring(lineStart);
          lineEnd = text.length;
        }
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
      lineStart = lineEnd + 1;
    }
    return chars;
  }
  // Allocate 2/3rds of the space for text1, the rest for text2.
  var maxLines = 40000;
  var chars1 = diff_linesToCharsMunge_(text1);
  maxLines = 65535;
  var chars2 = diff_linesToCharsMunge_(text2);
  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
};


/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */
diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
  for (var i = 0; i < diffs.length; i++) {
    var chars = diffs[i][1];
    var text = [];
    for (var j = 0; j < chars.length; j++) {
      text[j] = lineArray[chars.charCodeAt(j)];
    }
    diffs[i][1] = text.join('');
  }
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: https://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: https://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */
diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length == 0 || text2_length == 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  var text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 == text2) {
    return text_length;
  }

  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: https://neil.fraser.name/news/2010/11/04/
  var best = 0;
  var length = 1;
  while (true) {
    var pattern = text1.substring(text_length - length);
    var found = text2.indexOf(pattern);
    if (found == -1) {
      return best;
    }
    length += found;
    if (found == 0 || text1.substring(text_length - length) ==
        text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */
diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
  if (this.Diff_Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }
  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
                                               shorttext.substring(j));
      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
                                               shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastEquality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Number of characters that changed prior to the equality.
  var length_insertions1 = 0;
  var length_deletions1 = 0;
  // Number of characters that changed after the equality.
  var length_insertions2 = 0;
  var length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastEquality = diffs[pointer][1];
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastEquality && (lastEquality.length <=
          Math.max(length_insertions1, length_deletions1)) &&
          (lastEquality.length <= Math.max(length_insertions2,
                                           length_deletions2))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     new diff_match_patch.Diff(DIFF_DELETE, lastEquality));
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0;  // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastEquality = null;
        changes = true;
      }
    }
    pointer++;
  }

  // Normalize the diff.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
  this.diff_cleanupSemanticLossless(diffs);

  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] == DIFF_DELETE &&
        diffs[pointer][0] == DIFF_INSERT) {
      var deletion = diffs[pointer - 1][1];
      var insertion = diffs[pointer][1];
      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 ||
            overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0, new diff_match_patch.Diff(DIFF_EQUAL,
              insertion.substring(0, overlap_length1)));
          diffs[pointer - 1][1] =
              deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 ||
            overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0, new diff_match_patch.Diff(DIFF_EQUAL,
              deletion.substring(0, overlap_length2)));
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] =
              insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] =
              deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
};


/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }

    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    var char1 = one.charAt(one.length - 1);
    var char2 = two.charAt(0);
    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
    var whitespace1 = nonAlphaNumeric1 &&
        char1.match(diff_match_patch.whitespaceRegex_);
    var whitespace2 = nonAlphaNumeric2 &&
        char2.match(diff_match_patch.whitespaceRegex_);
    var lineBreak1 = whitespace1 &&
        char1.match(diff_match_patch.linebreakRegex_);
    var lineBreak2 = whitespace2 &&
        char2.match(diff_match_patch.linebreakRegex_);
    var blankLine1 = lineBreak1 &&
        one.match(diff_match_patch.blanklineEndRegex_);
    var blankLine2 = lineBreak2 &&
        two.match(diff_match_patch.blanklineStartRegex_);

    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }

  var pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      var equality1 = diffs[pointer - 1][1];
      var edit = diffs[pointer][1];
      var equality2 = diffs[pointer + 1][1];

      // First, shift the edit as far left as possible.
      var commonOffset = this.diff_commonSuffix(equality1, edit);
      if (commonOffset) {
        var commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }

      // Second, step character by character right, looking for the best fit.
      var bestEquality1 = equality1;
      var bestEdit = edit;
      var bestEquality2 = equality2;
      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
          diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        var score = diff_cleanupSemanticScore_(equality1, edit) +
            diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }

      if (diffs[pointer - 1][1] != bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
};

// Define some regex patterns for matching boundaries.
diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
diff_match_patch.whitespaceRegex_ = /\s/;
diff_match_patch.linebreakRegex_ = /[\r\n]/;
diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;

/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastEquality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Is there an insertion operation before the last equality.
  var pre_ins = false;
  // Is there a deletion operation before the last equality.
  var pre_del = false;
  // Is there an insertion operation after the last equality.
  var post_ins = false;
  // Is there a deletion operation after the last equality.
  var post_del = false;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      if (diffs[pointer][1].length < this.Diff_EditCost &&
          (post_ins || post_del)) {
        // Candidate found.
        equalities[equalitiesLength++] = pointer;
        pre_ins = post_ins;
        pre_del = post_del;
        lastEquality = diffs[pointer][1];
      } else {
        // Not a candidate, and can never become one.
        equalitiesLength = 0;
        lastEquality = null;
      }
      post_ins = post_del = false;
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_DELETE) {
        post_del = true;
      } else {
        post_ins = true;
      }
      /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */
      if (lastEquality && ((pre_ins && pre_del && post_ins && post_del) ||
                           ((lastEquality.length < this.Diff_EditCost / 2) &&
                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     new diff_match_patch.Diff(DIFF_DELETE, lastEquality));
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        equalitiesLength--;  // Throw away the equality we just deleted;
        lastEquality = null;
        if (pre_ins && pre_del) {
          // No changes made which could affect previous entry, keep going.
          post_ins = post_del = true;
          equalitiesLength = 0;
        } else {
          equalitiesLength--;  // Throw away the previous equality.
          pointer = equalitiesLength > 0 ?
              equalities[equalitiesLength - 1] : -1;
          post_ins = post_del = false;
        }
        changes = true;
      }
    }
    pointer++;
  }

  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
  // Add a dummy entry at the end.
  diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, ''));
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = this.diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, new diff_match_patch.Diff(DIFF_EQUAL,
                    text_insert.substring(0, commonlength)));
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = this.diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          pointer -= count_delete + count_insert;
          diffs.splice(pointer, count_delete + count_insert);
          if (text_delete.length) {
            diffs.splice(pointer, 0,
                new diff_match_patch.Diff(DIFF_DELETE, text_delete));
            pointer++;
          }
          if (text_insert.length) {
            diffs.splice(pointer, 0,
                new diff_match_patch.Diff(DIFF_INSERT, text_insert));
            pointer++;
          }
          pointer++;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */
diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
  var chars1 = 0;
  var chars2 = 0;
  var last_chars1 = 0;
  var last_chars2 = 0;
  var x;
  for (x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
      chars1 += diffs[x][1].length;
    }
    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
      chars2 += diffs[x][1].length;
    }
    if (chars1 > loc) {  // Overshot the location.
      break;
    }
    last_chars1 = chars1;
    last_chars2 = chars2;
  }
  // Was the location was deleted?
  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
    return last_chars2;
  }
  // Add the remaining character length.
  return last_chars2 + (loc - last_chars1);
};


/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */
diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
  var html = [];
  var pattern_amp = /&/g;
  var pattern_lt = /</g;
  var pattern_gt = />/g;
  var pattern_para = /\n/g;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];    // Operation (insert, delete, equal)
    var data = diffs[x][1];  // Text of change.
    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
    switch (op) {
      case DIFF_INSERT:
        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
        break;
      case DIFF_DELETE:
        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
        break;
      case DIFF_EQUAL:
        html[x] = '<span>' + text + '</span>';
        break;
    }
  }
  return html.join('');
};


/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */
diff_match_patch.prototype.diff_text1 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */
diff_match_patch.prototype.diff_text2 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_DELETE) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */
diff_match_patch.prototype.diff_levenshtein = function(diffs) {
  var levenshtein = 0;
  var insertions = 0;
  var deletions = 0;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];
    var data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        // A deletion and an insertion is one substitution.
        levenshtein += Math.max(insertions, deletions);
        insertions = 0;
        deletions = 0;
        break;
    }
  }
  levenshtein += Math.max(insertions, deletions);
  return levenshtein;
};


/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */
diff_match_patch.prototype.diff_toDelta = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    switch (diffs[x][0]) {
      case DIFF_INSERT:
        text[x] = '+' + encodeURI(diffs[x][1]);
        break;
      case DIFF_DELETE:
        text[x] = '-' + diffs[x][1].length;
        break;
      case DIFF_EQUAL:
        text[x] = '=' + diffs[x][1].length;
        break;
    }
  }
  return text.join('\t').replace(/%20/g, ' ');
};


/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
  var diffs = [];
  var diffsLength = 0;  // Keeping our own length var is faster in JS.
  var pointer = 0;  // Cursor in text1
  var tokens = delta.split(/\t/g);
  for (var x = 0; x < tokens.length; x++) {
    // Each token begins with a one character parameter which specifies the
    // operation of this token (delete, insert, equality).
    var param = tokens[x].substring(1);
    switch (tokens[x].charAt(0)) {
      case '+':
        try {
          diffs[diffsLength++] =
              new diff_match_patch.Diff(DIFF_INSERT, decodeURI(param));
        } catch (ex) {
          // Malformed URI sequence.
          throw new Error('Illegal escape in diff_fromDelta: ' + param);
        }
        break;
      case '-':
        // Fall through.
      case '=':
        var n = parseInt(param, 10);
        if (isNaN(n) || n < 0) {
          throw new Error('Invalid number in diff_fromDelta: ' + param);
        }
        var text = text1.substring(pointer, pointer += n);
        if (tokens[x].charAt(0) == '=') {
          diffs[diffsLength++] = new diff_match_patch.Diff(DIFF_EQUAL, text);
        } else {
          diffs[diffsLength++] = new diff_match_patch.Diff(DIFF_DELETE, text);
        }
        break;
      default:
        // Blank tokens are ok (from a trailing \t).
        // Anything else is an error.
        if (tokens[x]) {
          throw new Error('Invalid diff operation in diff_fromDelta: ' +
                          tokens[x]);
        }
    }
  }
  if (pointer != text1.length) {
    throw new Error('Delta length (' + pointer +
        ') does not equal source text length (' + text1.length + ').');
  }
  return diffs;
};


//  MATCH FUNCTIONS


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */
diff_match_patch.prototype.match_main = function(text, pattern, loc) {
  // Check for null inputs.
  if (text == null || pattern == null || loc == null) {
    throw new Error('Null input. (match_main)');
  }

  loc = Math.max(0, Math.min(loc, text.length));
  if (text == pattern) {
    // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
  } else if (!text.length) {
    // Nothing to match.
    return -1;
  } else if (text.substring(loc, loc + pattern.length) == pattern) {
    // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
  } else {
    // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
  }
};


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */
diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
  if (pattern.length > this.Match_MaxBits) {
    throw new Error('Pattern too long for this browser.');
  }

  // Initialise the alphabet.
  var s = this.match_alphabet_(pattern);

  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  function match_bitapScore_(e, x) {
    var accuracy = e / pattern.length;
    var proximity = Math.abs(loc - x);
    if (!dmp.Match_Distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy;
    }
    return accuracy + (proximity / dmp.Match_Distance);
  }

  // Highest score beyond which we give up.
  var score_threshold = this.Match_Threshold;
  // Is there a nearby exact match? (speedup)
  var best_loc = text.indexOf(pattern, loc);
  if (best_loc != -1) {
    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    // What about in the other direction? (speedup)
    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
    if (best_loc != -1) {
      score_threshold =
          Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
  }

  // Initialise the bit arrays.
  var matchmask = 1 << (pattern.length - 1);
  best_loc = -1;

  var bin_min, bin_mid;
  var bin_max = pattern.length + text.length;
  var last_rd;
  for (var d = 0; d < pattern.length; d++) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from 'loc' we can stray at this
    // error level.
    bin_min = 0;
    bin_mid = bin_max;
    while (bin_min < bin_mid) {
      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
        bin_min = bin_mid;
      } else {
        bin_max = bin_mid;
      }
      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
    }
    // Use the result from this iteration as the maximum for the next.
    bin_max = bin_mid;
    var start = Math.max(1, loc - bin_mid + 1);
    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;

    var rd = Array(finish + 2);
    rd[finish + 1] = (1 << d) - 1;
    for (var j = finish; j >= start; j--) {
      // The alphabet (s) is a sparse hash, so the following line generates
      // warnings.
      var charMatch = s[text.charAt(j - 1)];
      if (d === 0) {  // First pass: exact match.
        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
      } else {  // Subsequent passes: fuzzy match.
        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
                last_rd[j + 1];
      }
      if (rd[j] & matchmask) {
        var score = match_bitapScore_(d, j - 1);
        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (score <= score_threshold) {
          // Told you so.
          score_threshold = score;
          best_loc = j - 1;
          if (best_loc > loc) {
            // When passing loc, don't exceed our current distance from loc.
            start = Math.max(1, 2 * loc - best_loc);
          } else {
            // Already passed loc, downhill from here on in.
            break;
          }
        }
      }
    }
    // No hope for a (better) match at greater error levels.
    if (match_bitapScore_(d + 1, loc) > score_threshold) {
      break;
    }
    last_rd = rd;
  }
  return best_loc;
};


/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */
diff_match_patch.prototype.match_alphabet_ = function(pattern) {
  var s = {};
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] = 0;
  }
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
  }
  return s;
};


//  PATCH FUNCTIONS


/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */
diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
  if (text.length == 0) {
    return;
  }
  if (patch.start2 === null) {
    throw Error('patch not initialized');
  }
  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
  var padding = 0;

  // Look for the first and last matches of pattern in text.  If two different
  // matches are found, increase the pattern length.
  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
         pattern.length < this.Match_MaxBits - this.Patch_Margin -
         this.Patch_Margin) {
    padding += this.Patch_Margin;
    pattern = text.substring(patch.start2 - padding,
                             patch.start2 + patch.length1 + padding);
  }
  // Add one chunk for good luck.
  padding += this.Patch_Margin;

  // Add the prefix.
  var prefix = text.substring(patch.start2 - padding, patch.start2);
  if (prefix) {
    patch.diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, prefix));
  }
  // Add the suffix.
  var suffix = text.substring(patch.start2 + patch.length1,
                              patch.start2 + patch.length1 + padding);
  if (suffix) {
    patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, suffix));
  }

  // Roll back the start points.
  patch.start1 -= prefix.length;
  patch.start2 -= prefix.length;
  // Extend the lengths.
  patch.length1 += prefix.length + suffix.length;
  patch.length2 += prefix.length + suffix.length;
};


/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
  var text1, diffs;
  if (typeof a == 'string' && typeof opt_b == 'string' &&
      typeof opt_c == 'undefined') {
    // Method 1: text1, text2
    // Compute diffs from text1 and text2.
    text1 = /** @type {string} */(a);
    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
    if (diffs.length > 2) {
      this.diff_cleanupSemantic(diffs);
      this.diff_cleanupEfficiency(diffs);
    }
  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
      typeof opt_c == 'undefined') {
    // Method 2: diffs
    // Compute text1 from diffs.
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
    text1 = this.diff_text1(diffs);
  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
      typeof opt_c == 'undefined') {
    // Method 3: text1, diffs
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
      opt_c && typeof opt_c == 'object') {
    // Method 4: text1, text2, diffs
    // text2 is not used.
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
  } else {
    throw new Error('Unknown call format to patch_make.');
  }

  if (diffs.length === 0) {
    return [];  // Get rid of the null case.
  }
  var patches = [];
  var patch = new diff_match_patch.patch_obj();
  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
  var char_count1 = 0;  // Number of characters into the text1 string.
  var char_count2 = 0;  // Number of characters into the text2 string.
  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
  // text2 (postpatch_text).  We recreate the patches one by one to determine
  // context info.
  var prepatch_text = text1;
  var postpatch_text = text1;
  for (var x = 0; x < diffs.length; x++) {
    var diff_type = diffs[x][0];
    var diff_text = diffs[x][1];

    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
      // A new patch starts here.
      patch.start1 = char_count1;
      patch.start2 = char_count2;
    }

    switch (diff_type) {
      case DIFF_INSERT:
        patch.diffs[patchDiffLength++] = diffs[x];
        patch.length2 += diff_text.length;
        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
                         postpatch_text.substring(char_count2);
        break;
      case DIFF_DELETE:
        patch.length1 += diff_text.length;
        patch.diffs[patchDiffLength++] = diffs[x];
        postpatch_text = postpatch_text.substring(0, char_count2) +
                         postpatch_text.substring(char_count2 +
                             diff_text.length);
        break;
      case DIFF_EQUAL:
        if (diff_text.length <= 2 * this.Patch_Margin &&
            patchDiffLength && diffs.length != x + 1) {
          // Small equality inside a patch.
          patch.diffs[patchDiffLength++] = diffs[x];
          patch.length1 += diff_text.length;
          patch.length2 += diff_text.length;
        } else if (diff_text.length >= 2 * this.Patch_Margin) {
          // Time for a new patch.
          if (patchDiffLength) {
            this.patch_addContext_(patch, prepatch_text);
            patches.push(patch);
            patch = new diff_match_patch.patch_obj();
            patchDiffLength = 0;
            // Unlike Unidiff, our patch lists have a rolling context.
            // https://github.com/google/diff-match-patch/wiki/Unidiff
            // Update prepatch text & pos to reflect the application of the
            // just completed patch.
            prepatch_text = postpatch_text;
            char_count1 = char_count2;
          }
        }
        break;
    }

    // Update the current character count.
    if (diff_type !== DIFF_INSERT) {
      char_count1 += diff_text.length;
    }
    if (diff_type !== DIFF_DELETE) {
      char_count2 += diff_text.length;
    }
  }
  // Pick up the leftover patch if not empty.
  if (patchDiffLength) {
    this.patch_addContext_(patch, prepatch_text);
    patches.push(patch);
  }

  return patches;
};


/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_deepCopy = function(patches) {
  // Making deep copies is hard in JavaScript.
  var patchesCopy = [];
  for (var x = 0; x < patches.length; x++) {
    var patch = patches[x];
    var patchCopy = new diff_match_patch.patch_obj();
    patchCopy.diffs = [];
    for (var y = 0; y < patch.diffs.length; y++) {
      patchCopy.diffs[y] =
          new diff_match_patch.Diff(patch.diffs[y][0], patch.diffs[y][1]);
    }
    patchCopy.start1 = patch.start1;
    patchCopy.start2 = patch.start2;
    patchCopy.length1 = patch.length1;
    patchCopy.length2 = patch.length2;
    patchesCopy[x] = patchCopy;
  }
  return patchesCopy;
};


/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */
diff_match_patch.prototype.patch_apply = function(patches, text) {
  if (patches.length == 0) {
    return [text, []];
  }

  // Deep copy the patches so that no changes are made to originals.
  patches = this.patch_deepCopy(patches);

  var nullPadding = this.patch_addPadding(patches);
  text = nullPadding + text + nullPadding;

  this.patch_splitMax(patches);
  // delta keeps track of the offset between the expected and actual location
  // of the previous patch.  If there are patches expected at positions 10 and
  // 20, but the first patch was found at 12, delta is 2 and the second patch
  // has an effective expected position of 22.
  var delta = 0;
  var results = [];
  for (var x = 0; x < patches.length; x++) {
    var expected_loc = patches[x].start2 + delta;
    var text1 = this.diff_text1(patches[x].diffs);
    var start_loc;
    var end_loc = -1;
    if (text1.length > this.Match_MaxBits) {
      // patch_splitMax will only provide an oversized pattern in the case of
      // a monster delete.
      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
                                  expected_loc);
      if (start_loc != -1) {
        end_loc = this.match_main(text,
            text1.substring(text1.length - this.Match_MaxBits),
            expected_loc + text1.length - this.Match_MaxBits);
        if (end_loc == -1 || start_loc >= end_loc) {
          // Can't find valid trailing context.  Drop this patch.
          start_loc = -1;
        }
      }
    } else {
      start_loc = this.match_main(text, text1, expected_loc);
    }
    if (start_loc == -1) {
      // No match found.  :(
      results[x] = false;
      // Subtract the delta for this failed patch from subsequent patches.
      delta -= patches[x].length2 - patches[x].length1;
    } else {
      // Found a match.  :)
      results[x] = true;
      delta = start_loc - expected_loc;
      var text2;
      if (end_loc == -1) {
        text2 = text.substring(start_loc, start_loc + text1.length);
      } else {
        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
      }
      if (text1 == text2) {
        // Perfect match, just shove the replacement text in.
        text = text.substring(0, start_loc) +
               this.diff_text2(patches[x].diffs) +
               text.substring(start_loc + text1.length);
      } else {
        // Imperfect match.  Run a diff to get a framework of equivalent
        // indices.
        var diffs = this.diff_main(text1, text2, false);
        if (text1.length > this.Match_MaxBits &&
            this.diff_levenshtein(diffs) / text1.length >
            this.Patch_DeleteThreshold) {
          // The end points match, but the content is unacceptably bad.
          results[x] = false;
        } else {
          this.diff_cleanupSemanticLossless(diffs);
          var index1 = 0;
          var index2;
          for (var y = 0; y < patches[x].diffs.length; y++) {
            var mod = patches[x].diffs[y];
            if (mod[0] !== DIFF_EQUAL) {
              index2 = this.diff_xIndex(diffs, index1);
            }
            if (mod[0] === DIFF_INSERT) {  // Insertion
              text = text.substring(0, start_loc + index2) + mod[1] +
                     text.substring(start_loc + index2);
            } else if (mod[0] === DIFF_DELETE) {  // Deletion
              text = text.substring(0, start_loc + index2) +
                     text.substring(start_loc + this.diff_xIndex(diffs,
                         index1 + mod[1].length));
            }
            if (mod[0] !== DIFF_DELETE) {
              index1 += mod[1].length;
            }
          }
        }
      }
    }
  }
  // Strip the padding off.
  text = text.substring(nullPadding.length, text.length - nullPadding.length);
  return [text, results];
};


/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */
diff_match_patch.prototype.patch_addPadding = function(patches) {
  var paddingLength = this.Patch_Margin;
  var nullPadding = '';
  for (var x = 1; x <= paddingLength; x++) {
    nullPadding += String.fromCharCode(x);
  }

  // Bump all the patches forward.
  for (var x = 0; x < patches.length; x++) {
    patches[x].start1 += paddingLength;
    patches[x].start2 += paddingLength;
  }

  // Add some padding on start of first diff.
  var patch = patches[0];
  var diffs = patch.diffs;
  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, nullPadding));
    patch.start1 -= paddingLength;  // Should be 0.
    patch.start2 -= paddingLength;  // Should be 0.
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[0][1].length) {
    // Grow first equality.
    var extraLength = paddingLength - diffs[0][1].length;
    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
    patch.start1 -= extraLength;
    patch.start2 -= extraLength;
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  // Add some padding on end of last diff.
  patch = patches[patches.length - 1];
  diffs = patch.diffs;
  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, nullPadding));
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
    // Grow last equality.
    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  return nullPadding;
};


/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */
diff_match_patch.prototype.patch_splitMax = function(patches) {
  var patch_size = this.Match_MaxBits;
  for (var x = 0; x < patches.length; x++) {
    if (patches[x].length1 <= patch_size) {
      continue;
    }
    var bigpatch = patches[x];
    // Remove the big old patch.
    patches.splice(x--, 1);
    var start1 = bigpatch.start1;
    var start2 = bigpatch.start2;
    var precontext = '';
    while (bigpatch.diffs.length !== 0) {
      // Create one of several smaller patches.
      var patch = new diff_match_patch.patch_obj();
      var empty = true;
      patch.start1 = start1 - precontext.length;
      patch.start2 = start2 - precontext.length;
      if (precontext !== '') {
        patch.length1 = patch.length2 = precontext.length;
        patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, precontext));
      }
      while (bigpatch.diffs.length !== 0 &&
             patch.length1 < patch_size - this.Patch_Margin) {
        var diff_type = bigpatch.diffs[0][0];
        var diff_text = bigpatch.diffs[0][1];
        if (diff_type === DIFF_INSERT) {
          // Insertions are harmless.
          patch.length2 += diff_text.length;
          start2 += diff_text.length;
          patch.diffs.push(bigpatch.diffs.shift());
          empty = false;
        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
                   patch.diffs[0][0] == DIFF_EQUAL &&
                   diff_text.length > 2 * patch_size) {
          // This is a large deletion.  Let it pass in one chunk.
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          empty = false;
          patch.diffs.push(new diff_match_patch.Diff(diff_type, diff_text));
          bigpatch.diffs.shift();
        } else {
          // Deletion or equality.  Only take as much as we can stomach.
          diff_text = diff_text.substring(0,
              patch_size - patch.length1 - this.Patch_Margin);
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          if (diff_type === DIFF_EQUAL) {
            patch.length2 += diff_text.length;
            start2 += diff_text.length;
          } else {
            empty = false;
          }
          patch.diffs.push(new diff_match_patch.Diff(diff_type, diff_text));
          if (diff_text == bigpatch.diffs[0][1]) {
            bigpatch.diffs.shift();
          } else {
            bigpatch.diffs[0][1] =
                bigpatch.diffs[0][1].substring(diff_text.length);
          }
        }
      }
      // Compute the head context for the next patch.
      precontext = this.diff_text2(patch.diffs);
      precontext =
          precontext.substring(precontext.length - this.Patch_Margin);
      // Append the end context for this patch.
      var postcontext = this.diff_text1(bigpatch.diffs)
                            .substring(0, this.Patch_Margin);
      if (postcontext !== '') {
        patch.length1 += postcontext.length;
        patch.length2 += postcontext.length;
        if (patch.diffs.length !== 0 &&
            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
          patch.diffs[patch.diffs.length - 1][1] += postcontext;
        } else {
          patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, postcontext));
        }
      }
      if (!empty) {
        patches.splice(++x, 0, patch);
      }
    }
  }
};


/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */
diff_match_patch.prototype.patch_toText = function(patches) {
  var text = [];
  for (var x = 0; x < patches.length; x++) {
    text[x] = patches[x];
  }
  return text.join('');
};


/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.patch_fromText = function(textline) {
  var patches = [];
  if (!textline) {
    return patches;
  }
  var text = textline.split('\n');
  var textPointer = 0;
  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
  while (textPointer < text.length) {
    var m = text[textPointer].match(patchHeader);
    if (!m) {
      throw new Error('Invalid patch string: ' + text[textPointer]);
    }
    var patch = new diff_match_patch.patch_obj();
    patches.push(patch);
    patch.start1 = parseInt(m[1], 10);
    if (m[2] === '') {
      patch.start1--;
      patch.length1 = 1;
    } else if (m[2] == '0') {
      patch.length1 = 0;
    } else {
      patch.start1--;
      patch.length1 = parseInt(m[2], 10);
    }

    patch.start2 = parseInt(m[3], 10);
    if (m[4] === '') {
      patch.start2--;
      patch.length2 = 1;
    } else if (m[4] == '0') {
      patch.length2 = 0;
    } else {
      patch.start2--;
      patch.length2 = parseInt(m[4], 10);
    }
    textPointer++;

    while (textPointer < text.length) {
      var sign = text[textPointer].charAt(0);
      try {
        var line = decodeURI(text[textPointer].substring(1));
      } catch (ex) {
        // Malformed URI sequence.
        throw new Error('Illegal escape in patch_fromText: ' + line);
      }
      if (sign == '-') {
        // Deletion.
        patch.diffs.push(new diff_match_patch.Diff(DIFF_DELETE, line));
      } else if (sign == '+') {
        // Insertion.
        patch.diffs.push(new diff_match_patch.Diff(DIFF_INSERT, line));
      } else if (sign == ' ') {
        // Minor equality.
        patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, line));
      } else if (sign == '@') {
        // Start of next patch.
        break;
      } else if (sign === '') {
        // Blank line?  Whatever.
      } else {
        // WTF?
        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
      }
      textPointer++;
    }
  }
  return patches;
};


/**
 * Class representing one patch operation.
 * @constructor
 */
diff_match_patch.patch_obj = function() {
  /** @type {!Array.<!diff_match_patch.Diff>} */
  this.diffs = [];
  /** @type {?number} */
  this.start1 = null;
  /** @type {?number} */
  this.start2 = null;
  /** @type {number} */
  this.length1 = 0;
  /** @type {number} */
  this.length2 = 0;
};


/**
 * Emulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indices are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */
diff_match_patch.patch_obj.prototype.toString = function() {
  var coords1, coords2;
  if (this.length1 === 0) {
    coords1 = this.start1 + ',0';
  } else if (this.length1 == 1) {
    coords1 = this.start1 + 1;
  } else {
    coords1 = (this.start1 + 1) + ',' + this.length1;
  }
  if (this.length2 === 0) {
    coords2 = this.start2 + ',0';
  } else if (this.length2 == 1) {
    coords2 = this.start2 + 1;
  } else {
    coords2 = (this.start2 + 1) + ',' + this.length2;
  }
  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
  var op;
  // Escape the body of the patch with %xx notation.
  for (var x = 0; x < this.diffs.length; x++) {
    switch (this.diffs[x][0]) {
      case DIFF_INSERT:
        op = '+';
        break;
      case DIFF_DELETE:
        op = '-';
        break;
      case DIFF_EQUAL:
        op = ' ';
        break;
    }
    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
  }
  return text.join('').replace(/%20/g, ' ');
};


// The following export code was added by @ForbesLindesay
module.exports = diff_match_patch;
module.exports['diff_match_patch'] = diff_match_patch;
module.exports['DIFF_DELETE'] = DIFF_DELETE;
module.exports['DIFF_INSERT'] = DIFF_INSERT;
module.exports['DIFF_EQUAL'] = DIFF_EQUAL;
},{}],554:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createBeginDrag = createBeginDrag;
var _invariant = require("@react-dnd/invariant");
var _setClientOffsetJs = require("./local/setClientOffset.js");
var _jsUtilsJs = require("../../utils/js_utils.js");
var _typesJs = require("./types.js");
const ResetCoordinatesAction = {
    type: _typesJs.INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource =true , clientOffset , getSourceClientOffset ,  } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, _setClientOffsetJs).setClientOffset(clientOffset));
        verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch(ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) {
                throw new Error('getSourceClientOffset must be defined');
            }
            verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, _setClientOffsetJs).setClientOffset(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) {
            return undefined;
        }
        verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: _typesJs.BEGIN_DRAG,
            payload: {
                itemType,
                item,
                sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function verifyInvariants(sourceIds, monitor, registry) {
    (0, _invariant).invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        (0, _invariant).invariant(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, _invariant).invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function verifyItemIsObject(item) {
    (0, _invariant).invariant((0, _jsUtilsJs).isObject(item), 'Item must be an object.');
}
function getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--){
        if (monitor.canDragSource(sourceIds[i])) {
            sourceId = sourceIds[i];
            break;
        }
    }
    return sourceId;
}


},{"../../utils/js_utils.js":580,"./local/setClientOffset.js":559,"./types.js":561,"@react-dnd/invariant":331}],555:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDrop = createDrop;
var _invariant = require("@react-dnd/invariant");
var _typesJs = require("./types.js");
var _jsUtilsJs = require("../../utils/js_utils.js");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyInvariants(monitor);
        const targetIds = getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: _typesJs.DROP,
                payload: {
                    dropResult: _objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function verifyInvariants(monitor) {
    (0, _invariant).invariant(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, _invariant).invariant(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') {
        dropResult = index === 0 ? {} : monitor.getDropResult();
    }
    return dropResult;
}
function verifyDropResultType(dropResult) {
    (0, _invariant).invariant(typeof dropResult === 'undefined' || (0, _jsUtilsJs).isObject(dropResult), 'Drop result must either be an object or undefined.');
}
function getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}


},{"../../utils/js_utils.js":580,"./types.js":561,"@react-dnd/invariant":331}],556:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createEndDrag = createEndDrag;
var _invariant = require("@react-dnd/invariant");
var _typesJs = require("./types.js");
function createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: _typesJs.END_DRAG
        };
    };
}
function verifyIsDragging(monitor) {
    (0, _invariant).invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}


},{"./types.js":561,"@react-dnd/invariant":331}],557:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createHover = createHover;
var _invariant = require("@react-dnd/invariant");
var _matchesTypeJs = require("../../utils/matchesType.js");
var _typesJs = require("./types.js");
function createHover(manager) {
    return function hover(targetIdsArg, { clientOffset  } = {}) {
        verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        checkInvariants(targetIds, monitor, registry);
        const draggedItemType = monitor.getItemType();
        removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        hoverAllTargets(targetIds, monitor, registry);
        return {
            type: _typesJs.HOVER,
            payload: {
                targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function verifyTargetIdsIsArray(targetIdsArg) {
    (0, _invariant).invariant(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function checkInvariants(targetIds, monitor, registry) {
    (0, _invariant).invariant(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, _invariant).invariant(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, _invariant).invariant(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        const target = registry.getTarget(targetId);
        (0, _invariant).invariant(target, 'Expected targetIds to be registered.');
    }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, _matchesTypeJs).matchesType(targetType, draggedItemType)) {
            targetIds.splice(i, 1);
        }
    }
}
function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}


},{"../../utils/matchesType.js":581,"./types.js":561,"@react-dnd/invariant":331}],558:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDragDropActions = createDragDropActions;
var _beginDragJs = require("./beginDrag.js");
var _publishDragSourceJs = require("./publishDragSource.js");
var _hoverJs = require("./hover.js");
var _dropJs = require("./drop.js");
var _endDragJs = require("./endDrag.js");
var _typesJs = _interopRequireWildcard(require("./types.js"));
Object.keys(_typesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _typesJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typesJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function createDragDropActions(manager) {
    return {
        beginDrag: (0, _beginDragJs).createBeginDrag(manager),
        publishDragSource: (0, _publishDragSourceJs).createPublishDragSource(manager),
        hover: (0, _hoverJs).createHover(manager),
        drop: (0, _dropJs).createDrop(manager),
        endDrag: (0, _endDragJs).createEndDrag(manager)
    };
}


},{"./beginDrag.js":554,"./drop.js":555,"./endDrag.js":556,"./hover.js":557,"./publishDragSource.js":560,"./types.js":561}],559:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setClientOffset = setClientOffset;
var _typesJs = require("../types.js");
function setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: _typesJs.INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}


},{"../types.js":561}],560:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createPublishDragSource = createPublishDragSource;
var _typesJs = require("./types.js");
function createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) {
            return {
                type: _typesJs.PUBLISH_DRAG_SOURCE
            };
        }
        return;
    };
}


},{"./types.js":561}],561:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = exports.INIT_COORDS = void 0;
const INIT_COORDS = 'dnd-core/INIT_COORDS';
exports.INIT_COORDS = INIT_COORDS;
const BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
exports.BEGIN_DRAG = BEGIN_DRAG;
const PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
exports.PUBLISH_DRAG_SOURCE = PUBLISH_DRAG_SOURCE;
const HOVER = 'dnd-core/HOVER';
exports.HOVER = HOVER;
const DROP = 'dnd-core/DROP';
exports.DROP = DROP;
const END_DRAG = 'dnd-core/END_DRAG';
exports.END_DRAG = END_DRAG;


},{}],562:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
exports.REMOVE_TARGET = exports.REMOVE_SOURCE = exports.ADD_TARGET = exports.ADD_SOURCE = void 0;
const ADD_SOURCE = 'dnd-core/ADD_SOURCE';
exports.ADD_SOURCE = ADD_SOURCE;
const ADD_TARGET = 'dnd-core/ADD_TARGET';
exports.ADD_TARGET = ADD_TARGET;
const REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
exports.REMOVE_SOURCE = REMOVE_SOURCE;
const REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
exports.REMOVE_TARGET = REMOVE_TARGET;
function addSource(sourceId) {
    return {
        type: ADD_SOURCE,
        payload: {
            sourceId
        }
    };
}
function addTarget(targetId) {
    return {
        type: ADD_TARGET,
        payload: {
            targetId
        }
    };
}
function removeSource(sourceId) {
    return {
        type: REMOVE_SOURCE,
        payload: {
            sourceId
        }
    };
}
function removeTarget(targetId) {
    return {
        type: REMOVE_TARGET,
        payload: {
            targetId
        }
    };
}


},{}],563:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _indexJs = require("../actions/dragDrop/index.js");
class DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch  } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') {
                    dispatch(action);
                }
            };
        }
        const actions = (0, _indexJs).createDragDropActions(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}
exports.DragDropManagerImpl = DragDropManagerImpl;


},{"../actions/dragDrop/index.js":558}],564:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _invariant = require("@react-dnd/invariant");
var _matchesTypeJs = require("../utils/matchesType.js");
var _coordsJs = require("../utils/coords.js");
var _dirtinessJs = require("../utils/dirtiness.js");
class DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds  } = options;
        (0, _invariant).invariant(typeof listener === 'function', 'listener must be a function.');
        (0, _invariant).invariant(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtinessJs).areDirty(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) {
                    listener();
                }
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, _invariant).invariant(typeof listener === 'function', 'listener must be a function.');
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) {
                return;
            }
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) {
            return false;
        }
        const source = this.registry.getSource(sourceId);
        (0, _invariant).invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) {
            return false;
        }
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        const target = this.registry.getTarget(targetId);
        (0, _invariant).invariant(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) {
            return false;
        }
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, _matchesTypeJs).matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) {
            return false;
        }
        const source = this.registry.getSource(sourceId, true);
        (0, _invariant).invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) {
            return false;
        }
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) {
            return false;
        }
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        const { shallow  } = options;
        if (!this.isDragging()) {
            return false;
        }
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, _matchesTypeJs).matchesType(targetType, draggedItemType)) {
            return false;
        }
        const targetIds = this.getTargetIds();
        if (!targetIds.length) {
            return false;
        }
        const index = targetIds.indexOf(targetId);
        if (shallow) {
            return index === targetIds.length - 1;
        } else {
            return index > -1;
        }
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, _coordsJs).getSourceClientOffset(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, _coordsJs).getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}
exports.DragDropMonitorImpl = DragDropMonitorImpl;


},{"../utils/coords.js":576,"../utils/dirtiness.js":577,"../utils/matchesType.js":581,"@react-dnd/invariant":331}],565:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _invariant = require("@react-dnd/invariant");
var _registryJs = require("../actions/registry.js");
var _getNextUniqueIdJs = require("../utils/getNextUniqueId.js");
var _interfacesJs = require("../interfaces.js");
var _contractsJs = require("../contracts.js");
var _asap = require("@react-dnd/asap");
function getNextHandlerId(role) {
    const id = (0, _getNextUniqueIdJs).getNextUniqueId().toString();
    switch(role){
        case _interfacesJs.HandlerRole.SOURCE:
            return `S${id}`;
        case _interfacesJs.HandlerRole.TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return _interfacesJs.HandlerRole.SOURCE;
        case 'T':
            return _interfacesJs.HandlerRole.TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done , value: [, value] ,  } = entries.next();
        if (value === searchValue) {
            return true;
        }
        isDone = !!done;
    }while (!isDone)
    return false;
}
class HandlerRegistryImpl {
    addSource(type, source) {
        (0, _contractsJs).validateType(type);
        (0, _contractsJs).validateSourceContract(source);
        const sourceId = this.addHandler(_interfacesJs.HandlerRole.SOURCE, type, source);
        this.store.dispatch((0, _registryJs).addSource(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, _contractsJs).validateType(type, true);
        (0, _contractsJs).validateTargetContract(target);
        const targetId = this.addHandler(_interfacesJs.HandlerRole.TARGET, type, target);
        this.store.dispatch((0, _registryJs).addTarget(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, _invariant).invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, _invariant).invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, _invariant).invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, _invariant).invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === _interfacesJs.HandlerRole.SOURCE;
    }
    isTargetId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === _interfacesJs.HandlerRole.TARGET;
    }
    removeSource(sourceId) {
        (0, _invariant).invariant(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch((0, _registryJs).removeSource(sourceId));
        (0, _asap).asap(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, _invariant).invariant(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch((0, _registryJs).removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, _invariant).invariant(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, _invariant).invariant(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = getNextHandlerId(role);
        this.types.set(id, type);
        if (role === _interfacesJs.HandlerRole.SOURCE) {
            this.dragSources.set(id, handler);
        } else if (role === _interfacesJs.HandlerRole.TARGET) {
            this.dropTargets.set(id, handler);
        }
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}
exports.HandlerRegistryImpl = HandlerRegistryImpl;


},{"../actions/registry.js":562,"../contracts.js":566,"../interfaces.js":569,"../utils/getNextUniqueId.js":579,"@react-dnd/asap":329,"@react-dnd/invariant":331}],566:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSourceContract = validateSourceContract;
exports.validateTargetContract = validateTargetContract;
exports.validateType = validateType;
var _invariant = require("@react-dnd/invariant");
function validateSourceContract(source) {
    (0, _invariant).invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, _invariant).invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, _invariant).invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
    (0, _invariant).invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, _invariant).invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, _invariant).invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>validateType(t, false)
        );
        return;
    }
    (0, _invariant).invariant(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}


},{"@react-dnd/invariant":331}],567:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDragDropManager = createDragDropManager;
var _dragDropManagerImplJs = require("./classes/DragDropManagerImpl.js");
var _redux = require("redux");
var _indexJs = require("./reducers/index.js");
var _dragDropMonitorImplJs = require("./classes/DragDropMonitorImpl.js");
var _handlerRegistryImplJs = require("./classes/HandlerRegistryImpl.js");
function createDragDropManager(backendFactory, globalContext = undefined, backendOptions = {}, debugMode = false) {
    const store = makeStoreInstance(debugMode);
    const monitor = new _dragDropMonitorImplJs.DragDropMonitorImpl(store, new _handlerRegistryImplJs.HandlerRegistryImpl(store));
    const manager = new _dragDropManagerImplJs.DragDropManagerImpl(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, _redux).createStore(_indexJs.reduce, debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}


},{"./classes/DragDropManagerImpl.js":563,"./classes/DragDropMonitorImpl.js":564,"./classes/HandlerRegistryImpl.js":565,"./reducers/index.js":573,"redux":582}],568:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _interfacesJs = _interopRequireWildcard(require("./interfaces.js"));
Object.keys(_interfacesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _interfacesJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _interfacesJs[key];
        }
    });
});
var _createDragDropManagerJs = _interopRequireWildcard(require("./createDragDropManager.js"));
Object.keys(_createDragDropManagerJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _createDragDropManagerJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _createDragDropManagerJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./createDragDropManager.js":567,"./interfaces.js":569}],569:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HandlerRole = void 0;
var HandlerRole;
exports.HandlerRole = HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (exports.HandlerRole = HandlerRole = {}));


},{}],570:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
var _indexJs = require("../actions/dragDrop/index.js");
var _registryJs = require("../actions/registry.js");
var _equalityJs = require("../utils/equality.js");
var _dirtinessJs = require("../utils/dirtiness.js");
var _jsUtilsJs = require("../utils/js_utils.js");
function reduce(// eslint-disable-next-line @typescript-eslint/no-unused-vars
_state = _dirtinessJs.NONE, action) {
    switch(action.type){
        case _indexJs.HOVER:
            break;
        case _registryJs.ADD_SOURCE:
        case _registryJs.ADD_TARGET:
        case _registryJs.REMOVE_TARGET:
        case _registryJs.REMOVE_SOURCE:
            return _dirtinessJs.NONE;
        case _indexJs.BEGIN_DRAG:
        case _indexJs.PUBLISH_DRAG_SOURCE:
        case _indexJs.END_DRAG:
        case _indexJs.DROP:
        default:
            return _dirtinessJs.ALL;
    }
    const { targetIds =[] , prevTargetIds =[]  } = action.payload;
    const result = (0, _jsUtilsJs).xor(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, _equalityJs).areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) {
        return _dirtinessJs.NONE;
    }
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) {
            result.push(prevInnermostTargetId);
        }
        if (innermostTargetId) {
            result.push(innermostTargetId);
        }
    }
    return result;
}


},{"../actions/dragDrop/index.js":558,"../actions/registry.js":562,"../utils/dirtiness.js":577,"../utils/equality.js":578,"../utils/js_utils.js":580}],571:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
var _indexJs = require("../actions/dragDrop/index.js");
var _equalityJs = require("../utils/equality.js");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function reduce(state = initialState, action) {
    const { payload  } = action;
    switch(action.type){
        case _indexJs.INIT_COORDS:
        case _indexJs.BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case _indexJs.HOVER:
            if ((0, _equalityJs).areCoordsEqual(state.clientOffset, payload.clientOffset)) {
                return state;
            }
            return _objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case _indexJs.END_DRAG:
        case _indexJs.DROP:
            return initialState;
        default:
            return state;
    }
}


},{"../actions/dragDrop/index.js":558,"../utils/equality.js":578}],572:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
var _indexJs = require("../actions/dragDrop/index.js");
var _registryJs = require("../actions/registry.js");
var _jsUtilsJs = require("../utils/js_utils.js");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function reduce(state = initialState, action) {
    const { payload  } = action;
    switch(action.type){
        case _indexJs.BEGIN_DRAG:
            return _objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case _indexJs.PUBLISH_DRAG_SOURCE:
            return _objectSpread({}, state, {
                isSourcePublic: true
            });
        case _indexJs.HOVER:
            return _objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case _registryJs.REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) {
                return state;
            }
            return _objectSpread({}, state, {
                targetIds: (0, _jsUtilsJs).without(state.targetIds, payload.targetId)
            });
        case _indexJs.DROP:
            return _objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case _indexJs.END_DRAG:
            return _objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}


},{"../actions/dragDrop/index.js":558,"../actions/registry.js":562,"../utils/js_utils.js":580}],573:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
var _dragOffsetJs = require("./dragOffset.js");
var _dragOperationJs = require("./dragOperation.js");
var _refCountJs = require("./refCount.js");
var _dirtyHandlerIdsJs = require("./dirtyHandlerIds.js");
var _stateIdJs = require("./stateId.js");
var _jsUtilsJs = require("../utils/js_utils.js");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reduce(state = {}, action) {
    return {
        dirtyHandlerIds: (0, _dirtyHandlerIdsJs).reduce(state.dirtyHandlerIds, {
            type: action.type,
            payload: _objectSpread({}, action.payload, {
                prevTargetIds: (0, _jsUtilsJs).get(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: (0, _dragOffsetJs).reduce(state.dragOffset, action),
        refCount: (0, _refCountJs).reduce(state.refCount, action),
        dragOperation: (0, _dragOperationJs).reduce(state.dragOperation, action),
        stateId: (0, _stateIdJs).reduce(state.stateId)
    };
}


},{"../utils/js_utils.js":580,"./dirtyHandlerIds.js":570,"./dragOffset.js":571,"./dragOperation.js":572,"./refCount.js":574,"./stateId.js":575}],574:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
var _registryJs = require("../actions/registry.js");
function reduce(state = 0, action) {
    switch(action.type){
        case _registryJs.ADD_SOURCE:
        case _registryJs.ADD_TARGET:
            return state + 1;
        case _registryJs.REMOVE_SOURCE:
        case _registryJs.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}


},{"../actions/registry.js":562}],575:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
function reduce(state = 0) {
    return state + 1;
}


},{}],576:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add = add;
exports.subtract = subtract;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
function add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getSourceClientOffset(state) {
    const { clientOffset , initialClientOffset , initialSourceClientOffset  } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
        return null;
    }
    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function getDifferenceFromInitialOffset(state) {
    const { clientOffset , initialClientOffset  } = state;
    if (!clientOffset || !initialClientOffset) {
        return null;
    }
    return subtract(clientOffset, initialClientOffset);
}


},{}],577:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areDirty = areDirty;
exports.ALL = exports.NONE = void 0;
var _jsUtilsJs = require("./js_utils.js");
const NONE = [];
exports.NONE = NONE;
const ALL = [];
exports.ALL = ALL;
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === NONE) {
        return false;
    }
    if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
        return true;
    }
    const commonIds = (0, _jsUtilsJs).intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}


},{"./js_utils.js":580}],578:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areCoordsEqual = areCoordsEqual;
exports.areArraysEqual = areArraysEqual;
exports.strictEquality = void 0;
const strictEquality = (a, b)=>a === b
;
exports.strictEquality = strictEquality;
function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) {
        return true;
    } else if (!offsetA || !offsetB) {
        return false;
    } else {
        return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
    }
}
function areArraysEqual(a, b, isEqual = strictEquality) {
    if (a.length !== b.length) {
        return false;
    }
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) {
            return false;
        }
    }
    return true;
}


},{}],579:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNextUniqueId = getNextUniqueId;
let nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}


},{}],580:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.get = get;
exports.without = without;
exports.isString = isString;
exports.isObject = isObject;
exports.xor = xor;
exports.intersection = intersection;
function get(obj, path, defaultValue) {
    return path.split('.').reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null
    , obj);
}
function without(items, item) {
    return items.filter((i)=>i !== item
    );
}
function isString(input) {
    return typeof input === 'string';
}
function isObject(input) {
    return typeof input === 'object';
}
function xor(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) {
            result.push(key);
        }
    });
    return result;
}
function intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1
    );
}


},{}],581:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.matchesType = matchesType;
function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) {
        return targetType === null;
    }
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType
    ) : targetType === draggedItemType;
}


},{}],582:[function(require,module,exports){
'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : { 'default': e };
}
var _objectSpread__default = _interopDefaultLegacy(_objectSpread);
function formatProdErrorMessage(code) {
    return 'Minified Redux error #' + code + '; visit https://redux.js.org/Errors?code=' + code + ' for the full message or ' + 'use the non-minified dev environment for full errors. ';
}
var $$observable = function () {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: '@@redux/INIT' + randomString(),
    REPLACE: '@@redux/REPLACE' + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return '@@redux/PROBE_UNKNOWN_ACTION' + randomString();
    }
};
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null)
        return false;
    var proto = obj;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
}
function miniKindOf(val) {
    if (val === void 0)
        return 'undefined';
    if (val === null)
        return 'null';
    var type = typeof val;
    switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function': {
            return type;
        }
    }
    if (Array.isArray(val))
        return 'array';
    if (isDate(val))
        return 'date';
    if (isError(val))
        return 'error';
    var constructorName = ctorName(val);
    switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
        return constructorName;
    }
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
    if (val instanceof Date)
        return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
    var typeOfVal = typeof val;
    if ("production" !== 'production') {
        typeOfVal = miniKindOf(val);
    }
    return typeOfVal;
}
function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
        throw new Error("production" === 'production' ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
    }
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') {
            throw new Error("production" === 'production' ? formatProdErrorMessage(1) : 'Expected the enhancer to be a function. Instead, received: \'' + kindOf(enhancer) + '\'');
        }
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') {
        throw new Error("production" === 'production' ? formatProdErrorMessage(2) : 'Expected the root reducer to be a function. Instead, received: \'' + kindOf(reducer) + '\'');
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
        }
    }
    function getState() {
        if (isDispatching) {
            throw new Error("production" === 'production' ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
        }
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== 'function') {
            throw new Error("production" === 'production' ? formatProdErrorMessage(4) : 'Expected the listener to be a function. Instead, received: \'' + kindOf(listener) + '\'');
        }
        if (isDispatching) {
            throw new Error("production" === 'production' ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
        }
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) {
                return;
            }
            if (isDispatching) {
                throw new Error("production" === 'production' ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
            }
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) {
            throw new Error("production" === 'production' ? formatProdErrorMessage(7) : 'Actions must be plain objects. Instead, the actual type was: \'' + kindOf(action) + '\'. You may need to add middleware to your store setup to handle dispatching other values, such as \'redux-thunk\' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.');
        }
        if (typeof action.type === 'undefined') {
            throw new Error("production" === 'production' ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
        }
        if (isDispatching) {
            throw new Error("production" === 'production' ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
        }
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally {
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') {
            throw new Error("production" === 'production' ? formatProdErrorMessage(10) : 'Expected the nextReducer to be a function. Instead, received: \'' + kindOf(nextReducer));
        }
        currentReducer = nextReducer;
        dispatch({ type: ActionTypes.REPLACE });
    }
    function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) {
                    throw new Error("production" === 'production' ? formatProdErrorMessage(11) : 'Expected the observer to be an object. Instead, received: \'' + kindOf(observer) + '\'');
                }
                function observeState() {
                    if (observer.next) {
                        observer.next(getState());
                    }
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return { unsubscribe: unsubscribe };
            }
        }, _ref[$$observable] = function () {
            return this;
        }, _ref;
    }
    dispatch({ type: ActionTypes.INIT });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
function warning(message) {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
        console.error(message);
    }
    try {
        throw new Error(message);
    } catch (e) {
    }
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) {
        return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
    }
    if (!isPlainObject(inputState)) {
        return 'The ' + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    }
    var unexpectedKeys = Object.keys(inputState).filter(function (key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function (key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE)
        return;
    if (unexpectedKeys.length > 0) {
        return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
    }
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function (key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, { type: ActionTypes.INIT });
        if (typeof initialState === 'undefined') {
            throw new Error("production" === 'production' ? formatProdErrorMessage(12) : 'The slice reducer for key "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        }
        if (typeof reducer(undefined, { type: ActionTypes.PROBE_UNKNOWN_ACTION() }) === 'undefined') {
            throw new Error("production" === 'production' ? formatProdErrorMessage(13) : 'The slice reducer for key "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle \'' + ActionTypes.INIT + '\' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
        }
    });
}
function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for (var i = 0; i < reducerKeys.length; i++) {
        var key = reducerKeys[i];
        if ("production" !== 'production') {
            if (typeof reducers[key] === 'undefined') {
                warning('No reducer provided for key "' + key + '"');
            }
        }
        if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
        }
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    if ("production" !== 'production') {
        unexpectedKeyCache = {};
    }
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) {
            state = {};
        }
        if (shapeAssertionError) {
            throw shapeAssertionError;
        }
        if ("production" !== 'production') {
            var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
            if (warningMessage) {
                warning(warningMessage);
            }
        }
        var hasChanged = false;
        var nextState = {};
        for (var _i = 0; _i < finalReducerKeys.length; _i++) {
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error("production" === 'production' ? formatProdErrorMessage(14) : 'When called with an action of type ' + (actionType ? '"' + String(actionType) + '"' : '(unknown type)') + ', the slice reducer for key "' + _key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.');
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function () {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') {
        return bindActionCreator(actionCreators, dispatch);
    }
    if (typeof actionCreators !== 'object' || actionCreators === null) {
        throw new Error("production" === 'production' ? formatProdErrorMessage(16) : 'bindActionCreators expected an object or a function, but instead received: \'' + kindOf(actionCreators) + '\'. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    }
    var boundActionCreators = {};
    for (var key in actionCreators) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') {
            boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
        }
    }
    return boundActionCreators;
}
function compose() {
    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) {
        return function (arg) {
            return arg;
        };
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) {
        return function () {
            return a(b.apply(void 0, arguments));
        };
    });
}
function applyMiddleware() {
    for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
        middlewares[_key] = arguments[_key];
    }
    return function (createStore) {
        return function () {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("production" === 'production' ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function (middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, { dispatch: _dispatch });
        };
    };
}
function isCrushed() {
}
if ("production" !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
    warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}
exports.__DO_NOT_USE__ActionTypes = ActionTypes;
exports.applyMiddleware = applyMiddleware;
exports.bindActionCreators = bindActionCreators;
exports.combineReducers = combineReducers;
exports.compose = compose;
exports.createStore = createStore;
},{"@babel/runtime/helpers/objectSpread2":321}],583:[function(require,module,exports){
// This file should be ES5 compatible
/* eslint prefer-spread:0, no-var:0, prefer-reflect:0, no-magic-numbers:0 */
'use strict'
module.exports = (function () {
	// Import Events
	var events = require('events')

	// Export Domain
	var domain = {}
	domain.createDomain = domain.create = function () {
		var d = new events.EventEmitter()

		function emitError (e) {
			d.emit('error', e)
		}

		d.add = function (emitter) {
			emitter.on('error', emitError)
		}
		d.remove = function (emitter) {
			emitter.removeListener('error', emitError)
		}
		d.bind = function (fn) {
			return function () {
				var args = Array.prototype.slice.call(arguments)
				try {
					fn.apply(null, args)
				}
				catch (err) {
					emitError(err)
				}
			}
		}
		d.intercept = function (fn) {
			return function (err) {
				if ( err ) {
					emitError(err)
				}
				else {
					var args = Array.prototype.slice.call(arguments, 1)
					try {
						fn.apply(null, args)
					}
					catch (err) {
						emitError(err)
					}
				}
			}
		}
		d.run = function (fn) {
			try {
				fn()
			}
			catch (err) {
				emitError(err)
			}
			return this
		}
		d.dispose = function () {
			this.removeAllListeners()
			return this
		}
		d.enter = d.exit = function () {
			return this
		}
		return d
	}
	return domain
}).call(this)

},{"events":629}],584:[function(require,module,exports){
module.exports = {
  ted: require('./ted'),
  levenshtein: require('./levenshtein')
};

},{"./levenshtein":585,"./ted":586}],585:[function(require,module,exports){
var Mapping, levenshtein, levenshteinBt, ref, trackedMin, zero;

ref = require('./util'), Mapping = ref.Mapping, zero = ref.zero, trackedMin = ref.trackedMin;

levenshtein = function(stringA, stringB, insertCb, removeCb, updateCb) {
  var a, aC, b, bC, dist, distance, i, j, k, l, m, min, n, ref1, ref2, ref3, ref4, track;
  a = stringA;
  b = stringB;
  track = zero(a.length + 1, b.length + 1);
  dist = zero(a.length + 1, b.length + 1);
  for (i = k = 1, ref1 = a.length; k <= ref1; i = k += 1) {
    dist[i][0] = i;
  }
  for (j = l = 1, ref2 = b.length; l <= ref2; j = l += 1) {
    dist[0][j] = j;
  }
  for (i = m = 1, ref3 = a.length; m <= ref3; i = m += 1) {
    for (j = n = 1, ref4 = b.length; n <= ref4; j = n += 1) {
      aC = a[i - 1];
      bC = b[j - 1];
      min = trackedMin(dist[i - 1][j] + removeCb(aC), dist[i][j - 1] + insertCb(bC), dist[i - 1][j - 1] + updateCb(aC, bC));
      track[i][j] = min.index;
      dist[i][j] = min.value;
    }
  }
  distance = dist[a.length][b.length];
  return new Mapping(a, b, distance, track, levenshteinBt);
};

levenshteinBt = function(a, b, track) {
  var i, j, mapping;
  i = a.length;
  j = b.length;
  mapping = [];
  while (i > 0 && j > 0) {
    switch (track[i][j]) {
      case 0:
        mapping.push([a[i - 1], null]);
        --i;
        break;
      case 1:
        mapping.push([null, b[j - 1]]);
        --j;
        break;
      case 2:
        mapping.push([a[i - 1], b[j - 1]]);
        --i;
        --j;
        break;
      default:
        throw new Error("Invalid operation " + track[i][j] + " at (" + i + ", " + j + ")");
    }
  }
  if (i === 0 && j !== 0) {
    while (j > 0) {
      mapping.push([null, b[j - 1]]);
      --j;
    }
  }
  if (i !== 0 && j === 0) {
    while (i > 0) {
      mapping.push([a[i - 1], null]);
      --i;
    }
  }
  return mapping;
};

module.exports = levenshtein;

},{"./util":587}],586:[function(require,module,exports){
var Mapping, postOrderWalk, ref, ted, tedBt, trackedMin, zero;

ref = require('./util'), Mapping = ref.Mapping, zero = ref.zero, trackedMin = ref.trackedMin;

postOrderWalk = function(root, childrenCb, visitCb) {
  var child, children, firstChild, index, k, len, node, ref1, ref2, ref3, ref4, stack1, stack2;
  stack1 = [];
  stack2 = [];
  stack1.push([void 0, root]);
  while (stack1.length > 0) {
    ref1 = stack1.pop(), index = ref1[0], node = ref1[1];
    children = childrenCb(node);
    firstChild = (ref2 = children != null ? children[0] : void 0) != null ? ref2 : null;
    stack2.push([index, node, firstChild]);
    ref3 = children != null ? children : [];
    for (index = k = 0, len = ref3.length; k < len; index = ++k) {
      child = ref3[index];
      stack1.push([index, child]);
    }
  }
  while (stack2.length > 0) {
    ref4 = stack2.pop(), index = ref4[0], node = ref4[1], firstChild = ref4[2];
    visitCb(index, node, firstChild);
  }
};

ted = function(rootA, rootB, childrenCb, insertCb, removeCb, updateCb) {
  var fdist, i, j, k, l, len, len1, preprocess, ref1, ref2, tA, tB, tdist, tdistance, treeDistance, ttrack;
  preprocess = function(root) {
    var t;
    t = {
      nodes: [],
      llds: [],
      keyroots: []
    };
    postOrderWalk(root, childrenCb, function(index, node, firstChild) {
      var childIndex, lldIndex, nIndex;
      nIndex = t.nodes.length;
      t.nodes.push(node);
      if (firstChild == null) {
        lldIndex = nIndex;
      } else {
        childIndex = t.nodes.indexOf(firstChild);
        lldIndex = t.llds[childIndex];
      }
      t.llds.push(lldIndex);
      if (index !== 0) {
        t.keyroots.push(nIndex);
      }
    });
    return t;
  };
  treeDistance = function(i, j) {
    var a, aL, aN, b, bL, bN, iOff, jOff, k, l, m, min, n, o, p, q, r, ref1, ref2, ref3, ref4;
    aL = tA.llds;
    bL = tB.llds;
    aN = tA.nodes;
    bN = tB.nodes;
    iOff = aL[i] - 1;
    jOff = bL[j] - 1;
    m = i - aL[i] + 2;
    n = j - bL[j] + 2;
    for (a = k = 1, ref1 = m; k < ref1; a = k += 1) {
      fdist[a][0] = fdist[a - 1][0] + removeCb(aN[a + iOff]);
    }
    for (b = l = 1, ref2 = n; l < ref2; b = l += 1) {
      fdist[0][b] = fdist[0][b - 1] + insertCb(bN[b + jOff]);
    }
    for (a = o = 1, ref3 = m; o < ref3; a = o += 1) {
      for (b = r = 1, ref4 = n; r < ref4; b = r += 1) {
        if (aL[i] === aL[a + iOff] && bL[j] === bL[b + jOff]) {
          min = trackedMin(fdist[a - 1][b] + removeCb(aN[a + iOff]), fdist[a][b - 1] + insertCb(bN[b + jOff]), fdist[a - 1][b - 1] + updateCb(aN[a + iOff], bN[b + jOff]));
          ttrack[a + iOff][b + jOff] = min.index;
          tdist[a + iOff][b + jOff] = fdist[a][b] = min.value;
        } else {
          p = aL[a + iOff] - 1 - iOff;
          q = bL[b + jOff] - 1 - jOff;
          fdist[a][b] = Math.min(fdist[a - 1][b] + removeCb(aN[a + iOff]), fdist[a][b - 1] + insertCb(bN[b + jOff]), fdist[p][q] + tdist[a + iOff][b + jOff]);
        }
      }
    }
  };
  tA = preprocess(rootA);
  tB = preprocess(rootB);
  ttrack = zero(tA.nodes.length, tB.nodes.length);
  tdist = zero(tA.nodes.length, tB.nodes.length);
  fdist = zero(tA.nodes.length + 1, tB.nodes.length + 1);
  ref1 = tA.keyroots;
  for (k = 0, len = ref1.length; k < len; k++) {
    i = ref1[k];
    ref2 = tB.keyroots;
    for (l = 0, len1 = ref2.length; l < len1; l++) {
      j = ref2[l];
      treeDistance(i, j);
    }
  }
  tdistance = tdist[tA.nodes.length - 1][tB.nodes.length - 1];
  return new Mapping(tA, tB, tdistance, ttrack, tedBt);
};

tedBt = function(tA, tB, ttrack) {
  var i, j, mapping;
  mapping = [];
  i = tA.nodes.length - 1;
  j = tB.nodes.length - 1;
  while (i >= 0 && j >= 0) {
    switch (ttrack[i][j]) {
      case 0:
        mapping.push([tA.nodes[i], null]);
        --i;
        break;
      case 1:
        mapping.push([null, tB.nodes[j]]);
        --j;
        break;
      case 2:
        mapping.push([tA.nodes[i], tB.nodes[j]]);
        --i;
        --j;
        break;
      default:
        throw new Error("Invalid operation " + ttrack[i][j] + " at (" + i + ", " + j + ")");
    }
  }
  if (i === -1 && j !== -1) {
    while (j >= 0) {
      mapping.push([null, tB.nodes[j]]);
      --j;
    }
  }
  if (i !== -1 && j === -1) {
    while (i >= 0) {
      mapping.push([tA.nodes[i], null]);
      --i;
    }
  }
  return mapping;
};

module.exports = ted;

},{"./util":587}],587:[function(require,module,exports){
var Mapping,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

module.exports.Mapping = Mapping = (function() {
  function Mapping(a1, b1, distance, track, backtrackFn) {
    this.a = a1;
    this.b = b1;
    this.distance = distance;
    this.track = track;
    this.backtrackFn = backtrackFn;
    this.alignment = bind(this.alignment, this);
    this.pairs = bind(this.pairs, this);
    this.pairCache = null;
  }

  Mapping.prototype.pairs = function() {
    if (this.pairCache == null) {
      this.pairCache = this.backtrackFn(this.a, this.b, this.track);
    }
    return this.pairCache;
  };

  Mapping.prototype.alignment = function() {
    var alignmentA, alignmentB, k, len, pair, pairs, ref;
    pairs = this.pairs();
    alignmentA = [];
    alignmentB = [];
    ref = pairs.reverse();
    for (k = 0, len = ref.length; k < len; k++) {
      pair = ref[k];
      alignmentA.push(pair[0]);
      alignmentB.push(pair[1]);
    }
    return {
      alignmentA: alignmentA,
      alignmentB: alignmentB
    };
  };

  return Mapping;

})();

module.exports.zero = function(width, height) {
  var i, j, k, l, ref, ref1, x, y;
  x = new Array(width);
  for (i = k = 0, ref = width; k < ref; i = k += 1) {
    y = x[i] = new Array(height);
    for (j = l = 0, ref1 = height; l < ref1; j = l += 1) {
      y[j] = 0;
    }
  }
  return x;
};

module.exports.trackedMin = function(a, b, c) {
  var min;
  min = {
    value: a,
    index: 0 | 0
  };
  if (b < min.value) {
    min.value = b;
    min.index = 1 | 0;
  }
  if (c < min.value) {
    min.value = c;
    min.index = 2 | 0;
  }
  return min;
};

},{}],588:[function(require,module,exports){
module.exports={"compressed":true,"categories":[{"id":"people","name":"Smileys & People","emojis":["grinning","smiley","smile","grin","laughing","sweat_smile","rolling_on_the_floor_laughing","joy","slightly_smiling_face","upside_down_face","wink","blush","innocent","smiling_face_with_3_hearts","heart_eyes","star-struck","kissing_heart","kissing","relaxed","kissing_closed_eyes","kissing_smiling_eyes","yum","stuck_out_tongue","stuck_out_tongue_winking_eye","zany_face","stuck_out_tongue_closed_eyes","money_mouth_face","hugging_face","face_with_hand_over_mouth","shushing_face","thinking_face","zipper_mouth_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","smirk","unamused","face_with_rolling_eyes","grimacing","lying_face","relieved","pensive","sleepy","drooling_face","sleeping","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","hot_face","cold_face","woozy_face","dizzy_face","exploding_head","face_with_cowboy_hat","partying_face","sunglasses","nerd_face","face_with_monocle","confused","worried","slightly_frowning_face","white_frowning_face","open_mouth","hushed","astonished","flushed","pleading_face","frowning","anguished","fearful","cold_sweat","disappointed_relieved","cry","sob","scream","confounded","persevere","disappointed","sweat","weary","tired_face","yawning_face","triumph","rage","angry","face_with_symbols_on_mouth","smiling_imp","imp","skull","skull_and_crossbones","hankey","clown_face","japanese_ogre","japanese_goblin","ghost","alien","space_invader","robot_face","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","wave","raised_back_of_hand","raised_hand_with_fingers_splayed","hand","spock-hand","ok_hand","pinching_hand","v","crossed_fingers","i_love_you_hand_sign","the_horns","call_me_hand","point_left","point_right","point_up_2","middle_finger","point_down","point_up","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","clap","raised_hands","open_hands","palms_up_together","handshake","pray","writing_hand","nail_care","selfie","muscle","mechanical_arm","mechanical_leg","leg","foot","ear","ear_with_hearing_aid","nose","brain","tooth","bone","eyes","eye","tongue","lips","baby","child","boy","girl","adult","person_with_blond_hair","man","bearded_person","red_haired_man","curly_haired_man","white_haired_man","bald_man","woman","red_haired_woman","red_haired_person","curly_haired_woman","curly_haired_person","white_haired_woman","white_haired_person","bald_woman","bald_person","blond-haired-woman","blond-haired-man","older_adult","older_man","older_woman","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","deaf_person","deaf_man","deaf_woman","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","health_worker","male-doctor","female-doctor","student","male-student","female-student","teacher","male-teacher","female-teacher","judge","male-judge","female-judge","farmer","male-farmer","female-farmer","cook","male-cook","female-cook","mechanic","male-mechanic","female-mechanic","factory_worker","male-factory-worker","female-factory-worker","office_worker","male-office-worker","female-office-worker","scientist","male-scientist","female-scientist","technologist","male-technologist","female-technologist","singer","male-singer","female-singer","artist","male-artist","female-artist","pilot","male-pilot","female-pilot","astronaut","male-astronaut","female-astronaut","firefighter","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","construction_worker","male-construction-worker","female-construction-worker","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","man_in_tuxedo","bride_with_veil","pregnant_woman","breast-feeding","angel","santa","mrs_claus","superhero","male_superhero","female_superhero","supervillain","male_supervillain","female_supervillain","mage","male_mage","female_mage","fairy","male_fairy","female_fairy","vampire","male_vampire","female_vampire","merperson","merman","mermaid","elf","male_elf","female_elf","genie","male_genie","female_genie","zombie","male_zombie","female_zombie","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","standing_person","man_standing","woman_standing","kneeling_person","man_kneeling","woman_kneeling","person_with_probing_cane","man_with_probing_cane","woman_with_probing_cane","person_in_motorized_wheelchair","man_in_motorized_wheelchair","woman_in_motorized_wheelchair","person_in_manual_wheelchair","man_in_manual_wheelchair","woman_in_manual_wheelchair","runner","man-running","woman-running","dancer","man_dancing","man_in_business_suit_levitating","dancers","man-with-bunny-ears-partying","woman-with-bunny-ears-partying","person_in_steamy_room","man_in_steamy_room","woman_in_steamy_room","person_climbing","man_climbing","woman_climbing","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","person_in_lotus_position","man_in_lotus_position","woman_in_lotus_position","bath","sleeping_accommodation","people_holding_hands","two_women_holding_hands","couple","two_men_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","footprints","kiss","love_letter","cupid","gift_heart","sparkling_heart","heartpulse","heartbeat","revolving_hearts","two_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","broken_heart","heart","orange_heart","yellow_heart","green_heart","blue_heart","purple_heart","brown_heart","black_heart","white_heart","100","anger","boom","dizzy","sweat_drops","dash","hole","bomb","speech_balloon","eye-in-speech-bubble","left_speech_bubble","right_anger_bubble","thought_balloon","zzz"]},{"id":"nature","name":"Animals & Nature","emojis":["monkey_face","monkey","gorilla","orangutan","dog","dog2","guide_dog","service_dog","poodle","wolf","fox_face","raccoon","cat","cat2","lion_face","tiger","tiger2","leopard","horse","racehorse","unicorn_face","zebra_face","deer","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","llama","giraffe_face","elephant","rhinoceros","hippopotamus","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","hedgehog","bat","bear","koala","panda_face","sloth","otter","skunk","kangaroo","badger","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","swan","owl","flamingo","peacock","parrot","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","fish","tropical_fish","blowfish","shark","octopus","shell","snail","butterfly","bug","ant","bee","beetle","cricket","spider","spider_web","scorpion","mosquito","microbe","bouquet","cherry_blossom","white_flower","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","seedling","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves"]},{"id":"foods","name":"Food & Drink","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","leafy_green","broccoli","garlic","onion","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora"]},{"id":"activity","name":"Activities","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","8ball","crystal_ball","nazar_amulet","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","yarn"]},{"id":"places","name":"Travel & Places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","busstop","motorway","railway_track","oil_drum","fuelpump","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","name":"Objects","emojis":["eyeglasses","dark_sunglasses","goggles","lab_coat","safety_vest","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","sari","one-piece_swimsuit","briefs","shorts","bikini","womans_clothes","purse","handbag","pouch","shopping_bags","school_satchel","mans_shoe","athletic_shoe","hiking_boot","womans_flat_shoe","high_heel","sandal","ballet_shoes","boot","crown","womans_hat","tophat","mortar_board","billed_cap","helmet_with_white_cross","prayer_beads","lipstick","ring","gem","mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","guitar","musical_keyboard","trumpet","violin","banjo","drum_with_drumsticks","iphone","calling","phone","telephone_receiver","pager","fax","battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","abacus","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","candle","bulb","flashlight","izakaya_lantern","diya_lamp","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","yen","dollar","euro","pound","money_with_wings","credit_card","receipt","chart","currency_exchange","heavy_dollar_sign","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","axe","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","gun","bow_and_arrow","shield","wrench","nut_and_bolt","gear","compression","scales","probing_cane","link","chains","toolbox","magnet","alembic","test_tube","petri_dish","dna","microscope","telescope","satellite_antenna","syringe","drop_of_blood","pill","adhesive_bandage","stethoscope","door","bed","couch_and_lamp","chair","toilet","shower","bathtub","razor","lotion_bottle","safety_pin","broom","basket","roll_of_paper","soap","sponge","fire_extinguisher","shopping_trolley","smoking","coffin","funeral_urn","moyai"]},{"id":"symbols","name":"Symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","vibration_mode","mobile_phone_off","female_sign","male_sign","medical_symbol","infinity","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","heavy_multiplication_x","x","negative_squared_cross_mark","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","red_circle","large_orange_circle","large_yellow_circle","large_green_circle","large_blue_circle","large_purple_circle","large_brown_circle","black_circle","white_circle","large_red_square","large_orange_square","large_yellow_square","large_green_square","large_blue_square","large_purple_square","large_brown_square","black_large_square","white_large_square","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_small_square","white_small_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","white_square_button","black_square_button"]},{"id":"flags","name":"Flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","pirate_flag","rainbow-flag","ru","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}],"emojis":{"100":{"a":"Hundred Points Symbol","b":"1F4AF","d":true,"e":true,"f":true,"h":true,"j":["score","perfect","numbers","century","exam","quiz","test","pass","hundred"],"k":[26,5],"o":2},"1234":{"a":"Input Symbol for Numbers","b":"1F522","d":true,"e":true,"f":true,"h":true,"j":["numbers","blue-square"],"k":[28,5],"o":2},"grinning":{"a":"Grinning Face","b":"1F600","d":true,"e":true,"f":true,"h":true,"j":["face","smile","happy","joy",":D","grin"],"k":[30,35],"m":":D","o":2},"monkey_face":{"a":"Monkey Face","b":"1F435","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","circus"],"k":[12,25],"l":[":o)"],"o":2},"grapes":{"a":"Grapes","b":"1F347","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","wine"],"k":[6,31],"o":2},"eyeglasses":{"a":"Eyeglasses","b":"1F453","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","eyesight","nerdy","dork","geek"],"k":[14,7],"o":2},"checkered_flag":{"a":"Chequered Flag","b":"1F3C1","d":true,"e":true,"f":true,"h":true,"j":["contest","finishline","race","gokart"],"k":[8,39],"o":2},"jack_o_lantern":{"a":"Jack-O-Lantern","b":"1F383","d":true,"e":true,"f":true,"h":true,"j":["halloween","light","pumpkin","creepy","fall"],"k":[7,34],"o":2},"wave":{"skin_variations":{"1F3FB":{"unified":"1F44B-1F3FB","non_qualified":null,"image":"1f44b-1f3fb.png","sheet_x":13,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44B-1F3FC","non_qualified":null,"image":"1f44b-1f3fc.png","sheet_x":13,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44B-1F3FD","non_qualified":null,"image":"1f44b-1f3fd.png","sheet_x":13,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44B-1F3FE","non_qualified":null,"image":"1f44b-1f3fe.png","sheet_x":13,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44B-1F3FF","non_qualified":null,"image":"1f44b-1f3ff.png","sheet_x":13,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Waving Hand Sign","b":"1F44B","d":true,"e":true,"f":true,"h":true,"j":["hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"k":[13,26],"o":2},"earth_africa":{"a":"Earth Globe Europe-Africa","b":"1F30D","d":true,"e":true,"f":true,"h":true,"j":["globe","world","international"],"k":[5,32],"o":2},"atm":{"a":"Automated Teller Machine","b":"1F3E7","d":true,"e":true,"f":true,"h":true,"j":["money","sales","cash","blue-square","payment","bank"],"k":[11,1],"o":2},"melon":{"a":"Melon","b":"1F348","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,32],"o":2},"triangular_flag_on_post":{"a":"Triangular Flag on Post","b":"1F6A9","d":true,"e":true,"f":true,"h":true,"j":["mark","milestone","place"],"k":[35,0],"o":2},"put_litter_in_its_place":{"a":"Put Litter in Its Place Symbol","b":"1F6AE","d":true,"e":true,"f":true,"h":true,"j":["blue-square","sign","human","info"],"k":[35,5],"o":2},"christmas_tree":{"a":"Christmas Tree","b":"1F384","d":true,"e":true,"f":true,"h":true,"j":["festival","vacation","december","xmas","celebration"],"k":[7,35],"o":2},"monkey":{"a":"Monkey","b":"1F412","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","banana","circus"],"k":[11,46],"o":2},"earth_americas":{"a":"Earth Globe Americas","b":"1F30E","d":true,"e":true,"f":true,"h":true,"j":["globe","world","USA","international"],"k":[5,33],"o":2},"dark_sunglasses":{"a":"Dark Sunglasses","b":"1F576-FE0F","c":"1F576","d":true,"e":true,"f":true,"h":true,"j":["face","cool","accessories"],"k":[29,33],"o":2},"raised_back_of_hand":{"skin_variations":{"1F3FB":{"unified":"1F91A-1F3FB","non_qualified":null,"image":"1f91a-1f3fb.png","sheet_x":37,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91A-1F3FC","non_qualified":null,"image":"1f91a-1f3fc.png","sheet_x":37,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91A-1F3FD","non_qualified":null,"image":"1f91a-1f3fd.png","sheet_x":37,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91A-1F3FE","non_qualified":null,"image":"1f91a-1f3fe.png","sheet_x":37,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91A-1F3FF","non_qualified":null,"image":"1f91a-1f3ff.png","sheet_x":37,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Back of Hand","b":"1F91A","d":true,"e":true,"f":true,"h":true,"j":["fingers","raised","backhand"],"k":[37,43],"o":4},"smiley":{"a":"Smiling Face with Open Mouth","b":"1F603","d":true,"e":true,"f":true,"h":true,"j":["face","happy","joy","haha",":D",":)","smile","funny"],"k":[30,38],"l":["=)","=-)"],"m":":)","o":2},"earth_asia":{"a":"Earth Globe Asia-Australia","b":"1F30F","d":true,"e":true,"f":true,"h":true,"j":["globe","world","east","international"],"k":[5,34],"o":2},"crossed_flags":{"a":"Crossed Flags","b":"1F38C","d":true,"e":true,"f":true,"h":true,"j":["japanese","nation","country","border"],"k":[7,48],"o":2},"watermelon":{"a":"Watermelon","b":"1F349","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","picnic","summer"],"k":[6,33],"o":2},"goggles":{"a":"Goggles","b":"1F97D","d":true,"e":true,"f":true,"h":true,"k":[42,15],"o":11},"raised_hand_with_fingers_splayed":{"skin_variations":{"1F3FB":{"unified":"1F590-1F3FB","non_qualified":null,"image":"1f590-1f3fb.png","sheet_x":29,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F590-1F3FC","non_qualified":null,"image":"1f590-1f3fc.png","sheet_x":29,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F590-1F3FD","non_qualified":null,"image":"1f590-1f3fd.png","sheet_x":29,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F590-1F3FE","non_qualified":null,"image":"1f590-1f3fe.png","sheet_x":29,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F590-1F3FF","non_qualified":null,"image":"1f590-1f3ff.png","sheet_x":29,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand with Fingers Splayed","b":"1F590-FE0F","c":"1F590","d":true,"e":true,"f":true,"h":true,"j":["hand","fingers","palm"],"k":[29,48],"o":2},"smile":{"a":"Smiling Face with Open Mouth and Smiling Eyes","b":"1F604","d":true,"e":true,"f":true,"h":true,"j":["face","happy","joy","funny","haha","laugh","like",":D",":)"],"k":[30,39],"l":["C:","c:",":D",":-D"],"m":":)","o":2},"potable_water":{"a":"Potable Water Symbol","b":"1F6B0","d":true,"e":true,"f":true,"h":true,"j":["blue-square","liquid","restroom","cleaning","faucet"],"k":[35,7],"o":2},"fireworks":{"a":"Fireworks","b":"1F386","d":true,"e":true,"f":true,"h":true,"j":["photo","festival","carnival","congratulations"],"k":[7,42],"o":2},"gorilla":{"a":"Gorilla","b":"1F98D","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","circus"],"k":[42,31],"o":4},"lab_coat":{"a":"Lab Coat","b":"1F97C","d":true,"e":true,"f":true,"h":true,"k":[42,14],"o":11},"tangerine":{"a":"Tangerine","b":"1F34A","d":true,"e":true,"f":true,"h":true,"j":["food","fruit","nature","orange"],"k":[6,34],"o":2},"wheelchair":{"a":"Wheelchair Symbol","b":"267F","d":true,"e":true,"f":true,"h":true,"j":["blue-square","disabled","a11y","accessibility"],"k":[53,40],"o":2},"waving_black_flag":{"a":"Waving Black Flag","b":"1F3F4","d":true,"e":true,"f":true,"h":true,"k":[11,17],"o":2},"orangutan":{"a":"Orangutan","b":"1F9A7","d":true,"e":true,"f":true,"h":true,"k":[42,55],"o":12},"sparkler":{"a":"Firework Sparkler","b":"1F387","d":true,"e":true,"f":true,"h":true,"j":["stars","night","shine"],"k":[7,43],"o":2},"globe_with_meridians":{"a":"Globe with Meridians","b":"1F310","d":true,"e":true,"f":true,"h":true,"j":["earth","international","world","internet","interweb","i18n"],"k":[5,35],"o":2},"grin":{"a":"Grinning Face with Smiling Eyes","b":"1F601","d":true,"e":true,"f":true,"h":true,"j":["face","happy","smile","joy","kawaii"],"k":[30,36],"o":2},"hand":{"skin_variations":{"1F3FB":{"unified":"270B-1F3FB","non_qualified":null,"image":"270b-1f3fb.png","sheet_x":54,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270B-1F3FC","non_qualified":null,"image":"270b-1f3fc.png","sheet_x":54,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270B-1F3FD","non_qualified":null,"image":"270b-1f3fd.png","sheet_x":54,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270B-1F3FE","non_qualified":null,"image":"270b-1f3fe.png","sheet_x":54,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270B-1F3FF","non_qualified":null,"image":"270b-1f3ff.png","sheet_x":54,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand","b":"270B","d":true,"e":true,"f":true,"h":true,"k":[54,49],"n":["raised_hand"],"o":2},"firecracker":{"a":"Firecracker","b":"1F9E8","d":true,"e":true,"f":true,"h":true,"k":[51,27],"o":11},"lemon":{"a":"Lemon","b":"1F34B","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature"],"k":[6,35],"o":2},"dog":{"a":"Dog Face","b":"1F436","d":true,"e":true,"f":true,"h":true,"j":["animal","friend","nature","woof","puppy","pet","faithful"],"k":[12,26],"o":2},"mens":{"a":"Mens Symbol","b":"1F6B9","d":true,"e":true,"f":true,"h":true,"j":["toilet","restroom","wc","blue-square","gender","male"],"k":[36,10],"o":2},"spock-hand":{"skin_variations":{"1F3FB":{"unified":"1F596-1F3FB","non_qualified":null,"image":"1f596-1f3fb.png","sheet_x":30,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F596-1F3FC","non_qualified":null,"image":"1f596-1f3fc.png","sheet_x":30,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F596-1F3FD","non_qualified":null,"image":"1f596-1f3fd.png","sheet_x":30,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F596-1F3FE","non_qualified":null,"image":"1f596-1f3fe.png","sheet_x":30,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F596-1F3FF","non_qualified":null,"image":"1f596-1f3ff.png","sheet_x":30,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand with Part Between Middle and Ring Fingers","b":"1F596","d":true,"e":true,"f":true,"h":true,"k":[30,3],"o":2},"world_map":{"a":"World Map","b":"1F5FA-FE0F","c":"1F5FA","d":true,"e":true,"f":true,"h":true,"j":["location","direction"],"k":[30,29],"o":2},"laughing":{"a":"Smiling Face with Open Mouth and Tightly-Closed Eyes","b":"1F606","d":true,"e":true,"f":true,"h":true,"j":["happy","joy","lol","satisfied","haha","face","glad","XD","laugh"],"k":[30,41],"l":[":>",":->"],"n":["satisfied"],"o":2},"waving_white_flag":{"a":"Waving White Flag","b":"1F3F3-FE0F","c":"1F3F3","d":true,"e":true,"f":true,"h":true,"k":[11,12],"o":2},"safety_vest":{"a":"Safety Vest","b":"1F9BA","d":true,"e":true,"f":true,"h":true,"k":[43,54],"o":12},"sweat_smile":{"a":"Smiling Face with Open Mouth and Cold Sweat","b":"1F605","d":true,"e":true,"f":true,"h":true,"j":["face","hot","happy","laugh","sweat","smile","relief"],"k":[30,40],"o":2},"sparkles":{"a":"Sparkles","b":"2728","d":true,"e":true,"f":true,"h":true,"j":["stars","shine","shiny","cool","awesome","good","magic"],"k":[55,16],"o":2},"banana":{"a":"Banana","b":"1F34C","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","monkey"],"k":[6,36],"o":2},"rainbow-flag":{"a":"Rainbow Flag","b":"1F3F3-FE0F-200D-1F308","c":"1F3F3-200D-1F308","d":true,"e":true,"f":true,"h":true,"k":[11,11],"o":4},"ok_hand":{"skin_variations":{"1F3FB":{"unified":"1F44C-1F3FB","non_qualified":null,"image":"1f44c-1f3fb.png","sheet_x":13,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44C-1F3FC","non_qualified":null,"image":"1f44c-1f3fc.png","sheet_x":13,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44C-1F3FD","non_qualified":null,"image":"1f44c-1f3fd.png","sheet_x":13,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44C-1F3FE","non_qualified":null,"image":"1f44c-1f3fe.png","sheet_x":13,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44C-1F3FF","non_qualified":null,"image":"1f44c-1f3ff.png","sheet_x":13,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ok Hand Sign","b":"1F44C","d":true,"e":true,"f":true,"h":true,"j":["fingers","limbs","perfect","ok","okay"],"k":[13,32],"o":2},"japan":{"a":"Silhouette of Japan","b":"1F5FE","d":true,"e":true,"f":true,"h":true,"j":["nation","country","japanese","asia"],"k":[30,33],"o":2},"dog2":{"a":"Dog","b":"1F415","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","friend","doge","pet","faithful"],"k":[11,50],"o":2},"womens":{"a":"Womens Symbol","b":"1F6BA","d":true,"e":true,"f":true,"h":true,"j":["purple-square","woman","female","toilet","loo","restroom","gender"],"k":[36,11],"o":2},"necktie":{"a":"Necktie","b":"1F454","d":true,"e":true,"f":true,"h":true,"j":["shirt","suitup","formal","fashion","cloth","business"],"k":[14,8],"o":2},"pirate_flag":{"a":"Pirate Flag","b":"1F3F4-200D-2620-FE0F","c":"1F3F4-200D-2620","d":true,"e":true,"f":true,"h":true,"k":[11,13],"o":11},"guide_dog":{"a":"Guide Dog","b":"1F9AE","d":true,"e":true,"f":true,"h":true,"k":[43,2],"o":12},"restroom":{"a":"Restroom","b":"1F6BB","d":true,"e":true,"f":true,"h":true,"j":["blue-square","toilet","refresh","wc","gender"],"k":[36,12],"o":2},"compass":{"a":"Compass","b":"1F9ED","d":true,"e":true,"f":true,"h":true,"k":[51,32],"o":11},"rolling_on_the_floor_laughing":{"a":"Rolling on the Floor Laughing","b":"1F923","d":true,"e":true,"f":true,"h":true,"k":[38,20],"o":4},"balloon":{"a":"Balloon","b":"1F388","d":true,"e":true,"f":true,"h":true,"j":["party","celebration","birthday","circus"],"k":[7,44],"o":2},"pinching_hand":{"skin_variations":{"1F3FB":{"unified":"1F90F-1F3FB","non_qualified":null,"image":"1f90f-1f3fb.png","sheet_x":37,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F90F-1F3FC","non_qualified":null,"image":"1f90f-1f3fc.png","sheet_x":37,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F90F-1F3FD","non_qualified":null,"image":"1f90f-1f3fd.png","sheet_x":37,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F90F-1F3FE","non_qualified":null,"image":"1f90f-1f3fe.png","sheet_x":37,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F90F-1F3FF","non_qualified":null,"image":"1f90f-1f3ff.png","sheet_x":37,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Pinching Hand","b":"1F90F","d":true,"e":true,"f":true,"h":true,"k":[37,17],"o":12},"pineapple":{"a":"Pineapple","b":"1F34D","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,37],"o":2},"shirt":{"a":"T-Shirt","b":"1F455","d":true,"e":true,"f":true,"h":true,"k":[14,9],"n":["tshirt"],"o":2},"service_dog":{"a":"Service Dog","b":"1F415-200D-1F9BA","d":true,"e":true,"f":true,"h":true,"k":[11,49],"o":12},"baby_symbol":{"a":"Baby Symbol","b":"1F6BC","d":true,"e":true,"f":true,"h":true,"j":["orange-square","child"],"k":[36,13],"o":2},"joy":{"a":"Face with Tears of Joy","b":"1F602","d":true,"e":true,"f":true,"h":true,"j":["face","cry","tears","weep","happy","happytears","haha"],"k":[30,37],"o":2},"tada":{"a":"Party Popper","b":"1F389","d":true,"e":true,"f":true,"h":true,"j":["party","congratulations","birthday","magic","circus","celebration"],"k":[7,45],"o":2},"mango":{"a":"Mango","b":"1F96D","d":true,"e":true,"f":true,"h":true,"k":[42,3],"o":11},"v":{"skin_variations":{"1F3FB":{"unified":"270C-1F3FB","non_qualified":null,"image":"270c-1f3fb.png","sheet_x":54,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270C-1F3FC","non_qualified":null,"image":"270c-1f3fc.png","sheet_x":55,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270C-1F3FD","non_qualified":null,"image":"270c-1f3fd.png","sheet_x":55,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270C-1F3FE","non_qualified":null,"image":"270c-1f3fe.png","sheet_x":55,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270C-1F3FF","non_qualified":null,"image":"270c-1f3ff.png","sheet_x":55,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Victory Hand","b":"270C-FE0F","c":"270C","d":true,"e":true,"f":true,"h":true,"j":["fingers","ohyeah","hand","peace","victory","two"],"k":[54,55],"o":2},"snow_capped_mountain":{"a":"Snow Capped Mountain","b":"1F3D4-FE0F","c":"1F3D4","d":true,"e":true,"f":true,"h":true,"k":[10,39],"o":2},"flag-ac":{"a":"Ascension Island Flag","b":"1F1E6-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[0,31],"o":2},"jeans":{"a":"Jeans","b":"1F456","d":true,"e":true,"f":true,"h":true,"j":["fashion","shopping"],"k":[14,10],"o":2},"poodle":{"a":"Poodle","b":"1F429","d":true,"e":true,"f":true,"h":true,"j":["dog","animal","101","nature","pet"],"k":[12,13],"o":2},"crossed_fingers":{"skin_variations":{"1F3FB":{"unified":"1F91E-1F3FB","non_qualified":null,"image":"1f91e-1f3fb.png","sheet_x":38,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91E-1F3FC","non_qualified":null,"image":"1f91e-1f3fc.png","sheet_x":38,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91E-1F3FD","non_qualified":null,"image":"1f91e-1f3fd.png","sheet_x":38,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91E-1F3FE","non_qualified":null,"image":"1f91e-1f3fe.png","sheet_x":38,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91E-1F3FF","non_qualified":null,"image":"1f91e-1f3ff.png","sheet_x":38,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Hand with Index and Middle Fingers Crossed","b":"1F91E","d":true,"e":true,"f":true,"h":true,"j":["good","lucky"],"k":[38,5],"n":["hand_with_index_and_middle_fingers_crossed"],"o":4},"flag-ad":{"a":"Andorra Flag","b":"1F1E6-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[0,32],"o":2},"slightly_smiling_face":{"a":"Slightly Smiling Face","b":"1F642","d":true,"e":true,"f":true,"h":true,"j":["face","smile"],"k":[31,44],"l":[":)","(:",":-)"],"o":2},"apple":{"a":"Red Apple","b":"1F34E","d":true,"e":true,"f":true,"h":true,"j":["fruit","mac","school"],"k":[6,38],"o":2},"wc":{"a":"Water Closet","b":"1F6BE","d":true,"e":true,"f":true,"h":true,"j":["toilet","restroom","blue-square"],"k":[36,15],"o":2},"scarf":{"a":"Scarf","b":"1F9E3","d":true,"e":true,"f":true,"h":true,"k":[51,22],"o":5},"mountain":{"a":"Mountain","b":"26F0-FE0F","c":"26F0","d":true,"e":true,"f":true,"h":true,"j":["photo","nature","environment"],"k":[54,11],"o":2},"confetti_ball":{"a":"Confetti Ball","b":"1F38A","d":true,"e":true,"f":true,"h":true,"j":["festival","party","birthday","circus"],"k":[7,46],"o":2},"i_love_you_hand_sign":{"skin_variations":{"1F3FB":{"unified":"1F91F-1F3FB","non_qualified":null,"image":"1f91f-1f3fb.png","sheet_x":38,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91F-1F3FC","non_qualified":null,"image":"1f91f-1f3fc.png","sheet_x":38,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91F-1F3FD","non_qualified":null,"image":"1f91f-1f3fd.png","sheet_x":38,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91F-1F3FE","non_qualified":null,"image":"1f91f-1f3fe.png","sheet_x":38,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91F-1F3FF","non_qualified":null,"image":"1f91f-1f3ff.png","sheet_x":38,"sheet_y":16,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"I Love You Hand Sign","b":"1F91F","d":true,"e":true,"f":true,"h":true,"k":[38,11],"o":5},"wolf":{"a":"Wolf Face","b":"1F43A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wild"],"k":[12,30],"o":2},"gloves":{"a":"Gloves","b":"1F9E4","d":true,"e":true,"f":true,"h":true,"k":[51,23],"o":5},"flag-ae":{"a":"United Arab Emirates Flag","b":"1F1E6-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[0,33],"o":2},"upside_down_face":{"a":"Upside-Down Face","b":"1F643","d":true,"e":true,"f":true,"h":true,"j":["face","flipped","silly","smile"],"k":[31,45],"o":2},"green_apple":{"a":"Green Apple","b":"1F34F","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature"],"k":[6,39],"o":2},"passport_control":{"a":"Passport Control","b":"1F6C2","d":true,"e":true,"f":true,"h":true,"j":["custom","blue-square"],"k":[36,24],"o":2},"volcano":{"a":"Volcano","b":"1F30B","d":true,"e":true,"f":true,"h":true,"j":["photo","nature","disaster"],"k":[5,30],"o":2},"tanabata_tree":{"a":"Tanabata Tree","b":"1F38B","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","branch","summer"],"k":[7,47],"o":2},"customs":{"a":"Customs","b":"1F6C3","d":true,"e":true,"f":true,"h":true,"j":["passport","border","blue-square"],"k":[36,25],"o":2},"coat":{"a":"Coat","b":"1F9E5","d":true,"e":true,"f":true,"h":true,"k":[51,24],"o":5},"wink":{"a":"Winking Face","b":"1F609","d":true,"e":true,"f":true,"h":true,"j":["face","happy","mischievous","secret",";)","smile","eye"],"k":[30,44],"l":[";)",";-)"],"m":";)","o":2},"bamboo":{"a":"Pine Decoration","b":"1F38D","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","vegetable","panda","pine_decoration"],"k":[7,49],"o":2},"flag-af":{"a":"Afghanistan Flag","b":"1F1E6-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[0,34],"o":2},"fox_face":{"a":"Fox Face","b":"1F98A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","face"],"k":[42,28],"o":4},"pear":{"a":"Pear","b":"1F350","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,40],"o":2},"mount_fuji":{"a":"Mount Fuji","b":"1F5FB","d":true,"e":true,"f":true,"h":true,"j":["photo","mountain","nature","japanese"],"k":[30,30],"o":2},"the_horns":{"skin_variations":{"1F3FB":{"unified":"1F918-1F3FB","non_qualified":null,"image":"1f918-1f3fb.png","sheet_x":37,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F918-1F3FC","non_qualified":null,"image":"1f918-1f3fc.png","sheet_x":37,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F918-1F3FD","non_qualified":null,"image":"1f918-1f3fd.png","sheet_x":37,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F918-1F3FE","non_qualified":null,"image":"1f918-1f3fe.png","sheet_x":37,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F918-1F3FF","non_qualified":null,"image":"1f918-1f3ff.png","sheet_x":37,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Sign of the Horns","b":"1F918","d":true,"e":true,"f":true,"h":true,"k":[37,31],"n":["sign_of_the_horns"],"o":2},"call_me_hand":{"skin_variations":{"1F3FB":{"unified":"1F919-1F3FB","non_qualified":null,"image":"1f919-1f3fb.png","sheet_x":37,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F919-1F3FC","non_qualified":null,"image":"1f919-1f3fc.png","sheet_x":37,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F919-1F3FD","non_qualified":null,"image":"1f919-1f3fd.png","sheet_x":37,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F919-1F3FE","non_qualified":null,"image":"1f919-1f3fe.png","sheet_x":37,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F919-1F3FF","non_qualified":null,"image":"1f919-1f3ff.png","sheet_x":37,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Call Me Hand","b":"1F919","d":true,"e":true,"f":true,"h":true,"j":["hands","gesture"],"k":[37,37],"o":4},"flag-ag":{"a":"Antigua & Barbuda Flag","b":"1F1E6-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[0,35],"o":2},"raccoon":{"a":"Raccoon","b":"1F99D","d":true,"e":true,"f":true,"h":true,"k":[42,47],"o":11},"dolls":{"a":"Japanese Dolls","b":"1F38E","d":true,"e":true,"f":true,"h":true,"j":["japanese","toy","kimono"],"k":[7,50],"o":2},"blush":{"a":"Smiling Face with Smiling Eyes","b":"1F60A","d":true,"e":true,"f":true,"h":true,"j":["face","smile","happy","flushed","crush","embarrassed","shy","joy"],"k":[30,45],"m":":)","o":2},"peach":{"a":"Peach","b":"1F351","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,41],"o":2},"baggage_claim":{"a":"Baggage Claim","b":"1F6C4","d":true,"e":true,"f":true,"h":true,"j":["blue-square","airport","transport"],"k":[36,26],"o":2},"socks":{"a":"Socks","b":"1F9E6","d":true,"e":true,"f":true,"h":true,"k":[51,25],"o":5},"camping":{"a":"Camping","b":"1F3D5-FE0F","c":"1F3D5","d":true,"e":true,"f":true,"h":true,"j":["photo","outdoors","tent"],"k":[10,40],"o":2},"dress":{"a":"Dress","b":"1F457","d":true,"e":true,"f":true,"h":true,"j":["clothes","fashion","shopping"],"k":[14,11],"o":2},"beach_with_umbrella":{"a":"Beach with Umbrella","b":"1F3D6-FE0F","c":"1F3D6","d":true,"e":true,"f":true,"h":true,"k":[10,41],"o":2},"cherries":{"a":"Cherries","b":"1F352","d":true,"e":true,"f":true,"h":true,"j":["food","fruit"],"k":[6,42],"o":2},"cat":{"a":"Cat Face","b":"1F431","d":true,"e":true,"f":true,"h":true,"j":["animal","meow","nature","pet","kitten"],"k":[12,21],"o":2},"point_left":{"skin_variations":{"1F3FB":{"unified":"1F448-1F3FB","non_qualified":null,"image":"1f448-1f3fb.png","sheet_x":13,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F448-1F3FC","non_qualified":null,"image":"1f448-1f3fc.png","sheet_x":13,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F448-1F3FD","non_qualified":null,"image":"1f448-1f3fd.png","sheet_x":13,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F448-1F3FE","non_qualified":null,"image":"1f448-1f3fe.png","sheet_x":13,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F448-1F3FF","non_qualified":null,"image":"1f448-1f3ff.png","sheet_x":13,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Left Pointing Backhand Index","b":"1F448","d":true,"e":true,"f":true,"h":true,"j":["direction","fingers","hand","left"],"k":[13,8],"o":2},"left_luggage":{"a":"Left Luggage","b":"1F6C5","d":true,"e":true,"f":true,"h":true,"j":["blue-square","travel"],"k":[36,27],"o":2},"flag-ai":{"a":"Anguilla Flag","b":"1F1E6-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[0,36],"o":2},"innocent":{"a":"Smiling Face with Halo","b":"1F607","d":true,"e":true,"f":true,"h":true,"j":["face","angel","heaven","halo"],"k":[30,42],"o":2},"flags":{"a":"Carp Streamer","b":"1F38F","d":true,"e":true,"f":true,"h":true,"j":["fish","japanese","koinobori","carp","banner"],"k":[7,51],"o":2},"warning":{"a":"Warning Sign","b":"26A0-FE0F","c":"26A0","d":true,"e":true,"f":true,"h":true,"j":["exclamation","wip","alert","error","problem","issue"],"k":[53,50],"o":2},"strawberry":{"a":"Strawberry","b":"1F353","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","nature"],"k":[6,43],"o":2},"point_right":{"skin_variations":{"1F3FB":{"unified":"1F449-1F3FB","non_qualified":null,"image":"1f449-1f3fb.png","sheet_x":13,"sheet_y":15,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F449-1F3FC","non_qualified":null,"image":"1f449-1f3fc.png","sheet_x":13,"sheet_y":16,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F449-1F3FD","non_qualified":null,"image":"1f449-1f3fd.png","sheet_x":13,"sheet_y":17,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F449-1F3FE","non_qualified":null,"image":"1f449-1f3fe.png","sheet_x":13,"sheet_y":18,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F449-1F3FF","non_qualified":null,"image":"1f449-1f3ff.png","sheet_x":13,"sheet_y":19,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Right Pointing Backhand Index","b":"1F449","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","right"],"k":[13,14],"o":2},"desert":{"a":"Desert","b":"1F3DC-FE0F","c":"1F3DC","d":true,"e":true,"f":true,"h":true,"j":["photo","warm","saharah"],"k":[10,47],"o":2},"kimono":{"a":"Kimono","b":"1F458","d":true,"e":true,"f":true,"h":true,"j":["dress","fashion","women","female","japanese"],"k":[14,12],"o":2},"flag-al":{"a":"Albania Flag","b":"1F1E6-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[0,37],"o":2},"wind_chime":{"a":"Wind Chime","b":"1F390","d":true,"e":true,"f":true,"h":true,"j":["nature","ding","spring","bell"],"k":[7,52],"o":2},"smiling_face_with_3_hearts":{"a":"Smiling Face with Smiling Eyes and Three Hearts","b":"1F970","d":true,"e":true,"f":true,"h":true,"k":[42,6],"o":11},"cat2":{"a":"Cat","b":"1F408","d":true,"e":true,"f":true,"h":true,"j":["animal","meow","pet","cats"],"k":[11,36],"o":2},"rice_scene":{"a":"Moon Viewing Ceremony","b":"1F391","d":true,"e":true,"f":true,"h":true,"j":["photo","japan","asia","tsukimi"],"k":[7,53],"o":2},"heart_eyes":{"a":"Smiling Face with Heart-Shaped Eyes","b":"1F60D","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","crush","heart"],"k":[30,48],"o":2},"sari":{"a":"Sari","b":"1F97B","d":true,"e":true,"f":true,"h":true,"k":[42,13],"o":12},"flag-am":{"a":"Armenia Flag","b":"1F1E6-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[0,38],"o":2},"lion_face":{"a":"Lion Face","b":"1F981","d":true,"e":true,"f":true,"h":true,"k":[42,19],"o":2},"desert_island":{"a":"Desert Island","b":"1F3DD-FE0F","c":"1F3DD","d":true,"e":true,"f":true,"h":true,"j":["photo","tropical","mojito"],"k":[10,48],"o":2},"point_up_2":{"skin_variations":{"1F3FB":{"unified":"1F446-1F3FB","non_qualified":null,"image":"1f446-1f3fb.png","sheet_x":12,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F446-1F3FC","non_qualified":null,"image":"1f446-1f3fc.png","sheet_x":12,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F446-1F3FD","non_qualified":null,"image":"1f446-1f3fd.png","sheet_x":12,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F446-1F3FE","non_qualified":null,"image":"1f446-1f3fe.png","sheet_x":13,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F446-1F3FF","non_qualified":null,"image":"1f446-1f3ff.png","sheet_x":13,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Up Pointing Backhand Index","b":"1F446","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","up"],"k":[12,53],"o":2},"kiwifruit":{"a":"Kiwifruit","b":"1F95D","d":true,"e":true,"f":true,"h":true,"k":[41,44],"o":4},"children_crossing":{"a":"Children Crossing","b":"1F6B8","d":true,"e":true,"f":true,"h":true,"j":["school","warning","danger","sign","driving","yellow-diamond"],"k":[36,9],"o":2},"national_park":{"a":"National Park","b":"1F3DE-FE0F","c":"1F3DE","d":true,"e":true,"f":true,"h":true,"j":["photo","environment","nature"],"k":[10,49],"o":2},"no_entry":{"a":"No Entry","b":"26D4","d":true,"e":true,"f":true,"h":true,"j":["limit","security","privacy","bad","denied","stop","circle"],"k":[54,8],"o":2},"one-piece_swimsuit":{"a":"One-Piece Swimsuit","b":"1FA71","d":true,"e":true,"f":true,"h":true,"k":[51,52],"o":12},"tiger":{"a":"Tiger Face","b":"1F42F","d":true,"e":true,"f":true,"h":true,"j":["animal","cat","danger","wild","nature","roar"],"k":[12,19],"o":2},"red_envelope":{"a":"Red Gift Envelope","b":"1F9E7","d":true,"e":true,"f":true,"h":true,"k":[51,26],"o":11},"star-struck":{"a":"Grinning Face with Star Eyes","b":"1F929","d":true,"e":true,"f":true,"h":true,"k":[38,43],"n":["grinning_face_with_star_eyes"],"o":5},"middle_finger":{"skin_variations":{"1F3FB":{"unified":"1F595-1F3FB","non_qualified":null,"image":"1f595-1f3fb.png","sheet_x":29,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F595-1F3FC","non_qualified":null,"image":"1f595-1f3fc.png","sheet_x":29,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F595-1F3FD","non_qualified":null,"image":"1f595-1f3fd.png","sheet_x":30,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F595-1F3FE","non_qualified":null,"image":"1f595-1f3fe.png","sheet_x":30,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F595-1F3FF","non_qualified":null,"image":"1f595-1f3ff.png","sheet_x":30,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Reversed Hand with Middle Finger Extended","b":"1F595","d":true,"e":true,"f":true,"h":true,"k":[29,54],"n":["reversed_hand_with_middle_finger_extended"],"o":2},"flag-ao":{"a":"Angola Flag","b":"1F1E6-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[0,39],"o":2},"tomato":{"a":"Tomato","b":"1F345","d":true,"e":true,"f":true,"h":true,"j":["fruit","vegetable","nature","food"],"k":[6,29],"o":2},"coconut":{"a":"Coconut","b":"1F965","d":true,"e":true,"f":true,"h":true,"k":[41,52],"o":5},"ribbon":{"a":"Ribbon","b":"1F380","d":true,"e":true,"f":true,"h":true,"j":["decoration","pink","girl","bowtie"],"k":[7,31],"o":2},"no_entry_sign":{"a":"No Entry Sign","b":"1F6AB","d":true,"e":true,"f":true,"h":true,"j":["forbid","stop","limit","denied","disallow","circle"],"k":[35,2],"o":2},"point_down":{"skin_variations":{"1F3FB":{"unified":"1F447-1F3FB","non_qualified":null,"image":"1f447-1f3fb.png","sheet_x":13,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F447-1F3FC","non_qualified":null,"image":"1f447-1f3fc.png","sheet_x":13,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F447-1F3FD","non_qualified":null,"image":"1f447-1f3fd.png","sheet_x":13,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F447-1F3FE","non_qualified":null,"image":"1f447-1f3fe.png","sheet_x":13,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F447-1F3FF","non_qualified":null,"image":"1f447-1f3ff.png","sheet_x":13,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Down Pointing Backhand Index","b":"1F447","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","down"],"k":[13,2],"o":2},"flag-aq":{"a":"Antarctica Flag","b":"1F1E6-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[0,40],"o":2},"briefs":{"a":"Briefs","b":"1FA72","d":true,"e":true,"f":true,"h":true,"k":[51,53],"o":12},"kissing_heart":{"a":"Face Throwing a Kiss","b":"1F618","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[31,2],"l":[":*",":-*"],"o":2},"tiger2":{"a":"Tiger","b":"1F405","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","roar"],"k":[11,33],"o":2},"stadium":{"a":"Stadium","b":"1F3DF-FE0F","c":"1F3DF","d":true,"e":true,"f":true,"h":true,"j":["photo","place","sports","concert","venue"],"k":[10,50],"o":2},"leopard":{"a":"Leopard","b":"1F406","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,34],"o":2},"no_bicycles":{"a":"No Bicycles","b":"1F6B3","d":true,"e":true,"f":true,"h":true,"j":["cyclist","prohibited","circle"],"k":[35,10],"o":2},"kissing":{"a":"Kissing Face","b":"1F617","d":true,"e":true,"f":true,"h":true,"j":["love","like","face","3","valentines","infatuation","kiss"],"k":[31,1],"o":2},"flag-ar":{"a":"Argentina Flag","b":"1F1E6-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[0,41],"o":2},"avocado":{"a":"Avocado","b":"1F951","d":true,"e":true,"f":true,"h":true,"j":["fruit","food"],"k":[41,32],"o":4},"point_up":{"skin_variations":{"1F3FB":{"unified":"261D-1F3FB","non_qualified":null,"image":"261d-1f3fb.png","sheet_x":53,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"261D-1F3FC","non_qualified":null,"image":"261d-1f3fc.png","sheet_x":53,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"261D-1F3FD","non_qualified":null,"image":"261d-1f3fd.png","sheet_x":53,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"261D-1F3FE","non_qualified":null,"image":"261d-1f3fe.png","sheet_x":53,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"261D-1F3FF","non_qualified":null,"image":"261d-1f3ff.png","sheet_x":53,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Up Pointing Index","b":"261D-FE0F","c":"261D","d":true,"e":true,"f":true,"h":true,"j":["hand","fingers","direction","up"],"k":[53,2],"o":2},"gift":{"a":"Wrapped Present","b":"1F381","d":true,"e":true,"f":true,"h":true,"j":["present","birthday","christmas","xmas"],"k":[7,32],"o":2},"classical_building":{"a":"Classical Building","b":"1F3DB-FE0F","c":"1F3DB","d":true,"e":true,"f":true,"h":true,"j":["art","culture","history"],"k":[10,46],"o":2},"shorts":{"a":"Shorts","b":"1FA73","d":true,"e":true,"f":true,"h":true,"k":[51,54],"o":12},"+1":{"skin_variations":{"1F3FB":{"unified":"1F44D-1F3FB","non_qualified":null,"image":"1f44d-1f3fb.png","sheet_x":13,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44D-1F3FC","non_qualified":null,"image":"1f44d-1f3fc.png","sheet_x":13,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44D-1F3FD","non_qualified":null,"image":"1f44d-1f3fd.png","sheet_x":13,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44D-1F3FE","non_qualified":null,"image":"1f44d-1f3fe.png","sheet_x":13,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44D-1F3FF","non_qualified":null,"image":"1f44d-1f3ff.png","sheet_x":13,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Thumbs Up Sign","b":"1F44D","d":true,"e":true,"f":true,"h":true,"j":["thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"k":[13,38],"n":["thumbsup"],"o":2},"horse":{"a":"Horse Face","b":"1F434","d":true,"e":true,"f":true,"h":true,"j":["animal","brown","nature"],"k":[12,24],"o":2},"bikini":{"a":"Bikini","b":"1F459","d":true,"e":true,"f":true,"h":true,"j":["swimming","female","woman","girl","fashion","beach","summer"],"k":[14,13],"o":2},"no_smoking":{"a":"No Smoking Symbol","b":"1F6AD","d":true,"e":true,"f":true,"h":true,"j":["cigarette","blue-square","smell","smoke"],"k":[35,4],"o":2},"eggplant":{"a":"Aubergine","b":"1F346","d":true,"e":true,"f":true,"h":true,"j":["vegetable","nature","food","aubergine"],"k":[6,30],"o":2},"flag-as":{"a":"American Samoa Flag","b":"1F1E6-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[0,42],"o":2},"reminder_ribbon":{"a":"Reminder Ribbon","b":"1F397-FE0F","c":"1F397","d":true,"e":true,"f":true,"h":true,"j":["sports","cause","support","awareness"],"k":[8,0],"o":2},"building_construction":{"a":"Building Construction","b":"1F3D7-FE0F","c":"1F3D7","d":true,"e":true,"f":true,"h":true,"j":["wip","working","progress"],"k":[10,42],"o":2},"relaxed":{"a":"White Smiling Face","b":"263A-FE0F","c":"263A","d":true,"e":true,"f":true,"h":true,"j":["face","blush","massage","happiness"],"k":[53,17],"o":2},"kissing_closed_eyes":{"a":"Kissing Face with Closed Eyes","b":"1F61A","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[31,4],"o":2},"-1":{"skin_variations":{"1F3FB":{"unified":"1F44E-1F3FB","non_qualified":null,"image":"1f44e-1f3fb.png","sheet_x":13,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44E-1F3FC","non_qualified":null,"image":"1f44e-1f3fc.png","sheet_x":13,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44E-1F3FD","non_qualified":null,"image":"1f44e-1f3fd.png","sheet_x":13,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44E-1F3FE","non_qualified":null,"image":"1f44e-1f3fe.png","sheet_x":13,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44E-1F3FF","non_qualified":null,"image":"1f44e-1f3ff.png","sheet_x":13,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Thumbs Down Sign","b":"1F44E","d":true,"e":true,"f":true,"h":true,"j":["thumbsdown","no","dislike","hand"],"k":[13,44],"n":["thumbsdown"],"o":2},"admission_tickets":{"a":"Admission Tickets","b":"1F39F-FE0F","c":"1F39F","d":true,"e":true,"f":true,"h":true,"k":[8,5],"o":2},"flag-at":{"a":"Austria Flag","b":"1F1E6-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[0,43],"o":2},"womans_clothes":{"a":"Womans Clothes","b":"1F45A","d":true,"e":true,"f":true,"h":true,"j":["fashion","shopping_bags","female"],"k":[14,14],"o":2},"do_not_litter":{"a":"Do Not Litter Symbol","b":"1F6AF","d":true,"e":true,"f":true,"h":true,"j":["trash","bin","garbage","circle"],"k":[35,6],"o":2},"potato":{"a":"Potato","b":"1F954","d":true,"e":true,"f":true,"h":true,"j":["food","tuber","vegatable","starch"],"k":[41,35],"o":4},"racehorse":{"a":"Horse","b":"1F40E","d":true,"e":true,"f":true,"h":true,"j":["animal","gamble","luck"],"k":[11,42],"o":2},"bricks":{"a":"Brick","b":"1F9F1","d":true,"e":true,"f":true,"h":true,"k":[51,36],"o":11},"fist":{"skin_variations":{"1F3FB":{"unified":"270A-1F3FB","non_qualified":null,"image":"270a-1f3fb.png","sheet_x":54,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270A-1F3FC","non_qualified":null,"image":"270a-1f3fc.png","sheet_x":54,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270A-1F3FD","non_qualified":null,"image":"270a-1f3fd.png","sheet_x":54,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270A-1F3FE","non_qualified":null,"image":"270a-1f3fe.png","sheet_x":54,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270A-1F3FF","non_qualified":null,"image":"270a-1f3ff.png","sheet_x":54,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Fist","b":"270A","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","grasp"],"k":[54,43],"o":2},"house_buildings":{"a":"House Buildings","b":"1F3D8-FE0F","c":"1F3D8","d":true,"e":true,"f":true,"h":true,"k":[10,43],"o":2},"carrot":{"a":"Carrot","b":"1F955","d":true,"e":true,"f":true,"h":true,"j":["vegetable","food","orange"],"k":[41,36],"o":4},"ticket":{"a":"Ticket","b":"1F3AB","d":true,"e":true,"f":true,"h":true,"j":["event","concert","pass"],"k":[8,17],"o":2},"flag-au":{"a":"Australia Flag","b":"1F1E6-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[0,44],"o":2},"non-potable_water":{"a":"Non-Potable Water Symbol","b":"1F6B1","d":true,"e":true,"f":true,"h":true,"j":["drink","faucet","tap","circle"],"k":[35,8],"o":2},"purse":{"a":"Purse","b":"1F45B","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","money","sales","shopping"],"k":[14,15],"o":2},"unicorn_face":{"a":"Unicorn Face","b":"1F984","d":true,"e":true,"f":true,"h":true,"k":[42,22],"o":2},"kissing_smiling_eyes":{"a":"Kissing Face with Smiling Eyes","b":"1F619","d":true,"e":true,"f":true,"h":true,"j":["face","affection","valentines","infatuation","kiss"],"k":[31,3],"o":2},"facepunch":{"skin_variations":{"1F3FB":{"unified":"1F44A-1F3FB","non_qualified":null,"image":"1f44a-1f3fb.png","sheet_x":13,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44A-1F3FC","non_qualified":null,"image":"1f44a-1f3fc.png","sheet_x":13,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44A-1F3FD","non_qualified":null,"image":"1f44a-1f3fd.png","sheet_x":13,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44A-1F3FE","non_qualified":null,"image":"1f44a-1f3fe.png","sheet_x":13,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44A-1F3FF","non_qualified":null,"image":"1f44a-1f3ff.png","sheet_x":13,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Fisted Hand Sign","b":"1F44A","d":true,"e":true,"f":true,"h":true,"j":["angry","violence","fist","hit","attack","hand"],"k":[13,20],"n":["punch"],"o":2},"medal":{"a":"Medal","b":"1F396-FE0F","c":"1F396","d":true,"e":true,"f":true,"h":true,"k":[7,56],"o":2},"zebra_face":{"a":"Zebra Face","b":"1F993","d":true,"e":true,"f":true,"h":true,"k":[42,37],"o":5},"handbag":{"a":"Handbag","b":"1F45C","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessory","accessories","shopping"],"k":[14,16],"o":2},"derelict_house_building":{"a":"Derelict House Building","b":"1F3DA-FE0F","c":"1F3DA","d":true,"e":true,"f":true,"h":true,"k":[10,45],"o":2},"yum":{"a":"Face Savouring Delicious Food","b":"1F60B","d":true,"e":true,"f":true,"h":true,"j":["happy","joy","tongue","smile","face","silly","yummy","nom","delicious","savouring"],"k":[30,46],"o":2},"corn":{"a":"Ear of Maize","b":"1F33D","d":true,"e":true,"f":true,"h":true,"j":["food","vegetable","plant"],"k":[6,21],"o":2},"flag-aw":{"a":"Aruba Flag","b":"1F1E6-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[0,45],"o":2},"no_pedestrians":{"a":"No Pedestrians","b":"1F6B7","d":true,"e":true,"f":true,"h":true,"j":["rules","crossing","walking","circle"],"k":[36,8],"o":2},"house":{"a":"House Building","b":"1F3E0","d":true,"e":true,"f":true,"h":true,"j":["building","home"],"k":[10,51],"o":2},"hot_pepper":{"a":"Hot Pepper","b":"1F336-FE0F","c":"1F336","d":true,"e":true,"f":true,"h":true,"j":["food","spicy","chilli","chili"],"k":[6,14],"o":2},"flag-ax":{"a":"Åland Islands Flag","b":"1F1E6-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[0,46],"o":2},"trophy":{"a":"Trophy","b":"1F3C6","d":true,"e":true,"f":true,"h":true,"j":["win","award","contest","place","ftw","ceremony"],"k":[9,26],"o":2},"deer":{"a":"Deer","b":"1F98C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","horns","venison"],"k":[42,30],"o":4},"left-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91B-1F3FB","non_qualified":null,"image":"1f91b-1f3fb.png","sheet_x":37,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91B-1F3FC","non_qualified":null,"image":"1f91b-1f3fc.png","sheet_x":37,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91B-1F3FD","non_qualified":null,"image":"1f91b-1f3fd.png","sheet_x":37,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91B-1F3FE","non_qualified":null,"image":"1f91b-1f3fe.png","sheet_x":37,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91B-1F3FF","non_qualified":null,"image":"1f91b-1f3ff.png","sheet_x":37,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Left-Facing Fist","b":"1F91B","d":true,"e":true,"f":true,"h":true,"k":[37,49],"o":4},"stuck_out_tongue":{"a":"Face with Stuck-out Tongue","b":"1F61B","d":true,"e":true,"f":true,"h":true,"j":["face","prank","childish","playful","mischievous","smile","tongue"],"k":[31,5],"l":[":p",":-p",":P",":-P",":b",":-b"],"m":":p","o":2},"pouch":{"a":"Pouch","b":"1F45D","d":true,"e":true,"f":true,"h":true,"j":["bag","accessories","shopping"],"k":[14,17],"o":2},"no_mobile_phones":{"a":"No Mobile Phones","b":"1F4F5","d":true,"e":true,"f":true,"h":true,"j":["iphone","mute","circle"],"k":[27,18],"o":2},"stuck_out_tongue_winking_eye":{"a":"Face with Stuck-out Tongue and Winking Eye","b":"1F61C","d":true,"e":true,"f":true,"h":true,"j":["face","prank","childish","playful","mischievous","smile","wink","tongue"],"k":[31,6],"l":[";p",";-p",";b",";-b",";P",";-P"],"m":";p","o":2},"sports_medal":{"a":"Sports Medal","b":"1F3C5","d":true,"e":true,"f":true,"h":true,"k":[9,25],"o":2},"cucumber":{"a":"Cucumber","b":"1F952","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","pickle"],"k":[41,33],"o":4},"cow":{"a":"Cow Face","b":"1F42E","d":true,"e":true,"f":true,"h":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[12,18],"o":2},"underage":{"a":"No One Under Eighteen Symbol","b":"1F51E","d":true,"e":true,"f":true,"h":true,"j":["18","drink","pub","night","minor","circle"],"k":[28,1],"o":2},"flag-az":{"a":"Azerbaijan Flag","b":"1F1E6-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[0,47],"o":2},"shopping_bags":{"a":"Shopping Bags","b":"1F6CD-FE0F","c":"1F6CD","d":true,"e":true,"f":true,"h":true,"k":[36,35],"o":2},"right-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91C-1F3FB","non_qualified":null,"image":"1f91c-1f3fb.png","sheet_x":37,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91C-1F3FC","non_qualified":null,"image":"1f91c-1f3fc.png","sheet_x":38,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91C-1F3FD","non_qualified":null,"image":"1f91c-1f3fd.png","sheet_x":38,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91C-1F3FE","non_qualified":null,"image":"1f91c-1f3fe.png","sheet_x":38,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91C-1F3FF","non_qualified":null,"image":"1f91c-1f3ff.png","sheet_x":38,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Right-Facing Fist","b":"1F91C","d":true,"e":true,"f":true,"h":true,"k":[37,55],"o":4},"house_with_garden":{"a":"House with Garden","b":"1F3E1","d":true,"e":true,"f":true,"h":true,"j":["home","plant","nature"],"k":[10,52],"o":2},"clap":{"skin_variations":{"1F3FB":{"unified":"1F44F-1F3FB","non_qualified":null,"image":"1f44f-1f3fb.png","sheet_x":13,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44F-1F3FC","non_qualified":null,"image":"1f44f-1f3fc.png","sheet_x":13,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44F-1F3FD","non_qualified":null,"image":"1f44f-1f3fd.png","sheet_x":13,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44F-1F3FE","non_qualified":null,"image":"1f44f-1f3fe.png","sheet_x":13,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44F-1F3FF","non_qualified":null,"image":"1f44f-1f3ff.png","sheet_x":13,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Clapping Hands Sign","b":"1F44F","d":true,"e":true,"f":true,"h":true,"j":["hands","praise","applause","congrats","yay"],"k":[13,50],"o":2},"leafy_green":{"a":"Leafy Green","b":"1F96C","d":true,"e":true,"f":true,"h":true,"k":[42,2],"o":11},"office":{"a":"Office Building","b":"1F3E2","d":true,"e":true,"f":true,"h":true,"j":["building","bureau","work"],"k":[10,53],"o":2},"flag-ba":{"a":"Bosnia & Herzegovina Flag","b":"1F1E7-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[0,48],"o":2},"zany_face":{"a":"Grinning Face with One Large and One Small Eye","b":"1F92A","d":true,"e":true,"f":true,"h":true,"k":[38,44],"n":["grinning_face_with_one_large_and_one_small_eye"],"o":5},"first_place_medal":{"a":"First Place Medal","b":"1F947","d":true,"e":true,"f":true,"h":true,"k":[41,22],"o":4},"ox":{"a":"Ox","b":"1F402","d":true,"e":true,"f":true,"h":true,"j":["animal","cow","beef"],"k":[11,30],"o":2},"school_satchel":{"a":"School Satchel","b":"1F392","d":true,"e":true,"f":true,"h":true,"j":["student","education","bag","backpack"],"k":[7,54],"o":2},"radioactive_sign":{"a":"Radioactive Sign","b":"2622-FE0F","c":"2622","d":true,"e":true,"f":true,"h":true,"k":[53,9],"o":2},"second_place_medal":{"a":"Second Place Medal","b":"1F948","d":true,"e":true,"f":true,"h":true,"k":[41,23],"o":4},"stuck_out_tongue_closed_eyes":{"a":"Face with Stuck-out Tongue and Tightly-Closed Eyes","b":"1F61D","d":true,"e":true,"f":true,"h":true,"j":["face","prank","playful","mischievous","smile","tongue"],"k":[31,7],"o":2},"broccoli":{"a":"Broccoli","b":"1F966","d":true,"e":true,"f":true,"h":true,"k":[41,53],"o":5},"biohazard_sign":{"a":"Biohazard Sign","b":"2623-FE0F","c":"2623","d":true,"e":true,"f":true,"h":true,"k":[53,10],"o":2},"mans_shoe":{"a":"Mans Shoe","b":"1F45E","d":true,"e":true,"f":true,"h":true,"j":["fashion","male"],"k":[14,18],"n":["shoe"],"o":2},"raised_hands":{"skin_variations":{"1F3FB":{"unified":"1F64C-1F3FB","non_qualified":null,"image":"1f64c-1f3fb.png","sheet_x":33,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64C-1F3FC","non_qualified":null,"image":"1f64c-1f3fc.png","sheet_x":33,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64C-1F3FD","non_qualified":null,"image":"1f64c-1f3fd.png","sheet_x":33,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64C-1F3FE","non_qualified":null,"image":"1f64c-1f3fe.png","sheet_x":33,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64C-1F3FF","non_qualified":null,"image":"1f64c-1f3ff.png","sheet_x":33,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person Raising Both Hands in Celebration","b":"1F64C","d":true,"e":true,"f":true,"h":true,"j":["gesture","hooray","yea","celebration","hands"],"k":[33,8],"o":2},"post_office":{"a":"Japanese Post Office","b":"1F3E3","d":true,"e":true,"f":true,"h":true,"j":["building","envelope","communication"],"k":[10,54],"o":2},"flag-bb":{"a":"Barbados Flag","b":"1F1E7-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[0,49],"o":2},"water_buffalo":{"a":"Water Buffalo","b":"1F403","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","ox","cow"],"k":[11,31],"o":2},"third_place_medal":{"a":"Third Place Medal","b":"1F949","d":true,"e":true,"f":true,"h":true,"k":[41,24],"o":4},"european_post_office":{"a":"European Post Office","b":"1F3E4","d":true,"e":true,"f":true,"h":true,"j":["building","email"],"k":[10,55],"o":2},"athletic_shoe":{"a":"Athletic Shoe","b":"1F45F","d":true,"e":true,"f":true,"h":true,"j":["shoes","sports","sneakers"],"k":[14,19],"o":2},"arrow_up":{"a":"Upwards Black Arrow","b":"2B06-FE0F","c":"2B06","d":true,"e":true,"f":true,"h":true,"j":["blue-square","continue","top","direction"],"k":[55,38],"o":2},"cow2":{"a":"Cow","b":"1F404","d":true,"e":true,"f":true,"h":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[11,32],"o":2},"open_hands":{"skin_variations":{"1F3FB":{"unified":"1F450-1F3FB","non_qualified":null,"image":"1f450-1f3fb.png","sheet_x":14,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F450-1F3FC","non_qualified":null,"image":"1f450-1f3fc.png","sheet_x":14,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F450-1F3FD","non_qualified":null,"image":"1f450-1f3fd.png","sheet_x":14,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F450-1F3FE","non_qualified":null,"image":"1f450-1f3fe.png","sheet_x":14,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F450-1F3FF","non_qualified":null,"image":"1f450-1f3ff.png","sheet_x":14,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Open Hands Sign","b":"1F450","d":true,"e":true,"f":true,"h":true,"j":["fingers","butterfly","hands","open"],"k":[13,56],"o":2},"garlic":{"a":"Garlic","b":"1F9C4","d":true,"e":true,"f":true,"h":true,"k":[44,12],"o":12},"money_mouth_face":{"a":"Money-Mouth Face","b":"1F911","d":true,"e":true,"f":true,"h":true,"j":["face","rich","dollar","money"],"k":[37,24],"o":2},"flag-bd":{"a":"Bangladesh Flag","b":"1F1E7-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[0,50],"o":2},"soccer":{"a":"Soccer Ball","b":"26BD","d":true,"e":true,"f":true,"h":true,"j":["sports","football"],"k":[53,56],"o":2},"hugging_face":{"a":"Hugging Face","b":"1F917","d":true,"e":true,"f":true,"h":true,"k":[37,30],"o":2},"onion":{"a":"Onion","b":"1F9C5","d":true,"e":true,"f":true,"h":true,"k":[44,13],"o":12},"arrow_upper_right":{"a":"North East Arrow","b":"2197-FE0F","c":"2197","d":true,"e":true,"f":true,"h":true,"j":["blue-square","point","direction","diagonal","northeast"],"k":[52,17],"o":2},"palms_up_together":{"skin_variations":{"1F3FB":{"unified":"1F932-1F3FB","non_qualified":null,"image":"1f932-1f3fb.png","sheet_x":39,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F932-1F3FC","non_qualified":null,"image":"1f932-1f3fc.png","sheet_x":39,"sheet_y":7,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F932-1F3FD","non_qualified":null,"image":"1f932-1f3fd.png","sheet_x":39,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F932-1F3FE","non_qualified":null,"image":"1f932-1f3fe.png","sheet_x":39,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F932-1F3FF","non_qualified":null,"image":"1f932-1f3ff.png","sheet_x":39,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Palms Up Together","b":"1F932","d":true,"e":true,"f":true,"h":true,"k":[39,5],"o":5},"pig":{"a":"Pig Face","b":"1F437","d":true,"e":true,"f":true,"h":true,"j":["animal","oink","nature"],"k":[12,27],"o":2},"hospital":{"a":"Hospital","b":"1F3E5","d":true,"e":true,"f":true,"h":true,"j":["building","health","surgery","doctor"],"k":[10,56],"o":2},"hiking_boot":{"a":"Hiking Boot","b":"1F97E","d":true,"e":true,"f":true,"h":true,"k":[42,16],"o":11},"flag-be":{"a":"Belgium Flag","b":"1F1E7-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[0,51],"o":2},"flag-bf":{"a":"Burkina Faso Flag","b":"1F1E7-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[0,52],"o":2},"mushroom":{"a":"Mushroom","b":"1F344","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable"],"k":[6,28],"o":2},"pig2":{"a":"Pig","b":"1F416","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,51],"o":2},"baseball":{"a":"Baseball","b":"26BE","d":true,"e":true,"f":true,"h":true,"j":["sports","balls"],"k":[54,0],"o":2},"face_with_hand_over_mouth":{"a":"Smiling Face with Smiling Eyes and Hand Covering Mouth","b":"1F92D","d":true,"e":true,"f":true,"h":true,"k":[38,47],"n":["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],"o":5},"handshake":{"a":"Handshake","b":"1F91D","d":true,"e":true,"f":true,"h":true,"j":["agreement","shake"],"k":[38,4],"o":4},"womans_flat_shoe":{"a":"Flat Shoe","b":"1F97F","d":true,"e":true,"f":true,"h":true,"k":[42,17],"o":11},"bank":{"a":"Bank","b":"1F3E6","d":true,"e":true,"f":true,"h":true,"j":["building","money","sales","cash","business","enterprise"],"k":[11,0],"o":2},"arrow_right":{"a":"Black Rightwards Arrow","b":"27A1-FE0F","c":"27A1","d":true,"e":true,"f":true,"h":true,"j":["blue-square","next"],"k":[55,32],"o":2},"peanuts":{"a":"Peanuts","b":"1F95C","d":true,"e":true,"f":true,"h":true,"j":["food","nut"],"k":[41,43],"o":4},"shushing_face":{"a":"Face with Finger Covering Closed Lips","b":"1F92B","d":true,"e":true,"f":true,"h":true,"k":[38,45],"n":["face_with_finger_covering_closed_lips"],"o":5},"pray":{"skin_variations":{"1F3FB":{"unified":"1F64F-1F3FB","non_qualified":null,"image":"1f64f-1f3fb.png","sheet_x":33,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64F-1F3FC","non_qualified":null,"image":"1f64f-1f3fc.png","sheet_x":33,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64F-1F3FD","non_qualified":null,"image":"1f64f-1f3fd.png","sheet_x":33,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64F-1F3FE","non_qualified":null,"image":"1f64f-1f3fe.png","sheet_x":33,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64F-1F3FF","non_qualified":null,"image":"1f64f-1f3ff.png","sheet_x":33,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person with Folded Hands","b":"1F64F","d":true,"e":true,"f":true,"h":true,"j":["please","hope","wish","namaste","highfive"],"k":[33,50],"o":2},"softball":{"a":"Softball","b":"1F94E","d":true,"e":true,"f":true,"h":true,"k":[41,29],"o":11},"high_heel":{"a":"High-Heeled Shoe","b":"1F460","d":true,"e":true,"f":true,"h":true,"j":["fashion","shoes","female","pumps","stiletto"],"k":[14,20],"o":2},"flag-bg":{"a":"Bulgaria Flag","b":"1F1E7-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[0,53],"o":2},"arrow_lower_right":{"a":"South East Arrow","b":"2198-FE0F","c":"2198","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","diagonal","southeast"],"k":[52,18],"o":2},"hotel":{"a":"Hotel","b":"1F3E8","d":true,"e":true,"f":true,"h":true,"j":["building","accomodation","checkin"],"k":[11,2],"o":2},"boar":{"a":"Boar","b":"1F417","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,52],"o":2},"sandal":{"a":"Womans Sandal","b":"1F461","d":true,"e":true,"f":true,"h":true,"j":["shoes","fashion","flip flops"],"k":[14,21],"o":2},"flag-bh":{"a":"Bahrain Flag","b":"1F1E7-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[0,54],"o":2},"arrow_down":{"a":"Downwards Black Arrow","b":"2B07-FE0F","c":"2B07","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[55,39],"o":2},"thinking_face":{"a":"Thinking Face","b":"1F914","d":true,"e":true,"f":true,"h":true,"k":[37,27],"o":2},"writing_hand":{"skin_variations":{"1F3FB":{"unified":"270D-1F3FB","non_qualified":null,"image":"270d-1f3fb.png","sheet_x":55,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270D-1F3FC","non_qualified":null,"image":"270d-1f3fc.png","sheet_x":55,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270D-1F3FD","non_qualified":null,"image":"270d-1f3fd.png","sheet_x":55,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270D-1F3FE","non_qualified":null,"image":"270d-1f3fe.png","sheet_x":55,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270D-1F3FF","non_qualified":null,"image":"270d-1f3ff.png","sheet_x":55,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Writing Hand","b":"270D-FE0F","c":"270D","d":true,"e":true,"f":true,"h":true,"j":["lower_left_ballpoint_pen","stationery","write","compose"],"k":[55,4],"o":2},"chestnut":{"a":"Chestnut","b":"1F330","d":true,"e":true,"f":true,"h":true,"j":["food","squirrel"],"k":[6,8],"o":2},"basketball":{"a":"Basketball and Hoop","b":"1F3C0","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","NBA"],"k":[8,38],"o":2},"pig_nose":{"a":"Pig Nose","b":"1F43D","d":true,"e":true,"f":true,"h":true,"j":["animal","oink"],"k":[12,33],"o":2},"love_hotel":{"a":"Love Hotel","b":"1F3E9","d":true,"e":true,"f":true,"h":true,"j":["like","affection","dating"],"k":[11,3],"o":2},"nail_care":{"skin_variations":{"1F3FB":{"unified":"1F485-1F3FB","non_qualified":null,"image":"1f485-1f3fb.png","sheet_x":24,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F485-1F3FC","non_qualified":null,"image":"1f485-1f3fc.png","sheet_x":24,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F485-1F3FD","non_qualified":null,"image":"1f485-1f3fd.png","sheet_x":24,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F485-1F3FE","non_qualified":null,"image":"1f485-1f3fe.png","sheet_x":24,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F485-1F3FF","non_qualified":null,"image":"1f485-1f3ff.png","sheet_x":24,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Nail Polish","b":"1F485","d":true,"e":true,"f":true,"h":true,"j":["beauty","manicure","finger","fashion","nail"],"k":[24,33],"o":2},"volleyball":{"a":"Volleyball","b":"1F3D0","d":true,"e":true,"f":true,"h":true,"j":["sports","balls"],"k":[10,35],"o":2},"flag-bi":{"a":"Burundi Flag","b":"1F1E7-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[0,55],"o":2},"arrow_lower_left":{"a":"South West Arrow","b":"2199-FE0F","c":"2199","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","diagonal","southwest"],"k":[52,19],"o":2},"ram":{"a":"Ram","b":"1F40F","d":true,"e":true,"f":true,"h":true,"j":["animal","sheep","nature"],"k":[11,43],"o":2},"ballet_shoes":{"a":"Ballet Shoes","b":"1FA70","d":true,"e":true,"f":true,"h":true,"k":[51,51],"o":12},"zipper_mouth_face":{"a":"Zipper-Mouth Face","b":"1F910","d":true,"e":true,"f":true,"h":true,"j":["face","sealed","zipper","secret"],"k":[37,23],"o":2},"bread":{"a":"Bread","b":"1F35E","d":true,"e":true,"f":true,"h":true,"j":["food","wheat","breakfast","toast"],"k":[6,54],"o":2},"convenience_store":{"a":"Convenience Store","b":"1F3EA","d":true,"e":true,"f":true,"h":true,"j":["building","shopping","groceries"],"k":[11,4],"o":2},"boot":{"a":"Womans Boots","b":"1F462","d":true,"e":true,"f":true,"h":true,"j":["shoes","fashion"],"k":[14,22],"o":2},"sheep":{"a":"Sheep","b":"1F411","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wool","shipit"],"k":[11,45],"o":2},"face_with_raised_eyebrow":{"a":"Face with One Eyebrow Raised","b":"1F928","d":true,"e":true,"f":true,"h":true,"k":[38,42],"n":["face_with_one_eyebrow_raised"],"o":5},"flag-bj":{"a":"Benin Flag","b":"1F1E7-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[0,56],"o":2},"arrow_left":{"a":"Leftwards Black Arrow","b":"2B05-FE0F","c":"2B05","d":true,"e":true,"f":true,"h":true,"j":["blue-square","previous","back"],"k":[55,37],"o":2},"selfie":{"skin_variations":{"1F3FB":{"unified":"1F933-1F3FB","non_qualified":null,"image":"1f933-1f3fb.png","sheet_x":39,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F933-1F3FC","non_qualified":null,"image":"1f933-1f3fc.png","sheet_x":39,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F933-1F3FD","non_qualified":null,"image":"1f933-1f3fd.png","sheet_x":39,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F933-1F3FE","non_qualified":null,"image":"1f933-1f3fe.png","sheet_x":39,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F933-1F3FF","non_qualified":null,"image":"1f933-1f3ff.png","sheet_x":39,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Selfie","b":"1F933","d":true,"e":true,"f":true,"h":true,"j":["camera","phone"],"k":[39,11],"o":4},"croissant":{"a":"Croissant","b":"1F950","d":true,"e":true,"f":true,"h":true,"j":["food","bread","french"],"k":[41,31],"o":4},"school":{"a":"School","b":"1F3EB","d":true,"e":true,"f":true,"h":true,"j":["building","student","education","learn","teach"],"k":[11,5],"o":2},"football":{"a":"American Football","b":"1F3C8","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","NFL"],"k":[9,33],"o":2},"goat":{"a":"Goat","b":"1F410","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,44],"o":2},"department_store":{"a":"Department Store","b":"1F3EC","d":true,"e":true,"f":true,"h":true,"j":["building","shopping","mall"],"k":[11,6],"o":2},"flag-bl":{"a":"St. Barthélemy Flag","b":"1F1E7-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[1,0],"o":2},"crown":{"a":"Crown","b":"1F451","d":true,"e":true,"f":true,"h":true,"j":["king","kod","leader","royalty","lord"],"k":[14,5],"o":2},"arrow_upper_left":{"a":"North West Arrow","b":"2196-FE0F","c":"2196","d":true,"e":true,"f":true,"h":true,"j":["blue-square","point","direction","diagonal","northwest"],"k":[52,16],"o":2},"neutral_face":{"a":"Neutral Face","b":"1F610","d":true,"e":true,"f":true,"h":true,"j":["indifference","meh",":|","neutral"],"k":[30,51],"l":[":|",":-|"],"o":2},"rugby_football":{"a":"Rugby Football","b":"1F3C9","d":true,"e":true,"f":true,"h":true,"j":["sports","team"],"k":[9,34],"o":2},"muscle":{"skin_variations":{"1F3FB":{"unified":"1F4AA-1F3FB","non_qualified":null,"image":"1f4aa-1f3fb.png","sheet_x":25,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F4AA-1F3FC","non_qualified":null,"image":"1f4aa-1f3fc.png","sheet_x":25,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F4AA-1F3FD","non_qualified":null,"image":"1f4aa-1f3fd.png","sheet_x":25,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F4AA-1F3FE","non_qualified":null,"image":"1f4aa-1f3fe.png","sheet_x":25,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F4AA-1F3FF","non_qualified":null,"image":"1f4aa-1f3ff.png","sheet_x":26,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Flexed Biceps","b":"1F4AA","d":true,"e":true,"f":true,"h":true,"j":["arm","flex","hand","summer","strong","biceps"],"k":[25,52],"o":2},"baguette_bread":{"a":"Baguette Bread","b":"1F956","d":true,"e":true,"f":true,"h":true,"j":["food","bread","french"],"k":[41,37],"o":4},"expressionless":{"a":"Expressionless Face","b":"1F611","d":true,"e":true,"f":true,"h":true,"j":["face","indifferent","-_-","meh","deadpan"],"k":[30,52],"o":2},"womans_hat":{"a":"Womans Hat","b":"1F452","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","female","lady","spring"],"k":[14,6],"o":2},"pretzel":{"a":"Pretzel","b":"1F968","d":true,"e":true,"f":true,"h":true,"k":[41,55],"o":5},"mechanical_arm":{"a":"Mechanical Arm","b":"1F9BE","d":true,"e":true,"f":true,"h":true,"k":[44,6],"o":12},"arrow_up_down":{"a":"Up Down Arrow","b":"2195-FE0F","c":"2195","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","way","vertical"],"k":[52,15],"o":2},"dromedary_camel":{"a":"Dromedary Camel","b":"1F42A","d":true,"e":true,"f":true,"h":true,"j":["animal","hot","desert","hump"],"k":[12,14],"o":2},"tennis":{"a":"Tennis Racquet and Ball","b":"1F3BE","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","green"],"k":[8,36],"o":2},"flag-bm":{"a":"Bermuda Flag","b":"1F1E7-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,1],"o":2},"factory":{"a":"Factory","b":"1F3ED","d":true,"e":true,"f":true,"h":true,"j":["building","industry","pollution","smoke"],"k":[11,7],"o":2},"japanese_castle":{"a":"Japanese Castle","b":"1F3EF","d":true,"e":true,"f":true,"h":true,"j":["photo","building"],"k":[11,9],"o":2},"no_mouth":{"a":"Face Without Mouth","b":"1F636","d":true,"e":true,"f":true,"h":true,"j":["face","hellokitty"],"k":[31,32],"o":2},"mechanical_leg":{"a":"Mechanical Leg","b":"1F9BF","d":true,"e":true,"f":true,"h":true,"k":[44,7],"o":12},"bagel":{"a":"Bagel","b":"1F96F","d":true,"e":true,"f":true,"h":true,"k":[42,5],"o":11},"camel":{"a":"Bactrian Camel","b":"1F42B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","hot","desert","hump"],"k":[12,15],"o":2},"tophat":{"a":"Top Hat","b":"1F3A9","d":true,"e":true,"f":true,"h":true,"j":["magic","gentleman","classy","circus"],"k":[8,15],"o":2},"left_right_arrow":{"a":"Left Right Arrow","b":"2194-FE0F","c":"2194","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","horizontal","sideways"],"k":[52,14],"o":2},"flag-bn":{"a":"Brunei Flag","b":"1F1E7-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[1,2],"o":2},"flying_disc":{"a":"Flying Disc","b":"1F94F","d":true,"e":true,"f":true,"h":true,"k":[41,30],"o":11},"smirk":{"a":"Smirking Face","b":"1F60F","d":true,"e":true,"f":true,"h":true,"j":["face","smile","mean","prank","smug","sarcasm"],"k":[30,50],"o":2},"mortar_board":{"a":"Graduation Cap","b":"1F393","d":true,"e":true,"f":true,"h":true,"j":["school","college","degree","university","graduation","cap","hat","legal","learn","education"],"k":[7,55],"o":2},"european_castle":{"a":"European Castle","b":"1F3F0","d":true,"e":true,"f":true,"h":true,"j":["building","royalty","history"],"k":[11,10],"o":2},"leg":{"skin_variations":{"1F3FB":{"unified":"1F9B5-1F3FB","non_qualified":null,"image":"1f9b5-1f3fb.png","sheet_x":43,"sheet_y":6,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B5-1F3FC","non_qualified":null,"image":"1f9b5-1f3fc.png","sheet_x":43,"sheet_y":7,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B5-1F3FD","non_qualified":null,"image":"1f9b5-1f3fd.png","sheet_x":43,"sheet_y":8,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B5-1F3FE","non_qualified":null,"image":"1f9b5-1f3fe.png","sheet_x":43,"sheet_y":9,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B5-1F3FF","non_qualified":null,"image":"1f9b5-1f3ff.png","sheet_x":43,"sheet_y":10,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Leg","b":"1F9B5","d":true,"e":true,"f":true,"h":true,"k":[43,5],"o":11},"pancakes":{"a":"Pancakes","b":"1F95E","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","flapjacks","hotcakes"],"k":[41,45],"o":4},"leftwards_arrow_with_hook":{"a":"Leftwards Arrow with Hook","b":"21A9-FE0F","c":"21A9","d":true,"e":true,"f":true,"h":true,"j":["back","return","blue-square","undo","enter"],"k":[52,20],"o":2},"flag-bo":{"a":"Bolivia Flag","b":"1F1E7-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,3],"o":2},"bowling":{"a":"Bowling","b":"1F3B3","d":true,"e":true,"f":true,"h":true,"j":["sports","fun","play"],"k":[8,25],"o":2},"llama":{"a":"Llama","b":"1F999","d":true,"e":true,"f":true,"h":true,"k":[42,43],"o":11},"arrow_right_hook":{"a":"Rightwards Arrow with Hook","b":"21AA-FE0F","c":"21AA","d":true,"e":true,"f":true,"h":true,"j":["blue-square","return","rotate","direction"],"k":[52,21],"o":2},"wedding":{"a":"Wedding","b":"1F492","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","couple","marriage","bride","groom"],"k":[25,28],"o":2},"flag-bq":{"a":"Caribbean Netherlands Flag","b":"1F1E7-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[1,4],"o":2},"foot":{"skin_variations":{"1F3FB":{"unified":"1F9B6-1F3FB","non_qualified":null,"image":"1f9b6-1f3fb.png","sheet_x":43,"sheet_y":12,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B6-1F3FC","non_qualified":null,"image":"1f9b6-1f3fc.png","sheet_x":43,"sheet_y":13,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B6-1F3FD","non_qualified":null,"image":"1f9b6-1f3fd.png","sheet_x":43,"sheet_y":14,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B6-1F3FE","non_qualified":null,"image":"1f9b6-1f3fe.png","sheet_x":43,"sheet_y":15,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B6-1F3FF","non_qualified":null,"image":"1f9b6-1f3ff.png","sheet_x":43,"sheet_y":16,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Foot","b":"1F9B6","d":true,"e":true,"f":true,"h":true,"k":[43,11],"o":11},"giraffe_face":{"a":"Giraffe Face","b":"1F992","d":true,"e":true,"f":true,"h":true,"k":[42,36],"o":5},"unamused":{"a":"Unamused Face","b":"1F612","d":true,"e":true,"f":true,"h":true,"j":["indifference","bored","straight face","serious","sarcasm"],"k":[30,53],"m":":(","o":2},"billed_cap":{"a":"Billed Cap","b":"1F9E2","d":true,"e":true,"f":true,"h":true,"k":[51,21],"o":5},"waffle":{"a":"Waffle","b":"1F9C7","d":true,"e":true,"f":true,"h":true,"k":[44,15],"o":12},"cricket_bat_and_ball":{"a":"Cricket Bat and Ball","b":"1F3CF","d":true,"e":true,"f":true,"h":true,"k":[10,34],"o":2},"helmet_with_white_cross":{"a":"Helmet with White Cross","b":"26D1-FE0F","c":"26D1","d":true,"e":true,"f":true,"h":true,"k":[54,6],"o":2},"ear":{"skin_variations":{"1F3FB":{"unified":"1F442-1F3FB","non_qualified":null,"image":"1f442-1f3fb.png","sheet_x":12,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F442-1F3FC","non_qualified":null,"image":"1f442-1f3fc.png","sheet_x":12,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F442-1F3FD","non_qualified":null,"image":"1f442-1f3fd.png","sheet_x":12,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F442-1F3FE","non_qualified":null,"image":"1f442-1f3fe.png","sheet_x":12,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F442-1F3FF","non_qualified":null,"image":"1f442-1f3ff.png","sheet_x":12,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ear","b":"1F442","d":true,"e":true,"f":true,"h":true,"j":["face","hear","sound","listen"],"k":[12,39],"o":2},"elephant":{"a":"Elephant","b":"1F418","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","nose","th","circus"],"k":[11,53],"o":2},"cheese_wedge":{"a":"Cheese Wedge","b":"1F9C0","d":true,"e":true,"f":true,"h":true,"k":[44,8],"o":2},"tokyo_tower":{"a":"Tokyo Tower","b":"1F5FC","d":true,"e":true,"f":true,"h":true,"j":["photo","japanese"],"k":[30,31],"o":2},"arrow_heading_up":{"a":"Arrow Pointing Rightwards Then Curving Upwards","b":"2934-FE0F","c":"2934","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","top"],"k":[55,35],"o":2},"field_hockey_stick_and_ball":{"a":"Field Hockey Stick and Ball","b":"1F3D1","d":true,"e":true,"f":true,"h":true,"k":[10,36],"o":2},"flag-br":{"a":"Brazil Flag","b":"1F1E7-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,5],"o":2},"face_with_rolling_eyes":{"a":"Face with Rolling Eyes","b":"1F644","d":true,"e":true,"f":true,"h":true,"k":[31,46],"o":2},"ear_with_hearing_aid":{"skin_variations":{"1F3FB":{"unified":"1F9BB-1F3FB","non_qualified":null,"image":"1f9bb-1f3fb.png","sheet_x":43,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9BB-1F3FC","non_qualified":null,"image":"1f9bb-1f3fc.png","sheet_x":44,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9BB-1F3FD","non_qualified":null,"image":"1f9bb-1f3fd.png","sheet_x":44,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9BB-1F3FE","non_qualified":null,"image":"1f9bb-1f3fe.png","sheet_x":44,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9BB-1F3FF","non_qualified":null,"image":"1f9bb-1f3ff.png","sheet_x":44,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ear with Hearing Aid","b":"1F9BB","d":true,"e":true,"f":true,"h":true,"k":[43,55],"o":12},"arrow_heading_down":{"a":"Arrow Pointing Rightwards Then Curving Downwards","b":"2935-FE0F","c":"2935","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[55,36],"o":2},"ice_hockey_stick_and_puck":{"a":"Ice Hockey Stick and Puck","b":"1F3D2","d":true,"e":true,"f":true,"h":true,"k":[10,37],"o":2},"meat_on_bone":{"a":"Meat on Bone","b":"1F356","d":true,"e":true,"f":true,"h":true,"j":["good","food","drumstick"],"k":[6,46],"o":2},"prayer_beads":{"a":"Prayer Beads","b":"1F4FF","d":true,"e":true,"f":true,"h":true,"j":["dhikr","religious"],"k":[27,27],"o":2},"statue_of_liberty":{"a":"Statue of Liberty","b":"1F5FD","d":true,"e":true,"f":true,"h":true,"j":["american","newyork"],"k":[30,32],"o":2},"grimacing":{"a":"Grimacing Face","b":"1F62C","d":true,"e":true,"f":true,"h":true,"j":["face","grimace","teeth"],"k":[31,22],"o":2},"flag-bs":{"a":"Bahamas Flag","b":"1F1E7-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[1,6],"o":2},"rhinoceros":{"a":"Rhinoceros","b":"1F98F","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","horn"],"k":[42,33],"o":4},"lacrosse":{"a":"Lacrosse Stick and Ball","b":"1F94D","d":true,"e":true,"f":true,"h":true,"k":[41,28],"o":11},"poultry_leg":{"a":"Poultry Leg","b":"1F357","d":true,"e":true,"f":true,"h":true,"j":["food","meat","drumstick","bird","chicken","turkey"],"k":[6,47],"o":2},"hippopotamus":{"a":"Hippopotamus","b":"1F99B","d":true,"e":true,"f":true,"h":true,"k":[42,45],"o":11},"nose":{"skin_variations":{"1F3FB":{"unified":"1F443-1F3FB","non_qualified":null,"image":"1f443-1f3fb.png","sheet_x":12,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F443-1F3FC","non_qualified":null,"image":"1f443-1f3fc.png","sheet_x":12,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F443-1F3FD","non_qualified":null,"image":"1f443-1f3fd.png","sheet_x":12,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F443-1F3FE","non_qualified":null,"image":"1f443-1f3fe.png","sheet_x":12,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F443-1F3FF","non_qualified":null,"image":"1f443-1f3ff.png","sheet_x":12,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Nose","b":"1F443","d":true,"e":true,"f":true,"h":true,"j":["smell","sniff"],"k":[12,45],"o":2},"arrows_clockwise":{"a":"Clockwise Downwards and Upwards Open Circle Arrows","b":"1F503","d":true,"e":true,"f":true,"h":true,"j":["sync","cycle","round","repeat"],"k":[27,31],"o":2},"flag-bt":{"a":"Bhutan Flag","b":"1F1E7-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[1,7],"o":2},"church":{"a":"Church","b":"26EA","d":true,"e":true,"f":true,"h":true,"j":["building","religion","christ"],"k":[54,10],"o":2},"lipstick":{"a":"Lipstick","b":"1F484","d":true,"e":true,"f":true,"h":true,"j":["female","girl","fashion","woman"],"k":[24,32],"o":2},"lying_face":{"a":"Lying Face","b":"1F925","d":true,"e":true,"f":true,"h":true,"j":["face","lie","pinocchio"],"k":[38,22],"o":4},"arrows_counterclockwise":{"a":"Anticlockwise Downwards and Upwards Open Circle Arrows","b":"1F504","d":true,"e":true,"f":true,"h":true,"j":["blue-square","sync","cycle"],"k":[27,32],"o":2},"flag-bv":{"a":"Bouvet Island Flag","b":"1F1E7-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[1,8],"o":2},"cut_of_meat":{"a":"Cut of Meat","b":"1F969","d":true,"e":true,"f":true,"h":true,"k":[41,56],"o":5},"mosque":{"a":"Mosque","b":"1F54C","d":true,"e":true,"f":true,"h":true,"j":["islam","worship","minaret"],"k":[28,36],"o":2},"ring":{"a":"Ring","b":"1F48D","d":true,"e":true,"f":true,"h":true,"j":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"k":[25,23],"o":2},"brain":{"a":"Brain","b":"1F9E0","d":true,"e":true,"f":true,"h":true,"k":[51,19],"o":5},"table_tennis_paddle_and_ball":{"a":"Table Tennis Paddle and Ball","b":"1F3D3","d":true,"e":true,"f":true,"h":true,"k":[10,38],"o":2},"relieved":{"a":"Relieved Face","b":"1F60C","d":true,"e":true,"f":true,"h":true,"j":["face","relaxed","phew","massage","happiness"],"k":[30,47],"o":2},"mouse":{"a":"Mouse Face","b":"1F42D","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","cheese_wedge","rodent"],"k":[12,17],"o":2},"hindu_temple":{"a":"Hindu Temple","b":"1F6D5","d":true,"e":true,"f":true,"h":true,"k":[36,41],"o":12},"back":{"a":"Back with Leftwards Arrow Above","b":"1F519","d":true,"e":true,"f":true,"h":true,"j":["arrow","words","return"],"k":[27,53],"o":2},"gem":{"a":"Gem Stone","b":"1F48E","d":true,"e":true,"f":true,"h":true,"j":["blue","ruby","diamond","jewelry"],"k":[25,24],"o":2},"pensive":{"a":"Pensive Face","b":"1F614","d":true,"e":true,"f":true,"h":true,"j":["face","sad","depressed","upset"],"k":[30,55],"o":2},"flag-bw":{"a":"Botswana Flag","b":"1F1E7-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[1,9],"o":2},"mouse2":{"a":"Mouse","b":"1F401","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","rodent"],"k":[11,29],"o":2},"bacon":{"a":"Bacon","b":"1F953","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","pork","pig","meat"],"k":[41,34],"o":4},"tooth":{"a":"Tooth","b":"1F9B7","d":true,"e":true,"f":true,"h":true,"k":[43,17],"o":11},"badminton_racquet_and_shuttlecock":{"a":"Badminton Racquet and Shuttlecock","b":"1F3F8","d":true,"e":true,"f":true,"h":true,"k":[11,20],"o":2},"rat":{"a":"Rat","b":"1F400","d":true,"e":true,"f":true,"h":true,"j":["animal","mouse","rodent"],"k":[11,28],"o":2},"synagogue":{"a":"Synagogue","b":"1F54D","d":true,"e":true,"f":true,"h":true,"j":["judaism","worship","temple","jewish"],"k":[28,37],"o":2},"end":{"a":"End with Leftwards Arrow Above","b":"1F51A","d":true,"e":true,"f":true,"h":true,"j":["words","arrow"],"k":[27,54],"o":2},"bone":{"a":"Bone","b":"1F9B4","d":true,"e":true,"f":true,"h":true,"k":[43,4],"o":11},"boxing_glove":{"a":"Boxing Glove","b":"1F94A","d":true,"e":true,"f":true,"h":true,"j":["sports","fighting"],"k":[41,25],"o":4},"mute":{"a":"Speaker with Cancellation Stroke","b":"1F507","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","silence","quiet"],"k":[27,35],"o":2},"hamburger":{"a":"Hamburger","b":"1F354","d":true,"e":true,"f":true,"h":true,"j":["meat","fast food","beef","cheeseburger","mcdonalds","burger king"],"k":[6,44],"o":2},"flag-by":{"a":"Belarus Flag","b":"1F1E7-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[1,10],"o":2},"sleepy":{"a":"Sleepy Face","b":"1F62A","d":true,"e":true,"f":true,"h":true,"j":["face","tired","rest","nap"],"k":[31,20],"o":2},"on":{"a":"On with Exclamation Mark with Left Right Arrow Above","b":"1F51B","d":true,"e":true,"f":true,"h":true,"j":["arrow","words"],"k":[27,55],"o":2},"martial_arts_uniform":{"a":"Martial Arts Uniform","b":"1F94B","d":true,"e":true,"f":true,"h":true,"j":["judo","karate","taekwondo"],"k":[41,26],"o":4},"speaker":{"a":"Speaker","b":"1F508","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","silence","broadcast"],"k":[27,36],"o":2},"drooling_face":{"a":"Drooling Face","b":"1F924","d":true,"e":true,"f":true,"h":true,"j":["face"],"k":[38,21],"o":4},"eyes":{"a":"Eyes","b":"1F440","d":true,"e":true,"f":true,"h":true,"j":["look","watch","stalk","peek","see"],"k":[12,36],"o":2},"flag-bz":{"a":"Belize Flag","b":"1F1E7-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,11],"o":2},"hamster":{"a":"Hamster Face","b":"1F439","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,29],"o":2},"shinto_shrine":{"a":"Shinto Shrine","b":"26E9-FE0F","c":"26E9","d":true,"e":true,"f":true,"h":true,"j":["temple","japan","kyoto"],"k":[54,9],"o":2},"fries":{"a":"French Fries","b":"1F35F","d":true,"e":true,"f":true,"h":true,"j":["chips","snack","fast food"],"k":[6,55],"o":2},"goal_net":{"a":"Goal Net","b":"1F945","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[41,21],"o":4},"kaaba":{"a":"Kaaba","b":"1F54B","d":true,"e":true,"f":true,"h":true,"j":["mecca","mosque","islam"],"k":[28,35],"o":2},"soon":{"a":"Soon with Rightwards Arrow Above","b":"1F51C","d":true,"e":true,"f":true,"h":true,"j":["arrow","words"],"k":[27,56],"o":2},"flag-ca":{"a":"Canada Flag","b":"1F1E8-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,12],"o":2},"rabbit":{"a":"Rabbit Face","b":"1F430","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","pet","spring","magic","bunny"],"k":[12,20],"o":2},"eye":{"a":"Eye","b":"1F441-FE0F","c":"1F441","d":true,"e":true,"f":true,"h":true,"j":["face","look","see","watch","stare"],"k":[12,38],"o":2},"sleeping":{"a":"Sleeping Face","b":"1F634","d":true,"e":true,"f":true,"h":true,"j":["face","tired","sleepy","night","zzz"],"k":[31,30],"o":2},"pizza":{"a":"Slice of Pizza","b":"1F355","d":true,"e":true,"f":true,"h":true,"j":["food","party"],"k":[6,45],"o":2},"sound":{"a":"Speaker with One Sound Wave","b":"1F509","d":true,"e":true,"f":true,"h":true,"j":["volume","speaker","broadcast"],"k":[27,37],"o":2},"rabbit2":{"a":"Rabbit","b":"1F407","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","pet","magic","spring"],"k":[11,35],"o":2},"fountain":{"a":"Fountain","b":"26F2","d":true,"e":true,"f":true,"h":true,"j":["photo","summer","water","fresh"],"k":[54,13],"o":2},"golf":{"a":"Flag in Hole","b":"26F3","d":true,"e":true,"f":true,"h":true,"j":["sports","business","flag","hole","summer"],"k":[54,14],"o":2},"top":{"a":"Top with Upwards Arrow Above","b":"1F51D","d":true,"e":true,"f":true,"h":true,"j":["words","blue-square"],"k":[28,0],"o":2},"mask":{"a":"Face with Medical Mask","b":"1F637","d":true,"e":true,"f":true,"h":true,"j":["face","sick","ill","disease"],"k":[31,33],"o":2},"flag-cc":{"a":"Cocos (keeling) Islands Flag","b":"1F1E8-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[1,13],"o":2},"hotdog":{"a":"Hot Dog","b":"1F32D","d":true,"e":true,"f":true,"h":true,"j":["food","frankfurter"],"k":[6,5],"o":2},"loud_sound":{"a":"Speaker with Three Sound Waves","b":"1F50A","d":true,"e":true,"f":true,"h":true,"j":["volume","noise","noisy","speaker","broadcast"],"k":[27,38],"o":2},"tongue":{"a":"Tongue","b":"1F445","d":true,"e":true,"f":true,"h":true,"j":["mouth","playful"],"k":[12,52],"o":2},"place_of_worship":{"a":"Place of Worship","b":"1F6D0","d":true,"e":true,"f":true,"h":true,"j":["religion","church","temple","prayer"],"k":[36,38],"o":2},"ice_skate":{"a":"Ice Skate","b":"26F8-FE0F","c":"26F8","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[54,18],"o":2},"sandwich":{"a":"Sandwich","b":"1F96A","d":true,"e":true,"f":true,"h":true,"k":[42,0],"o":5},"chipmunk":{"a":"Chipmunk","b":"1F43F-FE0F","c":"1F43F","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","rodent","squirrel"],"k":[12,35],"o":2},"loudspeaker":{"a":"Public Address Loudspeaker","b":"1F4E2","d":true,"e":true,"f":true,"h":true,"j":["volume","sound"],"k":[26,56],"o":2},"lips":{"a":"Mouth","b":"1F444","d":true,"e":true,"f":true,"h":true,"j":["mouth","kiss"],"k":[12,51],"o":2},"flag-cd":{"a":"Congo - Kinshasa Flag","b":"1F1E8-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[1,14],"o":2},"tent":{"a":"Tent","b":"26FA","d":true,"e":true,"f":true,"h":true,"j":["photo","camping","outdoors"],"k":[54,37],"o":2},"face_with_thermometer":{"a":"Face with Thermometer","b":"1F912","d":true,"e":true,"f":true,"h":true,"j":["sick","temperature","thermometer","cold","fever"],"k":[37,25],"o":2},"taco":{"a":"Taco","b":"1F32E","d":true,"e":true,"f":true,"h":true,"j":["food","mexican"],"k":[6,6],"o":2},"foggy":{"a":"Foggy","b":"1F301","d":true,"e":true,"f":true,"h":true,"j":["photo","mountain"],"k":[5,20],"o":2},"flag-cf":{"a":"Central African Republic Flag","b":"1F1E8-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[1,15],"o":2},"baby":{"skin_variations":{"1F3FB":{"unified":"1F476-1F3FB","non_qualified":null,"image":"1f476-1f3fb.png","sheet_x":23,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F476-1F3FC","non_qualified":null,"image":"1f476-1f3fc.png","sheet_x":23,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F476-1F3FD","non_qualified":null,"image":"1f476-1f3fd.png","sheet_x":23,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F476-1F3FE","non_qualified":null,"image":"1f476-1f3fe.png","sheet_x":23,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F476-1F3FF","non_qualified":null,"image":"1f476-1f3ff.png","sheet_x":23,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Baby","b":"1F476","d":true,"e":true,"f":true,"h":true,"j":["child","boy","girl","toddler"],"k":[23,4],"o":2},"atom_symbol":{"a":"Atom Symbol","b":"269B-FE0F","c":"269B","d":true,"e":true,"f":true,"h":true,"j":["science","physics","chemistry"],"k":[53,48],"o":2},"fishing_pole_and_fish":{"a":"Fishing Pole and Fish","b":"1F3A3","d":true,"e":true,"f":true,"h":true,"j":["food","hobby","summer"],"k":[8,9],"o":2},"hedgehog":{"a":"Hedgehog","b":"1F994","d":true,"e":true,"f":true,"h":true,"k":[42,38],"o":5},"face_with_head_bandage":{"a":"Face with Head-Bandage","b":"1F915","d":true,"e":true,"f":true,"h":true,"j":["injured","clumsy","bandage","hurt"],"k":[37,28],"o":2},"mega":{"a":"Cheering Megaphone","b":"1F4E3","d":true,"e":true,"f":true,"h":true,"j":["sound","speaker","volume"],"k":[27,0],"o":2},"nauseated_face":{"a":"Nauseated Face","b":"1F922","d":true,"e":true,"f":true,"h":true,"j":["face","vomit","gross","green","sick","throw up","ill"],"k":[38,19],"o":4},"child":{"skin_variations":{"1F3FB":{"unified":"1F9D2-1F3FB","non_qualified":null,"image":"1f9d2-1f3fb.png","sheet_x":48,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D2-1F3FC","non_qualified":null,"image":"1f9d2-1f3fc.png","sheet_x":48,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D2-1F3FD","non_qualified":null,"image":"1f9d2-1f3fd.png","sheet_x":48,"sheet_y":19,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D2-1F3FE","non_qualified":null,"image":"1f9d2-1f3fe.png","sheet_x":48,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D2-1F3FF","non_qualified":null,"image":"1f9d2-1f3ff.png","sheet_x":48,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Child","b":"1F9D2","d":true,"e":true,"f":true,"h":true,"k":[48,16],"o":5},"flag-cg":{"a":"Congo - Brazzaville Flag","b":"1F1E8-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,16],"o":2},"bat":{"a":"Bat","b":"1F987","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","blind","vampire"],"k":[42,25],"o":4},"diving_mask":{"a":"Diving Mask","b":"1F93F","d":true,"e":true,"f":true,"h":true,"k":[41,15],"o":12},"burrito":{"a":"Burrito","b":"1F32F","d":true,"e":true,"f":true,"h":true,"j":["food","mexican"],"k":[6,7],"o":2},"postal_horn":{"a":"Postal Horn","b":"1F4EF","d":true,"e":true,"f":true,"h":true,"j":["instrument","music"],"k":[27,12],"o":2},"night_with_stars":{"a":"Night with Stars","b":"1F303","d":true,"e":true,"f":true,"h":true,"j":["evening","city","downtown"],"k":[5,22],"o":2},"om_symbol":{"a":"Om Symbol","b":"1F549-FE0F","c":"1F549","d":true,"e":true,"f":true,"h":true,"k":[28,33],"o":2},"star_of_david":{"a":"Star of David","b":"2721-FE0F","c":"2721","d":true,"e":true,"f":true,"h":true,"j":["judaism"],"k":[55,15],"o":2},"boy":{"skin_variations":{"1F3FB":{"unified":"1F466-1F3FB","non_qualified":null,"image":"1f466-1f3fb.png","sheet_x":14,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F466-1F3FC","non_qualified":null,"image":"1f466-1f3fc.png","sheet_x":14,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F466-1F3FD","non_qualified":null,"image":"1f466-1f3fd.png","sheet_x":14,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F466-1F3FE","non_qualified":null,"image":"1f466-1f3fe.png","sheet_x":14,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F466-1F3FF","non_qualified":null,"image":"1f466-1f3ff.png","sheet_x":14,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Boy","b":"1F466","d":true,"e":true,"f":true,"h":true,"j":["man","male","guy","teenager"],"k":[14,26],"o":2},"bell":{"a":"Bell","b":"1F514","d":true,"e":true,"f":true,"h":true,"j":["sound","notification","christmas","xmas","chime"],"k":[27,48],"o":2},"flag-ch":{"a":"Switzerland Flag","b":"1F1E8-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[1,17],"o":2},"running_shirt_with_sash":{"a":"Running Shirt with Sash","b":"1F3BD","d":true,"e":true,"f":true,"h":true,"j":["play","pageant"],"k":[8,35],"o":2},"stuffed_flatbread":{"a":"Stuffed Flatbread","b":"1F959","d":true,"e":true,"f":true,"h":true,"j":["food","flatbread","stuffed","gyro"],"k":[41,40],"o":4},"bear":{"a":"Bear Face","b":"1F43B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wild"],"k":[12,31],"o":2},"cityscape":{"a":"Cityscape","b":"1F3D9-FE0F","c":"1F3D9","d":true,"e":true,"f":true,"h":true,"j":["photo","night life","urban"],"k":[10,44],"o":2},"face_vomiting":{"a":"Face with Open Mouth Vomiting","b":"1F92E","d":true,"e":true,"f":true,"h":true,"k":[38,48],"n":["face_with_open_mouth_vomiting"],"o":5},"wheel_of_dharma":{"a":"Wheel of Dharma","b":"2638-FE0F","c":"2638","d":true,"e":true,"f":true,"h":true,"j":["hinduism","buddhism","sikhism","jainism"],"k":[53,15],"o":2},"ski":{"a":"Ski and Ski Boot","b":"1F3BF","d":true,"e":true,"f":true,"h":true,"j":["sports","winter","cold","snow"],"k":[8,37],"o":2},"girl":{"skin_variations":{"1F3FB":{"unified":"1F467-1F3FB","non_qualified":null,"image":"1f467-1f3fb.png","sheet_x":14,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F467-1F3FC","non_qualified":null,"image":"1f467-1f3fc.png","sheet_x":14,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F467-1F3FD","non_qualified":null,"image":"1f467-1f3fd.png","sheet_x":14,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F467-1F3FE","non_qualified":null,"image":"1f467-1f3fe.png","sheet_x":14,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F467-1F3FF","non_qualified":null,"image":"1f467-1f3ff.png","sheet_x":14,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Girl","b":"1F467","d":true,"e":true,"f":true,"h":true,"j":["female","woman","teenager"],"k":[14,32],"o":2},"falafel":{"a":"Falafel","b":"1F9C6","d":true,"e":true,"f":true,"h":true,"k":[44,14],"o":12},"sneezing_face":{"a":"Sneezing Face","b":"1F927","d":true,"e":true,"f":true,"h":true,"j":["face","gesundheit","sneeze","sick","allergy"],"k":[38,41],"o":4},"no_bell":{"a":"Bell with Cancellation Stroke","b":"1F515","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","mute","quiet","silent"],"k":[27,49],"o":2},"koala":{"a":"Koala","b":"1F428","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,12],"o":2},"sunrise_over_mountains":{"a":"Sunrise over Mountains","b":"1F304","d":true,"e":true,"f":true,"h":true,"j":["view","vacation","photo"],"k":[5,23],"o":2},"flag-ci":{"a":"Côte D’ivoire Flag","b":"1F1E8-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[1,18],"o":2},"sunrise":{"a":"Sunrise","b":"1F305","d":true,"e":true,"f":true,"h":true,"j":["morning","view","vacation","photo"],"k":[5,24],"o":2},"yin_yang":{"a":"Yin Yang","b":"262F-FE0F","c":"262F","d":true,"e":true,"f":true,"h":true,"j":["balance"],"k":[53,14],"o":2},"adult":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb.png","sheet_x":48,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc.png","sheet_x":48,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd.png","sheet_x":48,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe.png","sheet_x":48,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff.png","sheet_x":48,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Adult","b":"1F9D1","d":true,"e":true,"f":true,"h":true,"k":[48,10],"o":5},"hot_face":{"a":"Overheated Face","b":"1F975","d":true,"e":true,"f":true,"h":true,"k":[42,10],"o":11},"musical_score":{"a":"Musical Score","b":"1F3BC","d":true,"e":true,"f":true,"h":true,"j":["treble","clef","compose"],"k":[8,34],"o":2},"sled":{"a":"Sled","b":"1F6F7","d":true,"e":true,"f":true,"h":true,"k":[36,56],"o":5},"egg":{"a":"Egg","b":"1F95A","d":true,"e":true,"f":true,"h":true,"j":["food","chicken","breakfast"],"k":[41,41],"o":4},"panda_face":{"a":"Panda Face","b":"1F43C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","panda"],"k":[12,32],"o":2},"flag-ck":{"a":"Cook Islands Flag","b":"1F1E8-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,19],"o":2},"flag-cl":{"a":"Chile Flag","b":"1F1E8-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[1,20],"o":2},"person_with_blond_hair":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB","non_qualified":null,"image":"1f471-1f3fb.png","sheet_x":22,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F471-1F3FC","non_qualified":null,"image":"1f471-1f3fc.png","sheet_x":22,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F471-1F3FD","non_qualified":null,"image":"1f471-1f3fd.png","sheet_x":22,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F471-1F3FE","non_qualified":null,"image":"1f471-1f3fe.png","sheet_x":22,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F471-1F3FF","non_qualified":null,"image":"1f471-1f3ff.png","sheet_x":22,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F471-200D-2642-FE0F","a":"Person with Blond Hair","b":"1F471","d":true,"e":true,"f":true,"h":false,"k":[22,19],"o":2},"sloth":{"a":"Sloth","b":"1F9A5","d":true,"e":true,"f":true,"h":true,"k":[42,53],"o":12},"latin_cross":{"a":"Latin Cross","b":"271D-FE0F","c":"271D","d":true,"e":true,"f":true,"h":true,"j":["christianity"],"k":[55,14],"o":2},"curling_stone":{"a":"Curling Stone","b":"1F94C","d":true,"e":true,"f":true,"h":true,"k":[41,27],"o":5},"cold_face":{"a":"Freezing Face","b":"1F976","d":true,"e":true,"f":true,"h":true,"k":[42,11],"o":11},"fried_egg":{"a":"Cooking","b":"1F373","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","kitchen","egg"],"k":[7,18],"n":["cooking"],"o":2},"city_sunset":{"a":"Cityscape at Dusk","b":"1F306","d":true,"e":true,"f":true,"h":true,"j":["photo","evening","sky","buildings"],"k":[5,25],"o":2},"musical_note":{"a":"Musical Note","b":"1F3B5","d":true,"e":true,"f":true,"h":true,"j":["score","tone","sound"],"k":[8,27],"o":2},"flag-cm":{"a":"Cameroon Flag","b":"1F1E8-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,21],"o":2},"notes":{"a":"Multiple Musical Notes","b":"1F3B6","d":true,"e":true,"f":true,"h":true,"j":["music","score"],"k":[8,28],"o":2},"woozy_face":{"a":"Face with Uneven Eyes and Wavy Mouth","b":"1F974","d":true,"e":true,"f":true,"h":true,"k":[42,9],"o":11},"dart":{"a":"Direct Hit","b":"1F3AF","d":true,"e":true,"f":true,"h":true,"j":["game","play","bar"],"k":[8,21],"o":2},"orthodox_cross":{"a":"Orthodox Cross","b":"2626-FE0F","c":"2626","d":true,"e":true,"f":true,"h":true,"j":["suppedaneum","religion"],"k":[53,11],"o":2},"shallow_pan_of_food":{"a":"Shallow Pan of Food","b":"1F958","d":true,"e":true,"f":true,"h":true,"j":["food","cooking","casserole","paella"],"k":[41,39],"o":4},"otter":{"a":"Otter","b":"1F9A6","d":true,"e":true,"f":true,"h":true,"k":[42,54],"o":12},"man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fb.png","sheet_x":17,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fc.png","sheet_x":17,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fd.png","sheet_x":17,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fe.png","sheet_x":17,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF","non_qualified":null,"image":"1f468-1f3ff.png","sheet_x":17,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man","b":"1F468","d":true,"e":true,"f":true,"h":true,"j":["mustache","father","dad","guy","classy","sir","moustache"],"k":[17,22],"o":2},"city_sunrise":{"a":"Sunset over Buildings","b":"1F307","d":true,"e":true,"f":true,"h":true,"j":["photo","good morning","dawn"],"k":[5,26],"o":2},"bearded_person":{"skin_variations":{"1F3FB":{"unified":"1F9D4-1F3FB","non_qualified":null,"image":"1f9d4-1f3fb.png","sheet_x":48,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D4-1F3FC","non_qualified":null,"image":"1f9d4-1f3fc.png","sheet_x":48,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D4-1F3FD","non_qualified":null,"image":"1f9d4-1f3fd.png","sheet_x":48,"sheet_y":31,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D4-1F3FE","non_qualified":null,"image":"1f9d4-1f3fe.png","sheet_x":48,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D4-1F3FF","non_qualified":null,"image":"1f9d4-1f3ff.png","sheet_x":48,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bearded Person","b":"1F9D4","d":true,"e":true,"f":true,"h":true,"k":[48,28],"o":5},"skunk":{"a":"Skunk","b":"1F9A8","d":true,"e":true,"f":true,"h":true,"k":[42,56],"o":12},"stew":{"a":"Pot of Food","b":"1F372","d":true,"e":true,"f":true,"h":true,"j":["food","meat","soup"],"k":[7,17],"o":2},"cn":{"a":"China Flag","b":"1F1E8-1F1F3","d":true,"e":true,"f":true,"h":true,"j":["china","chinese","prc","flag","country","nation","banner"],"k":[1,22],"n":["flag-cn"],"o":2},"studio_microphone":{"a":"Studio Microphone","b":"1F399-FE0F","c":"1F399","d":true,"e":true,"f":true,"h":true,"j":["sing","recording","artist","talkshow"],"k":[8,1],"o":2},"star_and_crescent":{"a":"Star and Crescent","b":"262A-FE0F","c":"262A","d":true,"e":true,"f":true,"h":true,"j":["islam"],"k":[53,12],"o":2},"yo-yo":{"a":"Yo-Yo","b":"1FA80","d":true,"e":true,"f":true,"h":true,"k":[52,1],"o":12},"bridge_at_night":{"a":"Bridge at Night","b":"1F309","d":true,"e":true,"f":true,"h":true,"j":["photo","sanfrancisco"],"k":[5,28],"o":2},"dizzy_face":{"a":"Dizzy Face","b":"1F635","d":true,"e":true,"f":true,"h":true,"j":["spent","unconscious","xox","dizzy"],"k":[31,31],"o":2},"red_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b0.png","sheet_x":16,"sheet_y":24,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b0.png","sheet_x":16,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b0.png","sheet_x":16,"sheet_y":26,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b0.png","sheet_x":16,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b0.png","sheet_x":16,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Red Haired Man","b":"1F468-200D-1F9B0","d":true,"e":true,"f":true,"h":true,"k":[16,23],"o":11},"kite":{"a":"Kite","b":"1FA81","d":true,"e":true,"f":true,"h":true,"k":[52,2],"o":12},"bowl_with_spoon":{"a":"Bowl with Spoon","b":"1F963","d":true,"e":true,"f":true,"h":true,"k":[41,50],"o":5},"flag-co":{"a":"Colombia Flag","b":"1F1E8-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,23],"o":2},"peace_symbol":{"a":"Peace Symbol","b":"262E-FE0F","c":"262E","d":true,"e":true,"f":true,"h":true,"j":["hippie"],"k":[53,13],"o":2},"kangaroo":{"a":"Kangaroo","b":"1F998","d":true,"e":true,"f":true,"h":true,"k":[42,42],"o":11},"hotsprings":{"a":"Hot Springs","b":"2668-FE0F","c":"2668","d":true,"e":true,"f":true,"h":true,"j":["bath","warm","relax"],"k":[53,37],"o":2},"exploding_head":{"a":"Shocked Face with Exploding Head","b":"1F92F","d":true,"e":true,"f":true,"h":true,"k":[38,49],"n":["shocked_face_with_exploding_head"],"o":5},"level_slider":{"a":"Level Slider","b":"1F39A-FE0F","c":"1F39A","d":true,"e":true,"f":true,"h":true,"j":["scale"],"k":[8,2],"o":2},"badger":{"a":"Badger","b":"1F9A1","d":true,"e":true,"f":true,"h":true,"k":[42,51],"o":11},"8ball":{"a":"Billiards","b":"1F3B1","d":true,"e":true,"f":true,"h":true,"j":["pool","hobby","game","luck","magic"],"k":[8,23],"o":2},"curly_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b1.png","sheet_x":16,"sheet_y":30,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b1.png","sheet_x":16,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b1.png","sheet_x":16,"sheet_y":32,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b1.png","sheet_x":16,"sheet_y":33,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b1.png","sheet_x":16,"sheet_y":34,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Curly Haired Man","b":"1F468-200D-1F9B1","d":true,"e":true,"f":true,"h":true,"k":[16,29],"o":11},"flag-cp":{"a":"Clipperton Island Flag","b":"1F1E8-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[1,24],"o":2},"carousel_horse":{"a":"Carousel Horse","b":"1F3A0","d":true,"e":true,"f":true,"h":true,"j":["photo","carnival"],"k":[8,6],"o":2},"face_with_cowboy_hat":{"a":"Face with Cowboy Hat","b":"1F920","d":true,"e":true,"f":true,"h":true,"k":[38,17],"o":4},"menorah_with_nine_branches":{"a":"Menorah with Nine Branches","b":"1F54E","d":true,"e":true,"f":true,"h":true,"k":[28,38],"o":2},"green_salad":{"a":"Green Salad","b":"1F957","d":true,"e":true,"f":true,"h":true,"j":["food","healthy","lettuce"],"k":[41,38],"o":4},"control_knobs":{"a":"Control Knobs","b":"1F39B-FE0F","c":"1F39B","d":true,"e":true,"f":true,"h":true,"j":["dial"],"k":[8,3],"o":2},"popcorn":{"a":"Popcorn","b":"1F37F","d":true,"e":true,"f":true,"h":true,"j":["food","movie theater","films","snack"],"k":[7,30],"o":2},"six_pointed_star":{"a":"Six Pointed Star with Middle Dot","b":"1F52F","d":true,"e":true,"f":true,"h":true,"j":["purple-square","religion","jewish","hexagram"],"k":[28,18],"o":2},"feet":{"a":"Paw Prints","b":"1F43E","d":true,"e":true,"f":true,"h":true,"k":[12,34],"n":["paw_prints"],"o":2},"ferris_wheel":{"a":"Ferris Wheel","b":"1F3A1","d":true,"e":true,"f":true,"h":true,"j":["photo","carnival","londoneye"],"k":[8,7],"o":2},"microphone":{"a":"Microphone","b":"1F3A4","d":true,"e":true,"f":true,"h":true,"j":["sound","music","PA","sing","talkshow"],"k":[8,10],"o":2},"crystal_ball":{"a":"Crystal Ball","b":"1F52E","d":true,"e":true,"f":true,"h":true,"j":["disco","party","magic","circus","fortune_teller"],"k":[28,17],"o":2},"partying_face":{"a":"Face with Party Horn and Party Hat","b":"1F973","d":true,"e":true,"f":true,"h":true,"k":[42,8],"o":11},"flag-cr":{"a":"Costa Rica Flag","b":"1F1E8-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,25],"o":2},"white_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b3.png","sheet_x":16,"sheet_y":42,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b3.png","sheet_x":16,"sheet_y":43,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b3.png","sheet_x":16,"sheet_y":44,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b3.png","sheet_x":16,"sheet_y":45,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b3.png","sheet_x":16,"sheet_y":46,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Haired Man","b":"1F468-200D-1F9B3","d":true,"e":true,"f":true,"h":true,"k":[16,41],"o":11},"headphones":{"a":"Headphone","b":"1F3A7","d":true,"e":true,"f":true,"h":true,"j":["music","score","gadgets"],"k":[8,13],"o":2},"bald_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b2.png","sheet_x":16,"sheet_y":36,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b2.png","sheet_x":16,"sheet_y":37,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b2.png","sheet_x":16,"sheet_y":38,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b2.png","sheet_x":16,"sheet_y":39,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b2.png","sheet_x":16,"sheet_y":40,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bald Man","b":"1F468-200D-1F9B2","d":true,"e":true,"f":true,"h":true,"k":[16,35],"o":11},"sunglasses":{"a":"Smiling Face with Sunglasses","b":"1F60E","d":true,"e":true,"f":true,"h":true,"j":["face","cool","smile","summer","beach","sunglass"],"k":[30,49],"l":["8)"],"o":2},"butter":{"a":"Butter","b":"1F9C8","d":true,"e":true,"f":true,"h":true,"k":[44,16],"o":12},"roller_coaster":{"a":"Roller Coaster","b":"1F3A2","d":true,"e":true,"f":true,"h":true,"j":["carnival","playground","photo","fun"],"k":[8,8],"o":2},"turkey":{"a":"Turkey","b":"1F983","d":true,"e":true,"f":true,"h":true,"j":["animal","bird"],"k":[42,21],"o":2},"nazar_amulet":{"a":"Nazar Amulet","b":"1F9FF","d":true,"e":true,"f":true,"h":true,"k":[51,50],"o":11},"flag-cu":{"a":"Cuba Flag","b":"1F1E8-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[1,26],"o":2},"aries":{"a":"Aries","b":"2648","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,20],"o":2},"flag-cv":{"a":"Cape Verde Flag","b":"1F1E8-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[1,27],"o":2},"barber":{"a":"Barber Pole","b":"1F488","d":true,"e":true,"f":true,"h":true,"j":["hair","salon","style"],"k":[25,18],"o":2},"taurus":{"a":"Taurus","b":"2649","d":true,"e":true,"f":true,"h":true,"j":["purple-square","sign","zodiac","astrology"],"k":[53,21],"o":2},"salt":{"a":"Salt Shaker","b":"1F9C2","d":true,"e":true,"f":true,"h":true,"k":[44,10],"o":11},"woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fb.png","sheet_x":20,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fc.png","sheet_x":20,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fd.png","sheet_x":20,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fe.png","sheet_x":20,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF","non_qualified":null,"image":"1f469-1f3ff.png","sheet_x":20,"sheet_y":14,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman","b":"1F469","d":true,"e":true,"f":true,"h":true,"j":["female","girls","lady"],"k":[20,9],"o":2},"video_game":{"a":"Video Game","b":"1F3AE","d":true,"e":true,"f":true,"h":true,"j":["play","console","PS4","controller"],"k":[8,20],"o":2},"chicken":{"a":"Chicken","b":"1F414","d":true,"e":true,"f":true,"h":true,"j":["animal","cluck","nature","bird"],"k":[11,48],"o":2},"radio":{"a":"Radio","b":"1F4FB","d":true,"e":true,"f":true,"h":true,"j":["communication","music","podcast","program"],"k":[27,24],"o":2},"nerd_face":{"a":"Nerd Face","b":"1F913","d":true,"e":true,"f":true,"h":true,"j":["face","nerdy","geek","dork"],"k":[37,26],"o":2},"red_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b0.png","sheet_x":19,"sheet_y":9,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b0.png","sheet_x":19,"sheet_y":10,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b0.png","sheet_x":19,"sheet_y":11,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b0.png","sheet_x":19,"sheet_y":12,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b0.png","sheet_x":19,"sheet_y":13,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Red Haired Woman","b":"1F469-200D-1F9B0","d":true,"e":true,"f":true,"h":true,"k":[19,8],"o":11},"circus_tent":{"a":"Circus Tent","b":"1F3AA","d":true,"e":true,"f":true,"h":true,"j":["festival","carnival","party"],"k":[8,16],"o":2},"face_with_monocle":{"a":"Face with Monocle","b":"1F9D0","d":true,"e":true,"f":true,"h":true,"k":[45,16],"o":5},"canned_food":{"a":"Canned Food","b":"1F96B","d":true,"e":true,"f":true,"h":true,"k":[42,1],"o":5},"flag-cw":{"a":"Curaçao Flag","b":"1F1E8-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[1,28],"o":2},"gemini":{"a":"Gemini","b":"264A","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,22],"o":2},"saxophone":{"a":"Saxophone","b":"1F3B7","d":true,"e":true,"f":true,"h":true,"j":["music","instrument","jazz","blues"],"k":[8,29],"o":2},"rooster":{"a":"Rooster","b":"1F413","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","chicken"],"k":[11,47],"o":2},"joystick":{"a":"Joystick","b":"1F579-FE0F","c":"1F579","d":true,"e":true,"f":true,"h":true,"j":["game","play"],"k":[29,36],"o":2},"guitar":{"a":"Guitar","b":"1F3B8","d":true,"e":true,"f":true,"h":true,"j":["music","instrument"],"k":[8,30],"o":2},"slot_machine":{"a":"Slot Machine","b":"1F3B0","d":true,"e":true,"f":true,"h":true,"j":["bet","gamble","vegas","fruit machine","luck","casino"],"k":[8,22],"o":2},"bento":{"a":"Bento Box","b":"1F371","d":true,"e":true,"f":true,"h":true,"j":["food","japanese","box"],"k":[7,16],"o":2},"steam_locomotive":{"a":"Steam Locomotive","b":"1F682","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","train"],"k":[34,1],"o":2},"confused":{"a":"Confused Face","b":"1F615","d":true,"e":true,"f":true,"h":true,"j":["face","indifference","huh","weird","hmmm",":/"],"k":[30,56],"l":[":\\",":-\\",":/",":-/"],"o":2},"flag-cx":{"a":"Christmas Island Flag","b":"1F1E8-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[1,29],"o":2},"hatching_chick":{"a":"Hatching Chick","b":"1F423","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","egg","born","baby","bird"],"k":[12,7],"o":2},"cancer":{"a":"Cancer","b":"264B","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,23],"o":2},"red_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b0.png","sheet_x":47,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b0.png","sheet_x":47,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b0.png","sheet_x":47,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b0.png","sheet_x":47,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b0.png","sheet_x":47,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Red Haired Person","b":"1F9D1-200D-1F9B0","d":true,"e":false,"f":false,"h":false,"k":[47,13],"o":12},"flag-cy":{"a":"Cyprus Flag","b":"1F1E8-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[1,30],"o":2},"worried":{"a":"Worried Face","b":"1F61F","d":true,"e":true,"f":true,"h":true,"j":["face","concern","nervous",":("],"k":[31,9],"o":2},"railway_car":{"a":"Railway Car","b":"1F683","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,2],"o":2},"leo":{"a":"Leo","b":"264C","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,24],"o":2},"curly_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b1.png","sheet_x":19,"sheet_y":15,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b1.png","sheet_x":19,"sheet_y":16,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b1.png","sheet_x":19,"sheet_y":17,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b1.png","sheet_x":19,"sheet_y":18,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b1.png","sheet_x":19,"sheet_y":19,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Curly Haired Woman","b":"1F469-200D-1F9B1","d":true,"e":true,"f":true,"h":true,"k":[19,14],"o":11},"baby_chick":{"a":"Baby Chick","b":"1F424","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","bird"],"k":[12,8],"o":2},"musical_keyboard":{"a":"Musical Keyboard","b":"1F3B9","d":true,"e":true,"f":true,"h":true,"j":["piano","instrument","compose"],"k":[8,31],"o":2},"game_die":{"a":"Game Die","b":"1F3B2","d":true,"e":true,"f":true,"h":true,"j":["dice","random","tabletop","play","luck"],"k":[8,24],"o":2},"rice_cracker":{"a":"Rice Cracker","b":"1F358","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[6,48],"o":2},"virgo":{"a":"Virgo","b":"264D","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,25],"o":2},"flag-cz":{"a":"Czechia Flag","b":"1F1E8-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,31],"o":2},"curly_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b1.png","sheet_x":47,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b1.png","sheet_x":47,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b1.png","sheet_x":47,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b1.png","sheet_x":47,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b1.png","sheet_x":47,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Curly Haired Person","b":"1F9D1-200D-1F9B1","d":true,"e":false,"f":false,"h":false,"k":[47,19],"o":12},"rice_ball":{"a":"Rice Ball","b":"1F359","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[6,49],"o":2},"hatched_chick":{"a":"Front-Facing Baby Chick","b":"1F425","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","baby","bird"],"k":[12,9],"o":2},"jigsaw":{"a":"Jigsaw Puzzle Piece","b":"1F9E9","d":true,"e":true,"f":true,"h":true,"k":[51,28],"o":11},"trumpet":{"a":"Trumpet","b":"1F3BA","d":true,"e":true,"f":true,"h":true,"j":["music","brass"],"k":[8,32],"o":2},"slightly_frowning_face":{"a":"Slightly Frowning Face","b":"1F641","d":true,"e":true,"f":true,"h":true,"j":["face","frowning","disappointed","sad","upset"],"k":[31,43],"o":2},"bullettrain_side":{"a":"High-Speed Train","b":"1F684","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,3],"o":2},"libra":{"a":"Libra","b":"264E","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,26],"o":2},"de":{"a":"Germany Flag","b":"1F1E9-1F1EA","d":true,"e":true,"f":true,"h":true,"j":["german","nation","flag","country","banner"],"k":[1,32],"n":["flag-de"],"o":2},"rice":{"a":"Cooked Rice","b":"1F35A","d":true,"e":true,"f":true,"h":true,"j":["food","china","asian"],"k":[6,50],"o":2},"violin":{"a":"Violin","b":"1F3BB","d":true,"e":true,"f":true,"h":true,"j":["music","instrument","orchestra","symphony"],"k":[8,33],"o":2},"white_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b3.png","sheet_x":19,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b3.png","sheet_x":19,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b3.png","sheet_x":19,"sheet_y":29,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b3.png","sheet_x":19,"sheet_y":30,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b3.png","sheet_x":19,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Haired Woman","b":"1F469-200D-1F9B3","d":true,"e":true,"f":true,"h":true,"k":[19,26],"o":11},"bird":{"a":"Bird","b":"1F426","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fly","tweet","spring"],"k":[12,10],"o":2},"white_frowning_face":{"a":"White Frowning Face","b":"2639-FE0F","c":"2639","d":true,"e":true,"f":true,"h":true,"k":[53,16],"o":2},"bullettrain_front":{"a":"High-Speed Train with Bullet Nose","b":"1F685","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","speed","fast","public","travel"],"k":[34,4],"o":2},"teddy_bear":{"a":"Teddy Bear","b":"1F9F8","d":true,"e":true,"f":true,"h":true,"k":[51,43],"o":11},"white_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b3.png","sheet_x":47,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b3.png","sheet_x":47,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b3.png","sheet_x":47,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b3.png","sheet_x":47,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b3.png","sheet_x":47,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"White Haired Person","b":"1F9D1-200D-1F9B3","d":true,"e":false,"f":false,"h":false,"k":[47,31],"o":12},"spades":{"a":"Black Spade Suit","b":"2660-FE0F","c":"2660","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","suits","magic"],"k":[53,33],"o":2},"banjo":{"a":"Banjo","b":"1FA95","d":true,"e":true,"f":true,"h":true,"k":[52,9],"o":12},"train2":{"a":"Train","b":"1F686","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,5],"o":2},"scorpius":{"a":"Scorpius","b":"264F","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology","scorpio"],"k":[53,27],"o":2},"curry":{"a":"Curry and Rice","b":"1F35B","d":true,"e":true,"f":true,"h":true,"j":["food","spicy","hot","indian"],"k":[6,51],"o":2},"open_mouth":{"a":"Face with Open Mouth","b":"1F62E","d":true,"e":true,"f":true,"h":true,"j":["face","surprise","impressed","wow","whoa",":O"],"k":[31,24],"l":[":o",":-o",":O",":-O"],"o":2},"flag-dg":{"a":"Diego Garcia Flag","b":"1F1E9-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,33],"o":2},"penguin":{"a":"Penguin","b":"1F427","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,11],"o":2},"hearts":{"a":"Black Heart Suit","b":"2665-FE0F","c":"2665","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,35],"o":2},"ramen":{"a":"Steaming Bowl","b":"1F35C","d":true,"e":true,"f":true,"h":true,"j":["food","japanese","noodle","chopsticks"],"k":[6,52],"o":2},"sagittarius":{"a":"Sagittarius","b":"2650","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,28],"o":2},"bald_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b2.png","sheet_x":19,"sheet_y":21,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b2.png","sheet_x":19,"sheet_y":22,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b2.png","sheet_x":19,"sheet_y":23,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b2.png","sheet_x":19,"sheet_y":24,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b2.png","sheet_x":19,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bald Woman","b":"1F469-200D-1F9B2","d":true,"e":true,"f":true,"h":true,"k":[19,20],"o":11},"dove_of_peace":{"a":"Dove of Peace","b":"1F54A-FE0F","c":"1F54A","d":true,"e":true,"f":true,"h":true,"k":[28,34],"o":2},"hushed":{"a":"Hushed Face","b":"1F62F","d":true,"e":true,"f":true,"h":true,"j":["face","woo","shh"],"k":[31,25],"o":2},"metro":{"a":"Metro","b":"1F687","d":true,"e":true,"f":true,"h":true,"j":["transportation","blue-square","mrt","underground","tube"],"k":[34,6],"o":2},"flag-dj":{"a":"Djibouti Flag","b":"1F1E9-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[1,34],"o":2},"drum_with_drumsticks":{"a":"Drum with Drumsticks","b":"1F941","d":true,"e":true,"f":true,"h":true,"k":[41,17],"o":4},"spaghetti":{"a":"Spaghetti","b":"1F35D","d":true,"e":true,"f":true,"h":true,"j":["food","italian","noodle"],"k":[6,53],"o":2},"eagle":{"a":"Eagle","b":"1F985","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird"],"k":[42,23],"o":4},"astonished":{"a":"Astonished Face","b":"1F632","d":true,"e":true,"f":true,"h":true,"j":["face","xox","surprised","poisoned"],"k":[31,28],"o":2},"capricorn":{"a":"Capricorn","b":"2651","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,29],"o":2},"light_rail":{"a":"Light Rail","b":"1F688","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,7],"o":2},"flag-dk":{"a":"Denmark Flag","b":"1F1E9-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,35],"o":2},"iphone":{"a":"Mobile Phone","b":"1F4F1","d":true,"e":true,"f":true,"h":true,"j":["technology","apple","gadgets","dial"],"k":[27,14],"o":2},"bald_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b2.png","sheet_x":47,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b2.png","sheet_x":47,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b2.png","sheet_x":47,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b2.png","sheet_x":47,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b2.png","sheet_x":47,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Bald Person","b":"1F9D1-200D-1F9B2","d":true,"e":false,"f":false,"h":false,"k":[47,25],"o":12},"diamonds":{"a":"Black Diamond Suit","b":"2666-FE0F","c":"2666","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,36],"o":2},"clubs":{"a":"Black Club Suit","b":"2663-FE0F","c":"2663","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,34],"o":2},"aquarius":{"a":"Aquarius","b":"2652","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,30],"o":2},"sweet_potato":{"a":"Roasted Sweet Potato","b":"1F360","d":true,"e":true,"f":true,"h":true,"j":["food","nature"],"k":[6,56],"o":2},"flag-dm":{"a":"Dominica Flag","b":"1F1E9-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,36],"o":2},"duck":{"a":"Duck","b":"1F986","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird","mallard"],"k":[42,24],"o":4},"calling":{"a":"Mobile Phone with Rightwards Arrow at Left","b":"1F4F2","d":true,"e":true,"f":true,"h":true,"j":["iphone","incoming"],"k":[27,15],"o":2},"station":{"a":"Station","b":"1F689","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","public"],"k":[34,8],"o":2},"blond-haired-woman":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2640-FE0F","non_qualified":"1F471-1F3FB-200D-2640","image":"1f471-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F471-1F3FC-200D-2640-FE0F","non_qualified":"1F471-1F3FC-200D-2640","image":"1f471-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F471-1F3FD-200D-2640-FE0F","non_qualified":"1F471-1F3FD-200D-2640","image":"1f471-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F471-1F3FE-200D-2640-FE0F","non_qualified":"1F471-1F3FE-200D-2640","image":"1f471-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F471-1F3FF-200D-2640-FE0F","non_qualified":"1F471-1F3FF-200D-2640","image":"1f471-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Blond Haired Woman","b":"1F471-200D-2640-FE0F","c":"1F471-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[22,7],"o":4},"flushed":{"a":"Flushed Face","b":"1F633","d":true,"e":true,"f":true,"h":true,"j":["face","blush","shy","flattered"],"k":[31,29],"o":2},"pisces":{"a":"Pisces","b":"2653","d":true,"e":true,"f":true,"h":true,"j":["purple-square","sign","zodiac","astrology"],"k":[53,31],"o":2},"chess_pawn":{"a":"Chess Pawn","b":"265F-FE0F","c":"265F","d":true,"e":true,"f":true,"h":true,"k":[53,32],"o":11},"blond-haired-man":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2642-FE0F","non_qualified":"1F471-1F3FB-200D-2642","image":"1f471-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F471-1F3FC-200D-2642-FE0F","non_qualified":"1F471-1F3FC-200D-2642","image":"1f471-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F471-1F3FD-200D-2642-FE0F","non_qualified":"1F471-1F3FD-200D-2642","image":"1f471-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F471-1F3FE-200D-2642-FE0F","non_qualified":"1F471-1F3FE-200D-2642","image":"1f471-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F471-1F3FF-200D-2642-FE0F","non_qualified":"1F471-1F3FF-200D-2642","image":"1f471-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F471","a":"Blond Haired Man","b":"1F471-200D-2642-FE0F","c":"1F471-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[22,13],"o":4},"phone":{"a":"Black Telephone","b":"260E-FE0F","c":"260E","d":true,"e":true,"f":true,"h":true,"j":["technology","communication","dial","telephone"],"k":[52,54],"n":["telephone"],"o":2},"oden":{"a":"Oden","b":"1F362","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[7,1],"o":2},"flag-do":{"a":"Dominican Republic Flag","b":"1F1E9-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,37],"o":2},"tram":{"a":"Tram","b":"1F68A","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,9],"o":2},"swan":{"a":"Swan","b":"1F9A2","d":true,"e":true,"f":true,"h":true,"k":[42,52],"o":11},"pleading_face":{"a":"Face with Pleading Eyes","b":"1F97A","d":true,"e":true,"f":true,"h":true,"k":[42,12],"o":11},"flag-dz":{"a":"Algeria Flag","b":"1F1E9-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,38],"o":2},"monorail":{"a":"Monorail","b":"1F69D","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,28],"o":2},"owl":{"a":"Owl","b":"1F989","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird","hoot"],"k":[42,27],"o":4},"sushi":{"a":"Sushi","b":"1F363","d":true,"e":true,"f":true,"h":true,"j":["food","fish","japanese","rice"],"k":[7,2],"o":2},"telephone_receiver":{"a":"Telephone Receiver","b":"1F4DE","d":true,"e":true,"f":true,"h":true,"j":["technology","communication","dial"],"k":[26,52],"o":2},"black_joker":{"a":"Playing Card Black Joker","b":"1F0CF","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","game","play","magic"],"k":[0,15],"o":2},"ophiuchus":{"a":"Ophiuchus","b":"26CE","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","constellation","astrology"],"k":[54,4],"o":2},"frowning":{"a":"Frowning Face with Open Mouth","b":"1F626","d":true,"e":true,"f":true,"h":true,"j":["face","aw","what"],"k":[31,16],"o":2},"older_adult":{"skin_variations":{"1F3FB":{"unified":"1F9D3-1F3FB","non_qualified":null,"image":"1f9d3-1f3fb.png","sheet_x":48,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D3-1F3FC","non_qualified":null,"image":"1f9d3-1f3fc.png","sheet_x":48,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D3-1F3FD","non_qualified":null,"image":"1f9d3-1f3fd.png","sheet_x":48,"sheet_y":25,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D3-1F3FE","non_qualified":null,"image":"1f9d3-1f3fe.png","sheet_x":48,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D3-1F3FF","non_qualified":null,"image":"1f9d3-1f3ff.png","sheet_x":48,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Adult","b":"1F9D3","d":true,"e":true,"f":true,"h":true,"k":[48,22],"o":5},"flag-ea":{"a":"Ceuta & Melilla Flag","b":"1F1EA-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,39],"o":2},"flamingo":{"a":"Flamingo","b":"1F9A9","d":true,"e":true,"f":true,"h":true,"k":[43,0],"o":12},"pager":{"a":"Pager","b":"1F4DF","d":true,"e":true,"f":true,"h":true,"j":["bbcall","oldschool","90s"],"k":[26,53],"o":2},"mountain_railway":{"a":"Mountain Railway","b":"1F69E","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,29],"o":2},"mahjong":{"a":"Mahjong Tile Red Dragon","b":"1F004","d":true,"e":true,"f":true,"h":true,"j":["game","play","chinese","kanji"],"k":[0,14],"o":2},"older_man":{"skin_variations":{"1F3FB":{"unified":"1F474-1F3FB","non_qualified":null,"image":"1f474-1f3fb.png","sheet_x":22,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F474-1F3FC","non_qualified":null,"image":"1f474-1f3fc.png","sheet_x":22,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F474-1F3FD","non_qualified":null,"image":"1f474-1f3fd.png","sheet_x":22,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F474-1F3FE","non_qualified":null,"image":"1f474-1f3fe.png","sheet_x":22,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F474-1F3FF","non_qualified":null,"image":"1f474-1f3ff.png","sheet_x":22,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Man","b":"1F474","d":true,"e":true,"f":true,"h":true,"j":["human","male","men","old","elder","senior"],"k":[22,49],"o":2},"twisted_rightwards_arrows":{"a":"Twisted Rightwards Arrows","b":"1F500","d":true,"e":true,"f":true,"h":true,"j":["blue-square","shuffle","music","random"],"k":[27,28],"o":2},"fried_shrimp":{"a":"Fried Shrimp","b":"1F364","d":true,"e":true,"f":true,"h":true,"j":["food","animal","appetizer","summer"],"k":[7,3],"o":2},"anguished":{"a":"Anguished Face","b":"1F627","d":true,"e":true,"f":true,"h":true,"j":["face","stunned","nervous"],"k":[31,17],"l":["D:"],"o":2},"repeat":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows","b":"1F501","d":true,"e":true,"f":true,"h":true,"j":["loop","record"],"k":[27,29],"o":2},"fish_cake":{"a":"Fish Cake with Swirl Design","b":"1F365","d":true,"e":true,"f":true,"h":true,"j":["food","japan","sea","beach","narutomaki","pink","swirl","kamaboko","surimi","ramen"],"k":[7,4],"o":2},"fax":{"a":"Fax Machine","b":"1F4E0","d":true,"e":true,"f":true,"h":true,"j":["communication","technology"],"k":[26,54],"o":2},"older_woman":{"skin_variations":{"1F3FB":{"unified":"1F475-1F3FB","non_qualified":null,"image":"1f475-1f3fb.png","sheet_x":22,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F475-1F3FC","non_qualified":null,"image":"1f475-1f3fc.png","sheet_x":23,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F475-1F3FD","non_qualified":null,"image":"1f475-1f3fd.png","sheet_x":23,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F475-1F3FE","non_qualified":null,"image":"1f475-1f3fe.png","sheet_x":23,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F475-1F3FF","non_qualified":null,"image":"1f475-1f3ff.png","sheet_x":23,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Woman","b":"1F475","d":true,"e":true,"f":true,"h":true,"j":["human","female","women","lady","old","elder","senior"],"k":[22,55],"o":2},"flag-ec":{"a":"Ecuador Flag","b":"1F1EA-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[1,40],"o":2},"peacock":{"a":"Peacock","b":"1F99A","d":true,"e":true,"f":true,"h":true,"k":[42,44],"o":11},"fearful":{"a":"Fearful Face","b":"1F628","d":true,"e":true,"f":true,"h":true,"j":["face","scared","terrified","nervous","oops","huh"],"k":[31,18],"o":2},"train":{"a":"Tram Car","b":"1F68B","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","carriage","public","travel"],"k":[34,10],"o":2},"flower_playing_cards":{"a":"Flower Playing Cards","b":"1F3B4","d":true,"e":true,"f":true,"h":true,"j":["game","sunset","red"],"k":[8,26],"o":2},"repeat_one":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay","b":"1F502","d":true,"e":true,"f":true,"h":true,"j":["blue-square","loop"],"k":[27,30],"o":2},"moon_cake":{"a":"Moon Cake","b":"1F96E","d":true,"e":true,"f":true,"h":true,"k":[42,4],"o":11},"performing_arts":{"a":"Performing Arts","b":"1F3AD","d":true,"e":true,"f":true,"h":true,"j":["acting","theater","drama"],"k":[8,19],"o":2},"cold_sweat":{"a":"Face with Open Mouth and Cold Sweat","b":"1F630","d":true,"e":true,"f":true,"h":true,"j":["face","nervous","sweat"],"k":[31,26],"o":2},"person_frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB","non_qualified":null,"image":"1f64d-1f3fb.png","sheet_x":33,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64D-1F3FC","non_qualified":null,"image":"1f64d-1f3fc.png","sheet_x":33,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64D-1F3FD","non_qualified":null,"image":"1f64d-1f3fd.png","sheet_x":33,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64D-1F3FE","non_qualified":null,"image":"1f64d-1f3fe.png","sheet_x":33,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64D-1F3FF","non_qualified":null,"image":"1f64d-1f3ff.png","sheet_x":33,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64D-200D-2640-FE0F","a":"Person Frowning","b":"1F64D","d":true,"e":true,"f":true,"h":false,"k":[33,26],"o":2},"flag-ee":{"a":"Estonia Flag","b":"1F1EA-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[1,41],"o":2},"battery":{"a":"Battery","b":"1F50B","d":true,"e":true,"f":true,"h":true,"j":["power","energy","sustain"],"k":[27,39],"o":2},"parrot":{"a":"Parrot","b":"1F99C","d":true,"e":true,"f":true,"h":true,"k":[42,46],"o":11},"bus":{"a":"Bus","b":"1F68C","d":true,"e":true,"f":true,"h":true,"j":["car","vehicle","transportation"],"k":[34,11],"o":2},"flag-eg":{"a":"Egypt Flag","b":"1F1EA-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,42],"o":2},"arrow_forward":{"a":"Black Right-Pointing Triangle","b":"25B6-FE0F","c":"25B6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","right","direction","play"],"k":[52,43],"o":2},"man-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2642-FE0F","non_qualified":"1F64D-1F3FB-200D-2642","image":"1f64d-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64D-1F3FC-200D-2642-FE0F","non_qualified":"1F64D-1F3FC-200D-2642","image":"1f64d-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64D-1F3FD-200D-2642-FE0F","non_qualified":"1F64D-1F3FD-200D-2642","image":"1f64d-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64D-1F3FE-200D-2642-FE0F","non_qualified":"1F64D-1F3FE-200D-2642","image":"1f64d-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64D-1F3FF-200D-2642-FE0F","non_qualified":"1F64D-1F3FF-200D-2642","image":"1f64d-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Frowning","b":"1F64D-200D-2642-FE0F","c":"1F64D-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[33,20],"o":4},"disappointed_relieved":{"a":"Disappointed but Relieved Face","b":"1F625","d":true,"e":true,"f":true,"h":true,"j":["face","phew","sweat","nervous"],"k":[31,15],"o":2},"electric_plug":{"a":"Electric Plug","b":"1F50C","d":true,"e":true,"f":true,"h":true,"j":["charger","power"],"k":[27,40],"o":2},"frame_with_picture":{"a":"Frame with Picture","b":"1F5BC-FE0F","c":"1F5BC","d":true,"e":true,"f":true,"h":true,"k":[30,14],"o":2},"oncoming_bus":{"a":"Oncoming Bus","b":"1F68D","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation"],"k":[34,12],"o":2},"dango":{"a":"Dango","b":"1F361","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","sweet","japanese","barbecue","meat"],"k":[7,0],"o":2},"frog":{"a":"Frog Face","b":"1F438","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","croak","toad"],"k":[12,28],"o":2},"computer":{"a":"Personal Computer","b":"1F4BB","d":true,"e":true,"f":true,"h":true,"j":["technology","laptop","screen","display","monitor"],"k":[26,17],"o":2},"art":{"a":"Artist Palette","b":"1F3A8","d":true,"e":true,"f":true,"h":true,"j":["design","paint","draw","colors"],"k":[8,14],"o":2},"flag-eh":{"a":"Western Sahara Flag","b":"1F1EA-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[1,43],"o":2},"fast_forward":{"a":"Black Right-Pointing Double Triangle","b":"23E9","d":true,"e":true,"f":true,"h":true,"j":["blue-square","play","speed","continue"],"k":[52,26],"o":2},"cry":{"a":"Crying Face","b":"1F622","d":true,"e":true,"f":true,"h":true,"j":["face","tears","sad","depressed","upset",":'("],"k":[31,12],"l":[":'("],"m":":'(","o":2},"woman-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2640-FE0F","non_qualified":"1F64D-1F3FB-200D-2640","image":"1f64d-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64D-1F3FC-200D-2640-FE0F","non_qualified":"1F64D-1F3FC-200D-2640","image":"1f64d-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64D-1F3FD-200D-2640-FE0F","non_qualified":"1F64D-1F3FD-200D-2640","image":"1f64d-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64D-1F3FE-200D-2640-FE0F","non_qualified":"1F64D-1F3FE-200D-2640","image":"1f64d-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64D-1F3FF-200D-2640-FE0F","non_qualified":"1F64D-1F3FF-200D-2640","image":"1f64d-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64D","a":"Woman Frowning","b":"1F64D-200D-2640-FE0F","c":"1F64D-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[33,14],"o":4},"trolleybus":{"a":"Trolleybus","b":"1F68E","d":true,"e":true,"f":true,"h":true,"j":["bart","transportation","vehicle"],"k":[34,13],"o":2},"crocodile":{"a":"Crocodile","b":"1F40A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","reptile","lizard","alligator"],"k":[11,38],"o":2},"dumpling":{"a":"Dumpling","b":"1F95F","d":true,"e":true,"f":true,"h":true,"k":[41,46],"o":5},"black_right_pointing_double_triangle_with_vertical_bar":{"a":"Black Right Pointing Double Triangle with Vertical Bar","b":"23ED-FE0F","c":"23ED","d":true,"e":true,"f":true,"h":true,"k":[52,30],"o":2},"desktop_computer":{"a":"Desktop Computer","b":"1F5A5-FE0F","c":"1F5A5","d":true,"e":true,"f":true,"h":true,"j":["technology","computing","screen"],"k":[30,10],"o":2},"person_with_pouting_face":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB","non_qualified":null,"image":"1f64e-1f3fb.png","sheet_x":33,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64E-1F3FC","non_qualified":null,"image":"1f64e-1f3fc.png","sheet_x":33,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64E-1F3FD","non_qualified":null,"image":"1f64e-1f3fd.png","sheet_x":33,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64E-1F3FE","non_qualified":null,"image":"1f64e-1f3fe.png","sheet_x":33,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64E-1F3FF","non_qualified":null,"image":"1f64e-1f3ff.png","sheet_x":33,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64E-200D-2640-FE0F","a":"Person with Pouting Face","b":"1F64E","d":true,"e":true,"f":true,"h":false,"k":[33,44],"o":2},"turtle":{"a":"Turtle","b":"1F422","d":true,"e":true,"f":true,"h":true,"j":["animal","slow","nature","tortoise"],"k":[12,6],"o":2},"sob":{"a":"Loudly Crying Face","b":"1F62D","d":true,"e":true,"f":true,"h":true,"j":["face","cry","tears","sad","upset","depressed"],"k":[31,23],"m":":'(","o":2},"flag-er":{"a":"Eritrea Flag","b":"1F1EA-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,44],"o":2},"thread":{"a":"Spool of Thread","b":"1F9F5","d":true,"e":true,"f":true,"h":true,"k":[51,40],"o":11},"minibus":{"a":"Minibus","b":"1F690","d":true,"e":true,"f":true,"h":true,"j":["vehicle","car","transportation"],"k":[34,15],"o":2},"fortune_cookie":{"a":"Fortune Cookie","b":"1F960","d":true,"e":true,"f":true,"h":true,"k":[41,47],"o":5},"yarn":{"a":"Ball of Yarn","b":"1F9F6","d":true,"e":true,"f":true,"h":true,"k":[51,41],"o":11},"takeout_box":{"a":"Takeout Box","b":"1F961","d":true,"e":true,"f":true,"h":true,"k":[41,48],"o":5},"man-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2642-FE0F","non_qualified":"1F64E-1F3FB-200D-2642","image":"1f64e-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64E-1F3FC-200D-2642-FE0F","non_qualified":"1F64E-1F3FC-200D-2642","image":"1f64e-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64E-1F3FD-200D-2642-FE0F","non_qualified":"1F64E-1F3FD-200D-2642","image":"1f64e-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64E-1F3FE-200D-2642-FE0F","non_qualified":"1F64E-1F3FE-200D-2642","image":"1f64e-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64E-1F3FF-200D-2642-FE0F","non_qualified":"1F64E-1F3FF-200D-2642","image":"1f64e-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Pouting","b":"1F64E-200D-2642-FE0F","c":"1F64E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[33,38],"o":4},"printer":{"a":"Printer","b":"1F5A8-FE0F","c":"1F5A8","d":true,"e":true,"f":true,"h":true,"j":["paper","ink"],"k":[30,11],"o":2},"scream":{"a":"Face Screaming in Fear","b":"1F631","d":true,"e":true,"f":true,"h":true,"j":["face","munch","scared","omg"],"k":[31,27],"o":2},"es":{"a":"Spain Flag","b":"1F1EA-1F1F8","d":true,"e":true,"f":true,"h":true,"j":["spain","flag","nation","country","banner"],"k":[1,45],"n":["flag-es"],"o":2},"ambulance":{"a":"Ambulance","b":"1F691","d":true,"e":true,"f":true,"h":true,"j":["health","911","hospital"],"k":[34,16],"o":2},"black_right_pointing_triangle_with_double_vertical_bar":{"a":"Black Right Pointing Triangle with Double Vertical Bar","b":"23EF-FE0F","c":"23EF","d":true,"e":true,"f":true,"h":true,"k":[52,32],"o":2},"lizard":{"a":"Lizard","b":"1F98E","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","reptile"],"k":[42,32],"o":4},"flag-et":{"a":"Ethiopia Flag","b":"1F1EA-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[1,46],"o":2},"keyboard":{"a":"Keyboard","b":"2328-FE0F","c":"2328","d":true,"e":true,"f":true,"h":true,"j":["technology","computer","type","input","text"],"k":[52,24],"o":2},"crab":{"a":"Crab","b":"1F980","d":true,"e":true,"f":true,"h":true,"j":["animal","crustacean"],"k":[42,18],"o":2},"confounded":{"a":"Confounded Face","b":"1F616","d":true,"e":true,"f":true,"h":true,"j":["face","confused","sick","unwell","oops",":S"],"k":[31,0],"o":2},"snake":{"a":"Snake","b":"1F40D","d":true,"e":true,"f":true,"h":true,"j":["animal","evil","nature","hiss","python"],"k":[11,41],"o":2},"woman-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2640-FE0F","non_qualified":"1F64E-1F3FB-200D-2640","image":"1f64e-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64E-1F3FC-200D-2640-FE0F","non_qualified":"1F64E-1F3FC-200D-2640","image":"1f64e-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64E-1F3FD-200D-2640-FE0F","non_qualified":"1F64E-1F3FD-200D-2640","image":"1f64e-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64E-1F3FE-200D-2640-FE0F","non_qualified":"1F64E-1F3FE-200D-2640","image":"1f64e-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64E-1F3FF-200D-2640-FE0F","non_qualified":"1F64E-1F3FF-200D-2640","image":"1f64e-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64E","a":"Woman Pouting","b":"1F64E-200D-2640-FE0F","c":"1F64E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[33,32],"o":4},"arrow_backward":{"a":"Black Left-Pointing Triangle","b":"25C0-FE0F","c":"25C0","d":true,"e":true,"f":true,"h":true,"j":["blue-square","left","direction"],"k":[52,44],"o":2},"fire_engine":{"a":"Fire Engine","b":"1F692","d":true,"e":true,"f":true,"h":true,"j":["transportation","cars","vehicle"],"k":[34,17],"o":2},"rewind":{"a":"Black Left-Pointing Double Triangle","b":"23EA","d":true,"e":true,"f":true,"h":true,"j":["play","blue-square"],"k":[52,27],"o":2},"three_button_mouse":{"a":"Three Button Mouse","b":"1F5B1-FE0F","c":"1F5B1","d":true,"e":true,"f":true,"h":true,"k":[30,12],"o":2},"no_good":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB","non_qualified":null,"image":"1f645-1f3fb.png","sheet_x":32,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F645-1F3FC","non_qualified":null,"image":"1f645-1f3fc.png","sheet_x":32,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F645-1F3FD","non_qualified":null,"image":"1f645-1f3fd.png","sheet_x":32,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F645-1F3FE","non_qualified":null,"image":"1f645-1f3fe.png","sheet_x":32,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F645-1F3FF","non_qualified":null,"image":"1f645-1f3ff.png","sheet_x":32,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F645-200D-2640-FE0F","a":"Face with No Good Gesture","b":"1F645","d":true,"e":true,"f":true,"h":false,"k":[32,2],"o":2},"police_car":{"a":"Police Car","b":"1F693","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","transportation","law","legal","enforcement"],"k":[34,18],"o":2},"dragon_face":{"a":"Dragon Face","b":"1F432","d":true,"e":true,"f":true,"h":true,"j":["animal","myth","nature","chinese","green"],"k":[12,22],"o":2},"persevere":{"a":"Persevering Face","b":"1F623","d":true,"e":true,"f":true,"h":true,"j":["face","sick","no","upset","oops"],"k":[31,13],"o":2},"lobster":{"a":"Lobster","b":"1F99E","d":true,"e":true,"f":true,"h":true,"k":[42,48],"o":11},"flag-eu":{"a":"European Union Flag","b":"1F1EA-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[1,47],"o":2},"disappointed":{"a":"Disappointed Face","b":"1F61E","d":true,"e":true,"f":true,"h":true,"j":["face","sad","upset","depressed",":("],"k":[31,8],"l":["):",":(",":-("],"m":":(","o":2},"shrimp":{"a":"Shrimp","b":"1F990","d":true,"e":true,"f":true,"h":true,"j":["animal","ocean","nature","seafood"],"k":[42,34],"o":4},"dragon":{"a":"Dragon","b":"1F409","d":true,"e":true,"f":true,"h":true,"j":["animal","myth","nature","chinese","green"],"k":[11,37],"o":2},"man-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2642-FE0F","non_qualified":"1F645-1F3FB-200D-2642","image":"1f645-1f3fb-200d-2642-fe0f.png","sheet_x":31,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F645-1F3FC-200D-2642-FE0F","non_qualified":"1F645-1F3FC-200D-2642","image":"1f645-1f3fc-200d-2642-fe0f.png","sheet_x":31,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F645-1F3FD-200D-2642-FE0F","non_qualified":"1F645-1F3FD-200D-2642","image":"1f645-1f3fd-200d-2642-fe0f.png","sheet_x":31,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F645-1F3FE-200D-2642-FE0F","non_qualified":"1F645-1F3FE-200D-2642","image":"1f645-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F645-1F3FF-200D-2642-FE0F","non_qualified":"1F645-1F3FF-200D-2642","image":"1f645-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Gesturing No","b":"1F645-200D-2642-FE0F","c":"1F645-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[31,53],"o":4},"flag-fi":{"a":"Finland Flag","b":"1F1EB-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[1,48],"o":2},"trackball":{"a":"Trackball","b":"1F5B2-FE0F","c":"1F5B2","d":true,"e":true,"f":true,"h":true,"j":["technology","trackpad"],"k":[30,13],"o":2},"black_left_pointing_double_triangle_with_vertical_bar":{"a":"Black Left Pointing Double Triangle with Vertical Bar","b":"23EE-FE0F","c":"23EE","d":true,"e":true,"f":true,"h":true,"k":[52,31],"o":2},"oncoming_police_car":{"a":"Oncoming Police Car","b":"1F694","d":true,"e":true,"f":true,"h":true,"j":["vehicle","law","legal","enforcement","911"],"k":[34,19],"o":2},"minidisc":{"a":"Minidisc","b":"1F4BD","d":true,"e":true,"f":true,"h":true,"j":["technology","record","data","disk","90s"],"k":[26,19],"o":2},"sweat":{"a":"Face with Cold Sweat","b":"1F613","d":true,"e":true,"f":true,"h":true,"j":["face","hot","sad","tired","exercise"],"k":[30,54],"o":2},"squid":{"a":"Squid","b":"1F991","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","ocean","sea"],"k":[42,35],"o":4},"sauropod":{"a":"Sauropod","b":"1F995","d":true,"e":true,"f":true,"h":true,"k":[42,39],"o":5},"arrow_up_small":{"a":"Up-Pointing Small Red Triangle","b":"1F53C","d":true,"e":true,"f":true,"h":true,"j":["blue-square","triangle","direction","point","forward","top"],"k":[28,31],"o":2},"flag-fj":{"a":"Fiji Flag","b":"1F1EB-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[1,49],"o":2},"woman-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2640-FE0F","non_qualified":"1F645-1F3FB-200D-2640","image":"1f645-1f3fb-200d-2640-fe0f.png","sheet_x":31,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F645-1F3FC-200D-2640-FE0F","non_qualified":"1F645-1F3FC-200D-2640","image":"1f645-1f3fc-200d-2640-fe0f.png","sheet_x":31,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F645-1F3FD-200D-2640-FE0F","non_qualified":"1F645-1F3FD-200D-2640","image":"1f645-1f3fd-200d-2640-fe0f.png","sheet_x":31,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F645-1F3FE-200D-2640-FE0F","non_qualified":"1F645-1F3FE-200D-2640","image":"1f645-1f3fe-200d-2640-fe0f.png","sheet_x":31,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F645-1F3FF-200D-2640-FE0F","non_qualified":"1F645-1F3FF-200D-2640","image":"1f645-1f3ff-200d-2640-fe0f.png","sheet_x":31,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F645","a":"Woman Gesturing No","b":"1F645-200D-2640-FE0F","c":"1F645-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[31,47],"o":4},"taxi":{"a":"Taxi","b":"1F695","d":true,"e":true,"f":true,"h":true,"j":["uber","vehicle","cars","transportation"],"k":[34,20],"o":2},"flag-fk":{"a":"Falkland Islands Flag","b":"1F1EB-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,50],"o":2},"floppy_disk":{"a":"Floppy Disk","b":"1F4BE","d":true,"e":true,"f":true,"h":true,"j":["oldschool","technology","save","90s","80s"],"k":[26,20],"o":2},"t-rex":{"a":"T-Rex","b":"1F996","d":true,"e":true,"f":true,"h":true,"k":[42,40],"o":5},"oyster":{"a":"Oyster","b":"1F9AA","d":true,"e":true,"f":true,"h":true,"k":[43,1],"o":12},"arrow_double_up":{"a":"Black Up-Pointing Double Triangle","b":"23EB","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","top"],"k":[52,28],"o":2},"oncoming_taxi":{"a":"Oncoming Taxi","b":"1F696","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","uber"],"k":[34,21],"o":2},"ok_woman":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB","non_qualified":null,"image":"1f646-1f3fb.png","sheet_x":32,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F646-1F3FC","non_qualified":null,"image":"1f646-1f3fc.png","sheet_x":32,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F646-1F3FD","non_qualified":null,"image":"1f646-1f3fd.png","sheet_x":32,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F646-1F3FE","non_qualified":null,"image":"1f646-1f3fe.png","sheet_x":32,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F646-1F3FF","non_qualified":null,"image":"1f646-1f3ff.png","sheet_x":32,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F646-200D-2640-FE0F","a":"Face with Ok Gesture","b":"1F646","d":true,"e":true,"f":true,"h":false,"j":["women","girl","female","pink","human","woman"],"k":[32,20],"o":2},"weary":{"a":"Weary Face","b":"1F629","d":true,"e":true,"f":true,"h":true,"j":["face","tired","sleepy","sad","frustrated","upset"],"k":[31,19],"o":2},"man-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2642-FE0F","non_qualified":"1F646-1F3FB-200D-2642","image":"1f646-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F646-1F3FC-200D-2642-FE0F","non_qualified":"1F646-1F3FC-200D-2642","image":"1f646-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F646-1F3FD-200D-2642-FE0F","non_qualified":"1F646-1F3FD-200D-2642","image":"1f646-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F646-1F3FE-200D-2642-FE0F","non_qualified":"1F646-1F3FE-200D-2642","image":"1f646-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F646-1F3FF-200D-2642-FE0F","non_qualified":"1F646-1F3FF-200D-2642","image":"1f646-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Gesturing Ok","b":"1F646-200D-2642-FE0F","c":"1F646-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,14],"o":4},"arrow_down_small":{"a":"Down-Pointing Small Red Triangle","b":"1F53D","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[28,32],"o":2},"tired_face":{"a":"Tired Face","b":"1F62B","d":true,"e":true,"f":true,"h":true,"j":["sick","whine","upset","frustrated"],"k":[31,21],"o":2},"car":{"a":"Automobile","b":"1F697","d":true,"e":true,"f":true,"h":true,"k":[34,22],"n":["red_car"],"o":2},"icecream":{"a":"Soft Ice Cream","b":"1F366","d":true,"e":true,"f":true,"h":true,"j":["food","hot","dessert","summer"],"k":[7,5],"o":2},"cd":{"a":"Optical Disc","b":"1F4BF","d":true,"e":true,"f":true,"h":true,"j":["technology","dvd","disk","disc","90s"],"k":[26,21],"o":2},"whale":{"a":"Spouting Whale","b":"1F433","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","sea","ocean"],"k":[12,23],"o":2},"flag-fm":{"a":"Micronesia Flag","b":"1F1EB-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,51],"o":2},"oncoming_automobile":{"a":"Oncoming Automobile","b":"1F698","d":true,"e":true,"f":true,"h":true,"j":["car","vehicle","transportation"],"k":[34,23],"o":2},"arrow_double_down":{"a":"Black Down-Pointing Double Triangle","b":"23EC","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[52,29],"o":2},"woman-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2640-FE0F","non_qualified":"1F646-1F3FB-200D-2640","image":"1f646-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F646-1F3FC-200D-2640-FE0F","non_qualified":"1F646-1F3FC-200D-2640","image":"1f646-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F646-1F3FD-200D-2640-FE0F","non_qualified":"1F646-1F3FD-200D-2640","image":"1f646-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F646-1F3FE-200D-2640-FE0F","non_qualified":"1F646-1F3FE-200D-2640","image":"1f646-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F646-1F3FF-200D-2640-FE0F","non_qualified":"1F646-1F3FF-200D-2640","image":"1f646-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F646","a":"Woman Gesturing Ok","b":"1F646-200D-2640-FE0F","c":"1F646-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,8],"o":4},"yawning_face":{"a":"Yawning Face","b":"1F971","d":true,"e":true,"f":true,"h":true,"k":[42,7],"o":12},"dvd":{"a":"Dvd","b":"1F4C0","d":true,"e":true,"f":true,"h":true,"j":["cd","disk","disc"],"k":[26,22],"o":2},"whale2":{"a":"Whale","b":"1F40B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","sea","ocean"],"k":[11,39],"o":2},"flag-fo":{"a":"Faroe Islands Flag","b":"1F1EB-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,52],"o":2},"shaved_ice":{"a":"Shaved Ice","b":"1F367","d":true,"e":true,"f":true,"h":true,"j":["hot","dessert","summer"],"k":[7,6],"o":2},"double_vertical_bar":{"a":"Double Vertical Bar","b":"23F8-FE0F","c":"23F8","d":true,"e":true,"f":true,"h":true,"k":[52,37],"o":2},"information_desk_person":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB","non_qualified":null,"image":"1f481-1f3fb.png","sheet_x":24,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F481-1F3FC","non_qualified":null,"image":"1f481-1f3fc.png","sheet_x":24,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F481-1F3FD","non_qualified":null,"image":"1f481-1f3fd.png","sheet_x":24,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F481-1F3FE","non_qualified":null,"image":"1f481-1f3fe.png","sheet_x":24,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F481-1F3FF","non_qualified":null,"image":"1f481-1f3ff.png","sheet_x":24,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F481-200D-2640-FE0F","a":"Information Desk Person","b":"1F481","d":true,"e":true,"f":true,"h":false,"k":[24,2],"o":2},"dolphin":{"a":"Dolphin","b":"1F42C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fish","sea","ocean","flipper","fins","beach"],"k":[12,16],"n":["flipper"],"o":2},"blue_car":{"a":"Recreational Vehicle","b":"1F699","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,24],"o":2},"ice_cream":{"a":"Ice Cream","b":"1F368","d":true,"e":true,"f":true,"h":true,"j":["food","hot","dessert"],"k":[7,7],"o":2},"fr":{"a":"France Flag","b":"1F1EB-1F1F7","d":true,"e":true,"f":true,"h":true,"j":["banner","flag","nation","france","french","country"],"k":[1,53],"n":["flag-fr"],"o":2},"triumph":{"a":"Face with Look of Triumph","b":"1F624","d":true,"e":true,"f":true,"h":true,"j":["face","gas","phew","proud","pride"],"k":[31,14],"o":2},"abacus":{"a":"Abacus","b":"1F9EE","d":true,"e":true,"f":true,"h":true,"k":[51,33],"o":11},"man-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2642-FE0F","non_qualified":"1F481-1F3FB-200D-2642","image":"1f481-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F481-1F3FC-200D-2642-FE0F","non_qualified":"1F481-1F3FC-200D-2642","image":"1f481-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F481-1F3FD-200D-2642-FE0F","non_qualified":"1F481-1F3FD-200D-2642","image":"1f481-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F481-1F3FE-200D-2642-FE0F","non_qualified":"1F481-1F3FE-200D-2642","image":"1f481-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F481-1F3FF-200D-2642-FE0F","non_qualified":"1F481-1F3FF-200D-2642","image":"1f481-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Tipping Hand","b":"1F481-200D-2642-FE0F","c":"1F481-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[23,53],"o":4},"doughnut":{"a":"Doughnut","b":"1F369","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","snack","sweet","donut"],"k":[7,8],"o":2},"fish":{"a":"Fish","b":"1F41F","d":true,"e":true,"f":true,"h":true,"j":["animal","food","nature"],"k":[12,3],"o":2},"truck":{"a":"Delivery Truck","b":"1F69A","d":true,"e":true,"f":true,"h":true,"j":["cars","transportation"],"k":[34,25],"o":2},"movie_camera":{"a":"Movie Camera","b":"1F3A5","d":true,"e":true,"f":true,"h":true,"j":["film","record"],"k":[8,11],"o":2},"flag-ga":{"a":"Gabon Flag","b":"1F1EC-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,54],"o":2},"rage":{"a":"Pouting Face","b":"1F621","d":true,"e":true,"f":true,"h":true,"j":["angry","mad","hate","despise"],"k":[31,11],"o":2},"black_square_for_stop":{"a":"Black Square for Stop","b":"23F9-FE0F","c":"23F9","d":true,"e":true,"f":true,"h":true,"k":[52,38],"o":2},"articulated_lorry":{"a":"Articulated Lorry","b":"1F69B","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","transportation","express"],"k":[34,26],"o":2},"angry":{"a":"Angry Face","b":"1F620","d":true,"e":true,"f":true,"h":true,"j":["mad","face","annoyed","frustrated"],"k":[31,10],"l":[">:(",">:-("],"o":2},"cookie":{"a":"Cookie","b":"1F36A","d":true,"e":true,"f":true,"h":true,"j":["food","snack","oreo","chocolate","sweet","dessert"],"k":[7,9],"o":2},"gb":{"a":"United Kingdom Flag","b":"1F1EC-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[1,55],"n":["uk","flag-gb"],"o":2},"tropical_fish":{"a":"Tropical Fish","b":"1F420","d":true,"e":true,"f":true,"h":true,"j":["animal","swim","ocean","beach","nemo"],"k":[12,4],"o":2},"woman-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2640-FE0F","non_qualified":"1F481-1F3FB-200D-2640","image":"1f481-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F481-1F3FC-200D-2640-FE0F","non_qualified":"1F481-1F3FC-200D-2640","image":"1f481-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F481-1F3FD-200D-2640-FE0F","non_qualified":"1F481-1F3FD-200D-2640","image":"1f481-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F481-1F3FE-200D-2640-FE0F","non_qualified":"1F481-1F3FE-200D-2640","image":"1f481-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F481-1F3FF-200D-2640-FE0F","non_qualified":"1F481-1F3FF-200D-2640","image":"1f481-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F481","a":"Woman Tipping Hand","b":"1F481-200D-2640-FE0F","c":"1F481-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[23,47],"o":4},"black_circle_for_record":{"a":"Black Circle for Record","b":"23FA-FE0F","c":"23FA","d":true,"e":true,"f":true,"h":true,"k":[52,39],"o":2},"film_frames":{"a":"Film Frames","b":"1F39E-FE0F","c":"1F39E","d":true,"e":true,"f":true,"h":true,"k":[8,4],"o":2},"film_projector":{"a":"Film Projector","b":"1F4FD-FE0F","c":"1F4FD","d":true,"e":true,"f":true,"h":true,"j":["video","tape","record","movie"],"k":[27,26],"o":2},"flag-gd":{"a":"Grenada Flag","b":"1F1EC-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[1,56],"o":2},"blowfish":{"a":"Blowfish","b":"1F421","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","food","sea","ocean"],"k":[12,5],"o":2},"face_with_symbols_on_mouth":{"a":"Serious Face with Symbols Covering Mouth","b":"1F92C","d":true,"e":true,"f":true,"h":true,"k":[38,46],"n":["serious_face_with_symbols_covering_mouth"],"o":5},"birthday":{"a":"Birthday Cake","b":"1F382","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","cake"],"k":[7,33],"o":2},"eject":{"a":"Eject","b":"23CF-FE0F","c":"23CF","d":true,"e":true,"f":true,"h":true,"k":[52,25],"o":2},"raising_hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB","non_qualified":null,"image":"1f64b-1f3fb.png","sheet_x":33,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64B-1F3FC","non_qualified":null,"image":"1f64b-1f3fc.png","sheet_x":33,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64B-1F3FD","non_qualified":null,"image":"1f64b-1f3fd.png","sheet_x":33,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64B-1F3FE","non_qualified":null,"image":"1f64b-1f3fe.png","sheet_x":33,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64B-1F3FF","non_qualified":null,"image":"1f64b-1f3ff.png","sheet_x":33,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64B-200D-2640-FE0F","a":"Happy Person Raising One Hand","b":"1F64B","d":true,"e":true,"f":true,"h":false,"k":[33,2],"o":2},"tractor":{"a":"Tractor","b":"1F69C","d":true,"e":true,"f":true,"h":true,"j":["vehicle","car","farming","agriculture"],"k":[34,27],"o":2},"flag-ge":{"a":"Georgia Flag","b":"1F1EC-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,0],"o":2},"smiling_imp":{"a":"Smiling Face with Horns","b":"1F608","d":true,"e":true,"f":true,"h":true,"j":["devil","horns"],"k":[30,43],"o":2},"racing_car":{"a":"Racing Car","b":"1F3CE-FE0F","c":"1F3CE","d":true,"e":true,"f":true,"h":true,"j":["sports","race","fast","formula","f1"],"k":[10,33],"o":2},"cinema":{"a":"Cinema","b":"1F3A6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","record","film","movie","curtain","stage","theater"],"k":[8,12],"o":2},"clapper":{"a":"Clapper Board","b":"1F3AC","d":true,"e":true,"f":true,"h":true,"j":["movie","film","record"],"k":[8,18],"o":2},"shark":{"a":"Shark","b":"1F988","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"k":[42,26],"o":4},"cake":{"a":"Shortcake","b":"1F370","d":true,"e":true,"f":true,"h":true,"j":["food","dessert"],"k":[7,15],"o":2},"man-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2642-FE0F","non_qualified":"1F64B-1F3FB-200D-2642","image":"1f64b-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64B-1F3FC-200D-2642-FE0F","non_qualified":"1F64B-1F3FC-200D-2642","image":"1f64b-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64B-1F3FD-200D-2642-FE0F","non_qualified":"1F64B-1F3FD-200D-2642","image":"1f64b-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64B-1F3FE-200D-2642-FE0F","non_qualified":"1F64B-1F3FE-200D-2642","image":"1f64b-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64B-1F3FF-200D-2642-FE0F","non_qualified":"1F64B-1F3FF-200D-2642","image":"1f64b-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Raising Hand","b":"1F64B-200D-2642-FE0F","c":"1F64B-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,53],"o":4},"octopus":{"a":"Octopus","b":"1F419","d":true,"e":true,"f":true,"h":true,"j":["animal","creature","ocean","sea","nature","beach"],"k":[11,54],"o":2},"woman-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2640-FE0F","non_qualified":"1F64B-1F3FB-200D-2640","image":"1f64b-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64B-1F3FC-200D-2640-FE0F","non_qualified":"1F64B-1F3FC-200D-2640","image":"1f64b-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64B-1F3FD-200D-2640-FE0F","non_qualified":"1F64B-1F3FD-200D-2640","image":"1f64b-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64B-1F3FE-200D-2640-FE0F","non_qualified":"1F64B-1F3FE-200D-2640","image":"1f64b-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64B-1F3FF-200D-2640-FE0F","non_qualified":"1F64B-1F3FF-200D-2640","image":"1f64b-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64B","a":"Woman Raising Hand","b":"1F64B-200D-2640-FE0F","c":"1F64B-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,47],"o":4},"flag-gf":{"a":"French Guiana Flag","b":"1F1EC-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[2,1],"o":2},"tv":{"a":"Television","b":"1F4FA","d":true,"e":true,"f":true,"h":true,"j":["technology","program","oldschool","show","television"],"k":[27,23],"o":2},"imp":{"a":"Imp","b":"1F47F","d":true,"e":true,"f":true,"h":true,"j":["devil","angry","horns"],"k":[23,45],"o":2},"cupcake":{"a":"Cupcake","b":"1F9C1","d":true,"e":true,"f":true,"h":true,"k":[44,9],"o":11},"racing_motorcycle":{"a":"Racing Motorcycle","b":"1F3CD-FE0F","c":"1F3CD","d":true,"e":true,"f":true,"h":true,"k":[10,32],"o":2},"low_brightness":{"a":"Low Brightness Symbol","b":"1F505","d":true,"e":true,"f":true,"h":true,"j":["sun","afternoon","warm","summer"],"k":[27,33],"o":2},"shell":{"a":"Spiral Shell","b":"1F41A","d":true,"e":true,"f":true,"h":true,"j":["nature","sea","beach"],"k":[11,55],"o":2},"flag-gg":{"a":"Guernsey Flag","b":"1F1EC-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[2,2],"o":2},"high_brightness":{"a":"High Brightness Symbol","b":"1F506","d":true,"e":true,"f":true,"h":true,"j":["sun","light"],"k":[27,34],"o":2},"deaf_person":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB","non_qualified":null,"image":"1f9cf-1f3fb.png","sheet_x":45,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC","non_qualified":null,"image":"1f9cf-1f3fc.png","sheet_x":45,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD","non_qualified":null,"image":"1f9cf-1f3fd.png","sheet_x":45,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE","non_qualified":null,"image":"1f9cf-1f3fe.png","sheet_x":45,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF","non_qualified":null,"image":"1f9cf-1f3ff.png","sheet_x":45,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Person","b":"1F9CF","d":true,"e":true,"f":true,"h":true,"k":[45,10],"o":12},"skull":{"a":"Skull","b":"1F480","d":true,"e":true,"f":true,"h":true,"j":["dead","skeleton","creepy","death"],"k":[23,46],"o":2},"motor_scooter":{"a":"Motor Scooter","b":"1F6F5","d":true,"e":true,"f":true,"h":true,"j":["vehicle","vespa","sasha"],"k":[36,54],"o":4},"camera":{"a":"Camera","b":"1F4F7","d":true,"e":true,"f":true,"h":true,"j":["gadgets","photography"],"k":[27,20],"o":2},"pie":{"a":"Pie","b":"1F967","d":true,"e":true,"f":true,"h":true,"k":[41,54],"o":5},"flag-gh":{"a":"Ghana Flag","b":"1F1EC-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[2,3],"o":2},"deaf_man":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB-200D-2642-FE0F","non_qualified":"1F9CF-1F3FB-200D-2642","image":"1f9cf-1f3fb-200d-2642-fe0f.png","sheet_x":45,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC-200D-2642-FE0F","non_qualified":"1F9CF-1F3FC-200D-2642","image":"1f9cf-1f3fc-200d-2642-fe0f.png","sheet_x":45,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD-200D-2642-FE0F","non_qualified":"1F9CF-1F3FD-200D-2642","image":"1f9cf-1f3fd-200d-2642-fe0f.png","sheet_x":45,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE-200D-2642-FE0F","non_qualified":"1F9CF-1F3FE-200D-2642","image":"1f9cf-1f3fe-200d-2642-fe0f.png","sheet_x":45,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF-200D-2642-FE0F","non_qualified":"1F9CF-1F3FF-200D-2642","image":"1f9cf-1f3ff-200d-2642-fe0f.png","sheet_x":45,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Man","b":"1F9CF-200D-2642-FE0F","c":"1F9CF-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[45,4],"o":12},"skull_and_crossbones":{"a":"Skull and Crossbones","b":"2620-FE0F","c":"2620","d":true,"e":true,"f":true,"h":true,"j":["poison","danger","deadly","scary","death","pirate","evil"],"k":[53,8],"o":2},"camera_with_flash":{"a":"Camera with Flash","b":"1F4F8","d":true,"e":true,"f":true,"h":true,"k":[27,21],"o":2},"signal_strength":{"a":"Antenna with Bars","b":"1F4F6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","reception","phone","internet","connection","wifi","bluetooth","bars"],"k":[27,19],"o":2},"chocolate_bar":{"a":"Chocolate Bar","b":"1F36B","d":true,"e":true,"f":true,"h":true,"j":["food","snack","dessert","sweet"],"k":[7,10],"o":2},"manual_wheelchair":{"a":"Manual Wheelchair","b":"1F9BD","d":true,"e":true,"f":true,"h":true,"k":[44,5],"o":12},"snail":{"a":"Snail","b":"1F40C","d":true,"e":true,"f":true,"h":true,"j":["slow","animal","shell"],"k":[11,40],"o":2},"motorized_wheelchair":{"a":"Motorized Wheelchair","b":"1F9BC","d":true,"e":true,"f":true,"h":true,"k":[44,4],"o":12},"flag-gi":{"a":"Gibraltar Flag","b":"1F1EC-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,4],"o":2},"hankey":{"a":"Pile of Poo","b":"1F4A9","d":true,"e":true,"f":true,"h":true,"k":[25,51],"n":["poop","shit"],"o":2},"vibration_mode":{"a":"Vibration Mode","b":"1F4F3","d":true,"e":true,"f":true,"h":true,"j":["orange-square","phone"],"k":[27,16],"o":2},"deaf_woman":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB-200D-2640-FE0F","non_qualified":"1F9CF-1F3FB-200D-2640","image":"1f9cf-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC-200D-2640-FE0F","non_qualified":"1F9CF-1F3FC-200D-2640","image":"1f9cf-1f3fc-200d-2640-fe0f.png","sheet_x":45,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD-200D-2640-FE0F","non_qualified":"1F9CF-1F3FD-200D-2640","image":"1f9cf-1f3fd-200d-2640-fe0f.png","sheet_x":45,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE-200D-2640-FE0F","non_qualified":"1F9CF-1F3FE-200D-2640","image":"1f9cf-1f3fe-200d-2640-fe0f.png","sheet_x":45,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF-200D-2640-FE0F","non_qualified":"1F9CF-1F3FF-200D-2640","image":"1f9cf-1f3ff-200d-2640-fe0f.png","sheet_x":45,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Woman","b":"1F9CF-200D-2640-FE0F","c":"1F9CF-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,55],"o":12},"butterfly":{"a":"Butterfly","b":"1F98B","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","caterpillar"],"k":[42,29],"o":4},"video_camera":{"a":"Video Camera","b":"1F4F9","d":true,"e":true,"f":true,"h":true,"j":["film","record"],"k":[27,22],"o":2},"candy":{"a":"Candy","b":"1F36C","d":true,"e":true,"f":true,"h":true,"j":["snack","dessert","sweet","lolly"],"k":[7,11],"o":2},"auto_rickshaw":{"a":"Auto Rickshaw","b":"1F6FA","d":true,"e":true,"f":true,"h":true,"k":[37,2],"o":12},"bow":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB","non_qualified":null,"image":"1f647-1f3fb.png","sheet_x":32,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F647-1F3FC","non_qualified":null,"image":"1f647-1f3fc.png","sheet_x":32,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F647-1F3FD","non_qualified":null,"image":"1f647-1f3fd.png","sheet_x":32,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F647-1F3FE","non_qualified":null,"image":"1f647-1f3fe.png","sheet_x":32,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F647-1F3FF","non_qualified":null,"image":"1f647-1f3ff.png","sheet_x":32,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F647-200D-2642-FE0F","a":"Person Bowing Deeply","b":"1F647","d":true,"e":true,"f":true,"h":false,"k":[32,38],"o":2},"mobile_phone_off":{"a":"Mobile Phone off","b":"1F4F4","d":true,"e":true,"f":true,"h":true,"j":["mute","orange-square","silence","quiet"],"k":[27,17],"o":2},"clown_face":{"a":"Clown Face","b":"1F921","d":true,"e":true,"f":true,"h":true,"j":["face"],"k":[38,18],"o":4},"lollipop":{"a":"Lollipop","b":"1F36D","d":true,"e":true,"f":true,"h":true,"j":["food","snack","candy","sweet"],"k":[7,12],"o":2},"flag-gl":{"a":"Greenland Flag","b":"1F1EC-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[2,5],"o":2},"vhs":{"a":"Videocassette","b":"1F4FC","d":true,"e":true,"f":true,"h":true,"j":["record","video","oldschool","90s","80s"],"k":[27,25],"o":2},"bug":{"a":"Bug","b":"1F41B","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","worm"],"k":[11,56],"o":2},"bike":{"a":"Bicycle","b":"1F6B2","d":true,"e":true,"f":true,"h":true,"j":["sports","bicycle","exercise","hipster"],"k":[35,9],"o":2},"man-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2642-FE0F","non_qualified":"1F647-1F3FB-200D-2642","image":"1f647-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F647-1F3FC-200D-2642-FE0F","non_qualified":"1F647-1F3FC-200D-2642","image":"1f647-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F647-1F3FD-200D-2642-FE0F","non_qualified":"1F647-1F3FD-200D-2642","image":"1f647-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F647-1F3FE-200D-2642-FE0F","non_qualified":"1F647-1F3FE-200D-2642","image":"1f647-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F647-1F3FF-200D-2642-FE0F","non_qualified":"1F647-1F3FF-200D-2642","image":"1f647-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F647","a":"Man Bowing","b":"1F647-200D-2642-FE0F","c":"1F647-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,32],"o":4},"female_sign":{"a":"Female Sign","b":"2640-FE0F","c":"2640","d":false,"e":true,"f":true,"h":true,"k":[53,18],"o":4},"japanese_ogre":{"a":"Japanese Ogre","b":"1F479","d":true,"e":true,"f":true,"h":true,"j":["monster","red","mask","halloween","scary","creepy","devil","demon","japanese","ogre"],"k":[23,34],"o":2},"custard":{"a":"Custard","b":"1F36E","d":true,"e":true,"f":true,"h":true,"j":["dessert","food"],"k":[7,13],"o":2},"ant":{"a":"Ant","b":"1F41C","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","bug"],"k":[12,0],"o":2},"mag":{"a":"Left-Pointing Magnifying Glass","b":"1F50D","d":true,"e":true,"f":true,"h":true,"j":["search","zoom","find","detective"],"k":[27,41],"o":2},"flag-gm":{"a":"Gambia Flag","b":"1F1EC-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,6],"o":2},"honey_pot":{"a":"Honey Pot","b":"1F36F","d":true,"e":true,"f":true,"h":true,"j":["bees","sweet","kitchen"],"k":[7,14],"o":2},"woman-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2640-FE0F","non_qualified":"1F647-1F3FB-200D-2640","image":"1f647-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F647-1F3FC-200D-2640-FE0F","non_qualified":"1F647-1F3FC-200D-2640","image":"1f647-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F647-1F3FD-200D-2640-FE0F","non_qualified":"1F647-1F3FD-200D-2640","image":"1f647-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F647-1F3FE-200D-2640-FE0F","non_qualified":"1F647-1F3FE-200D-2640","image":"1f647-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F647-1F3FF-200D-2640-FE0F","non_qualified":"1F647-1F3FF-200D-2640","image":"1f647-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Bowing","b":"1F647-200D-2640-FE0F","c":"1F647-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,26],"o":4},"male_sign":{"a":"Male Sign","b":"2642-FE0F","c":"2642","d":false,"e":true,"f":true,"h":true,"k":[53,19],"o":4},"mag_right":{"a":"Right-Pointing Magnifying Glass","b":"1F50E","d":true,"e":true,"f":true,"h":true,"j":["search","zoom","find","detective"],"k":[27,42],"o":2},"japanese_goblin":{"a":"Japanese Goblin","b":"1F47A","d":true,"e":true,"f":true,"h":true,"j":["red","evil","mask","monster","scary","creepy","japanese","goblin"],"k":[23,35],"o":2},"scooter":{"a":"Scooter","b":"1F6F4","d":true,"e":true,"f":true,"h":true,"k":[36,53],"o":4},"bee":{"a":"Honeybee","b":"1F41D","d":true,"e":true,"f":true,"h":true,"k":[12,1],"n":["honeybee"],"o":2},"flag-gn":{"a":"Guinea Flag","b":"1F1EC-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,7],"o":2},"candle":{"a":"Candle","b":"1F56F-FE0F","c":"1F56F","d":true,"e":true,"f":true,"h":true,"j":["fire","wax"],"k":[29,6],"o":2},"skateboard":{"a":"Skateboard","b":"1F6F9","d":true,"e":true,"f":true,"h":true,"k":[37,1],"o":11},"medical_symbol":{"a":"Medical Symbol","b":"2695-FE0F","c":"2695","d":false,"e":true,"f":true,"h":true,"k":[53,44],"n":["staff_of_aesculapius"],"o":4},"ghost":{"a":"Ghost","b":"1F47B","d":true,"e":true,"f":true,"h":true,"j":["halloween","spooky","scary"],"k":[23,36],"o":2},"beetle":{"a":"Lady Beetle","b":"1F41E","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","ladybug"],"k":[12,2],"o":2},"face_palm":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB","non_qualified":null,"image":"1f926-1f3fb.png","sheet_x":38,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F926-1F3FC","non_qualified":null,"image":"1f926-1f3fc.png","sheet_x":38,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F926-1F3FD","non_qualified":null,"image":"1f926-1f3fd.png","sheet_x":38,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F926-1F3FE","non_qualified":null,"image":"1f926-1f3fe.png","sheet_x":38,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F926-1F3FF","non_qualified":null,"image":"1f926-1f3ff.png","sheet_x":38,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Face Palm","b":"1F926","d":true,"e":true,"f":true,"h":false,"k":[38,35],"o":4},"flag-gp":{"a":"Guadeloupe Flag","b":"1F1EC-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[2,8],"o":2},"baby_bottle":{"a":"Baby Bottle","b":"1F37C","d":true,"e":true,"f":true,"h":true,"j":["food","container","milk"],"k":[7,27],"o":2},"infinity":{"a":"Infinity","b":"267E-FE0F","c":"267E","d":true,"e":true,"f":true,"h":true,"k":[53,39],"o":11},"glass_of_milk":{"a":"Glass of Milk","b":"1F95B","d":true,"e":true,"f":true,"h":true,"k":[41,42],"o":4},"man-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2642-FE0F","non_qualified":"1F926-1F3FB-200D-2642","image":"1f926-1f3fb-200d-2642-fe0f.png","sheet_x":38,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F926-1F3FC-200D-2642-FE0F","non_qualified":"1F926-1F3FC-200D-2642","image":"1f926-1f3fc-200d-2642-fe0f.png","sheet_x":38,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F926-1F3FD-200D-2642-FE0F","non_qualified":"1F926-1F3FD-200D-2642","image":"1f926-1f3fd-200d-2642-fe0f.png","sheet_x":38,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F926-1F3FE-200D-2642-FE0F","non_qualified":"1F926-1F3FE-200D-2642","image":"1f926-1f3fe-200d-2642-fe0f.png","sheet_x":38,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F926-1F3FF-200D-2642-FE0F","non_qualified":"1F926-1F3FF-200D-2642","image":"1f926-1f3ff-200d-2642-fe0f.png","sheet_x":38,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Facepalming","b":"1F926-200D-2642-FE0F","c":"1F926-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[38,29],"o":4},"cricket":{"a":"Cricket","b":"1F997","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[42,41],"o":5},"busstop":{"a":"Bus Stop","b":"1F68F","d":true,"e":true,"f":true,"h":true,"j":["transportation","wait"],"k":[34,14],"o":2},"flag-gq":{"a":"Equatorial Guinea Flag","b":"1F1EC-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[2,9],"o":2},"alien":{"a":"Extraterrestrial Alien","b":"1F47D","d":true,"e":true,"f":true,"h":true,"j":["UFO","paul","weird","outer_space"],"k":[23,43],"o":2},"bulb":{"a":"Electric Light Bulb","b":"1F4A1","d":true,"e":true,"f":true,"h":true,"j":["light","electricity","idea"],"k":[25,43],"o":2},"woman-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2640-FE0F","non_qualified":"1F926-1F3FB-200D-2640","image":"1f926-1f3fb-200d-2640-fe0f.png","sheet_x":38,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F926-1F3FC-200D-2640-FE0F","non_qualified":"1F926-1F3FC-200D-2640","image":"1f926-1f3fc-200d-2640-fe0f.png","sheet_x":38,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F926-1F3FD-200D-2640-FE0F","non_qualified":"1F926-1F3FD-200D-2640","image":"1f926-1f3fd-200d-2640-fe0f.png","sheet_x":38,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F926-1F3FE-200D-2640-FE0F","non_qualified":"1F926-1F3FE-200D-2640","image":"1f926-1f3fe-200d-2640-fe0f.png","sheet_x":38,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F926-1F3FF-200D-2640-FE0F","non_qualified":"1F926-1F3FF-200D-2640","image":"1f926-1f3ff-200d-2640-fe0f.png","sheet_x":38,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Facepalming","b":"1F926-200D-2640-FE0F","c":"1F926-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[38,23],"o":4},"spider":{"a":"Spider","b":"1F577-FE0F","c":"1F577","d":true,"e":true,"f":true,"h":true,"j":["animal","arachnid"],"k":[29,34],"o":2},"space_invader":{"a":"Alien Monster","b":"1F47E","d":true,"e":true,"f":true,"h":true,"j":["game","arcade","play"],"k":[23,44],"o":2},"motorway":{"a":"Motorway","b":"1F6E3-FE0F","c":"1F6E3","d":true,"e":true,"f":true,"h":true,"j":["road","cupertino","interstate","highway"],"k":[36,45],"o":2},"flag-gr":{"a":"Greece Flag","b":"1F1EC-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,10],"o":2},"recycle":{"a":"Black Universal Recycling Symbol","b":"267B-FE0F","c":"267B","d":true,"e":true,"f":true,"h":true,"j":["arrow","environment","garbage","trash"],"k":[53,38],"o":2},"coffee":{"a":"Hot Beverage","b":"2615","d":true,"e":true,"f":true,"h":true,"j":["beverage","caffeine","latte","espresso"],"k":[53,0],"o":2},"flashlight":{"a":"Electric Torch","b":"1F526","d":true,"e":true,"f":true,"h":true,"j":["dark","camping","sight","night"],"k":[28,9],"o":2},"spider_web":{"a":"Spider Web","b":"1F578-FE0F","c":"1F578","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","arachnid","silk"],"k":[29,35],"o":2},"izakaya_lantern":{"a":"Izakaya Lantern","b":"1F3EE","d":true,"e":true,"f":true,"h":true,"j":["light","paper","halloween","spooky"],"k":[11,8],"n":["lantern"],"o":2},"flag-gs":{"a":"South Georgia & South Sandwich Islands Flag","b":"1F1EC-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,11],"o":2},"shrug":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB","non_qualified":null,"image":"1f937-1f3fb.png","sheet_x":39,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F937-1F3FC","non_qualified":null,"image":"1f937-1f3fc.png","sheet_x":39,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F937-1F3FD","non_qualified":null,"image":"1f937-1f3fd.png","sheet_x":39,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F937-1F3FE","non_qualified":null,"image":"1f937-1f3fe.png","sheet_x":39,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F937-1F3FF","non_qualified":null,"image":"1f937-1f3ff.png","sheet_x":39,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Shrug","b":"1F937","d":true,"e":true,"f":true,"h":false,"k":[39,47],"o":4},"fleur_de_lis":{"a":"Fleur De Lis","b":"269C-FE0F","c":"269C","d":true,"e":true,"f":true,"h":true,"j":["decorative","scout"],"k":[53,49],"o":2},"robot_face":{"a":"Robot Face","b":"1F916","d":true,"e":true,"f":true,"h":true,"k":[37,29],"o":2},"railway_track":{"a":"Railway Track","b":"1F6E4-FE0F","c":"1F6E4","d":true,"e":true,"f":true,"h":true,"j":["train","transportation"],"k":[36,46],"o":2},"tea":{"a":"Teacup Without Handle","b":"1F375","d":true,"e":true,"f":true,"h":true,"j":["drink","bowl","breakfast","green","british"],"k":[7,20],"o":2},"flag-gt":{"a":"Guatemala Flag","b":"1F1EC-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,12],"o":2},"oil_drum":{"a":"Oil Drum","b":"1F6E2-FE0F","c":"1F6E2","d":true,"e":true,"f":true,"h":true,"j":["barrell"],"k":[36,44],"o":2},"diya_lamp":{"a":"Diya Lamp","b":"1FA94","d":true,"e":true,"f":true,"h":true,"k":[52,8],"o":12},"sake":{"a":"Sake Bottle and Cup","b":"1F376","d":true,"e":true,"f":true,"h":true,"j":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"k":[7,21],"o":2},"trident":{"a":"Trident Emblem","b":"1F531","d":true,"e":true,"f":true,"h":true,"j":["weapon","spear"],"k":[28,20],"o":2},"man-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2642-FE0F","non_qualified":"1F937-1F3FB-200D-2642","image":"1f937-1f3fb-200d-2642-fe0f.png","sheet_x":39,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F937-1F3FC-200D-2642-FE0F","non_qualified":"1F937-1F3FC-200D-2642","image":"1f937-1f3fc-200d-2642-fe0f.png","sheet_x":39,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F937-1F3FD-200D-2642-FE0F","non_qualified":"1F937-1F3FD-200D-2642","image":"1f937-1f3fd-200d-2642-fe0f.png","sheet_x":39,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F937-1F3FE-200D-2642-FE0F","non_qualified":"1F937-1F3FE-200D-2642","image":"1f937-1f3fe-200d-2642-fe0f.png","sheet_x":39,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F937-1F3FF-200D-2642-FE0F","non_qualified":"1F937-1F3FF-200D-2642","image":"1f937-1f3ff-200d-2642-fe0f.png","sheet_x":39,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Shrugging","b":"1F937-200D-2642-FE0F","c":"1F937-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[39,41],"o":4},"smiley_cat":{"a":"Smiling Cat Face with Open Mouth","b":"1F63A","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","happy","smile"],"k":[31,36],"o":2},"scorpion":{"a":"Scorpion","b":"1F982","d":true,"e":true,"f":true,"h":true,"j":["animal","arachnid"],"k":[42,20],"o":2},"woman-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2640-FE0F","non_qualified":"1F937-1F3FB-200D-2640","image":"1f937-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F937-1F3FC-200D-2640-FE0F","non_qualified":"1F937-1F3FC-200D-2640","image":"1f937-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F937-1F3FD-200D-2640-FE0F","non_qualified":"1F937-1F3FD-200D-2640","image":"1f937-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F937-1F3FE-200D-2640-FE0F","non_qualified":"1F937-1F3FE-200D-2640","image":"1f937-1f3fe-200d-2640-fe0f.png","sheet_x":39,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F937-1F3FF-200D-2640-FE0F","non_qualified":"1F937-1F3FF-200D-2640","image":"1f937-1f3ff-200d-2640-fe0f.png","sheet_x":39,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Shrugging","b":"1F937-200D-2640-FE0F","c":"1F937-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[39,35],"o":4},"notebook_with_decorative_cover":{"a":"Notebook with Decorative Cover","b":"1F4D4","d":true,"e":true,"f":true,"h":true,"j":["classroom","notes","record","paper","study"],"k":[26,42],"o":2},"fuelpump":{"a":"Fuel Pump","b":"26FD","d":true,"e":true,"f":true,"h":true,"j":["gas station","petroleum"],"k":[54,38],"o":2},"name_badge":{"a":"Name Badge","b":"1F4DB","d":true,"e":true,"f":true,"h":true,"j":["fire","forbid"],"k":[26,49],"o":2},"mosquito":{"a":"Mosquito","b":"1F99F","d":true,"e":true,"f":true,"h":true,"k":[42,49],"o":11},"flag-gu":{"a":"Guam Flag","b":"1F1EC-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,13],"o":2},"smile_cat":{"a":"Grinning Cat Face with Smiling Eyes","b":"1F638","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","smile"],"k":[31,34],"o":2},"champagne":{"a":"Bottle with Popping Cork","b":"1F37E","d":true,"e":true,"f":true,"h":true,"j":["drink","wine","bottle","celebration"],"k":[7,29],"o":2},"joy_cat":{"a":"Cat Face with Tears of Joy","b":"1F639","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","haha","happy","tears"],"k":[31,35],"o":2},"closed_book":{"a":"Closed Book","b":"1F4D5","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","textbook","learn"],"k":[26,43],"o":2},"health_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2695-FE0F","non_qualified":"1F9D1-1F3FB-200D-2695","image":"1f9d1-1f3fb-200d-2695-fe0f.png","sheet_x":47,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2695-FE0F","non_qualified":"1F9D1-1F3FC-200D-2695","image":"1f9d1-1f3fc-200d-2695-fe0f.png","sheet_x":47,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2695-FE0F","non_qualified":"1F9D1-1F3FD-200D-2695","image":"1f9d1-1f3fd-200d-2695-fe0f.png","sheet_x":47,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2695-FE0F","non_qualified":"1F9D1-1F3FE-200D-2695","image":"1f9d1-1f3fe-200d-2695-fe0f.png","sheet_x":47,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2695-FE0F","non_qualified":"1F9D1-1F3FF-200D-2695","image":"1f9d1-1f3ff-200d-2695-fe0f.png","sheet_x":47,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Health Worker","b":"1F9D1-200D-2695-FE0F","c":"1F9D1-200D-2695","d":true,"e":false,"f":false,"h":false,"k":[47,49],"o":12},"rotating_light":{"a":"Police Cars Revolving Light","b":"1F6A8","d":true,"e":true,"f":true,"h":true,"j":["police","ambulance","911","emergency","alert","error","pinged","law","legal"],"k":[34,56],"o":2},"microbe":{"a":"Microbe","b":"1F9A0","d":true,"e":true,"f":true,"h":true,"k":[42,50],"o":11},"flag-gw":{"a":"Guinea-Bissau Flag","b":"1F1EC-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[2,14],"o":2},"wine_glass":{"a":"Wine Glass","b":"1F377","d":true,"e":true,"f":true,"h":true,"j":["drink","beverage","drunk","alcohol","booze"],"k":[7,22],"o":2},"beginner":{"a":"Japanese Symbol for Beginner","b":"1F530","d":true,"e":true,"f":true,"h":true,"j":["badge","shield"],"k":[28,19],"o":2},"bouquet":{"a":"Bouquet","b":"1F490","d":true,"e":true,"f":true,"h":true,"j":["flowers","nature","spring"],"k":[25,26],"o":2},"heart_eyes_cat":{"a":"Smiling Cat Face with Heart-Shaped Eyes","b":"1F63B","d":true,"e":true,"f":true,"h":true,"j":["animal","love","like","affection","cats","valentines","heart"],"k":[31,37],"o":2},"male-doctor":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2695-FE0F","non_qualified":"1F468-1F3FB-200D-2695","image":"1f468-1f3fb-200d-2695-fe0f.png","sheet_x":17,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2695-FE0F","non_qualified":"1F468-1F3FC-200D-2695","image":"1f468-1f3fc-200d-2695-fe0f.png","sheet_x":17,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2695-FE0F","non_qualified":"1F468-1F3FD-200D-2695","image":"1f468-1f3fd-200d-2695-fe0f.png","sheet_x":17,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2695-FE0F","non_qualified":"1F468-1F3FE-200D-2695","image":"1f468-1f3fe-200d-2695-fe0f.png","sheet_x":17,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2695-FE0F","non_qualified":"1F468-1F3FF-200D-2695","image":"1f468-1f3ff-200d-2695-fe0f.png","sheet_x":17,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Doctor","b":"1F468-200D-2695-FE0F","c":"1F468-200D-2695","d":true,"e":true,"f":true,"h":true,"k":[17,2],"o":4},"book":{"a":"Open Book","b":"1F4D6","d":true,"e":true,"f":true,"h":true,"k":[26,44],"n":["open_book"],"o":2},"traffic_light":{"a":"Horizontal Traffic Light","b":"1F6A5","d":true,"e":true,"f":true,"h":true,"j":["transportation","signal"],"k":[34,53],"o":2},"cocktail":{"a":"Cocktail Glass","b":"1F378","d":true,"e":true,"f":true,"h":true,"j":["drink","drunk","alcohol","beverage","booze","mojito"],"k":[7,23],"o":2},"o":{"a":"Heavy Large Circle","b":"2B55","d":true,"e":true,"f":true,"h":true,"j":["circle","round"],"k":[55,43],"o":2},"flag-gy":{"a":"Guyana Flag","b":"1F1EC-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[2,15],"o":2},"female-doctor":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2695-FE0F","non_qualified":"1F469-1F3FB-200D-2695","image":"1f469-1f3fb-200d-2695-fe0f.png","sheet_x":19,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2695-FE0F","non_qualified":"1F469-1F3FC-200D-2695","image":"1f469-1f3fc-200d-2695-fe0f.png","sheet_x":19,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2695-FE0F","non_qualified":"1F469-1F3FD-200D-2695","image":"1f469-1f3fd-200d-2695-fe0f.png","sheet_x":19,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2695-FE0F","non_qualified":"1F469-1F3FE-200D-2695","image":"1f469-1f3fe-200d-2695-fe0f.png","sheet_x":19,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2695-FE0F","non_qualified":"1F469-1F3FF-200D-2695","image":"1f469-1f3ff-200d-2695-fe0f.png","sheet_x":19,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Doctor","b":"1F469-200D-2695-FE0F","c":"1F469-200D-2695","d":true,"e":true,"f":true,"h":true,"k":[19,44],"o":4},"smirk_cat":{"a":"Cat Face with Wry Smile","b":"1F63C","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","smirk"],"k":[31,38],"o":2},"green_book":{"a":"Green Book","b":"1F4D7","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","study"],"k":[26,45],"o":2},"cherry_blossom":{"a":"Cherry Blossom","b":"1F338","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","spring","flower"],"k":[6,16],"o":2},"flag-hk":{"a":"Hong Kong Sar China Flag","b":"1F1ED-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[2,16],"o":2},"vertical_traffic_light":{"a":"Vertical Traffic Light","b":"1F6A6","d":true,"e":true,"f":true,"h":true,"j":["transportation","driving"],"k":[34,54],"o":2},"white_check_mark":{"a":"White Heavy Check Mark","b":"2705","d":true,"e":true,"f":true,"h":true,"j":["green-square","ok","agree","vote","election","answer","tick"],"k":[54,40],"o":2},"tropical_drink":{"a":"Tropical Drink","b":"1F379","d":true,"e":true,"f":true,"h":true,"j":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"k":[7,24],"o":2},"kissing_cat":{"a":"Kissing Cat Face with Closed Eyes","b":"1F63D","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","kiss"],"k":[31,39],"o":2},"flag-hm":{"a":"Heard & Mcdonald Islands Flag","b":"1F1ED-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,17],"o":2},"octagonal_sign":{"a":"Octagonal Sign","b":"1F6D1","d":true,"e":true,"f":true,"h":true,"k":[36,39],"o":4},"white_flower":{"a":"White Flower","b":"1F4AE","d":true,"e":true,"f":true,"h":true,"j":["japanese","spring"],"k":[26,4],"o":2},"ballot_box_with_check":{"a":"Ballot Box with Check","b":"2611-FE0F","c":"2611","d":true,"e":true,"f":true,"h":true,"j":["ok","agree","confirm","black-square","vote","election","yes","tick"],"k":[52,55],"o":2},"student":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f393.png","sheet_x":45,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f393.png","sheet_x":45,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f393.png","sheet_x":45,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f393.png","sheet_x":45,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F393","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f393.png","sheet_x":45,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Student","b":"1F9D1-200D-1F393","d":true,"e":false,"f":false,"h":false,"k":[45,29],"o":12},"blue_book":{"a":"Blue Book","b":"1F4D8","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","learn","study"],"k":[26,46],"o":2},"beer":{"a":"Beer Mug","b":"1F37A","d":true,"e":true,"f":true,"h":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[7,25],"o":2},"construction":{"a":"Construction Sign","b":"1F6A7","d":true,"e":true,"f":true,"h":true,"j":["wip","progress","caution","warning"],"k":[34,55],"o":2},"rosette":{"a":"Rosette","b":"1F3F5-FE0F","c":"1F3F5","d":true,"e":true,"f":true,"h":true,"j":["flower","decoration","military"],"k":[11,18],"o":2},"heavy_check_mark":{"a":"Heavy Check Mark","b":"2714-FE0F","c":"2714","d":true,"e":true,"f":true,"h":true,"j":["ok","nike","answer","yes","tick"],"k":[55,12],"o":2},"scream_cat":{"a":"Weary Cat Face","b":"1F640","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","munch","scared","scream"],"k":[31,42],"o":2},"orange_book":{"a":"Orange Book","b":"1F4D9","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","textbook","study"],"k":[26,47],"o":2},"beers":{"a":"Clinking Beer Mugs","b":"1F37B","d":true,"e":true,"f":true,"h":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[7,26],"o":2},"male-student":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F393","non_qualified":null,"image":"1f468-1f3fb-200d-1f393.png","sheet_x":14,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F393","non_qualified":null,"image":"1f468-1f3fc-200d-1f393.png","sheet_x":14,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F393","non_qualified":null,"image":"1f468-1f3fd-200d-1f393.png","sheet_x":14,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F393","non_qualified":null,"image":"1f468-1f3fe-200d-1f393.png","sheet_x":14,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F393","non_qualified":null,"image":"1f468-1f3ff-200d-1f393.png","sheet_x":14,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Student","b":"1F468-200D-1F393","d":true,"e":true,"f":true,"h":true,"k":[14,50],"o":4},"flag-hn":{"a":"Honduras Flag","b":"1F1ED-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,18],"o":2},"crying_cat_face":{"a":"Crying Cat Face","b":"1F63F","d":true,"e":true,"f":true,"h":true,"j":["animal","tears","weep","sad","cats","upset","cry"],"k":[31,41],"o":2},"anchor":{"a":"Anchor","b":"2693","d":true,"e":true,"f":true,"h":true,"j":["ship","ferry","sea","boat"],"k":[53,42],"o":2},"flag-hr":{"a":"Croatia Flag","b":"1F1ED-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,19],"o":2},"heavy_multiplication_x":{"a":"Heavy Multiplication X","b":"2716-FE0F","c":"2716","d":true,"e":true,"f":true,"h":true,"j":["math","calculation"],"k":[55,13],"o":2},"female-student":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F393","non_qualified":null,"image":"1f469-1f3fb-200d-1f393.png","sheet_x":17,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F393","non_qualified":null,"image":"1f469-1f3fc-200d-1f393.png","sheet_x":17,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F393","non_qualified":null,"image":"1f469-1f3fd-200d-1f393.png","sheet_x":17,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F393","non_qualified":null,"image":"1f469-1f3fe-200d-1f393.png","sheet_x":17,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F393","non_qualified":null,"image":"1f469-1f3ff-200d-1f393.png","sheet_x":17,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Student","b":"1F469-200D-1F393","d":true,"e":true,"f":true,"h":true,"k":[17,40],"o":4},"rose":{"a":"Rose","b":"1F339","d":true,"e":true,"f":true,"h":true,"j":["flowers","valentines","love","spring"],"k":[6,17],"o":2},"books":{"a":"Books","b":"1F4DA","d":true,"e":true,"f":true,"h":true,"j":["literature","library","study"],"k":[26,48],"o":2},"clinking_glasses":{"a":"Clinking Glasses","b":"1F942","d":true,"e":true,"f":true,"h":true,"j":["beverage","drink","party","alcohol","celebrate","cheers"],"k":[41,18],"o":4},"teacher":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3eb.png","sheet_x":45,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3eb.png","sheet_x":45,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3eb.png","sheet_x":45,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3eb.png","sheet_x":45,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3eb.png","sheet_x":45,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Teacher","b":"1F9D1-200D-1F3EB","d":true,"e":false,"f":false,"h":false,"k":[45,47],"o":12},"x":{"a":"Cross Mark","b":"274C","d":true,"e":true,"f":true,"h":true,"j":["no","delete","remove","cancel"],"k":[55,21],"o":2},"pouting_cat":{"a":"Pouting Cat Face","b":"1F63E","d":true,"e":true,"f":true,"h":true,"j":["animal","cats"],"k":[31,40],"o":2},"wilted_flower":{"a":"Wilted Flower","b":"1F940","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","flower"],"k":[41,16],"o":4},"boat":{"a":"Sailboat","b":"26F5","d":true,"e":true,"f":true,"h":true,"k":[54,16],"n":["sailboat"],"o":2},"flag-ht":{"a":"Haiti Flag","b":"1F1ED-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,20],"o":2},"tumbler_glass":{"a":"Tumbler Glass","b":"1F943","d":true,"e":true,"f":true,"h":true,"j":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","glass","shot"],"k":[41,19],"o":4},"notebook":{"a":"Notebook","b":"1F4D3","d":true,"e":true,"f":true,"h":true,"j":["stationery","record","notes","paper","study"],"k":[26,41],"o":2},"male-teacher":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fb-200d-1f3eb.png","sheet_x":15,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fc-200d-1f3eb.png","sheet_x":15,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fd-200d-1f3eb.png","sheet_x":15,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fe-200d-1f3eb.png","sheet_x":15,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f468-1f3ff-200d-1f3eb.png","sheet_x":15,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Teacher","b":"1F468-200D-1F3EB","d":true,"e":true,"f":true,"h":true,"k":[15,11],"o":4},"ledger":{"a":"Ledger","b":"1F4D2","d":true,"e":true,"f":true,"h":true,"j":["notes","paper"],"k":[26,40],"o":2},"flag-hu":{"a":"Hungary Flag","b":"1F1ED-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,21],"o":2},"cup_with_straw":{"a":"Cup with Straw","b":"1F964","d":true,"e":true,"f":true,"h":true,"k":[41,51],"o":5},"hibiscus":{"a":"Hibiscus","b":"1F33A","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable","flowers","beach"],"k":[6,18],"o":2},"see_no_evil":{"a":"See-No-Evil Monkey","b":"1F648","d":true,"e":true,"f":true,"h":true,"j":["monkey","animal","nature","haha"],"k":[32,44],"o":2},"canoe":{"a":"Canoe","b":"1F6F6","d":true,"e":true,"f":true,"h":true,"j":["boat","paddle","water","ship"],"k":[36,55],"o":4},"negative_squared_cross_mark":{"a":"Negative Squared Cross Mark","b":"274E","d":true,"e":true,"f":true,"h":true,"j":["x","green-square","no","deny"],"k":[55,22],"o":2},"flag-ic":{"a":"Canary Islands Flag","b":"1F1EE-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[2,22],"o":2},"beverage_box":{"a":"Beverage Box","b":"1F9C3","d":true,"e":true,"f":true,"h":true,"k":[44,11],"o":12},"speedboat":{"a":"Speedboat","b":"1F6A4","d":true,"e":true,"f":true,"h":true,"j":["ship","transportation","vehicle","summer"],"k":[34,52],"o":2},"heavy_plus_sign":{"a":"Heavy Plus Sign","b":"2795","d":true,"e":true,"f":true,"h":true,"j":["math","calculation","addition","more","increase"],"k":[55,29],"o":2},"sunflower":{"a":"Sunflower","b":"1F33B","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","fall"],"k":[6,19],"o":2},"page_with_curl":{"a":"Page with Curl","b":"1F4C3","d":true,"e":true,"f":true,"h":true,"j":["documents","office","paper"],"k":[26,25],"o":2},"female-teacher":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fb-200d-1f3eb.png","sheet_x":18,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fc-200d-1f3eb.png","sheet_x":18,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fd-200d-1f3eb.png","sheet_x":18,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fe-200d-1f3eb.png","sheet_x":18,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f469-1f3ff-200d-1f3eb.png","sheet_x":18,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Teacher","b":"1F469-200D-1F3EB","d":true,"e":true,"f":true,"h":true,"k":[18,1],"o":4},"hear_no_evil":{"a":"Hear-No-Evil Monkey","b":"1F649","d":true,"e":true,"f":true,"h":true,"j":["animal","monkey","nature"],"k":[32,45],"o":2},"mate_drink":{"a":"Mate Drink","b":"1F9C9","d":true,"e":true,"f":true,"h":true,"k":[44,17],"o":12},"passenger_ship":{"a":"Passenger Ship","b":"1F6F3-FE0F","c":"1F6F3","d":true,"e":true,"f":true,"h":true,"j":["yacht","cruise","ferry"],"k":[36,52],"o":2},"judge":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2696-FE0F","non_qualified":"1F9D1-1F3FB-200D-2696","image":"1f9d1-1f3fb-200d-2696-fe0f.png","sheet_x":47,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2696-FE0F","non_qualified":"1F9D1-1F3FC-200D-2696","image":"1f9d1-1f3fc-200d-2696-fe0f.png","sheet_x":48,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2696-FE0F","non_qualified":"1F9D1-1F3FD-200D-2696","image":"1f9d1-1f3fd-200d-2696-fe0f.png","sheet_x":48,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2696-FE0F","non_qualified":"1F9D1-1F3FE-200D-2696","image":"1f9d1-1f3fe-200d-2696-fe0f.png","sheet_x":48,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2696-FE0F","non_qualified":"1F9D1-1F3FF-200D-2696","image":"1f9d1-1f3ff-200d-2696-fe0f.png","sheet_x":48,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Judge","b":"1F9D1-200D-2696-FE0F","c":"1F9D1-200D-2696","d":true,"e":false,"f":false,"h":false,"k":[47,55],"o":12},"scroll":{"a":"Scroll","b":"1F4DC","d":true,"e":true,"f":true,"h":true,"j":["documents","ancient","history","paper"],"k":[26,50],"o":2},"blossom":{"a":"Blossom","b":"1F33C","d":true,"e":true,"f":true,"h":true,"j":["nature","flowers","yellow"],"k":[6,20],"o":2},"flag-id":{"a":"Indonesia Flag","b":"1F1EE-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[2,23],"o":2},"speak_no_evil":{"a":"Speak-No-Evil Monkey","b":"1F64A","d":true,"e":true,"f":true,"h":true,"j":["monkey","animal","nature","omg"],"k":[32,46],"o":2},"heavy_minus_sign":{"a":"Heavy Minus Sign","b":"2796","d":true,"e":true,"f":true,"h":true,"j":["math","calculation","subtract","less"],"k":[55,30],"o":2},"flag-ie":{"a":"Ireland Flag","b":"1F1EE-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,24],"o":2},"ice_cube":{"a":"Ice Cube","b":"1F9CA","d":true,"e":true,"f":true,"h":true,"k":[44,18],"o":12},"page_facing_up":{"a":"Page Facing Up","b":"1F4C4","d":true,"e":true,"f":true,"h":true,"j":["documents","office","paper","information"],"k":[26,26],"o":2},"male-judge":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2696-FE0F","non_qualified":"1F468-1F3FB-200D-2696","image":"1f468-1f3fb-200d-2696-fe0f.png","sheet_x":17,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2696-FE0F","non_qualified":"1F468-1F3FC-200D-2696","image":"1f468-1f3fc-200d-2696-fe0f.png","sheet_x":17,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2696-FE0F","non_qualified":"1F468-1F3FD-200D-2696","image":"1f468-1f3fd-200d-2696-fe0f.png","sheet_x":17,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2696-FE0F","non_qualified":"1F468-1F3FE-200D-2696","image":"1f468-1f3fe-200d-2696-fe0f.png","sheet_x":17,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2696-FE0F","non_qualified":"1F468-1F3FF-200D-2696","image":"1f468-1f3ff-200d-2696-fe0f.png","sheet_x":17,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Judge","b":"1F468-200D-2696-FE0F","c":"1F468-200D-2696","d":true,"e":true,"f":true,"h":true,"k":[17,8],"o":4},"tulip":{"a":"Tulip","b":"1F337","d":true,"e":true,"f":true,"h":true,"j":["flowers","plant","nature","summer","spring"],"k":[6,15],"o":2},"ferry":{"a":"Ferry","b":"26F4-FE0F","c":"26F4","d":true,"e":true,"f":true,"h":true,"j":["boat","ship","yacht"],"k":[54,15],"o":2},"kiss":{"a":"Kiss Mark","b":"1F48B","d":true,"e":true,"f":true,"h":true,"j":["face","lips","love","like","affection","valentines"],"k":[25,21],"o":2},"heavy_division_sign":{"a":"Heavy Division Sign","b":"2797","d":true,"e":true,"f":true,"h":true,"j":["divide","math","calculation"],"k":[55,31],"o":2},"newspaper":{"a":"Newspaper","b":"1F4F0","d":true,"e":true,"f":true,"h":true,"j":["press","headline"],"k":[27,13],"o":2},"female-judge":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2696-FE0F","non_qualified":"1F469-1F3FB-200D-2696","image":"1f469-1f3fb-200d-2696-fe0f.png","sheet_x":19,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2696-FE0F","non_qualified":"1F469-1F3FC-200D-2696","image":"1f469-1f3fc-200d-2696-fe0f.png","sheet_x":19,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2696-FE0F","non_qualified":"1F469-1F3FD-200D-2696","image":"1f469-1f3fd-200d-2696-fe0f.png","sheet_x":19,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2696-FE0F","non_qualified":"1F469-1F3FE-200D-2696","image":"1f469-1f3fe-200d-2696-fe0f.png","sheet_x":19,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2696-FE0F","non_qualified":"1F469-1F3FF-200D-2696","image":"1f469-1f3ff-200d-2696-fe0f.png","sheet_x":19,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Judge","b":"1F469-200D-2696-FE0F","c":"1F469-200D-2696","d":true,"e":true,"f":true,"h":true,"k":[19,50],"o":4},"seedling":{"a":"Seedling","b":"1F331","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","grass","lawn","spring"],"k":[6,9],"o":2},"love_letter":{"a":"Love Letter","b":"1F48C","d":true,"e":true,"f":true,"h":true,"j":["email","like","affection","envelope","valentines"],"k":[25,22],"o":2},"chopsticks":{"a":"Chopsticks","b":"1F962","d":true,"e":true,"f":true,"h":true,"k":[41,49],"o":5},"motor_boat":{"a":"Motor Boat","b":"1F6E5-FE0F","c":"1F6E5","d":true,"e":true,"f":true,"h":true,"j":["ship"],"k":[36,47],"o":2},"flag-il":{"a":"Israel Flag","b":"1F1EE-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[2,25],"o":2},"curly_loop":{"a":"Curly Loop","b":"27B0","d":true,"e":true,"f":true,"h":true,"j":["scribble","draw","shape","squiggle"],"k":[55,33],"o":2},"flag-im":{"a":"Isle of Man Flag","b":"1F1EE-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,26],"o":2},"evergreen_tree":{"a":"Evergreen Tree","b":"1F332","d":true,"e":true,"f":true,"h":true,"j":["plant","nature"],"k":[6,10],"o":2},"cupid":{"a":"Heart with Arrow","b":"1F498","d":true,"e":true,"f":true,"h":true,"j":["love","like","heart","affection","valentines"],"k":[25,34],"o":2},"loop":{"a":"Double Curly Loop","b":"27BF","d":true,"e":true,"f":true,"h":true,"j":["tape","cassette"],"k":[55,34],"o":2},"ship":{"a":"Ship","b":"1F6A2","d":true,"e":true,"f":true,"h":true,"j":["transportation","titanic","deploy"],"k":[34,33],"o":2},"farmer":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f33e.png","sheet_x":45,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f33e.png","sheet_x":45,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f33e.png","sheet_x":45,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f33e.png","sheet_x":45,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f33e.png","sheet_x":45,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Farmer","b":"1F9D1-200D-1F33E","d":true,"e":false,"f":false,"h":false,"k":[45,17],"o":12},"rolled_up_newspaper":{"a":"Rolled Up Newspaper","b":"1F5DE-FE0F","c":"1F5DE","d":true,"e":true,"f":true,"h":true,"k":[30,23],"o":2},"knife_fork_plate":{"a":"Knife Fork Plate","b":"1F37D-FE0F","c":"1F37D","d":true,"e":true,"f":true,"h":true,"k":[7,28],"o":2},"fork_and_knife":{"a":"Fork and Knife","b":"1F374","d":true,"e":true,"f":true,"h":true,"j":["cutlery","kitchen"],"k":[7,19],"o":2},"male-farmer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F33E","non_qualified":null,"image":"1f468-1f3fb-200d-1f33e.png","sheet_x":14,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F33E","non_qualified":null,"image":"1f468-1f3fc-200d-1f33e.png","sheet_x":14,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F33E","non_qualified":null,"image":"1f468-1f3fd-200d-1f33e.png","sheet_x":14,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F33E","non_qualified":null,"image":"1f468-1f3fe-200d-1f33e.png","sheet_x":14,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F33E","non_qualified":null,"image":"1f468-1f3ff-200d-1f33e.png","sheet_x":14,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Farmer","b":"1F468-200D-1F33E","d":true,"e":true,"f":true,"h":true,"k":[14,38],"o":4},"bookmark_tabs":{"a":"Bookmark Tabs","b":"1F4D1","d":true,"e":true,"f":true,"h":true,"j":["favorite","save","order","tidy"],"k":[26,39],"o":2},"part_alternation_mark":{"a":"Part Alternation Mark","b":"303D-FE0F","c":"303D","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","business","economics","bad"],"k":[55,45],"o":2},"flag-in":{"a":"India Flag","b":"1F1EE-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,27],"o":2},"gift_heart":{"a":"Heart with Ribbon","b":"1F49D","d":true,"e":true,"f":true,"h":true,"j":["love","valentines"],"k":[25,39],"o":2},"airplane":{"a":"Airplane","b":"2708-FE0F","c":"2708","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation","flight","fly"],"k":[54,41],"o":2},"deciduous_tree":{"a":"Deciduous Tree","b":"1F333","d":true,"e":true,"f":true,"h":true,"j":["plant","nature"],"k":[6,11],"o":2},"spoon":{"a":"Spoon","b":"1F944","d":true,"e":true,"f":true,"h":true,"j":["cutlery","kitchen","tableware"],"k":[41,20],"o":4},"flag-io":{"a":"British Indian Ocean Territory Flag","b":"1F1EE-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[2,28],"o":2},"palm_tree":{"a":"Palm Tree","b":"1F334","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable","nature","summer","beach","mojito","tropical"],"k":[6,12],"o":2},"sparkling_heart":{"a":"Sparkling Heart","b":"1F496","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,32],"o":2},"female-farmer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F33E","non_qualified":null,"image":"1f469-1f3fb-200d-1f33e.png","sheet_x":17,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F33E","non_qualified":null,"image":"1f469-1f3fc-200d-1f33e.png","sheet_x":17,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F33E","non_qualified":null,"image":"1f469-1f3fd-200d-1f33e.png","sheet_x":17,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F33E","non_qualified":null,"image":"1f469-1f3fe-200d-1f33e.png","sheet_x":17,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F33E","non_qualified":null,"image":"1f469-1f3ff-200d-1f33e.png","sheet_x":17,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Farmer","b":"1F469-200D-1F33E","d":true,"e":true,"f":true,"h":true,"k":[17,28],"o":4},"eight_spoked_asterisk":{"a":"Eight Spoked Asterisk","b":"2733-FE0F","c":"2733","d":true,"e":true,"f":true,"h":true,"j":["star","sparkle","green-square"],"k":[55,17],"o":2},"small_airplane":{"a":"Small Airplane","b":"1F6E9-FE0F","c":"1F6E9","d":true,"e":true,"f":true,"h":true,"j":["flight","transportation","fly","vehicle"],"k":[36,48],"o":2},"bookmark":{"a":"Bookmark","b":"1F516","d":true,"e":true,"f":true,"h":true,"j":["favorite","label","save"],"k":[27,50],"o":2},"cook":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f373.png","sheet_x":45,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f373.png","sheet_x":45,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f373.png","sheet_x":45,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f373.png","sheet_x":45,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F373","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f373.png","sheet_x":45,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Cook","b":"1F9D1-200D-1F373","d":true,"e":false,"f":false,"h":false,"k":[45,23],"o":12},"eight_pointed_black_star":{"a":"Eight Pointed Black Star","b":"2734-FE0F","c":"2734","d":true,"e":true,"f":true,"h":true,"j":["orange-square","shape","polygon"],"k":[55,18],"o":2},"heartpulse":{"a":"Growing Heart","b":"1F497","d":true,"e":true,"f":true,"h":true,"j":["like","love","affection","valentines","pink"],"k":[25,33],"o":2},"label":{"a":"Label","b":"1F3F7-FE0F","c":"1F3F7","d":true,"e":true,"f":true,"h":true,"j":["sale","tag"],"k":[11,19],"o":2},"flag-iq":{"a":"Iraq Flag","b":"1F1EE-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[2,29],"o":2},"hocho":{"a":"Hocho","b":"1F52A","d":true,"e":true,"f":true,"h":true,"j":["knife","blade","cutlery","kitchen","weapon"],"k":[28,13],"n":["knife"],"o":2},"cactus":{"a":"Cactus","b":"1F335","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature"],"k":[6,13],"o":2},"airplane_departure":{"a":"Airplane Departure","b":"1F6EB","d":true,"e":true,"f":true,"h":true,"k":[36,49],"o":2},"airplane_arriving":{"a":"Airplane Arriving","b":"1F6EC","d":true,"e":true,"f":true,"h":true,"k":[36,50],"o":2},"ear_of_rice":{"a":"Ear of Rice","b":"1F33E","d":true,"e":true,"f":true,"h":true,"j":["nature","plant"],"k":[6,22],"o":2},"flag-ir":{"a":"Iran Flag","b":"1F1EE-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,30],"o":2},"moneybag":{"a":"Money Bag","b":"1F4B0","d":true,"e":true,"f":true,"h":true,"j":["dollar","payment","coins","sale"],"k":[26,6],"o":2},"male-cook":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F373","non_qualified":null,"image":"1f468-1f3fb-200d-1f373.png","sheet_x":14,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F373","non_qualified":null,"image":"1f468-1f3fc-200d-1f373.png","sheet_x":14,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F373","non_qualified":null,"image":"1f468-1f3fd-200d-1f373.png","sheet_x":14,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F373","non_qualified":null,"image":"1f468-1f3fe-200d-1f373.png","sheet_x":14,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F373","non_qualified":null,"image":"1f468-1f3ff-200d-1f373.png","sheet_x":14,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Cook","b":"1F468-200D-1F373","d":true,"e":true,"f":true,"h":true,"k":[14,44],"o":4},"heartbeat":{"a":"Beating Heart","b":"1F493","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines","pink","heart"],"k":[25,29],"o":2},"sparkle":{"a":"Sparkle","b":"2747-FE0F","c":"2747","d":true,"e":true,"f":true,"h":true,"j":["stars","green-square","awesome","good","fireworks"],"k":[55,20],"o":2},"amphora":{"a":"Amphora","b":"1F3FA","d":true,"e":true,"f":true,"h":true,"j":["vase","jar"],"k":[11,22],"o":2},"yen":{"a":"Banknote with Yen Sign","b":"1F4B4","d":true,"e":true,"f":true,"h":true,"j":["money","sales","japanese","dollar","currency"],"k":[26,10],"o":2},"revolving_hearts":{"a":"Revolving Hearts","b":"1F49E","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,40],"o":2},"bangbang":{"a":"Double Exclamation Mark","b":"203C-FE0F","c":"203C","d":true,"e":true,"f":true,"h":true,"j":["exclamation","surprise"],"k":[52,10],"o":2},"parachute":{"a":"Parachute","b":"1FA82","d":true,"e":true,"f":true,"h":true,"k":[52,3],"o":12},"herb":{"a":"Herb","b":"1F33F","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","medicine","weed","grass","lawn"],"k":[6,23],"o":2},"flag-is":{"a":"Iceland Flag","b":"1F1EE-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,31],"o":2},"female-cook":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F373","non_qualified":null,"image":"1f469-1f3fb-200d-1f373.png","sheet_x":17,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F373","non_qualified":null,"image":"1f469-1f3fc-200d-1f373.png","sheet_x":17,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F373","non_qualified":null,"image":"1f469-1f3fd-200d-1f373.png","sheet_x":17,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F373","non_qualified":null,"image":"1f469-1f3fe-200d-1f373.png","sheet_x":17,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F373","non_qualified":null,"image":"1f469-1f3ff-200d-1f373.png","sheet_x":17,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Cook","b":"1F469-200D-1F373","d":true,"e":true,"f":true,"h":true,"k":[17,34],"o":4},"mechanic":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f527.png","sheet_x":46,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f527.png","sheet_x":46,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f527.png","sheet_x":46,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f527.png","sheet_x":46,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F527","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f527.png","sheet_x":46,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Mechanic","b":"1F9D1-200D-1F527","d":true,"e":false,"f":false,"h":false,"k":[46,14],"o":12},"interrobang":{"a":"Exclamation Question Mark","b":"2049-FE0F","c":"2049","d":true,"e":true,"f":true,"h":true,"j":["wat","punctuation","surprise"],"k":[52,11],"o":2},"seat":{"a":"Seat","b":"1F4BA","d":true,"e":true,"f":true,"h":true,"j":["sit","airplane","transport","bus","flight","fly"],"k":[26,16],"o":2},"dollar":{"a":"Banknote with Dollar Sign","b":"1F4B5","d":true,"e":true,"f":true,"h":true,"j":["money","sales","bill","currency"],"k":[26,11],"o":2},"two_hearts":{"a":"Two Hearts","b":"1F495","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines","heart"],"k":[25,31],"o":2},"it":{"a":"Italy Flag","b":"1F1EE-1F1F9","d":true,"e":true,"f":true,"h":true,"j":["italy","flag","nation","country","banner"],"k":[2,32],"n":["flag-it"],"o":2},"shamrock":{"a":"Shamrock","b":"2618-FE0F","c":"2618","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature","irish","clover"],"k":[53,1],"o":2},"four_leaf_clover":{"a":"Four Leaf Clover","b":"1F340","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature","lucky","irish"],"k":[6,24],"o":2},"euro":{"a":"Banknote with Euro Sign","b":"1F4B6","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","currency"],"k":[26,12],"o":2},"question":{"a":"Black Question Mark Ornament","b":"2753","d":true,"e":true,"f":true,"h":true,"j":["doubt","confused"],"k":[55,23],"o":2},"helicopter":{"a":"Helicopter","b":"1F681","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","fly"],"k":[34,0],"o":2},"heart_decoration":{"a":"Heart Decoration","b":"1F49F","d":true,"e":true,"f":true,"h":true,"j":["purple-square","love","like"],"k":[25,41],"o":2},"flag-je":{"a":"Jersey Flag","b":"1F1EF-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,33],"o":2},"male-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F527","non_qualified":null,"image":"1f468-1f3fb-200d-1f527.png","sheet_x":15,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F527","non_qualified":null,"image":"1f468-1f3fc-200d-1f527.png","sheet_x":15,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F527","non_qualified":null,"image":"1f468-1f3fd-200d-1f527.png","sheet_x":15,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F527","non_qualified":null,"image":"1f468-1f3fe-200d-1f527.png","sheet_x":15,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F527","non_qualified":null,"image":"1f468-1f3ff-200d-1f527.png","sheet_x":15,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Mechanic","b":"1F468-200D-1F527","d":true,"e":true,"f":true,"h":true,"k":[15,50],"o":4},"suspension_railway":{"a":"Suspension Railway","b":"1F69F","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation"],"k":[34,30],"o":2},"heavy_heart_exclamation_mark_ornament":{"a":"Heavy Heart Exclamation Mark Ornament","b":"2763-FE0F","c":"2763","d":true,"e":true,"f":true,"h":true,"k":[55,27],"o":2},"female-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F527","non_qualified":null,"image":"1f469-1f3fb-200d-1f527.png","sheet_x":18,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F527","non_qualified":null,"image":"1f469-1f3fc-200d-1f527.png","sheet_x":18,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F527","non_qualified":null,"image":"1f469-1f3fd-200d-1f527.png","sheet_x":18,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F527","non_qualified":null,"image":"1f469-1f3fe-200d-1f527.png","sheet_x":18,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F527","non_qualified":null,"image":"1f469-1f3ff-200d-1f527.png","sheet_x":18,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Mechanic","b":"1F469-200D-1F527","d":true,"e":true,"f":true,"h":true,"k":[18,35],"o":4},"flag-jm":{"a":"Jamaica Flag","b":"1F1EF-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,34],"o":2},"grey_question":{"a":"White Question Mark Ornament","b":"2754","d":true,"e":true,"f":true,"h":true,"j":["doubts","gray","huh","confused"],"k":[55,24],"o":2},"maple_leaf":{"a":"Maple Leaf","b":"1F341","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","vegetable","ca","fall"],"k":[6,25],"o":2},"pound":{"a":"Banknote with Pound Sign","b":"1F4B7","d":true,"e":true,"f":true,"h":true,"j":["british","sterling","money","sales","bills","uk","england","currency"],"k":[26,13],"o":2},"money_with_wings":{"a":"Money with Wings","b":"1F4B8","d":true,"e":true,"f":true,"h":true,"j":["dollar","bills","payment","sale"],"k":[26,14],"o":2},"flag-jo":{"a":"Jordan Flag","b":"1F1EF-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[2,35],"o":2},"fallen_leaf":{"a":"Fallen Leaf","b":"1F342","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","vegetable","leaves"],"k":[6,26],"o":2},"factory_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3ed.png","sheet_x":45,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3ed.png","sheet_x":45,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3ed.png","sheet_x":45,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3ed.png","sheet_x":46,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3ed.png","sheet_x":46,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Factory Worker","b":"1F9D1-200D-1F3ED","d":true,"e":false,"f":false,"h":false,"k":[45,53],"o":12},"broken_heart":{"a":"Broken Heart","b":"1F494","d":true,"e":true,"f":true,"h":true,"j":["sad","sorry","break","heart","heartbreak"],"k":[25,30],"l":["</3"],"m":"</3","o":2},"grey_exclamation":{"a":"White Exclamation Mark Ornament","b":"2755","d":true,"e":true,"f":true,"h":true,"j":["surprise","punctuation","gray","wow","warning"],"k":[55,25],"o":2},"mountain_cableway":{"a":"Mountain Cableway","b":"1F6A0","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","ski"],"k":[34,31],"o":2},"exclamation":{"a":"Heavy Exclamation Mark Symbol","b":"2757","d":true,"e":true,"f":true,"h":true,"j":["heavy_exclamation_mark","danger","surprise","punctuation","wow","warning"],"k":[55,26],"n":["heavy_exclamation_mark"],"o":2},"leaves":{"a":"Leaf Fluttering in Wind","b":"1F343","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","tree","vegetable","grass","lawn","spring"],"k":[6,27],"o":2},"heart":{"a":"Heavy Black Heart","b":"2764-FE0F","c":"2764","d":true,"e":true,"f":true,"h":true,"j":["love","like","valentines"],"k":[55,28],"l":["<3"],"m":"<3","o":2},"jp":{"a":"Japan Flag","b":"1F1EF-1F1F5","d":true,"e":true,"f":true,"h":true,"j":["japanese","nation","flag","country","banner"],"k":[2,36],"n":["flag-jp"],"o":2},"male-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fb-200d-1f3ed.png","sheet_x":15,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fc-200d-1f3ed.png","sheet_x":15,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fd-200d-1f3ed.png","sheet_x":15,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fe-200d-1f3ed.png","sheet_x":15,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f468-1f3ff-200d-1f3ed.png","sheet_x":15,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Factory Worker","b":"1F468-200D-1F3ED","d":true,"e":true,"f":true,"h":true,"k":[15,17],"o":4},"credit_card":{"a":"Credit Card","b":"1F4B3","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","bill","payment","shopping"],"k":[26,9],"o":2},"aerial_tramway":{"a":"Aerial Tramway","b":"1F6A1","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","ski"],"k":[34,32],"o":2},"female-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fb-200d-1f3ed.png","sheet_x":18,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fc-200d-1f3ed.png","sheet_x":18,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fd-200d-1f3ed.png","sheet_x":18,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fe-200d-1f3ed.png","sheet_x":18,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f469-1f3ff-200d-1f3ed.png","sheet_x":18,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Factory Worker","b":"1F469-200D-1F3ED","d":true,"e":true,"f":true,"h":true,"k":[18,7],"o":4},"receipt":{"a":"Receipt","b":"1F9FE","d":true,"e":true,"f":true,"h":true,"k":[51,49],"o":11},"wavy_dash":{"a":"Wavy Dash","b":"3030-FE0F","c":"3030","d":true,"e":true,"f":true,"h":true,"j":["draw","line","moustache","mustache","squiggle","scribble"],"k":[55,44],"o":2},"flag-ke":{"a":"Kenya Flag","b":"1F1F0-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,37],"o":2},"satellite":{"a":"Satellite","b":"1F6F0-FE0F","c":"1F6F0","d":true,"e":true,"f":true,"h":true,"j":["communication","future","radio","space"],"k":[36,51],"o":2},"orange_heart":{"a":"Orange Heart","b":"1F9E1","d":true,"e":true,"f":true,"h":true,"k":[51,20],"o":5},"yellow_heart":{"a":"Yellow Heart","b":"1F49B","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,37],"m":"<3","o":2},"copyright":{"a":"Copyright Sign","b":"00A9-FE0F","c":"00A9","d":true,"e":true,"f":true,"h":false,"j":["ip","license","circle","law","legal"],"k":[0,12],"o":2},"rocket":{"a":"Rocket","b":"1F680","d":true,"e":true,"f":true,"h":true,"j":["launch","ship","staffmode","NASA","outer space","outer_space","fly"],"k":[33,56],"o":2},"chart":{"a":"Chart with Upwards Trend and Yen Sign","b":"1F4B9","d":true,"e":true,"f":true,"h":true,"j":["green-square","graph","presentation","stats"],"k":[26,15],"o":2},"flag-kg":{"a":"Kyrgyzstan Flag","b":"1F1F0-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[2,38],"o":2},"office_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f4bc.png","sheet_x":46,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f4bc.png","sheet_x":46,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f4bc.png","sheet_x":46,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f4bc.png","sheet_x":46,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f4bc.png","sheet_x":46,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Office Worker","b":"1F9D1-200D-1F4BC","d":true,"e":false,"f":false,"h":false,"k":[46,8],"o":12},"currency_exchange":{"a":"Currency Exchange","b":"1F4B1","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","travel"],"k":[26,7],"o":2},"registered":{"a":"Registered Sign","b":"00AE-FE0F","c":"00AE","d":true,"e":true,"f":true,"h":false,"j":["alphabet","circle"],"k":[0,13],"o":2},"green_heart":{"a":"Green Heart","b":"1F49A","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,36],"m":"<3","o":2},"flying_saucer":{"a":"Flying Saucer","b":"1F6F8","d":true,"e":true,"f":true,"h":true,"k":[37,0],"o":5},"flag-kh":{"a":"Cambodia Flag","b":"1F1F0-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[2,39],"o":2},"male-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bc.png","sheet_x":15,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bc.png","sheet_x":15,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bc.png","sheet_x":15,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bc.png","sheet_x":15,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bc.png","sheet_x":15,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Office Worker","b":"1F468-200D-1F4BC","d":true,"e":true,"f":true,"h":true,"k":[15,44],"o":4},"tm":{"a":"Trade Mark Sign","b":"2122-FE0F","c":"2122","d":true,"e":true,"f":true,"h":true,"j":["trademark","brand","law","legal"],"k":[52,12],"o":2},"bellhop_bell":{"a":"Bellhop Bell","b":"1F6CE-FE0F","c":"1F6CE","d":true,"e":true,"f":true,"h":true,"j":["service"],"k":[36,36],"o":2},"blue_heart":{"a":"Blue Heart","b":"1F499","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,35],"m":"<3","o":2},"flag-ki":{"a":"Kiribati Flag","b":"1F1F0-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,40],"o":2},"heavy_dollar_sign":{"a":"Heavy Dollar Sign","b":"1F4B2","d":true,"e":true,"f":true,"h":true,"j":["money","sales","payment","currency","buck"],"k":[26,8],"o":2},"female-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bc.png","sheet_x":18,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bc.png","sheet_x":18,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bc.png","sheet_x":18,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bc.png","sheet_x":18,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bc.png","sheet_x":18,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Office Worker","b":"1F469-200D-1F4BC","d":true,"e":true,"f":true,"h":true,"k":[18,29],"o":4},"purple_heart":{"a":"Purple Heart","b":"1F49C","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,38],"m":"<3","o":2},"scientist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f52c.png","sheet_x":46,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f52c.png","sheet_x":46,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f52c.png","sheet_x":46,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f52c.png","sheet_x":46,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f52c.png","sheet_x":46,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Scientist","b":"1F9D1-200D-1F52C","d":true,"e":false,"f":false,"h":false,"k":[46,20],"o":12},"luggage":{"a":"Luggage","b":"1F9F3","d":true,"e":true,"f":true,"h":true,"k":[51,38],"o":11},"hash":{"a":"Hash Key","b":"0023-FE0F-20E3","c":"0023-20E3","d":true,"e":true,"f":true,"h":false,"j":["symbol","blue-square","twitter"],"k":[0,0],"o":0},"flag-km":{"a":"Comoros Flag","b":"1F1F0-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,41],"o":2},"email":{"a":"Envelope","b":"2709-FE0F","c":"2709","d":true,"e":true,"f":true,"h":true,"j":["letter","postal","inbox","communication"],"k":[54,42],"n":["envelope"],"o":2},"e-mail":{"a":"E-Mail Symbol","b":"1F4E7","d":true,"e":true,"f":true,"h":true,"j":["communication","inbox"],"k":[27,4],"o":2},"keycap_star":{"a":"Keycap Star","b":"002A-FE0F-20E3","c":"002A-20E3","d":true,"e":true,"f":true,"h":false,"k":[0,1],"o":0},"flag-kn":{"a":"St. Kitts & Nevis Flag","b":"1F1F0-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,42],"o":2},"hourglass":{"a":"Hourglass","b":"231B","d":true,"e":true,"f":true,"h":true,"j":["time","clock","oldschool","limit","exam","quiz","test"],"k":[52,23],"o":2},"brown_heart":{"a":"Brown Heart","b":"1F90E","d":true,"e":true,"f":true,"h":true,"k":[37,16],"o":12},"male-scientist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F52C","non_qualified":null,"image":"1f468-1f3fb-200d-1f52c.png","sheet_x":16,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F52C","non_qualified":null,"image":"1f468-1f3fc-200d-1f52c.png","sheet_x":16,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F52C","non_qualified":null,"image":"1f468-1f3fd-200d-1f52c.png","sheet_x":16,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F52C","non_qualified":null,"image":"1f468-1f3fe-200d-1f52c.png","sheet_x":16,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F52C","non_qualified":null,"image":"1f468-1f3ff-200d-1f52c.png","sheet_x":16,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Scientist","b":"1F468-200D-1F52C","d":true,"e":true,"f":true,"h":true,"k":[15,56],"o":4},"hourglass_flowing_sand":{"a":"Hourglass with Flowing Sand","b":"23F3","d":true,"e":true,"f":true,"h":true,"j":["oldschool","time","countdown"],"k":[52,36],"o":2},"black_heart":{"a":"Black Heart","b":"1F5A4","d":true,"e":true,"f":true,"h":true,"j":["evil"],"k":[30,9],"o":4},"zero":{"a":"Keycap 0","b":"0030-FE0F-20E3","c":"0030-20E3","d":true,"e":true,"f":true,"h":false,"j":["0","numbers","blue-square","null"],"k":[0,2],"o":0},"incoming_envelope":{"a":"Incoming Envelope","b":"1F4E8","d":true,"e":true,"f":true,"h":true,"j":["email","inbox"],"k":[27,5],"o":2},"flag-kp":{"a":"North Korea Flag","b":"1F1F0-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[2,43],"o":2},"female-scientist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F52C","non_qualified":null,"image":"1f469-1f3fb-200d-1f52c.png","sheet_x":18,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F52C","non_qualified":null,"image":"1f469-1f3fc-200d-1f52c.png","sheet_x":18,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F52C","non_qualified":null,"image":"1f469-1f3fd-200d-1f52c.png","sheet_x":18,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F52C","non_qualified":null,"image":"1f469-1f3fe-200d-1f52c.png","sheet_x":18,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F52C","non_qualified":null,"image":"1f469-1f3ff-200d-1f52c.png","sheet_x":18,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Scientist","b":"1F469-200D-1F52C","d":true,"e":true,"f":true,"h":true,"k":[18,41],"o":4},"watch":{"a":"Watch","b":"231A","d":true,"e":true,"f":true,"h":true,"j":["time","accessories"],"k":[52,22],"o":2},"white_heart":{"a":"White Heart","b":"1F90D","d":true,"e":true,"f":true,"h":true,"k":[37,15],"o":12},"one":{"a":"Keycap 1","b":"0031-FE0F-20E3","c":"0031-20E3","d":true,"e":true,"f":true,"h":false,"j":["blue-square","numbers","1"],"k":[0,3],"o":0},"kr":{"a":"South Korea Flag","b":"1F1F0-1F1F7","d":true,"e":true,"f":true,"h":true,"j":["south","korea","nation","flag","country","banner"],"k":[2,44],"n":["flag-kr"],"o":2},"envelope_with_arrow":{"a":"Envelope with Downwards Arrow Above","b":"1F4E9","d":true,"e":true,"f":true,"h":true,"j":["email","communication"],"k":[27,6],"o":2},"technologist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f4bb.png","sheet_x":46,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f4bb.png","sheet_x":46,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f4bb.png","sheet_x":46,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f4bb.png","sheet_x":46,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f4bb.png","sheet_x":46,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Technologist","b":"1F9D1-200D-1F4BB","d":true,"e":false,"f":false,"h":false,"k":[46,2],"o":12},"outbox_tray":{"a":"Outbox Tray","b":"1F4E4","d":true,"e":true,"f":true,"h":true,"j":["inbox","email"],"k":[27,1],"o":2},"male-technologist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bb.png","sheet_x":15,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bb.png","sheet_x":15,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bb.png","sheet_x":15,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bb.png","sheet_x":15,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bb.png","sheet_x":15,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Technologist","b":"1F468-200D-1F4BB","d":true,"e":true,"f":true,"h":true,"k":[15,38],"o":4},"alarm_clock":{"a":"Alarm Clock","b":"23F0","d":true,"e":true,"f":true,"h":true,"j":["time","wake"],"k":[52,33],"o":2},"flag-kw":{"a":"Kuwait Flag","b":"1F1F0-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[2,45],"o":2},"two":{"a":"Keycap 2","b":"0032-FE0F-20E3","c":"0032-20E3","d":true,"e":true,"f":true,"h":false,"j":["numbers","2","prime","blue-square"],"k":[0,4],"o":0},"anger":{"a":"Anger Symbol","b":"1F4A2","d":true,"e":true,"f":true,"h":true,"j":["angry","mad"],"k":[25,44],"o":2},"inbox_tray":{"a":"Inbox Tray","b":"1F4E5","d":true,"e":true,"f":true,"h":true,"j":["email","documents"],"k":[27,2],"o":2},"three":{"a":"Keycap 3","b":"0033-FE0F-20E3","c":"0033-20E3","d":true,"e":true,"f":true,"h":false,"j":["3","numbers","prime","blue-square"],"k":[0,5],"o":0},"flag-ky":{"a":"Cayman Islands Flag","b":"1F1F0-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[2,46],"o":2},"stopwatch":{"a":"Stopwatch","b":"23F1-FE0F","c":"23F1","d":true,"e":true,"f":true,"h":true,"j":["time","deadline"],"k":[52,34],"o":2},"female-technologist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bb.png","sheet_x":18,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bb.png","sheet_x":18,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bb.png","sheet_x":18,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bb.png","sheet_x":18,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bb.png","sheet_x":18,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Technologist","b":"1F469-200D-1F4BB","d":true,"e":true,"f":true,"h":true,"k":[18,23],"o":4},"boom":{"a":"Collision Symbol","b":"1F4A5","d":true,"e":true,"f":true,"h":true,"j":["bomb","explode","explosion","collision","blown"],"k":[25,47],"n":["collision"],"o":2},"flag-kz":{"a":"Kazakhstan Flag","b":"1F1F0-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[2,47],"o":2},"four":{"a":"Keycap 4","b":"0034-FE0F-20E3","c":"0034-20E3","d":true,"e":true,"f":true,"h":false,"j":["4","numbers","blue-square"],"k":[0,6],"o":0},"timer_clock":{"a":"Timer Clock","b":"23F2-FE0F","c":"23F2","d":true,"e":true,"f":true,"h":true,"j":["alarm"],"k":[52,35],"o":2},"singer":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3a4.png","sheet_x":45,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3a4.png","sheet_x":45,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3a4.png","sheet_x":45,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3a4.png","sheet_x":45,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3a4.png","sheet_x":45,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Singer","b":"1F9D1-200D-1F3A4","d":true,"e":false,"f":false,"h":false,"k":[45,35],"o":12},"package":{"a":"Package","b":"1F4E6","d":true,"e":true,"f":true,"h":true,"j":["mail","gift","cardboard","box","moving"],"k":[27,3],"o":2},"mailbox":{"a":"Closed Mailbox with Raised Flag","b":"1F4EB","d":true,"e":true,"f":true,"h":true,"j":["email","inbox","communication"],"k":[27,8],"o":2},"flag-la":{"a":"Laos Flag","b":"1F1F1-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[2,48],"o":2},"dizzy":{"a":"Dizzy Symbol","b":"1F4AB","d":true,"e":true,"f":true,"h":true,"j":["star","sparkle","shoot","magic"],"k":[26,1],"o":2},"five":{"a":"Keycap 5","b":"0035-FE0F-20E3","c":"0035-20E3","d":true,"e":true,"f":true,"h":false,"j":["5","numbers","blue-square","prime"],"k":[0,7],"o":0},"male-singer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a4.png","sheet_x":15,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a4.png","sheet_x":15,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a4.png","sheet_x":15,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a4.png","sheet_x":15,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a4.png","sheet_x":15,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Singer","b":"1F468-200D-1F3A4","d":true,"e":true,"f":true,"h":true,"k":[14,56],"o":4},"mantelpiece_clock":{"a":"Mantelpiece Clock","b":"1F570-FE0F","c":"1F570","d":true,"e":true,"f":true,"h":true,"j":["time"],"k":[29,7],"o":2},"female-singer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a4.png","sheet_x":17,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a4.png","sheet_x":17,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a4.png","sheet_x":17,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a4.png","sheet_x":17,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a4.png","sheet_x":17,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Singer","b":"1F469-200D-1F3A4","d":true,"e":true,"f":true,"h":true,"k":[17,46],"o":4},"flag-lb":{"a":"Lebanon Flag","b":"1F1F1-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[2,49],"o":2},"six":{"a":"Keycap 6","b":"0036-FE0F-20E3","c":"0036-20E3","d":true,"e":true,"f":true,"h":false,"j":["6","numbers","blue-square"],"k":[0,8],"o":0},"mailbox_closed":{"a":"Closed Mailbox with Lowered Flag","b":"1F4EA","d":true,"e":true,"f":true,"h":true,"j":["email","communication","inbox"],"k":[27,7],"o":2},"sweat_drops":{"a":"Splashing Sweat Symbol","b":"1F4A6","d":true,"e":true,"f":true,"h":true,"j":["water","drip","oops"],"k":[25,48],"o":2},"clock12":{"a":"Clock Face Twelve Oclock","b":"1F55B","d":true,"e":true,"f":true,"h":true,"j":["time","noon","midnight","midday","late","early","schedule"],"k":[28,50],"o":2},"seven":{"a":"Keycap 7","b":"0037-FE0F-20E3","c":"0037-20E3","d":true,"e":true,"f":true,"h":false,"j":["7","numbers","blue-square","prime"],"k":[0,9],"o":0},"mailbox_with_mail":{"a":"Open Mailbox with Raised Flag","b":"1F4EC","d":true,"e":true,"f":true,"h":true,"j":["email","inbox","communication"],"k":[27,9],"o":2},"clock1230":{"a":"Clock Face Twelve-Thirty","b":"1F567","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,5],"o":2},"dash":{"a":"Dash Symbol","b":"1F4A8","d":true,"e":true,"f":true,"h":true,"j":["wind","air","fast","shoo","fart","smoke","puff"],"k":[25,50],"o":2},"artist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3a8.png","sheet_x":45,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3a8.png","sheet_x":45,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3a8.png","sheet_x":45,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3a8.png","sheet_x":45,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3a8.png","sheet_x":45,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Artist","b":"1F9D1-200D-1F3A8","d":true,"e":false,"f":false,"h":false,"k":[45,41],"o":12},"flag-lc":{"a":"St. Lucia Flag","b":"1F1F1-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[2,50],"o":2},"hole":{"a":"Hole","b":"1F573-FE0F","c":"1F573","d":true,"e":true,"f":true,"h":true,"j":["embarrassing"],"k":[29,8],"o":2},"male-artist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a8.png","sheet_x":15,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a8.png","sheet_x":15,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a8.png","sheet_x":15,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a8.png","sheet_x":15,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a8.png","sheet_x":15,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Artist","b":"1F468-200D-1F3A8","d":true,"e":true,"f":true,"h":true,"k":[15,5],"o":4},"clock1":{"a":"Clock Face One Oclock","b":"1F550","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,39],"o":2},"eight":{"a":"Keycap 8","b":"0038-FE0F-20E3","c":"0038-20E3","d":true,"e":true,"f":true,"h":false,"j":["8","blue-square","numbers"],"k":[0,10],"o":0},"mailbox_with_no_mail":{"a":"Open Mailbox with Lowered Flag","b":"1F4ED","d":true,"e":true,"f":true,"h":true,"j":["email","inbox"],"k":[27,10],"o":2},"flag-li":{"a":"Liechtenstein Flag","b":"1F1F1-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,51],"o":2},"bomb":{"a":"Bomb","b":"1F4A3","d":true,"e":true,"f":true,"h":true,"j":["boom","explode","explosion","terrorism"],"k":[25,45],"o":2},"nine":{"a":"Keycap 9","b":"0039-FE0F-20E3","c":"0039-20E3","d":true,"e":true,"f":true,"h":false,"j":["blue-square","numbers","9"],"k":[0,11],"o":0},"postbox":{"a":"Postbox","b":"1F4EE","d":true,"e":true,"f":true,"h":true,"j":["email","letter","envelope"],"k":[27,11],"o":2},"female-artist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a8.png","sheet_x":17,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a8.png","sheet_x":17,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a8.png","sheet_x":17,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a8.png","sheet_x":17,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a8.png","sheet_x":18,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Artist","b":"1F469-200D-1F3A8","d":true,"e":true,"f":true,"h":true,"k":[17,52],"o":4},"clock130":{"a":"Clock Face One-Thirty","b":"1F55C","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,51],"o":2},"flag-lk":{"a":"Sri Lanka Flag","b":"1F1F1-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[2,52],"o":2},"ballot_box_with_ballot":{"a":"Ballot Box with Ballot","b":"1F5F3-FE0F","c":"1F5F3","d":true,"e":true,"f":true,"h":true,"k":[30,28],"o":2},"pilot":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2708-FE0F","non_qualified":"1F9D1-1F3FB-200D-2708","image":"1f9d1-1f3fb-200d-2708-fe0f.png","sheet_x":48,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2708-FE0F","non_qualified":"1F9D1-1F3FC-200D-2708","image":"1f9d1-1f3fc-200d-2708-fe0f.png","sheet_x":48,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2708-FE0F","non_qualified":"1F9D1-1F3FD-200D-2708","image":"1f9d1-1f3fd-200d-2708-fe0f.png","sheet_x":48,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2708-FE0F","non_qualified":"1F9D1-1F3FE-200D-2708","image":"1f9d1-1f3fe-200d-2708-fe0f.png","sheet_x":48,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2708-FE0F","non_qualified":"1F9D1-1F3FF-200D-2708","image":"1f9d1-1f3ff-200d-2708-fe0f.png","sheet_x":48,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Pilot","b":"1F9D1-200D-2708-FE0F","c":"1F9D1-200D-2708","d":true,"e":false,"f":false,"h":false,"k":[48,4],"o":12},"keycap_ten":{"a":"Keycap Ten","b":"1F51F","d":true,"e":true,"f":true,"h":true,"j":["numbers","10","blue-square"],"k":[28,2],"o":2},"clock2":{"a":"Clock Face Two Oclock","b":"1F551","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,40],"o":2},"flag-lr":{"a":"Liberia Flag","b":"1F1F1-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,53],"o":2},"speech_balloon":{"a":"Speech Balloon","b":"1F4AC","d":true,"e":true,"f":true,"h":true,"j":["bubble","words","message","talk","chatting"],"k":[26,2],"o":2},"eye-in-speech-bubble":{"a":"Eye in Speech Bubble","b":"1F441-FE0F-200D-1F5E8-FE0F","d":true,"e":true,"f":false,"h":false,"k":[12,37],"o":2},"flag-ls":{"a":"Lesotho Flag","b":"1F1F1-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,54],"o":2},"clock230":{"a":"Clock Face Two-Thirty","b":"1F55D","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,52],"o":2},"male-pilot":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2708-FE0F","non_qualified":"1F468-1F3FB-200D-2708","image":"1f468-1f3fb-200d-2708-fe0f.png","sheet_x":17,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2708-FE0F","non_qualified":"1F468-1F3FC-200D-2708","image":"1f468-1f3fc-200d-2708-fe0f.png","sheet_x":17,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2708-FE0F","non_qualified":"1F468-1F3FD-200D-2708","image":"1f468-1f3fd-200d-2708-fe0f.png","sheet_x":17,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2708-FE0F","non_qualified":"1F468-1F3FE-200D-2708","image":"1f468-1f3fe-200d-2708-fe0f.png","sheet_x":17,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2708-FE0F","non_qualified":"1F468-1F3FF-200D-2708","image":"1f468-1f3ff-200d-2708-fe0f.png","sheet_x":17,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Pilot","b":"1F468-200D-2708-FE0F","c":"1F468-200D-2708","d":true,"e":true,"f":true,"h":true,"k":[17,14],"o":4},"capital_abcd":{"a":"Input Symbol for Latin Capital Letters","b":"1F520","d":true,"e":true,"f":true,"h":true,"j":["alphabet","words","blue-square"],"k":[28,3],"o":2},"pencil2":{"a":"Pencil","b":"270F-FE0F","c":"270F","d":true,"e":true,"f":true,"h":true,"j":["stationery","write","paper","writing","school","study"],"k":[55,10],"o":2},"female-pilot":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2708-FE0F","non_qualified":"1F469-1F3FB-200D-2708","image":"1f469-1f3fb-200d-2708-fe0f.png","sheet_x":20,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2708-FE0F","non_qualified":"1F469-1F3FC-200D-2708","image":"1f469-1f3fc-200d-2708-fe0f.png","sheet_x":20,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2708-FE0F","non_qualified":"1F469-1F3FD-200D-2708","image":"1f469-1f3fd-200d-2708-fe0f.png","sheet_x":20,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2708-FE0F","non_qualified":"1F469-1F3FE-200D-2708","image":"1f469-1f3fe-200d-2708-fe0f.png","sheet_x":20,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2708-FE0F","non_qualified":"1F469-1F3FF-200D-2708","image":"1f469-1f3ff-200d-2708-fe0f.png","sheet_x":20,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Pilot","b":"1F469-200D-2708-FE0F","c":"1F469-200D-2708","d":true,"e":true,"f":true,"h":true,"k":[19,56],"o":4},"black_nib":{"a":"Black Nib","b":"2712-FE0F","c":"2712","d":true,"e":true,"f":true,"h":true,"j":["pen","stationery","writing","write"],"k":[55,11],"o":2},"left_speech_bubble":{"a":"Left Speech Bubble","b":"1F5E8-FE0F","c":"1F5E8","d":true,"e":true,"f":true,"h":true,"j":["words","message","talk","chatting"],"k":[30,26],"o":2},"clock3":{"a":"Clock Face Three Oclock","b":"1F552","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,41],"o":2},"abcd":{"a":"Input Symbol for Latin Small Letters","b":"1F521","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet"],"k":[28,4],"o":2},"flag-lt":{"a":"Lithuania Flag","b":"1F1F1-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,55],"o":2},"clock330":{"a":"Clock Face Three-Thirty","b":"1F55E","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,53],"o":2},"astronaut":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f680.png","sheet_x":46,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f680.png","sheet_x":46,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f680.png","sheet_x":46,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f680.png","sheet_x":46,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F680","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f680.png","sheet_x":46,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Astronaut","b":"1F9D1-200D-1F680","d":true,"e":false,"f":false,"h":false,"k":[46,26],"o":12},"flag-lu":{"a":"Luxembourg Flag","b":"1F1F1-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,56],"o":2},"right_anger_bubble":{"a":"Right Anger Bubble","b":"1F5EF-FE0F","c":"1F5EF","d":true,"e":true,"f":true,"h":true,"j":["caption","speech","thinking","mad"],"k":[30,27],"o":2},"lower_left_fountain_pen":{"a":"Lower Left Fountain Pen","b":"1F58B-FE0F","c":"1F58B","d":true,"e":true,"f":true,"h":true,"k":[29,45],"o":2},"male-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F680","non_qualified":null,"image":"1f468-1f3fb-200d-1f680.png","sheet_x":16,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F680","non_qualified":null,"image":"1f468-1f3fc-200d-1f680.png","sheet_x":16,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F680","non_qualified":null,"image":"1f468-1f3fd-200d-1f680.png","sheet_x":16,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F680","non_qualified":null,"image":"1f468-1f3fe-200d-1f680.png","sheet_x":16,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F680","non_qualified":null,"image":"1f468-1f3ff-200d-1f680.png","sheet_x":16,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Astronaut","b":"1F468-200D-1F680","d":true,"e":true,"f":true,"h":true,"k":[16,5],"o":4},"thought_balloon":{"a":"Thought Balloon","b":"1F4AD","d":true,"e":true,"f":true,"h":true,"j":["bubble","cloud","speech","thinking","dream"],"k":[26,3],"o":2},"symbols":{"a":"Input Symbol for Symbols","b":"1F523","d":true,"e":true,"f":true,"h":true,"j":["blue-square","music","note","ampersand","percent","glyphs","characters"],"k":[28,6],"o":2},"clock4":{"a":"Clock Face Four Oclock","b":"1F553","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,42],"o":2},"flag-lv":{"a":"Latvia Flag","b":"1F1F1-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[3,0],"o":2},"lower_left_ballpoint_pen":{"a":"Lower Left Ballpoint Pen","b":"1F58A-FE0F","c":"1F58A","d":true,"e":true,"f":true,"h":true,"k":[29,44],"o":2},"abc":{"a":"Input Symbol for Latin Letters","b":"1F524","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet"],"k":[28,7],"o":2},"zzz":{"a":"Sleeping Symbol","b":"1F4A4","d":true,"e":true,"f":true,"h":true,"j":["sleepy","tired","dream"],"k":[25,46],"o":2},"lower_left_paintbrush":{"a":"Lower Left Paintbrush","b":"1F58C-FE0F","c":"1F58C","d":true,"e":true,"f":true,"h":true,"k":[29,46],"o":2},"female-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F680","non_qualified":null,"image":"1f469-1f3fb-200d-1f680.png","sheet_x":18,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F680","non_qualified":null,"image":"1f469-1f3fc-200d-1f680.png","sheet_x":18,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F680","non_qualified":null,"image":"1f469-1f3fd-200d-1f680.png","sheet_x":18,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F680","non_qualified":null,"image":"1f469-1f3fe-200d-1f680.png","sheet_x":18,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F680","non_qualified":null,"image":"1f469-1f3ff-200d-1f680.png","sheet_x":18,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Astronaut","b":"1F469-200D-1F680","d":true,"e":true,"f":true,"h":true,"k":[18,47],"o":4},"flag-ly":{"a":"Libya Flag","b":"1F1F1-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,1],"o":2},"clock430":{"a":"Clock Face Four-Thirty","b":"1F55F","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,54],"o":2},"flag-ma":{"a":"Morocco Flag","b":"1F1F2-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,2],"o":2},"a":{"a":"Negative Squared Latin Capital Letter a","b":"1F170-FE0F","c":"1F170","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet","letter"],"k":[0,16],"o":2},"clock5":{"a":"Clock Face Five Oclock","b":"1F554","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,43],"o":2},"lower_left_crayon":{"a":"Lower Left Crayon","b":"1F58D-FE0F","c":"1F58D","d":true,"e":true,"f":true,"h":true,"k":[29,47],"o":2},"firefighter":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f692.png","sheet_x":46,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f692.png","sheet_x":46,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f692.png","sheet_x":46,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f692.png","sheet_x":46,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F692","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f692.png","sheet_x":46,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Firefighter","b":"1F9D1-200D-1F692","d":true,"e":false,"f":false,"h":false,"k":[46,32],"o":12},"male-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F692","non_qualified":null,"image":"1f468-1f3fb-200d-1f692.png","sheet_x":16,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F692","non_qualified":null,"image":"1f468-1f3fc-200d-1f692.png","sheet_x":16,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F692","non_qualified":null,"image":"1f468-1f3fd-200d-1f692.png","sheet_x":16,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F692","non_qualified":null,"image":"1f468-1f3fe-200d-1f692.png","sheet_x":16,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F692","non_qualified":null,"image":"1f468-1f3ff-200d-1f692.png","sheet_x":16,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Firefighter","b":"1F468-200D-1F692","d":true,"e":true,"f":true,"h":true,"k":[16,11],"o":4},"memo":{"a":"Memo","b":"1F4DD","d":true,"e":true,"f":true,"h":true,"j":["write","documents","stationery","pencil","paper","writing","legal","exam","quiz","test","study","compose"],"k":[26,51],"n":["pencil"],"o":2},"ab":{"a":"Negative Squared Ab","b":"1F18E","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet"],"k":[0,20],"o":2},"flag-mc":{"a":"Monaco Flag","b":"1F1F2-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[3,3],"o":2},"clock530":{"a":"Clock Face Five-Thirty","b":"1F560","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,55],"o":2},"briefcase":{"a":"Briefcase","b":"1F4BC","d":true,"e":true,"f":true,"h":true,"j":["business","documents","work","law","legal","job","career"],"k":[26,18],"o":2},"female-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F692","non_qualified":null,"image":"1f469-1f3fb-200d-1f692.png","sheet_x":18,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F692","non_qualified":null,"image":"1f469-1f3fc-200d-1f692.png","sheet_x":18,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F692","non_qualified":null,"image":"1f469-1f3fd-200d-1f692.png","sheet_x":18,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F692","non_qualified":null,"image":"1f469-1f3fe-200d-1f692.png","sheet_x":19,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F692","non_qualified":null,"image":"1f469-1f3ff-200d-1f692.png","sheet_x":19,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Firefighter","b":"1F469-200D-1F692","d":true,"e":true,"f":true,"h":true,"k":[18,53],"o":4},"clock6":{"a":"Clock Face Six Oclock","b":"1F555","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule","dawn","dusk"],"k":[28,44],"o":2},"b":{"a":"Negative Squared Latin Capital Letter B","b":"1F171-FE0F","c":"1F171","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet","letter"],"k":[0,17],"o":2},"flag-md":{"a":"Moldova Flag","b":"1F1F2-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[3,4],"o":2},"clock630":{"a":"Clock Face Six-Thirty","b":"1F561","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,56],"o":2},"cl":{"a":"Squared Cl","b":"1F191","d":true,"e":true,"f":true,"h":true,"j":["alphabet","words","red-square"],"k":[0,21],"o":2},"flag-me":{"a":"Montenegro Flag","b":"1F1F2-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,5],"o":2},"file_folder":{"a":"File Folder","b":"1F4C1","d":true,"e":true,"f":true,"h":true,"j":["documents","business","office"],"k":[26,23],"o":2},"cop":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB","non_qualified":null,"image":"1f46e-1f3fb.png","sheet_x":21,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F46E-1F3FC","non_qualified":null,"image":"1f46e-1f3fc.png","sheet_x":21,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F46E-1F3FD","non_qualified":null,"image":"1f46e-1f3fd.png","sheet_x":21,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F46E-1F3FE","non_qualified":null,"image":"1f46e-1f3fe.png","sheet_x":21,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F46E-1F3FF","non_qualified":null,"image":"1f46e-1f3ff.png","sheet_x":21,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F46E-200D-2642-FE0F","a":"Police Officer","b":"1F46E","d":true,"e":true,"f":true,"h":false,"k":[21,49],"o":2},"male-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2642-FE0F","non_qualified":"1F46E-1F3FB-200D-2642","image":"1f46e-1f3fb-200d-2642-fe0f.png","sheet_x":21,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46E-1F3FC-200D-2642-FE0F","non_qualified":"1F46E-1F3FC-200D-2642","image":"1f46e-1f3fc-200d-2642-fe0f.png","sheet_x":21,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46E-1F3FD-200D-2642-FE0F","non_qualified":"1F46E-1F3FD-200D-2642","image":"1f46e-1f3fd-200d-2642-fe0f.png","sheet_x":21,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46E-1F3FE-200D-2642-FE0F","non_qualified":"1F46E-1F3FE-200D-2642","image":"1f46e-1f3fe-200d-2642-fe0f.png","sheet_x":21,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46E-1F3FF-200D-2642-FE0F","non_qualified":"1F46E-1F3FF-200D-2642","image":"1f46e-1f3ff-200d-2642-fe0f.png","sheet_x":21,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F46E","a":"Male Police Officer","b":"1F46E-200D-2642-FE0F","c":"1F46E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[21,43],"o":4},"cool":{"a":"Squared Cool","b":"1F192","d":true,"e":true,"f":true,"h":true,"j":["words","blue-square"],"k":[0,22],"o":2},"clock7":{"a":"Clock Face Seven Oclock","b":"1F556","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,45],"o":2},"flag-mf":{"a":"St. Martin Flag","b":"1F1F2-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,6],"o":2},"open_file_folder":{"a":"Open File Folder","b":"1F4C2","d":true,"e":true,"f":true,"h":true,"j":["documents","load"],"k":[26,24],"o":2},"card_index_dividers":{"a":"Card Index Dividers","b":"1F5C2-FE0F","c":"1F5C2","d":true,"e":true,"f":true,"h":true,"j":["organizing","business","stationery"],"k":[30,15],"o":2},"flag-mg":{"a":"Madagascar Flag","b":"1F1F2-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,7],"o":2},"free":{"a":"Squared Free","b":"1F193","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words"],"k":[0,23],"o":2},"female-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2640-FE0F","non_qualified":"1F46E-1F3FB-200D-2640","image":"1f46e-1f3fb-200d-2640-fe0f.png","sheet_x":21,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46E-1F3FC-200D-2640-FE0F","non_qualified":"1F46E-1F3FC-200D-2640","image":"1f46e-1f3fc-200d-2640-fe0f.png","sheet_x":21,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46E-1F3FD-200D-2640-FE0F","non_qualified":"1F46E-1F3FD-200D-2640","image":"1f46e-1f3fd-200d-2640-fe0f.png","sheet_x":21,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46E-1F3FE-200D-2640-FE0F","non_qualified":"1F46E-1F3FE-200D-2640","image":"1f46e-1f3fe-200d-2640-fe0f.png","sheet_x":21,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46E-1F3FF-200D-2640-FE0F","non_qualified":"1F46E-1F3FF-200D-2640","image":"1f46e-1f3ff-200d-2640-fe0f.png","sheet_x":21,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Police Officer","b":"1F46E-200D-2640-FE0F","c":"1F46E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[21,37],"o":4},"clock730":{"a":"Clock Face Seven-Thirty","b":"1F562","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,0],"o":2},"date":{"a":"Calendar","b":"1F4C5","d":true,"e":true,"f":true,"h":true,"j":["calendar","schedule"],"k":[26,27],"o":2},"clock8":{"a":"Clock Face Eight Oclock","b":"1F557","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,46],"o":2},"information_source":{"a":"Information Source","b":"2139-FE0F","c":"2139","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet","letter"],"k":[52,13],"o":2},"sleuth_or_spy":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB","non_qualified":null,"image":"1f575-1f3fb.png","sheet_x":29,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F575-1F3FC","non_qualified":null,"image":"1f575-1f3fc.png","sheet_x":29,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F575-1F3FD","non_qualified":null,"image":"1f575-1f3fd.png","sheet_x":29,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F575-1F3FE","non_qualified":null,"image":"1f575-1f3fe.png","sheet_x":29,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F575-1F3FF","non_qualified":null,"image":"1f575-1f3ff.png","sheet_x":29,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F575-FE0F-200D-2642-FE0F","a":"Sleuth or Spy","b":"1F575-FE0F","c":"1F575","d":true,"e":true,"f":true,"h":false,"k":[29,27],"o":2},"flag-mh":{"a":"Marshall Islands Flag","b":"1F1F2-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[3,8],"o":2},"clock830":{"a":"Clock Face Eight-Thirty","b":"1F563","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,1],"o":2},"calendar":{"a":"Tear-off Calendar","b":"1F4C6","d":true,"e":true,"f":true,"h":true,"j":["schedule","date","planning"],"k":[26,28],"o":2},"male-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2642-FE0F","non_qualified":"1F575-1F3FB-200D-2642","image":"1f575-1f3fb-200d-2642-fe0f.png","sheet_x":29,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F575-1F3FC-200D-2642-FE0F","non_qualified":"1F575-1F3FC-200D-2642","image":"1f575-1f3fc-200d-2642-fe0f.png","sheet_x":29,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F575-1F3FD-200D-2642-FE0F","non_qualified":"1F575-1F3FD-200D-2642","image":"1f575-1f3fd-200d-2642-fe0f.png","sheet_x":29,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F575-1F3FE-200D-2642-FE0F","non_qualified":"1F575-1F3FE-200D-2642","image":"1f575-1f3fe-200d-2642-fe0f.png","sheet_x":29,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F575-1F3FF-200D-2642-FE0F","non_qualified":"1F575-1F3FF-200D-2642","image":"1f575-1f3ff-200d-2642-fe0f.png","sheet_x":29,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F575-FE0F","a":"Male Detective","b":"1F575-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[29,21],"o":4},"flag-mk":{"a":"North Macedonia Flag","b":"1F1F2-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[3,9],"o":2},"id":{"a":"Squared Id","b":"1F194","d":true,"e":true,"f":true,"h":true,"j":["purple-square","words"],"k":[0,24],"o":2},"spiral_note_pad":{"a":"Spiral Note Pad","b":"1F5D2-FE0F","c":"1F5D2","d":true,"e":true,"f":true,"h":true,"k":[30,19],"o":2},"female-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2640-FE0F","non_qualified":"1F575-1F3FB-200D-2640","image":"1f575-1f3fb-200d-2640-fe0f.png","sheet_x":29,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F575-1F3FC-200D-2640-FE0F","non_qualified":"1F575-1F3FC-200D-2640","image":"1f575-1f3fc-200d-2640-fe0f.png","sheet_x":29,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F575-1F3FD-200D-2640-FE0F","non_qualified":"1F575-1F3FD-200D-2640","image":"1f575-1f3fd-200d-2640-fe0f.png","sheet_x":29,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F575-1F3FE-200D-2640-FE0F","non_qualified":"1F575-1F3FE-200D-2640","image":"1f575-1f3fe-200d-2640-fe0f.png","sheet_x":29,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F575-1F3FF-200D-2640-FE0F","non_qualified":"1F575-1F3FF-200D-2640","image":"1f575-1f3ff-200d-2640-fe0f.png","sheet_x":29,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Detective","b":"1F575-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[29,15],"o":4},"clock9":{"a":"Clock Face Nine Oclock","b":"1F558","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,47],"o":2},"flag-ml":{"a":"Mali Flag","b":"1F1F2-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,10],"o":2},"m":{"a":"Circled Latin Capital Letter M","b":"24C2-FE0F","c":"24C2","d":true,"e":true,"f":true,"h":true,"j":["alphabet","blue-circle","letter"],"k":[52,40],"o":2},"flag-mm":{"a":"Myanmar (burma) Flag","b":"1F1F2-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,11],"o":2},"clock930":{"a":"Clock Face Nine-Thirty","b":"1F564","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,2],"o":2},"guardsman":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB","non_qualified":null,"image":"1f482-1f3fb.png","sheet_x":24,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F482-1F3FC","non_qualified":null,"image":"1f482-1f3fc.png","sheet_x":24,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F482-1F3FD","non_qualified":null,"image":"1f482-1f3fd.png","sheet_x":24,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F482-1F3FE","non_qualified":null,"image":"1f482-1f3fe.png","sheet_x":24,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F482-1F3FF","non_qualified":null,"image":"1f482-1f3ff.png","sheet_x":24,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F482-200D-2642-FE0F","a":"Guardsman","b":"1F482","d":true,"e":true,"f":true,"h":false,"j":["uk","gb","british","male","guy","royal"],"k":[24,20],"o":2},"new":{"a":"Squared New","b":"1F195","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words","start"],"k":[0,25],"o":2},"spiral_calendar_pad":{"a":"Spiral Calendar Pad","b":"1F5D3-FE0F","c":"1F5D3","d":true,"e":true,"f":true,"h":true,"k":[30,20],"o":2},"ng":{"a":"Squared Ng","b":"1F196","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words","shape","icon"],"k":[0,26],"o":2},"card_index":{"a":"Card Index","b":"1F4C7","d":true,"e":true,"f":true,"h":true,"j":["business","stationery"],"k":[26,29],"o":2},"clock10":{"a":"Clock Face Ten Oclock","b":"1F559","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,48],"o":2},"flag-mn":{"a":"Mongolia Flag","b":"1F1F2-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[3,12],"o":2},"male-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2642-FE0F","non_qualified":"1F482-1F3FB-200D-2642","image":"1f482-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F482-1F3FC-200D-2642-FE0F","non_qualified":"1F482-1F3FC-200D-2642","image":"1f482-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F482-1F3FD-200D-2642-FE0F","non_qualified":"1F482-1F3FD-200D-2642","image":"1f482-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F482-1F3FE-200D-2642-FE0F","non_qualified":"1F482-1F3FE-200D-2642","image":"1f482-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F482-1F3FF-200D-2642-FE0F","non_qualified":"1F482-1F3FF-200D-2642","image":"1f482-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F482","a":"Male Guard","b":"1F482-200D-2642-FE0F","c":"1F482-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[24,14],"o":4},"flag-mo":{"a":"Macao Sar China Flag","b":"1F1F2-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,13],"o":2},"clock1030":{"a":"Clock Face Ten-Thirty","b":"1F565","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,3],"o":2},"chart_with_upwards_trend":{"a":"Chart with Upwards Trend","b":"1F4C8","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"k":[26,30],"o":2},"o2":{"a":"Negative Squared Latin Capital Letter O","b":"1F17E-FE0F","c":"1F17E","d":true,"e":true,"f":true,"h":true,"j":["alphabet","red-square","letter"],"k":[0,18],"o":2},"female-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2640-FE0F","non_qualified":"1F482-1F3FB-200D-2640","image":"1f482-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F482-1F3FC-200D-2640-FE0F","non_qualified":"1F482-1F3FC-200D-2640","image":"1f482-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F482-1F3FD-200D-2640-FE0F","non_qualified":"1F482-1F3FD-200D-2640","image":"1f482-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F482-1F3FE-200D-2640-FE0F","non_qualified":"1F482-1F3FE-200D-2640","image":"1f482-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F482-1F3FF-200D-2640-FE0F","non_qualified":"1F482-1F3FF-200D-2640","image":"1f482-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Guard","b":"1F482-200D-2640-FE0F","c":"1F482-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[24,8],"o":4},"chart_with_downwards_trend":{"a":"Chart with Downwards Trend","b":"1F4C9","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"k":[26,31],"o":2},"flag-mp":{"a":"Northern Mariana Islands Flag","b":"1F1F2-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[3,14],"o":2},"ok":{"a":"Squared Ok","b":"1F197","d":true,"e":true,"f":true,"h":true,"j":["good","agree","yes","blue-square"],"k":[0,27],"o":2},"clock11":{"a":"Clock Face Eleven Oclock","b":"1F55A","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,49],"o":2},"construction_worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB","non_qualified":null,"image":"1f477-1f3fb.png","sheet_x":23,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F477-1F3FC","non_qualified":null,"image":"1f477-1f3fc.png","sheet_x":23,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F477-1F3FD","non_qualified":null,"image":"1f477-1f3fd.png","sheet_x":23,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F477-1F3FE","non_qualified":null,"image":"1f477-1f3fe.png","sheet_x":23,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F477-1F3FF","non_qualified":null,"image":"1f477-1f3ff.png","sheet_x":23,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F477-200D-2642-FE0F","a":"Construction Worker","b":"1F477","d":true,"e":true,"f":true,"h":false,"k":[23,22],"o":2},"male-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2642-FE0F","non_qualified":"1F477-1F3FB-200D-2642","image":"1f477-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F477-1F3FC-200D-2642-FE0F","non_qualified":"1F477-1F3FC-200D-2642","image":"1f477-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F477-1F3FD-200D-2642-FE0F","non_qualified":"1F477-1F3FD-200D-2642","image":"1f477-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F477-1F3FE-200D-2642-FE0F","non_qualified":"1F477-1F3FE-200D-2642","image":"1f477-1f3fe-200d-2642-fe0f.png","sheet_x":23,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F477-1F3FF-200D-2642-FE0F","non_qualified":"1F477-1F3FF-200D-2642","image":"1f477-1f3ff-200d-2642-fe0f.png","sheet_x":23,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F477","a":"Male Construction Worker","b":"1F477-200D-2642-FE0F","c":"1F477-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[23,16],"o":4},"clock1130":{"a":"Clock Face Eleven-Thirty","b":"1F566","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,4],"o":2},"flag-mq":{"a":"Martinique Flag","b":"1F1F2-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[3,15],"o":2},"bar_chart":{"a":"Bar Chart","b":"1F4CA","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats"],"k":[26,32],"o":2},"parking":{"a":"Negative Squared Latin Capital Letter P","b":"1F17F-FE0F","c":"1F17F","d":true,"e":true,"f":true,"h":true,"j":["cars","blue-square","alphabet","letter"],"k":[0,19],"o":2},"new_moon":{"a":"New Moon Symbol","b":"1F311","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,36],"o":2},"female-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2640-FE0F","non_qualified":"1F477-1F3FB-200D-2640","image":"1f477-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F477-1F3FC-200D-2640-FE0F","non_qualified":"1F477-1F3FC-200D-2640","image":"1f477-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F477-1F3FD-200D-2640-FE0F","non_qualified":"1F477-1F3FD-200D-2640","image":"1f477-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F477-1F3FE-200D-2640-FE0F","non_qualified":"1F477-1F3FE-200D-2640","image":"1f477-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F477-1F3FF-200D-2640-FE0F","non_qualified":"1F477-1F3FF-200D-2640","image":"1f477-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Construction Worker","b":"1F477-200D-2640-FE0F","c":"1F477-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[23,10],"o":4},"sos":{"a":"Squared Sos","b":"1F198","d":true,"e":true,"f":true,"h":true,"j":["help","red-square","words","emergency","911"],"k":[0,28],"o":2},"clipboard":{"a":"Clipboard","b":"1F4CB","d":true,"e":true,"f":true,"h":true,"j":["stationery","documents"],"k":[26,33],"o":2},"flag-mr":{"a":"Mauritania Flag","b":"1F1F2-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,16],"o":2},"prince":{"skin_variations":{"1F3FB":{"unified":"1F934-1F3FB","non_qualified":null,"image":"1f934-1f3fb.png","sheet_x":39,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F934-1F3FC","non_qualified":null,"image":"1f934-1f3fc.png","sheet_x":39,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F934-1F3FD","non_qualified":null,"image":"1f934-1f3fd.png","sheet_x":39,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F934-1F3FE","non_qualified":null,"image":"1f934-1f3fe.png","sheet_x":39,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F934-1F3FF","non_qualified":null,"image":"1f934-1f3ff.png","sheet_x":39,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Prince","b":"1F934","d":true,"e":true,"f":true,"h":true,"j":["boy","man","male","crown","royal","king"],"k":[39,17],"o":4},"waxing_crescent_moon":{"a":"Waxing Crescent Moon Symbol","b":"1F312","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,37],"o":2},"flag-ms":{"a":"Montserrat Flag","b":"1F1F2-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,17],"o":2},"pushpin":{"a":"Pushpin","b":"1F4CC","d":true,"e":true,"f":true,"h":true,"j":["stationery","mark","here"],"k":[26,34],"o":2},"up":{"a":"Squared Up with Exclamation Mark","b":"1F199","d":true,"e":true,"f":true,"h":true,"j":["blue-square","above","high"],"k":[0,29],"o":2},"flag-mt":{"a":"Malta Flag","b":"1F1F2-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[3,18],"o":2},"princess":{"skin_variations":{"1F3FB":{"unified":"1F478-1F3FB","non_qualified":null,"image":"1f478-1f3fb.png","sheet_x":23,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F478-1F3FC","non_qualified":null,"image":"1f478-1f3fc.png","sheet_x":23,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F478-1F3FD","non_qualified":null,"image":"1f478-1f3fd.png","sheet_x":23,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F478-1F3FE","non_qualified":null,"image":"1f478-1f3fe.png","sheet_x":23,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F478-1F3FF","non_qualified":null,"image":"1f478-1f3ff.png","sheet_x":23,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Princess","b":"1F478","d":true,"e":true,"f":true,"h":true,"j":["girl","woman","female","blond","crown","royal","queen"],"k":[23,28],"o":2},"round_pushpin":{"a":"Round Pushpin","b":"1F4CD","d":true,"e":true,"f":true,"h":true,"j":["stationery","location","map","here"],"k":[26,35],"o":2},"first_quarter_moon":{"a":"First Quarter Moon Symbol","b":"1F313","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,38],"o":2},"vs":{"a":"Squared Vs","b":"1F19A","d":true,"e":true,"f":true,"h":true,"j":["words","orange-square"],"k":[0,30],"o":2},"flag-mu":{"a":"Mauritius Flag","b":"1F1F2-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[3,19],"o":2},"koko":{"a":"Squared Katakana Koko","b":"1F201","d":true,"e":true,"f":true,"h":true,"j":["blue-square","here","katakana","japanese","destination"],"k":[5,4],"o":2},"man_with_turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB","non_qualified":null,"image":"1f473-1f3fb.png","sheet_x":22,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F473-1F3FC","non_qualified":null,"image":"1f473-1f3fc.png","sheet_x":22,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F473-1F3FD","non_qualified":null,"image":"1f473-1f3fd.png","sheet_x":22,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F473-1F3FE","non_qualified":null,"image":"1f473-1f3fe.png","sheet_x":22,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F473-1F3FF","non_qualified":null,"image":"1f473-1f3ff.png","sheet_x":22,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F473-200D-2642-FE0F","a":"Man with Turban","b":"1F473","d":true,"e":true,"f":true,"h":false,"j":["male","indian","hinduism","arabs"],"k":[22,43],"o":2},"moon":{"a":"Waxing Gibbous Moon Symbol","b":"1F314","d":true,"e":true,"f":true,"h":true,"k":[5,39],"n":["waxing_gibbous_moon"],"o":2},"paperclip":{"a":"Paperclip","b":"1F4CE","d":true,"e":true,"f":true,"h":true,"j":["documents","stationery"],"k":[26,36],"o":2},"linked_paperclips":{"a":"Linked Paperclips","b":"1F587-FE0F","c":"1F587","d":true,"e":true,"f":true,"h":true,"k":[29,43],"o":2},"man-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2642-FE0F","non_qualified":"1F473-1F3FB-200D-2642","image":"1f473-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F473-1F3FC-200D-2642-FE0F","non_qualified":"1F473-1F3FC-200D-2642","image":"1f473-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F473-1F3FD-200D-2642-FE0F","non_qualified":"1F473-1F3FD-200D-2642","image":"1f473-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F473-1F3FE-200D-2642-FE0F","non_qualified":"1F473-1F3FE-200D-2642","image":"1f473-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F473-1F3FF-200D-2642-FE0F","non_qualified":"1F473-1F3FF-200D-2642","image":"1f473-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F473","a":"Man Wearing Turban","b":"1F473-200D-2642-FE0F","c":"1F473-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[22,37],"o":4},"sa":{"a":"Squared Katakana Sa","b":"1F202-FE0F","c":"1F202","d":true,"e":true,"f":true,"h":true,"j":["japanese","blue-square","katakana"],"k":[5,5],"o":2},"full_moon":{"a":"Full Moon Symbol","b":"1F315","d":true,"e":true,"f":true,"h":true,"j":["nature","yellow","twilight","planet","space","night","evening","sleep"],"k":[5,40],"o":2},"flag-mv":{"a":"Maldives Flag","b":"1F1F2-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[3,20],"o":2},"flag-mw":{"a":"Malawi Flag","b":"1F1F2-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[3,21],"o":2},"waning_gibbous_moon":{"a":"Waning Gibbous Moon Symbol","b":"1F316","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep","waxing_gibbous_moon"],"k":[5,41],"o":2},"woman-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2640-FE0F","non_qualified":"1F473-1F3FB-200D-2640","image":"1f473-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F473-1F3FC-200D-2640-FE0F","non_qualified":"1F473-1F3FC-200D-2640","image":"1f473-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F473-1F3FD-200D-2640-FE0F","non_qualified":"1F473-1F3FD-200D-2640","image":"1f473-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F473-1F3FE-200D-2640-FE0F","non_qualified":"1F473-1F3FE-200D-2640","image":"1f473-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F473-1F3FF-200D-2640-FE0F","non_qualified":"1F473-1F3FF-200D-2640","image":"1f473-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Wearing Turban","b":"1F473-200D-2640-FE0F","c":"1F473-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[22,31],"o":4},"u6708":{"a":"Squared Cjk Unified Ideograph-6708","b":"1F237-FE0F","c":"1F237","d":true,"e":true,"f":true,"h":true,"j":["chinese","month","moon","japanese","orange-square","kanji"],"k":[5,13],"o":2},"straight_ruler":{"a":"Straight Ruler","b":"1F4CF","d":true,"e":true,"f":true,"h":true,"j":["stationery","calculate","length","math","school","drawing","architect","sketch"],"k":[26,37],"o":2},"u6709":{"a":"Squared Cjk Unified Ideograph-6709","b":"1F236","d":true,"e":true,"f":true,"h":true,"j":["orange-square","chinese","have","kanji"],"k":[5,12],"o":2},"triangular_ruler":{"a":"Triangular Ruler","b":"1F4D0","d":true,"e":true,"f":true,"h":true,"j":["stationery","math","architect","sketch"],"k":[26,38],"o":2},"man_with_gua_pi_mao":{"skin_variations":{"1F3FB":{"unified":"1F472-1F3FB","non_qualified":null,"image":"1f472-1f3fb.png","sheet_x":22,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F472-1F3FC","non_qualified":null,"image":"1f472-1f3fc.png","sheet_x":22,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F472-1F3FD","non_qualified":null,"image":"1f472-1f3fd.png","sheet_x":22,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F472-1F3FE","non_qualified":null,"image":"1f472-1f3fe.png","sheet_x":22,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F472-1F3FF","non_qualified":null,"image":"1f472-1f3ff.png","sheet_x":22,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man with Gua Pi Mao","b":"1F472","d":true,"e":true,"f":true,"h":true,"j":["male","boy","chinese"],"k":[22,25],"o":2},"flag-mx":{"a":"Mexico Flag","b":"1F1F2-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[3,22],"o":2},"last_quarter_moon":{"a":"Last Quarter Moon Symbol","b":"1F317","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,42],"o":2},"person_with_headscarf":{"skin_variations":{"1F3FB":{"unified":"1F9D5-1F3FB","non_qualified":null,"image":"1f9d5-1f3fb.png","sheet_x":48,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D5-1F3FC","non_qualified":null,"image":"1f9d5-1f3fc.png","sheet_x":48,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D5-1F3FD","non_qualified":null,"image":"1f9d5-1f3fd.png","sheet_x":48,"sheet_y":37,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D5-1F3FE","non_qualified":null,"image":"1f9d5-1f3fe.png","sheet_x":48,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D5-1F3FF","non_qualified":null,"image":"1f9d5-1f3ff.png","sheet_x":48,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person with Headscarf","b":"1F9D5","d":true,"e":true,"f":true,"h":true,"k":[48,34],"o":5},"waning_crescent_moon":{"a":"Waning Crescent Moon Symbol","b":"1F318","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,43],"o":2},"u6307":{"a":"Squared Cjk Unified Ideograph-6307","b":"1F22F","d":true,"e":true,"f":true,"h":true,"j":["chinese","point","green-square","kanji"],"k":[5,7],"o":2},"scissors":{"a":"Black Scissors","b":"2702-FE0F","c":"2702","d":true,"e":true,"f":true,"h":true,"j":["stationery","cut"],"k":[54,39],"o":2},"flag-my":{"a":"Malaysia Flag","b":"1F1F2-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,23],"o":2},"ideograph_advantage":{"a":"Circled Ideograph Advantage","b":"1F250","d":true,"e":true,"f":true,"h":true,"j":["chinese","kanji","obtain","get","circle"],"k":[5,17],"o":2},"man_in_tuxedo":{"skin_variations":{"1F3FB":{"unified":"1F935-1F3FB","non_qualified":null,"image":"1f935-1f3fb.png","sheet_x":39,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F935-1F3FC","non_qualified":null,"image":"1f935-1f3fc.png","sheet_x":39,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F935-1F3FD","non_qualified":null,"image":"1f935-1f3fd.png","sheet_x":39,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F935-1F3FE","non_qualified":null,"image":"1f935-1f3fe.png","sheet_x":39,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F935-1F3FF","non_qualified":null,"image":"1f935-1f3ff.png","sheet_x":39,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Tuxedo","b":"1F935","d":true,"e":true,"f":true,"h":true,"j":["couple","marriage","wedding","groom"],"k":[39,23],"o":4},"flag-mz":{"a":"Mozambique Flag","b":"1F1F2-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[3,24],"o":2},"card_file_box":{"a":"Card File Box","b":"1F5C3-FE0F","c":"1F5C3","d":true,"e":true,"f":true,"h":true,"j":["business","stationery"],"k":[30,16],"o":2},"crescent_moon":{"a":"Crescent Moon","b":"1F319","d":true,"e":true,"f":true,"h":true,"j":["night","sleep","sky","evening","magic"],"k":[5,44],"o":2},"flag-na":{"a":"Namibia Flag","b":"1F1F3-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,25],"o":2},"bride_with_veil":{"skin_variations":{"1F3FB":{"unified":"1F470-1F3FB","non_qualified":null,"image":"1f470-1f3fb.png","sheet_x":22,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F470-1F3FC","non_qualified":null,"image":"1f470-1f3fc.png","sheet_x":22,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F470-1F3FD","non_qualified":null,"image":"1f470-1f3fd.png","sheet_x":22,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F470-1F3FE","non_qualified":null,"image":"1f470-1f3fe.png","sheet_x":22,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F470-1F3FF","non_qualified":null,"image":"1f470-1f3ff.png","sheet_x":22,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bride with Veil","b":"1F470","d":true,"e":true,"f":true,"h":true,"j":["couple","marriage","wedding","woman","bride"],"k":[22,1],"o":2},"new_moon_with_face":{"a":"New Moon with Face","b":"1F31A","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,45],"o":2},"file_cabinet":{"a":"File Cabinet","b":"1F5C4-FE0F","c":"1F5C4","d":true,"e":true,"f":true,"h":true,"j":["filing","organizing"],"k":[30,17],"o":2},"u5272":{"a":"Squared Cjk Unified Ideograph-5272","b":"1F239","d":true,"e":true,"f":true,"h":true,"j":["cut","divide","chinese","kanji","pink-square"],"k":[5,15],"o":2},"wastebasket":{"a":"Wastebasket","b":"1F5D1-FE0F","c":"1F5D1","d":true,"e":true,"f":true,"h":true,"j":["bin","trash","rubbish","garbage","toss"],"k":[30,18],"o":2},"pregnant_woman":{"skin_variations":{"1F3FB":{"unified":"1F930-1F3FB","non_qualified":null,"image":"1f930-1f3fb.png","sheet_x":38,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F930-1F3FC","non_qualified":null,"image":"1f930-1f3fc.png","sheet_x":38,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F930-1F3FD","non_qualified":null,"image":"1f930-1f3fd.png","sheet_x":38,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F930-1F3FE","non_qualified":null,"image":"1f930-1f3fe.png","sheet_x":38,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F930-1F3FF","non_qualified":null,"image":"1f930-1f3ff.png","sheet_x":38,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Pregnant Woman","b":"1F930","d":true,"e":true,"f":true,"h":true,"j":["baby"],"k":[38,50],"o":4},"first_quarter_moon_with_face":{"a":"First Quarter Moon with Face","b":"1F31B","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,46],"o":2},"flag-nc":{"a":"New Caledonia Flag","b":"1F1F3-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[3,26],"o":2},"u7121":{"a":"Squared Cjk Unified Ideograph-7121","b":"1F21A","d":true,"e":true,"f":true,"h":true,"j":["nothing","chinese","kanji","japanese","orange-square"],"k":[5,6],"o":2},"lock":{"a":"Lock","b":"1F512","d":true,"e":true,"f":true,"h":true,"j":["security","password","padlock"],"k":[27,46],"o":2},"flag-ne":{"a":"Niger Flag","b":"1F1F3-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,27],"o":2},"last_quarter_moon_with_face":{"a":"Last Quarter Moon with Face","b":"1F31C","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,47],"o":2},"breast-feeding":{"skin_variations":{"1F3FB":{"unified":"1F931-1F3FB","non_qualified":null,"image":"1f931-1f3fb.png","sheet_x":39,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F931-1F3FC","non_qualified":null,"image":"1f931-1f3fc.png","sheet_x":39,"sheet_y":1,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F931-1F3FD","non_qualified":null,"image":"1f931-1f3fd.png","sheet_x":39,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F931-1F3FE","non_qualified":null,"image":"1f931-1f3fe.png","sheet_x":39,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F931-1F3FF","non_qualified":null,"image":"1f931-1f3ff.png","sheet_x":39,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Breast-Feeding","b":"1F931","d":true,"e":true,"f":true,"h":true,"k":[38,56],"o":5},"u7981":{"a":"Squared Cjk Unified Ideograph-7981","b":"1F232","d":true,"e":true,"f":true,"h":true,"j":["kanji","japanese","chinese","forbidden","limit","restricted","red-square"],"k":[5,8],"o":2},"accept":{"a":"Circled Ideograph Accept","b":"1F251","d":true,"e":true,"f":true,"h":true,"j":["ok","good","chinese","kanji","agree","yes","orange-circle"],"k":[5,18],"o":2},"angel":{"skin_variations":{"1F3FB":{"unified":"1F47C-1F3FB","non_qualified":null,"image":"1f47c-1f3fb.png","sheet_x":23,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F47C-1F3FC","non_qualified":null,"image":"1f47c-1f3fc.png","sheet_x":23,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F47C-1F3FD","non_qualified":null,"image":"1f47c-1f3fd.png","sheet_x":23,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F47C-1F3FE","non_qualified":null,"image":"1f47c-1f3fe.png","sheet_x":23,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F47C-1F3FF","non_qualified":null,"image":"1f47c-1f3ff.png","sheet_x":23,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Baby Angel","b":"1F47C","d":true,"e":true,"f":true,"h":true,"j":["heaven","wings","halo"],"k":[23,37],"o":2},"unlock":{"a":"Open Lock","b":"1F513","d":true,"e":true,"f":true,"h":true,"j":["privacy","security"],"k":[27,47],"o":2},"flag-nf":{"a":"Norfolk Island Flag","b":"1F1F3-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,28],"o":2},"thermometer":{"a":"Thermometer","b":"1F321-FE0F","c":"1F321","d":true,"e":true,"f":true,"h":true,"j":["weather","temperature","hot","cold"],"k":[5,52],"o":2},"flag-ng":{"a":"Nigeria Flag","b":"1F1F3-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,29],"o":2},"u7533":{"a":"Squared Cjk Unified Ideograph-7533","b":"1F238","d":true,"e":true,"f":true,"h":true,"j":["chinese","japanese","kanji","orange-square"],"k":[5,14],"o":2},"sunny":{"a":"Black Sun with Rays","b":"2600-FE0F","c":"2600","d":true,"e":true,"f":true,"h":true,"j":["weather","nature","brightness","summer","beach","spring"],"k":[52,49],"o":2},"lock_with_ink_pen":{"a":"Lock with Ink Pen","b":"1F50F","d":true,"e":true,"f":true,"h":true,"j":["security","secret"],"k":[27,43],"o":2},"santa":{"skin_variations":{"1F3FB":{"unified":"1F385-1F3FB","non_qualified":null,"image":"1f385-1f3fb.png","sheet_x":7,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F385-1F3FC","non_qualified":null,"image":"1f385-1f3fc.png","sheet_x":7,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F385-1F3FD","non_qualified":null,"image":"1f385-1f3fd.png","sheet_x":7,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F385-1F3FE","non_qualified":null,"image":"1f385-1f3fe.png","sheet_x":7,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F385-1F3FF","non_qualified":null,"image":"1f385-1f3ff.png","sheet_x":7,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Father Christmas","b":"1F385","d":true,"e":true,"f":true,"h":true,"j":["festival","man","male","xmas","father christmas"],"k":[7,36],"o":2},"closed_lock_with_key":{"a":"Closed Lock with Key","b":"1F510","d":true,"e":true,"f":true,"h":true,"j":["security","privacy"],"k":[27,44],"o":2},"u5408":{"a":"Squared Cjk Unified Ideograph-5408","b":"1F234","d":true,"e":true,"f":true,"h":true,"j":["japanese","chinese","join","kanji","red-square"],"k":[5,10],"o":2},"flag-ni":{"a":"Nicaragua Flag","b":"1F1F3-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[3,30],"o":2},"mrs_claus":{"skin_variations":{"1F3FB":{"unified":"1F936-1F3FB","non_qualified":null,"image":"1f936-1f3fb.png","sheet_x":39,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F936-1F3FC","non_qualified":null,"image":"1f936-1f3fc.png","sheet_x":39,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F936-1F3FD","non_qualified":null,"image":"1f936-1f3fd.png","sheet_x":39,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F936-1F3FE","non_qualified":null,"image":"1f936-1f3fe.png","sheet_x":39,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F936-1F3FF","non_qualified":null,"image":"1f936-1f3ff.png","sheet_x":39,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Mother Christmas","b":"1F936","d":true,"e":true,"f":true,"h":true,"j":["woman","female","xmas","mother christmas"],"k":[39,29],"n":["mother_christmas"],"o":4},"full_moon_with_face":{"a":"Full Moon with Face","b":"1F31D","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,48],"o":2},"key":{"a":"Key","b":"1F511","d":true,"e":true,"f":true,"h":true,"j":["lock","door","password"],"k":[27,45],"o":2},"superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB","non_qualified":null,"image":"1f9b8-1f3fb.png","sheet_x":43,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC","non_qualified":null,"image":"1f9b8-1f3fc.png","sheet_x":43,"sheet_y":32,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD","non_qualified":null,"image":"1f9b8-1f3fd.png","sheet_x":43,"sheet_y":33,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE","non_qualified":null,"image":"1f9b8-1f3fe.png","sheet_x":43,"sheet_y":34,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF","non_qualified":null,"image":"1f9b8-1f3ff.png","sheet_x":43,"sheet_y":35,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Superhero","b":"1F9B8","d":true,"e":true,"f":true,"h":true,"k":[43,30],"o":11},"flag-nl":{"a":"Netherlands Flag","b":"1F1F3-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,31],"o":2},"u7a7a":{"a":"Squared Cjk Unified Ideograph-7a7a","b":"1F233","d":true,"e":true,"f":true,"h":true,"j":["kanji","japanese","chinese","empty","sky","blue-square"],"k":[5,9],"o":2},"sun_with_face":{"a":"Sun with Face","b":"1F31E","d":true,"e":true,"f":true,"h":true,"j":["nature","morning","sky"],"k":[5,49],"o":2},"male_superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB-200D-2642-FE0F","non_qualified":"1F9B8-1F3FB-200D-2642","image":"1f9b8-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC-200D-2642-FE0F","non_qualified":"1F9B8-1F3FC-200D-2642","image":"1f9b8-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":26,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD-200D-2642-FE0F","non_qualified":"1F9B8-1F3FD-200D-2642","image":"1f9b8-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE-200D-2642-FE0F","non_qualified":"1F9B8-1F3FE-200D-2642","image":"1f9b8-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF-200D-2642-FE0F","non_qualified":"1F9B8-1F3FF-200D-2642","image":"1f9b8-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":29,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Superhero","b":"1F9B8-200D-2642-FE0F","c":"1F9B8-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[43,24],"o":11},"ringed_planet":{"a":"Ringed Planet","b":"1FA90","d":true,"e":true,"f":true,"h":true,"k":[52,4],"o":12},"old_key":{"a":"Old Key","b":"1F5DD-FE0F","c":"1F5DD","d":true,"e":true,"f":true,"h":true,"j":["lock","door","password"],"k":[30,22],"o":2},"congratulations":{"a":"Circled Ideograph Congratulation","b":"3297-FE0F","c":"3297","d":true,"e":true,"f":true,"h":true,"j":["chinese","kanji","japanese","red-circle"],"k":[55,46],"o":2},"flag-no":{"a":"Norway Flag","b":"1F1F3-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,32],"o":2},"star":{"a":"White Medium Star","b":"2B50","d":true,"e":true,"f":true,"h":true,"j":["night","yellow"],"k":[55,42],"o":2},"secret":{"a":"Circled Ideograph Secret","b":"3299-FE0F","c":"3299","d":true,"e":true,"f":true,"h":true,"j":["privacy","chinese","sshh","kanji","red-circle"],"k":[55,47],"o":2},"flag-np":{"a":"Nepal Flag","b":"1F1F3-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[3,33],"o":2},"female_superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB-200D-2640-FE0F","non_qualified":"1F9B8-1F3FB-200D-2640","image":"1f9b8-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":19,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC-200D-2640-FE0F","non_qualified":"1F9B8-1F3FC-200D-2640","image":"1f9b8-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":20,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD-200D-2640-FE0F","non_qualified":"1F9B8-1F3FD-200D-2640","image":"1f9b8-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":21,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE-200D-2640-FE0F","non_qualified":"1F9B8-1F3FE-200D-2640","image":"1f9b8-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":22,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF-200D-2640-FE0F","non_qualified":"1F9B8-1F3FF-200D-2640","image":"1f9b8-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":23,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Superhero","b":"1F9B8-200D-2640-FE0F","c":"1F9B8-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[43,18],"o":11},"hammer":{"a":"Hammer","b":"1F528","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[28,11],"o":2},"star2":{"a":"Glowing Star","b":"1F31F","d":true,"e":true,"f":true,"h":true,"j":["night","sparkle","awesome","good","magic"],"k":[5,50],"o":2},"flag-nr":{"a":"Nauru Flag","b":"1F1F3-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,34],"o":2},"axe":{"a":"Axe","b":"1FA93","d":true,"e":true,"f":true,"h":true,"k":[52,7],"o":12},"u55b6":{"a":"Squared Cjk Unified Ideograph-55b6","b":"1F23A","d":true,"e":true,"f":true,"h":true,"j":["japanese","opening hours","orange-square"],"k":[5,16],"o":2},"supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB","non_qualified":null,"image":"1f9b9-1f3fb.png","sheet_x":43,"sheet_y":49,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC","non_qualified":null,"image":"1f9b9-1f3fc.png","sheet_x":43,"sheet_y":50,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD","non_qualified":null,"image":"1f9b9-1f3fd.png","sheet_x":43,"sheet_y":51,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE","non_qualified":null,"image":"1f9b9-1f3fe.png","sheet_x":43,"sheet_y":52,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF","non_qualified":null,"image":"1f9b9-1f3ff.png","sheet_x":43,"sheet_y":53,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Supervillain","b":"1F9B9","d":true,"e":true,"f":true,"h":true,"k":[43,48],"o":11},"stars":{"a":"Shooting Star","b":"1F320","d":true,"e":true,"f":true,"h":true,"j":["night","photo"],"k":[5,51],"o":2},"u6e80":{"a":"Squared Cjk Unified Ideograph-6e80","b":"1F235","d":true,"e":true,"f":true,"h":true,"j":["full","chinese","japanese","red-square","kanji"],"k":[5,11],"o":2},"flag-nu":{"a":"Niue Flag","b":"1F1F3-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[3,35],"o":2},"pick":{"a":"Pick","b":"26CF-FE0F","c":"26CF","d":true,"e":true,"f":true,"h":true,"j":["tools","dig"],"k":[54,5],"o":2},"male_supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB-200D-2642-FE0F","non_qualified":"1F9B9-1F3FB-200D-2642","image":"1f9b9-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":43,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC-200D-2642-FE0F","non_qualified":"1F9B9-1F3FC-200D-2642","image":"1f9b9-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":44,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD-200D-2642-FE0F","non_qualified":"1F9B9-1F3FD-200D-2642","image":"1f9b9-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":45,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE-200D-2642-FE0F","non_qualified":"1F9B9-1F3FE-200D-2642","image":"1f9b9-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":46,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF-200D-2642-FE0F","non_qualified":"1F9B9-1F3FF-200D-2642","image":"1f9b9-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":47,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Supervillain","b":"1F9B9-200D-2642-FE0F","c":"1F9B9-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[43,42],"o":11},"female_supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB-200D-2640-FE0F","non_qualified":"1F9B9-1F3FB-200D-2640","image":"1f9b9-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":37,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC-200D-2640-FE0F","non_qualified":"1F9B9-1F3FC-200D-2640","image":"1f9b9-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":38,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD-200D-2640-FE0F","non_qualified":"1F9B9-1F3FD-200D-2640","image":"1f9b9-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":39,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE-200D-2640-FE0F","non_qualified":"1F9B9-1F3FE-200D-2640","image":"1f9b9-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":40,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF-200D-2640-FE0F","non_qualified":"1F9B9-1F3FF-200D-2640","image":"1f9b9-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":41,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Supervillain","b":"1F9B9-200D-2640-FE0F","c":"1F9B9-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[43,36],"o":11},"hammer_and_pick":{"a":"Hammer and Pick","b":"2692-FE0F","c":"2692","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[53,41],"o":2},"milky_way":{"a":"Milky Way","b":"1F30C","d":true,"e":true,"f":true,"h":true,"j":["photo","space","stars"],"k":[5,31],"o":2},"red_circle":{"a":"Large Red Circle","b":"1F534","d":true,"e":true,"f":true,"h":true,"j":["shape","error","danger"],"k":[28,23],"o":2},"flag-nz":{"a":"New Zealand Flag","b":"1F1F3-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[3,36],"o":2},"large_orange_circle":{"a":"Large Orange Circle","b":"1F7E0","d":true,"e":true,"f":true,"h":true,"k":[37,3],"o":12},"hammer_and_wrench":{"a":"Hammer and Wrench","b":"1F6E0-FE0F","c":"1F6E0","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[36,42],"o":2},"flag-om":{"a":"Oman Flag","b":"1F1F4-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,37],"o":2},"cloud":{"a":"Cloud","b":"2601-FE0F","c":"2601","d":true,"e":true,"f":true,"h":true,"j":["weather","sky"],"k":[52,50],"o":2},"mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB","non_qualified":null,"image":"1f9d9-1f3fb.png","sheet_x":49,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D9-1F3FC","non_qualified":null,"image":"1f9d9-1f3fc.png","sheet_x":49,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D9-1F3FD","non_qualified":null,"image":"1f9d9-1f3fd.png","sheet_x":49,"sheet_y":52,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D9-1F3FE","non_qualified":null,"image":"1f9d9-1f3fe.png","sheet_x":49,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D9-1F3FF","non_qualified":null,"image":"1f9d9-1f3ff.png","sheet_x":49,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D9-200D-2640-FE0F","a":"Mage","b":"1F9D9","d":true,"e":true,"f":true,"h":true,"k":[49,49],"o":5},"dagger_knife":{"a":"Dagger Knife","b":"1F5E1-FE0F","c":"1F5E1","d":true,"e":true,"f":true,"h":true,"k":[30,24],"o":2},"partly_sunny":{"a":"Sun Behind Cloud","b":"26C5","d":true,"e":true,"f":true,"h":true,"j":["weather","nature","cloudy","morning","fall","spring"],"k":[54,2],"o":2},"large_yellow_circle":{"a":"Large Yellow Circle","b":"1F7E1","d":true,"e":true,"f":true,"h":true,"k":[37,4],"o":12},"male_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2642-FE0F","non_qualified":"1F9D9-1F3FB-200D-2642","image":"1f9d9-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2642-FE0F","non_qualified":"1F9D9-1F3FC-200D-2642","image":"1f9d9-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2642-FE0F","non_qualified":"1F9D9-1F3FD-200D-2642","image":"1f9d9-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":46,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2642-FE0F","non_qualified":"1F9D9-1F3FE-200D-2642","image":"1f9d9-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2642-FE0F","non_qualified":"1F9D9-1F3FF-200D-2642","image":"1f9d9-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Mage","b":"1F9D9-200D-2642-FE0F","c":"1F9D9-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,43],"o":5},"flag-pa":{"a":"Panama Flag","b":"1F1F5-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,38],"o":2},"thunder_cloud_and_rain":{"a":"Thunder Cloud and Rain","b":"26C8-FE0F","c":"26C8","d":true,"e":true,"f":true,"h":true,"k":[54,3],"o":2},"large_green_circle":{"a":"Large Green Circle","b":"1F7E2","d":true,"e":true,"f":true,"h":true,"k":[37,5],"o":12},"female_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2640-FE0F","non_qualified":"1F9D9-1F3FB-200D-2640","image":"1f9d9-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FB"},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2640-FE0F","non_qualified":"1F9D9-1F3FC-200D-2640","image":"1f9d9-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FC"},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2640-FE0F","non_qualified":"1F9D9-1F3FD-200D-2640","image":"1f9d9-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":40,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FD"},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2640-FE0F","non_qualified":"1F9D9-1F3FE-200D-2640","image":"1f9d9-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FE"},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2640-FE0F","non_qualified":"1F9D9-1F3FF-200D-2640","image":"1f9d9-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FF"}},"obsoletes":"1F9D9","a":"Female Mage","b":"1F9D9-200D-2640-FE0F","c":"1F9D9-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,37],"o":5},"crossed_swords":{"a":"Crossed Swords","b":"2694-FE0F","c":"2694","d":true,"e":true,"f":true,"h":true,"j":["weapon"],"k":[53,43],"o":2},"flag-pe":{"a":"Peru Flag","b":"1F1F5-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,39],"o":2},"gun":{"a":"Pistol","b":"1F52B","d":true,"e":true,"f":true,"h":true,"j":["violence","weapon","pistol","revolver"],"k":[28,14],"o":2},"mostly_sunny":{"a":"Mostly Sunny","b":"1F324-FE0F","c":"1F324","d":true,"e":true,"f":true,"h":true,"k":[5,53],"n":["sun_small_cloud"],"o":2},"fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB","non_qualified":null,"image":"1f9da-1f3fb.png","sheet_x":50,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DA-1F3FC","non_qualified":null,"image":"1f9da-1f3fc.png","sheet_x":50,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DA-1F3FD","non_qualified":null,"image":"1f9da-1f3fd.png","sheet_x":50,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DA-1F3FE","non_qualified":null,"image":"1f9da-1f3fe.png","sheet_x":50,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DA-1F3FF","non_qualified":null,"image":"1f9da-1f3ff.png","sheet_x":50,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DA-200D-2640-FE0F","a":"Fairy","b":"1F9DA","d":true,"e":true,"f":true,"h":true,"k":[50,10],"o":5},"flag-pf":{"a":"French Polynesia Flag","b":"1F1F5-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,40],"o":2},"large_blue_circle":{"a":"Large Blue Circle","b":"1F535","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","button"],"k":[28,24],"o":2},"large_purple_circle":{"a":"Large Purple Circle","b":"1F7E3","d":true,"e":true,"f":true,"h":true,"k":[37,6],"o":12},"bow_and_arrow":{"a":"Bow and Arrow","b":"1F3F9","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[11,21],"o":2},"male_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2642-FE0F","non_qualified":"1F9DA-1F3FB-200D-2642","image":"1f9da-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2642-FE0F","non_qualified":"1F9DA-1F3FC-200D-2642","image":"1f9da-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2642-FE0F","non_qualified":"1F9DA-1F3FD-200D-2642","image":"1f9da-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":7,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2642-FE0F","non_qualified":"1F9DA-1F3FE-200D-2642","image":"1f9da-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2642-FE0F","non_qualified":"1F9DA-1F3FF-200D-2642","image":"1f9da-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Male Fairy","b":"1F9DA-200D-2642-FE0F","c":"1F9DA-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,4],"o":5},"barely_sunny":{"a":"Barely Sunny","b":"1F325-FE0F","c":"1F325","d":true,"e":true,"f":true,"h":true,"k":[5,54],"n":["sun_behind_cloud"],"o":2},"flag-pg":{"a":"Papua New Guinea Flag","b":"1F1F5-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,41],"o":2},"shield":{"a":"Shield","b":"1F6E1-FE0F","c":"1F6E1","d":true,"e":true,"f":true,"h":true,"j":["protection","security"],"k":[36,43],"o":2},"partly_sunny_rain":{"a":"Partly Sunny Rain","b":"1F326-FE0F","c":"1F326","d":true,"e":true,"f":true,"h":true,"k":[5,55],"n":["sun_behind_rain_cloud"],"o":2},"large_brown_circle":{"a":"Large Brown Circle","b":"1F7E4","d":true,"e":true,"f":true,"h":true,"k":[37,7],"o":12},"female_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2640-FE0F","non_qualified":"1F9DA-1F3FB-200D-2640","image":"1f9da-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FB"},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2640-FE0F","non_qualified":"1F9DA-1F3FC-200D-2640","image":"1f9da-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FC"},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2640-FE0F","non_qualified":"1F9DA-1F3FD-200D-2640","image":"1f9da-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":1,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FD"},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2640-FE0F","non_qualified":"1F9DA-1F3FE-200D-2640","image":"1f9da-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FE"},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2640-FE0F","non_qualified":"1F9DA-1F3FF-200D-2640","image":"1f9da-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FF"}},"obsoletes":"1F9DA","a":"Female Fairy","b":"1F9DA-200D-2640-FE0F","c":"1F9DA-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,55],"o":5},"flag-ph":{"a":"Philippines Flag","b":"1F1F5-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[3,42],"o":2},"flag-pk":{"a":"Pakistan Flag","b":"1F1F5-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[3,43],"o":2},"black_circle":{"a":"Medium Black Circle","b":"26AB","d":true,"e":true,"f":true,"h":true,"j":["shape","button","round"],"k":[53,53],"o":2},"wrench":{"a":"Wrench","b":"1F527","d":true,"e":true,"f":true,"h":true,"j":["tools","diy","ikea","fix","maintainer"],"k":[28,10],"o":2},"vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB","non_qualified":null,"image":"1f9db-1f3fb.png","sheet_x":50,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DB-1F3FC","non_qualified":null,"image":"1f9db-1f3fc.png","sheet_x":50,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DB-1F3FD","non_qualified":null,"image":"1f9db-1f3fd.png","sheet_x":50,"sheet_y":31,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DB-1F3FE","non_qualified":null,"image":"1f9db-1f3fe.png","sheet_x":50,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DB-1F3FF","non_qualified":null,"image":"1f9db-1f3ff.png","sheet_x":50,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DB-200D-2640-FE0F","a":"Vampire","b":"1F9DB","d":true,"e":true,"f":true,"h":true,"k":[50,28],"o":5},"rain_cloud":{"a":"Rain Cloud","b":"1F327-FE0F","c":"1F327","d":true,"e":true,"f":true,"h":true,"k":[5,56],"o":2},"snow_cloud":{"a":"Snow Cloud","b":"1F328-FE0F","c":"1F328","d":true,"e":true,"f":true,"h":true,"k":[6,0],"o":2},"flag-pl":{"a":"Poland Flag","b":"1F1F5-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,44],"o":2},"male_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2642-FE0F","non_qualified":"1F9DB-1F3FB-200D-2642","image":"1f9db-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2642-FE0F","non_qualified":"1F9DB-1F3FC-200D-2642","image":"1f9db-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2642-FE0F","non_qualified":"1F9DB-1F3FD-200D-2642","image":"1f9db-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":25,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2642-FE0F","non_qualified":"1F9DB-1F3FE-200D-2642","image":"1f9db-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2642-FE0F","non_qualified":"1F9DB-1F3FF-200D-2642","image":"1f9db-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Vampire","b":"1F9DB-200D-2642-FE0F","c":"1F9DB-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,22],"o":5},"nut_and_bolt":{"a":"Nut and Bolt","b":"1F529","d":true,"e":true,"f":true,"h":true,"j":["handy","tools","fix"],"k":[28,12],"o":2},"white_circle":{"a":"Medium White Circle","b":"26AA","d":true,"e":true,"f":true,"h":true,"j":["shape","round"],"k":[53,52],"o":2},"female_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2640-FE0F","non_qualified":"1F9DB-1F3FB-200D-2640","image":"1f9db-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FB"},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2640-FE0F","non_qualified":"1F9DB-1F3FC-200D-2640","image":"1f9db-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FC"},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2640-FE0F","non_qualified":"1F9DB-1F3FD-200D-2640","image":"1f9db-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":19,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FD"},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2640-FE0F","non_qualified":"1F9DB-1F3FE-200D-2640","image":"1f9db-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FE"},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2640-FE0F","non_qualified":"1F9DB-1F3FF-200D-2640","image":"1f9db-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FF"}},"obsoletes":"1F9DB","a":"Female Vampire","b":"1F9DB-200D-2640-FE0F","c":"1F9DB-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,16],"o":5},"flag-pm":{"a":"St. Pierre & Miquelon Flag","b":"1F1F5-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,45],"o":2},"large_red_square":{"a":"Large Red Square","b":"1F7E5","d":true,"e":true,"f":true,"h":true,"k":[37,8],"o":12},"lightning":{"a":"Lightning","b":"1F329-FE0F","c":"1F329","d":true,"e":true,"f":true,"h":true,"k":[6,1],"n":["lightning_cloud"],"o":2},"gear":{"a":"Gear","b":"2699-FE0F","c":"2699","d":true,"e":true,"f":true,"h":true,"j":["cog"],"k":[53,47],"o":2},"merperson":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB","non_qualified":null,"image":"1f9dc-1f3fb.png","sheet_x":50,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DC-1F3FC","non_qualified":null,"image":"1f9dc-1f3fc.png","sheet_x":50,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DC-1F3FD","non_qualified":null,"image":"1f9dc-1f3fd.png","sheet_x":50,"sheet_y":49,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DC-1F3FE","non_qualified":null,"image":"1f9dc-1f3fe.png","sheet_x":50,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DC-1F3FF","non_qualified":null,"image":"1f9dc-1f3ff.png","sheet_x":50,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DC-200D-2642-FE0F","a":"Merperson","b":"1F9DC","d":true,"e":true,"f":true,"h":true,"k":[50,46],"o":5},"tornado":{"a":"Tornado","b":"1F32A-FE0F","c":"1F32A","d":true,"e":true,"f":true,"h":true,"j":["weather","cyclone","twister"],"k":[6,2],"n":["tornado_cloud"],"o":2},"large_orange_square":{"a":"Large Orange Square","b":"1F7E7","d":true,"e":true,"f":true,"h":true,"k":[37,10],"o":12},"flag-pn":{"a":"Pitcairn Islands Flag","b":"1F1F5-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[3,46],"o":2},"compression":{"a":"Compression","b":"1F5DC-FE0F","c":"1F5DC","d":true,"e":true,"f":true,"h":true,"k":[30,21],"o":2},"merman":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2642-FE0F","non_qualified":"1F9DC-1F3FB-200D-2642","image":"1f9dc-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FB"},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2642-FE0F","non_qualified":"1F9DC-1F3FC-200D-2642","image":"1f9dc-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FC"},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2642-FE0F","non_qualified":"1F9DC-1F3FD-200D-2642","image":"1f9dc-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":43,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FD"},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2642-FE0F","non_qualified":"1F9DC-1F3FE-200D-2642","image":"1f9dc-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FE"},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2642-FE0F","non_qualified":"1F9DC-1F3FF-200D-2642","image":"1f9dc-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FF"}},"obsoletes":"1F9DC","a":"Merman","b":"1F9DC-200D-2642-FE0F","c":"1F9DC-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,40],"o":5},"large_yellow_square":{"a":"Large Yellow Square","b":"1F7E8","d":true,"e":true,"f":true,"h":true,"k":[37,11],"o":12},"fog":{"a":"Fog","b":"1F32B-FE0F","c":"1F32B","d":true,"e":true,"f":true,"h":true,"j":["weather"],"k":[6,3],"o":2},"scales":{"a":"Scales","b":"2696-FE0F","c":"2696","d":true,"e":true,"f":true,"h":true,"k":[53,45],"o":2},"flag-pr":{"a":"Puerto Rico Flag","b":"1F1F5-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,47],"o":2},"wind_blowing_face":{"a":"Wind Blowing Face","b":"1F32C-FE0F","c":"1F32C","d":true,"e":true,"f":true,"h":true,"k":[6,4],"o":2},"flag-ps":{"a":"Palestinian Territories Flag","b":"1F1F5-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,48],"o":2},"mermaid":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2640-FE0F","non_qualified":"1F9DC-1F3FB-200D-2640","image":"1f9dc-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2640-FE0F","non_qualified":"1F9DC-1F3FC-200D-2640","image":"1f9dc-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2640-FE0F","non_qualified":"1F9DC-1F3FD-200D-2640","image":"1f9dc-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":37,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2640-FE0F","non_qualified":"1F9DC-1F3FE-200D-2640","image":"1f9dc-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2640-FE0F","non_qualified":"1F9DC-1F3FF-200D-2640","image":"1f9dc-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Mermaid","b":"1F9DC-200D-2640-FE0F","c":"1F9DC-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,34],"o":5},"probing_cane":{"a":"Probing Cane","b":"1F9AF","d":true,"e":true,"f":true,"h":true,"k":[43,3],"o":12},"large_green_square":{"a":"Large Green Square","b":"1F7E9","d":true,"e":true,"f":true,"h":true,"k":[37,12],"o":12},"flag-pt":{"a":"Portugal Flag","b":"1F1F5-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[3,49],"o":2},"link":{"a":"Link Symbol","b":"1F517","d":true,"e":true,"f":true,"h":true,"j":["rings","url"],"k":[27,51],"o":2},"large_blue_square":{"a":"Large Blue Square","b":"1F7E6","d":true,"e":true,"f":true,"h":true,"k":[37,9],"o":12},"elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB","non_qualified":null,"image":"1f9dd-1f3fb.png","sheet_x":51,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DD-1F3FC","non_qualified":null,"image":"1f9dd-1f3fc.png","sheet_x":51,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DD-1F3FD","non_qualified":null,"image":"1f9dd-1f3fd.png","sheet_x":51,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DD-1F3FE","non_qualified":null,"image":"1f9dd-1f3fe.png","sheet_x":51,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DD-1F3FF","non_qualified":null,"image":"1f9dd-1f3ff.png","sheet_x":51,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DD-200D-2642-FE0F","a":"Elf","b":"1F9DD","d":true,"e":true,"f":true,"h":true,"k":[51,7],"o":5},"cyclone":{"a":"Cyclone","b":"1F300","d":true,"e":true,"f":true,"h":true,"j":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"k":[5,19],"o":2},"rainbow":{"a":"Rainbow","b":"1F308","d":true,"e":true,"f":true,"h":true,"j":["nature","happy","unicorn_face","photo","sky","spring"],"k":[5,27],"o":2},"male_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2642-FE0F","non_qualified":"1F9DD-1F3FB-200D-2642","image":"1f9dd-1f3fb-200d-2642-fe0f.png","sheet_x":51,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FB"},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2642-FE0F","non_qualified":"1F9DD-1F3FC-200D-2642","image":"1f9dd-1f3fc-200d-2642-fe0f.png","sheet_x":51,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FC"},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2642-FE0F","non_qualified":"1F9DD-1F3FD-200D-2642","image":"1f9dd-1f3fd-200d-2642-fe0f.png","sheet_x":51,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FD"},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2642-FE0F","non_qualified":"1F9DD-1F3FE-200D-2642","image":"1f9dd-1f3fe-200d-2642-fe0f.png","sheet_x":51,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FE"},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2642-FE0F","non_qualified":"1F9DD-1F3FF-200D-2642","image":"1f9dd-1f3ff-200d-2642-fe0f.png","sheet_x":51,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FF"}},"obsoletes":"1F9DD","a":"Male Elf","b":"1F9DD-200D-2642-FE0F","c":"1F9DD-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,1],"o":5},"flag-pw":{"a":"Palau Flag","b":"1F1F5-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[3,50],"o":2},"chains":{"a":"Chains","b":"26D3-FE0F","c":"26D3","d":true,"e":true,"f":true,"h":true,"j":["lock","arrest"],"k":[54,7],"o":2},"large_purple_square":{"a":"Large Purple Square","b":"1F7EA","d":true,"e":true,"f":true,"h":true,"k":[37,13],"o":12},"female_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2640-FE0F","non_qualified":"1F9DD-1F3FB-200D-2640","image":"1f9dd-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2640-FE0F","non_qualified":"1F9DD-1F3FC-200D-2640","image":"1f9dd-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2640-FE0F","non_qualified":"1F9DD-1F3FD-200D-2640","image":"1f9dd-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":55,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2640-FE0F","non_qualified":"1F9DD-1F3FE-200D-2640","image":"1f9dd-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2640-FE0F","non_qualified":"1F9DD-1F3FF-200D-2640","image":"1f9dd-1f3ff-200d-2640-fe0f.png","sheet_x":51,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Elf","b":"1F9DD-200D-2640-FE0F","c":"1F9DD-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,52],"o":5},"flag-py":{"a":"Paraguay Flag","b":"1F1F5-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,51],"o":2},"closed_umbrella":{"a":"Closed Umbrella","b":"1F302","d":true,"e":true,"f":true,"h":true,"j":["weather","rain","drizzle"],"k":[5,21],"o":2},"toolbox":{"a":"Toolbox","b":"1F9F0","d":true,"e":true,"f":true,"h":true,"k":[51,35],"o":11},"large_brown_square":{"a":"Large Brown Square","b":"1F7EB","d":true,"e":true,"f":true,"h":true,"k":[37,14],"o":12},"magnet":{"a":"Magnet","b":"1F9F2","d":true,"e":true,"f":true,"h":true,"k":[51,37],"o":11},"genie":{"obsoleted_by":"1F9DE-200D-2642-FE0F","a":"Genie","b":"1F9DE","d":true,"e":true,"f":true,"h":true,"k":[51,15],"o":5},"flag-qa":{"a":"Qatar Flag","b":"1F1F6-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,52],"o":2},"umbrella":{"a":"Umbrella","b":"2602-FE0F","c":"2602","d":true,"e":true,"f":true,"h":true,"j":["rainy","weather","spring"],"k":[52,51],"o":2},"black_large_square":{"a":"Black Large Square","b":"2B1B","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","button"],"k":[55,40],"o":2},"male_genie":{"obsoletes":"1F9DE","a":"Male Genie","b":"1F9DE-200D-2642-FE0F","c":"1F9DE-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,14],"o":5},"umbrella_with_rain_drops":{"a":"Umbrella with Rain Drops","b":"2614","d":true,"e":true,"f":true,"h":true,"k":[52,56],"o":2},"flag-re":{"a":"Réunion Flag","b":"1F1F7-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,53],"o":2},"white_large_square":{"a":"White Large Square","b":"2B1C","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","stone","button"],"k":[55,41],"o":2},"alembic":{"a":"Alembic","b":"2697-FE0F","c":"2697","d":true,"e":true,"f":true,"h":true,"j":["distilling","science","experiment","chemistry"],"k":[53,46],"o":2},"black_medium_square":{"a":"Black Medium Square","b":"25FC-FE0F","c":"25FC","d":true,"e":true,"f":true,"h":true,"j":["shape","button","icon"],"k":[52,46],"o":2},"test_tube":{"a":"Test Tube","b":"1F9EA","d":true,"e":true,"f":true,"h":true,"k":[51,29],"o":11},"flag-ro":{"a":"Romania Flag","b":"1F1F7-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,54],"o":2},"female_genie":{"a":"Female Genie","b":"1F9DE-200D-2640-FE0F","c":"1F9DE-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[51,13],"o":5},"umbrella_on_ground":{"a":"Umbrella on Ground","b":"26F1-FE0F","c":"26F1","d":true,"e":true,"f":true,"h":true,"k":[54,12],"o":2},"zombie":{"obsoleted_by":"1F9DF-200D-2642-FE0F","a":"Zombie","b":"1F9DF","d":true,"e":true,"f":true,"h":true,"k":[51,18],"o":5},"zap":{"a":"High Voltage Sign","b":"26A1","d":true,"e":true,"f":true,"h":true,"j":["thunder","weather","lightning bolt","fast"],"k":[53,51],"o":2},"white_medium_square":{"a":"White Medium Square","b":"25FB-FE0F","c":"25FB","d":true,"e":true,"f":true,"h":true,"j":["shape","stone","icon"],"k":[52,45],"o":2},"flag-rs":{"a":"Serbia Flag","b":"1F1F7-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,55],"o":2},"petri_dish":{"a":"Petri Dish","b":"1F9EB","d":true,"e":true,"f":true,"h":true,"k":[51,30],"o":11},"snowflake":{"a":"Snowflake","b":"2744-FE0F","c":"2744","d":true,"e":true,"f":true,"h":true,"j":["winter","season","cold","weather","christmas","xmas"],"k":[55,19],"o":2},"dna":{"a":"Dna Double Helix","b":"1F9EC","d":true,"e":true,"f":true,"h":true,"k":[51,31],"o":11},"male_zombie":{"obsoletes":"1F9DF","a":"Male Zombie","b":"1F9DF-200D-2642-FE0F","c":"1F9DF-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,17],"o":5},"black_medium_small_square":{"a":"Black Medium Small Square","b":"25FE","d":true,"e":true,"f":true,"h":true,"j":["icon","shape","button"],"k":[52,48],"o":2},"ru":{"a":"Russia Flag","b":"1F1F7-1F1FA","d":true,"e":true,"f":true,"h":true,"j":["russian","federation","flag","nation","country","banner"],"k":[3,56],"n":["flag-ru"],"o":2},"female_zombie":{"a":"Female Zombie","b":"1F9DF-200D-2640-FE0F","c":"1F9DF-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[51,16],"o":5},"flag-rw":{"a":"Rwanda Flag","b":"1F1F7-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[4,0],"o":2},"snowman":{"a":"Snowman","b":"2603-FE0F","c":"2603","d":true,"e":true,"f":true,"h":true,"j":["winter","season","cold","weather","christmas","xmas","frozen","without_snow"],"k":[52,52],"o":2},"white_medium_small_square":{"a":"White Medium Small Square","b":"25FD","d":true,"e":true,"f":true,"h":true,"j":["shape","stone","icon","button"],"k":[52,47],"o":2},"microscope":{"a":"Microscope","b":"1F52C","d":true,"e":true,"f":true,"h":true,"j":["laboratory","experiment","zoomin","science","study"],"k":[28,15],"o":2},"snowman_without_snow":{"a":"Snowman Without Snow","b":"26C4","d":true,"e":true,"f":true,"h":true,"k":[54,1],"o":2},"telescope":{"a":"Telescope","b":"1F52D","d":true,"e":true,"f":true,"h":true,"j":["stars","space","zoom","science","astronomy"],"k":[28,16],"o":2},"massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB","non_qualified":null,"image":"1f486-1f3fb.png","sheet_x":24,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F486-1F3FC","non_qualified":null,"image":"1f486-1f3fc.png","sheet_x":24,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F486-1F3FD","non_qualified":null,"image":"1f486-1f3fd.png","sheet_x":24,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F486-1F3FE","non_qualified":null,"image":"1f486-1f3fe.png","sheet_x":24,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F486-1F3FF","non_qualified":null,"image":"1f486-1f3ff.png","sheet_x":24,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F486-200D-2640-FE0F","a":"Face Massage","b":"1F486","d":true,"e":true,"f":true,"h":false,"k":[24,51],"o":2},"black_small_square":{"a":"Black Small Square","b":"25AA-FE0F","c":"25AA","d":true,"e":true,"f":true,"h":true,"j":["shape","icon"],"k":[52,41],"o":2},"flag-sa":{"a":"Saudi Arabia Flag","b":"1F1F8-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,1],"o":2},"man-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2642-FE0F","non_qualified":"1F486-1F3FB-200D-2642","image":"1f486-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F486-1F3FC-200D-2642-FE0F","non_qualified":"1F486-1F3FC-200D-2642","image":"1f486-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F486-1F3FD-200D-2642-FE0F","non_qualified":"1F486-1F3FD-200D-2642","image":"1f486-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F486-1F3FE-200D-2642-FE0F","non_qualified":"1F486-1F3FE-200D-2642","image":"1f486-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F486-1F3FF-200D-2642-FE0F","non_qualified":"1F486-1F3FF-200D-2642","image":"1f486-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Getting Massage","b":"1F486-200D-2642-FE0F","c":"1F486-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[24,45],"o":4},"comet":{"a":"Comet","b":"2604-FE0F","c":"2604","d":true,"e":true,"f":true,"h":true,"j":["space"],"k":[52,53],"o":2},"white_small_square":{"a":"White Small Square","b":"25AB-FE0F","c":"25AB","d":true,"e":true,"f":true,"h":true,"j":["shape","icon"],"k":[52,42],"o":2},"flag-sb":{"a":"Solomon Islands Flag","b":"1F1F8-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[4,2],"o":2},"satellite_antenna":{"a":"Satellite Antenna","b":"1F4E1","d":true,"e":true,"f":true,"h":true,"k":[26,55],"o":2},"large_orange_diamond":{"a":"Large Orange Diamond","b":"1F536","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,25],"o":2},"woman-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2640-FE0F","non_qualified":"1F486-1F3FB-200D-2640","image":"1f486-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F486-1F3FC-200D-2640-FE0F","non_qualified":"1F486-1F3FC-200D-2640","image":"1f486-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F486-1F3FD-200D-2640-FE0F","non_qualified":"1F486-1F3FD-200D-2640","image":"1f486-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F486-1F3FE-200D-2640-FE0F","non_qualified":"1F486-1F3FE-200D-2640","image":"1f486-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F486-1F3FF-200D-2640-FE0F","non_qualified":"1F486-1F3FF-200D-2640","image":"1f486-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F486","a":"Woman Getting Massage","b":"1F486-200D-2640-FE0F","c":"1F486-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[24,39],"o":4},"fire":{"a":"Fire","b":"1F525","d":true,"e":true,"f":true,"h":true,"j":["hot","cook","flame"],"k":[28,8],"o":2},"syringe":{"a":"Syringe","b":"1F489","d":true,"e":true,"f":true,"h":true,"j":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"k":[25,19],"o":2},"flag-sc":{"a":"Seychelles Flag","b":"1F1F8-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,3],"o":2},"large_blue_diamond":{"a":"Large Blue Diamond","b":"1F537","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,26],"o":2},"flag-sd":{"a":"Sudan Flag","b":"1F1F8-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[4,4],"o":2},"droplet":{"a":"Droplet","b":"1F4A7","d":true,"e":true,"f":true,"h":true,"j":["water","drip","faucet","spring"],"k":[25,49],"o":2},"drop_of_blood":{"a":"Drop of Blood","b":"1FA78","d":true,"e":true,"f":true,"h":true,"k":[51,55],"o":12},"haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB","non_qualified":null,"image":"1f487-1f3fb.png","sheet_x":25,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F487-1F3FC","non_qualified":null,"image":"1f487-1f3fc.png","sheet_x":25,"sheet_y":14,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F487-1F3FD","non_qualified":null,"image":"1f487-1f3fd.png","sheet_x":25,"sheet_y":15,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F487-1F3FE","non_qualified":null,"image":"1f487-1f3fe.png","sheet_x":25,"sheet_y":16,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F487-1F3FF","non_qualified":null,"image":"1f487-1f3ff.png","sheet_x":25,"sheet_y":17,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F487-200D-2640-FE0F","a":"Haircut","b":"1F487","d":true,"e":true,"f":true,"h":false,"k":[25,12],"o":2},"ocean":{"a":"Water Wave","b":"1F30A","d":true,"e":true,"f":true,"h":true,"j":["sea","water","wave","nature","tsunami","disaster"],"k":[5,29],"o":2},"flag-se":{"a":"Sweden Flag","b":"1F1F8-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,5],"o":2},"man-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2642-FE0F","non_qualified":"1F487-1F3FB-200D-2642","image":"1f487-1f3fb-200d-2642-fe0f.png","sheet_x":25,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F487-1F3FC-200D-2642-FE0F","non_qualified":"1F487-1F3FC-200D-2642","image":"1f487-1f3fc-200d-2642-fe0f.png","sheet_x":25,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F487-1F3FD-200D-2642-FE0F","non_qualified":"1F487-1F3FD-200D-2642","image":"1f487-1f3fd-200d-2642-fe0f.png","sheet_x":25,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F487-1F3FE-200D-2642-FE0F","non_qualified":"1F487-1F3FE-200D-2642","image":"1f487-1f3fe-200d-2642-fe0f.png","sheet_x":25,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F487-1F3FF-200D-2642-FE0F","non_qualified":"1F487-1F3FF-200D-2642","image":"1f487-1f3ff-200d-2642-fe0f.png","sheet_x":25,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Getting Haircut","b":"1F487-200D-2642-FE0F","c":"1F487-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[25,6],"o":4},"small_orange_diamond":{"a":"Small Orange Diamond","b":"1F538","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,27],"o":2},"pill":{"a":"Pill","b":"1F48A","d":true,"e":true,"f":true,"h":true,"j":["health","medicine","doctor","pharmacy","drug"],"k":[25,20],"o":2},"woman-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2640-FE0F","non_qualified":"1F487-1F3FB-200D-2640","image":"1f487-1f3fb-200d-2640-fe0f.png","sheet_x":25,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F487-1F3FC-200D-2640-FE0F","non_qualified":"1F487-1F3FC-200D-2640","image":"1f487-1f3fc-200d-2640-fe0f.png","sheet_x":25,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F487-1F3FD-200D-2640-FE0F","non_qualified":"1F487-1F3FD-200D-2640","image":"1f487-1f3fd-200d-2640-fe0f.png","sheet_x":25,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F487-1F3FE-200D-2640-FE0F","non_qualified":"1F487-1F3FE-200D-2640","image":"1f487-1f3fe-200d-2640-fe0f.png","sheet_x":25,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F487-1F3FF-200D-2640-FE0F","non_qualified":"1F487-1F3FF-200D-2640","image":"1f487-1f3ff-200d-2640-fe0f.png","sheet_x":25,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F487","a":"Woman Getting Haircut","b":"1F487-200D-2640-FE0F","c":"1F487-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[25,0],"o":4},"small_blue_diamond":{"a":"Small Blue Diamond","b":"1F539","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,28],"o":2},"flag-sg":{"a":"Singapore Flag","b":"1F1F8-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,6],"o":2},"adhesive_bandage":{"a":"Adhesive Bandage","b":"1FA79","d":true,"e":true,"f":true,"h":true,"k":[51,56],"o":12},"walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB","non_qualified":null,"image":"1f6b6-1f3fb.png","sheet_x":36,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B6-1F3FC","non_qualified":null,"image":"1f6b6-1f3fc.png","sheet_x":36,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B6-1F3FD","non_qualified":null,"image":"1f6b6-1f3fd.png","sheet_x":36,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B6-1F3FE","non_qualified":null,"image":"1f6b6-1f3fe.png","sheet_x":36,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B6-1F3FF","non_qualified":null,"image":"1f6b6-1f3ff.png","sheet_x":36,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B6-200D-2642-FE0F","a":"Pedestrian","b":"1F6B6","d":true,"e":true,"f":true,"h":false,"k":[36,2],"o":2},"small_red_triangle":{"a":"Up-Pointing Red Triangle","b":"1F53A","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","up","top"],"k":[28,29],"o":2},"flag-sh":{"a":"St. Helena Flag","b":"1F1F8-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[4,7],"o":2},"stethoscope":{"a":"Stethoscope","b":"1FA7A","d":true,"e":true,"f":true,"h":true,"k":[52,0],"o":12},"man-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2642-FE0F","non_qualified":"1F6B6-1F3FB-200D-2642","image":"1f6b6-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2642-FE0F","non_qualified":"1F6B6-1F3FC-200D-2642","image":"1f6b6-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2642-FE0F","non_qualified":"1F6B6-1F3FD-200D-2642","image":"1f6b6-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2642-FE0F","non_qualified":"1F6B6-1F3FE-200D-2642","image":"1f6b6-1f3fe-200d-2642-fe0f.png","sheet_x":36,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2642-FE0F","non_qualified":"1F6B6-1F3FF-200D-2642","image":"1f6b6-1f3ff-200d-2642-fe0f.png","sheet_x":36,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B6","a":"Man Walking","b":"1F6B6-200D-2642-FE0F","c":"1F6B6-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,53],"o":4},"flag-si":{"a":"Slovenia Flag","b":"1F1F8-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[4,8],"o":2},"door":{"a":"Door","b":"1F6AA","d":true,"e":true,"f":true,"h":true,"j":["house","entry","exit"],"k":[35,1],"o":2},"small_red_triangle_down":{"a":"Down-Pointing Red Triangle","b":"1F53B","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","bottom"],"k":[28,30],"o":2},"flag-sj":{"a":"Svalbard & Jan Mayen Flag","b":"1F1F8-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[4,9],"o":2},"diamond_shape_with_a_dot_inside":{"a":"Diamond Shape with a Dot Inside","b":"1F4A0","d":true,"e":true,"f":true,"h":true,"j":["jewel","blue","gem","crystal","fancy"],"k":[25,42],"o":2},"woman-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2640-FE0F","non_qualified":"1F6B6-1F3FB-200D-2640","image":"1f6b6-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2640-FE0F","non_qualified":"1F6B6-1F3FC-200D-2640","image":"1f6b6-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2640-FE0F","non_qualified":"1F6B6-1F3FD-200D-2640","image":"1f6b6-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2640-FE0F","non_qualified":"1F6B6-1F3FE-200D-2640","image":"1f6b6-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2640-FE0F","non_qualified":"1F6B6-1F3FF-200D-2640","image":"1f6b6-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Walking","b":"1F6B6-200D-2640-FE0F","c":"1F6B6-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,47],"o":4},"bed":{"a":"Bed","b":"1F6CF-FE0F","c":"1F6CF","d":true,"e":true,"f":true,"h":true,"j":["sleep","rest"],"k":[36,37],"o":2},"radio_button":{"a":"Radio Button","b":"1F518","d":true,"e":true,"f":true,"h":true,"j":["input","old","music","circle"],"k":[27,52],"o":2},"flag-sk":{"a":"Slovakia Flag","b":"1F1F8-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,10],"o":2},"standing_person":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB","non_qualified":null,"image":"1f9cd-1f3fb.png","sheet_x":44,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC","non_qualified":null,"image":"1f9cd-1f3fc.png","sheet_x":44,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD","non_qualified":null,"image":"1f9cd-1f3fd.png","sheet_x":44,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE","non_qualified":null,"image":"1f9cd-1f3fe.png","sheet_x":44,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF","non_qualified":null,"image":"1f9cd-1f3ff.png","sheet_x":44,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Standing Person","b":"1F9CD","d":true,"e":true,"f":true,"h":true,"k":[44,31],"o":12},"couch_and_lamp":{"a":"Couch and Lamp","b":"1F6CB-FE0F","c":"1F6CB","d":true,"e":true,"f":true,"h":true,"j":["read","chill"],"k":[36,28],"o":2},"man_standing":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB-200D-2642-FE0F","non_qualified":"1F9CD-1F3FB-200D-2642","image":"1f9cd-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC-200D-2642-FE0F","non_qualified":"1F9CD-1F3FC-200D-2642","image":"1f9cd-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD-200D-2642-FE0F","non_qualified":"1F9CD-1F3FD-200D-2642","image":"1f9cd-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE-200D-2642-FE0F","non_qualified":"1F9CD-1F3FE-200D-2642","image":"1f9cd-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF-200D-2642-FE0F","non_qualified":"1F9CD-1F3FF-200D-2642","image":"1f9cd-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Standing","b":"1F9CD-200D-2642-FE0F","c":"1F9CD-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[44,25],"o":12},"white_square_button":{"a":"White Square Button","b":"1F533","d":true,"e":true,"f":true,"h":true,"j":["shape","input"],"k":[28,22],"o":2},"flag-sl":{"a":"Sierra Leone Flag","b":"1F1F8-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[4,11],"o":2},"chair":{"a":"Chair","b":"1FA91","d":true,"e":true,"f":true,"h":true,"k":[52,5],"o":12},"toilet":{"a":"Toilet","b":"1F6BD","d":true,"e":true,"f":true,"h":true,"j":["restroom","wc","washroom","bathroom","potty"],"k":[36,14],"o":2},"black_square_button":{"a":"Black Square Button","b":"1F532","d":true,"e":true,"f":true,"h":true,"j":["shape","input","frame"],"k":[28,21],"o":2},"flag-sm":{"a":"San Marino Flag","b":"1F1F8-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,12],"o":2},"woman_standing":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB-200D-2640-FE0F","non_qualified":"1F9CD-1F3FB-200D-2640","image":"1f9cd-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC-200D-2640-FE0F","non_qualified":"1F9CD-1F3FC-200D-2640","image":"1f9cd-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD-200D-2640-FE0F","non_qualified":"1F9CD-1F3FD-200D-2640","image":"1f9cd-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE-200D-2640-FE0F","non_qualified":"1F9CD-1F3FE-200D-2640","image":"1f9cd-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF-200D-2640-FE0F","non_qualified":"1F9CD-1F3FF-200D-2640","image":"1f9cd-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Standing","b":"1F9CD-200D-2640-FE0F","c":"1F9CD-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,19],"o":12},"kneeling_person":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB","non_qualified":null,"image":"1f9ce-1f3fb.png","sheet_x":44,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC","non_qualified":null,"image":"1f9ce-1f3fc.png","sheet_x":44,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD","non_qualified":null,"image":"1f9ce-1f3fd.png","sheet_x":44,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE","non_qualified":null,"image":"1f9ce-1f3fe.png","sheet_x":44,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF","non_qualified":null,"image":"1f9ce-1f3ff.png","sheet_x":44,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Kneeling Person","b":"1F9CE","d":true,"e":true,"f":true,"h":true,"k":[44,49],"o":12},"shower":{"a":"Shower","b":"1F6BF","d":true,"e":true,"f":true,"h":true,"j":["clean","water","bathroom"],"k":[36,16],"o":2},"flag-sn":{"a":"Senegal Flag","b":"1F1F8-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,13],"o":2},"bathtub":{"a":"Bathtub","b":"1F6C1","d":true,"e":true,"f":true,"h":true,"j":["clean","shower","bathroom"],"k":[36,23],"o":2},"flag-so":{"a":"Somalia Flag","b":"1F1F8-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[4,14],"o":2},"man_kneeling":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB-200D-2642-FE0F","non_qualified":"1F9CE-1F3FB-200D-2642","image":"1f9ce-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC-200D-2642-FE0F","non_qualified":"1F9CE-1F3FC-200D-2642","image":"1f9ce-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD-200D-2642-FE0F","non_qualified":"1F9CE-1F3FD-200D-2642","image":"1f9ce-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE-200D-2642-FE0F","non_qualified":"1F9CE-1F3FE-200D-2642","image":"1f9ce-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF-200D-2642-FE0F","non_qualified":"1F9CE-1F3FF-200D-2642","image":"1f9ce-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Kneeling","b":"1F9CE-200D-2642-FE0F","c":"1F9CE-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[44,43],"o":12},"flag-sr":{"a":"Suriname Flag","b":"1F1F8-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[4,15],"o":2},"woman_kneeling":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB-200D-2640-FE0F","non_qualified":"1F9CE-1F3FB-200D-2640","image":"1f9ce-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC-200D-2640-FE0F","non_qualified":"1F9CE-1F3FC-200D-2640","image":"1f9ce-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD-200D-2640-FE0F","non_qualified":"1F9CE-1F3FD-200D-2640","image":"1f9ce-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE-200D-2640-FE0F","non_qualified":"1F9CE-1F3FE-200D-2640","image":"1f9ce-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF-200D-2640-FE0F","non_qualified":"1F9CE-1F3FF-200D-2640","image":"1f9ce-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Kneeling","b":"1F9CE-200D-2640-FE0F","c":"1F9CE-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,37],"o":12},"razor":{"a":"Razor","b":"1FA92","d":true,"e":true,"f":true,"h":true,"k":[52,6],"o":12},"person_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9af.png","sheet_x":47,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9af.png","sheet_x":47,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9af.png","sheet_x":47,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9af.png","sheet_x":47,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9af.png","sheet_x":47,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person with Probing Cane","b":"1F9D1-200D-1F9AF","d":true,"e":false,"f":false,"h":false,"k":[47,7],"o":12},"flag-ss":{"a":"South Sudan Flag","b":"1F1F8-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[4,16],"o":2},"lotion_bottle":{"a":"Lotion Bottle","b":"1F9F4","d":true,"e":true,"f":true,"h":true,"k":[51,39],"o":11},"flag-st":{"a":"São Tomé & Príncipe Flag","b":"1F1F8-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[4,17],"o":2},"safety_pin":{"a":"Safety Pin","b":"1F9F7","d":true,"e":true,"f":true,"h":true,"k":[51,42],"o":11},"man_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fb-200d-1f9af.png","sheet_x":16,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fc-200d-1f9af.png","sheet_x":16,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fd-200d-1f9af.png","sheet_x":16,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fe-200d-1f9af.png","sheet_x":16,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f468-1f3ff-200d-1f9af.png","sheet_x":16,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man with Probing Cane","b":"1F468-200D-1F9AF","d":true,"e":true,"f":true,"h":true,"k":[16,17],"o":12},"broom":{"a":"Broom","b":"1F9F9","d":true,"e":true,"f":true,"h":true,"k":[51,44],"o":11},"woman_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fb-200d-1f9af.png","sheet_x":19,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fc-200d-1f9af.png","sheet_x":19,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fd-200d-1f9af.png","sheet_x":19,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fe-200d-1f9af.png","sheet_x":19,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f469-1f3ff-200d-1f9af.png","sheet_x":19,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman with Probing Cane","b":"1F469-200D-1F9AF","d":true,"e":true,"f":true,"h":true,"k":[19,2],"o":12},"flag-sv":{"a":"El Salvador Flag","b":"1F1F8-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[4,18],"o":2},"flag-sx":{"a":"Sint Maarten Flag","b":"1F1F8-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[4,19],"o":2},"basket":{"a":"Basket","b":"1F9FA","d":true,"e":true,"f":true,"h":true,"k":[51,45],"o":11},"person_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9bc.png","sheet_x":47,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9bc.png","sheet_x":47,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9bc.png","sheet_x":47,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9bc.png","sheet_x":47,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9bc.png","sheet_x":47,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person in Motorized Wheelchair","b":"1F9D1-200D-1F9BC","d":true,"e":false,"f":false,"h":false,"k":[47,37],"o":12},"man_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f9bc.png","sheet_x":16,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f9bc.png","sheet_x":16,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f9bc.png","sheet_x":16,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f9bc.png","sheet_x":16,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f9bc.png","sheet_x":16,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Motorized Wheelchair","b":"1F468-200D-1F9BC","d":true,"e":true,"f":true,"h":true,"k":[16,47],"o":12},"flag-sy":{"a":"Syria Flag","b":"1F1F8-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[4,20],"o":2},"roll_of_paper":{"a":"Roll of Paper","b":"1F9FB","d":true,"e":true,"f":true,"h":true,"k":[51,46],"o":11},"woman_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f9bc.png","sheet_x":19,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f9bc.png","sheet_x":19,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f9bc.png","sheet_x":19,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f9bc.png","sheet_x":19,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f9bc.png","sheet_x":19,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Motorized Wheelchair","b":"1F469-200D-1F9BC","d":true,"e":true,"f":true,"h":true,"k":[19,32],"o":12},"flag-sz":{"a":"Eswatini Flag","b":"1F1F8-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,21],"o":2},"soap":{"a":"Bar of Soap","b":"1F9FC","d":true,"e":true,"f":true,"h":true,"k":[51,47],"o":11},"flag-ta":{"a":"Tristan Da Cunha Flag","b":"1F1F9-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,22],"o":2},"sponge":{"a":"Sponge","b":"1F9FD","d":true,"e":true,"f":true,"h":true,"k":[51,48],"o":11},"person_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9bd.png","sheet_x":47,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9bd.png","sheet_x":47,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9bd.png","sheet_x":47,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9bd.png","sheet_x":47,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9bd.png","sheet_x":47,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person in Manual Wheelchair","b":"1F9D1-200D-1F9BD","d":true,"e":false,"f":false,"h":false,"k":[47,43],"o":12},"fire_extinguisher":{"a":"Fire Extinguisher","b":"1F9EF","d":true,"e":true,"f":true,"h":true,"k":[51,34],"o":11},"man_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fb-200d-1f9bd.png","sheet_x":16,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fc-200d-1f9bd.png","sheet_x":16,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fd-200d-1f9bd.png","sheet_x":16,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fe-200d-1f9bd.png","sheet_x":17,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f468-1f3ff-200d-1f9bd.png","sheet_x":17,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Manual Wheelchair","b":"1F468-200D-1F9BD","d":true,"e":true,"f":true,"h":true,"k":[16,53],"o":12},"flag-tc":{"a":"Turks & Caicos Islands Flag","b":"1F1F9-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,23],"o":2},"woman_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fb-200d-1f9bd.png","sheet_x":19,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fc-200d-1f9bd.png","sheet_x":19,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fd-200d-1f9bd.png","sheet_x":19,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fe-200d-1f9bd.png","sheet_x":19,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f469-1f3ff-200d-1f9bd.png","sheet_x":19,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Manual Wheelchair","b":"1F469-200D-1F9BD","d":true,"e":true,"f":true,"h":true,"k":[19,38],"o":12},"flag-td":{"a":"Chad Flag","b":"1F1F9-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[4,24],"o":2},"shopping_trolley":{"a":"Shopping Trolley","b":"1F6D2","d":true,"e":true,"f":true,"h":true,"k":[36,40],"o":4},"runner":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB","non_qualified":null,"image":"1f3c3-1f3fb.png","sheet_x":9,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3C3-1F3FC","non_qualified":null,"image":"1f3c3-1f3fc.png","sheet_x":9,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3C3-1F3FD","non_qualified":null,"image":"1f3c3-1f3fd.png","sheet_x":9,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3C3-1F3FE","non_qualified":null,"image":"1f3c3-1f3fe.png","sheet_x":9,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3C3-1F3FF","non_qualified":null,"image":"1f3c3-1f3ff.png","sheet_x":9,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3C3-200D-2642-FE0F","a":"Runner","b":"1F3C3","d":true,"e":true,"f":true,"h":false,"k":[9,1],"n":["running"],"o":2},"flag-tf":{"a":"French Southern Territories Flag","b":"1F1F9-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[4,25],"o":2},"smoking":{"a":"Smoking Symbol","b":"1F6AC","d":true,"e":true,"f":true,"h":true,"j":["kills","tobacco","cigarette","joint","smoke"],"k":[35,3],"o":2},"coffin":{"a":"Coffin","b":"26B0-FE0F","c":"26B0","d":true,"e":true,"f":true,"h":true,"j":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"k":[53,54],"o":2},"man-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2642-FE0F","non_qualified":"1F3C3-1F3FB-200D-2642","image":"1f3c3-1f3fb-200d-2642-fe0f.png","sheet_x":8,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2642-FE0F","non_qualified":"1F3C3-1F3FC-200D-2642","image":"1f3c3-1f3fc-200d-2642-fe0f.png","sheet_x":8,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2642-FE0F","non_qualified":"1F3C3-1F3FD-200D-2642","image":"1f3c3-1f3fd-200d-2642-fe0f.png","sheet_x":8,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2642-FE0F","non_qualified":"1F3C3-1F3FE-200D-2642","image":"1f3c3-1f3fe-200d-2642-fe0f.png","sheet_x":8,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2642-FE0F","non_qualified":"1F3C3-1F3FF-200D-2642","image":"1f3c3-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3C3","a":"Man Running","b":"1F3C3-200D-2642-FE0F","c":"1F3C3-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[8,52],"o":4},"flag-tg":{"a":"Togo Flag","b":"1F1F9-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,26],"o":2},"woman-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2640-FE0F","non_qualified":"1F3C3-1F3FB-200D-2640","image":"1f3c3-1f3fb-200d-2640-fe0f.png","sheet_x":8,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2640-FE0F","non_qualified":"1F3C3-1F3FC-200D-2640","image":"1f3c3-1f3fc-200d-2640-fe0f.png","sheet_x":8,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2640-FE0F","non_qualified":"1F3C3-1F3FD-200D-2640","image":"1f3c3-1f3fd-200d-2640-fe0f.png","sheet_x":8,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2640-FE0F","non_qualified":"1F3C3-1F3FE-200D-2640","image":"1f3c3-1f3fe-200d-2640-fe0f.png","sheet_x":8,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2640-FE0F","non_qualified":"1F3C3-1F3FF-200D-2640","image":"1f3c3-1f3ff-200d-2640-fe0f.png","sheet_x":8,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Running","b":"1F3C3-200D-2640-FE0F","c":"1F3C3-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[8,46],"o":4},"funeral_urn":{"a":"Funeral Urn","b":"26B1-FE0F","c":"26B1","d":true,"e":true,"f":true,"h":true,"j":["dead","die","death","rip","ashes"],"k":[53,55],"o":2},"flag-th":{"a":"Thailand Flag","b":"1F1F9-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[4,27],"o":2},"moyai":{"a":"Moyai","b":"1F5FF","d":true,"e":true,"f":true,"h":true,"j":["rock","easter island","moai"],"k":[30,34],"o":2},"flag-tj":{"a":"Tajikistan Flag","b":"1F1F9-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[4,28],"o":2},"dancer":{"skin_variations":{"1F3FB":{"unified":"1F483-1F3FB","non_qualified":null,"image":"1f483-1f3fb.png","sheet_x":24,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F483-1F3FC","non_qualified":null,"image":"1f483-1f3fc.png","sheet_x":24,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F483-1F3FD","non_qualified":null,"image":"1f483-1f3fd.png","sheet_x":24,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F483-1F3FE","non_qualified":null,"image":"1f483-1f3fe.png","sheet_x":24,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F483-1F3FF","non_qualified":null,"image":"1f483-1f3ff.png","sheet_x":24,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Dancer","b":"1F483","d":true,"e":true,"f":true,"h":true,"j":["female","girl","woman","fun"],"k":[24,26],"o":2},"flag-tk":{"a":"Tokelau Flag","b":"1F1F9-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,29],"o":2},"man_dancing":{"skin_variations":{"1F3FB":{"unified":"1F57A-1F3FB","non_qualified":null,"image":"1f57a-1f3fb.png","sheet_x":29,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F57A-1F3FC","non_qualified":null,"image":"1f57a-1f3fc.png","sheet_x":29,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F57A-1F3FD","non_qualified":null,"image":"1f57a-1f3fd.png","sheet_x":29,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F57A-1F3FE","non_qualified":null,"image":"1f57a-1f3fe.png","sheet_x":29,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F57A-1F3FF","non_qualified":null,"image":"1f57a-1f3ff.png","sheet_x":29,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Dancing","b":"1F57A","d":true,"e":true,"f":true,"h":true,"j":["male","boy","fun","dancer"],"k":[29,37],"o":4},"flag-tl":{"a":"Timor-Leste Flag","b":"1F1F9-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[4,30],"o":2},"man_in_business_suit_levitating":{"skin_variations":{"1F3FB":{"unified":"1F574-1F3FB","non_qualified":null,"image":"1f574-1f3fb.png","sheet_x":29,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F574-1F3FC","non_qualified":null,"image":"1f574-1f3fc.png","sheet_x":29,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F574-1F3FD","non_qualified":null,"image":"1f574-1f3fd.png","sheet_x":29,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F574-1F3FE","non_qualified":null,"image":"1f574-1f3fe.png","sheet_x":29,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F574-1F3FF","non_qualified":null,"image":"1f574-1f3ff.png","sheet_x":29,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Business Suit Levitating","b":"1F574-FE0F","c":"1F574","d":true,"e":true,"f":true,"h":true,"k":[29,9],"o":2},"flag-tm":{"a":"Turkmenistan Flag","b":"1F1F9-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,31],"o":2},"dancers":{"obsoleted_by":"1F46F-200D-2640-FE0F","a":"Woman with Bunny Ears","b":"1F46F","d":true,"e":true,"f":true,"h":true,"k":[22,0],"o":2},"man-with-bunny-ears-partying":{"a":"Man with Bunny Ears Partying","b":"1F46F-200D-2642-FE0F","c":"1F46F-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[21,56],"o":4},"flag-tn":{"a":"Tunisia Flag","b":"1F1F9-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,32],"o":2},"flag-to":{"a":"Tonga Flag","b":"1F1F9-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[4,33],"o":2},"woman-with-bunny-ears-partying":{"obsoletes":"1F46F","a":"Woman with Bunny Ears Partying","b":"1F46F-200D-2640-FE0F","c":"1F46F-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[21,55],"o":4},"flag-tr":{"a":"Turkey Flag","b":"1F1F9-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[4,34],"o":2},"person_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB","non_qualified":null,"image":"1f9d6-1f3fb.png","sheet_x":48,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9D6-1F3FC","non_qualified":null,"image":"1f9d6-1f3fc.png","sheet_x":48,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9D6-1F3FD","non_qualified":null,"image":"1f9d6-1f3fd.png","sheet_x":48,"sheet_y":55,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9D6-1F3FE","non_qualified":null,"image":"1f9d6-1f3fe.png","sheet_x":48,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9D6-1F3FF","non_qualified":null,"image":"1f9d6-1f3ff.png","sheet_x":49,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9D6-200D-2642-FE0F","a":"Person in Steamy Room","b":"1F9D6","d":true,"e":true,"f":true,"h":true,"k":[48,52],"o":5},"man_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2642-FE0F","non_qualified":"1F9D6-1F3FB-200D-2642","image":"1f9d6-1f3fb-200d-2642-fe0f.png","sheet_x":48,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FB"},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2642-FE0F","non_qualified":"1F9D6-1F3FC-200D-2642","image":"1f9d6-1f3fc-200d-2642-fe0f.png","sheet_x":48,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FC"},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2642-FE0F","non_qualified":"1F9D6-1F3FD-200D-2642","image":"1f9d6-1f3fd-200d-2642-fe0f.png","sheet_x":48,"sheet_y":49,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FD"},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2642-FE0F","non_qualified":"1F9D6-1F3FE-200D-2642","image":"1f9d6-1f3fe-200d-2642-fe0f.png","sheet_x":48,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FE"},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2642-FE0F","non_qualified":"1F9D6-1F3FF-200D-2642","image":"1f9d6-1f3ff-200d-2642-fe0f.png","sheet_x":48,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FF"}},"obsoletes":"1F9D6","a":"Man in Steamy Room","b":"1F9D6-200D-2642-FE0F","c":"1F9D6-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[48,46],"o":5},"flag-tt":{"a":"Trinidad & Tobago Flag","b":"1F1F9-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[4,35],"o":2},"woman_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2640-FE0F","non_qualified":"1F9D6-1F3FB-200D-2640","image":"1f9d6-1f3fb-200d-2640-fe0f.png","sheet_x":48,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2640-FE0F","non_qualified":"1F9D6-1F3FC-200D-2640","image":"1f9d6-1f3fc-200d-2640-fe0f.png","sheet_x":48,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2640-FE0F","non_qualified":"1F9D6-1F3FD-200D-2640","image":"1f9d6-1f3fd-200d-2640-fe0f.png","sheet_x":48,"sheet_y":43,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2640-FE0F","non_qualified":"1F9D6-1F3FE-200D-2640","image":"1f9d6-1f3fe-200d-2640-fe0f.png","sheet_x":48,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2640-FE0F","non_qualified":"1F9D6-1F3FF-200D-2640","image":"1f9d6-1f3ff-200d-2640-fe0f.png","sheet_x":48,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Steamy Room","b":"1F9D6-200D-2640-FE0F","c":"1F9D6-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[48,40],"o":5},"flag-tv":{"a":"Tuvalu Flag","b":"1F1F9-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[4,36],"o":2},"flag-tw":{"a":"Taiwan Flag","b":"1F1F9-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[4,37],"o":2},"person_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB","non_qualified":null,"image":"1f9d7-1f3fb.png","sheet_x":49,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D7-1F3FC","non_qualified":null,"image":"1f9d7-1f3fc.png","sheet_x":49,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D7-1F3FD","non_qualified":null,"image":"1f9d7-1f3fd.png","sheet_x":49,"sheet_y":16,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D7-1F3FE","non_qualified":null,"image":"1f9d7-1f3fe.png","sheet_x":49,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D7-1F3FF","non_qualified":null,"image":"1f9d7-1f3ff.png","sheet_x":49,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D7-200D-2640-FE0F","a":"Person Climbing","b":"1F9D7","d":true,"e":true,"f":true,"h":true,"k":[49,13],"o":5},"man_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2642-FE0F","non_qualified":"1F9D7-1F3FB-200D-2642","image":"1f9d7-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2642-FE0F","non_qualified":"1F9D7-1F3FC-200D-2642","image":"1f9d7-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2642-FE0F","non_qualified":"1F9D7-1F3FD-200D-2642","image":"1f9d7-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2642-FE0F","non_qualified":"1F9D7-1F3FE-200D-2642","image":"1f9d7-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2642-FE0F","non_qualified":"1F9D7-1F3FF-200D-2642","image":"1f9d7-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Climbing","b":"1F9D7-200D-2642-FE0F","c":"1F9D7-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,7],"o":5},"flag-tz":{"a":"Tanzania Flag","b":"1F1F9-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,38],"o":2},"flag-ua":{"a":"Ukraine Flag","b":"1F1FA-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,39],"o":2},"woman_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2640-FE0F","non_qualified":"1F9D7-1F3FB-200D-2640","image":"1f9d7-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FB"},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2640-FE0F","non_qualified":"1F9D7-1F3FC-200D-2640","image":"1f9d7-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FC"},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2640-FE0F","non_qualified":"1F9D7-1F3FD-200D-2640","image":"1f9d7-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FD"},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2640-FE0F","non_qualified":"1F9D7-1F3FE-200D-2640","image":"1f9d7-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FE"},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2640-FE0F","non_qualified":"1F9D7-1F3FF-200D-2640","image":"1f9d7-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FF"}},"obsoletes":"1F9D7","a":"Woman Climbing","b":"1F9D7-200D-2640-FE0F","c":"1F9D7-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,1],"o":5},"flag-ug":{"a":"Uganda Flag","b":"1F1FA-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,40],"o":2},"fencer":{"a":"Fencer","b":"1F93A","d":true,"e":true,"f":true,"h":true,"k":[40,32],"o":4},"flag-um":{"a":"U.s. Outlying Islands Flag","b":"1F1FA-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,41],"o":2},"horse_racing":{"skin_variations":{"1F3FB":{"unified":"1F3C7-1F3FB","non_qualified":null,"image":"1f3c7-1f3fb.png","sheet_x":9,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C7-1F3FC","non_qualified":null,"image":"1f3c7-1f3fc.png","sheet_x":9,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C7-1F3FD","non_qualified":null,"image":"1f3c7-1f3fd.png","sheet_x":9,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C7-1F3FE","non_qualified":null,"image":"1f3c7-1f3fe.png","sheet_x":9,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C7-1F3FF","non_qualified":null,"image":"1f3c7-1f3ff.png","sheet_x":9,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Horse Racing","b":"1F3C7","d":true,"e":true,"f":true,"h":true,"j":["animal","betting","competition","gambling","luck"],"k":[9,27],"o":2},"skier":{"a":"Skier","b":"26F7-FE0F","c":"26F7","d":true,"e":true,"f":true,"h":true,"j":["sports","winter","snow"],"k":[54,17],"o":2},"flag-un":{"a":"United Nations Flag","b":"1F1FA-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,42],"o":4},"us":{"a":"United States Flag","b":"1F1FA-1F1F8","d":true,"e":true,"f":true,"h":true,"j":["united","states","america","flag","nation","country","banner"],"k":[4,43],"n":["flag-us"],"o":2},"snowboarder":{"skin_variations":{"1F3FB":{"unified":"1F3C2-1F3FB","non_qualified":null,"image":"1f3c2-1f3fb.png","sheet_x":8,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C2-1F3FC","non_qualified":null,"image":"1f3c2-1f3fc.png","sheet_x":8,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C2-1F3FD","non_qualified":null,"image":"1f3c2-1f3fd.png","sheet_x":8,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C2-1F3FE","non_qualified":null,"image":"1f3c2-1f3fe.png","sheet_x":8,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C2-1F3FF","non_qualified":null,"image":"1f3c2-1f3ff.png","sheet_x":8,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Snowboarder","b":"1F3C2","d":true,"e":true,"f":true,"h":true,"j":["sports","winter"],"k":[8,40],"o":2},"golfer":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB","non_qualified":null,"image":"1f3cc-1f3fb.png","sheet_x":10,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CC-1F3FC","non_qualified":null,"image":"1f3cc-1f3fc.png","sheet_x":10,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CC-1F3FD","non_qualified":null,"image":"1f3cc-1f3fd.png","sheet_x":10,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CC-1F3FE","non_qualified":null,"image":"1f3cc-1f3fe.png","sheet_x":10,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CC-1F3FF","non_qualified":null,"image":"1f3cc-1f3ff.png","sheet_x":10,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CC-FE0F-200D-2642-FE0F","a":"Golfer","b":"1F3CC-FE0F","c":"1F3CC","d":true,"e":true,"f":true,"h":false,"k":[10,26],"o":2},"flag-uy":{"a":"Uruguay Flag","b":"1F1FA-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[4,44],"o":2},"flag-uz":{"a":"Uzbekistan Flag","b":"1F1FA-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,45],"o":2},"man-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2642-FE0F","non_qualified":"1F3CC-1F3FB-200D-2642","image":"1f3cc-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2642-FE0F","non_qualified":"1F3CC-1F3FC-200D-2642","image":"1f3cc-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2642-FE0F","non_qualified":"1F3CC-1F3FD-200D-2642","image":"1f3cc-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2642-FE0F","non_qualified":"1F3CC-1F3FE-200D-2642","image":"1f3cc-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2642-FE0F","non_qualified":"1F3CC-1F3FF-200D-2642","image":"1f3cc-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CC-FE0F","a":"Man Golfing","b":"1F3CC-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,20],"o":4},"flag-va":{"a":"Vatican City Flag","b":"1F1FB-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,46],"o":2},"woman-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2640-FE0F","non_qualified":"1F3CC-1F3FB-200D-2640","image":"1f3cc-1f3fb-200d-2640-fe0f.png","sheet_x":10,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2640-FE0F","non_qualified":"1F3CC-1F3FC-200D-2640","image":"1f3cc-1f3fc-200d-2640-fe0f.png","sheet_x":10,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2640-FE0F","non_qualified":"1F3CC-1F3FD-200D-2640","image":"1f3cc-1f3fd-200d-2640-fe0f.png","sheet_x":10,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2640-FE0F","non_qualified":"1F3CC-1F3FE-200D-2640","image":"1f3cc-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2640-FE0F","non_qualified":"1F3CC-1F3FF-200D-2640","image":"1f3cc-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Golfing","b":"1F3CC-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,14],"o":4},"flag-vc":{"a":"St. Vincent & Grenadines Flag","b":"1F1FB-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,47],"o":2},"surfer":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB","non_qualified":null,"image":"1f3c4-1f3fb.png","sheet_x":9,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3C4-1F3FC","non_qualified":null,"image":"1f3c4-1f3fc.png","sheet_x":9,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3C4-1F3FD","non_qualified":null,"image":"1f3c4-1f3fd.png","sheet_x":9,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3C4-1F3FE","non_qualified":null,"image":"1f3c4-1f3fe.png","sheet_x":9,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3C4-1F3FF","non_qualified":null,"image":"1f3c4-1f3ff.png","sheet_x":9,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3C4-200D-2642-FE0F","a":"Surfer","b":"1F3C4","d":true,"e":true,"f":true,"h":false,"k":[9,19],"o":2},"man-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2642-FE0F","non_qualified":"1F3C4-1F3FB-200D-2642","image":"1f3c4-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2642-FE0F","non_qualified":"1F3C4-1F3FC-200D-2642","image":"1f3c4-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2642-FE0F","non_qualified":"1F3C4-1F3FD-200D-2642","image":"1f3c4-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2642-FE0F","non_qualified":"1F3C4-1F3FE-200D-2642","image":"1f3c4-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2642-FE0F","non_qualified":"1F3C4-1F3FF-200D-2642","image":"1f3c4-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3C4","a":"Man Surfing","b":"1F3C4-200D-2642-FE0F","c":"1F3C4-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[9,13],"o":4},"flag-ve":{"a":"Venezuela Flag","b":"1F1FB-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,48],"o":2},"flag-vg":{"a":"British Virgin Islands Flag","b":"1F1FB-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,49],"o":2},"woman-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2640-FE0F","non_qualified":"1F3C4-1F3FB-200D-2640","image":"1f3c4-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2640-FE0F","non_qualified":"1F3C4-1F3FC-200D-2640","image":"1f3c4-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2640-FE0F","non_qualified":"1F3C4-1F3FD-200D-2640","image":"1f3c4-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2640-FE0F","non_qualified":"1F3C4-1F3FE-200D-2640","image":"1f3c4-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2640-FE0F","non_qualified":"1F3C4-1F3FF-200D-2640","image":"1f3c4-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Surfing","b":"1F3C4-200D-2640-FE0F","c":"1F3C4-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[9,7],"o":4},"rowboat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB","non_qualified":null,"image":"1f6a3-1f3fb.png","sheet_x":34,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6A3-1F3FC","non_qualified":null,"image":"1f6a3-1f3fc.png","sheet_x":34,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6A3-1F3FD","non_qualified":null,"image":"1f6a3-1f3fd.png","sheet_x":34,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6A3-1F3FE","non_qualified":null,"image":"1f6a3-1f3fe.png","sheet_x":34,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6A3-1F3FF","non_qualified":null,"image":"1f6a3-1f3ff.png","sheet_x":34,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6A3-200D-2642-FE0F","a":"Rowboat","b":"1F6A3","d":true,"e":true,"f":true,"h":false,"k":[34,46],"o":2},"flag-vi":{"a":"U.s. Virgin Islands Flag","b":"1F1FB-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[4,50],"o":2},"man-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2642-FE0F","non_qualified":"1F6A3-1F3FB-200D-2642","image":"1f6a3-1f3fb-200d-2642-fe0f.png","sheet_x":34,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2642-FE0F","non_qualified":"1F6A3-1F3FC-200D-2642","image":"1f6a3-1f3fc-200d-2642-fe0f.png","sheet_x":34,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2642-FE0F","non_qualified":"1F6A3-1F3FD-200D-2642","image":"1f6a3-1f3fd-200d-2642-fe0f.png","sheet_x":34,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2642-FE0F","non_qualified":"1F6A3-1F3FE-200D-2642","image":"1f6a3-1f3fe-200d-2642-fe0f.png","sheet_x":34,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2642-FE0F","non_qualified":"1F6A3-1F3FF-200D-2642","image":"1f6a3-1f3ff-200d-2642-fe0f.png","sheet_x":34,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6A3","a":"Man Rowing Boat","b":"1F6A3-200D-2642-FE0F","c":"1F6A3-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[34,40],"o":4},"flag-vn":{"a":"Vietnam Flag","b":"1F1FB-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,51],"o":2},"flag-vu":{"a":"Vanuatu Flag","b":"1F1FB-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[4,52],"o":2},"woman-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2640-FE0F","non_qualified":"1F6A3-1F3FB-200D-2640","image":"1f6a3-1f3fb-200d-2640-fe0f.png","sheet_x":34,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2640-FE0F","non_qualified":"1F6A3-1F3FC-200D-2640","image":"1f6a3-1f3fc-200d-2640-fe0f.png","sheet_x":34,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2640-FE0F","non_qualified":"1F6A3-1F3FD-200D-2640","image":"1f6a3-1f3fd-200d-2640-fe0f.png","sheet_x":34,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2640-FE0F","non_qualified":"1F6A3-1F3FE-200D-2640","image":"1f6a3-1f3fe-200d-2640-fe0f.png","sheet_x":34,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2640-FE0F","non_qualified":"1F6A3-1F3FF-200D-2640","image":"1f6a3-1f3ff-200d-2640-fe0f.png","sheet_x":34,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Rowing Boat","b":"1F6A3-200D-2640-FE0F","c":"1F6A3-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[34,34],"o":4},"swimmer":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB","non_qualified":null,"image":"1f3ca-1f3fb.png","sheet_x":9,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CA-1F3FC","non_qualified":null,"image":"1f3ca-1f3fc.png","sheet_x":9,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CA-1F3FD","non_qualified":null,"image":"1f3ca-1f3fd.png","sheet_x":9,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CA-1F3FE","non_qualified":null,"image":"1f3ca-1f3fe.png","sheet_x":9,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CA-1F3FF","non_qualified":null,"image":"1f3ca-1f3ff.png","sheet_x":9,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CA-200D-2642-FE0F","a":"Swimmer","b":"1F3CA","d":true,"e":true,"f":true,"h":false,"k":[9,47],"o":2},"flag-wf":{"a":"Wallis & Futuna Flag","b":"1F1FC-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[4,53],"o":2},"man-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2642-FE0F","non_qualified":"1F3CA-1F3FB-200D-2642","image":"1f3ca-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2642-FE0F","non_qualified":"1F3CA-1F3FC-200D-2642","image":"1f3ca-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2642-FE0F","non_qualified":"1F3CA-1F3FD-200D-2642","image":"1f3ca-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2642-FE0F","non_qualified":"1F3CA-1F3FE-200D-2642","image":"1f3ca-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2642-FE0F","non_qualified":"1F3CA-1F3FF-200D-2642","image":"1f3ca-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CA","a":"Man Swimming","b":"1F3CA-200D-2642-FE0F","c":"1F3CA-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[9,41],"o":4},"flag-ws":{"a":"Samoa Flag","b":"1F1FC-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[4,54],"o":2},"woman-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2640-FE0F","non_qualified":"1F3CA-1F3FB-200D-2640","image":"1f3ca-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2640-FE0F","non_qualified":"1F3CA-1F3FC-200D-2640","image":"1f3ca-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2640-FE0F","non_qualified":"1F3CA-1F3FD-200D-2640","image":"1f3ca-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2640-FE0F","non_qualified":"1F3CA-1F3FE-200D-2640","image":"1f3ca-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2640-FE0F","non_qualified":"1F3CA-1F3FF-200D-2640","image":"1f3ca-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Swimming","b":"1F3CA-200D-2640-FE0F","c":"1F3CA-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[9,35],"o":4},"flag-xk":{"a":"Kosovo Flag","b":"1F1FD-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,55],"o":2},"person_with_ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB","non_qualified":null,"image":"26f9-1f3fb.png","sheet_x":54,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"26F9-1F3FC","non_qualified":null,"image":"26f9-1f3fc.png","sheet_x":54,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"26F9-1F3FD","non_qualified":null,"image":"26f9-1f3fd.png","sheet_x":54,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"26F9-1F3FE","non_qualified":null,"image":"26f9-1f3fe.png","sheet_x":54,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"26F9-1F3FF","non_qualified":null,"image":"26f9-1f3ff.png","sheet_x":54,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"26F9-FE0F-200D-2642-FE0F","a":"Person with Ball","b":"26F9-FE0F","c":"26F9","d":true,"e":true,"f":true,"h":false,"k":[54,31],"o":2},"flag-ye":{"a":"Yemen Flag","b":"1F1FE-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,56],"o":2},"man-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2642-FE0F","non_qualified":"26F9-1F3FB-200D-2642","image":"26f9-1f3fb-200d-2642-fe0f.png","sheet_x":54,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"26F9-1F3FC-200D-2642-FE0F","non_qualified":"26F9-1F3FC-200D-2642","image":"26f9-1f3fc-200d-2642-fe0f.png","sheet_x":54,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"26F9-1F3FD-200D-2642-FE0F","non_qualified":"26F9-1F3FD-200D-2642","image":"26f9-1f3fd-200d-2642-fe0f.png","sheet_x":54,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"26F9-1F3FE-200D-2642-FE0F","non_qualified":"26F9-1F3FE-200D-2642","image":"26f9-1f3fe-200d-2642-fe0f.png","sheet_x":54,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"26F9-1F3FF-200D-2642-FE0F","non_qualified":"26F9-1F3FF-200D-2642","image":"26f9-1f3ff-200d-2642-fe0f.png","sheet_x":54,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"26F9-FE0F","a":"Man Bouncing Ball","b":"26F9-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[54,25],"o":4},"flag-yt":{"a":"Mayotte Flag","b":"1F1FE-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[5,0],"o":2},"woman-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2640-FE0F","non_qualified":"26F9-1F3FB-200D-2640","image":"26f9-1f3fb-200d-2640-fe0f.png","sheet_x":54,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"26F9-1F3FC-200D-2640-FE0F","non_qualified":"26F9-1F3FC-200D-2640","image":"26f9-1f3fc-200d-2640-fe0f.png","sheet_x":54,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"26F9-1F3FD-200D-2640-FE0F","non_qualified":"26F9-1F3FD-200D-2640","image":"26f9-1f3fd-200d-2640-fe0f.png","sheet_x":54,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"26F9-1F3FE-200D-2640-FE0F","non_qualified":"26F9-1F3FE-200D-2640","image":"26f9-1f3fe-200d-2640-fe0f.png","sheet_x":54,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"26F9-1F3FF-200D-2640-FE0F","non_qualified":"26F9-1F3FF-200D-2640","image":"26f9-1f3ff-200d-2640-fe0f.png","sheet_x":54,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Bouncing Ball","b":"26F9-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[54,19],"o":4},"flag-za":{"a":"South Africa Flag","b":"1F1FF-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[5,1],"o":2},"flag-zm":{"a":"Zambia Flag","b":"1F1FF-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[5,2],"o":2},"weight_lifter":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB","non_qualified":null,"image":"1f3cb-1f3fb.png","sheet_x":10,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CB-1F3FC","non_qualified":null,"image":"1f3cb-1f3fc.png","sheet_x":10,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CB-1F3FD","non_qualified":null,"image":"1f3cb-1f3fd.png","sheet_x":10,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CB-1F3FE","non_qualified":null,"image":"1f3cb-1f3fe.png","sheet_x":10,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CB-1F3FF","non_qualified":null,"image":"1f3cb-1f3ff.png","sheet_x":10,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CB-FE0F-200D-2642-FE0F","a":"Weight Lifter","b":"1F3CB-FE0F","c":"1F3CB","d":true,"e":true,"f":true,"h":false,"k":[10,8],"o":2},"man-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2642-FE0F","non_qualified":"1F3CB-1F3FB-200D-2642","image":"1f3cb-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2642-FE0F","non_qualified":"1F3CB-1F3FC-200D-2642","image":"1f3cb-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2642-FE0F","non_qualified":"1F3CB-1F3FD-200D-2642","image":"1f3cb-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2642-FE0F","non_qualified":"1F3CB-1F3FE-200D-2642","image":"1f3cb-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2642-FE0F","non_qualified":"1F3CB-1F3FF-200D-2642","image":"1f3cb-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CB-FE0F","a":"Man Lifting Weights","b":"1F3CB-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,2],"o":4},"flag-zw":{"a":"Zimbabwe Flag","b":"1F1FF-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[5,3],"o":2},"woman-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2640-FE0F","non_qualified":"1F3CB-1F3FB-200D-2640","image":"1f3cb-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2640-FE0F","non_qualified":"1F3CB-1F3FC-200D-2640","image":"1f3cb-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2640-FE0F","non_qualified":"1F3CB-1F3FD-200D-2640","image":"1f3cb-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2640-FE0F","non_qualified":"1F3CB-1F3FE-200D-2640","image":"1f3cb-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2640-FE0F","non_qualified":"1F3CB-1F3FF-200D-2640","image":"1f3cb-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Lifting Weights","b":"1F3CB-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[9,53],"o":4},"flag-england":{"a":"England Flag","b":"1F3F4-E0067-E0062-E0065-E006E-E0067-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,14],"o":5},"bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB","non_qualified":null,"image":"1f6b4-1f3fb.png","sheet_x":35,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B4-1F3FC","non_qualified":null,"image":"1f6b4-1f3fc.png","sheet_x":35,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B4-1F3FD","non_qualified":null,"image":"1f6b4-1f3fd.png","sheet_x":35,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B4-1F3FE","non_qualified":null,"image":"1f6b4-1f3fe.png","sheet_x":35,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B4-1F3FF","non_qualified":null,"image":"1f6b4-1f3ff.png","sheet_x":35,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B4-200D-2642-FE0F","a":"Bicyclist","b":"1F6B4","d":true,"e":true,"f":true,"h":false,"k":[35,23],"o":2},"flag-scotland":{"a":"Scotland Flag","b":"1F3F4-E0067-E0062-E0073-E0063-E0074-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,15],"o":5},"flag-wales":{"a":"Wales Flag","b":"1F3F4-E0067-E0062-E0077-E006C-E0073-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,16],"o":5},"man-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2642-FE0F","non_qualified":"1F6B4-1F3FB-200D-2642","image":"1f6b4-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2642-FE0F","non_qualified":"1F6B4-1F3FC-200D-2642","image":"1f6b4-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2642-FE0F","non_qualified":"1F6B4-1F3FD-200D-2642","image":"1f6b4-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2642-FE0F","non_qualified":"1F6B4-1F3FE-200D-2642","image":"1f6b4-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2642-FE0F","non_qualified":"1F6B4-1F3FF-200D-2642","image":"1f6b4-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B4","a":"Man Biking","b":"1F6B4-200D-2642-FE0F","c":"1F6B4-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,17],"o":4},"woman-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2640-FE0F","non_qualified":"1F6B4-1F3FB-200D-2640","image":"1f6b4-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2640-FE0F","non_qualified":"1F6B4-1F3FC-200D-2640","image":"1f6b4-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2640-FE0F","non_qualified":"1F6B4-1F3FD-200D-2640","image":"1f6b4-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2640-FE0F","non_qualified":"1F6B4-1F3FE-200D-2640","image":"1f6b4-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2640-FE0F","non_qualified":"1F6B4-1F3FF-200D-2640","image":"1f6b4-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Biking","b":"1F6B4-200D-2640-FE0F","c":"1F6B4-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,11],"o":4},"mountain_bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB","non_qualified":null,"image":"1f6b5-1f3fb.png","sheet_x":35,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B5-1F3FC","non_qualified":null,"image":"1f6b5-1f3fc.png","sheet_x":35,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B5-1F3FD","non_qualified":null,"image":"1f6b5-1f3fd.png","sheet_x":35,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B5-1F3FE","non_qualified":null,"image":"1f6b5-1f3fe.png","sheet_x":35,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B5-1F3FF","non_qualified":null,"image":"1f6b5-1f3ff.png","sheet_x":35,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B5-200D-2642-FE0F","a":"Mountain Bicyclist","b":"1F6B5","d":true,"e":true,"f":true,"h":false,"k":[35,41],"o":2},"man-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2642-FE0F","non_qualified":"1F6B5-1F3FB-200D-2642","image":"1f6b5-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2642-FE0F","non_qualified":"1F6B5-1F3FC-200D-2642","image":"1f6b5-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2642-FE0F","non_qualified":"1F6B5-1F3FD-200D-2642","image":"1f6b5-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2642-FE0F","non_qualified":"1F6B5-1F3FE-200D-2642","image":"1f6b5-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2642-FE0F","non_qualified":"1F6B5-1F3FF-200D-2642","image":"1f6b5-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B5","a":"Man Mountain Biking","b":"1F6B5-200D-2642-FE0F","c":"1F6B5-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,35],"o":4},"woman-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2640-FE0F","non_qualified":"1F6B5-1F3FB-200D-2640","image":"1f6b5-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2640-FE0F","non_qualified":"1F6B5-1F3FC-200D-2640","image":"1f6b5-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2640-FE0F","non_qualified":"1F6B5-1F3FD-200D-2640","image":"1f6b5-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2640-FE0F","non_qualified":"1F6B5-1F3FE-200D-2640","image":"1f6b5-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2640-FE0F","non_qualified":"1F6B5-1F3FF-200D-2640","image":"1f6b5-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Mountain Biking","b":"1F6B5-200D-2640-FE0F","c":"1F6B5-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,29],"o":4},"person_doing_cartwheel":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB","non_qualified":null,"image":"1f938-1f3fb.png","sheet_x":40,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F938-1F3FC","non_qualified":null,"image":"1f938-1f3fc.png","sheet_x":40,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F938-1F3FD","non_qualified":null,"image":"1f938-1f3fd.png","sheet_x":40,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F938-1F3FE","non_qualified":null,"image":"1f938-1f3fe.png","sheet_x":40,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F938-1F3FF","non_qualified":null,"image":"1f938-1f3ff.png","sheet_x":40,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Person Doing Cartwheel","b":"1F938","d":true,"e":true,"f":true,"h":false,"k":[40,8],"o":4},"man-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2642-FE0F","non_qualified":"1F938-1F3FB-200D-2642","image":"1f938-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F938-1F3FC-200D-2642-FE0F","non_qualified":"1F938-1F3FC-200D-2642","image":"1f938-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F938-1F3FD-200D-2642-FE0F","non_qualified":"1F938-1F3FD-200D-2642","image":"1f938-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F938-1F3FE-200D-2642-FE0F","non_qualified":"1F938-1F3FE-200D-2642","image":"1f938-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F938-1F3FF-200D-2642-FE0F","non_qualified":"1F938-1F3FF-200D-2642","image":"1f938-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Cartwheeling","b":"1F938-200D-2642-FE0F","c":"1F938-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,2],"o":4},"woman-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2640-FE0F","non_qualified":"1F938-1F3FB-200D-2640","image":"1f938-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F938-1F3FC-200D-2640-FE0F","non_qualified":"1F938-1F3FC-200D-2640","image":"1f938-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F938-1F3FD-200D-2640-FE0F","non_qualified":"1F938-1F3FD-200D-2640","image":"1f938-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F938-1F3FE-200D-2640-FE0F","non_qualified":"1F938-1F3FE-200D-2640","image":"1f938-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F938-1F3FF-200D-2640-FE0F","non_qualified":"1F938-1F3FF-200D-2640","image":"1f938-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Cartwheeling","b":"1F938-200D-2640-FE0F","c":"1F938-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[39,53],"o":4},"wrestlers":{"a":"Wrestlers","b":"1F93C","d":true,"e":true,"f":true,"h":true,"k":[40,35],"o":4},"man-wrestling":{"a":"Man Wrestling","b":"1F93C-200D-2642-FE0F","c":"1F93C-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,34],"o":4},"woman-wrestling":{"a":"Woman Wrestling","b":"1F93C-200D-2640-FE0F","c":"1F93C-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,33],"o":4},"water_polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB","non_qualified":null,"image":"1f93d-1f3fb.png","sheet_x":40,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F93D-1F3FC","non_qualified":null,"image":"1f93d-1f3fc.png","sheet_x":40,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F93D-1F3FD","non_qualified":null,"image":"1f93d-1f3fd.png","sheet_x":40,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F93D-1F3FE","non_qualified":null,"image":"1f93d-1f3fe.png","sheet_x":40,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F93D-1F3FF","non_qualified":null,"image":"1f93d-1f3ff.png","sheet_x":40,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Water Polo","b":"1F93D","d":true,"e":true,"f":true,"h":false,"k":[40,48],"o":4},"man-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2642-FE0F","non_qualified":"1F93D-1F3FB-200D-2642","image":"1f93d-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93D-1F3FC-200D-2642-FE0F","non_qualified":"1F93D-1F3FC-200D-2642","image":"1f93d-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93D-1F3FD-200D-2642-FE0F","non_qualified":"1F93D-1F3FD-200D-2642","image":"1f93d-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93D-1F3FE-200D-2642-FE0F","non_qualified":"1F93D-1F3FE-200D-2642","image":"1f93d-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93D-1F3FF-200D-2642-FE0F","non_qualified":"1F93D-1F3FF-200D-2642","image":"1f93d-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Playing Water Polo","b":"1F93D-200D-2642-FE0F","c":"1F93D-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,42],"o":4},"woman-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2640-FE0F","non_qualified":"1F93D-1F3FB-200D-2640","image":"1f93d-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93D-1F3FC-200D-2640-FE0F","non_qualified":"1F93D-1F3FC-200D-2640","image":"1f93d-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93D-1F3FD-200D-2640-FE0F","non_qualified":"1F93D-1F3FD-200D-2640","image":"1f93d-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93D-1F3FE-200D-2640-FE0F","non_qualified":"1F93D-1F3FE-200D-2640","image":"1f93d-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93D-1F3FF-200D-2640-FE0F","non_qualified":"1F93D-1F3FF-200D-2640","image":"1f93d-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Playing Water Polo","b":"1F93D-200D-2640-FE0F","c":"1F93D-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,36],"o":4},"handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB","non_qualified":null,"image":"1f93e-1f3fb.png","sheet_x":41,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F93E-1F3FC","non_qualified":null,"image":"1f93e-1f3fc.png","sheet_x":41,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F93E-1F3FD","non_qualified":null,"image":"1f93e-1f3fd.png","sheet_x":41,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F93E-1F3FE","non_qualified":null,"image":"1f93e-1f3fe.png","sheet_x":41,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F93E-1F3FF","non_qualified":null,"image":"1f93e-1f3ff.png","sheet_x":41,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Handball","b":"1F93E","d":true,"e":true,"f":true,"h":false,"k":[41,9],"o":4},"man-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2642-FE0F","non_qualified":"1F93E-1F3FB-200D-2642","image":"1f93e-1f3fb-200d-2642-fe0f.png","sheet_x":41,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93E-1F3FC-200D-2642-FE0F","non_qualified":"1F93E-1F3FC-200D-2642","image":"1f93e-1f3fc-200d-2642-fe0f.png","sheet_x":41,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93E-1F3FD-200D-2642-FE0F","non_qualified":"1F93E-1F3FD-200D-2642","image":"1f93e-1f3fd-200d-2642-fe0f.png","sheet_x":41,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93E-1F3FE-200D-2642-FE0F","non_qualified":"1F93E-1F3FE-200D-2642","image":"1f93e-1f3fe-200d-2642-fe0f.png","sheet_x":41,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93E-1F3FF-200D-2642-FE0F","non_qualified":"1F93E-1F3FF-200D-2642","image":"1f93e-1f3ff-200d-2642-fe0f.png","sheet_x":41,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Playing Handball","b":"1F93E-200D-2642-FE0F","c":"1F93E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[41,3],"o":4},"woman-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2640-FE0F","non_qualified":"1F93E-1F3FB-200D-2640","image":"1f93e-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93E-1F3FC-200D-2640-FE0F","non_qualified":"1F93E-1F3FC-200D-2640","image":"1f93e-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93E-1F3FD-200D-2640-FE0F","non_qualified":"1F93E-1F3FD-200D-2640","image":"1f93e-1f3fd-200d-2640-fe0f.png","sheet_x":41,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93E-1F3FE-200D-2640-FE0F","non_qualified":"1F93E-1F3FE-200D-2640","image":"1f93e-1f3fe-200d-2640-fe0f.png","sheet_x":41,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93E-1F3FF-200D-2640-FE0F","non_qualified":"1F93E-1F3FF-200D-2640","image":"1f93e-1f3ff-200d-2640-fe0f.png","sheet_x":41,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Playing Handball","b":"1F93E-200D-2640-FE0F","c":"1F93E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,54],"o":4},"juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB","non_qualified":null,"image":"1f939-1f3fb.png","sheet_x":40,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC","non_qualified":null,"image":"1f939-1f3fc.png","sheet_x":40,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD","non_qualified":null,"image":"1f939-1f3fd.png","sheet_x":40,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE","non_qualified":null,"image":"1f939-1f3fe.png","sheet_x":40,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF","non_qualified":null,"image":"1f939-1f3ff.png","sheet_x":40,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Juggling","b":"1F939","d":true,"e":true,"f":true,"h":true,"k":[40,26],"o":4},"man-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2642-FE0F","non_qualified":"1F939-1F3FB-200D-2642","image":"1f939-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC-200D-2642-FE0F","non_qualified":"1F939-1F3FC-200D-2642","image":"1f939-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD-200D-2642-FE0F","non_qualified":"1F939-1F3FD-200D-2642","image":"1f939-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE-200D-2642-FE0F","non_qualified":"1F939-1F3FE-200D-2642","image":"1f939-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF-200D-2642-FE0F","non_qualified":"1F939-1F3FF-200D-2642","image":"1f939-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Juggling","b":"1F939-200D-2642-FE0F","c":"1F939-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,20],"o":4},"woman-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2640-FE0F","non_qualified":"1F939-1F3FB-200D-2640","image":"1f939-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC-200D-2640-FE0F","non_qualified":"1F939-1F3FC-200D-2640","image":"1f939-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD-200D-2640-FE0F","non_qualified":"1F939-1F3FD-200D-2640","image":"1f939-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE-200D-2640-FE0F","non_qualified":"1F939-1F3FE-200D-2640","image":"1f939-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF-200D-2640-FE0F","non_qualified":"1F939-1F3FF-200D-2640","image":"1f939-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Juggling","b":"1F939-200D-2640-FE0F","c":"1F939-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,14],"o":4},"person_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB","non_qualified":null,"image":"1f9d8-1f3fb.png","sheet_x":49,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D8-1F3FC","non_qualified":null,"image":"1f9d8-1f3fc.png","sheet_x":49,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D8-1F3FD","non_qualified":null,"image":"1f9d8-1f3fd.png","sheet_x":49,"sheet_y":34,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D8-1F3FE","non_qualified":null,"image":"1f9d8-1f3fe.png","sheet_x":49,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D8-1F3FF","non_qualified":null,"image":"1f9d8-1f3ff.png","sheet_x":49,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D8-200D-2640-FE0F","a":"Person in Lotus Position","b":"1F9D8","d":true,"e":true,"f":true,"h":true,"k":[49,31],"o":5},"man_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2642-FE0F","non_qualified":"1F9D8-1F3FB-200D-2642","image":"1f9d8-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2642-FE0F","non_qualified":"1F9D8-1F3FC-200D-2642","image":"1f9d8-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2642-FE0F","non_qualified":"1F9D8-1F3FD-200D-2642","image":"1f9d8-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":28,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2642-FE0F","non_qualified":"1F9D8-1F3FE-200D-2642","image":"1f9d8-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2642-FE0F","non_qualified":"1F9D8-1F3FF-200D-2642","image":"1f9d8-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Lotus Position","b":"1F9D8-200D-2642-FE0F","c":"1F9D8-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,25],"o":5},"woman_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2640-FE0F","non_qualified":"1F9D8-1F3FB-200D-2640","image":"1f9d8-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FB"},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2640-FE0F","non_qualified":"1F9D8-1F3FC-200D-2640","image":"1f9d8-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FC"},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2640-FE0F","non_qualified":"1F9D8-1F3FD-200D-2640","image":"1f9d8-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":22,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FD"},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2640-FE0F","non_qualified":"1F9D8-1F3FE-200D-2640","image":"1f9d8-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FE"},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2640-FE0F","non_qualified":"1F9D8-1F3FF-200D-2640","image":"1f9d8-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FF"}},"obsoletes":"1F9D8","a":"Woman in Lotus Position","b":"1F9D8-200D-2640-FE0F","c":"1F9D8-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,19],"o":5},"bath":{"skin_variations":{"1F3FB":{"unified":"1F6C0-1F3FB","non_qualified":null,"image":"1f6c0-1f3fb.png","sheet_x":36,"sheet_y":18,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6C0-1F3FC","non_qualified":null,"image":"1f6c0-1f3fc.png","sheet_x":36,"sheet_y":19,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6C0-1F3FD","non_qualified":null,"image":"1f6c0-1f3fd.png","sheet_x":36,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6C0-1F3FE","non_qualified":null,"image":"1f6c0-1f3fe.png","sheet_x":36,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6C0-1F3FF","non_qualified":null,"image":"1f6c0-1f3ff.png","sheet_x":36,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bath","b":"1F6C0","d":true,"e":true,"f":true,"h":true,"j":["clean","shower","bathroom"],"k":[36,17],"o":2},"sleeping_accommodation":{"skin_variations":{"1F3FB":{"unified":"1F6CC-1F3FB","non_qualified":null,"image":"1f6cc-1f3fb.png","sheet_x":36,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6CC-1F3FC","non_qualified":null,"image":"1f6cc-1f3fc.png","sheet_x":36,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6CC-1F3FD","non_qualified":null,"image":"1f6cc-1f3fd.png","sheet_x":36,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6CC-1F3FE","non_qualified":null,"image":"1f6cc-1f3fe.png","sheet_x":36,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6CC-1F3FF","non_qualified":null,"image":"1f6cc-1f3ff.png","sheet_x":36,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Sleeping Accommodation","b":"1F6CC","d":true,"e":true,"f":true,"h":true,"k":[36,29],"o":2},"people_holding_hands":{"skin_variations":{"1F3FB-1F3FB":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FC":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FD":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FE":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":47,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":47,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":47,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":47,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":47,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":47,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FF":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":47,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"People Holding Hands","b":"1F9D1-200D-1F91D-200D-1F9D1","d":true,"e":true,"f":true,"h":true,"k":[46,38],"o":12},"two_women_holding_hands":{"skin_variations":{"1F3FB":{"unified":"1F46D-1F3FB","non_qualified":null,"image":"1f46d-1f3fb.png","sheet_x":21,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46D-1F3FC","non_qualified":null,"image":"1f46d-1f3fc.png","sheet_x":21,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46D-1F3FD","non_qualified":null,"image":"1f46d-1f3fd.png","sheet_x":21,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46D-1F3FE","non_qualified":null,"image":"1f46d-1f3fe.png","sheet_x":21,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46D-1F3FF","non_qualified":null,"image":"1f46d-1f3ff.png","sheet_x":21,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Two Women Holding Hands","b":"1F46D","d":true,"e":true,"f":true,"h":true,"j":["pair","friendship","couple","love","like","female","people","human"],"k":[21,11],"n":["women_holding_hands"],"o":2},"couple":{"skin_variations":{"1F3FB":{"unified":"1F46B-1F3FB","non_qualified":null,"image":"1f46b-1f3fb.png","sheet_x":20,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46B-1F3FC","non_qualified":null,"image":"1f46b-1f3fc.png","sheet_x":20,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46B-1F3FD","non_qualified":null,"image":"1f46b-1f3fd.png","sheet_x":20,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46B-1F3FE","non_qualified":null,"image":"1f46b-1f3fe.png","sheet_x":20,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46B-1F3FF","non_qualified":null,"image":"1f46b-1f3ff.png","sheet_x":20,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FD":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FE":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FF":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FB":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FE":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FF":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FB":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FF":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FB":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FB":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man and Woman Holding Hands","b":"1F46B","d":true,"e":true,"f":true,"h":true,"j":["pair","people","human","love","date","dating","like","affection","valentines","marriage"],"k":[20,16],"n":["man_and_woman_holding_hands","woman_and_man_holding_hands"],"o":2},"two_men_holding_hands":{"skin_variations":{"1F3FB":{"unified":"1F46C-1F3FB","non_qualified":null,"image":"1f46c-1f3fb.png","sheet_x":20,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46C-1F3FC","non_qualified":null,"image":"1f46c-1f3fc.png","sheet_x":20,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46C-1F3FD","non_qualified":null,"image":"1f46c-1f3fd.png","sheet_x":20,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46C-1F3FE","non_qualified":null,"image":"1f46c-1f3fe.png","sheet_x":20,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46C-1F3FF","non_qualified":null,"image":"1f46c-1f3ff.png","sheet_x":20,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":21,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":21,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":21,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":21,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":21,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":21,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":21,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":21,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Two Men Holding Hands","b":"1F46C","d":true,"e":true,"f":true,"h":true,"j":["pair","couple","love","like","bromance","friendship","people","human"],"k":[20,42],"n":["men_holding_hands"],"o":2},"couplekiss":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","a":"Kiss","b":"1F48F","d":true,"e":true,"f":true,"h":true,"k":[25,25],"o":2},"woman-kiss-man":{"obsoletes":"1F48F","a":"Woman Kiss Man","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F469-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[20,7],"o":2},"man-kiss-man":{"a":"Man Kiss Man","b":"1F468-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F468-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[17,21],"o":2},"woman-kiss-woman":{"a":"Woman Kiss Woman","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F469","c":"1F469-200D-2764-200D-1F48B-200D-1F469","d":true,"e":true,"f":true,"h":true,"k":[20,8],"o":2},"couple_with_heart":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F468","a":"Couple with Heart","b":"1F491","d":true,"e":true,"f":true,"h":true,"k":[25,27],"o":2},"woman-heart-man":{"obsoletes":"1F491","a":"Woman Heart Man","b":"1F469-200D-2764-FE0F-200D-1F468","c":"1F469-200D-2764-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[20,5],"o":2},"man-heart-man":{"a":"Man Heart Man","b":"1F468-200D-2764-FE0F-200D-1F468","c":"1F468-200D-2764-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[17,20],"o":2},"woman-heart-woman":{"a":"Woman Heart Woman","b":"1F469-200D-2764-FE0F-200D-1F469","c":"1F469-200D-2764-200D-1F469","d":true,"e":true,"f":true,"h":true,"k":[20,6],"o":2},"family":{"obsoleted_by":"1F468-200D-1F469-200D-1F466","a":"Family","b":"1F46A","d":true,"e":true,"f":true,"h":true,"k":[20,15],"n":["man-woman-boy"],"o":2},"man-woman-boy":{"obsoletes":"1F46A","a":"Man Woman Boy","b":"1F468-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,33],"n":["family"],"o":2},"man-woman-girl":{"a":"Man Woman Girl","b":"1F468-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,35],"o":2},"man-woman-girl-boy":{"a":"Man Woman Girl Boy","b":"1F468-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,36],"o":2},"man-woman-boy-boy":{"a":"Man Woman Boy Boy","b":"1F468-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,34],"o":2},"man-woman-girl-girl":{"a":"Man Woman Girl Girl","b":"1F468-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,37],"o":2},"man-man-boy":{"a":"Man Man Boy","b":"1F468-200D-1F468-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,28],"o":2},"man-man-girl":{"a":"Man Man Girl","b":"1F468-200D-1F468-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,30],"o":2},"man-man-girl-boy":{"a":"Man Man Girl Boy","b":"1F468-200D-1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,31],"o":2},"man-man-boy-boy":{"a":"Man Man Boy Boy","b":"1F468-200D-1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,29],"o":2},"man-man-girl-girl":{"a":"Man Man Girl Girl","b":"1F468-200D-1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,32],"o":2},"woman-woman-boy":{"a":"Woman Woman Boy","b":"1F469-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,18],"o":2},"woman-woman-girl":{"a":"Woman Woman Girl","b":"1F469-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,20],"o":2},"woman-woman-girl-boy":{"a":"Woman Woman Girl Boy","b":"1F469-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,21],"o":2},"woman-woman-boy-boy":{"a":"Woman Woman Boy Boy","b":"1F469-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,19],"o":2},"woman-woman-girl-girl":{"a":"Woman Woman Girl Girl","b":"1F469-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,22],"o":2},"man-boy":{"a":"Man Boy","b":"1F468-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,24],"o":4},"man-boy-boy":{"a":"Man Boy Boy","b":"1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,23],"o":4},"man-girl":{"a":"Man Girl","b":"1F468-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,27],"o":4},"man-girl-boy":{"a":"Man Girl Boy","b":"1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,25],"o":4},"man-girl-girl":{"a":"Man Girl Girl","b":"1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,26],"o":4},"woman-boy":{"a":"Woman Boy","b":"1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,14],"o":4},"woman-boy-boy":{"a":"Woman Boy Boy","b":"1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,13],"o":4},"woman-girl":{"a":"Woman Girl","b":"1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,17],"o":4},"woman-girl-boy":{"a":"Woman Girl Boy","b":"1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,15],"o":4},"woman-girl-girl":{"a":"Woman Girl Girl","b":"1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,16],"o":4},"speaking_head_in_silhouette":{"a":"Speaking Head in Silhouette","b":"1F5E3-FE0F","c":"1F5E3","d":true,"e":true,"f":true,"h":true,"k":[30,25],"o":2},"bust_in_silhouette":{"a":"Bust in Silhouette","b":"1F464","d":true,"e":true,"f":true,"h":true,"j":["user","person","human"],"k":[14,24],"o":2},"busts_in_silhouette":{"a":"Busts in Silhouette","b":"1F465","d":true,"e":true,"f":true,"h":true,"j":["user","person","human","group","team"],"k":[14,25],"o":2},"footprints":{"a":"Footprints","b":"1F463","d":true,"e":true,"f":true,"h":true,"j":["feet","tracking","walking","beach"],"k":[14,23],"o":2}},"aliases":{"raised_hand":"hand","satisfied":"laughing","tshirt":"shirt","hand_with_index_and_middle_fingers_crossed":"crossed_fingers","sign_of_the_horns":"the_horns","grinning_face_with_star_eyes":"star-struck","reversed_hand_with_middle_finger_extended":"middle_finger","thumbsup":"+1","thumbsdown":"-1","punch":"facepunch","grinning_face_with_one_large_and_one_small_eye":"zany_face","shoe":"mans_shoe","smiling_face_with_smiling_eyes_and_hand_covering_mouth":"face_with_hand_over_mouth","face_with_finger_covering_closed_lips":"shushing_face","face_with_one_eyebrow_raised":"face_with_raised_eyebrow","face_with_open_mouth_vomiting":"face_vomiting","cooking":"fried_egg","flag-cn":"cn","shocked_face_with_exploding_head":"exploding_head","paw_prints":"feet","flag-de":"de","telephone":"phone","flag-es":"es","red_car":"car","flipper":"dolphin","flag-fr":"fr","uk":"gb","flag-gb":"gb","serious_face_with_symbols_covering_mouth":"face_with_symbols_on_mouth","poop":"hankey","shit":"hankey","honeybee":"bee","staff_of_aesculapius":"medical_symbol","lantern":"izakaya_lantern","open_book":"book","sailboat":"boat","knife":"hocho","flag-it":"it","heavy_exclamation_mark":"exclamation","flag-jp":"jp","envelope":"email","flag-kr":"kr","collision":"boom","pencil":"memo","waxing_gibbous_moon":"moon","mother_christmas":"mrs_claus","sun_small_cloud":"mostly_sunny","sun_behind_cloud":"barely_sunny","sun_behind_rain_cloud":"partly_sunny_rain","lightning_cloud":"lightning","tornado_cloud":"tornado","flag-ru":"ru","running":"runner","flag-us":"us","women_holding_hands":"two_women_holding_hands","man_and_woman_holding_hands":"couple","woman_and_man_holding_hands":"couple","men_holding_hands":"two_men_holding_hands","man-woman-boy":"family","family":"man-woman-boy"}}
},{}],589:[function(require,module,exports){
'use strict';
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _assertThisInitialized2 = _interopRequireDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));
var _react = _interopRequireDefault(require('react'));
var _propTypes = _interopRequireDefault(require('prop-types'));
var Anchors = function (_React$PureComponent) {
    (0, _inherits2['default'])(Anchors, _React$PureComponent);
    function Anchors(props) {
        var _this;
        (0, _classCallCheck2['default'])(this, Anchors);
        _this = (0, _possibleConstructorReturn2['default'])(this, (0, _getPrototypeOf2['default'])(Anchors).call(this, props));
        var defaultCategory = props.categories.filter(function (category) {
            return category.first;
        })[0];
        _this.state = { selected: defaultCategory.name };
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2['default'])(_this));
        return _this;
    }
    (0, _createClass2['default'])(Anchors, [
        {
            key: 'handleClick',
            value: function handleClick(e) {
                var index = e.currentTarget.getAttribute('data-index');
                var _this$props = this.props, categories = _this$props.categories, onAnchorClick = _this$props.onAnchorClick;
                onAnchorClick(categories[index], index);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, categories = _this$props2.categories, color = _this$props2.color, i18n = _this$props2.i18n, icons = _this$props2.icons, selected = this.state.selected;
                return _react['default'].createElement('nav', {
                    className: 'emoji-mart-anchors',
                    'aria-label': i18n.categorieslabel
                }, categories.map(function (category, i) {
                    var id = category.id, name = category.name, anchor = category.anchor, isSelected = name == selected;
                    if (anchor === false) {
                        return null;
                    }
                    var iconId = id.startsWith('custom-') ? 'custom' : id;
                    return _react['default'].createElement('button', {
                        key: id,
                        'aria-label': i18n.categories[id],
                        title: i18n.categories[id],
                        'data-index': i,
                        type: 'button',
                        onClick: _this2.handleClick,
                        className: 'emoji-mart-anchor '.concat(isSelected ? 'emoji-mart-anchor-selected' : ''),
                        style: { color: isSelected ? color : null }
                    }, _react['default'].createElement('div', { className: 'emoji-mart-anchor-icon' }, icons.categories[iconId]()), _react['default'].createElement('span', {
                        className: 'emoji-mart-anchor-bar',
                        style: { backgroundColor: color }
                    }));
                }));
            }
        }
    ]);
    return Anchors;
}(_react['default'].PureComponent);
exports['default'] = Anchors;
Anchors.propTypes = {
    categories: _propTypes['default'].array,
    onAnchorClick: _propTypes['default'].func,
    icons: _propTypes['default'].object
};
Anchors.defaultProps = {
    categories: [],
    onAnchorClick: function onAnchorClick() {
    },
    icons: {}
};
},{"@babel/runtime/helpers/assertThisInitialized":311,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],590:[function(require,module,exports){
'use strict';
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _assertThisInitialized2 = _interopRequireDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));
var _react = _interopRequireDefault(require('react'));
var _propTypes = _interopRequireDefault(require('prop-types'));
var _frequently = _interopRequireDefault(require('../utils/frequently'));
var _utils = require('../utils');
var _nimbleEmoji = _interopRequireDefault(require('./emoji/nimble-emoji'));
var _notFound = _interopRequireDefault(require('./not-found'));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2['default'])(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
var Category = function (_React$Component) {
    (0, _inherits2['default'])(Category, _React$Component);
    function Category(props) {
        var _this;
        (0, _classCallCheck2['default'])(this, Category);
        _this = (0, _possibleConstructorReturn2['default'])(this, (0, _getPrototypeOf2['default'])(Category).call(this, props));
        _this.data = props.data;
        _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2['default'])(_this));
        _this.setLabelRef = _this.setLabelRef.bind((0, _assertThisInitialized2['default'])(_this));
        return _this;
    }
    (0, _createClass2['default'])(Category, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.margin = 0;
                this.minMargin = 0;
                this.memoizeSize();
            }
        },
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps, nextState) {
                var _this$props = this.props, name = _this$props.name, perLine = _this$props.perLine, _native = _this$props['native'], hasStickyPosition = _this$props.hasStickyPosition, emojis = _this$props.emojis, emojiProps = _this$props.emojiProps, skin = emojiProps.skin, size = emojiProps.size, set = emojiProps.set, nextPerLine = nextProps.perLine, nextNative = nextProps['native'], nextHasStickyPosition = nextProps.hasStickyPosition, nextEmojis = nextProps.emojis, nextEmojiProps = nextProps.emojiProps, nextSkin = nextEmojiProps.skin, nextSize = nextEmojiProps.size, nextSet = nextEmojiProps.set, shouldUpdate = false;
                if (name == 'Recent' && perLine != nextPerLine) {
                    shouldUpdate = true;
                }
                if (name == 'Search') {
                    shouldUpdate = !(emojis == nextEmojis);
                }
                if (skin != nextSkin || size != nextSize || _native != nextNative || set != nextSet || hasStickyPosition != nextHasStickyPosition) {
                    shouldUpdate = true;
                }
                return shouldUpdate;
            }
        },
        {
            key: 'memoizeSize',
            value: function memoizeSize() {
                if (!this.container) {
                    this.top = 0;
                    this.maxMargin = 0;
                    return;
                }
                var parent = this.container.parentElement;
                var _this$container$getBo = this.container.getBoundingClientRect(), top = _this$container$getBo.top, height = _this$container$getBo.height;
                var _parent$getBoundingCl = parent.getBoundingClientRect(), parentTop = _parent$getBoundingCl.top;
                var _this$label$getBoundi = this.label.getBoundingClientRect(), labelHeight = _this$label$getBoundi.height;
                this.top = top - parentTop + parent.scrollTop;
                if (height == 0) {
                    this.maxMargin = 0;
                } else {
                    this.maxMargin = height - labelHeight;
                }
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(scrollTop) {
                var margin = scrollTop - this.top;
                margin = margin < this.minMargin ? this.minMargin : margin;
                margin = margin > this.maxMargin ? this.maxMargin : margin;
                if (margin == this.margin)
                    return;
                if (!this.props.hasStickyPosition) {
                    this.label.style.top = ''.concat(margin, 'px');
                }
                this.margin = margin;
                return true;
            }
        },
        {
            key: 'getEmojis',
            value: function getEmojis() {
                var _this2 = this;
                var _this$props2 = this.props, name = _this$props2.name, emojis = _this$props2.emojis, recent = _this$props2.recent, perLine = _this$props2.perLine;
                if (name == 'Recent') {
                    var custom = this.props.custom;
                    var frequentlyUsed = recent || _frequently['default'].get(perLine);
                    if (frequentlyUsed.length) {
                        emojis = frequentlyUsed.map(function (id) {
                            var emoji = custom.filter(function (e) {
                                return e.id === id;
                            })[0];
                            if (emoji) {
                                return emoji;
                            }
                            return id;
                        }).filter(function (id) {
                            return !!(0, _utils.getData)(id, null, null, _this2.data);
                        });
                    }
                    if (emojis.length === 0 && frequentlyUsed.length > 0) {
                        return null;
                    }
                }
                if (emojis) {
                    emojis = emojis.slice(0);
                }
                return emojis;
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay(display) {
                var emojis = this.getEmojis();
                if (!emojis || !this.container) {
                    return;
                }
                this.container.style.display = display;
            }
        },
        {
            key: 'setContainerRef',
            value: function setContainerRef(c) {
                this.container = c;
            }
        },
        {
            key: 'setLabelRef',
            value: function setLabelRef(c) {
                this.label = c;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, id = _this$props3.id, name = _this$props3.name, hasStickyPosition = _this$props3.hasStickyPosition, emojiProps = _this$props3.emojiProps, i18n = _this$props3.i18n, notFound = _this$props3.notFound, notFoundEmoji = _this$props3.notFoundEmoji, emojis = this.getEmojis(), labelStyles = {}, labelSpanStyles = {}, containerStyles = {};
                if (!emojis) {
                    containerStyles = { display: 'none' };
                }
                if (!hasStickyPosition) {
                    labelStyles = { height: 28 };
                    labelSpanStyles = { position: 'absolute' };
                }
                var label = i18n.categories[id] || name;
                return _react['default'].createElement('section', {
                    ref: this.setContainerRef,
                    className: 'emoji-mart-category',
                    'aria-label': label,
                    style: containerStyles
                }, _react['default'].createElement('div', {
                    style: labelStyles,
                    'data-name': name,
                    className: 'emoji-mart-category-label'
                }, _react['default'].createElement('span', {
                    style: labelSpanStyles,
                    ref: this.setLabelRef,
                    'aria-hidden': true
                }, label)), _react['default'].createElement('ul', { className: 'emoji-mart-category-list' }, emojis && emojis.map(function (emoji) {
                    return _react['default'].createElement('li', { key: emoji.short_names && emoji.short_names.join('_') || emoji }, (0, _nimbleEmoji['default'])(_objectSpread({
                        emoji: emoji,
                        data: _this3.data
                    }, emojiProps)));
                })), emojis && !emojis.length && _react['default'].createElement(_notFound['default'], {
                    i18n: i18n,
                    notFound: notFound,
                    notFoundEmoji: notFoundEmoji,
                    data: this.data,
                    emojiProps: emojiProps
                }));
            }
        }
    ]);
    return Category;
}(_react['default'].Component);
exports['default'] = Category;
Category.propTypes = {
    emojis: _propTypes['default'].array,
    hasStickyPosition: _propTypes['default'].bool,
    name: _propTypes['default'].string.isRequired,
    'native': _propTypes['default'].bool.isRequired,
    perLine: _propTypes['default'].number.isRequired,
    emojiProps: _propTypes['default'].object.isRequired,
    recent: _propTypes['default'].arrayOf(_propTypes['default'].string),
    notFound: _propTypes['default'].func,
    notFoundEmoji: _propTypes['default'].string.isRequired
};
Category.defaultProps = {
    emojis: [],
    hasStickyPosition: true
};
},{"../utils":608,"../utils/frequently":607,"./emoji/nimble-emoji":592,"./not-found":593,"@babel/runtime/helpers/assertThisInitialized":311,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],591:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _all = _interopRequireDefault(require("../../../data/all.json"));

var _nimbleEmoji = _interopRequireDefault(require("./nimble-emoji"));

var _sharedProps = require("../../utils/shared-props");

var _sharedDefaultProps = require("../../utils/shared-default-props");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Emoji = function Emoji(props) {
  for (var k in Emoji.defaultProps) {
    if (props[k] == undefined && Emoji.defaultProps[k] != undefined) {
      props[k] = Emoji.defaultProps[k];
    }
  }

  return (0, _nimbleEmoji["default"])(_objectSpread({}, props));
};

Emoji.propTypes
/* remove-proptypes */
= _sharedProps.EmojiPropTypes;
Emoji.defaultProps = _objectSpread({}, _sharedDefaultProps.EmojiDefaultProps, {
  data: _all["default"]
});
var _default = Emoji;
exports["default"] = _default;
},{"../../../data/all.json":588,"../../utils/shared-default-props":609,"../../utils/shared-props":610,"./nimble-emoji":592,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/interopRequireDefault":319,"react":1107}],592:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var _data = require("../../utils/data");

var _sharedProps = require("../../utils/shared-props");

var _sharedDefaultProps = require("../../utils/shared-default-props");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _getData = function _getData(props) {
  var emoji = props.emoji,
      skin = props.skin,
      set = props.set,
      data = props.data;
  return (0, _utils.getData)(emoji, skin, set, data);
};

var _getPosition = function _getPosition(props) {
  var _getData2 = _getData(props),
      sheet_x = _getData2.sheet_x,
      sheet_y = _getData2.sheet_y,
      multiplyX = 100 / (props.sheetColumns - 1),
      multiplyY = 100 / (props.sheetRows - 1);

  return "".concat(multiplyX * sheet_x, "% ").concat(multiplyY * sheet_y, "%");
};

var _getSanitizedData = function _getSanitizedData(props) {
  var emoji = props.emoji,
      skin = props.skin,
      set = props.set,
      data = props.data;
  return (0, _utils.getSanitizedData)(emoji, skin, set, data);
};

var _handleClick = function _handleClick(e, props) {
  if (!props.onClick) {
    return;
  }

  var onClick = props.onClick,
      emoji = _getSanitizedData(props);

  onClick(emoji, e);
};

var _handleOver = function _handleOver(e, props) {
  if (!props.onOver) {
    return;
  }

  var onOver = props.onOver,
      emoji = _getSanitizedData(props);

  onOver(emoji, e);
};

var _handleLeave = function _handleLeave(e, props) {
  if (!props.onLeave) {
    return;
  }

  var onLeave = props.onLeave,
      emoji = _getSanitizedData(props);

  onLeave(emoji, e);
};

var _isNumeric = function _isNumeric(value) {
  return !isNaN(value - parseFloat(value));
};

var _convertStyleToCSS = function _convertStyleToCSS(style) {
  var div = document.createElement('div');

  for (var key in style) {
    var value = style[key];

    if (_isNumeric(value)) {
      value += 'px';
    }

    div.style[key] = value;
  }

  return div.getAttribute('style');
};

var NimbleEmoji = function NimbleEmoji(props) {
  if (props.data.compressed) {
    (0, _data.uncompress)(props.data);
  }

  for (var k in NimbleEmoji.defaultProps) {
    if (props[k] == undefined && NimbleEmoji.defaultProps[k] != undefined) {
      props[k] = NimbleEmoji.defaultProps[k];
    }
  }

  var data = _getData(props);

  if (!data) {
    if (props.fallback) {
      return props.fallback(null, props);
    } else {
      return null;
    }
  }

  var unified = data.unified,
      custom = data.custom,
      short_names = data.short_names,
      imageUrl = data.imageUrl,
      style = {},
      children = props.children,
      className = 'emoji-mart-emoji',
      nativeEmoji = unified && (0, _utils.unifiedToNative)(unified),
      label = [nativeEmoji].concat(short_names).filter(Boolean).join(', '),
      title = null;

  if (!unified && !custom) {
    if (props.fallback) {
      return props.fallback(data, props);
    } else {
      return null;
    }
  }

  if (props.tooltip) {
    title = short_names[0];
  }

  if (props["native"] && unified) {
    className += ' emoji-mart-emoji-native';
    style = {
      fontSize: props.size
    };
    children = nativeEmoji;

    if (props.forceSize) {
      style.display = 'inline-block';
      style.width = props.size;
      style.height = props.size;
      style.wordBreak = 'keep-all';
    }
  } else if (custom) {
    className += ' emoji-mart-emoji-custom';
    style = {
      width: props.size,
      height: props.size,
      display: 'inline-block'
    };

    if (data.spriteUrl) {
      style = _objectSpread({}, style, {
        backgroundImage: "url(".concat(data.spriteUrl, ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      });
    } else {
      style = _objectSpread({}, style, {
        backgroundImage: "url(".concat(imageUrl, ")"),
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      });
    }
  } else {
    var setHasEmoji = data["has_img_".concat(props.set)] == undefined || data["has_img_".concat(props.set)];

    if (!setHasEmoji) {
      if (props.fallback) {
        return props.fallback(data, props);
      } else {
        return null;
      }
    } else {
      style = {
        width: props.size,
        height: props.size,
        display: 'inline-block',
        backgroundImage: "url(".concat(props.backgroundImageFn(props.set, props.sheetSize), ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      };
    }
  }

  var Tag = {
    name: 'span',
    props: {}
  };

  if (props.onClick && props.useButton) {
    Tag.name = 'button';
    Tag.props = {
      type: 'button'
    };
  }

  if (props.html) {
    style = _convertStyleToCSS(style);
    return "<".concat(Tag.name, " style='").concat(style, "' aria-label='").concat(label, "' ").concat(title ? "title='".concat(title, "'") : '', " class='").concat(className, "'>").concat(children || '', "</").concat(Tag.name, ">");
  } else {
    return _react["default"].createElement(Tag.name, (0, _extends2["default"])({
      onClick: function onClick(e) {
        return _handleClick(e, props);
      },
      onMouseEnter: function onMouseEnter(e) {
        return _handleOver(e, props);
      },
      onMouseLeave: function onMouseLeave(e) {
        return _handleLeave(e, props);
      },
      "aria-label": label,
      title: title,
      className: className
    }, Tag.props), _react["default"].createElement("span", {
      style: style
    }, children));
  }
};

NimbleEmoji.propTypes
/* remove-proptypes */
= _objectSpread({}, _sharedProps.EmojiPropTypes, {
  data: _propTypes["default"].object.isRequired
});
NimbleEmoji.defaultProps = _sharedDefaultProps.EmojiDefaultProps;
var _default = NimbleEmoji;
exports["default"] = _default;
},{"../../utils":608,"../../utils/data":604,"../../utils/shared-default-props":609,"../../utils/shared-props":610,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/interopRequireDefault":319,"prop-types":896,"react":1107}],593:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nimbleEmoji = _interopRequireDefault(require("./emoji/nimble-emoji"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NotFound =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(NotFound, _React$PureComponent);

  function NotFound() {
    (0, _classCallCheck2["default"])(this, NotFound);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(NotFound).apply(this, arguments));
  }

  (0, _createClass2["default"])(NotFound, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          emojiProps = _this$props.emojiProps,
          i18n = _this$props.i18n,
          notFound = _this$props.notFound,
          notFoundEmoji = _this$props.notFoundEmoji;

      var component = notFound && notFound() || _react["default"].createElement("div", {
        className: "emoji-mart-no-results"
      }, (0, _nimbleEmoji["default"])(_objectSpread({
        data: data
      }, emojiProps, {
        size: 38,
        emoji: notFoundEmoji,
        onOver: null,
        onLeave: null,
        onClick: null
      })), _react["default"].createElement("div", {
        className: "emoji-mart-no-results-label"
      }, i18n.notfound));

      return component;
    }
  }]);
  return NotFound;
}(_react["default"].PureComponent);

exports["default"] = NotFound;
NotFound.propTypes
/* remove-proptypes */
= {
  notFound: _propTypes["default"].func.isRequired,
  emojiProps: _propTypes["default"].object.isRequired
};
},{"./emoji/nimble-emoji":592,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],594:[function(require,module,exports){
'use strict';
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _assertThisInitialized2 = _interopRequireDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));
var _react = _interopRequireDefault(require('react'));
var _propTypes = _interopRequireDefault(require('prop-types'));
var icons = _interopRequireWildcard(require('../../svgs'));
var _store = _interopRequireDefault(require('../../utils/store'));
var _frequently = _interopRequireDefault(require('../../utils/frequently'));
var _utils = require('../../utils');
var _data = require('../../utils/data');
var _sharedProps = require('../../utils/shared-props');
var _anchors = _interopRequireDefault(require('../anchors'));
var _category = _interopRequireDefault(require('../category'));
var _preview = _interopRequireDefault(require('../preview'));
var _search = _interopRequireDefault(require('../search'));
var _sharedDefaultProps = require('../../utils/shared-default-props');
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2['default'])(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
var I18N = {
    search: 'Search',
    clear: 'Clear',
    notfound: 'No Emoji Found',
    skintext: 'Choose your default skin tone',
    categories: {
        search: 'Search Results',
        recent: 'Frequently Used',
        people: 'Smileys & People',
        nature: 'Animals & Nature',
        foods: 'Food & Drink',
        activity: 'Activity',
        places: 'Travel & Places',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags',
        custom: 'Custom'
    },
    categorieslabel: 'Emoji categories',
    skintones: {
        1: 'Default Skin Tone',
        2: 'Light Skin Tone',
        3: 'Medium-Light Skin Tone',
        4: 'Medium Skin Tone',
        5: 'Medium-Dark Skin Tone',
        6: 'Dark Skin Tone'
    }
};
var NimblePicker = function (_React$PureComponent) {
    (0, _inherits2['default'])(NimblePicker, _React$PureComponent);
    function NimblePicker(props) {
        var _this;
        (0, _classCallCheck2['default'])(this, NimblePicker);
        _this = (0, _possibleConstructorReturn2['default'])(this, (0, _getPrototypeOf2['default'])(NimblePicker).call(this, props));
        _this.CUSTOM = [];
        _this.RECENT_CATEGORY = {
            id: 'recent',
            name: 'Recent',
            emojis: null
        };
        _this.SEARCH_CATEGORY = {
            id: 'search',
            name: 'Search',
            emojis: null,
            anchor: false
        };
        if (props.data.compressed) {
            (0, _data.uncompress)(props.data);
        }
        _this.data = props.data;
        _this.i18n = (0, _utils.deepMerge)(I18N, props.i18n);
        _this.icons = (0, _utils.deepMerge)(icons, props.icons);
        _this.state = { firstRender: true };
        _this.categories = [];
        var allCategories = [].concat(_this.data.categories);
        if (props.custom.length > 0) {
            var customCategories = {};
            var customCategoriesCreated = 0;
            props.custom.forEach(function (emoji) {
                if (!customCategories[emoji.customCategory]) {
                    customCategories[emoji.customCategory] = {
                        id: emoji.customCategory ? 'custom-'.concat(emoji.customCategory) : 'custom',
                        name: emoji.customCategory || 'Custom',
                        emojis: [],
                        anchor: customCategoriesCreated === 0
                    };
                    customCategoriesCreated++;
                }
                var category = customCategories[emoji.customCategory];
                var customEmoji = _objectSpread({}, emoji, {
                    id: emoji.short_names[0],
                    custom: true
                });
                category.emojis.push(customEmoji);
                _this.CUSTOM.push(customEmoji);
            });
            allCategories = allCategories.concat(Object.keys(customCategories).map(function (key) {
                return customCategories[key];
            }));
        }
        _this.hideRecent = true;
        if (props.include != undefined) {
            allCategories.sort(function (a, b) {
                if (props.include.indexOf(a.id) > props.include.indexOf(b.id)) {
                    return 1;
                }
                return -1;
            });
        }
        for (var categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
            var category = allCategories[categoryIndex];
            var isIncluded = props.include && props.include.length ? props.include.indexOf(category.id) > -1 : true;
            var isExcluded = props.exclude && props.exclude.length ? props.exclude.indexOf(category.id) > -1 : false;
            if (!isIncluded || isExcluded) {
                continue;
            }
            if (props.emojisToShowFilter) {
                var newEmojis = [];
                var emojis = category.emojis;
                for (var emojiIndex = 0; emojiIndex < emojis.length; emojiIndex++) {
                    var emoji = emojis[emojiIndex];
                    if (props.emojisToShowFilter(_this.data.emojis[emoji] || emoji)) {
                        newEmojis.push(emoji);
                    }
                }
                if (newEmojis.length) {
                    var newCategory = {
                        emojis: newEmojis,
                        name: category.name,
                        id: category.id
                    };
                    _this.categories.push(newCategory);
                }
            } else {
                _this.categories.push(category);
            }
        }
        var includeRecent = props.include && props.include.length ? props.include.indexOf(_this.RECENT_CATEGORY.id) > -1 : true;
        var excludeRecent = props.exclude && props.exclude.length ? props.exclude.indexOf(_this.RECENT_CATEGORY.id) > -1 : false;
        if (includeRecent && !excludeRecent) {
            _this.hideRecent = false;
            _this.categories.unshift(_this.RECENT_CATEGORY);
        }
        if (_this.categories[0]) {
            _this.categories[0].first = true;
        }
        _this.categories.unshift(_this.SEARCH_CATEGORY);
        _this.setAnchorsRef = _this.setAnchorsRef.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleAnchorClick = _this.handleAnchorClick.bind((0, _assertThisInitialized2['default'])(_this));
        _this.setSearchRef = _this.setSearchRef.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleSearch = _this.handleSearch.bind((0, _assertThisInitialized2['default'])(_this));
        _this.setScrollRef = _this.setScrollRef.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleScroll = _this.handleScroll.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleScrollPaint = _this.handleScrollPaint.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleEmojiOver = _this.handleEmojiOver.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleEmojiLeave = _this.handleEmojiLeave.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleEmojiClick = _this.handleEmojiClick.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleEmojiSelect = _this.handleEmojiSelect.bind((0, _assertThisInitialized2['default'])(_this));
        _this.setPreviewRef = _this.setPreviewRef.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleSkinChange = _this.handleSkinChange.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleDarkMatchMediaChange = _this.handleDarkMatchMediaChange.bind((0, _assertThisInitialized2['default'])(_this));
        return _this;
    }
    (0, _createClass2['default'])(NimblePicker, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;
                if (this.state.firstRender) {
                    this.testStickyPosition();
                    this.firstRenderTimeout = setTimeout(function () {
                        _this2.setState({ firstRender: false });
                    }, 60);
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.updateCategoriesSize();
                this.handleScroll();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.SEARCH_CATEGORY.emojis = null;
                clearTimeout(this.leaveTimeout);
                clearTimeout(this.firstRenderTimeout);
                if (this.darkMatchMedia) {
                    this.darkMatchMedia.removeListener(this.handleDarkMatchMediaChange);
                }
            }
        },
        {
            key: 'testStickyPosition',
            value: function testStickyPosition() {
                var stickyTestElement = document.createElement('div');
                var prefixes = [
                    '',
                    '-webkit-',
                    '-ms-',
                    '-moz-',
                    '-o-'
                ];
                prefixes.forEach(function (prefix) {
                    return stickyTestElement.style.position = ''.concat(prefix, 'sticky');
                });
                this.hasStickyPosition = !!stickyTestElement.style.position.length;
            }
        },
        {
            key: 'getPreferredTheme',
            value: function getPreferredTheme() {
                if (this.props.theme != 'auto')
                    return this.props.theme;
                if (this.state.theme)
                    return this.state.theme;
                if (typeof matchMedia !== 'function')
                    return _sharedDefaultProps.PickerDefaultProps.theme;
                if (!this.darkMatchMedia) {
                    this.darkMatchMedia = matchMedia('(prefers-color-scheme: dark)');
                    this.darkMatchMedia.addListener(this.handleDarkMatchMediaChange);
                }
                if (this.darkMatchMedia.media.match(/^not/))
                    return _sharedDefaultProps.PickerDefaultProps.theme;
                return this.darkMatchMedia.matches ? 'dark' : 'light';
            }
        },
        {
            key: 'handleDarkMatchMediaChange',
            value: function handleDarkMatchMediaChange() {
                this.setState({ theme: this.darkMatchMedia.matches ? 'dark' : 'light' });
            }
        },
        {
            key: 'handleEmojiOver',
            value: function handleEmojiOver(emoji) {
                var preview = this.preview;
                if (!preview) {
                    return;
                }
                var emojiData = this.CUSTOM.filter(function (customEmoji) {
                    return customEmoji.id === emoji.id;
                })[0];
                for (var key in emojiData) {
                    if (emojiData.hasOwnProperty(key)) {
                        emoji[key] = emojiData[key];
                    }
                }
                preview.setState({ emoji: emoji });
                clearTimeout(this.leaveTimeout);
            }
        },
        {
            key: 'handleEmojiLeave',
            value: function handleEmojiLeave(emoji) {
                var preview = this.preview;
                if (!preview) {
                    return;
                }
                this.leaveTimeout = setTimeout(function () {
                    preview.setState({ emoji: null });
                }, 16);
            }
        },
        {
            key: 'handleEmojiClick',
            value: function handleEmojiClick(emoji, e) {
                this.props.onClick(emoji, e);
                this.handleEmojiSelect(emoji);
            }
        },
        {
            key: 'handleEmojiSelect',
            value: function handleEmojiSelect(emoji) {
                var _this3 = this;
                this.props.onSelect(emoji);
                if (!this.hideRecent && !this.props.recent)
                    _frequently['default'].add(emoji);
                var component = this.categoryRefs['category-1'];
                if (component) {
                    var maxMargin = component.maxMargin;
                    if (this.props.enableFrequentEmojiSort) {
                        component.forceUpdate();
                    }
                    requestAnimationFrame(function () {
                        if (!_this3.scroll)
                            return;
                        component.memoizeSize();
                        if (maxMargin == component.maxMargin)
                            return;
                        _this3.updateCategoriesSize();
                        _this3.handleScrollPaint();
                        if (_this3.SEARCH_CATEGORY.emojis) {
                            component.updateDisplay('none');
                        }
                    });
                }
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll() {
                if (!this.waitingForPaint) {
                    this.waitingForPaint = true;
                    requestAnimationFrame(this.handleScrollPaint);
                }
            }
        },
        {
            key: 'handleScrollPaint',
            value: function handleScrollPaint() {
                this.waitingForPaint = false;
                if (!this.scroll) {
                    return;
                }
                var activeCategory = null;
                if (this.SEARCH_CATEGORY.emojis) {
                    activeCategory = this.SEARCH_CATEGORY;
                } else {
                    var target = this.scroll, scrollTop = target.scrollTop, scrollingDown = scrollTop > (this.scrollTop || 0), minTop = 0;
                    for (var i = 0, l = this.categories.length; i < l; i++) {
                        var ii = scrollingDown ? this.categories.length - 1 - i : i, category = this.categories[ii], component = this.categoryRefs['category-'.concat(ii)];
                        if (component) {
                            var active = component.handleScroll(scrollTop);
                            if (!minTop || component.top < minTop) {
                                if (component.top > 0) {
                                    minTop = component.top;
                                }
                            }
                            if (active && !activeCategory) {
                                activeCategory = category;
                            }
                        }
                    }
                    if (scrollTop < minTop) {
                        activeCategory = this.categories.filter(function (category) {
                            return !(category.anchor === false);
                        })[0];
                    } else if (scrollTop + this.clientHeight >= this.scrollHeight) {
                        activeCategory = this.categories[this.categories.length - 1];
                    }
                }
                if (activeCategory) {
                    var anchors = this.anchors, _activeCategory = activeCategory, categoryName = _activeCategory.name;
                    if (anchors.state.selected != categoryName) {
                        anchors.setState({ selected: categoryName });
                    }
                }
                this.scrollTop = scrollTop;
            }
        },
        {
            key: 'handleSearch',
            value: function handleSearch(emojis) {
                this.SEARCH_CATEGORY.emojis = emojis;
                for (var i = 0, l = this.categories.length; i < l; i++) {
                    var component = this.categoryRefs['category-'.concat(i)];
                    if (component && component.props.name != 'Search') {
                        var display = emojis ? 'none' : 'inherit';
                        component.updateDisplay(display);
                    }
                }
                this.forceUpdate();
                if (this.scroll) {
                    this.scroll.scrollTop = 0;
                }
                this.handleScroll();
            }
        },
        {
            key: 'handleAnchorClick',
            value: function handleAnchorClick(category, i) {
                var component = this.categoryRefs['category-'.concat(i)], scroll = this.scroll, anchors = this.anchors, scrollToComponent = null;
                scrollToComponent = function scrollToComponent() {
                    if (component) {
                        var top = component.top;
                        if (category.first) {
                            top = 0;
                        } else {
                            top += 1;
                        }
                        scroll.scrollTop = top;
                    }
                };
                if (this.SEARCH_CATEGORY.emojis) {
                    this.handleSearch(null);
                    this.search.clear();
                    requestAnimationFrame(scrollToComponent);
                } else {
                    scrollToComponent();
                }
            }
        },
        {
            key: 'handleSkinChange',
            value: function handleSkinChange(skin) {
                var newState = { skin: skin }, onSkinChange = this.props.onSkinChange;
                this.setState(newState);
                _store['default'].update(newState);
                onSkinChange(skin);
            }
        },
        {
            key: 'handleKeyDown',
            value: function handleKeyDown(e) {
                var handled = false;
                switch (e.keyCode) {
                case 13:
                    var emoji;
                    if (this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (emoji = (0, _utils.getSanitizedData)(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data))) {
                        this.handleEmojiSelect(emoji);
                        handled = true;
                    }
                    break;
                }
                if (handled) {
                    e.preventDefault();
                }
            }
        },
        {
            key: 'updateCategoriesSize',
            value: function updateCategoriesSize() {
                for (var i = 0, l = this.categories.length; i < l; i++) {
                    var component = this.categoryRefs['category-'.concat(i)];
                    if (component)
                        component.memoizeSize();
                }
                if (this.scroll) {
                    var target = this.scroll;
                    this.scrollHeight = target.scrollHeight;
                    this.clientHeight = target.clientHeight;
                }
            }
        },
        {
            key: 'getCategories',
            value: function getCategories() {
                return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
            }
        },
        {
            key: 'setAnchorsRef',
            value: function setAnchorsRef(c) {
                this.anchors = c;
            }
        },
        {
            key: 'setSearchRef',
            value: function setSearchRef(c) {
                this.search = c;
            }
        },
        {
            key: 'setPreviewRef',
            value: function setPreviewRef(c) {
                this.preview = c;
            }
        },
        {
            key: 'setScrollRef',
            value: function setScrollRef(c) {
                this.scroll = c;
            }
        },
        {
            key: 'setCategoryRef',
            value: function setCategoryRef(name, c) {
                if (!this.categoryRefs) {
                    this.categoryRefs = {};
                }
                this.categoryRefs[name] = c;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _this$props = this.props, perLine = _this$props.perLine, emojiSize = _this$props.emojiSize, set = _this$props.set, sheetSize = _this$props.sheetSize, sheetColumns = _this$props.sheetColumns, sheetRows = _this$props.sheetRows, style = _this$props.style, title = _this$props.title, emoji = _this$props.emoji, color = _this$props.color, _native = _this$props['native'], backgroundImageFn = _this$props.backgroundImageFn, emojisToShowFilter = _this$props.emojisToShowFilter, showPreview = _this$props.showPreview, showSkinTones = _this$props.showSkinTones, emojiTooltip = _this$props.emojiTooltip, useButton = _this$props.useButton, include = _this$props.include, exclude = _this$props.exclude, recent = _this$props.recent, autoFocus = _this$props.autoFocus, skinEmoji = _this$props.skinEmoji, notFound = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji;
                var width = perLine * (emojiSize + 12) + 12 + 2 + (0, _utils.measureScrollbar)();
                var theme = this.getPreferredTheme();
                var skin = this.props.skin || this.state.skin || _store['default'].get('skin') || this.props.defaultSkin;
                return _react['default'].createElement('section', {
                    style: _objectSpread({ width: width }, style),
                    className: 'emoji-mart emoji-mart-'.concat(theme),
                    'aria-label': title,
                    onKeyDown: this.handleKeyDown
                }, _react['default'].createElement('div', { className: 'emoji-mart-bar' }, _react['default'].createElement(_anchors['default'], {
                    ref: this.setAnchorsRef,
                    data: this.data,
                    i18n: this.i18n,
                    color: color,
                    categories: this.categories,
                    onAnchorClick: this.handleAnchorClick,
                    icons: this.icons
                })), _react['default'].createElement(_search['default'], {
                    ref: this.setSearchRef,
                    onSearch: this.handleSearch,
                    data: this.data,
                    i18n: this.i18n,
                    emojisToShowFilter: emojisToShowFilter,
                    include: include,
                    exclude: exclude,
                    custom: this.CUSTOM,
                    autoFocus: autoFocus
                }), _react['default'].createElement('div', {
                    ref: this.setScrollRef,
                    className: 'emoji-mart-scroll',
                    onScroll: this.handleScroll
                }, this.getCategories().map(function (category, i) {
                    return _react['default'].createElement(_category['default'], {
                        ref: _this4.setCategoryRef.bind(_this4, 'category-'.concat(i)),
                        key: category.name,
                        id: category.id,
                        name: category.name,
                        emojis: category.emojis,
                        perLine: perLine,
                        'native': _native,
                        hasStickyPosition: _this4.hasStickyPosition,
                        data: _this4.data,
                        i18n: _this4.i18n,
                        recent: category.id == _this4.RECENT_CATEGORY.id ? recent : undefined,
                        custom: category.id == _this4.RECENT_CATEGORY.id ? _this4.CUSTOM : undefined,
                        emojiProps: {
                            'native': _native,
                            skin: skin,
                            size: emojiSize,
                            set: set,
                            sheetSize: sheetSize,
                            sheetColumns: sheetColumns,
                            sheetRows: sheetRows,
                            forceSize: _native,
                            tooltip: emojiTooltip,
                            backgroundImageFn: backgroundImageFn,
                            useButton: useButton,
                            onOver: _this4.handleEmojiOver,
                            onLeave: _this4.handleEmojiLeave,
                            onClick: _this4.handleEmojiClick
                        },
                        notFound: notFound,
                        notFoundEmoji: notFoundEmoji
                    });
                })), (showPreview || showSkinTones) && _react['default'].createElement('div', { className: 'emoji-mart-bar' }, _react['default'].createElement(_preview['default'], {
                    ref: this.setPreviewRef,
                    data: this.data,
                    title: title,
                    emoji: emoji,
                    showSkinTones: showSkinTones,
                    showPreview: showPreview,
                    emojiProps: {
                        'native': _native,
                        size: 38,
                        skin: skin,
                        set: set,
                        sheetSize: sheetSize,
                        sheetColumns: sheetColumns,
                        sheetRows: sheetRows,
                        backgroundImageFn: backgroundImageFn
                    },
                    skinsProps: {
                        skin: skin,
                        onChange: this.handleSkinChange,
                        skinEmoji: skinEmoji
                    },
                    i18n: this.i18n
                })));
            }
        }
    ]);
    return NimblePicker;
}(_react['default'].PureComponent);
exports['default'] = NimblePicker;
NimblePicker.propTypes = _objectSpread({}, _sharedProps.PickerPropTypes, { data: _propTypes['default'].object.isRequired });
NimblePicker.defaultProps = _objectSpread({}, _sharedDefaultProps.PickerDefaultProps);
},{"../../svgs":603,"../../utils":608,"../../utils/data":604,"../../utils/frequently":607,"../../utils/shared-default-props":609,"../../utils/shared-props":610,"../../utils/store":611,"../anchors":589,"../category":590,"../preview":596,"../search":597,"@babel/runtime/helpers/assertThisInitialized":311,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/interopRequireWildcard":320,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],595:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _all = _interopRequireDefault(require("../../../data/all.json"));

var _nimblePicker = _interopRequireDefault(require("./nimble-picker"));

var _sharedProps = require("../../utils/shared-props");

var _sharedDefaultProps = require("../../utils/shared-default-props");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Picker =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Picker, _React$PureComponent);

  function Picker() {
    (0, _classCallCheck2["default"])(this, Picker);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Picker).apply(this, arguments));
  }

  (0, _createClass2["default"])(Picker, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_nimblePicker["default"], (0, _extends2["default"])({}, this.props, this.state));
    }
  }]);
  return Picker;
}(_react["default"].PureComponent);

exports["default"] = Picker;
Picker.propTypes
/* remove-proptypes */
= _sharedProps.PickerPropTypes;
Picker.defaultProps = _objectSpread({}, _sharedDefaultProps.PickerDefaultProps, {
  data: _all["default"]
});
},{"../../../data/all.json":588,"../../utils/shared-default-props":609,"../../utils/shared-props":610,"./nimble-picker":594,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"react":1107}],596:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var _nimbleEmoji = _interopRequireDefault(require("./emoji/nimble-emoji"));

var _skinsEmoji = _interopRequireDefault(require("./skins-emoji"));

var _skinsDot = _interopRequireDefault(require("./skins-dot"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Preview =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Preview, _React$PureComponent);

  function Preview(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Preview);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Preview).call(this, props));
    _this.data = props.data;
    _this.state = {
      emoji: null
    };
    return _this;
  }

  (0, _createClass2["default"])(Preview, [{
    key: "render",
    value: function render() {
      var emoji = this.state.emoji,
          _this$props = this.props,
          emojiProps = _this$props.emojiProps,
          skinsProps = _this$props.skinsProps,
          showSkinTones = _this$props.showSkinTones,
          title = _this$props.title,
          idleEmoji = _this$props.emoji,
          i18n = _this$props.i18n,
          showPreview = _this$props.showPreview;

      if (emoji && showPreview) {
        var emojiData = (0, _utils.getData)(emoji, null, null, this.data),
            _emojiData$emoticons = emojiData.emoticons,
            emoticons = _emojiData$emoticons === void 0 ? [] : _emojiData$emoticons,
            knownEmoticons = [],
            listedEmoticons = [];
        emoticons.forEach(function (emoticon) {
          if (knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0) {
            return;
          }

          knownEmoticons.push(emoticon.toLowerCase());
          listedEmoticons.push(emoticon);
        });
        return _react["default"].createElement("div", {
          className: "emoji-mart-preview"
        }, _react["default"].createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, (0, _nimbleEmoji["default"])(_objectSpread({
          key: emoji.id,
          emoji: emoji,
          data: this.data
        }, emojiProps))), _react["default"].createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, _react["default"].createElement("div", {
          className: "emoji-mart-preview-name"
        }, emoji.name), _react["default"].createElement("div", {
          className: "emoji-mart-preview-shortnames"
        }, emojiData.short_names.map(function (short_name) {
          return _react["default"].createElement("span", {
            key: short_name,
            className: "emoji-mart-preview-shortname"
          }, ":", short_name, ":");
        })), _react["default"].createElement("div", {
          className: "emoji-mart-preview-emoticons"
        }, listedEmoticons.map(function (emoticon) {
          return _react["default"].createElement("span", {
            key: emoticon,
            className: "emoji-mart-preview-emoticon"
          }, emoticon);
        }))));
      } else {
        return _react["default"].createElement("div", {
          className: "emoji-mart-preview"
        }, _react["default"].createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, idleEmoji && idleEmoji.length && (0, _nimbleEmoji["default"])(_objectSpread({
          emoji: idleEmoji,
          data: this.data
        }, emojiProps))), _react["default"].createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, _react["default"].createElement("span", {
          className: "emoji-mart-title-label"
        }, title)), showSkinTones && _react["default"].createElement("div", {
          className: "emoji-mart-preview-skins".concat(skinsProps.skinEmoji ? ' custom' : '')
        }, skinsProps.skinEmoji ? _react["default"].createElement(_skinsEmoji["default"], {
          skin: skinsProps.skin,
          emojiProps: emojiProps,
          data: this.data,
          skinEmoji: skinsProps.skinEmoji,
          i18n: i18n,
          onChange: skinsProps.onChange
        }) : _react["default"].createElement(_skinsDot["default"], {
          skin: skinsProps.skin,
          i18n: i18n,
          onChange: skinsProps.onChange
        })));
      }
    }
  }]);
  return Preview;
}(_react["default"].PureComponent);

exports["default"] = Preview;
Preview.propTypes
/* remove-proptypes */
= {
  showSkinTones: _propTypes["default"].bool,
  title: _propTypes["default"].string.isRequired,
  emoji: _propTypes["default"].string.isRequired,
  emojiProps: _propTypes["default"].object.isRequired,
  skinsProps: _propTypes["default"].object.isRequired
};
Preview.defaultProps = {
  showSkinTones: true,
  onChange: function onChange() {}
};
},{"../utils":608,"./emoji/nimble-emoji":592,"./skins-dot":598,"./skins-emoji":599,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/defineProperty":314,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],597:[function(require,module,exports){
'use strict';
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _assertThisInitialized2 = _interopRequireDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));
var _react = _interopRequireDefault(require('react'));
var _propTypes = _interopRequireDefault(require('prop-types'));
var _svgs = require('../svgs');
var _nimbleEmojiIndex = _interopRequireDefault(require('../utils/emoji-index/nimble-emoji-index'));
var _index = require('../utils/index');
var id = 0;
var Search = function (_React$PureComponent) {
    (0, _inherits2['default'])(Search, _React$PureComponent);
    function Search(props) {
        var _this;
        (0, _classCallCheck2['default'])(this, Search);
        _this = (0, _possibleConstructorReturn2['default'])(this, (0, _getPrototypeOf2['default'])(Search).call(this, props));
        _this.state = {
            icon: _svgs.search.search,
            isSearching: false,
            id: ++id
        };
        _this.data = props.data;
        _this.emojiIndex = new _nimbleEmojiIndex['default'](_this.data);
        _this.setRef = _this.setRef.bind((0, _assertThisInitialized2['default'])(_this));
        _this.clear = _this.clear.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleChange = (0, _index.throttleIdleTask)(_this.handleChange.bind((0, _assertThisInitialized2['default'])(_this)));
        return _this;
    }
    (0, _createClass2['default'])(Search, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.input && this.input.value) {
                    this.search(this.input.value);
                }
            }
        },
        {
            key: 'search',
            value: function search(value) {
                if (value == '')
                    this.setState({
                        icon: _svgs.search.search,
                        isSearching: false
                    });
                else
                    this.setState({
                        icon: _svgs.search['delete'],
                        isSearching: true
                    });
                this.props.onSearch(this.emojiIndex.search(value, {
                    emojisToShowFilter: this.props.emojisToShowFilter,
                    maxResults: this.props.maxResults,
                    include: this.props.include,
                    exclude: this.props.exclude,
                    custom: this.props.custom
                }));
            }
        },
        {
            key: 'clear',
            value: function clear() {
                if (this.input.value == '')
                    return;
                this.input.value = '';
                this.input.focus();
                this.search('');
            }
        },
        {
            key: 'handleChange',
            value: function handleChange() {
                this.search(this.input.value);
            }
        },
        {
            key: 'handleKeyUp',
            value: function handleKeyUp(e) {
                if (e.keyCode === 13) {
                    this.clear();
                }
            }
        },
        {
            key: 'setRef',
            value: function setRef(c) {
                this.input = c;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this$props = this.props, i18n = _this$props.i18n, autoFocus = _this$props.autoFocus;
                var _this$state = this.state, icon = _this$state.icon, isSearching = _this$state.isSearching, id = _this$state.id;
                var inputId = 'emoji-mart-search-'.concat(id);
                return _react['default'].createElement('section', {
                    className: 'emoji-mart-search',
                    'aria-label': i18n.search
                }, _react['default'].createElement('input', {
                    id: inputId,
                    ref: this.setRef,
                    type: 'search',
                    onChange: this.handleChange,
                    placeholder: i18n.search,
                    autoFocus: autoFocus
                }), _react['default'].createElement('label', {
                    className: 'emoji-mart-sr-only',
                    htmlFor: inputId
                }, i18n.search), _react['default'].createElement('button', {
                    className: 'emoji-mart-search-icon',
                    onClick: this.clear,
                    onKeyUp: this.handleKeyUp,
                    'aria-label': i18n.clear,
                    disabled: !isSearching
                }, icon()));
            }
        }
    ]);
    return Search;
}(_react['default'].PureComponent);
exports['default'] = Search;
Search.propTypes = {
    onSearch: _propTypes['default'].func,
    maxResults: _propTypes['default'].number,
    emojisToShowFilter: _propTypes['default'].func,
    autoFocus: _propTypes['default'].bool
};
Search.defaultProps = {
    onSearch: function onSearch() {
    },
    maxResults: 75,
    emojisToShowFilter: null,
    autoFocus: false
};
},{"../svgs":603,"../utils/emoji-index/nimble-emoji-index":606,"../utils/index":608,"@babel/runtime/helpers/assertThisInitialized":311,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],598:[function(require,module,exports){
'use strict';
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _extends2 = _interopRequireDefault(require('@babel/runtime/helpers/extends'));
var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _assertThisInitialized2 = _interopRequireDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));
var _react = _interopRequireDefault(require('react'));
var _propTypes = _interopRequireDefault(require('prop-types'));
var _skins = _interopRequireDefault(require('./skins'));
var SkinsDot = function (_Skins) {
    (0, _inherits2['default'])(SkinsDot, _Skins);
    function SkinsDot(props) {
        var _this;
        (0, _classCallCheck2['default'])(this, SkinsDot);
        _this = (0, _possibleConstructorReturn2['default'])(this, (0, _getPrototypeOf2['default'])(SkinsDot).call(this, props));
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2['default'])(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2['default'])(_this));
        return _this;
    }
    (0, _createClass2['default'])(SkinsDot, [
        {
            key: 'handleKeyDown',
            value: function handleKeyDown(event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    this.handleClick(event);
                }
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this$props = this.props, skin = _this$props.skin, i18n = _this$props.i18n;
                var opened = this.state.opened;
                var skinToneNodes = [];
                for (var skinTone = 1; skinTone <= 6; skinTone++) {
                    var selected = skinTone === skin;
                    var visible = opened || selected;
                    skinToneNodes.push(_react['default'].createElement('span', (0, _extends2['default'])({
                        key: 'skin-tone-'.concat(skinTone),
                        className: 'emoji-mart-skin-swatch'.concat(selected ? ' selected' : ''),
                        'aria-label': i18n.skintones[skinTone],
                        'aria-hidden': !visible
                    }, opened ? { role: 'menuitem' } : {}), _react['default'].createElement('span', (0, _extends2['default'])({
                        onClick: this.handleClick,
                        onKeyDown: this.handleKeyDown,
                        role: 'button'
                    }, selected ? {
                        'aria-haspopup': true,
                        'aria-expanded': !!opened
                    } : {}, opened ? { 'aria-pressed': !!selected } : {}, {
                        tabIndex: visible ? '0' : '',
                        'aria-label': i18n.skintones[skinTone],
                        title: i18n.skintones[skinTone],
                        'data-skin': skinTone,
                        className: 'emoji-mart-skin emoji-mart-skin-tone-'.concat(skinTone)
                    }))));
                }
                return _react['default'].createElement('section', {
                    className: 'emoji-mart-skin-swatches'.concat(opened ? ' opened' : ''),
                    'aria-label': i18n.skintext
                }, _react['default'].createElement('div', opened ? { role: 'menubar' } : {}, skinToneNodes));
            }
        }
    ]);
    return SkinsDot;
}(_skins['default']);
exports['default'] = SkinsDot;
SkinsDot.propTypes = {
    onChange: _propTypes['default'].func,
    skin: _propTypes['default'].number.isRequired,
    i18n: _propTypes['default'].object
};
SkinsDot.defaultProps = {
    onChange: function onChange() {
    }
};
},{"./skins":600,"@babel/runtime/helpers/assertThisInitialized":311,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],599:[function(require,module,exports){
'use strict';
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _assertThisInitialized2 = _interopRequireDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));
var _react = _interopRequireDefault(require('react'));
var _propTypes = _interopRequireDefault(require('prop-types'));
var _nimbleEmoji = _interopRequireDefault(require('./emoji/nimble-emoji'));
var _skins = _interopRequireDefault(require('./skins'));
var SkinsEmoji = function (_Skins) {
    (0, _inherits2['default'])(SkinsEmoji, _Skins);
    function SkinsEmoji(props) {
        var _this;
        (0, _classCallCheck2['default'])(this, SkinsEmoji);
        _this = (0, _possibleConstructorReturn2['default'])(this, (0, _getPrototypeOf2['default'])(SkinsEmoji).call(this, props));
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2['default'])(_this));
        return _this;
    }
    (0, _createClass2['default'])(SkinsEmoji, [{
            key: 'render',
            value: function render() {
                var _this$props = this.props, skin = _this$props.skin, emojiProps = _this$props.emojiProps, data = _this$props.data, skinEmoji = _this$props.skinEmoji, i18n = _this$props.i18n;
                var opened = this.state.opened;
                var skinToneNodes = [];
                for (var skinTone = 1; skinTone <= 6; skinTone++) {
                    var selected = skinTone === skin;
                    skinToneNodes.push(_react['default'].createElement('span', {
                        key: 'skin-tone-'.concat(skinTone),
                        className: 'emoji-mart-skin-swatch custom'.concat(selected ? ' selected' : '')
                    }, _react['default'].createElement('span', {
                        onClick: this.handleClick,
                        'data-skin': skinTone,
                        className: 'emoji-mart-skin-tone-'.concat(skinTone)
                    }, (0, _nimbleEmoji['default'])({
                        emoji: skinEmoji,
                        data: data,
                        skin: skinTone,
                        backgroundImageFn: emojiProps.backgroundImageFn,
                        'native': emojiProps['native'],
                        set: emojiProps.set,
                        sheetSize: emojiProps.sheetSize,
                        size: 23
                    }))));
                }
                return _react['default'].createElement('div', { className: 'emoji-mart-skin-swatches custom'.concat(opened ? ' opened' : '') }, _react['default'].createElement('div', { className: 'emoji-mart-skin-text'.concat(opened ? ' opened' : '') }, i18n.skintext), skinToneNodes);
            }
        }]);
    return SkinsEmoji;
}(_skins['default']);
exports['default'] = SkinsEmoji;
SkinsEmoji.propTypes = {
    onChange: _propTypes['default'].func,
    skin: _propTypes['default'].number.isRequired,
    emojiProps: _propTypes['default'].object.isRequired,
    skinTone: _propTypes['default'].number,
    skinEmoji: _propTypes['default'].string.isRequired,
    i18n: _propTypes['default'].object
};
SkinsEmoji.defaultProps = {
    onChange: function onChange() {
    },
    skinTone: null
};
},{"./emoji/nimble-emoji":592,"./skins":600,"@babel/runtime/helpers/assertThisInitialized":311,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],600:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Skins =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Skins, _React$PureComponent);

  function Skins(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Skins);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Skins).call(this, props));
    _this.state = {
      opened: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Skins, [{
    key: "handleClick",
    value: function handleClick(e) {
      var skin = parseInt(e.currentTarget.getAttribute('data-skin'));
      var onChange = this.props.onChange;

      if (!this.state.opened) {
        this.setState({
          opened: true
        });
      } else {
        this.setState({
          opened: false
        });

        if (skin != this.props.skin) {
          onChange(skin);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Skins;
}(_react["default"].PureComponent);

exports["default"] = Skins;
Skins.propTypes
/* remove-proptypes */
= {
  onChange: _propTypes["default"].func,
  skin: _propTypes["default"].number.isRequired
};
Skins.defaultProps = {
  onChange: function onChange() {}
};
},{"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/getPrototypeOf":316,"@babel/runtime/helpers/inherits":317,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/possibleConstructorReturn":323,"prop-types":896,"react":1107}],601:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "emojiIndex", {
  enumerable: true,
  get: function get() {
    return _emojiIndex["default"];
  }
});
Object.defineProperty(exports, "NimbleEmojiIndex", {
  enumerable: true,
  get: function get() {
    return _nimbleEmojiIndex["default"];
  }
});
Object.defineProperty(exports, "store", {
  enumerable: true,
  get: function get() {
    return _store["default"];
  }
});
Object.defineProperty(exports, "frequently", {
  enumerable: true,
  get: function get() {
    return _frequently["default"];
  }
});
Object.defineProperty(exports, "getEmojiDataFromNative", {
  enumerable: true,
  get: function get() {
    return _utils.getEmojiDataFromNative;
  }
});
Object.defineProperty(exports, "Picker", {
  enumerable: true,
  get: function get() {
    return _picker["default"];
  }
});
Object.defineProperty(exports, "NimblePicker", {
  enumerable: true,
  get: function get() {
    return _nimblePicker["default"];
  }
});
Object.defineProperty(exports, "Emoji", {
  enumerable: true,
  get: function get() {
    return _emoji["default"];
  }
});
Object.defineProperty(exports, "NimbleEmoji", {
  enumerable: true,
  get: function get() {
    return _nimbleEmoji["default"];
  }
});
Object.defineProperty(exports, "Category", {
  enumerable: true,
  get: function get() {
    return _category["default"];
  }
});

var _emojiIndex = _interopRequireDefault(require("./utils/emoji-index/emoji-index"));

var _nimbleEmojiIndex = _interopRequireDefault(require("./utils/emoji-index/nimble-emoji-index"));

var _store = _interopRequireDefault(require("./utils/store"));

var _frequently = _interopRequireDefault(require("./utils/frequently"));

var _utils = require("./utils");

var _picker = _interopRequireDefault(require("./components/picker/picker"));

var _nimblePicker = _interopRequireDefault(require("./components/picker/nimble-picker"));

var _emoji = _interopRequireDefault(require("./components/emoji/emoji"));

var _nimbleEmoji = _interopRequireDefault(require("./components/emoji/nimble-emoji"));

var _category = _interopRequireDefault(require("./components/category"));
},{"./components/category":590,"./components/emoji/emoji":591,"./components/emoji/nimble-emoji":592,"./components/picker/nimble-picker":594,"./components/picker/picker":595,"./utils":608,"./utils/emoji-index/emoji-index":605,"./utils/emoji-index/nimble-emoji-index":606,"./utils/frequently":607,"./utils/store":611,"@babel/runtime/helpers/interopRequireDefault":319}],602:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _String = String;

var _default = _String.fromCodePoint || function stringFromCodePoint() {
  var MAX_SIZE = 0x4000;
  var codeUnits = [];
  var highSurrogate;
  var lowSurrogate;
  var index = -1;
  var length = arguments.length;

  if (!length) {
    return '';
  }

  var result = '';

  while (++index < length) {
    var codePoint = Number(arguments[index]);

    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 0x10ffff || // not a valid Unicode code point
    Math.floor(codePoint) != codePoint // not an integer
    ) {
        throw RangeError('Invalid code point: ' + codePoint);
      }

    if (codePoint <= 0xffff) {
      // BMP code point
      codeUnits.push(codePoint);
    } else {
      // Astral code point; split in surrogate halves
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      codePoint -= 0x10000;
      highSurrogate = (codePoint >> 10) + 0xd800;
      lowSurrogate = codePoint % 0x400 + 0xdc00;
      codeUnits.push(highSurrogate, lowSurrogate);
    }

    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
      result += String.fromCharCode.apply(null, codeUnits);
      codeUnits.length = 0;
    }
  }

  return result;
};

exports["default"] = _default;
},{}],603:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = exports.categories = void 0;

var _react = _interopRequireDefault(require("react"));

var categories = {
  activity: function activity() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
    }));
  },
  custom: function custom() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("g", {
      transform: "translate(2.000000, 1.000000)"
    }, _react["default"].createElement("rect", {
      id: "Rectangle",
      x: "8",
      y: "0",
      width: "3",
      height: "21",
      rx: "1.5"
    }), _react["default"].createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    }), _react["default"].createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    })));
  },
  flags: function flags() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
    }));
  },
  foods: function foods() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
    }));
  },
  nature: function nature() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
    }), _react["default"].createElement("path", {
      d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
    }));
  },
  objects: function objects() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
    }), _react["default"].createElement("path", {
      d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
    }));
  },
  people: function people() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }), _react["default"].createElement("path", {
      d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
    }));
  },
  places: function places() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
    }), _react["default"].createElement("path", {
      d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
    }));
  },
  recent: function recent() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
    }), _react["default"].createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }));
  },
  symbols: function symbols() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, _react["default"].createElement("path", {
      d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
    }));
  }
};
exports.categories = categories;
var search = {
  search: function search() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, _react["default"].createElement("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    }));
  },
  "delete": function _delete() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, _react["default"].createElement("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    }));
  }
};
exports.search = search;
},{"@babel/runtime/helpers/interopRequireDefault":319,"react":1107}],604:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uncompress = exports.compress = exports.buildSearch = void 0;
var mapping = {
  name: 'a',
  unified: 'b',
  non_qualified: 'c',
  has_img_apple: 'd',
  has_img_google: 'e',
  has_img_twitter: 'f',
  has_img_facebook: 'h',
  keywords: 'j',
  sheet: 'k',
  emoticons: 'l',
  text: 'm',
  short_names: 'n',
  added_in: 'o'
};

var buildSearch = function buildSearch(emoji) {
  var search = [];

  var addToSearch = function addToSearch(strings, split) {
    if (!strings) {
      return;
    }

    ;
    (Array.isArray(strings) ? strings : [strings]).forEach(function (string) {
      ;
      (split ? string.split(/[-|_|\s]+/) : [string]).forEach(function (s) {
        s = s.toLowerCase();

        if (search.indexOf(s) == -1) {
          search.push(s);
        }
      });
    });
  };

  addToSearch(emoji.short_names, true);
  addToSearch(emoji.name, true);
  addToSearch(emoji.keywords, false);
  addToSearch(emoji.emoticons, false);
  return search.join(',');
};

exports.buildSearch = buildSearch;

var compress = function compress(emoji) {
  emoji.short_names = emoji.short_names.filter(function (short_name) {
    return short_name !== emoji.short_name;
  });
  delete emoji.short_name;
  emoji.sheet = [emoji.sheet_x, emoji.sheet_y];
  delete emoji.sheet_x;
  delete emoji.sheet_y;
  emoji.added_in = parseInt(emoji.added_in);

  if (emoji.added_in === 6) {
    delete emoji.added_in;
  }

  for (var key in mapping) {
    emoji[mapping[key]] = emoji[key];
    delete emoji[key];
  }

  for (var _key in emoji) {
    var value = emoji[_key];

    if (Array.isArray(value) && !value.length) {
      delete emoji[_key];
    } else if (typeof value === 'string' && !value.length) {
      delete emoji[_key];
    } else if (value === null) {
      delete emoji[_key];
    }
  }
};

exports.compress = compress;

var uncompress = function uncompress(data) {
  data.compressed = false;

  for (var id in data.emojis) {
    var emoji = data.emojis[id];

    for (var key in mapping) {
      emoji[key] = emoji[mapping[key]];
      delete emoji[mapping[key]];
    }

    if (!emoji.short_names) emoji.short_names = [];
    emoji.short_names.unshift(id);
    emoji.sheet_x = emoji.sheet[0];
    emoji.sheet_y = emoji.sheet[1];
    delete emoji.sheet;
    if (!emoji.text) emoji.text = '';
    if (!emoji.added_in) emoji.added_in = 6;
    emoji.added_in = emoji.added_in.toFixed(1);
    emoji.search = buildSearch(emoji);
  }
};

exports.uncompress = uncompress;
},{}],605:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _all = _interopRequireDefault(require("../../../data/all.json"));

var _nimbleEmojiIndex = _interopRequireDefault(require("./nimble-emoji-index"));

var emojiIndex = new _nimbleEmojiIndex["default"](_all["default"]);
var emojis = emojiIndex.emojis,
    emoticons = emojiIndex.emoticons;

function search() {
  return emojiIndex.search.apply(emojiIndex, arguments);
}

var _default = {
  search: search,
  emojis: emojis,
  emoticons: emoticons
};
exports["default"] = _default;
},{"../../../data/all.json":588,"./nimble-emoji-index":606,"@babel/runtime/helpers/interopRequireDefault":319}],606:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ = require("..");

var _data = require("../data");

var _store = _interopRequireDefault(require("../store"));

var NimbleEmojiIndex =
/*#__PURE__*/
function () {
  function NimbleEmojiIndex(data, set) {
    (0, _classCallCheck2["default"])(this, NimbleEmojiIndex);

    if (data.compressed) {
      (0, _data.uncompress)(data);
    }

    this.data = data || {};
    this.set = set || null;
    this.originalPool = {};
    this.index = {};
    this.emojis = {};
    this.emoticons = {};
    this.customEmojisList = [];
    this.buildIndex();
  }

  (0, _createClass2["default"])(NimbleEmojiIndex, [{
    key: "buildIndex",
    value: function buildIndex() {
      var _this = this;

      var _loop = function _loop(emoji) {
        var emojiData = _this.data.emojis[emoji],
            short_names = emojiData.short_names,
            emoticons = emojiData.emoticons,
            skin_variations = emojiData.skin_variations,
            id = short_names[0];

        if (emoticons) {
          emoticons.forEach(function (emoticon) {
            if (_this.emoticons[emoticon]) {
              return;
            }

            _this.emoticons[emoticon] = id;
          });
        } // If skin variations include them


        if (skin_variations) {
          _this.emojis[id] = {};

          for (var skinTone = 1; skinTone <= 6; skinTone++) {
            _this.emojis[id][skinTone] = (0, _.getSanitizedData)({
              id: id,
              skin: skinTone
            }, skinTone, _this.set, _this.data);
          }
        } else {
          _this.emojis[id] = (0, _.getSanitizedData)(id, null, _this.set, _this.data);
        }

        _this.originalPool[id] = emojiData;
      };

      for (var emoji in this.data.emojis) {
        _loop(emoji);
      }
    }
  }, {
    key: "clearCustomEmojis",
    value: function clearCustomEmojis(pool) {
      var _this2 = this;

      this.customEmojisList.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];
        delete pool[emojiId];
        delete _this2.emojis[emojiId];
      });
    }
  }, {
    key: "addCustomToPool",
    value: function addCustomToPool(custom, pool) {
      var _this3 = this;

      if (this.customEmojisList.length) this.clearCustomEmojis(pool);
      custom.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];

        if (emojiId && !pool[emojiId]) {
          pool[emojiId] = (0, _.getData)(emoji, null, null, _this3.data);
          _this3.emojis[emojiId] = (0, _.getSanitizedData)(emoji, null, null, _this3.data);
        }
      });
      this.customEmojisList = custom;
      this.index = {};
    }
  }, {
    key: "search",
    value: function search(value) {
      var _this4 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          emojisToShowFilter = _ref.emojisToShowFilter,
          maxResults = _ref.maxResults,
          include = _ref.include,
          exclude = _ref.exclude,
          _ref$custom = _ref.custom,
          custom = _ref$custom === void 0 ? [] : _ref$custom;

      if (this.customEmojisList != custom) this.addCustomToPool(custom, this.originalPool);
      var skinTone = _store["default"].get('skin') || 1;
      maxResults || (maxResults = 75);
      include || (include = []);
      exclude || (exclude = []);
      var results = null,
          pool = this.originalPool;

      if (value.length) {
        if (value == '-' || value == '-1') {
          return [this.emojis['-1'][skinTone]];
        }

        var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
            allResults = [];

        if (values.length > 2) {
          values = [values[0], values[1]];
        }

        if (include.length || exclude.length) {
          pool = {};
          this.data.categories.forEach(function (category) {
            var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
            var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;

            if (!isIncluded || isExcluded) {
              return;
            }

            category.emojis.forEach(function (emojiId) {
              return pool[emojiId] = _this4.data.emojis[emojiId];
            });
          });

          if (custom.length) {
            var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
            var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;

            if (customIsIncluded && !customIsExcluded) {
              this.addCustomToPool(custom, pool);
            }
          }
        }

        allResults = values.map(function (value) {
          var aPool = pool,
              aIndex = _this4.index,
              length = 0;

          for (var charIndex = 0; charIndex < value.length; charIndex++) {
            var _char = value[charIndex];
            length++;
            aIndex[_char] || (aIndex[_char] = {});
            aIndex = aIndex[_char];

            if (!aIndex.results) {
              (function () {
                var scores = {};
                aIndex.results = [];
                aIndex.pool = {};

                for (var id in aPool) {
                  var emoji = aPool[id],
                      search = emoji.search,
                      sub = value.substr(0, length),
                      subIndex = search.indexOf(sub);

                  if (subIndex != -1) {
                    var score = subIndex + 1;
                    if (sub == id) score = 0;

                    if (_this4.emojis[id] && _this4.emojis[id][skinTone]) {
                      aIndex.results.push(_this4.emojis[id][skinTone]);
                    } else {
                      aIndex.results.push(_this4.emojis[id]);
                    }

                    aIndex.pool[id] = emoji;
                    scores[id] = score;
                  }
                }

                aIndex.results.sort(function (a, b) {
                  var aScore = scores[a.id],
                      bScore = scores[b.id];

                  if (aScore == bScore) {
                    return a.id.localeCompare(b.id);
                  } else {
                    return aScore - bScore;
                  }
                });
              })();
            }

            aPool = aIndex.pool;
          }

          return aIndex.results;
        }).filter(function (a) {
          return a;
        });

        if (allResults.length > 1) {
          results = _.intersect.apply(null, allResults);
        } else if (allResults.length) {
          results = allResults[0];
        } else {
          results = [];
        }
      }

      if (results) {
        if (emojisToShowFilter) {
          results = results.filter(function (result) {
            return emojisToShowFilter(pool[result.id]);
          });
        }

        if (results && results.length > maxResults) {
          results = results.slice(0, maxResults);
        }
      }

      return results;
    }
  }]);
  return NimbleEmojiIndex;
}();

exports["default"] = NimbleEmojiIndex;
},{"..":608,"../data":604,"../store":611,"@babel/runtime/helpers/classCallCheck":312,"@babel/runtime/helpers/createClass":313,"@babel/runtime/helpers/interopRequireDefault":319}],607:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _store = _interopRequireDefault(require("./store"));

var DEFAULTS = ['+1', 'grinning', 'kissing_heart', 'heart_eyes', 'laughing', 'stuck_out_tongue_winking_eye', 'sweat_smile', 'joy', 'scream', 'disappointed', 'unamused', 'weary', 'sob', 'sunglasses', 'heart', 'poop'];
var frequently, initialized;
var defaults = {};

function init() {
  initialized = true;
  frequently = _store["default"].get('frequently');
}

function add(emoji) {
  if (!initialized) init();
  var id = emoji.id;
  frequently || (frequently = defaults);
  frequently[id] || (frequently[id] = 0);
  frequently[id] += 1;

  _store["default"].set('last', id);

  _store["default"].set('frequently', frequently);
}

function get(perLine) {
  if (!initialized) init();

  if (!frequently) {
    defaults = {};
    var result = [];

    for (var i = 0; i < perLine; i++) {
      defaults[DEFAULTS[i]] = perLine - i;
      result.push(DEFAULTS[i]);
    }

    return result;
  }

  var quantity = perLine * 4;
  var frequentlyKeys = [];

  for (var key in frequently) {
    if (frequently.hasOwnProperty(key)) {
      frequentlyKeys.push(key);
    }
  }

  var sorted = frequentlyKeys.sort(function (a, b) {
    return frequently[a] - frequently[b];
  }).reverse();
  var sliced = sorted.slice(0, quantity);

  var last = _store["default"].get('last');

  if (last && sliced.indexOf(last) == -1) {
    sliced.pop();
    sliced.push(last);
  }

  return sliced;
}

var _default = {
  add: add,
  get: get
};
exports["default"] = _default;
},{"./store":611,"@babel/runtime/helpers/interopRequireDefault":319}],608:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getData = getData;
exports.getEmojiDataFromNative = getEmojiDataFromNative;
exports.getSanitizedData = getSanitizedData;
exports.uniq = uniq;
exports.intersect = intersect;
exports.deepMerge = deepMerge;
exports.unifiedToNative = unifiedToNative;
exports.measureScrollbar = measureScrollbar;
exports.throttleIdleTask = throttleIdleTask;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _data = require("./data");

var _stringFromCodePoint = _interopRequireDefault(require("../polyfills/stringFromCodePoint"));

var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];

function unifiedToNative(unified) {
  var unicodes = unified.split('-'),
      codePoints = unicodes.map(function (u) {
    return "0x".concat(u);
  });
  return _stringFromCodePoint["default"].apply(null, codePoints);
}

function sanitize(emoji) {
  var name = emoji.name,
      short_names = emoji.short_names,
      skin_tone = emoji.skin_tone,
      skin_variations = emoji.skin_variations,
      emoticons = emoji.emoticons,
      unified = emoji.unified,
      custom = emoji.custom,
      customCategory = emoji.customCategory,
      imageUrl = emoji.imageUrl,
      id = emoji.id || short_names[0],
      colons = ":".concat(id, ":");

  if (custom) {
    return {
      id: id,
      name: name,
      short_names: short_names,
      colons: colons,
      emoticons: emoticons,
      custom: custom,
      customCategory: customCategory,
      imageUrl: imageUrl
    };
  }

  if (skin_tone) {
    colons += ":skin-tone-".concat(skin_tone, ":");
  }

  return {
    id: id,
    name: name,
    short_names: short_names,
    colons: colons,
    emoticons: emoticons,
    unified: unified.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    "native": unifiedToNative(unified)
  };
}

function getSanitizedData() {
  return sanitize(getData.apply(void 0, arguments));
}

function getData(emoji, skin, set, data) {
  var emojiData = {};

  if (typeof emoji == 'string') {
    var matches = emoji.match(COLONS_REGEX);

    if (matches) {
      emoji = matches[1];

      if (matches[2]) {
        skin = parseInt(matches[2], 10);
      }
    }

    if (data.aliases.hasOwnProperty(emoji)) {
      emoji = data.aliases[emoji];
    }

    if (data.emojis.hasOwnProperty(emoji)) {
      emojiData = data.emojis[emoji];
    } else {
      return null;
    }
  } else if (emoji.id) {
    if (data.aliases.hasOwnProperty(emoji.id)) {
      emoji.id = data.aliases[emoji.id];
    }

    if (data.emojis.hasOwnProperty(emoji.id)) {
      emojiData = data.emojis[emoji.id];
      skin || (skin = emoji.skin);
    }
  }

  if (!Object.keys(emojiData).length) {
    emojiData = emoji;
    emojiData.custom = true;

    if (!emojiData.search) {
      emojiData.search = (0, _data.buildSearch)(emoji);
    }
  }

  emojiData.emoticons || (emojiData.emoticons = []);
  emojiData.variations || (emojiData.variations = []);

  if (emojiData.skin_variations && skin > 1) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    var skinKey = SKINS[skin - 1],
        variationData = emojiData.skin_variations[skinKey];

    if (variationData) {
      if (!variationData.variations && emojiData.variations) {
        delete emojiData.variations;
      }

      if (set && (variationData["has_img_".concat(set)] == undefined || variationData["has_img_".concat(set)]) || !set) {
        emojiData.skin_tone = skin;

        for (var k in variationData) {
          var v = variationData[k];
          emojiData[k] = v;
        }
      }
    }
  }

  if (emojiData.variations && emojiData.variations.length) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    emojiData.unified = emojiData.variations.shift();
  }

  return emojiData;
}

function getEmojiDataFromNative(nativeString, set, data) {
  if (data.compressed) {
    (0, _data.uncompress)(data);
  }

  var skinTones = ['🏻', '🏼', '🏽', '🏾', '🏿'];
  var skinCodes = ['1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];
  var skin;
  var skinCode;
  var baseNativeString = nativeString;
  skinTones.forEach(function (skinTone, skinToneIndex) {
    if (nativeString.indexOf(skinTone) > 0) {
      skin = skinToneIndex + 2;
      skinCode = skinCodes[skinToneIndex];
    }
  });
  var emojiData;

  for (var id in data.emojis) {
    var emoji = data.emojis[id];
    var emojiUnified = emoji.unified;

    if (emoji.variations && emoji.variations.length) {
      emojiUnified = emoji.variations.shift();
    }

    if (skin && emoji.skin_variations && emoji.skin_variations[skinCode]) {
      emojiUnified = emoji.skin_variations[skinCode].unified;
    }

    if (unifiedToNative(emojiUnified) === baseNativeString) emojiData = emoji;
  }

  if (!emojiData) {
    return null;
  }

  emojiData.id = emojiData.short_names[0];
  return getSanitizedData(emojiData, skin, set, data);
}

function uniq(arr) {
  return arr.reduce(function (acc, item) {
    if (acc.indexOf(item) === -1) {
      acc.push(item);
    }

    return acc;
  }, []);
}

function intersect(a, b) {
  var uniqA = uniq(a);
  var uniqB = uniq(b);
  return uniqA.filter(function (item) {
    return uniqB.indexOf(item) >= 0;
  });
}

function deepMerge(a, b) {
  var o = {};

  for (var key in a) {
    var originalValue = a[key],
        value = originalValue;

    if (b.hasOwnProperty(key)) {
      value = b[key];
    }

    if ((0, _typeof2["default"])(value) === 'object') {
      value = deepMerge(originalValue, value);
    }

    o[key] = value;
  }

  return o;
} // https://github.com/sonicdoe/measure-scrollbar


function measureScrollbar() {
  if (typeof document == 'undefined') return 0;
  var div = document.createElement('div');
  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';
  document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  return scrollbarWidth;
} // Use requestIdleCallback() if available, else fall back to setTimeout().
// Throttle so as not to run too frequently.


function throttleIdleTask(func) {
  var doIdleTask = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
  var running = false;
  return function throttled() {
    if (running) {
      return;
    }

    running = true;
    doIdleTask(function () {
      running = false;
      func();
    });
  };
}
},{"../polyfills/stringFromCodePoint":602,"./data":604,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/typeof":325}],609:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiDefaultProps = exports.PickerDefaultProps = void 0;
var EmojiDefaultProps = {
  skin: 1,
  set: 'apple',
  sheetSize: 64,
  sheetColumns: 57,
  sheetRows: 57,
  "native": false,
  forceSize: false,
  tooltip: false,
  useButton: true,
  backgroundImageFn: function backgroundImageFn(set, sheetSize) {
    return "https://unpkg.com/emoji-datasource-".concat(set, "@").concat("5.0.1", "/img/").concat(set, "/sheets-256/").concat(sheetSize, ".png");
  }
};
exports.EmojiDefaultProps = EmojiDefaultProps;
var PickerDefaultProps = {
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onSkinChange: function onSkinChange() {},
  emojiSize: 24,
  perLine: 9,
  i18n: {},
  style: {},
  title: 'Emoji Mart™',
  emoji: 'department_store',
  color: '#ae65c5',
  set: EmojiDefaultProps.set,
  theme: 'light',
  skin: null,
  defaultSkin: EmojiDefaultProps.skin,
  "native": EmojiDefaultProps["native"],
  sheetSize: EmojiDefaultProps.sheetSize,
  backgroundImageFn: EmojiDefaultProps.backgroundImageFn,
  emojisToShowFilter: null,
  showPreview: true,
  showSkinTones: true,
  emojiTooltip: EmojiDefaultProps.tooltip,
  useButton: EmojiDefaultProps.useButton,
  autoFocus: false,
  enableFrequentEmojiSort: false,
  custom: [],
  skinEmoji: '',
  notFound: function notFound() {},
  notFoundEmoji: 'sleuth_or_spy',
  icons: {}
};
exports.PickerDefaultProps = PickerDefaultProps;
},{}],610:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickerPropTypes = exports.EmojiPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var EmojiPropTypes = {
  data: _propTypes["default"].object.isRequired,
  onOver: _propTypes["default"].func,
  onLeave: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  fallback: _propTypes["default"].func,
  backgroundImageFn: _propTypes["default"].func,
  "native": _propTypes["default"].bool,
  forceSize: _propTypes["default"].bool,
  tooltip: _propTypes["default"].bool,
  useButton: _propTypes["default"].bool,
  skin: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),
  sheetSize: _propTypes["default"].oneOf([16, 20, 32, 64]),
  sheetColumns: _propTypes["default"].number,
  sheetRows: _propTypes["default"].number,
  set: _propTypes["default"].oneOf(['apple', 'google', 'twitter', 'facebook']),
  size: _propTypes["default"].number.isRequired,
  emoji: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired
};
exports.EmojiPropTypes = EmojiPropTypes;
var PickerPropTypes = {
  onClick: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onSkinChange: _propTypes["default"].func,
  perLine: _propTypes["default"].number,
  emojiSize: _propTypes["default"].number,
  i18n: _propTypes["default"].object,
  style: _propTypes["default"].object,
  title: _propTypes["default"].string,
  emoji: _propTypes["default"].string,
  color: _propTypes["default"].string,
  set: EmojiPropTypes.set,
  skin: EmojiPropTypes.skin,
  "native": _propTypes["default"].bool,
  backgroundImageFn: EmojiPropTypes.backgroundImageFn,
  sheetSize: EmojiPropTypes.sheetSize,
  emojisToShowFilter: _propTypes["default"].func,
  showPreview: _propTypes["default"].bool,
  showSkinTones: _propTypes["default"].bool,
  emojiTooltip: EmojiPropTypes.tooltip,
  useButton: EmojiPropTypes.useButton,
  theme: _propTypes["default"].oneOf(['auto', 'light', 'dark']),
  include: _propTypes["default"].arrayOf(_propTypes["default"].string),
  exclude: _propTypes["default"].arrayOf(_propTypes["default"].string),
  recent: _propTypes["default"].arrayOf(_propTypes["default"].string),
  autoFocus: _propTypes["default"].bool,
  enableFrequentEmojiSort: _propTypes["default"].bool,
  custom: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    short_names: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    emoticons: _propTypes["default"].arrayOf(_propTypes["default"].string),
    keywords: _propTypes["default"].arrayOf(_propTypes["default"].string),
    imageUrl: _propTypes["default"].string,
    spriteUrl: _propTypes["default"].string,
    sheet_x: _propTypes["default"].number,
    sheet_y: _propTypes["default"].number,
    size: _propTypes["default"].number,
    sheetColumns: _propTypes["default"].number,
    sheetRows: _propTypes["default"].number
  })),
  skinEmoji: _propTypes["default"].string,
  notFound: _propTypes["default"].func,
  notFoundEmoji: _propTypes["default"].string,
  icons: _propTypes["default"].object
};
exports.PickerPropTypes = PickerPropTypes;
},{"@babel/runtime/helpers/interopRequireDefault":319,"prop-types":896}],611:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var NAMESPACE = 'emoji-mart';
var isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;
var getter;
var setter;

function setHandlers(handlers) {
  handlers || (handlers = {});
  getter = handlers.getter;
  setter = handlers.setter;
}

function setNamespace(namespace) {
  NAMESPACE = namespace;
}

function update(state) {
  for (var key in state) {
    var value = state[key];
    set(key, value);
  }
}

function set(key, value) {
  if (setter) {
    setter(key, value);
  } else {
    if (!isLocalStorageSupported) return;

    try {
      window.localStorage["".concat(NAMESPACE, ".").concat(key)] = JSON.stringify(value);
    } catch (e) {}
  }
}

function get(key) {
  if (getter) {
    return getter(key);
  } else {
    if (!isLocalStorageSupported) return;

    try {
      var value = window.localStorage["".concat(NAMESPACE, ".").concat(key)];

      if (value) {
        return JSON.parse(value);
      }
    } catch (e) {
      return;
    }
  }
}

var _default = {
  update: update,
  set: set,
  get: get,
  setNamespace: setNamespace,
  setHandlers: setHandlers
};
exports["default"] = _default;
},{}],612:[function(require,module,exports){

module.exports = require('./lib/index');

},{"./lib/index":613}],613:[function(require,module,exports){

module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');

},{"./socket":614,"engine.io-parser":626}],614:[function(require,module,exports){
(function (global){(function (){
/**
 * Module dependencies.
 */

var transports = require('./transports/index');
var Emitter = require('component-emitter');
var debug = require('debug')('engine.io-client:socket');
var index = require('indexof');
var parser = require('engine.io-parser');
var parseuri = require('parseuri');
var parsejson = require('parsejson');
var parseqs = require('parseqs');

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (global.location && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (global.location ? location.hostname : 'localhost');
  this.port = opts.port || (global.location && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // other options for Node.js client
  var freeGlobal = typeof global === 'object' && global;
  if (freeGlobal.global === freeGlobal) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = require('./transport');
Socket.transports = require('./transports/index');
Socket.parser = require('engine.io-parser');

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    agent: this.agent,
    hostname: this.hostname,
    port: this.port,
    secure: this.secure,
    path: this.path,
    query: query,
    forceJSONP: this.forceJSONP,
    jsonp: this.jsonp,
    forceBase64: this.forceBase64,
    enablesXDR: this.enablesXDR,
    timestampRequests: this.timestampRequests,
    timestampParam: this.timestampParam,
    policyPort: this.policyPort,
    socket: this,
    pfx: this.pfx,
    key: this.key,
    passphrase: this.passphrase,
    cert: this.cert,
    ca: this.ca,
    ciphers: this.ciphers,
    rejectUnauthorized: this.rejectUnauthorized,
    perMessageDeflate: this.perMessageDeflate,
    extraHeaders: this.extraHeaders,
    forceNode: this.forceNode,
    localAddress: this.localAddress
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(parsejson(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./transport":615,"./transports/index":616,"component-emitter":622,"debug":623,"engine.io-parser":626,"indexof":667,"parsejson":888,"parseqs":889,"parseuri":890}],615:[function(require,module,exports){
/**
 * Module dependencies.
 */

var parser = require('engine.io-parser');
var Emitter = require('component-emitter');

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};

},{"component-emitter":622,"engine.io-parser":626}],616:[function(require,module,exports){
(function (global){(function (){
/**
 * Module dependencies
 */

var XMLHttpRequest = require('xmlhttprequest-ssl');
var XHR = require('./polling-xhr');
var JSONP = require('./polling-jsonp');
var websocket = require('./websocket');

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./polling-jsonp":617,"./polling-xhr":618,"./websocket":620,"xmlhttprequest-ssl":621}],617:[function(require,module,exports){
(function (global){(function (){

/**
 * Module requirements.
 */

var Polling = require('./polling');
var inherit = require('component-inherit');

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    if (!global.___eio) global.___eio = [];
    callbacks = global.___eio;
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (global.document && global.addEventListener) {
    global.addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./polling":619,"component-inherit":421}],618:[function(require,module,exports){
(function (global){(function (){
/**
 * Module requirements.
 */

var XMLHttpRequest = require('xmlhttprequest-ssl');
var Polling = require('./polling');
var Emitter = require('component-emitter');
var inherit = require('component-inherit');
var debug = require('debug')('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = opts.hostname !== global.location.hostname ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  } else {
    this.extraHeaders = opts.extraHeaders;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}
    if (this.supportsBinary) {
      // This has to be done after open because Firefox is stupid
      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
      xhr.responseType = 'arraybuffer';
    }

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (global.document) {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (global.document) {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      if (!this.supportsBinary) {
        data = this.xhr.responseText;
      } else {
        try {
          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
        } catch (e) {
          var ui8Arr = new Uint8Array(this.xhr.response);
          var dataArray = [];
          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
            dataArray.push(ui8Arr[idx]);
          }

          data = String.fromCharCode.apply(null, dataArray);
        }
      }
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (global.document) {
  if (global.attachEvent) {
    global.attachEvent('onunload', unloadHandler);
  } else if (global.addEventListener) {
    global.addEventListener('beforeunload', unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./polling":619,"component-emitter":622,"component-inherit":421,"debug":623,"xmlhttprequest-ssl":621}],619:[function(require,module,exports){
/**
 * Module dependencies.
 */

var Transport = require('../transport');
var parseqs = require('parseqs');
var parser = require('engine.io-parser');
var inherit = require('component-inherit');
var yeast = require('yeast');
var debug = require('debug')('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = require('xmlhttprequest-ssl');
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

},{"../transport":615,"component-inherit":421,"debug":623,"engine.io-parser":626,"parseqs":889,"xmlhttprequest-ssl":621,"yeast":1219}],620:[function(require,module,exports){
(function (global){(function (){
/**
 * Module dependencies.
 */

var Transport = require('../transport');
var parser = require('engine.io-parser');
var parseqs = require('parseqs');
var inherit = require('component-inherit');
var yeast = require('yeast');
var debug = require('debug')('engine.io-client:websocket');
var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
var NodeWebSocket;
if (typeof window === 'undefined') {
  try {
    NodeWebSocket = require('ws');
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket;
if (!WebSocket && typeof window === 'undefined') {
  WebSocket = NodeWebSocket;
}

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = void (0);
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../transport":615,"component-inherit":421,"debug":623,"engine.io-parser":626,"parseqs":889,"ws":402,"yeast":1219}],621:[function(require,module,exports){
(function (global){(function (){
// browser shim for xmlhttprequest module

var hasCORS = require('has-cors');

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"has-cors":643}],622:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],623:[function(require,module,exports){
(function (process){(function (){

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = require('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return process.env.DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

}).call(this)}).call(this,require('_process'))
},{"./debug":624,"_process":405}],624:[function(require,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require('ms');

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":625}],625:[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}

},{}],626:[function(require,module,exports){
(function (global){(function (){
/**
 * Module dependencies.
 */

var keys = require('./keys');
var hasBinary = require('has-binary');
var sliceBuffer = require('arraybuffer.slice');
var after = require('after');
var utf8 = require('wtf-8');

var base64encoder;
if (global && global.ArrayBuffer) {
  base64encoder = require('base64-arraybuffer');
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = require('blob');

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if ('function' == typeof supportsBinary) {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if ('function' == typeof utf8encode) {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data == 'string') {
    if (data.charAt(0) == 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data);
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary == 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data != 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data == '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = ''
    , n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (':' != chr) {
      length += chr;
    } else {
      if ('' == length || (length != (n = Number(length)))) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      msg = data.substr(i + 1, n);

      if (length != msg.length) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, true);

        if (err.type == packet.type && err.data == packet.data) {
          // parser error in individual packet - ignoring payload
          return callback(err, 0, 1);
        }

        var ret = callback(packet, i + n, l);
        if (false === ret) return;
      }

      // advance cursor
      i += n;
      length = '';
    }
  }

  if (length != '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  var numberTooLong = false;
  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] == 255) break;

      if (msgLength.length > 310) {
        numberTooLong = true;
        break;
      }

      msgLength += tailArray[i];
    }

    if(numberTooLong) return callback(err, 0, 1);

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./keys":627,"after":333,"arraybuffer.slice":334,"base64-arraybuffer":386,"blob":388,"has-binary":641,"wtf-8":1218}],627:[function(require,module,exports){

/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};

},{}],628:[function(require,module,exports){
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.4.2 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.4.2",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        fun = function () {},
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     > Arguments

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        eve = function (name, scope) {
            name = String(name);
            var e = events,
                oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                f = false,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event,
                errors = [];
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
        // Undocumented. Debug only.
        eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     > Arguments

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment. 
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        name = String(name);
        if (typeof f != "function") {
            return function () {};
        }
        var names = name.split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = name.split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     > Arguments
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     > Arguments
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(current_event);
        }
        return current_event;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = name.split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = name.split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.unbind(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    (typeof module != "undefined" && module.exports) ? (module.exports = eve) : (typeof define === "function" && define.amd ? (define("eve", [], function() { return eve; })) : (glob.eve = eve));
})(this);

},{}],629:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],630:[function(require,module,exports){
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
		define(function () {
			return ExecutionEnvironment;
		});
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());

},{}],631:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.exprEval = factory());
}(this, (function () { 'use strict';

  var INUMBER = 'INUMBER';
  var IOP1 = 'IOP1';
  var IOP2 = 'IOP2';
  var IOP3 = 'IOP3';
  var IVAR = 'IVAR';
  var IFUNCALL = 'IFUNCALL';
  var IEXPR = 'IEXPR';
  var IMEMBER = 'IMEMBER';

  function Instruction(type, value) {
    this.type = type;
    this.value = (value !== undefined && value !== null) ? value : 0;
  }

  Instruction.prototype.toString = function () {
    switch (this.type) {
      case INUMBER:
      case IOP1:
      case IOP2:
      case IOP3:
      case IVAR:
        return this.value;
      case IFUNCALL:
        return 'CALL ' + this.value;
      case IMEMBER:
        return '.' + this.value;
      default:
        return 'Invalid Instruction';
    }
  };

  function unaryInstruction(value) {
    return new Instruction(IOP1, value);
  }

  function binaryInstruction(value) {
    return new Instruction(IOP2, value);
  }

  function ternaryInstruction(value) {
    return new Instruction(IOP3, value);
  }

  function simplify(tokens, unaryOps, binaryOps, ternaryOps, values) {
    var nstack = [];
    var newexpression = [];
    var n1, n2, n3;
    var f;
    for (var i = 0; i < tokens.length; i++) {
      var item = tokens[i];
      var type = item.type;
      if (type === INUMBER) {
        nstack.push(item);
      } else if (type === IVAR && values.hasOwnProperty(item.value)) {
        item = new Instruction(INUMBER, values[item.value]);
        nstack.push(item);
      } else if (type === IOP2 && nstack.length > 1) {
        n2 = nstack.pop();
        n1 = nstack.pop();
        f = binaryOps[item.value];
        item = new Instruction(INUMBER, f(n1.value, n2.value));
        nstack.push(item);
      } else if (type === IOP3 && nstack.length > 2) {
        n3 = nstack.pop();
        n2 = nstack.pop();
        n1 = nstack.pop();
        if (item.value === '?') {
          nstack.push(n1.value ? n2.value : n3.value);
        } else {
          f = ternaryOps[item.value];
          item = new Instruction(INUMBER, f(n1.value, n2.value, n3.value));
          nstack.push(item);
        }
      } else if (type === IOP1 && nstack.length > 0) {
        n1 = nstack.pop();
        f = unaryOps[item.value];
        item = new Instruction(INUMBER, f(n1.value));
        nstack.push(item);
      } else if (type === IEXPR) {
        while (nstack.length > 0) {
          newexpression.push(nstack.shift());
        }
        newexpression.push(new Instruction(IEXPR, simplify(item.value, unaryOps, binaryOps, ternaryOps, values)));
      } else if (type === IMEMBER && nstack.length > 0) {
        n1 = nstack.pop();
        nstack.push(new Instruction(INUMBER, n1.value[item.value]));
      } else {
        while (nstack.length > 0) {
          newexpression.push(nstack.shift());
        }
        newexpression.push(item);
      }
    }
    while (nstack.length > 0) {
      newexpression.push(nstack.shift());
    }
    return newexpression;
  }

  function substitute(tokens, variable, expr) {
    var newexpression = [];
    for (var i = 0; i < tokens.length; i++) {
      var item = tokens[i];
      var type = item.type;
      if (type === IVAR && item.value === variable) {
        for (var j = 0; j < expr.tokens.length; j++) {
          var expritem = expr.tokens[j];
          var replitem;
          if (expritem.type === IOP1) {
            replitem = unaryInstruction(expritem.value);
          } else if (expritem.type === IOP2) {
            replitem = binaryInstruction(expritem.value);
          } else if (expritem.type === IOP3) {
            replitem = ternaryInstruction(expritem.value);
          } else {
            replitem = new Instruction(expritem.type, expritem.value);
          }
          newexpression.push(replitem);
        }
      } else if (type === IEXPR) {
        newexpression.push(new Instruction(IEXPR, substitute(item.value, variable, expr)));
      } else {
        newexpression.push(item);
      }
    }
    return newexpression;
  }

  function evaluate(tokens, expr, values) {
    var nstack = [];
    var n1, n2, n3;
    var f;
    for (var i = 0; i < tokens.length; i++) {
      var item = tokens[i];
      var type = item.type;
      if (type === INUMBER) {
        nstack.push(item.value);
      } else if (type === IOP2) {
        n2 = nstack.pop();
        n1 = nstack.pop();
        if (item.value === 'and') {
          nstack.push(n1 ? !!evaluate(n2, expr, values) : false);
        } else if (item.value === 'or') {
          nstack.push(n1 ? true : !!evaluate(n2, expr, values));
        } else {
          f = expr.binaryOps[item.value];
          nstack.push(f(n1, n2));
        }
      } else if (type === IOP3) {
        n3 = nstack.pop();
        n2 = nstack.pop();
        n1 = nstack.pop();
        if (item.value === '?') {
          nstack.push(evaluate(n1 ? n2 : n3, expr, values));
        } else {
          f = expr.ternaryOps[item.value];
          nstack.push(f(n1, n2, n3));
        }
      } else if (type === IVAR) {
        if (item.value in expr.functions) {
          nstack.push(expr.functions[item.value]);
        } else {
          var v = values[item.value];
          if (v !== undefined) {
            nstack.push(v);
          } else {
            throw new Error('undefined variable: ' + item.value);
          }
        }
      } else if (type === IOP1) {
        n1 = nstack.pop();
        f = expr.unaryOps[item.value];
        nstack.push(f(n1));
      } else if (type === IFUNCALL) {
        var argCount = item.value;
        var args = [];
        while (argCount-- > 0) {
          args.unshift(nstack.pop());
        }
        f = nstack.pop();
        if (f.apply && f.call) {
          nstack.push(f.apply(undefined, args));
        } else {
          throw new Error(f + ' is not a function');
        }
      } else if (type === IEXPR) {
        nstack.push(item.value);
      } else if (type === IMEMBER) {
        n1 = nstack.pop();
        nstack.push(n1[item.value]);
      } else {
        throw new Error('invalid Expression');
      }
    }
    if (nstack.length > 1) {
      throw new Error('invalid Expression (parity)');
    }
    return nstack[0] === -0 ? 0: nstack[0];
  }

  function expressionToString(tokens, toJS) {
    var nstack = [];
    var n1, n2, n3;
    var f;
    for (var i = 0; i < tokens.length; i++) {
      var item = tokens[i];
      var type = item.type;
      if (type === INUMBER) {
        if (typeof item.value === 'number' && item.value < 0) {
          nstack.push('(' + item.value + ')');
        } else {
          nstack.push(escapeValue(item.value));
        }
      } else if (type === IOP2) {
        n2 = nstack.pop();
        n1 = nstack.pop();
        f = item.value;
        if (toJS) {
          if (f === '^') {
            nstack.push('Math.pow(' + n1 + ', ' + n2 + ')');
          } else if (f === 'and') {
            nstack.push('(!!' + n1 + ' && !!' + n2 + ')');
          } else if (f === 'or') {
            nstack.push('(!!' + n1 + ' || !!' + n2 + ')');
          } else if (f === '||') {
            nstack.push('(String(' + n1 + ') + String(' + n2 + '))');
          } else if (f === '==') {
            nstack.push('(' + n1 + ' === ' + n2 + ')');
          } else if (f === '!=') {
            nstack.push('(' + n1 + ' !== ' + n2 + ')');
          } else {
            nstack.push('(' + n1 + ' ' + f + ' ' + n2 + ')');
          }
        } else {
          nstack.push('(' + n1 + ' ' + f + ' ' + n2 + ')');
        }
      } else if (type === IOP3) {
        n3 = nstack.pop();
        n2 = nstack.pop();
        n1 = nstack.pop();
        f = item.value;
        if (f === '?') {
          nstack.push('(' + n1 + ' ? ' + n2 + ' : ' + n3 + ')');
        } else {
          throw new Error('invalid Expression');
        }
      } else if (type === IVAR) {
        nstack.push(item.value);
      } else if (type === IOP1) {
        n1 = nstack.pop();
        f = item.value;
        if (f === '-' || f === '+') {
          nstack.push('(' + f + n1 + ')');
        } else if (toJS) {
          if (f === 'not') {
            nstack.push('(' + '!' + n1 + ')');
          } else if (f === '!') {
            nstack.push('fac(' + n1 + ')');
          } else {
            nstack.push(f + '(' + n1 + ')');
          }
        } else if (f === '!') {
          nstack.push('(' + n1 + '!)');
        } else {
          nstack.push('(' + f + ' ' + n1 + ')');
        }
      } else if (type === IFUNCALL) {
        var argCount = item.value;
        var args = [];
        while (argCount-- > 0) {
          args.unshift(nstack.pop());
        }
        f = nstack.pop();
        nstack.push(f + '(' + args.join(', ') + ')');
      } else if (type === IMEMBER) {
        n1 = nstack.pop();
        nstack.push(n1 + '.' + item.value);
      } else if (type === IEXPR) {
        nstack.push('(' + expressionToString(item.value, toJS) + ')');
      } else {
        throw new Error('invalid Expression');
      }
    }
    if (nstack.length > 1) {
      throw new Error('invalid Expression (parity)');
    }
    return String(nstack[0]);
  }

  function escapeValue(v) {
    if (typeof v === 'string') {
      return JSON.stringify(v).replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
    }
    return v;
  }

  function contains(array, obj) {
    for (var i = 0; i < array.length; i++) {
      if (array[i] === obj) {
        return true;
      }
    }
    return false;
  }

  function getSymbols(tokens, symbols, options) {
    options = options || {};
    var withMembers = !!options.withMembers;
    var prevVar = null;

    for (var i = 0; i < tokens.length; i++) {
      var item = tokens[i];
      if (item.type === IVAR) {
        if (!withMembers && !contains(symbols, item.value)) {
          symbols.push(item.value);
        } else if (prevVar !== null) {
          if (!contains(symbols, prevVar)) {
            symbols.push(prevVar);
          }
          prevVar = item.value;
        } else {
          prevVar = item.value;
        }
      } else if (item.type === IMEMBER && withMembers && prevVar !== null) {
        prevVar += '.' + item.value;
      } else if (item.type === IEXPR) {
        getSymbols(item.value, symbols, options);
      } else if (prevVar !== null) {
        if (!contains(symbols, prevVar)) {
          symbols.push(prevVar);
        }
        prevVar = null;
      }
    }

    if (prevVar !== null && !contains(symbols, prevVar)) {
      symbols.push(prevVar);
    }
  }

  function Expression(tokens, parser) {
    this.tokens = tokens;
    this.parser = parser;
    this.unaryOps = parser.unaryOps;
    this.binaryOps = parser.binaryOps;
    this.ternaryOps = parser.ternaryOps;
    this.functions = parser.functions;
  }

  Expression.prototype.simplify = function (values) {
    values = values || {};
    return new Expression(simplify(this.tokens, this.unaryOps, this.binaryOps, this.ternaryOps, values), this.parser);
  };

  Expression.prototype.substitute = function (variable, expr) {
    if (!(expr instanceof Expression)) {
      expr = this.parser.parse(String(expr));
    }

    return new Expression(substitute(this.tokens, variable, expr), this.parser);
  };

  Expression.prototype.evaluate = function (values) {
    values = values || {};
    return evaluate(this.tokens, this, values);
  };

  Expression.prototype.toString = function () {
    return expressionToString(this.tokens, false);
  };

  Expression.prototype.symbols = function (options) {
    options = options || {};
    var vars = [];
    getSymbols(this.tokens, vars, options);
    return vars;
  };

  Expression.prototype.variables = function (options) {
    options = options || {};
    var vars = [];
    getSymbols(this.tokens, vars, options);
    var functions = this.functions;
    return vars.filter(function (name) {
      return !(name in functions);
    });
  };

  Expression.prototype.toJSFunction = function (param, variables) {
    var expr = this;
    var f = new Function(param, 'with(this.functions) with (this.ternaryOps) with (this.binaryOps) with (this.unaryOps) { return ' + expressionToString(this.simplify(variables).tokens, true) + '; }'); // eslint-disable-line no-new-func
    return function () {
      return f.apply(expr, arguments);
    };
  };

  var TEOF = 'TEOF';
  var TOP = 'TOP';
  var TNUMBER = 'TNUMBER';
  var TSTRING = 'TSTRING';
  var TPAREN = 'TPAREN';
  var TCOMMA = 'TCOMMA';
  var TNAME = 'TNAME';

  function Token(type, value, index) {
    this.type = type;
    this.value = value;
    this.index = index;
  }

  Token.prototype.toString = function () {
    return this.type + ': ' + this.value;
  };

  function TokenStream(parser, expression) {
    this.pos = 0;
    this.current = null;
    this.unaryOps = parser.unaryOps;
    this.binaryOps = parser.binaryOps;
    this.ternaryOps = parser.ternaryOps;
    this.consts = parser.consts;
    this.expression = expression;
    this.savedPosition = 0;
    this.savedCurrent = null;
    this.options = parser.options;
  }

  TokenStream.prototype.newToken = function (type, value, pos) {
    return new Token(type, value, pos != null ? pos : this.pos);
  };

  TokenStream.prototype.save = function () {
    this.savedPosition = this.pos;
    this.savedCurrent = this.current;
  };

  TokenStream.prototype.restore = function () {
    this.pos = this.savedPosition;
    this.current = this.savedCurrent;
  };

  TokenStream.prototype.next = function () {
    if (this.pos >= this.expression.length) {
      return this.newToken(TEOF, 'EOF');
    }

    if (this.isWhitespace() || this.isComment()) {
      return this.next();
    } else if (this.isRadixInteger() ||
        this.isNumber() ||
        this.isOperator() ||
        this.isString() ||
        this.isParen() ||
        this.isComma() ||
        this.isNamedOp() ||
        this.isConst() ||
        this.isName()) {
      return this.current;
    } else {
      this.parseError('Unknown character "' + this.expression.charAt(this.pos) + '"');
    }
  };

  TokenStream.prototype.isString = function () {
    var r = false;
    var startPos = this.pos;
    var quote = this.expression.charAt(startPos);

    if (quote === '\'' || quote === '"') {
      var index = this.expression.indexOf(quote, startPos + 1);
      while (index >= 0 && this.pos < this.expression.length) {
        this.pos = index + 1;
        if (this.expression.charAt(index - 1) !== '\\') {
          var rawString = this.expression.substring(startPos + 1, index);
          this.current = this.newToken(TSTRING, this.unescape(rawString), startPos);
          r = true;
          break;
        }
        index = this.expression.indexOf(quote, index + 1);
      }
    }
    return r;
  };

  TokenStream.prototype.isParen = function () {
    var c = this.expression.charAt(this.pos);
    if (c === '(' || c === ')') {
      this.current = this.newToken(TPAREN, c);
      this.pos++;
      return true;
    }
    return false;
  };

  TokenStream.prototype.isComma = function () {
    var c = this.expression.charAt(this.pos);
    if (c === ',') {
      this.current = this.newToken(TCOMMA, ',');
      this.pos++;
      return true;
    }
    return false;
  };

  TokenStream.prototype.isConst = function () {
    var startPos = this.pos;
    var i = startPos;
    for (; i < this.expression.length; i++) {
      var c = this.expression.charAt(i);
      if (c.toUpperCase() === c.toLowerCase()) {
        if (i === this.pos || (c !== '_' && c !== '.' && (c < '0' || c > '9'))) {
          break;
        }
      }
    }
    if (i > startPos) {
      var str = this.expression.substring(startPos, i);
      if (str in this.consts) {
        this.current = this.newToken(TNUMBER, this.consts[str]);
        this.pos += str.length;
        return true;
      }
    }
    return false;
  };

  TokenStream.prototype.isNamedOp = function () {
    var startPos = this.pos;
    var i = startPos;
    for (; i < this.expression.length; i++) {
      var c = this.expression.charAt(i);
      if (c.toUpperCase() === c.toLowerCase()) {
        if (i === this.pos || (c !== '_' && (c < '0' || c > '9'))) {
          break;
        }
      }
    }
    if (i > startPos) {
      var str = this.expression.substring(startPos, i);
      if (this.isOperatorEnabled(str) && (str in this.binaryOps || str in this.unaryOps || str in this.ternaryOps)) {
        this.current = this.newToken(TOP, str);
        this.pos += str.length;
        return true;
      }
    }
    return false;
  };

  TokenStream.prototype.isName = function () {
    var startPos = this.pos;
    var i = startPos;
    var hasLetter = false;
    for (; i < this.expression.length; i++) {
      var c = this.expression.charAt(i);
      if (c.toUpperCase() === c.toLowerCase()) {
        if (i === this.pos && (c === '$' || c === '_')) {
          if (c === '_') {
            hasLetter = true;
          }
          continue;
        } else if (i === this.pos || !hasLetter || (c !== '_' && (c < '0' || c > '9'))) {
          break;
        }
      } else {
        hasLetter = true;
      }
    }
    if (hasLetter) {
      var str = this.expression.substring(startPos, i);
      this.current = this.newToken(TNAME, str);
      this.pos += str.length;
      return true;
    }
    return false;
  };

  TokenStream.prototype.isWhitespace = function () {
    var r = false;
    var c = this.expression.charAt(this.pos);
    while (c === ' ' || c === '\t' || c === '\n' || c === '\r') {
      r = true;
      this.pos++;
      if (this.pos >= this.expression.length) {
        break;
      }
      c = this.expression.charAt(this.pos);
    }
    return r;
  };

  var codePointPattern = /^[0-9a-f]{4}$/i;

  TokenStream.prototype.unescape = function (v) {
    var index = v.indexOf('\\');
    if (index < 0) {
      return v;
    }

    var buffer = v.substring(0, index);
    while (index >= 0) {
      var c = v.charAt(++index);
      switch (c) {
        case '\'':
          buffer += '\'';
          break;
        case '"':
          buffer += '"';
          break;
        case '\\':
          buffer += '\\';
          break;
        case '/':
          buffer += '/';
          break;
        case 'b':
          buffer += '\b';
          break;
        case 'f':
          buffer += '\f';
          break;
        case 'n':
          buffer += '\n';
          break;
        case 'r':
          buffer += '\r';
          break;
        case 't':
          buffer += '\t';
          break;
        case 'u':
          // interpret the following 4 characters as the hex of the unicode code point
          var codePoint = v.substring(index + 1, index + 5);
          if (!codePointPattern.test(codePoint)) {
            this.parseError('Illegal escape sequence: \\u' + codePoint);
          }
          buffer += String.fromCharCode(parseInt(codePoint, 16));
          index += 4;
          break;
        default:
          throw this.parseError('Illegal escape sequence: "\\' + c + '"');
      }
      ++index;
      var backslash = v.indexOf('\\', index);
      buffer += v.substring(index, backslash < 0 ? v.length : backslash);
      index = backslash;
    }

    return buffer;
  };

  TokenStream.prototype.isComment = function () {
    var c = this.expression.charAt(this.pos);
    if (c === '/' && this.expression.charAt(this.pos + 1) === '*') {
      this.pos = this.expression.indexOf('*/', this.pos) + 2;
      if (this.pos === 1) {
        this.pos = this.expression.length;
      }
      return true;
    }
    return false;
  };

  TokenStream.prototype.isRadixInteger = function () {
    var pos = this.pos;

    if (pos >= this.expression.length - 2 || this.expression.charAt(pos) !== '0') {
      return false;
    }
    ++pos;

    var radix;
    var validDigit;
    if (this.expression.charAt(pos) === 'x') {
      radix = 16;
      validDigit = /^[0-9a-f]$/i;
      ++pos;
    } else if (this.expression.charAt(pos) === 'b') {
      radix = 2;
      validDigit = /^[01]$/i;
      ++pos;
    } else {
      return false;
    }

    var valid = false;
    var startPos = pos;

    while (pos < this.expression.length) {
      var c = this.expression.charAt(pos);
      if (validDigit.test(c)) {
        pos++;
        valid = true;
      } else {
        break;
      }
    }

    if (valid) {
      this.current = this.newToken(TNUMBER, parseInt(this.expression.substring(startPos, pos), radix));
      this.pos = pos;
    }
    return valid;
  };

  TokenStream.prototype.isNumber = function () {
    var valid = false;
    var pos = this.pos;
    var startPos = pos;
    var resetPos = pos;
    var foundDot = false;
    var foundDigits = false;
    var c;

    while (pos < this.expression.length) {
      c = this.expression.charAt(pos);
      if ((c >= '0' && c <= '9') || (!foundDot && c === '.')) {
        if (c === '.') {
          foundDot = true;
        } else {
          foundDigits = true;
        }
        pos++;
        valid = foundDigits;
      } else {
        break;
      }
    }

    if (valid) {
      resetPos = pos;
    }

    if (c === 'e' || c === 'E') {
      pos++;
      var acceptSign = true;
      var validExponent = false;
      while (pos < this.expression.length) {
        c = this.expression.charAt(pos);
        if (acceptSign && (c === '+' || c === '-')) {
          acceptSign = false;
        } else if (c >= '0' && c <= '9') {
          validExponent = true;
          acceptSign = false;
        } else {
          break;
        }
        pos++;
      }

      if (!validExponent) {
        pos = resetPos;
      }
    }

    if (valid) {
      this.current = this.newToken(TNUMBER, parseFloat(this.expression.substring(startPos, pos)));
      this.pos = pos;
    } else {
      this.pos = resetPos;
    }
    return valid;
  };

  TokenStream.prototype.isOperator = function () {
    var startPos = this.pos;
    var c = this.expression.charAt(this.pos);

    if (c === '+' || c === '-' || c === '*' || c === '/' || c === '%' || c === '^' || c === '?' || c === ':' || c === '.') {
      this.current = this.newToken(TOP, c);
    } else if (c === '∙' || c === '•') {
      this.current = this.newToken(TOP, '*');
    } else if (c === '>') {
      if (this.expression.charAt(this.pos + 1) === '=') {
        this.current = this.newToken(TOP, '>=');
        this.pos++;
      } else {
        this.current = this.newToken(TOP, '>');
      }
    } else if (c === '<') {
      if (this.expression.charAt(this.pos + 1) === '=') {
        this.current = this.newToken(TOP, '<=');
        this.pos++;
      } else {
        this.current = this.newToken(TOP, '<');
      }
    } else if (c === '|') {
      if (this.expression.charAt(this.pos + 1) === '|') {
        this.current = this.newToken(TOP, '||');
        this.pos++;
      } else {
        return false;
      }
    } else if (c === '=') {
      if (this.expression.charAt(this.pos + 1) === '=') {
        this.current = this.newToken(TOP, '==');
        this.pos++;
      } else {
        return false;
      }
    } else if (c === '!') {
      if (this.expression.charAt(this.pos + 1) === '=') {
        this.current = this.newToken(TOP, '!=');
        this.pos++;
      } else {
        this.current = this.newToken(TOP, c);
      }
    } else {
      return false;
    }
    this.pos++;

    if (this.isOperatorEnabled(this.current.value)) {
      return true;
    } else {
      this.pos = startPos;
      return false;
    }
  };

  var optionNameMap = {
    '+': 'add',
    '-': 'subtract',
    '*': 'multiply',
    '/': 'divide',
    '%': 'remainder',
    '^': 'power',
    '!': 'factorial',
    '<': 'comparison',
    '>': 'comparison',
    '<=': 'comparison',
    '>=': 'comparison',
    '==': 'comparison',
    '!=': 'comparison',
    '||': 'concatenate',
    'and': 'logical',
    'or': 'logical',
    'not': 'logical',
    '?': 'conditional',
    ':': 'conditional'
  };

  function getOptionName(op) {
    return optionNameMap.hasOwnProperty(op) ? optionNameMap[op] : op;
  }

  TokenStream.prototype.isOperatorEnabled = function (op) {
    var optionName = getOptionName(op);
    var operators = this.options.operators || {};

    // in is a special case for now because it's disabled by default
    if (optionName === 'in') {
      return !!operators['in'];
    }

    return !(optionName in operators) || !!operators[optionName];
  };

  TokenStream.prototype.getCoordinates = function () {
    var line = 0;
    var column;
    var newline = -1;
    do {
      line++;
      column = this.pos - newline;
      newline = this.expression.indexOf('\n', newline + 1);
    } while (newline >= 0 && newline < this.pos);

    return {
      line: line,
      column: column
    };
  };

  TokenStream.prototype.parseError = function (msg) {
    var coords = this.getCoordinates();
    throw new Error('parse error [' + coords.line + ':' + coords.column + ']: ' + msg);
  };

  function ParserState(parser, tokenStream, options) {
    this.parser = parser;
    this.tokens = tokenStream;
    this.current = null;
    this.nextToken = null;
    this.next();
    this.savedCurrent = null;
    this.savedNextToken = null;
    this.allowMemberAccess = options.allowMemberAccess !== false;
  }

  ParserState.prototype.next = function () {
    this.current = this.nextToken;
    return (this.nextToken = this.tokens.next());
  };

  ParserState.prototype.tokenMatches = function (token, value) {
    if (typeof value === 'undefined') {
      return true;
    } else if (Array.isArray(value)) {
      return contains(value, token.value);
    } else if (typeof value === 'function') {
      return value(token);
    } else {
      return token.value === value;
    }
  };

  ParserState.prototype.save = function () {
    this.savedCurrent = this.current;
    this.savedNextToken = this.nextToken;
    this.tokens.save();
  };

  ParserState.prototype.restore = function () {
    this.tokens.restore();
    this.current = this.savedCurrent;
    this.nextToken = this.savedNextToken;
  };

  ParserState.prototype.accept = function (type, value) {
    if (this.nextToken.type === type && this.tokenMatches(this.nextToken, value)) {
      this.next();
      return true;
    }
    return false;
  };

  ParserState.prototype.expect = function (type, value) {
    if (!this.accept(type, value)) {
      var coords = this.tokens.getCoordinates();
      throw new Error('parse error [' + coords.line + ':' + coords.column + ']: Expected ' + (value || type));
    }
  };

  ParserState.prototype.parseAtom = function (instr) {
    if (this.accept(TNAME)) {
      instr.push(new Instruction(IVAR, this.current.value));
    } else if (this.accept(TNUMBER)) {
      instr.push(new Instruction(INUMBER, this.current.value));
    } else if (this.accept(TSTRING)) {
      instr.push(new Instruction(INUMBER, this.current.value));
    } else if (this.accept(TPAREN, '(')) {
      this.parseExpression(instr);
      this.expect(TPAREN, ')');
    } else {
      throw new Error('unexpected ' + this.nextToken);
    }
  };

  ParserState.prototype.parseExpression = function (instr) {
    this.parseConditionalExpression(instr);
  };

  ParserState.prototype.parseConditionalExpression = function (instr) {
    this.parseOrExpression(instr);
    while (this.accept(TOP, '?')) {
      var trueBranch = [];
      var falseBranch = [];
      this.parseConditionalExpression(trueBranch);
      this.expect(TOP, ':');
      this.parseConditionalExpression(falseBranch);
      instr.push(new Instruction(IEXPR, trueBranch));
      instr.push(new Instruction(IEXPR, falseBranch));
      instr.push(ternaryInstruction('?'));
    }
  };

  ParserState.prototype.parseOrExpression = function (instr) {
    this.parseAndExpression(instr);
    while (this.accept(TOP, 'or')) {
      var falseBranch = [];
      this.parseAndExpression(falseBranch);
      instr.push(new Instruction(IEXPR, falseBranch));
      instr.push(binaryInstruction('or'));
    }
  };

  ParserState.prototype.parseAndExpression = function (instr) {
    this.parseComparison(instr);
    while (this.accept(TOP, 'and')) {
      var trueBranch = [];
      this.parseComparison(trueBranch);
      instr.push(new Instruction(IEXPR, trueBranch));
      instr.push(binaryInstruction('and'));
    }
  };

  var COMPARISON_OPERATORS = ['==', '!=', '<', '<=', '>=', '>', 'in'];

  ParserState.prototype.parseComparison = function (instr) {
    this.parseAddSub(instr);
    while (this.accept(TOP, COMPARISON_OPERATORS)) {
      var op = this.current;
      this.parseAddSub(instr);
      instr.push(binaryInstruction(op.value));
    }
  };

  var ADD_SUB_OPERATORS = ['+', '-', '||'];

  ParserState.prototype.parseAddSub = function (instr) {
    this.parseTerm(instr);
    while (this.accept(TOP, ADD_SUB_OPERATORS)) {
      var op = this.current;
      this.parseTerm(instr);
      instr.push(binaryInstruction(op.value));
    }
  };

  var TERM_OPERATORS = ['*', '/', '%'];

  ParserState.prototype.parseTerm = function (instr) {
    this.parseFactor(instr);
    while (this.accept(TOP, TERM_OPERATORS)) {
      var op = this.current;
      this.parseFactor(instr);
      instr.push(binaryInstruction(op.value));
    }
  };

  ParserState.prototype.parseFactor = function (instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
      return token.value in unaryOps;
    }

    this.save();
    if (this.accept(TOP, isPrefixOperator)) {
      if ((this.current.value !== '-' && this.current.value !== '+' && this.nextToken.type === TPAREN && this.nextToken.value === '(')) {
        this.restore();
        this.parseExponential(instr);
      } else {
        var op = this.current;
        this.parseFactor(instr);
        instr.push(unaryInstruction(op.value));
      }
    } else {
      this.parseExponential(instr);
    }
  };

  ParserState.prototype.parseExponential = function (instr) {
    this.parsePostfixExpression(instr);
    while (this.accept(TOP, '^')) {
      this.parseFactor(instr);
      instr.push(binaryInstruction('^'));
    }
  };

  ParserState.prototype.parsePostfixExpression = function (instr) {
    this.parseFunctionCall(instr);
    while (this.accept(TOP, '!')) {
      instr.push(unaryInstruction('!'));
    }
  };

  ParserState.prototype.parseFunctionCall = function (instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
      return token.value in unaryOps;
    }

    if (this.accept(TOP, isPrefixOperator)) {
      var op = this.current;
      this.parseAtom(instr);
      instr.push(unaryInstruction(op.value));
    } else {
      this.parseMemberExpression(instr);
      while (this.accept(TPAREN, '(')) {
        if (this.accept(TPAREN, ')')) {
          instr.push(new Instruction(IFUNCALL, 0));
        } else {
          var argCount = this.parseArgumentList(instr);
          instr.push(new Instruction(IFUNCALL, argCount));
        }
      }
    }
  };

  ParserState.prototype.parseArgumentList = function (instr) {
    var argCount = 0;

    while (!this.accept(TPAREN, ')')) {
      this.parseExpression(instr);
      ++argCount;
      while (this.accept(TCOMMA)) {
        this.parseExpression(instr);
        ++argCount;
      }
    }

    return argCount;
  };

  ParserState.prototype.parseMemberExpression = function (instr) {
    this.parseAtom(instr);
    while (this.accept(TOP, '.')) {
      if (!this.allowMemberAccess) {
        throw new Error('unexpected ".", member access is not permitted');
      }

      this.expect(TNAME);
      instr.push(new Instruction(IMEMBER, this.current.value));
    }
  };

  function add(a, b) {
    return Number(a) + Number(b);
  }

  function sub(a, b) {
    return a - b;
  }

  function mul(a, b) {
    return a * b;
  }

  function div(a, b) {
    return a / b;
  }

  function mod(a, b) {
    return a % b;
  }

  function concat(a, b) {
    return '' + a + b;
  }

  function equal(a, b) {
    return a === b;
  }

  function notEqual(a, b) {
    return a !== b;
  }

  function greaterThan(a, b) {
    return a > b;
  }

  function lessThan(a, b) {
    return a < b;
  }

  function greaterThanEqual(a, b) {
    return a >= b;
  }

  function lessThanEqual(a, b) {
    return a <= b;
  }

  function andOperator(a, b) {
    return Boolean(a && b);
  }

  function orOperator(a, b) {
    return Boolean(a || b);
  }

  function inOperator(a, b) {
    return contains(b, a);
  }

  function sinh(a) {
    return ((Math.exp(a) - Math.exp(-a)) / 2);
  }

  function cosh(a) {
    return ((Math.exp(a) + Math.exp(-a)) / 2);
  }

  function tanh(a) {
    if (a === Infinity) return 1;
    if (a === -Infinity) return -1;
    return (Math.exp(a) - Math.exp(-a)) / (Math.exp(a) + Math.exp(-a));
  }

  function asinh(a) {
    if (a === -Infinity) return a;
    return Math.log(a + Math.sqrt((a * a) + 1));
  }

  function acosh(a) {
    return Math.log(a + Math.sqrt((a * a) - 1));
  }

  function atanh(a) {
    return (Math.log((1 + a) / (1 - a)) / 2);
  }

  function log10(a) {
    return Math.log(a) * Math.LOG10E;
  }

  function neg(a) {
    return -a;
  }

  function not(a) {
    return !a;
  }

  function trunc(a) {
    return a < 0 ? Math.ceil(a) : Math.floor(a);
  }

  function random(a) {
    return Math.random() * (a || 1);
  }

  function factorial(a) { // a!
    return gamma(a + 1);
  }

  function isInteger(value) {
    return isFinite(value) && (value === Math.round(value));
  }

  var GAMMA_G = 4.7421875;
  var GAMMA_P = [
    0.99999999999999709182,
    57.156235665862923517, -59.597960355475491248,
    14.136097974741747174, -0.49191381609762019978,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4, -0.98374475304879564677e-4,
    0.15808870322491248884e-3, -0.21026444172410488319e-3,
    0.21743961811521264320e-3, -0.16431810653676389022e-3,
    0.84418223983852743293e-4, -0.26190838401581408670e-4,
    0.36899182659531622704e-5
  ];

  // Gamma function from math.js
  function gamma(n) {
    var t, x;

    if (isInteger(n)) {
      if (n <= 0) {
        return isFinite(n) ? Infinity : NaN;
      }

      if (n > 171) {
        return Infinity; // Will overflow
      }

      var value = n - 2;
      var res = n - 1;
      while (value > 1) {
        res *= value;
        value--;
      }

      if (res === 0) {
        res = 1; // 0! is per definition 1
      }

      return res;
    }

    if (n < 0.5) {
      return Math.PI / (Math.sin(Math.PI * n) * gamma(1 - n));
    }

    if (n >= 171.35) {
      return Infinity; // will overflow
    }

    if (n > 85.0) { // Extended Stirling Approx
      var twoN = n * n;
      var threeN = twoN * n;
      var fourN = threeN * n;
      var fiveN = fourN * n;
      return Math.sqrt(2 * Math.PI / n) * Math.pow((n / Math.E), n) *
        (1 + (1 / (12 * n)) + (1 / (288 * twoN)) - (139 / (51840 * threeN)) -
        (571 / (2488320 * fourN)) + (163879 / (209018880 * fiveN)) +
        (5246819 / (75246796800 * fiveN * n)));
    }

    --n;
    x = GAMMA_P[0];
    for (var i = 1; i < GAMMA_P.length; ++i) {
      x += GAMMA_P[i] / (n + i);
    }

    t = n + GAMMA_G + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
  }

  function stringLength(s) {
    return String(s).length;
  }

  function hypot() {
    var sum = 0;
    var larg = 0;
    for (var i = 0; i < arguments.length; i++) {
      var arg = Math.abs(arguments[i]);
      var div;
      if (larg < arg) {
        div = larg / arg;
        sum = (sum * div * div) + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else {
        sum += arg;
      }
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }

  function condition(cond, yep, nope) {
    return cond ? yep : nope;
  }

  /**
  * Decimal adjustment of a number.
  * From @escopecz.
  *
  * @param {Number} value The number.
  * @param {Integer} exp  The exponent (the 10 logarithm of the adjustment base).
  * @return {Number} The adjusted value.
  */
  function roundTo(value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math.round(value);
    }
    value = +value;
    exp = -(+exp);
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  function Parser(options) {
    this.options = options || {};
    this.unaryOps = {
      sin: Math.sin,
      cos: Math.cos,
      tan: Math.tan,
      asin: Math.asin,
      acos: Math.acos,
      atan: Math.atan,
      sinh: Math.sinh || sinh,
      cosh: Math.cosh || cosh,
      tanh: Math.tanh || tanh,
      asinh: Math.asinh || asinh,
      acosh: Math.acosh || acosh,
      atanh: Math.atanh || atanh,
      sqrt: Math.sqrt,
      log: Math.log,
      ln: Math.log,
      lg: Math.log10 || log10,
      log10: Math.log10 || log10,
      abs: Math.abs,
      ceil: Math.ceil,
      floor: Math.floor,
      round: Math.round,
      trunc: Math.trunc || trunc,
      '-': neg,
      '+': Number,
      exp: Math.exp,
      not: not,
      length: stringLength,
      '!': factorial
    };

    this.binaryOps = {
      '+': add,
      '-': sub,
      '*': mul,
      '/': div,
      '%': mod,
      '^': Math.pow,
      '||': concat,
      '==': equal,
      '!=': notEqual,
      '>': greaterThan,
      '<': lessThan,
      '>=': greaterThanEqual,
      '<=': lessThanEqual,
      and: andOperator,
      or: orOperator,
      'in': inOperator
    };

    this.ternaryOps = {
      '?': condition
    };

    this.functions = {
      random: random,
      fac: factorial,
      min: Math.min,
      max: Math.max,
      hypot: Math.hypot || hypot,
      pyt: Math.hypot || hypot, // backward compat
      pow: Math.pow,
      atan2: Math.atan2,
      'if': condition,
      gamma: gamma,
      roundTo: roundTo
    };

    this.consts = {
      E: Math.E,
      PI: Math.PI,
      'true': true,
      'false': false
    };
  }

  Parser.prototype.parse = function (expr) {
    var instr = [];
    var parserState = new ParserState(
      this,
      new TokenStream(this, expr),
      { allowMemberAccess: this.options.allowMemberAccess }
    );

    parserState.parseExpression(instr);
    parserState.expect(TEOF, 'EOF');

    return new Expression(instr, this);
  };

  Parser.prototype.evaluate = function (expr, variables) {
    return this.parse(expr).evaluate(variables);
  };

  var sharedParser = new Parser();

  Parser.parse = function (expr) {
    return sharedParser.parse(expr);
  };

  Parser.evaluate = function (expr, variables) {
    return sharedParser.parse(expr).evaluate(variables);
  };

  /*!
   Based on ndef.parser, by Raphael Graf(r@undefined.ch)
   http://www.undefined.ch/mparser/index.html

   Ported to JavaScript and modified by Matthew Crumley (email@matthewcrumley.com, http://silentmatt.com/)

   You are free to use and modify this code in anyway you find useful. Please leave this comment in the code
   to acknowledge its original source. If you feel like it, I enjoy hearing about projects that use my code,
   but don't feel like you have to let me know or ask permission.
  */

  var index = {
    Parser: Parser,
    Expression: Expression
  };

  return index;

})));

},{}],632:[function(require,module,exports){
'use strict';

// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

},{}],633:[function(require,module,exports){
//
// Main
//

function memoize (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3)
  var cacheKey = serializer(args)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null)
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
}

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
}

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value
}

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
}

//
// API
//

module.exports = memoize
module.exports.strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
}

},{}],634:[function(require,module,exports){
!(function(win) {

/**
 * FastDom
 *
 * Eliminates layout thrashing
 * by batching DOM read/write
 * interactions.
 *
 * @author Wilson Page <wilsonpage@me.com>
 * @author Kornel Lesinski <kornel.lesinski@ft.com>
 */

'use strict';

/**
 * Mini logger
 *
 * @return {Function}
 */
var debug = 0 ? console.log.bind(console, '[fastdom]') : function() {};

/**
 * Normalized rAF
 *
 * @type {Function}
 */
var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };

/**
 * Initialize a `FastDom`.
 *
 * @constructor
 */
function FastDom() {
  var self = this;
  self.reads = [];
  self.writes = [];
  self.raf = raf.bind(win); // test hook
  debug('initialized', self);
}

FastDom.prototype = {
  constructor: FastDom,

  /**
   * We run this inside a try catch
   * so that if any jobs error, we
   * are able to recover and continue
   * to flush the batch until it's empty.
   *
   * @param {Array} tasks
   */
  runTasks: function(tasks) {
    debug('run tasks');
    var task; while (task = tasks.shift()) task();
  },

  /**
   * Adds a job to the read batch and
   * schedules a new frame if need be.
   *
   * @param  {Function} fn
   * @param  {Object} ctx the context to be bound to `fn` (optional).
   * @public
   */
  measure: function(fn, ctx) {
    debug('measure');
    var task = !ctx ? fn : fn.bind(ctx);
    this.reads.push(task);
    scheduleFlush(this);
    return task;
  },

  /**
   * Adds a job to the
   * write batch and schedules
   * a new frame if need be.
   *
   * @param  {Function} fn
   * @param  {Object} ctx the context to be bound to `fn` (optional).
   * @public
   */
  mutate: function(fn, ctx) {
    debug('mutate');
    var task = !ctx ? fn : fn.bind(ctx);
    this.writes.push(task);
    scheduleFlush(this);
    return task;
  },

  /**
   * Clears a scheduled 'read' or 'write' task.
   *
   * @param {Object} task
   * @return {Boolean} success
   * @public
   */
  clear: function(task) {
    debug('clear', task);
    return remove(this.reads, task) || remove(this.writes, task);
  },

  /**
   * Extend this FastDom with some
   * custom functionality.
   *
   * Because fastdom must *always* be a
   * singleton, we're actually extending
   * the fastdom instance. This means tasks
   * scheduled by an extension still enter
   * fastdom's global task queue.
   *
   * The 'super' instance can be accessed
   * from `this.fastdom`.
   *
   * @example
   *
   * var myFastdom = fastdom.extend({
   *   initialize: function() {
   *     // runs on creation
   *   },
   *
   *   // override a method
   *   measure: function(fn) {
   *     // do extra stuff ...
   *
   *     // then call the original
   *     return this.fastdom.measure(fn);
   *   },
   *
   *   ...
   * });
   *
   * @param  {Object} props  properties to mixin
   * @return {FastDom}
   */
  extend: function(props) {
    debug('extend', props);
    if (typeof props != 'object') throw new Error('expected object');

    var child = Object.create(this);
    mixin(child, props);
    child.fastdom = this;

    // run optional creation hook
    if (child.initialize) child.initialize();

    return child;
  },

  // override this with a function
  // to prevent Errors in console
  // when tasks throw
  catch: null
};

/**
 * Schedules a new read/write
 * batch if one isn't pending.
 *
 * @private
 */
function scheduleFlush(fastdom) {
  if (!fastdom.scheduled) {
    fastdom.scheduled = true;
    fastdom.raf(flush.bind(null, fastdom));
    debug('flush scheduled');
  }
}

/**
 * Runs queued `read` and `write` tasks.
 *
 * Errors are caught and thrown by default.
 * If a `.catch` function has been defined
 * it is called instead.
 *
 * @private
 */
function flush(fastdom) {
  debug('flush');

  var writes = fastdom.writes;
  var reads = fastdom.reads;
  var error;

  try {
    debug('flushing reads', reads.length);
    fastdom.runTasks(reads);
    debug('flushing writes', writes.length);
    fastdom.runTasks(writes);
  } catch (e) { error = e; }

  fastdom.scheduled = false;

  // If the batch errored we may still have tasks queued
  if (reads.length || writes.length) scheduleFlush(fastdom);

  if (error) {
    debug('task errored', error.message);
    if (fastdom.catch) fastdom.catch(error);
    else throw error;
  }
}

/**
 * Remove an item from an Array.
 *
 * @param  {Array} array
 * @param  {*} item
 * @return {Boolean}
 */
function remove(array, item) {
  var index = array.indexOf(item);
  return !!~index && !!array.splice(index, 1);
}

/**
 * Mixin own properties of source
 * object into the target.
 *
 * @param  {Object} target
 * @param  {Object} source
 */
function mixin(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) target[key] = source[key];
  }
}

// There should never be more than
// one instance of `FastDom` in an app
var exports = win.fastdom = (win.fastdom || new FastDom()); // jshint ignore:line

// Expose to CJS & AMD
if ((typeof define) == 'function') define(function() { return exports; });
else if ((typeof module) == 'object') module.exports = exports;

})( typeof window !== 'undefined' ? window : this);

},{}],635:[function(require,module,exports){
(function (process,Buffer){(function (){
'use strict';
function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var r = _interopDefault(require('restructure'));
var _Object$getOwnPropertyDescriptor = _interopDefault(require('babel-runtime/core-js/object/get-own-property-descriptor'));
var _getIterator = _interopDefault(require('babel-runtime/core-js/get-iterator'));
var _Object$freeze = _interopDefault(require('babel-runtime/core-js/object/freeze'));
var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Object$defineProperty = _interopDefault(require('babel-runtime/core-js/object/define-property'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _Map = _interopDefault(require('babel-runtime/core-js/map'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var restructure_src_utils = require('restructure/src/utils');
var _Object$defineProperties = _interopDefault(require('babel-runtime/core-js/object/define-properties'));
var isEqual = _interopDefault(require('deep-equal'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _String$fromCodePoint = _interopDefault(require('babel-runtime/core-js/string/from-code-point'));
var _Array$from = _interopDefault(require('babel-runtime/core-js/array/from'));
var _Set = _interopDefault(require('babel-runtime/core-js/set'));
var unicode = _interopDefault(require('unicode-properties'));
var UnicodeTrie = _interopDefault(require('unicode-trie'));
var StateMachine = _interopDefault(require('dfa'));
var _Number$EPSILON = _interopDefault(require('babel-runtime/core-js/number/epsilon'));
var cloneDeep = _interopDefault(require('clone'));
var inflate = _interopDefault(require('tiny-inflate'));
var brotli = _interopDefault(require('brotli/decompress'));
var fontkit = {};
fontkit.logErrors = false;
var formats = [];
fontkit.registerFormat = function (format) {
    formats.push(format);
};
fontkit.openSync = function (filename, postscriptName) {
    var buffer = fs.readFileSync(filename);
    return fontkit.create(buffer, postscriptName);
};
fontkit.open = function (filename, postscriptName, callback) {
    if (typeof postscriptName === 'function') {
        callback = postscriptName;
        postscriptName = null;
    }
    fs.readFile(filename, function (err, buffer) {
        if (err) {
            return callback(err);
        }
        try {
            var font = fontkit.create(buffer, postscriptName);
        } catch (e) {
            return callback(e);
        }
        return callback(null, font);
    });
    return;
};
fontkit.create = function (buffer, postscriptName) {
    for (var i = 0; i < formats.length; i++) {
        var format = formats[i];
        if (format.probe(buffer)) {
            var font = new format(new r.DecodeStream(buffer));
            if (postscriptName) {
                return font.getFont(postscriptName);
            }
            return font;
        }
    }
    throw new Error('Unknown font format');
};
fontkit.defaultLanguage = 'en';
fontkit.setDefaultLanguage = function () {
    var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    fontkit.defaultLanguage = lang;
};
function cache(target, key, descriptor) {
    if (descriptor.get) {
        var get = descriptor.get;
        descriptor.get = function () {
            var value = get.call(this);
            _Object$defineProperty(this, key, { value: value });
            return value;
        };
    } else if (typeof descriptor.value === 'function') {
        var fn = descriptor.value;
        return {
            get: function get() {
                var cache = new _Map();
                function memoized() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }
                    var key = args.length > 0 ? args[0] : 'value';
                    if (cache.has(key)) {
                        return cache.get(key);
                    }
                    var result = fn.apply(this, args);
                    cache.set(key, result);
                    return result;
                }
                ;
                _Object$defineProperty(this, key, { value: memoized });
                return memoized;
            }
        };
    }
}
var SubHeader = new r.Struct({
        firstCode: r.uint16,
        entryCount: r.uint16,
        idDelta: r.int16,
        idRangeOffset: r.uint16
    });
var CmapGroup = new r.Struct({
        startCharCode: r.uint32,
        endCharCode: r.uint32,
        glyphID: r.uint32
    });
var UnicodeValueRange = new r.Struct({
        startUnicodeValue: r.uint24,
        additionalCount: r.uint8
    });
var UVSMapping = new r.Struct({
        unicodeValue: r.uint24,
        glyphID: r.uint16
    });
var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);
var VarSelectorRecord = new r.Struct({
        varSelector: r.uint24,
        defaultUVS: new r.Pointer(r.uint32, DefaultUVS, { type: 'parent' }),
        nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, { type: 'parent' })
    });
var CmapSubtable = new r.VersionedStruct(r.uint16, {
        0: {
            length: r.uint16,
            language: r.uint16,
            codeMap: new r.LazyArray(r.uint8, 256)
        },
        2: {
            length: r.uint16,
            language: r.uint16,
            subHeaderKeys: new r.Array(r.uint16, 256),
            subHeaderCount: function subHeaderCount(t) {
                return Math.max.apply(Math, t.subHeaderKeys);
            },
            subHeaders: new r.LazyArray(SubHeader, 'subHeaderCount'),
            glyphIndexArray: new r.LazyArray(r.uint16, 'subHeaderCount')
        },
        4: {
            length: r.uint16,
            language: r.uint16,
            segCountX2: r.uint16,
            segCount: function segCount(t) {
                return t.segCountX2 >> 1;
            },
            searchRange: r.uint16,
            entrySelector: r.uint16,
            rangeShift: r.uint16,
            endCode: new r.LazyArray(r.uint16, 'segCount'),
            reservedPad: new r.Reserved(r.uint16),
            startCode: new r.LazyArray(r.uint16, 'segCount'),
            idDelta: new r.LazyArray(r.int16, 'segCount'),
            idRangeOffset: new r.LazyArray(r.uint16, 'segCount'),
            glyphIndexArray: new r.LazyArray(r.uint16, function (t) {
                return (t.length - t._currentOffset) / 2;
            })
        },
        6: {
            length: r.uint16,
            language: r.uint16,
            firstCode: r.uint16,
            entryCount: r.uint16,
            glyphIndices: new r.LazyArray(r.uint16, 'entryCount')
        },
        8: {
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint16,
            is32: new r.LazyArray(r.uint8, 8192),
            nGroups: r.uint32,
            groups: new r.LazyArray(CmapGroup, 'nGroups')
        },
        10: {
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint32,
            firstCode: r.uint32,
            entryCount: r.uint32,
            glyphIndices: new r.LazyArray(r.uint16, 'numChars')
        },
        12: {
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint32,
            nGroups: r.uint32,
            groups: new r.LazyArray(CmapGroup, 'nGroups')
        },
        13: {
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint32,
            nGroups: r.uint32,
            groups: new r.LazyArray(CmapGroup, 'nGroups')
        },
        14: {
            length: r.uint32,
            numRecords: r.uint32,
            varSelectors: new r.LazyArray(VarSelectorRecord, 'numRecords')
        }
    });
var CmapEntry = new r.Struct({
        platformID: r.uint16,
        encodingID: r.uint16,
        table: new r.Pointer(r.uint32, CmapSubtable, {
            type: 'parent',
            lazy: true
        })
    });
var cmap = new r.Struct({
        version: r.uint16,
        numSubtables: r.uint16,
        tables: new r.Array(CmapEntry, 'numSubtables')
    });
var head = new r.Struct({
        version: r.int32,
        revision: r.int32,
        checkSumAdjustment: r.uint32,
        magicNumber: r.uint32,
        flags: r.uint16,
        unitsPerEm: r.uint16,
        created: new r.Array(r.int32, 2),
        modified: new r.Array(r.int32, 2),
        xMin: r.int16,
        yMin: r.int16,
        xMax: r.int16,
        yMax: r.int16,
        macStyle: new r.Bitfield(r.uint16, [
            'bold',
            'italic',
            'underline',
            'outline',
            'shadow',
            'condensed',
            'extended'
        ]),
        lowestRecPPEM: r.uint16,
        fontDirectionHint: r.int16,
        indexToLocFormat: r.int16,
        glyphDataFormat: r.int16
    });
var hhea = new r.Struct({
        version: r.int32,
        ascent: r.int16,
        descent: r.int16,
        lineGap: r.int16,
        advanceWidthMax: r.uint16,
        minLeftSideBearing: r.int16,
        minRightSideBearing: r.int16,
        xMaxExtent: r.int16,
        caretSlopeRise: r.int16,
        caretSlopeRun: r.int16,
        caretOffset: r.int16,
        reserved: new r.Reserved(r.int16, 4),
        metricDataFormat: r.int16,
        numberOfMetrics: r.uint16
    });
var HmtxEntry = new r.Struct({
        advance: r.uint16,
        bearing: r.int16
    });
var hmtx = new r.Struct({
        metrics: new r.LazyArray(HmtxEntry, function (t) {
            return t.parent.hhea.numberOfMetrics;
        }),
        bearings: new r.LazyArray(r.int16, function (t) {
            return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
        })
    });
var maxp = new r.Struct({
        version: r.int32,
        numGlyphs: r.uint16,
        maxPoints: r.uint16,
        maxContours: r.uint16,
        maxComponentPoints: r.uint16,
        maxComponentContours: r.uint16,
        maxZones: r.uint16,
        maxTwilightPoints: r.uint16,
        maxStorage: r.uint16,
        maxFunctionDefs: r.uint16,
        maxInstructionDefs: r.uint16,
        maxStackElements: r.uint16,
        maxSizeOfInstructions: r.uint16,
        maxComponentElements: r.uint16,
        maxComponentDepth: r.uint16
    });
function getEncoding(platformID, encodingID) {
    var languageID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) {
        return MAC_LANGUAGE_ENCODINGS[languageID];
    }
    return ENCODINGS[platformID][encodingID];
}
var ENCODINGS = [
        [
            'utf16be',
            'utf16be',
            'utf16be',
            'utf16be',
            'utf16be',
            'utf16be'
        ],
        [
            'macroman',
            'shift-jis',
            'big5',
            'euc-kr',
            'iso-8859-6',
            'iso-8859-8',
            'macgreek',
            'maccyrillic',
            'symbol',
            'Devanagari',
            'Gurmukhi',
            'Gujarati',
            'Oriya',
            'Bengali',
            'Tamil',
            'Telugu',
            'Kannada',
            'Malayalam',
            'Sinhalese',
            'Burmese',
            'Khmer',
            'macthai',
            'Laotian',
            'Georgian',
            'Armenian',
            'gb-2312-80',
            'Tibetan',
            'Mongolian',
            'Geez',
            'maccenteuro',
            'Vietnamese',
            'Sindhi'
        ],
        ['ascii'],
        [
            'symbol',
            'utf16be',
            'shift-jis',
            'gb18030',
            'big5',
            'wansung',
            'johab',
            null,
            null,
            null,
            'utf16be'
        ]
    ];
var MAC_LANGUAGE_ENCODINGS = {
        15: 'maciceland',
        17: 'macturkish',
        18: 'maccroatian',
        24: 'maccenteuro',
        25: 'maccenteuro',
        26: 'maccenteuro',
        27: 'maccenteuro',
        28: 'maccenteuro',
        30: 'maciceland',
        37: 'macromania',
        38: 'maccenteuro',
        39: 'maccenteuro',
        40: 'maccenteuro',
        143: 'macinuit',
        146: 'macgaelic'
    };
var LANGUAGES = [
        [],
        {
            0: 'en',
            30: 'fo',
            60: 'ks',
            90: 'rw',
            1: 'fr',
            31: 'fa',
            61: 'ku',
            91: 'rn',
            2: 'de',
            32: 'ru',
            62: 'sd',
            92: 'ny',
            3: 'it',
            33: 'zh',
            63: 'bo',
            93: 'mg',
            4: 'nl',
            34: 'nl-BE',
            64: 'ne',
            94: 'eo',
            5: 'sv',
            35: 'ga',
            65: 'sa',
            128: 'cy',
            6: 'es',
            36: 'sq',
            66: 'mr',
            129: 'eu',
            7: 'da',
            37: 'ro',
            67: 'bn',
            130: 'ca',
            8: 'pt',
            38: 'cz',
            68: 'as',
            131: 'la',
            9: 'no',
            39: 'sk',
            69: 'gu',
            132: 'qu',
            10: 'he',
            40: 'si',
            70: 'pa',
            133: 'gn',
            11: 'ja',
            41: 'yi',
            71: 'or',
            134: 'ay',
            12: 'ar',
            42: 'sr',
            72: 'ml',
            135: 'tt',
            13: 'fi',
            43: 'mk',
            73: 'kn',
            136: 'ug',
            14: 'el',
            44: 'bg',
            74: 'ta',
            137: 'dz',
            15: 'is',
            45: 'uk',
            75: 'te',
            138: 'jv',
            16: 'mt',
            46: 'be',
            76: 'si',
            139: 'su',
            17: 'tr',
            47: 'uz',
            77: 'my',
            140: 'gl',
            18: 'hr',
            48: 'kk',
            78: 'km',
            141: 'af',
            19: 'zh-Hant',
            49: 'az-Cyrl',
            79: 'lo',
            142: 'br',
            20: 'ur',
            50: 'az-Arab',
            80: 'vi',
            143: 'iu',
            21: 'hi',
            51: 'hy',
            81: 'id',
            144: 'gd',
            22: 'th',
            52: 'ka',
            82: 'tl',
            145: 'gv',
            23: 'ko',
            53: 'mo',
            83: 'ms',
            146: 'ga',
            24: 'lt',
            54: 'ky',
            84: 'ms-Arab',
            147: 'to',
            25: 'pl',
            55: 'tg',
            85: 'am',
            148: 'el-polyton',
            26: 'hu',
            56: 'tk',
            86: 'ti',
            149: 'kl',
            27: 'es',
            57: 'mn-CN',
            87: 'om',
            150: 'az',
            28: 'lv',
            58: 'mn',
            88: 'so',
            151: 'nn',
            29: 'se',
            59: 'ps',
            89: 'sw'
        },
        [],
        {
            1078: 'af',
            16393: 'en-IN',
            1159: 'rw',
            1074: 'tn',
            1052: 'sq',
            6153: 'en-IE',
            1089: 'sw',
            1115: 'si',
            1156: 'gsw',
            8201: 'en-JM',
            1111: 'kok',
            1051: 'sk',
            1118: 'am',
            17417: 'en-MY',
            1042: 'ko',
            1060: 'sl',
            5121: 'ar-DZ',
            5129: 'en-NZ',
            1088: 'ky',
            11274: 'es-AR',
            15361: 'ar-BH',
            13321: 'en-PH',
            1108: 'lo',
            16394: 'es-BO',
            3073: 'ar',
            18441: 'en-SG',
            1062: 'lv',
            13322: 'es-CL',
            2049: 'ar-IQ',
            7177: 'en-ZA',
            1063: 'lt',
            9226: 'es-CO',
            11265: 'ar-JO',
            11273: 'en-TT',
            2094: 'dsb',
            5130: 'es-CR',
            13313: 'ar-KW',
            2057: 'en-GB',
            1134: 'lb',
            7178: 'es-DO',
            12289: 'ar-LB',
            1033: 'en',
            1071: 'mk',
            12298: 'es-EC',
            4097: 'ar-LY',
            12297: 'en-ZW',
            2110: 'ms-BN',
            17418: 'es-SV',
            6145: 'ary',
            1061: 'et',
            1086: 'ms',
            4106: 'es-GT',
            8193: 'ar-OM',
            1080: 'fo',
            1100: 'ml',
            18442: 'es-HN',
            16385: 'ar-QA',
            1124: 'fil',
            1082: 'mt',
            2058: 'es-MX',
            1025: 'ar-SA',
            1035: 'fi',
            1153: 'mi',
            19466: 'es-NI',
            10241: 'ar-SY',
            2060: 'fr-BE',
            1146: 'arn',
            6154: 'es-PA',
            7169: 'aeb',
            3084: 'fr-CA',
            1102: 'mr',
            15370: 'es-PY',
            14337: 'ar-AE',
            1036: 'fr',
            1148: 'moh',
            10250: 'es-PE',
            9217: 'ar-YE',
            5132: 'fr-LU',
            1104: 'mn',
            20490: 'es-PR',
            1067: 'hy',
            6156: 'fr-MC',
            2128: 'mn-CN',
            3082: 'es',
            1101: 'as',
            4108: 'fr-CH',
            1121: 'ne',
            1034: 'es',
            2092: 'az-Cyrl',
            1122: 'fy',
            1044: 'nb',
            21514: 'es-US',
            1068: 'az',
            1110: 'gl',
            2068: 'nn',
            14346: 'es-UY',
            1133: 'ba',
            1079: 'ka',
            1154: 'oc',
            8202: 'es-VE',
            1069: 'eu',
            3079: 'de-AT',
            1096: 'or',
            2077: 'sv-FI',
            1059: 'be',
            1031: 'de',
            1123: 'ps',
            1053: 'sv',
            2117: 'bn',
            5127: 'de-LI',
            1045: 'pl',
            1114: 'syr',
            1093: 'bn-IN',
            4103: 'de-LU',
            1046: 'pt',
            1064: 'tg',
            8218: 'bs-Cyrl',
            2055: 'de-CH',
            2070: 'pt-PT',
            2143: 'tzm',
            5146: 'bs',
            1032: 'el',
            1094: 'pa',
            1097: 'ta',
            1150: 'br',
            1135: 'kl',
            1131: 'qu-BO',
            1092: 'tt',
            1026: 'bg',
            1095: 'gu',
            2155: 'qu-EC',
            1098: 'te',
            1027: 'ca',
            1128: 'ha',
            3179: 'qu',
            1054: 'th',
            3076: 'zh-HK',
            1037: 'he',
            1048: 'ro',
            1105: 'bo',
            5124: 'zh-MO',
            1081: 'hi',
            1047: 'rm',
            1055: 'tr',
            2052: 'zh',
            1038: 'hu',
            1049: 'ru',
            1090: 'tk',
            4100: 'zh-SG',
            1039: 'is',
            9275: 'smn',
            1152: 'ug',
            1028: 'zh-TW',
            1136: 'ig',
            4155: 'smj-NO',
            1058: 'uk',
            1155: 'co',
            1057: 'id',
            5179: 'smj',
            1070: 'hsb',
            1050: 'hr',
            1117: 'iu',
            3131: 'se-FI',
            1056: 'ur',
            4122: 'hr-BA',
            2141: 'iu-Latn',
            1083: 'se',
            2115: 'uz-Cyrl',
            1029: 'cs',
            2108: 'ga',
            2107: 'se-SE',
            1091: 'uz',
            1030: 'da',
            1076: 'xh',
            8251: 'sms',
            1066: 'vi',
            1164: 'prs',
            1077: 'zu',
            6203: 'sma-NO',
            1106: 'cy',
            1125: 'dv',
            1040: 'it',
            7227: 'sms',
            1160: 'wo',
            2067: 'nl-BE',
            2064: 'it-CH',
            1103: 'sa',
            1157: 'sah',
            1043: 'nl',
            1041: 'ja',
            7194: 'sr-Cyrl-BA',
            1144: 'ii',
            3081: 'en-AU',
            1099: 'kn',
            3098: 'sr',
            1130: 'yo',
            10249: 'en-BZ',
            1087: 'kk',
            6170: 'sr-Latn-BA',
            4105: 'en-CA',
            1107: 'km',
            2074: 'sr-Latn',
            9225: 'en-029',
            1158: 'quc',
            1132: 'nso'
        }
    ];
var NameRecord = new r.Struct({
        platformID: r.uint16,
        encodingID: r.uint16,
        languageID: r.uint16,
        nameID: r.uint16,
        length: r.uint16,
        string: new r.Pointer(r.uint16, new r.String('length', function (t) {
            return getEncoding(t.platformID, t.encodingID, t.languageID);
        }), {
            type: 'parent',
            relativeTo: 'parent.stringOffset',
            allowNull: false
        })
    });
var LangTagRecord = new r.Struct({
        length: r.uint16,
        tag: new r.Pointer(r.uint16, new r.String('length', 'utf16be'), {
            type: 'parent',
            relativeTo: 'stringOffset'
        })
    });
var NameTable = new r.VersionedStruct(r.uint16, {
        0: {
            count: r.uint16,
            stringOffset: r.uint16,
            records: new r.Array(NameRecord, 'count')
        },
        1: {
            count: r.uint16,
            stringOffset: r.uint16,
            records: new r.Array(NameRecord, 'count'),
            langTagCount: r.uint16,
            langTags: new r.Array(LangTagRecord, 'langTagCount')
        }
    });
var NAMES = [
        'copyright',
        'fontFamily',
        'fontSubfamily',
        'uniqueSubfamily',
        'fullName',
        'version',
        'postscriptName',
        'trademark',
        'manufacturer',
        'designer',
        'description',
        'vendorURL',
        'designerURL',
        'license',
        'licenseURL',
        null,
        'preferredFamily',
        'preferredSubfamily',
        'compatibleFull',
        'sampleText',
        'postscriptCIDFontName',
        'wwsFamilyName',
        'wwsSubfamilyName'
    ];
NameTable.process = function (stream) {
    var records = {};
    for (var _iterator = this.records, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length)
                break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done)
                break;
            _ref = _i.value;
        }
        var record = _ref;
        var language = LANGUAGES[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 32768) {
            language = this.langTags[record.languageID - 32768].tag;
        }
        if (language == null) {
            language = record.platformID + '-' + record.languageID;
        }
        var key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;
        if (records[key] == null) {
            records[key] = {};
        }
        var obj = records[key];
        if (record.nameID >= 256) {
            obj = obj[record.nameID] || (obj[record.nameID] = {});
        }
        if (typeof record.string === 'string' || typeof obj[language] !== 'string') {
            obj[language] = record.string;
        }
    }
    this.records = records;
};
NameTable.preEncode = function () {
    if (Array.isArray(this.records))
        return;
    this.version = 0;
    var records = [];
    for (var key in this.records) {
        var val = this.records[key];
        if (key === 'fontFeatures')
            continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 1033,
            nameID: NAMES.indexOf(key),
            length: Buffer.byteLength(val.en, 'utf16le'),
            string: val.en
        });
        if (key === 'postscriptName') {
            records.push({
                platformID: 1,
                encodingID: 0,
                languageID: 0,
                nameID: NAMES.indexOf(key),
                length: val.en.length,
                string: val.en
            });
        }
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = NameTable.size(this, null, false);
};
var OS2 = new r.VersionedStruct(r.uint16, {
        header: {
            xAvgCharWidth: r.int16,
            usWeightClass: r.uint16,
            usWidthClass: r.uint16,
            fsType: new r.Bitfield(r.uint16, [
                null,
                'noEmbedding',
                'viewOnly',
                'editable',
                null,
                null,
                null,
                null,
                'noSubsetting',
                'bitmapOnly'
            ]),
            ySubscriptXSize: r.int16,
            ySubscriptYSize: r.int16,
            ySubscriptXOffset: r.int16,
            ySubscriptYOffset: r.int16,
            ySuperscriptXSize: r.int16,
            ySuperscriptYSize: r.int16,
            ySuperscriptXOffset: r.int16,
            ySuperscriptYOffset: r.int16,
            yStrikeoutSize: r.int16,
            yStrikeoutPosition: r.int16,
            sFamilyClass: r.int16,
            panose: new r.Array(r.uint8, 10),
            ulCharRange: new r.Array(r.uint32, 4),
            vendorID: new r.String(4),
            fsSelection: new r.Bitfield(r.uint16, [
                'italic',
                'underscore',
                'negative',
                'outlined',
                'strikeout',
                'bold',
                'regular',
                'useTypoMetrics',
                'wws',
                'oblique'
            ]),
            usFirstCharIndex: r.uint16,
            usLastCharIndex: r.uint16
        },
        0: {},
        1: {
            typoAscender: r.int16,
            typoDescender: r.int16,
            typoLineGap: r.int16,
            winAscent: r.uint16,
            winDescent: r.uint16,
            codePageRange: new r.Array(r.uint32, 2)
        },
        2: {
            typoAscender: r.int16,
            typoDescender: r.int16,
            typoLineGap: r.int16,
            winAscent: r.uint16,
            winDescent: r.uint16,
            codePageRange: new r.Array(r.uint32, 2),
            xHeight: r.int16,
            capHeight: r.int16,
            defaultChar: r.uint16,
            breakChar: r.uint16,
            maxContent: r.uint16
        },
        5: {
            typoAscender: r.int16,
            typoDescender: r.int16,
            typoLineGap: r.int16,
            winAscent: r.uint16,
            winDescent: r.uint16,
            codePageRange: new r.Array(r.uint32, 2),
            xHeight: r.int16,
            capHeight: r.int16,
            defaultChar: r.uint16,
            breakChar: r.uint16,
            maxContent: r.uint16,
            usLowerOpticalPointSize: r.uint16,
            usUpperOpticalPointSize: r.uint16
        }
    });
var versions = OS2.versions;
versions[3] = versions[4] = versions[2];
var post = new r.VersionedStruct(r.fixed32, {
        header: {
            italicAngle: r.fixed32,
            underlinePosition: r.int16,
            underlineThickness: r.int16,
            isFixedPitch: r.uint32,
            minMemType42: r.uint32,
            maxMemType42: r.uint32,
            minMemType1: r.uint32,
            maxMemType1: r.uint32
        },
        1: {},
        2: {
            numberOfGlyphs: r.uint16,
            glyphNameIndex: new r.Array(r.uint16, 'numberOfGlyphs'),
            names: new r.Array(new r.String(r.uint8))
        },
        2.5: {
            numberOfGlyphs: r.uint16,
            offsets: new r.Array(r.uint8, 'numberOfGlyphs')
        },
        3: {},
        4: {
            map: new r.Array(r.uint32, function (t) {
                return t.parent.maxp.numGlyphs;
            })
        }
    });
var cvt = new r.Struct({ controlValues: new r.Array(r.int16) });
var fpgm = new r.Struct({ instructions: new r.Array(r.uint8) });
var loca = new r.VersionedStruct('head.indexToLocFormat', {
        0: { offsets: new r.Array(r.uint16) },
        1: { offsets: new r.Array(r.uint32) }
    });
loca.process = function () {
    if (this.version === 0) {
        for (var i = 0; i < this.offsets.length; i++) {
            this.offsets[i] <<= 1;
        }
    }
};
loca.preEncode = function () {
    if (this.version === 0) {
        for (var i = 0; i < this.offsets.length; i++) {
            this.offsets[i] >>>= 1;
        }
    }
};
var prep = new r.Struct({ controlValueProgram: new r.Array(r.uint8) });
var glyf = new r.Array(new r.Buffer());
var CFFIndex = function () {
        function CFFIndex(type) {
            _classCallCheck(this, CFFIndex);
            this.type = type;
        }
        CFFIndex.prototype.getCFFVersion = function getCFFVersion(ctx) {
            while (ctx && !ctx.hdrSize) {
                ctx = ctx.parent;
            }
            return ctx ? ctx.version : -1;
        };
        CFFIndex.prototype.decode = function decode(stream, parent) {
            var version = this.getCFFVersion(parent);
            var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
            if (count === 0) {
                return [];
            }
            var offSize = stream.readUInt8();
            var offsetType = void 0;
            if (offSize === 1) {
                offsetType = r.uint8;
            } else if (offSize === 2) {
                offsetType = r.uint16;
            } else if (offSize === 3) {
                offsetType = r.uint24;
            } else if (offSize === 4) {
                offsetType = r.uint32;
            } else {
                throw new Error('Bad offset size in CFFIndex: ' + offSize + ' ' + stream.pos);
            }
            var ret = [];
            var startPos = stream.pos + (count + 1) * offSize - 1;
            var start = offsetType.decode(stream);
            for (var i = 0; i < count; i++) {
                var end = offsetType.decode(stream);
                if (this.type != null) {
                    var pos = stream.pos;
                    stream.pos = startPos + start;
                    parent.length = end - start;
                    ret.push(this.type.decode(stream, parent));
                    stream.pos = pos;
                } else {
                    ret.push({
                        offset: startPos + start,
                        length: end - start
                    });
                }
                start = end;
            }
            stream.pos = startPos + start;
            return ret;
        };
        CFFIndex.prototype.size = function size(arr, parent) {
            var size = 2;
            if (arr.length === 0) {
                return size;
            }
            var type = this.type || new r.Buffer();
            var offset = 1;
            for (var i = 0; i < arr.length; i++) {
                var item = arr[i];
                offset += type.size(item, parent);
            }
            var offsetType = void 0;
            if (offset <= 255) {
                offsetType = r.uint8;
            } else if (offset <= 65535) {
                offsetType = r.uint16;
            } else if (offset <= 16777215) {
                offsetType = r.uint24;
            } else if (offset <= 4294967295) {
                offsetType = r.uint32;
            } else {
                throw new Error('Bad offset in CFFIndex');
            }
            size += 1 + offsetType.size() * (arr.length + 1);
            size += offset - 1;
            return size;
        };
        CFFIndex.prototype.encode = function encode(stream, arr, parent) {
            stream.writeUInt16BE(arr.length);
            if (arr.length === 0) {
                return;
            }
            var type = this.type || new r.Buffer();
            var sizes = [];
            var offset = 1;
            for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var item = _ref;
                var s = type.size(item, parent);
                sizes.push(s);
                offset += s;
            }
            var offsetType = void 0;
            if (offset <= 255) {
                offsetType = r.uint8;
            } else if (offset <= 65535) {
                offsetType = r.uint16;
            } else if (offset <= 16777215) {
                offsetType = r.uint24;
            } else if (offset <= 4294967295) {
                offsetType = r.uint32;
            } else {
                throw new Error('Bad offset in CFFIndex');
            }
            stream.writeUInt8(offsetType.size());
            offset = 1;
            offsetType.encode(stream, offset);
            for (var _iterator2 = sizes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var size = _ref2;
                offset += size;
                offsetType.encode(stream, offset);
            }
            for (var _iterator3 = arr, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length)
                        break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done)
                        break;
                    _ref3 = _i3.value;
                }
                var _item = _ref3;
                type.encode(stream, _item, parent);
            }
            return;
        };
        return CFFIndex;
    }();
var FLOAT_EOF = 15;
var FLOAT_LOOKUP = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '.',
        'E',
        'E-',
        null,
        '-'
    ];
var FLOAT_ENCODE_LOOKUP = {
        '.': 10,
        'E': 11,
        'E-': 12,
        '-': 14
    };
var CFFOperand = function () {
        function CFFOperand() {
            _classCallCheck(this, CFFOperand);
        }
        CFFOperand.decode = function decode(stream, value) {
            if (32 <= value && value <= 246) {
                return value - 139;
            }
            if (247 <= value && value <= 250) {
                return (value - 247) * 256 + stream.readUInt8() + 108;
            }
            if (251 <= value && value <= 254) {
                return -(value - 251) * 256 - stream.readUInt8() - 108;
            }
            if (value === 28) {
                return stream.readInt16BE();
            }
            if (value === 29) {
                return stream.readInt32BE();
            }
            if (value === 30) {
                var str = '';
                while (true) {
                    var b = stream.readUInt8();
                    var n1 = b >> 4;
                    if (n1 === FLOAT_EOF) {
                        break;
                    }
                    str += FLOAT_LOOKUP[n1];
                    var n2 = b & 15;
                    if (n2 === FLOAT_EOF) {
                        break;
                    }
                    str += FLOAT_LOOKUP[n2];
                }
                return parseFloat(str);
            }
            return null;
        };
        CFFOperand.size = function size(value) {
            if (value.forceLarge) {
                value = 32768;
            }
            if ((value | 0) !== value) {
                var str = '' + value;
                return 1 + Math.ceil((str.length + 1) / 2);
            } else if (-107 <= value && value <= 107) {
                return 1;
            } else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) {
                return 2;
            } else if (-32768 <= value && value <= 32767) {
                return 3;
            } else {
                return 5;
            }
        };
        CFFOperand.encode = function encode(stream, value) {
            var val = Number(value);
            if (value.forceLarge) {
                stream.writeUInt8(29);
                return stream.writeInt32BE(val);
            } else if ((val | 0) !== val) {
                stream.writeUInt8(30);
                var str = '' + val;
                for (var i = 0; i < str.length; i += 2) {
                    var c1 = str[i];
                    var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;
                    if (i === str.length - 1) {
                        var n2 = FLOAT_EOF;
                    } else {
                        var c2 = str[i + 1];
                        var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
                    }
                    stream.writeUInt8(n1 << 4 | n2 & 15);
                }
                if (n2 !== FLOAT_EOF) {
                    return stream.writeUInt8(FLOAT_EOF << 4);
                }
            } else if (-107 <= val && val <= 107) {
                return stream.writeUInt8(val + 139);
            } else if (108 <= val && val <= 1131) {
                val -= 108;
                stream.writeUInt8((val >> 8) + 247);
                return stream.writeUInt8(val & 255);
            } else if (-1131 <= val && val <= -108) {
                val = -val - 108;
                stream.writeUInt8((val >> 8) + 251);
                return stream.writeUInt8(val & 255);
            } else if (-32768 <= val && val <= 32767) {
                stream.writeUInt8(28);
                return stream.writeInt16BE(val);
            } else {
                stream.writeUInt8(29);
                return stream.writeInt32BE(val);
            }
        };
        return CFFOperand;
    }();
var CFFDict = function () {
        function CFFDict() {
            var ops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            _classCallCheck(this, CFFDict);
            this.ops = ops;
            this.fields = {};
            for (var _iterator = ops, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var field = _ref;
                var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
                this.fields[key] = field;
            }
        }
        CFFDict.prototype.decodeOperands = function decodeOperands(type, stream, ret, operands) {
            var _this = this;
            if (Array.isArray(type)) {
                return operands.map(function (op, i) {
                    return _this.decodeOperands(type[i], stream, ret, [op]);
                });
            } else if (type.decode != null) {
                return type.decode(stream, ret, operands);
            } else {
                switch (type) {
                case 'number':
                case 'offset':
                case 'sid':
                    return operands[0];
                case 'boolean':
                    return !!operands[0];
                default:
                    return operands;
                }
            }
        };
        CFFDict.prototype.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
            var _this2 = this;
            if (Array.isArray(type)) {
                return operands.map(function (op, i) {
                    return _this2.encodeOperands(type[i], stream, ctx, op)[0];
                });
            } else if (type.encode != null) {
                return type.encode(stream, operands, ctx);
            } else if (typeof operands === 'number') {
                return [operands];
            } else if (typeof operands === 'boolean') {
                return [+operands];
            } else if (Array.isArray(operands)) {
                return operands;
            } else {
                return [operands];
            }
        };
        CFFDict.prototype.decode = function decode(stream, parent) {
            var end = stream.pos + parent.length;
            var ret = {};
            var operands = [];
            _Object$defineProperties(ret, {
                parent: { value: parent },
                _startOffset: { value: stream.pos }
            });
            for (var key in this.fields) {
                var field = this.fields[key];
                ret[field[1]] = field[3];
            }
            while (stream.pos < end) {
                var b = stream.readUInt8();
                if (b < 28) {
                    if (b === 12) {
                        b = b << 8 | stream.readUInt8();
                    }
                    var _field = this.fields[b];
                    if (!_field) {
                        throw new Error('Unknown operator ' + b);
                    }
                    var val = this.decodeOperands(_field[2], stream, ret, operands);
                    if (val != null) {
                        if (val instanceof restructure_src_utils.PropertyDescriptor) {
                            _Object$defineProperty(ret, _field[1], val);
                        } else {
                            ret[_field[1]] = val;
                        }
                    }
                    operands = [];
                } else {
                    operands.push(CFFOperand.decode(stream, b));
                }
            }
            return ret;
        };
        CFFDict.prototype.size = function size(dict, parent) {
            var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var ctx = {
                    parent: parent,
                    val: dict,
                    pointerSize: 0,
                    startOffset: parent.startOffset || 0
                };
            var len = 0;
            for (var k in this.fields) {
                var field = this.fields[k];
                var val = dict[field[1]];
                if (val == null || isEqual(val, field[3])) {
                    continue;
                }
                var operands = this.encodeOperands(field[2], null, ctx, val);
                for (var _iterator2 = operands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length)
                            break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done)
                            break;
                        _ref2 = _i2.value;
                    }
                    var op = _ref2;
                    len += CFFOperand.size(op);
                }
                var key = Array.isArray(field[0]) ? field[0] : [field[0]];
                len += key.length;
            }
            if (includePointers) {
                len += ctx.pointerSize;
            }
            return len;
        };
        CFFDict.prototype.encode = function encode(stream, dict, parent) {
            var ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: dict,
                    pointerSize: 0
                };
            ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
            for (var _iterator3 = this.ops, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length)
                        break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done)
                        break;
                    _ref3 = _i3.value;
                }
                var field = _ref3;
                var val = dict[field[1]];
                if (val == null || isEqual(val, field[3])) {
                    continue;
                }
                var operands = this.encodeOperands(field[2], stream, ctx, val);
                for (var _iterator4 = operands, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
                    var _ref4;
                    if (_isArray4) {
                        if (_i4 >= _iterator4.length)
                            break;
                        _ref4 = _iterator4[_i4++];
                    } else {
                        _i4 = _iterator4.next();
                        if (_i4.done)
                            break;
                        _ref4 = _i4.value;
                    }
                    var op = _ref4;
                    CFFOperand.encode(stream, op);
                }
                var key = Array.isArray(field[0]) ? field[0] : [field[0]];
                for (var _iterator5 = key, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
                    var _ref5;
                    if (_isArray5) {
                        if (_i5 >= _iterator5.length)
                            break;
                        _ref5 = _iterator5[_i5++];
                    } else {
                        _i5 = _iterator5.next();
                        if (_i5.done)
                            break;
                        _ref5 = _i5.value;
                    }
                    var _op = _ref5;
                    stream.writeUInt8(_op);
                }
            }
            var i = 0;
            while (i < ctx.pointers.length) {
                var ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
            return;
        };
        return CFFDict;
    }();
var CFFPointer = function (_r$Pointer) {
        _inherits(CFFPointer, _r$Pointer);
        function CFFPointer(type) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, CFFPointer);
            if (options.type == null) {
                options.type = 'global';
            }
            return _possibleConstructorReturn(this, _r$Pointer.call(this, null, type, options));
        }
        CFFPointer.prototype.decode = function decode(stream, parent, operands) {
            this.offsetType = {
                decode: function decode() {
                    return operands[0];
                }
            };
            return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
        };
        CFFPointer.prototype.encode = function encode(stream, value, ctx) {
            if (!stream) {
                this.offsetType = {
                    size: function size() {
                        return 0;
                    }
                };
                this.size(value, ctx);
                return [new Ptr(0)];
            }
            var ptr = null;
            this.offsetType = {
                encode: function encode(stream, val) {
                    return ptr = val;
                }
            };
            _r$Pointer.prototype.encode.call(this, stream, value, ctx);
            return [new Ptr(ptr)];
        };
        return CFFPointer;
    }(r.Pointer);
var Ptr = function () {
        function Ptr(val) {
            _classCallCheck(this, Ptr);
            this.val = val;
            this.forceLarge = true;
        }
        Ptr.prototype.valueOf = function valueOf() {
            return this.val;
        };
        return Ptr;
    }();
var CFFBlendOp = function () {
        function CFFBlendOp() {
            _classCallCheck(this, CFFBlendOp);
        }
        CFFBlendOp.decode = function decode(stream, parent, operands) {
            var numBlends = operands.pop();
            while (operands.length > numBlends) {
                operands.pop();
            }
        };
        return CFFBlendOp;
    }();
var CFFPrivateDict = new CFFDict([
        [
            6,
            'BlueValues',
            'delta',
            null
        ],
        [
            7,
            'OtherBlues',
            'delta',
            null
        ],
        [
            8,
            'FamilyBlues',
            'delta',
            null
        ],
        [
            9,
            'FamilyOtherBlues',
            'delta',
            null
        ],
        [
            [
                12,
                9
            ],
            'BlueScale',
            'number',
            0.039625
        ],
        [
            [
                12,
                10
            ],
            'BlueShift',
            'number',
            7
        ],
        [
            [
                12,
                11
            ],
            'BlueFuzz',
            'number',
            1
        ],
        [
            10,
            'StdHW',
            'number',
            null
        ],
        [
            11,
            'StdVW',
            'number',
            null
        ],
        [
            [
                12,
                12
            ],
            'StemSnapH',
            'delta',
            null
        ],
        [
            [
                12,
                13
            ],
            'StemSnapV',
            'delta',
            null
        ],
        [
            [
                12,
                14
            ],
            'ForceBold',
            'boolean',
            false
        ],
        [
            [
                12,
                17
            ],
            'LanguageGroup',
            'number',
            0
        ],
        [
            [
                12,
                18
            ],
            'ExpansionFactor',
            'number',
            0.06
        ],
        [
            [
                12,
                19
            ],
            'initialRandomSeed',
            'number',
            0
        ],
        [
            20,
            'defaultWidthX',
            'number',
            0
        ],
        [
            21,
            'nominalWidthX',
            'number',
            0
        ],
        [
            22,
            'vsindex',
            'number',
            0
        ],
        [
            23,
            'blend',
            CFFBlendOp,
            null
        ],
        [
            19,
            'Subrs',
            new CFFPointer(new CFFIndex(), { type: 'local' }),
            null
        ]
    ]);
var standardStrings = [
        '.notdef',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quoteright',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'quoteleft',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        'exclamdown',
        'cent',
        'sterling',
        'fraction',
        'yen',
        'florin',
        'section',
        'currency',
        'quotesingle',
        'quotedblleft',
        'guillemotleft',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        'endash',
        'dagger',
        'daggerdbl',
        'periodcentered',
        'paragraph',
        'bullet',
        'quotesinglbase',
        'quotedblbase',
        'quotedblright',
        'guillemotright',
        'ellipsis',
        'perthousand',
        'questiondown',
        'grave',
        'acute',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'dieresis',
        'ring',
        'cedilla',
        'hungarumlaut',
        'ogonek',
        'caron',
        'emdash',
        'AE',
        'ordfeminine',
        'Lslash',
        'Oslash',
        'OE',
        'ordmasculine',
        'ae',
        'dotlessi',
        'lslash',
        'oslash',
        'oe',
        'germandbls',
        'onesuperior',
        'logicalnot',
        'mu',
        'trademark',
        'Eth',
        'onehalf',
        'plusminus',
        'Thorn',
        'onequarter',
        'divide',
        'brokenbar',
        'degree',
        'thorn',
        'threequarters',
        'twosuperior',
        'registered',
        'minus',
        'eth',
        'multiply',
        'threesuperior',
        'copyright',
        'Aacute',
        'Acircumflex',
        'Adieresis',
        'Agrave',
        'Aring',
        'Atilde',
        'Ccedilla',
        'Eacute',
        'Ecircumflex',
        'Edieresis',
        'Egrave',
        'Iacute',
        'Icircumflex',
        'Idieresis',
        'Igrave',
        'Ntilde',
        'Oacute',
        'Ocircumflex',
        'Odieresis',
        'Ograve',
        'Otilde',
        'Scaron',
        'Uacute',
        'Ucircumflex',
        'Udieresis',
        'Ugrave',
        'Yacute',
        'Ydieresis',
        'Zcaron',
        'aacute',
        'acircumflex',
        'adieresis',
        'agrave',
        'aring',
        'atilde',
        'ccedilla',
        'eacute',
        'ecircumflex',
        'edieresis',
        'egrave',
        'iacute',
        'icircumflex',
        'idieresis',
        'igrave',
        'ntilde',
        'oacute',
        'ocircumflex',
        'odieresis',
        'ograve',
        'otilde',
        'scaron',
        'uacute',
        'ucircumflex',
        'udieresis',
        'ugrave',
        'yacute',
        'ydieresis',
        'zcaron',
        'exclamsmall',
        'Hungarumlautsmall',
        'dollaroldstyle',
        'dollarsuperior',
        'ampersandsmall',
        'Acutesmall',
        'parenleftsuperior',
        'parenrightsuperior',
        'twodotenleader',
        'onedotenleader',
        'zerooldstyle',
        'oneoldstyle',
        'twooldstyle',
        'threeoldstyle',
        'fouroldstyle',
        'fiveoldstyle',
        'sixoldstyle',
        'sevenoldstyle',
        'eightoldstyle',
        'nineoldstyle',
        'commasuperior',
        'threequartersemdash',
        'periodsuperior',
        'questionsmall',
        'asuperior',
        'bsuperior',
        'centsuperior',
        'dsuperior',
        'esuperior',
        'isuperior',
        'lsuperior',
        'msuperior',
        'nsuperior',
        'osuperior',
        'rsuperior',
        'ssuperior',
        'tsuperior',
        'ff',
        'ffi',
        'ffl',
        'parenleftinferior',
        'parenrightinferior',
        'Circumflexsmall',
        'hyphensuperior',
        'Gravesmall',
        'Asmall',
        'Bsmall',
        'Csmall',
        'Dsmall',
        'Esmall',
        'Fsmall',
        'Gsmall',
        'Hsmall',
        'Ismall',
        'Jsmall',
        'Ksmall',
        'Lsmall',
        'Msmall',
        'Nsmall',
        'Osmall',
        'Psmall',
        'Qsmall',
        'Rsmall',
        'Ssmall',
        'Tsmall',
        'Usmall',
        'Vsmall',
        'Wsmall',
        'Xsmall',
        'Ysmall',
        'Zsmall',
        'colonmonetary',
        'onefitted',
        'rupiah',
        'Tildesmall',
        'exclamdownsmall',
        'centoldstyle',
        'Lslashsmall',
        'Scaronsmall',
        'Zcaronsmall',
        'Dieresissmall',
        'Brevesmall',
        'Caronsmall',
        'Dotaccentsmall',
        'Macronsmall',
        'figuredash',
        'hypheninferior',
        'Ogoneksmall',
        'Ringsmall',
        'Cedillasmall',
        'questiondownsmall',
        'oneeighth',
        'threeeighths',
        'fiveeighths',
        'seveneighths',
        'onethird',
        'twothirds',
        'zerosuperior',
        'foursuperior',
        'fivesuperior',
        'sixsuperior',
        'sevensuperior',
        'eightsuperior',
        'ninesuperior',
        'zeroinferior',
        'oneinferior',
        'twoinferior',
        'threeinferior',
        'fourinferior',
        'fiveinferior',
        'sixinferior',
        'seveninferior',
        'eightinferior',
        'nineinferior',
        'centinferior',
        'dollarinferior',
        'periodinferior',
        'commainferior',
        'Agravesmall',
        'Aacutesmall',
        'Acircumflexsmall',
        'Atildesmall',
        'Adieresissmall',
        'Aringsmall',
        'AEsmall',
        'Ccedillasmall',
        'Egravesmall',
        'Eacutesmall',
        'Ecircumflexsmall',
        'Edieresissmall',
        'Igravesmall',
        'Iacutesmall',
        'Icircumflexsmall',
        'Idieresissmall',
        'Ethsmall',
        'Ntildesmall',
        'Ogravesmall',
        'Oacutesmall',
        'Ocircumflexsmall',
        'Otildesmall',
        'Odieresissmall',
        'OEsmall',
        'Oslashsmall',
        'Ugravesmall',
        'Uacutesmall',
        'Ucircumflexsmall',
        'Udieresissmall',
        'Yacutesmall',
        'Thornsmall',
        'Ydieresissmall',
        '001.000',
        '001.001',
        '001.002',
        '001.003',
        'Black',
        'Bold',
        'Book',
        'Light',
        'Medium',
        'Regular',
        'Roman',
        'Semibold'
    ];
var StandardEncoding = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quoteright',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'quoteleft',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'exclamdown',
        'cent',
        'sterling',
        'fraction',
        'yen',
        'florin',
        'section',
        'currency',
        'quotesingle',
        'quotedblleft',
        'guillemotleft',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        '',
        'endash',
        'dagger',
        'daggerdbl',
        'periodcentered',
        '',
        'paragraph',
        'bullet',
        'quotesinglbase',
        'quotedblbase',
        'quotedblright',
        'guillemotright',
        'ellipsis',
        'perthousand',
        '',
        'questiondown',
        '',
        'grave',
        'acute',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'dieresis',
        '',
        'ring',
        'cedilla',
        '',
        'hungarumlaut',
        'ogonek',
        'caron',
        'emdash',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'AE',
        '',
        'ordfeminine',
        '',
        '',
        '',
        '',
        'Lslash',
        'Oslash',
        'OE',
        'ordmasculine',
        '',
        '',
        '',
        '',
        '',
        'ae',
        '',
        '',
        '',
        'dotlessi',
        '',
        '',
        'lslash',
        'oslash',
        'oe',
        'germandbls'
    ];
var ExpertEncoding = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'space',
        'exclamsmall',
        'Hungarumlautsmall',
        '',
        'dollaroldstyle',
        'dollarsuperior',
        'ampersandsmall',
        'Acutesmall',
        'parenleftsuperior',
        'parenrightsuperior',
        'twodotenleader',
        'onedotenleader',
        'comma',
        'hyphen',
        'period',
        'fraction',
        'zerooldstyle',
        'oneoldstyle',
        'twooldstyle',
        'threeoldstyle',
        'fouroldstyle',
        'fiveoldstyle',
        'sixoldstyle',
        'sevenoldstyle',
        'eightoldstyle',
        'nineoldstyle',
        'colon',
        'semicolon',
        'commasuperior',
        'threequartersemdash',
        'periodsuperior',
        'questionsmall',
        '',
        'asuperior',
        'bsuperior',
        'centsuperior',
        'dsuperior',
        'esuperior',
        '',
        '',
        'isuperior',
        '',
        '',
        'lsuperior',
        'msuperior',
        'nsuperior',
        'osuperior',
        '',
        '',
        'rsuperior',
        'ssuperior',
        'tsuperior',
        '',
        'ff',
        'fi',
        'fl',
        'ffi',
        'ffl',
        'parenleftinferior',
        '',
        'parenrightinferior',
        'Circumflexsmall',
        'hyphensuperior',
        'Gravesmall',
        'Asmall',
        'Bsmall',
        'Csmall',
        'Dsmall',
        'Esmall',
        'Fsmall',
        'Gsmall',
        'Hsmall',
        'Ismall',
        'Jsmall',
        'Ksmall',
        'Lsmall',
        'Msmall',
        'Nsmall',
        'Osmall',
        'Psmall',
        'Qsmall',
        'Rsmall',
        'Ssmall',
        'Tsmall',
        'Usmall',
        'Vsmall',
        'Wsmall',
        'Xsmall',
        'Ysmall',
        'Zsmall',
        'colonmonetary',
        'onefitted',
        'rupiah',
        'Tildesmall',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'exclamdownsmall',
        'centoldstyle',
        'Lslashsmall',
        '',
        '',
        'Scaronsmall',
        'Zcaronsmall',
        'Dieresissmall',
        'Brevesmall',
        'Caronsmall',
        '',
        'Dotaccentsmall',
        '',
        '',
        'Macronsmall',
        '',
        '',
        'figuredash',
        'hypheninferior',
        '',
        '',
        'Ogoneksmall',
        'Ringsmall',
        'Cedillasmall',
        '',
        '',
        '',
        'onequarter',
        'onehalf',
        'threequarters',
        'questiondownsmall',
        'oneeighth',
        'threeeighths',
        'fiveeighths',
        'seveneighths',
        'onethird',
        'twothirds',
        '',
        '',
        'zerosuperior',
        'onesuperior',
        'twosuperior',
        'threesuperior',
        'foursuperior',
        'fivesuperior',
        'sixsuperior',
        'sevensuperior',
        'eightsuperior',
        'ninesuperior',
        'zeroinferior',
        'oneinferior',
        'twoinferior',
        'threeinferior',
        'fourinferior',
        'fiveinferior',
        'sixinferior',
        'seveninferior',
        'eightinferior',
        'nineinferior',
        'centinferior',
        'dollarinferior',
        'periodinferior',
        'commainferior',
        'Agravesmall',
        'Aacutesmall',
        'Acircumflexsmall',
        'Atildesmall',
        'Adieresissmall',
        'Aringsmall',
        'AEsmall',
        'Ccedillasmall',
        'Egravesmall',
        'Eacutesmall',
        'Ecircumflexsmall',
        'Edieresissmall',
        'Igravesmall',
        'Iacutesmall',
        'Icircumflexsmall',
        'Idieresissmall',
        'Ethsmall',
        'Ntildesmall',
        'Ogravesmall',
        'Oacutesmall',
        'Ocircumflexsmall',
        'Otildesmall',
        'Odieresissmall',
        'OEsmall',
        'Oslashsmall',
        'Ugravesmall',
        'Uacutesmall',
        'Ucircumflexsmall',
        'Udieresissmall',
        'Yacutesmall',
        'Thornsmall',
        'Ydieresissmall'
    ];
var ISOAdobeCharset = [
        '.notdef',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quoteright',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'quoteleft',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        'exclamdown',
        'cent',
        'sterling',
        'fraction',
        'yen',
        'florin',
        'section',
        'currency',
        'quotesingle',
        'quotedblleft',
        'guillemotleft',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        'endash',
        'dagger',
        'daggerdbl',
        'periodcentered',
        'paragraph',
        'bullet',
        'quotesinglbase',
        'quotedblbase',
        'quotedblright',
        'guillemotright',
        'ellipsis',
        'perthousand',
        'questiondown',
        'grave',
        'acute',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'dieresis',
        'ring',
        'cedilla',
        'hungarumlaut',
        'ogonek',
        'caron',
        'emdash',
        'AE',
        'ordfeminine',
        'Lslash',
        'Oslash',
        'OE',
        'ordmasculine',
        'ae',
        'dotlessi',
        'lslash',
        'oslash',
        'oe',
        'germandbls',
        'onesuperior',
        'logicalnot',
        'mu',
        'trademark',
        'Eth',
        'onehalf',
        'plusminus',
        'Thorn',
        'onequarter',
        'divide',
        'brokenbar',
        'degree',
        'thorn',
        'threequarters',
        'twosuperior',
        'registered',
        'minus',
        'eth',
        'multiply',
        'threesuperior',
        'copyright',
        'Aacute',
        'Acircumflex',
        'Adieresis',
        'Agrave',
        'Aring',
        'Atilde',
        'Ccedilla',
        'Eacute',
        'Ecircumflex',
        'Edieresis',
        'Egrave',
        'Iacute',
        'Icircumflex',
        'Idieresis',
        'Igrave',
        'Ntilde',
        'Oacute',
        'Ocircumflex',
        'Odieresis',
        'Ograve',
        'Otilde',
        'Scaron',
        'Uacute',
        'Ucircumflex',
        'Udieresis',
        'Ugrave',
        'Yacute',
        'Ydieresis',
        'Zcaron',
        'aacute',
        'acircumflex',
        'adieresis',
        'agrave',
        'aring',
        'atilde',
        'ccedilla',
        'eacute',
        'ecircumflex',
        'edieresis',
        'egrave',
        'iacute',
        'icircumflex',
        'idieresis',
        'igrave',
        'ntilde',
        'oacute',
        'ocircumflex',
        'odieresis',
        'ograve',
        'otilde',
        'scaron',
        'uacute',
        'ucircumflex',
        'udieresis',
        'ugrave',
        'yacute',
        'ydieresis',
        'zcaron'
    ];
var ExpertCharset = [
        '.notdef',
        'space',
        'exclamsmall',
        'Hungarumlautsmall',
        'dollaroldstyle',
        'dollarsuperior',
        'ampersandsmall',
        'Acutesmall',
        'parenleftsuperior',
        'parenrightsuperior',
        'twodotenleader',
        'onedotenleader',
        'comma',
        'hyphen',
        'period',
        'fraction',
        'zerooldstyle',
        'oneoldstyle',
        'twooldstyle',
        'threeoldstyle',
        'fouroldstyle',
        'fiveoldstyle',
        'sixoldstyle',
        'sevenoldstyle',
        'eightoldstyle',
        'nineoldstyle',
        'colon',
        'semicolon',
        'commasuperior',
        'threequartersemdash',
        'periodsuperior',
        'questionsmall',
        'asuperior',
        'bsuperior',
        'centsuperior',
        'dsuperior',
        'esuperior',
        'isuperior',
        'lsuperior',
        'msuperior',
        'nsuperior',
        'osuperior',
        'rsuperior',
        'ssuperior',
        'tsuperior',
        'ff',
        'fi',
        'fl',
        'ffi',
        'ffl',
        'parenleftinferior',
        'parenrightinferior',
        'Circumflexsmall',
        'hyphensuperior',
        'Gravesmall',
        'Asmall',
        'Bsmall',
        'Csmall',
        'Dsmall',
        'Esmall',
        'Fsmall',
        'Gsmall',
        'Hsmall',
        'Ismall',
        'Jsmall',
        'Ksmall',
        'Lsmall',
        'Msmall',
        'Nsmall',
        'Osmall',
        'Psmall',
        'Qsmall',
        'Rsmall',
        'Ssmall',
        'Tsmall',
        'Usmall',
        'Vsmall',
        'Wsmall',
        'Xsmall',
        'Ysmall',
        'Zsmall',
        'colonmonetary',
        'onefitted',
        'rupiah',
        'Tildesmall',
        'exclamdownsmall',
        'centoldstyle',
        'Lslashsmall',
        'Scaronsmall',
        'Zcaronsmall',
        'Dieresissmall',
        'Brevesmall',
        'Caronsmall',
        'Dotaccentsmall',
        'Macronsmall',
        'figuredash',
        'hypheninferior',
        'Ogoneksmall',
        'Ringsmall',
        'Cedillasmall',
        'onequarter',
        'onehalf',
        'threequarters',
        'questiondownsmall',
        'oneeighth',
        'threeeighths',
        'fiveeighths',
        'seveneighths',
        'onethird',
        'twothirds',
        'zerosuperior',
        'onesuperior',
        'twosuperior',
        'threesuperior',
        'foursuperior',
        'fivesuperior',
        'sixsuperior',
        'sevensuperior',
        'eightsuperior',
        'ninesuperior',
        'zeroinferior',
        'oneinferior',
        'twoinferior',
        'threeinferior',
        'fourinferior',
        'fiveinferior',
        'sixinferior',
        'seveninferior',
        'eightinferior',
        'nineinferior',
        'centinferior',
        'dollarinferior',
        'periodinferior',
        'commainferior',
        'Agravesmall',
        'Aacutesmall',
        'Acircumflexsmall',
        'Atildesmall',
        'Adieresissmall',
        'Aringsmall',
        'AEsmall',
        'Ccedillasmall',
        'Egravesmall',
        'Eacutesmall',
        'Ecircumflexsmall',
        'Edieresissmall',
        'Igravesmall',
        'Iacutesmall',
        'Icircumflexsmall',
        'Idieresissmall',
        'Ethsmall',
        'Ntildesmall',
        'Ogravesmall',
        'Oacutesmall',
        'Ocircumflexsmall',
        'Otildesmall',
        'Odieresissmall',
        'OEsmall',
        'Oslashsmall',
        'Ugravesmall',
        'Uacutesmall',
        'Ucircumflexsmall',
        'Udieresissmall',
        'Yacutesmall',
        'Thornsmall',
        'Ydieresissmall'
    ];
var ExpertSubsetCharset = [
        '.notdef',
        'space',
        'dollaroldstyle',
        'dollarsuperior',
        'parenleftsuperior',
        'parenrightsuperior',
        'twodotenleader',
        'onedotenleader',
        'comma',
        'hyphen',
        'period',
        'fraction',
        'zerooldstyle',
        'oneoldstyle',
        'twooldstyle',
        'threeoldstyle',
        'fouroldstyle',
        'fiveoldstyle',
        'sixoldstyle',
        'sevenoldstyle',
        'eightoldstyle',
        'nineoldstyle',
        'colon',
        'semicolon',
        'commasuperior',
        'threequartersemdash',
        'periodsuperior',
        'asuperior',
        'bsuperior',
        'centsuperior',
        'dsuperior',
        'esuperior',
        'isuperior',
        'lsuperior',
        'msuperior',
        'nsuperior',
        'osuperior',
        'rsuperior',
        'ssuperior',
        'tsuperior',
        'ff',
        'fi',
        'fl',
        'ffi',
        'ffl',
        'parenleftinferior',
        'parenrightinferior',
        'hyphensuperior',
        'colonmonetary',
        'onefitted',
        'rupiah',
        'centoldstyle',
        'figuredash',
        'hypheninferior',
        'onequarter',
        'onehalf',
        'threequarters',
        'oneeighth',
        'threeeighths',
        'fiveeighths',
        'seveneighths',
        'onethird',
        'twothirds',
        'zerosuperior',
        'onesuperior',
        'twosuperior',
        'threesuperior',
        'foursuperior',
        'fivesuperior',
        'sixsuperior',
        'sevensuperior',
        'eightsuperior',
        'ninesuperior',
        'zeroinferior',
        'oneinferior',
        'twoinferior',
        'threeinferior',
        'fourinferior',
        'fiveinferior',
        'sixinferior',
        'seveninferior',
        'eightinferior',
        'nineinferior',
        'centinferior',
        'dollarinferior',
        'periodinferior',
        'commainferior'
    ];
var LangSysTable = new r.Struct({
        reserved: new r.Reserved(r.uint16),
        reqFeatureIndex: r.uint16,
        featureCount: r.uint16,
        featureIndexes: new r.Array(r.uint16, 'featureCount')
    });
var LangSysRecord = new r.Struct({
        tag: new r.String(4),
        langSys: new r.Pointer(r.uint16, LangSysTable, { type: 'parent' })
    });
var Script = new r.Struct({
        defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
        count: r.uint16,
        langSysRecords: new r.Array(LangSysRecord, 'count')
    });
var ScriptRecord = new r.Struct({
        tag: new r.String(4),
        script: new r.Pointer(r.uint16, Script, { type: 'parent' })
    });
var ScriptList = new r.Array(ScriptRecord, r.uint16);
var Feature = new r.Struct({
        featureParams: r.uint16,
        lookupCount: r.uint16,
        lookupListIndexes: new r.Array(r.uint16, 'lookupCount')
    });
var FeatureRecord = new r.Struct({
        tag: new r.String(4),
        feature: new r.Pointer(r.uint16, Feature, { type: 'parent' })
    });
var FeatureList = new r.Array(FeatureRecord, r.uint16);
var LookupFlags = new r.Struct({
        markAttachmentType: r.uint8,
        flags: new r.Bitfield(r.uint8, [
            'rightToLeft',
            'ignoreBaseGlyphs',
            'ignoreLigatures',
            'ignoreMarks',
            'useMarkFilteringSet'
        ])
    });
function LookupList(SubTable) {
    var Lookup = new r.Struct({
            lookupType: r.uint16,
            flags: LookupFlags,
            subTableCount: r.uint16,
            subTables: new r.Array(new r.Pointer(r.uint16, SubTable), 'subTableCount'),
            markFilteringSet: new r.Optional(r.uint16, function (t) {
                return t.flags.flags.useMarkFilteringSet;
            })
        });
    return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
}
var RangeRecord = new r.Struct({
        start: r.uint16,
        end: r.uint16,
        startCoverageIndex: r.uint16
    });
var Coverage = new r.VersionedStruct(r.uint16, {
        1: {
            glyphCount: r.uint16,
            glyphs: new r.Array(r.uint16, 'glyphCount')
        },
        2: {
            rangeCount: r.uint16,
            rangeRecords: new r.Array(RangeRecord, 'rangeCount')
        }
    });
var ClassRangeRecord = new r.Struct({
        start: r.uint16,
        end: r.uint16,
        class: r.uint16
    });
var ClassDef = new r.VersionedStruct(r.uint16, {
        1: {
            startGlyph: r.uint16,
            glyphCount: r.uint16,
            classValueArray: new r.Array(r.uint16, 'glyphCount')
        },
        2: {
            classRangeCount: r.uint16,
            classRangeRecord: new r.Array(ClassRangeRecord, 'classRangeCount')
        }
    });
var Device = new r.Struct({
        a: r.uint16,
        b: r.uint16,
        deltaFormat: r.uint16
    });
var LookupRecord = new r.Struct({
        sequenceIndex: r.uint16,
        lookupListIndex: r.uint16
    });
var Rule = new r.Struct({
        glyphCount: r.uint16,
        lookupCount: r.uint16,
        input: new r.Array(r.uint16, function (t) {
            return t.glyphCount - 1;
        }),
        lookupRecords: new r.Array(LookupRecord, 'lookupCount')
    });
var RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);
var ClassRule = new r.Struct({
        glyphCount: r.uint16,
        lookupCount: r.uint16,
        classes: new r.Array(r.uint16, function (t) {
            return t.glyphCount - 1;
        }),
        lookupRecords: new r.Array(LookupRecord, 'lookupCount')
    });
var ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);
var Context = new r.VersionedStruct(r.uint16, {
        1: {
            coverage: new r.Pointer(r.uint16, Coverage),
            ruleSetCount: r.uint16,
            ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), 'ruleSetCount')
        },
        2: {
            coverage: new r.Pointer(r.uint16, Coverage),
            classDef: new r.Pointer(r.uint16, ClassDef),
            classSetCnt: r.uint16,
            classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), 'classSetCnt')
        },
        3: {
            glyphCount: r.uint16,
            lookupCount: r.uint16,
            coverages: new r.Array(new r.Pointer(r.uint16, Coverage), 'glyphCount'),
            lookupRecords: new r.Array(LookupRecord, 'lookupCount')
        }
    });
var ChainRule = new r.Struct({
        backtrackGlyphCount: r.uint16,
        backtrack: new r.Array(r.uint16, 'backtrackGlyphCount'),
        inputGlyphCount: r.uint16,
        input: new r.Array(r.uint16, function (t) {
            return t.inputGlyphCount - 1;
        }),
        lookaheadGlyphCount: r.uint16,
        lookahead: new r.Array(r.uint16, 'lookaheadGlyphCount'),
        lookupCount: r.uint16,
        lookupRecords: new r.Array(LookupRecord, 'lookupCount')
    });
var ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);
var ChainingContext = new r.VersionedStruct(r.uint16, {
        1: {
            coverage: new r.Pointer(r.uint16, Coverage),
            chainCount: r.uint16,
            chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
        },
        2: {
            coverage: new r.Pointer(r.uint16, Coverage),
            backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
            inputClassDef: new r.Pointer(r.uint16, ClassDef),
            lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
            chainCount: r.uint16,
            chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
        },
        3: {
            backtrackGlyphCount: r.uint16,
            backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
            inputGlyphCount: r.uint16,
            inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'inputGlyphCount'),
            lookaheadGlyphCount: r.uint16,
            lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
            lookupCount: r.uint16,
            lookupRecords: new r.Array(LookupRecord, 'lookupCount')
        }
    });
var _;
var F2DOT14 = new r.Fixed(16, 'BE', 14);
var RegionAxisCoordinates = new r.Struct({
        startCoord: F2DOT14,
        peakCoord: F2DOT14,
        endCoord: F2DOT14
    });
var VariationRegionList = new r.Struct({
        axisCount: r.uint16,
        regionCount: r.uint16,
        variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, 'axisCount'), 'regionCount')
    });
var DeltaSet = new r.Struct({
        shortDeltas: new r.Array(r.int16, function (t) {
            return t.parent.shortDeltaCount;
        }),
        regionDeltas: new r.Array(r.int8, function (t) {
            return t.parent.regionIndexCount - t.parent.shortDeltaCount;
        }),
        deltas: function deltas(t) {
            return t.shortDeltas.concat(t.regionDeltas);
        }
    });
var ItemVariationData = new r.Struct({
        itemCount: r.uint16,
        shortDeltaCount: r.uint16,
        regionIndexCount: r.uint16,
        regionIndexes: new r.Array(r.uint16, 'regionIndexCount'),
        deltaSets: new r.Array(DeltaSet, 'itemCount')
    });
var ItemVariationStore = new r.Struct({
        format: r.uint16,
        variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
        variationDataCount: r.uint16,
        itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), 'variationDataCount')
    });
var ConditionTable = new r.VersionedStruct(r.uint16, { 1: (_ = { axisIndex: r.uint16 }, _['axisIndex'] = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _) });
var ConditionSet = new r.Struct({
        conditionCount: r.uint16,
        conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), 'conditionCount')
    });
var FeatureTableSubstitutionRecord = new r.Struct({
        featureIndex: r.uint16,
        alternateFeatureTable: new r.Pointer(r.uint32, Feature, { type: 'parent' })
    });
var FeatureTableSubstitution = new r.Struct({
        version: r.fixed32,
        substitutionCount: r.uint16,
        substitutions: new r.Array(FeatureTableSubstitutionRecord, 'substitutionCount')
    });
var FeatureVariationRecord = new r.Struct({
        conditionSet: new r.Pointer(r.uint32, ConditionSet, { type: 'parent' }),
        featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, { type: 'parent' })
    });
var FeatureVariations = new r.Struct({
        majorVersion: r.uint16,
        minorVersion: r.uint16,
        featureVariationRecordCount: r.uint32,
        featureVariationRecords: new r.Array(FeatureVariationRecord, 'featureVariationRecordCount')
    });
var PredefinedOp = function () {
        function PredefinedOp(predefinedOps, type) {
            _classCallCheck(this, PredefinedOp);
            this.predefinedOps = predefinedOps;
            this.type = type;
        }
        PredefinedOp.prototype.decode = function decode(stream, parent, operands) {
            if (this.predefinedOps[operands[0]]) {
                return this.predefinedOps[operands[0]];
            }
            return this.type.decode(stream, parent, operands);
        };
        PredefinedOp.prototype.size = function size(value, ctx) {
            return this.type.size(value, ctx);
        };
        PredefinedOp.prototype.encode = function encode(stream, value, ctx) {
            var index = this.predefinedOps.indexOf(value);
            if (index !== -1) {
                return index;
            }
            return this.type.encode(stream, value, ctx);
        };
        return PredefinedOp;
    }();
var CFFEncodingVersion = function (_r$Number) {
        _inherits(CFFEncodingVersion, _r$Number);
        function CFFEncodingVersion() {
            _classCallCheck(this, CFFEncodingVersion);
            return _possibleConstructorReturn(this, _r$Number.call(this, 'UInt8'));
        }
        CFFEncodingVersion.prototype.decode = function decode(stream) {
            return r.uint8.decode(stream) & 127;
        };
        return CFFEncodingVersion;
    }(r.Number);
var Range1 = new r.Struct({
        first: r.uint16,
        nLeft: r.uint8
    });
var Range2 = new r.Struct({
        first: r.uint16,
        nLeft: r.uint16
    });
var CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
        0: {
            nCodes: r.uint8,
            codes: new r.Array(r.uint8, 'nCodes')
        },
        1: {
            nRanges: r.uint8,
            ranges: new r.Array(Range1, 'nRanges')
        }
    });
var CFFEncoding = new PredefinedOp([
        StandardEncoding,
        ExpertEncoding
    ], new CFFPointer(CFFCustomEncoding, { lazy: true }));
var RangeArray = function (_r$Array) {
        _inherits(RangeArray, _r$Array);
        function RangeArray() {
            _classCallCheck(this, RangeArray);
            return _possibleConstructorReturn(this, _r$Array.apply(this, arguments));
        }
        RangeArray.prototype.decode = function decode(stream, parent) {
            var length = restructure_src_utils.resolveLength(this.length, stream, parent);
            var count = 0;
            var res = [];
            while (count < length) {
                var range = this.type.decode(stream, parent);
                range.offset = count;
                count += range.nLeft + 1;
                res.push(range);
            }
            return res;
        };
        return RangeArray;
    }(r.Array);
var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
        0: {
            glyphs: new r.Array(r.uint16, function (t) {
                return t.parent.CharStrings.length - 1;
            })
        },
        1: {
            ranges: new RangeArray(Range1, function (t) {
                return t.parent.CharStrings.length - 1;
            })
        },
        2: {
            ranges: new RangeArray(Range2, function (t) {
                return t.parent.CharStrings.length - 1;
            })
        }
    });
var CFFCharset = new PredefinedOp([
        ISOAdobeCharset,
        ExpertCharset,
        ExpertSubsetCharset
    ], new CFFPointer(CFFCustomCharset, { lazy: true }));
var FDRange3 = new r.Struct({
        first: r.uint16,
        fd: r.uint8
    });
var FDRange4 = new r.Struct({
        first: r.uint32,
        fd: r.uint16
    });
var FDSelect = new r.VersionedStruct(r.uint8, {
        0: {
            fds: new r.Array(r.uint8, function (t) {
                return t.parent.CharStrings.length;
            })
        },
        3: {
            nRanges: r.uint16,
            ranges: new r.Array(FDRange3, 'nRanges'),
            sentinel: r.uint16
        },
        4: {
            nRanges: r.uint32,
            ranges: new r.Array(FDRange4, 'nRanges'),
            sentinel: r.uint32
        }
    });
var ptr = new CFFPointer(CFFPrivateDict);
var CFFPrivateOp = function () {
        function CFFPrivateOp() {
            _classCallCheck(this, CFFPrivateOp);
        }
        CFFPrivateOp.prototype.decode = function decode(stream, parent, operands) {
            parent.length = operands[0];
            return ptr.decode(stream, parent, [operands[1]]);
        };
        CFFPrivateOp.prototype.size = function size(dict, ctx) {
            return [
                CFFPrivateDict.size(dict, ctx, false),
                ptr.size(dict, ctx)[0]
            ];
        };
        CFFPrivateOp.prototype.encode = function encode(stream, dict, ctx) {
            return [
                CFFPrivateDict.size(dict, ctx, false),
                ptr.encode(stream, dict, ctx)[0]
            ];
        };
        return CFFPrivateOp;
    }();
var FontDict = new CFFDict([
        [
            18,
            'Private',
            new CFFPrivateOp(),
            null
        ],
        [
            [
                12,
                38
            ],
            'FontName',
            'sid',
            null
        ]
    ]);
var CFFTopDict = new CFFDict([
        [
            [
                12,
                30
            ],
            'ROS',
            [
                'sid',
                'sid',
                'number'
            ],
            null
        ],
        [
            0,
            'version',
            'sid',
            null
        ],
        [
            1,
            'Notice',
            'sid',
            null
        ],
        [
            [
                12,
                0
            ],
            'Copyright',
            'sid',
            null
        ],
        [
            2,
            'FullName',
            'sid',
            null
        ],
        [
            3,
            'FamilyName',
            'sid',
            null
        ],
        [
            4,
            'Weight',
            'sid',
            null
        ],
        [
            [
                12,
                1
            ],
            'isFixedPitch',
            'boolean',
            false
        ],
        [
            [
                12,
                2
            ],
            'ItalicAngle',
            'number',
            0
        ],
        [
            [
                12,
                3
            ],
            'UnderlinePosition',
            'number',
            -100
        ],
        [
            [
                12,
                4
            ],
            'UnderlineThickness',
            'number',
            50
        ],
        [
            [
                12,
                5
            ],
            'PaintType',
            'number',
            0
        ],
        [
            [
                12,
                6
            ],
            'CharstringType',
            'number',
            2
        ],
        [
            [
                12,
                7
            ],
            'FontMatrix',
            'array',
            [
                0.001,
                0,
                0,
                0.001,
                0,
                0
            ]
        ],
        [
            13,
            'UniqueID',
            'number',
            null
        ],
        [
            5,
            'FontBBox',
            'array',
            [
                0,
                0,
                0,
                0
            ]
        ],
        [
            [
                12,
                8
            ],
            'StrokeWidth',
            'number',
            0
        ],
        [
            14,
            'XUID',
            'array',
            null
        ],
        [
            15,
            'charset',
            CFFCharset,
            ISOAdobeCharset
        ],
        [
            16,
            'Encoding',
            CFFEncoding,
            StandardEncoding
        ],
        [
            17,
            'CharStrings',
            new CFFPointer(new CFFIndex()),
            null
        ],
        [
            18,
            'Private',
            new CFFPrivateOp(),
            null
        ],
        [
            [
                12,
                20
            ],
            'SyntheticBase',
            'number',
            null
        ],
        [
            [
                12,
                21
            ],
            'PostScript',
            'sid',
            null
        ],
        [
            [
                12,
                22
            ],
            'BaseFontName',
            'sid',
            null
        ],
        [
            [
                12,
                23
            ],
            'BaseFontBlend',
            'delta',
            null
        ],
        [
            [
                12,
                31
            ],
            'CIDFontVersion',
            'number',
            0
        ],
        [
            [
                12,
                32
            ],
            'CIDFontRevision',
            'number',
            0
        ],
        [
            [
                12,
                33
            ],
            'CIDFontType',
            'number',
            0
        ],
        [
            [
                12,
                34
            ],
            'CIDCount',
            'number',
            8720
        ],
        [
            [
                12,
                35
            ],
            'UIDBase',
            'number',
            null
        ],
        [
            [
                12,
                37
            ],
            'FDSelect',
            new CFFPointer(FDSelect),
            null
        ],
        [
            [
                12,
                36
            ],
            'FDArray',
            new CFFPointer(new CFFIndex(FontDict)),
            null
        ],
        [
            [
                12,
                38
            ],
            'FontName',
            'sid',
            null
        ]
    ]);
var VariationStore = new r.Struct({
        length: r.uint16,
        itemVariationStore: ItemVariationStore
    });
var CFF2TopDict = new CFFDict([
        [
            [
                12,
                7
            ],
            'FontMatrix',
            'array',
            [
                0.001,
                0,
                0,
                0.001,
                0,
                0
            ]
        ],
        [
            17,
            'CharStrings',
            new CFFPointer(new CFFIndex()),
            null
        ],
        [
            [
                12,
                37
            ],
            'FDSelect',
            new CFFPointer(FDSelect),
            null
        ],
        [
            [
                12,
                36
            ],
            'FDArray',
            new CFFPointer(new CFFIndex(FontDict)),
            null
        ],
        [
            24,
            'vstore',
            new CFFPointer(VariationStore),
            null
        ],
        [
            25,
            'maxstack',
            'number',
            193
        ]
    ]);
var CFFTop = new r.VersionedStruct(r.fixed16, {
        1: {
            hdrSize: r.uint8,
            offSize: r.uint8,
            nameIndex: new CFFIndex(new r.String('length')),
            topDictIndex: new CFFIndex(CFFTopDict),
            stringIndex: new CFFIndex(new r.String('length')),
            globalSubrIndex: new CFFIndex()
        },
        2: {
            hdrSize: r.uint8,
            length: r.uint16,
            topDict: CFF2TopDict,
            globalSubrIndex: new CFFIndex()
        }
    });
var CFFFont = function () {
        function CFFFont(stream) {
            _classCallCheck(this, CFFFont);
            this.stream = stream;
            this.decode();
        }
        CFFFont.decode = function decode(stream) {
            return new CFFFont(stream);
        };
        CFFFont.prototype.decode = function decode() {
            var start = this.stream.pos;
            var top = CFFTop.decode(this.stream);
            for (var key in top) {
                var val = top[key];
                this[key] = val;
            }
            if (this.version < 2) {
                if (this.topDictIndex.length !== 1) {
                    throw new Error('Only a single font is allowed in CFF');
                }
                this.topDict = this.topDictIndex[0];
            }
            this.isCIDFont = this.topDict.ROS != null;
            return this;
        };
        CFFFont.prototype.string = function string(sid) {
            if (this.version >= 2) {
                return null;
            }
            if (sid < standardStrings.length) {
                return standardStrings[sid];
            }
            return this.stringIndex[sid - standardStrings.length];
        };
        CFFFont.prototype.getCharString = function getCharString(glyph) {
            this.stream.pos = this.topDict.CharStrings[glyph].offset;
            return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
        };
        CFFFont.prototype.getGlyphName = function getGlyphName(gid) {
            if (this.version >= 2) {
                return null;
            }
            if (this.isCIDFont) {
                return null;
            }
            var charset = this.topDict.charset;
            if (Array.isArray(charset)) {
                return charset[gid];
            }
            if (gid === 0) {
                return '.notdef';
            }
            gid -= 1;
            switch (charset.version) {
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for (var i = 0; i < charset.ranges.length; i++) {
                    var range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) {
                        return this.string(range.first + (gid - range.offset));
                    }
                }
                break;
            }
            return null;
        };
        CFFFont.prototype.fdForGlyph = function fdForGlyph(gid) {
            if (!this.topDict.FDSelect) {
                return null;
            }
            switch (this.topDict.FDSelect.version) {
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                var ranges = this.topDict.FDSelect.ranges;
                var low = 0;
                var high = ranges.length - 1;
                while (low <= high) {
                    var mid = low + high >> 1;
                    if (gid < ranges[mid].first) {
                        high = mid - 1;
                    } else if (mid < high && gid > ranges[mid + 1].first) {
                        low = mid + 1;
                    } else {
                        return ranges[mid].fd;
                    }
                }
            default:
                throw new Error('Unknown FDSelect version: ' + this.topDict.FDSelect.version);
            }
        };
        CFFFont.prototype.privateDictForGlyph = function privateDictForGlyph(gid) {
            if (this.topDict.FDSelect) {
                var fd = this.fdForGlyph(gid);
                if (this.topDict.FDArray[fd]) {
                    return this.topDict.FDArray[fd].Private;
                }
                return null;
            }
            if (this.version < 2) {
                return this.topDict.Private;
            }
            return this.topDict.FDArray[0].Private;
        };
        _createClass(CFFFont, [
            {
                key: 'postscriptName',
                get: function get() {
                    if (this.version < 2) {
                        return this.nameIndex[0];
                    }
                    return null;
                }
            },
            {
                key: 'fullName',
                get: function get() {
                    return this.string(this.topDict.FullName);
                }
            },
            {
                key: 'familyName',
                get: function get() {
                    return this.string(this.topDict.FamilyName);
                }
            }
        ]);
        return CFFFont;
    }();
var VerticalOrigin = new r.Struct({
        glyphIndex: r.uint16,
        vertOriginY: r.int16
    });
var VORG = new r.Struct({
        majorVersion: r.uint16,
        minorVersion: r.uint16,
        defaultVertOriginY: r.int16,
        numVertOriginYMetrics: r.uint16,
        metrics: new r.Array(VerticalOrigin, 'numVertOriginYMetrics')
    });
var BigMetrics = new r.Struct({
        height: r.uint8,
        width: r.uint8,
        horiBearingX: r.int8,
        horiBearingY: r.int8,
        horiAdvance: r.uint8,
        vertBearingX: r.int8,
        vertBearingY: r.int8,
        vertAdvance: r.uint8
    });
var SmallMetrics = new r.Struct({
        height: r.uint8,
        width: r.uint8,
        bearingX: r.int8,
        bearingY: r.int8,
        advance: r.uint8
    });
var EBDTComponent = new r.Struct({
        glyph: r.uint16,
        xOffset: r.int8,
        yOffset: r.int8
    });
var ByteAligned = function ByteAligned() {
    _classCallCheck(this, ByteAligned);
};
var BitAligned = function BitAligned() {
    _classCallCheck(this, BitAligned);
};
var glyph = new r.VersionedStruct('version', {
        1: {
            metrics: SmallMetrics,
            data: ByteAligned
        },
        2: {
            metrics: SmallMetrics,
            data: BitAligned
        },
        5: { data: BitAligned },
        6: {
            metrics: BigMetrics,
            data: ByteAligned
        },
        7: {
            metrics: BigMetrics,
            data: BitAligned
        },
        8: {
            metrics: SmallMetrics,
            pad: new r.Reserved(r.uint8),
            numComponents: r.uint16,
            components: new r.Array(EBDTComponent, 'numComponents')
        },
        9: {
            metrics: BigMetrics,
            pad: new r.Reserved(r.uint8),
            numComponents: r.uint16,
            components: new r.Array(EBDTComponent, 'numComponents')
        },
        17: {
            metrics: SmallMetrics,
            dataLen: r.uint32,
            data: new r.Buffer('dataLen')
        },
        18: {
            metrics: BigMetrics,
            dataLen: r.uint32,
            data: new r.Buffer('dataLen')
        },
        19: {
            dataLen: r.uint32,
            data: new r.Buffer('dataLen')
        }
    });
var SBitLineMetrics = new r.Struct({
        ascender: r.int8,
        descender: r.int8,
        widthMax: r.uint8,
        caretSlopeNumerator: r.int8,
        caretSlopeDenominator: r.int8,
        caretOffset: r.int8,
        minOriginSB: r.int8,
        minAdvanceSB: r.int8,
        maxBeforeBL: r.int8,
        minAfterBL: r.int8,
        pad: new r.Reserved(r.int8, 2)
    });
var CodeOffsetPair = new r.Struct({
        glyphCode: r.uint16,
        offset: r.uint16
    });
var IndexSubtable = new r.VersionedStruct(r.uint16, {
        header: {
            imageFormat: r.uint16,
            imageDataOffset: r.uint32
        },
        1: {
            offsetArray: new r.Array(r.uint32, function (t) {
                return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
            })
        },
        2: {
            imageSize: r.uint32,
            bigMetrics: BigMetrics
        },
        3: {
            offsetArray: new r.Array(r.uint16, function (t) {
                return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
            })
        },
        4: {
            numGlyphs: r.uint32,
            glyphArray: new r.Array(CodeOffsetPair, function (t) {
                return t.numGlyphs + 1;
            })
        },
        5: {
            imageSize: r.uint32,
            bigMetrics: BigMetrics,
            numGlyphs: r.uint32,
            glyphCodeArray: new r.Array(r.uint16, 'numGlyphs')
        }
    });
var IndexSubtableArray = new r.Struct({
        firstGlyphIndex: r.uint16,
        lastGlyphIndex: r.uint16,
        subtable: new r.Pointer(r.uint32, IndexSubtable)
    });
var BitmapSizeTable = new r.Struct({
        indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), { type: 'parent' }),
        indexTablesSize: r.uint32,
        numberOfIndexSubTables: r.uint32,
        colorRef: r.uint32,
        hori: SBitLineMetrics,
        vert: SBitLineMetrics,
        startGlyphIndex: r.uint16,
        endGlyphIndex: r.uint16,
        ppemX: r.uint8,
        ppemY: r.uint8,
        bitDepth: r.uint8,
        flags: new r.Bitfield(r.uint8, [
            'horizontal',
            'vertical'
        ])
    });
var EBLC = new r.Struct({
        version: r.uint32,
        numSizes: r.uint32,
        sizes: new r.Array(BitmapSizeTable, 'numSizes')
    });
var ImageTable = new r.Struct({
        ppem: r.uint16,
        resolution: r.uint16,
        imageOffsets: new r.Array(new r.Pointer(r.uint32, 'void'), function (t) {
            return t.parent.parent.maxp.numGlyphs + 1;
        })
    });
var sbix = new r.Struct({
        version: r.uint16,
        flags: new r.Bitfield(r.uint16, ['renderOutlines']),
        numImgTables: r.uint32,
        imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), 'numImgTables')
    });
var LayerRecord = new r.Struct({
        gid: r.uint16,
        paletteIndex: r.uint16
    });
var BaseGlyphRecord = new r.Struct({
        gid: r.uint16,
        firstLayerIndex: r.uint16,
        numLayers: r.uint16
    });
var COLR = new r.Struct({
        version: r.uint16,
        numBaseGlyphRecords: r.uint16,
        baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
        layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, 'numLayerRecords'), { lazy: true }),
        numLayerRecords: r.uint16
    });
var ColorRecord = new r.Struct({
        blue: r.uint8,
        green: r.uint8,
        red: r.uint8,
        alpha: r.uint8
    });
var CPAL = new r.VersionedStruct(r.uint16, {
        header: {
            numPaletteEntries: r.uint16,
            numPalettes: r.uint16,
            numColorRecords: r.uint16,
            colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, 'numColorRecords')),
            colorRecordIndices: new r.Array(r.uint16, 'numPalettes')
        },
        0: {},
        1: {
            offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, 'numPalettes')),
            offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPalettes')),
            offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPaletteEntries'))
        }
    });
var BaseCoord = new r.VersionedStruct(r.uint16, {
        1: { coordinate: r.int16 },
        2: {
            coordinate: r.int16,
            referenceGlyph: r.uint16,
            baseCoordPoint: r.uint16
        },
        3: {
            coordinate: r.int16,
            deviceTable: new r.Pointer(r.uint16, Device)
        }
    });
var BaseValues = new r.Struct({
        defaultIndex: r.uint16,
        baseCoordCount: r.uint16,
        baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), 'baseCoordCount')
    });
var FeatMinMaxRecord = new r.Struct({
        tag: new r.String(4),
        minCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }),
        maxCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' })
    });
var MinMax = new r.Struct({
        minCoord: new r.Pointer(r.uint16, BaseCoord),
        maxCoord: new r.Pointer(r.uint16, BaseCoord),
        featMinMaxCount: r.uint16,
        featMinMaxRecords: new r.Array(FeatMinMaxRecord, 'featMinMaxCount')
    });
var BaseLangSysRecord = new r.Struct({
        tag: new r.String(4),
        minMax: new r.Pointer(r.uint16, MinMax, { type: 'parent' })
    });
var BaseScript = new r.Struct({
        baseValues: new r.Pointer(r.uint16, BaseValues),
        defaultMinMax: new r.Pointer(r.uint16, MinMax),
        baseLangSysCount: r.uint16,
        baseLangSysRecords: new r.Array(BaseLangSysRecord, 'baseLangSysCount')
    });
var BaseScriptRecord = new r.Struct({
        tag: new r.String(4),
        script: new r.Pointer(r.uint16, BaseScript, { type: 'parent' })
    });
var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16);
var BaseTagList = new r.Array(new r.String(4), r.uint16);
var Axis = new r.Struct({
        baseTagList: new r.Pointer(r.uint16, BaseTagList),
        baseScriptList: new r.Pointer(r.uint16, BaseScriptList)
    });
var BASE = new r.VersionedStruct(r.uint32, {
        header: {
            horizAxis: new r.Pointer(r.uint16, Axis),
            vertAxis: new r.Pointer(r.uint16, Axis)
        },
        65536: {},
        65537: { itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore) }
    });
var AttachPoint = new r.Array(r.uint16, r.uint16);
var AttachList = new r.Struct({
        coverage: new r.Pointer(r.uint16, Coverage),
        glyphCount: r.uint16,
        attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), 'glyphCount')
    });
var CaretValue = new r.VersionedStruct(r.uint16, {
        1: { coordinate: r.int16 },
        2: { caretValuePoint: r.uint16 },
        3: {
            coordinate: r.int16,
            deviceTable: new r.Pointer(r.uint16, Device)
        }
    });
var LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);
var LigCaretList = new r.Struct({
        coverage: new r.Pointer(r.uint16, Coverage),
        ligGlyphCount: r.uint16,
        ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), 'ligGlyphCount')
    });
var MarkGlyphSetsDef = new r.Struct({
        markSetTableFormat: r.uint16,
        markSetCount: r.uint16,
        coverage: new r.Array(new r.Pointer(r.uint32, Coverage), 'markSetCount')
    });
var GDEF = new r.VersionedStruct(r.uint32, {
        header: {
            glyphClassDef: new r.Pointer(r.uint16, ClassDef),
            attachList: new r.Pointer(r.uint16, AttachList),
            ligCaretList: new r.Pointer(r.uint16, LigCaretList),
            markAttachClassDef: new r.Pointer(r.uint16, ClassDef)
        },
        65536: {},
        65538: { markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef) },
        65539: {
            markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
            itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
        }
    });
var ValueFormat = new r.Bitfield(r.uint16, [
        'xPlacement',
        'yPlacement',
        'xAdvance',
        'yAdvance',
        'xPlaDevice',
        'yPlaDevice',
        'xAdvDevice',
        'yAdvDevice'
    ]);
var types = {
        xPlacement: r.int16,
        yPlacement: r.int16,
        xAdvance: r.int16,
        yAdvance: r.int16,
        xPlaDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: 'rel'
        }),
        yPlaDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: 'rel'
        }),
        xAdvDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: 'rel'
        }),
        yAdvDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: 'rel'
        })
    };
var ValueRecord = function () {
        function ValueRecord() {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valueFormat';
            _classCallCheck(this, ValueRecord);
            this.key = key;
        }
        ValueRecord.prototype.buildStruct = function buildStruct(parent) {
            var struct = parent;
            while (!struct[this.key] && struct.parent) {
                struct = struct.parent;
            }
            if (!struct[this.key])
                return;
            var fields = {};
            fields.rel = function () {
                return struct._startOffset;
            };
            var format = struct[this.key];
            for (var key in format) {
                if (format[key]) {
                    fields[key] = types[key];
                }
            }
            return new r.Struct(fields);
        };
        ValueRecord.prototype.size = function size(val, ctx) {
            return this.buildStruct(ctx).size(val, ctx);
        };
        ValueRecord.prototype.decode = function decode(stream, parent) {
            var res = this.buildStruct(parent).decode(stream, parent);
            delete res.rel;
            return res;
        };
        return ValueRecord;
    }();
var PairValueRecord = new r.Struct({
        secondGlyph: r.uint16,
        value1: new ValueRecord('valueFormat1'),
        value2: new ValueRecord('valueFormat2')
    });
var PairSet = new r.Array(PairValueRecord, r.uint16);
var Class2Record = new r.Struct({
        value1: new ValueRecord('valueFormat1'),
        value2: new ValueRecord('valueFormat2')
    });
var Anchor = new r.VersionedStruct(r.uint16, {
        1: {
            xCoordinate: r.int16,
            yCoordinate: r.int16
        },
        2: {
            xCoordinate: r.int16,
            yCoordinate: r.int16,
            anchorPoint: r.uint16
        },
        3: {
            xCoordinate: r.int16,
            yCoordinate: r.int16,
            xDeviceTable: new r.Pointer(r.uint16, Device),
            yDeviceTable: new r.Pointer(r.uint16, Device)
        }
    });
var EntryExitRecord = new r.Struct({
        entryAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' }),
        exitAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
    });
var MarkRecord = new r.Struct({
        class: r.uint16,
        markAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
    });
var MarkArray = new r.Array(MarkRecord, r.uint16);
var BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
        return t.parent.classCount;
    });
var BaseArray = new r.Array(BaseRecord, r.uint16);
var ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
        return t.parent.parent.classCount;
    });
var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
var LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);
var GPOSLookup = new r.VersionedStruct('lookupType', {
        1: new r.VersionedStruct(r.uint16, {
            1: {
                coverage: new r.Pointer(r.uint16, Coverage),
                valueFormat: ValueFormat,
                value: new ValueRecord()
            },
            2: {
                coverage: new r.Pointer(r.uint16, Coverage),
                valueFormat: ValueFormat,
                valueCount: r.uint16,
                values: new r.LazyArray(new ValueRecord(), 'valueCount')
            }
        }),
        2: new r.VersionedStruct(r.uint16, {
            1: {
                coverage: new r.Pointer(r.uint16, Coverage),
                valueFormat1: ValueFormat,
                valueFormat2: ValueFormat,
                pairSetCount: r.uint16,
                pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), 'pairSetCount')
            },
            2: {
                coverage: new r.Pointer(r.uint16, Coverage),
                valueFormat1: ValueFormat,
                valueFormat2: ValueFormat,
                classDef1: new r.Pointer(r.uint16, ClassDef),
                classDef2: new r.Pointer(r.uint16, ClassDef),
                class1Count: r.uint16,
                class2Count: r.uint16,
                classRecords: new r.LazyArray(new r.LazyArray(Class2Record, 'class2Count'), 'class1Count')
            }
        }),
        3: {
            format: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            entryExitCount: r.uint16,
            entryExitRecords: new r.Array(EntryExitRecord, 'entryExitCount')
        },
        4: {
            format: r.uint16,
            markCoverage: new r.Pointer(r.uint16, Coverage),
            baseCoverage: new r.Pointer(r.uint16, Coverage),
            classCount: r.uint16,
            markArray: new r.Pointer(r.uint16, MarkArray),
            baseArray: new r.Pointer(r.uint16, BaseArray)
        },
        5: {
            format: r.uint16,
            markCoverage: new r.Pointer(r.uint16, Coverage),
            ligatureCoverage: new r.Pointer(r.uint16, Coverage),
            classCount: r.uint16,
            markArray: new r.Pointer(r.uint16, MarkArray),
            ligatureArray: new r.Pointer(r.uint16, LigatureArray)
        },
        6: {
            format: r.uint16,
            mark1Coverage: new r.Pointer(r.uint16, Coverage),
            mark2Coverage: new r.Pointer(r.uint16, Coverage),
            classCount: r.uint16,
            mark1Array: new r.Pointer(r.uint16, MarkArray),
            mark2Array: new r.Pointer(r.uint16, BaseArray)
        },
        7: Context,
        8: ChainingContext,
        9: {
            posFormat: r.uint16,
            lookupType: r.uint16,
            extension: new r.Pointer(r.uint32, GPOSLookup)
        }
    });
GPOSLookup.versions[9].extension.type = GPOSLookup;
var GPOS = new r.VersionedStruct(r.uint32, {
        header: {
            scriptList: new r.Pointer(r.uint16, ScriptList),
            featureList: new r.Pointer(r.uint16, FeatureList),
            lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
        },
        65536: {},
        65537: { featureVariations: new r.Pointer(r.uint32, FeatureVariations) }
    });
var Sequence = new r.Array(r.uint16, r.uint16);
var AlternateSet = Sequence;
var Ligature = new r.Struct({
        glyph: r.uint16,
        compCount: r.uint16,
        components: new r.Array(r.uint16, function (t) {
            return t.compCount - 1;
        })
    });
var LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);
var GSUBLookup = new r.VersionedStruct('lookupType', {
        1: new r.VersionedStruct(r.uint16, {
            1: {
                coverage: new r.Pointer(r.uint16, Coverage),
                deltaGlyphID: r.int16
            },
            2: {
                coverage: new r.Pointer(r.uint16, Coverage),
                glyphCount: r.uint16,
                substitute: new r.LazyArray(r.uint16, 'glyphCount')
            }
        }),
        2: {
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            count: r.uint16,
            sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), 'count')
        },
        3: {
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            count: r.uint16,
            alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), 'count')
        },
        4: {
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            count: r.uint16,
            ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), 'count')
        },
        5: Context,
        6: ChainingContext,
        7: {
            substFormat: r.uint16,
            lookupType: r.uint16,
            extension: new r.Pointer(r.uint32, GSUBLookup)
        },
        8: {
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
            lookaheadGlyphCount: r.uint16,
            lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
            glyphCount: r.uint16,
            substitutes: new r.Array(r.uint16, 'glyphCount')
        }
    });
GSUBLookup.versions[7].extension.type = GSUBLookup;
var GSUB = new r.VersionedStruct(r.uint32, {
        header: {
            scriptList: new r.Pointer(r.uint16, ScriptList),
            featureList: new r.Pointer(r.uint16, FeatureList),
            lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup))
        },
        65536: {},
        65537: { featureVariations: new r.Pointer(r.uint32, FeatureVariations) }
    });
var JstfGSUBModList = new r.Array(r.uint16, r.uint16);
var JstfPriority = new r.Struct({
        shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
        shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
        shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
        shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
        shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
        extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
        extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
        extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
        extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
        extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
    });
var JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);
var JstfLangSysRecord = new r.Struct({
        tag: new r.String(4),
        jstfLangSys: new r.Pointer(r.uint16, JstfLangSys)
    });
var JstfScript = new r.Struct({
        extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)),
        defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
        langSysCount: r.uint16,
        langSysRecords: new r.Array(JstfLangSysRecord, 'langSysCount')
    });
var JstfScriptRecord = new r.Struct({
        tag: new r.String(4),
        script: new r.Pointer(r.uint16, JstfScript, { type: 'parent' })
    });
var JSTF = new r.Struct({
        version: r.uint32,
        scriptCount: r.uint16,
        scriptList: new r.Array(JstfScriptRecord, 'scriptCount')
    });
var VariableSizeNumber = function () {
        function VariableSizeNumber(size) {
            _classCallCheck(this, VariableSizeNumber);
            this._size = size;
        }
        VariableSizeNumber.prototype.decode = function decode(stream, parent) {
            switch (this.size(0, parent)) {
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
            }
        };
        VariableSizeNumber.prototype.size = function size(val, parent) {
            return restructure_src_utils.resolveLength(this._size, null, parent);
        };
        return VariableSizeNumber;
    }();
var MapDataEntry = new r.Struct({
        entry: new VariableSizeNumber(function (t) {
            return ((t.parent.entryFormat & 48) >> 4) + 1;
        }),
        outerIndex: function outerIndex(t) {
            return t.entry >> (t.parent.entryFormat & 15) + 1;
        },
        innerIndex: function innerIndex(t) {
            return t.entry & (1 << (t.parent.entryFormat & 15) + 1) - 1;
        }
    });
var DeltaSetIndexMap = new r.Struct({
        entryFormat: r.uint16,
        mapCount: r.uint16,
        mapData: new r.Array(MapDataEntry, 'mapCount')
    });
var HVAR = new r.Struct({
        majorVersion: r.uint16,
        minorVersion: r.uint16,
        itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
        advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
        LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
        RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap)
    });
var Signature = new r.Struct({
        format: r.uint32,
        length: r.uint32,
        offset: r.uint32
    });
var SignatureBlock = new r.Struct({
        reserved: new r.Reserved(r.uint16, 2),
        cbSignature: r.uint32,
        signature: new r.Buffer('cbSignature')
    });
var DSIG = new r.Struct({
        ulVersion: r.uint32,
        usNumSigs: r.uint16,
        usFlag: r.uint16,
        signatures: new r.Array(Signature, 'usNumSigs'),
        signatureBlocks: new r.Array(SignatureBlock, 'usNumSigs')
    });
var GaspRange = new r.Struct({
        rangeMaxPPEM: r.uint16,
        rangeGaspBehavior: new r.Bitfield(r.uint16, [
            'grayscale',
            'gridfit',
            'symmetricSmoothing',
            'symmetricGridfit'
        ])
    });
var gasp = new r.Struct({
        version: r.uint16,
        numRanges: r.uint16,
        gaspRanges: new r.Array(GaspRange, 'numRanges')
    });
var DeviceRecord = new r.Struct({
        pixelSize: r.uint8,
        maximumWidth: r.uint8,
        widths: new r.Array(r.uint8, function (t) {
            return t.parent.parent.maxp.numGlyphs;
        })
    });
var hdmx = new r.Struct({
        version: r.uint16,
        numRecords: r.int16,
        sizeDeviceRecord: r.int32,
        records: new r.Array(DeviceRecord, 'numRecords')
    });
var KernPair = new r.Struct({
        left: r.uint16,
        right: r.uint16,
        value: r.int16
    });
var ClassTable = new r.Struct({
        firstGlyph: r.uint16,
        nGlyphs: r.uint16,
        offsets: new r.Array(r.uint16, 'nGlyphs'),
        max: function max(t) {
            return t.offsets.length && Math.max.apply(Math, t.offsets);
        }
    });
var Kern2Array = new r.Struct({
        off: function off(t) {
            return t._startOffset - t.parent.parent._startOffset;
        },
        len: function len(t) {
            return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
        },
        values: new r.LazyArray(r.int16, 'len')
    });
var KernSubtable = new r.VersionedStruct('format', {
        0: {
            nPairs: r.uint16,
            searchRange: r.uint16,
            entrySelector: r.uint16,
            rangeShift: r.uint16,
            pairs: new r.Array(KernPair, 'nPairs')
        },
        2: {
            rowWidth: r.uint16,
            leftTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
            rightTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
            array: new r.Pointer(r.uint16, Kern2Array, { type: 'parent' })
        },
        3: {
            glyphCount: r.uint16,
            kernValueCount: r.uint8,
            leftClassCount: r.uint8,
            rightClassCount: r.uint8,
            flags: r.uint8,
            kernValue: new r.Array(r.int16, 'kernValueCount'),
            leftClass: new r.Array(r.uint8, 'glyphCount'),
            rightClass: new r.Array(r.uint8, 'glyphCount'),
            kernIndex: new r.Array(r.uint8, function (t) {
                return t.leftClassCount * t.rightClassCount;
            })
        }
    });
var KernTable = new r.VersionedStruct('version', {
        0: {
            subVersion: r.uint16,
            length: r.uint16,
            format: r.uint8,
            coverage: new r.Bitfield(r.uint8, [
                'horizontal',
                'minimum',
                'crossStream',
                'override'
            ]),
            subtable: KernSubtable,
            padding: new r.Reserved(r.uint8, function (t) {
                return t.length - t._currentOffset;
            })
        },
        1: {
            length: r.uint32,
            coverage: new r.Bitfield(r.uint8, [
                null,
                null,
                null,
                null,
                null,
                'variation',
                'crossStream',
                'vertical'
            ]),
            format: r.uint8,
            tupleIndex: r.uint16,
            subtable: KernSubtable,
            padding: new r.Reserved(r.uint8, function (t) {
                return t.length - t._currentOffset;
            })
        }
    });
var kern = new r.VersionedStruct(r.uint16, {
        0: {
            nTables: r.uint16,
            tables: new r.Array(KernTable, 'nTables')
        },
        1: {
            reserved: new r.Reserved(r.uint16),
            nTables: r.uint32,
            tables: new r.Array(KernTable, 'nTables')
        }
    });
var LTSH = new r.Struct({
        version: r.uint16,
        numGlyphs: r.uint16,
        yPels: new r.Array(r.uint8, 'numGlyphs')
    });
var PCLT = new r.Struct({
        version: r.uint16,
        fontNumber: r.uint32,
        pitch: r.uint16,
        xHeight: r.uint16,
        style: r.uint16,
        typeFamily: r.uint16,
        capHeight: r.uint16,
        symbolSet: r.uint16,
        typeface: new r.String(16),
        characterComplement: new r.String(8),
        fileName: new r.String(6),
        strokeWeight: new r.String(1),
        widthType: new r.String(1),
        serifStyle: r.uint8,
        reserved: new r.Reserved(r.uint8)
    });
var Ratio = new r.Struct({
        bCharSet: r.uint8,
        xRatio: r.uint8,
        yStartRatio: r.uint8,
        yEndRatio: r.uint8
    });
var vTable = new r.Struct({
        yPelHeight: r.uint16,
        yMax: r.int16,
        yMin: r.int16
    });
var VdmxGroup = new r.Struct({
        recs: r.uint16,
        startsz: r.uint8,
        endsz: r.uint8,
        entries: new r.Array(vTable, 'recs')
    });
var VDMX = new r.Struct({
        version: r.uint16,
        numRecs: r.uint16,
        numRatios: r.uint16,
        ratioRanges: new r.Array(Ratio, 'numRatios'),
        offsets: new r.Array(r.uint16, 'numRatios'),
        groups: new r.Array(VdmxGroup, 'numRecs')
    });
var vhea = new r.Struct({
        version: r.uint16,
        ascent: r.int16,
        descent: r.int16,
        lineGap: r.int16,
        advanceHeightMax: r.int16,
        minTopSideBearing: r.int16,
        minBottomSideBearing: r.int16,
        yMaxExtent: r.int16,
        caretSlopeRise: r.int16,
        caretSlopeRun: r.int16,
        caretOffset: r.int16,
        reserved: new r.Reserved(r.int16, 4),
        metricDataFormat: r.int16,
        numberOfMetrics: r.uint16
    });
var VmtxEntry = new r.Struct({
        advance: r.uint16,
        bearing: r.int16
    });
var vmtx = new r.Struct({
        metrics: new r.LazyArray(VmtxEntry, function (t) {
            return t.parent.vhea.numberOfMetrics;
        }),
        bearings: new r.LazyArray(r.int16, function (t) {
            return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
        })
    });
var shortFrac = new r.Fixed(16, 'BE', 14);
var Correspondence = new r.Struct({
        fromCoord: shortFrac,
        toCoord: shortFrac
    });
var Segment = new r.Struct({
        pairCount: r.uint16,
        correspondence: new r.Array(Correspondence, 'pairCount')
    });
var avar = new r.Struct({
        version: r.fixed32,
        axisCount: r.uint32,
        segment: new r.Array(Segment, 'axisCount')
    });
var UnboundedArrayAccessor = function () {
        function UnboundedArrayAccessor(type, stream, parent) {
            _classCallCheck(this, UnboundedArrayAccessor);
            this.type = type;
            this.stream = stream;
            this.parent = parent;
            this.base = this.stream.pos;
            this._items = [];
        }
        UnboundedArrayAccessor.prototype.getItem = function getItem(index) {
            if (this._items[index] == null) {
                var pos = this.stream.pos;
                this.stream.pos = this.base + this.type.size(null, this.parent) * index;
                this._items[index] = this.type.decode(this.stream, this.parent);
                this.stream.pos = pos;
            }
            return this._items[index];
        };
        UnboundedArrayAccessor.prototype.inspect = function inspect() {
            return '[UnboundedArray ' + this.type.constructor.name + ']';
        };
        return UnboundedArrayAccessor;
    }();
var UnboundedArray = function (_r$Array) {
        _inherits(UnboundedArray, _r$Array);
        function UnboundedArray(type) {
            _classCallCheck(this, UnboundedArray);
            return _possibleConstructorReturn(this, _r$Array.call(this, type, 0));
        }
        UnboundedArray.prototype.decode = function decode(stream, parent) {
            return new UnboundedArrayAccessor(this.type, stream, parent);
        };
        return UnboundedArray;
    }(r.Array);
var LookupTable = function LookupTable() {
    var ValueType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r.uint16;
    var Shadow = function () {
            function Shadow(type) {
                _classCallCheck(this, Shadow);
                this.type = type;
            }
            Shadow.prototype.decode = function decode(stream, ctx) {
                ctx = ctx.parent.parent;
                return this.type.decode(stream, ctx);
            };
            Shadow.prototype.size = function size(val, ctx) {
                ctx = ctx.parent.parent;
                return this.type.size(val, ctx);
            };
            Shadow.prototype.encode = function encode(stream, val, ctx) {
                ctx = ctx.parent.parent;
                return this.type.encode(stream, val, ctx);
            };
            return Shadow;
        }();
    ValueType = new Shadow(ValueType);
    var BinarySearchHeader = new r.Struct({
            unitSize: r.uint16,
            nUnits: r.uint16,
            searchRange: r.uint16,
            entrySelector: r.uint16,
            rangeShift: r.uint16
        });
    var LookupSegmentSingle = new r.Struct({
            lastGlyph: r.uint16,
            firstGlyph: r.uint16,
            value: ValueType
        });
    var LookupSegmentArray = new r.Struct({
            lastGlyph: r.uint16,
            firstGlyph: r.uint16,
            values: new r.Pointer(r.uint16, new r.Array(ValueType, function (t) {
                return t.lastGlyph - t.firstGlyph + 1;
            }), { type: 'parent' })
        });
    var LookupSingle = new r.Struct({
            glyph: r.uint16,
            value: ValueType
        });
    return new r.VersionedStruct(r.uint16, {
        0: { values: new UnboundedArray(ValueType) },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new r.Array(LookupSegmentSingle, function (t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new r.Array(LookupSegmentArray, function (t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new r.Array(LookupSingle, function (t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        8: {
            firstGlyph: r.uint16,
            count: r.uint16,
            values: new r.Array(ValueType, 'count')
        }
    });
};
function StateTable() {
    var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;
    var entry = _Object$assign({
            newState: r.uint16,
            flags: r.uint16
        }, entryData);
    var Entry = new r.Struct(entry);
    var StateArray = new UnboundedArray(new r.Array(r.uint16, function (t) {
            return t.nClasses;
        }));
    var StateHeader = new r.Struct({
            nClasses: r.uint32,
            classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
            stateArray: new r.Pointer(r.uint32, StateArray),
            entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry))
        });
    return StateHeader;
}
function StateTable1() {
    var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;
    var ClassLookupTable = new r.Struct({
            version: function version() {
                return 8;
            },
            firstGlyph: r.uint16,
            values: new r.Array(r.uint8, r.uint16)
        });
    var entry = _Object$assign({
            newStateOffset: r.uint16,
            newState: function newState(t) {
                return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
            },
            flags: r.uint16
        }, entryData);
    var Entry = new r.Struct(entry);
    var StateArray = new UnboundedArray(new r.Array(r.uint8, function (t) {
            return t.nClasses;
        }));
    var StateHeader1 = new r.Struct({
            nClasses: r.uint16,
            classTable: new r.Pointer(r.uint16, ClassLookupTable),
            stateArray: new r.Pointer(r.uint16, StateArray),
            entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry))
        });
    return StateHeader1;
}
var BslnSubtable = new r.VersionedStruct('format', {
        0: { deltas: new r.Array(r.int16, 32) },
        1: {
            deltas: new r.Array(r.int16, 32),
            mappingData: new LookupTable(r.uint16)
        },
        2: {
            standardGlyph: r.uint16,
            controlPoints: new r.Array(r.uint16, 32)
        },
        3: {
            standardGlyph: r.uint16,
            controlPoints: new r.Array(r.uint16, 32),
            mappingData: new LookupTable(r.uint16)
        }
    });
var bsln = new r.Struct({
        version: r.fixed32,
        format: r.uint16,
        defaultBaseline: r.uint16,
        subtable: BslnSubtable
    });
var Setting = new r.Struct({
        setting: r.uint16,
        nameIndex: r.int16,
        name: function name(t) {
            return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
        }
    });
var FeatureName = new r.Struct({
        feature: r.uint16,
        nSettings: r.uint16,
        settingTable: new r.Pointer(r.uint32, new r.Array(Setting, 'nSettings'), { type: 'parent' }),
        featureFlags: new r.Bitfield(r.uint8, [
            null,
            null,
            null,
            null,
            null,
            null,
            'hasDefault',
            'exclusive'
        ]),
        defaultSetting: r.uint8,
        nameIndex: r.int16,
        name: function name(t) {
            return t.parent.parent.name.records.fontFeatures[t.nameIndex];
        }
    });
var feat = new r.Struct({
        version: r.fixed32,
        featureNameCount: r.uint16,
        reserved1: new r.Reserved(r.uint16),
        reserved2: new r.Reserved(r.uint32),
        featureNames: new r.Array(FeatureName, 'featureNameCount')
    });
var Axis$1 = new r.Struct({
        axisTag: new r.String(4),
        minValue: r.fixed32,
        defaultValue: r.fixed32,
        maxValue: r.fixed32,
        flags: r.uint16,
        nameID: r.uint16,
        name: function name(t) {
            return t.parent.parent.name.records.fontFeatures[t.nameID];
        }
    });
var Instance = new r.Struct({
        nameID: r.uint16,
        name: function name(t) {
            return t.parent.parent.name.records.fontFeatures[t.nameID];
        },
        flags: r.uint16,
        coord: new r.Array(r.fixed32, function (t) {
            return t.parent.axisCount;
        }),
        postscriptNameID: new r.Optional(r.uint16, function (t) {
            return t.parent.instanceSize - t._currentOffset > 0;
        })
    });
var fvar = new r.Struct({
        version: r.fixed32,
        offsetToData: r.uint16,
        countSizePairs: r.uint16,
        axisCount: r.uint16,
        axisSize: r.uint16,
        instanceCount: r.uint16,
        instanceSize: r.uint16,
        axis: new r.Array(Axis$1, 'axisCount'),
        instance: new r.Array(Instance, 'instanceCount')
    });
var shortFrac$1 = new r.Fixed(16, 'BE', 14);
var Offset = function () {
        function Offset() {
            _classCallCheck(this, Offset);
        }
        Offset.decode = function decode(stream, parent) {
            return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
        };
        return Offset;
    }();
var gvar = new r.Struct({
        version: r.uint16,
        reserved: new r.Reserved(r.uint16),
        axisCount: r.uint16,
        globalCoordCount: r.uint16,
        globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
        glyphCount: r.uint16,
        flags: r.uint16,
        offsetToData: r.uint32,
        offsets: new r.Array(new r.Pointer(Offset, 'void', {
            relativeTo: 'offsetToData',
            allowNull: false
        }), function (t) {
            return t.glyphCount + 1;
        })
    });
var ClassTable$1 = new r.Struct({
        length: r.uint16,
        coverage: r.uint16,
        subFeatureFlags: r.uint32,
        stateTable: new StateTable1()
    });
var WidthDeltaRecord = new r.Struct({
        justClass: r.uint32,
        beforeGrowLimit: r.fixed32,
        beforeShrinkLimit: r.fixed32,
        afterGrowLimit: r.fixed32,
        afterShrinkLimit: r.fixed32,
        growFlags: r.uint16,
        shrinkFlags: r.uint16
    });
var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);
var ActionData = new r.VersionedStruct('actionType', {
        0: {
            lowerLimit: r.fixed32,
            upperLimit: r.fixed32,
            order: r.uint16,
            glyphs: new r.Array(r.uint16, r.uint16)
        },
        1: { addGlyph: r.uint16 },
        2: {
            substThreshold: r.fixed32,
            addGlyph: r.uint16,
            substGlyph: r.uint16
        },
        3: {},
        4: {
            variationAxis: r.uint32,
            minimumLimit: r.fixed32,
            noStretchValue: r.fixed32,
            maximumLimit: r.fixed32
        },
        5: {
            flags: r.uint16,
            glyph: r.uint16
        }
    });
var Action = new r.Struct({
        actionClass: r.uint16,
        actionType: r.uint16,
        actionLength: r.uint32,
        actionData: ActionData,
        padding: new r.Reserved(r.uint8, function (t) {
            return t.actionLength - t._currentOffset;
        })
    });
var PostcompensationAction = new r.Array(Action, r.uint32);
var PostCompensationTable = new r.Struct({ lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction)) });
var JustificationTable = new r.Struct({
        classTable: new r.Pointer(r.uint16, ClassTable$1, { type: 'parent' }),
        wdcOffset: r.uint16,
        postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, { type: 'parent' }),
        widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, {
            type: 'parent',
            relativeTo: 'wdcOffset'
        }))
    });
var just = new r.Struct({
        version: r.uint32,
        format: r.uint16,
        horizontal: new r.Pointer(r.uint16, JustificationTable),
        vertical: new r.Pointer(r.uint16, JustificationTable)
    });
var LigatureData = { action: r.uint16 };
var ContextualData = {
        markIndex: r.uint16,
        currentIndex: r.uint16
    };
var InsertionData = {
        currentInsertIndex: r.uint16,
        markedInsertIndex: r.uint16
    };
var SubstitutionTable = new r.Struct({ items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable())) });
var SubtableData = new r.VersionedStruct('type', {
        0: { stateTable: new StateTable() },
        1: {
            stateTable: new StateTable(ContextualData),
            substitutionTable: new r.Pointer(r.uint32, SubstitutionTable)
        },
        2: {
            stateTable: new StateTable(LigatureData),
            ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
            components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
            ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
        },
        4: { lookupTable: new LookupTable() },
        5: {
            stateTable: new StateTable(InsertionData),
            insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
        }
    });
var Subtable = new r.Struct({
        length: r.uint32,
        coverage: r.uint24,
        type: r.uint8,
        subFeatureFlags: r.uint32,
        table: SubtableData,
        padding: new r.Reserved(r.uint8, function (t) {
            return t.length - t._currentOffset;
        })
    });
var FeatureEntry = new r.Struct({
        featureType: r.uint16,
        featureSetting: r.uint16,
        enableFlags: r.uint32,
        disableFlags: r.uint32
    });
var MorxChain = new r.Struct({
        defaultFlags: r.uint32,
        chainLength: r.uint32,
        nFeatureEntries: r.uint32,
        nSubtables: r.uint32,
        features: new r.Array(FeatureEntry, 'nFeatureEntries'),
        subtables: new r.Array(Subtable, 'nSubtables')
    });
var morx = new r.Struct({
        version: r.uint16,
        unused: new r.Reserved(r.uint16),
        nChains: r.uint32,
        chains: new r.Array(MorxChain, 'nChains')
    });
var OpticalBounds = new r.Struct({
        left: r.int16,
        top: r.int16,
        right: r.int16,
        bottom: r.int16
    });
var opbd = new r.Struct({
        version: r.fixed32,
        format: r.uint16,
        lookupTable: new LookupTable(OpticalBounds)
    });
var tables = {};
tables.cmap = cmap;
tables.head = head;
tables.hhea = hhea;
tables.hmtx = hmtx;
tables.maxp = maxp;
tables.name = NameTable;
tables['OS/2'] = OS2;
tables.post = post;
tables.fpgm = fpgm;
tables.loca = loca;
tables.prep = prep;
tables['cvt '] = cvt;
tables.glyf = glyf;
tables['CFF '] = CFFFont;
tables['CFF2'] = CFFFont;
tables.VORG = VORG;
tables.EBLC = EBLC;
tables.CBLC = tables.EBLC;
tables.sbix = sbix;
tables.COLR = COLR;
tables.CPAL = CPAL;
tables.BASE = BASE;
tables.GDEF = GDEF;
tables.GPOS = GPOS;
tables.GSUB = GSUB;
tables.JSTF = JSTF;
tables.HVAR = HVAR;
tables.DSIG = DSIG;
tables.gasp = gasp;
tables.hdmx = hdmx;
tables.kern = kern;
tables.LTSH = LTSH;
tables.PCLT = PCLT;
tables.VDMX = VDMX;
tables.vhea = vhea;
tables.vmtx = vmtx;
tables.avar = avar;
tables.bsln = bsln;
tables.feat = feat;
tables.fvar = fvar;
tables.gvar = gvar;
tables.just = just;
tables.morx = morx;
tables.opbd = opbd;
var TableEntry = new r.Struct({
        tag: new r.String(4),
        checkSum: r.uint32,
        offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
        length: r.uint32
    });
var Directory = new r.Struct({
        tag: new r.String(4),
        numTables: r.uint16,
        searchRange: r.uint16,
        entrySelector: r.uint16,
        rangeShift: r.uint16,
        tables: new r.Array(TableEntry, 'numTables')
    });
Directory.process = function () {
    var tables = {};
    for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length)
                break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done)
                break;
            _ref = _i.value;
        }
        var table = _ref;
        tables[table.tag] = table;
    }
    this.tables = tables;
};
Directory.preEncode = function (stream) {
    var tables$$ = [];
    for (var tag in this.tables) {
        var table = this.tables[tag];
        if (table) {
            tables$$.push({
                tag: tag,
                checkSum: 0,
                offset: new r.VoidPointer(tables[tag], table),
                length: tables[tag].size(table)
            });
        }
    }
    this.tag = 'true';
    this.numTables = tables$$.length;
    this.tables = tables$$;
    var maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    var maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
function binarySearch(arr, cmp) {
    var min = 0;
    var max = arr.length - 1;
    while (min <= max) {
        var mid = min + max >> 1;
        var res = cmp(arr[mid]);
        if (res < 0) {
            max = mid - 1;
        } else if (res > 0) {
            min = mid + 1;
        } else {
            return mid;
        }
    }
    return -1;
}
function range(index, end) {
    var range = [];
    while (index < end) {
        range.push(index++);
    }
    return range;
}
var _class$1;
function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }
    return desc;
}
try {
    var iconv = require('iconv-lite');
} catch (err) {
}
var CmapProcessor = (_class$1 = function () {
        function CmapProcessor(cmapTable) {
            _classCallCheck(this, CmapProcessor);
            this.encoding = null;
            this.cmap = this.findSubtable(cmapTable, [
                [
                    3,
                    10
                ],
                [
                    0,
                    6
                ],
                [
                    0,
                    4
                ],
                [
                    3,
                    1
                ],
                [
                    0,
                    3
                ],
                [
                    0,
                    2
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    0
                ]
            ]);
            if (!this.cmap && iconv) {
                for (var _iterator = cmapTable.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length)
                            break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done)
                            break;
                        _ref = _i.value;
                    }
                    var cmap = _ref;
                    var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
                    if (iconv.encodingExists(encoding)) {
                        this.cmap = cmap.table;
                        this.encoding = encoding;
                    }
                }
            }
            if (!this.cmap) {
                throw new Error('Could not find a supported cmap table');
            }
            this.uvs = this.findSubtable(cmapTable, [[
                    0,
                    5
                ]]);
            if (this.uvs && this.uvs.version !== 14) {
                this.uvs = null;
            }
        }
        CmapProcessor.prototype.findSubtable = function findSubtable(cmapTable, pairs) {
            for (var _iterator2 = pairs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var _ref3 = _ref2, platformID = _ref3[0], encodingID = _ref3[1];
                for (var _iterator3 = cmapTable.tables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                    var _ref4;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length)
                            break;
                        _ref4 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done)
                            break;
                        _ref4 = _i3.value;
                    }
                    var cmap = _ref4;
                    if (cmap.platformID === platformID && cmap.encodingID === encodingID) {
                        return cmap.table;
                    }
                }
            }
            return null;
        };
        CmapProcessor.prototype.lookup = function lookup(codepoint, variationSelector) {
            if (this.encoding) {
                var buf = iconv.encode(_String$fromCodePoint(codepoint), this.encoding);
                codepoint = 0;
                for (var i = 0; i < buf.length; i++) {
                    codepoint = codepoint << 8 | buf[i];
                }
            } else if (variationSelector) {
                var gid = this.getVariationSelector(codepoint, variationSelector);
                if (gid) {
                    return gid;
                }
            }
            var cmap = this.cmap;
            switch (cmap.version) {
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4: {
                    var min = 0;
                    var max = cmap.segCount - 1;
                    while (min <= max) {
                        var mid = min + max >> 1;
                        if (codepoint < cmap.startCode.get(mid)) {
                            max = mid - 1;
                        } else if (codepoint > cmap.endCode.get(mid)) {
                            min = mid + 1;
                        } else {
                            var rangeOffset = cmap.idRangeOffset.get(mid);
                            var _gid = void 0;
                            if (rangeOffset === 0) {
                                _gid = codepoint + cmap.idDelta.get(mid);
                            } else {
                                var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                _gid = cmap.glyphIndexArray.get(index) || 0;
                                if (_gid !== 0) {
                                    _gid += cmap.idDelta.get(mid);
                                }
                            }
                            return _gid & 65535;
                        }
                    }
                    return 0;
                }
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13: {
                    var _min = 0;
                    var _max = cmap.nGroups - 1;
                    while (_min <= _max) {
                        var _mid = _min + _max >> 1;
                        var group = cmap.groups.get(_mid);
                        if (codepoint < group.startCharCode) {
                            _max = _mid - 1;
                        } else if (codepoint > group.endCharCode) {
                            _min = _mid + 1;
                        } else {
                            if (cmap.version === 12) {
                                return group.glyphID + (codepoint - group.startCharCode);
                            } else {
                                return group.glyphID;
                            }
                        }
                    }
                    return 0;
                }
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error('Unknown cmap format ' + cmap.version);
            }
        };
        CmapProcessor.prototype.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
            if (!this.uvs) {
                return 0;
            }
            var selectors = this.uvs.varSelectors.toArray();
            var i = binarySearch(selectors, function (x) {
                    return variationSelector - x.varSelector;
                });
            var sel = selectors[i];
            if (i !== -1 && sel.defaultUVS) {
                i = binarySearch(sel.defaultUVS, function (x) {
                    return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? +1 : 0;
                });
            }
            if (i !== -1 && sel.nonDefaultUVS) {
                i = binarySearch(sel.nonDefaultUVS, function (x) {
                    return codepoint - x.unicodeValue;
                });
                if (i !== -1) {
                    return sel.nonDefaultUVS[i].glyphID;
                }
            }
            return 0;
        };
        CmapProcessor.prototype.getCharacterSet = function getCharacterSet() {
            var cmap = this.cmap;
            switch (cmap.version) {
            case 0:
                return range(0, cmap.codeMap.length);
            case 4: {
                    var res = [];
                    var endCodes = cmap.endCode.toArray();
                    for (var i = 0; i < endCodes.length; i++) {
                        var tail = endCodes[i] + 1;
                        var start = cmap.startCode.get(i);
                        res.push.apply(res, range(start, tail));
                    }
                    return res;
                }
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13: {
                    var _res = [];
                    for (var _iterator4 = cmap.groups.toArray(), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
                        var _ref5;
                        if (_isArray4) {
                            if (_i4 >= _iterator4.length)
                                break;
                            _ref5 = _iterator4[_i4++];
                        } else {
                            _i4 = _iterator4.next();
                            if (_i4.done)
                                break;
                            _ref5 = _i4.value;
                        }
                        var group = _ref5;
                        _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
                    }
                    return _res;
                }
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error('Unknown cmap format ' + cmap.version);
            }
        };
        CmapProcessor.prototype.codePointsForGlyph = function codePointsForGlyph(gid) {
            var cmap = this.cmap;
            switch (cmap.version) {
            case 0: {
                    var res = [];
                    for (var i = 0; i < 256; i++) {
                        if (cmap.codeMap.get(i) === gid) {
                            res.push(i);
                        }
                    }
                    return res;
                }
            case 4: {
                    var _res2 = [];
                    for (var _i5 = 0; _i5 < cmap.segCount; _i5++) {
                        var end = cmap.endCode.get(_i5);
                        var start = cmap.startCode.get(_i5);
                        var rangeOffset = cmap.idRangeOffset.get(_i5);
                        var delta = cmap.idDelta.get(_i5);
                        for (var c = start; c <= end; c++) {
                            var g = 0;
                            if (rangeOffset === 0) {
                                g = c + delta;
                            } else {
                                var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i5);
                                g = cmap.glyphIndexArray.get(index) || 0;
                                if (g !== 0) {
                                    g += delta;
                                }
                            }
                            if (g === gid) {
                                _res2.push(c);
                            }
                        }
                    }
                    return _res2;
                }
            case 12: {
                    var _res3 = [];
                    for (var _iterator5 = cmap.groups.toArray(), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
                        var _ref6;
                        if (_isArray5) {
                            if (_i6 >= _iterator5.length)
                                break;
                            _ref6 = _iterator5[_i6++];
                        } else {
                            _i6 = _iterator5.next();
                            if (_i6.done)
                                break;
                            _ref6 = _i6.value;
                        }
                        var group = _ref6;
                        if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) {
                            _res3.push(group.startCharCode + (gid - group.glyphID));
                        }
                    }
                    return _res3;
                }
            case 13: {
                    var _res4 = [];
                    for (var _iterator6 = cmap.groups.toArray(), _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
                        var _ref7;
                        if (_isArray6) {
                            if (_i7 >= _iterator6.length)
                                break;
                            _ref7 = _iterator6[_i7++];
                        } else {
                            _i7 = _iterator6.next();
                            if (_i7.done)
                                break;
                            _ref7 = _i7.value;
                        }
                        var _group = _ref7;
                        if (gid === _group.glyphID) {
                            _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
                        }
                    }
                    return _res4;
                }
            default:
                throw new Error('Unknown cmap format ' + cmap.version);
            }
        };
        return CmapProcessor;
    }(), (_applyDecoratedDescriptor$1(_class$1.prototype, 'getCharacterSet', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'getCharacterSet'), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, 'codePointsForGlyph', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'codePointsForGlyph'), _class$1.prototype)), _class$1);
var KernProcessor = function () {
        function KernProcessor(font) {
            _classCallCheck(this, KernProcessor);
            this.kern = font.kern;
        }
        KernProcessor.prototype.process = function process(glyphs, positions) {
            for (var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++) {
                var left = glyphs[glyphIndex].id;
                var right = glyphs[glyphIndex + 1].id;
                positions[glyphIndex].xAdvance += this.getKerning(left, right);
            }
        };
        KernProcessor.prototype.getKerning = function getKerning(left, right) {
            var res = 0;
            for (var _iterator = this.kern.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var table = _ref;
                if (table.coverage.crossStream) {
                    continue;
                }
                switch (table.version) {
                case 0:
                    if (!table.coverage.horizontal) {
                        continue;
                    }
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) {
                        continue;
                    }
                    break;
                default:
                    throw new Error('Unsupported kerning table version ' + table.version);
                }
                var val = 0;
                var s = table.subtable;
                switch (table.format) {
                case 0:
                    var pairIdx = binarySearch(s.pairs, function (pair) {
                            return left - pair.left || right - pair.right;
                        });
                    if (pairIdx >= 0) {
                        val = s.pairs[pairIdx].value;
                    }
                    break;
                case 2:
                    var leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) {
                        leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    } else {
                        leftOffset = s.array.off;
                    }
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) {
                        rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    }
                    var index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) {
                        return 0;
                    }
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error('Unsupported kerning sub-table format ' + table.format);
                }
                if (table.coverage.override) {
                    res = val;
                } else {
                    res += val;
                }
            }
            return res;
        };
        return KernProcessor;
    }();
var UnicodeLayoutEngine = function () {
        function UnicodeLayoutEngine(font) {
            _classCallCheck(this, UnicodeLayoutEngine);
            this.font = font;
        }
        UnicodeLayoutEngine.prototype.positionGlyphs = function positionGlyphs(glyphs, positions) {
            var clusterStart = 0;
            var clusterEnd = 0;
            for (var index = 0; index < glyphs.length; index++) {
                var glyph = glyphs[index];
                if (glyph.isMark) {
                    clusterEnd = index;
                } else {
                    if (clusterStart !== clusterEnd) {
                        this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                    }
                    clusterStart = clusterEnd = index;
                }
            }
            if (clusterStart !== clusterEnd) {
                this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
            }
            return positions;
        };
        UnicodeLayoutEngine.prototype.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
            var base = glyphs[clusterStart];
            var baseBox = base.cbox.copy();
            if (base.codePoints.length > 1) {
                baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
            }
            var xOffset = -positions[clusterStart].xAdvance;
            var yOffset = 0;
            var yGap = this.font.unitsPerEm / 16;
            for (var index = clusterStart + 1; index <= clusterEnd; index++) {
                var mark = glyphs[index];
                var markBox = mark.cbox;
                var position = positions[index];
                var combiningClass = this.getCombiningClass(mark.codePoints[0]);
                if (combiningClass !== 'Not_Reordered') {
                    position.xOffset = position.yOffset = 0;
                    switch (combiningClass) {
                    case 'Double_Above':
                    case 'Double_Below':
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case 'Attached_Below_Left':
                    case 'Below_Left':
                    case 'Above_Left':
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case 'Attached_Above_Right':
                    case 'Below_Right':
                    case 'Above_Right':
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                    }
                    switch (combiningClass) {
                    case 'Double_Below':
                    case 'Below_Left':
                    case 'Below':
                    case 'Below_Right':
                    case 'Attached_Below_Left':
                    case 'Attached_Below':
                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') {
                            baseBox.minY += yGap;
                        }
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case 'Double_Above':
                    case 'Above_Left':
                    case 'Above':
                    case 'Above_Right':
                    case 'Attached_Above':
                    case 'Attached_Above_Right':
                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') {
                            baseBox.maxY += yGap;
                        }
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                    }
                    position.xAdvance = position.yAdvance = 0;
                    position.xOffset += xOffset;
                    position.yOffset += yOffset;
                } else {
                    xOffset -= position.xAdvance;
                    yOffset -= position.yAdvance;
                }
            }
            return;
        };
        UnicodeLayoutEngine.prototype.getCombiningClass = function getCombiningClass(codePoint) {
            var combiningClass = unicode.getCombiningClass(codePoint);
            if ((codePoint & ~255) === 3584) {
                if (combiningClass === 'Not_Reordered') {
                    switch (codePoint) {
                    case 3633:
                    case 3636:
                    case 3637:
                    case 3638:
                    case 3639:
                    case 3655:
                    case 3660:
                    case 3645:
                    case 3662:
                        return 'Above_Right';
                    case 3761:
                    case 3764:
                    case 3765:
                    case 3766:
                    case 3767:
                    case 3771:
                    case 3788:
                    case 3789:
                        return 'Above';
                    case 3772:
                        return 'Below';
                    }
                } else if (codePoint === 3642) {
                    return 'Below_Right';
                }
            }
            switch (combiningClass) {
            case 'CCC10':
            case 'CCC11':
            case 'CCC12':
            case 'CCC13':
            case 'CCC14':
            case 'CCC15':
            case 'CCC16':
            case 'CCC17':
            case 'CCC18':
            case 'CCC20':
            case 'CCC22':
                return 'Below';
            case 'CCC23':
                return 'Attached_Above';
            case 'CCC24':
                return 'Above_Right';
            case 'CCC25':
            case 'CCC19':
                return 'Above_Left';
            case 'CCC26':
                return 'Above';
            case 'CCC21':
                break;
            case 'CCC27':
            case 'CCC28':
            case 'CCC30':
            case 'CCC31':
            case 'CCC33':
            case 'CCC34':
            case 'CCC35':
            case 'CCC36':
                return 'Above';
            case 'CCC29':
            case 'CCC32':
                return 'Below';
            case 'CCC103':
                return 'Below_Right';
            case 'CCC107':
                return 'Above_Right';
            case 'CCC118':
                return 'Below';
            case 'CCC122':
                return 'Above';
            case 'CCC129':
            case 'CCC132':
                return 'Below';
            case 'CCC130':
                return 'Above';
            }
            return combiningClass;
        };
        return UnicodeLayoutEngine;
    }();
var BBox = function () {
        function BBox() {
            var minX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
            var minY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
            var maxX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -Infinity;
            var maxY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -Infinity;
            _classCallCheck(this, BBox);
            this.minX = minX;
            this.minY = minY;
            this.maxX = maxX;
            this.maxY = maxY;
        }
        BBox.prototype.addPoint = function addPoint(x, y) {
            if (Math.abs(x) !== Infinity) {
                if (x < this.minX) {
                    this.minX = x;
                }
                if (x > this.maxX) {
                    this.maxX = x;
                }
            }
            if (Math.abs(y) !== Infinity) {
                if (y < this.minY) {
                    this.minY = y;
                }
                if (y > this.maxY) {
                    this.maxY = y;
                }
            }
        };
        BBox.prototype.copy = function copy() {
            return new BBox(this.minX, this.minY, this.maxX, this.maxY);
        };
        _createClass(BBox, [
            {
                key: 'width',
                get: function get() {
                    return this.maxX - this.minX;
                }
            },
            {
                key: 'height',
                get: function get() {
                    return this.maxY - this.minY;
                }
            }
        ]);
        return BBox;
    }();
var UNICODE_SCRIPTS = {
        Caucasian_Albanian: 'aghb',
        Arabic: 'arab',
        Imperial_Aramaic: 'armi',
        Armenian: 'armn',
        Avestan: 'avst',
        Balinese: 'bali',
        Bamum: 'bamu',
        Bassa_Vah: 'bass',
        Batak: 'batk',
        Bengali: [
            'bng2',
            'beng'
        ],
        Bopomofo: 'bopo',
        Brahmi: 'brah',
        Braille: 'brai',
        Buginese: 'bugi',
        Buhid: 'buhd',
        Chakma: 'cakm',
        Canadian_Aboriginal: 'cans',
        Carian: 'cari',
        Cham: 'cham',
        Cherokee: 'cher',
        Coptic: 'copt',
        Cypriot: 'cprt',
        Cyrillic: 'cyrl',
        Devanagari: [
            'dev2',
            'deva'
        ],
        Deseret: 'dsrt',
        Duployan: 'dupl',
        Egyptian_Hieroglyphs: 'egyp',
        Elbasan: 'elba',
        Ethiopic: 'ethi',
        Georgian: 'geor',
        Glagolitic: 'glag',
        Gothic: 'goth',
        Grantha: 'gran',
        Greek: 'grek',
        Gujarati: [
            'gjr2',
            'gujr'
        ],
        Gurmukhi: [
            'gur2',
            'guru'
        ],
        Hangul: 'hang',
        Han: 'hani',
        Hanunoo: 'hano',
        Hebrew: 'hebr',
        Hiragana: 'hira',
        Pahawh_Hmong: 'hmng',
        Katakana_Or_Hiragana: 'hrkt',
        Old_Italic: 'ital',
        Javanese: 'java',
        Kayah_Li: 'kali',
        Katakana: 'kana',
        Kharoshthi: 'khar',
        Khmer: 'khmr',
        Khojki: 'khoj',
        Kannada: [
            'knd2',
            'knda'
        ],
        Kaithi: 'kthi',
        Tai_Tham: 'lana',
        Lao: 'lao ',
        Latin: 'latn',
        Lepcha: 'lepc',
        Limbu: 'limb',
        Linear_A: 'lina',
        Linear_B: 'linb',
        Lisu: 'lisu',
        Lycian: 'lyci',
        Lydian: 'lydi',
        Mahajani: 'mahj',
        Mandaic: 'mand',
        Manichaean: 'mani',
        Mende_Kikakui: 'mend',
        Meroitic_Cursive: 'merc',
        Meroitic_Hieroglyphs: 'mero',
        Malayalam: [
            'mlm2',
            'mlym'
        ],
        Modi: 'modi',
        Mongolian: 'mong',
        Mro: 'mroo',
        Meetei_Mayek: 'mtei',
        Myanmar: [
            'mym2',
            'mymr'
        ],
        Old_North_Arabian: 'narb',
        Nabataean: 'nbat',
        Nko: 'nko ',
        Ogham: 'ogam',
        Ol_Chiki: 'olck',
        Old_Turkic: 'orkh',
        Oriya: [
            'ory2',
            'orya'
        ],
        Osmanya: 'osma',
        Palmyrene: 'palm',
        Pau_Cin_Hau: 'pauc',
        Old_Permic: 'perm',
        Phags_Pa: 'phag',
        Inscriptional_Pahlavi: 'phli',
        Psalter_Pahlavi: 'phlp',
        Phoenician: 'phnx',
        Miao: 'plrd',
        Inscriptional_Parthian: 'prti',
        Rejang: 'rjng',
        Runic: 'runr',
        Samaritan: 'samr',
        Old_South_Arabian: 'sarb',
        Saurashtra: 'saur',
        Shavian: 'shaw',
        Sharada: 'shrd',
        Siddham: 'sidd',
        Khudawadi: 'sind',
        Sinhala: 'sinh',
        Sora_Sompeng: 'sora',
        Sundanese: 'sund',
        Syloti_Nagri: 'sylo',
        Syriac: 'syrc',
        Tagbanwa: 'tagb',
        Takri: 'takr',
        Tai_Le: 'tale',
        New_Tai_Lue: 'talu',
        Tamil: [
            'tml2',
            'taml'
        ],
        Tai_Viet: 'tavt',
        Telugu: [
            'tel2',
            'telu'
        ],
        Tifinagh: 'tfng',
        Tagalog: 'tglg',
        Thaana: 'thaa',
        Thai: 'thai',
        Tibetan: 'tibt',
        Tirhuta: 'tirh',
        Ugaritic: 'ugar',
        Vai: 'vai ',
        Warang_Citi: 'wara',
        Old_Persian: 'xpeo',
        Cuneiform: 'xsux',
        Yi: 'yi  ',
        Inherited: 'zinh',
        Common: 'zyyy',
        Unknown: 'zzzz'
    };
var OPENTYPE_SCRIPTS = {};
for (var script in UNICODE_SCRIPTS) {
    var tag = UNICODE_SCRIPTS[script];
    if (Array.isArray(tag)) {
        for (var _iterator = tag, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length)
                    break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done)
                    break;
                _ref = _i.value;
            }
            var t = _ref;
            OPENTYPE_SCRIPTS[t] = script;
        }
    } else {
        OPENTYPE_SCRIPTS[tag] = script;
    }
}
function fromOpenType(tag) {
    return OPENTYPE_SCRIPTS[tag];
}
function forString(string) {
    var len = string.length;
    var idx = 0;
    while (idx < len) {
        var code = string.charCodeAt(idx++);
        if (55296 <= code && code <= 56319 && idx < len) {
            var next = string.charCodeAt(idx);
            if (56320 <= next && next <= 57343) {
                idx++;
                code = ((code & 1023) << 10) + (next & 1023) + 65536;
            }
        }
        var _script = unicode.getScript(code);
        if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') {
            return UNICODE_SCRIPTS[_script];
        }
    }
    return UNICODE_SCRIPTS.Unknown;
}
function forCodePoints(codePoints) {
    for (var i = 0; i < codePoints.length; i++) {
        var codePoint = codePoints[i];
        var _script2 = unicode.getScript(codePoint);
        if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') {
            return UNICODE_SCRIPTS[_script2];
        }
    }
    return UNICODE_SCRIPTS.Unknown;
}
var RTL = {
        arab: true,
        hebr: true,
        syrc: true,
        thaa: true,
        cprt: true,
        khar: true,
        phnx: true,
        'nko ': true,
        lydi: true,
        avst: true,
        armi: true,
        phli: true,
        prti: true,
        sarb: true,
        orkh: true,
        samr: true,
        mand: true,
        merc: true,
        mero: true,
        mani: true,
        mend: true,
        nbat: true,
        narb: true,
        palm: true,
        phlp: true
    };
function direction(script) {
    if (RTL[script]) {
        return 'rtl';
    }
    return 'ltr';
}
var GlyphRun = function () {
        function GlyphRun(glyphs, features, script, language, direction$$) {
            _classCallCheck(this, GlyphRun);
            this.glyphs = glyphs;
            this.positions = null;
            this.script = script;
            this.language = language || null;
            this.direction = direction$$ || direction(script);
            this.features = {};
            if (Array.isArray(features)) {
                for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length)
                            break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done)
                            break;
                        _ref = _i.value;
                    }
                    var tag = _ref;
                    this.features[tag] = true;
                }
            } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
                this.features = features;
            }
        }
        _createClass(GlyphRun, [
            {
                key: 'advanceWidth',
                get: function get() {
                    var width = 0;
                    for (var _iterator2 = this.positions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length)
                                break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done)
                                break;
                            _ref2 = _i2.value;
                        }
                        var position = _ref2;
                        width += position.xAdvance;
                    }
                    return width;
                }
            },
            {
                key: 'advanceHeight',
                get: function get() {
                    var height = 0;
                    for (var _iterator3 = this.positions, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                        var _ref3;
                        if (_isArray3) {
                            if (_i3 >= _iterator3.length)
                                break;
                            _ref3 = _iterator3[_i3++];
                        } else {
                            _i3 = _iterator3.next();
                            if (_i3.done)
                                break;
                            _ref3 = _i3.value;
                        }
                        var position = _ref3;
                        height += position.yAdvance;
                    }
                    return height;
                }
            },
            {
                key: 'bbox',
                get: function get() {
                    var bbox = new BBox();
                    var x = 0;
                    var y = 0;
                    for (var index = 0; index < this.glyphs.length; index++) {
                        var glyph = this.glyphs[index];
                        var p = this.positions[index];
                        var b = glyph.bbox;
                        bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                        bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                        x += p.xAdvance;
                        y += p.yAdvance;
                    }
                    return bbox;
                }
            }
        ]);
        return GlyphRun;
    }();
var GlyphPosition = function GlyphPosition() {
    var xAdvance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var yAdvance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var xOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var yOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    _classCallCheck(this, GlyphPosition);
    this.xAdvance = xAdvance;
    this.yAdvance = yAdvance;
    this.xOffset = xOffset;
    this.yOffset = yOffset;
};
var features = {
        allTypographicFeatures: {
            code: 0,
            exclusive: false,
            allTypeFeatures: 0
        },
        ligatures: {
            code: 1,
            exclusive: false,
            requiredLigatures: 0,
            commonLigatures: 2,
            rareLigatures: 4,
            rebusPictures: 8,
            diphthongLigatures: 10,
            squaredLigatures: 12,
            abbrevSquaredLigatures: 14,
            symbolLigatures: 16,
            contextualLigatures: 18,
            historicalLigatures: 20
        },
        cursiveConnection: {
            code: 2,
            exclusive: true,
            unconnected: 0,
            partiallyConnected: 1,
            cursive: 2
        },
        letterCase: {
            code: 3,
            exclusive: true
        },
        verticalSubstitution: {
            code: 4,
            exclusive: false,
            substituteVerticalForms: 0
        },
        linguisticRearrangement: {
            code: 5,
            exclusive: false,
            linguisticRearrangement: 0
        },
        numberSpacing: {
            code: 6,
            exclusive: true,
            monospacedNumbers: 0,
            proportionalNumbers: 1,
            thirdWidthNumbers: 2,
            quarterWidthNumbers: 3
        },
        smartSwash: {
            code: 8,
            exclusive: false,
            wordInitialSwashes: 0,
            wordFinalSwashes: 2,
            nonFinalSwashes: 8
        },
        diacritics: {
            code: 9,
            exclusive: true,
            showDiacritics: 0,
            hideDiacritics: 1,
            decomposeDiacritics: 2
        },
        verticalPosition: {
            code: 10,
            exclusive: true,
            normalPosition: 0,
            superiors: 1,
            inferiors: 2,
            ordinals: 3,
            scientificInferiors: 4
        },
        fractions: {
            code: 11,
            exclusive: true,
            noFractions: 0,
            verticalFractions: 1,
            diagonalFractions: 2
        },
        overlappingCharacters: {
            code: 13,
            exclusive: false,
            preventOverlap: 0
        },
        typographicExtras: {
            code: 14,
            exclusive: false,
            slashedZero: 4
        },
        mathematicalExtras: {
            code: 15,
            exclusive: false,
            mathematicalGreek: 10
        },
        ornamentSets: {
            code: 16,
            exclusive: true,
            noOrnaments: 0,
            dingbats: 1,
            piCharacters: 2,
            fleurons: 3,
            decorativeBorders: 4,
            internationalSymbols: 5,
            mathSymbols: 6
        },
        characterAlternatives: {
            code: 17,
            exclusive: true,
            noAlternates: 0
        },
        designComplexity: {
            code: 18,
            exclusive: true,
            designLevel1: 0,
            designLevel2: 1,
            designLevel3: 2,
            designLevel4: 3,
            designLevel5: 4
        },
        styleOptions: {
            code: 19,
            exclusive: true,
            noStyleOptions: 0,
            displayText: 1,
            engravedText: 2,
            illuminatedCaps: 3,
            titlingCaps: 4,
            tallCaps: 5
        },
        characterShape: {
            code: 20,
            exclusive: true,
            traditionalCharacters: 0,
            simplifiedCharacters: 1,
            JIS1978Characters: 2,
            JIS1983Characters: 3,
            JIS1990Characters: 4,
            traditionalAltOne: 5,
            traditionalAltTwo: 6,
            traditionalAltThree: 7,
            traditionalAltFour: 8,
            traditionalAltFive: 9,
            expertCharacters: 10,
            JIS2004Characters: 11,
            hojoCharacters: 12,
            NLCCharacters: 13,
            traditionalNamesCharacters: 14
        },
        numberCase: {
            code: 21,
            exclusive: true,
            lowerCaseNumbers: 0,
            upperCaseNumbers: 1
        },
        textSpacing: {
            code: 22,
            exclusive: true,
            proportionalText: 0,
            monospacedText: 1,
            halfWidthText: 2,
            thirdWidthText: 3,
            quarterWidthText: 4,
            altProportionalText: 5,
            altHalfWidthText: 6
        },
        transliteration: {
            code: 23,
            exclusive: true,
            noTransliteration: 0
        },
        annotation: {
            code: 24,
            exclusive: true,
            noAnnotation: 0,
            boxAnnotation: 1,
            roundedBoxAnnotation: 2,
            circleAnnotation: 3,
            invertedCircleAnnotation: 4,
            parenthesisAnnotation: 5,
            periodAnnotation: 6,
            romanNumeralAnnotation: 7,
            diamondAnnotation: 8,
            invertedBoxAnnotation: 9,
            invertedRoundedBoxAnnotation: 10
        },
        kanaSpacing: {
            code: 25,
            exclusive: true,
            fullWidthKana: 0,
            proportionalKana: 1
        },
        ideographicSpacing: {
            code: 26,
            exclusive: true,
            fullWidthIdeographs: 0,
            proportionalIdeographs: 1,
            halfWidthIdeographs: 2
        },
        unicodeDecomposition: {
            code: 27,
            exclusive: false,
            canonicalComposition: 0,
            compatibilityComposition: 2,
            transcodingComposition: 4
        },
        rubyKana: {
            code: 28,
            exclusive: false,
            rubyKana: 2
        },
        CJKSymbolAlternatives: {
            code: 29,
            exclusive: true,
            noCJKSymbolAlternatives: 0,
            CJKSymbolAltOne: 1,
            CJKSymbolAltTwo: 2,
            CJKSymbolAltThree: 3,
            CJKSymbolAltFour: 4,
            CJKSymbolAltFive: 5
        },
        ideographicAlternatives: {
            code: 30,
            exclusive: true,
            noIdeographicAlternatives: 0,
            ideographicAltOne: 1,
            ideographicAltTwo: 2,
            ideographicAltThree: 3,
            ideographicAltFour: 4,
            ideographicAltFive: 5
        },
        CJKVerticalRomanPlacement: {
            code: 31,
            exclusive: true,
            CJKVerticalRomanCentered: 0,
            CJKVerticalRomanHBaseline: 1
        },
        italicCJKRoman: {
            code: 32,
            exclusive: false,
            CJKItalicRoman: 2
        },
        caseSensitiveLayout: {
            code: 33,
            exclusive: false,
            caseSensitiveLayout: 0,
            caseSensitiveSpacing: 2
        },
        alternateKana: {
            code: 34,
            exclusive: false,
            alternateHorizKana: 0,
            alternateVertKana: 2
        },
        stylisticAlternatives: {
            code: 35,
            exclusive: false,
            noStylisticAlternates: 0,
            stylisticAltOne: 2,
            stylisticAltTwo: 4,
            stylisticAltThree: 6,
            stylisticAltFour: 8,
            stylisticAltFive: 10,
            stylisticAltSix: 12,
            stylisticAltSeven: 14,
            stylisticAltEight: 16,
            stylisticAltNine: 18,
            stylisticAltTen: 20,
            stylisticAltEleven: 22,
            stylisticAltTwelve: 24,
            stylisticAltThirteen: 26,
            stylisticAltFourteen: 28,
            stylisticAltFifteen: 30,
            stylisticAltSixteen: 32,
            stylisticAltSeventeen: 34,
            stylisticAltEighteen: 36,
            stylisticAltNineteen: 38,
            stylisticAltTwenty: 40
        },
        contextualAlternates: {
            code: 36,
            exclusive: false,
            contextualAlternates: 0,
            swashAlternates: 2,
            contextualSwashAlternates: 4
        },
        lowerCase: {
            code: 37,
            exclusive: true,
            defaultLowerCase: 0,
            lowerCaseSmallCaps: 1,
            lowerCasePetiteCaps: 2
        },
        upperCase: {
            code: 38,
            exclusive: true,
            defaultUpperCase: 0,
            upperCaseSmallCaps: 1,
            upperCasePetiteCaps: 2
        },
        languageTag: {
            code: 39,
            exclusive: true
        },
        CJKRomanSpacing: {
            code: 103,
            exclusive: true,
            halfWidthCJKRoman: 0,
            proportionalCJKRoman: 1,
            defaultCJKRoman: 2,
            fullWidthCJKRoman: 3
        }
    };
var feature = function feature(name, selector) {
    return [
        features[name].code,
        features[name][selector]
    ];
};
var OTMapping = {
        rlig: feature('ligatures', 'requiredLigatures'),
        clig: feature('ligatures', 'contextualLigatures'),
        dlig: feature('ligatures', 'rareLigatures'),
        hlig: feature('ligatures', 'historicalLigatures'),
        liga: feature('ligatures', 'commonLigatures'),
        hist: feature('ligatures', 'historicalLigatures'),
        smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
        pcap: feature('lowerCase', 'lowerCasePetiteCaps'),
        frac: feature('fractions', 'diagonalFractions'),
        dnom: feature('fractions', 'diagonalFractions'),
        numr: feature('fractions', 'diagonalFractions'),
        afrc: feature('fractions', 'verticalFractions'),
        case: feature('caseSensitiveLayout', 'caseSensitiveLayout'),
        ccmp: feature('unicodeDecomposition', 'canonicalComposition'),
        cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
        valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
        swsh: feature('contextualAlternates', 'swashAlternates'),
        cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
        curs: feature('cursiveConnection', 'cursive'),
        c2pc: feature('upperCase', 'upperCasePetiteCaps'),
        c2sc: feature('upperCase', 'upperCaseSmallCaps'),
        init: feature('smartSwash', 'wordInitialSwashes'),
        fin2: feature('smartSwash', 'wordFinalSwashes'),
        medi: feature('smartSwash', 'nonFinalSwashes'),
        med2: feature('smartSwash', 'nonFinalSwashes'),
        fin3: feature('smartSwash', 'wordFinalSwashes'),
        fina: feature('smartSwash', 'wordFinalSwashes'),
        pkna: feature('kanaSpacing', 'proportionalKana'),
        half: feature('textSpacing', 'halfWidthText'),
        halt: feature('textSpacing', 'altHalfWidthText'),
        hkna: feature('alternateKana', 'alternateHorizKana'),
        vkna: feature('alternateKana', 'alternateVertKana'),
        ital: feature('italicCJKRoman', 'CJKItalicRoman'),
        lnum: feature('numberCase', 'upperCaseNumbers'),
        onum: feature('numberCase', 'lowerCaseNumbers'),
        mgrk: feature('mathematicalExtras', 'mathematicalGreek'),
        calt: feature('contextualAlternates', 'contextualAlternates'),
        vrt2: feature('verticalSubstitution', 'substituteVerticalForms'),
        vert: feature('verticalSubstitution', 'substituteVerticalForms'),
        tnum: feature('numberSpacing', 'monospacedNumbers'),
        pnum: feature('numberSpacing', 'proportionalNumbers'),
        sups: feature('verticalPosition', 'superiors'),
        subs: feature('verticalPosition', 'inferiors'),
        ordn: feature('verticalPosition', 'ordinals'),
        pwid: feature('textSpacing', 'proportionalText'),
        hwid: feature('textSpacing', 'halfWidthText'),
        qwid: feature('textSpacing', 'quarterWidthText'),
        twid: feature('textSpacing', 'thirdWidthText'),
        fwid: feature('textSpacing', 'proportionalText'),
        palt: feature('textSpacing', 'altProportionalText'),
        trad: feature('characterShape', 'traditionalCharacters'),
        smpl: feature('characterShape', 'simplifiedCharacters'),
        jp78: feature('characterShape', 'JIS1978Characters'),
        jp83: feature('characterShape', 'JIS1983Characters'),
        jp90: feature('characterShape', 'JIS1990Characters'),
        jp04: feature('characterShape', 'JIS2004Characters'),
        expt: feature('characterShape', 'expertCharacters'),
        hojo: feature('characterShape', 'hojoCharacters'),
        nlck: feature('characterShape', 'NLCCharacters'),
        tnam: feature('characterShape', 'traditionalNamesCharacters'),
        ruby: feature('rubyKana', 'rubyKana'),
        titl: feature('styleOptions', 'titlingCaps'),
        zero: feature('typographicExtras', 'slashedZero'),
        ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
        ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
        ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
        ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
        ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
        ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
        ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
        ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
        ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
        ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
        ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
        ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
        ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
        ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
        ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
        ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
        ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
        ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
        ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
        ss20: feature('stylisticAlternatives', 'stylisticAltTwenty')
    };
for (var i = 1; i <= 99; i++) {
    OTMapping['cv' + ('00' + i).slice(-2)] = [
        features.characterAlternatives.code,
        i
    ];
}
var AATMapping = {};
for (var ot in OTMapping) {
    var aat = OTMapping[ot];
    if (AATMapping[aat[0]] == null) {
        AATMapping[aat[0]] = {};
    }
    AATMapping[aat[0]][aat[1]] = ot;
}
function mapOTToAAT(features) {
    var res = {};
    for (var k in features) {
        var r = void 0;
        if (r = OTMapping[k]) {
            if (res[r[0]] == null) {
                res[r[0]] = {};
            }
            res[r[0]][r[1]] = features[k];
        }
    }
    return res;
}
function mapFeatureStrings(f) {
    var type = f[0], setting = f[1];
    if (isNaN(type)) {
        var typeCode = features[type] && features[type].code;
    } else {
        var typeCode = type;
    }
    if (isNaN(setting)) {
        var settingCode = features[type] && features[type][setting];
    } else {
        var settingCode = setting;
    }
    return [
        typeCode,
        settingCode
    ];
}
function mapAATToOT(features) {
    var res = {};
    if (Array.isArray(features)) {
        for (var k = 0; k < features.length; k++) {
            var r = void 0;
            var f = mapFeatureStrings(features[k]);
            if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) {
                res[r] = true;
            }
        }
    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
        for (var type in features) {
            var _feature = features[type];
            for (var setting in _feature) {
                var _r = void 0;
                var _f = mapFeatureStrings([
                        type,
                        setting
                    ]);
                if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) {
                    res[_r] = true;
                }
            }
        }
    }
    return _Object$keys(res);
}
var _class$3;
function _applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }
    return desc;
}
var AATLookupTable = (_class$3 = function () {
        function AATLookupTable(table) {
            _classCallCheck(this, AATLookupTable);
            this.table = table;
        }
        AATLookupTable.prototype.lookup = function lookup(glyph) {
            switch (this.table.version) {
            case 0:
                return this.table.values.getItem(glyph);
            case 2:
            case 4: {
                    var min = 0;
                    var max = this.table.binarySearchHeader.nUnits - 1;
                    while (min <= max) {
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        if (seg.firstGlyph === 65535) {
                            return null;
                        }
                        if (glyph < seg.firstGlyph) {
                            max = mid - 1;
                        } else if (glyph > seg.lastGlyph) {
                            min = mid + 1;
                        } else {
                            if (this.table.version === 2) {
                                return seg.value;
                            } else {
                                return seg.values[glyph - seg.firstGlyph];
                            }
                        }
                    }
                    return null;
                }
            case 6: {
                    var _min = 0;
                    var _max = this.table.binarySearchHeader.nUnits - 1;
                    while (_min <= _max) {
                        var mid = _min + _max >> 1;
                        var seg = this.table.segments[mid];
                        if (seg.glyph === 65535) {
                            return null;
                        }
                        if (glyph < seg.glyph) {
                            _max = mid - 1;
                        } else if (glyph > seg.glyph) {
                            _min = mid + 1;
                        } else {
                            return seg.value;
                        }
                    }
                    return null;
                }
            case 8:
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error('Unknown lookup table format: ' + this.table.version);
            }
        };
        AATLookupTable.prototype.glyphsForValue = function glyphsForValue(classValue) {
            var res = [];
            switch (this.table.version) {
            case 2:
            case 4: {
                    for (var _iterator = this.table.segments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length)
                                break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done)
                                break;
                            _ref = _i.value;
                        }
                        var segment = _ref;
                        if (this.table.version === 2 && segment.value === classValue) {
                            res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
                        } else {
                            for (var index = 0; index < segment.values.length; index++) {
                                if (segment.values[index] === classValue) {
                                    res.push(segment.firstGlyph + index);
                                }
                            }
                        }
                    }
                    break;
                }
            case 6: {
                    for (var _iterator2 = this.table.segments, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length)
                                break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done)
                                break;
                            _ref2 = _i2.value;
                        }
                        var _segment = _ref2;
                        if (_segment.value === classValue) {
                            res.push(_segment.glyph);
                        }
                    }
                    break;
                }
            case 8: {
                    for (var i = 0; i < this.table.values.length; i++) {
                        if (this.table.values[i] === classValue) {
                            res.push(this.table.firstGlyph + i);
                        }
                    }
                    break;
                }
            default:
                throw new Error('Unknown lookup table format: ' + this.table.version);
            }
            return res;
        };
        return AATLookupTable;
    }(), _applyDecoratedDescriptor$3(_class$3.prototype, 'glyphsForValue', [cache], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'glyphsForValue'), _class$3.prototype), _class$3);
var START_OF_TEXT_STATE = 0;
var END_OF_TEXT_CLASS = 0;
var OUT_OF_BOUNDS_CLASS = 1;
var DELETED_GLYPH_CLASS = 2;
var DONT_ADVANCE = 16384;
var AATStateMachine = function () {
        function AATStateMachine(stateTable) {
            _classCallCheck(this, AATStateMachine);
            this.stateTable = stateTable;
            this.lookupTable = new AATLookupTable(stateTable.classTable);
        }
        AATStateMachine.prototype.process = function process(glyphs, reverse, processEntry) {
            var currentState = START_OF_TEXT_STATE;
            var index = reverse ? glyphs.length - 1 : 0;
            var dir = reverse ? -1 : 1;
            while (dir === 1 && index <= glyphs.length || dir === -1 && index >= -1) {
                var glyph = null;
                var classCode = OUT_OF_BOUNDS_CLASS;
                var shouldAdvance = true;
                if (index === glyphs.length || index === -1) {
                    classCode = END_OF_TEXT_CLASS;
                } else {
                    glyph = glyphs[index];
                    if (glyph.id === 65535) {
                        classCode = DELETED_GLYPH_CLASS;
                    } else {
                        classCode = this.lookupTable.lookup(glyph.id);
                        if (classCode == null) {
                            classCode = OUT_OF_BOUNDS_CLASS;
                        }
                    }
                }
                var row = this.stateTable.stateArray.getItem(currentState);
                var entryIndex = row[classCode];
                var entry = this.stateTable.entryTable.getItem(entryIndex);
                if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
                    processEntry(glyph, entry, index);
                    shouldAdvance = !(entry.flags & DONT_ADVANCE);
                }
                currentState = entry.newState;
                if (shouldAdvance) {
                    index += dir;
                }
            }
            return glyphs;
        };
        AATStateMachine.prototype.traverse = function traverse(opts) {
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Set();
            if (visited.has(state)) {
                return;
            }
            visited.add(state);
            var _stateTable = this.stateTable, nClasses = _stateTable.nClasses, stateArray = _stateTable.stateArray, entryTable = _stateTable.entryTable;
            var row = stateArray.getItem(state);
            for (var classCode = 4; classCode < nClasses; classCode++) {
                var entryIndex = row[classCode];
                var entry = entryTable.getItem(entryIndex);
                for (var _iterator = this.lookupTable.glyphsForValue(classCode), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length)
                            break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done)
                            break;
                        _ref = _i.value;
                    }
                    var glyph = _ref;
                    if (opts.enter) {
                        opts.enter(glyph, entry);
                    }
                    if (entry.newState !== 0) {
                        this.traverse(opts, entry.newState, visited);
                    }
                    if (opts.exit) {
                        opts.exit(glyph, entry);
                    }
                }
            }
        };
        return AATStateMachine;
    }();
var _class$2;
function _applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }
    return desc;
}
var MARK_FIRST = 32768;
var MARK_LAST = 8192;
var VERB = 15;
var SET_MARK = 32768;
var SET_COMPONENT = 32768;
var PERFORM_ACTION = 8192;
var LAST_MASK = 2147483648;
var STORE_MASK = 1073741824;
var OFFSET_MASK = 1073741823;
var REVERSE_DIRECTION = 4194304;
var CURRENT_INSERT_BEFORE = 2048;
var MARKED_INSERT_BEFORE = 1024;
var CURRENT_INSERT_COUNT = 992;
var MARKED_INSERT_COUNT = 31;
var AATMorxProcessor = (_class$2 = function () {
        function AATMorxProcessor(font) {
            _classCallCheck(this, AATMorxProcessor);
            this.processIndicRearragement = this.processIndicRearragement.bind(this);
            this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
            this.processLigature = this.processLigature.bind(this);
            this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
            this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
            this.font = font;
            this.morx = font.morx;
            this.inputCache = null;
        }
        AATMorxProcessor.prototype.process = function process(glyphs) {
            var features = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            for (var _iterator = this.morx.chains, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var chain = _ref;
                var flags = chain.defaultFlags;
                for (var _iterator2 = chain.features, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length)
                            break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done)
                            break;
                        _ref2 = _i2.value;
                    }
                    var feature = _ref2;
                    var f = void 0;
                    if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
                        flags &= feature.disableFlags;
                        flags |= feature.enableFlags;
                    }
                }
                for (var _iterator3 = chain.subtables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                    var _ref3;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length)
                            break;
                        _ref3 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done)
                            break;
                        _ref3 = _i3.value;
                    }
                    var subtable = _ref3;
                    if (subtable.subFeatureFlags & flags) {
                        this.processSubtable(subtable, glyphs);
                    }
                }
            }
            var index = glyphs.length - 1;
            while (index >= 0) {
                if (glyphs[index].id === 65535) {
                    glyphs.splice(index, 1);
                }
                index--;
            }
            return glyphs;
        };
        AATMorxProcessor.prototype.processSubtable = function processSubtable(subtable, glyphs) {
            this.subtable = subtable;
            this.glyphs = glyphs;
            if (this.subtable.type === 4) {
                this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
                return;
            }
            this.ligatureStack = [];
            this.markedGlyph = null;
            this.firstGlyph = null;
            this.lastGlyph = null;
            this.markedIndex = null;
            var stateMachine = this.getStateMachine(subtable);
            var process = this.getProcessor();
            var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
            return stateMachine.process(this.glyphs, reverse, process);
        };
        AATMorxProcessor.prototype.getStateMachine = function getStateMachine(subtable) {
            return new AATStateMachine(subtable.table.stateTable);
        };
        AATMorxProcessor.prototype.getProcessor = function getProcessor() {
            switch (this.subtable.type) {
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error('Invalid morx subtable type: ' + this.subtable.type);
            }
        };
        AATMorxProcessor.prototype.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
            if (entry.flags & MARK_FIRST) {
                this.firstGlyph = index;
            }
            if (entry.flags & MARK_LAST) {
                this.lastGlyph = index;
            }
            reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
        };
        AATMorxProcessor.prototype.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
            var subsitutions = this.subtable.table.substitutionTable.items;
            if (entry.markIndex !== 65535) {
                var lookup = subsitutions.getItem(entry.markIndex);
                var lookupTable = new AATLookupTable(lookup);
                glyph = this.glyphs[this.markedGlyph];
                var gid = lookupTable.lookup(glyph.id);
                if (gid) {
                    this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
                }
            }
            if (entry.currentIndex !== 65535) {
                var _lookup = subsitutions.getItem(entry.currentIndex);
                var _lookupTable = new AATLookupTable(_lookup);
                glyph = this.glyphs[index];
                var gid = _lookupTable.lookup(glyph.id);
                if (gid) {
                    this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                }
            }
            if (entry.flags & SET_MARK) {
                this.markedGlyph = index;
            }
        };
        AATMorxProcessor.prototype.processLigature = function processLigature(glyph, entry, index) {
            if (entry.flags & SET_COMPONENT) {
                this.ligatureStack.push(index);
            }
            if (entry.flags & PERFORM_ACTION) {
                var _ligatureStack;
                var actions = this.subtable.table.ligatureActions;
                var components = this.subtable.table.components;
                var ligatureList = this.subtable.table.ligatureList;
                var actionIndex = entry.action;
                var last = false;
                var ligatureIndex = 0;
                var codePoints = [];
                var ligatureGlyphs = [];
                while (!last) {
                    var _codePoints;
                    var componentGlyph = this.ligatureStack.pop();
                    (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
                    var action = actions.getItem(actionIndex++);
                    last = !!(action & LAST_MASK);
                    var store = !!(action & STORE_MASK);
                    var offset = (action & OFFSET_MASK) << 2 >> 2;
                    offset += this.glyphs[componentGlyph].id;
                    var component = components.getItem(offset);
                    ligatureIndex += component;
                    if (last || store) {
                        var ligatureEntry = ligatureList.getItem(ligatureIndex);
                        this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                        ligatureGlyphs.push(componentGlyph);
                        ligatureIndex = 0;
                        codePoints = [];
                    } else {
                        this.glyphs[componentGlyph] = this.font.getGlyph(65535);
                    }
                }
                (_ligatureStack = this.ligatureStack).push.apply(_ligatureStack, ligatureGlyphs);
            }
        };
        AATMorxProcessor.prototype.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
            var lookupTable = new AATLookupTable(subtable.table.lookupTable);
            for (index = 0; index < glyphs.length; index++) {
                var glyph = glyphs[index];
                if (glyph.id !== 65535) {
                    var gid = lookupTable.lookup(glyph.id);
                    if (gid) {
                        glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                    }
                }
            }
        };
        AATMorxProcessor.prototype._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
            var _glyphs;
            var insertions = [];
            while (count--) {
                var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
                insertions.push(this.font.getGlyph(gid));
            }
            if (!isBefore) {
                glyphIndex++;
            }
            (_glyphs = this.glyphs).splice.apply(_glyphs, [
                glyphIndex,
                0
            ].concat(insertions));
        };
        AATMorxProcessor.prototype.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
            if (entry.flags & SET_MARK) {
                this.markedIndex = index;
            }
            if (entry.markedInsertIndex !== 65535) {
                var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
                var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
                this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
            }
            if (entry.currentInsertIndex !== 65535) {
                var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
                var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
                this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
            }
        };
        AATMorxProcessor.prototype.getSupportedFeatures = function getSupportedFeatures() {
            var features = [];
            for (var _iterator4 = this.morx.chains, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
                var _ref4;
                if (_isArray4) {
                    if (_i4 >= _iterator4.length)
                        break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done)
                        break;
                    _ref4 = _i4.value;
                }
                var chain = _ref4;
                for (var _iterator5 = chain.features, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
                    var _ref5;
                    if (_isArray5) {
                        if (_i5 >= _iterator5.length)
                            break;
                        _ref5 = _iterator5[_i5++];
                    } else {
                        _i5 = _iterator5.next();
                        if (_i5.done)
                            break;
                        _ref5 = _i5.value;
                    }
                    var feature = _ref5;
                    features.push([
                        feature.featureType,
                        feature.featureSetting
                    ]);
                }
            }
            return features;
        };
        AATMorxProcessor.prototype.generateInputs = function generateInputs(gid) {
            if (!this.inputCache) {
                this.generateInputCache();
            }
            return this.inputCache[gid] || [];
        };
        AATMorxProcessor.prototype.generateInputCache = function generateInputCache() {
            this.inputCache = {};
            for (var _iterator6 = this.morx.chains, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
                var _ref6;
                if (_isArray6) {
                    if (_i6 >= _iterator6.length)
                        break;
                    _ref6 = _iterator6[_i6++];
                } else {
                    _i6 = _iterator6.next();
                    if (_i6.done)
                        break;
                    _ref6 = _i6.value;
                }
                var chain = _ref6;
                var flags = chain.defaultFlags;
                for (var _iterator7 = chain.subtables, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
                    var _ref7;
                    if (_isArray7) {
                        if (_i7 >= _iterator7.length)
                            break;
                        _ref7 = _iterator7[_i7++];
                    } else {
                        _i7 = _iterator7.next();
                        if (_i7.done)
                            break;
                        _ref7 = _i7.value;
                    }
                    var subtable = _ref7;
                    if (subtable.subFeatureFlags & flags) {
                        this.generateInputsForSubtable(subtable);
                    }
                }
            }
        };
        AATMorxProcessor.prototype.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
            var _this = this;
            if (subtable.type !== 2) {
                return;
            }
            var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
            if (reverse) {
                throw new Error('Reverse subtable, not supported.');
            }
            this.subtable = subtable;
            this.ligatureStack = [];
            var stateMachine = this.getStateMachine(subtable);
            var process = this.getProcessor();
            var input = [];
            var stack = [];
            this.glyphs = [];
            stateMachine.traverse({
                enter: function enter(glyph, entry) {
                    var glyphs = _this.glyphs;
                    stack.push({
                        glyphs: glyphs.slice(),
                        ligatureStack: _this.ligatureStack.slice()
                    });
                    var g = _this.font.getGlyph(glyph);
                    input.push(g);
                    glyphs.push(input[input.length - 1]);
                    process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
                    var count = 0;
                    var found = 0;
                    for (var i = 0; i < glyphs.length && count <= 1; i++) {
                        if (glyphs[i].id !== 65535) {
                            count++;
                            found = glyphs[i].id;
                        }
                    }
                    if (count === 1) {
                        var result = input.map(function (g) {
                                return g.id;
                            });
                        var _cache = _this.inputCache[found];
                        if (_cache) {
                            _cache.push(result);
                        } else {
                            _this.inputCache[found] = [result];
                        }
                    }
                },
                exit: function exit() {
                    var _stack$pop = stack.pop();
                    _this.glyphs = _stack$pop.glyphs;
                    _this.ligatureStack = _stack$pop.ligatureStack;
                    input.pop();
                }
            });
        };
        return AATMorxProcessor;
    }(), _applyDecoratedDescriptor$2(_class$2.prototype, 'getStateMachine', [cache], _Object$getOwnPropertyDescriptor(_class$2.prototype, 'getStateMachine'), _class$2.prototype), _class$2);
function swap(glyphs, rangeA, rangeB) {
    var reverseA = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var reverseB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) {
        end.reverse();
    }
    var start = glyphs.splice.apply(glyphs, [
            rangeA[0],
            rangeA[1]
        ].concat(end));
    if (reverseA) {
        start.reverse();
    }
    glyphs.splice.apply(glyphs, [
        rangeB[0] - (rangeA[1] - 1),
        0
    ].concat(start));
    return glyphs;
}
function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    var length = lastGlyph - firstGlyph + 1;
    switch (verb) {
    case 0:
        return glyphs;
    case 1:
        return swap(glyphs, [
            firstGlyph,
            1
        ], [
            lastGlyph,
            0
        ]);
    case 2:
        return swap(glyphs, [
            firstGlyph,
            0
        ], [
            lastGlyph,
            1
        ]);
    case 3:
        return swap(glyphs, [
            firstGlyph,
            1
        ], [
            lastGlyph,
            1
        ]);
    case 4:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            0
        ]);
    case 5:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            0
        ], true, false);
    case 6:
        return swap(glyphs, [
            firstGlyph,
            0
        ], [
            lastGlyph,
            2
        ]);
    case 7:
        return swap(glyphs, [
            firstGlyph,
            0
        ], [
            lastGlyph,
            2
        ], false, true);
    case 8:
        return swap(glyphs, [
            firstGlyph,
            1
        ], [
            lastGlyph,
            2
        ]);
    case 9:
        return swap(glyphs, [
            firstGlyph,
            1
        ], [
            lastGlyph,
            2
        ], false, true);
    case 10:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            1
        ]);
    case 11:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            1
        ], true, false);
    case 12:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            2
        ]);
    case 13:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            2
        ], true, false);
    case 14:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            2
        ], false, true);
    case 15:
        return swap(glyphs, [
            firstGlyph,
            2
        ], [
            lastGlyph,
            2
        ], true, true);
    default:
        throw new Error('Unknown verb: ' + verb);
    }
}
var AATLayoutEngine = function () {
        function AATLayoutEngine(font) {
            _classCallCheck(this, AATLayoutEngine);
            this.font = font;
            this.morxProcessor = new AATMorxProcessor(font);
            this.fallbackPosition = false;
        }
        AATLayoutEngine.prototype.substitute = function substitute(glyphRun) {
            if (glyphRun.direction === 'rtl') {
                glyphRun.glyphs.reverse();
            }
            this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
        };
        AATLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
            return mapAATToOT(this.morxProcessor.getSupportedFeatures());
        };
        AATLayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
            var glyphStrings = this.morxProcessor.generateInputs(gid);
            var result = new _Set();
            for (var _iterator = glyphStrings, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var glyphs = _ref;
                this._addStrings(glyphs, 0, result, '');
            }
            return result;
        };
        AATLayoutEngine.prototype._addStrings = function _addStrings(glyphs, index, strings, string) {
            var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
            for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var codePoint = _ref2;
                var s = string + _String$fromCodePoint(codePoint);
                if (index < glyphs.length - 1) {
                    this._addStrings(glyphs, index + 1, strings, s);
                } else {
                    strings.add(s);
                }
            }
        };
        return AATLayoutEngine;
    }();
var ShapingPlan = function () {
        function ShapingPlan(font, script, direction) {
            _classCallCheck(this, ShapingPlan);
            this.font = font;
            this.script = script;
            this.direction = direction;
            this.stages = [];
            this.globalFeatures = {};
            this.allFeatures = {};
        }
        ShapingPlan.prototype._addFeatures = function _addFeatures(features, global) {
            var stageIndex = this.stages.length - 1;
            var stage = this.stages[stageIndex];
            for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var feature = _ref;
                if (this.allFeatures[feature] == null) {
                    stage.push(feature);
                    this.allFeatures[feature] = stageIndex;
                    if (global) {
                        this.globalFeatures[feature] = true;
                    }
                }
            }
        };
        ShapingPlan.prototype.add = function add(arg) {
            var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (this.stages.length === 0) {
                this.stages.push([]);
            }
            if (typeof arg === 'string') {
                arg = [arg];
            }
            if (Array.isArray(arg)) {
                this._addFeatures(arg, global);
            } else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
                this._addFeatures(arg.global || [], true);
                this._addFeatures(arg.local || [], false);
            } else {
                throw new Error('Unsupported argument to ShapingPlan#add');
            }
        };
        ShapingPlan.prototype.addStage = function addStage(arg, global) {
            if (typeof arg === 'function') {
                this.stages.push(arg, []);
            } else {
                this.stages.push([]);
                this.add(arg, global);
            }
        };
        ShapingPlan.prototype.setFeatureOverrides = function setFeatureOverrides(features) {
            if (Array.isArray(features)) {
                this.add(features);
            } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
                for (var tag in features) {
                    if (features[tag]) {
                        this.add(tag);
                    } else if (this.allFeatures[tag] != null) {
                        var stage = this.stages[this.allFeatures[tag]];
                        stage.splice(stage.indexOf(tag), 1);
                        delete this.allFeatures[tag];
                        delete this.globalFeatures[tag];
                    }
                }
            }
        };
        ShapingPlan.prototype.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
            for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var glyph = _ref2;
                for (var feature in this.globalFeatures) {
                    glyph.features[feature] = true;
                }
            }
        };
        ShapingPlan.prototype.process = function process(processor, glyphs, positions) {
            for (var _iterator3 = this.stages, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length)
                        break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done)
                        break;
                    _ref3 = _i3.value;
                }
                var stage = _ref3;
                if (typeof stage === 'function') {
                    if (!positions) {
                        stage(this.font, glyphs, this);
                    }
                } else if (stage.length > 0) {
                    processor.applyFeatures(stage, glyphs, positions);
                }
            }
        };
        return ShapingPlan;
    }();
var _class$4;
var _temp;
var VARIATION_FEATURES = ['rvrn'];
var COMMON_FEATURES = [
        'ccmp',
        'locl',
        'rlig',
        'mark',
        'mkmk'
    ];
var FRACTIONAL_FEATURES = [
        'frac',
        'numr',
        'dnom'
    ];
var HORIZONTAL_FEATURES = [
        'calt',
        'clig',
        'liga',
        'rclt',
        'curs',
        'kern'
    ];
var DIRECTIONAL_FEATURES = {
        ltr: [
            'ltra',
            'ltrm'
        ],
        rtl: [
            'rtla',
            'rtlm'
        ]
    };
var DefaultShaper = (_temp = _class$4 = function () {
        function DefaultShaper() {
            _classCallCheck(this, DefaultShaper);
        }
        DefaultShaper.plan = function plan(_plan, glyphs, features) {
            this.planPreprocessing(_plan);
            this.planFeatures(_plan);
            this.planPostprocessing(_plan, features);
            _plan.assignGlobalFeatures(glyphs);
            this.assignFeatures(_plan, glyphs);
        };
        DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
            plan.add({
                global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
                local: FRACTIONAL_FEATURES
            });
        };
        DefaultShaper.planFeatures = function planFeatures(plan) {
        };
        DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
            plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
            plan.setFeatureOverrides(userFeatures);
        };
        DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            for (var i = 0; i < glyphs.length; i++) {
                var glyph = glyphs[i];
                if (glyph.codePoints[0] === 8260) {
                    var start = i;
                    var end = i + 1;
                    while (start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])) {
                        glyphs[start - 1].features.numr = true;
                        glyphs[start - 1].features.frac = true;
                        start--;
                    }
                    while (end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])) {
                        glyphs[end].features.dnom = true;
                        glyphs[end].features.frac = true;
                        end++;
                    }
                    glyph.features.frac = true;
                    i = end - 1;
                }
            }
        };
        return DefaultShaper;
    }(), _class$4.zeroMarkWidths = 'AFTER_GPOS', _temp);
var trie = new UnicodeTrie(Buffer('AAEQAAAAAAAAADGgAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=', 'base64'));
var FEATURES = [
        'isol',
        'fina',
        'fin2',
        'fin3',
        'medi',
        'med2',
        'init'
    ];
var ShapingClasses = {
        Non_Joining: 0,
        Left_Joining: 1,
        Right_Joining: 2,
        Dual_Joining: 3,
        Join_Causing: 3,
        ALAPH: 4,
        'DALATH RISH': 5,
        Transparent: 6
    };
var ISOL = 'isol';
var FINA = 'fina';
var FIN2 = 'fin2';
var FIN3 = 'fin3';
var MEDI = 'medi';
var MED2 = 'med2';
var INIT = 'init';
var NONE = null;
var STATE_TABLE = [
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                NONE,
                ISOL,
                1
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                NONE,
                ISOL,
                1
            ],
            [
                NONE,
                ISOL,
                6
            ]
        ],
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                NONE,
                ISOL,
                1
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                NONE,
                FIN2,
                5
            ],
            [
                NONE,
                ISOL,
                6
            ]
        ],
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                INIT,
                FINA,
                1
            ],
            [
                INIT,
                FINA,
                3
            ],
            [
                INIT,
                FINA,
                4
            ],
            [
                INIT,
                FINA,
                6
            ]
        ],
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                MEDI,
                FINA,
                1
            ],
            [
                MEDI,
                FINA,
                3
            ],
            [
                MEDI,
                FINA,
                4
            ],
            [
                MEDI,
                FINA,
                6
            ]
        ],
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                MED2,
                ISOL,
                1
            ],
            [
                MED2,
                ISOL,
                2
            ],
            [
                MED2,
                FIN2,
                5
            ],
            [
                MED2,
                ISOL,
                6
            ]
        ],
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                ISOL,
                ISOL,
                1
            ],
            [
                ISOL,
                ISOL,
                2
            ],
            [
                ISOL,
                FIN2,
                5
            ],
            [
                ISOL,
                ISOL,
                6
            ]
        ],
        [
            [
                NONE,
                NONE,
                0
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                NONE,
                ISOL,
                1
            ],
            [
                NONE,
                ISOL,
                2
            ],
            [
                NONE,
                FIN3,
                5
            ],
            [
                NONE,
                ISOL,
                6
            ]
        ]
    ];
var ArabicShaper = function (_DefaultShaper) {
        _inherits(ArabicShaper, _DefaultShaper);
        function ArabicShaper() {
            _classCallCheck(this, ArabicShaper);
            return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
        }
        ArabicShaper.planFeatures = function planFeatures(plan) {
            plan.add([
                'ccmp',
                'locl'
            ]);
            for (var i = 0; i < FEATURES.length; i++) {
                var feature = FEATURES[i];
                plan.addStage(feature, false);
            }
            plan.addStage('mset');
        };
        ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            _DefaultShaper.assignFeatures.call(this, plan, glyphs);
            var prev = -1;
            var state = 0;
            var actions = [];
            for (var i = 0; i < glyphs.length; i++) {
                var curAction = void 0, prevAction = void 0;
                var glyph = glyphs[i];
                var type = getShapingClass(glyph.codePoints[0]);
                if (type === ShapingClasses.Transparent) {
                    actions[i] = NONE;
                    continue;
                }
                var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
                prevAction = _STATE_TABLE$state$ty[0];
                curAction = _STATE_TABLE$state$ty[1];
                state = _STATE_TABLE$state$ty[2];
                if (prevAction !== NONE && prev !== -1) {
                    actions[prev] = prevAction;
                }
                actions[i] = curAction;
                prev = i;
            }
            for (var index = 0; index < glyphs.length; index++) {
                var feature = void 0;
                var glyph = glyphs[index];
                if (feature = actions[index]) {
                    glyph.features[feature] = true;
                }
            }
        };
        return ArabicShaper;
    }(DefaultShaper);
function getShapingClass(codePoint) {
    var res = trie.get(codePoint);
    if (res) {
        return res - 1;
    }
    var category = unicode.getCategory(codePoint);
    if (category === 'Mn' || category === 'Me' || category === 'Cf') {
        return ShapingClasses.Transparent;
    }
    return ShapingClasses.Non_Joining;
}
var GlyphIterator = function () {
        function GlyphIterator(glyphs, options) {
            _classCallCheck(this, GlyphIterator);
            this.glyphs = glyphs;
            this.reset(options);
        }
        GlyphIterator.prototype.reset = function reset() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            this.options = options;
            this.flags = options.flags || {};
            this.markAttachmentType = options.markAttachmentType || 0;
            this.index = index;
        };
        GlyphIterator.prototype.shouldIgnore = function shouldIgnore(glyph) {
            return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
        };
        GlyphIterator.prototype.move = function move(dir) {
            this.index += dir;
            while (0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index])) {
                this.index += dir;
            }
            if (0 > this.index || this.index >= this.glyphs.length) {
                return null;
            }
            return this.glyphs[this.index];
        };
        GlyphIterator.prototype.next = function next() {
            return this.move(+1);
        };
        GlyphIterator.prototype.prev = function prev() {
            return this.move(-1);
        };
        GlyphIterator.prototype.peek = function peek() {
            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var idx = this.index;
            var res = this.increment(count);
            this.index = idx;
            return res;
        };
        GlyphIterator.prototype.peekIndex = function peekIndex() {
            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var idx = this.index;
            this.increment(count);
            var res = this.index;
            this.index = idx;
            return res;
        };
        GlyphIterator.prototype.increment = function increment() {
            var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var dir = count < 0 ? -1 : 1;
            count = Math.abs(count);
            while (count--) {
                this.move(dir);
            }
            return this.glyphs[this.index];
        };
        _createClass(GlyphIterator, [{
                key: 'cur',
                get: function get() {
                    return this.glyphs[this.index] || null;
                }
            }]);
        return GlyphIterator;
    }();
var DEFAULT_SCRIPTS = [
        'DFLT',
        'dflt',
        'latn'
    ];
var OTProcessor = function () {
        function OTProcessor(font, table) {
            _classCallCheck(this, OTProcessor);
            this.font = font;
            this.table = table;
            this.script = null;
            this.scriptTag = null;
            this.language = null;
            this.languageTag = null;
            this.features = {};
            this.lookups = {};
            this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
            this.selectScript();
            this.glyphs = [];
            this.positions = [];
            this.ligatureID = 1;
            this.currentFeature = null;
        }
        OTProcessor.prototype.findScript = function findScript(script) {
            if (this.table.scriptList == null) {
                return null;
            }
            if (!Array.isArray(script)) {
                script = [script];
            }
            for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var s = _ref;
                for (var _iterator2 = this.table.scriptList, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length)
                            break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done)
                            break;
                        _ref2 = _i2.value;
                    }
                    var entry = _ref2;
                    if (entry.tag === s) {
                        return entry;
                    }
                }
            }
            return null;
        };
        OTProcessor.prototype.selectScript = function selectScript(script, language, direction$$) {
            var changed = false;
            var entry = void 0;
            if (!this.script || script !== this.scriptTag) {
                entry = this.findScript(script);
                if (!entry) {
                    entry = this.findScript(DEFAULT_SCRIPTS);
                }
                if (!entry) {
                    return this.scriptTag;
                }
                this.scriptTag = entry.tag;
                this.script = entry.script;
                this.language = null;
                this.languageTag = null;
                changed = true;
            }
            if (!direction$$ || direction$$ !== this.direction) {
                this.direction = direction$$ || direction(script);
            }
            if (language && language.length < 4) {
                language += ' '.repeat(4 - language.length);
            }
            if (!language || language !== this.languageTag) {
                this.language = null;
                for (var _iterator3 = this.script.langSysRecords, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                    var _ref3;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length)
                            break;
                        _ref3 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done)
                            break;
                        _ref3 = _i3.value;
                    }
                    var lang = _ref3;
                    if (lang.tag === language) {
                        this.language = lang.langSys;
                        this.languageTag = lang.tag;
                        break;
                    }
                }
                if (!this.language) {
                    this.language = this.script.defaultLangSys;
                    this.languageTag = null;
                }
                changed = true;
            }
            if (changed) {
                this.features = {};
                if (this.language) {
                    for (var _iterator4 = this.language.featureIndexes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
                        var _ref4;
                        if (_isArray4) {
                            if (_i4 >= _iterator4.length)
                                break;
                            _ref4 = _iterator4[_i4++];
                        } else {
                            _i4 = _iterator4.next();
                            if (_i4.done)
                                break;
                            _ref4 = _i4.value;
                        }
                        var featureIndex = _ref4;
                        var record = this.table.featureList[featureIndex];
                        var substituteFeature = this.substituteFeatureForVariations(featureIndex);
                        this.features[record.tag] = substituteFeature || record.feature;
                    }
                }
            }
            return this.scriptTag;
        };
        OTProcessor.prototype.lookupsForFeatures = function lookupsForFeatures() {
            var userFeatures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var exclude = arguments[1];
            var lookups = [];
            for (var _iterator5 = userFeatures, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
                var _ref5;
                if (_isArray5) {
                    if (_i5 >= _iterator5.length)
                        break;
                    _ref5 = _iterator5[_i5++];
                } else {
                    _i5 = _iterator5.next();
                    if (_i5.done)
                        break;
                    _ref5 = _i5.value;
                }
                var tag = _ref5;
                var feature = this.features[tag];
                if (!feature) {
                    continue;
                }
                for (var _iterator6 = feature.lookupListIndexes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
                    var _ref6;
                    if (_isArray6) {
                        if (_i6 >= _iterator6.length)
                            break;
                        _ref6 = _iterator6[_i6++];
                    } else {
                        _i6 = _iterator6.next();
                        if (_i6.done)
                            break;
                        _ref6 = _i6.value;
                    }
                    var lookupIndex = _ref6;
                    if (exclude && exclude.indexOf(lookupIndex) !== -1) {
                        continue;
                    }
                    lookups.push({
                        feature: tag,
                        index: lookupIndex,
                        lookup: this.table.lookupList.get(lookupIndex)
                    });
                }
            }
            lookups.sort(function (a, b) {
                return a.index - b.index;
            });
            return lookups;
        };
        OTProcessor.prototype.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
            if (this.variationsIndex === -1) {
                return null;
            }
            var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
            var substitutions = record.featureTableSubstitution.substitutions;
            for (var _iterator7 = substitutions, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
                var _ref7;
                if (_isArray7) {
                    if (_i7 >= _iterator7.length)
                        break;
                    _ref7 = _iterator7[_i7++];
                } else {
                    _i7 = _iterator7.next();
                    if (_i7.done)
                        break;
                    _ref7 = _i7.value;
                }
                var substitution = _ref7;
                if (substitution.featureIndex === featureIndex) {
                    return substitution.alternateFeatureTable;
                }
            }
            return null;
        };
        OTProcessor.prototype.findVariationsIndex = function findVariationsIndex(coords) {
            var variations = this.table.featureVariations;
            if (!variations) {
                return -1;
            }
            var records = variations.featureVariationRecords;
            for (var i = 0; i < records.length; i++) {
                var conditions = records[i].conditionSet.conditionTable;
                if (this.variationConditionsMatch(conditions, coords)) {
                    return i;
                }
            }
            return -1;
        };
        OTProcessor.prototype.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
            return conditions.every(function (condition) {
                var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
                return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
            });
        };
        OTProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
            var lookups = this.lookupsForFeatures(userFeatures);
            this.applyLookups(lookups, glyphs, advances);
        };
        OTProcessor.prototype.applyLookups = function applyLookups(lookups, glyphs, positions) {
            this.glyphs = glyphs;
            this.positions = positions;
            this.glyphIterator = new GlyphIterator(glyphs);
            for (var _iterator8 = lookups, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _getIterator(_iterator8);;) {
                var _ref8;
                if (_isArray8) {
                    if (_i8 >= _iterator8.length)
                        break;
                    _ref8 = _iterator8[_i8++];
                } else {
                    _i8 = _iterator8.next();
                    if (_i8.done)
                        break;
                    _ref8 = _i8.value;
                }
                var _ref9 = _ref8, feature = _ref9.feature, lookup = _ref9.lookup;
                this.currentFeature = feature;
                this.glyphIterator.reset(lookup.flags);
                while (this.glyphIterator.index < glyphs.length) {
                    if (!(feature in this.glyphIterator.cur.features)) {
                        this.glyphIterator.next();
                        continue;
                    }
                    for (var _iterator9 = lookup.subTables, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _getIterator(_iterator9);;) {
                        var _ref10;
                        if (_isArray9) {
                            if (_i9 >= _iterator9.length)
                                break;
                            _ref10 = _iterator9[_i9++];
                        } else {
                            _i9 = _iterator9.next();
                            if (_i9.done)
                                break;
                            _ref10 = _i9.value;
                        }
                        var table = _ref10;
                        var res = this.applyLookup(lookup.lookupType, table);
                        if (res) {
                            break;
                        }
                    }
                    this.glyphIterator.next();
                }
            }
        };
        OTProcessor.prototype.applyLookup = function applyLookup(lookup, table) {
            throw new Error('applyLookup must be implemented by subclasses');
        };
        OTProcessor.prototype.applyLookupList = function applyLookupList(lookupRecords) {
            var options = this.glyphIterator.options;
            var glyphIndex = this.glyphIterator.index;
            for (var _iterator10 = lookupRecords, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _getIterator(_iterator10);;) {
                var _ref11;
                if (_isArray10) {
                    if (_i10 >= _iterator10.length)
                        break;
                    _ref11 = _iterator10[_i10++];
                } else {
                    _i10 = _iterator10.next();
                    if (_i10.done)
                        break;
                    _ref11 = _i10.value;
                }
                var lookupRecord = _ref11;
                this.glyphIterator.reset(options, glyphIndex);
                this.glyphIterator.increment(lookupRecord.sequenceIndex);
                var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
                this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
                for (var _iterator11 = lookup.subTables, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _getIterator(_iterator11);;) {
                    var _ref12;
                    if (_isArray11) {
                        if (_i11 >= _iterator11.length)
                            break;
                        _ref12 = _iterator11[_i11++];
                    } else {
                        _i11 = _iterator11.next();
                        if (_i11.done)
                            break;
                        _ref12 = _i11.value;
                    }
                    var table = _ref12;
                    if (this.applyLookup(lookup.lookupType, table)) {
                        break;
                    }
                }
            }
            this.glyphIterator.reset(options, glyphIndex);
            return true;
        };
        OTProcessor.prototype.coverageIndex = function coverageIndex(coverage, glyph) {
            if (glyph == null) {
                glyph = this.glyphIterator.cur.id;
            }
            switch (coverage.version) {
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for (var _iterator12 = coverage.rangeRecords, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _getIterator(_iterator12);;) {
                    var _ref13;
                    if (_isArray12) {
                        if (_i12 >= _iterator12.length)
                            break;
                        _ref13 = _iterator12[_i12++];
                    } else {
                        _i12 = _iterator12.next();
                        if (_i12.done)
                            break;
                        _ref13 = _i12.value;
                    }
                    var range = _ref13;
                    if (range.start <= glyph && glyph <= range.end) {
                        return range.startCoverageIndex + glyph - range.start;
                    }
                }
                break;
            }
            return -1;
        };
        OTProcessor.prototype.match = function match(sequenceIndex, sequence, fn, matched) {
            var pos = this.glyphIterator.index;
            var glyph = this.glyphIterator.increment(sequenceIndex);
            var idx = 0;
            while (idx < sequence.length && glyph && fn(sequence[idx], glyph)) {
                if (matched) {
                    matched.push(this.glyphIterator.index);
                }
                idx++;
                glyph = this.glyphIterator.next();
            }
            this.glyphIterator.index = pos;
            if (idx < sequence.length) {
                return false;
            }
            return matched || true;
        };
        OTProcessor.prototype.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
            return this.match(sequenceIndex, sequence, function (component, glyph) {
                return component === glyph.id;
            });
        };
        OTProcessor.prototype.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
            var _this = this;
            return this.match(sequenceIndex, sequence, function (component, glyph) {
                if (!(_this.currentFeature in glyph.features)) {
                    return false;
                }
                return component === glyph.id;
            }, []);
        };
        OTProcessor.prototype.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
            var _this2 = this;
            return this.match(sequenceIndex, sequence, function (coverage, glyph) {
                return _this2.coverageIndex(coverage, glyph.id) >= 0;
            });
        };
        OTProcessor.prototype.getClassID = function getClassID(glyph, classDef) {
            switch (classDef.version) {
            case 1:
                var i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) {
                    return classDef.classValueArray[i];
                }
                break;
            case 2:
                for (var _iterator13 = classDef.classRangeRecord, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _getIterator(_iterator13);;) {
                    var _ref14;
                    if (_isArray13) {
                        if (_i13 >= _iterator13.length)
                            break;
                        _ref14 = _iterator13[_i13++];
                    } else {
                        _i13 = _iterator13.next();
                        if (_i13.done)
                            break;
                        _ref14 = _i13.value;
                    }
                    var range = _ref14;
                    if (range.start <= glyph && glyph <= range.end) {
                        return range.class;
                    }
                }
                break;
            }
            return 0;
        };
        OTProcessor.prototype.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
            var _this3 = this;
            return this.match(sequenceIndex, sequence, function (classID, glyph) {
                return classID === _this3.getClassID(glyph.id, classDef);
            });
        };
        OTProcessor.prototype.applyContext = function applyContext(table) {
            switch (table.version) {
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) {
                    return false;
                }
                var set = table.ruleSets[index];
                for (var _iterator14 = set, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _getIterator(_iterator14);;) {
                    var _ref15;
                    if (_isArray14) {
                        if (_i14 >= _iterator14.length)
                            break;
                        _ref15 = _iterator14[_i14++];
                    } else {
                        _i14 = _iterator14.next();
                        if (_i14.done)
                            break;
                        _ref15 = _i14.value;
                    }
                    var rule = _ref15;
                    if (this.sequenceMatches(1, rule.input)) {
                        return this.applyLookupList(rule.lookupRecords);
                    }
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) {
                    return false;
                }
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) {
                    return false;
                }
                set = table.classSet[index];
                for (var _iterator15 = set, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _getIterator(_iterator15);;) {
                    var _ref16;
                    if (_isArray15) {
                        if (_i15 >= _iterator15.length)
                            break;
                        _ref16 = _iterator15[_i15++];
                    } else {
                        _i15 = _iterator15.next();
                        if (_i15.done)
                            break;
                        _ref16 = _i15.value;
                    }
                    var _rule = _ref16;
                    if (this.classSequenceMatches(1, _rule.classes, table.classDef)) {
                        return this.applyLookupList(_rule.lookupRecords);
                    }
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) {
                    return this.applyLookupList(table.lookupRecords);
                }
                break;
            }
            return false;
        };
        OTProcessor.prototype.applyChainingContext = function applyChainingContext(table) {
            switch (table.version) {
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) {
                    return false;
                }
                var set = table.chainRuleSets[index];
                for (var _iterator16 = set, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _getIterator(_iterator16);;) {
                    var _ref17;
                    if (_isArray16) {
                        if (_i16 >= _iterator16.length)
                            break;
                        _ref17 = _iterator16[_i16++];
                    } else {
                        _i16 = _iterator16.next();
                        if (_i16.done)
                            break;
                        _ref17 = _i16.value;
                    }
                    var rule = _ref17;
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) {
                        return this.applyLookupList(rule.lookupRecords);
                    }
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) {
                    return false;
                }
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                var rules = table.chainClassSet[index];
                if (!rules) {
                    return false;
                }
                for (var _iterator17 = rules, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _getIterator(_iterator17);;) {
                    var _ref18;
                    if (_isArray17) {
                        if (_i17 >= _iterator17.length)
                            break;
                        _ref18 = _iterator17[_i17++];
                    } else {
                        _i17 = _iterator17.next();
                        if (_i17.done)
                            break;
                        _ref18 = _i17.value;
                    }
                    var _rule2 = _ref18;
                    if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) {
                        return this.applyLookupList(_rule2.lookupRecords);
                    }
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) {
                    return this.applyLookupList(table.lookupRecords);
                }
                break;
            }
            return false;
        };
        return OTProcessor;
    }();
var GlyphInfo = function () {
        function GlyphInfo(font, id) {
            var codePoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var features = arguments[3];
            _classCallCheck(this, GlyphInfo);
            this._font = font;
            this.codePoints = codePoints;
            this.id = id;
            this.features = {};
            if (Array.isArray(features)) {
                for (var i = 0; i < features.length; i++) {
                    var feature = features[i];
                    this.features[feature] = true;
                }
            } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
                _Object$assign(this.features, features);
            }
            this.ligatureID = null;
            this.ligatureComponent = null;
            this.isLigated = false;
            this.cursiveAttachment = null;
            this.markAttachment = null;
            this.shaperInfo = null;
            this.substituted = false;
            this.isMultiplied = false;
        }
        GlyphInfo.prototype.copy = function copy() {
            return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
        };
        _createClass(GlyphInfo, [{
                key: 'id',
                get: function get() {
                    return this._id;
                },
                set: function set(id) {
                    this._id = id;
                    this.substituted = true;
                    var GDEF = this._font.GDEF;
                    if (GDEF && GDEF.glyphClassDef) {
                        var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                        this.isBase = classID === 1;
                        this.isLigature = classID === 2;
                        this.isMark = classID === 3;
                        this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
                    } else {
                        this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
                        this.isBase = !this.isMark;
                        this.isLigature = this.codePoints.length > 1;
                        this.markAttachmentType = 0;
                    }
                }
            }]);
        return GlyphInfo;
    }();
var _class$5;
var _temp$1;
var HangulShaper = (_temp$1 = _class$5 = function (_DefaultShaper) {
        _inherits(HangulShaper, _DefaultShaper);
        function HangulShaper() {
            _classCallCheck(this, HangulShaper);
            return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
        }
        HangulShaper.planFeatures = function planFeatures(plan) {
            plan.add([
                'ljmo',
                'vjmo',
                'tjmo'
            ], false);
        };
        HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            var state = 0;
            var i = 0;
            while (i < glyphs.length) {
                var action = void 0;
                var glyph = glyphs[i];
                var code = glyph.codePoints[0];
                var type = getType(code);
                var _STATE_TABLE$state$ty = STATE_TABLE$1[state][type];
                action = _STATE_TABLE$state$ty[0];
                state = _STATE_TABLE$state$ty[1];
                switch (action) {
                case DECOMPOSE:
                    if (!plan.font.hasGlyphForCodePoint(code)) {
                        i = decompose(glyphs, i, plan.font);
                    }
                    break;
                case COMPOSE:
                    i = compose(glyphs, i, plan.font);
                    break;
                case TONE_MARK:
                    reorderToneMark(glyphs, i, plan.font);
                    break;
                case INVALID:
                    i = insertDottedCircle(glyphs, i, plan.font);
                    break;
                }
                i++;
            }
        };
        return HangulShaper;
    }(DefaultShaper), _class$5.zeroMarkWidths = 'NONE', _temp$1);
var HANGUL_BASE = 44032;
var HANGUL_END = 55204;
var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
var L_BASE = 4352;
var V_BASE = 4449;
var T_BASE = 4519;
var L_COUNT = 19;
var V_COUNT = 21;
var T_COUNT = 28;
var L_END = L_BASE + L_COUNT - 1;
var V_END = V_BASE + V_COUNT - 1;
var T_END = T_BASE + T_COUNT - 1;
var DOTTED_CIRCLE = 9676;
var isL = function isL(code) {
    return 4352 <= code && code <= 4447 || 43360 <= code && code <= 43388;
};
var isV = function isV(code) {
    return 4448 <= code && code <= 4519 || 55216 <= code && code <= 55238;
};
var isT = function isT(code) {
    return 4520 <= code && code <= 4607 || 55243 <= code && code <= 55291;
};
var isTone = function isTone(code) {
    return 12334 <= code && code <= 12335;
};
var isLVT = function isLVT(code) {
    return HANGUL_BASE <= code && code <= HANGUL_END;
};
var isLV = function isLV(code) {
    return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
};
var isCombiningL = function isCombiningL(code) {
    return L_BASE <= code && code <= L_END;
};
var isCombiningV = function isCombiningV(code) {
    return V_BASE <= code && code <= V_END;
};
var isCombiningT = function isCombiningT(code) {
    return T_BASE + 1 && 1 <= code && code <= T_END;
};
var X = 0;
var L = 1;
var V = 2;
var T = 3;
var LV = 4;
var LVT = 5;
var M = 6;
function getType(code) {
    if (isL(code)) {
        return L;
    }
    if (isV(code)) {
        return V;
    }
    if (isT(code)) {
        return T;
    }
    if (isLV(code)) {
        return LV;
    }
    if (isLVT(code)) {
        return LVT;
    }
    if (isTone(code)) {
        return M;
    }
    return X;
}
var NO_ACTION = 0;
var DECOMPOSE = 1;
var COMPOSE = 2;
var TONE_MARK = 4;
var INVALID = 5;
var STATE_TABLE$1 = [
        [
            [
                NO_ACTION,
                0
            ],
            [
                NO_ACTION,
                1
            ],
            [
                NO_ACTION,
                0
            ],
            [
                NO_ACTION,
                0
            ],
            [
                DECOMPOSE,
                2
            ],
            [
                DECOMPOSE,
                3
            ],
            [
                INVALID,
                0
            ]
        ],
        [
            [
                NO_ACTION,
                0
            ],
            [
                NO_ACTION,
                1
            ],
            [
                COMPOSE,
                2
            ],
            [
                NO_ACTION,
                0
            ],
            [
                DECOMPOSE,
                2
            ],
            [
                DECOMPOSE,
                3
            ],
            [
                INVALID,
                0
            ]
        ],
        [
            [
                NO_ACTION,
                0
            ],
            [
                NO_ACTION,
                1
            ],
            [
                NO_ACTION,
                0
            ],
            [
                COMPOSE,
                3
            ],
            [
                DECOMPOSE,
                2
            ],
            [
                DECOMPOSE,
                3
            ],
            [
                TONE_MARK,
                0
            ]
        ],
        [
            [
                NO_ACTION,
                0
            ],
            [
                NO_ACTION,
                1
            ],
            [
                NO_ACTION,
                0
            ],
            [
                NO_ACTION,
                0
            ],
            [
                DECOMPOSE,
                2
            ],
            [
                DECOMPOSE,
                3
            ],
            [
                TONE_MARK,
                0
            ]
        ]
    ];
function getGlyph(font, code, features) {
    return new GlyphInfo(font, font.glyphForCodePoint(code).id, [code], features);
}
function decompose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyph.codePoints[0];
    var s = code - HANGUL_BASE;
    var t = T_BASE + s % T_COUNT;
    s = s / T_COUNT | 0;
    var l = L_BASE + s / V_COUNT | 0;
    var v = V_BASE + s % V_COUNT;
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) {
        return i;
    }
    var ljmo = getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    var vjmo = getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    var insert = [
            ljmo,
            vjmo
        ];
    if (t > T_BASE) {
        var tjmo = getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice.apply(glyphs, [
        i,
        1
    ].concat(insert));
    return i + insert.length - 1;
}
function compose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    var type = getType(code);
    var prev = glyphs[i - 1].codePoints[0];
    var prevType = getType(prev);
    var lv = void 0, ljmo = void 0, vjmo = void 0, tjmo = void 0;
    if (prevType === LV && type === T) {
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === V) {
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        var l = ljmo.codePoints[0];
        var v = vjmo.codePoints[0];
        if (isCombiningL(l) && isCombiningV(v)) {
            lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
        }
    }
    var t = tjmo && tjmo.codePoints[0] || T_BASE;
    if (lv != null && (t === T_BASE || isCombiningT(t))) {
        var s = lv + (t - T_BASE);
        if (font.hasGlyphForCodePoint(s)) {
            var del = prevType === V ? 3 : 2;
            glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    }
    if (ljmo) {
        ljmo.features.ljmo = true;
    }
    if (vjmo) {
        vjmo.features.vjmo = true;
    }
    if (tjmo) {
        tjmo.features.tjmo = true;
    }
    if (prevType === LV) {
        decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function getLength(code) {
    switch (getType(code)) {
    case LV:
    case LVT:
        return 1;
    case V:
        return 2;
    case T:
        return 3;
    }
}
function reorderToneMark(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    if (font.glyphForCodePoint(code).advanceWidth === 0) {
        return;
    }
    var prev = glyphs[i - 1].codePoints[0];
    var len = getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function insertDottedCircle(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
        var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features);
        var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
var stateTable = [
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            0,
            10,
            11,
            11,
            12,
            13,
            14,
            15,
            16,
            17
        ],
        [
            0,
            0,
            0,
            18,
            19,
            20,
            21,
            22,
            23,
            0,
            24,
            0,
            0,
            25,
            26,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            28,
            29,
            30,
            31,
            32,
            33,
            0,
            34,
            0,
            0,
            35,
            36,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            38,
            5,
            7,
            7,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            13,
            0,
            0,
            16,
            0
        ],
        [
            0,
            39,
            0,
            0,
            0,
            40,
            41,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            39,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            43,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            12,
            43,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            43,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            0,
            43,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            45,
            46,
            47,
            48,
            49,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            50,
            0,
            0,
            51,
            0,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            52,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            53,
            54,
            55,
            56,
            57,
            58,
            0,
            59,
            0,
            0,
            60,
            61,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            4,
            5,
            7,
            7,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            13,
            0,
            0,
            16,
            0
        ],
        [
            0,
            63,
            64,
            0,
            0,
            40,
            41,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            63,
            0,
            0
        ],
        [
            0,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            0,
            10,
            11,
            11,
            12,
            13,
            0,
            2,
            16,
            0
        ],
        [
            0,
            0,
            0,
            18,
            65,
            20,
            21,
            22,
            23,
            0,
            24,
            0,
            0,
            25,
            26,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            66,
            67,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            68,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            69,
            0,
            70,
            70,
            0,
            71,
            0,
            72,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            73,
            19,
            74,
            74,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            26,
            0,
            0,
            27,
            0
        ],
        [
            0,
            75,
            0,
            0,
            0,
            76,
            77,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            75,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            79,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            25,
            79,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            18,
            19,
            20,
            74,
            22,
            23,
            0,
            24,
            0,
            0,
            25,
            26,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            81,
            82,
            83,
            84,
            85,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            86,
            0,
            0,
            87,
            0,
            24,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            88,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            18,
            19,
            74,
            74,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            26,
            0,
            0,
            27,
            0
        ],
        [
            0,
            89,
            90,
            0,
            0,
            76,
            77,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            89,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            91,
            92,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            93,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            94,
            29,
            95,
            31,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            36,
            0,
            0,
            37,
            0
        ],
        [
            0,
            96,
            0,
            0,
            0,
            97,
            98,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            96,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            100,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            35,
            100,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            100,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            100,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            102,
            103,
            104,
            105,
            106,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            107,
            0,
            0,
            108,
            0,
            34,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            109,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            28,
            29,
            95,
            31,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            36,
            0,
            0,
            37,
            0
        ],
        [
            0,
            110,
            111,
            0,
            0,
            97,
            98,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            110,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            112,
            113,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            114,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            5,
            7,
            7,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            13,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            115,
            116,
            117,
            118,
            8,
            9,
            0,
            10,
            0,
            0,
            119,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            39,
            0,
            122,
            0,
            123,
            123,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            39,
            0,
            0
        ],
        [
            0,
            124,
            64,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            124,
            0,
            0
        ],
        [
            0,
            39,
            0,
            0,
            0,
            121,
            125,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            39,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            126,
            126,
            8,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            46,
            47,
            48,
            49,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            47,
            47,
            49,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            127,
            127,
            49,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            128,
            127,
            127,
            49,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            129,
            130,
            131,
            132,
            133,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            50,
            0,
            0,
            0,
            0,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            134,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            135,
            54,
            56,
            56,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            61,
            0,
            0,
            62,
            0
        ],
        [
            0,
            136,
            0,
            0,
            0,
            137,
            138,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            136,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            140,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            60,
            140,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            140,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            0,
            140,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            142,
            143,
            144,
            145,
            146,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            147,
            0,
            0,
            148,
            0,
            59,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            53,
            54,
            56,
            56,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            61,
            0,
            0,
            62,
            0
        ],
        [
            0,
            150,
            151,
            0,
            0,
            137,
            138,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            150,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            152,
            153,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            154,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            155,
            116,
            156,
            157,
            8,
            9,
            0,
            10,
            0,
            0,
            158,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            75,
            3,
            4,
            5,
            159,
            160,
            8,
            161,
            0,
            162,
            0,
            11,
            12,
            163,
            0,
            75,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            40,
            164,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            165,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            0,
            165,
            0,
            0,
            0,
            0
        ],
        [
            0,
            124,
            64,
            0,
            0,
            40,
            164,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            124,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            70,
            70,
            0,
            71,
            0,
            72,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            71,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            166,
            0,
            0,
            167,
            0,
            72,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            168,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            19,
            74,
            74,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            26,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            79,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            0,
            79,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            169,
            170,
            171,
            172,
            22,
            23,
            0,
            24,
            0,
            0,
            173,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            75,
            0,
            176,
            0,
            177,
            177,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            75,
            0,
            0
        ],
        [
            0,
            178,
            90,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            178,
            0,
            0
        ],
        [
            0,
            75,
            0,
            0,
            0,
            175,
            179,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            75,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            180,
            180,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            82,
            83,
            84,
            85,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            83,
            83,
            85,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            181,
            181,
            85,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            182,
            181,
            181,
            85,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            183,
            184,
            185,
            186,
            187,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            24,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            86,
            0,
            0,
            0,
            0,
            24,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            188,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            189,
            170,
            190,
            191,
            22,
            23,
            0,
            24,
            0,
            0,
            192,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            76,
            193,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            194,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            0,
            194,
            0,
            0,
            0,
            0
        ],
        [
            0,
            178,
            90,
            0,
            0,
            76,
            193,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            178,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            29,
            95,
            31,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            36,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            100,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            100,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            195,
            196,
            197,
            198,
            32,
            33,
            0,
            34,
            0,
            0,
            199,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            96,
            0,
            202,
            0,
            203,
            203,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            96,
            0,
            0
        ],
        [
            0,
            204,
            111,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            204,
            0,
            0
        ],
        [
            0,
            96,
            0,
            0,
            0,
            201,
            205,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            96,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            206,
            206,
            32,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            103,
            104,
            105,
            106,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            104,
            104,
            106,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            207,
            207,
            106,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            208,
            207,
            207,
            106,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            209,
            210,
            211,
            212,
            213,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            34,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            107,
            0,
            0,
            0,
            0,
            34,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            214,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            215,
            196,
            216,
            217,
            32,
            33,
            0,
            34,
            0,
            0,
            218,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            97,
            219,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            220,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            220,
            0,
            0,
            0,
            0
        ],
        [
            0,
            204,
            111,
            0,
            0,
            97,
            219,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            204,
            0,
            0
        ],
        [
            0,
            0,
            0,
            221,
            116,
            222,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            223,
            0,
            0,
            0,
            40,
            224,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            223,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            225,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            119,
            225,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            115,
            116,
            117,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            119,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            115,
            116,
            222,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            226,
            64,
            0,
            0,
            40,
            224,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            226,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            39,
            0,
            0,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            39,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            227,
            0,
            228,
            229,
            0,
            9,
            0,
            10,
            0,
            0,
            230,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            39,
            0,
            122,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            39,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            231,
            231,
            49,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            232,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            130,
            131,
            132,
            133,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            131,
            131,
            133,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            233,
            233,
            133,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            234,
            233,
            233,
            133,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            235,
            236,
            237,
            238,
            239,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            54,
            56,
            56,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            61,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            240,
            241,
            242,
            243,
            57,
            58,
            0,
            59,
            0,
            0,
            244,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            136,
            0,
            247,
            0,
            248,
            248,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            136,
            0,
            0
        ],
        [
            0,
            249,
            151,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            249,
            0,
            0
        ],
        [
            0,
            136,
            0,
            0,
            0,
            246,
            250,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            136,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            251,
            251,
            57,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            143,
            144,
            145,
            146,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            144,
            144,
            146,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            252,
            252,
            146,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            253,
            252,
            252,
            146,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            254,
            255,
            256,
            257,
            258,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            59,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            147,
            0,
            0,
            0,
            0,
            59,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            259,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            260,
            241,
            261,
            262,
            57,
            58,
            0,
            59,
            0,
            0,
            263,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            137,
            264,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            265,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            0,
            265,
            0,
            0,
            0,
            0
        ],
        [
            0,
            249,
            151,
            0,
            0,
            137,
            264,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            249,
            0,
            0
        ],
        [
            0,
            0,
            0,
            221,
            116,
            222,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            225,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            158,
            225,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            155,
            116,
            156,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            158,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            155,
            116,
            222,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            43,
            266,
            266,
            8,
            161,
            0,
            24,
            0,
            0,
            12,
            267,
            0,
            0,
            0,
            0
        ],
        [
            0,
            75,
            0,
            176,
            43,
            268,
            268,
            269,
            161,
            0,
            24,
            0,
            0,
            0,
            267,
            0,
            75,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            270,
            0,
            0,
            271,
            0,
            162,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            272,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            273,
            274,
            0,
            0,
            40,
            41,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            273,
            0,
            0
        ],
        [
            0,
            0,
            0,
            40,
            0,
            123,
            123,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            121,
            275,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            72,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            166,
            0,
            0,
            0,
            0,
            72,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            276,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            277,
            170,
            278,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            279,
            0,
            0,
            0,
            76,
            280,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            279,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            281,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            173,
            281,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            169,
            170,
            171,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            173,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            169,
            170,
            278,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            282,
            90,
            0,
            0,
            76,
            280,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            282,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            75,
            0,
            0,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            75,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            283,
            0,
            284,
            285,
            0,
            23,
            0,
            24,
            0,
            0,
            286,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            75,
            0,
            176,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            75,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            287,
            287,
            85,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            288,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            184,
            185,
            186,
            187,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            185,
            185,
            187,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            289,
            289,
            187,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            290,
            289,
            289,
            187,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            291,
            292,
            293,
            294,
            295,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            277,
            170,
            278,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            281,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            192,
            281,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            189,
            170,
            190,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            192,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            189,
            170,
            278,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            76,
            0,
            177,
            177,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            175,
            296,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            297,
            196,
            298,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            299,
            0,
            0,
            0,
            97,
            300,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            299,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            301,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            199,
            301,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            195,
            196,
            197,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            199,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            195,
            196,
            298,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            302,
            111,
            0,
            0,
            97,
            300,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            302,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            96,
            0,
            0,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            96,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            303,
            0,
            304,
            305,
            0,
            33,
            0,
            34,
            0,
            0,
            306,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            96,
            0,
            202,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            96,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            32,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            307,
            307,
            106,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            210,
            211,
            212,
            213,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            211,
            211,
            213,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            309,
            309,
            213,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            310,
            309,
            309,
            213,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            311,
            312,
            313,
            314,
            315,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            297,
            196,
            298,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            301,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            218,
            301,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            215,
            196,
            216,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            218,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            215,
            196,
            298,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            97,
            0,
            203,
            203,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            201,
            316,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            116,
            222,
            222,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            225,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            0,
            225,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            317,
            318,
            319,
            320,
            8,
            9,
            0,
            10,
            0,
            0,
            321,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            223,
            0,
            323,
            0,
            123,
            123,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            223,
            0,
            0
        ],
        [
            0,
            223,
            0,
            0,
            0,
            121,
            324,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            223,
            0,
            0
        ],
        [
            0,
            0,
            0,
            325,
            318,
            326,
            327,
            8,
            9,
            0,
            10,
            0,
            0,
            328,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            64,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9,
            0,
            0,
            0,
            0,
            230,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            227,
            0,
            228,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            230,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            227,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            49,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            46,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            329,
            329,
            133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            330,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            236,
            237,
            238,
            239,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            237,
            237,
            239,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            331,
            331,
            239,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            332,
            331,
            331,
            239,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            333,
            40,
            121,
            334,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            335,
            241,
            336,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            337,
            0,
            0,
            0,
            137,
            338,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            337,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            339,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            244,
            339,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            240,
            241,
            242,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            244,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            240,
            241,
            336,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            340,
            151,
            0,
            0,
            137,
            338,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            340,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            136,
            0,
            0,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            136,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            341,
            0,
            342,
            343,
            0,
            58,
            0,
            59,
            0,
            0,
            344,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            136,
            0,
            247,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            136,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            57,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            345,
            345,
            146,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            346,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            255,
            256,
            257,
            258,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            256,
            256,
            258,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            347,
            347,
            258,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            348,
            347,
            347,
            258,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            349,
            350,
            351,
            352,
            353,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            335,
            241,
            336,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            339,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            263,
            339,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            260,
            241,
            261,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            263,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            260,
            241,
            336,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            137,
            0,
            248,
            248,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            246,
            354,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            126,
            126,
            8,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            355,
            90,
            0,
            0,
            121,
            125,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            355,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            356,
            356,
            269,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            357,
            358,
            359,
            360,
            361,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            162,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            270,
            0,
            0,
            0,
            0,
            162,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            363,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            364,
            116,
            365,
            366,
            8,
            161,
            0,
            162,
            0,
            0,
            367,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            368,
            368,
            0,
            161,
            0,
            162,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            40,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            170,
            278,
            278,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            174,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            281,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            0,
            281,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            369,
            370,
            371,
            372,
            22,
            23,
            0,
            24,
            0,
            0,
            373,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            279,
            0,
            375,
            0,
            177,
            177,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            279,
            0,
            0
        ],
        [
            0,
            279,
            0,
            0,
            0,
            175,
            376,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            279,
            0,
            0
        ],
        [
            0,
            0,
            0,
            377,
            370,
            378,
            379,
            22,
            23,
            0,
            24,
            0,
            0,
            380,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            90,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            286,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            283,
            0,
            284,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            286,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            283,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            85,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            82,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            381,
            381,
            187,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            382,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            292,
            293,
            294,
            295,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            293,
            293,
            295,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            383,
            383,
            295,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            384,
            383,
            383,
            295,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            385,
            76,
            175,
            386,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            76,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            196,
            298,
            298,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            200,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            301,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            301,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            387,
            388,
            389,
            390,
            32,
            33,
            0,
            34,
            0,
            0,
            391,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            299,
            0,
            393,
            0,
            203,
            203,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            299,
            0,
            0
        ],
        [
            0,
            299,
            0,
            0,
            0,
            201,
            394,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            299,
            0,
            0
        ],
        [
            0,
            0,
            0,
            395,
            388,
            396,
            397,
            32,
            33,
            0,
            34,
            0,
            0,
            398,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            111,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            33,
            0,
            0,
            0,
            0,
            306,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            303,
            0,
            304,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            306,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            303,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            106,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            399,
            399,
            213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            400,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            312,
            313,
            314,
            315,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            313,
            313,
            315,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            401,
            401,
            315,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            402,
            401,
            401,
            315,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            403,
            97,
            201,
            404,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            97,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            405,
            318,
            406,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            407,
            0,
            0,
            0,
            40,
            408,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            407,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            409,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            321,
            409,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            317,
            318,
            319,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            321,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            317,
            318,
            406,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            410,
            64,
            0,
            0,
            40,
            408,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            410,
            0,
            0
        ],
        [
            0,
            223,
            0,
            0,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            223,
            0,
            0
        ],
        [
            0,
            223,
            0,
            323,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            223,
            0,
            0
        ],
        [
            0,
            0,
            0,
            405,
            318,
            406,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            409,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            328,
            409,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            325,
            318,
            326,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            328,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            325,
            318,
            406,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            130,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            411,
            411,
            239,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            412,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            40,
            121,
            334,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            413,
            0,
            0,
            0,
            9,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            241,
            336,
            336,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            245,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            339,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            0,
            339,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            414,
            415,
            416,
            417,
            57,
            58,
            0,
            59,
            0,
            0,
            418,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            337,
            0,
            420,
            0,
            248,
            248,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            337,
            0,
            0
        ],
        [
            0,
            337,
            0,
            0,
            0,
            246,
            421,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            337,
            0,
            0
        ],
        [
            0,
            0,
            0,
            422,
            415,
            423,
            424,
            57,
            58,
            0,
            59,
            0,
            0,
            425,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            151,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            58,
            0,
            0,
            0,
            0,
            344,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            341,
            0,
            342,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            344,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            341,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            146,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            143,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            426,
            426,
            258,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            427,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            350,
            351,
            352,
            353,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            351,
            351,
            353,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            428,
            428,
            353,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            429,
            428,
            428,
            353,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            430,
            137,
            246,
            431,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            137,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            432,
            116,
            433,
            434,
            8,
            161,
            0,
            162,
            0,
            0,
            435,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            180,
            180,
            269,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            358,
            359,
            360,
            361,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            359,
            359,
            361,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            436,
            436,
            361,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            437,
            436,
            436,
            361,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            438,
            439,
            440,
            441,
            442,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            443,
            274,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            443,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            444,
            116,
            445,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            225,
            44,
            44,
            8,
            161,
            0,
            0,
            0,
            0,
            367,
            225,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            364,
            116,
            365,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            367,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            364,
            116,
            445,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            446,
            370,
            447,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            448,
            0,
            0,
            0,
            76,
            449,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            448,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            450,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            373,
            450,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            369,
            370,
            371,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            373,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            369,
            370,
            447,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            451,
            90,
            0,
            0,
            76,
            449,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            451,
            0,
            0
        ],
        [
            0,
            279,
            0,
            0,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            279,
            0,
            0
        ],
        [
            0,
            279,
            0,
            375,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            279,
            0,
            0
        ],
        [
            0,
            0,
            0,
            446,
            370,
            447,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            450,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            380,
            450,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            377,
            370,
            378,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            380,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            377,
            370,
            447,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            187,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            184,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            452,
            452,
            295,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            453,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            76,
            175,
            386,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            454,
            0,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            455,
            388,
            456,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            457,
            0,
            0,
            0,
            97,
            458,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            457,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            459,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            391,
            459,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            387,
            388,
            389,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            391,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            387,
            388,
            456,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            460,
            111,
            0,
            0,
            97,
            458,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            460,
            0,
            0
        ],
        [
            0,
            299,
            0,
            0,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            299,
            0,
            0
        ],
        [
            0,
            299,
            0,
            393,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            299,
            0,
            0
        ],
        [
            0,
            0,
            0,
            455,
            388,
            456,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            459,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            398,
            459,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            395,
            388,
            396,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            398,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            395,
            388,
            456,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            210,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            461,
            461,
            315,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            462,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            97,
            201,
            404,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            463,
            0,
            0,
            0,
            33,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            318,
            406,
            406,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            322,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            409,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            0,
            409,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            464,
            465,
            466,
            467,
            8,
            9,
            0,
            10,
            0,
            0,
            468,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            407,
            0,
            470,
            0,
            123,
            123,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            407,
            0,
            0
        ],
        [
            0,
            407,
            0,
            0,
            0,
            121,
            471,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            407,
            0,
            0
        ],
        [
            0,
            0,
            0,
            472,
            465,
            473,
            474,
            8,
            9,
            0,
            10,
            0,
            0,
            475,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            239,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            236,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            476,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            477,
            415,
            478,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            479,
            0,
            0,
            0,
            137,
            480,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            479,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            481,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            418,
            481,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            414,
            415,
            416,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            418,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            414,
            415,
            478,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            482,
            151,
            0,
            0,
            137,
            480,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            482,
            0,
            0
        ],
        [
            0,
            337,
            0,
            0,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            337,
            0,
            0
        ],
        [
            0,
            337,
            0,
            420,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            337,
            0,
            0
        ],
        [
            0,
            0,
            0,
            477,
            415,
            478,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            481,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            425,
            481,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            422,
            415,
            423,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            425,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            422,
            415,
            478,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            258,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            255,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            483,
            483,
            353,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            484,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            137,
            246,
            431,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            485,
            0,
            0,
            0,
            58,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            444,
            116,
            445,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            225,
            44,
            44,
            8,
            161,
            0,
            0,
            0,
            0,
            435,
            225,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            432,
            116,
            433,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            435,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            432,
            116,
            445,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            486,
            486,
            361,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            487,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            439,
            440,
            441,
            442,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            440,
            440,
            442,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            488,
            488,
            442,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            489,
            488,
            488,
            442,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            490,
            491,
            492,
            493,
            494,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            495,
            0,
            496,
            497,
            0,
            161,
            0,
            162,
            0,
            0,
            498,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            116,
            445,
            445,
            8,
            161,
            0,
            162,
            0,
            0,
            0,
            120,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            225,
            44,
            44,
            8,
            161,
            0,
            0,
            0,
            0,
            0,
            225,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            370,
            447,
            447,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            374,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            450,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            0,
            450,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            499,
            500,
            501,
            502,
            22,
            23,
            0,
            24,
            0,
            0,
            503,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            448,
            0,
            505,
            0,
            177,
            177,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            448,
            0,
            0
        ],
        [
            0,
            448,
            0,
            0,
            0,
            175,
            506,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            448,
            0,
            0
        ],
        [
            0,
            0,
            0,
            507,
            500,
            508,
            509,
            22,
            23,
            0,
            24,
            0,
            0,
            510,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            295,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            292,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            511,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            388,
            456,
            456,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            392,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            459,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            459,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            512,
            513,
            514,
            515,
            32,
            33,
            0,
            34,
            0,
            0,
            516,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            457,
            0,
            518,
            0,
            203,
            203,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            457,
            0,
            0
        ],
        [
            0,
            457,
            0,
            0,
            0,
            201,
            519,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            457,
            0,
            0
        ],
        [
            0,
            0,
            0,
            520,
            513,
            521,
            522,
            32,
            33,
            0,
            34,
            0,
            0,
            523,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            315,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            312,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            524,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            525,
            465,
            526,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            527,
            0,
            0,
            0,
            40,
            528,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            527,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            529,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            468,
            529,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            464,
            465,
            466,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            468,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            464,
            465,
            526,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            530,
            64,
            0,
            0,
            40,
            528,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            530,
            0,
            0
        ],
        [
            0,
            407,
            0,
            0,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            407,
            0,
            0
        ],
        [
            0,
            407,
            0,
            470,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            407,
            0,
            0
        ],
        [
            0,
            0,
            0,
            525,
            465,
            526,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            529,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            475,
            529,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            472,
            465,
            473,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            475,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            472,
            465,
            526,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            40,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            415,
            478,
            478,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            419,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            481,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            0,
            481,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            531,
            532,
            533,
            534,
            57,
            58,
            0,
            59,
            0,
            0,
            535,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            479,
            0,
            537,
            0,
            248,
            248,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            479,
            0,
            0
        ],
        [
            0,
            479,
            0,
            0,
            0,
            246,
            538,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            479,
            0,
            0
        ],
        [
            0,
            0,
            0,
            539,
            532,
            540,
            541,
            57,
            58,
            0,
            59,
            0,
            0,
            542,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            353,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            350,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            543,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            361,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            358,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            544,
            544,
            442,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            545,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            491,
            492,
            493,
            494,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            492,
            492,
            494,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            546,
            546,
            494,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            547,
            546,
            546,
            494,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            548,
            549,
            368,
            550,
            0,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            274,
            0,
            368,
            368,
            0,
            161,
            0,
            162,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            161,
            0,
            0,
            0,
            0,
            498,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            495,
            0,
            496,
            368,
            0,
            161,
            0,
            162,
            0,
            0,
            498,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            495,
            0,
            368,
            368,
            0,
            161,
            0,
            162,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            551,
            500,
            552,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            553,
            0,
            0,
            0,
            76,
            554,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            553,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            555,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            503,
            555,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            499,
            500,
            501,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            503,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            499,
            500,
            552,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            556,
            90,
            0,
            0,
            76,
            554,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            556,
            0,
            0
        ],
        [
            0,
            448,
            0,
            0,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            448,
            0,
            0
        ],
        [
            0,
            448,
            0,
            505,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            448,
            0,
            0
        ],
        [
            0,
            0,
            0,
            551,
            500,
            552,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            555,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            510,
            555,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            507,
            500,
            508,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            510,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            507,
            500,
            552,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            76,
            0,
            0
        ],
        [
            0,
            0,
            0,
            557,
            513,
            558,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            559,
            0,
            0,
            0,
            97,
            560,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            559,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            561,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            516,
            561,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            512,
            513,
            514,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            516,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            512,
            513,
            558,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            562,
            111,
            0,
            0,
            97,
            560,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            562,
            0,
            0
        ],
        [
            0,
            457,
            0,
            0,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            457,
            0,
            0
        ],
        [
            0,
            457,
            0,
            518,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            457,
            0,
            0
        ],
        [
            0,
            0,
            0,
            557,
            513,
            558,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            561,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            523,
            561,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            520,
            513,
            521,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            523,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            520,
            513,
            558,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            97,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            465,
            526,
            526,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            469,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            529,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            0,
            529,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            563,
            66,
            564,
            565,
            8,
            9,
            0,
            10,
            0,
            0,
            566,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            527,
            0,
            567,
            0,
            123,
            123,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            527,
            0,
            0
        ],
        [
            0,
            527,
            0,
            0,
            0,
            121,
            568,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            527,
            0,
            0
        ],
        [
            0,
            0,
            0,
            569,
            66,
            570,
            571,
            8,
            9,
            0,
            10,
            0,
            0,
            572,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            573,
            532,
            574,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            575,
            0,
            0,
            0,
            137,
            576,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            575,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            577,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            535,
            577,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            531,
            532,
            533,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            535,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            531,
            532,
            574,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            578,
            151,
            0,
            0,
            137,
            576,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            578,
            0,
            0
        ],
        [
            0,
            479,
            0,
            0,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            479,
            0,
            0
        ],
        [
            0,
            479,
            0,
            537,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            479,
            0,
            0
        ],
        [
            0,
            0,
            0,
            573,
            532,
            574,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            577,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            542,
            577,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            539,
            532,
            540,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            542,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            539,
            532,
            574,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            137,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            442,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            439,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            579,
            579,
            494,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            580,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            549,
            368,
            550,
            0,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            368,
            368,
            0,
            161,
            0,
            162,
            0,
            0,
            0,
            362,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            581,
            0,
            0,
            0,
            161,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            500,
            552,
            552,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            504,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            555,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            0,
            555,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            582,
            91,
            583,
            584,
            22,
            23,
            0,
            24,
            0,
            0,
            585,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            553,
            0,
            586,
            0,
            177,
            177,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            553,
            0,
            0
        ],
        [
            0,
            553,
            0,
            0,
            0,
            175,
            587,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            553,
            0,
            0
        ],
        [
            0,
            0,
            0,
            588,
            91,
            589,
            590,
            22,
            23,
            0,
            24,
            0,
            0,
            591,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            513,
            558,
            558,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            517,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            561,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            0,
            561,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            592,
            112,
            593,
            594,
            32,
            33,
            0,
            34,
            0,
            0,
            595,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            559,
            0,
            596,
            0,
            203,
            203,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            559,
            0,
            0
        ],
        [
            0,
            559,
            0,
            0,
            0,
            201,
            597,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            559,
            0,
            0
        ],
        [
            0,
            0,
            0,
            598,
            112,
            599,
            600,
            32,
            33,
            0,
            34,
            0,
            0,
            601,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            602,
            66,
            67,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            165,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            566,
            165,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            563,
            66,
            564,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            566,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            563,
            66,
            67,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            527,
            0,
            0,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            527,
            0,
            0
        ],
        [
            0,
            527,
            0,
            567,
            0,
            121,
            121,
            0,
            9,
            0,
            10,
            0,
            0,
            0,
            42,
            0,
            527,
            0,
            0
        ],
        [
            0,
            0,
            0,
            602,
            66,
            67,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            165,
            44,
            44,
            8,
            9,
            0,
            0,
            0,
            0,
            572,
            165,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            569,
            66,
            570,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            572,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            569,
            66,
            67,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            0,
            532,
            574,
            574,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            536,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            577,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            0,
            577,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            603,
            152,
            604,
            605,
            57,
            58,
            0,
            59,
            0,
            0,
            606,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            575,
            0,
            607,
            0,
            248,
            248,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            575,
            0,
            0
        ],
        [
            0,
            575,
            0,
            0,
            0,
            246,
            608,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            575,
            0,
            0
        ],
        [
            0,
            0,
            0,
            609,
            152,
            610,
            611,
            57,
            58,
            0,
            59,
            0,
            0,
            612,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            494,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            491,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            613,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            614,
            91,
            92,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            194,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            585,
            194,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            582,
            91,
            583,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            585,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            582,
            91,
            92,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            553,
            0,
            0,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            553,
            0,
            0
        ],
        [
            0,
            553,
            0,
            586,
            0,
            175,
            175,
            0,
            23,
            0,
            24,
            0,
            0,
            0,
            78,
            0,
            553,
            0,
            0
        ],
        [
            0,
            0,
            0,
            614,
            91,
            92,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            194,
            80,
            80,
            22,
            23,
            0,
            0,
            0,
            0,
            591,
            194,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            588,
            91,
            589,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            591,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            588,
            91,
            92,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            615,
            112,
            113,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            220,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            595,
            220,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            592,
            112,
            593,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            595,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            592,
            112,
            113,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            559,
            0,
            0,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            559,
            0,
            0
        ],
        [
            0,
            559,
            0,
            596,
            0,
            201,
            201,
            0,
            33,
            0,
            34,
            0,
            0,
            0,
            99,
            0,
            559,
            0,
            0
        ],
        [
            0,
            0,
            0,
            615,
            112,
            113,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            220,
            101,
            101,
            32,
            33,
            0,
            0,
            0,
            0,
            601,
            220,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            598,
            112,
            599,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            601,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            598,
            112,
            113,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            66,
            67,
            67,
            8,
            9,
            0,
            10,
            0,
            0,
            0,
            68,
            0,
            0,
            16,
            0
        ],
        [
            0,
            0,
            0,
            616,
            152,
            153,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            265,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            606,
            265,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            603,
            152,
            604,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            606,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            603,
            152,
            153,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            575,
            0,
            0,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            575,
            0,
            0
        ],
        [
            0,
            575,
            0,
            607,
            0,
            246,
            246,
            0,
            58,
            0,
            59,
            0,
            0,
            0,
            139,
            0,
            575,
            0,
            0
        ],
        [
            0,
            0,
            0,
            616,
            152,
            153,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            265,
            141,
            141,
            57,
            58,
            0,
            0,
            0,
            0,
            612,
            265,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            609,
            152,
            610,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            612,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            609,
            152,
            153,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            154,
            0,
            0,
            62,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            549,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            91,
            92,
            92,
            22,
            23,
            0,
            24,
            0,
            0,
            0,
            93,
            0,
            0,
            27,
            0
        ],
        [
            0,
            0,
            0,
            0,
            112,
            113,
            113,
            32,
            33,
            0,
            34,
            0,
            0,
            0,
            114,
            0,
            0,
            37,
            0
        ],
        [
            0,
            0,
            0,
            0,
            152,
            153,
            153,
            57,
            58,
            0,
            59,
            0,
            0,
            0,
            154,
            0,
            0,
            62,
            0
        ]
    ];
var accepting = [
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        true,
        false,
        true,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        true,
        false,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        false,
        false,
        false,
        false,
        true,
        true,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        false,
        true,
        true,
        true
    ];
var tags = [
        [],
        ['broken_cluster'],
        ['consonant_syllable'],
        ['vowel_syllable'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['standalone_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['consonant_syllable'],
        ['broken_cluster'],
        ['symbol_cluster'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['symbol_cluster'],
        [],
        ['symbol_cluster'],
        ['symbol_cluster'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['symbol_cluster'],
        ['symbol_cluster'],
        ['symbol_cluster'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        [],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        ['broken_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['broken_cluster'],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        ['broken_cluster'],
        ['symbol_cluster'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        [],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        [],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        [],
        [],
        ['broken_cluster'],
        [],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        [],
        [],
        ['consonant_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        [],
        [],
        ['vowel_syllable'],
        [],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        [],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        [],
        [],
        ['standalone_cluster'],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        [],
        [],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        [],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        [],
        [],
        [],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [
            'consonant_syllable',
            'broken_cluster'
        ],
        [],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        [],
        [],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['consonant_syllable'],
        [],
        ['consonant_syllable'],
        ['consonant_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['vowel_syllable'],
        [],
        ['vowel_syllable'],
        ['vowel_syllable'],
        ['broken_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['standalone_cluster'],
        ['standalone_cluster'],
        [],
        ['consonant_syllable'],
        ['vowel_syllable'],
        ['standalone_cluster']
    ];
var indicMachine = {
        stateTable: stateTable,
        accepting: accepting,
        tags: tags
    };
var categories = [
        'O',
        'IND',
        'S',
        'GB',
        'B',
        'FM',
        'CGJ',
        'VMAbv',
        'VMPst',
        'VAbv',
        'VPst',
        'CMBlw',
        'VPre',
        'VBlw',
        'H',
        'VMBlw',
        'CMAbv',
        'MBlw',
        'CS',
        'R',
        'SUB',
        'MPst',
        'MPre',
        'FAbv',
        'FPst',
        'FBlw',
        'SMAbv',
        'SMBlw',
        'VMPre',
        'ZWNJ',
        'ZWJ',
        'WJ',
        'VS',
        'N',
        'HN',
        'MAbv'
    ];
var decompositions$1 = {
        '2507': [
            2503,
            2494
        ],
        '2508': [
            2503,
            2519
        ],
        '2888': [
            2887,
            2902
        ],
        '2891': [
            2887,
            2878
        ],
        '2892': [
            2887,
            2903
        ],
        '3018': [
            3014,
            3006
        ],
        '3019': [
            3015,
            3006
        ],
        '3020': [
            3014,
            3031
        ],
        '3144': [
            3142,
            3158
        ],
        '3264': [
            3263,
            3285
        ],
        '3271': [
            3270,
            3285
        ],
        '3272': [
            3270,
            3286
        ],
        '3274': [
            3270,
            3266
        ],
        '3275': [
            3270,
            3266,
            3285
        ],
        '3402': [
            3398,
            3390
        ],
        '3403': [
            3399,
            3390
        ],
        '3404': [
            3398,
            3415
        ],
        '3546': [
            3545,
            3530
        ],
        '3548': [
            3545,
            3535
        ],
        '3549': [
            3545,
            3535,
            3530
        ],
        '3550': [
            3545,
            3551
        ],
        '3635': [
            3661,
            3634
        ],
        '3763': [
            3789,
            3762
        ],
        '3955': [
            3953,
            3954
        ],
        '3957': [
            3953,
            3956
        ],
        '3958': [
            4018,
            3968
        ],
        '3959': [
            4018,
            3953,
            3968
        ],
        '3960': [
            4019,
            3968
        ],
        '3961': [
            4019,
            3953,
            3968
        ],
        '3969': [
            3953,
            3968
        ],
        '6971': [
            6970,
            6965
        ],
        '6973': [
            6972,
            6965
        ],
        '6976': [
            6974,
            6965
        ],
        '6977': [
            6975,
            6965
        ],
        '6979': [
            6978,
            6965
        ],
        '69934': [
            69937,
            69927
        ],
        '69935': [
            69938,
            69927
        ],
        '70475': [
            70471,
            70462
        ],
        '70476': [
            70471,
            70487
        ],
        '70843': [
            70841,
            70842
        ],
        '70844': [
            70841,
            70832
        ],
        '70846': [
            70841,
            70845
        ],
        '71098': [
            71096,
            71087
        ],
        '71099': [
            71097,
            71087
        ]
    };
var stateTable$1 = [
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            2,
            2,
            3,
            4,
            4,
            5,
            0,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            0,
            17,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            2,
            0,
            24,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            26,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            27,
            28,
            0,
            0,
            0,
            0,
            27,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            0,
            0,
            41,
            35,
            42,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            39,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            0,
            0,
            0,
            0,
            0,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            7,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            0,
            0,
            12,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            0,
            9,
            0,
            0,
            0,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            0,
            16,
            0,
            0,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            0,
            11,
            12,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            0,
            9,
            0,
            0,
            12,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            18,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            7,
            0,
            0,
            0,
            0,
            0,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            0,
            0,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            0,
            11,
            12,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            11,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            4,
            4,
            5,
            0,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            0,
            0,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            48,
            11,
            12,
            13,
            14,
            48,
            16,
            0,
            0,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            49,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            0,
            11,
            12,
            0,
            14,
            0,
            16,
            0,
            0,
            0,
            11,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            21,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            21,
            22,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            0,
            0,
            0,
            0,
            0,
            0,
            14,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            50,
            0,
            51,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            0,
            11,
            12,
            0,
            14,
            0,
            16,
            0,
            0,
            0,
            11,
            0,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            27,
            28,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            28,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            0,
            0,
            0,
            0,
            0,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            0,
            31,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            0,
            0,
            36,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            0,
            33,
            0,
            0,
            0,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            0,
            40,
            0,
            0,
            41,
            35,
            42,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            0,
            35,
            36,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            0,
            33,
            0,
            0,
            36,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            41,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            0,
            31,
            0,
            0,
            0,
            0,
            0,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            0,
            0,
            41,
            35,
            42,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            0,
            35,
            36,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            35,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            52,
            35,
            36,
            37,
            38,
            52,
            40,
            0,
            0,
            41,
            35,
            42,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            53,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            0,
            35,
            36,
            0,
            38,
            0,
            40,
            0,
            0,
            0,
            35,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            44,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            44,
            45,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            0,
            0,
            0,
            0,
            0,
            0,
            38,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            0,
            35,
            36,
            0,
            38,
            0,
            40,
            0,
            0,
            0,
            35,
            0,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            48,
            11,
            12,
            13,
            14,
            0,
            16,
            0,
            0,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            6,
            7,
            8,
            9,
            48,
            11,
            12,
            13,
            14,
            48,
            16,
            0,
            0,
            18,
            11,
            19,
            20,
            21,
            22,
            0,
            0,
            23,
            0,
            0,
            0,
            0,
            0,
            0,
            25
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            51,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            54,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            52,
            35,
            36,
            37,
            38,
            0,
            40,
            0,
            0,
            41,
            35,
            42,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            29,
            0,
            30,
            31,
            32,
            33,
            52,
            35,
            36,
            37,
            38,
            52,
            40,
            0,
            0,
            41,
            35,
            42,
            43,
            44,
            45,
            0,
            0,
            46,
            0,
            0,
            0,
            0,
            0,
            0,
            47
        ],
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            50,
            0,
            51,
            0
        ]
    ];
var accepting$1 = [
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
    ];
var tags$1 = [
        [],
        ['broken_cluster'],
        ['independent_cluster'],
        ['symbol_cluster'],
        ['standard_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        [],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['numeral_cluster'],
        ['broken_cluster'],
        ['independent_cluster'],
        ['symbol_cluster'],
        ['symbol_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['virama_terminated_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['broken_cluster'],
        ['broken_cluster'],
        ['numeral_cluster'],
        ['number_joiner_terminated_cluster'],
        ['standard_cluster'],
        ['standard_cluster'],
        ['numeral_cluster']
    ];
var useData = {
        categories: categories,
        decompositions: decompositions$1,
        stateTable: stateTable$1,
        accepting: accepting$1,
        tags: tags$1
    };
var CATEGORIES = {
        X: 1 << 0,
        C: 1 << 1,
        V: 1 << 2,
        N: 1 << 3,
        H: 1 << 4,
        ZWNJ: 1 << 5,
        ZWJ: 1 << 6,
        M: 1 << 7,
        SM: 1 << 8,
        VD: 1 << 9,
        A: 1 << 10,
        Placeholder: 1 << 11,
        Dotted_Circle: 1 << 12,
        RS: 1 << 13,
        Coeng: 1 << 14,
        Repha: 1 << 15,
        Ra: 1 << 16,
        CM: 1 << 17,
        Symbol: 1 << 18
    };
var POSITIONS = {
        Start: 1 << 0,
        Ra_To_Become_Reph: 1 << 1,
        Pre_M: 1 << 2,
        Pre_C: 1 << 3,
        Base_C: 1 << 4,
        After_Main: 1 << 5,
        Above_C: 1 << 6,
        Before_Sub: 1 << 7,
        Below_C: 1 << 8,
        After_Sub: 1 << 9,
        Before_Post: 1 << 10,
        Post_C: 1 << 11,
        After_Post: 1 << 12,
        Final_C: 1 << 13,
        SMVD: 1 << 14,
        End: 1 << 15
    };
var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
var INDIC_CONFIGS = {
        Default: {
            hasOldSpec: false,
            virama: 0,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Devanagari: {
            hasOldSpec: true,
            virama: 2381,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Bengali: {
            hasOldSpec: true,
            virama: 2509,
            basePos: 'Last',
            rephPos: POSITIONS.After_Sub,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Gurmukhi: {
            hasOldSpec: true,
            virama: 2637,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Sub,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Gujarati: {
            hasOldSpec: true,
            virama: 2765,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Oriya: {
            hasOldSpec: true,
            virama: 2893,
            basePos: 'Last',
            rephPos: POSITIONS.After_Main,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Tamil: {
            hasOldSpec: true,
            virama: 3021,
            basePos: 'Last',
            rephPos: POSITIONS.After_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post'
        },
        Telugu: {
            hasOldSpec: true,
            virama: 3149,
            basePos: 'Last',
            rephPos: POSITIONS.After_Post,
            rephMode: 'Explicit',
            blwfMode: 'Post_Only'
        },
        Kannada: {
            hasOldSpec: true,
            virama: 3277,
            basePos: 'Last',
            rephPos: POSITIONS.After_Post,
            rephMode: 'Implicit',
            blwfMode: 'Post_Only'
        },
        Malayalam: {
            hasOldSpec: true,
            virama: 3405,
            basePos: 'Last',
            rephPos: POSITIONS.After_Main,
            rephMode: 'Log_Repha',
            blwfMode: 'Pre_And_Post'
        },
        Khmer: {
            hasOldSpec: false,
            virama: 6098,
            basePos: 'First',
            rephPos: POSITIONS.Ra_To_Become_Reph,
            rephMode: 'Vis_Repha',
            blwfMode: 'Pre_And_Post'
        }
    };
var INDIC_DECOMPOSITIONS = {
        6078: [
            6081,
            6078
        ],
        6079: [
            6081,
            6079
        ],
        6080: [
            6081,
            6080
        ],
        6084: [
            6081,
            6084
        ],
        6085: [
            6081,
            6085
        ]
    };
var _class$6;
var _temp$2;
var decompositions = useData.decompositions;
var trie$1 = new UnicodeTrie(Buffer('ABEAAAAAAAAAAMKgAbENTvLtnX+sHUUVx/f13nd/vHf7bl+FRGL7R0OJMcWYphBrimkVCSJR2xiEaLEGQ7AkBGowbYRSgj8K2B/GkpRYE6wlQSyJKCagrSlGkmqsqUZMY7S2CWkgqQViQSkt4Hfuzrx77tyZ2fm1u+/RPcknuzs7O3PmnDOzs7N73zteS5KXwKvgDTCnniTvBfPBJeAVpP2vFr69GGUtAkvAModyr0DeT4BrwCpwPVgDbga3ga+DjYbyluLcCvBN8F2wGWwHO8Ej4DjyPIbtz0DCeZpvD4CD4E/gb+AoOAFOgtPgLKiNJkkbTIKLwALwfvAh8GGwHFwFPg2uAzeCm8Ft4E5wN7gPPAi+D34AfgR+Ap7kx8+AZ8HvwZ/BEXAMvAheAa+Bc6OpzvVGknTABY30eB62C8GlYDFYCpaDq/n5z2J7PVgDbgG3N1KbrOdbWzby/N/G9i6wlR8/wLebUNcOll7vX7PLsQ4bdpAy92B/L3gK7AO/A38EfwX/AC+AkyT/m3x7mqdtYz7Gfq2ZJOPgPc3UXu/D9uJmmmcRT1uC7TJwZTONJxFL1+J4JbgBrAG3gNv5Nev5dhO2m3l54rqtON7RNLd1V8Z5auMfI+8Wbvv12P4Ux78AvyZl/Bb7fwD34HwH/EVR/t8t6rRlrYgFlHnMsdyXIupRFP+Gzv8Bb4CklSSjrTR9bz21uZx/Nj8v+uIFOJ4HFnJo3kWtNG6WkPSzBl1YbC8jeVfx+q+R9Pg48lxN8jFdhd8+01LrLTCdq6io8GNb1a8qKioqKioqKioc2cbXGcrWQ2Ynf9a9rmV/zVua9Dc16V/gz8pfxvar4A6wAdwL7gdbwUPgh+BR8AR4qpWuLe3D9gA4CA6DI+AoOAFOtdL1nNexfYs937fxDA8ubKf1zmv3dViI/Uvb9m2sqKioqAiHrVtehrH3TK2/3l4WZduioqIiDq+Rd1Jbef9ehnHmSnCtNNf7nOPcr8PHilO8jrfBF9v996lfwf6tUpl3tPvvdSjsvcwGnLt3Gsw/kzkpK8CdYH83my3Id0iT91WkL5xMktXgIfD85OD54zjfmYu5OFgN7h1LkmdBMg5fgbvAChzv49ujfEuZ3xlOk7kReTaSfL/B/jl+fMXsJLkb7AcPj8TlHC/zsgnYcyLd3zSh1vGAJr2ioqKiIn/eKXkMjn3/cWF5t/z6y37+K5urwP2YB36vPfw8yr7zeRjpu8g8cTf2H2+n89EtivLE93fs27Ez/Br2vM2+qWPl/ZyX9StFfQxW5v724PPxzXz7XHu4Pps5Jvtmiq13szmzfP0hlHkYHGn358bHeD0vYvsy+K+kz9vt/jy8gT40G1w4Rua0PN98nnaGf/e1G+mXIO2DY8P6Xz7WPz7Ky/7omJ0PBff4+B91fAqsAp8HXwI3gR04txbbdWDDWDpP/g7Yxs6BXWAP2AueJHo+M5bOpw+Cw+AIOApOgFMW7Xkdec6AkXH1+QfgyzbOTY73jy/C/gJ+/CCOP4D9xfz4I9h+TFMWtf9SRWzZwq7f0yi/L9voWSRbDfV/clx/3TuKfjoT26/iX813URx4tiVG3ay/sfFuJenb7J50A4mr1di/CZzLKZ6y2reunup4qzT+fM0wHp0PUD9+A7bYNJ5fn3eNP/Ft5bc0+S4n9/l1Gj+K82zesd1wfj3fZ79h2YyyVvLj7djfCR4xjJEyuy1+S/FyDt/MPwodn5hB8axrxy9nSBtYjOyHrs+BQ+B58E+u+wsWbWBtpb/hYL8RuA/pJ8fT2GffX+wl+daSa08jz9nxNG2k4963XBG/ZVhpUS573mh3BtPo7x/Eb7pE2yd5XvZssY/M/RZLc9SLeDsfD5gfTidi9//pwrzWu7t9lKcN7dxynthAh8vcKrQu1frHTGKBNF662KfoOXU1FsaFxe6x2kjClkBnGvXxwX0bytZ5unK+S9n2jxabTc5M0HUaIyTrfFa+Ljmflc9Xz7JtNdPa4eKz6WAPlb5l6xfLBzopWxcfncvSf7rHRJk2KSN2bKRsvcu2UZmxVIb9qd551e8rZcTERGuQ+qwIjERkjl2+djOlhWfpibnp/qxmP92FVr1/bc9GYxxuI5o3UzdukzYpj+H6nOxra9nHiaksjhDdsasPe9ca/CvOU1GVwUT4t8P921H4T8gsnkdIh+dn/pXrU0mnOZw21CbJv1P5LP0r4jtkbLH171BbCvavnFfeZ8L8K2wv/CuQRU6n/qWSNSbr2mO8xtK/U+Mq6Y/1yQyFJHHtv8Kn2uOC/Gvbf2VEPxJ9SvhY5d+Q+y21iRxLruOzsY6MWGrOkPHZ1b+jFuPzqEX/VcmoZkyIPT53k36/DZnrMd+K/Dbjs6kv6+6VYl9OU+WT07TplvMvWWhfVo3f4t48S+rbjIZl/1b5Xyd5vJdQiTyf7tUdMlbn0J9d/cn6c7M5DO1TNF0+bmT0Z3qdKaaoXeg1Lv7NEhufzyT/6vIKEeO1jX/psdi38a889qpkStcI/u12U3zE1Re+/Yv6QNwvdTDJGi9t2ps1XtKYDJ0PmcZKcU812sRxvms7J47mZ5c+SWJD5LPRg4qqj+nWL8Q5sRVrGar1EG0sOI6ndH3DVWL7wpeuwaY6O1Nh19N+Oqs5uI7Eto3aICxNrCn5rAuZ7Cn2bdJtfZPlL/k8Ld+ki6v9E56XPUvT52mV/YVvmMj2Zz8TEuNMTxfHuFfFUJ60OLrz1utODnFG47fLbSjXy0xSy4gN63EywlhMxWcNmK71svszi5OGTvdJe3rtd8ifB6I/mKBr1ap7uU/sqqTsMb+H5fxBFyuq+yqLnd7cmj33TwyOVVOwuj3nVXRtQtUGWR9jzI6kecZrKSKPuFakU2hZmXXZMDlsS1W9jBavv6eHpf3EtfJ7mKwYV0lX2g9FVY5N+Ung9aH1590+n3KLgEredfiez6u9svisY/Suk9Jsnkli1a+C1m/T7rzqd5UY9mfiXX9R92ibdZUIawTC96b1GBn6rDG1JsPv/b392SkiXVUGmyN0LO5LYi46Zf/Adc/QMaCo8TtG/bH1Z/TsW1QfUPRjm2cZee5PRaT33lEbnhlMax4qe1o/Y8a0icdaoOv9bsh+Hj6jonueoGtHumcMlX9lxLxXq7/D84fSzznGt6rtUerXxYU47/IcPeG3vqBbJ1StETZqg9fS2Akd/0Ovp+/CxD3P+/6bQwzJtsvyh5w+XjeXH9KfXGH3/VbSX4tS4XoftPZbnvcyxX1G5QvW1wbWTkbs7c3mTco6NWODbdxk3R9lGZo/aGxhiknTmETXLVs1c90u9+mBGCf6hs6fsmTq29sxPv8d82CuhCpNjGNjg31blGHrz1i41hd6nuYzbU3XhLQzj7Jt67Otw0uXUdDoH8e4F/joMdVui2dMJc3E+Tetvr6jEtPnPhJaVwz9Y7TDVlx1qnfitlEbtzlTVD0qX/pcm1esxI65PO3mU4eNrr5SZMz46FDE+aIlb5tntb1o/WOUETsW847pvNpaZH225eUpNnrS9yDy9wTysyr9XVOe63+qd3M6e4X6Ptd1Dpc1SdV53ZqFag1hpP+bE5f4ivY74BzXilzWWW1+S0TjJng91Gd9wmbNgpMVz6W8d7GJZwWtWp8p++c8fpjW0Vzff3dJfzGuoersEtnmpjVLupY48H6o7n8/C+kvJn+Lcd6q3QHx3usvZax3W8apvP6rev+UJSHfiCYe/h2aTwTaRi5DO28ZSd9zNhTfJ8b2je7drOo9HtNNbPMW03zOpq2qNqnKFN+0huhlMye2Pe9TdzfCedfxMlRfG7xjncaJ7fiXMYZk3X+ZvuKbXCGh8y8XH8TybajPTfq4tjG2/qb0RJO3SB19ba2SMuoNbW8R/g653qa9sdsRYsssu+ZxPss+tnayFd94yjofEi+hZdvo73q9jd3yisUYbfEpQ9XmMqUIm2fFZh4xkZeE1BNDL5v+ZcqXh/90bSwjflz8U0QcFWHzPOpy0amM+stqf1ad7LltVPqWmG3p3+GiIvLJf8duYA3NcBwbWRpkDXmo7RP+z5E6+8Xswz512dbrW2aMNrpKaBt9y45VR2j9efhAQL/PF38Xadq907NYC5dpZLy3kMX6PUHgeGGS3nfoPn9rObJ9s/4uMntnSt/J5TX+2ZRhtFcB8ZgVmyZbit8GCd/7/C7EOcYK7LdyjNhIlL81nqN/Xf9mOHt/anovP4X0tyem/OUZF9TmscY2nzEulq96ZeVwv2Bxxnwk3s9njT8m/YWOKl199fe53tTXyu5DLojfKWXej6R3RAPtDf1ex/PvtdJ8Q7aP7Ht6XpdXSJf8/wMdQuS/j0/HtKny9KbT+oT2K2ETuW7Tt09Uss5nCdWhjPuMTXzrztO4FHMy+V6TJaH9I6+2C5HPq9oc8xlKRva5rF8M/7tC26/6BsNFivQ//e1pVsyP19VrNrH1D5Wi7oUDdVp8Q5HVr1ztlzXPtH2Gc30+lMX3edH3ecm3fp0+Ps/IPvWH6OpiV7meEMlbzyIkpi1jtDU0Pmm6nMd0jU8bXK7N0jWkb/joHyNebfWgtrJpc0h7QiQP24aKqcwYPnTRIUmG63fRQ5VXLsekgy5NtVXVadLfpjzV9S6xYnuNri159ZmsmLCpJ8/6XSRGOaH659H+GLYtwhd51xvq31B9Qm0UavM84qhoKaNOnfwf', 'base64'));
var stateMachine = new StateMachine(indicMachine);
var IndicShaper = (_temp$2 = _class$6 = function (_DefaultShaper) {
        _inherits(IndicShaper, _DefaultShaper);
        function IndicShaper() {
            _classCallCheck(this, IndicShaper);
            return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
        }
        IndicShaper.planFeatures = function planFeatures(plan) {
            plan.addStage(setupSyllables);
            plan.addStage([
                'locl',
                'ccmp'
            ]);
            plan.addStage(initialReordering);
            plan.addStage('nukt');
            plan.addStage('akhn');
            plan.addStage('rphf', false);
            plan.addStage('rkrf');
            plan.addStage('pref', false);
            plan.addStage('blwf', false);
            plan.addStage('abvf', false);
            plan.addStage('half', false);
            plan.addStage('pstf', false);
            plan.addStage('vatu');
            plan.addStage('cjct');
            plan.addStage('cfar', false);
            plan.addStage(finalReordering);
            plan.addStage({
                local: ['init'],
                global: [
                    'pres',
                    'abvs',
                    'blws',
                    'psts',
                    'haln',
                    'dist',
                    'abvm',
                    'blwm',
                    'calt',
                    'clig'
                ]
            });
            plan.unicodeScript = fromOpenType(plan.script);
            plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
            plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';
        };
        IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            var _loop = function _loop(i) {
                var codepoint = glyphs[i].codePoints[0];
                var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions[codepoint];
                if (d) {
                    var decomposed = d.map(function (c) {
                            var g = plan.font.glyphForCodePoint(c);
                            return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
                        });
                    glyphs.splice.apply(glyphs, [
                        i,
                        1
                    ].concat(decomposed));
                }
            };
            for (var i = glyphs.length - 1; i >= 0; i--) {
                _loop(i);
            }
        };
        return IndicShaper;
    }(DefaultShaper), _class$6.zeroMarkWidths = 'NONE', _temp$2);
function indicCategory(glyph) {
    return trie$1.get(glyph.codePoints[0]) >> 8;
}
function indicPosition(glyph) {
    return 1 << (trie$1.get(glyph.codePoints[0]) & 255);
}
var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
    _classCallCheck(this, IndicInfo);
    this.category = category;
    this.position = position;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function setupSyllables(font, glyphs) {
    var syllable = 0;
    var last = 0;
    for (var _iterator = stateMachine.match(glyphs.map(indicCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length)
                break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done)
                break;
            _ref = _i.value;
        }
        var _ref2 = _ref, start = _ref2[0], end = _ref2[1], tags = _ref2[2];
        if (start > last) {
            ++syllable;
            for (var _i2 = last; _i2 < start; _i2++) {
                glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
            }
        }
        ++syllable;
        for (var _i3 = start; _i3 <= end; _i3++) {
            glyphs[_i3].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i3]), indicPosition(glyphs[_i3]), tags[0], syllable);
        }
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for (var i = last; i < glyphs.length; i++) {
            glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
        }
    }
}
function isConsonant(glyph) {
    return glyph.shaperInfo.category & CONSONANT_FLAGS;
}
function isJoiner(glyph) {
    return glyph.shaperInfo.category & JOINER_FLAGS;
}
function isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
}
function wouldSubstitute(glyphs, feature) {
    for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _glyph$features;
        var _ref3;
        if (_isArray2) {
            if (_i4 >= _iterator2.length)
                break;
            _ref3 = _iterator2[_i4++];
        } else {
            _i4 = _iterator2.next();
            if (_i4.done)
                break;
            _ref3 = _i4.value;
        }
        var glyph = _ref3;
        glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
    }
    var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([feature], glyphs);
    return glyphs.length === 1;
}
function consonantPosition(font, consonant, virama) {
    var glyphs = [
            virama,
            consonant,
            virama
        ];
    if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) {
        return POSITIONS.Below_C;
    } else if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) {
        return POSITIONS.Post_C;
    } else if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) {
        return POSITIONS.Post_C;
    }
    return POSITIONS.Base_C;
}
function initialReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    var dottedCircle = font.glyphForCodePoint(9676).id;
    var virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        var info = new GlyphInfo(font, virama, [indicConfig.virama]);
        for (var i = 0; i < glyphs.length; i++) {
            if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) {
                glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
            }
        }
    }
    for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
        var _glyphs$start$shaperI = glyphs[start].shaperInfo, category = _glyphs$start$shaperI.category, syllableType = _glyphs$start$shaperI.syllableType;
        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') {
            continue;
        }
        if (syllableType === 'broken_cluster' && dottedCircle) {
            var g = new GlyphInfo(font, dottedCircle, [9676]);
            g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
            var _i5 = start;
            while (_i5 < end && glyphs[_i5].shaperInfo.category === CATEGORIES.Repha) {
                _i5++;
            }
            glyphs.splice(_i5++, 0, g);
            end++;
        }
        var base = end;
        var limit = start;
        var hasReph = false;
        if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
            var _g = [
                    glyphs[start].copy(),
                    glyphs[start + 1].copy(),
                    glyphs[start + 2].copy()
                ];
            if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
                limit += 2;
                while (limit < end && isJoiner(glyphs[limit])) {
                    limit++;
                }
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
            limit++;
            while (limit < end && isJoiner(glyphs[limit])) {
                limit++;
            }
            base = start;
            hasReph = true;
        }
        switch (indicConfig.basePos) {
        case 'Last': {
                var _i6 = end;
                var seenBelow = false;
                do {
                    var _info = glyphs[--_i6].shaperInfo;
                    if (isConsonant(glyphs[_i6])) {
                        if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
                            base = _i6;
                            break;
                        }
                        if (_info.position === POSITIONS.Below_C) {
                            seenBelow = true;
                        }
                        base = _i6;
                    } else if (start < _i6 && _info.category === CATEGORIES.ZWJ && glyphs[_i6 - 1].shaperInfo.category === CATEGORIES.H) {
                        break;
                    }
                } while (_i6 > limit);
                break;
            }
        case 'First': {
                base = start;
                for (var _i7 = base + 1; _i7 < end; _i7++) {
                    if (isConsonant(glyphs[_i7])) {
                        glyphs[_i7].shaperInfo.position = POSITIONS.Below_C;
                    }
                }
            }
        }
        if (hasReph && base === start && limit - base <= 2) {
            hasReph = false;
        }
        for (var _i8 = start; _i8 < base; _i8++) {
            var _info2 = glyphs[_i8].shaperInfo;
            _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
        }
        if (base < end) {
            glyphs[base].shaperInfo.position = POSITIONS.Base_C;
        }
        for (var _i9 = base + 1; _i9 < end; _i9++) {
            if (glyphs[_i9].shaperInfo.category === CATEGORIES.M) {
                for (var j = _i9 + 1; j < end; j++) {
                    if (isConsonant(glyphs[j])) {
                        glyphs[j].shaperInfo.position = POSITIONS.Final_C;
                        break;
                    }
                }
                break;
            }
        }
        if (hasReph) {
            glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
        }
        if (plan.isOldSpec) {
            var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
            for (var _i10 = base + 1; _i10 < end; _i10++) {
                if (glyphs[_i10].shaperInfo.category === CATEGORIES.H) {
                    var _j = void 0;
                    for (_j = end - 1; _j > _i10; _j--) {
                        if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) {
                            break;
                        }
                    }
                    if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i10) {
                        var t = glyphs[_i10];
                        glyphs.splice.apply(glyphs, [
                            _i10,
                            0
                        ].concat(glyphs.splice(_i10 + 1, _j - _i10)));
                        glyphs[_j] = t;
                    }
                    break;
                }
            }
        }
        var lastPos = POSITIONS.Start;
        for (var _i11 = start; _i11 < end; _i11++) {
            var _info3 = glyphs[_i11].shaperInfo;
            if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
                _info3.position = lastPos;
                if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
                    for (var _j2 = _i11; _j2 > start; _j2--) {
                        if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
                            _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                            break;
                        }
                    }
                }
            } else if (_info3.position !== POSITIONS.SMVD) {
                lastPos = _info3.position;
            }
        }
        var last = base;
        for (var _i12 = base + 1; _i12 < end; _i12++) {
            if (isConsonant(glyphs[_i12])) {
                for (var _j3 = last + 1; _j3 < _i12; _j3++) {
                    if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) {
                        glyphs[_j3].shaperInfo.position = glyphs[_i12].shaperInfo.position;
                    }
                }
                last = _i12;
            } else if (glyphs[_i12].shaperInfo.category === CATEGORIES.M) {
                last = _i12;
            }
        }
        var arr = glyphs.slice(start, end);
        arr.sort(function (a, b) {
            return a.shaperInfo.position - b.shaperInfo.position;
        });
        glyphs.splice.apply(glyphs, [
            start,
            arr.length
        ].concat(arr));
        for (var _i13 = start; _i13 < end; _i13++) {
            if (glyphs[_i13].shaperInfo.position === POSITIONS.Base_C) {
                base = _i13;
                break;
            }
        }
        for (var _i14 = start; _i14 < end && glyphs[_i14].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i14++) {
            glyphs[_i14].features.rphf = true;
        }
        var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
        for (var _i15 = start; _i15 < base; _i15++) {
            glyphs[_i15].features.half = true;
            if (blwf) {
                glyphs[_i15].features.blwf = true;
            }
        }
        for (var _i16 = base + 1; _i16 < end; _i16++) {
            glyphs[_i16].features.abvf = true;
            glyphs[_i16].features.pstf = true;
            glyphs[_i16].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
            for (var _i17 = start; _i17 + 1 < base; _i17++) {
                if (glyphs[_i17].shaperInfo.category === CATEGORIES.Ra && glyphs[_i17 + 1].shaperInfo.category === CATEGORIES.H && (_i17 + 1 === base || glyphs[_i17 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                    glyphs[_i17].features.blwf = true;
                    glyphs[_i17 + 1].features.blwf = true;
                }
            }
        }
        var prefLen = 2;
        if (features.pref && base + prefLen < end) {
            for (var _i18 = base + 1; _i18 + prefLen - 1 < end; _i18++) {
                var _g2 = [
                        glyphs[_i18].copy(),
                        glyphs[_i18 + 1].copy()
                    ];
                if (wouldSubstitute(_g2, 'pref')) {
                    for (var _j4 = 0; _j4 < prefLen; _j4++) {
                        glyphs[_i18++].features.pref = true;
                    }
                    if (features.cfar) {
                        for (; _i18 < end; _i18++) {
                            glyphs[_i18].features.cfar = true;
                        }
                    }
                    break;
                }
            }
        }
        for (var _i19 = start + 1; _i19 < end; _i19++) {
            if (isJoiner(glyphs[_i19])) {
                var nonJoiner = glyphs[_i19].shaperInfo.category === CATEGORIES.ZWNJ;
                var _j5 = _i19;
                do {
                    _j5--;
                    if (nonJoiner) {
                        delete glyphs[_j5].features.half;
                    }
                } while (_j5 > start && !isConsonant(glyphs[_j5]));
            }
        }
    }
}
function finalReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
        var tryPref = !!features.pref;
        var base = start;
        for (; base < end; base++) {
            if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
                if (tryPref && base + 1 < end) {
                    for (var i = base + 1; i < end; i++) {
                        if (glyphs[i].features.pref) {
                            if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                                base = i;
                                while (base < end && isHalantOrCoeng(glyphs[base])) {
                                    base++;
                                }
                                glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
                                tryPref = false;
                            }
                            break;
                        }
                    }
                }
                if (plan.unicodeScript === 'Malayalam') {
                    for (var _i20 = base + 1; _i20 < end; _i20++) {
                        while (_i20 < end && isJoiner(glyphs[_i20])) {
                            _i20++;
                        }
                        if (_i20 === end || !isHalantOrCoeng(glyphs[_i20])) {
                            break;
                        }
                        _i20++;
                        while (_i20 < end && isJoiner(glyphs[_i20])) {
                            _i20++;
                        }
                        if (_i20 < end && isConsonant(glyphs[_i20]) && glyphs[_i20].shaperInfo.position === POSITIONS.Below_C) {
                            base = _i20;
                            glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                        }
                    }
                }
                if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) {
                    base--;
                }
                break;
            }
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) {
            base--;
        }
        if (base < end) {
            while (start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS)) {
                base--;
            }
        }
        if (start + 1 < end && start < base) {
            var newPos = base === end ? base - 2 : base - 1;
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while (newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
                    newPos--;
                }
                if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                    if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) {
                        newPos++;
                    }
                } else {
                    newPos = start;
                }
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                for (var _i21 = newPos; _i21 > start; _i21--) {
                    if (glyphs[_i21 - 1].shaperInfo.position === POSITIONS.Pre_M) {
                        var oldPos = _i21 - 1;
                        if (oldPos < base && base <= newPos) {
                            base--;
                        }
                        var tmp = glyphs[oldPos];
                        glyphs.splice.apply(glyphs, [
                            oldPos,
                            0
                        ].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                        glyphs[newPos] = tmp;
                        newPos--;
                    }
                }
            }
        }
        if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            var newRephPos = void 0;
            var rephPos = indicConfig.rephPos;
            var found = false;
            if (rephPos !== POSITIONS.After_Post) {
                newRephPos = start + 1;
                while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
                    newRephPos++;
                }
                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
                        newRephPos++;
                    }
                    found = true;
                }
                if (!found && rephPos === POSITIONS.After_Main) {
                    newRephPos = base;
                    while (newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main) {
                        newRephPos++;
                    }
                    found = newRephPos < end;
                }
                if (!found && rephPos === POSITIONS.After_Sub) {
                    newRephPos = base;
                    while (newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD))) {
                        newRephPos++;
                    }
                    found = newRephPos < end;
                }
            }
            if (!found) {
                newRephPos = start + 1;
                while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
                    newRephPos++;
                }
                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
                        newRephPos++;
                    }
                    found = true;
                }
            }
            if (!found) {
                newRephPos = end - 1;
                while (newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD) {
                    newRephPos--;
                }
                if (isHalantOrCoeng(glyphs[newRephPos])) {
                    for (var _i22 = base + 1; _i22 < newRephPos; _i22++) {
                        if (glyphs[_i22].shaperInfo.category === CATEGORIES.M) {
                            newRephPos--;
                        }
                    }
                }
            }
            var reph = glyphs[start];
            glyphs.splice.apply(glyphs, [
                start,
                0
            ].concat(glyphs.splice(start + 1, newRephPos - start)));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) {
                base--;
            }
        }
        if (tryPref && base + 1 < end) {
            for (var _i23 = base + 1; _i23 < end; _i23++) {
                if (glyphs[_i23].features.pref) {
                    if (glyphs[_i23].isLigated && !glyphs[_i23].isMultiplied) {
                        var _newPos = base;
                        if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                            while (_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
                                _newPos--;
                            }
                            if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
                                var _oldPos2 = _i23;
                                for (var j = base + 1; j < _oldPos2; j++) {
                                    if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
                                        _newPos--;
                                        break;
                                    }
                                }
                            }
                        }
                        if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) {
                            if (_newPos < end && isJoiner(glyphs[_newPos])) {
                                _newPos++;
                            }
                        }
                        var _oldPos = _i23;
                        var _tmp = glyphs[_oldPos];
                        glyphs.splice.apply(glyphs, [
                            _newPos + 1,
                            0
                        ].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                        glyphs[_newPos] = _tmp;
                        if (_newPos <= base && base < _oldPos) {
                            base++;
                        }
                    }
                    break;
                }
            }
        }
        if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) {
            glyphs[start].features.init = true;
        }
    }
}
function nextSyllable(glyphs, start) {
    if (start >= glyphs.length)
        return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {
    }
    return start;
}
var _class$7;
var _temp$3;
var categories$1 = useData.categories;
var decompositions$2 = useData.decompositions;
var trie$2 = new UnicodeTrie(Buffer('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', 'base64'));
var stateMachine$1 = new StateMachine(useData);
var UniversalShaper = (_temp$3 = _class$7 = function (_DefaultShaper) {
        _inherits(UniversalShaper, _DefaultShaper);
        function UniversalShaper() {
            _classCallCheck(this, UniversalShaper);
            return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
        }
        UniversalShaper.planFeatures = function planFeatures(plan) {
            plan.addStage(setupSyllables$1);
            plan.addStage([
                'locl',
                'ccmp',
                'nukt',
                'akhn'
            ]);
            plan.addStage(clearSubstitutionFlags);
            plan.addStage(['rphf'], false);
            plan.addStage(recordRphf);
            plan.addStage(clearSubstitutionFlags);
            plan.addStage(['pref']);
            plan.addStage(recordPref);
            plan.addStage([
                'rkrf',
                'abvf',
                'blwf',
                'half',
                'pstf',
                'vatu',
                'cjct'
            ]);
            plan.addStage(reorder);
            plan.addStage([
                'abvs',
                'blws',
                'pres',
                'psts',
                'dist',
                'abvm',
                'blwm'
            ]);
        };
        UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            var _loop = function _loop(i) {
                var codepoint = glyphs[i].codePoints[0];
                if (decompositions$2[codepoint]) {
                    var decomposed = decompositions$2[codepoint].map(function (c) {
                            var g = plan.font.glyphForCodePoint(c);
                            return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
                        });
                    glyphs.splice.apply(glyphs, [
                        i,
                        1
                    ].concat(decomposed));
                }
            };
            for (var i = glyphs.length - 1; i >= 0; i--) {
                _loop(i);
            }
        };
        return UniversalShaper;
    }(DefaultShaper), _class$7.zeroMarkWidths = 'BEFORE_GPOS', _temp$3);
function useCategory(glyph) {
    return trie$2.get(glyph.codePoints[0]);
}
var USEInfo = function USEInfo(category, syllableType, syllable) {
    _classCallCheck(this, USEInfo);
    this.category = category;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function setupSyllables$1(font, glyphs) {
    var syllable = 0;
    for (var _iterator = stateMachine$1.match(glyphs.map(useCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length)
                break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done)
                break;
            _ref = _i.value;
        }
        var _ref2 = _ref, start = _ref2[0], end = _ref2[1], tags = _ref2[2];
        ++syllable;
        for (var i = start; i <= end; i++) {
            glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
        }
        var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
        for (var _i2 = start; _i2 < start + limit; _i2++) {
            glyphs[_i2].features.rphf = true;
        }
    }
}
function clearSubstitutionFlags(font, glyphs) {
    for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref3;
        if (_isArray2) {
            if (_i3 >= _iterator2.length)
                break;
            _ref3 = _iterator2[_i3++];
        } else {
            _i3 = _iterator2.next();
            if (_i3.done)
                break;
            _ref3 = _i3.value;
        }
        var glyph = _ref3;
        glyph.substituted = false;
    }
}
function recordRphf(font, glyphs) {
    for (var _iterator3 = glyphs, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref4;
        if (_isArray3) {
            if (_i4 >= _iterator3.length)
                break;
            _ref4 = _iterator3[_i4++];
        } else {
            _i4 = _iterator3.next();
            if (_i4.done)
                break;
            _ref4 = _i4.value;
        }
        var glyph = _ref4;
        if (glyph.substituted && glyph.features.rphf) {
            glyph.shaperInfo.category = 'R';
        }
    }
}
function recordPref(font, glyphs) {
    for (var _iterator4 = glyphs, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
        var _ref5;
        if (_isArray4) {
            if (_i5 >= _iterator4.length)
                break;
            _ref5 = _iterator4[_i5++];
        } else {
            _i5 = _iterator4.next();
            if (_i5.done)
                break;
            _ref5 = _i5.value;
        }
        var glyph = _ref5;
        if (glyph.substituted) {
            glyph.shaperInfo.category = 'VPre';
        }
    }
}
function reorder(font, glyphs) {
    var dottedCircle = font.glyphForCodePoint(9676).id;
    for (var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)) {
        var i = void 0, j = void 0;
        var info = glyphs[start].shaperInfo;
        var type = info.syllableType;
        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') {
            continue;
        }
        if (type === 'broken_cluster' && dottedCircle) {
            var g = new GlyphInfo(font, dottedCircle, [9676]);
            g.shaperInfo = info;
            for (i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++) {
            }
            glyphs.splice(++i, 0, g);
            end++;
        }
        if (info.category === 'R' && end - start > 1) {
            for (i = start + 1; i < end; i++) {
                info = glyphs[i].shaperInfo;
                if (isBase(info) || isHalant(glyphs[i])) {
                    if (isHalant(glyphs[i])) {
                        i--;
                    }
                    glyphs.splice.apply(glyphs, [
                        start,
                        0
                    ].concat(glyphs.splice(start + 1, i - start), [glyphs[i]]));
                    break;
                }
            }
        }
        for (i = start, j = end; i < end; i++) {
            info = glyphs[i].shaperInfo;
            if (isBase(info) || isHalant(glyphs[i])) {
                j = isHalant(glyphs[i]) ? i + 1 : i;
            } else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) {
                glyphs.splice.apply(glyphs, [
                    j,
                    1,
                    glyphs[i]
                ].concat(glyphs.splice(j, i - j)));
            }
        }
    }
}
function nextSyllable$1(glyphs, start) {
    if (start >= glyphs.length)
        return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {
    }
    return start;
}
function isHalant(glyph) {
    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}
function isBase(info) {
    return info.category === 'B' || info.category === 'GB';
}
var SHAPERS = {
        arab: ArabicShaper,
        mong: ArabicShaper,
        syrc: ArabicShaper,
        'nko ': ArabicShaper,
        phag: ArabicShaper,
        mand: ArabicShaper,
        mani: ArabicShaper,
        phlp: ArabicShaper,
        hang: HangulShaper,
        bng2: IndicShaper,
        beng: IndicShaper,
        dev2: IndicShaper,
        deva: IndicShaper,
        gjr2: IndicShaper,
        gujr: IndicShaper,
        guru: IndicShaper,
        gur2: IndicShaper,
        knda: IndicShaper,
        knd2: IndicShaper,
        mlm2: IndicShaper,
        mlym: IndicShaper,
        ory2: IndicShaper,
        orya: IndicShaper,
        taml: IndicShaper,
        tml2: IndicShaper,
        telu: IndicShaper,
        tel2: IndicShaper,
        khmr: IndicShaper,
        bali: UniversalShaper,
        batk: UniversalShaper,
        brah: UniversalShaper,
        bugi: UniversalShaper,
        buhd: UniversalShaper,
        cakm: UniversalShaper,
        cham: UniversalShaper,
        dupl: UniversalShaper,
        egyp: UniversalShaper,
        gran: UniversalShaper,
        hano: UniversalShaper,
        java: UniversalShaper,
        kthi: UniversalShaper,
        kali: UniversalShaper,
        khar: UniversalShaper,
        khoj: UniversalShaper,
        sind: UniversalShaper,
        lepc: UniversalShaper,
        limb: UniversalShaper,
        mahj: UniversalShaper,
        mtei: UniversalShaper,
        modi: UniversalShaper,
        hmng: UniversalShaper,
        rjng: UniversalShaper,
        saur: UniversalShaper,
        shrd: UniversalShaper,
        sidd: UniversalShaper,
        sinh: UniversalShaper,
        sund: UniversalShaper,
        sylo: UniversalShaper,
        tglg: UniversalShaper,
        tagb: UniversalShaper,
        tale: UniversalShaper,
        lana: UniversalShaper,
        tavt: UniversalShaper,
        takr: UniversalShaper,
        tibt: UniversalShaper,
        tfng: UniversalShaper,
        tirh: UniversalShaper,
        latn: DefaultShaper,
        DFLT: DefaultShaper
    };
function choose(script) {
    if (!Array.isArray(script)) {
        script = [script];
    }
    for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length)
                break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done)
                break;
            _ref = _i.value;
        }
        var s = _ref;
        var shaper = SHAPERS[s];
        if (shaper) {
            return shaper;
        }
    }
    return DefaultShaper;
}
var GSUBProcessor = function (_OTProcessor) {
        _inherits(GSUBProcessor, _OTProcessor);
        function GSUBProcessor() {
            _classCallCheck(this, GSUBProcessor);
            return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
        }
        GSUBProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
            var _this2 = this;
            switch (lookupType) {
            case 1: {
                    var index = this.coverageIndex(table.coverage);
                    if (index === -1) {
                        return false;
                    }
                    var glyph = this.glyphIterator.cur;
                    switch (table.version) {
                    case 1:
                        glyph.id = glyph.id + table.deltaGlyphID & 65535;
                        break;
                    case 2:
                        glyph.id = table.substitute.get(index);
                        break;
                    }
                    return true;
                }
            case 2: {
                    var _index = this.coverageIndex(table.coverage);
                    if (_index !== -1) {
                        var _glyphs;
                        var sequence = table.sequences.get(_index);
                        if (sequence.length === 0) {
                            this.glyphs.splice(this.glyphIterator.index, 1);
                            return true;
                        }
                        this.glyphIterator.cur.id = sequence[0];
                        this.glyphIterator.cur.ligatureComponent = 0;
                        var features = this.glyphIterator.cur.features;
                        var curGlyph = this.glyphIterator.cur;
                        var replacement = sequence.slice(1).map(function (gid, i) {
                                var glyph = new GlyphInfo(_this2.font, gid, undefined, features);
                                glyph.shaperInfo = curGlyph.shaperInfo;
                                glyph.isLigated = curGlyph.isLigated;
                                glyph.ligatureComponent = i + 1;
                                glyph.substituted = true;
                                glyph.isMultiplied = true;
                                return glyph;
                            });
                        (_glyphs = this.glyphs).splice.apply(_glyphs, [
                            this.glyphIterator.index + 1,
                            0
                        ].concat(replacement));
                        return true;
                    }
                    return false;
                }
            case 3: {
                    var _index2 = this.coverageIndex(table.coverage);
                    if (_index2 !== -1) {
                        var USER_INDEX = 0;
                        this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                        return true;
                    }
                    return false;
                }
            case 4: {
                    var _index3 = this.coverageIndex(table.coverage);
                    if (_index3 === -1) {
                        return false;
                    }
                    for (var _iterator = table.ligatureSets.get(_index3), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length)
                                break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done)
                                break;
                            _ref = _i.value;
                        }
                        var ligature = _ref;
                        var matched = this.sequenceMatchIndices(1, ligature.components);
                        if (!matched) {
                            continue;
                        }
                        var _curGlyph = this.glyphIterator.cur;
                        var characters = _curGlyph.codePoints.slice();
                        for (var _iterator2 = matched, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                            var _ref2;
                            if (_isArray2) {
                                if (_i2 >= _iterator2.length)
                                    break;
                                _ref2 = _iterator2[_i2++];
                            } else {
                                _i2 = _iterator2.next();
                                if (_i2.done)
                                    break;
                                _ref2 = _i2.value;
                            }
                            var _index4 = _ref2;
                            characters.push.apply(characters, this.glyphs[_index4].codePoints);
                        }
                        var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
                        ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                        ligatureGlyph.isLigated = true;
                        ligatureGlyph.substituted = true;
                        var isMarkLigature = _curGlyph.isMark;
                        for (var i = 0; i < matched.length && isMarkLigature; i++) {
                            isMarkLigature = this.glyphs[matched[i]].isMark;
                        }
                        ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                        var lastLigID = _curGlyph.ligatureID;
                        var lastNumComps = _curGlyph.codePoints.length;
                        var curComps = lastNumComps;
                        var idx = this.glyphIterator.index + 1;
                        for (var _iterator3 = matched, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                            var _ref3;
                            if (_isArray3) {
                                if (_i3 >= _iterator3.length)
                                    break;
                                _ref3 = _iterator3[_i3++];
                            } else {
                                _i3 = _iterator3.next();
                                if (_i3.done)
                                    break;
                                _ref3 = _i3.value;
                            }
                            var matchIndex = _ref3;
                            if (isMarkLigature) {
                                idx = matchIndex;
                            } else {
                                while (idx < matchIndex) {
                                    var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                    this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                    this.glyphs[idx].ligatureComponent = ligatureComponent;
                                    idx++;
                                }
                            }
                            lastLigID = this.glyphs[idx].ligatureID;
                            lastNumComps = this.glyphs[idx].codePoints.length;
                            curComps += lastNumComps;
                            idx++;
                        }
                        if (lastLigID && !isMarkLigature) {
                            for (var _i4 = idx; _i4 < this.glyphs.length; _i4++) {
                                if (this.glyphs[_i4].ligatureID === lastLigID) {
                                    var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i4].ligatureComponent || 1, lastNumComps);
                                    this.glyphs[_i4].ligatureComponent = ligatureComponent;
                                } else {
                                    break;
                                }
                            }
                        }
                        for (var _i5 = matched.length - 1; _i5 >= 0; _i5--) {
                            this.glyphs.splice(matched[_i5], 1);
                        }
                        this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                        return true;
                    }
                    return false;
                }
            case 5:
                return this.applyContext(table);
            case 6:
                return this.applyChainingContext(table);
            case 7:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error('GSUB lookupType ' + lookupType + ' is not supported');
            }
        };
        return GSUBProcessor;
    }(OTProcessor);
var GPOSProcessor = function (_OTProcessor) {
        _inherits(GPOSProcessor, _OTProcessor);
        function GPOSProcessor() {
            _classCallCheck(this, GPOSProcessor);
            return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
        }
        GPOSProcessor.prototype.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
            var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
            if (value.xAdvance != null) {
                position.xAdvance += value.xAdvance;
            }
            if (value.yAdvance != null) {
                position.yAdvance += value.yAdvance;
            }
            if (value.xPlacement != null) {
                position.xOffset += value.xPlacement;
            }
            if (value.yPlacement != null) {
                position.yOffset += value.yPlacement;
            }
            var variationProcessor = this.font._variationProcessor;
            var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
            if (variationProcessor && variationStore) {
                if (value.xPlaDevice) {
                    position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
                }
                if (value.yPlaDevice) {
                    position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
                }
                if (value.xAdvDevice) {
                    position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
                }
                if (value.yAdvDevice) {
                    position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
                }
            }
        };
        GPOSProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
            switch (lookupType) {
            case 1: {
                    var index = this.coverageIndex(table.coverage);
                    if (index === -1) {
                        return false;
                    }
                    switch (table.version) {
                    case 1:
                        this.applyPositionValue(0, table.value);
                        break;
                    case 2:
                        this.applyPositionValue(0, table.values.get(index));
                        break;
                    }
                    return true;
                }
            case 2: {
                    var nextGlyph = this.glyphIterator.peek();
                    if (!nextGlyph) {
                        return false;
                    }
                    var _index = this.coverageIndex(table.coverage);
                    if (_index === -1) {
                        return false;
                    }
                    switch (table.version) {
                    case 1:
                        var set = table.pairSets.get(_index);
                        for (var _iterator = set, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length)
                                    break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done)
                                    break;
                                _ref = _i.value;
                            }
                            var _pair = _ref;
                            if (_pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, _pair.value1);
                                this.applyPositionValue(1, _pair.value2);
                                return true;
                            }
                        }
                        return false;
                    case 2:
                        var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                        var class2 = this.getClassID(nextGlyph.id, table.classDef2);
                        if (class1 === -1 || class2 === -1) {
                            return false;
                        }
                        var pair = table.classRecords.get(class1).get(class2);
                        this.applyPositionValue(0, pair.value1);
                        this.applyPositionValue(1, pair.value2);
                        return true;
                    }
                }
            case 3: {
                    var nextIndex = this.glyphIterator.peekIndex();
                    var _nextGlyph = this.glyphs[nextIndex];
                    if (!_nextGlyph) {
                        return false;
                    }
                    var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                    if (!curRecord || !curRecord.exitAnchor) {
                        return false;
                    }
                    var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
                    if (!nextRecord || !nextRecord.entryAnchor) {
                        return false;
                    }
                    var entry = this.getAnchor(nextRecord.entryAnchor);
                    var exit = this.getAnchor(curRecord.exitAnchor);
                    var cur = this.positions[this.glyphIterator.index];
                    var next = this.positions[nextIndex];
                    switch (this.direction) {
                    case 'ltr':
                        cur.xAdvance = exit.x + cur.xOffset;
                        var d = entry.x + next.xOffset;
                        next.xAdvance -= d;
                        next.xOffset -= d;
                        break;
                    case 'rtl':
                        d = exit.x + cur.xOffset;
                        cur.xAdvance -= d;
                        cur.xOffset -= d;
                        next.xAdvance = entry.x + next.xOffset;
                        break;
                    }
                    if (this.glyphIterator.flags.rightToLeft) {
                        this.glyphIterator.cur.cursiveAttachment = nextIndex;
                        cur.yOffset = entry.y - exit.y;
                    } else {
                        _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                        cur.yOffset = exit.y - entry.y;
                    }
                    return true;
                }
            case 4: {
                    var markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) {
                        return false;
                    }
                    var baseGlyphIndex = this.glyphIterator.index;
                    while (--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0)) {
                    }
                    if (baseGlyphIndex < 0) {
                        return false;
                    }
                    var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                    if (baseIndex === -1) {
                        return false;
                    }
                    var markRecord = table.markArray[markIndex];
                    var baseAnchor = table.baseArray[baseIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 5: {
                    var _markIndex = this.coverageIndex(table.markCoverage);
                    if (_markIndex === -1) {
                        return false;
                    }
                    var _baseGlyphIndex = this.glyphIterator.index;
                    while (--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark) {
                    }
                    if (_baseGlyphIndex < 0) {
                        return false;
                    }
                    var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
                    if (ligIndex === -1) {
                        return false;
                    }
                    var ligAttach = table.ligatureArray[ligIndex];
                    var markGlyph = this.glyphIterator.cur;
                    var ligGlyph = this.glyphs[_baseGlyphIndex];
                    var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                    var _markRecord = table.markArray[_markIndex];
                    var _baseAnchor = ligAttach[compIndex][_markRecord.class];
                    this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                    return true;
                }
            case 6: {
                    var mark1Index = this.coverageIndex(table.mark1Coverage);
                    if (mark1Index === -1) {
                        return false;
                    }
                    var prevIndex = this.glyphIterator.peekIndex(-1);
                    var prev = this.glyphs[prevIndex];
                    if (!prev || !prev.isMark) {
                        return false;
                    }
                    var _cur = this.glyphIterator.cur;
                    var good = false;
                    if (_cur.ligatureID === prev.ligatureID) {
                        if (!_cur.ligatureID) {
                            good = true;
                        } else if (_cur.ligatureComponent === prev.ligatureComponent) {
                            good = true;
                        }
                    } else {
                        if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) {
                            good = true;
                        }
                    }
                    if (!good) {
                        return false;
                    }
                    var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                    if (mark2Index === -1) {
                        return false;
                    }
                    var _markRecord2 = table.mark1Array[mark1Index];
                    var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
                    this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                    return true;
                }
            case 7:
                return this.applyContext(table);
            case 8:
                return this.applyChainingContext(table);
            case 9:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error('Unsupported GPOS table: ' + lookupType);
            }
        };
        GPOSProcessor.prototype.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
            var baseCoords = this.getAnchor(baseAnchor);
            var markCoords = this.getAnchor(markRecord.markAnchor);
            var basePos = this.positions[baseGlyphIndex];
            var markPos = this.positions[this.glyphIterator.index];
            markPos.xOffset = baseCoords.x - markCoords.x;
            markPos.yOffset = baseCoords.y - markCoords.y;
            this.glyphIterator.cur.markAttachment = baseGlyphIndex;
        };
        GPOSProcessor.prototype.getAnchor = function getAnchor(anchor) {
            var x = anchor.xCoordinate;
            var y = anchor.yCoordinate;
            var variationProcessor = this.font._variationProcessor;
            var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
            if (variationProcessor && variationStore) {
                if (anchor.xDeviceTable) {
                    x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
                }
                if (anchor.yDeviceTable) {
                    y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
                }
            }
            return {
                x: x,
                y: y
            };
        };
        GPOSProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
            _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
            for (var i = 0; i < this.glyphs.length; i++) {
                this.fixCursiveAttachment(i);
            }
            this.fixMarkAttachment();
        };
        GPOSProcessor.prototype.fixCursiveAttachment = function fixCursiveAttachment(i) {
            var glyph = this.glyphs[i];
            if (glyph.cursiveAttachment != null) {
                var j = glyph.cursiveAttachment;
                glyph.cursiveAttachment = null;
                this.fixCursiveAttachment(j);
                this.positions[i].yOffset += this.positions[j].yOffset;
            }
        };
        GPOSProcessor.prototype.fixMarkAttachment = function fixMarkAttachment() {
            for (var i = 0; i < this.glyphs.length; i++) {
                var glyph = this.glyphs[i];
                if (glyph.markAttachment != null) {
                    var j = glyph.markAttachment;
                    this.positions[i].xOffset += this.positions[j].xOffset;
                    this.positions[i].yOffset += this.positions[j].yOffset;
                    if (this.direction === 'ltr') {
                        for (var k = j; k < i; k++) {
                            this.positions[i].xOffset -= this.positions[k].xAdvance;
                            this.positions[i].yOffset -= this.positions[k].yAdvance;
                        }
                    } else {
                        for (var _k = j + 1; _k < i + 1; _k++) {
                            this.positions[i].xOffset += this.positions[_k].xAdvance;
                            this.positions[i].yOffset += this.positions[_k].yAdvance;
                        }
                    }
                }
            }
        };
        return GPOSProcessor;
    }(OTProcessor);
var OTLayoutEngine = function () {
        function OTLayoutEngine(font) {
            _classCallCheck(this, OTLayoutEngine);
            this.font = font;
            this.glyphInfos = null;
            this.plan = null;
            this.GSUBProcessor = null;
            this.GPOSProcessor = null;
            this.fallbackPosition = true;
            if (font.GSUB) {
                this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
            }
            if (font.GPOS) {
                this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
            }
        }
        OTLayoutEngine.prototype.setup = function setup(glyphRun) {
            var _this = this;
            this.glyphInfos = glyphRun.glyphs.map(function (glyph) {
                return new GlyphInfo(_this.font, glyph.id, [].concat(glyph.codePoints));
            });
            var script = null;
            if (this.GPOSProcessor) {
                script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
            }
            if (this.GSUBProcessor) {
                script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
            }
            this.shaper = choose(script);
            this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
            this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
            for (var key in this.plan.allFeatures) {
                glyphRun.features[key] = true;
            }
        };
        OTLayoutEngine.prototype.substitute = function substitute(glyphRun) {
            var _this2 = this;
            if (this.GSUBProcessor) {
                this.plan.process(this.GSUBProcessor, this.glyphInfos);
                glyphRun.glyphs = this.glyphInfos.map(function (glyphInfo) {
                    return _this2.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
                });
            }
        };
        OTLayoutEngine.prototype.position = function position(glyphRun) {
            if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') {
                this.zeroMarkAdvances(glyphRun.positions);
            }
            if (this.GPOSProcessor) {
                this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
            }
            if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') {
                this.zeroMarkAdvances(glyphRun.positions);
            }
            if (glyphRun.direction === 'rtl') {
                glyphRun.glyphs.reverse();
                glyphRun.positions.reverse();
            }
            return this.GPOSProcessor && this.GPOSProcessor.features;
        };
        OTLayoutEngine.prototype.zeroMarkAdvances = function zeroMarkAdvances(positions) {
            for (var i = 0; i < this.glyphInfos.length; i++) {
                if (this.glyphInfos[i].isMark) {
                    positions[i].xAdvance = 0;
                    positions[i].yAdvance = 0;
                }
            }
        };
        OTLayoutEngine.prototype.cleanup = function cleanup() {
            this.glyphInfos = null;
            this.plan = null;
            this.shaper = null;
        };
        OTLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
            var features = [];
            if (this.GSUBProcessor) {
                this.GSUBProcessor.selectScript(script, language);
                features.push.apply(features, _Object$keys(this.GSUBProcessor.features));
            }
            if (this.GPOSProcessor) {
                this.GPOSProcessor.selectScript(script, language);
                features.push.apply(features, _Object$keys(this.GPOSProcessor.features));
            }
            return features;
        };
        return OTLayoutEngine;
    }();
var LayoutEngine = function () {
        function LayoutEngine(font) {
            _classCallCheck(this, LayoutEngine);
            this.font = font;
            this.unicodeLayoutEngine = null;
            this.kernProcessor = null;
            if (this.font.morx) {
                this.engine = new AATLayoutEngine(this.font);
            } else if (this.font.GSUB || this.font.GPOS) {
                this.engine = new OTLayoutEngine(this.font);
            }
        }
        LayoutEngine.prototype.layout = function layout(string, features, script, language, direction) {
            if (typeof features === 'string') {
                direction = language;
                language = script;
                script = features;
                features = [];
            }
            if (typeof string === 'string') {
                if (script == null) {
                    script = forString(string);
                }
                var glyphs = this.font.glyphsForString(string);
            } else {
                if (script == null) {
                    var codePoints = [];
                    for (var _iterator = string, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length)
                                break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done)
                                break;
                            _ref = _i.value;
                        }
                        var glyph = _ref;
                        codePoints.push.apply(codePoints, glyph.codePoints);
                    }
                    script = forCodePoints(codePoints);
                }
                var glyphs = string;
            }
            var glyphRun = new GlyphRun(glyphs, features, script, language, direction);
            if (glyphs.length === 0) {
                glyphRun.positions = [];
                return glyphRun;
            }
            if (this.engine && this.engine.setup) {
                this.engine.setup(glyphRun);
            }
            this.substitute(glyphRun);
            this.position(glyphRun);
            this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
            if (this.engine && this.engine.cleanup) {
                this.engine.cleanup();
            }
            return glyphRun;
        };
        LayoutEngine.prototype.substitute = function substitute(glyphRun) {
            if (this.engine && this.engine.substitute) {
                this.engine.substitute(glyphRun);
            }
        };
        LayoutEngine.prototype.position = function position(glyphRun) {
            glyphRun.positions = glyphRun.glyphs.map(function (glyph) {
                return new GlyphPosition(glyph.advanceWidth);
            });
            var positioned = null;
            if (this.engine && this.engine.position) {
                positioned = this.engine.position(glyphRun);
            }
            if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
                if (!this.unicodeLayoutEngine) {
                    this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
                }
                this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
            }
            if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
                if (!this.kernProcessor) {
                    this.kernProcessor = new KernProcessor(this.font);
                }
                this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
                glyphRun.features.kern = true;
            }
        };
        LayoutEngine.prototype.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
            var space = this.font.glyphForCodePoint(32);
            for (var i = 0; i < glyphs.length; i++) {
                if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
                    glyphs[i] = space;
                    positions[i].xAdvance = 0;
                    positions[i].yAdvance = 0;
                }
            }
        };
        LayoutEngine.prototype.isDefaultIgnorable = function isDefaultIgnorable(ch) {
            var plane = ch >> 16;
            if (plane === 0) {
                switch (ch >> 8) {
                case 0:
                    return ch === 173;
                case 3:
                    return ch === 847;
                case 6:
                    return ch === 1564;
                case 23:
                    return 6068 <= ch && ch <= 6069;
                case 24:
                    return 6155 <= ch && ch <= 6158;
                case 32:
                    return 8203 <= ch && ch <= 8207 || 8234 <= ch && ch <= 8238 || 8288 <= ch && ch <= 8303;
                case 254:
                    return 65024 <= ch && ch <= 65039 || ch === 65279;
                case 255:
                    return 65520 <= ch && ch <= 65528;
                default:
                    return false;
                }
            } else {
                switch (plane) {
                case 1:
                    return 113824 <= ch && ch <= 113827 || 119155 <= ch && ch <= 119162;
                case 14:
                    return 917504 <= ch && ch <= 921599;
                default:
                    return false;
                }
            }
        };
        LayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
            var features = [];
            if (this.engine) {
                features.push.apply(features, this.engine.getAvailableFeatures(script, language));
            }
            if (this.font.kern && features.indexOf('kern') === -1) {
                features.push('kern');
            }
            return features;
        };
        LayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
            var result = new _Set();
            var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
            for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var codePoint = _ref2;
                result.add(_String$fromCodePoint(codePoint));
            }
            if (this.engine && this.engine.stringsForGlyph) {
                for (var _iterator3 = this.engine.stringsForGlyph(gid), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                    var _ref3;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length)
                            break;
                        _ref3 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done)
                            break;
                        _ref3 = _i3.value;
                    }
                    var string = _ref3;
                    result.add(string);
                }
            }
            return _Array$from(result);
        };
        return LayoutEngine;
    }();
var SVG_COMMANDS = {
        moveTo: 'M',
        lineTo: 'L',
        quadraticCurveTo: 'Q',
        bezierCurveTo: 'C',
        closePath: 'Z'
    };
var Path = function () {
        function Path() {
            _classCallCheck(this, Path);
            this.commands = [];
            this._bbox = null;
            this._cbox = null;
            this.fill = 'black';
            this.stroke = null;
            this.strokeWidth = 1;
        }
        Path.prototype.toFunction = function toFunction() {
            var cmds = this.commands.map(function (c) {
                    return '  ctx.' + c.command + '(' + c.args.join(', ') + ');';
                });
            return new Function('ctx', cmds.join('\n'));
        };
        Path.prototype.draw = function draw(ctx) {
            ctx.scale(1, -1);
            ctx.beginPath();
            var fn = this.toFunction();
            fn(ctx);
            if (this.fill) {
                ctx.fillStyle = this.fill;
                ctx.fill();
            }
            if (this.stroke) {
                ctx.strokeStyle = this.stroke;
                ctx.lineWidth = this.strokeWidth;
                ctx.stroke();
            }
        };
        Path.prototype.toSVG = function toSVG() {
            var cmds = this.commands.map(function (c) {
                    var args = c.args.map(function (arg) {
                            return Math.round(arg * 100) / 100;
                        });
                    return '' + SVG_COMMANDS[c.command] + args.join(' ');
                });
            return cmds.join('');
        };
        Path.prototype.mapPoints = function mapPoints(fn) {
            var path = new Path();
            for (var _iterator = this.commands, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var c = _ref;
                var args = [];
                for (var _i2 = 0; _i2 < c.args.length; _i2 += 2) {
                    var _fn = fn(c.args[_i2], c.args[_i2 + 1]), x = _fn[0], y = _fn[1];
                    args.push(x, y);
                }
                path[c.command].apply(path, args);
            }
            return path;
        };
        Path.prototype.transform = function transform(m0, m1, m2, m3, m4, m5) {
            return this.mapPoints(function (x, y) {
                x = m0 * x + m2 * y + m4;
                y = m1 * x + m3 * y + m5;
                return [
                    x,
                    y
                ];
            });
        };
        Path.prototype.translate = function translate(x, y) {
            return this.transform(1, 0, 0, 1, x, y);
        };
        Path.prototype.rotate = function rotate(angle) {
            var cos = Math.cos(angle);
            var sin = Math.sin(angle);
            return this.transform(cos, sin, -sin, cos, 0, 0);
        };
        Path.prototype.scale = function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
            return this.transform(scaleX, 0, 0, scaleY, 0, 0);
        };
        _createClass(Path, [
            {
                key: 'cbox',
                get: function get() {
                    if (!this._cbox) {
                        var cbox = new BBox();
                        for (var _iterator2 = this.commands, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                            var _ref2;
                            if (_isArray2) {
                                if (_i3 >= _iterator2.length)
                                    break;
                                _ref2 = _iterator2[_i3++];
                            } else {
                                _i3 = _iterator2.next();
                                if (_i3.done)
                                    break;
                                _ref2 = _i3.value;
                            }
                            var command = _ref2;
                            for (var _i4 = 0; _i4 < command.args.length; _i4 += 2) {
                                cbox.addPoint(command.args[_i4], command.args[_i4 + 1]);
                            }
                        }
                        this._cbox = _Object$freeze(cbox);
                    }
                    return this._cbox;
                }
            },
            {
                key: 'bbox',
                get: function get() {
                    if (this._bbox) {
                        return this._bbox;
                    }
                    var bbox = new BBox();
                    var cx = 0, cy = 0;
                    var f = function f(t) {
                        return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
                    };
                    for (var _iterator3 = this.commands, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                        var _ref3;
                        if (_isArray3) {
                            if (_i5 >= _iterator3.length)
                                break;
                            _ref3 = _iterator3[_i5++];
                        } else {
                            _i5 = _iterator3.next();
                            if (_i5.done)
                                break;
                            _ref3 = _i5.value;
                        }
                        var c = _ref3;
                        switch (c.command) {
                        case 'moveTo':
                        case 'lineTo':
                            var _c$args = c.args, x = _c$args[0], y = _c$args[1];
                            bbox.addPoint(x, y);
                            cx = x;
                            cy = y;
                            break;
                        case 'quadraticCurveTo':
                        case 'bezierCurveTo':
                            if (c.command === 'quadraticCurveTo') {
                                var _c$args2 = c.args, qp1x = _c$args2[0], qp1y = _c$args2[1], p3x = _c$args2[2], p3y = _c$args2[3];
                                var cp1x = cx + 2 / 3 * (qp1x - cx);
                                var cp1y = cy + 2 / 3 * (qp1y - cy);
                                var cp2x = p3x + 2 / 3 * (qp1x - p3x);
                                var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                            } else {
                                var _c$args3 = c.args, cp1x = _c$args3[0], cp1y = _c$args3[1], cp2x = _c$args3[2], cp2y = _c$args3[3], p3x = _c$args3[4], p3y = _c$args3[5];
                            }
                            bbox.addPoint(p3x, p3y);
                            var p0 = [
                                    cx,
                                    cy
                                ];
                            var p1 = [
                                    cp1x,
                                    cp1y
                                ];
                            var p2 = [
                                    cp2x,
                                    cp2y
                                ];
                            var p3 = [
                                    p3x,
                                    p3y
                                ];
                            for (var i = 0; i <= 1; i++) {
                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                c = 3 * p1[i] - 3 * p0[i];
                                if (a === 0) {
                                    if (b === 0) {
                                        continue;
                                    }
                                    var t = -c / b;
                                    if (0 < t && t < 1) {
                                        if (i === 0) {
                                            bbox.addPoint(f(t), bbox.maxY);
                                        } else if (i === 1) {
                                            bbox.addPoint(bbox.maxX, f(t));
                                        }
                                    }
                                    continue;
                                }
                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                if (b2ac < 0) {
                                    continue;
                                }
                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t1 && t1 < 1) {
                                    if (i === 0) {
                                        bbox.addPoint(f(t1), bbox.maxY);
                                    } else if (i === 1) {
                                        bbox.addPoint(bbox.maxX, f(t1));
                                    }
                                }
                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t2 && t2 < 1) {
                                    if (i === 0) {
                                        bbox.addPoint(f(t2), bbox.maxY);
                                    } else if (i === 1) {
                                        bbox.addPoint(bbox.maxX, f(t2));
                                    }
                                }
                            }
                            cx = p3x;
                            cy = p3y;
                            break;
                        }
                    }
                    return this._bbox = _Object$freeze(bbox);
                }
            }
        ]);
        return Path;
    }();
var _arr = [
        'moveTo',
        'lineTo',
        'quadraticCurveTo',
        'bezierCurveTo',
        'closePath'
    ];
var _loop = function _loop() {
    var command = _arr[_i6];
    Path.prototype[command] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        this._bbox = this._cbox = null;
        this.commands.push({
            command: command,
            args: args
        });
        return this;
    };
};
for (var _i6 = 0; _i6 < _arr.length; _i6++) {
    _loop();
}
var StandardNames = [
        '.notdef',
        '.null',
        'nonmarkingreturn',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quotesingle',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'grave',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        'Adieresis',
        'Aring',
        'Ccedilla',
        'Eacute',
        'Ntilde',
        'Odieresis',
        'Udieresis',
        'aacute',
        'agrave',
        'acircumflex',
        'adieresis',
        'atilde',
        'aring',
        'ccedilla',
        'eacute',
        'egrave',
        'ecircumflex',
        'edieresis',
        'iacute',
        'igrave',
        'icircumflex',
        'idieresis',
        'ntilde',
        'oacute',
        'ograve',
        'ocircumflex',
        'odieresis',
        'otilde',
        'uacute',
        'ugrave',
        'ucircumflex',
        'udieresis',
        'dagger',
        'degree',
        'cent',
        'sterling',
        'section',
        'bullet',
        'paragraph',
        'germandbls',
        'registered',
        'copyright',
        'trademark',
        'acute',
        'dieresis',
        'notequal',
        'AE',
        'Oslash',
        'infinity',
        'plusminus',
        'lessequal',
        'greaterequal',
        'yen',
        'mu',
        'partialdiff',
        'summation',
        'product',
        'pi',
        'integral',
        'ordfeminine',
        'ordmasculine',
        'Omega',
        'ae',
        'oslash',
        'questiondown',
        'exclamdown',
        'logicalnot',
        'radical',
        'florin',
        'approxequal',
        'Delta',
        'guillemotleft',
        'guillemotright',
        'ellipsis',
        'nonbreakingspace',
        'Agrave',
        'Atilde',
        'Otilde',
        'OE',
        'oe',
        'endash',
        'emdash',
        'quotedblleft',
        'quotedblright',
        'quoteleft',
        'quoteright',
        'divide',
        'lozenge',
        'ydieresis',
        'Ydieresis',
        'fraction',
        'currency',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        'daggerdbl',
        'periodcentered',
        'quotesinglbase',
        'quotedblbase',
        'perthousand',
        'Acircumflex',
        'Ecircumflex',
        'Aacute',
        'Edieresis',
        'Egrave',
        'Iacute',
        'Icircumflex',
        'Idieresis',
        'Igrave',
        'Oacute',
        'Ocircumflex',
        'apple',
        'Ograve',
        'Uacute',
        'Ucircumflex',
        'Ugrave',
        'dotlessi',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'ring',
        'cedilla',
        'hungarumlaut',
        'ogonek',
        'caron',
        'Lslash',
        'lslash',
        'Scaron',
        'scaron',
        'Zcaron',
        'zcaron',
        'brokenbar',
        'Eth',
        'eth',
        'Yacute',
        'yacute',
        'Thorn',
        'thorn',
        'minus',
        'multiply',
        'onesuperior',
        'twosuperior',
        'threesuperior',
        'onehalf',
        'onequarter',
        'threequarters',
        'franc',
        'Gbreve',
        'gbreve',
        'Idotaccent',
        'Scedilla',
        'scedilla',
        'Cacute',
        'cacute',
        'Ccaron',
        'ccaron',
        'dcroat'
    ];
var _class$8;
function _applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }
    return desc;
}
var Glyph = (_class$8 = function () {
        function Glyph(id, codePoints, font) {
            _classCallCheck(this, Glyph);
            this.id = id;
            this.codePoints = codePoints;
            this._font = font;
            this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
            this.isLigature = this.codePoints.length > 1;
        }
        Glyph.prototype._getPath = function _getPath() {
            return new Path();
        };
        Glyph.prototype._getCBox = function _getCBox() {
            return this.path.cbox;
        };
        Glyph.prototype._getBBox = function _getBBox() {
            return this.path.bbox;
        };
        Glyph.prototype._getTableMetrics = function _getTableMetrics(table) {
            if (this.id < table.metrics.length) {
                return table.metrics.get(this.id);
            }
            var metric = table.metrics.get(table.metrics.length - 1);
            var res = {
                    advance: metric ? metric.advance : 0,
                    bearing: table.bearings.get(this.id - table.metrics.length) || 0
                };
            return res;
        };
        Glyph.prototype._getMetrics = function _getMetrics(cbox) {
            if (this._metrics) {
                return this._metrics;
            }
            var _getTableMetrics2 = this._getTableMetrics(this._font.hmtx), advanceWidth = _getTableMetrics2.advance, leftBearing = _getTableMetrics2.bearing;
            if (this._font.vmtx) {
                var _getTableMetrics3 = this._getTableMetrics(this._font.vmtx), advanceHeight = _getTableMetrics3.advance, topBearing = _getTableMetrics3.bearing;
            } else {
                var os2 = void 0;
                if (typeof cbox === 'undefined' || cbox === null) {
                    cbox = this.cbox;
                }
                if ((os2 = this._font['OS/2']) && os2.version > 0) {
                    var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                    var topBearing = os2.typoAscender - cbox.maxY;
                } else {
                    var hhea = this._font.hhea;
                    var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                    var topBearing = hhea.ascent - cbox.maxY;
                }
            }
            if (this._font._variationProcessor && this._font.HVAR) {
                advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
            }
            return this._metrics = {
                advanceWidth: advanceWidth,
                advanceHeight: advanceHeight,
                leftBearing: leftBearing,
                topBearing: topBearing
            };
        };
        Glyph.prototype.getScaledPath = function getScaledPath(size) {
            var scale = 1 / this._font.unitsPerEm * size;
            return this.path.scale(scale);
        };
        Glyph.prototype._getName = function _getName() {
            var post = this._font.post;
            if (!post) {
                return null;
            }
            switch (post.version) {
            case 1:
                return StandardNames[this.id];
            case 2:
                var id = post.glyphNameIndex[this.id];
                if (id < StandardNames.length) {
                    return StandardNames[id];
                }
                return post.names[id - StandardNames.length];
            case 2.5:
                return StandardNames[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
            }
        };
        Glyph.prototype.render = function render(ctx, size) {
            ctx.save();
            var scale = 1 / this._font.head.unitsPerEm * size;
            ctx.scale(scale, scale);
            var fn = this.path.toFunction();
            fn(ctx);
            ctx.fill();
            ctx.restore();
        };
        _createClass(Glyph, [
            {
                key: 'cbox',
                get: function get() {
                    return this._getCBox();
                }
            },
            {
                key: 'bbox',
                get: function get() {
                    return this._getBBox();
                }
            },
            {
                key: 'path',
                get: function get() {
                    return this._getPath();
                }
            },
            {
                key: 'advanceWidth',
                get: function get() {
                    return this._getMetrics().advanceWidth;
                }
            },
            {
                key: 'advanceHeight',
                get: function get() {
                    return this._getMetrics().advanceHeight;
                }
            },
            {
                key: 'ligatureCaretPositions',
                get: function get() {
                }
            },
            {
                key: 'name',
                get: function get() {
                    return this._getName();
                }
            }
        ]);
        return Glyph;
    }(), (_applyDecoratedDescriptor$4(_class$8.prototype, 'cbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'cbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'bbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'path', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'path'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceWidth', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceWidth'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceHeight', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceHeight'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'name', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'name'), _class$8.prototype)), _class$8);
var GlyfHeader = new r.Struct({
        numberOfContours: r.int16,
        xMin: r.int16,
        yMin: r.int16,
        xMax: r.int16,
        yMax: r.int16
    });
var ON_CURVE = 1 << 0;
var X_SHORT_VECTOR = 1 << 1;
var Y_SHORT_VECTOR = 1 << 2;
var REPEAT = 1 << 3;
var SAME_X = 1 << 4;
var SAME_Y = 1 << 5;
var ARG_1_AND_2_ARE_WORDS = 1 << 0;
var WE_HAVE_A_SCALE = 1 << 3;
var MORE_COMPONENTS = 1 << 5;
var WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
var WE_HAVE_A_TWO_BY_TWO = 1 << 7;
var WE_HAVE_INSTRUCTIONS = 1 << 8;
var Point = function () {
        function Point(onCurve, endContour) {
            var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            _classCallCheck(this, Point);
            this.onCurve = onCurve;
            this.endContour = endContour;
            this.x = x;
            this.y = y;
        }
        Point.prototype.copy = function copy() {
            return new Point(this.onCurve, this.endContour, this.x, this.y);
        };
        return Point;
    }();
var Component = function Component(glyphID, dx, dy) {
    _classCallCheck(this, Component);
    this.glyphID = glyphID;
    this.dx = dx;
    this.dy = dy;
    this.pos = 0;
    this.scaleX = this.scaleY = 1;
    this.scale01 = this.scale10 = 0;
};
var TTFGlyph = function (_Glyph) {
        _inherits(TTFGlyph, _Glyph);
        function TTFGlyph() {
            _classCallCheck(this, TTFGlyph);
            return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
        }
        TTFGlyph.prototype._getCBox = function _getCBox(internal) {
            if (this._font._variationProcessor && !internal) {
                return this.path.cbox;
            }
            var stream = this._font._getTableStream('glyf');
            stream.pos += this._font.loca.offsets[this.id];
            var glyph = GlyfHeader.decode(stream);
            var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
            return _Object$freeze(cbox);
        };
        TTFGlyph.prototype._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
            if (short) {
                var val = stream.readUInt8();
                if (!same) {
                    val = -val;
                }
                val += prev;
            } else {
                if (same) {
                    var val = prev;
                } else {
                    var val = prev + stream.readInt16BE();
                }
            }
            return val;
        };
        TTFGlyph.prototype._decode = function _decode() {
            var glyfPos = this._font.loca.offsets[this.id];
            var nextPos = this._font.loca.offsets[this.id + 1];
            if (glyfPos === nextPos) {
                return null;
            }
            var stream = this._font._getTableStream('glyf');
            stream.pos += glyfPos;
            var startPos = stream.pos;
            var glyph = GlyfHeader.decode(stream);
            if (glyph.numberOfContours > 0) {
                this._decodeSimple(glyph, stream);
            } else if (glyph.numberOfContours < 0) {
                this._decodeComposite(glyph, stream, startPos);
            }
            return glyph;
        };
        TTFGlyph.prototype._decodeSimple = function _decodeSimple(glyph, stream) {
            glyph.points = [];
            var endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
            glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);
            var flags = [];
            var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
            while (flags.length < numCoords) {
                var flag = stream.readUInt8();
                flags.push(flag);
                if (flag & REPEAT) {
                    var count = stream.readUInt8();
                    for (var j = 0; j < count; j++) {
                        flags.push(flag);
                    }
                }
            }
            for (var i = 0; i < flags.length; i++) {
                var flag = flags[i];
                var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
                glyph.points.push(point);
            }
            var px = 0;
            for (var i = 0; i < flags.length; i++) {
                var flag = flags[i];
                glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
            }
            var py = 0;
            for (var i = 0; i < flags.length; i++) {
                var flag = flags[i];
                glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
            }
            if (this._font._variationProcessor) {
                var points = glyph.points.slice();
                points.push.apply(points, this._getPhantomPoints(glyph));
                this._font._variationProcessor.transformPoints(this.id, points);
                glyph.phantomPoints = points.slice(-4);
            }
            return;
        };
        TTFGlyph.prototype._decodeComposite = function _decodeComposite(glyph, stream) {
            var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            glyph.components = [];
            var haveInstructions = false;
            var flags = MORE_COMPONENTS;
            while (flags & MORE_COMPONENTS) {
                flags = stream.readUInt16BE();
                var gPos = stream.pos - offset;
                var glyphID = stream.readUInt16BE();
                if (!haveInstructions) {
                    haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
                }
                if (flags & ARG_1_AND_2_ARE_WORDS) {
                    var dx = stream.readInt16BE();
                    var dy = stream.readInt16BE();
                } else {
                    var dx = stream.readInt8();
                    var dy = stream.readInt8();
                }
                var component = new Component(glyphID, dx, dy);
                component.pos = gPos;
                if (flags & WE_HAVE_A_SCALE) {
                    component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                    component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                    component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                    component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                    component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                    component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                    component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                }
                glyph.components.push(component);
            }
            if (this._font._variationProcessor) {
                var points = [];
                for (var j = 0; j < glyph.components.length; j++) {
                    var component = glyph.components[j];
                    points.push(new Point(true, true, component.dx, component.dy));
                }
                points.push.apply(points, this._getPhantomPoints(glyph));
                this._font._variationProcessor.transformPoints(this.id, points);
                glyph.phantomPoints = points.splice(-4, 4);
                for (var i = 0; i < points.length; i++) {
                    var point = points[i];
                    glyph.components[i].dx = point.x;
                    glyph.components[i].dy = point.y;
                }
            }
            return haveInstructions;
        };
        TTFGlyph.prototype._getPhantomPoints = function _getPhantomPoints(glyph) {
            var cbox = this._getCBox(true);
            if (this._metrics == null) {
                this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
            }
            var _metrics = this._metrics, advanceWidth = _metrics.advanceWidth, advanceHeight = _metrics.advanceHeight, leftBearing = _metrics.leftBearing, topBearing = _metrics.topBearing;
            return [
                new Point(false, true, glyph.xMin - leftBearing, 0),
                new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
                new Point(false, true, 0, glyph.yMax + topBearing),
                new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)
            ];
        };
        TTFGlyph.prototype._getContours = function _getContours() {
            var glyph = this._decode();
            if (!glyph) {
                return [];
            }
            var points = [];
            if (glyph.numberOfContours < 0) {
                for (var _iterator = glyph.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length)
                            break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done)
                            break;
                        _ref = _i.value;
                    }
                    var component = _ref;
                    var _contours = this._font.getGlyph(component.glyphID)._getContours();
                    for (var i = 0; i < _contours.length; i++) {
                        var contour = _contours[i];
                        for (var j = 0; j < contour.length; j++) {
                            var _point = contour[j];
                            var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                            var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                            points.push(new Point(_point.onCurve, _point.endContour, x, y));
                        }
                    }
                }
            } else {
                points = glyph.points || [];
            }
            if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
                this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
                this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
                this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
                this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
            }
            var contours = [];
            var cur = [];
            for (var k = 0; k < points.length; k++) {
                var point = points[k];
                cur.push(point);
                if (point.endContour) {
                    contours.push(cur);
                    cur = [];
                }
            }
            return contours;
        };
        TTFGlyph.prototype._getMetrics = function _getMetrics() {
            if (this._metrics) {
                return this._metrics;
            }
            var cbox = this._getCBox(true);
            _Glyph.prototype._getMetrics.call(this, cbox);
            if (this._font._variationProcessor && !this._font.HVAR) {
                this.path;
            }
            return this._metrics;
        };
        TTFGlyph.prototype._getPath = function _getPath() {
            var contours = this._getContours();
            var path = new Path();
            for (var i = 0; i < contours.length; i++) {
                var contour = contours[i];
                var firstPt = contour[0];
                var lastPt = contour[contour.length - 1];
                var start = 0;
                if (firstPt.onCurve) {
                    var curvePt = null;
                    start = 1;
                } else {
                    if (lastPt.onCurve) {
                        firstPt = lastPt;
                    } else {
                        firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                    }
                    var curvePt = firstPt;
                }
                path.moveTo(firstPt.x, firstPt.y);
                for (var j = start; j < contour.length; j++) {
                    var pt = contour[j];
                    var prevPt = j === 0 ? firstPt : contour[j - 1];
                    if (prevPt.onCurve && pt.onCurve) {
                        path.lineTo(pt.x, pt.y);
                    } else if (prevPt.onCurve && !pt.onCurve) {
                        var curvePt = pt;
                    } else if (!prevPt.onCurve && !pt.onCurve) {
                        var midX = (prevPt.x + pt.x) / 2;
                        var midY = (prevPt.y + pt.y) / 2;
                        path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                        var curvePt = pt;
                    } else if (!prevPt.onCurve && pt.onCurve) {
                        path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                        var curvePt = null;
                    } else {
                        throw new Error('Unknown TTF path state');
                    }
                }
                if (curvePt) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
                }
                path.closePath();
            }
            return path;
        };
        return TTFGlyph;
    }(Glyph);
var CFFGlyph = function (_Glyph) {
        _inherits(CFFGlyph, _Glyph);
        function CFFGlyph() {
            _classCallCheck(this, CFFGlyph);
            return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
        }
        CFFGlyph.prototype._getName = function _getName() {
            if (this._font.CFF2) {
                return _Glyph.prototype._getName.call(this);
            }
            return this._font['CFF '].getGlyphName(this.id);
        };
        CFFGlyph.prototype.bias = function bias(s) {
            if (s.length < 1240) {
                return 107;
            } else if (s.length < 33900) {
                return 1131;
            } else {
                return 32768;
            }
        };
        CFFGlyph.prototype._getPath = function _getPath() {
            var cff = this._font.CFF2 || this._font['CFF '];
            var stream = cff.stream;
            var str = cff.topDict.CharStrings[this.id];
            var end = str.offset + str.length;
            stream.pos = str.offset;
            var path = new Path();
            var stack = [];
            var trans = [];
            var width = null;
            var nStems = 0;
            var x = 0, y = 0;
            var usedGsubrs = void 0;
            var usedSubrs = void 0;
            var open = false;
            this._usedGsubrs = usedGsubrs = {};
            this._usedSubrs = usedSubrs = {};
            var gsubrs = cff.globalSubrIndex || [];
            var gsubrsBias = this.bias(gsubrs);
            var privateDict = cff.privateDictForGlyph(this.id) || {};
            var subrs = privateDict.Subrs || [];
            var subrsBias = this.bias(subrs);
            var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
            var vsindex = privateDict.vsindex;
            var variationProcessor = this._font._variationProcessor;
            function checkWidth() {
                if (width == null) {
                    width = stack.shift() + privateDict.nominalWidthX;
                }
            }
            function parseStems() {
                if (stack.length % 2 !== 0) {
                    checkWidth();
                }
                nStems += stack.length >> 1;
                return stack.length = 0;
            }
            function moveTo(x, y) {
                if (open) {
                    path.closePath();
                }
                path.moveTo(x, y);
                open = true;
            }
            var parse = function parse() {
                while (stream.pos < end) {
                    var op = stream.readUInt8();
                    if (op < 32) {
                        switch (op) {
                        case 1:
                        case 3:
                        case 18:
                        case 23:
                            parseStems();
                            break;
                        case 4:
                            if (stack.length > 1) {
                                checkWidth();
                            }
                            y += stack.shift();
                            moveTo(x, y);
                            break;
                        case 5:
                            while (stack.length >= 2) {
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                            }
                            break;
                        case 6:
                        case 7:
                            var phase = op === 6;
                            while (stack.length >= 1) {
                                if (phase) {
                                    x += stack.shift();
                                } else {
                                    y += stack.shift();
                                }
                                path.lineTo(x, y);
                                phase = !phase;
                            }
                            break;
                        case 8:
                            while (stack.length > 0) {
                                var c1x = x + stack.shift();
                                var c1y = y + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 10:
                            var index = stack.pop() + subrsBias;
                            var subr = subrs[index];
                            if (subr) {
                                usedSubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 11:
                            if (cff.version >= 2) {
                                break;
                            }
                            return;
                        case 14:
                            if (cff.version >= 2) {
                                break;
                            }
                            if (stack.length > 0) {
                                checkWidth();
                            }
                            if (open) {
                                path.closePath();
                                open = false;
                            }
                            break;
                        case 15: {
                                if (cff.version < 2) {
                                    throw new Error('vsindex operator not supported in CFF v1');
                                }
                                vsindex = stack.pop();
                                break;
                            }
                        case 16: {
                                if (cff.version < 2) {
                                    throw new Error('blend operator not supported in CFF v1');
                                }
                                if (!variationProcessor) {
                                    throw new Error('blend operator in non-variation font');
                                }
                                var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                var numBlends = stack.pop();
                                var numOperands = numBlends * blendVector.length;
                                var delta = stack.length - numOperands;
                                var base = delta - numBlends;
                                for (var i = 0; i < numBlends; i++) {
                                    var sum = stack[base + i];
                                    for (var j = 0; j < blendVector.length; j++) {
                                        sum += blendVector[j] * stack[delta++];
                                    }
                                    stack[base + i] = sum;
                                }
                                while (numOperands--) {
                                    stack.pop();
                                }
                                break;
                            }
                        case 19:
                        case 20:
                            parseStems();
                            stream.pos += nStems + 7 >> 3;
                            break;
                        case 21:
                            if (stack.length > 2) {
                                checkWidth();
                            }
                            x += stack.shift();
                            y += stack.shift();
                            moveTo(x, y);
                            break;
                        case 22:
                            if (stack.length > 1) {
                                checkWidth();
                            }
                            x += stack.shift();
                            moveTo(x, y);
                            break;
                        case 24:
                            while (stack.length >= 8) {
                                var c1x = x + stack.shift();
                                var c1y = y + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                            break;
                        case 25:
                            while (stack.length >= 8) {
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                            }
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            break;
                        case 26:
                            if (stack.length % 2) {
                                x += stack.shift();
                            }
                            while (stack.length >= 4) {
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x;
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 27:
                            if (stack.length % 2) {
                                y += stack.shift();
                            }
                            while (stack.length >= 4) {
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 28:
                            stack.push(stream.readInt16BE());
                            break;
                        case 29:
                            index = stack.pop() + gsubrsBias;
                            subr = gsubrs[index];
                            if (subr) {
                                usedGsubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 30:
                        case 31:
                            phase = op === 31;
                            while (stack.length >= 4) {
                                if (phase) {
                                    c1x = x + stack.shift();
                                    c1y = y;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    y = c2y + stack.shift();
                                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
                                } else {
                                    c1x = x;
                                    c1y = y + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    x = c2x + stack.shift();
                                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
                                }
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                phase = !phase;
                            }
                            break;
                        case 12:
                            op = stream.readUInt8();
                            switch (op) {
                            case 3:
                                var a = stack.pop();
                                var b = stack.pop();
                                stack.push(a && b ? 1 : 0);
                                break;
                            case 4:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a || b ? 1 : 0);
                                break;
                            case 5:
                                a = stack.pop();
                                stack.push(a ? 0 : 1);
                                break;
                            case 9:
                                a = stack.pop();
                                stack.push(Math.abs(a));
                                break;
                            case 10:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a + b);
                                break;
                            case 11:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a - b);
                                break;
                            case 12:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a / b);
                                break;
                            case 14:
                                a = stack.pop();
                                stack.push(-a);
                                break;
                            case 15:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a === b ? 1 : 0);
                                break;
                            case 18:
                                stack.pop();
                                break;
                            case 20:
                                var val = stack.pop();
                                var idx = stack.pop();
                                trans[idx] = val;
                                break;
                            case 21:
                                idx = stack.pop();
                                stack.push(trans[idx] || 0);
                                break;
                            case 22:
                                var s1 = stack.pop();
                                var s2 = stack.pop();
                                var v1 = stack.pop();
                                var v2 = stack.pop();
                                stack.push(v1 <= v2 ? s1 : s2);
                                break;
                            case 23:
                                stack.push(Math.random());
                                break;
                            case 24:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a * b);
                                break;
                            case 26:
                                a = stack.pop();
                                stack.push(Math.sqrt(a));
                                break;
                            case 27:
                                a = stack.pop();
                                stack.push(a, a);
                                break;
                            case 28:
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(b, a);
                                break;
                            case 29:
                                idx = stack.pop();
                                if (idx < 0) {
                                    idx = 0;
                                } else if (idx > stack.length - 1) {
                                    idx = stack.length - 1;
                                }
                                stack.push(stack[idx]);
                                break;
                            case 30:
                                var n = stack.pop();
                                var _j = stack.pop();
                                if (_j >= 0) {
                                    while (_j > 0) {
                                        var t = stack[n - 1];
                                        for (var _i = n - 2; _i >= 0; _i--) {
                                            stack[_i + 1] = stack[_i];
                                        }
                                        stack[0] = t;
                                        _j--;
                                    }
                                } else {
                                    while (_j < 0) {
                                        var t = stack[0];
                                        for (var _i2 = 0; _i2 <= n; _i2++) {
                                            stack[_i2] = stack[_i2 + 1];
                                        }
                                        stack[n - 1] = t;
                                        _j++;
                                    }
                                }
                                break;
                            case 34:
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                var c3x = c2x + stack.shift();
                                var c3y = c2y;
                                var c4x = c3x + stack.shift();
                                var c4y = c3y;
                                var c5x = c4x + stack.shift();
                                var c5y = c4y;
                                var c6x = c5x + stack.shift();
                                var c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 35:
                                var pts = [];
                                for (var _i3 = 0; _i3 <= 5; _i3++) {
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                stack.shift();
                                break;
                            case 36:
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                c3x = c2x + stack.shift();
                                c3y = c2y;
                                c4x = c3x + stack.shift();
                                c4y = c3y;
                                c5x = c4x + stack.shift();
                                c5y = c4y + stack.shift();
                                c6x = c5x + stack.shift();
                                c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 37:
                                var startx = x;
                                var starty = y;
                                pts = [];
                                for (var _i4 = 0; _i4 <= 4; _i4++) {
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                    x += stack.shift();
                                    y = starty;
                                } else {
                                    x = startx;
                                    y += stack.shift();
                                }
                                pts.push(x, y);
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                break;
                            default:
                                throw new Error('Unknown op: 12 ' + op);
                            }
                            break;
                        default:
                            throw new Error('Unknown op: ' + op);
                        }
                    } else if (op < 247) {
                        stack.push(op - 139);
                    } else if (op < 251) {
                        var b1 = stream.readUInt8();
                        stack.push((op - 247) * 256 + b1 + 108);
                    } else if (op < 255) {
                        var b1 = stream.readUInt8();
                        stack.push(-(op - 251) * 256 - b1 - 108);
                    } else {
                        stack.push(stream.readInt32BE() / 65536);
                    }
                }
            };
            parse();
            if (open) {
                path.closePath();
            }
            return path;
        };
        return CFFGlyph;
    }(Glyph);
var SBIXImage = new r.Struct({
        originX: r.uint16,
        originY: r.uint16,
        type: new r.String(4),
        data: new r.Buffer(function (t) {
            return t.parent.buflen - t._currentOffset;
        })
    });
var SBIXGlyph = function (_TTFGlyph) {
        _inherits(SBIXGlyph, _TTFGlyph);
        function SBIXGlyph() {
            _classCallCheck(this, SBIXGlyph);
            return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
        }
        SBIXGlyph.prototype.getImageForSize = function getImageForSize(size) {
            for (var i = 0; i < this._font.sbix.imageTables.length; i++) {
                var table = this._font.sbix.imageTables[i];
                if (table.ppem >= size) {
                    break;
                }
            }
            var offsets = table.imageOffsets;
            var start = offsets[this.id];
            var end = offsets[this.id + 1];
            if (start === end) {
                return null;
            }
            this._font.stream.pos = start;
            return SBIXImage.decode(this._font.stream, { buflen: end - start });
        };
        SBIXGlyph.prototype.render = function render(ctx, size) {
            var img = this.getImageForSize(size);
            if (img != null) {
                var scale = size / this._font.unitsPerEm;
                ctx.image(img.data, {
                    height: size,
                    x: img.originX,
                    y: (this.bbox.minY - img.originY) * scale
                });
            }
            if (this._font.sbix.flags.renderOutlines) {
                _TTFGlyph.prototype.render.call(this, ctx, size);
            }
        };
        return SBIXGlyph;
    }(TTFGlyph);
var COLRLayer = function COLRLayer(glyph, color) {
    _classCallCheck(this, COLRLayer);
    this.glyph = glyph;
    this.color = color;
};
var COLRGlyph = function (_Glyph) {
        _inherits(COLRGlyph, _Glyph);
        function COLRGlyph() {
            _classCallCheck(this, COLRGlyph);
            return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
        }
        COLRGlyph.prototype._getBBox = function _getBBox() {
            var bbox = new BBox();
            for (var i = 0; i < this.layers.length; i++) {
                var layer = this.layers[i];
                var b = layer.glyph.bbox;
                bbox.addPoint(b.minX, b.minY);
                bbox.addPoint(b.maxX, b.maxY);
            }
            return bbox;
        };
        COLRGlyph.prototype.render = function render(ctx, size) {
            for (var _iterator = this.layers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var _ref2 = _ref, glyph = _ref2.glyph, color = _ref2.color;
                ctx.fillColor([
                    color.red,
                    color.green,
                    color.blue
                ], color.alpha / 255 * 100);
                glyph.render(ctx, size);
            }
            return;
        };
        _createClass(COLRGlyph, [{
                key: 'layers',
                get: function get() {
                    var cpal = this._font.CPAL;
                    var colr = this._font.COLR;
                    var low = 0;
                    var high = colr.baseGlyphRecord.length - 1;
                    while (low <= high) {
                        var mid = low + high >> 1;
                        var rec = colr.baseGlyphRecord[mid];
                        if (this.id < rec.gid) {
                            high = mid - 1;
                        } else if (this.id > rec.gid) {
                            low = mid + 1;
                        } else {
                            var baseLayer = rec;
                            break;
                        }
                    }
                    if (baseLayer == null) {
                        var g = this._font._getBaseGlyph(this.id);
                        var color = {
                                red: 0,
                                green: 0,
                                blue: 0,
                                alpha: 255
                            };
                        return [new COLRLayer(g, color)];
                    }
                    var layers = [];
                    for (var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++) {
                        var rec = colr.layerRecords[i];
                        var color = cpal.colorRecords[rec.paletteIndex];
                        var g = this._font._getBaseGlyph(rec.gid);
                        layers.push(new COLRLayer(g, color));
                    }
                    return layers;
                }
            }]);
        return COLRGlyph;
    }(Glyph);
var TUPLES_SHARE_POINT_NUMBERS = 32768;
var TUPLE_COUNT_MASK = 4095;
var EMBEDDED_TUPLE_COORD = 32768;
var INTERMEDIATE_TUPLE = 16384;
var PRIVATE_POINT_NUMBERS = 8192;
var TUPLE_INDEX_MASK = 4095;
var POINTS_ARE_WORDS = 128;
var POINT_RUN_COUNT_MASK = 127;
var DELTAS_ARE_ZERO = 128;
var DELTAS_ARE_WORDS = 64;
var DELTA_RUN_COUNT_MASK = 63;
var GlyphVariationProcessor = function () {
        function GlyphVariationProcessor(font, coords) {
            _classCallCheck(this, GlyphVariationProcessor);
            this.font = font;
            this.normalizedCoords = this.normalizeCoords(coords);
            this.blendVectors = new _Map();
        }
        GlyphVariationProcessor.prototype.normalizeCoords = function normalizeCoords(coords) {
            var normalized = [];
            for (var i = 0; i < this.font.fvar.axis.length; i++) {
                var axis = this.font.fvar.axis[i];
                if (coords[i] < axis.defaultValue) {
                    normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.defaultValue - axis.minValue + _Number$EPSILON));
                } else {
                    normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.maxValue - axis.defaultValue + _Number$EPSILON));
                }
            }
            if (this.font.avar) {
                for (var i = 0; i < this.font.avar.segment.length; i++) {
                    var segment = this.font.avar.segment[i];
                    for (var j = 0; j < segment.correspondence.length; j++) {
                        var pair = segment.correspondence[j];
                        if (j >= 1 && normalized[i] < pair.fromCoord) {
                            var prev = segment.correspondence[j - 1];
                            normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + _Number$EPSILON) / (pair.fromCoord - prev.fromCoord + _Number$EPSILON) + prev.toCoord;
                            break;
                        }
                    }
                }
            }
            return normalized;
        };
        GlyphVariationProcessor.prototype.transformPoints = function transformPoints(gid, glyphPoints) {
            if (!this.font.fvar || !this.font.gvar) {
                return;
            }
            var gvar = this.font.gvar;
            if (gid >= gvar.glyphCount) {
                return;
            }
            var offset = gvar.offsets[gid];
            if (offset === gvar.offsets[gid + 1]) {
                return;
            }
            var stream = this.font.stream;
            stream.pos = offset;
            if (stream.pos >= stream.length) {
                return;
            }
            var tupleCount = stream.readUInt16BE();
            var offsetToData = offset + stream.readUInt16BE();
            if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
                var here = stream.pos;
                stream.pos = offsetToData;
                var sharedPoints = this.decodePoints();
                offsetToData = stream.pos;
                stream.pos = here;
            }
            var origPoints = glyphPoints.map(function (pt) {
                    return pt.copy();
                });
            tupleCount &= TUPLE_COUNT_MASK;
            for (var i = 0; i < tupleCount; i++) {
                var tupleDataSize = stream.readUInt16BE();
                var tupleIndex = stream.readUInt16BE();
                if (tupleIndex & EMBEDDED_TUPLE_COORD) {
                    var tupleCoords = [];
                    for (var a = 0; a < gvar.axisCount; a++) {
                        tupleCoords.push(stream.readInt16BE() / 16384);
                    }
                } else {
                    if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) {
                        throw new Error('Invalid gvar table');
                    }
                    var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
                }
                if (tupleIndex & INTERMEDIATE_TUPLE) {
                    var startCoords = [];
                    for (var _a = 0; _a < gvar.axisCount; _a++) {
                        startCoords.push(stream.readInt16BE() / 16384);
                    }
                    var endCoords = [];
                    for (var _a2 = 0; _a2 < gvar.axisCount; _a2++) {
                        endCoords.push(stream.readInt16BE() / 16384);
                    }
                }
                var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
                if (factor === 0) {
                    offsetToData += tupleDataSize;
                    continue;
                }
                var here = stream.pos;
                stream.pos = offsetToData;
                if (tupleIndex & PRIVATE_POINT_NUMBERS) {
                    var points = this.decodePoints();
                } else {
                    var points = sharedPoints;
                }
                var nPoints = points.length === 0 ? glyphPoints.length : points.length;
                var xDeltas = this.decodeDeltas(nPoints);
                var yDeltas = this.decodeDeltas(nPoints);
                if (points.length === 0) {
                    for (var _i = 0; _i < glyphPoints.length; _i++) {
                        var point = glyphPoints[_i];
                        point.x += Math.round(xDeltas[_i] * factor);
                        point.y += Math.round(yDeltas[_i] * factor);
                    }
                } else {
                    var outPoints = origPoints.map(function (pt) {
                            return pt.copy();
                        });
                    var hasDelta = glyphPoints.map(function () {
                            return false;
                        });
                    for (var _i2 = 0; _i2 < points.length; _i2++) {
                        var idx = points[_i2];
                        if (idx < glyphPoints.length) {
                            var _point = outPoints[idx];
                            hasDelta[idx] = true;
                            _point.x += Math.round(xDeltas[_i2] * factor);
                            _point.y += Math.round(yDeltas[_i2] * factor);
                        }
                    }
                    this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                    for (var _i3 = 0; _i3 < glyphPoints.length; _i3++) {
                        var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                        var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                        glyphPoints[_i3].x += deltaX;
                        glyphPoints[_i3].y += deltaY;
                    }
                }
                offsetToData += tupleDataSize;
                stream.pos = here;
            }
        };
        GlyphVariationProcessor.prototype.decodePoints = function decodePoints() {
            var stream = this.font.stream;
            var count = stream.readUInt8();
            if (count & POINTS_ARE_WORDS) {
                count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
            }
            var points = new Uint16Array(count);
            var i = 0;
            var point = 0;
            while (i < count) {
                var run = stream.readUInt8();
                var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
                var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
                for (var j = 0; j < runCount && i < count; j++) {
                    point += fn.call(stream);
                    points[i++] = point;
                }
            }
            return points;
        };
        GlyphVariationProcessor.prototype.decodeDeltas = function decodeDeltas(count) {
            var stream = this.font.stream;
            var i = 0;
            var deltas = new Int16Array(count);
            while (i < count) {
                var run = stream.readUInt8();
                var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;
                if (run & DELTAS_ARE_ZERO) {
                    i += runCount;
                } else {
                    var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                    for (var j = 0; j < runCount && i < count; j++) {
                        deltas[i++] = fn.call(stream);
                    }
                }
            }
            return deltas;
        };
        GlyphVariationProcessor.prototype.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
            var normalized = this.normalizedCoords;
            var gvar = this.font.gvar;
            var factor = 1;
            for (var i = 0; i < gvar.axisCount; i++) {
                if (tupleCoords[i] === 0) {
                    continue;
                }
                if (normalized[i] === 0) {
                    return 0;
                }
                if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
                    if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) {
                        return 0;
                    }
                    factor = (factor * normalized[i] + _Number$EPSILON) / (tupleCoords[i] + _Number$EPSILON);
                } else {
                    if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) {
                        return 0;
                    } else if (normalized[i] < tupleCoords[i]) {
                        factor = factor * (normalized[i] - startCoords[i] + _Number$EPSILON) / (tupleCoords[i] - startCoords[i] + _Number$EPSILON);
                    } else {
                        factor = factor * (endCoords[i] - normalized[i] + _Number$EPSILON) / (endCoords[i] - tupleCoords[i] + _Number$EPSILON);
                    }
                }
            }
            return factor;
        };
        GlyphVariationProcessor.prototype.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
            if (points.length === 0) {
                return;
            }
            var point = 0;
            while (point < points.length) {
                var firstPoint = point;
                var endPoint = point;
                var pt = points[endPoint];
                while (!pt.endContour) {
                    pt = points[++endPoint];
                }
                while (point <= endPoint && !hasDelta[point]) {
                    point++;
                }
                if (point > endPoint) {
                    continue;
                }
                var firstDelta = point;
                var curDelta = point;
                point++;
                while (point <= endPoint) {
                    if (hasDelta[point]) {
                        this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                        curDelta = point;
                    }
                    point++;
                }
                if (curDelta === firstDelta) {
                    this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
                } else {
                    this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                    if (firstDelta > 0) {
                        this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
                    }
                }
                point = endPoint + 1;
            }
        };
        GlyphVariationProcessor.prototype.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
            if (p1 > p2) {
                return;
            }
            var iterable = [
                    'x',
                    'y'
                ];
            for (var i = 0; i < iterable.length; i++) {
                var k = iterable[i];
                if (inPoints[ref1][k] > inPoints[ref2][k]) {
                    var p = ref1;
                    ref1 = ref2;
                    ref2 = p;
                }
                var in1 = inPoints[ref1][k];
                var in2 = inPoints[ref2][k];
                var out1 = outPoints[ref1][k];
                var out2 = outPoints[ref2][k];
                if (in1 !== in2 || out1 === out2) {
                    var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                    for (var _p = p1; _p <= p2; _p++) {
                        var out = inPoints[_p][k];
                        if (out <= in1) {
                            out += out1 - in1;
                        } else if (out >= in2) {
                            out += out2 - in2;
                        } else {
                            out = out1 + (out - in1) * scale;
                        }
                        outPoints[_p][k] = out;
                    }
                }
            }
        };
        GlyphVariationProcessor.prototype.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
            var deltaX = outPoints[ref].x - inPoints[ref].x;
            var deltaY = outPoints[ref].y - inPoints[ref].y;
            if (deltaX === 0 && deltaY === 0) {
                return;
            }
            for (var p = p1; p <= p2; p++) {
                if (p !== ref) {
                    outPoints[p].x += deltaX;
                    outPoints[p].y += deltaY;
                }
            }
        };
        GlyphVariationProcessor.prototype.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
            var outerIndex = void 0, innerIndex = void 0;
            if (table.advanceWidthMapping) {
                var idx = gid;
                if (idx >= table.advanceWidthMapping.mapCount) {
                    idx = table.advanceWidthMapping.mapCount - 1;
                }
                var entryFormat = table.advanceWidthMapping.entryFormat;
                var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
                outerIndex = _table$advanceWidthMa.outerIndex;
                innerIndex = _table$advanceWidthMa.innerIndex;
            } else {
                outerIndex = 0;
                innerIndex = gid;
            }
            return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
        };
        GlyphVariationProcessor.prototype.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
            if (outerIndex >= itemStore.itemVariationData.length) {
                return 0;
            }
            var varData = itemStore.itemVariationData[outerIndex];
            if (innerIndex >= varData.deltaSets.length) {
                return 0;
            }
            var deltaSet = varData.deltaSets[innerIndex];
            var blendVector = this.getBlendVector(itemStore, outerIndex);
            var netAdjustment = 0;
            for (var master = 0; master < varData.regionIndexCount; master++) {
                netAdjustment += deltaSet.deltas[master] * blendVector[master];
            }
            return netAdjustment;
        };
        GlyphVariationProcessor.prototype.getBlendVector = function getBlendVector(itemStore, outerIndex) {
            var varData = itemStore.itemVariationData[outerIndex];
            if (this.blendVectors.has(varData)) {
                return this.blendVectors.get(varData);
            }
            var normalizedCoords = this.normalizedCoords;
            var blendVector = [];
            for (var master = 0; master < varData.regionIndexCount; master++) {
                var scalar = 1;
                var regionIndex = varData.regionIndexes[master];
                var axes = itemStore.variationRegionList.variationRegions[regionIndex];
                for (var j = 0; j < axes.length; j++) {
                    var axis = axes[j];
                    var axisScalar = void 0;
                    if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) {
                        axisScalar = 1;
                    } else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) {
                        axisScalar = 1;
                    } else if (axis.peakCoord === 0) {
                        axisScalar = 1;
                    } else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) {
                        axisScalar = 0;
                    } else {
                        if (normalizedCoords[j] === axis.peakCoord) {
                            axisScalar = 1;
                        } else if (normalizedCoords[j] < axis.peakCoord) {
                            axisScalar = (normalizedCoords[j] - axis.startCoord + _Number$EPSILON) / (axis.peakCoord - axis.startCoord + _Number$EPSILON);
                        } else {
                            axisScalar = (axis.endCoord - normalizedCoords[j] + _Number$EPSILON) / (axis.endCoord - axis.peakCoord + _Number$EPSILON);
                        }
                    }
                    scalar *= axisScalar;
                }
                blendVector[master] = scalar;
            }
            this.blendVectors.set(varData, blendVector);
            return blendVector;
        };
        return GlyphVariationProcessor;
    }();
var Subset = function () {
        function Subset(font) {
            _classCallCheck(this, Subset);
            this.font = font;
            this.glyphs = [];
            this.mapping = {};
            this.includeGlyph(0);
        }
        Subset.prototype.includeGlyph = function includeGlyph(glyph) {
            if ((typeof glyph === 'undefined' ? 'undefined' : _typeof(glyph)) === 'object') {
                glyph = glyph.id;
            }
            if (this.mapping[glyph] == null) {
                this.glyphs.push(glyph);
                this.mapping[glyph] = this.glyphs.length - 1;
            }
            return this.mapping[glyph];
        };
        Subset.prototype.encodeStream = function encodeStream() {
            var _this = this;
            var s = new r.EncodeStream();
            process.nextTick(function () {
                _this.encode(s);
                return s.end();
            });
            return s;
        };
        return Subset;
    }();
var ON_CURVE$1 = 1 << 0;
var X_SHORT_VECTOR$1 = 1 << 1;
var Y_SHORT_VECTOR$1 = 1 << 2;
var REPEAT$1 = 1 << 3;
var SAME_X$1 = 1 << 4;
var SAME_Y$1 = 1 << 5;
var Point$1 = function () {
        function Point() {
            _classCallCheck(this, Point);
        }
        Point.size = function size(val) {
            return val >= 0 && val <= 255 ? 1 : 2;
        };
        Point.encode = function encode(stream, value) {
            if (value >= 0 && value <= 255) {
                stream.writeUInt8(value);
            } else {
                stream.writeInt16BE(value);
            }
        };
        return Point;
    }();
var Glyf = new r.Struct({
        numberOfContours: r.int16,
        xMin: r.int16,
        yMin: r.int16,
        xMax: r.int16,
        yMax: r.int16,
        endPtsOfContours: new r.Array(r.uint16, 'numberOfContours'),
        instructions: new r.Array(r.uint8, r.uint16),
        flags: new r.Array(r.uint8, 0),
        xPoints: new r.Array(Point$1, 0),
        yPoints: new r.Array(Point$1, 0)
    });
var TTFGlyphEncoder = function () {
        function TTFGlyphEncoder() {
            _classCallCheck(this, TTFGlyphEncoder);
        }
        TTFGlyphEncoder.prototype.encodeSimple = function encodeSimple(path) {
            var instructions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var endPtsOfContours = [];
            var xPoints = [];
            var yPoints = [];
            var flags = [];
            var same = 0;
            var lastX = 0, lastY = 0, lastFlag = 0;
            var pointCount = 0;
            for (var i = 0; i < path.commands.length; i++) {
                var c = path.commands[i];
                for (var j = 0; j < c.args.length; j += 2) {
                    var x = c.args[j];
                    var y = c.args[j + 1];
                    var flag = 0;
                    if (c.command === 'quadraticCurveTo' && j === 2) {
                        var next = path.commands[i + 1];
                        if (next && next.command === 'quadraticCurveTo') {
                            var midX = (lastX + next.args[0]) / 2;
                            var midY = (lastY + next.args[1]) / 2;
                            if (x === midX && y === midY) {
                                continue;
                            }
                        }
                    }
                    if (!(c.command === 'quadraticCurveTo' && j === 0)) {
                        flag |= ON_CURVE$1;
                    }
                    flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
                    flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);
                    if (flag === lastFlag && same < 255) {
                        flags[flags.length - 1] |= REPEAT$1;
                        same++;
                    } else {
                        if (same > 0) {
                            flags.push(same);
                            same = 0;
                        }
                        flags.push(flag);
                        lastFlag = flag;
                    }
                    lastX = x;
                    lastY = y;
                    pointCount++;
                }
                if (c.command === 'closePath') {
                    endPtsOfContours.push(pointCount - 1);
                }
            }
            if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') {
                endPtsOfContours.push(pointCount - 1);
            }
            var bbox = path.bbox;
            var glyf = {
                    numberOfContours: endPtsOfContours.length,
                    xMin: bbox.minX,
                    yMin: bbox.minY,
                    xMax: bbox.maxX,
                    yMax: bbox.maxY,
                    endPtsOfContours: endPtsOfContours,
                    instructions: instructions,
                    flags: flags,
                    xPoints: xPoints,
                    yPoints: yPoints
                };
            var size = Glyf.size(glyf);
            var tail = 4 - size % 4;
            var stream = new r.EncodeStream(size + tail);
            Glyf.encode(stream, glyf);
            if (tail !== 0) {
                stream.fill(0, tail);
            }
            return stream.buffer;
        };
        TTFGlyphEncoder.prototype._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
            var diff = value - last;
            if (value === last) {
                flag |= sameFlag;
            } else {
                if (-255 <= diff && diff <= 255) {
                    flag |= shortFlag;
                    if (diff < 0) {
                        diff = -diff;
                    } else {
                        flag |= sameFlag;
                    }
                }
                points.push(diff);
            }
            return flag;
        };
        return TTFGlyphEncoder;
    }();
var TTFSubset = function (_Subset) {
        _inherits(TTFSubset, _Subset);
        function TTFSubset(font) {
            _classCallCheck(this, TTFSubset);
            var _this = _possibleConstructorReturn(this, _Subset.call(this, font));
            _this.glyphEncoder = new TTFGlyphEncoder();
            return _this;
        }
        TTFSubset.prototype._addGlyph = function _addGlyph(gid) {
            var glyph = this.font.getGlyph(gid);
            var glyf = glyph._decode();
            var curOffset = this.font.loca.offsets[gid];
            var nextOffset = this.font.loca.offsets[gid + 1];
            var stream = this.font._getTableStream('glyf');
            stream.pos += curOffset;
            var buffer = stream.readBuffer(nextOffset - curOffset);
            if (glyf && glyf.numberOfContours < 0) {
                buffer = new Buffer(buffer);
                for (var _iterator = glyf.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length)
                            break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done)
                            break;
                        _ref = _i.value;
                    }
                    var component = _ref;
                    gid = this.includeGlyph(component.glyphID);
                    buffer.writeUInt16BE(gid, component.pos);
                }
            } else if (glyf && this.font._variationProcessor) {
                buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
            }
            this.glyf.push(buffer);
            this.loca.offsets.push(this.offset);
            this.hmtx.metrics.push({
                advance: glyph.advanceWidth,
                bearing: glyph._getMetrics().leftBearing
            });
            this.offset += buffer.length;
            return this.glyf.length - 1;
        };
        TTFSubset.prototype.encode = function encode(stream) {
            this.glyf = [];
            this.offset = 0;
            this.loca = {
                offsets: [],
                version: this.font.loca.version
            };
            this.hmtx = {
                metrics: [],
                bearings: []
            };
            var i = 0;
            while (i < this.glyphs.length) {
                this._addGlyph(this.glyphs[i++]);
            }
            var maxp = cloneDeep(this.font.maxp);
            maxp.numGlyphs = this.glyf.length;
            this.loca.offsets.push(this.offset);
            var head = cloneDeep(this.font.head);
            head.indexToLocFormat = this.loca.version;
            var hhea = cloneDeep(this.font.hhea);
            hhea.numberOfMetrics = this.hmtx.metrics.length;
            Directory.encode(stream, {
                tables: {
                    head: head,
                    hhea: hhea,
                    loca: this.loca,
                    maxp: maxp,
                    'cvt ': this.font['cvt '],
                    prep: this.font.prep,
                    glyf: this.glyf,
                    hmtx: this.hmtx,
                    fpgm: this.font.fpgm
                }
            });
        };
        return TTFSubset;
    }(Subset);
var CFFSubset = function (_Subset) {
        _inherits(CFFSubset, _Subset);
        function CFFSubset(font) {
            _classCallCheck(this, CFFSubset);
            var _this = _possibleConstructorReturn(this, _Subset.call(this, font));
            _this.cff = _this.font['CFF '];
            if (!_this.cff) {
                throw new Error('Not a CFF Font');
            }
            return _this;
        }
        CFFSubset.prototype.subsetCharstrings = function subsetCharstrings() {
            this.charstrings = [];
            var gsubrs = {};
            for (var _iterator = this.glyphs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var gid = _ref;
                this.charstrings.push(this.cff.getCharString(gid));
                var glyph = this.font.getGlyph(gid);
                var path = glyph.path;
                for (var subr in glyph._usedGsubrs) {
                    gsubrs[subr] = true;
                }
            }
            this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
        };
        CFFSubset.prototype.subsetSubrs = function subsetSubrs(subrs, used) {
            var res = [];
            for (var i = 0; i < subrs.length; i++) {
                var subr = subrs[i];
                if (used[i]) {
                    this.cff.stream.pos = subr.offset;
                    res.push(this.cff.stream.readBuffer(subr.length));
                } else {
                    res.push(new Buffer([11]));
                }
            }
            return res;
        };
        CFFSubset.prototype.subsetFontdict = function subsetFontdict(topDict) {
            topDict.FDArray = [];
            topDict.FDSelect = {
                version: 0,
                fds: []
            };
            var used_fds = {};
            var used_subrs = [];
            for (var _iterator2 = this.glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var gid = _ref2;
                var fd = this.cff.fdForGlyph(gid);
                if (fd == null) {
                    continue;
                }
                if (!used_fds[fd]) {
                    topDict.FDArray.push(_Object$assign({}, this.cff.topDict.FDArray[fd]));
                    used_subrs.push({});
                }
                used_fds[fd] = true;
                topDict.FDSelect.fds.push(topDict.FDArray.length - 1);
                var glyph = this.font.getGlyph(gid);
                var path = glyph.path;
                for (var subr in glyph._usedSubrs) {
                    used_subrs[used_subrs.length - 1][subr] = true;
                }
            }
            for (var i = 0; i < topDict.FDArray.length; i++) {
                var dict = topDict.FDArray[i];
                delete dict.FontName;
                if (dict.Private && dict.Private.Subrs) {
                    dict.Private = _Object$assign({}, dict.Private);
                    dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
                }
            }
            return;
        };
        CFFSubset.prototype.createCIDFontdict = function createCIDFontdict(topDict) {
            var used_subrs = {};
            for (var _iterator3 = this.glyphs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length)
                        break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done)
                        break;
                    _ref3 = _i3.value;
                }
                var gid = _ref3;
                var glyph = this.font.getGlyph(gid);
                var path = glyph.path;
                for (var subr in glyph._usedSubrs) {
                    used_subrs[subr] = true;
                }
            }
            var privateDict = _Object$assign({}, this.cff.topDict.Private);
            if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) {
                privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
            }
            topDict.FDArray = [{ Private: privateDict }];
            return topDict.FDSelect = {
                version: 3,
                nRanges: 1,
                ranges: [{
                        first: 0,
                        fd: 0
                    }],
                sentinel: this.charstrings.length
            };
        };
        CFFSubset.prototype.addString = function addString(string) {
            if (!string) {
                return null;
            }
            if (!this.strings) {
                this.strings = [];
            }
            this.strings.push(string);
            return standardStrings.length + this.strings.length - 1;
        };
        CFFSubset.prototype.encode = function encode(stream) {
            this.subsetCharstrings();
            var charset = {
                    version: this.charstrings.length > 255 ? 2 : 1,
                    ranges: [{
                            first: 1,
                            nLeft: this.charstrings.length - 2
                        }]
                };
            var topDict = _Object$assign({}, this.cff.topDict);
            topDict.Private = null;
            topDict.charset = charset;
            topDict.Encoding = null;
            topDict.CharStrings = this.charstrings;
            var _arr = [
                    'version',
                    'Notice',
                    'Copyright',
                    'FullName',
                    'FamilyName',
                    'Weight',
                    'PostScript',
                    'BaseFontName',
                    'FontName'
                ];
            for (var _i4 = 0; _i4 < _arr.length; _i4++) {
                var key = _arr[_i4];
                topDict[key] = this.addString(this.cff.string(topDict[key]));
            }
            topDict.ROS = [
                this.addString('Adobe'),
                this.addString('Identity'),
                0
            ];
            topDict.CIDCount = this.charstrings.length;
            if (this.cff.isCIDFont) {
                this.subsetFontdict(topDict);
            } else {
                this.createCIDFontdict(topDict);
            }
            var top = {
                    version: 1,
                    hdrSize: this.cff.hdrSize,
                    offSize: 4,
                    header: this.cff.header,
                    nameIndex: [this.cff.postscriptName],
                    topDictIndex: [topDict],
                    stringIndex: this.strings,
                    globalSubrIndex: this.gsubrs
                };
            CFFTop.encode(stream, top);
        };
        return CFFSubset;
    }(Subset);
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }
    return desc;
}
var TTFFont = (_class = function () {
        TTFFont.probe = function probe(buffer) {
            var format = buffer.toString('ascii', 0, 4);
            return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
        };
        function TTFFont(stream) {
            var variationCoords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            _classCallCheck(this, TTFFont);
            this.defaultLanguage = null;
            this.stream = stream;
            this.variationCoords = variationCoords;
            this._directoryPos = this.stream.pos;
            this._tables = {};
            this._glyphs = {};
            this._decodeDirectory();
            for (var tag in this.directory.tables) {
                var table = this.directory.tables[tag];
                if (tables[tag] && table.length > 0) {
                    _Object$defineProperty(this, tag, { get: this._getTable.bind(this, table) });
                }
            }
        }
        TTFFont.prototype.setDefaultLanguage = function setDefaultLanguage() {
            var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            this.defaultLanguage = lang;
        };
        TTFFont.prototype._getTable = function _getTable(table) {
            if (!(table.tag in this._tables)) {
                try {
                    this._tables[table.tag] = this._decodeTable(table);
                } catch (e) {
                    if (fontkit.logErrors) {
                        console.error('Error decoding table ' + table.tag);
                        console.error(e.stack);
                    }
                }
            }
            return this._tables[table.tag];
        };
        TTFFont.prototype._getTableStream = function _getTableStream(tag) {
            var table = this.directory.tables[tag];
            if (table) {
                this.stream.pos = table.offset;
                return this.stream;
            }
            return null;
        };
        TTFFont.prototype._decodeDirectory = function _decodeDirectory() {
            return this.directory = Directory.decode(this.stream, { _startOffset: 0 });
        };
        TTFFont.prototype._decodeTable = function _decodeTable(table) {
            var pos = this.stream.pos;
            var stream = this._getTableStream(table.tag);
            var result = tables[table.tag].decode(stream, this, table.length);
            this.stream.pos = pos;
            return result;
        };
        TTFFont.prototype.getName = function getName(key) {
            var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultLanguage || fontkit.defaultLanguage;
            var record = this.name && this.name.records[key];
            if (record) {
                return record[lang] || record[this.defaultLanguage] || record[fontkit.defaultLanguage] || record['en'] || record[_Object$keys(record)[0]] || null;
            }
            return null;
        };
        TTFFont.prototype.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
            return !!this._cmapProcessor.lookup(codePoint);
        };
        TTFFont.prototype.glyphForCodePoint = function glyphForCodePoint(codePoint) {
            return this.getGlyph(this._cmapProcessor.lookup(codePoint), [codePoint]);
        };
        TTFFont.prototype.glyphsForString = function glyphsForString(string) {
            var glyphs = [];
            var len = string.length;
            var idx = 0;
            var last = -1;
            var state = -1;
            while (idx <= len) {
                var code = 0;
                var nextState = 0;
                if (idx < len) {
                    code = string.charCodeAt(idx++);
                    if (55296 <= code && code <= 56319 && idx < len) {
                        var next = string.charCodeAt(idx);
                        if (56320 <= next && next <= 57343) {
                            idx++;
                            code = ((code & 1023) << 10) + (next & 1023) + 65536;
                        }
                    }
                    nextState = 65024 <= code && code <= 65039 || 917760 <= code && code <= 917999 ? 1 : 0;
                } else {
                    idx++;
                }
                if (state === 0 && nextState === 1) {
                    glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                        last,
                        code
                    ]));
                } else if (state === 0 && nextState === 0) {
                    glyphs.push(this.glyphForCodePoint(last));
                }
                last = code;
                state = nextState;
            }
            return glyphs;
        };
        TTFFont.prototype.layout = function layout(string, userFeatures, script, language, direction) {
            return this._layoutEngine.layout(string, userFeatures, script, language, direction);
        };
        TTFFont.prototype.stringsForGlyph = function stringsForGlyph(gid) {
            return this._layoutEngine.stringsForGlyph(gid);
        };
        TTFFont.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
            return this._layoutEngine.getAvailableFeatures(script, language);
        };
        TTFFont.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
            var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            if (!this._glyphs[glyph]) {
                if (this.directory.tables.glyf) {
                    this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
                } else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) {
                    this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
                }
            }
            return this._glyphs[glyph] || null;
        };
        TTFFont.prototype.getGlyph = function getGlyph(glyph) {
            var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            if (!this._glyphs[glyph]) {
                if (this.directory.tables.sbix) {
                    this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
                } else if (this.directory.tables.COLR && this.directory.tables.CPAL) {
                    this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
                } else {
                    this._getBaseGlyph(glyph, characters);
                }
            }
            return this._glyphs[glyph] || null;
        };
        TTFFont.prototype.createSubset = function createSubset() {
            if (this.directory.tables['CFF ']) {
                return new CFFSubset(this);
            }
            return new TTFSubset(this);
        };
        TTFFont.prototype.getVariation = function getVariation(settings) {
            if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) {
                throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
            }
            if (typeof settings === 'string') {
                settings = this.namedVariations[settings];
            }
            if ((typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) !== 'object') {
                throw new Error('Variation settings must be either a variation name or settings object.');
            }
            var coords = this.fvar.axis.map(function (axis, i) {
                    var axisTag = axis.axisTag.trim();
                    if (axisTag in settings) {
                        return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
                    } else {
                        return axis.defaultValue;
                    }
                });
            var stream = new r.DecodeStream(this.stream.buffer);
            stream.pos = this._directoryPos;
            var font = new TTFFont(stream, coords);
            font._tables = this._tables;
            return font;
        };
        TTFFont.prototype.getFont = function getFont(name) {
            return this.getVariation(name);
        };
        _createClass(TTFFont, [
            {
                key: 'postscriptName',
                get: function get() {
                    return this.getName('postscriptName');
                }
            },
            {
                key: 'fullName',
                get: function get() {
                    return this.getName('fullName');
                }
            },
            {
                key: 'familyName',
                get: function get() {
                    return this.getName('fontFamily');
                }
            },
            {
                key: 'subfamilyName',
                get: function get() {
                    return this.getName('fontSubfamily');
                }
            },
            {
                key: 'copyright',
                get: function get() {
                    return this.getName('copyright');
                }
            },
            {
                key: 'version',
                get: function get() {
                    return this.getName('version');
                }
            },
            {
                key: 'ascent',
                get: function get() {
                    return this.hhea.ascent;
                }
            },
            {
                key: 'descent',
                get: function get() {
                    return this.hhea.descent;
                }
            },
            {
                key: 'lineGap',
                get: function get() {
                    return this.hhea.lineGap;
                }
            },
            {
                key: 'underlinePosition',
                get: function get() {
                    return this.post.underlinePosition;
                }
            },
            {
                key: 'underlineThickness',
                get: function get() {
                    return this.post.underlineThickness;
                }
            },
            {
                key: 'italicAngle',
                get: function get() {
                    return this.post.italicAngle;
                }
            },
            {
                key: 'capHeight',
                get: function get() {
                    var os2 = this['OS/2'];
                    return os2 ? os2.capHeight : this.ascent;
                }
            },
            {
                key: 'xHeight',
                get: function get() {
                    var os2 = this['OS/2'];
                    return os2 ? os2.xHeight : 0;
                }
            },
            {
                key: 'numGlyphs',
                get: function get() {
                    return this.maxp.numGlyphs;
                }
            },
            {
                key: 'unitsPerEm',
                get: function get() {
                    return this.head.unitsPerEm;
                }
            },
            {
                key: 'bbox',
                get: function get() {
                    return _Object$freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
                }
            },
            {
                key: '_cmapProcessor',
                get: function get() {
                    return new CmapProcessor(this.cmap);
                }
            },
            {
                key: 'characterSet',
                get: function get() {
                    return this._cmapProcessor.getCharacterSet();
                }
            },
            {
                key: '_layoutEngine',
                get: function get() {
                    return new LayoutEngine(this);
                }
            },
            {
                key: 'availableFeatures',
                get: function get() {
                    return this._layoutEngine.getAvailableFeatures();
                }
            },
            {
                key: 'variationAxes',
                get: function get() {
                    var res = {};
                    if (!this.fvar) {
                        return res;
                    }
                    for (var _iterator = this.fvar.axis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length)
                                break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done)
                                break;
                            _ref = _i.value;
                        }
                        var axis = _ref;
                        res[axis.axisTag.trim()] = {
                            name: axis.name.en,
                            min: axis.minValue,
                            default: axis.defaultValue,
                            max: axis.maxValue
                        };
                    }
                    return res;
                }
            },
            {
                key: 'namedVariations',
                get: function get() {
                    var res = {};
                    if (!this.fvar) {
                        return res;
                    }
                    for (var _iterator2 = this.fvar.instance, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length)
                                break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done)
                                break;
                            _ref2 = _i2.value;
                        }
                        var instance = _ref2;
                        var settings = {};
                        for (var i = 0; i < this.fvar.axis.length; i++) {
                            var axis = this.fvar.axis[i];
                            settings[axis.axisTag.trim()] = instance.coord[i];
                        }
                        res[instance.name.en] = settings;
                    }
                    return res;
                }
            },
            {
                key: '_variationProcessor',
                get: function get() {
                    if (!this.fvar) {
                        return null;
                    }
                    var variationCoords = this.variationCoords;
                    if (!variationCoords && !this.CFF2) {
                        return null;
                    }
                    if (!variationCoords) {
                        variationCoords = this.fvar.axis.map(function (axis) {
                            return axis.defaultValue;
                        });
                    }
                    return new GlyphVariationProcessor(this, variationCoords);
                }
            }
        ]);
        return TTFFont;
    }(), (_applyDecoratedDescriptor(_class.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'bbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cmapProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_cmapProcessor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'characterSet', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'characterSet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_layoutEngine', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_layoutEngine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'variationAxes', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'variationAxes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'namedVariations', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'namedVariations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_variationProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_variationProcessor'), _class.prototype)), _class);
var WOFFDirectoryEntry = new r.Struct({
        tag: new r.String(4),
        offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
        compLength: r.uint32,
        length: r.uint32,
        origChecksum: r.uint32
    });
var WOFFDirectory = new r.Struct({
        tag: new r.String(4),
        flavor: r.uint32,
        length: r.uint32,
        numTables: r.uint16,
        reserved: new r.Reserved(r.uint16),
        totalSfntSize: r.uint32,
        majorVersion: r.uint16,
        minorVersion: r.uint16,
        metaOffset: r.uint32,
        metaLength: r.uint32,
        metaOrigLength: r.uint32,
        privOffset: r.uint32,
        privLength: r.uint32,
        tables: new r.Array(WOFFDirectoryEntry, 'numTables')
    });
WOFFDirectory.process = function () {
    var tables = {};
    for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length)
                break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done)
                break;
            _ref = _i.value;
        }
        var table = _ref;
        tables[table.tag] = table;
    }
    this.tables = tables;
};
var WOFFFont = function (_TTFFont) {
        _inherits(WOFFFont, _TTFFont);
        function WOFFFont() {
            _classCallCheck(this, WOFFFont);
            return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
        }
        WOFFFont.probe = function probe(buffer) {
            return buffer.toString('ascii', 0, 4) === 'wOFF';
        };
        WOFFFont.prototype._decodeDirectory = function _decodeDirectory() {
            this.directory = WOFFDirectory.decode(this.stream, { _startOffset: 0 });
        };
        WOFFFont.prototype._getTableStream = function _getTableStream(tag) {
            var table = this.directory.tables[tag];
            if (table) {
                this.stream.pos = table.offset;
                if (table.compLength < table.length) {
                    this.stream.pos += 2;
                    var outBuffer = new Buffer(table.length);
                    var buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
                    return new r.DecodeStream(buf);
                } else {
                    return this.stream;
                }
            }
            return null;
        };
        return WOFFFont;
    }(TTFFont);
var WOFF2Glyph = function (_TTFGlyph) {
        _inherits(WOFF2Glyph, _TTFGlyph);
        function WOFF2Glyph() {
            _classCallCheck(this, WOFF2Glyph);
            return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
        }
        WOFF2Glyph.prototype._decode = function _decode() {
            return this._font._transformedGlyphs[this.id];
        };
        WOFF2Glyph.prototype._getCBox = function _getCBox() {
            return this.path.bbox;
        };
        return WOFF2Glyph;
    }(TTFGlyph);
var Base128 = {
        decode: function decode(stream) {
            var result = 0;
            var iterable = [
                    0,
                    1,
                    2,
                    3,
                    4
                ];
            for (var j = 0; j < iterable.length; j++) {
                var i = iterable[j];
                var code = stream.readUInt8();
                if (result & 3758096384) {
                    throw new Error('Overflow');
                }
                result = result << 7 | code & 127;
                if ((code & 128) === 0) {
                    return result;
                }
            }
            throw new Error('Bad base 128 number');
        }
    };
var knownTags = [
        'cmap',
        'head',
        'hhea',
        'hmtx',
        'maxp',
        'name',
        'OS/2',
        'post',
        'cvt ',
        'fpgm',
        'glyf',
        'loca',
        'prep',
        'CFF ',
        'VORG',
        'EBDT',
        'EBLC',
        'gasp',
        'hdmx',
        'kern',
        'LTSH',
        'PCLT',
        'VDMX',
        'vhea',
        'vmtx',
        'BASE',
        'GDEF',
        'GPOS',
        'GSUB',
        'EBSC',
        'JSTF',
        'MATH',
        'CBDT',
        'CBLC',
        'COLR',
        'CPAL',
        'SVG ',
        'sbix',
        'acnt',
        'avar',
        'bdat',
        'bloc',
        'bsln',
        'cvar',
        'fdsc',
        'feat',
        'fmtx',
        'fvar',
        'gvar',
        'hsty',
        'just',
        'lcar',
        'mort',
        'morx',
        'opbd',
        'prop',
        'trak',
        'Zapf',
        'Silf',
        'Glat',
        'Gloc',
        'Feat',
        'Sill'
    ];
var WOFF2DirectoryEntry = new r.Struct({
        flags: r.uint8,
        customTag: new r.Optional(new r.String(4), function (t) {
            return (t.flags & 63) === 63;
        }),
        tag: function tag(t) {
            return t.customTag || knownTags[t.flags & 63];
        },
        length: Base128,
        transformVersion: function transformVersion(t) {
            return t.flags >>> 6 & 3;
        },
        transformed: function transformed(t) {
            return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
        },
        transformLength: new r.Optional(Base128, function (t) {
            return t.transformed;
        })
    });
var WOFF2Directory = new r.Struct({
        tag: new r.String(4),
        flavor: r.uint32,
        length: r.uint32,
        numTables: r.uint16,
        reserved: new r.Reserved(r.uint16),
        totalSfntSize: r.uint32,
        totalCompressedSize: r.uint32,
        majorVersion: r.uint16,
        minorVersion: r.uint16,
        metaOffset: r.uint32,
        metaLength: r.uint32,
        metaOrigLength: r.uint32,
        privOffset: r.uint32,
        privLength: r.uint32,
        tables: new r.Array(WOFF2DirectoryEntry, 'numTables')
    });
WOFF2Directory.process = function () {
    var tables = {};
    for (var i = 0; i < this.tables.length; i++) {
        var table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
var WOFF2Font = function (_TTFFont) {
        _inherits(WOFF2Font, _TTFFont);
        function WOFF2Font() {
            _classCallCheck(this, WOFF2Font);
            return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
        }
        WOFF2Font.probe = function probe(buffer) {
            return buffer.toString('ascii', 0, 4) === 'wOF2';
        };
        WOFF2Font.prototype._decodeDirectory = function _decodeDirectory() {
            this.directory = WOFF2Directory.decode(this.stream);
            this._dataPos = this.stream.pos;
        };
        WOFF2Font.prototype._decompress = function _decompress() {
            if (!this._decompressed) {
                this.stream.pos = this._dataPos;
                var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
                var decompressedSize = 0;
                for (var tag in this.directory.tables) {
                    var entry = this.directory.tables[tag];
                    entry.offset = decompressedSize;
                    decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
                }
                var decompressed = brotli(buffer, decompressedSize);
                if (!decompressed) {
                    throw new Error('Error decoding compressed data in WOFF2');
                }
                this.stream = new r.DecodeStream(new Buffer(decompressed));
                this._decompressed = true;
            }
        };
        WOFF2Font.prototype._decodeTable = function _decodeTable(table) {
            this._decompress();
            return _TTFFont.prototype._decodeTable.call(this, table);
        };
        WOFF2Font.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
            var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            if (!this._glyphs[glyph]) {
                if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                    if (!this._transformedGlyphs) {
                        this._transformGlyfTable();
                    }
                    return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
                } else {
                    return _TTFFont.prototype._getBaseGlyph.call(this, glyph, characters);
                }
            }
        };
        WOFF2Font.prototype._transformGlyfTable = function _transformGlyfTable() {
            this._decompress();
            this.stream.pos = this.directory.tables.glyf.offset;
            var table = GlyfTable.decode(this.stream);
            var glyphs = [];
            for (var index = 0; index < table.numGlyphs; index++) {
                var glyph = {};
                var nContours = table.nContours.readInt16BE();
                glyph.numberOfContours = nContours;
                if (nContours > 0) {
                    var nPoints = [];
                    var totalPoints = 0;
                    for (var i = 0; i < nContours; i++) {
                        var _r = read255UInt16(table.nPoints);
                        totalPoints += _r;
                        nPoints.push(totalPoints);
                    }
                    glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);
                    for (var _i = 0; _i < nContours; _i++) {
                        glyph.points[nPoints[_i] - 1].endContour = true;
                    }
                    var instructionSize = read255UInt16(table.glyphs);
                } else if (nContours < 0) {
                    var haveInstructions = TTFGlyph.prototype._decodeComposite.call({ _font: this }, glyph, table.composites);
                    if (haveInstructions) {
                        var instructionSize = read255UInt16(table.glyphs);
                    }
                }
                glyphs.push(glyph);
            }
            this._transformedGlyphs = glyphs;
        };
        return WOFF2Font;
    }(TTFFont);
var Substream = function () {
        function Substream(length) {
            _classCallCheck(this, Substream);
            this.length = length;
            this._buf = new r.Buffer(length);
        }
        Substream.prototype.decode = function decode(stream, parent) {
            return new r.DecodeStream(this._buf.decode(stream, parent));
        };
        return Substream;
    }();
var GlyfTable = new r.Struct({
        version: r.uint32,
        numGlyphs: r.uint16,
        indexFormat: r.uint16,
        nContourStreamSize: r.uint32,
        nPointsStreamSize: r.uint32,
        flagStreamSize: r.uint32,
        glyphStreamSize: r.uint32,
        compositeStreamSize: r.uint32,
        bboxStreamSize: r.uint32,
        instructionStreamSize: r.uint32,
        nContours: new Substream('nContourStreamSize'),
        nPoints: new Substream('nPointsStreamSize'),
        flags: new Substream('flagStreamSize'),
        glyphs: new Substream('glyphStreamSize'),
        composites: new Substream('compositeStreamSize'),
        bboxes: new Substream('bboxStreamSize'),
        instructions: new Substream('instructionStreamSize')
    });
var WORD_CODE = 253;
var ONE_MORE_BYTE_CODE2 = 254;
var ONE_MORE_BYTE_CODE1 = 255;
var LOWEST_U_CODE = 253;
function read255UInt16(stream) {
    var code = stream.readUInt8();
    if (code === WORD_CODE) {
        return stream.readUInt16BE();
    }
    if (code === ONE_MORE_BYTE_CODE1) {
        return stream.readUInt8() + LOWEST_U_CODE;
    }
    if (code === ONE_MORE_BYTE_CODE2) {
        return stream.readUInt8() + LOWEST_U_CODE * 2;
    }
    return code;
}
function withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function decodeTriplet(flags, glyphs, nPoints) {
    var y = void 0;
    var x = y = 0;
    var res = [];
    for (var i = 0; i < nPoints; i++) {
        var dx = 0, dy = 0;
        var flag = flags.readUInt8();
        var onCurve = !(flag >> 7);
        flag &= 127;
        if (flag < 10) {
            dx = 0;
            dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = withSign(flag, 1 + (b0 & 48) + (b1 >> 4));
            dy = withSign(flag >> 1, 1 + ((b0 & 12) << 2) + (b1 & 15));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            var b2 = glyphs.readUInt8();
            dx = withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = withSign(flag >> 1, ((b2 & 15) << 8) + glyphs.readUInt8());
        } else {
            dx = withSign(flag, glyphs.readUInt16BE());
            dy = withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new Point(onCurve, false, x, y));
    }
    return res;
}
var TTCHeader = new r.VersionedStruct(r.uint32, {
        65536: {
            numFonts: r.uint32,
            offsets: new r.Array(r.uint32, 'numFonts')
        },
        131072: {
            numFonts: r.uint32,
            offsets: new r.Array(r.uint32, 'numFonts'),
            dsigTag: r.uint32,
            dsigLength: r.uint32,
            dsigOffset: r.uint32
        }
    });
var TrueTypeCollection = function () {
        TrueTypeCollection.probe = function probe(buffer) {
            return buffer.toString('ascii', 0, 4) === 'ttcf';
        };
        function TrueTypeCollection(stream) {
            _classCallCheck(this, TrueTypeCollection);
            this.stream = stream;
            if (stream.readString(4) !== 'ttcf') {
                throw new Error('Not a TrueType collection');
            }
            this.header = TTCHeader.decode(stream);
        }
        TrueTypeCollection.prototype.getFont = function getFont(name) {
            for (var _iterator = this.header.offsets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var offset = _ref;
                var stream = new r.DecodeStream(this.stream.buffer);
                stream.pos = offset;
                var font = new TTFFont(stream);
                if (font.postscriptName === name) {
                    return font;
                }
            }
            return null;
        };
        _createClass(TrueTypeCollection, [{
                key: 'fonts',
                get: function get() {
                    var fonts = [];
                    for (var _iterator2 = this.header.offsets, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length)
                                break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done)
                                break;
                            _ref2 = _i2.value;
                        }
                        var offset = _ref2;
                        var stream = new r.DecodeStream(this.stream.buffer);
                        stream.pos = offset;
                        fonts.push(new TTFFont(stream));
                    }
                    return fonts;
                }
            }]);
        return TrueTypeCollection;
    }();
var DFontName = new r.String(r.uint8);
var DFontData = new r.Struct({
        len: r.uint32,
        buf: new r.Buffer('len')
    });
var Ref = new r.Struct({
        id: r.uint16,
        nameOffset: r.int16,
        attr: r.uint8,
        dataOffset: r.uint24,
        handle: r.uint32
    });
var Type = new r.Struct({
        name: new r.String(4),
        maxTypeIndex: r.uint16,
        refList: new r.Pointer(r.uint16, new r.Array(Ref, function (t) {
            return t.maxTypeIndex + 1;
        }), { type: 'parent' })
    });
var TypeList = new r.Struct({
        length: r.uint16,
        types: new r.Array(Type, function (t) {
            return t.length + 1;
        })
    });
var DFontMap = new r.Struct({
        reserved: new r.Reserved(r.uint8, 24),
        typeList: new r.Pointer(r.uint16, TypeList),
        nameListOffset: new r.Pointer(r.uint16, 'void')
    });
var DFontHeader = new r.Struct({
        dataOffset: r.uint32,
        map: new r.Pointer(r.uint32, DFontMap),
        dataLength: r.uint32,
        mapLength: r.uint32
    });
var DFont = function () {
        DFont.probe = function probe(buffer) {
            var stream = new r.DecodeStream(buffer);
            try {
                var header = DFontHeader.decode(stream);
            } catch (e) {
                return false;
            }
            for (var _iterator = header.map.typeList.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length)
                        break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done)
                        break;
                    _ref = _i.value;
                }
                var type = _ref;
                if (type.name === 'sfnt') {
                    return true;
                }
            }
            return false;
        };
        function DFont(stream) {
            _classCallCheck(this, DFont);
            this.stream = stream;
            this.header = DFontHeader.decode(this.stream);
            for (var _iterator2 = this.header.map.typeList.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length)
                        break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done)
                        break;
                    _ref2 = _i2.value;
                }
                var type = _ref2;
                for (var _iterator3 = type.refList, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
                    var _ref3;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length)
                            break;
                        _ref3 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done)
                            break;
                        _ref3 = _i3.value;
                    }
                    var ref = _ref3;
                    if (ref.nameOffset >= 0) {
                        this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                        ref.name = DFontName.decode(this.stream);
                    } else {
                        ref.name = null;
                    }
                }
                if (type.name === 'sfnt') {
                    this.sfnt = type;
                }
            }
        }
        DFont.prototype.getFont = function getFont(name) {
            if (!this.sfnt) {
                return null;
            }
            for (var _iterator4 = this.sfnt.refList, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
                var _ref4;
                if (_isArray4) {
                    if (_i4 >= _iterator4.length)
                        break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done)
                        break;
                    _ref4 = _i4.value;
                }
                var ref = _ref4;
                var pos = this.header.dataOffset + ref.dataOffset + 4;
                var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                var font = new TTFFont(stream);
                if (font.postscriptName === name) {
                    return font;
                }
            }
            return null;
        };
        _createClass(DFont, [{
                key: 'fonts',
                get: function get() {
                    var fonts = [];
                    for (var _iterator5 = this.sfnt.refList, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
                        var _ref5;
                        if (_isArray5) {
                            if (_i5 >= _iterator5.length)
                                break;
                            _ref5 = _iterator5[_i5++];
                        } else {
                            _i5 = _iterator5.next();
                            if (_i5.done)
                                break;
                            _ref5 = _i5.value;
                        }
                        var ref = _ref5;
                        var pos = this.header.dataOffset + ref.dataOffset + 4;
                        var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                        fonts.push(new TTFFont(stream));
                    }
                    return fonts;
                }
            }]);
        return DFont;
    }();
fontkit.registerFormat(TTFFont);
fontkit.registerFormat(WOFFFont);
fontkit.registerFormat(WOFF2Font);
fontkit.registerFormat(TrueTypeCollection);
fontkit.registerFormat(DFont);
module.exports = fontkit;
}).call(this)}).call(this,require('_process'),require("buffer").Buffer)
},{"_process":405,"babel-runtime/core-js/array/from":364,"babel-runtime/core-js/get-iterator":365,"babel-runtime/core-js/map":366,"babel-runtime/core-js/number/epsilon":367,"babel-runtime/core-js/object/assign":368,"babel-runtime/core-js/object/define-properties":370,"babel-runtime/core-js/object/define-property":371,"babel-runtime/core-js/object/freeze":372,"babel-runtime/core-js/object/get-own-property-descriptor":373,"babel-runtime/core-js/object/keys":374,"babel-runtime/core-js/set":376,"babel-runtime/core-js/string/from-code-point":377,"babel-runtime/helpers/classCallCheck":380,"babel-runtime/helpers/createClass":381,"babel-runtime/helpers/inherits":382,"babel-runtime/helpers/possibleConstructorReturn":383,"babel-runtime/helpers/typeof":384,"brotli/decompress":401,"buffer":404,"clone":411,"deep-equal":547,"dfa":552,"iconv-lite":665,"restructure":1138,"restructure/src/utils":1154,"tiny-inflate":1203,"unicode-properties":1209,"unicode-trie":1210}],636:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],637:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":636}],638:[function(require,module,exports){
'use strict';

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('has');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"function-bind":637,"has":646,"has-symbols":644}],639:[function(require,module,exports){
let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,r=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,l=/\/\*[^]*?\*\/|\s\s+|\n/g,s=(e,t)=>{let r="",l="",a="";for(let o in e){let n=e[o];"@"==o[0]?"i"==o[1]?r=o+" "+n+";":l+="f"==o[1]?s(n,o):o+"{"+s(n,"k"==o[1]?"":t)+"}":"object"==typeof n?l+=s(n,t?t.replace(/([^,])+/g,e=>o.replace(/(^:.*)|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):o):null!=n&&(o=o.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=s.p?s.p(o,n):o+":"+n+";")}return r+(t&&a?t+"{"+a+"}":a)+l},a={},o=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+o(e[r]);return t}return e},n=(e,t,n,c,p)=>{let i=o(e),u=a[i]||(a[i]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return"go"+r})(i));if(!a[u]){let t=i!==e?e:(e=>{let t,s=[{}];for(;t=r.exec(e.replace(l,""));)t[4]?s.shift():t[3]?s.unshift(s[0][t[3]]=s[0][t[3]]||{}):s[0][t[1]]=t[2];return s[0]})(e);a[u]=s(p?{["@keyframes "+u]:t}:t,n?"":"."+u)}return((e,t,r)=>{-1==t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e)})(a[u],t,c),u},c=(e,t,r)=>e.reduce((e,l,a)=>{let o=t[a];if(o&&o.call){let e=o(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;o=t?"."+t:e&&"object"==typeof e?e.props?"":s(e,""):!1===e?"":e}return e+l+(null==o?"":o)},"");function p(e){let r=this||{},l=e.call?e(r.p):e;return n(l.unshift?l.raw?c(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}let i,u,d,f=p.bind({g:1}),g=p.bind({k:1});exports.css=p,exports.extractCss=e=>{let r=t(e),l=r.data;return r.data="",l},exports.glob=f,exports.keyframes=g,exports.setup=function(e,t,r,l){s.p=t,i=e,u=r,d=l},exports.styled=function(e,t){let r=this||{};return function(){let l=arguments;function s(a,o){let n=Object.assign({},a),c=n.className||s.className;r.p=Object.assign({theme:u&&u()},n),r.o=/ *go\d+/.test(c),n.className=p.apply(r,l)+(c?" "+c:""),t&&(n.ref=o);let f=e;return e[0]&&(f=n.as||e,delete n.as),d&&f[0]&&d(n),i(f,n)}return t?t(s):s}};

},{}],640:[function(require,module,exports){
(function (global){(function (){
/*!
 * VERSION: 1.20.5
 * DATE: 2018-05-21
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {

	"use strict";

	_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {

		var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			_applyCycle = function(vars, targets, i) {
				var alt = vars.cycle,
					p, val;
				for (p in alt) {
					val = alt[p];
					vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
				}
				delete vars.cycle;
			},
			TweenMax = function(target, duration, vars) {
				TweenLite.call(this, target, duration, vars);
				this._cycle = 0;
				this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				if (this._repeat) {
					this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
				}
				this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
			},
			_tinyNum = 0.0000000001,
			TweenLiteInternals = TweenLite._internals,
			_isSelector = TweenLiteInternals.isSelector,
			_isArray = TweenLiteInternals.isArray,
			p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
			_blankArray = [];

		TweenMax.version = "1.20.5";
		p.constructor = TweenMax;
		p.kill()._gc = false;
		TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
		TweenMax.getTweensOf = TweenLite.getTweensOf;
		TweenMax.lagSmoothing = TweenLite.lagSmoothing;
		TweenMax.ticker = TweenLite.ticker;
		TweenMax.render = TweenLite.render;

		p.invalidate = function() {
			this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
			this._repeat = this.vars.repeat || 0;
			this._repeatDelay = this.vars.repeatDelay || 0;
			this._yoyoEase = null;
			this._uncache(true);
			return TweenLite.prototype.invalidate.call(this);
		};
		
		p.updateTo = function(vars, resetDuration) {
			var curRatio = this.ratio,
				immediate = this.vars.immediateRender || vars.immediateRender,
				p;
			if (resetDuration && this._startTime < this._timeline._time) {
				this._startTime = this._timeline._time;
				this._uncache(false);
				if (this._gc) {
					this._enabled(true, false);
				} else {
					this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			for (p in vars) {
				this.vars[p] = vars[p];
			}
			if (this._initted || immediate) {
				if (resetDuration) {
					this._initted = false;
					if (immediate) {
						this.render(0, true, true);
					}
				} else {
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._notifyPluginsOfEnabled && this._firstPT) {
						TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
					}
					if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
						var prevTime = this._totalTime;
						this.render(0, true, false);
						this._initted = false;
						this.render(prevTime, true, false);
					} else {
						this._initted = false;
						this._init();
						if (this._time > 0 || immediate) {
							var inv = 1 / (1 - curRatio),
								pt = this._firstPT, endValue;
							while (pt) {
								endValue = pt.s + pt.c;
								pt.c *= inv;
								pt.s = endValue - pt.c;
								pt = pt._next;
							}
						}
					}
				}
			}
			return this;
		};
				
		p.render = function(time, suppressEvents, force) {
			if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
				this.invalidate();
			}
			var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
				prevTime = this._time,
				prevTotalTime = this._totalTime, 
				prevCycle = this._cycle,
				duration = this._duration,
				prevRawPrevTime = this._rawPrevTime,
				isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
			if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = totalDur;
				this._cycle = this._repeat;
				if (this._yoyo && (this._cycle & 1) !== 0) {
					this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				} else {
					this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				}
				if (!this._reversed) {
					isComplete = true;
					callback = "onComplete";
					force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}
				
			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = this._cycle = 0;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0) {
							force = true;
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
					force = true;
				}
			} else {
				this._totalTime = this._time = time;
				if (this._repeat !== 0) {
					cycleDuration = duration + this._repeatDelay;
					this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
					if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
						this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
					}
					this._time = this._totalTime - (this._cycle * cycleDuration);
					if (this._yoyo) if ((this._cycle & 1) !== 0) {
						this._time = duration - this._time;
						yoyoEase = this._yoyoEase || this.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
						if (yoyoEase) {
							if (!this._yoyoEase) {
								if (yoyoEase === true && !this._initted) { //if it's not initted and yoyoEase is true, this._ease won't have been populated yet so we must discern it here.
									yoyoEase = this.vars.ease;
									this._yoyoEase = yoyoEase = !yoyoEase ? TweenLite.defaultEase : (yoyoEase instanceof Ease) ? yoyoEase : (typeof(yoyoEase) === "function") ? new Ease(yoyoEase, this.vars.easeParams) : Ease.map[yoyoEase] || TweenLite.defaultEase;
								} else {
									this._yoyoEase = yoyoEase = (yoyoEase === true) ? this._ease : (yoyoEase instanceof Ease) ? yoyoEase : Ease.map[yoyoEase];
								}
							}
							this.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - this._time) / duration) : 0;
						}
					}
					if (this._time > duration) {
						this._time = duration;
					} else if (this._time < 0) {
						this._time = 0;
					}
				}
				if (this._easeType && !yoyoEase) {
					r = this._time / duration;
					type = this._easeType;
					pow = this._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}

					if (type === 1) {
						this.ratio = 1 - r;
					} else if (type === 2) {
						this.ratio = r;
					} else if (this._time / duration < 0.5) {
						this.ratio = r / 2;
					} else {
						this.ratio = 1 - (r / 2);
					}

				} else if (!yoyoEase) {
					this.ratio = this._ease.getRatio(this._time / duration);
				}
				
			}
				
			if (prevTime === this._time && !force && prevCycle === this._cycle) {
				if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
					this._callback("onUpdate");
				}
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
					this._time = prevTime;
					this._totalTime = prevTotalTime;
					this._rawPrevTime = prevRawPrevTime;
					this._cycle = prevCycle;
					TweenLiteInternals.lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete && !yoyoEase) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd && !yoyoEase) {
					this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
				}
			}
			if (this._lazy !== false) {
				this._lazy = false;
			}

			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTotalTime === 0) {
				if (this._initted === 2 && time > 0) {
					//this.invalidate();
					this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
				}
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}
			
			if (this._onUpdate) {
				if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
					this._callback("onUpdate");
				}
			}
			if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
				this._callback("onRepeat");
			}
			if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};
		
//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
		
		TweenMax.to = function(target, duration, vars) {
			return new TweenMax(target, duration, vars);
		};
		
		TweenMax.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenMax(target, duration, vars);
		};
		
		TweenMax.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenMax(target, duration, toVars);
		};
		
		TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			stagger = stagger || 0;
			var delay = 0,
				a = [],
				finalComplete = function() {
					if (vars.onComplete) {
						vars.onComplete.apply(vars.onCompleteScope || this, arguments);
					}
					onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
				},
				cycle = vars.cycle,
				fromCycle = (vars.startAt && vars.startAt.cycle),
				l, copy, i, p;
			if (!_isArray(targets)) {
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				if (_isSelector(targets)) {
					targets = _slice(targets);
				}
			}
			targets = targets || [];
			if (stagger < 0) {
				targets = _slice(targets);
				targets.reverse();
				stagger *= -1;
			}
			l = targets.length - 1;
			for (i = 0; i <= l; i++) {
				copy = {};
				for (p in vars) {
					copy[p] = vars[p];
				}
				if (cycle) {
					_applyCycle(copy, targets, i);
					if (copy.duration != null) {
						duration = copy.duration;
						delete copy.duration;
					}
				}
				if (fromCycle) {
					fromCycle = copy.startAt = {};
					for (p in vars.startAt) {
						fromCycle[p] = vars.startAt[p];
					}
					_applyCycle(copy.startAt, targets, i);
				}
				copy.delay = delay + (copy.delay || 0);
				if (i === l && onCompleteAll) {
					copy.onComplete = finalComplete;
				}
				a[i] = new TweenMax(targets[i], duration, copy);
				delay += stagger;
			}
			return a;
		};
		
		TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};
		
		TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};
				
		TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
		};
		
		TweenMax.set = function(target, vars) {
			return new TweenMax(target, 0, vars);
		};
		
		TweenMax.isTweening = function(target) {
			return (TweenLite.getTweensOf(target, true).length > 0);
		};
		
		var _getChildrenOf = function(timeline, includeTimelines) {
				var a = [],
					cnt = 0,
					tween = timeline._first;
				while (tween) {
					if (tween instanceof TweenLite) {
						a[cnt++] = tween;
					} else {
						if (includeTimelines) {
							a[cnt++] = tween;
						}
						a = a.concat(_getChildrenOf(tween, includeTimelines));
						cnt = a.length;
					}
					tween = tween._next;
				}
				return a;
			}, 
			getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
				return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
			};
		
		TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
			if (tweens == null) {
				tweens = true;
			}
			if (delayedCalls == null) {
				delayedCalls = true;
			}
			var a = getAllTweens((timelines != false)),
				l = a.length,
				allTrue = (tweens && delayedCalls && timelines),
				isDC, tween, i;
			for (i = 0; i < l; i++) {
				tween = a[i];
				if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
					if (complete) {
						tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
					} else {
						tween._enabled(false, false);
					}
				}
			}
		};
		
		TweenMax.killChildTweensOf = function(parent, complete) {
			if (parent == null) {
				return;
			}
			var tl = TweenLiteInternals.tweenLookup,
				a, curParent, p, i, l;
			if (typeof(parent) === "string") {
				parent = TweenLite.selector(parent) || parent;
			}
			if (_isSelector(parent)) {
				parent = _slice(parent);
			}
			if (_isArray(parent)) {
				i = parent.length;
				while (--i > -1) {
					TweenMax.killChildTweensOf(parent[i], complete);
				}
				return;
			}
			a = [];
			for (p in tl) {
				curParent = tl[p].target.parentNode;
				while (curParent) {
					if (curParent === parent) {
						a = a.concat(tl[p].tweens);
					}
					curParent = curParent.parentNode;
				}
			}
			l = a.length;
			for (i = 0; i < l; i++) {
				if (complete) {
					a[i].totalTime(a[i].totalDuration());
				}
				a[i]._enabled(false, false);
			}
		};

		var _changePause = function(pause, tweens, delayedCalls, timelines) {
			tweens = (tweens !== false);
			delayedCalls = (delayedCalls !== false);
			timelines = (timelines !== false);
			var a = getAllTweens(timelines),
				allTrue = (tweens && delayedCalls && timelines),
				i = a.length,
				isDC, tween;
			while (--i > -1) {
				tween = a[i];
				if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
					tween.paused(pause);
				}
			}
		};
		
		TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
			_changePause(true, tweens, delayedCalls, timelines);
		};
		
		TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
			_changePause(false, tweens, delayedCalls, timelines);
		};

		TweenMax.globalTimeScale = function(value) {
			var tl = Animation._rootTimeline,
				t = TweenLite.ticker.time;
			if (!arguments.length) {
				return tl._timeScale;
			}
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
			tl = Animation._rootFramesTimeline;
			t = TweenLite.ticker.frame;
			tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
			tl._timeScale = Animation._rootTimeline._timeScale = value;
			return value;
		};
		
	
//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
		
		p.progress = function(value, suppressEvents) {
			return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
		};
		
		p.totalProgress = function(value, suppressEvents) {
			return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
		};
		
		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			if (value > this._duration) {
				value = this._duration;
			}
			if (this._yoyo && (this._cycle & 1) !== 0) {
				value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
			} else if (this._repeat !== 0) {
				value += this._cycle * (this._duration + this._repeatDelay);
			}
			return this.totalTime(value, suppressEvents);
		};

		p.duration = function(value) {
			if (!arguments.length) {
				return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
			}
			return Animation.prototype.duration.call(this, value);
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					//instead of Infinity, we use 999999999999 so that we can accommodate reverses
					this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					this._dirty = false;
				}
				return this._totalDuration;
			}
			return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
		};
		
		p.repeat = function(value) {
			if (!arguments.length) {
				return this._repeat;
			}
			this._repeat = value;
			return this._uncache(true);
		};
		
		p.repeatDelay = function(value) {
			if (!arguments.length) {
				return this._repeatDelay;
			}
			this._repeatDelay = value;
			return this._uncache(true);
		};
		
		p.yoyo = function(value) {
			if (!arguments.length) {
				return this._yoyo;
			}
			this._yoyo = value;
			return this;
		};
		
		
		return TweenMax;
		
	}, true);








/*
 * ----------------------------------------------------------------
 * TimelineLite
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {

		var TimelineLite = function(vars) {
				SimpleTimeline.call(this, vars);
				this._labels = {};
				this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
				this.smoothChildTiming = (this.vars.smoothChildTiming === true);
				this._sortChildren = true;
				this._onUpdate = this.vars.onUpdate;
				var v = this.vars,
					val, p;
				for (p in v) {
					val = v[p];
					if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
						v[p] = this._swapSelfInParams(val);
					}
				}
				if (_isArray(v.tweens)) {
					this.add(v.tweens, 0, v.align, v.stagger);
				}
			},
			_tinyNum = 0.0000000001,
			TweenLiteInternals = TweenLite._internals,
			_internals = TimelineLite._internals = {},
			_isSelector = TweenLiteInternals.isSelector,
			_isArray = TweenLiteInternals.isArray,
			_lazyTweens = TweenLiteInternals.lazyTweens,
			_lazyRender = TweenLiteInternals.lazyRender,
			_globals = _gsScope._gsDefine.globals,
			_copy = function(vars) {
				var copy = {}, p;
				for (p in vars) {
					copy[p] = vars[p];
				}
				return copy;
			},
			_applyCycle = function(vars, targets, i) {
				var alt = vars.cycle,
					p, val;
				for (p in alt) {
					val = alt[p];
					vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
				}
				delete vars.cycle;
			},
			_pauseCallback = _internals.pauseCallback = function() {},
			_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			p = TimelineLite.prototype = new SimpleTimeline();

		TimelineLite.version = "1.20.4";
		p.constructor = TimelineLite;
		p.kill()._gc = p._forcingPlayhead = p._hasPause = false;

		/* might use later...
		//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
		function localToGlobal(time, animation) {
			while (animation) {
				time = (time / animation._timeScale) + animation._startTime;
				animation = animation.timeline;
			}
			return time;
		}

		//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
		function globalToLocal(time, animation) {
			var scale = 1;
			time -= localToGlobal(0, animation);
			while (animation) {
				scale *= animation._timeScale;
				animation = animation.timeline;
			}
			return time * scale;
		}
		*/

		p.to = function(target, duration, vars, position) {
			var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
			return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
		};

		p.from = function(target, duration, vars, position) {
			return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
		};

		p.fromTo = function(target, duration, fromVars, toVars, position) {
			var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
			return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
		};

		p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
				cycle = vars.cycle,
				copy, i;
			if (typeof(targets) === "string") {
				targets = TweenLite.selector(targets) || targets;
			}
			targets = targets || [];
			if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
				targets = _slice(targets);
			}
			stagger = stagger || 0;
			if (stagger < 0) {
				targets = _slice(targets);
				targets.reverse();
				stagger *= -1;
			}
			for (i = 0; i < targets.length; i++) {
				copy = _copy(vars);
				if (copy.startAt) {
					copy.startAt = _copy(copy.startAt);
					if (copy.startAt.cycle) {
						_applyCycle(copy.startAt, targets, i);
					}
				}
				if (cycle) {
					_applyCycle(copy, targets, i);
					if (copy.duration != null) {
						duration = copy.duration;
						delete copy.duration;
					}
				}
				tl.to(targets[i], duration, copy, i * stagger);
			}
			return this.add(tl, position);
		};

		p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			vars.immediateRender = (vars.immediateRender != false);
			vars.runBackwards = true;
			return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		p.call = function(callback, params, scope, position) {
			return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
		};

		p.set = function(target, vars, position) {
			position = this._parseTimeOrLabel(position, 0, true);
			if (vars.immediateRender == null) {
				vars.immediateRender = (position === this._time && !this._paused);
			}
			return this.add( new TweenLite(target, 0, vars), position);
		};

		TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
			vars = vars || {};
			if (vars.smoothChildTiming == null) {
				vars.smoothChildTiming = true;
			}
			var tl = new TimelineLite(vars),
				root = tl._timeline,
				hasNegativeStart, time,	tween, next;
			if (ignoreDelayedCalls == null) {
				ignoreDelayedCalls = true;
			}
			root._remove(tl, true);
			tl._startTime = 0;
			tl._rawPrevTime = tl._time = tl._totalTime = root._time;
			tween = root._first;
			while (tween) {
				next = tween._next;
				if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
					time = tween._startTime - tween._delay;
					if (time < 0) {
						hasNegativeStart = 1;
					}
					tl.add(tween, time);
				}
				tween = next;
			}
			root.add(tl, 0);
			if (hasNegativeStart) { //calling totalDuration() will force the adjustment necessary to shift the children forward so none of them start before zero, and moves the timeline backwards the same amount, so the playhead is still aligned where it should be globally, but the timeline doesn't have illegal children that start before zero.
				tl.totalDuration();
			}
			return tl;
		};

		p.add = function(value, position, align, stagger) {
			var curTime, l, i, child, tl, beforeRawTime;
			if (typeof(position) !== "number") {
				position = this._parseTimeOrLabel(position, 0, true, value);
			}
			if (!(value instanceof Animation)) {
				if ((value instanceof Array) || (value && value.push && _isArray(value))) {
					align = align || "normal";
					stagger = stagger || 0;
					curTime = position;
					l = value.length;
					for (i = 0; i < l; i++) {
						if (_isArray(child = value[i])) {
							child = new TimelineLite({tweens:child});
						}
						this.add(child, curTime);
						if (typeof(child) !== "string" && typeof(child) !== "function") {
							if (align === "sequence") {
								curTime = child._startTime + (child.totalDuration() / child._timeScale);
							} else if (align === "start") {
								child._startTime -= child.delay();
							}
						}
						curTime += stagger;
					}
					return this._uncache(true);
				} else if (typeof(value) === "string") {
					return this.addLabel(value, position);
				} else if (typeof(value) === "function") {
					value = TweenLite.delayedCall(0, value);
				} else {
					throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
				}
			}

			SimpleTimeline.prototype.add.call(this, value, position);

			if (value._time) { //in case, for example, the _startTime is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
				value.render((this.rawTime() - value._startTime) * value._timeScale, false, false);
			}

			//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
			if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
				//in case any of the ancestors had completed but should now be enabled...
				tl = this;
				beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
				while (tl._timeline) {
					if (beforeRawTime && tl._timeline.smoothChildTiming) {
						tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
					} else if (tl._gc) {
						tl._enabled(true, false);
					}
					tl = tl._timeline;
				}
			}

			return this;
		};

		p.remove = function(value) {
			if (value instanceof Animation) {
				this._remove(value, false);
				var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
				value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
				return this;
			} else if (value instanceof Array || (value && value.push && _isArray(value))) {
				var i = value.length;
				while (--i > -1) {
					this.remove(value[i]);
				}
				return this;
			} else if (typeof(value) === "string") {
				return this.removeLabel(value);
			}
			return this.kill(null, value);
		};

		p._remove = function(tween, skipDisable) {
			SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
			var last = this._last;
			if (!last) {
				this._time = this._totalTime = this._duration = this._totalDuration = 0;
			} else if (this._time > this.duration()) {
				this._time = this._duration;
				this._totalTime = this._totalDuration;
			}
			return this;
		};

		p.append = function(value, offsetOrLabel) {
			return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
		};

		p.insert = p.insertMultiple = function(value, position, align, stagger) {
			return this.add(value, position || 0, align, stagger);
		};

		p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
			return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
		};

		p.addLabel = function(label, position) {
			this._labels[label] = this._parseTimeOrLabel(position);
			return this;
		};

		p.addPause = function(position, callback, params, scope) {
			var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
			t.vars.onComplete = t.vars.onReverseComplete = callback;
			t.data = "isPause";
			this._hasPause = true;
			return this.add(t, position);
		};

		p.removeLabel = function(label) {
			delete this._labels[label];
			return this;
		};

		p.getLabelTime = function(label) {
			return (this._labels[label] != null) ? this._labels[label] : -1;
		};

		p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
			var clippedDuration, i;
			//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
			if (ignore instanceof Animation && ignore.timeline === this) {
				this.remove(ignore);
			} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
				i = ignore.length;
				while (--i > -1) {
					if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
						this.remove(ignore[i]);
					}
				}
			}
			clippedDuration = (typeof(timeOrLabel) === "number" && !offsetOrLabel) ? 0 : (this.duration() > 99999999999) ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
			if (typeof(offsetOrLabel) === "string") {
				return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
			}
			offsetOrLabel = offsetOrLabel || 0;
			if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
				i = timeOrLabel.indexOf("=");
				if (i === -1) {
					if (this._labels[timeOrLabel] == null) {
						return appendIfAbsent ? (this._labels[timeOrLabel] = clippedDuration + offsetOrLabel) : offsetOrLabel;
					}
					return this._labels[timeOrLabel] + offsetOrLabel;
				}
				offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
				timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : clippedDuration;
			} else if (timeOrLabel == null) {
				timeOrLabel = clippedDuration;
			}
			return Number(timeOrLabel) + offsetOrLabel;
		};

		p.seek = function(position, suppressEvents) {
			return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
		};

		p.stop = function() {
			return this.paused(true);
		};

		p.gotoAndPlay = function(position, suppressEvents) {
			return this.play(position, suppressEvents);
		};

		p.gotoAndStop = function(position, suppressEvents) {
			return this.pause(position, suppressEvents);
		};

		p.render = function(time, suppressEvents, force) {
			if (this._gc) {
				this._enabled(true, false);
			}
			var prevTime = this._time,
				totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
				prevStart = this._startTime,
				prevTimeScale = this._timeScale,
				prevPaused = this._paused,
				tween, isComplete, next, callback, internalForce, pauseTween, curTime;
			if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
				time += this._time - prevTime;
			}
			if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = this._time = totalDur;
				if (!this._reversed) if (!this._hasPausedChild()) {
					isComplete = true;
					callback = "onComplete";
					internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
						internalForce = true;
						if (this._rawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
				}
				this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = 0;
				if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
						internalForce = isComplete = true;
						callback = "onReverseComplete";
					} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
						internalForce = true;
					}
					this._rawPrevTime = time;
				} else {
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
						tween = this._first;
						while (tween && tween._startTime === 0) {
							if (!tween._duration) {
								isComplete = false;
							}
							tween = tween._next;
						}
					}
					time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
					if (!this._initted) {
						internalForce = true;
					}
				}

			} else {

				if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
					if (time >= prevTime) {
						tween = this._first;
						while (tween && tween._startTime <= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
								pauseTween = tween;
							}
							tween = tween._next;
						}
					} else {
						tween = this._last;
						while (tween && tween._startTime >= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
								pauseTween = tween;
							}
							tween = tween._prev;
						}
					}
					if (pauseTween) {
						this._time = time = pauseTween._startTime;
						this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
					}
				}

				this._totalTime = this._time = this._rawPrevTime = time;
			}
			if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
				return;
			} else if (!this._initted) {
				this._initted = true;
			}

			if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
				this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
			}

			if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
				this._callback("onStart");
			}

			curTime = this._time;
			if (curTime >= prevTime) {
				tween = this._first;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			} else {
				tween = this._last;
				while (tween) {
					next = tween._prev; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
							while (pauseTween && pauseTween.endTime() > this._time) {
								pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
								pauseTween = pauseTween._prev;
							}
							pauseTween = null;
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			}

			if (this._onUpdate) if (!suppressEvents) {
				if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
					_lazyRender();
				}
				this._callback("onUpdate");
			}

			if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
				if (isComplete) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
			}
		};

		p._hasPausedChild = function() {
			var tween = this._first;
			while (tween) {
				if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
					return true;
				}
				tween = tween._next;
			}
			return false;
		};

		p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
			ignoreBeforeTime = ignoreBeforeTime || -9999999999;
			var a = [],
				tween = this._first,
				cnt = 0;
			while (tween) {
				if (tween._startTime < ignoreBeforeTime) {
					//do nothing
				} else if (tween instanceof TweenLite) {
					if (tweens !== false) {
						a[cnt++] = tween;
					}
				} else {
					if (timelines !== false) {
						a[cnt++] = tween;
					}
					if (nested !== false) {
						a = a.concat(tween.getChildren(true, tweens, timelines));
						cnt = a.length;
					}
				}
				tween = tween._next;
			}
			return a;
		};

		p.getTweensOf = function(target, nested) {
			var disabled = this._gc,
				a = [],
				cnt = 0,
				tweens, i;
			if (disabled) {
				this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
			}
			tweens = TweenLite.getTweensOf(target);
			i = tweens.length;
			while (--i > -1) {
				if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
					a[cnt++] = tweens[i];
				}
			}
			if (disabled) {
				this._enabled(false, true);
			}
			return a;
		};

		p.recent = function() {
			return this._recent;
		};

		p._contains = function(tween) {
			var tl = tween.timeline;
			while (tl) {
				if (tl === this) {
					return true;
				}
				tl = tl.timeline;
			}
			return false;
		};

		p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
			ignoreBeforeTime = ignoreBeforeTime || 0;
			var tween = this._first,
				labels = this._labels,
				p;
			while (tween) {
				if (tween._startTime >= ignoreBeforeTime) {
					tween._startTime += amount;
				}
				tween = tween._next;
			}
			if (adjustLabels) {
				for (p in labels) {
					if (labels[p] >= ignoreBeforeTime) {
						labels[p] += amount;
					}
				}
			}
			return this._uncache(true);
		};

		p._kill = function(vars, target) {
			if (!vars && !target) {
				return this._enabled(false, false);
			}
			var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
				i = tweens.length,
				changed = false;
			while (--i > -1) {
				if (tweens[i]._kill(vars, target)) {
					changed = true;
				}
			}
			return changed;
		};

		p.clear = function(labels) {
			var tweens = this.getChildren(false, true, true),
				i = tweens.length;
			this._time = this._totalTime = 0;
			while (--i > -1) {
				tweens[i]._enabled(false, false);
			}
			if (labels !== false) {
				this._labels = {};
			}
			return this._uncache(true);
		};

		p.invalidate = function() {
			var tween = this._first;
			while (tween) {
				tween.invalidate();
				tween = tween._next;
			}
			return Animation.prototype.invalidate.call(this);;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (enabled === this._gc) {
				var tween = this._first;
				while (tween) {
					tween._enabled(enabled, true);
					tween = tween._next;
				}
			}
			return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			this._forcingPlayhead = true;
			var val = Animation.prototype.totalTime.apply(this, arguments);
			this._forcingPlayhead = false;
			return val;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					this.totalDuration(); //just triggers recalculation
				}
				return this._duration;
			}
			if (this.duration() !== 0 && value !== 0) {
				this.timeScale(this._duration / value);
			}
			return this;
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					var max = 0,
						tween = this._last,
						prevStart = 999999999999,
						prev, end;
					while (tween) {
						prev = tween._prev; //record it here in case the tween changes position in the sequence...
						if (tween._dirty) {
							tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
						}
						if (tween._startTime > prevStart && this._sortChildren && !tween._paused && !this._calculatingDuration) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
							this._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
							this.add(tween, tween._startTime - tween._delay);
							this._calculatingDuration = 0;
						} else {
							prevStart = tween._startTime;
						}
						if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
							max -= tween._startTime;
							if (this._timeline.smoothChildTiming) {
								this._startTime += tween._startTime / this._timeScale;
								this._time -= tween._startTime;
								this._totalTime -= tween._startTime;
								this._rawPrevTime -= tween._startTime;
							}
							this.shiftChildren(-tween._startTime, false, -9999999999);
							prevStart = 0;
						}
						end = tween._startTime + (tween._totalDuration / tween._timeScale);
						if (end > max) {
							max = end;
						}
						tween = prev;
					}
					this._duration = this._totalDuration = max;
					this._dirty = false;
				}
				return this._totalDuration;
			}
			return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
		};

		p.paused = function(value) {
			if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
				var tween = this._first,
					time = this._time;
				while (tween) {
					if (tween._startTime === time && tween.data === "isPause") {
						tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
					}
					tween = tween._next;
				}
			}
			return Animation.prototype.paused.apply(this, arguments);
		};

		p.usesFrames = function() {
			var tl = this._timeline;
			while (tl._timeline) {
				tl = tl._timeline;
			}
			return (tl === Animation._rootFramesTimeline);
		};

		p.rawTime = function(wrapRepeats) {
			return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
		};

		return TimelineLite;

	}, true);








	
	
	
	
	
/*
 * ----------------------------------------------------------------
 * TimelineMax
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {

		var TimelineMax = function(vars) {
				TimelineLite.call(this, vars);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._cycle = 0;
				this._yoyo = (this.vars.yoyo === true);
				this._dirty = true;
			},
			_tinyNum = 0.0000000001,
			TweenLiteInternals = TweenLite._internals,
			_lazyTweens = TweenLiteInternals.lazyTweens,
			_lazyRender = TweenLiteInternals.lazyRender,
			_globals = _gsScope._gsDefine.globals,
			_easeNone = new Ease(null, null, 1, 0),
			p = TimelineMax.prototype = new TimelineLite();

		p.constructor = TimelineMax;
		p.kill()._gc = false;
		TimelineMax.version = "1.20.4";

		p.invalidate = function() {
			this._yoyo = (this.vars.yoyo === true);
			this._repeat = this.vars.repeat || 0;
			this._repeatDelay = this.vars.repeatDelay || 0;
			this._uncache(true);
			return TimelineLite.prototype.invalidate.call(this);
		};

		p.addCallback = function(callback, position, params, scope) {
			return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
		};

		p.removeCallback = function(callback, position) {
			if (callback) {
				if (position == null) {
					this._kill(null, callback);
				} else {
					var a = this.getTweensOf(callback, false),
						i = a.length,
						time = this._parseTimeOrLabel(position);
					while (--i > -1) {
						if (a[i]._startTime === time) {
							a[i]._enabled(false, false);
						}
					}
				}
			}
			return this;
		};

		p.removePause = function(position) {
			return this.removeCallback(TimelineLite._internals.pauseCallback, position);
		};

		p.tweenTo = function(position, vars) {
			vars = vars || {};
			var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false, lazy:false},
				Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
				duration, p, t;
			for (p in vars) {
				copy[p] = vars[p];
			}
			copy.time = this._parseTimeOrLabel(position);
			duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
			t = new Engine(this, duration, copy);
			copy.onStart = function() {
				t.target.paused(true);
				if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
					t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale ).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
				}
				if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
					vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
				}
			};
			return t;
		};

		p.tweenFromTo = function(fromPosition, toPosition, vars) {
			vars = vars || {};
			fromPosition = this._parseTimeOrLabel(fromPosition);
			vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
			vars.immediateRender = (vars.immediateRender !== false);
			var t = this.tweenTo(toPosition, vars);
			t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
			return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
		};

		p.render = function(time, suppressEvents, force) {
			if (this._gc) {
				this._enabled(true, false);
			}
			var prevTime = this._time,
				totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
				dur = this._duration,
				prevTotalTime = this._totalTime,
				prevStart = this._startTime,
				prevTimeScale = this._timeScale,
				prevRawPrevTime = this._rawPrevTime,
				prevPaused = this._paused,
				prevCycle = this._cycle,
				tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
			if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
				time += this._time - prevTime;
			}
			if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				if (!this._locked) {
					this._totalTime = totalDur;
					this._cycle = this._repeat;
				}
				if (!this._reversed) if (!this._hasPausedChild()) {
					isComplete = true;
					callback = "onComplete";
					internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
						internalForce = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
				}
				this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				if (this._yoyo && (this._cycle & 1) !== 0) {
					this._time = time = 0;
				} else {
					this._time = dur;
					time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
				}

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				if (!this._locked) {
					this._totalTime = this._cycle = 0;
				}
				this._time = 0;
				if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (this._timeline.autoRemoveChildren && this._reversed) {
						internalForce = isComplete = true;
						callback = "onReverseComplete";
					} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
						internalForce = true;
					}
					this._rawPrevTime = time;
				} else {
					this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
						tween = this._first;
						while (tween && tween._startTime === 0) {
							if (!tween._duration) {
								isComplete = false;
							}
							tween = tween._next;
						}
					}
					time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
					if (!this._initted) {
						internalForce = true;
					}
				}

			} else {
				if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
					internalForce = true;
				}
				this._time = this._rawPrevTime = time;
				if (!this._locked) {
					this._totalTime = time;
					if (this._repeat !== 0) {
						cycleDuration = dur + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = dur - this._time;
						}
						if (this._time > dur) {
							this._time = dur;
							time = dur + 0.0001; //to avoid occasional floating point rounding error
						} else if (this._time < 0) {
							this._time = time = 0;
						} else {
							time = this._time;
						}
					}
				}

				if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
					time = this._time;
					if (time >= prevTime || (this._repeat && prevCycle !== this._cycle)) {
						tween = this._first;
						while (tween && tween._startTime <= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
								pauseTween = tween;
							}
							tween = tween._next;
						}
					} else {
						tween = this._last;
						while (tween && tween._startTime >= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
								pauseTween = tween;
							}
							tween = tween._prev;
						}
					}
					if (pauseTween && pauseTween._startTime < dur) {
						this._time = time = pauseTween._startTime;
						this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
					}
				}

			}

			if (this._cycle !== prevCycle) if (!this._locked) {
				/*
				make sure children at the end/beginning of the timeline are rendered properly. If, for example,
				a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
				would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
				could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
				we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
				ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
				*/
				var backwards = (this._yoyo && (prevCycle & 1) !== 0),
					wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
					recTotalTime = this._totalTime,
					recCycle = this._cycle,
					recRawPrevTime = this._rawPrevTime,
					recTime = this._time;

				this._totalTime = prevCycle * dur;
				if (this._cycle < prevCycle) {
					backwards = !backwards;
				} else {
					this._totalTime += dur;
				}
				this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.

				this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
				this._cycle = prevCycle;
				this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
				prevTime = (backwards) ? 0 : dur;
				this.render(prevTime, suppressEvents, (dur === 0));
				if (!suppressEvents) if (!this._gc) {
					if (this.vars.onRepeat) {
						this._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
						this._locked = false;
						this._callback("onRepeat");
					}
				}
				if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
					return;
				}
				if (wrap) {
					this._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
					this._locked = true;
					prevTime = (backwards) ? dur + 0.0001 : -0.0001;
					this.render(prevTime, true, false);
				}
				this._locked = false;
				if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
					return;
				}
				this._time = recTime;
				this._totalTime = recTotalTime;
				this._cycle = recCycle;
				this._rawPrevTime = recRawPrevTime;
			}

			if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
				if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
					this._callback("onUpdate");
				}
				return;
			} else if (!this._initted) {
				this._initted = true;
			}

			if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
				this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
			}

			if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
				this._callback("onStart");
			}

			curTime = this._time;
			if (curTime >= prevTime) {
				tween = this._first;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			} else {
				tween = this._last;
				while (tween) {
					next = tween._prev; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
							while (pauseTween && pauseTween.endTime() > this._time) {
								pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
								pauseTween = pauseTween._prev;
							}
							pauseTween = null;
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			}

			if (this._onUpdate) if (!suppressEvents) {
				if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
					_lazyRender();
				}
				this._callback("onUpdate");
			}
			if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
				if (isComplete) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
			}
		};

		p.getActive = function(nested, tweens, timelines) {
			if (nested == null) {
				nested = true;
			}
			if (tweens == null) {
				tweens = true;
			}
			if (timelines == null) {
				timelines = false;
			}
			var a = [],
				all = this.getChildren(nested, tweens, timelines),
				cnt = 0,
				l = all.length,
				i, tween;
			for (i = 0; i < l; i++) {
				tween = all[i];
				if (tween.isActive()) {
					a[cnt++] = tween;
				}
			}
			return a;
		};


		p.getLabelAfter = function(time) {
			if (!time) if (time !== 0) { //faster than isNan()
				time = this._time;
			}
			var labels = this.getLabelsArray(),
				l = labels.length,
				i;
			for (i = 0; i < l; i++) {
				if (labels[i].time > time) {
					return labels[i].name;
				}
			}
			return null;
		};

		p.getLabelBefore = function(time) {
			if (time == null) {
				time = this._time;
			}
			var labels = this.getLabelsArray(),
				i = labels.length;
			while (--i > -1) {
				if (labels[i].time < time) {
					return labels[i].name;
				}
			}
			return null;
		};

		p.getLabelsArray = function() {
			var a = [],
				cnt = 0,
				p;
			for (p in this._labels) {
				a[cnt++] = {time:this._labels[p], name:p};
			}
			a.sort(function(a,b) {
				return a.time - b.time;
			});
			return a;
		};

		p.invalidate = function() {
			this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
			return TimelineLite.prototype.invalidate.call(this);
		};


//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------

		p.progress = function(value, suppressEvents) {
			return (!arguments.length) ? (this._time / this.duration()) || 0 : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
		};

		p.totalProgress = function(value, suppressEvents) {
			return (!arguments.length) ? (this._totalTime / this.totalDuration()) || 0 : this.totalTime( this.totalDuration() * value, suppressEvents);
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					TimelineLite.prototype.totalDuration.call(this); //just forces refresh
					//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
					this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
				}
				return this._totalDuration;
			}
			return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			if (value > this._duration) {
				value = this._duration;
			}
			if (this._yoyo && (this._cycle & 1) !== 0) {
				value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
			} else if (this._repeat !== 0) {
				value += this._cycle * (this._duration + this._repeatDelay);
			}
			return this.totalTime(value, suppressEvents);
		};

		p.repeat = function(value) {
			if (!arguments.length) {
				return this._repeat;
			}
			this._repeat = value;
			return this._uncache(true);
		};

		p.repeatDelay = function(value) {
			if (!arguments.length) {
				return this._repeatDelay;
			}
			this._repeatDelay = value;
			return this._uncache(true);
		};

		p.yoyo = function(value) {
			if (!arguments.length) {
				return this._yoyo;
			}
			this._yoyo = value;
			return this;
		};

		p.currentLabel = function(value) {
			if (!arguments.length) {
				return this.getLabelBefore(this._time + 0.00000001);
			}
			return this.seek(value, true);
		};

		return TimelineMax;

	}, true);
	




	
	
	
	
	

	
/*
 * ----------------------------------------------------------------
 * BezierPlugin
 * ----------------------------------------------------------------
 */
	(function() {

		var _RAD2DEG = 180 / Math.PI,
			_r1 = [],
			_r2 = [],
			_r3 = [],
			_corProps = {},
			_globals = _gsScope._gsDefine.globals,
			Segment = function(a, b, c, d) {
				if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
					c = d - (d - b) / 1000000;
				}
				if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
					b = a + (c - a) / 1000000;
				}
				this.a = a;
				this.b = b;
				this.c = c;
				this.d = d;
				this.da = d - a;
				this.ca = c - a;
				this.ba = b - a;
			},
			_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
			cubicToQuadratic = function(a, b, c, d) {
				var q1 = {a:a},
					q2 = {},
					q3 = {},
					q4 = {c:d},
					mab = (a + b) / 2,
					mbc = (b + c) / 2,
					mcd = (c + d) / 2,
					mabc = (mab + mbc) / 2,
					mbcd = (mbc + mcd) / 2,
					m8 = (mbcd - mabc) / 8;
				q1.b = mab + (a - mab) / 4;
				q2.b = mabc + m8;
				q1.c = q2.a = (q1.b + q2.b) / 2;
				q2.c = q3.a = (mabc + mbcd) / 2;
				q3.b = mbcd - m8;
				q4.b = mcd + (d - mcd) / 4;
				q3.c = q4.a = (q3.b + q4.b) / 2;
				return [q1, q2, q3, q4];
			},
			_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
				var l = a.length - 1,
					ii = 0,
					cp1 = a[0].a,
					i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
				for (i = 0; i < l; i++) {
					seg = a[ii];
					p1 = seg.a;
					p2 = seg.d;
					p3 = a[ii+1].d;

					if (correlate) {
						r1 = _r1[i];
						r2 = _r2[i];
						tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
						m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
						m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
						mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
					} else {
						m1 = p2 - (p2 - p1) * curviness * 0.5;
						m2 = p2 + (p3 - p2) * curviness * 0.5;
						mm = p2 - (m1 + m2) / 2;
					}
					m1 += mm;
					m2 += mm;

					seg.c = cp2 = m1;
					if (i !== 0) {
						seg.b = cp1;
					} else {
						seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
					}

					seg.da = p2 - p1;
					seg.ca = cp2 - p1;
					seg.ba = cp1 - p1;

					if (quad) {
						qb = cubicToQuadratic(p1, cp1, cp2, p2);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
						ii += 4;
					} else {
						ii++;
					}

					cp1 = m2;
				}
				seg = a[ii];
				seg.b = cp1;
				seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
				seg.da = seg.d - seg.a;
				seg.ca = seg.c - seg.a;
				seg.ba = cp1 - seg.a;
				if (quad) {
					qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
					a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
				}
			},
			_parseAnchors = function(values, p, correlate, prepend) {
				var a = [],
					l, i, p1, p2, p3, tmp;
				if (prepend) {
					values = [prepend].concat(values);
					i = values.length;
					while (--i > -1) {
						if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
							values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
						}
					}
				}
				l = values.length - 2;
				if (l < 0) {
					a[0] = new Segment(values[0][p], 0, 0, values[0][p]);
					return a;
				}
				for (i = 0; i < l; i++) {
					p1 = values[i][p];
					p2 = values[i+1][p];
					a[i] = new Segment(p1, 0, 0, p2);
					if (correlate) {
						p3 = values[i+2][p];
						_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
						_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
					}
				}
				a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
				return a;
			},
			bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
				var obj = {},
					props = [],
					first = prepend || values[0],
					i, p, a, j, r, l, seamless, last;
				correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
				if (curviness == null) {
					curviness = 1;
				}
				for (p in values[0]) {
					props.push(p);
				}
				//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
				if (values.length > 1) {
					last = values[values.length - 1];
					seamless = true;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
							seamless = false;
							break;
						}
					}
					if (seamless) {
						values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
						if (prepend) {
							values.unshift(prepend);
						}
						values.push(values[1]);
						prepend = values[values.length - 3];
					}
				}
				_r1.length = _r2.length = _r3.length = 0;
				i = props.length;
				while (--i > -1) {
					p = props[i];
					_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
					obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
				}
				i = _r1.length;
				while (--i > -1) {
					_r1[i] = Math.sqrt(_r1[i]);
					_r2[i] = Math.sqrt(_r2[i]);
				}
				if (!basic) {
					i = props.length;
					while (--i > -1) {
						if (_corProps[p]) {
							a = obj[props[i]];
							l = a.length - 1;
							for (j = 0; j < l; j++) {
								r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
								_r3[j] = (_r3[j] || 0) + r * r;
							}
						}
					}
					i = _r3.length;
					while (--i > -1) {
						_r3[i] = Math.sqrt(_r3[i]);
					}
				}
				i = props.length;
				j = quadratic ? 4 : 1;
				while (--i > -1) {
					p = props[i];
					a = obj[p];
					_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
					if (seamless) {
						a.splice(0, j);
						a.splice(a.length - j, j);
					}
				}
				return obj;
			},
			_parseBezierData = function(values, type, prepend) {
				type = type || "soft";
				var obj = {},
					inc = (type === "cubic") ? 3 : 2,
					soft = (type === "soft"),
					props = [],
					a, b, c, d, cur, i, j, l, p, cnt, tmp;
				if (soft && prepend) {
					values = [prepend].concat(values);
				}
				if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
				for (p in values[0]) {
					props.push(p);
				}
				i = props.length;
				while (--i > -1) {
					p = props[i];
					obj[p] = cur = [];
					cnt = 0;
					l = values.length;
					for (j = 0; j < l; j++) {
						a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
						if (soft) if (j > 1) if (j < l - 1) {
							cur[cnt++] = (a + cur[cnt-2]) / 2;
						}
						cur[cnt++] = a;
					}
					l = cnt - inc + 1;
					cnt = 0;
					for (j = 0; j < l; j += inc) {
						a = cur[j];
						b = cur[j+1];
						c = cur[j+2];
						d = (inc === 2) ? 0 : cur[j+3];
						cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
					}
					cur.length = cnt;
				}
				return obj;
			},
			_addCubicLengths = function(a, steps, resolution) {
				var inc = 1 / resolution,
					j = a.length,
					d, d1, s, da, ca, ba, p, i, inv, bez, index;
				while (--j > -1) {
					bez = a[j];
					s = bez.a;
					da = bez.d - s;
					ca = bez.c - s;
					ba = bez.b - s;
					d = d1 = 0;
					for (i = 1; i <= resolution; i++) {
						p = inc * i;
						inv = 1 - p;
						d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
						index = j * resolution + i - 1;
						steps[index] = (steps[index] || 0) + d * d;
					}
				}
			},
			_parseLengthData = function(obj, resolution) {
				resolution = resolution >> 0 || 6;
				var a = [],
					lengths = [],
					d = 0,
					total = 0,
					threshold = resolution - 1,
					segments = [],
					curLS = [], //current length segments array
					p, i, l, index;
				for (p in obj) {
					_addCubicLengths(obj[p], a, resolution);
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					d += Math.sqrt(a[i]);
					index = i % resolution;
					curLS[index] = d;
					if (index === threshold) {
						total += d;
						index = (i / resolution) >> 0;
						segments[index] = curLS;
						lengths[index] = total;
						d = 0;
						curLS = [];
					}
				}
				return {length:total, lengths:lengths, segments:segments};
			},



			BezierPlugin = _gsScope._gsDefine.plugin({
					propName: "bezier",
					priority: -1,
					version: "1.3.8",
					API: 2,
					global:true,

					//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, vars, tween) {
						this._target = target;
						if (vars instanceof Array) {
							vars = {values:vars};
						}
						this._func = {};
						this._mod = {};
						this._props = [];
						this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
						var values = vars.values || [],
							first = {},
							second = values[0],
							autoRotate = vars.autoRotate || tween.vars.orientToBezier,
							p, isFunc, i, j, prepend;

						this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
						for (p in second) {
							this._props.push(p);
						}

						i = this._props.length;
						while (--i > -1) {
							p = this._props[i];

							this._overwriteProps.push(p);
							isFunc = this._func[p] = (typeof(target[p]) === "function");
							first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
							if (!prepend) if (first[p] !== values[0][p]) {
								prepend = first;
							}
						}
						this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
						this._segCount = this._beziers[p].length;

						if (this._timeRes) {
							var ld = _parseLengthData(this._beziers, this._timeRes);
							this._length = ld.length;
							this._lengths = ld.lengths;
							this._segments = ld.segments;
							this._l1 = this._li = this._s1 = this._si = 0;
							this._l2 = this._lengths[0];
							this._curSeg = this._segments[0];
							this._s2 = this._curSeg[0];
							this._prec = 1 / this._curSeg.length;
						}

						if ((autoRotate = this._autoRotate)) {
							this._initialRotations = [];
							if (!(autoRotate[0] instanceof Array)) {
								this._autoRotate = autoRotate = [autoRotate];
							}
							i = autoRotate.length;
							while (--i > -1) {
								for (j = 0; j < 3; j++) {
									p = autoRotate[i][j];
									this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
								}
								p = autoRotate[i][2];
								this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
								this._overwriteProps.push(p);
							}
						}
						this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
						return true;
					},

					//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
					set: function(v) {
						var segments = this._segCount,
							func = this._func,
							target = this._target,
							notStart = (v !== this._startRatio),
							curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
						if (!this._timeRes) {
							curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
							t = (v - (curIndex * (1 / segments))) * segments;
						} else {
							lengths = this._lengths;
							curSeg = this._curSeg;
							v *= this._length;
							i = this._li;
							//find the appropriate segment (if the currently cached one isn't correct)
							if (v > this._l2 && i < segments - 1) {
								l = segments - 1;
								while (i < l && (this._l2 = lengths[++i]) <= v) {	}
								this._l1 = lengths[i-1];
								this._li = i;
								this._curSeg = curSeg = this._segments[i];
								this._s2 = curSeg[(this._s1 = this._si = 0)];
							} else if (v < this._l1 && i > 0) {
								while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
								if (i === 0 && v < this._l1) {
									this._l1 = 0;
								} else {
									i++;
								}
								this._l2 = lengths[i];
								this._li = i;
								this._curSeg = curSeg = this._segments[i];
								this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
								this._s2 = curSeg[this._si];
							}
							curIndex = i;
							//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
							v -= this._l1;
							i = this._si;
							if (v > this._s2 && i < curSeg.length - 1) {
								l = curSeg.length - 1;
								while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
								this._s1 = curSeg[i-1];
								this._si = i;
							} else if (v < this._s1 && i > 0) {
								while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
								if (i === 0 && v < this._s1) {
									this._s1 = 0;
								} else {
									i++;
								}
								this._s2 = curSeg[i];
								this._si = i;
							}
							t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
						}
						inv = 1 - t;

						i = this._props.length;
						while (--i > -1) {
							p = this._props[i];
							b = this._beziers[p][curIndex];
							val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
							if (this._mod[p]) {
								val = this._mod[p](val, target);
							}
							if (func[p]) {
								target[p](val);
							} else {
								target[p] = val;
							}
						}

						if (this._autoRotate) {
							var ar = this._autoRotate,
								b2, x1, y1, x2, y2, add, conv;
							i = ar.length;
							while (--i > -1) {
								p = ar[i][2];
								add = ar[i][3] || 0;
								conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
								b = this._beziers[ar[i][0]];
								b2 = this._beziers[ar[i][1]];

								if (b && b2) { //in case one of the properties got overwritten.
									b = b[curIndex];
									b2 = b2[curIndex];

									x1 = b.a + (b.b - b.a) * t;
									x2 = b.b + (b.c - b.b) * t;
									x1 += (x2 - x1) * t;
									x2 += ((b.c + (b.d - b.c) * t) - x2) * t;

									y1 = b2.a + (b2.b - b2.a) * t;
									y2 = b2.b + (b2.c - b2.b) * t;
									y1 += (y2 - y1) * t;
									y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;

									val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];

									if (this._mod[p]) {
										val = this._mod[p](val, target); //for modProps
									}

									if (func[p]) {
										target[p](val);
									} else {
										target[p] = val;
									}
								}
							}
						}
					}
			}),
			p = BezierPlugin.prototype;


		BezierPlugin.bezierThrough = bezierThrough;
		BezierPlugin.cubicToQuadratic = cubicToQuadratic;
		BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
		BezierPlugin.quadraticToCubic = function(a, b, c) {
			return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
		};

		BezierPlugin._cssRegister = function() {
			var CSSPlugin = _globals.CSSPlugin;
			if (!CSSPlugin) {
				return;
			}
			var _internals = CSSPlugin._internals,
				_parseToProxy = _internals._parseToProxy,
				_setPluginRatio = _internals._setPluginRatio,
				CSSPropTween = _internals.CSSPropTween;
			_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
				if (e instanceof Array) {
					e = {values:e};
				}
				plugin = new BezierPlugin();
				var values = e.values,
					l = values.length - 1,
					pluginValues = [],
					v = {},
					i, p, data;
				if (l < 0) {
					return pt;
				}
				for (i = 0; i <= l; i++) {
					data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
					pluginValues[i] = data.end;
				}
				for (p in e) {
					v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
				}
				v.values = pluginValues;
				pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
				pt.data = data;
				pt.plugin = plugin;
				pt.setRatio = _setPluginRatio;
				if (v.autoRotate === 0) {
					v.autoRotate = true;
				}
				if (v.autoRotate && !(v.autoRotate instanceof Array)) {
					i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
					v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
				}
				if (v.autoRotate) {
					if (!cssp._transform) {
						cssp._enableTransforms(false);
					}
					data.autoRotate = cssp._target._gsTransform;
					data.proxy.rotation = data.autoRotate.rotation || 0;
					cssp._overwriteProps.push("rotation");
				}
				plugin._onInitTween(data.proxy, v, cssp._tween);
				return pt;
			}});
		};

		p._mod = function(lookup) {
			var op = this._overwriteProps,
				i = op.length,
				val;
			while (--i > -1) {
				val = lookup[op[i]];
				if (val && typeof(val) === "function") {
					this._mod[op[i]] = val;
				}
			}
		};

		p._kill = function(lookup) {
			var a = this._props,
				p, i;
			for (p in this._beziers) {
				if (p in lookup) {
					delete this._beziers[p];
					delete this._func[p];
					i = a.length;
					while (--i > -1) {
						if (a[i] === p) {
							a.splice(i, 1);
						}
					}
				}
			}
			a = this._autoRotate;
			if (a) {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i][2]]) {
						a.splice(i, 1);
					}
				}
			}
			return this._super._kill.call(this, lookup);
		};

	}());






	
	
	
	
	
	
	
	
/*
 * ----------------------------------------------------------------
 * CSSPlugin
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {

		/** @constructor **/
		var CSSPlugin = function() {
				TweenPlugin.call(this, "css");
				this._overwriteProps.length = 0;
				this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
			},
			_globals = _gsScope._gsDefine.globals,
			_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
			_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
			_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
			_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
			_specialProps = {},
			p = CSSPlugin.prototype = new TweenPlugin("css");

		p.constructor = CSSPlugin;
		CSSPlugin.version = "1.20.5";
		CSSPlugin.API = 2;
		CSSPlugin.defaultTransformPerspective = 0;
		CSSPlugin.defaultSkewType = "compensated";
		CSSPlugin.defaultSmoothOrigin = true;
		p = "px"; //we'll reuse the "p" variable to keep file size down
		CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};


		var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
			_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
			_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
			_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
			_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
			_opacityExp = /opacity *= *([^)]*)/i,
			_opacityValExp = /opacity:([^;]*)/i,
			_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
			_rgbhslExp = /^(rgb|hsl)/,
			_capsExp = /([A-Z])/g,
			_camelExp = /-([a-z])/gi,
			_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
			_camelFunc = function(s, g) { return g.toUpperCase(); },
			_horizExp = /(?:Left|Right|Width)/i,
			_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
			_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
			_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
			_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
			_DEG2RAD = Math.PI / 180,
			_RAD2DEG = 180 / Math.PI,
			_forcePT = {},
			_dummyElement = {style:{}},
			_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
			_createElement = function(type, ns) {
				return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
			},
			_tempDiv = _createElement("div"),
			_tempImg = _createElement("img"),
			_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
			_agent = (_gsScope.navigator || {}).userAgent || "",
			_autoRound,
			_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).

			_isSafari,
			_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
			_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
			_ieVers,
			_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
				var i = _agent.indexOf("Android"),
					a = _createElement("a");
				_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
				_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
				_isFirefox = (_agent.indexOf("Firefox") !== -1);
				if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
					_ieVers = parseFloat( RegExp.$1 );
				}
				if (!a) {
					return false;
				}
				a.style.cssText = "top:1px;opacity:.55;";
				return /^0.55/.test(a.style.opacity);
			}()),
			_getIEOpacity = function(v) {
				return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
			},
			_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
				if (_gsScope.console) {
					console.log(s);
				}
			},
			_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
			_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params

			_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
			_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".

			// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
			_checkPropPrefix = function(p, e) {
				e = e || _tempDiv;
				var s = e.style,
					a, i;
				if (s[p] !== undefined) {
					return p;
				}
				p = p.charAt(0).toUpperCase() + p.substr(1);
				a = ["O","Moz","ms","Ms","Webkit"];
				i = 5;
				while (--i > -1 && s[a[i]+p] === undefined) { }
				if (i >= 0) {
					_prefix = (i === 3) ? "ms" : a[i];
					_prefixCSS = "-" + _prefix.toLowerCase() + "-";
					return _prefix + p;
				}
				return null;
			},

			_getComputedStyle = (typeof(window) !== "undefined" ? window : _doc.defaultView || {getComputedStyle:function() {}}).getComputedStyle,

			/**
			 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
			 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
			 *
			 * @param {!Object} t Target element whose style property you want to query
			 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
			 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
			 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
			 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
			 * @return {?string} The current property value
			 */
			_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
				var rv;
				if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
					return _getIEOpacity(t);
				}
				if (!calc && t.style[p]) {
					rv = t.style[p];
				} else if ((cs = cs || _getComputedStyle(t))) {
					rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
				} else if (t.currentStyle) {
					rv = t.currentStyle[p];
				}
				return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
			},

			/**
			 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
			 * @param {!Object} t Target element
			 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
			 * @param {!number} v Value
			 * @param {string=} sfx Suffix (like "px" or "%" or "em")
			 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
			 * @return {number} value in pixels
			 */
			_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
				if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
				if (sfx === "auto" || !v) { return 0; }
				var horiz = _horizExp.test(p),
					node = t,
					style = _tempDiv.style,
					neg = (v < 0),
					precise = (v === 1),
					pix, cache, time;
				if (neg) {
					v = -v;
				}
				if (precise) {
					v *= 100;
				}
				if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
					cache = _getComputedStyle(t).lineHeight;
					t.style.lineHeight = v;
					pix = parseFloat(_getComputedStyle(t).lineHeight);
					t.style.lineHeight = cache;
				} else if (sfx === "%" && p.indexOf("border") !== -1) {
					pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
				} else {
					style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
					if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
						node = t.parentNode || _doc.body;
						if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
							style.position = "absolute";
						}
						cache = node._gsCache;
						time = TweenLite.ticker.frame;
						if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
							return cache.width * v / 100;
						}
						style[(horiz ? "width" : "height")] = v + sfx;
					} else {
						style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
					}
					node.appendChild(_tempDiv);
					pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
					node.removeChild(_tempDiv);
					if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
						cache = node._gsCache = node._gsCache || {};
						cache.time = time;
						cache.width = pix / v * 100;
					}
					if (pix === 0 && !recurse) {
						pix = _convertToPixels(t, p, v, sfx, true);
					}
				}
				if (precise) {
					pix /= 100;
				}
				return neg ? -pix : pix;
			},
			_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
				if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
				var dim = ((p === "left") ? "Left" : "Top"),
					v = _getStyle(t, "margin" + dim, cs);
				return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
			},

			// @private returns at object containing ALL of the style properties in camelCase and their associated values.
			_getAllStyles = function(t, cs) {
				var s = {},
					i, tr, p;
				if ((cs = cs || _getComputedStyle(t, null))) {
					if ((i = cs.length)) {
						while (--i > -1) {
							p = cs[i];
							if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
								s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
							}
						}
					} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
						for (i in cs) {
							if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
								s[i] = cs[i];
							}
						}
					}
				} else if ((cs = t.currentStyle || t.style)) {
					for (i in cs) {
						if (typeof(i) === "string" && s[i] === undefined) {
							s[i.replace(_camelExp, _camelFunc)] = cs[i];
						}
					}
				}
				if (!_supportsOpacity) {
					s.opacity = _getIEOpacity(t);
				}
				tr = _getTransform(t, cs, false);
				s.rotation = tr.rotation;
				s.skewX = tr.skewX;
				s.scaleX = tr.scaleX;
				s.scaleY = tr.scaleY;
				s.x = tr.x;
				s.y = tr.y;
				if (_supports3D) {
					s.z = tr.z;
					s.rotationX = tr.rotationX;
					s.rotationY = tr.rotationY;
					s.scaleZ = tr.scaleZ;
				}
				if (s.filters) {
					delete s.filters;
				}
				return s;
			},

			// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
			_cssDif = function(t, s1, s2, vars, forceLookup) {
				var difs = {},
					style = t.style,
					val, p, mpt;
				for (p in s2) {
					if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
						difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
						if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
							mpt = new MiniPropTween(style, p, style[p], mpt);
						}
					}
				}
				if (vars) {
					for (p in vars) { //copy properties (except className)
						if (p !== "className") {
							difs[p] = vars[p];
						}
					}
				}
				return {difs:difs, firstMPT:mpt};
			},
			_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
			_margins = ["marginLeft","marginRight","marginTop","marginBottom"],

			/**
			 * @private Gets the width or height of an element
			 * @param {!Object} t Target element
			 * @param {!string} p Property name ("width" or "height")
			 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
			 * @return {number} Dimension (in pixels)
			 */
			_getDimension = function(t, p, cs) {
				if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
					return (cs || _getComputedStyle(t))[p] || 0;
				} else if (t.getCTM && _isSVG(t)) {
					return t.getBBox()[p] || 0;
				}
				var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
					a = _dimensions[p],
					i = a.length;
				cs = cs || _getComputedStyle(t, null);
				while (--i > -1) {
					v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
					v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
				}
				return v;
			},

			// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
			_parsePosition = function(v, recObj) {
				if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
					return v + " ";
				}
				if (v == null || v === "") {
					v = "0 0";
				}
				var a = v.split(" "),
					x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
					y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
					i;
				if (a.length > 3 && !recObj) { //multiple positions
					a = v.split(", ").join(",").split(",");
					v = [];
					for (i = 0; i < a.length; i++) {
						v.push(_parsePosition(a[i]));
					}
					return v.join(",");
				}
				if (y == null) {
					y = (x === "center") ? "50%" : "0";
				} else if (y === "center") {
					y = "50%";
				}
				if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
					x = "50%";
				}
				v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
				if (recObj) {
					recObj.oxp = (x.indexOf("%") !== -1);
					recObj.oyp = (y.indexOf("%") !== -1);
					recObj.oxr = (x.charAt(1) === "=");
					recObj.oyr = (y.charAt(1) === "=");
					recObj.ox = parseFloat(x.replace(_NaNExp, ""));
					recObj.oy = parseFloat(y.replace(_NaNExp, ""));
					recObj.v = v;
				}
				return recObj || v;
			},

			/**
			 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
			 * @param {(number|string)} e End value which is typically a string, but could be a number
			 * @param {(number|string)} b Beginning value which is typically a string but could be a number
			 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
			 */
			_parseChange = function(e, b) {
				if (typeof(e) === "function") {
					e = e(_index, _target);
				}
				return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
			},

			/**
			 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @return {number} Parsed value
			 */
			_parseVal = function(v, d) {
				if (typeof(v) === "function") {
					v = v(_index, _target);
				}
				return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
			},

			/**
			 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
			 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
			 * @return {number} parsed angle in radians
			 */
			_parseAngle = function(v, d, p, directionalEnd) {
				var min = 0.000001,
					cap, split, dif, result, isRelative;
				if (typeof(v) === "function") {
					v = v(_index, _target);
				}
				if (v == null) {
					result = d;
				} else if (typeof(v) === "number") {
					result = v;
				} else {
					cap = 360;
					split = v.split("_");
					isRelative = (v.charAt(1) === "=");
					dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
					if (split.length) {
						if (directionalEnd) {
							directionalEnd[p] = d + dif;
						}
						if (v.indexOf("short") !== -1) {
							dif = dif % cap;
							if (dif !== dif % (cap / 2)) {
								dif = (dif < 0) ? dif + cap : dif - cap;
							}
						}
						if (v.indexOf("_cw") !== -1 && dif < 0) {
							dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						} else if (v.indexOf("ccw") !== -1 && dif > 0) {
							dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						}
					}
					result = d + dif;
				}
				if (result < min && result > -min) {
					result = 0;
				}
				return result;
			},

			_colorLookup = {aqua:[0,255,255],
				lime:[0,255,0],
				silver:[192,192,192],
				black:[0,0,0],
				maroon:[128,0,0],
				teal:[0,128,128],
				blue:[0,0,255],
				navy:[0,0,128],
				white:[255,255,255],
				fuchsia:[255,0,255],
				olive:[128,128,0],
				yellow:[255,255,0],
				orange:[255,165,0],
				gray:[128,128,128],
				purple:[128,0,128],
				green:[0,128,0],
				red:[255,0,0],
				pink:[255,192,203],
				cyan:[0,255,255],
				transparent:[255,255,255,0]},

			_hue = function(h, m1, m2) {
				h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
				return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
			},

			/**
			 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
			 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
			 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
			 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
			 */
			_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
				var a, r, g, b, h, s, l, max, min, d, wasHSL;
				if (!v) {
					a = _colorLookup.black;
				} else if (typeof(v) === "number") {
					a = [v >> 16, (v >> 8) & 255, v & 255];
				} else {
					if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
						v = v.substr(0, v.length - 1);
					}
					if (_colorLookup[v]) {
						a = _colorLookup[v];
					} else if (v.charAt(0) === "#") {
						if (v.length === 4) { //for shorthand like #9F0
							r = v.charAt(1);
							g = v.charAt(2);
							b = v.charAt(3);
							v = "#" + r + r + g + g + b + b;
						}
						v = parseInt(v.substr(1), 16);
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else if (v.substr(0, 3) === "hsl") {
						a = wasHSL = v.match(_numExp);
						if (!toHSL) {
							h = (Number(a[0]) % 360) / 360;
							s = Number(a[1]) / 100;
							l = Number(a[2]) / 100;
							g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
							r = l * 2 - g;
							if (a.length > 3) {
								a[3] = Number(a[3]);
							}
							a[0] = _hue(h + 1 / 3, r, g);
							a[1] = _hue(h, r, g);
							a[2] = _hue(h - 1 / 3, r, g);
						} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
							return v.match(_relNumExp);
						}
					} else {
						a = v.match(_numExp) || _colorLookup.transparent;
					}
					a[0] = Number(a[0]);
					a[1] = Number(a[1]);
					a[2] = Number(a[2]);
					if (a.length > 3) {
						a[3] = Number(a[3]);
					}
				}
				if (toHSL && !wasHSL) {
					r = a[0] / 255;
					g = a[1] / 255;
					b = a[2] / 255;
					max = Math.max(r, g, b);
					min = Math.min(r, g, b);
					l = (max + min) / 2;
					if (max === min) {
						h = s = 0;
					} else {
						d = max - min;
						s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
						h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
						h *= 60;
					}
					a[0] = (h + 0.5) | 0;
					a[1] = (s * 100 + 0.5) | 0;
					a[2] = (l * 100 + 0.5) | 0;
				}
				return a;
			},
			_formatColors = function(s, toHSL) {
				var colors = s.match(_colorExp) || [],
					charIndex = 0,
					parsed = "",
					i, color, temp;
				if (!colors.length) {
					return s;
				}
				for (i = 0; i < colors.length; i++) {
					color = colors[i];
					temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
					charIndex += temp.length + color.length;
					color = _parseColor(color, toHSL);
					if (color.length === 3) {
						color.push(1);
					}
					parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
				}
				return parsed + s.substr(charIndex);
			},
			_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.

		for (p in _colorLookup) {
			_colorExp += "|" + p + "\\b";
		}
		_colorExp = new RegExp(_colorExp+")", "gi");

		CSSPlugin.colorStringFilter = function(a) {
			var combined = a[0] + " " + a[1],
				toHSL;
			if (_colorExp.test(combined)) {
				toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
				a[0] = _formatColors(a[0], toHSL);
				a[1] = _formatColors(a[1], toHSL);
			}
			_colorExp.lastIndex = 0;
		};

		if (!TweenLite.defaultStringFilter) {
			TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
		}

		/**
		 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
		 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
		 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
		 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
		 * @return {Function} formatter function
		 */
		var _getFormatter = function(dflt, clr, collapsible, multi) {
				if (dflt == null) {
					return function(v) {return v;};
				}
				var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
					dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
					pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
					sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
					delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
					numVals = dVals.length,
					dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
					formatter;
				if (!numVals) {
					return function(v) {return v;};
				}
				if (clr) {
					formatter = function(v) {
						var color, vals, i, a;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						color = (v.match(_colorExp) || [dColor])[0];
						vals = v.split(color).join("").match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
					};
					return formatter;

				}
				formatter = function(v) {
					var vals, a, i;
					if (typeof(v) === "number") {
						v += dSfx;
					} else if (multi && _commasOutsideParenExp.test(v)) {
						a = v.replace(_commasOutsideParenExp, "|").split("|");
						for (i = 0; i < a.length; i++) {
							a[i] = formatter(a[i]);
						}
						return a.join(",");
					}
					vals = v.match(_valuesExp) || [];
					i = vals.length;
					if (numVals > i--) {
						while (++i < numVals) {
							vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
						}
					}
					return pfx + vals.join(delim) + sfx;
				};
				return formatter;
			},

			/**
			 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
			 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
			 * @return {Function} a formatter function
			 */
			_getEdgeParser = function(props) {
				props = props.split(",");
				return function(t, e, p, cssp, pt, plugin, vars) {
					var a = (e + "").split(" "),
						i;
					vars = {};
					for (i = 0; i < 4; i++) {
						vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
					}
					return cssp.parse(t, vars, pt, plugin);
				};
			},

			// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
			_setPluginRatio = _internals._setPluginRatio = function(v) {
				this.plugin.setRatio(v);
				var d = this.data,
					proxy = d.proxy,
					mpt = d.firstMPT,
					min = 0.000001,
					val, pt, i, str, p;
				while (mpt) {
					val = proxy[mpt.v];
					if (mpt.r) {
						val = mpt.r(val);
					} else if (val < min && val > -min) {
						val = 0;
					}
					mpt.t[mpt.p] = val;
					mpt = mpt._next;
				}
				if (d.autoRotate) {
					d.autoRotate.rotation = d.mod ? d.mod.call(this._tween, proxy.rotation, this.t, this._tween) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
				}
				//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
				if (v === 1 || v === 0) {
					mpt = d.firstMPT;
					p = (v === 1) ? "e" : "b";
					while (mpt) {
						pt = mpt.t;
						if (!pt.type) {
							pt[p] = pt.s + pt.xs0;
						} else if (pt.type === 1) {
							str = pt.xs0 + pt.s + pt.xs1;
							for (i = 1; i < pt.l; i++) {
								str += pt["xn"+i] + pt["xs"+(i+1)];
							}
							pt[p] = str;
						}
						mpt = mpt._next;
					}
				}
			},

			/**
			 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
			 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
			 * @param {!string} p property name
			 * @param {(number|string|object)} v value
			 * @param {MiniPropTween=} next next MiniPropTween in the linked list
			 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
			 */
			MiniPropTween = function(t, p, v, next, r) {
				this.t = t;
				this.p = p;
				this.v = v;
				this.r = r;
				if (next) {
					next._prev = this;
					this._next = next;
				}
			},

			/**
			 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
			 * This method returns an object that has the following properties:
			 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
			 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
			 *  - firstMPT: the first MiniPropTween in the linked list
			 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
			 * @param {!Object} t target object to be tweened
			 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
			 * @param {!CSSPlugin} cssp The CSSPlugin instance
			 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
			 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
			 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
			 */
			_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
				var bpt = pt,
					start = {},
					end = {},
					transform = cssp._transform,
					oldForce = _forcePT,
					i, p, xp, mpt, firstPT;
				cssp._transform = null;
				_forcePT = vars;
				pt = firstPT = cssp.parse(t, vars, pt, plugin);
				_forcePT = oldForce;
				//break off from the linked list so the new ones are isolated.
				if (shallow) {
					cssp._transform = transform;
					if (bpt) {
						bpt._prev = null;
						if (bpt._prev) {
							bpt._prev._next = null;
						}
					}
				}
				while (pt && pt !== bpt) {
					if (pt.type <= 1) {
						p = pt.p;
						end[p] = pt.s + pt.c;
						start[p] = pt.s;
						if (!shallow) {
							mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
							pt.c = 0;
						}
						if (pt.type === 1) {
							i = pt.l;
							while (--i > 0) {
								xp = "xn" + i;
								p = pt.p + "_" + xp;
								end[p] = pt.data[xp];
								start[p] = pt[xp];
								if (!shallow) {
									mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
								}
							}
						}
					}
					pt = pt._next;
				}
				return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
			},



			/**
			 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
			 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
			 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
			 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
			 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
			 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
			 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
			 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
			 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
			 * @param {number} s Starting numeric value
			 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
			 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
			 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
			 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
			 * @param {boolean=} r If true, the value(s) should be rounded
			 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
			 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
			 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
			 */
			CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
				this.t = t; //target
				this.p = p; //property
				this.s = s; //starting value
				this.c = c; //change value
				this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
				if (!(t instanceof CSSPropTween)) {
					_overwriteProps.push(this.n);
				}
				this.r = !r ? r : (typeof(r) === "function") ? r : Math.round; //round (boolean)
				this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
				if (pr) {
					this.pr = pr;
					_hasPriority = true;
				}
				this.b = (b === undefined) ? s : b;
				this.e = (e === undefined) ? s + c : e;
				if (next) {
					this._next = next;
					next._prev = this;
				}
			},

			_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
				var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
				pt.b = start;
				pt.e = pt.xs0 = end;
				return pt;
			},

			/**
			 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
			 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
			 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
			 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
			 *
			 * @param {!Object} t Target whose property will be tweened
			 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
			 * @param {string} b Beginning value
			 * @param {string} e Ending value
			 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
			 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
			 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
			 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
			 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
			 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
			 */
			_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
				//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
				b = b || dflt || "";
				if (typeof(e) === "function") {
					e = e(_index, _target);
				}
				pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
				e += ""; //ensures it's a string
				if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
					e = [b, e];
					CSSPlugin.colorStringFilter(e);
					b = e[0];
					e = e[1];
				}
				var ba = b.split(", ").join(",").split(" "), //beginning array
					ea = e.split(", ").join(",").split(" "), //ending array
					l = ba.length,
					autoRound = (_autoRound !== false),
					i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
				if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
					if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
					} else {
						ba = ba.join(" ").split(",").join(", ").split(" ");
						ea = ea.join(" ").split(",").join(", ").split(" ");
					}
					l = ba.length;
				}
				if (l !== ea.length) {
					//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
					ba = (dflt || "").split(" ");
					l = ba.length;
				}
				pt.plugin = plugin;
				pt.setRatio = setRatio;
				_colorExp.lastIndex = 0;
				for (i = 0; i < l; i++) {
					bv = ba[i];
					ev = ea[i] + "";
					bn = parseFloat(bv);
					//if the value begins with a number (most common). It's fine if it has a suffix like px
					if (bn || bn === 0) {
						pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1) ? Math.round : false, true);

					//if the value is a color
					} else if (clrs && _colorExp.test(bv)) {
						str = ev.indexOf(")") + 1;
						str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
						useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
						temp = ev; //original string value so we can look for any prefix later.
						bv = _parseColor(bv, useHSL);
						ev = _parseColor(ev, useHSL);
						hasAlpha = (bv.length + ev.length > 6);
						if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
							pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
							pt.e = pt.e.split(ea[i]).join("transparent");
						} else {
							if (!_supportsOpacity) { //old versions of IE don't support rgba().
								hasAlpha = false;
							}
							if (useHSL) {
								pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
									.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
									.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
							} else {
								pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", Math.round, true)
									.appendXtra("", bv[1], ev[1] - bv[1], ",", Math.round)
									.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), Math.round);
							}

							if (hasAlpha) {
								bv = (bv.length < 4) ? 1 : bv[3];
								pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
							}
						}
						_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.

					} else {
						bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array

						//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
						if (!bnums) {
							pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;

						//loop through all the numbers that are found and construct the extra values on the pt.
						} else {
							enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
							if (!enums || enums.length !== bnums.length) {
								//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
								return pt;
							}
							ni = 0;
							for (xi = 0; xi < bnums.length; xi++) {
								cv = bnums[xi];
								temp = bv.indexOf(cv, ni);
								pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px") ? Math.round : false, (xi === 0));
								ni = temp + cv.length;
							}
							pt["xs" + pt.l] += bv.substr(ni);
						}
					}
				}
				//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
				if (e.indexOf("=") !== -1) if (pt.data) {
					str = pt.xs0 + pt.data.s;
					for (i = 1; i < pt.l; i++) {
						str += pt["xs" + i] + pt.data["xn" + i];
					}
					pt.e = str + pt["xs" + i];
				}
				if (!pt.l) {
					pt.type = -1;
					pt.xs0 = pt.e;
				}
				return pt.xfirst || pt;
			},
			i = 9;


		p = CSSPropTween.prototype;
		p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
		while (--i > 0) {
			p["xn" + i] = 0;
			p["xs" + i] = "";
		}
		p.xs0 = "";
		p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;


		/**
		 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
		 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
		 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
		 * @param {string=} pfx Prefix (if any)
		 * @param {!number} s Starting value
		 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
		 * @param {string=} sfx Suffix (if any)
		 * @param {boolean=} r Round (if true).
		 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
		 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
		 */
		p.appendXtra = function(pfx, s, c, sfx, r, pad) {
			var pt = this,
				l = pt.l;
			pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
			if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
				pt["xs" + l] += s + (sfx || "");
				return pt;
			}
			pt.l++;
			pt.type = pt.setRatio ? 2 : 1;
			pt["xs" + pt.l] = sfx || "";
			if (l > 0) {
				pt.data["xn" + l] = s + c;
				pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
				pt["xn" + l] = s;
				if (!pt.plugin) {
					pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
					pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
				}
				return pt;
			}
			pt.data = {s:s + c};
			pt.rxp = {};
			pt.s = s;
			pt.c = c;
			pt.r = r;
			return pt;
		};

		/**
		 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
		 * @param {!string} p Property name (like "boxShadow" or "throwProps")
		 * @param {Object=} options An object containing any of the following configuration options:
		 *                      - defaultValue: the default value
		 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
		 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
		 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
		 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
		 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
		 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
		 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
		 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
		 */
		var SpecialProp = function(p, options) {
				options = options || {};
				this.p = options.prefix ? _checkPropPrefix(p) || p : p;
				_specialProps[p] = _specialProps[this.p] = this;
				this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
				if (options.parser) {
					this.parse = options.parser;
				}
				this.clrs = options.color;
				this.multi = options.multi;
				this.keyword = options.keyword;
				this.dflt = options.defaultValue;
				this.pr = options.priority || 0;
			},

			//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
			_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
				if (typeof(options) !== "object") {
					options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
				}
				var a = p.split(","),
					d = options.defaultValue,
					i, temp;
				defaults = defaults || [d];
				for (i = 0; i < a.length; i++) {
					options.prefix = (i === 0 && options.prefix);
					options.defaultValue = defaults[i] || d;
					temp = new SpecialProp(a[i], options);
				}
			},

			//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
			_registerPluginProp = _internals._registerPluginProp = function(p) {
				if (!_specialProps[p]) {
					var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
					_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
						var pluginClass = _globals.com.greensock.plugins[pluginName];
						if (!pluginClass) {
							_log("Error: " + pluginName + " js file not loaded.");
							return pt;
						}
						pluginClass._cssRegister();
						return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
					}});
				}
			};


		p = SpecialProp.prototype;

		/**
		 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
		 * @param {!Object} t target element
		 * @param {(string|number|object)} b beginning value
		 * @param {(string|number|object)} e ending (destination) value
		 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
		 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
		 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
		 * @return {CSSPropTween=} First CSSPropTween in the linked list
		 */
		p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
			var kwd = this.keyword,
				i, ba, ea, l, bi, ei;
			//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
			if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
				ba = b.replace(_commasOutsideParenExp, "|").split("|");
				ea = e.replace(_commasOutsideParenExp, "|").split("|");
			} else if (kwd) {
				ba = [b];
				ea = [e];
			}
			if (ea) {
				l = (ea.length > ba.length) ? ea.length : ba.length;
				for (i = 0; i < l; i++) {
					b = ba[i] = ba[i] || this.dflt;
					e = ea[i] = ea[i] || this.dflt;
					if (kwd) {
						bi = b.indexOf(kwd);
						ei = e.indexOf(kwd);
						if (bi !== ei) {
							if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
								ba[i] = ba[i].split(kwd).join("");
							} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
								ba[i] += " " + kwd;
							}
						}
					}
				}
				b = ba.join(", ");
				e = ea.join(", ");
			}
			return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
		};

		/**
		 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
		 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
		 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
		 * @param {!Object} t Target object whose property is being tweened
		 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
		 * @param {!string} p Property name
		 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
		 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
		 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
		 * @param {Object=} vars Original vars object that contains the data for parsing.
		 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
		 */
		p.parse = function(t, e, p, cssp, pt, plugin, vars) {
			return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
		};

		/**
		 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
		 *  1) Target object whose property should be tweened (typically a DOM element)
		 *  2) The end/destination value (could be a string, number, object, or whatever you want)
		 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
		 *
		 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
		 *
		 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
		 *      var start = target.style.width;
		 *      return function(ratio) {
		 *              target.style.width = (start + value * ratio) + "px";
		 *              console.log("set width to " + target.style.width);
		 *          }
		 * }, 0);
		 *
		 * Then, when I do this tween, it will trigger my special property:
		 *
		 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
		 *
		 * In the example, of course, we're just changing the width, but you can do anything you want.
		 *
		 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
		 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
		 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
		 */
		CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
			_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
				rv.plugin = plugin;
				rv.setRatio = onInitTween(t, e, cssp._tween, p);
				return rv;
			}, priority:priority});
		};






		//transform-related methods and properties
		CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
		var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
			_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
			_transformPropCSS = _prefixCSS + "transform",
			_transformOriginProp = _checkPropPrefix("transformOrigin"),
			_supports3D = (_checkPropPrefix("perspective") !== null),
			Transform = _internals.Transform = function() {
				this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
				this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
			},
			_SVGElement = _gsScope.SVGElement,
			_useSVGTransformAttr,
			//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.

			_createSVG = function(type, container, attributes) {
				var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
					reg = /([a-z])([A-Z])/g,
					p;
				for (p in attributes) {
					element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
				}
				container.appendChild(element);
				return element;
			},
			_docElement = _doc.documentElement || {},
			_forceSVGTransformAttr = (function() {
				//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
				var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
					svg, rect, width;
				if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
					svg = _createSVG("svg", _docElement);
					rect = _createSVG("rect", svg, {width:100, height:50, x:100});
					width = rect.getBoundingClientRect().width;
					rect.style[_transformOriginProp] = "50% 50%";
					rect.style[_transformProp] = "scaleX(0.5)";
					force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
					_docElement.removeChild(svg);
				}
				return force;
			})(),
			_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
				var tm = e._gsTransform,
					m = _getMatrix(e, true),
					v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
				if (tm) {
					xOriginOld = tm.xOrigin; //record the original values before we alter them.
					yOriginOld = tm.yOrigin;
				}
				if (!absolute || (v = absolute.split(" ")).length < 2) {
					b = e.getBBox();
					if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
						b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
					}
					local = _parsePosition(local).split(" ");
					v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
						 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
				}
				decoratee.xOrigin = xOrigin = parseFloat(v[0]);
				decoratee.yOrigin = yOrigin = parseFloat(v[1]);
				if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
					a = m[0];
					b = m[1];
					c = m[2];
					d = m[3];
					tx = m[4];
					ty = m[5];
					determinant = (a * d - b * c);
					if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
						x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
						y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
						xOrigin = decoratee.xOrigin = v[0] = x;
						yOrigin = decoratee.yOrigin = v[1] = y;
					}
				}
				if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
					if (skipRecord) {
						decoratee.xOffset = tm.xOffset;
						decoratee.yOffset = tm.yOffset;
						tm = decoratee;
					}
					if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
						x = xOrigin - xOriginOld;
						y = yOrigin - yOriginOld;
						//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
						//tm.x -= x - (x * m[0] + y * m[2]);
						//tm.y -= y - (x * m[1] + y * m[3]);
						tm.xOffset += (x * m[0] + y * m[2]) - x;
						tm.yOffset += (x * m[1] + y * m[3]) - y;
					} else {
						tm.xOffset = tm.yOffset = 0;
					}
				}
				if (!skipRecord) {
					e.setAttribute("data-svg-origin", v.join(" "));
				}
			},
			_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
				var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
					oldParent = this.parentNode,
					oldSibling = this.nextSibling,
					oldCSS = this.style.cssText,
					bbox;
				_docElement.appendChild(svg);
				svg.appendChild(this);
				this.style.display = "block";
				if (swapIfPossible) {
					try {
						bbox = this.getBBox();
						this._originalGetBBox = this.getBBox;
						this.getBBox = _getBBoxHack;
					} catch (e) { }
				} else if (this._originalGetBBox) {
					bbox = this._originalGetBBox();
				}
				if (oldSibling) {
					oldParent.insertBefore(this, oldSibling);
				} else {
					oldParent.appendChild(this);
				}
				_docElement.removeChild(svg);
				this.style.cssText = oldCSS;
				return bbox;
			},
			_getBBox = function(e) {
				try {
					return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
				} catch (error) {
					return _getBBoxHack.call(e, true);
				}
			},
			_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
				return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
			},
			_identity2DMatrix = [1,0,0,1,0,0],
			_getMatrix = function(e, force2D) {
				var tm = e._gsTransform || new Transform(),
					rnd = 100000,
					style = e.style,
					isDefault, s, m, n, dec, none;
				if (_transformProp) {
					s = _getStyle(e, _transformPropCSS, null, true);
				} else if (e.currentStyle) {
					//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
					s = e.currentStyle.filter.match(_ieGetMatrixExp);
					s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
				}
				isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
				if (_transformProp && ((none = (!_getComputedStyle(e) || _getComputedStyle(e).display === "none")) || !e.parentNode)) { //note: Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
					if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
						n = style.display;
						style.display = "block";
					}
					if (!e.parentNode) {
						dec = 1; //flag
						_docElement.appendChild(e);
					}
					s = _getStyle(e, _transformPropCSS, null, true);
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (n) {
						style.display = n;
					} else if (none) {
						_removeProp(style, "display");
					}
					if (dec) {
						_docElement.removeChild(e);
					}
				}
				if (tm.svg || (e.getCTM && _isSVG(e))) {
					if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
						s = style[_transformProp];
						isDefault = 0;
					}
					m = e.getAttribute("transform");
					if (isDefault && m) {
						m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
						s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
						isDefault = 0;
					}
				}
				if (isDefault) {
					return _identity2DMatrix;
				}
				//split the matrix values out into an array (m for matrix)
				m = (s || "").match(_numExp) || [];
				i = m.length;
				while (--i > -1) {
					n = Number(m[i]);
					m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
				}
				return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
			},

			/**
			 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
			 * @param {!Object} t target element
			 * @param {Object=} cs computed style object (optional)
			 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
			 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
			 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
			 */
			_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
				if (t._gsTransform && rec && !parse) {
					return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
				}
				var tm = rec ? t._gsTransform || new Transform() : new Transform(),
					invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
					min = 0.00002,
					rnd = 100000,
					zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
					defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
					m, i, scaleX, scaleY, rotation, skewX;

				tm.svg = !!(t.getCTM && _isSVG(t));
				if (tm.svg) {
					_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
					_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
				}
				m = _getMatrix(t);
				if (m !== _identity2DMatrix) {

					if (m.length === 16) {
						//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
						var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
							a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
							a13 = m[8], a23 = m[9], a33 = m[10],
							a14 = m[12], a24 = m[13], a34 = m[14],
							a43 = m[11],
							angle = Math.atan2(a32, a33),
							t1, t2, t3, t4, cos, sin;
						//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
						if (tm.zOrigin) {
							a34 = -tm.zOrigin;
							a14 = a13*a34-m[12];
							a24 = a23*a34-m[13];
							a34 = a33*a34+tm.zOrigin-m[14];
						}
						//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
						tm.rotationX = angle * _RAD2DEG;
						//rotationX
						if (angle) {
							cos = Math.cos(-angle);
							sin = Math.sin(-angle);
							t1 = a12*cos+a13*sin;
							t2 = a22*cos+a23*sin;
							t3 = a32*cos+a33*sin;
							a13 = a12*-sin+a13*cos;
							a23 = a22*-sin+a23*cos;
							a33 = a32*-sin+a33*cos;
							a43 = a42*-sin+a43*cos;
							a12 = t1;
							a22 = t2;
							a32 = t3;
						}
						//rotationY
						angle = Math.atan2(-a31, a33);
						tm.rotationY = angle * _RAD2DEG;
						if (angle) {
							cos = Math.cos(-angle);
							sin = Math.sin(-angle);
							t1 = a11*cos-a13*sin;
							t2 = a21*cos-a23*sin;
							t3 = a31*cos-a33*sin;
							a23 = a21*sin+a23*cos;
							a33 = a31*sin+a33*cos;
							a43 = a41*sin+a43*cos;
							a11 = t1;
							a21 = t2;
							a31 = t3;
						}
						//rotationZ
						angle = Math.atan2(a21, a11);
						tm.rotation = angle * _RAD2DEG;
						if (angle) {
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							t1 = a11*cos+a21*sin;
							t2 = a12*cos+a22*sin;
							t3 = a13*cos+a23*sin;
							a21 = a21*cos-a11*sin;
							a22 = a22*cos-a12*sin;
							a23 = a23*cos-a13*sin;
							a11 = t1;
							a12 = t2;
							a13 = t3;
						}

						if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
							tm.rotationX = tm.rotation = 0;
							tm.rotationY = 180 - tm.rotationY;
						}

						//skewX
						angle = Math.atan2(a12, a22);

						//scales
						tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
						tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
						tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
						a11 /= tm.scaleX;
						a12 /= tm.scaleY;
						a21 /= tm.scaleX;
						a22 /= tm.scaleY;
						if (Math.abs(angle) > min) {
							tm.skewX = angle * _RAD2DEG;
							a12 = 0; //unskews
							if (tm.skewType !== "simple") {
								tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
							}

						} else {
							tm.skewX = 0;
						}

						/* //for testing purposes
						var transform = "matrix3d(",
							comma = ",",
							zero = "0";
						a13 /= tm.scaleZ;
						a23 /= tm.scaleZ;
						a31 /= tm.scaleX;
						a32 /= tm.scaleY;
						a33 /= tm.scaleZ;
						transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
						transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
						transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
						console.log(transform);
						document.querySelector(".test").style[_transformProp] = transform;
						*/

						tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
						tm.x = a14;
						tm.y = a24;
						tm.z = a34;
						if (tm.svg) {
							tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
							tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
						}

					} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
						var k = (m.length >= 6),
							a = k ? m[0] : 1,
							b = m[1] || 0,
							c = m[2] || 0,
							d = k ? m[3] : 1;
						tm.x = m[4] || 0;
						tm.y = m[5] || 0;
						scaleX = Math.sqrt(a * a + b * b);
						scaleY = Math.sqrt(d * d + c * c);
						rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
						skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
						tm.scaleX = scaleX;
						tm.scaleY = scaleY;
						tm.rotation = rotation;
						tm.skewX = skewX;
						if (_supports3D) {
							tm.rotationX = tm.rotationY = tm.z = 0;
							tm.perspective = defaultTransformPerspective;
							tm.scaleZ = 1;
						}
						if (tm.svg) {
							tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
							tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
						}
					}
					if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
						if (invX) {
							tm.scaleX *= -1;
							tm.skewX += (tm.rotation <= 0) ? 180 : -180;
							tm.rotation += (tm.rotation <= 0) ? 180 : -180;
						} else {
							tm.scaleY *= -1;
							tm.skewX += (tm.skewX <= 0) ? 180 : -180;
						}
					}
					tm.zOrigin = zOrigin;
					//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
					for (i in tm) {
						if (tm[i] < min) if (tm[i] > -min) {
							tm[i] = 0;
						}
					}
				}
				//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
				if (rec) {
					t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
					if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
						if (_useSVGTransformAttr && t.style[_transformProp]) {
							TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
								_removeProp(t.style, _transformProp);
							});
						} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
							TweenLite.delayedCall(0.001, function(){
								t.removeAttribute("transform");
							});
						}
					}
				}
				return tm;
			},

			//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
			_setIETransformRatio = function(v) {
				var t = this.data, //refers to the element's _gsTransform object
					ang = -t.rotation * _DEG2RAD,
					skew = ang + t.skewX * _DEG2RAD,
					rnd = 100000,
					a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
					b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
					c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
					d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
					style = this.t.style,
					cs = this.t.currentStyle,
					filters, val;
				if (!cs) {
					return;
				}
				val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
				b = -c;
				c = -val;
				filters = cs.filter;
				style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
				var w = this.t.offsetWidth,
					h = this.t.offsetHeight,
					clip = (cs.position !== "absolute"),
					m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
					ox = t.x + (w * t.xPercent / 100),
					oy = t.y + (h * t.yPercent / 100),
					dx, dy;

				//if transformOrigin is being used, adjust the offset x and y
				if (t.ox != null) {
					dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
					dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
					ox += dx - (dx * a + dy * b);
					oy += dy - (dx * c + dy * d);
				}

				if (!clip) {
					m += ", sizingMethod='auto expand')";
				} else {
					dx = (w / 2);
					dy = (h / 2);
					//translate to ensure that transformations occur around the correct origin (default is center).
					m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
				}
				if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
					style.filter = filters.replace(_ieSetMatrixExp, m);
				} else {
					style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
				}

				//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
				if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
					style.removeAttribute("filter");
				}

				//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
				if (!clip) {
					var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
						marg, prop, dif;
					dx = t.ieOffsetX || 0;
					dy = t.ieOffsetY || 0;
					t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
					t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
					for (i = 0; i < 4; i++) {
						prop = _margins[i];
						marg = cs[prop];
						//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
						val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
						if (val !== t[prop]) {
							dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
						} else {
							dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
						}
						style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
					}
				}
			},

			/* translates a super small decimal to a string WITHOUT scientific notation
			_safeDecimal = function(n) {
				var s = (n < 0 ? -n : n) + "",
					a = s.split("e-");
				return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
			},
			*/

			_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
				var t = this.data, //refers to the element's _gsTransform object
					style = this.t.style,
					angle = t.rotation,
					rotationX = t.rotationX,
					rotationY = t.rotationY,
					sx = t.scaleX,
					sy = t.scaleY,
					sz = t.scaleZ,
					x = t.x,
					y = t.y,
					z = t.z,
					isSVG = t.svg,
					perspective = t.perspective,
					force3D = t.force3D,
					skewY = t.skewY,
					skewX = t.skewX,
					t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
					zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
				if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
					skewX += skewY;
					angle += skewY;
				}

				//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
				if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.

					//2D
					if (angle || skewX || isSVG) {
						angle *= _DEG2RAD;
						skew = skewX * _DEG2RAD;
						rnd = 100000;
						a11 = Math.cos(angle) * sx;
						a21 = Math.sin(angle) * sx;
						a12 = Math.sin(angle - skew) * -sy;
						a22 = Math.cos(angle - skew) * sy;
						if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
							t1 = Math.tan(skew - skewY * _DEG2RAD);
							t1 = Math.sqrt(1 + t1 * t1);
							a12 *= t1;
							a22 *= t1;
							if (skewY) {
								t1 = Math.tan(skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a11 *= t1;
								a21 *= t1;
							}
						}
						if (isSVG) {
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
							if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
								min = this.t.getBBox();
								x += t.xPercent * 0.01 * min.width;
								y += t.yPercent * 0.01 * min.height;
							}
							min = 0.000001;
							if (x < min) if (x > -min) {
								x = 0;
							}
							if (y < min) if (y > -min) {
								y = 0;
							}
						}
						transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
						if (isSVG && _useSVGTransformAttr) {
							this.t.setAttribute("transform", "matrix(" + transform);
						} else {
							//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
						}
					} else {
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
					}
					return;

				}
				if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
					min = 0.0001;
					if (sx < min && sx > -min) {
						sx = sz = 0.00002;
					}
					if (sy < min && sy > -min) {
						sy = sz = 0.00002;
					}
					if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
						perspective = 0;
					}
				}
				if (angle || skewX) {
					angle *= _DEG2RAD;
					cos = a11 = Math.cos(angle);
					sin = a21 = Math.sin(angle);
					if (skewX) {
						angle -= skewX * _DEG2RAD;
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
							t1 = Math.tan((skewX - skewY) * _DEG2RAD);
							t1 = Math.sqrt(1 + t1 * t1);
							cos *= t1;
							sin *= t1;
							if (t.skewY) {
								t1 = Math.tan(skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a11 *= t1;
								a21 *= t1;
							}
						}
					}
					a12 = -sin;
					a22 = cos;

				} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
					style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
					return;
				} else {
					a11 = a22 = 1;
					a12 = a21 = 0;
				}
				// KEY  INDEX   AFFECTS a[row][column]
				// a11  0       rotation, rotationY, scaleX
				// a21  1       rotation, rotationY, scaleX
				// a31  2       rotationY, scaleX
				// a41  3       rotationY, scaleX
				// a12  4       rotation, skewX, rotationX, scaleY
				// a22  5       rotation, skewX, rotationX, scaleY
				// a32  6       rotationX, scaleY
				// a42  7       rotationX, scaleY
				// a13  8       rotationY, rotationX, scaleZ
				// a23  9       rotationY, rotationX, scaleZ
				// a33  10      rotationY, rotationX, scaleZ
				// a43  11      rotationY, rotationX, perspective, scaleZ
				// a14  12      x, zOrigin, svgOrigin
				// a24  13      y, zOrigin, svgOrigin
				// a34  14      z, zOrigin
				// a44  15
				// rotation: Math.atan2(a21, a11)
				// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
				// rotationX: Math.atan2(a32, a33)
				a33 = 1;
				a13 = a23 = a31 = a32 = a41 = a42 = 0;
				a43 = (perspective) ? -1 / perspective : 0;
				zOrigin = t.zOrigin;
				min = 0.000001; //threshold below which browsers use scientific notation which won't work.
				comma = ",";
				zero = "0";
				angle = rotationY * _DEG2RAD;
				if (angle) {
					cos = Math.cos(angle);
					sin = Math.sin(angle);
					a31 = -sin;
					a41 = a43*-sin;
					a13 = a11*sin;
					a23 = a21*sin;
					a33 = cos;
					a43 *= cos;
					a11 *= cos;
					a21 *= cos;
				}
				angle = rotationX * _DEG2RAD;
				if (angle) {
					cos = Math.cos(angle);
					sin = Math.sin(angle);
					t1 = a12*cos+a13*sin;
					t2 = a22*cos+a23*sin;
					a32 = a33*sin;
					a42 = a43*sin;
					a13 = a12*-sin+a13*cos;
					a23 = a22*-sin+a23*cos;
					a33 = a33*cos;
					a43 = a43*cos;
					a12 = t1;
					a22 = t2;
				}
				if (sz !== 1) {
					a13*=sz;
					a23*=sz;
					a33*=sz;
					a43*=sz;
				}
				if (sy !== 1) {
					a12*=sy;
					a22*=sy;
					a32*=sy;
					a42*=sy;
				}
				if (sx !== 1) {
					a11*=sx;
					a21*=sx;
					a31*=sx;
					a41*=sx;
				}

				if (zOrigin || isSVG) {
					if (zOrigin) {
						x += a13*-zOrigin;
						y += a23*-zOrigin;
						z += a33*-zOrigin+zOrigin;
					}
					if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
						x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
						y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
					}
					if (x < min && x > -min) {
						x = zero;
					}
					if (y < min && y > -min) {
						y = zero;
					}
					if (z < min && z > -min) {
						z = 0; //don't use string because we calculate perspective later and need the number.
					}
				}

				//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
				transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
				transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
				transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
				if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
					transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
					transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
				} else {
					transform += ",0,0,0,0,1,0,";
				}
				transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";

				style[_transformProp] = transform;
			};

		p = Transform.prototype;
		p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
		p.scaleX = p.scaleY = p.scaleZ = 1;

		_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
			if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
			cssp._lastParsedTransform = vars;
			var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
				swapFunc;
			if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
				swapFunc = vars[parsingProp];
				vars[parsingProp] = e;
			}
			if (scaleFunc) {
				vars.scale = scaleFunc(_index, t);
			}
			var originalGSTransform = t._gsTransform,
				style = t.style,
				min = 0.000001,
				i = _transformProps.length,
				v = vars,
				endRotations = {},
				transformOriginString = "transformOrigin",
				m1 = _getTransform(t, _cs, true, v.parseTransform),
				orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
				m2, copy, has3D, hasChange, dr, x, y, matrix, p;
			m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
			cssp._transform = m1;
			if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
				copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
				copy[_transformProp] = orig;
				copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
				copy.position = "absolute";
				if (orig.indexOf("%") !== -1) { //%-based translations will fail unless we set the width/height to match the original target...
					copy.width = _getStyle(t, "width");
					copy.height = _getStyle(t, "height");
				}
				_doc.body.appendChild(_tempDiv);
				m2 = _getTransform(_tempDiv, null, false);
				if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
					m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
				}
				if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
					x = m1.xOrigin;
					y = m1.yOrigin;
					m2.x -= m1.xOffset;
					m2.y -= m1.yOffset;
					if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
						orig = {};
						_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
						x = orig.xOrigin;
						y = orig.yOrigin;
						m2.x -= orig.xOffset - m1.xOffset;
						m2.y -= orig.yOffset - m1.yOffset;
					}
					if (x || y) {
						matrix = _getMatrix(_tempDiv, true);
						m2.x -= x - (x * matrix[0] + y * matrix[2]);
						m2.y -= y - (x * matrix[1] + y * matrix[3]);
					}
				}
				_doc.body.removeChild(_tempDiv);
				if (!m2.perspective) {
					m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
				}
				if (v.xPercent != null) {
					m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
				}
				if (v.yPercent != null) {
					m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
				}
			} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
				m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
					scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
					scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
					x:_parseVal(v.x, m1.x),
					y:_parseVal(v.y, m1.y),
					z:_parseVal(v.z, m1.z),
					xPercent:_parseVal(v.xPercent, m1.xPercent),
					yPercent:_parseVal(v.yPercent, m1.yPercent),
					perspective:_parseVal(v.transformPerspective, m1.perspective)};
				dr = v.directionalRotation;
				if (dr != null) {
					if (typeof(dr) === "object") {
						for (copy in dr) {
							v[copy] = dr[copy];
						}
					} else {
						v.rotation = dr;
					}
				}
				if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
					m2.x = 0;
					m2.xPercent = _parseVal(v.x, m1.xPercent);
				}
				if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
					m2.y = 0;
					m2.yPercent = _parseVal(v.y, m1.yPercent);
				}

				m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
				if (_supports3D) {
					m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
					m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
				}
				m2.skewX = _parseAngle(v.skewX, m1.skewX);
				m2.skewY = _parseAngle(v.skewY, m1.skewY);
			}
			if (_supports3D && v.force3D != null) {
				m1.force3D = v.force3D;
				hasChange = true;
			}

			has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
			if (!has3D && v.scale != null) {
				m2.scaleZ = 1; //no need to tween scaleZ.
			}

			while (--i > -1) {
				p = _transformProps[i];
				orig = m2[p] - m1[p];
				if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
					hasChange = true;
					pt = new CSSPropTween(m1, p, m1[p], orig, pt);
					if (p in endRotations) {
						pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
					}
					pt.xs0 = 0; //ensures the value stays numeric in setRatio()
					pt.plugin = plugin;
					cssp._overwriteProps.push(pt.n);
				}
			}

			orig = v.transformOrigin;
			if (m1.svg && (orig || v.svgOrigin)) {
				x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
				y = m1.yOffset;
				_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
				pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
				pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
				if (x !== m1.xOffset || y !== m1.yOffset) {
					pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
					pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
				}
				orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
			}
			if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
				if (_transformProp) {
					hasChange = true;
					p = _transformOriginProp;
					orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
					pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
					pt.b = style[p];
					pt.plugin = plugin;
					if (_supports3D) {
						copy = m1.zOrigin;
						orig = orig.split(" ");
						m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
						pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
						pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
						pt.b = copy;
						pt.xs0 = pt.e = m1.zOrigin;
					} else {
						pt.xs0 = pt.e = orig;
					}

					//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
				} else {
					_parsePosition(orig + "", m1);
				}
			}
			if (hasChange) {
				cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
			}
			if (swapFunc) {
				vars[parsingProp] = swapFunc;
			}
			if (scaleFunc) {
				vars.scale = scaleFunc;
			}
			return pt;
		}, prefix:true});

		_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});

		_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
			e = this.format(e);
			var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
				style = t.style,
				ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
			w = parseFloat(t.offsetWidth);
			h = parseFloat(t.offsetHeight);
			ea1 = e.split(" ");
			for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
				if (this.p.indexOf("border")) { //older browsers used a prefix
					props[i] = _checkPropPrefix(props[i]);
				}
				bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
				if (bs.indexOf(" ") !== -1) {
					bs2 = bs.split(" ");
					bs = bs2[0];
					bs2 = bs2[1];
				}
				es = es2 = ea1[i];
				bn = parseFloat(bs);
				bsfx = bs.substr((bn + "").length);
				rel = (es.charAt(1) === "=");
				if (rel) {
					en = parseInt(es.charAt(0)+"1", 10);
					es = es.substr(2);
					en *= parseFloat(es);
					esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
				} else {
					en = parseFloat(es);
					esfx = es.substr((en + "").length);
				}
				if (esfx === "") {
					esfx = _suffixMap[p] || bsfx;
				}
				if (esfx !== bsfx) {
					hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
					vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
					if (esfx === "%") {
						bs = (hn / w * 100) + "%";
						bs2 = (vn / h * 100) + "%";
					} else if (esfx === "em") {
						em = _convertToPixels(t, "borderLeft", 1, "em");
						bs = (hn / em) + "em";
						bs2 = (vn / em) + "em";
					} else {
						bs = hn + "px";
						bs2 = vn + "px";
					}
					if (rel) {
						es = (parseFloat(bs) + en) + esfx;
						es2 = (parseFloat(bs2) + en) + esfx;
					}
				}
				pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
			}
			return pt;
		}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
		_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
			return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
		}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
		_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
			var bp = "background-position",
				cs = (_cs || _getComputedStyle(t, null)),
				bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
				es = this.format(e),
				ba, ea, i, pct, overlap, src;
			if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
				src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
				if (src && src !== "none") {
					ba = bs.split(" ");
					ea = es.split(" ");
					_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
					i = 2;
					while (--i > -1) {
						bs = ba[i];
						pct = (bs.indexOf("%") !== -1);
						if (pct !== (ea[i].indexOf("%") !== -1)) {
							overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
							ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
						}
					}
					bs = ba.join(" ");
				}
			}
			return this.parseComplex(t.style, bs, es, pt, plugin);
		}, formatter:_parsePosition});
		_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
			v += ""; //ensure it's a string
			return (v.substr(0,2) === "co") ? v : _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong). Also remember that it could be "cover" or "contain" which we can't tween but should be able to set.
		}});
		_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
		_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
		_registerComplexSpecialProp("transformStyle", {prefix:true});
		_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
		_registerComplexSpecialProp("userSelect", {prefix:true});
		_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
		_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
		_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
			var b, cs, delim;
			if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
				cs = t.currentStyle;
				delim = _ieVers < 8 ? " " : ",";
				b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
				e = this.format(e).split(",").join(delim);
			} else {
				b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
				e = this.format(e);
			}
			return this.parseComplex(t.style, b, e, pt, plugin);
		}});
		_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
		_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
		_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
			var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
				end = this.format(e).split(" "),
				esfx = end[0].replace(_suffixExp, "");
			if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
				bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
			}
			return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
			}, color:true, formatter:function(v) {
				var a = v.split(" ");
				return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
			}});
		_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
		_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
			var s = t.style,
				prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
			return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
		}});

		//opacity-related
		var _setIEOpacityRatio = function(v) {
				var t = this.t, //refers to the element's style property
					filters = t.filter || _getStyle(this.data, "filter") || "",
					val = (this.s + this.c * v) | 0,
					skip;
				if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
					if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
						t.removeAttribute("filter");
						skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
					} else {
						t.filter = filters.replace(_alphaFilterExp, "");
						skip = true;
					}
				}
				if (!skip) {
					if (this.xn1) {
						t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
					}
					if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
						if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
							t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
						}
					} else {
						t.filter = filters.replace(_opacityExp, "opacity=" + val);
					}
				}
			};
		_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
			var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
				style = t.style,
				isAutoAlpha = (p === "autoAlpha");
			if (typeof(e) === "string" && e.charAt(1) === "=") {
				e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
			}
			if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
				b = 0;
			}
			if (_supportsOpacity) {
				pt = new CSSPropTween(style, "opacity", b, e - b, pt);
			} else {
				pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
				pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
				style.zoom = 1; //helps correct an IE issue.
				pt.type = 2;
				pt.b = "alpha(opacity=" + pt.s + ")";
				pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
				pt.data = t;
				pt.plugin = plugin;
				pt.setRatio = _setIEOpacityRatio;
			}
			if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
				pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
				pt.xs0 = "inherit";
				cssp._overwriteProps.push(pt.n);
				cssp._overwriteProps.push(p);
			}
			return pt;
		}});


		var _removeProp = function(s, p) {
				if (p) {
					if (s.removeProperty) {
						if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
							p = "-" + p;
						}
						s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
					} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
						s.removeAttribute(p);
					}
				}
			},
			_setClassNameRatio = function(v) {
				this.t._gsClassPT = this;
				if (v === 1 || v === 0) {
					this.t.setAttribute("class", (v === 0) ? this.b : this.e);
					var mpt = this.data, //first MiniPropTween
						s = this.t.style;
					while (mpt) {
						if (!mpt.v) {
							_removeProp(s, mpt.p);
						} else {
							s[mpt.p] = mpt.v;
						}
						mpt = mpt._next;
					}
					if (v === 1 && this.t._gsClassPT === this) {
						this.t._gsClassPT = null;
					}
				} else if (this.t.getAttribute("class") !== this.e) {
					this.t.setAttribute("class", this.e);
				}
			};
		_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
			var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
				cssText = t.style.cssText,
				difData, bs, cnpt, cnptLookup, mpt;
			pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
			pt.setRatio = _setClassNameRatio;
			pt.pr = -11;
			_hasPriority = true;
			pt.b = b;
			bs = _getAllStyles(t, _cs);
			//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
			cnpt = t._gsClassPT;
			if (cnpt) {
				cnptLookup = {};
				mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
				while (mpt) {
					cnptLookup[mpt.p] = 1;
					mpt = mpt._next;
				}
				cnpt.setRatio(1);
			}
			t._gsClassPT = pt;
			pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
			t.setAttribute("class", pt.e);
			difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
			t.setAttribute("class", b);
			pt.data = difData.firstMPT;
			t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
			pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
			return pt;
		}});


		var _setClearPropsRatio = function(v) {
			if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
				var s = this.t.style,
					transformParse = _specialProps.transform.parse,
					a, p, i, clearTransform, transform;
				if (this.e === "all") {
					s.cssText = "";
					clearTransform = true;
				} else {
					a = this.e.split(" ").join("").split(",");
					i = a.length;
					while (--i > -1) {
						p = a[i];
						if (_specialProps[p]) {
							if (_specialProps[p].parse === transformParse) {
								clearTransform = true;
							} else {
								p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
							}
						}
						_removeProp(s, p);
					}
				}
				if (clearTransform) {
					_removeProp(s, _transformProp);
					transform = this.t._gsTransform;
					if (transform) {
						if (transform.svg) {
							this.t.removeAttribute("data-svg-origin");
							this.t.removeAttribute("transform");
						}
						delete this.t._gsTransform;
					}
				}

			}
		};
		_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
			pt = new CSSPropTween(t, p, 0, 0, pt, 2);
			pt.setRatio = _setClearPropsRatio;
			pt.e = e;
			pt.pr = -10;
			pt.data = cssp._tween;
			_hasPriority = true;
			return pt;
		}});

		p = "bezier,throwProps,physicsProps,physics2D".split(",");
		i = p.length;
		while (i--) {
			_registerPluginProp(p[i]);
		}








		p = CSSPlugin.prototype;
		p._firstPT = p._lastParsedTransform = p._transform = null;

		//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
		p._onInitTween = function(target, vars, tween, index) {
			if (!target.nodeType) { //css is only for dom elements
				return false;
			}
			this._target = _target = target;
			this._tween = tween;
			this._vars = vars;
			_index = index;
			_autoRound = vars.autoRound;
			_hasPriority = false;
			_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
			_cs = _getComputedStyle(target, "");
			_overwriteProps = this._overwriteProps;
			var style = target.style,
				v, pt, pt2, first, last, next, zIndex, tpt, threeD;
			if (_reqSafariFix) if (style.zIndex === "") {
				v = _getStyle(target, "zIndex", _cs);
				if (v === "auto" || v === "") {
					//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
					this._addLazySet(style, "zIndex", 0);
				}
			}

			if (typeof(vars) === "string") {
				first = style.cssText;
				v = _getAllStyles(target, _cs);
				style.cssText = first + ";" + vars;
				v = _cssDif(target, v, _getAllStyles(target)).difs;
				if (!_supportsOpacity && _opacityValExp.test(vars)) {
					v.opacity = parseFloat( RegExp.$1 );
				}
				vars = v;
				style.cssText = first;
			}

			if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
				this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
			} else {
				this._firstPT = pt = this.parse(target, vars, null);
			}

			if (this._transformType) {
				threeD = (this._transformType === 3);
				if (!_transformProp) {
					style.zoom = 1; //helps correct an IE issue.
				} else if (_isSafari) {
					_reqSafariFix = true;
					//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
					if (style.zIndex === "") {
						zIndex = _getStyle(target, "zIndex", _cs);
						if (zIndex === "auto" || zIndex === "") {
							this._addLazySet(style, "zIndex", 0);
						}
					}
					//Setting WebkitBackfaceVisibility corrects 3 bugs:
					// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
					// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
					// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
					//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
					if (_isSafariLT6) {
						this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
					}
				}
				pt2 = pt;
				while (pt2 && pt2._next) {
					pt2 = pt2._next;
				}
				tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
				this._linkCSSP(tpt, null, pt2);
				tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
				tpt.data = this._transform || _getTransform(target, _cs, true);
				tpt.tween = tween;
				tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
				_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
			}

			if (_hasPriority) {
				//reorders the linked list in order of pr (priority)
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				this._firstPT = first;
			}
			return true;
		};


		p.parse = function(target, vars, pt, plugin) {
			var style = target.style,
				p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
			for (p in vars) {
				es = vars[p]; //ending value string
				if (typeof(es) === "function") {
					es = es(_index, _target);
				}
				sp = _specialProps[p]; //SpecialProp lookup.
				if (sp) {
					pt = sp.parse(target, es, p, this, pt, plugin, vars);
				} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
					this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
					continue;
				} else {
					bs = _getStyle(target, p, _cs) + "";
					isStr = (typeof(es) === "string");
					if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
						if (!isStr) {
							es = _parseColor(es);
							es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
						}
						pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);

					} else if (isStr && _complexExp.test(es)) {
						pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);

					} else {
						bn = parseFloat(bs);
						bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.

						if (bs === "" || bs === "auto") {
							if (p === "width" || p === "height") {
								bn = _getDimension(target, p, _cs);
								bsfx = "px";
							} else if (p === "left" || p === "top") {
								bn = _calculateOffset(target, p, _cs);
								bsfx = "px";
							} else {
								bn = (p !== "opacity") ? 0 : 1;
								bsfx = "";
							}
						}

						rel = (isStr && es.charAt(1) === "=");
						if (rel) {
							en = parseInt(es.charAt(0) + "1", 10);
							es = es.substr(2);
							en *= parseFloat(es);
							esfx = es.replace(_suffixExp, "");
						} else {
							en = parseFloat(es);
							esfx = isStr ? es.replace(_suffixExp, "") : "";
						}

						if (esfx === "") {
							esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
						}

						es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
						//if the beginning/ending suffixes don't match, normalize them...
						if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
							bn = _convertToPixels(target, p, bn, bsfx);
							if (esfx === "%") {
								bn /= _convertToPixels(target, p, 100, "%") / 100;
								if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
									bs = bn + "%";
								}

							} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
								bn /= _convertToPixels(target, p, 1, esfx);

							//otherwise convert to pixels.
							} else if (esfx !== "px") {
								en = _convertToPixels(target, p, en, esfx);
								esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
							}
							if (rel) if (en || en === 0) {
								es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
							}
						}

						if (rel) {
							en += bn;
						}

						if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
							pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
							pt.xs0 = esfx;
							//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
						} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
							_log("invalid " + p + " tween value: " + vars[p]);
						} else {
							pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
							pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
							//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
						}
					}
				}
				if (plugin) if (pt && !pt.plugin) {
					pt.plugin = plugin;
				}
			}
			return pt;
		};


		//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
		p.setRatio = function(v) {
			var pt = this._firstPT,
				min = 0.000001,
				val, str, i;
			//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
			if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
				while (pt) {
					if (pt.type !== 2) {
						if (pt.r && pt.type !== -1) {
							val = pt.r(pt.s + pt.c);
							if (!pt.type) {
								pt.t[pt.p] = val + pt.xs0;
							} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
								i = pt.l;
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
						} else {
							pt.t[pt.p] = pt.e;
						}
					} else {
						pt.setRatio(v);
					}
					pt = pt._next;
				}

			} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
				while (pt) {
					val = pt.c * v + pt.s;
					if (pt.r) {
						val = pt.r(val);
					} else if (val < min) if (val > -min) {
						val = 0;
					}
					if (!pt.type) {
						pt.t[pt.p] = val + pt.xs0;
					} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
						i = pt.l;
						if (i === 2) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
						} else if (i === 3) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
						} else if (i === 4) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
						} else if (i === 5) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
						} else {
							str = pt.xs0 + val + pt.xs1;
							for (i = 1; i < pt.l; i++) {
								str += pt["xn"+i] + pt["xs"+(i+1)];
							}
							pt.t[pt.p] = str;
						}

					} else if (pt.type === -1) { //non-tweening value
						pt.t[pt.p] = pt.xs0;

					} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
						pt.setRatio(v);
					}
					pt = pt._next;
				}

			//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
			} else {
				while (pt) {
					if (pt.type !== 2) {
						pt.t[pt.p] = pt.b;
					} else {
						pt.setRatio(v);
					}
					pt = pt._next;
				}
			}
		};

		/**
		 * @private
		 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
		 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
		 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
		 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
		 * doesn't have any transform-related properties of its own. You can call this method as many times as you
		 * want and it won't create duplicate CSSPropTweens.
		 *
		 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
		 */
		p._enableTransforms = function(threeD) {
			this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
			this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
		};

		var lazySet = function(v) {
			this.t[this.p] = this.e;
			this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
		};
		/** @private Gives us a way to set a value on the first render (and only the first render). **/
		p._addLazySet = function(t, p, v) {
			var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
			pt.e = v;
			pt.setRatio = lazySet;
			pt.data = this;
		};

		/** @private **/
		p._linkCSSP = function(pt, next, prev, remove) {
			if (pt) {
				if (next) {
					next._prev = pt;
				}
				if (pt._next) {
					pt._next._prev = pt._prev;
				}
				if (pt._prev) {
					pt._prev._next = pt._next;
				} else if (this._firstPT === pt) {
					this._firstPT = pt._next;
					remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
				}
				if (prev) {
					prev._next = pt;
				} else if (!remove && this._firstPT === null) {
					this._firstPT = pt;
				}
				pt._next = next;
				pt._prev = prev;
			}
			return pt;
		};

		p._mod = function(lookup) {
			var pt = this._firstPT;
			while (pt) {
				if (typeof(lookup[pt.p]) === "function") { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally.
					pt.r = lookup[pt.p];
				}
				pt = pt._next;
			}
		};

		//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
		p._kill = function(lookup) {
			var copy = lookup,
				pt, p, xfirst;
			if (lookup.autoAlpha || lookup.alpha) {
				copy = {};
				for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
					copy[p] = lookup[p];
				}
				copy.opacity = 1;
				if (copy.autoAlpha) {
					copy.visibility = 1;
				}
			}
			if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
				xfirst = pt.xfirst;
				if (xfirst && xfirst._prev) {
					this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
				} else if (xfirst === this._firstPT) {
					this._firstPT = pt._next;
				}
				if (pt._next) {
					this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
				}
				this._classNamePT = null;
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
					pt.plugin._kill(lookup);
					p = pt.plugin;
				}
				pt = pt._next;
			}
			return TweenPlugin.prototype._kill.call(this, copy);
		};



		//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
		var _getChildStyles = function(e, props, targets) {
				var children, i, child, type;
				if (e.slice) {
					i = e.length;
					while (--i > -1) {
						_getChildStyles(e[i], props, targets);
					}
					return;
				}
				children = e.childNodes;
				i = children.length;
				while (--i > -1) {
					child = children[i];
					type = child.type;
					if (child.style) {
						props.push(_getAllStyles(child));
						if (targets) {
							targets.push(child);
						}
					}
					if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
						_getChildStyles(child, props, targets);
					}
				}
			};

		/**
		 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
		 * and then compares the style properties of all the target's child elements at the tween's start and end, and
		 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
		 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
		 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
		 * is because it creates entirely new tweens that may have completely different targets than the original tween,
		 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
		 * and it would create other problems. For example:
		 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
		 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
		 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
		 *
		 * @param {Object} target object to be tweened
		 * @param {number} Duration in seconds (or frames for frames-based tweens)
		 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
		 * @return {Array} An array of TweenLite instances
		 */
		CSSPlugin.cascadeTo = function(target, duration, vars) {
			var tween = TweenLite.to(target, duration, vars),
				results = [tween],
				b = [],
				e = [],
				targets = [],
				_reservedProps = TweenLite._internals.reservedProps,
				i, difs, p, from;
			target = tween._targets || tween.target;
			_getChildStyles(target, b, targets);
			tween.render(duration, true, true);
			_getChildStyles(target, e);
			tween.render(0, true, true);
			tween._enabled(true);
			i = targets.length;
			while (--i > -1) {
				difs = _cssDif(targets[i], b[i], e[i]);
				if (difs.firstMPT) {
					difs = difs.difs;
					for (p in vars) {
						if (_reservedProps[p]) {
							difs[p] = vars[p];
						}
					}
					from = {};
					for (p in difs) {
						from[p] = b[i][p];
					}
					results.push(TweenLite.fromTo(targets[i], duration, from, difs));
				}
			}
			return results;
		};

		TweenPlugin.activate([CSSPlugin]);
		return CSSPlugin;

	}, true);

	
	
	
	
	
	
	
	
	
	
/*
 * ----------------------------------------------------------------
 * RoundPropsPlugin
 * ----------------------------------------------------------------
 */
	(function() {

		var RoundPropsPlugin = _gsScope._gsDefine.plugin({
				propName: "roundProps",
				version: "1.7.0",
				priority: -1,
				API: 2,

				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween) {
					this._tween = tween;
					return true;
				}

			}),
			_getRoundFunc = function(v) { //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
				var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
				return function(n) {
					return ((Math.round(n / v) * v * p) | 0) / p;
				};
			},
			_roundLinkedList = function(node, mod) {
				while (node) {
					if (!node.f && !node.blob) {
						node.m = mod || Math.round;
					}
					node = node._next;
				}
			},
			p = RoundPropsPlugin.prototype;

		p._onInitAllProps = function() {
			var tween = this._tween,
				rp = tween.vars.roundProps,
				lookup = {},
				rpt = tween._propLookup.roundProps,
				pt, next, i, p;
			if (typeof(rp) === "object" && !rp.push) {
				for (p in rp) {
					lookup[p] = _getRoundFunc(rp[p]);
				}
			} else {
				if (typeof(rp) === "string") {
					rp = rp.split(",");
				}
				i = rp.length;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
			}

			for (p in lookup) {
				pt = tween._firstPT;
				while (pt) {
					next = pt._next; //record here, because it may get removed
					if (pt.pg) {
						pt.t._mod(lookup);
					} else if (pt.n === p) {
						if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
							_roundLinkedList(pt.t._firstPT, lookup[p]);
						} else {
							this._add(pt.t, p, pt.s, pt.c, lookup[p]);
							//remove from linked list
							if (next) {
								next._prev = pt._prev;
							}
							if (pt._prev) {
								pt._prev._next = next;
							} else if (tween._firstPT === pt) {
								tween._firstPT = next;
							}
							pt._next = pt._prev = null;
							tween._propLookup[p] = rpt;
						}
					}
					pt = next;
				}
			}
			return false;
		};

		p._add = function(target, p, s, c, mod) {
			this._addTween(target, p, s, s + c, p, mod || Math.round);
			this._overwriteProps.push(p);
		};

	}());










/*
 * ----------------------------------------------------------------
 * AttrPlugin
 * ----------------------------------------------------------------
 */

	(function() {

		_gsScope._gsDefine.plugin({
			propName: "attr",
			API: 2,
			version: "0.6.1",

			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				var p, end;
				if (typeof(target.setAttribute) !== "function") {
					return false;
				}
				for (p in value) {
					end = value[p];
					if (typeof(end) === "function") {
						end = end(index, target);
					}
					this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
					this._overwriteProps.push(p);
				}
				return true;
			}

		});

	}());










/*
 * ----------------------------------------------------------------
 * DirectionalRotationPlugin
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine.plugin({
		propName: "directionalRotation",
		version: "0.3.1",
		API: 2,

		//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
		init: function(target, value, tween, index) {
			if (typeof(value) !== "object") {
				value = {rotation:value};
			}
			this.finals = {};
			var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
				min = 0.000001,
				p, v, start, end, dif, split;
			for (p in value) {
				if (p !== "useRadians") {
					end = value[p];
					if (typeof(end) === "function") {
						end = end(index, target);
					}
					split = (end + "").split("_");
					v = split[0];
					start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
					end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
					dif = end - start;
					if (split.length) {
						v = split.join("_");
						if (v.indexOf("short") !== -1) {
							dif = dif % cap;
							if (dif !== dif % (cap / 2)) {
								dif = (dif < 0) ? dif + cap : dif - cap;
							}
						}
						if (v.indexOf("_cw") !== -1 && dif < 0) {
							dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						} else if (v.indexOf("ccw") !== -1 && dif > 0) {
							dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						}
					}
					if (dif > min || dif < -min) {
						this._addTween(target, p, start, start + dif, p);
						this._overwriteProps.push(p);
					}
				}
			}
			return true;
		},

		//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
		set: function(ratio) {
			var pt;
			if (ratio !== 1) {
				this._super.setRatio.call(this, ratio);
			} else {
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](this.finals[pt.p]);
					} else {
						pt.t[pt.p] = this.finals[pt.p];
					}
					pt = pt._next;
				}
			}
		}

	})._autoCSS = true;







	
	
	
	
/*
 * ----------------------------------------------------------------
 * EasePack
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
		
		var w = (_gsScope.GreenSockGlobals || _gsScope),
			gs = w.com.greensock,
			_2PI = Math.PI * 2,
			_HALF_PI = Math.PI / 2,
			_class = gs._class,
			_create = function(n, f) {
				var C = _class("easing." + n, function(){}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				return C;
			},
			_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
			_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
				var C = _class("easing."+name, {
					easeOut:new EaseOut(),
					easeIn:new EaseIn(),
					easeInOut:new EaseInOut()
				}, true);
				_easeReg(C, name);
				return C;
			},
			EasePoint = function(time, value, next) {
				this.t = time;
				this.v = value;
				if (next) {
					this.next = next;
					next.prev = this;
					this.c = next.v - value;
					this.gap = next.t - time;
				}
			},

			//Back
			_createBack = function(n, f) {
				var C = _class("easing." + n, function(overshoot) {
						this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
						this._p2 = this._p1 * 1.525;
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(overshoot) {
					return new C(overshoot);
				};
				return C;
			},

			Back = _wrap("Back",
				_createBack("BackOut", function(p) {
					return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
				}),
				_createBack("BackIn", function(p) {
					return p * p * ((this._p1 + 1) * p - this._p1);
				}),
				_createBack("BackInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
				})
			),


			//SlowMo
			SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
				power = (power || power === 0) ? power : 0.7;
				if (linearRatio == null) {
					linearRatio = 0.7;
				} else if (linearRatio > 1) {
					linearRatio = 1;
				}
				this._p = (linearRatio !== 1) ? power : 0;
				this._p1 = (1 - linearRatio) / 2;
				this._p2 = linearRatio;
				this._p3 = this._p1 + this._p2;
				this._calcEnd = (yoyoMode === true);
			}, true),
			p = SlowMo.prototype = new Ease(),
			SteppedEase, ExpoScaleEase, RoughEase, _createElastic;

		p.constructor = SlowMo;
		p.getRatio = function(p) {
			var r = p + (0.5 - p) * this._p;
			if (p < this._p1) {
				return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
			} else if (p > this._p3) {
				return this._calcEnd ? (p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p) : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p); //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
			}
			return this._calcEnd ? 1 : r;
		};
		SlowMo.ease = new SlowMo(0.7, 0.7);

		p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
			return new SlowMo(linearRatio, power, yoyoMode);
		};


		//SteppedEase
		SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
				steps = steps || 1;
				this._p1 = 1 / steps;
				this._p2 = steps + (immediateStart ? 0 : 1);
				this._p3 = immediateStart ? 1 : 0;
			}, true);
		p = SteppedEase.prototype = new Ease();
		p.constructor = SteppedEase;
		p.getRatio = function(p) {
			if (p < 0) {
				p = 0;
			} else if (p >= 1) {
				p = 0.999999999;
			}
			return (((this._p2 * p) | 0) + this._p3) * this._p1;
		};
		p.config = SteppedEase.config = function(steps, immediateStart) {
			return new SteppedEase(steps, immediateStart);
		};

		//ExpoScaleEase
		ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
			this._p1 = Math.log(end / start);
			this._p2 = end - start;
			this._p3 = start;
			this._ease = ease;
		}, true);
		p = ExpoScaleEase.prototype = new Ease();
		p.constructor = ExpoScaleEase;
		p.getRatio = function(p) {
			if (this._ease) {
				p = this._ease.getRatio(p);
			}
			return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
		};
		p.config = ExpoScaleEase.config = function(start, end, ease) {
			return new ExpoScaleEase(start, end, ease);
		};


		//RoughEase
		RoughEase = _class("easing.RoughEase", function(vars) {
			vars = vars || {};
			var taper = vars.taper || "none",
				a = [],
				cnt = 0,
				points = (vars.points || 20) | 0,
				i = points,
				randomize = (vars.randomize !== false),
				clamp = (vars.clamp === true),
				template = (vars.template instanceof Ease) ? vars.template : null,
				strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
				x, y, bump, invX, obj, pnt;
			while (--i > -1) {
				x = randomize ? Math.random() : (1 / points) * i;
				y = template ? template.getRatio(x) : x;
				if (taper === "none") {
					bump = strength;
				} else if (taper === "out") {
					invX = 1 - x;
					bump = invX * invX * strength;
				} else if (taper === "in") {
					bump = x * x * strength;
				} else if (x < 0.5) {  //"both" (start)
					invX = x * 2;
					bump = invX * invX * 0.5 * strength;
				} else {				//"both" (end)
					invX = (1 - x) * 2;
					bump = invX * invX * 0.5 * strength;
				}
				if (randomize) {
					y += (Math.random() * bump) - (bump * 0.5);
				} else if (i % 2) {
					y += bump * 0.5;
				} else {
					y -= bump * 0.5;
				}
				if (clamp) {
					if (y > 1) {
						y = 1;
					} else if (y < 0) {
						y = 0;
					}
				}
				a[cnt++] = {x:x, y:y};
			}
			a.sort(function(a, b) {
				return a.x - b.x;
			});

			pnt = new EasePoint(1, 1, null);
			i = points;
			while (--i > -1) {
				obj = a[i];
				pnt = new EasePoint(obj.x, obj.y, pnt);
			}

			this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
		}, true);
		p = RoughEase.prototype = new Ease();
		p.constructor = RoughEase;
		p.getRatio = function(p) {
			var pnt = this._prev;
			if (p > pnt.t) {
				while (pnt.next && p >= pnt.t) {
					pnt = pnt.next;
				}
				pnt = pnt.prev;
			} else {
				while (pnt.prev && p <= pnt.t) {
					pnt = pnt.prev;
				}
			}
			this._prev = pnt;
			return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
		};
		p.config = function(vars) {
			return new RoughEase(vars);
		};
		RoughEase.ease = new RoughEase();


		//Bounce
		_wrap("Bounce",
			_create("BounceOut", function(p) {
				if (p < 1 / 2.75) {
					return 7.5625 * p * p;
				} else if (p < 2 / 2.75) {
					return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
				} else if (p < 2.5 / 2.75) {
					return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
				}
				return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
			}),
			_create("BounceIn", function(p) {
				if ((p = 1 - p) < 1 / 2.75) {
					return 1 - (7.5625 * p * p);
				} else if (p < 2 / 2.75) {
					return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
				} else if (p < 2.5 / 2.75) {
					return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
				}
				return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
			}),
			_create("BounceInOut", function(p) {
				var invert = (p < 0.5);
				if (invert) {
					p = 1 - (p * 2);
				} else {
					p = (p * 2) - 1;
				}
				if (p < 1 / 2.75) {
					p = 7.5625 * p * p;
				} else if (p < 2 / 2.75) {
					p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
				} else if (p < 2.5 / 2.75) {
					p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
				} else {
					p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}
				return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
			})
		);


		//CIRC
		_wrap("Circ",
			_create("CircOut", function(p) {
				return Math.sqrt(1 - (p = p - 1) * p);
			}),
			_create("CircIn", function(p) {
				return -(Math.sqrt(1 - (p * p)) - 1);
			}),
			_create("CircInOut", function(p) {
				return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
			})
		);


		//Elastic
		_createElastic = function(n, f, def) {
			var C = _class("easing." + n, function(amplitude, period) {
					this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
					this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
					this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
					this._p2 = _2PI / this._p2; //precalculate to optimize
				}, true),
				p = C.prototype = new Ease();
			p.constructor = C;
			p.getRatio = f;
			p.config = function(amplitude, period) {
				return new C(amplitude, period);
			};
			return C;
		};
		_wrap("Elastic",
			_createElastic("ElasticOut", function(p) {
				return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
			}, 0.3),
			_createElastic("ElasticIn", function(p) {
				return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
			}, 0.3),
			_createElastic("ElasticInOut", function(p) {
				return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
			}, 0.45)
		);


		//Expo
		_wrap("Expo",
			_create("ExpoOut", function(p) {
				return 1 - Math.pow(2, -10 * p);
			}),
			_create("ExpoIn", function(p) {
				return Math.pow(2, 10 * (p - 1)) - 0.001;
			}),
			_create("ExpoInOut", function(p) {
				return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
			})
		);


		//Sine
		_wrap("Sine",
			_create("SineOut", function(p) {
				return Math.sin(p * _HALF_PI);
			}),
			_create("SineIn", function(p) {
				return -Math.cos(p * _HALF_PI) + 1;
			}),
			_create("SineInOut", function(p) {
				return -0.5 * (Math.cos(Math.PI * p) - 1);
			})
		);

		_class("easing.EaseLookup", {
				find:function(s) {
					return Ease.map[s];
				}
			}, true);

		//register the non-standard eases
		_easeReg(w.SlowMo, "SlowMo", "ease,");
		_easeReg(RoughEase, "RoughEase", "ease,");
		_easeReg(SteppedEase, "SteppedEase", "ease,");

		return Back;
		
	}, true);


});

if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.











/*
 * ----------------------------------------------------------------
 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
 * ----------------------------------------------------------------
 */
(function(window, moduleName) {

		"use strict";
		var _exports = {},
			_doc = window.document,
			_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function(ns) {
				var a = ns.split("."),
					p = _globals, i;
				for (i = 0; i < a.length; i++) {
					p[a[i]] = p = p[a[i]] || {};
				}
				return p;
			},
			gs = _namespace("com.greensock"),
			_tinyNum = 0.0000000001,
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++])) {}
				return b;
			},
			_emptyFunc = function() {},
			_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
				var toString = Object.prototype.toString,
					array = toString.call([]);
				return function(obj) {
					return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
				};
			}()),
			a, i, p, _ticker, _tickerActive,
			_defLookup = {},

			/**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */
			Definition = function(ns, dependencies, func, global) {
				this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
				_defLookup[ns] = this;
				this.gsClass = null;
				this.func = func;
				var _classes = [];
				this.check = function(init) {
					var i = dependencies.length,
						missing = i,
						cur, a, n, cl;
					while (--i > -1) {
						if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
							_classes[i] = cur.gsClass;
							missing--;
						} else if (init) {
							cur.sc.push(this);
						}
					}
					if (missing === 0 && func) {
						a = ("com.greensock." + ns).split(".");
						n = a.pop();
						cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);

						//exports to multiple environments
						if (global) {
							_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
							if (typeof(module) !== "undefined" && module.exports) { //node
								if (ns === moduleName) {
									module.exports = _exports[moduleName] = cl;
									for (i in _exports) {
										cl[i] = _exports[i];
									}
								} else if (_exports[moduleName]) {
									_exports[moduleName][n] = cl;
								}
							} else if (typeof(define) === "function" && define.amd){ //AMD
								define((window.GreenSockAMDPath ? window.GreenSockAMDPath + "/" : "") + ns.split(".").pop(), [], function() { return cl; });
							}
						}
						for (i = 0; i < this.sc.length; i++) {
							this.sc[i].check();
						}
					}
				};
				this.check(true);
			},

			//used to create Definition instances (which basically registers a class that has dependencies).
			_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
				return new Definition(ns, dependencies, func, global);
			},

			//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
			_class = gs._class = function(ns, func, global) {
				func = func || function() {};
				_gsDefine(ns, [], function(){ return func; }, global);
				return func;
			};

		_gsDefine.globals = _globals;



/*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */
		var _baseParams = [0, 0, 1, 1],
			Ease = _class("easing.Ease", function(func, extraParams, type, power) {
				this._func = func;
				this._type = type || 0;
				this._power = power || 0;
				this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
			}, true),
			_easeMap = Ease.map = {},
			_easeReg = Ease.register = function(ease, names, types, create) {
				var na = names.split(","),
					i = na.length,
					ta = (types || "easeIn,easeOut,easeInOut").split(","),
					e, name, j, type;
				while (--i > -1) {
					name = na[i];
					e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
					j = ta.length;
					while (--j > -1) {
						type = ta[j];
						_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
					}
				}
			};

		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function(p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
				pw = this._power,
				r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
		};

		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i]+",Power"+i;
			_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
			_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
			_easeReg(new Ease(null,null,3,i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks


/*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */
		var EventDispatcher = _class("events.EventDispatcher", function(target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;

		p.addEventListener = function(type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
				index = 0,
				listener, i;
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
		};

		p.removeEventListener = function(type, callback) {
			var list = this._listeners[type], i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};

		p.dispatchEvent = function(type) {
			var list = this._listeners[type],
				i, t, listener;
			if (list) {
				i = list.length;
				if (i > 1) {
					list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
				}
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, {type:type, target:t});
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};


/*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */
 		var _reqAnimFrame = window.requestAnimationFrame,
			_cancelAnimFrame = window.cancelAnimationFrame,
			_getTime = Date.now || function() {return new Date().getTime();},
			_lastUpdate = _getTime();

		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms","moz","webkit","o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}

		_class("Ticker", function(fps, useRAF) {
			var _self = this,
				_startTime = _getTime(),
				_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
				_lagThreshold = 500,
				_adjustedLag = 33,
				_tickWord = "tick", //helps reduce gc burden
				_fps, _req, _id, _gap, _nextTime,
				_tick = function(manual) {
					var elapsed = _getTime() - _lastUpdate,
						overlap, dispatch;
					if (elapsed > _lagThreshold) {
						_startTime += elapsed - _adjustedLag;
					}
					_lastUpdate += elapsed;
					_self.time = (_lastUpdate - _startTime) / 1000;
					overlap = _self.time - _nextTime;
					if (!_fps || overlap > 0 || manual === true) {
						_self.frame++;
						_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
						dispatch = true;
					}
					if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
						_id = _req(_tick);
					}
					if (dispatch) {
						_self.dispatchEvent(_tickWord);
					}
				};

			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function() {
				_tick(true);
			};

			_self.lagSmoothing = function(threshold, adjustedLag) {
				if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
					return (_lagThreshold < 1 / _tinyNum);
				}
				_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};

			_self.sleep = function() {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};

			_self.wake = function(seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};

			_self.fps = function(value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};

			_self.useRAF = function(value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);

			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function() {
				if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});

		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;


/*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */
		var Animation = _class("core.Animation", function(duration, vars) {
				this.vars = vars = vars || {};
				this._duration = this._totalDuration = duration || 0;
				this._delay = Number(vars.delay) || 0;
				this._timeScale = 1;
				this._active = (vars.immediateRender === true);
				this.data = vars.data;
				this._reversed = (vars.reversed === true);

				if (!_rootTimeline) {
					return;
				}
				if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
					_ticker.wake();
				}

				var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
				tl.add(this, tl._time);

				if (this.vars.paused) {
					this.paused(true);
				}
			});

		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;


		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function() {
				if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
					_ticker.wake();
				}
				var t = setTimeout(_checkTimeout, 2000);
				if (t.unref) {
					// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
					t.unref();
				}
			};
		_checkTimeout();


		p.play = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};

		p.pause = function(atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};

		p.resume = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};

		p.seek = function(time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};

		p.restart = function(includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
		};

		p.reverse = function(from, suppressEvents) {
			if (from != null) {
				this.seek((from || this.totalDuration()), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};

		p.render = function(time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};

		p.invalidate = function() {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};

		p.isActive = function() {
			var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
				startTime = this._startTime,
				rawTime;
			return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
		};

		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};


		p._kill = function(vars, target) {
			return this._enabled(false, false);
		};

		p.kill = function(vars, target) {
			this._kill(vars, target);
			return this;
		};

		p._uncache = function(includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};

		p._swapSelfInParams = function(params) {
			var i = params.length,
				copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};

		p._callback = function(type) {
			var v = this.vars,
				callback = v[type],
				params = v[type + "Params"],
				scope = v[type + "Scope"] || v.callbackScope || this,
				l = params ? params.length : 0;
			switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
				case 0: callback.call(scope); break;
				case 1: callback.call(scope, params[0]); break;
				case 2: callback.call(scope, params[0], params[1]); break;
				default: callback.apply(scope, params);
			}
		};

//----Animation getters/setters --------------------------------------------------------

		p.eventCallback = function(type, callback, params, scope) {
			if ((type || "").substr(0,2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};

		p.delay = function(value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime( this._startTime + value - this._delay );
			}
			this._delay = value;
			return this;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};

		p.totalDuration = function(value) {
			this._dirty = false;
			return (!arguments.length) ? this._totalDuration : this.duration(value);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
						tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
					if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};

		p.progress = p.totalProgress = function(value, suppressEvents) {
			var duration = this.duration();
			return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
		};

		p.startTime = function(value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};

		p.endTime = function(includeRepeats) {
			return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
		};

		p.timeScale = function(value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			var pauseTime, t;
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				pauseTime = this._pauseTime;
				t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
				this._startTime = t - ((t - this._startTime) * this._timeScale / value);
			}
			this._timeScale = value;
			t = this.timeline;
			while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
				t._dirty = true;
				t.totalDuration();
				t = t.timeline;
			}
			return this;
		};

		p.reversed = function(value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
			}
			return this;
		};

		p.paused = function(value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
				raw, elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};


/*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */
		var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});

		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;

		p.add = p.insert = function(child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};

		p._remove = function(tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}

				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}

				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};

		p.render = function(time, suppressEvents, force) {
			var tween = this._first,
				next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
					}
				}
				tween = next;
			}
		};

		p.rawTime = function() {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};

/*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */
		var TweenLite = _class("TweenLite", function(target, duration, vars) {
				Animation.call(this, duration, vars);
				this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)

				if (target == null) {
					throw "Cannot tween a null target.";
				}

				this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;

				var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
					overwrite = this.vars.overwrite,
					i, targ, targets;

				this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];

				if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
					this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					this._propLookup = [];
					this._siblings = [];
					for (i = 0; i < targets.length; i++) {
						targ = targets[i];
						if (!targ) {
							targets.splice(i--, 1);
							continue;
						} else if (typeof(targ) === "string") {
							targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
							if (typeof(targ) === "string") {
								targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
							}
							continue;
						} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
							targets.splice(i--, 1);
							this._targets = targets = targets.concat(_slice(targ));
							continue;
						}
						this._siblings[i] = _register(targ, this, false);
						if (overwrite === 1) if (this._siblings[i].length > 1) {
							_applyOverwrite(targ, this, null, 1, this._siblings[i]);
						}
					}

				} else {
					this._propLookup = {};
					this._siblings = _register(target, this, false);
					if (overwrite === 1) if (this._siblings.length > 1) {
						_applyOverwrite(target, this, null, 1, this._siblings);
					}
				}
				if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative
				}
			}, true),
			_isSelector = function(v) {
				return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
			},
			_autoCSS = function(vars, target) {
				var css = {},
					p;
				for (p in vars) {
					if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
						css[p] = vars[p];
						delete vars[p];
					}
				}
				vars.css = css;
			};

		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;

//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------

		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;

		TweenLite.version = "1.20.5";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function(threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};

		TweenLite.selector = window.$ || window.jQuery || function(e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			if (!_doc) { //in some dev environments (like Angular 6), GSAP gets loaded before the document is defined! So re-query it here if/when necessary.
				_doc = window.document;
			}
			return (!_doc) ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
		};

		var _lazyTweens = [],
			_lazyLookup = {},
			_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_relExp = /[\+-]=-?[\.\d]/,
			//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
			_setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val;
				while (pt) {
					val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
					if (pt.m) {
						val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
					} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
						val = 0;
					}
					if (!pt.f) {
						pt.t[pt.p] = val;
					} else if (pt.fp) {
						pt.t[pt.p](pt.fp, val);
					} else {
						pt.t[pt.p](val);
					}
					pt = pt._next;
				}
			},
			//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
			_blobDif = function(start, end, filter, pt) {
				var a = [],
					charIndex = 0,
					s = "",
					color = 0,
					startNums, endNums, num, i, l, nonNumbers, currentNum;
				a.start = start;
				a.end = end;
				start = a[0] = start + ""; //ensure values are strings
				end = a[1] = end + "";
				if (filter) {
					filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
					start = a[0];
					end = a[1];
				}
				a.length = 0;
				startNums = start.match(_numbersExp) || [];
				endNums = end.match(_numbersExp) || [];
				if (pt) {
					pt._next = null;
					pt.blob = 1;
					a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
				}
				l = endNums.length;
				for (i = 0; i < l; i++) {
					currentNum = endNums[i];
					nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
					s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
					charIndex += nonNumbers.length;
					if (color) { //sense rgba() values and round them.
						color = (color + 1) % 5;
					} else if (nonNumbers.substr(-5) === "rgba(") {
						color = 1;
					}
					if (currentNum === startNums[i] || startNums.length <= i) {
						s += currentNum;
					} else {
						if (s) {
							a.push(s);
							s = "";
						}
						num = parseFloat(startNums[i]);
						a.push(num);
						a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
						//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
					}
					charIndex += currentNum.length;
				}
				s += end.substr(charIndex);
				if (s) {
					a.push(s);
				}
				a.setRatio = _setRatio;
				if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
					a.end = null;
				}
				return a;
			},
			//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
			_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
				if (typeof(end) === "function") {
					end = end(index || 0, target);
				}
				var type = typeof(target[prop]),
					getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
					s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
					isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
					pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
					blob;

				if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
					if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
						//a blob (string that has multiple numbers in it)
						pt.fp = funcParam;
						blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
						pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
					} else {
						pt.s = parseFloat(s);
						if (!isRelative) {
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
				}
				if (pt.c) { //only add it to the linked list if there's a change.
					if ((pt._next = this._firstPT)) {
						pt._next._prev = pt;
					}
					this._firstPT = pt;
					return pt;
				}
			},
			_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
			_plugins = TweenLite._plugins = {},
			_tweenLookup = _internals.tweenLookup = {},
			_tweenLookupNum = 0,
			_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
			_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
			_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
			_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
			_nextGCFrame = 30,
			_lazyRender = _internals.lazyRender = function() {
				var i = _lazyTweens.length,
					tween;
				_lazyLookup = {};
				while (--i > -1) {
					tween = _lazyTweens[i];
					if (tween && tween._lazy !== false) {
						tween.render(tween._lazy[0], tween._lazy[1], true);
						tween._lazy = false;
					}
				}
				_lazyTweens.length = 0;
			};

		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".

		Animation._updateRoot = TweenLite.render = function() {
				var i, a, p;
				if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
					_lazyRender();
				}
				_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
				_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
				if (_lazyTweens.length) {
					_lazyRender();
				}
				if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
					_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
					for (p in _tweenLookup) {
						a = _tweenLookup[p].tweens;
						i = a.length;
						while (--i > -1) {
							if (a[i]._gc) {
								a.splice(i, 1);
							}
						}
						if (a.length === 0) {
							delete _tweenLookup[p];
						}
					}
					//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
					p = _rootTimeline._first;
					if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
						while (p && p._paused) {
							p = p._next;
						}
						if (!p) {
							_ticker.sleep();
						}
					}
				}
			};

		_ticker.addEventListener("tick", Animation._updateRoot);

		var _register = function(target, tween, scrub) {
				var id = target._gsTweenID, a, i;
				if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
					_tweenLookup[id] = {target:target, tweens:[]};
				}
				if (tween) {
					a = _tweenLookup[id].tweens;
					a[(i = a.length)] = tween;
					if (scrub) {
						while (--i > -1) {
							if (a[i] === tween) {
								a.splice(i, 1);
							}
						}
					}
				}
				return _tweenLookup[id].tweens;
			},
			_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
				var func = overwrittenTween.vars.onOverwrite, r1, r2;
				if (func) {
					r1 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				func = TweenLite.onOverwrite;
				if (func) {
					r2 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				return (r1 !== false && r2 !== false);
			},
			_applyOverwrite = function(target, tween, props, mode, siblings) {
				var i, changed, curTween, l;
				if (mode === 1 || mode >= 4) {
					l = siblings.length;
					for (i = 0; i < l; i++) {
						if ((curTween = siblings[i]) !== tween) {
							if (!curTween._gc) {
								if (curTween._kill(null, target, tween)) {
									changed = true;
								}
							}
						} else if (mode === 5) {
							break;
						}
					}
					return changed;
				}
				//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
				var startTime = tween._startTime + _tinyNum,
					overlaps = [],
					oCount = 0,
					zeroDur = (tween._duration === 0),
					globalStart;
				i = siblings.length;
				while (--i > -1) {
					if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
						//ignore
					} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
						overlaps[oCount++] = curTween;
					}
				}

				i = oCount;
				while (--i > -1) {
					curTween = overlaps[i];
					if (mode === 2) if (curTween._kill(props, target, tween)) {
						changed = true;
					}
					if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
						if (mode !== 2 && !_onOverwrite(curTween, tween)) {
							continue;
						}
						if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
							changed = true;
						}
					}
				}
				return changed;
			},
			_checkOverlap = function(tween, reference, zeroDur) {
				var tl = tween._timeline,
					ts = tl._timeScale,
					t = tween._startTime;
				while (tl._timeline) {
					t += tl._startTime;
					ts *= tl._timeScale;
					if (tl._paused) {
						return -100;
					}
					tl = tl._timeline;
				}
				t /= ts;
				return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
			};


//---- TweenLite instance methods -----------------------------------------------------------------------------

		p._init = function() {
			var v = this.vars,
				op = this._overwrittenProps,
				dur = this._duration,
				immediate = !!v.immediateRender,
				ease = v.ease,
				i, initPlugins, pt, p, startVars, l;
			if (v.startAt) {
				if (this._startAt) {
					this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					this._startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.data = "isStart";
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = (immediate && v.lazy !== false);
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				startVars.onUpdate = v.onUpdate;
				startVars.onUpdateParams = v.onUpdateParams;
				startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
				this._startAt = TweenLite.to(this.target || {}, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
						return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
					}
				}
			} else if (v.runBackwards && dur !== 0) {
				//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
				if (this._startAt) {
					this._startAt.render(-1, true);
					this._startAt.kill();
					this._startAt = null;
				} else {
					if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
						immediate = false;
					}
					pt = {};
					for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
						if (!_reservedProps[p] || p === "autoCSS") {
							pt[p] = v[p];
						}
					}
					pt.overwrite = 0;
					pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
					pt.lazy = (immediate && v.lazy !== false);
					pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
					this._startAt = TweenLite.to(this.target, 0, pt);
					if (!immediate) {
						this._startAt._init(); //ensures that the initial values are recorded
						this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
						if (this.vars.immediateRender) {
							this._startAt = null;
						}
					} else if (this._time === 0) {
						return;
					}
				}
			}
			this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;

			if (this._targets) {
				l = this._targets.length;
				for (i = 0; i < l; i++) {
					if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
			}

			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};

		p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}

			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}

			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}

				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {

					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					//m - mod           [function | 0]
					this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}

				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
				}
			}

			if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};

		p.render = function(time, suppressEvents, force) {
			var prevTime = this._time,
				duration = this._duration,
				prevRawPrevTime = this._rawPrevTime,
				isComplete, callback, pt, rawPrevTime;
			if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = this._time = duration;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				if (!this._reversed ) {
					isComplete = true;
					callback = "onComplete";
					force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = 0;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
							force = true;
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
					force = true;
				}
			} else {
				this._totalTime = this._time = time;

				if (this._easeType) {
					var r = time / duration, type = this._easeType, pow = this._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}

					if (type === 1) {
						this.ratio = 1 - r;
					} else if (type === 2) {
						this.ratio = r;
					} else if (time / duration < 0.5) {
						this.ratio = r / 2;
					} else {
						this.ratio = 1 - (r / 2);
					}

				} else {
					this.ratio = this._ease.getRatio(time / duration);
				}
			}

			if (this._time === prevTime && !force) {
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
					this._time = this._totalTime = prevTime;
					this._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd) {
					this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
				}
			}
			if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				this._lazy = false;
			}
			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (this._onUpdate) {
				if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
					this._callback("onUpdate");
				}
			}
			if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					this._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};

		p._kill = function(vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
			var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
				i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}

				if (propLookup) {
					killProps = vars || propLookup;
					record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}

					for (p in killProps) {
						if ((pt = propLookup[p])) {
							if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};

		p.invalidate = function() {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = (this._targets) ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(Math.min(0, -this._delay)); //in case delay is negative.
			}
			return this;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
					i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
			}
			return false;
		};


//----TweenLite static methods -----------------------------------------------------

		TweenLite.to = function(target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};

		TweenLite.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenLite(target, duration, vars);
		};

		TweenLite.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenLite(target, duration, toVars);
		};

		TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
		};

		TweenLite.set = function(target, vars) {
			return new TweenLite(target, 0, vars);
		};

		TweenLite.getTweensOf = function(target, onlyActive) {
			if (target == null) { return []; }
			target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else if (target._gsTweenID) {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || (onlyActive && !a[i].isActive())) {
						a.splice(i, 1);
					}
				}
			}
			return a || [];
		};

		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
			if (typeof(onlyActive) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
				i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};



/*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */
		var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
					this._overwriteProps = (props || "").split(",");
					this._propName = this._overwriteProps[0];
					this._priority = priority || 0;
					this._super = TweenPlugin.prototype;
				}, true);

		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.19.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;

		p._kill = function(lookup) {
			var a = this._overwriteProps,
				pt = this._firstPT,
				i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};

		p._mod = p._roundProps = function(lookup) {
			var pt = this._firstPT,
				val;
			while (pt) {
				val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
				if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					if (pt.f === 2) {
						pt.t._applyPT.m = val;
					} else {
						pt.m = val;
					}
				}
				pt = pt._next;
			}
		};

		TweenLite._onPluginEvent = function(type, tween) {
			var pt = tween._firstPT,
				changed, pt2, first, last, next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};

		TweenPlugin.activate = function(plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[(new plugins[i]())._propName] = plugins[i];
				}
			}
			return true;
		};

		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function(config) {
			if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
			var propName = config.propName,
				priority = config.priority || 0,
				overwriteProps = config.overwriteProps,
				map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
				Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
					function() {
						TweenPlugin.call(this, propName, priority);
						this._overwriteProps = overwriteProps || [];
					}, (config.global === true)),
				p = Plugin.prototype = new TweenPlugin(propName),
				prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof(config[prop]) === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};


		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: " + p);
				}
			}
		}

		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated

})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],641:[function(require,module,exports){
(function (global){(function (){

/*
 * Module requirements.
 */

var isArray = require('isarray');

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      // see: https://github.com/Automattic/has-binary/pull/4
      if (obj.toJSON && 'function' == typeof obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"isarray":642}],642:[function(require,module,exports){
module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],643:[function(require,module,exports){

/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}

},{}],644:[function(require,module,exports){
(function (global){(function (){
'use strict';

var origSymbol = global.Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./shams":645}],645:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],646:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"function-bind":637}],647:[function(require,module,exports){
"use strict";
var Buffer = require("safer-buffer").Buffer;

// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.

exports._dbcs = DBCSCodec;

var UNASSIGNED = -1,
    GB18030_CODE = -2,
    SEQ_START  = -10,
    NODE_START = -1000,
    UNASSIGNED_NODE = new Array(0x100),
    DEF_CHAR = -1;

for (var i = 0; i < 0x100; i++)
    UNASSIGNED_NODE[i] = UNASSIGNED;


// Class DBCSCodec reads and initializes mapping tables.
function DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions)
        throw new Error("DBCS codec is called without the data.")
    if (!codecOptions.table)
        throw new Error("Encoding '" + this.encodingName + "' has no data.");

    // Load tables.
    var mappingTable = codecOptions.table();


    // Decode tables: MBCS -> Unicode.

    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.

    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = [];

    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for (var i = 0; i < mappingTable.length; i++)
        this._addDecodeChunk(mappingTable[i]);

    this.defaultCharUnicode = iconv.defaultCharUnicode;

    
    // Encode tables: Unicode -> DBCS.

    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];

    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals)
        for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
            var val = codecOptions.encodeSkipVals[i];
            if (typeof val === 'number')
                skipEncodeChars[val] = true;
            else
                for (var j = val.from; j <= val.to; j++)
                    skipEncodeChars[j] = true;
        }
        
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);

    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for (var uChar in codecOptions.encodeAdd)
            if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar))
                this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }

    this.defCharSB  = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);


    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.

        // Add GB18030 decode tables.
        var thirdByteNodeIdx = this.decodeTables.length;
        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);

        var fourthByteNodeIdx = this.decodeTables.length;
        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);

        for (var i = 0x81; i <= 0xFE; i++) {
            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
            var secondByteNode = this.decodeTables[secondByteNodeIdx];
            for (var j = 0x30; j <= 0x39; j++)
                secondByteNode[j] = NODE_START - thirdByteNodeIdx;
        }
        for (var i = 0x81; i <= 0xFE; i++)
            thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
        for (var i = 0x30; i <= 0x39; i++)
            fourthByteNode[i] = GB18030_CODE
    }        
}

DBCSCodec.prototype.encoder = DBCSEncoder;
DBCSCodec.prototype.decoder = DBCSDecoder;

// Decoder helpers
DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for (; addr > 0; addr >>= 8)
        bytes.push(addr & 0xFF);
    if (bytes.length == 0)
        bytes.push(0);

    var node = this.decodeTables[0];
    for (var i = bytes.length-1; i > 0; i--) { // Traverse nodes deeper into the trie.
        var val = node[bytes[i]];

        if (val == UNASSIGNED) { // Create new node.
            node[bytes[i]] = NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
        }
        else if (val <= NODE_START) { // Existing node.
            node = this.decodeTables[NODE_START - val];
        }
        else
            throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
}


DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);

    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;

    // Write all other elements of the chunk to the table.
    for (var k = 1; k < chunk.length; k++) {
        var part = chunk[k];
        if (typeof part === "string") { // String, write as-is.
            for (var l = 0; l < part.length;) {
                var code = part.charCodeAt(l++);
                if (0xD800 <= code && code < 0xDC00) { // Decode surrogate
                    var codeTrail = part.charCodeAt(l++);
                    if (0xDC00 <= codeTrail && codeTrail < 0xE000)
                        writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                    else
                        throw new Error("Incorrect surrogate pair in "  + this.encodingName + " at chunk " + chunk[0]);
                }
                else if (0x0FF0 < code && code <= 0x0FFF) { // Character sequence (our own encoding used)
                    var len = 0xFFF - code + 2;
                    var seq = [];
                    for (var m = 0; m < len; m++)
                        seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.

                    writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                    this.decodeTableSeq.push(seq);
                }
                else
                    writeTable[curAddr++] = code; // Basic char
            }
        } 
        else if (typeof part === "number") { // Integer, meaning increasing sequence starting with prev character.
            var charCode = writeTable[curAddr - 1] + 1;
            for (var l = 0; l < part; l++)
                writeTable[curAddr++] = charCode++;
        }
        else
            throw new Error("Incorrect type '" + typeof part + "' given in "  + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF)
        throw new Error("Incorrect chunk in "  + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
}

// Encoder helpers
DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined)
        this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
}

DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= SEQ_START)
        this.encodeTableSeq[SEQ_START-bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == UNASSIGNED)
        bucket[low] = dbcsCode;
}

DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;

    var node;
    if (bucket[low] <= SEQ_START) {
        // There's already a sequence with  - use it.
        node = this.encodeTableSeq[SEQ_START-bucket[low]];
    }
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }

    // Traverse the character tree, allocating new nodes as needed.
    for (var j = 1; j < seq.length-1; j++) {
        var oldVal = node[uCode];
        if (typeof oldVal === 'object')
            node = oldVal;
        else {
            node = node[uCode] = {}
            if (oldVal !== undefined)
                node[DEF_CHAR] = oldVal
        }
    }

    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length-1];
    node[uCode] = dbcsCode;
}

DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    for (var i = 0; i < 0x100; i++) {
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode])
            continue;

        if (uCode >= 0)
            this._setEncodeChar(uCode, mbCode);
        else if (uCode <= NODE_START)
            this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
        else if (uCode <= SEQ_START)
            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
    }
}



// == Encoder ==================================================================

function DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}

DBCSEncoder.prototype.write = function(str) {
    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)),
        leadSurrogate = this.leadSurrogate,
        seqObj = this.seqObj, nextChar = -1,
        i = 0, j = 0;

    while (true) {
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        }
        else {
            var uCode = nextChar;
            nextChar = -1;    
        }

        // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) { // Char is one of surrogates.
            if (uCode < 0xDC00) { // We've got lead surrogate.
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = UNASSIGNED;
                }
            } else { // We've got trail surrogate.
                if (leadSurrogate !== -1) {
                    uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                    leadSurrogate = -1;
                } else {
                    // Incomplete surrogate pair - only trail surrogate found.
                    uCode = UNASSIGNED;
                }
                
            }
        }
        else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        }

        // 2. Convert uCode character.
        var dbcsCode = UNASSIGNED;
        if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') { // Sequence continues.
                seqObj = resCode;
                continue;

            } else if (typeof resCode == 'number') { // Sequence finished. Write it.
                dbcsCode = resCode;

            } else if (resCode == undefined) { // Current character is not part of the sequence.

                // Try default character for this sequence
                resCode = seqObj[DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.

                } else {
                    // TODO: What if we have no default? (resCode == undefined)
                    // Then, we should write first char of the sequence as-is and try the rest recursively.
                    // Didn't do it for now because no encoding has this situation yet.
                    // Currently, just skip the sequence and write current char.
                }
            }
            seqObj = undefined;
        }
        else if (uCode >= 0) {  // Regular character
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined)
                dbcsCode = subtable[uCode & 0xFF];
            
            if (dbcsCode <= SEQ_START) { // Sequence start
                seqObj = this.encodeTableSeq[SEQ_START-dbcsCode];
                continue;
            }

            if (dbcsCode == UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }

        // 3. Write dbcsCode character.
        if (dbcsCode === UNASSIGNED)
            dbcsCode = this.defaultCharSingleByte;
        
        if (dbcsCode < 0x100) {
            newBuf[j++] = dbcsCode;
        }
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8;   // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        }
        else {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = (dbcsCode >> 8) & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }

    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
}

DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined)
        return; // All clean. Most often case.

    var newBuf = Buffer.alloc(10), j = 0;

    if (this.seqObj) { // We're in the sequence.
        var dbcsCode = this.seqObj[DEF_CHAR];
        if (dbcsCode !== undefined) { // Write beginning of the sequence.
            if (dbcsCode < 0x100) {
                newBuf[j++] = dbcsCode;
            }
            else {
                newBuf[j++] = dbcsCode >> 8;   // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        } else {
            // See todo above.
        }
        this.seqObj = undefined;
    }

    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    
    return newBuf.slice(0, j);
}

// Export for testing
DBCSEncoder.prototype.findIdx = findIdx;


// == Decoder ==================================================================

function DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBuf = Buffer.alloc(0);

    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}

DBCSDecoder.prototype.write = function(buf) {
    var newBuf = Buffer.alloc(buf.length*2),
        nodeIdx = this.nodeIdx, 
        prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length,
        seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
        uCode;

    if (prevBufOffset > 0) // Make prev buf overlap a little to make it easier to slice later.
        prevBuf = Buffer.concat([prevBuf, buf.slice(0, 10)]);
    
    for (var i = 0, j = 0; i < buf.length; i++) {
        var curByte = (i >= 0) ? buf[i] : prevBuf[i + prevBufOffset];

        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];

        if (uCode >= 0) { 
            // Normal character, just use it.
        }
        else if (uCode === UNASSIGNED) { // Unknown char.
            // TODO: Callback with seq.
            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
            uCode = this.defaultCharUnicode.charCodeAt(0);
        }
        else if (uCode === GB18030_CODE) {
            var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            var ptr = (curSeq[0]-0x81)*12600 + (curSeq[1]-0x30)*1260 + (curSeq[2]-0x81)*10 + (curSeq[3]-0x30);
            var idx = findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        }
        else if (uCode <= NODE_START) { // Go to next trie node.
            nodeIdx = NODE_START - uCode;
            continue;
        }
        else if (uCode <= SEQ_START) { // Output a sequence of chars.
            var seq = this.decodeTableSeq[SEQ_START - uCode];
            for (var k = 0; k < seq.length - 1; k++) {
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length-1];
        }
        else
            throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);

        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode > 0xFFFF) { 
            uCode -= 0x10000;
            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;

            uCode = 0xDC00 + uCode % 0x400;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;

        // Reset trie node.
        nodeIdx = 0; seqStart = i+1;
    }

    this.nodeIdx = nodeIdx;
    this.prevBuf = (seqStart >= 0) ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
    return newBuf.slice(0, j).toString('ucs2');
}

DBCSDecoder.prototype.end = function() {
    var ret = '';

    // Try to parse all remaining chars.
    while (this.prevBuf.length > 0) {
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var buf = this.prevBuf.slice(1);

        // Parse remaining as usual.
        this.prevBuf = Buffer.alloc(0);
        this.nodeIdx = 0;
        if (buf.length > 0)
            ret += this.write(buf);
    }

    this.nodeIdx = 0;
    return ret;
}

// Binary search for GB18030. Returns largest i such that table[i] <= val.
function findIdx(table, val) {
    if (table[0] > val)
        return -1;

    var l = 0, r = table.length;
    while (l < r-1) { // always table[l] <= val < table[r]
        var mid = l + Math.floor((r-l+1)/2);
        if (table[mid] <= val)
            l = mid;
        else
            r = mid;
    }
    return l;
}


},{"safer-buffer":1156}],648:[function(require,module,exports){
"use strict";

// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.

module.exports = {
    
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)

    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html

    'shiftjis': {
        type: '_dbcs',
        table: function() { return require('./tables/shiftjis.json') },
        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
        encodeSkipVals: [{from: 0xED40, to: 0xF940}],
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',

    'eucjp': {
        type: '_dbcs',
        table: function() { return require('./tables/eucjp.json') },
        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
    },

    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.


    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder

    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',

    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function() { return require('./tables/cp936.json') },
    },

    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function() { return require('./tables/cp936.json').concat(require('./tables/gbk-added.json')) },
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',

    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function() { return require('./tables/cp936.json').concat(require('./tables/gbk-added.json')) },
        gb18030: function() { return require('./tables/gb18030-ranges.json') },
        encodeSkipVals: [0x80],
        encodeAdd: {'€': 0xA2E3},
    },

    'chinese': 'gb18030',


    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function() { return require('./tables/cp949.json') },
    },

    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',


    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.

    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function() { return require('./tables/cp950.json') },
    },

    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function() { return require('./tables/cp950.json').concat(require('./tables/big5-added.json')) },
        encodeSkipVals: [0xa2cc],
    },

    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs',
};

},{"./tables/big5-added.json":654,"./tables/cp936.json":655,"./tables/cp949.json":656,"./tables/cp950.json":657,"./tables/eucjp.json":658,"./tables/gb18030-ranges.json":659,"./tables/gbk-added.json":660,"./tables/shiftjis.json":661}],649:[function(require,module,exports){
"use strict";

// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var modules = [
    require("./internal"),
    require("./utf16"),
    require("./utf7"),
    require("./sbcs-codec"),
    require("./sbcs-data"),
    require("./sbcs-data-generated"),
    require("./dbcs-codec"),
    require("./dbcs-data"),
];

// Put all encoding/alias/codec definitions to single object and export it. 
for (var i = 0; i < modules.length; i++) {
    var module = modules[i];
    for (var enc in module)
        if (Object.prototype.hasOwnProperty.call(module, enc))
            exports[enc] = module[enc];
}

},{"./dbcs-codec":647,"./dbcs-data":648,"./internal":650,"./sbcs-codec":651,"./sbcs-data":653,"./sbcs-data-generated":652,"./utf16":662,"./utf7":663}],650:[function(require,module,exports){
"use strict";
var Buffer = require("safer-buffer").Buffer;

// Export Node.js internal encodings.

module.exports = {
    // Encodings
    utf8:   { type: "_internal", bomAware: true},
    cesu8:  { type: "_internal", bomAware: true},
    unicode11utf8: "utf8",

    ucs2:   { type: "_internal", bomAware: true},
    utf16le: "ucs2",

    binary: { type: "_internal" },
    base64: { type: "_internal" },
    hex:    { type: "_internal" },

    // Codec.
    _internal: InternalCodec,
};

//------------------------------------------------------------------------------

function InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;

    if (this.enc === "base64")
        this.encoder = InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = InternalEncoderCesu8;

        // Add decoder for versions of Node not supporting CESU-8
        if (Buffer.from('eda0bdedb2a9', 'hex').toString() !== '💩') {
            this.decoder = InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}

InternalCodec.prototype.encoder = InternalEncoder;
InternalCodec.prototype.decoder = InternalDecoder;

//------------------------------------------------------------------------------

// We use node.js internal decoder. Its signature is the same as ours.
var StringDecoder = require('string_decoder').StringDecoder;

if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
    StringDecoder.prototype.end = function() {};


function InternalDecoder(options, codec) {
    StringDecoder.call(this, codec.enc);
}

InternalDecoder.prototype = StringDecoder.prototype;


//------------------------------------------------------------------------------
// Encoder is mostly trivial

function InternalEncoder(options, codec) {
    this.enc = codec.enc;
}

InternalEncoder.prototype.write = function(str) {
    return Buffer.from(str, this.enc);
}

InternalEncoder.prototype.end = function() {
}


//------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.

function InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}

InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - (str.length % 4);
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);

    return Buffer.from(str, "base64");
}

InternalEncoderBase64.prototype.end = function() {
    return Buffer.from(this.prevStr, "base64");
}


//------------------------------------------------------------------------------
// CESU-8 encoder is also special.

function InternalEncoderCesu8(options, codec) {
}

InternalEncoderCesu8.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length * 3), bufIdx = 0;
    for (var i = 0; i < str.length; i++) {
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80)
            buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
        else { // charCode will always be < 0x10000 in javascript.
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
}

InternalEncoderCesu8.prototype.end = function() {
}

//------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+

function InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}

InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, 
        res = '';
    for (var i = 0; i < buf.length; i++) {
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) { // Leading byte
            if (contBytes > 0) { // Previous code is invalid
                res += this.defaultCharUnicode;
                contBytes = 0;
            }

            if (curByte < 0x80) { // Single-byte code
                res += String.fromCharCode(curByte);
            } else if (curByte < 0xE0) { // Two-byte code
                acc = curByte & 0x1F;
                contBytes = 1; accBytes = 1;
            } else if (curByte < 0xF0) { // Three-byte code
                acc = curByte & 0x0F;
                contBytes = 2; accBytes = 1;
            } else { // Four or more are not supported for CESU-8.
                res += this.defaultCharUnicode;
            }
        } else { // Continuation byte
            if (contBytes > 0) { // We're waiting for it.
                acc = (acc << 6) | (curByte & 0x3f);
                contBytes--; accBytes++;
                if (contBytes === 0) {
                    // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                    if (accBytes === 2 && acc < 0x80 && acc > 0)
                        res += this.defaultCharUnicode;
                    else if (accBytes === 3 && acc < 0x800)
                        res += this.defaultCharUnicode;
                    else
                        // Actually add character.
                        res += String.fromCharCode(acc);
                }
            } else { // Unexpected continuation byte
                res += this.defaultCharUnicode;
            }
        }
    }
    this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
    return res;
}

InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0)
        res += this.defaultCharUnicode;
    return res;
}

},{"safer-buffer":1156,"string_decoder":406}],651:[function(require,module,exports){
"use strict";
var Buffer = require("safer-buffer").Buffer;

// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 

exports._sbcs = SBCSCodec;
function SBCSCodec(codecOptions, iconv) {
    if (!codecOptions)
        throw new Error("SBCS codec is called without the data.")
    
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256))
        throw new Error("Encoding '"+codecOptions.type+"' has incorrect 'chars' (must be of len 128 or 256)");
    
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for (var i = 0; i < 128; i++)
            asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }

    this.decodeBuf = Buffer.from(codecOptions.chars, 'ucs2');
    
    // Encoding buffer.
    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));

    for (var i = 0; i < codecOptions.chars.length; i++)
        encodeBuf[codecOptions.chars.charCodeAt(i)] = i;

    this.encodeBuf = encodeBuf;
}

SBCSCodec.prototype.encoder = SBCSEncoder;
SBCSCodec.prototype.decoder = SBCSDecoder;


function SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}

SBCSEncoder.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length);
    for (var i = 0; i < str.length; i++)
        buf[i] = this.encodeBuf[str.charCodeAt(i)];
    
    return buf;
}

SBCSEncoder.prototype.end = function() {
}


function SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}

SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = Buffer.alloc(buf.length*2);
    var idx1 = 0, idx2 = 0;
    for (var i = 0; i < buf.length; i++) {
        idx1 = buf[i]*2; idx2 = i*2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2+1] = decodeBuf[idx1+1];
    }
    return newBuf.toString('ucs2');
}

SBCSDecoder.prototype.end = function() {
}

},{"safer-buffer":1156}],652:[function(require,module,exports){
"use strict";

// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
  "437": "cp437",
  "737": "cp737",
  "775": "cp775",
  "850": "cp850",
  "852": "cp852",
  "855": "cp855",
  "856": "cp856",
  "857": "cp857",
  "858": "cp858",
  "860": "cp860",
  "861": "cp861",
  "862": "cp862",
  "863": "cp863",
  "864": "cp864",
  "865": "cp865",
  "866": "cp866",
  "869": "cp869",
  "874": "windows874",
  "922": "cp922",
  "1046": "cp1046",
  "1124": "cp1124",
  "1125": "cp1125",
  "1129": "cp1129",
  "1133": "cp1133",
  "1161": "cp1161",
  "1162": "cp1162",
  "1163": "cp1163",
  "1250": "windows1250",
  "1251": "windows1251",
  "1252": "windows1252",
  "1253": "windows1253",
  "1254": "windows1254",
  "1255": "windows1255",
  "1256": "windows1256",
  "1257": "windows1257",
  "1258": "windows1258",
  "28591": "iso88591",
  "28592": "iso88592",
  "28593": "iso88593",
  "28594": "iso88594",
  "28595": "iso88595",
  "28596": "iso88596",
  "28597": "iso88597",
  "28598": "iso88598",
  "28599": "iso88599",
  "28600": "iso885910",
  "28601": "iso885911",
  "28603": "iso885913",
  "28604": "iso885914",
  "28605": "iso885915",
  "28606": "iso885916",
  "windows874": {
    "type": "_sbcs",
    "chars": "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  },
  "win874": "windows874",
  "cp874": "windows874",
  "windows1250": {
    "type": "_sbcs",
    "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
  },
  "win1250": "windows1250",
  "cp1250": "windows1250",
  "windows1251": {
    "type": "_sbcs",
    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
  },
  "win1251": "windows1251",
  "cp1251": "windows1251",
  "windows1252": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "win1252": "windows1252",
  "cp1252": "windows1252",
  "windows1253": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
  },
  "win1253": "windows1253",
  "cp1253": "windows1253",
  "windows1254": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
  },
  "win1254": "windows1254",
  "cp1254": "windows1254",
  "windows1255": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
  },
  "win1255": "windows1255",
  "cp1255": "windows1255",
  "windows1256": {
    "type": "_sbcs",
    "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
  },
  "win1256": "windows1256",
  "cp1256": "windows1256",
  "windows1257": {
    "type": "_sbcs",
    "chars": "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
  },
  "win1257": "windows1257",
  "cp1257": "windows1257",
  "windows1258": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
  },
  "win1258": "windows1258",
  "cp1258": "windows1258",
  "iso88591": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "cp28591": "iso88591",
  "iso88592": {
    "type": "_sbcs",
    "chars": " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
  },
  "cp28592": "iso88592",
  "iso88593": {
    "type": "_sbcs",
    "chars": " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
  },
  "cp28593": "iso88593",
  "iso88594": {
    "type": "_sbcs",
    "chars": " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
  },
  "cp28594": "iso88594",
  "iso88595": {
    "type": "_sbcs",
    "chars": " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
  },
  "cp28595": "iso88595",
  "iso88596": {
    "type": "_sbcs",
    "chars": " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
  },
  "cp28596": "iso88596",
  "iso88597": {
    "type": "_sbcs",
    "chars": " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
  },
  "cp28597": "iso88597",
  "iso88598": {
    "type": "_sbcs",
    "chars": " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
  },
  "cp28598": "iso88598",
  "iso88599": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
  },
  "cp28599": "iso88599",
  "iso885910": {
    "type": "_sbcs",
    "chars": " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
  },
  "cp28600": "iso885910",
  "iso885911": {
    "type": "_sbcs",
    "chars": " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  },
  "cp28601": "iso885911",
  "iso885913": {
    "type": "_sbcs",
    "chars": " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
  },
  "cp28603": "iso885913",
  "iso885914": {
    "type": "_sbcs",
    "chars": " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
  },
  "cp28604": "iso885914",
  "iso885915": {
    "type": "_sbcs",
    "chars": " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "cp28605": "iso885915",
  "iso885916": {
    "type": "_sbcs",
    "chars": " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
  },
  "cp28606": "iso885916",
  "cp437": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm437": "cp437",
  "csibm437": "cp437",
  "cp737": {
    "type": "_sbcs",
    "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
  },
  "ibm737": "cp737",
  "csibm737": "cp737",
  "cp775": {
    "type": "_sbcs",
    "chars": "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
  },
  "ibm775": "cp775",
  "csibm775": "cp775",
  "cp850": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
  },
  "ibm850": "cp850",
  "csibm850": "cp850",
  "cp852": {
    "type": "_sbcs",
    "chars": "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
  },
  "ibm852": "cp852",
  "csibm852": "cp852",
  "cp855": {
    "type": "_sbcs",
    "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
  },
  "ibm855": "cp855",
  "csibm855": "cp855",
  "cp856": {
    "type": "_sbcs",
    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
  },
  "ibm856": "cp856",
  "csibm856": "cp856",
  "cp857": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
  },
  "ibm857": "cp857",
  "csibm857": "cp857",
  "cp858": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
  },
  "ibm858": "cp858",
  "csibm858": "cp858",
  "cp860": {
    "type": "_sbcs",
    "chars": "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm860": "cp860",
  "csibm860": "cp860",
  "cp861": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm861": "cp861",
  "csibm861": "cp861",
  "cp862": {
    "type": "_sbcs",
    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm862": "cp862",
  "csibm862": "cp862",
  "cp863": {
    "type": "_sbcs",
    "chars": "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm863": "cp863",
  "csibm863": "cp863",
  "cp864": {
    "type": "_sbcs",
    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
  },
  "ibm864": "cp864",
  "csibm864": "cp864",
  "cp865": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm865": "cp865",
  "csibm865": "cp865",
  "cp866": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
  },
  "ibm866": "cp866",
  "csibm866": "cp866",
  "cp869": {
    "type": "_sbcs",
    "chars": "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
  },
  "ibm869": "cp869",
  "csibm869": "cp869",
  "cp922": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
  },
  "ibm922": "cp922",
  "csibm922": "cp922",
  "cp1046": {
    "type": "_sbcs",
    "chars": "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
  },
  "ibm1046": "cp1046",
  "csibm1046": "cp1046",
  "cp1124": {
    "type": "_sbcs",
    "chars": " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
  },
  "ibm1124": "cp1124",
  "csibm1124": "cp1124",
  "cp1125": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
  },
  "ibm1125": "cp1125",
  "csibm1125": "cp1125",
  "cp1129": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
  },
  "ibm1129": "cp1129",
  "csibm1129": "cp1129",
  "cp1133": {
    "type": "_sbcs",
    "chars": " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
  },
  "ibm1133": "cp1133",
  "csibm1133": "cp1133",
  "cp1161": {
    "type": "_sbcs",
    "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
  },
  "ibm1161": "cp1161",
  "csibm1161": "cp1161",
  "cp1162": {
    "type": "_sbcs",
    "chars": "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  },
  "ibm1162": "cp1162",
  "csibm1162": "cp1162",
  "cp1163": {
    "type": "_sbcs",
    "chars": " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
  },
  "ibm1163": "cp1163",
  "csibm1163": "cp1163",
  "maccroatian": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
  },
  "maccyrillic": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
  },
  "macgreek": {
    "type": "_sbcs",
    "chars": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
  },
  "maciceland": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macroman": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macromania": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macthai": {
    "type": "_sbcs",
    "chars": "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
  },
  "macturkish": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macukraine": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
  },
  "koi8r": {
    "type": "_sbcs",
    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "koi8u": {
    "type": "_sbcs",
    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "koi8ru": {
    "type": "_sbcs",
    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "koi8t": {
    "type": "_sbcs",
    "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "armscii8": {
    "type": "_sbcs",
    "chars": " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
  },
  "rk1048": {
    "type": "_sbcs",
    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
  },
  "tcvn": {
    "type": "_sbcs",
    "chars": "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ"
  },
  "georgianacademy": {
    "type": "_sbcs",
    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "georgianps": {
    "type": "_sbcs",
    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "pt154": {
    "type": "_sbcs",
    "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
  },
  "viscii": {
    "type": "_sbcs",
    "chars": "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ"
  },
  "iso646cn": {
    "type": "_sbcs",
    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
  },
  "iso646jp": {
    "type": "_sbcs",
    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
  },
  "hproman8": {
    "type": "_sbcs",
    "chars": " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
  },
  "macintosh": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "ascii": {
    "type": "_sbcs",
    "chars": "��������������������������������������������������������������������������������������������������������������������������������"
  },
  "tis620": {
    "type": "_sbcs",
    "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  }
}
},{}],653:[function(require,module,exports){
"use strict";

// Manually added data to be used by sbcs codec in addition to generated one.

module.exports = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
    },

    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
    },

    "mik": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№§╗╝┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
    },

    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",

    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",

    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek" : "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",

    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",

    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",

    "cp819": "iso88591",
    "ibm819": "iso88591",

    "cyrillic": "iso88595",

    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",

    "greek" : "iso88597",
    "greek8" : "iso88597",
    "ecma118" : "iso88597",
    "elot928" : "iso88597",

    "hebrew": "iso88598",
    "hebrew8": "iso88598",

    "turkish": "iso88599",
    "turkish8": "iso88599",

    "thai": "iso885911",
    "thai8": "iso885911",

    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",

    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",

    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",

    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",

    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",

    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",

    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",

    "strk10482002": "rk1048",

    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",

    "gb198880": "iso646cn",
    "cn": "iso646cn",

    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",

    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",

    "mac": "macintosh",
    "csmacintosh": "macintosh",
};


},{}],654:[function(require,module,exports){
module.exports=[
["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],
["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],
["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],
["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],
["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],
["8940","𪎩𡅅"],
["8943","攊"],
["8946","丽滝鵎釟"],
["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],
["89a1","琑糼緍楆竉刧"],
["89ab","醌碸酞肼"],
["89b0","贋胶𠧧"],
["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],
["89c1","溚舾甙"],
["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],
["8a40","𧶄唥"],
["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],
["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],
["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],
["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],
["8aac","䠋𠆩㿺塳𢶍"],
["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],
["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],
["8ac9","𪘁𠸉𢫏𢳉"],
["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],
["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],
["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],
["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],
["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],
["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],
["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],
["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],
["8ca1","𣏹椙橃𣱣泿"],
["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],
["8cc9","顨杫䉶圽"],
["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],
["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],
["8d40","𠮟"],
["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],
["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],
["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],
["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],
["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],
["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],
["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],
["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],
["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],
["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],
["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],
["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],
["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],
["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],
["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],
["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],
["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],
["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],
["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],
["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],
["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],
["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],
["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],
["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],
["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],
["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],
["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],
["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],
["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],
["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],
["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],
["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],
["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],
["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],
["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],
["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],
["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],
["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],
["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],
["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],
["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],
["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],
["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],
["9fae","酙隁酜"],
["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],
["9fc1","𤤙盖鮝个𠳔莾衂"],
["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],
["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],
["9fe7","毺蠘罸"],
["9feb","嘠𪙊蹷齓"],
["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],
["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],
["a055","𡠻𦸅"],
["a058","詾𢔛"],
["a05b","惽癧髗鵄鍮鮏蟵"],
["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],
["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],
["a0a1","嵗𨯂迚𨸹"],
["a0a6","僙𡵆礆匲阸𠼻䁥"],
["a0ae","矾"],
["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],
["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],
["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],
["a3c0","␀",31,"␡"],
["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],
["c740","す",58,"ァアィイ"],
["c7a1","ゥ",81,"А",5,"ЁЖ",4],
["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],
["c8a1","龰冈龱𧘇"],
["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],
["c8f5","ʃɐɛɔɵœøŋʊɪ"],
["f9fe","￭"],
["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],
["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],
["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],
["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],
["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],
["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],
["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],
["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],
["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],
["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]
]

},{}],655:[function(require,module,exports){
module.exports=[
["0","\u0000",127,"€"],
["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],
["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],
["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],
["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],
["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],
["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],
["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],
["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],
["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],
["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],
["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],
["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],
["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],
["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],
["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],
["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],
["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],
["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],
["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],
["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],
["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],
["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],
["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],
["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],
["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],
["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],
["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],
["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],
["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],
["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],
["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],
["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],
["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],
["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],
["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],
["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],
["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],
["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],
["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],
["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],
["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],
["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],
["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],
["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],
["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],
["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],
["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],
["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],
["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],
["9980","檧檨檪檭",114,"欥欦欨",6],
["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],
["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],
["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],
["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],
["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],
["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],
["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],
["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],
["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],
["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],
["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],
["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],
["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],
["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],
["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],
["a2a1","ⅰ",9],
["a2b1","⒈",19,"⑴",19,"①",9],
["a2e5","㈠",9],
["a2f1","Ⅰ",11],
["a3a1","！＂＃￥％",88,"￣"],
["a4a1","ぁ",82],
["a5a1","ァ",85],
["a6a1","Α",16,"Σ",6],
["a6c1","α",16,"σ",6],
["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],
["a6ee","︻︼︷︸︱"],
["a6f4","︳︴"],
["a7a1","А",5,"ЁЖ",25],
["a7d1","а",5,"ёж",25],
["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],
["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],
["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],
["a8bd","ńň"],
["a8c0","ɡ"],
["a8c5","ㄅ",36],
["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],
["a959","℡㈱"],
["a95c","‐"],
["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],
["a980","﹢",4,"﹨﹩﹪﹫"],
["a996","〇"],
["a9a4","─",75],
["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],
["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],
["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],
["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],
["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],
["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],
["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],
["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],
["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],
["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],
["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],
["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],
["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],
["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],
["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],
["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],
["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],
["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],
["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],
["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],
["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],
["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],
["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],
["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],
["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],
["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],
["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],
["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],
["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],
["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],
["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],
["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],
["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],
["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],
["bb40","籃",9,"籎",36,"籵",5,"籾",9],
["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],
["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],
["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],
["bd40","紷",54,"絯",7],
["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],
["be40","継",12,"綧",6,"綯",42],
["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],
["bf40","緻",62],
["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],
["c040","繞",35,"纃",23,"纜纝纞"],
["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],
["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],
["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],
["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],
["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],
["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],
["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],
["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],
["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],
["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],
["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],
["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],
["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],
["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],
["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],
["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],
["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],
["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],
["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],
["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],
["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],
["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],
["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],
["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],
["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],
["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],
["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],
["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],
["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],
["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],
["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],
["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],
["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],
["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],
["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],
["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],
["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],
["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],
["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],
["d440","訞",31,"訿",8,"詉",21],
["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],
["d540","誁",7,"誋",7,"誔",46],
["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],
["d640","諤",34,"謈",27],
["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],
["d740","譆",31,"譧",4,"譭",25],
["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],
["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],
["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],
["d940","貮",62],
["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],
["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],
["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],
["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],
["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],
["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],
["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],
["dd40","軥",62],
["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],
["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],
["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],
["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],
["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],
["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],
["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],
["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],
["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],
["e240","釦",62],
["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],
["e340","鉆",45,"鉵",16],
["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],
["e440","銨",5,"銯",24,"鋉",31],
["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],
["e540","錊",51,"錿",10],
["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],
["e640","鍬",34,"鎐",27],
["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],
["e740","鏎",7,"鏗",54],
["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],
["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],
["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],
["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],
["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],
["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],
["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],
["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],
["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],
["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],
["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],
["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],
["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],
["ee40","頏",62],
["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],
["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],
["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],
["f040","餈",4,"餎餏餑",28,"餯",26],
["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],
["f140","馌馎馚",10,"馦馧馩",47],
["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],
["f240","駺",62],
["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],
["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],
["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],
["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],
["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],
["f540","魼",62],
["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],
["f640","鯜",62],
["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],
["f740","鰼",62],
["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],
["f840","鳣",62],
["f880","鴢",32],
["f940","鵃",62],
["f980","鶂",32],
["fa40","鶣",62],
["fa80","鷢",32],
["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],
["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],
["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],
["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],
["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],
["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],
["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]
]

},{}],656:[function(require,module,exports){
module.exports=[
["0","\u0000",127],
["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],
["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],
["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],
["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],
["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],
["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],
["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],
["8361","긝",18,"긲긳긵긶긹긻긼"],
["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],
["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],
["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],
["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],
["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],
["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],
["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],
["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],
["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],
["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],
["8741","놞",9,"놩",15],
["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],
["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],
["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],
["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],
["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],
["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],
["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],
["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],
["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],
["8a61","둧",4,"둭",18,"뒁뒂"],
["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],
["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],
["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],
["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],
["8c41","똀",15,"똒똓똕똖똗똙",4],
["8c61","똞",6,"똦",5,"똭",6,"똵",5],
["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],
["8d41","뛃",16,"뛕",8],
["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],
["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],
["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],
["8e61","럂",4,"럈럊",19],
["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],
["8f41","뢅",7,"뢎",17],
["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],
["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],
["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],
["9061","륾",5,"릆릈릋릌릏",15],
["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],
["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],
["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],
["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],
["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],
["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],
["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],
["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],
["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],
["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],
["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],
["9461","봞",5,"봥",6,"봭",12],
["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],
["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],
["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],
["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],
["9641","뺸",23,"뻒뻓"],
["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],
["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],
["9741","뾃",16,"뾕",8],
["9761","뾞",17,"뾱",7],
["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],
["9841","쁀",16,"쁒",5,"쁙쁚쁛"],
["9861","쁝쁞쁟쁡",6,"쁪",15],
["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],
["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],
["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],
["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],
["9a41","숤숥숦숧숪숬숮숰숳숵",16],
["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],
["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],
["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],
["9b61","쌳",17,"썆",7],
["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],
["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],
["9c61","쏿",8,"쐉",6,"쐑",9],
["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],
["9d41","쒪",13,"쒹쒺쒻쒽",8],
["9d61","쓆",25],
["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],
["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],
["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],
["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],
["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],
["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],
["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],
["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],
["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],
["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],
["a141","좥좦좧좩",18,"좾좿죀죁"],
["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],
["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],
["a241","줐줒",5,"줙",18],
["a261","줭",6,"줵",18],
["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],
["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],
["a361","즑",6,"즚즜즞",16],
["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],
["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],
["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],
["a481","쨦쨧쨨쨪",28,"ㄱ",93],
["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],
["a561","쩫",17,"쩾",5,"쪅쪆"],
["a581","쪇",16,"쪙",14,"ⅰ",9],
["a5b0","Ⅰ",9],
["a5c1","Α",16,"Σ",6],
["a5e1","α",16,"σ",6],
["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],
["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],
["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],
["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],
["a761","쬪",22,"쭂쭃쭄"],
["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],
["a841","쭭",10,"쭺",14],
["a861","쮉",18,"쮝",6],
["a881","쮤",19,"쮹",11,"ÆÐªĦ"],
["a8a6","Ĳ"],
["a8a8","ĿŁØŒºÞŦŊ"],
["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],
["a941","쯅",14,"쯕",10],
["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],
["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],
["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],
["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],
["aa81","챳챴챶",29,"ぁ",82],
["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],
["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],
["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],
["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],
["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],
["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],
["acd1","а",5,"ёж",25],
["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],
["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],
["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],
["ae41","췆",5,"췍췎췏췑",16],
["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],
["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],
["af41","츬츭츮츯츲츴츶",19],
["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],
["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],
["b041","캚",5,"캢캦",5,"캮",12],
["b061","캻",5,"컂",19],
["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],
["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],
["b161","켥",6,"켮켲",5,"켹",11],
["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],
["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],
["b261","쾎",18,"쾢",5,"쾩"],
["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],
["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],
["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],
["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],
["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],
["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],
["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],
["b541","킕",14,"킦킧킩킪킫킭",5],
["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],
["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],
["b641","턅",7,"턎",17],
["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],
["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],
["b741","텮",13,"텽",6,"톅톆톇톉톊"],
["b761","톋",20,"톢톣톥톦톧"],
["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],
["b841","퇐",7,"퇙",17],
["b861","퇫",8,"퇵퇶퇷퇹",13],
["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],
["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],
["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],
["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],
["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],
["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],
["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],
["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],
["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],
["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],
["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],
["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],
["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],
["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],
["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],
["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],
["be41","퐸",7,"푁푂푃푅",14],
["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],
["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],
["bf41","풞",10,"풪",14],
["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],
["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],
["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],
["c061","픞",25],
["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],
["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],
["c161","햌햍햎햏햑",19,"햦햧"],
["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],
["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],
["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],
["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],
["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],
["c361","홢",4,"홨홪",5,"홲홳홵",11],
["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],
["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],
["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],
["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],
["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],
["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],
["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],
["c641","힍힎힏힑",6,"힚힜힞",5],
["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],
["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],
["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],
["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],
["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],
["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],
["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],
["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],
["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],
["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],
["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],
["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],
["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],
["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],
["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],
["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],
["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],
["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],
["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],
["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],
["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],
["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],
["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],
["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],
["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],
["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],
["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],
["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],
["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],
["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],
["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],
["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],
["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],
["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],
["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],
["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],
["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],
["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],
["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],
["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],
["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],
["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],
["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],
["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],
["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],
["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],
["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],
["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],
["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],
["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],
["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],
["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],
["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],
["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],
["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]
]

},{}],657:[function(require,module,exports){
module.exports=[
["0","\u0000",127],
["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],
["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],
["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],
["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],
["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],
["a3a1","ㄐ",25,"˙ˉˊˇˋ"],
["a3e1","€"],
["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],
["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],
["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],
["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],
["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],
["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],
["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],
["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],
["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],
["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],
["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],
["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],
["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],
["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],
["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],
["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],
["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],
["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],
["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],
["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],
["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],
["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],
["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],
["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],
["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],
["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],
["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],
["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],
["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],
["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],
["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],
["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],
["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],
["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],
["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],
["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],
["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],
["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],
["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],
["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],
["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],
["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],
["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],
["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],
["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],
["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],
["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],
["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],
["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],
["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],
["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],
["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],
["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],
["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],
["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],
["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],
["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],
["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],
["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],
["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],
["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],
["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],
["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],
["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],
["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],
["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],
["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],
["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],
["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],
["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],
["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],
["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],
["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],
["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],
["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],
["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],
["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],
["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],
["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],
["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],
["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],
["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],
["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],
["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],
["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],
["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],
["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],
["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],
["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],
["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],
["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],
["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],
["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],
["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],
["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],
["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],
["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],
["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],
["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],
["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],
["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],
["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],
["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],
["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],
["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],
["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],
["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],
["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],
["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],
["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],
["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],
["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],
["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],
["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],
["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],
["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],
["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],
["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],
["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],
["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],
["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],
["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],
["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],
["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],
["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],
["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],
["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],
["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],
["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],
["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],
["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],
["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],
["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],
["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],
["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],
["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],
["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],
["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],
["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],
["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],
["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],
["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],
["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],
["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],
["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],
["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],
["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],
["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],
["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],
["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],
["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],
["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],
["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],
["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],
["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],
["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],
["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],
["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],
["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],
["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],
["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],
["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],
["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],
["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],
["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],
["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],
["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]
]

},{}],658:[function(require,module,exports){
module.exports=[
["0","\u0000",127],
["8ea1","｡",62],
["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],
["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],
["a2ba","∈∋⊆⊇⊂⊃∪∩"],
["a2ca","∧∨￢⇒⇔∀∃"],
["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],
["a2f2","Å‰♯♭♪†‡¶"],
["a2fe","◯"],
["a3b0","０",9],
["a3c1","Ａ",25],
["a3e1","ａ",25],
["a4a1","ぁ",82],
["a5a1","ァ",85],
["a6a1","Α",16,"Σ",6],
["a6c1","α",16,"σ",6],
["a7a1","А",5,"ЁЖ",25],
["a7d1","а",5,"ёж",25],
["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],
["ada1","①",19,"Ⅰ",9],
["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],
["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],
["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],
["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],
["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],
["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],
["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],
["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],
["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],
["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],
["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],
["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],
["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],
["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],
["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],
["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],
["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],
["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],
["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],
["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],
["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],
["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],
["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],
["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],
["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],
["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],
["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],
["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],
["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],
["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],
["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],
["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],
["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],
["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],
["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],
["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],
["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],
["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],
["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],
["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],
["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],
["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],
["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],
["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],
["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],
["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],
["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],
["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],
["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],
["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],
["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],
["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],
["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],
["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],
["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],
["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],
["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],
["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],
["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],
["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],
["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],
["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],
["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],
["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],
["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],
["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],
["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],
["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],
["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],
["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],
["f4a1","堯槇遙瑤凜熙"],
["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],
["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],
["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],
["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],
["fcf1","ⅰ",9,"￢￤＇＂"],
["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],
["8fa2c2","¡¦¿"],
["8fa2eb","ºª©®™¤№"],
["8fa6e1","ΆΈΉΊΪ"],
["8fa6e7","Ό"],
["8fa6e9","ΎΫ"],
["8fa6ec","Ώ"],
["8fa6f1","άέήίϊΐόςύϋΰώ"],
["8fa7c2","Ђ",10,"ЎЏ"],
["8fa7f2","ђ",10,"ўџ"],
["8fa9a1","ÆĐ"],
["8fa9a4","Ħ"],
["8fa9a6","Ĳ"],
["8fa9a8","ŁĿ"],
["8fa9ab","ŊØŒ"],
["8fa9af","ŦÞ"],
["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],
["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],
["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],
["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],
["8fabbd","ġĥíìïîǐ"],
["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],
["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],
["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],
["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],
["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],
["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],
["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],
["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],
["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],
["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],
["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],
["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],
["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],
["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],
["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],
["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],
["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],
["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],
["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],
["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],
["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],
["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],
["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],
["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],
["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],
["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],
["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],
["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],
["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],
["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],
["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],
["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],
["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],
["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],
["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],
["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],
["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],
["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],
["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],
["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],
["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],
["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],
["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],
["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],
["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],
["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],
["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],
["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],
["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],
["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],
["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],
["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],
["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],
["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],
["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],
["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],
["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],
["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],
["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],
["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],
["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],
["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],
["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]
]

},{}],659:[function(require,module,exports){
module.exports={"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}
},{}],660:[function(require,module,exports){
module.exports=[
["a140","",62],
["a180","",32],
["a240","",62],
["a280","",32],
["a2ab","",5],
["a2e3","€"],
["a2ef",""],
["a2fd",""],
["a340","",62],
["a380","",31,"　"],
["a440","",62],
["a480","",32],
["a4f4","",10],
["a540","",62],
["a580","",32],
["a5f7","",7],
["a640","",62],
["a680","",32],
["a6b9","",7],
["a6d9","",6],
["a6ec",""],
["a6f3",""],
["a6f6","",8],
["a740","",62],
["a780","",32],
["a7c2","",14],
["a7f2","",12],
["a896","",10],
["a8bc",""],
["a8bf","ǹ"],
["a8c1",""],
["a8ea","",20],
["a958",""],
["a95b",""],
["a95d",""],
["a989","〾⿰",11],
["a997","",12],
["a9f0","",14],
["aaa1","",93],
["aba1","",93],
["aca1","",93],
["ada1","",93],
["aea1","",93],
["afa1","",93],
["d7fa","",4],
["f8a1","",93],
["f9a1","",93],
["faa1","",93],
["fba1","",93],
["fca1","",93],
["fda1","",93],
["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],
["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]
]

},{}],661:[function(require,module,exports){
module.exports=[
["0","\u0000",128],
["a1","｡",62],
["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],
["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],
["81b8","∈∋⊆⊇⊂⊃∪∩"],
["81c8","∧∨￢⇒⇔∀∃"],
["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],
["81f0","Å‰♯♭♪†‡¶"],
["81fc","◯"],
["824f","０",9],
["8260","Ａ",25],
["8281","ａ",25],
["829f","ぁ",82],
["8340","ァ",62],
["8380","ム",22],
["839f","Α",16,"Σ",6],
["83bf","α",16,"σ",6],
["8440","А",5,"ЁЖ",25],
["8470","а",5,"ёж",7],
["8480","о",17],
["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],
["8740","①",19,"Ⅰ",9],
["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],
["877e","㍻"],
["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],
["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],
["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],
["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],
["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],
["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],
["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],
["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],
["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],
["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],
["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],
["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],
["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],
["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],
["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],
["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],
["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],
["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],
["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],
["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],
["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],
["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],
["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],
["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],
["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],
["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],
["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],
["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],
["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],
["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],
["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],
["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],
["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],
["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],
["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],
["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],
["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],
["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],
["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],
["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],
["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],
["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],
["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],
["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],
["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],
["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],
["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],
["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],
["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],
["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],
["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],
["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],
["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],
["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],
["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],
["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],
["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],
["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],
["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],
["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],
["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],
["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],
["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],
["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],
["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],
["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],
["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],
["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],
["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],
["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],
["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],
["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],
["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],
["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],
["eeef","ⅰ",9,"￢￤＇＂"],
["f040","",62],
["f080","",124],
["f140","",62],
["f180","",124],
["f240","",62],
["f280","",124],
["f340","",62],
["f380","",124],
["f440","",62],
["f480","",124],
["f540","",62],
["f580","",124],
["f640","",62],
["f680","",124],
["f740","",62],
["f780","",124],
["f840","",62],
["f880","",124],
["f940",""],
["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],
["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],
["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],
["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],
["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]
]

},{}],662:[function(require,module,exports){
"use strict";
var Buffer = require("safer-buffer").Buffer;

// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js

// == UTF16-BE codec. ==========================================================

exports.utf16be = Utf16BECodec;
function Utf16BECodec() {
}

Utf16BECodec.prototype.encoder = Utf16BEEncoder;
Utf16BECodec.prototype.decoder = Utf16BEDecoder;
Utf16BECodec.prototype.bomAware = true;


// -- Encoding

function Utf16BEEncoder() {
}

Utf16BEEncoder.prototype.write = function(str) {
    var buf = Buffer.from(str, 'ucs2');
    for (var i = 0; i < buf.length; i += 2) {
        var tmp = buf[i]; buf[i] = buf[i+1]; buf[i+1] = tmp;
    }
    return buf;
}

Utf16BEEncoder.prototype.end = function() {
}


// -- Decoding

function Utf16BEDecoder() {
    this.overflowByte = -1;
}

Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0)
        return '';

    var buf2 = Buffer.alloc(buf.length + 1),
        i = 0, j = 0;

    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1; j = 2;
    }

    for (; i < buf.length-1; i += 2, j+= 2) {
        buf2[j] = buf[i+1];
        buf2[j+1] = buf[i];
    }

    this.overflowByte = (i == buf.length-1) ? buf[buf.length-1] : -1;

    return buf2.slice(0, j).toString('ucs2');
}

Utf16BEDecoder.prototype.end = function() {
}


// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});

// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).

exports.utf16 = Utf16Codec;
function Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}

Utf16Codec.prototype.encoder = Utf16Encoder;
Utf16Codec.prototype.decoder = Utf16Decoder;


// -- Encoding (pass-through)

function Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined)
        options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}

Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
}

Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
}


// -- Decoding

function Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBytes = [];
    this.initialBytesLen = 0;

    this.options = options || {};
    this.iconv = codec.iconv;
}

Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBytes.push(buf);
        this.initialBytesLen += buf.length;
        
        if (this.initialBytesLen < 16) // We need more bytes to use space heuristic (see below)
            return '';

        // We have enough bytes -> detect endianness.
        var buf = Buffer.concat(this.initialBytes),
            encoding = detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        this.initialBytes.length = this.initialBytesLen = 0;
    }

    return this.decoder.write(buf);
}

Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var buf = Buffer.concat(this.initialBytes),
            encoding = detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);

        var res = this.decoder.write(buf),
            trail = this.decoder.end();

        return trail ? (res + trail) : res;
    }
    return this.decoder.end();
}

function detectEncoding(buf, defaultEncoding) {
    var enc = defaultEncoding || 'utf-16le';

    if (buf.length >= 2) {
        // Check BOM.
        if (buf[0] == 0xFE && buf[1] == 0xFF) // UTF-16BE BOM
            enc = 'utf-16be';
        else if (buf[0] == 0xFF && buf[1] == 0xFE) // UTF-16LE BOM
            enc = 'utf-16le';
        else {
            // No BOM found. Try to deduce encoding from initial content.
            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
            // So, we count ASCII as if it was LE or BE, and decide from that.
            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
                _len = Math.min(buf.length - (buf.length % 2), 64); // Len is always even.

            for (var i = 0; i < _len; i += 2) {
                if (buf[i] === 0 && buf[i+1] !== 0) asciiCharsBE++;
                if (buf[i] !== 0 && buf[i+1] === 0) asciiCharsLE++;
            }

            if (asciiCharsBE > asciiCharsLE)
                enc = 'utf-16be';
            else if (asciiCharsBE < asciiCharsLE)
                enc = 'utf-16le';
        }
    }

    return enc;
}



},{"safer-buffer":1156}],663:[function(require,module,exports){
"use strict";
var Buffer = require("safer-buffer").Buffer;

// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3

exports.utf7 = Utf7Codec;
exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
};

Utf7Codec.prototype.encoder = Utf7Encoder;
Utf7Codec.prototype.decoder = Utf7Decoder;
Utf7Codec.prototype.bomAware = true;


// -- Encoding

var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;

function Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}

Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return Buffer.from(str.replace(nonDirectChars, function(chunk) {
        return "+" + (chunk === '+' ? '' : 
            this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) 
            + "-";
    }.bind(this)));
}

Utf7Encoder.prototype.end = function() {
}


// -- Decoding

function Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}

var base64Regex = /[A-Za-z0-9\/+]/;
var base64Chars = [];
for (var i = 0; i < 256; i++)
    base64Chars[i] = base64Regex.test(String.fromCharCode(i));

var plusChar = '+'.charCodeAt(0), 
    minusChar = '-'.charCodeAt(0),
    andChar = '&'.charCodeAt(0);

Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0,
        inBase64 = this.inBase64,
        base64Accum = this.base64Accum;

    // The decoder is more involved as we must handle chunks in stream.

    for (var i = 0; i < buf.length; i++) {
        if (!inBase64) { // We're in direct mode.
            // Write direct chars until '+'
            if (buf[i] == plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i+1;
                inBase64 = true;
            }
        } else { // We decode base64.
            if (!base64Chars[buf[i]]) { // Base64 ended.
                if (i == lastI && buf[i] == minusChar) {// "+-" -> "+"
                    res += "+";
                } else {
                    var b64str = base64Accum + buf.slice(lastI, i).toString();
                    res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                }

                if (buf[i] != minusChar) // Minus is absorbed after base64.
                    i--;

                lastI = i+1;
                inBase64 = false;
                base64Accum = '';
            }
        }
    }

    if (!inBase64) {
        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    } else {
        var b64str = base64Accum + buf.slice(lastI).toString();

        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);

        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
    }

    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;

    return res;
}

Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0)
        res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");

    this.inBase64 = false;
    this.base64Accum = '';
    return res;
}


// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.


exports.utf7imap = Utf7IMAPCodec;
function Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
};

Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
Utf7IMAPCodec.prototype.bomAware = true;


// -- Encoding

function Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = Buffer.alloc(6);
    this.base64AccumIdx = 0;
}

Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64,
        base64Accum = this.base64Accum,
        base64AccumIdx = this.base64AccumIdx,
        buf = Buffer.alloc(str.length*5 + 10), bufIdx = 0;

    for (var i = 0; i < str.length; i++) {
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) { // Direct character or '&'.
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }

                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }

            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character

                if (uChar === andChar)  // Ampersand -> '&-'
                    buf[bufIdx++] = minusChar;
            }

        } else { // Non-direct character
            if (!inBase64) {
                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;

                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }

    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;

    return buf.slice(0, bufIdx);
}

Utf7IMAPEncoder.prototype.end = function() {
    var buf = Buffer.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }

        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }

    return buf.slice(0, bufIdx);
}


// -- Decoding

function Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}

var base64IMAPChars = base64Chars.slice();
base64IMAPChars[','.charCodeAt(0)] = true;

Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0,
        inBase64 = this.inBase64,
        base64Accum = this.base64Accum;

    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).

    for (var i = 0; i < buf.length; i++) {
        if (!inBase64) { // We're in direct mode.
            // Write direct chars until '&'
            if (buf[i] == andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i+1;
                inBase64 = true;
            }
        } else { // We decode base64.
            if (!base64IMAPChars[buf[i]]) { // Base64 ended.
                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
                    res += "&";
                } else {
                    var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
                    res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                }

                if (buf[i] != minusChar) // Minus may be absorbed after base64.
                    i--;

                lastI = i+1;
                inBase64 = false;
                base64Accum = '';
            }
        }
    }

    if (!inBase64) {
        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    } else {
        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');

        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);

        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
    }

    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;

    return res;
}

Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0)
        res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");

    this.inBase64 = false;
    this.base64Accum = '';
    return res;
}



},{"safer-buffer":1156}],664:[function(require,module,exports){
"use strict";

var BOMChar = '\uFEFF';

exports.PrependBOM = PrependBOMWrapper
function PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}

PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = BOMChar + str;
        this.addBOM = false;
    }

    return this.encoder.write(str);
}

PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
}


//------------------------------------------------------------------------------

exports.StripBOM = StripBOMWrapper;
function StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}

StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res)
        return res;

    if (res[0] === BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function')
            this.options.stripBOM();
    }

    this.pass = true;
    return res;
}

StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
}


},{}],665:[function(require,module,exports){
(function (process){(function (){
"use strict";

// Some environments don't have global Buffer (e.g. React Native).
// Solution would be installing npm modules "buffer" and "stream" explicitly.
var Buffer = require("safer-buffer").Buffer;

var bomHandling = require("./bom-handling"),
    iconv = module.exports;

// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
iconv.encodings = null;

// Characters emitted in case of error.
iconv.defaultCharUnicode = '�';
iconv.defaultCharSingleByte = '?';

// Public API.
iconv.encode = function encode(str, encoding, options) {
    str = "" + (str || ""); // Ensure string.

    var encoder = iconv.getEncoder(encoding, options);

    var res = encoder.write(str);
    var trail = encoder.end();
    
    return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
}

iconv.decode = function decode(buf, encoding, options) {
    if (typeof buf === 'string') {
        if (!iconv.skipDecodeWarning) {
            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
            iconv.skipDecodeWarning = true;
        }

        buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
    }

    var decoder = iconv.getDecoder(encoding, options);

    var res = decoder.write(buf);
    var trail = decoder.end();

    return trail ? (res + trail) : res;
}

iconv.encodingExists = function encodingExists(enc) {
    try {
        iconv.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
}

// Legacy aliases to convert functions
iconv.toEncoding = iconv.encode;
iconv.fromEncoding = iconv.decode;

// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
iconv._codecDataCache = {};
iconv.getCodec = function getCodec(encoding) {
    if (!iconv.encodings)
        iconv.encodings = require("../encodings"); // Lazy load all encoding definitions.
    
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = iconv._canonicalizeEncoding(encoding);

    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while (true) {
        var codec = iconv._codecDataCache[enc];
        if (codec)
            return codec;

        var codecDef = iconv.encodings[enc];

        switch (typeof codecDef) {
            case "string": // Direct alias to other encoding.
                enc = codecDef;
                break;

            case "object": // Alias with options. Can be layered.
                for (var key in codecDef)
                    codecOptions[key] = codecDef[key];

                if (!codecOptions.encodingName)
                    codecOptions.encodingName = enc;
                
                enc = codecDef.type;
                break;

            case "function": // Codec itself.
                if (!codecOptions.encodingName)
                    codecOptions.encodingName = enc;

                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, iconv);

                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;

            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '"+enc+"')");
        }
    }
}

iconv._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return (''+encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
}

iconv.getEncoder = function getEncoder(encoding, options) {
    var codec = iconv.getCodec(encoding),
        encoder = new codec.encoder(options, codec);

    if (codec.bomAware && options && options.addBOM)
        encoder = new bomHandling.PrependBOM(encoder, options);

    return encoder;
}

iconv.getDecoder = function getDecoder(encoding, options) {
    var codec = iconv.getCodec(encoding),
        decoder = new codec.decoder(options, codec);

    if (codec.bomAware && !(options && options.stripBOM === false))
        decoder = new bomHandling.StripBOM(decoder, options);

    return decoder;
}


// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
if (nodeVer) {

    // Load streaming support in Node v0.10+
    var nodeVerArr = nodeVer.split(".").map(Number);
    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) {
        require("./streams")(iconv);
    }

    // Load Node primitive extensions.
    require("./extend-node")(iconv);
}

if ("Ā" != "\u0100") {
    console.error("iconv-lite warning: javascript files use encoding different from utf-8. See https://github.com/ashtuchkin/iconv-lite/wiki/Javascript-source-file-encodings for more info.");
}

}).call(this)}).call(this,require('_process'))
},{"../encodings":649,"./bom-handling":664,"./extend-node":402,"./streams":402,"_process":405,"safer-buffer":1156}],666:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],667:[function(require,module,exports){

var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};
},{}],668:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],669:[function(require,module,exports){
'use strict';

var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var callBound = require('call-bind/callBound');

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"call-bind/callBound":407}],670:[function(require,module,exports){
module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};

},{}],671:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],672:[function(require,module,exports){
'use strict';

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

},{}],673:[function(require,module,exports){
'use strict';

var callBound = require('call-bind/callBound');
var hasSymbols = require('has-symbols')();
var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};

},{"call-bind/callBound":407,"has-symbols":644}],674:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],675:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],676:[function(require,module,exports){
(function (global){(function (){
/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = typeof define === "function" && define.amd;

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root["Object"]());
    exports || (exports = root["Object"]());

    // Native constructor aliases.
    var Number = context["Number"] || root["Number"],
        String = context["String"] || root["String"],
        Object = context["Object"] || root["Object"],
        Date = context["Date"] || root["Date"],
        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
        TypeError = context["TypeError"] || root["TypeError"],
        Math = context["Math"] || root["Math"],
        nativeJSON = context["JSON"] || root["JSON"];

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty, forEach, undef;

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    try {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    } catch (exception) {}

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] !== undef) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("json-parse");
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            try {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undef &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undef) === undef &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undef &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undef]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undef, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
                // The milliseconds are optional in ES 5, but required in 5.1.
                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
            } catch (exception) {
              stringifySupported = false;
            }
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse;
          if (typeof parse == "function") {
            try {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  try {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  } catch (exception) {}
                  if (parseSupported) {
                    try {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    } catch (exception) {}
                  }
                  if (parseSupported) {
                    try {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    } catch (exception) {}
                  }
                }
              }
            } catch (exception) {
              parseSupported = false;
            }
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Define additional utility methods if the `Date` methods are buggy.
      if (!isExtended) {
        var floor = Math.floor;
        // A mapping between the months of the year and the number of days between
        // January 1st and the first of the respective month.
        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        // Internal: Calculates the number of days between the Unix epoch and the
        // first day of the given month.
        var getDay = function (year, month) {
          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
        };
      }

      // Internal: Determines if a property is a direct property of the given
      // object. Delegates to the native `Object#hasOwnProperty` method.
      if (!(isProperty = objectProto.hasOwnProperty)) {
        isProperty = function (property) {
          var members = {}, constructor;
          if ((members.__proto__ = null, members.__proto__ = {
            // The *proto* property cannot be set multiple times in recent
            // versions of Firefox and SeaMonkey.
            "toString": 1
          }, members).toString != getClass) {
            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
            // supports the mutable *proto* property.
            isProperty = function (property) {
              // Capture and break the object's prototype chain (see section 8.6.2
              // of the ES 5.1 spec). The parenthesized expression prevents an
              // unsafe transformation by the Closure Compiler.
              var original = this.__proto__, result = property in (this.__proto__ = null, this);
              // Restore the original prototype chain.
              this.__proto__ = original;
              return result;
            };
          } else {
            // Capture a reference to the top-level `Object` constructor.
            constructor = members.constructor;
            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
            // other environments.
            isProperty = function (property) {
              var parent = (this.constructor || constructor).prototype;
              return property in this && !(property in parent && this[property] === parent[property]);
            };
          }
          members = null;
          return isProperty.call(this, property);
        };
      }

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      forEach = function (object, callback) {
        var size = 0, Properties, members, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        members = new Properties();
        for (property in members) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(members, property)) {
            size++;
          }
        }
        Properties = members = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
          };
        } else if (size == 2) {
          // Safari <= 2.0.4 enumerates shadowed properties twice.
          forEach = function (object, callback) {
            // Create a set of iterated properties.
            var members = {}, isFunction = getClass.call(object) == functionClass, property;
            for (property in object) {
              // Store each property name to prevent double enumeration. The
              // `prototype` property of functions is not enumerated due to cross-
              // environment inconsistencies.
              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forEach(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Double-quotes a string `value`, replacing all ASCII control
        // characters (characters with code unit values between 0 and 31) with
        // their escaped equivalents. This is an implementation of the
        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
        var unicodePrefix = "\\u00";
        var quote = function (value) {
          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
          for (; index < length; index++) {
            var charCode = value.charCodeAt(index);
            // If the character is a control character, append its Unicode or
            // shorthand escape sequence; otherwise, append the character as-is.
            switch (charCode) {
              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
                result += Escapes[charCode];
                break;
              default:
                if (charCode < 32) {
                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
                  break;
                }
                result += useCharIndex ? symbols[index] : value.charAt(index);
            }
          }
          return result + '"';
        };

        // Internal: Recursively serializes an object. Implements the
        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
          try {
            // Necessary for host object support.
            value = object[property];
          } catch (exception) {}
          if (typeof value == "object" && value) {
            className = getClass.call(value);
            if (className == dateClass && !isProperty.call(value, "toJSON")) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                if (getDay) {
                  // Manually compute the year, month, date, hours, minutes,
                  // seconds, and milliseconds if the `getUTC*` methods are
                  // buggy. Adapted from @Yaffle's `date-shim` project.
                  date = floor(value / 864e5);
                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
                  date = 1 + date - getDay(year, month);
                  // The `time` value specifies the time within the day (see ES
                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                  // to compute `A modulo B`, as the `%` operator does not
                  // correspond to the `modulo` operation for negative numbers.
                  time = (value % 864e5 + 864e5) % 864e5;
                  // The hours, minutes, seconds, and milliseconds are obtained by
                  // decomposing the time within the day. See section 15.9.1.10.
                  hours = floor(time / 36e5) % 24;
                  minutes = floor(time / 6e4) % 60;
                  seconds = floor(time / 1e3) % 60;
                  milliseconds = time % 1e3;
                } else {
                  year = value.getUTCFullYear();
                  month = value.getUTCMonth();
                  date = value.getUTCDate();
                  hours = value.getUTCHours();
                  minutes = value.getUTCMinutes();
                  seconds = value.getUTCSeconds();
                  milliseconds = value.getUTCMilliseconds();
                }
                // Serialize extended years correctly.
                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
                  // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
                  // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
              } else {
                value = null;
              }
            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
              // ignores all `toJSON` methods on these objects unless they are
              // defined directly on an instance.
              value = value.toJSON(property);
            }
          }
          if (callback) {
            // If a replacement function was provided, call it to obtain the value
            // for serialization.
            value = callback.call(object, property, value);
          }
          if (value === null) {
            return "null";
          }
          className = getClass.call(value);
          if (className == booleanClass) {
            // Booleans are represented literally.
            return "" + value;
          } else if (className == numberClass) {
            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
            // `"null"`.
            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
          } else if (className == stringClass) {
            // Strings are double-quoted and escaped.
            return quote("" + value);
          }
          // Recursively serialize objects and arrays.
          if (typeof value == "object") {
            // Check for cyclic structures. This is a linear search; performance
            // is inversely proportional to the number of unique nested objects.
            for (length = stack.length; length--;) {
              if (stack[length] === value) {
                // Cyclic structures cannot be serialized by `JSON.stringify`.
                throw TypeError();
              }
            }
            // Add the object to the stack of traversed objects.
            stack.push(value);
            results = [];
            // Save the current indentation level and indent one additional level.
            prefix = indentation;
            indentation += whitespace;
            if (className == arrayClass) {
              // Recursively serialize array elements.
              for (index = 0, length = value.length; index < length; index++) {
                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                results.push(element === undef ? "null" : element);
              }
              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
            } else {
              // Recursively serialize object members. Members are selected from
              // either a user-specified list of property names, or the object
              // itself.
              forEach(properties || value, function (property) {
                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                if (element !== undef) {
                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                  // is not the empty string, let `member` {quote(property) + ":"}
                  // be the concatenation of `member` and the `space` character."
                  // The "`space` character" refers to the literal space
                  // character, not the `space` {width} argument provided to
                  // `JSON.stringify`.
                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                }
              });
              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
            }
            // Remove the object from the traversed object stack.
            stack.pop();
            return result;
          }
        };

        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
        exports.stringify = function (source, filter, width) {
          var whitespace, callback, properties, className;
          if (objectTypes[typeof filter] && filter) {
            if ((className = getClass.call(filter)) == functionClass) {
              callback = filter;
            } else if (className == arrayClass) {
              // Convert the property names array into a makeshift set.
              properties = {};
              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
            }
          }
          if (width) {
            if ((className = getClass.call(width)) == numberClass) {
              // Convert the `width` to an integer and create a string containing
              // `width` number of space characters.
              if ((width -= width % 1) > 0) {
                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
              }
            } else if (className == stringClass) {
              whitespace = width.length <= 10 ? width : width.slice(0, 10);
            }
          }
          // Opera <= 7.54u2 discards the values associated with empty string keys
          // (`""`) only if they are used directly within an object member list
          // (e.g., `!("" in { "": 1})`).
          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
        };
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                if (source.slice(Index, Index + 4) == "true") {
                  Index += 4;
                  return true;
                } else if (source.slice(Index, Index + 5) == "false") {
                  Index += 5;
                  return false;
                } else if (source.slice(Index, Index + 4) == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undef) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forEach` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(value, length, callback);
              }
            } else {
              forEach(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports["runInContext"] = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root["JSON3"],
        isRestored = false;

    var JSON3 = runInContext(root, (root["JSON3"] = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root["JSON3"] = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    define(function () {
      return JSON3;
    });
  }
}).call(this);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],677:[function(require,module,exports){
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

"use strict";

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function(obj) {
  var ret = {};
  var key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

},{}],678:[function(require,module,exports){

module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}

},{}],679:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

},{"./_getNative":770,"./_root":814}],680:[function(require,module,exports){
var hashClear = require('./_hashClear'),
    hashDelete = require('./_hashDelete'),
    hashGet = require('./_hashGet'),
    hashHas = require('./_hashHas'),
    hashSet = require('./_hashSet');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

},{"./_hashClear":778,"./_hashDelete":779,"./_hashGet":780,"./_hashHas":781,"./_hashSet":782}],681:[function(require,module,exports){
var listCacheClear = require('./_listCacheClear'),
    listCacheDelete = require('./_listCacheDelete'),
    listCacheGet = require('./_listCacheGet'),
    listCacheHas = require('./_listCacheHas'),
    listCacheSet = require('./_listCacheSet');

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

},{"./_listCacheClear":794,"./_listCacheDelete":795,"./_listCacheGet":796,"./_listCacheHas":797,"./_listCacheSet":798}],682:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

},{"./_getNative":770,"./_root":814}],683:[function(require,module,exports){
var mapCacheClear = require('./_mapCacheClear'),
    mapCacheDelete = require('./_mapCacheDelete'),
    mapCacheGet = require('./_mapCacheGet'),
    mapCacheHas = require('./_mapCacheHas'),
    mapCacheSet = require('./_mapCacheSet');

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

},{"./_mapCacheClear":799,"./_mapCacheDelete":800,"./_mapCacheGet":801,"./_mapCacheHas":802,"./_mapCacheSet":803}],684:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

},{"./_getNative":770,"./_root":814}],685:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

},{"./_getNative":770,"./_root":814}],686:[function(require,module,exports){
var MapCache = require('./_MapCache'),
    setCacheAdd = require('./_setCacheAdd'),
    setCacheHas = require('./_setCacheHas');

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

},{"./_MapCache":683,"./_setCacheAdd":816,"./_setCacheHas":817}],687:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    stackClear = require('./_stackClear'),
    stackDelete = require('./_stackDelete'),
    stackGet = require('./_stackGet'),
    stackHas = require('./_stackHas'),
    stackSet = require('./_stackSet');

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

},{"./_ListCache":681,"./_stackClear":821,"./_stackDelete":822,"./_stackGet":823,"./_stackHas":824,"./_stackSet":825}],688:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":814}],689:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

},{"./_root":814}],690:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

},{"./_getNative":770,"./_root":814}],691:[function(require,module,exports){
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

},{}],692:[function(require,module,exports){
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

},{}],693:[function(require,module,exports){
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

},{}],694:[function(require,module,exports){
var baseIndexOf = require('./_baseIndexOf');

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;

},{"./_baseIndexOf":717}],695:[function(require,module,exports){
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;

},{}],696:[function(require,module,exports){
var baseTimes = require('./_baseTimes'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isIndex = require('./_isIndex'),
    isTypedArray = require('./isTypedArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

},{"./_baseTimes":739,"./_isIndex":787,"./isArguments":840,"./isArray":841,"./isBuffer":844,"./isTypedArray":855}],697:[function(require,module,exports){
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

},{}],698:[function(require,module,exports){
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

},{}],699:[function(require,module,exports){
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

},{}],700:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

},{"./_baseAssignValue":705,"./eq":834}],701:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

},{"./_baseAssignValue":705,"./eq":834}],702:[function(require,module,exports){
var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

},{"./eq":834}],703:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keys = require('./keys');

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

},{"./_copyObject":753,"./keys":857}],704:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

},{"./_copyObject":753,"./keysIn":858}],705:[function(require,module,exports){
var defineProperty = require('./_defineProperty');

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

},{"./_defineProperty":761}],706:[function(require,module,exports){
var Stack = require('./_Stack'),
    arrayEach = require('./_arrayEach'),
    assignValue = require('./_assignValue'),
    baseAssign = require('./_baseAssign'),
    baseAssignIn = require('./_baseAssignIn'),
    cloneBuffer = require('./_cloneBuffer'),
    copyArray = require('./_copyArray'),
    copySymbols = require('./_copySymbols'),
    copySymbolsIn = require('./_copySymbolsIn'),
    getAllKeys = require('./_getAllKeys'),
    getAllKeysIn = require('./_getAllKeysIn'),
    getTag = require('./_getTag'),
    initCloneArray = require('./_initCloneArray'),
    initCloneByTag = require('./_initCloneByTag'),
    initCloneObject = require('./_initCloneObject'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isMap = require('./isMap'),
    isObject = require('./isObject'),
    isSet = require('./isSet'),
    keys = require('./keys'),
    keysIn = require('./keysIn');

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

},{"./_Stack":687,"./_arrayEach":692,"./_assignValue":701,"./_baseAssign":703,"./_baseAssignIn":704,"./_cloneBuffer":747,"./_copyArray":752,"./_copySymbols":754,"./_copySymbolsIn":755,"./_getAllKeys":766,"./_getAllKeysIn":767,"./_getTag":775,"./_initCloneArray":783,"./_initCloneByTag":784,"./_initCloneObject":785,"./isArray":841,"./isBuffer":844,"./isMap":848,"./isObject":849,"./isSet":852,"./keys":857,"./keysIn":858}],707:[function(require,module,exports){
var isObject = require('./isObject');

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;

},{"./isObject":849}],708:[function(require,module,exports){
var baseForOwn = require('./_baseForOwn'),
    createBaseEach = require('./_createBaseEach');

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

},{"./_baseForOwn":712,"./_createBaseEach":758}],709:[function(require,module,exports){
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;

},{}],710:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isFlattenable = require('./_isFlattenable');

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

},{"./_arrayPush":698,"./_isFlattenable":786}],711:[function(require,module,exports){
var createBaseFor = require('./_createBaseFor');

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

},{"./_createBaseFor":759}],712:[function(require,module,exports){
var baseFor = require('./_baseFor'),
    keys = require('./keys');

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

},{"./_baseFor":711,"./keys":857}],713:[function(require,module,exports){
var castPath = require('./_castPath'),
    toKey = require('./_toKey');

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;

},{"./_castPath":745,"./_toKey":828}],714:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isArray = require('./isArray');

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

},{"./_arrayPush":698,"./isArray":841}],715:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":688,"./_getRawTag":772,"./_objectToString":811}],716:[function(require,module,exports){
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

},{}],717:[function(require,module,exports){
var baseFindIndex = require('./_baseFindIndex'),
    baseIsNaN = require('./_baseIsNaN'),
    strictIndexOf = require('./_strictIndexOf');

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;

},{"./_baseFindIndex":709,"./_baseIsNaN":723,"./_strictIndexOf":826}],718:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":715,"./isObjectLike":850}],719:[function(require,module,exports){
var baseIsEqualDeep = require('./_baseIsEqualDeep'),
    isObjectLike = require('./isObjectLike');

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

},{"./_baseIsEqualDeep":720,"./isObjectLike":850}],720:[function(require,module,exports){
var Stack = require('./_Stack'),
    equalArrays = require('./_equalArrays'),
    equalByTag = require('./_equalByTag'),
    equalObjects = require('./_equalObjects'),
    getTag = require('./_getTag'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isTypedArray = require('./isTypedArray');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

},{"./_Stack":687,"./_equalArrays":762,"./_equalByTag":763,"./_equalObjects":764,"./_getTag":775,"./isArray":841,"./isBuffer":844,"./isTypedArray":855}],721:[function(require,module,exports){
var getTag = require('./_getTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;

},{"./_getTag":775,"./isObjectLike":850}],722:[function(require,module,exports){
var Stack = require('./_Stack'),
    baseIsEqual = require('./_baseIsEqual');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

},{"./_Stack":687,"./_baseIsEqual":719}],723:[function(require,module,exports){
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;

},{}],724:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isMasked = require('./_isMasked'),
    isObject = require('./isObject'),
    toSource = require('./_toSource');

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

},{"./_isMasked":791,"./_toSource":829,"./isFunction":846,"./isObject":849}],725:[function(require,module,exports){
var getTag = require('./_getTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;

},{"./_getTag":775,"./isObjectLike":850}],726:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isLength = require('./isLength'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

},{"./_baseGetTag":715,"./isLength":847,"./isObjectLike":850}],727:[function(require,module,exports){
var baseMatches = require('./_baseMatches'),
    baseMatchesProperty = require('./_baseMatchesProperty'),
    identity = require('./identity'),
    isArray = require('./isArray'),
    property = require('./property');

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

},{"./_baseMatches":731,"./_baseMatchesProperty":732,"./identity":839,"./isArray":841,"./property":866}],728:[function(require,module,exports){
var isPrototype = require('./_isPrototype'),
    nativeKeys = require('./_nativeKeys');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

},{"./_isPrototype":792,"./_nativeKeys":808}],729:[function(require,module,exports){
var isObject = require('./isObject'),
    isPrototype = require('./_isPrototype'),
    nativeKeysIn = require('./_nativeKeysIn');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

},{"./_isPrototype":792,"./_nativeKeysIn":809,"./isObject":849}],730:[function(require,module,exports){
var baseEach = require('./_baseEach'),
    isArrayLike = require('./isArrayLike');

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;

},{"./_baseEach":708,"./isArrayLike":842}],731:[function(require,module,exports){
var baseIsMatch = require('./_baseIsMatch'),
    getMatchData = require('./_getMatchData'),
    matchesStrictComparable = require('./_matchesStrictComparable');

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

},{"./_baseIsMatch":722,"./_getMatchData":769,"./_matchesStrictComparable":805}],732:[function(require,module,exports){
var baseIsEqual = require('./_baseIsEqual'),
    get = require('./get'),
    hasIn = require('./hasIn'),
    isKey = require('./_isKey'),
    isStrictComparable = require('./_isStrictComparable'),
    matchesStrictComparable = require('./_matchesStrictComparable'),
    toKey = require('./_toKey');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

},{"./_baseIsEqual":719,"./_isKey":789,"./_isStrictComparable":793,"./_matchesStrictComparable":805,"./_toKey":828,"./get":837,"./hasIn":838}],733:[function(require,module,exports){
var Stack = require('./_Stack'),
    assignMergeValue = require('./_assignMergeValue'),
    baseFor = require('./_baseFor'),
    baseMergeDeep = require('./_baseMergeDeep'),
    isObject = require('./isObject'),
    keysIn = require('./keysIn'),
    safeGet = require('./_safeGet');

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

},{"./_Stack":687,"./_assignMergeValue":700,"./_baseFor":711,"./_baseMergeDeep":734,"./_safeGet":815,"./isObject":849,"./keysIn":858}],734:[function(require,module,exports){
var assignMergeValue = require('./_assignMergeValue'),
    cloneBuffer = require('./_cloneBuffer'),
    cloneTypedArray = require('./_cloneTypedArray'),
    copyArray = require('./_copyArray'),
    initCloneObject = require('./_initCloneObject'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isArrayLikeObject = require('./isArrayLikeObject'),
    isBuffer = require('./isBuffer'),
    isFunction = require('./isFunction'),
    isObject = require('./isObject'),
    isPlainObject = require('./isPlainObject'),
    isTypedArray = require('./isTypedArray'),
    safeGet = require('./_safeGet'),
    toPlainObject = require('./toPlainObject');

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

},{"./_assignMergeValue":700,"./_cloneBuffer":747,"./_cloneTypedArray":751,"./_copyArray":752,"./_initCloneObject":785,"./_safeGet":815,"./isArguments":840,"./isArray":841,"./isArrayLikeObject":843,"./isBuffer":844,"./isFunction":846,"./isObject":849,"./isPlainObject":851,"./isTypedArray":855,"./toPlainObject":871}],735:[function(require,module,exports){
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

},{}],736:[function(require,module,exports){
var baseGet = require('./_baseGet');

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

},{"./_baseGet":713}],737:[function(require,module,exports){
var identity = require('./identity'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

},{"./_overRest":813,"./_setToString":819,"./identity":839}],738:[function(require,module,exports){
var constant = require('./constant'),
    defineProperty = require('./_defineProperty'),
    identity = require('./identity');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

},{"./_defineProperty":761,"./constant":831,"./identity":839}],739:[function(require,module,exports){
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

},{}],740:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    arrayMap = require('./_arrayMap'),
    isArray = require('./isArray'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;

},{"./_Symbol":688,"./_arrayMap":697,"./isArray":841,"./isSymbol":854}],741:[function(require,module,exports){
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;

},{}],742:[function(require,module,exports){
var SetCache = require('./_SetCache'),
    arrayIncludes = require('./_arrayIncludes'),
    arrayIncludesWith = require('./_arrayIncludesWith'),
    cacheHas = require('./_cacheHas'),
    createSet = require('./_createSet'),
    setToArray = require('./_setToArray');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;

},{"./_SetCache":686,"./_arrayIncludes":694,"./_arrayIncludesWith":695,"./_cacheHas":743,"./_createSet":760,"./_setToArray":818}],743:[function(require,module,exports){
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

},{}],744:[function(require,module,exports){
var identity = require('./identity');

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;

},{"./identity":839}],745:[function(require,module,exports){
var isArray = require('./isArray'),
    isKey = require('./_isKey'),
    stringToPath = require('./_stringToPath'),
    toString = require('./toString');

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

},{"./_isKey":789,"./_stringToPath":827,"./isArray":841,"./toString":872}],746:[function(require,module,exports){
var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

},{"./_Uint8Array":689}],747:[function(require,module,exports){
var root = require('./_root');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

},{"./_root":814}],748:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

},{"./_cloneArrayBuffer":746}],749:[function(require,module,exports){
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

},{}],750:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

},{"./_Symbol":688}],751:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

},{"./_cloneArrayBuffer":746}],752:[function(require,module,exports){
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

},{}],753:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    baseAssignValue = require('./_baseAssignValue');

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

},{"./_assignValue":701,"./_baseAssignValue":705}],754:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    getSymbols = require('./_getSymbols');

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

},{"./_copyObject":753,"./_getSymbols":773}],755:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    getSymbolsIn = require('./_getSymbolsIn');

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

},{"./_copyObject":753,"./_getSymbolsIn":774}],756:[function(require,module,exports){
var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

},{"./_root":814}],757:[function(require,module,exports){
var baseRest = require('./_baseRest'),
    isIterateeCall = require('./_isIterateeCall');

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

},{"./_baseRest":737,"./_isIterateeCall":788}],758:[function(require,module,exports){
var isArrayLike = require('./isArrayLike');

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

},{"./isArrayLike":842}],759:[function(require,module,exports){
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

},{}],760:[function(require,module,exports){
var Set = require('./_Set'),
    noop = require('./noop'),
    setToArray = require('./_setToArray');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;

},{"./_Set":685,"./_setToArray":818,"./noop":864}],761:[function(require,module,exports){
var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;

},{"./_getNative":770}],762:[function(require,module,exports){
var SetCache = require('./_SetCache'),
    arraySome = require('./_arraySome'),
    cacheHas = require('./_cacheHas');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

},{"./_SetCache":686,"./_arraySome":699,"./_cacheHas":743}],763:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    Uint8Array = require('./_Uint8Array'),
    eq = require('./eq'),
    equalArrays = require('./_equalArrays'),
    mapToArray = require('./_mapToArray'),
    setToArray = require('./_setToArray');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

},{"./_Symbol":688,"./_Uint8Array":689,"./_equalArrays":762,"./_mapToArray":804,"./_setToArray":818,"./eq":834}],764:[function(require,module,exports){
var getAllKeys = require('./_getAllKeys');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

},{"./_getAllKeys":766}],765:[function(require,module,exports){
(function (global){(function (){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],766:[function(require,module,exports){
var baseGetAllKeys = require('./_baseGetAllKeys'),
    getSymbols = require('./_getSymbols'),
    keys = require('./keys');

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

},{"./_baseGetAllKeys":714,"./_getSymbols":773,"./keys":857}],767:[function(require,module,exports){
var baseGetAllKeys = require('./_baseGetAllKeys'),
    getSymbolsIn = require('./_getSymbolsIn'),
    keysIn = require('./keysIn');

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

},{"./_baseGetAllKeys":714,"./_getSymbolsIn":774,"./keysIn":858}],768:[function(require,module,exports){
var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;

},{"./_isKeyable":790}],769:[function(require,module,exports){
var isStrictComparable = require('./_isStrictComparable'),
    keys = require('./keys');

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;

},{"./_isStrictComparable":793,"./keys":857}],770:[function(require,module,exports){
var baseIsNative = require('./_baseIsNative'),
    getValue = require('./_getValue');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

},{"./_baseIsNative":724,"./_getValue":776}],771:[function(require,module,exports){
var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

},{"./_overArg":812}],772:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":688}],773:[function(require,module,exports){
var arrayFilter = require('./_arrayFilter'),
    stubArray = require('./stubArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

},{"./_arrayFilter":693,"./stubArray":867}],774:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    getPrototype = require('./_getPrototype'),
    getSymbols = require('./_getSymbols'),
    stubArray = require('./stubArray');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

},{"./_arrayPush":698,"./_getPrototype":771,"./_getSymbols":773,"./stubArray":867}],775:[function(require,module,exports){
var DataView = require('./_DataView'),
    Map = require('./_Map'),
    Promise = require('./_Promise'),
    Set = require('./_Set'),
    WeakMap = require('./_WeakMap'),
    baseGetTag = require('./_baseGetTag'),
    toSource = require('./_toSource');

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;

},{"./_DataView":679,"./_Map":682,"./_Promise":684,"./_Set":685,"./_WeakMap":690,"./_baseGetTag":715,"./_toSource":829}],776:[function(require,module,exports){
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

},{}],777:[function(require,module,exports){
var castPath = require('./_castPath'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isIndex = require('./_isIndex'),
    isLength = require('./isLength'),
    toKey = require('./_toKey');

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;

},{"./_castPath":745,"./_isIndex":787,"./_toKey":828,"./isArguments":840,"./isArray":841,"./isLength":847}],778:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

},{"./_nativeCreate":807}],779:[function(require,module,exports){
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

},{}],780:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

},{"./_nativeCreate":807}],781:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

},{"./_nativeCreate":807}],782:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

},{"./_nativeCreate":807}],783:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

},{}],784:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer'),
    cloneDataView = require('./_cloneDataView'),
    cloneRegExp = require('./_cloneRegExp'),
    cloneSymbol = require('./_cloneSymbol'),
    cloneTypedArray = require('./_cloneTypedArray');

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

},{"./_cloneArrayBuffer":746,"./_cloneDataView":748,"./_cloneRegExp":749,"./_cloneSymbol":750,"./_cloneTypedArray":751}],785:[function(require,module,exports){
var baseCreate = require('./_baseCreate'),
    getPrototype = require('./_getPrototype'),
    isPrototype = require('./_isPrototype');

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;

},{"./_baseCreate":707,"./_getPrototype":771,"./_isPrototype":792}],786:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray');

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

},{"./_Symbol":688,"./isArguments":840,"./isArray":841}],787:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;

},{}],788:[function(require,module,exports){
var eq = require('./eq'),
    isArrayLike = require('./isArrayLike'),
    isIndex = require('./_isIndex'),
    isObject = require('./isObject');

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

},{"./_isIndex":787,"./eq":834,"./isArrayLike":842,"./isObject":849}],789:[function(require,module,exports){
var isArray = require('./isArray'),
    isSymbol = require('./isSymbol');

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;

},{"./isArray":841,"./isSymbol":854}],790:[function(require,module,exports){
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;

},{}],791:[function(require,module,exports){
var coreJsData = require('./_coreJsData');

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;

},{"./_coreJsData":756}],792:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;

},{}],793:[function(require,module,exports){
var isObject = require('./isObject');

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

},{"./isObject":849}],794:[function(require,module,exports){
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

},{}],795:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

},{"./_assocIndexOf":702}],796:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

},{"./_assocIndexOf":702}],797:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

},{"./_assocIndexOf":702}],798:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

},{"./_assocIndexOf":702}],799:[function(require,module,exports){
var Hash = require('./_Hash'),
    ListCache = require('./_ListCache'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;

},{"./_Hash":680,"./_ListCache":681,"./_Map":682}],800:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

},{"./_getMapData":768}],801:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

},{"./_getMapData":768}],802:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

},{"./_getMapData":768}],803:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

},{"./_getMapData":768}],804:[function(require,module,exports){
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

},{}],805:[function(require,module,exports){
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;

},{}],806:[function(require,module,exports){
var memoize = require('./memoize');

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

},{"./memoize":862}],807:[function(require,module,exports){
var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

},{"./_getNative":770}],808:[function(require,module,exports){
var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

},{"./_overArg":812}],809:[function(require,module,exports){
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

},{}],810:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

},{"./_freeGlobal":765}],811:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],812:[function(require,module,exports){
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

},{}],813:[function(require,module,exports){
var apply = require('./_apply');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

},{"./_apply":691}],814:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":765}],815:[function(require,module,exports){
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;

},{}],816:[function(require,module,exports){
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

},{}],817:[function(require,module,exports){
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

},{}],818:[function(require,module,exports){
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

},{}],819:[function(require,module,exports){
var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

},{"./_baseSetToString":738,"./_shortOut":820}],820:[function(require,module,exports){
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

},{}],821:[function(require,module,exports){
var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;

},{"./_ListCache":681}],822:[function(require,module,exports){
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

},{}],823:[function(require,module,exports){
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

},{}],824:[function(require,module,exports){
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

},{}],825:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    Map = require('./_Map'),
    MapCache = require('./_MapCache');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

},{"./_ListCache":681,"./_Map":682,"./_MapCache":683}],826:[function(require,module,exports){
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;

},{}],827:[function(require,module,exports){
var memoizeCapped = require('./_memoizeCapped');

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;

},{"./_memoizeCapped":806}],828:[function(require,module,exports){
var isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;

},{"./isSymbol":854}],829:[function(require,module,exports){
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

},{}],830:[function(require,module,exports){
var baseClone = require('./_baseClone');

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;

},{"./_baseClone":706}],831:[function(require,module,exports){
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;

},{}],832:[function(require,module,exports){
var isObject = require('./isObject'),
    now = require('./now'),
    toNumber = require('./toNumber');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

},{"./isObject":849,"./now":865,"./toNumber":870}],833:[function(require,module,exports){
module.exports = require('./forEach');

},{"./forEach":835}],834:[function(require,module,exports){
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;

},{}],835:[function(require,module,exports){
var arrayEach = require('./_arrayEach'),
    baseEach = require('./_baseEach'),
    castFunction = require('./_castFunction'),
    isArray = require('./isArray');

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;

},{"./_arrayEach":692,"./_baseEach":708,"./_castFunction":744,"./isArray":841}],836:[function(require,module,exports){
var baseForOwn = require('./_baseForOwn'),
    castFunction = require('./_castFunction');

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;

},{"./_baseForOwn":712,"./_castFunction":744}],837:[function(require,module,exports){
var baseGet = require('./_baseGet');

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

},{"./_baseGet":713}],838:[function(require,module,exports){
var baseHasIn = require('./_baseHasIn'),
    hasPath = require('./_hasPath');

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

},{"./_baseHasIn":716,"./_hasPath":777}],839:[function(require,module,exports){
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

},{}],840:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":718,"./isObjectLike":850}],841:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],842:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

},{"./isFunction":846,"./isLength":847}],843:[function(require,module,exports){
var isArrayLike = require('./isArrayLike'),
    isObjectLike = require('./isObjectLike');

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

},{"./isArrayLike":842,"./isObjectLike":850}],844:[function(require,module,exports){
var root = require('./_root'),
    stubFalse = require('./stubFalse');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

},{"./_root":814,"./stubFalse":868}],845:[function(require,module,exports){
var baseIsEqual = require('./_baseIsEqual');

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

},{"./_baseIsEqual":719}],846:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObject = require('./isObject');

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

},{"./_baseGetTag":715,"./isObject":849}],847:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

},{}],848:[function(require,module,exports){
var baseIsMap = require('./_baseIsMap'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;

},{"./_baseIsMap":721,"./_baseUnary":741,"./_nodeUtil":810}],849:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],850:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],851:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    getPrototype = require('./_getPrototype'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

},{"./_baseGetTag":715,"./_getPrototype":771,"./isObjectLike":850}],852:[function(require,module,exports){
var baseIsSet = require('./_baseIsSet'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;

},{"./_baseIsSet":725,"./_baseUnary":741,"./_nodeUtil":810}],853:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isArray = require('./isArray'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;

},{"./_baseGetTag":715,"./isArray":841,"./isObjectLike":850}],854:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;

},{"./_baseGetTag":715,"./isObjectLike":850}],855:[function(require,module,exports){
var baseIsTypedArray = require('./_baseIsTypedArray'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

},{"./_baseIsTypedArray":726,"./_baseUnary":741,"./_nodeUtil":810}],856:[function(require,module,exports){
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;

},{}],857:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeys = require('./_baseKeys'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

},{"./_arrayLikeKeys":696,"./_baseKeys":728,"./isArrayLike":842}],858:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeysIn = require('./_baseKeysIn'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

},{"./_arrayLikeKeys":696,"./_baseKeysIn":729,"./isArrayLike":842}],859:[function(require,module,exports){
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

},{}],860:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],861:[function(require,module,exports){
var arrayMap = require('./_arrayMap'),
    baseIteratee = require('./_baseIteratee'),
    baseMap = require('./_baseMap'),
    isArray = require('./isArray');

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;

},{"./_arrayMap":697,"./_baseIteratee":727,"./_baseMap":730,"./isArray":841}],862:[function(require,module,exports){
var MapCache = require('./_MapCache');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

},{"./_MapCache":683}],863:[function(require,module,exports){
var baseMerge = require('./_baseMerge'),
    createAssigner = require('./_createAssigner');

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;

},{"./_baseMerge":733,"./_createAssigner":757}],864:[function(require,module,exports){
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;

},{}],865:[function(require,module,exports){
var root = require('./_root');

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;

},{"./_root":814}],866:[function(require,module,exports){
var baseProperty = require('./_baseProperty'),
    basePropertyDeep = require('./_basePropertyDeep'),
    isKey = require('./_isKey'),
    toKey = require('./_toKey');

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

},{"./_baseProperty":735,"./_basePropertyDeep":736,"./_isKey":789,"./_toKey":828}],867:[function(require,module,exports){
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

},{}],868:[function(require,module,exports){
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

},{}],869:[function(require,module,exports){
var debounce = require('./debounce'),
    isObject = require('./isObject');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;

},{"./debounce":832,"./isObject":849}],870:[function(require,module,exports){
var isObject = require('./isObject'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;

},{"./isObject":849,"./isSymbol":854}],871:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

},{"./_copyObject":753,"./keysIn":858}],872:[function(require,module,exports){
var baseToString = require('./_baseToString');

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

},{"./_baseToString":740}],873:[function(require,module,exports){
var baseFlatten = require('./_baseFlatten'),
    baseIteratee = require('./_baseIteratee'),
    baseRest = require('./_baseRest'),
    baseUniq = require('./_baseUniq'),
    isArrayLikeObject = require('./isArrayLikeObject'),
    last = require('./last');

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;

},{"./_baseFlatten":710,"./_baseIteratee":727,"./_baseRest":737,"./_baseUniq":742,"./isArrayLikeObject":843,"./last":859}],874:[function(require,module,exports){
/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.9"
/*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function () {
    return this
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.empty

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(factory)
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();

},{}],875:[function(require,module,exports){
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.materialColors = factory();
  }
})(this, function() {
  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
});

},{}],876:[function(require,module,exports){
'use strict';

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

module.exports = memoizeOne;

},{}],877:[function(require,module,exports){
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.

module.exports = function (random, alphabet, size) {
  // We can’t use bytes bigger than the alphabet. To make bytes values closer
  // to the alphabet, we apply bitmask on them. We look for the closest
  // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
  // 30 symbols in the alphabet, we will take 31 (00011111).
  // We do not use faster Math.clz32, because it is not available in browsers.
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
  // which is bigger than the alphabet). As a result, we will need more bytes,
  // than ID size, because we will refuse bytes bigger than the alphabet.

  // Every hardware random generator call is costly,
  // because we need to wait for entropy collection. This is why often it will
  // be faster to ask for few extra bytes in advance, to avoid additional calls.

  // Here we calculate how many random bytes should we call in advance.
  // It depends on ID length, mask / alphabet size and magic number 1.6
  // (which was selected according benchmarks).

  // -~f => Math.ceil(f) if n is float number
  // -~i => i + 1 if n is integer number
  var step = -~(1.6 * mask * size / alphabet.length)
  var id = ''

  while (true) {
    var bytes = random(step)
    // Compact alternative for `for (var i = 0; i < step; i++)`
    var i = step
    while (i--) {
      // If random byte is bigger than alphabet even after bitmask,
      // we refuse it by `|| ''`.
      id += alphabet[bytes[i] & mask] || ''
      // More compact than `id.length + 1 === size`
      if (id.length === +size) return id
    }
  }
}

},{}],878:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.Notify = global.Notify || {})));
}(this, function (exports) { 'use strict';

  var _objectWithoutProperties = (function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  })

  /*
   * Author: Alex Gibson
   * https://github.com/alexgibson/notify.js
   * License: MIT license
   */

  var N = window.Notification;

  function isFunction(item) {
      return typeof item === 'function';
  }

  function Notify(title) {
      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];


      if (typeof title !== 'string') {
          throw new Error('Notify(): first arg (title) must be a string.');
      }

      if (typeof options !== 'object') {
          throw new Error('Notify(): second arg (options) must be an object.');
      }

      var _options$notifyShow = options.notifyShow;
      var
      // Notify options
      notifyShow = _options$notifyShow === undefined ? null : _options$notifyShow;
      var _options$notifyClose = options.notifyClose;
      var notifyClose = _options$notifyClose === undefined ? null : _options$notifyClose;
      var _options$notifyClick = options.notifyClick;
      var notifyClick = _options$notifyClick === undefined ? null : _options$notifyClick;
      var _options$notifyError = options.notifyError;
      var notifyError = _options$notifyError === undefined ? null : _options$notifyError;
      var _options$closeOnClick = options.closeOnClick;
      var closeOnClick = _options$closeOnClick === undefined ? false : _options$closeOnClick;
      var _options$timeout = options.timeout;
      var timeout = _options$timeout === undefined ? null : _options$timeout;

      var rest = _objectWithoutProperties(options, ['notifyShow', 'notifyClose', 'notifyClick', 'notifyError', 'closeOnClick', 'timeout']);

      this.title = title;
      this.options = rest;
      this.permission = null;
      this.closeOnClick = closeOnClick;
      this.timeout = timeout;

      //callback when notification is displayed
      if (isFunction(notifyShow)) {
          this.onShowCallback = notifyShow;
      }

      //callback when notification is closed
      if (isFunction(notifyClose)) {
          this.onCloseCallback = notifyClose;
      }

      //callback when notification is clicked
      if (isFunction(notifyClick)) {
          this.onClickCallback = notifyClick;
      }

      //callback when notification throws error
      if (isFunction(notifyError)) {
          this.onErrorCallback = notifyError;
      }
  }

  // returns true if the browser supports Web Notifications
  // https://developers.google.com/web/updates/2015/05/Notifying-you-of-notificiation-changes
  // @param {perm} for test purposes only
  Notify.isSupported = function (perm) {
      if (!N || !N.requestPermission) {
          return false;
      }

      if (perm === 'granted' || N.permission === 'granted') {
          throw new Error('You must only call this before calling Notification.requestPermission(), otherwise this feature detect would trigger an actual notification!');
      }

      try {
          new N('');
      } catch (e) {
          if (e.name === 'TypeError') {
              return false;
          }
      }
      return true;
  };

  // true if the permission is not granted
  Notify.needsPermission = N && N.permission && N.permission === 'granted' ? false : true;

  // asks the user for permission to display notifications.  Then calls the callback functions is supplied.
  Notify.requestPermission = function (onPermissionGrantedCallback, onPermissionDeniedCallback) {
      N.requestPermission(function (perm) {
          switch (perm) {
              case 'granted':
                  Notify.needsPermission = false;
                  if (isFunction(onPermissionGrantedCallback)) {
                      onPermissionGrantedCallback();
                  }
                  break;
              case 'denied':
                  Notify.needsPermission = true;
                  if (isFunction(onPermissionDeniedCallback)) {
                      onPermissionDeniedCallback();
                  }
                  break;
          }
      });
  };

  Notify.prototype.show = function () {
      this.myNotify = new N(this.title, this.options);

      if (!this.options.requireInteraction && this.timeout && !isNaN(this.timeout)) {
          setTimeout(this.close.bind(this), this.timeout * 1000);
      }

      this.myNotify.addEventListener('show', this, false);
      this.myNotify.addEventListener('error', this, false);
      this.myNotify.addEventListener('close', this, false);
      this.myNotify.addEventListener('click', this, false);
  };

  Notify.prototype.onShowNotification = function (e) {
      if (this.onShowCallback) {
          this.onShowCallback(e);
      }
  };

  Notify.prototype.onCloseNotification = function (e) {
      if (this.onCloseCallback) {
          this.onCloseCallback(e);
      }
      this.destroy();
  };

  Notify.prototype.onClickNotification = function (e) {
      if (this.onClickCallback) {
          this.onClickCallback(e);
      }

      if (this.closeOnClick) {
          this.close();
      }
  };

  Notify.prototype.onErrorNotification = function (e) {
      if (this.onErrorCallback) {
          this.onErrorCallback(e);
      }
      this.destroy();
  };

  Notify.prototype.destroy = function () {
      this.myNotify.removeEventListener('show', this, false);
      this.myNotify.removeEventListener('error', this, false);
      this.myNotify.removeEventListener('close', this, false);
      this.myNotify.removeEventListener('click', this, false);
  };

  Notify.prototype.close = function () {
      this.myNotify.close();
  };

  Notify.prototype.handleEvent = function (e) {
      switch (e.type) {
          case 'show':
              this.onShowNotification(e);
              break;
          case 'close':
              this.onCloseNotification(e);
              break;
          case 'click':
              this.onClickNotification(e);
              break;
          case 'error':
              this.onErrorNotification(e);
              break;
      }
  };

  exports['default'] = Notify;

}));
},{}],879:[function(require,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],880:[function(require,module,exports){
'use strict';

var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};


},{}],881:[function(require,module,exports){
'use strict';

var define = require('define-properties');
var callBind = require('call-bind');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;

},{"./implementation":880,"./polyfill":882,"./shim":883,"call-bind":408,"define-properties":550}],882:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};

},{"./implementation":880}],883:[function(require,module,exports){
'use strict';

var getPolyfill = require('./polyfill');
var define = require('define-properties');

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

},{"./polyfill":882,"define-properties":550}],884:[function(require,module,exports){
'use strict';

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = require('./isArguments'); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

},{"./isArguments":886}],885:[function(require,module,exports){
'use strict';

var slice = Array.prototype.slice;
var isArgs = require('./isArguments');

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : require('./implementation');

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

},{"./implementation":884,"./isArguments":886}],886:[function(require,module,exports){
'use strict';

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

},{}],887:[function(require,module,exports){
(function (Buffer){(function (){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : factory(global.opentype = {});
}(this, function (exports) {
    'use strict';
    if (!String.prototype.codePointAt) {
        (function () {
            var defineProperty = function () {
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) {
                }
                return result;
            }();
            var codePointAt = function (position) {
                if (this == null) {
                    throw TypeError();
                }
                var string = String(this);
                var size = string.length;
                var index = position ? Number(position) : 0;
                if (index != index) {
                    index = 0;
                }
                if (index < 0 || index >= size) {
                    return undefined;
                }
                var first = string.charCodeAt(index);
                var second;
                if (first >= 55296 && first <= 56319 && size > index + 1) {
                    second = string.charCodeAt(index + 1);
                    if (second >= 56320 && second <= 57343) {
                        return (first - 55296) * 1024 + second - 56320 + 65536;
                    }
                }
                return first;
            };
            if (defineProperty) {
                defineProperty(String.prototype, 'codePointAt', {
                    'value': codePointAt,
                    'configurable': true,
                    'writable': true
                });
            } else {
                String.prototype.codePointAt = codePointAt;
            }
        }());
    }
    var TINF_OK = 0;
    var TINF_DATA_ERROR = -3;
    function Tree() {
        this.table = new Uint16Array(16);
        this.trans = new Uint16Array(288);
    }
    function Data(source, dest) {
        this.source = source;
        this.sourceIndex = 0;
        this.tag = 0;
        this.bitcount = 0;
        this.dest = dest;
        this.destLen = 0;
        this.ltree = new Tree();
        this.dtree = new Tree();
    }
    var sltree = new Tree();
    var sdtree = new Tree();
    var length_bits = new Uint8Array(30);
    var length_base = new Uint16Array(30);
    var dist_bits = new Uint8Array(30);
    var dist_base = new Uint16Array(30);
    var clcidx = new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    var code_tree = new Tree();
    var lengths = new Uint8Array(288 + 32);
    function tinf_build_bits_base(bits, base, delta, first) {
        var i, sum;
        for (i = 0; i < delta; ++i) {
            bits[i] = 0;
        }
        for (i = 0; i < 30 - delta; ++i) {
            bits[i + delta] = i / delta | 0;
        }
        for (sum = first, i = 0; i < 30; ++i) {
            base[i] = sum;
            sum += 1 << bits[i];
        }
    }
    function tinf_build_fixed_trees(lt, dt) {
        var i;
        for (i = 0; i < 7; ++i) {
            lt.table[i] = 0;
        }
        lt.table[7] = 24;
        lt.table[8] = 152;
        lt.table[9] = 112;
        for (i = 0; i < 24; ++i) {
            lt.trans[i] = 256 + i;
        }
        for (i = 0; i < 144; ++i) {
            lt.trans[24 + i] = i;
        }
        for (i = 0; i < 8; ++i) {
            lt.trans[24 + 144 + i] = 280 + i;
        }
        for (i = 0; i < 112; ++i) {
            lt.trans[24 + 144 + 8 + i] = 144 + i;
        }
        for (i = 0; i < 5; ++i) {
            dt.table[i] = 0;
        }
        dt.table[5] = 32;
        for (i = 0; i < 32; ++i) {
            dt.trans[i] = i;
        }
    }
    var offs = new Uint16Array(16);
    function tinf_build_tree(t, lengths, off, num) {
        var i, sum;
        for (i = 0; i < 16; ++i) {
            t.table[i] = 0;
        }
        for (i = 0; i < num; ++i) {
            t.table[lengths[off + i]]++;
        }
        t.table[0] = 0;
        for (sum = 0, i = 0; i < 16; ++i) {
            offs[i] = sum;
            sum += t.table[i];
        }
        for (i = 0; i < num; ++i) {
            if (lengths[off + i]) {
                t.trans[offs[lengths[off + i]]++] = i;
            }
        }
    }
    function tinf_getbit(d) {
        if (!d.bitcount--) {
            d.tag = d.source[d.sourceIndex++];
            d.bitcount = 7;
        }
        var bit = d.tag & 1;
        d.tag >>>= 1;
        return bit;
    }
    function tinf_read_bits(d, num, base) {
        if (!num) {
            return base;
        }
        while (d.bitcount < 24) {
            d.tag |= d.source[d.sourceIndex++] << d.bitcount;
            d.bitcount += 8;
        }
        var val = d.tag & 65535 >>> 16 - num;
        d.tag >>>= num;
        d.bitcount -= num;
        return val + base;
    }
    function tinf_decode_symbol(d, t) {
        while (d.bitcount < 24) {
            d.tag |= d.source[d.sourceIndex++] << d.bitcount;
            d.bitcount += 8;
        }
        var sum = 0, cur = 0, len = 0;
        var tag = d.tag;
        do {
            cur = 2 * cur + (tag & 1);
            tag >>>= 1;
            ++len;
            sum += t.table[len];
            cur -= t.table[len];
        } while (cur >= 0);
        d.tag = tag;
        d.bitcount -= len;
        return t.trans[sum + cur];
    }
    function tinf_decode_trees(d, lt, dt) {
        var hlit, hdist, hclen;
        var i, num, length;
        hlit = tinf_read_bits(d, 5, 257);
        hdist = tinf_read_bits(d, 5, 1);
        hclen = tinf_read_bits(d, 4, 4);
        for (i = 0; i < 19; ++i) {
            lengths[i] = 0;
        }
        for (i = 0; i < hclen; ++i) {
            var clen = tinf_read_bits(d, 3, 0);
            lengths[clcidx[i]] = clen;
        }
        tinf_build_tree(code_tree, lengths, 0, 19);
        for (num = 0; num < hlit + hdist;) {
            var sym = tinf_decode_symbol(d, code_tree);
            switch (sym) {
            case 16:
                var prev = lengths[num - 1];
                for (length = tinf_read_bits(d, 2, 3); length; --length) {
                    lengths[num++] = prev;
                }
                break;
            case 17:
                for (length = tinf_read_bits(d, 3, 3); length; --length) {
                    lengths[num++] = 0;
                }
                break;
            case 18:
                for (length = tinf_read_bits(d, 7, 11); length; --length) {
                    lengths[num++] = 0;
                }
                break;
            default:
                lengths[num++] = sym;
                break;
            }
        }
        tinf_build_tree(lt, lengths, 0, hlit);
        tinf_build_tree(dt, lengths, hlit, hdist);
    }
    function tinf_inflate_block_data(d, lt, dt) {
        while (1) {
            var sym = tinf_decode_symbol(d, lt);
            if (sym === 256) {
                return TINF_OK;
            }
            if (sym < 256) {
                d.dest[d.destLen++] = sym;
            } else {
                var length, dist, offs;
                var i;
                sym -= 257;
                length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
                dist = tinf_decode_symbol(d, dt);
                offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
                for (i = offs; i < offs + length; ++i) {
                    d.dest[d.destLen++] = d.dest[i];
                }
            }
        }
    }
    function tinf_inflate_uncompressed_block(d) {
        var length, invlength;
        var i;
        while (d.bitcount > 8) {
            d.sourceIndex--;
            d.bitcount -= 8;
        }
        length = d.source[d.sourceIndex + 1];
        length = 256 * length + d.source[d.sourceIndex];
        invlength = d.source[d.sourceIndex + 3];
        invlength = 256 * invlength + d.source[d.sourceIndex + 2];
        if (length !== (~invlength & 65535)) {
            return TINF_DATA_ERROR;
        }
        d.sourceIndex += 4;
        for (i = length; i; --i) {
            d.dest[d.destLen++] = d.source[d.sourceIndex++];
        }
        d.bitcount = 0;
        return TINF_OK;
    }
    function tinf_uncompress(source, dest) {
        var d = new Data(source, dest);
        var bfinal, btype, res;
        do {
            bfinal = tinf_getbit(d);
            btype = tinf_read_bits(d, 2, 0);
            switch (btype) {
            case 0:
                res = tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                res = tinf_inflate_block_data(d, sltree, sdtree);
                break;
            case 2:
                tinf_decode_trees(d, d.ltree, d.dtree);
                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = TINF_DATA_ERROR;
            }
            if (res !== TINF_OK) {
                throw new Error('Data error');
            }
        } while (!bfinal);
        if (d.destLen < d.dest.length) {
            if (typeof d.dest.slice === 'function') {
                return d.dest.slice(0, d.destLen);
            } else {
                return d.dest.subarray(0, d.destLen);
            }
        }
        return d.dest;
    }
    tinf_build_fixed_trees(sltree, sdtree);
    tinf_build_bits_base(length_bits, length_base, 4, 3);
    tinf_build_bits_base(dist_bits, dist_base, 2, 1);
    length_bits[28] = 0;
    length_base[28] = 258;
    var tinyInflate = tinf_uncompress;
    function derive(v0, v1, v2, v3, t) {
        return Math.pow(1 - t, 3) * v0 + 3 * Math.pow(1 - t, 2) * t * v1 + 3 * (1 - t) * Math.pow(t, 2) * v2 + Math.pow(t, 3) * v3;
    }
    function BoundingBox() {
        this.x1 = Number.NaN;
        this.y1 = Number.NaN;
        this.x2 = Number.NaN;
        this.y2 = Number.NaN;
    }
    BoundingBox.prototype.isEmpty = function () {
        return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
    };
    BoundingBox.prototype.addPoint = function (x, y) {
        if (typeof x === 'number') {
            if (isNaN(this.x1) || isNaN(this.x2)) {
                this.x1 = x;
                this.x2 = x;
            }
            if (x < this.x1) {
                this.x1 = x;
            }
            if (x > this.x2) {
                this.x2 = x;
            }
        }
        if (typeof y === 'number') {
            if (isNaN(this.y1) || isNaN(this.y2)) {
                this.y1 = y;
                this.y2 = y;
            }
            if (y < this.y1) {
                this.y1 = y;
            }
            if (y > this.y2) {
                this.y2 = y;
            }
        }
    };
    BoundingBox.prototype.addX = function (x) {
        this.addPoint(x, null);
    };
    BoundingBox.prototype.addY = function (y) {
        this.addPoint(null, y);
    };
    BoundingBox.prototype.addBezier = function (x0, y0, x1, y1, x2, y2, x, y) {
        var this$1 = this;
        var p0 = [
            x0,
            y0
        ];
        var p1 = [
            x1,
            y1
        ];
        var p2 = [
            x2,
            y2
        ];
        var p3 = [
            x,
            y
        ];
        this.addPoint(x0, y0);
        this.addPoint(x, y);
        for (var i = 0; i <= 1; i++) {
            var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            var c = 3 * p1[i] - 3 * p0[i];
            if (a === 0) {
                if (b === 0) {
                    continue;
                }
                var t = -c / b;
                if (0 < t && t < 1) {
                    if (i === 0) {
                        this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t));
                    }
                    if (i === 1) {
                        this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t));
                    }
                }
                continue;
            }
            var b2ac = Math.pow(b, 2) - 4 * c * a;
            if (b2ac < 0) {
                continue;
            }
            var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
            if (0 < t1 && t1 < 1) {
                if (i === 0) {
                    this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t1));
                }
                if (i === 1) {
                    this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t1));
                }
            }
            var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
            if (0 < t2 && t2 < 1) {
                if (i === 0) {
                    this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t2));
                }
                if (i === 1) {
                    this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t2));
                }
            }
        }
    };
    BoundingBox.prototype.addQuad = function (x0, y0, x1, y1, x, y) {
        var cp1x = x0 + 2 / 3 * (x1 - x0);
        var cp1y = y0 + 2 / 3 * (y1 - y0);
        var cp2x = cp1x + 1 / 3 * (x - x0);
        var cp2y = cp1y + 1 / 3 * (y - y0);
        this.addBezier(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y);
    };
    function Path() {
        this.commands = [];
        this.fill = 'black';
        this.stroke = null;
        this.strokeWidth = 1;
    }
    Path.prototype.moveTo = function (x, y) {
        this.commands.push({
            type: 'M',
            x: x,
            y: y
        });
    };
    Path.prototype.lineTo = function (x, y) {
        this.commands.push({
            type: 'L',
            x: x,
            y: y
        });
    };
    Path.prototype.curveTo = Path.prototype.bezierCurveTo = function (x1, y1, x2, y2, x, y) {
        this.commands.push({
            type: 'C',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            x: x,
            y: y
        });
    };
    Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function (x1, y1, x, y) {
        this.commands.push({
            type: 'Q',
            x1: x1,
            y1: y1,
            x: x,
            y: y
        });
    };
    Path.prototype.close = Path.prototype.closePath = function () {
        this.commands.push({ type: 'Z' });
    };
    Path.prototype.extend = function (pathOrCommands) {
        if (pathOrCommands.commands) {
            pathOrCommands = pathOrCommands.commands;
        } else if (pathOrCommands instanceof BoundingBox) {
            var box = pathOrCommands;
            this.moveTo(box.x1, box.y1);
            this.lineTo(box.x2, box.y1);
            this.lineTo(box.x2, box.y2);
            this.lineTo(box.x1, box.y2);
            this.close();
            return;
        }
        Array.prototype.push.apply(this.commands, pathOrCommands);
    };
    Path.prototype.getBoundingBox = function () {
        var this$1 = this;
        var box = new BoundingBox();
        var startX = 0;
        var startY = 0;
        var prevX = 0;
        var prevY = 0;
        for (var i = 0; i < this.commands.length; i++) {
            var cmd = this$1.commands[i];
            switch (cmd.type) {
            case 'M':
                box.addPoint(cmd.x, cmd.y);
                startX = prevX = cmd.x;
                startY = prevY = cmd.y;
                break;
            case 'L':
                box.addPoint(cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'Q':
                box.addQuad(prevX, prevY, cmd.x1, cmd.y1, cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'C':
                box.addBezier(prevX, prevY, cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'Z':
                prevX = startX;
                prevY = startY;
                break;
            default:
                throw new Error('Unexpected path command ' + cmd.type);
            }
        }
        if (box.isEmpty()) {
            box.addPoint(0, 0);
        }
        return box;
    };
    Path.prototype.draw = function (ctx) {
        var this$1 = this;
        function roundTo2DecimalPlaces(v) {
            return Math.round(v * 100) / 100;
        }
        ctx.beginPath();
        for (var i = 0; i < this.commands.length; i += 1) {
            var cmd = this$1.commands[i];
            if (cmd.type === 'M') {
                ctx.moveTo(roundTo2DecimalPlaces(cmd.x), roundTo2DecimalPlaces(cmd.y));
            } else if (cmd.type === 'L') {
                ctx.lineTo(roundTo2DecimalPlaces(cmd.x), roundTo2DecimalPlaces(cmd.y));
            } else if (cmd.type === 'C') {
                ctx.bezierCurveTo(roundTo2DecimalPlaces(cmd.x1), roundTo2DecimalPlaces(cmd.y1), roundTo2DecimalPlaces(cmd.x2), roundTo2DecimalPlaces(cmd.y2), roundTo2DecimalPlaces(cmd.x), roundTo2DecimalPlaces(cmd.y));
            } else if (cmd.type === 'Q') {
                ctx.quadraticCurveTo(roundTo2DecimalPlaces(cmd.x1), roundTo2DecimalPlaces(cmd.y1), roundTo2DecimalPlaces(cmd.x), roundTo2DecimalPlaces(cmd.y));
            } else if (cmd.type === 'Z') {
                ctx.closePath();
            }
        }
        if (this.fill) {
            ctx.fillStyle = this.fill;
            ctx.fill();
        }
        if (this.stroke) {
            ctx.strokeStyle = this.stroke;
            ctx.lineWidth = this.strokeWidth;
            ctx.stroke();
        }
    };
    Path.prototype.toPathData = function (decimalPlaces) {
        var this$1 = this;
        decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;
        function floatToString(v) {
            if (Math.round(v) === v) {
                return '' + Math.round(v);
            } else {
                return v.toFixed(decimalPlaces);
            }
        }
        function packValues() {
            var arguments$1 = arguments;
            var s = '';
            for (var i = 0; i < arguments.length; i += 1) {
                var v = arguments$1[i];
                if (v >= 0 && i > 0) {
                    s += ' ';
                }
                s += floatToString(v);
            }
            return s;
        }
        var d = '';
        for (var i = 0; i < this.commands.length; i += 1) {
            var cmd = this$1.commands[i];
            if (cmd.type === 'M') {
                d += 'M' + packValues(cmd.x, cmd.y);
            } else if (cmd.type === 'L') {
                d += 'L' + packValues(cmd.x, cmd.y);
            } else if (cmd.type === 'C') {
                d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
            } else if (cmd.type === 'Q') {
                d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
            } else if (cmd.type === 'Z') {
                d += 'Z';
            }
        }
        return d;
    };
    Path.prototype.toSVG = function (decimalPlaces) {
        var svg = '<path d="';
        svg += this.toPathData(decimalPlaces);
        svg += '"';
        if (this.fill && this.fill !== 'black') {
            if (this.fill === null) {
                svg += ' fill="none"';
            } else {
                svg += ' fill="' + this.fill + '"';
            }
        }
        if (this.stroke) {
            svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
        }
        svg += '/>';
        return svg;
    };
    Path.prototype.toDOMElement = function (decimalPlaces) {
        var temporaryPath = this.toPathData(decimalPlaces);
        var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        newPath.setAttribute('d', temporaryPath);
        return newPath;
    };
    function fail(message) {
        throw new Error(message);
    }
    function argument(predicate, message) {
        if (!predicate) {
            fail(message);
        }
    }
    var check = {
        fail: fail,
        argument: argument,
        assert: argument
    };
    var LIMIT16 = 32768;
    var LIMIT32 = 2147483648;
    var decode = {};
    var encode = {};
    var sizeOf = {};
    function constant(v) {
        return function () {
            return v;
        };
    }
    encode.BYTE = function (v) {
        check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
        return [v];
    };
    sizeOf.BYTE = constant(1);
    encode.CHAR = function (v) {
        return [v.charCodeAt(0)];
    };
    sizeOf.CHAR = constant(1);
    encode.CHARARRAY = function (v) {
        var b = [];
        for (var i = 0; i < v.length; i += 1) {
            b[i] = v.charCodeAt(i);
        }
        return b;
    };
    sizeOf.CHARARRAY = function (v) {
        return v.length;
    };
    encode.USHORT = function (v) {
        return [
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.USHORT = constant(2);
    encode.SHORT = function (v) {
        if (v >= LIMIT16) {
            v = -(2 * LIMIT16 - v);
        }
        return [
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.SHORT = constant(2);
    encode.UINT24 = function (v) {
        return [
            v >> 16 & 255,
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.UINT24 = constant(3);
    encode.ULONG = function (v) {
        return [
            v >> 24 & 255,
            v >> 16 & 255,
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.ULONG = constant(4);
    encode.LONG = function (v) {
        if (v >= LIMIT32) {
            v = -(2 * LIMIT32 - v);
        }
        return [
            v >> 24 & 255,
            v >> 16 & 255,
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.LONG = constant(4);
    encode.FIXED = encode.ULONG;
    sizeOf.FIXED = sizeOf.ULONG;
    encode.FWORD = encode.SHORT;
    sizeOf.FWORD = sizeOf.SHORT;
    encode.UFWORD = encode.USHORT;
    sizeOf.UFWORD = sizeOf.USHORT;
    encode.LONGDATETIME = function (v) {
        return [
            0,
            0,
            0,
            0,
            v >> 24 & 255,
            v >> 16 & 255,
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.LONGDATETIME = constant(8);
    encode.TAG = function (v) {
        check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
        return [
            v.charCodeAt(0),
            v.charCodeAt(1),
            v.charCodeAt(2),
            v.charCodeAt(3)
        ];
    };
    sizeOf.TAG = constant(4);
    encode.Card8 = encode.BYTE;
    sizeOf.Card8 = sizeOf.BYTE;
    encode.Card16 = encode.USHORT;
    sizeOf.Card16 = sizeOf.USHORT;
    encode.OffSize = encode.BYTE;
    sizeOf.OffSize = sizeOf.BYTE;
    encode.SID = encode.USHORT;
    sizeOf.SID = sizeOf.USHORT;
    encode.NUMBER = function (v) {
        if (v >= -107 && v <= 107) {
            return [v + 139];
        } else if (v >= 108 && v <= 1131) {
            v = v - 108;
            return [
                (v >> 8) + 247,
                v & 255
            ];
        } else if (v >= -1131 && v <= -108) {
            v = -v - 108;
            return [
                (v >> 8) + 251,
                v & 255
            ];
        } else if (v >= -32768 && v <= 32767) {
            return encode.NUMBER16(v);
        } else {
            return encode.NUMBER32(v);
        }
    };
    sizeOf.NUMBER = function (v) {
        return encode.NUMBER(v).length;
    };
    encode.NUMBER16 = function (v) {
        return [
            28,
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.NUMBER16 = constant(3);
    encode.NUMBER32 = function (v) {
        return [
            29,
            v >> 24 & 255,
            v >> 16 & 255,
            v >> 8 & 255,
            v & 255
        ];
    };
    sizeOf.NUMBER32 = constant(5);
    encode.REAL = function (v) {
        var value = v.toString();
        var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
        if (m) {
            var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
            value = (Math.round(v * epsilon) / epsilon).toString();
        }
        var nibbles = '';
        for (var i = 0, ii = value.length; i < ii; i += 1) {
            var c = value[i];
            if (c === 'e') {
                nibbles += value[++i] === '-' ? 'c' : 'b';
            } else if (c === '.') {
                nibbles += 'a';
            } else if (c === '-') {
                nibbles += 'e';
            } else {
                nibbles += c;
            }
        }
        nibbles += nibbles.length & 1 ? 'f' : 'ff';
        var out = [30];
        for (var i$1 = 0, ii$1 = nibbles.length; i$1 < ii$1; i$1 += 2) {
            out.push(parseInt(nibbles.substr(i$1, 2), 16));
        }
        return out;
    };
    sizeOf.REAL = function (v) {
        return encode.REAL(v).length;
    };
    encode.NAME = encode.CHARARRAY;
    sizeOf.NAME = sizeOf.CHARARRAY;
    encode.STRING = encode.CHARARRAY;
    sizeOf.STRING = sizeOf.CHARARRAY;
    decode.UTF8 = function (data, offset, numBytes) {
        var codePoints = [];
        var numChars = numBytes;
        for (var j = 0; j < numChars; j++, offset += 1) {
            codePoints[j] = data.getUint8(offset);
        }
        return String.fromCharCode.apply(null, codePoints);
    };
    decode.UTF16 = function (data, offset, numBytes) {
        var codePoints = [];
        var numChars = numBytes / 2;
        for (var j = 0; j < numChars; j++, offset += 2) {
            codePoints[j] = data.getUint16(offset);
        }
        return String.fromCharCode.apply(null, codePoints);
    };
    encode.UTF16 = function (v) {
        var b = [];
        for (var i = 0; i < v.length; i += 1) {
            var codepoint = v.charCodeAt(i);
            b[b.length] = codepoint >> 8 & 255;
            b[b.length] = codepoint & 255;
        }
        return b;
    };
    sizeOf.UTF16 = function (v) {
        return v.length * 2;
    };
    var eightBitMacEncodings = {
        'x-mac-croatian': 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü\u2020\xB0\xA2\xA3\xA7\u2022\xB6ß\xAEŠ\u2122\xB4\xA8\u2260ŽØ\u221E\xB1\u2264\u2265\u2206µ\u2202\u2211\u220Fš\u222BªºΩžø' + '\xBF\xA1\xAC\u221Aƒ\u2248Ć\xABČ\u2026\xA0ÀÃÕŒœĐ\u2014\u201C\u201D\u2018\u2019\xF7\u25CA\uF8FF\xA9\u2044\u20AC\u2039\u203AÆ\xBB\u2013\xB7\u201A\u201E\u2030ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ\u02DC\xAFπË\u02DA\xB8Êæˇ',
        'x-mac-cyrillic': 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ\u2020\xB0Ґ\xA3\xA7\u2022\xB6І\xAE\xA9\u2122Ђђ\u2260Ѓѓ\u221E\xB1\u2264\u2265іµґЈЄєЇїЉљЊњ' + 'јЅ\xAC\u221Aƒ\u2248\u2206\xAB\xBB\u2026\xA0ЋћЌќѕ\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u201EЎўЏџ\u2116Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю',
        'x-mac-gaelic': 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü\u2020\xB0\xA2\xA3\xA7\u2022\xB6ß\xAE\xA9\u2122\xB4\xA8\u2260ÆØḂ\xB1\u2264\u2265ḃĊċḊḋḞḟĠġṀæø' + 'ṁṖṗɼƒſṠ\xAB\xBB\u2026\xA0ÀÃÕŒœ\u2013\u2014\u201C\u201D\u2018\u2019ṡẛÿŸṪ\u20AC\u2039\u203AŶŷṫ\xB7Ỳỳ\u204AÂÊÁËÈÍÎÏÌÓÔ\u2663ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ',
        'x-mac-greek': 'Ä\xB9\xB2É\xB3ÖÜ\u0385àâä\u0384\xA8çéèêë\xA3\u2122îï\u2022\xBD\u2030ôö\xA6\u20ACùûü\u2020ΓΔΘΛΞΠß\xAE\xA9ΣΪ\xA7\u2260\xB0\xB7Α\xB1\u2264\u2265\xA5ΒΕΖΗΙΚΜΦΫΨΩ' + 'άΝ\xACΟΡ\u2248Τ\xAB\xBB\u2026\xA0ΥΧΆΈœ\u2013\u2015\u201C\u201D\u2018\u2019\xF7ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ\xAD',
        'x-mac-icelandic': 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ\xB0\xA2\xA3\xA7\u2022\xB6ß\xAE\xA9\u2122\xB4\xA8\u2260ÆØ\u221E\xB1\u2264\u2265\xA5µ\u2202\u2211\u220Fπ\u222BªºΩæø' + '\xBF\xA1\xAC\u221Aƒ\u2248\u2206\xAB\xBB\u2026\xA0ÀÃÕŒœ\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CAÿŸ\u2044\u20ACÐðÞþý\xB7\u201A\u201E\u2030ÂÊÁËÈÍÎÏÌÓÔ\uF8FFÒÚÛÙıˆ\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DBˇ',
        'x-mac-inuit': 'ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ\xB0ᒡᒥᒦ\u2022\xB6ᒧ\xAE\xA9\u2122ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗ' + 'ᓘᓚᓛᓪᔨᔩᔪᔫᔭ\u2026\xA0ᔮᔾᕕᕖᕗ\u2013\u2014\u201C\u201D\u2018\u2019ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł',
        'x-mac-ce': 'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü\u2020\xB0Ę\xA3\xA7\u2022\xB6ß\xAE\xA9\u2122ę\xA8\u2260ģĮįĪ\u2264\u2265īĶ\u2202\u2211łĻļĽľĹĺŅ' + 'ņŃ\xAC\u221AńŇ\u2206\xAB\xBB\u2026\xA0ňŐÕőŌ\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CAōŔŕŘ\u2039\u203AřŖŗŠ\u201A\u201EšŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
        macintosh: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü\u2020\xB0\xA2\xA3\xA7\u2022\xB6ß\xAE\xA9\u2122\xB4\xA8\u2260ÆØ\u221E\xB1\u2264\u2265\xA5µ\u2202\u2211\u220Fπ\u222BªºΩæø' + '\xBF\xA1\xAC\u221Aƒ\u2248\u2206\xAB\xBB\u2026\xA0ÀÃÕŒœ\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CAÿŸ\u2044\u20AC\u2039\u203Aﬁﬂ\u2021\xB7\u201A\u201E\u2030ÂÊÁËÈÍÎÏÌÓÔ\uF8FFÒÚÛÙıˆ\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DBˇ',
        'x-mac-romanian': 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü\u2020\xB0\xA2\xA3\xA7\u2022\xB6ß\xAE\xA9\u2122\xB4\xA8\u2260ĂȘ\u221E\xB1\u2264\u2265\xA5µ\u2202\u2211\u220Fπ\u222BªºΩăș' + '\xBF\xA1\xAC\u221Aƒ\u2248\u2206\xAB\xBB\u2026\xA0ÀÃÕŒœ\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CAÿŸ\u2044\u20AC\u2039\u203AȚț\u2021\xB7\u201A\u201E\u2030ÂÊÁËÈÍÎÏÌÓÔ\uF8FFÒÚÛÙıˆ\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DBˇ',
        'x-mac-turkish': 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü\u2020\xB0\xA2\xA3\xA7\u2022\xB6ß\xAE\xA9\u2122\xB4\xA8\u2260ÆØ\u221E\xB1\u2264\u2265\xA5µ\u2202\u2211\u220Fπ\u222BªºΩæø' + '\xBF\xA1\xAC\u221Aƒ\u2248\u2206\xAB\xBB\u2026\xA0ÀÃÕŒœ\u2013\u2014\u201C\u201D\u2018\u2019\xF7\u25CAÿŸĞğİıŞş\u2021\xB7\u201A\u201E\u2030ÂÊÁËÈÍÎÏÌÓÔ\uF8FFÒÚÛÙ\uF8A0ˆ\u02DC\xAF\u02D8\u02D9\u02DA\xB8\u02DD\u02DBˇ'
    };
    decode.MACSTRING = function (dataView, offset, dataLength, encoding) {
        var table = eightBitMacEncodings[encoding];
        if (table === undefined) {
            return undefined;
        }
        var result = '';
        for (var i = 0; i < dataLength; i++) {
            var c = dataView.getUint8(offset + i);
            if (c <= 127) {
                result += String.fromCharCode(c);
            } else {
                result += table[c & 127];
            }
        }
        return result;
    };
    var macEncodingTableCache = typeof WeakMap === 'function' && new WeakMap();
    var macEncodingCacheKeys;
    var getMacEncodingTable = function (encoding) {
        if (!macEncodingCacheKeys) {
            macEncodingCacheKeys = {};
            for (var e in eightBitMacEncodings) {
                macEncodingCacheKeys[e] = new String(e);
            }
        }
        var cacheKey = macEncodingCacheKeys[encoding];
        if (cacheKey === undefined) {
            return undefined;
        }
        if (macEncodingTableCache) {
            var cachedTable = macEncodingTableCache.get(cacheKey);
            if (cachedTable !== undefined) {
                return cachedTable;
            }
        }
        var decodingTable = eightBitMacEncodings[encoding];
        if (decodingTable === undefined) {
            return undefined;
        }
        var encodingTable = {};
        for (var i = 0; i < decodingTable.length; i++) {
            encodingTable[decodingTable.charCodeAt(i)] = i + 128;
        }
        if (macEncodingTableCache) {
            macEncodingTableCache.set(cacheKey, encodingTable);
        }
        return encodingTable;
    };
    encode.MACSTRING = function (str, encoding) {
        var table = getMacEncodingTable(encoding);
        if (table === undefined) {
            return undefined;
        }
        var result = [];
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            if (c >= 128) {
                c = table[c];
                if (c === undefined) {
                    return undefined;
                }
            }
            result[i] = c;
        }
        return result;
    };
    sizeOf.MACSTRING = function (str, encoding) {
        var b = encode.MACSTRING(str, encoding);
        if (b !== undefined) {
            return b.length;
        } else {
            return 0;
        }
    };
    function isByteEncodable(value) {
        return value >= -128 && value <= 127;
    }
    function encodeVarDeltaRunAsZeroes(deltas, pos, result) {
        var runLength = 0;
        var numDeltas = deltas.length;
        while (pos < numDeltas && runLength < 64 && deltas[pos] === 0) {
            ++pos;
            ++runLength;
        }
        result.push(128 | runLength - 1);
        return pos;
    }
    function encodeVarDeltaRunAsBytes(deltas, offset, result) {
        var runLength = 0;
        var numDeltas = deltas.length;
        var pos = offset;
        while (pos < numDeltas && runLength < 64) {
            var value = deltas[pos];
            if (!isByteEncodable(value)) {
                break;
            }
            if (value === 0 && pos + 1 < numDeltas && deltas[pos + 1] === 0) {
                break;
            }
            ++pos;
            ++runLength;
        }
        result.push(runLength - 1);
        for (var i = offset; i < pos; ++i) {
            result.push(deltas[i] + 256 & 255);
        }
        return pos;
    }
    function encodeVarDeltaRunAsWords(deltas, offset, result) {
        var runLength = 0;
        var numDeltas = deltas.length;
        var pos = offset;
        while (pos < numDeltas && runLength < 64) {
            var value = deltas[pos];
            if (value === 0) {
                break;
            }
            if (isByteEncodable(value) && pos + 1 < numDeltas && isByteEncodable(deltas[pos + 1])) {
                break;
            }
            ++pos;
            ++runLength;
        }
        result.push(64 | runLength - 1);
        for (var i = offset; i < pos; ++i) {
            var val = deltas[i];
            result.push(val + 65536 >> 8 & 255, val + 256 & 255);
        }
        return pos;
    }
    encode.VARDELTAS = function (deltas) {
        var pos = 0;
        var result = [];
        while (pos < deltas.length) {
            var value = deltas[pos];
            if (value === 0) {
                pos = encodeVarDeltaRunAsZeroes(deltas, pos, result);
            } else if (value >= -128 && value <= 127) {
                pos = encodeVarDeltaRunAsBytes(deltas, pos, result);
            } else {
                pos = encodeVarDeltaRunAsWords(deltas, pos, result);
            }
        }
        return result;
    };
    encode.INDEX = function (l) {
        var offset = 1;
        var offsets = [offset];
        var data = [];
        for (var i = 0; i < l.length; i += 1) {
            var v = encode.OBJECT(l[i]);
            Array.prototype.push.apply(data, v);
            offset += v.length;
            offsets.push(offset);
        }
        if (data.length === 0) {
            return [
                0,
                0
            ];
        }
        var encodedOffsets = [];
        var offSize = 1 + Math.floor(Math.log(offset) / Math.log(2)) / 8 | 0;
        var offsetEncoder = [
            undefined,
            encode.BYTE,
            encode.USHORT,
            encode.UINT24,
            encode.ULONG
        ][offSize];
        for (var i$1 = 0; i$1 < offsets.length; i$1 += 1) {
            var encodedOffset = offsetEncoder(offsets[i$1]);
            Array.prototype.push.apply(encodedOffsets, encodedOffset);
        }
        return Array.prototype.concat(encode.Card16(l.length), encode.OffSize(offSize), encodedOffsets, data);
    };
    sizeOf.INDEX = function (v) {
        return encode.INDEX(v).length;
    };
    encode.DICT = function (m) {
        var d = [];
        var keys = Object.keys(m);
        var length = keys.length;
        for (var i = 0; i < length; i += 1) {
            var k = parseInt(keys[i], 0);
            var v = m[k];
            d = d.concat(encode.OPERAND(v.value, v.type));
            d = d.concat(encode.OPERATOR(k));
        }
        return d;
    };
    sizeOf.DICT = function (m) {
        return encode.DICT(m).length;
    };
    encode.OPERATOR = function (v) {
        if (v < 1200) {
            return [v];
        } else {
            return [
                12,
                v - 1200
            ];
        }
    };
    encode.OPERAND = function (v, type) {
        var d = [];
        if (Array.isArray(type)) {
            for (var i = 0; i < type.length; i += 1) {
                check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
                d = d.concat(encode.OPERAND(v[i], type[i]));
            }
        } else {
            if (type === 'SID') {
                d = d.concat(encode.NUMBER(v));
            } else if (type === 'offset') {
                d = d.concat(encode.NUMBER32(v));
            } else if (type === 'number') {
                d = d.concat(encode.NUMBER(v));
            } else if (type === 'real') {
                d = d.concat(encode.REAL(v));
            } else {
                throw new Error('Unknown operand type ' + type);
            }
        }
        return d;
    };
    encode.OP = encode.BYTE;
    sizeOf.OP = sizeOf.BYTE;
    var wmm = typeof WeakMap === 'function' && new WeakMap();
    encode.CHARSTRING = function (ops) {
        if (wmm) {
            var cachedValue = wmm.get(ops);
            if (cachedValue !== undefined) {
                return cachedValue;
            }
        }
        var d = [];
        var length = ops.length;
        for (var i = 0; i < length; i += 1) {
            var op = ops[i];
            d = d.concat(encode[op.type](op.value));
        }
        if (wmm) {
            wmm.set(ops, d);
        }
        return d;
    };
    sizeOf.CHARSTRING = function (ops) {
        return encode.CHARSTRING(ops).length;
    };
    encode.OBJECT = function (v) {
        var encodingFunction = encode[v.type];
        check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
        return encodingFunction(v.value);
    };
    sizeOf.OBJECT = function (v) {
        var sizeOfFunction = sizeOf[v.type];
        check.argument(sizeOfFunction !== undefined, 'No sizeOf function for type ' + v.type);
        return sizeOfFunction(v.value);
    };
    encode.TABLE = function (table) {
        var d = [];
        var length = table.fields.length;
        var subtables = [];
        var subtableOffsets = [];
        for (var i = 0; i < length; i += 1) {
            var field = table.fields[i];
            var encodingFunction = encode[field.type];
            check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type + ' (' + field.name + ')');
            var value = table[field.name];
            if (value === undefined) {
                value = field.value;
            }
            var bytes = encodingFunction(value);
            if (field.type === 'TABLE') {
                subtableOffsets.push(d.length);
                d = d.concat([
                    0,
                    0
                ]);
                subtables.push(bytes);
            } else {
                d = d.concat(bytes);
            }
        }
        for (var i$1 = 0; i$1 < subtables.length; i$1 += 1) {
            var o = subtableOffsets[i$1];
            var offset = d.length;
            check.argument(offset < 65536, 'Table ' + table.tableName + ' too big.');
            d[o] = offset >> 8;
            d[o + 1] = offset & 255;
            d = d.concat(subtables[i$1]);
        }
        return d;
    };
    sizeOf.TABLE = function (table) {
        var numBytes = 0;
        var length = table.fields.length;
        for (var i = 0; i < length; i += 1) {
            var field = table.fields[i];
            var sizeOfFunction = sizeOf[field.type];
            check.argument(sizeOfFunction !== undefined, 'No sizeOf function for field type ' + field.type + ' (' + field.name + ')');
            var value = table[field.name];
            if (value === undefined) {
                value = field.value;
            }
            numBytes += sizeOfFunction(value);
            if (field.type === 'TABLE') {
                numBytes += 2;
            }
        }
        return numBytes;
    };
    encode.RECORD = encode.TABLE;
    sizeOf.RECORD = sizeOf.TABLE;
    encode.LITERAL = function (v) {
        return v;
    };
    sizeOf.LITERAL = function (v) {
        return v.length;
    };
    function Table(tableName, fields, options) {
        var this$1 = this;
        for (var i = 0; i < fields.length; i += 1) {
            var field = fields[i];
            this$1[field.name] = field.value;
        }
        this.tableName = tableName;
        this.fields = fields;
        if (options) {
            var optionKeys = Object.keys(options);
            for (var i$1 = 0; i$1 < optionKeys.length; i$1 += 1) {
                var k = optionKeys[i$1];
                var v = options[k];
                if (this$1[k] !== undefined) {
                    this$1[k] = v;
                }
            }
        }
    }
    Table.prototype.encode = function () {
        return encode.TABLE(this);
    };
    Table.prototype.sizeOf = function () {
        return sizeOf.TABLE(this);
    };
    function ushortList(itemName, list, count) {
        if (count === undefined) {
            count = list.length;
        }
        var fields = new Array(list.length + 1);
        fields[0] = {
            name: itemName + 'Count',
            type: 'USHORT',
            value: count
        };
        for (var i = 0; i < list.length; i++) {
            fields[i + 1] = {
                name: itemName + i,
                type: 'USHORT',
                value: list[i]
            };
        }
        return fields;
    }
    function tableList(itemName, records, itemCallback) {
        var count = records.length;
        var fields = new Array(count + 1);
        fields[0] = {
            name: itemName + 'Count',
            type: 'USHORT',
            value: count
        };
        for (var i = 0; i < count; i++) {
            fields[i + 1] = {
                name: itemName + i,
                type: 'TABLE',
                value: itemCallback(records[i], i)
            };
        }
        return fields;
    }
    function recordList(itemName, records, itemCallback) {
        var count = records.length;
        var fields = [];
        fields[0] = {
            name: itemName + 'Count',
            type: 'USHORT',
            value: count
        };
        for (var i = 0; i < count; i++) {
            fields = fields.concat(itemCallback(records[i], i));
        }
        return fields;
    }
    function Coverage(coverageTable) {
        if (coverageTable.format === 1) {
            Table.call(this, 'coverageTable', [{
                    name: 'coverageFormat',
                    type: 'USHORT',
                    value: 1
                }].concat(ushortList('glyph', coverageTable.glyphs)));
        } else {
            check.assert(false, 'Can\'t create coverage table format 2 yet.');
        }
    }
    Coverage.prototype = Object.create(Table.prototype);
    Coverage.prototype.constructor = Coverage;
    function ScriptList(scriptListTable) {
        Table.call(this, 'scriptListTable', recordList('scriptRecord', scriptListTable, function (scriptRecord, i) {
            var script = scriptRecord.script;
            var defaultLangSys = script.defaultLangSys;
            check.assert(!!defaultLangSys, 'Unable to write GSUB: script ' + scriptRecord.tag + ' has no default language system.');
            return [
                {
                    name: 'scriptTag' + i,
                    type: 'TAG',
                    value: scriptRecord.tag
                },
                {
                    name: 'script' + i,
                    type: 'TABLE',
                    value: new Table('scriptTable', [{
                            name: 'defaultLangSys',
                            type: 'TABLE',
                            value: new Table('defaultLangSys', [
                                {
                                    name: 'lookupOrder',
                                    type: 'USHORT',
                                    value: 0
                                },
                                {
                                    name: 'reqFeatureIndex',
                                    type: 'USHORT',
                                    value: defaultLangSys.reqFeatureIndex
                                }
                            ].concat(ushortList('featureIndex', defaultLangSys.featureIndexes)))
                        }].concat(recordList('langSys', script.langSysRecords, function (langSysRecord, i) {
                        var langSys = langSysRecord.langSys;
                        return [
                            {
                                name: 'langSysTag' + i,
                                type: 'TAG',
                                value: langSysRecord.tag
                            },
                            {
                                name: 'langSys' + i,
                                type: 'TABLE',
                                value: new Table('langSys', [
                                    {
                                        name: 'lookupOrder',
                                        type: 'USHORT',
                                        value: 0
                                    },
                                    {
                                        name: 'reqFeatureIndex',
                                        type: 'USHORT',
                                        value: langSys.reqFeatureIndex
                                    }
                                ].concat(ushortList('featureIndex', langSys.featureIndexes)))
                            }
                        ];
                    })))
                }
            ];
        }));
    }
    ScriptList.prototype = Object.create(Table.prototype);
    ScriptList.prototype.constructor = ScriptList;
    function FeatureList(featureListTable) {
        Table.call(this, 'featureListTable', recordList('featureRecord', featureListTable, function (featureRecord, i) {
            var feature = featureRecord.feature;
            return [
                {
                    name: 'featureTag' + i,
                    type: 'TAG',
                    value: featureRecord.tag
                },
                {
                    name: 'feature' + i,
                    type: 'TABLE',
                    value: new Table('featureTable', [{
                            name: 'featureParams',
                            type: 'USHORT',
                            value: feature.featureParams
                        }].concat(ushortList('lookupListIndex', feature.lookupListIndexes)))
                }
            ];
        }));
    }
    FeatureList.prototype = Object.create(Table.prototype);
    FeatureList.prototype.constructor = FeatureList;
    function LookupList(lookupListTable, subtableMakers) {
        Table.call(this, 'lookupListTable', tableList('lookup', lookupListTable, function (lookupTable) {
            var subtableCallback = subtableMakers[lookupTable.lookupType];
            check.assert(!!subtableCallback, 'Unable to write GSUB lookup type ' + lookupTable.lookupType + ' tables.');
            return new Table('lookupTable', [
                {
                    name: 'lookupType',
                    type: 'USHORT',
                    value: lookupTable.lookupType
                },
                {
                    name: 'lookupFlag',
                    type: 'USHORT',
                    value: lookupTable.lookupFlag
                }
            ].concat(tableList('subtable', lookupTable.subtables, subtableCallback)));
        }));
    }
    LookupList.prototype = Object.create(Table.prototype);
    LookupList.prototype.constructor = LookupList;
    var table = {
        Table: Table,
        Record: Table,
        Coverage: Coverage,
        ScriptList: ScriptList,
        FeatureList: FeatureList,
        LookupList: LookupList,
        ushortList: ushortList,
        tableList: tableList,
        recordList: recordList
    };
    function getByte(dataView, offset) {
        return dataView.getUint8(offset);
    }
    function getUShort(dataView, offset) {
        return dataView.getUint16(offset, false);
    }
    function getShort(dataView, offset) {
        return dataView.getInt16(offset, false);
    }
    function getULong(dataView, offset) {
        return dataView.getUint32(offset, false);
    }
    function getFixed(dataView, offset) {
        var decimal = dataView.getInt16(offset, false);
        var fraction = dataView.getUint16(offset + 2, false);
        return decimal + fraction / 65535;
    }
    function getTag(dataView, offset) {
        var tag = '';
        for (var i = offset; i < offset + 4; i += 1) {
            tag += String.fromCharCode(dataView.getInt8(i));
        }
        return tag;
    }
    function getOffset(dataView, offset, offSize) {
        var v = 0;
        for (var i = 0; i < offSize; i += 1) {
            v <<= 8;
            v += dataView.getUint8(offset + i);
        }
        return v;
    }
    function getBytes(dataView, startOffset, endOffset) {
        var bytes = [];
        for (var i = startOffset; i < endOffset; i += 1) {
            bytes.push(dataView.getUint8(i));
        }
        return bytes;
    }
    function bytesToString(bytes) {
        var s = '';
        for (var i = 0; i < bytes.length; i += 1) {
            s += String.fromCharCode(bytes[i]);
        }
        return s;
    }
    var typeOffsets = {
        byte: 1,
        uShort: 2,
        short: 2,
        uLong: 4,
        fixed: 4,
        longDateTime: 8,
        tag: 4
    };
    function Parser(data, offset) {
        this.data = data;
        this.offset = offset;
        this.relativeOffset = 0;
    }
    Parser.prototype.parseByte = function () {
        var v = this.data.getUint8(this.offset + this.relativeOffset);
        this.relativeOffset += 1;
        return v;
    };
    Parser.prototype.parseChar = function () {
        var v = this.data.getInt8(this.offset + this.relativeOffset);
        this.relativeOffset += 1;
        return v;
    };
    Parser.prototype.parseCard8 = Parser.prototype.parseByte;
    Parser.prototype.parseUShort = function () {
        var v = this.data.getUint16(this.offset + this.relativeOffset);
        this.relativeOffset += 2;
        return v;
    };
    Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
    Parser.prototype.parseSID = Parser.prototype.parseUShort;
    Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;
    Parser.prototype.parseShort = function () {
        var v = this.data.getInt16(this.offset + this.relativeOffset);
        this.relativeOffset += 2;
        return v;
    };
    Parser.prototype.parseF2Dot14 = function () {
        var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
        this.relativeOffset += 2;
        return v;
    };
    Parser.prototype.parseULong = function () {
        var v = getULong(this.data, this.offset + this.relativeOffset);
        this.relativeOffset += 4;
        return v;
    };
    Parser.prototype.parseOffset32 = Parser.prototype.parseULong;
    Parser.prototype.parseFixed = function () {
        var v = getFixed(this.data, this.offset + this.relativeOffset);
        this.relativeOffset += 4;
        return v;
    };
    Parser.prototype.parseString = function (length) {
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        var string = '';
        this.relativeOffset += length;
        for (var i = 0; i < length; i++) {
            string += String.fromCharCode(dataView.getUint8(offset + i));
        }
        return string;
    };
    Parser.prototype.parseTag = function () {
        return this.parseString(4);
    };
    Parser.prototype.parseLongDateTime = function () {
        var v = getULong(this.data, this.offset + this.relativeOffset + 4);
        v -= 2082844800;
        this.relativeOffset += 8;
        return v;
    };
    Parser.prototype.parseVersion = function (minorBase) {
        var major = getUShort(this.data, this.offset + this.relativeOffset);
        var minor = getUShort(this.data, this.offset + this.relativeOffset + 2);
        this.relativeOffset += 4;
        if (minorBase === undefined) {
            minorBase = 4096;
        }
        return major + minor / minorBase / 10;
    };
    Parser.prototype.skip = function (type, amount) {
        if (amount === undefined) {
            amount = 1;
        }
        this.relativeOffset += typeOffsets[type] * amount;
    };
    Parser.prototype.parseULongList = function (count) {
        if (count === undefined) {
            count = this.parseULong();
        }
        var offsets = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            offsets[i] = dataView.getUint32(offset);
            offset += 4;
        }
        this.relativeOffset += count * 4;
        return offsets;
    };
    Parser.prototype.parseOffset16List = Parser.prototype.parseUShortList = function (count) {
        if (count === undefined) {
            count = this.parseUShort();
        }
        var offsets = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            offsets[i] = dataView.getUint16(offset);
            offset += 2;
        }
        this.relativeOffset += count * 2;
        return offsets;
    };
    Parser.prototype.parseShortList = function (count) {
        var list = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            list[i] = dataView.getInt16(offset);
            offset += 2;
        }
        this.relativeOffset += count * 2;
        return list;
    };
    Parser.prototype.parseByteList = function (count) {
        var list = new Array(count);
        var dataView = this.data;
        var offset = this.offset + this.relativeOffset;
        for (var i = 0; i < count; i++) {
            list[i] = dataView.getUint8(offset++);
        }
        this.relativeOffset += count;
        return list;
    };
    Parser.prototype.parseList = function (count, itemCallback) {
        var this$1 = this;
        if (!itemCallback) {
            itemCallback = count;
            count = this.parseUShort();
        }
        var list = new Array(count);
        for (var i = 0; i < count; i++) {
            list[i] = itemCallback.call(this$1);
        }
        return list;
    };
    Parser.prototype.parseList32 = function (count, itemCallback) {
        var this$1 = this;
        if (!itemCallback) {
            itemCallback = count;
            count = this.parseULong();
        }
        var list = new Array(count);
        for (var i = 0; i < count; i++) {
            list[i] = itemCallback.call(this$1);
        }
        return list;
    };
    Parser.prototype.parseRecordList = function (count, recordDescription) {
        var this$1 = this;
        if (!recordDescription) {
            recordDescription = count;
            count = this.parseUShort();
        }
        var records = new Array(count);
        var fields = Object.keys(recordDescription);
        for (var i = 0; i < count; i++) {
            var rec = {};
            for (var j = 0; j < fields.length; j++) {
                var fieldName = fields[j];
                var fieldType = recordDescription[fieldName];
                rec[fieldName] = fieldType.call(this$1);
            }
            records[i] = rec;
        }
        return records;
    };
    Parser.prototype.parseRecordList32 = function (count, recordDescription) {
        var this$1 = this;
        if (!recordDescription) {
            recordDescription = count;
            count = this.parseULong();
        }
        var records = new Array(count);
        var fields = Object.keys(recordDescription);
        for (var i = 0; i < count; i++) {
            var rec = {};
            for (var j = 0; j < fields.length; j++) {
                var fieldName = fields[j];
                var fieldType = recordDescription[fieldName];
                rec[fieldName] = fieldType.call(this$1);
            }
            records[i] = rec;
        }
        return records;
    };
    Parser.prototype.parseStruct = function (description) {
        var this$1 = this;
        if (typeof description === 'function') {
            return description.call(this);
        } else {
            var fields = Object.keys(description);
            var struct = {};
            for (var j = 0; j < fields.length; j++) {
                var fieldName = fields[j];
                var fieldType = description[fieldName];
                struct[fieldName] = fieldType.call(this$1);
            }
            return struct;
        }
    };
    Parser.prototype.parseValueRecord = function (valueFormat) {
        if (valueFormat === undefined) {
            valueFormat = this.parseUShort();
        }
        if (valueFormat === 0) {
            return;
        }
        var valueRecord = {};
        if (valueFormat & 1) {
            valueRecord.xPlacement = this.parseShort();
        }
        if (valueFormat & 2) {
            valueRecord.yPlacement = this.parseShort();
        }
        if (valueFormat & 4) {
            valueRecord.xAdvance = this.parseShort();
        }
        if (valueFormat & 8) {
            valueRecord.yAdvance = this.parseShort();
        }
        if (valueFormat & 16) {
            valueRecord.xPlaDevice = undefined;
            this.parseShort();
        }
        if (valueFormat & 32) {
            valueRecord.yPlaDevice = undefined;
            this.parseShort();
        }
        if (valueFormat & 64) {
            valueRecord.xAdvDevice = undefined;
            this.parseShort();
        }
        if (valueFormat & 128) {
            valueRecord.yAdvDevice = undefined;
            this.parseShort();
        }
        return valueRecord;
    };
    Parser.prototype.parseValueRecordList = function () {
        var this$1 = this;
        var valueFormat = this.parseUShort();
        var valueCount = this.parseUShort();
        var values = new Array(valueCount);
        for (var i = 0; i < valueCount; i++) {
            values[i] = this$1.parseValueRecord(valueFormat);
        }
        return values;
    };
    Parser.prototype.parsePointer = function (description) {
        var structOffset = this.parseOffset16();
        if (structOffset > 0) {
            return new Parser(this.data, this.offset + structOffset).parseStruct(description);
        }
        return undefined;
    };
    Parser.prototype.parsePointer32 = function (description) {
        var structOffset = this.parseOffset32();
        if (structOffset > 0) {
            return new Parser(this.data, this.offset + structOffset).parseStruct(description);
        }
        return undefined;
    };
    Parser.prototype.parseListOfLists = function (itemCallback) {
        var this$1 = this;
        var offsets = this.parseOffset16List();
        var count = offsets.length;
        var relativeOffset = this.relativeOffset;
        var list = new Array(count);
        for (var i = 0; i < count; i++) {
            var start = offsets[i];
            if (start === 0) {
                list[i] = undefined;
                continue;
            }
            this$1.relativeOffset = start;
            if (itemCallback) {
                var subOffsets = this$1.parseOffset16List();
                var subList = new Array(subOffsets.length);
                for (var j = 0; j < subOffsets.length; j++) {
                    this$1.relativeOffset = start + subOffsets[j];
                    subList[j] = itemCallback.call(this$1);
                }
                list[i] = subList;
            } else {
                list[i] = this$1.parseUShortList();
            }
        }
        this.relativeOffset = relativeOffset;
        return list;
    };
    Parser.prototype.parseCoverage = function () {
        var this$1 = this;
        var startOffset = this.offset + this.relativeOffset;
        var format = this.parseUShort();
        var count = this.parseUShort();
        if (format === 1) {
            return {
                format: 1,
                glyphs: this.parseUShortList(count)
            };
        } else if (format === 2) {
            var ranges = new Array(count);
            for (var i = 0; i < count; i++) {
                ranges[i] = {
                    start: this$1.parseUShort(),
                    end: this$1.parseUShort(),
                    index: this$1.parseUShort()
                };
            }
            return {
                format: 2,
                ranges: ranges
            };
        }
        throw new Error('0x' + startOffset.toString(16) + ': Coverage format must be 1 or 2.');
    };
    Parser.prototype.parseClassDef = function () {
        var startOffset = this.offset + this.relativeOffset;
        var format = this.parseUShort();
        if (format === 1) {
            return {
                format: 1,
                startGlyph: this.parseUShort(),
                classes: this.parseUShortList()
            };
        } else if (format === 2) {
            return {
                format: 2,
                ranges: this.parseRecordList({
                    start: Parser.uShort,
                    end: Parser.uShort,
                    classId: Parser.uShort
                })
            };
        }
        throw new Error('0x' + startOffset.toString(16) + ': ClassDef format must be 1 or 2.');
    };
    Parser.list = function (count, itemCallback) {
        return function () {
            return this.parseList(count, itemCallback);
        };
    };
    Parser.list32 = function (count, itemCallback) {
        return function () {
            return this.parseList32(count, itemCallback);
        };
    };
    Parser.recordList = function (count, recordDescription) {
        return function () {
            return this.parseRecordList(count, recordDescription);
        };
    };
    Parser.recordList32 = function (count, recordDescription) {
        return function () {
            return this.parseRecordList32(count, recordDescription);
        };
    };
    Parser.pointer = function (description) {
        return function () {
            return this.parsePointer(description);
        };
    };
    Parser.pointer32 = function (description) {
        return function () {
            return this.parsePointer32(description);
        };
    };
    Parser.tag = Parser.prototype.parseTag;
    Parser.byte = Parser.prototype.parseByte;
    Parser.uShort = Parser.offset16 = Parser.prototype.parseUShort;
    Parser.uShortList = Parser.prototype.parseUShortList;
    Parser.uLong = Parser.offset32 = Parser.prototype.parseULong;
    Parser.uLongList = Parser.prototype.parseULongList;
    Parser.struct = Parser.prototype.parseStruct;
    Parser.coverage = Parser.prototype.parseCoverage;
    Parser.classDef = Parser.prototype.parseClassDef;
    var langSysTable = {
        reserved: Parser.uShort,
        reqFeatureIndex: Parser.uShort,
        featureIndexes: Parser.uShortList
    };
    Parser.prototype.parseScriptList = function () {
        return this.parsePointer(Parser.recordList({
            tag: Parser.tag,
            script: Parser.pointer({
                defaultLangSys: Parser.pointer(langSysTable),
                langSysRecords: Parser.recordList({
                    tag: Parser.tag,
                    langSys: Parser.pointer(langSysTable)
                })
            })
        })) || [];
    };
    Parser.prototype.parseFeatureList = function () {
        return this.parsePointer(Parser.recordList({
            tag: Parser.tag,
            feature: Parser.pointer({
                featureParams: Parser.offset16,
                lookupListIndexes: Parser.uShortList
            })
        })) || [];
    };
    Parser.prototype.parseLookupList = function (lookupTableParsers) {
        return this.parsePointer(Parser.list(Parser.pointer(function () {
            var lookupType = this.parseUShort();
            check.argument(1 <= lookupType && lookupType <= 9, 'GPOS/GSUB lookup type ' + lookupType + ' unknown.');
            var lookupFlag = this.parseUShort();
            var useMarkFilteringSet = lookupFlag & 16;
            return {
                lookupType: lookupType,
                lookupFlag: lookupFlag,
                subtables: this.parseList(Parser.pointer(lookupTableParsers[lookupType])),
                markFilteringSet: useMarkFilteringSet ? this.parseUShort() : undefined
            };
        }))) || [];
    };
    Parser.prototype.parseFeatureVariationsList = function () {
        return this.parsePointer32(function () {
            var majorVersion = this.parseUShort();
            var minorVersion = this.parseUShort();
            check.argument(majorVersion === 1 && minorVersion < 1, 'GPOS/GSUB feature variations table unknown.');
            var featureVariations = this.parseRecordList32({
                conditionSetOffset: Parser.offset32,
                featureTableSubstitutionOffset: Parser.offset32
            });
            return featureVariations;
        }) || [];
    };
    var parse = {
        getByte: getByte,
        getCard8: getByte,
        getUShort: getUShort,
        getCard16: getUShort,
        getShort: getShort,
        getULong: getULong,
        getFixed: getFixed,
        getTag: getTag,
        getOffset: getOffset,
        getBytes: getBytes,
        bytesToString: bytesToString,
        Parser: Parser
    };
    function parseCmapTableFormat12(cmap, p) {
        p.parseUShort();
        cmap.length = p.parseULong();
        cmap.language = p.parseULong();
        var groupCount;
        cmap.groupCount = groupCount = p.parseULong();
        cmap.glyphIndexMap = {};
        for (var i = 0; i < groupCount; i += 1) {
            var startCharCode = p.parseULong();
            var endCharCode = p.parseULong();
            var startGlyphId = p.parseULong();
            for (var c = startCharCode; c <= endCharCode; c += 1) {
                cmap.glyphIndexMap[c] = startGlyphId;
                startGlyphId++;
            }
        }
    }
    function parseCmapTableFormat4(cmap, p, data, start, offset) {
        cmap.length = p.parseUShort();
        cmap.language = p.parseUShort();
        var segCount;
        cmap.segCount = segCount = p.parseUShort() >> 1;
        p.skip('uShort', 3);
        cmap.glyphIndexMap = {};
        var endCountParser = new parse.Parser(data, start + offset + 14);
        var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
        var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
        var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
        var glyphIndexOffset = start + offset + 16 + segCount * 8;
        for (var i = 0; i < segCount - 1; i += 1) {
            var glyphIndex = void 0;
            var endCount = endCountParser.parseUShort();
            var startCount = startCountParser.parseUShort();
            var idDelta = idDeltaParser.parseShort();
            var idRangeOffset = idRangeOffsetParser.parseUShort();
            for (var c = startCount; c <= endCount; c += 1) {
                if (idRangeOffset !== 0) {
                    glyphIndexOffset = idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2;
                    glyphIndexOffset += idRangeOffset;
                    glyphIndexOffset += (c - startCount) * 2;
                    glyphIndex = parse.getUShort(data, glyphIndexOffset);
                    if (glyphIndex !== 0) {
                        glyphIndex = glyphIndex + idDelta & 65535;
                    }
                } else {
                    glyphIndex = c + idDelta & 65535;
                }
                cmap.glyphIndexMap[c] = glyphIndex;
            }
        }
    }
    function parseCmapTable(data, start) {
        var cmap = {};
        cmap.version = parse.getUShort(data, start);
        check.argument(cmap.version === 0, 'cmap table version should be 0.');
        cmap.numTables = parse.getUShort(data, start + 2);
        var offset = -1;
        for (var i = cmap.numTables - 1; i >= 0; i -= 1) {
            var platformId = parse.getUShort(data, start + 4 + i * 8);
            var encodingId = parse.getUShort(data, start + 4 + i * 8 + 2);
            if (platformId === 3 && (encodingId === 0 || encodingId === 1 || encodingId === 10)) {
                offset = parse.getULong(data, start + 4 + i * 8 + 4);
                break;
            }
        }
        if (offset === -1) {
            throw new Error('No valid cmap sub-tables found.');
        }
        var p = new parse.Parser(data, start + offset);
        cmap.format = p.parseUShort();
        if (cmap.format === 12) {
            parseCmapTableFormat12(cmap, p);
        } else if (cmap.format === 4) {
            parseCmapTableFormat4(cmap, p, data, start, offset);
        } else {
            throw new Error('Only format 4 and 12 cmap tables are supported (found format ' + cmap.format + ').');
        }
        return cmap;
    }
    function addSegment(t, code, glyphIndex) {
        t.segments.push({
            end: code,
            start: code,
            delta: -(code - glyphIndex),
            offset: 0,
            glyphIndex: glyphIndex
        });
    }
    function addTerminatorSegment(t) {
        t.segments.push({
            end: 65535,
            start: 65535,
            delta: 1,
            offset: 0
        });
    }
    function makeCmapTable(glyphs) {
        var isPlan0Only = true;
        var i;
        for (i = glyphs.length - 1; i > 0; i -= 1) {
            var g = glyphs.get(i);
            if (g.unicode > 65535) {
                console.log('Adding CMAP format 12 (needed!)');
                isPlan0Only = false;
                break;
            }
        }
        var cmapTable = [
            {
                name: 'version',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'numTables',
                type: 'USHORT',
                value: isPlan0Only ? 1 : 2
            },
            {
                name: 'platformID',
                type: 'USHORT',
                value: 3
            },
            {
                name: 'encodingID',
                type: 'USHORT',
                value: 1
            },
            {
                name: 'offset',
                type: 'ULONG',
                value: isPlan0Only ? 12 : 12 + 8
            }
        ];
        if (!isPlan0Only) {
            cmapTable = cmapTable.concat([
                {
                    name: 'cmap12PlatformID',
                    type: 'USHORT',
                    value: 3
                },
                {
                    name: 'cmap12EncodingID',
                    type: 'USHORT',
                    value: 10
                },
                {
                    name: 'cmap12Offset',
                    type: 'ULONG',
                    value: 0
                }
            ]);
        }
        cmapTable = cmapTable.concat([
            {
                name: 'format',
                type: 'USHORT',
                value: 4
            },
            {
                name: 'cmap4Length',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'language',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'segCountX2',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'searchRange',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'entrySelector',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'rangeShift',
                type: 'USHORT',
                value: 0
            }
        ]);
        var t = new table.Table('cmap', cmapTable);
        t.segments = [];
        for (i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            for (var j = 0; j < glyph.unicodes.length; j += 1) {
                addSegment(t, glyph.unicodes[j], i);
            }
            t.segments = t.segments.sort(function (a, b) {
                return a.start - b.start;
            });
        }
        addTerminatorSegment(t);
        var segCount = t.segments.length;
        var segCountToRemove = 0;
        var endCounts = [];
        var startCounts = [];
        var idDeltas = [];
        var idRangeOffsets = [];
        var glyphIds = [];
        var cmap12Groups = [];
        for (i = 0; i < segCount; i += 1) {
            var segment = t.segments[i];
            if (segment.end <= 65535 && segment.start <= 65535) {
                endCounts = endCounts.concat({
                    name: 'end_' + i,
                    type: 'USHORT',
                    value: segment.end
                });
                startCounts = startCounts.concat({
                    name: 'start_' + i,
                    type: 'USHORT',
                    value: segment.start
                });
                idDeltas = idDeltas.concat({
                    name: 'idDelta_' + i,
                    type: 'SHORT',
                    value: segment.delta
                });
                idRangeOffsets = idRangeOffsets.concat({
                    name: 'idRangeOffset_' + i,
                    type: 'USHORT',
                    value: segment.offset
                });
                if (segment.glyphId !== undefined) {
                    glyphIds = glyphIds.concat({
                        name: 'glyph_' + i,
                        type: 'USHORT',
                        value: segment.glyphId
                    });
                }
            } else {
                segCountToRemove += 1;
            }
            if (!isPlan0Only && segment.glyphIndex !== undefined) {
                cmap12Groups = cmap12Groups.concat({
                    name: 'cmap12Start_' + i,
                    type: 'ULONG',
                    value: segment.start
                });
                cmap12Groups = cmap12Groups.concat({
                    name: 'cmap12End_' + i,
                    type: 'ULONG',
                    value: segment.end
                });
                cmap12Groups = cmap12Groups.concat({
                    name: 'cmap12Glyph_' + i,
                    type: 'ULONG',
                    value: segment.glyphIndex
                });
            }
        }
        t.segCountX2 = (segCount - segCountToRemove) * 2;
        t.searchRange = Math.pow(2, Math.floor(Math.log(segCount - segCountToRemove) / Math.log(2))) * 2;
        t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
        t.rangeShift = t.segCountX2 - t.searchRange;
        t.fields = t.fields.concat(endCounts);
        t.fields.push({
            name: 'reservedPad',
            type: 'USHORT',
            value: 0
        });
        t.fields = t.fields.concat(startCounts);
        t.fields = t.fields.concat(idDeltas);
        t.fields = t.fields.concat(idRangeOffsets);
        t.fields = t.fields.concat(glyphIds);
        t.cmap4Length = 14 + endCounts.length * 2 + 2 + startCounts.length * 2 + idDeltas.length * 2 + idRangeOffsets.length * 2 + glyphIds.length * 2;
        if (!isPlan0Only) {
            var cmap12Length = 16 + cmap12Groups.length * 4;
            t.cmap12Offset = 12 + 2 * 2 + 4 + t.cmap4Length;
            t.fields = t.fields.concat([
                {
                    name: 'cmap12Format',
                    type: 'USHORT',
                    value: 12
                },
                {
                    name: 'cmap12Reserved',
                    type: 'USHORT',
                    value: 0
                },
                {
                    name: 'cmap12Length',
                    type: 'ULONG',
                    value: cmap12Length
                },
                {
                    name: 'cmap12Language',
                    type: 'ULONG',
                    value: 0
                },
                {
                    name: 'cmap12nGroups',
                    type: 'ULONG',
                    value: cmap12Groups.length / 3
                }
            ]);
            t.fields = t.fields.concat(cmap12Groups);
        }
        return t;
    }
    var cmap = {
        parse: parseCmapTable,
        make: makeCmapTable
    };
    var cffStandardStrings = [
        '.notdef',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quoteright',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'quoteleft',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        'exclamdown',
        'cent',
        'sterling',
        'fraction',
        'yen',
        'florin',
        'section',
        'currency',
        'quotesingle',
        'quotedblleft',
        'guillemotleft',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        'endash',
        'dagger',
        'daggerdbl',
        'periodcentered',
        'paragraph',
        'bullet',
        'quotesinglbase',
        'quotedblbase',
        'quotedblright',
        'guillemotright',
        'ellipsis',
        'perthousand',
        'questiondown',
        'grave',
        'acute',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'dieresis',
        'ring',
        'cedilla',
        'hungarumlaut',
        'ogonek',
        'caron',
        'emdash',
        'AE',
        'ordfeminine',
        'Lslash',
        'Oslash',
        'OE',
        'ordmasculine',
        'ae',
        'dotlessi',
        'lslash',
        'oslash',
        'oe',
        'germandbls',
        'onesuperior',
        'logicalnot',
        'mu',
        'trademark',
        'Eth',
        'onehalf',
        'plusminus',
        'Thorn',
        'onequarter',
        'divide',
        'brokenbar',
        'degree',
        'thorn',
        'threequarters',
        'twosuperior',
        'registered',
        'minus',
        'eth',
        'multiply',
        'threesuperior',
        'copyright',
        'Aacute',
        'Acircumflex',
        'Adieresis',
        'Agrave',
        'Aring',
        'Atilde',
        'Ccedilla',
        'Eacute',
        'Ecircumflex',
        'Edieresis',
        'Egrave',
        'Iacute',
        'Icircumflex',
        'Idieresis',
        'Igrave',
        'Ntilde',
        'Oacute',
        'Ocircumflex',
        'Odieresis',
        'Ograve',
        'Otilde',
        'Scaron',
        'Uacute',
        'Ucircumflex',
        'Udieresis',
        'Ugrave',
        'Yacute',
        'Ydieresis',
        'Zcaron',
        'aacute',
        'acircumflex',
        'adieresis',
        'agrave',
        'aring',
        'atilde',
        'ccedilla',
        'eacute',
        'ecircumflex',
        'edieresis',
        'egrave',
        'iacute',
        'icircumflex',
        'idieresis',
        'igrave',
        'ntilde',
        'oacute',
        'ocircumflex',
        'odieresis',
        'ograve',
        'otilde',
        'scaron',
        'uacute',
        'ucircumflex',
        'udieresis',
        'ugrave',
        'yacute',
        'ydieresis',
        'zcaron',
        'exclamsmall',
        'Hungarumlautsmall',
        'dollaroldstyle',
        'dollarsuperior',
        'ampersandsmall',
        'Acutesmall',
        'parenleftsuperior',
        'parenrightsuperior',
        '266 ff',
        'onedotenleader',
        'zerooldstyle',
        'oneoldstyle',
        'twooldstyle',
        'threeoldstyle',
        'fouroldstyle',
        'fiveoldstyle',
        'sixoldstyle',
        'sevenoldstyle',
        'eightoldstyle',
        'nineoldstyle',
        'commasuperior',
        'threequartersemdash',
        'periodsuperior',
        'questionsmall',
        'asuperior',
        'bsuperior',
        'centsuperior',
        'dsuperior',
        'esuperior',
        'isuperior',
        'lsuperior',
        'msuperior',
        'nsuperior',
        'osuperior',
        'rsuperior',
        'ssuperior',
        'tsuperior',
        'ff',
        'ffi',
        'ffl',
        'parenleftinferior',
        'parenrightinferior',
        'Circumflexsmall',
        'hyphensuperior',
        'Gravesmall',
        'Asmall',
        'Bsmall',
        'Csmall',
        'Dsmall',
        'Esmall',
        'Fsmall',
        'Gsmall',
        'Hsmall',
        'Ismall',
        'Jsmall',
        'Ksmall',
        'Lsmall',
        'Msmall',
        'Nsmall',
        'Osmall',
        'Psmall',
        'Qsmall',
        'Rsmall',
        'Ssmall',
        'Tsmall',
        'Usmall',
        'Vsmall',
        'Wsmall',
        'Xsmall',
        'Ysmall',
        'Zsmall',
        'colonmonetary',
        'onefitted',
        'rupiah',
        'Tildesmall',
        'exclamdownsmall',
        'centoldstyle',
        'Lslashsmall',
        'Scaronsmall',
        'Zcaronsmall',
        'Dieresissmall',
        'Brevesmall',
        'Caronsmall',
        'Dotaccentsmall',
        'Macronsmall',
        'figuredash',
        'hypheninferior',
        'Ogoneksmall',
        'Ringsmall',
        'Cedillasmall',
        'questiondownsmall',
        'oneeighth',
        'threeeighths',
        'fiveeighths',
        'seveneighths',
        'onethird',
        'twothirds',
        'zerosuperior',
        'foursuperior',
        'fivesuperior',
        'sixsuperior',
        'sevensuperior',
        'eightsuperior',
        'ninesuperior',
        'zeroinferior',
        'oneinferior',
        'twoinferior',
        'threeinferior',
        'fourinferior',
        'fiveinferior',
        'sixinferior',
        'seveninferior',
        'eightinferior',
        'nineinferior',
        'centinferior',
        'dollarinferior',
        'periodinferior',
        'commainferior',
        'Agravesmall',
        'Aacutesmall',
        'Acircumflexsmall',
        'Atildesmall',
        'Adieresissmall',
        'Aringsmall',
        'AEsmall',
        'Ccedillasmall',
        'Egravesmall',
        'Eacutesmall',
        'Ecircumflexsmall',
        'Edieresissmall',
        'Igravesmall',
        'Iacutesmall',
        'Icircumflexsmall',
        'Idieresissmall',
        'Ethsmall',
        'Ntildesmall',
        'Ogravesmall',
        'Oacutesmall',
        'Ocircumflexsmall',
        'Otildesmall',
        'Odieresissmall',
        'OEsmall',
        'Oslashsmall',
        'Ugravesmall',
        'Uacutesmall',
        'Ucircumflexsmall',
        'Udieresissmall',
        'Yacutesmall',
        'Thornsmall',
        'Ydieresissmall',
        '001.000',
        '001.001',
        '001.002',
        '001.003',
        'Black',
        'Bold',
        'Book',
        'Light',
        'Medium',
        'Regular',
        'Roman',
        'Semibold'
    ];
    var cffStandardEncoding = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quoteright',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'quoteleft',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'exclamdown',
        'cent',
        'sterling',
        'fraction',
        'yen',
        'florin',
        'section',
        'currency',
        'quotesingle',
        'quotedblleft',
        'guillemotleft',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        '',
        'endash',
        'dagger',
        'daggerdbl',
        'periodcentered',
        '',
        'paragraph',
        'bullet',
        'quotesinglbase',
        'quotedblbase',
        'quotedblright',
        'guillemotright',
        'ellipsis',
        'perthousand',
        '',
        'questiondown',
        '',
        'grave',
        'acute',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'dieresis',
        '',
        'ring',
        'cedilla',
        '',
        'hungarumlaut',
        'ogonek',
        'caron',
        'emdash',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'AE',
        '',
        'ordfeminine',
        '',
        '',
        '',
        '',
        'Lslash',
        'Oslash',
        'OE',
        'ordmasculine',
        '',
        '',
        '',
        '',
        '',
        'ae',
        '',
        '',
        '',
        'dotlessi',
        '',
        '',
        'lslash',
        'oslash',
        'oe',
        'germandbls'
    ];
    var cffExpertEncoding = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'space',
        'exclamsmall',
        'Hungarumlautsmall',
        '',
        'dollaroldstyle',
        'dollarsuperior',
        'ampersandsmall',
        'Acutesmall',
        'parenleftsuperior',
        'parenrightsuperior',
        'twodotenleader',
        'onedotenleader',
        'comma',
        'hyphen',
        'period',
        'fraction',
        'zerooldstyle',
        'oneoldstyle',
        'twooldstyle',
        'threeoldstyle',
        'fouroldstyle',
        'fiveoldstyle',
        'sixoldstyle',
        'sevenoldstyle',
        'eightoldstyle',
        'nineoldstyle',
        'colon',
        'semicolon',
        'commasuperior',
        'threequartersemdash',
        'periodsuperior',
        'questionsmall',
        '',
        'asuperior',
        'bsuperior',
        'centsuperior',
        'dsuperior',
        'esuperior',
        '',
        '',
        'isuperior',
        '',
        '',
        'lsuperior',
        'msuperior',
        'nsuperior',
        'osuperior',
        '',
        '',
        'rsuperior',
        'ssuperior',
        'tsuperior',
        '',
        'ff',
        'fi',
        'fl',
        'ffi',
        'ffl',
        'parenleftinferior',
        '',
        'parenrightinferior',
        'Circumflexsmall',
        'hyphensuperior',
        'Gravesmall',
        'Asmall',
        'Bsmall',
        'Csmall',
        'Dsmall',
        'Esmall',
        'Fsmall',
        'Gsmall',
        'Hsmall',
        'Ismall',
        'Jsmall',
        'Ksmall',
        'Lsmall',
        'Msmall',
        'Nsmall',
        'Osmall',
        'Psmall',
        'Qsmall',
        'Rsmall',
        'Ssmall',
        'Tsmall',
        'Usmall',
        'Vsmall',
        'Wsmall',
        'Xsmall',
        'Ysmall',
        'Zsmall',
        'colonmonetary',
        'onefitted',
        'rupiah',
        'Tildesmall',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'exclamdownsmall',
        'centoldstyle',
        'Lslashsmall',
        '',
        '',
        'Scaronsmall',
        'Zcaronsmall',
        'Dieresissmall',
        'Brevesmall',
        'Caronsmall',
        '',
        'Dotaccentsmall',
        '',
        '',
        'Macronsmall',
        '',
        '',
        'figuredash',
        'hypheninferior',
        '',
        '',
        'Ogoneksmall',
        'Ringsmall',
        'Cedillasmall',
        '',
        '',
        '',
        'onequarter',
        'onehalf',
        'threequarters',
        'questiondownsmall',
        'oneeighth',
        'threeeighths',
        'fiveeighths',
        'seveneighths',
        'onethird',
        'twothirds',
        '',
        '',
        'zerosuperior',
        'onesuperior',
        'twosuperior',
        'threesuperior',
        'foursuperior',
        'fivesuperior',
        'sixsuperior',
        'sevensuperior',
        'eightsuperior',
        'ninesuperior',
        'zeroinferior',
        'oneinferior',
        'twoinferior',
        'threeinferior',
        'fourinferior',
        'fiveinferior',
        'sixinferior',
        'seveninferior',
        'eightinferior',
        'nineinferior',
        'centinferior',
        'dollarinferior',
        'periodinferior',
        'commainferior',
        'Agravesmall',
        'Aacutesmall',
        'Acircumflexsmall',
        'Atildesmall',
        'Adieresissmall',
        'Aringsmall',
        'AEsmall',
        'Ccedillasmall',
        'Egravesmall',
        'Eacutesmall',
        'Ecircumflexsmall',
        'Edieresissmall',
        'Igravesmall',
        'Iacutesmall',
        'Icircumflexsmall',
        'Idieresissmall',
        'Ethsmall',
        'Ntildesmall',
        'Ogravesmall',
        'Oacutesmall',
        'Ocircumflexsmall',
        'Otildesmall',
        'Odieresissmall',
        'OEsmall',
        'Oslashsmall',
        'Ugravesmall',
        'Uacutesmall',
        'Ucircumflexsmall',
        'Udieresissmall',
        'Yacutesmall',
        'Thornsmall',
        'Ydieresissmall'
    ];
    var standardNames = [
        '.notdef',
        '.null',
        'nonmarkingreturn',
        'space',
        'exclam',
        'quotedbl',
        'numbersign',
        'dollar',
        'percent',
        'ampersand',
        'quotesingle',
        'parenleft',
        'parenright',
        'asterisk',
        'plus',
        'comma',
        'hyphen',
        'period',
        'slash',
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'colon',
        'semicolon',
        'less',
        'equal',
        'greater',
        'question',
        'at',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'bracketleft',
        'backslash',
        'bracketright',
        'asciicircum',
        'underscore',
        'grave',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'braceleft',
        'bar',
        'braceright',
        'asciitilde',
        'Adieresis',
        'Aring',
        'Ccedilla',
        'Eacute',
        'Ntilde',
        'Odieresis',
        'Udieresis',
        'aacute',
        'agrave',
        'acircumflex',
        'adieresis',
        'atilde',
        'aring',
        'ccedilla',
        'eacute',
        'egrave',
        'ecircumflex',
        'edieresis',
        'iacute',
        'igrave',
        'icircumflex',
        'idieresis',
        'ntilde',
        'oacute',
        'ograve',
        'ocircumflex',
        'odieresis',
        'otilde',
        'uacute',
        'ugrave',
        'ucircumflex',
        'udieresis',
        'dagger',
        'degree',
        'cent',
        'sterling',
        'section',
        'bullet',
        'paragraph',
        'germandbls',
        'registered',
        'copyright',
        'trademark',
        'acute',
        'dieresis',
        'notequal',
        'AE',
        'Oslash',
        'infinity',
        'plusminus',
        'lessequal',
        'greaterequal',
        'yen',
        'mu',
        'partialdiff',
        'summation',
        'product',
        'pi',
        'integral',
        'ordfeminine',
        'ordmasculine',
        'Omega',
        'ae',
        'oslash',
        'questiondown',
        'exclamdown',
        'logicalnot',
        'radical',
        'florin',
        'approxequal',
        'Delta',
        'guillemotleft',
        'guillemotright',
        'ellipsis',
        'nonbreakingspace',
        'Agrave',
        'Atilde',
        'Otilde',
        'OE',
        'oe',
        'endash',
        'emdash',
        'quotedblleft',
        'quotedblright',
        'quoteleft',
        'quoteright',
        'divide',
        'lozenge',
        'ydieresis',
        'Ydieresis',
        'fraction',
        'currency',
        'guilsinglleft',
        'guilsinglright',
        'fi',
        'fl',
        'daggerdbl',
        'periodcentered',
        'quotesinglbase',
        'quotedblbase',
        'perthousand',
        'Acircumflex',
        'Ecircumflex',
        'Aacute',
        'Edieresis',
        'Egrave',
        'Iacute',
        'Icircumflex',
        'Idieresis',
        'Igrave',
        'Oacute',
        'Ocircumflex',
        'apple',
        'Ograve',
        'Uacute',
        'Ucircumflex',
        'Ugrave',
        'dotlessi',
        'circumflex',
        'tilde',
        'macron',
        'breve',
        'dotaccent',
        'ring',
        'cedilla',
        'hungarumlaut',
        'ogonek',
        'caron',
        'Lslash',
        'lslash',
        'Scaron',
        'scaron',
        'Zcaron',
        'zcaron',
        'brokenbar',
        'Eth',
        'eth',
        'Yacute',
        'yacute',
        'Thorn',
        'thorn',
        'minus',
        'multiply',
        'onesuperior',
        'twosuperior',
        'threesuperior',
        'onehalf',
        'onequarter',
        'threequarters',
        'franc',
        'Gbreve',
        'gbreve',
        'Idotaccent',
        'Scedilla',
        'scedilla',
        'Cacute',
        'cacute',
        'Ccaron',
        'ccaron',
        'dcroat'
    ];
    function DefaultEncoding(font) {
        this.font = font;
    }
    DefaultEncoding.prototype.charToGlyphIndex = function (c) {
        var code = c.codePointAt(0);
        var glyphs = this.font.glyphs;
        if (glyphs) {
            for (var i = 0; i < glyphs.length; i += 1) {
                var glyph = glyphs.get(i);
                for (var j = 0; j < glyph.unicodes.length; j += 1) {
                    if (glyph.unicodes[j] === code) {
                        return i;
                    }
                }
            }
        }
        return null;
    };
    function CmapEncoding(cmap) {
        this.cmap = cmap;
    }
    CmapEncoding.prototype.charToGlyphIndex = function (c) {
        return this.cmap.glyphIndexMap[c.codePointAt(0)] || 0;
    };
    function CffEncoding(encoding, charset) {
        this.encoding = encoding;
        this.charset = charset;
    }
    CffEncoding.prototype.charToGlyphIndex = function (s) {
        var code = s.codePointAt(0);
        var charName = this.encoding[code];
        return this.charset.indexOf(charName);
    };
    function GlyphNames(post) {
        var this$1 = this;
        switch (post.version) {
        case 1:
            this.names = standardNames.slice();
            break;
        case 2:
            this.names = new Array(post.numberOfGlyphs);
            for (var i = 0; i < post.numberOfGlyphs; i++) {
                if (post.glyphNameIndex[i] < standardNames.length) {
                    this$1.names[i] = standardNames[post.glyphNameIndex[i]];
                } else {
                    this$1.names[i] = post.names[post.glyphNameIndex[i] - standardNames.length];
                }
            }
            break;
        case 2.5:
            this.names = new Array(post.numberOfGlyphs);
            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                this$1.names[i$1] = standardNames[i$1 + post.glyphNameIndex[i$1]];
            }
            break;
        case 3:
            this.names = [];
            break;
        default:
            this.names = [];
            break;
        }
    }
    GlyphNames.prototype.nameToGlyphIndex = function (name) {
        return this.names.indexOf(name);
    };
    GlyphNames.prototype.glyphIndexToName = function (gid) {
        return this.names[gid];
    };
    function addGlyphNames(font) {
        var glyph;
        var glyphIndexMap = font.tables.cmap.glyphIndexMap;
        var charCodes = Object.keys(glyphIndexMap);
        for (var i = 0; i < charCodes.length; i += 1) {
            var c = charCodes[i];
            var glyphIndex = glyphIndexMap[c];
            glyph = font.glyphs.get(glyphIndex);
            glyph.addUnicode(parseInt(c));
        }
        for (var i$1 = 0; i$1 < font.glyphs.length; i$1 += 1) {
            glyph = font.glyphs.get(i$1);
            if (font.cffEncoding) {
                if (font.isCIDFont) {
                    glyph.name = 'gid' + i$1;
                } else {
                    glyph.name = font.cffEncoding.charset[i$1];
                }
            } else if (font.glyphNames.names) {
                glyph.name = font.glyphNames.glyphIndexToName(i$1);
            }
        }
    }
    function line(ctx, x1, y1, x2, y2) {
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
    }
    var draw = { line: line };
    function getPathDefinition(glyph, path) {
        var _path = path || new Path();
        return {
            configurable: true,
            get: function () {
                if (typeof _path === 'function') {
                    _path = _path();
                }
                return _path;
            },
            set: function (p) {
                _path = p;
            }
        };
    }
    function Glyph(options) {
        this.bindConstructorValues(options);
    }
    Glyph.prototype.bindConstructorValues = function (options) {
        this.index = options.index || 0;
        this.name = options.name || null;
        this.unicode = options.unicode || undefined;
        this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];
        if (options.xMin) {
            this.xMin = options.xMin;
        }
        if (options.yMin) {
            this.yMin = options.yMin;
        }
        if (options.xMax) {
            this.xMax = options.xMax;
        }
        if (options.yMax) {
            this.yMax = options.yMax;
        }
        if (options.advanceWidth) {
            this.advanceWidth = options.advanceWidth;
        }
        Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
    };
    Glyph.prototype.addUnicode = function (unicode) {
        if (this.unicodes.length === 0) {
            this.unicode = unicode;
        }
        this.unicodes.push(unicode);
    };
    Glyph.prototype.getBoundingBox = function () {
        return this.path.getBoundingBox();
    };
    Glyph.prototype.getPath = function (x, y, fontSize, options, font) {
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 72;
        var commands;
        var hPoints;
        if (!options) {
            options = {};
        }
        var xScale = options.xScale;
        var yScale = options.yScale;
        if (options.hinting && font && font.hinting) {
            hPoints = this.path && font.hinting.exec(this, fontSize);
        }
        if (hPoints) {
            commands = font.hinting.getCommands(hPoints);
            x = Math.round(x);
            y = Math.round(y);
            xScale = yScale = 1;
        } else {
            commands = this.path.commands;
            var scale = 1 / this.path.unitsPerEm * fontSize;
            if (xScale === undefined) {
                xScale = scale;
            }
            if (yScale === undefined) {
                yScale = scale;
            }
        }
        var p = new Path();
        for (var i = 0; i < commands.length; i += 1) {
            var cmd = commands[i];
            if (cmd.type === 'M') {
                p.moveTo(x + cmd.x * xScale, y + -cmd.y * yScale);
            } else if (cmd.type === 'L') {
                p.lineTo(x + cmd.x * xScale, y + -cmd.y * yScale);
            } else if (cmd.type === 'Q') {
                p.quadraticCurveTo(x + cmd.x1 * xScale, y + -cmd.y1 * yScale, x + cmd.x * xScale, y + -cmd.y * yScale);
            } else if (cmd.type === 'C') {
                p.curveTo(x + cmd.x1 * xScale, y + -cmd.y1 * yScale, x + cmd.x2 * xScale, y + -cmd.y2 * yScale, x + cmd.x * xScale, y + -cmd.y * yScale);
            } else if (cmd.type === 'Z') {
                p.closePath();
            }
        }
        return p;
    };
    Glyph.prototype.getContours = function () {
        var this$1 = this;
        if (this.points === undefined) {
            return [];
        }
        var contours = [];
        var currentContour = [];
        for (var i = 0; i < this.points.length; i += 1) {
            var pt = this$1.points[i];
            currentContour.push(pt);
            if (pt.lastPointOfContour) {
                contours.push(currentContour);
                currentContour = [];
            }
        }
        check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
        return contours;
    };
    Glyph.prototype.getMetrics = function () {
        var commands = this.path.commands;
        var xCoords = [];
        var yCoords = [];
        for (var i = 0; i < commands.length; i += 1) {
            var cmd = commands[i];
            if (cmd.type !== 'Z') {
                xCoords.push(cmd.x);
                yCoords.push(cmd.y);
            }
            if (cmd.type === 'Q' || cmd.type === 'C') {
                xCoords.push(cmd.x1);
                yCoords.push(cmd.y1);
            }
            if (cmd.type === 'C') {
                xCoords.push(cmd.x2);
                yCoords.push(cmd.y2);
            }
        }
        var metrics = {
            xMin: Math.min.apply(null, xCoords),
            yMin: Math.min.apply(null, yCoords),
            xMax: Math.max.apply(null, xCoords),
            yMax: Math.max.apply(null, yCoords),
            leftSideBearing: this.leftSideBearing
        };
        if (!isFinite(metrics.xMin)) {
            metrics.xMin = 0;
        }
        if (!isFinite(metrics.xMax)) {
            metrics.xMax = this.advanceWidth;
        }
        if (!isFinite(metrics.yMin)) {
            metrics.yMin = 0;
        }
        if (!isFinite(metrics.yMax)) {
            metrics.yMax = 0;
        }
        metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
        return metrics;
    };
    Glyph.prototype.draw = function (ctx, x, y, fontSize, options) {
        this.getPath(x, y, fontSize, options).draw(ctx);
    };
    Glyph.prototype.drawPoints = function (ctx, x, y, fontSize) {
        function drawCircles(l, x, y, scale) {
            var PI_SQ = Math.PI * 2;
            ctx.beginPath();
            for (var j = 0; j < l.length; j += 1) {
                ctx.moveTo(x + l[j].x * scale, y + l[j].y * scale);
                ctx.arc(x + l[j].x * scale, y + l[j].y * scale, 2, 0, PI_SQ, false);
            }
            ctx.closePath();
            ctx.fill();
        }
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 24;
        var scale = 1 / this.path.unitsPerEm * fontSize;
        var blueCircles = [];
        var redCircles = [];
        var path = this.path;
        for (var i = 0; i < path.commands.length; i += 1) {
            var cmd = path.commands[i];
            if (cmd.x !== undefined) {
                blueCircles.push({
                    x: cmd.x,
                    y: -cmd.y
                });
            }
            if (cmd.x1 !== undefined) {
                redCircles.push({
                    x: cmd.x1,
                    y: -cmd.y1
                });
            }
            if (cmd.x2 !== undefined) {
                redCircles.push({
                    x: cmd.x2,
                    y: -cmd.y2
                });
            }
        }
        ctx.fillStyle = 'blue';
        drawCircles(blueCircles, x, y, scale);
        ctx.fillStyle = 'red';
        drawCircles(redCircles, x, y, scale);
    };
    Glyph.prototype.drawMetrics = function (ctx, x, y, fontSize) {
        var scale;
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 24;
        scale = 1 / this.path.unitsPerEm * fontSize;
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'black';
        draw.line(ctx, x, -10000, x, 10000);
        draw.line(ctx, -10000, y, 10000, y);
        var xMin = this.xMin || 0;
        var yMin = this.yMin || 0;
        var xMax = this.xMax || 0;
        var yMax = this.yMax || 0;
        var advanceWidth = this.advanceWidth || 0;
        ctx.strokeStyle = 'blue';
        draw.line(ctx, x + xMin * scale, -10000, x + xMin * scale, 10000);
        draw.line(ctx, x + xMax * scale, -10000, x + xMax * scale, 10000);
        draw.line(ctx, -10000, y + -yMin * scale, 10000, y + -yMin * scale);
        draw.line(ctx, -10000, y + -yMax * scale, 10000, y + -yMax * scale);
        ctx.strokeStyle = 'green';
        draw.line(ctx, x + advanceWidth * scale, -10000, x + advanceWidth * scale, 10000);
    };
    function defineDependentProperty(glyph, externalName, internalName) {
        Object.defineProperty(glyph, externalName, {
            get: function () {
                glyph.path;
                return glyph[internalName];
            },
            set: function (newValue) {
                glyph[internalName] = newValue;
            },
            enumerable: true,
            configurable: true
        });
    }
    function GlyphSet(font, glyphs) {
        var this$1 = this;
        this.font = font;
        this.glyphs = {};
        if (Array.isArray(glyphs)) {
            for (var i = 0; i < glyphs.length; i++) {
                this$1.glyphs[i] = glyphs[i];
            }
        }
        this.length = glyphs && glyphs.length || 0;
    }
    GlyphSet.prototype.get = function (index) {
        if (typeof this.glyphs[index] === 'function') {
            this.glyphs[index] = this.glyphs[index]();
        }
        return this.glyphs[index];
    };
    GlyphSet.prototype.push = function (index, loader) {
        this.glyphs[index] = loader;
        this.length++;
    };
    function glyphLoader(font, index) {
        return new Glyph({
            index: index,
            font: font
        });
    }
    function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
        return function () {
            var glyph = new Glyph({
                index: index,
                font: font
            });
            glyph.path = function () {
                parseGlyph(glyph, data, position);
                var path = buildPath(font.glyphs, glyph);
                path.unitsPerEm = font.unitsPerEm;
                return path;
            };
            defineDependentProperty(glyph, 'xMin', '_xMin');
            defineDependentProperty(glyph, 'xMax', '_xMax');
            defineDependentProperty(glyph, 'yMin', '_yMin');
            defineDependentProperty(glyph, 'yMax', '_yMax');
            return glyph;
        };
    }
    function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
        return function () {
            var glyph = new Glyph({
                index: index,
                font: font
            });
            glyph.path = function () {
                var path = parseCFFCharstring(font, glyph, charstring);
                path.unitsPerEm = font.unitsPerEm;
                return path;
            };
            return glyph;
        };
    }
    var glyphset = {
        GlyphSet: GlyphSet,
        glyphLoader: glyphLoader,
        ttfGlyphLoader: ttfGlyphLoader,
        cffGlyphLoader: cffGlyphLoader
    };
    function equals(a, b) {
        if (a === b) {
            return true;
        } else if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i += 1) {
                if (!equals(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        } else {
            return false;
        }
    }
    function calcCFFSubroutineBias(subrs) {
        var bias;
        if (subrs.length < 1240) {
            bias = 107;
        } else if (subrs.length < 33900) {
            bias = 1131;
        } else {
            bias = 32768;
        }
        return bias;
    }
    function parseCFFIndex(data, start, conversionFn) {
        var offsets = [];
        var objects = [];
        var count = parse.getCard16(data, start);
        var objectOffset;
        var endOffset;
        if (count !== 0) {
            var offsetSize = parse.getByte(data, start + 2);
            objectOffset = start + (count + 1) * offsetSize + 2;
            var pos = start + 3;
            for (var i = 0; i < count + 1; i += 1) {
                offsets.push(parse.getOffset(data, pos, offsetSize));
                pos += offsetSize;
            }
            endOffset = objectOffset + offsets[count];
        } else {
            endOffset = start + 2;
        }
        for (var i$1 = 0; i$1 < offsets.length - 1; i$1 += 1) {
            var value = parse.getBytes(data, objectOffset + offsets[i$1], objectOffset + offsets[i$1 + 1]);
            if (conversionFn) {
                value = conversionFn(value);
            }
            objects.push(value);
        }
        return {
            objects: objects,
            startOffset: start,
            endOffset: endOffset
        };
    }
    function parseFloatOperand(parser) {
        var s = '';
        var eof = 15;
        var lookup = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '.',
            'E',
            'E-',
            null,
            '-'
        ];
        while (true) {
            var b = parser.parseByte();
            var n1 = b >> 4;
            var n2 = b & 15;
            if (n1 === eof) {
                break;
            }
            s += lookup[n1];
            if (n2 === eof) {
                break;
            }
            s += lookup[n2];
        }
        return parseFloat(s);
    }
    function parseOperand(parser, b0) {
        var b1;
        var b2;
        var b3;
        var b4;
        if (b0 === 28) {
            b1 = parser.parseByte();
            b2 = parser.parseByte();
            return b1 << 8 | b2;
        }
        if (b0 === 29) {
            b1 = parser.parseByte();
            b2 = parser.parseByte();
            b3 = parser.parseByte();
            b4 = parser.parseByte();
            return b1 << 24 | b2 << 16 | b3 << 8 | b4;
        }
        if (b0 === 30) {
            return parseFloatOperand(parser);
        }
        if (b0 >= 32 && b0 <= 246) {
            return b0 - 139;
        }
        if (b0 >= 247 && b0 <= 250) {
            b1 = parser.parseByte();
            return (b0 - 247) * 256 + b1 + 108;
        }
        if (b0 >= 251 && b0 <= 254) {
            b1 = parser.parseByte();
            return -(b0 - 251) * 256 - b1 - 108;
        }
        throw new Error('Invalid b0 ' + b0);
    }
    function entriesToObject(entries) {
        var o = {};
        for (var i = 0; i < entries.length; i += 1) {
            var key = entries[i][0];
            var values = entries[i][1];
            var value = void 0;
            if (values.length === 1) {
                value = values[0];
            } else {
                value = values;
            }
            if (o.hasOwnProperty(key) && !isNaN(o[key])) {
                throw new Error('Object ' + o + ' already has key ' + key);
            }
            o[key] = value;
        }
        return o;
    }
    function parseCFFDict(data, start, size) {
        start = start !== undefined ? start : 0;
        var parser = new parse.Parser(data, start);
        var entries = [];
        var operands = [];
        size = size !== undefined ? size : data.length;
        while (parser.relativeOffset < size) {
            var op = parser.parseByte();
            if (op <= 21) {
                if (op === 12) {
                    op = 1200 + parser.parseByte();
                }
                entries.push([
                    op,
                    operands
                ]);
                operands = [];
            } else {
                operands.push(parseOperand(parser, op));
            }
        }
        return entriesToObject(entries);
    }
    function getCFFString(strings, index) {
        if (index <= 390) {
            index = cffStandardStrings[index];
        } else {
            index = strings[index - 391];
        }
        return index;
    }
    function interpretDict(dict, meta, strings) {
        var newDict = {};
        var value;
        for (var i = 0; i < meta.length; i += 1) {
            var m = meta[i];
            if (Array.isArray(m.type)) {
                var values = [];
                values.length = m.type.length;
                for (var j = 0; j < m.type.length; j++) {
                    value = dict[m.op] !== undefined ? dict[m.op][j] : undefined;
                    if (value === undefined) {
                        value = m.value !== undefined && m.value[j] !== undefined ? m.value[j] : null;
                    }
                    if (m.type[j] === 'SID') {
                        value = getCFFString(strings, value);
                    }
                    values[j] = value;
                }
                newDict[m.name] = values;
            } else {
                value = dict[m.op];
                if (value === undefined) {
                    value = m.value !== undefined ? m.value : null;
                }
                if (m.type === 'SID') {
                    value = getCFFString(strings, value);
                }
                newDict[m.name] = value;
            }
        }
        return newDict;
    }
    function parseCFFHeader(data, start) {
        var header = {};
        header.formatMajor = parse.getCard8(data, start);
        header.formatMinor = parse.getCard8(data, start + 1);
        header.size = parse.getCard8(data, start + 2);
        header.offsetSize = parse.getCard8(data, start + 3);
        header.startOffset = start;
        header.endOffset = start + 4;
        return header;
    }
    var TOP_DICT_META = [
        {
            name: 'version',
            op: 0,
            type: 'SID'
        },
        {
            name: 'notice',
            op: 1,
            type: 'SID'
        },
        {
            name: 'copyright',
            op: 1200,
            type: 'SID'
        },
        {
            name: 'fullName',
            op: 2,
            type: 'SID'
        },
        {
            name: 'familyName',
            op: 3,
            type: 'SID'
        },
        {
            name: 'weight',
            op: 4,
            type: 'SID'
        },
        {
            name: 'isFixedPitch',
            op: 1201,
            type: 'number',
            value: 0
        },
        {
            name: 'italicAngle',
            op: 1202,
            type: 'number',
            value: 0
        },
        {
            name: 'underlinePosition',
            op: 1203,
            type: 'number',
            value: -100
        },
        {
            name: 'underlineThickness',
            op: 1204,
            type: 'number',
            value: 50
        },
        {
            name: 'paintType',
            op: 1205,
            type: 'number',
            value: 0
        },
        {
            name: 'charstringType',
            op: 1206,
            type: 'number',
            value: 2
        },
        {
            name: 'fontMatrix',
            op: 1207,
            type: [
                'real',
                'real',
                'real',
                'real',
                'real',
                'real'
            ],
            value: [
                0.001,
                0,
                0,
                0.001,
                0,
                0
            ]
        },
        {
            name: 'uniqueId',
            op: 13,
            type: 'number'
        },
        {
            name: 'fontBBox',
            op: 5,
            type: [
                'number',
                'number',
                'number',
                'number'
            ],
            value: [
                0,
                0,
                0,
                0
            ]
        },
        {
            name: 'strokeWidth',
            op: 1208,
            type: 'number',
            value: 0
        },
        {
            name: 'xuid',
            op: 14,
            type: [],
            value: null
        },
        {
            name: 'charset',
            op: 15,
            type: 'offset',
            value: 0
        },
        {
            name: 'encoding',
            op: 16,
            type: 'offset',
            value: 0
        },
        {
            name: 'charStrings',
            op: 17,
            type: 'offset',
            value: 0
        },
        {
            name: 'private',
            op: 18,
            type: [
                'number',
                'offset'
            ],
            value: [
                0,
                0
            ]
        },
        {
            name: 'ros',
            op: 1230,
            type: [
                'SID',
                'SID',
                'number'
            ]
        },
        {
            name: 'cidFontVersion',
            op: 1231,
            type: 'number',
            value: 0
        },
        {
            name: 'cidFontRevision',
            op: 1232,
            type: 'number',
            value: 0
        },
        {
            name: 'cidFontType',
            op: 1233,
            type: 'number',
            value: 0
        },
        {
            name: 'cidCount',
            op: 1234,
            type: 'number',
            value: 8720
        },
        {
            name: 'uidBase',
            op: 1235,
            type: 'number'
        },
        {
            name: 'fdArray',
            op: 1236,
            type: 'offset'
        },
        {
            name: 'fdSelect',
            op: 1237,
            type: 'offset'
        },
        {
            name: 'fontName',
            op: 1238,
            type: 'SID'
        }
    ];
    var PRIVATE_DICT_META = [
        {
            name: 'subrs',
            op: 19,
            type: 'offset',
            value: 0
        },
        {
            name: 'defaultWidthX',
            op: 20,
            type: 'number',
            value: 0
        },
        {
            name: 'nominalWidthX',
            op: 21,
            type: 'number',
            value: 0
        }
    ];
    function parseCFFTopDict(data, strings) {
        var dict = parseCFFDict(data, 0, data.byteLength);
        return interpretDict(dict, TOP_DICT_META, strings);
    }
    function parseCFFPrivateDict(data, start, size, strings) {
        var dict = parseCFFDict(data, start, size);
        return interpretDict(dict, PRIVATE_DICT_META, strings);
    }
    function gatherCFFTopDicts(data, start, cffIndex, strings) {
        var topDictArray = [];
        for (var iTopDict = 0; iTopDict < cffIndex.length; iTopDict += 1) {
            var topDictData = new DataView(new Uint8Array(cffIndex[iTopDict]).buffer);
            var topDict = parseCFFTopDict(topDictData, strings);
            topDict._subrs = [];
            topDict._subrsBias = 0;
            var privateSize = topDict.private[0];
            var privateOffset = topDict.private[1];
            if (privateSize !== 0 && privateOffset !== 0) {
                var privateDict = parseCFFPrivateDict(data, privateOffset + start, privateSize, strings);
                topDict._defaultWidthX = privateDict.defaultWidthX;
                topDict._nominalWidthX = privateDict.nominalWidthX;
                if (privateDict.subrs !== 0) {
                    var subrOffset = privateOffset + privateDict.subrs;
                    var subrIndex = parseCFFIndex(data, subrOffset + start);
                    topDict._subrs = subrIndex.objects;
                    topDict._subrsBias = calcCFFSubroutineBias(topDict._subrs);
                }
                topDict._privateDict = privateDict;
            }
            topDictArray.push(topDict);
        }
        return topDictArray;
    }
    function parseCFFCharset(data, start, nGlyphs, strings) {
        var sid;
        var count;
        var parser = new parse.Parser(data, start);
        nGlyphs -= 1;
        var charset = ['.notdef'];
        var format = parser.parseCard8();
        if (format === 0) {
            for (var i = 0; i < nGlyphs; i += 1) {
                sid = parser.parseSID();
                charset.push(getCFFString(strings, sid));
            }
        } else if (format === 1) {
            while (charset.length <= nGlyphs) {
                sid = parser.parseSID();
                count = parser.parseCard8();
                for (var i$1 = 0; i$1 <= count; i$1 += 1) {
                    charset.push(getCFFString(strings, sid));
                    sid += 1;
                }
            }
        } else if (format === 2) {
            while (charset.length <= nGlyphs) {
                sid = parser.parseSID();
                count = parser.parseCard16();
                for (var i$2 = 0; i$2 <= count; i$2 += 1) {
                    charset.push(getCFFString(strings, sid));
                    sid += 1;
                }
            }
        } else {
            throw new Error('Unknown charset format ' + format);
        }
        return charset;
    }
    function parseCFFEncoding(data, start, charset) {
        var code;
        var enc = {};
        var parser = new parse.Parser(data, start);
        var format = parser.parseCard8();
        if (format === 0) {
            var nCodes = parser.parseCard8();
            for (var i = 0; i < nCodes; i += 1) {
                code = parser.parseCard8();
                enc[code] = i;
            }
        } else if (format === 1) {
            var nRanges = parser.parseCard8();
            code = 1;
            for (var i$1 = 0; i$1 < nRanges; i$1 += 1) {
                var first = parser.parseCard8();
                var nLeft = parser.parseCard8();
                for (var j = first; j <= first + nLeft; j += 1) {
                    enc[j] = code;
                    code += 1;
                }
            }
        } else {
            throw new Error('Unknown encoding format ' + format);
        }
        return new CffEncoding(enc, charset);
    }
    function parseCFFCharstring(font, glyph, code) {
        var c1x;
        var c1y;
        var c2x;
        var c2y;
        var p = new Path();
        var stack = [];
        var nStems = 0;
        var haveWidth = false;
        var open = false;
        var x = 0;
        var y = 0;
        var subrs;
        var subrsBias;
        var defaultWidthX;
        var nominalWidthX;
        if (font.isCIDFont) {
            var fdIndex = font.tables.cff.topDict._fdSelect[glyph.index];
            var fdDict = font.tables.cff.topDict._fdArray[fdIndex];
            subrs = fdDict._subrs;
            subrsBias = fdDict._subrsBias;
            defaultWidthX = fdDict._defaultWidthX;
            nominalWidthX = fdDict._nominalWidthX;
        } else {
            subrs = font.tables.cff.topDict._subrs;
            subrsBias = font.tables.cff.topDict._subrsBias;
            defaultWidthX = font.tables.cff.topDict._defaultWidthX;
            nominalWidthX = font.tables.cff.topDict._nominalWidthX;
        }
        var width = defaultWidthX;
        function newContour(x, y) {
            if (open) {
                p.closePath();
            }
            p.moveTo(x, y);
            open = true;
        }
        function parseStems() {
            var hasWidthArg;
            hasWidthArg = stack.length % 2 !== 0;
            if (hasWidthArg && !haveWidth) {
                width = stack.shift() + nominalWidthX;
            }
            nStems += stack.length >> 1;
            stack.length = 0;
            haveWidth = true;
        }
        function parse$$1(code) {
            var b1;
            var b2;
            var b3;
            var b4;
            var codeIndex;
            var subrCode;
            var jpx;
            var jpy;
            var c3x;
            var c3y;
            var c4x;
            var c4y;
            var i = 0;
            while (i < code.length) {
                var v = code[i];
                i += 1;
                switch (v) {
                case 1:
                    parseStems();
                    break;
                case 3:
                    parseStems();
                    break;
                case 4:
                    if (stack.length > 1 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }
                    y += stack.pop();
                    newContour(x, y);
                    break;
                case 5:
                    while (stack.length > 0) {
                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                    }
                    break;
                case 6:
                    while (stack.length > 0) {
                        x += stack.shift();
                        p.lineTo(x, y);
                        if (stack.length === 0) {
                            break;
                        }
                        y += stack.shift();
                        p.lineTo(x, y);
                    }
                    break;
                case 7:
                    while (stack.length > 0) {
                        y += stack.shift();
                        p.lineTo(x, y);
                        if (stack.length === 0) {
                            break;
                        }
                        x += stack.shift();
                        p.lineTo(x, y);
                    }
                    break;
                case 8:
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }
                    break;
                case 10:
                    codeIndex = stack.pop() + subrsBias;
                    subrCode = subrs[codeIndex];
                    if (subrCode) {
                        parse$$1(subrCode);
                    }
                    break;
                case 11:
                    return;
                case 12:
                    v = code[i];
                    i += 1;
                    switch (v) {
                    case 35:
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        jpx = c2x + stack.shift();
                        jpy = c2y + stack.shift();
                        c3x = jpx + stack.shift();
                        c3y = jpy + stack.shift();
                        c4x = c3x + stack.shift();
                        c4y = c3y + stack.shift();
                        x = c4x + stack.shift();
                        y = c4y + stack.shift();
                        stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                        p.curveTo(c3x, c3y, c4x, c4y, x, y);
                        break;
                    case 34:
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        jpx = c2x + stack.shift();
                        jpy = c2y;
                        c3x = jpx + stack.shift();
                        c3y = c2y;
                        c4x = c3x + stack.shift();
                        c4y = y;
                        x = c4x + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                        p.curveTo(c3x, c3y, c4x, c4y, x, y);
                        break;
                    case 36:
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        jpx = c2x + stack.shift();
                        jpy = c2y;
                        c3x = jpx + stack.shift();
                        c3y = c2y;
                        c4x = c3x + stack.shift();
                        c4y = c3y + stack.shift();
                        x = c4x + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                        p.curveTo(c3x, c3y, c4x, c4y, x, y);
                        break;
                    case 37:
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        jpx = c2x + stack.shift();
                        jpy = c2y + stack.shift();
                        c3x = jpx + stack.shift();
                        c3y = jpy + stack.shift();
                        c4x = c3x + stack.shift();
                        c4y = c3y + stack.shift();
                        if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
                            x = c4x + stack.shift();
                        } else {
                            y = c4y + stack.shift();
                        }
                        p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                        p.curveTo(c3x, c3y, c4x, c4y, x, y);
                        break;
                    default:
                        console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
                        stack.length = 0;
                    }
                    break;
                case 14:
                    if (stack.length > 0 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }
                    if (open) {
                        p.closePath();
                        open = false;
                    }
                    break;
                case 18:
                    parseStems();
                    break;
                case 19:
                case 20:
                    parseStems();
                    i += nStems + 7 >> 3;
                    break;
                case 21:
                    if (stack.length > 2 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }
                    y += stack.pop();
                    x += stack.pop();
                    newContour(x, y);
                    break;
                case 22:
                    if (stack.length > 1 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }
                    x += stack.pop();
                    newContour(x, y);
                    break;
                case 23:
                    parseStems();
                    break;
                case 24:
                    while (stack.length > 2) {
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }
                    x += stack.shift();
                    y += stack.shift();
                    p.lineTo(x, y);
                    break;
                case 25:
                    while (stack.length > 6) {
                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                    }
                    c1x = x + stack.shift();
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + stack.shift();
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    break;
                case 26:
                    if (stack.length % 2) {
                        x += stack.shift();
                    }
                    while (stack.length > 0) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x;
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }
                    break;
                case 27:
                    if (stack.length % 2) {
                        y += stack.shift();
                    }
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y;
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }
                    break;
                case 28:
                    b1 = code[i];
                    b2 = code[i + 1];
                    stack.push((b1 << 24 | b2 << 16) >> 16);
                    i += 2;
                    break;
                case 29:
                    codeIndex = stack.pop() + font.gsubrsBias;
                    subrCode = font.gsubrs[codeIndex];
                    if (subrCode) {
                        parse$$1(subrCode);
                    }
                    break;
                case 30:
                    while (stack.length > 0) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        if (stack.length === 0) {
                            break;
                        }
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        y = c2y + stack.shift();
                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }
                    break;
                case 31:
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        y = c2y + stack.shift();
                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        if (stack.length === 0) {
                            break;
                        }
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }
                    break;
                default:
                    if (v < 32) {
                        console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
                    } else if (v < 247) {
                        stack.push(v - 139);
                    } else if (v < 251) {
                        b1 = code[i];
                        i += 1;
                        stack.push((v - 247) * 256 + b1 + 108);
                    } else if (v < 255) {
                        b1 = code[i];
                        i += 1;
                        stack.push(-(v - 251) * 256 - b1 - 108);
                    } else {
                        b1 = code[i];
                        b2 = code[i + 1];
                        b3 = code[i + 2];
                        b4 = code[i + 3];
                        i += 4;
                        stack.push((b1 << 24 | b2 << 16 | b3 << 8 | b4) / 65536);
                    }
                }
            }
        }
        parse$$1(code);
        glyph.advanceWidth = width;
        return p;
    }
    function parseCFFFDSelect(data, start, nGlyphs, fdArrayCount) {
        var fdSelect = [];
        var fdIndex;
        var parser = new parse.Parser(data, start);
        var format = parser.parseCard8();
        if (format === 0) {
            for (var iGid = 0; iGid < nGlyphs; iGid++) {
                fdIndex = parser.parseCard8();
                if (fdIndex >= fdArrayCount) {
                    throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
                }
                fdSelect.push(fdIndex);
            }
        } else if (format === 3) {
            var nRanges = parser.parseCard16();
            var first = parser.parseCard16();
            if (first !== 0) {
                throw new Error('CFF Table CID Font FDSelect format 3 range has bad initial GID ' + first);
            }
            var next;
            for (var iRange = 0; iRange < nRanges; iRange++) {
                fdIndex = parser.parseCard8();
                next = parser.parseCard16();
                if (fdIndex >= fdArrayCount) {
                    throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
                }
                if (next > nGlyphs) {
                    throw new Error('CFF Table CID Font FDSelect format 3 range has bad GID ' + next);
                }
                for (; first < next; first++) {
                    fdSelect.push(fdIndex);
                }
                first = next;
            }
            if (next !== nGlyphs) {
                throw new Error('CFF Table CID Font FDSelect format 3 range has bad final GID ' + next);
            }
        } else {
            throw new Error('CFF Table CID Font FDSelect table has unsupported format ' + format);
        }
        return fdSelect;
    }
    function parseCFFTable(data, start, font) {
        font.tables.cff = {};
        var header = parseCFFHeader(data, start);
        var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
        var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
        var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
        var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
        font.gsubrs = globalSubrIndex.objects;
        font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);
        var topDictArray = gatherCFFTopDicts(data, start, topDictIndex.objects, stringIndex.objects);
        if (topDictArray.length !== 1) {
            throw new Error('CFF table has too many fonts in \'FontSet\' - count of fonts NameIndex.length = ' + topDictArray.length);
        }
        var topDict = topDictArray[0];
        font.tables.cff.topDict = topDict;
        if (topDict._privateDict) {
            font.defaultWidthX = topDict._privateDict.defaultWidthX;
            font.nominalWidthX = topDict._privateDict.nominalWidthX;
        }
        if (topDict.ros[0] !== undefined && topDict.ros[1] !== undefined) {
            font.isCIDFont = true;
        }
        if (font.isCIDFont) {
            var fdArrayOffset = topDict.fdArray;
            var fdSelectOffset = topDict.fdSelect;
            if (fdArrayOffset === 0 || fdSelectOffset === 0) {
                throw new Error('Font is marked as a CID font, but FDArray and/or FDSelect information is missing');
            }
            fdArrayOffset += start;
            var fdArrayIndex = parseCFFIndex(data, fdArrayOffset);
            var fdArray = gatherCFFTopDicts(data, start, fdArrayIndex.objects, stringIndex.objects);
            topDict._fdArray = fdArray;
            fdSelectOffset += start;
            topDict._fdSelect = parseCFFFDSelect(data, fdSelectOffset, font.numGlyphs, fdArray.length);
        }
        var privateDictOffset = start + topDict.private[1];
        var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict.private[0], stringIndex.objects);
        font.defaultWidthX = privateDict.defaultWidthX;
        font.nominalWidthX = privateDict.nominalWidthX;
        if (privateDict.subrs !== 0) {
            var subrOffset = privateDictOffset + privateDict.subrs;
            var subrIndex = parseCFFIndex(data, subrOffset);
            font.subrs = subrIndex.objects;
            font.subrsBias = calcCFFSubroutineBias(font.subrs);
        } else {
            font.subrs = [];
            font.subrsBias = 0;
        }
        var charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
        font.nGlyphs = charStringsIndex.objects.length;
        var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
        if (topDict.encoding === 0) {
            font.cffEncoding = new CffEncoding(cffStandardEncoding, charset);
        } else if (topDict.encoding === 1) {
            font.cffEncoding = new CffEncoding(cffExpertEncoding, charset);
        } else {
            font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
        }
        font.encoding = font.encoding || font.cffEncoding;
        font.glyphs = new glyphset.GlyphSet(font);
        for (var i = 0; i < font.nGlyphs; i += 1) {
            var charString = charStringsIndex.objects[i];
            font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
        }
    }
    function encodeString(s, strings) {
        var sid;
        var i = cffStandardStrings.indexOf(s);
        if (i >= 0) {
            sid = i;
        }
        i = strings.indexOf(s);
        if (i >= 0) {
            sid = i + cffStandardStrings.length;
        } else {
            sid = cffStandardStrings.length + strings.length;
            strings.push(s);
        }
        return sid;
    }
    function makeHeader() {
        return new table.Record('Header', [
            {
                name: 'major',
                type: 'Card8',
                value: 1
            },
            {
                name: 'minor',
                type: 'Card8',
                value: 0
            },
            {
                name: 'hdrSize',
                type: 'Card8',
                value: 4
            },
            {
                name: 'major',
                type: 'Card8',
                value: 1
            }
        ]);
    }
    function makeNameIndex(fontNames) {
        var t = new table.Record('Name INDEX', [{
                name: 'names',
                type: 'INDEX',
                value: []
            }]);
        t.names = [];
        for (var i = 0; i < fontNames.length; i += 1) {
            t.names.push({
                name: 'name_' + i,
                type: 'NAME',
                value: fontNames[i]
            });
        }
        return t;
    }
    function makeDict(meta, attrs, strings) {
        var m = {};
        for (var i = 0; i < meta.length; i += 1) {
            var entry = meta[i];
            var value = attrs[entry.name];
            if (value !== undefined && !equals(value, entry.value)) {
                if (entry.type === 'SID') {
                    value = encodeString(value, strings);
                }
                m[entry.op] = {
                    name: entry.name,
                    type: entry.type,
                    value: value
                };
            }
        }
        return m;
    }
    function makeTopDict(attrs, strings) {
        var t = new table.Record('Top DICT', [{
                name: 'dict',
                type: 'DICT',
                value: {}
            }]);
        t.dict = makeDict(TOP_DICT_META, attrs, strings);
        return t;
    }
    function makeTopDictIndex(topDict) {
        var t = new table.Record('Top DICT INDEX', [{
                name: 'topDicts',
                type: 'INDEX',
                value: []
            }]);
        t.topDicts = [{
                name: 'topDict_0',
                type: 'TABLE',
                value: topDict
            }];
        return t;
    }
    function makeStringIndex(strings) {
        var t = new table.Record('String INDEX', [{
                name: 'strings',
                type: 'INDEX',
                value: []
            }]);
        t.strings = [];
        for (var i = 0; i < strings.length; i += 1) {
            t.strings.push({
                name: 'string_' + i,
                type: 'STRING',
                value: strings[i]
            });
        }
        return t;
    }
    function makeGlobalSubrIndex() {
        return new table.Record('Global Subr INDEX', [{
                name: 'subrs',
                type: 'INDEX',
                value: []
            }]);
    }
    function makeCharsets(glyphNames, strings) {
        var t = new table.Record('Charsets', [{
                name: 'format',
                type: 'Card8',
                value: 0
            }]);
        for (var i = 0; i < glyphNames.length; i += 1) {
            var glyphName = glyphNames[i];
            var glyphSID = encodeString(glyphName, strings);
            t.fields.push({
                name: 'glyph_' + i,
                type: 'SID',
                value: glyphSID
            });
        }
        return t;
    }
    function glyphToOps(glyph) {
        var ops = [];
        var path = glyph.path;
        ops.push({
            name: 'width',
            type: 'NUMBER',
            value: glyph.advanceWidth
        });
        var x = 0;
        var y = 0;
        for (var i = 0; i < path.commands.length; i += 1) {
            var dx = void 0;
            var dy = void 0;
            var cmd = path.commands[i];
            if (cmd.type === 'Q') {
                var _13 = 1 / 3;
                var _23 = 2 / 3;
                cmd = {
                    type: 'C',
                    x: cmd.x,
                    y: cmd.y,
                    x1: _13 * x + _23 * cmd.x1,
                    y1: _13 * y + _23 * cmd.y1,
                    x2: _13 * cmd.x + _23 * cmd.x1,
                    y2: _13 * cmd.y + _23 * cmd.y1
                };
            }
            if (cmd.type === 'M') {
                dx = Math.round(cmd.x - x);
                dy = Math.round(cmd.y - y);
                ops.push({
                    name: 'dx',
                    type: 'NUMBER',
                    value: dx
                });
                ops.push({
                    name: 'dy',
                    type: 'NUMBER',
                    value: dy
                });
                ops.push({
                    name: 'rmoveto',
                    type: 'OP',
                    value: 21
                });
                x = Math.round(cmd.x);
                y = Math.round(cmd.y);
            } else if (cmd.type === 'L') {
                dx = Math.round(cmd.x - x);
                dy = Math.round(cmd.y - y);
                ops.push({
                    name: 'dx',
                    type: 'NUMBER',
                    value: dx
                });
                ops.push({
                    name: 'dy',
                    type: 'NUMBER',
                    value: dy
                });
                ops.push({
                    name: 'rlineto',
                    type: 'OP',
                    value: 5
                });
                x = Math.round(cmd.x);
                y = Math.round(cmd.y);
            } else if (cmd.type === 'C') {
                var dx1 = Math.round(cmd.x1 - x);
                var dy1 = Math.round(cmd.y1 - y);
                var dx2 = Math.round(cmd.x2 - cmd.x1);
                var dy2 = Math.round(cmd.y2 - cmd.y1);
                dx = Math.round(cmd.x - cmd.x2);
                dy = Math.round(cmd.y - cmd.y2);
                ops.push({
                    name: 'dx1',
                    type: 'NUMBER',
                    value: dx1
                });
                ops.push({
                    name: 'dy1',
                    type: 'NUMBER',
                    value: dy1
                });
                ops.push({
                    name: 'dx2',
                    type: 'NUMBER',
                    value: dx2
                });
                ops.push({
                    name: 'dy2',
                    type: 'NUMBER',
                    value: dy2
                });
                ops.push({
                    name: 'dx',
                    type: 'NUMBER',
                    value: dx
                });
                ops.push({
                    name: 'dy',
                    type: 'NUMBER',
                    value: dy
                });
                ops.push({
                    name: 'rrcurveto',
                    type: 'OP',
                    value: 8
                });
                x = Math.round(cmd.x);
                y = Math.round(cmd.y);
            }
        }
        ops.push({
            name: 'endchar',
            type: 'OP',
            value: 14
        });
        return ops;
    }
    function makeCharStringsIndex(glyphs) {
        var t = new table.Record('CharStrings INDEX', [{
                name: 'charStrings',
                type: 'INDEX',
                value: []
            }]);
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            var ops = glyphToOps(glyph);
            t.charStrings.push({
                name: glyph.name,
                type: 'CHARSTRING',
                value: ops
            });
        }
        return t;
    }
    function makePrivateDict(attrs, strings) {
        var t = new table.Record('Private DICT', [{
                name: 'dict',
                type: 'DICT',
                value: {}
            }]);
        t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
        return t;
    }
    function makeCFFTable(glyphs, options) {
        var t = new table.Table('CFF ', [
            {
                name: 'header',
                type: 'RECORD'
            },
            {
                name: 'nameIndex',
                type: 'RECORD'
            },
            {
                name: 'topDictIndex',
                type: 'RECORD'
            },
            {
                name: 'stringIndex',
                type: 'RECORD'
            },
            {
                name: 'globalSubrIndex',
                type: 'RECORD'
            },
            {
                name: 'charsets',
                type: 'RECORD'
            },
            {
                name: 'charStringsIndex',
                type: 'RECORD'
            },
            {
                name: 'privateDict',
                type: 'RECORD'
            }
        ]);
        var fontScale = 1 / options.unitsPerEm;
        var attrs = {
            version: options.version,
            fullName: options.fullName,
            familyName: options.familyName,
            weight: options.weightName,
            fontBBox: options.fontBBox || [
                0,
                0,
                0,
                0
            ],
            fontMatrix: [
                fontScale,
                0,
                0,
                fontScale,
                0,
                0
            ],
            charset: 999,
            encoding: 0,
            charStrings: 999,
            private: [
                0,
                999
            ]
        };
        var privateAttrs = {};
        var glyphNames = [];
        var glyph;
        for (var i = 1; i < glyphs.length; i += 1) {
            glyph = glyphs.get(i);
            glyphNames.push(glyph.name);
        }
        var strings = [];
        t.header = makeHeader();
        t.nameIndex = makeNameIndex([options.postScriptName]);
        var topDict = makeTopDict(attrs, strings);
        t.topDictIndex = makeTopDictIndex(topDict);
        t.globalSubrIndex = makeGlobalSubrIndex();
        t.charsets = makeCharsets(glyphNames, strings);
        t.charStringsIndex = makeCharStringsIndex(glyphs);
        t.privateDict = makePrivateDict(privateAttrs, strings);
        t.stringIndex = makeStringIndex(strings);
        var startOffset = t.header.sizeOf() + t.nameIndex.sizeOf() + t.topDictIndex.sizeOf() + t.stringIndex.sizeOf() + t.globalSubrIndex.sizeOf();
        attrs.charset = startOffset;
        attrs.encoding = 0;
        attrs.charStrings = attrs.charset + t.charsets.sizeOf();
        attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();
        topDict = makeTopDict(attrs, strings);
        t.topDictIndex = makeTopDictIndex(topDict);
        return t;
    }
    var cff = {
        parse: parseCFFTable,
        make: makeCFFTable
    };
    function parseHeadTable(data, start) {
        var head = {};
        var p = new parse.Parser(data, start);
        head.version = p.parseVersion();
        head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
        head.checkSumAdjustment = p.parseULong();
        head.magicNumber = p.parseULong();
        check.argument(head.magicNumber === 1594834165, 'Font header has wrong magic number.');
        head.flags = p.parseUShort();
        head.unitsPerEm = p.parseUShort();
        head.created = p.parseLongDateTime();
        head.modified = p.parseLongDateTime();
        head.xMin = p.parseShort();
        head.yMin = p.parseShort();
        head.xMax = p.parseShort();
        head.yMax = p.parseShort();
        head.macStyle = p.parseUShort();
        head.lowestRecPPEM = p.parseUShort();
        head.fontDirectionHint = p.parseShort();
        head.indexToLocFormat = p.parseShort();
        head.glyphDataFormat = p.parseShort();
        return head;
    }
    function makeHeadTable(options) {
        var timestamp = Math.round(new Date().getTime() / 1000) + 2082844800;
        var createdTimestamp = timestamp;
        if (options.createdTimestamp) {
            createdTimestamp = options.createdTimestamp + 2082844800;
        }
        return new table.Table('head', [
            {
                name: 'version',
                type: 'FIXED',
                value: 65536
            },
            {
                name: 'fontRevision',
                type: 'FIXED',
                value: 65536
            },
            {
                name: 'checkSumAdjustment',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'magicNumber',
                type: 'ULONG',
                value: 1594834165
            },
            {
                name: 'flags',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'unitsPerEm',
                type: 'USHORT',
                value: 1000
            },
            {
                name: 'created',
                type: 'LONGDATETIME',
                value: createdTimestamp
            },
            {
                name: 'modified',
                type: 'LONGDATETIME',
                value: timestamp
            },
            {
                name: 'xMin',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'yMin',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'xMax',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'yMax',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'macStyle',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'lowestRecPPEM',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'fontDirectionHint',
                type: 'SHORT',
                value: 2
            },
            {
                name: 'indexToLocFormat',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'glyphDataFormat',
                type: 'SHORT',
                value: 0
            }
        ], options);
    }
    var head = {
        parse: parseHeadTable,
        make: makeHeadTable
    };
    function parseHheaTable(data, start) {
        var hhea = {};
        var p = new parse.Parser(data, start);
        hhea.version = p.parseVersion();
        hhea.ascender = p.parseShort();
        hhea.descender = p.parseShort();
        hhea.lineGap = p.parseShort();
        hhea.advanceWidthMax = p.parseUShort();
        hhea.minLeftSideBearing = p.parseShort();
        hhea.minRightSideBearing = p.parseShort();
        hhea.xMaxExtent = p.parseShort();
        hhea.caretSlopeRise = p.parseShort();
        hhea.caretSlopeRun = p.parseShort();
        hhea.caretOffset = p.parseShort();
        p.relativeOffset += 8;
        hhea.metricDataFormat = p.parseShort();
        hhea.numberOfHMetrics = p.parseUShort();
        return hhea;
    }
    function makeHheaTable(options) {
        return new table.Table('hhea', [
            {
                name: 'version',
                type: 'FIXED',
                value: 65536
            },
            {
                name: 'ascender',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'descender',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'lineGap',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'advanceWidthMax',
                type: 'UFWORD',
                value: 0
            },
            {
                name: 'minLeftSideBearing',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'minRightSideBearing',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'xMaxExtent',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'caretSlopeRise',
                type: 'SHORT',
                value: 1
            },
            {
                name: 'caretSlopeRun',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'caretOffset',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'reserved1',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'reserved2',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'reserved3',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'reserved4',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'metricDataFormat',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'numberOfHMetrics',
                type: 'USHORT',
                value: 0
            }
        ], options);
    }
    var hhea = {
        parse: parseHheaTable,
        make: makeHheaTable
    };
    function parseHmtxTable(data, start, numMetrics, numGlyphs, glyphs) {
        var advanceWidth;
        var leftSideBearing;
        var p = new parse.Parser(data, start);
        for (var i = 0; i < numGlyphs; i += 1) {
            if (i < numMetrics) {
                advanceWidth = p.parseUShort();
                leftSideBearing = p.parseShort();
            }
            var glyph = glyphs.get(i);
            glyph.advanceWidth = advanceWidth;
            glyph.leftSideBearing = leftSideBearing;
        }
    }
    function makeHmtxTable(glyphs) {
        var t = new table.Table('hmtx', []);
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            var advanceWidth = glyph.advanceWidth || 0;
            var leftSideBearing = glyph.leftSideBearing || 0;
            t.fields.push({
                name: 'advanceWidth_' + i,
                type: 'USHORT',
                value: advanceWidth
            });
            t.fields.push({
                name: 'leftSideBearing_' + i,
                type: 'SHORT',
                value: leftSideBearing
            });
        }
        return t;
    }
    var hmtx = {
        parse: parseHmtxTable,
        make: makeHmtxTable
    };
    function makeLtagTable(tags) {
        var result = new table.Table('ltag', [
            {
                name: 'version',
                type: 'ULONG',
                value: 1
            },
            {
                name: 'flags',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'numTags',
                type: 'ULONG',
                value: tags.length
            }
        ]);
        var stringPool = '';
        var stringPoolOffset = 12 + tags.length * 4;
        for (var i = 0; i < tags.length; ++i) {
            var pos = stringPool.indexOf(tags[i]);
            if (pos < 0) {
                pos = stringPool.length;
                stringPool += tags[i];
            }
            result.fields.push({
                name: 'offset ' + i,
                type: 'USHORT',
                value: stringPoolOffset + pos
            });
            result.fields.push({
                name: 'length ' + i,
                type: 'USHORT',
                value: tags[i].length
            });
        }
        result.fields.push({
            name: 'stringPool',
            type: 'CHARARRAY',
            value: stringPool
        });
        return result;
    }
    function parseLtagTable(data, start) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseULong();
        check.argument(tableVersion === 1, 'Unsupported ltag table version.');
        p.skip('uLong', 1);
        var numTags = p.parseULong();
        var tags = [];
        for (var i = 0; i < numTags; i++) {
            var tag = '';
            var offset = start + p.parseUShort();
            var length = p.parseUShort();
            for (var j = offset; j < offset + length; ++j) {
                tag += String.fromCharCode(data.getInt8(j));
            }
            tags.push(tag);
        }
        return tags;
    }
    var ltag = {
        make: makeLtagTable,
        parse: parseLtagTable
    };
    function parseMaxpTable(data, start) {
        var maxp = {};
        var p = new parse.Parser(data, start);
        maxp.version = p.parseVersion();
        maxp.numGlyphs = p.parseUShort();
        if (maxp.version === 1) {
            maxp.maxPoints = p.parseUShort();
            maxp.maxContours = p.parseUShort();
            maxp.maxCompositePoints = p.parseUShort();
            maxp.maxCompositeContours = p.parseUShort();
            maxp.maxZones = p.parseUShort();
            maxp.maxTwilightPoints = p.parseUShort();
            maxp.maxStorage = p.parseUShort();
            maxp.maxFunctionDefs = p.parseUShort();
            maxp.maxInstructionDefs = p.parseUShort();
            maxp.maxStackElements = p.parseUShort();
            maxp.maxSizeOfInstructions = p.parseUShort();
            maxp.maxComponentElements = p.parseUShort();
            maxp.maxComponentDepth = p.parseUShort();
        }
        return maxp;
    }
    function makeMaxpTable(numGlyphs) {
        return new table.Table('maxp', [
            {
                name: 'version',
                type: 'FIXED',
                value: 20480
            },
            {
                name: 'numGlyphs',
                type: 'USHORT',
                value: numGlyphs
            }
        ]);
    }
    var maxp = {
        parse: parseMaxpTable,
        make: makeMaxpTable
    };
    var nameTableNames = [
        'copyright',
        'fontFamily',
        'fontSubfamily',
        'uniqueID',
        'fullName',
        'version',
        'postScriptName',
        'trademark',
        'manufacturer',
        'designer',
        'description',
        'manufacturerURL',
        'designerURL',
        'license',
        'licenseURL',
        'reserved',
        'preferredFamily',
        'preferredSubfamily',
        'compatibleFullName',
        'sampleText',
        'postScriptFindFontName',
        'wwsFamily',
        'wwsSubfamily'
    ];
    var macLanguages = {
        0: 'en',
        1: 'fr',
        2: 'de',
        3: 'it',
        4: 'nl',
        5: 'sv',
        6: 'es',
        7: 'da',
        8: 'pt',
        9: 'no',
        10: 'he',
        11: 'ja',
        12: 'ar',
        13: 'fi',
        14: 'el',
        15: 'is',
        16: 'mt',
        17: 'tr',
        18: 'hr',
        19: 'zh-Hant',
        20: 'ur',
        21: 'hi',
        22: 'th',
        23: 'ko',
        24: 'lt',
        25: 'pl',
        26: 'hu',
        27: 'es',
        28: 'lv',
        29: 'se',
        30: 'fo',
        31: 'fa',
        32: 'ru',
        33: 'zh',
        34: 'nl-BE',
        35: 'ga',
        36: 'sq',
        37: 'ro',
        38: 'cz',
        39: 'sk',
        40: 'si',
        41: 'yi',
        42: 'sr',
        43: 'mk',
        44: 'bg',
        45: 'uk',
        46: 'be',
        47: 'uz',
        48: 'kk',
        49: 'az-Cyrl',
        50: 'az-Arab',
        51: 'hy',
        52: 'ka',
        53: 'mo',
        54: 'ky',
        55: 'tg',
        56: 'tk',
        57: 'mn-CN',
        58: 'mn',
        59: 'ps',
        60: 'ks',
        61: 'ku',
        62: 'sd',
        63: 'bo',
        64: 'ne',
        65: 'sa',
        66: 'mr',
        67: 'bn',
        68: 'as',
        69: 'gu',
        70: 'pa',
        71: 'or',
        72: 'ml',
        73: 'kn',
        74: 'ta',
        75: 'te',
        76: 'si',
        77: 'my',
        78: 'km',
        79: 'lo',
        80: 'vi',
        81: 'id',
        82: 'tl',
        83: 'ms',
        84: 'ms-Arab',
        85: 'am',
        86: 'ti',
        87: 'om',
        88: 'so',
        89: 'sw',
        90: 'rw',
        91: 'rn',
        92: 'ny',
        93: 'mg',
        94: 'eo',
        128: 'cy',
        129: 'eu',
        130: 'ca',
        131: 'la',
        132: 'qu',
        133: 'gn',
        134: 'ay',
        135: 'tt',
        136: 'ug',
        137: 'dz',
        138: 'jv',
        139: 'su',
        140: 'gl',
        141: 'af',
        142: 'br',
        143: 'iu',
        144: 'gd',
        145: 'gv',
        146: 'ga',
        147: 'to',
        148: 'el-polyton',
        149: 'kl',
        150: 'az',
        151: 'nn'
    };
    var macLanguageToScript = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 5,
        11: 1,
        12: 4,
        13: 0,
        14: 6,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 2,
        20: 4,
        21: 9,
        22: 21,
        23: 3,
        24: 29,
        25: 29,
        26: 29,
        27: 29,
        28: 29,
        29: 0,
        30: 0,
        31: 4,
        32: 7,
        33: 25,
        34: 0,
        35: 0,
        36: 0,
        37: 0,
        38: 29,
        39: 29,
        40: 0,
        41: 5,
        42: 7,
        43: 7,
        44: 7,
        45: 7,
        46: 7,
        47: 7,
        48: 7,
        49: 7,
        50: 4,
        51: 24,
        52: 23,
        53: 7,
        54: 7,
        55: 7,
        56: 7,
        57: 27,
        58: 7,
        59: 4,
        60: 4,
        61: 4,
        62: 4,
        63: 26,
        64: 9,
        65: 9,
        66: 9,
        67: 13,
        68: 13,
        69: 11,
        70: 10,
        71: 12,
        72: 17,
        73: 16,
        74: 14,
        75: 15,
        76: 18,
        77: 19,
        78: 20,
        79: 22,
        80: 30,
        81: 0,
        82: 0,
        83: 0,
        84: 4,
        85: 28,
        86: 28,
        87: 28,
        88: 0,
        89: 0,
        90: 0,
        91: 0,
        92: 0,
        93: 0,
        94: 0,
        128: 0,
        129: 0,
        130: 0,
        131: 0,
        132: 0,
        133: 0,
        134: 0,
        135: 7,
        136: 4,
        137: 26,
        138: 0,
        139: 0,
        140: 0,
        141: 0,
        142: 0,
        143: 28,
        144: 0,
        145: 0,
        146: 0,
        147: 0,
        148: 6,
        149: 0,
        150: 0,
        151: 0
    };
    var windowsLanguages = {
        1078: 'af',
        1052: 'sq',
        1156: 'gsw',
        1118: 'am',
        5121: 'ar-DZ',
        15361: 'ar-BH',
        3073: 'ar',
        2049: 'ar-IQ',
        11265: 'ar-JO',
        13313: 'ar-KW',
        12289: 'ar-LB',
        4097: 'ar-LY',
        6145: 'ary',
        8193: 'ar-OM',
        16385: 'ar-QA',
        1025: 'ar-SA',
        10241: 'ar-SY',
        7169: 'aeb',
        14337: 'ar-AE',
        9217: 'ar-YE',
        1067: 'hy',
        1101: 'as',
        2092: 'az-Cyrl',
        1068: 'az',
        1133: 'ba',
        1069: 'eu',
        1059: 'be',
        2117: 'bn',
        1093: 'bn-IN',
        8218: 'bs-Cyrl',
        5146: 'bs',
        1150: 'br',
        1026: 'bg',
        1027: 'ca',
        3076: 'zh-HK',
        5124: 'zh-MO',
        2052: 'zh',
        4100: 'zh-SG',
        1028: 'zh-TW',
        1155: 'co',
        1050: 'hr',
        4122: 'hr-BA',
        1029: 'cs',
        1030: 'da',
        1164: 'prs',
        1125: 'dv',
        2067: 'nl-BE',
        1043: 'nl',
        3081: 'en-AU',
        10249: 'en-BZ',
        4105: 'en-CA',
        9225: 'en-029',
        16393: 'en-IN',
        6153: 'en-IE',
        8201: 'en-JM',
        17417: 'en-MY',
        5129: 'en-NZ',
        13321: 'en-PH',
        18441: 'en-SG',
        7177: 'en-ZA',
        11273: 'en-TT',
        2057: 'en-GB',
        1033: 'en',
        12297: 'en-ZW',
        1061: 'et',
        1080: 'fo',
        1124: 'fil',
        1035: 'fi',
        2060: 'fr-BE',
        3084: 'fr-CA',
        1036: 'fr',
        5132: 'fr-LU',
        6156: 'fr-MC',
        4108: 'fr-CH',
        1122: 'fy',
        1110: 'gl',
        1079: 'ka',
        3079: 'de-AT',
        1031: 'de',
        5127: 'de-LI',
        4103: 'de-LU',
        2055: 'de-CH',
        1032: 'el',
        1135: 'kl',
        1095: 'gu',
        1128: 'ha',
        1037: 'he',
        1081: 'hi',
        1038: 'hu',
        1039: 'is',
        1136: 'ig',
        1057: 'id',
        1117: 'iu',
        2141: 'iu-Latn',
        2108: 'ga',
        1076: 'xh',
        1077: 'zu',
        1040: 'it',
        2064: 'it-CH',
        1041: 'ja',
        1099: 'kn',
        1087: 'kk',
        1107: 'km',
        1158: 'quc',
        1159: 'rw',
        1089: 'sw',
        1111: 'kok',
        1042: 'ko',
        1088: 'ky',
        1108: 'lo',
        1062: 'lv',
        1063: 'lt',
        2094: 'dsb',
        1134: 'lb',
        1071: 'mk',
        2110: 'ms-BN',
        1086: 'ms',
        1100: 'ml',
        1082: 'mt',
        1153: 'mi',
        1146: 'arn',
        1102: 'mr',
        1148: 'moh',
        1104: 'mn',
        2128: 'mn-CN',
        1121: 'ne',
        1044: 'nb',
        2068: 'nn',
        1154: 'oc',
        1096: 'or',
        1123: 'ps',
        1045: 'pl',
        1046: 'pt',
        2070: 'pt-PT',
        1094: 'pa',
        1131: 'qu-BO',
        2155: 'qu-EC',
        3179: 'qu',
        1048: 'ro',
        1047: 'rm',
        1049: 'ru',
        9275: 'smn',
        4155: 'smj-NO',
        5179: 'smj',
        3131: 'se-FI',
        1083: 'se',
        2107: 'se-SE',
        8251: 'sms',
        6203: 'sma-NO',
        7227: 'sms',
        1103: 'sa',
        7194: 'sr-Cyrl-BA',
        3098: 'sr',
        6170: 'sr-Latn-BA',
        2074: 'sr-Latn',
        1132: 'nso',
        1074: 'tn',
        1115: 'si',
        1051: 'sk',
        1060: 'sl',
        11274: 'es-AR',
        16394: 'es-BO',
        13322: 'es-CL',
        9226: 'es-CO',
        5130: 'es-CR',
        7178: 'es-DO',
        12298: 'es-EC',
        17418: 'es-SV',
        4106: 'es-GT',
        18442: 'es-HN',
        2058: 'es-MX',
        19466: 'es-NI',
        6154: 'es-PA',
        15370: 'es-PY',
        10250: 'es-PE',
        20490: 'es-PR',
        3082: 'es',
        1034: 'es',
        21514: 'es-US',
        14346: 'es-UY',
        8202: 'es-VE',
        2077: 'sv-FI',
        1053: 'sv',
        1114: 'syr',
        1064: 'tg',
        2143: 'tzm',
        1097: 'ta',
        1092: 'tt',
        1098: 'te',
        1054: 'th',
        1105: 'bo',
        1055: 'tr',
        1090: 'tk',
        1152: 'ug',
        1058: 'uk',
        1070: 'hsb',
        1056: 'ur',
        2115: 'uz-Cyrl',
        1091: 'uz',
        1066: 'vi',
        1106: 'cy',
        1160: 'wo',
        1157: 'sah',
        1144: 'ii',
        1130: 'yo'
    };
    function getLanguageCode(platformID, languageID, ltag) {
        switch (platformID) {
        case 0:
            if (languageID === 65535) {
                return 'und';
            } else if (ltag) {
                return ltag[languageID];
            }
            break;
        case 1:
            return macLanguages[languageID];
        case 3:
            return windowsLanguages[languageID];
        }
        return undefined;
    }
    var utf16 = 'utf-16';
    var macScriptEncodings = {
        0: 'macintosh',
        1: 'x-mac-japanese',
        2: 'x-mac-chinesetrad',
        3: 'x-mac-korean',
        6: 'x-mac-greek',
        7: 'x-mac-cyrillic',
        9: 'x-mac-devanagai',
        10: 'x-mac-gurmukhi',
        11: 'x-mac-gujarati',
        12: 'x-mac-oriya',
        13: 'x-mac-bengali',
        14: 'x-mac-tamil',
        15: 'x-mac-telugu',
        16: 'x-mac-kannada',
        17: 'x-mac-malayalam',
        18: 'x-mac-sinhalese',
        19: 'x-mac-burmese',
        20: 'x-mac-khmer',
        21: 'x-mac-thai',
        22: 'x-mac-lao',
        23: 'x-mac-georgian',
        24: 'x-mac-armenian',
        25: 'x-mac-chinesesimp',
        26: 'x-mac-tibetan',
        27: 'x-mac-mongolian',
        28: 'x-mac-ethiopic',
        29: 'x-mac-ce',
        30: 'x-mac-vietnamese',
        31: 'x-mac-extarabic'
    };
    var macLanguageEncodings = {
        15: 'x-mac-icelandic',
        17: 'x-mac-turkish',
        18: 'x-mac-croatian',
        24: 'x-mac-ce',
        25: 'x-mac-ce',
        26: 'x-mac-ce',
        27: 'x-mac-ce',
        28: 'x-mac-ce',
        30: 'x-mac-icelandic',
        37: 'x-mac-romanian',
        38: 'x-mac-ce',
        39: 'x-mac-ce',
        40: 'x-mac-ce',
        143: 'x-mac-inuit',
        146: 'x-mac-gaelic'
    };
    function getEncoding(platformID, encodingID, languageID) {
        switch (platformID) {
        case 0:
            return utf16;
        case 1:
            return macLanguageEncodings[languageID] || macScriptEncodings[encodingID];
        case 3:
            if (encodingID === 1 || encodingID === 10) {
                return utf16;
            }
            break;
        }
        return undefined;
    }
    function parseNameTable(data, start, ltag) {
        var name = {};
        var p = new parse.Parser(data, start);
        var format = p.parseUShort();
        var count = p.parseUShort();
        var stringOffset = p.offset + p.parseUShort();
        for (var i = 0; i < count; i++) {
            var platformID = p.parseUShort();
            var encodingID = p.parseUShort();
            var languageID = p.parseUShort();
            var nameID = p.parseUShort();
            var property = nameTableNames[nameID] || nameID;
            var byteLength = p.parseUShort();
            var offset = p.parseUShort();
            var language = getLanguageCode(platformID, languageID, ltag);
            var encoding = getEncoding(platformID, encodingID, languageID);
            if (encoding !== undefined && language !== undefined) {
                var text = void 0;
                if (encoding === utf16) {
                    text = decode.UTF16(data, stringOffset + offset, byteLength);
                } else {
                    text = decode.MACSTRING(data, stringOffset + offset, byteLength, encoding);
                }
                if (text) {
                    var translations = name[property];
                    if (translations === undefined) {
                        translations = name[property] = {};
                    }
                    translations[language] = text;
                }
            }
        }
        var langTagCount = 0;
        if (format === 1) {
            langTagCount = p.parseUShort();
        }
        return name;
    }
    function reverseDict(dict) {
        var result = {};
        for (var key in dict) {
            result[dict[key]] = parseInt(key);
        }
        return result;
    }
    function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
        return new table.Record('NameRecord', [
            {
                name: 'platformID',
                type: 'USHORT',
                value: platformID
            },
            {
                name: 'encodingID',
                type: 'USHORT',
                value: encodingID
            },
            {
                name: 'languageID',
                type: 'USHORT',
                value: languageID
            },
            {
                name: 'nameID',
                type: 'USHORT',
                value: nameID
            },
            {
                name: 'length',
                type: 'USHORT',
                value: length
            },
            {
                name: 'offset',
                type: 'USHORT',
                value: offset
            }
        ]);
    }
    function findSubArray(needle, haystack) {
        var needleLength = needle.length;
        var limit = haystack.length - needleLength + 1;
        loop:
            for (var pos = 0; pos < limit; pos++) {
                for (; pos < limit; pos++) {
                    for (var k = 0; k < needleLength; k++) {
                        if (haystack[pos + k] !== needle[k]) {
                            continue loop;
                        }
                    }
                    return pos;
                }
            }
        return -1;
    }
    function addStringToPool(s, pool) {
        var offset = findSubArray(s, pool);
        if (offset < 0) {
            offset = pool.length;
            var i = 0;
            var len = s.length;
            for (; i < len; ++i) {
                pool.push(s[i]);
            }
        }
        return offset;
    }
    function makeNameTable(names, ltag) {
        var nameID;
        var nameIDs = [];
        var namesWithNumericKeys = {};
        var nameTableIds = reverseDict(nameTableNames);
        for (var key in names) {
            var id = nameTableIds[key];
            if (id === undefined) {
                id = key;
            }
            nameID = parseInt(id);
            if (isNaN(nameID)) {
                throw new Error('Name table entry "' + key + '" does not exist, see nameTableNames for complete list.');
            }
            namesWithNumericKeys[nameID] = names[key];
            nameIDs.push(nameID);
        }
        var macLanguageIds = reverseDict(macLanguages);
        var windowsLanguageIds = reverseDict(windowsLanguages);
        var nameRecords = [];
        var stringPool = [];
        for (var i = 0; i < nameIDs.length; i++) {
            nameID = nameIDs[i];
            var translations = namesWithNumericKeys[nameID];
            for (var lang in translations) {
                var text = translations[lang];
                var macPlatform = 1;
                var macLanguage = macLanguageIds[lang];
                var macScript = macLanguageToScript[macLanguage];
                var macEncoding = getEncoding(macPlatform, macScript, macLanguage);
                var macName = encode.MACSTRING(text, macEncoding);
                if (macName === undefined) {
                    macPlatform = 0;
                    macLanguage = ltag.indexOf(lang);
                    if (macLanguage < 0) {
                        macLanguage = ltag.length;
                        ltag.push(lang);
                    }
                    macScript = 4;
                    macName = encode.UTF16(text);
                }
                var macNameOffset = addStringToPool(macName, stringPool);
                nameRecords.push(makeNameRecord(macPlatform, macScript, macLanguage, nameID, macName.length, macNameOffset));
                var winLanguage = windowsLanguageIds[lang];
                if (winLanguage !== undefined) {
                    var winName = encode.UTF16(text);
                    var winNameOffset = addStringToPool(winName, stringPool);
                    nameRecords.push(makeNameRecord(3, 1, winLanguage, nameID, winName.length, winNameOffset));
                }
            }
        }
        nameRecords.sort(function (a, b) {
            return a.platformID - b.platformID || a.encodingID - b.encodingID || a.languageID - b.languageID || a.nameID - b.nameID;
        });
        var t = new table.Table('name', [
            {
                name: 'format',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'count',
                type: 'USHORT',
                value: nameRecords.length
            },
            {
                name: 'stringOffset',
                type: 'USHORT',
                value: 6 + nameRecords.length * 12
            }
        ]);
        for (var r = 0; r < nameRecords.length; r++) {
            t.fields.push({
                name: 'record_' + r,
                type: 'RECORD',
                value: nameRecords[r]
            });
        }
        t.fields.push({
            name: 'strings',
            type: 'LITERAL',
            value: stringPool
        });
        return t;
    }
    var _name = {
        parse: parseNameTable,
        make: makeNameTable
    };
    var unicodeRanges = [
        {
            begin: 0,
            end: 127
        },
        {
            begin: 128,
            end: 255
        },
        {
            begin: 256,
            end: 383
        },
        {
            begin: 384,
            end: 591
        },
        {
            begin: 592,
            end: 687
        },
        {
            begin: 688,
            end: 767
        },
        {
            begin: 768,
            end: 879
        },
        {
            begin: 880,
            end: 1023
        },
        {
            begin: 11392,
            end: 11519
        },
        {
            begin: 1024,
            end: 1279
        },
        {
            begin: 1328,
            end: 1423
        },
        {
            begin: 1424,
            end: 1535
        },
        {
            begin: 42240,
            end: 42559
        },
        {
            begin: 1536,
            end: 1791
        },
        {
            begin: 1984,
            end: 2047
        },
        {
            begin: 2304,
            end: 2431
        },
        {
            begin: 2432,
            end: 2559
        },
        {
            begin: 2560,
            end: 2687
        },
        {
            begin: 2688,
            end: 2815
        },
        {
            begin: 2816,
            end: 2943
        },
        {
            begin: 2944,
            end: 3071
        },
        {
            begin: 3072,
            end: 3199
        },
        {
            begin: 3200,
            end: 3327
        },
        {
            begin: 3328,
            end: 3455
        },
        {
            begin: 3584,
            end: 3711
        },
        {
            begin: 3712,
            end: 3839
        },
        {
            begin: 4256,
            end: 4351
        },
        {
            begin: 6912,
            end: 7039
        },
        {
            begin: 4352,
            end: 4607
        },
        {
            begin: 7680,
            end: 7935
        },
        {
            begin: 7936,
            end: 8191
        },
        {
            begin: 8192,
            end: 8303
        },
        {
            begin: 8304,
            end: 8351
        },
        {
            begin: 8352,
            end: 8399
        },
        {
            begin: 8400,
            end: 8447
        },
        {
            begin: 8448,
            end: 8527
        },
        {
            begin: 8528,
            end: 8591
        },
        {
            begin: 8592,
            end: 8703
        },
        {
            begin: 8704,
            end: 8959
        },
        {
            begin: 8960,
            end: 9215
        },
        {
            begin: 9216,
            end: 9279
        },
        {
            begin: 9280,
            end: 9311
        },
        {
            begin: 9312,
            end: 9471
        },
        {
            begin: 9472,
            end: 9599
        },
        {
            begin: 9600,
            end: 9631
        },
        {
            begin: 9632,
            end: 9727
        },
        {
            begin: 9728,
            end: 9983
        },
        {
            begin: 9984,
            end: 10175
        },
        {
            begin: 12288,
            end: 12351
        },
        {
            begin: 12352,
            end: 12447
        },
        {
            begin: 12448,
            end: 12543
        },
        {
            begin: 12544,
            end: 12591
        },
        {
            begin: 12592,
            end: 12687
        },
        {
            begin: 43072,
            end: 43135
        },
        {
            begin: 12800,
            end: 13055
        },
        {
            begin: 13056,
            end: 13311
        },
        {
            begin: 44032,
            end: 55215
        },
        {
            begin: 55296,
            end: 57343
        },
        {
            begin: 67840,
            end: 67871
        },
        {
            begin: 19968,
            end: 40959
        },
        {
            begin: 57344,
            end: 63743
        },
        {
            begin: 12736,
            end: 12783
        },
        {
            begin: 64256,
            end: 64335
        },
        {
            begin: 64336,
            end: 65023
        },
        {
            begin: 65056,
            end: 65071
        },
        {
            begin: 65040,
            end: 65055
        },
        {
            begin: 65104,
            end: 65135
        },
        {
            begin: 65136,
            end: 65279
        },
        {
            begin: 65280,
            end: 65519
        },
        {
            begin: 65520,
            end: 65535
        },
        {
            begin: 3840,
            end: 4095
        },
        {
            begin: 1792,
            end: 1871
        },
        {
            begin: 1920,
            end: 1983
        },
        {
            begin: 3456,
            end: 3583
        },
        {
            begin: 4096,
            end: 4255
        },
        {
            begin: 4608,
            end: 4991
        },
        {
            begin: 5024,
            end: 5119
        },
        {
            begin: 5120,
            end: 5759
        },
        {
            begin: 5760,
            end: 5791
        },
        {
            begin: 5792,
            end: 5887
        },
        {
            begin: 6016,
            end: 6143
        },
        {
            begin: 6144,
            end: 6319
        },
        {
            begin: 10240,
            end: 10495
        },
        {
            begin: 40960,
            end: 42127
        },
        {
            begin: 5888,
            end: 5919
        },
        {
            begin: 66304,
            end: 66351
        },
        {
            begin: 66352,
            end: 66383
        },
        {
            begin: 66560,
            end: 66639
        },
        {
            begin: 118784,
            end: 119039
        },
        {
            begin: 119808,
            end: 120831
        },
        {
            begin: 1044480,
            end: 1048573
        },
        {
            begin: 65024,
            end: 65039
        },
        {
            begin: 917504,
            end: 917631
        },
        {
            begin: 6400,
            end: 6479
        },
        {
            begin: 6480,
            end: 6527
        },
        {
            begin: 6528,
            end: 6623
        },
        {
            begin: 6656,
            end: 6687
        },
        {
            begin: 11264,
            end: 11359
        },
        {
            begin: 11568,
            end: 11647
        },
        {
            begin: 19904,
            end: 19967
        },
        {
            begin: 43008,
            end: 43055
        },
        {
            begin: 65536,
            end: 65663
        },
        {
            begin: 65856,
            end: 65935
        },
        {
            begin: 66432,
            end: 66463
        },
        {
            begin: 66464,
            end: 66527
        },
        {
            begin: 66640,
            end: 66687
        },
        {
            begin: 66688,
            end: 66735
        },
        {
            begin: 67584,
            end: 67647
        },
        {
            begin: 68096,
            end: 68191
        },
        {
            begin: 119552,
            end: 119647
        },
        {
            begin: 73728,
            end: 74751
        },
        {
            begin: 119648,
            end: 119679
        },
        {
            begin: 7040,
            end: 7103
        },
        {
            begin: 7168,
            end: 7247
        },
        {
            begin: 7248,
            end: 7295
        },
        {
            begin: 43136,
            end: 43231
        },
        {
            begin: 43264,
            end: 43311
        },
        {
            begin: 43312,
            end: 43359
        },
        {
            begin: 43520,
            end: 43615
        },
        {
            begin: 65936,
            end: 65999
        },
        {
            begin: 66000,
            end: 66047
        },
        {
            begin: 66208,
            end: 66271
        },
        {
            begin: 127024,
            end: 127135
        }
    ];
    function getUnicodeRange(unicode) {
        for (var i = 0; i < unicodeRanges.length; i += 1) {
            var range = unicodeRanges[i];
            if (unicode >= range.begin && unicode < range.end) {
                return i;
            }
        }
        return -1;
    }
    function parseOS2Table(data, start) {
        var os2 = {};
        var p = new parse.Parser(data, start);
        os2.version = p.parseUShort();
        os2.xAvgCharWidth = p.parseShort();
        os2.usWeightClass = p.parseUShort();
        os2.usWidthClass = p.parseUShort();
        os2.fsType = p.parseUShort();
        os2.ySubscriptXSize = p.parseShort();
        os2.ySubscriptYSize = p.parseShort();
        os2.ySubscriptXOffset = p.parseShort();
        os2.ySubscriptYOffset = p.parseShort();
        os2.ySuperscriptXSize = p.parseShort();
        os2.ySuperscriptYSize = p.parseShort();
        os2.ySuperscriptXOffset = p.parseShort();
        os2.ySuperscriptYOffset = p.parseShort();
        os2.yStrikeoutSize = p.parseShort();
        os2.yStrikeoutPosition = p.parseShort();
        os2.sFamilyClass = p.parseShort();
        os2.panose = [];
        for (var i = 0; i < 10; i++) {
            os2.panose[i] = p.parseByte();
        }
        os2.ulUnicodeRange1 = p.parseULong();
        os2.ulUnicodeRange2 = p.parseULong();
        os2.ulUnicodeRange3 = p.parseULong();
        os2.ulUnicodeRange4 = p.parseULong();
        os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
        os2.fsSelection = p.parseUShort();
        os2.usFirstCharIndex = p.parseUShort();
        os2.usLastCharIndex = p.parseUShort();
        os2.sTypoAscender = p.parseShort();
        os2.sTypoDescender = p.parseShort();
        os2.sTypoLineGap = p.parseShort();
        os2.usWinAscent = p.parseUShort();
        os2.usWinDescent = p.parseUShort();
        if (os2.version >= 1) {
            os2.ulCodePageRange1 = p.parseULong();
            os2.ulCodePageRange2 = p.parseULong();
        }
        if (os2.version >= 2) {
            os2.sxHeight = p.parseShort();
            os2.sCapHeight = p.parseShort();
            os2.usDefaultChar = p.parseUShort();
            os2.usBreakChar = p.parseUShort();
            os2.usMaxContent = p.parseUShort();
        }
        return os2;
    }
    function makeOS2Table(options) {
        return new table.Table('OS/2', [
            {
                name: 'version',
                type: 'USHORT',
                value: 3
            },
            {
                name: 'xAvgCharWidth',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'usWeightClass',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'usWidthClass',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'fsType',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'ySubscriptXSize',
                type: 'SHORT',
                value: 650
            },
            {
                name: 'ySubscriptYSize',
                type: 'SHORT',
                value: 699
            },
            {
                name: 'ySubscriptXOffset',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'ySubscriptYOffset',
                type: 'SHORT',
                value: 140
            },
            {
                name: 'ySuperscriptXSize',
                type: 'SHORT',
                value: 650
            },
            {
                name: 'ySuperscriptYSize',
                type: 'SHORT',
                value: 699
            },
            {
                name: 'ySuperscriptXOffset',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'ySuperscriptYOffset',
                type: 'SHORT',
                value: 479
            },
            {
                name: 'yStrikeoutSize',
                type: 'SHORT',
                value: 49
            },
            {
                name: 'yStrikeoutPosition',
                type: 'SHORT',
                value: 258
            },
            {
                name: 'sFamilyClass',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'bFamilyType',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bSerifStyle',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bWeight',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bProportion',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bContrast',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bStrokeVariation',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bArmStyle',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bLetterform',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bMidline',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'bXHeight',
                type: 'BYTE',
                value: 0
            },
            {
                name: 'ulUnicodeRange1',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'ulUnicodeRange2',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'ulUnicodeRange3',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'ulUnicodeRange4',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'achVendID',
                type: 'CHARARRAY',
                value: 'XXXX'
            },
            {
                name: 'fsSelection',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'usFirstCharIndex',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'usLastCharIndex',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'sTypoAscender',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'sTypoDescender',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'sTypoLineGap',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'usWinAscent',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'usWinDescent',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'ulCodePageRange1',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'ulCodePageRange2',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'sxHeight',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'sCapHeight',
                type: 'SHORT',
                value: 0
            },
            {
                name: 'usDefaultChar',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'usBreakChar',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'usMaxContext',
                type: 'USHORT',
                value: 0
            }
        ], options);
    }
    var os2 = {
        parse: parseOS2Table,
        make: makeOS2Table,
        unicodeRanges: unicodeRanges,
        getUnicodeRange: getUnicodeRange
    };
    function parsePostTable(data, start) {
        var post = {};
        var p = new parse.Parser(data, start);
        post.version = p.parseVersion();
        post.italicAngle = p.parseFixed();
        post.underlinePosition = p.parseShort();
        post.underlineThickness = p.parseShort();
        post.isFixedPitch = p.parseULong();
        post.minMemType42 = p.parseULong();
        post.maxMemType42 = p.parseULong();
        post.minMemType1 = p.parseULong();
        post.maxMemType1 = p.parseULong();
        switch (post.version) {
        case 1:
            post.names = standardNames.slice();
            break;
        case 2:
            post.numberOfGlyphs = p.parseUShort();
            post.glyphNameIndex = new Array(post.numberOfGlyphs);
            for (var i = 0; i < post.numberOfGlyphs; i++) {
                post.glyphNameIndex[i] = p.parseUShort();
            }
            post.names = [];
            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                if (post.glyphNameIndex[i$1] >= standardNames.length) {
                    var nameLength = p.parseChar();
                    post.names.push(p.parseString(nameLength));
                }
            }
            break;
        case 2.5:
            post.numberOfGlyphs = p.parseUShort();
            post.offset = new Array(post.numberOfGlyphs);
            for (var i$2 = 0; i$2 < post.numberOfGlyphs; i$2++) {
                post.offset[i$2] = p.parseChar();
            }
            break;
        }
        return post;
    }
    function makePostTable() {
        return new table.Table('post', [
            {
                name: 'version',
                type: 'FIXED',
                value: 196608
            },
            {
                name: 'italicAngle',
                type: 'FIXED',
                value: 0
            },
            {
                name: 'underlinePosition',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'underlineThickness',
                type: 'FWORD',
                value: 0
            },
            {
                name: 'isFixedPitch',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'minMemType42',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'maxMemType42',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'minMemType1',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'maxMemType1',
                type: 'ULONG',
                value: 0
            }
        ]);
    }
    var post = {
        parse: parsePostTable,
        make: makePostTable
    };
    var subtableParsers = new Array(9);
    subtableParsers[1] = function parseLookup1() {
        var start = this.offset + this.relativeOffset;
        var substFormat = this.parseUShort();
        if (substFormat === 1) {
            return {
                substFormat: 1,
                coverage: this.parsePointer(Parser.coverage),
                deltaGlyphId: this.parseUShort()
            };
        } else if (substFormat === 2) {
            return {
                substFormat: 2,
                coverage: this.parsePointer(Parser.coverage),
                substitute: this.parseOffset16List()
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': lookup type 1 format must be 1 or 2.');
    };
    subtableParsers[2] = function parseLookup2() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Multiple Substitution Subtable identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            sequences: this.parseListOfLists()
        };
    };
    subtableParsers[3] = function parseLookup3() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Alternate Substitution Subtable identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            alternateSets: this.parseListOfLists()
        };
    };
    subtableParsers[4] = function parseLookup4() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB ligature table identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            ligatureSets: this.parseListOfLists(function () {
                return {
                    ligGlyph: this.parseUShort(),
                    components: this.parseUShortList(this.parseUShort() - 1)
                };
            })
        };
    };
    var lookupRecordDesc = {
        sequenceIndex: Parser.uShort,
        lookupListIndex: Parser.uShort
    };
    subtableParsers[5] = function parseLookup5() {
        var start = this.offset + this.relativeOffset;
        var substFormat = this.parseUShort();
        if (substFormat === 1) {
            return {
                substFormat: substFormat,
                coverage: this.parsePointer(Parser.coverage),
                ruleSets: this.parseListOfLists(function () {
                    var glyphCount = this.parseUShort();
                    var substCount = this.parseUShort();
                    return {
                        input: this.parseUShortList(glyphCount - 1),
                        lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 2) {
            return {
                substFormat: substFormat,
                coverage: this.parsePointer(Parser.coverage),
                classDef: this.parsePointer(Parser.classDef),
                classSets: this.parseListOfLists(function () {
                    var glyphCount = this.parseUShort();
                    var substCount = this.parseUShort();
                    return {
                        classes: this.parseUShortList(glyphCount - 1),
                        lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 3) {
            var glyphCount = this.parseUShort();
            var substCount = this.parseUShort();
            return {
                substFormat: substFormat,
                coverages: this.parseList(glyphCount, Parser.pointer(Parser.coverage)),
                lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': lookup type 5 format must be 1, 2 or 3.');
    };
    subtableParsers[6] = function parseLookup6() {
        var start = this.offset + this.relativeOffset;
        var substFormat = this.parseUShort();
        if (substFormat === 1) {
            return {
                substFormat: 1,
                coverage: this.parsePointer(Parser.coverage),
                chainRuleSets: this.parseListOfLists(function () {
                    return {
                        backtrack: this.parseUShortList(),
                        input: this.parseUShortList(this.parseShort() - 1),
                        lookahead: this.parseUShortList(),
                        lookupRecords: this.parseRecordList(lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 2) {
            return {
                substFormat: 2,
                coverage: this.parsePointer(Parser.coverage),
                backtrackClassDef: this.parsePointer(Parser.classDef),
                inputClassDef: this.parsePointer(Parser.classDef),
                lookaheadClassDef: this.parsePointer(Parser.classDef),
                chainClassSet: this.parseListOfLists(function () {
                    return {
                        backtrack: this.parseUShortList(),
                        input: this.parseUShortList(this.parseShort() - 1),
                        lookahead: this.parseUShortList(),
                        lookupRecords: this.parseRecordList(lookupRecordDesc)
                    };
                })
            };
        } else if (substFormat === 3) {
            return {
                substFormat: 3,
                backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
                inputCoverage: this.parseList(Parser.pointer(Parser.coverage)),
                lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
                lookupRecords: this.parseRecordList(lookupRecordDesc)
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': lookup type 6 format must be 1, 2 or 3.');
    };
    subtableParsers[7] = function parseLookup7() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Extension Substitution subtable identifier-format must be 1');
        var extensionLookupType = this.parseUShort();
        var extensionParser = new Parser(this.data, this.offset + this.parseULong());
        return {
            substFormat: 1,
            lookupType: extensionLookupType,
            extension: subtableParsers[extensionLookupType].call(extensionParser)
        };
    };
    subtableParsers[8] = function parseLookup8() {
        var substFormat = this.parseUShort();
        check.argument(substFormat === 1, 'GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1');
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            substitutes: this.parseUShortList()
        };
    };
    function parseGsubTable(data, start) {
        start = start || 0;
        var p = new Parser(data, start);
        var tableVersion = p.parseVersion(1);
        check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GSUB table version.');
        if (tableVersion === 1) {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers)
            };
        } else {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers),
                variations: p.parseFeatureVariationsList()
            };
        }
    }
    var subtableMakers = new Array(9);
    subtableMakers[1] = function makeLookup1(subtable) {
        if (subtable.substFormat === 1) {
            return new table.Table('substitutionTable', [
                {
                    name: 'substFormat',
                    type: 'USHORT',
                    value: 1
                },
                {
                    name: 'coverage',
                    type: 'TABLE',
                    value: new table.Coverage(subtable.coverage)
                },
                {
                    name: 'deltaGlyphID',
                    type: 'USHORT',
                    value: subtable.deltaGlyphId
                }
            ]);
        } else {
            return new table.Table('substitutionTable', [
                {
                    name: 'substFormat',
                    type: 'USHORT',
                    value: 2
                },
                {
                    name: 'coverage',
                    type: 'TABLE',
                    value: new table.Coverage(subtable.coverage)
                }
            ].concat(table.ushortList('substitute', subtable.substitute)));
        }
        check.fail('Lookup type 1 substFormat must be 1 or 2.');
    };
    subtableMakers[3] = function makeLookup3(subtable) {
        check.assert(subtable.substFormat === 1, 'Lookup type 3 substFormat must be 1.');
        return new table.Table('substitutionTable', [
            {
                name: 'substFormat',
                type: 'USHORT',
                value: 1
            },
            {
                name: 'coverage',
                type: 'TABLE',
                value: new table.Coverage(subtable.coverage)
            }
        ].concat(table.tableList('altSet', subtable.alternateSets, function (alternateSet) {
            return new table.Table('alternateSetTable', table.ushortList('alternate', alternateSet));
        })));
    };
    subtableMakers[4] = function makeLookup4(subtable) {
        check.assert(subtable.substFormat === 1, 'Lookup type 4 substFormat must be 1.');
        return new table.Table('substitutionTable', [
            {
                name: 'substFormat',
                type: 'USHORT',
                value: 1
            },
            {
                name: 'coverage',
                type: 'TABLE',
                value: new table.Coverage(subtable.coverage)
            }
        ].concat(table.tableList('ligSet', subtable.ligatureSets, function (ligatureSet) {
            return new table.Table('ligatureSetTable', table.tableList('ligature', ligatureSet, function (ligature) {
                return new table.Table('ligatureTable', [{
                        name: 'ligGlyph',
                        type: 'USHORT',
                        value: ligature.ligGlyph
                    }].concat(table.ushortList('component', ligature.components, ligature.components.length + 1)));
            }));
        })));
    };
    function makeGsubTable(gsub) {
        return new table.Table('GSUB', [
            {
                name: 'version',
                type: 'ULONG',
                value: 65536
            },
            {
                name: 'scripts',
                type: 'TABLE',
                value: new table.ScriptList(gsub.scripts)
            },
            {
                name: 'features',
                type: 'TABLE',
                value: new table.FeatureList(gsub.features)
            },
            {
                name: 'lookups',
                type: 'TABLE',
                value: new table.LookupList(gsub.lookups, subtableMakers)
            }
        ]);
    }
    var gsub = {
        parse: parseGsubTable,
        make: makeGsubTable
    };
    function parseMetaTable(data, start) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseULong();
        check.argument(tableVersion === 1, 'Unsupported META table version.');
        p.parseULong();
        p.parseULong();
        var numDataMaps = p.parseULong();
        var tags = {};
        for (var i = 0; i < numDataMaps; i++) {
            var tag = p.parseTag();
            var dataOffset = p.parseULong();
            var dataLength = p.parseULong();
            var text = decode.UTF8(data, start + dataOffset, dataLength);
            tags[tag] = text;
        }
        return tags;
    }
    function makeMetaTable(tags) {
        var numTags = Object.keys(tags).length;
        var stringPool = '';
        var stringPoolOffset = 16 + numTags * 12;
        var result = new table.Table('meta', [
            {
                name: 'version',
                type: 'ULONG',
                value: 1
            },
            {
                name: 'flags',
                type: 'ULONG',
                value: 0
            },
            {
                name: 'offset',
                type: 'ULONG',
                value: stringPoolOffset
            },
            {
                name: 'numTags',
                type: 'ULONG',
                value: numTags
            }
        ]);
        for (var tag in tags) {
            var pos = stringPool.length;
            stringPool += tags[tag];
            result.fields.push({
                name: 'tag ' + tag,
                type: 'TAG',
                value: tag
            });
            result.fields.push({
                name: 'offset ' + tag,
                type: 'ULONG',
                value: stringPoolOffset + pos
            });
            result.fields.push({
                name: 'length ' + tag,
                type: 'ULONG',
                value: tags[tag].length
            });
        }
        result.fields.push({
            name: 'stringPool',
            type: 'CHARARRAY',
            value: stringPool
        });
        return result;
    }
    var meta = {
        parse: parseMetaTable,
        make: makeMetaTable
    };
    function log2(v) {
        return Math.log(v) / Math.log(2) | 0;
    }
    function computeCheckSum(bytes) {
        while (bytes.length % 4 !== 0) {
            bytes.push(0);
        }
        var sum = 0;
        for (var i = 0; i < bytes.length; i += 4) {
            sum += (bytes[i] << 24) + (bytes[i + 1] << 16) + (bytes[i + 2] << 8) + bytes[i + 3];
        }
        sum %= Math.pow(2, 32);
        return sum;
    }
    function makeTableRecord(tag, checkSum, offset, length) {
        return new table.Record('Table Record', [
            {
                name: 'tag',
                type: 'TAG',
                value: tag !== undefined ? tag : ''
            },
            {
                name: 'checkSum',
                type: 'ULONG',
                value: checkSum !== undefined ? checkSum : 0
            },
            {
                name: 'offset',
                type: 'ULONG',
                value: offset !== undefined ? offset : 0
            },
            {
                name: 'length',
                type: 'ULONG',
                value: length !== undefined ? length : 0
            }
        ]);
    }
    function makeSfntTable(tables) {
        var sfnt = new table.Table('sfnt', [
            {
                name: 'version',
                type: 'TAG',
                value: 'OTTO'
            },
            {
                name: 'numTables',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'searchRange',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'entrySelector',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'rangeShift',
                type: 'USHORT',
                value: 0
            }
        ]);
        sfnt.tables = tables;
        sfnt.numTables = tables.length;
        var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
        sfnt.searchRange = 16 * highestPowerOf2;
        sfnt.entrySelector = log2(highestPowerOf2);
        sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;
        var recordFields = [];
        var tableFields = [];
        var offset = sfnt.sizeOf() + makeTableRecord().sizeOf() * sfnt.numTables;
        while (offset % 4 !== 0) {
            offset += 1;
            tableFields.push({
                name: 'padding',
                type: 'BYTE',
                value: 0
            });
        }
        for (var i = 0; i < tables.length; i += 1) {
            var t = tables[i];
            check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
            var tableLength = t.sizeOf();
            var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
            recordFields.push({
                name: tableRecord.tag + ' Table Record',
                type: 'RECORD',
                value: tableRecord
            });
            tableFields.push({
                name: t.tableName + ' table',
                type: 'RECORD',
                value: t
            });
            offset += tableLength;
            check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
            while (offset % 4 !== 0) {
                offset += 1;
                tableFields.push({
                    name: 'padding',
                    type: 'BYTE',
                    value: 0
                });
            }
        }
        recordFields.sort(function (r1, r2) {
            if (r1.value.tag > r2.value.tag) {
                return 1;
            } else {
                return -1;
            }
        });
        sfnt.fields = sfnt.fields.concat(recordFields);
        sfnt.fields = sfnt.fields.concat(tableFields);
        return sfnt;
    }
    function metricsForChar(font, chars, notFoundMetrics) {
        for (var i = 0; i < chars.length; i += 1) {
            var glyphIndex = font.charToGlyphIndex(chars[i]);
            if (glyphIndex > 0) {
                var glyph = font.glyphs.get(glyphIndex);
                return glyph.getMetrics();
            }
        }
        return notFoundMetrics;
    }
    function average(vs) {
        var sum = 0;
        for (var i = 0; i < vs.length; i += 1) {
            sum += vs[i];
        }
        return sum / vs.length;
    }
    function fontToSfntTable(font) {
        var xMins = [];
        var yMins = [];
        var xMaxs = [];
        var yMaxs = [];
        var advanceWidths = [];
        var leftSideBearings = [];
        var rightSideBearings = [];
        var firstCharIndex;
        var lastCharIndex = 0;
        var ulUnicodeRange1 = 0;
        var ulUnicodeRange2 = 0;
        var ulUnicodeRange3 = 0;
        var ulUnicodeRange4 = 0;
        for (var i = 0; i < font.glyphs.length; i += 1) {
            var glyph = font.glyphs.get(i);
            var unicode = glyph.unicode | 0;
            if (isNaN(glyph.advanceWidth)) {
                throw new Error('Glyph ' + glyph.name + ' (' + i + '): advanceWidth is not a number.');
            }
            if (firstCharIndex > unicode || firstCharIndex === undefined) {
                if (unicode > 0) {
                    firstCharIndex = unicode;
                }
            }
            if (lastCharIndex < unicode) {
                lastCharIndex = unicode;
            }
            var position = os2.getUnicodeRange(unicode);
            if (position < 32) {
                ulUnicodeRange1 |= 1 << position;
            } else if (position < 64) {
                ulUnicodeRange2 |= 1 << position - 32;
            } else if (position < 96) {
                ulUnicodeRange3 |= 1 << position - 64;
            } else if (position < 123) {
                ulUnicodeRange4 |= 1 << position - 96;
            } else {
                throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
            }
            if (glyph.name === '.notdef') {
                continue;
            }
            var metrics = glyph.getMetrics();
            xMins.push(metrics.xMin);
            yMins.push(metrics.yMin);
            xMaxs.push(metrics.xMax);
            yMaxs.push(metrics.yMax);
            leftSideBearings.push(metrics.leftSideBearing);
            rightSideBearings.push(metrics.rightSideBearing);
            advanceWidths.push(glyph.advanceWidth);
        }
        var globals = {
            xMin: Math.min.apply(null, xMins),
            yMin: Math.min.apply(null, yMins),
            xMax: Math.max.apply(null, xMaxs),
            yMax: Math.max.apply(null, yMaxs),
            advanceWidthMax: Math.max.apply(null, advanceWidths),
            advanceWidthAvg: average(advanceWidths),
            minLeftSideBearing: Math.min.apply(null, leftSideBearings),
            maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
            minRightSideBearing: Math.min.apply(null, rightSideBearings)
        };
        globals.ascender = font.ascender;
        globals.descender = font.descender;
        var headTable = head.make({
            flags: 3,
            unitsPerEm: font.unitsPerEm,
            xMin: globals.xMin,
            yMin: globals.yMin,
            xMax: globals.xMax,
            yMax: globals.yMax,
            lowestRecPPEM: 3,
            createdTimestamp: font.createdTimestamp
        });
        var hheaTable = hhea.make({
            ascender: globals.ascender,
            descender: globals.descender,
            advanceWidthMax: globals.advanceWidthMax,
            minLeftSideBearing: globals.minLeftSideBearing,
            minRightSideBearing: globals.minRightSideBearing,
            xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
            numberOfHMetrics: font.glyphs.length
        });
        var maxpTable = maxp.make(font.glyphs.length);
        var os2Table = os2.make({
            xAvgCharWidth: Math.round(globals.advanceWidthAvg),
            usWeightClass: font.tables.os2.usWeightClass,
            usWidthClass: font.tables.os2.usWidthClass,
            usFirstCharIndex: firstCharIndex,
            usLastCharIndex: lastCharIndex,
            ulUnicodeRange1: ulUnicodeRange1,
            ulUnicodeRange2: ulUnicodeRange2,
            ulUnicodeRange3: ulUnicodeRange3,
            ulUnicodeRange4: ulUnicodeRange4,
            fsSelection: font.tables.os2.fsSelection,
            sTypoAscender: globals.ascender,
            sTypoDescender: globals.descender,
            sTypoLineGap: 0,
            usWinAscent: globals.yMax,
            usWinDescent: Math.abs(globals.yMin),
            ulCodePageRange1: 1,
            sxHeight: metricsForChar(font, 'xyvw', { yMax: Math.round(globals.ascender / 2) }).yMax,
            sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
            usDefaultChar: font.hasChar(' ') ? 32 : 0,
            usBreakChar: font.hasChar(' ') ? 32 : 0
        });
        var hmtxTable = hmtx.make(font.glyphs);
        var cmapTable = cmap.make(font.glyphs);
        var englishFamilyName = font.getEnglishName('fontFamily');
        var englishStyleName = font.getEnglishName('fontSubfamily');
        var englishFullName = englishFamilyName + ' ' + englishStyleName;
        var postScriptName = font.getEnglishName('postScriptName');
        if (!postScriptName) {
            postScriptName = englishFamilyName.replace(/\s/g, '') + '-' + englishStyleName;
        }
        var names = {};
        for (var n in font.names) {
            names[n] = font.names[n];
        }
        if (!names.uniqueID) {
            names.uniqueID = { en: font.getEnglishName('manufacturer') + ':' + englishFullName };
        }
        if (!names.postScriptName) {
            names.postScriptName = { en: postScriptName };
        }
        if (!names.preferredFamily) {
            names.preferredFamily = font.names.fontFamily;
        }
        if (!names.preferredSubfamily) {
            names.preferredSubfamily = font.names.fontSubfamily;
        }
        var languageTags = [];
        var nameTable = _name.make(names, languageTags);
        var ltagTable = languageTags.length > 0 ? ltag.make(languageTags) : undefined;
        var postTable = post.make();
        var cffTable = cff.make(font.glyphs, {
            version: font.getEnglishName('version'),
            fullName: englishFullName,
            familyName: englishFamilyName,
            weightName: englishStyleName,
            postScriptName: postScriptName,
            unitsPerEm: font.unitsPerEm,
            fontBBox: [
                0,
                globals.yMin,
                globals.ascender,
                globals.advanceWidthMax
            ]
        });
        var metaTable = font.metas && Object.keys(font.metas).length > 0 ? meta.make(font.metas) : undefined;
        var tables = [
            headTable,
            hheaTable,
            maxpTable,
            os2Table,
            nameTable,
            cmapTable,
            postTable,
            cffTable,
            hmtxTable
        ];
        if (ltagTable) {
            tables.push(ltagTable);
        }
        if (font.tables.gsub) {
            tables.push(gsub.make(font.tables.gsub));
        }
        if (metaTable) {
            tables.push(metaTable);
        }
        var sfntTable = makeSfntTable(tables);
        var bytes = sfntTable.encode();
        var checkSum = computeCheckSum(bytes);
        var tableFields = sfntTable.fields;
        var checkSumAdjusted = false;
        for (var i$1 = 0; i$1 < tableFields.length; i$1 += 1) {
            if (tableFields[i$1].name === 'head table') {
                tableFields[i$1].value.checkSumAdjustment = 2981146554 - checkSum;
                checkSumAdjusted = true;
                break;
            }
        }
        if (!checkSumAdjusted) {
            throw new Error('Could not find head table with checkSum to adjust.');
        }
        return sfntTable;
    }
    var sfnt = {
        make: makeSfntTable,
        fontToTable: fontToSfntTable,
        computeCheckSum: computeCheckSum
    };
    function searchTag(arr, tag) {
        var imin = 0;
        var imax = arr.length - 1;
        while (imin <= imax) {
            var imid = imin + imax >>> 1;
            var val = arr[imid].tag;
            if (val === tag) {
                return imid;
            } else if (val < tag) {
                imin = imid + 1;
            } else {
                imax = imid - 1;
            }
        }
        return -imin - 1;
    }
    function binSearch(arr, value) {
        var imin = 0;
        var imax = arr.length - 1;
        while (imin <= imax) {
            var imid = imin + imax >>> 1;
            var val = arr[imid];
            if (val === value) {
                return imid;
            } else if (val < value) {
                imin = imid + 1;
            } else {
                imax = imid - 1;
            }
        }
        return -imin - 1;
    }
    function searchRange(ranges, value) {
        var range;
        var imin = 0;
        var imax = ranges.length - 1;
        while (imin <= imax) {
            var imid = imin + imax >>> 1;
            range = ranges[imid];
            var start = range.start;
            if (start === value) {
                return range;
            } else if (start < value) {
                imin = imid + 1;
            } else {
                imax = imid - 1;
            }
        }
        if (imin > 0) {
            range = ranges[imin - 1];
            if (value > range.end) {
                return 0;
            }
            return range;
        }
    }
    function Layout(font, tableName) {
        this.font = font;
        this.tableName = tableName;
    }
    Layout.prototype = {
        searchTag: searchTag,
        binSearch: binSearch,
        getTable: function (create) {
            var layout = this.font.tables[this.tableName];
            if (!layout && create) {
                layout = this.font.tables[this.tableName] = this.createDefaultTable();
            }
            return layout;
        },
        getScriptNames: function () {
            var layout = this.getTable();
            if (!layout) {
                return [];
            }
            return layout.scripts.map(function (script) {
                return script.tag;
            });
        },
        getDefaultScriptName: function () {
            var layout = this.getTable();
            if (!layout) {
                return;
            }
            var hasLatn = false;
            for (var i = 0; i < layout.scripts.length; i++) {
                var name = layout.scripts[i].tag;
                if (name === 'DFLT') {
                    return name;
                }
                if (name === 'latn') {
                    hasLatn = true;
                }
            }
            if (hasLatn) {
                return 'latn';
            }
        },
        getScriptTable: function (script, create) {
            var layout = this.getTable(create);
            if (layout) {
                script = script || 'DFLT';
                var scripts = layout.scripts;
                var pos = searchTag(layout.scripts, script);
                if (pos >= 0) {
                    return scripts[pos].script;
                } else if (create) {
                    var scr = {
                        tag: script,
                        script: {
                            defaultLangSys: {
                                reserved: 0,
                                reqFeatureIndex: 65535,
                                featureIndexes: []
                            },
                            langSysRecords: []
                        }
                    };
                    scripts.splice(-1 - pos, 0, scr);
                    return scr.script;
                }
            }
        },
        getLangSysTable: function (script, language, create) {
            var scriptTable = this.getScriptTable(script, create);
            if (scriptTable) {
                if (!language || language === 'dflt' || language === 'DFLT') {
                    return scriptTable.defaultLangSys;
                }
                var pos = searchTag(scriptTable.langSysRecords, language);
                if (pos >= 0) {
                    return scriptTable.langSysRecords[pos].langSys;
                } else if (create) {
                    var langSysRecord = {
                        tag: language,
                        langSys: {
                            reserved: 0,
                            reqFeatureIndex: 65535,
                            featureIndexes: []
                        }
                    };
                    scriptTable.langSysRecords.splice(-1 - pos, 0, langSysRecord);
                    return langSysRecord.langSys;
                }
            }
        },
        getFeatureTable: function (script, language, feature, create) {
            var langSysTable = this.getLangSysTable(script, language, create);
            if (langSysTable) {
                var featureRecord;
                var featIndexes = langSysTable.featureIndexes;
                var allFeatures = this.font.tables[this.tableName].features;
                for (var i = 0; i < featIndexes.length; i++) {
                    featureRecord = allFeatures[featIndexes[i]];
                    if (featureRecord.tag === feature) {
                        return featureRecord.feature;
                    }
                }
                if (create) {
                    var index = allFeatures.length;
                    check.assert(index === 0 || feature >= allFeatures[index - 1].tag, 'Features must be added in alphabetical order.');
                    featureRecord = {
                        tag: feature,
                        feature: {
                            params: 0,
                            lookupListIndexes: []
                        }
                    };
                    allFeatures.push(featureRecord);
                    featIndexes.push(index);
                    return featureRecord.feature;
                }
            }
        },
        getLookupTables: function (script, language, feature, lookupType, create) {
            var featureTable = this.getFeatureTable(script, language, feature, create);
            var tables = [];
            if (featureTable) {
                var lookupTable;
                var lookupListIndexes = featureTable.lookupListIndexes;
                var allLookups = this.font.tables[this.tableName].lookups;
                for (var i = 0; i < lookupListIndexes.length; i++) {
                    lookupTable = allLookups[lookupListIndexes[i]];
                    if (lookupTable.lookupType === lookupType) {
                        tables.push(lookupTable);
                    }
                }
                if (tables.length === 0 && create) {
                    lookupTable = {
                        lookupType: lookupType,
                        lookupFlag: 0,
                        subtables: [],
                        markFilteringSet: undefined
                    };
                    var index = allLookups.length;
                    allLookups.push(lookupTable);
                    lookupListIndexes.push(index);
                    return [lookupTable];
                }
            }
            return tables;
        },
        getGlyphClass: function (classDefTable, glyphIndex) {
            switch (classDefTable.format) {
            case 1:
                if (classDefTable.startGlyph <= glyphIndex && glyphIndex < classDefTable.startGlyph + classDefTable.classes.length) {
                    return classDefTable.classes[glyphIndex - classDefTable.startGlyph];
                }
                return 0;
            case 2:
                var range = searchRange(classDefTable.ranges, glyphIndex);
                return range ? range.classId : 0;
            }
        },
        getCoverageIndex: function (coverageTable, glyphIndex) {
            switch (coverageTable.format) {
            case 1:
                var index = binSearch(coverageTable.glyphs, glyphIndex);
                return index >= 0 ? index : -1;
            case 2:
                var range = searchRange(coverageTable.ranges, glyphIndex);
                return range ? range.index + glyphIndex - range.start : -1;
            }
        },
        expandCoverage: function (coverageTable) {
            if (coverageTable.format === 1) {
                return coverageTable.glyphs;
            } else {
                var glyphs = [];
                var ranges = coverageTable.ranges;
                for (var i = 0; i < ranges.length; i++) {
                    var range = ranges[i];
                    var start = range.start;
                    var end = range.end;
                    for (var j = start; j <= end; j++) {
                        glyphs.push(j);
                    }
                }
                return glyphs;
            }
        }
    };
    function Position(font) {
        Layout.call(this, font, 'gpos');
    }
    Position.prototype = Layout.prototype;
    Position.prototype.init = function () {
        var script = this.getDefaultScriptName();
        this.defaultKerningTables = this.getKerningTables(script);
    };
    Position.prototype.getKerningValue = function (kerningLookups, leftIndex, rightIndex) {
        var this$1 = this;
        for (var i = 0; i < kerningLookups.length; i++) {
            var subtables = kerningLookups[i].subtables;
            for (var j = 0; j < subtables.length; j++) {
                var subtable = subtables[j];
                var covIndex = this$1.getCoverageIndex(subtable.coverage, leftIndex);
                if (covIndex < 0) {
                    continue;
                }
                switch (subtable.posFormat) {
                case 1:
                    var pairSet = subtable.pairSets[covIndex];
                    for (var k = 0; k < pairSet.length; k++) {
                        var pair = pairSet[k];
                        if (pair.secondGlyph === rightIndex) {
                            return pair.value1 && pair.value1.xAdvance || 0;
                        }
                    }
                    break;
                case 2:
                    var class1 = this$1.getGlyphClass(subtable.classDef1, leftIndex);
                    var class2 = this$1.getGlyphClass(subtable.classDef2, rightIndex);
                    var pair$1 = subtable.classRecords[class1][class2];
                    return pair$1.value1 && pair$1.value1.xAdvance || 0;
                }
            }
        }
        return 0;
    };
    Position.prototype.getKerningTables = function (script, language) {
        if (this.font.tables.gpos) {
            return this.getLookupTables(script, language, 'kern', 2);
        }
    };
    function Substitution(font) {
        Layout.call(this, font, 'gsub');
    }
    function arraysEqual(ar1, ar2) {
        var n = ar1.length;
        if (n !== ar2.length) {
            return false;
        }
        for (var i = 0; i < n; i++) {
            if (ar1[i] !== ar2[i]) {
                return false;
            }
        }
        return true;
    }
    function getSubstFormat(lookupTable, format, defaultSubtable) {
        var subtables = lookupTable.subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            if (subtable.substFormat === format) {
                return subtable;
            }
        }
        if (defaultSubtable) {
            subtables.push(defaultSubtable);
            return defaultSubtable;
        }
        return undefined;
    }
    Substitution.prototype = Layout.prototype;
    Substitution.prototype.createDefaultTable = function () {
        return {
            version: 1,
            scripts: [{
                    tag: 'DFLT',
                    script: {
                        defaultLangSys: {
                            reserved: 0,
                            reqFeatureIndex: 65535,
                            featureIndexes: []
                        },
                        langSysRecords: []
                    }
                }],
            features: [],
            lookups: []
        };
    };
    Substitution.prototype.getSingle = function (feature, script, language) {
        var this$1 = this;
        var substitutions = [];
        var lookupTables = this.getLookupTables(script, language, feature, 1);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this$1.expandCoverage(subtable.coverage);
                var j = void 0;
                if (subtable.substFormat === 1) {
                    var delta = subtable.deltaGlyphId;
                    for (j = 0; j < glyphs.length; j++) {
                        var glyph = glyphs[j];
                        substitutions.push({
                            sub: glyph,
                            by: glyph + delta
                        });
                    }
                } else {
                    var substitute = subtable.substitute;
                    for (j = 0; j < glyphs.length; j++) {
                        substitutions.push({
                            sub: glyphs[j],
                            by: substitute[j]
                        });
                    }
                }
            }
        }
        return substitutions;
    };
    Substitution.prototype.getAlternates = function (feature, script, language) {
        var this$1 = this;
        var alternates = [];
        var lookupTables = this.getLookupTables(script, language, feature, 3);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this$1.expandCoverage(subtable.coverage);
                var alternateSets = subtable.alternateSets;
                for (var j = 0; j < glyphs.length; j++) {
                    alternates.push({
                        sub: glyphs[j],
                        by: alternateSets[j]
                    });
                }
            }
        }
        return alternates;
    };
    Substitution.prototype.getLigatures = function (feature, script, language) {
        var this$1 = this;
        var ligatures = [];
        var lookupTables = this.getLookupTables(script, language, feature, 4);
        for (var idx = 0; idx < lookupTables.length; idx++) {
            var subtables = lookupTables[idx].subtables;
            for (var i = 0; i < subtables.length; i++) {
                var subtable = subtables[i];
                var glyphs = this$1.expandCoverage(subtable.coverage);
                var ligatureSets = subtable.ligatureSets;
                for (var j = 0; j < glyphs.length; j++) {
                    var startGlyph = glyphs[j];
                    var ligSet = ligatureSets[j];
                    for (var k = 0; k < ligSet.length; k++) {
                        var lig = ligSet[k];
                        ligatures.push({
                            sub: [startGlyph].concat(lig.components),
                            by: lig.ligGlyph
                        });
                    }
                }
            }
        }
        return ligatures;
    };
    Substitution.prototype.addSingle = function (feature, substitution, script, language) {
        var lookupTable = this.getLookupTables(script, language, feature, 1, true)[0];
        var subtable = getSubstFormat(lookupTable, 2, {
            substFormat: 2,
            coverage: {
                format: 1,
                glyphs: []
            },
            substitute: []
        });
        check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = substitution.sub;
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos < 0) {
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.substitute.splice(pos, 0, 0);
        }
        subtable.substitute[pos] = substitution.by;
    };
    Substitution.prototype.addAlternate = function (feature, substitution, script, language) {
        var lookupTable = this.getLookupTables(script, language, feature, 3, true)[0];
        var subtable = getSubstFormat(lookupTable, 1, {
            substFormat: 1,
            coverage: {
                format: 1,
                glyphs: []
            },
            alternateSets: []
        });
        check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = substitution.sub;
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos < 0) {
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.alternateSets.splice(pos, 0, 0);
        }
        subtable.alternateSets[pos] = substitution.by;
    };
    Substitution.prototype.addLigature = function (feature, ligature, script, language) {
        var lookupTable = this.getLookupTables(script, language, feature, 4, true)[0];
        var subtable = lookupTable.subtables[0];
        if (!subtable) {
            subtable = {
                substFormat: 1,
                coverage: {
                    format: 1,
                    glyphs: []
                },
                ligatureSets: []
            };
            lookupTable.subtables[0] = subtable;
        }
        check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
        var coverageGlyph = ligature.sub[0];
        var ligComponents = ligature.sub.slice(1);
        var ligatureTable = {
            ligGlyph: ligature.by,
            components: ligComponents
        };
        var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
        if (pos >= 0) {
            var ligatureSet = subtable.ligatureSets[pos];
            for (var i = 0; i < ligatureSet.length; i++) {
                if (arraysEqual(ligatureSet[i].components, ligComponents)) {
                    return;
                }
            }
            ligatureSet.push(ligatureTable);
        } else {
            pos = -1 - pos;
            subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
            subtable.ligatureSets.splice(pos, 0, [ligatureTable]);
        }
    };
    Substitution.prototype.getFeature = function (feature, script, language) {
        if (/ss\d\d/.test(feature)) {
            return this.getSingle(feature, script, language);
        }
        switch (feature) {
        case 'aalt':
        case 'salt':
            return this.getSingle(feature, script, language).concat(this.getAlternates(feature, script, language));
        case 'dlig':
        case 'liga':
        case 'rlig':
            return this.getLigatures(feature, script, language);
        }
        return undefined;
    };
    Substitution.prototype.add = function (feature, sub, script, language) {
        if (/ss\d\d/.test(feature)) {
            return this.addSingle(feature, sub, script, language);
        }
        switch (feature) {
        case 'aalt':
        case 'salt':
            if (typeof sub.by === 'number') {
                return this.addSingle(feature, sub, script, language);
            }
            return this.addAlternate(feature, sub, script, language);
        case 'dlig':
        case 'liga':
        case 'rlig':
            return this.addLigature(feature, sub, script, language);
        }
        return undefined;
    };
    function isBrowser() {
        return typeof window !== 'undefined';
    }
    function nodeBufferToArrayBuffer(buffer) {
        var ab = new ArrayBuffer(buffer.length);
        var view = new Uint8Array(ab);
        for (var i = 0; i < buffer.length; ++i) {
            view[i] = buffer[i];
        }
        return ab;
    }
    function arrayBufferToNodeBuffer(ab) {
        var buffer = new Buffer(ab.byteLength);
        var view = new Uint8Array(ab);
        for (var i = 0; i < buffer.length; ++i) {
            buffer[i] = view[i];
        }
        return buffer;
    }
    function checkArgument(expression, message) {
        if (!expression) {
            throw message;
        }
    }
    function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
        var v;
        if ((flag & shortVectorBitMask) > 0) {
            v = p.parseByte();
            if ((flag & sameBitMask) === 0) {
                v = -v;
            }
            v = previousValue + v;
        } else {
            if ((flag & sameBitMask) > 0) {
                v = previousValue;
            } else {
                v = previousValue + p.parseShort();
            }
        }
        return v;
    }
    function parseGlyph(glyph, data, start) {
        var p = new parse.Parser(data, start);
        glyph.numberOfContours = p.parseShort();
        glyph._xMin = p.parseShort();
        glyph._yMin = p.parseShort();
        glyph._xMax = p.parseShort();
        glyph._yMax = p.parseShort();
        var flags;
        var flag;
        if (glyph.numberOfContours > 0) {
            var endPointIndices = glyph.endPointIndices = [];
            for (var i = 0; i < glyph.numberOfContours; i += 1) {
                endPointIndices.push(p.parseUShort());
            }
            glyph.instructionLength = p.parseUShort();
            glyph.instructions = [];
            for (var i$1 = 0; i$1 < glyph.instructionLength; i$1 += 1) {
                glyph.instructions.push(p.parseByte());
            }
            var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
            flags = [];
            for (var i$2 = 0; i$2 < numberOfCoordinates; i$2 += 1) {
                flag = p.parseByte();
                flags.push(flag);
                if ((flag & 8) > 0) {
                    var repeatCount = p.parseByte();
                    for (var j = 0; j < repeatCount; j += 1) {
                        flags.push(flag);
                        i$2 += 1;
                    }
                }
            }
            check.argument(flags.length === numberOfCoordinates, 'Bad flags.');
            if (endPointIndices.length > 0) {
                var points = [];
                var point;
                if (numberOfCoordinates > 0) {
                    for (var i$3 = 0; i$3 < numberOfCoordinates; i$3 += 1) {
                        flag = flags[i$3];
                        point = {};
                        point.onCurve = !!(flag & 1);
                        point.lastPointOfContour = endPointIndices.indexOf(i$3) >= 0;
                        points.push(point);
                    }
                    var px = 0;
                    for (var i$4 = 0; i$4 < numberOfCoordinates; i$4 += 1) {
                        flag = flags[i$4];
                        point = points[i$4];
                        point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
                        px = point.x;
                    }
                    var py = 0;
                    for (var i$5 = 0; i$5 < numberOfCoordinates; i$5 += 1) {
                        flag = flags[i$5];
                        point = points[i$5];
                        point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
                        py = point.y;
                    }
                }
                glyph.points = points;
            } else {
                glyph.points = [];
            }
        } else if (glyph.numberOfContours === 0) {
            glyph.points = [];
        } else {
            glyph.isComposite = true;
            glyph.points = [];
            glyph.components = [];
            var moreComponents = true;
            while (moreComponents) {
                flags = p.parseUShort();
                var component = {
                    glyphIndex: p.parseUShort(),
                    xScale: 1,
                    scale01: 0,
                    scale10: 0,
                    yScale: 1,
                    dx: 0,
                    dy: 0
                };
                if ((flags & 1) > 0) {
                    if ((flags & 2) > 0) {
                        component.dx = p.parseShort();
                        component.dy = p.parseShort();
                    } else {
                        component.matchedPoints = [
                            p.parseUShort(),
                            p.parseUShort()
                        ];
                    }
                } else {
                    if ((flags & 2) > 0) {
                        component.dx = p.parseChar();
                        component.dy = p.parseChar();
                    } else {
                        component.matchedPoints = [
                            p.parseByte(),
                            p.parseByte()
                        ];
                    }
                }
                if ((flags & 8) > 0) {
                    component.xScale = component.yScale = p.parseF2Dot14();
                } else if ((flags & 64) > 0) {
                    component.xScale = p.parseF2Dot14();
                    component.yScale = p.parseF2Dot14();
                } else if ((flags & 128) > 0) {
                    component.xScale = p.parseF2Dot14();
                    component.scale01 = p.parseF2Dot14();
                    component.scale10 = p.parseF2Dot14();
                    component.yScale = p.parseF2Dot14();
                }
                glyph.components.push(component);
                moreComponents = !!(flags & 32);
            }
            if (flags & 256) {
                glyph.instructionLength = p.parseUShort();
                glyph.instructions = [];
                for (var i$6 = 0; i$6 < glyph.instructionLength; i$6 += 1) {
                    glyph.instructions.push(p.parseByte());
                }
            }
        }
    }
    function transformPoints(points, transform) {
        var newPoints = [];
        for (var i = 0; i < points.length; i += 1) {
            var pt = points[i];
            var newPt = {
                x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
                y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
                onCurve: pt.onCurve,
                lastPointOfContour: pt.lastPointOfContour
            };
            newPoints.push(newPt);
        }
        return newPoints;
    }
    function getContours(points) {
        var contours = [];
        var currentContour = [];
        for (var i = 0; i < points.length; i += 1) {
            var pt = points[i];
            currentContour.push(pt);
            if (pt.lastPointOfContour) {
                contours.push(currentContour);
                currentContour = [];
            }
        }
        check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
        return contours;
    }
    function getPath(points) {
        var p = new Path();
        if (!points) {
            return p;
        }
        var contours = getContours(points);
        for (var contourIndex = 0; contourIndex < contours.length; ++contourIndex) {
            var contour = contours[contourIndex];
            var prev = null;
            var curr = contour[contour.length - 1];
            var next = contour[0];
            if (curr.onCurve) {
                p.moveTo(curr.x, curr.y);
            } else {
                if (next.onCurve) {
                    p.moveTo(next.x, next.y);
                } else {
                    var start = {
                        x: (curr.x + next.x) * 0.5,
                        y: (curr.y + next.y) * 0.5
                    };
                    p.moveTo(start.x, start.y);
                }
            }
            for (var i = 0; i < contour.length; ++i) {
                prev = curr;
                curr = next;
                next = contour[(i + 1) % contour.length];
                if (curr.onCurve) {
                    p.lineTo(curr.x, curr.y);
                } else {
                    var prev2 = prev;
                    var next2 = next;
                    if (!prev.onCurve) {
                        prev2 = {
                            x: (curr.x + prev.x) * 0.5,
                            y: (curr.y + prev.y) * 0.5
                        };
                    }
                    if (!next.onCurve) {
                        next2 = {
                            x: (curr.x + next.x) * 0.5,
                            y: (curr.y + next.y) * 0.5
                        };
                    }
                    p.quadraticCurveTo(curr.x, curr.y, next2.x, next2.y);
                }
            }
            p.closePath();
        }
        return p;
    }
    function buildPath(glyphs, glyph) {
        if (glyph.isComposite) {
            for (var j = 0; j < glyph.components.length; j += 1) {
                var component = glyph.components[j];
                var componentGlyph = glyphs.get(component.glyphIndex);
                componentGlyph.getPath();
                if (componentGlyph.points) {
                    var transformedPoints = void 0;
                    if (component.matchedPoints === undefined) {
                        transformedPoints = transformPoints(componentGlyph.points, component);
                    } else {
                        if (component.matchedPoints[0] > glyph.points.length - 1 || component.matchedPoints[1] > componentGlyph.points.length - 1) {
                            throw Error('Matched points out of range in ' + glyph.name);
                        }
                        var firstPt = glyph.points[component.matchedPoints[0]];
                        var secondPt = componentGlyph.points[component.matchedPoints[1]];
                        var transform = {
                            xScale: component.xScale,
                            scale01: component.scale01,
                            scale10: component.scale10,
                            yScale: component.yScale,
                            dx: 0,
                            dy: 0
                        };
                        secondPt = transformPoints([secondPt], transform)[0];
                        transform.dx = firstPt.x - secondPt.x;
                        transform.dy = firstPt.y - secondPt.y;
                        transformedPoints = transformPoints(componentGlyph.points, transform);
                    }
                    glyph.points = glyph.points.concat(transformedPoints);
                }
            }
        }
        return getPath(glyph.points);
    }
    function parseGlyfTable(data, start, loca, font) {
        var glyphs = new glyphset.GlyphSet(font);
        for (var i = 0; i < loca.length - 1; i += 1) {
            var offset = loca[i];
            var nextOffset = loca[i + 1];
            if (offset !== nextOffset) {
                glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
            } else {
                glyphs.push(i, glyphset.glyphLoader(font, i));
            }
        }
        return glyphs;
    }
    var glyf = {
        getPath: getPath,
        parse: parseGlyfTable
    };
    var instructionTable;
    var exec;
    var execGlyph;
    var execComponent;
    function Hinting(font) {
        this.font = font;
        this.getCommands = function (hPoints) {
            return glyf.getPath(hPoints).commands;
        };
        this._fpgmState = this._prepState = undefined;
        this._errorState = 0;
    }
    function roundOff(v) {
        return v;
    }
    function roundToGrid(v) {
        return Math.sign(v) * Math.round(Math.abs(v));
    }
    function roundToDoubleGrid(v) {
        return Math.sign(v) * Math.round(Math.abs(v * 2)) / 2;
    }
    function roundToHalfGrid(v) {
        return Math.sign(v) * (Math.round(Math.abs(v) + 0.5) - 0.5);
    }
    function roundUpToGrid(v) {
        return Math.sign(v) * Math.ceil(Math.abs(v));
    }
    function roundDownToGrid(v) {
        return Math.sign(v) * Math.floor(Math.abs(v));
    }
    var roundSuper = function (v) {
        var period = this.srPeriod;
        var phase = this.srPhase;
        var threshold = this.srThreshold;
        var sign = 1;
        if (v < 0) {
            v = -v;
            sign = -1;
        }
        v += threshold - phase;
        v = Math.trunc(v / period) * period;
        v += phase;
        if (v < 0) {
            return phase * sign;
        }
        return v * sign;
    };
    var xUnitVector = {
        x: 1,
        y: 0,
        axis: 'x',
        distance: function (p1, p2, o1, o2) {
            return (o1 ? p1.xo : p1.x) - (o2 ? p2.xo : p2.x);
        },
        interpolate: function (p, rp1, rp2, pv) {
            var do1;
            var do2;
            var doa1;
            var doa2;
            var dm1;
            var dm2;
            var dt;
            if (!pv || pv === this) {
                do1 = p.xo - rp1.xo;
                do2 = p.xo - rp2.xo;
                dm1 = rp1.x - rp1.xo;
                dm2 = rp2.x - rp2.xo;
                doa1 = Math.abs(do1);
                doa2 = Math.abs(do2);
                dt = doa1 + doa2;
                if (dt === 0) {
                    p.x = p.xo + (dm1 + dm2) / 2;
                    return;
                }
                p.x = p.xo + (dm1 * doa2 + dm2 * doa1) / dt;
                return;
            }
            do1 = pv.distance(p, rp1, true, true);
            do2 = pv.distance(p, rp2, true, true);
            dm1 = pv.distance(rp1, rp1, false, true);
            dm2 = pv.distance(rp2, rp2, false, true);
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;
            if (dt === 0) {
                xUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
                return;
            }
            xUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
        },
        normalSlope: Number.NEGATIVE_INFINITY,
        setRelative: function (p, rp, d, pv, org) {
            if (!pv || pv === this) {
                p.x = (org ? rp.xo : rp.x) + d;
                return;
            }
            var rpx = org ? rp.xo : rp.x;
            var rpy = org ? rp.yo : rp.y;
            var rpdx = rpx + d * pv.x;
            var rpdy = rpy + d * pv.y;
            p.x = rpdx + (p.y - rpdy) / pv.normalSlope;
        },
        slope: 0,
        touch: function (p) {
            p.xTouched = true;
        },
        touched: function (p) {
            return p.xTouched;
        },
        untouch: function (p) {
            p.xTouched = false;
        }
    };
    var yUnitVector = {
        x: 0,
        y: 1,
        axis: 'y',
        distance: function (p1, p2, o1, o2) {
            return (o1 ? p1.yo : p1.y) - (o2 ? p2.yo : p2.y);
        },
        interpolate: function (p, rp1, rp2, pv) {
            var do1;
            var do2;
            var doa1;
            var doa2;
            var dm1;
            var dm2;
            var dt;
            if (!pv || pv === this) {
                do1 = p.yo - rp1.yo;
                do2 = p.yo - rp2.yo;
                dm1 = rp1.y - rp1.yo;
                dm2 = rp2.y - rp2.yo;
                doa1 = Math.abs(do1);
                doa2 = Math.abs(do2);
                dt = doa1 + doa2;
                if (dt === 0) {
                    p.y = p.yo + (dm1 + dm2) / 2;
                    return;
                }
                p.y = p.yo + (dm1 * doa2 + dm2 * doa1) / dt;
                return;
            }
            do1 = pv.distance(p, rp1, true, true);
            do2 = pv.distance(p, rp2, true, true);
            dm1 = pv.distance(rp1, rp1, false, true);
            dm2 = pv.distance(rp2, rp2, false, true);
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;
            if (dt === 0) {
                yUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
                return;
            }
            yUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
        },
        normalSlope: 0,
        setRelative: function (p, rp, d, pv, org) {
            if (!pv || pv === this) {
                p.y = (org ? rp.yo : rp.y) + d;
                return;
            }
            var rpx = org ? rp.xo : rp.x;
            var rpy = org ? rp.yo : rp.y;
            var rpdx = rpx + d * pv.x;
            var rpdy = rpy + d * pv.y;
            p.y = rpdy + pv.normalSlope * (p.x - rpdx);
        },
        slope: Number.POSITIVE_INFINITY,
        touch: function (p) {
            p.yTouched = true;
        },
        touched: function (p) {
            return p.yTouched;
        },
        untouch: function (p) {
            p.yTouched = false;
        }
    };
    Object.freeze(xUnitVector);
    Object.freeze(yUnitVector);
    function UnitVector(x, y) {
        this.x = x;
        this.y = y;
        this.axis = undefined;
        this.slope = y / x;
        this.normalSlope = -x / y;
        Object.freeze(this);
    }
    UnitVector.prototype.distance = function (p1, p2, o1, o2) {
        return this.x * xUnitVector.distance(p1, p2, o1, o2) + this.y * yUnitVector.distance(p1, p2, o1, o2);
    };
    UnitVector.prototype.interpolate = function (p, rp1, rp2, pv) {
        var dm1;
        var dm2;
        var do1;
        var do2;
        var doa1;
        var doa2;
        var dt;
        do1 = pv.distance(p, rp1, true, true);
        do2 = pv.distance(p, rp2, true, true);
        dm1 = pv.distance(rp1, rp1, false, true);
        dm2 = pv.distance(rp2, rp2, false, true);
        doa1 = Math.abs(do1);
        doa2 = Math.abs(do2);
        dt = doa1 + doa2;
        if (dt === 0) {
            this.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
            return;
        }
        this.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
    };
    UnitVector.prototype.setRelative = function (p, rp, d, pv, org) {
        pv = pv || this;
        var rpx = org ? rp.xo : rp.x;
        var rpy = org ? rp.yo : rp.y;
        var rpdx = rpx + d * pv.x;
        var rpdy = rpy + d * pv.y;
        var pvns = pv.normalSlope;
        var fvs = this.slope;
        var px = p.x;
        var py = p.y;
        p.x = (fvs * px - pvns * rpdx + rpdy - py) / (fvs - pvns);
        p.y = fvs * (p.x - px) + py;
    };
    UnitVector.prototype.touch = function (p) {
        p.xTouched = true;
        p.yTouched = true;
    };
    function getUnitVector(x, y) {
        var d = Math.sqrt(x * x + y * y);
        x /= d;
        y /= d;
        if (x === 1 && y === 0) {
            return xUnitVector;
        } else if (x === 0 && y === 1) {
            return yUnitVector;
        } else {
            return new UnitVector(x, y);
        }
    }
    function HPoint(x, y, lastPointOfContour, onCurve) {
        this.x = this.xo = Math.round(x * 64) / 64;
        this.y = this.yo = Math.round(y * 64) / 64;
        this.lastPointOfContour = lastPointOfContour;
        this.onCurve = onCurve;
        this.prevPointOnContour = undefined;
        this.nextPointOnContour = undefined;
        this.xTouched = false;
        this.yTouched = false;
        Object.preventExtensions(this);
    }
    HPoint.prototype.nextTouched = function (v) {
        var p = this.nextPointOnContour;
        while (!v.touched(p) && p !== this) {
            p = p.nextPointOnContour;
        }
        return p;
    };
    HPoint.prototype.prevTouched = function (v) {
        var p = this.prevPointOnContour;
        while (!v.touched(p) && p !== this) {
            p = p.prevPointOnContour;
        }
        return p;
    };
    var HPZero = Object.freeze(new HPoint(0, 0));
    var defaultState = {
        cvCutIn: 17 / 16,
        deltaBase: 9,
        deltaShift: 0.125,
        loop: 1,
        minDis: 1,
        autoFlip: true
    };
    function State(env, prog) {
        this.env = env;
        this.stack = [];
        this.prog = prog;
        switch (env) {
        case 'glyf':
            this.zp0 = this.zp1 = this.zp2 = 1;
            this.rp0 = this.rp1 = this.rp2 = 0;
        case 'prep':
            this.fv = this.pv = this.dpv = xUnitVector;
            this.round = roundToGrid;
        }
    }
    Hinting.prototype.exec = function (glyph, ppem) {
        if (typeof ppem !== 'number') {
            throw new Error('Point size is not a number!');
        }
        if (this._errorState > 2) {
            return;
        }
        var font = this.font;
        var prepState = this._prepState;
        if (!prepState || prepState.ppem !== ppem) {
            var fpgmState = this._fpgmState;
            if (!fpgmState) {
                State.prototype = defaultState;
                fpgmState = this._fpgmState = new State('fpgm', font.tables.fpgm);
                fpgmState.funcs = [];
                fpgmState.font = font;
                if (exports.DEBUG) {
                    console.log('---EXEC FPGM---');
                    fpgmState.step = -1;
                }
                try {
                    exec(fpgmState);
                } catch (e) {
                    console.log('Hinting error in FPGM:' + e);
                    this._errorState = 3;
                    return;
                }
            }
            State.prototype = fpgmState;
            prepState = this._prepState = new State('prep', font.tables.prep);
            prepState.ppem = ppem;
            var oCvt = font.tables.cvt;
            if (oCvt) {
                var cvt = prepState.cvt = new Array(oCvt.length);
                var scale = ppem / font.unitsPerEm;
                for (var c = 0; c < oCvt.length; c++) {
                    cvt[c] = oCvt[c] * scale;
                }
            } else {
                prepState.cvt = [];
            }
            if (exports.DEBUG) {
                console.log('---EXEC PREP---');
                prepState.step = -1;
            }
            try {
                exec(prepState);
            } catch (e) {
                if (this._errorState < 2) {
                    console.log('Hinting error in PREP:' + e);
                }
                this._errorState = 2;
            }
        }
        if (this._errorState > 1) {
            return;
        }
        try {
            return execGlyph(glyph, prepState);
        } catch (e) {
            if (this._errorState < 1) {
                console.log('Hinting error:' + e);
                console.log('Note: further hinting errors are silenced');
            }
            this._errorState = 1;
            return undefined;
        }
    };
    execGlyph = function (glyph, prepState) {
        var xScale = prepState.ppem / prepState.font.unitsPerEm;
        var yScale = xScale;
        var components = glyph.components;
        var contours;
        var gZone;
        var state;
        State.prototype = prepState;
        if (!components) {
            state = new State('glyf', glyph.instructions);
            if (exports.DEBUG) {
                console.log('---EXEC GLYPH---');
                state.step = -1;
            }
            execComponent(glyph, state, xScale, yScale);
            gZone = state.gZone;
        } else {
            var font = prepState.font;
            gZone = [];
            contours = [];
            for (var i = 0; i < components.length; i++) {
                var c = components[i];
                var cg = font.glyphs.get(c.glyphIndex);
                state = new State('glyf', cg.instructions);
                if (exports.DEBUG) {
                    console.log('---EXEC COMP ' + i + '---');
                    state.step = -1;
                }
                execComponent(cg, state, xScale, yScale);
                var dx = Math.round(c.dx * xScale);
                var dy = Math.round(c.dy * yScale);
                var gz = state.gZone;
                var cc = state.contours;
                for (var pi = 0; pi < gz.length; pi++) {
                    var p = gz[pi];
                    p.xTouched = p.yTouched = false;
                    p.xo = p.x = p.x + dx;
                    p.yo = p.y = p.y + dy;
                }
                var gLen = gZone.length;
                gZone.push.apply(gZone, gz);
                for (var j = 0; j < cc.length; j++) {
                    contours.push(cc[j] + gLen);
                }
            }
            if (glyph.instructions && !state.inhibitGridFit) {
                state = new State('glyf', glyph.instructions);
                state.gZone = state.z0 = state.z1 = state.z2 = gZone;
                state.contours = contours;
                gZone.push(new HPoint(0, 0), new HPoint(Math.round(glyph.advanceWidth * xScale), 0));
                if (exports.DEBUG) {
                    console.log('---EXEC COMPOSITE---');
                    state.step = -1;
                }
                exec(state);
                gZone.length -= 2;
            }
        }
        return gZone;
    };
    execComponent = function (glyph, state, xScale, yScale) {
        var points = glyph.points || [];
        var pLen = points.length;
        var gZone = state.gZone = state.z0 = state.z1 = state.z2 = [];
        var contours = state.contours = [];
        var cp;
        for (var i = 0; i < pLen; i++) {
            cp = points[i];
            gZone[i] = new HPoint(cp.x * xScale, cp.y * yScale, cp.lastPointOfContour, cp.onCurve);
        }
        var sp;
        var np;
        for (var i$1 = 0; i$1 < pLen; i$1++) {
            cp = gZone[i$1];
            if (!sp) {
                sp = cp;
                contours.push(i$1);
            }
            if (cp.lastPointOfContour) {
                cp.nextPointOnContour = sp;
                sp.prevPointOnContour = cp;
                sp = undefined;
            } else {
                np = gZone[i$1 + 1];
                cp.nextPointOnContour = np;
                np.prevPointOnContour = cp;
            }
        }
        if (state.inhibitGridFit) {
            return;
        }
        if (exports.DEBUG) {
            console.log('PROCESSING GLYPH', state.stack);
            for (var i$2 = 0; i$2 < pLen; i$2++) {
                console.log(i$2, gZone[i$2].x, gZone[i$2].y);
            }
        }
        gZone.push(new HPoint(0, 0), new HPoint(Math.round(glyph.advanceWidth * xScale), 0));
        exec(state);
        gZone.length -= 2;
        if (exports.DEBUG) {
            console.log('FINISHED GLYPH', state.stack);
            for (var i$3 = 0; i$3 < pLen; i$3++) {
                console.log(i$3, gZone[i$3].x, gZone[i$3].y);
            }
        }
    };
    exec = function (state) {
        var prog = state.prog;
        if (!prog) {
            return;
        }
        var pLen = prog.length;
        var ins;
        for (state.ip = 0; state.ip < pLen; state.ip++) {
            if (exports.DEBUG) {
                state.step++;
            }
            ins = instructionTable[prog[state.ip]];
            if (!ins) {
                throw new Error('unknown instruction: 0x' + Number(prog[state.ip]).toString(16));
            }
            ins(state);
        }
    };
    function initTZone(state) {
        var tZone = state.tZone = new Array(state.gZone.length);
        for (var i = 0; i < tZone.length; i++) {
            tZone[i] = new HPoint(0, 0);
        }
    }
    function skip(state, handleElse) {
        var prog = state.prog;
        var ip = state.ip;
        var nesting = 1;
        var ins;
        do {
            ins = prog[++ip];
            if (ins === 88) {
                nesting++;
            } else if (ins === 89) {
                nesting--;
            } else if (ins === 64) {
                ip += prog[ip + 1] + 1;
            } else if (ins === 65) {
                ip += 2 * prog[ip + 1] + 1;
            } else if (ins >= 176 && ins <= 183) {
                ip += ins - 176 + 1;
            } else if (ins >= 184 && ins <= 191) {
                ip += (ins - 184 + 1) * 2;
            } else if (handleElse && nesting === 1 && ins === 27) {
                break;
            }
        } while (nesting > 0);
        state.ip = ip;
    }
    function SVTCA(v, state) {
        if (exports.DEBUG) {
            console.log(state.step, 'SVTCA[' + v.axis + ']');
        }
        state.fv = state.pv = state.dpv = v;
    }
    function SPVTCA(v, state) {
        if (exports.DEBUG) {
            console.log(state.step, 'SPVTCA[' + v.axis + ']');
        }
        state.pv = state.dpv = v;
    }
    function SFVTCA(v, state) {
        if (exports.DEBUG) {
            console.log(state.step, 'SFVTCA[' + v.axis + ']');
        }
        state.fv = v;
    }
    function SPVTL(a, state) {
        var stack = state.stack;
        var p2i = stack.pop();
        var p1i = stack.pop();
        var p2 = state.z2[p2i];
        var p1 = state.z1[p1i];
        if (exports.DEBUG) {
            console.log('SPVTL[' + a + ']', p2i, p1i);
        }
        var dx;
        var dy;
        if (!a) {
            dx = p1.x - p2.x;
            dy = p1.y - p2.y;
        } else {
            dx = p2.y - p1.y;
            dy = p1.x - p2.x;
        }
        state.pv = state.dpv = getUnitVector(dx, dy);
    }
    function SFVTL(a, state) {
        var stack = state.stack;
        var p2i = stack.pop();
        var p1i = stack.pop();
        var p2 = state.z2[p2i];
        var p1 = state.z1[p1i];
        if (exports.DEBUG) {
            console.log('SFVTL[' + a + ']', p2i, p1i);
        }
        var dx;
        var dy;
        if (!a) {
            dx = p1.x - p2.x;
            dy = p1.y - p2.y;
        } else {
            dx = p2.y - p1.y;
            dy = p1.x - p2.x;
        }
        state.fv = getUnitVector(dx, dy);
    }
    function SPVFS(state) {
        var stack = state.stack;
        var y = stack.pop();
        var x = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SPVFS[]', y, x);
        }
        state.pv = state.dpv = getUnitVector(x, y);
    }
    function SFVFS(state) {
        var stack = state.stack;
        var y = stack.pop();
        var x = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SPVFS[]', y, x);
        }
        state.fv = getUnitVector(x, y);
    }
    function GPV(state) {
        var stack = state.stack;
        var pv = state.pv;
        if (exports.DEBUG) {
            console.log(state.step, 'GPV[]');
        }
        stack.push(pv.x * 16384);
        stack.push(pv.y * 16384);
    }
    function GFV(state) {
        var stack = state.stack;
        var fv = state.fv;
        if (exports.DEBUG) {
            console.log(state.step, 'GFV[]');
        }
        stack.push(fv.x * 16384);
        stack.push(fv.y * 16384);
    }
    function SFVTPV(state) {
        state.fv = state.pv;
        if (exports.DEBUG) {
            console.log(state.step, 'SFVTPV[]');
        }
    }
    function ISECT(state) {
        var stack = state.stack;
        var pa0i = stack.pop();
        var pa1i = stack.pop();
        var pb0i = stack.pop();
        var pb1i = stack.pop();
        var pi = stack.pop();
        var z0 = state.z0;
        var z1 = state.z1;
        var pa0 = z0[pa0i];
        var pa1 = z0[pa1i];
        var pb0 = z1[pb0i];
        var pb1 = z1[pb1i];
        var p = state.z2[pi];
        if (exports.DEBUG) {
            console.log('ISECT[], ', pa0i, pa1i, pb0i, pb1i, pi);
        }
        var x1 = pa0.x;
        var y1 = pa0.y;
        var x2 = pa1.x;
        var y2 = pa1.y;
        var x3 = pb0.x;
        var y3 = pb0.y;
        var x4 = pb1.x;
        var y4 = pb1.y;
        var div = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        var f1 = x1 * y2 - y1 * x2;
        var f2 = x3 * y4 - y3 * x4;
        p.x = (f1 * (x3 - x4) - f2 * (x1 - x2)) / div;
        p.y = (f1 * (y3 - y4) - f2 * (y1 - y2)) / div;
    }
    function SRP0(state) {
        state.rp0 = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SRP0[]', state.rp0);
        }
    }
    function SRP1(state) {
        state.rp1 = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SRP1[]', state.rp1);
        }
    }
    function SRP2(state) {
        state.rp2 = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SRP2[]', state.rp2);
        }
    }
    function SZP0(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SZP0[]', n);
        }
        state.zp0 = n;
        switch (n) {
        case 0:
            if (!state.tZone) {
                initTZone(state);
            }
            state.z0 = state.tZone;
            break;
        case 1:
            state.z0 = state.gZone;
            break;
        default:
            throw new Error('Invalid zone pointer');
        }
    }
    function SZP1(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SZP1[]', n);
        }
        state.zp1 = n;
        switch (n) {
        case 0:
            if (!state.tZone) {
                initTZone(state);
            }
            state.z1 = state.tZone;
            break;
        case 1:
            state.z1 = state.gZone;
            break;
        default:
            throw new Error('Invalid zone pointer');
        }
    }
    function SZP2(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SZP2[]', n);
        }
        state.zp2 = n;
        switch (n) {
        case 0:
            if (!state.tZone) {
                initTZone(state);
            }
            state.z2 = state.tZone;
            break;
        case 1:
            state.z2 = state.gZone;
            break;
        default:
            throw new Error('Invalid zone pointer');
        }
    }
    function SZPS(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SZPS[]', n);
        }
        state.zp0 = state.zp1 = state.zp2 = n;
        switch (n) {
        case 0:
            if (!state.tZone) {
                initTZone(state);
            }
            state.z0 = state.z1 = state.z2 = state.tZone;
            break;
        case 1:
            state.z0 = state.z1 = state.z2 = state.gZone;
            break;
        default:
            throw new Error('Invalid zone pointer');
        }
    }
    function SLOOP(state) {
        state.loop = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SLOOP[]', state.loop);
        }
    }
    function RTG(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'RTG[]');
        }
        state.round = roundToGrid;
    }
    function RTHG(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'RTHG[]');
        }
        state.round = roundToHalfGrid;
    }
    function SMD(state) {
        var d = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SMD[]', d);
        }
        state.minDis = d / 64;
    }
    function ELSE(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'ELSE[]');
        }
        skip(state, false);
    }
    function JMPR(state) {
        var o = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'JMPR[]', o);
        }
        state.ip += o - 1;
    }
    function SCVTCI(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SCVTCI[]', n);
        }
        state.cvCutIn = n / 64;
    }
    function DUP(state) {
        var stack = state.stack;
        if (exports.DEBUG) {
            console.log(state.step, 'DUP[]');
        }
        stack.push(stack[stack.length - 1]);
    }
    function POP(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'POP[]');
        }
        state.stack.pop();
    }
    function CLEAR(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'CLEAR[]');
        }
        state.stack.length = 0;
    }
    function SWAP(state) {
        var stack = state.stack;
        var a = stack.pop();
        var b = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SWAP[]');
        }
        stack.push(a);
        stack.push(b);
    }
    function DEPTH(state) {
        var stack = state.stack;
        if (exports.DEBUG) {
            console.log(state.step, 'DEPTH[]');
        }
        stack.push(stack.length);
    }
    function LOOPCALL(state) {
        var stack = state.stack;
        var fn = stack.pop();
        var c = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'LOOPCALL[]', fn, c);
        }
        var cip = state.ip;
        var cprog = state.prog;
        state.prog = state.funcs[fn];
        for (var i = 0; i < c; i++) {
            exec(state);
            if (exports.DEBUG) {
                console.log(++state.step, i + 1 < c ? 'next loopcall' : 'done loopcall', i);
            }
        }
        state.ip = cip;
        state.prog = cprog;
    }
    function CALL(state) {
        var fn = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'CALL[]', fn);
        }
        var cip = state.ip;
        var cprog = state.prog;
        state.prog = state.funcs[fn];
        exec(state);
        state.ip = cip;
        state.prog = cprog;
        if (exports.DEBUG) {
            console.log(++state.step, 'returning from', fn);
        }
    }
    function CINDEX(state) {
        var stack = state.stack;
        var k = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'CINDEX[]', k);
        }
        stack.push(stack[stack.length - k]);
    }
    function MINDEX(state) {
        var stack = state.stack;
        var k = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'MINDEX[]', k);
        }
        stack.push(stack.splice(stack.length - k, 1)[0]);
    }
    function FDEF(state) {
        if (state.env !== 'fpgm') {
            throw new Error('FDEF not allowed here');
        }
        var stack = state.stack;
        var prog = state.prog;
        var ip = state.ip;
        var fn = stack.pop();
        var ipBegin = ip;
        if (exports.DEBUG) {
            console.log(state.step, 'FDEF[]', fn);
        }
        while (prog[++ip] !== 45) {
        }
        state.ip = ip;
        state.funcs[fn] = prog.slice(ipBegin + 1, ip);
    }
    function MDAP(round, state) {
        var pi = state.stack.pop();
        var p = state.z0[pi];
        var fv = state.fv;
        var pv = state.pv;
        if (exports.DEBUG) {
            console.log(state.step, 'MDAP[' + round + ']', pi);
        }
        var d = pv.distance(p, HPZero);
        if (round) {
            d = state.round(d);
        }
        fv.setRelative(p, HPZero, d, pv);
        fv.touch(p);
        state.rp0 = state.rp1 = pi;
    }
    function IUP(v, state) {
        var z2 = state.z2;
        var pLen = z2.length - 2;
        var cp;
        var pp;
        var np;
        if (exports.DEBUG) {
            console.log(state.step, 'IUP[' + v.axis + ']');
        }
        for (var i = 0; i < pLen; i++) {
            cp = z2[i];
            if (v.touched(cp)) {
                continue;
            }
            pp = cp.prevTouched(v);
            if (pp === cp) {
                continue;
            }
            np = cp.nextTouched(v);
            if (pp === np) {
                v.setRelative(cp, cp, v.distance(pp, pp, false, true), v, true);
            }
            v.interpolate(cp, pp, np, v);
        }
    }
    function SHP(a, state) {
        var stack = state.stack;
        var rpi = a ? state.rp1 : state.rp2;
        var rp = (a ? state.z0 : state.z1)[rpi];
        var fv = state.fv;
        var pv = state.pv;
        var loop = state.loop;
        var z2 = state.z2;
        while (loop--) {
            var pi = stack.pop();
            var p = z2[pi];
            var d = pv.distance(rp, rp, false, true);
            fv.setRelative(p, p, d, pv);
            fv.touch(p);
            if (exports.DEBUG) {
                console.log(state.step, (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') + 'SHP[' + (a ? 'rp1' : 'rp2') + ']', pi);
            }
        }
        state.loop = 1;
    }
    function SHC(a, state) {
        var stack = state.stack;
        var rpi = a ? state.rp1 : state.rp2;
        var rp = (a ? state.z0 : state.z1)[rpi];
        var fv = state.fv;
        var pv = state.pv;
        var ci = stack.pop();
        var sp = state.z2[state.contours[ci]];
        var p = sp;
        if (exports.DEBUG) {
            console.log(state.step, 'SHC[' + a + ']', ci);
        }
        var d = pv.distance(rp, rp, false, true);
        do {
            if (p !== rp) {
                fv.setRelative(p, p, d, pv);
            }
            p = p.nextPointOnContour;
        } while (p !== sp);
    }
    function SHZ(a, state) {
        var stack = state.stack;
        var rpi = a ? state.rp1 : state.rp2;
        var rp = (a ? state.z0 : state.z1)[rpi];
        var fv = state.fv;
        var pv = state.pv;
        var e = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SHZ[' + a + ']', e);
        }
        var z;
        switch (e) {
        case 0:
            z = state.tZone;
            break;
        case 1:
            z = state.gZone;
            break;
        default:
            throw new Error('Invalid zone');
        }
        var p;
        var d = pv.distance(rp, rp, false, true);
        var pLen = z.length - 2;
        for (var i = 0; i < pLen; i++) {
            p = z[i];
            fv.setRelative(p, p, d, pv);
        }
    }
    function SHPIX(state) {
        var stack = state.stack;
        var loop = state.loop;
        var fv = state.fv;
        var d = stack.pop() / 64;
        var z2 = state.z2;
        while (loop--) {
            var pi = stack.pop();
            var p = z2[pi];
            if (exports.DEBUG) {
                console.log(state.step, (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') + 'SHPIX[]', pi, d);
            }
            fv.setRelative(p, p, d);
            fv.touch(p);
        }
        state.loop = 1;
    }
    function IP(state) {
        var stack = state.stack;
        var rp1i = state.rp1;
        var rp2i = state.rp2;
        var loop = state.loop;
        var rp1 = state.z0[rp1i];
        var rp2 = state.z1[rp2i];
        var fv = state.fv;
        var pv = state.dpv;
        var z2 = state.z2;
        while (loop--) {
            var pi = stack.pop();
            var p = z2[pi];
            if (exports.DEBUG) {
                console.log(state.step, (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') + 'IP[]', pi, rp1i, '<->', rp2i);
            }
            fv.interpolate(p, rp1, rp2, pv);
            fv.touch(p);
        }
        state.loop = 1;
    }
    function MSIRP(a, state) {
        var stack = state.stack;
        var d = stack.pop() / 64;
        var pi = stack.pop();
        var p = state.z1[pi];
        var rp0 = state.z0[state.rp0];
        var fv = state.fv;
        var pv = state.pv;
        fv.setRelative(p, rp0, d, pv);
        fv.touch(p);
        if (exports.DEBUG) {
            console.log(state.step, 'MSIRP[' + a + ']', d, pi);
        }
        state.rp1 = state.rp0;
        state.rp2 = pi;
        if (a) {
            state.rp0 = pi;
        }
    }
    function ALIGNRP(state) {
        var stack = state.stack;
        var rp0i = state.rp0;
        var rp0 = state.z0[rp0i];
        var loop = state.loop;
        var fv = state.fv;
        var pv = state.pv;
        var z1 = state.z1;
        while (loop--) {
            var pi = stack.pop();
            var p = z1[pi];
            if (exports.DEBUG) {
                console.log(state.step, (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') + 'ALIGNRP[]', pi);
            }
            fv.setRelative(p, rp0, 0, pv);
            fv.touch(p);
        }
        state.loop = 1;
    }
    function RTDG(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'RTDG[]');
        }
        state.round = roundToDoubleGrid;
    }
    function MIAP(round, state) {
        var stack = state.stack;
        var n = stack.pop();
        var pi = stack.pop();
        var p = state.z0[pi];
        var fv = state.fv;
        var pv = state.pv;
        var cv = state.cvt[n];
        if (exports.DEBUG) {
            console.log(state.step, 'MIAP[' + round + ']', n, '(', cv, ')', pi);
        }
        var d = pv.distance(p, HPZero);
        if (round) {
            if (Math.abs(d - cv) < state.cvCutIn) {
                d = cv;
            }
            d = state.round(d);
        }
        fv.setRelative(p, HPZero, d, pv);
        if (state.zp0 === 0) {
            p.xo = p.x;
            p.yo = p.y;
        }
        fv.touch(p);
        state.rp0 = state.rp1 = pi;
    }
    function NPUSHB(state) {
        var prog = state.prog;
        var ip = state.ip;
        var stack = state.stack;
        var n = prog[++ip];
        if (exports.DEBUG) {
            console.log(state.step, 'NPUSHB[]', n);
        }
        for (var i = 0; i < n; i++) {
            stack.push(prog[++ip]);
        }
        state.ip = ip;
    }
    function NPUSHW(state) {
        var ip = state.ip;
        var prog = state.prog;
        var stack = state.stack;
        var n = prog[++ip];
        if (exports.DEBUG) {
            console.log(state.step, 'NPUSHW[]', n);
        }
        for (var i = 0; i < n; i++) {
            var w = prog[++ip] << 8 | prog[++ip];
            if (w & 32768) {
                w = -((w ^ 65535) + 1);
            }
            stack.push(w);
        }
        state.ip = ip;
    }
    function WS(state) {
        var stack = state.stack;
        var store = state.store;
        if (!store) {
            store = state.store = [];
        }
        var v = stack.pop();
        var l = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'WS', v, l);
        }
        store[l] = v;
    }
    function RS(state) {
        var stack = state.stack;
        var store = state.store;
        var l = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'RS', l);
        }
        var v = store && store[l] || 0;
        stack.push(v);
    }
    function WCVTP(state) {
        var stack = state.stack;
        var v = stack.pop();
        var l = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'WCVTP', v, l);
        }
        state.cvt[l] = v / 64;
    }
    function RCVT(state) {
        var stack = state.stack;
        var cvte = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'RCVT', cvte);
        }
        stack.push(state.cvt[cvte] * 64);
    }
    function GC(a, state) {
        var stack = state.stack;
        var pi = stack.pop();
        var p = state.z2[pi];
        if (exports.DEBUG) {
            console.log(state.step, 'GC[' + a + ']', pi);
        }
        stack.push(state.dpv.distance(p, HPZero, a, false) * 64);
    }
    function MD(a, state) {
        var stack = state.stack;
        var pi2 = stack.pop();
        var pi1 = stack.pop();
        var p2 = state.z1[pi2];
        var p1 = state.z0[pi1];
        var d = state.dpv.distance(p1, p2, a, a);
        if (exports.DEBUG) {
            console.log(state.step, 'MD[' + a + ']', pi2, pi1, '->', d);
        }
        state.stack.push(Math.round(d * 64));
    }
    function MPPEM(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'MPPEM[]');
        }
        state.stack.push(state.ppem);
    }
    function FLIPON(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'FLIPON[]');
        }
        state.autoFlip = true;
    }
    function LT(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'LT[]', e2, e1);
        }
        stack.push(e1 < e2 ? 1 : 0);
    }
    function LTEQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'LTEQ[]', e2, e1);
        }
        stack.push(e1 <= e2 ? 1 : 0);
    }
    function GT(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'GT[]', e2, e1);
        }
        stack.push(e1 > e2 ? 1 : 0);
    }
    function GTEQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'GTEQ[]', e2, e1);
        }
        stack.push(e1 >= e2 ? 1 : 0);
    }
    function EQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'EQ[]', e2, e1);
        }
        stack.push(e2 === e1 ? 1 : 0);
    }
    function NEQ(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'NEQ[]', e2, e1);
        }
        stack.push(e2 !== e1 ? 1 : 0);
    }
    function ODD(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'ODD[]', n);
        }
        stack.push(Math.trunc(n) % 2 ? 1 : 0);
    }
    function EVEN(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'EVEN[]', n);
        }
        stack.push(Math.trunc(n) % 2 ? 0 : 1);
    }
    function IF(state) {
        var test = state.stack.pop();
        var ins;
        if (exports.DEBUG) {
            console.log(state.step, 'IF[]', test);
        }
        if (!test) {
            skip(state, true);
            if (exports.DEBUG) {
                console.log(state.step, ins === 27 ? 'ELSE[]' : 'EIF[]');
            }
        }
    }
    function EIF(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'EIF[]');
        }
    }
    function AND(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'AND[]', e2, e1);
        }
        stack.push(e2 && e1 ? 1 : 0);
    }
    function OR(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'OR[]', e2, e1);
        }
        stack.push(e2 || e1 ? 1 : 0);
    }
    function NOT(state) {
        var stack = state.stack;
        var e = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'NOT[]', e);
        }
        stack.push(e ? 0 : 1);
    }
    function DELTAP123(b, state) {
        var stack = state.stack;
        var n = stack.pop();
        var fv = state.fv;
        var pv = state.pv;
        var ppem = state.ppem;
        var base = state.deltaBase + (b - 1) * 16;
        var ds = state.deltaShift;
        var z0 = state.z0;
        if (exports.DEBUG) {
            console.log(state.step, 'DELTAP[' + b + ']', n, stack);
        }
        for (var i = 0; i < n; i++) {
            var pi = stack.pop();
            var arg = stack.pop();
            var appem = base + ((arg & 240) >> 4);
            if (appem !== ppem) {
                continue;
            }
            var mag = (arg & 15) - 8;
            if (mag >= 0) {
                mag++;
            }
            if (exports.DEBUG) {
                console.log(state.step, 'DELTAPFIX', pi, 'by', mag * ds);
            }
            var p = z0[pi];
            fv.setRelative(p, p, mag * ds, pv);
        }
    }
    function SDB(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SDB[]', n);
        }
        state.deltaBase = n;
    }
    function SDS(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SDS[]', n);
        }
        state.deltaShift = Math.pow(0.5, n);
    }
    function ADD(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'ADD[]', n2, n1);
        }
        stack.push(n1 + n2);
    }
    function SUB(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SUB[]', n2, n1);
        }
        stack.push(n1 - n2);
    }
    function DIV(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'DIV[]', n2, n1);
        }
        stack.push(n1 * 64 / n2);
    }
    function MUL(state) {
        var stack = state.stack;
        var n2 = stack.pop();
        var n1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'MUL[]', n2, n1);
        }
        stack.push(n1 * n2 / 64);
    }
    function ABS(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'ABS[]', n);
        }
        stack.push(Math.abs(n));
    }
    function NEG(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'NEG[]', n);
        }
        stack.push(-n);
    }
    function FLOOR(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'FLOOR[]', n);
        }
        stack.push(Math.floor(n / 64) * 64);
    }
    function CEILING(state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'CEILING[]', n);
        }
        stack.push(Math.ceil(n / 64) * 64);
    }
    function ROUND(dt, state) {
        var stack = state.stack;
        var n = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'ROUND[]');
        }
        stack.push(state.round(n / 64) * 64);
    }
    function WCVTF(state) {
        var stack = state.stack;
        var v = stack.pop();
        var l = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'WCVTF[]', v, l);
        }
        state.cvt[l] = v * state.ppem / state.font.unitsPerEm;
    }
    function DELTAC123(b, state) {
        var stack = state.stack;
        var n = stack.pop();
        var ppem = state.ppem;
        var base = state.deltaBase + (b - 1) * 16;
        var ds = state.deltaShift;
        if (exports.DEBUG) {
            console.log(state.step, 'DELTAC[' + b + ']', n, stack);
        }
        for (var i = 0; i < n; i++) {
            var c = stack.pop();
            var arg = stack.pop();
            var appem = base + ((arg & 240) >> 4);
            if (appem !== ppem) {
                continue;
            }
            var mag = (arg & 15) - 8;
            if (mag >= 0) {
                mag++;
            }
            var delta = mag * ds;
            if (exports.DEBUG) {
                console.log(state.step, 'DELTACFIX', c, 'by', delta);
            }
            state.cvt[c] += delta;
        }
    }
    function SROUND(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SROUND[]', n);
        }
        state.round = roundSuper;
        var period;
        switch (n & 192) {
        case 0:
            period = 0.5;
            break;
        case 64:
            period = 1;
            break;
        case 128:
            period = 2;
            break;
        default:
            throw new Error('invalid SROUND value');
        }
        state.srPeriod = period;
        switch (n & 48) {
        case 0:
            state.srPhase = 0;
            break;
        case 16:
            state.srPhase = 0.25 * period;
            break;
        case 32:
            state.srPhase = 0.5 * period;
            break;
        case 48:
            state.srPhase = 0.75 * period;
            break;
        default:
            throw new Error('invalid SROUND value');
        }
        n &= 15;
        if (n === 0) {
            state.srThreshold = 0;
        } else {
            state.srThreshold = (n / 8 - 0.5) * period;
        }
    }
    function S45ROUND(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'S45ROUND[]', n);
        }
        state.round = roundSuper;
        var period;
        switch (n & 192) {
        case 0:
            period = Math.sqrt(2) / 2;
            break;
        case 64:
            period = Math.sqrt(2);
            break;
        case 128:
            period = 2 * Math.sqrt(2);
            break;
        default:
            throw new Error('invalid S45ROUND value');
        }
        state.srPeriod = period;
        switch (n & 48) {
        case 0:
            state.srPhase = 0;
            break;
        case 16:
            state.srPhase = 0.25 * period;
            break;
        case 32:
            state.srPhase = 0.5 * period;
            break;
        case 48:
            state.srPhase = 0.75 * period;
            break;
        default:
            throw new Error('invalid S45ROUND value');
        }
        n &= 15;
        if (n === 0) {
            state.srThreshold = 0;
        } else {
            state.srThreshold = (n / 8 - 0.5) * period;
        }
    }
    function ROFF(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'ROFF[]');
        }
        state.round = roundOff;
    }
    function RUTG(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'RUTG[]');
        }
        state.round = roundUpToGrid;
    }
    function RDTG(state) {
        if (exports.DEBUG) {
            console.log(state.step, 'RDTG[]');
        }
        state.round = roundDownToGrid;
    }
    function SCANCTRL(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SCANCTRL[]', n);
        }
    }
    function SDPVTL(a, state) {
        var stack = state.stack;
        var p2i = stack.pop();
        var p1i = stack.pop();
        var p2 = state.z2[p2i];
        var p1 = state.z1[p1i];
        if (exports.DEBUG) {
            console.log(state.step, 'SDPVTL[' + a + ']', p2i, p1i);
        }
        var dx;
        var dy;
        if (!a) {
            dx = p1.x - p2.x;
            dy = p1.y - p2.y;
        } else {
            dx = p2.y - p1.y;
            dy = p1.x - p2.x;
        }
        state.dpv = getUnitVector(dx, dy);
    }
    function GETINFO(state) {
        var stack = state.stack;
        var sel = stack.pop();
        var r = 0;
        if (exports.DEBUG) {
            console.log(state.step, 'GETINFO[]', sel);
        }
        if (sel & 1) {
            r = 35;
        }
        if (sel & 32) {
            r |= 4096;
        }
        stack.push(r);
    }
    function ROLL(state) {
        var stack = state.stack;
        var a = stack.pop();
        var b = stack.pop();
        var c = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'ROLL[]');
        }
        stack.push(b);
        stack.push(a);
        stack.push(c);
    }
    function MAX(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'MAX[]', e2, e1);
        }
        stack.push(Math.max(e1, e2));
    }
    function MIN(state) {
        var stack = state.stack;
        var e2 = stack.pop();
        var e1 = stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'MIN[]', e2, e1);
        }
        stack.push(Math.min(e1, e2));
    }
    function SCANTYPE(state) {
        var n = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'SCANTYPE[]', n);
        }
    }
    function INSTCTRL(state) {
        var s = state.stack.pop();
        var v = state.stack.pop();
        if (exports.DEBUG) {
            console.log(state.step, 'INSTCTRL[]', s, v);
        }
        switch (s) {
        case 1:
            state.inhibitGridFit = !!v;
            return;
        case 2:
            state.ignoreCvt = !!v;
            return;
        default:
            throw new Error('invalid INSTCTRL[] selector');
        }
    }
    function PUSHB(n, state) {
        var stack = state.stack;
        var prog = state.prog;
        var ip = state.ip;
        if (exports.DEBUG) {
            console.log(state.step, 'PUSHB[' + n + ']');
        }
        for (var i = 0; i < n; i++) {
            stack.push(prog[++ip]);
        }
        state.ip = ip;
    }
    function PUSHW(n, state) {
        var ip = state.ip;
        var prog = state.prog;
        var stack = state.stack;
        if (exports.DEBUG) {
            console.log(state.ip, 'PUSHW[' + n + ']');
        }
        for (var i = 0; i < n; i++) {
            var w = prog[++ip] << 8 | prog[++ip];
            if (w & 32768) {
                w = -((w ^ 65535) + 1);
            }
            stack.push(w);
        }
        state.ip = ip;
    }
    function MDRP_MIRP(indirect, setRp0, keepD, ro, dt, state) {
        var stack = state.stack;
        var cvte = indirect && stack.pop();
        var pi = stack.pop();
        var rp0i = state.rp0;
        var rp = state.z0[rp0i];
        var p = state.z1[pi];
        var md = state.minDis;
        var fv = state.fv;
        var pv = state.dpv;
        var od;
        var d;
        var sign;
        var cv;
        d = od = pv.distance(p, rp, true, true);
        sign = d >= 0 ? 1 : -1;
        d = Math.abs(d);
        if (indirect) {
            cv = state.cvt[cvte];
            if (ro && Math.abs(d - cv) < state.cvCutIn) {
                d = cv;
            }
        }
        if (keepD && d < md) {
            d = md;
        }
        if (ro) {
            d = state.round(d);
        }
        fv.setRelative(p, rp, sign * d, pv);
        fv.touch(p);
        if (exports.DEBUG) {
            console.log(state.step, (indirect ? 'MIRP[' : 'MDRP[') + (setRp0 ? 'M' : 'm') + (keepD ? '>' : '_') + (ro ? 'R' : '_') + (dt === 0 ? 'Gr' : dt === 1 ? 'Bl' : dt === 2 ? 'Wh' : '') + ']', indirect ? cvte + '(' + state.cvt[cvte] + ',' + cv + ')' : '', pi, '(d =', od, '->', sign * d, ')');
        }
        state.rp1 = state.rp0;
        state.rp2 = pi;
        if (setRp0) {
            state.rp0 = pi;
        }
    }
    instructionTable = [
        SVTCA.bind(undefined, yUnitVector),
        SVTCA.bind(undefined, xUnitVector),
        SPVTCA.bind(undefined, yUnitVector),
        SPVTCA.bind(undefined, xUnitVector),
        SFVTCA.bind(undefined, yUnitVector),
        SFVTCA.bind(undefined, xUnitVector),
        SPVTL.bind(undefined, 0),
        SPVTL.bind(undefined, 1),
        SFVTL.bind(undefined, 0),
        SFVTL.bind(undefined, 1),
        SPVFS,
        SFVFS,
        GPV,
        GFV,
        SFVTPV,
        ISECT,
        SRP0,
        SRP1,
        SRP2,
        SZP0,
        SZP1,
        SZP2,
        SZPS,
        SLOOP,
        RTG,
        RTHG,
        SMD,
        ELSE,
        JMPR,
        SCVTCI,
        undefined,
        undefined,
        DUP,
        POP,
        CLEAR,
        SWAP,
        DEPTH,
        CINDEX,
        MINDEX,
        undefined,
        undefined,
        undefined,
        LOOPCALL,
        CALL,
        FDEF,
        undefined,
        MDAP.bind(undefined, 0),
        MDAP.bind(undefined, 1),
        IUP.bind(undefined, yUnitVector),
        IUP.bind(undefined, xUnitVector),
        SHP.bind(undefined, 0),
        SHP.bind(undefined, 1),
        SHC.bind(undefined, 0),
        SHC.bind(undefined, 1),
        SHZ.bind(undefined, 0),
        SHZ.bind(undefined, 1),
        SHPIX,
        IP,
        MSIRP.bind(undefined, 0),
        MSIRP.bind(undefined, 1),
        ALIGNRP,
        RTDG,
        MIAP.bind(undefined, 0),
        MIAP.bind(undefined, 1),
        NPUSHB,
        NPUSHW,
        WS,
        RS,
        WCVTP,
        RCVT,
        GC.bind(undefined, 0),
        GC.bind(undefined, 1),
        undefined,
        MD.bind(undefined, 0),
        MD.bind(undefined, 1),
        MPPEM,
        undefined,
        FLIPON,
        undefined,
        undefined,
        LT,
        LTEQ,
        GT,
        GTEQ,
        EQ,
        NEQ,
        ODD,
        EVEN,
        IF,
        EIF,
        AND,
        OR,
        NOT,
        DELTAP123.bind(undefined, 1),
        SDB,
        SDS,
        ADD,
        SUB,
        DIV,
        MUL,
        ABS,
        NEG,
        FLOOR,
        CEILING,
        ROUND.bind(undefined, 0),
        ROUND.bind(undefined, 1),
        ROUND.bind(undefined, 2),
        ROUND.bind(undefined, 3),
        undefined,
        undefined,
        undefined,
        undefined,
        WCVTF,
        DELTAP123.bind(undefined, 2),
        DELTAP123.bind(undefined, 3),
        DELTAC123.bind(undefined, 1),
        DELTAC123.bind(undefined, 2),
        DELTAC123.bind(undefined, 3),
        SROUND,
        S45ROUND,
        undefined,
        undefined,
        ROFF,
        undefined,
        RUTG,
        RDTG,
        POP,
        POP,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        SCANCTRL,
        SDPVTL.bind(undefined, 0),
        SDPVTL.bind(undefined, 1),
        GETINFO,
        undefined,
        ROLL,
        MAX,
        MIN,
        SCANTYPE,
        INSTCTRL,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        PUSHB.bind(undefined, 1),
        PUSHB.bind(undefined, 2),
        PUSHB.bind(undefined, 3),
        PUSHB.bind(undefined, 4),
        PUSHB.bind(undefined, 5),
        PUSHB.bind(undefined, 6),
        PUSHB.bind(undefined, 7),
        PUSHB.bind(undefined, 8),
        PUSHW.bind(undefined, 1),
        PUSHW.bind(undefined, 2),
        PUSHW.bind(undefined, 3),
        PUSHW.bind(undefined, 4),
        PUSHW.bind(undefined, 5),
        PUSHW.bind(undefined, 6),
        PUSHW.bind(undefined, 7),
        PUSHW.bind(undefined, 8),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 0),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 1),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 2),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 3),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 0),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 1),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 2),
        MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 3),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 0),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 1),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 2),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 3),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 0),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 1),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 2),
        MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 3),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 0),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 1),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 2),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 3),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 0),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 1),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 2),
        MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 3),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 0),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 1),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 2),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 3),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 0),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 1),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 2),
        MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 3),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 0),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 1),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 2),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 3),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 0),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 1),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 2),
        MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 3),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 0),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 1),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 2),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 3),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 0),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 1),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 2),
        MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 3),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 0),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 1),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 2),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 3),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 0),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 1),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 2),
        MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 3),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 0),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 1),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 2),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 3),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 0),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 1),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 2),
        MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 3)
    ];
    var arrayFromString = Array.from || function (s) {
        return s.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
    };
    function Font(options) {
        options = options || {};
        if (!options.empty) {
            checkArgument(options.familyName, 'When creating a new Font object, familyName is required.');
            checkArgument(options.styleName, 'When creating a new Font object, styleName is required.');
            checkArgument(options.unitsPerEm, 'When creating a new Font object, unitsPerEm is required.');
            checkArgument(options.ascender, 'When creating a new Font object, ascender is required.');
            checkArgument(options.descender, 'When creating a new Font object, descender is required.');
            checkArgument(options.descender < 0, 'Descender should be negative (e.g. -512).');
            this.names = {
                fontFamily: { en: options.familyName || ' ' },
                fontSubfamily: { en: options.styleName || ' ' },
                fullName: { en: options.fullName || options.familyName + ' ' + options.styleName },
                postScriptName: { en: options.postScriptName || (options.familyName + options.styleName).replace(/\s/g, '') },
                designer: { en: options.designer || ' ' },
                designerURL: { en: options.designerURL || ' ' },
                manufacturer: { en: options.manufacturer || ' ' },
                manufacturerURL: { en: options.manufacturerURL || ' ' },
                license: { en: options.license || ' ' },
                licenseURL: { en: options.licenseURL || ' ' },
                version: { en: options.version || 'Version 0.1' },
                description: { en: options.description || ' ' },
                copyright: { en: options.copyright || ' ' },
                trademark: { en: options.trademark || ' ' }
            };
            this.unitsPerEm = options.unitsPerEm || 1000;
            this.ascender = options.ascender;
            this.descender = options.descender;
            this.createdTimestamp = options.createdTimestamp;
            this.tables = {
                os2: {
                    usWeightClass: options.weightClass || this.usWeightClasses.MEDIUM,
                    usWidthClass: options.widthClass || this.usWidthClasses.MEDIUM,
                    fsSelection: options.fsSelection || this.fsSelectionValues.REGULAR
                }
            };
        }
        this.supported = true;
        this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
        this.encoding = new DefaultEncoding(this);
        this.position = new Position(this);
        this.substitution = new Substitution(this);
        this.tables = this.tables || {};
        Object.defineProperty(this, 'hinting', {
            get: function () {
                if (this._hinting) {
                    return this._hinting;
                }
                if (this.outlinesFormat === 'truetype') {
                    return this._hinting = new Hinting(this);
                }
            }
        });
    }
    Font.prototype.hasChar = function (c) {
        return this.encoding.charToGlyphIndex(c) !== null;
    };
    Font.prototype.charToGlyphIndex = function (s) {
        return this.encoding.charToGlyphIndex(s);
    };
    Font.prototype.charToGlyph = function (c) {
        var glyphIndex = this.charToGlyphIndex(c);
        var glyph = this.glyphs.get(glyphIndex);
        if (!glyph) {
            glyph = this.glyphs.get(0);
        }
        return glyph;
    };
    Font.prototype.stringToGlyphs = function (s, options) {
        var this$1 = this;
        options = options || this.defaultRenderOptions;
        var chars = arrayFromString(s);
        var indexes = [];
        for (var i = 0; i < chars.length; i += 1) {
            var c = chars[i];
            indexes.push(this$1.charToGlyphIndex(c));
        }
        var length = indexes.length;
        if (options.features) {
            var script = options.script || this.substitution.getDefaultScriptName();
            var manyToOne = [];
            if (options.features.liga) {
                manyToOne = manyToOne.concat(this.substitution.getFeature('liga', script, options.language));
            }
            if (options.features.rlig) {
                manyToOne = manyToOne.concat(this.substitution.getFeature('rlig', script, options.language));
            }
            for (var i$1 = 0; i$1 < length; i$1 += 1) {
                for (var j = 0; j < manyToOne.length; j++) {
                    var ligature = manyToOne[j];
                    var components = ligature.sub;
                    var compCount = components.length;
                    var k = 0;
                    while (k < compCount && components[k] === indexes[i$1 + k]) {
                        k++;
                    }
                    if (k === compCount) {
                        indexes.splice(i$1, compCount, ligature.by);
                        length = length - compCount + 1;
                    }
                }
            }
        }
        var glyphs = new Array(length);
        var notdef = this.glyphs.get(0);
        for (var i$2 = 0; i$2 < length; i$2 += 1) {
            glyphs[i$2] = this$1.glyphs.get(indexes[i$2]) || notdef;
        }
        return glyphs;
    };
    Font.prototype.nameToGlyphIndex = function (name) {
        return this.glyphNames.nameToGlyphIndex(name);
    };
    Font.prototype.nameToGlyph = function (name) {
        var glyphIndex = this.nameToGlyphIndex(name);
        var glyph = this.glyphs.get(glyphIndex);
        if (!glyph) {
            glyph = this.glyphs.get(0);
        }
        return glyph;
    };
    Font.prototype.glyphIndexToName = function (gid) {
        if (!this.glyphNames.glyphIndexToName) {
            return '';
        }
        return this.glyphNames.glyphIndexToName(gid);
    };
    Font.prototype.getKerningValue = function (leftGlyph, rightGlyph) {
        leftGlyph = leftGlyph.index || leftGlyph;
        rightGlyph = rightGlyph.index || rightGlyph;
        var gposKerning = this.position.defaultKerningTables;
        if (gposKerning) {
            return this.position.getKerningValue(gposKerning, leftGlyph, rightGlyph);
        }
        return this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0;
    };
    Font.prototype.defaultRenderOptions = {
        kerning: true,
        features: {
            liga: true,
            rlig: true
        }
    };
    Font.prototype.forEachGlyph = function (text, x, y, fontSize, options, callback) {
        var this$1 = this;
        x = x !== undefined ? x : 0;
        y = y !== undefined ? y : 0;
        fontSize = fontSize !== undefined ? fontSize : 72;
        options = options || this.defaultRenderOptions;
        var fontScale = 1 / this.unitsPerEm * fontSize;
        var glyphs = this.stringToGlyphs(text, options);
        var kerningLookups;
        if (options.kerning) {
            var script = options.script || this.position.getDefaultScriptName();
            kerningLookups = this.position.getKerningTables(script, options.language);
        }
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs[i];
            callback.call(this$1, glyph, x, y, fontSize, options);
            if (glyph.advanceWidth) {
                x += glyph.advanceWidth * fontScale;
            }
            if (options.kerning && i < glyphs.length - 1) {
                var kerningValue = kerningLookups ? this$1.position.getKerningValue(kerningLookups, glyph.index, glyphs[i + 1].index) : this$1.getKerningValue(glyph, glyphs[i + 1]);
                x += kerningValue * fontScale;
            }
            if (options.letterSpacing) {
                x += options.letterSpacing * fontSize;
            } else if (options.tracking) {
                x += options.tracking / 1000 * fontSize;
            }
        }
        return x;
    };
    Font.prototype.getPath = function (text, x, y, fontSize, options) {
        var fullPath = new Path();
        this.forEachGlyph(text, x, y, fontSize, options, function (glyph, gX, gY, gFontSize) {
            var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
            fullPath.extend(glyphPath);
        });
        return fullPath;
    };
    Font.prototype.getPaths = function (text, x, y, fontSize, options) {
        var glyphPaths = [];
        this.forEachGlyph(text, x, y, fontSize, options, function (glyph, gX, gY, gFontSize) {
            var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
            glyphPaths.push(glyphPath);
        });
        return glyphPaths;
    };
    Font.prototype.getAdvanceWidth = function (text, fontSize, options) {
        return this.forEachGlyph(text, 0, 0, fontSize, options, function () {
        });
    };
    Font.prototype.draw = function (ctx, text, x, y, fontSize, options) {
        this.getPath(text, x, y, fontSize, options).draw(ctx);
    };
    Font.prototype.drawPoints = function (ctx, text, x, y, fontSize, options) {
        this.forEachGlyph(text, x, y, fontSize, options, function (glyph, gX, gY, gFontSize) {
            glyph.drawPoints(ctx, gX, gY, gFontSize);
        });
    };
    Font.prototype.drawMetrics = function (ctx, text, x, y, fontSize, options) {
        this.forEachGlyph(text, x, y, fontSize, options, function (glyph, gX, gY, gFontSize) {
            glyph.drawMetrics(ctx, gX, gY, gFontSize);
        });
    };
    Font.prototype.getEnglishName = function (name) {
        var translations = this.names[name];
        if (translations) {
            return translations.en;
        }
    };
    Font.prototype.validate = function () {
        var _this = this;
        function assert(predicate, message) {
        }
        function assertNamePresent(name) {
            var englishName = _this.getEnglishName(name);
        }
        assertNamePresent('fontFamily');
        assertNamePresent('weightName');
        assertNamePresent('manufacturer');
        assertNamePresent('copyright');
        assertNamePresent('version');
    };
    Font.prototype.toTables = function () {
        return sfnt.fontToTable(this);
    };
    Font.prototype.toBuffer = function () {
        console.warn('Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.');
        return this.toArrayBuffer();
    };
    Font.prototype.toArrayBuffer = function () {
        var sfntTable = this.toTables();
        var bytes = sfntTable.encode();
        var buffer = new ArrayBuffer(bytes.length);
        var intArray = new Uint8Array(buffer);
        for (var i = 0; i < bytes.length; i++) {
            intArray[i] = bytes[i];
        }
        return buffer;
    };
    Font.prototype.download = function (fileName) {
        var familyName = this.getEnglishName('fontFamily');
        var styleName = this.getEnglishName('fontSubfamily');
        fileName = fileName || familyName.replace(/\s/g, '') + '-' + styleName + '.otf';
        var arrayBuffer = this.toArrayBuffer();
        if (isBrowser()) {
            window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;
            window.requestFileSystem(window.TEMPORARY, arrayBuffer.byteLength, function (fs) {
                fs.root.getFile(fileName, { create: true }, function (fileEntry) {
                    fileEntry.createWriter(function (writer) {
                        var dataView = new DataView(arrayBuffer);
                        var blob = new Blob([dataView], { type: 'font/opentype' });
                        writer.write(blob);
                        writer.addEventListener('writeend', function () {
                            location.href = fileEntry.toURL();
                        }, false);
                    });
                });
            }, function (err) {
                throw new Error(err.name + ': ' + err.message);
            });
        } else {
            var fs = require('fs');
            var buffer = arrayBufferToNodeBuffer(arrayBuffer);
            fs.writeFileSync(fileName, buffer);
        }
    };
    Font.prototype.fsSelectionValues = {
        ITALIC: 1,
        UNDERSCORE: 2,
        NEGATIVE: 4,
        OUTLINED: 8,
        STRIKEOUT: 16,
        BOLD: 32,
        REGULAR: 64,
        USER_TYPO_METRICS: 128,
        WWS: 256,
        OBLIQUE: 512
    };
    Font.prototype.usWidthClasses = {
        ULTRA_CONDENSED: 1,
        EXTRA_CONDENSED: 2,
        CONDENSED: 3,
        SEMI_CONDENSED: 4,
        MEDIUM: 5,
        SEMI_EXPANDED: 6,
        EXPANDED: 7,
        EXTRA_EXPANDED: 8,
        ULTRA_EXPANDED: 9
    };
    Font.prototype.usWeightClasses = {
        THIN: 100,
        EXTRA_LIGHT: 200,
        LIGHT: 300,
        NORMAL: 400,
        MEDIUM: 500,
        SEMI_BOLD: 600,
        BOLD: 700,
        EXTRA_BOLD: 800,
        BLACK: 900
    };
    function addName(name, names) {
        var nameString = JSON.stringify(name);
        var nameID = 256;
        for (var nameKey in names) {
            var n = parseInt(nameKey);
            if (!n || n < 256) {
                continue;
            }
            if (JSON.stringify(names[nameKey]) === nameString) {
                return n;
            }
            if (nameID <= n) {
                nameID = n + 1;
            }
        }
        names[nameID] = name;
        return nameID;
    }
    function makeFvarAxis(n, axis, names) {
        var nameID = addName(axis.name, names);
        return [
            {
                name: 'tag_' + n,
                type: 'TAG',
                value: axis.tag
            },
            {
                name: 'minValue_' + n,
                type: 'FIXED',
                value: axis.minValue << 16
            },
            {
                name: 'defaultValue_' + n,
                type: 'FIXED',
                value: axis.defaultValue << 16
            },
            {
                name: 'maxValue_' + n,
                type: 'FIXED',
                value: axis.maxValue << 16
            },
            {
                name: 'flags_' + n,
                type: 'USHORT',
                value: 0
            },
            {
                name: 'nameID_' + n,
                type: 'USHORT',
                value: nameID
            }
        ];
    }
    function parseFvarAxis(data, start, names) {
        var axis = {};
        var p = new parse.Parser(data, start);
        axis.tag = p.parseTag();
        axis.minValue = p.parseFixed();
        axis.defaultValue = p.parseFixed();
        axis.maxValue = p.parseFixed();
        p.skip('uShort', 1);
        axis.name = names[p.parseUShort()] || {};
        return axis;
    }
    function makeFvarInstance(n, inst, axes, names) {
        var nameID = addName(inst.name, names);
        var fields = [
            {
                name: 'nameID_' + n,
                type: 'USHORT',
                value: nameID
            },
            {
                name: 'flags_' + n,
                type: 'USHORT',
                value: 0
            }
        ];
        for (var i = 0; i < axes.length; ++i) {
            var axisTag = axes[i].tag;
            fields.push({
                name: 'axis_' + n + ' ' + axisTag,
                type: 'FIXED',
                value: inst.coordinates[axisTag] << 16
            });
        }
        return fields;
    }
    function parseFvarInstance(data, start, axes, names) {
        var inst = {};
        var p = new parse.Parser(data, start);
        inst.name = names[p.parseUShort()] || {};
        p.skip('uShort', 1);
        inst.coordinates = {};
        for (var i = 0; i < axes.length; ++i) {
            inst.coordinates[axes[i].tag] = p.parseFixed();
        }
        return inst;
    }
    function makeFvarTable(fvar, names) {
        var result = new table.Table('fvar', [
            {
                name: 'version',
                type: 'ULONG',
                value: 65536
            },
            {
                name: 'offsetToData',
                type: 'USHORT',
                value: 0
            },
            {
                name: 'countSizePairs',
                type: 'USHORT',
                value: 2
            },
            {
                name: 'axisCount',
                type: 'USHORT',
                value: fvar.axes.length
            },
            {
                name: 'axisSize',
                type: 'USHORT',
                value: 20
            },
            {
                name: 'instanceCount',
                type: 'USHORT',
                value: fvar.instances.length
            },
            {
                name: 'instanceSize',
                type: 'USHORT',
                value: 4 + fvar.axes.length * 4
            }
        ]);
        result.offsetToData = result.sizeOf();
        for (var i = 0; i < fvar.axes.length; i++) {
            result.fields = result.fields.concat(makeFvarAxis(i, fvar.axes[i], names));
        }
        for (var j = 0; j < fvar.instances.length; j++) {
            result.fields = result.fields.concat(makeFvarInstance(j, fvar.instances[j], fvar.axes, names));
        }
        return result;
    }
    function parseFvarTable(data, start, names) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseULong();
        check.argument(tableVersion === 65536, 'Unsupported fvar table version.');
        var offsetToData = p.parseOffset16();
        p.skip('uShort', 1);
        var axisCount = p.parseUShort();
        var axisSize = p.parseUShort();
        var instanceCount = p.parseUShort();
        var instanceSize = p.parseUShort();
        var axes = [];
        for (var i = 0; i < axisCount; i++) {
            axes.push(parseFvarAxis(data, start + offsetToData + i * axisSize, names));
        }
        var instances = [];
        var instanceStart = start + offsetToData + axisCount * axisSize;
        for (var j = 0; j < instanceCount; j++) {
            instances.push(parseFvarInstance(data, instanceStart + j * instanceSize, axes, names));
        }
        return {
            axes: axes,
            instances: instances
        };
    }
    var fvar = {
        make: makeFvarTable,
        parse: parseFvarTable
    };
    var subtableParsers$1 = new Array(10);
    subtableParsers$1[1] = function parseLookup1() {
        var start = this.offset + this.relativeOffset;
        var posformat = this.parseUShort();
        if (posformat === 1) {
            return {
                posFormat: 1,
                coverage: this.parsePointer(Parser.coverage),
                value: this.parseValueRecord()
            };
        } else if (posformat === 2) {
            return {
                posFormat: 2,
                coverage: this.parsePointer(Parser.coverage),
                values: this.parseValueRecordList()
            };
        }
        check.assert(false, '0x' + start.toString(16) + ': GPOS lookup type 1 format must be 1 or 2.');
    };
    subtableParsers$1[2] = function parseLookup2() {
        var start = this.offset + this.relativeOffset;
        var posFormat = this.parseUShort();
        check.assert(posFormat === 1 || posFormat === 2, '0x' + start.toString(16) + ': GPOS lookup type 2 format must be 1 or 2.');
        var coverage = this.parsePointer(Parser.coverage);
        var valueFormat1 = this.parseUShort();
        var valueFormat2 = this.parseUShort();
        if (posFormat === 1) {
            return {
                posFormat: posFormat,
                coverage: coverage,
                valueFormat1: valueFormat1,
                valueFormat2: valueFormat2,
                pairSets: this.parseList(Parser.pointer(Parser.list(function () {
                    return {
                        secondGlyph: this.parseUShort(),
                        value1: this.parseValueRecord(valueFormat1),
                        value2: this.parseValueRecord(valueFormat2)
                    };
                })))
            };
        } else if (posFormat === 2) {
            var classDef1 = this.parsePointer(Parser.classDef);
            var classDef2 = this.parsePointer(Parser.classDef);
            var class1Count = this.parseUShort();
            var class2Count = this.parseUShort();
            return {
                posFormat: posFormat,
                coverage: coverage,
                valueFormat1: valueFormat1,
                valueFormat2: valueFormat2,
                classDef1: classDef1,
                classDef2: classDef2,
                class1Count: class1Count,
                class2Count: class2Count,
                classRecords: this.parseList(class1Count, Parser.list(class2Count, function () {
                    return {
                        value1: this.parseValueRecord(valueFormat1),
                        value2: this.parseValueRecord(valueFormat2)
                    };
                }))
            };
        }
    };
    subtableParsers$1[3] = function parseLookup3() {
        return { error: 'GPOS Lookup 3 not supported' };
    };
    subtableParsers$1[4] = function parseLookup4() {
        return { error: 'GPOS Lookup 4 not supported' };
    };
    subtableParsers$1[5] = function parseLookup5() {
        return { error: 'GPOS Lookup 5 not supported' };
    };
    subtableParsers$1[6] = function parseLookup6() {
        return { error: 'GPOS Lookup 6 not supported' };
    };
    subtableParsers$1[7] = function parseLookup7() {
        return { error: 'GPOS Lookup 7 not supported' };
    };
    subtableParsers$1[8] = function parseLookup8() {
        return { error: 'GPOS Lookup 8 not supported' };
    };
    subtableParsers$1[9] = function parseLookup9() {
        return { error: 'GPOS Lookup 9 not supported' };
    };
    function parseGposTable(data, start) {
        start = start || 0;
        var p = new Parser(data, start);
        var tableVersion = p.parseVersion(1);
        check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GPOS table version ' + tableVersion);
        if (tableVersion === 1) {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers$1)
            };
        } else {
            return {
                version: tableVersion,
                scripts: p.parseScriptList(),
                features: p.parseFeatureList(),
                lookups: p.parseLookupList(subtableParsers$1),
                variations: p.parseFeatureVariationsList()
            };
        }
    }
    var subtableMakers$1 = new Array(10);
    function makeGposTable(gpos) {
        return new table.Table('GPOS', [
            {
                name: 'version',
                type: 'ULONG',
                value: 65536
            },
            {
                name: 'scripts',
                type: 'TABLE',
                value: new table.ScriptList(gpos.scripts)
            },
            {
                name: 'features',
                type: 'TABLE',
                value: new table.FeatureList(gpos.features)
            },
            {
                name: 'lookups',
                type: 'TABLE',
                value: new table.LookupList(gpos.lookups, subtableMakers$1)
            }
        ]);
    }
    var gpos = {
        parse: parseGposTable,
        make: makeGposTable
    };
    function parseWindowsKernTable(p) {
        var pairs = {};
        p.skip('uShort');
        var subtableVersion = p.parseUShort();
        check.argument(subtableVersion === 0, 'Unsupported kern sub-table version.');
        p.skip('uShort', 2);
        var nPairs = p.parseUShort();
        p.skip('uShort', 3);
        for (var i = 0; i < nPairs; i += 1) {
            var leftIndex = p.parseUShort();
            var rightIndex = p.parseUShort();
            var value = p.parseShort();
            pairs[leftIndex + ',' + rightIndex] = value;
        }
        return pairs;
    }
    function parseMacKernTable(p) {
        var pairs = {};
        p.skip('uShort');
        var nTables = p.parseULong();
        if (nTables > 1) {
            console.warn('Only the first kern subtable is supported.');
        }
        p.skip('uLong');
        var coverage = p.parseUShort();
        var subtableVersion = coverage & 255;
        p.skip('uShort');
        if (subtableVersion === 0) {
            var nPairs = p.parseUShort();
            p.skip('uShort', 3);
            for (var i = 0; i < nPairs; i += 1) {
                var leftIndex = p.parseUShort();
                var rightIndex = p.parseUShort();
                var value = p.parseShort();
                pairs[leftIndex + ',' + rightIndex] = value;
            }
        }
        return pairs;
    }
    function parseKernTable(data, start) {
        var p = new parse.Parser(data, start);
        var tableVersion = p.parseUShort();
        if (tableVersion === 0) {
            return parseWindowsKernTable(p);
        } else if (tableVersion === 1) {
            return parseMacKernTable(p);
        } else {
            throw new Error('Unsupported kern table version (' + tableVersion + ').');
        }
    }
    var kern = { parse: parseKernTable };
    function parseLocaTable(data, start, numGlyphs, shortVersion) {
        var p = new parse.Parser(data, start);
        var parseFn = shortVersion ? p.parseUShort : p.parseULong;
        var glyphOffsets = [];
        for (var i = 0; i < numGlyphs + 1; i += 1) {
            var glyphOffset = parseFn.call(p);
            if (shortVersion) {
                glyphOffset *= 2;
            }
            glyphOffsets.push(glyphOffset);
        }
        return glyphOffsets;
    }
    var loca = { parse: parseLocaTable };
    function loadFromFile(path, callback) {
        var fs = require('fs');
        fs.readFile(path, function (err, buffer) {
            if (err) {
                return callback(err.message);
            }
            callback(null, nodeBufferToArrayBuffer(buffer));
        });
    }
    function loadFromUrl(url, callback) {
        var request = new XMLHttpRequest();
        request.open('get', url, true);
        request.responseType = 'arraybuffer';
        request.onload = function () {
            if (request.response) {
                return callback(null, request.response);
            } else {
                return callback('Font could not be loaded: ' + request.statusText);
            }
        };
        request.onerror = function () {
            callback('Font could not be loaded');
        };
        request.send();
    }
    function parseOpenTypeTableEntries(data, numTables) {
        var tableEntries = [];
        var p = 12;
        for (var i = 0; i < numTables; i += 1) {
            var tag = parse.getTag(data, p);
            var checksum = parse.getULong(data, p + 4);
            var offset = parse.getULong(data, p + 8);
            var length = parse.getULong(data, p + 12);
            tableEntries.push({
                tag: tag,
                checksum: checksum,
                offset: offset,
                length: length,
                compression: false
            });
            p += 16;
        }
        return tableEntries;
    }
    function parseWOFFTableEntries(data, numTables) {
        var tableEntries = [];
        var p = 44;
        for (var i = 0; i < numTables; i += 1) {
            var tag = parse.getTag(data, p);
            var offset = parse.getULong(data, p + 4);
            var compLength = parse.getULong(data, p + 8);
            var origLength = parse.getULong(data, p + 12);
            var compression = void 0;
            if (compLength < origLength) {
                compression = 'WOFF';
            } else {
                compression = false;
            }
            tableEntries.push({
                tag: tag,
                offset: offset,
                compression: compression,
                compressedLength: compLength,
                length: origLength
            });
            p += 20;
        }
        return tableEntries;
    }
    function uncompressTable(data, tableEntry) {
        if (tableEntry.compression === 'WOFF') {
            var inBuffer = new Uint8Array(data.buffer, tableEntry.offset + 2, tableEntry.compressedLength - 2);
            var outBuffer = new Uint8Array(tableEntry.length);
            tinyInflate(inBuffer, outBuffer);
            if (outBuffer.byteLength !== tableEntry.length) {
                throw new Error('Decompression error: ' + tableEntry.tag + ' decompressed length doesn\'t match recorded length');
            }
            var view = new DataView(outBuffer.buffer, 0);
            return {
                data: view,
                offset: 0
            };
        } else {
            return {
                data: data,
                offset: tableEntry.offset
            };
        }
    }
    function parseBuffer(buffer) {
        var indexToLocFormat;
        var ltagTable;
        var font = new Font({ empty: true });
        var data = new DataView(buffer, 0);
        var numTables;
        var tableEntries = [];
        var signature = parse.getTag(data, 0);
        if (signature === String.fromCharCode(0, 1, 0, 0) || signature === 'true' || signature === 'typ1') {
            font.outlinesFormat = 'truetype';
            numTables = parse.getUShort(data, 4);
            tableEntries = parseOpenTypeTableEntries(data, numTables);
        } else if (signature === 'OTTO') {
            font.outlinesFormat = 'cff';
            numTables = parse.getUShort(data, 4);
            tableEntries = parseOpenTypeTableEntries(data, numTables);
        } else if (signature === 'wOFF') {
            var flavor = parse.getTag(data, 4);
            if (flavor === String.fromCharCode(0, 1, 0, 0)) {
                font.outlinesFormat = 'truetype';
            } else if (flavor === 'OTTO') {
                font.outlinesFormat = 'cff';
            } else {
                throw new Error('Unsupported OpenType flavor ' + signature);
            }
            numTables = parse.getUShort(data, 12);
            tableEntries = parseWOFFTableEntries(data, numTables);
        } else {
            throw new Error('Unsupported OpenType signature ' + signature);
        }
        var cffTableEntry;
        var fvarTableEntry;
        var glyfTableEntry;
        var gposTableEntry;
        var gsubTableEntry;
        var hmtxTableEntry;
        var kernTableEntry;
        var locaTableEntry;
        var nameTableEntry;
        var metaTableEntry;
        var p;
        for (var i = 0; i < numTables; i += 1) {
            var tableEntry = tableEntries[i];
            var table = void 0;
            switch (tableEntry.tag) {
            case 'cmap':
                table = uncompressTable(data, tableEntry);
                font.tables.cmap = cmap.parse(table.data, table.offset);
                font.encoding = new CmapEncoding(font.tables.cmap);
                break;
            case 'cvt ':
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.cvt = p.parseShortList(tableEntry.length / 2);
                break;
            case 'fvar':
                fvarTableEntry = tableEntry;
                break;
            case 'fpgm':
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.fpgm = p.parseByteList(tableEntry.length);
                break;
            case 'head':
                table = uncompressTable(data, tableEntry);
                font.tables.head = head.parse(table.data, table.offset);
                font.unitsPerEm = font.tables.head.unitsPerEm;
                indexToLocFormat = font.tables.head.indexToLocFormat;
                break;
            case 'hhea':
                table = uncompressTable(data, tableEntry);
                font.tables.hhea = hhea.parse(table.data, table.offset);
                font.ascender = font.tables.hhea.ascender;
                font.descender = font.tables.hhea.descender;
                font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
                break;
            case 'hmtx':
                hmtxTableEntry = tableEntry;
                break;
            case 'ltag':
                table = uncompressTable(data, tableEntry);
                ltagTable = ltag.parse(table.data, table.offset);
                break;
            case 'maxp':
                table = uncompressTable(data, tableEntry);
                font.tables.maxp = maxp.parse(table.data, table.offset);
                font.numGlyphs = font.tables.maxp.numGlyphs;
                break;
            case 'name':
                nameTableEntry = tableEntry;
                break;
            case 'OS/2':
                table = uncompressTable(data, tableEntry);
                font.tables.os2 = os2.parse(table.data, table.offset);
                break;
            case 'post':
                table = uncompressTable(data, tableEntry);
                font.tables.post = post.parse(table.data, table.offset);
                font.glyphNames = new GlyphNames(font.tables.post);
                break;
            case 'prep':
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.prep = p.parseByteList(tableEntry.length);
                break;
            case 'glyf':
                glyfTableEntry = tableEntry;
                break;
            case 'loca':
                locaTableEntry = tableEntry;
                break;
            case 'CFF ':
                cffTableEntry = tableEntry;
                break;
            case 'kern':
                kernTableEntry = tableEntry;
                break;
            case 'GPOS':
                gposTableEntry = tableEntry;
                break;
            case 'GSUB':
                gsubTableEntry = tableEntry;
                break;
            case 'meta':
                metaTableEntry = tableEntry;
                break;
            }
        }
        var nameTable = uncompressTable(data, nameTableEntry);
        font.tables.name = _name.parse(nameTable.data, nameTable.offset, ltagTable);
        font.names = font.tables.name;
        if (glyfTableEntry && locaTableEntry) {
            var shortVersion = indexToLocFormat === 0;
            var locaTable = uncompressTable(data, locaTableEntry);
            var locaOffsets = loca.parse(locaTable.data, locaTable.offset, font.numGlyphs, shortVersion);
            var glyfTable = uncompressTable(data, glyfTableEntry);
            font.glyphs = glyf.parse(glyfTable.data, glyfTable.offset, locaOffsets, font);
        } else if (cffTableEntry) {
            var cffTable = uncompressTable(data, cffTableEntry);
            cff.parse(cffTable.data, cffTable.offset, font);
        } else {
            throw new Error('Font doesn\'t contain TrueType or CFF outlines.');
        }
        var hmtxTable = uncompressTable(data, hmtxTableEntry);
        hmtx.parse(hmtxTable.data, hmtxTable.offset, font.numberOfHMetrics, font.numGlyphs, font.glyphs);
        addGlyphNames(font);
        if (kernTableEntry) {
            var kernTable = uncompressTable(data, kernTableEntry);
            font.kerningPairs = kern.parse(kernTable.data, kernTable.offset);
        } else {
            font.kerningPairs = {};
        }
        if (gposTableEntry) {
            var gposTable = uncompressTable(data, gposTableEntry);
            font.tables.gpos = gpos.parse(gposTable.data, gposTable.offset);
            font.position.init();
        }
        if (gsubTableEntry) {
            var gsubTable = uncompressTable(data, gsubTableEntry);
            font.tables.gsub = gsub.parse(gsubTable.data, gsubTable.offset);
        }
        if (fvarTableEntry) {
            var fvarTable = uncompressTable(data, fvarTableEntry);
            font.tables.fvar = fvar.parse(fvarTable.data, fvarTable.offset, font.names);
        }
        if (metaTableEntry) {
            var metaTable = uncompressTable(data, metaTableEntry);
            font.tables.meta = meta.parse(metaTable.data, metaTable.offset);
            font.metas = font.tables.meta;
        }
        return font;
    }
    function load(url, callback) {
        var isNode$$1 = typeof window === 'undefined';
        var loadFn = isNode$$1 ? loadFromFile : loadFromUrl;
        loadFn(url, function (err, arrayBuffer) {
            if (err) {
                return callback(err);
            }
            var font;
            try {
                font = parseBuffer(arrayBuffer);
            } catch (e) {
                return callback(e, null);
            }
            return callback(null, font);
        });
    }
    function loadSync(url) {
        var fs = require('fs');
        var buffer = fs.readFileSync(url);
        return parseBuffer(nodeBufferToArrayBuffer(buffer));
    }
    exports.Font = Font;
    exports.Glyph = Glyph;
    exports.Path = Path;
    exports.BoundingBox = BoundingBox;
    exports._parse = parse;
    exports.parse = parseBuffer;
    exports.load = load;
    exports.loadSync = loadSync;
    Object.defineProperty(exports, '__esModule', { value: true });
}));
}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":404,"fs":402}],888:[function(require,module,exports){
(function (global){(function (){
/**
 * JSON parse.
 *
 * @see Based on jQuery#parseJSON (MIT) and JSON2
 * @api private
 */

var rvalidchars = /^[\],:{}\s]*$/;
var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
var rtrimLeft = /^\s+/;
var rtrimRight = /\s+$/;

module.exports = function parsejson(data) {
  if ('string' != typeof data || !data) {
    return null;
  }

  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');

  // Attempt to parse using the native JSON parser first
  if (global.JSON && JSON.parse) {
    return JSON.parse(data);
  }

  if (rvalidchars.test(data.replace(rvalidescape, '@')
      .replace(rvalidtokens, ']')
      .replace(rvalidbraces, ''))) {
    return (new Function('return ' + data))();
  }
};
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],889:[function(require,module,exports){
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};

},{}],890:[function(require,module,exports){
/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};

},{}],891:[function(require,module,exports){
(function (process){(function (){
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);



}).call(this)}).call(this,require('_process'))
},{"_process":405}],892:[function(require,module,exports){
(function (process){(function (){
'use strict';

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this)}).call(this,require('_process'))
},{"_process":405}],893:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var printWarning = function() {};

if ("production" !== 'production') {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if ("production" !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if ("production" !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;

},{"./lib/ReactPropTypesSecret":897}],894:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

},{"./lib/ReactPropTypesSecret":897}],895:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var ReactIs = require('react-is');
var assign = require('object-assign');

var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
var checkPropTypes = require('./checkPropTypes');

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if ("production" !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if ("production" !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if ("production" !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if ("production" !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      "production" !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

},{"./checkPropTypes":893,"./lib/ReactPropTypesSecret":897,"object-assign":879,"react-is":1028}],896:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if ("production" !== 'production') {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require('./factoryWithThrowingShims')();
}

},{"./factoryWithThrowingShims":894,"./factoryWithTypeCheckers":895,"react-is":1028}],897:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

},{}],898:[function(require,module,exports){
(function (global){(function (){
var now = require('performance-now')
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"performance-now":891}],899:[function(require,module,exports){
// randomColor by David Merfield under the CC0 license
// https://github.com/davidmerfield/randomColor/

;(function(root, factory) {

  // Support CommonJS
  if (typeof exports === 'object') {
    var randomColor = factory();

    // Support NodeJS & Component, which allow module.exports to be a function
    if (typeof module === 'object' && module && module.exports) {
      exports = module.exports = randomColor;
    }

    // Support CommonJS 1.1.1 spec
    exports.randomColor = randomColor;

  // Support AMD
  } else if (typeof define === 'function' && define.amd) {
    define([], factory);

  // Support vanilla script loading
  } else {
    root.randomColor = factory();
  }

}(this, function() {

  // Seed to get repeatable colors
  var seed = null;

  // Shared color dictionary
  var colorDictionary = {};

  // Populate the color dictionary
  loadColorBounds();

  // check if a range is taken
  var colorRanges = [];

  var randomColor = function (options) {

    options = options || {};

    // Check if there is a seed and ensure it's an
    // integer. Otherwise, reset the seed value.
    if (options.seed !== undefined && options.seed !== null && options.seed === parseInt(options.seed, 10)) {
      seed = options.seed;

    // A string was passed as a seed
    } else if (typeof options.seed === 'string') {
      seed = stringToInteger(options.seed);

    // Something was passed as a seed but it wasn't an integer or string
    } else if (options.seed !== undefined && options.seed !== null) {
      throw new TypeError('The seed value must be an integer or string');

    // No seed, reset the value outside.
    } else {
      seed = null;
    }

    var H,S,B;

    // Check if we need to generate multiple colors
    if (options.count !== null && options.count !== undefined) {

      var totalColors = options.count,
          colors = [];
      // Value false at index i means the range i is not taken yet.
      for (var i = 0; i < options.count; i++) {
        colorRanges.push(false)
        }
      options.count = null;

      while (totalColors > colors.length) {

        // Since we're generating multiple colors,
        // incremement the seed. Otherwise we'd just
        // generate the same color each time...
        if (seed && options.seed) options.seed += 1;

        colors.push(randomColor(options));
      }

      options.count = totalColors;

      return colors;
    }

    // First we pick a hue (H)
    H = pickHue(options);

    // Then use H to determine saturation (S)
    S = pickSaturation(H, options);

    // Then use S and H to determine brightness (B).
    B = pickBrightness(H, S, options);

    // Then we return the HSB color in the desired format
    return setFormat([H,S,B], options);
  };

  function pickHue(options) {
    if (colorRanges.length > 0) {
      var hueRange = getRealHueRange(options.hue)

      var hue = randomWithin(hueRange)

      //Each of colorRanges.length ranges has a length equal approximatelly one step
      var step = (hueRange[1] - hueRange[0]) / colorRanges.length

      var j = parseInt((hue - hueRange[0]) / step)

      //Check if the range j is taken
      if (colorRanges[j] === true) {
        j = (j + 2) % colorRanges.length
      }
      else {
        colorRanges[j] = true
           }

      var min = (hueRange[0] + j * step) % 359,
          max = (hueRange[0] + (j + 1) * step) % 359;

      hueRange = [min, max]

      hue = randomWithin(hueRange)

      if (hue < 0) {hue = 360 + hue;}
      return hue
    }
    else {
      var hueRange = getHueRange(options.hue)

      hue = randomWithin(hueRange);
      // Instead of storing red as two seperate ranges,
      // we group them, using negative numbers
      if (hue < 0) {
        hue = 360 + hue;
      }

      return hue;
    }
  }

  function pickSaturation (hue, options) {

    if (options.hue === 'monochrome') {
      return 0;
    }

    if (options.luminosity === 'random') {
      return randomWithin([0,100]);
    }

    var saturationRange = getSaturationRange(hue);

    var sMin = saturationRange[0],
        sMax = saturationRange[1];

    switch (options.luminosity) {

      case 'bright':
        sMin = 55;
        break;

      case 'dark':
        sMin = sMax - 10;
        break;

      case 'light':
        sMax = 55;
        break;
   }

    return randomWithin([sMin, sMax]);

  }

  function pickBrightness (H, S, options) {

    var bMin = getMinimumBrightness(H, S),
        bMax = 100;

    switch (options.luminosity) {

      case 'dark':
        bMax = bMin + 20;
        break;

      case 'light':
        bMin = (bMax + bMin)/2;
        break;

      case 'random':
        bMin = 0;
        bMax = 100;
        break;
    }

    return randomWithin([bMin, bMax]);
  }

  function setFormat (hsv, options) {

    switch (options.format) {

      case 'hsvArray':
        return hsv;

      case 'hslArray':
        return HSVtoHSL(hsv);

      case 'hsl':
        var hsl = HSVtoHSL(hsv);
        return 'hsl('+hsl[0]+', '+hsl[1]+'%, '+hsl[2]+'%)';

      case 'hsla':
        var hslColor = HSVtoHSL(hsv);
        var alpha = options.alpha || Math.random();
        return 'hsla('+hslColor[0]+', '+hslColor[1]+'%, '+hslColor[2]+'%, ' + alpha + ')';

      case 'rgbArray':
        return HSVtoRGB(hsv);

      case 'rgb':
        var rgb = HSVtoRGB(hsv);
        return 'rgb(' + rgb.join(', ') + ')';

      case 'rgba':
        var rgbColor = HSVtoRGB(hsv);
        var alpha = options.alpha || Math.random();
        return 'rgba(' + rgbColor.join(', ') + ', ' + alpha + ')';

      default:
        return HSVtoHex(hsv);
    }

  }

  function getMinimumBrightness(H, S) {

    var lowerBounds = getColorInfo(H).lowerBounds;

    for (var i = 0; i < lowerBounds.length - 1; i++) {

      var s1 = lowerBounds[i][0],
          v1 = lowerBounds[i][1];

      var s2 = lowerBounds[i+1][0],
          v2 = lowerBounds[i+1][1];

      if (S >= s1 && S <= s2) {

         var m = (v2 - v1)/(s2 - s1),
             b = v1 - m*s1;

         return m*S + b;
      }

    }

    return 0;
  }

  function getHueRange (colorInput) {

    if (typeof parseInt(colorInput) === 'number') {

      var number = parseInt(colorInput);

      if (number < 360 && number > 0) {
        return [number, number];
      }

    }

    if (typeof colorInput === 'string') {

      if (colorDictionary[colorInput]) {
        var color = colorDictionary[colorInput];
        if (color.hueRange) {return color.hueRange;}
      } else if (colorInput.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
        var hue = HexToHSB(colorInput)[0];
        return [ hue, hue ];
      }
    }

    return [0,360];

  }

  function getSaturationRange (hue) {
    return getColorInfo(hue).saturationRange;
  }

  function getColorInfo (hue) {

    // Maps red colors to make picking hue easier
    if (hue >= 334 && hue <= 360) {
      hue-= 360;
    }

    for (var colorName in colorDictionary) {
       var color = colorDictionary[colorName];
       if (color.hueRange &&
           hue >= color.hueRange[0] &&
           hue <= color.hueRange[1]) {
          return colorDictionary[colorName];
       }
    } return 'Color not found';
  }

  function randomWithin (range) {
    if (seed === null) {
      //generate random evenly destinct number from : https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
      var golden_ratio = 0.618033988749895
      var r=Math.random()
      r += golden_ratio
      r %= 1
      return Math.floor(range[0] + r*(range[1] + 1 - range[0]));
    } else {
      //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
      var max = range[1] || 1;
      var min = range[0] || 0;
      seed = (seed * 9301 + 49297) % 233280;
      var rnd = seed / 233280.0;
      return Math.floor(min + rnd * (max - min));
}
  }

  function HSVtoHex (hsv){

    var rgb = HSVtoRGB(hsv);

    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);

    return hex;

  }

  function defineColor (name, hueRange, lowerBounds) {

    var sMin = lowerBounds[0][0],
        sMax = lowerBounds[lowerBounds.length - 1][0],

        bMin = lowerBounds[lowerBounds.length - 1][1],
        bMax = lowerBounds[0][1];

    colorDictionary[name] = {
      hueRange: hueRange,
      lowerBounds: lowerBounds,
      saturationRange: [sMin, sMax],
      brightnessRange: [bMin, bMax]
    };

  }

  function loadColorBounds () {

    defineColor(
      'monochrome',
      null,
      [[0,0],[100,0]]
    );

    defineColor(
      'red',
      [-26,18],
      [[20,100],[30,92],[40,89],[50,85],[60,78],[70,70],[80,60],[90,55],[100,50]]
    );

    defineColor(
      'orange',
      [19,46],
      [[20,100],[30,93],[40,88],[50,86],[60,85],[70,70],[100,70]]
    );

    defineColor(
      'yellow',
      [47,62],
      [[25,100],[40,94],[50,89],[60,86],[70,84],[80,82],[90,80],[100,75]]
    );

    defineColor(
      'green',
      [63,178],
      [[30,100],[40,90],[50,85],[60,81],[70,74],[80,64],[90,50],[100,40]]
    );

    defineColor(
      'blue',
      [179, 257],
      [[20,100],[30,86],[40,80],[50,74],[60,60],[70,52],[80,44],[90,39],[100,35]]
    );

    defineColor(
      'purple',
      [258, 282],
      [[20,100],[30,87],[40,79],[50,70],[60,65],[70,59],[80,52],[90,45],[100,42]]
    );

    defineColor(
      'pink',
      [283, 334],
      [[20,100],[30,90],[40,86],[60,84],[80,80],[90,75],[100,73]]
    );

  }

  function HSVtoRGB (hsv) {

    // this doesn't work for the values of 0 and 360
    // here's the hacky fix
    var h = hsv[0];
    if (h === 0) {h = 1;}
    if (h === 360) {h = 359;}

    // Rebase the h,s,v values
    h = h/360;
    var s = hsv[1]/100,
        v = hsv[2]/100;

    var h_i = Math.floor(h*6),
      f = h * 6 - h_i,
      p = v * (1 - s),
      q = v * (1 - f*s),
      t = v * (1 - (1 - f)*s),
      r = 256,
      g = 256,
      b = 256;

    switch(h_i) {
      case 0: r = v; g = t; b = p;  break;
      case 1: r = q; g = v; b = p;  break;
      case 2: r = p; g = v; b = t;  break;
      case 3: r = p; g = q; b = v;  break;
      case 4: r = t; g = p; b = v;  break;
      case 5: r = v; g = p; b = q;  break;
    }

    var result = [Math.floor(r*255), Math.floor(g*255), Math.floor(b*255)];
    return result;
  }

  function HexToHSB (hex) {
    hex = hex.replace(/^#/, '');
    hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;

    var red = parseInt(hex.substr(0, 2), 16) / 255,
          green = parseInt(hex.substr(2, 2), 16) / 255,
          blue = parseInt(hex.substr(4, 2), 16) / 255;

    var cMax = Math.max(red, green, blue),
          delta = cMax - Math.min(red, green, blue),
          saturation = cMax ? (delta / cMax) : 0;

    switch (cMax) {
      case red: return [ 60 * (((green - blue) / delta) % 6) || 0, saturation, cMax ];
      case green: return [ 60 * (((blue - red) / delta) + 2) || 0, saturation, cMax ];
      case blue: return [ 60 * (((red - green) / delta) + 4) || 0, saturation, cMax ];
    }
  }

  function HSVtoHSL (hsv) {
    var h = hsv[0],
      s = hsv[1]/100,
      v = hsv[2]/100,
      k = (2-s)*v;

    return [
      h,
      Math.round(s*v / (k<1 ? k : 2-k) * 10000) / 100,
      k/2 * 100
    ];
  }

  function stringToInteger (string) {
    var total = 0
    for (var i = 0; i !== string.length; i++) {
      if (total >= Number.MAX_SAFE_INTEGER) break;
      total += string.charCodeAt(i)
    }
    return total
  }

  // get The range of given hue when options.count!=0
  function getRealHueRange(colorHue)
  { if (!isNaN(colorHue)) {
    var number = parseInt(colorHue);

    if (number < 360 && number > 0) {
      return getColorInfo(colorHue).hueRange
    }
  }
    else if (typeof colorHue === 'string') {

      if (colorDictionary[colorHue]) {
        var color = colorDictionary[colorHue];

        if (color.hueRange) {
          return color.hueRange
       }
    } else if (colorHue.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
        var hue = HexToHSB(colorHue)[0]
        return getColorInfo(hue).hueRange
    }
  }

    return [0,360]
}
  return randomColor;
}));

},{}],900:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */

'use strict';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;

},{}],901:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = require('../common');

var _AlphaPointer = require('./AlphaPointer');

var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

exports.default = (0, _common.ColorWrap)(AlphaPicker);
},{"../common":919,"./AlphaPointer":902,"react":1107,"reactcss":1113}],902:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPointer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = AlphaPointer;
},{"react":1107,"reactcss":1113}],903:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

var _BlockSwatches = require('./BlockSwatches');

var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = exports.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    color.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: color.getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['top', 'hide']),
  styles: _propTypes2.default.object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Block);
},{"../../helpers/color":951,"../common":919,"./BlockSwatches":904,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],904:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockSwatches = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = BlockSwatches;
},{"../common":919,"lodash/map":861,"react":1107,"reactcss":1113}],905:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _ChromeFields = require('./ChromeFields');

var _ChromeFields2 = _interopRequireDefault(_ChromeFields);

var _ChromePointer = require('./ChromePointer');

var _ChromePointer2 = _interopRequireDefault(_ChromePointer);

var _ChromePointerCircle = require('./ChromePointerCircle');

var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  disableAlpha: _propTypes2.default.bool,
  styles: _propTypes2.default.object,
  defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Chrome);
},{"../common":919,"./ChromeFields":906,"./ChromePointer":907,"./ChromePointerCircle":908,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],906:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _common = require('../common');

var _UnfoldMoreHorizontalIcon = require('@icons/material/UnfoldMoreHorizontalIcon');

var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(_UnfoldMoreHorizontalIcon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck(this, ChromeFields);

    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        color.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

exports.default = ChromeFields;
},{"../../helpers/color":951,"../common":919,"@icons/material/UnfoldMoreHorizontalIcon":327,"lodash/isUndefined":856,"react":1107,"reactcss":1113}],907:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;
},{"react":1107,"reactcss":1113}],908:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;
},{"react":1107,"reactcss":1113}],909:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _materialColors = require('material-colors');

var material = _interopRequireWildcard(_materialColors);

var _common = require('../common');

var _CircleSwatch = require('./CircleSwatch');

var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = exports.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  circleSize: _propTypes2.default.number,
  circleSpacing: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Circle);
},{"../common":919,"./CircleSwatch":910,"lodash/map":861,"lodash/merge":863,"material-colors":875,"prop-types":896,"react":1107,"reactcss":1113}],910:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSwatch = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

exports.default = (0, _reactcss.handleHover)(CircleSwatch);
},{"../common":919,"react":1107,"reactcss":1113}],911:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = require('../../helpers/alpha');

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = require('./Checkboard');

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports.default = Alpha;
},{"../../helpers/alpha":949,"./Checkboard":912,"react":1107,"reactcss":1113}],912:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = require('../../helpers/checkboard');

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0, _react.isValidElement)(children) ? _react2.default.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;
},{"../../helpers/checkboard":950,"react":1107,"reactcss":1113}],913:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = color.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = color.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color.toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, color.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends({}, color.toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;
},{"../../helpers/color":951,"lodash/debounce":832,"react":1107}],914:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports.default = EditableInput;
},{"react":1107,"reactcss":1113}],915:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = require('../../helpers/hue');

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports.default = Hue;
},{"../../helpers/hue":952,"react":1107,"reactcss":1113}],916:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

exports.default = Raised;
},{"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],917:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = require('../../helpers/saturation');

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports.default = Saturation;
},{"../../helpers/saturation":954,"lodash/throttle":869,"react":1107,"reactcss":1113}],918:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = require('../../helpers/interaction');

var _Checkboard = require('./Checkboard');

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, _interaction.handleFocus)(Swatch);
},{"../../helpers/interaction":953,"./Checkboard":912,"react":1107,"reactcss":1113}],919:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = require('./Alpha');

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = require('./Checkboard');

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = require('./EditableInput');

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = require('./Hue');

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = require('./Raised');

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = require('./Saturation');

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = require('./ColorWrap');

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = require('./Swatch');

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./Alpha":911,"./Checkboard":912,"./ColorWrap":913,"./EditableInput":914,"./Hue":915,"./Raised":916,"./Saturation":917,"./Swatch":918}],920:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compact = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

var _CompactColor = require('./CompactColor');

var _CompactColor2 = _interopRequireDefault(_CompactColor);

var _CompactFields = require('./CompactFields');

var _CompactFields2 = _interopRequireDefault(_CompactFields);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = exports.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { style: styles.Compact, styles: passedStyles },
    _react2.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2.default.createElement(
        'div',
        null,
        (0, _map2.default)(colors, function (c) {
          return _react2.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2.default.createElement('div', { style: styles.clear })
      ),
      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  styles: _propTypes2.default.object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Compact);
},{"../../helpers/color":951,"../common":919,"./CompactColor":921,"./CompactFields":922,"lodash/map":861,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],921:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactColor = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = require('../../helpers/color');

var colorUtils = _interopRequireWildcard(_color);

var _common = require('../common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = exports.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: colorUtils.getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2.default.createElement(
    _common.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement('div', { style: styles.dot })
  );
};

exports.default = CompactColor;
},{"../../helpers/color":951,"../common":919,"react":1107,"reactcss":1113}],922:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactFields = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = exports.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement('div', { style: styles.active }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

exports.default = CompactFields;
},{"../common":919,"react":1107,"reactcss":1113}],923:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Github = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _GithubSwatch = require('./GithubSwatch');

var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = exports.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: _propTypes2.default.object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Github);
},{"../common":919,"./GithubSwatch":924,"lodash/map":861,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],924:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GithubSwatch = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

exports.default = (0, _reactcss.handleHover)(GithubSwatch);
},{"../common":919,"react":1107,"reactcss":1113}],925:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Google = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _GooglePointerCircle = require('./GooglePointerCircle');

var _GooglePointerCircle2 = _interopRequireDefault(_GooglePointerCircle);

var _GooglePointer = require('./GooglePointer');

var _GooglePointer2 = _interopRequireDefault(_GooglePointer);

var _GoogleFields = require('./GoogleFields');

var _GoogleFields2 = _interopRequireDefault(_GoogleFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Google = exports.Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'google-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.head },
      header
    ),
    _react2.default.createElement('div', { style: styles.swatch }),
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        hsl: hsl,
        hsv: hsv,
        pointer: _GooglePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            radius: '4px',
            pointer: _GooglePointer2.default,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(_GoogleFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
      })
    )
  );
};

Google.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  styles: _propTypes2.default.object,
  header: _propTypes2.default.string

};

Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};

exports.default = (0, _common.ColorWrap)(Google);
},{"../common":919,"./GoogleFields":926,"./GooglePointer":927,"./GooglePointerCircle":928,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],926:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleFields = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleFields = exports.GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;


  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      color.isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');
      if (color.isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');
      if (color.isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      double: {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });

  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';

  return _react2.default.createElement(
    'div',
    { style: styles.wrap, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.fields },
      _react2.default.createElement(
        'div',
        { style: styles.double },
        _react2.default.createElement(_common.EditableInput, {
          style: { input: styles.input, label: styles.label },
          label: 'hex',
          value: hex,
          onChange: handleChange
        })
      ),
      _react2.default.createElement(
        'div',
        { style: styles.column },
        _react2.default.createElement(
          'div',
          { style: styles.single },
          _react2.default.createElement(_common.EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'rgb',
            value: rgbValue,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.single },
          _react2.default.createElement(_common.EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsv',
            value: hsvValue,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.single },
          _react2.default.createElement(_common.EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsl',
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = GoogleFields;
},{"../../helpers/color":951,"../common":919,"react":1107,"reactcss":1113}],927:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GooglePointer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GooglePointer = exports.GooglePointer = function GooglePointer(props) {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

GooglePointer.propTypes = {
  hsl: _propTypes2.default.shape({
    h: _propTypes2.default.number,
    s: _propTypes2.default.number,
    l: _propTypes2.default.number,
    a: _propTypes2.default.number
  })
};

GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

exports.default = GooglePointer;
},{"prop-types":896,"react":1107,"reactcss":1113}],928:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GooglePointerCircle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GooglePointerCircle = exports.GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

GooglePointerCircle.propTypes = {
  hsl: _propTypes2.default.shape({
    h: _propTypes2.default.number,
    s: _propTypes2.default.number,
    l: _propTypes2.default.number,
    a: _propTypes2.default.number
  })
};

GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

exports.default = GooglePointerCircle;
},{"prop-types":896,"react":1107,"reactcss":1113}],929:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HuePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _HuePointer = require('./HuePointer');

var _HuePointer2 = _interopRequireDefault(_HuePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = exports.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: _propTypes2.default.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default,
  styles: {}
};

exports.default = (0, _common.ColorWrap)(HuePicker);
},{"../common":919,"./HuePointer":930,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],930:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;
},{"react":1107,"reactcss":1113}],931:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Material = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = exports.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { styles: passedStyles },
    _react2.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2.default.createElement(_common.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = (0, _common.ColorWrap)(Material);
},{"../../helpers/color":951,"../common":919,"lodash/merge":863,"react":1107,"reactcss":1113}],932:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Photoshop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _PhotoshopFields = require('./PhotoshopFields');

var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);

var _PhotoshopPointerCircle = require('./PhotoshopPointerCircle');

var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);

var _PhotoshopPointer = require('./PhotoshopPointer');

var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);

var _PhotoshopButton = require('./PhotoshopButton');

var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);

var _PhotoshopPreviews = require('./PhotoshopPreviews');

var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = exports.Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2.default)((0, _merge2.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return _react2.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.saturation },
            _react2.default.createElement(_common.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.controls },
            _react2.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2.default.createElement(
                'div',
                { style: styles.previews },
                _react2.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2.default.createElement(
                'div',
                { style: styles.actions },
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2.default.Component);

Photoshop.propTypes = {
  header: _propTypes2.default.string,
  styles: _propTypes2.default.object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Photoshop);
},{"../common":919,"./PhotoshopButton":933,"./PhotoshopFields":934,"./PhotoshopPointer":935,"./PhotoshopPointerCircle":936,"./PhotoshopPreviews":937,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],933:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopButton = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

exports.default = PhotoshopButton;
},{"react":1107,"reactcss":1113}],934:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPicker = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      color.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields },
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

exports.default = PhotoshopPicker;
},{"../../helpers/color":951,"../common":919,"react":1107,"reactcss":1113}],935:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.pointer },
    _react2.default.createElement(
      'div',
      { style: styles.left },
      _react2.default.createElement('div', { style: styles.leftInside })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.right },
      _react2.default.createElement('div', { style: styles.rightInside })
    )
  );
};

exports.default = PhotoshopPointerCircle;
},{"react":1107,"reactcss":1113}],936:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = PhotoshopPointerCircle;
},{"react":1107,"reactcss":1113}],937:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPreviews = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement('div', { style: styles.new }),
      _react2.default.createElement('div', { style: styles.current })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

exports.default = PhotoshopPreviews;
},{"react":1107,"reactcss":1113}],938:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sketch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _SketchFields = require('./SketchFields');

var _SketchFields2 = _interopRequireDefault(_SketchFields);

var _SketchPresetColors = require('./SketchPresetColors');

var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = exports.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': _extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2.default.createElement(
        'div',
        { style: styles.sliders },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.alpha },
          _react2.default.createElement(_common.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: styles.color },
        _react2.default.createElement(_common.Checkboard, null),
        _react2.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2.default.bool,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  styles: _propTypes2.default.object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

exports.default = (0, _common.ColorWrap)(Sketch);
},{"../common":919,"./SketchFields":939,"./SketchPresetColors":940,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],939:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchFields = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = exports.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.double },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.alpha },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

exports.default = SketchFields;
},{"../../helpers/color":951,"../common":919,"react":1107,"reactcss":1113}],940:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchPresetColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2.default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        _react2.default.createElement(_common.Swatch, _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    color: _propTypes2.default.string,
    title: _propTypes2.default.string
  })])).isRequired
};

exports.default = SketchPresetColors;
},{"../common":919,"prop-types":896,"react":1107,"reactcss":1113}],941:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _common = require('../common');

var _SliderSwatches = require('./SliderSwatches');

var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);

var _SliderPointer = require('./SliderPointer');

var _SliderPointer2 = _interopRequireDefault(_SliderPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return _react2.default.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.hue },
      _react2.default.createElement(_common.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: _propTypes2.default.object
};
Slider.defaultProps = {
  pointer: _SliderPointer2.default,
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Slider);
},{"../common":919,"./SliderPointer":942,"./SliderSwatches":944,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],942:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;
},{"react":1107,"reactcss":1113}],943:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatch = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

exports.default = SliderSwatch;
},{"react":1107,"reactcss":1113}],944:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _SliderSwatch = require('./SliderSwatch');

var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = SliderSwatches;
},{"./SliderSwatch":943,"react":1107,"reactcss":1113}],945:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatches = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _materialColors = require('material-colors');

var material = _interopRequireWildcard(_materialColors);

var _common = require('../common');

var _SwatchesGroup = require('./SwatchesGroup');

var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = exports.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2.default.createElement(
      _common.Raised,
      null,
      _react2.default.createElement(
        'div',
        { style: styles.overflow },
        _react2.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2.default)(colors, function (group) {
            return _react2.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
  styles: _propTypes2.default.object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Swatches);
},{"../common":919,"./SwatchesGroup":947,"lodash/map":861,"lodash/merge":863,"material-colors":875,"prop-types":896,"react":1107,"reactcss":1113}],946:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = require('../../helpers/color');

var colorUtils = _interopRequireWildcard(_color);

var _common = require('../common');

var _CheckIcon = require('@icons/material/CheckIcon');

var _CheckIcon2 = _interopRequireDefault(_CheckIcon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: colorUtils.getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2.default.createElement(
    _common.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement(
      'div',
      { style: styles.check },
      _react2.default.createElement(_CheckIcon2.default, null)
    )
  );
};

exports.default = SwatchesColor;
},{"../../helpers/color":951,"../common":919,"@icons/material/CheckIcon":326,"react":1107,"reactcss":1113}],947:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesGroup = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _SwatchesColor = require('./SwatchesColor');

var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

exports.default = SwatchesGroup;
},{"./SwatchesColor":946,"lodash/map":861,"react":1107,"reactcss":1113}],948:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _color = require('../../helpers/color');

var color = _interopRequireWildcard(_color);

var _common = require('../common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = exports.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    color.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2.default.createElement(_common.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2.default.createElement(_common.EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  styles: _propTypes2.default.object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Twitter);
},{"../../helpers/color":951,"../common":919,"lodash/map":861,"lodash/merge":863,"prop-types":896,"react":1107,"reactcss":1113}],949:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};
},{}],950:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
},{}],951:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isvalidColorString = exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  (0, _each2.default)(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = exports.toState = function toState(data, oldHue) {
  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = exports.isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
};

var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

var isvalidColorString = exports.isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};
},{"lodash/each":833,"tinycolor2":1204}],952:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};
},{}],953:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2.default.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2.default.Component);
};
},{"react":1107}],954:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};
},{}],955:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.GooglePicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;

var _Alpha = require('./components/alpha/Alpha');

Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Block = require('./components/block/Block');

Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Block).default;
  }
});

var _Circle = require('./components/circle/Circle');

Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Chrome = require('./components/chrome/Chrome');

Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chrome).default;
  }
});

var _Compact = require('./components/compact/Compact');

Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compact).default;
  }
});

var _Github = require('./components/github/Github');

Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Github).default;
  }
});

var _Hue = require('./components/hue/Hue');

Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Material = require('./components/material/Material');

Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Material).default;
  }
});

var _Photoshop = require('./components/photoshop/Photoshop');

Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Photoshop).default;
  }
});

var _Sketch = require('./components/sketch/Sketch');

Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sketch).default;
  }
});

var _Slider = require('./components/slider/Slider');

Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Swatches = require('./components/swatches/Swatches');

Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatches).default;
  }
});

var _Twitter = require('./components/twitter/Twitter');

Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitter).default;
  }
});

var _Google = require('./components/google/Google');

Object.defineProperty(exports, 'GooglePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Google).default;
  }
});

var _ColorWrap = require('./components/common/ColorWrap');

Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Chrome2 = _interopRequireDefault(_Chrome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;
},{"./components/alpha/Alpha":901,"./components/block/Block":903,"./components/chrome/Chrome":905,"./components/circle/Circle":909,"./components/common/ColorWrap":913,"./components/compact/Compact":920,"./components/github/Github":923,"./components/google/Google":925,"./components/hue/Hue":929,"./components/material/Material":931,"./components/photoshop/Photoshop":932,"./components/sketch/Sketch":938,"./components/slider/Slider":941,"./components/swatches/Swatches":945,"./components/twitter/Twitter":948}],956:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSafari = exports.isFirefox = void 0;
var _jsUtilsJs = require("./utils/js_utils.js");
const isFirefox = (0, _jsUtilsJs).memoize(()=>/firefox/i.test(navigator.userAgent)
);
exports.isFirefox = isFirefox;
const isSafari = (0, _jsUtilsJs).memoize(()=>Boolean(window.safari)
);
exports.isSafari = isSafari;


},{"./utils/js_utils.js":969}],957:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _jsUtilsJs = require("./utils/js_utils.js");
class EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode))
        ;
        this.entered = (0, _jsUtilsJs).union(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, _jsUtilsJs).without(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}
exports.EnterLeaveCounter = EnterLeaveCounter;


},{"./utils/js_utils.js":969}],958:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _enterLeaveCounterJs = require("./EnterLeaveCounter.js");
var _offsetUtilsJs = require("./OffsetUtils.js");
var _indexJs = require("./NativeDragSources/index.js");
var NativeTypes = _interopRequireWildcard(require("./NativeTypes.js"));
var _optionsReaderJs = require("./OptionsReader.js");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) {
            return;
        }
        if (root.__isReactDndBackendSetUp) {
            throw new Error('Cannot have two HTML5 backends at the same time.');
        }
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) {
            return;
        }
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 ? void 0 : ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId)
        ;
        const handleSelectStart = (e)=>this.handleSelectStart(e)
        ;
        node.setAttribute('draggable', 'true');
        node.addEventListener('dragstart', handleDragStart);
        node.addEventListener('selectstart', handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener('dragstart', handleDragStart);
            node.removeEventListener('selectstart', handleSelectStart);
            node.setAttribute('draggable', 'false');
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId)
        ;
        const handleDragOver = (e)=>this.handleDragOver(e, targetId)
        ;
        const handleDrop = (e)=>this.handleDrop(e, targetId)
        ;
        node.addEventListener('dragenter', handleDragEnter);
        node.addEventListener('dragover', handleDragOver);
        node.addEventListener('drop', handleDrop);
        return ()=>{
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('drop', handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) {
            return;
        }
        target.addEventListener('dragstart', this.handleTopDragStart);
        target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.addEventListener('dragend', this.handleTopDragEndCapture, true);
        target.addEventListener('dragenter', this.handleTopDragEnter);
        target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.addEventListener('dragover', this.handleTopDragOver);
        target.addEventListener('dragover', this.handleTopDragOverCapture, true);
        target.addEventListener('drop', this.handleTopDrop);
        target.addEventListener('drop', this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) {
            return;
        }
        target.removeEventListener('dragstart', this.handleTopDragStart);
        target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
        target.removeEventListener('dragenter', this.handleTopDragEnter);
        target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.removeEventListener('dragover', this.handleTopDragOver);
        target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
        target.removeEventListener('drop', this.handleTopDrop);
        target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return _objectSpread({
            dropEffect: this.altKeyPressed ? 'copy' : 'move'
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) {
            // It makes more sense to default to 'copy' for native resources
            return 'copy';
        }
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return _objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys(NativeTypes).some((key)=>NativeTypes[key] === itemType
        );
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, _indexJs).createNativeDragSource(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 ? void 0 : ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) {
            return;
        }
        if (!this.dragStartSourceIds) {
            this.dragStartSourceIds = [];
        }
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) {
            this.dragOverTargetIds = [];
        }
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, _offsetUtilsJs).getNodeClientOffset(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) {
                return;
            }
            this.actions.endDrag();
            if (this.currentNativeHandle) {
                this.registry.removeSource(this.currentNativeHandle);
            }
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) {
                return;
            }
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
                this.actions.endDrag();
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) {
                return;
            }
            const { dragStartSourceIds  } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, _offsetUtilsJs).getEventClientOffset(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset
            });
            const { dataTransfer  } = e;
            const nativeType = (0, _indexJs).matchNativeItemType(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX , anchorY , offsetX , offsetY  } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX,
                            anchorY
                        };
                        const offsetPoint = {
                            offsetX,
                            offsetY
                        };
                        const dragPreviewOffset = (0, _offsetUtilsJs).getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData('application/json', {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState  } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) {
                    // Usually we want to publish it in the next tick so that browser
                    // is able to screenshot the current (not yet dragging) state.
                    //
                    // It also neatly avoids a situation where render() returns null
                    // in the same tick for the source element, and browser freaks out.
                    setTimeout(()=>this.actions.publishDragSource()
                    , 0);
                } else {
                    // In some cases the user may want to override this behavior, e.g.
                    // to work around IE not supporting custom drag previews.
                    //
                    // When using a custom drag layer, the only way to prevent
                    // the default drag preview from drawing in IE is to screenshot
                    // the dragging state in which the node itself has zero opacity
                    // and height. In this case, though, returning null from render()
                    // will abruptly end the dragging, which is not obvious.
                    //
                    // This is the reason such behavior is strictly opt-in.
                    this.actions.publishDragSource();
                }
            } else if (nativeType) {
                // A native item (such as URL) dragged from inside the document
                this.beginDragNativeItem(nativeType);
            } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
                // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return;
            } else {
                // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
            }
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
                // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                this.actions.endDrag();
            }
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) {
                return;
            }
            const { dataTransfer  } = e;
            const nativeType = (0, _indexJs).matchNativeItemType(dataTransfer);
            if (nativeType) {
                // A native item (such as file or URL) dragged from outside the document
                this.beginDragNativeItem(nativeType, dataTransfer);
            }
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds  } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                return;
            }
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) {
                this.actions.hover(dragEnterTargetIds, {
                    clientOffset: (0, _offsetUtilsJs).getEventClientOffset(e)
                });
            }
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId)
            );
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds  } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, _offsetUtilsJs).getEventClientOffset(e);
            if (this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') {
                this.hoverRafId = requestAnimationFrame(()=>{
                    if (this.monitor.isDragging()) {
                        this.actions.hover(dragOverTargetIds || [], {
                            clientOffset: this.lastClientOffset
                        });
                    }
                    this.hoverRafId = null;
                });
            }
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId)
            );
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            } else if (this.isDraggingNativeItem()) {
                // Don't show a nice cursor but still prevent default
                // "drop and blow away the whole document" action.
                e.preventDefault();
            } else {
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) {
                e.preventDefault();
            }
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) {
                return;
            }
            if (this.isDraggingNativeItem()) {
                setTimeout(()=>this.endDragNativeItem()
                , 0);
            }
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, _indexJs).matchNativeItemType(e.dataTransfer)) {
                // Dragging some elements, like <a> and <img> may still behave like a native drag event,
                // even if the current drag event matches a user-defined type.
                // Stop the default behavior when we're not expecting a native item to be dropped.
                e.preventDefault();
            }
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds  } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, _offsetUtilsJs).getEventClientOffset(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) {
                this.endDragNativeItem();
            } else if (this.monitor.isDragging()) {
                this.actions.endDrag();
            }
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') {
                return;
            }
            // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
                return;
            }
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new _optionsReaderJs.OptionsReader(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new _enterLeaveCounterJs.EnterLeaveCounter(this.isNodeInDocument);
    }
}
exports.HTML5BackendImpl = HTML5BackendImpl;


},{"./EnterLeaveCounter.js":957,"./NativeDragSources/index.js":962,"./NativeTypes.js":964,"./OffsetUtils.js":965,"./OptionsReader.js":966}],959:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class MonotonicInterpolant {
    interpolate(x) {
        const { xs , ys , c1s , c2s , c3s  } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) {
            return ys[i];
        }
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) {
                low = mid + 1;
            } else if (xHere > x) {
                high = mid - 1;
            } else {
                return ys[mid];
            }
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length  } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++){
            indexes.push(i);
        }
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1
        );
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) {
                c1s.push(0);
            } else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}
exports.MonotonicInterpolant = MonotonicInterpolant;


},{}],960:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) {
                    newProperties[property] = {
                        value: propertyFn(dataTransfer, this.config.matchesTypes),
                        configurable: true,
                        enumerable: true
                    };
                }
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}
exports.NativeDragSource = NativeDragSource;


},{}],961:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDataFromDataTransfer = getDataFromDataTransfer;
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry)
    , '');
    return result != null ? result : defaultValue;
}


},{}],962:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;
var _nativeTypesConfigJs = require("./nativeTypesConfig.js");
var _nativeDragSourceJs = require("./NativeDragSource.js");
function createNativeDragSource(type, dataTransfer) {
    const config = _nativeTypesConfigJs.nativeTypesConfig[type];
    if (!config) {
        throw new Error(`native type ${type} has no configuration`);
    }
    const result = new _nativeDragSourceJs.NativeDragSource(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function matchNativeItemType(dataTransfer) {
    if (!dataTransfer) {
        return null;
    }
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys(_nativeTypesConfigJs.nativeTypesConfig).filter((nativeItemType)=>{
        const typeConfig = _nativeTypesConfigJs.nativeTypesConfig[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) {
            return false;
        }
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1
        );
    })[0] || null;
}


},{"./NativeDragSource.js":960,"./nativeTypesConfig.js":963}],963:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nativeTypesConfig = void 0;
var NativeTypes = _interopRequireWildcard(require("../NativeTypes.js"));
var _getDataFromDataTransferJs = require("./getDataFromDataTransfer.js");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
const nativeTypesConfig = {
    [NativeTypes.FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files)
            ,
            items: (dataTransfer)=>dataTransfer.items
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Files'
        ]
    },
    [NativeTypes.HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, _getDataFromDataTransferJs).getDataFromDataTransfer(dataTransfer, matchesTypes, '')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Html',
            'text/html'
        ]
    },
    [NativeTypes.URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, _getDataFromDataTransferJs).getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Url',
            'text/uri-list'
        ]
    },
    [NativeTypes.TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, _getDataFromDataTransferJs).getDataFromDataTransfer(dataTransfer, matchesTypes, '')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Text',
            'text/plain'
        ]
    }
};
exports.nativeTypesConfig = nativeTypesConfig;


},{"../NativeTypes.js":964,"./getDataFromDataTransfer.js":961}],964:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HTML = exports.TEXT = exports.URL = exports.FILE = void 0;
const FILE = '__NATIVE_FILE__';
exports.FILE = FILE;
const URL = '__NATIVE_URL__';
exports.URL = URL;
const TEXT = '__NATIVE_TEXT__';
exports.TEXT = TEXT;
const HTML = '__NATIVE_HTML__';
exports.HTML = HTML;


},{}],965:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;
var _browserDetectorJs = require("./BrowserDetector.js");
var _monotonicInterpolantJs = require("./MonotonicInterpolant.js");
const ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    const el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) {
        return null;
    }
    const { top , left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function isImageNode(node) {
    var ref;
    return node.nodeName === 'IMG' && ((0, _browserDetectorJs).isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, _browserDetectorJs).isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth,
        dragPreviewHeight
    };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth , offsetHeight: sourceHeight  } = sourceNode;
    const { anchorX , anchorY  } = anchorPoint;
    const { dragPreviewWidth , dragPreviewHeight  } = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new _monotonicInterpolantJs.MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            (offsetFromDragPreview.y / sourceHeight) * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight, 
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, _browserDetectorJs).isSafari() && isImage) {
            // We'll have to wait for @3x to see if this is entirely correct
            y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        }
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new _monotonicInterpolantJs.MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            (offsetFromDragPreview.x / sourceWidth) * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth, 
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX , offsetY  } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


},{"./BrowserDetector.js":956,"./MonotonicInterpolant.js":959}],966:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class OptionsReader {
    get window() {
        if (this.globalContext) {
            return this.globalContext;
        } else if (typeof window !== 'undefined') {
            return window;
        }
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) {
            return this.globalContext.document;
        } else if (this.window) {
            return this.window.document;
        } else {
            return undefined;
        }
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}
exports.OptionsReader = OptionsReader;


},{}],967:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEmptyImage = getEmptyImage;
let emptyImage;
function getEmptyImage() {
    if (!emptyImage) {
        emptyImage = new Image();
        emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
    return emptyImage;
}


},{}],968:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getEmptyImage", {
    enumerable: true,
    get: function() {
        return _getEmptyImageJs.getEmptyImage;
    }
});
exports.HTML5Backend = exports.NativeTypes = void 0;
var _html5BackendImplJs = require("./HTML5BackendImpl.js");
var _NativeTypes = _interopRequireWildcard(require("./NativeTypes.js"));
var _getEmptyImageJs = require("./getEmptyImage.js");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
exports.NativeTypes = _NativeTypes;
const HTML5Backend = function createBackend(manager, context, options) {
    return new _html5BackendImplJs.HTML5BackendImpl(manager, context, options);
};
exports.HTML5Backend = HTML5Backend;


},{"./HTML5BackendImpl.js":958,"./NativeTypes.js":964,"./getEmptyImage.js":967}],969:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.memoize = memoize;
exports.without = without;
exports.union = union;
function memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) {
            result = fn();
        }
        return result;
    };
    return memoized;
}
function without(items, item) {
    return items.filter((i)=>i !== item
    );
}
function union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item)
    ;
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key)
    );
    return result;
}


},{}],970:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DndContext = void 0;
var _react = require("react");
const DndContext = (0, _react).createContext({
    dragDropManager: undefined
});
exports.DndContext = DndContext;


},{"react":1107}],971:[function(require,module,exports){
(function (global){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DndProvider = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dndCore = require("dnd-core");
var _dndContextJs = require("./DndContext.js");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
var DndProvider = /*#__PURE__*/ (0, _react).memo(function DndProvider(_param) {
    var { children  } = _param, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, _react).useEffect(()=>{
        if (isGlobalInstance) {
            const context = getGlobalContext();
            ++refCount;
            return ()=>{
                if (--refCount === 0) {
                    context[INSTANCE_SYM] = null;
                }
            };
        }
        return;
    }, []);
    return(/*#__PURE__*/ (0, _jsxRuntime).jsx(_dndContextJs.DndContext.Provider, {
        value: manager,
        children: children
    }));
});
exports.DndProvider = DndProvider;
function getDndContextValue(props) {
    if ('manager' in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function createSingletonDndContext(backend, context = getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[INSTANCE_SYM]) {
        ctx[INSTANCE_SYM] = {
            dragDropManager: (0, _dndCore).createDragDropManager(backend, context, options, debugMode)
        };
    }
    return ctx[INSTANCE_SYM];
}
function getGlobalContext() {
    return typeof global !== 'undefined' ? global : window;
}


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./DndContext.js":970,"dnd-core":568,"react":1107,"react/jsx-runtime":1108}],972:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DragPreviewImage = void 0;
var _react = require("react");
const DragPreviewImage = (0, _react).memo(function DragPreviewImage({ connect , src  }) {
    (0, _react).useEffect(()=>{
        if (typeof Image === 'undefined') return;
        let connected = false;
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            connect(img);
            connected = true;
        };
        return ()=>{
            if (connected) {
                connect(null);
            }
        };
    });
    return null;
});
exports.DragPreviewImage = DragPreviewImage;


},{"react":1107}],973:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _dndContextJs = _interopRequireWildcard(require("./DndContext.js"));
Object.keys(_dndContextJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dndContextJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dndContextJs[key];
        }
    });
});
var _dndProviderJs = _interopRequireWildcard(require("./DndProvider.js"));
Object.keys(_dndProviderJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dndProviderJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dndProviderJs[key];
        }
    });
});
var _dragPreviewImageJs = _interopRequireWildcard(require("./DragPreviewImage.js"));
Object.keys(_dragPreviewImageJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dragPreviewImageJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dragPreviewImageJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./DndContext.js":970,"./DndProvider.js":971,"./DragPreviewImage.js":972}],974:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _indexJs = _interopRequireWildcard(require("./useDrag/index.js"));
Object.keys(_indexJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _indexJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _indexJs[key];
        }
    });
});
var _indexJs1 = _interopRequireWildcard(require("./useDrop/index.js"));
Object.keys(_indexJs1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _indexJs1[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _indexJs1[key];
        }
    });
});
var _useDragLayerJs = _interopRequireWildcard(require("./useDragLayer.js"));
Object.keys(_useDragLayerJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useDragLayerJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useDragLayerJs[key];
        }
    });
});
var _useDragDropManagerJs = _interopRequireWildcard(require("./useDragDropManager.js"));
Object.keys(_useDragDropManagerJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useDragDropManagerJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useDragDropManagerJs[key];
        }
    });
});
var _typesJs = _interopRequireWildcard(require("./types.js"));
Object.keys(_typesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typesJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typesJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./types.js":975,"./useDrag/index.js":980,"./useDragDropManager.js":987,"./useDragLayer.js":988,"./useDrop/index.js":991}],975:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});


},{}],976:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCollectedProps = useCollectedProps;
var _useMonitorOutputJs = require("./useMonitorOutput.js");
function useCollectedProps(collector, monitor, connector) {
    return (0, _useMonitorOutputJs).useMonitorOutput(monitor, collector || (()=>({})
    ), ()=>connector.reconnect()
    );
}


},{"./useMonitorOutput.js":999}],977:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCollector = useCollector;
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _react = require("react");
var _useIsomorphicLayoutEffectJs = require("./useIsomorphicLayoutEffect.js");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function useCollector(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, _react).useState(()=>collect(monitor)
    );
    const updateCollected = (0, _react).useCallback(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, _fastDeepEqual).default(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) {
                onUpdate();
            }
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(updateCollected);
    return [
        collected,
        updateCollected
    ];
}


},{"./useIsomorphicLayoutEffect.js":998,"fast-deep-equal":632,"react":1107}],978:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class DragSourceImpl {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === 'object') {
            result = spec.item;
        } else if (typeof spec.item === 'function') {
            result = spec.item(monitor);
        } else {
            result = {};
        }
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === 'boolean') {
            return spec.canDrag;
        } else if (typeof spec.canDrag === 'function') {
            return spec.canDrag(monitor);
        } else {
            return true;
        }
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging  } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end  } = spec;
        if (end) {
            end(monitor.getItem(), monitor);
        }
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}
exports.DragSourceImpl = DragSourceImpl;


},{}],979:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConnectDragSource = useConnectDragSource;
exports.useConnectDragPreview = useConnectDragPreview;
var _react = require("react");
function useConnectDragSource(connector) {
    return (0, _react).useMemo(()=>connector.hooks.dragSource()
    , [
        connector
    ]);
}
function useConnectDragPreview(connector) {
    return (0, _react).useMemo(()=>connector.hooks.dragPreview()
    , [
        connector
    ]);
}


},{"react":1107}],980:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _useDragJs = _interopRequireWildcard(require("./useDrag.js"));
Object.keys(_useDragJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _useDragJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useDragJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./useDrag.js":981}],981:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDrag = useDrag;
var _useRegisteredDragSourceJs = require("./useRegisteredDragSource.js");
var _useOptionalFactoryJs = require("../useOptionalFactory.js");
var _useDragSourceMonitorJs = require("./useDragSourceMonitor.js");
var _useDragSourceConnectorJs = require("./useDragSourceConnector.js");
var _useCollectedPropsJs = require("../useCollectedProps.js");
var _connectorsJs = require("./connectors.js");
var _invariant = require("@react-dnd/invariant");
function useDrag(specArg, deps) {
    const spec = (0, _useOptionalFactoryJs).useOptionalFactory(specArg, deps);
    (0, _invariant).invariant(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, _useDragSourceMonitorJs).useDragSourceMonitor();
    const connector = (0, _useDragSourceConnectorJs).useDragSourceConnector(spec.options, spec.previewOptions);
    (0, _useRegisteredDragSourceJs).useRegisteredDragSource(spec, monitor, connector);
    return [
        (0, _useCollectedPropsJs).useCollectedProps(spec.collect, monitor, connector),
        (0, _connectorsJs).useConnectDragSource(connector),
        (0, _connectorsJs).useConnectDragPreview(connector), 
    ];
}


},{"../useCollectedProps.js":976,"../useOptionalFactory.js":1000,"./connectors.js":979,"./useDragSourceConnector.js":983,"./useDragSourceMonitor.js":984,"./useRegisteredDragSource.js":986,"@react-dnd/invariant":331}],982:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDragSource = useDragSource;
var _react = require("react");
var _dragSourceImplJs = require("./DragSourceImpl.js");
function useDragSource(spec, monitor, connector) {
    const handler = (0, _react).useMemo(()=>new _dragSourceImplJs.DragSourceImpl(spec, monitor, connector)
    , [
        monitor,
        connector
    ]);
    (0, _react).useEffect(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}


},{"./DragSourceImpl.js":978,"react":1107}],983:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDragSourceConnector = useDragSourceConnector;
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, _useDragDropManagerJs).useDragDropManager();
    const connector = (0, _react).useMemo(()=>new _indexJs.SourceConnector(manager.getBackend())
    , [
        manager
    ]);
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource()
        ;
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview()
        ;
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}


},{"../../internals/index.js":1006,"../useDragDropManager.js":987,"../useIsomorphicLayoutEffect.js":998,"react":1107}],984:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDragSourceMonitor = useDragSourceMonitor;
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
function useDragSourceMonitor() {
    const manager = (0, _useDragDropManagerJs).useDragDropManager();
    return (0, _react).useMemo(()=>new _indexJs.DragSourceMonitorImpl(manager)
    , [
        manager
    ]);
}


},{"../../internals/index.js":1006,"../useDragDropManager.js":987,"react":1107}],985:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDragType = useDragType;
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
function useDragType(spec) {
    return (0, _react).useMemo(()=>{
        const result = spec.type;
        (0, _invariant).invariant(result != null, 'spec.type must be defined');
        return result;
    }, [
        spec
    ]);
}


},{"@react-dnd/invariant":331,"react":1107}],986:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useRegisteredDragSource = useRegisteredDragSource;
var _indexJs = require("../../internals/index.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
var _useDragSourceJs = require("./useDragSource.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useDragTypeJs = require("./useDragType.js");
function useRegisteredDragSource(spec, monitor, connector) {
    const manager = (0, _useDragDropManagerJs).useDragDropManager();
    const handler = (0, _useDragSourceJs).useDragSource(spec, monitor, connector);
    const itemType = (0, _useDragTypeJs).useDragType(spec);
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, _indexJs).registerSource(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}


},{"../../internals/index.js":1006,"../useDragDropManager.js":987,"../useIsomorphicLayoutEffect.js":998,"./useDragSource.js":982,"./useDragType.js":985}],987:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDragDropManager = useDragDropManager;
var _react = require("react");
var _invariant = require("@react-dnd/invariant");
var _indexJs = require("../core/index.js");
function useDragDropManager() {
    const { dragDropManager  } = (0, _react).useContext(_indexJs.DndContext);
    (0, _invariant).invariant(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}


},{"../core/index.js":973,"@react-dnd/invariant":331,"react":1107}],988:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDragLayer = useDragLayer;
var _react = require("react");
var _useDragDropManagerJs = require("./useDragDropManager.js");
var _useCollectorJs = require("./useCollector.js");
function useDragLayer(collect) {
    const dragDropManager = (0, _useDragDropManagerJs).useDragDropManager();
    const monitor = dragDropManager.getMonitor();
    const [collected, updateCollected] = (0, _useCollectorJs).useCollector(monitor, collect);
    (0, _react).useEffect(()=>monitor.subscribeToOffsetChange(updateCollected)
    );
    (0, _react).useEffect(()=>monitor.subscribeToStateChange(updateCollected)
    );
    return collected;
}


},{"./useCollector.js":977,"./useDragDropManager.js":987,"react":1107}],989:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class DropTargetImpl {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) {
            spec.hover(monitor.getItem(), monitor);
        }
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) {
            return spec.drop(monitor.getItem(), monitor);
        }
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}
exports.DropTargetImpl = DropTargetImpl;


},{}],990:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConnectDropTarget = useConnectDropTarget;
var _react = require("react");
function useConnectDropTarget(connector) {
    return (0, _react).useMemo(()=>connector.hooks.dropTarget()
    , [
        connector
    ]);
}


},{"react":1107}],991:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _useDropJs = _interopRequireWildcard(require("./useDrop.js"));
Object.keys(_useDropJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _useDropJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useDropJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./useDrop.js":993}],992:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAccept = useAccept;
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
function useAccept(spec) {
    const { accept  } = spec;
    return (0, _react).useMemo(()=>{
        (0, _invariant).invariant(spec.accept != null, 'accept must be defined');
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}


},{"@react-dnd/invariant":331,"react":1107}],993:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDrop = useDrop;
var _useRegisteredDropTargetJs = require("./useRegisteredDropTarget.js");
var _useOptionalFactoryJs = require("../useOptionalFactory.js");
var _useDropTargetMonitorJs = require("./useDropTargetMonitor.js");
var _useDropTargetConnectorJs = require("./useDropTargetConnector.js");
var _useCollectedPropsJs = require("../useCollectedProps.js");
var _connectorsJs = require("./connectors.js");
function useDrop(specArg, deps) {
    const spec = (0, _useOptionalFactoryJs).useOptionalFactory(specArg, deps);
    const monitor = (0, _useDropTargetMonitorJs).useDropTargetMonitor();
    const connector = (0, _useDropTargetConnectorJs).useDropTargetConnector(spec.options);
    (0, _useRegisteredDropTargetJs).useRegisteredDropTarget(spec, monitor, connector);
    return [
        (0, _useCollectedPropsJs).useCollectedProps(spec.collect, monitor, connector),
        (0, _connectorsJs).useConnectDropTarget(connector), 
    ];
}


},{"../useCollectedProps.js":976,"../useOptionalFactory.js":1000,"./connectors.js":990,"./useDropTargetConnector.js":995,"./useDropTargetMonitor.js":996,"./useRegisteredDropTarget.js":997}],994:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDropTarget = useDropTarget;
var _react = require("react");
var _dropTargetImplJs = require("./DropTargetImpl.js");
function useDropTarget(spec, monitor) {
    const dropTarget = (0, _react).useMemo(()=>new _dropTargetImplJs.DropTargetImpl(spec, monitor)
    , [
        monitor
    ]);
    (0, _react).useEffect(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}


},{"./DropTargetImpl.js":989,"react":1107}],995:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDropTargetConnector = useDropTargetConnector;
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
function useDropTargetConnector(options) {
    const manager = (0, _useDragDropManagerJs).useDragDropManager();
    const connector = (0, _react).useMemo(()=>new _indexJs.TargetConnector(manager.getBackend())
    , [
        manager
    ]);
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget()
        ;
    }, [
        options
    ]);
    return connector;
}


},{"../../internals/index.js":1006,"../useDragDropManager.js":987,"../useIsomorphicLayoutEffect.js":998,"react":1107}],996:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDropTargetMonitor = useDropTargetMonitor;
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
function useDropTargetMonitor() {
    const manager = (0, _useDragDropManagerJs).useDragDropManager();
    return (0, _react).useMemo(()=>new _indexJs.DropTargetMonitorImpl(manager)
    , [
        manager
    ]);
}


},{"../../internals/index.js":1006,"../useDragDropManager.js":987,"react":1107}],997:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useRegisteredDropTarget = useRegisteredDropTarget;
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
var _useAcceptJs = require("./useAccept.js");
var _useDropTargetJs = require("./useDropTarget.js");
function useRegisteredDropTarget(spec, monitor, connector) {
    const manager = (0, _useDragDropManagerJs).useDragDropManager();
    const dropTarget = (0, _useDropTargetJs).useDropTarget(spec, monitor);
    const accept = (0, _useAcceptJs).useAccept(spec);
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(function registerDropTarget() {
        const [handlerId, unregister] = (0, _indexJs).registerTarget(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()
        ).join('|'), 
    ]);
}


},{"../../internals/index.js":1006,"../useDragDropManager.js":987,"../useIsomorphicLayoutEffect.js":998,"./useAccept.js":992,"./useDropTarget.js":994}],998:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useIsomorphicLayoutEffect = void 0;
var _react = require("react");
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;


},{"react":1107}],999:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useMonitorOutput = useMonitorOutput;
var _useIsomorphicLayoutEffectJs = require("./useIsomorphicLayoutEffect.js");
var _useCollectorJs = require("./useCollector.js");
function useMonitorOutput(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, _useCollectorJs).useCollector(monitor, collect, onCollect);
    (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) {
            return;
        }
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}


},{"./useCollector.js":977,"./useIsomorphicLayoutEffect.js":998}],1000:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useOptionalFactory = useOptionalFactory;
var _react = require("react");
function useOptionalFactory(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== 'function') {
        memoDeps.push(arg);
    }
    return (0, _react).useMemo(()=>{
        return typeof arg === 'function' ? arg() : arg;
    }, memoDeps);
}


},{"react":1107}],1001:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _indexJs = _interopRequireWildcard(require("./types/index.js"));
Object.keys(_indexJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _indexJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _indexJs[key];
        }
    });
});
var _indexJs1 = _interopRequireWildcard(require("./core/index.js"));
Object.keys(_indexJs1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _indexJs1[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _indexJs1[key];
        }
    });
});
var _indexJs2 = _interopRequireWildcard(require("./hooks/index.js"));
Object.keys(_indexJs2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _indexJs2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _indexJs2[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./core/index.js":973,"./hooks/index.js":974,"./types/index.js":1011}],1002:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _invariant = require("@react-dnd/invariant");
let isCallingCanDrag = false;
let isCallingIsDragging = false;
class DragSourceMonitorImpl {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, _invariant).invariant(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
        try {
            isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) {
            return false;
        }
        (0, _invariant).invariant(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
        try {
            isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
exports.DragSourceMonitorImpl = DragSourceMonitorImpl;


},{"@react-dnd/invariant":331}],1003:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _invariant = require("@react-dnd/invariant");
let isCallingCanDrop = false;
class DropTargetMonitorImpl {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) {
            return false;
        }
        (0, _invariant).invariant(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');
        try {
            isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) {
            return false;
        }
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
exports.DropTargetMonitorImpl = DropTargetMonitorImpl;


},{"@react-dnd/invariant":331}],1004:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _wrapConnectorHooksJs = require("./wrapConnectorHooks.js");
var _isRefJs = require("./isRef.js");
var _shallowequal = require("@react-dnd/shallowequal");
class SourceConnector {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) {
            return;
        }
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) {
            this.disconnectDragSource();
        }
        if (!this.handlerId) {
            return didChange;
        }
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) {
            this.disconnectDragPreview();
        }
        if (!this.handlerId) {
            return;
        }
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, _shallowequal).shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, _shallowequal).shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, _wrapConnectorHooksJs).wrapConnectorHooks({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, _isRefJs).isRef(node)) {
                    this.dragSourceRef = node;
                } else {
                    this.dragSourceNode = node;
                }
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, _isRefJs).isRef(node)) {
                    this.dragPreviewRef = node;
                } else {
                    this.dragPreviewNode = node;
                }
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}
exports.SourceConnector = SourceConnector;


},{"./isRef.js":1007,"./wrapConnectorHooks.js":1009,"@react-dnd/shallowequal":332}],1005:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _shallowequal = require("@react-dnd/shallowequal");
var _wrapConnectorHooksJs = require("./wrapConnectorHooks.js");
var _isRefJs = require("./isRef.js");
class TargetConnector {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) {
            this.disconnectDropTarget();
        }
        const dropTarget = this.dropTarget;
        if (!this.handlerId) {
            return;
        }
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) {
            return;
        }
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, _shallowequal).shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, _wrapConnectorHooksJs).wrapConnectorHooks({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, _isRefJs).isRef(node)) {
                    this.dropTargetRef = node;
                } else {
                    this.dropTargetNode = node;
                }
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}
exports.TargetConnector = TargetConnector;


},{"./isRef.js":1007,"./wrapConnectorHooks.js":1009,"@react-dnd/shallowequal":332}],1006:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _dragSourceMonitorImplJs = _interopRequireWildcard(require("./DragSourceMonitorImpl.js"));
Object.keys(_dragSourceMonitorImplJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dragSourceMonitorImplJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dragSourceMonitorImplJs[key];
        }
    });
});
var _dropTargetMonitorImplJs = _interopRequireWildcard(require("./DropTargetMonitorImpl.js"));
Object.keys(_dropTargetMonitorImplJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dropTargetMonitorImplJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dropTargetMonitorImplJs[key];
        }
    });
});
var _sourceConnectorJs = _interopRequireWildcard(require("./SourceConnector.js"));
Object.keys(_sourceConnectorJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _sourceConnectorJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _sourceConnectorJs[key];
        }
    });
});
var _targetConnectorJs = _interopRequireWildcard(require("./TargetConnector.js"));
Object.keys(_targetConnectorJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _targetConnectorJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _targetConnectorJs[key];
        }
    });
});
var _registrationJs = _interopRequireWildcard(require("./registration.js"));
Object.keys(_registrationJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _registrationJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _registrationJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./DragSourceMonitorImpl.js":1002,"./DropTargetMonitorImpl.js":1003,"./SourceConnector.js":1004,"./TargetConnector.js":1005,"./registration.js":1008}],1007:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRef = isRef;
function isRef(obj) {
    return(// eslint-disable-next-line no-prototype-builtins
    obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current'));
}


},{}],1008:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerTarget = registerTarget;
exports.registerSource = registerSource;
function registerTarget(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function registerSource(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}


},{}],1009:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wrapConnectorHooks = wrapConnectorHooks;
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') {
        return;
    }
    const displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + `You can either wrap ${displayName} into a <div>, or turn it into a ` + 'drag source or a drop target itself.');
}
function wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, _react).isValidElement(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options)
         : hook;
        return cloneWithRef(element, ref);
    };
}
function wrapConnectorHooks(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) {
            wrappedHooks[key] = hooks[key];
        } else {
            const wrappedHook = wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook
            ;
        }
    });
    return wrappedHooks;
}
function setRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    } else {
        ref.current = node;
    }
}
function cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, _invariant).invariant(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs');
    if (!previousRef) {
        // When there is no ref on the element, use the new ref directly
        return (0, _react).cloneElement(element, {
            ref: newRef
        });
    } else {
        return (0, _react).cloneElement(element, {
            ref: (node)=>{
                setRef(previousRef, node);
                setRef(newRef, node);
            }
        });
    }
}


},{"@react-dnd/invariant":331,"react":1107}],1010:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});


},{}],1011:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _monitorsJs = _interopRequireWildcard(require("./monitors.js"));
Object.keys(_monitorsJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _monitorsJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _monitorsJs[key];
        }
    });
});
var _optionsJs = _interopRequireWildcard(require("./options.js"));
Object.keys(_optionsJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _optionsJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _optionsJs[key];
        }
    });
});
var _connectorsJs = _interopRequireWildcard(require("./connectors.js"));
Object.keys(_connectorsJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _connectorsJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _connectorsJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


},{"./connectors.js":1010,"./monitors.js":1012,"./options.js":1013}],1012:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});


},{}],1013:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});


},{}],1014:[function(require,module,exports){
'use strict';
if ('production' !== 'production') {
    (function () {
        'use strict';
        var React = require('react');
        var _assign = require('object-assign');
        var Scheduler = require('scheduler');
        var tracing = require('scheduler/tracing');
        var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function warn(format) {
            {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }
                printWarning('warn', format, args);
            }
        }
        function error(format) {
            {
                for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                    args[_key2 - 1] = arguments[_key2];
                }
                printWarning('error', format, args);
            }
        }
        function printWarning(level, format, args) {
            {
                var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
                var stack = ReactDebugCurrentFrame.getStackAddendum();
                if (stack !== '') {
                    format += '%s';
                    args = args.concat([stack]);
                }
                var argsWithFormat = args.map(function (item) {
                    return '' + item;
                });
                argsWithFormat.unshift('Warning: ' + format);
                Function.prototype.apply.call(console[level], console, argsWithFormat);
            }
        }
        if (!React) {
            {
                throw Error('ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.');
            }
        }
        var FunctionComponent = 0;
        var ClassComponent = 1;
        var IndeterminateComponent = 2;
        var HostRoot = 3;
        var HostPortal = 4;
        var HostComponent = 5;
        var HostText = 6;
        var Fragment = 7;
        var Mode = 8;
        var ContextConsumer = 9;
        var ContextProvider = 10;
        var ForwardRef = 11;
        var Profiler = 12;
        var SuspenseComponent = 13;
        var MemoComponent = 14;
        var SimpleMemoComponent = 15;
        var LazyComponent = 16;
        var IncompleteClassComponent = 17;
        var DehydratedFragment = 18;
        var SuspenseListComponent = 19;
        var FundamentalComponent = 20;
        var ScopeComponent = 21;
        var Block = 22;
        var OffscreenComponent = 23;
        var LegacyHiddenComponent = 24;
        var enableProfilerTimer = true;
        var enableFundamentalAPI = false;
        var enableNewReconciler = false;
        var warnAboutStringRefs = false;
        var allNativeEvents = new Set();
        var registrationNameDependencies = {};
        var possibleRegistrationNames = {};
        function registerTwoPhaseEvent(registrationName, dependencies) {
            registerDirectEvent(registrationName, dependencies);
            registerDirectEvent(registrationName + 'Capture', dependencies);
        }
        function registerDirectEvent(registrationName, dependencies) {
            {
                if (registrationNameDependencies[registrationName]) {
                    error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
                }
            }
            registrationNameDependencies[registrationName] = dependencies;
            {
                var lowerCasedName = registrationName.toLowerCase();
                possibleRegistrationNames[lowerCasedName] = registrationName;
                if (registrationName === 'onDoubleClick') {
                    possibleRegistrationNames.ondblclick = registrationName;
                }
            }
            for (var i = 0; i < dependencies.length; i++) {
                allNativeEvents.add(dependencies[i]);
            }
        }
        var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
        var RESERVED = 0;
        var STRING = 1;
        var BOOLEANISH_STRING = 2;
        var BOOLEAN = 3;
        var OVERLOADED_BOOLEAN = 4;
        var NUMERIC = 5;
        var POSITIVE_NUMERIC = 6;
        var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
        var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
        var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
        var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var illegalAttributeNameCache = {};
        var validatedAttributeNameCache = {};
        function isAttributeNameSafe(attributeName) {
            if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
                return true;
            }
            if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
                return false;
            }
            if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
                validatedAttributeNameCache[attributeName] = true;
                return true;
            }
            illegalAttributeNameCache[attributeName] = true;
            {
                error('Invalid attribute name: `%s`', attributeName);
            }
            return false;
        }
        function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
            if (propertyInfo !== null) {
                return propertyInfo.type === RESERVED;
            }
            if (isCustomComponentTag) {
                return false;
            }
            if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
                return true;
            }
            return false;
        }
        function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
            if (propertyInfo !== null && propertyInfo.type === RESERVED) {
                return false;
            }
            switch (typeof value) {
            case 'function':
            case 'symbol':
                return true;
            case 'boolean': {
                    if (isCustomComponentTag) {
                        return false;
                    }
                    if (propertyInfo !== null) {
                        return !propertyInfo.acceptsBooleans;
                    } else {
                        var prefix = name.toLowerCase().slice(0, 5);
                        return prefix !== 'data-' && prefix !== 'aria-';
                    }
                }
            default:
                return false;
            }
        }
        function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
            if (value === null || typeof value === 'undefined') {
                return true;
            }
            if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
                return true;
            }
            if (isCustomComponentTag) {
                return false;
            }
            if (propertyInfo !== null) {
                switch (propertyInfo.type) {
                case BOOLEAN:
                    return !value;
                case OVERLOADED_BOOLEAN:
                    return value === false;
                case NUMERIC:
                    return isNaN(value);
                case POSITIVE_NUMERIC:
                    return isNaN(value) || value < 1;
                }
            }
            return false;
        }
        function getPropertyInfo(name) {
            return properties.hasOwnProperty(name) ? properties[name] : null;
        }
        function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
            this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
            this.attributeName = attributeName;
            this.attributeNamespace = attributeNamespace;
            this.mustUseProperty = mustUseProperty;
            this.propertyName = name;
            this.type = type;
            this.sanitizeURL = sanitizeURL;
            this.removeEmptyString = removeEmptyString;
        }
        var properties = {};
        var reservedProps = [
            'children',
            'dangerouslySetInnerHTML',
            'defaultValue',
            'defaultChecked',
            'innerHTML',
            'suppressContentEditableWarning',
            'suppressHydrationWarning',
            'style'
        ];
        reservedProps.forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
        });
        [
            [
                'acceptCharset',
                'accept-charset'
            ],
            [
                'className',
                'class'
            ],
            [
                'htmlFor',
                'for'
            ],
            [
                'httpEquiv',
                'http-equiv'
            ]
        ].forEach(function (_ref) {
            var name = _ref[0], attributeName = _ref[1];
            properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
        });
        [
            'contentEditable',
            'draggable',
            'spellCheck',
            'value'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
        });
        [
            'autoReverse',
            'externalResourcesRequired',
            'focusable',
            'preserveAlpha'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
        });
        [
            'allowFullScreen',
            'async',
            'autoFocus',
            'autoPlay',
            'controls',
            'default',
            'defer',
            'disabled',
            'disablePictureInPicture',
            'disableRemotePlayback',
            'formNoValidate',
            'hidden',
            'loop',
            'noModule',
            'noValidate',
            'open',
            'playsInline',
            'readOnly',
            'required',
            'reversed',
            'scoped',
            'seamless',
            'itemScope'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
        });
        [
            'checked',
            'multiple',
            'muted',
            'selected'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
        });
        [
            'capture',
            'download'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
        });
        [
            'cols',
            'rows',
            'size',
            'span'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
        });
        [
            'rowSpan',
            'start'
        ].forEach(function (name) {
            properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
        });
        var CAMELIZE = /[\-\:]([a-z])/g;
        var capitalize = function (token) {
            return token[1].toUpperCase();
        };
        [
            'accent-height',
            'alignment-baseline',
            'arabic-form',
            'baseline-shift',
            'cap-height',
            'clip-path',
            'clip-rule',
            'color-interpolation',
            'color-interpolation-filters',
            'color-profile',
            'color-rendering',
            'dominant-baseline',
            'enable-background',
            'fill-opacity',
            'fill-rule',
            'flood-color',
            'flood-opacity',
            'font-family',
            'font-size',
            'font-size-adjust',
            'font-stretch',
            'font-style',
            'font-variant',
            'font-weight',
            'glyph-name',
            'glyph-orientation-horizontal',
            'glyph-orientation-vertical',
            'horiz-adv-x',
            'horiz-origin-x',
            'image-rendering',
            'letter-spacing',
            'lighting-color',
            'marker-end',
            'marker-mid',
            'marker-start',
            'overline-position',
            'overline-thickness',
            'paint-order',
            'panose-1',
            'pointer-events',
            'rendering-intent',
            'shape-rendering',
            'stop-color',
            'stop-opacity',
            'strikethrough-position',
            'strikethrough-thickness',
            'stroke-dasharray',
            'stroke-dashoffset',
            'stroke-linecap',
            'stroke-linejoin',
            'stroke-miterlimit',
            'stroke-opacity',
            'stroke-width',
            'text-anchor',
            'text-decoration',
            'text-rendering',
            'underline-position',
            'underline-thickness',
            'unicode-bidi',
            'unicode-range',
            'units-per-em',
            'v-alphabetic',
            'v-hanging',
            'v-ideographic',
            'v-mathematical',
            'vector-effect',
            'vert-adv-y',
            'vert-origin-x',
            'vert-origin-y',
            'word-spacing',
            'writing-mode',
            'xmlns:xlink',
            'x-height'
        ].forEach(function (attributeName) {
            var name = attributeName.replace(CAMELIZE, capitalize);
            properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
        });
        [
            'xlink:actuate',
            'xlink:arcrole',
            'xlink:role',
            'xlink:show',
            'xlink:title',
            'xlink:type'
        ].forEach(function (attributeName) {
            var name = attributeName.replace(CAMELIZE, capitalize);
            properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
        });
        [
            'xml:base',
            'xml:lang',
            'xml:space'
        ].forEach(function (attributeName) {
            var name = attributeName.replace(CAMELIZE, capitalize);
            properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
        });
        [
            'tabIndex',
            'crossOrigin'
        ].forEach(function (attributeName) {
            properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
        });
        var xlinkHref = 'xlinkHref';
        properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
        [
            'src',
            'href',
            'action',
            'formAction'
        ].forEach(function (attributeName) {
            properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
        });
        var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
        var didWarn = false;
        function sanitizeURL(url) {
            {
                if (!didWarn && isJavaScriptProtocol.test(url)) {
                    didWarn = true;
                    error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
                }
            }
        }
        function getValueForProperty(node, name, expected, propertyInfo) {
            {
                if (propertyInfo.mustUseProperty) {
                    var propertyName = propertyInfo.propertyName;
                    return node[propertyName];
                } else {
                    if (propertyInfo.sanitizeURL) {
                        sanitizeURL('' + expected);
                    }
                    var attributeName = propertyInfo.attributeName;
                    var stringValue = null;
                    if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                        if (node.hasAttribute(attributeName)) {
                            var value = node.getAttribute(attributeName);
                            if (value === '') {
                                return true;
                            }
                            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                                return value;
                            }
                            if (value === '' + expected) {
                                return expected;
                            }
                            return value;
                        }
                    } else if (node.hasAttribute(attributeName)) {
                        if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                            return node.getAttribute(attributeName);
                        }
                        if (propertyInfo.type === BOOLEAN) {
                            return expected;
                        }
                        stringValue = node.getAttribute(attributeName);
                    }
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                        return stringValue === null ? expected : stringValue;
                    } else if (stringValue === '' + expected) {
                        return expected;
                    } else {
                        return stringValue;
                    }
                }
            }
        }
        function getValueForAttribute(node, name, expected) {
            {
                if (!isAttributeNameSafe(name)) {
                    return;
                }
                if (isOpaqueHydratingObject(expected)) {
                    return expected;
                }
                if (!node.hasAttribute(name)) {
                    return expected === undefined ? undefined : null;
                }
                var value = node.getAttribute(name);
                if (value === '' + expected) {
                    return expected;
                }
                return value;
            }
        }
        function setValueForProperty(node, name, value, isCustomComponentTag) {
            var propertyInfo = getPropertyInfo(name);
            if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
                return;
            }
            if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
                value = null;
            }
            if (isCustomComponentTag || propertyInfo === null) {
                if (isAttributeNameSafe(name)) {
                    var _attributeName = name;
                    if (value === null) {
                        node.removeAttribute(_attributeName);
                    } else {
                        node.setAttribute(_attributeName, '' + value);
                    }
                }
                return;
            }
            var mustUseProperty = propertyInfo.mustUseProperty;
            if (mustUseProperty) {
                var propertyName = propertyInfo.propertyName;
                if (value === null) {
                    var type = propertyInfo.type;
                    node[propertyName] = type === BOOLEAN ? false : '';
                } else {
                    node[propertyName] = value;
                }
                return;
            }
            var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
            if (value === null) {
                node.removeAttribute(attributeName);
            } else {
                var _type = propertyInfo.type;
                var attributeValue;
                if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
                    attributeValue = '';
                } else {
                    {
                        attributeValue = '' + value;
                    }
                    if (propertyInfo.sanitizeURL) {
                        sanitizeURL(attributeValue.toString());
                    }
                }
                if (attributeNamespace) {
                    node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
                } else {
                    node.setAttribute(attributeName, attributeValue);
                }
            }
        }
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        var REACT_FRAGMENT_TYPE = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_SCOPE_TYPE = 60119;
        var REACT_OPAQUE_ID_TYPE = 60128;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_OFFSCREEN_TYPE = 60130;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === 'function' && Symbol.for) {
            var symbolFor = Symbol.for;
            REACT_ELEMENT_TYPE = symbolFor('react.element');
            REACT_PORTAL_TYPE = symbolFor('react.portal');
            REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
            REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
            REACT_PROFILER_TYPE = symbolFor('react.profiler');
            REACT_PROVIDER_TYPE = symbolFor('react.provider');
            REACT_CONTEXT_TYPE = symbolFor('react.context');
            REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
            REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
            REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
            REACT_MEMO_TYPE = symbolFor('react.memo');
            REACT_LAZY_TYPE = symbolFor('react.lazy');
            REACT_BLOCK_TYPE = symbolFor('react.block');
            REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
            REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
            REACT_SCOPE_TYPE = symbolFor('react.scope');
            REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
            REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
            REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
            REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';
        function getIteratorFn(maybeIterable) {
            if (maybeIterable === null || typeof maybeIterable !== 'object') {
                return null;
            }
            var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
            if (typeof maybeIterator === 'function') {
                return maybeIterator;
            }
            return null;
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
            {
                if (disabledDepth === 0) {
                    prevLog = console.log;
                    prevInfo = console.info;
                    prevWarn = console.warn;
                    prevError = console.error;
                    prevGroup = console.group;
                    prevGroupCollapsed = console.groupCollapsed;
                    prevGroupEnd = console.groupEnd;
                    var props = {
                        configurable: true,
                        enumerable: true,
                        value: disabledLog,
                        writable: true
                    };
                    Object.defineProperties(console, {
                        info: props,
                        log: props,
                        warn: props,
                        error: props,
                        group: props,
                        groupCollapsed: props,
                        groupEnd: props
                    });
                }
                disabledDepth++;
            }
        }
        function reenableLogs() {
            {
                disabledDepth--;
                if (disabledDepth === 0) {
                    var props = {
                        configurable: true,
                        enumerable: true,
                        writable: true
                    };
                    Object.defineProperties(console, {
                        log: _assign({}, props, { value: prevLog }),
                        info: _assign({}, props, { value: prevInfo }),
                        warn: _assign({}, props, { value: prevWarn }),
                        error: _assign({}, props, { value: prevError }),
                        group: _assign({}, props, { value: prevGroup }),
                        groupCollapsed: _assign({}, props, { value: prevGroupCollapsed }),
                        groupEnd: _assign({}, props, { value: prevGroupEnd })
                    });
                }
                if (disabledDepth < 0) {
                    error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
                }
            }
        }
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;
        function describeBuiltInComponentFrame(name, source, ownerFn) {
            {
                if (prefix === undefined) {
                    try {
                        throw Error();
                    } catch (x) {
                        var match = x.stack.trim().match(/\n( *(at )?)/);
                        prefix = match && match[1] || '';
                    }
                }
                return '\n' + prefix + name;
            }
        }
        var reentry = false;
        var componentFrameCache;
        {
            var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
            componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn, construct) {
            if (!fn || reentry) {
                return '';
            }
            {
                var frame = componentFrameCache.get(fn);
                if (frame !== undefined) {
                    return frame;
                }
            }
            var control;
            reentry = true;
            var previousPrepareStackTrace = Error.prepareStackTrace;
            Error.prepareStackTrace = undefined;
            var previousDispatcher;
            {
                previousDispatcher = ReactCurrentDispatcher.current;
                ReactCurrentDispatcher.current = null;
                disableLogs();
            }
            try {
                if (construct) {
                    var Fake = function () {
                        throw Error();
                    };
                    Object.defineProperty(Fake.prototype, 'props', {
                        set: function () {
                            throw Error();
                        }
                    });
                    if (typeof Reflect === 'object' && Reflect.construct) {
                        try {
                            Reflect.construct(Fake, []);
                        } catch (x) {
                            control = x;
                        }
                        Reflect.construct(fn, [], Fake);
                    } else {
                        try {
                            Fake.call();
                        } catch (x) {
                            control = x;
                        }
                        fn.call(Fake.prototype);
                    }
                } else {
                    try {
                        throw Error();
                    } catch (x) {
                        control = x;
                    }
                    fn();
                }
            } catch (sample) {
                if (sample && control && typeof sample.stack === 'string') {
                    var sampleLines = sample.stack.split('\n');
                    var controlLines = control.stack.split('\n');
                    var s = sampleLines.length - 1;
                    var c = controlLines.length - 1;
                    while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
                        c--;
                    }
                    for (; s >= 1 && c >= 0; s--, c--) {
                        if (sampleLines[s] !== controlLines[c]) {
                            if (s !== 1 || c !== 1) {
                                do {
                                    s--;
                                    c--;
                                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                                        var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                                        {
                                            if (typeof fn === 'function') {
                                                componentFrameCache.set(fn, _frame);
                                            }
                                        }
                                        return _frame;
                                    }
                                } while (s >= 1 && c >= 0);
                            }
                            break;
                        }
                    }
                }
            } finally {
                reentry = false;
                {
                    ReactCurrentDispatcher.current = previousDispatcher;
                    reenableLogs();
                }
                Error.prepareStackTrace = previousPrepareStackTrace;
            }
            var name = fn ? fn.displayName || fn.name : '';
            var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
            {
                if (typeof fn === 'function') {
                    componentFrameCache.set(fn, syntheticFrame);
                }
            }
            return syntheticFrame;
        }
        function describeClassComponentFrame(ctor, source, ownerFn) {
            {
                return describeNativeComponentFrame(ctor, true);
            }
        }
        function describeFunctionComponentFrame(fn, source, ownerFn) {
            {
                return describeNativeComponentFrame(fn, false);
            }
        }
        function shouldConstruct(Component) {
            var prototype = Component.prototype;
            return !!(prototype && prototype.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
            if (type == null) {
                return '';
            }
            if (typeof type === 'function') {
                {
                    return describeNativeComponentFrame(type, shouldConstruct(type));
                }
            }
            if (typeof type === 'string') {
                return describeBuiltInComponentFrame(type);
            }
            switch (type) {
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
            }
            if (typeof type === 'object') {
                switch (type.$$typeof) {
                case REACT_FORWARD_REF_TYPE:
                    return describeFunctionComponentFrame(type.render);
                case REACT_MEMO_TYPE:
                    return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
                case REACT_BLOCK_TYPE:
                    return describeFunctionComponentFrame(type._render);
                case REACT_LAZY_TYPE: {
                        var lazyComponent = type;
                        var payload = lazyComponent._payload;
                        var init = lazyComponent._init;
                        try {
                            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                        } catch (x) {
                        }
                    }
                }
            }
            return '';
        }
        function describeFiber(fiber) {
            var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
            var source = fiber._debugSource;
            switch (fiber.tag) {
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case Block:
                return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
            }
        }
        function getStackByFiberInDevAndProd(workInProgress) {
            try {
                var info = '';
                var node = workInProgress;
                do {
                    info += describeFiber(node);
                    node = node.return;
                } while (node);
                return info;
            } catch (x) {
                return '\nError generating stack: ' + x.message + '\n' + x.stack;
            }
        }
        function getWrappedName(outerType, innerType, wrapperName) {
            var functionName = innerType.displayName || innerType.name || '';
            return outerType.displayName || (functionName !== '' ? wrapperName + '(' + functionName + ')' : wrapperName);
        }
        function getContextName(type) {
            return type.displayName || 'Context';
        }
        function getComponentName(type) {
            if (type == null) {
                return null;
            }
            {
                if (typeof type.tag === 'number') {
                    error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
                }
            }
            if (typeof type === 'function') {
                return type.displayName || type.name || null;
            }
            if (typeof type === 'string') {
                return type;
            }
            switch (type) {
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
            }
            if (typeof type === 'object') {
                switch (type.$$typeof) {
                case REACT_CONTEXT_TYPE:
                    var context = type;
                    return getContextName(context) + '.Consumer';
                case REACT_PROVIDER_TYPE:
                    var provider = type;
                    return getContextName(provider._context) + '.Provider';
                case REACT_FORWARD_REF_TYPE:
                    return getWrappedName(type, type.render, 'ForwardRef');
                case REACT_MEMO_TYPE:
                    return getComponentName(type.type);
                case REACT_BLOCK_TYPE:
                    return getComponentName(type._render);
                case REACT_LAZY_TYPE: {
                        var lazyComponent = type;
                        var payload = lazyComponent._payload;
                        var init = lazyComponent._init;
                        try {
                            return getComponentName(init(payload));
                        } catch (x) {
                            return null;
                        }
                    }
                }
            }
            return null;
        }
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var current = null;
        var isRendering = false;
        function getCurrentFiberOwnerNameInDevOrNull() {
            {
                if (current === null) {
                    return null;
                }
                var owner = current._debugOwner;
                if (owner !== null && typeof owner !== 'undefined') {
                    return getComponentName(owner.type);
                }
            }
            return null;
        }
        function getCurrentFiberStackInDev() {
            {
                if (current === null) {
                    return '';
                }
                return getStackByFiberInDevAndProd(current);
            }
        }
        function resetCurrentFiber() {
            {
                ReactDebugCurrentFrame.getCurrentStack = null;
                current = null;
                isRendering = false;
            }
        }
        function setCurrentFiber(fiber) {
            {
                ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
                current = fiber;
                isRendering = false;
            }
        }
        function setIsRendering(rendering) {
            {
                isRendering = rendering;
            }
        }
        function getIsRendering() {
            {
                return isRendering;
            }
        }
        function toString(value) {
            return '' + value;
        }
        function getToStringValue(value) {
            switch (typeof value) {
            case 'boolean':
            case 'number':
            case 'object':
            case 'string':
            case 'undefined':
                return value;
            default:
                return '';
            }
        }
        var hasReadOnlyValue = {
            button: true,
            checkbox: true,
            image: true,
            hidden: true,
            radio: true,
            reset: true,
            submit: true
        };
        function checkControlledValueProps(tagName, props) {
            {
                if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
                    error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
                }
                if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
                    error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
                }
            }
        }
        function isCheckable(elem) {
            var type = elem.type;
            var nodeName = elem.nodeName;
            return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
        }
        function getTracker(node) {
            return node._valueTracker;
        }
        function detachTracker(node) {
            node._valueTracker = null;
        }
        function getValueFromNode(node) {
            var value = '';
            if (!node) {
                return value;
            }
            if (isCheckable(node)) {
                value = node.checked ? 'true' : 'false';
            } else {
                value = node.value;
            }
            return value;
        }
        function trackValueOnNode(node) {
            var valueField = isCheckable(node) ? 'checked' : 'value';
            var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
            var currentValue = '' + node[valueField];
            if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
                return;
            }
            var get = descriptor.get, set = descriptor.set;
            Object.defineProperty(node, valueField, {
                configurable: true,
                get: function () {
                    return get.call(this);
                },
                set: function (value) {
                    currentValue = '' + value;
                    set.call(this, value);
                }
            });
            Object.defineProperty(node, valueField, { enumerable: descriptor.enumerable });
            var tracker = {
                getValue: function () {
                    return currentValue;
                },
                setValue: function (value) {
                    currentValue = '' + value;
                },
                stopTracking: function () {
                    detachTracker(node);
                    delete node[valueField];
                }
            };
            return tracker;
        }
        function track(node) {
            if (getTracker(node)) {
                return;
            }
            node._valueTracker = trackValueOnNode(node);
        }
        function updateValueIfChanged(node) {
            if (!node) {
                return false;
            }
            var tracker = getTracker(node);
            if (!tracker) {
                return true;
            }
            var lastValue = tracker.getValue();
            var nextValue = getValueFromNode(node);
            if (nextValue !== lastValue) {
                tracker.setValue(nextValue);
                return true;
            }
            return false;
        }
        function getActiveElement(doc) {
            doc = doc || (typeof document !== 'undefined' ? document : undefined);
            if (typeof doc === 'undefined') {
                return null;
            }
            try {
                return doc.activeElement || doc.body;
            } catch (e) {
                return doc.body;
            }
        }
        var didWarnValueDefaultValue = false;
        var didWarnCheckedDefaultChecked = false;
        var didWarnControlledToUncontrolled = false;
        var didWarnUncontrolledToControlled = false;
        function isControlled(props) {
            var usesChecked = props.type === 'checkbox' || props.type === 'radio';
            return usesChecked ? props.checked != null : props.value != null;
        }
        function getHostProps(element, props) {
            var node = element;
            var checked = props.checked;
            var hostProps = _assign({}, props, {
                defaultChecked: undefined,
                defaultValue: undefined,
                value: undefined,
                checked: checked != null ? checked : node._wrapperState.initialChecked
            });
            return hostProps;
        }
        function initWrapperState(element, props) {
            {
                checkControlledValueProps('input', props);
                if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
                    error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
                    didWarnCheckedDefaultChecked = true;
                }
                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
                    error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
                    didWarnValueDefaultValue = true;
                }
            }
            var node = element;
            var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
            node._wrapperState = {
                initialChecked: props.checked != null ? props.checked : props.defaultChecked,
                initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
                controlled: isControlled(props)
            };
        }
        function updateChecked(element, props) {
            var node = element;
            var checked = props.checked;
            if (checked != null) {
                setValueForProperty(node, 'checked', checked, false);
            }
        }
        function updateWrapper(element, props) {
            var node = element;
            {
                var controlled = isControlled(props);
                if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
                    error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
                    didWarnUncontrolledToControlled = true;
                }
                if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
                    error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
                    didWarnControlledToUncontrolled = true;
                }
            }
            updateChecked(element, props);
            var value = getToStringValue(props.value);
            var type = props.type;
            if (value != null) {
                if (type === 'number') {
                    if (value === 0 && node.value === '' || node.value != value) {
                        node.value = toString(value);
                    }
                } else if (node.value !== toString(value)) {
                    node.value = toString(value);
                }
            } else if (type === 'submit' || type === 'reset') {
                node.removeAttribute('value');
                return;
            }
            {
                if (props.hasOwnProperty('value')) {
                    setDefaultValue(node, props.type, value);
                } else if (props.hasOwnProperty('defaultValue')) {
                    setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
                }
            }
            {
                if (props.checked == null && props.defaultChecked != null) {
                    node.defaultChecked = !!props.defaultChecked;
                }
            }
        }
        function postMountWrapper(element, props, isHydrating) {
            var node = element;
            if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
                var type = props.type;
                var isButton = type === 'submit' || type === 'reset';
                if (isButton && (props.value === undefined || props.value === null)) {
                    return;
                }
                var initialValue = toString(node._wrapperState.initialValue);
                if (!isHydrating) {
                    {
                        if (initialValue !== node.value) {
                            node.value = initialValue;
                        }
                    }
                }
                {
                    node.defaultValue = initialValue;
                }
            }
            var name = node.name;
            if (name !== '') {
                node.name = '';
            }
            {
                node.defaultChecked = !node.defaultChecked;
                node.defaultChecked = !!node._wrapperState.initialChecked;
            }
            if (name !== '') {
                node.name = name;
            }
        }
        function restoreControlledState(element, props) {
            var node = element;
            updateWrapper(node, props);
            updateNamedCousins(node, props);
        }
        function updateNamedCousins(rootNode, props) {
            var name = props.name;
            if (props.type === 'radio' && name != null) {
                var queryRoot = rootNode;
                while (queryRoot.parentNode) {
                    queryRoot = queryRoot.parentNode;
                }
                var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
                for (var i = 0; i < group.length; i++) {
                    var otherNode = group[i];
                    if (otherNode === rootNode || otherNode.form !== rootNode.form) {
                        continue;
                    }
                    var otherProps = getFiberCurrentPropsFromNode(otherNode);
                    if (!otherProps) {
                        {
                            throw Error('ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.');
                        }
                    }
                    updateValueIfChanged(otherNode);
                    updateWrapper(otherNode, otherProps);
                }
            }
        }
        function setDefaultValue(node, type, value) {
            if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
                if (value == null) {
                    node.defaultValue = toString(node._wrapperState.initialValue);
                } else if (node.defaultValue !== toString(value)) {
                    node.defaultValue = toString(value);
                }
            }
        }
        var didWarnSelectedSetOnOption = false;
        var didWarnInvalidChild = false;
        function flattenChildren(children) {
            var content = '';
            React.Children.forEach(children, function (child) {
                if (child == null) {
                    return;
                }
                content += child;
            });
            return content;
        }
        function validateProps(element, props) {
            {
                if (typeof props.children === 'object' && props.children !== null) {
                    React.Children.forEach(props.children, function (child) {
                        if (child == null) {
                            return;
                        }
                        if (typeof child === 'string' || typeof child === 'number') {
                            return;
                        }
                        if (typeof child.type !== 'string') {
                            return;
                        }
                        if (!didWarnInvalidChild) {
                            didWarnInvalidChild = true;
                            error('Only strings and numbers are supported as <option> children.');
                        }
                    });
                }
                if (props.selected != null && !didWarnSelectedSetOnOption) {
                    error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
                    didWarnSelectedSetOnOption = true;
                }
            }
        }
        function postMountWrapper$1(element, props) {
            if (props.value != null) {
                element.setAttribute('value', toString(getToStringValue(props.value)));
            }
        }
        function getHostProps$1(element, props) {
            var hostProps = _assign({ children: undefined }, props);
            var content = flattenChildren(props.children);
            if (content) {
                hostProps.children = content;
            }
            return hostProps;
        }
        var didWarnValueDefaultValue$1;
        {
            didWarnValueDefaultValue$1 = false;
        }
        function getDeclarationErrorAddendum() {
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) {
                return '\n\nCheck the render method of `' + ownerName + '`.';
            }
            return '';
        }
        var valuePropNames = [
            'value',
            'defaultValue'
        ];
        function checkSelectPropTypes(props) {
            {
                checkControlledValueProps('select', props);
                for (var i = 0; i < valuePropNames.length; i++) {
                    var propName = valuePropNames[i];
                    if (props[propName] == null) {
                        continue;
                    }
                    var isArray = Array.isArray(props[propName]);
                    if (props.multiple && !isArray) {
                        error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
                    } else if (!props.multiple && isArray) {
                        error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
                    }
                }
            }
        }
        function updateOptions(node, multiple, propValue, setDefaultSelected) {
            var options = node.options;
            if (multiple) {
                var selectedValues = propValue;
                var selectedValue = {};
                for (var i = 0; i < selectedValues.length; i++) {
                    selectedValue['$' + selectedValues[i]] = true;
                }
                for (var _i = 0; _i < options.length; _i++) {
                    var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                    if (options[_i].selected !== selected) {
                        options[_i].selected = selected;
                    }
                    if (selected && setDefaultSelected) {
                        options[_i].defaultSelected = true;
                    }
                }
            } else {
                var _selectedValue = toString(getToStringValue(propValue));
                var defaultSelected = null;
                for (var _i2 = 0; _i2 < options.length; _i2++) {
                    if (options[_i2].value === _selectedValue) {
                        options[_i2].selected = true;
                        if (setDefaultSelected) {
                            options[_i2].defaultSelected = true;
                        }
                        return;
                    }
                    if (defaultSelected === null && !options[_i2].disabled) {
                        defaultSelected = options[_i2];
                    }
                }
                if (defaultSelected !== null) {
                    defaultSelected.selected = true;
                }
            }
        }
        function getHostProps$2(element, props) {
            return _assign({}, props, { value: undefined });
        }
        function initWrapperState$1(element, props) {
            var node = element;
            {
                checkSelectPropTypes(props);
            }
            node._wrapperState = { wasMultiple: !!props.multiple };
            {
                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
                    error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
                    didWarnValueDefaultValue$1 = true;
                }
            }
        }
        function postMountWrapper$2(element, props) {
            var node = element;
            node.multiple = !!props.multiple;
            var value = props.value;
            if (value != null) {
                updateOptions(node, !!props.multiple, value, false);
            } else if (props.defaultValue != null) {
                updateOptions(node, !!props.multiple, props.defaultValue, true);
            }
        }
        function postUpdateWrapper(element, props) {
            var node = element;
            var wasMultiple = node._wrapperState.wasMultiple;
            node._wrapperState.wasMultiple = !!props.multiple;
            var value = props.value;
            if (value != null) {
                updateOptions(node, !!props.multiple, value, false);
            } else if (wasMultiple !== !!props.multiple) {
                if (props.defaultValue != null) {
                    updateOptions(node, !!props.multiple, props.defaultValue, true);
                } else {
                    updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
                }
            }
        }
        function restoreControlledState$1(element, props) {
            var node = element;
            var value = props.value;
            if (value != null) {
                updateOptions(node, !!props.multiple, value, false);
            }
        }
        var didWarnValDefaultVal = false;
        function getHostProps$3(element, props) {
            var node = element;
            if (!(props.dangerouslySetInnerHTML == null)) {
                {
                    throw Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
                }
            }
            var hostProps = _assign({}, props, {
                value: undefined,
                defaultValue: undefined,
                children: toString(node._wrapperState.initialValue)
            });
            return hostProps;
        }
        function initWrapperState$2(element, props) {
            var node = element;
            {
                checkControlledValueProps('textarea', props);
                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
                    error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');
                    didWarnValDefaultVal = true;
                }
            }
            var initialValue = props.value;
            if (initialValue == null) {
                var children = props.children, defaultValue = props.defaultValue;
                if (children != null) {
                    {
                        error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
                    }
                    {
                        if (!(defaultValue == null)) {
                            {
                                throw Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
                            }
                        }
                        if (Array.isArray(children)) {
                            if (!(children.length <= 1)) {
                                {
                                    throw Error('<textarea> can only have at most one child.');
                                }
                            }
                            children = children[0];
                        }
                        defaultValue = children;
                    }
                }
                if (defaultValue == null) {
                    defaultValue = '';
                }
                initialValue = defaultValue;
            }
            node._wrapperState = { initialValue: getToStringValue(initialValue) };
        }
        function updateWrapper$1(element, props) {
            var node = element;
            var value = getToStringValue(props.value);
            var defaultValue = getToStringValue(props.defaultValue);
            if (value != null) {
                var newValue = toString(value);
                if (newValue !== node.value) {
                    node.value = newValue;
                }
                if (props.defaultValue == null && node.defaultValue !== newValue) {
                    node.defaultValue = newValue;
                }
            }
            if (defaultValue != null) {
                node.defaultValue = toString(defaultValue);
            }
        }
        function postMountWrapper$3(element, props) {
            var node = element;
            var textContent = node.textContent;
            if (textContent === node._wrapperState.initialValue) {
                if (textContent !== '' && textContent !== null) {
                    node.value = textContent;
                }
            }
        }
        function restoreControlledState$2(element, props) {
            updateWrapper$1(element, props);
        }
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var Namespaces = {
            html: HTML_NAMESPACE,
            mathml: MATH_NAMESPACE,
            svg: SVG_NAMESPACE
        };
        function getIntrinsicNamespace(type) {
            switch (type) {
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
            }
        }
        function getChildNamespace(parentNamespace, type) {
            if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
                return getIntrinsicNamespace(type);
            }
            if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
                return HTML_NAMESPACE;
            }
            return parentNamespace;
        }
        var createMicrosoftUnsafeLocalFunction = function (func) {
            if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
                return function (arg0, arg1, arg2, arg3) {
                    MSApp.execUnsafeLocalFunction(function () {
                        return func(arg0, arg1, arg2, arg3);
                    });
                };
            } else {
                return func;
            }
        };
        var reusableSVGContainer;
        var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
            if (node.namespaceURI === Namespaces.svg) {
                if (!('innerHTML' in node)) {
                    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                    reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                    var svgNode = reusableSVGContainer.firstChild;
                    while (node.firstChild) {
                        node.removeChild(node.firstChild);
                    }
                    while (svgNode.firstChild) {
                        node.appendChild(svgNode.firstChild);
                    }
                    return;
                }
            }
            node.innerHTML = html;
        });
        var ELEMENT_NODE = 1;
        var TEXT_NODE = 3;
        var COMMENT_NODE = 8;
        var DOCUMENT_NODE = 9;
        var DOCUMENT_FRAGMENT_NODE = 11;
        var setTextContent = function (node, text) {
            if (text) {
                var firstChild = node.firstChild;
                if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                    firstChild.nodeValue = text;
                    return;
                }
            }
            node.textContent = text;
        };
        var shorthandToLonghand = {
            animation: [
                'animationDelay',
                'animationDirection',
                'animationDuration',
                'animationFillMode',
                'animationIterationCount',
                'animationName',
                'animationPlayState',
                'animationTimingFunction'
            ],
            background: [
                'backgroundAttachment',
                'backgroundClip',
                'backgroundColor',
                'backgroundImage',
                'backgroundOrigin',
                'backgroundPositionX',
                'backgroundPositionY',
                'backgroundRepeat',
                'backgroundSize'
            ],
            backgroundPosition: [
                'backgroundPositionX',
                'backgroundPositionY'
            ],
            border: [
                'borderBottomColor',
                'borderBottomStyle',
                'borderBottomWidth',
                'borderImageOutset',
                'borderImageRepeat',
                'borderImageSlice',
                'borderImageSource',
                'borderImageWidth',
                'borderLeftColor',
                'borderLeftStyle',
                'borderLeftWidth',
                'borderRightColor',
                'borderRightStyle',
                'borderRightWidth',
                'borderTopColor',
                'borderTopStyle',
                'borderTopWidth'
            ],
            borderBlockEnd: [
                'borderBlockEndColor',
                'borderBlockEndStyle',
                'borderBlockEndWidth'
            ],
            borderBlockStart: [
                'borderBlockStartColor',
                'borderBlockStartStyle',
                'borderBlockStartWidth'
            ],
            borderBottom: [
                'borderBottomColor',
                'borderBottomStyle',
                'borderBottomWidth'
            ],
            borderColor: [
                'borderBottomColor',
                'borderLeftColor',
                'borderRightColor',
                'borderTopColor'
            ],
            borderImage: [
                'borderImageOutset',
                'borderImageRepeat',
                'borderImageSlice',
                'borderImageSource',
                'borderImageWidth'
            ],
            borderInlineEnd: [
                'borderInlineEndColor',
                'borderInlineEndStyle',
                'borderInlineEndWidth'
            ],
            borderInlineStart: [
                'borderInlineStartColor',
                'borderInlineStartStyle',
                'borderInlineStartWidth'
            ],
            borderLeft: [
                'borderLeftColor',
                'borderLeftStyle',
                'borderLeftWidth'
            ],
            borderRadius: [
                'borderBottomLeftRadius',
                'borderBottomRightRadius',
                'borderTopLeftRadius',
                'borderTopRightRadius'
            ],
            borderRight: [
                'borderRightColor',
                'borderRightStyle',
                'borderRightWidth'
            ],
            borderStyle: [
                'borderBottomStyle',
                'borderLeftStyle',
                'borderRightStyle',
                'borderTopStyle'
            ],
            borderTop: [
                'borderTopColor',
                'borderTopStyle',
                'borderTopWidth'
            ],
            borderWidth: [
                'borderBottomWidth',
                'borderLeftWidth',
                'borderRightWidth',
                'borderTopWidth'
            ],
            columnRule: [
                'columnRuleColor',
                'columnRuleStyle',
                'columnRuleWidth'
            ],
            columns: [
                'columnCount',
                'columnWidth'
            ],
            flex: [
                'flexBasis',
                'flexGrow',
                'flexShrink'
            ],
            flexFlow: [
                'flexDirection',
                'flexWrap'
            ],
            font: [
                'fontFamily',
                'fontFeatureSettings',
                'fontKerning',
                'fontLanguageOverride',
                'fontSize',
                'fontSizeAdjust',
                'fontStretch',
                'fontStyle',
                'fontVariant',
                'fontVariantAlternates',
                'fontVariantCaps',
                'fontVariantEastAsian',
                'fontVariantLigatures',
                'fontVariantNumeric',
                'fontVariantPosition',
                'fontWeight',
                'lineHeight'
            ],
            fontVariant: [
                'fontVariantAlternates',
                'fontVariantCaps',
                'fontVariantEastAsian',
                'fontVariantLigatures',
                'fontVariantNumeric',
                'fontVariantPosition'
            ],
            gap: [
                'columnGap',
                'rowGap'
            ],
            grid: [
                'gridAutoColumns',
                'gridAutoFlow',
                'gridAutoRows',
                'gridTemplateAreas',
                'gridTemplateColumns',
                'gridTemplateRows'
            ],
            gridArea: [
                'gridColumnEnd',
                'gridColumnStart',
                'gridRowEnd',
                'gridRowStart'
            ],
            gridColumn: [
                'gridColumnEnd',
                'gridColumnStart'
            ],
            gridColumnGap: ['columnGap'],
            gridGap: [
                'columnGap',
                'rowGap'
            ],
            gridRow: [
                'gridRowEnd',
                'gridRowStart'
            ],
            gridRowGap: ['rowGap'],
            gridTemplate: [
                'gridTemplateAreas',
                'gridTemplateColumns',
                'gridTemplateRows'
            ],
            listStyle: [
                'listStyleImage',
                'listStylePosition',
                'listStyleType'
            ],
            margin: [
                'marginBottom',
                'marginLeft',
                'marginRight',
                'marginTop'
            ],
            marker: [
                'markerEnd',
                'markerMid',
                'markerStart'
            ],
            mask: [
                'maskClip',
                'maskComposite',
                'maskImage',
                'maskMode',
                'maskOrigin',
                'maskPositionX',
                'maskPositionY',
                'maskRepeat',
                'maskSize'
            ],
            maskPosition: [
                'maskPositionX',
                'maskPositionY'
            ],
            outline: [
                'outlineColor',
                'outlineStyle',
                'outlineWidth'
            ],
            overflow: [
                'overflowX',
                'overflowY'
            ],
            padding: [
                'paddingBottom',
                'paddingLeft',
                'paddingRight',
                'paddingTop'
            ],
            placeContent: [
                'alignContent',
                'justifyContent'
            ],
            placeItems: [
                'alignItems',
                'justifyItems'
            ],
            placeSelf: [
                'alignSelf',
                'justifySelf'
            ],
            textDecoration: [
                'textDecorationColor',
                'textDecorationLine',
                'textDecorationStyle'
            ],
            textEmphasis: [
                'textEmphasisColor',
                'textEmphasisStyle'
            ],
            transition: [
                'transitionDelay',
                'transitionDuration',
                'transitionProperty',
                'transitionTimingFunction'
            ],
            wordWrap: ['overflowWrap']
        };
        var isUnitlessNumber = {
            animationIterationCount: true,
            borderImageOutset: true,
            borderImageSlice: true,
            borderImageWidth: true,
            boxFlex: true,
            boxFlexGroup: true,
            boxOrdinalGroup: true,
            columnCount: true,
            columns: true,
            flex: true,
            flexGrow: true,
            flexPositive: true,
            flexShrink: true,
            flexNegative: true,
            flexOrder: true,
            gridArea: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowSpan: true,
            gridRowStart: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnSpan: true,
            gridColumnStart: true,
            fontWeight: true,
            lineClamp: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            tabSize: true,
            widows: true,
            zIndex: true,
            zoom: true,
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeDasharray: true,
            strokeDashoffset: true,
            strokeMiterlimit: true,
            strokeOpacity: true,
            strokeWidth: true
        };
        function prefixKey(prefix, key) {
            return prefix + key.charAt(0).toUpperCase() + key.substring(1);
        }
        var prefixes = [
            'Webkit',
            'ms',
            'Moz',
            'O'
        ];
        Object.keys(isUnitlessNumber).forEach(function (prop) {
            prefixes.forEach(function (prefix) {
                isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
            });
        });
        function dangerousStyleValue(name, value, isCustomProperty) {
            var isEmpty = value == null || typeof value === 'boolean' || value === '';
            if (isEmpty) {
                return '';
            }
            if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
                return value + 'px';
            }
            return ('' + value).trim();
        }
        var uppercasePattern = /([A-Z])/g;
        var msPattern = /^ms-/;
        function hyphenateStyleName(name) {
            return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
        }
        var warnValidStyle = function () {
        };
        {
            var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
            var msPattern$1 = /^-ms-/;
            var hyphenPattern = /-(.)/g;
            var badStyleValueWithSemicolonPattern = /;\s*$/;
            var warnedStyleNames = {};
            var warnedStyleValues = {};
            var warnedForNaNValue = false;
            var warnedForInfinityValue = false;
            var camelize = function (string) {
                return string.replace(hyphenPattern, function (_, character) {
                    return character.toUpperCase();
                });
            };
            var warnHyphenatedStyleName = function (name) {
                if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
                    return;
                }
                warnedStyleNames[name] = true;
                error('Unsupported style property %s. Did you mean %s?', name, camelize(name.replace(msPattern$1, 'ms-')));
            };
            var warnBadVendoredStyleName = function (name) {
                if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
                    return;
                }
                warnedStyleNames[name] = true;
                error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
            };
            var warnStyleValueWithSemicolon = function (name, value) {
                if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
                    return;
                }
                warnedStyleValues[value] = true;
                error('Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
            };
            var warnStyleValueIsNaN = function (name, value) {
                if (warnedForNaNValue) {
                    return;
                }
                warnedForNaNValue = true;
                error('`NaN` is an invalid value for the `%s` css style property.', name);
            };
            var warnStyleValueIsInfinity = function (name, value) {
                if (warnedForInfinityValue) {
                    return;
                }
                warnedForInfinityValue = true;
                error('`Infinity` is an invalid value for the `%s` css style property.', name);
            };
            warnValidStyle = function (name, value) {
                if (name.indexOf('-') > -1) {
                    warnHyphenatedStyleName(name);
                } else if (badVendoredStyleNamePattern.test(name)) {
                    warnBadVendoredStyleName(name);
                } else if (badStyleValueWithSemicolonPattern.test(value)) {
                    warnStyleValueWithSemicolon(name, value);
                }
                if (typeof value === 'number') {
                    if (isNaN(value)) {
                        warnStyleValueIsNaN(name, value);
                    } else if (!isFinite(value)) {
                        warnStyleValueIsInfinity(name, value);
                    }
                }
            };
        }
        var warnValidStyle$1 = warnValidStyle;
        function createDangerousStringForStyles(styles) {
            {
                var serialized = '';
                var delimiter = '';
                for (var styleName in styles) {
                    if (!styles.hasOwnProperty(styleName)) {
                        continue;
                    }
                    var styleValue = styles[styleName];
                    if (styleValue != null) {
                        var isCustomProperty = styleName.indexOf('--') === 0;
                        serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                        serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                        delimiter = ';';
                    }
                }
                return serialized || null;
            }
        }
        function setValueForStyles(node, styles) {
            var style = node.style;
            for (var styleName in styles) {
                if (!styles.hasOwnProperty(styleName)) {
                    continue;
                }
                var isCustomProperty = styleName.indexOf('--') === 0;
                {
                    if (!isCustomProperty) {
                        warnValidStyle$1(styleName, styles[styleName]);
                    }
                }
                var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
                if (styleName === 'float') {
                    styleName = 'cssFloat';
                }
                if (isCustomProperty) {
                    style.setProperty(styleName, styleValue);
                } else {
                    style[styleName] = styleValue;
                }
            }
        }
        function isValueEmpty(value) {
            return value == null || typeof value === 'boolean' || value === '';
        }
        function expandShorthandMap(styles) {
            var expanded = {};
            for (var key in styles) {
                var longhands = shorthandToLonghand[key] || [key];
                for (var i = 0; i < longhands.length; i++) {
                    expanded[longhands[i]] = key;
                }
            }
            return expanded;
        }
        function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
            {
                if (!nextStyles) {
                    return;
                }
                var expandedUpdates = expandShorthandMap(styleUpdates);
                var expandedStyles = expandShorthandMap(nextStyles);
                var warnedAbout = {};
                for (var key in expandedUpdates) {
                    var originalKey = expandedUpdates[key];
                    var correctOriginalKey = expandedStyles[key];
                    if (correctOriginalKey && originalKey !== correctOriginalKey) {
                        var warningKey = originalKey + ',' + correctOriginalKey;
                        if (warnedAbout[warningKey]) {
                            continue;
                        }
                        warnedAbout[warningKey] = true;
                        error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + 'avoid this, don\'t mix shorthand and non-shorthand properties ' + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
                    }
                }
            }
        }
        var omittedCloseTags = {
            area: true,
            base: true,
            br: true,
            col: true,
            embed: true,
            hr: true,
            img: true,
            input: true,
            keygen: true,
            link: true,
            meta: true,
            param: true,
            source: true,
            track: true,
            wbr: true
        };
        var voidElementTags = _assign({ menuitem: true }, omittedCloseTags);
        var HTML = '__html';
        function assertValidProps(tag, props) {
            if (!props) {
                return;
            }
            if (voidElementTags[tag]) {
                if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
                    {
                        throw Error(tag + ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.');
                    }
                }
            }
            if (props.dangerouslySetInnerHTML != null) {
                if (!(props.children == null)) {
                    {
                        throw Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
                    }
                }
                if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
                    {
                        throw Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.');
                    }
                }
            }
            {
                if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
                    error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
                }
            }
            if (!(props.style == null || typeof props.style === 'object')) {
                {
                    throw Error('The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.');
                }
            }
        }
        function isCustomComponent(tagName, props) {
            if (tagName.indexOf('-') === -1) {
                return typeof props.is === 'string';
            }
            switch (tagName) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
            }
        }
        var possibleStandardNames = {
            accept: 'accept',
            acceptcharset: 'acceptCharset',
            'accept-charset': 'acceptCharset',
            accesskey: 'accessKey',
            action: 'action',
            allowfullscreen: 'allowFullScreen',
            alt: 'alt',
            as: 'as',
            async: 'async',
            autocapitalize: 'autoCapitalize',
            autocomplete: 'autoComplete',
            autocorrect: 'autoCorrect',
            autofocus: 'autoFocus',
            autoplay: 'autoPlay',
            autosave: 'autoSave',
            capture: 'capture',
            cellpadding: 'cellPadding',
            cellspacing: 'cellSpacing',
            challenge: 'challenge',
            charset: 'charSet',
            checked: 'checked',
            children: 'children',
            cite: 'cite',
            class: 'className',
            classid: 'classID',
            classname: 'className',
            cols: 'cols',
            colspan: 'colSpan',
            content: 'content',
            contenteditable: 'contentEditable',
            contextmenu: 'contextMenu',
            controls: 'controls',
            controlslist: 'controlsList',
            coords: 'coords',
            crossorigin: 'crossOrigin',
            dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
            data: 'data',
            datetime: 'dateTime',
            default: 'default',
            defaultchecked: 'defaultChecked',
            defaultvalue: 'defaultValue',
            defer: 'defer',
            dir: 'dir',
            disabled: 'disabled',
            disablepictureinpicture: 'disablePictureInPicture',
            disableremoteplayback: 'disableRemotePlayback',
            download: 'download',
            draggable: 'draggable',
            enctype: 'encType',
            enterkeyhint: 'enterKeyHint',
            for: 'htmlFor',
            form: 'form',
            formmethod: 'formMethod',
            formaction: 'formAction',
            formenctype: 'formEncType',
            formnovalidate: 'formNoValidate',
            formtarget: 'formTarget',
            frameborder: 'frameBorder',
            headers: 'headers',
            height: 'height',
            hidden: 'hidden',
            high: 'high',
            href: 'href',
            hreflang: 'hrefLang',
            htmlfor: 'htmlFor',
            httpequiv: 'httpEquiv',
            'http-equiv': 'httpEquiv',
            icon: 'icon',
            id: 'id',
            innerhtml: 'innerHTML',
            inputmode: 'inputMode',
            integrity: 'integrity',
            is: 'is',
            itemid: 'itemID',
            itemprop: 'itemProp',
            itemref: 'itemRef',
            itemscope: 'itemScope',
            itemtype: 'itemType',
            keyparams: 'keyParams',
            keytype: 'keyType',
            kind: 'kind',
            label: 'label',
            lang: 'lang',
            list: 'list',
            loop: 'loop',
            low: 'low',
            manifest: 'manifest',
            marginwidth: 'marginWidth',
            marginheight: 'marginHeight',
            max: 'max',
            maxlength: 'maxLength',
            media: 'media',
            mediagroup: 'mediaGroup',
            method: 'method',
            min: 'min',
            minlength: 'minLength',
            multiple: 'multiple',
            muted: 'muted',
            name: 'name',
            nomodule: 'noModule',
            nonce: 'nonce',
            novalidate: 'noValidate',
            open: 'open',
            optimum: 'optimum',
            pattern: 'pattern',
            placeholder: 'placeholder',
            playsinline: 'playsInline',
            poster: 'poster',
            preload: 'preload',
            profile: 'profile',
            radiogroup: 'radioGroup',
            readonly: 'readOnly',
            referrerpolicy: 'referrerPolicy',
            rel: 'rel',
            required: 'required',
            reversed: 'reversed',
            role: 'role',
            rows: 'rows',
            rowspan: 'rowSpan',
            sandbox: 'sandbox',
            scope: 'scope',
            scoped: 'scoped',
            scrolling: 'scrolling',
            seamless: 'seamless',
            selected: 'selected',
            shape: 'shape',
            size: 'size',
            sizes: 'sizes',
            span: 'span',
            spellcheck: 'spellCheck',
            src: 'src',
            srcdoc: 'srcDoc',
            srclang: 'srcLang',
            srcset: 'srcSet',
            start: 'start',
            step: 'step',
            style: 'style',
            summary: 'summary',
            tabindex: 'tabIndex',
            target: 'target',
            title: 'title',
            type: 'type',
            usemap: 'useMap',
            value: 'value',
            width: 'width',
            wmode: 'wmode',
            wrap: 'wrap',
            about: 'about',
            accentheight: 'accentHeight',
            'accent-height': 'accentHeight',
            accumulate: 'accumulate',
            additive: 'additive',
            alignmentbaseline: 'alignmentBaseline',
            'alignment-baseline': 'alignmentBaseline',
            allowreorder: 'allowReorder',
            alphabetic: 'alphabetic',
            amplitude: 'amplitude',
            arabicform: 'arabicForm',
            'arabic-form': 'arabicForm',
            ascent: 'ascent',
            attributename: 'attributeName',
            attributetype: 'attributeType',
            autoreverse: 'autoReverse',
            azimuth: 'azimuth',
            basefrequency: 'baseFrequency',
            baselineshift: 'baselineShift',
            'baseline-shift': 'baselineShift',
            baseprofile: 'baseProfile',
            bbox: 'bbox',
            begin: 'begin',
            bias: 'bias',
            by: 'by',
            calcmode: 'calcMode',
            capheight: 'capHeight',
            'cap-height': 'capHeight',
            clip: 'clip',
            clippath: 'clipPath',
            'clip-path': 'clipPath',
            clippathunits: 'clipPathUnits',
            cliprule: 'clipRule',
            'clip-rule': 'clipRule',
            color: 'color',
            colorinterpolation: 'colorInterpolation',
            'color-interpolation': 'colorInterpolation',
            colorinterpolationfilters: 'colorInterpolationFilters',
            'color-interpolation-filters': 'colorInterpolationFilters',
            colorprofile: 'colorProfile',
            'color-profile': 'colorProfile',
            colorrendering: 'colorRendering',
            'color-rendering': 'colorRendering',
            contentscripttype: 'contentScriptType',
            contentstyletype: 'contentStyleType',
            cursor: 'cursor',
            cx: 'cx',
            cy: 'cy',
            d: 'd',
            datatype: 'datatype',
            decelerate: 'decelerate',
            descent: 'descent',
            diffuseconstant: 'diffuseConstant',
            direction: 'direction',
            display: 'display',
            divisor: 'divisor',
            dominantbaseline: 'dominantBaseline',
            'dominant-baseline': 'dominantBaseline',
            dur: 'dur',
            dx: 'dx',
            dy: 'dy',
            edgemode: 'edgeMode',
            elevation: 'elevation',
            enablebackground: 'enableBackground',
            'enable-background': 'enableBackground',
            end: 'end',
            exponent: 'exponent',
            externalresourcesrequired: 'externalResourcesRequired',
            fill: 'fill',
            fillopacity: 'fillOpacity',
            'fill-opacity': 'fillOpacity',
            fillrule: 'fillRule',
            'fill-rule': 'fillRule',
            filter: 'filter',
            filterres: 'filterRes',
            filterunits: 'filterUnits',
            floodopacity: 'floodOpacity',
            'flood-opacity': 'floodOpacity',
            floodcolor: 'floodColor',
            'flood-color': 'floodColor',
            focusable: 'focusable',
            fontfamily: 'fontFamily',
            'font-family': 'fontFamily',
            fontsize: 'fontSize',
            'font-size': 'fontSize',
            fontsizeadjust: 'fontSizeAdjust',
            'font-size-adjust': 'fontSizeAdjust',
            fontstretch: 'fontStretch',
            'font-stretch': 'fontStretch',
            fontstyle: 'fontStyle',
            'font-style': 'fontStyle',
            fontvariant: 'fontVariant',
            'font-variant': 'fontVariant',
            fontweight: 'fontWeight',
            'font-weight': 'fontWeight',
            format: 'format',
            from: 'from',
            fx: 'fx',
            fy: 'fy',
            g1: 'g1',
            g2: 'g2',
            glyphname: 'glyphName',
            'glyph-name': 'glyphName',
            glyphorientationhorizontal: 'glyphOrientationHorizontal',
            'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
            glyphorientationvertical: 'glyphOrientationVertical',
            'glyph-orientation-vertical': 'glyphOrientationVertical',
            glyphref: 'glyphRef',
            gradienttransform: 'gradientTransform',
            gradientunits: 'gradientUnits',
            hanging: 'hanging',
            horizadvx: 'horizAdvX',
            'horiz-adv-x': 'horizAdvX',
            horizoriginx: 'horizOriginX',
            'horiz-origin-x': 'horizOriginX',
            ideographic: 'ideographic',
            imagerendering: 'imageRendering',
            'image-rendering': 'imageRendering',
            in2: 'in2',
            in: 'in',
            inlist: 'inlist',
            intercept: 'intercept',
            k1: 'k1',
            k2: 'k2',
            k3: 'k3',
            k4: 'k4',
            k: 'k',
            kernelmatrix: 'kernelMatrix',
            kernelunitlength: 'kernelUnitLength',
            kerning: 'kerning',
            keypoints: 'keyPoints',
            keysplines: 'keySplines',
            keytimes: 'keyTimes',
            lengthadjust: 'lengthAdjust',
            letterspacing: 'letterSpacing',
            'letter-spacing': 'letterSpacing',
            lightingcolor: 'lightingColor',
            'lighting-color': 'lightingColor',
            limitingconeangle: 'limitingConeAngle',
            local: 'local',
            markerend: 'markerEnd',
            'marker-end': 'markerEnd',
            markerheight: 'markerHeight',
            markermid: 'markerMid',
            'marker-mid': 'markerMid',
            markerstart: 'markerStart',
            'marker-start': 'markerStart',
            markerunits: 'markerUnits',
            markerwidth: 'markerWidth',
            mask: 'mask',
            maskcontentunits: 'maskContentUnits',
            maskunits: 'maskUnits',
            mathematical: 'mathematical',
            mode: 'mode',
            numoctaves: 'numOctaves',
            offset: 'offset',
            opacity: 'opacity',
            operator: 'operator',
            order: 'order',
            orient: 'orient',
            orientation: 'orientation',
            origin: 'origin',
            overflow: 'overflow',
            overlineposition: 'overlinePosition',
            'overline-position': 'overlinePosition',
            overlinethickness: 'overlineThickness',
            'overline-thickness': 'overlineThickness',
            paintorder: 'paintOrder',
            'paint-order': 'paintOrder',
            panose1: 'panose1',
            'panose-1': 'panose1',
            pathlength: 'pathLength',
            patterncontentunits: 'patternContentUnits',
            patterntransform: 'patternTransform',
            patternunits: 'patternUnits',
            pointerevents: 'pointerEvents',
            'pointer-events': 'pointerEvents',
            points: 'points',
            pointsatx: 'pointsAtX',
            pointsaty: 'pointsAtY',
            pointsatz: 'pointsAtZ',
            prefix: 'prefix',
            preservealpha: 'preserveAlpha',
            preserveaspectratio: 'preserveAspectRatio',
            primitiveunits: 'primitiveUnits',
            property: 'property',
            r: 'r',
            radius: 'radius',
            refx: 'refX',
            refy: 'refY',
            renderingintent: 'renderingIntent',
            'rendering-intent': 'renderingIntent',
            repeatcount: 'repeatCount',
            repeatdur: 'repeatDur',
            requiredextensions: 'requiredExtensions',
            requiredfeatures: 'requiredFeatures',
            resource: 'resource',
            restart: 'restart',
            result: 'result',
            results: 'results',
            rotate: 'rotate',
            rx: 'rx',
            ry: 'ry',
            scale: 'scale',
            security: 'security',
            seed: 'seed',
            shaperendering: 'shapeRendering',
            'shape-rendering': 'shapeRendering',
            slope: 'slope',
            spacing: 'spacing',
            specularconstant: 'specularConstant',
            specularexponent: 'specularExponent',
            speed: 'speed',
            spreadmethod: 'spreadMethod',
            startoffset: 'startOffset',
            stddeviation: 'stdDeviation',
            stemh: 'stemh',
            stemv: 'stemv',
            stitchtiles: 'stitchTiles',
            stopcolor: 'stopColor',
            'stop-color': 'stopColor',
            stopopacity: 'stopOpacity',
            'stop-opacity': 'stopOpacity',
            strikethroughposition: 'strikethroughPosition',
            'strikethrough-position': 'strikethroughPosition',
            strikethroughthickness: 'strikethroughThickness',
            'strikethrough-thickness': 'strikethroughThickness',
            string: 'string',
            stroke: 'stroke',
            strokedasharray: 'strokeDasharray',
            'stroke-dasharray': 'strokeDasharray',
            strokedashoffset: 'strokeDashoffset',
            'stroke-dashoffset': 'strokeDashoffset',
            strokelinecap: 'strokeLinecap',
            'stroke-linecap': 'strokeLinecap',
            strokelinejoin: 'strokeLinejoin',
            'stroke-linejoin': 'strokeLinejoin',
            strokemiterlimit: 'strokeMiterlimit',
            'stroke-miterlimit': 'strokeMiterlimit',
            strokewidth: 'strokeWidth',
            'stroke-width': 'strokeWidth',
            strokeopacity: 'strokeOpacity',
            'stroke-opacity': 'strokeOpacity',
            suppresscontenteditablewarning: 'suppressContentEditableWarning',
            suppresshydrationwarning: 'suppressHydrationWarning',
            surfacescale: 'surfaceScale',
            systemlanguage: 'systemLanguage',
            tablevalues: 'tableValues',
            targetx: 'targetX',
            targety: 'targetY',
            textanchor: 'textAnchor',
            'text-anchor': 'textAnchor',
            textdecoration: 'textDecoration',
            'text-decoration': 'textDecoration',
            textlength: 'textLength',
            textrendering: 'textRendering',
            'text-rendering': 'textRendering',
            to: 'to',
            transform: 'transform',
            typeof: 'typeof',
            u1: 'u1',
            u2: 'u2',
            underlineposition: 'underlinePosition',
            'underline-position': 'underlinePosition',
            underlinethickness: 'underlineThickness',
            'underline-thickness': 'underlineThickness',
            unicode: 'unicode',
            unicodebidi: 'unicodeBidi',
            'unicode-bidi': 'unicodeBidi',
            unicoderange: 'unicodeRange',
            'unicode-range': 'unicodeRange',
            unitsperem: 'unitsPerEm',
            'units-per-em': 'unitsPerEm',
            unselectable: 'unselectable',
            valphabetic: 'vAlphabetic',
            'v-alphabetic': 'vAlphabetic',
            values: 'values',
            vectoreffect: 'vectorEffect',
            'vector-effect': 'vectorEffect',
            version: 'version',
            vertadvy: 'vertAdvY',
            'vert-adv-y': 'vertAdvY',
            vertoriginx: 'vertOriginX',
            'vert-origin-x': 'vertOriginX',
            vertoriginy: 'vertOriginY',
            'vert-origin-y': 'vertOriginY',
            vhanging: 'vHanging',
            'v-hanging': 'vHanging',
            videographic: 'vIdeographic',
            'v-ideographic': 'vIdeographic',
            viewbox: 'viewBox',
            viewtarget: 'viewTarget',
            visibility: 'visibility',
            vmathematical: 'vMathematical',
            'v-mathematical': 'vMathematical',
            vocab: 'vocab',
            widths: 'widths',
            wordspacing: 'wordSpacing',
            'word-spacing': 'wordSpacing',
            writingmode: 'writingMode',
            'writing-mode': 'writingMode',
            x1: 'x1',
            x2: 'x2',
            x: 'x',
            xchannelselector: 'xChannelSelector',
            xheight: 'xHeight',
            'x-height': 'xHeight',
            xlinkactuate: 'xlinkActuate',
            'xlink:actuate': 'xlinkActuate',
            xlinkarcrole: 'xlinkArcrole',
            'xlink:arcrole': 'xlinkArcrole',
            xlinkhref: 'xlinkHref',
            'xlink:href': 'xlinkHref',
            xlinkrole: 'xlinkRole',
            'xlink:role': 'xlinkRole',
            xlinkshow: 'xlinkShow',
            'xlink:show': 'xlinkShow',
            xlinktitle: 'xlinkTitle',
            'xlink:title': 'xlinkTitle',
            xlinktype: 'xlinkType',
            'xlink:type': 'xlinkType',
            xmlbase: 'xmlBase',
            'xml:base': 'xmlBase',
            xmllang: 'xmlLang',
            'xml:lang': 'xmlLang',
            xmlns: 'xmlns',
            'xml:space': 'xmlSpace',
            xmlnsxlink: 'xmlnsXlink',
            'xmlns:xlink': 'xmlnsXlink',
            xmlspace: 'xmlSpace',
            y1: 'y1',
            y2: 'y2',
            y: 'y',
            ychannelselector: 'yChannelSelector',
            z: 'z',
            zoomandpan: 'zoomAndPan'
        };
        var ariaProperties = {
            'aria-current': 0,
            'aria-details': 0,
            'aria-disabled': 0,
            'aria-hidden': 0,
            'aria-invalid': 0,
            'aria-keyshortcuts': 0,
            'aria-label': 0,
            'aria-roledescription': 0,
            'aria-autocomplete': 0,
            'aria-checked': 0,
            'aria-expanded': 0,
            'aria-haspopup': 0,
            'aria-level': 0,
            'aria-modal': 0,
            'aria-multiline': 0,
            'aria-multiselectable': 0,
            'aria-orientation': 0,
            'aria-placeholder': 0,
            'aria-pressed': 0,
            'aria-readonly': 0,
            'aria-required': 0,
            'aria-selected': 0,
            'aria-sort': 0,
            'aria-valuemax': 0,
            'aria-valuemin': 0,
            'aria-valuenow': 0,
            'aria-valuetext': 0,
            'aria-atomic': 0,
            'aria-busy': 0,
            'aria-live': 0,
            'aria-relevant': 0,
            'aria-dropeffect': 0,
            'aria-grabbed': 0,
            'aria-activedescendant': 0,
            'aria-colcount': 0,
            'aria-colindex': 0,
            'aria-colspan': 0,
            'aria-controls': 0,
            'aria-describedby': 0,
            'aria-errormessage': 0,
            'aria-flowto': 0,
            'aria-labelledby': 0,
            'aria-owns': 0,
            'aria-posinset': 0,
            'aria-rowcount': 0,
            'aria-rowindex': 0,
            'aria-rowspan': 0,
            'aria-setsize': 0
        };
        var warnedProperties = {};
        var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
        function validateProperty(tagName, name) {
            {
                if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
                    return true;
                }
                if (rARIACamel.test(name)) {
                    var ariaName = 'aria-' + name.slice(4).toLowerCase();
                    var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;
                    if (correctName == null) {
                        error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                        warnedProperties[name] = true;
                        return true;
                    }
                    if (name !== correctName) {
                        error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                        warnedProperties[name] = true;
                        return true;
                    }
                }
                if (rARIA.test(name)) {
                    var lowerCasedName = name.toLowerCase();
                    var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;
                    if (standardName == null) {
                        warnedProperties[name] = true;
                        return false;
                    }
                    if (name !== standardName) {
                        error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                        warnedProperties[name] = true;
                        return true;
                    }
                }
            }
            return true;
        }
        function warnInvalidARIAProps(type, props) {
            {
                var invalidProps = [];
                for (var key in props) {
                    var isValid = validateProperty(type, key);
                    if (!isValid) {
                        invalidProps.push(key);
                    }
                }
                var unknownPropString = invalidProps.map(function (prop) {
                    return '`' + prop + '`';
                }).join(', ');
                if (invalidProps.length === 1) {
                    error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
                } else if (invalidProps.length > 1) {
                    error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
                }
            }
        }
        function validateProperties(type, props) {
            if (isCustomComponent(type, props)) {
                return;
            }
            warnInvalidARIAProps(type, props);
        }
        var didWarnValueNull = false;
        function validateProperties$1(type, props) {
            {
                if (type !== 'input' && type !== 'textarea' && type !== 'select') {
                    return;
                }
                if (props != null && props.value === null && !didWarnValueNull) {
                    didWarnValueNull = true;
                    if (type === 'select' && props.multiple) {
                        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
                    } else {
                        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
                    }
                }
            }
        }
        var validateProperty$1 = function () {
        };
        {
            var warnedProperties$1 = {};
            var _hasOwnProperty = Object.prototype.hasOwnProperty;
            var EVENT_NAME_REGEX = /^on./;
            var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
            var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
            var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
            validateProperty$1 = function (tagName, name, value, eventRegistry) {
                if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
                    return true;
                }
                var lowerCasedName = name.toLowerCase();
                if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
                    error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (eventRegistry != null) {
                    var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
                    if (registrationNameDependencies.hasOwnProperty(name)) {
                        return true;
                    }
                    var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
                    if (registrationName != null) {
                        error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                        warnedProperties$1[name] = true;
                        return true;
                    }
                    if (EVENT_NAME_REGEX.test(name)) {
                        error('Unknown event handler property `%s`. It will be ignored.', name);
                        warnedProperties$1[name] = true;
                        return true;
                    }
                } else if (EVENT_NAME_REGEX.test(name)) {
                    if (INVALID_EVENT_NAME_REGEX.test(name)) {
                        error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
                    }
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
                    return true;
                }
                if (lowerCasedName === 'innerhtml') {
                    error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (lowerCasedName === 'aria') {
                    error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
                    error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (typeof value === 'number' && isNaN(value)) {
                    error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
                    warnedProperties$1[name] = true;
                    return true;
                }
                var propertyInfo = getPropertyInfo(name);
                var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;
                if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
                    var standardName = possibleStandardNames[lowerCasedName];
                    if (standardName !== name) {
                        error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                        warnedProperties$1[name] = true;
                        return true;
                    }
                } else if (!isReserved && name !== lowerCasedName) {
                    error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
                    if (value) {
                        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
                    } else {
                        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
                    }
                    warnedProperties$1[name] = true;
                    return true;
                }
                if (isReserved) {
                    return true;
                }
                if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
                    warnedProperties$1[name] = true;
                    return false;
                }
                if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
                    error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
                    warnedProperties$1[name] = true;
                    return true;
                }
                return true;
            };
        }
        var warnUnknownProperties = function (type, props, eventRegistry) {
            {
                var unknownProps = [];
                for (var key in props) {
                    var isValid = validateProperty$1(type, key, props[key], eventRegistry);
                    if (!isValid) {
                        unknownProps.push(key);
                    }
                }
                var unknownPropString = unknownProps.map(function (prop) {
                    return '`' + prop + '`';
                }).join(', ');
                if (unknownProps.length === 1) {
                    error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
                } else if (unknownProps.length > 1) {
                    error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
                }
            }
        };
        function validateProperties$2(type, props, eventRegistry) {
            if (isCustomComponent(type, props)) {
                return;
            }
            warnUnknownProperties(type, props, eventRegistry);
        }
        var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
        var IS_NON_DELEGATED = 1 << 1;
        var IS_CAPTURE_PHASE = 1 << 2;
        var IS_REPLAYED = 1 << 4;
        var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
        function getEventTarget(nativeEvent) {
            var target = nativeEvent.target || nativeEvent.srcElement || window;
            if (target.correspondingUseElement) {
                target = target.correspondingUseElement;
            }
            return target.nodeType === TEXT_NODE ? target.parentNode : target;
        }
        var restoreImpl = null;
        var restoreTarget = null;
        var restoreQueue = null;
        function restoreStateOfTarget(target) {
            var internalInstance = getInstanceFromNode(target);
            if (!internalInstance) {
                return;
            }
            if (!(typeof restoreImpl === 'function')) {
                {
                    throw Error('setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
            var stateNode = internalInstance.stateNode;
            if (stateNode) {
                var _props = getFiberCurrentPropsFromNode(stateNode);
                restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
            }
        }
        function setRestoreImplementation(impl) {
            restoreImpl = impl;
        }
        function enqueueStateRestore(target) {
            if (restoreTarget) {
                if (restoreQueue) {
                    restoreQueue.push(target);
                } else {
                    restoreQueue = [target];
                }
            } else {
                restoreTarget = target;
            }
        }
        function needsStateRestore() {
            return restoreTarget !== null || restoreQueue !== null;
        }
        function restoreStateIfNeeded() {
            if (!restoreTarget) {
                return;
            }
            var target = restoreTarget;
            var queuedTargets = restoreQueue;
            restoreTarget = null;
            restoreQueue = null;
            restoreStateOfTarget(target);
            if (queuedTargets) {
                for (var i = 0; i < queuedTargets.length; i++) {
                    restoreStateOfTarget(queuedTargets[i]);
                }
            }
        }
        var batchedUpdatesImpl = function (fn, bookkeeping) {
            return fn(bookkeeping);
        };
        var discreteUpdatesImpl = function (fn, a, b, c, d) {
            return fn(a, b, c, d);
        };
        var flushDiscreteUpdatesImpl = function () {
        };
        var batchedEventUpdatesImpl = batchedUpdatesImpl;
        var isInsideEventHandler = false;
        var isBatchingEventUpdates = false;
        function finishEventHandler() {
            var controlledComponentsHavePendingUpdates = needsStateRestore();
            if (controlledComponentsHavePendingUpdates) {
                flushDiscreteUpdatesImpl();
                restoreStateIfNeeded();
            }
        }
        function batchedUpdates(fn, bookkeeping) {
            if (isInsideEventHandler) {
                return fn(bookkeeping);
            }
            isInsideEventHandler = true;
            try {
                return batchedUpdatesImpl(fn, bookkeeping);
            } finally {
                isInsideEventHandler = false;
                finishEventHandler();
            }
        }
        function batchedEventUpdates(fn, a, b) {
            if (isBatchingEventUpdates) {
                return fn(a, b);
            }
            isBatchingEventUpdates = true;
            try {
                return batchedEventUpdatesImpl(fn, a, b);
            } finally {
                isBatchingEventUpdates = false;
                finishEventHandler();
            }
        }
        function discreteUpdates(fn, a, b, c, d) {
            var prevIsInsideEventHandler = isInsideEventHandler;
            isInsideEventHandler = true;
            try {
                return discreteUpdatesImpl(fn, a, b, c, d);
            } finally {
                isInsideEventHandler = prevIsInsideEventHandler;
                if (!isInsideEventHandler) {
                    finishEventHandler();
                }
            }
        }
        function flushDiscreteUpdatesIfNeeded(timeStamp) {
            {
                if (!isInsideEventHandler) {
                    flushDiscreteUpdatesImpl();
                }
            }
        }
        function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
            batchedUpdatesImpl = _batchedUpdatesImpl;
            discreteUpdatesImpl = _discreteUpdatesImpl;
            flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
            batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
        }
        function isInteractive(tag) {
            return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
        }
        function shouldPreventMouseEvent(name, type, props) {
            switch (name) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
            }
        }
        function getListener(inst, registrationName) {
            var stateNode = inst.stateNode;
            if (stateNode === null) {
                return null;
            }
            var props = getFiberCurrentPropsFromNode(stateNode);
            if (props === null) {
                return null;
            }
            var listener = props[registrationName];
            if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
                return null;
            }
            if (!(!listener || typeof listener === 'function')) {
                {
                    throw Error('Expected `' + registrationName + '` listener to be a function, instead got a value of `' + typeof listener + '` type.');
                }
            }
            return listener;
        }
        var passiveBrowserEventsSupported = false;
        if (canUseDOM) {
            try {
                var options = {};
                Object.defineProperty(options, 'passive', {
                    get: function () {
                        passiveBrowserEventsSupported = true;
                    }
                });
                window.addEventListener('test', options, options);
                window.removeEventListener('test', options, options);
            } catch (e) {
                passiveBrowserEventsSupported = false;
            }
        }
        function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            try {
                func.apply(context, funcArgs);
            } catch (error) {
                this.onError(error);
            }
        }
        var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
        {
            if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
                var fakeNode = document.createElement('react');
                invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
                    if (!(typeof document !== 'undefined')) {
                        {
                            throw Error('The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.');
                        }
                    }
                    var evt = document.createEvent('Event');
                    var didCall = false;
                    var didError = true;
                    var windowEvent = window.event;
                    var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
                    function restoreAfterDispatch() {
                        fakeNode.removeEventListener(evtType, callCallback, false);
                        if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                            window.event = windowEvent;
                        }
                    }
                    var funcArgs = Array.prototype.slice.call(arguments, 3);
                    function callCallback() {
                        didCall = true;
                        restoreAfterDispatch();
                        func.apply(context, funcArgs);
                        didError = false;
                    }
                    var error;
                    var didSetError = false;
                    var isCrossOriginError = false;
                    function handleWindowError(event) {
                        error = event.error;
                        didSetError = true;
                        if (error === null && event.colno === 0 && event.lineno === 0) {
                            isCrossOriginError = true;
                        }
                        if (event.defaultPrevented) {
                            if (error != null && typeof error === 'object') {
                                try {
                                    error._suppressLogging = true;
                                } catch (inner) {
                                }
                            }
                        }
                    }
                    var evtType = 'react-' + (name ? name : 'invokeguardedcallback');
                    window.addEventListener('error', handleWindowError);
                    fakeNode.addEventListener(evtType, callCallback, false);
                    evt.initEvent(evtType, false, false);
                    fakeNode.dispatchEvent(evt);
                    if (windowEventDescriptor) {
                        Object.defineProperty(window, 'event', windowEventDescriptor);
                    }
                    if (didCall && didError) {
                        if (!didSetError) {
                            error = new Error('An error was thrown inside one of your components, but React ' + 'doesn\'t know what it was. This is likely due to browser ' + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + 'DEV-mode only tricks. It\'s possible that these don\'t work in ' + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
                        } else if (isCrossOriginError) {
                            error = new Error('A cross-origin error was thrown. React doesn\'t have access to ' + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
                        }
                        this.onError(error);
                    }
                    window.removeEventListener('error', handleWindowError);
                    if (!didCall) {
                        restoreAfterDispatch();
                        return invokeGuardedCallbackProd.apply(this, arguments);
                    }
                };
            }
        }
        var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
        var hasError = false;
        var caughtError = null;
        var hasRethrowError = false;
        var rethrowError = null;
        var reporter = {
            onError: function (error) {
                hasError = true;
                caughtError = error;
            }
        };
        function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
            hasError = false;
            caughtError = null;
            invokeGuardedCallbackImpl$1.apply(reporter, arguments);
        }
        function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
            invokeGuardedCallback.apply(this, arguments);
            if (hasError) {
                var error = clearCaughtError();
                if (!hasRethrowError) {
                    hasRethrowError = true;
                    rethrowError = error;
                }
            }
        }
        function rethrowCaughtError() {
            if (hasRethrowError) {
                var error = rethrowError;
                hasRethrowError = false;
                rethrowError = null;
                throw error;
            }
        }
        function hasCaughtError() {
            return hasError;
        }
        function clearCaughtError() {
            if (hasError) {
                var error = caughtError;
                hasError = false;
                caughtError = null;
                return error;
            } else {
                {
                    {
                        throw Error('clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
            }
        }
        function get(key) {
            return key._reactInternals;
        }
        function has(key) {
            return key._reactInternals !== undefined;
        }
        function set(key, value) {
            key._reactInternals = value;
        }
        var NoFlags = 0;
        var PerformedWork = 1;
        var Placement = 2;
        var Update = 4;
        var PlacementAndUpdate = 6;
        var Deletion = 8;
        var ContentReset = 16;
        var Callback = 32;
        var DidCapture = 64;
        var Ref = 128;
        var Snapshot = 256;
        var Passive = 512;
        var PassiveUnmountPendingDev = 8192;
        var Hydrating = 1024;
        var HydratingAndUpdate = 1028;
        var LifecycleEffectMask = 932;
        var HostEffectMask = 2047;
        var Incomplete = 2048;
        var ShouldCapture = 4096;
        var ForceUpdateForLegacySuspense = 16384;
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        function getNearestMountedFiber(fiber) {
            var node = fiber;
            var nearestMounted = fiber;
            if (!fiber.alternate) {
                var nextNode = node;
                do {
                    node = nextNode;
                    if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
                        nearestMounted = node.return;
                    }
                    nextNode = node.return;
                } while (nextNode);
            } else {
                while (node.return) {
                    node = node.return;
                }
            }
            if (node.tag === HostRoot) {
                return nearestMounted;
            }
            return null;
        }
        function getSuspenseInstanceFromFiber(fiber) {
            if (fiber.tag === SuspenseComponent) {
                var suspenseState = fiber.memoizedState;
                if (suspenseState === null) {
                    var current = fiber.alternate;
                    if (current !== null) {
                        suspenseState = current.memoizedState;
                    }
                }
                if (suspenseState !== null) {
                    return suspenseState.dehydrated;
                }
            }
            return null;
        }
        function getContainerFromFiber(fiber) {
            return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
        }
        function isFiberMounted(fiber) {
            return getNearestMountedFiber(fiber) === fiber;
        }
        function isMounted(component) {
            {
                var owner = ReactCurrentOwner.current;
                if (owner !== null && owner.tag === ClassComponent) {
                    var ownerFiber = owner;
                    var instance = ownerFiber.stateNode;
                    if (!instance._warnedAboutRefsInRender) {
                        error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
                    }
                    instance._warnedAboutRefsInRender = true;
                }
            }
            var fiber = get(component);
            if (!fiber) {
                return false;
            }
            return getNearestMountedFiber(fiber) === fiber;
        }
        function assertIsMounted(fiber) {
            if (!(getNearestMountedFiber(fiber) === fiber)) {
                {
                    throw Error('Unable to find node on an unmounted component.');
                }
            }
        }
        function findCurrentFiberUsingSlowPath(fiber) {
            var alternate = fiber.alternate;
            if (!alternate) {
                var nearestMounted = getNearestMountedFiber(fiber);
                if (!(nearestMounted !== null)) {
                    {
                        throw Error('Unable to find node on an unmounted component.');
                    }
                }
                if (nearestMounted !== fiber) {
                    return null;
                }
                return fiber;
            }
            var a = fiber;
            var b = alternate;
            while (true) {
                var parentA = a.return;
                if (parentA === null) {
                    break;
                }
                var parentB = parentA.alternate;
                if (parentB === null) {
                    var nextParent = parentA.return;
                    if (nextParent !== null) {
                        a = b = nextParent;
                        continue;
                    }
                    break;
                }
                if (parentA.child === parentB.child) {
                    var child = parentA.child;
                    while (child) {
                        if (child === a) {
                            assertIsMounted(parentA);
                            return fiber;
                        }
                        if (child === b) {
                            assertIsMounted(parentA);
                            return alternate;
                        }
                        child = child.sibling;
                    }
                    {
                        {
                            throw Error('Unable to find node on an unmounted component.');
                        }
                    }
                }
                if (a.return !== b.return) {
                    a = parentA;
                    b = parentB;
                } else {
                    var didFindChild = false;
                    var _child = parentA.child;
                    while (_child) {
                        if (_child === a) {
                            didFindChild = true;
                            a = parentA;
                            b = parentB;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentA;
                            a = parentB;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) {
                        _child = parentB.child;
                        while (_child) {
                            if (_child === a) {
                                didFindChild = true;
                                a = parentB;
                                b = parentA;
                                break;
                            }
                            if (_child === b) {
                                didFindChild = true;
                                b = parentB;
                                a = parentA;
                                break;
                            }
                            _child = _child.sibling;
                        }
                        if (!didFindChild) {
                            {
                                throw Error('Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.');
                            }
                        }
                    }
                }
                if (!(a.alternate === b)) {
                    {
                        throw Error('Return fibers should always be each others\' alternates. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
            }
            if (!(a.tag === HostRoot)) {
                {
                    throw Error('Unable to find node on an unmounted component.');
                }
            }
            if (a.stateNode.current === a) {
                return fiber;
            }
            return alternate;
        }
        function findCurrentHostFiber(parent) {
            var currentParent = findCurrentFiberUsingSlowPath(parent);
            if (!currentParent) {
                return null;
            }
            var node = currentParent;
            while (true) {
                if (node.tag === HostComponent || node.tag === HostText) {
                    return node;
                } else if (node.child) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === currentParent) {
                    return null;
                }
                while (!node.sibling) {
                    if (!node.return || node.return === currentParent) {
                        return null;
                    }
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
            return null;
        }
        function findCurrentHostFiberWithNoPortals(parent) {
            var currentParent = findCurrentFiberUsingSlowPath(parent);
            if (!currentParent) {
                return null;
            }
            var node = currentParent;
            while (true) {
                if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) {
                    return node;
                } else if (node.child && node.tag !== HostPortal) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === currentParent) {
                    return null;
                }
                while (!node.sibling) {
                    if (!node.return || node.return === currentParent) {
                        return null;
                    }
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
            return null;
        }
        function doesFiberContain(parentFiber, childFiber) {
            var node = childFiber;
            var parentFiberAlternate = parentFiber.alternate;
            while (node !== null) {
                if (node === parentFiber || node === parentFiberAlternate) {
                    return true;
                }
                node = node.return;
            }
            return false;
        }
        var attemptUserBlockingHydration;
        function setAttemptUserBlockingHydration(fn) {
            attemptUserBlockingHydration = fn;
        }
        var attemptContinuousHydration;
        function setAttemptContinuousHydration(fn) {
            attemptContinuousHydration = fn;
        }
        var attemptHydrationAtCurrentPriority;
        function setAttemptHydrationAtCurrentPriority(fn) {
            attemptHydrationAtCurrentPriority = fn;
        }
        var attemptHydrationAtPriority;
        function setAttemptHydrationAtPriority(fn) {
            attemptHydrationAtPriority = fn;
        }
        var hasScheduledReplayAttempt = false;
        var queuedDiscreteEvents = [];
        var queuedFocus = null;
        var queuedDrag = null;
        var queuedMouse = null;
        var queuedPointers = new Map();
        var queuedPointerCaptures = new Map();
        var queuedExplicitHydrationTargets = [];
        function hasQueuedDiscreteEvents() {
            return queuedDiscreteEvents.length > 0;
        }
        var discreteReplayableEvents = [
            'mousedown',
            'mouseup',
            'touchcancel',
            'touchend',
            'touchstart',
            'auxclick',
            'dblclick',
            'pointercancel',
            'pointerdown',
            'pointerup',
            'dragend',
            'dragstart',
            'drop',
            'compositionend',
            'compositionstart',
            'keydown',
            'keypress',
            'keyup',
            'input',
            'textInput',
            'copy',
            'cut',
            'paste',
            'click',
            'change',
            'contextmenu',
            'reset',
            'submit'
        ];
        function isReplayableDiscreteEvent(eventType) {
            return discreteReplayableEvents.indexOf(eventType) > -1;
        }
        function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
            return {
                blockedOn: blockedOn,
                domEventName: domEventName,
                eventSystemFlags: eventSystemFlags | IS_REPLAYED,
                nativeEvent: nativeEvent,
                targetContainers: [targetContainer]
            };
        }
        function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            queuedDiscreteEvents.push(queuedEvent);
        }
        function clearIfContinuousEvent(domEventName, nativeEvent) {
            switch (domEventName) {
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout': {
                    var pointerId = nativeEvent.pointerId;
                    queuedPointers.delete(pointerId);
                    break;
                }
            case 'gotpointercapture':
            case 'lostpointercapture': {
                    var _pointerId = nativeEvent.pointerId;
                    queuedPointerCaptures.delete(_pointerId);
                    break;
                }
            }
        }
        function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
            if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
                var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (blockedOn !== null) {
                    var _fiber2 = getInstanceFromNode(blockedOn);
                    if (_fiber2 !== null) {
                        attemptContinuousHydration(_fiber2);
                    }
                }
                return queuedEvent;
            }
            existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
            var targetContainers = existingQueuedEvent.targetContainers;
            if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
                targetContainers.push(targetContainer);
            }
            return existingQueuedEvent;
        }
        function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
            switch (domEventName) {
            case 'focusin': {
                    var focusEvent = nativeEvent;
                    queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                    return true;
                }
            case 'dragenter': {
                    var dragEvent = nativeEvent;
                    queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                    return true;
                }
            case 'mouseover': {
                    var mouseEvent = nativeEvent;
                    queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                    return true;
                }
            case 'pointerover': {
                    var pointerEvent = nativeEvent;
                    var pointerId = pointerEvent.pointerId;
                    queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                    return true;
                }
            case 'gotpointercapture': {
                    var _pointerEvent = nativeEvent;
                    var _pointerId2 = _pointerEvent.pointerId;
                    queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                    return true;
                }
            }
            return false;
        }
        function attemptExplicitHydrationTarget(queuedTarget) {
            var targetInst = getClosestInstanceFromNode(queuedTarget.target);
            if (targetInst !== null) {
                var nearestMounted = getNearestMountedFiber(targetInst);
                if (nearestMounted !== null) {
                    var tag = nearestMounted.tag;
                    if (tag === SuspenseComponent) {
                        var instance = getSuspenseInstanceFromFiber(nearestMounted);
                        if (instance !== null) {
                            queuedTarget.blockedOn = instance;
                            attemptHydrationAtPriority(queuedTarget.lanePriority, function () {
                                Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
                                    attemptHydrationAtCurrentPriority(nearestMounted);
                                });
                            });
                            return;
                        }
                    } else if (tag === HostRoot) {
                        var root = nearestMounted.stateNode;
                        if (root.hydrate) {
                            queuedTarget.blockedOn = getContainerFromFiber(nearestMounted);
                            return;
                        }
                    }
                }
            }
            queuedTarget.blockedOn = null;
        }
        function attemptReplayContinuousQueuedEvent(queuedEvent) {
            if (queuedEvent.blockedOn !== null) {
                return false;
            }
            var targetContainers = queuedEvent.targetContainers;
            while (targetContainers.length > 0) {
                var targetContainer = targetContainers[0];
                var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
                if (nextBlockedOn !== null) {
                    var _fiber3 = getInstanceFromNode(nextBlockedOn);
                    if (_fiber3 !== null) {
                        attemptContinuousHydration(_fiber3);
                    }
                    queuedEvent.blockedOn = nextBlockedOn;
                    return false;
                }
                targetContainers.shift();
            }
            return true;
        }
        function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
            if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
                map.delete(key);
            }
        }
        function replayUnblockedEvents() {
            hasScheduledReplayAttempt = false;
            while (queuedDiscreteEvents.length > 0) {
                var nextDiscreteEvent = queuedDiscreteEvents[0];
                if (nextDiscreteEvent.blockedOn !== null) {
                    var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);
                    if (_fiber4 !== null) {
                        attemptUserBlockingHydration(_fiber4);
                    }
                    break;
                }
                var targetContainers = nextDiscreteEvent.targetContainers;
                while (targetContainers.length > 0) {
                    var targetContainer = targetContainers[0];
                    var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);
                    if (nextBlockedOn !== null) {
                        nextDiscreteEvent.blockedOn = nextBlockedOn;
                        break;
                    }
                    targetContainers.shift();
                }
                if (nextDiscreteEvent.blockedOn === null) {
                    queuedDiscreteEvents.shift();
                }
            }
            if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
                queuedFocus = null;
            }
            if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
                queuedDrag = null;
            }
            if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
                queuedMouse = null;
            }
            queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
            queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
        }
        function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
            if (queuedEvent.blockedOn === unblocked) {
                queuedEvent.blockedOn = null;
                if (!hasScheduledReplayAttempt) {
                    hasScheduledReplayAttempt = true;
                    Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
                }
            }
        }
        function retryIfBlockedOn(unblocked) {
            if (queuedDiscreteEvents.length > 0) {
                scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked);
                for (var i = 1; i < queuedDiscreteEvents.length; i++) {
                    var queuedEvent = queuedDiscreteEvents[i];
                    if (queuedEvent.blockedOn === unblocked) {
                        queuedEvent.blockedOn = null;
                    }
                }
            }
            if (queuedFocus !== null) {
                scheduleCallbackIfUnblocked(queuedFocus, unblocked);
            }
            if (queuedDrag !== null) {
                scheduleCallbackIfUnblocked(queuedDrag, unblocked);
            }
            if (queuedMouse !== null) {
                scheduleCallbackIfUnblocked(queuedMouse, unblocked);
            }
            var unblock = function (queuedEvent) {
                return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
            };
            queuedPointers.forEach(unblock);
            queuedPointerCaptures.forEach(unblock);
            for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
                var queuedTarget = queuedExplicitHydrationTargets[_i];
                if (queuedTarget.blockedOn === unblocked) {
                    queuedTarget.blockedOn = null;
                }
            }
            while (queuedExplicitHydrationTargets.length > 0) {
                var nextExplicitTarget = queuedExplicitHydrationTargets[0];
                if (nextExplicitTarget.blockedOn !== null) {
                    break;
                } else {
                    attemptExplicitHydrationTarget(nextExplicitTarget);
                    if (nextExplicitTarget.blockedOn === null) {
                        queuedExplicitHydrationTargets.shift();
                    }
                }
            }
        }
        var DiscreteEvent = 0;
        var UserBlockingEvent = 1;
        var ContinuousEvent = 2;
        function makePrefixMap(styleProp, eventName) {
            var prefixes = {};
            prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
            prefixes['Webkit' + styleProp] = 'webkit' + eventName;
            prefixes['Moz' + styleProp] = 'moz' + eventName;
            return prefixes;
        }
        var vendorPrefixes = {
            animationend: makePrefixMap('Animation', 'AnimationEnd'),
            animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
            animationstart: makePrefixMap('Animation', 'AnimationStart'),
            transitionend: makePrefixMap('Transition', 'TransitionEnd')
        };
        var prefixedEventNames = {};
        var style = {};
        if (canUseDOM) {
            style = document.createElement('div').style;
            if (!('AnimationEvent' in window)) {
                delete vendorPrefixes.animationend.animation;
                delete vendorPrefixes.animationiteration.animation;
                delete vendorPrefixes.animationstart.animation;
            }
            if (!('TransitionEvent' in window)) {
                delete vendorPrefixes.transitionend.transition;
            }
        }
        function getVendorPrefixedEventName(eventName) {
            if (prefixedEventNames[eventName]) {
                return prefixedEventNames[eventName];
            } else if (!vendorPrefixes[eventName]) {
                return eventName;
            }
            var prefixMap = vendorPrefixes[eventName];
            for (var styleProp in prefixMap) {
                if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
                    return prefixedEventNames[eventName] = prefixMap[styleProp];
                }
            }
            return eventName;
        }
        var ANIMATION_END = getVendorPrefixedEventName('animationend');
        var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
        var ANIMATION_START = getVendorPrefixedEventName('animationstart');
        var TRANSITION_END = getVendorPrefixedEventName('transitionend');
        var topLevelEventsToReactNames = new Map();
        var eventPriorities = new Map();
        var discreteEventPairsForSimpleEventPlugin = [
            'cancel',
            'cancel',
            'click',
            'click',
            'close',
            'close',
            'contextmenu',
            'contextMenu',
            'copy',
            'copy',
            'cut',
            'cut',
            'auxclick',
            'auxClick',
            'dblclick',
            'doubleClick',
            'dragend',
            'dragEnd',
            'dragstart',
            'dragStart',
            'drop',
            'drop',
            'focusin',
            'focus',
            'focusout',
            'blur',
            'input',
            'input',
            'invalid',
            'invalid',
            'keydown',
            'keyDown',
            'keypress',
            'keyPress',
            'keyup',
            'keyUp',
            'mousedown',
            'mouseDown',
            'mouseup',
            'mouseUp',
            'paste',
            'paste',
            'pause',
            'pause',
            'play',
            'play',
            'pointercancel',
            'pointerCancel',
            'pointerdown',
            'pointerDown',
            'pointerup',
            'pointerUp',
            'ratechange',
            'rateChange',
            'reset',
            'reset',
            'seeked',
            'seeked',
            'submit',
            'submit',
            'touchcancel',
            'touchCancel',
            'touchend',
            'touchEnd',
            'touchstart',
            'touchStart',
            'volumechange',
            'volumeChange'
        ];
        var otherDiscreteEvents = [
            'change',
            'selectionchange',
            'textInput',
            'compositionstart',
            'compositionend',
            'compositionupdate'
        ];
        var userBlockingPairsForSimpleEventPlugin = [
            'drag',
            'drag',
            'dragenter',
            'dragEnter',
            'dragexit',
            'dragExit',
            'dragleave',
            'dragLeave',
            'dragover',
            'dragOver',
            'mousemove',
            'mouseMove',
            'mouseout',
            'mouseOut',
            'mouseover',
            'mouseOver',
            'pointermove',
            'pointerMove',
            'pointerout',
            'pointerOut',
            'pointerover',
            'pointerOver',
            'scroll',
            'scroll',
            'toggle',
            'toggle',
            'touchmove',
            'touchMove',
            'wheel',
            'wheel'
        ];
        var continuousPairsForSimpleEventPlugin = [
            'abort',
            'abort',
            ANIMATION_END,
            'animationEnd',
            ANIMATION_ITERATION,
            'animationIteration',
            ANIMATION_START,
            'animationStart',
            'canplay',
            'canPlay',
            'canplaythrough',
            'canPlayThrough',
            'durationchange',
            'durationChange',
            'emptied',
            'emptied',
            'encrypted',
            'encrypted',
            'ended',
            'ended',
            'error',
            'error',
            'gotpointercapture',
            'gotPointerCapture',
            'load',
            'load',
            'loadeddata',
            'loadedData',
            'loadedmetadata',
            'loadedMetadata',
            'loadstart',
            'loadStart',
            'lostpointercapture',
            'lostPointerCapture',
            'playing',
            'playing',
            'progress',
            'progress',
            'seeking',
            'seeking',
            'stalled',
            'stalled',
            'suspend',
            'suspend',
            'timeupdate',
            'timeUpdate',
            TRANSITION_END,
            'transitionEnd',
            'waiting',
            'waiting'
        ];
        function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
            for (var i = 0; i < eventTypes.length; i += 2) {
                var topEvent = eventTypes[i];
                var event = eventTypes[i + 1];
                var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
                var reactName = 'on' + capitalizedEvent;
                eventPriorities.set(topEvent, priority);
                topLevelEventsToReactNames.set(topEvent, reactName);
                registerTwoPhaseEvent(reactName, [topEvent]);
            }
        }
        function setEventPriorities(eventTypes, priority) {
            for (var i = 0; i < eventTypes.length; i++) {
                eventPriorities.set(eventTypes[i], priority);
            }
        }
        function getEventPriorityForPluginSystem(domEventName) {
            var priority = eventPriorities.get(domEventName);
            return priority === undefined ? ContinuousEvent : priority;
        }
        function registerSimpleEvents() {
            registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
            registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
            registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
            setEventPriorities(otherDiscreteEvents, DiscreteEvent);
        }
        var Scheduler_now = Scheduler.unstable_now;
        {
            if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
                {
                    throw Error('It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling');
                }
            }
        }
        var ImmediatePriority = 99;
        var UserBlockingPriority = 98;
        var NormalPriority = 97;
        var LowPriority = 96;
        var IdlePriority = 95;
        var NoPriority = 90;
        var initialTimeMs = Scheduler_now();
        var SyncLanePriority = 15;
        var SyncBatchedLanePriority = 14;
        var InputDiscreteHydrationLanePriority = 13;
        var InputDiscreteLanePriority = 12;
        var InputContinuousHydrationLanePriority = 11;
        var InputContinuousLanePriority = 10;
        var DefaultHydrationLanePriority = 9;
        var DefaultLanePriority = 8;
        var TransitionHydrationPriority = 7;
        var TransitionPriority = 6;
        var RetryLanePriority = 5;
        var SelectiveHydrationLanePriority = 4;
        var IdleHydrationLanePriority = 3;
        var IdleLanePriority = 2;
        var OffscreenLanePriority = 1;
        var NoLanePriority = 0;
        var TotalLanes = 31;
        var NoLanes = 0;
        var NoLane = 0;
        var SyncLane = 1;
        var SyncBatchedLane = 2;
        var InputDiscreteHydrationLane = 4;
        var InputDiscreteLanes = 24;
        var InputContinuousHydrationLane = 32;
        var InputContinuousLanes = 192;
        var DefaultHydrationLane = 256;
        var DefaultLanes = 3584;
        var TransitionHydrationLane = 4096;
        var TransitionLanes = 4186112;
        var RetryLanes = 62914560;
        var SomeRetryLane = 33554432;
        var SelectiveHydrationLane = 67108864;
        var NonIdleLanes = 134217727;
        var IdleHydrationLane = 134217728;
        var IdleLanes = 805306368;
        var OffscreenLane = 1073741824;
        var NoTimestamp = -1;
        function setCurrentUpdateLanePriority(newLanePriority) {
        }
        var return_highestLanePriority = DefaultLanePriority;
        function getHighestPriorityLanes(lanes) {
            if ((SyncLane & lanes) !== NoLanes) {
                return_highestLanePriority = SyncLanePriority;
                return SyncLane;
            }
            if ((SyncBatchedLane & lanes) !== NoLanes) {
                return_highestLanePriority = SyncBatchedLanePriority;
                return SyncBatchedLane;
            }
            if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
                return_highestLanePriority = InputDiscreteHydrationLanePriority;
                return InputDiscreteHydrationLane;
            }
            var inputDiscreteLanes = InputDiscreteLanes & lanes;
            if (inputDiscreteLanes !== NoLanes) {
                return_highestLanePriority = InputDiscreteLanePriority;
                return inputDiscreteLanes;
            }
            if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
                return_highestLanePriority = InputContinuousHydrationLanePriority;
                return InputContinuousHydrationLane;
            }
            var inputContinuousLanes = InputContinuousLanes & lanes;
            if (inputContinuousLanes !== NoLanes) {
                return_highestLanePriority = InputContinuousLanePriority;
                return inputContinuousLanes;
            }
            if ((lanes & DefaultHydrationLane) !== NoLanes) {
                return_highestLanePriority = DefaultHydrationLanePriority;
                return DefaultHydrationLane;
            }
            var defaultLanes = DefaultLanes & lanes;
            if (defaultLanes !== NoLanes) {
                return_highestLanePriority = DefaultLanePriority;
                return defaultLanes;
            }
            if ((lanes & TransitionHydrationLane) !== NoLanes) {
                return_highestLanePriority = TransitionHydrationPriority;
                return TransitionHydrationLane;
            }
            var transitionLanes = TransitionLanes & lanes;
            if (transitionLanes !== NoLanes) {
                return_highestLanePriority = TransitionPriority;
                return transitionLanes;
            }
            var retryLanes = RetryLanes & lanes;
            if (retryLanes !== NoLanes) {
                return_highestLanePriority = RetryLanePriority;
                return retryLanes;
            }
            if (lanes & SelectiveHydrationLane) {
                return_highestLanePriority = SelectiveHydrationLanePriority;
                return SelectiveHydrationLane;
            }
            if ((lanes & IdleHydrationLane) !== NoLanes) {
                return_highestLanePriority = IdleHydrationLanePriority;
                return IdleHydrationLane;
            }
            var idleLanes = IdleLanes & lanes;
            if (idleLanes !== NoLanes) {
                return_highestLanePriority = IdleLanePriority;
                return idleLanes;
            }
            if ((OffscreenLane & lanes) !== NoLanes) {
                return_highestLanePriority = OffscreenLanePriority;
                return OffscreenLane;
            }
            {
                error('Should have found matching lanes. This is a bug in React.');
            }
            return_highestLanePriority = DefaultLanePriority;
            return lanes;
        }
        function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
            switch (schedulerPriorityLevel) {
            case ImmediatePriority:
                return SyncLanePriority;
            case UserBlockingPriority:
                return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
                return DefaultLanePriority;
            case IdlePriority:
                return IdleLanePriority;
            default:
                return NoLanePriority;
            }
        }
        function lanePriorityToSchedulerPriority(lanePriority) {
            switch (lanePriority) {
            case SyncLanePriority:
            case SyncBatchedLanePriority:
                return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
                return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
                return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
                return IdlePriority;
            case NoLanePriority:
                return NoPriority;
            default: {
                    {
                        throw Error('Invalid update priority: ' + lanePriority + '. This is a bug in React.');
                    }
                }
            }
        }
        function getNextLanes(root, wipLanes) {
            var pendingLanes = root.pendingLanes;
            if (pendingLanes === NoLanes) {
                return_highestLanePriority = NoLanePriority;
                return NoLanes;
            }
            var nextLanes = NoLanes;
            var nextLanePriority = NoLanePriority;
            var expiredLanes = root.expiredLanes;
            var suspendedLanes = root.suspendedLanes;
            var pingedLanes = root.pingedLanes;
            if (expiredLanes !== NoLanes) {
                nextLanes = expiredLanes;
                nextLanePriority = return_highestLanePriority = SyncLanePriority;
            } else {
                var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
                if (nonIdlePendingLanes !== NoLanes) {
                    var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
                    if (nonIdleUnblockedLanes !== NoLanes) {
                        nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                        nextLanePriority = return_highestLanePriority;
                    } else {
                        var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                        if (nonIdlePingedLanes !== NoLanes) {
                            nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                            nextLanePriority = return_highestLanePriority;
                        }
                    }
                } else {
                    var unblockedLanes = pendingLanes & ~suspendedLanes;
                    if (unblockedLanes !== NoLanes) {
                        nextLanes = getHighestPriorityLanes(unblockedLanes);
                        nextLanePriority = return_highestLanePriority;
                    } else {
                        if (pingedLanes !== NoLanes) {
                            nextLanes = getHighestPriorityLanes(pingedLanes);
                            nextLanePriority = return_highestLanePriority;
                        }
                    }
                }
            }
            if (nextLanes === NoLanes) {
                return NoLanes;
            }
            nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes);
            if (wipLanes !== NoLanes && wipLanes !== nextLanes && (wipLanes & suspendedLanes) === NoLanes) {
                getHighestPriorityLanes(wipLanes);
                var wipLanePriority = return_highestLanePriority;
                if (nextLanePriority <= wipLanePriority) {
                    return wipLanes;
                } else {
                    return_highestLanePriority = nextLanePriority;
                }
            }
            var entangledLanes = root.entangledLanes;
            if (entangledLanes !== NoLanes) {
                var entanglements = root.entanglements;
                var lanes = nextLanes & entangledLanes;
                while (lanes > 0) {
                    var index = pickArbitraryLaneIndex(lanes);
                    var lane = 1 << index;
                    nextLanes |= entanglements[index];
                    lanes &= ~lane;
                }
            }
            return nextLanes;
        }
        function getMostRecentEventTime(root, lanes) {
            var eventTimes = root.eventTimes;
            var mostRecentEventTime = NoTimestamp;
            while (lanes > 0) {
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                var eventTime = eventTimes[index];
                if (eventTime > mostRecentEventTime) {
                    mostRecentEventTime = eventTime;
                }
                lanes &= ~lane;
            }
            return mostRecentEventTime;
        }
        function computeExpirationTime(lane, currentTime) {
            getHighestPriorityLanes(lane);
            var priority = return_highestLanePriority;
            if (priority >= InputContinuousLanePriority) {
                return currentTime + 250;
            } else if (priority >= TransitionPriority) {
                return currentTime + 5000;
            } else {
                return NoTimestamp;
            }
        }
        function markStarvedLanesAsExpired(root, currentTime) {
            var pendingLanes = root.pendingLanes;
            var suspendedLanes = root.suspendedLanes;
            var pingedLanes = root.pingedLanes;
            var expirationTimes = root.expirationTimes;
            var lanes = pendingLanes;
            while (lanes > 0) {
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                var expirationTime = expirationTimes[index];
                if (expirationTime === NoTimestamp) {
                    if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
                        expirationTimes[index] = computeExpirationTime(lane, currentTime);
                    }
                } else if (expirationTime <= currentTime) {
                    root.expiredLanes |= lane;
                }
                lanes &= ~lane;
            }
        }
        function getLanesToRetrySynchronouslyOnError(root) {
            var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
            if (everythingButOffscreen !== NoLanes) {
                return everythingButOffscreen;
            }
            if (everythingButOffscreen & OffscreenLane) {
                return OffscreenLane;
            }
            return NoLanes;
        }
        function returnNextLanesPriority() {
            return return_highestLanePriority;
        }
        function includesNonIdleWork(lanes) {
            return (lanes & NonIdleLanes) !== NoLanes;
        }
        function includesOnlyRetries(lanes) {
            return (lanes & RetryLanes) === lanes;
        }
        function includesOnlyTransitions(lanes) {
            return (lanes & TransitionLanes) === lanes;
        }
        function findUpdateLane(lanePriority, wipLanes) {
            switch (lanePriority) {
            case NoLanePriority:
                break;
            case SyncLanePriority:
                return SyncLane;
            case SyncBatchedLanePriority:
                return SyncBatchedLane;
            case InputDiscreteLanePriority: {
                    var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
                    if (_lane === NoLane) {
                        return findUpdateLane(InputContinuousLanePriority, wipLanes);
                    }
                    return _lane;
                }
            case InputContinuousLanePriority: {
                    var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
                    if (_lane2 === NoLane) {
                        return findUpdateLane(DefaultLanePriority, wipLanes);
                    }
                    return _lane2;
                }
            case DefaultLanePriority: {
                    var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
                    if (_lane3 === NoLane) {
                        _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                        if (_lane3 === NoLane) {
                            _lane3 = pickArbitraryLane(DefaultLanes);
                        }
                    }
                    return _lane3;
                }
            case TransitionPriority:
            case RetryLanePriority:
                break;
            case IdleLanePriority:
                var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
                if (lane === NoLane) {
                    lane = pickArbitraryLane(IdleLanes);
                }
                return lane;
            }
            {
                {
                    throw Error('Invalid update priority: ' + lanePriority + '. This is a bug in React.');
                }
            }
        }
        function findTransitionLane(wipLanes, pendingLanes) {
            var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
            if (lane === NoLane) {
                lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
                if (lane === NoLane) {
                    lane = pickArbitraryLane(TransitionLanes);
                }
            }
            return lane;
        }
        function findRetryLane(wipLanes) {
            var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
            if (lane === NoLane) {
                lane = pickArbitraryLane(RetryLanes);
            }
            return lane;
        }
        function getHighestPriorityLane(lanes) {
            return lanes & -lanes;
        }
        function getLowestPriorityLane(lanes) {
            var index = 31 - clz32(lanes);
            return index < 0 ? NoLanes : 1 << index;
        }
        function getEqualOrHigherPriorityLanes(lanes) {
            return (getLowestPriorityLane(lanes) << 1) - 1;
        }
        function pickArbitraryLane(lanes) {
            return getHighestPriorityLane(lanes);
        }
        function pickArbitraryLaneIndex(lanes) {
            return 31 - clz32(lanes);
        }
        function laneToIndex(lane) {
            return pickArbitraryLaneIndex(lane);
        }
        function includesSomeLane(a, b) {
            return (a & b) !== NoLanes;
        }
        function isSubsetOfLanes(set, subset) {
            return (set & subset) === subset;
        }
        function mergeLanes(a, b) {
            return a | b;
        }
        function removeLanes(set, subset) {
            return set & ~subset;
        }
        function laneToLanes(lane) {
            return lane;
        }
        function higherPriorityLane(a, b) {
            return a !== NoLane && a < b ? a : b;
        }
        function createLaneMap(initial) {
            var laneMap = [];
            for (var i = 0; i < TotalLanes; i++) {
                laneMap.push(initial);
            }
            return laneMap;
        }
        function markRootUpdated(root, updateLane, eventTime) {
            root.pendingLanes |= updateLane;
            var higherPriorityLanes = updateLane - 1;
            root.suspendedLanes &= higherPriorityLanes;
            root.pingedLanes &= higherPriorityLanes;
            var eventTimes = root.eventTimes;
            var index = laneToIndex(updateLane);
            eventTimes[index] = eventTime;
        }
        function markRootSuspended(root, suspendedLanes) {
            root.suspendedLanes |= suspendedLanes;
            root.pingedLanes &= ~suspendedLanes;
            var expirationTimes = root.expirationTimes;
            var lanes = suspendedLanes;
            while (lanes > 0) {
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                expirationTimes[index] = NoTimestamp;
                lanes &= ~lane;
            }
        }
        function markRootPinged(root, pingedLanes, eventTime) {
            root.pingedLanes |= root.suspendedLanes & pingedLanes;
        }
        function markDiscreteUpdatesExpired(root) {
            root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
        }
        function hasDiscreteLanes(lanes) {
            return (lanes & InputDiscreteLanes) !== NoLanes;
        }
        function markRootMutableRead(root, updateLane) {
            root.mutableReadLanes |= updateLane & root.pendingLanes;
        }
        function markRootFinished(root, remainingLanes) {
            var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
            root.pendingLanes = remainingLanes;
            root.suspendedLanes = 0;
            root.pingedLanes = 0;
            root.expiredLanes &= remainingLanes;
            root.mutableReadLanes &= remainingLanes;
            root.entangledLanes &= remainingLanes;
            var entanglements = root.entanglements;
            var eventTimes = root.eventTimes;
            var expirationTimes = root.expirationTimes;
            var lanes = noLongerPendingLanes;
            while (lanes > 0) {
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                entanglements[index] = NoLanes;
                eventTimes[index] = NoTimestamp;
                expirationTimes[index] = NoTimestamp;
                lanes &= ~lane;
            }
        }
        function markRootEntangled(root, entangledLanes) {
            root.entangledLanes |= entangledLanes;
            var entanglements = root.entanglements;
            var lanes = entangledLanes;
            while (lanes > 0) {
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                entanglements[index] |= entangledLanes;
                lanes &= ~lane;
            }
        }
        var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
        var log = Math.log;
        var LN2 = Math.LN2;
        function clz32Fallback(lanes) {
            if (lanes === 0) {
                return 32;
            }
            return 31 - (log(lanes) / LN2 | 0) | 0;
        }
        var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority;
        var _enabled = true;
        function setEnabled(enabled) {
            _enabled = !!enabled;
        }
        function isEnabled() {
            return _enabled;
        }
        function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
            var eventPriority = getEventPriorityForPluginSystem(domEventName);
            var listenerWrapper;
            switch (eventPriority) {
            case DiscreteEvent:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case UserBlockingEvent:
                listenerWrapper = dispatchUserBlockingUpdate;
                break;
            case ContinuousEvent:
            default:
                listenerWrapper = dispatchEvent;
                break;
            }
            return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        }
        function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
            {
                flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
            }
            discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
        }
        function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
            {
                runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
            }
        }
        function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
            if (!_enabled) {
                return;
            }
            var allowReplay = true;
            {
                allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
            }
            if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
                queueDiscreteEvent(null, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                return;
            }
            var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn === null) {
                if (allowReplay) {
                    clearIfContinuousEvent(domEventName, nativeEvent);
                }
                return;
            }
            if (allowReplay) {
                if (isReplayableDiscreteEvent(domEventName)) {
                    queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                    return;
                }
                if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
                    return;
                }
                clearIfContinuousEvent(domEventName, nativeEvent);
            }
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
        function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
            var nativeEventTarget = getEventTarget(nativeEvent);
            var targetInst = getClosestInstanceFromNode(nativeEventTarget);
            if (targetInst !== null) {
                var nearestMounted = getNearestMountedFiber(targetInst);
                if (nearestMounted === null) {
                    targetInst = null;
                } else {
                    var tag = nearestMounted.tag;
                    if (tag === SuspenseComponent) {
                        var instance = getSuspenseInstanceFromFiber(nearestMounted);
                        if (instance !== null) {
                            return instance;
                        }
                        targetInst = null;
                    } else if (tag === HostRoot) {
                        var root = nearestMounted.stateNode;
                        if (root.hydrate) {
                            return getContainerFromFiber(nearestMounted);
                        }
                        targetInst = null;
                    } else if (nearestMounted !== targetInst) {
                        targetInst = null;
                    }
                }
            }
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer);
            return null;
        }
        function addEventBubbleListener(target, eventType, listener) {
            target.addEventListener(eventType, listener, false);
            return listener;
        }
        function addEventCaptureListener(target, eventType, listener) {
            target.addEventListener(eventType, listener, true);
            return listener;
        }
        function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
            target.addEventListener(eventType, listener, {
                capture: true,
                passive: passive
            });
            return listener;
        }
        function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
            target.addEventListener(eventType, listener, { passive: passive });
            return listener;
        }
        var root = null;
        var startText = null;
        var fallbackText = null;
        function initialize(nativeEventTarget) {
            root = nativeEventTarget;
            startText = getText();
            return true;
        }
        function reset() {
            root = null;
            startText = null;
            fallbackText = null;
        }
        function getData() {
            if (fallbackText) {
                return fallbackText;
            }
            var start;
            var startValue = startText;
            var startLength = startValue.length;
            var end;
            var endValue = getText();
            var endLength = endValue.length;
            for (start = 0; start < startLength; start++) {
                if (startValue[start] !== endValue[start]) {
                    break;
                }
            }
            var minEnd = startLength - start;
            for (end = 1; end <= minEnd; end++) {
                if (startValue[startLength - end] !== endValue[endLength - end]) {
                    break;
                }
            }
            var sliceTail = end > 1 ? 1 - end : undefined;
            fallbackText = endValue.slice(start, sliceTail);
            return fallbackText;
        }
        function getText() {
            if ('value' in root) {
                return root.value;
            }
            return root.textContent;
        }
        function getEventCharCode(nativeEvent) {
            var charCode;
            var keyCode = nativeEvent.keyCode;
            if ('charCode' in nativeEvent) {
                charCode = nativeEvent.charCode;
                if (charCode === 0 && keyCode === 13) {
                    charCode = 13;
                }
            } else {
                charCode = keyCode;
            }
            if (charCode === 10) {
                charCode = 13;
            }
            if (charCode >= 32 || charCode === 13) {
                return charCode;
            }
            return 0;
        }
        function functionThatReturnsTrue() {
            return true;
        }
        function functionThatReturnsFalse() {
            return false;
        }
        function createSyntheticEvent(Interface) {
            function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
                this._reactName = reactName;
                this._targetInst = targetInst;
                this.type = reactEventType;
                this.nativeEvent = nativeEvent;
                this.target = nativeEventTarget;
                this.currentTarget = null;
                for (var _propName in Interface) {
                    if (!Interface.hasOwnProperty(_propName)) {
                        continue;
                    }
                    var normalize = Interface[_propName];
                    if (normalize) {
                        this[_propName] = normalize(nativeEvent);
                    } else {
                        this[_propName] = nativeEvent[_propName];
                    }
                }
                var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
                if (defaultPrevented) {
                    this.isDefaultPrevented = functionThatReturnsTrue;
                } else {
                    this.isDefaultPrevented = functionThatReturnsFalse;
                }
                this.isPropagationStopped = functionThatReturnsFalse;
                return this;
            }
            _assign(SyntheticBaseEvent.prototype, {
                preventDefault: function () {
                    this.defaultPrevented = true;
                    var event = this.nativeEvent;
                    if (!event) {
                        return;
                    }
                    if (event.preventDefault) {
                        event.preventDefault();
                    } else if (typeof event.returnValue !== 'unknown') {
                        event.returnValue = false;
                    }
                    this.isDefaultPrevented = functionThatReturnsTrue;
                },
                stopPropagation: function () {
                    var event = this.nativeEvent;
                    if (!event) {
                        return;
                    }
                    if (event.stopPropagation) {
                        event.stopPropagation();
                    } else if (typeof event.cancelBubble !== 'unknown') {
                        event.cancelBubble = true;
                    }
                    this.isPropagationStopped = functionThatReturnsTrue;
                },
                persist: function () {
                },
                isPersistent: functionThatReturnsTrue
            });
            return SyntheticBaseEvent;
        }
        var EventInterface = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (event) {
                return event.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0
        };
        var SyntheticEvent = createSyntheticEvent(EventInterface);
        var UIEventInterface = _assign({}, EventInterface, {
            view: 0,
            detail: 0
        });
        var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
        var lastMovementX;
        var lastMovementY;
        var lastMouseEvent;
        function updateMouseMovementPolyfillState(event) {
            if (event !== lastMouseEvent) {
                if (lastMouseEvent && event.type === 'mousemove') {
                    lastMovementX = event.screenX - lastMouseEvent.screenX;
                    lastMovementY = event.screenY - lastMouseEvent.screenY;
                } else {
                    lastMovementX = 0;
                    lastMovementY = 0;
                }
                lastMouseEvent = event;
            }
        }
        var MouseEventInterface = _assign({}, UIEventInterface, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: getEventModifierState,
            button: 0,
            buttons: 0,
            relatedTarget: function (event) {
                if (event.relatedTarget === undefined)
                    return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
                return event.relatedTarget;
            },
            movementX: function (event) {
                if ('movementX' in event) {
                    return event.movementX;
                }
                updateMouseMovementPolyfillState(event);
                return lastMovementX;
            },
            movementY: function (event) {
                if ('movementY' in event) {
                    return event.movementY;
                }
                return lastMovementY;
            }
        });
        var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
        var DragEventInterface = _assign({}, MouseEventInterface, { dataTransfer: 0 });
        var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
        var FocusEventInterface = _assign({}, UIEventInterface, { relatedTarget: 0 });
        var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
        var AnimationEventInterface = _assign({}, EventInterface, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0
        });
        var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
        var ClipboardEventInterface = _assign({}, EventInterface, {
            clipboardData: function (event) {
                return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
            }
        });
        var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
        var CompositionEventInterface = _assign({}, EventInterface, { data: 0 });
        var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
        var SyntheticInputEvent = SyntheticCompositionEvent;
        var normalizeKey = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified'
        };
        var translateToKey = {
            '8': 'Backspace',
            '9': 'Tab',
            '12': 'Clear',
            '13': 'Enter',
            '16': 'Shift',
            '17': 'Control',
            '18': 'Alt',
            '19': 'Pause',
            '20': 'CapsLock',
            '27': 'Escape',
            '32': ' ',
            '33': 'PageUp',
            '34': 'PageDown',
            '35': 'End',
            '36': 'Home',
            '37': 'ArrowLeft',
            '38': 'ArrowUp',
            '39': 'ArrowRight',
            '40': 'ArrowDown',
            '45': 'Insert',
            '46': 'Delete',
            '112': 'F1',
            '113': 'F2',
            '114': 'F3',
            '115': 'F4',
            '116': 'F5',
            '117': 'F6',
            '118': 'F7',
            '119': 'F8',
            '120': 'F9',
            '121': 'F10',
            '122': 'F11',
            '123': 'F12',
            '144': 'NumLock',
            '145': 'ScrollLock',
            '224': 'Meta'
        };
        function getEventKey(nativeEvent) {
            if (nativeEvent.key) {
                var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                if (key !== 'Unidentified') {
                    return key;
                }
            }
            if (nativeEvent.type === 'keypress') {
                var charCode = getEventCharCode(nativeEvent);
                return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
            }
            if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
                return translateToKey[nativeEvent.keyCode] || 'Unidentified';
            }
            return '';
        }
        var modifierKeyToProp = {
            Alt: 'altKey',
            Control: 'ctrlKey',
            Meta: 'metaKey',
            Shift: 'shiftKey'
        };
        function modifierStateGetter(keyArg) {
            var syntheticEvent = this;
            var nativeEvent = syntheticEvent.nativeEvent;
            if (nativeEvent.getModifierState) {
                return nativeEvent.getModifierState(keyArg);
            }
            var keyProp = modifierKeyToProp[keyArg];
            return keyProp ? !!nativeEvent[keyProp] : false;
        }
        function getEventModifierState(nativeEvent) {
            return modifierStateGetter;
        }
        var KeyboardEventInterface = _assign({}, UIEventInterface, {
            key: getEventKey,
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: getEventModifierState,
            charCode: function (event) {
                if (event.type === 'keypress') {
                    return getEventCharCode(event);
                }
                return 0;
            },
            keyCode: function (event) {
                if (event.type === 'keydown' || event.type === 'keyup') {
                    return event.keyCode;
                }
                return 0;
            },
            which: function (event) {
                if (event.type === 'keypress') {
                    return getEventCharCode(event);
                }
                if (event.type === 'keydown' || event.type === 'keyup') {
                    return event.keyCode;
                }
                return 0;
            }
        });
        var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
        var PointerEventInterface = _assign({}, MouseEventInterface, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0
        });
        var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
        var TouchEventInterface = _assign({}, UIEventInterface, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: getEventModifierState
        });
        var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
        var TransitionEventInterface = _assign({}, EventInterface, {
            propertyName: 0,
            elapsedTime: 0,
            pseudoElement: 0
        });
        var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
        var WheelEventInterface = _assign({}, MouseEventInterface, {
            deltaX: function (event) {
                return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
            },
            deltaY: function (event) {
                return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
            },
            deltaZ: 0,
            deltaMode: 0
        });
        var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
        var END_KEYCODES = [
            9,
            13,
            27,
            32
        ];
        var START_KEYCODE = 229;
        var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
        var documentMode = null;
        if (canUseDOM && 'documentMode' in document) {
            documentMode = document.documentMode;
        }
        var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode;
        var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
        var SPACEBAR_CODE = 32;
        var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
        function registerEvents() {
            registerTwoPhaseEvent('onBeforeInput', [
                'compositionend',
                'keypress',
                'textInput',
                'paste'
            ]);
            registerTwoPhaseEvent('onCompositionEnd', [
                'compositionend',
                'focusout',
                'keydown',
                'keypress',
                'keyup',
                'mousedown'
            ]);
            registerTwoPhaseEvent('onCompositionStart', [
                'compositionstart',
                'focusout',
                'keydown',
                'keypress',
                'keyup',
                'mousedown'
            ]);
            registerTwoPhaseEvent('onCompositionUpdate', [
                'compositionupdate',
                'focusout',
                'keydown',
                'keypress',
                'keyup',
                'mousedown'
            ]);
        }
        var hasSpaceKeypress = false;
        function isKeypressCommand(nativeEvent) {
            return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && !(nativeEvent.ctrlKey && nativeEvent.altKey);
        }
        function getCompositionEventType(domEventName) {
            switch (domEventName) {
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
            }
        }
        function isFallbackCompositionStart(domEventName, nativeEvent) {
            return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
        }
        function isFallbackCompositionEnd(domEventName, nativeEvent) {
            switch (domEventName) {
            case 'keyup':
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                return true;
            default:
                return false;
            }
        }
        function getDataFromCustomEvent(nativeEvent) {
            var detail = nativeEvent.detail;
            if (typeof detail === 'object' && 'data' in detail) {
                return detail.data;
            }
            return null;
        }
        function isUsingKoreanIME(nativeEvent) {
            return nativeEvent.locale === 'ko';
        }
        var isComposing = false;
        function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
            var eventType;
            var fallbackData;
            if (canUseCompositionEvent) {
                eventType = getCompositionEventType(domEventName);
            } else if (!isComposing) {
                if (isFallbackCompositionStart(domEventName, nativeEvent)) {
                    eventType = 'onCompositionStart';
                }
            } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
                eventType = 'onCompositionEnd';
            }
            if (!eventType) {
                return null;
            }
            if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
                if (!isComposing && eventType === 'onCompositionStart') {
                    isComposing = initialize(nativeEventTarget);
                } else if (eventType === 'onCompositionEnd') {
                    if (isComposing) {
                        fallbackData = getData();
                    }
                }
            }
            var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
            if (listeners.length > 0) {
                var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                if (fallbackData) {
                    event.data = fallbackData;
                } else {
                    var customData = getDataFromCustomEvent(nativeEvent);
                    if (customData !== null) {
                        event.data = customData;
                    }
                }
            }
        }
        function getNativeBeforeInputChars(domEventName, nativeEvent) {
            switch (domEventName) {
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) {
                    return null;
                }
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                var chars = nativeEvent.data;
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                    return null;
                }
                return chars;
            default:
                return null;
            }
        }
        function getFallbackBeforeInputChars(domEventName, nativeEvent) {
            if (isComposing) {
                if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                    var chars = getData();
                    reset();
                    isComposing = false;
                    return chars;
                }
                return null;
            }
            switch (domEventName) {
            case 'paste':
                return null;
            case 'keypress':
                if (!isKeypressCommand(nativeEvent)) {
                    if (nativeEvent.char && nativeEvent.char.length > 1) {
                        return nativeEvent.char;
                    } else if (nativeEvent.which) {
                        return String.fromCharCode(nativeEvent.which);
                    }
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
            }
        }
        function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
            var chars;
            if (canUseTextInputEvent) {
                chars = getNativeBeforeInputChars(domEventName, nativeEvent);
            } else {
                chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
            }
            if (!chars) {
                return null;
            }
            var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
            if (listeners.length > 0) {
                var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.data = chars;
            }
        }
        function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
            extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        var supportedInputTypes = {
            color: true,
            date: true,
            datetime: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            password: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true
        };
        function isTextInputElement(elem) {
            var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
            if (nodeName === 'input') {
                return !!supportedInputTypes[elem.type];
            }
            if (nodeName === 'textarea') {
                return true;
            }
            return false;
        }
        function isEventSupported(eventNameSuffix) {
            if (!canUseDOM) {
                return false;
            }
            var eventName = 'on' + eventNameSuffix;
            var isSupported = eventName in document;
            if (!isSupported) {
                var element = document.createElement('div');
                element.setAttribute(eventName, 'return;');
                isSupported = typeof element[eventName] === 'function';
            }
            return isSupported;
        }
        function registerEvents$1() {
            registerTwoPhaseEvent('onChange', [
                'change',
                'click',
                'focusin',
                'focusout',
                'input',
                'keydown',
                'keyup',
                'selectionchange'
            ]);
        }
        function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
            enqueueStateRestore(target);
            var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
            }
        }
        var activeElement = null;
        var activeElementInst = null;
        function shouldUseChangeEvent(elem) {
            var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
            return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
        }
        function manualDispatchChangeEvent(nativeEvent) {
            var dispatchQueue = [];
            createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
            batchedUpdates(runEventInBatch, dispatchQueue);
        }
        function runEventInBatch(dispatchQueue) {
            processDispatchQueue(dispatchQueue, 0);
        }
        function getInstIfValueChanged(targetInst) {
            var targetNode = getNodeFromInstance(targetInst);
            if (updateValueIfChanged(targetNode)) {
                return targetInst;
            }
        }
        function getTargetInstForChangeEvent(domEventName, targetInst) {
            if (domEventName === 'change') {
                return targetInst;
            }
        }
        var isInputEventSupported = false;
        if (canUseDOM) {
            isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
        }
        function startWatchingForValueChange(target, targetInst) {
            activeElement = target;
            activeElementInst = targetInst;
            activeElement.attachEvent('onpropertychange', handlePropertyChange);
        }
        function stopWatchingForValueChange() {
            if (!activeElement) {
                return;
            }
            activeElement.detachEvent('onpropertychange', handlePropertyChange);
            activeElement = null;
            activeElementInst = null;
        }
        function handlePropertyChange(nativeEvent) {
            if (nativeEvent.propertyName !== 'value') {
                return;
            }
            if (getInstIfValueChanged(activeElementInst)) {
                manualDispatchChangeEvent(nativeEvent);
            }
        }
        function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
            if (domEventName === 'focusin') {
                stopWatchingForValueChange();
                startWatchingForValueChange(target, targetInst);
            } else if (domEventName === 'focusout') {
                stopWatchingForValueChange();
            }
        }
        function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
            if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
                return getInstIfValueChanged(activeElementInst);
            }
        }
        function shouldUseClickEvent(elem) {
            var nodeName = elem.nodeName;
            return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
        }
        function getTargetInstForClickEvent(domEventName, targetInst) {
            if (domEventName === 'click') {
                return getInstIfValueChanged(targetInst);
            }
        }
        function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
            if (domEventName === 'input' || domEventName === 'change') {
                return getInstIfValueChanged(targetInst);
            }
        }
        function handleControlledInputBlur(node) {
            var state = node._wrapperState;
            if (!state || !state.controlled || node.type !== 'number') {
                return;
            }
            {
                setDefaultValue(node, 'number', node.value);
            }
        }
        function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
            var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
            var getTargetInstFunc, handleEventFunc;
            if (shouldUseChangeEvent(targetNode)) {
                getTargetInstFunc = getTargetInstForChangeEvent;
            } else if (isTextInputElement(targetNode)) {
                if (isInputEventSupported) {
                    getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                } else {
                    getTargetInstFunc = getTargetInstForInputEventPolyfill;
                    handleEventFunc = handleEventsForInputEventPolyfill;
                }
            } else if (shouldUseClickEvent(targetNode)) {
                getTargetInstFunc = getTargetInstForClickEvent;
            }
            if (getTargetInstFunc) {
                var inst = getTargetInstFunc(domEventName, targetInst);
                if (inst) {
                    createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                    return;
                }
            }
            if (handleEventFunc) {
                handleEventFunc(domEventName, targetNode, targetInst);
            }
            if (domEventName === 'focusout') {
                handleControlledInputBlur(targetNode);
            }
        }
        function registerEvents$2() {
            registerDirectEvent('onMouseEnter', [
                'mouseout',
                'mouseover'
            ]);
            registerDirectEvent('onMouseLeave', [
                'mouseout',
                'mouseover'
            ]);
            registerDirectEvent('onPointerEnter', [
                'pointerout',
                'pointerover'
            ]);
            registerDirectEvent('onPointerLeave', [
                'pointerout',
                'pointerover'
            ]);
        }
        function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
            var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
            var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
            if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
                var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
                if (related) {
                    if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
                        return;
                    }
                }
            }
            if (!isOutEvent && !isOverEvent) {
                return;
            }
            var win;
            if (nativeEventTarget.window === nativeEventTarget) {
                win = nativeEventTarget;
            } else {
                var doc = nativeEventTarget.ownerDocument;
                if (doc) {
                    win = doc.defaultView || doc.parentWindow;
                } else {
                    win = window;
                }
            }
            var from;
            var to;
            if (isOutEvent) {
                var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
                from = targetInst;
                to = _related ? getClosestInstanceFromNode(_related) : null;
                if (to !== null) {
                    var nearestMounted = getNearestMountedFiber(to);
                    if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
                        to = null;
                    }
                }
            } else {
                from = null;
                to = targetInst;
            }
            if (from === to) {
                return;
            }
            var SyntheticEventCtor = SyntheticMouseEvent;
            var leaveEventType = 'onMouseLeave';
            var enterEventType = 'onMouseEnter';
            var eventTypePrefix = 'mouse';
            if (domEventName === 'pointerout' || domEventName === 'pointerover') {
                SyntheticEventCtor = SyntheticPointerEvent;
                leaveEventType = 'onPointerLeave';
                enterEventType = 'onPointerEnter';
                eventTypePrefix = 'pointer';
            }
            var fromNode = from == null ? win : getNodeFromInstance(from);
            var toNode = to == null ? win : getNodeFromInstance(to);
            var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
            leave.target = fromNode;
            leave.relatedTarget = toNode;
            var enter = null;
            var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
            if (nativeTargetInst === targetInst) {
                var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
                enterEvent.target = toNode;
                enterEvent.relatedTarget = fromNode;
                enter = enterEvent;
            }
            accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
        }
        function is(x, y) {
            return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
        }
        var objectIs = typeof Object.is === 'function' ? Object.is : is;
        var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
        function shallowEqual(objA, objB) {
            if (objectIs(objA, objB)) {
                return true;
            }
            if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
                return false;
            }
            var keysA = Object.keys(objA);
            var keysB = Object.keys(objB);
            if (keysA.length !== keysB.length) {
                return false;
            }
            for (var i = 0; i < keysA.length; i++) {
                if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
                    return false;
                }
            }
            return true;
        }
        function getLeafNode(node) {
            while (node && node.firstChild) {
                node = node.firstChild;
            }
            return node;
        }
        function getSiblingNode(node) {
            while (node) {
                if (node.nextSibling) {
                    return node.nextSibling;
                }
                node = node.parentNode;
            }
        }
        function getNodeForCharacterOffset(root, offset) {
            var node = getLeafNode(root);
            var nodeStart = 0;
            var nodeEnd = 0;
            while (node) {
                if (node.nodeType === TEXT_NODE) {
                    nodeEnd = nodeStart + node.textContent.length;
                    if (nodeStart <= offset && nodeEnd >= offset) {
                        return {
                            node: node,
                            offset: offset - nodeStart
                        };
                    }
                    nodeStart = nodeEnd;
                }
                node = getLeafNode(getSiblingNode(node));
            }
        }
        function getOffsets(outerNode) {
            var ownerDocument = outerNode.ownerDocument;
            var win = ownerDocument && ownerDocument.defaultView || window;
            var selection = win.getSelection && win.getSelection();
            if (!selection || selection.rangeCount === 0) {
                return null;
            }
            var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset;
            try {
                anchorNode.nodeType;
                focusNode.nodeType;
            } catch (e) {
                return null;
            }
            return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
        }
        function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
            var length = 0;
            var start = -1;
            var end = -1;
            var indexWithinAnchor = 0;
            var indexWithinFocus = 0;
            var node = outerNode;
            var parentNode = null;
            outer:
                while (true) {
                    var next = null;
                    while (true) {
                        if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
                            start = length + anchorOffset;
                        }
                        if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
                            end = length + focusOffset;
                        }
                        if (node.nodeType === TEXT_NODE) {
                            length += node.nodeValue.length;
                        }
                        if ((next = node.firstChild) === null) {
                            break;
                        }
                        parentNode = node;
                        node = next;
                    }
                    while (true) {
                        if (node === outerNode) {
                            break outer;
                        }
                        if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
                            start = length;
                        }
                        if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
                            end = length;
                        }
                        if ((next = node.nextSibling) !== null) {
                            break;
                        }
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
            if (start === -1 || end === -1) {
                return null;
            }
            return {
                start: start,
                end: end
            };
        }
        function setOffsets(node, offsets) {
            var doc = node.ownerDocument || document;
            var win = doc && doc.defaultView || window;
            if (!win.getSelection) {
                return;
            }
            var selection = win.getSelection();
            var length = node.textContent.length;
            var start = Math.min(offsets.start, length);
            var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
            if (!selection.extend && start > end) {
                var temp = end;
                end = start;
                start = temp;
            }
            var startMarker = getNodeForCharacterOffset(node, start);
            var endMarker = getNodeForCharacterOffset(node, end);
            if (startMarker && endMarker) {
                if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
                    return;
                }
                var range = doc.createRange();
                range.setStart(startMarker.node, startMarker.offset);
                selection.removeAllRanges();
                if (start > end) {
                    selection.addRange(range);
                    selection.extend(endMarker.node, endMarker.offset);
                } else {
                    range.setEnd(endMarker.node, endMarker.offset);
                    selection.addRange(range);
                }
            }
        }
        function isTextNode(node) {
            return node && node.nodeType === TEXT_NODE;
        }
        function containsNode(outerNode, innerNode) {
            if (!outerNode || !innerNode) {
                return false;
            } else if (outerNode === innerNode) {
                return true;
            } else if (isTextNode(outerNode)) {
                return false;
            } else if (isTextNode(innerNode)) {
                return containsNode(outerNode, innerNode.parentNode);
            } else if ('contains' in outerNode) {
                return outerNode.contains(innerNode);
            } else if (outerNode.compareDocumentPosition) {
                return !!(outerNode.compareDocumentPosition(innerNode) & 16);
            } else {
                return false;
            }
        }
        function isInDocument(node) {
            return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
        }
        function isSameOriginFrame(iframe) {
            try {
                return typeof iframe.contentWindow.location.href === 'string';
            } catch (err) {
                return false;
            }
        }
        function getActiveElementDeep() {
            var win = window;
            var element = getActiveElement();
            while (element instanceof win.HTMLIFrameElement) {
                if (isSameOriginFrame(element)) {
                    win = element.contentWindow;
                } else {
                    return element;
                }
                element = getActiveElement(win.document);
            }
            return element;
        }
        function hasSelectionCapabilities(elem) {
            var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
            return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
        }
        function getSelectionInformation() {
            var focusedElem = getActiveElementDeep();
            return {
                focusedElem: focusedElem,
                selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
            };
        }
        function restoreSelection(priorSelectionInformation) {
            var curFocusedElem = getActiveElementDeep();
            var priorFocusedElem = priorSelectionInformation.focusedElem;
            var priorSelectionRange = priorSelectionInformation.selectionRange;
            if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
                if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
                    setSelection(priorFocusedElem, priorSelectionRange);
                }
                var ancestors = [];
                var ancestor = priorFocusedElem;
                while (ancestor = ancestor.parentNode) {
                    if (ancestor.nodeType === ELEMENT_NODE) {
                        ancestors.push({
                            element: ancestor,
                            left: ancestor.scrollLeft,
                            top: ancestor.scrollTop
                        });
                    }
                }
                if (typeof priorFocusedElem.focus === 'function') {
                    priorFocusedElem.focus();
                }
                for (var i = 0; i < ancestors.length; i++) {
                    var info = ancestors[i];
                    info.element.scrollLeft = info.left;
                    info.element.scrollTop = info.top;
                }
            }
        }
        function getSelection(input) {
            var selection;
            if ('selectionStart' in input) {
                selection = {
                    start: input.selectionStart,
                    end: input.selectionEnd
                };
            } else {
                selection = getOffsets(input);
            }
            return selection || {
                start: 0,
                end: 0
            };
        }
        function setSelection(input, offsets) {
            var start = offsets.start;
            var end = offsets.end;
            if (end === undefined) {
                end = start;
            }
            if ('selectionStart' in input) {
                input.selectionStart = start;
                input.selectionEnd = Math.min(end, input.value.length);
            } else {
                setOffsets(input, offsets);
            }
        }
        var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
        function registerEvents$3() {
            registerTwoPhaseEvent('onSelect', [
                'focusout',
                'contextmenu',
                'dragend',
                'focusin',
                'keydown',
                'keyup',
                'mousedown',
                'mouseup',
                'selectionchange'
            ]);
        }
        var activeElement$1 = null;
        var activeElementInst$1 = null;
        var lastSelection = null;
        var mouseDown = false;
        function getSelection$1(node) {
            if ('selectionStart' in node && hasSelectionCapabilities(node)) {
                return {
                    start: node.selectionStart,
                    end: node.selectionEnd
                };
            } else {
                var win = node.ownerDocument && node.ownerDocument.defaultView || window;
                var selection = win.getSelection();
                return {
                    anchorNode: selection.anchorNode,
                    anchorOffset: selection.anchorOffset,
                    focusNode: selection.focusNode,
                    focusOffset: selection.focusOffset
                };
            }
        }
        function getEventTargetDocument(eventTarget) {
            return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
        }
        function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
            var doc = getEventTargetDocument(nativeEventTarget);
            if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
                return;
            }
            var currentSelection = getSelection$1(activeElement$1);
            if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
                lastSelection = currentSelection;
                var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
                if (listeners.length > 0) {
                    var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                    dispatchQueue.push({
                        event: event,
                        listeners: listeners
                    });
                    event.target = activeElement$1;
                }
            }
        }
        function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
            var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
            switch (domEventName) {
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            case 'selectionchange':
                if (skipSelectionChangeEvent) {
                    break;
                }
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
        }
        function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (reactName === undefined) {
                return;
            }
            var SyntheticEventCtor = SyntheticEvent;
            var reactEventType = domEventName;
            switch (domEventName) {
            case 'keypress':
                if (getEventCharCode(nativeEvent) === 0) {
                    return;
                }
            case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                if (nativeEvent.button === 2) {
                    return;
                }
            case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
            }
            var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
            {
                var accumulateTargetOnly = !inCapturePhase && domEventName === 'scroll';
                var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
                if (_listeners.length > 0) {
                    var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
                    dispatchQueue.push({
                        event: _event,
                        listeners: _listeners
                    });
                }
            }
        }
        registerSimpleEvents();
        registerEvents$2();
        registerEvents$1();
        registerEvents$3();
        registerEvents();
        function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
            extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0;
            if (shouldProcessPolyfillPlugins) {
                extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
                extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
                extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
                extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            }
        }
        var mediaEventTypes = [
            'abort',
            'canplay',
            'canplaythrough',
            'durationchange',
            'emptied',
            'encrypted',
            'ended',
            'error',
            'loadeddata',
            'loadedmetadata',
            'loadstart',
            'pause',
            'play',
            'playing',
            'progress',
            'ratechange',
            'seeked',
            'seeking',
            'stalled',
            'suspend',
            'timeupdate',
            'volumechange',
            'waiting'
        ];
        var nonDelegatedEvents = new Set([
            'cancel',
            'close',
            'invalid',
            'load',
            'scroll',
            'toggle'
        ].concat(mediaEventTypes));
        function executeDispatch(event, listener, currentTarget) {
            var type = event.type || 'unknown-event';
            event.currentTarget = currentTarget;
            invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
            event.currentTarget = null;
        }
        function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
            var previousInstance;
            if (inCapturePhase) {
                for (var i = dispatchListeners.length - 1; i >= 0; i--) {
                    var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) {
                        return;
                    }
                    executeDispatch(event, listener, currentTarget);
                    previousInstance = instance;
                }
            } else {
                for (var _i = 0; _i < dispatchListeners.length; _i++) {
                    var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
                    if (_instance !== previousInstance && event.isPropagationStopped()) {
                        return;
                    }
                    executeDispatch(event, _listener, _currentTarget);
                    previousInstance = _instance;
                }
            }
        }
        function processDispatchQueue(dispatchQueue, eventSystemFlags) {
            var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
            for (var i = 0; i < dispatchQueue.length; i++) {
                var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
                processDispatchQueueItemsInOrder(event, listeners, inCapturePhase);
            }
            rethrowCaughtError();
        }
        function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
            var nativeEventTarget = getEventTarget(nativeEvent);
            var dispatchQueue = [];
            extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            processDispatchQueue(dispatchQueue, eventSystemFlags);
        }
        function listenToNonDelegatedEvent(domEventName, targetElement) {
            var isCapturePhaseListener = false;
            var listenerSet = getEventListenerSet(targetElement);
            var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
            if (!listenerSet.has(listenerSetKey)) {
                addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
                listenerSet.add(listenerSetKey);
            }
        }
        var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
        function listenToAllSupportedEvents(rootContainerElement) {
            {
                if (rootContainerElement[listeningMarker]) {
                    return;
                }
                rootContainerElement[listeningMarker] = true;
                allNativeEvents.forEach(function (domEventName) {
                    if (!nonDelegatedEvents.has(domEventName)) {
                        listenToNativeEvent(domEventName, false, rootContainerElement, null);
                    }
                    listenToNativeEvent(domEventName, true, rootContainerElement, null);
                });
            }
        }
        function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
            var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
            var target = rootContainerElement;
            if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) {
                target = rootContainerElement.ownerDocument;
            }
            if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
                if (domEventName !== 'scroll') {
                    return;
                }
                eventSystemFlags |= IS_NON_DELEGATED;
                target = targetElement;
            }
            var listenerSet = getEventListenerSet(target);
            var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
            if (!listenerSet.has(listenerSetKey)) {
                if (isCapturePhaseListener) {
                    eventSystemFlags |= IS_CAPTURE_PHASE;
                }
                addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
                listenerSet.add(listenerSetKey);
            }
        }
        function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
            var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags);
            var isPassiveListener = undefined;
            if (passiveBrowserEventsSupported) {
                if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
                    isPassiveListener = true;
                }
            }
            targetContainer = targetContainer;
            var unsubscribeListener;
            if (isCapturePhaseListener) {
                if (isPassiveListener !== undefined) {
                    unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
                } else {
                    unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
                }
            } else {
                if (isPassiveListener !== undefined) {
                    unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
                } else {
                    unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
                }
            }
        }
        function isMatchingRootContainer(grandContainer, targetContainer) {
            return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
        }
        function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
            var ancestorInst = targetInst;
            if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
                var targetContainerNode = targetContainer;
                if (targetInst !== null) {
                    var node = targetInst;
                    mainLoop:
                        while (true) {
                            if (node === null) {
                                return;
                            }
                            var nodeTag = node.tag;
                            if (nodeTag === HostRoot || nodeTag === HostPortal) {
                                var container = node.stateNode.containerInfo;
                                if (isMatchingRootContainer(container, targetContainerNode)) {
                                    break;
                                }
                                if (nodeTag === HostPortal) {
                                    var grandNode = node.return;
                                    while (grandNode !== null) {
                                        var grandTag = grandNode.tag;
                                        if (grandTag === HostRoot || grandTag === HostPortal) {
                                            var grandContainer = grandNode.stateNode.containerInfo;
                                            if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                                                return;
                                            }
                                        }
                                        grandNode = grandNode.return;
                                    }
                                }
                                while (container !== null) {
                                    var parentNode = getClosestInstanceFromNode(container);
                                    if (parentNode === null) {
                                        return;
                                    }
                                    var parentTag = parentNode.tag;
                                    if (parentTag === HostComponent || parentTag === HostText) {
                                        node = ancestorInst = parentNode;
                                        continue mainLoop;
                                    }
                                    container = container.parentNode;
                                }
                            }
                            node = node.return;
                        }
                }
            }
            batchedEventUpdates(function () {
                return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
            });
        }
        function createDispatchListener(instance, listener, currentTarget) {
            return {
                instance: instance,
                listener: listener,
                currentTarget: currentTarget
            };
        }
        function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
            var captureName = reactName !== null ? reactName + 'Capture' : null;
            var reactEventName = inCapturePhase ? captureName : reactName;
            var listeners = [];
            var instance = targetFiber;
            var lastHostComponent = null;
            while (instance !== null) {
                var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag;
                if (tag === HostComponent && stateNode !== null) {
                    lastHostComponent = stateNode;
                    if (reactEventName !== null) {
                        var listener = getListener(instance, reactEventName);
                        if (listener != null) {
                            listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                        }
                    }
                }
                if (accumulateTargetOnly) {
                    break;
                }
                instance = instance.return;
            }
            return listeners;
        }
        function accumulateTwoPhaseListeners(targetFiber, reactName) {
            var captureName = reactName + 'Capture';
            var listeners = [];
            var instance = targetFiber;
            while (instance !== null) {
                var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag;
                if (tag === HostComponent && stateNode !== null) {
                    var currentTarget = stateNode;
                    var captureListener = getListener(instance, captureName);
                    if (captureListener != null) {
                        listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                    }
                    var bubbleListener = getListener(instance, reactName);
                    if (bubbleListener != null) {
                        listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                    }
                }
                instance = instance.return;
            }
            return listeners;
        }
        function getParent(inst) {
            if (inst === null) {
                return null;
            }
            do {
                inst = inst.return;
            } while (inst && inst.tag !== HostComponent);
            if (inst) {
                return inst;
            }
            return null;
        }
        function getLowestCommonAncestor(instA, instB) {
            var nodeA = instA;
            var nodeB = instB;
            var depthA = 0;
            for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
                depthA++;
            }
            var depthB = 0;
            for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
                depthB++;
            }
            while (depthA - depthB > 0) {
                nodeA = getParent(nodeA);
                depthA--;
            }
            while (depthB - depthA > 0) {
                nodeB = getParent(nodeB);
                depthB--;
            }
            var depth = depthA;
            while (depth--) {
                if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
                    return nodeA;
                }
                nodeA = getParent(nodeA);
                nodeB = getParent(nodeB);
            }
            return null;
        }
        function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
            var registrationName = event._reactName;
            var listeners = [];
            var instance = target;
            while (instance !== null) {
                if (instance === common) {
                    break;
                }
                var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
                if (alternate !== null && alternate === common) {
                    break;
                }
                if (tag === HostComponent && stateNode !== null) {
                    var currentTarget = stateNode;
                    if (inCapturePhase) {
                        var captureListener = getListener(instance, registrationName);
                        if (captureListener != null) {
                            listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                        }
                    } else if (!inCapturePhase) {
                        var bubbleListener = getListener(instance, registrationName);
                        if (bubbleListener != null) {
                            listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                        }
                    }
                }
                instance = instance.return;
            }
            if (listeners.length !== 0) {
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
            }
        }
        function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
            var common = from && to ? getLowestCommonAncestor(from, to) : null;
            if (from !== null) {
                accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
            }
            if (to !== null && enterEvent !== null) {
                accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
            }
        }
        function getListenerSetKey(domEventName, capture) {
            return domEventName + '__' + (capture ? 'capture' : 'bubble');
        }
        var didWarnInvalidHydration = false;
        var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
        var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
        var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
        var AUTOFOCUS = 'autoFocus';
        var CHILDREN = 'children';
        var STYLE = 'style';
        var HTML$1 = '__html';
        var HTML_NAMESPACE$1 = Namespaces.html;
        var warnedUnknownTags;
        var suppressHydrationWarning;
        var validatePropertiesInDevelopment;
        var warnForTextDifference;
        var warnForPropDifference;
        var warnForExtraAttributes;
        var warnForInvalidEventListener;
        var canDiffStyleForHydrationWarning;
        var normalizeMarkupForTextOrAttribute;
        var normalizeHTML;
        {
            warnedUnknownTags = {
                dialog: true,
                webview: true
            };
            validatePropertiesInDevelopment = function (type, props) {
                validateProperties(type, props);
                validateProperties$1(type, props);
                validateProperties$2(type, props, {
                    registrationNameDependencies: registrationNameDependencies,
                    possibleRegistrationNames: possibleRegistrationNames
                });
            };
            canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
            var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
            var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
            normalizeMarkupForTextOrAttribute = function (markup) {
                var markupString = typeof markup === 'string' ? markup : '' + markup;
                return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
            };
            warnForTextDifference = function (serverText, clientText) {
                if (didWarnInvalidHydration) {
                    return;
                }
                var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
                var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
                if (normalizedServerText === normalizedClientText) {
                    return;
                }
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            };
            warnForPropDifference = function (propName, serverValue, clientValue) {
                if (didWarnInvalidHydration) {
                    return;
                }
                var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
                var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
                if (normalizedServerValue === normalizedClientValue) {
                    return;
                }
                didWarnInvalidHydration = true;
                error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
            };
            warnForExtraAttributes = function (attributeNames) {
                if (didWarnInvalidHydration) {
                    return;
                }
                didWarnInvalidHydration = true;
                var names = [];
                attributeNames.forEach(function (name) {
                    names.push(name);
                });
                error('Extra attributes from the server: %s', names);
            };
            warnForInvalidEventListener = function (registrationName, listener) {
                if (listener === false) {
                    error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
                } else {
                    error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
                }
            };
            normalizeHTML = function (parent, html) {
                var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
                testElement.innerHTML = html;
                return testElement.innerHTML;
            };
        }
        function getOwnerDocumentFromRootContainer(rootContainerElement) {
            return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
        }
        function noop() {
        }
        function trapClickOnNonInteractiveElement(node) {
            node.onclick = noop;
        }
        function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
            for (var propKey in nextProps) {
                if (!nextProps.hasOwnProperty(propKey)) {
                    continue;
                }
                var nextProp = nextProps[propKey];
                if (propKey === STYLE) {
                    {
                        if (nextProp) {
                            Object.freeze(nextProp);
                        }
                    }
                    setValueForStyles(domElement, nextProp);
                } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        setInnerHTML(domElement, nextHtml);
                    }
                } else if (propKey === CHILDREN) {
                    if (typeof nextProp === 'string') {
                        var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                        if (canSetTextContent) {
                            setTextContent(domElement, nextProp);
                        }
                    } else if (typeof nextProp === 'number') {
                        setTextContent(domElement, '' + nextProp);
                    }
                } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING);
                else if (propKey === AUTOFOCUS);
                else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                    if (nextProp != null) {
                        if (typeof nextProp !== 'function') {
                            warnForInvalidEventListener(propKey, nextProp);
                        }
                        if (propKey === 'onScroll') {
                            listenToNonDelegatedEvent('scroll', domElement);
                        }
                    }
                } else if (nextProp != null) {
                    setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
                }
            }
        }
        function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
            for (var i = 0; i < updatePayload.length; i += 2) {
                var propKey = updatePayload[i];
                var propValue = updatePayload[i + 1];
                if (propKey === STYLE) {
                    setValueForStyles(domElement, propValue);
                } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    setInnerHTML(domElement, propValue);
                } else if (propKey === CHILDREN) {
                    setTextContent(domElement, propValue);
                } else {
                    setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
                }
            }
        }
        function createElement(type, props, rootContainerElement, parentNamespace) {
            var isCustomComponentTag;
            var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
            var domElement;
            var namespaceURI = parentNamespace;
            if (namespaceURI === HTML_NAMESPACE$1) {
                namespaceURI = getIntrinsicNamespace(type);
            }
            if (namespaceURI === HTML_NAMESPACE$1) {
                {
                    isCustomComponentTag = isCustomComponent(type, props);
                    if (!isCustomComponentTag && type !== type.toLowerCase()) {
                        error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
                    }
                }
                if (type === 'script') {
                    var div = ownerDocument.createElement('div');
                    div.innerHTML = '<script><' + '/script>';
                    var firstChild = div.firstChild;
                    domElement = div.removeChild(firstChild);
                } else if (typeof props.is === 'string') {
                    domElement = ownerDocument.createElement(type, { is: props.is });
                } else {
                    domElement = ownerDocument.createElement(type);
                    if (type === 'select') {
                        var node = domElement;
                        if (props.multiple) {
                            node.multiple = true;
                        } else if (props.size) {
                            node.size = props.size;
                        }
                    }
                }
            } else {
                domElement = ownerDocument.createElementNS(namespaceURI, type);
            }
            {
                if (namespaceURI === HTML_NAMESPACE$1) {
                    if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                        warnedUnknownTags[type] = true;
                        error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
                    }
                }
            }
            return domElement;
        }
        function createTextNode(text, rootContainerElement) {
            return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
        }
        function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
            var isCustomComponentTag = isCustomComponent(tag, rawProps);
            {
                validatePropertiesInDevelopment(tag, rawProps);
            }
            var props;
            switch (tag) {
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                for (var i = 0; i < mediaEventTypes.length; i++) {
                    listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                }
                props = rawProps;
                break;
            case 'source':
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps);
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps);
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps);
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
            }
            assertValidProps(tag, props);
            setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
            switch (tag) {
            case 'input':
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') {
                    trapClickOnNonInteractiveElement(domElement);
                }
                break;
            }
        }
        function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
            {
                validatePropertiesInDevelopment(tag, nextRawProps);
            }
            var updatePayload = null;
            var lastProps;
            var nextProps;
            switch (tag) {
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'option':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
                    trapClickOnNonInteractiveElement(domElement);
                }
                break;
            }
            assertValidProps(tag, nextProps);
            var propKey;
            var styleName;
            var styleUpdates = null;
            for (propKey in lastProps) {
                if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
                    continue;
                }
                if (propKey === STYLE) {
                    var lastStyle = lastProps[propKey];
                    for (styleName in lastStyle) {
                        if (lastStyle.hasOwnProperty(styleName)) {
                            if (!styleUpdates) {
                                styleUpdates = {};
                            }
                            styleUpdates[styleName] = '';
                        }
                    }
                } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN);
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING);
                else if (propKey === AUTOFOCUS);
                else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                    if (!updatePayload) {
                        updatePayload = [];
                    }
                } else {
                    (updatePayload = updatePayload || []).push(propKey, null);
                }
            }
            for (propKey in nextProps) {
                var nextProp = nextProps[propKey];
                var lastProp = lastProps != null ? lastProps[propKey] : undefined;
                if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
                    continue;
                }
                if (propKey === STYLE) {
                    {
                        if (nextProp) {
                            Object.freeze(nextProp);
                        }
                    }
                    if (lastProp) {
                        for (styleName in lastProp) {
                            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                                if (!styleUpdates) {
                                    styleUpdates = {};
                                }
                                styleUpdates[styleName] = '';
                            }
                        }
                        for (styleName in nextProp) {
                            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                                if (!styleUpdates) {
                                    styleUpdates = {};
                                }
                                styleUpdates[styleName] = nextProp[styleName];
                            }
                        }
                    } else {
                        if (!styleUpdates) {
                            if (!updatePayload) {
                                updatePayload = [];
                            }
                            updatePayload.push(propKey, styleUpdates);
                        }
                        styleUpdates = nextProp;
                    }
                } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        if (lastHtml !== nextHtml) {
                            (updatePayload = updatePayload || []).push(propKey, nextHtml);
                        }
                    }
                } else if (propKey === CHILDREN) {
                    if (typeof nextProp === 'string' || typeof nextProp === 'number') {
                        (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
                    }
                } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING);
                else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                    if (nextProp != null) {
                        if (typeof nextProp !== 'function') {
                            warnForInvalidEventListener(propKey, nextProp);
                        }
                        if (propKey === 'onScroll') {
                            listenToNonDelegatedEvent('scroll', domElement);
                        }
                    }
                    if (!updatePayload && lastProp !== nextProp) {
                        updatePayload = [];
                    }
                } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) {
                    nextProp.toString();
                } else {
                    (updatePayload = updatePayload || []).push(propKey, nextProp);
                }
            }
            if (styleUpdates) {
                {
                    validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
                }
                (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
            }
            return updatePayload;
        }
        function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
            if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
                updateChecked(domElement, nextRawProps);
            }
            var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
            var isCustomComponentTag = isCustomComponent(tag, nextRawProps);
            updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag);
            switch (tag) {
            case 'input':
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                postUpdateWrapper(domElement, nextRawProps);
                break;
            }
        }
        function getPossibleStandardName(propName) {
            {
                var lowerCasedName = propName.toLowerCase();
                if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
                    return null;
                }
                return possibleStandardNames[lowerCasedName] || null;
            }
        }
        function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
            var isCustomComponentTag;
            var extraAttributeNames;
            {
                suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
                isCustomComponentTag = isCustomComponent(tag, rawProps);
                validatePropertiesInDevelopment(tag, rawProps);
            }
            switch (tag) {
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                for (var i = 0; i < mediaEventTypes.length; i++) {
                    listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                }
                break;
            case 'source':
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            }
            assertValidProps(tag, rawProps);
            {
                extraAttributeNames = new Set();
                var attributes = domElement.attributes;
                for (var _i = 0; _i < attributes.length; _i++) {
                    var name = attributes[_i].name.toLowerCase();
                    switch (name) {
                    case 'data-reactroot':
                        break;
                    case 'value':
                        break;
                    case 'checked':
                        break;
                    case 'selected':
                        break;
                    default:
                        extraAttributeNames.add(attributes[_i].name);
                    }
                }
            }
            var updatePayload = null;
            for (var propKey in rawProps) {
                if (!rawProps.hasOwnProperty(propKey)) {
                    continue;
                }
                var nextProp = rawProps[propKey];
                if (propKey === CHILDREN) {
                    if (typeof nextProp === 'string') {
                        if (domElement.textContent !== nextProp) {
                            if (!suppressHydrationWarning) {
                                warnForTextDifference(domElement.textContent, nextProp);
                            }
                            updatePayload = [
                                CHILDREN,
                                nextProp
                            ];
                        }
                    } else if (typeof nextProp === 'number') {
                        if (domElement.textContent !== '' + nextProp) {
                            if (!suppressHydrationWarning) {
                                warnForTextDifference(domElement.textContent, nextProp);
                            }
                            updatePayload = [
                                CHILDREN,
                                '' + nextProp
                            ];
                        }
                    }
                } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                    if (nextProp != null) {
                        if (typeof nextProp !== 'function') {
                            warnForInvalidEventListener(propKey, nextProp);
                        }
                        if (propKey === 'onScroll') {
                            listenToNonDelegatedEvent('scroll', domElement);
                        }
                    }
                } else if (typeof isCustomComponentTag === 'boolean') {
                    var serverValue = void 0;
                    var propertyInfo = getPropertyInfo(propKey);
                    if (suppressHydrationWarning);
                    else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || propKey === 'value' || propKey === 'checked' || propKey === 'selected');
                    else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                        var serverHTML = domElement.innerHTML;
                        var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                        if (nextHtml != null) {
                            var expectedHTML = normalizeHTML(domElement, nextHtml);
                            if (expectedHTML !== serverHTML) {
                                warnForPropDifference(propKey, serverHTML, expectedHTML);
                            }
                        }
                    } else if (propKey === STYLE) {
                        extraAttributeNames.delete(propKey);
                        if (canDiffStyleForHydrationWarning) {
                            var expectedStyle = createDangerousStringForStyles(nextProp);
                            serverValue = domElement.getAttribute('style');
                            if (expectedStyle !== serverValue) {
                                warnForPropDifference(propKey, serverValue, expectedStyle);
                            }
                        }
                    } else if (isCustomComponentTag) {
                        extraAttributeNames.delete(propKey.toLowerCase());
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                        if (nextProp !== serverValue) {
                            warnForPropDifference(propKey, serverValue, nextProp);
                        }
                    } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                        var isMismatchDueToBadCasing = false;
                        if (propertyInfo !== null) {
                            extraAttributeNames.delete(propertyInfo.attributeName);
                            serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                        } else {
                            var ownNamespace = parentNamespace;
                            if (ownNamespace === HTML_NAMESPACE$1) {
                                ownNamespace = getIntrinsicNamespace(tag);
                            }
                            if (ownNamespace === HTML_NAMESPACE$1) {
                                extraAttributeNames.delete(propKey.toLowerCase());
                            } else {
                                var standardName = getPossibleStandardName(propKey);
                                if (standardName !== null && standardName !== propKey) {
                                    isMismatchDueToBadCasing = true;
                                    extraAttributeNames.delete(standardName);
                                }
                                extraAttributeNames.delete(propKey);
                            }
                            serverValue = getValueForAttribute(domElement, propKey, nextProp);
                        }
                        if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                            warnForPropDifference(propKey, serverValue, nextProp);
                        }
                    }
                }
            }
            {
                if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
                    warnForExtraAttributes(extraAttributeNames);
                }
            }
            switch (tag) {
            case 'input':
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') {
                    trapClickOnNonInteractiveElement(domElement);
                }
                break;
            }
            return updatePayload;
        }
        function diffHydratedText(textNode, text) {
            var isDifferent = textNode.nodeValue !== text;
            return isDifferent;
        }
        function warnForUnmatchedText(textNode, text) {
            {
                warnForTextDifference(textNode.nodeValue, text);
            }
        }
        function warnForDeletedHydratableElement(parentNode, child) {
            {
                if (didWarnInvalidHydration) {
                    return;
                }
                didWarnInvalidHydration = true;
                error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
            }
        }
        function warnForDeletedHydratableText(parentNode, child) {
            {
                if (didWarnInvalidHydration) {
                    return;
                }
                didWarnInvalidHydration = true;
                error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
            }
        }
        function warnForInsertedHydratedElement(parentNode, tag, props) {
            {
                if (didWarnInvalidHydration) {
                    return;
                }
                didWarnInvalidHydration = true;
                error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
            }
        }
        function warnForInsertedHydratedText(parentNode, text) {
            {
                if (text === '') {
                    return;
                }
                if (didWarnInvalidHydration) {
                    return;
                }
                didWarnInvalidHydration = true;
                error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
            }
        }
        function restoreControlledState$3(domElement, tag, props) {
            switch (tag) {
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
            }
        }
        var validateDOMNesting = function () {
        };
        var updatedAncestorInfo = function () {
        };
        {
            var specialTags = [
                'address',
                'applet',
                'area',
                'article',
                'aside',
                'base',
                'basefont',
                'bgsound',
                'blockquote',
                'body',
                'br',
                'button',
                'caption',
                'center',
                'col',
                'colgroup',
                'dd',
                'details',
                'dir',
                'div',
                'dl',
                'dt',
                'embed',
                'fieldset',
                'figcaption',
                'figure',
                'footer',
                'form',
                'frame',
                'frameset',
                'h1',
                'h2',
                'h3',
                'h4',
                'h5',
                'h6',
                'head',
                'header',
                'hgroup',
                'hr',
                'html',
                'iframe',
                'img',
                'input',
                'isindex',
                'li',
                'link',
                'listing',
                'main',
                'marquee',
                'menu',
                'menuitem',
                'meta',
                'nav',
                'noembed',
                'noframes',
                'noscript',
                'object',
                'ol',
                'p',
                'param',
                'plaintext',
                'pre',
                'script',
                'section',
                'select',
                'source',
                'style',
                'summary',
                'table',
                'tbody',
                'td',
                'template',
                'textarea',
                'tfoot',
                'th',
                'thead',
                'title',
                'tr',
                'track',
                'ul',
                'wbr',
                'xmp'
            ];
            var inScopeTags = [
                'applet',
                'caption',
                'html',
                'table',
                'td',
                'th',
                'marquee',
                'object',
                'template',
                'foreignObject',
                'desc',
                'title'
            ];
            var buttonScopeTags = inScopeTags.concat(['button']);
            var impliedEndTags = [
                'dd',
                'dt',
                'li',
                'option',
                'optgroup',
                'p',
                'rp',
                'rt'
            ];
            var emptyAncestorInfo = {
                current: null,
                formTag: null,
                aTagInScope: null,
                buttonTagInScope: null,
                nobrTagInScope: null,
                pTagInButtonScope: null,
                listItemTagAutoclosing: null,
                dlItemTagAutoclosing: null
            };
            updatedAncestorInfo = function (oldInfo, tag) {
                var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
                var info = { tag: tag };
                if (inScopeTags.indexOf(tag) !== -1) {
                    ancestorInfo.aTagInScope = null;
                    ancestorInfo.buttonTagInScope = null;
                    ancestorInfo.nobrTagInScope = null;
                }
                if (buttonScopeTags.indexOf(tag) !== -1) {
                    ancestorInfo.pTagInButtonScope = null;
                }
                if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
                    ancestorInfo.listItemTagAutoclosing = null;
                    ancestorInfo.dlItemTagAutoclosing = null;
                }
                ancestorInfo.current = info;
                if (tag === 'form') {
                    ancestorInfo.formTag = info;
                }
                if (tag === 'a') {
                    ancestorInfo.aTagInScope = info;
                }
                if (tag === 'button') {
                    ancestorInfo.buttonTagInScope = info;
                }
                if (tag === 'nobr') {
                    ancestorInfo.nobrTagInScope = info;
                }
                if (tag === 'p') {
                    ancestorInfo.pTagInButtonScope = info;
                }
                if (tag === 'li') {
                    ancestorInfo.listItemTagAutoclosing = info;
                }
                if (tag === 'dd' || tag === 'dt') {
                    ancestorInfo.dlItemTagAutoclosing = info;
                }
                return ancestorInfo;
            };
            var isTagValidWithParent = function (tag, parentTag) {
                switch (parentTag) {
                case 'select':
                    return tag === 'option' || tag === 'optgroup' || tag === '#text';
                case 'optgroup':
                    return tag === 'option' || tag === '#text';
                case 'option':
                    return tag === '#text';
                case 'tr':
                    return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
                case 'tbody':
                case 'thead':
                case 'tfoot':
                    return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
                case 'colgroup':
                    return tag === 'col' || tag === 'template';
                case 'table':
                    return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
                case 'head':
                    return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
                case 'html':
                    return tag === 'head' || tag === 'body' || tag === 'frameset';
                case 'frameset':
                    return tag === 'frame';
                case '#document':
                    return tag === 'html';
                }
                switch (tag) {
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                    return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
                case 'rp':
                case 'rt':
                    return impliedEndTags.indexOf(parentTag) === -1;
                case 'body':
                case 'caption':
                case 'col':
                case 'colgroup':
                case 'frameset':
                case 'frame':
                case 'head':
                case 'html':
                case 'tbody':
                case 'td':
                case 'tfoot':
                case 'th':
                case 'thead':
                case 'tr':
                    return parentTag == null;
                }
                return true;
            };
            var findInvalidAncestorForTag = function (tag, ancestorInfo) {
                switch (tag) {
                case 'address':
                case 'article':
                case 'aside':
                case 'blockquote':
                case 'center':
                case 'details':
                case 'dialog':
                case 'dir':
                case 'div':
                case 'dl':
                case 'fieldset':
                case 'figcaption':
                case 'figure':
                case 'footer':
                case 'header':
                case 'hgroup':
                case 'main':
                case 'menu':
                case 'nav':
                case 'ol':
                case 'p':
                case 'section':
                case 'summary':
                case 'ul':
                case 'pre':
                case 'listing':
                case 'table':
                case 'hr':
                case 'xmp':
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                    return ancestorInfo.pTagInButtonScope;
                case 'form':
                    return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
                case 'li':
                    return ancestorInfo.listItemTagAutoclosing;
                case 'dd':
                case 'dt':
                    return ancestorInfo.dlItemTagAutoclosing;
                case 'button':
                    return ancestorInfo.buttonTagInScope;
                case 'a':
                    return ancestorInfo.aTagInScope;
                case 'nobr':
                    return ancestorInfo.nobrTagInScope;
                }
                return null;
            };
            var didWarn$1 = {};
            validateDOMNesting = function (childTag, childText, ancestorInfo) {
                ancestorInfo = ancestorInfo || emptyAncestorInfo;
                var parentInfo = ancestorInfo.current;
                var parentTag = parentInfo && parentInfo.tag;
                if (childText != null) {
                    if (childTag != null) {
                        error('validateDOMNesting: when childText is passed, childTag should be null');
                    }
                    childTag = '#text';
                }
                var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
                var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
                var invalidParentOrAncestor = invalidParent || invalidAncestor;
                if (!invalidParentOrAncestor) {
                    return;
                }
                var ancestorTag = invalidParentOrAncestor.tag;
                var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
                if (didWarn$1[warnKey]) {
                    return;
                }
                didWarn$1[warnKey] = true;
                var tagDisplayName = childTag;
                var whitespaceInfo = '';
                if (childTag === '#text') {
                    if (/\S/.test(childText)) {
                        tagDisplayName = 'Text nodes';
                    } else {
                        tagDisplayName = 'Whitespace text nodes';
                        whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
                    }
                } else {
                    tagDisplayName = '<' + childTag + '>';
                }
                if (invalidParent) {
                    var info = '';
                    if (ancestorTag === 'table' && childTag === 'tr') {
                        info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
                    }
                    error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
                } else {
                    error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
                }
            };
        }
        var SUPPRESS_HYDRATION_WARNING$1;
        {
            SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
        }
        var SUSPENSE_START_DATA = '$';
        var SUSPENSE_END_DATA = '/$';
        var SUSPENSE_PENDING_START_DATA = '$?';
        var SUSPENSE_FALLBACK_START_DATA = '$!';
        var STYLE$1 = 'style';
        var eventsEnabled = null;
        var selectionInformation = null;
        function shouldAutoFocusHostComponent(type, props) {
            switch (type) {
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
            }
            return false;
        }
        function getRootHostContext(rootContainerInstance) {
            var type;
            var namespace;
            var nodeType = rootContainerInstance.nodeType;
            switch (nodeType) {
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE: {
                    type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                    var root = rootContainerInstance.documentElement;
                    namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                    break;
                }
            default: {
                    var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                    var ownNamespace = container.namespaceURI || null;
                    type = container.tagName;
                    namespace = getChildNamespace(ownNamespace, type);
                    break;
                }
            }
            {
                var validatedTag = type.toLowerCase();
                var ancestorInfo = updatedAncestorInfo(null, validatedTag);
                return {
                    namespace: namespace,
                    ancestorInfo: ancestorInfo
                };
            }
        }
        function getChildHostContext(parentHostContext, type, rootContainerInstance) {
            {
                var parentHostContextDev = parentHostContext;
                var namespace = getChildNamespace(parentHostContextDev.namespace, type);
                var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
                return {
                    namespace: namespace,
                    ancestorInfo: ancestorInfo
                };
            }
        }
        function getPublicInstance(instance) {
            return instance;
        }
        function prepareForCommit(containerInfo) {
            eventsEnabled = isEnabled();
            selectionInformation = getSelectionInformation();
            var activeInstance = null;
            setEnabled(false);
            return activeInstance;
        }
        function resetAfterCommit(containerInfo) {
            restoreSelection(selectionInformation);
            setEnabled(eventsEnabled);
            eventsEnabled = null;
            selectionInformation = null;
        }
        function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
            var parentNamespace;
            {
                var hostContextDev = hostContext;
                validateDOMNesting(type, null, hostContextDev.ancestorInfo);
                if (typeof props.children === 'string' || typeof props.children === 'number') {
                    var string = '' + props.children;
                    var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
                    validateDOMNesting(null, string, ownAncestorInfo);
                }
                parentNamespace = hostContextDev.namespace;
            }
            var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
            precacheFiberNode(internalInstanceHandle, domElement);
            updateFiberProps(domElement, props);
            return domElement;
        }
        function appendInitialChild(parentInstance, child) {
            parentInstance.appendChild(child);
        }
        function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
            setInitialProperties(domElement, type, props, rootContainerInstance);
            return shouldAutoFocusHostComponent(type, props);
        }
        function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
            {
                var hostContextDev = hostContext;
                if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
                    var string = '' + newProps.children;
                    var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
                    validateDOMNesting(null, string, ownAncestorInfo);
                }
            }
            return diffProperties(domElement, type, oldProps, newProps);
        }
        function shouldSetTextContent(type, props) {
            return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
        }
        function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
            {
                var hostContextDev = hostContext;
                validateDOMNesting(null, text, hostContextDev.ancestorInfo);
            }
            var textNode = createTextNode(text, rootContainerInstance);
            precacheFiberNode(internalInstanceHandle, textNode);
            return textNode;
        }
        var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
        var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
        var noTimeout = -1;
        function commitMount(domElement, type, newProps, internalInstanceHandle) {
            if (shouldAutoFocusHostComponent(type, newProps)) {
                domElement.focus();
            }
        }
        function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
            updateFiberProps(domElement, newProps);
            updateProperties(domElement, updatePayload, type, oldProps, newProps);
        }
        function resetTextContent(domElement) {
            setTextContent(domElement, '');
        }
        function commitTextUpdate(textInstance, oldText, newText) {
            textInstance.nodeValue = newText;
        }
        function appendChild(parentInstance, child) {
            parentInstance.appendChild(child);
        }
        function appendChildToContainer(container, child) {
            var parentNode;
            if (container.nodeType === COMMENT_NODE) {
                parentNode = container.parentNode;
                parentNode.insertBefore(child, container);
            } else {
                parentNode = container;
                parentNode.appendChild(child);
            }
            var reactRootContainer = container._reactRootContainer;
            if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
                trapClickOnNonInteractiveElement(parentNode);
            }
        }
        function insertBefore(parentInstance, child, beforeChild) {
            parentInstance.insertBefore(child, beforeChild);
        }
        function insertInContainerBefore(container, child, beforeChild) {
            if (container.nodeType === COMMENT_NODE) {
                container.parentNode.insertBefore(child, beforeChild);
            } else {
                container.insertBefore(child, beforeChild);
            }
        }
        function removeChild(parentInstance, child) {
            parentInstance.removeChild(child);
        }
        function removeChildFromContainer(container, child) {
            if (container.nodeType === COMMENT_NODE) {
                container.parentNode.removeChild(child);
            } else {
                container.removeChild(child);
            }
        }
        function hideInstance(instance) {
            instance = instance;
            var style = instance.style;
            if (typeof style.setProperty === 'function') {
                style.setProperty('display', 'none', 'important');
            } else {
                style.display = 'none';
            }
        }
        function hideTextInstance(textInstance) {
            textInstance.nodeValue = '';
        }
        function unhideInstance(instance, props) {
            instance = instance;
            var styleProp = props[STYLE$1];
            var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
            instance.style.display = dangerousStyleValue('display', display);
        }
        function unhideTextInstance(textInstance, text) {
            textInstance.nodeValue = text;
        }
        function clearContainer(container) {
            if (container.nodeType === ELEMENT_NODE) {
                container.textContent = '';
            } else if (container.nodeType === DOCUMENT_NODE) {
                var body = container.body;
                if (body != null) {
                    body.textContent = '';
                }
            }
        }
        function canHydrateInstance(instance, type, props) {
            if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
                return null;
            }
            return instance;
        }
        function canHydrateTextInstance(instance, text) {
            if (text === '' || instance.nodeType !== TEXT_NODE) {
                return null;
            }
            return instance;
        }
        function isSuspenseInstancePending(instance) {
            return instance.data === SUSPENSE_PENDING_START_DATA;
        }
        function isSuspenseInstanceFallback(instance) {
            return instance.data === SUSPENSE_FALLBACK_START_DATA;
        }
        function getNextHydratable(node) {
            for (; node != null; node = node.nextSibling) {
                var nodeType = node.nodeType;
                if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
                    break;
                }
            }
            return node;
        }
        function getNextHydratableSibling(instance) {
            return getNextHydratable(instance.nextSibling);
        }
        function getFirstHydratableChild(parentInstance) {
            return getNextHydratable(parentInstance.firstChild);
        }
        function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
            precacheFiberNode(internalInstanceHandle, instance);
            updateFiberProps(instance, props);
            var parentNamespace;
            {
                var hostContextDev = hostContext;
                parentNamespace = hostContextDev.namespace;
            }
            return diffHydratedProperties(instance, type, props, parentNamespace);
        }
        function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
            precacheFiberNode(internalInstanceHandle, textInstance);
            return diffHydratedText(textInstance, text);
        }
        function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
            var node = suspenseInstance.nextSibling;
            var depth = 0;
            while (node) {
                if (node.nodeType === COMMENT_NODE) {
                    var data = node.data;
                    if (data === SUSPENSE_END_DATA) {
                        if (depth === 0) {
                            return getNextHydratableSibling(node);
                        } else {
                            depth--;
                        }
                    } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                        depth++;
                    }
                }
                node = node.nextSibling;
            }
            return null;
        }
        function getParentSuspenseInstance(targetInstance) {
            var node = targetInstance.previousSibling;
            var depth = 0;
            while (node) {
                if (node.nodeType === COMMENT_NODE) {
                    var data = node.data;
                    if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                        if (depth === 0) {
                            return node;
                        } else {
                            depth--;
                        }
                    } else if (data === SUSPENSE_END_DATA) {
                        depth++;
                    }
                }
                node = node.previousSibling;
            }
            return null;
        }
        function commitHydratedContainer(container) {
            retryIfBlockedOn(container);
        }
        function commitHydratedSuspenseInstance(suspenseInstance) {
            retryIfBlockedOn(suspenseInstance);
        }
        function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
            {
                warnForUnmatchedText(textInstance, text);
            }
        }
        function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
            if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
                warnForUnmatchedText(textInstance, text);
            }
        }
        function didNotHydrateContainerInstance(parentContainer, instance) {
            {
                if (instance.nodeType === ELEMENT_NODE) {
                    warnForDeletedHydratableElement(parentContainer, instance);
                } else if (instance.nodeType === COMMENT_NODE);
                else {
                    warnForDeletedHydratableText(parentContainer, instance);
                }
            }
        }
        function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
            if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
                if (instance.nodeType === ELEMENT_NODE) {
                    warnForDeletedHydratableElement(parentInstance, instance);
                } else if (instance.nodeType === COMMENT_NODE);
                else {
                    warnForDeletedHydratableText(parentInstance, instance);
                }
            }
        }
        function didNotFindHydratableContainerInstance(parentContainer, type, props) {
            {
                warnForInsertedHydratedElement(parentContainer, type);
            }
        }
        function didNotFindHydratableContainerTextInstance(parentContainer, text) {
            {
                warnForInsertedHydratedText(parentContainer, text);
            }
        }
        function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
            if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
                warnForInsertedHydratedElement(parentInstance, type);
            }
        }
        function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
            if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
                warnForInsertedHydratedText(parentInstance, text);
            }
        }
        function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
            if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true);
        }
        var clientId = 0;
        function makeClientIdInDEV(warnOnAccessInDEV) {
            var id = 'r:' + (clientId++).toString(36);
            return {
                toString: function () {
                    warnOnAccessInDEV();
                    return id;
                },
                valueOf: function () {
                    warnOnAccessInDEV();
                    return id;
                }
            };
        }
        function isOpaqueHydratingObject(value) {
            return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
        }
        function makeOpaqueHydratingObject(attemptToReadValue) {
            return {
                $$typeof: REACT_OPAQUE_ID_TYPE,
                toString: attemptToReadValue,
                valueOf: attemptToReadValue
            };
        }
        function preparePortalMount(portalInstance) {
            {
                listenToAllSupportedEvents(portalInstance);
            }
        }
        var randomKey = Math.random().toString(36).slice(2);
        var internalInstanceKey = '__reactFiber$' + randomKey;
        var internalPropsKey = '__reactProps$' + randomKey;
        var internalContainerInstanceKey = '__reactContainer$' + randomKey;
        var internalEventHandlersKey = '__reactEvents$' + randomKey;
        function precacheFiberNode(hostInst, node) {
            node[internalInstanceKey] = hostInst;
        }
        function markContainerAsRoot(hostRoot, node) {
            node[internalContainerInstanceKey] = hostRoot;
        }
        function unmarkContainerAsRoot(node) {
            node[internalContainerInstanceKey] = null;
        }
        function isContainerMarkedAsRoot(node) {
            return !!node[internalContainerInstanceKey];
        }
        function getClosestInstanceFromNode(targetNode) {
            var targetInst = targetNode[internalInstanceKey];
            if (targetInst) {
                return targetInst;
            }
            var parentNode = targetNode.parentNode;
            while (parentNode) {
                targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
                if (targetInst) {
                    var alternate = targetInst.alternate;
                    if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                        var suspenseInstance = getParentSuspenseInstance(targetNode);
                        while (suspenseInstance !== null) {
                            var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                            if (targetSuspenseInst) {
                                return targetSuspenseInst;
                            }
                            suspenseInstance = getParentSuspenseInstance(suspenseInstance);
                        }
                    }
                    return targetInst;
                }
                targetNode = parentNode;
                parentNode = targetNode.parentNode;
            }
            return null;
        }
        function getInstanceFromNode(node) {
            var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
            if (inst) {
                if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
                    return inst;
                } else {
                    return null;
                }
            }
            return null;
        }
        function getNodeFromInstance(inst) {
            if (inst.tag === HostComponent || inst.tag === HostText) {
                return inst.stateNode;
            }
            {
                {
                    throw Error('getNodeFromInstance: Invalid argument.');
                }
            }
        }
        function getFiberCurrentPropsFromNode(node) {
            return node[internalPropsKey] || null;
        }
        function updateFiberProps(node, props) {
            node[internalPropsKey] = props;
        }
        function getEventListenerSet(node) {
            var elementListenerSet = node[internalEventHandlersKey];
            if (elementListenerSet === undefined) {
                elementListenerSet = node[internalEventHandlersKey] = new Set();
            }
            return elementListenerSet;
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
            {
                if (element) {
                    var owner = element._owner;
                    var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
                    ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
                } else {
                    ReactDebugCurrentFrame$1.setExtraStackFrame(null);
                }
            }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
            {
                var has = Function.call.bind(Object.prototype.hasOwnProperty);
                for (var typeSpecName in typeSpecs) {
                    if (has(typeSpecs, typeSpecName)) {
                        var error$1 = void 0;
                        try {
                            if (typeof typeSpecs[typeSpecName] !== 'function') {
                                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                                err.name = 'Invariant Violation';
                                throw err;
                            }
                            error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
                        } catch (ex) {
                            error$1 = ex;
                        }
                        if (error$1 && !(error$1 instanceof Error)) {
                            setCurrentlyValidatingElement(element);
                            error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                            setCurrentlyValidatingElement(null);
                        }
                        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                            loggedTypeFailures[error$1.message] = true;
                            setCurrentlyValidatingElement(element);
                            error('Failed %s type: %s', location, error$1.message);
                            setCurrentlyValidatingElement(null);
                        }
                    }
                }
            }
        }
        var valueStack = [];
        var fiberStack;
        {
            fiberStack = [];
        }
        var index = -1;
        function createCursor(defaultValue) {
            return { current: defaultValue };
        }
        function pop(cursor, fiber) {
            if (index < 0) {
                {
                    error('Unexpected pop.');
                }
                return;
            }
            {
                if (fiber !== fiberStack[index]) {
                    error('Unexpected Fiber popped.');
                }
            }
            cursor.current = valueStack[index];
            valueStack[index] = null;
            {
                fiberStack[index] = null;
            }
            index--;
        }
        function push(cursor, value, fiber) {
            index++;
            valueStack[index] = cursor.current;
            {
                fiberStack[index] = fiber;
            }
            cursor.current = value;
        }
        var warnedAboutMissingGetChildContext;
        {
            warnedAboutMissingGetChildContext = {};
        }
        var emptyContextObject = {};
        {
            Object.freeze(emptyContextObject);
        }
        var contextStackCursor = createCursor(emptyContextObject);
        var didPerformWorkStackCursor = createCursor(false);
        var previousContext = emptyContextObject;
        function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
            {
                if (didPushOwnContextIfProvider && isContextProvider(Component)) {
                    return previousContext;
                }
                return contextStackCursor.current;
            }
        }
        function cacheContext(workInProgress, unmaskedContext, maskedContext) {
            {
                var instance = workInProgress.stateNode;
                instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
                instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
            }
        }
        function getMaskedContext(workInProgress, unmaskedContext) {
            {
                var type = workInProgress.type;
                var contextTypes = type.contextTypes;
                if (!contextTypes) {
                    return emptyContextObject;
                }
                var instance = workInProgress.stateNode;
                if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
                    return instance.__reactInternalMemoizedMaskedChildContext;
                }
                var context = {};
                for (var key in contextTypes) {
                    context[key] = unmaskedContext[key];
                }
                {
                    var name = getComponentName(type) || 'Unknown';
                    checkPropTypes(contextTypes, context, 'context', name);
                }
                if (instance) {
                    cacheContext(workInProgress, unmaskedContext, context);
                }
                return context;
            }
        }
        function hasContextChanged() {
            {
                return didPerformWorkStackCursor.current;
            }
        }
        function isContextProvider(type) {
            {
                var childContextTypes = type.childContextTypes;
                return childContextTypes !== null && childContextTypes !== undefined;
            }
        }
        function popContext(fiber) {
            {
                pop(didPerformWorkStackCursor, fiber);
                pop(contextStackCursor, fiber);
            }
        }
        function popTopLevelContextObject(fiber) {
            {
                pop(didPerformWorkStackCursor, fiber);
                pop(contextStackCursor, fiber);
            }
        }
        function pushTopLevelContextObject(fiber, context, didChange) {
            {
                if (!(contextStackCursor.current === emptyContextObject)) {
                    {
                        throw Error('Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
                push(contextStackCursor, context, fiber);
                push(didPerformWorkStackCursor, didChange, fiber);
            }
        }
        function processChildContext(fiber, type, parentContext) {
            {
                var instance = fiber.stateNode;
                var childContextTypes = type.childContextTypes;
                if (typeof instance.getChildContext !== 'function') {
                    {
                        var componentName = getComponentName(type) || 'Unknown';
                        if (!warnedAboutMissingGetChildContext[componentName]) {
                            warnedAboutMissingGetChildContext[componentName] = true;
                            error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
                        }
                    }
                    return parentContext;
                }
                var childContext = instance.getChildContext();
                for (var contextKey in childContext) {
                    if (!(contextKey in childContextTypes)) {
                        {
                            throw Error((getComponentName(type) || 'Unknown') + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
                        }
                    }
                }
                {
                    var name = getComponentName(type) || 'Unknown';
                    checkPropTypes(childContextTypes, childContext, 'child context', name);
                }
                return _assign({}, parentContext, childContext);
            }
        }
        function pushContextProvider(workInProgress) {
            {
                var instance = workInProgress.stateNode;
                var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject;
                previousContext = contextStackCursor.current;
                push(contextStackCursor, memoizedMergedChildContext, workInProgress);
                push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
                return true;
            }
        }
        function invalidateContextProvider(workInProgress, type, didChange) {
            {
                var instance = workInProgress.stateNode;
                if (!instance) {
                    {
                        throw Error('Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
                if (didChange) {
                    var mergedContext = processChildContext(workInProgress, type, previousContext);
                    instance.__reactInternalMemoizedMergedChildContext = mergedContext;
                    pop(didPerformWorkStackCursor, workInProgress);
                    pop(contextStackCursor, workInProgress);
                    push(contextStackCursor, mergedContext, workInProgress);
                    push(didPerformWorkStackCursor, didChange, workInProgress);
                } else {
                    pop(didPerformWorkStackCursor, workInProgress);
                    push(didPerformWorkStackCursor, didChange, workInProgress);
                }
            }
        }
        function findCurrentUnmaskedContext(fiber) {
            {
                if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
                    {
                        throw Error('Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
                var node = fiber;
                do {
                    switch (node.tag) {
                    case HostRoot:
                        return node.stateNode.context;
                    case ClassComponent: {
                            var Component = node.type;
                            if (isContextProvider(Component)) {
                                return node.stateNode.__reactInternalMemoizedMergedChildContext;
                            }
                            break;
                        }
                    }
                    node = node.return;
                } while (node !== null);
                {
                    {
                        throw Error('Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
            }
        }
        var LegacyRoot = 0;
        var BlockingRoot = 1;
        var ConcurrentRoot = 2;
        var rendererID = null;
        var injectedHook = null;
        var hasLoggedError = false;
        var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
        function injectInternals(internals) {
            if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                return false;
            }
            var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (hook.isDisabled) {
                return true;
            }
            if (!hook.supportsFiber) {
                {
                    error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
                }
                return true;
            }
            try {
                rendererID = hook.inject(internals);
                injectedHook = hook;
            } catch (err) {
                {
                    error('React instrumentation encountered an error: %s.', err);
                }
            }
            return true;
        }
        function onScheduleRoot(root, children) {
            {
                if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
                    try {
                        injectedHook.onScheduleFiberRoot(rendererID, root, children);
                    } catch (err) {
                        if (!hasLoggedError) {
                            hasLoggedError = true;
                            error('React instrumentation encountered an error: %s', err);
                        }
                    }
                }
            }
        }
        function onCommitRoot(root, priorityLevel) {
            if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
                try {
                    var didError = (root.current.flags & DidCapture) === DidCapture;
                    if (enableProfilerTimer) {
                        injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
                    } else {
                        injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
                    }
                } catch (err) {
                    {
                        if (!hasLoggedError) {
                            hasLoggedError = true;
                            error('React instrumentation encountered an error: %s', err);
                        }
                    }
                }
            }
        }
        function onCommitUnmount(fiber) {
            if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
                try {
                    injectedHook.onCommitFiberUnmount(rendererID, fiber);
                } catch (err) {
                    {
                        if (!hasLoggedError) {
                            hasLoggedError = true;
                            error('React instrumentation encountered an error: %s', err);
                        }
                    }
                }
            }
        }
        var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now$1 = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
        {
            if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
                {
                    throw Error('It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling');
                }
            }
        }
        var fakeCallbackNode = {};
        var ImmediatePriority$1 = 99;
        var UserBlockingPriority$2 = 98;
        var NormalPriority$1 = 97;
        var LowPriority$1 = 96;
        var IdlePriority$1 = 95;
        var NoPriority$1 = 90;
        var shouldYield = Scheduler_shouldYield;
        var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {
        };
        var syncQueue = null;
        var immediateQueueCallbackNode = null;
        var isFlushingSyncQueue = false;
        var initialTimeMs$1 = Scheduler_now$1();
        var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function () {
            return Scheduler_now$1() - initialTimeMs$1;
        };
        function getCurrentPriorityLevel() {
            switch (Scheduler_getCurrentPriorityLevel()) {
            case Scheduler_ImmediatePriority:
                return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$2;
            case Scheduler_NormalPriority:
                return NormalPriority$1;
            case Scheduler_LowPriority:
                return LowPriority$1;
            case Scheduler_IdlePriority:
                return IdlePriority$1;
            default: {
                    {
                        throw Error('Unknown priority level.');
                    }
                }
            }
        }
        function reactPriorityToSchedulerPriority(reactPriorityLevel) {
            switch (reactPriorityLevel) {
            case ImmediatePriority$1:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$2:
                return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
                return Scheduler_NormalPriority;
            case LowPriority$1:
                return Scheduler_LowPriority;
            case IdlePriority$1:
                return Scheduler_IdlePriority;
            default: {
                    {
                        throw Error('Unknown priority level.');
                    }
                }
            }
        }
        function runWithPriority$1(reactPriorityLevel, fn) {
            var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
            return Scheduler_runWithPriority(priorityLevel, fn);
        }
        function scheduleCallback(reactPriorityLevel, callback, options) {
            var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
            return Scheduler_scheduleCallback(priorityLevel, callback, options);
        }
        function scheduleSyncCallback(callback) {
            if (syncQueue === null) {
                syncQueue = [callback];
                immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
            } else {
                syncQueue.push(callback);
            }
            return fakeCallbackNode;
        }
        function cancelCallback(callbackNode) {
            if (callbackNode !== fakeCallbackNode) {
                Scheduler_cancelCallback(callbackNode);
            }
        }
        function flushSyncCallbackQueue() {
            if (immediateQueueCallbackNode !== null) {
                var node = immediateQueueCallbackNode;
                immediateQueueCallbackNode = null;
                Scheduler_cancelCallback(node);
            }
            flushSyncCallbackQueueImpl();
        }
        function flushSyncCallbackQueueImpl() {
            if (!isFlushingSyncQueue && syncQueue !== null) {
                isFlushingSyncQueue = true;
                var i = 0;
                {
                    try {
                        var _isSync2 = true;
                        var _queue = syncQueue;
                        runWithPriority$1(ImmediatePriority$1, function () {
                            for (; i < _queue.length; i++) {
                                var callback = _queue[i];
                                do {
                                    callback = callback(_isSync2);
                                } while (callback !== null);
                            }
                        });
                        syncQueue = null;
                    } catch (error) {
                        if (syncQueue !== null) {
                            syncQueue = syncQueue.slice(i + 1);
                        }
                        Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                        throw error;
                    } finally {
                        isFlushingSyncQueue = false;
                    }
                }
            }
        }
        var ReactVersion = '17.0.1';
        var NoMode = 0;
        var StrictMode = 1;
        var BlockingMode = 2;
        var ConcurrentMode = 4;
        var ProfileMode = 8;
        var DebugTracingMode = 16;
        var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
        var NoTransition = 0;
        function requestCurrentTransition() {
            return ReactCurrentBatchConfig.transition;
        }
        var ReactStrictModeWarnings = {
            recordUnsafeLifecycleWarnings: function (fiber, instance) {
            },
            flushPendingUnsafeLifecycleWarnings: function () {
            },
            recordLegacyContextWarning: function (fiber, instance) {
            },
            flushLegacyContextWarning: function () {
            },
            discardPendingWarnings: function () {
            }
        };
        {
            var findStrictRoot = function (fiber) {
                var maybeStrictRoot = null;
                var node = fiber;
                while (node !== null) {
                    if (node.mode & StrictMode) {
                        maybeStrictRoot = node;
                    }
                    node = node.return;
                }
                return maybeStrictRoot;
            };
            var setToSortedString = function (set) {
                var array = [];
                set.forEach(function (value) {
                    array.push(value);
                });
                return array.sort().join(', ');
            };
            var pendingComponentWillMountWarnings = [];
            var pendingUNSAFE_ComponentWillMountWarnings = [];
            var pendingComponentWillReceivePropsWarnings = [];
            var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            var pendingComponentWillUpdateWarnings = [];
            var pendingUNSAFE_ComponentWillUpdateWarnings = [];
            var didWarnAboutUnsafeLifecycles = new Set();
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
                if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
                    return;
                }
                if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                    pendingComponentWillMountWarnings.push(fiber);
                }
                if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
                    pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
                }
                if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                    pendingComponentWillReceivePropsWarnings.push(fiber);
                }
                if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
                    pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
                }
                if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                    pendingComponentWillUpdateWarnings.push(fiber);
                }
                if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
                    pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
                }
            };
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
                var componentWillMountUniqueNames = new Set();
                if (pendingComponentWillMountWarnings.length > 0) {
                    pendingComponentWillMountWarnings.forEach(function (fiber) {
                        componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutUnsafeLifecycles.add(fiber.type);
                    });
                    pendingComponentWillMountWarnings = [];
                }
                var UNSAFE_componentWillMountUniqueNames = new Set();
                if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
                    pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
                        UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutUnsafeLifecycles.add(fiber.type);
                    });
                    pendingUNSAFE_ComponentWillMountWarnings = [];
                }
                var componentWillReceivePropsUniqueNames = new Set();
                if (pendingComponentWillReceivePropsWarnings.length > 0) {
                    pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
                        componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutUnsafeLifecycles.add(fiber.type);
                    });
                    pendingComponentWillReceivePropsWarnings = [];
                }
                var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
                if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
                    pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
                        UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutUnsafeLifecycles.add(fiber.type);
                    });
                    pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
                }
                var componentWillUpdateUniqueNames = new Set();
                if (pendingComponentWillUpdateWarnings.length > 0) {
                    pendingComponentWillUpdateWarnings.forEach(function (fiber) {
                        componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutUnsafeLifecycles.add(fiber.type);
                    });
                    pendingComponentWillUpdateWarnings = [];
                }
                var UNSAFE_componentWillUpdateUniqueNames = new Set();
                if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
                    pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
                        UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutUnsafeLifecycles.add(fiber.type);
                    });
                    pendingUNSAFE_ComponentWillUpdateWarnings = [];
                }
                if (UNSAFE_componentWillMountUniqueNames.size > 0) {
                    var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
                    error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
                }
                if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
                    var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
                    error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* If you\'re updating state whenever props change, ' + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
                }
                if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
                    var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
                    error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
                }
                if (componentWillMountUniqueNames.size > 0) {
                    var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
                    warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
                }
                if (componentWillReceivePropsUniqueNames.size > 0) {
                    var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
                    warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* If you\'re updating state whenever props change, refactor your ' + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
                }
                if (componentWillUpdateUniqueNames.size > 0) {
                    var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
                    warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
                }
            };
            var pendingLegacyContextWarning = new Map();
            var didWarnAboutLegacyContext = new Set();
            ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
                var strictRoot = findStrictRoot(fiber);
                if (strictRoot === null) {
                    error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
                    return;
                }
                if (didWarnAboutLegacyContext.has(fiber.type)) {
                    return;
                }
                var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
                if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
                    if (warningsForRoot === undefined) {
                        warningsForRoot = [];
                        pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
                    }
                    warningsForRoot.push(fiber);
                }
            };
            ReactStrictModeWarnings.flushLegacyContextWarning = function () {
                pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
                    if (fiberArray.length === 0) {
                        return;
                    }
                    var firstFiber = fiberArray[0];
                    var uniqueNames = new Set();
                    fiberArray.forEach(function (fiber) {
                        uniqueNames.add(getComponentName(fiber.type) || 'Component');
                        didWarnAboutLegacyContext.add(fiber.type);
                    });
                    var sortedNames = setToSortedString(uniqueNames);
                    try {
                        setCurrentFiber(firstFiber);
                        error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
                    } finally {
                        resetCurrentFiber();
                    }
                });
            };
            ReactStrictModeWarnings.discardPendingWarnings = function () {
                pendingComponentWillMountWarnings = [];
                pendingUNSAFE_ComponentWillMountWarnings = [];
                pendingComponentWillReceivePropsWarnings = [];
                pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
                pendingComponentWillUpdateWarnings = [];
                pendingUNSAFE_ComponentWillUpdateWarnings = [];
                pendingLegacyContextWarning = new Map();
            };
        }
        function resolveDefaultProps(Component, baseProps) {
            if (Component && Component.defaultProps) {
                var props = _assign({}, baseProps);
                var defaultProps = Component.defaultProps;
                for (var propName in defaultProps) {
                    if (props[propName] === undefined) {
                        props[propName] = defaultProps[propName];
                    }
                }
                return props;
            }
            return baseProps;
        }
        var MAX_SIGNED_31_BIT_INT = 1073741823;
        var valueCursor = createCursor(null);
        var rendererSigil;
        {
            rendererSigil = {};
        }
        var currentlyRenderingFiber = null;
        var lastContextDependency = null;
        var lastContextWithAllBitsObserved = null;
        var isDisallowedContextReadInDEV = false;
        function resetContextDependencies() {
            currentlyRenderingFiber = null;
            lastContextDependency = null;
            lastContextWithAllBitsObserved = null;
            {
                isDisallowedContextReadInDEV = false;
            }
        }
        function enterDisallowedContextReadInDEV() {
            {
                isDisallowedContextReadInDEV = true;
            }
        }
        function exitDisallowedContextReadInDEV() {
            {
                isDisallowedContextReadInDEV = false;
            }
        }
        function pushProvider(providerFiber, nextValue) {
            var context = providerFiber.type._context;
            {
                push(valueCursor, context._currentValue, providerFiber);
                context._currentValue = nextValue;
                {
                    if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
                        error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
                    }
                    context._currentRenderer = rendererSigil;
                }
            }
        }
        function popProvider(providerFiber) {
            var currentValue = valueCursor.current;
            pop(valueCursor, providerFiber);
            var context = providerFiber.type._context;
            {
                context._currentValue = currentValue;
            }
        }
        function calculateChangedBits(context, newValue, oldValue) {
            if (objectIs(oldValue, newValue)) {
                return 0;
            } else {
                var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                {
                    if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
                        error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
                    }
                }
                return changedBits | 0;
            }
        }
        function scheduleWorkOnParentPath(parent, renderLanes) {
            var node = parent;
            while (node !== null) {
                var alternate = node.alternate;
                if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                    node.childLanes = mergeLanes(node.childLanes, renderLanes);
                    if (alternate !== null) {
                        alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
                    }
                } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
                    alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
                } else {
                    break;
                }
                node = node.return;
            }
        }
        function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
            var fiber = workInProgress.child;
            if (fiber !== null) {
                fiber.return = workInProgress;
            }
            while (fiber !== null) {
                var nextFiber = void 0;
                var list = fiber.dependencies;
                if (list !== null) {
                    nextFiber = fiber.child;
                    var dependency = list.firstContext;
                    while (dependency !== null) {
                        if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                            if (fiber.tag === ClassComponent) {
                                var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
                                update.tag = ForceUpdate;
                                enqueueUpdate(fiber, update);
                            }
                            fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                            var alternate = fiber.alternate;
                            if (alternate !== null) {
                                alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                            }
                            scheduleWorkOnParentPath(fiber.return, renderLanes);
                            list.lanes = mergeLanes(list.lanes, renderLanes);
                            break;
                        }
                        dependency = dependency.next;
                    }
                } else if (fiber.tag === ContextProvider) {
                    nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
                } else {
                    nextFiber = fiber.child;
                }
                if (nextFiber !== null) {
                    nextFiber.return = fiber;
                } else {
                    nextFiber = fiber;
                    while (nextFiber !== null) {
                        if (nextFiber === workInProgress) {
                            nextFiber = null;
                            break;
                        }
                        var sibling = nextFiber.sibling;
                        if (sibling !== null) {
                            sibling.return = nextFiber.return;
                            nextFiber = sibling;
                            break;
                        }
                        nextFiber = nextFiber.return;
                    }
                }
                fiber = nextFiber;
            }
        }
        function prepareToReadContext(workInProgress, renderLanes) {
            currentlyRenderingFiber = workInProgress;
            lastContextDependency = null;
            lastContextWithAllBitsObserved = null;
            var dependencies = workInProgress.dependencies;
            if (dependencies !== null) {
                var firstContext = dependencies.firstContext;
                if (firstContext !== null) {
                    if (includesSomeLane(dependencies.lanes, renderLanes)) {
                        markWorkInProgressReceivedUpdate();
                    }
                    dependencies.firstContext = null;
                }
            }
        }
        function readContext(context, observedBits) {
            {
                if (isDisallowedContextReadInDEV) {
                    error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
                }
            }
            if (lastContextWithAllBitsObserved === context);
            else if (observedBits === false || observedBits === 0);
            else {
                var resolvedObservedBits;
                if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
                    lastContextWithAllBitsObserved = context;
                    resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
                } else {
                    resolvedObservedBits = observedBits;
                }
                var contextItem = {
                    context: context,
                    observedBits: resolvedObservedBits,
                    next: null
                };
                if (lastContextDependency === null) {
                    if (!(currentlyRenderingFiber !== null)) {
                        {
                            throw Error('Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().');
                        }
                    }
                    lastContextDependency = contextItem;
                    currentlyRenderingFiber.dependencies = {
                        lanes: NoLanes,
                        firstContext: contextItem,
                        responders: null
                    };
                } else {
                    lastContextDependency = lastContextDependency.next = contextItem;
                }
            }
            return context._currentValue;
        }
        var UpdateState = 0;
        var ReplaceState = 1;
        var ForceUpdate = 2;
        var CaptureUpdate = 3;
        var hasForceUpdate = false;
        var didWarnUpdateInsideUpdate;
        var currentlyProcessingQueue;
        {
            didWarnUpdateInsideUpdate = false;
            currentlyProcessingQueue = null;
        }
        function initializeUpdateQueue(fiber) {
            var queue = {
                baseState: fiber.memoizedState,
                firstBaseUpdate: null,
                lastBaseUpdate: null,
                shared: { pending: null },
                effects: null
            };
            fiber.updateQueue = queue;
        }
        function cloneUpdateQueue(current, workInProgress) {
            var queue = workInProgress.updateQueue;
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                var clone = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: currentQueue.firstBaseUpdate,
                    lastBaseUpdate: currentQueue.lastBaseUpdate,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = clone;
            }
        }
        function createUpdate(eventTime, lane) {
            var update = {
                eventTime: eventTime,
                lane: lane,
                tag: UpdateState,
                payload: null,
                callback: null,
                next: null
            };
            return update;
        }
        function enqueueUpdate(fiber, update) {
            var updateQueue = fiber.updateQueue;
            if (updateQueue === null) {
                return;
            }
            var sharedQueue = updateQueue.shared;
            var pending = sharedQueue.pending;
            if (pending === null) {
                update.next = update;
            } else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update;
            {
                if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
                    error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
                    didWarnUpdateInsideUpdate = true;
                }
            }
        }
        function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
            var queue = workInProgress.updateQueue;
            var current = workInProgress.alternate;
            if (current !== null) {
                var currentQueue = current.updateQueue;
                if (queue === currentQueue) {
                    var newFirst = null;
                    var newLast = null;
                    var firstBaseUpdate = queue.firstBaseUpdate;
                    if (firstBaseUpdate !== null) {
                        var update = firstBaseUpdate;
                        do {
                            var clone = {
                                eventTime: update.eventTime,
                                lane: update.lane,
                                tag: update.tag,
                                payload: update.payload,
                                callback: update.callback,
                                next: null
                            };
                            if (newLast === null) {
                                newFirst = newLast = clone;
                            } else {
                                newLast.next = clone;
                                newLast = clone;
                            }
                            update = update.next;
                        } while (update !== null);
                        if (newLast === null) {
                            newFirst = newLast = capturedUpdate;
                        } else {
                            newLast.next = capturedUpdate;
                            newLast = capturedUpdate;
                        }
                    } else {
                        newFirst = newLast = capturedUpdate;
                    }
                    queue = {
                        baseState: currentQueue.baseState,
                        firstBaseUpdate: newFirst,
                        lastBaseUpdate: newLast,
                        shared: currentQueue.shared,
                        effects: currentQueue.effects
                    };
                    workInProgress.updateQueue = queue;
                    return;
                }
            }
            var lastBaseUpdate = queue.lastBaseUpdate;
            if (lastBaseUpdate === null) {
                queue.firstBaseUpdate = capturedUpdate;
            } else {
                lastBaseUpdate.next = capturedUpdate;
            }
            queue.lastBaseUpdate = capturedUpdate;
        }
        function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
            switch (update.tag) {
            case ReplaceState: {
                    var payload = update.payload;
                    if (typeof payload === 'function') {
                        {
                            enterDisallowedContextReadInDEV();
                        }
                        var nextState = payload.call(instance, prevState, nextProps);
                        {
                            if (workInProgress.mode & StrictMode) {
                                disableLogs();
                                try {
                                    payload.call(instance, prevState, nextProps);
                                } finally {
                                    reenableLogs();
                                }
                            }
                            exitDisallowedContextReadInDEV();
                        }
                        return nextState;
                    }
                    return payload;
                }
            case CaptureUpdate: {
                    workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
                }
            case UpdateState: {
                    var _payload = update.payload;
                    var partialState;
                    if (typeof _payload === 'function') {
                        {
                            enterDisallowedContextReadInDEV();
                        }
                        partialState = _payload.call(instance, prevState, nextProps);
                        {
                            if (workInProgress.mode & StrictMode) {
                                disableLogs();
                                try {
                                    _payload.call(instance, prevState, nextProps);
                                } finally {
                                    reenableLogs();
                                }
                            }
                            exitDisallowedContextReadInDEV();
                        }
                    } else {
                        partialState = _payload;
                    }
                    if (partialState === null || partialState === undefined) {
                        return prevState;
                    }
                    return _assign({}, prevState, partialState);
                }
            case ForceUpdate: {
                    hasForceUpdate = true;
                    return prevState;
                }
            }
            return prevState;
        }
        function processUpdateQueue(workInProgress, props, instance, renderLanes) {
            var queue = workInProgress.updateQueue;
            hasForceUpdate = false;
            {
                currentlyProcessingQueue = queue.shared;
            }
            var firstBaseUpdate = queue.firstBaseUpdate;
            var lastBaseUpdate = queue.lastBaseUpdate;
            var pendingQueue = queue.shared.pending;
            if (pendingQueue !== null) {
                queue.shared.pending = null;
                var lastPendingUpdate = pendingQueue;
                var firstPendingUpdate = lastPendingUpdate.next;
                lastPendingUpdate.next = null;
                if (lastBaseUpdate === null) {
                    firstBaseUpdate = firstPendingUpdate;
                } else {
                    lastBaseUpdate.next = firstPendingUpdate;
                }
                lastBaseUpdate = lastPendingUpdate;
                var current = workInProgress.alternate;
                if (current !== null) {
                    var currentQueue = current.updateQueue;
                    var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                    if (currentLastBaseUpdate !== lastBaseUpdate) {
                        if (currentLastBaseUpdate === null) {
                            currentQueue.firstBaseUpdate = firstPendingUpdate;
                        } else {
                            currentLastBaseUpdate.next = firstPendingUpdate;
                        }
                        currentQueue.lastBaseUpdate = lastPendingUpdate;
                    }
                }
            }
            if (firstBaseUpdate !== null) {
                var newState = queue.baseState;
                var newLanes = NoLanes;
                var newBaseState = null;
                var newFirstBaseUpdate = null;
                var newLastBaseUpdate = null;
                var update = firstBaseUpdate;
                do {
                    var updateLane = update.lane;
                    var updateEventTime = update.eventTime;
                    if (!isSubsetOfLanes(renderLanes, updateLane)) {
                        var clone = {
                            eventTime: updateEventTime,
                            lane: updateLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLastBaseUpdate === null) {
                            newFirstBaseUpdate = newLastBaseUpdate = clone;
                            newBaseState = newState;
                        } else {
                            newLastBaseUpdate = newLastBaseUpdate.next = clone;
                        }
                        newLanes = mergeLanes(newLanes, updateLane);
                    } else {
                        if (newLastBaseUpdate !== null) {
                            var _clone = {
                                eventTime: updateEventTime,
                                lane: NoLane,
                                tag: update.tag,
                                payload: update.payload,
                                callback: update.callback,
                                next: null
                            };
                            newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                        }
                        newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                        var callback = update.callback;
                        if (callback !== null) {
                            workInProgress.flags |= Callback;
                            var effects = queue.effects;
                            if (effects === null) {
                                queue.effects = [update];
                            } else {
                                effects.push(update);
                            }
                        }
                    }
                    update = update.next;
                    if (update === null) {
                        pendingQueue = queue.shared.pending;
                        if (pendingQueue === null) {
                            break;
                        } else {
                            var _lastPendingUpdate = pendingQueue;
                            var _firstPendingUpdate = _lastPendingUpdate.next;
                            _lastPendingUpdate.next = null;
                            update = _firstPendingUpdate;
                            queue.lastBaseUpdate = _lastPendingUpdate;
                            queue.shared.pending = null;
                        }
                    }
                } while (true);
                if (newLastBaseUpdate === null) {
                    newBaseState = newState;
                }
                queue.baseState = newBaseState;
                queue.firstBaseUpdate = newFirstBaseUpdate;
                queue.lastBaseUpdate = newLastBaseUpdate;
                markSkippedUpdateLanes(newLanes);
                workInProgress.lanes = newLanes;
                workInProgress.memoizedState = newState;
            }
            {
                currentlyProcessingQueue = null;
            }
        }
        function callCallback(callback, context) {
            if (!(typeof callback === 'function')) {
                {
                    throw Error('Invalid argument passed as callback. Expected a function. Instead received: ' + callback);
                }
            }
            callback.call(context);
        }
        function resetHasForceUpdateBeforeProcessing() {
            hasForceUpdate = false;
        }
        function checkHasForceUpdateAfterProcessing() {
            return hasForceUpdate;
        }
        function commitUpdateQueue(finishedWork, finishedQueue, instance) {
            var effects = finishedQueue.effects;
            finishedQueue.effects = null;
            if (effects !== null) {
                for (var i = 0; i < effects.length; i++) {
                    var effect = effects[i];
                    var callback = effect.callback;
                    if (callback !== null) {
                        effect.callback = null;
                        callCallback(callback, instance);
                    }
                }
            }
        }
        var fakeInternalInstance = {};
        var isArray = Array.isArray;
        var emptyRefsObject = new React.Component().refs;
        var didWarnAboutStateAssignmentForComponent;
        var didWarnAboutUninitializedState;
        var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
        var didWarnAboutLegacyLifecyclesAndDerivedState;
        var didWarnAboutUndefinedDerivedState;
        var warnOnUndefinedDerivedState;
        var warnOnInvalidCallback;
        var didWarnAboutDirectlyAssigningPropsToState;
        var didWarnAboutContextTypeAndContextTypes;
        var didWarnAboutInvalidateContextType;
        {
            didWarnAboutStateAssignmentForComponent = new Set();
            didWarnAboutUninitializedState = new Set();
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
            didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
            didWarnAboutDirectlyAssigningPropsToState = new Set();
            didWarnAboutUndefinedDerivedState = new Set();
            didWarnAboutContextTypeAndContextTypes = new Set();
            didWarnAboutInvalidateContextType = new Set();
            var didWarnOnInvalidCallback = new Set();
            warnOnInvalidCallback = function (callback, callerName) {
                if (callback === null || typeof callback === 'function') {
                    return;
                }
                var key = callerName + '_' + callback;
                if (!didWarnOnInvalidCallback.has(key)) {
                    didWarnOnInvalidCallback.add(key);
                    error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
                }
            };
            warnOnUndefinedDerivedState = function (type, partialState) {
                if (partialState === undefined) {
                    var componentName = getComponentName(type) || 'Component';
                    if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                        didWarnAboutUndefinedDerivedState.add(componentName);
                        error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
                    }
                }
            };
            Object.defineProperty(fakeInternalInstance, '_processChildContext', {
                enumerable: false,
                value: function () {
                    {
                        {
                            throw Error('_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn\'t supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).');
                        }
                    }
                }
            });
            Object.freeze(fakeInternalInstance);
        }
        function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
            var prevState = workInProgress.memoizedState;
            {
                if (workInProgress.mode & StrictMode) {
                    disableLogs();
                    try {
                        getDerivedStateFromProps(nextProps, prevState);
                    } finally {
                        reenableLogs();
                    }
                }
            }
            var partialState = getDerivedStateFromProps(nextProps, prevState);
            {
                warnOnUndefinedDerivedState(ctor, partialState);
            }
            var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
            workInProgress.memoizedState = memoizedState;
            if (workInProgress.lanes === NoLanes) {
                var updateQueue = workInProgress.updateQueue;
                updateQueue.baseState = memoizedState;
            }
        }
        var classComponentUpdater = {
            isMounted: isMounted,
            enqueueSetState: function (inst, payload, callback) {
                var fiber = get(inst);
                var eventTime = requestEventTime();
                var lane = requestUpdateLane(fiber);
                var update = createUpdate(eventTime, lane);
                update.payload = payload;
                if (callback !== undefined && callback !== null) {
                    {
                        warnOnInvalidCallback(callback, 'setState');
                    }
                    update.callback = callback;
                }
                enqueueUpdate(fiber, update);
                scheduleUpdateOnFiber(fiber, lane, eventTime);
            },
            enqueueReplaceState: function (inst, payload, callback) {
                var fiber = get(inst);
                var eventTime = requestEventTime();
                var lane = requestUpdateLane(fiber);
                var update = createUpdate(eventTime, lane);
                update.tag = ReplaceState;
                update.payload = payload;
                if (callback !== undefined && callback !== null) {
                    {
                        warnOnInvalidCallback(callback, 'replaceState');
                    }
                    update.callback = callback;
                }
                enqueueUpdate(fiber, update);
                scheduleUpdateOnFiber(fiber, lane, eventTime);
            },
            enqueueForceUpdate: function (inst, callback) {
                var fiber = get(inst);
                var eventTime = requestEventTime();
                var lane = requestUpdateLane(fiber);
                var update = createUpdate(eventTime, lane);
                update.tag = ForceUpdate;
                if (callback !== undefined && callback !== null) {
                    {
                        warnOnInvalidCallback(callback, 'forceUpdate');
                    }
                    update.callback = callback;
                }
                enqueueUpdate(fiber, update);
                scheduleUpdateOnFiber(fiber, lane, eventTime);
            }
        };
        function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
            var instance = workInProgress.stateNode;
            if (typeof instance.shouldComponentUpdate === 'function') {
                {
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            instance.shouldComponentUpdate(newProps, newState, nextContext);
                        } finally {
                            reenableLogs();
                        }
                    }
                }
                var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                {
                    if (shouldUpdate === undefined) {
                        error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
                    }
                }
                return shouldUpdate;
            }
            if (ctor.prototype && ctor.prototype.isPureReactComponent) {
                return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
            }
            return true;
        }
        function checkClassInstance(workInProgress, ctor, newProps) {
            var instance = workInProgress.stateNode;
            {
                var name = getComponentName(ctor) || 'Component';
                var renderPresent = instance.render;
                if (!renderPresent) {
                    if (ctor.prototype && typeof ctor.prototype.render === 'function') {
                        error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
                    } else {
                        error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
                    }
                }
                if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
                    error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
                }
                if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
                    error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
                }
                if (instance.propTypes) {
                    error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
                }
                if (instance.contextType) {
                    error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
                }
                {
                    if (instance.contextTypes) {
                        error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
                    }
                    if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
                        didWarnAboutContextTypeAndContextTypes.add(ctor);
                        error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
                    }
                }
                if (typeof instance.componentShouldUpdate === 'function') {
                    error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
                }
                if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
                    error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
                }
                if (typeof instance.componentDidUnmount === 'function') {
                    error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
                }
                if (typeof instance.componentDidReceiveProps === 'function') {
                    error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
                }
                if (typeof instance.componentWillRecieveProps === 'function') {
                    error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
                }
                if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
                    error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
                }
                var hasMutatedProps = instance.props !== newProps;
                if (instance.props !== undefined && hasMutatedProps) {
                    error('%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', name, name);
                }
                if (instance.defaultProps) {
                    error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
                }
                if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
                    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
                    error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
                }
                if (typeof instance.getDerivedStateFromProps === 'function') {
                    error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
                }
                if (typeof instance.getDerivedStateFromError === 'function') {
                    error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
                }
                if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
                    error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
                }
                var _state = instance.state;
                if (_state && (typeof _state !== 'object' || isArray(_state))) {
                    error('%s.state: must be set to an object or null', name);
                }
                if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
                    error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
                }
            }
        }
        function adoptClassInstance(workInProgress, instance) {
            instance.updater = classComponentUpdater;
            workInProgress.stateNode = instance;
            set(instance, workInProgress);
            {
                instance._reactInternalInstance = fakeInternalInstance;
            }
        }
        function constructClassInstance(workInProgress, ctor, props) {
            var isLegacyContextConsumer = false;
            var unmaskedContext = emptyContextObject;
            var context = emptyContextObject;
            var contextType = ctor.contextType;
            {
                if ('contextType' in ctor) {
                    var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined;
                    if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                        didWarnAboutInvalidateContextType.add(ctor);
                        var addendum = '';
                        if (contextType === undefined) {
                            addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
                        } else if (typeof contextType !== 'object') {
                            addendum = ' However, it is set to a ' + typeof contextType + '.';
                        } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                            addendum = ' Did you accidentally pass the Context.Provider instead?';
                        } else if (contextType._context !== undefined) {
                            addendum = ' Did you accidentally pass the Context.Consumer instead?';
                        } else {
                            addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                        }
                        error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
                    }
                }
            }
            if (typeof contextType === 'object' && contextType !== null) {
                context = readContext(contextType);
            } else {
                unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
                var contextTypes = ctor.contextTypes;
                isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
                context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
            }
            {
                if (workInProgress.mode & StrictMode) {
                    disableLogs();
                    try {
                        new ctor(props, context);
                    } finally {
                        reenableLogs();
                    }
                }
            }
            var instance = new ctor(props, context);
            var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
            adoptClassInstance(workInProgress, instance);
            {
                if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
                    var componentName = getComponentName(ctor) || 'Component';
                    if (!didWarnAboutUninitializedState.has(componentName)) {
                        didWarnAboutUninitializedState.add(componentName);
                        error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
                    }
                }
                if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
                    var foundWillMountName = null;
                    var foundWillReceivePropsName = null;
                    var foundWillUpdateName = null;
                    if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                        foundWillMountName = 'componentWillMount';
                    } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
                        foundWillMountName = 'UNSAFE_componentWillMount';
                    }
                    if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                        foundWillReceivePropsName = 'componentWillReceiveProps';
                    } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
                        foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
                    }
                    if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                        foundWillUpdateName = 'componentWillUpdate';
                    } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
                        foundWillUpdateName = 'UNSAFE_componentWillUpdate';
                    }
                    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                        var _componentName = getComponentName(ctor) || 'Component';
                        var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                        if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                            didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                            error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? '\n  ' + foundWillMountName : '', foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '', foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '');
                        }
                    }
                }
            }
            if (isLegacyContextConsumer) {
                cacheContext(workInProgress, unmaskedContext, context);
            }
            return instance;
        }
        function callComponentWillMount(workInProgress, instance) {
            var oldState = instance.state;
            if (typeof instance.componentWillMount === 'function') {
                instance.componentWillMount();
            }
            if (typeof instance.UNSAFE_componentWillMount === 'function') {
                instance.UNSAFE_componentWillMount();
            }
            if (oldState !== instance.state) {
                {
                    error('%s.componentWillMount(): Assigning directly to this.state is ' + 'deprecated (except inside a component\'s ' + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
                }
                classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
            }
        }
        function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
            var oldState = instance.state;
            if (typeof instance.componentWillReceiveProps === 'function') {
                instance.componentWillReceiveProps(newProps, nextContext);
            }
            if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
                instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
            }
            if (instance.state !== oldState) {
                {
                    var componentName = getComponentName(workInProgress.type) || 'Component';
                    if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                        didWarnAboutStateAssignmentForComponent.add(componentName);
                        error('%s.componentWillReceiveProps(): Assigning directly to ' + 'this.state is deprecated (except inside a component\'s ' + 'constructor). Use setState instead.', componentName);
                    }
                }
                classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
            }
        }
        function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
            {
                checkClassInstance(workInProgress, ctor, newProps);
            }
            var instance = workInProgress.stateNode;
            instance.props = newProps;
            instance.state = workInProgress.memoizedState;
            instance.refs = emptyRefsObject;
            initializeUpdateQueue(workInProgress);
            var contextType = ctor.contextType;
            if (typeof contextType === 'object' && contextType !== null) {
                instance.context = readContext(contextType);
            } else {
                var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
                instance.context = getMaskedContext(workInProgress, unmaskedContext);
            }
            {
                if (instance.state === newProps) {
                    var componentName = getComponentName(ctor) || 'Component';
                    if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                        didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                        error('%s: It is not recommended to assign props directly to state ' + 'because updates to props won\'t be reflected in state. ' + 'In most cases, it is better to use props directly.', componentName);
                    }
                }
                if (workInProgress.mode & StrictMode) {
                    ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
                }
                {
                    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
                }
            }
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
            var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === 'function') {
                applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
                instance.state = workInProgress.memoizedState;
            }
            if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                callComponentWillMount(workInProgress, instance);
                processUpdateQueue(workInProgress, newProps, instance, renderLanes);
                instance.state = workInProgress.memoizedState;
            }
            if (typeof instance.componentDidMount === 'function') {
                workInProgress.flags |= Update;
            }
        }
        function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
            var instance = workInProgress.stateNode;
            var oldProps = workInProgress.memoizedProps;
            instance.props = oldProps;
            var oldContext = instance.context;
            var contextType = ctor.contextType;
            var nextContext = emptyContextObject;
            if (typeof contextType === 'object' && contextType !== null) {
                nextContext = readContext(contextType);
            } else {
                var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
                nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
            }
            var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
            var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function';
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
                if (oldProps !== newProps || oldContext !== nextContext) {
                    callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
                }
            }
            resetHasForceUpdateBeforeProcessing();
            var oldState = workInProgress.memoizedState;
            var newState = instance.state = oldState;
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            newState = workInProgress.memoizedState;
            if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
                if (typeof instance.componentDidMount === 'function') {
                    workInProgress.flags |= Update;
                }
                return false;
            }
            if (typeof getDerivedStateFromProps === 'function') {
                applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
                newState = workInProgress.memoizedState;
            }
            var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
            if (shouldUpdate) {
                if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                    if (typeof instance.componentWillMount === 'function') {
                        instance.componentWillMount();
                    }
                    if (typeof instance.UNSAFE_componentWillMount === 'function') {
                        instance.UNSAFE_componentWillMount();
                    }
                }
                if (typeof instance.componentDidMount === 'function') {
                    workInProgress.flags |= Update;
                }
            } else {
                if (typeof instance.componentDidMount === 'function') {
                    workInProgress.flags |= Update;
                }
                workInProgress.memoizedProps = newProps;
                workInProgress.memoizedState = newState;
            }
            instance.props = newProps;
            instance.state = newState;
            instance.context = nextContext;
            return shouldUpdate;
        }
        function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
            var instance = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            var unresolvedOldProps = workInProgress.memoizedProps;
            var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
            instance.props = oldProps;
            var unresolvedNewProps = workInProgress.pendingProps;
            var oldContext = instance.context;
            var contextType = ctor.contextType;
            var nextContext = emptyContextObject;
            if (typeof contextType === 'object' && contextType !== null) {
                nextContext = readContext(contextType);
            } else {
                var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
                nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
            }
            var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
            var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function';
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
                if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
                    callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
                }
            }
            resetHasForceUpdateBeforeProcessing();
            var oldState = workInProgress.memoizedState;
            var newState = instance.state = oldState;
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            newState = workInProgress.memoizedState;
            if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
                if (typeof instance.componentDidUpdate === 'function') {
                    if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                        workInProgress.flags |= Update;
                    }
                }
                if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                    if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                        workInProgress.flags |= Snapshot;
                    }
                }
                return false;
            }
            if (typeof getDerivedStateFromProps === 'function') {
                applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
                newState = workInProgress.memoizedState;
            }
            var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
            if (shouldUpdate) {
                if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                    if (typeof instance.componentWillUpdate === 'function') {
                        instance.componentWillUpdate(newProps, newState, nextContext);
                    }
                    if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
                        instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
                    }
                }
                if (typeof instance.componentDidUpdate === 'function') {
                    workInProgress.flags |= Update;
                }
                if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                    workInProgress.flags |= Snapshot;
                }
            } else {
                if (typeof instance.componentDidUpdate === 'function') {
                    if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                        workInProgress.flags |= Update;
                    }
                }
                if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                    if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                        workInProgress.flags |= Snapshot;
                    }
                }
                workInProgress.memoizedProps = newProps;
                workInProgress.memoizedState = newState;
            }
            instance.props = newProps;
            instance.state = newState;
            instance.context = nextContext;
            return shouldUpdate;
        }
        var didWarnAboutMaps;
        var didWarnAboutGenerators;
        var didWarnAboutStringRefs;
        var ownerHasKeyUseWarning;
        var ownerHasFunctionTypeWarning;
        var warnForMissingKey = function (child, returnFiber) {
        };
        {
            didWarnAboutMaps = false;
            didWarnAboutGenerators = false;
            didWarnAboutStringRefs = {};
            ownerHasKeyUseWarning = {};
            ownerHasFunctionTypeWarning = {};
            warnForMissingKey = function (child, returnFiber) {
                if (child === null || typeof child !== 'object') {
                    return;
                }
                if (!child._store || child._store.validated || child.key != null) {
                    return;
                }
                if (!(typeof child._store === 'object')) {
                    {
                        throw Error('React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
                child._store.validated = true;
                var componentName = getComponentName(returnFiber.type) || 'Component';
                if (ownerHasKeyUseWarning[componentName]) {
                    return;
                }
                ownerHasKeyUseWarning[componentName] = true;
                error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
            };
        }
        var isArray$1 = Array.isArray;
        function coerceRef(returnFiber, current, element) {
            var mixedRef = element.ref;
            if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
                {
                    if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                        var componentName = getComponentName(returnFiber.type) || 'Component';
                        if (!didWarnAboutStringRefs[componentName]) {
                            {
                                error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                            }
                            didWarnAboutStringRefs[componentName] = true;
                        }
                    }
                }
                if (element._owner) {
                    var owner = element._owner;
                    var inst;
                    if (owner) {
                        var ownerFiber = owner;
                        if (!(ownerFiber.tag === ClassComponent)) {
                            {
                                throw Error('Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref');
                            }
                        }
                        inst = ownerFiber.stateNode;
                    }
                    if (!inst) {
                        {
                            throw Error('Missing owner for string ref ' + mixedRef + '. This error is likely caused by a bug in React. Please file an issue.');
                        }
                    }
                    var stringRef = '' + mixedRef;
                    if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
                        return current.ref;
                    }
                    var ref = function (value) {
                        var refs = inst.refs;
                        if (refs === emptyRefsObject) {
                            refs = inst.refs = {};
                        }
                        if (value === null) {
                            delete refs[stringRef];
                        } else {
                            refs[stringRef] = value;
                        }
                    };
                    ref._stringRef = stringRef;
                    return ref;
                } else {
                    if (!(typeof mixedRef === 'string')) {
                        {
                            throw Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
                        }
                    }
                    if (!element._owner) {
                        {
                            throw Error('Element ref was specified as a string (' + mixedRef + ') but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component\'s render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.');
                        }
                    }
                }
            }
            return mixedRef;
        }
        function throwOnInvalidObjectType(returnFiber, newChild) {
            if (returnFiber.type !== 'textarea') {
                {
                    {
                        throw Error('Objects are not valid as a React child (found: ' + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + '). If you meant to render a collection of children, use an array instead.');
                    }
                }
            }
        }
        function warnOnFunctionType(returnFiber) {
            {
                var componentName = getComponentName(returnFiber.type) || 'Component';
                if (ownerHasFunctionTypeWarning[componentName]) {
                    return;
                }
                ownerHasFunctionTypeWarning[componentName] = true;
                error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
            }
        }
        function ChildReconciler(shouldTrackSideEffects) {
            function deleteChild(returnFiber, childToDelete) {
                if (!shouldTrackSideEffects) {
                    return;
                }
                var last = returnFiber.lastEffect;
                if (last !== null) {
                    last.nextEffect = childToDelete;
                    returnFiber.lastEffect = childToDelete;
                } else {
                    returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
                }
                childToDelete.nextEffect = null;
                childToDelete.flags = Deletion;
            }
            function deleteRemainingChildren(returnFiber, currentFirstChild) {
                if (!shouldTrackSideEffects) {
                    return null;
                }
                var childToDelete = currentFirstChild;
                while (childToDelete !== null) {
                    deleteChild(returnFiber, childToDelete);
                    childToDelete = childToDelete.sibling;
                }
                return null;
            }
            function mapRemainingChildren(returnFiber, currentFirstChild) {
                var existingChildren = new Map();
                var existingChild = currentFirstChild;
                while (existingChild !== null) {
                    if (existingChild.key !== null) {
                        existingChildren.set(existingChild.key, existingChild);
                    } else {
                        existingChildren.set(existingChild.index, existingChild);
                    }
                    existingChild = existingChild.sibling;
                }
                return existingChildren;
            }
            function useFiber(fiber, pendingProps) {
                var clone = createWorkInProgress(fiber, pendingProps);
                clone.index = 0;
                clone.sibling = null;
                return clone;
            }
            function placeChild(newFiber, lastPlacedIndex, newIndex) {
                newFiber.index = newIndex;
                if (!shouldTrackSideEffects) {
                    return lastPlacedIndex;
                }
                var current = newFiber.alternate;
                if (current !== null) {
                    var oldIndex = current.index;
                    if (oldIndex < lastPlacedIndex) {
                        newFiber.flags = Placement;
                        return lastPlacedIndex;
                    } else {
                        return oldIndex;
                    }
                } else {
                    newFiber.flags = Placement;
                    return lastPlacedIndex;
                }
            }
            function placeSingleChild(newFiber) {
                if (shouldTrackSideEffects && newFiber.alternate === null) {
                    newFiber.flags = Placement;
                }
                return newFiber;
            }
            function updateTextNode(returnFiber, current, textContent, lanes) {
                if (current === null || current.tag !== HostText) {
                    var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                    created.return = returnFiber;
                    return created;
                } else {
                    var existing = useFiber(current, textContent);
                    existing.return = returnFiber;
                    return existing;
                }
            }
            function updateElement(returnFiber, current, element, lanes) {
                if (current !== null) {
                    if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                        var existing = useFiber(current, element.props);
                        existing.ref = coerceRef(returnFiber, current, element);
                        existing.return = returnFiber;
                        {
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                        }
                        return existing;
                    }
                }
                var created = createFiberFromElement(element, returnFiber.mode, lanes);
                created.ref = coerceRef(returnFiber, current, element);
                created.return = returnFiber;
                return created;
            }
            function updatePortal(returnFiber, current, portal, lanes) {
                if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                    var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                    created.return = returnFiber;
                    return created;
                } else {
                    var existing = useFiber(current, portal.children || []);
                    existing.return = returnFiber;
                    return existing;
                }
            }
            function updateFragment(returnFiber, current, fragment, lanes, key) {
                if (current === null || current.tag !== Fragment) {
                    var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                    created.return = returnFiber;
                    return created;
                } else {
                    var existing = useFiber(current, fragment);
                    existing.return = returnFiber;
                    return existing;
                }
            }
            function createChild(returnFiber, newChild, lanes) {
                if (typeof newChild === 'string' || typeof newChild === 'number') {
                    var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                    created.return = returnFiber;
                    return created;
                }
                if (typeof newChild === 'object' && newChild !== null) {
                    switch (newChild.$$typeof) {
                    case REACT_ELEMENT_TYPE: {
                            var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                            _created.ref = coerceRef(returnFiber, null, newChild);
                            _created.return = returnFiber;
                            return _created;
                        }
                    case REACT_PORTAL_TYPE: {
                            var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                            _created2.return = returnFiber;
                            return _created2;
                        }
                    }
                    if (isArray$1(newChild) || getIteratorFn(newChild)) {
                        var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                        _created3.return = returnFiber;
                        return _created3;
                    }
                    throwOnInvalidObjectType(returnFiber, newChild);
                }
                {
                    if (typeof newChild === 'function') {
                        warnOnFunctionType(returnFiber);
                    }
                }
                return null;
            }
            function updateSlot(returnFiber, oldFiber, newChild, lanes) {
                var key = oldFiber !== null ? oldFiber.key : null;
                if (typeof newChild === 'string' || typeof newChild === 'number') {
                    if (key !== null) {
                        return null;
                    }
                    return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
                }
                if (typeof newChild === 'object' && newChild !== null) {
                    switch (newChild.$$typeof) {
                    case REACT_ELEMENT_TYPE: {
                            if (newChild.key === key) {
                                if (newChild.type === REACT_FRAGMENT_TYPE) {
                                    return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
                                }
                                return updateElement(returnFiber, oldFiber, newChild, lanes);
                            } else {
                                return null;
                            }
                        }
                    case REACT_PORTAL_TYPE: {
                            if (newChild.key === key) {
                                return updatePortal(returnFiber, oldFiber, newChild, lanes);
                            } else {
                                return null;
                            }
                        }
                    }
                    if (isArray$1(newChild) || getIteratorFn(newChild)) {
                        if (key !== null) {
                            return null;
                        }
                        return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                    }
                    throwOnInvalidObjectType(returnFiber, newChild);
                }
                {
                    if (typeof newChild === 'function') {
                        warnOnFunctionType(returnFiber);
                    }
                }
                return null;
            }
            function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
                if (typeof newChild === 'string' || typeof newChild === 'number') {
                    var matchedFiber = existingChildren.get(newIdx) || null;
                    return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
                }
                if (typeof newChild === 'object' && newChild !== null) {
                    switch (newChild.$$typeof) {
                    case REACT_ELEMENT_TYPE: {
                            var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                            if (newChild.type === REACT_FRAGMENT_TYPE) {
                                return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                            }
                            return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                        }
                    case REACT_PORTAL_TYPE: {
                            var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                            return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                        }
                    }
                    if (isArray$1(newChild) || getIteratorFn(newChild)) {
                        var _matchedFiber3 = existingChildren.get(newIdx) || null;
                        return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                    }
                    throwOnInvalidObjectType(returnFiber, newChild);
                }
                {
                    if (typeof newChild === 'function') {
                        warnOnFunctionType(returnFiber);
                    }
                }
                return null;
            }
            function warnOnInvalidKey(child, knownKeys, returnFiber) {
                {
                    if (typeof child !== 'object' || child === null) {
                        return knownKeys;
                    }
                    switch (child.$$typeof) {
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        warnForMissingKey(child, returnFiber);
                        var key = child.key;
                        if (typeof key !== 'string') {
                            break;
                        }
                        if (knownKeys === null) {
                            knownKeys = new Set();
                            knownKeys.add(key);
                            break;
                        }
                        if (!knownKeys.has(key)) {
                            knownKeys.add(key);
                            break;
                        }
                        error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted \u2014 the behavior is unsupported and ' + 'could change in a future version.', key);
                        break;
                    }
                }
                return knownKeys;
            }
            function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
                {
                    var knownKeys = null;
                    for (var i = 0; i < newChildren.length; i++) {
                        var child = newChildren[i];
                        knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                    }
                }
                var resultingFirstChild = null;
                var previousNewFiber = null;
                var oldFiber = currentFirstChild;
                var lastPlacedIndex = 0;
                var newIdx = 0;
                var nextOldFiber = null;
                for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
                    if (oldFiber.index > newIdx) {
                        nextOldFiber = oldFiber;
                        oldFiber = null;
                    } else {
                        nextOldFiber = oldFiber.sibling;
                    }
                    var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                    if (newFiber === null) {
                        if (oldFiber === null) {
                            oldFiber = nextOldFiber;
                        }
                        break;
                    }
                    if (shouldTrackSideEffects) {
                        if (oldFiber && newFiber.alternate === null) {
                            deleteChild(returnFiber, oldFiber);
                        }
                    }
                    lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) {
                        resultingFirstChild = newFiber;
                    } else {
                        previousNewFiber.sibling = newFiber;
                    }
                    previousNewFiber = newFiber;
                    oldFiber = nextOldFiber;
                }
                if (newIdx === newChildren.length) {
                    deleteRemainingChildren(returnFiber, oldFiber);
                    return resultingFirstChild;
                }
                if (oldFiber === null) {
                    for (; newIdx < newChildren.length; newIdx++) {
                        var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                        if (_newFiber === null) {
                            continue;
                        }
                        lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                        if (previousNewFiber === null) {
                            resultingFirstChild = _newFiber;
                        } else {
                            previousNewFiber.sibling = _newFiber;
                        }
                        previousNewFiber = _newFiber;
                    }
                    return resultingFirstChild;
                }
                var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
                for (; newIdx < newChildren.length; newIdx++) {
                    var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                    if (_newFiber2 !== null) {
                        if (shouldTrackSideEffects) {
                            if (_newFiber2.alternate !== null) {
                                existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                            }
                        }
                        lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                        if (previousNewFiber === null) {
                            resultingFirstChild = _newFiber2;
                        } else {
                            previousNewFiber.sibling = _newFiber2;
                        }
                        previousNewFiber = _newFiber2;
                    }
                }
                if (shouldTrackSideEffects) {
                    existingChildren.forEach(function (child) {
                        return deleteChild(returnFiber, child);
                    });
                }
                return resultingFirstChild;
            }
            function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
                var iteratorFn = getIteratorFn(newChildrenIterable);
                if (!(typeof iteratorFn === 'function')) {
                    {
                        throw Error('An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
                {
                    if (typeof Symbol === 'function' && newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                        if (!didWarnAboutGenerators) {
                            error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
                        }
                        didWarnAboutGenerators = true;
                    }
                    if (newChildrenIterable.entries === iteratorFn) {
                        if (!didWarnAboutMaps) {
                            error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
                        }
                        didWarnAboutMaps = true;
                    }
                    var _newChildren = iteratorFn.call(newChildrenIterable);
                    if (_newChildren) {
                        var knownKeys = null;
                        var _step = _newChildren.next();
                        for (; !_step.done; _step = _newChildren.next()) {
                            var child = _step.value;
                            knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                        }
                    }
                }
                var newChildren = iteratorFn.call(newChildrenIterable);
                if (!(newChildren != null)) {
                    {
                        throw Error('An iterable object provided no iterator.');
                    }
                }
                var resultingFirstChild = null;
                var previousNewFiber = null;
                var oldFiber = currentFirstChild;
                var lastPlacedIndex = 0;
                var newIdx = 0;
                var nextOldFiber = null;
                var step = newChildren.next();
                for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
                    if (oldFiber.index > newIdx) {
                        nextOldFiber = oldFiber;
                        oldFiber = null;
                    } else {
                        nextOldFiber = oldFiber.sibling;
                    }
                    var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                    if (newFiber === null) {
                        if (oldFiber === null) {
                            oldFiber = nextOldFiber;
                        }
                        break;
                    }
                    if (shouldTrackSideEffects) {
                        if (oldFiber && newFiber.alternate === null) {
                            deleteChild(returnFiber, oldFiber);
                        }
                    }
                    lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) {
                        resultingFirstChild = newFiber;
                    } else {
                        previousNewFiber.sibling = newFiber;
                    }
                    previousNewFiber = newFiber;
                    oldFiber = nextOldFiber;
                }
                if (step.done) {
                    deleteRemainingChildren(returnFiber, oldFiber);
                    return resultingFirstChild;
                }
                if (oldFiber === null) {
                    for (; !step.done; newIdx++, step = newChildren.next()) {
                        var _newFiber3 = createChild(returnFiber, step.value, lanes);
                        if (_newFiber3 === null) {
                            continue;
                        }
                        lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                        if (previousNewFiber === null) {
                            resultingFirstChild = _newFiber3;
                        } else {
                            previousNewFiber.sibling = _newFiber3;
                        }
                        previousNewFiber = _newFiber3;
                    }
                    return resultingFirstChild;
                }
                var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
                for (; !step.done; newIdx++, step = newChildren.next()) {
                    var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                    if (_newFiber4 !== null) {
                        if (shouldTrackSideEffects) {
                            if (_newFiber4.alternate !== null) {
                                existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                            }
                        }
                        lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                        if (previousNewFiber === null) {
                            resultingFirstChild = _newFiber4;
                        } else {
                            previousNewFiber.sibling = _newFiber4;
                        }
                        previousNewFiber = _newFiber4;
                    }
                }
                if (shouldTrackSideEffects) {
                    existingChildren.forEach(function (child) {
                        return deleteChild(returnFiber, child);
                    });
                }
                return resultingFirstChild;
            }
            function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
                if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                    var existing = useFiber(currentFirstChild, textContent);
                    existing.return = returnFiber;
                    return existing;
                }
                deleteRemainingChildren(returnFiber, currentFirstChild);
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
                var key = element.key;
                var child = currentFirstChild;
                while (child !== null) {
                    if (child.key === key) {
                        switch (child.tag) {
                        case Fragment: {
                                if (element.type === REACT_FRAGMENT_TYPE) {
                                    deleteRemainingChildren(returnFiber, child.sibling);
                                    var existing = useFiber(child, element.props.children);
                                    existing.return = returnFiber;
                                    {
                                        existing._debugSource = element._source;
                                        existing._debugOwner = element._owner;
                                    }
                                    return existing;
                                }
                                break;
                            }
                        case Block:
                        default: {
                                if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                    deleteRemainingChildren(returnFiber, child.sibling);
                                    var _existing3 = useFiber(child, element.props);
                                    _existing3.ref = coerceRef(returnFiber, child, element);
                                    _existing3.return = returnFiber;
                                    {
                                        _existing3._debugSource = element._source;
                                        _existing3._debugOwner = element._owner;
                                    }
                                    return _existing3;
                                }
                                break;
                            }
                        }
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    } else {
                        deleteChild(returnFiber, child);
                    }
                    child = child.sibling;
                }
                if (element.type === REACT_FRAGMENT_TYPE) {
                    var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                    created.return = returnFiber;
                    return created;
                } else {
                    var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                    _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                    _created4.return = returnFiber;
                    return _created4;
                }
            }
            function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
                var key = portal.key;
                var child = currentFirstChild;
                while (child !== null) {
                    if (child.key === key) {
                        if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, portal.children || []);
                            existing.return = returnFiber;
                            return existing;
                        } else {
                            deleteRemainingChildren(returnFiber, child);
                            break;
                        }
                    } else {
                        deleteChild(returnFiber, child);
                    }
                    child = child.sibling;
                }
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
                var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
                if (isUnkeyedTopLevelFragment) {
                    newChild = newChild.props.children;
                }
                var isObject = typeof newChild === 'object' && newChild !== null;
                if (isObject) {
                    switch (newChild.$$typeof) {
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    }
                }
                if (typeof newChild === 'string' || typeof newChild === 'number') {
                    return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
                }
                if (isArray$1(newChild)) {
                    return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                }
                if (getIteratorFn(newChild)) {
                    return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                }
                if (isObject) {
                    throwOnInvalidObjectType(returnFiber, newChild);
                }
                {
                    if (typeof newChild === 'function') {
                        warnOnFunctionType(returnFiber);
                    }
                }
                if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
                    switch (returnFiber.tag) {
                    case ClassComponent: {
                            {
                                var instance = returnFiber.stateNode;
                                if (instance.render._isMockFunction) {
                                    break;
                                }
                            }
                        }
                    case Block:
                    case FunctionComponent:
                    case ForwardRef:
                    case SimpleMemoComponent: {
                            {
                                {
                                    throw Error((getComponentName(returnFiber.type) || 'Component') + '(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.');
                                }
                            }
                        }
                    }
                }
                return deleteRemainingChildren(returnFiber, currentFirstChild);
            }
            return reconcileChildFibers;
        }
        var reconcileChildFibers = ChildReconciler(true);
        var mountChildFibers = ChildReconciler(false);
        function cloneChildFibers(current, workInProgress) {
            if (!(current === null || workInProgress.child === current.child)) {
                {
                    throw Error('Resuming work not yet implemented.');
                }
            }
            if (workInProgress.child === null) {
                return;
            }
            var currentChild = workInProgress.child;
            var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
            workInProgress.child = newChild;
            newChild.return = workInProgress;
            while (currentChild.sibling !== null) {
                currentChild = currentChild.sibling;
                newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
                newChild.return = workInProgress;
            }
            newChild.sibling = null;
        }
        function resetChildFibers(workInProgress, lanes) {
            var child = workInProgress.child;
            while (child !== null) {
                resetWorkInProgress(child, lanes);
                child = child.sibling;
            }
        }
        var NO_CONTEXT = {};
        var contextStackCursor$1 = createCursor(NO_CONTEXT);
        var contextFiberStackCursor = createCursor(NO_CONTEXT);
        var rootInstanceStackCursor = createCursor(NO_CONTEXT);
        function requiredContext(c) {
            if (!(c !== NO_CONTEXT)) {
                {
                    throw Error('Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
            return c;
        }
        function getRootHostContainer() {
            var rootInstance = requiredContext(rootInstanceStackCursor.current);
            return rootInstance;
        }
        function pushHostContainer(fiber, nextRootInstance) {
            push(rootInstanceStackCursor, nextRootInstance, fiber);
            push(contextFiberStackCursor, fiber, fiber);
            push(contextStackCursor$1, NO_CONTEXT, fiber);
            var nextRootContext = getRootHostContext(nextRootInstance);
            pop(contextStackCursor$1, fiber);
            push(contextStackCursor$1, nextRootContext, fiber);
        }
        function popHostContainer(fiber) {
            pop(contextStackCursor$1, fiber);
            pop(contextFiberStackCursor, fiber);
            pop(rootInstanceStackCursor, fiber);
        }
        function getHostContext() {
            var context = requiredContext(contextStackCursor$1.current);
            return context;
        }
        function pushHostContext(fiber) {
            var rootInstance = requiredContext(rootInstanceStackCursor.current);
            var context = requiredContext(contextStackCursor$1.current);
            var nextContext = getChildHostContext(context, fiber.type);
            if (context === nextContext) {
                return;
            }
            push(contextFiberStackCursor, fiber, fiber);
            push(contextStackCursor$1, nextContext, fiber);
        }
        function popHostContext(fiber) {
            if (contextFiberStackCursor.current !== fiber) {
                return;
            }
            pop(contextStackCursor$1, fiber);
            pop(contextFiberStackCursor, fiber);
        }
        var DefaultSuspenseContext = 0;
        var SubtreeSuspenseContextMask = 1;
        var InvisibleParentSuspenseContext = 1;
        var ForceSuspenseFallback = 2;
        var suspenseStackCursor = createCursor(DefaultSuspenseContext);
        function hasSuspenseContext(parentContext, flag) {
            return (parentContext & flag) !== 0;
        }
        function setDefaultShallowSuspenseContext(parentContext) {
            return parentContext & SubtreeSuspenseContextMask;
        }
        function setShallowSuspenseContext(parentContext, shallowContext) {
            return parentContext & SubtreeSuspenseContextMask | shallowContext;
        }
        function addSubtreeSuspenseContext(parentContext, subtreeContext) {
            return parentContext | subtreeContext;
        }
        function pushSuspenseContext(fiber, newContext) {
            push(suspenseStackCursor, newContext, fiber);
        }
        function popSuspenseContext(fiber) {
            pop(suspenseStackCursor, fiber);
        }
        function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
            var nextState = workInProgress.memoizedState;
            if (nextState !== null) {
                if (nextState.dehydrated !== null) {
                    return true;
                }
                return false;
            }
            var props = workInProgress.memoizedProps;
            if (props.fallback === undefined) {
                return false;
            }
            if (props.unstable_avoidThisFallback !== true) {
                return true;
            }
            if (hasInvisibleParent) {
                return false;
            }
            return true;
        }
        function findFirstSuspended(row) {
            var node = row;
            while (node !== null) {
                if (node.tag === SuspenseComponent) {
                    var state = node.memoizedState;
                    if (state !== null) {
                        var dehydrated = state.dehydrated;
                        if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                            return node;
                        }
                    }
                } else if (node.tag === SuspenseListComponent && node.memoizedProps.revealOrder !== undefined) {
                    var didSuspend = (node.flags & DidCapture) !== NoFlags;
                    if (didSuspend) {
                        return node;
                    }
                } else if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === row) {
                    return null;
                }
                while (node.sibling === null) {
                    if (node.return === null || node.return === row) {
                        return null;
                    }
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
            return null;
        }
        var NoFlags$1 = 0;
        var HasEffect = 1;
        var Layout = 2;
        var Passive$1 = 4;
        var hydrationParentFiber = null;
        var nextHydratableInstance = null;
        var isHydrating = false;
        function enterHydrationState(fiber) {
            var parentInstance = fiber.stateNode.containerInfo;
            nextHydratableInstance = getFirstHydratableChild(parentInstance);
            hydrationParentFiber = fiber;
            isHydrating = true;
            return true;
        }
        function deleteHydratableInstance(returnFiber, instance) {
            {
                switch (returnFiber.tag) {
                case HostRoot:
                    didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                    break;
                case HostComponent:
                    didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                    break;
                }
            }
            var childToDelete = createFiberFromHostInstanceForDeletion();
            childToDelete.stateNode = instance;
            childToDelete.return = returnFiber;
            childToDelete.flags = Deletion;
            if (returnFiber.lastEffect !== null) {
                returnFiber.lastEffect.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else {
                returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            }
        }
        function insertNonHydratedInstance(returnFiber, fiber) {
            fiber.flags = fiber.flags & ~Hydrating | Placement;
            {
                switch (returnFiber.tag) {
                case HostRoot: {
                        var parentContainer = returnFiber.stateNode.containerInfo;
                        switch (fiber.tag) {
                        case HostComponent:
                            var type = fiber.type;
                            var props = fiber.pendingProps;
                            didNotFindHydratableContainerInstance(parentContainer, type);
                            break;
                        case HostText:
                            var text = fiber.pendingProps;
                            didNotFindHydratableContainerTextInstance(parentContainer, text);
                            break;
                        }
                        break;
                    }
                case HostComponent: {
                        var parentType = returnFiber.type;
                        var parentProps = returnFiber.memoizedProps;
                        var parentInstance = returnFiber.stateNode;
                        switch (fiber.tag) {
                        case HostComponent:
                            var _type = fiber.type;
                            var _props = fiber.pendingProps;
                            didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                            break;
                        case HostText:
                            var _text = fiber.pendingProps;
                            didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                            break;
                        case SuspenseComponent:
                            didNotFindHydratableSuspenseInstance(parentType, parentProps);
                            break;
                        }
                        break;
                    }
                default:
                    return;
                }
            }
        }
        function tryHydrate(fiber, nextInstance) {
            switch (fiber.tag) {
            case HostComponent: {
                    var type = fiber.type;
                    var props = fiber.pendingProps;
                    var instance = canHydrateInstance(nextInstance, type);
                    if (instance !== null) {
                        fiber.stateNode = instance;
                        return true;
                    }
                    return false;
                }
            case HostText: {
                    var text = fiber.pendingProps;
                    var textInstance = canHydrateTextInstance(nextInstance, text);
                    if (textInstance !== null) {
                        fiber.stateNode = textInstance;
                        return true;
                    }
                    return false;
                }
            case SuspenseComponent: {
                    return false;
                }
            default:
                return false;
            }
        }
        function tryToClaimNextHydratableInstance(fiber) {
            if (!isHydrating) {
                return;
            }
            var nextInstance = nextHydratableInstance;
            if (!nextInstance) {
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            }
            var firstAttemptedInstance = nextInstance;
            if (!tryHydrate(fiber, nextInstance)) {
                nextInstance = getNextHydratableSibling(firstAttemptedInstance);
                if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                    insertNonHydratedInstance(hydrationParentFiber, fiber);
                    isHydrating = false;
                    hydrationParentFiber = fiber;
                    return;
                }
                deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
            }
            hydrationParentFiber = fiber;
            nextHydratableInstance = getFirstHydratableChild(nextInstance);
        }
        function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
            var instance = fiber.stateNode;
            var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber);
            fiber.updateQueue = updatePayload;
            if (updatePayload !== null) {
                return true;
            }
            return false;
        }
        function prepareToHydrateHostTextInstance(fiber) {
            var textInstance = fiber.stateNode;
            var textContent = fiber.memoizedProps;
            var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
            {
                if (shouldUpdate) {
                    var returnFiber = hydrationParentFiber;
                    if (returnFiber !== null) {
                        switch (returnFiber.tag) {
                        case HostRoot: {
                                var parentContainer = returnFiber.stateNode.containerInfo;
                                didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                                break;
                            }
                        case HostComponent: {
                                var parentType = returnFiber.type;
                                var parentProps = returnFiber.memoizedProps;
                                var parentInstance = returnFiber.stateNode;
                                didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                                break;
                            }
                        }
                    }
                }
            }
            return shouldUpdate;
        }
        function skipPastDehydratedSuspenseInstance(fiber) {
            var suspenseState = fiber.memoizedState;
            var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
            if (!suspenseInstance) {
                {
                    throw Error('Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
            return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
        }
        function popToNextHostParent(fiber) {
            var parent = fiber.return;
            while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
                parent = parent.return;
            }
            hydrationParentFiber = parent;
        }
        function popHydrationState(fiber) {
            if (fiber !== hydrationParentFiber) {
                return false;
            }
            if (!isHydrating) {
                popToNextHostParent(fiber);
                isHydrating = true;
                return false;
            }
            var type = fiber.type;
            if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
                var nextInstance = nextHydratableInstance;
                while (nextInstance) {
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
            popToNextHostParent(fiber);
            if (fiber.tag === SuspenseComponent) {
                nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
            } else {
                nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
            }
            return true;
        }
        function resetHydrationState() {
            hydrationParentFiber = null;
            nextHydratableInstance = null;
            isHydrating = false;
        }
        function getIsHydrating() {
            return isHydrating;
        }
        var workInProgressSources = [];
        var rendererSigil$1;
        {
            rendererSigil$1 = {};
        }
        function markSourceAsDirty(mutableSource) {
            workInProgressSources.push(mutableSource);
        }
        function resetWorkInProgressVersions() {
            for (var i = 0; i < workInProgressSources.length; i++) {
                var mutableSource = workInProgressSources[i];
                {
                    mutableSource._workInProgressVersionPrimary = null;
                }
            }
            workInProgressSources.length = 0;
        }
        function getWorkInProgressVersion(mutableSource) {
            {
                return mutableSource._workInProgressVersionPrimary;
            }
        }
        function setWorkInProgressVersion(mutableSource, version) {
            {
                mutableSource._workInProgressVersionPrimary = version;
            }
            workInProgressSources.push(mutableSource);
        }
        function warnAboutMultipleRenderersDEV(mutableSource) {
            {
                {
                    if (mutableSource._currentPrimaryRenderer == null) {
                        mutableSource._currentPrimaryRenderer = rendererSigil$1;
                    } else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) {
                        error('Detected multiple renderers concurrently rendering the ' + 'same mutable source. This is currently unsupported.');
                    }
                }
            }
        }
        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
        var didWarnAboutMismatchedHooksForComponent;
        var didWarnAboutUseOpaqueIdentifier;
        {
            didWarnAboutUseOpaqueIdentifier = {};
            didWarnAboutMismatchedHooksForComponent = new Set();
        }
        var renderLanes = NoLanes;
        var currentlyRenderingFiber$1 = null;
        var currentHook = null;
        var workInProgressHook = null;
        var didScheduleRenderPhaseUpdate = false;
        var didScheduleRenderPhaseUpdateDuringThisPass = false;
        var RE_RENDER_LIMIT = 25;
        var currentHookNameInDev = null;
        var hookTypesDev = null;
        var hookTypesUpdateIndexDev = -1;
        var ignorePreviousDependencies = false;
        function mountHookTypesDev() {
            {
                var hookName = currentHookNameInDev;
                if (hookTypesDev === null) {
                    hookTypesDev = [hookName];
                } else {
                    hookTypesDev.push(hookName);
                }
            }
        }
        function updateHookTypesDev() {
            {
                var hookName = currentHookNameInDev;
                if (hookTypesDev !== null) {
                    hookTypesUpdateIndexDev++;
                    if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
                        warnOnHookMismatchInDev(hookName);
                    }
                }
            }
        }
        function checkDepsAreArrayDev(deps) {
            {
                if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
                    error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
                }
            }
        }
        function warnOnHookMismatchInDev(currentHookName) {
            {
                var componentName = getComponentName(currentlyRenderingFiber$1.type);
                if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
                    didWarnAboutMismatchedHooksForComponent.add(componentName);
                    if (hookTypesDev !== null) {
                        var table = '';
                        var secondColumnStart = 30;
                        for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                            var oldHookName = hookTypesDev[i];
                            var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                            var row = i + 1 + '. ' + oldHookName;
                            while (row.length < secondColumnStart) {
                                row += ' ';
                            }
                            row += newHookName + '\n';
                            table += row;
                        }
                        error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
                    }
                }
            }
        }
        function throwInvalidHookError() {
            {
                {
                    throw Error('Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.');
                }
            }
        }
        function areHookInputsEqual(nextDeps, prevDeps) {
            {
                if (ignorePreviousDependencies) {
                    return false;
                }
            }
            if (prevDeps === null) {
                {
                    error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
                }
                return false;
            }
            {
                if (nextDeps.length !== prevDeps.length) {
                    error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, '[' + prevDeps.join(', ') + ']', '[' + nextDeps.join(', ') + ']');
                }
            }
            for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
                if (objectIs(nextDeps[i], prevDeps[i])) {
                    continue;
                }
                return false;
            }
            return true;
        }
        function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
            renderLanes = nextRenderLanes;
            currentlyRenderingFiber$1 = workInProgress;
            {
                hookTypesDev = current !== null ? current._debugHookTypes : null;
                hookTypesUpdateIndexDev = -1;
                ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
            }
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.lanes = NoLanes;
            {
                if (current !== null && current.memoizedState !== null) {
                    ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
                } else if (hookTypesDev !== null) {
                    ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
                } else {
                    ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
                }
            }
            var children = Component(props, secondArg);
            if (didScheduleRenderPhaseUpdateDuringThisPass) {
                var numberOfReRenders = 0;
                do {
                    didScheduleRenderPhaseUpdateDuringThisPass = false;
                    if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
                        {
                            throw Error('Too many re-renders. React limits the number of renders to prevent an infinite loop.');
                        }
                    }
                    numberOfReRenders += 1;
                    {
                        ignorePreviousDependencies = false;
                    }
                    currentHook = null;
                    workInProgressHook = null;
                    workInProgress.updateQueue = null;
                    {
                        hookTypesUpdateIndexDev = -1;
                    }
                    ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                    children = Component(props, secondArg);
                } while (didScheduleRenderPhaseUpdateDuringThisPass);
            }
            ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
            {
                workInProgress._debugHookTypes = hookTypesDev;
            }
            var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
            renderLanes = NoLanes;
            currentlyRenderingFiber$1 = null;
            currentHook = null;
            workInProgressHook = null;
            {
                currentHookNameInDev = null;
                hookTypesDev = null;
                hookTypesUpdateIndexDev = -1;
            }
            didScheduleRenderPhaseUpdate = false;
            if (!!didRenderTooFewHooks) {
                {
                    throw Error('Rendered fewer hooks than expected. This may be caused by an accidental early return statement.');
                }
            }
            return children;
        }
        function bailoutHooks(current, workInProgress, lanes) {
            workInProgress.updateQueue = current.updateQueue;
            workInProgress.flags &= ~(Passive | Update);
            current.lanes = removeLanes(current.lanes, lanes);
        }
        function resetHooksAfterThrow() {
            ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
            if (didScheduleRenderPhaseUpdate) {
                var hook = currentlyRenderingFiber$1.memoizedState;
                while (hook !== null) {
                    var queue = hook.queue;
                    if (queue !== null) {
                        queue.pending = null;
                    }
                    hook = hook.next;
                }
                didScheduleRenderPhaseUpdate = false;
            }
            renderLanes = NoLanes;
            currentlyRenderingFiber$1 = null;
            currentHook = null;
            workInProgressHook = null;
            {
                hookTypesDev = null;
                hookTypesUpdateIndexDev = -1;
                currentHookNameInDev = null;
                isUpdatingOpaqueValueInRenderPhase = false;
            }
            didScheduleRenderPhaseUpdateDuringThisPass = false;
        }
        function mountWorkInProgressHook() {
            var hook = {
                memoizedState: null,
                baseState: null,
                baseQueue: null,
                queue: null,
                next: null
            };
            if (workInProgressHook === null) {
                currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
            } else {
                workInProgressHook = workInProgressHook.next = hook;
            }
            return workInProgressHook;
        }
        function updateWorkInProgressHook() {
            var nextCurrentHook;
            if (currentHook === null) {
                var current = currentlyRenderingFiber$1.alternate;
                if (current !== null) {
                    nextCurrentHook = current.memoizedState;
                } else {
                    nextCurrentHook = null;
                }
            } else {
                nextCurrentHook = currentHook.next;
            }
            var nextWorkInProgressHook;
            if (workInProgressHook === null) {
                nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
            } else {
                nextWorkInProgressHook = workInProgressHook.next;
            }
            if (nextWorkInProgressHook !== null) {
                workInProgressHook = nextWorkInProgressHook;
                nextWorkInProgressHook = workInProgressHook.next;
                currentHook = nextCurrentHook;
            } else {
                if (!(nextCurrentHook !== null)) {
                    {
                        throw Error('Rendered more hooks than during the previous render.');
                    }
                }
                currentHook = nextCurrentHook;
                var newHook = {
                    memoizedState: currentHook.memoizedState,
                    baseState: currentHook.baseState,
                    baseQueue: currentHook.baseQueue,
                    queue: currentHook.queue,
                    next: null
                };
                if (workInProgressHook === null) {
                    currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
                } else {
                    workInProgressHook = workInProgressHook.next = newHook;
                }
            }
            return workInProgressHook;
        }
        function createFunctionComponentUpdateQueue() {
            return { lastEffect: null };
        }
        function basicStateReducer(state, action) {
            return typeof action === 'function' ? action(state) : action;
        }
        function mountReducer(reducer, initialArg, init) {
            var hook = mountWorkInProgressHook();
            var initialState;
            if (init !== undefined) {
                initialState = init(initialArg);
            } else {
                initialState = initialArg;
            }
            hook.memoizedState = hook.baseState = initialState;
            var queue = hook.queue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: reducer,
                lastRenderedState: initialState
            };
            var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
            return [
                hook.memoizedState,
                dispatch
            ];
        }
        function updateReducer(reducer, initialArg, init) {
            var hook = updateWorkInProgressHook();
            var queue = hook.queue;
            if (!(queue !== null)) {
                {
                    throw Error('Should have a queue. This is likely a bug in React. Please file an issue.');
                }
            }
            queue.lastRenderedReducer = reducer;
            var current = currentHook;
            var baseQueue = current.baseQueue;
            var pendingQueue = queue.pending;
            if (pendingQueue !== null) {
                if (baseQueue !== null) {
                    var baseFirst = baseQueue.next;
                    var pendingFirst = pendingQueue.next;
                    baseQueue.next = pendingFirst;
                    pendingQueue.next = baseFirst;
                }
                {
                    if (current.baseQueue !== baseQueue) {
                        error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
                    }
                }
                current.baseQueue = baseQueue = pendingQueue;
                queue.pending = null;
            }
            if (baseQueue !== null) {
                var first = baseQueue.next;
                var newState = current.baseState;
                var newBaseState = null;
                var newBaseQueueFirst = null;
                var newBaseQueueLast = null;
                var update = first;
                do {
                    var updateLane = update.lane;
                    if (!isSubsetOfLanes(renderLanes, updateLane)) {
                        var clone = {
                            lane: updateLane,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        if (newBaseQueueLast === null) {
                            newBaseQueueFirst = newBaseQueueLast = clone;
                            newBaseState = newState;
                        } else {
                            newBaseQueueLast = newBaseQueueLast.next = clone;
                        }
                        currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                        markSkippedUpdateLanes(updateLane);
                    } else {
                        if (newBaseQueueLast !== null) {
                            var _clone = {
                                lane: NoLane,
                                action: update.action,
                                eagerReducer: update.eagerReducer,
                                eagerState: update.eagerState,
                                next: null
                            };
                            newBaseQueueLast = newBaseQueueLast.next = _clone;
                        }
                        if (update.eagerReducer === reducer) {
                            newState = update.eagerState;
                        } else {
                            var action = update.action;
                            newState = reducer(newState, action);
                        }
                    }
                    update = update.next;
                } while (update !== null && update !== first);
                if (newBaseQueueLast === null) {
                    newBaseState = newState;
                } else {
                    newBaseQueueLast.next = newBaseQueueFirst;
                }
                if (!objectIs(newState, hook.memoizedState)) {
                    markWorkInProgressReceivedUpdate();
                }
                hook.memoizedState = newState;
                hook.baseState = newBaseState;
                hook.baseQueue = newBaseQueueLast;
                queue.lastRenderedState = newState;
            }
            var dispatch = queue.dispatch;
            return [
                hook.memoizedState,
                dispatch
            ];
        }
        function rerenderReducer(reducer, initialArg, init) {
            var hook = updateWorkInProgressHook();
            var queue = hook.queue;
            if (!(queue !== null)) {
                {
                    throw Error('Should have a queue. This is likely a bug in React. Please file an issue.');
                }
            }
            queue.lastRenderedReducer = reducer;
            var dispatch = queue.dispatch;
            var lastRenderPhaseUpdate = queue.pending;
            var newState = hook.memoizedState;
            if (lastRenderPhaseUpdate !== null) {
                queue.pending = null;
                var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
                var update = firstRenderPhaseUpdate;
                do {
                    var action = update.action;
                    newState = reducer(newState, action);
                    update = update.next;
                } while (update !== firstRenderPhaseUpdate);
                if (!objectIs(newState, hook.memoizedState)) {
                    markWorkInProgressReceivedUpdate();
                }
                hook.memoizedState = newState;
                if (hook.baseQueue === null) {
                    hook.baseState = newState;
                }
                queue.lastRenderedState = newState;
            }
            return [
                newState,
                dispatch
            ];
        }
        function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
            {
                warnAboutMultipleRenderersDEV(source);
            }
            var getVersion = source._getVersion;
            var version = getVersion(source._source);
            var isSafeToReadFromSource = false;
            var currentRenderVersion = getWorkInProgressVersion(source);
            if (currentRenderVersion !== null) {
                isSafeToReadFromSource = currentRenderVersion === version;
            } else {
                isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);
                if (isSafeToReadFromSource) {
                    setWorkInProgressVersion(source, version);
                }
            }
            if (isSafeToReadFromSource) {
                var snapshot = getSnapshot(source._source);
                {
                    if (typeof snapshot === 'function') {
                        error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
                    }
                }
                return snapshot;
            } else {
                markSourceAsDirty(source);
                {
                    {
                        throw Error('Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.');
                    }
                }
            }
        }
        function useMutableSource(hook, source, getSnapshot, subscribe) {
            var root = getWorkInProgressRoot();
            if (!(root !== null)) {
                {
                    throw Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
                }
            }
            var getVersion = source._getVersion;
            var version = getVersion(source._source);
            var dispatcher = ReactCurrentDispatcher$1.current;
            var _dispatcher$useState = dispatcher.useState(function () {
                    return readFromUnsubcribedMutableSource(root, source, getSnapshot);
                }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
            var snapshot = currentSnapshot;
            var stateHook = workInProgressHook;
            var memoizedState = hook.memoizedState;
            var refs = memoizedState.refs;
            var prevGetSnapshot = refs.getSnapshot;
            var prevSource = memoizedState.source;
            var prevSubscribe = memoizedState.subscribe;
            var fiber = currentlyRenderingFiber$1;
            hook.memoizedState = {
                refs: refs,
                source: source,
                subscribe: subscribe
            };
            dispatcher.useEffect(function () {
                refs.getSnapshot = getSnapshot;
                refs.setSnapshot = setSnapshot;
                var maybeNewVersion = getVersion(source._source);
                if (!objectIs(version, maybeNewVersion)) {
                    var maybeNewSnapshot = getSnapshot(source._source);
                    {
                        if (typeof maybeNewSnapshot === 'function') {
                            error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
                        }
                    }
                    if (!objectIs(snapshot, maybeNewSnapshot)) {
                        setSnapshot(maybeNewSnapshot);
                        var lane = requestUpdateLane(fiber);
                        markRootMutableRead(root, lane);
                    }
                    markRootEntangled(root, root.mutableReadLanes);
                }
            }, [
                getSnapshot,
                source,
                subscribe
            ]);
            dispatcher.useEffect(function () {
                var handleChange = function () {
                    var latestGetSnapshot = refs.getSnapshot;
                    var latestSetSnapshot = refs.setSnapshot;
                    try {
                        latestSetSnapshot(latestGetSnapshot(source._source));
                        var lane = requestUpdateLane(fiber);
                        markRootMutableRead(root, lane);
                    } catch (error) {
                        latestSetSnapshot(function () {
                            throw error;
                        });
                    }
                };
                var unsubscribe = subscribe(source._source, handleChange);
                {
                    if (typeof unsubscribe !== 'function') {
                        error('Mutable source subscribe function must return an unsubscribe function.');
                    }
                }
                return unsubscribe;
            }, [
                source,
                subscribe
            ]);
            if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
                var newQueue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: basicStateReducer,
                    lastRenderedState: snapshot
                };
                newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
                stateHook.queue = newQueue;
                stateHook.baseQueue = null;
                snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
                stateHook.memoizedState = stateHook.baseState = snapshot;
            }
            return snapshot;
        }
        function mountMutableSource(source, getSnapshot, subscribe) {
            var hook = mountWorkInProgressHook();
            hook.memoizedState = {
                refs: {
                    getSnapshot: getSnapshot,
                    setSnapshot: null
                },
                source: source,
                subscribe: subscribe
            };
            return useMutableSource(hook, source, getSnapshot, subscribe);
        }
        function updateMutableSource(source, getSnapshot, subscribe) {
            var hook = updateWorkInProgressHook();
            return useMutableSource(hook, source, getSnapshot, subscribe);
        }
        function mountState(initialState) {
            var hook = mountWorkInProgressHook();
            if (typeof initialState === 'function') {
                initialState = initialState();
            }
            hook.memoizedState = hook.baseState = initialState;
            var queue = hook.queue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialState
            };
            var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
            return [
                hook.memoizedState,
                dispatch
            ];
        }
        function updateState(initialState) {
            return updateReducer(basicStateReducer);
        }
        function rerenderState(initialState) {
            return rerenderReducer(basicStateReducer);
        }
        function pushEffect(tag, create, destroy, deps) {
            var effect = {
                tag: tag,
                create: create,
                destroy: destroy,
                deps: deps,
                next: null
            };
            var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
            if (componentUpdateQueue === null) {
                componentUpdateQueue = createFunctionComponentUpdateQueue();
                currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
                componentUpdateQueue.lastEffect = effect.next = effect;
            } else {
                var lastEffect = componentUpdateQueue.lastEffect;
                if (lastEffect === null) {
                    componentUpdateQueue.lastEffect = effect.next = effect;
                } else {
                    var firstEffect = lastEffect.next;
                    lastEffect.next = effect;
                    effect.next = firstEffect;
                    componentUpdateQueue.lastEffect = effect;
                }
            }
            return effect;
        }
        function mountRef(initialValue) {
            var hook = mountWorkInProgressHook();
            var ref = { current: initialValue };
            {
                Object.seal(ref);
            }
            hook.memoizedState = ref;
            return ref;
        }
        function updateRef(initialValue) {
            var hook = updateWorkInProgressHook();
            return hook.memoizedState;
        }
        function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
            var hook = mountWorkInProgressHook();
            var nextDeps = deps === undefined ? null : deps;
            currentlyRenderingFiber$1.flags |= fiberFlags;
            hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
        }
        function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
            var hook = updateWorkInProgressHook();
            var nextDeps = deps === undefined ? null : deps;
            var destroy = undefined;
            if (currentHook !== null) {
                var prevEffect = currentHook.memoizedState;
                destroy = prevEffect.destroy;
                if (nextDeps !== null) {
                    var prevDeps = prevEffect.deps;
                    if (areHookInputsEqual(nextDeps, prevDeps)) {
                        pushEffect(hookFlags, create, destroy, nextDeps);
                        return;
                    }
                }
            }
            currentlyRenderingFiber$1.flags |= fiberFlags;
            hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
        }
        function mountEffect(create, deps) {
            {
                if ('undefined' !== typeof jest) {
                    warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
                }
            }
            return mountEffectImpl(Update | Passive, Passive$1, create, deps);
        }
        function updateEffect(create, deps) {
            {
                if ('undefined' !== typeof jest) {
                    warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
                }
            }
            return updateEffectImpl(Update | Passive, Passive$1, create, deps);
        }
        function mountLayoutEffect(create, deps) {
            return mountEffectImpl(Update, Layout, create, deps);
        }
        function updateLayoutEffect(create, deps) {
            return updateEffectImpl(Update, Layout, create, deps);
        }
        function imperativeHandleEffect(create, ref) {
            if (typeof ref === 'function') {
                var refCallback = ref;
                var _inst = create();
                refCallback(_inst);
                return function () {
                    refCallback(null);
                };
            } else if (ref !== null && ref !== undefined) {
                var refObject = ref;
                {
                    if (!refObject.hasOwnProperty('current')) {
                        error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
                    }
                }
                var _inst2 = create();
                refObject.current = _inst2;
                return function () {
                    refObject.current = null;
                };
            }
        }
        function mountImperativeHandle(ref, create, deps) {
            {
                if (typeof create !== 'function') {
                    error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
                }
            }
            var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
            return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
        }
        function updateImperativeHandle(ref, create, deps) {
            {
                if (typeof create !== 'function') {
                    error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
                }
            }
            var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
            return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
        }
        function mountDebugValue(value, formatterFn) {
        }
        var updateDebugValue = mountDebugValue;
        function mountCallback(callback, deps) {
            var hook = mountWorkInProgressHook();
            var nextDeps = deps === undefined ? null : deps;
            hook.memoizedState = [
                callback,
                nextDeps
            ];
            return callback;
        }
        function updateCallback(callback, deps) {
            var hook = updateWorkInProgressHook();
            var nextDeps = deps === undefined ? null : deps;
            var prevState = hook.memoizedState;
            if (prevState !== null) {
                if (nextDeps !== null) {
                    var prevDeps = prevState[1];
                    if (areHookInputsEqual(nextDeps, prevDeps)) {
                        return prevState[0];
                    }
                }
            }
            hook.memoizedState = [
                callback,
                nextDeps
            ];
            return callback;
        }
        function mountMemo(nextCreate, deps) {
            var hook = mountWorkInProgressHook();
            var nextDeps = deps === undefined ? null : deps;
            var nextValue = nextCreate();
            hook.memoizedState = [
                nextValue,
                nextDeps
            ];
            return nextValue;
        }
        function updateMemo(nextCreate, deps) {
            var hook = updateWorkInProgressHook();
            var nextDeps = deps === undefined ? null : deps;
            var prevState = hook.memoizedState;
            if (prevState !== null) {
                if (nextDeps !== null) {
                    var prevDeps = prevState[1];
                    if (areHookInputsEqual(nextDeps, prevDeps)) {
                        return prevState[0];
                    }
                }
            }
            var nextValue = nextCreate();
            hook.memoizedState = [
                nextValue,
                nextDeps
            ];
            return nextValue;
        }
        function mountDeferredValue(value) {
            var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
            mountEffect(function () {
                var prevTransition = ReactCurrentBatchConfig$1.transition;
                ReactCurrentBatchConfig$1.transition = 1;
                try {
                    setValue(value);
                } finally {
                    ReactCurrentBatchConfig$1.transition = prevTransition;
                }
            }, [value]);
            return prevValue;
        }
        function updateDeferredValue(value) {
            var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
            updateEffect(function () {
                var prevTransition = ReactCurrentBatchConfig$1.transition;
                ReactCurrentBatchConfig$1.transition = 1;
                try {
                    setValue(value);
                } finally {
                    ReactCurrentBatchConfig$1.transition = prevTransition;
                }
            }, [value]);
            return prevValue;
        }
        function rerenderDeferredValue(value) {
            var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
            updateEffect(function () {
                var prevTransition = ReactCurrentBatchConfig$1.transition;
                ReactCurrentBatchConfig$1.transition = 1;
                try {
                    setValue(value);
                } finally {
                    ReactCurrentBatchConfig$1.transition = prevTransition;
                }
            }, [value]);
            return prevValue;
        }
        function startTransition(setPending, callback) {
            var priorityLevel = getCurrentPriorityLevel();
            {
                runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function () {
                    setPending(true);
                });
                runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function () {
                    var prevTransition = ReactCurrentBatchConfig$1.transition;
                    ReactCurrentBatchConfig$1.transition = 1;
                    try {
                        setPending(false);
                        callback();
                    } finally {
                        ReactCurrentBatchConfig$1.transition = prevTransition;
                    }
                });
            }
        }
        function mountTransition() {
            var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
            var start = startTransition.bind(null, setPending);
            mountRef(start);
            return [
                start,
                isPending
            ];
        }
        function updateTransition() {
            var _updateState2 = updateState(), isPending = _updateState2[0];
            var startRef = updateRef();
            var start = startRef.current;
            return [
                start,
                isPending
            ];
        }
        function rerenderTransition() {
            var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
            var startRef = updateRef();
            var start = startRef.current;
            return [
                start,
                isPending
            ];
        }
        var isUpdatingOpaqueValueInRenderPhase = false;
        function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
            {
                return isUpdatingOpaqueValueInRenderPhase;
            }
        }
        function warnOnOpaqueIdentifierAccessInDEV(fiber) {
            {
                var name = getComponentName(fiber.type) || 'Unknown';
                if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
                    error('The object passed back from useOpaqueIdentifier is meant to be ' + 'passed through to attributes only. Do not read the ' + 'value directly.');
                    didWarnAboutUseOpaqueIdentifier[name] = true;
                }
            }
        }
        function mountOpaqueIdentifier() {
            var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
            if (getIsHydrating()) {
                var didUpgrade = false;
                var fiber = currentlyRenderingFiber$1;
                var readValue = function () {
                    if (!didUpgrade) {
                        didUpgrade = true;
                        {
                            isUpdatingOpaqueValueInRenderPhase = true;
                            setId(makeId());
                            isUpdatingOpaqueValueInRenderPhase = false;
                            warnOnOpaqueIdentifierAccessInDEV(fiber);
                        }
                    }
                    {
                        {
                            throw Error('The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.');
                        }
                    }
                };
                var id = makeOpaqueHydratingObject(readValue);
                var setId = mountState(id)[1];
                if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
                    currentlyRenderingFiber$1.flags |= Update | Passive;
                    pushEffect(HasEffect | Passive$1, function () {
                        setId(makeId());
                    }, undefined, null);
                }
                return id;
            } else {
                var _id = makeId();
                mountState(_id);
                return _id;
            }
        }
        function updateOpaqueIdentifier() {
            var id = updateState()[0];
            return id;
        }
        function rerenderOpaqueIdentifier() {
            var id = rerenderState()[0];
            return id;
        }
        function dispatchAction(fiber, queue, action) {
            {
                if (typeof arguments[3] === 'function') {
                    error('State updates from the useState() and useReducer() Hooks don\'t support the ' + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
                }
            }
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = {
                lane: lane,
                action: action,
                eagerReducer: null,
                eagerState: null,
                next: null
            };
            var pending = queue.pending;
            if (pending === null) {
                update.next = update;
            } else {
                update.next = pending.next;
                pending.next = update;
            }
            queue.pending = update;
            var alternate = fiber.alternate;
            if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
                didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
            } else {
                if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                    var lastRenderedReducer = queue.lastRenderedReducer;
                    if (lastRenderedReducer !== null) {
                        var prevDispatcher;
                        {
                            prevDispatcher = ReactCurrentDispatcher$1.current;
                            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                        }
                        try {
                            var currentState = queue.lastRenderedState;
                            var eagerState = lastRenderedReducer(currentState, action);
                            update.eagerReducer = lastRenderedReducer;
                            update.eagerState = eagerState;
                            if (objectIs(eagerState, currentState)) {
                                return;
                            }
                        } catch (error) {
                        } finally {
                            {
                                ReactCurrentDispatcher$1.current = prevDispatcher;
                            }
                        }
                    }
                }
                {
                    if ('undefined' !== typeof jest) {
                        warnIfNotScopedWithMatchingAct(fiber);
                        warnIfNotCurrentlyActingUpdatesInDev(fiber);
                    }
                }
                scheduleUpdateOnFiber(fiber, lane, eventTime);
            }
        }
        var ContextOnlyDispatcher = {
            readContext: readContext,
            useCallback: throwInvalidHookError,
            useContext: throwInvalidHookError,
            useEffect: throwInvalidHookError,
            useImperativeHandle: throwInvalidHookError,
            useLayoutEffect: throwInvalidHookError,
            useMemo: throwInvalidHookError,
            useReducer: throwInvalidHookError,
            useRef: throwInvalidHookError,
            useState: throwInvalidHookError,
            useDebugValue: throwInvalidHookError,
            useDeferredValue: throwInvalidHookError,
            useTransition: throwInvalidHookError,
            useMutableSource: throwInvalidHookError,
            useOpaqueIdentifier: throwInvalidHookError,
            unstable_isNewReconciler: enableNewReconciler
        };
        var HooksDispatcherOnMountInDEV = null;
        var HooksDispatcherOnMountWithHookTypesInDEV = null;
        var HooksDispatcherOnUpdateInDEV = null;
        var HooksDispatcherOnRerenderInDEV = null;
        var InvalidNestedHooksDispatcherOnMountInDEV = null;
        var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
        var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
        {
            var warnInvalidContextAccess = function () {
                error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
            };
            var warnInvalidHookAccess = function () {
                error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
            };
            HooksDispatcherOnMountInDEV = {
                readContext: function (context, observedBits) {
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    mountHookTypesDev();
                    checkDepsAreArrayDev(deps);
                    return mountCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    mountHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    mountHookTypesDev();
                    checkDepsAreArrayDev(deps);
                    return mountEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    mountHookTypesDev();
                    checkDepsAreArrayDev(deps);
                    return mountImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    mountHookTypesDev();
                    checkDepsAreArrayDev(deps);
                    return mountLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    mountHookTypesDev();
                    checkDepsAreArrayDev(deps);
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    mountHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    mountHookTypesDev();
                    return mountRef(initialValue);
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    mountHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    mountHookTypesDev();
                    return mountDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    mountHookTypesDev();
                    return mountDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    mountHookTypesDev();
                    return mountTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    mountHookTypesDev();
                    return mountMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    mountHookTypesDev();
                    return mountOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
            HooksDispatcherOnMountWithHookTypesInDEV = {
                readContext: function (context, observedBits) {
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    updateHookTypesDev();
                    return mountCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    updateHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    updateHookTypesDev();
                    return mountEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    updateHookTypesDev();
                    return mountImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    updateHookTypesDev();
                    return mountLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    updateHookTypesDev();
                    return mountRef(initialValue);
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    updateHookTypesDev();
                    return mountDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    updateHookTypesDev();
                    return mountDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    updateHookTypesDev();
                    return mountTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    updateHookTypesDev();
                    return mountMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    updateHookTypesDev();
                    return mountOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
            HooksDispatcherOnUpdateInDEV = {
                readContext: function (context, observedBits) {
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    updateHookTypesDev();
                    return updateCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    updateHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    updateHookTypesDev();
                    return updateEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    updateHookTypesDev();
                    return updateImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    updateHookTypesDev();
                    return updateLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    updateHookTypesDev();
                    return updateRef();
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    updateHookTypesDev();
                    return updateDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    updateHookTypesDev();
                    return updateDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    updateHookTypesDev();
                    return updateTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    updateHookTypesDev();
                    return updateMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    updateHookTypesDev();
                    return updateOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
            HooksDispatcherOnRerenderInDEV = {
                readContext: function (context, observedBits) {
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    updateHookTypesDev();
                    return updateCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    updateHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    updateHookTypesDev();
                    return updateEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    updateHookTypesDev();
                    return updateImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    updateHookTypesDev();
                    return updateLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
                    try {
                        return updateMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
                    try {
                        return rerenderReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    updateHookTypesDev();
                    return updateRef();
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
                    try {
                        return rerenderState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    updateHookTypesDev();
                    return updateDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    updateHookTypesDev();
                    return rerenderDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    updateHookTypesDev();
                    return rerenderTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    updateHookTypesDev();
                    return updateMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    updateHookTypesDev();
                    return rerenderOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
            InvalidNestedHooksDispatcherOnMountInDEV = {
                readContext: function (context, observedBits) {
                    warnInvalidContextAccess();
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountRef(initialValue);
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
                    try {
                        return mountState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    warnInvalidHookAccess();
                    mountHookTypesDev();
                    return mountOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
            InvalidNestedHooksDispatcherOnUpdateInDEV = {
                readContext: function (context, observedBits) {
                    warnInvalidContextAccess();
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateRef();
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
            InvalidNestedHooksDispatcherOnRerenderInDEV = {
                readContext: function (context, observedBits) {
                    warnInvalidContextAccess();
                    return readContext(context, observedBits);
                },
                useCallback: function (callback, deps) {
                    currentHookNameInDev = 'useCallback';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateCallback(callback, deps);
                },
                useContext: function (context, observedBits) {
                    currentHookNameInDev = 'useContext';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return readContext(context, observedBits);
                },
                useEffect: function (create, deps) {
                    currentHookNameInDev = 'useEffect';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateEffect(create, deps);
                },
                useImperativeHandle: function (ref, create, deps) {
                    currentHookNameInDev = 'useImperativeHandle';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateImperativeHandle(ref, create, deps);
                },
                useLayoutEffect: function (create, deps) {
                    currentHookNameInDev = 'useLayoutEffect';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateLayoutEffect(create, deps);
                },
                useMemo: function (create, deps) {
                    currentHookNameInDev = 'useMemo';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return updateMemo(create, deps);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useReducer: function (reducer, initialArg, init) {
                    currentHookNameInDev = 'useReducer';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return rerenderReducer(reducer, initialArg, init);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useRef: function (initialValue) {
                    currentHookNameInDev = 'useRef';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateRef();
                },
                useState: function (initialState) {
                    currentHookNameInDev = 'useState';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    var prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        return rerenderState(initialState);
                    } finally {
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                },
                useDebugValue: function (value, formatterFn) {
                    currentHookNameInDev = 'useDebugValue';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateDebugValue();
                },
                useDeferredValue: function (value) {
                    currentHookNameInDev = 'useDeferredValue';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return rerenderDeferredValue(value);
                },
                useTransition: function () {
                    currentHookNameInDev = 'useTransition';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return rerenderTransition();
                },
                useMutableSource: function (source, getSnapshot, subscribe) {
                    currentHookNameInDev = 'useMutableSource';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return updateMutableSource(source, getSnapshot, subscribe);
                },
                useOpaqueIdentifier: function () {
                    currentHookNameInDev = 'useOpaqueIdentifier';
                    warnInvalidHookAccess();
                    updateHookTypesDev();
                    return rerenderOpaqueIdentifier();
                },
                unstable_isNewReconciler: enableNewReconciler
            };
        }
        var now$1 = Scheduler.unstable_now;
        var commitTime = 0;
        var profilerStartTime = -1;
        function getCommitTime() {
            return commitTime;
        }
        function recordCommitTime() {
            commitTime = now$1();
        }
        function startProfilerTimer(fiber) {
            profilerStartTime = now$1();
            if (fiber.actualStartTime < 0) {
                fiber.actualStartTime = now$1();
            }
        }
        function stopProfilerTimerIfRunning(fiber) {
            profilerStartTime = -1;
        }
        function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
            if (profilerStartTime >= 0) {
                var elapsedTime = now$1() - profilerStartTime;
                fiber.actualDuration += elapsedTime;
                if (overrideBaseTime) {
                    fiber.selfBaseDuration = elapsedTime;
                }
                profilerStartTime = -1;
            }
        }
        function transferActualDuration(fiber) {
            var child = fiber.child;
            while (child) {
                fiber.actualDuration += child.actualDuration;
                child = child.sibling;
            }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var didReceiveUpdate = false;
        var didWarnAboutBadClass;
        var didWarnAboutModulePatternComponent;
        var didWarnAboutContextTypeOnFunctionComponent;
        var didWarnAboutGetDerivedStateOnFunctionComponent;
        var didWarnAboutFunctionRefs;
        var didWarnAboutReassigningProps;
        var didWarnAboutRevealOrder;
        var didWarnAboutTailOptions;
        {
            didWarnAboutBadClass = {};
            didWarnAboutModulePatternComponent = {};
            didWarnAboutContextTypeOnFunctionComponent = {};
            didWarnAboutGetDerivedStateOnFunctionComponent = {};
            didWarnAboutFunctionRefs = {};
            didWarnAboutReassigningProps = false;
            didWarnAboutRevealOrder = {};
            didWarnAboutTailOptions = {};
        }
        function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
            if (current === null) {
                workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            } else {
                workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
            }
        }
        function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
            workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes);
            workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        }
        function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
            {
                if (workInProgress.type !== workInProgress.elementType) {
                    var innerPropTypes = Component.propTypes;
                    if (innerPropTypes) {
                        checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
                    }
                }
            }
            var render = Component.render;
            var ref = workInProgress.ref;
            var nextChildren;
            prepareToReadContext(workInProgress, renderLanes);
            {
                ReactCurrentOwner$1.current = workInProgress;
                setIsRendering(true);
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                if (workInProgress.mode & StrictMode) {
                    disableLogs();
                    try {
                        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                    } finally {
                        reenableLogs();
                    }
                }
                setIsRendering(false);
            }
            if (current !== null && !didReceiveUpdate) {
                bailoutHooks(current, workInProgress, renderLanes);
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
            workInProgress.flags |= PerformedWork;
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
            if (current === null) {
                var type = Component.type;
                if (isSimpleFunctionComponent(type) && Component.compare === null && Component.defaultProps === undefined) {
                    var resolvedType = type;
                    {
                        resolvedType = resolveFunctionForHotReloading(type);
                    }
                    workInProgress.tag = SimpleMemoComponent;
                    workInProgress.type = resolvedType;
                    {
                        validateFunctionComponentInDev(workInProgress, type);
                    }
                    return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
                }
                {
                    var innerPropTypes = type.propTypes;
                    if (innerPropTypes) {
                        checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(type));
                    }
                }
                var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
                child.ref = workInProgress.ref;
                child.return = workInProgress;
                workInProgress.child = child;
                return child;
            }
            {
                var _type = Component.type;
                var _innerPropTypes = _type.propTypes;
                if (_innerPropTypes) {
                    checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentName(_type));
                }
            }
            var currentChild = current.child;
            if (!includesSomeLane(updateLanes, renderLanes)) {
                var prevProps = currentChild.memoizedProps;
                var compare = Component.compare;
                compare = compare !== null ? compare : shallowEqual;
                if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                }
            }
            workInProgress.flags |= PerformedWork;
            var newChild = createWorkInProgress(currentChild, nextProps);
            newChild.ref = workInProgress.ref;
            newChild.return = workInProgress;
            workInProgress.child = newChild;
            return newChild;
        }
        function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
            {
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerMemoType = workInProgress.elementType;
                    if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                        var lazyComponent = outerMemoType;
                        var payload = lazyComponent._payload;
                        var init = lazyComponent._init;
                        try {
                            outerMemoType = init(payload);
                        } catch (x) {
                            outerMemoType = null;
                        }
                        var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                        if (outerPropTypes) {
                            checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentName(outerMemoType));
                        }
                    }
                }
            }
            if (current !== null) {
                var prevProps = current.memoizedProps;
                if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                    didReceiveUpdate = false;
                    if (!includesSomeLane(renderLanes, updateLanes)) {
                        workInProgress.lanes = current.lanes;
                        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                        didReceiveUpdate = true;
                    }
                }
            }
            return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
        }
        function updateOffscreenComponent(current, workInProgress, renderLanes) {
            var nextProps = workInProgress.pendingProps;
            var nextChildren = nextProps.children;
            var prevState = current !== null ? current.memoizedState : null;
            if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
                if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                    var nextState = { baseLanes: NoLanes };
                    workInProgress.memoizedState = nextState;
                    pushRenderLanes(workInProgress, renderLanes);
                } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                    var nextBaseLanes;
                    if (prevState !== null) {
                        var prevBaseLanes = prevState.baseLanes;
                        nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                    } else {
                        nextBaseLanes = renderLanes;
                    }
                    {
                        markSpawnedWork(OffscreenLane);
                    }
                    workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                    var _nextState = { baseLanes: nextBaseLanes };
                    workInProgress.memoizedState = _nextState;
                    pushRenderLanes(workInProgress, nextBaseLanes);
                    return null;
                } else {
                    var _nextState2 = { baseLanes: NoLanes };
                    workInProgress.memoizedState = _nextState2;
                    var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                    pushRenderLanes(workInProgress, subtreeRenderLanes);
                }
            } else {
                var _subtreeRenderLanes;
                if (prevState !== null) {
                    _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                    workInProgress.memoizedState = null;
                } else {
                    _subtreeRenderLanes = renderLanes;
                }
                pushRenderLanes(workInProgress, _subtreeRenderLanes);
            }
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        var updateLegacyHiddenComponent = updateOffscreenComponent;
        function updateFragment(current, workInProgress, renderLanes) {
            var nextChildren = workInProgress.pendingProps;
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        function updateMode(current, workInProgress, renderLanes) {
            var nextChildren = workInProgress.pendingProps.children;
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        function updateProfiler(current, workInProgress, renderLanes) {
            {
                workInProgress.flags |= Update;
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
            }
            var nextProps = workInProgress.pendingProps;
            var nextChildren = nextProps.children;
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        function markRef(current, workInProgress) {
            var ref = workInProgress.ref;
            if (current === null && ref !== null || current !== null && current.ref !== ref) {
                workInProgress.flags |= Ref;
            }
        }
        function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
            {
                if (workInProgress.type !== workInProgress.elementType) {
                    var innerPropTypes = Component.propTypes;
                    if (innerPropTypes) {
                        checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
                    }
                }
            }
            var context;
            {
                var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
                context = getMaskedContext(workInProgress, unmaskedContext);
            }
            var nextChildren;
            prepareToReadContext(workInProgress, renderLanes);
            {
                ReactCurrentOwner$1.current = workInProgress;
                setIsRendering(true);
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                if (workInProgress.mode & StrictMode) {
                    disableLogs();
                    try {
                        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                    } finally {
                        reenableLogs();
                    }
                }
                setIsRendering(false);
            }
            if (current !== null && !didReceiveUpdate) {
                bailoutHooks(current, workInProgress, renderLanes);
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
            workInProgress.flags |= PerformedWork;
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
            {
                if (workInProgress.type !== workInProgress.elementType) {
                    var innerPropTypes = Component.propTypes;
                    if (innerPropTypes) {
                        checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
                    }
                }
            }
            var hasContext;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else {
                hasContext = false;
            }
            prepareToReadContext(workInProgress, renderLanes);
            var instance = workInProgress.stateNode;
            var shouldUpdate;
            if (instance === null) {
                if (current !== null) {
                    current.alternate = null;
                    workInProgress.alternate = null;
                    workInProgress.flags |= Placement;
                }
                constructClassInstance(workInProgress, Component, nextProps);
                mountClassInstance(workInProgress, Component, nextProps, renderLanes);
                shouldUpdate = true;
            } else if (current === null) {
                shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
            } else {
                shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
            }
            var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
            {
                var inst = workInProgress.stateNode;
                if (shouldUpdate && inst.props !== nextProps) {
                    if (!didWarnAboutReassigningProps) {
                        error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
                    }
                    didWarnAboutReassigningProps = true;
                }
            }
            return nextUnitOfWork;
        }
        function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
            markRef(current, workInProgress);
            var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
            if (!shouldUpdate && !didCaptureError) {
                if (hasContext) {
                    invalidateContextProvider(workInProgress, Component, false);
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
            var instance = workInProgress.stateNode;
            ReactCurrentOwner$1.current = workInProgress;
            var nextChildren;
            if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
                nextChildren = null;
                {
                    stopProfilerTimerIfRunning();
                }
            } else {
                {
                    setIsRendering(true);
                    nextChildren = instance.render();
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            instance.render();
                        } finally {
                            reenableLogs();
                        }
                    }
                    setIsRendering(false);
                }
            }
            workInProgress.flags |= PerformedWork;
            if (current !== null && didCaptureError) {
                forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
            } else {
                reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            }
            workInProgress.memoizedState = instance.state;
            if (hasContext) {
                invalidateContextProvider(workInProgress, Component, true);
            }
            return workInProgress.child;
        }
        function pushHostRootContext(workInProgress) {
            var root = workInProgress.stateNode;
            if (root.pendingContext) {
                pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
            } else if (root.context) {
                pushTopLevelContextObject(workInProgress, root.context, false);
            }
            pushHostContainer(workInProgress, root.containerInfo);
        }
        function updateHostRoot(current, workInProgress, renderLanes) {
            pushHostRootContext(workInProgress);
            var updateQueue = workInProgress.updateQueue;
            if (!(current !== null && updateQueue !== null)) {
                {
                    throw Error('If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
            var nextProps = workInProgress.pendingProps;
            var prevState = workInProgress.memoizedState;
            var prevChildren = prevState !== null ? prevState.element : null;
            cloneUpdateQueue(current, workInProgress);
            processUpdateQueue(workInProgress, nextProps, null, renderLanes);
            var nextState = workInProgress.memoizedState;
            var nextChildren = nextState.element;
            if (nextChildren === prevChildren) {
                resetHydrationState();
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
            var root = workInProgress.stateNode;
            if (root.hydrate && enterHydrationState(workInProgress)) {
                {
                    var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;
                    if (mutableSourceEagerHydrationData != null) {
                        for (var i = 0; i < mutableSourceEagerHydrationData.length; i += 2) {
                            var mutableSource = mutableSourceEagerHydrationData[i];
                            var version = mutableSourceEagerHydrationData[i + 1];
                            setWorkInProgressVersion(mutableSource, version);
                        }
                    }
                }
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while (node) {
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            } else {
                reconcileChildren(current, workInProgress, nextChildren, renderLanes);
                resetHydrationState();
            }
            return workInProgress.child;
        }
        function updateHostComponent(current, workInProgress, renderLanes) {
            pushHostContext(workInProgress);
            if (current === null) {
                tryToClaimNextHydratableInstance(workInProgress);
            }
            var type = workInProgress.type;
            var nextProps = workInProgress.pendingProps;
            var prevProps = current !== null ? current.memoizedProps : null;
            var nextChildren = nextProps.children;
            var isDirectTextChild = shouldSetTextContent(type, nextProps);
            if (isDirectTextChild) {
                nextChildren = null;
            } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
                workInProgress.flags |= ContentReset;
            }
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            return workInProgress.child;
        }
        function updateHostText(current, workInProgress) {
            if (current === null) {
                tryToClaimNextHydratableInstance(workInProgress);
            }
            return null;
        }
        function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
            if (_current !== null) {
                _current.alternate = null;
                workInProgress.alternate = null;
                workInProgress.flags |= Placement;
            }
            var props = workInProgress.pendingProps;
            var lazyComponent = elementType;
            var payload = lazyComponent._payload;
            var init = lazyComponent._init;
            var Component = init(payload);
            workInProgress.type = Component;
            var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
            var resolvedProps = resolveDefaultProps(Component, props);
            var child;
            switch (resolvedTag) {
            case FunctionComponent: {
                    {
                        validateFunctionComponentInDev(workInProgress, Component);
                        workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                    }
                    child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                    return child;
                }
            case ClassComponent: {
                    {
                        workInProgress.type = Component = resolveClassForHotReloading(Component);
                    }
                    child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                    return child;
                }
            case ForwardRef: {
                    {
                        workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                    }
                    child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                    return child;
                }
            case MemoComponent: {
                    {
                        if (workInProgress.type !== workInProgress.elementType) {
                            var outerPropTypes = Component.propTypes;
                            if (outerPropTypes) {
                                checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentName(Component));
                            }
                        }
                    }
                    child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateLanes, renderLanes);
                    return child;
                }
            }
            var hint = '';
            {
                if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
                    hint = ' Did you wrap a component in React.lazy() more than once?';
                }
            }
            {
                {
                    throw Error('Element type is invalid. Received a promise that resolves to: ' + Component + '. Lazy element type must resolve to a class or function.' + hint);
                }
            }
        }
        function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
            if (_current !== null) {
                _current.alternate = null;
                workInProgress.alternate = null;
                workInProgress.flags |= Placement;
            }
            workInProgress.tag = ClassComponent;
            var hasContext;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else {
                hasContext = false;
            }
            prepareToReadContext(workInProgress, renderLanes);
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        }
        function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
            if (_current !== null) {
                _current.alternate = null;
                workInProgress.alternate = null;
                workInProgress.flags |= Placement;
            }
            var props = workInProgress.pendingProps;
            var context;
            {
                var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
                context = getMaskedContext(workInProgress, unmaskedContext);
            }
            prepareToReadContext(workInProgress, renderLanes);
            var value;
            {
                if (Component.prototype && typeof Component.prototype.render === 'function') {
                    var componentName = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutBadClass[componentName]) {
                        error('The <%s /> component appears to have a render method, but doesn\'t extend React.Component. ' + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
                        didWarnAboutBadClass[componentName] = true;
                    }
                }
                if (workInProgress.mode & StrictMode) {
                    ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
                }
                setIsRendering(true);
                ReactCurrentOwner$1.current = workInProgress;
                value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                setIsRendering(false);
            }
            workInProgress.flags |= PerformedWork;
            {
                if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
                    var _componentName = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutModulePatternComponent[_componentName]) {
                        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + 'If you can\'t use a class try assigning the prototype on the function as a workaround. ' + '`%s.prototype = React.Component.prototype`. Don\'t use an arrow function since it ' + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
                        didWarnAboutModulePatternComponent[_componentName] = true;
                    }
                }
            }
            if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
                {
                    var _componentName2 = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutModulePatternComponent[_componentName2]) {
                        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + 'If you can\'t use a class try assigning the prototype on the function as a workaround. ' + '`%s.prototype = React.Component.prototype`. Don\'t use an arrow function since it ' + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);
                        didWarnAboutModulePatternComponent[_componentName2] = true;
                    }
                }
                workInProgress.tag = ClassComponent;
                workInProgress.memoizedState = null;
                workInProgress.updateQueue = null;
                var hasContext = false;
                if (isContextProvider(Component)) {
                    hasContext = true;
                    pushContextProvider(workInProgress);
                } else {
                    hasContext = false;
                }
                workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
                initializeUpdateQueue(workInProgress);
                var getDerivedStateFromProps = Component.getDerivedStateFromProps;
                if (typeof getDerivedStateFromProps === 'function') {
                    applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
                }
                adoptClassInstance(workInProgress, value);
                mountClassInstance(workInProgress, Component, props, renderLanes);
                return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
            } else {
                workInProgress.tag = FunctionComponent;
                {
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                        } finally {
                            reenableLogs();
                        }
                    }
                }
                reconcileChildren(null, workInProgress, value, renderLanes);
                {
                    validateFunctionComponentInDev(workInProgress, Component);
                }
                return workInProgress.child;
            }
        }
        function validateFunctionComponentInDev(workInProgress, Component) {
            {
                if (Component) {
                    if (Component.childContextTypes) {
                        error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
                    }
                }
                if (workInProgress.ref !== null) {
                    var info = '';
                    var ownerName = getCurrentFiberOwnerNameInDevOrNull();
                    if (ownerName) {
                        info += '\n\nCheck the render method of `' + ownerName + '`.';
                    }
                    var warningKey = ownerName || workInProgress._debugID || '';
                    var debugSource = workInProgress._debugSource;
                    if (debugSource) {
                        warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
                    }
                    if (!didWarnAboutFunctionRefs[warningKey]) {
                        didWarnAboutFunctionRefs[warningKey] = true;
                        error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
                    }
                }
                if (typeof Component.getDerivedStateFromProps === 'function') {
                    var _componentName3 = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                        error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                        didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
                    }
                }
                if (typeof Component.contextType === 'object' && Component.contextType !== null) {
                    var _componentName4 = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                        error('%s: Function components do not support contextType.', _componentName4);
                        didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
                    }
                }
            }
        }
        var SUSPENDED_MARKER = {
            dehydrated: null,
            retryLane: NoLane
        };
        function mountSuspenseOffscreenState(renderLanes) {
            return { baseLanes: renderLanes };
        }
        function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
            return { baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes) };
        }
        function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
            if (current !== null) {
                var suspenseState = current.memoizedState;
                if (suspenseState === null) {
                    return false;
                }
            }
            return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        }
        function getRemainingWorkInPrimaryTree(current, renderLanes) {
            return removeLanes(current.childLanes, renderLanes);
        }
        function updateSuspenseComponent(current, workInProgress, renderLanes) {
            var nextProps = workInProgress.pendingProps;
            {
                if (shouldSuspend(workInProgress)) {
                    workInProgress.flags |= DidCapture;
                }
            }
            var suspenseContext = suspenseStackCursor.current;
            var showFallback = false;
            var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
            if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
                showFallback = true;
                workInProgress.flags &= ~DidCapture;
            } else {
                if (current === null || current.memoizedState !== null) {
                    if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
                        suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
                    }
                }
            }
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
            pushSuspenseContext(workInProgress, suspenseContext);
            if (current === null) {
                if (nextProps.fallback !== undefined) {
                    tryToClaimNextHydratableInstance(workInProgress);
                }
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                if (showFallback) {
                    var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                    var primaryChildFragment = workInProgress.child;
                    primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    return fallbackFragment;
                } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
                    var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                    var _primaryChildFragment = workInProgress.child;
                    _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    workInProgress.lanes = SomeRetryLane;
                    {
                        markSpawnedWork(SomeRetryLane);
                    }
                    return _fallbackFragment;
                } else {
                    return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
                }
            } else {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    if (showFallback) {
                        var _nextFallbackChildren2 = nextProps.fallback;
                        var _nextPrimaryChildren2 = nextProps.children;
                        var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);
                        var _primaryChildFragment3 = workInProgress.child;
                        var prevOffscreenState = current.child.memoizedState;
                        _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                        _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                        workInProgress.memoizedState = SUSPENDED_MARKER;
                        return _fallbackChildFragment;
                    } else {
                        var _nextPrimaryChildren3 = nextProps.children;
                        var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);
                        workInProgress.memoizedState = null;
                        return _primaryChildFragment4;
                    }
                } else {
                    if (showFallback) {
                        var _nextFallbackChildren3 = nextProps.fallback;
                        var _nextPrimaryChildren4 = nextProps.children;
                        var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);
                        var _primaryChildFragment5 = workInProgress.child;
                        var _prevOffscreenState = current.child.memoizedState;
                        _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
                        _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                        workInProgress.memoizedState = SUSPENDED_MARKER;
                        return _fallbackChildFragment2;
                    } else {
                        var _nextPrimaryChildren5 = nextProps.children;
                        var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);
                        workInProgress.memoizedState = null;
                        return _primaryChildFragment6;
                    }
                }
            }
        }
        function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
            var mode = workInProgress.mode;
            var primaryChildProps = {
                mode: 'visible',
                children: primaryChildren
            };
            var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
            primaryChildFragment.return = workInProgress;
            workInProgress.child = primaryChildFragment;
            return primaryChildFragment;
        }
        function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
            var mode = workInProgress.mode;
            var progressedPrimaryFragment = workInProgress.child;
            var primaryChildProps = {
                mode: 'hidden',
                children: primaryChildren
            };
            var primaryChildFragment;
            var fallbackChildFragment;
            if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
                primaryChildFragment = progressedPrimaryFragment;
                primaryChildFragment.childLanes = NoLanes;
                primaryChildFragment.pendingProps = primaryChildProps;
                if (workInProgress.mode & ProfileMode) {
                    primaryChildFragment.actualDuration = 0;
                    primaryChildFragment.actualStartTime = -1;
                    primaryChildFragment.selfBaseDuration = 0;
                    primaryChildFragment.treeBaseDuration = 0;
                }
                fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
            } else {
                primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
                fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
            }
            primaryChildFragment.return = workInProgress;
            fallbackChildFragment.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildFragment;
            workInProgress.child = primaryChildFragment;
            return fallbackChildFragment;
        }
        function createWorkInProgressOffscreenFiber(current, offscreenProps) {
            return createWorkInProgress(current, offscreenProps);
        }
        function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
            var currentPrimaryChildFragment = current.child;
            var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
            var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
                mode: 'visible',
                children: primaryChildren
            });
            if ((workInProgress.mode & BlockingMode) === NoMode) {
                primaryChildFragment.lanes = renderLanes;
            }
            primaryChildFragment.return = workInProgress;
            primaryChildFragment.sibling = null;
            if (currentFallbackChildFragment !== null) {
                currentFallbackChildFragment.nextEffect = null;
                currentFallbackChildFragment.flags = Deletion;
                workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
            }
            workInProgress.child = primaryChildFragment;
            return primaryChildFragment;
        }
        function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
            var mode = workInProgress.mode;
            var currentPrimaryChildFragment = current.child;
            var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
            var primaryChildProps = {
                mode: 'hidden',
                children: primaryChildren
            };
            var primaryChildFragment;
            if ((mode & BlockingMode) === NoMode && workInProgress.child !== currentPrimaryChildFragment) {
                var progressedPrimaryFragment = workInProgress.child;
                primaryChildFragment = progressedPrimaryFragment;
                primaryChildFragment.childLanes = NoLanes;
                primaryChildFragment.pendingProps = primaryChildProps;
                if (workInProgress.mode & ProfileMode) {
                    primaryChildFragment.actualDuration = 0;
                    primaryChildFragment.actualStartTime = -1;
                    primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                    primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
                }
                var progressedLastEffect = primaryChildFragment.lastEffect;
                if (progressedLastEffect !== null) {
                    workInProgress.firstEffect = primaryChildFragment.firstEffect;
                    workInProgress.lastEffect = progressedLastEffect;
                    progressedLastEffect.nextEffect = null;
                } else {
                    workInProgress.firstEffect = workInProgress.lastEffect = null;
                }
            } else {
                primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
            }
            var fallbackChildFragment;
            if (currentFallbackChildFragment !== null) {
                fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
            } else {
                fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
                fallbackChildFragment.flags |= Placement;
            }
            fallbackChildFragment.return = workInProgress;
            primaryChildFragment.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildFragment;
            workInProgress.child = primaryChildFragment;
            return fallbackChildFragment;
        }
        function scheduleWorkOnFiber(fiber, renderLanes) {
            fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
            var alternate = fiber.alternate;
            if (alternate !== null) {
                alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
            }
            scheduleWorkOnParentPath(fiber.return, renderLanes);
        }
        function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
            var node = firstChild;
            while (node !== null) {
                if (node.tag === SuspenseComponent) {
                    var state = node.memoizedState;
                    if (state !== null) {
                        scheduleWorkOnFiber(node, renderLanes);
                    }
                } else if (node.tag === SuspenseListComponent) {
                    scheduleWorkOnFiber(node, renderLanes);
                } else if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === workInProgress) {
                    return;
                }
                while (node.sibling === null) {
                    if (node.return === null || node.return === workInProgress) {
                        return;
                    }
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        function findLastContentRow(firstChild) {
            var row = firstChild;
            var lastContentRow = null;
            while (row !== null) {
                var currentRow = row.alternate;
                if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    lastContentRow = row;
                }
                row = row.sibling;
            }
            return lastContentRow;
        }
        function validateRevealOrder(revealOrder) {
            {
                if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
                    didWarnAboutRevealOrder[revealOrder] = true;
                    if (typeof revealOrder === 'string') {
                        switch (revealOrder.toLowerCase()) {
                        case 'together':
                        case 'forwards':
                        case 'backwards': {
                                error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                                break;
                            }
                        case 'forward':
                        case 'backward': {
                                error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                                break;
                            }
                        default:
                            error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                            break;
                        }
                    } else {
                        error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    }
                }
            }
        }
        function validateTailOptions(tailMode, revealOrder) {
            {
                if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
                    if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                        didWarnAboutTailOptions[tailMode] = true;
                        error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
                    } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                        didWarnAboutTailOptions[tailMode] = true;
                        error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
                    }
                }
            }
        }
        function validateSuspenseListNestedChild(childSlot, index) {
            {
                var isArray = Array.isArray(childSlot);
                var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
                if (isArray || isIterable) {
                    var type = isArray ? 'array' : 'iterable';
                    error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
                    return false;
                }
            }
            return true;
        }
        function validateSuspenseListChildren(children, revealOrder) {
            {
                if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
                    if (Array.isArray(children)) {
                        for (var i = 0; i < children.length; i++) {
                            if (!validateSuspenseListNestedChild(children[i], i)) {
                                return;
                            }
                        }
                    } else {
                        var iteratorFn = getIteratorFn(children);
                        if (typeof iteratorFn === 'function') {
                            var childrenIterator = iteratorFn.call(children);
                            if (childrenIterator) {
                                var step = childrenIterator.next();
                                var _i = 0;
                                for (; !step.done; step = childrenIterator.next()) {
                                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                                        return;
                                    }
                                    _i++;
                                }
                            }
                        } else {
                            error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
                        }
                    }
                }
            }
        }
        function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
            var renderState = workInProgress.memoizedState;
            if (renderState === null) {
                workInProgress.memoizedState = {
                    isBackwards: isBackwards,
                    rendering: null,
                    renderingStartTime: 0,
                    last: lastContentRow,
                    tail: tail,
                    tailMode: tailMode,
                    lastEffect: lastEffectBeforeRendering
                };
            } else {
                renderState.isBackwards = isBackwards;
                renderState.rendering = null;
                renderState.renderingStartTime = 0;
                renderState.last = lastContentRow;
                renderState.tail = tail;
                renderState.tailMode = tailMode;
                renderState.lastEffect = lastEffectBeforeRendering;
            }
        }
        function updateSuspenseListComponent(current, workInProgress, renderLanes) {
            var nextProps = workInProgress.pendingProps;
            var revealOrder = nextProps.revealOrder;
            var tailMode = nextProps.tail;
            var newChildren = nextProps.children;
            validateRevealOrder(revealOrder);
            validateTailOptions(tailMode, revealOrder);
            validateSuspenseListChildren(newChildren, revealOrder);
            reconcileChildren(current, workInProgress, newChildren, renderLanes);
            var suspenseContext = suspenseStackCursor.current;
            var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
            if (shouldForceFallback) {
                suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                workInProgress.flags |= DidCapture;
            } else {
                var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
                if (didSuspendBefore) {
                    propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
                }
                suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
            }
            pushSuspenseContext(workInProgress, suspenseContext);
            if ((workInProgress.mode & BlockingMode) === NoMode) {
                workInProgress.memoizedState = null;
            } else {
                switch (revealOrder) {
                case 'forwards': {
                        var lastContentRow = findLastContentRow(workInProgress.child);
                        var tail;
                        if (lastContentRow === null) {
                            tail = workInProgress.child;
                            workInProgress.child = null;
                        } else {
                            tail = lastContentRow.sibling;
                            lastContentRow.sibling = null;
                        }
                        initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                        break;
                    }
                case 'backwards': {
                        var _tail = null;
                        var row = workInProgress.child;
                        workInProgress.child = null;
                        while (row !== null) {
                            var currentRow = row.alternate;
                            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                                workInProgress.child = row;
                                break;
                            }
                            var nextRow = row.sibling;
                            row.sibling = _tail;
                            _tail = row;
                            row = nextRow;
                        }
                        initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                        break;
                    }
                case 'together': {
                        initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                        break;
                    }
                default: {
                        workInProgress.memoizedState = null;
                    }
                }
            }
            return workInProgress.child;
        }
        function updatePortalComponent(current, workInProgress, renderLanes) {
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            var nextChildren = workInProgress.pendingProps;
            if (current === null) {
                workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
            } else {
                reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            }
            return workInProgress.child;
        }
        var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
        function updateContextProvider(current, workInProgress, renderLanes) {
            var providerType = workInProgress.type;
            var context = providerType._context;
            var newProps = workInProgress.pendingProps;
            var oldProps = workInProgress.memoizedProps;
            var newValue = newProps.value;
            {
                if (!('value' in newProps)) {
                    if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                        hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                        error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
                    }
                }
                var providerPropTypes = workInProgress.type.propTypes;
                if (providerPropTypes) {
                    checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
                }
            }
            pushProvider(workInProgress, newValue);
            if (oldProps !== null) {
                var oldValue = oldProps.value;
                var changedBits = calculateChangedBits(context, newValue, oldValue);
                if (changedBits === 0) {
                    if (oldProps.children === newProps.children && !hasContextChanged()) {
                        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    }
                } else {
                    propagateContextChange(workInProgress, context, changedBits, renderLanes);
                }
            }
            var newChildren = newProps.children;
            reconcileChildren(current, workInProgress, newChildren, renderLanes);
            return workInProgress.child;
        }
        var hasWarnedAboutUsingContextAsConsumer = false;
        function updateContextConsumer(current, workInProgress, renderLanes) {
            var context = workInProgress.type;
            {
                if (context._context === undefined) {
                    if (context !== context.Consumer) {
                        if (!hasWarnedAboutUsingContextAsConsumer) {
                            hasWarnedAboutUsingContextAsConsumer = true;
                            error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
                        }
                    }
                } else {
                    context = context._context;
                }
            }
            var newProps = workInProgress.pendingProps;
            var render = newProps.children;
            {
                if (typeof render !== 'function') {
                    error('A context consumer was rendered with multiple children, or a child ' + 'that isn\'t a function. A context consumer expects a single child ' + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
                }
            }
            prepareToReadContext(workInProgress, renderLanes);
            var newValue = readContext(context, newProps.unstable_observedBits);
            var newChildren;
            {
                ReactCurrentOwner$1.current = workInProgress;
                setIsRendering(true);
                newChildren = render(newValue);
                setIsRendering(false);
            }
            workInProgress.flags |= PerformedWork;
            reconcileChildren(current, workInProgress, newChildren, renderLanes);
            return workInProgress.child;
        }
        function markWorkInProgressReceivedUpdate() {
            didReceiveUpdate = true;
        }
        function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
            if (current !== null) {
                workInProgress.dependencies = current.dependencies;
            }
            {
                stopProfilerTimerIfRunning();
            }
            markSkippedUpdateLanes(workInProgress.lanes);
            if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
                return null;
            } else {
                cloneChildFibers(current, workInProgress);
                return workInProgress.child;
            }
        }
        function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
            {
                var returnFiber = oldWorkInProgress.return;
                if (returnFiber === null) {
                    throw new Error('Cannot swap the root fiber.');
                }
                current.alternate = null;
                oldWorkInProgress.alternate = null;
                newWorkInProgress.index = oldWorkInProgress.index;
                newWorkInProgress.sibling = oldWorkInProgress.sibling;
                newWorkInProgress.return = oldWorkInProgress.return;
                newWorkInProgress.ref = oldWorkInProgress.ref;
                if (oldWorkInProgress === returnFiber.child) {
                    returnFiber.child = newWorkInProgress;
                } else {
                    var prevSibling = returnFiber.child;
                    if (prevSibling === null) {
                        throw new Error('Expected parent to have a child.');
                    }
                    while (prevSibling.sibling !== oldWorkInProgress) {
                        prevSibling = prevSibling.sibling;
                        if (prevSibling === null) {
                            throw new Error('Expected to find the previous sibling.');
                        }
                    }
                    prevSibling.sibling = newWorkInProgress;
                }
                var last = returnFiber.lastEffect;
                if (last !== null) {
                    last.nextEffect = current;
                    returnFiber.lastEffect = current;
                } else {
                    returnFiber.firstEffect = returnFiber.lastEffect = current;
                }
                current.nextEffect = null;
                current.flags = Deletion;
                newWorkInProgress.flags |= Placement;
                return newWorkInProgress;
            }
        }
        function beginWork(current, workInProgress, renderLanes) {
            var updateLanes = workInProgress.lanes;
            {
                if (workInProgress._debugNeedsRemount && current !== null) {
                    return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
                }
            }
            if (current !== null) {
                var oldProps = current.memoizedProps;
                var newProps = workInProgress.pendingProps;
                if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) {
                    didReceiveUpdate = true;
                } else if (!includesSomeLane(renderLanes, updateLanes)) {
                    didReceiveUpdate = false;
                    switch (workInProgress.tag) {
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        break;
                    case ClassComponent: {
                            var Component = workInProgress.type;
                            if (isContextProvider(Component)) {
                                pushContextProvider(workInProgress);
                            }
                            break;
                        }
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider: {
                            var newValue = workInProgress.memoizedProps.value;
                            pushProvider(workInProgress, newValue);
                            break;
                        }
                    case Profiler: {
                            var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                            if (hasChildWork) {
                                workInProgress.flags |= Update;
                            }
                            var stateNode = workInProgress.stateNode;
                            stateNode.effectDuration = 0;
                            stateNode.passiveEffectDuration = 0;
                        }
                        break;
                    case SuspenseComponent: {
                            var state = workInProgress.memoizedState;
                            if (state !== null) {
                                var primaryChildFragment = workInProgress.child;
                                var primaryChildLanes = primaryChildFragment.childLanes;
                                if (includesSomeLane(renderLanes, primaryChildLanes)) {
                                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                                } else {
                                    pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                                    var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                                    if (child !== null) {
                                        return child.sibling;
                                    } else {
                                        return null;
                                    }
                                }
                            } else {
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                            }
                            break;
                        }
                    case SuspenseListComponent: {
                            var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                            var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                            if (didSuspendBefore) {
                                if (_hasChildWork) {
                                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                                }
                                workInProgress.flags |= DidCapture;
                            }
                            var renderState = workInProgress.memoizedState;
                            if (renderState !== null) {
                                renderState.rendering = null;
                                renderState.tail = null;
                                renderState.lastEffect = null;
                            }
                            pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                            if (_hasChildWork) {
                                break;
                            } else {
                                return null;
                            }
                        }
                    case OffscreenComponent:
                    case LegacyHiddenComponent: {
                            workInProgress.lanes = NoLanes;
                            return updateOffscreenComponent(current, workInProgress, renderLanes);
                        }
                    }
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else {
                    if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                        didReceiveUpdate = true;
                    } else {
                        didReceiveUpdate = false;
                    }
                }
            } else {
                didReceiveUpdate = false;
            }
            workInProgress.lanes = NoLanes;
            switch (workInProgress.tag) {
            case IndeterminateComponent: {
                    return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
                }
            case LazyComponent: {
                    var elementType = workInProgress.elementType;
                    return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
                }
            case FunctionComponent: {
                    var _Component = workInProgress.type;
                    var unresolvedProps = workInProgress.pendingProps;
                    var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                    return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
                }
            case ClassComponent: {
                    var _Component2 = workInProgress.type;
                    var _unresolvedProps = workInProgress.pendingProps;
                    var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                    return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
                }
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef: {
                    var type = workInProgress.type;
                    var _unresolvedProps2 = workInProgress.pendingProps;
                    var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                    return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
                }
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent: {
                    var _type2 = workInProgress.type;
                    var _unresolvedProps3 = workInProgress.pendingProps;
                    var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                    {
                        if (workInProgress.type !== workInProgress.elementType) {
                            var outerPropTypes = _type2.propTypes;
                            if (outerPropTypes) {
                                checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentName(_type2));
                            }
                        }
                    }
                    _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                    return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
                }
            case SimpleMemoComponent: {
                    return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
                }
            case IncompleteClassComponent: {
                    var _Component3 = workInProgress.type;
                    var _unresolvedProps4 = workInProgress.pendingProps;
                    var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                    return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
                }
            case SuspenseListComponent: {
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                }
            case FundamentalComponent: {
                    break;
                }
            case ScopeComponent: {
                    break;
                }
            case Block: {
                    break;
                }
            case OffscreenComponent: {
                    return updateOffscreenComponent(current, workInProgress, renderLanes);
                }
            case LegacyHiddenComponent: {
                    return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
                }
            }
            {
                {
                    throw Error('Unknown unit of work tag (' + workInProgress.tag + '). This error is likely caused by a bug in React. Please file an issue.');
                }
            }
        }
        function markUpdate(workInProgress) {
            workInProgress.flags |= Update;
        }
        function markRef$1(workInProgress) {
            workInProgress.flags |= Ref;
        }
        var appendAllChildren;
        var updateHostContainer;
        var updateHostComponent$1;
        var updateHostText$1;
        {
            appendAllChildren = function (parent, workInProgress, needsVisibilityToggle, isHidden) {
                var node = workInProgress.child;
                while (node !== null) {
                    if (node.tag === HostComponent || node.tag === HostText) {
                        appendInitialChild(parent, node.stateNode);
                    } else if (node.tag === HostPortal);
                    else if (node.child !== null) {
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                    if (node === workInProgress) {
                        return;
                    }
                    while (node.sibling === null) {
                        if (node.return === null || node.return === workInProgress) {
                            return;
                        }
                        node = node.return;
                    }
                    node.sibling.return = node.return;
                    node = node.sibling;
                }
            };
            updateHostContainer = function (workInProgress) {
            };
            updateHostComponent$1 = function (current, workInProgress, type, newProps, rootContainerInstance) {
                var oldProps = current.memoizedProps;
                if (oldProps === newProps) {
                    return;
                }
                var instance = workInProgress.stateNode;
                var currentHostContext = getHostContext();
                var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
                workInProgress.updateQueue = updatePayload;
                if (updatePayload) {
                    markUpdate(workInProgress);
                }
            };
            updateHostText$1 = function (current, workInProgress, oldText, newText) {
                if (oldText !== newText) {
                    markUpdate(workInProgress);
                }
            };
        }
        function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
            if (getIsHydrating()) {
                return;
            }
            switch (renderState.tailMode) {
            case 'hidden': {
                    var tailNode = renderState.tail;
                    var lastTailNode = null;
                    while (tailNode !== null) {
                        if (tailNode.alternate !== null) {
                            lastTailNode = tailNode;
                        }
                        tailNode = tailNode.sibling;
                    }
                    if (lastTailNode === null) {
                        renderState.tail = null;
                    } else {
                        lastTailNode.sibling = null;
                    }
                    break;
                }
            case 'collapsed': {
                    var _tailNode = renderState.tail;
                    var _lastTailNode = null;
                    while (_tailNode !== null) {
                        if (_tailNode.alternate !== null) {
                            _lastTailNode = _tailNode;
                        }
                        _tailNode = _tailNode.sibling;
                    }
                    if (_lastTailNode === null) {
                        if (!hasRenderedATailFallback && renderState.tail !== null) {
                            renderState.tail.sibling = null;
                        } else {
                            renderState.tail = null;
                        }
                    } else {
                        _lastTailNode.sibling = null;
                    }
                    break;
                }
            }
        }
        function completeWork(current, workInProgress, renderLanes) {
            var newProps = workInProgress.pendingProps;
            switch (workInProgress.tag) {
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent: {
                    var Component = workInProgress.type;
                    if (isContextProvider(Component)) {
                        popContext(workInProgress);
                    }
                    return null;
                }
            case HostRoot: {
                    popHostContainer(workInProgress);
                    popTopLevelContextObject(workInProgress);
                    resetWorkInProgressVersions();
                    var fiberRoot = workInProgress.stateNode;
                    if (fiberRoot.pendingContext) {
                        fiberRoot.context = fiberRoot.pendingContext;
                        fiberRoot.pendingContext = null;
                    }
                    if (current === null || current.child === null) {
                        var wasHydrated = popHydrationState(workInProgress);
                        if (wasHydrated) {
                            markUpdate(workInProgress);
                        } else if (!fiberRoot.hydrate) {
                            workInProgress.flags |= Snapshot;
                        }
                    }
                    updateHostContainer(workInProgress);
                    return null;
                }
            case HostComponent: {
                    popHostContext(workInProgress);
                    var rootContainerInstance = getRootHostContainer();
                    var type = workInProgress.type;
                    if (current !== null && workInProgress.stateNode != null) {
                        updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                        if (current.ref !== workInProgress.ref) {
                            markRef$1(workInProgress);
                        }
                    } else {
                        if (!newProps) {
                            if (!(workInProgress.stateNode !== null)) {
                                {
                                    throw Error('We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.');
                                }
                            }
                            return null;
                        }
                        var currentHostContext = getHostContext();
                        var _wasHydrated = popHydrationState(workInProgress);
                        if (_wasHydrated) {
                            if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                                markUpdate(workInProgress);
                            }
                        } else {
                            var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                            appendAllChildren(instance, workInProgress, false, false);
                            workInProgress.stateNode = instance;
                            if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                                markUpdate(workInProgress);
                            }
                        }
                        if (workInProgress.ref !== null) {
                            markRef$1(workInProgress);
                        }
                    }
                    return null;
                }
            case HostText: {
                    var newText = newProps;
                    if (current && workInProgress.stateNode != null) {
                        var oldText = current.memoizedProps;
                        updateHostText$1(current, workInProgress, oldText, newText);
                    } else {
                        if (typeof newText !== 'string') {
                            if (!(workInProgress.stateNode !== null)) {
                                {
                                    throw Error('We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.');
                                }
                            }
                        }
                        var _rootContainerInstance = getRootHostContainer();
                        var _currentHostContext = getHostContext();
                        var _wasHydrated2 = popHydrationState(workInProgress);
                        if (_wasHydrated2) {
                            if (prepareToHydrateHostTextInstance(workInProgress)) {
                                markUpdate(workInProgress);
                            }
                        } else {
                            workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                        }
                    }
                    return null;
                }
            case SuspenseComponent: {
                    popSuspenseContext(workInProgress);
                    var nextState = workInProgress.memoizedState;
                    if ((workInProgress.flags & DidCapture) !== NoFlags) {
                        workInProgress.lanes = renderLanes;
                        if ((workInProgress.mode & ProfileMode) !== NoMode) {
                            transferActualDuration(workInProgress);
                        }
                        return workInProgress;
                    }
                    var nextDidTimeout = nextState !== null;
                    var prevDidTimeout = false;
                    if (current === null) {
                        if (workInProgress.memoizedProps.fallback !== undefined) {
                            popHydrationState(workInProgress);
                        }
                    } else {
                        var prevState = current.memoizedState;
                        prevDidTimeout = prevState !== null;
                    }
                    if (nextDidTimeout && !prevDidTimeout) {
                        if ((workInProgress.mode & BlockingMode) !== NoMode) {
                            var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                                renderDidSuspend();
                            } else {
                                renderDidSuspendDelayIfPossible();
                            }
                        }
                    }
                    {
                        if (nextDidTimeout || prevDidTimeout) {
                            workInProgress.flags |= Update;
                        }
                    }
                    return null;
                }
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                if (current === null) {
                    preparePortalMount(workInProgress.stateNode.containerInfo);
                }
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent: {
                    var _Component = workInProgress.type;
                    if (isContextProvider(_Component)) {
                        popContext(workInProgress);
                    }
                    return null;
                }
            case SuspenseListComponent: {
                    popSuspenseContext(workInProgress);
                    var renderState = workInProgress.memoizedState;
                    if (renderState === null) {
                        return null;
                    }
                    var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                    var renderedTail = renderState.rendering;
                    if (renderedTail === null) {
                        if (!didSuspendAlready) {
                            var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                            if (!cannotBeSuspended) {
                                var row = workInProgress.child;
                                while (row !== null) {
                                    var suspended = findFirstSuspended(row);
                                    if (suspended !== null) {
                                        didSuspendAlready = true;
                                        workInProgress.flags |= DidCapture;
                                        cutOffTailIfNeeded(renderState, false);
                                        var newThennables = suspended.updateQueue;
                                        if (newThennables !== null) {
                                            workInProgress.updateQueue = newThennables;
                                            workInProgress.flags |= Update;
                                        }
                                        if (renderState.lastEffect === null) {
                                            workInProgress.firstEffect = null;
                                        }
                                        workInProgress.lastEffect = renderState.lastEffect;
                                        resetChildFibers(workInProgress, renderLanes);
                                        pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                        return workInProgress.child;
                                    }
                                    row = row.sibling;
                                }
                            }
                            if (renderState.tail !== null && now() > getRenderTargetTime()) {
                                workInProgress.flags |= DidCapture;
                                didSuspendAlready = true;
                                cutOffTailIfNeeded(renderState, false);
                                workInProgress.lanes = SomeRetryLane;
                                {
                                    markSpawnedWork(SomeRetryLane);
                                }
                            }
                        } else {
                            cutOffTailIfNeeded(renderState, false);
                        }
                    } else {
                        if (!didSuspendAlready) {
                            var _suspended = findFirstSuspended(renderedTail);
                            if (_suspended !== null) {
                                workInProgress.flags |= DidCapture;
                                didSuspendAlready = true;
                                var _newThennables = _suspended.updateQueue;
                                if (_newThennables !== null) {
                                    workInProgress.updateQueue = _newThennables;
                                    workInProgress.flags |= Update;
                                }
                                cutOffTailIfNeeded(renderState, true);
                                if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating()) {
                                    var lastEffect = workInProgress.lastEffect = renderState.lastEffect;
                                    if (lastEffect !== null) {
                                        lastEffect.nextEffect = null;
                                    }
                                    return null;
                                }
                            } else if (now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                                workInProgress.flags |= DidCapture;
                                didSuspendAlready = true;
                                cutOffTailIfNeeded(renderState, false);
                                workInProgress.lanes = SomeRetryLane;
                                {
                                    markSpawnedWork(SomeRetryLane);
                                }
                            }
                        }
                        if (renderState.isBackwards) {
                            renderedTail.sibling = workInProgress.child;
                            workInProgress.child = renderedTail;
                        } else {
                            var previousSibling = renderState.last;
                            if (previousSibling !== null) {
                                previousSibling.sibling = renderedTail;
                            } else {
                                workInProgress.child = renderedTail;
                            }
                            renderState.last = renderedTail;
                        }
                    }
                    if (renderState.tail !== null) {
                        var next = renderState.tail;
                        renderState.rendering = next;
                        renderState.tail = next.sibling;
                        renderState.lastEffect = workInProgress.lastEffect;
                        renderState.renderingStartTime = now();
                        next.sibling = null;
                        var suspenseContext = suspenseStackCursor.current;
                        if (didSuspendAlready) {
                            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                        } else {
                            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                        }
                        pushSuspenseContext(workInProgress, suspenseContext);
                        return next;
                    }
                    return null;
                }
            case FundamentalComponent: {
                    break;
                }
            case ScopeComponent: {
                    break;
                }
            case Block:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent: {
                    popRenderLanes(workInProgress);
                    if (current !== null) {
                        var _nextState = workInProgress.memoizedState;
                        var _prevState = current.memoizedState;
                        var prevIsHidden = _prevState !== null;
                        var nextIsHidden = _nextState !== null;
                        if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') {
                            workInProgress.flags |= Update;
                        }
                    }
                    return null;
                }
            }
            {
                {
                    throw Error('Unknown unit of work tag (' + workInProgress.tag + '). This error is likely caused by a bug in React. Please file an issue.');
                }
            }
        }
        function unwindWork(workInProgress, renderLanes) {
            switch (workInProgress.tag) {
            case ClassComponent: {
                    var Component = workInProgress.type;
                    if (isContextProvider(Component)) {
                        popContext(workInProgress);
                    }
                    var flags = workInProgress.flags;
                    if (flags & ShouldCapture) {
                        workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                        if ((workInProgress.mode & ProfileMode) !== NoMode) {
                            transferActualDuration(workInProgress);
                        }
                        return workInProgress;
                    }
                    return null;
                }
            case HostRoot: {
                    popHostContainer(workInProgress);
                    popTopLevelContextObject(workInProgress);
                    resetWorkInProgressVersions();
                    var _flags = workInProgress.flags;
                    if (!((_flags & DidCapture) === NoFlags)) {
                        {
                            throw Error('The root failed to unmount after an error. This is likely a bug in React. Please file an issue.');
                        }
                    }
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                }
            case HostComponent: {
                    popHostContext(workInProgress);
                    return null;
                }
            case SuspenseComponent: {
                    popSuspenseContext(workInProgress);
                    var _flags2 = workInProgress.flags;
                    if (_flags2 & ShouldCapture) {
                        workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture;
                        if ((workInProgress.mode & ProfileMode) !== NoMode) {
                            transferActualDuration(workInProgress);
                        }
                        return workInProgress;
                    }
                    return null;
                }
            case SuspenseListComponent: {
                    popSuspenseContext(workInProgress);
                    return null;
                }
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            default:
                return null;
            }
        }
        function unwindInterruptedWork(interruptedWork) {
            switch (interruptedWork.tag) {
            case ClassComponent: {
                    var childContextTypes = interruptedWork.type.childContextTypes;
                    if (childContextTypes !== null && childContextTypes !== undefined) {
                        popContext(interruptedWork);
                    }
                    break;
                }
            case HostRoot: {
                    popHostContainer(interruptedWork);
                    popTopLevelContextObject(interruptedWork);
                    resetWorkInProgressVersions();
                    break;
                }
            case HostComponent: {
                    popHostContext(interruptedWork);
                    break;
                }
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
            }
        }
        function createCapturedValue(value, source) {
            return {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
        }
        function showErrorDialog(boundary, errorInfo) {
            return true;
        }
        function logCapturedError(boundary, errorInfo) {
            try {
                var logError = showErrorDialog(boundary, errorInfo);
                if (logError === false) {
                    return;
                }
                var error = errorInfo.value;
                if (true) {
                    var source = errorInfo.source;
                    var stack = errorInfo.stack;
                    var componentStack = stack !== null ? stack : '';
                    if (error != null && error._suppressLogging) {
                        if (boundary.tag === ClassComponent) {
                            return;
                        }
                        console['error'](error);
                    }
                    var componentName = source ? getComponentName(source.type) : null;
                    var componentNameMessage = componentName ? 'The above error occurred in the <' + componentName + '> component:' : 'The above error occurred in one of your React components:';
                    var errorBoundaryMessage;
                    var errorBoundaryName = getComponentName(boundary.type);
                    if (errorBoundaryName) {
                        errorBoundaryMessage = 'React will try to recreate this component tree from scratch ' + ('using the error boundary you provided, ' + errorBoundaryName + '.');
                    } else {
                        errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
                    }
                    var combinedMessage = componentNameMessage + '\n' + componentStack + '\n\n' + ('' + errorBoundaryMessage);
                    console['error'](combinedMessage);
                } else {
                    console['error'](error);
                }
            } catch (e) {
                setTimeout(function () {
                    throw e;
                });
            }
        }
        var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
        function createRootErrorUpdate(fiber, errorInfo, lane) {
            var update = createUpdate(NoTimestamp, lane);
            update.tag = CaptureUpdate;
            update.payload = { element: null };
            var error = errorInfo.value;
            update.callback = function () {
                onUncaughtError(error);
                logCapturedError(fiber, errorInfo);
            };
            return update;
        }
        function createClassErrorUpdate(fiber, errorInfo, lane) {
            var update = createUpdate(NoTimestamp, lane);
            update.tag = CaptureUpdate;
            var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
            if (typeof getDerivedStateFromError === 'function') {
                var error$1 = errorInfo.value;
                update.payload = function () {
                    logCapturedError(fiber, errorInfo);
                    return getDerivedStateFromError(error$1);
                };
            }
            var inst = fiber.stateNode;
            if (inst !== null && typeof inst.componentDidCatch === 'function') {
                update.callback = function callback() {
                    {
                        markFailedErrorBoundaryForHotReloading(fiber);
                    }
                    if (typeof getDerivedStateFromError !== 'function') {
                        markLegacyErrorBoundaryAsFailed(this);
                        logCapturedError(fiber, errorInfo);
                    }
                    var error$1 = errorInfo.value;
                    var stack = errorInfo.stack;
                    this.componentDidCatch(error$1, { componentStack: stack !== null ? stack : '' });
                    {
                        if (typeof getDerivedStateFromError !== 'function') {
                            if (!includesSomeLane(fiber.lanes, SyncLane)) {
                                error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
                            }
                        }
                    }
                };
            } else {
                update.callback = function () {
                    markFailedErrorBoundaryForHotReloading(fiber);
                };
            }
            return update;
        }
        function attachPingListener(root, wakeable, lanes) {
            var pingCache = root.pingCache;
            var threadIDs;
            if (pingCache === null) {
                pingCache = root.pingCache = new PossiblyWeakMap$1();
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            } else {
                threadIDs = pingCache.get(wakeable);
                if (threadIDs === undefined) {
                    threadIDs = new Set();
                    pingCache.set(wakeable, threadIDs);
                }
            }
            if (!threadIDs.has(lanes)) {
                threadIDs.add(lanes);
                var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
                wakeable.then(ping, ping);
            }
        }
        function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
            sourceFiber.flags |= Incomplete;
            sourceFiber.firstEffect = sourceFiber.lastEffect = null;
            if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
                var wakeable = value;
                if ((sourceFiber.mode & BlockingMode) === NoMode) {
                    var currentSource = sourceFiber.alternate;
                    if (currentSource) {
                        sourceFiber.updateQueue = currentSource.updateQueue;
                        sourceFiber.memoizedState = currentSource.memoizedState;
                        sourceFiber.lanes = currentSource.lanes;
                    } else {
                        sourceFiber.updateQueue = null;
                        sourceFiber.memoizedState = null;
                    }
                }
                var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext);
                var _workInProgress = returnFiber;
                do {
                    if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                        var wakeables = _workInProgress.updateQueue;
                        if (wakeables === null) {
                            var updateQueue = new Set();
                            updateQueue.add(wakeable);
                            _workInProgress.updateQueue = updateQueue;
                        } else {
                            wakeables.add(wakeable);
                        }
                        if ((_workInProgress.mode & BlockingMode) === NoMode) {
                            _workInProgress.flags |= DidCapture;
                            sourceFiber.flags |= ForceUpdateForLegacySuspense;
                            sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                            if (sourceFiber.tag === ClassComponent) {
                                var currentSourceFiber = sourceFiber.alternate;
                                if (currentSourceFiber === null) {
                                    sourceFiber.tag = IncompleteClassComponent;
                                } else {
                                    var update = createUpdate(NoTimestamp, SyncLane);
                                    update.tag = ForceUpdate;
                                    enqueueUpdate(sourceFiber, update);
                                }
                            }
                            sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
                            return;
                        }
                        attachPingListener(root, wakeable, rootRenderLanes);
                        _workInProgress.flags |= ShouldCapture;
                        _workInProgress.lanes = rootRenderLanes;
                        return;
                    }
                    _workInProgress = _workInProgress.return;
                } while (_workInProgress !== null);
                value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
            }
            renderDidError();
            value = createCapturedValue(value, sourceFiber);
            var workInProgress = returnFiber;
            do {
                switch (workInProgress.tag) {
                case HostRoot: {
                        var _errorInfo = value;
                        workInProgress.flags |= ShouldCapture;
                        var lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                        var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                case ClassComponent:
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane);
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
                }
                workInProgress = workInProgress.return;
            } while (workInProgress !== null);
        }
        var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
        {
            didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
        }
        var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
        var callComponentWillUnmountWithTimer = function (current, instance) {
            instance.props = current.memoizedProps;
            instance.state = current.memoizedState;
            {
                instance.componentWillUnmount();
            }
        };
        function safelyCallComponentWillUnmount(current, instance) {
            {
                invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
                if (hasCaughtError()) {
                    var unmountError = clearCaughtError();
                    captureCommitPhaseError(current, unmountError);
                }
            }
        }
        function safelyDetachRef(current) {
            var ref = current.ref;
            if (ref !== null) {
                if (typeof ref === 'function') {
                    {
                        invokeGuardedCallback(null, ref, null, null);
                        if (hasCaughtError()) {
                            var refError = clearCaughtError();
                            captureCommitPhaseError(current, refError);
                        }
                    }
                } else {
                    ref.current = null;
                }
            }
        }
        function safelyCallDestroy(current, destroy) {
            {
                invokeGuardedCallback(null, destroy, null);
                if (hasCaughtError()) {
                    var error = clearCaughtError();
                    captureCommitPhaseError(current, error);
                }
            }
        }
        function commitBeforeMutationLifeCycles(current, finishedWork) {
            switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block: {
                    return;
                }
            case ClassComponent: {
                    if (finishedWork.flags & Snapshot) {
                        if (current !== null) {
                            var prevProps = current.memoizedProps;
                            var prevState = current.memoizedState;
                            var instance = finishedWork.stateNode;
                            {
                                if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                    if (instance.props !== finishedWork.memoizedProps) {
                                        error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                    }
                                    if (instance.state !== finishedWork.memoizedState) {
                                        error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                    }
                                }
                            }
                            var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                            {
                                var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                                if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                                    didWarnSet.add(finishedWork.type);
                                    error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
                                }
                            }
                            instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                        }
                    }
                    return;
                }
            case HostRoot: {
                    {
                        if (finishedWork.flags & Snapshot) {
                            var root = finishedWork.stateNode;
                            clearContainer(root.containerInfo);
                        }
                    }
                    return;
                }
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                return;
            }
            {
                {
                    throw Error('This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
        }
        function commitHookEffectListUnmount(tag, finishedWork) {
            var updateQueue = finishedWork.updateQueue;
            var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
            if (lastEffect !== null) {
                var firstEffect = lastEffect.next;
                var effect = firstEffect;
                do {
                    if ((effect.tag & tag) === tag) {
                        var destroy = effect.destroy;
                        effect.destroy = undefined;
                        if (destroy !== undefined) {
                            destroy();
                        }
                    }
                    effect = effect.next;
                } while (effect !== firstEffect);
            }
        }
        function commitHookEffectListMount(tag, finishedWork) {
            var updateQueue = finishedWork.updateQueue;
            var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
            if (lastEffect !== null) {
                var firstEffect = lastEffect.next;
                var effect = firstEffect;
                do {
                    if ((effect.tag & tag) === tag) {
                        var create = effect.create;
                        effect.destroy = create();
                        {
                            var destroy = effect.destroy;
                            if (destroy !== undefined && typeof destroy !== 'function') {
                                var addendum = void 0;
                                if (destroy === null) {
                                    addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                                } else if (typeof destroy.then === 'function') {
                                    addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + '}, [someId]); // Or [] if effect doesn\'t need props or state\n\n' + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                                } else {
                                    addendum = ' You returned: ' + destroy;
                                }
                                error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s', addendum);
                            }
                        }
                    }
                    effect = effect.next;
                } while (effect !== firstEffect);
            }
        }
        function schedulePassiveEffects(finishedWork) {
            var updateQueue = finishedWork.updateQueue;
            var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
            if (lastEffect !== null) {
                var firstEffect = lastEffect.next;
                var effect = firstEffect;
                do {
                    var _effect = effect, next = _effect.next, tag = _effect.tag;
                    if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                        enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                        enqueuePendingPassiveHookEffectMount(finishedWork, effect);
                    }
                    effect = next;
                } while (effect !== firstEffect);
            }
        }
        function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
            switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block: {
                    {
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    }
                    schedulePassiveEffects(finishedWork);
                    return;
                }
            case ClassComponent: {
                    var instance = finishedWork.stateNode;
                    if (finishedWork.flags & Update) {
                        if (current === null) {
                            {
                                if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                    if (instance.props !== finishedWork.memoizedProps) {
                                        error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                    }
                                    if (instance.state !== finishedWork.memoizedState) {
                                        error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                    }
                                }
                            }
                            {
                                instance.componentDidMount();
                            }
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState;
                            {
                                if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                    if (instance.props !== finishedWork.memoizedProps) {
                                        error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                    }
                                    if (instance.state !== finishedWork.memoizedState) {
                                        error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                    }
                                }
                            }
                            {
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                    }
                    var updateQueue = finishedWork.updateQueue;
                    if (updateQueue !== null) {
                        {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) {
                                    error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                }
                                if (instance.state !== finishedWork.memoizedState) {
                                    error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                                }
                            }
                        }
                        commitUpdateQueue(finishedWork, updateQueue, instance);
                    }
                    return;
                }
            case HostRoot: {
                    var _updateQueue = finishedWork.updateQueue;
                    if (_updateQueue !== null) {
                        var _instance = null;
                        if (finishedWork.child !== null) {
                            switch (finishedWork.child.tag) {
                            case HostComponent:
                                _instance = getPublicInstance(finishedWork.child.stateNode);
                                break;
                            case ClassComponent:
                                _instance = finishedWork.child.stateNode;
                                break;
                            }
                        }
                        commitUpdateQueue(finishedWork, _updateQueue, _instance);
                    }
                    return;
                }
            case HostComponent: {
                    var _instance2 = finishedWork.stateNode;
                    if (current === null && finishedWork.flags & Update) {
                        var type = finishedWork.type;
                        var props = finishedWork.memoizedProps;
                        commitMount(_instance2, type, props);
                    }
                    return;
                }
            case HostText: {
                    return;
                }
            case HostPortal: {
                    return;
                }
            case Profiler: {
                    {
                        var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                        var effectDuration = finishedWork.stateNode.effectDuration;
                        var commitTime = getCommitTime();
                        if (typeof onRender === 'function') {
                            {
                                onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
                            }
                        }
                    }
                    return;
                }
            case SuspenseComponent: {
                    commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                    return;
                }
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
                return;
            }
            {
                {
                    throw Error('This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
        }
        function hideOrUnhideAllChildren(finishedWork, isHidden) {
            {
                var node = finishedWork;
                while (true) {
                    if (node.tag === HostComponent) {
                        var instance = node.stateNode;
                        if (isHidden) {
                            hideInstance(instance);
                        } else {
                            unhideInstance(node.stateNode, node.memoizedProps);
                        }
                    } else if (node.tag === HostText) {
                        var _instance3 = node.stateNode;
                        if (isHidden) {
                            hideTextInstance(_instance3);
                        } else {
                            unhideTextInstance(_instance3, node.memoizedProps);
                        }
                    } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork);
                    else if (node.child !== null) {
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                    if (node === finishedWork) {
                        return;
                    }
                    while (node.sibling === null) {
                        if (node.return === null || node.return === finishedWork) {
                            return;
                        }
                        node = node.return;
                    }
                    node.sibling.return = node.return;
                    node = node.sibling;
                }
            }
        }
        function commitAttachRef(finishedWork) {
            var ref = finishedWork.ref;
            if (ref !== null) {
                var instance = finishedWork.stateNode;
                var instanceToUse;
                switch (finishedWork.tag) {
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
                }
                if (typeof ref === 'function') {
                    ref(instanceToUse);
                } else {
                    {
                        if (!ref.hasOwnProperty('current')) {
                            error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentName(finishedWork.type));
                        }
                    }
                    ref.current = instanceToUse;
                }
            }
        }
        function commitDetachRef(current) {
            var currentRef = current.ref;
            if (currentRef !== null) {
                if (typeof currentRef === 'function') {
                    currentRef(null);
                } else {
                    currentRef.current = null;
                }
            }
        }
        function commitUnmount(finishedRoot, current, renderPriorityLevel) {
            onCommitUnmount(current);
            switch (current.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block: {
                    var updateQueue = current.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect2 = effect, destroy = _effect2.destroy, tag = _effect2.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Passive$1) !== NoFlags$1) {
                                        enqueuePendingPassiveHookEffectUnmount(current, effect);
                                    } else {
                                        {
                                            safelyCallDestroy(current, destroy);
                                        }
                                    }
                                }
                                effect = effect.next;
                            } while (effect !== firstEffect);
                        }
                    }
                    return;
                }
            case ClassComponent: {
                    safelyDetachRef(current);
                    var instance = current.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') {
                        safelyCallComponentWillUnmount(current, instance);
                    }
                    return;
                }
            case HostComponent: {
                    safelyDetachRef(current);
                    return;
                }
            case HostPortal: {
                    {
                        unmountHostComponents(finishedRoot, current);
                    }
                    return;
                }
            case FundamentalComponent: {
                    return;
                }
            case DehydratedFragment: {
                    return;
                }
            case ScopeComponent: {
                    return;
                }
            }
        }
        function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
            var node = root;
            while (true) {
                commitUnmount(finishedRoot, node);
                if (node.child !== null && node.tag !== HostPortal) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
                if (node === root) {
                    return;
                }
                while (node.sibling === null) {
                    if (node.return === null || node.return === root) {
                        return;
                    }
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        function detachFiberMutation(fiber) {
            fiber.alternate = null;
            fiber.child = null;
            fiber.dependencies = null;
            fiber.firstEffect = null;
            fiber.lastEffect = null;
            fiber.memoizedProps = null;
            fiber.memoizedState = null;
            fiber.pendingProps = null;
            fiber.return = null;
            fiber.updateQueue = null;
            {
                fiber._debugOwner = null;
            }
        }
        function getHostParentFiber(fiber) {
            var parent = fiber.return;
            while (parent !== null) {
                if (isHostParent(parent)) {
                    return parent;
                }
                parent = parent.return;
            }
            {
                {
                    throw Error('Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
        }
        function isHostParent(fiber) {
            return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
        }
        function getHostSibling(fiber) {
            var node = fiber;
            siblings:
                while (true) {
                    while (node.sibling === null) {
                        if (node.return === null || isHostParent(node.return)) {
                            return null;
                        }
                        node = node.return;
                    }
                    node.sibling.return = node.return;
                    node = node.sibling;
                    while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
                        if (node.flags & Placement) {
                            continue siblings;
                        }
                        if (node.child === null || node.tag === HostPortal) {
                            continue siblings;
                        } else {
                            node.child.return = node;
                            node = node.child;
                        }
                    }
                    if (!(node.flags & Placement)) {
                        return node.stateNode;
                    }
                }
        }
        function commitPlacement(finishedWork) {
            var parentFiber = getHostParentFiber(finishedWork);
            var parent;
            var isContainer;
            var parentStateNode = parentFiber.stateNode;
            switch (parentFiber.tag) {
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            default: {
                    {
                        throw Error('Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
            }
            if (parentFiber.flags & ContentReset) {
                resetTextContent(parent);
                parentFiber.flags &= ~ContentReset;
            }
            var before = getHostSibling(finishedWork);
            if (isContainer) {
                insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
            } else {
                insertOrAppendPlacementNode(finishedWork, before, parent);
            }
        }
        function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
            var tag = node.tag;
            var isHost = tag === HostComponent || tag === HostText;
            if (isHost || enableFundamentalAPI) {
                var stateNode = isHost ? node.stateNode : node.stateNode.instance;
                if (before) {
                    insertInContainerBefore(parent, stateNode, before);
                } else {
                    appendChildToContainer(parent, stateNode);
                }
            } else if (tag === HostPortal);
            else {
                var child = node.child;
                if (child !== null) {
                    insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                    var sibling = child.sibling;
                    while (sibling !== null) {
                        insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                        sibling = sibling.sibling;
                    }
                }
            }
        }
        function insertOrAppendPlacementNode(node, before, parent) {
            var tag = node.tag;
            var isHost = tag === HostComponent || tag === HostText;
            if (isHost || enableFundamentalAPI) {
                var stateNode = isHost ? node.stateNode : node.stateNode.instance;
                if (before) {
                    insertBefore(parent, stateNode, before);
                } else {
                    appendChild(parent, stateNode);
                }
            } else if (tag === HostPortal);
            else {
                var child = node.child;
                if (child !== null) {
                    insertOrAppendPlacementNode(child, before, parent);
                    var sibling = child.sibling;
                    while (sibling !== null) {
                        insertOrAppendPlacementNode(sibling, before, parent);
                        sibling = sibling.sibling;
                    }
                }
            }
        }
        function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
            var node = current;
            var currentParentIsValid = false;
            var currentParent;
            var currentParentIsContainer;
            while (true) {
                if (!currentParentIsValid) {
                    var parent = node.return;
                    findParent:
                        while (true) {
                            if (!(parent !== null)) {
                                {
                                    throw Error('Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.');
                                }
                            }
                            var parentStateNode = parent.stateNode;
                            switch (parent.tag) {
                            case HostComponent:
                                currentParent = parentStateNode;
                                currentParentIsContainer = false;
                                break findParent;
                            case HostRoot:
                                currentParent = parentStateNode.containerInfo;
                                currentParentIsContainer = true;
                                break findParent;
                            case HostPortal:
                                currentParent = parentStateNode.containerInfo;
                                currentParentIsContainer = true;
                                break findParent;
                            }
                            parent = parent.return;
                        }
                    currentParentIsValid = true;
                }
                if (node.tag === HostComponent || node.tag === HostText) {
                    commitNestedUnmounts(finishedRoot, node);
                    if (currentParentIsContainer) {
                        removeChildFromContainer(currentParent, node.stateNode);
                    } else {
                        removeChild(currentParent, node.stateNode);
                    }
                } else if (node.tag === HostPortal) {
                    if (node.child !== null) {
                        currentParent = node.stateNode.containerInfo;
                        currentParentIsContainer = true;
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                } else {
                    commitUnmount(finishedRoot, node);
                    if (node.child !== null) {
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                }
                if (node === current) {
                    return;
                }
                while (node.sibling === null) {
                    if (node.return === null || node.return === current) {
                        return;
                    }
                    node = node.return;
                    if (node.tag === HostPortal) {
                        currentParentIsValid = false;
                    }
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        function commitDeletion(finishedRoot, current, renderPriorityLevel) {
            {
                unmountHostComponents(finishedRoot, current);
            }
            var alternate = current.alternate;
            detachFiberMutation(current);
            if (alternate !== null) {
                detachFiberMutation(alternate);
            }
        }
        function commitWork(current, finishedWork) {
            switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block: {
                    {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                    }
                    return;
                }
            case ClassComponent: {
                    return;
                }
            case HostComponent: {
                    var instance = finishedWork.stateNode;
                    if (instance != null) {
                        var newProps = finishedWork.memoizedProps;
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type;
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) {
                            commitUpdate(instance, updatePayload, type, oldProps, newProps);
                        }
                    }
                    return;
                }
            case HostText: {
                    if (!(finishedWork.stateNode !== null)) {
                        {
                            throw Error('This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.');
                        }
                    }
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps;
                    var oldText = current !== null ? current.memoizedProps : newText;
                    commitTextUpdate(textInstance, oldText, newText);
                    return;
                }
            case HostRoot: {
                    {
                        var _root = finishedWork.stateNode;
                        if (_root.hydrate) {
                            _root.hydrate = false;
                            commitHydratedContainer(_root.containerInfo);
                        }
                    }
                    return;
                }
            case Profiler: {
                    return;
                }
            case SuspenseComponent: {
                    commitSuspenseComponent(finishedWork);
                    attachSuspenseRetryListeners(finishedWork);
                    return;
                }
            case SuspenseListComponent: {
                    attachSuspenseRetryListeners(finishedWork);
                    return;
                }
            case IncompleteClassComponent: {
                    return;
                }
            case FundamentalComponent: {
                    break;
                }
            case ScopeComponent: {
                    break;
                }
            case OffscreenComponent:
            case LegacyHiddenComponent: {
                    var newState = finishedWork.memoizedState;
                    var isHidden = newState !== null;
                    hideOrUnhideAllChildren(finishedWork, isHidden);
                    return;
                }
            }
            {
                {
                    throw Error('This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
        }
        function commitSuspenseComponent(finishedWork) {
            var newState = finishedWork.memoizedState;
            if (newState !== null) {
                markCommitTimeOfFallback();
                {
                    var primaryChildParent = finishedWork.child;
                    hideOrUnhideAllChildren(primaryChildParent, true);
                }
            }
        }
        function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
            var newState = finishedWork.memoizedState;
            if (newState === null) {
                var current = finishedWork.alternate;
                if (current !== null) {
                    var prevState = current.memoizedState;
                    if (prevState !== null) {
                        var suspenseInstance = prevState.dehydrated;
                        if (suspenseInstance !== null) {
                            commitHydratedSuspenseInstance(suspenseInstance);
                        }
                    }
                }
            }
        }
        function attachSuspenseRetryListeners(finishedWork) {
            var wakeables = finishedWork.updateQueue;
            if (wakeables !== null) {
                finishedWork.updateQueue = null;
                var retryCache = finishedWork.stateNode;
                if (retryCache === null) {
                    retryCache = finishedWork.stateNode = new PossiblyWeakSet();
                }
                wakeables.forEach(function (wakeable) {
                    var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                    if (!retryCache.has(wakeable)) {
                        {
                            if (wakeable.__reactDoNotTraceInteractions !== true) {
                                retry = tracing.unstable_wrap(retry);
                            }
                        }
                        retryCache.add(wakeable);
                        wakeable.then(retry, retry);
                    }
                });
            }
        }
        function isSuspenseBoundaryBeingHidden(current, finishedWork) {
            if (current !== null) {
                var oldState = current.memoizedState;
                if (oldState === null || oldState.dehydrated !== null) {
                    var newState = finishedWork.memoizedState;
                    return newState !== null && newState.dehydrated === null;
                }
            }
            return false;
        }
        function commitResetTextContent(current) {
            resetTextContent(current.stateNode);
        }
        var COMPONENT_TYPE = 0;
        var HAS_PSEUDO_CLASS_TYPE = 1;
        var ROLE_TYPE = 2;
        var TEST_NAME_TYPE = 3;
        var TEXT_TYPE = 4;
        if (typeof Symbol === 'function' && Symbol.for) {
            var symbolFor$1 = Symbol.for;
            COMPONENT_TYPE = symbolFor$1('selector.component');
            HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
            ROLE_TYPE = symbolFor$1('selector.role');
            TEST_NAME_TYPE = symbolFor$1('selector.test_id');
            TEXT_TYPE = symbolFor$1('selector.text');
        }
        var commitHooks = [];
        function onCommitRoot$1() {
            {
                commitHooks.forEach(function (commitHook) {
                    return commitHook();
                });
            }
        }
        var ceil = Math.ceil;
        var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
        var NoContext = 0;
        var BatchedContext = 1;
        var EventContext = 2;
        var DiscreteEventContext = 4;
        var LegacyUnbatchedContext = 8;
        var RenderContext = 16;
        var CommitContext = 32;
        var RetryAfterError = 64;
        var RootIncomplete = 0;
        var RootFatalErrored = 1;
        var RootErrored = 2;
        var RootSuspended = 3;
        var RootSuspendedWithDelay = 4;
        var RootCompleted = 5;
        var executionContext = NoContext;
        var workInProgressRoot = null;
        var workInProgress = null;
        var workInProgressRootRenderLanes = NoLanes;
        var subtreeRenderLanes = NoLanes;
        var subtreeRenderLanesCursor = createCursor(NoLanes);
        var workInProgressRootExitStatus = RootIncomplete;
        var workInProgressRootFatalError = null;
        var workInProgressRootIncludedLanes = NoLanes;
        var workInProgressRootSkippedLanes = NoLanes;
        var workInProgressRootUpdatedLanes = NoLanes;
        var workInProgressRootPingedLanes = NoLanes;
        var mostRecentlyUpdatedRoot = null;
        var globalMostRecentFallbackTime = 0;
        var FALLBACK_THROTTLE_MS = 500;
        var workInProgressRootRenderTargetTime = Infinity;
        var RENDER_TIMEOUT_MS = 500;
        function resetRenderTimer() {
            workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
        }
        function getRenderTargetTime() {
            return workInProgressRootRenderTargetTime;
        }
        var nextEffect = null;
        var hasUncaughtError = false;
        var firstUncaughtError = null;
        var legacyErrorBoundariesThatAlreadyFailed = null;
        var rootDoesHavePassiveEffects = false;
        var rootWithPendingPassiveEffects = null;
        var pendingPassiveEffectsRenderPriority = NoPriority$1;
        var pendingPassiveEffectsLanes = NoLanes;
        var pendingPassiveHookEffectsMount = [];
        var pendingPassiveHookEffectsUnmount = [];
        var rootsWithPendingDiscreteUpdates = null;
        var NESTED_UPDATE_LIMIT = 50;
        var nestedUpdateCount = 0;
        var rootWithNestedUpdates = null;
        var NESTED_PASSIVE_UPDATE_LIMIT = 50;
        var nestedPassiveUpdateCount = 0;
        var spawnedWorkDuringRender = null;
        var currentEventTime = NoTimestamp;
        var currentEventWipLanes = NoLanes;
        var currentEventPendingLanes = NoLanes;
        var isFlushingPassiveEffects = false;
        var focusedInstanceHandle = null;
        var shouldFireAfterActiveInstanceBlur = false;
        function getWorkInProgressRoot() {
            return workInProgressRoot;
        }
        function requestEventTime() {
            if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
                return now();
            }
            if (currentEventTime !== NoTimestamp) {
                return currentEventTime;
            }
            currentEventTime = now();
            return currentEventTime;
        }
        function requestUpdateLane(fiber) {
            var mode = fiber.mode;
            if ((mode & BlockingMode) === NoMode) {
                return SyncLane;
            } else if ((mode & ConcurrentMode) === NoMode) {
                return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
            }
            if (currentEventWipLanes === NoLanes) {
                currentEventWipLanes = workInProgressRootIncludedLanes;
            }
            var isTransition = requestCurrentTransition() !== NoTransition;
            if (isTransition) {
                if (currentEventPendingLanes !== NoLanes) {
                    currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
                }
                return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
            }
            var schedulerPriority = getCurrentPriorityLevel();
            var lane;
            if ((executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) {
                lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
            } else {
                var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
                lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
            }
            return lane;
        }
        function requestRetryLane(fiber) {
            var mode = fiber.mode;
            if ((mode & BlockingMode) === NoMode) {
                return SyncLane;
            } else if ((mode & ConcurrentMode) === NoMode) {
                return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
            }
            if (currentEventWipLanes === NoLanes) {
                currentEventWipLanes = workInProgressRootIncludedLanes;
            }
            return findRetryLane(currentEventWipLanes);
        }
        function scheduleUpdateOnFiber(fiber, lane, eventTime) {
            checkForNestedUpdates();
            warnAboutRenderPhaseUpdatesInDEV(fiber);
            var root = markUpdateLaneFromFiberToRoot(fiber, lane);
            if (root === null) {
                warnAboutUpdateOnUnmountedFiberInDEV(fiber);
                return null;
            }
            markRootUpdated(root, lane, eventTime);
            if (root === workInProgressRoot) {
                {
                    workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
                }
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
                    markRootSuspended$1(root, workInProgressRootRenderLanes);
                }
            }
            var priorityLevel = getCurrentPriorityLevel();
            if (lane === SyncLane) {
                if ((executionContext & LegacyUnbatchedContext) !== NoContext && (executionContext & (RenderContext | CommitContext)) === NoContext) {
                    schedulePendingInteractions(root, lane);
                    performSyncWorkOnRoot(root);
                } else {
                    ensureRootIsScheduled(root, eventTime);
                    schedulePendingInteractions(root, lane);
                    if (executionContext === NoContext) {
                        resetRenderTimer();
                        flushSyncCallbackQueue();
                    }
                }
            } else {
                if ((executionContext & DiscreteEventContext) !== NoContext && (priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
                    if (rootsWithPendingDiscreteUpdates === null) {
                        rootsWithPendingDiscreteUpdates = new Set([root]);
                    } else {
                        rootsWithPendingDiscreteUpdates.add(root);
                    }
                }
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, lane);
            }
            mostRecentlyUpdatedRoot = root;
        }
        function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
            sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
            var alternate = sourceFiber.alternate;
            if (alternate !== null) {
                alternate.lanes = mergeLanes(alternate.lanes, lane);
            }
            {
                if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
                    warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
                }
            }
            var node = sourceFiber;
            var parent = sourceFiber.return;
            while (parent !== null) {
                parent.childLanes = mergeLanes(parent.childLanes, lane);
                alternate = parent.alternate;
                if (alternate !== null) {
                    alternate.childLanes = mergeLanes(alternate.childLanes, lane);
                } else {
                    {
                        if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
                            warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
                        }
                    }
                }
                node = parent;
                parent = parent.return;
            }
            if (node.tag === HostRoot) {
                var root = node.stateNode;
                return root;
            } else {
                return null;
            }
        }
        function ensureRootIsScheduled(root, currentTime) {
            var existingCallbackNode = root.callbackNode;
            markStarvedLanesAsExpired(root, currentTime);
            var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
            var newCallbackPriority = returnNextLanesPriority();
            if (nextLanes === NoLanes) {
                if (existingCallbackNode !== null) {
                    cancelCallback(existingCallbackNode);
                    root.callbackNode = null;
                    root.callbackPriority = NoLanePriority;
                }
                return;
            }
            if (existingCallbackNode !== null) {
                var existingCallbackPriority = root.callbackPriority;
                if (existingCallbackPriority === newCallbackPriority) {
                    return;
                }
                cancelCallback(existingCallbackNode);
            }
            var newCallbackNode;
            if (newCallbackPriority === SyncLanePriority) {
                newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else if (newCallbackPriority === SyncBatchedLanePriority) {
                newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
            } else {
                var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
                newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
            }
            root.callbackPriority = newCallbackPriority;
            root.callbackNode = newCallbackNode;
        }
        function performConcurrentWorkOnRoot(root) {
            currentEventTime = NoTimestamp;
            currentEventWipLanes = NoLanes;
            currentEventPendingLanes = NoLanes;
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
                {
                    throw Error('Should not already be working.');
                }
            }
            var originalCallbackNode = root.callbackNode;
            var didFlushPassiveEffects = flushPassiveEffects();
            if (didFlushPassiveEffects) {
                if (root.callbackNode !== originalCallbackNode) {
                    return null;
                }
            }
            var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
            if (lanes === NoLanes) {
                return null;
            }
            var exitStatus = renderRootConcurrent(root, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
                prepareFreshStack(root, NoLanes);
            } else if (exitStatus !== RootIncomplete) {
                if (exitStatus === RootErrored) {
                    executionContext |= RetryAfterError;
                    if (root.hydrate) {
                        root.hydrate = false;
                        clearContainer(root.containerInfo);
                    }
                    lanes = getLanesToRetrySynchronouslyOnError(root);
                    if (lanes !== NoLanes) {
                        exitStatus = renderRootSync(root, lanes);
                    }
                }
                if (exitStatus === RootFatalErrored) {
                    var fatalError = workInProgressRootFatalError;
                    prepareFreshStack(root, NoLanes);
                    markRootSuspended$1(root, lanes);
                    ensureRootIsScheduled(root, now());
                    throw fatalError;
                }
                var finishedWork = root.current.alternate;
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
            ensureRootIsScheduled(root, now());
            if (root.callbackNode === originalCallbackNode) {
                return performConcurrentWorkOnRoot.bind(null, root);
            }
            return null;
        }
        function finishConcurrentRender(root, exitStatus, lanes) {
            switch (exitStatus) {
            case RootIncomplete:
            case RootFatalErrored: {
                    {
                        {
                            throw Error('Root did not complete. This is a bug in React.');
                        }
                    }
                }
            case RootErrored: {
                    commitRoot(root);
                    break;
                }
            case RootSuspended: {
                    markRootSuspended$1(root, lanes);
                    if (includesOnlyRetries(lanes) && !shouldForceFlushFallbacksInDEV()) {
                        var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now();
                        if (msUntilTimeout > 10) {
                            var nextLanes = getNextLanes(root, NoLanes);
                            if (nextLanes !== NoLanes) {
                                break;
                            }
                            var suspendedLanes = root.suspendedLanes;
                            if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                                var eventTime = requestEventTime();
                                markRootPinged(root, suspendedLanes);
                                break;
                            }
                            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                            break;
                        }
                    }
                    commitRoot(root);
                    break;
                }
            case RootSuspendedWithDelay: {
                    markRootSuspended$1(root, lanes);
                    if (includesOnlyTransitions(lanes)) {
                        break;
                    }
                    if (!shouldForceFlushFallbacksInDEV()) {
                        var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                        var eventTimeMs = mostRecentEventTime;
                        var timeElapsedMs = now() - eventTimeMs;
                        var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs;
                        if (_msUntilTimeout > 10) {
                            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                            break;
                        }
                    }
                    commitRoot(root);
                    break;
                }
            case RootCompleted: {
                    commitRoot(root);
                    break;
                }
            default: {
                    {
                        {
                            throw Error('Unknown root exit status.');
                        }
                    }
                }
            }
        }
        function markRootSuspended$1(root, suspendedLanes) {
            suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
            suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
            markRootSuspended(root, suspendedLanes);
        }
        function performSyncWorkOnRoot(root) {
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
                {
                    throw Error('Should not already be working.');
                }
            }
            flushPassiveEffects();
            var lanes;
            var exitStatus;
            if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
                lanes = workInProgressRootRenderLanes;
                exitStatus = renderRootSync(root, lanes);
                if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
                    lanes = getNextLanes(root, lanes);
                    exitStatus = renderRootSync(root, lanes);
                }
            } else {
                lanes = getNextLanes(root, NoLanes);
                exitStatus = renderRootSync(root, lanes);
            }
            if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
                executionContext |= RetryAfterError;
                if (root.hydrate) {
                    root.hydrate = false;
                    clearContainer(root.containerInfo);
                }
                lanes = getLanesToRetrySynchronouslyOnError(root);
                if (lanes !== NoLanes) {
                    exitStatus = renderRootSync(root, lanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            var finishedWork = root.current.alternate;
            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            commitRoot(root);
            ensureRootIsScheduled(root, now());
            return null;
        }
        function flushDiscreteUpdates() {
            if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
                {
                    if ((executionContext & RenderContext) !== NoContext) {
                        error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
                    }
                }
                return;
            }
            flushPendingDiscreteUpdates();
            flushPassiveEffects();
        }
        function flushPendingDiscreteUpdates() {
            if (rootsWithPendingDiscreteUpdates !== null) {
                var roots = rootsWithPendingDiscreteUpdates;
                rootsWithPendingDiscreteUpdates = null;
                roots.forEach(function (root) {
                    markDiscreteUpdatesExpired(root);
                    ensureRootIsScheduled(root, now());
                });
            }
            flushSyncCallbackQueue();
        }
        function batchedUpdates$1(fn, a) {
            var prevExecutionContext = executionContext;
            executionContext |= BatchedContext;
            try {
                return fn(a);
            } finally {
                executionContext = prevExecutionContext;
                if (executionContext === NoContext) {
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        }
        function batchedEventUpdates$1(fn, a) {
            var prevExecutionContext = executionContext;
            executionContext |= EventContext;
            try {
                return fn(a);
            } finally {
                executionContext = prevExecutionContext;
                if (executionContext === NoContext) {
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        }
        function discreteUpdates$1(fn, a, b, c, d) {
            var prevExecutionContext = executionContext;
            executionContext |= DiscreteEventContext;
            {
                try {
                    return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
                } finally {
                    executionContext = prevExecutionContext;
                    if (executionContext === NoContext) {
                        resetRenderTimer();
                        flushSyncCallbackQueue();
                    }
                }
            }
        }
        function unbatchedUpdates(fn, a) {
            var prevExecutionContext = executionContext;
            executionContext &= ~BatchedContext;
            executionContext |= LegacyUnbatchedContext;
            try {
                return fn(a);
            } finally {
                executionContext = prevExecutionContext;
                if (executionContext === NoContext) {
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        }
        function flushSync(fn, a) {
            var prevExecutionContext = executionContext;
            if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
                {
                    error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
                }
                return fn(a);
            }
            executionContext |= BatchedContext;
            {
                try {
                    if (fn) {
                        return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
                    } else {
                        return undefined;
                    }
                } finally {
                    executionContext = prevExecutionContext;
                    flushSyncCallbackQueue();
                }
            }
        }
        function pushRenderLanes(fiber, lanes) {
            push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
            subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
            workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
        }
        function popRenderLanes(fiber) {
            subtreeRenderLanes = subtreeRenderLanesCursor.current;
            pop(subtreeRenderLanesCursor, fiber);
        }
        function prepareFreshStack(root, lanes) {
            root.finishedWork = null;
            root.finishedLanes = NoLanes;
            var timeoutHandle = root.timeoutHandle;
            if (timeoutHandle !== noTimeout) {
                root.timeoutHandle = noTimeout;
                cancelTimeout(timeoutHandle);
            }
            if (workInProgress !== null) {
                var interruptedWork = workInProgress.return;
                while (interruptedWork !== null) {
                    unwindInterruptedWork(interruptedWork);
                    interruptedWork = interruptedWork.return;
                }
            }
            workInProgressRoot = root;
            workInProgress = createWorkInProgress(root.current, null);
            workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
            workInProgressRootExitStatus = RootIncomplete;
            workInProgressRootFatalError = null;
            workInProgressRootSkippedLanes = NoLanes;
            workInProgressRootUpdatedLanes = NoLanes;
            workInProgressRootPingedLanes = NoLanes;
            {
                spawnedWorkDuringRender = null;
            }
            {
                ReactStrictModeWarnings.discardPendingWarnings();
            }
        }
        function handleError(root, thrownValue) {
            do {
                var erroredWork = workInProgress;
                try {
                    resetContextDependencies();
                    resetHooksAfterThrow();
                    resetCurrentFiber();
                    ReactCurrentOwner$2.current = null;
                    if (erroredWork === null || erroredWork.return === null) {
                        workInProgressRootExitStatus = RootFatalErrored;
                        workInProgressRootFatalError = thrownValue;
                        workInProgress = null;
                        return;
                    }
                    if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
                        stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                    }
                    throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                    completeUnitOfWork(erroredWork);
                } catch (yetAnotherThrownValue) {
                    thrownValue = yetAnotherThrownValue;
                    if (workInProgress === erroredWork && erroredWork !== null) {
                        erroredWork = erroredWork.return;
                        workInProgress = erroredWork;
                    } else {
                        erroredWork = workInProgress;
                    }
                    continue;
                }
                return;
            } while (true);
        }
        function pushDispatcher() {
            var prevDispatcher = ReactCurrentDispatcher$2.current;
            ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
            if (prevDispatcher === null) {
                return ContextOnlyDispatcher;
            } else {
                return prevDispatcher;
            }
        }
        function popDispatcher(prevDispatcher) {
            ReactCurrentDispatcher$2.current = prevDispatcher;
        }
        function pushInteractions(root) {
            {
                var prevInteractions = tracing.__interactionsRef.current;
                tracing.__interactionsRef.current = root.memoizedInteractions;
                return prevInteractions;
            }
        }
        function popInteractions(prevInteractions) {
            {
                tracing.__interactionsRef.current = prevInteractions;
            }
        }
        function markCommitTimeOfFallback() {
            globalMostRecentFallbackTime = now();
        }
        function markSkippedUpdateLanes(lane) {
            workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
        }
        function renderDidSuspend() {
            if (workInProgressRootExitStatus === RootIncomplete) {
                workInProgressRootExitStatus = RootSuspended;
            }
        }
        function renderDidSuspendDelayIfPossible() {
            if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
                workInProgressRootExitStatus = RootSuspendedWithDelay;
            }
            if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
                markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
            }
        }
        function renderDidError() {
            if (workInProgressRootExitStatus !== RootCompleted) {
                workInProgressRootExitStatus = RootErrored;
            }
        }
        function renderHasNotSuspendedYet() {
            return workInProgressRootExitStatus === RootIncomplete;
        }
        function renderRootSync(root, lanes) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
                prepareFreshStack(root, lanes);
                startWorkOnPendingInteractions(root, lanes);
            }
            var prevInteractions = pushInteractions(root);
            do {
                try {
                    workLoopSync();
                    break;
                } catch (thrownValue) {
                    handleError(root, thrownValue);
                }
            } while (true);
            resetContextDependencies();
            {
                popInteractions(prevInteractions);
            }
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            if (workInProgress !== null) {
                {
                    {
                        throw Error('Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.');
                    }
                }
            }
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes;
            return workInProgressRootExitStatus;
        }
        function workLoopSync() {
            while (workInProgress !== null) {
                performUnitOfWork(workInProgress);
            }
        }
        function renderRootConcurrent(root, lanes) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
                resetRenderTimer();
                prepareFreshStack(root, lanes);
                startWorkOnPendingInteractions(root, lanes);
            }
            var prevInteractions = pushInteractions(root);
            do {
                try {
                    workLoopConcurrent();
                    break;
                } catch (thrownValue) {
                    handleError(root, thrownValue);
                }
            } while (true);
            resetContextDependencies();
            {
                popInteractions(prevInteractions);
            }
            popDispatcher(prevDispatcher);
            executionContext = prevExecutionContext;
            if (workInProgress !== null) {
                return RootIncomplete;
            } else {
                workInProgressRoot = null;
                workInProgressRootRenderLanes = NoLanes;
                return workInProgressRootExitStatus;
            }
        }
        function workLoopConcurrent() {
            while (workInProgress !== null && !shouldYield()) {
                performUnitOfWork(workInProgress);
            }
        }
        function performUnitOfWork(unitOfWork) {
            var current = unitOfWork.alternate;
            setCurrentFiber(unitOfWork);
            var next;
            if ((unitOfWork.mode & ProfileMode) !== NoMode) {
                startProfilerTimer(unitOfWork);
                next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
                stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
            } else {
                next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            }
            resetCurrentFiber();
            unitOfWork.memoizedProps = unitOfWork.pendingProps;
            if (next === null) {
                completeUnitOfWork(unitOfWork);
            } else {
                workInProgress = next;
            }
            ReactCurrentOwner$2.current = null;
        }
        function completeUnitOfWork(unitOfWork) {
            var completedWork = unitOfWork;
            do {
                var current = completedWork.alternate;
                var returnFiber = completedWork.return;
                if ((completedWork.flags & Incomplete) === NoFlags) {
                    setCurrentFiber(completedWork);
                    var next = void 0;
                    if ((completedWork.mode & ProfileMode) === NoMode) {
                        next = completeWork(current, completedWork, subtreeRenderLanes);
                    } else {
                        startProfilerTimer(completedWork);
                        next = completeWork(current, completedWork, subtreeRenderLanes);
                        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                    }
                    resetCurrentFiber();
                    if (next !== null) {
                        workInProgress = next;
                        return;
                    }
                    resetChildLanes(completedWork);
                    if (returnFiber !== null && (returnFiber.flags & Incomplete) === NoFlags) {
                        if (returnFiber.firstEffect === null) {
                            returnFiber.firstEffect = completedWork.firstEffect;
                        }
                        if (completedWork.lastEffect !== null) {
                            if (returnFiber.lastEffect !== null) {
                                returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                            }
                            returnFiber.lastEffect = completedWork.lastEffect;
                        }
                        var flags = completedWork.flags;
                        if (flags > PerformedWork) {
                            if (returnFiber.lastEffect !== null) {
                                returnFiber.lastEffect.nextEffect = completedWork;
                            } else {
                                returnFiber.firstEffect = completedWork;
                            }
                            returnFiber.lastEffect = completedWork;
                        }
                    }
                } else {
                    var _next = unwindWork(completedWork);
                    if (_next !== null) {
                        _next.flags &= HostEffectMask;
                        workInProgress = _next;
                        return;
                    }
                    if ((completedWork.mode & ProfileMode) !== NoMode) {
                        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                        var actualDuration = completedWork.actualDuration;
                        var child = completedWork.child;
                        while (child !== null) {
                            actualDuration += child.actualDuration;
                            child = child.sibling;
                        }
                        completedWork.actualDuration = actualDuration;
                    }
                    if (returnFiber !== null) {
                        returnFiber.firstEffect = returnFiber.lastEffect = null;
                        returnFiber.flags |= Incomplete;
                    }
                }
                var siblingFiber = completedWork.sibling;
                if (siblingFiber !== null) {
                    workInProgress = siblingFiber;
                    return;
                }
                completedWork = returnFiber;
                workInProgress = completedWork;
            } while (completedWork !== null);
            if (workInProgressRootExitStatus === RootIncomplete) {
                workInProgressRootExitStatus = RootCompleted;
            }
        }
        function resetChildLanes(completedWork) {
            if ((completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) {
                return;
            }
            var newChildLanes = NoLanes;
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
                var child = completedWork.child;
                while (child !== null) {
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    if (shouldBubbleActualDurations) {
                        actualDuration += child.actualDuration;
                    }
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
                if (isTimedOutSuspense) {
                    var primaryChildFragment = completedWork.child;
                    if (primaryChildFragment !== null) {
                        treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while (_child !== null) {
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    _child = _child.sibling;
                }
            }
            completedWork.childLanes = newChildLanes;
        }
        function commitRoot(root) {
            var renderPriorityLevel = getCurrentPriorityLevel();
            runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
            return null;
        }
        function commitRootImpl(root, renderPriorityLevel) {
            do {
                flushPassiveEffects();
            } while (rootWithPendingPassiveEffects !== null);
            flushRenderPhaseStrictModeWarningsInDEV();
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
                {
                    throw Error('Should not already be working.');
                }
            }
            var finishedWork = root.finishedWork;
            var lanes = root.finishedLanes;
            if (finishedWork === null) {
                return null;
            }
            root.finishedWork = null;
            root.finishedLanes = NoLanes;
            if (!(finishedWork !== root.current)) {
                {
                    throw Error('Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.');
                }
            }
            root.callbackNode = null;
            var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
            markRootFinished(root, remainingLanes);
            if (rootsWithPendingDiscreteUpdates !== null) {
                if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) {
                    rootsWithPendingDiscreteUpdates.delete(root);
                }
            }
            if (root === workInProgressRoot) {
                workInProgressRoot = null;
                workInProgress = null;
                workInProgressRootRenderLanes = NoLanes;
            }
            var firstEffect;
            if (finishedWork.flags > PerformedWork) {
                if (finishedWork.lastEffect !== null) {
                    finishedWork.lastEffect.nextEffect = finishedWork;
                    firstEffect = finishedWork.firstEffect;
                } else {
                    firstEffect = finishedWork;
                }
            } else {
                firstEffect = finishedWork.firstEffect;
            }
            if (firstEffect !== null) {
                var prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                var prevInteractions = pushInteractions(root);
                ReactCurrentOwner$2.current = null;
                focusedInstanceHandle = prepareForCommit(root.containerInfo);
                shouldFireAfterActiveInstanceBlur = false;
                nextEffect = firstEffect;
                do {
                    {
                        invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                        if (hasCaughtError()) {
                            if (!(nextEffect !== null)) {
                                {
                                    throw Error('Should be working on an effect.');
                                }
                            }
                            var error = clearCaughtError();
                            captureCommitPhaseError(nextEffect, error);
                            nextEffect = nextEffect.nextEffect;
                        }
                    }
                } while (nextEffect !== null);
                focusedInstanceHandle = null;
                {
                    recordCommitTime();
                }
                nextEffect = firstEffect;
                do {
                    {
                        invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                        if (hasCaughtError()) {
                            if (!(nextEffect !== null)) {
                                {
                                    throw Error('Should be working on an effect.');
                                }
                            }
                            var _error = clearCaughtError();
                            captureCommitPhaseError(nextEffect, _error);
                            nextEffect = nextEffect.nextEffect;
                        }
                    }
                } while (nextEffect !== null);
                resetAfterCommit(root.containerInfo);
                root.current = finishedWork;
                nextEffect = firstEffect;
                do {
                    {
                        invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);
                        if (hasCaughtError()) {
                            if (!(nextEffect !== null)) {
                                {
                                    throw Error('Should be working on an effect.');
                                }
                            }
                            var _error2 = clearCaughtError();
                            captureCommitPhaseError(nextEffect, _error2);
                            nextEffect = nextEffect.nextEffect;
                        }
                    }
                } while (nextEffect !== null);
                nextEffect = null;
                requestPaint();
                {
                    popInteractions(prevInteractions);
                }
                executionContext = prevExecutionContext;
            } else {
                root.current = finishedWork;
                {
                    recordCommitTime();
                }
            }
            var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
            if (rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = false;
                rootWithPendingPassiveEffects = root;
                pendingPassiveEffectsLanes = lanes;
                pendingPassiveEffectsRenderPriority = renderPriorityLevel;
            } else {
                nextEffect = firstEffect;
                while (nextEffect !== null) {
                    var nextNextEffect = nextEffect.nextEffect;
                    nextEffect.nextEffect = null;
                    if (nextEffect.flags & Deletion) {
                        detachFiberAfterEffects(nextEffect);
                    }
                    nextEffect = nextNextEffect;
                }
            }
            remainingLanes = root.pendingLanes;
            if (remainingLanes !== NoLanes) {
                {
                    if (spawnedWorkDuringRender !== null) {
                        var expirationTimes = spawnedWorkDuringRender;
                        spawnedWorkDuringRender = null;
                        for (var i = 0; i < expirationTimes.length; i++) {
                            scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
                        }
                    }
                    schedulePendingInteractions(root, remainingLanes);
                }
            } else {
                legacyErrorBoundariesThatAlreadyFailed = null;
            }
            {
                if (!rootDidHavePassiveEffects) {
                    finishPendingInteractions(root, lanes);
                }
            }
            if (remainingLanes === SyncLane) {
                if (root === rootWithNestedUpdates) {
                    nestedUpdateCount++;
                } else {
                    nestedUpdateCount = 0;
                    rootWithNestedUpdates = root;
                }
            } else {
                nestedUpdateCount = 0;
            }
            onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
            {
                onCommitRoot$1();
            }
            ensureRootIsScheduled(root, now());
            if (hasUncaughtError) {
                hasUncaughtError = false;
                var _error3 = firstUncaughtError;
                firstUncaughtError = null;
                throw _error3;
            }
            if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
                return null;
            }
            flushSyncCallbackQueue();
            return null;
        }
        function commitBeforeMutationEffects() {
            while (nextEffect !== null) {
                var current = nextEffect.alternate;
                if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
                    if ((nextEffect.flags & Deletion) !== NoFlags) {
                        if (doesFiberContain(nextEffect, focusedInstanceHandle)) {
                            shouldFireAfterActiveInstanceBlur = true;
                        }
                    } else {
                        if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) {
                            shouldFireAfterActiveInstanceBlur = true;
                        }
                    }
                }
                var flags = nextEffect.flags;
                if ((flags & Snapshot) !== NoFlags) {
                    setCurrentFiber(nextEffect);
                    commitBeforeMutationLifeCycles(current, nextEffect);
                    resetCurrentFiber();
                }
                if ((flags & Passive) !== NoFlags) {
                    if (!rootDoesHavePassiveEffects) {
                        rootDoesHavePassiveEffects = true;
                        scheduleCallback(NormalPriority$1, function () {
                            flushPassiveEffects();
                            return null;
                        });
                    }
                }
                nextEffect = nextEffect.nextEffect;
            }
        }
        function commitMutationEffects(root, renderPriorityLevel) {
            while (nextEffect !== null) {
                setCurrentFiber(nextEffect);
                var flags = nextEffect.flags;
                if (flags & ContentReset) {
                    commitResetTextContent(nextEffect);
                }
                if (flags & Ref) {
                    var current = nextEffect.alternate;
                    if (current !== null) {
                        commitDetachRef(current);
                    }
                }
                var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);
                switch (primaryFlags) {
                case Placement: {
                        commitPlacement(nextEffect);
                        nextEffect.flags &= ~Placement;
                        break;
                    }
                case PlacementAndUpdate: {
                        commitPlacement(nextEffect);
                        nextEffect.flags &= ~Placement;
                        var _current = nextEffect.alternate;
                        commitWork(_current, nextEffect);
                        break;
                    }
                case Hydrating: {
                        nextEffect.flags &= ~Hydrating;
                        break;
                    }
                case HydratingAndUpdate: {
                        nextEffect.flags &= ~Hydrating;
                        var _current2 = nextEffect.alternate;
                        commitWork(_current2, nextEffect);
                        break;
                    }
                case Update: {
                        var _current3 = nextEffect.alternate;
                        commitWork(_current3, nextEffect);
                        break;
                    }
                case Deletion: {
                        commitDeletion(root, nextEffect);
                        break;
                    }
                }
                resetCurrentFiber();
                nextEffect = nextEffect.nextEffect;
            }
        }
        function commitLayoutEffects(root, committedLanes) {
            while (nextEffect !== null) {
                setCurrentFiber(nextEffect);
                var flags = nextEffect.flags;
                if (flags & (Update | Callback)) {
                    var current = nextEffect.alternate;
                    commitLifeCycles(root, current, nextEffect);
                }
                {
                    if (flags & Ref) {
                        commitAttachRef(nextEffect);
                    }
                }
                resetCurrentFiber();
                nextEffect = nextEffect.nextEffect;
            }
        }
        function flushPassiveEffects() {
            if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
                var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
                pendingPassiveEffectsRenderPriority = NoPriority$1;
                {
                    return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
                }
            }
            return false;
        }
        function enqueuePendingPassiveHookEffectMount(fiber, effect) {
            pendingPassiveHookEffectsMount.push(effect, fiber);
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                scheduleCallback(NormalPriority$1, function () {
                    flushPassiveEffects();
                    return null;
                });
            }
        }
        function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
            pendingPassiveHookEffectsUnmount.push(effect, fiber);
            {
                fiber.flags |= PassiveUnmountPendingDev;
                var alternate = fiber.alternate;
                if (alternate !== null) {
                    alternate.flags |= PassiveUnmountPendingDev;
                }
            }
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                scheduleCallback(NormalPriority$1, function () {
                    flushPassiveEffects();
                    return null;
                });
            }
        }
        function invokePassiveEffectCreate(effect) {
            var create = effect.create;
            effect.destroy = create();
        }
        function flushPassiveEffectsImpl() {
            if (rootWithPendingPassiveEffects === null) {
                return false;
            }
            var root = rootWithPendingPassiveEffects;
            var lanes = pendingPassiveEffectsLanes;
            rootWithPendingPassiveEffects = null;
            pendingPassiveEffectsLanes = NoLanes;
            if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
                {
                    throw Error('Cannot flush passive effects while already rendering.');
                }
            }
            {
                isFlushingPassiveEffects = true;
            }
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root);
            var unmountEffects = pendingPassiveHookEffectsUnmount;
            pendingPassiveHookEffectsUnmount = [];
            for (var i = 0; i < unmountEffects.length; i += 2) {
                var _effect = unmountEffects[i];
                var fiber = unmountEffects[i + 1];
                var destroy = _effect.destroy;
                _effect.destroy = undefined;
                {
                    fiber.flags &= ~PassiveUnmountPendingDev;
                    var alternate = fiber.alternate;
                    if (alternate !== null) {
                        alternate.flags &= ~PassiveUnmountPendingDev;
                    }
                }
                if (typeof destroy === 'function') {
                    {
                        setCurrentFiber(fiber);
                        {
                            invokeGuardedCallback(null, destroy, null);
                        }
                        if (hasCaughtError()) {
                            if (!(fiber !== null)) {
                                {
                                    throw Error('Should be working on an effect.');
                                }
                            }
                            var error = clearCaughtError();
                            captureCommitPhaseError(fiber, error);
                        }
                        resetCurrentFiber();
                    }
                }
            }
            var mountEffects = pendingPassiveHookEffectsMount;
            pendingPassiveHookEffectsMount = [];
            for (var _i = 0; _i < mountEffects.length; _i += 2) {
                var _effect2 = mountEffects[_i];
                var _fiber = mountEffects[_i + 1];
                {
                    setCurrentFiber(_fiber);
                    {
                        invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
                    }
                    if (hasCaughtError()) {
                        if (!(_fiber !== null)) {
                            {
                                throw Error('Should be working on an effect.');
                            }
                        }
                        var _error4 = clearCaughtError();
                        captureCommitPhaseError(_fiber, _error4);
                    }
                    resetCurrentFiber();
                }
            }
            var effect = root.current.firstEffect;
            while (effect !== null) {
                var nextNextEffect = effect.nextEffect;
                effect.nextEffect = null;
                if (effect.flags & Deletion) {
                    detachFiberAfterEffects(effect);
                }
                effect = nextNextEffect;
            }
            {
                popInteractions(prevInteractions);
                finishPendingInteractions(root, lanes);
            }
            {
                isFlushingPassiveEffects = false;
            }
            executionContext = prevExecutionContext;
            flushSyncCallbackQueue();
            nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
            return true;
        }
        function isAlreadyFailedLegacyErrorBoundary(instance) {
            return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
        }
        function markLegacyErrorBoundaryAsFailed(instance) {
            if (legacyErrorBoundariesThatAlreadyFailed === null) {
                legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
            } else {
                legacyErrorBoundariesThatAlreadyFailed.add(instance);
            }
        }
        function prepareToThrowUncaughtError(error) {
            if (!hasUncaughtError) {
                hasUncaughtError = true;
                firstUncaughtError = error;
            }
        }
        var onUncaughtError = prepareToThrowUncaughtError;
        function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
            var errorInfo = createCapturedValue(error, sourceFiber);
            var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
            enqueueUpdate(rootFiber, update);
            var eventTime = requestEventTime();
            var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
            if (root !== null) {
                markRootUpdated(root, SyncLane, eventTime);
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, SyncLane);
            }
        }
        function captureCommitPhaseError(sourceFiber, error) {
            if (sourceFiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
                return;
            }
            var fiber = sourceFiber.return;
            while (fiber !== null) {
                if (fiber.tag === HostRoot) {
                    captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                    return;
                } else if (fiber.tag === ClassComponent) {
                    var ctor = fiber.type;
                    var instance = fiber.stateNode;
                    if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                        var errorInfo = createCapturedValue(error, sourceFiber);
                        var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                        enqueueUpdate(fiber, update);
                        var eventTime = requestEventTime();
                        var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                        if (root !== null) {
                            markRootUpdated(root, SyncLane, eventTime);
                            ensureRootIsScheduled(root, eventTime);
                            schedulePendingInteractions(root, SyncLane);
                        } else {
                            if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                                try {
                                    instance.componentDidCatch(error, errorInfo);
                                } catch (errorToIgnore) {
                                }
                            }
                        }
                        return;
                    }
                }
                fiber = fiber.return;
            }
        }
        function pingSuspendedRoot(root, wakeable, pingedLanes) {
            var pingCache = root.pingCache;
            if (pingCache !== null) {
                pingCache.delete(wakeable);
            }
            var eventTime = requestEventTime();
            markRootPinged(root, pingedLanes);
            if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
                if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
                    prepareFreshStack(root, NoLanes);
                } else {
                    workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
                }
            }
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, pingedLanes);
        }
        function retryTimedOutBoundary(boundaryFiber, retryLane) {
            if (retryLane === NoLane) {
                retryLane = requestRetryLane(boundaryFiber);
            }
            var eventTime = requestEventTime();
            var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
            if (root !== null) {
                markRootUpdated(root, retryLane, eventTime);
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, retryLane);
            }
        }
        function resolveRetryWakeable(boundaryFiber, wakeable) {
            var retryLane = NoLane;
            var retryCache;
            {
                retryCache = boundaryFiber.stateNode;
            }
            if (retryCache !== null) {
                retryCache.delete(wakeable);
            }
            retryTimedOutBoundary(boundaryFiber, retryLane);
        }
        function jnd(timeElapsed) {
            return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
        }
        function checkForNestedUpdates() {
            if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = null;
                {
                    {
                        throw Error('Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.');
                    }
                }
            }
            {
                if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
                    nestedPassiveUpdateCount = 0;
                    error('Maximum update depth exceeded. This can happen when a component ' + 'calls setState inside useEffect, but useEffect either doesn\'t ' + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
                }
            }
        }
        function flushRenderPhaseStrictModeWarningsInDEV() {
            {
                ReactStrictModeWarnings.flushLegacyContextWarning();
                {
                    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
                }
            }
        }
        var didWarnStateUpdateForNotYetMountedComponent = null;
        function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
            {
                if ((executionContext & RenderContext) !== NoContext) {
                    return;
                }
                if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
                    return;
                }
                var tag = fiber.tag;
                if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
                    return;
                }
                var componentName = getComponentName(fiber.type) || 'ReactComponent';
                if (didWarnStateUpdateForNotYetMountedComponent !== null) {
                    if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
                        return;
                    }
                    didWarnStateUpdateForNotYetMountedComponent.add(componentName);
                } else {
                    didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
                }
                var previousFiber = current;
                try {
                    setCurrentFiber(fiber);
                    error('Can\'t perform a React state update on a component that hasn\'t mounted yet. ' + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
                } finally {
                    if (previousFiber) {
                        setCurrentFiber(fiber);
                    } else {
                        resetCurrentFiber();
                    }
                }
            }
        }
        var didWarnStateUpdateForUnmountedComponent = null;
        function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
            {
                var tag = fiber.tag;
                if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
                    return;
                }
                if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
                    return;
                }
                var componentName = getComponentName(fiber.type) || 'ReactComponent';
                if (didWarnStateUpdateForUnmountedComponent !== null) {
                    if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
                        return;
                    }
                    didWarnStateUpdateForUnmountedComponent.add(componentName);
                } else {
                    didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
                }
                if (isFlushingPassiveEffects);
                else {
                    var previousFiber = current;
                    try {
                        setCurrentFiber(fiber);
                        error('Can\'t perform a React state update on an unmounted component. This ' + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
                    } finally {
                        if (previousFiber) {
                            setCurrentFiber(fiber);
                        } else {
                            resetCurrentFiber();
                        }
                    }
                }
            }
        }
        var beginWork$1;
        {
            var dummyFiber = null;
            beginWork$1 = function (current, unitOfWork, lanes) {
                var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
                try {
                    return beginWork(current, unitOfWork, lanes);
                } catch (originalError) {
                    if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
                        throw originalError;
                    }
                    resetContextDependencies();
                    resetHooksAfterThrow();
                    unwindInterruptedWork(unitOfWork);
                    assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
                    if (unitOfWork.mode & ProfileMode) {
                        startProfilerTimer(unitOfWork);
                    }
                    invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
                    if (hasCaughtError()) {
                        var replayError = clearCaughtError();
                        throw replayError;
                    } else {
                        throw originalError;
                    }
                }
            };
        }
        var didWarnAboutUpdateInRender = false;
        var didWarnAboutUpdateInRenderForAnotherComponent;
        {
            didWarnAboutUpdateInRenderForAnotherComponent = new Set();
        }
        function warnAboutRenderPhaseUpdatesInDEV(fiber) {
            {
                if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
                    switch (fiber.tag) {
                    case FunctionComponent:
                    case ForwardRef:
                    case SimpleMemoComponent: {
                            var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown';
                            var dedupeKey = renderingComponentName;
                            if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                                didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                                var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                                error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                            }
                            break;
                        }
                    case ClassComponent: {
                            if (!didWarnAboutUpdateInRender) {
                                error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                                didWarnAboutUpdateInRender = true;
                            }
                            break;
                        }
                    }
                }
            }
        }
        var IsThisRendererActing = { current: false };
        function warnIfNotScopedWithMatchingAct(fiber) {
            {
                if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
                    var previousFiber = current;
                    try {
                        setCurrentFiber(fiber);
                        error('It looks like you\'re using the wrong act() around your test interactions.\n' + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + 'import {act} fr' + 'om \'react-dom/test-utils\';\n' + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + 'import TestRenderer fr' + 'om react-test-renderer\';\n' + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);');
                    } finally {
                        if (previousFiber) {
                            setCurrentFiber(fiber);
                        } else {
                            resetCurrentFiber();
                        }
                    }
                }
            }
        }
        function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
            {
                if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
                    error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + 'This ensures that you\'re testing the behavior the user would see ' + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
                }
            }
        }
        function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
            {
                if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
                    var previousFiber = current;
                    try {
                        setCurrentFiber(fiber);
                        error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + 'This ensures that you\'re testing the behavior the user would see ' + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
                    } finally {
                        if (previousFiber) {
                            setCurrentFiber(fiber);
                        } else {
                            resetCurrentFiber();
                        }
                    }
                }
            }
        }
        var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV;
        var didWarnAboutUnmockedScheduler = false;
        function warnIfUnmockedScheduler(fiber) {
            {
                if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
                    if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                        didWarnAboutUnmockedScheduler = true;
                        error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + 'jest.mock(\'scheduler\', () => require' + '(\'scheduler/unstable_mock\'));\n\n' + 'For more info, visit https://reactjs.org/link/mock-scheduler');
                    }
                }
            }
        }
        function computeThreadID(root, lane) {
            return lane * 1000 + root.interactionThreadID;
        }
        function markSpawnedWork(lane) {
            if (spawnedWorkDuringRender === null) {
                spawnedWorkDuringRender = [lane];
            } else {
                spawnedWorkDuringRender.push(lane);
            }
        }
        function scheduleInteractions(root, lane, interactions) {
            if (interactions.size > 0) {
                var pendingInteractionMap = root.pendingInteractionMap;
                var pendingInteractions = pendingInteractionMap.get(lane);
                if (pendingInteractions != null) {
                    interactions.forEach(function (interaction) {
                        if (!pendingInteractions.has(interaction)) {
                            interaction.__count++;
                        }
                        pendingInteractions.add(interaction);
                    });
                } else {
                    pendingInteractionMap.set(lane, new Set(interactions));
                    interactions.forEach(function (interaction) {
                        interaction.__count++;
                    });
                }
                var subscriber = tracing.__subscriberRef.current;
                if (subscriber !== null) {
                    var threadID = computeThreadID(root, lane);
                    subscriber.onWorkScheduled(interactions, threadID);
                }
            }
        }
        function schedulePendingInteractions(root, lane) {
            scheduleInteractions(root, lane, tracing.__interactionsRef.current);
        }
        function startWorkOnPendingInteractions(root, lanes) {
            var interactions = new Set();
            root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledLane) {
                if (includesSomeLane(lanes, scheduledLane)) {
                    scheduledInteractions.forEach(function (interaction) {
                        return interactions.add(interaction);
                    });
                }
            });
            root.memoizedInteractions = interactions;
            if (interactions.size > 0) {
                var subscriber = tracing.__subscriberRef.current;
                if (subscriber !== null) {
                    var threadID = computeThreadID(root, lanes);
                    try {
                        subscriber.onWorkStarted(interactions, threadID);
                    } catch (error) {
                        scheduleCallback(ImmediatePriority$1, function () {
                            throw error;
                        });
                    }
                }
            }
        }
        function finishPendingInteractions(root, committedLanes) {
            var remainingLanesAfterCommit = root.pendingLanes;
            var subscriber;
            try {
                subscriber = tracing.__subscriberRef.current;
                if (subscriber !== null && root.memoizedInteractions.size > 0) {
                    var threadID = computeThreadID(root, committedLanes);
                    subscriber.onWorkStopped(root.memoizedInteractions, threadID);
                }
            } catch (error) {
                scheduleCallback(ImmediatePriority$1, function () {
                    throw error;
                });
            } finally {
                var pendingInteractionMap = root.pendingInteractionMap;
                pendingInteractionMap.forEach(function (scheduledInteractions, lane) {
                    if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                        pendingInteractionMap.delete(lane);
                        scheduledInteractions.forEach(function (interaction) {
                            interaction.__count--;
                            if (subscriber !== null && interaction.__count === 0) {
                                try {
                                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                                } catch (error) {
                                    scheduleCallback(ImmediatePriority$1, function () {
                                        throw error;
                                    });
                                }
                            }
                        });
                    }
                });
            }
        }
        function shouldForceFlushFallbacksInDEV() {
            return actingUpdatesScopeDepth > 0;
        }
        var actingUpdatesScopeDepth = 0;
        function detachFiberAfterEffects(fiber) {
            fiber.sibling = null;
            fiber.stateNode = null;
        }
        var resolveFamily = null;
        var failedBoundaries = null;
        var setRefreshHandler = function (handler) {
            {
                resolveFamily = handler;
            }
        };
        function resolveFunctionForHotReloading(type) {
            {
                if (resolveFamily === null) {
                    return type;
                }
                var family = resolveFamily(type);
                if (family === undefined) {
                    return type;
                }
                return family.current;
            }
        }
        function resolveClassForHotReloading(type) {
            return resolveFunctionForHotReloading(type);
        }
        function resolveForwardRefForHotReloading(type) {
            {
                if (resolveFamily === null) {
                    return type;
                }
                var family = resolveFamily(type);
                if (family === undefined) {
                    if (type !== null && type !== undefined && typeof type.render === 'function') {
                        var currentRender = resolveFunctionForHotReloading(type.render);
                        if (type.render !== currentRender) {
                            var syntheticType = {
                                $$typeof: REACT_FORWARD_REF_TYPE,
                                render: currentRender
                            };
                            if (type.displayName !== undefined) {
                                syntheticType.displayName = type.displayName;
                            }
                            return syntheticType;
                        }
                    }
                    return type;
                }
                return family.current;
            }
        }
        function isCompatibleFamilyForHotReloading(fiber, element) {
            {
                if (resolveFamily === null) {
                    return false;
                }
                var prevType = fiber.elementType;
                var nextType = element.type;
                var needsCompareFamilies = false;
                var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
                switch (fiber.tag) {
                case ClassComponent: {
                        if (typeof nextType === 'function') {
                            needsCompareFamilies = true;
                        }
                        break;
                    }
                case FunctionComponent: {
                        if (typeof nextType === 'function') {
                            needsCompareFamilies = true;
                        } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                            needsCompareFamilies = true;
                        }
                        break;
                    }
                case ForwardRef: {
                        if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                            needsCompareFamilies = true;
                        } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                            needsCompareFamilies = true;
                        }
                        break;
                    }
                case MemoComponent:
                case SimpleMemoComponent: {
                        if ($$typeofNextType === REACT_MEMO_TYPE) {
                            needsCompareFamilies = true;
                        } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                            needsCompareFamilies = true;
                        }
                        break;
                    }
                default:
                    return false;
                }
                if (needsCompareFamilies) {
                    var prevFamily = resolveFamily(prevType);
                    if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
                        return true;
                    }
                }
                return false;
            }
        }
        function markFailedErrorBoundaryForHotReloading(fiber) {
            {
                if (resolveFamily === null) {
                    return;
                }
                if (typeof WeakSet !== 'function') {
                    return;
                }
                if (failedBoundaries === null) {
                    failedBoundaries = new WeakSet();
                }
                failedBoundaries.add(fiber);
            }
        }
        var scheduleRefresh = function (root, update) {
            {
                if (resolveFamily === null) {
                    return;
                }
                var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
                flushPassiveEffects();
                flushSync(function () {
                    scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
                });
            }
        };
        var scheduleRoot = function (root, element) {
            {
                if (root.context !== emptyContextObject) {
                    return;
                }
                flushPassiveEffects();
                flushSync(function () {
                    updateContainer(element, root, null, null);
                });
            }
        };
        function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
            {
                var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
                var candidateType = null;
                switch (tag) {
                case FunctionComponent:
                case SimpleMemoComponent:
                case ClassComponent:
                    candidateType = type;
                    break;
                case ForwardRef:
                    candidateType = type.render;
                    break;
                }
                if (resolveFamily === null) {
                    throw new Error('Expected resolveFamily to be set during hot reload.');
                }
                var needsRender = false;
                var needsRemount = false;
                if (candidateType !== null) {
                    var family = resolveFamily(candidateType);
                    if (family !== undefined) {
                        if (staleFamilies.has(family)) {
                            needsRemount = true;
                        } else if (updatedFamilies.has(family)) {
                            if (tag === ClassComponent) {
                                needsRemount = true;
                            } else {
                                needsRender = true;
                            }
                        }
                    }
                }
                if (failedBoundaries !== null) {
                    if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
                        needsRemount = true;
                    }
                }
                if (needsRemount) {
                    fiber._debugNeedsRemount = true;
                }
                if (needsRemount || needsRender) {
                    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
                }
                if (child !== null && !needsRemount) {
                    scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
                }
                if (sibling !== null) {
                    scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
                }
            }
        }
        var findHostInstancesForRefresh = function (root, families) {
            {
                var hostInstances = new Set();
                var types = new Set(families.map(function (family) {
                    return family.current;
                }));
                findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
                return hostInstances;
            }
        };
        function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
            {
                var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
                var candidateType = null;
                switch (tag) {
                case FunctionComponent:
                case SimpleMemoComponent:
                case ClassComponent:
                    candidateType = type;
                    break;
                case ForwardRef:
                    candidateType = type.render;
                    break;
                }
                var didMatch = false;
                if (candidateType !== null) {
                    if (types.has(candidateType)) {
                        didMatch = true;
                    }
                }
                if (didMatch) {
                    findHostInstancesForFiberShallowly(fiber, hostInstances);
                } else {
                    if (child !== null) {
                        findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
                    }
                }
                if (sibling !== null) {
                    findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
                }
            }
        }
        function findHostInstancesForFiberShallowly(fiber, hostInstances) {
            {
                var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
                if (foundHostInstances) {
                    return;
                }
                var node = fiber;
                while (true) {
                    switch (node.tag) {
                    case HostComponent:
                        hostInstances.add(node.stateNode);
                        return;
                    case HostPortal:
                        hostInstances.add(node.stateNode.containerInfo);
                        return;
                    case HostRoot:
                        hostInstances.add(node.stateNode.containerInfo);
                        return;
                    }
                    if (node.return === null) {
                        throw new Error('Expected to reach root first.');
                    }
                    node = node.return;
                }
            }
        }
        function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
            {
                var node = fiber;
                var foundHostInstances = false;
                while (true) {
                    if (node.tag === HostComponent) {
                        foundHostInstances = true;
                        hostInstances.add(node.stateNode);
                    } else if (node.child !== null) {
                        node.child.return = node;
                        node = node.child;
                        continue;
                    }
                    if (node === fiber) {
                        return foundHostInstances;
                    }
                    while (node.sibling === null) {
                        if (node.return === null || node.return === fiber) {
                            return foundHostInstances;
                        }
                        node = node.return;
                    }
                    node.sibling.return = node.return;
                    node = node.sibling;
                }
            }
            return false;
        }
        var hasBadMapPolyfill;
        {
            hasBadMapPolyfill = false;
            try {
                var nonExtensibleObject = Object.preventExtensions({});
                new Map([[
                        nonExtensibleObject,
                        null
                    ]]);
                new Set([nonExtensibleObject]);
            } catch (e) {
                hasBadMapPolyfill = true;
            }
        }
        var debugCounter = 1;
        function FiberNode(tag, pendingProps, key, mode) {
            this.tag = tag;
            this.key = key;
            this.elementType = null;
            this.type = null;
            this.stateNode = null;
            this.return = null;
            this.child = null;
            this.sibling = null;
            this.index = 0;
            this.ref = null;
            this.pendingProps = pendingProps;
            this.memoizedProps = null;
            this.updateQueue = null;
            this.memoizedState = null;
            this.dependencies = null;
            this.mode = mode;
            this.flags = NoFlags;
            this.nextEffect = null;
            this.firstEffect = null;
            this.lastEffect = null;
            this.lanes = NoLanes;
            this.childLanes = NoLanes;
            this.alternate = null;
            {
                this.actualDuration = Number.NaN;
                this.actualStartTime = Number.NaN;
                this.selfBaseDuration = Number.NaN;
                this.treeBaseDuration = Number.NaN;
                this.actualDuration = 0;
                this.actualStartTime = -1;
                this.selfBaseDuration = 0;
                this.treeBaseDuration = 0;
            }
            {
                this._debugID = debugCounter++;
                this._debugSource = null;
                this._debugOwner = null;
                this._debugNeedsRemount = false;
                this._debugHookTypes = null;
                if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
                    Object.preventExtensions(this);
                }
            }
        }
        var createFiber = function (tag, pendingProps, key, mode) {
            return new FiberNode(tag, pendingProps, key, mode);
        };
        function shouldConstruct$1(Component) {
            var prototype = Component.prototype;
            return !!(prototype && prototype.isReactComponent);
        }
        function isSimpleFunctionComponent(type) {
            return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
        }
        function resolveLazyComponentTag(Component) {
            if (typeof Component === 'function') {
                return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
            } else if (Component !== undefined && Component !== null) {
                var $$typeof = Component.$$typeof;
                if ($$typeof === REACT_FORWARD_REF_TYPE) {
                    return ForwardRef;
                }
                if ($$typeof === REACT_MEMO_TYPE) {
                    return MemoComponent;
                }
            }
            return IndeterminateComponent;
        }
        function createWorkInProgress(current, pendingProps) {
            var workInProgress = current.alternate;
            if (workInProgress === null) {
                workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
                workInProgress.elementType = current.elementType;
                workInProgress.type = current.type;
                workInProgress.stateNode = current.stateNode;
                {
                    workInProgress._debugID = current._debugID;
                    workInProgress._debugSource = current._debugSource;
                    workInProgress._debugOwner = current._debugOwner;
                    workInProgress._debugHookTypes = current._debugHookTypes;
                }
                workInProgress.alternate = current;
                current.alternate = workInProgress;
            } else {
                workInProgress.pendingProps = pendingProps;
                workInProgress.type = current.type;
                workInProgress.flags = NoFlags;
                workInProgress.nextEffect = null;
                workInProgress.firstEffect = null;
                workInProgress.lastEffect = null;
                {
                    workInProgress.actualDuration = 0;
                    workInProgress.actualStartTime = -1;
                }
            }
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue;
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            workInProgress.sibling = current.sibling;
            workInProgress.index = current.index;
            workInProgress.ref = current.ref;
            {
                workInProgress.selfBaseDuration = current.selfBaseDuration;
                workInProgress.treeBaseDuration = current.treeBaseDuration;
            }
            {
                workInProgress._debugNeedsRemount = current._debugNeedsRemount;
                switch (workInProgress.tag) {
                case IndeterminateComponent:
                case FunctionComponent:
                case SimpleMemoComponent:
                    workInProgress.type = resolveFunctionForHotReloading(current.type);
                    break;
                case ClassComponent:
                    workInProgress.type = resolveClassForHotReloading(current.type);
                    break;
                case ForwardRef:
                    workInProgress.type = resolveForwardRefForHotReloading(current.type);
                    break;
                }
            }
            return workInProgress;
        }
        function resetWorkInProgress(workInProgress, renderLanes) {
            workInProgress.flags &= Placement;
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            var current = workInProgress.alternate;
            if (current === null) {
                workInProgress.childLanes = NoLanes;
                workInProgress.lanes = renderLanes;
                workInProgress.child = null;
                workInProgress.memoizedProps = null;
                workInProgress.memoizedState = null;
                workInProgress.updateQueue = null;
                workInProgress.dependencies = null;
                workInProgress.stateNode = null;
                {
                    workInProgress.selfBaseDuration = 0;
                    workInProgress.treeBaseDuration = 0;
                }
            } else {
                workInProgress.childLanes = current.childLanes;
                workInProgress.lanes = current.lanes;
                workInProgress.child = current.child;
                workInProgress.memoizedProps = current.memoizedProps;
                workInProgress.memoizedState = current.memoizedState;
                workInProgress.updateQueue = current.updateQueue;
                workInProgress.type = current.type;
                var currentDependencies = current.dependencies;
                workInProgress.dependencies = currentDependencies === null ? null : {
                    lanes: currentDependencies.lanes,
                    firstContext: currentDependencies.firstContext
                };
                {
                    workInProgress.selfBaseDuration = current.selfBaseDuration;
                    workInProgress.treeBaseDuration = current.treeBaseDuration;
                }
            }
            return workInProgress;
        }
        function createHostRootFiber(tag) {
            var mode;
            if (tag === ConcurrentRoot) {
                mode = ConcurrentMode | BlockingMode | StrictMode;
            } else if (tag === BlockingRoot) {
                mode = BlockingMode | StrictMode;
            } else {
                mode = NoMode;
            }
            if (isDevToolsPresent) {
                mode |= ProfileMode;
            }
            return createFiber(HostRoot, null, null, mode);
        }
        function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
            var fiberTag = IndeterminateComponent;
            var resolvedType = type;
            if (typeof type === 'function') {
                if (shouldConstruct$1(type)) {
                    fiberTag = ClassComponent;
                    {
                        resolvedType = resolveClassForHotReloading(resolvedType);
                    }
                } else {
                    {
                        resolvedType = resolveFunctionForHotReloading(resolvedType);
                    }
                }
            } else if (typeof type === 'string') {
                fiberTag = HostComponent;
            } else {
                getTag:
                    switch (type) {
                    case REACT_FRAGMENT_TYPE:
                        return createFiberFromFragment(pendingProps.children, mode, lanes, key);
                    case REACT_DEBUG_TRACING_MODE_TYPE:
                        fiberTag = Mode;
                        mode |= DebugTracingMode;
                        break;
                    case REACT_STRICT_MODE_TYPE:
                        fiberTag = Mode;
                        mode |= StrictMode;
                        break;
                    case REACT_PROFILER_TYPE:
                        return createFiberFromProfiler(pendingProps, mode, lanes, key);
                    case REACT_SUSPENSE_TYPE:
                        return createFiberFromSuspense(pendingProps, mode, lanes, key);
                    case REACT_SUSPENSE_LIST_TYPE:
                        return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
                    case REACT_OFFSCREEN_TYPE:
                        return createFiberFromOffscreen(pendingProps, mode, lanes, key);
                    case REACT_LEGACY_HIDDEN_TYPE:
                        return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
                    case REACT_SCOPE_TYPE:
                    default: {
                            if (typeof type === 'object' && type !== null) {
                                switch (type.$$typeof) {
                                case REACT_PROVIDER_TYPE:
                                    fiberTag = ContextProvider;
                                    break getTag;
                                case REACT_CONTEXT_TYPE:
                                    fiberTag = ContextConsumer;
                                    break getTag;
                                case REACT_FORWARD_REF_TYPE:
                                    fiberTag = ForwardRef;
                                    {
                                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                                    }
                                    break getTag;
                                case REACT_MEMO_TYPE:
                                    fiberTag = MemoComponent;
                                    break getTag;
                                case REACT_LAZY_TYPE:
                                    fiberTag = LazyComponent;
                                    resolvedType = null;
                                    break getTag;
                                case REACT_BLOCK_TYPE:
                                    fiberTag = Block;
                                    break getTag;
                                }
                            }
                            var info = '';
                            {
                                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                                    info += ' You likely forgot to export your component from the file ' + 'it\'s defined in, or you might have mixed up default and ' + 'named imports.';
                                }
                                var ownerName = owner ? getComponentName(owner.type) : null;
                                if (ownerName) {
                                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                                }
                            }
                            {
                                {
                                    throw Error('Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: ' + (type == null ? type : typeof type) + '.' + info);
                                }
                            }
                        }
                    }
            }
            var fiber = createFiber(fiberTag, pendingProps, key, mode);
            fiber.elementType = type;
            fiber.type = resolvedType;
            fiber.lanes = lanes;
            {
                fiber._debugOwner = owner;
            }
            return fiber;
        }
        function createFiberFromElement(element, mode, lanes) {
            var owner = null;
            {
                owner = element._owner;
            }
            var type = element.type;
            var key = element.key;
            var pendingProps = element.props;
            var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
            {
                fiber._debugSource = element._source;
                fiber._debugOwner = element._owner;
            }
            return fiber;
        }
        function createFiberFromFragment(elements, mode, lanes, key) {
            var fiber = createFiber(Fragment, elements, key, mode);
            fiber.lanes = lanes;
            return fiber;
        }
        function createFiberFromProfiler(pendingProps, mode, lanes, key) {
            {
                if (typeof pendingProps.id !== 'string') {
                    error('Profiler must specify an "id" as a prop');
                }
            }
            var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
            fiber.elementType = REACT_PROFILER_TYPE;
            fiber.type = REACT_PROFILER_TYPE;
            fiber.lanes = lanes;
            {
                fiber.stateNode = {
                    effectDuration: 0,
                    passiveEffectDuration: 0
                };
            }
            return fiber;
        }
        function createFiberFromSuspense(pendingProps, mode, lanes, key) {
            var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
            fiber.type = REACT_SUSPENSE_TYPE;
            fiber.elementType = REACT_SUSPENSE_TYPE;
            fiber.lanes = lanes;
            return fiber;
        }
        function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
            var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
            {
                fiber.type = REACT_SUSPENSE_LIST_TYPE;
            }
            fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
            fiber.lanes = lanes;
            return fiber;
        }
        function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
            var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
            {
                fiber.type = REACT_OFFSCREEN_TYPE;
            }
            fiber.elementType = REACT_OFFSCREEN_TYPE;
            fiber.lanes = lanes;
            return fiber;
        }
        function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
            var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode);
            {
                fiber.type = REACT_LEGACY_HIDDEN_TYPE;
            }
            fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
            fiber.lanes = lanes;
            return fiber;
        }
        function createFiberFromText(content, mode, lanes) {
            var fiber = createFiber(HostText, content, null, mode);
            fiber.lanes = lanes;
            return fiber;
        }
        function createFiberFromHostInstanceForDeletion() {
            var fiber = createFiber(HostComponent, null, null, NoMode);
            fiber.elementType = 'DELETED';
            fiber.type = 'DELETED';
            return fiber;
        }
        function createFiberFromPortal(portal, mode, lanes) {
            var pendingProps = portal.children !== null ? portal.children : [];
            var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
            fiber.lanes = lanes;
            fiber.stateNode = {
                containerInfo: portal.containerInfo,
                pendingChildren: null,
                implementation: portal.implementation
            };
            return fiber;
        }
        function assignFiberPropertiesInDEV(target, source) {
            if (target === null) {
                target = createFiber(IndeterminateComponent, null, null, NoMode);
            }
            target.tag = source.tag;
            target.key = source.key;
            target.elementType = source.elementType;
            target.type = source.type;
            target.stateNode = source.stateNode;
            target.return = source.return;
            target.child = source.child;
            target.sibling = source.sibling;
            target.index = source.index;
            target.ref = source.ref;
            target.pendingProps = source.pendingProps;
            target.memoizedProps = source.memoizedProps;
            target.updateQueue = source.updateQueue;
            target.memoizedState = source.memoizedState;
            target.dependencies = source.dependencies;
            target.mode = source.mode;
            target.flags = source.flags;
            target.nextEffect = source.nextEffect;
            target.firstEffect = source.firstEffect;
            target.lastEffect = source.lastEffect;
            target.lanes = source.lanes;
            target.childLanes = source.childLanes;
            target.alternate = source.alternate;
            {
                target.actualDuration = source.actualDuration;
                target.actualStartTime = source.actualStartTime;
                target.selfBaseDuration = source.selfBaseDuration;
                target.treeBaseDuration = source.treeBaseDuration;
            }
            target._debugID = source._debugID;
            target._debugSource = source._debugSource;
            target._debugOwner = source._debugOwner;
            target._debugNeedsRemount = source._debugNeedsRemount;
            target._debugHookTypes = source._debugHookTypes;
            return target;
        }
        function FiberRootNode(containerInfo, tag, hydrate) {
            this.tag = tag;
            this.containerInfo = containerInfo;
            this.pendingChildren = null;
            this.current = null;
            this.pingCache = null;
            this.finishedWork = null;
            this.timeoutHandle = noTimeout;
            this.context = null;
            this.pendingContext = null;
            this.hydrate = hydrate;
            this.callbackNode = null;
            this.callbackPriority = NoLanePriority;
            this.eventTimes = createLaneMap(NoLanes);
            this.expirationTimes = createLaneMap(NoTimestamp);
            this.pendingLanes = NoLanes;
            this.suspendedLanes = NoLanes;
            this.pingedLanes = NoLanes;
            this.expiredLanes = NoLanes;
            this.mutableReadLanes = NoLanes;
            this.finishedLanes = NoLanes;
            this.entangledLanes = NoLanes;
            this.entanglements = createLaneMap(NoLanes);
            {
                this.mutableSourceEagerHydrationData = null;
            }
            {
                this.interactionThreadID = tracing.unstable_getThreadID();
                this.memoizedInteractions = new Set();
                this.pendingInteractionMap = new Map();
            }
            {
                switch (tag) {
                case BlockingRoot:
                    this._debugRootType = 'createBlockingRoot()';
                    break;
                case ConcurrentRoot:
                    this._debugRootType = 'createRoot()';
                    break;
                case LegacyRoot:
                    this._debugRootType = 'createLegacyRoot()';
                    break;
                }
            }
        }
        function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
            var root = new FiberRootNode(containerInfo, tag, hydrate);
            var uninitializedFiber = createHostRootFiber(tag);
            root.current = uninitializedFiber;
            uninitializedFiber.stateNode = root;
            initializeUpdateQueue(uninitializedFiber);
            return root;
        }
        function registerMutableSourceForHydration(root, mutableSource) {
            var getVersion = mutableSource._getVersion;
            var version = getVersion(mutableSource._source);
            if (root.mutableSourceEagerHydrationData == null) {
                root.mutableSourceEagerHydrationData = [
                    mutableSource,
                    version
                ];
            } else {
                root.mutableSourceEagerHydrationData.push(mutableSource, version);
            }
        }
        function createPortal(children, containerInfo, implementation) {
            var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            return {
                $$typeof: REACT_PORTAL_TYPE,
                key: key == null ? null : '' + key,
                children: children,
                containerInfo: containerInfo,
                implementation: implementation
            };
        }
        var didWarnAboutNestedUpdates;
        var didWarnAboutFindNodeInStrictMode;
        {
            didWarnAboutNestedUpdates = false;
            didWarnAboutFindNodeInStrictMode = {};
        }
        function getContextForSubtree(parentComponent) {
            if (!parentComponent) {
                return emptyContextObject;
            }
            var fiber = get(parentComponent);
            var parentContext = findCurrentUnmaskedContext(fiber);
            if (fiber.tag === ClassComponent) {
                var Component = fiber.type;
                if (isContextProvider(Component)) {
                    return processChildContext(fiber, Component, parentContext);
                }
            }
            return parentContext;
        }
        function findHostInstanceWithWarning(component, methodName) {
            {
                var fiber = get(component);
                if (fiber === undefined) {
                    if (typeof component.render === 'function') {
                        {
                            {
                                throw Error('Unable to find node on an unmounted component.');
                            }
                        }
                    } else {
                        {
                            {
                                throw Error('Argument appears to not be a ReactComponent. Keys: ' + Object.keys(component));
                            }
                        }
                    }
                }
                var hostFiber = findCurrentHostFiber(fiber);
                if (hostFiber === null) {
                    return null;
                }
                if (hostFiber.mode & StrictMode) {
                    var componentName = getComponentName(fiber.type) || 'Component';
                    if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                        didWarnAboutFindNodeInStrictMode[componentName] = true;
                        var previousFiber = current;
                        try {
                            setCurrentFiber(hostFiber);
                            if (fiber.mode & StrictMode) {
                                error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                            } else {
                                error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                            }
                        } finally {
                            if (previousFiber) {
                                setCurrentFiber(previousFiber);
                            } else {
                                resetCurrentFiber();
                            }
                        }
                    }
                }
                return hostFiber.stateNode;
            }
        }
        function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
            return createFiberRoot(containerInfo, tag, hydrate);
        }
        function updateContainer(element, container, parentComponent, callback) {
            {
                onScheduleRoot(container, element);
            }
            var current$1 = container.current;
            var eventTime = requestEventTime();
            {
                if ('undefined' !== typeof jest) {
                    warnIfUnmockedScheduler(current$1);
                    warnIfNotScopedWithMatchingAct(current$1);
                }
            }
            var lane = requestUpdateLane(current$1);
            var context = getContextForSubtree(parentComponent);
            if (container.context === null) {
                container.context = context;
            } else {
                container.pendingContext = context;
            }
            {
                if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
                    didWarnAboutNestedUpdates = true;
                    error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
                }
            }
            var update = createUpdate(eventTime, lane);
            update.payload = { element: element };
            callback = callback === undefined ? null : callback;
            if (callback !== null) {
                {
                    if (typeof callback !== 'function') {
                        error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
                    }
                }
                update.callback = callback;
            }
            enqueueUpdate(current$1, update);
            scheduleUpdateOnFiber(current$1, lane, eventTime);
            return lane;
        }
        function getPublicRootInstance(container) {
            var containerFiber = container.current;
            if (!containerFiber.child) {
                return null;
            }
            switch (containerFiber.child.tag) {
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
            }
        }
        function markRetryLaneImpl(fiber, retryLane) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState !== null && suspenseState.dehydrated !== null) {
                suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
            }
        }
        function markRetryLaneIfNotHydrated(fiber, retryLane) {
            markRetryLaneImpl(fiber, retryLane);
            var alternate = fiber.alternate;
            if (alternate) {
                markRetryLaneImpl(alternate, retryLane);
            }
        }
        function attemptUserBlockingHydration$1(fiber) {
            if (fiber.tag !== SuspenseComponent) {
                return;
            }
            var eventTime = requestEventTime();
            var lane = InputDiscreteHydrationLane;
            scheduleUpdateOnFiber(fiber, lane, eventTime);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
        function attemptContinuousHydration$1(fiber) {
            if (fiber.tag !== SuspenseComponent) {
                return;
            }
            var eventTime = requestEventTime();
            var lane = SelectiveHydrationLane;
            scheduleUpdateOnFiber(fiber, lane, eventTime);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
        function attemptHydrationAtCurrentPriority$1(fiber) {
            if (fiber.tag !== SuspenseComponent) {
                return;
            }
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
        function runWithPriority$2(priority, fn) {
            try {
                setCurrentUpdateLanePriority(priority);
                return fn();
            } finally {
            }
        }
        function findHostInstanceWithNoPortals(fiber) {
            var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
            if (hostFiber === null) {
                return null;
            }
            if (hostFiber.tag === FundamentalComponent) {
                return hostFiber.stateNode.instance;
            }
            return hostFiber.stateNode;
        }
        var shouldSuspendImpl = function (fiber) {
            return false;
        };
        function shouldSuspend(fiber) {
            return shouldSuspendImpl(fiber);
        }
        var overrideHookState = null;
        var overrideHookStateDeletePath = null;
        var overrideHookStateRenamePath = null;
        var overrideProps = null;
        var overridePropsDeletePath = null;
        var overridePropsRenamePath = null;
        var scheduleUpdate = null;
        var setSuspenseHandler = null;
        {
            var copyWithDeleteImpl = function (obj, path, index) {
                var key = path[index];
                var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
                if (index + 1 === path.length) {
                    if (Array.isArray(updated)) {
                        updated.splice(key, 1);
                    } else {
                        delete updated[key];
                    }
                    return updated;
                }
                updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
                return updated;
            };
            var copyWithDelete = function (obj, path) {
                return copyWithDeleteImpl(obj, path, 0);
            };
            var copyWithRenameImpl = function (obj, oldPath, newPath, index) {
                var oldKey = oldPath[index];
                var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
                if (index + 1 === oldPath.length) {
                    var newKey = newPath[index];
                    updated[newKey] = updated[oldKey];
                    if (Array.isArray(updated)) {
                        updated.splice(oldKey, 1);
                    } else {
                        delete updated[oldKey];
                    }
                } else {
                    updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
                }
                return updated;
            };
            var copyWithRename = function (obj, oldPath, newPath) {
                if (oldPath.length !== newPath.length) {
                    warn('copyWithRename() expects paths of the same length');
                    return;
                } else {
                    for (var i = 0; i < newPath.length - 1; i++) {
                        if (oldPath[i] !== newPath[i]) {
                            warn('copyWithRename() expects paths to be the same except for the deepest key');
                            return;
                        }
                    }
                }
                return copyWithRenameImpl(obj, oldPath, newPath, 0);
            };
            var copyWithSetImpl = function (obj, path, index, value) {
                if (index >= path.length) {
                    return value;
                }
                var key = path[index];
                var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
                updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
                return updated;
            };
            var copyWithSet = function (obj, path, value) {
                return copyWithSetImpl(obj, path, 0, value);
            };
            var findHook = function (fiber, id) {
                var currentHook = fiber.memoizedState;
                while (currentHook !== null && id > 0) {
                    currentHook = currentHook.next;
                    id--;
                }
                return currentHook;
            };
            overrideHookState = function (fiber, id, path, value) {
                var hook = findHook(fiber, id);
                if (hook !== null) {
                    var newState = copyWithSet(hook.memoizedState, path, value);
                    hook.memoizedState = newState;
                    hook.baseState = newState;
                    fiber.memoizedProps = _assign({}, fiber.memoizedProps);
                    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
                }
            };
            overrideHookStateDeletePath = function (fiber, id, path) {
                var hook = findHook(fiber, id);
                if (hook !== null) {
                    var newState = copyWithDelete(hook.memoizedState, path);
                    hook.memoizedState = newState;
                    hook.baseState = newState;
                    fiber.memoizedProps = _assign({}, fiber.memoizedProps);
                    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
                }
            };
            overrideHookStateRenamePath = function (fiber, id, oldPath, newPath) {
                var hook = findHook(fiber, id);
                if (hook !== null) {
                    var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
                    hook.memoizedState = newState;
                    hook.baseState = newState;
                    fiber.memoizedProps = _assign({}, fiber.memoizedProps);
                    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
                }
            };
            overrideProps = function (fiber, path, value) {
                fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
                if (fiber.alternate) {
                    fiber.alternate.pendingProps = fiber.pendingProps;
                }
                scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            };
            overridePropsDeletePath = function (fiber, path) {
                fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
                if (fiber.alternate) {
                    fiber.alternate.pendingProps = fiber.pendingProps;
                }
                scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            };
            overridePropsRenamePath = function (fiber, oldPath, newPath) {
                fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
                if (fiber.alternate) {
                    fiber.alternate.pendingProps = fiber.pendingProps;
                }
                scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            };
            scheduleUpdate = function (fiber) {
                scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            };
            setSuspenseHandler = function (newShouldSuspendImpl) {
                shouldSuspendImpl = newShouldSuspendImpl;
            };
        }
        function findHostInstanceByFiber(fiber) {
            var hostFiber = findCurrentHostFiber(fiber);
            if (hostFiber === null) {
                return null;
            }
            return hostFiber.stateNode;
        }
        function emptyFindFiberByHostInstance(instance) {
            return null;
        }
        function getCurrentFiberForDevTools() {
            return current;
        }
        function injectIntoDevTools(devToolsConfig) {
            var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
            var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
            return injectInternals({
                bundleType: devToolsConfig.bundleType,
                version: devToolsConfig.version,
                rendererPackageName: devToolsConfig.rendererPackageName,
                rendererConfig: devToolsConfig.rendererConfig,
                overrideHookState: overrideHookState,
                overrideHookStateDeletePath: overrideHookStateDeletePath,
                overrideHookStateRenamePath: overrideHookStateRenamePath,
                overrideProps: overrideProps,
                overridePropsDeletePath: overridePropsDeletePath,
                overridePropsRenamePath: overridePropsRenamePath,
                setSuspenseHandler: setSuspenseHandler,
                scheduleUpdate: scheduleUpdate,
                currentDispatcherRef: ReactCurrentDispatcher,
                findHostInstanceByFiber: findHostInstanceByFiber,
                findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
                findHostInstancesForRefresh: findHostInstancesForRefresh,
                scheduleRefresh: scheduleRefresh,
                scheduleRoot: scheduleRoot,
                setRefreshHandler: setRefreshHandler,
                getCurrentFiber: getCurrentFiberForDevTools
            });
        }
        function ReactDOMRoot(container, options) {
            this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
        }
        function ReactDOMBlockingRoot(container, tag, options) {
            this._internalRoot = createRootImpl(container, tag, options);
        }
        ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
            var root = this._internalRoot;
            {
                if (typeof arguments[1] === 'function') {
                    error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
                }
                var container = root.containerInfo;
                if (container.nodeType !== COMMENT_NODE) {
                    var hostInstance = findHostInstanceWithNoPortals(root.current);
                    if (hostInstance) {
                        if (hostInstance.parentNode !== container) {
                            error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'root.unmount() to empty a root\'s container.');
                        }
                    }
                }
            }
            updateContainer(children, root, null, null);
        };
        ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
            {
                if (typeof arguments[0] === 'function') {
                    error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
                }
            }
            var root = this._internalRoot;
            var container = root.containerInfo;
            updateContainer(null, root, null, function () {
                unmarkContainerAsRoot(container);
            });
        };
        function createRootImpl(container, tag, options) {
            var hydrate = options != null && options.hydrate === true;
            var hydrationCallbacks = options != null && options.hydrationOptions || null;
            var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
            var root = createContainer(container, tag, hydrate);
            markContainerAsRoot(root.current, container);
            var containerNodeType = container.nodeType;
            {
                var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
                listenToAllSupportedEvents(rootContainerElement);
            }
            if (mutableSources) {
                for (var i = 0; i < mutableSources.length; i++) {
                    var mutableSource = mutableSources[i];
                    registerMutableSourceForHydration(root, mutableSource);
                }
            }
            return root;
        }
        function createLegacyRoot(container, options) {
            return new ReactDOMBlockingRoot(container, LegacyRoot, options);
        }
        function isValidContainer(node) {
            return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
        }
        var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
        var topLevelUpdateWarnings;
        var warnedAboutHydrateAPI = false;
        {
            topLevelUpdateWarnings = function (container) {
                if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
                    var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
                    if (hostInstance) {
                        if (hostInstance.parentNode !== container) {
                            error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
                        }
                    }
                }
                var isRootRenderedBySomeReact = !!container._reactRootContainer;
                var rootEl = getReactRootElementInContainer(container);
                var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
                if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
                    error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
                }
                if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
                    error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
                }
            };
        }
        function getReactRootElementInContainer(container) {
            if (!container) {
                return null;
            }
            if (container.nodeType === DOCUMENT_NODE) {
                return container.documentElement;
            } else {
                return container.firstChild;
            }
        }
        function shouldHydrateDueToLegacyHeuristic(container) {
            var rootElement = getReactRootElementInContainer(container);
            return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
        }
        function legacyCreateRootFromDOMContainer(container, forceHydrate) {
            var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container);
            if (!shouldHydrate) {
                var warned = false;
                var rootSibling;
                while (rootSibling = container.lastChild) {
                    {
                        if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                            warned = true;
                            error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
                        }
                    }
                    container.removeChild(rootSibling);
                }
            }
            {
                if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
                    warnedAboutHydrateAPI = true;
                    warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v18. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
                }
            }
            return createLegacyRoot(container, shouldHydrate ? { hydrate: true } : undefined);
        }
        function warnOnInvalidCallback$1(callback, callerName) {
            {
                if (callback !== null && typeof callback !== 'function') {
                    error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
                }
            }
        }
        function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
            {
                topLevelUpdateWarnings(container);
                warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
            }
            var root = container._reactRootContainer;
            var fiberRoot;
            if (!root) {
                root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
                fiberRoot = root._internalRoot;
                if (typeof callback === 'function') {
                    var originalCallback = callback;
                    callback = function () {
                        var instance = getPublicRootInstance(fiberRoot);
                        originalCallback.call(instance);
                    };
                }
                unbatchedUpdates(function () {
                    updateContainer(children, fiberRoot, parentComponent, callback);
                });
            } else {
                fiberRoot = root._internalRoot;
                if (typeof callback === 'function') {
                    var _originalCallback = callback;
                    callback = function () {
                        var instance = getPublicRootInstance(fiberRoot);
                        _originalCallback.call(instance);
                    };
                }
                updateContainer(children, fiberRoot, parentComponent, callback);
            }
            return getPublicRootInstance(fiberRoot);
        }
        function findDOMNode(componentOrElement) {
            {
                var owner = ReactCurrentOwner$3.current;
                if (owner !== null && owner.stateNode !== null) {
                    var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
                    if (!warnedAboutRefsInRender) {
                        error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
                    }
                    owner.stateNode._warnedAboutRefsInRender = true;
                }
            }
            if (componentOrElement == null) {
                return null;
            }
            if (componentOrElement.nodeType === ELEMENT_NODE) {
                return componentOrElement;
            }
            {
                return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
            }
        }
        function hydrate(element, container, callback) {
            if (!isValidContainer(container)) {
                {
                    throw Error('Target container is not a DOM element.');
                }
            }
            {
                var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
                if (isModernRoot) {
                    error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
                }
            }
            return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
        }
        function render(element, container, callback) {
            if (!isValidContainer(container)) {
                {
                    throw Error('Target container is not a DOM element.');
                }
            }
            {
                var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
                if (isModernRoot) {
                    error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
                }
            }
            return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
        }
        function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
            if (!isValidContainer(containerNode)) {
                {
                    throw Error('Target container is not a DOM element.');
                }
            }
            if (!(parentComponent != null && has(parentComponent))) {
                {
                    throw Error('parentComponent must be a valid React Component');
                }
            }
            return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
        }
        function unmountComponentAtNode(container) {
            if (!isValidContainer(container)) {
                {
                    throw Error('unmountComponentAtNode(...): Target container is not a DOM element.');
                }
            }
            {
                var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
                if (isModernRoot) {
                    error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
                }
            }
            if (container._reactRootContainer) {
                {
                    var rootEl = getReactRootElementInContainer(container);
                    var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
                    if (renderedByDifferentReact) {
                        error('unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.');
                    }
                }
                unbatchedUpdates(function () {
                    legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
                        container._reactRootContainer = null;
                        unmarkContainerAsRoot(container);
                    });
                });
                return true;
            } else {
                {
                    var _rootEl = getReactRootElementInContainer(container);
                    var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl));
                    var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
                    if (hasNonRootReactChild) {
                        error('unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
                    }
                }
                return false;
            }
        }
        setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
        setAttemptContinuousHydration(attemptContinuousHydration$1);
        setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
        setAttemptHydrationAtPriority(runWithPriority$2);
        var didWarnAboutUnstableCreatePortal = false;
        {
            if (typeof Map !== 'function' || Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
                error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
            }
        }
        setRestoreImplementation(restoreControlledState$3);
        setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
        function createPortal$1(children, container) {
            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (!isValidContainer(container)) {
                {
                    throw Error('Target container is not a DOM element.');
                }
            }
            return createPortal(children, container, null, key);
        }
        function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
            return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
        }
        function unstable_createPortal(children, container) {
            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            {
                if (!didWarnAboutUnstableCreatePortal) {
                    didWarnAboutUnstableCreatePortal = true;
                    warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 18+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
                }
            }
            return createPortal$1(children, container, key);
        }
        var Internals = {
            Events: [
                getInstanceFromNode,
                getNodeFromInstance,
                getFiberCurrentPropsFromNode,
                enqueueStateRestore,
                restoreStateIfNeeded,
                flushPassiveEffects,
                IsThisRendererActing
            ]
        };
        var foundDevTools = injectIntoDevTools({
            findFiberByHostInstance: getClosestInstanceFromNode,
            bundleType: 1,
            version: ReactVersion,
            rendererPackageName: 'react-dom'
        });
        {
            if (!foundDevTools && canUseDOM && window.top === window.self) {
                if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
                    var protocol = window.location.protocol;
                    if (/^(https?|file):$/.test(protocol)) {
                        console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
                    }
                }
            }
        }
        exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
        exports.createPortal = createPortal$1;
        exports.findDOMNode = findDOMNode;
        exports.flushSync = flushSync;
        exports.hydrate = hydrate;
        exports.render = render;
        exports.unmountComponentAtNode = unmountComponentAtNode;
        exports.unstable_batchedUpdates = batchedUpdates$1;
        exports.unstable_createPortal = unstable_createPortal;
        exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
        exports.version = ReactVersion;
    }());
}
},{"object-assign":879,"react":1107,"scheduler":1161,"scheduler/tracing":1162}],1015:[function(require,module,exports){
/** @license React v17.0.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
'use strict';var aa=require("react"),m=require("object-assign"),r=require("scheduler");function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.1",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.1";

},{"object-assign":879,"react":1107,"scheduler":1161}],1016:[function(require,module,exports){
'use strict';

function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if ("production" !== 'production') {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if ("production" === 'production') {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = require('./cjs/react-dom.production.min.js');
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

},{"./cjs/react-dom.development.js":1014,"./cjs/react-dom.production.min.js":1015}],1017:[function(require,module,exports){
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

},{}],1018:[function(require,module,exports){

'use strict'

if ("production" === 'production') {
  module.exports = require('./react-hot-toast.cjs.production.min.js')
} else {
  module.exports = require('./react-hot-toast.cjs.development.js')
}

},{"./react-hot-toast.cjs.development.js":1019,"./react-hot-toast.cjs.production.min.js":1020}],1019:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var goober = require('goober');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var isFunction = function isFunction(valOrFunction) {
  return typeof valOrFunction === 'function';
};

var resolveValue = function resolveValue(valOrFunction, arg) {
  return isFunction(valOrFunction) ? valOrFunction(arg) : valOrFunction;
};

var genId = /*#__PURE__*/function () {
  var count = 0;
  return function () {
    return (++count).toString();
  };
}();
var createRectRef = function createRectRef(onRect) {
  return function (el) {
    if (el) {
      setTimeout(function () {
        var boundingRect = el.getBoundingClientRect();
        onRect(boundingRect);
      });
    }
  };
};
var prefersReducedMotion = /*#__PURE__*/function () {
  // Cache result
  var shouldReduceMotion = undefined;
  return function () {
    if (shouldReduceMotion === undefined && typeof window !== 'undefined') {
      var mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      shouldReduceMotion = !mediaQuery || mediaQuery.matches;
    }

    return shouldReduceMotion;
  };
}();

var TOAST_LIMIT = 20;
var ActionType;

(function (ActionType) {
  ActionType[ActionType["ADD_TOAST"] = 0] = "ADD_TOAST";
  ActionType[ActionType["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
  ActionType[ActionType["UPSERT_TOAST"] = 2] = "UPSERT_TOAST";
  ActionType[ActionType["DISMISS_TOAST"] = 3] = "DISMISS_TOAST";
  ActionType[ActionType["REMOVE_TOAST"] = 4] = "REMOVE_TOAST";
  ActionType[ActionType["START_PAUSE"] = 5] = "START_PAUSE";
  ActionType[ActionType["END_PAUSE"] = 6] = "END_PAUSE";
})(ActionType || (ActionType = {}));

var toastTimeouts = /*#__PURE__*/new Map();

var addToRemoveQueue = function addToRemoveQueue(toastId) {
  if (toastTimeouts.has(toastId)) {
    return;
  }

  var timeout = setTimeout(function () {
    toastTimeouts["delete"](toastId);
    dispatch({
      type: ActionType.REMOVE_TOAST,
      toastId: toastId
    });
  }, 1000);
  toastTimeouts.set(toastId, timeout);
};

var clearFromRemoveQueue = function clearFromRemoveQueue(toastId) {
  var timeout = toastTimeouts.get(toastId);

  if (timeout) {
    clearTimeout(timeout);
  }
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionType.ADD_TOAST:
      return _extends({}, state, {
        toasts: [action.toast].concat(state.toasts).slice(0, TOAST_LIMIT)
      });

    case ActionType.UPDATE_TOAST:
      //  ! Side effects !
      if (action.toast.id) {
        clearFromRemoveQueue(action.toast.id);
      }

      return _extends({}, state, {
        toasts: state.toasts.map(function (t) {
          return t.id === action.toast.id ? _extends({}, t, action.toast) : t;
        })
      });

    case ActionType.UPSERT_TOAST:
      var toast = action.toast;
      return state.toasts.find(function (t) {
        return t.id === toast.id;
      }) ? reducer(state, {
        type: ActionType.UPDATE_TOAST,
        toast: toast
      }) : reducer(state, {
        type: ActionType.ADD_TOAST,
        toast: toast
      });

    case ActionType.DISMISS_TOAST:
      var toastId = action.toastId; // ! Side effects ! - This could be execrated into a dismissToast() action, but I'll keep it here for simplicity

      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach(function (toast) {
          addToRemoveQueue(toast.id);
        });
      }

      return _extends({}, state, {
        toasts: state.toasts.map(function (t) {
          return t.id === toastId || toastId === undefined ? _extends({}, t, {
            visible: false
          }) : t;
        })
      });

    case ActionType.REMOVE_TOAST:
      if (action.toastId === undefined) {
        return _extends({}, state, {
          toasts: []
        });
      }

      return _extends({}, state, {
        toasts: state.toasts.filter(function (t) {
          return t.id !== action.toastId;
        })
      });

    case ActionType.START_PAUSE:
      return _extends({}, state, {
        pausedAt: action.time
      });

    case ActionType.END_PAUSE:
      var diff = action.time - (state.pausedAt || 0);
      return _extends({}, state, {
        pausedAt: undefined,
        toasts: state.toasts.map(function (t) {
          return _extends({}, t, {
            pauseDuration: t.pauseDuration + diff
          });
        })
      });
  }
};
var listeners = [];
var memoryState = {
  toasts: [],
  pausedAt: undefined
};
var dispatch = function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
};
var defaultTimeouts = {
  blank: 4000,
  error: 4000,
  success: 2000,
  loading: Infinity,
  custom: 4000
};
var useStore = function useStore(toastOptions) {
  if (toastOptions === void 0) {
    toastOptions = {};
  }

  var _useState = React.useState(memoryState),
      state = _useState[0],
      setState = _useState[1];

  React.useEffect(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);

      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  var mergedToasts = state.toasts.map(function (t) {
    var _toastOptions$t$type, _toastOptions, _toastOptions$t$type2;

    return _extends({}, toastOptions, toastOptions[t.type], t, {
      duration: t.duration || ((_toastOptions$t$type = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type.duration) || ((_toastOptions = toastOptions) == null ? void 0 : _toastOptions.duration) || defaultTimeouts[t.type],
      style: _extends({}, toastOptions.style, (_toastOptions$t$type2 = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type2.style, t.style)
    });
  });
  return _extends({}, state, {
    toasts: mergedToasts
  });
};

var createToast = function createToast(message, type, opts) {
  if (type === void 0) {
    type = 'blank';
  }

  return _extends({
    createdAt: Date.now(),
    visible: true,
    type: type,
    ariaProps: {
      role: 'status',
      'aria-live': 'polite'
    },
    message: message,
    pauseDuration: 0
  }, opts, {
    id: (opts == null ? void 0 : opts.id) || genId()
  });
};

var createHandler = function createHandler(type) {
  return function (message, options) {
    var toast = createToast(message, type, options);
    dispatch({
      type: ActionType.UPSERT_TOAST,
      toast: toast
    });
    return toast.id;
  };
};

var toast = function toast(message, opts) {
  return createHandler('blank')(message, opts);
};

toast.error = /*#__PURE__*/createHandler('error');
toast.success = /*#__PURE__*/createHandler('success');
toast.loading = /*#__PURE__*/createHandler('loading');
toast.custom = /*#__PURE__*/createHandler('custom');

toast.dismiss = function (toastId) {
  dispatch({
    type: ActionType.DISMISS_TOAST,
    toastId: toastId
  });
};

toast.remove = function (toastId) {
  return dispatch({
    type: ActionType.REMOVE_TOAST,
    toastId: toastId
  });
};

toast.promise = function (promise, msgs, opts) {
  var id = toast.loading(msgs.loading, _extends({}, opts, opts == null ? void 0 : opts.loading));
  promise.then(function (p) {
    toast.success(resolveValue(msgs.success, p), _extends({
      id: id
    }, opts, opts == null ? void 0 : opts.success));
    return p;
  })["catch"](function (e) {
    toast.error(resolveValue(msgs.error, e), _extends({
      id: id
    }, opts, opts == null ? void 0 : opts.error));
  });
  return promise;
};

var useToaster = function useToaster(toastOptions) {
  var _useStore = useStore(toastOptions),
      toasts = _useStore.toasts,
      pausedAt = _useStore.pausedAt;

  React.useEffect(function () {
    if (pausedAt) {
      return;
    }

    var now = Date.now();
    var timeouts = toasts.map(function (t) {
      if (t.duration === Infinity) {
        return;
      }

      var durationLeft = (t.duration || 0) + t.pauseDuration - (now - t.createdAt);

      if (durationLeft < 0) {
        if (t.visible) {
          toast.dismiss(t.id);
        }

        return;
      }

      return setTimeout(function () {
        return toast.dismiss(t.id);
      }, durationLeft);
    });
    return function () {
      timeouts.forEach(function (timeout) {
        return timeout && clearTimeout(timeout);
      });
    };
  }, [toasts, pausedAt]);
  var handlers = React.useMemo(function () {
    return {
      startPause: function startPause() {
        dispatch({
          type: ActionType.START_PAUSE,
          time: Date.now()
        });
      },
      endPause: function endPause() {
        if (pausedAt) {
          dispatch({
            type: ActionType.END_PAUSE,
            time: Date.now()
          });
        }
      },
      updateHeight: function updateHeight(toastId, height) {
        return dispatch({
          type: ActionType.UPDATE_TOAST,
          toast: {
            id: toastId,
            height: height
          }
        });
      },
      calculateOffset: function calculateOffset(toast, opts) {
        var _relevantToasts$filte;

        var _ref = opts || {},
            _ref$reverseOrder = _ref.reverseOrder,
            reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder,
            _ref$gutter = _ref.gutter,
            gutter = _ref$gutter === void 0 ? 8 : _ref$gutter,
            defaultPosition = _ref.defaultPosition;

        var relevantToasts = toasts.filter(function (t) {
          return (t.position || defaultPosition) === (toast.position || defaultPosition) && t.height;
        });
        var toastIndex = relevantToasts.findIndex(function (t) {
          return t.id === toast.id;
        });
        var toastsBefore = relevantToasts.filter(function (toast, i) {
          return i < toastIndex && toast.visible;
        }).length;

        var offset = (_relevantToasts$filte = relevantToasts.filter(function (t) {
          return t.visible;
        })).slice.apply(_relevantToasts$filte, reverseOrder ? [toastsBefore + 1] : [0, toastsBefore]).reduce(function (acc, t) {
          return acc + (t.height || 0) + gutter;
        }, 0);

        return offset;
      }
    };
  }, [toasts, pausedAt]);
  return {
    toasts: toasts,
    handlers: handlers
  };
};

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var circleAnimation = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject());
var firstLineAnimation = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject2());
var secondLineAnimation = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject3());
var ErrorIcon = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject4(), function (p) {
  return p.primary || '#ff4b4b';
}, circleAnimation, firstLineAnimation, function (p) {
  return p.secondary || '#fff';
}, secondLineAnimation);

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var rotate = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject$1());
var LoaderIcon = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject2$1(), function (p) {
  return p.secondary || '#e0e0e0';
}, function (p) {
  return p.primary || '#616161';
}, rotate);

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var circleAnimation$1 = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject$2());
var checkmarkAnimation = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject2$2());
var CheckmarkIcon = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject3$1(), function (p) {
  return p.primary || '#61d345';
}, circleAnimation$1, checkmarkAnimation, function (p) {
  return p.secondary || '#fff';
});

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StatusWrapper = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject$3());
var IndicatorWrapper = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject2$3());
var enter = /*#__PURE__*/goober.keyframes( /*#__PURE__*/_templateObject3$2());
var AnimatedIconWrapper = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject4$1(), enter);
var ToastIcon = function ToastIcon(_ref) {
  var toast = _ref.toast;
  var icon = toast.icon,
      type = toast.type,
      iconTheme = toast.iconTheme;

  if (icon !== undefined) {
    if (typeof icon === 'string') {
      return React.createElement(AnimatedIconWrapper, null, icon);
    } else {
      return icon;
    }
  }

  if (type === 'blank') {
    return null;
  }

  return React.createElement(IndicatorWrapper, null, React.createElement(LoaderIcon, Object.assign({}, iconTheme)), type !== 'loading' && React.createElement(StatusWrapper, null, type === 'error' ? React.createElement(ErrorIcon, Object.assign({}, iconTheme)) : React.createElement(CheckmarkIcon, Object.assign({}, iconTheme))));
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var enterAnimation = function enterAnimation(factor) {
  return "\n0% {transform: translate3d(0," + factor * -200 + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
};

var exitAnimation = function exitAnimation(factor) {
  return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + factor * -150 + "%,-1px) scale(.6); opacity:0;}\n";
};

var fadeInAnimation = "0%{opacity:0;} 100%{opacity:1;}";
var fadeOutAnimation = "0%{opacity:1;} 100%{opacity:0;}";
var ToastBarBase = /*#__PURE__*/goober.styled('div', React.forwardRef)( /*#__PURE__*/_templateObject$4());
var Message = /*#__PURE__*/goober.styled('div')( /*#__PURE__*/_templateObject2$4());

var getAnimationStyle = function getAnimationStyle(position, visible) {
  var top = position.includes('top');
  var factor = top ? 1 : -1;

  var _ref = prefersReducedMotion() ? [fadeInAnimation, fadeOutAnimation] : [enterAnimation(factor), exitAnimation(factor)],
      enter = _ref[0],
      exit = _ref[1];

  return {
    animation: visible ? goober.keyframes(enter) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : goober.keyframes(exit) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
  };
};

var ToastBar = /*#__PURE__*/React.memo(function (_ref2) {
  var toast = _ref2.toast,
      position = _ref2.position,
      style = _ref2.style,
      children = _ref2.children;
  var animationStyle = toast != null && toast.height ? getAnimationStyle(toast.position || position || 'top-center', toast.visible) : {
    opacity: 0
  };
  var icon = React.createElement(ToastIcon, {
    toast: toast
  });
  var message = React.createElement(Message, Object.assign({}, toast.ariaProps), resolveValue(toast.message, toast));
  return React.createElement(ToastBarBase, {
    className: toast.className,
    style: _extends({}, animationStyle, style, toast.style)
  }, typeof children === 'function' ? children({
    icon: icon,
    message: message
  }) : React.createElement(React.Fragment, null, icon, message));
});

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
goober.setup(React.createElement);

var getPositionStyle = function getPositionStyle(position, offset) {
  var top = position.includes('top');
  var verticalStyle = top ? {
    top: 0
  } : {
    bottom: 0
  };
  var horizontalStyle = position.includes('center') ? {
    justifyContent: 'center'
  } : position.includes('right') ? {
    justifyContent: 'flex-end'
  } : {};
  return _extends({
    left: 0,
    right: 0,
    display: 'flex',
    position: 'absolute',
    transition: prefersReducedMotion() ? undefined : "all 230ms cubic-bezier(.21,1.02,.73,1)",
    transform: "translateY(" + offset * (top ? 1 : -1) + "px)"
  }, verticalStyle, horizontalStyle);
};

var activeClass = /*#__PURE__*/goober.css( /*#__PURE__*/_templateObject$5());
var DEFAULT_OFFSET = 16;
var Toaster = function Toaster(_ref) {
  var reverseOrder = _ref.reverseOrder,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top-center' : _ref$position,
      toastOptions = _ref.toastOptions,
      gutter = _ref.gutter,
      children = _ref.children,
      containerStyle = _ref.containerStyle,
      containerClassName = _ref.containerClassName;

  var _useToaster = useToaster(toastOptions),
      toasts = _useToaster.toasts,
      handlers = _useToaster.handlers;

  return React.createElement("div", {
    style: _extends({
      position: 'fixed',
      zIndex: 9999,
      top: DEFAULT_OFFSET,
      left: DEFAULT_OFFSET,
      right: DEFAULT_OFFSET,
      bottom: DEFAULT_OFFSET,
      pointerEvents: 'none'
    }, containerStyle),
    className: containerClassName,
    onMouseEnter: handlers.startPause,
    onMouseLeave: handlers.endPause
  }, toasts.map(function (t) {
    var toastPosition = t.position || position;
    var offset = handlers.calculateOffset(t, {
      reverseOrder: reverseOrder,
      gutter: gutter,
      defaultPosition: position
    });
    var positionStyle = getPositionStyle(toastPosition, offset);
    var ref = t.height ? undefined : createRectRef(function (rect) {
      handlers.updateHeight(t.id, rect.height);
    });
    return React.createElement("div", {
      ref: ref,
      className: t.visible ? activeClass : '',
      key: t.id,
      style: positionStyle
    }, t.type === 'custom' ? resolveValue(t.message, t) : children ? children(t) : React.createElement(ToastBar, {
      toast: t,
      position: toastPosition
    }));
  }));
};

exports.CheckmarkIcon = CheckmarkIcon;
exports.ErrorIcon = ErrorIcon;
exports.LoaderIcon = LoaderIcon;
exports.ToastBar = ToastBar;
exports.ToastIcon = ToastIcon;
exports.Toaster = Toaster;
exports.default = toast;
exports.resolveValue = resolveValue;
exports.toast = toast;
exports.useToaster = useToaster;
exports.useToasterStore = useStore;


},{"goober":639,"react":1107}],1020:[function(require,module,exports){
"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var n=require("react"),t=require("goober");function e(){return(e=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r])}return n}).apply(this,arguments)}function r(n,t){return t||(t=n.slice(0)),n.raw=t,n}var o,i=function(n,t){return function(n){return"function"==typeof n}(n)?n(t):n},a=function(){var n=0;return function(){return(++n).toString()}}(),s=function(){var n=void 0;return function(){if(void 0===n&&"undefined"!=typeof window){var t=matchMedia("(prefers-reduced-motion: reduce)");n=!t||t.matches}return n}}();!function(n){n[n.ADD_TOAST=0]="ADD_TOAST",n[n.UPDATE_TOAST=1]="UPDATE_TOAST",n[n.UPSERT_TOAST=2]="UPSERT_TOAST",n[n.DISMISS_TOAST=3]="DISMISS_TOAST",n[n.REMOVE_TOAST=4]="REMOVE_TOAST",n[n.START_PAUSE=5]="START_PAUSE",n[n.END_PAUSE=6]="END_PAUSE"}(o||(o={}));var u=new Map,c=function(n){if(!u.has(n)){var t=setTimeout((function(){u.delete(n),l({type:o.REMOVE_TOAST,toastId:n})}),1e3);u.set(n,t)}},f=[],d={toasts:[],pausedAt:void 0},l=function(n){d=function n(t,r){switch(r.type){case o.ADD_TOAST:return e({},t,{toasts:[r.toast].concat(t.toasts).slice(0,20)});case o.UPDATE_TOAST:return r.toast.id&&function(n){var t=u.get(n);t&&clearTimeout(t)}(r.toast.id),e({},t,{toasts:t.toasts.map((function(n){return n.id===r.toast.id?e({},n,r.toast):n}))});case o.UPSERT_TOAST:var i=r.toast;return t.toasts.find((function(n){return n.id===i.id}))?n(t,{type:o.UPDATE_TOAST,toast:i}):n(t,{type:o.ADD_TOAST,toast:i});case o.DISMISS_TOAST:var a=r.toastId;return a?c(a):t.toasts.forEach((function(n){c(n.id)})),e({},t,{toasts:t.toasts.map((function(n){return n.id===a||void 0===a?e({},n,{visible:!1}):n}))});case o.REMOVE_TOAST:return e({},t,void 0===r.toastId?{toasts:[]}:{toasts:t.toasts.filter((function(n){return n.id!==r.toastId}))});case o.START_PAUSE:return e({},t,{pausedAt:r.time});case o.END_PAUSE:var s=r.time-(t.pausedAt||0);return e({},t,{pausedAt:void 0,toasts:t.toasts.map((function(n){return e({},n,{pauseDuration:n.pauseDuration+s})}))})}}(d,n),f.forEach((function(n){n(d)}))},p={blank:4e3,error:4e3,success:2e3,loading:Infinity,custom:4e3},m=function(t){void 0===t&&(t={});var r=n.useState(d),o=r[0],i=r[1];n.useEffect((function(){return f.push(i),function(){var n=f.indexOf(i);n>-1&&f.splice(n,1)}}),[o]);var a=o.toasts.map((function(n){var r,o,i;return e({},t,t[n.type],n,{duration:n.duration||(null==(r=t[n.type])?void 0:r.duration)||(null==(o=t)?void 0:o.duration)||p[n.type],style:e({},t.style,null==(i=t[n.type])?void 0:i.style,n.style)})}));return e({},o,{toasts:a})},v=function(n){return function(t,r){var i=function(n,t,r){return void 0===t&&(t="blank"),e({createdAt:Date.now(),visible:!0,type:t,ariaProps:{role:"status","aria-live":"polite"},message:n,pauseDuration:0},r,{id:(null==r?void 0:r.id)||a()})}(t,n,r);return l({type:o.UPSERT_TOAST,toast:i}),i.id}},y=function(n,t){return v("blank")(n,t)};y.error=v("error"),y.success=v("success"),y.loading=v("loading"),y.custom=v("custom"),y.dismiss=function(n){l({type:o.DISMISS_TOAST,toastId:n})},y.remove=function(n){return l({type:o.REMOVE_TOAST,toastId:n})},y.promise=function(n,t,r){var o=y.loading(t.loading,e({},r,null==r?void 0:r.loading));return n.then((function(n){return y.success(i(t.success,n),e({id:o},r,null==r?void 0:r.success)),n})).catch((function(n){y.error(i(t.error,n),e({id:o},r,null==r?void 0:r.error))})),n};var g=function(t){var e=m(t),r=e.toasts,i=e.pausedAt;n.useEffect((function(){if(!i){var n=Date.now(),t=r.map((function(t){if(Infinity!==t.duration){var e=(t.duration||0)+t.pauseDuration-(n-t.createdAt);if(!(e<0))return setTimeout((function(){return y.dismiss(t.id)}),e);t.visible&&y.dismiss(t.id)}}));return function(){t.forEach((function(n){return n&&clearTimeout(n)}))}}}),[r,i]);var a=n.useMemo((function(){return{startPause:function(){l({type:o.START_PAUSE,time:Date.now()})},endPause:function(){i&&l({type:o.END_PAUSE,time:Date.now()})},updateHeight:function(n,t){return l({type:o.UPDATE_TOAST,toast:{id:n,height:t}})},calculateOffset:function(n,t){var e,o=t||{},i=o.reverseOrder,a=void 0!==i&&i,s=o.gutter,u=void 0===s?8:s,c=o.defaultPosition,f=r.filter((function(t){return(t.position||c)===(n.position||c)&&t.height})),d=f.findIndex((function(t){return t.id===n.id})),l=f.filter((function(n,t){return t<d&&n.visible})).length;return(e=f.filter((function(n){return n.visible}))).slice.apply(e,a?[l+1]:[0,l]).reduce((function(n,t){return n+(t.height||0)+u}),0)}}}),[r,i]);return{toasts:r,handlers:a}};function h(){var n=r(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: "," 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: "," 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ",";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: "," 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"]);return h=function(){return n},n}function T(){var n=r(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]);return T=function(){return n},n}function b(){var n=r(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);return b=function(){return n},n}function x(){var n=r(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]);return x=function(){return n},n}var S=t.keyframes(x()),E=t.keyframes(b()),A=t.keyframes(T()),O=t.styled("div")(h(),(function(n){return n.primary||"#ff4b4b"}),S,E,(function(n){return n.secondary||"#fff"}),A);function w(){var n=r(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ",";\n  border-right-color: ",";\n  animation: "," 1s linear infinite;\n"]);return w=function(){return n},n}function _(){var n=r(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);return _=function(){return n},n}var D=t.keyframes(_()),P=t.styled("div")(w(),(function(n){return n.secondary||"#e0e0e0"}),(function(n){return n.primary||"#616161"}),D);function I(){var n=r(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: "," 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: "," 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ",";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"]);return I=function(){return n},n}function k(){var n=r(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]);return k=function(){return n},n}function U(){var n=r(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]);return U=function(){return n},n}var M=t.keyframes(U()),R=t.keyframes(k()),j=t.styled("div")(I(),(function(n){return n.primary||"#61d345"}),M,R,(function(n){return n.secondary||"#fff"}));function z(){var n=r(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: "," 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"]);return z=function(){return n},n}function N(){var n=r(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);return N=function(){return n},n}function V(){var n=r(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]);return V=function(){return n},n}function C(){var n=r(["\n  position: absolute;\n"]);return C=function(){return n},n}var q=t.styled("div")(C()),B=t.styled("div")(V()),H=t.keyframes(N()),L=t.styled("div")(z(),H),F=function(t){var e=t.toast,r=e.icon,o=e.type,i=e.iconTheme;return void 0!==r?"string"==typeof r?n.createElement(L,null,r):r:"blank"===o?null:n.createElement(B,null,n.createElement(P,Object.assign({},i)),"loading"!==o&&n.createElement(q,null,n.createElement("error"===o?O:j,Object.assign({},i))))};function Y(){var n=r(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]);return Y=function(){return n},n}function G(){var n=r(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]);return G=function(){return n},n}var J=function(n){return"\n0% {transform: translate3d(0,"+-200*n+"%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n"},K=function(n){return"\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0,"+-150*n+"%,-1px) scale(.6); opacity:0;}\n"},Q=t.styled("div",n.forwardRef)(G()),W=t.styled("div")(Y()),X=n.memo((function(r){var o,a,u,c,f=r.toast,d=r.style,l=r.children,p=null!=f&&f.height?(o=f.visible,a=(f.position||r.position||"top-center").includes("top")?1:-1,c=(u=s()?["0%{opacity:0;} 100%{opacity:1;}","0%{opacity:1;} 100%{opacity:0;}"]:[J(a),K(a)])[1],{animation:o?t.keyframes(u[0])+" 0.35s cubic-bezier(.21,1.02,.73,1) forwards":t.keyframes(c)+" 0.4s forwards cubic-bezier(.06,.71,.55,1)"}):{opacity:0},m=n.createElement(F,{toast:f}),v=n.createElement(W,Object.assign({},f.ariaProps),i(f.message,f));return n.createElement(Q,{className:f.className,style:e({},p,d,f.style)},"function"==typeof l?l({icon:m,message:v}):n.createElement(n.Fragment,null,m,v))}));function Z(){var n=r(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]);return Z=function(){return n},n}t.setup(n.createElement);var $=t.css(Z());exports.CheckmarkIcon=j,exports.ErrorIcon=O,exports.LoaderIcon=P,exports.ToastBar=X,exports.ToastIcon=F,exports.Toaster=function(t){var r=t.reverseOrder,o=t.position,a=void 0===o?"top-center":o,u=t.gutter,c=t.children,f=t.containerStyle,d=t.containerClassName,l=g(t.toastOptions),p=l.toasts,m=l.handlers;return n.createElement("div",{style:e({position:"fixed",zIndex:9999,top:16,left:16,right:16,bottom:16,pointerEvents:"none"},f),className:d,onMouseEnter:m.startPause,onMouseLeave:m.endPause},p.map((function(t){var o,f=t.position||a,d=function(n,t){var r=n.includes("top"),o=r?{top:0}:{bottom:0},i=n.includes("center")?{justifyContent:"center"}:n.includes("right")?{justifyContent:"flex-end"}:{};return e({left:0,right:0,display:"flex",position:"absolute",transition:s()?void 0:"all 230ms cubic-bezier(.21,1.02,.73,1)",transform:"translateY("+t*(r?1:-1)+"px)"},o,i)}(f,m.calculateOffset(t,{reverseOrder:r,gutter:u,defaultPosition:a})),l=t.height?void 0:(o=function(n){m.updateHeight(t.id,n.height)},function(n){n&&setTimeout((function(){var t=n.getBoundingClientRect();o(t)}))});return n.createElement("div",{ref:l,className:t.visible?$:"",key:t.id,style:d},"custom"===t.type?i(t.message,t):c?c(t):n.createElement(X,{toast:t,position:f}))})))},exports.default=y,exports.resolveValue=i,exports.toast=y,exports.useToaster=g,exports.useToasterStore=m;


},{"goober":639,"react":1107}],1021:[function(require,module,exports){
// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.Fa500Px = function Fa500Px (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"}}]})(props);
};
module.exports.FaAccessibleIcon = function FaAccessibleIcon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"}}]})(props);
};
module.exports.FaAccusoft = function FaAccusoft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"}}]})(props);
};
module.exports.FaAcquisitionsIncorporated = function FaAcquisitionsIncorporated (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"}}]})(props);
};
module.exports.FaAdn = function FaAdn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"}}]})(props);
};
module.exports.FaAdversal = function FaAdversal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"}}]})(props);
};
module.exports.FaAffiliatetheme = function FaAffiliatetheme (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"}}]})(props);
};
module.exports.FaAirbnb = function FaAirbnb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"}}]})(props);
};
module.exports.FaAlgolia = function FaAlgolia (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"}}]})(props);
};
module.exports.FaAlipay = function FaAlipay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"}}]})(props);
};
module.exports.FaAmazonPay = function FaAmazonPay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"}}]})(props);
};
module.exports.FaAmazon = function FaAmazon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"}}]})(props);
};
module.exports.FaAmilia = function FaAmilia (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"}}]})(props);
};
module.exports.FaAndroid = function FaAndroid (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"}}]})(props);
};
module.exports.FaAngellist = function FaAngellist (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"}}]})(props);
};
module.exports.FaAngrycreative = function FaAngrycreative (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"}}]})(props);
};
module.exports.FaAngular = function FaAngular (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"}}]})(props);
};
module.exports.FaAppStoreIos = function FaAppStoreIos (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"}}]})(props);
};
module.exports.FaAppStore = function FaAppStore (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"}}]})(props);
};
module.exports.FaApper = function FaApper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"}}]})(props);
};
module.exports.FaApplePay = function FaApplePay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"}}]})(props);
};
module.exports.FaApple = function FaApple (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"}}]})(props);
};
module.exports.FaArtstation = function FaArtstation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"}}]})(props);
};
module.exports.FaAsymmetrik = function FaAsymmetrik (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"}}]})(props);
};
module.exports.FaAtlassian = function FaAtlassian (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"}}]})(props);
};
module.exports.FaAudible = function FaAudible (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"}}]})(props);
};
module.exports.FaAutoprefixer = function FaAutoprefixer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"}}]})(props);
};
module.exports.FaAvianex = function FaAvianex (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"}}]})(props);
};
module.exports.FaAviato = function FaAviato (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"}}]})(props);
};
module.exports.FaAws = function FaAws (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"}}]})(props);
};
module.exports.FaBandcamp = function FaBandcamp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"}}]})(props);
};
module.exports.FaBattleNet = function FaBattleNet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"}}]})(props);
};
module.exports.FaBehanceSquare = function FaBehanceSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"}}]})(props);
};
module.exports.FaBehance = function FaBehance (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"}}]})(props);
};
module.exports.FaBimobject = function FaBimobject (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"}}]})(props);
};
module.exports.FaBitbucket = function FaBitbucket (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"}}]})(props);
};
module.exports.FaBitcoin = function FaBitcoin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"}}]})(props);
};
module.exports.FaBity = function FaBity (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"}}]})(props);
};
module.exports.FaBlackTie = function FaBlackTie (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"}}]})(props);
};
module.exports.FaBlackberry = function FaBlackberry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"}}]})(props);
};
module.exports.FaBloggerB = function FaBloggerB (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"}}]})(props);
};
module.exports.FaBlogger = function FaBlogger (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"}}]})(props);
};
module.exports.FaBluetoothB = function FaBluetoothB (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"}}]})(props);
};
module.exports.FaBluetooth = function FaBluetooth (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"}}]})(props);
};
module.exports.FaBootstrap = function FaBootstrap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"}}]})(props);
};
module.exports.FaBtc = function FaBtc (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"}}]})(props);
};
module.exports.FaBuffer = function FaBuffer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"}}]})(props);
};
module.exports.FaBuromobelexperte = function FaBuromobelexperte (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"}}]})(props);
};
module.exports.FaBuyNLarge = function FaBuyNLarge (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"}}]})(props);
};
module.exports.FaBuysellads = function FaBuysellads (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"}}]})(props);
};
module.exports.FaCanadianMapleLeaf = function FaCanadianMapleLeaf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"}}]})(props);
};
module.exports.FaCcAmazonPay = function FaCcAmazonPay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"}}]})(props);
};
module.exports.FaCcAmex = function FaCcAmex (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"}}]})(props);
};
module.exports.FaCcApplePay = function FaCcApplePay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"}}]})(props);
};
module.exports.FaCcDinersClub = function FaCcDinersClub (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"}}]})(props);
};
module.exports.FaCcDiscover = function FaCcDiscover (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"}}]})(props);
};
module.exports.FaCcJcb = function FaCcJcb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"}}]})(props);
};
module.exports.FaCcMastercard = function FaCcMastercard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"}}]})(props);
};
module.exports.FaCcPaypal = function FaCcPaypal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"}}]})(props);
};
module.exports.FaCcStripe = function FaCcStripe (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"}}]})(props);
};
module.exports.FaCcVisa = function FaCcVisa (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"}}]})(props);
};
module.exports.FaCentercode = function FaCentercode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"}}]})(props);
};
module.exports.FaCentos = function FaCentos (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"}}]})(props);
};
module.exports.FaChrome = function FaChrome (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"}}]})(props);
};
module.exports.FaChromecast = function FaChromecast (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"}}]})(props);
};
module.exports.FaCloudflare = function FaCloudflare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"}}]})(props);
};
module.exports.FaCloudscale = function FaCloudscale (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"}}]})(props);
};
module.exports.FaCloudsmith = function FaCloudsmith (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 332 512"},"child":[{"tag":"path","attr":{"d":"M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"}}]})(props);
};
module.exports.FaCloudversify = function FaCloudversify (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 616 512"},"child":[{"tag":"path","attr":{"d":"M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"}}]})(props);
};
module.exports.FaCodepen = function FaCodepen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"}}]})(props);
};
module.exports.FaCodiepie = function FaCodiepie (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 472 512"},"child":[{"tag":"path","attr":{"d":"M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"}}]})(props);
};
module.exports.FaConfluence = function FaConfluence (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"}}]})(props);
};
module.exports.FaConnectdevelop = function FaConnectdevelop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"}}]})(props);
};
module.exports.FaContao = function FaContao (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"}}]})(props);
};
module.exports.FaCottonBureau = function FaCottonBureau (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"}}]})(props);
};
module.exports.FaCpanel = function FaCpanel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"}}]})(props);
};
module.exports.FaCreativeCommonsBy = function FaCreativeCommonsBy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"}}]})(props);
};
module.exports.FaCreativeCommonsNcEu = function FaCreativeCommonsNcEu (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"}}]})(props);
};
module.exports.FaCreativeCommonsNcJp = function FaCreativeCommonsNcJp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"}}]})(props);
};
module.exports.FaCreativeCommonsNc = function FaCreativeCommonsNc (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"}}]})(props);
};
module.exports.FaCreativeCommonsNd = function FaCreativeCommonsNd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"}}]})(props);
};
module.exports.FaCreativeCommonsPdAlt = function FaCreativeCommonsPdAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"}}]})(props);
};
module.exports.FaCreativeCommonsPd = function FaCreativeCommonsPd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"}}]})(props);
};
module.exports.FaCreativeCommonsRemix = function FaCreativeCommonsRemix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"}}]})(props);
};
module.exports.FaCreativeCommonsSa = function FaCreativeCommonsSa (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"}}]})(props);
};
module.exports.FaCreativeCommonsSamplingPlus = function FaCreativeCommonsSamplingPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"}}]})(props);
};
module.exports.FaCreativeCommonsSampling = function FaCreativeCommonsSampling (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"}}]})(props);
};
module.exports.FaCreativeCommonsShare = function FaCreativeCommonsShare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"}}]})(props);
};
module.exports.FaCreativeCommonsZero = function FaCreativeCommonsZero (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"}}]})(props);
};
module.exports.FaCreativeCommons = function FaCreativeCommons (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"}}]})(props);
};
module.exports.FaCriticalRole = function FaCriticalRole (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"}}]})(props);
};
module.exports.FaCss3Alt = function FaCss3Alt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"}}]})(props);
};
module.exports.FaCss3 = function FaCss3 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"}}]})(props);
};
module.exports.FaCuttlefish = function FaCuttlefish (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 440 512"},"child":[{"tag":"path","attr":{"d":"M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"}}]})(props);
};
module.exports.FaDAndDBeyond = function FaDAndDBeyond (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"}}]})(props);
};
module.exports.FaDAndD = function FaDAndD (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"}}]})(props);
};
module.exports.FaDailymotion = function FaDailymotion (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"}}]})(props);
};
module.exports.FaDashcube = function FaDashcube (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"}}]})(props);
};
module.exports.FaDeezer = function FaDeezer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"}}]})(props);
};
module.exports.FaDelicious = function FaDelicious (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"}}]})(props);
};
module.exports.FaDeploydog = function FaDeploydog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"}}]})(props);
};
module.exports.FaDeskpro = function FaDeskpro (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"}}]})(props);
};
module.exports.FaDev = function FaDev (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"}}]})(props);
};
module.exports.FaDeviantart = function FaDeviantart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"}}]})(props);
};
module.exports.FaDhl = function FaDhl (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"}}]})(props);
};
module.exports.FaDiaspora = function FaDiaspora (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"}}]})(props);
};
module.exports.FaDigg = function FaDigg (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"}}]})(props);
};
module.exports.FaDigitalOcean = function FaDigitalOcean (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"}}]})(props);
};
module.exports.FaDiscord = function FaDiscord (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"}}]})(props);
};
module.exports.FaDiscourse = function FaDiscourse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"}}]})(props);
};
module.exports.FaDochub = function FaDochub (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"}}]})(props);
};
module.exports.FaDocker = function FaDocker (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"}}]})(props);
};
module.exports.FaDraft2Digital = function FaDraft2Digital (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"}}]})(props);
};
module.exports.FaDribbbleSquare = function FaDribbbleSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"}}]})(props);
};
module.exports.FaDribbble = function FaDribbble (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"}}]})(props);
};
module.exports.FaDropbox = function FaDropbox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 528 512"},"child":[{"tag":"path","attr":{"d":"M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"}}]})(props);
};
module.exports.FaDrupal = function FaDrupal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"}}]})(props);
};
module.exports.FaDyalog = function FaDyalog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"}}]})(props);
};
module.exports.FaEarlybirds = function FaEarlybirds (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"}}]})(props);
};
module.exports.FaEbay = function FaEbay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"}}]})(props);
};
module.exports.FaEdgeLegacy = function FaEdgeLegacy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"}}]})(props);
};
module.exports.FaEdge = function FaEdge (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"}}]})(props);
};
module.exports.FaElementor = function FaElementor (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"}}]})(props);
};
module.exports.FaEllo = function FaEllo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"}}]})(props);
};
module.exports.FaEmber = function FaEmber (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"}}]})(props);
};
module.exports.FaEmpire = function FaEmpire (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"}}]})(props);
};
module.exports.FaEnvira = function FaEnvira (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"}}]})(props);
};
module.exports.FaErlang = function FaErlang (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"}}]})(props);
};
module.exports.FaEthereum = function FaEthereum (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"}}]})(props);
};
module.exports.FaEtsy = function FaEtsy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"}}]})(props);
};
module.exports.FaEvernote = function FaEvernote (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"}}]})(props);
};
module.exports.FaExpeditedssl = function FaExpeditedssl (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"}}]})(props);
};
module.exports.FaFacebookF = function FaFacebookF (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"}}]})(props);
};
module.exports.FaFacebookMessenger = function FaFacebookMessenger (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"}}]})(props);
};
module.exports.FaFacebookSquare = function FaFacebookSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"}}]})(props);
};
module.exports.FaFacebook = function FaFacebook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"}}]})(props);
};
module.exports.FaFantasyFlightGames = function FaFantasyFlightGames (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"}}]})(props);
};
module.exports.FaFedex = function FaFedex (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"}}]})(props);
};
module.exports.FaFedora = function FaFedora (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"}}]})(props);
};
module.exports.FaFigma = function FaFigma (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"}}]})(props);
};
module.exports.FaFirefoxBrowser = function FaFirefoxBrowser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"}}]})(props);
};
module.exports.FaFirefox = function FaFirefox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"}}]})(props);
};
module.exports.FaFirstOrderAlt = function FaFirstOrderAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"}}]})(props);
};
module.exports.FaFirstOrder = function FaFirstOrder (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"}}]})(props);
};
module.exports.FaFirstdraft = function FaFirstdraft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"}}]})(props);
};
module.exports.FaFlickr = function FaFlickr (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"}}]})(props);
};
module.exports.FaFlipboard = function FaFlipboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"}}]})(props);
};
module.exports.FaFly = function FaFly (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"}}]})(props);
};
module.exports.FaFontAwesomeAlt = function FaFontAwesomeAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"}}]})(props);
};
module.exports.FaFontAwesomeFlag = function FaFontAwesomeFlag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"}}]})(props);
};
module.exports.FaFontAwesomeLogoFull = function FaFontAwesomeLogoFull (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 3992 512"},"child":[{"tag":"path","attr":{"d":"M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"}}]})(props);
};
module.exports.FaFontAwesome = function FaFontAwesome (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"}}]})(props);
};
module.exports.FaFonticonsFi = function FaFonticonsFi (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"}}]})(props);
};
module.exports.FaFonticons = function FaFonticons (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"}}]})(props);
};
module.exports.FaFortAwesomeAlt = function FaFortAwesomeAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"}}]})(props);
};
module.exports.FaFortAwesome = function FaFortAwesome (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"}}]})(props);
};
module.exports.FaForumbee = function FaForumbee (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"}}]})(props);
};
module.exports.FaFoursquare = function FaFoursquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 368 512"},"child":[{"tag":"path","attr":{"d":"M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"}}]})(props);
};
module.exports.FaFreeCodeCamp = function FaFreeCodeCamp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"}}]})(props);
};
module.exports.FaFreebsd = function FaFreebsd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"}}]})(props);
};
module.exports.FaFulcrum = function FaFulcrum (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"}}]})(props);
};
module.exports.FaGalacticRepublic = function FaGalacticRepublic (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"}}]})(props);
};
module.exports.FaGalacticSenate = function FaGalacticSenate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"}}]})(props);
};
module.exports.FaGetPocket = function FaGetPocket (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"}}]})(props);
};
module.exports.FaGgCircle = function FaGgCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"}}]})(props);
};
module.exports.FaGg = function FaGg (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"}}]})(props);
};
module.exports.FaGitAlt = function FaGitAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"}}]})(props);
};
module.exports.FaGitSquare = function FaGitSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"}}]})(props);
};
module.exports.FaGit = function FaGit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"}}]})(props);
};
module.exports.FaGithubAlt = function FaGithubAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"}}]})(props);
};
module.exports.FaGithubSquare = function FaGithubSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"}}]})(props);
};
module.exports.FaGithub = function FaGithub (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"}}]})(props);
};
module.exports.FaGitkraken = function FaGitkraken (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 592 512"},"child":[{"tag":"path","attr":{"d":"M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"}}]})(props);
};
module.exports.FaGitlab = function FaGitlab (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"}}]})(props);
};
module.exports.FaGitter = function FaGitter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"}}]})(props);
};
module.exports.FaGlideG = function FaGlideG (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"}}]})(props);
};
module.exports.FaGlide = function FaGlide (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"}}]})(props);
};
module.exports.FaGofore = function FaGofore (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 400 512"},"child":[{"tag":"path","attr":{"d":"M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"}}]})(props);
};
module.exports.FaGoodreadsG = function FaGoodreadsG (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"}}]})(props);
};
module.exports.FaGoodreads = function FaGoodreads (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"}}]})(props);
};
module.exports.FaGoogleDrive = function FaGoogleDrive (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"}}]})(props);
};
module.exports.FaGooglePay = function FaGooglePay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"}}]})(props);
};
module.exports.FaGooglePlay = function FaGooglePlay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"}}]})(props);
};
module.exports.FaGooglePlusG = function FaGooglePlusG (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"}}]})(props);
};
module.exports.FaGooglePlusSquare = function FaGooglePlusSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"}}]})(props);
};
module.exports.FaGooglePlus = function FaGooglePlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"}}]})(props);
};
module.exports.FaGoogleWallet = function FaGoogleWallet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"}}]})(props);
};
module.exports.FaGoogle = function FaGoogle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 488 512"},"child":[{"tag":"path","attr":{"d":"M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"}}]})(props);
};
module.exports.FaGratipay = function FaGratipay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"}}]})(props);
};
module.exports.FaGrav = function FaGrav (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"}}]})(props);
};
module.exports.FaGripfire = function FaGripfire (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"}}]})(props);
};
module.exports.FaGrunt = function FaGrunt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"}}]})(props);
};
module.exports.FaGuilded = function FaGuilded (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"}}]})(props);
};
module.exports.FaGulp = function FaGulp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"}}]})(props);
};
module.exports.FaHackerNewsSquare = function FaHackerNewsSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}}]})(props);
};
module.exports.FaHackerNews = function FaHackerNews (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}}]})(props);
};
module.exports.FaHackerrank = function FaHackerrank (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"}}]})(props);
};
module.exports.FaHips = function FaHips (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"}}]})(props);
};
module.exports.FaHireAHelper = function FaHireAHelper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"}}]})(props);
};
module.exports.FaHive = function FaHive (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"}}]})(props);
};
module.exports.FaHooli = function FaHooli (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"}}]})(props);
};
module.exports.FaHornbill = function FaHornbill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"}}]})(props);
};
module.exports.FaHotjar = function FaHotjar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"}}]})(props);
};
module.exports.FaHouzz = function FaHouzz (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"}}]})(props);
};
module.exports.FaHtml5 = function FaHtml5 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"}}]})(props);
};
module.exports.FaHubspot = function FaHubspot (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"}}]})(props);
};
module.exports.FaIdeal = function FaIdeal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"}}]})(props);
};
module.exports.FaImdb = function FaImdb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"}}]})(props);
};
module.exports.FaInnosoft = function FaInnosoft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"}}]})(props);
};
module.exports.FaInstagramSquare = function FaInstagramSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"}}]})(props);
};
module.exports.FaInstagram = function FaInstagram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}}]})(props);
};
module.exports.FaInstalod = function FaInstalod (props) {
  return GenIcon({"tag":"svg","attr":{"dataName":"Layer 1","viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"}}]})(props);
};
module.exports.FaIntercom = function FaIntercom (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"}}]})(props);
};
module.exports.FaInternetExplorer = function FaInternetExplorer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"}}]})(props);
};
module.exports.FaInvision = function FaInvision (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"}}]})(props);
};
module.exports.FaIoxhost = function FaIoxhost (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"}}]})(props);
};
module.exports.FaItchIo = function FaItchIo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"}}]})(props);
};
module.exports.FaItunesNote = function FaItunesNote (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"}}]})(props);
};
module.exports.FaItunes = function FaItunes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"}}]})(props);
};
module.exports.FaJava = function FaJava (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"}}]})(props);
};
module.exports.FaJediOrder = function FaJediOrder (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"}}]})(props);
};
module.exports.FaJenkins = function FaJenkins (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"}}]})(props);
};
module.exports.FaJira = function FaJira (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"}}]})(props);
};
module.exports.FaJoget = function FaJoget (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"}}]})(props);
};
module.exports.FaJoomla = function FaJoomla (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"}}]})(props);
};
module.exports.FaJsSquare = function FaJsSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"}}]})(props);
};
module.exports.FaJs = function FaJs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"}}]})(props);
};
module.exports.FaJsfiddle = function FaJsfiddle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"}}]})(props);
};
module.exports.FaKaggle = function FaKaggle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"}}]})(props);
};
module.exports.FaKeybase = function FaKeybase (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"}}]})(props);
};
module.exports.FaKeycdn = function FaKeycdn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"}}]})(props);
};
module.exports.FaKickstarterK = function FaKickstarterK (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"}}]})(props);
};
module.exports.FaKickstarter = function FaKickstarter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"}}]})(props);
};
module.exports.FaKorvue = function FaKorvue (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 446 512"},"child":[{"tag":"path","attr":{"d":"M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"}}]})(props);
};
module.exports.FaLaravel = function FaLaravel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"}}]})(props);
};
module.exports.FaLastfmSquare = function FaLastfmSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"}}]})(props);
};
module.exports.FaLastfm = function FaLastfm (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"}}]})(props);
};
module.exports.FaLeanpub = function FaLeanpub (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"}}]})(props);
};
module.exports.FaLess = function FaLess (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"}}]})(props);
};
module.exports.FaLine = function FaLine (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"}}]})(props);
};
module.exports.FaLinkedinIn = function FaLinkedinIn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"}}]})(props);
};
module.exports.FaLinkedin = function FaLinkedin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"}}]})(props);
};
module.exports.FaLinode = function FaLinode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"}}]})(props);
};
module.exports.FaLinux = function FaLinux (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"}}]})(props);
};
module.exports.FaLyft = function FaLyft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"}}]})(props);
};
module.exports.FaMagento = function FaMagento (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"}}]})(props);
};
module.exports.FaMailchimp = function FaMailchimp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"}}]})(props);
};
module.exports.FaMandalorian = function FaMandalorian (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"}}]})(props);
};
module.exports.FaMarkdown = function FaMarkdown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"}}]})(props);
};
module.exports.FaMastodon = function FaMastodon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"}}]})(props);
};
module.exports.FaMaxcdn = function FaMaxcdn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"}}]})(props);
};
module.exports.FaMdb = function FaMdb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"}}]})(props);
};
module.exports.FaMedapps = function FaMedapps (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"}}]})(props);
};
module.exports.FaMediumM = function FaMediumM (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"}}]})(props);
};
module.exports.FaMedium = function FaMedium (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"}}]})(props);
};
module.exports.FaMedrt = function FaMedrt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"}}]})(props);
};
module.exports.FaMeetup = function FaMeetup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"}}]})(props);
};
module.exports.FaMegaport = function FaMegaport (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"}}]})(props);
};
module.exports.FaMendeley = function FaMendeley (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"}}]})(props);
};
module.exports.FaMicroblog = function FaMicroblog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"}}]})(props);
};
module.exports.FaMicrosoft = function FaMicrosoft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"}}]})(props);
};
module.exports.FaMix = function FaMix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"}}]})(props);
};
module.exports.FaMixcloud = function FaMixcloud (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"}}]})(props);
};
module.exports.FaMixer = function FaMixer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"}}]})(props);
};
module.exports.FaMizuni = function FaMizuni (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"}}]})(props);
};
module.exports.FaModx = function FaModx (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"}}]})(props);
};
module.exports.FaMonero = function FaMonero (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"}}]})(props);
};
module.exports.FaNapster = function FaNapster (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"}}]})(props);
};
module.exports.FaNeos = function FaNeos (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"}}]})(props);
};
module.exports.FaNimblr = function FaNimblr (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"}}]})(props);
};
module.exports.FaNodeJs = function FaNodeJs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"}}]})(props);
};
module.exports.FaNode = function FaNode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"}}]})(props);
};
module.exports.FaNpm = function FaNpm (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"}}]})(props);
};
module.exports.FaNs8 = function FaNs8 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"}}]})(props);
};
module.exports.FaNutritionix = function FaNutritionix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 400 512"},"child":[{"tag":"path","attr":{"d":"M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"}}]})(props);
};
module.exports.FaOctopusDeploy = function FaOctopusDeploy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"}}]})(props);
};
module.exports.FaOdnoklassnikiSquare = function FaOdnoklassnikiSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"}}]})(props);
};
module.exports.FaOdnoklassniki = function FaOdnoklassniki (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"}}]})(props);
};
module.exports.FaOldRepublic = function FaOldRepublic (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"}}]})(props);
};
module.exports.FaOpencart = function FaOpencart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"}}]})(props);
};
module.exports.FaOpenid = function FaOpenid (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"}}]})(props);
};
module.exports.FaOpera = function FaOpera (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"}}]})(props);
};
module.exports.FaOptinMonster = function FaOptinMonster (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"}}]})(props);
};
module.exports.FaOrcid = function FaOrcid (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"}}]})(props);
};
module.exports.FaOsi = function FaOsi (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"}}]})(props);
};
module.exports.FaPage4 = function FaPage4 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"}}]})(props);
};
module.exports.FaPagelines = function FaPagelines (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"}}]})(props);
};
module.exports.FaPalfed = function FaPalfed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"}}]})(props);
};
module.exports.FaPatreon = function FaPatreon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"}}]})(props);
};
module.exports.FaPaypal = function FaPaypal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"}}]})(props);
};
module.exports.FaPennyArcade = function FaPennyArcade (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"}}]})(props);
};
module.exports.FaPerbyte = function FaPerbyte (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"}}]})(props);
};
module.exports.FaPeriscope = function FaPeriscope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"}}]})(props);
};
module.exports.FaPhabricator = function FaPhabricator (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"}}]})(props);
};
module.exports.FaPhoenixFramework = function FaPhoenixFramework (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"}}]})(props);
};
module.exports.FaPhoenixSquadron = function FaPhoenixSquadron (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"}}]})(props);
};
module.exports.FaPhp = function FaPhp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"}}]})(props);
};
module.exports.FaPiedPiperAlt = function FaPiedPiperAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"}}]})(props);
};
module.exports.FaPiedPiperHat = function FaPiedPiperHat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"}}]})(props);
};
module.exports.FaPiedPiperPp = function FaPiedPiperPp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"}}]})(props);
};
module.exports.FaPiedPiperSquare = function FaPiedPiperSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"}}]})(props);
};
module.exports.FaPiedPiper = function FaPiedPiper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"}}]})(props);
};
module.exports.FaPinterestP = function FaPinterestP (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"}}]})(props);
};
module.exports.FaPinterestSquare = function FaPinterestSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"}}]})(props);
};
module.exports.FaPinterest = function FaPinterest (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"}}]})(props);
};
module.exports.FaPlaystation = function FaPlaystation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"}}]})(props);
};
module.exports.FaProductHunt = function FaProductHunt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"}}]})(props);
};
module.exports.FaPushed = function FaPushed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 432 512"},"child":[{"tag":"path","attr":{"d":"M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"}}]})(props);
};
module.exports.FaPython = function FaPython (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"}}]})(props);
};
module.exports.FaQq = function FaQq (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"}}]})(props);
};
module.exports.FaQuinscape = function FaQuinscape (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"}}]})(props);
};
module.exports.FaQuora = function FaQuora (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"}}]})(props);
};
module.exports.FaRProject = function FaRProject (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 581 512"},"child":[{"tag":"path","attr":{"d":"M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"}}]})(props);
};
module.exports.FaRaspberryPi = function FaRaspberryPi (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 407 512"},"child":[{"tag":"path","attr":{"d":"M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"}}]})(props);
};
module.exports.FaRavelry = function FaRavelry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"}}]})(props);
};
module.exports.FaReact = function FaReact (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"}}]})(props);
};
module.exports.FaReacteurope = function FaReacteurope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"}}]})(props);
};
module.exports.FaReadme = function FaReadme (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"}}]})(props);
};
module.exports.FaRebel = function FaRebel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"}}]})(props);
};
module.exports.FaRedRiver = function FaRedRiver (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"}}]})(props);
};
module.exports.FaRedditAlien = function FaRedditAlien (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"}}]})(props);
};
module.exports.FaRedditSquare = function FaRedditSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"}}]})(props);
};
module.exports.FaReddit = function FaReddit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"}}]})(props);
};
module.exports.FaRedhat = function FaRedhat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"}}]})(props);
};
module.exports.FaRenren = function FaRenren (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"}}]})(props);
};
module.exports.FaReplyd = function FaReplyd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"}}]})(props);
};
module.exports.FaResearchgate = function FaResearchgate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"}}]})(props);
};
module.exports.FaResolving = function FaResolving (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"}}]})(props);
};
module.exports.FaRev = function FaRev (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"}}]})(props);
};
module.exports.FaRocketchat = function FaRocketchat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"}}]})(props);
};
module.exports.FaRockrms = function FaRockrms (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"}}]})(props);
};
module.exports.FaRust = function FaRust (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"}}]})(props);
};
module.exports.FaSafari = function FaSafari (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"}}]})(props);
};
module.exports.FaSalesforce = function FaSalesforce (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"}}]})(props);
};
module.exports.FaSass = function FaSass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"}}]})(props);
};
module.exports.FaSchlix = function FaSchlix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"}}]})(props);
};
module.exports.FaScribd = function FaScribd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"}}]})(props);
};
module.exports.FaSearchengin = function FaSearchengin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 460 512"},"child":[{"tag":"path","attr":{"d":"M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"}}]})(props);
};
module.exports.FaSellcast = function FaSellcast (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"}}]})(props);
};
module.exports.FaSellsy = function FaSellsy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"}}]})(props);
};
module.exports.FaServicestack = function FaServicestack (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"}}]})(props);
};
module.exports.FaShirtsinbulk = function FaShirtsinbulk (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"}}]})(props);
};
module.exports.FaShopify = function FaShopify (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"}}]})(props);
};
module.exports.FaShopware = function FaShopware (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"}}]})(props);
};
module.exports.FaSimplybuilt = function FaSimplybuilt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"}}]})(props);
};
module.exports.FaSistrix = function FaSistrix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"}}]})(props);
};
module.exports.FaSith = function FaSith (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"}}]})(props);
};
module.exports.FaSketch = function FaSketch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"}}]})(props);
};
module.exports.FaSkyatlas = function FaSkyatlas (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"}}]})(props);
};
module.exports.FaSkype = function FaSkype (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"}}]})(props);
};
module.exports.FaSlackHash = function FaSlackHash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"}}]})(props);
};
module.exports.FaSlack = function FaSlack (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"}}]})(props);
};
module.exports.FaSlideshare = function FaSlideshare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"}}]})(props);
};
module.exports.FaSnapchatGhost = function FaSnapchatGhost (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"}}]})(props);
};
module.exports.FaSnapchatSquare = function FaSnapchatSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"}}]})(props);
};
module.exports.FaSnapchat = function FaSnapchat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"}}]})(props);
};
module.exports.FaSoundcloud = function FaSoundcloud (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"}}]})(props);
};
module.exports.FaSourcetree = function FaSourcetree (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"}}]})(props);
};
module.exports.FaSpeakap = function FaSpeakap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"}}]})(props);
};
module.exports.FaSpeakerDeck = function FaSpeakerDeck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"}}]})(props);
};
module.exports.FaSpotify = function FaSpotify (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"}}]})(props);
};
module.exports.FaSquarespace = function FaSquarespace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"}}]})(props);
};
module.exports.FaStackExchange = function FaStackExchange (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"}}]})(props);
};
module.exports.FaStackOverflow = function FaStackOverflow (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"}}]})(props);
};
module.exports.FaStackpath = function FaStackpath (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"}}]})(props);
};
module.exports.FaStaylinked = function FaStaylinked (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 440 512"},"child":[{"tag":"path","attr":{"d":"M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"}}]})(props);
};
module.exports.FaSteamSquare = function FaSteamSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"}}]})(props);
};
module.exports.FaSteamSymbol = function FaSteamSymbol (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"}}]})(props);
};
module.exports.FaSteam = function FaSteam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"}}]})(props);
};
module.exports.FaStickerMule = function FaStickerMule (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"}}]})(props);
};
module.exports.FaStrava = function FaStrava (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"}}]})(props);
};
module.exports.FaStripeS = function FaStripeS (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"}}]})(props);
};
module.exports.FaStripe = function FaStripe (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"}}]})(props);
};
module.exports.FaStudiovinari = function FaStudiovinari (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"}}]})(props);
};
module.exports.FaStumbleuponCircle = function FaStumbleuponCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"}}]})(props);
};
module.exports.FaStumbleupon = function FaStumbleupon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"}}]})(props);
};
module.exports.FaSuperpowers = function FaSuperpowers (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"}}]})(props);
};
module.exports.FaSupple = function FaSupple (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"}}]})(props);
};
module.exports.FaSuse = function FaSuse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"}}]})(props);
};
module.exports.FaSwift = function FaSwift (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"}}]})(props);
};
module.exports.FaSymfony = function FaSymfony (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"}}]})(props);
};
module.exports.FaTeamspeak = function FaTeamspeak (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"}}]})(props);
};
module.exports.FaTelegramPlane = function FaTelegramPlane (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"}}]})(props);
};
module.exports.FaTelegram = function FaTelegram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"}}]})(props);
};
module.exports.FaTencentWeibo = function FaTencentWeibo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"}}]})(props);
};
module.exports.FaTheRedYeti = function FaTheRedYeti (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"}}]})(props);
};
module.exports.FaThemeco = function FaThemeco (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"}}]})(props);
};
module.exports.FaThemeisle = function FaThemeisle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"}}]})(props);
};
module.exports.FaThinkPeaks = function FaThinkPeaks (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"}}]})(props);
};
module.exports.FaTiktok = function FaTiktok (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"}}]})(props);
};
module.exports.FaTradeFederation = function FaTradeFederation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"}}]})(props);
};
module.exports.FaTrello = function FaTrello (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"}}]})(props);
};
module.exports.FaTripadvisor = function FaTripadvisor (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"}}]})(props);
};
module.exports.FaTumblrSquare = function FaTumblrSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"}}]})(props);
};
module.exports.FaTumblr = function FaTumblr (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}}]})(props);
};
module.exports.FaTwitch = function FaTwitch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"}}]})(props);
};
module.exports.FaTwitterSquare = function FaTwitterSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"}}]})(props);
};
module.exports.FaTwitter = function FaTwitter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}}]})(props);
};
module.exports.FaTypo3 = function FaTypo3 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"}}]})(props);
};
module.exports.FaUber = function FaUber (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"}}]})(props);
};
module.exports.FaUbuntu = function FaUbuntu (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"}}]})(props);
};
module.exports.FaUikit = function FaUikit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"}}]})(props);
};
module.exports.FaUmbraco = function FaUmbraco (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 510 512"},"child":[{"tag":"path","attr":{"d":"M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"}}]})(props);
};
module.exports.FaUncharted = function FaUncharted (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"}}]})(props);
};
module.exports.FaUniregistry = function FaUniregistry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"}}]})(props);
};
module.exports.FaUnity = function FaUnity (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"}}]})(props);
};
module.exports.FaUnsplash = function FaUnsplash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"}}]})(props);
};
module.exports.FaUntappd = function FaUntappd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"}}]})(props);
};
module.exports.FaUps = function FaUps (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"}}]})(props);
};
module.exports.FaUsb = function FaUsb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"}}]})(props);
};
module.exports.FaUsps = function FaUsps (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"}}]})(props);
};
module.exports.FaUssunnah = function FaUssunnah (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"}}]})(props);
};
module.exports.FaVaadin = function FaVaadin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"}}]})(props);
};
module.exports.FaViacoin = function FaViacoin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"}}]})(props);
};
module.exports.FaViadeoSquare = function FaViadeoSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"}}]})(props);
};
module.exports.FaViadeo = function FaViadeo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"}}]})(props);
};
module.exports.FaViber = function FaViber (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"}}]})(props);
};
module.exports.FaVimeoSquare = function FaVimeoSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"}}]})(props);
};
module.exports.FaVimeoV = function FaVimeoV (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"}}]})(props);
};
module.exports.FaVimeo = function FaVimeo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"}}]})(props);
};
module.exports.FaVine = function FaVine (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"}}]})(props);
};
module.exports.FaVk = function FaVk (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"}}]})(props);
};
module.exports.FaVnv = function FaVnv (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"}}]})(props);
};
module.exports.FaVuejs = function FaVuejs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"}}]})(props);
};
module.exports.FaWatchmanMonitoring = function FaWatchmanMonitoring (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"}}]})(props);
};
module.exports.FaWaze = function FaWaze (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"}}]})(props);
};
module.exports.FaWeebly = function FaWeebly (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"}}]})(props);
};
module.exports.FaWeibo = function FaWeibo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"}}]})(props);
};
module.exports.FaWeixin = function FaWeixin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"}}]})(props);
};
module.exports.FaWhatsappSquare = function FaWhatsappSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"}}]})(props);
};
module.exports.FaWhatsapp = function FaWhatsapp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}}]})(props);
};
module.exports.FaWhmcs = function FaWhmcs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"}}]})(props);
};
module.exports.FaWikipediaW = function FaWikipediaW (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"}}]})(props);
};
module.exports.FaWindows = function FaWindows (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"}}]})(props);
};
module.exports.FaWix = function FaWix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"}}]})(props);
};
module.exports.FaWizardsOfTheCoast = function FaWizardsOfTheCoast (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"}}]})(props);
};
module.exports.FaWodu = function FaWodu (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"}}]})(props);
};
module.exports.FaWolfPackBattalion = function FaWolfPackBattalion (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"}}]})(props);
};
module.exports.FaWordpressSimple = function FaWordpressSimple (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"}}]})(props);
};
module.exports.FaWordpress = function FaWordpress (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"}}]})(props);
};
module.exports.FaWpbeginner = function FaWpbeginner (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"}}]})(props);
};
module.exports.FaWpexplorer = function FaWpexplorer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"}}]})(props);
};
module.exports.FaWpforms = function FaWpforms (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"}}]})(props);
};
module.exports.FaWpressr = function FaWpressr (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"}}]})(props);
};
module.exports.FaXbox = function FaXbox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"}}]})(props);
};
module.exports.FaXingSquare = function FaXingSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"}}]})(props);
};
module.exports.FaXing = function FaXing (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"}}]})(props);
};
module.exports.FaYCombinator = function FaYCombinator (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"}}]})(props);
};
module.exports.FaYahoo = function FaYahoo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"}}]})(props);
};
module.exports.FaYammer = function FaYammer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"}}]})(props);
};
module.exports.FaYandexInternational = function FaYandexInternational (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"}}]})(props);
};
module.exports.FaYandex = function FaYandex (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"}}]})(props);
};
module.exports.FaYarn = function FaYarn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"}}]})(props);
};
module.exports.FaYelp = function FaYelp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"}}]})(props);
};
module.exports.FaYoast = function FaYoast (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"}}]})(props);
};
module.exports.FaYoutubeSquare = function FaYoutubeSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"}}]})(props);
};
module.exports.FaYoutube = function FaYoutube (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}}]})(props);
};
module.exports.FaZhihu = function FaZhihu (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"}}]})(props);
};
module.exports.FaAd = function FaAd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"}}]})(props);
};
module.exports.FaAddressBook = function FaAddressBook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"}}]})(props);
};
module.exports.FaAddressCard = function FaAddressCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"}}]})(props);
};
module.exports.FaAdjust = function FaAdjust (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"}}]})(props);
};
module.exports.FaAirFreshener = function FaAirFreshener (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"}}]})(props);
};
module.exports.FaAlignCenter = function FaAlignCenter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"}}]})(props);
};
module.exports.FaAlignJustify = function FaAlignJustify (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaAlignLeft = function FaAlignLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaAlignRight = function FaAlignRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"}}]})(props);
};
module.exports.FaAllergies = function FaAllergies (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
};
module.exports.FaAmbulance = function FaAmbulance (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"}}]})(props);
};
module.exports.FaAmericanSignLanguageInterpreting = function FaAmericanSignLanguageInterpreting (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"}}]})(props);
};
module.exports.FaAnchor = function FaAnchor (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"}}]})(props);
};
module.exports.FaAngleDoubleDown = function FaAngleDoubleDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"}}]})(props);
};
module.exports.FaAngleDoubleLeft = function FaAngleDoubleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"}}]})(props);
};
module.exports.FaAngleDoubleRight = function FaAngleDoubleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"}}]})(props);
};
module.exports.FaAngleDoubleUp = function FaAngleDoubleUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"}}]})(props);
};
module.exports.FaAngleDown = function FaAngleDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"}}]})(props);
};
module.exports.FaAngleLeft = function FaAngleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"}}]})(props);
};
module.exports.FaAngleRight = function FaAngleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"}}]})(props);
};
module.exports.FaAngleUp = function FaAngleUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"}}]})(props);
};
module.exports.FaAngry = function FaAngry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"}}]})(props);
};
module.exports.FaAnkh = function FaAnkh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"}}]})(props);
};
module.exports.FaAppleAlt = function FaAppleAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"}}]})(props);
};
module.exports.FaArchive = function FaArchive (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"}}]})(props);
};
module.exports.FaArchway = function FaArchway (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaArrowAltCircleDown = function FaArrowAltCircleDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"}}]})(props);
};
module.exports.FaArrowAltCircleLeft = function FaArrowAltCircleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"}}]})(props);
};
module.exports.FaArrowAltCircleRight = function FaArrowAltCircleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"}}]})(props);
};
module.exports.FaArrowAltCircleUp = function FaArrowAltCircleUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"}}]})(props);
};
module.exports.FaArrowCircleDown = function FaArrowCircleDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"}}]})(props);
};
module.exports.FaArrowCircleLeft = function FaArrowCircleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"}}]})(props);
};
module.exports.FaArrowCircleRight = function FaArrowCircleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"}}]})(props);
};
module.exports.FaArrowCircleUp = function FaArrowCircleUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"}}]})(props);
};
module.exports.FaArrowDown = function FaArrowDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"}}]})(props);
};
module.exports.FaArrowLeft = function FaArrowLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"}}]})(props);
};
module.exports.FaArrowRight = function FaArrowRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"}}]})(props);
};
module.exports.FaArrowUp = function FaArrowUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"}}]})(props);
};
module.exports.FaArrowsAltH = function FaArrowsAltH (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"}}]})(props);
};
module.exports.FaArrowsAltV = function FaArrowsAltV (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"}}]})(props);
};
module.exports.FaArrowsAlt = function FaArrowsAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"}}]})(props);
};
module.exports.FaAssistiveListeningSystems = function FaAssistiveListeningSystems (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"}}]})(props);
};
module.exports.FaAsterisk = function FaAsterisk (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"}}]})(props);
};
module.exports.FaAt = function FaAt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"}}]})(props);
};
module.exports.FaAtlas = function FaAtlas (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"}}]})(props);
};
module.exports.FaAtom = function FaAtom (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"}}]})(props);
};
module.exports.FaAudioDescription = function FaAudioDescription (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"}}]})(props);
};
module.exports.FaAward = function FaAward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"}}]})(props);
};
module.exports.FaBabyCarriage = function FaBabyCarriage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"}}]})(props);
};
module.exports.FaBaby = function FaBaby (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"}}]})(props);
};
module.exports.FaBackspace = function FaBackspace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"}}]})(props);
};
module.exports.FaBackward = function FaBackward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"}}]})(props);
};
module.exports.FaBacon = function FaBacon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"}}]})(props);
};
module.exports.FaBacteria = function FaBacteria (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"}}]})(props);
};
module.exports.FaBacterium = function FaBacterium (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"}}]})(props);
};
module.exports.FaBahai = function FaBahai (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"}}]})(props);
};
module.exports.FaBalanceScaleLeft = function FaBalanceScaleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"}}]})(props);
};
module.exports.FaBalanceScaleRight = function FaBalanceScaleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"}}]})(props);
};
module.exports.FaBalanceScale = function FaBalanceScale (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaBan = function FaBan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"}}]})(props);
};
module.exports.FaBandAid = function FaBandAid (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"}}]})(props);
};
module.exports.FaBarcode = function FaBarcode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"}}]})(props);
};
module.exports.FaBars = function FaBars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"}}]})(props);
};
module.exports.FaBaseballBall = function FaBaseballBall (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"}}]})(props);
};
module.exports.FaBasketballBall = function FaBasketballBall (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"}}]})(props);
};
module.exports.FaBath = function FaBath (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"}}]})(props);
};
module.exports.FaBatteryEmpty = function FaBatteryEmpty (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"}}]})(props);
};
module.exports.FaBatteryFull = function FaBatteryFull (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"}}]})(props);
};
module.exports.FaBatteryHalf = function FaBatteryHalf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"}}]})(props);
};
module.exports.FaBatteryQuarter = function FaBatteryQuarter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"}}]})(props);
};
module.exports.FaBatteryThreeQuarters = function FaBatteryThreeQuarters (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"}}]})(props);
};
module.exports.FaBed = function FaBed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"}}]})(props);
};
module.exports.FaBeer = function FaBeer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"}}]})(props);
};
module.exports.FaBellSlash = function FaBellSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"}}]})(props);
};
module.exports.FaBell = function FaBell (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"}}]})(props);
};
module.exports.FaBezierCurve = function FaBezierCurve (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaBible = function FaBible (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"}}]})(props);
};
module.exports.FaBicycle = function FaBicycle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"}}]})(props);
};
module.exports.FaBiking = function FaBiking (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"}}]})(props);
};
module.exports.FaBinoculars = function FaBinoculars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"}}]})(props);
};
module.exports.FaBiohazard = function FaBiohazard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
};
module.exports.FaBirthdayCake = function FaBirthdayCake (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"}}]})(props);
};
module.exports.FaBlenderPhone = function FaBlenderPhone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaBlender = function FaBlender (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"}}]})(props);
};
module.exports.FaBlind = function FaBlind (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"}}]})(props);
};
module.exports.FaBlog = function FaBlog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"}}]})(props);
};
module.exports.FaBold = function FaBold (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"}}]})(props);
};
module.exports.FaBolt = function FaBolt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"}}]})(props);
};
module.exports.FaBomb = function FaBomb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"}}]})(props);
};
module.exports.FaBone = function FaBone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"}}]})(props);
};
module.exports.FaBong = function FaBong (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"}}]})(props);
};
module.exports.FaBookDead = function FaBookDead (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"}}]})(props);
};
module.exports.FaBookMedical = function FaBookMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"}}]})(props);
};
module.exports.FaBookOpen = function FaBookOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"}}]})(props);
};
module.exports.FaBookReader = function FaBookReader (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"}}]})(props);
};
module.exports.FaBook = function FaBook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"}}]})(props);
};
module.exports.FaBookmark = function FaBookmark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"}}]})(props);
};
module.exports.FaBorderAll = function FaBorderAll (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"}}]})(props);
};
module.exports.FaBorderNone = function FaBorderNone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaBorderStyle = function FaBorderStyle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaBowlingBall = function FaBowlingBall (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaBoxOpen = function FaBoxOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"}}]})(props);
};
module.exports.FaBoxTissue = function FaBoxTissue (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"}}]})(props);
};
module.exports.FaBox = function FaBox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"}}]})(props);
};
module.exports.FaBoxes = function FaBoxes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaBraille = function FaBraille (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"}}]})(props);
};
module.exports.FaBrain = function FaBrain (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"}}]})(props);
};
module.exports.FaBreadSlice = function FaBreadSlice (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"}}]})(props);
};
module.exports.FaBriefcaseMedical = function FaBriefcaseMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"}}]})(props);
};
module.exports.FaBriefcase = function FaBriefcase (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"}}]})(props);
};
module.exports.FaBroadcastTower = function FaBroadcastTower (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"}}]})(props);
};
module.exports.FaBroom = function FaBroom (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"}}]})(props);
};
module.exports.FaBrush = function FaBrush (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"}}]})(props);
};
module.exports.FaBug = function FaBug (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"}}]})(props);
};
module.exports.FaBuilding = function FaBuilding (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"}}]})(props);
};
module.exports.FaBullhorn = function FaBullhorn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"}}]})(props);
};
module.exports.FaBullseye = function FaBullseye (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"}}]})(props);
};
module.exports.FaBurn = function FaBurn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"}}]})(props);
};
module.exports.FaBusAlt = function FaBusAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaBus = function FaBus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaBusinessTime = function FaBusinessTime (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"}}]})(props);
};
module.exports.FaCalculator = function FaCalculator (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"}}]})(props);
};
module.exports.FaCalendarAlt = function FaCalendarAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaCalendarCheck = function FaCalendarCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"}}]})(props);
};
module.exports.FaCalendarDay = function FaCalendarDay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaCalendarMinus = function FaCalendarMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"}}]})(props);
};
module.exports.FaCalendarPlus = function FaCalendarPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"}}]})(props);
};
module.exports.FaCalendarTimes = function FaCalendarTimes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"}}]})(props);
};
module.exports.FaCalendarWeek = function FaCalendarWeek (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaCalendar = function FaCalendar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"}}]})(props);
};
module.exports.FaCameraRetro = function FaCameraRetro (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"}}]})(props);
};
module.exports.FaCamera = function FaCamera (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"}}]})(props);
};
module.exports.FaCampground = function FaCampground (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"}}]})(props);
};
module.exports.FaCandyCane = function FaCandyCane (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"}}]})(props);
};
module.exports.FaCannabis = function FaCannabis (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"}}]})(props);
};
module.exports.FaCapsules = function FaCapsules (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"}}]})(props);
};
module.exports.FaCarAlt = function FaCarAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"}}]})(props);
};
module.exports.FaCarBattery = function FaCarBattery (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"}}]})(props);
};
module.exports.FaCarCrash = function FaCarCrash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"}}]})(props);
};
module.exports.FaCarSide = function FaCarSide (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"}}]})(props);
};
module.exports.FaCar = function FaCar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"}}]})(props);
};
module.exports.FaCaravan = function FaCaravan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"}}]})(props);
};
module.exports.FaCaretDown = function FaCaretDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"}}]})(props);
};
module.exports.FaCaretLeft = function FaCaretLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"}}]})(props);
};
module.exports.FaCaretRight = function FaCaretRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"}}]})(props);
};
module.exports.FaCaretSquareDown = function FaCaretSquareDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"}}]})(props);
};
module.exports.FaCaretSquareLeft = function FaCaretSquareLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"}}]})(props);
};
module.exports.FaCaretSquareRight = function FaCaretSquareRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"}}]})(props);
};
module.exports.FaCaretSquareUp = function FaCaretSquareUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"}}]})(props);
};
module.exports.FaCaretUp = function FaCaretUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"}}]})(props);
};
module.exports.FaCarrot = function FaCarrot (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"}}]})(props);
};
module.exports.FaCartArrowDown = function FaCartArrowDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"}}]})(props);
};
module.exports.FaCartPlus = function FaCartPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"}}]})(props);
};
module.exports.FaCashRegister = function FaCashRegister (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"}}]})(props);
};
module.exports.FaCat = function FaCat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"}}]})(props);
};
module.exports.FaCertificate = function FaCertificate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"}}]})(props);
};
module.exports.FaChair = function FaChair (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"}}]})(props);
};
module.exports.FaChalkboardTeacher = function FaChalkboardTeacher (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"}}]})(props);
};
module.exports.FaChalkboard = function FaChalkboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaChargingStation = function FaChargingStation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"}}]})(props);
};
module.exports.FaChartArea = function FaChartArea (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"}}]})(props);
};
module.exports.FaChartBar = function FaChartBar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaChartLine = function FaChartLine (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"}}]})(props);
};
module.exports.FaChartPie = function FaChartPie (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"}}]})(props);
};
module.exports.FaCheckCircle = function FaCheckCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"}}]})(props);
};
module.exports.FaCheckDouble = function FaCheckDouble (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"}}]})(props);
};
module.exports.FaCheckSquare = function FaCheckSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"}}]})(props);
};
module.exports.FaCheck = function FaCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}}]})(props);
};
module.exports.FaCheese = function FaCheese (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"}}]})(props);
};
module.exports.FaChessBishop = function FaChessBishop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaChessBoard = function FaChessBoard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"}}]})(props);
};
module.exports.FaChessKing = function FaChessKing (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"}}]})(props);
};
module.exports.FaChessKnight = function FaChessKnight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaChessPawn = function FaChessPawn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaChessQueen = function FaChessQueen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"}}]})(props);
};
module.exports.FaChessRook = function FaChessRook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaChess = function FaChess (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"}}]})(props);
};
module.exports.FaChevronCircleDown = function FaChevronCircleDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"}}]})(props);
};
module.exports.FaChevronCircleLeft = function FaChevronCircleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"}}]})(props);
};
module.exports.FaChevronCircleRight = function FaChevronCircleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"}}]})(props);
};
module.exports.FaChevronCircleUp = function FaChevronCircleUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"}}]})(props);
};
module.exports.FaChevronDown = function FaChevronDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"}}]})(props);
};
module.exports.FaChevronLeft = function FaChevronLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"}}]})(props);
};
module.exports.FaChevronRight = function FaChevronRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"}}]})(props);
};
module.exports.FaChevronUp = function FaChevronUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"}}]})(props);
};
module.exports.FaChild = function FaChild (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"}}]})(props);
};
module.exports.FaChurch = function FaChurch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"}}]})(props);
};
module.exports.FaCircleNotch = function FaCircleNotch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"}}]})(props);
};
module.exports.FaCircle = function FaCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"}}]})(props);
};
module.exports.FaCity = function FaCity (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"}}]})(props);
};
module.exports.FaClinicMedical = function FaClinicMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"}}]})(props);
};
module.exports.FaClipboardCheck = function FaClipboardCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"}}]})(props);
};
module.exports.FaClipboardList = function FaClipboardList (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"}}]})(props);
};
module.exports.FaClipboard = function FaClipboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"}}]})(props);
};
module.exports.FaClock = function FaClock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"}}]})(props);
};
module.exports.FaClone = function FaClone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"}}]})(props);
};
module.exports.FaClosedCaptioning = function FaClosedCaptioning (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"}}]})(props);
};
module.exports.FaCloudDownloadAlt = function FaCloudDownloadAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"}}]})(props);
};
module.exports.FaCloudMeatball = function FaCloudMeatball (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"}}]})(props);
};
module.exports.FaCloudMoonRain = function FaCloudMoonRain (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"}}]})(props);
};
module.exports.FaCloudMoon = function FaCloudMoon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"}}]})(props);
};
module.exports.FaCloudRain = function FaCloudRain (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"}}]})(props);
};
module.exports.FaCloudShowersHeavy = function FaCloudShowersHeavy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"}}]})(props);
};
module.exports.FaCloudSunRain = function FaCloudSunRain (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"}}]})(props);
};
module.exports.FaCloudSun = function FaCloudSun (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"}}]})(props);
};
module.exports.FaCloudUploadAlt = function FaCloudUploadAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"}}]})(props);
};
module.exports.FaCloud = function FaCloud (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"}}]})(props);
};
module.exports.FaCocktail = function FaCocktail (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"}}]})(props);
};
module.exports.FaCodeBranch = function FaCodeBranch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"}}]})(props);
};
module.exports.FaCode = function FaCode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"}}]})(props);
};
module.exports.FaCoffee = function FaCoffee (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"}}]})(props);
};
module.exports.FaCog = function FaCog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaCogs = function FaCogs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"}}]})(props);
};
module.exports.FaCoins = function FaCoins (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"}}]})(props);
};
module.exports.FaColumns = function FaColumns (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"}}]})(props);
};
module.exports.FaCommentAlt = function FaCommentAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"}}]})(props);
};
module.exports.FaCommentDollar = function FaCommentDollar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"}}]})(props);
};
module.exports.FaCommentDots = function FaCommentDots (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaCommentMedical = function FaCommentMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"}}]})(props);
};
module.exports.FaCommentSlash = function FaCommentSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"}}]})(props);
};
module.exports.FaComment = function FaComment (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"}}]})(props);
};
module.exports.FaCommentsDollar = function FaCommentsDollar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"}}]})(props);
};
module.exports.FaComments = function FaComments (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"}}]})(props);
};
module.exports.FaCompactDisc = function FaCompactDisc (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
};
module.exports.FaCompass = function FaCompass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"}}]})(props);
};
module.exports.FaCompressAlt = function FaCompressAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"}}]})(props);
};
module.exports.FaCompressArrowsAlt = function FaCompressArrowsAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"}}]})(props);
};
module.exports.FaCompress = function FaCompress (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"}}]})(props);
};
module.exports.FaConciergeBell = function FaConciergeBell (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaCookieBite = function FaCookieBite (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaCookie = function FaCookie (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaCopy = function FaCopy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"}}]})(props);
};
module.exports.FaCopyright = function FaCopyright (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"}}]})(props);
};
module.exports.FaCouch = function FaCouch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"}}]})(props);
};
module.exports.FaCreditCard = function FaCreditCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"}}]})(props);
};
module.exports.FaCropAlt = function FaCropAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"}}]})(props);
};
module.exports.FaCrop = function FaCrop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
};
module.exports.FaCross = function FaCross (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaCrosshairs = function FaCrosshairs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"}}]})(props);
};
module.exports.FaCrow = function FaCrow (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaCrown = function FaCrown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"}}]})(props);
};
module.exports.FaCrutch = function FaCrutch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"}}]})(props);
};
module.exports.FaCube = function FaCube (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"}}]})(props);
};
module.exports.FaCubes = function FaCubes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"}}]})(props);
};
module.exports.FaCut = function FaCut (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"}}]})(props);
};
module.exports.FaDatabase = function FaDatabase (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"}}]})(props);
};
module.exports.FaDeaf = function FaDeaf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"}}]})(props);
};
module.exports.FaDemocrat = function FaDemocrat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"}}]})(props);
};
module.exports.FaDesktop = function FaDesktop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"}}]})(props);
};
module.exports.FaDharmachakra = function FaDharmachakra (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"}}]})(props);
};
module.exports.FaDiagnoses = function FaDiagnoses (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaDiceD20 = function FaDiceD20 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"}}]})(props);
};
module.exports.FaDiceD6 = function FaDiceD6 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"}}]})(props);
};
module.exports.FaDiceFive = function FaDiceFive (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaDiceFour = function FaDiceFour (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaDiceOne = function FaDiceOne (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaDiceSix = function FaDiceSix (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaDiceThree = function FaDiceThree (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaDiceTwo = function FaDiceTwo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaDice = function FaDice (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaDigitalTachograph = function FaDigitalTachograph (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"}}]})(props);
};
module.exports.FaDirections = function FaDirections (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"}}]})(props);
};
module.exports.FaDisease = function FaDisease (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"}}]})(props);
};
module.exports.FaDivide = function FaDivide (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaDizzy = function FaDizzy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"}}]})(props);
};
module.exports.FaDna = function FaDna (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"}}]})(props);
};
module.exports.FaDog = function FaDog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"}}]})(props);
};
module.exports.FaDollarSign = function FaDollarSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"}}]})(props);
};
module.exports.FaDollyFlatbed = function FaDollyFlatbed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaDolly = function FaDolly (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
};
module.exports.FaDonate = function FaDonate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"}}]})(props);
};
module.exports.FaDoorClosed = function FaDoorClosed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"}}]})(props);
};
module.exports.FaDoorOpen = function FaDoorOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"}}]})(props);
};
module.exports.FaDotCircle = function FaDotCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"}}]})(props);
};
module.exports.FaDove = function FaDove (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
};
module.exports.FaDownload = function FaDownload (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"}}]})(props);
};
module.exports.FaDraftingCompass = function FaDraftingCompass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"}}]})(props);
};
module.exports.FaDragon = function FaDragon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"}}]})(props);
};
module.exports.FaDrawPolygon = function FaDrawPolygon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"}}]})(props);
};
module.exports.FaDrumSteelpan = function FaDrumSteelpan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"}}]})(props);
};
module.exports.FaDrum = function FaDrum (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"}}]})(props);
};
module.exports.FaDrumstickBite = function FaDrumstickBite (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"}}]})(props);
};
module.exports.FaDumbbell = function FaDumbbell (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"}}]})(props);
};
module.exports.FaDumpsterFire = function FaDumpsterFire (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"}}]})(props);
};
module.exports.FaDumpster = function FaDumpster (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaDungeon = function FaDungeon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"}}]})(props);
};
module.exports.FaEdit = function FaEdit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"}}]})(props);
};
module.exports.FaEgg = function FaEgg (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"}}]})(props);
};
module.exports.FaEject = function FaEject (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"}}]})(props);
};
module.exports.FaEllipsisH = function FaEllipsisH (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"}}]})(props);
};
module.exports.FaEllipsisV = function FaEllipsisV (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"}}]})(props);
};
module.exports.FaEnvelopeOpenText = function FaEnvelopeOpenText (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"}}]})(props);
};
module.exports.FaEnvelopeOpen = function FaEnvelopeOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"}}]})(props);
};
module.exports.FaEnvelopeSquare = function FaEnvelopeSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"}}]})(props);
};
module.exports.FaEnvelope = function FaEnvelope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"}}]})(props);
};
module.exports.FaEquals = function FaEquals (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaEraser = function FaEraser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"}}]})(props);
};
module.exports.FaEthernet = function FaEthernet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaEuroSign = function FaEuroSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"}}]})(props);
};
module.exports.FaExchangeAlt = function FaExchangeAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"}}]})(props);
};
module.exports.FaExclamationCircle = function FaExclamationCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"}}]})(props);
};
module.exports.FaExclamationTriangle = function FaExclamationTriangle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"}}]})(props);
};
module.exports.FaExclamation = function FaExclamation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"}}]})(props);
};
module.exports.FaExpandAlt = function FaExpandAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"}}]})(props);
};
module.exports.FaExpandArrowsAlt = function FaExpandArrowsAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"}}]})(props);
};
module.exports.FaExpand = function FaExpand (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"}}]})(props);
};
module.exports.FaExternalLinkAlt = function FaExternalLinkAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"}}]})(props);
};
module.exports.FaExternalLinkSquareAlt = function FaExternalLinkSquareAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"}}]})(props);
};
module.exports.FaEyeDropper = function FaEyeDropper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"}}]})(props);
};
module.exports.FaEyeSlash = function FaEyeSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"}}]})(props);
};
module.exports.FaEye = function FaEye (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"}}]})(props);
};
module.exports.FaFan = function FaFan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"}}]})(props);
};
module.exports.FaFastBackward = function FaFastBackward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"}}]})(props);
};
module.exports.FaFastForward = function FaFastForward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"}}]})(props);
};
module.exports.FaFaucet = function FaFaucet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"}}]})(props);
};
module.exports.FaFax = function FaFax (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"}}]})(props);
};
module.exports.FaFeatherAlt = function FaFeatherAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"}}]})(props);
};
module.exports.FaFeather = function FaFeather (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"}}]})(props);
};
module.exports.FaFemale = function FaFemale (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"}}]})(props);
};
module.exports.FaFighterJet = function FaFighterJet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"}}]})(props);
};
module.exports.FaFileAlt = function FaFileAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
};
module.exports.FaFileArchive = function FaFileArchive (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"}}]})(props);
};
module.exports.FaFileAudio = function FaFileAudio (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
};
module.exports.FaFileCode = function FaFileCode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"}}]})(props);
};
module.exports.FaFileContract = function FaFileContract (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
};
module.exports.FaFileCsv = function FaFileCsv (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
};
module.exports.FaFileDownload = function FaFileDownload (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
};
module.exports.FaFileExcel = function FaFileExcel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
};
module.exports.FaFileExport = function FaFileExport (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"}}]})(props);
};
module.exports.FaFileImage = function FaFileImage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"}}]})(props);
};
module.exports.FaFileImport = function FaFileImport (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"}}]})(props);
};
module.exports.FaFileInvoiceDollar = function FaFileInvoiceDollar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"}}]})(props);
};
module.exports.FaFileInvoice = function FaFileInvoice (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"}}]})(props);
};
module.exports.FaFileMedicalAlt = function FaFileMedicalAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
};
module.exports.FaFileMedical = function FaFileMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"}}]})(props);
};
module.exports.FaFilePdf = function FaFilePdf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"}}]})(props);
};
module.exports.FaFilePowerpoint = function FaFilePowerpoint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"}}]})(props);
};
module.exports.FaFilePrescription = function FaFilePrescription (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
};
module.exports.FaFileSignature = function FaFileSignature (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"}}]})(props);
};
module.exports.FaFileUpload = function FaFileUpload (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"}}]})(props);
};
module.exports.FaFileVideo = function FaFileVideo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"}}]})(props);
};
module.exports.FaFileWord = function FaFileWord (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
};
module.exports.FaFile = function FaFile (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"}}]})(props);
};
module.exports.FaFillDrip = function FaFillDrip (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"}}]})(props);
};
module.exports.FaFill = function FaFill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"}}]})(props);
};
module.exports.FaFilm = function FaFilm (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"}}]})(props);
};
module.exports.FaFilter = function FaFilter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"}}]})(props);
};
module.exports.FaFingerprint = function FaFingerprint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"}}]})(props);
};
module.exports.FaFireAlt = function FaFireAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"}}]})(props);
};
module.exports.FaFireExtinguisher = function FaFireExtinguisher (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"}}]})(props);
};
module.exports.FaFire = function FaFire (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"}}]})(props);
};
module.exports.FaFirstAid = function FaFirstAid (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaFish = function FaFish (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaFistRaised = function FaFistRaised (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"}}]})(props);
};
module.exports.FaFlagCheckered = function FaFlagCheckered (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"}}]})(props);
};
module.exports.FaFlagUsa = function FaFlagUsa (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"}}]})(props);
};
module.exports.FaFlag = function FaFlag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"}}]})(props);
};
module.exports.FaFlask = function FaFlask (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"}}]})(props);
};
module.exports.FaFlushed = function FaFlushed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"}}]})(props);
};
module.exports.FaFolderMinus = function FaFolderMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"}}]})(props);
};
module.exports.FaFolderOpen = function FaFolderOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"}}]})(props);
};
module.exports.FaFolderPlus = function FaFolderPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"}}]})(props);
};
module.exports.FaFolder = function FaFolder (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"}}]})(props);
};
module.exports.FaFont = function FaFont (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"}}]})(props);
};
module.exports.FaFootballBall = function FaFootballBall (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"}}]})(props);
};
module.exports.FaForward = function FaForward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"}}]})(props);
};
module.exports.FaFrog = function FaFrog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaFrownOpen = function FaFrownOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaFrown = function FaFrown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"}}]})(props);
};
module.exports.FaFunnelDollar = function FaFunnelDollar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"}}]})(props);
};
module.exports.FaFutbol = function FaFutbol (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"}}]})(props);
};
module.exports.FaGamepad = function FaGamepad (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"}}]})(props);
};
module.exports.FaGasPump = function FaGasPump (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"}}]})(props);
};
module.exports.FaGavel = function FaGavel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"}}]})(props);
};
module.exports.FaGem = function FaGem (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"}}]})(props);
};
module.exports.FaGenderless = function FaGenderless (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"}}]})(props);
};
module.exports.FaGhost = function FaGhost (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaGift = function FaGift (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"}}]})(props);
};
module.exports.FaGifts = function FaGifts (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"}}]})(props);
};
module.exports.FaGlassCheers = function FaGlassCheers (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"}}]})(props);
};
module.exports.FaGlassMartiniAlt = function FaGlassMartiniAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"}}]})(props);
};
module.exports.FaGlassMartini = function FaGlassMartini (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"}}]})(props);
};
module.exports.FaGlassWhiskey = function FaGlassWhiskey (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"}}]})(props);
};
module.exports.FaGlasses = function FaGlasses (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"}}]})(props);
};
module.exports.FaGlobeAfrica = function FaGlobeAfrica (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"}}]})(props);
};
module.exports.FaGlobeAmericas = function FaGlobeAmericas (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"}}]})(props);
};
module.exports.FaGlobeAsia = function FaGlobeAsia (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"}}]})(props);
};
module.exports.FaGlobeEurope = function FaGlobeEurope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"}}]})(props);
};
module.exports.FaGlobe = function FaGlobe (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"}}]})(props);
};
module.exports.FaGolfBall = function FaGolfBall (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"}}]})(props);
};
module.exports.FaGopuram = function FaGopuram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"}}]})(props);
};
module.exports.FaGraduationCap = function FaGraduationCap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"}}]})(props);
};
module.exports.FaGreaterThanEqual = function FaGreaterThanEqual (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
};
module.exports.FaGreaterThan = function FaGreaterThan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"}}]})(props);
};
module.exports.FaGrimace = function FaGrimace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"}}]})(props);
};
module.exports.FaGrinAlt = function FaGrinAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
};
module.exports.FaGrinBeamSweat = function FaGrinBeamSweat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 504 512"},"child":[{"tag":"path","attr":{"d":"M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
};
module.exports.FaGrinBeam = function FaGrinBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
};
module.exports.FaGrinHearts = function FaGrinHearts (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"}}]})(props);
};
module.exports.FaGrinSquintTears = function FaGrinSquintTears (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"}}]})(props);
};
module.exports.FaGrinSquint = function FaGrinSquint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
};
module.exports.FaGrinStars = function FaGrinStars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"}}]})(props);
};
module.exports.FaGrinTears = function FaGrinTears (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
};
module.exports.FaGrinTongueSquint = function FaGrinTongueSquint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"}}]})(props);
};
module.exports.FaGrinTongueWink = function FaGrinTongueWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"}}]})(props);
};
module.exports.FaGrinTongue = function FaGrinTongue (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"}}]})(props);
};
module.exports.FaGrinWink = function FaGrinWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"}}]})(props);
};
module.exports.FaGrin = function FaGrin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"}}]})(props);
};
module.exports.FaGripHorizontal = function FaGripHorizontal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaGripLinesVertical = function FaGripLinesVertical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"}}]})(props);
};
module.exports.FaGripLines = function FaGripLines (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaGripVertical = function FaGripVertical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaGuitar = function FaGuitar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"}}]})(props);
};
module.exports.FaHSquare = function FaHSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"}}]})(props);
};
module.exports.FaHamburger = function FaHamburger (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"}}]})(props);
};
module.exports.FaHammer = function FaHammer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"}}]})(props);
};
module.exports.FaHamsa = function FaHamsa (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"}}]})(props);
};
module.exports.FaHandHoldingHeart = function FaHandHoldingHeart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"}}]})(props);
};
module.exports.FaHandHoldingMedical = function FaHandHoldingMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"}}]})(props);
};
module.exports.FaHandHoldingUsd = function FaHandHoldingUsd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"}}]})(props);
};
module.exports.FaHandHoldingWater = function FaHandHoldingWater (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"}}]})(props);
};
module.exports.FaHandHolding = function FaHandHolding (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"}}]})(props);
};
module.exports.FaHandLizard = function FaHandLizard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"}}]})(props);
};
module.exports.FaHandMiddleFinger = function FaHandMiddleFinger (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"}}]})(props);
};
module.exports.FaHandPaper = function FaHandPaper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"}}]})(props);
};
module.exports.FaHandPeace = function FaHandPeace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"}}]})(props);
};
module.exports.FaHandPointDown = function FaHandPointDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"}}]})(props);
};
module.exports.FaHandPointLeft = function FaHandPointLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"}}]})(props);
};
module.exports.FaHandPointRight = function FaHandPointRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"}}]})(props);
};
module.exports.FaHandPointUp = function FaHandPointUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"}}]})(props);
};
module.exports.FaHandPointer = function FaHandPointer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"}}]})(props);
};
module.exports.FaHandRock = function FaHandRock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"}}]})(props);
};
module.exports.FaHandScissors = function FaHandScissors (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"}}]})(props);
};
module.exports.FaHandSparkles = function FaHandSparkles (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"}}]})(props);
};
module.exports.FaHandSpock = function FaHandSpock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"}}]})(props);
};
module.exports.FaHandsHelping = function FaHandsHelping (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"}}]})(props);
};
module.exports.FaHandsWash = function FaHandsWash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"}}]})(props);
};
module.exports.FaHands = function FaHands (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"}}]})(props);
};
module.exports.FaHandshakeAltSlash = function FaHandshakeAltSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"}}]})(props);
};
module.exports.FaHandshakeSlash = function FaHandshakeSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"}}]})(props);
};
module.exports.FaHandshake = function FaHandshake (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"}}]})(props);
};
module.exports.FaHanukiah = function FaHanukiah (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"}}]})(props);
};
module.exports.FaHardHat = function FaHardHat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaHashtag = function FaHashtag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"}}]})(props);
};
module.exports.FaHatCowboySide = function FaHatCowboySide (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"}}]})(props);
};
module.exports.FaHatCowboy = function FaHatCowboy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"}}]})(props);
};
module.exports.FaHatWizard = function FaHatWizard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"}}]})(props);
};
module.exports.FaHdd = function FaHdd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"}}]})(props);
};
module.exports.FaHeadSideCoughSlash = function FaHeadSideCoughSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"}}]})(props);
};
module.exports.FaHeadSideCough = function FaHeadSideCough (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"}}]})(props);
};
module.exports.FaHeadSideMask = function FaHeadSideMask (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"}}]})(props);
};
module.exports.FaHeadSideVirus = function FaHeadSideVirus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"}}]})(props);
};
module.exports.FaHeading = function FaHeading (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"}}]})(props);
};
module.exports.FaHeadphonesAlt = function FaHeadphonesAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"}}]})(props);
};
module.exports.FaHeadphones = function FaHeadphones (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"}}]})(props);
};
module.exports.FaHeadset = function FaHeadset (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"}}]})(props);
};
module.exports.FaHeartBroken = function FaHeartBroken (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"}}]})(props);
};
module.exports.FaHeart = function FaHeart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"}}]})(props);
};
module.exports.FaHeartbeat = function FaHeartbeat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"}}]})(props);
};
module.exports.FaHelicopter = function FaHelicopter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"}}]})(props);
};
module.exports.FaHighlighter = function FaHighlighter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 544 512"},"child":[{"tag":"path","attr":{"d":"M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"}}]})(props);
};
module.exports.FaHiking = function FaHiking (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"}}]})(props);
};
module.exports.FaHippo = function FaHippo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"}}]})(props);
};
module.exports.FaHistory = function FaHistory (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"}}]})(props);
};
module.exports.FaHockeyPuck = function FaHockeyPuck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"}}]})(props);
};
module.exports.FaHollyBerry = function FaHollyBerry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"}}]})(props);
};
module.exports.FaHome = function FaHome (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"}}]})(props);
};
module.exports.FaHorseHead = function FaHorseHead (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"}}]})(props);
};
module.exports.FaHorse = function FaHorse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"}}]})(props);
};
module.exports.FaHospitalAlt = function FaHospitalAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"}}]})(props);
};
module.exports.FaHospitalSymbol = function FaHospitalSymbol (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"}}]})(props);
};
module.exports.FaHospitalUser = function FaHospitalUser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"}}]})(props);
};
module.exports.FaHospital = function FaHospital (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"}}]})(props);
};
module.exports.FaHotTub = function FaHotTub (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"}}]})(props);
};
module.exports.FaHotdog = function FaHotdog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"}}]})(props);
};
module.exports.FaHotel = function FaHotel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"}}]})(props);
};
module.exports.FaHourglassEnd = function FaHourglassEnd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"}}]})(props);
};
module.exports.FaHourglassHalf = function FaHourglassHalf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"}}]})(props);
};
module.exports.FaHourglassStart = function FaHourglassStart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"}}]})(props);
};
module.exports.FaHourglass = function FaHourglass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"}}]})(props);
};
module.exports.FaHouseDamage = function FaHouseDamage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"}}]})(props);
};
module.exports.FaHouseUser = function FaHouseUser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"}}]})(props);
};
module.exports.FaHryvnia = function FaHryvnia (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"}}]})(props);
};
module.exports.FaICursor = function FaICursor (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"}}]})(props);
};
module.exports.FaIceCream = function FaIceCream (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"}}]})(props);
};
module.exports.FaIcicles = function FaIcicles (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"}}]})(props);
};
module.exports.FaIcons = function FaIcons (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"}}]})(props);
};
module.exports.FaIdBadge = function FaIdBadge (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"}}]})(props);
};
module.exports.FaIdCardAlt = function FaIdCardAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"}}]})(props);
};
module.exports.FaIdCard = function FaIdCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"}}]})(props);
};
module.exports.FaIgloo = function FaIgloo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"}}]})(props);
};
module.exports.FaImage = function FaImage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"}}]})(props);
};
module.exports.FaImages = function FaImages (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"}}]})(props);
};
module.exports.FaInbox = function FaInbox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"}}]})(props);
};
module.exports.FaIndent = function FaIndent (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaIndustry = function FaIndustry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"}}]})(props);
};
module.exports.FaInfinity = function FaInfinity (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"}}]})(props);
};
module.exports.FaInfoCircle = function FaInfoCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"}}]})(props);
};
module.exports.FaInfo = function FaInfo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"}}]})(props);
};
module.exports.FaItalic = function FaItalic (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"}}]})(props);
};
module.exports.FaJedi = function FaJedi (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"}}]})(props);
};
module.exports.FaJoint = function FaJoint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"}}]})(props);
};
module.exports.FaJournalWhills = function FaJournalWhills (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"}}]})(props);
};
module.exports.FaKaaba = function FaKaaba (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"}}]})(props);
};
module.exports.FaKey = function FaKey (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"}}]})(props);
};
module.exports.FaKeyboard = function FaKeyboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"}}]})(props);
};
module.exports.FaKhanda = function FaKhanda (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"}}]})(props);
};
module.exports.FaKissBeam = function FaKissBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"}}]})(props);
};
module.exports.FaKissWinkHeart = function FaKissWinkHeart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 504 512"},"child":[{"tag":"path","attr":{"d":"M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"}}]})(props);
};
module.exports.FaKiss = function FaKiss (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaKiwiBird = function FaKiwiBird (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"}}]})(props);
};
module.exports.FaLandmark = function FaLandmark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaLanguage = function FaLanguage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"}}]})(props);
};
module.exports.FaLaptopCode = function FaLaptopCode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"}}]})(props);
};
module.exports.FaLaptopHouse = function FaLaptopHouse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"}}]})(props);
};
module.exports.FaLaptopMedical = function FaLaptopMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaLaptop = function FaLaptop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"}}]})(props);
};
module.exports.FaLaughBeam = function FaLaughBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"}}]})(props);
};
module.exports.FaLaughSquint = function FaLaughSquint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"}}]})(props);
};
module.exports.FaLaughWink = function FaLaughWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"}}]})(props);
};
module.exports.FaLaugh = function FaLaugh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"}}]})(props);
};
module.exports.FaLayerGroup = function FaLayerGroup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"}}]})(props);
};
module.exports.FaLeaf = function FaLeaf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"}}]})(props);
};
module.exports.FaLemon = function FaLemon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"}}]})(props);
};
module.exports.FaLessThanEqual = function FaLessThanEqual (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
};
module.exports.FaLessThan = function FaLessThan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"}}]})(props);
};
module.exports.FaLevelDownAlt = function FaLevelDownAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"}}]})(props);
};
module.exports.FaLevelUpAlt = function FaLevelUpAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"}}]})(props);
};
module.exports.FaLifeRing = function FaLifeRing (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"}}]})(props);
};
module.exports.FaLightbulb = function FaLightbulb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"}}]})(props);
};
module.exports.FaLink = function FaLink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"}}]})(props);
};
module.exports.FaLiraSign = function FaLiraSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"}}]})(props);
};
module.exports.FaListAlt = function FaListAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"}}]})(props);
};
module.exports.FaListOl = function FaListOl (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"}}]})(props);
};
module.exports.FaListUl = function FaListUl (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaList = function FaList (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaLocationArrow = function FaLocationArrow (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"}}]})(props);
};
module.exports.FaLockOpen = function FaLockOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"}}]})(props);
};
module.exports.FaLock = function FaLock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"}}]})(props);
};
module.exports.FaLongArrowAltDown = function FaLongArrowAltDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"}}]})(props);
};
module.exports.FaLongArrowAltLeft = function FaLongArrowAltLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"}}]})(props);
};
module.exports.FaLongArrowAltRight = function FaLongArrowAltRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"}}]})(props);
};
module.exports.FaLongArrowAltUp = function FaLongArrowAltUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"}}]})(props);
};
module.exports.FaLowVision = function FaLowVision (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"}}]})(props);
};
module.exports.FaLuggageCart = function FaLuggageCart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"}}]})(props);
};
module.exports.FaLungsVirus = function FaLungsVirus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"}}]})(props);
};
module.exports.FaLungs = function FaLungs (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"}}]})(props);
};
module.exports.FaMagic = function FaMagic (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"}}]})(props);
};
module.exports.FaMagnet = function FaMagnet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"}}]})(props);
};
module.exports.FaMailBulk = function FaMailBulk (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"}}]})(props);
};
module.exports.FaMale = function FaMale (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 192 512"},"child":[{"tag":"path","attr":{"d":"M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"}}]})(props);
};
module.exports.FaMapMarkedAlt = function FaMapMarkedAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"}}]})(props);
};
module.exports.FaMapMarked = function FaMapMarked (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"}}]})(props);
};
module.exports.FaMapMarkerAlt = function FaMapMarkerAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"}}]})(props);
};
module.exports.FaMapMarker = function FaMapMarker (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"}}]})(props);
};
module.exports.FaMapPin = function FaMapPin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"}}]})(props);
};
module.exports.FaMapSigns = function FaMapSigns (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"}}]})(props);
};
module.exports.FaMap = function FaMap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"}}]})(props);
};
module.exports.FaMarker = function FaMarker (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"}}]})(props);
};
module.exports.FaMarsDouble = function FaMarsDouble (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"}}]})(props);
};
module.exports.FaMarsStrokeH = function FaMarsStrokeH (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"}}]})(props);
};
module.exports.FaMarsStrokeV = function FaMarsStrokeV (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"}}]})(props);
};
module.exports.FaMarsStroke = function FaMarsStroke (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaMars = function FaMars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaMask = function FaMask (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"}}]})(props);
};
module.exports.FaMedal = function FaMedal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"}}]})(props);
};
module.exports.FaMedkit = function FaMedkit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"}}]})(props);
};
module.exports.FaMehBlank = function FaMehBlank (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaMehRollingEyes = function FaMehRollingEyes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"}}]})(props);
};
module.exports.FaMeh = function FaMeh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaMemory = function FaMemory (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"}}]})(props);
};
module.exports.FaMenorah = function FaMenorah (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"}}]})(props);
};
module.exports.FaMercury = function FaMercury (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"}}]})(props);
};
module.exports.FaMeteor = function FaMeteor (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"}}]})(props);
};
module.exports.FaMicrochip = function FaMicrochip (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"}}]})(props);
};
module.exports.FaMicrophoneAltSlash = function FaMicrophoneAltSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaMicrophoneAlt = function FaMicrophoneAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"}}]})(props);
};
module.exports.FaMicrophoneSlash = function FaMicrophoneSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaMicrophone = function FaMicrophone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaMicroscope = function FaMicroscope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"}}]})(props);
};
module.exports.FaMinusCircle = function FaMinusCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"}}]})(props);
};
module.exports.FaMinusSquare = function FaMinusSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"}}]})(props);
};
module.exports.FaMinus = function FaMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaMitten = function FaMitten (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"}}]})(props);
};
module.exports.FaMobileAlt = function FaMobileAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"}}]})(props);
};
module.exports.FaMobile = function FaMobile (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaMoneyBillAlt = function FaMoneyBillAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"}}]})(props);
};
module.exports.FaMoneyBillWaveAlt = function FaMoneyBillWaveAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"}}]})(props);
};
module.exports.FaMoneyBillWave = function FaMoneyBillWave (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"}}]})(props);
};
module.exports.FaMoneyBill = function FaMoneyBill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"}}]})(props);
};
module.exports.FaMoneyCheckAlt = function FaMoneyCheckAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"}}]})(props);
};
module.exports.FaMoneyCheck = function FaMoneyCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaMonument = function FaMonument (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"}}]})(props);
};
module.exports.FaMoon = function FaMoon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"}}]})(props);
};
module.exports.FaMortarPestle = function FaMortarPestle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaMosque = function FaMosque (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"}}]})(props);
};
module.exports.FaMotorcycle = function FaMotorcycle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"}}]})(props);
};
module.exports.FaMountain = function FaMountain (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"}}]})(props);
};
module.exports.FaMousePointer = function FaMousePointer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"}}]})(props);
};
module.exports.FaMouse = function FaMouse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"}}]})(props);
};
module.exports.FaMugHot = function FaMugHot (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"}}]})(props);
};
module.exports.FaMusic = function FaMusic (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"}}]})(props);
};
module.exports.FaNetworkWired = function FaNetworkWired (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"}}]})(props);
};
module.exports.FaNeuter = function FaNeuter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaNewspaper = function FaNewspaper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"}}]})(props);
};
module.exports.FaNotEqual = function FaNotEqual (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"}}]})(props);
};
module.exports.FaNotesMedical = function FaNotesMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"}}]})(props);
};
module.exports.FaObjectGroup = function FaObjectGroup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"}}]})(props);
};
module.exports.FaObjectUngroup = function FaObjectUngroup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"}}]})(props);
};
module.exports.FaOilCan = function FaOilCan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"}}]})(props);
};
module.exports.FaOm = function FaOm (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"}}]})(props);
};
module.exports.FaOtter = function FaOtter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"}}]})(props);
};
module.exports.FaOutdent = function FaOutdent (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaPager = function FaPager (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"}}]})(props);
};
module.exports.FaPaintBrush = function FaPaintBrush (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"}}]})(props);
};
module.exports.FaPaintRoller = function FaPaintRoller (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"}}]})(props);
};
module.exports.FaPalette = function FaPalette (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaPallet = function FaPallet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"}}]})(props);
};
module.exports.FaPaperPlane = function FaPaperPlane (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"}}]})(props);
};
module.exports.FaPaperclip = function FaPaperclip (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"}}]})(props);
};
module.exports.FaParachuteBox = function FaParachuteBox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"}}]})(props);
};
module.exports.FaParagraph = function FaParagraph (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"}}]})(props);
};
module.exports.FaParking = function FaParking (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"}}]})(props);
};
module.exports.FaPassport = function FaPassport (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"}}]})(props);
};
module.exports.FaPastafarianism = function FaPastafarianism (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"}}]})(props);
};
module.exports.FaPaste = function FaPaste (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"}}]})(props);
};
module.exports.FaPauseCircle = function FaPauseCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"}}]})(props);
};
module.exports.FaPause = function FaPause (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"}}]})(props);
};
module.exports.FaPaw = function FaPaw (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"}}]})(props);
};
module.exports.FaPeace = function FaPeace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"}}]})(props);
};
module.exports.FaPenAlt = function FaPenAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"}}]})(props);
};
module.exports.FaPenFancy = function FaPenFancy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"}}]})(props);
};
module.exports.FaPenNib = function FaPenNib (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"}}]})(props);
};
module.exports.FaPenSquare = function FaPenSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"}}]})(props);
};
module.exports.FaPen = function FaPen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"}}]})(props);
};
module.exports.FaPencilAlt = function FaPencilAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"}}]})(props);
};
module.exports.FaPencilRuler = function FaPencilRuler (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"}}]})(props);
};
module.exports.FaPeopleArrows = function FaPeopleArrows (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"}}]})(props);
};
module.exports.FaPeopleCarry = function FaPeopleCarry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"}}]})(props);
};
module.exports.FaPepperHot = function FaPepperHot (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"}}]})(props);
};
module.exports.FaPercent = function FaPercent (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"}}]})(props);
};
module.exports.FaPercentage = function FaPercentage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"}}]})(props);
};
module.exports.FaPersonBooth = function FaPersonBooth (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"}}]})(props);
};
module.exports.FaPhoneAlt = function FaPhoneAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"}}]})(props);
};
module.exports.FaPhoneSlash = function FaPhoneSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"}}]})(props);
};
module.exports.FaPhoneSquareAlt = function FaPhoneSquareAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"}}]})(props);
};
module.exports.FaPhoneSquare = function FaPhoneSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"}}]})(props);
};
module.exports.FaPhoneVolume = function FaPhoneVolume (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"}}]})(props);
};
module.exports.FaPhone = function FaPhone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"}}]})(props);
};
module.exports.FaPhotoVideo = function FaPhotoVideo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"}}]})(props);
};
module.exports.FaPiggyBank = function FaPiggyBank (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"}}]})(props);
};
module.exports.FaPills = function FaPills (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"}}]})(props);
};
module.exports.FaPizzaSlice = function FaPizzaSlice (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"}}]})(props);
};
module.exports.FaPlaceOfWorship = function FaPlaceOfWorship (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"}}]})(props);
};
module.exports.FaPlaneArrival = function FaPlaneArrival (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"}}]})(props);
};
module.exports.FaPlaneDeparture = function FaPlaneDeparture (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"}}]})(props);
};
module.exports.FaPlaneSlash = function FaPlaneSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"}}]})(props);
};
module.exports.FaPlane = function FaPlane (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"}}]})(props);
};
module.exports.FaPlayCircle = function FaPlayCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"}}]})(props);
};
module.exports.FaPlay = function FaPlay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"}}]})(props);
};
module.exports.FaPlug = function FaPlug (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"}}]})(props);
};
module.exports.FaPlusCircle = function FaPlusCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"}}]})(props);
};
module.exports.FaPlusSquare = function FaPlusSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"}}]})(props);
};
module.exports.FaPlus = function FaPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaPodcast = function FaPodcast (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"}}]})(props);
};
module.exports.FaPollH = function FaPollH (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"}}]})(props);
};
module.exports.FaPoll = function FaPoll (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"}}]})(props);
};
module.exports.FaPooStorm = function FaPooStorm (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"}}]})(props);
};
module.exports.FaPoo = function FaPoo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaPoop = function FaPoop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"}}]})(props);
};
module.exports.FaPortrait = function FaPortrait (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"}}]})(props);
};
module.exports.FaPoundSign = function FaPoundSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"}}]})(props);
};
module.exports.FaPowerOff = function FaPowerOff (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"}}]})(props);
};
module.exports.FaPray = function FaPray (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"}}]})(props);
};
module.exports.FaPrayingHands = function FaPrayingHands (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"}}]})(props);
};
module.exports.FaPrescriptionBottleAlt = function FaPrescriptionBottleAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"}}]})(props);
};
module.exports.FaPrescriptionBottle = function FaPrescriptionBottle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"}}]})(props);
};
module.exports.FaPrescription = function FaPrescription (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"}}]})(props);
};
module.exports.FaPrint = function FaPrint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaProcedures = function FaProcedures (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"}}]})(props);
};
module.exports.FaProjectDiagram = function FaProjectDiagram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaPumpMedical = function FaPumpMedical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"}}]})(props);
};
module.exports.FaPumpSoap = function FaPumpSoap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"}}]})(props);
};
module.exports.FaPuzzlePiece = function FaPuzzlePiece (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"}}]})(props);
};
module.exports.FaQrcode = function FaQrcode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"}}]})(props);
};
module.exports.FaQuestionCircle = function FaQuestionCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"}}]})(props);
};
module.exports.FaQuestion = function FaQuestion (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"}}]})(props);
};
module.exports.FaQuidditch = function FaQuidditch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"}}]})(props);
};
module.exports.FaQuoteLeft = function FaQuoteLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaQuoteRight = function FaQuoteRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaQuran = function FaQuran (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"}}]})(props);
};
module.exports.FaRadiationAlt = function FaRadiationAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}}]})(props);
};
module.exports.FaRadiation = function FaRadiation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"}}]})(props);
};
module.exports.FaRainbow = function FaRainbow (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"}}]})(props);
};
module.exports.FaRandom = function FaRandom (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"}}]})(props);
};
module.exports.FaReceipt = function FaReceipt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"}}]})(props);
};
module.exports.FaRecordVinyl = function FaRecordVinyl (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"}}]})(props);
};
module.exports.FaRecycle = function FaRecycle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"}}]})(props);
};
module.exports.FaRedoAlt = function FaRedoAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"}}]})(props);
};
module.exports.FaRedo = function FaRedo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"}}]})(props);
};
module.exports.FaRegistered = function FaRegistered (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"}}]})(props);
};
module.exports.FaRemoveFormat = function FaRemoveFormat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"}}]})(props);
};
module.exports.FaReplyAll = function FaReplyAll (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"}}]})(props);
};
module.exports.FaReply = function FaReply (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"}}]})(props);
};
module.exports.FaRepublican = function FaRepublican (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaRestroom = function FaRestroom (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"}}]})(props);
};
module.exports.FaRetweet = function FaRetweet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"}}]})(props);
};
module.exports.FaRibbon = function FaRibbon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"}}]})(props);
};
module.exports.FaRing = function FaRing (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"}}]})(props);
};
module.exports.FaRoad = function FaRoad (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"}}]})(props);
};
module.exports.FaRobot = function FaRobot (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"}}]})(props);
};
module.exports.FaRocket = function FaRocket (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"}}]})(props);
};
module.exports.FaRoute = function FaRoute (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaRssSquare = function FaRssSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"}}]})(props);
};
module.exports.FaRss = function FaRss (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"}}]})(props);
};
module.exports.FaRubleSign = function FaRubleSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"}}]})(props);
};
module.exports.FaRulerCombined = function FaRulerCombined (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaRulerHorizontal = function FaRulerHorizontal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaRulerVertical = function FaRulerVertical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"}}]})(props);
};
module.exports.FaRuler = function FaRuler (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"}}]})(props);
};
module.exports.FaRunning = function FaRunning (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"}}]})(props);
};
module.exports.FaRupeeSign = function FaRupeeSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"}}]})(props);
};
module.exports.FaSadCry = function FaSadCry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"}}]})(props);
};
module.exports.FaSadTear = function FaSadTear (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"}}]})(props);
};
module.exports.FaSatelliteDish = function FaSatelliteDish (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"}}]})(props);
};
module.exports.FaSatellite = function FaSatellite (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"}}]})(props);
};
module.exports.FaSave = function FaSave (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"}}]})(props);
};
module.exports.FaSchool = function FaSchool (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaScrewdriver = function FaScrewdriver (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"}}]})(props);
};
module.exports.FaScroll = function FaScroll (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"}}]})(props);
};
module.exports.FaSdCard = function FaSdCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"}}]})(props);
};
module.exports.FaSearchDollar = function FaSearchDollar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"}}]})(props);
};
module.exports.FaSearchLocation = function FaSearchLocation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaSearchMinus = function FaSearchMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"}}]})(props);
};
module.exports.FaSearchPlus = function FaSearchPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"}}]})(props);
};
module.exports.FaSearch = function FaSearch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"}}]})(props);
};
module.exports.FaSeedling = function FaSeedling (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"}}]})(props);
};
module.exports.FaServer = function FaServer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"}}]})(props);
};
module.exports.FaShapes = function FaShapes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"}}]})(props);
};
module.exports.FaShareAltSquare = function FaShareAltSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"}}]})(props);
};
module.exports.FaShareAlt = function FaShareAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"}}]})(props);
};
module.exports.FaShareSquare = function FaShareSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"}}]})(props);
};
module.exports.FaShare = function FaShare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"}}]})(props);
};
module.exports.FaShekelSign = function FaShekelSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaShieldAlt = function FaShieldAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"}}]})(props);
};
module.exports.FaShieldVirus = function FaShieldVirus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"}}]})(props);
};
module.exports.FaShip = function FaShip (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"}}]})(props);
};
module.exports.FaShippingFast = function FaShippingFast (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"}}]})(props);
};
module.exports.FaShoePrints = function FaShoePrints (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"}}]})(props);
};
module.exports.FaShoppingBag = function FaShoppingBag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"}}]})(props);
};
module.exports.FaShoppingBasket = function FaShoppingBasket (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"}}]})(props);
};
module.exports.FaShoppingCart = function FaShoppingCart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"}}]})(props);
};
module.exports.FaShower = function FaShower (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"}}]})(props);
};
module.exports.FaShuttleVan = function FaShuttleVan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"}}]})(props);
};
module.exports.FaSignInAlt = function FaSignInAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"}}]})(props);
};
module.exports.FaSignLanguage = function FaSignLanguage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"}}]})(props);
};
module.exports.FaSignOutAlt = function FaSignOutAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"}}]})(props);
};
module.exports.FaSign = function FaSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"}}]})(props);
};
module.exports.FaSignal = function FaSignal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaSignature = function FaSignature (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"}}]})(props);
};
module.exports.FaSimCard = function FaSimCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"}}]})(props);
};
module.exports.FaSink = function FaSink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"}}]})(props);
};
module.exports.FaSitemap = function FaSitemap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"}}]})(props);
};
module.exports.FaSkating = function FaSkating (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"}}]})(props);
};
module.exports.FaSkiingNordic = function FaSkiingNordic (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"}}]})(props);
};
module.exports.FaSkiing = function FaSkiing (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"}}]})(props);
};
module.exports.FaSkullCrossbones = function FaSkullCrossbones (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"}}]})(props);
};
module.exports.FaSkull = function FaSkull (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}}]})(props);
};
module.exports.FaSlash = function FaSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"}}]})(props);
};
module.exports.FaSleigh = function FaSleigh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"}}]})(props);
};
module.exports.FaSlidersH = function FaSlidersH (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaSmileBeam = function FaSmileBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"}}]})(props);
};
module.exports.FaSmileWink = function FaSmileWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"}}]})(props);
};
module.exports.FaSmile = function FaSmile (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"}}]})(props);
};
module.exports.FaSmog = function FaSmog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"}}]})(props);
};
module.exports.FaSmokingBan = function FaSmokingBan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"}}]})(props);
};
module.exports.FaSmoking = function FaSmoking (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"}}]})(props);
};
module.exports.FaSms = function FaSms (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"}}]})(props);
};
module.exports.FaSnowboarding = function FaSnowboarding (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"}}]})(props);
};
module.exports.FaSnowflake = function FaSnowflake (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"}}]})(props);
};
module.exports.FaSnowman = function FaSnowman (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
};
module.exports.FaSnowplow = function FaSnowplow (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"}}]})(props);
};
module.exports.FaSoap = function FaSoap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"}}]})(props);
};
module.exports.FaSocks = function FaSocks (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"}}]})(props);
};
module.exports.FaSolarPanel = function FaSolarPanel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"}}]})(props);
};
module.exports.FaSortAlphaDownAlt = function FaSortAlphaDownAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"}}]})(props);
};
module.exports.FaSortAlphaDown = function FaSortAlphaDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"}}]})(props);
};
module.exports.FaSortAlphaUpAlt = function FaSortAlphaUpAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"}}]})(props);
};
module.exports.FaSortAlphaUp = function FaSortAlphaUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"}}]})(props);
};
module.exports.FaSortAmountDownAlt = function FaSortAmountDownAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"}}]})(props);
};
module.exports.FaSortAmountDown = function FaSortAmountDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaSortAmountUpAlt = function FaSortAmountUpAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"}}]})(props);
};
module.exports.FaSortAmountUp = function FaSortAmountUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaSortDown = function FaSortDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"}}]})(props);
};
module.exports.FaSortNumericDownAlt = function FaSortNumericDownAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"}}]})(props);
};
module.exports.FaSortNumericDown = function FaSortNumericDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"}}]})(props);
};
module.exports.FaSortNumericUpAlt = function FaSortNumericUpAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"}}]})(props);
};
module.exports.FaSortNumericUp = function FaSortNumericUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"}}]})(props);
};
module.exports.FaSortUp = function FaSortUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"}}]})(props);
};
module.exports.FaSort = function FaSort (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"}}]})(props);
};
module.exports.FaSpa = function FaSpa (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"}}]})(props);
};
module.exports.FaSpaceShuttle = function FaSpaceShuttle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"}}]})(props);
};
module.exports.FaSpellCheck = function FaSpellCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"}}]})(props);
};
module.exports.FaSpider = function FaSpider (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"}}]})(props);
};
module.exports.FaSpinner = function FaSpinner (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"}}]})(props);
};
module.exports.FaSplotch = function FaSplotch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"}}]})(props);
};
module.exports.FaSprayCan = function FaSprayCan (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"}}]})(props);
};
module.exports.FaSquareFull = function FaSquareFull (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 512H0V0h512v512z"}}]})(props);
};
module.exports.FaSquareRootAlt = function FaSquareRootAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"}}]})(props);
};
module.exports.FaSquare = function FaSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaStamp = function FaStamp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"}}]})(props);
};
module.exports.FaStarAndCrescent = function FaStarAndCrescent (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"}}]})(props);
};
module.exports.FaStarHalfAlt = function FaStarHalfAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 536 512"},"child":[{"tag":"path","attr":{"d":"M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"}}]})(props);
};
module.exports.FaStarHalf = function FaStarHalf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"}}]})(props);
};
module.exports.FaStarOfDavid = function FaStarOfDavid (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 464 512"},"child":[{"tag":"path","attr":{"d":"M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"}}]})(props);
};
module.exports.FaStarOfLife = function FaStarOfLife (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"}}]})(props);
};
module.exports.FaStar = function FaStar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"}}]})(props);
};
module.exports.FaStepBackward = function FaStepBackward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"}}]})(props);
};
module.exports.FaStepForward = function FaStepForward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"}}]})(props);
};
module.exports.FaStethoscope = function FaStethoscope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"}}]})(props);
};
module.exports.FaStickyNote = function FaStickyNote (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"}}]})(props);
};
module.exports.FaStopCircle = function FaStopCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"}}]})(props);
};
module.exports.FaStop = function FaStop (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaStopwatch20 = function FaStopwatch20 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"}}]})(props);
};
module.exports.FaStopwatch = function FaStopwatch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"}}]})(props);
};
module.exports.FaStoreAltSlash = function FaStoreAltSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"}}]})(props);
};
module.exports.FaStoreAlt = function FaStoreAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"}}]})(props);
};
module.exports.FaStoreSlash = function FaStoreSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"}}]})(props);
};
module.exports.FaStore = function FaStore (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 616 512"},"child":[{"tag":"path","attr":{"d":"M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"}}]})(props);
};
module.exports.FaStream = function FaStream (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaStreetView = function FaStreetView (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"}}]})(props);
};
module.exports.FaStrikethrough = function FaStrikethrough (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"}}]})(props);
};
module.exports.FaStroopwafel = function FaStroopwafel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"}}]})(props);
};
module.exports.FaSubscript = function FaSubscript (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaSubway = function FaSubway (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"}}]})(props);
};
module.exports.FaSuitcaseRolling = function FaSuitcaseRolling (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"}}]})(props);
};
module.exports.FaSuitcase = function FaSuitcase (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"}}]})(props);
};
module.exports.FaSun = function FaSun (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"}}]})(props);
};
module.exports.FaSuperscript = function FaSuperscript (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaSurprise = function FaSurprise (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaSwatchbook = function FaSwatchbook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"}}]})(props);
};
module.exports.FaSwimmer = function FaSwimmer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"}}]})(props);
};
module.exports.FaSwimmingPool = function FaSwimmingPool (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"}}]})(props);
};
module.exports.FaSynagogue = function FaSynagogue (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"}}]})(props);
};
module.exports.FaSyncAlt = function FaSyncAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"}}]})(props);
};
module.exports.FaSync = function FaSync (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"}}]})(props);
};
module.exports.FaSyringe = function FaSyringe (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"}}]})(props);
};
module.exports.FaTableTennis = function FaTableTennis (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"}}]})(props);
};
module.exports.FaTable = function FaTable (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"}}]})(props);
};
module.exports.FaTabletAlt = function FaTabletAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"}}]})(props);
};
module.exports.FaTablet = function FaTablet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"}}]})(props);
};
module.exports.FaTablets = function FaTablets (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"}}]})(props);
};
module.exports.FaTachometerAlt = function FaTachometerAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaTag = function FaTag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"}}]})(props);
};
module.exports.FaTags = function FaTags (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"}}]})(props);
};
module.exports.FaTape = function FaTape (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"}}]})(props);
};
module.exports.FaTasks = function FaTasks (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaTaxi = function FaTaxi (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaTeethOpen = function FaTeethOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"}}]})(props);
};
module.exports.FaTeeth = function FaTeeth (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"}}]})(props);
};
module.exports.FaTemperatureHigh = function FaTemperatureHigh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"}}]})(props);
};
module.exports.FaTemperatureLow = function FaTemperatureLow (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"}}]})(props);
};
module.exports.FaTenge = function FaTenge (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"}}]})(props);
};
module.exports.FaTerminal = function FaTerminal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"}}]})(props);
};
module.exports.FaTextHeight = function FaTextHeight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"}}]})(props);
};
module.exports.FaTextWidth = function FaTextWidth (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"}}]})(props);
};
module.exports.FaThLarge = function FaThLarge (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"}}]})(props);
};
module.exports.FaThList = function FaThList (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"}}]})(props);
};
module.exports.FaTh = function FaTh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"}}]})(props);
};
module.exports.FaTheaterMasks = function FaTheaterMasks (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"}}]})(props);
};
module.exports.FaThermometerEmpty = function FaThermometerEmpty (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
};
module.exports.FaThermometerFull = function FaThermometerFull (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"}}]})(props);
};
module.exports.FaThermometerHalf = function FaThermometerHalf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
};
module.exports.FaThermometerQuarter = function FaThermometerQuarter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
};
module.exports.FaThermometerThreeQuarters = function FaThermometerThreeQuarters (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"}}]})(props);
};
module.exports.FaThermometer = function FaThermometer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"}}]})(props);
};
module.exports.FaThumbsDown = function FaThumbsDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"}}]})(props);
};
module.exports.FaThumbsUp = function FaThumbsUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"}}]})(props);
};
module.exports.FaThumbtack = function FaThumbtack (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"}}]})(props);
};
module.exports.FaTicketAlt = function FaTicketAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"}}]})(props);
};
module.exports.FaTimesCircle = function FaTimesCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"}}]})(props);
};
module.exports.FaTimes = function FaTimes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"}}]})(props);
};
module.exports.FaTintSlash = function FaTintSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"}}]})(props);
};
module.exports.FaTint = function FaTint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"}}]})(props);
};
module.exports.FaTired = function FaTired (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"}}]})(props);
};
module.exports.FaToggleOff = function FaToggleOff (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"}}]})(props);
};
module.exports.FaToggleOn = function FaToggleOn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"}}]})(props);
};
module.exports.FaToiletPaperSlash = function FaToiletPaperSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"}}]})(props);
};
module.exports.FaToiletPaper = function FaToiletPaper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"}}]})(props);
};
module.exports.FaToilet = function FaToilet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"}}]})(props);
};
module.exports.FaToolbox = function FaToolbox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"}}]})(props);
};
module.exports.FaTools = function FaTools (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"}}]})(props);
};
module.exports.FaTooth = function FaTooth (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"}}]})(props);
};
module.exports.FaTorah = function FaTorah (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"}}]})(props);
};
module.exports.FaToriiGate = function FaToriiGate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"}}]})(props);
};
module.exports.FaTractor = function FaTractor (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"}}]})(props);
};
module.exports.FaTrademark = function FaTrademark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"}}]})(props);
};
module.exports.FaTrafficLight = function FaTrafficLight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"}}]})(props);
};
module.exports.FaTrailer = function FaTrailer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"}}]})(props);
};
module.exports.FaTrain = function FaTrain (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"}}]})(props);
};
module.exports.FaTram = function FaTram (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}}]})(props);
};
module.exports.FaTransgenderAlt = function FaTransgenderAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaTransgender = function FaTransgender (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaTrashAlt = function FaTrashAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaTrashRestoreAlt = function FaTrashRestoreAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaTrashRestore = function FaTrashRestore (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaTrash = function FaTrash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"}}]})(props);
};
module.exports.FaTree = function FaTree (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"}}]})(props);
};
module.exports.FaTrophy = function FaTrophy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"}}]})(props);
};
module.exports.FaTruckLoading = function FaTruckLoading (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}}]})(props);
};
module.exports.FaTruckMonster = function FaTruckMonster (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"}}]})(props);
};
module.exports.FaTruckMoving = function FaTruckMoving (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"}}]})(props);
};
module.exports.FaTruckPickup = function FaTruckPickup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"}}]})(props);
};
module.exports.FaTruck = function FaTruck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"}}]})(props);
};
module.exports.FaTshirt = function FaTshirt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"}}]})(props);
};
module.exports.FaTty = function FaTty (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"}}]})(props);
};
module.exports.FaTv = function FaTv (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"}}]})(props);
};
module.exports.FaUmbrellaBeach = function FaUmbrellaBeach (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"}}]})(props);
};
module.exports.FaUmbrella = function FaUmbrella (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"}}]})(props);
};
module.exports.FaUnderline = function FaUnderline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"}}]})(props);
};
module.exports.FaUndoAlt = function FaUndoAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"}}]})(props);
};
module.exports.FaUndo = function FaUndo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"}}]})(props);
};
module.exports.FaUniversalAccess = function FaUniversalAccess (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"}}]})(props);
};
module.exports.FaUniversity = function FaUniversity (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"}}]})(props);
};
module.exports.FaUnlink = function FaUnlink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"}}]})(props);
};
module.exports.FaUnlockAlt = function FaUnlockAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"}}]})(props);
};
module.exports.FaUnlock = function FaUnlock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaUpload = function FaUpload (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"}}]})(props);
};
module.exports.FaUserAltSlash = function FaUserAltSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"}}]})(props);
};
module.exports.FaUserAlt = function FaUserAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"}}]})(props);
};
module.exports.FaUserAstronaut = function FaUserAstronaut (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"}}]})(props);
};
module.exports.FaUserCheck = function FaUserCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"}}]})(props);
};
module.exports.FaUserCircle = function FaUserCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"}}]})(props);
};
module.exports.FaUserClock = function FaUserClock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"}}]})(props);
};
module.exports.FaUserCog = function FaUserCog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"}}]})(props);
};
module.exports.FaUserEdit = function FaUserEdit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"}}]})(props);
};
module.exports.FaUserFriends = function FaUserFriends (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"}}]})(props);
};
module.exports.FaUserGraduate = function FaUserGraduate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"}}]})(props);
};
module.exports.FaUserInjured = function FaUserInjured (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"}}]})(props);
};
module.exports.FaUserLock = function FaUserLock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"}}]})(props);
};
module.exports.FaUserMd = function FaUserMd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"}}]})(props);
};
module.exports.FaUserMinus = function FaUserMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
};
module.exports.FaUserNinja = function FaUserNinja (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"}}]})(props);
};
module.exports.FaUserNurse = function FaUserNurse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"}}]})(props);
};
module.exports.FaUserPlus = function FaUserPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
};
module.exports.FaUserSecret = function FaUserSecret (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"}}]})(props);
};
module.exports.FaUserShield = function FaUserShield (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"}}]})(props);
};
module.exports.FaUserSlash = function FaUserSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"}}]})(props);
};
module.exports.FaUserTag = function FaUserTag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"}}]})(props);
};
module.exports.FaUserTie = function FaUserTie (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"}}]})(props);
};
module.exports.FaUserTimes = function FaUserTimes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
};
module.exports.FaUser = function FaUser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"}}]})(props);
};
module.exports.FaUsersCog = function FaUsersCog (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"}}]})(props);
};
module.exports.FaUsersSlash = function FaUsersSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"}}]})(props);
};
module.exports.FaUsers = function FaUsers (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"}}]})(props);
};
module.exports.FaUtensilSpoon = function FaUtensilSpoon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"}}]})(props);
};
module.exports.FaUtensils = function FaUtensils (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 416 512"},"child":[{"tag":"path","attr":{"d":"M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"}}]})(props);
};
module.exports.FaVectorSquare = function FaVectorSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"}}]})(props);
};
module.exports.FaVenusDouble = function FaVenusDouble (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"}}]})(props);
};
module.exports.FaVenusMars = function FaVenusMars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"}}]})(props);
};
module.exports.FaVenus = function FaVenus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"}}]})(props);
};
module.exports.FaVestPatches = function FaVestPatches (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"}}]})(props);
};
module.exports.FaVest = function FaVest (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"}}]})(props);
};
module.exports.FaVial = function FaVial (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 480 512"},"child":[{"tag":"path","attr":{"d":"M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"}}]})(props);
};
module.exports.FaVials = function FaVials (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"}}]})(props);
};
module.exports.FaVideoSlash = function FaVideoSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"}}]})(props);
};
module.exports.FaVideo = function FaVideo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"}}]})(props);
};
module.exports.FaVihara = function FaVihara (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"}}]})(props);
};
module.exports.FaVirusSlash = function FaVirusSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"}}]})(props);
};
module.exports.FaVirus = function FaVirus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"}}]})(props);
};
module.exports.FaViruses = function FaViruses (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"}}]})(props);
};
module.exports.FaVoicemail = function FaVoicemail (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"}}]})(props);
};
module.exports.FaVolleyballBall = function FaVolleyballBall (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"}}]})(props);
};
module.exports.FaVolumeDown = function FaVolumeDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"}}]})(props);
};
module.exports.FaVolumeMute = function FaVolumeMute (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"}}]})(props);
};
module.exports.FaVolumeOff = function FaVolumeOff (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 512"},"child":[{"tag":"path","attr":{"d":"M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"}}]})(props);
};
module.exports.FaVolumeUp = function FaVolumeUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"}}]})(props);
};
module.exports.FaVoteYea = function FaVoteYea (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"}}]})(props);
};
module.exports.FaVrCardboard = function FaVrCardboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"}}]})(props);
};
module.exports.FaWalking = function FaWalking (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"}}]})(props);
};
module.exports.FaWallet = function FaWallet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"}}]})(props);
};
module.exports.FaWarehouse = function FaWarehouse (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"}}]})(props);
};
module.exports.FaWater = function FaWater (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"}}]})(props);
};
module.exports.FaWaveSquare = function FaWaveSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"}}]})(props);
};
module.exports.FaWeightHanging = function FaWeightHanging (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"}}]})(props);
};
module.exports.FaWeight = function FaWeight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"}}]})(props);
};
module.exports.FaWheelchair = function FaWheelchair (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"}}]})(props);
};
module.exports.FaWifi = function FaWifi (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"}}]})(props);
};
module.exports.FaWind = function FaWind (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"}}]})(props);
};
module.exports.FaWindowClose = function FaWindowClose (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"}}]})(props);
};
module.exports.FaWindowMaximize = function FaWindowMaximize (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"}}]})(props);
};
module.exports.FaWindowMinimize = function FaWindowMinimize (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"}}]})(props);
};
module.exports.FaWindowRestore = function FaWindowRestore (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"}}]})(props);
};
module.exports.FaWineBottle = function FaWineBottle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"}}]})(props);
};
module.exports.FaWineGlassAlt = function FaWineGlassAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"}}]})(props);
};
module.exports.FaWineGlass = function FaWineGlass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 288 512"},"child":[{"tag":"path","attr":{"d":"M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"}}]})(props);
};
module.exports.FaWonSign = function FaWonSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"}}]})(props);
};
module.exports.FaWrench = function FaWrench (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"}}]})(props);
};
module.exports.FaXRay = function FaXRay (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"}}]})(props);
};
module.exports.FaYenSign = function FaYenSign (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"}}]})(props);
};
module.exports.FaYinYang = function FaYinYang (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"}}]})(props);
};
module.exports.FaRegAddressBook = function FaRegAddressBook (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"}}]})(props);
};
module.exports.FaRegAddressCard = function FaRegAddressCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"}}]})(props);
};
module.exports.FaRegAngry = function FaRegAngry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"}}]})(props);
};
module.exports.FaRegArrowAltCircleDown = function FaRegArrowAltCircleDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"}}]})(props);
};
module.exports.FaRegArrowAltCircleLeft = function FaRegArrowAltCircleLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"}}]})(props);
};
module.exports.FaRegArrowAltCircleRight = function FaRegArrowAltCircleRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"}}]})(props);
};
module.exports.FaRegArrowAltCircleUp = function FaRegArrowAltCircleUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"}}]})(props);
};
module.exports.FaRegBellSlash = function FaRegBellSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"}}]})(props);
};
module.exports.FaRegBell = function FaRegBell (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"}}]})(props);
};
module.exports.FaRegBookmark = function FaRegBookmark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"}}]})(props);
};
module.exports.FaRegBuilding = function FaRegBuilding (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"}}]})(props);
};
module.exports.FaRegCalendarAlt = function FaRegCalendarAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCalendarCheck = function FaRegCalendarCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"}}]})(props);
};
module.exports.FaRegCalendarMinus = function FaRegCalendarMinus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCalendarPlus = function FaRegCalendarPlus (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCalendarTimes = function FaRegCalendarTimes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCalendar = function FaRegCalendar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"}}]})(props);
};
module.exports.FaRegCaretSquareDown = function FaRegCaretSquareDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCaretSquareLeft = function FaRegCaretSquareLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCaretSquareRight = function FaRegCaretSquareRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegCaretSquareUp = function FaRegCaretSquareUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegChartBar = function FaRegChartBar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"}}]})(props);
};
module.exports.FaRegCheckCircle = function FaRegCheckCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"}}]})(props);
};
module.exports.FaRegCheckSquare = function FaRegCheckSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"}}]})(props);
};
module.exports.FaRegCircle = function FaRegCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"}}]})(props);
};
module.exports.FaRegClipboard = function FaRegClipboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"}}]})(props);
};
module.exports.FaRegClock = function FaRegClock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"}}]})(props);
};
module.exports.FaRegClone = function FaRegClone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"}}]})(props);
};
module.exports.FaRegClosedCaptioning = function FaRegClosedCaptioning (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"}}]})(props);
};
module.exports.FaRegCommentAlt = function FaRegCommentAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"}}]})(props);
};
module.exports.FaRegCommentDots = function FaRegCommentDots (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"}}]})(props);
};
module.exports.FaRegComment = function FaRegComment (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"}}]})(props);
};
module.exports.FaRegComments = function FaRegComments (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"}}]})(props);
};
module.exports.FaRegCompass = function FaRegCompass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"}}]})(props);
};
module.exports.FaRegCopy = function FaRegCopy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"}}]})(props);
};
module.exports.FaRegCopyright = function FaRegCopyright (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"}}]})(props);
};
module.exports.FaRegCreditCard = function FaRegCreditCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"}}]})(props);
};
module.exports.FaRegDizzy = function FaRegDizzy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"}}]})(props);
};
module.exports.FaRegDotCircle = function FaRegDotCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"}}]})(props);
};
module.exports.FaRegEdit = function FaRegEdit (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"}}]})(props);
};
module.exports.FaRegEnvelopeOpen = function FaRegEnvelopeOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"}}]})(props);
};
module.exports.FaRegEnvelope = function FaRegEnvelope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"}}]})(props);
};
module.exports.FaRegEyeSlash = function FaRegEyeSlash (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"}}]})(props);
};
module.exports.FaRegEye = function FaRegEye (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"}}]})(props);
};
module.exports.FaRegFileAlt = function FaRegFileAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"}}]})(props);
};
module.exports.FaRegFileArchive = function FaRegFileArchive (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"}}]})(props);
};
module.exports.FaRegFileAudio = function FaRegFileAudio (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"}}]})(props);
};
module.exports.FaRegFileCode = function FaRegFileCode (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"}}]})(props);
};
module.exports.FaRegFileExcel = function FaRegFileExcel (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"}}]})(props);
};
module.exports.FaRegFileImage = function FaRegFileImage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"}}]})(props);
};
module.exports.FaRegFilePdf = function FaRegFilePdf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"}}]})(props);
};
module.exports.FaRegFilePowerpoint = function FaRegFilePowerpoint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"}}]})(props);
};
module.exports.FaRegFileVideo = function FaRegFileVideo (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"}}]})(props);
};
module.exports.FaRegFileWord = function FaRegFileWord (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"}}]})(props);
};
module.exports.FaRegFile = function FaRegFile (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"}}]})(props);
};
module.exports.FaRegFlag = function FaRegFlag (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"}}]})(props);
};
module.exports.FaRegFlushed = function FaRegFlushed (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"}}]})(props);
};
module.exports.FaRegFolderOpen = function FaRegFolderOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"}}]})(props);
};
module.exports.FaRegFolder = function FaRegFolder (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"}}]})(props);
};
module.exports.FaRegFontAwesomeLogoFull = function FaRegFontAwesomeLogoFull (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 3992 512"},"child":[{"tag":"path","attr":{"d":"M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"}}]})(props);
};
module.exports.FaRegFrownOpen = function FaRegFrownOpen (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"}}]})(props);
};
module.exports.FaRegFrown = function FaRegFrown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"}}]})(props);
};
module.exports.FaRegFutbol = function FaRegFutbol (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"}}]})(props);
};
module.exports.FaRegGem = function FaRegGem (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"}}]})(props);
};
module.exports.FaRegGrimace = function FaRegGrimace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"}}]})(props);
};
module.exports.FaRegGrinAlt = function FaRegGrinAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"}}]})(props);
};
module.exports.FaRegGrinBeamSweat = function FaRegGrinBeamSweat (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"}}]})(props);
};
module.exports.FaRegGrinBeam = function FaRegGrinBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"}}]})(props);
};
module.exports.FaRegGrinHearts = function FaRegGrinHearts (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"}}]})(props);
};
module.exports.FaRegGrinSquintTears = function FaRegGrinSquintTears (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"}}]})(props);
};
module.exports.FaRegGrinSquint = function FaRegGrinSquint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"}}]})(props);
};
module.exports.FaRegGrinStars = function FaRegGrinStars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"}}]})(props);
};
module.exports.FaRegGrinTears = function FaRegGrinTears (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"}}]})(props);
};
module.exports.FaRegGrinTongueSquint = function FaRegGrinTongueSquint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"}}]})(props);
};
module.exports.FaRegGrinTongueWink = function FaRegGrinTongueWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"}}]})(props);
};
module.exports.FaRegGrinTongue = function FaRegGrinTongue (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
};
module.exports.FaRegGrinWink = function FaRegGrinWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"}}]})(props);
};
module.exports.FaRegGrin = function FaRegGrin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}}]})(props);
};
module.exports.FaRegHandLizard = function FaRegHandLizard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"}}]})(props);
};
module.exports.FaRegHandPaper = function FaRegHandPaper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"}}]})(props);
};
module.exports.FaRegHandPeace = function FaRegHandPeace (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"}}]})(props);
};
module.exports.FaRegHandPointDown = function FaRegHandPointDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"}}]})(props);
};
module.exports.FaRegHandPointLeft = function FaRegHandPointLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"}}]})(props);
};
module.exports.FaRegHandPointRight = function FaRegHandPointRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"}}]})(props);
};
module.exports.FaRegHandPointUp = function FaRegHandPointUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"}}]})(props);
};
module.exports.FaRegHandPointer = function FaRegHandPointer (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"}}]})(props);
};
module.exports.FaRegHandRock = function FaRegHandRock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"}}]})(props);
};
module.exports.FaRegHandScissors = function FaRegHandScissors (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"}}]})(props);
};
module.exports.FaRegHandSpock = function FaRegHandSpock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"}}]})(props);
};
module.exports.FaRegHandshake = function FaRegHandshake (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"}}]})(props);
};
module.exports.FaRegHdd = function FaRegHdd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"}}]})(props);
};
module.exports.FaRegHeart = function FaRegHeart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"}}]})(props);
};
module.exports.FaRegHospital = function FaRegHospital (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"}}]})(props);
};
module.exports.FaRegHourglass = function FaRegHourglass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"}}]})(props);
};
module.exports.FaRegIdBadge = function FaRegIdBadge (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"}}]})(props);
};
module.exports.FaRegIdCard = function FaRegIdCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"}}]})(props);
};
module.exports.FaRegImage = function FaRegImage (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"}}]})(props);
};
module.exports.FaRegImages = function FaRegImages (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"}}]})(props);
};
module.exports.FaRegKeyboard = function FaRegKeyboard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"}}]})(props);
};
module.exports.FaRegKissBeam = function FaRegKissBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"}}]})(props);
};
module.exports.FaRegKissWinkHeart = function FaRegKissWinkHeart (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 504 512"},"child":[{"tag":"path","attr":{"d":"M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"}}]})(props);
};
module.exports.FaRegKiss = function FaRegKiss (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
};
module.exports.FaRegLaughBeam = function FaRegLaughBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
};
module.exports.FaRegLaughSquint = function FaRegLaughSquint (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
};
module.exports.FaRegLaughWink = function FaRegLaughWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
};
module.exports.FaRegLaugh = function FaRegLaugh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"}}]})(props);
};
module.exports.FaRegLemon = function FaRegLemon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"}}]})(props);
};
module.exports.FaRegLifeRing = function FaRegLifeRing (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"}}]})(props);
};
module.exports.FaRegLightbulb = function FaRegLightbulb (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 352 512"},"child":[{"tag":"path","attr":{"d":"M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"}}]})(props);
};
module.exports.FaRegListAlt = function FaRegListAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"}}]})(props);
};
module.exports.FaRegMap = function FaRegMap (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"}}]})(props);
};
module.exports.FaRegMehBlank = function FaRegMehBlank (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
};
module.exports.FaRegMehRollingEyes = function FaRegMehRollingEyes (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"}}]})(props);
};
module.exports.FaRegMeh = function FaRegMeh (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"}}]})(props);
};
module.exports.FaRegMinusSquare = function FaRegMinusSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegMoneyBillAlt = function FaRegMoneyBillAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 640 512"},"child":[{"tag":"path","attr":{"d":"M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"}}]})(props);
};
module.exports.FaRegMoon = function FaRegMoon (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"}}]})(props);
};
module.exports.FaRegNewspaper = function FaRegNewspaper (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"}}]})(props);
};
module.exports.FaRegObjectGroup = function FaRegObjectGroup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"}}]})(props);
};
module.exports.FaRegObjectUngroup = function FaRegObjectUngroup (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"}}]})(props);
};
module.exports.FaRegPaperPlane = function FaRegPaperPlane (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"}}]})(props);
};
module.exports.FaRegPauseCircle = function FaRegPauseCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"}}]})(props);
};
module.exports.FaRegPlayCircle = function FaRegPlayCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"}}]})(props);
};
module.exports.FaRegPlusSquare = function FaRegPlusSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"}}]})(props);
};
module.exports.FaRegQuestionCircle = function FaRegQuestionCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"}}]})(props);
};
module.exports.FaRegRegistered = function FaRegRegistered (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"}}]})(props);
};
module.exports.FaRegSadCry = function FaRegSadCry (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"}}]})(props);
};
module.exports.FaRegSadTear = function FaRegSadTear (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"}}]})(props);
};
module.exports.FaRegSave = function FaRegSave (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"}}]})(props);
};
module.exports.FaRegShareSquare = function FaRegShareSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"}}]})(props);
};
module.exports.FaRegSmileBeam = function FaRegSmileBeam (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"}}]})(props);
};
module.exports.FaRegSmileWink = function FaRegSmileWink (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"}}]})(props);
};
module.exports.FaRegSmile = function FaRegSmile (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"}}]})(props);
};
module.exports.FaRegSnowflake = function FaRegSnowflake (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"}}]})(props);
};
module.exports.FaRegSquare = function FaRegSquare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"}}]})(props);
};
module.exports.FaRegStarHalf = function FaRegStarHalf (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"}}]})(props);
};
module.exports.FaRegStar = function FaRegStar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"}}]})(props);
};
module.exports.FaRegStickyNote = function FaRegStickyNote (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"}}]})(props);
};
module.exports.FaRegStopCircle = function FaRegStopCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"}}]})(props);
};
module.exports.FaRegSun = function FaRegSun (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"}}]})(props);
};
module.exports.FaRegSurprise = function FaRegSurprise (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}}]})(props);
};
module.exports.FaRegThumbsDown = function FaRegThumbsDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"}}]})(props);
};
module.exports.FaRegThumbsUp = function FaRegThumbsUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"}}]})(props);
};
module.exports.FaRegTimesCircle = function FaRegTimesCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"}}]})(props);
};
module.exports.FaRegTired = function FaRegTired (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"}}]})(props);
};
module.exports.FaRegTrashAlt = function FaRegTrashAlt (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"}}]})(props);
};
module.exports.FaRegUserCircle = function FaRegUserCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 496 512"},"child":[{"tag":"path","attr":{"d":"M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"}}]})(props);
};
module.exports.FaRegUser = function FaRegUser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"}}]})(props);
};
module.exports.FaRegWindowClose = function FaRegWindowClose (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"}}]})(props);
};
module.exports.FaRegWindowMaximize = function FaRegWindowMaximize (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"}}]})(props);
};
module.exports.FaRegWindowMinimize = function FaRegWindowMinimize (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"}}]})(props);
};
module.exports.FaRegWindowRestore = function FaRegWindowRestore (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"}}]})(props);
};

},{"../lib":1025}],1022:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBase = exports.GenIcon = void 0;
var React = require("react");
var iconContext_1 = require("./iconContext");
function Tree2Element(tree) {
    return tree && tree.map(function (node, i) { return React.createElement(node.tag, __assign({ key: i }, node.attr), Tree2Element(node.child)); });
}
function GenIcon(data) {
    return function (props) { return (React.createElement(IconBase, __assign({ attr: __assign({}, data.attr) }, props), Tree2Element(data.child))); };
}
exports.GenIcon = GenIcon;
function IconBase(props) {
    var elem = function (conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className)
            className = conf.className;
        if (props.className)
            className = (className ? className + ' ' : '') + props.className;
        return (React.createElement("svg", __assign({ stroke: "currentColor", fill: "currentColor", strokeWidth: "0" }, conf.attr, attr, svgProps, { className: className, style: __assign(__assign({ color: props.color || conf.color }, conf.style), props.style), height: computedSize, width: computedSize, xmlns: "http://www.w3.org/2000/svg" }),
            title && React.createElement("title", null, title),
            props.children));
    };
    return iconContext_1.IconContext !== undefined
        ? React.createElement(iconContext_1.IconContext.Consumer, null, function (conf) { return elem(conf); })
        : elem(iconContext_1.DefaultContext);
}
exports.IconBase = IconBase;

},{"./iconContext":1023,"react":1107}],1023:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconContext = exports.DefaultContext = void 0;
var React = require("react");
exports.DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined,
};
exports.IconContext = React.createContext && React.createContext(exports.DefaultContext);

},{"react":1107}],1024:[function(require,module,exports){
module.exports.IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
},{}],1025:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./iconsManifest"), exports);
__exportStar(require("./iconBase"), exports);
__exportStar(require("./iconContext"), exports);

},{"./iconBase":1022,"./iconContext":1023,"./iconsManifest":1024}],1026:[function(require,module,exports){
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';



if ("production" !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}

},{}],1027:[function(require,module,exports){
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;

},{}],1028:[function(require,module,exports){
'use strict';

if ("production" === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}

},{"./cjs/react-is.development.js":1026,"./cjs/react-is.production.min.js":1027}],1029:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

exports.polyfill = polyfill;

},{}],1030:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _objectWithoutPropertiesLoose = _interopDefault(require('@babel/runtime/helpers/objectWithoutPropertiesLoose'));
var _inheritsLoose = _interopDefault(require('@babel/runtime/helpers/inheritsLoose'));
var react = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var ResizeObserver = _interopDefault(require('resize-observer-polyfill'));

var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}

function getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: styles ? parseInt(styles.marginTop) : 0,
      right: styles ? parseInt(styles.marginRight) : 0,
      bottom: styles ? parseInt(styles.marginBottom) : 0,
      left: styles ? parseInt(styles.marginLeft) : 0
    };
  }

  return calculations;
}

/**
 * Returns the global window object associated with provided element.
 */
function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
  // provided element.

  return ownerGlobal || window;
}

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(WithContentRect, _Component);

      function WithContentRect() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        };
        _this._animationFrameID = null;
        _this._resizeObserver = null;
        _this._node = null;
        _this._window = null;

        _this.measure = function (entries) {
          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this._animationFrameID = _this._window.requestAnimationFrame(function () {
            if (_this._resizeObserver !== null) {
              _this.setState({
                contentRect: contentRect
              });

              if (typeof _this.props.onResize === 'function') {
                _this.props.onResize(contentRect);
              }
            }
          });
        };

        _this._handleRef = function (node) {
          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.unobserve(_this._node);
          }

          _this._node = node;
          _this._window = getWindowOf(_this._node);
          var innerRef = _this.props.innerRef;

          if (innerRef) {
            if (typeof innerRef === 'function') {
              innerRef(_this._node);
            } else {
              innerRef.current = _this._node;
            }
          }

          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.observe(_this._node);
          }
        };

        return _this;
      }

      var _proto = WithContentRect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new ResizeObserver(this.measure);

        if (this._node !== null) {
          this._resizeObserver.observe(this._node);

          if (typeof this.props.onResize === 'function') {
            this.props.onResize(getContentRect(this._node, types || getTypes(this.props)));
          }
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this._window !== null) {
          this._window.cancelAnimationFrame(this._animationFrameID);
        }

        if (this._resizeObserver !== null) {
          this._resizeObserver.disconnect();

          this._resizeObserver = null;
        }
      };

      _proto.render = function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            onResize = _this$props.onResize,
            props = _objectWithoutPropertiesLoose(_this$props, ["innerRef", "onResize"]);

        return react.createElement(WrappedComponent, _extends({}, props, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      };

      return WithContentRect;
    }(react.Component), _class.propTypes = {
      client: PropTypes.bool,
      offset: PropTypes.bool,
      scroll: PropTypes.bool,
      bounds: PropTypes.bool,
      margin: PropTypes.bool,
      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
      onResize: PropTypes.func
    }, _temp;
  };
}

var Measure = withContentRect()(function (_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;
  return children({
    measure: measure,
    measureRef: measureRef,
    contentRect: contentRect
  });
});
Measure.displayName = 'Measure';
Measure.propTypes.children = PropTypes.func;

exports.default = Measure;
exports.withContentRect = withContentRect;

},{"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/inheritsLoose":318,"@babel/runtime/helpers/objectWithoutPropertiesLoose":322,"prop-types":896,"react":1107,"resize-observer-polyfill":1137}],1031:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = require("./ModalPortal");

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = require("../helpers/ariaAppHider");

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = require("../helpers/safeHTMLElement");

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = require("react-lifecycles-compat");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;
},{"../helpers/ariaAppHider":1033,"../helpers/safeHTMLElement":1038,"./ModalPortal":1032,"prop-types":896,"react":1107,"react-dom":1016,"react-lifecycles-compat":1029}],1032:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = require("../helpers/focusManager");

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = require("../helpers/scopeTab");

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = require("../helpers/ariaAppHider");

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = require("../helpers/classList");

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = require("../helpers/safeHTMLElement");

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = require("../helpers/portalOpenInstances");

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

require("../helpers/bodyTrap");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if ("production" !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
},{"../helpers/ariaAppHider":1033,"../helpers/bodyTrap":1034,"../helpers/classList":1035,"../helpers/focusManager":1036,"../helpers/portalOpenInstances":1037,"../helpers/safeHTMLElement":1038,"../helpers/scopeTab":1039,"prop-types":896,"react":1107}],1033:[function(require,module,exports){
'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;
var _warning = require('warning');
var _warning2 = _interopRequireDefault(_warning);
var _safeHTMLElement = require('./safeHTMLElement');
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
var globalElement = null;
function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) {
        throw new Error('react-modal: No elements were found for selector ' + selector + '.');
    }
}
function setElement(element) {
    var useElement = element;
    if (typeof useElement === 'string' && _safeHTMLElement.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        assertNodeList(el, useElement);
        useElement = 'length' in el ? el[0] : el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
}
function validateElement(appElement) {
    if (!appElement && !globalElement) {
        (0, _warning2.default)(false, [
            'react-modal: App element is not defined.',
            'Please use `Modal.setAppElement(el)` or set `appElement={el}`.',
            'This is needed so screen readers don\'t see main content',
            'when modal is opened. It is not recommended, but you can opt-out',
            'by setting `ariaHideApp={false}`.'
        ].join(' '));
        return false;
    }
    return true;
}
function hide(appElement) {
    if (validateElement(appElement)) {
        (appElement || globalElement).setAttribute('aria-hidden', 'true');
    }
}
function show(appElement) {
    if (validateElement(appElement)) {
        (appElement || globalElement).removeAttribute('aria-hidden');
    }
}
function documentNotReadyOrSSRTesting() {
    globalElement = null;
}
function resetForTesting() {
    globalElement = null;
}
},{"./safeHTMLElement":1038,"warning":1042}],1034:[function(require,module,exports){
"use strict";

var _portalOpenInstances = require("./portalOpenInstances");

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if ("production" !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);
},{"./portalOpenInstances":1037}],1035:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if ("production" !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
},{}],1036:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = require("../helpers/tabbable");

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
},{"../helpers/tabbable":1040}],1037:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if ("production" !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if ("production" !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];
},{}],1038:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = require("exenv");

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;
},{"exenv":630}],1039:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = require("./tabbable");

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
},{"./tabbable":1040}],1040:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];
},{}],1041:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = require("./components/Modal");

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
},{"./components/Modal":1031}],1042:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

},{}],1043:[function(require,module,exports){

      const createReactPlayer = require('./lib/ReactPlayer').createReactPlayer
      const Player = require('./lib/players/FilePlayer').default
      module.exports = createReactPlayer([{
        key: 'file',
        canPlay: Player.canPlay,
        lazyPlayer: Player
      }])
    
},{"./lib/ReactPlayer":1046,"./lib/players/FilePlayer":1051}],1044:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _reactFastCompare = _interopRequireDefault(require('react-fast-compare'));
var _props = require('./props');
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { 'default': obj };
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _extends() {
    _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SEEK_ON_PLAY_EXPIRY = 5000;
var Player = function (_Component) {
    _inherits(Player, _Component);
    var _super = _createSuper(Player);
    function Player() {
        var _this;
        _classCallCheck(this, Player);
        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
            _args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(_args));
        _defineProperty(_assertThisInitialized(_this), 'mounted', false);
        _defineProperty(_assertThisInitialized(_this), 'isReady', false);
        _defineProperty(_assertThisInitialized(_this), 'isPlaying', false);
        _defineProperty(_assertThisInitialized(_this), 'isLoading', true);
        _defineProperty(_assertThisInitialized(_this), 'loadOnReady', null);
        _defineProperty(_assertThisInitialized(_this), 'startOnPlay', true);
        _defineProperty(_assertThisInitialized(_this), 'seekOnPlay', null);
        _defineProperty(_assertThisInitialized(_this), 'onDurationCalled', false);
        _defineProperty(_assertThisInitialized(_this), 'handlePlayerMount', function (player) {
            _this.player = player;
            _this.player.load(_this.props.url);
            _this.progress();
        });
        _defineProperty(_assertThisInitialized(_this), 'getInternalPlayer', function (key) {
            if (!_this.player)
                return null;
            return _this.player[key];
        });
        _defineProperty(_assertThisInitialized(_this), 'progress', function () {
            if (_this.props.url && _this.player && _this.isReady) {
                var playedSeconds = _this.getCurrentTime() || 0;
                var loadedSeconds = _this.getSecondsLoaded();
                var duration = _this.getDuration();
                if (duration) {
                    var progress = {
                        playedSeconds: playedSeconds,
                        played: playedSeconds / duration
                    };
                    if (loadedSeconds !== null) {
                        progress.loadedSeconds = loadedSeconds;
                        progress.loaded = loadedSeconds / duration;
                    }
                    if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
                        _this.props.onProgress(progress);
                    }
                    _this.prevPlayed = progress.playedSeconds;
                    _this.prevLoaded = progress.loadedSeconds;
                }
            }
            _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
        });
        _defineProperty(_assertThisInitialized(_this), 'handleReady', function () {
            if (!_this.mounted)
                return;
            _this.isReady = true;
            _this.isLoading = false;
            var _this$props = _this.props, onReady = _this$props.onReady, playing = _this$props.playing, volume = _this$props.volume, muted = _this$props.muted;
            onReady();
            if (!muted && volume !== null) {
                _this.player.setVolume(volume);
            }
            if (_this.loadOnReady) {
                _this.player.load(_this.loadOnReady, true);
                _this.loadOnReady = null;
            } else if (playing) {
                _this.player.play();
            }
            _this.handleDurationCheck();
        });
        _defineProperty(_assertThisInitialized(_this), 'handlePlay', function () {
            _this.isPlaying = true;
            _this.isLoading = false;
            var _this$props2 = _this.props, onStart = _this$props2.onStart, onPlay = _this$props2.onPlay, playbackRate = _this$props2.playbackRate;
            if (_this.startOnPlay) {
                if (_this.player.setPlaybackRate && playbackRate !== 1) {
                    _this.player.setPlaybackRate(playbackRate);
                }
                onStart();
                _this.startOnPlay = false;
            }
            onPlay();
            if (_this.seekOnPlay) {
                _this.seekTo(_this.seekOnPlay);
                _this.seekOnPlay = null;
            }
            _this.handleDurationCheck();
        });
        _defineProperty(_assertThisInitialized(_this), 'handlePause', function (e) {
            _this.isPlaying = false;
            if (!_this.isLoading) {
                _this.props.onPause(e);
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'handleEnded', function () {
            var _this$props3 = _this.props, activePlayer = _this$props3.activePlayer, loop = _this$props3.loop, onEnded = _this$props3.onEnded;
            if (activePlayer.loopOnEnded && loop) {
                _this.seekTo(0);
            }
            if (!loop) {
                _this.isPlaying = false;
                onEnded();
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'handleError', function () {
            var _this$props4;
            _this.isLoading = false;
            (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'handleDurationCheck', function () {
            clearTimeout(_this.durationCheckTimeout);
            var duration = _this.getDuration();
            if (duration) {
                if (!_this.onDurationCalled) {
                    _this.props.onDuration(duration);
                    _this.onDurationCalled = true;
                }
            } else {
                _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'handleLoaded', function () {
            _this.isLoading = false;
        });
        return _this;
    }
    _createClass(Player, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.mounted = true;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                clearTimeout(this.progressTimeout);
                clearTimeout(this.durationCheckTimeout);
                if (this.isReady && this.props.stopOnUnmount) {
                    this.player.stop();
                    if (this.player.disablePIP) {
                        this.player.disablePIP();
                    }
                }
                this.mounted = false;
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var _this2 = this;
                if (!this.player) {
                    return;
                }
                var _this$props5 = this.props, url = _this$props5.url, playing = _this$props5.playing, volume = _this$props5.volume, muted = _this$props5.muted, playbackRate = _this$props5.playbackRate, pip = _this$props5.pip, loop = _this$props5.loop, activePlayer = _this$props5.activePlayer;
                if (!(0, _reactFastCompare['default'])(prevProps.url, url)) {
                    if (this.isLoading && !activePlayer.forceLoad) {
                        console.warn('ReactPlayer: the attempt to load '.concat(url, ' is being deferred until the player has loaded'));
                        this.loadOnReady = url;
                        return;
                    }
                    this.isLoading = true;
                    this.startOnPlay = true;
                    this.onDurationCalled = false;
                    this.player.load(url, this.isReady);
                }
                if (!prevProps.playing && playing && !this.isPlaying) {
                    this.player.play();
                }
                if (prevProps.playing && !playing && this.isPlaying) {
                    this.player.pause();
                }
                if (!prevProps.pip && pip && this.player.enablePIP) {
                    this.player.enablePIP();
                }
                if (prevProps.pip && !pip && this.player.disablePIP) {
                    this.player.disablePIP();
                }
                if (prevProps.volume !== volume && volume !== null) {
                    this.player.setVolume(volume);
                }
                if (prevProps.muted !== muted) {
                    if (muted) {
                        this.player.mute();
                    } else {
                        this.player.unmute();
                        if (volume !== null) {
                            setTimeout(function () {
                                return _this2.player.setVolume(volume);
                            });
                        }
                    }
                }
                if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
                    this.player.setPlaybackRate(playbackRate);
                }
                if (prevProps.loop !== loop && this.player.setLoop) {
                    this.player.setLoop(loop);
                }
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                if (!this.isReady)
                    return null;
                return this.player.getDuration();
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                if (!this.isReady)
                    return null;
                return this.player.getCurrentTime();
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                if (!this.isReady)
                    return null;
                return this.player.getSecondsLoaded();
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(amount, type) {
                var _this3 = this;
                if (!this.isReady && amount !== 0) {
                    this.seekOnPlay = amount;
                    setTimeout(function () {
                        _this3.seekOnPlay = null;
                    }, SEEK_ON_PLAY_EXPIRY);
                    return;
                }
                var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';
                if (isFraction) {
                    var duration = this.player.getDuration();
                    if (!duration) {
                        console.warn('ReactPlayer: could not seek using fraction \u2013\xA0duration not yet available');
                        return;
                    }
                    this.player.seekTo(duration * amount);
                    return;
                }
                this.player.seekTo(amount);
            }
        },
        {
            key: 'render',
            value: function render() {
                var Player = this.props.activePlayer;
                if (!Player) {
                    return null;
                }
                return _react['default'].createElement(Player, _extends({}, this.props, {
                    onMount: this.handlePlayerMount,
                    onReady: this.handleReady,
                    onPlay: this.handlePlay,
                    onPause: this.handlePause,
                    onEnded: this.handleEnded,
                    onLoaded: this.handleLoaded,
                    onError: this.handleError
                }));
            }
        }
    ]);
    return Player;
}(_react.Component);
exports['default'] = Player;
_defineProperty(Player, 'displayName', 'Player');
_defineProperty(Player, 'propTypes', _props.propTypes);
_defineProperty(Player, 'defaultProps', _props.defaultProps);
},{"./props":1062,"react":1107,"react-fast-compare":1017}],1045:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ICON_SIZE = '64px';
var cache = {};
var Preview = function (_Component) {
    _inherits(Preview, _Component);
    var _super = _createSuper(Preview);
    function Preview() {
        var _this;
        _classCallCheck(this, Preview);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'mounted', false);
        _defineProperty(_assertThisInitialized(_this), 'state', { image: null });
        _defineProperty(_assertThisInitialized(_this), 'handleKeyPress', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                _this.props.onClick();
            }
        });
        return _this;
    }
    _createClass(Preview, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.mounted = true;
                this.fetchImage(this.props);
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, url = _this$props.url, light = _this$props.light;
                if (prevProps.url !== url || prevProps.light !== light) {
                    this.fetchImage(this.props);
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: 'fetchImage',
            value: function fetchImage(_ref) {
                var _this2 = this;
                var url = _ref.url, light = _ref.light;
                if (typeof light === 'string') {
                    this.setState({ image: light });
                    return;
                }
                if (cache[url]) {
                    this.setState({ image: cache[url] });
                    return;
                }
                this.setState({ image: null });
                return window.fetch('https://noembed.com/embed?url='.concat(url)).then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.thumbnail_url && _this2.mounted) {
                        var image = data.thumbnail_url.replace('height=100', 'height=480');
                        _this2.setState({ image: image });
                        cache[url] = image;
                    }
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this$props2 = this.props, onClick = _this$props2.onClick, playIcon = _this$props2.playIcon, previewTabIndex = _this$props2.previewTabIndex;
                var image = this.state.image;
                var flexCenter = {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                };
                var styles = {
                    preview: _objectSpread({
                        width: '100%',
                        height: '100%',
                        backgroundImage: image ? 'url('.concat(image, ')') : undefined,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        cursor: 'pointer'
                    }, flexCenter),
                    shadow: _objectSpread({
                        background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
                        borderRadius: ICON_SIZE,
                        width: ICON_SIZE,
                        height: ICON_SIZE
                    }, flexCenter),
                    playIcon: {
                        borderStyle: 'solid',
                        borderWidth: '16px 0 16px 26px',
                        borderColor: 'transparent transparent transparent white',
                        marginLeft: '7px'
                    }
                };
                var defaultPlayIcon = _react['default'].createElement('div', {
                    style: styles.shadow,
                    className: 'react-player__shadow'
                }, _react['default'].createElement('div', {
                    style: styles.playIcon,
                    className: 'react-player__play-icon'
                }));
                return _react['default'].createElement('div', {
                    style: styles.preview,
                    className: 'react-player__preview',
                    onClick: onClick,
                    tabIndex: previewTabIndex,
                    onKeyPress: this.handleKeyPress
                }, playIcon || defaultPlayIcon);
            }
        }
    ]);
    return Preview;
}(_react.Component);
exports['default'] = Preview;
},{"react":1107}],1046:[function(require,module,exports){
(function (global){(function (){
'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.createReactPlayer = void 0;
var _react = _interopRequireWildcard(require('react'));
var _deepmerge = _interopRequireDefault(require('deepmerge'));
var _memoizeOne = _interopRequireDefault(require('memoize-one'));
var _reactFastCompare = _interopRequireDefault(require('react-fast-compare'));
var _props = require('./props');
var _utils = require('./utils');
var _Player3 = _interopRequireDefault(require('./Player'));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { 'default': obj };
}
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && Symbol.iterator in Object(iter))
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var Preview = (0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('./Preview'));
    });
});
var IS_BROWSER = typeof window !== 'undefined' && window.document;
var IS_GLOBAL = typeof global !== 'undefined' && global.window && global.window.document;
var SUPPORTED_PROPS = Object.keys(_props.propTypes);
var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? _react.Suspense : function () {
    return null;
};
var customPlayers = [];
var createReactPlayer = function createReactPlayer(players, fallback) {
    var _class, _temp;
    return _temp = _class = function (_Component) {
        _inherits(ReactPlayer, _Component);
        var _super = _createSuper(ReactPlayer);
        function ReactPlayer() {
            var _this;
            _classCallCheck(this, ReactPlayer);
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }
            _this = _super.call.apply(_super, [this].concat(args));
            _defineProperty(_assertThisInitialized(_this), 'state', { showPreview: !!_this.props.light });
            _defineProperty(_assertThisInitialized(_this), 'references', {
                wrapper: function wrapper(_wrapper) {
                    _this.wrapper = _wrapper;
                },
                player: function player(_player) {
                    _this.player = _player;
                }
            });
            _defineProperty(_assertThisInitialized(_this), 'handleClickPreview', function (e) {
                _this.setState({ showPreview: false });
                _this.props.onClickPreview(e);
            });
            _defineProperty(_assertThisInitialized(_this), 'showPreview', function () {
                _this.setState({ showPreview: true });
            });
            _defineProperty(_assertThisInitialized(_this), 'getDuration', function () {
                if (!_this.player)
                    return null;
                return _this.player.getDuration();
            });
            _defineProperty(_assertThisInitialized(_this), 'getCurrentTime', function () {
                if (!_this.player)
                    return null;
                return _this.player.getCurrentTime();
            });
            _defineProperty(_assertThisInitialized(_this), 'getSecondsLoaded', function () {
                if (!_this.player)
                    return null;
                return _this.player.getSecondsLoaded();
            });
            _defineProperty(_assertThisInitialized(_this), 'getInternalPlayer', function () {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
                if (!_this.player)
                    return null;
                return _this.player.getInternalPlayer(key);
            });
            _defineProperty(_assertThisInitialized(_this), 'seekTo', function (fraction, type) {
                if (!_this.player)
                    return null;
                _this.player.seekTo(fraction, type);
            });
            _defineProperty(_assertThisInitialized(_this), 'handleReady', function () {
                _this.props.onReady(_assertThisInitialized(_this));
            });
            _defineProperty(_assertThisInitialized(_this), 'getActivePlayer', (0, _memoizeOne['default'])(function (url) {
                for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
                    var player = _arr[_i];
                    if (player.canPlay(url)) {
                        return player;
                    }
                }
                if (fallback) {
                    return fallback;
                }
                return null;
            }));
            _defineProperty(_assertThisInitialized(_this), 'getConfig', (0, _memoizeOne['default'])(function (url, key) {
                var config = _this.props.config;
                return _deepmerge['default'].all([
                    _props.defaultProps.config,
                    _props.defaultProps.config[key] || {},
                    config,
                    config[key] || {}
                ]);
            }));
            _defineProperty(_assertThisInitialized(_this), 'getAttributes', (0, _memoizeOne['default'])(function (url) {
                return (0, _utils.omit)(_this.props, SUPPORTED_PROPS);
            }));
            _defineProperty(_assertThisInitialized(_this), 'renderActivePlayer', function (url) {
                if (!url)
                    return null;
                var player = _this.getActivePlayer(url);
                if (!player)
                    return null;
                var config = _this.getConfig(url, player.key);
                return _react['default'].createElement(_Player3['default'], _extends({}, _this.props, {
                    key: player.key,
                    ref: _this.references.player,
                    config: config,
                    activePlayer: player.lazyPlayer || player,
                    onReady: _this.handleReady
                }));
            });
            return _this;
        }
        _createClass(ReactPlayer, [
            {
                key: 'shouldComponentUpdate',
                value: function shouldComponentUpdate(nextProps, nextState) {
                    return !(0, _reactFastCompare['default'])(this.props, nextProps) || !(0, _reactFastCompare['default'])(this.state, nextState);
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate(prevProps) {
                    var light = this.props.light;
                    if (!prevProps.light && light) {
                        this.setState({ showPreview: true });
                    }
                    if (prevProps.light && !light) {
                        this.setState({ showPreview: false });
                    }
                }
            },
            {
                key: 'renderPreview',
                value: function renderPreview(url) {
                    if (!url)
                        return null;
                    var _this$props = this.props, light = _this$props.light, playIcon = _this$props.playIcon, previewTabIndex = _this$props.previewTabIndex;
                    return _react['default'].createElement(Preview, {
                        url: url,
                        light: light,
                        playIcon: playIcon,
                        previewTabIndex: previewTabIndex,
                        onClick: this.handleClickPreview
                    });
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _this$props2 = this.props, url = _this$props2.url, style = _this$props2.style, width = _this$props2.width, height = _this$props2.height, fallback = _this$props2.fallback, Wrapper = _this$props2.wrapper;
                    var showPreview = this.state.showPreview;
                    var attributes = this.getAttributes(url);
                    return _react['default'].createElement(Wrapper, _extends({
                        ref: this.references.wrapper,
                        style: _objectSpread(_objectSpread({}, style), {}, {
                            width: width,
                            height: height
                        })
                    }, attributes), _react['default'].createElement(UniversalSuspense, { fallback: fallback }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
                }
            }
        ]);
        return ReactPlayer;
    }(_react.Component), _defineProperty(_class, 'displayName', 'ReactPlayer'), _defineProperty(_class, 'propTypes', _props.propTypes), _defineProperty(_class, 'defaultProps', _props.defaultProps), _defineProperty(_class, 'addCustomPlayer', function (player) {
        customPlayers.push(player);
    }), _defineProperty(_class, 'removeCustomPlayers', function () {
        customPlayers.length = 0;
    }), _defineProperty(_class, 'canPlay', function (url) {
        for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
            var _Player = _arr2[_i2];
            if (_Player.canPlay(url)) {
                return true;
            }
        }
        return false;
    }), _defineProperty(_class, 'canEnablePIP', function (url) {
        for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
            var _Player2 = _arr3[_i3];
            if (_Player2.canEnablePIP && _Player2.canEnablePIP(url)) {
                return true;
            }
        }
        return false;
    }), _temp;
};
exports.createReactPlayer = createReactPlayer;
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./Player":1044,"./Preview":1045,"./props":1062,"./utils":1063,"deepmerge":1064,"memoize-one":876,"react":1107,"react-fast-compare":1017}],1047:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _players = _interopRequireDefault(require("./players"));

var _ReactPlayer = require("./ReactPlayer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Fall back to FilePlayer if nothing else can play the URL
var fallback = _players["default"][_players["default"].length - 1];

var _default = (0, _ReactPlayer.createReactPlayer)(_players["default"], fallback);

exports["default"] = _default;
},{"./ReactPlayer":1046,"./players":1061}],1048:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canPlay = exports.FLV_EXTENSIONS = exports.DASH_EXTENSIONS = exports.HLS_EXTENSIONS = exports.VIDEO_EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.MATCH_URL_KALTURA = exports.MATCH_URL_VIDYARD = exports.MATCH_URL_MIXCLOUD = exports.MATCH_URL_DAILYMOTION = exports.MATCH_URL_TWITCH_CHANNEL = exports.MATCH_URL_TWITCH_VIDEO = exports.MATCH_URL_WISTIA = exports.MATCH_URL_STREAMABLE = exports.MATCH_URL_FACEBOOK_WATCH = exports.MATCH_URL_FACEBOOK = exports.MATCH_URL_VIMEO = exports.MATCH_URL_SOUNDCLOUD = exports.MATCH_URL_YOUTUBE = void 0;

var _utils = require("./utils");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
exports.MATCH_URL_YOUTUBE = MATCH_URL_YOUTUBE;
var MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
exports.MATCH_URL_SOUNDCLOUD = MATCH_URL_SOUNDCLOUD;
var MATCH_URL_VIMEO = /vimeo\.com\/.+/;
exports.MATCH_URL_VIMEO = MATCH_URL_VIMEO;
var MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
exports.MATCH_URL_FACEBOOK = MATCH_URL_FACEBOOK;
var MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
exports.MATCH_URL_FACEBOOK_WATCH = MATCH_URL_FACEBOOK_WATCH;
var MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
exports.MATCH_URL_STREAMABLE = MATCH_URL_STREAMABLE;
var MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?(.*)$/;
exports.MATCH_URL_WISTIA = MATCH_URL_WISTIA;
var MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
exports.MATCH_URL_TWITCH_VIDEO = MATCH_URL_TWITCH_VIDEO;
var MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
exports.MATCH_URL_TWITCH_CHANNEL = MATCH_URL_TWITCH_CHANNEL;
var MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
exports.MATCH_URL_DAILYMOTION = MATCH_URL_DAILYMOTION;
var MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
exports.MATCH_URL_MIXCLOUD = MATCH_URL_MIXCLOUD;
var MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-]+)/;
exports.MATCH_URL_VIDYARD = MATCH_URL_VIDYARD;
var MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_]+)$/;
exports.MATCH_URL_KALTURA = MATCH_URL_KALTURA;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
exports.AUDIO_EXTENSIONS = AUDIO_EXTENSIONS;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
exports.VIDEO_EXTENSIONS = VIDEO_EXTENSIONS;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
exports.HLS_EXTENSIONS = HLS_EXTENSIONS;
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
exports.DASH_EXTENSIONS = DASH_EXTENSIONS;
var FLV_EXTENSIONS = /\.(flv)($|\?)/i;
exports.FLV_EXTENSIONS = FLV_EXTENSIONS;

var canPlayFile = function canPlayFile(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlayFile(item)) {
          return true;
        }

        if (canPlayFile(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, _utils.isMediaStream)(url) || (0, _utils.isBlobUrl)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};

var canPlay = {
  youtube: function youtube(url) {
    if (url instanceof Array) {
      return url.every(function (item) {
        return MATCH_URL_YOUTUBE.test(item);
      });
    }

    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: function soundcloud(url) {
    return MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url);
  },
  vimeo: function vimeo(url) {
    return MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url);
  },
  facebook: function facebook(url) {
    return MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url);
  },
  streamable: function streamable(url) {
    return MATCH_URL_STREAMABLE.test(url);
  },
  wistia: function wistia(url) {
    return MATCH_URL_WISTIA.test(url);
  },
  twitch: function twitch(url) {
    return MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url);
  },
  dailymotion: function dailymotion(url) {
    return MATCH_URL_DAILYMOTION.test(url);
  },
  mixcloud: function mixcloud(url) {
    return MATCH_URL_MIXCLOUD.test(url);
  },
  vidyard: function vidyard(url) {
    return MATCH_URL_VIDYARD.test(url);
  },
  kaltura: function kaltura(url) {
    return MATCH_URL_KALTURA.test(url);
  },
  file: canPlayFile
};
exports.canPlay = canPlay;
},{"./utils":1063}],1049:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr)))
        return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
                break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i['return'] != null)
                _i['return']();
        } finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr))
        return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var DailyMotion = function (_Component) {
    _inherits(DailyMotion, _Component);
    var _super = _createSuper(DailyMotion);
    function DailyMotion() {
        var _this;
        _classCallCheck(this, DailyMotion);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'onDurationChange', function () {
            var duration = _this.getDuration();
            _this.props.onDuration(duration);
        });
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('setMuted', true);
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('setMuted', false);
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (container) {
            _this.container = container;
        });
        return _this;
    }
    _createClass(DailyMotion, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                var _this$props = this.props, controls = _this$props.controls, config = _this$props.config, onError = _this$props.onError, playing = _this$props.playing;
                var _url$match = url.match(_patterns.MATCH_URL_DAILYMOTION), _url$match2 = _slicedToArray(_url$match, 2), id = _url$match2[1];
                if (this.player) {
                    this.player.load(id, {
                        start: (0, _utils.parseStartTime)(url),
                        autoplay: playing
                    });
                    return;
                }
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
                    return DM.player;
                }).then(function (DM) {
                    if (!_this2.container)
                        return;
                    var Player = DM.player;
                    _this2.player = new Player(_this2.container, {
                        width: '100%',
                        height: '100%',
                        video: id,
                        params: _objectSpread({
                            controls: controls,
                            autoplay: _this2.props.playing,
                            mute: _this2.props.muted,
                            start: (0, _utils.parseStartTime)(url),
                            origin: window.location.origin
                        }, config.params),
                        events: {
                            apiready: _this2.props.onReady,
                            seeked: function seeked() {
                                return _this2.props.onSeek(_this2.player.currentTime);
                            },
                            video_end: _this2.props.onEnded,
                            durationchange: _this2.onDurationChange,
                            pause: _this2.props.onPause,
                            playing: _this2.props.onPlay,
                            waiting: _this2.props.onBuffer,
                            error: function error(event) {
                                return onError(event);
                            }
                        }
                    });
                }, onError);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('seek', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.player.duration || null;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.player.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return this.player.bufferedTime;
            }
        },
        {
            key: 'render',
            value: function render() {
                var display = this.props.display;
                var style = {
                    width: '100%',
                    height: '100%',
                    display: display
                };
                return _react['default'].createElement('div', { style: style }, _react['default'].createElement('div', { ref: this.ref }));
            }
        }
    ]);
    return DailyMotion;
}(_react.Component);
exports['default'] = DailyMotion;
_defineProperty(DailyMotion, 'displayName', 'DailyMotion');
_defineProperty(DailyMotion, 'canPlay', _patterns.canPlay.dailymotion);
_defineProperty(DailyMotion, 'loopOnEnded', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1050:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _extends() {
    _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var PLAYER_ID_PREFIX = 'facebook-player-';
var Facebook = function (_Component) {
    _inherits(Facebook, _Component);
    var _super = _createSuper(Facebook);
    function Facebook() {
        var _this;
        _classCallCheck(this, Facebook);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'playerID', _this.props.config.playerId || ''.concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('mute');
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('unmute');
        });
        return _this;
    }
    _createClass(Facebook, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url, isReady) {
                var _this2 = this;
                if (isReady) {
                    (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
                        return FB.XFBML.parse();
                    });
                    return;
                }
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
                    FB.init({
                        appId: _this2.props.config.appId,
                        xfbml: true,
                        version: _this2.props.config.version
                    });
                    FB.Event.subscribe('xfbml.render', function (msg) {
                        _this2.props.onLoaded();
                    });
                    FB.Event.subscribe('xfbml.ready', function (msg) {
                        if (msg.type === 'video' && msg.id === _this2.playerID) {
                            _this2.player = msg.instance;
                            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
                            _this2.player.subscribe('paused', _this2.props.onPause);
                            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
                            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
                            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);
                            _this2.player.subscribe('error', _this2.props.onError);
                            if (_this2.props.muted) {
                                _this2.callPlayer('mute');
                            } else {
                                _this2.callPlayer('unmute');
                            }
                            _this2.props.onReady();
                            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
                        }
                    });
                });
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('seek', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.callPlayer('getDuration');
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.callPlayer('getCurrentPosition');
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var attributes = this.props.config.attributes;
                var style = {
                    width: '100%',
                    height: '100%'
                };
                return _react['default'].createElement('div', _extends({
                    style: style,
                    id: this.playerID,
                    className: 'fb-video',
                    'data-href': this.props.url,
                    'data-autoplay': this.props.playing ? 'true' : 'false',
                    'data-allowfullscreen': 'true',
                    'data-controls': this.props.controls ? 'true' : 'false'
                }, attributes));
            }
        }
    ]);
    return Facebook;
}(_react.Component);
exports['default'] = Facebook;
_defineProperty(Facebook, 'displayName', 'Facebook');
_defineProperty(Facebook, 'canPlay', _patterns.canPlay.facebook);
_defineProperty(Facebook, 'loopOnEnded', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1051:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _extends() {
    _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var HAS_NAVIGATOR = typeof navigator !== 'undefined';
var IS_IPAD_PRO = HAS_NAVIGATOR && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_IOS = HAS_NAVIGATOR && (/iPad|iPhone|iPod/.test(navigator.userAgent) || IS_IPAD_PRO) && !window.MSStream;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var FLV_SDK_URL = 'https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js';
var FLV_GLOBAL = 'flvjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
var MATCH_CLOUDFLARE_STREAM = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/;
var REPLACE_CLOUDFLARE_STREAM = 'https://videodelivery.net/{id}/manifest/video.m3u8';
var FilePlayer = function (_Component) {
    _inherits(FilePlayer, _Component);
    var _super = _createSuper(FilePlayer);
    function FilePlayer() {
        var _this;
        _classCallCheck(this, FilePlayer);
        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
            _args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(_args));
        _defineProperty(_assertThisInitialized(_this), 'onReady', function () {
            var _this$props;
            return (_this$props = _this.props).onReady.apply(_this$props, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onPlay', function () {
            var _this$props2;
            return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onBuffer', function () {
            var _this$props3;
            return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onBufferEnd', function () {
            var _this$props4;
            return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onPause', function () {
            var _this$props5;
            return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onEnded', function () {
            var _this$props6;
            return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onError', function () {
            var _this$props7;
            return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onEnablePIP', function () {
            var _this$props8;
            return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onDisablePIP', function (e) {
            var _this$props9 = _this.props, onDisablePIP = _this$props9.onDisablePIP, playing = _this$props9.playing;
            onDisablePIP(e);
            if (playing) {
                _this.play();
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'onPresentationModeChange', function (e) {
            if (_this.player && (0, _utils.supportsWebKitPresentationMode)(_this.player)) {
                var webkitPresentationMode = _this.player.webkitPresentationMode;
                if (webkitPresentationMode === 'picture-in-picture') {
                    _this.onEnablePIP(e);
                } else if (webkitPresentationMode === 'inline') {
                    _this.onDisablePIP(e);
                }
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'onSeek', function (e) {
            _this.props.onSeek(e.target.currentTime);
        });
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.player.muted = true;
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.player.muted = false;
        });
        _defineProperty(_assertThisInitialized(_this), 'renderSourceElement', function (source, index) {
            if (typeof source === 'string') {
                return _react['default'].createElement('source', {
                    key: index,
                    src: source
                });
            }
            return _react['default'].createElement('source', _extends({ key: index }, source));
        });
        _defineProperty(_assertThisInitialized(_this), 'renderTrack', function (track, index) {
            return _react['default'].createElement('track', _extends({ key: index }, track));
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (player) {
            if (_this.player) {
                _this.prevPlayer = _this.player;
            }
            _this.player = player;
        });
        return _this;
    }
    _createClass(FilePlayer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
                this.addListeners(this.player);
                if (IS_IOS) {
                    this.player.load();
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
                    this.removeListeners(this.prevPlayer, prevProps.url);
                    this.addListeners(this.player);
                }
                if (this.props.url !== prevProps.url && !(0, _utils.isMediaStream)(this.props.url)) {
                    this.player.srcObject = null;
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners(this.player);
                if (this.hls) {
                    this.hls.destroy();
                }
            }
        },
        {
            key: 'addListeners',
            value: function addListeners(player) {
                var _this$props10 = this.props, url = _this$props10.url, playsinline = _this$props10.playsinline;
                player.addEventListener('play', this.onPlay);
                player.addEventListener('waiting', this.onBuffer);
                player.addEventListener('playing', this.onBufferEnd);
                player.addEventListener('pause', this.onPause);
                player.addEventListener('seeked', this.onSeek);
                player.addEventListener('ended', this.onEnded);
                player.addEventListener('error', this.onError);
                player.addEventListener('enterpictureinpicture', this.onEnablePIP);
                player.addEventListener('leavepictureinpicture', this.onDisablePIP);
                player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
                if (!this.shouldUseHLS(url)) {
                    player.addEventListener('canplay', this.onReady);
                }
                if (playsinline) {
                    player.setAttribute('playsinline', '');
                    player.setAttribute('webkit-playsinline', '');
                    player.setAttribute('x5-playsinline', '');
                }
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners(player, url) {
                player.removeEventListener('canplay', this.onReady);
                player.removeEventListener('play', this.onPlay);
                player.removeEventListener('waiting', this.onBuffer);
                player.removeEventListener('playing', this.onBufferEnd);
                player.removeEventListener('pause', this.onPause);
                player.removeEventListener('seeked', this.onSeek);
                player.removeEventListener('ended', this.onEnded);
                player.removeEventListener('error', this.onError);
                player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
                player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
                player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
                if (!this.shouldUseHLS(url)) {
                    player.removeEventListener('canplay', this.onReady);
                }
            }
        },
        {
            key: 'shouldUseAudio',
            value: function shouldUseAudio(props) {
                if (props.config.forceVideo) {
                    return false;
                }
                if (props.config.attributes.poster) {
                    return false;
                }
                return _patterns.AUDIO_EXTENSIONS.test(props.url) || props.config.forceAudio;
            }
        },
        {
            key: 'shouldUseHLS',
            value: function shouldUseHLS(url) {
                if (this.props.config.forceHLS) {
                    return true;
                }
                if (IS_IOS) {
                    return false;
                }
                return _patterns.HLS_EXTENSIONS.test(url) || MATCH_CLOUDFLARE_STREAM.test(url);
            }
        },
        {
            key: 'shouldUseDASH',
            value: function shouldUseDASH(url) {
                return _patterns.DASH_EXTENSIONS.test(url) || this.props.config.forceDASH;
            }
        },
        {
            key: 'shouldUseFLV',
            value: function shouldUseFLV(url) {
                return _patterns.FLV_EXTENSIONS.test(url) || this.props.config.forceFLV;
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                var _this$props$config = this.props.config, hlsVersion = _this$props$config.hlsVersion, hlsOptions = _this$props$config.hlsOptions, dashVersion = _this$props$config.dashVersion, flvVersion = _this$props$config.flvVersion;
                if (this.hls) {
                    this.hls.destroy();
                }
                if (this.dash) {
                    this.dash.reset();
                }
                if (this.shouldUseHLS(url)) {
                    (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
                        _this2.hls = new Hls(hlsOptions);
                        _this2.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                            _this2.props.onReady();
                        });
                        _this2.hls.on(Hls.Events.ERROR, function (e, data) {
                            _this2.props.onError(e, data, _this2.hls, Hls);
                        });
                        if (MATCH_CLOUDFLARE_STREAM.test(url)) {
                            var id = url.match(MATCH_CLOUDFLARE_STREAM)[1];
                            _this2.hls.loadSource(REPLACE_CLOUDFLARE_STREAM.replace('{id}', id));
                        } else {
                            _this2.hls.loadSource(url);
                        }
                        _this2.hls.attachMedia(_this2.player);
                        _this2.props.onLoaded();
                    });
                }
                if (this.shouldUseDASH(url)) {
                    (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
                        _this2.dash = dashjs.MediaPlayer().create();
                        _this2.dash.initialize(_this2.player, url, _this2.props.playing);
                        _this2.dash.on('error', _this2.props.onError);
                        if (parseInt(dashVersion) < 3) {
                            _this2.dash.getDebug().setLogToBrowserConsole(false);
                        } else {
                            _this2.dash.updateSettings({ debug: { logLevel: dashjs.Debug.LOG_LEVEL_NONE } });
                        }
                        _this2.props.onLoaded();
                    });
                }
                if (this.shouldUseFLV(url)) {
                    (0, _utils.getSDK)(FLV_SDK_URL.replace('VERSION', flvVersion), FLV_GLOBAL).then(function (flvjs) {
                        _this2.flv = flvjs.createPlayer({
                            type: 'flv',
                            url: url
                        });
                        _this2.flv.attachMediaElement(_this2.player);
                        _this2.flv.load();
                        _this2.props.onLoaded();
                    });
                }
                if (url instanceof Array) {
                    this.player.load();
                } else if ((0, _utils.isMediaStream)(url)) {
                    try {
                        this.player.srcObject = url;
                    } catch (e) {
                        this.player.src = window.URL.createObjectURL(url);
                    }
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                var promise = this.player.play();
                if (promise) {
                    promise['catch'](this.props.onError);
                }
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.player.pause();
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.player.removeAttribute('src');
                if (this.dash) {
                    this.dash.reset();
                }
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.player.currentTime = seconds;
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.player.volume = fraction;
            }
        },
        {
            key: 'enablePIP',
            value: function enablePIP() {
                if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
                    this.player.requestPictureInPicture();
                } else if ((0, _utils.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
                    this.player.webkitSetPresentationMode('picture-in-picture');
                }
            }
        },
        {
            key: 'disablePIP',
            value: function disablePIP() {
                if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
                    document.exitPictureInPicture();
                } else if ((0, _utils.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'inline') {
                    this.player.webkitSetPresentationMode('inline');
                }
            }
        },
        {
            key: 'setPlaybackRate',
            value: function setPlaybackRate(rate) {
                this.player.playbackRate = rate;
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                if (!this.player)
                    return null;
                var _this$player = this.player, duration = _this$player.duration, seekable = _this$player.seekable;
                if (duration === Infinity && seekable.length > 0) {
                    return seekable.end(seekable.length - 1);
                }
                return duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                if (!this.player)
                    return null;
                return this.player.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                if (!this.player)
                    return null;
                var buffered = this.player.buffered;
                if (buffered.length === 0) {
                    return 0;
                }
                var end = buffered.end(buffered.length - 1);
                var duration = this.getDuration();
                if (end > duration) {
                    return duration;
                }
                return end;
            }
        },
        {
            key: 'getSource',
            value: function getSource(url) {
                var useHLS = this.shouldUseHLS(url);
                var useDASH = this.shouldUseDASH(url);
                var useFLV = this.shouldUseFLV(url);
                if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH || useFLV) {
                    return undefined;
                }
                if (MATCH_DROPBOX_URL.test(url)) {
                    return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
                }
                return url;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this$props11 = this.props, url = _this$props11.url, playing = _this$props11.playing, loop = _this$props11.loop, controls = _this$props11.controls, muted = _this$props11.muted, config = _this$props11.config, width = _this$props11.width, height = _this$props11.height;
                var useAudio = this.shouldUseAudio(this.props);
                var Element = useAudio ? 'audio' : 'video';
                var style = {
                    width: width === 'auto' ? width : '100%',
                    height: height === 'auto' ? height : '100%'
                };
                return _react['default'].createElement(Element, _extends({
                    ref: this.ref,
                    src: this.getSource(url),
                    style: style,
                    preload: 'auto',
                    autoPlay: playing || undefined,
                    controls: controls,
                    muted: muted,
                    loop: loop
                }, config.attributes), url instanceof Array && url.map(this.renderSourceElement), config.tracks.map(this.renderTrack));
            }
        }
    ]);
    return FilePlayer;
}(_react.Component);
exports['default'] = FilePlayer;
_defineProperty(FilePlayer, 'displayName', 'FilePlayer');
_defineProperty(FilePlayer, 'canPlay', _patterns.canPlay.file);
},{"../patterns":1048,"../utils":1063,"react":1107}],1052:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var Kaltura = function (_Component) {
    _inherits(Kaltura, _Component);
    var _super = _createSuper(Kaltura);
    function Kaltura() {
        var _this;
        _classCallCheck(this, Kaltura);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'duration', null);
        _defineProperty(_assertThisInitialized(_this), 'currentTime', null);
        _defineProperty(_assertThisInitialized(_this), 'secondsLoaded', null);
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('mute');
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('unmute');
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (iframe) {
            _this.iframe = iframe;
        });
        return _this;
    }
    _createClass(Kaltura, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
                    if (!_this2.iframe)
                        return;
                    _this2.player = new playerjs.Player(_this2.iframe);
                    _this2.player.on('ready', function () {
                        _this2.player.isReady = true;
                        _this2.player.on('play', _this2.props.onPlay);
                        _this2.player.on('pause', _this2.props.onPause);
                        _this2.player.on('seeked', _this2.props.onSeek);
                        _this2.player.on('ended', _this2.props.onEnded);
                        _this2.player.on('error', _this2.props.onError);
                        _this2.player.on('timeupdate', function (_ref) {
                            var duration = _ref.duration, seconds = _ref.seconds;
                            _this2.duration = duration;
                            _this2.currentTime = seconds;
                        });
                        _this2.player.on('buffered', function (_ref2) {
                            var percent = _ref2.percent;
                            if (_this2.duration) {
                                _this2.secondsLoaded = _this2.duration * percent;
                            }
                        });
                        _this2.player.setLoop(_this2.props.loop);
                        if (_this2.props.muted) {
                            _this2.player.mute();
                        }
                        setTimeout(function () {
                            _this2.props.onReady();
                        });
                    });
                }, this.props.onError);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('setCurrentTime', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction);
            }
        },
        {
            key: 'setLoop',
            value: function setLoop(loop) {
                this.callPlayer('setLoop', loop);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return this.secondsLoaded;
            }
        },
        {
            key: 'render',
            value: function render() {
                var style = {
                    width: '100%',
                    height: '100%'
                };
                return _react['default'].createElement('iframe', {
                    ref: this.ref,
                    src: this.props.url,
                    frameBorder: '0',
                    scrolling: 'no',
                    style: style,
                    allowFullScreen: true,
                    allow: 'encrypted-media',
                    referrerPolicy: 'no-referrer-when-downgrade'
                });
            }
        }
    ]);
    return Kaltura;
}(_react.Component);
exports['default'] = Kaltura;
_defineProperty(Kaltura, 'displayName', 'Kaltura');
_defineProperty(Kaltura, 'canPlay', _patterns.canPlay.kaltura);
},{"../patterns":1048,"../utils":1063,"react":1107}],1053:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var Mixcloud = function (_Component) {
    _inherits(Mixcloud, _Component);
    var _super = _createSuper(Mixcloud);
    function Mixcloud() {
        var _this;
        _classCallCheck(this, Mixcloud);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'duration', null);
        _defineProperty(_assertThisInitialized(_this), 'currentTime', null);
        _defineProperty(_assertThisInitialized(_this), 'secondsLoaded', null);
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (iframe) {
            _this.iframe = iframe;
        });
        return _this;
    }
    _createClass(Mixcloud, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
                    _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
                    _this2.player.ready.then(function () {
                        _this2.player.events.play.on(_this2.props.onPlay);
                        _this2.player.events.pause.on(_this2.props.onPause);
                        _this2.player.events.ended.on(_this2.props.onEnded);
                        _this2.player.events.error.on(_this2.props.error);
                        _this2.player.events.progress.on(function (seconds, duration) {
                            _this2.currentTime = seconds;
                            _this2.duration = duration;
                        });
                        _this2.props.onReady();
                    });
                }, this.props.onError);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('seek', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this$props = this.props, url = _this$props.url, config = _this$props.config;
                var id = url.match(_patterns.MATCH_URL_MIXCLOUD)[1];
                var style = {
                    width: '100%',
                    height: '100%'
                };
                var query = (0, _utils.queryString)(_objectSpread(_objectSpread({}, config.options), {}, { feed: '/'.concat(id, '/') }));
                return _react['default'].createElement('iframe', {
                    key: id,
                    ref: this.ref,
                    style: style,
                    src: 'https://www.mixcloud.com/widget/iframe/?'.concat(query),
                    frameBorder: '0'
                });
            }
        }
    ]);
    return Mixcloud;
}(_react.Component);
exports['default'] = Mixcloud;
_defineProperty(Mixcloud, 'displayName', 'Mixcloud');
_defineProperty(Mixcloud, 'canPlay', _patterns.canPlay.mixcloud);
_defineProperty(Mixcloud, 'loopOnEnded', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1054:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var SoundCloud = function (_Component) {
    _inherits(SoundCloud, _Component);
    var _super = _createSuper(SoundCloud);
    function SoundCloud() {
        var _this;
        _classCallCheck(this, SoundCloud);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'duration', null);
        _defineProperty(_assertThisInitialized(_this), 'currentTime', null);
        _defineProperty(_assertThisInitialized(_this), 'fractionLoaded', null);
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.setVolume(0);
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            if (_this.props.volume !== null) {
                _this.setVolume(_this.props.volume);
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (iframe) {
            _this.iframe = iframe;
        });
        return _this;
    }
    _createClass(SoundCloud, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url, isReady) {
                var _this2 = this;
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
                    if (!_this2.iframe)
                        return;
                    var _SC$Widget$Events = SC.Widget.Events, PLAY = _SC$Widget$Events.PLAY, PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS, PAUSE = _SC$Widget$Events.PAUSE, FINISH = _SC$Widget$Events.FINISH, ERROR = _SC$Widget$Events.ERROR;
                    if (!isReady) {
                        _this2.player = SC.Widget(_this2.iframe);
                        _this2.player.bind(PLAY, _this2.props.onPlay);
                        _this2.player.bind(PAUSE, function () {
                            var remaining = _this2.duration - _this2.currentTime;
                            if (remaining < 0.05) {
                                return;
                            }
                            _this2.props.onPause();
                        });
                        _this2.player.bind(PLAY_PROGRESS, function (e) {
                            _this2.currentTime = e.currentPosition / 1000;
                            _this2.fractionLoaded = e.loadedProgress;
                        });
                        _this2.player.bind(FINISH, function () {
                            return _this2.props.onEnded();
                        });
                        _this2.player.bind(ERROR, function (e) {
                            return _this2.props.onError(e);
                        });
                    }
                    _this2.player.load(url, _objectSpread(_objectSpread({}, _this2.props.config.options), {}, {
                        callback: function callback() {
                            _this2.player.getDuration(function (duration) {
                                _this2.duration = duration / 1000;
                                _this2.props.onReady();
                            });
                        }
                    }));
                });
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('seekTo', seconds * 1000);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction * 100);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return this.fractionLoaded * this.duration;
            }
        },
        {
            key: 'render',
            value: function render() {
                var display = this.props.display;
                var style = {
                    width: '100%',
                    height: '100%',
                    display: display
                };
                return _react['default'].createElement('iframe', {
                    ref: this.ref,
                    src: 'https://w.soundcloud.com/player/?url='.concat(encodeURIComponent(this.props.url)),
                    style: style,
                    frameBorder: 0,
                    allow: 'autoplay'
                });
            }
        }
    ]);
    return SoundCloud;
}(_react.Component);
exports['default'] = SoundCloud;
_defineProperty(SoundCloud, 'displayName', 'SoundCloud');
_defineProperty(SoundCloud, 'canPlay', _patterns.canPlay.soundcloud);
_defineProperty(SoundCloud, 'loopOnEnded', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1055:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var Streamable = function (_Component) {
    _inherits(Streamable, _Component);
    var _super = _createSuper(Streamable);
    function Streamable() {
        var _this;
        _classCallCheck(this, Streamable);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'duration', null);
        _defineProperty(_assertThisInitialized(_this), 'currentTime', null);
        _defineProperty(_assertThisInitialized(_this), 'secondsLoaded', null);
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('mute');
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('unmute');
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (iframe) {
            _this.iframe = iframe;
        });
        return _this;
    }
    _createClass(Streamable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
                    if (!_this2.iframe)
                        return;
                    _this2.player = new playerjs.Player(_this2.iframe);
                    _this2.player.setLoop(_this2.props.loop);
                    _this2.player.on('ready', _this2.props.onReady);
                    _this2.player.on('play', _this2.props.onPlay);
                    _this2.player.on('pause', _this2.props.onPause);
                    _this2.player.on('seeked', _this2.props.onSeek);
                    _this2.player.on('ended', _this2.props.onEnded);
                    _this2.player.on('error', _this2.props.onError);
                    _this2.player.on('timeupdate', function (_ref) {
                        var duration = _ref.duration, seconds = _ref.seconds;
                        _this2.duration = duration;
                        _this2.currentTime = seconds;
                    });
                    _this2.player.on('buffered', function (_ref2) {
                        var percent = _ref2.percent;
                        if (_this2.duration) {
                            _this2.secondsLoaded = _this2.duration * percent;
                        }
                    });
                    if (_this2.props.muted) {
                        _this2.player.mute();
                    }
                }, this.props.onError);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('setCurrentTime', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction * 100);
            }
        },
        {
            key: 'setLoop',
            value: function setLoop(loop) {
                this.callPlayer('setLoop', loop);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return this.secondsLoaded;
            }
        },
        {
            key: 'render',
            value: function render() {
                var id = this.props.url.match(_patterns.MATCH_URL_STREAMABLE)[1];
                var style = {
                    width: '100%',
                    height: '100%'
                };
                return _react['default'].createElement('iframe', {
                    ref: this.ref,
                    src: 'https://streamable.com/o/'.concat(id),
                    frameBorder: '0',
                    scrolling: 'no',
                    style: style,
                    allowFullScreen: true
                });
            }
        }
    ]);
    return Streamable;
}(_react.Component);
exports['default'] = Streamable;
_defineProperty(Streamable, 'displayName', 'Streamable');
_defineProperty(Streamable, 'canPlay', _patterns.canPlay.streamable);
},{"../patterns":1048,"../utils":1063,"react":1107}],1056:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var PLAYER_ID_PREFIX = 'twitch-player-';
var Twitch = function (_Component) {
    _inherits(Twitch, _Component);
    var _super = _createSuper(Twitch);
    function Twitch() {
        var _this;
        _classCallCheck(this, Twitch);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'playerID', _this.props.config.playerId || ''.concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('setMuted', true);
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('setMuted', false);
        });
        return _this;
    }
    _createClass(Twitch, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url, isReady) {
                var _this2 = this;
                var _this$props = this.props, playsinline = _this$props.playsinline, onError = _this$props.onError, config = _this$props.config, controls = _this$props.controls;
                var isChannel = _patterns.MATCH_URL_TWITCH_CHANNEL.test(url);
                var id = isChannel ? url.match(_patterns.MATCH_URL_TWITCH_CHANNEL)[1] : url.match(_patterns.MATCH_URL_TWITCH_VIDEO)[1];
                if (isReady) {
                    if (isChannel) {
                        this.player.setChannel(id);
                    } else {
                        this.player.setVideo('v' + id);
                    }
                    return;
                }
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
                    _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
                        video: isChannel ? '' : id,
                        channel: isChannel ? id : '',
                        height: '100%',
                        width: '100%',
                        playsinline: playsinline,
                        autoplay: _this2.props.playing,
                        muted: _this2.props.muted,
                        controls: isChannel ? true : controls,
                        time: (0, _utils.parseStartTime)(url)
                    }, config.options));
                    var _Twitch$Player = Twitch.Player, READY = _Twitch$Player.READY, PLAYING = _Twitch$Player.PLAYING, PAUSE = _Twitch$Player.PAUSE, ENDED = _Twitch$Player.ENDED, ONLINE = _Twitch$Player.ONLINE, OFFLINE = _Twitch$Player.OFFLINE;
                    _this2.player.addEventListener(READY, _this2.props.onReady);
                    _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
                    _this2.player.addEventListener(PAUSE, _this2.props.onPause);
                    _this2.player.addEventListener(ENDED, _this2.props.onEnded);
                    _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);
                    _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
                }, onError);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('seek', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.callPlayer('getDuration');
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.callPlayer('getCurrentTime');
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var style = {
                    width: '100%',
                    height: '100%'
                };
                return _react['default'].createElement('div', {
                    style: style,
                    id: this.playerID
                });
            }
        }
    ]);
    return Twitch;
}(_react.Component);
exports['default'] = Twitch;
_defineProperty(Twitch, 'displayName', 'Twitch');
_defineProperty(Twitch, 'canPlay', _patterns.canPlay.twitch);
_defineProperty(Twitch, 'loopOnEnded', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1057:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://play.vidyard.com/embed/v4.js';
var SDK_GLOBAL = 'VidyardV4';
var SDK_GLOBAL_READY = 'onVidyardAPI';
var Vidyard = function (_Component) {
    _inherits(Vidyard, _Component);
    var _super = _createSuper(Vidyard);
    function Vidyard() {
        var _this;
        _classCallCheck(this, Vidyard);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.setVolume(0);
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            if (_this.props.volume !== null) {
                _this.setVolume(_this.props.volume);
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (container) {
            _this.container = container;
        });
        return _this;
    }
    _createClass(Vidyard, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                var _this$props = this.props, playing = _this$props.playing, config = _this$props.config, onError = _this$props.onError, onDuration = _this$props.onDuration;
                var id = url && url.match(_patterns.MATCH_URL_VIDYARD)[1];
                if (this.player) {
                    this.stop();
                }
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (Vidyard) {
                    if (!_this2.container)
                        return;
                    Vidyard.api.addReadyListener(function (data, player) {
                        _this2.player = player;
                        _this2.player.on('ready', _this2.props.onReady);
                        _this2.player.on('play', _this2.props.onPlay);
                        _this2.player.on('pause', _this2.props.onPause);
                        _this2.player.on('seek', _this2.props.onSeek);
                        _this2.player.on('playerComplete', _this2.props.onEnded);
                    }, id);
                    Vidyard.api.renderPlayer(_objectSpread({
                        uuid: id,
                        container: _this2.container,
                        autoplay: playing ? 1 : 0
                    }, config.options));
                    Vidyard.api.getPlayerMetadata(id).then(function (meta) {
                        _this2.duration = meta.length_in_seconds;
                        onDuration(meta.length_in_seconds);
                    });
                }, onError);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
                window.VidyardV4.api.destroyPlayer(this.player);
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(amount) {
                this.callPlayer('seek', amount);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction);
            }
        },
        {
            key: 'setPlaybackRate',
            value: function setPlaybackRate(rate) {
                this.callPlayer('setPlaybackSpeed', rate);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.callPlayer('currentTime');
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var display = this.props.display;
                var style = {
                    width: '100%',
                    height: '100%',
                    display: display
                };
                return _react['default'].createElement('div', { style: style }, _react['default'].createElement('div', { ref: this.ref }));
            }
        }
    ]);
    return Vidyard;
}(_react.Component);
exports['default'] = Vidyard;
_defineProperty(Vidyard, 'displayName', 'Vidyard');
_defineProperty(Vidyard, 'canPlay', _patterns.canPlay.vidyard);
},{"../patterns":1048,"../utils":1063,"react":1107}],1058:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var Vimeo = function (_Component) {
    _inherits(Vimeo, _Component);
    var _super = _createSuper(Vimeo);
    function Vimeo() {
        var _this;
        _classCallCheck(this, Vimeo);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'duration', null);
        _defineProperty(_assertThisInitialized(_this), 'currentTime', null);
        _defineProperty(_assertThisInitialized(_this), 'secondsLoaded', null);
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.setVolume(0);
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            if (_this.props.volume !== null) {
                _this.setVolume(_this.props.volume);
            }
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (container) {
            _this.container = container;
        });
        return _this;
    }
    _createClass(Vimeo, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                this.duration = null;
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
                    if (!_this2.container)
                        return;
                    _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
                        url: url,
                        autoplay: _this2.props.playing,
                        muted: _this2.props.muted,
                        loop: _this2.props.loop,
                        playsinline: _this2.props.playsinline,
                        controls: _this2.props.controls
                    }, _this2.props.config.playerOptions));
                    _this2.player.ready().then(function () {
                        var iframe = _this2.container.querySelector('iframe');
                        iframe.style.width = '100%';
                        iframe.style.height = '100%';
                    })['catch'](_this2.props.onError);
                    _this2.player.on('loaded', function () {
                        _this2.props.onReady();
                        _this2.refreshDuration();
                    });
                    _this2.player.on('play', function () {
                        _this2.props.onPlay();
                        _this2.refreshDuration();
                    });
                    _this2.player.on('pause', _this2.props.onPause);
                    _this2.player.on('seeked', function (e) {
                        return _this2.props.onSeek(e.seconds);
                    });
                    _this2.player.on('ended', _this2.props.onEnded);
                    _this2.player.on('error', _this2.props.onError);
                    _this2.player.on('timeupdate', function (_ref) {
                        var seconds = _ref.seconds;
                        _this2.currentTime = seconds;
                    });
                    _this2.player.on('progress', function (_ref2) {
                        var seconds = _ref2.seconds;
                        _this2.secondsLoaded = seconds;
                    });
                    _this2.player.on('bufferstart', _this2.props.onBuffer);
                    _this2.player.on('bufferend', _this2.props.onBufferEnd);
                }, this.props.onError);
            }
        },
        {
            key: 'refreshDuration',
            value: function refreshDuration() {
                var _this3 = this;
                this.player.getDuration().then(function (duration) {
                    _this3.duration = duration;
                });
            }
        },
        {
            key: 'play',
            value: function play() {
                var promise = this.callPlayer('play');
                if (promise) {
                    promise['catch'](this.props.onError);
                }
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.callPlayer('unload');
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('setCurrentTime', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction);
            }
        },
        {
            key: 'setLoop',
            value: function setLoop(loop) {
                this.callPlayer('setLoop', loop);
            }
        },
        {
            key: 'setPlaybackRate',
            value: function setPlaybackRate(rate) {
                this.callPlayer('setPlaybackRate', rate);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.duration;
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.currentTime;
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return this.secondsLoaded;
            }
        },
        {
            key: 'render',
            value: function render() {
                var display = this.props.display;
                var style = {
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    display: display
                };
                return _react['default'].createElement('div', {
                    key: this.props.url,
                    ref: this.ref,
                    style: style
                });
            }
        }
    ]);
    return Vimeo;
}(_react.Component);
exports['default'] = Vimeo;
_defineProperty(Vimeo, 'displayName', 'Vimeo');
_defineProperty(Vimeo, 'canPlay', _patterns.canPlay.vimeo);
_defineProperty(Vimeo, 'forceLoad', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1059:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var PLAYER_ID_PREFIX = 'wistia-player-';
var Wistia = function (_Component) {
    _inherits(Wistia, _Component);
    var _super = _createSuper(Wistia);
    function Wistia() {
        var _this;
        _classCallCheck(this, Wistia);
        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
            _args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(_args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'playerID', _this.props.config.playerId || ''.concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));
        _defineProperty(_assertThisInitialized(_this), 'onPlay', function () {
            var _this$props;
            return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onPause', function () {
            var _this$props2;
            return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onSeek', function () {
            var _this$props3;
            return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'onEnded', function () {
            var _this$props4;
            return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('mute');
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('unmute');
        });
        return _this;
    }
    _createClass(Wistia, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'load',
            value: function load(url) {
                var _this2 = this;
                var _this$props5 = this.props, playing = _this$props5.playing, muted = _this$props5.muted, controls = _this$props5.controls, _onReady = _this$props5.onReady, config = _this$props5.config, onError = _this$props5.onError;
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Wistia) {
                    if (config.customControls) {
                        config.customControls.forEach(function (control) {
                            return Wistia.defineControl(control);
                        });
                    }
                    window._wq = window._wq || [];
                    window._wq.push({
                        id: _this2.playerID,
                        options: _objectSpread({
                            autoPlay: playing,
                            silentAutoPlay: 'allow',
                            muted: muted,
                            controlsVisibleOnLoad: controls,
                            fullscreenButton: controls,
                            playbar: controls,
                            playbackRateControl: controls,
                            qualityControl: controls,
                            volumeControl: controls,
                            settingsControl: controls,
                            smallPlayButton: controls
                        }, config.options),
                        onReady: function onReady(player) {
                            _this2.player = player;
                            _this2.unbind();
                            _this2.player.bind('play', _this2.onPlay);
                            _this2.player.bind('pause', _this2.onPause);
                            _this2.player.bind('seek', _this2.onSeek);
                            _this2.player.bind('end', _this2.onEnded);
                            _onReady();
                        }
                    });
                }, onError);
            }
        },
        {
            key: 'unbind',
            value: function unbind() {
                this.player.unbind('play', this.onPlay);
                this.player.unbind('pause', this.onPause);
                this.player.unbind('seek', this.onSeek);
                this.player.unbind('end', this.onEnded);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('play');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pause');
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.unbind();
                this.callPlayer('remove');
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(seconds) {
                this.callPlayer('time', seconds);
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('volume', fraction);
            }
        },
        {
            key: 'setPlaybackRate',
            value: function setPlaybackRate(rate) {
                this.callPlayer('playbackRate', rate);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.callPlayer('duration');
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.callPlayer('time');
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var url = this.props.url;
                var videoID = url && url.match(_patterns.MATCH_URL_WISTIA)[1];
                var className = 'wistia_embed wistia_async_'.concat(videoID);
                var style = {
                    width: '100%',
                    height: '100%'
                };
                return _react['default'].createElement('div', {
                    id: this.playerID,
                    key: videoID,
                    className: className,
                    style: style
                });
            }
        }
    ]);
    return Wistia;
}(_react.Component);
exports['default'] = Wistia;
_defineProperty(Wistia, 'displayName', 'Wistia');
_defineProperty(Wistia, 'canPlay', _patterns.canPlay.wistia);
_defineProperty(Wistia, 'loopOnEnded', true);
},{"../patterns":1048,"../utils":1063,"react":1107}],1060:[function(require,module,exports){
'use strict';
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
Object.defineProperty(exports, '__esModule', { value: true });
exports['default'] = void 0;
var _react = _interopRequireWildcard(require('react'));
var _utils = require('../utils');
var _patterns = require('../patterns');
function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function')
        return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || _typeof(obj) !== 'object' && typeof obj !== 'function') {
        return { 'default': obj };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj['default'] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr)))
        return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
                break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i['return'] != null)
                _i['return']();
        } finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr))
        return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
var NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';
var YouTube = function (_Component) {
    _inherits(YouTube, _Component);
    var _super = _createSuper(YouTube);
    function YouTube() {
        var _this;
        _classCallCheck(this, YouTube);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), 'callPlayer', _utils.callPlayer);
        _defineProperty(_assertThisInitialized(_this), 'parsePlaylist', function (url) {
            if (url instanceof Array) {
                return {
                    listType: 'playlist',
                    playlist: url.map(_this.getID).join(',')
                };
            }
            if (MATCH_PLAYLIST.test(url)) {
                var _url$match = url.match(MATCH_PLAYLIST), _url$match2 = _slicedToArray(_url$match, 2), playlistId = _url$match2[1];
                return {
                    listType: 'playlist',
                    list: playlistId.replace(/^UC/, 'UU')
                };
            }
            if (MATCH_USER_UPLOADS.test(url)) {
                var _url$match3 = url.match(MATCH_USER_UPLOADS), _url$match4 = _slicedToArray(_url$match3, 2), username = _url$match4[1];
                return {
                    listType: 'user_uploads',
                    list: username
                };
            }
            return {};
        });
        _defineProperty(_assertThisInitialized(_this), 'onStateChange', function (event) {
            var data = event.data;
            var _this$props = _this.props, onPlay = _this$props.onPlay, onPause = _this$props.onPause, onBuffer = _this$props.onBuffer, onBufferEnd = _this$props.onBufferEnd, onEnded = _this$props.onEnded, onReady = _this$props.onReady, loop = _this$props.loop, _this$props$config = _this$props.config, playerVars = _this$props$config.playerVars, onUnstarted = _this$props$config.onUnstarted;
            var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState, UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED, PLAYING = _window$SDK_GLOBAL$Pl.PLAYING, PAUSED = _window$SDK_GLOBAL$Pl.PAUSED, BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING, ENDED = _window$SDK_GLOBAL$Pl.ENDED, CUED = _window$SDK_GLOBAL$Pl.CUED;
            if (data === UNSTARTED)
                onUnstarted();
            if (data === PLAYING) {
                onPlay();
                onBufferEnd();
            }
            if (data === PAUSED)
                onPause();
            if (data === BUFFERING)
                onBuffer();
            if (data === ENDED) {
                var isPlaylist = !!_this.callPlayer('getPlaylist');
                if (loop && !isPlaylist) {
                    if (playerVars.start) {
                        _this.seekTo(playerVars.start);
                    } else {
                        _this.play();
                    }
                }
                onEnded();
            }
            if (data === CUED)
                onReady();
        });
        _defineProperty(_assertThisInitialized(_this), 'mute', function () {
            _this.callPlayer('mute');
        });
        _defineProperty(_assertThisInitialized(_this), 'unmute', function () {
            _this.callPlayer('unMute');
        });
        _defineProperty(_assertThisInitialized(_this), 'ref', function (container) {
            _this.container = container;
        });
        return _this;
    }
    _createClass(YouTube, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.onMount && this.props.onMount(this);
            }
        },
        {
            key: 'getID',
            value: function getID(url) {
                if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
                    return null;
                }
                return url.match(_patterns.MATCH_URL_YOUTUBE)[1];
            }
        },
        {
            key: 'load',
            value: function load(url, isReady) {
                var _this2 = this;
                var _this$props2 = this.props, playing = _this$props2.playing, muted = _this$props2.muted, playsinline = _this$props2.playsinline, controls = _this$props2.controls, loop = _this$props2.loop, config = _this$props2.config, _onError = _this$props2.onError;
                var playerVars = config.playerVars, embedOptions = config.embedOptions;
                var id = this.getID(url);
                if (isReady) {
                    if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
                        this.player.loadPlaylist(this.parsePlaylist(url));
                        return;
                    }
                    this.player.cueVideoById({
                        videoId: id,
                        startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
                        endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
                    });
                    return;
                }
                (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
                    return YT.loaded;
                }).then(function (YT) {
                    if (!_this2.container)
                        return;
                    _this2.player = new YT.Player(_this2.container, _objectSpread({
                        width: '100%',
                        height: '100%',
                        videoId: id,
                        playerVars: _objectSpread(_objectSpread({
                            autoplay: playing ? 1 : 0,
                            mute: muted ? 1 : 0,
                            controls: controls ? 1 : 0,
                            start: (0, _utils.parseStartTime)(url),
                            end: (0, _utils.parseEndTime)(url),
                            origin: window.location.origin,
                            playsinline: playsinline ? 1 : 0
                        }, _this2.parsePlaylist(url)), playerVars),
                        events: {
                            onReady: function onReady() {
                                if (loop) {
                                    _this2.player.setLoop(true);
                                }
                                _this2.props.onReady();
                            },
                            onStateChange: _this2.onStateChange,
                            onError: function onError(event) {
                                return _onError(event.data);
                            }
                        },
                        host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : undefined
                    }, embedOptions));
                }, _onError);
                if (embedOptions.events) {
                    console.warn('Using `embedOptions.events` will likely break things. Use ReactPlayer\u2019s callback props instead, eg onReady, onPlay, onPause');
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                this.callPlayer('playVideo');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.callPlayer('pauseVideo');
            }
        },
        {
            key: 'stop',
            value: function stop() {
                if (!document.body.contains(this.callPlayer('getIframe')))
                    return;
                this.callPlayer('stopVideo');
            }
        },
        {
            key: 'seekTo',
            value: function seekTo(amount) {
                this.callPlayer('seekTo', amount);
                if (!this.props.playing) {
                    this.pause();
                }
            }
        },
        {
            key: 'setVolume',
            value: function setVolume(fraction) {
                this.callPlayer('setVolume', fraction * 100);
            }
        },
        {
            key: 'setPlaybackRate',
            value: function setPlaybackRate(rate) {
                this.callPlayer('setPlaybackRate', rate);
            }
        },
        {
            key: 'setLoop',
            value: function setLoop(loop) {
                this.callPlayer('setLoop', loop);
            }
        },
        {
            key: 'getDuration',
            value: function getDuration() {
                return this.callPlayer('getDuration');
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                return this.callPlayer('getCurrentTime');
            }
        },
        {
            key: 'getSecondsLoaded',
            value: function getSecondsLoaded() {
                return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
            }
        },
        {
            key: 'render',
            value: function render() {
                var display = this.props.display;
                var style = {
                    width: '100%',
                    height: '100%',
                    display: display
                };
                return _react['default'].createElement('div', { style: style }, _react['default'].createElement('div', { ref: this.ref }));
            }
        }
    ]);
    return YouTube;
}(_react.Component);
exports['default'] = YouTube;
_defineProperty(YouTube, 'displayName', 'YouTube');
_defineProperty(YouTube, 'canPlay', _patterns.canPlay.youtube);
},{"../patterns":1048,"../utils":1063,"react":1107}],1061:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _utils = require("../utils");

var _patterns = require("../patterns");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = [{
  key: 'youtube',
  name: 'YouTube',
  canPlay: _patterns.canPlay.youtube,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./YouTube'));
    });
  })
}, {
  key: 'soundcloud',
  name: 'SoundCloud',
  canPlay: _patterns.canPlay.soundcloud,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./SoundCloud'));
    });
  })
}, {
  key: 'vimeo',
  name: 'Vimeo',
  canPlay: _patterns.canPlay.vimeo,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Vimeo'));
    });
  })
}, {
  key: 'facebook',
  name: 'Facebook',
  canPlay: _patterns.canPlay.facebook,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Facebook'));
    });
  })
}, {
  key: 'streamable',
  name: 'Streamable',
  canPlay: _patterns.canPlay.streamable,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Streamable'));
    });
  })
}, {
  key: 'wistia',
  name: 'Wistia',
  canPlay: _patterns.canPlay.wistia,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Wistia'));
    });
  })
}, {
  key: 'twitch',
  name: 'Twitch',
  canPlay: _patterns.canPlay.twitch,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Twitch'));
    });
  })
}, {
  key: 'dailymotion',
  name: 'DailyMotion',
  canPlay: _patterns.canPlay.dailymotion,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./DailyMotion'));
    });
  })
}, {
  key: 'mixcloud',
  name: 'Mixcloud',
  canPlay: _patterns.canPlay.mixcloud,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Mixcloud'));
    });
  })
}, {
  key: 'vidyard',
  name: 'Vidyard',
  canPlay: _patterns.canPlay.vidyard,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Vidyard'));
    });
  })
}, {
  key: 'kaltura',
  name: 'Kaltura',
  canPlay: _patterns.canPlay.kaltura,
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./Kaltura'));
    });
  })
}, {
  key: 'file',
  name: 'FilePlayer',
  canPlay: _patterns.canPlay.file,
  canEnablePIP: function canEnablePIP(url) {
    return _patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, _utils.supportsWebKitPresentationMode)()) && !_patterns.AUDIO_EXTENSIONS.test(url);
  },
  lazyPlayer: /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./FilePlayer'));
    });
  })
}];
exports["default"] = _default;
},{"../patterns":1048,"../utils":1063,"./DailyMotion":1049,"./Facebook":1050,"./FilePlayer":1051,"./Kaltura":1052,"./Mixcloud":1053,"./SoundCloud":1054,"./Streamable":1055,"./Twitch":1056,"./Vidyard":1057,"./Vimeo":1058,"./Wistia":1059,"./YouTube":1060,"react":1107}],1062:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;

var noop = function noop() {};

var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: 'div',
  previewTabIndex: 0,
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      }
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: '0.14.16',
      dashVersion: '3.1.3',
      flvVersion: '1.5.0'
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};
exports.defaultProps = defaultProps;
},{"prop-types":896}],1063:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isMediaStream = isMediaStream;
exports.isBlobUrl = isBlobUrl;
exports.supportsWebKitPresentationMode = supportsWebKitPresentationMode;

var _loadScript = _interopRequireDefault(require("load-script"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return undefined;
  }

  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
}

function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }

  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }

  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }

  return null;
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
  var existingGlobal = getGlobal(sdkGlobal);

  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
}

function getConfig(props, defaultProps) {
  return (0, _deepmerge["default"])(defaultProps.config, props.config);
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

function isBlobUrl(url) {
  return /^blob:/.test(url);
}

function supportsWebKitPresentationMode() {
  var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('video');
  // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function
  var notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && notMobile;
}
},{"deepmerge":1064,"load-script":678}],1064:[function(require,module,exports){
arguments[4][549][0].apply(exports,arguments)
},{"dup":549}],1065:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = exports.ReactReduxContext = void 0;

var _react = _interopRequireDefault(require("react"));

var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);

exports.ReactReduxContext = ReactReduxContext;

if ("production" !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

var _default = ReactReduxContext;
exports["default"] = _default;
},{"@babel/runtime/helpers/interopRequireDefault":319,"react":1107}],1066:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Context = require("./Context");

var _Subscription = _interopRequireDefault(require("../utils/Subscription"));

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0, _react.useMemo)(function () {
    var subscription = new _Subscription["default"](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0, _react.useMemo)(function () {
    return store.getState();
  }, [store]);
  (0, _react.useEffect)(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || _Context.ReactReduxContext;
  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if ("production" !== 'production') {
  Provider.propTypes = {
    store: _propTypes["default"].shape({
      subscribe: _propTypes["default"].func.isRequired,
      dispatch: _propTypes["default"].func.isRequired,
      getState: _propTypes["default"].func.isRequired
    }),
    context: _propTypes["default"].object,
    children: _propTypes["default"].any
  };
}

var _default = Provider;
exports["default"] = _default;
},{"../utils/Subscription":1080,"./Context":1065,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/interopRequireWildcard":320,"prop-types":896,"react":1107}],1067:[function(require,module,exports){
"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = connectAdvanced;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _react = _interopRequireWildcard(require("react"));

var _reactIs = require("react-is");

var _Subscription = _interopRequireDefault(require("../utils/Subscription"));

var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");

var _Context = require("./Context");

// Define some constant arrays just to avoid re-creating these
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if ("production" !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if ("production" !== 'production' && !(0, _reactIs.isValidElementType)(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);
    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });
    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0, _react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["reactReduxForwardedRef"]);
        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0, _react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if ("production" !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0, _react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0, _react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new _Subscription["default"](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0, _react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0, _extends2["default"])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0, _react.useRef)();
      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0, _react.useRef)();
      var renderIsScheduled = (0, _react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0, _react.useMemo)(function () {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0, _react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
    }

    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
  };
}
},{"../utils/Subscription":1080,"../utils/useIsomorphicLayoutEffect":1085,"./Context":1065,"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/interopRequireWildcard":320,"@babel/runtime/helpers/objectWithoutPropertiesLoose":322,"hoist-non-react-statics":1088,"react":1107,"react-is":1028}],1068:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createConnect = createConnect;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _connectAdvanced = _interopRequireDefault(require("../components/connectAdvanced"));

var _shallowEqual = _interopRequireDefault(require("../utils/shallowEqual"));

var _mapDispatchToProps = _interopRequireDefault(require("./mapDispatchToProps"));

var _mapStateToProps = _interopRequireDefault(require("./mapStateToProps"));

var _mergeProps = _interopRequireDefault(require("./mergeProps"));

var _selectorFactory = _interopRequireDefault(require("./selectorFactory"));

/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */
function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0, _extends2["default"])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}

var _default = /*#__PURE__*/createConnect();

exports["default"] = _default;
},{"../components/connectAdvanced":1067,"../utils/shallowEqual":1084,"./mapDispatchToProps":1069,"./mapStateToProps":1070,"./mergeProps":1071,"./selectorFactory":1072,"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/objectWithoutPropertiesLoose":322}],1069:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
exports["default"] = void 0;

var _redux = require("redux");

var _wrapMapToProps = require("./wrapMapToProps");

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
  }) : undefined;
}

var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
exports["default"] = _default;
},{"./wrapMapToProps":1074,"redux":1131}],1070:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
exports["default"] = void 0;

var _wrapMapToProps = require("./wrapMapToProps");

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
    return {};
  }) : undefined;
}

var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
exports["default"] = _default;
},{"./wrapMapToProps":1074}],1071:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.defaultMergeProps = defaultMergeProps;
exports.wrapMergePropsFunc = wrapMergePropsFunc;
exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _verifyPlainObject = _interopRequireDefault(require("../utils/verifyPlainObject"));

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if ("production" !== 'production') (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
exports["default"] = _default;
},{"../utils/verifyPlainObject":1086,"@babel/runtime/helpers/extends":315,"@babel/runtime/helpers/interopRequireDefault":319}],1072:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
exports["default"] = finalPropsSelectorFactory;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _verifySubselectors = _interopRequireDefault(require("./verifySubselectors"));

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.


function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if ("production" !== 'production') {
    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
},{"./verifySubselectors":1073,"@babel/runtime/helpers/interopRequireDefault":319,"@babel/runtime/helpers/objectWithoutPropertiesLoose":322}],1073:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = verifySubselectors;

var _warning = _interopRequireDefault(require("../utils/warning"));

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
},{"../utils/warning":1087,"@babel/runtime/helpers/interopRequireDefault":319}],1074:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
exports.getDependsOnOwnProps = getDependsOnOwnProps;
exports.wrapMapToPropsFunc = wrapMapToPropsFunc;

var _verifyPlainObject = _interopRequireDefault(require("../utils/verifyPlainObject"));

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..


function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//


function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if ("production" !== 'production') (0, _verifyPlainObject["default"])(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}
},{"../utils/verifyPlainObject":1086,"@babel/runtime/helpers/interopRequireDefault":319}],1075:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createDispatchHook = createDispatchHook;
exports.useDispatch = void 0;

var _Context = require("../components/Context");

var _useStore = require("./useStore");

/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */
function createDispatchHook(context) {
  if (context === void 0) {
    context = _Context.ReactReduxContext;
  }

  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */


var useDispatch = /*#__PURE__*/createDispatchHook();
exports.useDispatch = useDispatch;
},{"../components/Context":1065,"./useStore":1078}],1076:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.useReduxContext = useReduxContext;

var _react = require("react");

var _Context = require("../components/Context");

/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */
function useReduxContext() {
  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);

  if ("production" !== 'production' && !contextValue) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}
},{"../components/Context":1065,"react":1107}],1077:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createSelectorHook = createSelectorHook;
exports.useSelector = void 0;

var _react = require("react");

var _useReduxContext2 = require("./useReduxContext");

var _Subscription = _interopRequireDefault(require("../utils/Subscription"));

var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");

var _Context = require("../components/Context");

var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0, _react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0, _react.useMemo)(function () {
    return new _Subscription["default"](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0, _react.useRef)();
  var latestSelector = (0, _react.useRef)();
  var latestStoreState = (0, _react.useRef)();
  var latestSelectedState = (0, _react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(storeState);
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = _Context.ReactReduxContext;
  }

  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
    return (0, _react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if ("production" !== 'production' && !selector) {
      throw new Error("You must pass a selector to useSelector");
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0, _react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */


var useSelector = /*#__PURE__*/createSelectorHook();
exports.useSelector = useSelector;
},{"../components/Context":1065,"../utils/Subscription":1080,"../utils/useIsomorphicLayoutEffect":1085,"./useReduxContext":1076,"@babel/runtime/helpers/interopRequireDefault":319,"react":1107}],1078:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createStoreHook = createStoreHook;
exports.useStore = void 0;

var _react = require("react");

var _Context = require("../components/Context");

var _useReduxContext2 = require("./useReduxContext");

/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */
function createStoreHook(context) {
  if (context === void 0) {
    context = _Context.ReactReduxContext;
  }

  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
    return (0, _react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */


var useStore = /*#__PURE__*/createStoreHook();
exports.useStore = useStore;
},{"../components/Context":1065,"./useReduxContext":1076,"react":1107}],1079:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Provider = _interopRequireDefault(require("./components/Provider"));

exports.Provider = _Provider["default"];

var _connectAdvanced = _interopRequireDefault(require("./components/connectAdvanced"));

exports.connectAdvanced = _connectAdvanced["default"];

var _Context = require("./components/Context");

exports.ReactReduxContext = _Context.ReactReduxContext;

var _connect = _interopRequireDefault(require("./connect/connect"));

exports.connect = _connect["default"];

var _useDispatch = require("./hooks/useDispatch");

exports.useDispatch = _useDispatch.useDispatch;
exports.createDispatchHook = _useDispatch.createDispatchHook;

var _useSelector = require("./hooks/useSelector");

exports.useSelector = _useSelector.useSelector;
exports.createSelectorHook = _useSelector.createSelectorHook;

var _useStore = require("./hooks/useStore");

exports.useStore = _useStore.useStore;
exports.createStoreHook = _useStore.createStoreHook;

var _batch = require("./utils/batch");

var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");

exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;

var _shallowEqual = _interopRequireDefault(require("./utils/shallowEqual"));

exports.shallowEqual = _shallowEqual["default"];
(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);
},{"./components/Context":1065,"./components/Provider":1066,"./components/connectAdvanced":1067,"./connect/connect":1068,"./hooks/useDispatch":1075,"./hooks/useSelector":1077,"./hooks/useStore":1078,"./utils/batch":1081,"./utils/reactBatchedUpdates":1083,"./utils/shallowEqual":1084,"@babel/runtime/helpers/interopRequireDefault":319}],1080:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _batch = require("./batch");

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = (0, _batch.getBatch)();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();

exports["default"] = Subscription;
},{"./batch":1081}],1081:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getBatch = exports.setBatch = void 0;

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings


exports.setBatch = setBatch;

var getBatch = function getBatch() {
  return batch;
};

exports.getBatch = getBatch;
},{}],1082:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports["default"] = isPlainObject;

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
},{}],1083:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.unstable_batchedUpdates = void 0;

var _reactDom = require("react-dom");

exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;
},{"react-dom":1016}],1084:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports["default"] = shallowEqual;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
},{}],1085:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.useIsomorphicLayoutEffect = void 0;

var _react = require("react");

// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;
},{"react":1107}],1086:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = verifyPlainObject;

var _isPlainObject = _interopRequireDefault(require("./isPlainObject"));

var _warning = _interopRequireDefault(require("./warning"));

function verifyPlainObject(value, displayName, methodName) {
  if (!(0, _isPlainObject["default"])(value)) {
    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
},{"./isPlainObject":1082,"./warning":1087,"@babel/runtime/helpers/interopRequireDefault":319}],1087:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports["default"] = warning;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}
},{}],1088:[function(require,module,exports){
'use strict';

var reactIs = require('react-is');

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;

},{"react-is":1028}],1089:[function(require,module,exports){
Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/*
The MIT License (MIT)

Copyright (c) 2015 instructure-react

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
var uncheckedIcon = React.createElement('svg', {
  viewBox: "-2 -5 14 20",
  height: "100%",
  width: "100%",
  style: {
    position: "absolute",
    top: 0
  }
}, React.createElement('path', {
  d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
  fill: "#fff",
  fillRule: "evenodd"
}));
var checkedIcon = React.createElement('svg', {
  height: "100%",
  width: "100%",
  viewBox: "-2 -5 17 21",
  style: {
    position: "absolute",
    top: 0
  }
}, React.createElement('path', {
  d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
  fill: "#fff",
  fillRule: "evenodd"
}));

function createBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var relativePos = (pos - uncheckedPos) / (checkedPos - uncheckedPos);

  if (relativePos === 0) {
    return offColor;
  }

  if (relativePos === 1) {
    return onColor;
  }

  var newColor = "#";

  for (var i = 1; i < 6; i += 2) {
    var offComponent = parseInt(offColor.substr(i, 2), 16);
    var onComponent = parseInt(onColor.substr(i, 2), 16);
    var weightedValue = Math.round((1 - relativePos) * offComponent + relativePos * onComponent);
    var newComponent = weightedValue.toString(16);

    if (newComponent.length === 1) {
      newComponent = "0" + newComponent;
    }

    newColor += newComponent;
  }

  return newColor;
}

function convertShorthandColor(color) {
  if (color.length === 7) {
    return color;
  }

  var sixDigitColor = "#";

  for (var i = 1; i < 4; i += 1) {
    sixDigitColor += color[i] + color[i];
  }

  return sixDigitColor;
}

function getBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var sixDigitOffColor = convertShorthandColor(offColor);
  var sixDigitOnColor = convertShorthandColor(onColor);
  return createBackgroundColor(pos, checkedPos, uncheckedPos, sixDigitOffColor, sixDigitOnColor);
}

// Make sure color props are strings that start with "#" since other ways to write colors are not supported.
var hexColorPropType = function (props, propName, componentName) {
  var prop = props[propName];

  if (typeof prop !== "string" || prop[0] !== "#" || prop.length !== 4 && prop.length !== 7) {
    return new Error("Invalid prop '" + propName + "' supplied to '" + componentName + "'. '" + propName + "' has to be either a 3-digit or 6-digit hex-color string. Valid examples: '#abc', '#123456'");
  }

  return null;
};

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];

  return target;
}

var ReactSwitch = /*@__PURE__*/function (Component) {
  function ReactSwitch(props) {
    Component.call(this, props);
    var height = props.height;
    var width = props.width;
    var handleDiameter = props.handleDiameter;
    var checked = props.checked;
    this.$handleDiameter = handleDiameter || height - 2;
    this.$checkedPos = Math.max(width - height, width - (height + this.$handleDiameter) / 2);
    this.$uncheckedPos = Math.max(0, (height - this.$handleDiameter) / 2);
    this.state = {
      $pos: checked ? this.$checkedPos : this.$uncheckedPos
    };
    this.$lastDragAt = 0;
    this.$lastKeyUpAt = 0;
    this.$onMouseDown = this.$onMouseDown.bind(this);
    this.$onMouseMove = this.$onMouseMove.bind(this);
    this.$onMouseUp = this.$onMouseUp.bind(this);
    this.$onTouchStart = this.$onTouchStart.bind(this);
    this.$onTouchMove = this.$onTouchMove.bind(this);
    this.$onTouchEnd = this.$onTouchEnd.bind(this);
    this.$onClick = this.$onClick.bind(this);
    this.$onInputChange = this.$onInputChange.bind(this);
    this.$onKeyUp = this.$onKeyUp.bind(this);
    this.$setHasOutline = this.$setHasOutline.bind(this);
    this.$unsetHasOutline = this.$unsetHasOutline.bind(this);
    this.$getInputRef = this.$getInputRef.bind(this);
  }

  if (Component) ReactSwitch.__proto__ = Component;
  ReactSwitch.prototype = Object.create(Component && Component.prototype);
  ReactSwitch.prototype.constructor = ReactSwitch;

  ReactSwitch.prototype.componentDidMount = function componentDidMount() {
    this.$isMounted = true;
  };

  ReactSwitch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.checked === this.props.checked) {
      return;
    }

    var $pos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
    this.setState({
      $pos: $pos
    });
  };

  ReactSwitch.prototype.componentWillUnmount = function componentWillUnmount() {
    this.$isMounted = false;
  };

  ReactSwitch.prototype.$onDragStart = function $onDragStart(clientX) {
    this.$inputRef.focus();
    this.setState({
      $startX: clientX,
      $hasOutline: true,
      $dragStartingTime: Date.now()
    });
  };

  ReactSwitch.prototype.$onDrag = function $onDrag(clientX) {
    var ref = this.state;
    var $startX = ref.$startX;
    var $isDragging = ref.$isDragging;
    var $pos = ref.$pos;
    var ref$1 = this.props;
    var checked = ref$1.checked;
    var startPos = checked ? this.$checkedPos : this.$uncheckedPos;
    var mousePos = startPos + clientX - $startX; // We need this check to fix a windows glitch where onDrag is triggered onMouseDown in some cases

    if (!$isDragging && clientX !== $startX) {
      this.setState({
        $isDragging: true
      });
    }

    var newPos = Math.min(this.$checkedPos, Math.max(this.$uncheckedPos, mousePos)); // Prevent unnecessary rerenders

    if (newPos !== $pos) {
      this.setState({
        $pos: newPos
      });
    }
  };

  ReactSwitch.prototype.$onDragStop = function $onDragStop(event) {
    var ref = this.state;
    var $pos = ref.$pos;
    var $isDragging = ref.$isDragging;
    var $dragStartingTime = ref.$dragStartingTime;
    var ref$1 = this.props;
    var checked = ref$1.checked;
    var halfwayCheckpoint = (this.$checkedPos + this.$uncheckedPos) / 2;
    /*
      Set position state back to the previous position even if user drags the switch with intention to change the state.
      This is to prevent the switch from getting stuck in the middle if the event isn't handled in the onChange callback.
    */

    var prevPos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
    this.setState({
      $pos: prevPos
    }); // Act as if the user clicked the handle if they didn't drag it _or_ the dragged it for less than 250ms

    var timeSinceStart = Date.now() - $dragStartingTime;
    var isSimulatedClick = !$isDragging || timeSinceStart < 250; // Handle when the user has dragged the switch more than halfway from either side

    var isDraggedHalfway = checked && $pos <= halfwayCheckpoint || !checked && $pos >= halfwayCheckpoint;

    if (isSimulatedClick || isDraggedHalfway) {
      this.$onChange(event);
    }

    if (this.$isMounted) {
      this.setState({
        $isDragging: false,
        $hasOutline: false
      });
    }

    this.$lastDragAt = Date.now();
  };

  ReactSwitch.prototype.$onMouseDown = function $onMouseDown(event) {
    event.preventDefault(); // Ignore right click and scroll

    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }

    this.$onDragStart(event.clientX);
    window.addEventListener("mousemove", this.$onMouseMove);
    window.addEventListener("mouseup", this.$onMouseUp);
  };

  ReactSwitch.prototype.$onMouseMove = function $onMouseMove(event) {
    event.preventDefault();
    this.$onDrag(event.clientX);
  };

  ReactSwitch.prototype.$onMouseUp = function $onMouseUp(event) {
    this.$onDragStop(event);
    window.removeEventListener("mousemove", this.$onMouseMove);
    window.removeEventListener("mouseup", this.$onMouseUp);
  };

  ReactSwitch.prototype.$onTouchStart = function $onTouchStart(event) {
    this.$checkedStateFromDragging = null;
    this.$onDragStart(event.touches[0].clientX);
  };

  ReactSwitch.prototype.$onTouchMove = function $onTouchMove(event) {
    this.$onDrag(event.touches[0].clientX);
  };

  ReactSwitch.prototype.$onTouchEnd = function $onTouchEnd(event) {
    event.preventDefault();
    this.$onDragStop(event);
  };

  ReactSwitch.prototype.$onInputChange = function $onInputChange(event) {
    // This condition is unfortunately needed in some browsers where the input's change event might get triggered
    // right after the dragstop event is triggered (occurs when dropping over a label element)
    if (Date.now() - this.$lastDragAt > 50) {
      this.$onChange(event); // Prevent clicking label, but not key activation from setting outline to true - yes, this is absurd

      if (Date.now() - this.$lastKeyUpAt > 50) {
        if (this.$isMounted) {
          this.setState({
            $hasOutline: false
          });
        }
      }
    }
  };

  ReactSwitch.prototype.$onKeyUp = function $onKeyUp() {
    this.$lastKeyUpAt = Date.now();
  };

  ReactSwitch.prototype.$setHasOutline = function $setHasOutline() {
    this.setState({
      $hasOutline: true
    });
  };

  ReactSwitch.prototype.$unsetHasOutline = function $unsetHasOutline() {
    this.setState({
      $hasOutline: false
    });
  };

  ReactSwitch.prototype.$getInputRef = function $getInputRef(el) {
    this.$inputRef = el;
  };

  ReactSwitch.prototype.$onClick = function $onClick(event) {
    event.preventDefault();
    this.$inputRef.focus();
    this.$onChange(event);

    if (this.$isMounted) {
      this.setState({
        $hasOutline: false
      });
    }
  };

  ReactSwitch.prototype.$onChange = function $onChange(event) {
    var ref = this.props;
    var checked = ref.checked;
    var onChange = ref.onChange;
    var id = ref.id;
    onChange(!checked, event, id);
  };

  ReactSwitch.prototype.render = function render() {
    var ref = this.props;
    var checked = ref.checked;
    var disabled = ref.disabled;
    var className = ref.className;
    var offColor = ref.offColor;
    var onColor = ref.onColor;
    var offHandleColor = ref.offHandleColor;
    var onHandleColor = ref.onHandleColor;
    var checkedIcon = ref.checkedIcon;
    var uncheckedIcon = ref.uncheckedIcon;
    var checkedHandleIcon = ref.checkedHandleIcon;
    var uncheckedHandleIcon = ref.uncheckedHandleIcon;
    var boxShadow = ref.boxShadow;
    var activeBoxShadow = ref.activeBoxShadow;
    var height = ref.height;
    var width = ref.width;
    var borderRadius = ref.borderRadius;
    var handleDiameter = ref.handleDiameter;
    var rest$1 = objectWithoutProperties(ref, ["checked", "disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "checkedHandleIcon", "uncheckedHandleIcon", "boxShadow", "activeBoxShadow", "height", "width", "borderRadius", "handleDiameter"]);
    var rest = rest$1;
    var ref$1 = this.state;
    var $pos = ref$1.$pos;
    var $isDragging = ref$1.$isDragging;
    var $hasOutline = ref$1.$hasOutline;
    var rootStyle = {
      position: "relative",
      display: "inline-block",
      textAlign: "left",
      opacity: disabled ? 0.5 : 1,
      direction: "ltr",
      borderRadius: height / 2,
      WebkitTransition: "opacity 0.25s",
      MozTransition: "opacity 0.25s",
      transition: "opacity 0.25s",
      touchAction: "none",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none"
    };
    var backgroundStyle = {
      height: height,
      width: width,
      margin: Math.max(0, (this.$handleDiameter - height) / 2),
      position: "relative",
      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offColor, onColor),
      borderRadius: typeof borderRadius === "number" ? borderRadius : height / 2,
      cursor: disabled ? "default" : "pointer",
      WebkitTransition: $isDragging ? null : "background 0.25s",
      MozTransition: $isDragging ? null : "background 0.25s",
      transition: $isDragging ? null : "background 0.25s"
    };
    var checkedIconStyle = {
      height: height,
      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
      position: "relative",
      opacity: ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var uncheckedIconStyle = {
      height: height,
      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
      position: "absolute",
      opacity: 1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
      right: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var handleStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offHandleColor, onHandleColor),
      display: "inline-block",
      cursor: disabled ? "default" : "pointer",
      borderRadius: typeof borderRadius === "number" ? borderRadius - 1 : "50%",
      position: "absolute",
      transform: "translateX(" + $pos + "px)",
      top: Math.max(0, (height - this.$handleDiameter) / 2),
      outline: 0,
      boxShadow: $hasOutline ? activeBoxShadow : boxShadow,
      border: 0,
      WebkitTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
      MozTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
      transition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
    };
    var uncheckedHandleIconStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      opacity: Math.max((1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
      position: "absolute",
      left: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var checkedHandleIconStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      opacity: Math.max((($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
      position: "absolute",
      left: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var inputStyle = {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: 1
    };
    return React.createElement('div', {
      className: className,
      style: rootStyle
    }, React.createElement('div', {
      className: "react-switch-bg",
      style: backgroundStyle,
      onClick: disabled ? null : this.$onClick,
      onMouseDown: function (e) {
        return e.preventDefault();
      }
    }, checkedIcon && React.createElement('div', {
      style: checkedIconStyle
    }, checkedIcon), uncheckedIcon && React.createElement('div', {
      style: uncheckedIconStyle
    }, uncheckedIcon)), React.createElement('div', {
      className: "react-switch-handle",
      style: handleStyle,
      onClick: function (e) {
        return e.preventDefault();
      },
      onMouseDown: disabled ? null : this.$onMouseDown,
      onTouchStart: disabled ? null : this.$onTouchStart,
      onTouchMove: disabled ? null : this.$onTouchMove,
      onTouchEnd: disabled ? null : this.$onTouchEnd,
      onTouchCancel: disabled ? null : this.$unsetHasOutline
    }, uncheckedHandleIcon && React.createElement('div', {
      style: uncheckedHandleIconStyle
    }, uncheckedHandleIcon), checkedHandleIcon && React.createElement('div', {
      style: checkedHandleIconStyle
    }, checkedHandleIcon)), React.createElement('input', _extends({}, {
      type: "checkbox",
      role: "switch",
      'aria-checked': checked,
      checked: checked,
      disabled: disabled,
      style: inputStyle
    }, rest, {
      ref: this.$getInputRef,
      onFocus: this.$setHasOutline,
      onBlur: this.$unsetHasOutline,
      onKeyUp: this.$onKeyUp,
      onChange: this.$onInputChange
    })));
  };

  return ReactSwitch;
}(React.Component);

ReactSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  offColor: hexColorPropType,
  onColor: hexColorPropType,
  offHandleColor: hexColorPropType,
  onHandleColor: hexColorPropType,
  handleDiameter: PropTypes.number,
  uncheckedIcon: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  checkedIcon: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  boxShadow: PropTypes.string,
  borderRadius: PropTypes.number,
  activeBoxShadow: PropTypes.string,
  uncheckedHandleIcon: PropTypes.element,
  checkedHandleIcon: PropTypes.element,
  height: PropTypes.number,
  width: PropTypes.number,
  id: PropTypes.string,
  className: PropTypes.string
};
ReactSwitch.defaultProps = {
  disabled: false,
  offColor: "#888",
  onColor: "#080",
  offHandleColor: "#fff",
  onHandleColor: "#fff",
  uncheckedIcon: uncheckedIcon,
  checkedIcon: checkedIcon,
  boxShadow: null,
  activeBoxShadow: "0 0 2px 3px #3bf",
  height: 28,
  width: 56
};

exports.default = ReactSwitch;

},{"prop-types":896,"react":1107}],1090:[function(require,module,exports){
Object.defineProperty(exports,"__esModule",{value:!0});var t=require("react");function i(){return(i=Object.assign||function(t){for(var i=1;i<arguments.length;i++){var s=arguments[i];for(var n in s)Object.prototype.hasOwnProperty.call(s,n)&&(t[n]=s[n])}return t}).apply(this,arguments)}var s=t.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},t.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),n=t.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},t.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function o(t){if(7===t.length)return t;for(var i="#",s=1;s<4;s+=1)i+=t[s]+t[s];return i}function h(t,i,s,n,h){return function(t,i,s,n,o){var h=(t-s)/(i-s);if(0===h)return n;if(1===h)return o;for(var e="#",a=1;a<6;a+=2){var r=parseInt(n.substr(a,2),16),l=parseInt(o.substr(a,2),16),u=Math.round((1-h)*r+h*l).toString(16);1===u.length&&(u="0"+u),e+=u}return e}(t,i,s,o(n),o(h))}var e=function(s){function n(t){s.call(this,t);var i=t.height,n=t.width,o=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(n-i,n-(i+this.t)/2),this.o=Math.max(0,(i-this.t)/2),this.state={h:o?this.i:this.o},this.l=0,this.u=0,this.p=this.p.bind(this),this.v=this.v.bind(this),this.g=this.g.bind(this),this.k=this.k.bind(this),this.M=this.M.bind(this),this.m=this.m.bind(this),this.T=this.T.bind(this),this.$=this.$.bind(this),this.C=this.C.bind(this),this.D=this.D.bind(this),this.O=this.O.bind(this),this.S=this.S.bind(this)}return s&&(n.__proto__=s),(n.prototype=Object.create(s&&s.prototype)).constructor=n,n.prototype.componentDidMount=function(){this.W=!0},n.prototype.componentDidUpdate=function(t){t.checked!==this.props.checked&&this.setState({h:this.props.checked?this.i:this.o})},n.prototype.componentWillUnmount=function(){this.W=!1},n.prototype.I=function(t){this.H.focus(),this.setState({R:t,j:!0,B:Date.now()})},n.prototype.L=function(t){var i=this.state,s=i.R,n=i.h,o=(this.props.checked?this.i:this.o)+t-s;i.N||t===s||this.setState({N:!0});var h=Math.min(this.i,Math.max(this.o,o));h!==n&&this.setState({h:h})},n.prototype.U=function(t){var i=this.state,s=i.h,n=i.N,o=i.B,h=this.props.checked,e=(this.i+this.o)/2;this.setState({h:this.props.checked?this.i:this.o});var a=Date.now()-o;(!n||a<250||(h&&s<=e||!h&&s>=e))&&this.A(t),this.W&&this.setState({N:!1,j:!1}),this.l=Date.now()},n.prototype.p=function(t){t.preventDefault(),"number"==typeof t.button&&0!==t.button||(this.I(t.clientX),window.addEventListener("mousemove",this.v),window.addEventListener("mouseup",this.g))},n.prototype.v=function(t){t.preventDefault(),this.L(t.clientX)},n.prototype.g=function(t){this.U(t),window.removeEventListener("mousemove",this.v),window.removeEventListener("mouseup",this.g)},n.prototype.k=function(t){this.X=null,this.I(t.touches[0].clientX)},n.prototype.M=function(t){this.L(t.touches[0].clientX)},n.prototype.m=function(t){t.preventDefault(),this.U(t)},n.prototype.$=function(t){Date.now()-this.l>50&&(this.A(t),Date.now()-this.u>50&&this.W&&this.setState({j:!1}))},n.prototype.C=function(){this.u=Date.now()},n.prototype.D=function(){this.setState({j:!0})},n.prototype.O=function(){this.setState({j:!1})},n.prototype.S=function(t){this.H=t},n.prototype.T=function(t){t.preventDefault(),this.H.focus(),this.A(t),this.W&&this.setState({j:!1})},n.prototype.A=function(t){var i=this.props;(0,i.onChange)(!i.checked,t,i.id)},n.prototype.render=function(){var s=this.props,n=s.checked,o=s.disabled,e=s.className,a=s.offColor,r=s.onColor,l=s.offHandleColor,u=s.onHandleColor,c=s.checkedIcon,d=s.uncheckedIcon,f=s.checkedHandleIcon,p=s.uncheckedHandleIcon,b=s.boxShadow,v=s.activeBoxShadow,g=s.height,y=s.width,w=s.borderRadius,k=function(t,i){var s={};for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&-1===i.indexOf(n)&&(s[n]=t[n]);return s}(s,["checked","disabled","className","offColor","onColor","offHandleColor","onHandleColor","checkedIcon","uncheckedIcon","checkedHandleIcon","uncheckedHandleIcon","boxShadow","activeBoxShadow","height","width","borderRadius","handleDiameter"]),M=this.state,m=M.h,T=M.N,x=M.j,$={position:"relative",display:"inline-block",textAlign:"left",opacity:o?.5:1,direction:"ltr",borderRadius:g/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},C={height:g,width:y,margin:Math.max(0,(this.t-g)/2),position:"relative",background:h(m,this.i,this.o,a,r),borderRadius:"number"==typeof w?w:g/2,cursor:o?"default":"pointer",WebkitTransition:T?null:"background 0.25s",MozTransition:T?null:"background 0.25s",transition:T?null:"background 0.25s"},D={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"relative",opacity:(m-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},O={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"absolute",opacity:1-(m-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},S={height:this.t,width:this.t,background:h(m,this.i,this.o,l,u),display:"inline-block",cursor:o?"default":"pointer",borderRadius:"number"==typeof w?w-1:"50%",position:"absolute",transform:"translateX("+m+"px)",top:Math.max(0,(g-this.t)/2),outline:0,boxShadow:x?v:b,border:0,WebkitTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"},W={height:this.t,width:this.t,opacity:Math.max(2*(1-(m-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},z={height:this.t,width:this.t,opacity:Math.max(2*((m-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"};return t.createElement("div",{className:e,style:$},t.createElement("div",{className:"react-switch-bg",style:C,onClick:o?null:this.T,onMouseDown:function(t){return t.preventDefault()}},c&&t.createElement("div",{style:D},c),d&&t.createElement("div",{style:O},d)),t.createElement("div",{className:"react-switch-handle",style:S,onClick:function(t){return t.preventDefault()},onMouseDown:o?null:this.p,onTouchStart:o?null:this.k,onTouchMove:o?null:this.M,onTouchEnd:o?null:this.m,onTouchCancel:o?null:this.O},p&&t.createElement("div",{style:W},p),f&&t.createElement("div",{style:z},f)),t.createElement("input",i({},{type:"checkbox",role:"switch","aria-checked":n,checked:n,disabled:o,style:{border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1}},k,{ref:this.S,onFocus:this.D,onBlur:this.O,onKeyUp:this.C,onChange:this.$})))},n}(t.Component);e.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:s,checkedIcon:n,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},exports.default=e;

},{"react":1107}],1091:[function(require,module,exports){
if ("production" === "production") {
  module.exports = require("./dist/react-switch.min.js");
} else {
  module.exports = require("./dist/react-switch.dev.js");
}

},{"./dist/react-switch.dev.js":1089,"./dist/react-switch.min.js":1090}],1092:[function(require,module,exports){
'use strict';
function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var uuid = require('uuid');
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
var CONSTANT = {
    GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
    }
};
var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    var event;
    if (typeof window.CustomEvent === 'function') {
        event = new window.CustomEvent(eventName, { detail: opts });
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function staticMethods(target) {
    target.hide = function (target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, { target: target });
    };
    target.rebuild = function () {
        dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
    };
    target.show = function (target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, { target: target });
    };
    target.prototype.globalRebuild = function () {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function (event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.showTooltip({ currentTarget: hasTarget && event.detail.target }, true);
        }
    };
    target.prototype.globalHide = function (event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
        }
    };
}
function windowListener(target) {
    target.prototype.bindWindowEvents = function (resizeHide) {
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        if (resizeHide) {
            window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('resize', this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function () {
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
    };
    target.prototype.onWindowResize = function () {
        if (!this.mount)
            return;
        this.hideTooltip();
    };
}
var checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute('currentItem');
    if (!isCapture)
        e.stopPropagation();
    if (show && currentItem === 'true') {
        if (!dataEventOff)
            this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for (var i = 0; i < targetArray.length; i++) {
        if (currentTarget !== targetArray[i]) {
            targetArray[i].setAttribute('currentItem', 'false');
        } else {
            targetArray[i].setAttribute('currentItem', 'true');
        }
    }
};
var customListeners = {
    id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else {
            Object.defineProperty(target, this.id, {
                configurable: true,
                value: _defineProperty({}, event, listener)
            });
        }
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) {
            return map[event];
        }
    }
};
function customEvent(target) {
    target.prototype.isCustomEvent = function (ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
    };
    target.prototype.customBindListener = function (ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function (event) {
            ele.removeEventListener(event, customListeners.get(ele, event));
            var customListener = checkStatus.bind(_this, dataEventOff);
            customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) {
            dataEventOff.split(' ').forEach(function (event) {
                ele.removeEventListener(event, _this.hideTooltip);
                ele.addEventListener(event, _this.hideTooltip, false);
            });
        }
    };
    target.prototype.customUnbindListener = function (ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, customListeners.get(ele, event));
        if (dataEventOff)
            ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
function isCapture(target) {
    target.prototype.isCapture = function (currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
    };
}
function getEffect(target) {
    target.prototype.getEffect = function (currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
    };
}
var makeProxy = function makeProxy(e) {
    var proxy = {};
    for (var key in e) {
        if (typeof e[key] === 'function') {
            proxy[key] = e[key].bind(e);
        } else {
            proxy[key] = e[key];
        }
    }
    return proxy;
};
var bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = e.target.getAttribute('data-tip') || null;
    var forId = e.target.getAttribute('data-for') || null;
    var target = e.target;
    if (this.isCustomEvent(target) && !customEvent) {
        return;
    }
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function (target) {
        var event = target.getAttribute(dataAttribute);
        if (event)
            event.split(' ').forEach(function (event) {
                return events[event] = true;
            });
    });
    return events;
};
var getBody = function getBody() {
    return document.getElementsByTagName('body')[0];
};
function bodyMode(target) {
    target.prototype.isBodyMode = function () {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function (targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = getBody();
        var customEvents = findCustomEvents(targetArray, 'data-event');
        var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
        if (event != null)
            customEvents[event] = true;
        if (eventOff != null)
            customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function (event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function (event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = bodyListener.bind(this, this.updateTooltip, { respectEffect: true });
            listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
        }
        for (var _event in customEvents) {
            listeners[_event] = bodyListener.bind(this, function (e) {
                var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
                checkStatus.call(_this, targetEventOff, e);
            }, { customEvent: true });
        }
        for (var _event2 in customEventsOff) {
            listeners[_event2] = bodyListener.bind(this, this.hideTooltip, { customEvent: true });
        }
        for (var _event3 in listeners) {
            body.addEventListener(_event3, listeners[_event3]);
        }
    };
    target.prototype.unbindBodyListener = function (body) {
        body = body || getBody();
        var listeners = this.bodyModeListeners;
        for (var event in listeners) {
            body.removeEventListener(event, listeners[event]);
        }
    };
}
var getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function trackRemoval(target) {
    target.prototype.bindRemovalTracker = function () {
        var _this = this;
        var MutationObserver = getMutationObserverClass();
        if (MutationObserver == null)
            return;
        var observer = new MutationObserver(function (mutations) {
            for (var m1 = 0; m1 < mutations.length; m1++) {
                var mutation = mutations[m1];
                for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function () {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
function getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        'top',
        'bottom',
        'left',
        'right'
    ];
    var insideList = [];
    for (var i = 0; i < 4; i++) {
        var p = placesList[i];
        if (inside(p)) {
            insideList.push(p);
        }
    }
    var isNewState = false;
    var newPlace;
    var shouldUpdatePlace = desiredPlace !== place;
    if (inside(desiredPlace) && shouldUpdatePlace) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) {
        return {
            isNewState: true,
            newState: { place: newPlace }
        };
    }
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === 'float') {
        return {
            mouseX: e.clientX,
            mouseY: e.clientY
        };
    }
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12;
    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
var calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') {
        offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    }
    for (var key in offset) {
        if (key === 'top') {
            extraOffsetY -= parseInt(offset[key], 10);
        } else if (key === 'bottom') {
            extraOffsetY += parseInt(offset[key], 10);
        } else if (key === 'left') {
            extraOffsetX -= parseInt(offset[key], 10);
        } else if (key === 'right') {
            extraOffsetX += parseInt(offset[key], 10);
        }
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
var getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while (currentParent) {
        var computedStyle = window.getComputedStyle(currentParent);
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform')
            break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
function getTipContent(tip, children, getContent, multiline) {
    if (children)
        return children;
    if (getContent !== undefined && getContent !== null)
        return getContent;
    if (getContent === null)
        return null;
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === 'false' || !regexp.test(tip)) {
        return tip;
    }
    return tip.split(regexp).map(function (d, i) {
        return React.createElement('span', {
            key: i,
            className: 'multi-line'
        }, d);
    });
}
function parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function (prop) {
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function (prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
function nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) {
        return Array.prototype.slice.call(nodeList);
    }
    return new Array(length).fill().map(function (index) {
        return nodeList[index];
    });
}
function generateUUID() {
    return 't' + uuid.v4();
}
var baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
var defaultColors = {
    dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
    },
    success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
    },
    warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
    },
    error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
    },
    info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
    },
    light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
    }
};
function getDefaultPopupColors(type) {
    return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
}
function generateTooltipStyle(uuid, customColors, type, hasBorder) {
    return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
}
function generateStyle(uuid, colors) {
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    return '\n  \t.'.concat(uuid, ' {\n\t    color: ').concat(textColor, ';\n\t    background: ').concat(backgroundColor, ';\n\t    border: 1px solid ').concat(borderColor, ';\n  \t}\n\n  \t.').concat(uuid, '.place-top {\n        margin-top: -10px;\n    }\n    .').concat(uuid, '.place-top::before {\n        border-top: 8px solid ').concat(borderColor, ';\n    }\n    .').concat(uuid, '.place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ').concat(arrowColor, ';\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .').concat(uuid, '.place-bottom {\n        margin-top: 10px;\n    }\n    .').concat(uuid, '.place-bottom::before {\n        border-bottom: 8px solid ').concat(borderColor, ';\n    }\n    .').concat(uuid, '.place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ').concat(arrowColor, ';\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .').concat(uuid, '.place-left {\n        margin-left: -10px;\n    }\n    .').concat(uuid, '.place-left::before {\n        border-left: 8px solid ').concat(borderColor, ';\n    }\n    .').concat(uuid, '.place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ').concat(arrowColor, ';\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .').concat(uuid, '.place-right {\n        margin-left: 10px;\n    }\n    .').concat(uuid, '.place-right::before {\n        border-right: 8px solid ').concat(borderColor, ';\n    }\n    .').concat(uuid, '.place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ').concat(arrowColor, ';\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ');
}
function getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = getDefaultPopupColors(type);
    if (textColor) {
        colors.text = textColor;
    }
    if (backgroundColor) {
        colors.background = backgroundColor;
    }
    if (hasBorder) {
        if (borderColor) {
            colors.border = borderColor;
        } else {
            colors.border = type === 'light' ? 'black' : 'white';
        }
    }
    if (arrowColor) {
        colors.arrow = arrowColor;
    }
    return colors;
}
var _class, _class2, _temp;
var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 = function (_React$Component) {
    _inherits(ReactTooltip, _React$Component);
    _createClass(ReactTooltip, null, [{
            key: 'propTypes',
            get: function get() {
                return {
                    uuid: PropTypes.string,
                    children: PropTypes.any,
                    place: PropTypes.string,
                    type: PropTypes.string,
                    effect: PropTypes.string,
                    offset: PropTypes.object,
                    multiline: PropTypes.bool,
                    border: PropTypes.bool,
                    textColor: PropTypes.string,
                    backgroundColor: PropTypes.string,
                    borderColor: PropTypes.string,
                    arrowColor: PropTypes.string,
                    insecure: PropTypes.bool,
                    'class': PropTypes.string,
                    className: PropTypes.string,
                    id: PropTypes.string,
                    html: PropTypes.bool,
                    delayHide: PropTypes.number,
                    delayUpdate: PropTypes.number,
                    delayShow: PropTypes.number,
                    event: PropTypes.string,
                    eventOff: PropTypes.string,
                    isCapture: PropTypes.bool,
                    globalEventOff: PropTypes.string,
                    getContent: PropTypes.any,
                    afterShow: PropTypes.func,
                    afterHide: PropTypes.func,
                    overridePosition: PropTypes.func,
                    disable: PropTypes.bool,
                    scrollHide: PropTypes.bool,
                    resizeHide: PropTypes.bool,
                    wrapper: PropTypes.string,
                    bodyMode: PropTypes.bool,
                    possibleCustomEvents: PropTypes.string,
                    possibleCustomEventsOff: PropTypes.string,
                    clickable: PropTypes.bool
                };
            }
        }]);
    function ReactTooltip(props) {
        var _this;
        _classCallCheck(this, ReactTooltip);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
        _this.state = {
            uuid: props.uuid || generateUUID(),
            place: props.place || 'top',
            desiredPlace: props.place || 'top',
            type: 'dark',
            effect: 'float',
            show: false,
            border: false,
            customColors: {},
            offset: {},
            extraClass: '',
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            currentTarget: null,
            ariaProps: parseAria(props),
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || '',
            possibleCustomEventsOff: props.possibleCustomEventsOff || '',
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            'showTooltip',
            'updateTooltip',
            'hideTooltip',
            'hideTooltipOnScroll',
            'getTooltipContent',
            'globalRebuild',
            'globalShow',
            'globalHide',
            'onWindowResize',
            'mouseOnToolTip'
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    _createClass(ReactTooltip, [
        {
            key: 'bind',
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function (method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
                this.bindListener();
                this.bindWindowEvents(resizeHide);
                this.injectStyles();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: 'injectStyles',
            value: function injectStyles() {
                var id = this.props.id;
                var targetArray = this.getTargetArray(id);
                var domRoots = [];
                targetArray.forEach(function (target) {
                    var parentNode = target.parentNode;
                    while (parentNode.parentNode && !parentNode.host) {
                        parentNode = parentNode.parentNode;
                    }
                    var head = parentNode.querySelector('head');
                    domRoots.push(head || parentNode);
                });
                if (domRoots.length) {
                    var style = document.createElement('style');
                    style.textContent = baseCss;
                    style.setAttribute('data-react-tooltip', 'true');
                    domRoots.filter(function (item, idx, src) {
                        return src.indexOf(item) === idx;
                    }).forEach(function (domRoot) {
                        if (!domRoot.querySelector('style[data-react-tooltip]')) {
                            domRoot.appendChild(style);
                        }
                    });
                }
            }
        },
        {
            key: 'mouseOnToolTip',
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    if (!this.tooltipRef.matches) {
                        if (this.tooltipRef.msMatchesSelector) {
                            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        } else {
                            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                        }
                    }
                    return this.tooltipRef.matches(':hover');
                }
                return false;
            }
        },
        {
            key: 'getTargetArray',
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) {
                    selector = '[data-tip]:not([data-for])';
                } else {
                    var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                    selector = '[data-tip][data-for="'.concat(escaped, '"]');
                }
                nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
                    return element.shadowRoot;
                }).forEach(function (element) {
                    targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: 'bindListener',
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function (target) {
                    if (target.getAttribute('currentItem') === null) {
                        target.setAttribute('currentItem', 'false');
                    }
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customUnbindListener(target);
                    }
                });
                if (this.isBodyMode()) {
                    this.bindBodyListener(targetArray);
                } else {
                    targetArray.forEach(function (target) {
                        var isCaptureMode = _this3.isCapture(target);
                        var effect = _this3.getEffect(target);
                        if (_this3.isCustomEvent(target)) {
                            _this3.customBindListener(target);
                            return;
                        }
                        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
                        if (effect === 'float') {
                            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
                        }
                        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
                    });
                }
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                this.bindRemovalTracker();
            }
        },
        {
            key: 'unbindListener',
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) {
                    this.unbindBodyListener();
                } else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function (target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target))
                            _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff)
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: 'unbindBasicListener',
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
                target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
                target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: 'getTooltipContent',
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) {
                        content = getContent[0] && getContent[0](this.state.originTooltip);
                    } else {
                        content = getContent(this.state.originTooltip);
                    }
                }
                return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: 'isEmptyTip',
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
            }
        },
        {
            key: 'showTooltip',
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) {
                    return;
                }
                if (isGlobalCall) {
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function (ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement)
                        return;
                }
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute('data-tip');
                var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                var scrollHide = true;
                if (e.currentTarget.getAttribute('data-scroll-hide')) {
                    scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
                } else if (this.props.scrollHide != null) {
                    scrollHide = this.props.scrollHide;
                }
                var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
                var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
                var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) {
                    result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                }
                var place = result.isNewState ? result.newState.place : desiredPlace;
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
                var self = this;
                var updateState = function updateState() {
                    self.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute('data-type') || self.props.type || 'dark',
                        customColors: {
                            text: target.getAttribute('data-text-color') || self.props.textColor || null,
                            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
                            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
                            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
                        },
                        effect: effect,
                        offset: offset,
                        html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
                        delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
                        delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
                        delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
                        border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
                        extraClass: target.getAttribute('data-class') || self.props['class'] || self.props.className || '',
                        disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
                        currentTarget: target
                    }, function () {
                        if (scrollHide) {
                            self.addScrollListener(self.state.currentTarget);
                        }
                        self.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) {
                            self.intervalUpdateContent = setInterval(function () {
                                if (self.mount) {
                                    var _getContent = self.props.getContent;
                                    var placeholder = getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                                    var isEmptyTip = self.isEmptyTip(placeholder);
                                    self.setState({ isEmptyTip: isEmptyTip });
                                    self.updatePosition();
                                }
                            }, getContent[1]);
                        }
                    });
                };
                if (reshowDelay) {
                    this.delayReshow = setTimeout(updateState, reshowDelay);
                } else {
                    updateState();
                }
            }
        },
        {
            key: 'updateTooltip',
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var delayTime = parseInt(delayShow, 10);
                var eventTarget = e.currentTarget || e.target;
                if (this.mouseOnToolTip()) {
                    return;
                }
                if (this.isEmptyTip(placeholder) || disable) {
                    return;
                }
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function () {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) {
                                afterShow(e);
                            }
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayShow) {
                    this.delayShowLoop = setTimeout(updateState, delayTime);
                } else {
                    updateState();
                }
            }
        },
        {
            key: 'listenForTooltipExit',
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
                }
            }
        },
        {
            key: 'removeListenerForTooltipExit',
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
                }
            }
        },
        {
            key: 'hideTooltip',
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { isScroll: false };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount)
                    return;
                if (this.isEmptyTip(placeholder) || disable)
                    return;
                if (hasTarget) {
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function (ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show)
                        return;
                }
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({ show: false }, function () {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) {
                            afterHide(e);
                        }
                    });
                };
                this.clearTimer();
                if (delayHide) {
                    this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                } else {
                    resetState();
                }
            }
        },
        {
            key: 'hideTooltipOnScroll',
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, { isScroll: true });
            }
        },
        {
            key: 'addScrollListener',
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: 'removeScrollListener',
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: 'updatePosition',
            value: function updatePosition() {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) {
                    result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                }
                if (result.isNewState) {
                    return this.setState(result.newState, function () {
                        _this7.updatePosition();
                    });
                }
                node.style.left = result.position.left + 'px';
                node.style.top = result.position.top + 'px';
            }
        },
        {
            key: 'clearTimer',
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: 'hasCustomColors',
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function (color) {
                    return color !== 'border' && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors['border']);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
                var tooltipClass = '__react_component_tooltip' + ' '.concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + ' place-'.concat(this.state.place) + ' type-'.concat(this.hasCustomColors() ? 'custom' : this.state.type) + (this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
                    Wrapper = ReactTooltip.defaultProps.wrapper;
                }
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(' ');
                if (html) {
                    var htmlContent = ''.concat(content, '\n<style>').concat(style, '</style>');
                    return React.createElement(Wrapper, _extends({
                        className: ''.concat(wrapperClassName),
                        id: this.props.id,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        'data-id': 'tooltip',
                        dangerouslySetInnerHTML: { __html: htmlContent }
                    }));
                } else {
                    return React.createElement(Wrapper, _extends({
                        className: ''.concat(wrapperClassName),
                        id: this.props.id
                    }, ariaProps, {
                        ref: function ref(_ref2) {
                            return _this9.tooltipRef = _ref2;
                        },
                        'data-id': 'tooltip'
                    }), React.createElement('style', { dangerouslySetInnerHTML: { __html: style } }), content);
                }
            }
        }
    ], [{
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function (props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) {
                    return null;
                }
                return _objectSpread2({}, prevState, { ariaProps: newAriaProps });
            }
        }]);
    return ReactTooltip;
}(React.Component), _defineProperty(_class2, 'defaultProps', {
    insecure: true,
    resizeHide: true,
    wrapper: 'div',
    clickable: false
}), _defineProperty(_class2, 'supportedWrappers', [
    'div',
    'span'
]), _defineProperty(_class2, 'displayName', 'ReactTooltip'), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
module.exports = ReactTooltip;
},{"prop-types":896,"react":1107,"uuid":1094}],1093:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

var _default = bytesToUuid;
exports.default = _default;
module.exports = exports.default;
},{}],1094:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "v1", {
  enumerable: true,
  get: function () {
    return _v.default;
  }
});
Object.defineProperty(exports, "v3", {
  enumerable: true,
  get: function () {
    return _v2.default;
  }
});
Object.defineProperty(exports, "v4", {
  enumerable: true,
  get: function () {
    return _v3.default;
  }
});
Object.defineProperty(exports, "v5", {
  enumerable: true,
  get: function () {
    return _v4.default;
  }
});

var _v = _interopRequireDefault(require("./v1.js"));

var _v2 = _interopRequireDefault(require("./v3.js"));

var _v3 = _interopRequireDefault(require("./v4.js"));

var _v4 = _interopRequireDefault(require("./v5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./v1.js":1098,"./v3.js":1099,"./v4.js":1101,"./v5.js":1102}],1095:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var i;
  var x;
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';
  var hex;

  for (i = 0; i < length32; i += 8) {
    x = input[i >> 5] >>> i % 32 & 0xff;
    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;

  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }

  var length8 = input.length * 8;

  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports.default = _default;
module.exports = exports.default;
},{}],1096:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}

module.exports = exports.default;
},{}],1097:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Array(msg.length);

    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var i = 0; i < N; i++) {
    M[i] = new Array(16);

    for (var j = 0; j < 16; j++) {
      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var i = 0; i < N; i++) {
    var W = new Array(80);

    for (var t = 0; t < 16; t++) W[t] = M[i][t];

    for (var t = 16; t < 80; t++) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var t = 0; t < 80; t++) {
      var s = Math.floor(t / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports.default = _default;
module.exports = exports.default;
},{}],1098:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _bytesToUuid = _interopRequireDefault(require("./bytesToUuid.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : (0, _bytesToUuid.default)(b);
}

var _default = v1;
exports.default = _default;
module.exports = exports.default;
},{"./bytesToUuid.js":1093,"./rng.js":1096}],1099:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _md = _interopRequireDefault(require("./md5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports.default = _default;
module.exports = exports.default;
},{"./md5.js":1095,"./v35.js":1100}],1100:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.URL = exports.DNS = void 0;

var _bytesToUuid = _interopRequireDefault(require("./bytesToUuid.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function uuidToBytes(uuid) {
  // Note: We assume we're being passed a valid uuid string
  var bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = new Array(str.length);

  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function _default(name, version, hashfunc) {
  var generateUUID = function (value, namespace, buf, offset) {
    var off = buf && offset || 0;
    if (typeof value == 'string') value = stringToBytes(value);
    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3

    var bytes = hashfunc(namespace.concat(value));
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      for (var idx = 0; idx < 16; ++idx) {
        buf[off + idx] = bytes[idx];
      }
    }

    return buf || (0, _bytesToUuid.default)(bytes);
  }; // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name;
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
},{"./bytesToUuid.js":1093}],1101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _bytesToUuid = _interopRequireDefault(require("./bytesToUuid.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};

  var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || (0, _bytesToUuid.default)(rnds);
}

var _default = v4;
exports.default = _default;
module.exports = exports.default;
},{"./bytesToUuid.js":1093,"./rng.js":1096}],1102:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _sha = _interopRequireDefault(require("./sha1.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports.default = _default;
module.exports = exports.default;
},{"./sha1.js":1097,"./v35.js":1100}],1103:[function(require,module,exports){
/** @license React v17.0.1
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

if ("production" !== "production") {
  (function() {
'use strict';

var React = require('react');
var _assign = require('object-assign');

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}

},{"object-assign":879,"react":1107}],1104:[function(require,module,exports){
/** @license React v17.0.1
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';require("object-assign");var f=require("react"),g=60103;exports.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");exports.Fragment=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;

},{"object-assign":879,"react":1107}],1105:[function(require,module,exports){
/** @license React v17.0.1
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

if ("production" !== "production") {
  (function() {
'use strict';

var _assign = require('object-assign');

// TODO: this is special because it gets imported during build.
var ReactVersion = '17.0.1';

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
exports.StrictMode = 0xeacc;
exports.Profiler = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
exports.Suspense = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  exports.StrictMode = symbolFor('react.strict_mode');
  exports.Profiler = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  exports.Suspense = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

/**
 * Keeps track of the current dispatcher.
 */
var ReactCurrentDispatcher = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

/**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */
var ReactCurrentBatchConfig = {
  transition: 0
};

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var ReactDebugCurrentFrame = {};
var currentExtraStackFrame = null;
function setExtraStackFrame(stack) {
  {
    currentExtraStackFrame = stack;
  }
}

{
  ReactDebugCurrentFrame.setExtraStackFrame = function (stack) {
    {
      currentExtraStackFrame = stack;
    }
  }; // Stack implementation injected by the current renderer.


  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = ''; // Add an extra top frame while an element is being validated

    if (currentExtraStackFrame) {
      stack += currentExtraStackFrame;
    } // Delegate to the injected renderer-specific implementation


    var impl = ReactDebugCurrentFrame.getCurrentStack;

    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

/**
 * Used by act() to track whether you're inside an act() scope.
 */
var IsSomeRendererActing = {
  current: false
};

var ReactSharedInternals = {
  ReactCurrentDispatcher: ReactCurrentDispatcher,
  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
  ReactCurrentOwner: ReactCurrentOwner,
  IsSomeRendererActing: IsSomeRendererActing,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + "." + callerName;

    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }

    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}
/**
 * This is the abstract API for an update queue.
 */


var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};

{
  Object.freeze(emptyObject);
}
/**
 * Base class helpers for the updating state of a component.
 */


function Component(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
  // renderer.

  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */

Component.prototype.setState = function (partialState, callback) {
  if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
    {
      throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
    }
  }

  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */


Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};
/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */


{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };

  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

        return undefined;
      }
    });
  };

  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}

ComponentDummy.prototype = Component.prototype;
/**
 * Convenience component with default shallow equality check for sCU.
 */

function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

_assign(pureComponentPrototype, Component.prototype);

pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };

  {
    Object.seal(refObject);
  }

  return refObject;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case exports.Profiler:
      return 'Profiler';

    case exports.StrictMode:
      return 'StrictMode';

    case exports.Suspense:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    }
  };

  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    }
  };

  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

function warnIfStringRefCannotBeAutoConverted(config) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */

function createElement(type, config, children) {
  var propName; // Reserved names are extracted

  var props = {};
  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;

      {
        warnIfStringRefCannotBeAutoConverted(config);
      }
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }

    props.children = childArray;
  } // Resolve default props


  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;

    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }

  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}
function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
  return newElement;
}
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */

function cloneElement(element, config, children) {
  if (!!(element === null || element === undefined)) {
    {
      throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
    }
  }

  var propName; // Original props are copied

  var props = _assign({}, element.props); // Reserved names are extracted


  var key = element.key;
  var ref = element.ref; // Self is preserved since the owner is preserved.

  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.

  var source = element._source; // Owner will be preserved, unless ref is overridden

  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    } // Remaining properties override existing props


    var defaultProps;

    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = key.replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });
  return '$' + escapedString;
}
/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */


var didWarnAboutMaps = false;
var userProvidedKeyEscapeRegex = /\/+/g;

function escapeUserProvidedKey(text) {
  return text.replace(userProvidedKeyEscapeRegex, '$&/');
}
/**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */


function getElementKey(element, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof element === 'object' && element !== null && element.key != null) {
    // Explicit key
    return escape('' + element.key);
  } // Implicit key determined by the index in the set


  return index.toString(36);
}

function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;

      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }

    }
  }

  if (invokeCallback) {
    var _child = children;
    var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows:

    var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;

    if (Array.isArray(mappedChild)) {
      var escapedChildKey = '';

      if (childKey != null) {
        escapedChildKey = escapeUserProvidedKey(childKey) + '/';
      }

      mapIntoArray(mappedChild, array, escapedChildKey, '', function (c) {
        return c;
      });
    } else if (mappedChild != null) {
      if (isValidElement(mappedChild)) {
        mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        escapedPrefix + ( // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
        mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
        escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
      }

      array.push(mappedChild);
    }

    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.

  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getElementKey(child, i);
      subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
    }
  } else {
    var iteratorFn = getIteratorFn(children);

    if (typeof iteratorFn === 'function') {
      var iterableChildren = children;

      {
        // Warn about using Maps as children
        if (iteratorFn === iterableChildren.entries) {
          if (!didWarnAboutMaps) {
            warn('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
          }

          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(iterableChildren);
      var step;
      var ii = 0;

      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getElementKey(child, ii++);
        subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
      }
    } else if (type === 'object') {
      var childrenString = '' + children;

      {
        {
          throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead." );
        }
      }
    }
  }

  return subtreeCount;
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }

  var result = [];
  var count = 0;
  mapIntoArray(children, result, '', '', function (child) {
    return func.call(context, child, count++);
  });
  return result;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */


function countChildren(children) {
  var n = 0;
  mapChildren(children, function () {
    n++; // Don't return anything
  });
  return n;
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  mapChildren(children, function () {
    forEachFunc.apply(this, arguments); // Don't return anything.
  }, forEachContext);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */


function toArray(children) {
  return mapChildren(children, function (child) {
    return child;
  }) || [];
}
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */


function onlyChild(children) {
  if (!isValidElement(children)) {
    {
      throw Error( "React.Children.only expected to receive a single React element child." );
    }
  }

  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
        error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
      }
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // Used to track how many concurrent renderers this context currently
    // supports within in a single renderer. Such as parallel server rendering.
    _threadCount: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };
  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;
  var hasWarnedAboutDisplayNameOnConsumer = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;

            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }

          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      _threadCount: {
        get: function () {
          return context._threadCount;
        },
        set: function (_threadCount) {
          context._threadCount = _threadCount;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;

            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }

          return context.Consumer;
        }
      },
      displayName: {
        get: function () {
          return context.displayName;
        },
        set: function (displayName) {
          if (!hasWarnedAboutDisplayNameOnConsumer) {
            warn('Setting `displayName` on Context.Consumer has no effect. ' + "You should set it directly on the context with Context.displayName = '%s'.", displayName);

            hasWarnedAboutDisplayNameOnConsumer = true;
          }
        }
      }
    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

var Uninitialized = -1;
var Pending = 0;
var Resolved = 1;
var Rejected = 2;

function lazyInitializer(payload) {
  if (payload._status === Uninitialized) {
    var ctor = payload._result;
    var thenable = ctor(); // Transition to the next state.

    var pending = payload;
    pending._status = Pending;
    pending._result = thenable;
    thenable.then(function (moduleObject) {
      if (payload._status === Pending) {
        var defaultExport = moduleObject.default;

        {
          if (defaultExport === undefined) {
            error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
            'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))", moduleObject);
          }
        } // Transition to the next state.


        var resolved = payload;
        resolved._status = Resolved;
        resolved._result = defaultExport;
      }
    }, function (error) {
      if (payload._status === Pending) {
        // Transition to the next state.
        var rejected = payload;
        rejected._status = Rejected;
        rejected._result = error;
      }
    });
  }

  if (payload._status === Resolved) {
    return payload._result;
  } else {
    throw payload._result;
  }
}

function lazy(ctor) {
  var payload = {
    // We use these fields to store the result.
    _status: -1,
    _result: ctor
  };
  var lazyType = {
    $$typeof: REACT_LAZY_TYPE,
    _payload: payload,
    _init: lazyInitializer
  };

  {
    // In production, this would just set it on the object.
    var defaultProps;
    var propTypes; // $FlowFixMe

    Object.defineProperties(lazyType, {
      defaultProps: {
        configurable: true,
        get: function () {
          return defaultProps;
        },
        set: function (newDefaultProps) {
          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          defaultProps = newDefaultProps; // Match production behavior more closely:
          // $FlowFixMe

          Object.defineProperty(lazyType, 'defaultProps', {
            enumerable: true
          });
        }
      },
      propTypes: {
        configurable: true,
        get: function () {
          return propTypes;
        },
        set: function (newPropTypes) {
          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          propTypes = newPropTypes; // Match production behavior more closely:
          // $FlowFixMe

          Object.defineProperty(lazyType, 'propTypes', {
            enumerable: true
          });
        }
      }
    });
  }

  return lazyType;
}

function forwardRef(render) {
  {
    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
    } else if (typeof render !== 'function') {
      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      if (render.length !== 0 && render.length !== 2) {
        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
      }
    }

    if (render != null) {
      if (render.defaultProps != null || render.propTypes != null) {
        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
      }
    }
  }

  var elementType = {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };

  {
    var ownName;
    Object.defineProperty(elementType, 'displayName', {
      enumerable: false,
      configurable: true,
      get: function () {
        return ownName;
      },
      set: function (name) {
        ownName = name;

        if (render.displayName == null) {
          render.displayName = name;
        }
      }
    });
  }

  return elementType;
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === exports.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports.StrictMode || type === exports.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }

  var elementType = {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };

  {
    var ownName;
    Object.defineProperty(elementType, 'displayName', {
      enumerable: false,
      configurable: true,
      get: function () {
        return ownName;
      },
      set: function (name) {
        ownName = name;

        if (type.displayName == null) {
          type.displayName = name;
        }
      }
    });
  }

  return elementType;
}

function resolveDispatcher() {
  var dispatcher = ReactCurrentDispatcher.current;

  if (!(dispatcher !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  return dispatcher;
}

function useContext(Context, unstable_observedBits) {
  var dispatcher = resolveDispatcher();

  {
    if (unstable_observedBits !== undefined) {
      error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://reactjs.org/link/rules-of-hooks' : '');
    } // TODO: add a more generic warning for invalid values.


    if (Context._context !== undefined) {
      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
      // and nobody should be using this in existing code.

      if (realContext.Consumer === Context) {
        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
      } else if (realContext.Provider === Context) {
        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
      }
    }
  }

  return dispatcher.useContext(Context, unstable_observedBits);
}
function useState(initialState) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useState(initialState);
}
function useReducer(reducer, initialArg, init) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useReducer(reducer, initialArg, init);
}
function useRef(initialValue) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useRef(initialValue);
}
function useEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useEffect(create, deps);
}
function useLayoutEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useLayoutEffect(create, deps);
}
function useCallback(callback, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useCallback(callback, deps);
}
function useMemo(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useMemo(create, deps);
}
function useImperativeHandle(ref, create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useImperativeHandle(ref, create, deps);
}
function useDebugValue(value, formatterFn) {
  {
    var dispatcher = resolveDispatcher();
    return dispatcher.useDebugValue(value, formatterFn);
  }
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher$1.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher$1.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case exports.Suspense:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      setExtraStackFrame(stack);
    } else {
      setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);

    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }

  return '';
}

function getSourceInfoErrorAddendum(source) {
  if (source !== undefined) {
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }

  return '';
}

function getSourceInfoErrorAddendumForProps(elementProps) {
  if (elementProps !== null && elementProps !== undefined) {
    return getSourceInfoErrorAddendum(elementProps.__source);
  }

  return '';
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

    if (parentName) {
      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
    }
  }

  return info;
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }

  element._store.validated = true;
  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }

  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.

  var childOwner = '';

  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
  }

  {
    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }

  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];

      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);

    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;

        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}
function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.

  if (!validType) {
    var info = '';

    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString;

    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    {
      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }
  }

  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.

  if (element == null) {
    return element;
  } // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)


  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === exports.Fragment) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}
var didWarnAboutDeprecatedCreateFactory = false;
function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;

  {
    if (!didWarnAboutDeprecatedCreateFactory) {
      didWarnAboutDeprecatedCreateFactory = true;

      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
    } // Legacy hook: remove it


    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}
function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);

  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }

  validatePropTypes(newElement);
  return newElement;
}

{

  try {
    var frozenObject = Object.freeze({});
    /* eslint-disable no-new */

    new Map([[frozenObject, null]]);
    new Set([frozenObject]);
    /* eslint-enable no-new */
  } catch (e) {
  }
}

var createElement$1 =  createElementWithValidation ;
var cloneElement$1 =  cloneElementWithValidation ;
var createFactory =  createFactoryWithValidation ;
var Children = {
  map: mapChildren,
  forEach: forEachChildren,
  count: countChildren,
  toArray: toArray,
  only: onlyChild
};

exports.Children = Children;
exports.Component = Component;
exports.PureComponent = PureComponent;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
exports.cloneElement = cloneElement$1;
exports.createContext = createContext;
exports.createElement = createElement$1;
exports.createFactory = createFactory;
exports.createRef = createRef;
exports.forwardRef = forwardRef;
exports.isValidElement = isValidElement;
exports.lazy = lazy;
exports.memo = memo;
exports.useCallback = useCallback;
exports.useContext = useContext;
exports.useDebugValue = useDebugValue;
exports.useEffect = useEffect;
exports.useImperativeHandle = useImperativeHandle;
exports.useLayoutEffect = useLayoutEffect;
exports.useMemo = useMemo;
exports.useReducer = useReducer;
exports.useRef = useRef;
exports.useState = useState;
exports.version = ReactVersion;
  })();
}

},{"object-assign":879}],1106:[function(require,module,exports){
/** @license React v17.0.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';var l=require("object-assign"),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.1";

},{"object-assign":879}],1107:[function(require,module,exports){
'use strict';

if ("production" === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}

},{"./cjs/react.development.js":1105,"./cjs/react.production.min.js":1106}],1108:[function(require,module,exports){
'use strict';

if ("production" === 'production') {
  module.exports = require('./cjs/react-jsx-runtime.production.min.js');
} else {
  module.exports = require('./cjs/react-jsx-runtime.development.js');
}

},{"./cjs/react-jsx-runtime.development.js":1103,"./cjs/react-jsx-runtime.production.min.js":1104}],1109:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = require('lodash/forOwn');

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;
},{"lodash/forOwn":836}],1110:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;
},{"react":1107}],1111:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;
},{"react":1107}],1112:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = require('lodash/forOwn');

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;
},{"lodash/forOwn":836,"lodash/isPlainObject":851,"lodash/isString":853,"lodash/map":861}],1113:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = require('./flattenNames');

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = require('./mergeClasses');

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = require('./autoprefix');

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = require('./components/hover');

var _hover3 = _interopRequireDefault(_hover2);

var _active = require('./components/active');

var _active2 = _interopRequireDefault(_active);

var _loop2 = require('./loop');

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;
},{"./autoprefix":1109,"./components/active":1110,"./components/hover":1111,"./flattenNames":1112,"./loop":1114,"./mergeClasses":1115}],1114:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;
},{}],1115:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = require('lodash/forOwn');

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;
},{"lodash/cloneDeep":830,"lodash/forOwn":836}],1116:[function(require,module,exports){
module.exports = require('./lib/_stream_duplex.js');

},{"./lib/_stream_duplex.js":1117}],1117:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};
},{"./_stream_readable":1119,"./_stream_writable":1121,"core-util-is":544,"inherits":668,"process-nextick-args":892}],1118:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":1120,"core-util-is":544,"inherits":668}],1119:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./_stream_duplex":1117,"./internal/streams/BufferList":1122,"./internal/streams/destroy":1123,"./internal/streams/stream":1124,"_process":405,"core-util-is":544,"events":629,"inherits":668,"isarray":674,"process-nextick-args":892,"safe-buffer":1155,"string_decoder/":1192,"util":402}],1120:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":1117,"core-util-is":544,"inherits":668}],1121:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"./_stream_duplex":1117,"./internal/streams/destroy":1123,"./internal/streams/stream":1124,"_process":405,"core-util-is":544,"inherits":668,"process-nextick-args":892,"safe-buffer":1155,"timers":1201,"util-deprecate":1214}],1122:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = require('safe-buffer').Buffer;
var util = require('util');

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
},{"safe-buffer":1155,"util":402}],1123:[function(require,module,exports){
'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};
},{"process-nextick-args":892}],1124:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":629}],1125:[function(require,module,exports){
module.exports = require('./readable').PassThrough

},{"./readable":1126}],1126:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":1117,"./lib/_stream_passthrough.js":1118,"./lib/_stream_readable.js":1119,"./lib/_stream_transform.js":1120,"./lib/_stream_writable.js":1121}],1127:[function(require,module,exports){
module.exports = require('./readable').Transform

},{"./readable":1126}],1128:[function(require,module,exports){
module.exports = require('./lib/_stream_writable.js');

},{"./lib/_stream_writable.js":1121}],1129:[function(require,module,exports){
(function (global){(function (){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1130:[function(require,module,exports){
'use strict';

exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;
},{}],1131:[function(require,module,exports){
'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var $$observable = _interopDefault(require('symbol-observable'));
var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: '@@redux/INIT' + randomString(),
    REPLACE: '@@redux/REPLACE' + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return '@@redux/PROBE_UNKNOWN_ACTION' + randomString();
    }
};
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null)
        return false;
    var proto = obj;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
}
function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
        throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
    }
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') {
            throw new Error('Expected the enhancer to be a function.');
        }
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') {
        throw new Error('Expected the reducer to be a function.');
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
        }
    }
    function getState() {
        if (isDispatching) {
            throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
        }
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== 'function') {
            throw new Error('Expected the listener to be a function.');
        }
        if (isDispatching) {
            throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
        }
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) {
                return;
            }
            if (isDispatching) {
                throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
            }
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) {
            throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
        }
        if (typeof action.type === 'undefined') {
            throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
        }
        if (isDispatching) {
            throw new Error('Reducers may not dispatch actions.');
        }
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally {
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') {
            throw new Error('Expected the nextReducer to be a function.');
        }
        currentReducer = nextReducer;
        dispatch({ type: ActionTypes.REPLACE });
    }
    function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) {
                    throw new TypeError('Expected the observer to be an object.');
                }
                function observeState() {
                    if (observer.next) {
                        observer.next(getState());
                    }
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return { unsubscribe: unsubscribe };
            }
        }, _ref[$$observable] = function () {
            return this;
        }, _ref;
    }
    dispatch({ type: ActionTypes.INIT });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
function warning(message) {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
        console.error(message);
    }
    try {
        throw new Error(message);
    } catch (e) {
    }
}
function getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';
    return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) {
        return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
    }
    if (!isPlainObject(inputState)) {
        return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    }
    var unexpectedKeys = Object.keys(inputState).filter(function (key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function (key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE)
        return;
    if (unexpectedKeys.length > 0) {
        return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
    }
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function (key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, { type: ActionTypes.INIT });
        if (typeof initialState === 'undefined') {
            throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        }
        if (typeof reducer(undefined, { type: ActionTypes.PROBE_UNKNOWN_ACTION() }) === 'undefined') {
            throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
        }
    });
}
function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for (var i = 0; i < reducerKeys.length; i++) {
        var key = reducerKeys[i];
        if ('production' !== 'production') {
            if (typeof reducers[key] === 'undefined') {
                warning('No reducer provided for key "' + key + '"');
            }
        }
        if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
        }
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    if ('production' !== 'production') {
        unexpectedKeyCache = {};
    }
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) {
            state = {};
        }
        if (shapeAssertionError) {
            throw shapeAssertionError;
        }
        if ('production' !== 'production') {
            var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
            if (warningMessage) {
                warning(warningMessage);
            }
        }
        var hasChanged = false;
        var nextState = {};
        for (var _i = 0; _i < finalReducerKeys.length; _i++) {
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function () {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') {
        return bindActionCreator(actionCreators, dispatch);
    }
    if (typeof actionCreators !== 'object' || actionCreators === null) {
        throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    }
    var boundActionCreators = {};
    for (var key in actionCreators) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') {
            boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
        }
    }
    return boundActionCreators;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        keys.push.apply(keys, Object.getOwnPropertySymbols(object));
    }
    if (enumerableOnly)
        keys = keys.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
    return keys;
}
function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(source, true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function compose() {
    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) {
        return function (arg) {
            return arg;
        };
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) {
        return function () {
            return a(b.apply(void 0, arguments));
        };
    });
}
function applyMiddleware() {
    for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
        middlewares[_key] = arguments[_key];
    }
    return function (createStore) {
        return function () {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function (middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return _objectSpread2({}, store, { dispatch: _dispatch });
        };
    };
}
function isCrushed() {
}
if ('production' !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
    warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}
exports.__DO_NOT_USE__ActionTypes = ActionTypes;
exports.applyMiddleware = applyMiddleware;
exports.bindActionCreators = bindActionCreators;
exports.combineReducers = combineReducers;
exports.compose = compose;
exports.createStore = createStore;
},{"symbol-observable":1199}],1132:[function(require,module,exports){
'use strict';

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

},{}],1133:[function(require,module,exports){
'use strict';

var define = require('define-properties');
var callBind = require('call-bind');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;

},{"./implementation":1132,"./polyfill":1134,"./shim":1135,"call-bind":408,"define-properties":550}],1134:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

var supportsDescriptors = require('define-properties').supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};

},{"./implementation":1132,"define-properties":550}],1135:[function(require,module,exports){
'use strict';

var supportsDescriptors = require('define-properties').supportsDescriptors;
var getPolyfill = require('./polyfill');
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

},{"./polyfill":1134,"define-properties":550}],1136:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}
},{}],1137:[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ResizeObserver = factory());
}(this, (function () { 'use strict';

    /**
     * A collection of shims that provide minimal functionality of the ES6 collections.
     *
     * These implementations are not meant to be used outside of the ResizeObserver
     * modules as they cover only a limited range of use cases.
     */
    /* eslint-disable require-jsdoc, valid-jsdoc */
    var MapShim = (function () {
        if (typeof Map !== 'undefined') {
            return Map;
        }
        /**
         * Returns index in provided array that matches the specified key.
         *
         * @param {Array<Array>} arr
         * @param {*} key
         * @returns {number}
         */
        function getIndex(arr, key) {
            var result = -1;
            arr.some(function (entry, index) {
                if (entry[0] === key) {
                    result = index;
                    return true;
                }
                return false;
            });
            return result;
        }
        return /** @class */ (function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function () {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                }
                else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) { ctx = null; }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }());
    })();

    /**
     * Detects whether window and document objects are available in current environment.
     */
    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

    // Returns global object of a current environment.
    var global$1 = (function () {
        if (typeof global !== 'undefined' && global.Math === Math) {
            return global;
        }
        if (typeof self !== 'undefined' && self.Math === Math) {
            return self;
        }
        if (typeof window !== 'undefined' && window.Math === Math) {
            return window;
        }
        // eslint-disable-next-line no-new-func
        return Function('return this')();
    })();

    /**
     * A shim for the requestAnimationFrame which falls back to the setTimeout if
     * first one is not supported.
     *
     * @returns {number} Requests' identifier.
     */
    var requestAnimationFrame$1 = (function () {
        if (typeof requestAnimationFrame === 'function') {
            // It's required to use a bounded function because IE sometimes throws
            // an "Invalid calling object" error if rAF is invoked without the global
            // object on the left hand side.
            return requestAnimationFrame.bind(global$1);
        }
        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
    })();

    // Defines minimum timeout before adding a trailing call.
    var trailingTimeout = 2;
    /**
     * Creates a wrapper function which ensures that provided callback will be
     * invoked only once during the specified delay period.
     *
     * @param {Function} callback - Function to be invoked after the delay period.
     * @param {number} delay - Delay after which to invoke callback.
     * @returns {Function}
     */
    function throttle (callback, delay) {
        var leadingCall = false, trailingCall = false, lastCallTime = 0;
        /**
         * Invokes the original callback function and schedules new invocation if
         * the "proxy" was called during current request.
         *
         * @returns {void}
         */
        function resolvePending() {
            if (leadingCall) {
                leadingCall = false;
                callback();
            }
            if (trailingCall) {
                proxy();
            }
        }
        /**
         * Callback invoked after the specified delay. It will further postpone
         * invocation of the original function delegating it to the
         * requestAnimationFrame.
         *
         * @returns {void}
         */
        function timeoutCallback() {
            requestAnimationFrame$1(resolvePending);
        }
        /**
         * Schedules invocation of the original function.
         *
         * @returns {void}
         */
        function proxy() {
            var timeStamp = Date.now();
            if (leadingCall) {
                // Reject immediately following calls.
                if (timeStamp - lastCallTime < trailingTimeout) {
                    return;
                }
                // Schedule new call to be in invoked when the pending one is resolved.
                // This is important for "transitions" which never actually start
                // immediately so there is a chance that we might miss one if change
                // happens amids the pending invocation.
                trailingCall = true;
            }
            else {
                leadingCall = true;
                trailingCall = false;
                setTimeout(timeoutCallback, delay);
            }
            lastCallTime = timeStamp;
        }
        return proxy;
    }

    // Minimum delay before invoking the update of observers.
    var REFRESH_DELAY = 20;
    // A list of substrings of CSS properties used to find transition events that
    // might affect dimensions of observed elements.
    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
    // Check if MutationObserver is available.
    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
    /**
     * Singleton controller class which handles updates of ResizeObserver instances.
     */
    var ResizeObserverController = /** @class */ (function () {
        /**
         * Creates a new instance of ResizeObserverController.
         *
         * @private
         */
        function ResizeObserverController() {
            /**
             * Indicates whether DOM listeners have been added.
             *
             * @private {boolean}
             */
            this.connected_ = false;
            /**
             * Tells that controller has subscribed for Mutation Events.
             *
             * @private {boolean}
             */
            this.mutationEventsAdded_ = false;
            /**
             * Keeps reference to the instance of MutationObserver.
             *
             * @private {MutationObserver}
             */
            this.mutationsObserver_ = null;
            /**
             * A list of connected observers.
             *
             * @private {Array<ResizeObserverSPI>}
             */
            this.observers_ = [];
            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
        }
        /**
         * Adds observer to observers list.
         *
         * @param {ResizeObserverSPI} observer - Observer to be added.
         * @returns {void}
         */
        ResizeObserverController.prototype.addObserver = function (observer) {
            if (!~this.observers_.indexOf(observer)) {
                this.observers_.push(observer);
            }
            // Add listeners if they haven't been added yet.
            if (!this.connected_) {
                this.connect_();
            }
        };
        /**
         * Removes observer from observers list.
         *
         * @param {ResizeObserverSPI} observer - Observer to be removed.
         * @returns {void}
         */
        ResizeObserverController.prototype.removeObserver = function (observer) {
            var observers = this.observers_;
            var index = observers.indexOf(observer);
            // Remove observer if it's present in registry.
            if (~index) {
                observers.splice(index, 1);
            }
            // Remove listeners if controller has no connected observers.
            if (!observers.length && this.connected_) {
                this.disconnect_();
            }
        };
        /**
         * Invokes the update of observers. It will continue running updates insofar
         * it detects changes.
         *
         * @returns {void}
         */
        ResizeObserverController.prototype.refresh = function () {
            var changesDetected = this.updateObservers_();
            // Continue running updates if changes have been detected as there might
            // be future ones caused by CSS transitions.
            if (changesDetected) {
                this.refresh();
            }
        };
        /**
         * Updates every observer from observers list and notifies them of queued
         * entries.
         *
         * @private
         * @returns {boolean} Returns "true" if any observer has detected changes in
         *      dimensions of it's elements.
         */
        ResizeObserverController.prototype.updateObservers_ = function () {
            // Collect observers that have active observations.
            var activeObservers = this.observers_.filter(function (observer) {
                return observer.gatherActive(), observer.hasActive();
            });
            // Deliver notifications in a separate cycle in order to avoid any
            // collisions between observers, e.g. when multiple instances of
            // ResizeObserver are tracking the same element and the callback of one
            // of them changes content dimensions of the observed target. Sometimes
            // this may result in notifications being blocked for the rest of observers.
            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
            return activeObservers.length > 0;
        };
        /**
         * Initializes DOM listeners.
         *
         * @private
         * @returns {void}
         */
        ResizeObserverController.prototype.connect_ = function () {
            // Do nothing if running in a non-browser environment or if listeners
            // have been already added.
            if (!isBrowser || this.connected_) {
                return;
            }
            // Subscription to the "Transitionend" event is used as a workaround for
            // delayed transitions. This way it's possible to capture at least the
            // final state of an element.
            document.addEventListener('transitionend', this.onTransitionEnd_);
            window.addEventListener('resize', this.refresh);
            if (mutationObserverSupported) {
                this.mutationsObserver_ = new MutationObserver(this.refresh);
                this.mutationsObserver_.observe(document, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
            else {
                document.addEventListener('DOMSubtreeModified', this.refresh);
                this.mutationEventsAdded_ = true;
            }
            this.connected_ = true;
        };
        /**
         * Removes DOM listeners.
         *
         * @private
         * @returns {void}
         */
        ResizeObserverController.prototype.disconnect_ = function () {
            // Do nothing if running in a non-browser environment or if listeners
            // have been already removed.
            if (!isBrowser || !this.connected_) {
                return;
            }
            document.removeEventListener('transitionend', this.onTransitionEnd_);
            window.removeEventListener('resize', this.refresh);
            if (this.mutationsObserver_) {
                this.mutationsObserver_.disconnect();
            }
            if (this.mutationEventsAdded_) {
                document.removeEventListener('DOMSubtreeModified', this.refresh);
            }
            this.mutationsObserver_ = null;
            this.mutationEventsAdded_ = false;
            this.connected_ = false;
        };
        /**
         * "Transitionend" event handler.
         *
         * @private
         * @param {TransitionEvent} event
         * @returns {void}
         */
        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
            // Detect whether transition may affect dimensions of an element.
            var isReflowProperty = transitionKeys.some(function (key) {
                return !!~propertyName.indexOf(key);
            });
            if (isReflowProperty) {
                this.refresh();
            }
        };
        /**
         * Returns instance of the ResizeObserverController.
         *
         * @returns {ResizeObserverController}
         */
        ResizeObserverController.getInstance = function () {
            if (!this.instance_) {
                this.instance_ = new ResizeObserverController();
            }
            return this.instance_;
        };
        /**
         * Holds reference to the controller's instance.
         *
         * @private {ResizeObserverController}
         */
        ResizeObserverController.instance_ = null;
        return ResizeObserverController;
    }());

    /**
     * Defines non-writable/enumerable properties of the provided target object.
     *
     * @param {Object} target - Object for which to define properties.
     * @param {Object} props - Properties to be defined.
     * @returns {Object} Target object.
     */
    var defineConfigurable = (function (target, props) {
        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
            var key = _a[_i];
            Object.defineProperty(target, key, {
                value: props[key],
                enumerable: false,
                writable: false,
                configurable: true
            });
        }
        return target;
    });

    /**
     * Returns the global object associated with provided element.
     *
     * @param {Object} target
     * @returns {Object}
     */
    var getWindowOf = (function (target) {
        // Assume that the element is an instance of Node, which means that it
        // has the "ownerDocument" property from which we can retrieve a
        // corresponding global object.
        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
        // Return the local global object if it's not possible extract one from
        // provided element.
        return ownerGlobal || global$1;
    });

    // Placeholder of an empty content rectangle.
    var emptyRect = createRectInit(0, 0, 0, 0);
    /**
     * Converts provided string to a number.
     *
     * @param {number|string} value
     * @returns {number}
     */
    function toFloat(value) {
        return parseFloat(value) || 0;
    }
    /**
     * Extracts borders size from provided styles.
     *
     * @param {CSSStyleDeclaration} styles
     * @param {...string} positions - Borders positions (top, right, ...)
     * @returns {number}
     */
    function getBordersSize(styles) {
        var positions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            positions[_i - 1] = arguments[_i];
        }
        return positions.reduce(function (size, position) {
            var value = styles['border-' + position + '-width'];
            return size + toFloat(value);
        }, 0);
    }
    /**
     * Extracts paddings sizes from provided styles.
     *
     * @param {CSSStyleDeclaration} styles
     * @returns {Object} Paddings box.
     */
    function getPaddings(styles) {
        var positions = ['top', 'right', 'bottom', 'left'];
        var paddings = {};
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            var position = positions_1[_i];
            var value = styles['padding-' + position];
            paddings[position] = toFloat(value);
        }
        return paddings;
    }
    /**
     * Calculates content rectangle of provided SVG element.
     *
     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
     *      to be calculated.
     * @returns {DOMRectInit}
     */
    function getSVGContentRect(target) {
        var bbox = target.getBBox();
        return createRectInit(0, 0, bbox.width, bbox.height);
    }
    /**
     * Calculates content rectangle of provided HTMLElement.
     *
     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
     * @returns {DOMRectInit}
     */
    function getHTMLElementContentRect(target) {
        // Client width & height properties can't be
        // used exclusively as they provide rounded values.
        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
        // By this condition we can catch all non-replaced inline, hidden and
        // detached elements. Though elements with width & height properties less
        // than 0.5 will be discarded as well.
        //
        // Without it we would need to implement separate methods for each of
        // those cases and it's not possible to perform a precise and performance
        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
        // gives wrong results for elements with width & height less than 0.5.
        if (!clientWidth && !clientHeight) {
            return emptyRect;
        }
        var styles = getWindowOf(target).getComputedStyle(target);
        var paddings = getPaddings(styles);
        var horizPad = paddings.left + paddings.right;
        var vertPad = paddings.top + paddings.bottom;
        // Computed styles of width & height are being used because they are the
        // only dimensions available to JS that contain non-rounded values. It could
        // be possible to utilize the getBoundingClientRect if only it's data wasn't
        // affected by CSS transformations let alone paddings, borders and scroll bars.
        var width = toFloat(styles.width), height = toFloat(styles.height);
        // Width & height include paddings and borders when the 'border-box' box
        // model is applied (except for IE).
        if (styles.boxSizing === 'border-box') {
            // Following conditions are required to handle Internet Explorer which
            // doesn't include paddings and borders to computed CSS dimensions.
            //
            // We can say that if CSS dimensions + paddings are equal to the "client"
            // properties then it's either IE, and thus we don't need to subtract
            // anything, or an element merely doesn't have paddings/borders styles.
            if (Math.round(width + horizPad) !== clientWidth) {
                width -= getBordersSize(styles, 'left', 'right') + horizPad;
            }
            if (Math.round(height + vertPad) !== clientHeight) {
                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
            }
        }
        // Following steps can't be applied to the document's root element as its
        // client[Width/Height] properties represent viewport area of the window.
        // Besides, it's as well not necessary as the <html> itself neither has
        // rendered scroll bars nor it can be clipped.
        if (!isDocumentElement(target)) {
            // In some browsers (only in Firefox, actually) CSS width & height
            // include scroll bars size which can be removed at this step as scroll
            // bars are the only difference between rounded dimensions + paddings
            // and "client" properties, though that is not always true in Chrome.
            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
            // Chrome has a rather weird rounding of "client" properties.
            // E.g. for an element with content width of 314.2px it sometimes gives
            // the client width of 315px and for the width of 314.7px it may give
            // 314px. And it doesn't happen all the time. So just ignore this delta
            // as a non-relevant.
            if (Math.abs(vertScrollbar) !== 1) {
                width -= vertScrollbar;
            }
            if (Math.abs(horizScrollbar) !== 1) {
                height -= horizScrollbar;
            }
        }
        return createRectInit(paddings.left, paddings.top, width, height);
    }
    /**
     * Checks whether provided element is an instance of the SVGGraphicsElement.
     *
     * @param {Element} target - Element to be checked.
     * @returns {boolean}
     */
    var isSVGGraphicsElement = (function () {
        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
        // interface.
        if (typeof SVGGraphicsElement !== 'undefined') {
            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
        }
        // If it's so, then check that element is at least an instance of the
        // SVGElement and that it has the "getBBox" method.
        // eslint-disable-next-line no-extra-parens
        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
            typeof target.getBBox === 'function'); };
    })();
    /**
     * Checks whether provided element is a document element (<html>).
     *
     * @param {Element} target - Element to be checked.
     * @returns {boolean}
     */
    function isDocumentElement(target) {
        return target === getWindowOf(target).document.documentElement;
    }
    /**
     * Calculates an appropriate content rectangle for provided html or svg element.
     *
     * @param {Element} target - Element content rectangle of which needs to be calculated.
     * @returns {DOMRectInit}
     */
    function getContentRect(target) {
        if (!isBrowser) {
            return emptyRect;
        }
        if (isSVGGraphicsElement(target)) {
            return getSVGContentRect(target);
        }
        return getHTMLElementContentRect(target);
    }
    /**
     * Creates rectangle with an interface of the DOMRectReadOnly.
     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
     *
     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
     * @returns {DOMRectReadOnly}
     */
    function createReadOnlyRect(_a) {
        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
        var rect = Object.create(Constr.prototype);
        // Rectangle's properties are not writable and non-enumerable.
        defineConfigurable(rect, {
            x: x, y: y, width: width, height: height,
            top: y,
            right: x + width,
            bottom: height + y,
            left: x
        });
        return rect;
    }
    /**
     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
     *
     * @param {number} x - X coordinate.
     * @param {number} y - Y coordinate.
     * @param {number} width - Rectangle's width.
     * @param {number} height - Rectangle's height.
     * @returns {DOMRectInit}
     */
    function createRectInit(x, y, width, height) {
        return { x: x, y: y, width: width, height: height };
    }

    /**
     * Class that is responsible for computations of the content rectangle of
     * provided DOM element and for keeping track of it's changes.
     */
    var ResizeObservation = /** @class */ (function () {
        /**
         * Creates an instance of ResizeObservation.
         *
         * @param {Element} target - Element to be observed.
         */
        function ResizeObservation(target) {
            /**
             * Broadcasted width of content rectangle.
             *
             * @type {number}
             */
            this.broadcastWidth = 0;
            /**
             * Broadcasted height of content rectangle.
             *
             * @type {number}
             */
            this.broadcastHeight = 0;
            /**
             * Reference to the last observed content rectangle.
             *
             * @private {DOMRectInit}
             */
            this.contentRect_ = createRectInit(0, 0, 0, 0);
            this.target = target;
        }
        /**
         * Updates content rectangle and tells whether it's width or height properties
         * have changed since the last broadcast.
         *
         * @returns {boolean}
         */
        ResizeObservation.prototype.isActive = function () {
            var rect = getContentRect(this.target);
            this.contentRect_ = rect;
            return (rect.width !== this.broadcastWidth ||
                rect.height !== this.broadcastHeight);
        };
        /**
         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
         * from the corresponding properties of the last observed content rectangle.
         *
         * @returns {DOMRectInit} Last observed content rectangle.
         */
        ResizeObservation.prototype.broadcastRect = function () {
            var rect = this.contentRect_;
            this.broadcastWidth = rect.width;
            this.broadcastHeight = rect.height;
            return rect;
        };
        return ResizeObservation;
    }());

    var ResizeObserverEntry = /** @class */ (function () {
        /**
         * Creates an instance of ResizeObserverEntry.
         *
         * @param {Element} target - Element that is being observed.
         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
         */
        function ResizeObserverEntry(target, rectInit) {
            var contentRect = createReadOnlyRect(rectInit);
            // According to the specification following properties are not writable
            // and are also not enumerable in the native implementation.
            //
            // Property accessors are not being used as they'd require to define a
            // private WeakMap storage which may cause memory leaks in browsers that
            // don't support this type of collections.
            defineConfigurable(this, { target: target, contentRect: contentRect });
        }
        return ResizeObserverEntry;
    }());

    var ResizeObserverSPI = /** @class */ (function () {
        /**
         * Creates a new instance of ResizeObserver.
         *
         * @param {ResizeObserverCallback} callback - Callback function that is invoked
         *      when one of the observed elements changes it's content dimensions.
         * @param {ResizeObserverController} controller - Controller instance which
         *      is responsible for the updates of observer.
         * @param {ResizeObserver} callbackCtx - Reference to the public
         *      ResizeObserver instance which will be passed to callback function.
         */
        function ResizeObserverSPI(callback, controller, callbackCtx) {
            /**
             * Collection of resize observations that have detected changes in dimensions
             * of elements.
             *
             * @private {Array<ResizeObservation>}
             */
            this.activeObservations_ = [];
            /**
             * Registry of the ResizeObservation instances.
             *
             * @private {Map<Element, ResizeObservation>}
             */
            this.observations_ = new MapShim();
            if (typeof callback !== 'function') {
                throw new TypeError('The callback provided as parameter 1 is not a function.');
            }
            this.callback_ = callback;
            this.controller_ = controller;
            this.callbackCtx_ = callbackCtx;
        }
        /**
         * Starts observing provided element.
         *
         * @param {Element} target - Element to be observed.
         * @returns {void}
         */
        ResizeObserverSPI.prototype.observe = function (target) {
            if (!arguments.length) {
                throw new TypeError('1 argument required, but only 0 present.');
            }
            // Do nothing if current environment doesn't have the Element interface.
            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
                return;
            }
            if (!(target instanceof getWindowOf(target).Element)) {
                throw new TypeError('parameter 1 is not of type "Element".');
            }
            var observations = this.observations_;
            // Do nothing if element is already being observed.
            if (observations.has(target)) {
                return;
            }
            observations.set(target, new ResizeObservation(target));
            this.controller_.addObserver(this);
            // Force the update of observations.
            this.controller_.refresh();
        };
        /**
         * Stops observing provided element.
         *
         * @param {Element} target - Element to stop observing.
         * @returns {void}
         */
        ResizeObserverSPI.prototype.unobserve = function (target) {
            if (!arguments.length) {
                throw new TypeError('1 argument required, but only 0 present.');
            }
            // Do nothing if current environment doesn't have the Element interface.
            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
                return;
            }
            if (!(target instanceof getWindowOf(target).Element)) {
                throw new TypeError('parameter 1 is not of type "Element".');
            }
            var observations = this.observations_;
            // Do nothing if element is not being observed.
            if (!observations.has(target)) {
                return;
            }
            observations.delete(target);
            if (!observations.size) {
                this.controller_.removeObserver(this);
            }
        };
        /**
         * Stops observing all elements.
         *
         * @returns {void}
         */
        ResizeObserverSPI.prototype.disconnect = function () {
            this.clearActive();
            this.observations_.clear();
            this.controller_.removeObserver(this);
        };
        /**
         * Collects observation instances the associated element of which has changed
         * it's content rectangle.
         *
         * @returns {void}
         */
        ResizeObserverSPI.prototype.gatherActive = function () {
            var _this = this;
            this.clearActive();
            this.observations_.forEach(function (observation) {
                if (observation.isActive()) {
                    _this.activeObservations_.push(observation);
                }
            });
        };
        /**
         * Invokes initial callback function with a list of ResizeObserverEntry
         * instances collected from active resize observations.
         *
         * @returns {void}
         */
        ResizeObserverSPI.prototype.broadcastActive = function () {
            // Do nothing if observer doesn't have active observations.
            if (!this.hasActive()) {
                return;
            }
            var ctx = this.callbackCtx_;
            // Create ResizeObserverEntry instance for every active observation.
            var entries = this.activeObservations_.map(function (observation) {
                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
            });
            this.callback_.call(ctx, entries, ctx);
            this.clearActive();
        };
        /**
         * Clears the collection of active observations.
         *
         * @returns {void}
         */
        ResizeObserverSPI.prototype.clearActive = function () {
            this.activeObservations_.splice(0);
        };
        /**
         * Tells whether observer has active observations.
         *
         * @returns {boolean}
         */
        ResizeObserverSPI.prototype.hasActive = function () {
            return this.activeObservations_.length > 0;
        };
        return ResizeObserverSPI;
    }());

    // Registry of internal observers. If WeakMap is not available use current shim
    // for the Map collection as it has all required methods and because WeakMap
    // can't be fully polyfilled anyway.
    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
    /**
     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
     * exposing only those methods and properties that are defined in the spec.
     */
    var ResizeObserver = /** @class */ (function () {
        /**
         * Creates a new instance of ResizeObserver.
         *
         * @param {ResizeObserverCallback} callback - Callback that is invoked when
         *      dimensions of the observed elements change.
         */
        function ResizeObserver(callback) {
            if (!(this instanceof ResizeObserver)) {
                throw new TypeError('Cannot call a class as a function.');
            }
            if (!arguments.length) {
                throw new TypeError('1 argument required, but only 0 present.');
            }
            var controller = ResizeObserverController.getInstance();
            var observer = new ResizeObserverSPI(callback, controller, this);
            observers.set(this, observer);
        }
        return ResizeObserver;
    }());
    // Expose public methods of ResizeObserver.
    [
        'observe',
        'unobserve',
        'disconnect'
    ].forEach(function (method) {
        ResizeObserver.prototype[method] = function () {
            var _a;
            return (_a = observers.get(this))[method].apply(_a, arguments);
        };
    });

    var index = (function () {
        // Export existing implementation if available.
        if (typeof global$1.ResizeObserver !== 'undefined') {
            return global$1.ResizeObserver;
        }
        return ResizeObserver;
    })();

    return index;

})));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1138:[function(require,module,exports){
(function () {
    var key, val, _ref, _ref1;
    exports.EncodeStream = require('./src/EncodeStream');
    exports.DecodeStream = require('./src/DecodeStream');
    exports.Array = require('./src/Array');
    exports.LazyArray = require('./src/LazyArray');
    exports.Bitfield = require('./src/Bitfield');
    exports.Boolean = require('./src/Boolean');
    exports.Buffer = require('./src/Buffer');
    exports.Enum = require('./src/Enum');
    exports.Optional = require('./src/Optional');
    exports.Reserved = require('./src/Reserved');
    exports.String = require('./src/String');
    exports.Struct = require('./src/Struct');
    exports.VersionedStruct = require('./src/VersionedStruct');
    _ref = require('./src/Number');
    for (key in _ref) {
        val = _ref[key];
        exports[key] = val;
    }
    _ref1 = require('./src/Pointer');
    for (key in _ref1) {
        val = _ref1[key];
        exports[key] = val;
    }
}.call(this));
},{"./src/Array":1139,"./src/Bitfield":1140,"./src/Boolean":1141,"./src/Buffer":1142,"./src/DecodeStream":1143,"./src/EncodeStream":1144,"./src/Enum":1145,"./src/LazyArray":1146,"./src/Number":1147,"./src/Optional":1148,"./src/Pointer":1149,"./src/Reserved":1150,"./src/String":1151,"./src/Struct":1152,"./src/VersionedStruct":1153}],1139:[function(require,module,exports){
(function () {
    var ArrayT, NumberT, utils;
    NumberT = require('./Number').Number;
    utils = require('./utils');
    ArrayT = function () {
        function ArrayT(type, length, lengthType) {
            this.type = type;
            this.length = length;
            this.lengthType = lengthType != null ? lengthType : 'count';
        }
        ArrayT.prototype.decode = function (stream, parent) {
            var ctx, i, length, pos, res, target, _i;
            pos = stream.pos;
            res = [];
            ctx = parent;
            if (this.length != null) {
                length = utils.resolveLength(this.length, stream, parent);
            }
            if (this.length instanceof NumberT) {
                Object.defineProperties(res, {
                    parent: { value: parent },
                    _startOffset: { value: pos },
                    _currentOffset: {
                        value: 0,
                        writable: true
                    },
                    _length: { value: length }
                });
                ctx = res;
            }
            if (length == null || this.lengthType === 'bytes') {
                target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
                while (stream.pos < target) {
                    res.push(this.type.decode(stream, ctx));
                }
            } else {
                for (i = _i = 0; _i < length; i = _i += 1) {
                    res.push(this.type.decode(stream, ctx));
                }
            }
            return res;
        };
        ArrayT.prototype.size = function (array, ctx) {
            var item, size, _i, _len;
            if (!array) {
                return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
            }
            size = 0;
            if (this.length instanceof NumberT) {
                size += this.length.size();
                ctx = { parent: ctx };
            }
            for (_i = 0, _len = array.length; _i < _len; _i++) {
                item = array[_i];
                size += this.type.size(item, ctx);
            }
            return size;
        };
        ArrayT.prototype.encode = function (stream, array, parent) {
            var ctx, i, item, ptr, _i, _len;
            ctx = parent;
            if (this.length instanceof NumberT) {
                ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent
                };
                ctx.pointerOffset = stream.pos + this.size(array, ctx);
                this.length.encode(stream, array.length);
            }
            for (_i = 0, _len = array.length; _i < _len; _i++) {
                item = array[_i];
                this.type.encode(stream, item, ctx);
            }
            if (this.length instanceof NumberT) {
                i = 0;
                while (i < ctx.pointers.length) {
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val);
                }
            }
        };
        return ArrayT;
    }();
    module.exports = ArrayT;
}.call(this));
},{"./Number":1147,"./utils":1154}],1140:[function(require,module,exports){
(function () {
    var Bitfield;
    Bitfield = function () {
        function Bitfield(type, flags) {
            this.type = type;
            this.flags = flags != null ? flags : [];
        }
        Bitfield.prototype.decode = function (stream) {
            var flag, i, res, val, _i, _len, _ref;
            val = this.type.decode(stream);
            res = {};
            _ref = this.flags;
            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
                flag = _ref[i];
                if (flag != null) {
                    res[flag] = !!(val & 1 << i);
                }
            }
            return res;
        };
        Bitfield.prototype.size = function () {
            return this.type.size();
        };
        Bitfield.prototype.encode = function (stream, keys) {
            var flag, i, val, _i, _len, _ref;
            val = 0;
            _ref = this.flags;
            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
                flag = _ref[i];
                if (flag != null) {
                    if (keys[flag]) {
                        val |= 1 << i;
                    }
                }
            }
            return this.type.encode(stream, val);
        };
        return Bitfield;
    }();
    module.exports = Bitfield;
}.call(this));
},{}],1141:[function(require,module,exports){
(function () {
    var BooleanT;
    BooleanT = function () {
        function BooleanT(type) {
            this.type = type;
        }
        BooleanT.prototype.decode = function (stream, parent) {
            return !!this.type.decode(stream, parent);
        };
        BooleanT.prototype.size = function (val, parent) {
            return this.type.size(val, parent);
        };
        BooleanT.prototype.encode = function (stream, val, parent) {
            return this.type.encode(stream, +val, parent);
        };
        return BooleanT;
    }();
    module.exports = BooleanT;
}.call(this));
},{}],1142:[function(require,module,exports){
(function () {
    var BufferT, NumberT, utils;
    utils = require('./utils');
    NumberT = require('./Number').Number;
    BufferT = function () {
        function BufferT(length) {
            this.length = length;
        }
        BufferT.prototype.decode = function (stream, parent) {
            var length;
            length = utils.resolveLength(this.length, stream, parent);
            return stream.readBuffer(length);
        };
        BufferT.prototype.size = function (val, parent) {
            if (!val) {
                return utils.resolveLength(this.length, null, parent);
            }
            return val.length;
        };
        BufferT.prototype.encode = function (stream, buf, parent) {
            if (this.length instanceof NumberT) {
                this.length.encode(stream, buf.length);
            }
            return stream.writeBuffer(buf);
        };
        return BufferT;
    }();
    module.exports = BufferT;
}.call(this));
},{"./Number":1147,"./utils":1154}],1143:[function(require,module,exports){
(function (Buffer){(function (){
(function () {
    var DecodeStream, iconv;
    try {
        iconv = require('iconv-lite');
    } catch (_error) {
    }
    DecodeStream = function () {
        var key;
        function DecodeStream(buffer) {
            this.buffer = buffer;
            this.pos = 0;
            this.length = this.buffer.length;
        }
        DecodeStream.TYPES = {
            UInt8: 1,
            UInt16: 2,
            UInt24: 3,
            UInt32: 4,
            Int8: 1,
            Int16: 2,
            Int24: 3,
            Int32: 4,
            Float: 4,
            Double: 8
        };
        for (key in Buffer.prototype) {
            if (key.slice(0, 4) === 'read') {
                (function (key) {
                    var bytes;
                    bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
                    return DecodeStream.prototype[key] = function () {
                        var ret;
                        ret = this.buffer[key](this.pos);
                        this.pos += bytes;
                        return ret;
                    };
                }(key));
            }
        }
        DecodeStream.prototype.readString = function (length, encoding) {
            var buf, byte, i, _i, _ref;
            if (encoding == null) {
                encoding = 'ascii';
            }
            switch (encoding) {
            case 'utf16le':
            case 'ucs2':
            case 'utf8':
            case 'ascii':
                return this.buffer.toString(encoding, this.pos, this.pos += length);
            case 'utf16be':
                buf = new Buffer(this.readBuffer(length));
                for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
                    byte = buf[i];
                    buf[i] = buf[i + 1];
                    buf[i + 1] = byte;
                }
                return buf.toString('utf16le');
            default:
                buf = this.readBuffer(length);
                if (iconv) {
                    try {
                        return iconv.decode(buf, encoding);
                    } catch (_error) {
                    }
                }
                return buf;
            }
        };
        DecodeStream.prototype.readBuffer = function (length) {
            return this.buffer.slice(this.pos, this.pos += length);
        };
        DecodeStream.prototype.readUInt24BE = function () {
            return (this.readUInt16BE() << 8) + this.readUInt8();
        };
        DecodeStream.prototype.readUInt24LE = function () {
            return this.readUInt16LE() + (this.readUInt8() << 16);
        };
        DecodeStream.prototype.readInt24BE = function () {
            return (this.readInt16BE() << 8) + this.readUInt8();
        };
        DecodeStream.prototype.readInt24LE = function () {
            return this.readUInt16LE() + (this.readInt8() << 16);
        };
        return DecodeStream;
    }();
    module.exports = DecodeStream;
}.call(this));
}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":404,"iconv-lite":665}],1144:[function(require,module,exports){
(function (Buffer){(function (){
(function () {
    var DecodeStream, EncodeStream, iconv, stream, __hasProp = {}.hasOwnProperty, __extends = function (child, parent) {
            for (var key in parent) {
                if (__hasProp.call(parent, key))
                    child[key] = parent[key];
            }
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
    stream = require('stream');
    DecodeStream = require('./DecodeStream');
    try {
        iconv = require('iconv-lite');
    } catch (_error) {
    }
    EncodeStream = function (_super) {
        var key;
        __extends(EncodeStream, _super);
        function EncodeStream(bufferSize) {
            if (bufferSize == null) {
                bufferSize = 65536;
            }
            EncodeStream.__super__.constructor.apply(this, arguments);
            this.buffer = new Buffer(bufferSize);
            this.bufferOffset = 0;
            this.pos = 0;
        }
        for (key in Buffer.prototype) {
            if (key.slice(0, 5) === 'write') {
                (function (key) {
                    var bytes;
                    bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];
                    return EncodeStream.prototype[key] = function (value) {
                        this.ensure(bytes);
                        this.buffer[key](value, this.bufferOffset);
                        this.bufferOffset += bytes;
                        return this.pos += bytes;
                    };
                }(key));
            }
        }
        EncodeStream.prototype._read = function () {
        };
        EncodeStream.prototype.ensure = function (bytes) {
            if (this.bufferOffset + bytes > this.buffer.length) {
                return this.flush();
            }
        };
        EncodeStream.prototype.flush = function () {
            if (this.bufferOffset > 0) {
                this.push(new Buffer(this.buffer.slice(0, this.bufferOffset)));
                return this.bufferOffset = 0;
            }
        };
        EncodeStream.prototype.writeBuffer = function (buffer) {
            this.flush();
            this.push(buffer);
            return this.pos += buffer.length;
        };
        EncodeStream.prototype.writeString = function (string, encoding) {
            var buf, byte, i, _i, _ref;
            if (encoding == null) {
                encoding = 'ascii';
            }
            switch (encoding) {
            case 'utf16le':
            case 'ucs2':
            case 'utf8':
            case 'ascii':
                return this.writeBuffer(new Buffer(string, encoding));
            case 'utf16be':
                buf = new Buffer(string, 'utf16le');
                for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
                    byte = buf[i];
                    buf[i] = buf[i + 1];
                    buf[i + 1] = byte;
                }
                return this.writeBuffer(buf);
            default:
                if (iconv) {
                    return this.writeBuffer(iconv.encode(string, encoding));
                } else {
                    throw new Error('Install iconv-lite to enable additional string encodings.');
                }
            }
        };
        EncodeStream.prototype.writeUInt24BE = function (val) {
            this.ensure(3);
            this.buffer[this.bufferOffset++] = val >>> 16 & 255;
            this.buffer[this.bufferOffset++] = val >>> 8 & 255;
            this.buffer[this.bufferOffset++] = val & 255;
            return this.pos += 3;
        };
        EncodeStream.prototype.writeUInt24LE = function (val) {
            this.ensure(3);
            this.buffer[this.bufferOffset++] = val & 255;
            this.buffer[this.bufferOffset++] = val >>> 8 & 255;
            this.buffer[this.bufferOffset++] = val >>> 16 & 255;
            return this.pos += 3;
        };
        EncodeStream.prototype.writeInt24BE = function (val) {
            if (val >= 0) {
                return this.writeUInt24BE(val);
            } else {
                return this.writeUInt24BE(val + 16777215 + 1);
            }
        };
        EncodeStream.prototype.writeInt24LE = function (val) {
            if (val >= 0) {
                return this.writeUInt24LE(val);
            } else {
                return this.writeUInt24LE(val + 16777215 + 1);
            }
        };
        EncodeStream.prototype.fill = function (val, length) {
            var buf;
            if (length < this.buffer.length) {
                this.ensure(length);
                this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
                this.bufferOffset += length;
                return this.pos += length;
            } else {
                buf = new Buffer(length);
                buf.fill(val);
                return this.writeBuffer(buf);
            }
        };
        EncodeStream.prototype.end = function () {
            this.flush();
            return this.push(null);
        };
        return EncodeStream;
    }(stream.Readable);
    module.exports = EncodeStream;
}.call(this));
}).call(this)}).call(this,require("buffer").Buffer)
},{"./DecodeStream":1143,"buffer":404,"iconv-lite":665,"stream":1191}],1145:[function(require,module,exports){
(function () {
    var Enum;
    Enum = function () {
        function Enum(type, options) {
            this.type = type;
            this.options = options != null ? options : [];
        }
        Enum.prototype.decode = function (stream) {
            var index;
            index = this.type.decode(stream);
            return this.options[index] || index;
        };
        Enum.prototype.size = function () {
            return this.type.size();
        };
        Enum.prototype.encode = function (stream, val) {
            var index;
            index = this.options.indexOf(val);
            if (index === -1) {
                throw new Error('Unknown option in enum: ' + val);
            }
            return this.type.encode(stream, index);
        };
        return Enum;
    }();
    module.exports = Enum;
}.call(this));
},{}],1146:[function(require,module,exports){
(function () {
    var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils, __hasProp = {}.hasOwnProperty, __extends = function (child, parent) {
            for (var key in parent) {
                if (__hasProp.call(parent, key))
                    child[key] = parent[key];
            }
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
    ArrayT = require('./Array');
    NumberT = require('./Number').Number;
    utils = require('./utils');
    inspect = require('util').inspect;
    LazyArrayT = function (_super) {
        __extends(LazyArrayT, _super);
        function LazyArrayT() {
            return LazyArrayT.__super__.constructor.apply(this, arguments);
        }
        LazyArrayT.prototype.decode = function (stream, parent) {
            var length, pos, res;
            pos = stream.pos;
            length = utils.resolveLength(this.length, stream, parent);
            if (this.length instanceof NumberT) {
                parent = {
                    parent: parent,
                    _startOffset: pos,
                    _currentOffset: 0,
                    _length: length
                };
            }
            res = new LazyArray(this.type, length, stream, parent);
            stream.pos += length * this.type.size(null, parent);
            return res;
        };
        LazyArrayT.prototype.size = function (val, ctx) {
            if (val instanceof LazyArray) {
                val = val.toArray();
            }
            return LazyArrayT.__super__.size.call(this, val, ctx);
        };
        LazyArrayT.prototype.encode = function (stream, val, ctx) {
            if (val instanceof LazyArray) {
                val = val.toArray();
            }
            return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
        };
        return LazyArrayT;
    }(ArrayT);
    LazyArray = function () {
        function LazyArray(type, length, stream, ctx) {
            this.type = type;
            this.length = length;
            this.stream = stream;
            this.ctx = ctx;
            this.base = this.stream.pos;
            this.items = [];
        }
        LazyArray.prototype.get = function (index) {
            var pos;
            if (index < 0 || index >= this.length) {
                return void 0;
            }
            if (this.items[index] == null) {
                pos = this.stream.pos;
                this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
                this.items[index] = this.type.decode(this.stream, this.ctx);
                this.stream.pos = pos;
            }
            return this.items[index];
        };
        LazyArray.prototype.toArray = function () {
            var i, _i, _ref, _results;
            _results = [];
            for (i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1) {
                _results.push(this.get(i));
            }
            return _results;
        };
        LazyArray.prototype.inspect = function () {
            return inspect(this.toArray());
        };
        return LazyArray;
    }();
    module.exports = LazyArrayT;
}.call(this));
},{"./Array":1139,"./Number":1147,"./utils":1154,"util":1217}],1147:[function(require,module,exports){
(function () {
    var DecodeStream, Fixed, NumberT, __hasProp = {}.hasOwnProperty, __extends = function (child, parent) {
            for (var key in parent) {
                if (__hasProp.call(parent, key))
                    child[key] = parent[key];
            }
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
    DecodeStream = require('./DecodeStream');
    NumberT = function () {
        function NumberT(type, endian) {
            this.type = type;
            this.endian = endian != null ? endian : 'BE';
            this.fn = this.type;
            if (this.type[this.type.length - 1] !== '8') {
                this.fn += this.endian;
            }
        }
        NumberT.prototype.size = function () {
            return DecodeStream.TYPES[this.type];
        };
        NumberT.prototype.decode = function (stream) {
            return stream['read' + this.fn]();
        };
        NumberT.prototype.encode = function (stream, val) {
            return stream['write' + this.fn](val);
        };
        return NumberT;
    }();
    exports.Number = NumberT;
    exports.uint8 = new NumberT('UInt8');
    exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
    exports.uint16le = new NumberT('UInt16', 'LE');
    exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
    exports.uint24le = new NumberT('UInt24', 'LE');
    exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
    exports.uint32le = new NumberT('UInt32', 'LE');
    exports.int8 = new NumberT('Int8');
    exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
    exports.int16le = new NumberT('Int16', 'LE');
    exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
    exports.int24le = new NumberT('Int24', 'LE');
    exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
    exports.int32le = new NumberT('Int32', 'LE');
    exports.floatbe = exports.float = new NumberT('Float', 'BE');
    exports.floatle = new NumberT('Float', 'LE');
    exports.doublebe = exports.double = new NumberT('Double', 'BE');
    exports.doublele = new NumberT('Double', 'LE');
    Fixed = function (_super) {
        __extends(Fixed, _super);
        function Fixed(size, endian, fracBits) {
            if (fracBits == null) {
                fracBits = size >> 1;
            }
            Fixed.__super__.constructor.call(this, 'Int' + size, endian);
            this._point = 1 << fracBits;
        }
        Fixed.prototype.decode = function (stream) {
            return Fixed.__super__.decode.call(this, stream) / this._point;
        };
        Fixed.prototype.encode = function (stream, val) {
            return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
        };
        return Fixed;
    }(NumberT);
    exports.Fixed = Fixed;
    exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
    exports.fixed16le = new Fixed(16, 'LE');
    exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
    exports.fixed32le = new Fixed(32, 'LE');
}.call(this));
},{"./DecodeStream":1143}],1148:[function(require,module,exports){
(function () {
    var Optional;
    Optional = function () {
        function Optional(type, condition) {
            this.type = type;
            this.condition = condition != null ? condition : true;
        }
        Optional.prototype.decode = function (stream, parent) {
            var condition;
            condition = this.condition;
            if (typeof condition === 'function') {
                condition = condition.call(parent, parent);
            }
            if (condition) {
                return this.type.decode(stream, parent);
            }
        };
        Optional.prototype.size = function (val, parent) {
            var condition;
            condition = this.condition;
            if (typeof condition === 'function') {
                condition = condition.call(parent, parent);
            }
            if (condition) {
                return this.type.size(val, parent);
            } else {
                return 0;
            }
        };
        Optional.prototype.encode = function (stream, val, parent) {
            var condition;
            condition = this.condition;
            if (typeof condition === 'function') {
                condition = condition.call(parent, parent);
            }
            if (condition) {
                return this.type.encode(stream, val, parent);
            }
        };
        return Optional;
    }();
    module.exports = Optional;
}.call(this));
},{}],1149:[function(require,module,exports){
(function () {
    var Pointer, VoidPointer, utils;
    utils = require('./utils');
    Pointer = function () {
        function Pointer(offsetType, type, options) {
            var _base, _base1, _base2, _base3;
            this.offsetType = offsetType;
            this.type = type;
            this.options = options != null ? options : {};
            if (this.type === 'void') {
                this.type = null;
            }
            if ((_base = this.options).type == null) {
                _base.type = 'local';
            }
            if ((_base1 = this.options).allowNull == null) {
                _base1.allowNull = true;
            }
            if ((_base2 = this.options).nullValue == null) {
                _base2.nullValue = 0;
            }
            if ((_base3 = this.options).lazy == null) {
                _base3.lazy = false;
            }
            if (this.options.relativeTo) {
                this.relativeToGetter = new Function('ctx', 'return ctx.' + this.options.relativeTo);
            }
        }
        Pointer.prototype.decode = function (stream, ctx) {
            var c, decodeValue, offset, ptr, relative, val;
            offset = this.offsetType.decode(stream, ctx);
            if (offset === this.options.nullValue && this.options.allowNull) {
                return null;
            }
            relative = function () {
                switch (this.options.type) {
                case 'local':
                    return ctx._startOffset;
                case 'immediate':
                    return stream.pos - this.offsetType.size();
                case 'parent':
                    return ctx.parent._startOffset;
                default:
                    c = ctx;
                    while (c.parent) {
                        c = c.parent;
                    }
                    return c._startOffset || 0;
                }
            }.call(this);
            if (this.options.relativeTo) {
                relative += this.relativeToGetter(ctx);
            }
            ptr = offset + relative;
            if (this.type != null) {
                val = null;
                decodeValue = function (_this) {
                    return function () {
                        var pos;
                        if (val != null) {
                            return val;
                        }
                        pos = stream.pos;
                        stream.pos = ptr;
                        val = _this.type.decode(stream, ctx);
                        stream.pos = pos;
                        return val;
                    };
                }(this);
                if (this.options.lazy) {
                    return new utils.PropertyDescriptor({ get: decodeValue });
                }
                return decodeValue();
            } else {
                return ptr;
            }
        };
        Pointer.prototype.size = function (val, ctx) {
            var parent, type;
            parent = ctx;
            switch (this.options.type) {
            case 'local':
            case 'immediate':
                break;
            case 'parent':
                ctx = ctx.parent;
                break;
            default:
                while (ctx.parent) {
                    ctx = ctx.parent;
                }
            }
            type = this.type;
            if (type == null) {
                if (!(val instanceof VoidPointer)) {
                    throw new Error('Must be a VoidPointer');
                }
                type = val.type;
                val = val.value;
            }
            if (val && ctx) {
                ctx.pointerSize += type.size(val, parent);
            }
            return this.offsetType.size();
        };
        Pointer.prototype.encode = function (stream, val, ctx) {
            var parent, relative, type;
            parent = ctx;
            if (val == null) {
                this.offsetType.encode(stream, this.options.nullValue);
                return;
            }
            switch (this.options.type) {
            case 'local':
                relative = ctx.startOffset;
                break;
            case 'immediate':
                relative = stream.pos + this.offsetType.size(val, parent);
                break;
            case 'parent':
                ctx = ctx.parent;
                relative = ctx.startOffset;
                break;
            default:
                relative = 0;
                while (ctx.parent) {
                    ctx = ctx.parent;
                }
            }
            if (this.options.relativeTo) {
                relative += this.relativeToGetter(parent.val);
            }
            this.offsetType.encode(stream, ctx.pointerOffset - relative);
            type = this.type;
            if (type == null) {
                if (!(val instanceof VoidPointer)) {
                    throw new Error('Must be a VoidPointer');
                }
                type = val.type;
                val = val.value;
            }
            ctx.pointers.push({
                type: type,
                val: val,
                parent: parent
            });
            return ctx.pointerOffset += type.size(val, parent);
        };
        return Pointer;
    }();
    VoidPointer = function () {
        function VoidPointer(type, value) {
            this.type = type;
            this.value = value;
        }
        return VoidPointer;
    }();
    exports.Pointer = Pointer;
    exports.VoidPointer = VoidPointer;
}.call(this));
},{"./utils":1154}],1150:[function(require,module,exports){
(function () {
    var Reserved, utils;
    utils = require('./utils');
    Reserved = function () {
        function Reserved(type, count) {
            this.type = type;
            this.count = count != null ? count : 1;
        }
        Reserved.prototype.decode = function (stream, parent) {
            stream.pos += this.size(null, parent);
            return void 0;
        };
        Reserved.prototype.size = function (data, parent) {
            var count;
            count = utils.resolveLength(this.count, null, parent);
            return this.type.size() * count;
        };
        Reserved.prototype.encode = function (stream, val, parent) {
            return stream.fill(0, this.size(val, parent));
        };
        return Reserved;
    }();
    module.exports = Reserved;
}.call(this));
},{"./utils":1154}],1151:[function(require,module,exports){
(function (Buffer){(function (){
(function () {
    var NumberT, StringT, utils;
    NumberT = require('./Number').Number;
    utils = require('./utils');
    StringT = function () {
        function StringT(length, encoding) {
            this.length = length;
            this.encoding = encoding != null ? encoding : 'ascii';
        }
        StringT.prototype.decode = function (stream, parent) {
            var buffer, encoding, length, pos, string;
            length = function () {
                if (this.length != null) {
                    return utils.resolveLength(this.length, stream, parent);
                } else {
                    buffer = stream.buffer, length = stream.length, pos = stream.pos;
                    while (pos < length && buffer[pos] !== 0) {
                        ++pos;
                    }
                    return pos - stream.pos;
                }
            }.call(this);
            encoding = this.encoding;
            if (typeof encoding === 'function') {
                encoding = encoding.call(parent, parent) || 'ascii';
            }
            string = stream.readString(length, encoding);
            if (this.length == null && stream.pos < stream.length) {
                stream.pos++;
            }
            return string;
        };
        StringT.prototype.size = function (val, parent) {
            var encoding, size;
            if (!val) {
                return utils.resolveLength(this.length, null, parent);
            }
            encoding = this.encoding;
            if (typeof encoding === 'function') {
                encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
            }
            if (encoding === 'utf16be') {
                encoding = 'utf16le';
            }
            size = Buffer.byteLength(val, encoding);
            if (this.length instanceof NumberT) {
                size += this.length.size();
            }
            if (this.length == null) {
                size++;
            }
            return size;
        };
        StringT.prototype.encode = function (stream, val, parent) {
            var encoding;
            encoding = this.encoding;
            if (typeof encoding === 'function') {
                encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
            }
            if (this.length instanceof NumberT) {
                this.length.encode(stream, Buffer.byteLength(val, encoding));
            }
            stream.writeString(val, encoding);
            if (this.length == null) {
                return stream.writeUInt8(0);
            }
        };
        return StringT;
    }();
    module.exports = StringT;
}.call(this));
}).call(this)}).call(this,require("buffer").Buffer)
},{"./Number":1147,"./utils":1154,"buffer":404}],1152:[function(require,module,exports){
(function () {
    var Struct, utils;
    utils = require('./utils');
    Struct = function () {
        function Struct(fields) {
            this.fields = fields != null ? fields : {};
        }
        Struct.prototype.decode = function (stream, parent, length) {
            var res, _ref;
            if (length == null) {
                length = 0;
            }
            res = this._setup(stream, parent, length);
            this._parseFields(stream, res, this.fields);
            if ((_ref = this.process) != null) {
                _ref.call(res, stream);
            }
            return res;
        };
        Struct.prototype._setup = function (stream, parent, length) {
            var res;
            res = {};
            Object.defineProperties(res, {
                parent: { value: parent },
                _startOffset: { value: stream.pos },
                _currentOffset: {
                    value: 0,
                    writable: true
                },
                _length: { value: length }
            });
            return res;
        };
        Struct.prototype._parseFields = function (stream, res, fields) {
            var key, type, val;
            for (key in fields) {
                type = fields[key];
                if (typeof type === 'function') {
                    val = type.call(res, res);
                } else {
                    val = type.decode(stream, res);
                }
                if (val !== void 0) {
                    if (val instanceof utils.PropertyDescriptor) {
                        Object.defineProperty(res, key, val);
                    } else {
                        res[key] = val;
                    }
                }
                res._currentOffset = stream.pos - res._startOffset;
            }
        };
        Struct.prototype.size = function (val, parent, includePointers) {
            var ctx, key, size, type, _ref;
            if (val == null) {
                val = {};
            }
            if (includePointers == null) {
                includePointers = true;
            }
            ctx = {
                parent: parent,
                val: val,
                pointerSize: 0
            };
            size = 0;
            _ref = this.fields;
            for (key in _ref) {
                type = _ref[key];
                if (type.size != null) {
                    size += type.size(val[key], ctx);
                }
            }
            if (includePointers) {
                size += ctx.pointerSize;
            }
            return size;
        };
        Struct.prototype.encode = function (stream, val, parent) {
            var ctx, i, key, ptr, type, _ref, _ref1;
            if ((_ref = this.preEncode) != null) {
                _ref.call(val, stream);
            }
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent: parent,
                val: val,
                pointerSize: 0
            };
            ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
            _ref1 = this.fields;
            for (key in _ref1) {
                type = _ref1[key];
                if (type.encode != null) {
                    type.encode(stream, val[key], ctx);
                }
            }
            i = 0;
            while (i < ctx.pointers.length) {
                ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        };
        return Struct;
    }();
    module.exports = Struct;
}.call(this));
},{"./utils":1154}],1153:[function(require,module,exports){
(function () {
    var Struct, VersionedStruct, __hasProp = {}.hasOwnProperty, __extends = function (child, parent) {
            for (var key in parent) {
                if (__hasProp.call(parent, key))
                    child[key] = parent[key];
            }
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
    Struct = require('./Struct');
    VersionedStruct = function (_super) {
        __extends(VersionedStruct, _super);
        function VersionedStruct(type, versions) {
            this.type = type;
            this.versions = versions != null ? versions : {};
            if (typeof this.type === 'string') {
                this.versionGetter = new Function('parent', 'return parent.' + this.type);
                this.versionSetter = new Function('parent', 'version', 'return parent.' + this.type + ' = version');
            }
        }
        VersionedStruct.prototype.decode = function (stream, parent, length) {
            var fields, res, _ref;
            if (length == null) {
                length = 0;
            }
            res = this._setup(stream, parent, length);
            if (typeof this.type === 'string') {
                res.version = this.versionGetter(parent);
            } else {
                res.version = this.type.decode(stream);
            }
            if (this.versions.header) {
                this._parseFields(stream, res, this.versions.header);
            }
            fields = this.versions[res.version];
            if (fields == null) {
                throw new Error('Unknown version ' + res.version);
            }
            if (fields instanceof VersionedStruct) {
                return fields.decode(stream, parent);
            }
            this._parseFields(stream, res, fields);
            if ((_ref = this.process) != null) {
                _ref.call(res, stream);
            }
            return res;
        };
        VersionedStruct.prototype.size = function (val, parent, includePointers) {
            var ctx, fields, key, size, type, _ref;
            if (includePointers == null) {
                includePointers = true;
            }
            if (!val) {
                throw new Error('Not a fixed size');
            }
            ctx = {
                parent: parent,
                val: val,
                pointerSize: 0
            };
            size = 0;
            if (typeof this.type !== 'string') {
                size += this.type.size(val.version, ctx);
            }
            if (this.versions.header) {
                _ref = this.versions.header;
                for (key in _ref) {
                    type = _ref[key];
                    if (type.size != null) {
                        size += type.size(val[key], ctx);
                    }
                }
            }
            fields = this.versions[val.version];
            if (fields == null) {
                throw new Error('Unknown version ' + val.version);
            }
            for (key in fields) {
                type = fields[key];
                if (type.size != null) {
                    size += type.size(val[key], ctx);
                }
            }
            if (includePointers) {
                size += ctx.pointerSize;
            }
            return size;
        };
        VersionedStruct.prototype.encode = function (stream, val, parent) {
            var ctx, fields, i, key, ptr, type, _ref, _ref1;
            if ((_ref = this.preEncode) != null) {
                _ref.call(val, stream);
            }
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent: parent,
                val: val,
                pointerSize: 0
            };
            ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
            if (typeof this.type !== 'string') {
                this.type.encode(stream, val.version);
            }
            if (this.versions.header) {
                _ref1 = this.versions.header;
                for (key in _ref1) {
                    type = _ref1[key];
                    if (type.encode != null) {
                        type.encode(stream, val[key], ctx);
                    }
                }
            }
            fields = this.versions[val.version];
            for (key in fields) {
                type = fields[key];
                if (type.encode != null) {
                    type.encode(stream, val[key], ctx);
                }
            }
            i = 0;
            while (i < ctx.pointers.length) {
                ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        };
        return VersionedStruct;
    }(Struct);
    module.exports = VersionedStruct;
}.call(this));
},{"./Struct":1152}],1154:[function(require,module,exports){
(function () {
    var NumberT, PropertyDescriptor;
    NumberT = require('./Number').Number;
    exports.resolveLength = function (length, stream, parent) {
        var res;
        if (typeof length === 'number') {
            res = length;
        } else if (typeof length === 'function') {
            res = length.call(parent, parent);
        } else if (parent && typeof length === 'string') {
            res = parent[length];
        } else if (stream && length instanceof NumberT) {
            res = length.decode(stream);
        }
        if (isNaN(res)) {
            throw new Error('Not a fixed size');
        }
        return res;
    };
    PropertyDescriptor = function () {
        function PropertyDescriptor(opts) {
            var key, val;
            if (opts == null) {
                opts = {};
            }
            this.enumerable = true;
            this.configurable = true;
            for (key in opts) {
                val = opts[key];
                this[key] = val;
            }
        }
        return PropertyDescriptor;
    }();
    exports.PropertyDescriptor = PropertyDescriptor;
}.call(this));
},{"./Number":1147}],1155:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":404}],1156:[function(require,module,exports){
(function (process){(function (){
/* eslint-disable node/no-deprecated-api */

'use strict'

var buffer = require('buffer')
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

}).call(this)}).call(this,require('_process'))
},{"_process":405,"buffer":404}],1157:[function(require,module,exports){
/** @license React v0.20.1
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

if ("production" !== "production") {
  (function() {
'use strict';

var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

var interactionIDCounter = 0;
var threadIDCounter = 0; // Set of currently traced interactions.
// Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.

exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

exports.__subscriberRef = null;

{
  exports.__interactionsRef = {
    current: new Set()
  };
  exports.__subscriberRef = {
    current: null
  };
}
function unstable_clear(callback) {

  var prevInteractions = exports.__interactionsRef.current;
  exports.__interactionsRef.current = new Set();

  try {
    return callback();
  } finally {
    exports.__interactionsRef.current = prevInteractions;
  }
}
function unstable_getCurrent() {
  {
    return exports.__interactionsRef.current;
  }
}
function unstable_getThreadID() {
  return ++threadIDCounter;
}
function unstable_trace(name, timestamp, callback) {
  var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;

  var interaction = {
    __count: 1,
    id: interactionIDCounter++,
    name: name,
    timestamp: timestamp
  };
  var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
  // To do that, clone the current interactions.
  // The previous set will be restored upon completion.

  var interactions = new Set(prevInteractions);
  interactions.add(interaction);
  exports.__interactionsRef.current = interactions;
  var subscriber = exports.__subscriberRef.current;
  var returnValue;

  try {
    if (subscriber !== null) {
      subscriber.onInteractionTraced(interaction);
    }
  } finally {
    try {
      if (subscriber !== null) {
        subscriber.onWorkStarted(interactions, threadID);
      }
    } finally {
      try {
        returnValue = callback();
      } finally {
        exports.__interactionsRef.current = prevInteractions;

        try {
          if (subscriber !== null) {
            subscriber.onWorkStopped(interactions, threadID);
          }
        } finally {
          interaction.__count--; // If no async work was scheduled for this interaction,
          // Notify subscribers that it's completed.

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        }
      }
    }
  }

  return returnValue;
}
function unstable_wrap(callback) {
  var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;

  var wrappedInteractions = exports.__interactionsRef.current;
  var subscriber = exports.__subscriberRef.current;

  if (subscriber !== null) {
    subscriber.onWorkScheduled(wrappedInteractions, threadID);
  } // Update the pending async work count for the current interactions.
  // Update after calling subscribers in case of error.


  wrappedInteractions.forEach(function (interaction) {
    interaction.__count++;
  });
  var hasRun = false;

  function wrapped() {
    var prevInteractions = exports.__interactionsRef.current;
    exports.__interactionsRef.current = wrappedInteractions;
    subscriber = exports.__subscriberRef.current;

    try {
      var returnValue;

      try {
        if (subscriber !== null) {
          subscriber.onWorkStarted(wrappedInteractions, threadID);
        }
      } finally {
        try {
          returnValue = callback.apply(undefined, arguments);
        } finally {
          exports.__interactionsRef.current = prevInteractions;

          if (subscriber !== null) {
            subscriber.onWorkStopped(wrappedInteractions, threadID);
          }
        }
      }

      return returnValue;
    } finally {
      if (!hasRun) {
        // We only expect a wrapped function to be executed once,
        // But in the event that it's executed more than once–
        // Only decrement the outstanding interaction counts once.
        hasRun = true; // Update pending async counts for all wrapped interactions.
        // If this was the last scheduled async work for any of them,
        // Mark them as completed.

        wrappedInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        });
      }
    }
  }

  wrapped.cancel = function cancel() {
    subscriber = exports.__subscriberRef.current;

    try {
      if (subscriber !== null) {
        subscriber.onWorkCanceled(wrappedInteractions, threadID);
      }
    } finally {
      // Update pending async counts for all wrapped interactions.
      // If this was the last scheduled async work for any of them,
      // Mark them as completed.
      wrappedInteractions.forEach(function (interaction) {
        interaction.__count--;

        if (subscriber && interaction.__count === 0) {
          subscriber.onInteractionScheduledWorkCompleted(interaction);
        }
      });
    }
  };

  return wrapped;
}

var subscribers = null;

{
  subscribers = new Set();
}

function unstable_subscribe(subscriber) {
  {
    subscribers.add(subscriber);

    if (subscribers.size === 1) {
      exports.__subscriberRef.current = {
        onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
        onInteractionTraced: onInteractionTraced,
        onWorkCanceled: onWorkCanceled,
        onWorkScheduled: onWorkScheduled,
        onWorkStarted: onWorkStarted,
        onWorkStopped: onWorkStopped
      };
    }
  }
}
function unstable_unsubscribe(subscriber) {
  {
    subscribers.delete(subscriber);

    if (subscribers.size === 0) {
      exports.__subscriberRef.current = null;
    }
  }
}

function onInteractionTraced(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionTraced(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onInteractionScheduledWorkCompleted(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionScheduledWorkCompleted(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkScheduled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkScheduled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStarted(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStarted(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStopped(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStopped(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkCanceled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkCanceled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

exports.unstable_clear = unstable_clear;
exports.unstable_getCurrent = unstable_getCurrent;
exports.unstable_getThreadID = unstable_getThreadID;
exports.unstable_subscribe = unstable_subscribe;
exports.unstable_trace = unstable_trace;
exports.unstable_unsubscribe = unstable_unsubscribe;
exports.unstable_wrap = unstable_wrap;
  })();
}

},{}],1158:[function(require,module,exports){
/** @license React v0.20.1
 * scheduler-tracing.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';var b=0;exports.__interactionsRef=null;exports.__subscriberRef=null;exports.unstable_clear=function(a){return a()};exports.unstable_getCurrent=function(){return null};exports.unstable_getThreadID=function(){return++b};exports.unstable_subscribe=function(){};exports.unstable_trace=function(a,d,c){return c()};exports.unstable_unsubscribe=function(){};exports.unstable_wrap=function(a){return a};

},{}],1159:[function(require,module,exports){
/** @license React v0.20.1
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

if ("production" !== "production") {
  (function() {
'use strict';

var enableSchedulerDebugging = false;
var enableProfiling = true;

var requestHostCallback;
var requestHostTimeout;
var cancelHostTimeout;
var requestPaint;
var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

if (hasPerformanceNow) {
  var localPerformance = performance;

  exports.unstable_now = function () {
    return localPerformance.now();
  };
} else {
  var localDate = Date;
  var initialTime = localDate.now();

  exports.unstable_now = function () {
    return localDate.now() - initialTime;
  };
}

if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
// implementation using setTimeout.
typeof window === 'undefined' || // Check if MessageChannel is supported, too.
typeof MessageChannel !== 'function') {
  // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
  // fallback to a naive implementation.
  var _callback = null;
  var _timeoutID = null;

  var _flushCallback = function () {
    if (_callback !== null) {
      try {
        var currentTime = exports.unstable_now();
        var hasRemainingTime = true;

        _callback(hasRemainingTime, currentTime);

        _callback = null;
      } catch (e) {
        setTimeout(_flushCallback, 0);
        throw e;
      }
    }
  };

  requestHostCallback = function (cb) {
    if (_callback !== null) {
      // Protect against re-entrancy.
      setTimeout(requestHostCallback, 0, cb);
    } else {
      _callback = cb;
      setTimeout(_flushCallback, 0);
    }
  };

  requestHostTimeout = function (cb, ms) {
    _timeoutID = setTimeout(cb, ms);
  };

  cancelHostTimeout = function () {
    clearTimeout(_timeoutID);
  };

  exports.unstable_shouldYield = function () {
    return false;
  };

  requestPaint = exports.unstable_forceFrameRate = function () {};
} else {
  // Capture local references to native APIs, in case a polyfill overrides them.
  var _setTimeout = window.setTimeout;
  var _clearTimeout = window.clearTimeout;

  if (typeof console !== 'undefined') {
    // TODO: Scheduler no longer requires these methods to be polyfilled. But
    // maybe we want to continue warning if they don't exist, to preserve the
    // option to rely on it in the future?
    var requestAnimationFrame = window.requestAnimationFrame;
    var cancelAnimationFrame = window.cancelAnimationFrame;

    if (typeof requestAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }

    if (typeof cancelAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }
  }

  var isMessageLoopRunning = false;
  var scheduledHostCallback = null;
  var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
  // thread, like user events. By default, it yields multiple times per frame.
  // It does not attempt to align with frame boundaries, since most tasks don't
  // need to be frame aligned; for those that do, use requestAnimationFrame.

  var yieldInterval = 5;
  var deadline = 0; // TODO: Make this configurable

  {
    // `isInputPending` is not available. Since we have no way of knowing if
    // there's pending input, always yield at the end of the frame.
    exports.unstable_shouldYield = function () {
      return exports.unstable_now() >= deadline;
    }; // Since we yield every frame regardless, `requestPaint` has no effect.


    requestPaint = function () {};
  }

  exports.unstable_forceFrameRate = function (fps) {
    if (fps < 0 || fps > 125) {
      // Using console['error'] to evade Babel and ESLint
      console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
      return;
    }

    if (fps > 0) {
      yieldInterval = Math.floor(1000 / fps);
    } else {
      // reset the framerate
      yieldInterval = 5;
    }
  };

  var performWorkUntilDeadline = function () {
    if (scheduledHostCallback !== null) {
      var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
      // cycle. This means there's always time remaining at the beginning of
      // the message event.

      deadline = currentTime + yieldInterval;
      var hasTimeRemaining = true;

      try {
        var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);

        if (!hasMoreWork) {
          isMessageLoopRunning = false;
          scheduledHostCallback = null;
        } else {
          // If there's more work, schedule the next message event at the end
          // of the preceding one.
          port.postMessage(null);
        }
      } catch (error) {
        // If a scheduler task throws, exit the current browser task so the
        // error can be observed.
        port.postMessage(null);
        throw error;
      }
    } else {
      isMessageLoopRunning = false;
    } // Yielding to the browser will give it a chance to paint, so we can
  };

  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = performWorkUntilDeadline;

  requestHostCallback = function (callback) {
    scheduledHostCallback = callback;

    if (!isMessageLoopRunning) {
      isMessageLoopRunning = true;
      port.postMessage(null);
    }
  };

  requestHostTimeout = function (callback, ms) {
    taskTimeoutID = _setTimeout(function () {
      callback(exports.unstable_now());
    }, ms);
  };

  cancelHostTimeout = function () {
    _clearTimeout(taskTimeoutID);

    taskTimeoutID = -1;
  };
}

function push(heap, node) {
  var index = heap.length;
  heap.push(node);
  siftUp(heap, node, index);
}
function peek(heap) {
  var first = heap[0];
  return first === undefined ? null : first;
}
function pop(heap) {
  var first = heap[0];

  if (first !== undefined) {
    var last = heap.pop();

    if (last !== first) {
      heap[0] = last;
      siftDown(heap, last, 0);
    }

    return first;
  } else {
    return null;
  }
}

function siftUp(heap, node, i) {
  var index = i;

  while (true) {
    var parentIndex = index - 1 >>> 1;
    var parent = heap[parentIndex];

    if (parent !== undefined && compare(parent, node) > 0) {
      // The parent is larger. Swap positions.
      heap[parentIndex] = node;
      heap[index] = parent;
      index = parentIndex;
    } else {
      // The parent is smaller. Exit.
      return;
    }
  }
}

function siftDown(heap, node, i) {
  var index = i;
  var length = heap.length;

  while (index < length) {
    var leftIndex = (index + 1) * 2 - 1;
    var left = heap[leftIndex];
    var rightIndex = leftIndex + 1;
    var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

    if (left !== undefined && compare(left, node) < 0) {
      if (right !== undefined && compare(right, left) < 0) {
        heap[index] = right;
        heap[rightIndex] = node;
        index = rightIndex;
      } else {
        heap[index] = left;
        heap[leftIndex] = node;
        index = leftIndex;
      }
    } else if (right !== undefined && compare(right, node) < 0) {
      heap[index] = right;
      heap[rightIndex] = node;
      index = rightIndex;
    } else {
      // Neither child is smaller. Exit.
      return;
    }
  }
}

function compare(a, b) {
  // Compare sort index first, then task id.
  var diff = a.sortIndex - b.sortIndex;
  return diff !== 0 ? diff : a.id - b.id;
}

// TODO: Use symbols?
var NoPriority = 0;
var ImmediatePriority = 1;
var UserBlockingPriority = 2;
var NormalPriority = 3;
var LowPriority = 4;
var IdlePriority = 5;

var runIdCounter = 0;
var mainThreadIdCounter = 0;
var profilingStateSize = 4;
var sharedProfilingBuffer =  // $FlowFixMe Flow doesn't know about SharedArrayBuffer
typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : // $FlowFixMe Flow doesn't know about ArrayBuffer
typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
;
var profilingState =  sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks

var PRIORITY = 0;
var CURRENT_TASK_ID = 1;
var CURRENT_RUN_ID = 2;
var QUEUE_SIZE = 3;

{
  profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
  // array might include canceled tasks.

  profilingState[QUEUE_SIZE] = 0;
  profilingState[CURRENT_TASK_ID] = 0;
} // Bytes per element is 4


var INITIAL_EVENT_LOG_SIZE = 131072;
var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes

var eventLogSize = 0;
var eventLogBuffer = null;
var eventLog = null;
var eventLogIndex = 0;
var TaskStartEvent = 1;
var TaskCompleteEvent = 2;
var TaskErrorEvent = 3;
var TaskCancelEvent = 4;
var TaskRunEvent = 5;
var TaskYieldEvent = 6;
var SchedulerSuspendEvent = 7;
var SchedulerResumeEvent = 8;

function logEvent(entries) {
  if (eventLog !== null) {
    var offset = eventLogIndex;
    eventLogIndex += entries.length;

    if (eventLogIndex + 1 > eventLogSize) {
      eventLogSize *= 2;

      if (eventLogSize > MAX_EVENT_LOG_SIZE) {
        // Using console['error'] to evade Babel and ESLint
        console['error']("Scheduler Profiling: Event log exceeded maximum size. Don't " + 'forget to call `stopLoggingProfilingEvents()`.');
        stopLoggingProfilingEvents();
        return;
      }

      var newEventLog = new Int32Array(eventLogSize * 4);
      newEventLog.set(eventLog);
      eventLogBuffer = newEventLog.buffer;
      eventLog = newEventLog;
    }

    eventLog.set(entries, offset);
  }
}

function startLoggingProfilingEvents() {
  eventLogSize = INITIAL_EVENT_LOG_SIZE;
  eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
  eventLog = new Int32Array(eventLogBuffer);
  eventLogIndex = 0;
}
function stopLoggingProfilingEvents() {
  var buffer = eventLogBuffer;
  eventLogSize = 0;
  eventLogBuffer = null;
  eventLog = null;
  eventLogIndex = 0;
  return buffer;
}
function markTaskStart(task, ms) {
  {
    profilingState[QUEUE_SIZE]++;

    if (eventLog !== null) {
      // performance.now returns a float, representing milliseconds. When the
      // event is logged, it's coerced to an int. Convert to microseconds to
      // maintain extra degrees of precision.
      logEvent([TaskStartEvent, ms * 1000, task.id, task.priorityLevel]);
    }
  }
}
function markTaskCompleted(task, ms) {
  {
    profilingState[PRIORITY] = NoPriority;
    profilingState[CURRENT_TASK_ID] = 0;
    profilingState[QUEUE_SIZE]--;

    if (eventLog !== null) {
      logEvent([TaskCompleteEvent, ms * 1000, task.id]);
    }
  }
}
function markTaskCanceled(task, ms) {
  {
    profilingState[QUEUE_SIZE]--;

    if (eventLog !== null) {
      logEvent([TaskCancelEvent, ms * 1000, task.id]);
    }
  }
}
function markTaskErrored(task, ms) {
  {
    profilingState[PRIORITY] = NoPriority;
    profilingState[CURRENT_TASK_ID] = 0;
    profilingState[QUEUE_SIZE]--;

    if (eventLog !== null) {
      logEvent([TaskErrorEvent, ms * 1000, task.id]);
    }
  }
}
function markTaskRun(task, ms) {
  {
    runIdCounter++;
    profilingState[PRIORITY] = task.priorityLevel;
    profilingState[CURRENT_TASK_ID] = task.id;
    profilingState[CURRENT_RUN_ID] = runIdCounter;

    if (eventLog !== null) {
      logEvent([TaskRunEvent, ms * 1000, task.id, runIdCounter]);
    }
  }
}
function markTaskYield(task, ms) {
  {
    profilingState[PRIORITY] = NoPriority;
    profilingState[CURRENT_TASK_ID] = 0;
    profilingState[CURRENT_RUN_ID] = 0;

    if (eventLog !== null) {
      logEvent([TaskYieldEvent, ms * 1000, task.id, runIdCounter]);
    }
  }
}
function markSchedulerSuspended(ms) {
  {
    mainThreadIdCounter++;

    if (eventLog !== null) {
      logEvent([SchedulerSuspendEvent, ms * 1000, mainThreadIdCounter]);
    }
  }
}
function markSchedulerUnsuspended(ms) {
  {
    if (eventLog !== null) {
      logEvent([SchedulerResumeEvent, ms * 1000, mainThreadIdCounter]);
    }
  }
}

/* eslint-disable no-var */
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111

var maxSigned31BitInt = 1073741823; // Times out immediately

var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
var NORMAL_PRIORITY_TIMEOUT = 5000;
var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap

var taskQueue = [];
var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
var currentTask = null;
var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

var isPerformingWork = false;
var isHostCallbackScheduled = false;
var isHostTimeoutScheduled = false;

function advanceTimers(currentTime) {
  // Check for tasks that are no longer delayed and add them to the queue.
  var timer = peek(timerQueue);

  while (timer !== null) {
    if (timer.callback === null) {
      // Timer was cancelled.
      pop(timerQueue);
    } else if (timer.startTime <= currentTime) {
      // Timer fired. Transfer to the task queue.
      pop(timerQueue);
      timer.sortIndex = timer.expirationTime;
      push(taskQueue, timer);

      {
        markTaskStart(timer, currentTime);
        timer.isQueued = true;
      }
    } else {
      // Remaining timers are pending.
      return;
    }

    timer = peek(timerQueue);
  }
}

function handleTimeout(currentTime) {
  isHostTimeoutScheduled = false;
  advanceTimers(currentTime);

  if (!isHostCallbackScheduled) {
    if (peek(taskQueue) !== null) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    } else {
      var firstTimer = peek(timerQueue);

      if (firstTimer !== null) {
        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
      }
    }
  }
}

function flushWork(hasTimeRemaining, initialTime) {
  {
    markSchedulerUnsuspended(initialTime);
  } // We'll need a host callback the next time work is scheduled.


  isHostCallbackScheduled = false;

  if (isHostTimeoutScheduled) {
    // We scheduled a timeout but it's no longer needed. Cancel it.
    isHostTimeoutScheduled = false;
    cancelHostTimeout();
  }

  isPerformingWork = true;
  var previousPriorityLevel = currentPriorityLevel;

  try {
    if (enableProfiling) {
      try {
        return workLoop(hasTimeRemaining, initialTime);
      } catch (error) {
        if (currentTask !== null) {
          var currentTime = exports.unstable_now();
          markTaskErrored(currentTask, currentTime);
          currentTask.isQueued = false;
        }

        throw error;
      }
    } else {
      // No catch in prod code path.
      return workLoop(hasTimeRemaining, initialTime);
    }
  } finally {
    currentTask = null;
    currentPriorityLevel = previousPriorityLevel;
    isPerformingWork = false;

    {
      var _currentTime = exports.unstable_now();

      markSchedulerSuspended(_currentTime);
    }
  }
}

function workLoop(hasTimeRemaining, initialTime) {
  var currentTime = initialTime;
  advanceTimers(currentTime);
  currentTask = peek(taskQueue);

  while (currentTask !== null && !(enableSchedulerDebugging )) {
    if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports.unstable_shouldYield())) {
      // This currentTask hasn't expired, and we've reached the deadline.
      break;
    }

    var callback = currentTask.callback;

    if (typeof callback === 'function') {
      currentTask.callback = null;
      currentPriorityLevel = currentTask.priorityLevel;
      var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
      markTaskRun(currentTask, currentTime);
      var continuationCallback = callback(didUserCallbackTimeout);
      currentTime = exports.unstable_now();

      if (typeof continuationCallback === 'function') {
        currentTask.callback = continuationCallback;
        markTaskYield(currentTask, currentTime);
      } else {
        {
          markTaskCompleted(currentTask, currentTime);
          currentTask.isQueued = false;
        }

        if (currentTask === peek(taskQueue)) {
          pop(taskQueue);
        }
      }

      advanceTimers(currentTime);
    } else {
      pop(taskQueue);
    }

    currentTask = peek(taskQueue);
  } // Return whether there's additional work


  if (currentTask !== null) {
    return true;
  } else {
    var firstTimer = peek(timerQueue);

    if (firstTimer !== null) {
      requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
    }

    return false;
  }
}

function unstable_runWithPriority(priorityLevel, eventHandler) {
  switch (priorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
    case LowPriority:
    case IdlePriority:
      break;

    default:
      priorityLevel = NormalPriority;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_next(eventHandler) {
  var priorityLevel;

  switch (currentPriorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
      // Shift down to normal priority
      priorityLevel = NormalPriority;
      break;

    default:
      // Anything lower than normal priority should remain at the current level.
      priorityLevel = currentPriorityLevel;
      break;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_wrapCallback(callback) {
  var parentPriorityLevel = currentPriorityLevel;
  return function () {
    // This is a fork of runWithPriority, inlined for performance.
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = parentPriorityLevel;

    try {
      return callback.apply(this, arguments);
    } finally {
      currentPriorityLevel = previousPriorityLevel;
    }
  };
}

function unstable_scheduleCallback(priorityLevel, callback, options) {
  var currentTime = exports.unstable_now();
  var startTime;

  if (typeof options === 'object' && options !== null) {
    var delay = options.delay;

    if (typeof delay === 'number' && delay > 0) {
      startTime = currentTime + delay;
    } else {
      startTime = currentTime;
    }
  } else {
    startTime = currentTime;
  }

  var timeout;

  switch (priorityLevel) {
    case ImmediatePriority:
      timeout = IMMEDIATE_PRIORITY_TIMEOUT;
      break;

    case UserBlockingPriority:
      timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
      break;

    case IdlePriority:
      timeout = IDLE_PRIORITY_TIMEOUT;
      break;

    case LowPriority:
      timeout = LOW_PRIORITY_TIMEOUT;
      break;

    case NormalPriority:
    default:
      timeout = NORMAL_PRIORITY_TIMEOUT;
      break;
  }

  var expirationTime = startTime + timeout;
  var newTask = {
    id: taskIdCounter++,
    callback: callback,
    priorityLevel: priorityLevel,
    startTime: startTime,
    expirationTime: expirationTime,
    sortIndex: -1
  };

  {
    newTask.isQueued = false;
  }

  if (startTime > currentTime) {
    // This is a delayed task.
    newTask.sortIndex = startTime;
    push(timerQueue, newTask);

    if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
      // All tasks are delayed, and this is the task with the earliest delay.
      if (isHostTimeoutScheduled) {
        // Cancel an existing timeout.
        cancelHostTimeout();
      } else {
        isHostTimeoutScheduled = true;
      } // Schedule a timeout.


      requestHostTimeout(handleTimeout, startTime - currentTime);
    }
  } else {
    newTask.sortIndex = expirationTime;
    push(taskQueue, newTask);

    {
      markTaskStart(newTask, currentTime);
      newTask.isQueued = true;
    } // Schedule a host callback, if needed. If we're already performing work,
    // wait until the next time we yield.


    if (!isHostCallbackScheduled && !isPerformingWork) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    }
  }

  return newTask;
}

function unstable_pauseExecution() {
}

function unstable_continueExecution() {

  if (!isHostCallbackScheduled && !isPerformingWork) {
    isHostCallbackScheduled = true;
    requestHostCallback(flushWork);
  }
}

function unstable_getFirstCallbackNode() {
  return peek(taskQueue);
}

function unstable_cancelCallback(task) {
  {
    if (task.isQueued) {
      var currentTime = exports.unstable_now();
      markTaskCanceled(task, currentTime);
      task.isQueued = false;
    }
  } // Null out the callback to indicate the task has been canceled. (Can't
  // remove from the queue because you can't remove arbitrary nodes from an
  // array based heap, only the first one.)


  task.callback = null;
}

function unstable_getCurrentPriorityLevel() {
  return currentPriorityLevel;
}

var unstable_requestPaint = requestPaint;
var unstable_Profiling =  {
  startLoggingProfilingEvents: startLoggingProfilingEvents,
  stopLoggingProfilingEvents: stopLoggingProfilingEvents,
  sharedProfilingBuffer: sharedProfilingBuffer
} ;

exports.unstable_IdlePriority = IdlePriority;
exports.unstable_ImmediatePriority = ImmediatePriority;
exports.unstable_LowPriority = LowPriority;
exports.unstable_NormalPriority = NormalPriority;
exports.unstable_Profiling = unstable_Profiling;
exports.unstable_UserBlockingPriority = UserBlockingPriority;
exports.unstable_cancelCallback = unstable_cancelCallback;
exports.unstable_continueExecution = unstable_continueExecution;
exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
exports.unstable_next = unstable_next;
exports.unstable_pauseExecution = unstable_pauseExecution;
exports.unstable_requestPaint = unstable_requestPaint;
exports.unstable_runWithPriority = unstable_runWithPriority;
exports.unstable_scheduleCallback = unstable_scheduleCallback;
exports.unstable_wrapCallback = unstable_wrapCallback;
  })();
}

},{}],1160:[function(require,module,exports){
/** @license React v0.20.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};

},{}],1161:[function(require,module,exports){
'use strict';

if ("production" === 'production') {
  module.exports = require('./cjs/scheduler.production.min.js');
} else {
  module.exports = require('./cjs/scheduler.development.js');
}

},{"./cjs/scheduler.development.js":1159,"./cjs/scheduler.production.min.js":1160}],1162:[function(require,module,exports){
'use strict';

if ("production" === 'production') {
  module.exports = require('./cjs/scheduler-tracing.production.min.js');
} else {
  module.exports = require('./cjs/scheduler-tracing.development.js');
}

},{"./cjs/scheduler-tracing.development.js":1157,"./cjs/scheduler-tracing.production.min.js":1158}],1163:[function(require,module,exports){
'use strict';
module.exports = require('./lib/index');

},{"./lib/index":1167}],1164:[function(require,module,exports){
'use strict';

var randomFromSeed = require('./random/random-from-seed');

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};

},{"./random/random-from-seed":1170}],1165:[function(require,module,exports){
'use strict';

var generate = require('./generate');
var alphabet = require('./alphabet');

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1567752802062;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 7;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;

},{"./alphabet":1164,"./generate":1166}],1166:[function(require,module,exports){
'use strict';

var alphabet = require('./alphabet');
var random = require('./random/random-byte');
var format = require('nanoid/format');

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;

},{"./alphabet":1164,"./random/random-byte":1169,"nanoid/format":877}],1167:[function(require,module,exports){
'use strict';

var alphabet = require('./alphabet');
var build = require('./build');
var isValid = require('./is-valid');

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = require('./util/cluster-worker-id') || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;

},{"./alphabet":1164,"./build":1165,"./is-valid":1168,"./util/cluster-worker-id":1171}],1168:[function(require,module,exports){
'use strict';
var alphabet = require('./alphabet');

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;

},{"./alphabet":1164}],1169:[function(require,module,exports){
'use strict';

var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;

},{}],1170:[function(require,module,exports){
'use strict';

// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};

},{}],1171:[function(require,module,exports){
'use strict';

module.exports = 0;

},{}],1172:[function(require,module,exports){
'use strict';

var isArrayish = require('is-arrayish');

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle.wrap = function (fn) {
	return function () {
		return fn(swizzle(arguments));
	};
};

},{"is-arrayish":670}],1173:[function(require,module,exports){
// Snap.svg 0.4.1
//
// Copyright (c) 2013 – 2015 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
//
// build: 2017-05-15

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.4.2 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.4.2",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        fun = function () {},
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     > Arguments

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        eve = function (name, scope) {
            name = String(name);
            var e = events,
                oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                f = false,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event,
                errors = [];
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
        // Undocumented. Debug only.
        eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     > Arguments

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment. 
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        name = String(name);
        if (typeof f != "function") {
            return function () {};
        }
        var names = name.split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = name.split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     > Arguments
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     > Arguments
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(current_event);
        }
        return current_event;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = name.split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = name.split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.unbind(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    (typeof module != "undefined" && module.exports) ? (module.exports = eve) : (typeof define === "function" && define.amd ? (define("eve", [], function() { return eve; })) : (glob.eve = eve));
})(this);

(function (glob, factory) {
    // AMD support
    if (typeof define == "function" && define.amd) {
        // Define as an anonymous module
        define(["eve"], function (eve) {
            return factory(glob, eve);
        });
    } else if (typeof exports != 'undefined') {
        // Next for Node.js or CommonJS
        var eve = require('eve');
        module.exports = factory(glob, eve);
    } else {
        // Browser globals (glob is window)
        // Snap adds itself to window
        factory(glob, glob.eve);
    }
}(window || this, function (window, eve) {

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var mina = (function (eve) {
    var animations = {},
    requestAnimFrame = window.requestAnimationFrame       ||
                       window.webkitRequestAnimationFrame ||
                       window.mozRequestAnimationFrame    ||
                       window.oRequestAnimationFrame      ||
                       window.msRequestAnimationFrame     ||
                       function (callback) {
                           setTimeout(callback, 16);
                       },
    isArray = Array.isArray || function (a) {
        return a instanceof Array ||
            Object.prototype.toString.call(a) == "[object Array]";
    },
    idgen = 0,
    idprefix = "M" + (+new Date).toString(36),
    ID = function () {
        return idprefix + (idgen++).toString(36);
    },
    diff = function (a, b, A, B) {
        if (isArray(a)) {
            res = [];
            for (var i = 0, ii = a.length; i < ii; i++) {
                res[i] = diff(a[i], b, A[i], B);
            }
            return res;
        }
        var dif = (A - a) / (B - b);
        return function (bb) {
            return a + dif * (bb - b);
        };
    },
    timer = Date.now || function () {
        return +new Date;
    },
    sta = function (val) {
        var a = this;
        if (val == null) {
            return a.s;
        }
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
    },
    speed = function (val) {
        var a = this;
        if (val == null) {
            return a.spd;
        }
        a.spd = val;
    },
    duration = function (val) {
        var a = this;
        if (val == null) {
            return a.dur;
        }
        a.s = a.s * val / a.dur;
        a.dur = val;
    },
    stopit = function () {
        var a = this;
        delete animations[a.id];
        a.update();
        eve("mina.stop." + a.id, a);
    },
    pause = function () {
        var a = this;
        if (a.pdif) {
            return;
        }
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
    },
    resume = function () {
        var a = this;
        if (!a.pdif) {
            return;
        }
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
    },
    update = function () {
        var a = this,
            res;
        if (isArray(a.start)) {
            res = [];
            for (var j = 0, jj = a.start.length; j < jj; j++) {
                res[j] = +a.start[j] +
                    (a.end[j] - a.start[j]) * a.easing(a.s);
            }
        } else {
            res = +a.start + (a.end - a.start) * a.easing(a.s);
        }
        a.set(res);
    },
    frame = function () {
        var len = 0;
        for (var i in animations) if (animations.hasOwnProperty(i)) {
            var a = animations[i],
                b = a.get(),
                res;
            len++;
            a.s = (b - a.b) / (a.dur / a.spd);
            if (a.s >= 1) {
                delete animations[i];
                a.s = 1;
                len--;
                (function (a) {
                    setTimeout(function () {
                        eve("mina.finish." + a.id, a);
                    });
                }(a));
            }
            a.update();
        }
        len && requestAnimFrame(frame);
    },
    /*\
     * mina
     [ method ]
     **
     * Generic animation of numbers
     **
     - a (number) start _slave_ number
     - A (number) end _slave_ number
     - b (number) start _master_ number (start time in general case)
     - B (number) end _master_ number (end time in gereal case)
     - get (function) getter of _master_ number (see @mina.time)
     - set (function) setter of _slave_ number
     - easing (function) #optional easing function, default is @mina.linear
     = (object) animation descriptor
     o {
     o         id (string) animation id,
     o         start (number) start _slave_ number,
     o         end (number) end _slave_ number,
     o         b (number) start _master_ number,
     o         s (number) animation status (0..1),
     o         dur (number) animation duration,
     o         spd (number) animation speed,
     o         get (function) getter of _master_ number (see @mina.time),
     o         set (function) setter of _slave_ number,
     o         easing (function) easing function, default is @mina.linear,
     o         status (function) status getter/setter,
     o         speed (function) speed getter/setter,
     o         duration (function) duration getter/setter,
     o         stop (function) animation stopper
     o         pause (function) pauses the animation
     o         resume (function) resumes the animation
     o         update (function) calles setter with the right value of the animation
     o }
    \*/
    mina = function (a, A, b, B, get, set, easing) {
        var anim = {
            id: ID(),
            start: a,
            end: A,
            b: b,
            s: 0,
            dur: B - b,
            spd: 1,
            get: get,
            set: set,
            easing: easing || mina.linear,
            status: sta,
            speed: speed,
            duration: duration,
            stop: stopit,
            pause: pause,
            resume: resume,
            update: update
        };
        animations[anim.id] = anim;
        var len = 0, i;
        for (i in animations) if (animations.hasOwnProperty(i)) {
            len++;
            if (len == 2) {
                break;
            }
        }
        len == 1 && requestAnimFrame(frame);
        return anim;
    };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/
    mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/
    mina.getById = function (id) {
        return animations[id] || null;
    };

    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.linear = function (n) {
        return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeout = function (n) {
        return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easein = function (n) {
        return Math.pow(n, .48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeinout = function (n) {
        if (n == 1) {
            return 1;
        }
        if (n == 0) {
            return 0;
        }
        var q = .48 - n / 1.04,
            Q = Math.sqrt(.1734 + q * q),
            x = Q - q,
            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
            y = -Q - q,
            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
            t = X + Y + .5;
        return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backin = function (n) {
        if (n == 1) {
            return 1;
        }
        var s = 1.70158;
        return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backout = function (n) {
        if (n == 0) {
            return 0;
        }
        n = n - 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.elastic = function (n) {
        if (n == !!n) {
            return n;
        }
        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
            (2 * Math.PI) / .3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.bounce = function (n) {
        var s = 7.5625,
            p = 2.75,
            l;
        if (n < (1 / p)) {
            l = s * n * n;
        } else {
            if (n < (2 / p)) {
                n -= (1.5 / p);
                l = s * n * n + .75;
            } else {
                if (n < (2.5 / p)) {
                    n -= (2.25 / p);
                    l = s * n * n + .9375;
                } else {
                    n -= (2.625 / p);
                    l = s * n * n + .984375;
                }
            }
        }
        return l;
    };
    window.mina = mina;
    return mina;
})(typeof eve == "undefined" ? function () {} : eve);
// Copyright (c) 2013 - 2015 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var Snap = (function(root) {
Snap.version = "0.4.0";
/*\
 * Snap
 [ method ]
 **
 * Creates a drawing surface or wraps existing SVG element.
 **
 - width (number|string) width of surface
 - height (number|string) height of surface
 * or
 - DOM (SVGElement) element to be wrapped into Snap structure
 * or
 - array (array) array of elements (will return set of elements)
 * or
 - query (string) CSS query selector
 = (object) @Element
\*/
function Snap(w, h) {
    if (w) {
        if (w.nodeType) {
            return wrap(w);
        }
        if (is(w, "array") && Snap.set) {
            return Snap.set.apply(Snap, w);
        }
        if (w instanceof Element) {
            return w;
        }
        if (h == null) {
            w = glob.doc.querySelector(String(w));
            return wrap(w);
        }
    }
    w = w == null ? "100%" : w;
    h = h == null ? "100%" : h;
    return new Paper(w, h);
}
Snap.toString = function () {
    return "Snap v" + this.version;
};
Snap._ = {};
var glob = {
    win: root.window,
    doc: root.window.document
};
Snap._.glob = glob;
var has = "hasOwnProperty",
    Str = String,
    toFloat = parseFloat,
    toInt = parseInt,
    math = Math,
    mmax = math.max,
    mmin = math.min,
    abs = math.abs,
    pow = math.pow,
    PI = math.PI,
    round = math.round,
    E = "",
    S = " ",
    objectToString = Object.prototype.toString,
    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
    reURLValue = /^url\(#?([^)]+)\)$/,
    separator = Snap._.separator = /[,\s]+/,
    whitespace = /[\s]/g,
    commaSpaces = /[\s]*,[\s]*/,
    hsrg = {hs: 1, rg: 1},
    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\\d+)?)[\s]*,?[\s]*/ig,
    idgen = 0,
    idprefix = "S" + (+new Date).toString(36),
    ID = function (el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
    },
    xlink = "http://www.w3.org/1999/xlink",
    xmlns = "http://www.w3.org/2000/svg",
    hub = {},
    URL = Snap.url = function (url) {
        return "url('#" + url + "')";
    };

function $(el, attr) {
    if (attr) {
        if (el == "#text") {
            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
        }
        if (el == "#comment") {
            el = glob.doc.createComment(attr.text || attr["#text"] || "");
        }
        if (typeof el == "string") {
            el = $(el);
        }
        if (typeof attr == "string") {
            if (el.nodeType == 1) {
                if (attr.substring(0, 6) == "xlink:") {
                    return el.getAttributeNS(xlink, attr.substring(6));
                }
                if (attr.substring(0, 4) == "xml:") {
                    return el.getAttributeNS(xmlns, attr.substring(4));
                }
                return el.getAttribute(attr);
            } else if (attr == "text") {
                return el.nodeValue;
            } else {
                return null;
            }
        }
        if (el.nodeType == 1) {
            for (var key in attr) if (attr[has](key)) {
                var val = Str(attr[key]);
                if (val) {
                    if (key.substring(0, 6) == "xlink:") {
                        el.setAttributeNS(xlink, key.substring(6), val);
                    } else if (key.substring(0, 4) == "xml:") {
                        el.setAttributeNS(xmlns, key.substring(4), val);
                    } else {
                        el.setAttribute(key, val);
                    }
                } else {
                    el.removeAttribute(key);
                }
            }
        } else if ("text" in attr) {
            el.nodeValue = attr.text;
        }
    } else {
        el = glob.doc.createElementNS(xmlns, el);
    }
    return el;
}
Snap._.$ = $;
Snap._.id = ID;
function getAttrs(el) {
    var attrs = el.attributes,
        name,
        out = {};
    for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].namespaceURI == xlink) {
            name = "xlink:";
        } else {
            name = "";
        }
        name += attrs[i].name;
        out[name] = attrs[i].textContent;
    }
    return out;
}
function is(o, type) {
    type = Str.prototype.toLowerCase.call(type);
    if (type == "finite") {
        return isFinite(o);
    }
    if (type == "array" &&
        (o instanceof Array || Array.isArray && Array.isArray(o))) {
        return true;
    }
    return  (type == "null" && o === null) ||
            (type == typeof o && o !== null) ||
            (type == "object" && o === Object(o)) ||
            objectToString.call(o).slice(8, -1).toLowerCase() == type;
}
/*\
 * Snap.format
 [ method ]
 **
 * Replaces construction of type `{<name>}` to the corresponding argument
 **
 - token (string) string to format
 - json (object) object which properties are used as a replacement
 = (string) formatted string
 > Usage
 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
 |     x: 10,
 |     y: 20,
 |     dim: {
 |         width: 40,
 |         height: 50,
 |         "negative width": -40
 |     }
 | }));
\*/
Snap.format = (function () {
    var tokenRegex = /\{([^\}]+)\}/g,
        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
        replacer = function (all, key, obj) {
            var res = obj;
            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res) {
                    if (name in res) {
                        res = res[name];
                    }
                    typeof res == "function" && isFunc && (res = res());
                }
            });
            res = (res == null || res == obj ? all : res) + "";
            return res;
        };
    return function (str, obj) {
        return Str(str).replace(tokenRegex, function (all, key) {
            return replacer(all, key, obj);
        });
    };
})();
function clone(obj) {
    if (typeof obj == "function" || Object(obj) !== obj) {
        return obj;
    }
    var res = new obj.constructor;
    for (var key in obj) if (obj[has](key)) {
        res[key] = clone(obj[key]);
    }
    return res;
}
Snap._.clone = clone;
function repush(array, item) {
    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
        return array.push(array.splice(i, 1)[0]);
    }
}
function cacher(f, scope, postprocessor) {
    function newf() {
        var arg = Array.prototype.slice.call(arguments, 0),
            args = arg.join("\u2400"),
            cache = newf.cache = newf.cache || {},
            count = newf.count = newf.count || [];
        if (cache[has](args)) {
            repush(count, args);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        count.length >= 1e3 && delete cache[count.shift()];
        count.push(args);
        cache[args] = f.apply(scope, arg);
        return postprocessor ? postprocessor(cache[args]) : cache[args];
    }
    return newf;
}
Snap._.cacher = cacher;
function angle(x1, y1, x2, y2, x3, y3) {
    if (x3 == null) {
        var x = x1 - x2,
            y = y1 - y2;
        if (!x && !y) {
            return 0;
        }
        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
    } else {
        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
    }
}
function rad(deg) {
    return deg % 360 * PI / 180;
}
function deg(rad) {
    return rad * 180 / PI % 360;
}
function x_y() {
    return this.x + S + this.y;
}
function x_y_w_h() {
    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
}

/*\
 * Snap.rad
 [ method ]
 **
 * Transform angle to radians
 - deg (number) angle in degrees
 = (number) angle in radians
\*/
Snap.rad = rad;
/*\
 * Snap.deg
 [ method ]
 **
 * Transform angle to degrees
 - rad (number) angle in radians
 = (number) angle in degrees
\*/
Snap.deg = deg;
/*\
 * Snap.sin
 [ method ]
 **
 * Equivalent to `Math.sin()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) sin
\*/
Snap.sin = function (angle) {
    return math.sin(Snap.rad(angle));
};
/*\
 * Snap.tan
 [ method ]
 **
 * Equivalent to `Math.tan()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) tan
\*/
Snap.tan = function (angle) {
    return math.tan(Snap.rad(angle));
};
/*\
 * Snap.cos
 [ method ]
 **
 * Equivalent to `Math.cos()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) cos
\*/
Snap.cos = function (angle) {
    return math.cos(Snap.rad(angle));
};
/*\
 * Snap.asin
 [ method ]
 **
 * Equivalent to `Math.asin()` only works with degrees, not radians.
 - num (number) value
 = (number) asin in degrees
\*/
Snap.asin = function (num) {
    return Snap.deg(math.asin(num));
};
/*\
 * Snap.acos
 [ method ]
 **
 * Equivalent to `Math.acos()` only works with degrees, not radians.
 - num (number) value
 = (number) acos in degrees
\*/
Snap.acos = function (num) {
    return Snap.deg(math.acos(num));
};
/*\
 * Snap.atan
 [ method ]
 **
 * Equivalent to `Math.atan()` only works with degrees, not radians.
 - num (number) value
 = (number) atan in degrees
\*/
Snap.atan = function (num) {
    return Snap.deg(math.atan(num));
};
/*\
 * Snap.atan2
 [ method ]
 **
 * Equivalent to `Math.atan2()` only works with degrees, not radians.
 - num (number) value
 = (number) atan2 in degrees
\*/
Snap.atan2 = function (num) {
    return Snap.deg(math.atan2(num));
};
/*\
 * Snap.angle
 [ method ]
 **
 * Returns an angle between two or three points
 > Parameters
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 - x3 (number) #optional x coord of third point
 - y3 (number) #optional y coord of third point
 = (number) angle in degrees
\*/
Snap.angle = angle;
/*\
 * Snap.len
 [ method ]
 **
 * Returns distance between two points
 > Parameters
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len = function (x1, y1, x2, y2) {
    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
};
/*\
 * Snap.len2
 [ method ]
 **
 * Returns squared distance between two points
 > Parameters
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len2 = function (x1, y1, x2, y2) {
    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
};
/*\
 * Snap.closestPoint
 [ method ]
 **
 * Returns closest point to a given one on a given path.
 > Parameters
 - path (Element) path element
 - x (number) x coord of a point
 - y (number) y coord of a point
 = (object) in format
 {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
 }
\*/
// Copied from http://bl.ocks.org/mbostock/8027637
Snap.closestPoint = function (path, x, y) {
    function distance2(p) {
        var dx = p.x - x,
            dy = p.y - y;
        return dx * dx + dy * dy;
    }
    var pathNode = path.node,
        pathLength = pathNode.getTotalLength(),
        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
        best,
        bestLength,
        bestDistance = Infinity;

    // linear scan for coarse approximation
    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan, bestLength = scanLength, bestDistance = scanDistance;
        }
    }

    // binary search for precise estimate
    precision *= .5;
    while (precision > .5) {
        var before,
            after,
            beforeLength,
            afterLength,
            beforeDistance,
            afterDistance;
        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
            best = before, bestLength = beforeLength, bestDistance = beforeDistance;
        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
            best = after, bestLength = afterLength, bestDistance = afterDistance;
        } else {
            precision *= .5;
        }
    }

    best = {
        x: best.x,
        y: best.y,
        length: bestLength,
        distance: Math.sqrt(bestDistance)
    };
    return best;
}
/*\
 * Snap.is
 [ method ]
 **
 * Handy replacement for the `typeof` operator
 - o (…) any object or primitive
 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
 = (boolean) `true` if given value is of given type
\*/
Snap.is = is;
/*\
 * Snap.snapTo
 [ method ]
 **
 * Snaps given value to given grid
 - values (array|number) given array of values or step of the grid
 - value (number) value to adjust
 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
 = (number) adjusted value
\*/
Snap.snapTo = function (values, value, tolerance) {
    tolerance = is(tolerance, "finite") ? tolerance : 10;
    if (is(values, "array")) {
        var i = values.length;
        while (i--) if (abs(values[i] - value) <= tolerance) {
            return values[i];
        }
    } else {
        values = +values;
        var rem = value % values;
        if (rem < tolerance) {
            return value - rem;
        }
        if (rem > values - tolerance) {
            return value - rem + values;
        }
    }
    return value;
};
// Colour
/*\
 * Snap.getRGB
 [ method ]
 **
 * Parses color string as RGB object
 - color (string) color string in one of the following formats:
 # <ul>
 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
 # </ul>
 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) true if string can't be parsed
 o }
\*/
Snap.getRGB = cacher(function (colour) {
    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    if (colour == "none") {
        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
    }
    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
    if (!colour) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    var res,
        red,
        green,
        blue,
        opacity,
        t,
        values,
        rgb = colour.match(colourRegExp);
    if (rgb) {
        if (rgb[2]) {
            blue = toInt(rgb[2].substring(5), 16);
            green = toInt(rgb[2].substring(3, 5), 16);
            red = toInt(rgb[2].substring(1, 3), 16);
        }
        if (rgb[3]) {
            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
            green = toInt((t = rgb[3].charAt(2)) + t, 16);
            red = toInt((t = rgb[3].charAt(1)) + t, 16);
        }
        if (rgb[4]) {
            values = rgb[4].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red *= 2.55);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green *= 2.55);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue *= 2.55);
            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        }
        if (rgb[5]) {
            values = rgb[5].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsb2rgb(red, green, blue, opacity);
        }
        if (rgb[6]) {
            values = rgb[6].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsl2rgb(red, green, blue, opacity);
        }
        red = mmin(math.round(red), 255);
        green = mmin(math.round(green), 255);
        blue = mmin(math.round(blue), 255);
        opacity = mmin(mmax(opacity, 0), 1);
        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
        rgb.hex = "#" + (16777216 | blue | (green << 8) | (red << 16)).toString(16).slice(1);
        rgb.opacity = is(opacity, "finite") ? opacity : 1;
        return rgb;
    }
    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
}, Snap);
/*\
 * Snap.hsb
 [ method ]
 **
 * Converts HSB values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - b (number) value or brightness
 = (string) hex representation of the color
\*/
Snap.hsb = cacher(function (h, s, b) {
    return Snap.hsb2rgb(h, s, b).hex;
});
/*\
 * Snap.hsl
 [ method ]
 **
 * Converts HSL values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (string) hex representation of the color
\*/
Snap.hsl = cacher(function (h, s, l) {
    return Snap.hsl2rgb(h, s, l).hex;
});
/*\
 * Snap.rgb
 [ method ]
 **
 * Converts RGB values to a hex representation of the color
 - r (number) red
 - g (number) green
 - b (number) blue
 = (string) hex representation of the color
\*/
Snap.rgb = cacher(function (r, g, b, o) {
    if (is(o, "finite")) {
        var round = math.round;
        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
    }
    return "#" + (16777216 | b | (g << 8) | (r << 16)).toString(16).slice(1);
});
var toHex = function (color) {
    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
        red = "rgb(255, 0, 0)";
    toHex = cacher(function (color) {
        if (color.toLowerCase() == "red") {
            return red;
        }
        i.style.color = red;
        i.style.color = color;
        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
        return out == red ? null : out;
    });
    return toHex(color);
},
hsbtoString = function () {
    return "hsb(" + [this.h, this.s, this.b] + ")";
},
hsltoString = function () {
    return "hsl(" + [this.h, this.s, this.l] + ")";
},
rgbtoString = function () {
    return this.opacity == 1 || this.opacity == null ?
            this.hex :
            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
},
prepareRGB = function (r, g, b) {
    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
        b = r.b;
        g = r.g;
        r = r.r;
    }
    if (g == null && is(r, string)) {
        var clr = Snap.getRGB(r);
        r = clr.r;
        g = clr.g;
        b = clr.b;
    }
    if (r > 1 || g > 1 || b > 1) {
        r /= 255;
        g /= 255;
        b /= 255;
    }
    
    return [r, g, b];
},
packageRGB = function (r, g, b, o) {
    r = math.round(r * 255);
    g = math.round(g * 255);
    b = math.round(b * 255);
    var rgb = {
        r: r,
        g: g,
        b: b,
        opacity: is(o, "finite") ? o : 1,
        hex: Snap.rgb(r, g, b),
        toString: rgbtoString
    };
    is(o, "finite") && (rgb.opacity = o);
    return rgb;
};
/*\
 * Snap.color
 [ method ]
 **
 * Parses the color string and returns an object featuring the color's component values
 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
 = (object) Combined RGB/HSB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) `true` if string can't be parsed,
 o     h (number) hue,
 o     s (number) saturation,
 o     v (number) value (brightness),
 o     l (number) lightness
 o }
\*/
Snap.color = function (clr) {
    var rgb;
    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
        rgb = Snap.hsb2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
        rgb = Snap.hsl2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else {
        if (is(clr, "string")) {
            clr = Snap.getRGB(clr);
        }
        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
            rgb = Snap.rgb2hsl(clr);
            clr.h = rgb.h;
            clr.s = rgb.s;
            clr.l = rgb.l;
            rgb = Snap.rgb2hsb(clr);
            clr.v = rgb.b;
        } else {
            clr = {hex: "none"};
            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
            clr.error = 1;
        }
    }
    clr.toString = rgbtoString;
    return clr;
};
/*\
 * Snap.hsb2rgb
 [ method ]
 **
 * Converts HSB values to an RGB object
 - h (number) hue
 - s (number) saturation
 - v (number) value or brightness
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsb2rgb = function (h, s, v, o) {
    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
        v = h.b;
        s = h.s;
        o = h.o;
        h = h.h;
    }
    h *= 360;
    var R, G, B, X, C;
    h = (h % 360) / 60;
    C = v * s;
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = v - C;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.hsl2rgb
 [ method ]
 **
 * Converts HSL values to an RGB object
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsl2rgb = function (h, s, l, o) {
    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
        l = h.l;
        s = h.s;
        h = h.h;
    }
    if (h > 1 || s > 1 || l > 1) {
        h /= 360;
        s /= 100;
        l /= 100;
    }
    h *= 360;
    var R, G, B, X, C;
    h = (h % 360) / 60;
    C = 2 * s * (l < .5 ? l : 1 - l);
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = l - C / 2;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.rgb2hsb
 [ method ]
 **
 * Converts RGB values to an HSB object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSB object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     b (number) brightness
 o }
\*/
Snap.rgb2hsb = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, V, C;
    V = mmax(r, g, b);
    C = V - mmin(r, g, b);
    H = (C == 0 ? null :
         V == r ? (g - b) / C :
         V == g ? (b - r) / C + 2 :
                  (r - g) / C + 4
        );
    H = ((H + 360) % 6) * 60 / 360;
    S = C == 0 ? 0 : C / V;
    return {h: H, s: S, b: V, toString: hsbtoString};
};
/*\
 * Snap.rgb2hsl
 [ method ]
 **
 * Converts RGB values to an HSL object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSL object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     l (number) luminosity
 o }
\*/
Snap.rgb2hsl = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, L, M, m, C;
    M = mmax(r, g, b);
    m = mmin(r, g, b);
    C = M - m;
    H = (C == 0 ? null :
         M == r ? (g - b) / C :
         M == g ? (b - r) / C + 2 :
                  (r - g) / C + 4);
    H = ((H + 360) % 6) * 60 / 360;
    L = (M + m) / 2;
    S = (C == 0 ? 0 :
         L < .5 ? C / (2 * L) :
                  C / (2 - 2 * L));
    return {h: H, s: S, l: L, toString: hsltoString};
};

// Transformations
/*\
 * Snap.parsePathString
 [ method ]
 **
 * Utility method
 **
 * Parses given path string into an array of arrays of path segments
 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
 = (array) array of segments
\*/
Snap.parsePathString = function (pathString) {
    if (!pathString) {
        return null;
    }
    var pth = Snap.path(pathString);
    if (pth.arr) {
        return Snap.path.clone(pth.arr);
    }
    
    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
        data = [];
    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
        data = Snap.path.clone(pathString);
    }
    if (!data.length) {
        Str(pathString).replace(pathCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            if (name == "m" && params.length > 2) {
                data.push([b].concat(params.splice(0, 2)));
                name = "l";
                b = b == "m" ? "l" : "L";
            }
            if (name == "o" && params.length == 1) {
                data.push([b, params[0]]);
            }
            if (name == "r") {
                data.push([b].concat(params));
            } else while (params.length >= paramCounts[name]) {
                data.push([b].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) {
                    break;
                }
            }
        });
    }
    data.toString = Snap.path.toString;
    pth.arr = Snap.path.clone(data);
    return data;
};
/*\
 * Snap.parseTransformString
 [ method ]
 **
 * Utility method
 **
 * Parses given transform string into an array of transformations
 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
 = (array) array of transformations
\*/
var parseTransformString = Snap.parseTransformString = function (TString) {
    if (!TString) {
        return null;
    }
    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
        data = [];
    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
        data = Snap.path.clone(TString);
    }
    if (!data.length) {
        Str(TString).replace(tCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            data.push([b].concat(params));
        });
    }
    data.toString = Snap.path.toString;
    return data;
};
function svgTransform2string(tstr) {
    var res = [];
    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
        params = params.split(/\s*,\s*|\s+/);
        if (name == "rotate" && params.length == 1) {
            params.push(0, 0);
        }
        if (name == "scale") {
            if (params.length > 2) {
                params = params.slice(0, 2);
            } else if (params.length == 2) {
                params.push(0, 0);
            }
            if (params.length == 1) {
                params.push(params[0], 0, 0);
            }
        }
        if (name == "skewX") {
            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
        } else if (name == "skewY") {
            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
        } else {
            res.push([name.charAt(0)].concat(params));
        }
        return all;
    });
    return res;
}
Snap._.svgTransform2string = svgTransform2string;
Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
function transform2matrix(tstr, bbox) {
    var tdata = parseTransformString(tstr),
        m = new Snap.Matrix;
    if (tdata) {
        for (var i = 0, ii = tdata.length; i < ii; i++) {
            var t = tdata[i],
                tlen = t.length,
                command = Str(t[0]).toLowerCase(),
                absolute = t[0] != command,
                inver = absolute ? m.invert() : 0,
                x1,
                y1,
                x2,
                y2,
                bb;
            if (command == "t" && tlen == 2){
                m.translate(t[1], 0);
            } else if (command == "t" && tlen == 3) {
                if (absolute) {
                    x1 = inver.x(0, 0);
                    y1 = inver.y(0, 0);
                    x2 = inver.x(t[1], t[2]);
                    y2 = inver.y(t[1], t[2]);
                    m.translate(x2 - x1, y2 - y1);
                } else {
                    m.translate(t[1], t[2]);
                }
            } else if (command == "r") {
                if (tlen == 2) {
                    bb = bb || bbox;
                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.rotate(t[1], x2, y2);
                    } else {
                        m.rotate(t[1], t[2], t[3]);
                    }
                }
            } else if (command == "s") {
                if (tlen == 2 || tlen == 3) {
                    bb = bb || bbox;
                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.scale(t[1], t[1], x2, y2);
                    } else {
                        m.scale(t[1], t[1], t[2], t[3]);
                    }
                } else if (tlen == 5) {
                    if (absolute) {
                        x2 = inver.x(t[3], t[4]);
                        y2 = inver.y(t[3], t[4]);
                        m.scale(t[1], t[2], x2, y2);
                    } else {
                        m.scale(t[1], t[2], t[3], t[4]);
                    }
                }
            } else if (command == "m" && tlen == 7) {
                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
            }
        }
    }
    return m;
}
Snap._.transform2matrix = transform2matrix;
Snap._unit2px = unit2px;
var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
    function (a, b) {
        var adown = a.nodeType == 9 ? a.documentElement : a,
            bup = b && b.parentNode;
            return a == bup || !!(bup && bup.nodeType == 1 && (
                adown.contains ?
                    adown.contains(bup) :
                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
            ));
    } :
    function (a, b) {
        if (b) {
            while (b) {
                b = b.parentNode;
                if (b == a) {
                    return true;
                }
            }
        }
        return false;
    };
function getSomeDefs(el) {
    var p = (el.node.ownerSVGElement && wrap(el.node.ownerSVGElement)) ||
            (el.node.parentNode && wrap(el.node.parentNode)) ||
            Snap.select("svg") ||
            Snap(0, 0),
        pdefs = p.select("defs"),
        defs  = pdefs == null ? false : pdefs.node;
    if (!defs) {
        defs = make("defs", p.node).node;
    }
    return defs;
}
function getSomeSVG(el) {
    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
}
Snap._.getSomeDefs = getSomeDefs;
Snap._.getSomeSVG = getSomeSVG;
function unit2px(el, name, value) {
    var svg = getSomeSVG(el).node,
        out = {},
        mgr = svg.querySelector(".svg---mgr");
    if (!mgr) {
        mgr = $("rect");
        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
        svg.appendChild(mgr);
    }
    function getW(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {width: val});
        try {
            return mgr.getBBox().width;
        } catch (e) {
            return 0;
        }
    }
    function getH(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {height: val});
        try {
            return mgr.getBBox().height;
        } catch (e) {
            return 0;
        }
    }
    function set(nam, f) {
        if (name == null) {
            out[nam] = f(el.attr(nam) || 0);
        } else if (nam == name) {
            out = f(value == null ? el.attr(nam) || 0 : value);
        }
    }
    switch (el.type) {
        case "rect":
            set("rx", getW);
            set("ry", getH);
        case "image":
            set("width", getW);
            set("height", getH);
        case "text":
            set("x", getW);
            set("y", getH);
        break;
        case "circle":
            set("cx", getW);
            set("cy", getH);
            set("r", getW);
        break;
        case "ellipse":
            set("cx", getW);
            set("cy", getH);
            set("rx", getW);
            set("ry", getH);
        break;
        case "line":
            set("x1", getW);
            set("x2", getW);
            set("y1", getH);
            set("y2", getH);
        break;
        case "marker":
            set("refX", getW);
            set("markerWidth", getW);
            set("refY", getH);
            set("markerHeight", getH);
        break;
        case "radialGradient":
            set("fx", getW);
            set("fy", getH);
        break;
        case "tspan":
            set("dx", getW);
            set("dy", getH);
        break;
        default:
            set(name, getW);
    }
    svg.removeChild(mgr);
    return out;
}
/*\
 * Snap.select
 [ method ]
 **
 * Wraps a DOM element specified by CSS selector as @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.select = function (query) {
    query = Str(query).replace(/([^\\]):/g, "$1\\:");
    return wrap(glob.doc.querySelector(query));
};
/*\
 * Snap.selectAll
 [ method ]
 **
 * Wraps DOM elements specified by CSS selector as set or array of @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.selectAll = function (query) {
    var nodelist = glob.doc.querySelectorAll(query),
        set = (Snap.set || Array)();
    for (var i = 0; i < nodelist.length; i++) {
        set.push(wrap(nodelist[i]));
    }
    return set;
};

function add2group(list) {
    if (!is(list, "array")) {
        list = Array.prototype.slice.call(arguments, 0);
    }
    var i = 0,
        j = 0,
        node = this.node;
    while (this[i]) delete this[i++];
    for (i = 0; i < list.length; i++) {
        if (list[i].type == "set") {
            list[i].forEach(function (el) {
                node.appendChild(el.node);
            });
        } else {
            node.appendChild(list[i].node);
        }
    }
    var children = node.childNodes;
    for (i = 0; i < children.length; i++) {
        this[j++] = wrap(children[i]);
    }
    return this;
}
// Hub garbage collector every 10s
setInterval(function () {
    for (var key in hub) if (hub[has](key)) {
        var el = hub[key],
            node = el.node;
        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
            delete hub[key];
        }
    }
}, 1e4);
function Element(el) {
    if (el.snap in hub) {
        return hub[el.snap];
    }
    var svg;
    try {
        svg = el.ownerSVGElement;
    } catch(e) {}
    /*\
     * Element.node
     [ property (object) ]
     **
     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
     > Usage
     | // draw a circle at coordinate 10,10 with radius of 10
     | var c = paper.circle(10, 10, 10);
     | c.node.onclick = function () {
     |     c.attr("fill", "red");
     | };
    \*/
    this.node = el;
    if (svg) {
        this.paper = new Paper(svg);
    }
    /*\
     * Element.type
     [ property (string) ]
     **
     * SVG tag name of the given element.
    \*/
    this.type = el.tagName || el.nodeName;
    var id = this.id = ID(this);
    this.anims = {};
    this._ = {
        transform: []
    };
    el.snap = id;
    hub[id] = this;
    if (this.type == "g") {
        this.add = add2group;
    }
    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
            this[method] = Paper.prototype[method];
        }
    }
}
   /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/
    Element.prototype.attr = function (params, value) {
        var el = this,
            node = el.node;
        if (!params) {
            if (node.nodeType != 1) {
                return {
                    text: node.nodeValue
                };
            }
            var attr = node.attributes,
                out = {};
            for (var i = 0, ii = attr.length; i < ii; i++) {
                out[attr[i].nodeName] = attr[i].nodeValue;
            }
            return out;
        }
        if (is(params, "string")) {
            if (arguments.length > 1) {
                var json = {};
                json[params] = value;
                params = json;
            } else {
                return eve("snap.util.getattr." + params, el).firstDefined();
            }
        }
        for (var att in params) {
            if (params[has](att)) {
                eve("snap.util.attr." + att, el, params[att]);
            }
        }
        return el;
    };
/*\
 * Snap.parse
 [ method ]
 **
 * Parses SVG fragment and converts it into a @Fragment
 **
 - svg (string) SVG string
 = (Fragment) the @Fragment
\*/
Snap.parse = function (svg) {
    var f = glob.doc.createDocumentFragment(),
        full = true,
        div = glob.doc.createElement("div");
    svg = Str(svg);
    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
        svg = "<svg>" + svg + "</svg>";
        full = false;
    }
    div.innerHTML = svg;
    svg = div.getElementsByTagName("svg")[0];
    if (svg) {
        if (full) {
            f = svg;
        } else {
            while (svg.firstChild) {
                f.appendChild(svg.firstChild);
            }
        }
    }
    return new Fragment(f);
};
function Fragment(frag) {
    this.node = frag;
}
/*\
 * Snap.fragment
 [ method ]
 **
 * Creates a DOM fragment from a given list of elements or strings
 **
 - varargs (…) SVG string
 = (Fragment) the @Fragment
\*/
Snap.fragment = function () {
    var args = Array.prototype.slice.call(arguments, 0),
        f = glob.doc.createDocumentFragment();
    for (var i = 0, ii = args.length; i < ii; i++) {
        var item = args[i];
        if (item.node && item.node.nodeType) {
            f.appendChild(item.node);
        }
        if (item.nodeType) {
            f.appendChild(item);
        }
        if (typeof item == "string") {
            f.appendChild(Snap.parse(item).node);
        }
    }
    return new Fragment(f);
};

function make(name, parent) {
    var res = $(name);
    parent.appendChild(res);
    var el = wrap(res);
    return el;
}
function Paper(w, h) {
    var res,
        desc,
        defs,
        proto = Paper.prototype;
    if (w && w.tagName == "svg") {
        if (w.snap in hub) {
            return hub[w.snap];
        }
        var doc = w.ownerDocument;
        res = new Element(w);
        desc = w.getElementsByTagName("desc")[0];
        defs = w.getElementsByTagName("defs")[0];
        if (!desc) {
            desc = $("desc");
            desc.appendChild(doc.createTextNode("Created with Snap"));
            res.node.appendChild(desc);
        }
        if (!defs) {
            defs = $("defs");
            res.node.appendChild(defs);
        }
        res.defs = defs;
        for (var key in proto) if (proto[has](key)) {
            res[key] = proto[key];
        }
        res.paper = res.root = res;
    } else {
        res = make("svg", glob.doc.body);
        $(res.node, {
            height: h,
            version: 1.1,
            width: w,
            xmlns: xmlns
        });
    }
    return res;
}
function wrap(dom) {
    if (!dom) {
        return dom;
    }
    if (dom instanceof Element || dom instanceof Fragment) {
        return dom;
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
        return new Paper(dom);
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
    }
    return new Element(dom);
}

Snap._.make = make;
Snap._.wrap = wrap;
/*\
 * Paper.el
 [ method ]
 **
 * Creates an element on paper with a given name and no attributes
 **
 - name (string) tag name
 - attr (object) attributes
 = (Element) the current element
 > Usage
 | var c = paper.circle(10, 10, 10); // is the same as...
 | var c = paper.el("circle").attr({
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
 | // and the same as
 | var c = paper.el("circle", {
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
\*/
Paper.prototype.el = function (name, attr) {
    var el = make(name, this.node);
    attr && el.attr(attr);
    return el;
};
/*\
 * Element.children
 [ method ]
 **
 * Returns array of all the children of the element.
 = (array) array of Elements
\*/
Element.prototype.children = function () {
    var out = [],
        ch = this.node.childNodes;
    for (var i = 0, ii = ch.length; i < ii; i++) {
        out[i] = Snap(ch[i]);
    }
    return out;
};
function jsonFiller(root, o) {
    for (var i = 0, ii = root.length; i < ii; i++) {
        var item = {
                type: root[i].type,
                attr: root[i].attr()
            },
            children = root[i].children();
        o.push(item);
        if (children.length) {
            jsonFiller(children, item.childNodes = []);
        }
    }
}
/*\
 * Element.toJSON
 [ method ]
 **
 * Returns object representation of the given element and all its children.
 = (object) in format
 o {
 o     type (string) this.type,
 o     attr (object) attributes map,
 o     childNodes (array) optional array of children in the same format
 o }
\*/
Element.prototype.toJSON = function () {
    var out = [];
    jsonFiller([this], out);
    return out[0];
};
// default
eve.on("snap.util.getattr", function () {
    var att = eve.nt();
    att = att.substring(att.lastIndexOf(".") + 1);
    var css = att.replace(/[A-Z]/g, function (letter) {
        return "-" + letter.toLowerCase();
    });
    if (cssAttr[has](css)) {
        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
    } else {
        return $(this.node, att);
    }
});
var cssAttr = {
    "alignment-baseline": 0,
    "baseline-shift": 0,
    "clip": 0,
    "clip-path": 0,
    "clip-rule": 0,
    "color": 0,
    "color-interpolation": 0,
    "color-interpolation-filters": 0,
    "color-profile": 0,
    "color-rendering": 0,
    "cursor": 0,
    "direction": 0,
    "display": 0,
    "dominant-baseline": 0,
    "enable-background": 0,
    "fill": 0,
    "fill-opacity": 0,
    "fill-rule": 0,
    "filter": 0,
    "flood-color": 0,
    "flood-opacity": 0,
    "font": 0,
    "font-family": 0,
    "font-size": 0,
    "font-size-adjust": 0,
    "font-stretch": 0,
    "font-style": 0,
    "font-variant": 0,
    "font-weight": 0,
    "glyph-orientation-horizontal": 0,
    "glyph-orientation-vertical": 0,
    "image-rendering": 0,
    "kerning": 0,
    "letter-spacing": 0,
    "lighting-color": 0,
    "marker": 0,
    "marker-end": 0,
    "marker-mid": 0,
    "marker-start": 0,
    "mask": 0,
    "opacity": 0,
    "overflow": 0,
    "pointer-events": 0,
    "shape-rendering": 0,
    "stop-color": 0,
    "stop-opacity": 0,
    "stroke": 0,
    "stroke-dasharray": 0,
    "stroke-dashoffset": 0,
    "stroke-linecap": 0,
    "stroke-linejoin": 0,
    "stroke-miterlimit": 0,
    "stroke-opacity": 0,
    "stroke-width": 0,
    "text-anchor": 0,
    "text-decoration": 0,
    "text-rendering": 0,
    "unicode-bidi": 0,
    "visibility": 0,
    "word-spacing": 0,
    "writing-mode": 0
};

eve.on("snap.util.attr", function (value) {
    var att = eve.nt(),
        attr = {};
    att = att.substring(att.lastIndexOf(".") + 1);
    attr[att] = value;
    var style = att.replace(/-(\w)/gi, function (all, letter) {
            return letter.toUpperCase();
        }),
        css = att.replace(/[A-Z]/g, function (letter) {
            return "-" + letter.toLowerCase();
        });
    if (cssAttr[has](css)) {
        this.node.style[style] = value == null ? E : value;
    } else {
        $(this.node, attr);
    }
});
(function (proto) {}(Paper.prototype));

// simple ajax
/*\
 * Snap.ajax
 [ method ]
 **
 * Simple implementation of Ajax
 **
 - url (string) URL
 - postData (object|string) data for post request
 - callback (function) callback
 - scope (object) #optional scope of callback
 * or
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
 = (XMLHttpRequest) the XMLHttpRequest object, just in case
\*/
Snap.ajax = function (url, postData, callback, scope){
    var req = new XMLHttpRequest,
        id = ID();
    if (req) {
        if (is(postData, "function")) {
            scope = callback;
            callback = postData;
            postData = null;
        } else if (is(postData, "object")) {
            var pd = [];
            for (var key in postData) if (postData.hasOwnProperty(key)) {
                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
            }
            postData = pd.join("&");
        }
        req.open((postData ? "POST" : "GET"), url, true);
        if (postData) {
            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }
        if (callback) {
            eve.once("snap.ajax." + id + ".0", callback);
            eve.once("snap.ajax." + id + ".200", callback);
            eve.once("snap.ajax." + id + ".304", callback);
        }
        req.onreadystatechange = function() {
            if (req.readyState != 4) return;
            eve("snap.ajax." + id + "." + req.status, scope, req);
        };
        if (req.readyState == 4) {
            return req;
        }
        req.send(postData);
        return req;
    }
};
/*\
 * Snap.load
 [ method ]
 **
 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
 **
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
\*/
Snap.load = function (url, callback, scope) {
    Snap.ajax(url, function (req) {
        var f = Snap.parse(req.responseText);
        scope ? callback.call(scope, f) : callback(f);
    });
};
var getOffset = function (elem) {
    var box = elem.getBoundingClientRect(),
        doc = elem.ownerDocument,
        body = doc.body,
        docElem = doc.documentElement,
        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
    return {
        y: top,
        x: left
    };
};
/*\
 * Snap.getElementByPoint
 [ method ]
 **
 * Returns you topmost element under given point.
 **
 = (object) Snap element object
 - x (number) x coordinate from the top left corner of the window
 - y (number) y coordinate from the top left corner of the window
 > Usage
 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
\*/
Snap.getElementByPoint = function (x, y) {
    var paper = this,
        svg = paper.canvas,
        target = glob.doc.elementFromPoint(x, y);
    if (glob.win.opera && target.tagName == "svg") {
        var so = getOffset(target),
            sr = target.createSVGRect();
        sr.x = x - so.x;
        sr.y = y - so.y;
        sr.width = sr.height = 1;
        var hits = target.getIntersectionList(sr, null);
        if (hits.length) {
            target = hits[hits.length - 1];
        }
    }
    if (!target) {
        return null;
    }
    return wrap(target);
};
/*\
 * Snap.plugin
 [ method ]
 **
 * Let you write plugins. You pass in a function with five arguments, like this:
 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
 |     Snap.newmethod = function () {};
 |     Element.prototype.newmethod = function () {};
 |     Paper.prototype.newmethod = function () {};
 | });
 * Inside the function you have access to all main objects (and their
 * prototypes). This allow you to extend anything you want.
 **
 - f (function) your plugin body
\*/
Snap.plugin = function (f) {
    f(Snap, Element, Paper, glob, Fragment);
};
glob.win.Snap = Snap;
return Snap;
}(window || this));

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
        is = Snap.is,
        Str = String,
        unit2px = Snap._unit2px,
        $ = Snap._.$,
        make = Snap._.make,
        getSomeDefs = Snap._.getSomeDefs,
        has = "hasOwnProperty",
        wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/
    elproto.getBBox = function (isWithoutTransform) {
        if (!Snap.Matrix || !Snap.path) {
            return this.node.getBBox();
        }
        var el = this,
            m = new Snap.Matrix;
        if (el.removed) {
            return Snap._.box();
        }
        while (el.type == "use") {
            if (!isWithoutTransform) {
                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
            }
            if (el.original) {
                el = el.original;
            } else {
                var href = el.attr("xlink:href");
                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
            }
        }
        var _ = el._,
            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
        try {
            if (isWithoutTransform) {
                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
                return Snap._.box(_.bboxwt);
            } else {
                el.realPath = pathfinder(el);
                el.matrix = el.transform().localMatrix;
                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
                return Snap._.box(_.bbox);
            }
        } catch (e) {
            // Firefox doesn’t give you bbox of hidden element
            return Snap._.box();
        }
    };
    var propString = function () {
        return this.string;
    };
    function extractTransform(el, tstr) {
        if (tstr == null) {
            var doReturn = true;
            if (el.type == "linearGradient" || el.type == "radialGradient") {
                tstr = el.node.getAttribute("gradientTransform");
            } else if (el.type == "pattern") {
                tstr = el.node.getAttribute("patternTransform");
            } else {
                tstr = el.node.getAttribute("transform");
            }
            if (!tstr) {
                return new Snap.Matrix;
            }
            tstr = Snap._.svgTransform2string(tstr);
        } else {
            if (!Snap._.rgTransform.test(tstr)) {
                tstr = Snap._.svgTransform2string(tstr);
            } else {
                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
            }
            if (is(tstr, "array")) {
                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
            }
            el._.transform = tstr;
        }
        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) {
            return m;
        } else {
            el.matrix = m;
        }
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/
    elproto.transform = function (tstr) {
        var _ = this._;
        if (tstr == null) {
            var papa = this,
                global = new Snap.Matrix(this.node.getCTM()),
                local = extractTransform(this),
                ms = [local],
                m = new Snap.Matrix,
                i,
                localString = local.toTransformString(),
                string = Str(local) == Str(this.matrix) ?
                            Str(_.transform) : localString;
            while (papa.type != "svg" && (papa = papa.parent())) {
                ms.push(extractTransform(papa));
            }
            i = ms.length;
            while (i--) {
                m.add(ms[i]);
            }
            return {
                string: string,
                globalMatrix: global,
                totalMatrix: m,
                localMatrix: local,
                diffMatrix: global.clone().add(local.invert()),
                global: global.toTransformString(),
                total: m.toTransformString(),
                local: localString,
                toString: propString
            };
        }
        if (tstr instanceof Snap.Matrix) {
            this.matrix = tstr;
            this._.transform = tstr.toTransformString();
        } else {
            extractTransform(this, tstr);
        }

        if (this.node) {
            if (this.type == "linearGradient" || this.type == "radialGradient") {
                $(this.node, {gradientTransform: this.matrix});
            } else if (this.type == "pattern") {
                $(this.node, {patternTransform: this.matrix});
            } else {
                $(this.node, {transform: this.matrix});
            }
        }

        return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/
    elproto.parent = function () {
        return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/
    /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/
    elproto.append = elproto.add = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this;
                el.forEach(function (el) {
                    it.add(el);
                });
                return this;
            }
            el = wrap(el);
            this.node.appendChild(el.node);
            el.paper = this.paper;
        }
        return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/
    elproto.appendTo = function (el) {
        if (el) {
            el = wrap(el);
            el.append(this);
        }
        return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/
    elproto.prepend = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this,
                    first;
                el.forEach(function (el) {
                    if (first) {
                        first.after(el);
                    } else {
                        it.prepend(el);
                    }
                    first = el;
                });
                return this;
            }
            el = wrap(el);
            var parent = el.parent();
            this.node.insertBefore(el.node, this.node.firstChild);
            this.add && this.add();
            el.paper = this.paper;
            this.parent() && this.parent().add();
            parent && parent.add();
        }
        return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/
    elproto.prependTo = function (el) {
        el = wrap(el);
        el.prepend(this);
        return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.before = function (el) {
        if (el.type == "set") {
            var it = this;
            el.forEach(function (el) {
                var parent = el.parent();
                it.node.parentNode.insertBefore(el.node, it.node);
                parent && parent.add();
            });
            this.parent().add();
            return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.after = function (el) {
        el = wrap(el);
        var parent = el.parent();
        if (this.node.nextSibling) {
            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        } else {
            this.node.parentNode.appendChild(el.node);
        }
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertBefore = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertAfter = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/
    elproto.remove = function () {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/
    elproto.select = function (query) {
        return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/
    elproto.selectAll = function (query) {
        var nodelist = this.node.querySelectorAll(query),
            set = (Snap.set || Array)();
        for (var i = 0; i < nodelist.length; i++) {
            set.push(wrap(nodelist[i]));
        }
        return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/
    elproto.asPX = function (attr, value) {
        if (value == null) {
            value = this.attr(attr);
        }
        return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/
    elproto.use = function () {
        var use,
            id = this.node.id;
        if (!id) {
            id = this.id;
            $(this.node, {
                id: id
            });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" ||
            this.type == "pattern") {
            use = make(this.type, this.node.parentNode);
        } else {
            use = make("use", this.node.parentNode);
        }
        $(use.node, {
            "xlink:href": "#" + id
        });
        use.original = this;
        return use;
    };
    function fixids(el) {
        var els = el.selectAll("*"),
            it,
            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
            ids = [],
            uses = {};
        function urltest(it, name) {
            var val = $(it.node, name);
            val = val && val.match(url);
            val = val && val[2];
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    var attr = {};
                    attr[name] = URL(id);
                    $(it.node, attr);
                });
            }
        }
        function linktest(it) {
            var val = $(it.node, "xlink:href");
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    it.attr("xlink:href", "#" + id);
                });
            }
        }
        for (var i = 0, ii = els.length; i < ii; i++) {
            it = els[i];
            urltest(it, "fill");
            urltest(it, "stroke");
            urltest(it, "filter");
            urltest(it, "mask");
            urltest(it, "clip-path");
            linktest(it);
            var oldid = $(it.node, "id");
            if (oldid) {
                $(it.node, {id: it.id});
                ids.push({
                    old: oldid,
                    id: it.id
                });
            }
        }
        for (i = 0, ii = ids.length; i < ii; i++) {
            var fs = uses[ids[i].old];
            if (fs) {
                for (var j = 0, jj = fs.length; j < jj; j++) {
                    fs[j](ids[i].id);
                }
            }
        }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/
    elproto.clone = function () {
        var clone = wrap(this.node.cloneNode(true));
        if ($(clone.node, "id")) {
            $(clone.node, {id: clone.id});
        }
        fixids(clone);
        clone.insertAfter(this);
        return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/
    elproto.toDefs = function () {
        var defs = getSomeDefs(this);
        defs.appendChild(this.node);
        return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/
    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
        var p = make("pattern", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        $(p.node, {
            x: x,
            y: y,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            id: p.id,
            viewBox: [x, y, width, height].join(" ")
        });
        p.node.appendChild(this.node);
        return p;
    };
// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/
    // TODO add usage for markers
    elproto.marker = function (x, y, width, height, refX, refY) {
        var p = make("marker", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            refX = x.refX || x.cx;
            refY = x.refY || x.cy;
            x = x.x;
        }
        $(p.node, {
            viewBox: [x, y, width, height].join(" "),
            markerWidth: width,
            markerHeight: height,
            orient: "auto",
            refX: refX || 0,
            refY: refY || 0,
            id: p.id
        });
        p.node.appendChild(this.node);
        return p;
    };
    // animation
    function slice(from, to, f) {
        return function (arr) {
            var res = arr.slice(from, to);
            if (res.length == 1) {
                res = res[0];
            }
            return f ? f(res) : res;
        };
    }
    var Animation = function (attr, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        this.attr = attr;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/
    Snap.animation = function (attr, ms, easing, callback) {
        return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/
    elproto.inAnim = function () {
        var el = this,
            res = [];
        for (var id in el.anims) if (el.anims[has](id)) {
            (function (a) {
                res.push({
                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
                    mina: a,
                    curStatus: a.status(),
                    status: function (val) {
                        return a.status(val);
                    },
                    stop: function () {
                        a.stop();
                    }
                });
            }(el.anims[id]));
        }
        return res;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/
    Snap.animate = function (from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        var now = mina.time(),
            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
        callback && eve.once("mina.finish." + anim.id, callback);
        return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/
    elproto.stop = function () {
        var anims = this.inAnim();
        for (var i = 0, ii = anims.length; i < ii; i++) {
            anims[i].stop();
        }
        return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/
    elproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = attrs.dur;
            attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
            el = this;
        for (var key in attrs) if (attrs[has](key)) {
            if (el.equal) {
                eq = el.equal(key, Str(attrs[key]));
                from = eq.from;
                to = eq.to;
                f = eq.f;
            } else {
                from = +el.attr(key);
                to = +attrs[key];
            }
            var len = is(from, "array") ? from.length : 1;
            keys[key] = slice(fkeys.length, fkeys.length + len, f);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
        }
        var now = mina.time(),
            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
                var attr = {};
                for (var key in keys) if (keys[has](key)) {
                    attr[key] = keys[key](val);
                }
                el.attr(attr);
            }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve("snap.animcreated." + el.id, anim);
        eve.once("mina.finish." + anim.id, function () {
            delete el.anims[anim.id];
            callback && callback.call(el);
        });
        eve.once("mina.stop." + anim.id, function () {
            delete el.anims[anim.id];
        });
        return el;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/
    elproto.data = function (key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0){
            eve("snap.data.get." + this.id, this, data, null);
            return data;
        }
        if (arguments.length == 1) {
            if (Snap.is(key, "object")) {
                for (var i in key) if (key[has](i)) {
                    this.data(i, key[i]);
                }
                return this;
            }
            eve("snap.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("snap.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/
    elproto.removeData = function (key) {
        if (key == null) {
            eldata[this.id] = {};
        } else {
            eldata[this.id] && delete eldata[this.id][key];
        }
        return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/
    /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/
    elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/
    elproto.innerSVG = toString();
    function toString(type) {
        return function () {
            var res = type ? "<" + this.type : "",
                attr = this.node.attributes,
                chld = this.node.childNodes;
            if (type) {
                for (var i = 0, ii = attr.length; i < ii; i++) {
                    res += " " + attr[i].name + '="' +
                            attr[i].value.replace(/"/g, '\\"') + '"';
                }
            }
            if (chld.length) {
                type && (res += ">");
                for (i = 0, ii = chld.length; i < ii; i++) {
                    if (chld[i].nodeType == 3) {
                        res += chld[i].nodeValue;
                    } else if (chld[i].nodeType == 1) {
                        res += wrap(chld[i]).toString();
                    }
                }
                type && (res += "</" + this.type + ">");
            } else {
                type && (res += "/>");
            }
            return res;
        };
    }
    elproto.toDataURL = function () {
        if (window && window.btoa) {
            var bb = this.getBBox(),
                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                x: +bb.x.toFixed(3),
                y: +bb.y.toFixed(3),
                width: +bb.width.toFixed(3),
                height: +bb.height.toFixed(3),
                contents: this.outerSVG()
            });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/
    Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/
    Fragment.prototype.selectAll = elproto.selectAll;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString,
        Str = String,
        math = Math,
        E = "";
    function Matrix(a, b, c, d, e, f) {
        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
            this.a = a.a;
            this.b = a.b;
            this.c = a.c;
            this.d = a.d;
            this.e = a.e;
            this.f = a.f;
            return;
        }
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function (matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
        matrixproto.add = function (a, b, c, d, e, f) {
            var out = [[], [], []],
                m = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]],
                matrix = [[a, c, e], [b, d, f], [0, 0, 1]],
                x, y, z, res;

            if (a && a instanceof Matrix) {
                matrix = [[a.a, a.c, a.e], [a.b, a.d, a.f], [0, 0, 1]];
            }

            for (x = 0; x < 3; x++) {
                for (y = 0; y < 3; y++) {
                    res = 0;
                    for (z = 0; z < 3; z++) {
                        res += m[x][z] * matrix[z][y];
                    }
                    out[x][y] = res;
                }
            }
            this.a = out[0][0];
            this.b = out[1][0];
            this.c = out[0][1];
            this.d = out[1][1];
            this.e = out[0][2];
            this.f = out[1][2];
            return this;
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/
        matrixproto.invert = function () {
            var me = this,
                x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/
        matrixproto.clone = function () {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/
        matrixproto.translate = function (x, y) {
            return this.add(1, 0, 0, 1, x, y);
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/
        matrixproto.scale = function (x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.add(1, 0, 0, 1, cx, cy);
            this.add(x, 0, 0, y, 0, 0);
            (cx || cy) && this.add(1, 0, 0, 1, -cx, -cy);
            return this;
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/
        matrixproto.rotate = function (a, x, y) {
            a = Snap.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math.cos(a).toFixed(9),
                sin = +math.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            return this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.skewX
         [ method ]
         **
         * Skews the matrix along the x-axis
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
        matrixproto.skewX = function (x) {
            return this.skew(x, 0);
        };
        /*\
         * Matrix.skewY
         [ method ]
         **
         * Skews the matrix along the y-axis
         - y (number) Angle to skew along the y-axis (in degrees).
        \*/
        matrixproto.skewY = function (y) {
            return this.skew(0, y);
        };
        /*\
         * Matrix.skew
         [ method ]
         **
         * Skews the matrix
         - y (number) Angle to skew along the y-axis (in degrees).
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
        matrixproto.skew = function (x, y) {
            x = x || 0;
            y = y || 0;
            x = Snap.rad(x);
            y = Snap.rad(y);
            var c = math.tan(x).toFixed(9);
            var b = math.tan(y).toFixed(9);
            return this.add(1, b, c, 1, 0, 0);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/
        matrixproto.x = function (x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/
        matrixproto.y = function (x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function (i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function () {
            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
        };
        matrixproto.offset = function () {
            return [this.e.toFixed(4), this.f.toFixed(4)];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/
        matrixproto.determinant = function () {
            return this.a * this.d - this.b * this.c;
        };
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/
        matrixproto.split = function () {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;

            // scale and shear
            var row = [[this.a, this.c], [this.b, this.d]];
            out.scalex = math.sqrt(norm(row[0]));
            normalize(row[0]);

            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];

            out.scaley = math.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;

            if (this.determinant() < 0) {
                out.scalex = -out.scalex;
            }

            // rotation
            var sin = -row[0][1],
                cos = row[1][1];
            if (cos < 0) {
                out.rotate = Snap.deg(math.acos(cos));
                if (sin < 0) {
                    out.rotate = 360 - out.rotate;
                }
            } else {
                out.rotate = Snap.deg(math.asin(sin));
            }

            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/
        matrixproto.toTransformString = function (shorter) {
            var s = shorter || this.split();
            if (!+s.shear.toFixed(9)) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) + 
                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E) +
                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E);
            } else {
                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
            }
        };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/
    Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/
    Snap.matrix = function (a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty",
        make = Snap._.make,
        wrap = Snap._.wrap,
        is = Snap.is,
        getSomeDefs = Snap._.getSomeDefs,
        reURLValue = /^url\(#?([^)]+)\)$/,
        $ = Snap._.$,
        URL = Snap.url,
        Str = String,
        separator = Snap._.separator,
        E = "";
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value.type == "mask") {
                var mask = value;
            } else {
                mask = make("mask", getSomeDefs(this));
                mask.node.appendChild(value.node);
            }
            !mask.node.id && $(mask.node, {
                id: mask.id
            });
            $(this.node, {
                mask: URL(mask.id)
            });
        }
    });
    (function (clipIt) {
        eve.on("snap.util.attr.clip", clipIt);
        eve.on("snap.util.attr.clip-path", clipIt);
        eve.on("snap.util.attr.clipPath", clipIt);
    }(function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value.type == "clipPath") {
                var clip = value;
            } else {
                clip = make("clipPath", getSomeDefs(this));
                clip.node.appendChild(value.node);
                !clip.node.id && $(clip.node, {
                    id: clip.id
                });
            }
            $(this.node, {
                "clip-path": URL(clip.node.id || clip.id)
            });
        }
    }));
    function fillStroke(name) {
        return function (value) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
                (value.node.firstChild.tagName == "radialGradient" ||
                value.node.firstChild.tagName == "linearGradient" ||
                value.node.firstChild.tagName == "pattern")) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value instanceof Element) {
                if (value.type == "radialGradient" || value.type == "linearGradient"
                   || value.type == "pattern") {
                    if (!value.node.id) {
                        $(value.node, {
                            id: value.id
                        });
                    }
                    var fill = URL(value.node.id);
                } else {
                    fill = value.attr(name);
                }
            } else {
                fill = Snap.color(value);
                if (fill.error) {
                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
                    if (grad) {
                        if (!grad.node.id) {
                            $(grad.node, {
                                id: grad.id
                            });
                        }
                        fill = URL(grad.node.id);
                    } else {
                        fill = value;
                    }
                } else {
                    fill = Str(fill);
                }
            }
            var attrs = {};
            attrs[name] = fill;
            $(this.node, attrs);
            this.node.style[name] = E;
        };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string) {
        string = Str(string);
        var tokens = string.match(gradrg);
        if (!tokens) {
            return null;
        }
        var type = tokens[1],
            params = tokens[2],
            stops = tokens[3];
        params = params.split(/\s*,\s*/).map(function (el) {
            return +el == el ? +el : el;
        });
        if (params.length == 1 && params[0] == 0) {
            params = [];
        }
        stops = stops.split("-");
        stops = stops.map(function (el) {
            el = el.split(":");
            var out = {
                color: el[0]
            };
            if (el[1]) {
                out.offset = parseFloat(el[1]);
            }
            return out;
        });
        return {
            type: type,
            params: params,
            stops: stops
        };
    });

    eve.on("snap.util.attr.d", function (value) {
        eve.stop();
        if (is(value, "array") && is(value[0], "array")) {
            value = Snap.path.toString.call(value);
        }
        value = Str(value);
        if (value.match(/[ruo]/i)) {
            value = Snap.path.toAbsolute(value);
        }
        $(this.node, {d: value});
    })(-1);
    eve.on("snap.util.attr.#text", function (value) {
        eve.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while (this.node.firstChild) {
            this.node.removeChild(this.node.firstChild);
        }
        this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function (value) {
        eve.stop();
        this.attr({d: value});
    })(-1);
    eve.on("snap.util.attr.class", function (value) {
        eve.stop();
        this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function (value) {
        var vb;
        if (is(value, "object") && "x" in value) {
            vb = [value.x, value.y, value.width, value.height].join(" ");
        } else if (is(value, "array")) {
            vb = value.join(" ");
        } else {
            vb = value;
        }
        $(this.node, {
            viewBox: vb
        });
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function (value) {
        this.transform(value);
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function (value) {
        if (this.type == "rect") {
            eve.stop();
            $(this.node, {
                rx: value,
                ry: value
            });
        }
    })(-1);
    eve.on("snap.util.attr.textpath", function (value) {
        eve.stop();
        if (this.type == "text") {
            var id, tp, node;
            if (!value && this.textPath) {
                tp = this.textPath;
                while (tp.node.firstChild) {
                    this.node.appendChild(tp.node.firstChild);
                }
                tp.remove();
                delete this.textPath;
                return;
            }
            if (is(value, "string")) {
                var defs = getSomeDefs(this),
                    path = wrap(defs.parentNode).path(value);
                defs.appendChild(path.node);
                id = path.id;
                path.attr({id: id});
            } else {
                value = wrap(value);
                if (value instanceof Element) {
                    id = value.attr("id");
                    if (!id) {
                        id = value.id;
                        value.attr({id: id});
                    }
                }
            }
            if (id) {
                tp = this.textPath;
                node = this.node;
                if (tp) {
                    tp.attr({"xlink:href": "#" + id});
                } else {
                    tp = $("textPath", {
                        "xlink:href": "#" + id
                    });
                    while (node.firstChild) {
                        tp.appendChild(node.firstChild);
                    }
                    node.appendChild(tp);
                    this.textPath = wrap(tp);
                }
            }
        }
    })(-1);
    eve.on("snap.util.attr.text", function (value) {
        if (this.type == "text") {
            var i = 0,
                node = this.node,
                tuner = function (chunk) {
                    var out = $("tspan");
                    if (is(chunk, "array")) {
                        for (var i = 0; i < chunk.length; i++) {
                            out.appendChild(tuner(chunk[i]));
                        }
                    } else {
                        out.appendChild(glob.doc.createTextNode(chunk));
                    }
                    out.normalize && out.normalize();
                    return out;
                };
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            var tuned = tuner(value);
            while (tuned.firstChild) {
                node.appendChild(tuned.firstChild);
            }
        }
        eve.stop();
    })(-1);
    function setFontSize(value) {
        eve.stop();
        if (value == +value) {
            value += "px";
        }
        this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);


    eve.on("snap.util.getattr.transform", function () {
        eve.stop();
        return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function () {
        eve.stop();
        return this.textPath;
    })(-1);
    // Markers
    (function () {
        function getter(end) {
            return function () {
                eve.stop();
                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
                if (style == "none") {
                    return style;
                } else {
                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
                }
            };
        }
        function setter(end) {
            return function (value) {
                eve.stop();
                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
                if (value == "" || !value) {
                    this.node.style[name] = "none";
                    return;
                }
                if (value.type == "marker") {
                    var id = value.node.id;
                    if (!id) {
                        $(value.node, {id: value.id});
                    }
                    this.node.style[name] = URL(id);
                    return;
                }
            };
        }
        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    }());
    eve.on("snap.util.getattr.r", function () {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
            eve.stop();
            return $(this.node, "rx");
        }
    })(-1);
    function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for (var i = 0, ii = children.length; i < ii; i++) {
            var chi = children[i];
            if (chi.nodeType == 3) {
                out.push(chi.nodeValue);
            }
            if (chi.tagName == "tspan") {
                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
                    out.push(chi.firstChild.nodeValue);
                } else {
                    out.push(textExtract(chi));
                }
            }
        }
        return out;
    }
    eve.on("snap.util.getattr.text", function () {
        if (this.type == "text" || this.type == "tspan") {
            eve.stop();
            var out = textExtract(this.node);
            return out.length == 1 ? out[0] : out;
        }
    })(-1);
    eve.on("snap.util.getattr.#text", function () {
        return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function () {
        eve.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
            vb = vb.split(separator);
            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.points", function () {
        var p = $(this.node, "points");
        eve.stop();
        if (p) {
            return p.split(separator);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.path", function () {
        var p = $(this.node, "d");
        eve.stop();
        return p;
    })(-1);
    eve.on("snap.util.getattr.class", function () {
        return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
        eve.stop();
        return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g,
        rgBadSpace = /[\t\r\n\f]/g,
        rgTrim = /(^\s+|\s+$)/g,
        Str = String,
        elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.addClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;

        if (classes.length) {
            j = 0;
            while ((clazz = classes[j++])) {
                pos = curClasses.indexOf(clazz);
                if (!~pos) {
                    curClasses.push(clazz);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.removeClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        if (curClasses.length) {
            j = 0;
            while ((clazz = classes[j++])) {
                pos = curClasses.indexOf(clazz);
                if (~pos) {
                    curClasses.splice(pos, 1);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/
    elproto.hasClass = function (value) {
        var elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/
    elproto.toggleClass = function (value, flag) {
        if (flag != null) {
            if (flag) {
                return this.addClass(value);
            } else {
                return this.removeClass(value);
            }
        }
        var classes = (value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        j = 0;
        while ((clazz = classes[j++])) {
            pos = curClasses.indexOf(clazz);
            if (~pos) {
                curClasses.splice(pos, 1);
            } else {
                curClasses.push(clazz);
            }
        }

        finalValue = curClasses.join(" ");
        if (className != finalValue) {
            elem.className.baseVal = finalValue;
        }
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var operators = {
            "+": function (x, y) {
                    return x + y;
                },
            "-": function (x, y) {
                    return x - y;
                },
            "/": function (x, y) {
                    return x / y;
                },
            "*": function (x, y) {
                    return x * y;
                }
        },
        Str = String,
        reUnit = /[a-z]+$/i,
        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    eve.on("snap.util.attr", function (val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
            var evnt = eve.nt(),
                name = evnt.substring(evnt.lastIndexOf(".") + 1),
                a = this.attr(name),
                atr = {};
            eve.stop();
            var unit = plus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[plus[1]];
            if (aUnit && aUnit == unit) {
                val = op(parseFloat(a), +plus[2]);
            } else {
                a = this.asPX(name);
                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
            }
            if (isNaN(a) || isNaN(val)) {
                return;
            }
            atr[name] = val;
            this.attr(atr);
        }
    })(-10);
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this,
            bplus = Str(b).match(reAddon);
        if (bplus) {
            eve.stop();
            var unit = bplus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[bplus[1]];
            if (aUnit && aUnit == unit) {
                return {
                    from: parseFloat(a),
                    to: op(parseFloat(a), +bplus[2]),
                    f: getUnit(aUnit)
                };
            } else {
                a = this.asPX(name);
                return {
                    from: a,
                    to: op(a, this.asPX(name, bplus[2] + unit)),
                    f: getNumber
                };
            }
        }
    })(-10);
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype,
        is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/
    proto.rect = function (x, y, w, h, rx, ry) {
        var attr;
        if (ry == null) {
            ry = rx;
        }
        if (is(x, "object") && x == "[object Object]") {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                width: w,
                height: h
            };
            if (rx != null) {
                attr.rx = rx;
                attr.ry = ry;
            }
        }
        return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/
    proto.circle = function (cx, cy, r) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr = {
                cx: cx,
                cy: cy,
                r: r
            };
        }
        return this.el("circle", attr);
    };

    var preload = (function () {
        function onerror() {
            this.parentNode.removeChild(this);
        }
        return function (src, f) {
            var img = glob.doc.createElement("img"),
                body = glob.doc.body;
            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
            img.onload = function () {
                f.call(img);
                img.onload = img.onerror = null;
                body.removeChild(img);
            };
            img.onerror = onerror;
            body.appendChild(img);
            img.src = src;
        };
    }());

    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/
    proto.image = function (src, x, y, width, height) {
        var el = this.el("image");
        if (is(src, "object") && "src" in src) {
            el.attr(src);
        } else if (src != null) {
            var set = {
                "xlink:href": src,
                preserveAspectRatio: "none"
            };
            if (x != null && y != null) {
                set.x = x;
                set.y = y;
            }
            if (width != null && height != null) {
                set.width = width;
                set.height = height;
            } else {
                preload(src, function () {
                    Snap._.$(el.node, {
                        width: this.offsetWidth,
                        height: this.offsetHeight
                    });
                });
            }
            Snap._.$(el.node, set);
        }
        return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/
    proto.ellipse = function (cx, cy, rx, ry) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr ={
                cx: cx,
                cy: cy,
                rx: rx,
                ry: ry
            };
        }
        return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/
    proto.path = function (d) {
        var attr;
        if (is(d, "object") && !is(d, "array")) {
            attr = d;
        } else if (d) {
            attr = {d: d};
        }
        return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/
    /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/
    proto.group = proto.g = function (first) {
        var attr,
            el = this.el("g");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/
    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is(x, "object") && y == null) {
            attrs = x;
        } else {
            if (x != null) {
                attrs.x = x;
            }
            if (y != null) {
                attrs.y = y;
            }
            if (width != null) {
                attrs.width = width;
            }
            if (height != null) {
                attrs.height = height;
            }
            if (vbx != null && vby != null && vbw != null && vbh != null) {
                attrs.viewBox = [vbx, vby, vbw, vbh];
            }
        }
        return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/
    proto.mask = function (first) {
        var attr,
            el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/
    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
        if (is(x, "object")) {
            var attr = x;
        } else {
            attr = {patternUnits: "userSpaceOnUse"};
            if (x) {
                attr.x = x;
            }
            if (y) {
                attr.y = y;
            }
            if (width != null) {
                attr.width = width;
            }
            if (height != null) {
                attr.height = height;
            }
            if (vx != null && vy != null && vw != null && vh != null) {
                attr.viewBox = [vx, vy, vw, vh];
            } else {
                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
            }
        }
        return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/
    proto.use = function (id) {
        if (id != null) {
            if (id instanceof Element) {
                if (!id.attr("id")) {
                    id.attr({id: Snap._.id(id)});
                }
                id = id.attr("id");
            }
            if (String(id).charAt() == "#") {
                id = id.substring(1);
            }
            return this.el("use", {"xlink:href": "#" + id});
        } else {
            return Element.prototype.use.call(this);
        }
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/
    proto.symbol = function (vx, vy, vw, vh) {
        var attr = {};
        if (vx != null && vy != null && vw != null && vh != null) {
            attr.viewBox = [vx, vy, vw, vh];
        }

        return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/
    proto.text = function (x, y, text) {
        var attr = {};
        if (is(x, "object")) {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                text: text || ""
            };
        }
        return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/
    proto.line = function (x1, y1, x2, y2) {
        var attr = {};
        if (is(x1, "object")) {
            attr = x1;
        } else if (x1 != null) {
            attr = {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        }
        return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/
    proto.polyline = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/
    proto.polygon = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polygon", attr);
    };
    // gradients
    (function () {
        var $ = Snap._.$;
        // gradients' helpers
        function Gstops() {
            return this.selectAll("stop");
        }
        function GaddStop(color, offset) {
            var stop = $("stop"),
                attr = {
                    offset: +offset + "%"
                };
            color = Snap.color(color);
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) {
                attr["stop-opacity"] = color.opacity;
            }
            $(stop, attr);
            this.node.appendChild(stop);
            return this;
        }
        function GgetBBox() {
            if (this.type == "linearGradient") {
                var x1 = $(this.node, "x1") || 0,
                    x2 = $(this.node, "x2") || 1,
                    y1 = $(this.node, "y1") || 0,
                    y2 = $(this.node, "y2") || 0;
                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
            } else {
                var cx = this.node.cx || .5,
                    cy = this.node.cy || .5,
                    r = this.node.r || 0;
                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
            }
        }
        function gradient(defs, str) {
            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
                el;
            if (!grad) {
                return null;
            }
            grad.params.unshift(defs);
            if (grad.type.toLowerCase() == "l") {
                el = gradientLinear.apply(0, grad.params);
            } else {
                el = gradientRadial.apply(0, grad.params);
            }
            if (grad.type != grad.type.toLowerCase()) {
                $(el.node, {
                    gradientUnits: "userSpaceOnUse"
                });
            }
            var stops = grad.stops,
                len = stops.length,
                start = 0,
                j = 0;
            function seed(i, end) {
                var step = (end - start) / (i - j);
                for (var k = j; k < i; k++) {
                    stops[k].offset = +(+start + step * (k - j)).toFixed(2);
                }
                j = i;
                start = end;
            }
            len--;
            for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
                seed(i, stops[i].offset);
            }
            stops[len].offset = stops[len].offset || 100;
            seed(len, stops[len].offset);
            for (i = 0; i <= len; i++) {
                var stop = stops[i];
                el.addStop(stop.color, stop.offset);
            }
            return el;
        }
        function gradientLinear(defs, x1, y1, x2, y2) {
            var el = Snap._.make("linearGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (x1 != null) {
                $(el.node, {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                });
            }
            return el;
        }
        function gradientRadial(defs, cx, cy, r, fx, fy) {
            var el = Snap._.make("radialGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (cx != null) {
                $(el.node, {
                    cx: cx,
                    cy: cy,
                    r: r
                });
            }
            if (fx != null && fy != null) {
                $(el.node, {
                    fx: fx,
                    fy: fy
                });
            }
            return el;
        }
        /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/
        proto.gradient = function (str) {
            return gradient(this.defs, str);
        };
        proto.gradientLinear = function (x1, y1, x2, y2) {
            return gradientLinear(this.defs, x1, y1, x2, y2);
        };
        proto.gradientRadial = function (cx, cy, r, fx, fy) {
            return gradientRadial(this.defs, cx, cy, r, fx, fy);
        };
        /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/
        proto.toString = function () {
            var doc = this.node.ownerDocument,
                f = doc.createDocumentFragment(),
                d = doc.createElement("div"),
                svg = this.node.cloneNode(true),
                res;
            f.appendChild(d);
            d.appendChild(svg);
            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
            res = d.innerHTML;
            f.removeChild(f.firstChild);
            return res;
        };
        /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/
        proto.toDataURL = function () {
            if (window && window.btoa) {
                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
            }
        };
        /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/
        proto.clear = function () {
            var node = this.node.firstChild,
                next;
            while (node) {
                next = node.nextSibling;
                if (node.tagName != "defs") {
                    node.parentNode.removeChild(node);
                } else {
                    proto.clear.call({node: node});
                }
                node = next;
            }
        };
    }());
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        is = Snap.is,
        clone = Snap._.clone,
        has = "hasOwnProperty",
        p2s = /,?([a-z]),?/gi,
        toFloat = parseFloat,
        math = Math,
        PI = math.PI,
        mmin = math.min,
        mmax = math.max,
        pow = math.pow,
        abs = math.abs;
    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) {
            p[ps].sleep = 100;
        } else {
            p[ps] = {
                sleep: 100
            };
        }
        setTimeout(function () {
            for (var key in p) if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }
    function box(x, y, width, height) {
        if (x == null) {
            x = y = width = height = 0;
        }
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math.min(width, height) / 2,
            r2: math.max(width, height) / 2,
            r0: math.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [x, y, width, height].join(" ")
        };
    }
    function toString() {
        return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
        var res = clone(pathArray);
        res.toString = toString;
        return res;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) {
            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        } else {
            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
        }
    }
    function getLengthFactory(istotal, subpath) {
        function O(val) {
            return +(+val).toFixed(3);
        }
        return Snap._.cacher(function (path, length, onlystart) {
            if (path instanceof Element) {
                path = path.attr("d");
            }
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point,
                len = 0;
            for (var i = 0, ii = path.length; i < ii; i++) {
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += [
                                "C" + O(point.start.x),
                                O(point.start.y),
                                O(point.m.x),
                                O(point.m.y),
                                O(point.x),
                                O(point.y)
                            ];
                            if (onlystart) {return sp;}
                            subpaths.start = sp;
                            sp = [
                                "M" + O(point.x),
                                O(point.y) + "C" + O(point.n.x),
                                O(point.n.y),
                                O(point.end.x),
                                O(point.end.y),
                                O(p[5]),
                                O(p[6])
                            ].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return point;
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            return point;
        }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1),
        getPointAtLength = getLengthFactory(),
        getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t,
            t13 = pow(t1, 3),
            t12 = pow(t1, 2),
            t2 = t * t,
            t3 = t2 * t,
            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
            ax = t1 * p1x + t * c1x,
            ay = t1 * p1y + t * c1y,
            cx = t1 * c2x + t * p2x,
            cy = t1 * c2y + t * p2y,
            alpha = (90 - math.atan2(mx - nx, my - ny) * 180 / PI);
        // (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {x: mx, y: my},
            n: {x: nx, y: ny},
            start: {x: ax, y: ay},
            end: {x: cx, y: cy},
            alpha: alpha
        };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap.is(p1x, "array")) {
            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox = curveDim.apply(null, p1x);
        return box(
            bbox.min.x,
            bbox.min.y,
            bbox.max.x - bbox.min.x,
            bbox.max.y - bbox.min.y
        );
    }
    function isPointInsideBBox(bbox, x, y) {
        return  x >= bbox.x &&
                x <= bbox.x + bbox.width &&
                y >= bbox.y &&
                y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) {
            z = 1;
        }
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2,
            n = 12,
            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
            sum = 0;
        for (var i = 0; i < n; i++) {
            var ct = z2 * Tvalues[i] + z2,
                xbase = base3(ct, x1, x2, x3, x4),
                ybase = base3(ct, y1, y2, y3, y4),
                comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
            return;
        }
        var t = 1,
            step = t / 2,
            t2 = t - step,
            l,
            e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while (abs(l - ll) > e) {
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (
            mmax(x1, x2) < mmin(x3, x4) ||
            mmin(x1, x2) > mmax(x3, x4) ||
            mmax(y1, y2) < mmin(y3, y4) ||
            mmin(y1, y2) > mmax(y3, y4)
        ) {
            return;
        }
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

        if (!denominator) {
            return;
        }
        var px = nx / denominator,
            py = ny / denominator,
            px2 = +px.toFixed(2),
            py2 = +py.toFixed(2);
        if (
            px2 < +mmin(x1, x2).toFixed(2) ||
            px2 > +mmax(x1, x2).toFixed(2) ||
            px2 < +mmin(x3, x4).toFixed(2) ||
            px2 > +mmax(x3, x4).toFixed(2) ||
            py2 < +mmin(y1, y2).toFixed(2) ||
            py2 > +mmax(y1, y2).toFixed(2) ||
            py2 < +mmin(y3, y4).toFixed(2) ||
            py2 > +mmax(y3, y4).toFixed(2)
        ) {
            return;
        }
        return {x: px, y: py};
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1),
            bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) {
            return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1),
            l2 = bezlen.apply(0, bez2),
            n1 = ~~(l1 / 8),
            n2 = ~~(l2 / 8),
            dots1 = [],
            dots2 = [],
            xy = {},
            res = justCount ? 0 : [];
        for (var i = 0; i < n1 + 1; i++) {
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({x: p.x, y: p.y, t: i / n1});
        }
        for (i = 0; i < n2 + 1; i++) {
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({x: p.x, y: p.y, t: i / n2});
        }
        for (i = 0; i < n1; i++) {
            for (var j = 0; j < n2; j++) {
                var di = dots1[i],
                    di1 = dots1[i + 1],
                    dj = dots2[j],
                    dj1 = dots2[j + 1],
                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
                if (is) {
                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
                        continue;
                    }
                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                        if (justCount) {
                            res++;
                        } else {
                            res.push({
                                x: is.x,
                                y: is.y,
                                t1: t1,
                                t2: t2
                            });
                        }
                    }
                }
            }
        }
        return res;
    }
    function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
            res = justCount ? 0 : [];
        for (var i = 0, ii = path1.length; i < ii; i++) {
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [x1, y1].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
                    x1 = x1m;
                    y1 = y1m;
                }
                for (var j = 0, jj = path2.length; j < jj; j++) {
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [x2, y2].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) {
                            res += intr;
                        } else {
                            for (var k = 0, kk = intr.length; k < kk; k++) {
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res = res.concat(intr);
                        }
                    }
                }
            }
        }
        return res;
    }
    function isPointInsidePath(path, x, y) {
        var bbox = pathBBox(path);
        return isPointInsideBBox(bbox, x, y) &&
               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
    }
    function pathBBox(path) {
        var pth = paths(path);
        if (pth.bbox) {
            return clone(pth.bbox);
        }
        if (!path) {
            return box();
        }
        path = path2curve(path);
        var x = 0, 
            y = 0,
            X = [],
            Y = [],
            p;
        for (var i = 0, ii = path.length; i < ii; i++) {
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X.concat(dim.min.x, dim.max.x);
                Y = Y.concat(dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin.apply(0, X),
            ymin = mmin.apply(0, Y),
            xmax = mmax.apply(0, X),
            ymax = mmax.apply(0, Y),
            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone(bb);
        return bb;
    }
    function rectPath(x, y, w, h, r) {
        if (r) {
            return [
                ["M", +x + (+r), y],
                ["l", w - r * 2, 0],
                ["a", r, r, 0, 0, 1, r, r],
                ["l", 0, h - r * 2],
                ["a", r, r, 0, 0, 1, -r, r],
                ["l", r * 2 - w, 0],
                ["a", r, r, 0, 0, 1, -r, -r],
                ["l", 0, r * 2 - h],
                ["a", r, r, 0, 0, 1, r, -r],
                ["z"]
            ];
        }
        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
        res.toString = toString;
        return res;
    }
    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) {
            ry = rx;
        }
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) {
            var rad = Math.PI / 180,
                x1 = x + rx * Math.cos(-ry * rad),
                x2 = x + rx * Math.cos(-a * rad),
                y1 = y + rx * Math.sin(-ry * rad),
                y2 = y + rx * Math.sin(-a * rad),
                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
        } else {
            res = [
                ["M", x, y],
                ["m", 0, -ry],
                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
                ["z"]
            ];
        }
        res.toString = toString;
        return res;
    }
    var unit2px = Snap._unit2px,
        getPath = {
        path: function (el) {
            return el.attr("path");
        },
        circle: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function (el) {
            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
        },
        polyline: function (el) {
            return "M" + el.attr("points");
        },
        polygon: function (el) {
            return "M" + el.attr("points") + "z";
        },
        deflt: function (el) {
            var bbox = el.node.getBBox();
            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
    };
    function pathToRelative(pathArray) {
        var pth = paths(pathArray),
            lowerCase = String.prototype.toLowerCase;
        if (pth.rel) {
            return pathClone(pth.rel);
        }
        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
            pathArray = Snap.parsePathString(pathArray);
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0;
        if (pathArray[0][0] == "M") {
            x = pathArray[0][1];
            y = pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res.push(["M", x, y]);
        }
        for (var i = start, ii = pathArray.length; i < ii; i++) {
            var r = res[i] = [],
                pa = pathArray[i];
            if (pa[0] != lowerCase.call(pa[0])) {
                r[0] = lowerCase.call(pa[0]);
                switch (r[0]) {
                    case "a":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +(pa[6] - x).toFixed(3);
                        r[7] = +(pa[7] - y).toFixed(3);
                        break;
                    case "v":
                        r[1] = +(pa[1] - y).toFixed(3);
                        break;
                    case "m":
                        mx = pa[1];
                        my = pa[2];
                    default:
                        for (var j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +(pa[j] - ((j % 2) ? x : y)).toFixed(3);
                        }
                }
            } else {
                r = res[i] = [];
                if (pa[0] == "m") {
                    mx = pa[1] + x;
                    my = pa[2] + y;
                }
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    res[i][k] = pa[k];
                }
            }
            var len = res[i].length;
            switch (res[i][0]) {
                case "z":
                    x = mx;
                    y = my;
                    break;
                case "h":
                    x += +res[i][len - 1];
                    break;
                case "v":
                    y += +res[i][len - 1];
                    break;
                default:
                    x += +res[i][len - 2];
                    y += +res[i][len - 1];
            }
        }
        res.toString = toString;
        pth.rel = pathClone(res);
        return res;
    }
    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) {
            return pathClone(pth.abs);
        }
        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
            pathArray = Snap.parsePathString(pathArray);
        }
        if (!pathArray || !pathArray.length) {
            return [["M", 0, 0]];
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0,
            pa0;
        if (pathArray[0][0] == "M") {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res[0] = ["M", x, y];
        }
        var crz = pathArray.length == 3 &&
            pathArray[0][0] == "M" &&
            pathArray[1][0].toUpperCase() == "R" &&
            pathArray[2][0].toUpperCase() == "Z";
        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
            res.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch (r[0]) {
                    case "A":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case "V":
                        r[1] = +pa[1] + y;
                        break;
                    case "H":
                        r[1] = +pa[1] + x;
                        break;
                    case "R":
                        var dots = [x, y].concat(pa.slice(1));
                        for (var j = 2, jj = dots.length; j < jj; j++) {
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res.pop();
                        res = res.concat(catmullRom2bezier(dots, crz));
                        break;
                    case "O":
                        res.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res = res.concat(dots);
                        break;
                    case "U":
                        res.pop();
                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = ["U"].concat(res[res.length - 1].slice(-2));
                        break;
                    case "M":
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for (j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +pa[j] + ((j % 2) ? x : y);
                        }
                }
            } else if (pa0 == "R") {
                dots = [x, y].concat(pa.slice(1));
                res.pop();
                res = res.concat(catmullRom2bezier(dots, crz));
                r = ["R"].concat(pa.slice(-2));
            } else if (pa0 == "O") {
                res.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res = res.concat(dots);
            } else if (pa0 == "U") {
                res.pop();
                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = ["U"].concat(res[res.length - 1].slice(-2));
            } else {
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    r[k] = pa[k];
                }
            }
            pa0 = pa0.toUpperCase();
            if (pa0 != "O") {
                switch (r[0]) {
                    case "Z":
                        x = +mx;
                        y = +my;
                        break;
                    case "H":
                        x = r[1];
                        break;
                    case "V":
                        y = r[1];
                        break;
                    case "M":
                        mx = r[r.length - 2];
                        my = r[r.length - 1];
                    default:
                        x = r[r.length - 2];
                        y = r[r.length - 1];
                }
            }
        }
        res.toString = toString;
        pth.abs = pathClone(res);
        return res;
    }
    function l2c(x1, y1, x2, y2) {
        return [x1, y1, x2, y2, x2, y2];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3,
            _23 = 2 / 3;
        return [
                _13 * x1 + _23 * ax,
                _13 * y1 + _23 * ay,
                _13 * x2 + _23 * ax,
                _13 * y2 + _23 * ay,
                x2,
                y2
            ];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        // for more information of where this math came from visit:
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        var _120 = PI * 120 / 180,
            rad = PI / 180 * (+angle || 0),
            res = [],
            xy,
            rotate = Snap._.cacher(function (x, y, rad) {
                var X = x * math.cos(rad) - y * math.sin(rad),
                    Y = x * math.sin(rad) + y * math.cos(rad);
                return {x: X, y: Y};
            });
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var cos = math.cos(PI / 180 * angle),
                sin = math.sin(PI / 180 * angle),
                x = (x1 - x2) / 2,
                y = (y1 - y2) / 2;
            var h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
            if (h > 1) {
                h = math.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx,
                ry2 = ry * ry,
                k = (large_arc_flag == sweep_flag ? -1 : 1) *
                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
                cx = k * rx * y / ry + (x1 + x2) / 2,
                cy = k * -ry * x / rx + (y1 + y2) / 2,
                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
                f2 = math.asin(((y2 - cy) / ry).toFixed(9));

            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) {
                f1 = f1 - PI * 2;
            }
            if (!sweep_flag && f2 > f1) {
                f2 = f2 - PI * 2;
            }
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2,
                x2old = x2,
                y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math.cos(f2);
            y2 = cy + ry * math.sin(f2);
            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
        }
        df = f2 - f1;
        var c1 = math.cos(f1),
            s1 = math.sin(f1),
            c2 = math.cos(f2),
            s2 = math.sin(f2),
            t = math.tan(df / 4),
            hx = 4 / 3 * rx * t,
            hy = 4 / 3 * ry * t,
            m1 = [x1, y1],
            m2 = [x1 + hx * s1, y1 - hy * c1],
            m3 = [x2 + hx * s2, y2 - hy * c2],
            m4 = [x2, y2];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) {
            return [m2, m3, m4].concat(res);
        } else {
            res = [m2, m3, m4].concat(res).join().split(",");
            var newres = [];
            for (var i = 0, ii = res.length; i < ii; i++) {
                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
            }
            return newres;
        }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t;
        return {
            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
        };
    }
    
    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [],
            bounds = [[], []],
            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for (var i = 0; i < 2; ++i) {
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) {
                    continue;
                }
                t = -c / b;
                if (0 < t && t < 1) {
                    tvalues.push(t);
                }
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math.sqrt(b2ac);
            if (b2ac < 0) {
                continue;
            }
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) {
                tvalues.push(t1);
            }
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) {
                tvalues.push(t2);
            }
        }

        var x, y, j = tvalues.length,
            jlen = j,
            mt;
        while (j--) {
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
            bounds[1][j] = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
        }

        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;


        return {
          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
        };
    }

    function path2curve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) {
            return pathClone(pth.curve);
        }
        var p = pathToAbsolute(path),
            p2 = path2 && pathToAbsolute(path2),
            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            processPath = function (path, d, pcom) {
                var nx, ny;
                if (!path) {
                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
                }
                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
                switch (path[0]) {
                    case "M":
                        d.X = path[1];
                        d.Y = path[2];
                        break;
                    case "A":
                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
                        break;
                    case "S":
                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
                            nx = d.x * 2 - d.bx;          // And reflect the previous
                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
                        }
                        else {                            // or some else or nothing
                            nx = d.x;
                            ny = d.y;
                        }
                        path = ["C", nx, ny].concat(path.slice(1));
                        break;
                    case "T":
                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
                            d.qy = d.y * 2 - d.qy;        // to case "S".
                        }
                        else {                            // or something else or nothing
                            d.qx = d.x;
                            d.qy = d.y;
                        }
                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                        break;
                    case "Q":
                        d.qx = path[1];
                        d.qy = path[2];
                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                        break;
                    case "L":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
                        break;
                    case "H":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
                        break;
                    case "V":
                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
                        break;
                    case "Z":
                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
                        break;
                }
                return path;
            },
            fixArc = function (pp, i) {
                if (pp[i].length > 7) {
                    pp[i].shift();
                    var pi = pp[i];
                    while (pi.length) {
                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
                        p2 && (pcoms2[i] = "A"); // the same as above
                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
                    }
                    pp.splice(i, 1);
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            fixM = function (path1, path2, a1, a2, i) {
                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                    path2.splice(i, 0, ["M", a2.x, a2.y]);
                    a1.bx = 0;
                    a1.by = 0;
                    a1.x = path1[i][1];
                    a1.y = path1[i][2];
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            pcoms1 = [], // path commands of original path p
            pcoms2 = [], // path commands of original path p2
            pfirst = "", // temporary holder for original path command
            pcom = ""; // holder for previous path command of original path
        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
            p[i] && (pfirst = p[i][0]); // save current path command

            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
            {
                pcoms1[i] = pfirst; // Save current path command
                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
            }
            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
            // which may produce multiple C:s
            // so we have to make sure that C is also C in original path

            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

            if (p2) { // the same procedures is done to p2
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != "C") {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);

                if (pcoms2[i] != "A" && pfirst == "C") {
                    pcoms2[i] = "C";
                }

                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i],
                seg2 = p2 && p2[i],
                seglen = seg.length,
                seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) {
            pth.curve = pathClone(p);
        }
        return p2 ? [p, p2] : p;
    }
    function mapPath(path, matrix) {
        if (!matrix) {
            return path;
        }
        var x, y, i, j, ii, jj, pathi;
        path = path2curve(path);
        for (i = 0, ii = path.length; i < ii; i++) {
            pathi = path[i];
            for (j = 1, jj = pathi.length; j < jj; j += 2) {
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    }

    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
            var p = [
                        {x: +crp[i - 2], y: +crp[i - 1]},
                        {x: +crp[i],     y: +crp[i + 1]},
                        {x: +crp[i + 2], y: +crp[i + 3]},
                        {x: +crp[i + 4], y: +crp[i + 5]}
                    ];
            if (z) {
                if (!i) {
                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
                } else if (iLen - 4 == i) {
                    p[3] = {x: +crp[0], y: +crp[1]};
                } else if (iLen - 2 == i) {
                    p[2] = {x: +crp[0], y: +crp[1]};
                    p[3] = {x: +crp[2], y: +crp[3]};
                }
            } else {
                if (iLen - 4 == i) {
                    p[3] = p[2];
                } else if (!i) {
                    p[0] = {x: +crp[i], y: +crp[i + 1]};
                }
            }
            d.push(["C",
                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
                  (p[1].y + 6*p[2].y - p[3].y) / 6,
                  p[2].x,
                  p[2].y
            ]);
        }

        return d;
    }

    // export
    Snap.path = paths;

    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/
    Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    Snap.path.getSubpath = function (path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) {
            return getSubpathsAtLength(path, from).end;
        }
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/
    elproto.getTotalLength = function () {
        if (this.node.getTotalLength) {
            return this.node.getTotalLength();
        }
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    elproto.getPointAtLength = function (length) {
        return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    elproto.getSubpath = function (from, to) {
        return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/
    Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/
    Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function (x, y, X, Y) {
        var r = 100,
            b = box(x - r / 2, y - r / 2, r, r),
            inside = [],
            getter = X[0].hasOwnProperty("x") ? function (i) {
                return {
                    x: X[i].x,
                    y: X[i].y
                };
            } : function (i) {
                return {
                    x: X[i],
                    y: Y[i]
                };
            },
            found = 0;
        while (r <= 1e6 && !found) {
            for (var i = 0, ii = X.length; i < ii; i++) {
                var xy = getter(i);
                if (isPointInsideBBox(b, xy.x, xy.y)) {
                    found++;
                    inside.push(xy);
                    break;
                }
            }
            if (!found) {
                r *= 2;
                b = box(x - r / 2, y - r / 2, r, r)
            }
        }
        if (r == 1e6) {
            return;
        }
        var len = Infinity,
            res;
        for (i = 0, ii = inside.length; i < ii; i++) {
            var l = Snap.len(x, y, inside[i].x, inside[i].y);
            if (len > l) {
                len = l;
                inside[i].len = l;
                res = inside[i];
            }
        }
        return res;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/
    Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/
    Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/
    Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/
    Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/
    Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var mmax = Math.max,
        mmin = Math.min;

    // Set
    var Set = function (items) {
        this.items = [];
	this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
            for (var i = 0, ii = items.length; i < ii; i++) {
                if (items[i]) {
                    this[this.items.length] = this.items[this.items.length] = items[i];
                    this.length++;
                }
            }
        }
    },
    setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/
    setproto.push = function () {
        var item,
            len;
        for (var i = 0, ii = arguments.length; i < ii; i++) {
            item = arguments[i];
            if (item) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/
    setproto.pop = function () {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/
    setproto.forEach = function (callback, thisArg) {
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            if (callback.call(thisArg, this.items[i], i) === false) {
                return this;
            }
        }
        return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/
    setproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Snap._.Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
            var each = true;
        }
        var begin,
            handler = function () {
                if (begin) {
                    this.b = begin;
                } else {
                    begin = this.b;
                }
            },
            cb = 0,
            set = this,
            callbacker = callback && function () {
                if (++cb == set.length) {
                    callback.call(this);
                }
            };
        return this.forEach(function (el, i) {
            eve.once("snap.animcreated." + el.id, handler);
            if (each) {
                args[i] && el.animate.apply(el, args[i]);
            } else {
                el.animate(attrs, ms, easing, callbacker);
            }
        });
    };
    setproto.remove = function () {
        while (this.length) {
            this.pop().remove();
        }
        return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/
    setproto.bind = function (attr, a, b) {
        var data = {};
        if (typeof a == "function") {
            this.bindings[attr] = a;
        } else {
            var aname = b || attr;
            this.bindings[attr] = function (v) {
                data[aname] = v;
                a.attr(data);
            };
        }
        return this;
    };
    setproto.attr = function (value) {
        var unbound = {};
        for (var k in value) {
            if (this.bindings[k]) {
                this.bindings[k](value[k]);
            } else {
                unbound[k] = value[k];
            }
        }
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            this.items[i].attr(unbound);
        }
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/
    setproto.clear = function () {
        while (this.length) {
            this.pop();
        }
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/
    setproto.splice = function (index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [],
            todel = [],
            args = [],
            i;
        for (i = 2; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        for (i = 0; i < count; i++) {
            todel.push(this[index + i]);
        }
        for (; i < this.length - index; i++) {
            tail.push(this[index + i]);
        }
        var arglen = args.length;
        for (i = 0; i < arglen + tail.length; i++) {
            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        }
        i = this.items.length = this.length -= count - arglen;
        while (this[i]) {
            delete this[i++];
        }
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/
    setproto.exclude = function (el) {
        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
        return false;
    };
    setproto.insertAfter = function (el) {
        var i = this.items.length;
        while (i--) {
            this.items[i].insertAfter(el);
        }
        return this;
    };
    setproto.getBBox = function () {
        var x = [],
            y = [],
            x2 = [],
            y2 = [];
        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin.apply(0, x);
        y = mmin.apply(0, y);
        x2 = mmax.apply(0, x2);
        y2 = mmax.apply(0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y,
            cx: x + (x2 - x) / 2,
            cy: y + (y2 - y) / 2
        };
    };
    setproto.clone = function (s) {
        s = new Set;
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            s.push(this.items[i].clone());
        }
        return s;
    };
    setproto.toString = function () {
        return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    Snap.Set = Set;
    Snap.set = function () {
        var set = new Set;
        if (arguments.length) {
            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        }
        return set;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var names = {},
        reUnit = /[a-z]+$/i,
        Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
        var l = item[0];
        switch (l.toLowerCase()) {
            case "t": return [l, 0, 0];
            case "m": return [l, 1, 0, 0, 1, 0, 0];
            case "r": if (item.length == 4) {
                return [l, 0, item[2], item[3]];
            } else {
                return [l, 0];
            }
            case "s": if (item.length == 5) {
                return [l, 1, 1, item[3], item[4]];
            } else if (item.length == 3) {
                return [l, 1, 1];
            } else {
                return [l, 1];
            }
        }
    }
    function equaliseTransform(t1, t2, getBBox) {
        t2 = Str(t2).replace(/\.{3}|\u2026/g, t1);
        t1 = Snap.parseTransformString(t1) || [];
        t2 = Snap.parseTransformString(t2) || [];
        var maxlength = Math.max(t1.length, t2.length),
            from = [],
            to = [],
            i = 0, j, jj,
            tt1, tt2;
        for (; i < maxlength; i++) {
            tt1 = t1[i] || getEmpty(t2[i]);
            tt2 = t2[i] || getEmpty(tt1);
            if ((tt1[0] != tt2[0]) ||
                (tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3])) ||
                (tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4]))
                ) {
                    t1 = Snap._.transform2matrix(t1, getBBox());
                    t2 = Snap._.transform2matrix(t2, getBBox());
                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
                    break;
            }
            from[i] = [];
            to[i] = [];
            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
                j in tt1 && (from[i][j] = tt1[j]);
                j in tt2 && (to[i][j] = tt2[j]);
            }
        }
        return {
            from: path2array(from),
            to: path2array(to),
            f: getPath(from)
        };
    }
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    function getViewBox(val) {
        return val.join(" ");
    }
    function getColour(clr) {
        return Snap.rgb(clr[0], clr[1], clr[2]);
    }
    function getPath(path) {
        var k = 0, i, ii, j, jj, out, a, b = [];
        for (i = 0, ii = path.length; i < ii; i++) {
            out = "[";
            a = ['"' + path[i][0] + '"'];
            for (j = 1, jj = path[i].length; j < jj; j++) {
                a[j] = "val[" + (k++) + "]";
            }
            out += a + "]";
            b[i] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
        var out = [];
        for (var i = 0, ii = path.length; i < ii; i++) {
            for (var j = 1, jj = path[i].length; j < jj; j++) {
                out.push(path[i][j]);
            }
        }
        return out;
    }
    function isNumeric(obj) {
        return isFinite(parseFloat(obj));
    }
    function arrayEqual(arr1, arr2) {
        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
            return false;
        }
        return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function (name, b) {
        return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this;
        if (isNumeric(a) && isNumeric(b)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getNumber
            };
        }
        if (names[name] == "colour") {
            A = Snap.color(a);
            B = Snap.color(b);
            return {
                from: [A.r, A.g, A.b, A.opacity],
                to: [B.r, B.g, B.b, B.opacity],
                f: getColour
            };
        }
        if (name == "viewBox") {
            A = this.attr(name).vb.split(" ").map(Number);
            B = b.split(" ").map(Number);
            return {
                from: A,
                to: B,
                f: getViewBox
            };
        }
        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
            if (b instanceof Snap.Matrix) {
                b = b.toTransformString();
            }
            if (!Snap._.rgTransform.test(b)) {
                b = Snap._.svgTransform2string(b);
            }
            return equaliseTransform(a, b, function () {
                return el.getBBox(1);
            });
        }
        if (name == "d" || name == "path") {
            A = Snap.path.toCubic(a, b);
            return {
                from: path2array(A[0]),
                to: path2array(A[1]),
                f: getPath(A[0])
            };
        }
        if (name == "points") {
            A = Str(a).split(Snap._.separator);
            B = Str(b).split(Snap._.separator);
            return {
                from: A,
                to: B,
                f: function (val) { return val; }
            };
        }
        var aUnit = a.match(reUnit),
            bUnit = Str(b).match(reUnit);
        if (aUnit && arrayEqual(aUnit, bUnit)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getUnit(aUnit)
            };
        } else {
            return {
                from: this.asPX(name),
                to: this.asPX(name, b),
                f: getNumber
            };
        }
    });
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
    has = "hasOwnProperty",
    supportsTouch = "createTouch" in glob.doc,
    events = [
        "click", "dblclick", "mousedown", "mousemove", "mouseout",
        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
        "touchcancel"
    ],
    touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
    },
    getScroll = function (xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft",
            doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
    },
    preventDefault = function () {
        this.returnValue = false;
    },
    preventTouch = function () {
        return this.originalEvent.preventDefault();
    },
    stopPropagation = function () {
        this.cancelBubble = true;
    },
    stopTouch = function () {
        return this.originalEvent.stopPropagation();
    },
    addEvent = function (obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
            f = function (e) {
                var scrollY = getScroll("y", element),
                    scrollX = getScroll("x", element);
                if (supportsTouch && touchMap[has](type)) {
                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                            var olde = e;
                            e = e.targetTouches[i];
                            e.originalEvent = olde;
                            e.preventDefault = preventTouch;
                            e.stopPropagation = stopTouch;
                            break;
                        }
                    }
                }
                var x = e.clientX + scrollX,
                    y = e.clientY + scrollY;
                return fn.call(element, e, x, y);
            };

        if (type !== realName) {
            obj.addEventListener(type, f, false);
        }

        obj.addEventListener(realName, f, false);

        return function () {
            if (type !== realName) {
                obj.removeEventListener(type, f, false);
            }

            obj.removeEventListener(realName, f, false);
            return true;
        };
    },
    drag = [],
    dragMove = function (e) {
        var x = e.clientX,
            y = e.clientY,
            scrollY = getScroll("y"),
            scrollX = getScroll("x"),
            dragi,
            j = drag.length;
        while (j--) {
            dragi = drag[j];
            if (supportsTouch) {
                var i = e.touches && e.touches.length,
                    touch;
                while (i--) {
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else {
                e.preventDefault();
            }
            var node = dragi.el.node,
                o,
                next = node.nextSibling,
                parent = node.parentNode,
                display = node.style.display;
            // glob.win.opera && parent.removeChild(node);
            // node.style.display = "none";
            // o = dragi.el.paper.getElementByPoint(x, y);
            // node.style.display = display;
            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    },
    dragUp = function (e) {
        Snap.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length,
            dragi;
        while (i--) {
            dragi = drag[i];
            dragi.el._drag = {};
            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
            eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
    };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    for (var i = events.length; i--;) {
        (function (eventName) {
            Snap[eventName] = elproto[eventName] = function (fn, scope) {
                if (Snap.is(fn, "function")) {
                    this.events = this.events || [];
                    this.events.push({
                        name: eventName,
                        f: fn,
                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
                    });
                } else {
                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
                        try {
                            this.events[i].f.call(this);
                        } catch (e) {}
                    }
                }
                return this;
            };
            Snap["un" + eventName] =
            elproto["un" + eventName] = function (fn) {
                var events = this.events || [],
                    l = events.length;
                while (l--) if (events[l].name == eventName &&
                               (events[l].f == fn || !fn)) {
                    events[l].unbind();
                    events.splice(l, 1);
                    !events.length && delete this.events;
                    return this;
                }
                return this;
            };
        })(events[i]);
    }
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/
    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/
    elproto.unhover = function (f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/
    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
            var origTransform;
            return el.drag(function (dx, dy) {
                this.attr({
                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
                });
            }, function () {
                origTransform = this.transform().local;
            });
        }
        function start(e, x, y) {
            (e.originalEvent || e).preventDefault();
            el._drag.x = x;
            el._drag.y = y;
            el._drag.id = e.identifier;
            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
            onstart && eve.on("snap.drag.start." + el.id, onstart);
            onmove && eve.on("snap.drag.move." + el.id, onmove);
            onend && eve.on("snap.drag.end." + el.id, onend);
            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
        }
        function init(e, x, y) {
            eve("snap.draginit." + el.id, el, e, x, y);
        }
        eve.on("snap.draginit." + el.id, start);
        el._drag = {};
        draggable.push({el: el, start: start, init: init});
        el.mousedown(init);
        return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/
    // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/
    elproto.undrag = function () {
        var i = draggable.length;
        while (i--) if (draggable[i].el == this) {
            this.unmousedown(draggable[i].init);
            draggable.splice(i, 1);
            eve.unbind("snap.drag.*." + this.id);
            eve.unbind("snap.draginit." + this.id);
        }
        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        pproto = Paper.prototype,
        rgurl = /^\s*url\((.+)\)/,
        Str = String,
        $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    pproto.filter = function (filstr) {
        var paper = this;
        if (paper.type != "svg") {
            paper = paper.paper;
        }
        var f = Snap.parse(Str(filstr)),
            id = Snap._.id(),
            width = paper.node.offsetWidth,
            height = paper.node.offsetHeight,
            filter = $("filter");
        $(filter, {
            id: id,
            filterUnits: "userSpaceOnUse"
        });
        filter.appendChild(f.node);
        paper.defs.appendChild(filter);
        return new Element(filter);
    };
    
    eve.on("snap.util.getattr.filter", function () {
        eve.stop();
        var p = $(this.node, "filter");
        if (p) {
            var match = Str(p).match(rgurl);
            return match && Snap.select(match[1]);
        }
    });
    eve.on("snap.util.attr.filter", function (value) {
        if (value instanceof Element && value.type == "filter") {
            eve.stop();
            var id = value.node.id;
            if (!id) {
                $(value.node, {id: value.id});
                id = value.id;
            }
            $(this.node, {
                filter: Snap.url(id)
            });
        }
        if (!value || value == "none") {
            eve.stop();
            this.node.removeAttribute("filter");
        }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.blur = function (x, y) {
        if (x == null) {
            x = 2;
        }
        var def = y == null ? x : [x, y];
        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
            def: def
        });
    };
    Snap.filter.blur.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, 3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
        if (typeof blur == "string") {
            color = blur;
            opacity = color;
            blur = 4;
        }
        if (typeof color != "string") {
            opacity = color;
            color = "#000";
        }
        color = color || "#000";
        if (blur == null) {
            blur = 4;
        }
        if (opacity == null) {
            opacity = 1;
        }
        if (dx == null) {
            dx = 0;
            dy = 2;
        }
        if (dy == null) {
            dy = dx;
        }
        color = Snap.color(color);
        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
            color: color,
            dx: dx,
            dy: dy,
            blur: blur,
            opacity: opacity
        });
    };
    Snap.filter.shadow.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.grayscale = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
            a: 0.2126 + 0.7874 * (1 - amount),
            b: 0.7152 - 0.7152 * (1 - amount),
            c: 0.0722 - 0.0722 * (1 - amount),
            d: 0.2126 - 0.2126 * (1 - amount),
            e: 0.7152 + 0.2848 * (1 - amount),
            f: 0.0722 - 0.0722 * (1 - amount),
            g: 0.2126 - 0.2126 * (1 - amount),
            h: 0.0722 + 0.9278 * (1 - amount)
        });
    };
    Snap.filter.grayscale.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.sepia = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
            a: 0.393 + 0.607 * (1 - amount),
            b: 0.769 - 0.769 * (1 - amount),
            c: 0.189 - 0.189 * (1 - amount),
            d: 0.349 - 0.349 * (1 - amount),
            e: 0.686 + 0.314 * (1 - amount),
            f: 0.168 - 0.168 * (1 - amount),
            g: 0.272 - 0.272 * (1 - amount),
            h: 0.534 - 0.534 * (1 - amount),
            i: 0.131 + 0.869 * (1 - amount)
        });
    };
    Snap.filter.sepia.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.saturate = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
            amount: 1 - amount
        });
    };
    Snap.filter.saturate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/
    Snap.filter.hueRotate = function (angle) {
        angle = angle || 0;
        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
            angle: angle
        });
    };
    Snap.filter.hueRotate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.invert = function (amount) {
        if (amount == null) {
            amount = 1;
        }
//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: 1 - amount
        });
    };
    Snap.filter.invert.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.brightness = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
            amount: amount
        });
    };
    Snap.filter.brightness.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.contrast = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: .5 - amount / 2
        });
    };
    Snap.filter.contrast.toString = function () {
        return this();
    };
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box,
        is = Snap.is,
        firstLetter = /^[^a-z]*([tbmlrc])/i,
        toString = function () {
            return "T" + this.dx + "," + this.dy;
        };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/
    Element.prototype.getAlign = function (el, way) {
        if (way == null && is(el, "string")) {
            way = el;
            el = null;
        }
        el = el || this.paper;
        var bx = el.getBBox ? el.getBBox() : box(el),
            bb = this.getBBox(),
            out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch (way) {
            case "t":
                out.dx = 0;
                out.dy = bx.y - bb.y;
            break;
            case "b":
                out.dx = 0;
                out.dy = bx.y2 - bb.y2;
            break;
            case "m":
                out.dx = 0;
                out.dy = bx.cy - bb.cy;
            break;
            case "l":
                out.dx = bx.x - bb.x;
                out.dy = 0;
            break;
            case "r":
                out.dx = bx.x2 - bb.x2;
                out.dy = 0;
            break;
            default:
                out.dx = bx.cx - bb.cx;
                out.dy = 0;
            break;
        }
        out.toString = toString;
        return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/
    Element.prototype.align = function (el, way) {
        return this.transform("..." + this.getAlign(el, way));
    };
});

return Snap;
}));
},{"eve":628}],1174:[function(require,module,exports){

/**
 * Module dependencies.
 */

var url = require('./url');
var parser = require('socket.io-parser');
var Manager = require('./manager');
var debug = require('debug')('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  } else if (opts && 'object' === typeof opts.query) {
    opts.query = encodeQueryString(opts.query);
  }
  return io.socket(parsed.path, opts);
}
/**
 *  Helper method to parse query objects to string.
 * @param {object} query
 * @returns {string}
 */
function encodeQueryString (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
}
/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = require('./manager');
exports.Socket = require('./socket');

},{"./manager":1175,"./socket":1177,"./url":1178,"debug":1180,"socket.io-parser":1184}],1175:[function(require,module,exports){

/**
 * Module dependencies.
 */

var eio = require('engine.io-client');
var Socket = require('./socket');
var Emitter = require('component-emitter');
var parser = require('socket.io-parser');
var on = require('./on');
var bind = require('component-bind');
var debug = require('debug')('socket.io-client:manager');
var indexOf = require('indexof');
var Backoff = require('backo2');

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  this.encoder = new parser.Encoder();
  this.decoder = new parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.engine.id;
    }
  }
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.engine.id;
    });

    if (this.autoConnect) {
      // manually call here since connecting evnet is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};

},{"./on":1176,"./socket":1177,"backo2":385,"component-bind":419,"component-emitter":1179,"debug":1180,"engine.io-client":612,"indexof":667,"socket.io-parser":1184}],1176:[function(require,module,exports){

/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}

},{}],1177:[function(require,module,exports){

/**
 * Module dependencies.
 */

var parser = require('socket.io-parser');
var Emitter = require('component-emitter');
var toArray = require('to-array');
var on = require('./on');
var bind = require('component-bind');
var debug = require('debug')('socket.io-client:socket');
var hasBin = require('has-binary');

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var parserType = parser.EVENT; // default
  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
  var packet = { type: parserType, data: args };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  delete this.flags;

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      this.packet({type: parser.CONNECT, query: this.query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  if (packet.nsp !== this.nsp) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
    self.packet({
      type: type,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags = this.flags || {};
  this.flags.compress = compress;
  return this;
};

},{"./on":1176,"component-bind":419,"component-emitter":1179,"debug":1180,"has-binary":641,"socket.io-parser":1184,"to-array":1205}],1178:[function(require,module,exports){
(function (global){(function (){

/**
 * Module dependencies.
 */

var parseuri = require('parseuri');
var debug = require('debug')('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || global.location;
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"debug":1180,"parseuri":890}],1179:[function(require,module,exports){
arguments[4][622][0].apply(exports,arguments)
},{"dup":622}],1180:[function(require,module,exports){
arguments[4][623][0].apply(exports,arguments)
},{"./debug":1181,"_process":405,"dup":623}],1181:[function(require,module,exports){
arguments[4][624][0].apply(exports,arguments)
},{"dup":624,"ms":1182}],1182:[function(require,module,exports){
arguments[4][625][0].apply(exports,arguments)
},{"dup":625}],1183:[function(require,module,exports){
(function (global){(function (){
/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = require('isarray');
var isBuf = require('./is-buffer');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet){
  var buffers = [];
  var packetData = packet.data;

  function _deconstructPacket(data) {
    if (!data) return data;

    if (isBuf(data)) {
      var placeholder = { _placeholder: true, num: buffers.length };
      buffers.push(data);
      return placeholder;
    } else if (isArray(data)) {
      var newData = new Array(data.length);
      for (var i = 0; i < data.length; i++) {
        newData[i] = _deconstructPacket(data[i]);
      }
      return newData;
    } else if ('object' == typeof data && !(data instanceof Date)) {
      var newData = {};
      for (var key in data) {
        newData[key] = _deconstructPacket(data[key]);
      }
      return newData;
    }
    return data;
  }

  var pack = packet;
  pack.data = _deconstructPacket(packetData);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  var curPlaceHolder = 0;

  function _reconstructPacket(data) {
    if (data && data._placeholder) {
      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
      return buf;
    } else if (isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        data[i] = _reconstructPacket(data[i]);
      }
      return data;
    } else if (data && 'object' == typeof data) {
      for (var key in data) {
        data[key] = _reconstructPacket(data[key]);
      }
      return data;
    }
    return data;
  }

  packet.data = _reconstructPacket(packet.data);
  packet.attachments = undefined; // no longer useful
  return packet;
};

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((global.Blob && obj instanceof Blob) ||
        (global.File && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./is-buffer":1185,"isarray":1189}],1184:[function(require,module,exports){

/**
 * Module dependencies.
 */

var debug = require('debug')('socket.io-parser');
var json = require('json3');
var Emitter = require('component-emitter');
var binary = require('./binary');
var isBuf = require('./is-buffer');

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    encodeAsBinary(obj, callback);
  }
  else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {
  var str = '';
  var nsp = false;

  // first is type
  str += obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    str += obj.attachments;
    str += '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' != obj.nsp) {
    nsp = true;
    str += obj.nsp;
  }

  // immediately followed by the id
  if (null != obj.id) {
    if (nsp) {
      str += ',';
      nsp = false;
    }
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    if (nsp) str += ',';
    str += json.stringify(obj.data);
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an ecoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if ('string' == typeof obj) {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  }
  else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  }
  else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var p = {};
  var i = 0;

  // look up type
  p.type = Number(str.charAt(0));
  if (null == exports.types[p.type]) return error();

  // look up attachments if type binary
  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
    var buf = '';
    while (str.charAt(++i) != '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) != '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' == str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' == c) break;
      p.nsp += c;
      if (i == str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i == str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    p = tryParse(p, str.substr(i));
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(p, str) {
  try {
    p.data = json.parse(str);
  } catch(e){
    return error();
  }
  return p; 
};

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(data){
  return {
    type: exports.ERROR,
    data: 'parser error'
  };
}

},{"./binary":1183,"./is-buffer":1185,"component-emitter":1186,"debug":1187,"json3":676}],1185:[function(require,module,exports){
(function (global){(function (){

module.exports = isBuf;

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer);
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1186:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],1187:[function(require,module,exports){

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = require('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  return ('WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

},{"./debug":1188}],1188:[function(require,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require('ms');

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = Array.prototype.slice.call(arguments);

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    if ('function' === typeof exports.formatArgs) {
      args = exports.formatArgs.apply(self, args);
    }
    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":1190}],1189:[function(require,module,exports){
arguments[4][642][0].apply(exports,arguments)
},{"dup":642}],1190:[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  options = options || {};
  if ('string' == typeof val) return parse(val);
  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = '' + str;
  if (str.length > 10000) return;
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  return plural(ms, d, 'day')
    || plural(ms, h, 'hour')
    || plural(ms, m, 'minute')
    || plural(ms, s, 'second')
    || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) return;
  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
  return Math.ceil(ms / n) + ' ' + name + 's';
}

},{}],1191:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/readable.js');
Stream.Writable = require('readable-stream/writable.js');
Stream.Duplex = require('readable-stream/duplex.js');
Stream.Transform = require('readable-stream/transform.js');
Stream.PassThrough = require('readable-stream/passthrough.js');

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":629,"inherits":668,"readable-stream/duplex.js":1116,"readable-stream/passthrough.js":1125,"readable-stream/readable.js":1126,"readable-stream/transform.js":1127,"readable-stream/writable.js":1128}],1192:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":1155}],1193:[function(require,module,exports){
/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = require('emitter');
var requestBase = require('./request-base');
var isObject = require('./is-object');

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = module.exports = require('./request').bind(null, Request);

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */),
        key = parts.shift(),
        val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this._setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this._parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype._setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype._setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
      // issue #876: return the http status code if the response parsing fails
      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (res.status < 200 || res.status >= 300) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `requestBase`.
 */

Emitter(Request.prototype);
for (var key in requestBase) {
  Request.prototype[key] = requestBase[key];
}

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (!options) {
    options = {
      type: 'basic'
    }
  }

  switch (options.type) {
    case 'basic':
      var str = btoa(user + ':' + pass);
      this.set('Authorization', 'Basic ' + str);
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
  }
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  this._getFormData().append(field, file, filename || file.name);
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype._timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self._timeoutError();
      if (self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  this._appendQueryString();

  // initiate request
  if (this.username && this.password) {
    xhr.open(this.method, this.url, true, this.username, this.password);
  } else {
    xhr.open(this.method, this.url, true);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};


/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./is-object":1194,"./request":1196,"./request-base":1195,"emitter":420}],1194:[function(require,module,exports){
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;

},{}],1195:[function(require,module,exports){
/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = require('./is-object');

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

exports.clearTimeout = function _clearTimeout(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

exports.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

exports.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

exports.timeout = function timeout(ms){
  this._timeout = ms;
  return this;
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @return {Request}
 */

exports.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

exports.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

exports.use = function use(fn) {
  fn(this);
  return this;
}


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

exports.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

exports.getHeader = exports.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

exports.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
exports.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
exports.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
exports.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

exports.withCredentials = function(){
  // This is browser-only functionality. Node side is no-op.
  this._withCredentials = true;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

exports.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

exports.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

exports._isHost = function _isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

exports.send = function(data){
  var obj = isObject(data);
  var type = this._header['content-type'];

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || this._isHost(data)) return this;

  // default to json
  if (!type) this.type('json');
  return this;
};

},{"./is-object":1194}],1196:[function(require,module,exports){
// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(RequestConstructor, method, url) {
  // callback
  if ('function' == typeof url) {
    return new RequestConstructor('GET', method).end(url);
  }

  // url first
  if (2 == arguments.length) {
    return new RequestConstructor('GET', method);
  }

  return new RequestConstructor(method, url);
}

module.exports = request;

},{}],1197:[function(require,module,exports){
!function(root, factory) {
    "function" == typeof define && define.amd ? // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function() {
        return root.loadsvgexternal = factory();
    }) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    function loadreadystatechange1(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    item.onloadcallback(target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function loadsvgexternal(src, onloadcallback) {
        var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#"), xhr = requests[url];
        xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
        xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
        xhr._embeds.push({
            id: id,
            onloadcallback: function(target) {
                onloadcallback(target);
            }
        }), // prepare the xhr ready state change event
        loadreadystatechange1(xhr);
    }
    var requests = {};
    return loadsvgexternal;
});
},{}],1198:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.svgson = factory());
}(this, (function () { 'use strict';

  /*!
   * isobject <https://github.com/jonschlinkert/isobject>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */

  var isobject$1 = function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
  };

  function isObjectObject(o) {
    return isobject$1(o) === true
      && Object.prototype.toString.call(o) === '[object Object]';
  }

  var isPlainObject = function isPlainObject(o) {
    var ctor,prot;

    if (isObjectObject(o) === false) return false;

    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== 'function') return false;

    // If has modified prototype
    prot = ctor.prototype;
    if (isObjectObject(prot) === false) return false;

    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) {
      return false;
    }

    // Most likely a plain Object
    return true;
  };

  var toString$2 = {}.toString;

  var isarray = Array.isArray || function (arr) {
    return toString$2.call(arr) == '[object Array]';
  };

  var isobject = function isObject(val) {
    return val != null && typeof val === 'object' && isarray(val) === false;
  };

  /*!
   * has-values <https://github.com/jonschlinkert/has-values>
   *
   * Copyright (c) 2014-2015, Jon Schlinkert.
   * Licensed under the MIT License.
   */

  var hasValues = function hasValue(o, noZero) {
    if (o === null || o === undefined) {
      return false;
    }

    if (typeof o === 'boolean') {
      return true;
    }

    if (typeof o === 'number') {
      if (o === 0 && noZero === true) {
        return false;
      }
      return true;
    }

    if (o.length !== undefined) {
      return o.length !== 0;
    }

    for (var key in o) {
      if (o.hasOwnProperty(key)) {
        return true;
      }
    }
    return false;
  };

  /*!
   * get-value <https://github.com/jonschlinkert/get-value>
   *
   * Copyright (c) 2014-2015, Jon Schlinkert.
   * Licensed under the MIT License.
   */

  var getValue = function(obj, prop, a, b, c) {
    if (!isObject(obj) || !prop) {
      return obj;
    }

    prop = toString$1(prop);

    // allowing for multiple properties to be passed as
    // a string or array, but much faster (3-4x) than doing
    // `[].slice.call(arguments)`
    if (a) prop += '.' + toString$1(a);
    if (b) prop += '.' + toString$1(b);
    if (c) prop += '.' + toString$1(c);

    if (prop in obj) {
      return obj[prop];
    }

    var segs = prop.split('.');
    var len = segs.length;
    var i = -1;

    while (obj && (++i < len)) {
      var key = segs[i];
      while (key[key.length - 1] === '\\') {
        key = key.slice(0, -1) + '.' + segs[++i];
      }
      obj = obj[key];
    }
    return obj;
  };

  function isObject(val) {
    return val !== null && (typeof val === 'object' || typeof val === 'function');
  }

  function toString$1(val) {
    if (!val) return '';
    if (Array.isArray(val)) {
      return val.join('.');
    }
    return val;
  }

  var hasValue = function(obj, prop, noZero) {
    if (isobject(obj)) {
      return hasValues(getValue(obj, prop), noZero);
    }
    return hasValues(obj, prop);
  };

  var unsetValue = function unset(obj, prop) {
    if (!isobject$1(obj)) {
      throw new TypeError('expected an object.');
    }
    if (obj.hasOwnProperty(prop)) {
      delete obj[prop];
      return true;
    }

    if (hasValue(obj, prop)) {
      var segs = prop.split('.');
      var last = segs.pop();
      while (segs.length && segs[segs.length - 1].slice(-1) === '\\') {
        last = segs.pop().slice(0, -1) + '.' + last;
      }
      while (segs.length) obj = obj[prop = segs.shift()];
      return (delete obj[last]);
    }
    return true;
  };

  var omitDeep = function omitDeep(value, keys) {
    if (typeof value === 'undefined') {
      return {};
    }

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        value[i] = omitDeep(value[i], keys);
      }
      return value;
    }

    if (!isPlainObject(value)) {
      return value;
    }

    if (typeof keys === 'string') {
      keys = [keys];
    }

    if (!Array.isArray(keys)) {
      return value;
    }

    for (var j = 0; j < keys.length; j++) {
      unsetValue(value, keys[j]);
    }

    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        value[key] = omitDeep(value[key], keys);
      }
    }

    return value;
  };

  /*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */

  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  var isBuffer_1 = function (obj) {
    return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
  };

  function isBuffer (obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
  }

  // For Node v0.10 support. Remove this eventually.
  function isSlowBuffer (obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
  }

  var toString = Object.prototype.toString;

  /**
   * Get the native `typeof` a value.
   *
   * @param  {*} `val`
   * @return {*} Native javascript type
   */

  var kindOf = function kindOf(val) {
    // primitivies
    if (typeof val === 'undefined') {
      return 'undefined';
    }
    if (val === null) {
      return 'null';
    }
    if (val === true || val === false || val instanceof Boolean) {
      return 'boolean';
    }
    if (typeof val === 'string' || val instanceof String) {
      return 'string';
    }
    if (typeof val === 'number' || val instanceof Number) {
      return 'number';
    }

    // functions
    if (typeof val === 'function' || val instanceof Function) {
      return 'function';
    }

    // array
    if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
      return 'array';
    }

    // check for instances of RegExp and Date before calling `toString`
    if (val instanceof RegExp) {
      return 'regexp';
    }
    if (val instanceof Date) {
      return 'date';
    }

    // other objects
    var type = toString.call(val);

    if (type === '[object RegExp]') {
      return 'regexp';
    }
    if (type === '[object Date]') {
      return 'date';
    }
    if (type === '[object Arguments]') {
      return 'arguments';
    }
    if (type === '[object Error]') {
      return 'error';
    }

    // buffer
    if (isBuffer_1(val)) {
      return 'buffer';
    }

    // es6: Map, WeakMap, Set, WeakSet
    if (type === '[object Set]') {
      return 'set';
    }
    if (type === '[object WeakSet]') {
      return 'weakset';
    }
    if (type === '[object Map]') {
      return 'map';
    }
    if (type === '[object WeakMap]') {
      return 'weakmap';
    }
    if (type === '[object Symbol]') {
      return 'symbol';
    }

    // typed arrays
    if (type === '[object Int8Array]') {
      return 'int8array';
    }
    if (type === '[object Uint8Array]') {
      return 'uint8array';
    }
    if (type === '[object Uint8ClampedArray]') {
      return 'uint8clampedarray';
    }
    if (type === '[object Int16Array]') {
      return 'int16array';
    }
    if (type === '[object Uint16Array]') {
      return 'uint16array';
    }
    if (type === '[object Int32Array]') {
      return 'int32array';
    }
    if (type === '[object Uint32Array]') {
      return 'uint32array';
    }
    if (type === '[object Float32Array]') {
      return 'float32array';
    }
    if (type === '[object Float64Array]') {
      return 'float64array';
    }

    // must be a plain object
    return 'object';
  };

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var renameKeys = createCommonjsModule(function (module) {
  (function() {

    function rename(obj, fn) {
      if (typeof fn !== 'function') {
        return obj;
      }

      var res = {};
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          res[fn(key, obj[key]) || key] = obj[key];
        }
      }
      return res;
    }

    if (module.exports) {
      module.exports = rename;
    } else {
      {
        window.rename = rename;
      }
    }
  })();
  });

  /**
   * Expose `renameDeep`
   */

  var deepRenameKeys = function renameDeep(obj, cb) {
    var type = kindOf(obj);

    if (type !== 'object' && type !== 'array') {
      throw new Error('expected an object');
    }

    var res = [];
    if (type === 'object') {
      obj = renameKeys(obj, cb);
      res = {};
    }

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        var val = obj[key];
        if (kindOf(val) === 'object' || kindOf(val) === 'array') {
          res[key] = renameDeep(val, cb);
        } else {
          res[key] = val;
        }
      }
    }
    return res;
  };

  var eventemitter3 = createCommonjsModule(function (module) {

  var has = Object.prototype.hasOwnProperty
    , prefix = '~';

  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @api private
   */
  function Events() {}

  //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //
  if (Object.create) {
    Events.prototype = Object.create(null);

    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
  }

  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {Mixed} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @api private
   */
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }

  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @api public
   */
  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }

  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @api public
   */
  EventEmitter.prototype.eventNames = function eventNames() {
    var names = []
      , events
      , name;

    if (this._eventsCount === 0) return names;

    for (name in (events = this._events)) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }

    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }

    return names;
  };

  /**
   * Return the listeners registered for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Boolean} exists Only check if there are listeners.
   * @returns {Array|Boolean}
   * @api public
   */
  EventEmitter.prototype.listeners = function listeners(event, exists) {
    var evt = prefix ? prefix + event : event
      , available = this._events[evt];

    if (exists) return !!available;
    if (!available) return [];
    if (available.fn) return [available.fn];

    for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
      ee[i] = available[i].fn;
    }

    return ee;
  };

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @api public
   */
  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;

    if (!this._events[evt]) return false;

    var listeners = this._events[evt]
      , len = arguments.length
      , args
      , i;

    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

      switch (len) {
        case 1: return listeners.fn.call(listeners.context), true;
        case 2: return listeners.fn.call(listeners.context, a1), true;
        case 3: return listeners.fn.call(listeners.context, a1, a2), true;
        case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }

      for (i = 1, args = new Array(len -1); i < len; i++) {
        args[i - 1] = arguments[i];
      }

      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length
        , j;

      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

        switch (len) {
          case 1: listeners[i].fn.call(listeners[i].context); break;
          case 2: listeners[i].fn.call(listeners[i].context, a1); break;
          case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
          case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
          default:
            if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
              args[j - 1] = arguments[j];
            }

            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }

    return true;
  };

  /**
   * Add a listener for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn The listener function.
   * @param {Mixed} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.on = function on(event, fn, context) {
    var listener = new EE(fn, context || this)
      , evt = prefix ? prefix + event : event;

    if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
    else if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [this._events[evt], listener];

    return this;
  };

  /**
   * Add a one-time listener for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn The listener function.
   * @param {Mixed} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.once = function once(event, fn, context) {
    var listener = new EE(fn, context || this, true)
      , evt = prefix ? prefix + event : event;

    if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
    else if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [this._events[evt], listener];

    return this;
  };

  /**
   * Remove the listeners of a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {Mixed} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;

    if (!this._events[evt]) return this;
    if (!fn) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
      return this;
    }

    var listeners = this._events[evt];

    if (listeners.fn) {
      if (
           listeners.fn === fn
        && (!once || listeners.once)
        && (!context || listeners.context === context)
      ) {
        if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }

      //
      // Reset the array, or remove it completely if we have no more listeners.
      //
      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
      else if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }

    return this;
  };

  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {String|Symbol} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;

    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) {
        if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
      }
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }

    return this;
  };

  //
  // Alias methods names because people roll like that.
  //
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  //
  // This function doesn't apply anymore.
  //
  EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
    return this;
  };

  //
  // Expose the prefix.
  //
  EventEmitter.prefixed = prefix;

  //
  // Allow `EventEmitter` to be imported as module namespace.
  //
  EventEmitter.EventEmitter = EventEmitter;

  //
  // Expose the module.
  //
  {
    module.exports = EventEmitter;
  }
  });

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


  var noop = function noop() {};

  var State = {
      data: 'state-data',
      cdata: 'state-cdata',
      tagBegin: 'state-tag-begin',
      tagName: 'state-tag-name',
      tagEnd: 'state-tag-end',
      attributeNameStart: 'state-attribute-name-start',
      attributeName: 'state-attribute-name',
      attributeNameEnd: 'state-attribute-name-end',
      attributeValueBegin: 'state-attribute-value-begin',
      attributeValue: 'state-attribute-value'
  };

  var Action = {
      lt: 'action-lt',
      gt: 'action-gt',
      space: 'action-space',
      equal: 'action-equal',
      quote: 'action-quote',
      slash: 'action-slash',
      char: 'action-char',
      error: 'action-error'
  };

  var Type$1 = {
      text: 'text',
      openTag: 'open-tag',
      closeTag: 'close-tag',
      attributeName: 'attribute-name',
      attributeValue: 'attribute-value'
  };

  var charToAction = {
      ' ': Action.space,
      '\t': Action.space,
      '\n': Action.space,
      '\r': Action.space,
      '<': Action.lt,
      '>': Action.gt,
      '"': Action.quote,
      "'": Action.quote,
      '=': Action.equal,
      '/': Action.slash
  };

  var getAction = function getAction(char) {
      return charToAction[char] || Action.char;
  };

  /**
   * @param  {Object} options
   * @param  {Boolean} options.debug
   * @return {Object}
   */
  var create$1 = function create(options) {
      var _State$data, _State$tagBegin, _State$tagName, _State$tagEnd, _State$attributeNameS, _State$attributeName, _State$attributeNameE, _State$attributeValue, _State$attributeValue2, _lexer$stateMachine;

      options = Object.assign({ debug: false }, options);
      var lexer = new eventemitter3();
      var state = State.data;
      var data = '';
      var tagName = '';
      var attrName = '';
      var attrValue = '';
      var isClosing = '';
      var openingQuote = '';

      var emit = function emit(type, value) {
          // for now, ignore tags like: '?xml', '!DOCTYPE' or comments
          if (tagName[0] === '?' || tagName[0] === '!') {
              return;
          }
          var event = { type: type, value: value };
          if (options.debug) {
              console.log('emit:', event);
          }
          lexer.emit('data', event);
      };

      lexer.stateMachine = (_lexer$stateMachine = {}, _defineProperty(_lexer$stateMachine, State.data, (_State$data = {}, _defineProperty(_State$data, Action.lt, function () {
          if (data.trim()) {
              emit(Type$1.text, data);
          }
          tagName = '';
          isClosing = false;
          state = State.tagBegin;
      }), _defineProperty(_State$data, Action.char, function (char) {
          data += char;
      }), _State$data)), _defineProperty(_lexer$stateMachine, State.cdata, _defineProperty({}, Action.char, function (char) {
          data += char;
          if (data.substr(-3) === ']]>') {
              emit(Type$1.text, data.slice(0, -3));
              data = '';
              state = State.data;
          }
      })), _defineProperty(_lexer$stateMachine, State.tagBegin, (_State$tagBegin = {}, _defineProperty(_State$tagBegin, Action.space, noop), _defineProperty(_State$tagBegin, Action.char, function (char) {
          tagName = char;
          state = State.tagName;
      }), _defineProperty(_State$tagBegin, Action.slash, function () {
          tagName = '';
          isClosing = true;
      }), _State$tagBegin)), _defineProperty(_lexer$stateMachine, State.tagName, (_State$tagName = {}, _defineProperty(_State$tagName, Action.space, function () {
          if (isClosing) {
              state = State.tagEnd;
          } else {
              state = State.attributeNameStart;
              emit(Type$1.openTag, tagName);
          }
      }), _defineProperty(_State$tagName, Action.gt, function () {
          if (isClosing) {
              emit(Type$1.closeTag, tagName);
          } else {
              emit(Type$1.openTag, tagName);
          }
          data = '';
          state = State.data;
      }), _defineProperty(_State$tagName, Action.slash, function () {
          state = State.tagEnd;
          emit(Type$1.openTag, tagName);
      }), _defineProperty(_State$tagName, Action.char, function (char) {
          tagName += char;
          if (tagName === '![CDATA[') {
              state = State.cdata;
              data = '';
              tagName = '';
          }
      }), _State$tagName)), _defineProperty(_lexer$stateMachine, State.tagEnd, (_State$tagEnd = {}, _defineProperty(_State$tagEnd, Action.gt, function () {
          emit(Type$1.closeTag, tagName);
          data = '';
          state = State.data;
      }), _defineProperty(_State$tagEnd, Action.char, noop), _State$tagEnd)), _defineProperty(_lexer$stateMachine, State.attributeNameStart, (_State$attributeNameS = {}, _defineProperty(_State$attributeNameS, Action.char, function (char) {
          attrName = char;
          state = State.attributeName;
      }), _defineProperty(_State$attributeNameS, Action.gt, function () {
          data = '';
          state = State.data;
      }), _defineProperty(_State$attributeNameS, Action.space, noop), _defineProperty(_State$attributeNameS, Action.slash, function () {
          isClosing = true;
          state = State.tagEnd;
      }), _State$attributeNameS)), _defineProperty(_lexer$stateMachine, State.attributeName, (_State$attributeName = {}, _defineProperty(_State$attributeName, Action.space, function () {
          state = State.attributeNameEnd;
      }), _defineProperty(_State$attributeName, Action.equal, function () {
          emit(Type$1.attributeName, attrName);
          state = State.attributeValueBegin;
      }), _defineProperty(_State$attributeName, Action.gt, function () {
          attrValue = '';
          emit(Type$1.attributeName, attrName);
          emit(Type$1.attributeValue, attrValue);
          data = '';
          state = State.data;
      }), _defineProperty(_State$attributeName, Action.slash, function () {
          isClosing = true;
          attrValue = '';
          emit(Type$1.attributeName, attrName);
          emit(Type$1.attributeValue, attrValue);
          state = State.tagEnd;
      }), _defineProperty(_State$attributeName, Action.char, function (char) {
          attrName += char;
      }), _State$attributeName)), _defineProperty(_lexer$stateMachine, State.attributeNameEnd, (_State$attributeNameE = {}, _defineProperty(_State$attributeNameE, Action.space, noop), _defineProperty(_State$attributeNameE, Action.equal, function () {
          emit(Type$1.attributeName, attrName);
          state = State.attributeValueBegin;
      }), _defineProperty(_State$attributeNameE, Action.gt, function () {
          attrValue = '';
          emit(Type$1.attributeName, attrName);
          emit(Type$1.attributeValue, attrValue);
          data = '';
          state = State.data;
      }), _defineProperty(_State$attributeNameE, Action.char, function (char) {
          attrValue = '';
          emit(Type$1.attributeName, attrName);
          emit(Type$1.attributeValue, attrValue);
          attrName = char;
          state = State.attributeName;
      }), _State$attributeNameE)), _defineProperty(_lexer$stateMachine, State.attributeValueBegin, (_State$attributeValue = {}, _defineProperty(_State$attributeValue, Action.space, noop), _defineProperty(_State$attributeValue, Action.quote, function (char) {
          openingQuote = char;
          attrValue = '';
          state = State.attributeValue;
      }), _defineProperty(_State$attributeValue, Action.gt, function () {
          attrValue = '';
          emit(Type$1.attributeValue, attrValue);
          data = '';
          state = State.data;
      }), _defineProperty(_State$attributeValue, Action.char, function (char) {
          openingQuote = '';
          attrValue = char;
          state = State.attributeValue;
      }), _State$attributeValue)), _defineProperty(_lexer$stateMachine, State.attributeValue, (_State$attributeValue2 = {}, _defineProperty(_State$attributeValue2, Action.space, function (char) {
          if (openingQuote) {
              attrValue += char;
          } else {
              emit(Type$1.attributeValue, attrValue);
              state = State.attributeNameStart;
          }
      }), _defineProperty(_State$attributeValue2, Action.quote, function (char) {
          if (openingQuote === char) {
              emit(Type$1.attributeValue, attrValue);
              state = State.attributeNameStart;
          } else {
              attrValue += char;
          }
      }), _defineProperty(_State$attributeValue2, Action.gt, function (char) {
          if (openingQuote) {
              attrValue += char;
          } else {
              emit(Type$1.attributeValue, attrValue);
              data = '';
              state = State.data;
          }
      }), _defineProperty(_State$attributeValue2, Action.slash, function (char) {
          if (openingQuote) {
              attrValue += char;
          } else {
              emit(Type$1.attributeValue, attrValue);
              isClosing = true;
              state = State.tagEnd;
          }
      }), _defineProperty(_State$attributeValue2, Action.char, function (char) {
          attrValue += char;
      }), _State$attributeValue2)), _lexer$stateMachine);

      var step = function step(char) {
          if (options.debug) {
              console.log(state, char);
          }
          var actions = lexer.stateMachine[state];
          var action = actions[getAction(char)] || actions[Action.error] || actions[Action.char];
          action(char);
      };

      lexer.write = function (str) {
          var len = str.length;
          for (var i = 0; i < len; i++) {
              step(str[i]);
          }
      };

      return lexer;
  };

  var lexer = {
      State: State,
      Action: Action,
      Type: Type$1,
      create: create$1
  };

  var Type = lexer.Type;

  var NodeType = {
      element: 'element',
      text: 'text'
  };

  var createNode = function createNode(params) {
      return Object.assign({
          name: '',
          type: NodeType.element,
          value: '',
          parent: null,
          attributes: {},
          children: []
      }, params);
  };

  var create = function create(options) {
      options = Object.assign({
          stream: false,
          parentNodes: true,
          doneEvent: 'done',
          tagPrefix: 'tag:',
          emitTopLevelOnly: false,
          debug: false
      }, options);

      var lexer$1 = void 0,
          rootNode = void 0,
          current = void 0,
          attrName = void 0;

      var reader = new eventemitter3();

      var handleLexerData = function handleLexerData(data) {
          switch (data.type) {

              case Type.openTag:
                  if (current === null) {
                      current = rootNode;
                      current.name = data.value;
                  } else {
                      var node = createNode({
                          name: data.value,
                          parent: current
                      });
                      current.children.push(node);
                      current = node;
                  }
                  break;

              case Type.closeTag:
                  var parent = current.parent;
                  if (!options.parentNodes) {
                      current.parent = null;
                  }
                  if (current.name !== data.value) {
                      // ignore unexpected closing tag
                      break;
                  }
                  if (options.stream && parent === rootNode) {
                      rootNode.children = [];
                      // do not expose parent node in top level nodes
                      current.parent = null;
                  }
                  if (!options.emitTopLevelOnly || parent === rootNode) {
                      reader.emit(options.tagPrefix + current.name, current);
                      reader.emit('tag', current.name, current);
                  }
                  if (current === rootNode) {
                      // end of document, stop listening
                      lexer$1.removeAllListeners('data');
                      reader.emit(options.doneEvent, current);
                      rootNode = null;
                  }
                  current = parent;
                  break;

              case Type.text:
                  if (current) {
                      current.children.push(createNode({
                          type: NodeType.text,
                          value: data.value,
                          parent: options.parentNodes ? current : null
                      }));
                  }
                  break;

              case Type.attributeName:
                  attrName = data.value;
                  current.attributes[attrName] = '';
                  break;

              case Type.attributeValue:
                  current.attributes[attrName] = data.value;
                  break;
          }
      };

      reader.reset = function () {
          lexer$1 = lexer.create({ debug: options.debug });
          lexer$1.on('data', handleLexerData);
          rootNode = createNode();
          current = null;
          attrName = '';
          reader.parse = lexer$1.write;
      };

      reader.reset();
      return reader;
  };

  var parseSync = function parseSync(xml, options) {
      options = Object.assign({}, options, { stream: false, tagPrefix: ':' });
      var reader = create(options);
      var res = void 0;
      reader.on('done', function (ast) {
          res = ast;
      });
      reader.parse(xml);
      return res;
  };

  var reader = {
      parseSync: parseSync,
      create: create,
      NodeType: NodeType
  };
  var reader_1 = reader.parseSync;

  var parseInput = function parseInput(input) {
    var parsed = reader_1("<root>".concat(input, "</root>"), {
      parentNodes: false
    });
    var isValid = parsed.children && parsed.children.length > 0 && parsed.children.every(function (node) {
      return node.name === 'svg';
    });

    if (isValid) {
      return parsed.children.length === 1 ? parsed.children[0] : parsed.children;
    } else {
      throw Error('nothing to parse');
    }
  };
  var removeAttrs = function removeAttrs(obj) {
    return omitDeep(obj, ['parent']);
  };
  var camelize = function camelize(node) {
    return deepRenameKeys(node, function (key) {
      if (!notCamelcase(key)) {
        return toCamelCase(key);
      }

      return key;
    });
  };
  var toCamelCase = function toCamelCase(prop) {
    return prop.replace(/[-|:]([a-z])/gi, function (all, letter) {
      return letter.toUpperCase();
    });
  };

  var notCamelcase = function notCamelcase(prop) {
    return /^(data|aria)(-\w+)/.test(prop);
  };

  var escapeText = function escapeText(text) {
    if (text) {
      var str = String(text);
      return /[&<>]/.test(str) ? "<![CDATA[".concat(str.replace(/]]>/, ']]]]><![CDATA[>'), "]]>") : str;
    }

    return '';
  };
  var escapeAttr = function escapeAttr(attr) {
    return String(attr).replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  var svgsonSync = function svgsonSync(input) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$transformNode = _ref.transformNode,
        transformNode = _ref$transformNode === void 0 ? function (node) {
      return node;
    } : _ref$transformNode,
        _ref$camelcase = _ref.camelcase,
        camelcase = _ref$camelcase === void 0 ? false : _ref$camelcase;

    var applyFilters = function applyFilters(input) {
      var n;
      n = removeAttrs(input);
      n = transformNode(n);

      if (camelcase) {
        n = camelize(n);
      }

      return n;
    };

    return applyFilters(parseInput(input));
  };
  function svgson() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {
      try {
        var res = svgsonSync.apply(void 0, args);
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  var stringify = function stringify(_ast) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$transformAttr = _ref.transformAttr,
        transformAttr = _ref$transformAttr === void 0 ? function (key, value, escape) {
      return "".concat(key, "=\"").concat(escape(value), "\"");
    } : _ref$transformAttr,
        _ref$transformNode = _ref.transformNode,
        transformNode = _ref$transformNode === void 0 ? function (node) {
      return node;
    } : _ref$transformNode,
        _ref$selfClose = _ref.selfClose,
        selfClose = _ref$selfClose === void 0 ? true : _ref$selfClose;

    if (Array.isArray(_ast)) {
      return _ast.map(function (ast) {
        return stringify(ast, {
          transformAttr: transformAttr,
          selfClose: selfClose,
          transformNode: transformNode
        });
      }).join('');
    }

    var ast = transformNode(_ast);

    if (ast.type === 'text') {
      return escapeText(ast.value);
    }

    var attributes = '';

    for (var attr in ast.attributes) {
      var attrStr = transformAttr(attr, ast.attributes[attr], escapeAttr, ast.name);
      attributes += attrStr ? " ".concat(attrStr) : '';
    }

    return ast.children && ast.children.length > 0 || !selfClose ? "<".concat(ast.name).concat(attributes, ">").concat(stringify(ast.children, {
      transformAttr: transformAttr,
      transformNode: transformNode,
      selfClose: selfClose
    }), "</").concat(ast.name, ">") : "<".concat(ast.name).concat(attributes, "/>");
  };

  var indexUmd = Object.assign({}, {
    parse: svgson,
    parseSync: svgsonSync,
    stringify: stringify
  });

  return indexUmd;

})));

},{}],1199:[function(require,module,exports){
(function (global){(function (){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = require('./ponyfill.js');

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./ponyfill.js":1200}],1200:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};
},{}],1201:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":1202,"timers":1201}],1202:[function(require,module,exports){
arguments[4][405][0].apply(exports,arguments)
},{"dup":405}],1203:[function(require,module,exports){
var TINF_OK = 0;
var TINF_DATA_ERROR = -3;

function Tree() {
  this.table = new Uint16Array(16);   /* table of code length counts */
  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
}

function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  
  this.dest = dest;
  this.destLen = 0;
  
  this.ltree = new Tree();  /* dynamic length/symbol tree */
  this.dtree = new Tree();  /* dynamic distance tree */
}

/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

var sltree = new Tree();
var sdtree = new Tree();

/* extra bits and base tables for length codes */
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);

/* extra bits and base tables for distance codes */
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);

/* special ordering of code length codes */
var clcidx = new Uint8Array([
  16, 17, 18, 0, 8, 7, 9, 6,
  10, 5, 11, 4, 12, 3, 13, 2,
  14, 1, 15
]);

/* used by tinf_decode_trees, avoids allocations every call */
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);

/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

/* build extra bits and base tables */
function tinf_build_bits_base(bits, base, delta, first) {
  var i, sum;

  /* build bits table */
  for (i = 0; i < delta; ++i) bits[i] = 0;
  for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;

  /* build base table */
  for (sum = first, i = 0; i < 30; ++i) {
    base[i] = sum;
    sum += 1 << bits[i];
  }
}

/* build the fixed huffman trees */
function tinf_build_fixed_trees(lt, dt) {
  var i;

  /* build fixed length tree */
  for (i = 0; i < 7; ++i) lt.table[i] = 0;

  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;

  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;

  /* build fixed distance tree */
  for (i = 0; i < 5; ++i) dt.table[i] = 0;

  dt.table[5] = 32;

  for (i = 0; i < 32; ++i) dt.trans[i] = i;
}

/* given an array of code lengths, build a tree */
var offs = new Uint16Array(16);

function tinf_build_tree(t, lengths, off, num) {
  var i, sum;

  /* clear code length count table */
  for (i = 0; i < 16; ++i) t.table[i] = 0;

  /* scan symbol lengths, and sum code length counts */
  for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;

  t.table[0] = 0;

  /* compute offset table for distribution sort */
  for (sum = 0, i = 0; i < 16; ++i) {
    offs[i] = sum;
    sum += t.table[i];
  }

  /* create code->symbol translation table (symbols sorted by code) */
  for (i = 0; i < num; ++i) {
    if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
  }
}

/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

/* get one bit from source stream */
function tinf_getbit(d) {
  /* check if tag is empty */
  if (!d.bitcount--) {
    /* load next tag */
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }

  /* shift bit out of tag */
  var bit = d.tag & 1;
  d.tag >>>= 1;

  return bit;
}

/* read a num bit value from a stream and add base */
function tinf_read_bits(d, num, base) {
  if (!num)
    return base;

  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }

  var val = d.tag & (0xffff >>> (16 - num));
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}

/* given a data stream and a tree, decode a symbol */
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  
  var sum = 0, cur = 0, len = 0;
  var tag = d.tag;

  /* get more bits while code value is above sum */
  do {
    cur = 2 * cur + (tag & 1);
    tag >>>= 1;
    ++len;

    sum += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  
  d.tag = tag;
  d.bitcount -= len;

  return t.trans[sum + cur];
}

/* given a data stream, decode dynamic trees from it */
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;

  /* get 5 bits HLIT (257-286) */
  hlit = tinf_read_bits(d, 5, 257);

  /* get 5 bits HDIST (1-32) */
  hdist = tinf_read_bits(d, 5, 1);

  /* get 4 bits HCLEN (4-19) */
  hclen = tinf_read_bits(d, 4, 4);

  for (i = 0; i < 19; ++i) lengths[i] = 0;

  /* read code lengths for code length alphabet */
  for (i = 0; i < hclen; ++i) {
    /* get 3 bits code length (0-7) */
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }

  /* build code length tree */
  tinf_build_tree(code_tree, lengths, 0, 19);

  /* decode code lengths for the dynamic trees */
  for (num = 0; num < hlit + hdist;) {
    var sym = tinf_decode_symbol(d, code_tree);

    switch (sym) {
      case 16:
        /* copy previous code length 3-6 times (read 2 bits) */
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        /* repeat code length 0 for 3-10 times (read 3 bits) */
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        /* repeat code length 0 for 11-138 times (read 7 bits) */
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        /* values 0-15 represent the actual code lengths */
        lengths[num++] = sym;
        break;
    }
  }

  /* build dynamic trees */
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}

/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

/* given a stream and two trees, inflate a block of data */
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);

    /* check for end of block */
    if (sym === 256) {
      return TINF_OK;
    }

    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs;
      var i;

      sym -= 257;

      /* possibly get more bits from length code */
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

      dist = tinf_decode_symbol(d, dt);

      /* possibly get more bits from distance code */
      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

      /* copy match */
      for (i = offs; i < offs + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}

/* inflate an uncompressed block of data */
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  
  /* unread from bitbuffer */
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }

  /* get length */
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];

  /* get one's complement of length */
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

  /* check length */
  if (length !== (~invlength & 0x0000ffff))
    return TINF_DATA_ERROR;

  d.sourceIndex += 4;

  /* copy block */
  for (i = length; i; --i)
    d.dest[d.destLen++] = d.source[d.sourceIndex++];

  /* make sure we start next block on a byte boundary */
  d.bitcount = 0;

  return TINF_OK;
}

/* inflate stream from source to dest */
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res;

  do {
    /* read final block flag */
    bfinal = tinf_getbit(d);

    /* read block type (2 bits) */
    btype = tinf_read_bits(d, 2, 0);

    /* decompress block */
    switch (btype) {
      case 0:
        /* decompress uncompressed block */
        res = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        /* decompress block with fixed huffman trees */
        res = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        /* decompress block with dynamic huffman trees */
        tinf_decode_trees(d, d.ltree, d.dtree);
        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res = TINF_DATA_ERROR;
    }

    if (res !== TINF_OK)
      throw new Error('Data error');

  } while (!bfinal);

  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === 'function')
      return d.dest.slice(0, d.destLen);
    else
      return d.dest.subarray(0, d.destLen);
  }
  
  return d.dest;
}

/* -------------------- *
 * -- initialization -- *
 * -------------------- */

/* build fixed huffman trees */
tinf_build_fixed_trees(sltree, sdtree);

/* build extra bits and base tables */
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);

/* fix a special case */
length_bits[28] = 0;
length_base[28] = 258;

module.exports = tinf_uncompress;

},{}],1204:[function(require,module,exports){
// This file is autogenerated. It's used to publish CJS to npm.
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));

},{}],1205:[function(require,module,exports){
module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}

},{}],1206:[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.12.0
  //     https://underscorejs.org
  //     (c) 2009-2020 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.12.0';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key]; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  }

  _.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath(path) {
    return isArray(path) ? path : [path];
  }
  _.toPath = toPath;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath$1(path) {
    return _.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath$1(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has$1(obj, path) {
    path = toPath$1(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath$1(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_.iteratee !== iteratee) return _.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath$1(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath$1(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten$1(array, depth) {
    return flatten(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = array && max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has$1,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten$1,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _$1 = mixin(allExports);
  // Legacy Node.js API.
  _$1._ = _$1;

  return _$1;

})));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1207:[function(require,module,exports){
const inflate = require('tiny-inflate');
const { swap32LE } = require('./swap');

// Shift size for getting the index-1 table offset.
const SHIFT_1 = 6 + 5;

// Shift size for getting the index-2 table offset.
const SHIFT_2 = 5;

// Difference between the two shift sizes,
// for getting an index-1 offset from an index-2 offset. 6=11-5
const SHIFT_1_2 = SHIFT_1 - SHIFT_2;

// Number of index-1 entries for the BMP. 32=0x20
// This part of the index-1 table is omitted from the serialized form.
const OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;

// Number of entries in an index-2 block. 64=0x40
const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;

// Mask for getting the lower bits for the in-index-2-block offset. */
const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;

// Shift size for shifting left the index array values.
// Increases possible data size with 16-bit index values at the cost
// of compactability.
// This requires data blocks to be aligned by DATA_GRANULARITY.
const INDEX_SHIFT = 2;

// Number of entries in a data block. 32=0x20
const DATA_BLOCK_LENGTH = 1 << SHIFT_2;

// Mask for getting the lower bits for the in-data-block offset.
const DATA_MASK = DATA_BLOCK_LENGTH - 1;

// The part of the index-2 table for U+D800..U+DBFF stores values for
// lead surrogate code _units_ not code _points_.
// Values for lead surrogate code _points_ are indexed with this portion of the table.
// Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
const LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
const LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;

// Count the lengths of both BMP pieces. 2080=0x820
const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;

// The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
// Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
const UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;  // U+0800 is the first code point after 2-byte UTF-8

// The index-1 table, only used for supplementary code points, at offset 2112=0x840.
// Variable length, for code points up to highStart, where the last single-value range starts.
// Maximum length 512=0x200=0x100000>>SHIFT_1.
// (For 0x100000 supplementary code points U+10000..U+10ffff.)
//
// The part of the index-2 table for supplementary code points starts
// after this index-1 table.
//
// Both the index-1 table and the following part of the index-2 table
// are omitted completely if there is only BMP data.
const INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;

// The alignment size of a data block. Also the granularity for compaction.
const DATA_GRANULARITY = 1 << INDEX_SHIFT;

class UnicodeTrie {
  constructor(data) {
    const isBuffer = (typeof data.readUInt32BE === 'function') && (typeof data.slice === 'function');

    if (isBuffer || data instanceof Uint8Array) {
      // read binary format
      let uncompressedLength;
      if (isBuffer) {
        this.highStart = data.readUInt32LE(0);
        this.errorValue = data.readUInt32LE(4);
        uncompressedLength = data.readUInt32LE(8);
        data = data.slice(12);
      } else {
        const view = new DataView(data.buffer);
        this.highStart = view.getUint32(0, true);
        this.errorValue = view.getUint32(4, true);
        uncompressedLength = view.getUint32(8, true);
        data = data.subarray(12);
      }

      // double inflate the actual trie data
      data = inflate(data, new Uint8Array(uncompressedLength));
      data = inflate(data, new Uint8Array(uncompressedLength));

      // swap bytes from little-endian
      swap32LE(data);

      this.data = new Uint32Array(data.buffer);

    } else {
      // pre-parsed data
      ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
  }

  get(codePoint) {
    let index;
    if ((codePoint < 0) || (codePoint > 0x10ffff)) {
      return this.errorValue;
    }

    if ((codePoint < 0xd800) || ((codePoint > 0xdbff) && (codePoint <= 0xffff))) {
      // Ordinary BMP code point, excluding leading surrogates.
      // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
      // data is stored in the index array itself.
      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }

    if (codePoint <= 0xffff) {
      // Lead Surrogate Code Point.  A Separate index section is stored for
      // lead surrogate code units and code points.
      //   The main index has the code unit data.
      //   For this function, we need the code point data.
      index = (this.data[LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }

    if (codePoint < this.highStart) {
      // Supplemental code point, use two-level lookup.
      index = this.data[(INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH) + (codePoint >> SHIFT_1)];
      index = this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }

    return this.data[this.data.length - DATA_GRANULARITY];
  }
}

module.exports = UnicodeTrie;
},{"./swap":1208,"tiny-inflate":1203}],1208:[function(require,module,exports){
const isBigEndian = (new Uint8Array(new Uint32Array([0x12345678]).buffer)[0] === 0x12);

const swap = (b, n, m) => {
  let i = b[n];
  b[n] = b[m];
  b[m] = i;
};

const swap32 = array => {
  const len = array.length;
  for (let i = 0; i < len; i += 4) {
    swap(array, i, i + 3);
    swap(array, i + 1, i + 2);
  }
};

const swap32LE = array => {
  if (isBigEndian) {
    swap32(array);
  }
};

module.exports = {
  swap32LE: swap32LE
};

},{}],1209:[function(require,module,exports){
'use strict';

var UnicodeTrie = require('unicode-trie');
var base64 = require('base64-js');

var categories=["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"];var combiningClasses=["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"];var scripts=["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"];var eaw=["N","Na","A","W","H","F"];var data = {categories:categories,combiningClasses:combiningClasses,scripts:scripts,eaw:eaw};

var data$1="AAARAAAAAADwfAEAZXl5ONRt+/5bPVFZimRfKoTQJNm37CGE7Iw0j3UsTWKsoyI7kwyyTiEUzSD7NiEzhWYijH0wMVkHE4Mx49fzfo+3nuP4/fdZjvv+XNd5n/d9nef1WZvmKhTxiZndzDQBSEYQqxqKwnsKvGQucFh+6t6cJ792ePQBZv5S9yXSwkyjf/P4T7mTNnIAv1dOVhMlR9lflbUL9JeJguqsjvG9NTj/wLb566VAURnLo2vvRi89S3gW/33ihh2eXpDn40BIW7REl/7coRKIhAFlAiOtbLDTt6mMb4GzMF1gNnvX/sBxtbsAIjfztCNcQjcNDtLThRvuXu5M5g/CBjaLBE4lJm4qy/oZD97+IJryApcXfgWYlkvWbhfXgujOJKVu8B+ozqTLbxyJ5kNiR75CxDqfBM9eOlDMmGeoZ0iQbbS5VUplIwI+ZNXEKQVJxlwqjhOY7w3XwPesbLK5JZE+Tt4X8q8km0dzInsPPzbscrjBMVjF5mOHSeRdJVgKUjLTHiHqXSPkep8N/zFk8167KLp75f6RndkvzdfB6Uz3MmqvRArzdCbs1/iRZjYPLLF3U8Qs+H+Rb8iK51a6NIV2V9+07uJsTGFWpPz8J++7iRu2B6eAKlK/kujrLthwaD/7a6J5w90TusnH1JMAc+gNrql4aspOUG/RrsxUKmPzhHgP4Bleru+6Vfc/MBjgXVx7who94nPn7MPFrnwQP7g0k0Dq0h2GSKO6fTZ8nLodN1SiOUj/5EL/Xo1DBvRm0wmrh3x6phcJ20/9CuMr5h8WPqXMSasLoLHoufTmE7mzYrs6B0dY7KjuCogKqsvxnxAwXWvd9Puc9PnE8DOHT2INHxRlIyVHrqZahtfV2E/A2PDdtA3ewlRHMtFIBKO/T4IozWTQZ+mb+gdKuk/ZHrqloucKdsOSJmlWTSntWjcxVMjUmroXLM10I6TwDLnBq4LP69TxgVeyGsd8yHvhF8ydPlrNRSNs9EP7WmeuSE7Lu10JbOuQcJw/63sDp68wB9iwP5AO+mBpV0R5VDDeyQUFCel1G+4KHBgEVFS0YK+m2sXLWLuGTlkVAd97WwKKdacjWElRCuDRauf33l/yVcDF6sVPKeTes99FC1NpNWcpieGSV/IbO8PCTy5pbUR1U8lxzf4T+y6fZMxOz3LshkQLeeDSd0WmUrQgajmbktrxsb2AZ0ACw2Vgni+gV/m+KvCRWLg08Clx7uhql+v9XySGcjjOHlsp8vBw/e8HS7dtiqF6T/XcSXuaMW66GF1g4q9YyBadHqy3Y5jin1c7yZos6BBr6dsomSHxiUHanYtcYQwnMMZhRhOnaYJeyJzaRuukyCUh48+e/BUvk/aEfDp8ag+jD64BHxNnQ5v/E7WRk7eLjGV13I3oqy45YNONi/1op1oDr7rPjkhPsTXgUpQtGDPlIs55KhQaic9kSGs/UrZ2QKQOflB8MTEQxRF9pullToWO7Eplan6mcMRFnUu2441yxi23x+KqKlr7RWWsi9ZXMWlr8vfP3llk1m2PRj0yudccxBuoa7VfIgRmnFPGX6Pm1WIfMm/Rm4n/xTn8IGqA0GWuqgu48pEUO0U9nN+ZdIvFpPb7VDPphIfRZxznlHeVFebkd9l+raXy9BpTMcIUIvBfgHEb6ndGo8VUkxpief14KjzFOcaANfgvFpvyY8lE8lE4raHizLpluPzMks1hx/e1Hok5yV0p7qQH7GaYeMzzZTFvRpv6k6iaJ4yNqzBvN8J7B430h2wFm1IBPcqbou33G7/NWPgopl4Mllla6e24L3TOTVNkza2zv3QKuDWTeDpClCEYgTQ+5vEBSQZs/rMF50+sm4jofTgWLqgX1x3TkrDEVaRqfY/xZizFZ3Y8/DFEFD31VSfBQ5raEB6nHnZh6ddehtclQJ8fBrldyIh99LNnV32HzKEej04hk6SYjdauCa4aYW0ru/QxvQRGzLKOAQszf3ixJypTW3WWL6BLSF2EMCMIw7OUvWBC6A/gDc2D1jvBapMCc7ztx6jYczwTKsRLL6dMNXb83HS8kdD0pTMMj161zbVHkU0mhSHo9SlBDDXdN6hDvRGizmohtIyR3ot8tF5iUG4GLNcXeGvBudSFrHu+bVZb9jirNVG+rQPI51A7Hu8/b0UeaIaZ4UgDO68PkYx3PE2HWpKapJ764Kxt5TFYpywMy4DLQqVRy11I7SOLhxUFmqiEK52NaijWArIfCg6qG8q5eSiwRCJb1R7GDJG74TrYgx/lVq7w9++Kh929xSJEaoSse5fUOQg9nMAnIZv+7fwVRcNv3gOHI46Vb5jYUC66PYHO6lS+TOmvEQjuYmx4RkffYGxqZIp/DPWNHAixbRBc+XKE3JEOgs4jIwu/dSAwhydruOGF39co91aTs85JJ3Z/LpXoF43hUwJsb/M1Chzdn8HX8vLXnqWUKvRhNLpfAF4PTFqva1sBQG0J+59HyYfmQ3oa4/sxZdapVLlo/fooxSXi/dOEQWIWq8E0FkttEyTFXR2aNMPINMIzZwCNEheYTVltsdaLkMyKoEUluPNAYCM2IG3br0DLy0fVNWKHtbSKbBjfiw7Lu06gQFalC7RC9BwRMSpLYDUo9pDtDfzwUiPJKLJ2LGcSphWBadOI/iJjNqUHV7ucG8yC6+iNM9QYElqBR7ECFXrcTgWQ3eG/tCWacT9bxIkfmxPmi3vOd36KxihAJA73vWNJ+Y9oapXNscVSVqS5g15xOWND/WuUCcA9YAAg6WFbjHamrblZ5c0L6Zx1X58ZittGcfDKU697QRSqW/g+RofNRyvrWMrBn44cPvkRe2HdTu/Cq01C5/riWPHZyXPKHuSDDdW8c1XPgd6ogvLh20qEIu8c19sqr4ufyHrwh37ZN5MkvY1dsGmEz9pUBTxWrvvhNyODyX2Q1k/fbX/T/vbHNcBrmjgDtvBdtZrVtiIg5iXQuzO/DEMvRX8Mi1zymSlt92BGILeKItjoShJXE/H7xwnf0Iewb8BFieJ9MflEBCQYEDm8eZniiEPfGoaYiiEdhQxHQNr2AuRdmbL9mcl18Kumh+HEZLp6z+j35ML9zTbUwahUZCyQQOgQrGfdfQtaR/OYJ/9dYXb2TWZFMijfCA8Nov4sa5FFDUe1T68h4q08WDE7JbbDiej4utRMR9ontevxlXv6LuJTXt1YEv8bDzEt683PuSsIN0afvu0rcBu9AbXZbkOG3K3AhtqQ28N23lXm7S3Yn6KXmAhBhz+GeorJJ4XxO/b3vZk2LXp42+QvsVxGSNVpfSctIFMTR1bD9t70i6sfNF3WKz/uKDEDCpzzztwhL45lsw89H2IpWN10sXHRlhDse9KCdpP5qNNpU84cTY+aiqswqR8XZ9ea0KbVRwRuOGQU3csAtV2fSbnq47U6es6rKlWLWhg3s/B9C9g+oTyp6RtIldR51OOkP5/6nSy6itUVPcMNOp4M/hDdKOz3uK6srbdxOrc2cJgr1Sg02oBxxSky6V7JaG+ziNwlfqnjnvh2/uq1lKfbp+qpwq/D/5OI5gkFl5CejKGxfc2YVJfGqc4E0x5e9PHK2ukbHNI7/RZV6LNe65apbTGjoCaQls0txPPbmQbCQn+/upCoXRZy9yzorWJvZ0KWcbXlBxU/d5I4ERUTxMuVWhSMmF677LNN7NnLwsmKawXkCgbrpcluOl0WChR1qhtSrxGXHu251dEItYhYX3snvn1gS2uXuzdTxCJjZtjsip0iT2sDC0qMS7Bk9su2NyXjFK5/f5ZoWwofg3DtTyjaFqspnOOTSh8xK/CKUFS57guVEkw9xoQuRCwwEO9Lu9z2vYxSa9NFV8DvSxv2C4WYLYF8Nrc4DzWkzNsk81JJOlZ/LYJrGCoj4MmZpnf3AXmzxT4rtl9jsqljEyedz468SGKdBiQzyz/qWKEhFg45ZczlZZ3KGL3l6sn+3TTa3zMVMhPa1obGp/z+fvY0QXTrJTf1XAT3EtQdUfYYlmWZyvPZ/6rWwU7UOQei7pVE0osgN94Iy+T1+omE6z4Rh2O20FjgBeK2y1mcoFiMDOJvuZPn5Moy9fmFH3wyfKvn4+TwfLvt/lHTTVnvrtoUWRBiQXhiNM8nE6ZoWeux/Z0b2unRcdUzdDpmL7CAgd1ToRXwgmHTZOgiGtVT+xr1QH9ObebRTT4NzL+XSpLuuWp62GqQvJVTPoZOeJCb6gIwd9XHMftQ+Kc08IKKdKQANSJ1a2gve3JdRhO0+tNiYzWAZfd7isoeBu67W7xuK8WX7nhJURld98Inb0t/dWOSau/kDvV4DJo/cImw9AO2Gvq0F2n0M7yIZKL8amMbjYld+qFls7hq8Acvq97K2PrCaomuUiesu7qNanGupEl6J/iem8lyr/NMnsTr6o41PO0yhQh3hPFN0wJP7S830je9iTBLzUNgYH+gUZpROo3rN2qgCI+6GewpX8w8CH+ro6QrWiStqmcMzVa3vEel+3/dDxMp0rDv1Q6wTMS3K64zTT6RWzK1y643im25Ja7X2ePCV2mTswd/4jshZPo4bLnerqIosq/hy2bKUAmVn9n4oun1+a0DIZ56UhVwmZHdUNpLa8gmPvxS1eNvCF1T0wo1wKPdCJi0qOrWz7oYRTzgTtkzEzZn308XSLwUog4OWGKJzCn/3FfF9iA32dZHSv30pRCM3KBY9WZoRhtdK/ChHk6DEQBsfV6tN2o1Cn0mLtPBfnkS+qy1L2xfFe9TQPtDE1Be44RTl82E9hPT2rS2+93LFbzhQQO3C/hD2jRFH3BWWbasAfuMhRJFcTri73eE835y016s22DjoFJ862WvLj69fu2TgSF3RHia9D5DSitlQAXYCnbdqjPkR287Lh6dCHDapos+eFDvcZPP2edPmTFxznJE/EBLoQQ0Qmn9EkZOyJmHxMbvKYb8o21ZHmv5YLqgsEPk9gWZwYQY9wLqGXuax/8QlV5qDaPbq9pLPT1yp+zOWKmraEy1OUJI7zdEcEmvBpbdwLrDCgEb2xX8S/nxZgjK4bRi+pbOmbh8bEeoPvU/L9ndx9kntlDALbdAvp0O8ZC3zSUnFg4cePsw7jxewWvL7HRSBLUn6J7vTH9uld5N76JFPgBCdXGF221oEJk++XfRwXplLSyrVO7HFWBEs99nTazKveW3HpbD4dH/YmdAl+lwbSt8BQWyTG7jAsACI7bPPUU9hI9XUHWqQOuezHzUjnx5Qqs6T1qNHfTTHleDtmqK7flA9a0gz2nycIpz1FHBuWxKNtUeTdqP29Fb3tv+tl5JyBqXoR+vCsdzZwZUhf6Lu8bvkB9yQP4x7GGegB0ym0Lpl03Q7e+C0cDsm9GSDepCDji7nUslLyYyluPfvLyKaDSX4xpR+nVYQjQQn5F8KbY1gbIVLiK1J3mW90zTyR1bqApX2BlWh7KG8LAY9/S9nWC0XXh9pZZo6xuir12T43rkaGfQssbQyIslA7uJnSHOV22NhlNtUo0czxPAsXhh8tIQYaTM4l/yAlZlydTcXhlG22Gs/n3BxKBd/3ZjYwg3NaUurVXhNB+afVnFfNr9TbC9ksNdvwpNfeHanyJ8M6GrIVfLlYAPv0ILe4dn0Z+BJSbJkN7eZY/c6+6ttDYcIDeUKIDXqUSE42Xdh5nRbuaObozjht0HJ5H1e+em+NJi/+8kQlyjCbJpPckwThZeIF9/u7lrVIKNeJLCN/TpPAeXxvd31/CUDWHK9MuP1V1TJgngzi4V0qzS3SW3Qy5UiGHqg02wQa5tsEl9s/X9nNMosgLlUgZSfCBj1DiypLfhr9/r0nR0XY2tmhDOcUS4E7cqa4EJBhzqvpbZa35Q5Iz5EqmhYiOGDAYk606Tv74+KGfPjKVuP15rIzgW0I7/niOu9el/sn2bRye0gV+GrePDRDMHjwO1lEdeXH8N+UTO3IoN18kpI3tPxz+fY+n2MGMSGFHAx/83tKeJOl+2i+f1O9v6FfEDBbqrw+lpM8Anav7zHNr7hE78nXUtPNodMbCnITWA7Ma/IHlZ50F9hWge/wzOvSbtqFVFtkS8Of2nssjZwbSFdU+VO8z6tCEc9UA9ACxT5zIUeSrkBB/v1krOpm7bVMrGxEKfI6LcnpB4D8bvn2hDKGqKrJaVAJuDaBEY3F7eXyqnFWlOoFV/8ZLspZiZd7orXLhd4mhHQgbuKbHjJWUzrnm0Dxw/LJLzXCkh7slMxKo8uxZIWZfdKHlfI7uj3LP6ARAuWdF7ZmZ7daOKqKGbz5LxOggTgS39oEioYmrqkCeUDvbxkBYKeHhcLmMN8dMF01ZMb32IpL/cH8R7VHQSI5I0YfL14g9d7P/6cjB1JXXxbozEDbsrPdmL8ph7QW10jio+v7YsqHKQ6xrBbOVtxU0/nFfzUGZwIBLwyUvg49ii+54nv9FyECBpURnQK4Ox6N7lw5fsjdd5l/2SwBcAHMJoyjO1Pifye2dagaOwCVMqdJWAo77pvBe0zdJcTWu5fdzPNfV2p1pc7/JKQ8zhKkwsOELUDhXygPJ5oR8Vpk2lsCen3D3QOQp2zdrSZHjVBstDF/wWO98rrkQ6/7zt/Drip7OHIug1lomNdmRaHRrjmqeodn22sesQQPgzimPOMqC60a5+i/UYh51uZm+ijWkkaI2xjrBO2558DZNZMiuDQlaVAvBy2wLn/bR3FrNzfnO/9oDztYqxZrr7JMIhqmrochbqmQnKowxW29bpqTaJu7kW1VotC72QkYX8OoDDdMDwV1kJRk3mufgJBzf+iwFRJ7XWQwO5ujVglgFgHtycWiMLx5N+6XU+TulLabWjOzoao03fniUW0xvIJNPbk7CQlFZd/RCOPvgQbLjh5ITE8NVJeKt3HGr6JTnFdIzcVOlEtwqbIIX0IM7saC+4N5047MTJ9+Wn11EhyEPIlwsHE5utCeXRjQzlrR+R1Cf/qDzcNbqLXdk3J7gQ39VUrrEkS/VMWjjg+t2oYrqB0tUZClcUF6+LBC3EQ7KnGIwm/qjZX4GKPtjTX1zQKV6nPAb2t/Rza5IqKRf8i2DFEhV/YSifX0YwsiF6TQnp48Gr65TFq0zUe6LGjiY7fq0LSGKL1VnC6ESI2yxvt3XqBx53B3gSlGFeJcPbUbonW1E9E9m4NfuwPh+t5QjRxX34lvBPVxwQd7aeTd+r9dw5CiP1pt8wMZoMdni7GapYdo6KPgeQKcmlFfq4UYhvV0IBgeiR3RnTMBaqDqpZrTRyLdsp4l0IXZTdErfH0sN3dqBG5vRIx3VgCYcHmmkqJ8Hyu3s9K9uBD1d8cZUEx3qYcF5vsqeRpF1GOg8emeWM2OmBlWPdZ6qAXwm3nENFyh+kvXk132PfWAlN0kb7yh4fz2T7VWUY/hEXX5DvxGABC03XRpyOG8t/u3Gh5tZdpsSV9AWaxJN7zwhVglgII1gV28tUViyqn4UMdIh5t+Ea2zo7PO48oba0TwQbiSZOH4YhD578kPF3reuaP7LujPMsjHmaDuId9XEaZBCJhbXJbRg5VCk3KJpryH/+8S3wdhR47pdFcmpZG2p0Bpjp/VbvalgIZMllYX5L31aMPdt1J7r/7wbixt0Mnz2ZvNGTARHPVD+2O1D8SGpWXlVnP2ekgon55YiinADDynyaXtZDXueVqbuTi8z8cHHK325pgqM+mWZwzHeEreMvhZopAScXM14SJHpGwZyRljMlDvcMm9FZ/1e9+r/puOnpXOtc9Iu2fmgBfEP9cGW1Fzb1rGlfJ08pACtq1ZW18bf2cevebzVeHbaA50G9qoUp39JWdPHbYkPCRXjt4gzlq3Cxge28Mky8MoS/+On72kc+ZI2xBtgJytpAQHQ1zrEddMIVyR5urX6yBNu8v5lKC8eLdGKTJtbgIZ3ZyTzSfWmx9f+cvcJe8yM39K/djkp2aUTE/9m2Lj5jg7b8vdRAer7DO3SyLNHs1CAm5x5iAdh2yGJYivArZbCBNY88Tw+w+C1Tbt7wK3zl2rzTHo/D8/gb3c3mYrnEIEipYqPUcdWjnTsSw471O3EUN7Gtg4NOAs9PJrxm03VuZKa5xwXAYCjt7Gs01Km6T2DhOYUMoFcCSu7Hk1p3yP1eG+M3v3Q5luAze6WwBnZIYO0TCucPWK+UJ36KoJ8Y+vpavhLO8g5ed704IjlQdfemrMu//EvPYXTQSGIPPfiagJS9nMqP5IvkxN9pvuJz7h8carPXTKMq8jnTeL0STan6dnLTAqwIswcIwWDR2KwbGddAVN8SYWRB7kfBfBRkSXzvHlIF8D6jo64kUzYk5o/n8oLjKqat0rdXvQ86MkwQGMnnlcasqPPT2+mVtUGb32KuH6cyZQenrRG11TArcAl27+nvOMBDe++EKHf4YdyGf7mznzOz33cFFGEcv329p4qG2hoaQ8ULiMyVz6ENcxhoqGnFIdupcn7GICQWuw3yO3W8S33mzCcMYJ8ywc7U7rmaQf/W5K63Gr4bVTpXOyOp4tbaPyIaatBNpXqlmQUTSZXjxPr19+73PSaT+QnI35YsWn6WpfJjRtK8vlJZoTSgjaRU39AGCkWOZtifJrnefCrqwTKDFmuWUCukEsYcRrMzCoit28wYpP7kSVjMD8WJYQiNc2blMjuqYegmf6SsfC1jqz8XzghMlOX+gn/MKZmgljszrmehEa4V98VreJDxYvHr3j7IeJB9/sBZV41BWT/AZAjuC5XorlIPnZgBAniBEhanp0/0+qZmEWDpu8ige1hUPIyTo6T6gDEcFhWSoduNh8YSu65KgMOGBw7VlNYzNIgwHtq9KP2yyTVysqX5v12sf7D+vQUdR2dRDvCV40rIInXSLWT/yrC6ExOQxBJwIDbeZcl3z1yR5Rj3l8IGpxspapnvBL+fwupA3b6fkFceID9wgiM1ILB0cHVdvo/R4xg8yqKXT8efl0GnGX1/27FUYeUW2L/GNRGGWVGp3i91oaJkb4rybENHre9a2P5viz/yqk8ngWUUS+Kv+fu+9BLFnfLiLXOFcIeBJLhnayCiuDRSqcx0Qu68gVsGYc6EHD500Fkt+gpDj6gvr884n8wZ5o6q7xtL5wA0beXQnffWYkZrs2NGIRgQbsc5NB302SVx+R4ROvmgZaR8wBcji128BMfJ9kcvJ4DC+bQ57kRmv5yxgU4ngZfn0/JNZ8JBwxjTqS+s9kjJFG1unGUGLwMiIuXUD9EFhNIJuyCEAmVZSIGKH4G6v1gRR1LyzQKH2ZqiI1DnHMoDEZspbDjTeaFIAbSvjSq3A+n46y9hhVM8wIpnARSXyzmOD96d9UXvFroSPgGw1dq2vdEqDq9fJN1EbL2WulNmHkFDvxSO9ZT/RX/Bw2gA/BrF90XrJACereVfbV/YXaKfp77Nmx5NjEIUlxojsy7iN7nBHSZigfsbFyVOX1ZTeCCxvqnRSExP4lk5ZeYlRu9caaa743TWNdchRIhEWwadsBIe245C8clpaZ4zrPsk+OwXzxWCvRRumyNSLW5KWaSJyJU95cwheK76gr7228spZ3hmTtLyrfM2QRFqZFMR8/Q6yWfVgwTdfX2Ry4w3+eAO/5VT5nFb5NlzXPvBEAWrNZ6Q3jbH0RF4vcbp+fDngf/ywpoyNQtjrfvcq93AVb1RDWRghvyqgI2BkMr1rwYi8gizZ0G9GmPpMeqPerAQ0dJbzx+KAFM4IBq6iSLpZHUroeyfd9o5o+4fR2EtsZBoJORQEA4SW0CmeXSnblx2e9QkCHIodyqV6+g5ETEpZsLqnd/Na60EKPX/tQpPEcO+COIBPcQdszDzSiHGyQFPly/7KciUh1u+mFfxTCHGv9nn2WqndGgeGjQ/kr02qmTBX7Hc1qiEvgiSz1Tz/sy7Es29wvn6FrDGPP7asXlhOaiHxOctPvTptFA1kHFUk8bME7SsTSnGbFbUrssxrq70LhoSh5OwvQna+w84XdXhZb2sloJ4ZsCg3j+PrjJL08/JBi5zGd6ud/ZxhmcGKLOXPcNunQq5ESW92iJvfsuRrNYtawWwSmNhPYoFj2QqWNF0ffLpGt/ad24RJ8vkb5sXkpyKXmvFG5Vcdzf/44k3PBL/ojJ52+kWGzOArnyp5f969oV3J2c4Li27Nkova9VwRNVKqN0V+gV+mTHitgkXV30aWd3A1RSildEleiNPA+5cp+3+T7X+xfHiRZXQ1s4FA9TxIcnveQs9JSZ5r5qNmgqlW4zMtZ6rYNvgmyVcywKtu8ZxnSbS5vXlBV+NXdIfi3+xzrnJ0TkFL+Un8v1PWOC2PPFCjVPq7qTH7mOpzOYj/b4h0ceT+eHgr97Jqhb1ziVfeANzfN8bFUhPKBi7hJBCukQnB0aGjFTYLJPXL26lQ2b80xrOD5cFWgA8hz3St0e69kwNnD3+nX3gy12FjrjO+ddRvvvfyV3SWbXcxqNHfmsb9u1TV+wHTb9B07/L2sB8WUHJ9eeNomDyysEWZ0deqEhH/oWI2oiEh526gvAK1Nx2kIhNvkYR+tPYHEa9j+nd1VBpQP1uzSjIDO+fDDB7uy029rRjDC5Sk6aKczyz1D5uA9Lu+Rrrapl8JXNL3VRllNQH2K1ZFxOpX8LprttfqQ56MbPM0IttUheXWD/mROOeFqGUbL+kUOVlXLTFX/525g4faLEFO4qWWdmOXMNvVjpIVTWt650HfQjX9oT3Dg5Au6+v1/Ci78La6ZOngYCFPT1AUwxQuZ0yt5xKdNXLaDTISMTeCj16XTryhM36K2mfGRIgot71voWs8tTpL/f1rvcwv3LSDf+/G8THCT7NpfHWcW+lsF/ol8q9Bi6MezNTqp0rpp/kJRiVfNrX/w27cRRTu8RIIqtUblBMkxy4jwAVqCjUJkiPBj2cAoVloG8B2/N5deLdMhDb7xs5nhd3dubJhuj8WbaFRyu1L678DHhhA+rMimNo4C1kGpp0tD/qnCfCFHejpf0LJX43OTr578PY0tnIIrlWyNYyuR/ie6j2xNb1OV6u0dOX/1Dtcd7+ya9W+rY2LmnyQMtk8SMLTon8RAdwOaN2tNg5zVnDKlmVeOxPV2vhHIo9QEPV7jc3f+zVDquiNg1OaHX3cZXJDRY5MJpo+VanAcmqp4oasYLG+wrXUL5vJU0kqk2hGEskhP+Jjigrz1l6QnEwp6n8PMVeJp70Ii6ppeaK9GhF6fJE00ceLyxv08tKiPat4QdxZFgSbQknnEiCLD8Qc1rjazVKM3r3gXnnMeONgdz/yFV1q+haaN+wnF3Fn4uYCI9XsKOuVwDD0LsCO/f0gj5cmxCFcr7sclIcefWjvore+3aSU474cyqDVxH7w1RX3CHsaqsMRX17ZLgjsDXws3kLm2XJdM3Ku383UXqaHqsywzPhx7NFir0Fqjym/w6cxD2U9ypa3dx7Z12w/fi3Jps8sqJ8f8Ah8aZAvkHXvIRyrsxK7rrFaNNdNvjI8+3Emri195DCNa858anj2Qdny6Czshkn4N2+1m+k5S8sunX3Ja7I+JutRzg1mc2e9Yc0Zv9PZn1SwhxIdU9sXwZRTd/J5FoUm0e+PYREeHg3oc2YYzGf2xfJxXExt4pT3RfDRHvMXLUmoXOy63xv5pLuhOEax0dRgSywZ/GH+YBXFgCeTU0hZ8SPEFsn8punp1Kurd1KgXxUZ+la3R5+4ePGR4ZF5UQtOa83+Vj8zh80dfzbhxWCeoJnQ4dkZJM4drzknZOOKx2n3WrvJnzFIS8p0xeic+M3ZRVXIp10tV2DyYKwRxLzulPwzHcLlYTxl4PF7v8l106Azr+6wBFejbq/3P72C/0j78cepY9990/d4eAurn2lqdGKLU8FffnMw7cY7pVeXJRMU73Oxwi2g2vh/+4gX8dvbjfojn/eLVhhYl8GthwCQ50KcZq4z2JeW5eeOnJWFQEnVxDoG459TaC4zXybECEoJ0V5q1tXrQbDMtUxeTV6Pdt1/zJuc7TJoV/9YZFWxUtCf6Ou3Vd/vR/vG0138hJQrHkNeoep5dLe+6umcSquKvMaFpm3EZHDBOvCi0XYyIFHMgX7Cqp3JVXlxJFwQfHSaIUEbI2u1lBVUdlNw4Qa9UsLPEK94Qiln3pyKxQVCeNlx8yd7EegVNQBkFLabKvnietYVB4IPZ1fSor82arbgYec8aSdFMaIluYTYuNx32SxfrjKUdPGq+UNp5YpydoEG3xVLixtmHO9zXxKAnHnPuH2fPGrjx0GcuCDEU+yXUtXh6nfUL+cykws1gJ5vkfYFaFBr9PdCXvVf35OJQxzUMmWjv0W6uGJK11uAGDqSpOwCf6rouSIjPVgw57cJCOQ4b9tkI/Y5WNon9Swe72aZryKo8d+HyHBEdWJKrkary0LIGczA4Irq353Wc0Zga3om7UQiAGCvIl8GGyaqz5zH+1gMP5phWUCpKtttWIyicz09vXg76GxkmiGSMQ06Z9X8BUwqOtauDbPIf4rpK/yYoeAHxJ9soXS9VDe1Aw+awOOxaN8foLrif0TXBvQ55dtRtulRq9emFDBxlQcqKCaD8NeTSE7FOHvcjf/+oKbbtRqz9gbofoc2EzQ3pL6W5JdfJzAWmOk8oeoECe90lVMruwl/ltM015P/zIPazqvdvFmLNVHMIZrwiQ2tIKtGh6PDVH+85ew3caqVt2BsDv5rOcu3G9srQWd7NmgtzCRUXLYknYRSwtH9oUtkqyN3CfP20xQ1faXQl4MEmjQehWR6GmGnkdpYNQYeIG408yAX7uCZmYUic9juOfb+Re28+OVOB+scYK4DaPcBe+5wmji9gymtkMpKo4UKqCz7yxzuN8VIlx9yNozpRJpNaWHtaZVEqP45n2JemTlYBSmNIK1FuSYAUQ1yBLnKxevrjayd+h2i8PjdB3YY6b0nr3JuOXGpPMyh4V2dslpR3DFEvgpsBLqhqLDOWP4yEvIL6f21PpA7/8B";var trieData = {data:data$1};

var log2 = Math.log2 || (n => Math.log(n) / Math.LN2);

var bits = n => log2(n) + 1 | 0;

var buildUnicodeProperties = (data, trie) => {
  // compute the number of bits stored for each field
  var CATEGORY_BITS = bits(data.categories.length - 1);
  var COMBINING_BITS = bits(data.combiningClasses.length - 1);
  var SCRIPT_BITS = bits(data.scripts.length - 1);
  var EAW_BITS = bits(data.eaw.length - 1);
  var NUMBER_BITS = 10; // compute shift and mask values for each field

  var CATEGORY_SHIFT = COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
  var COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
  var SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;
  var EAW_SHIFT = NUMBER_BITS;
  var CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;
  var COMBINING_MASK = (1 << COMBINING_BITS) - 1;
  var SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;
  var EAW_MASK = (1 << EAW_BITS) - 1;
  var NUMBER_MASK = (1 << NUMBER_BITS) - 1;

  var getCategory = codePoint => {
    var val = trie.get(codePoint);
    return data.categories[val >> CATEGORY_SHIFT & CATEGORY_MASK];
  };

  var getCombiningClass = codePoint => {
    var val = trie.get(codePoint);
    return data.combiningClasses[val >> COMBINING_SHIFT & COMBINING_MASK];
  };

  var getScript = codePoint => {
    var val = trie.get(codePoint);
    return data.scripts[val >> SCRIPT_SHIFT & SCRIPT_MASK];
  };

  var getEastAsianWidth = codePoint => {
    var val = trie.get(codePoint);
    return data.eaw[val >> EAW_SHIFT & EAW_MASK];
  };

  var getNumericValue = codePoint => {
    var val = trie.get(codePoint);
    var num = val & NUMBER_MASK;

    if (num === 0) {
      return null;
    } else if (num <= 50) {
      return num - 1;
    } else if (num < 0x1e0) {
      var numerator = (num >> 4) - 12;
      var denominator = (num & 0xf) + 1;
      return numerator / denominator;
    } else if (num < 0x300) {
      val = (num >> 5) - 14;
      var exp = (num & 0x1f) + 2;

      while (exp > 0) {
        val *= 10;
        exp--;
      }

      return val;
    } else {
      val = (num >> 2) - 0xbf;

      var _exp = (num & 3) + 1;

      while (_exp > 0) {
        val *= 60;
        _exp--;
      }

      return val;
    }
  };

  var isAlphabetic = codePoint => {
    var category = getCategory(codePoint);
    return category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Nl';
  };

  var isDigit = codePoint => getCategory(codePoint) === 'Nd';

  var isPunctuation = codePoint => {
    var category = getCategory(codePoint);
    return category === 'Pc' || category === 'Pd' || category === 'Pe' || category === 'Pf' || category === 'Pi' || category === 'Po' || category === 'Ps';
  };

  var isLowerCase = codePoint => {
    return getCategory(codePoint) === 'Ll';
  };

  var isUpperCase = codePoint => getCategory(codePoint) === 'Lu';

  var isTitleCase = codePoint => getCategory(codePoint) === 'Lt';

  var isWhiteSpace = codePoint => {
    var category = getCategory(codePoint);
    return category === 'Zs' || category === 'Zl' || category === 'Zp';
  };

  var isBaseForm = codePoint => {
    var category = getCategory(codePoint);
    return category === 'Nd' || category === 'No' || category === 'Nl' || category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Me' || category === 'Mc';
  };

  var isMark = codePoint => {
    var category = getCategory(codePoint);
    return category === 'Mn' || category === 'Me' || category === 'Mc';
  };

  return {
    getCategory,
    getCombiningClass,
    getScript,
    getEastAsianWidth,
    getNumericValue,
    isAlphabetic,
    isDigit,
    isPunctuation,
    isLowerCase,
    isUpperCase,
    isTitleCase,
    isWhiteSpace,
    isBaseForm,
    isMark
  };
};

var trie = new UnicodeTrie(base64.toByteArray(trieData.data));
var unicodeProperties = buildUnicodeProperties(data, trie);

module.exports = unicodeProperties;


},{"base64-js":387,"unicode-trie":1207}],1210:[function(require,module,exports){
// Generated by CoffeeScript 1.7.1
var UnicodeTrie, inflate;

inflate = require('tiny-inflate');

UnicodeTrie = (function() {
  var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;

  SHIFT_1 = 6 + 5;

  SHIFT_2 = 5;

  SHIFT_1_2 = SHIFT_1 - SHIFT_2;

  OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;

  INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;

  INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;

  INDEX_SHIFT = 2;

  DATA_BLOCK_LENGTH = 1 << SHIFT_2;

  DATA_MASK = DATA_BLOCK_LENGTH - 1;

  LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;

  LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;

  INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;

  UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;

  UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;

  INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;

  DATA_GRANULARITY = 1 << INDEX_SHIFT;

  function UnicodeTrie(data) {
    var isBuffer, uncompressedLength, view;
    isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
    if (isBuffer || data instanceof Uint8Array) {
      if (isBuffer) {
        this.highStart = data.readUInt32BE(0);
        this.errorValue = data.readUInt32BE(4);
        uncompressedLength = data.readUInt32BE(8);
        data = data.slice(12);
      } else {
        view = new DataView(data.buffer);
        this.highStart = view.getUint32(0);
        this.errorValue = view.getUint32(4);
        uncompressedLength = view.getUint32(8);
        data = data.subarray(12);
      }
      data = inflate(data, new Uint8Array(uncompressedLength));
      data = inflate(data, new Uint8Array(uncompressedLength));
      this.data = new Uint32Array(data.buffer);
    } else {
      this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
    }
  }

  UnicodeTrie.prototype.get = function(codePoint) {
    var index;
    if (codePoint < 0 || codePoint > 0x10ffff) {
      return this.errorValue;
    }
    if (codePoint < 0xd800 || (codePoint > 0xdbff && codePoint <= 0xffff)) {
      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint <= 0xffff) {
      index = (this.data[LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint < this.highStart) {
      index = this.data[(INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH) + (codePoint >> SHIFT_1)];
      index = this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    return this.data[this.data.length - DATA_GRANULARITY];
  };

  return UnicodeTrie;

})();

module.exports = UnicodeTrie;

},{"tiny-inflate":1203}],1211:[function(require,module,exports){

'use strict'

if ("production" === 'production') {
  module.exports = require('./unsplash-js.cjs.production.min.js')
} else {
  module.exports = require('./unsplash-js.cjs.development.js')
}

},{"./unsplash-js.cjs.development.js":1212,"./unsplash-js.cjs.production.min.js":1213}],1212:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ContentTypeHelpers = require('content-type');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var checkIsString = /*#__PURE__*/getRefinement(function (value) {
  return typeof value === 'string' ? value : null;
});
var isDefined = function isDefined(x) {
  return x !== null && x !== undefined;
};
function getRefinement(getB) {
  return function (a) {
    return isDefined(getB(a));
  };
}
var checkIsNonEmptyArray = function checkIsNonEmptyArray(a) {
  return a.length > 0;
};

/** Takes a dictionary containing nullish values and returns a dictionary of all the defined
 * (non-nullish) values.
 */

var compactDefined = function compactDefined(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _ref;

    var value = obj[key];
    return _extends({}, acc, isDefined(value) ? (_ref = {}, _ref[key] = value, _ref) : {});
  }, {});
};
function flow() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  var len = fns.length - 1;
  return function () {
    for (var _len2 = arguments.length, x = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      x[_key2] = arguments[_key2];
    }

    var y = fns[0].apply(this, x);

    for (var i = 1; i <= len; i++) {
      y = fns[i].call(this, y);
    }

    return y;
  };
}

var checkIsObject = /*#__PURE__*/getRefinement(function (response) {
  return isDefined(response) && typeof response === 'object' && !Array.isArray(response) ? response : null;
});
var checkIsErrors = /*#__PURE__*/getRefinement(function (errors) {
  return Array.isArray(errors) && errors.every(checkIsString) && checkIsNonEmptyArray(errors) ? errors : null;
});
var checkIsApiError = /*#__PURE__*/getRefinement(function (response) {
  return checkIsObject(response) && 'errors' in response && checkIsErrors(response.errors) ? {
    errors: response.errors
  } : null;
});
var getErrorForBadStatusCode = function getErrorForBadStatusCode(jsonResponse) {
  if (checkIsApiError(jsonResponse)) {
    return {
      errors: jsonResponse.errors,
      source: 'api'
    };
  } else {
    return {
      errors: ['Responded with a status code outside the 2xx range, and the response body is not recognisable.'],
      source: 'decoding'
    };
  }
};
var DecodingError = function DecodingError(message) {
  this.message = message;
};

var CONTENT_TYPE_RESPONSE_HEADER = 'content-type';
var CONTENT_TYPE_JSON = 'application/json';

var checkIsJsonResponse = function checkIsJsonResponse(response) {
  var contentTypeHeader = response.headers.get(CONTENT_TYPE_RESPONSE_HEADER);
  return isDefined(contentTypeHeader) && ContentTypeHelpers.parse(contentTypeHeader).type === CONTENT_TYPE_JSON;
};
/**
 * Note: restrict the type of JSON to `AnyJson` so that `any` doesn't leak downstream.
 */


var getJsonResponse = function getJsonResponse(response) {
  if (checkIsJsonResponse(response)) {
    return response.json()["catch"](function (_err) {
      throw new DecodingError('unable to parse JSON response.');
    });
  } else {
    throw new DecodingError('expected JSON response from server.');
  }
};

var handleFetchResponse = function handleFetchResponse(handleResponse) {
  return function (response) {
    return (response.ok ? handleResponse({
      response: response
    }).then(function (handledResponse) {
      return {
        type: 'success',
        status: response.status,
        response: handledResponse,
        originalResponse: response
      };
    }) : getJsonResponse(response).then(function (jsonResponse) {
      return _extends({
        type: 'error',
        status: response.status
      }, getErrorForBadStatusCode(jsonResponse), {
        originalResponse: response
      });
    }))["catch"](function (error) {
      /**
       * We want to separate expected decoding errors from unknown ones. We do so by throwing a custom
       * `DecodingError` whenever we encounter one within `handleFetchResponse` and catch them all
       * here. This allows us to easily handle all of these errors at once. Unexpected errors are not
       * caught, so that they bubble up and fail loudly.
       *
       * Note: Ideally we'd use an Either type, but this does the job without introducing dependencies
       * like `fp-ts`.
       */
      if (error instanceof DecodingError) {
        return {
          type: 'error',
          source: 'decoding',
          status: response.status,
          originalResponse: response,
          errors: [error.message]
        };
      } else {
        throw error;
      }
    });
  };
};
var castResponse = function castResponse() {
  return function (_ref) {
    var response = _ref.response;
    return getJsonResponse(response);
  };
};

var addQueryToUrl = function addQueryToUrl(query) {
  return function (url) {
    Object.keys(query).forEach(function (queryKey) {
      return url.searchParams.set(queryKey, query[queryKey].toString());
    });
  };
};

var addPathnameToUrl = function addPathnameToUrl(pathname) {
  return function (url) {
    // When there is no existing pathname, the value is `/`. Appending would give us a URL with two
    // forward slashes. This is why we replace the value in that scenario.
    if (url.pathname === '/') {
      url.pathname = pathname;
    } else {
      url.pathname += pathname;
    }
  };
};

var buildUrl = function buildUrl(_ref) {
  var pathname = _ref.pathname,
      query = _ref.query;
  return function (apiUrl) {
    var url = new URL(apiUrl);
    addPathnameToUrl(pathname)(url);
    addQueryToUrl(query)(url);
    return url.toString();
  };
};

var getQueryFromSearchParams = function getQueryFromSearchParams(searchParams) {
  var query = {};
  searchParams.forEach(function (value, key) {
    query[key] = value;
  });
  return query;
};

var parseQueryAndPathname = function parseQueryAndPathname(url) {
  var _URL = new URL(url),
      pathname = _URL.pathname,
      searchParams = _URL.searchParams;

  var query = getQueryFromSearchParams(searchParams);
  return {
    query: query,
    pathname: pathname === '/' ? undefined : pathname
  };
};

/**
 * helper used to type-check the arguments, and add default params for all requests
 */

var createRequestHandler = function createRequestHandler(fn) {
  return function (a, additionalFetchOptions) {
    if (additionalFetchOptions === void 0) {
      additionalFetchOptions = {};
    }

    var _fn = fn(a),
        headers = _fn.headers,
        query = _fn.query,
        baseReqParams = _objectWithoutPropertiesLoose(_fn, ["headers", "query"]);

    return _extends({}, baseReqParams, additionalFetchOptions, {
      query: query,
      headers: _extends({}, headers, additionalFetchOptions.headers)
    });
  };
};
var makeEndpoint = function makeEndpoint(endpoint) {
  return endpoint;
};
var initMakeRequest = function initMakeRequest(_ref) {
  var accessKey = _ref.accessKey,
      _ref$apiVersion = _ref.apiVersion,
      apiVersion = _ref$apiVersion === void 0 ? 'v1' : _ref$apiVersion,
      _ref$apiUrl = _ref.apiUrl,
      apiUrl = _ref$apiUrl === void 0 ? 'https://api.unsplash.com' : _ref$apiUrl,
      generalHeaders = _ref.headers,
      providedFetch = _ref.fetch,
      generalFetchOptions = _objectWithoutPropertiesLoose(_ref, ["accessKey", "apiVersion", "apiUrl", "headers", "fetch"]);

  return function (_ref2) {
    var handleResponse = _ref2.handleResponse,
        handleRequest = _ref2.handleRequest;
    return flow(handleRequest, function (_ref3) {
      var pathname = _ref3.pathname,
          query = _ref3.query,
          _ref3$method = _ref3.method,
          method = _ref3$method === void 0 ? 'GET' : _ref3$method,
          endpointHeaders = _ref3.headers,
          body = _ref3.body,
          signal = _ref3.signal;
      var url = buildUrl({
        pathname: pathname,
        query: query
      })(apiUrl);

      var fetchOptions = _extends({
        method: method,
        headers: _extends({}, generalHeaders, endpointHeaders, {
          'Accept-Version': apiVersion
        }, isDefined(accessKey) ? {
          Authorization: "Client-ID " + accessKey
        } : {}),
        body: body,
        signal: signal
      }, generalFetchOptions);

      var fetchToUse = providedFetch != null ? providedFetch : fetch;
      return fetchToUse(url, fetchOptions).then(handleFetchResponse(handleResponse));
    });
  };
};

var TOTAL_RESPONSE_HEADER = 'x-total';

var getTotalFromApiFeedResponse = function getTotalFromApiFeedResponse(response) {
  var totalsStr = response.headers.get(TOTAL_RESPONSE_HEADER);

  if (isDefined(totalsStr)) {
    var total = parseInt(totalsStr);

    if (Number.isInteger(total)) {
      return total;
    } else {
      throw new DecodingError("expected " + TOTAL_RESPONSE_HEADER + " header to be valid integer.");
    }
  } else {
    throw new DecodingError("expected " + TOTAL_RESPONSE_HEADER + " header to exist.");
  }
};

var handleFeedResponse = function handleFeedResponse() {
  return function (_ref) {
    var response = _ref.response;
    return castResponse()({
      response: response
    }).then(function (results) {
      return {
        results: results,
        total: getTotalFromApiFeedResponse(response)
      };
    });
  };
};

var getCollections = function getCollections(collectionIds) {
  return isDefined(collectionIds) ? {
    collections: collectionIds.join()
  } : {};
};
var getTopics = function getTopics(topicIds) {
  return isDefined(topicIds) ? {
    topics: topicIds.join()
  } : {};
};
var getFeedParams = function getFeedParams(_ref) {
  var page = _ref.page,
      perPage = _ref.perPage,
      orderBy = _ref.orderBy;
  return compactDefined({
    per_page: perPage,
    order_by: orderBy,
    page: page
  });
};

var COLLECTIONS_PATH_PREFIX = '/collections';
var getPhotos = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref) {
    var collectionId = _ref.collectionId;
    return COLLECTIONS_PATH_PREFIX + "/" + collectionId + "/photos";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref2) {
      var collectionId = _ref2.collectionId,
          orientation = _ref2.orientation,
          paginationParams = _objectWithoutPropertiesLoose(_ref2, ["collectionId", "orientation"]);

      return {
        pathname: getPathname({
          collectionId: collectionId
        }),
        query: compactDefined(_extends({}, getFeedParams(paginationParams), {
          orientation: orientation
        }))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var get = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref3) {
    var collectionId = _ref3.collectionId;
    return COLLECTIONS_PATH_PREFIX + "/" + collectionId;
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref4) {
      var collectionId = _ref4.collectionId;
      return {
        pathname: getPathname({
          collectionId: collectionId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var list = /*#__PURE__*/function () {
  var getPathname = function getPathname() {
    return COLLECTIONS_PATH_PREFIX;
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (paginationParams) {
      if (paginationParams === void 0) {
        paginationParams = {};
      }

      return {
        pathname: getPathname(),
        query: getFeedParams(paginationParams)
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var getRelated = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref5) {
    var collectionId = _ref5.collectionId;
    return COLLECTIONS_PATH_PREFIX + "/" + collectionId + "/related";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref6) {
      var collectionId = _ref6.collectionId;
      return {
        pathname: getPathname({
          collectionId: collectionId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();

var index = {
  __proto__: null,
  getPhotos: getPhotos,
  get: get,
  list: list,
  getRelated: getRelated
};

var PHOTOS_PATH_PREFIX = '/photos';
var list$1 = /*#__PURE__*/function () {
  var _getPathname = function getPathname() {
    return PHOTOS_PATH_PREFIX;
  };

  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname();
    },
    handleRequest: createRequestHandler(function (feedParams) {
      if (feedParams === void 0) {
        feedParams = {};
      }

      return {
        pathname: PHOTOS_PATH_PREFIX,
        query: compactDefined(getFeedParams(feedParams))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var get$1 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref) {
    var photoId = _ref.photoId;
    return PHOTOS_PATH_PREFIX + "/" + photoId;
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref2) {
      var photoId = _ref2.photoId;
      return {
        pathname: getPathname({
          photoId: photoId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var getStats = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref3) {
    var photoId = _ref3.photoId;
    return PHOTOS_PATH_PREFIX + "/" + photoId + "/statistics";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref4) {
      var photoId = _ref4.photoId;
      return {
        pathname: getPathname({
          photoId: photoId
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var getRandom = /*#__PURE__*/function () {
  var getPathname = function getPathname() {
    return PHOTOS_PATH_PREFIX + "/random";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_temp) {
      var _ref5 = _temp === void 0 ? {} : _temp,
          collectionIds = _ref5.collectionIds,
          contentFilter = _ref5.contentFilter,
          topicIds = _ref5.topicIds,
          queryParams = _objectWithoutPropertiesLoose(_ref5, ["collectionIds", "contentFilter", "topicIds"]);

      return {
        pathname: getPathname(),
        query: compactDefined(_extends({}, queryParams, {
          content_filter: contentFilter
        }, getCollections(collectionIds), getTopics(topicIds))),
        headers: {
          /**
           * Avoid response caching
           */
          'cache-control': 'no-cache'
        }
      };
    }),
    handleResponse: castResponse()
  });
}();
var trackDownload = {
  handleRequest: /*#__PURE__*/createRequestHandler(function (_ref6) {
    var downloadLocation = _ref6.downloadLocation;

    var _parseQueryAndPathnam = parseQueryAndPathname(downloadLocation),
        pathname = _parseQueryAndPathnam.pathname,
        query = _parseQueryAndPathnam.query;

    if (!isDefined(pathname)) {
      throw new Error('Could not parse pathname from url.');
    }

    return {
      pathname: pathname,
      query: compactDefined(query)
    };
  }),
  handleResponse: /*#__PURE__*/castResponse()
};

var index$1 = {
  __proto__: null,
  list: list$1,
  get: get$1,
  getStats: getStats,
  getRandom: getRandom,
  trackDownload: trackDownload
};

var SEARCH_PATH_PREFIX = "/search";
var getPhotos$1 = /*#__PURE__*/function () {
  var _getPathname = function getPathname() {
    return SEARCH_PATH_PREFIX + "/photos";
  };

  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname();
    },
    handleRequest: createRequestHandler(function (_ref) {
      var query = _ref.query,
          page = _ref.page,
          perPage = _ref.perPage,
          orderBy = _ref.orderBy,
          collectionIds = _ref.collectionIds,
          lang = _ref.lang,
          contentFilter = _ref.contentFilter,
          filters = _objectWithoutPropertiesLoose(_ref, ["query", "page", "perPage", "orderBy", "collectionIds", "lang", "contentFilter"]);

      return {
        pathname: _getPathname(),
        query: compactDefined(_extends({
          query: query,
          content_filter: contentFilter,
          lang: lang,
          order_by: orderBy
        }, getFeedParams({
          page: page,
          perPage: perPage
        }), getCollections(collectionIds), filters))
      };
    }),
    handleResponse: castResponse()
  });
}();
var getCollections$1 = /*#__PURE__*/function () {
  var _getPathname2 = function getPathname() {
    return SEARCH_PATH_PREFIX + "/collections";
  };

  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname2();
    },
    handleRequest: createRequestHandler(function (_ref2) {
      var query = _ref2.query,
          paginationParams = _objectWithoutPropertiesLoose(_ref2, ["query"]);

      return {
        pathname: _getPathname2(),
        query: _extends({
          query: query
        }, getFeedParams(paginationParams))
      };
    }),
    handleResponse: castResponse()
  });
}();
var getUsers = /*#__PURE__*/function () {
  var _getPathname3 = function getPathname() {
    return SEARCH_PATH_PREFIX + "/users";
  };

  return makeEndpoint({
    // Wrapper uses type trick to allow 0 args
    getPathname: function getPathname(_params) {
      return _getPathname3();
    },
    handleRequest: createRequestHandler(function (_ref3) {
      var query = _ref3.query,
          paginationParams = _objectWithoutPropertiesLoose(_ref3, ["query"]);

      return {
        pathname: _getPathname3(),
        query: _extends({
          query: query
        }, getFeedParams(paginationParams))
      };
    }),
    handleResponse: castResponse()
  });
}();

var index$2 = {
  __proto__: null,
  getPhotos: getPhotos$1,
  getCollections: getCollections$1,
  getUsers: getUsers
};

var USERS_PATH_PREFIX = '/users';
var get$2 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref) {
    var username = _ref.username;
    return USERS_PATH_PREFIX + "/" + username;
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref2) {
      var username = _ref2.username;
      return {
        pathname: getPathname({
          username: username
        }),
        query: {}
      };
    }),
    handleResponse: castResponse()
  });
}();
var getPhotos$2 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref3) {
    var username = _ref3.username;
    return USERS_PATH_PREFIX + "/" + username + "/photos";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref4) {
      var username = _ref4.username,
          stats = _ref4.stats,
          orientation = _ref4.orientation,
          paginationParams = _objectWithoutPropertiesLoose(_ref4, ["username", "stats", "orientation"]);

      return {
        pathname: getPathname({
          username: username
        }),
        query: compactDefined(_extends({}, getFeedParams(paginationParams), {
          orientation: orientation,
          stats: stats
        }))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var getLikes = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref5) {
    var username = _ref5.username;
    return USERS_PATH_PREFIX + "/" + username + "/likes";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref6) {
      var username = _ref6.username,
          orientation = _ref6.orientation,
          paginationParams = _objectWithoutPropertiesLoose(_ref6, ["username", "orientation"]);

      return {
        pathname: getPathname({
          username: username
        }),
        query: compactDefined(_extends({}, getFeedParams(paginationParams), {
          orientation: orientation
        }))
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();
var getCollections$2 = /*#__PURE__*/function () {
  var getPathname = function getPathname(_ref7) {
    var username = _ref7.username;
    return USERS_PATH_PREFIX + "/" + username + "/collections";
  };

  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: createRequestHandler(function (_ref8) {
      var username = _ref8.username,
          paginationParams = _objectWithoutPropertiesLoose(_ref8, ["username"]);

      return {
        pathname: getPathname({
          username: username
        }),
        query: getFeedParams(paginationParams)
      };
    }),
    handleResponse: handleFeedResponse()
  });
}();

var index$3 = {
  __proto__: null,
  get: get$2,
  getPhotos: getPhotos$2,
  getLikes: getLikes,
  getCollections: getCollections$2
};

var BASE_TOPIC_PATH = '/topics';

var getTopicPath = function getTopicPath(_ref) {
  var topicIdOrSlug = _ref.topicIdOrSlug;
  return BASE_TOPIC_PATH + "/" + topicIdOrSlug;
};

var list$2 = /*#__PURE__*/makeEndpoint({
  getPathname: getTopicPath,
  handleRequest: function handleRequest(_ref2) {
    var page = _ref2.page,
        perPage = _ref2.perPage,
        orderBy = _ref2.orderBy,
        topicIdsOrSlugs = _ref2.topicIdsOrSlugs;
    return {
      pathname: BASE_TOPIC_PATH,
      query: compactDefined(_extends({}, getFeedParams({
        page: page,
        perPage: perPage
      }), {
        ids: topicIdsOrSlugs == null ? void 0 : topicIdsOrSlugs.join(','),
        order_by: orderBy
      }))
    };
  },
  handleResponse: /*#__PURE__*/handleFeedResponse()
});
var get$3 = /*#__PURE__*/makeEndpoint({
  getPathname: getTopicPath,
  handleRequest: function handleRequest(_ref3) {
    var topicIdOrSlug = _ref3.topicIdOrSlug;
    return {
      pathname: getTopicPath({
        topicIdOrSlug: topicIdOrSlug
      }),
      query: {}
    };
  },
  handleResponse: /*#__PURE__*/castResponse()
});
var getPhotos$3 = /*#__PURE__*/function () {
  var getPathname = /*#__PURE__*/flow(getTopicPath, function (topicPath) {
    return topicPath + "/photos";
  });
  return makeEndpoint({
    getPathname: getPathname,
    handleRequest: function handleRequest(_ref4) {
      var topicIdOrSlug = _ref4.topicIdOrSlug,
          orientation = _ref4.orientation,
          feedParams = _objectWithoutPropertiesLoose(_ref4, ["topicIdOrSlug", "orientation"]);

      return {
        pathname: getPathname({
          topicIdOrSlug: topicIdOrSlug
        }),
        query: compactDefined(_extends({}, getFeedParams(feedParams), {
          orientation: orientation
        }))
      };
    },
    handleResponse: handleFeedResponse()
  });
}();

var index$4 = {
  __proto__: null,
  list: list$2,
  get: get$3,
  getPhotos: getPhotos$3
};

var trackNonHotLinkedPhotoView = function trackNonHotLinkedPhotoView(_ref) {
  var appId = _ref.appId;
  return function (_ref2) {
    var photoId = _ref2.photoId;
    var ids = !Array.isArray(photoId) ? [photoId] : photoId;

    if (ids.length > 20) {
      throw new Error('You cannot track more than 20 photos at once. Please try again with fewer photos.');
    }

    return fetch("views.unsplash.com/v?photo_id=" + ids.join() + "&app_id=" + appId);
  };
};



var internals = {
  __proto__: null,
  collections: index,
  photos: index$1,
  search: index$2,
  users: index$3,
  topics: index$4,
  trackNonHotLinkedPhotoView: trackNonHotLinkedPhotoView
};

(function (Language) {
  Language["Afrikaans"] = "af";
  Language["Amharic"] = "am";
  Language["Arabic"] = "ar";
  Language["Azerbaijani"] = "az";
  Language["Belarusian"] = "be";
  Language["Bulgarian"] = "bg";
  Language["Bengali"] = "bn";
  Language["Bosnian"] = "bs";
  Language["Catalan"] = "ca";
  Language["Cebuano"] = "ceb";
  Language["Corsican"] = "co";
  Language["Czech"] = "cs";
  Language["Welsh"] = "cy";
  Language["Danish"] = "da";
  Language["German"] = "de";
  Language["Greek"] = "el";
  Language["English"] = "en";
  Language["Esperanto"] = "eo";
  Language["Spanish"] = "es";
  Language["Estonian"] = "et";
  Language["Basque"] = "eu";
  Language["Persian"] = "fa";
  Language["Finnish"] = "fi";
  Language["French"] = "fr";
  Language["Frisian"] = "fy";
  Language["Irish"] = "ga";
  Language["ScotsGaelic"] = "gd";
  Language["Galician"] = "gl";
  Language["Gujarati"] = "gu";
  Language["Hausa"] = "ha";
  Language["Hawaiian"] = "haw";
  Language["Hindi"] = "hi";
  Language["Hmong"] = "hmn";
  Language["Croatian"] = "hr";
  Language["HaitianCreole"] = "ht";
  Language["Hungarian"] = "hu";
  Language["Armenian"] = "hy";
  Language["Indonesian"] = "id";
  Language["Igbo"] = "ig";
  Language["Icelandic"] = "is";
  Language["Italian"] = "it";
  Language["Hebrew"] = "iw";
  Language["Japanese"] = "ja";
  Language["Javanese"] = "jw";
  Language["Georgian"] = "ka";
  Language["Kazakh"] = "kk";
  Language["Khmer"] = "km";
  Language["Kannada"] = "kn";
  Language["Korean"] = "ko";
  Language["Kurdish"] = "ku";
  Language["Kyrgyz"] = "ky";
  Language["Latin"] = "la";
  Language["Luxembourgish"] = "lb";
  Language["Lao"] = "lo";
  Language["Lithuanian"] = "lt";
  Language["Latvian"] = "lv";
  Language["Malagasy"] = "mg";
  Language["Maori"] = "mi";
  Language["Macedonian"] = "mk";
  Language["Malayalam"] = "ml";
  Language["Mongolian"] = "mn";
  Language["Marathi"] = "mr";
  Language["Malay"] = "ms";
  Language["Maltese"] = "mt";
  Language["Myanmar"] = "my";
  Language["Nepali"] = "ne";
  Language["Dutch"] = "nl";
  Language["Norwegian"] = "no";
  Language["Nyanja"] = "ny";
  Language["Oriya"] = "or";
  Language["Punjabi"] = "pa";
  Language["Polish"] = "pl";
  Language["Pashto"] = "ps";
  Language["Portuguese"] = "pt";
  Language["Romanian"] = "ro";
  Language["Russian"] = "ru";
  Language["Kinyarwanda"] = "rw";
  Language["Sindhi"] = "sd";
  Language["Sinhala"] = "si";
  Language["Slovak"] = "sk";
  Language["Slovenian"] = "sl";
  Language["Samoan"] = "sm";
  Language["Shona"] = "sn";
  Language["Somali"] = "so";
  Language["Albanian"] = "sq";
  Language["Serbian"] = "sr";
  Language["Sesotho"] = "st";
  Language["Sundanese"] = "su";
  Language["Swedish"] = "sv";
  Language["Swahili"] = "sw";
  Language["Tamil"] = "ta";
  Language["Telugu"] = "te";
  Language["Tajik"] = "tg";
  Language["Thai"] = "th";
  Language["Turkmen"] = "tk";
  Language["Filipino"] = "tl";
  Language["Turkish"] = "tr";
  Language["Tatar"] = "tt";
  Language["Uighur"] = "ug";
  Language["Ukrainian"] = "uk";
  Language["Urdu"] = "ur";
  Language["Uzbek"] = "uz";
  Language["Vietnamese"] = "vi";
  Language["Xhosa"] = "xh";
  Language["Yiddish"] = "yi";
  Language["Yoruba"] = "yo";
  Language["ChineseSimplified"] = "zh";
  Language["ChineseTraditional"] = "zh-TW";
  Language["Zulu"] = "zu";
})(exports.Language || (exports.Language = {}));

(function (OrderBy) {
  OrderBy["LATEST"] = "latest";
  OrderBy["POPULAR"] = "popular";
  OrderBy["VIEWS"] = "views";
  OrderBy["DOWNLOADS"] = "downloads";
  OrderBy["OLDEST"] = "oldest";
})(exports.OrderBy || (exports.OrderBy = {}));

var createApi = /*#__PURE__*/flow(initMakeRequest, function (makeRequest) {
  return {
    photos: {
      get: makeRequest(get$1),
      list: makeRequest(list$1),
      getStats: makeRequest(getStats),
      getRandom: makeRequest(getRandom),
      trackDownload: makeRequest(trackDownload)
    },
    users: {
      getPhotos: makeRequest(getPhotos$2),
      getCollections: makeRequest(getCollections$2),
      getLikes: makeRequest(getLikes),
      get: makeRequest(get$2)
    },
    search: {
      getCollections: makeRequest(getCollections$1),
      getPhotos: makeRequest(getPhotos$1),
      getUsers: makeRequest(getUsers)
    },
    collections: {
      getPhotos: makeRequest(getPhotos),
      get: makeRequest(get),
      list: makeRequest(list),
      getRelated: makeRequest(getRelated)
    },
    topics: {
      list: makeRequest(list$2),
      get: makeRequest(get$3),
      getPhotos: makeRequest(getPhotos$3)
    }
  };
});

exports._internals = internals;
exports.createApi = createApi;


},{"content-type":422}],1213:[function(require,module,exports){
"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("content-type");function n(){return(n=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)}function t(e,n){if(null==e)return{};var t,r,a={},o=Object.keys(e);for(r=0;r<o.length;r++)n.indexOf(t=o[r])>=0||(a[t]=e[t]);return a}var r=o((function(e){return"string"==typeof e?e:null})),a=function(e){return null!=e};function o(e){return function(n){return a(e(n))}}var u=function(e){return Object.keys(e).reduce((function(t,r){var o,u=e[r];return n({},t,a(u)?((o={})[r]=u,o):{})}),{})};function i(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n.length-1;return function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];for(var o=n[0].apply(this,t),u=1;u<=r;u++)o=n[u].call(this,o);return o}}var s,c,l=o((function(e){return a(e)&&"object"==typeof e&&!Array.isArray(e)?e:null})),h=o((function(e){return Array.isArray(e)&&e.every(r)&&e.length>0?e:null})),p=o((function(e){return l(e)&&"errors"in e&&h(e.errors)?{errors:e.errors}:null})),d=function(e){this.message=e},f=function(n){if(function(n){var t=n.headers.get("content-type");return a(t)&&"application/json"===e.parse(t).type}(n))return n.json().catch((function(e){throw new d("unable to parse JSON response.")}));throw new d("expected JSON response from server.")},g=function(){return function(e){return f(e.response)}},m=function(e){return function(r,a){void 0===a&&(a={});var o=e(r),u=o.headers,i=o.query;return n({},t(o,["headers","query"]),a,{query:i,headers:n({},u,a.headers)})}},y=function(e){return e},v=function(e){var r=e.accessKey,o=e.apiVersion,u=void 0===o?"v1":o,s=e.apiUrl,c=void 0===s?"https://api.unsplash.com":s,l=e.headers,h=e.fetch,g=t(e,["accessKey","apiVersion","apiUrl","headers","fetch"]);return function(e){var t=e.handleResponse;return i(e.handleRequest,(function(e){var o=e.method,i=void 0===o?"GET":o,s=e.headers,m=e.body,y=e.signal,v=function(e){var n=e.pathname,t=e.query;return function(e){var r=new URL(e);return function(e){return function(n){"/"===n.pathname?n.pathname=e:n.pathname+=e}}(n)(r),function(e){return function(n){Object.keys(e).forEach((function(t){return n.searchParams.set(t,e[t].toString())}))}}(t)(r),r.toString()}}({pathname:e.pathname,query:e.query})(c),q=n({method:i,headers:n({},l,s,{"Accept-Version":u},a(r)?{Authorization:"Client-ID "+r}:{}),body:m,signal:y},g);return(null!=h?h:fetch)(v,q).then(function(e){return function(t){return(t.ok?e({response:t}).then((function(e){return{type:"success",status:t.status,response:e,originalResponse:t}})):f(t).then((function(e){return n({type:"error",status:t.status},function(e){return p(e)?{errors:e.errors,source:"api"}:{errors:["Responded with a status code outside the 2xx range, and the response body is not recognisable."],source:"decoding"}}(e),{originalResponse:t})}))).catch((function(e){if(e instanceof d)return{type:"error",source:"decoding",status:t.status,originalResponse:t,errors:[e.message]};throw e}))}}(t))}))}},q=function(e){var n=e.headers.get("x-total");if(a(n)){var t=parseInt(n);if(Number.isInteger(t))return t;throw new d("expected x-total header to be valid integer.")}throw new d("expected x-total header to exist.")},R=function(){return function(e){var n=e.response;return g()({response:n}).then((function(e){return{results:e,total:q(n)}}))}},P=function(e){return a(e)?{collections:e.join()}:{}},I=function(e){return a(e)?{topics:e.join()}:{}},w=function(e){return u({per_page:e.perPage,order_by:e.orderBy,page:e.page})},_=function(){var e=function(e){return"/collections/"+e.collectionId+"/photos"};return{getPathname:e,handleRequest:m((function(r){var a=r.collectionId,o=r.orientation,i=t(r,["collectionId","orientation"]);return{pathname:e({collectionId:a}),query:u(n({},w(i),{orientation:o}))}})),handleResponse:R()}}(),b=function(){var e=function(e){return"/collections/"+e.collectionId};return{getPathname:e,handleRequest:m((function(n){return{pathname:e({collectionId:n.collectionId}),query:{}}})),handleResponse:g()}}(),k=function(){return{getPathname:function(){return"/collections"},handleRequest:m((function(e){return void 0===e&&(e={}),{pathname:"/collections",query:w(e)}})),handleResponse:R()}}(),S=function(){var e=function(e){return"/collections/"+e.collectionId+"/related"};return{getPathname:e,handleRequest:m((function(n){return{pathname:e({collectionId:n.collectionId}),query:{}}})),handleResponse:g()}}(),O={__proto__:null,getPhotos:_,get:b,list:k,getRelated:S},j=function(){return{getPathname:function(e){return"/photos"},handleRequest:m((function(e){return void 0===e&&(e={}),{pathname:"/photos",query:u(w(e))}})),handleResponse:R()}}(),A=function(){var e=function(e){return"/photos/"+e.photoId};return{getPathname:e,handleRequest:m((function(n){return{pathname:e({photoId:n.photoId}),query:{}}})),handleResponse:g()}}(),x=function(){var e=function(e){return"/photos/"+e.photoId+"/statistics"};return{getPathname:e,handleRequest:m((function(n){return{pathname:e({photoId:n.photoId}),query:{}}})),handleResponse:g()}}(),L=function(){return{getPathname:function(){return"/photos/random"},handleRequest:m((function(e){var r=void 0===e?{}:e,a=r.collectionIds,o=r.contentFilter,i=r.topicIds,s=t(r,["collectionIds","contentFilter","topicIds"]);return{pathname:"/photos/random",query:u(n({},s,{content_filter:o},P(a),I(i))),headers:{"cache-control":"no-cache"}}})),handleResponse:g()}}(),C={handleRequest:m((function(e){var n=function(e){var n=new URL(e),t=n.pathname;return{query:function(e){var n={};return e.forEach((function(e,t){n[t]=e})),n}(n.searchParams),pathname:"/"===t?void 0:t}}(e.downloadLocation),t=n.pathname,r=n.query;if(!a(t))throw new Error("Could not parse pathname from url.");return{pathname:t,query:u(r)}})),handleResponse:g()},T={__proto__:null,list:j,get:A,getStats:x,getRandom:L,trackDownload:C},z=function(){return{getPathname:function(e){return"/search/photos"},handleRequest:m((function(e){var r=e.query,a=e.page,o=e.perPage,i=e.orderBy,s=e.collectionIds,c=e.lang,l=e.contentFilter,h=t(e,["query","page","perPage","orderBy","collectionIds","lang","contentFilter"]);return{pathname:"/search/photos",query:u(n({query:r,content_filter:l,lang:c,order_by:i},w({page:a,perPage:o}),P(s),h))}})),handleResponse:g()}}(),B=function(){return{getPathname:function(e){return"/search/collections"},handleRequest:m((function(e){var r=e.query,a=t(e,["query"]);return{pathname:"/search/collections",query:n({query:r},w(a))}})),handleResponse:g()}}(),E=function(){return{getPathname:function(e){return"/search/users"},handleRequest:m((function(e){var r=e.query,a=t(e,["query"]);return{pathname:"/search/users",query:n({query:r},w(a))}})),handleResponse:g()}}(),U={__proto__:null,getPhotos:z,getCollections:B,getUsers:E},M=function(){var e=function(e){return"/users/"+e.username};return{getPathname:e,handleRequest:m((function(n){return{pathname:e({username:n.username}),query:{}}})),handleResponse:g()}}(),K=function(){var e=function(e){return"/users/"+e.username+"/photos"};return{getPathname:e,handleRequest:m((function(r){var a=r.username,o=r.stats,i=r.orientation,s=t(r,["username","stats","orientation"]);return{pathname:e({username:a}),query:u(n({},w(s),{orientation:i,stats:o}))}})),handleResponse:R()}}(),D=function(){var e=function(e){return"/users/"+e.username+"/likes"};return{getPathname:e,handleRequest:m((function(r){var a=r.username,o=r.orientation,i=t(r,["username","orientation"]);return{pathname:e({username:a}),query:u(n({},w(i),{orientation:o}))}})),handleResponse:R()}}(),F=function(){var e=function(e){return"/users/"+e.username+"/collections"};return{getPathname:e,handleRequest:m((function(n){var r=n.username,a=t(n,["username"]);return{pathname:e({username:r}),query:w(a)}})),handleResponse:R()}}(),H={__proto__:null,get:M,getPhotos:K,getLikes:D,getCollections:F},N=function(e){return"/topics/"+e.topicIdOrSlug},G=y({getPathname:N,handleRequest:function(e){var t=e.orderBy,r=e.topicIdsOrSlugs;return{pathname:"/topics",query:u(n({},w({page:e.page,perPage:e.perPage}),{ids:null==r?void 0:r.join(","),order_by:t}))}},handleResponse:R()}),V=y({getPathname:N,handleRequest:function(e){return{pathname:N({topicIdOrSlug:e.topicIdOrSlug}),query:{}}},handleResponse:g()}),J=function(){var e=i(N,(function(e){return e+"/photos"}));return{getPathname:e,handleRequest:function(r){var a=r.topicIdOrSlug,o=r.orientation,i=t(r,["topicIdOrSlug","orientation"]);return{pathname:e({topicIdOrSlug:a}),query:u(n({},w(i),{orientation:o}))}},handleResponse:R()}}(),W={__proto__:null,collections:O,photos:T,search:U,users:H,topics:{__proto__:null,list:G,get:V,getPhotos:J},trackNonHotLinkedPhotoView:function(e){var n=e.appId;return function(e){var t=e.photoId,r=Array.isArray(t)?t:[t];if(r.length>20)throw new Error("You cannot track more than 20 photos at once. Please try again with fewer photos.");return fetch("views.unsplash.com/v?photo_id="+r.join()+"&app_id="+n)}}};(s=exports.Language||(exports.Language={})).Afrikaans="af",s.Amharic="am",s.Arabic="ar",s.Azerbaijani="az",s.Belarusian="be",s.Bulgarian="bg",s.Bengali="bn",s.Bosnian="bs",s.Catalan="ca",s.Cebuano="ceb",s.Corsican="co",s.Czech="cs",s.Welsh="cy",s.Danish="da",s.German="de",s.Greek="el",s.English="en",s.Esperanto="eo",s.Spanish="es",s.Estonian="et",s.Basque="eu",s.Persian="fa",s.Finnish="fi",s.French="fr",s.Frisian="fy",s.Irish="ga",s.ScotsGaelic="gd",s.Galician="gl",s.Gujarati="gu",s.Hausa="ha",s.Hawaiian="haw",s.Hindi="hi",s.Hmong="hmn",s.Croatian="hr",s.HaitianCreole="ht",s.Hungarian="hu",s.Armenian="hy",s.Indonesian="id",s.Igbo="ig",s.Icelandic="is",s.Italian="it",s.Hebrew="iw",s.Japanese="ja",s.Javanese="jw",s.Georgian="ka",s.Kazakh="kk",s.Khmer="km",s.Kannada="kn",s.Korean="ko",s.Kurdish="ku",s.Kyrgyz="ky",s.Latin="la",s.Luxembourgish="lb",s.Lao="lo",s.Lithuanian="lt",s.Latvian="lv",s.Malagasy="mg",s.Maori="mi",s.Macedonian="mk",s.Malayalam="ml",s.Mongolian="mn",s.Marathi="mr",s.Malay="ms",s.Maltese="mt",s.Myanmar="my",s.Nepali="ne",s.Dutch="nl",s.Norwegian="no",s.Nyanja="ny",s.Oriya="or",s.Punjabi="pa",s.Polish="pl",s.Pashto="ps",s.Portuguese="pt",s.Romanian="ro",s.Russian="ru",s.Kinyarwanda="rw",s.Sindhi="sd",s.Sinhala="si",s.Slovak="sk",s.Slovenian="sl",s.Samoan="sm",s.Shona="sn",s.Somali="so",s.Albanian="sq",s.Serbian="sr",s.Sesotho="st",s.Sundanese="su",s.Swedish="sv",s.Swahili="sw",s.Tamil="ta",s.Telugu="te",s.Tajik="tg",s.Thai="th",s.Turkmen="tk",s.Filipino="tl",s.Turkish="tr",s.Tatar="tt",s.Uighur="ug",s.Ukrainian="uk",s.Urdu="ur",s.Uzbek="uz",s.Vietnamese="vi",s.Xhosa="xh",s.Yiddish="yi",s.Yoruba="yo",s.ChineseSimplified="zh",s.ChineseTraditional="zh-TW",s.Zulu="zu",(c=exports.OrderBy||(exports.OrderBy={})).LATEST="latest",c.POPULAR="popular",c.VIEWS="views",c.DOWNLOADS="downloads",c.OLDEST="oldest";var Y=i(v,(function(e){return{photos:{get:e(A),list:e(j),getStats:e(x),getRandom:e(L),trackDownload:e(C)},users:{getPhotos:e(K),getCollections:e(F),getLikes:e(D),get:e(M)},search:{getCollections:e(B),getPhotos:e(z),getUsers:e(E)},collections:{getPhotos:e(_),get:e(b),list:e(k),getRelated:e(S)},topics:{list:e(G),get:e(V),getPhotos:e(J)}}}));exports._internals=W,exports.createApi=Y;


},{"content-type":422}],1214:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1215:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],1216:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],1217:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":1216,"_process":405,"inherits":1215}],1218:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/wtf8 v1.0.0 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function wtf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte.
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read the first byte.
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			var byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid WTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function wtf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var wtf8 = {
		'version': '1.0.0',
		'encode': wtf8encode,
		'decode': wtf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return wtf8;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = wtf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in wtf8) {
				hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.wtf8 = wtf8;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1219:[function(require,module,exports){
'use strict';

var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;

},{}]},{},[302]);
